// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
        ? self
        : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
            ? global
            : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"d0evx":[function(require,module,exports,__globalThis) {
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
// @ts-expect-error TS7017
var global = arguments[3];
var HMR_HOST = null;
var HMR_PORT = null;
var HMR_SECURE = false;
var HMR_ENV_HASH = "953d53f787114b14";
var HMR_USE_SSE = false;
var HMR_ENABLE_BUNDLE_VERSION = false;
module.bundle.HMR_BUNDLE_ID = "74ad1ac5fb68e3d7";
"use strict";
/* global HMR_HOST, HMR_PORT, HMR_ENV_HASH, HMR_SECURE, HMR_USE_SSE, chrome, browser, __parcel__import__, __parcel__importScripts__, ServiceWorkerGlobalScope, HMR_ENABLE_BUNDLE_VERSION */ /*::
import type {
  HMRAsset,
  HMRMessage,
} from '@atlaspack/reporter-dev-server/src/HMRServer';
interface ParcelRequire {
  (string): mixed;
  cache: {|[string]: ParcelModule|};
  hotData: {|[string]: mixed|};
  Module: any;
  parent: ?ParcelRequire;
  isParcelRequire: true;
  modules: {|[string]: [Function, {|[string]: string|}]|};
  HMR_BUNDLE_ID: string;
  root: ParcelRequire;
}
interface ParcelModule {
  hot: {|
    data: mixed,
    accept(cb: (Function) => void): void,
    dispose(cb: (mixed) => void): void,
    // accept(deps: Array<string> | string, cb: (Function) => void): void,
    // decline(): void,
    _acceptCallbacks: Array<(Function) => void>,
    _disposeCallbacks: Array<(mixed) => void>,
  |};
}
interface ExtensionContext {
  runtime: {|
    reload(): void,
    getURL(url: string): string;
    getManifest(): {manifest_version: number, ...};
  |};
}
declare var module: {bundle: ParcelRequire, ...};
declare var HMR_HOST: string;
declare var HMR_PORT: string;
declare var HMR_ENV_HASH: string;
declare var HMR_SECURE: boolean;
declare var HMR_USE_SSE: boolean;
declare var HMR_ENABLE_BUNDLE_VERSION: boolean;
declare var chrome: ExtensionContext;
declare var browser: ExtensionContext;
declare var __parcel__import__: (string) => Promise<void>;
declare var __parcel__importScripts__: (string) => Promise<void>;
declare var globalThis: typeof self;
declare var ServiceWorkerGlobalScope: Object;
*/ // flow-to-ts helpers
// /flow-to-ts helpers
var OVERLAY_ID = '__parcel__error__overlay__';
var HMR_BUNDLE_VERSION = '__parcel__hmrBundleVersion';
// @ts-expect-error TS2339
var OldModule = module.bundle.Module;
function Module(moduleName) {
    // @ts-expect-error TS2683
    OldModule.call(this, moduleName);
    // @ts-expect-error TS2683
    this.hot = {
        // @ts-expect-error TS2339
        data: module.bundle.hotData[moduleName],
        _acceptCallbacks: [],
        _disposeCallbacks: [],
        // @ts-expect-error TS7006
        accept: function accept(fn) {
            this._acceptCallbacks.push(fn || function() {});
        },
        // @ts-expect-error TS7006
        dispose: function dispose(fn) {
            this._disposeCallbacks.push(fn);
        }
    };
    // @ts-expect-error TS2339
    module.bundle.hotData[moduleName] = undefined;
}
// @ts-expect-error TS2339
module.bundle.Module = Module;
// @ts-expect-error TS2339
module.bundle.hotData = {};
// @ts-expect-error TS7034
var checkedAssets /*: {|[string]: boolean|} */ , // @ts-expect-error TS7034
disposedAssets /*: {|[string]: boolean|} */ , // @ts-expect-error TS7034
assetsToDispose /*: Array<[ParcelRequire, string]> */ , // @ts-expect-error TS7034
assetsToAccept /*: Array<[ParcelRequire, string]> */ ;
function getBundleVersion() {
    // @ts-expect-error TS7017
    return globalThis[HMR_BUNDLE_VERSION];
}
function bumpBundleVersion() {
    // @ts-expect-error TS2304
    if (!HMR_ENABLE_BUNDLE_VERSION) return;
    var version = getBundleVersion();
    var nextVersion = typeof version === 'number' && Number.isFinite(version) ? version + 1 : 1;
    // @ts-expect-error TS7017
    globalThis[HMR_BUNDLE_VERSION] = nextVersion;
    return nextVersion;
}
function appendBundleVersion(url) {
    // @ts-expect-error TS2304
    if (!HMR_ENABLE_BUNDLE_VERSION) return url + (url.includes('?') ? '&' : '?') + 't=' + Date.now();
    var version = getBundleVersion();
    if (version == null) return url;
    return url + (url.includes('?') ? '&' : '?') + 't=' + version;
}
function getHostname() {
    return(// @ts-expect-error TS2304
    HMR_HOST || (location.protocol.indexOf('http') === 0 ? location.hostname : 'localhost'));
}
function getPort() {
    // @ts-expect-error TS2304
    return HMR_PORT || location.port;
}
// eslint-disable-next-line no-redeclare
// @ts-expect-error TS2339
var parent = module.bundle.parent;
if ((!parent || !parent.isParcelRequire) && typeof WebSocket !== 'undefined') {
    var hostname = getHostname();
    var port = getPort();
    var protocol = // @ts-expect-error TS2304
    HMR_SECURE || location.protocol == 'https:' && ![
        'localhost',
        '127.0.0.1',
        '0.0.0.0'
    ].includes(hostname) ? 'wss' : 'ws';
    var ws;
    // @ts-expect-error TS2304
    if (HMR_USE_SSE) ws = new EventSource('/__parcel_hmr');
    else try {
        ws = new WebSocket(protocol + '://' + hostname + (port ? ':' + port : '') + '/');
    } catch (err) {
        if (err.message) console.error(err.message);
        ws = {};
    }
    // Web extension context
    var extCtx = // @ts-expect-error TS2304
    typeof browser === 'undefined' ? // @ts-expect-error TS2304
    typeof chrome === 'undefined' ? null : // @ts-expect-error TS2304
    chrome : // @ts-expect-error TS2304
    browser;
    // Safari doesn't support sourceURL in error stacks.
    // eval may also be disabled via CSP, so do a quick check.
    var supportsSourceURL = false;
    try {
        (0, eval)('throw new Error("test"); //# sourceURL=test.js');
    } catch (err) {
        supportsSourceURL = err.stack.includes('test.js');
    }
    // @ts-expect-error TS2339
    ws.onmessage = function(event) {
        return (0, _asyncToGenerator._)(function() {
            var data /*: HMRMessage */ , assets, handled, processedAssets, i, id, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, ansiDiagnostic, stack, overlay;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        checkedAssets = {} /*: {|[string]: boolean|} */ ;
                        disposedAssets = {} /*: {|[string]: boolean|} */ ;
                        assetsToAccept = [];
                        assetsToDispose = [];
                        data = JSON.parse(event.data);
                        if (!(data.type === 'reload')) return [
                            3,
                            1
                        ];
                        fullReload();
                        return [
                            3,
                            4
                        ];
                    case 1:
                        if (!(data.type === 'update')) return [
                            3,
                            4
                        ];
                        // Remove error overlay if there is one
                        if (typeof document !== 'undefined') removeErrorOverlay();
                        assets = data.assets.filter(// @ts-expect-error TS7006
                        function(asset) {
                            return asset.envHash === HMR_ENV_HASH;
                        });
                        // Handle HMR Update
                        // @ts-expect-error TS7006
                        handled = assets.every(function(asset) {
                            return asset.type === 'css' || asset.type === 'js' && // @ts-expect-error TS2339
                            hmrAcceptCheck(module.bundle.root, asset.id, asset.depsByBundle);
                        });
                        if (!handled) return [
                            3,
                            3
                        ];
                        bumpBundleVersion();
                        console.clear();
                        // Dispatch custom event so other runtimes (e.g React Refresh) are aware.
                        if (typeof window !== 'undefined' && typeof CustomEvent !== 'undefined') window.dispatchEvent(new CustomEvent('parcelhmraccept'));
                        return [
                            4,
                            hmrApplyUpdates(assets)
                        ];
                    case 2:
                        _state.sent();
                        hmrDisposeQueue();
                        // Run accept callbacks. This will also re-execute other disposed assets in topological order.
                        processedAssets = {};
                        for(i = 0; i < assetsToAccept.length; i++){
                            // @ts-expect-error TS7005
                            id = assetsToAccept[i][1];
                            if (!processedAssets[id]) {
                                // @ts-expect-error TS7005
                                hmrAccept(assetsToAccept[i][0], id);
                                processedAssets[id] = true;
                            }
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        fullReload();
                        _state.label = 4;
                    case 4:
                        if (data.type === 'error') {
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                // Log parcel errors to console
                                for(_iterator = data.diagnostics.ansi[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    ansiDiagnostic = _step.value;
                                    stack = ansiDiagnostic.codeframe ? ansiDiagnostic.codeframe : ansiDiagnostic.stack;
                                    console.error("\uD83D\uDEA8 [parcel]: " + ansiDiagnostic.message + '\n' + stack + '\n\n' + ansiDiagnostic.hints.join('\n'));
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            if (typeof document !== 'undefined') {
                                // Render the fancy html overlay
                                removeErrorOverlay();
                                overlay = createErrorOverlay(data.diagnostics.html);
                                document.body.appendChild(overlay);
                            }
                        }
                        return [
                            2
                        ];
                }
            });
        })();
    };
    if ((0, _instanceof._)(ws, WebSocket)) {
        ws.onerror = function(e) {
            if (e.message) console.error(e.message);
        };
        ws.onclose = function(e) {
            console.warn("[parcel] \uD83D\uDEA8 Connection to the HMR server was lost");
        };
    }
}
function removeErrorOverlay() {
    var overlay = document.getElementById(OVERLAY_ID);
    if (overlay) {
        overlay.remove();
        console.log("[parcel] \u2728 Error resolved");
    }
}
function createErrorOverlay(diagnostics) {
    var overlay = document.createElement('div');
    overlay.id = OVERLAY_ID;
    var errorHTML = '<div style="background: black; opacity: 0.85; font-size: 16px; color: white; position: fixed; height: 100%; width: 100%; top: 0px; left: 0px; padding: 30px; font-family: Menlo, Consolas, monospace; z-index: 9999;">';
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = diagnostics[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var diagnostic = _step.value;
            var stack = diagnostic.frames.length ? // @ts-expect-error TS7006
            diagnostic.frames.reduce(function(p, frame) {
                return "".concat(p, '\n<a href="/__parcel_launch_editor?file=').concat(encodeURIComponent(frame.location), '" style="text-decoration: underline; color: #888" onclick="fetch(this.href); return false">').concat(frame.location, "</a>\n").concat(frame.code);
            }, '') : diagnostic.stack;
            errorHTML += '\n      <div>\n        <div style="font-size: 18px; font-weight: bold; margin-top: 20px;">\n          \uD83D\uDEA8 '.concat(diagnostic.message, "\n        </div>\n        <pre>").concat(stack, "</pre>\n        <div>\n          ").concat(diagnostic.hints// @ts-expect-error TS7006
            .map(function(hint) {
                return "<div>\uD83D\uDCA1 " + hint + '</div>';
            }).join(''), "\n        </div>\n        ").concat(diagnostic.documentation ? '<div>\uD83D\uDCDD <a style="color: violet" href="'.concat(diagnostic.documentation, '" target="_blank">Learn more</a></div>') : '', "\n      </div>\n    ");
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    errorHTML += '</div>';
    overlay.innerHTML = errorHTML;
    return overlay;
}
function fullReload() {
    if ('reload' in location) location.reload();
    else if (extCtx && extCtx.runtime && extCtx.runtime.reload) extCtx.runtime.reload();
}
function getParents(// @ts-expect-error TS2304
bundle, id) /*: Array<[ParcelRequire, string]> */ {
    var modules = bundle.modules;
    if (!modules) return [];
    // @ts-expect-error TS2304
    var parents = [];
    var k, d, dep;
    for(k in modules)for(d in modules[k][1]){
        dep = modules[k][1][d];
        if (dep === id || Array.isArray(dep) && dep[dep.length - 1] === id) parents.push([
            bundle,
            k
        ]);
    }
    if (bundle.parent) parents = parents.concat(getParents(bundle.parent, id));
    return parents;
}
function updateLink(link) {
    var href = link.getAttribute('href');
    if (!href) return;
    var newLink = link.cloneNode();
    // @ts-expect-error TS2345
    newLink.onload = function() {
        if (link.parentNode !== null) link.parentNode.removeChild(link);
    };
    // @ts-expect-error TS2339
    newLink.setAttribute('href', appendBundleVersion(href));
    // @ts-expect-error TS18047
    link.parentNode.insertBefore(newLink, link.nextSibling);
}
// @ts-expect-error TS7034
var cssTimeout = null;
function reloadCSS() {
    // @ts-expect-error TS7005
    if (cssTimeout) return;
    cssTimeout = setTimeout(function() {
        var document1 = window.document;
        var links = document1.querySelectorAll('link[rel="stylesheet"]');
        for(var i = 0; i < links.length; i++){
            var href /*: string */  = links[i].getAttribute('href');
            var hostname = getHostname();
            var servedFromHMRServer = hostname === 'localhost' ? new RegExp('^(https?:\\/\\/(0.0.0.0|127.0.0.1)|localhost):' + getPort()) // @ts-expect-error TS2345
            .test(href) : // @ts-expect-error TS2345
            href.indexOf(hostname + ':' + getPort());
            var absolute = // @ts-expect-error TS2345
            /^https?:\/\//i.test(href) && // @ts-expect-error TS18047
            href.indexOf(location.origin) !== 0 && !servedFromHMRServer;
            if (!absolute) // @ts-expect-error TS2345
            updateLink(links[i]);
        }
        cssTimeout = null;
    }, 50);
}
// @ts-expect-error TS2304
function hmrDownload(asset) {
    if (asset.type === 'js') {
        if (typeof document !== 'undefined') {
            var script = document.createElement('script');
            script.src = appendBundleVersion(asset.url);
            if (asset.outputFormat === 'esmodule') script.type = 'module';
            return new Promise(function(resolve, reject) {
                var _document$head;
                script.onload = function() {
                    return resolve(script);
                };
                script.onerror = reject;
                (_document$head = document.head) === null || _document$head === void 0 || _document$head.appendChild(script);
            });
        // @ts-expect-error TS2304
        } else if (typeof importScripts === 'function') {
            // Worker scripts
            if (asset.outputFormat === 'esmodule') // @ts-expect-error TS2304
            return import(appendBundleVersion(asset.url));
            else return new Promise(function(resolve, reject) {
                try {
                    // @ts-expect-error TS2304
                    importScripts(appendBundleVersion(asset.url));
                    // @ts-expect-error TS2794
                    resolve();
                } catch (err) {
                    reject(err);
                }
            });
        }
    }
}
// @ts-expect-error TS2304
function hmrApplyUpdates(assets) {
    return (0, _asyncToGenerator._)(function() {
        var scriptsToRemove, promises;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    global.parcelHotUpdate = Object.create(null);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        ,
                        4,
                        5
                    ]);
                    if (!!supportsSourceURL) return [
                        3,
                        3
                    ];
                    promises = assets.map(function(asset) {
                        var _hmrDownload;
                        return (_hmrDownload = hmrDownload(asset)) === null || _hmrDownload === void 0 ? void 0 : _hmrDownload.catch(function(err) {
                            // Web extension fix
                            if (extCtx && extCtx.runtime && extCtx.runtime.getManifest().manifest_version == 3 && // @ts-expect-error TS2304
                            typeof ServiceWorkerGlobalScope != 'undefined' && // @ts-expect-error TS2304
                            (0, _instanceof._)(global, ServiceWorkerGlobalScope)) {
                                extCtx.runtime.reload();
                                return;
                            }
                            throw err;
                        });
                    });
                    return [
                        4,
                        Promise.all(promises)
                    ];
                case 2:
                    scriptsToRemove = _state.sent();
                    _state.label = 3;
                case 3:
                    assets.forEach(function(asset) {
                        // @ts-expect-error TS2339
                        hmrApply(module.bundle.root, asset);
                    });
                    return [
                        3,
                        5
                    ];
                case 4:
                    // @ts-expect-error TS7017
                    delete global.parcelHotUpdate;
                    if (scriptsToRemove) // @ts-expect-error TS7006
                    scriptsToRemove.forEach(function(script) {
                        if (script) {
                            var _document$head2;
                            (_document$head2 = document.head) === null || _document$head2 === void 0 || _document$head2.removeChild(script);
                        }
                    });
                    return [
                        7
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    })();
}
function hmrApply(// @ts-expect-error TS2304
bundle, // @ts-expect-error TS2304
asset) {
    var modules = bundle.modules;
    if (!modules) return;
    if (asset.type === 'css') reloadCSS();
    else if (asset.type === 'js') {
        var deps = asset.depsByBundle[bundle.HMR_BUNDLE_ID];
        if (deps) {
            if (modules[asset.id]) {
                // Remove dependencies that are removed and will become orphaned.
                // This is necessary so that if the asset is added back again, the cache is gone, and we prevent a full page reload.
                var oldDeps = modules[asset.id][1];
                for(var dep in oldDeps)if (!deps[dep] || deps[dep] !== oldDeps[dep]) {
                    var id = oldDeps[dep];
                    // @ts-expect-error TS2339
                    var parents = getParents(module.bundle.root, id);
                    if (parents.length === 1) // @ts-expect-error TS2339
                    hmrDelete(module.bundle.root, id);
                }
            }
            if (supportsSourceURL) // Global eval. We would use `new Function` here but browser
            // support for source maps is better with eval.
            (0, eval)(asset.output);
            // @ts-expect-error TS7017
            var fn = global.parcelHotUpdate[asset.id];
            modules[asset.id] = [
                fn,
                deps
            ];
        }
        // Always traverse to the parent bundle, even if we already replaced the asset in this bundle.
        // This is required in case modules are duplicated. We need to ensure all instances have the updated code.
        if (bundle.parent) hmrApply(bundle.parent, asset);
    }
}
// @ts-expect-error TS2304
function hmrDelete(bundle, id) {
    var modules = bundle.modules;
    if (!modules) return;
    if (modules[id]) {
        // Collect dependencies that will become orphaned when this module is deleted.
        var deps = modules[id][1];
        var orphans = [];
        for(var dep in deps){
            // @ts-expect-error TS2339
            var parents = getParents(module.bundle.root, deps[dep]);
            if (parents.length === 1) orphans.push(deps[dep]);
        }
        // Delete the module. This must be done before deleting dependencies in case of circular dependencies.
        delete modules[id];
        delete bundle.cache[id];
        // Now delete the orphans.
        orphans.forEach(function(id) {
            // @ts-expect-error TS2339
            hmrDelete(module.bundle.root, id);
        });
    } else if (bundle.parent) hmrDelete(bundle.parent, id);
}
function hmrAcceptCheck(// @ts-expect-error TS2304
bundle, id, depsByBundle) {
    if (hmrAcceptCheckOne(bundle, id, depsByBundle)) return true;
    // Traverse parents breadth first. All possible ancestries must accept the HMR update, or we'll reload.
    // @ts-expect-error TS2339
    var parents = getParents(module.bundle.root, id);
    var accepted = false;
    while(parents.length > 0){
        var v = parents.shift();
        // @ts-expect-error TS18048
        var a = hmrAcceptCheckOne(v[0], v[1], null);
        if (a) // If this parent accepts, stop traversing upward, but still consider siblings.
        accepted = true;
        else {
            var _parents;
            // Otherwise, queue the parents in the next level upward.
            // @ts-expect-error TS2339
            var p = getParents(module.bundle.root, v[1]);
            if (p.length === 0) {
                // If there are no parents, then we've reached an entry without accepting. Reload.
                accepted = false;
                break;
            }
            (_parents = parents).push.apply(_parents, (0, _toConsumableArray._)(p));
        }
    }
    return accepted;
}
function hmrAcceptCheckOne(// @ts-expect-error TS2304
bundle, id, depsByBundle) {
    var modules = bundle.modules;
    if (!modules) return;
    if (depsByBundle && !depsByBundle[bundle.HMR_BUNDLE_ID]) {
        // If we reached the root bundle without finding where the asset should go,
        // there's nothing to do. Mark as "accepted" so we don't reload the page.
        if (!bundle.parent) return true;
        return hmrAcceptCheck(bundle.parent, id, depsByBundle);
    }
    // @ts-expect-error TS7005
    if (checkedAssets[id]) return true;
    // @ts-expect-error TS7005
    checkedAssets[id] = true;
    var cached = bundle.cache[id];
    assetsToDispose.push([
        bundle,
        id
    ]);
    if (!cached || cached.hot && cached.hot._acceptCallbacks.length) {
        assetsToAccept.push([
            bundle,
            id
        ]);
        return true;
    }
}
function hmrDisposeQueue() {
    // Dispose all old assets.
    for(var i = 0; i < assetsToDispose.length; i++){
        // @ts-expect-error TS7005
        var id = assetsToDispose[i][1];
        // @ts-expect-error TS7005
        if (!disposedAssets[id]) {
            // @ts-expect-error TS7005
            hmrDispose(assetsToDispose[i][0], id);
            disposedAssets[id] = true;
        }
    }
    assetsToDispose = [];
}
function hmrDispose(// @ts-expect-error TS2304
bundle, id) {
    var cached = bundle.cache[id];
    bundle.hotData[id] = {};
    if (cached && cached.hot) cached.hot.data = bundle.hotData[id];
    if (cached && cached.hot && cached.hot._disposeCallbacks.length) // @ts-expect-error TS7006
    cached.hot._disposeCallbacks.forEach(function(cb) {
        cb(bundle.hotData[id]);
    });
    delete bundle.cache[id];
}
function hmrAccept(// @ts-expect-error TS2304
bundle, id) {
    // Execute the module.
    bundle(id);
    // Run the accept callbacks in the new version of the module.
    var cached = bundle.cache[id];
    if (cached && cached.hot && cached.hot._acceptCallbacks.length) {
        var assetsToAlsoAccept = [];
        // @ts-expect-error TS7006
        cached.hot._acceptCallbacks.forEach(function(cb) {
            var // @ts-expect-error TS2345
            _assetsToAlsoAccept;
            var additionalAssets = cb(function() {
                // @ts-expect-error TS2339
                return getParents(module.bundle.root, id);
            });
            if (Array.isArray(additionalAssets) && additionalAssets.length) (_assetsToAlsoAccept = assetsToAlsoAccept).push.apply(_assetsToAlsoAccept, (0, _toConsumableArray._)(additionalAssets));
        });
        if (assetsToAlsoAccept.length > 0) {
            var handled = assetsToAlsoAccept.every(function(a) {
                // @ts-expect-error TS2554
                return hmrAcceptCheck(a[0], a[1]);
            });
            if (!handled) return fullReload();
            hmrDisposeQueue();
        }
    }
}

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_to_consumable_array":"1eSZf","@swc/helpers/_/_ts_generator":"78Tqx"}],"hjHWA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _async_to_generator;
});
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6QcHb":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"h9UKc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _instanceof;
});
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) return !!right[Symbol.hasInstance](left);
    else return left instanceof right;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1eSZf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _to_consumable_array;
});
var _arrayWithoutHolesJs = require("./_array_without_holes.js");
var _iterableToArrayJs = require("./_iterable_to_array.js");
var _nonIterableSpreadJs = require("./_non_iterable_spread.js");
var _unsupportedIterableToArrayJs = require("./_unsupported_iterable_to_array.js");
function _to_consumable_array(arr) {
    return (0, _arrayWithoutHolesJs._)(arr) || (0, _iterableToArrayJs._)(arr) || (0, _unsupportedIterableToArrayJs._)(arr) || (0, _nonIterableSpreadJs._)();
}

},{"./_array_without_holes.js":"1haxp","./_iterable_to_array.js":"cfFdp","./_non_iterable_spread.js":"he9bN","./_unsupported_iterable_to_array.js":"7lOoC","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1haxp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _array_without_holes;
});
var _arrayLikeToArrayJs = require("./_array_like_to_array.js");
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return (0, _arrayLikeToArrayJs._)(arr);
}

},{"./_array_like_to_array.js":"28F7i","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"28F7i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _array_like_to_array;
});
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cfFdp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _iterable_to_array;
});
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"he9bN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _non_iterable_spread;
});
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7lOoC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _unsupported_iterable_to_array;
});
var _arrayLikeToArrayJs = require("./_array_like_to_array.js");
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, _arrayLikeToArrayJs._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, _arrayLikeToArrayJs._)(o, minLen);
}

},{"./_array_like_to_array.js":"28F7i","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"78Tqx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return 0, _tslib.__generator;
});
var _tslib = require("tslib");

},{"tslib":"6MhhU","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6MhhU":[function(require,module,exports,__globalThis) {
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__esDecorate", function() {
    return __esDecorate;
});
parcelHelpers.export(exports, "__runInitializers", function() {
    return __runInitializers;
});
parcelHelpers.export(exports, "__propKey", function() {
    return __propKey;
});
parcelHelpers.export(exports, "__setFunctionName", function() {
    return __setFunctionName;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
/** @deprecated */ parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
/** @deprecated */ parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__spreadArray", function() {
    return __spreadArray;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
parcelHelpers.export(exports, "__classPrivateFieldIn", function() {
    return __classPrivateFieldIn;
});
parcelHelpers.export(exports, "__addDisposableResource", function() {
    return __addDisposableResource;
});
parcelHelpers.export(exports, "__disposeResources", function() {
    return __disposeResources;
});
parcelHelpers.export(exports, "__rewriteRelativeImportExtension", function() {
    return __rewriteRelativeImportExtension;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
var _typeOf = require("@swc/helpers/_/_type_of");
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || (0, _instanceof._)({
        __proto__: []
    }, Array) && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, _typeOf._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function __propKey(x) {
    return (typeof x === "undefined" ? "undefined" : (0, _typeOf._)(x)) === "symbol" ? x : "".concat(x);
}
function __setFunctionName(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, _typeOf._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function __metadata(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return (0, _instanceof._)(value, P) ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var __createBinding = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function __exportStar(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
    return (0, _instanceof._)(this, __await) ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        (0, _instanceof._)(r.value, __await) ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var __setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var ownKeys = function ownKeys1(o) {
    ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return ownKeys(o);
};
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") __createBinding(result, mod, k[i]);
    }
    __setModuleDefault(result, mod);
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver === "undefined" ? "undefined" : (0, _typeOf._)(receiver)) !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if ((typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function __rewriteRelativeImportExtension(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
exports.default = {
    __extends: __extends,
    __assign: __assign,
    __rest: __rest,
    __decorate: __decorate,
    __param: __param,
    __esDecorate: __esDecorate,
    __runInitializers: __runInitializers,
    __propKey: __propKey,
    __setFunctionName: __setFunctionName,
    __metadata: __metadata,
    __awaiter: __awaiter,
    __generator: __generator,
    __createBinding: __createBinding,
    __exportStar: __exportStar,
    __values: __values,
    __read: __read,
    __spread: __spread,
    __spreadArrays: __spreadArrays,
    __spreadArray: __spreadArray,
    __await: __await,
    __asyncGenerator: __asyncGenerator,
    __asyncDelegator: __asyncDelegator,
    __asyncValues: __asyncValues,
    __makeTemplateObject: __makeTemplateObject,
    __importStar: __importStar,
    __importDefault: __importDefault,
    __classPrivateFieldGet: __classPrivateFieldGet,
    __classPrivateFieldSet: __classPrivateFieldSet,
    __classPrivateFieldIn: __classPrivateFieldIn,
    __addDisposableResource: __addDisposableResource,
    __disposeResources: __disposeResources,
    __rewriteRelativeImportExtension: __rewriteRelativeImportExtension
};

},{"@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_type_of":"iFJdx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iFJdx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _type_of;
});
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gxDd3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _client = require("react-dom/client");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _browserApis = require("@atlaskit/browser-apis");
var _app = require("./ui/App");
var _twgMicrositeExperience = require("@atlassian/twg-microsite-experience");
var _initUFO = require("./analytics/react-ufo/initUFO");
var _getDocument;
// Initialise Sentry before rendering the app.
// Disabled in dev environments (localhost / development / local).
(0, _twgMicrositeExperience.initSentry)();
// Initialise React UFO before rendering so the React Profiler subscription
// is in place when the first commit happens.
(0, _initUFO.initUFO)();
// Brute force new app logos
// eslint-disable-next-line @atlaskit/platform/no-module-level-eval
(0, _platformFeatureFlags.setBooleanFeatureFlagResolver)(function(flagName) {
    return flagName === 'platform-logo-rebrand';
});
var rootNode = (_getDocument = (0, _browserApis.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.getElementById('pillar-root');
if (rootNode) {
    var root = (0, _client.createRoot)(rootNode);
    root.render(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _app.App), {}));
}

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","react-dom/client":"2ebWF","@atlaskit/platform-feature-flags":"kO5t9","@atlaskit/browser-apis":"2dayt","./ui/App":"7XeDp","@atlassian/twg-microsite-experience":"3ciWs","./analytics/react-ufo/initUFO":"7lXyx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bGvcw":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("8f6663d459303948");

},{"8f6663d459303948":"kXQRc"}],"kXQRc":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var f = require("1fb5592ff6bdf302"), k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: n.current
    };
}
exports.Fragment = l;
exports.jsx = q;
exports.jsxs = q;

},{"1fb5592ff6bdf302":"ltHCL"}],"ltHCL":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("a94a675d5a7c6f10");

},{"a94a675d5a7c6f10":"526IC"}],"526IC":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var l = Symbol.for("react.element"), n = Symbol.for("react.portal"), p = Symbol.for("react.fragment"), q = Symbol.for("react.strict_mode"), r = Symbol.for("react.profiler"), t = Symbol.for("react.provider"), u = Symbol.for("react.context"), v = Symbol.for("react.forward_ref"), w = Symbol.for("react.suspense"), x = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), z = Symbol.iterator;
function A(a) {
    if (null === a || "object" !== (typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a))) return null;
    a = z && a[z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var B = {
    isMounted: function isMounted() {
        return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
}, C = Object.assign, D = {};
function E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
E.prototype.isReactComponent = {};
E.prototype.setState = function(a, b) {
    if ("object" !== (typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)) && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function F() {}
F.prototype = E.prototype;
function G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
var H = G.prototype = new F;
H.constructor = G;
C(H, E.prototype);
H.isPureReactComponent = !0;
var I = Array.isArray, J = Object.prototype.hasOwnProperty, K = {
    current: null
}, L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)J.call(b, d) && !L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: K.current
    };
}
function N(a, b) {
    return {
        $$typeof: l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function O(a) {
    return "object" === (typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)) && null !== a && a.$$typeof === l;
}
function escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var P = /\/+/g;
function Q(a, b) {
    return "object" === (typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)) && null !== a && null != a.key ? escape("" + a.key) : b.toString(36);
}
function R(a, b, e, d, c) {
    var k = typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a);
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case l:
                case n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + Q(h, 0) : d, I(c) ? (e = "", null != a && (e = a.replace(P, "$&/") + "/"), R(c, b, e, "", function(a) {
        return a;
    })) : null != c && (O(c) && (c = N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace(P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if (I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + Q(k, g);
        h += R(k, b, e, f, c);
    }
    else if (f = A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + Q(k, g++), h += R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var U = {
    current: null
}, V = {
    transition: null
}, W = {
    ReactCurrentDispatcher: U,
    ReactCurrentBatchConfig: V,
    ReactCurrentOwner: K
};
function X() {
    throw Error("act(...) is not supported in production builds of React.");
}
exports.Children = {
    map: S,
    forEach: function forEach(a, b, e) {
        S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function count(a) {
        var b = 0;
        S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function toArray(a) {
        return S(a, function(a) {
            return a;
        }) || [];
    },
    only: function only(a) {
        if (!O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
exports.Component = E;
exports.Fragment = p;
exports.Profiler = r;
exports.PureComponent = G;
exports.StrictMode = q;
exports.Suspense = w;
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = W;
exports.act = X;
exports.cloneElement = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)J.call(b, f) && !L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
exports.createContext = function(a) {
    a = {
        $$typeof: u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: t,
        _context: a
    };
    return a.Consumer = a;
};
exports.createElement = M;
exports.createFactory = function(a) {
    var b = M.bind(null, a);
    b.type = a;
    return b;
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(a) {
    return {
        $$typeof: v,
        render: a
    };
};
exports.isValidElement = O;
exports.lazy = function(a) {
    return {
        $$typeof: y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: T
    };
};
exports.memo = function(a, b) {
    return {
        $$typeof: x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
exports.startTransition = function(a) {
    var b = V.transition;
    V.transition = {};
    try {
        a();
    } finally{
        V.transition = b;
    }
};
exports.unstable_act = X;
exports.useCallback = function(a, b) {
    return U.current.useCallback(a, b);
};
exports.useContext = function(a) {
    return U.current.useContext(a);
};
exports.useDebugValue = function() {};
exports.useDeferredValue = function(a) {
    return U.current.useDeferredValue(a);
};
exports.useEffect = function(a, b) {
    return U.current.useEffect(a, b);
};
exports.useId = function() {
    return U.current.useId();
};
exports.useImperativeHandle = function(a, b, e) {
    return U.current.useImperativeHandle(a, b, e);
};
exports.useInsertionEffect = function(a, b) {
    return U.current.useInsertionEffect(a, b);
};
exports.useLayoutEffect = function(a, b) {
    return U.current.useLayoutEffect(a, b);
};
exports.useMemo = function(a, b) {
    return U.current.useMemo(a, b);
};
exports.useReducer = function(a, b, e) {
    return U.current.useReducer(a, b, e);
};
exports.useRef = function(a) {
    return U.current.useRef(a);
};
exports.useState = function(a) {
    return U.current.useState(a);
};
exports.useSyncExternalStore = function(a, b, e) {
    return U.current.useSyncExternalStore(a, b, e);
};
exports.useTransition = function() {
    return U.current.useTransition();
};
exports.version = "18.3.1";

},{"@swc/helpers/_/_type_of":"iFJdx"}],"2ebWF":[function(require,module,exports,__globalThis) {
'use strict';
var m = require("f12fe9ca6f307f1");
var i;
exports.createRoot = m.createRoot;
exports.hydrateRoot = m.hydrateRoot;

},{"f12fe9ca6f307f1":"bvX0P"}],"bvX0P":[function(require,module,exports,__globalThis) {
'use strict';
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("c03e607a51bccdf1");

},{"c03e607a51bccdf1":"cG2yi"}],"cG2yi":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var _instanceof = require("@swc/helpers/_/_instanceof");
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var aa = require("bd7f3b4998918581"), ca = require("653854775ab22d43");
function p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var da = new Set, ea = {};
function fa(a, b) {
    ha(a, b);
    ha(a + "Capture", b);
}
function ha(a, b) {
    ea[a] = b;
    for(a = 0; a < b.length; a++)da.add(b[a]);
}
var ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ja = Object.prototype.hasOwnProperty, ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, la = {}, ma = {};
function oa(a) {
    if (ja.call(ma, a)) return !0;
    if (ja.call(la, a)) return !1;
    if (ka.test(a)) return ma[a] = !0;
    la[a] = !0;
    return !1;
}
function pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b === "undefined" ? "undefined" : (0, _typeOf._)(b)){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    z[a] = new v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    z[b] = new v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    z[a] = new v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    z[a] = new v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    z[a] = new v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    z[a] = new v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    z[a] = new v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var ra = /[\-:]([a-z])/g;
function sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
z.xlinkHref = new v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function ta(a, b, c, d) {
    var e = z.hasOwnProperty(b) ? z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) qa(b, c, e, d) && (c = null), d || null === e ? oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var ua = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, va = Symbol.for("react.element"), wa = Symbol.for("react.portal"), ya = Symbol.for("react.fragment"), za = Symbol.for("react.strict_mode"), Aa = Symbol.for("react.profiler"), Ba = Symbol.for("react.provider"), Ca = Symbol.for("react.context"), Da = Symbol.for("react.forward_ref"), Ea = Symbol.for("react.suspense"), Fa = Symbol.for("react.suspense_list"), Ga = Symbol.for("react.memo"), Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var Ja = Symbol.iterator;
function Ka(a) {
    if (null === a || "object" !== (typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a))) return null;
    a = Ja && a[Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var A = Object.assign, La;
function Ma(a) {
    if (void 0 === La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        La = b && b[1] || "";
    }
    return "\n" + La + a;
}
var Na = !1;
function Oa(a, b) {
    if (!a || Na) return "";
    Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function b() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function set() {
                    throw Error();
                }
            }), "object" === (typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Ma(a) : "";
}
function Pa(a) {
    switch(a.tag){
        case 5:
            return Ma(a.type);
        case 16:
            return Ma("Lazy");
        case 13:
            return Ma("Suspense");
        case 19:
            return Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Oa(a.type, !1), a;
        case 11:
            return a = Oa(a.type.render, !1), a;
        case 1:
            return a = Oa(a.type, !0), a;
        default:
            return "";
    }
}
function Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ya:
            return "Fragment";
        case wa:
            return "Portal";
        case Aa:
            return "Profiler";
        case za:
            return "StrictMode";
        case Ea:
            return "Suspense";
        case Fa:
            return "SuspenseList";
    }
    if ("object" === (typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a))) switch(a.$$typeof){
        case Ca:
            return (a.displayName || "Context") + ".Consumer";
        case Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case Ga:
            return b = a.displayName || null, null !== b ? b : Qa(a.type) || "Memo";
        case Ha:
            b = a._payload;
            a = a._init;
            try {
                return Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return Qa(b);
        case 8:
            return b === za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function Sa(a) {
    switch(typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function get() {
                return e.call(this);
            },
            set: function set(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function getValue() {
                return d;
            },
            setValue: function setValue(a) {
                d = "" + a;
            },
            stopTracking: function stopTracking() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function ab(a, b) {
    b = b.checked;
    null != b && ta(a, "checked", b, !1);
}
function bb(a, b) {
    ab(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && cb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function cb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var eb = Array.isArray;
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(p(91));
    return A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(p(92));
            if (eb(c)) {
                if (1 < c.length) throw Error(p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var mb, nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        mb = mb || document.createElement("div");
        mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(pb).forEach(function(a) {
    qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        pb[b] = pb[a];
    });
});
function rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || pb.hasOwnProperty(a) && pb[a] ? ("" + b).trim() : b + "px";
}
function sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var tb = A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function ub(a, b) {
    if (b) {
        if (tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(p(60));
            if ("object" !== (0, _typeOf._)(b.dangerouslySetInnerHTML) || !("__html" in b.dangerouslySetInnerHTML)) throw Error(p(61));
        }
        if (null != b.style && "object" !== (0, _typeOf._)(b.style)) throw Error(p(62));
    }
}
function vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var wb = null;
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(p(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb() {}
var Ib = !1;
function Jb(a, b, c) {
    if (Ib) return a(b, c);
    Ib = !0;
    try {
        return Gb(a, b, c);
    } finally{
        if (Ib = !1, null !== zb || null !== Ab) Hb(), Fb();
    }
}
function Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(p(231, b, typeof c === "undefined" ? "undefined" : (0, _typeOf._)(c)));
    return c;
}
var Lb = !1;
if (ia) try {
    var Mb = {};
    Object.defineProperty(Mb, "passive", {
        get: function get() {
            Lb = !0;
        }
    });
    window.addEventListener("test", Mb, Mb);
    window.removeEventListener("test", Mb, Mb);
} catch (a) {
    Lb = !1;
}
function Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var Ob = !1, Pb = null, Qb = !1, Rb = null, Sb = {
    onError: function onError(a) {
        Ob = !0;
        Pb = a;
    }
};
function Tb(a, b, c, d, e, f, g, h, k) {
    Ob = !1;
    Pb = null;
    Nb.apply(Sb, arguments);
}
function Ub(a, b, c, d, e, f, g, h, k) {
    Tb.apply(this, arguments);
    if (Ob) {
        if (Ob) {
            var l = Pb;
            Ob = !1;
            Pb = null;
        } else throw Error(p(198));
        Qb || (Qb = !0, Rb = l);
    }
}
function Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function Xb(a) {
    if (Vb(a) !== a) throw Error(p(188));
}
function Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = Vb(a);
        if (null === b) throw Error(p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return Xb(e), a;
                if (f === d) return Xb(e), b;
                f = f.sibling;
            }
            throw Error(p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(p(189));
            }
        }
        if (c.alternate !== d) throw Error(p(190));
    }
    if (3 !== c.tag) throw Error(p(188));
    return c.stateNode.current === c ? a : b;
}
function Zb(a) {
    a = Yb(a);
    return null !== a ? $b(a) : null;
}
function $b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var ac = ca.unstable_scheduleCallback, bc = ca.unstable_cancelCallback, cc = ca.unstable_shouldYield, dc = ca.unstable_requestPaint, B = ca.unstable_now, ec = ca.unstable_getCurrentPriorityLevel, fc = ca.unstable_ImmediatePriority, gc = ca.unstable_UserBlockingPriority, hc = ca.unstable_NormalPriority, ic = ca.unstable_LowPriority, jc = ca.unstable_IdlePriority, kc = null, lc = null;
function mc(a) {
    if (lc && "function" === typeof lc.onCommitFiberRoot) try {
        lc.onCommitFiberRoot(kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var oc = Math.clz32 ? Math.clz32 : nc, pc = Math.log, qc = Math.LN2;
function nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - (pc(a) / qc | 0) | 0;
}
var rc = 64, sc = 4194304;
function tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = tc(h) : (f &= g, 0 !== f && (d = tc(f)));
    } else g = c & ~e, 0 !== g ? d = tc(g) : 0 !== f && (d = tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function yc() {
    var a = rc;
    rc <<= 1;
    0 === (rc & 4194240) && (rc = 64);
    return a;
}
function zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - oc(b);
    a[b] = c;
}
function Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var C = 0;
function Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var Ec, Fc, Gc, Hc, Ic, Jc = !1, Kc = [], Lc = null, Mc = null, Nc = null, Oc = new Map, Pc = new Map, Qc = [], Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            Pc.delete(b.pointerId);
    }
}
function Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = Cb(b), null !== b && Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return Lc = Tc(Lc, a, b, c, d, e), !0;
        case "dragenter":
            return Mc = Tc(Mc, a, b, c, d, e), !0;
        case "mouseover":
            return Nc = Tc(Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            Oc.set(f, Tc(Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, Pc.set(f, Tc(Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function Vc(a) {
    var b = Wc(a.target);
    if (null !== b) {
        var c = Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = Wb(c), null !== b) {
                    a.blockedOn = b;
                    Ic(a.priority, function() {
                        Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            wb = d;
            c.target.dispatchEvent(d);
            wb = null;
        } else return b = Cb(c), null !== b && Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function Zc(a, b, c) {
    Xc(a) && c.delete(b);
}
function $c() {
    Jc = !1;
    null !== Lc && Xc(Lc) && (Lc = null);
    null !== Mc && Xc(Mc) && (Mc = null);
    null !== Nc && Xc(Nc) && (Nc = null);
    Oc.forEach(Zc);
    Pc.forEach(Zc);
}
function ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, Jc || (Jc = !0, ca.unstable_scheduleCallback(ca.unstable_NormalPriority, $c)));
}
function bd(a) {
    function b(b) {
        return ad(b, a);
    }
    if (0 < Kc.length) {
        ad(Kc[0], a);
        for(var c = 1; c < Kc.length; c++){
            var d = Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== Lc && ad(Lc, a);
    null !== Mc && ad(Mc, a);
    null !== Nc && ad(Nc, a);
    Oc.forEach(b);
    Pc.forEach(b);
    for(c = 0; c < Qc.length; c++)d = Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < Qc.length && (c = Qc[0], null === c.blockedOn);)Vc(c), null === c.blockedOn && Qc.shift();
}
var cd = ua.ReactCurrentBatchConfig, dd = !0;
function ed(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 1, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function gd(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 4, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function fd(a, b, c, d) {
    if (dd) {
        var e = Yc(a, b, c, d);
        if (null === e) hd(a, b, d, id, c), Sc(a, d);
        else if (Uc(e, a, b, c, d)) d.stopPropagation();
        else if (Sc(a, d), b & 4 && -1 < Rc.indexOf(a)) {
            for(; null !== e;){
                var f = Cb(e);
                null !== f && Ec(f);
                f = Yc(a, b, c, d);
                null === f && hd(a, b, d, id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else hd(a, b, d, null, c);
    }
}
var id = null;
function Yc(a, b, c, d) {
    id = null;
    a = xb(d);
    a = Wc(a);
    if (null !== a) {
        if (b = Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    id = a;
    return null;
}
function jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch(ec()){
                case fc:
                    return 1;
                case gc:
                    return 4;
                case hc:
                case ic:
                    return 16;
                case jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    A(b.prototype, {
        preventDefault: function preventDefault() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== (0, _typeOf._)(a.returnValue) && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function stopPropagation() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== (0, _typeOf._)(a.cancelBubble) && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function persist() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function timeStamp(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = A({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = A({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function relatedTarget(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function movementX(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function movementY(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = A({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = A({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = A({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = A({}, sd, {
    clipboardData: function clipboardData(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = A({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = A({}, ud, {
    key: function key(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function charCode(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function keyCode(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function which(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = A({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = A({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = A({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = A({}, Ad, {
    deltaX: function deltaX(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function deltaY(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = ia && "CompositionEvent" in window, be = null;
ia && "documentMode" in document && (be = document.documentMode);
var ce = ia && "TextEvent" in window && !be, de = ia && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === (typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)) && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (ia) {
    var xe;
    if (ia) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        Jb(re, b);
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge;
function Ie(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== (typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)) || null === a || "object" !== (typeof b === "undefined" ? "undefined" : (0, _typeOf._)(b)) || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!ja.call(b, e) || !He(a[e], b[e])) return !1;
    }
    return !0;
}
function Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Ke(a, b) {
    var c = Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Je(c);
    }
}
function Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Me() {
    for(var a = window, b = Xa(); (0, _instanceof._)(b, a.HTMLIFrameElement);){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function Oe(a) {
    var b = Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = Ke(c, f);
                var g = Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var Pe = ia && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Ie(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
function Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var We = {
    animationend: Ve("Animation", "AnimationEnd"),
    animationiteration: Ve("Animation", "AnimationIteration"),
    animationstart: Ve("Animation", "AnimationStart"),
    transitionend: Ve("Transition", "TransitionEnd")
}, Xe = {}, Ye = {};
ia && (Ye = document.createElement("div").style, "AnimationEvent" in window || (delete We.animationend.animation, delete We.animationiteration.animation, delete We.animationstart.animation), "TransitionEvent" in window || delete We.transitionend.transition);
function Ze(a) {
    if (Xe[a]) return Xe[a];
    if (!We[a]) return a;
    var b = We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Ye) return Xe[a] = b[c];
    return a;
}
var $e = Ze("animationend"), af = Ze("animationiteration"), bf = Ze("animationstart"), cf = Ze("transitionend"), df = new Map, ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function ff(a, b) {
    df.set(a, b);
    fa(b, [
        a
    ]);
}
for(var gf = 0; gf < ef.length; gf++){
    var hf = ef[gf], jf = hf.toLowerCase(), kf = hf[0].toUpperCase() + hf.slice(1);
    ff(jf, "on" + kf);
}
ff($e, "onAnimationEnd");
ff(af, "onAnimationIteration");
ff(bf, "onAnimationStart");
ff("dblclick", "onDoubleClick");
ff("focusin", "onFocus");
ff("focusout", "onBlur");
ff(cf, "onTransitionEnd");
ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), mf = new Set("cancel close invalid load scroll toggle".split(" ").concat(lf));
function nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
        }
    }
    if (Qb) throw a = Rb, Qb = !1, Rb = null, a;
}
function D(a, b) {
    var c = b[of];
    void 0 === c && (c = b[of] = new Set);
    var d = a + "__bubble";
    c.has(d) || (pf(b, a, 2, !1), c.add(d));
}
function qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    pf(c, a, d, b);
}
var rf = "_reactListening" + Math.random().toString(36).slice(2);
function sf(a) {
    if (!a[rf]) {
        a[rf] = !0;
        da.forEach(function(b) {
            "selectionchange" !== b && (mf.has(b) || qf(b, !1, a), qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[rf] || (b[rf] = !0, qf("selectionchange", !1, b));
    }
}
function pf(a, b, c, d) {
    switch(jd(b)){
        case 1:
            var e = ed;
            break;
        case 4:
            e = gd;
            break;
        default:
            e = fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Jb(function() {
        var _$d = f, _$e = xb(c), g = [];
        a: {
            var h = df.get(a);
            if (void 0 !== h) {
                var k = td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case $e:
                    case af:
                    case bf:
                        k = Hd;
                        break;
                    case cf:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = _$d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = Kb(w, x), null != F && t.push(tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, _$e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== wb && (n = c.relatedTarget || c.fromElement) && (Wc(n) || n[uf])) break a;
                if (k || h) {
                    h = _$e.window === _$e ? _$e : (h = _$e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = _$d, n = n ? Wc(n) : null, null !== n && (J = Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = _$d;
                    if (k !== n) {
                        t = Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : ue(k);
                        u = null == n ? h : ue(n);
                        h = new t(F, w + "leave", k, c, _$e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        Wc(_$e) === _$d && (t = new t(x, w + "enter", n, c, _$e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = vf(u))w++;
                            u = 0;
                            for(F = x; F; F = vf(F))u++;
                            for(; 0 < w - u;)t = vf(t), w--;
                            for(; 0 < u - w;)x = vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = vf(t);
                                x = vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && wf(g, h, k, t, !1);
                        null !== n && null !== J && wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = _$d ? ue(_$d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = ve;
                else if (me(h)) {
                    if (we) na = Fe;
                    else {
                        na = De;
                        var xa = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = Ee);
                if (na && (na = na(a, _$d))) {
                    ne(g, na, c, _$e);
                    break a;
                }
                xa && xa(a, h, _$d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && cb(h, "number", h.value);
            }
            xa = _$d ? ue(_$d) : window;
            switch(a){
                case "focusin":
                    if (me(xa) || "true" === xa.contentEditable) Qe = xa, Re = _$d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, _$e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, _$e);
            }
            var $a;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else ie ? ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && ie && ($a = nd()) : (kd = _$e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), xa = oe(_$d, ba), 0 < xa.length && (ba = new Ld(ba, a, null, c, _$e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = he(c), null !== $a && (ba.data = $a))));
            if ($a = ce ? je(a, c) : ke(a, c)) _$d = oe(_$d, "onBeforeInput"), 0 < _$d.length && (_$e = new Ld("onBeforeInput", "beforeinput", null, c, _$e), g.push({
                event: _$e,
                listeners: _$d
            }), _$e.data = $a);
        }
        se(g, b);
    });
}
function tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Kb(a, c), null != f && d.unshift(tf(a, f, e)), f = Kb(a, b), null != f && d.push(tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Kb(c, f), null != k && g.unshift(tf(c, k, h))) : e || (k = Kb(c, f), null != k && g.push(tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var xf = /\r\n?/g, yf = /\u0000|\uFFFD/g;
function zf(a) {
    return ("string" === typeof a ? a : "" + a).replace(xf, "\n").replace(yf, "");
}
function Af(a, b, c) {
    b = zf(b);
    if (zf(a) !== b && c) throw Error(p(425));
}
function Bf() {}
var Cf = null, Df = null;
function Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === (0, _typeOf._)(b.dangerouslySetInnerHTML) && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var Ff = "function" === typeof setTimeout ? setTimeout : void 0, Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, Hf = "function" === typeof Promise ? Promise : void 0, Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof Hf ? function Jf(a) {
    return Hf.resolve(null).then(a).catch(If);
} : Ff;
function If(a) {
    setTimeout(function() {
        throw a;
    });
}
function Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    bd(b);
}
function Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var Nf = Math.random().toString(36).slice(2), Of = "__reactFiber$" + Nf, Pf = "__reactProps$" + Nf, uf = "__reactContainer$" + Nf, of = "__reactEvents$" + Nf, Qf = "__reactListeners$" + Nf, Rf = "__reactHandles$" + Nf;
function Wc(a) {
    var b = a[Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[uf] || c[Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = Mf(a); null !== a;){
                if (c = a[Of]) return c;
                a = Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[Of] || a[uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(p(33));
}
function Db(a) {
    return a[Pf] || null;
}
var Sf = [], Tf = -1;
function Uf(a) {
    return {
        current: a
    };
}
function E(a) {
    0 > Tf || (a.current = Sf[Tf], Sf[Tf] = null, Tf--);
}
function G(a, b) {
    Tf++;
    Sf[Tf] = a.current;
    a.current = b;
}
var Vf = {}, H = Uf(Vf), Wf = Uf(!1), Xf = Vf;
function Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $f() {
    E(Wf);
    E(H);
}
function ag(a, b, c) {
    if (H.current !== Vf) throw Error(p(168));
    G(H, b);
    G(Wf, c);
}
function bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error(p(108, Ra(a) || "Unknown", e));
    return A({}, c, d);
}
function cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Vf;
    Xf = H.current;
    G(H, a);
    G(Wf, Wf.current);
    return !0;
}
function dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(p(169));
    c ? (a = bg(a, b, Xf), d.__reactInternalMemoizedMergedChildContext = a, E(Wf), E(H), G(H, a)) : E(Wf);
    G(Wf, c);
}
var eg = null, fg = !1, gg = !1;
function hg(a) {
    null === eg ? eg = [
        a
    ] : eg.push(a);
}
function ig(a) {
    fg = !0;
    hg(a);
}
function jg() {
    if (!gg && null !== eg) {
        gg = !0;
        var a = 0, b = C;
        try {
            var c = eg;
            for(C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            eg = null;
            fg = !1;
        } catch (e) {
            throw null !== eg && (eg = eg.slice(a + 1)), ac(fc, jg), e;
        } finally{
            C = b, gg = !1;
        }
    }
    return null;
}
var kg = [], lg = 0, mg = null, ng = 0, og = [], pg = 0, qg = null, rg = 1, sg = "";
function tg(a, b) {
    kg[lg++] = ng;
    kg[lg++] = mg;
    mg = a;
    ng = b;
}
function ug(a, b, c) {
    og[pg++] = rg;
    og[pg++] = sg;
    og[pg++] = qg;
    qg = a;
    var d = rg;
    a = sg;
    var e = 32 - oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        rg = 1 << 32 - oc(b) + e | c << e | d;
        sg = f + a;
    } else rg = 1 << f | c << e | d, sg = a;
}
function vg(a) {
    null !== a.return && (tg(a, 1), ug(a, 1, 0));
}
function wg(a) {
    for(; a === mg;)mg = kg[--lg], kg[lg] = null, ng = kg[--lg], kg[lg] = null;
    for(; a === qg;)qg = og[--pg], og[pg] = null, sg = og[--pg], og[pg] = null, rg = og[--pg], og[pg] = null;
}
var xg = null, yg = null, I = !1, zg = null;
function Ag(a, b) {
    var c = Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, xg = a, yg = Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, xg = a, yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== qg ? {
                id: rg,
                overflow: sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, xg = a, yg = null, !0) : !1;
        default:
            return !1;
    }
}
function Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function Eg(a) {
    if (I) {
        var b = yg;
        if (b) {
            var c = b;
            if (!Cg(a, b)) {
                if (Dg(a)) throw Error(p(418));
                b = Lf(c.nextSibling);
                var d = xg;
                b && Cg(a, b) ? Ag(d, c) : (a.flags = a.flags & -4097 | 2, I = !1, xg = a);
            }
        } else {
            if (Dg(a)) throw Error(p(418));
            a.flags = a.flags & -4097 | 2;
            I = !1;
            xg = a;
        }
    }
}
function Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    xg = a;
}
function Gg(a) {
    if (a !== xg) return !1;
    if (!I) return Fg(a), I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !Ef(a.type, a.memoizedProps));
    if (b && (b = yg)) {
        if (Dg(a)) throw Hg(), Error(p(418));
        for(; b;)Ag(a, b), b = Lf(b.nextSibling);
    }
    Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            yg = Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            yg = null;
        }
    } else yg = xg ? Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function Hg() {
    for(var a = yg; a;)a = Lf(a.nextSibling);
}
function Ig() {
    yg = xg = null;
    I = !1;
}
function Jg(a) {
    null === zg ? zg = [
        a
    ] : zg.push(a);
}
var Kg = ua.ReactCurrentBatchConfig;
function Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== (typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a))) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function b(a) {
                var _$b = e.refs;
                null === a ? delete _$b[f] : _$b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error(p(284));
        if (!c._owner) throw Error(p(290, a));
    }
    return a;
}
function Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error(p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === (typeof f === "undefined" ? "undefined" : (0, _typeOf._)(f)) && null !== f && f.$$typeof === Ha && Ng(f) === b.type)) return d = e(b, c.props), d.ref = Lg(a, b, c), d.return = a, d;
        d = Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === (typeof b === "undefined" ? "undefined" : (0, _typeOf._)(b)) && null !== b) {
            switch(b.$$typeof){
                case va:
                    return c = Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = Lg(a, null, b), c.return = a, c;
                case wa:
                    return b = Sg(b, a.mode, c), b.return = a, b;
                case Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if (eb(b) || Ka(b)) return b = Tg(b, a.mode, c, null), b.return = a, b;
            Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === (typeof c === "undefined" ? "undefined" : (0, _typeOf._)(c)) && null !== c) {
            switch(c.$$typeof){
                case va:
                    return c.key === e ? k(a, b, c, d) : null;
                case wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if (eb(c) || Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === (typeof d === "undefined" ? "undefined" : (0, _typeOf._)(d)) && null !== d) {
            switch(d.$$typeof){
                case va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if (eb(d) || Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), I && tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            I && tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = Ka(h);
        if ("function" !== typeof l) throw Error(p(150));
        h = l.call(h);
        if (null == h) throw Error(p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), I && tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            I && tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === (typeof f === "undefined" ? "undefined" : (0, _typeOf._)(f)) && null !== f && f.type === ya && null === f.key && (f = f.props.children);
        if ("object" === (typeof f === "undefined" ? "undefined" : (0, _typeOf._)(f)) && null !== f) {
            switch(f.$$typeof){
                case va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === (typeof k === "undefined" ? "undefined" : (0, _typeOf._)(k)) && null !== k && k.$$typeof === Ha && Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === ya ? (d = Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if (eb(f)) return n(a, d, f, h);
            if (Ka(f)) return t(a, d, f, h);
            Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var Ug = Og(!0), Vg = Og(!1), Wg = Uf(null), Xg = null, Yg = null, Zg = null;
function $g() {
    Zg = Yg = Xg = null;
}
function ah(a) {
    var b = Wg.current;
    E(Wg);
    a._currentValue = b;
}
function bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function ch(a, b) {
    Xg = a;
    Zg = Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (dh = !0), a.firstContext = null);
}
function eh(a) {
    var b = a._currentValue;
    if (Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === Yg) {
            if (null === Xg) throw Error(p(308));
            Yg = a;
            Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else Yg = Yg.next = a;
    }
    return b;
}
var fh = null;
function gh(a) {
    null === fh ? fh = [
        a
    ] : fh.push(a);
}
function hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return ih(a, d);
}
function ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var jh = !1;
function kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== (K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return ih(a, c);
}
function oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
function ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function qh(a, b, c, d) {
    var e = a.updateQueue;
    jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = A({}, q, r);
                            break a;
                        case 2:
                            jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(p(191, e));
            e.call(d);
        }
    }
}
var th = {}, uh = Uf(th), vh = Uf(th), wh = Uf(th);
function xh(a) {
    if (a === th) throw Error(p(174));
    return a;
}
function yh(a, b) {
    G(wh, b);
    G(vh, a);
    G(uh, th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = lb(b, a);
    }
    E(uh);
    G(uh, b);
}
function zh() {
    E(uh);
    E(vh);
    E(wh);
}
function Ah(a) {
    xh(wh.current);
    var b = xh(uh.current);
    var c = lb(b, a.type);
    b !== c && (G(vh, a), G(uh, c));
}
function Bh(a) {
    vh.current === a && (E(uh), E(vh));
}
var L = Uf(0);
function Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var Dh = [];
function Eh() {
    for(var a = 0; a < Dh.length; a++)Dh[a]._workInProgressVersionPrimary = null;
    Dh.length = 0;
}
var Fh = ua.ReactCurrentDispatcher, Gh = ua.ReactCurrentBatchConfig, Hh = 0, M = null, N = null, O = null, Ih = !1, Jh = !1, Kh = 0, Lh = 0;
function P() {
    throw Error(p(321));
}
function Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Nh(a, b, c, d, e, f) {
    Hh = f;
    M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    Fh.current = null === a || null === a.memoizedState ? Oh : Ph;
    a = c(d, e);
    if (Jh) {
        f = 0;
        do {
            Jh = !1;
            Kh = 0;
            if (25 <= f) throw Error(p(301));
            f += 1;
            O = N = null;
            b.updateQueue = null;
            Fh.current = Qh;
            a = c(d, e);
        }while (Jh);
    }
    Fh.current = Rh;
    b = null !== N && null !== N.next;
    Hh = 0;
    O = N = M = null;
    Ih = !1;
    if (b) throw Error(p(300));
    return a;
}
function Sh() {
    var a = 0 !== Kh;
    Kh = 0;
    return a;
}
function Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === O ? M.memoizedState = O = a : O = O.next = a;
    return O;
}
function Uh() {
    if (null === N) {
        var a = M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = N.next;
    var b = null === O ? M.memoizedState : O.next;
    if (null !== b) O = b, N = a;
    else {
        if (null === a) throw Error(p(310));
        N = a;
        a = {
            memoizedState: N.memoizedState,
            baseState: N.baseState,
            baseQueue: N.baseQueue,
            queue: N.queue,
            next: null
        };
        null === O ? M.memoizedState = O = a : O = O.next = a;
    }
    return O;
}
function Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Wh(a) {
    var b = Uh(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if ((Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                M.lanes |= m;
                rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        He(d, b.memoizedState) || (dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, M.lanes |= f, rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Xh(a) {
    var b = Uh(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Yh() {}
function Zh(a, b) {
    var c = M, d = Uh(), e = b(), f = !He(d.memoizedState, e);
    f && (d.memoizedState = e, dh = !0);
    d = d.queue;
    $h(ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== O && O.memoizedState.tag & 1) {
        c.flags |= 2048;
        bi(9, ci.bind(null, c, d, e, b), void 0, null);
        if (null === Q) throw Error(p(349));
        0 !== (Hh & 30) || di(c, b, e);
    }
    return e;
}
function di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    ei(b) && fi(a);
}
function ai(a, b, c) {
    return c(function() {
        ei(b) && fi(a);
    });
}
function ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !He(a, c);
    } catch (d) {
        return !0;
    }
}
function fi(a) {
    var b = ih(a, 1);
    null !== b && gi(b, a, 1, -1);
}
function hi(a) {
    var b = Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = ii.bind(null, M, a);
    return [
        b.memoizedState,
        a
    ];
}
function bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function ji() {
    return Uh().memoizedState;
}
function ki(a, b, c, d) {
    var e = Th();
    M.flags |= a;
    e.memoizedState = bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function li(a, b, c, d) {
    var e = Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== N) {
        var g = N.memoizedState;
        f = g.destroy;
        if (null !== d && Mh(d, g.deps)) {
            e.memoizedState = bi(b, c, f, d);
            return;
        }
    }
    M.flags |= a;
    e.memoizedState = bi(1 | b, c, f, d);
}
function mi(a, b) {
    return ki(8390656, 8, a, b);
}
function $h(a, b) {
    return li(2048, 8, a, b);
}
function ni(a, b) {
    return li(4, 2, a, b);
}
function oi(a, b) {
    return li(4, 4, a, b);
}
function pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return li(4, 4, pi.bind(null, b, a), c);
}
function ri() {}
function si(a, b) {
    var c = Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ti(a, b) {
    var c = Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ui(a, b, c) {
    if (0 === (Hh & 21)) return a.baseState && (a.baseState = !1, dh = !0), a.memoizedState = c;
    He(c, b) || (c = yc(), M.lanes |= c, rh |= c, a.baseState = !0);
    return b;
}
function vi(a, b) {
    var c = C;
    C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = Gh.transition;
    Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        C = c, Gh.transition = d;
    }
}
function wi() {
    return Uh().memoizedState;
}
function xi(a, b, c) {
    var d = yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (zi(a)) Ai(b, c);
    else if (c = hh(a, b, c, d), null !== c) {
        var e = R();
        gi(c, a, d, e);
        Bi(c, b, d);
    }
}
function ii(a, b, c) {
    var d = yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (zi(a)) Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if (He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = hh(a, b, e, d);
        null !== c && (e = R(), gi(c, a, d, e), Bi(c, b, d));
    }
}
function zi(a) {
    var b = a.alternate;
    return a === M || null !== b && b === M;
}
function Ai(a, b) {
    Jh = Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
var Rh = {
    readContext: eh,
    useCallback: P,
    useContext: P,
    useEffect: P,
    useImperativeHandle: P,
    useInsertionEffect: P,
    useLayoutEffect: P,
    useMemo: P,
    useReducer: P,
    useRef: P,
    useState: P,
    useDebugValue: P,
    useDeferredValue: P,
    useTransition: P,
    useMutableSource: P,
    useSyncExternalStore: P,
    useId: P,
    unstable_isNewReconciler: !1
}, Oh = {
    readContext: eh,
    useCallback: function useCallback(a, b) {
        Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: eh,
    useEffect: mi,
    useImperativeHandle: function useImperativeHandle(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return ki(4194308, 4, pi.bind(null, b, a), c);
    },
    useLayoutEffect: function useLayoutEffect(a, b) {
        return ki(4194308, 4, a, b);
    },
    useInsertionEffect: function useInsertionEffect(a, b) {
        return ki(4, 2, a, b);
    },
    useMemo: function useMemo(a, b) {
        var c = Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function useReducer(a, b, c) {
        var d = Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = xi.bind(null, M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function useRef(a) {
        var b = Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: hi,
    useDebugValue: ri,
    useDeferredValue: function useDeferredValue(a) {
        return Th().memoizedState = a;
    },
    useTransition: function useTransition() {
        var a = hi(!1), b = a[0];
        a = vi.bind(null, a[1]);
        Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function useMutableSource() {},
    useSyncExternalStore: function useSyncExternalStore(a, b, c) {
        var d = M, e = Th();
        if (I) {
            if (void 0 === c) throw Error(p(407));
            c = c();
        } else {
            c = b();
            if (null === Q) throw Error(p(349));
            0 !== (Hh & 30) || di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        mi(ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        bi(9, ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function useId() {
        var a = Th(), b = Q.identifierPrefix;
        if (I) {
            var c = sg;
            var d = rg;
            c = (d & ~(1 << 32 - oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, Ph = {
    readContext: eh,
    useCallback: si,
    useContext: eh,
    useEffect: $h,
    useImperativeHandle: qi,
    useInsertionEffect: ni,
    useLayoutEffect: oi,
    useMemo: ti,
    useReducer: Wh,
    useRef: ji,
    useState: function useState() {
        return Wh(Vh);
    },
    useDebugValue: ri,
    useDeferredValue: function useDeferredValue(a) {
        var b = Uh();
        return ui(b, N.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = Wh(Vh)[0], b = Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: Yh,
    useSyncExternalStore: Zh,
    useId: wi,
    unstable_isNewReconciler: !1
}, Qh = {
    readContext: eh,
    useCallback: si,
    useContext: eh,
    useEffect: $h,
    useImperativeHandle: qi,
    useInsertionEffect: ni,
    useLayoutEffect: oi,
    useMemo: ti,
    useReducer: Xh,
    useRef: ji,
    useState: function useState() {
        return Xh(Vh);
    },
    useDebugValue: ri,
    useDeferredValue: function useDeferredValue(a) {
        var b = Uh();
        return null === N ? b.memoizedState = a : ui(b, N.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = Xh(Vh)[0], b = Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: Yh,
    useSyncExternalStore: Zh,
    useId: wi,
    unstable_isNewReconciler: !1
};
function Ci(a, b) {
    if (a && a.defaultProps) {
        b = A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Ei = {
    isMounted: function isMounted(a) {
        return (a = a._reactInternals) ? Vb(a) === a : !1;
    },
    enqueueSetState: function enqueueSetState(a, b, c) {
        a = a._reactInternals;
        var d = R(), e = yi(a), f = mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = nh(a, f, e);
        null !== b && (gi(b, a, e, d), oh(b, a, e));
    },
    enqueueReplaceState: function enqueueReplaceState(a, b, c) {
        a = a._reactInternals;
        var d = R(), e = yi(a), f = mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = nh(a, f, e);
        null !== b && (gi(b, a, e, d), oh(b, a, e));
    },
    enqueueForceUpdate: function enqueueForceUpdate(a, b) {
        a = a._reactInternals;
        var c = R(), d = yi(a), e = mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = nh(a, e, d);
        null !== b && (gi(b, a, d, c), oh(b, a, d));
    }
};
function Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Ie(c, d) || !Ie(e, f) : !0;
}
function Gi(a, b, c) {
    var d = !1, e = Vf;
    var f = b.contextType;
    "object" === (typeof f === "undefined" ? "undefined" : (0, _typeOf._)(f)) && null !== f ? f = eh(f) : (e = Zf(b) ? Xf : H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Yf(a, e) : Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Ei.enqueueReplaceState(b, b.state, null);
}
function Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    kh(a);
    var f = b.contextType;
    "object" === (typeof f === "undefined" ? "undefined" : (0, _typeOf._)(f)) && null !== f ? e.context = eh(f) : (f = Zf(b) ? Xf : H.current, e.context = Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Ei.enqueueReplaceState(e, e.state, null), qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function Ji(a, b) {
    try {
        var c = "", d = b;
        do c += Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Mi = "function" === typeof WeakMap ? WeakMap : Map;
function Ni(a, b, c) {
    c = mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Oi || (Oi = !0, Pi = d);
        Li(a, b);
    };
    return c;
}
function Qi(a, b, c) {
    c = mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        Li(a, b);
        "function" !== typeof d && (null === Ri ? Ri = new Set([
            this
        ]) : Ri.add(this));
        var _$c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== _$c ? _$c : ""
        });
    });
    return c;
}
function Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = Ti.bind(null, a, b, c), b.then(a, a));
}
function Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = mh(-1, 1), b.tag = 2, nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var Wi = ua.ReactCurrentOwner, dh = !1;
function Xi(a, b, c, d) {
    b.child = null === a ? Vg(b, null, c, d) : Ug(b, a.child, c, d);
}
function Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    ch(b, e);
    d = Nh(a, b, c, d, f, e);
    c = Sh();
    if (null !== a && !dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zi(a, b, e);
    I && c && vg(b);
    b.flags |= 1;
    Xi(a, b, d, e);
    return b.child;
}
function $i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, bj(a, b, f, d, e);
        a = Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : Ie;
        if (c(g, d) && a.ref === b.ref) return Zi(a, b, e);
    }
    b.flags |= 1;
    a = Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if (Ie(f, d) && a.ref === b.ref) {
            if (dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && (dh = !0);
            else return b.lanes = a.lanes, Zi(a, b, e);
        }
    }
    return cj(a, b, c, d, e);
}
function dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, G(ej, fj), fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, G(ej, fj), fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            G(ej, fj);
            fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, G(ej, fj), fj |= d;
    Xi(a, b, e, c);
    return b.child;
}
function gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function cj(a, b, c, d, e) {
    var f = Zf(c) ? Xf : H.current;
    f = Yf(b, f);
    ch(b, e);
    c = Nh(a, b, c, d, f, e);
    d = Sh();
    if (null !== a && !dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zi(a, b, e);
    I && d && vg(b);
    b.flags |= 1;
    Xi(a, b, c, e);
    return b.child;
}
function hj(a, b, c, d, e) {
    if (Zf(c)) {
        var f = !0;
        cg(b);
    } else f = !1;
    ch(b, e);
    if (null === b.stateNode) ij(a, b), Gi(b, c, d), Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === (typeof l === "undefined" ? "undefined" : (0, _typeOf._)(l)) && null !== l ? l = eh(l) : (l = Zf(c) ? Xf : H.current, l = Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Hi(b, g, d, l);
        jh = !1;
        var r = b.memoizedState;
        g.state = r;
        qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || Wf.current || jh ? ("function" === typeof m && (Di(b, c, m, d), k = b.memoizedState), (h = jh || Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === (typeof k === "undefined" ? "undefined" : (0, _typeOf._)(k)) && null !== k ? k = eh(k) : (k = Zf(c) ? Xf : H.current, k = Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && Hi(b, g, d, k);
        jh = !1;
        r = b.memoizedState;
        g.state = r;
        qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || Wf.current || jh ? ("function" === typeof y && (Di(b, c, y, d), n = b.memoizedState), (l = jh || Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return jj(a, b, c, d, f, e);
}
function jj(a, b, c, d, e, f) {
    gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && dg(b, c, !1), Zi(a, b, f);
    d = b.stateNode;
    Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Ug(b, a.child, null, f), b.child = Ug(b, null, h, f)) : Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && dg(b, c, !0);
    return b.child;
}
function kj(a) {
    var b = a.stateNode;
    b.pendingContext ? ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && ag(a, b.context, !1);
    yh(a, b.containerInfo);
}
function lj(a, b, c, d, e) {
    Ig();
    Jg(e);
    b.flags |= 256;
    Xi(a, b, c, d);
    return b.child;
}
var mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function oj(a, b, c) {
    var d = b.pendingProps, e = L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    G(L, e & 1);
    if (null === a) {
        Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = pj(g, d, 0, null), a = Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = nj(c), b.memoizedState = mj, a) : qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = Pg(h, f) : (f = Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function qj(a, b) {
    b = pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function sj(a, b, c, d) {
    null !== d && Jg(d);
    Ug(b, a.child, null, c);
    a = qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = Ki(Error(p(422))), sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && Ug(b, a.child, null, g);
        b.child.memoizedState = nj(g);
        b.memoizedState = mj;
        return f;
    }
    if (0 === (b.mode & 1)) return sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error(p(419));
        d = Ki(f, d, void 0);
        return sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if (dh || h) {
        d = Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, ih(a, e), gi(d, a, e, -1));
        }
        tj();
        d = Ki(Error(p(421)));
        return sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    yg = Lf(e.nextSibling);
    xg = b;
    I = !0;
    zg = null;
    null !== a && (og[pg++] = rg, og[pg++] = sg, og[pg++] = qg, rg = a.id, sg = a.overflow, qg = b);
    b = qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    bh(a.return, b, c);
}
function wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    Xi(a, b, d.children, c);
    d = L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && vj(a, c, b);
            else if (19 === a.tag) vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    G(L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            wj(b, !0, c, null, f);
            break;
        case "together":
            wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error(p(153));
    if (null !== b.child) {
        a = b.child;
        c = Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function yj(a, b, c) {
    switch(b.tag){
        case 3:
            kj(b);
            Ig();
            break;
        case 5:
            Ah(b);
            break;
        case 1:
            Zf(b.type) && cg(b);
            break;
        case 4:
            yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            G(Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return G(L, L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return oj(a, b, c);
                G(L, L.current & 1);
                a = Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            G(L, L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            G(L, L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, dj(a, b, c);
    }
    return Zi(a, b, c);
}
var zj, Aj, Bj, Cj;
zj = function zj(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Aj = function Aj() {};
Bj = function Bj(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        xh(uh.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "select":
                e = A({}, e, {
                    value: void 0
                });
                d = A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = Bf);
        }
        ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Cj = function Cj(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Dj(a, b) {
    if (!I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function Ej(a, b, c) {
    var d = b.pendingProps;
    wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return S(b), null;
        case 1:
            return Zf(b.type) && $f(), S(b), null;
        case 3:
            d = b.stateNode;
            zh();
            E(Wf);
            E(H);
            Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== zg && (Fj(zg), zg = null));
            Aj(a, b);
            S(b);
            return null;
        case 5:
            Bh(b);
            var e = xh(wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(p(166));
                    S(b);
                    return null;
                }
                a = xh(uh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[Of] = b;
                    d[Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            D("cancel", d);
                            D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < lf.length; e++)D(lf[e], d);
                            break;
                        case "source":
                            D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            D("error", d);
                            D("load", d);
                            break;
                        case "details":
                            D("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            D("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), D("invalid", d);
                    }
                    ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : ea.hasOwnProperty(g) && null != h && "onScroll" === g && D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            Va(d);
                            db(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[Of] = b;
                    a[Pf] = d;
                    zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = vb(c, d);
                        switch(c){
                            case "dialog":
                                D("cancel", a);
                                D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < lf.length; e++)D(lf[e], a);
                                e = d;
                                break;
                            case "source":
                                D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                D("error", a);
                                D("load", a);
                                e = d;
                                break;
                            case "details":
                                D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                Za(a, d);
                                e = Ya(a, d);
                                D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = A({}, d, {
                                    value: void 0
                                });
                                D("invalid", a);
                                break;
                            case "textarea":
                                hb(a, d);
                                e = gb(a, d);
                                D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && ob(a, k) : "number" === typeof k && ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ea.hasOwnProperty(f) ? null != k && "onScroll" === f && D("scroll", a) : null != k && ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                Va(a);
                                db(a, d, !1);
                                break;
                            case "textarea":
                                Va(a);
                                jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(p(166));
                c = xh(wh.current);
                xh(uh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = xg, null !== a) switch(a.tag){
                            case 3:
                                Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[Of] = b, b.stateNode = d;
            }
            S(b);
            return null;
        case 13:
            E(L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if (I && null !== yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) Hg(), Ig(), b.flags |= 98560, f = !1;
                else if (f = Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error(p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error(p(317));
                        f[Of] = b;
                    } else Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    S(b);
                    f = !1;
                } else null !== zg && (Fj(zg), zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== (L.current & 1) ? 0 === T && (T = 3) : tj()));
            null !== b.updateQueue && (b.flags |= 4);
            S(b);
            return null;
        case 4:
            return zh(), Aj(a, b), null === a && sf(b.stateNode.containerInfo), S(b), null;
        case 10:
            return ah(b.type._context), S(b), null;
        case 17:
            return Zf(b.type) && $f(), S(b), null;
        case 19:
            E(L);
            f = b.memoizedState;
            if (null === f) return S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) Dj(f, !1);
                else {
                    if (0 !== T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            G(L, L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && B() > Gj && (b.flags |= 128, d = !0, Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !I) return S(b), null;
                    } else 2 * B() - f.renderingStartTime > Gj && 1073741824 !== c && (b.flags |= 128, d = !0, Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = B(), b.sibling = null, c = L.current, G(L, d ? c & 1 | 2 : c & 1), b;
            S(b);
            return null;
        case 22:
        case 23:
            return Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== (fj & 1073741824) && (S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error(p(156, b.tag));
}
function Ij(a, b) {
    wg(b);
    switch(b.tag){
        case 1:
            return Zf(b.type) && $f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return zh(), E(Wf), E(H), Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return Bh(b), null;
        case 13:
            E(L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error(p(340));
                Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return E(L), null;
        case 4:
            return zh(), null;
        case 10:
            return ah(b.type._context), null;
        case 22:
        case 23:
            return Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var Jj = !1, U = !1, Kj = "function" === typeof WeakSet ? WeakSet : Set, V = null;
function Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            W(a, b, d);
        }
        else c.current = null;
    }
}
function Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        W(a, b, d);
    }
}
var Nj = !1;
function Oj(a, b) {
    Cf = dd;
    a = Me();
    if (Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    Df = {
        focusedElem: a,
        selectionRange: c
    };
    dd = !1;
    for(V = b; null !== V;)if (b = V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, V = a;
    else for(; null !== V;){
        b = V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error(p(163));
            }
        } catch (F) {
            W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            V = a;
            break;
        }
        V = b.return;
    }
    n = Nj;
    Nj = !1;
    return n;
}
function Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[Of], delete b[Pf], delete b[of], delete b[Qf], delete b[Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = Bf));
    else if (4 !== d && (a = a.child, null !== a)) for(Vj(a, b, c), a = a.sibling; null !== a;)Vj(a, b, c), a = a.sibling;
}
function Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(Wj(a, b, c), a = a.sibling; null !== a;)Wj(a, b, c), a = a.sibling;
}
var X = null, Xj = !1;
function Yj(a, b, c) {
    for(c = c.child; null !== c;)Zj(a, b, c), c = c.sibling;
}
function Zj(a, b, c) {
    if (lc && "function" === typeof lc.onCommitFiberUnmount) try {
        lc.onCommitFiberUnmount(kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            U || Lj(c, b);
        case 6:
            var d = X, e = Xj;
            X = null;
            Yj(a, b, c);
            X = d;
            Xj = e;
            null !== X && (Xj ? (a = X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : X.removeChild(c.stateNode));
            break;
        case 18:
            null !== X && (Xj ? (a = X, c = c.stateNode, 8 === a.nodeType ? Kf(a.parentNode, c) : 1 === a.nodeType && Kf(a, c), bd(a)) : Kf(X, c.stateNode));
            break;
        case 4:
            d = X;
            e = Xj;
            X = c.stateNode.containerInfo;
            Xj = !0;
            Yj(a, b, c);
            X = d;
            Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? Mj(c, b, g) : 0 !== (f & 4) && Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            Yj(a, b, c);
            break;
        case 1:
            if (!U && (Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                W(c, b, h);
            }
            Yj(a, b, c);
            break;
        case 21:
            Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? (U = (d = U) || null !== c.memoizedState, Yj(a, b, c), U = d) : Yj(a, b, c);
            break;
        default:
            Yj(a, b, c);
    }
}
function ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Kj);
        b.forEach(function(b) {
            var d = bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        X = h.stateNode;
                        Xj = !1;
                        break a;
                    case 3:
                        X = h.stateNode.containerInfo;
                        Xj = !0;
                        break a;
                    case 4:
                        X = h.stateNode.containerInfo;
                        Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === X) throw Error(p(160));
            Zj(f, g, e);
            X = null;
            Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)dk(b, a), b = b.sibling;
}
function dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            ck(b, a);
            ek(a);
            if (d & 4) {
                try {
                    Pj(3, a, a.return), Qj(3, a);
                } catch (t) {
                    W(a, a.return, t);
                }
                try {
                    Pj(5, a, a.return);
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 1:
            ck(b, a);
            ek(a);
            d & 512 && null !== c && Lj(c, c.return);
            break;
        case 5:
            ck(b, a);
            ek(a);
            d & 512 && null !== c && Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    ob(e, "");
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && ab(e, f);
                    vb(h, g);
                    var l = vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? sb(e, q) : "dangerouslySetInnerHTML" === m ? nb(e, q) : "children" === m ? ob(e, q) : ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            bb(e, f);
                            break;
                        case "textarea":
                            ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? fb(e, !!f.multiple, f.defaultValue, !0) : fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[Pf] = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 6:
            ck(b, a);
            ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error(p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 3:
            ck(b, a);
            ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                bd(b.containerInfo);
            } catch (t) {
                W(a, a.return, t);
            }
            break;
        case 4:
            ck(b, a);
            ek(a);
            break;
        case 13:
            ck(b, a);
            ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || (fk = B()));
            d & 4 && ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? (U = (l = U) || m, ck(b, a), U = l) : ck(b, a);
            ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for(V = a, m = a.child; null !== m;){
                    for(q = V = m; null !== V;){
                        r = V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                Pj(4, r, r.return);
                                break;
                            case 1:
                                Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, V = y) : gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = rb("display", g));
                            } catch (t) {
                                W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            ck(b, a);
            ek(a);
            d & 4 && ak(a);
            break;
        case 21:
            break;
        default:
            ck(b, a), ek(a);
    }
}
function ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if (Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error(p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && (ob(e, ""), d.flags &= -33);
                    var f = Uj(a);
                    Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = Uj(a);
                    Vj(a, h, g);
                    break;
                default:
                    throw Error(p(161));
            }
        } catch (k) {
            W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function hk(a, b, c) {
    V = a;
    ik(a, b, c);
}
function ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== V;){
        var e = V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || U;
                h = Jj;
                var l = U;
                Jj = g;
                if ((U = k) && !l) for(V = e; null !== V;)g = V, k = g.child, 22 === g.tag && null !== g.memoizedState ? jk(e) : null !== k ? (k.return = g, V = k) : jk(e);
                for(; null !== f;)V = f, ik(f, b, c), f = f.sibling;
                V = e;
                Jj = h;
                U = l;
            }
            kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, V = f) : kk(a, b, c);
    }
}
function kk(a) {
    for(; null !== V;){
        var b = V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        U || Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error(p(163));
                }
                U || b.flags & 512 && Rj(b);
            } catch (r) {
                W(b, b.return, r);
            }
        }
        if (b === a) {
            V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function gk(a) {
    for(; null !== V;){
        var b = V;
        if (b === a) {
            V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function jk(a) {
    for(; null !== V;){
        var b = V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        Qj(4, b);
                    } catch (k) {
                        W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        Rj(b);
                    } catch (k) {
                        W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        Rj(b);
                    } catch (k) {
                        W(b, g, k);
                    }
            }
        } catch (k) {
            W(b, b.return, k);
        }
        if (b === a) {
            V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            V = h;
            break;
        }
        V = b.return;
    }
}
var lk = Math.ceil, mk = ua.ReactCurrentDispatcher, nk = ua.ReactCurrentOwner, ok = ua.ReactCurrentBatchConfig, K = 0, Q = null, Y = null, Z = 0, fj = 0, ej = Uf(0), T = 0, pk = null, rh = 0, qk = 0, rk = 0, sk = null, tk = null, fk = 0, Gj = Infinity, uk = null, Oi = !1, Pi = null, Ri = null, vk = !1, wk = null, xk = 0, yk = 0, zk = null, Ak = -1, Bk = 0;
function R() {
    return 0 !== (K & 6) ? B() : -1 !== Ak ? Ak : Ak = B();
}
function yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== (K & 2) && 0 !== Z) return Z & -Z;
    if (null !== Kg.transition) return 0 === Bk && (Bk = yc()), Bk;
    a = C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : jd(a.type);
    return a;
}
function gi(a, b, c, d) {
    if (50 < yk) throw yk = 0, zk = null, Error(p(185));
    Ac(a, c, d);
    if (0 === (K & 2) || a !== Q) a === Q && (0 === (K & 2) && (qk |= c), 4 === T && Ck(a, Z)), Dk(a, d), 1 === c && 0 === K && 0 === (b.mode & 1) && (Gj = B() + 500, fg && jg());
}
function Dk(a, b) {
    var c = a.callbackNode;
    wc(a, b);
    var d = uc(a, a === Q ? Z : 0);
    if (0 === d) null !== c && bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && bc(c);
        if (1 === b) 0 === a.tag ? ig(Ek.bind(null, a)) : hg(Ek.bind(null, a)), Jf(function() {
            0 === (K & 6) && jg();
        }), c = null;
        else {
            switch(Dc(d)){
                case 1:
                    c = fc;
                    break;
                case 4:
                    c = gc;
                    break;
                case 16:
                    c = hc;
                    break;
                case 536870912:
                    c = jc;
                    break;
                default:
                    c = hc;
            }
            c = Fk(c, Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Gk(a, b) {
    Ak = -1;
    Bk = 0;
    if (0 !== (K & 6)) throw Error(p(327));
    var c = a.callbackNode;
    if (Hk() && a.callbackNode !== c) return null;
    var d = uc(a, a === Q ? Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = Ik(a, d);
    else {
        b = d;
        var e = K;
        K |= 2;
        var f = Jk();
        if (Q !== a || Z !== b) uk = null, Gj = B() + 500, Kk(a, b);
        for(;;)try {
            Lk();
            break;
        } catch (h) {
            Mk(a, h);
        }
        $g();
        mk.current = f;
        K = e;
        null !== Y ? b = 0 : (Q = null, Z = 0, b = T);
    }
    if (0 !== b) {
        2 === b && (e = xc(a), 0 !== e && (d = e, b = Nk(a, e)));
        if (1 === b) throw c = pk, Kk(a, 0), Ck(a, d), Dk(a, B()), c;
        if (6 === b) Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !Ok(e) && (b = Ik(a, d), 2 === b && (f = xc(a), 0 !== f && (d = f, b = Nk(a, f))), 1 === b)) throw c = pk, Kk(a, 0), Ck(a, d), Dk(a, B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error(p(345));
                case 2:
                    Pk(a, tk, uk);
                    break;
                case 3:
                    Ck(a, d);
                    if ((d & 130023424) === d && (b = fk + 500 - B(), 10 < b)) {
                        if (0 !== uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = Ff(Pk.bind(null, a, tk, uk), b);
                        break;
                    }
                    Pk(a, tk, uk);
                    break;
                case 4:
                    Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = Ff(Pk.bind(null, a, tk, uk), d);
                        break;
                    }
                    Pk(a, tk, uk);
                    break;
                case 5:
                    Pk(a, tk, uk);
                    break;
                default:
                    throw Error(p(329));
            }
        }
    }
    Dk(a, B());
    return a.callbackNode === c ? Gk.bind(null, a) : null;
}
function Nk(a, b) {
    var c = sk;
    a.current.memoizedState.isDehydrated && (Kk(a, b).flags |= 256);
    a = Ik(a, b);
    2 !== a && (b = tk, tk = c, null !== b && Fj(b));
    return a;
}
function Fj(a) {
    null === tk ? tk = a : tk.push.apply(tk, a);
}
function Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function Ck(a, b) {
    b &= ~rk;
    b &= ~qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Ek(a) {
    if (0 !== (K & 6)) throw Error(p(327));
    Hk();
    var b = uc(a, 0);
    if (0 === (b & 1)) return Dk(a, B()), null;
    var c = Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = xc(a);
        0 !== d && (b = d, c = Nk(a, d));
    }
    if (1 === c) throw c = pk, Kk(a, 0), Ck(a, b), Dk(a, B()), c;
    if (6 === c) throw Error(p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Pk(a, tk, uk);
    Dk(a, B());
    return null;
}
function Qk(a, b) {
    var c = K;
    K |= 1;
    try {
        return a(b);
    } finally{
        K = c, 0 === K && (Gj = B() + 500, fg && jg());
    }
}
function Rk(a) {
    null !== wk && 0 === wk.tag && 0 === (K & 6) && Hk();
    var b = K;
    K |= 1;
    var c = ok.transition, d = C;
    try {
        if (ok.transition = null, C = 1, a) return a();
    } finally{
        C = d, ok.transition = c, K = b, 0 === (K & 6) && jg();
    }
}
function Hj() {
    fj = ej.current;
    E(ej);
}
function Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Gf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $f();
                break;
            case 3:
                zh();
                E(Wf);
                E(H);
                Eh();
                break;
            case 5:
                Bh(d);
                break;
            case 4:
                zh();
                break;
            case 13:
                E(L);
                break;
            case 19:
                E(L);
                break;
            case 10:
                ah(d.type._context);
                break;
            case 22:
            case 23:
                Hj();
        }
        c = c.return;
    }
    Q = a;
    Y = a = Pg(a.current, null);
    Z = fj = b;
    T = 0;
    pk = null;
    rk = qk = rh = 0;
    tk = sk = null;
    if (null !== fh) {
        for(b = 0; b < fh.length; b++)if (c = fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        fh = null;
    }
    return a;
}
function Mk(a, b) {
    do {
        var c = Y;
        try {
            $g();
            Fh.current = Rh;
            if (Ih) {
                for(var d = M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                Ih = !1;
            }
            Hh = 0;
            O = N = M = null;
            Jh = !1;
            Kh = 0;
            nk.current = null;
            if (null === c || null === c.return) {
                T = 1;
                pk = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = Z;
                h.flags |= 32768;
                if (null !== k && "object" === (typeof k === "undefined" ? "undefined" : (0, _typeOf._)(k)) && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        Vi(y, g, h, f, b);
                        y.mode & 1 && Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            Si(f, l, b);
                            tj();
                            break a;
                        }
                        k = Error(p(426));
                    }
                } else if (I && h.mode & 1) {
                    var J = Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        Vi(J, g, h, f, b);
                        Jg(Ji(k, h));
                        break a;
                    }
                }
                f = k = Ji(k, h);
                4 !== T && (T = 2);
                null === sk ? sk = [
                    f
                ] : sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = Ni(f, k, b);
                            ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === Ri || !Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = Qi(f, h, b);
                                ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            Sk(c);
        } catch (na) {
            b = na;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Jk() {
    var a = mk.current;
    mk.current = Rh;
    return null === a ? Rh : a;
}
function tj() {
    if (0 === T || 3 === T || 2 === T) T = 4;
    null === Q || 0 === (rh & 268435455) && 0 === (qk & 268435455) || Ck(Q, Z);
}
function Ik(a, b) {
    var c = K;
    K |= 2;
    var d = Jk();
    if (Q !== a || Z !== b) uk = null, Kk(a, b);
    for(;;)try {
        Tk();
        break;
    } catch (e) {
        Mk(a, e);
    }
    $g();
    K = c;
    mk.current = d;
    if (null !== Y) throw Error(p(261));
    Q = null;
    Z = 0;
    return T;
}
function Tk() {
    for(; null !== Y;)Uk(Y);
}
function Lk() {
    for(; null !== Y && !cc();)Uk(Y);
}
function Uk(a) {
    var b = Vk(a.alternate, a, fj);
    a.memoizedProps = a.pendingProps;
    null === b ? Sk(a) : Y = b;
    nk.current = null;
}
function Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = Ej(c, b, fj), null !== c) {
                Y = c;
                return;
            }
        } else {
            c = Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                T = 6;
                Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === T && (T = 5);
}
function Pk(a, b, c) {
    var d = C, e = ok.transition;
    try {
        ok.transition = null, C = 1, Wk(a, b, c, d);
    } finally{
        ok.transition = e, C = d;
    }
    return null;
}
function Wk(a, b, c, d) {
    do Hk();
    while (null !== wk);
    if (0 !== (K & 6)) throw Error(p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    Bc(a, f);
    a === Q && (Y = Q = null, Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || vk || (vk = !0, Fk(hc, function() {
        Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = ok.transition;
        ok.transition = null;
        var g = C;
        C = 1;
        var h = K;
        K |= 4;
        nk.current = null;
        Oj(a, c);
        dk(c, a);
        Oe(Df);
        dd = !!Cf;
        Df = Cf = null;
        a.current = c;
        hk(c, a, e);
        dc();
        K = h;
        C = g;
        ok.transition = f;
    } else a.current = c;
    vk && (vk = !1, wk = a, xk = e);
    f = a.pendingLanes;
    0 === f && (Ri = null);
    mc(c.stateNode, d);
    Dk(a, B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if (Oi) throw Oi = !1, a = Pi, Pi = null, a;
    0 !== (xk & 1) && 0 !== a.tag && Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === zk ? yk++ : (yk = 0, zk = a) : yk = 0;
    jg();
    return null;
}
function Hk() {
    if (null !== wk) {
        var a = Dc(xk), b = ok.transition, c = C;
        try {
            ok.transition = null;
            C = 16 > a ? 16 : a;
            if (null === wk) var d = !1;
            else {
                a = wk;
                wk = null;
                xk = 0;
                if (0 !== (K & 6)) throw Error(p(331));
                var e = K;
                K |= 4;
                for(V = a.current; null !== V;){
                    var f = V, g = f.child;
                    if (0 !== (V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for(V = l; null !== V;){
                                    var m = V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, V = q;
                                    else for(; null !== V;){
                                        m = V;
                                        var r = m.sibling, y = m.return;
                                        Sj(m);
                                        if (m === l) {
                                            V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            V = r;
                                            break;
                                        }
                                        V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, V = g;
                    else b: for(; null !== V;){
                        f = V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            V = x;
                            break b;
                        }
                        V = f.return;
                    }
                }
                var w = a.current;
                for(V = w; null !== V;){
                    g = V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, V = u;
                    else b: for(g = w; null !== V;){
                        h = V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    Qj(9, h);
                            }
                        } catch (na) {
                            W(h, h.return, na);
                        }
                        if (h === g) {
                            V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            V = F;
                            break b;
                        }
                        V = h.return;
                    }
                }
                K = e;
                jg();
                if (lc && "function" === typeof lc.onPostCommitFiberRoot) try {
                    lc.onPostCommitFiberRoot(kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            C = c, ok.transition = b;
        }
    }
    return !1;
}
function Xk(a, b, c) {
    b = Ji(c, b);
    b = Ni(a, b, 1);
    a = nh(a, b, 1);
    b = R();
    null !== a && (Ac(a, 1, b), Dk(a, b));
}
function W(a, b, c) {
    if (3 === a.tag) Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ri || !Ri.has(d))) {
                a = Ji(c, a);
                a = Qi(b, a, 1);
                b = nh(b, a, 1);
                a = R();
                null !== b && (Ac(b, 1, a), Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = R();
    a.pingedLanes |= a.suspendedLanes & c;
    Q === a && (Z & c) === c && (4 === T || 3 === T && (Z & 130023424) === Z && 500 > B() - fk ? Kk(a, 0) : rk |= c);
    Dk(a, b);
}
function Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = sc, sc <<= 1, 0 === (sc & 130023424) && (sc = 4194304)));
    var c = R();
    a = ih(a, b);
    null !== a && (Ac(a, b, c), Dk(a, c));
}
function uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    Yk(a, c);
}
function bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error(p(314));
    }
    null !== d && d.delete(b);
    Yk(a, c);
}
var Vk;
Vk = function Vk(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || Wf.current) dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return dh = !1, yj(a, b, c);
            dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else dh = !1, I && 0 !== (b.flags & 1048576) && ug(b, ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            ij(a, b);
            a = b.pendingProps;
            var e = Yf(b, H.current);
            ch(b, c);
            e = Nh(null, b, d, a, e, c);
            var f = Sh();
            b.flags |= 1;
            "object" === (typeof e === "undefined" ? "undefined" : (0, _typeOf._)(e)) && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, Zf(d) ? (f = !0, cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, kh(b), e.updater = Ei, b.stateNode = e, e._reactInternals = b, Ii(b, d, a, c), b = jj(null, b, d, !0, f, c)) : (b.tag = 0, I && f && vg(b), Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = Zk(d);
                a = Ci(d, a);
                switch(e){
                    case 0:
                        b = cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $i(null, b, d, Ci(d.type, a), c);
                        break a;
                }
                throw Error(p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), hj(a, b, d, e, c);
        case 3:
            a: {
                kj(b);
                if (null === a) throw Error(p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                lh(a, b);
                qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = Ji(Error(p(423)), b);
                        b = lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = Ji(Error(p(424)), b);
                        b = lj(a, b, d, c, e);
                        break a;
                    } else for(yg = Lf(b.stateNode.containerInfo.firstChild), xg = b, I = !0, zg = null, c = Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    Ig();
                    if (d === e) {
                        b = Zi(a, b, c);
                        break a;
                    }
                    Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return Ah(b), null === a && Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Ef(d, e) ? g = null : null !== f && Ef(d, f) && (b.flags |= 32), gj(a, b), Xi(a, b, g, c), b.child;
        case 6:
            return null === a && Eg(b), null;
        case 13:
            return oj(a, b, c);
        case 4:
            return yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Ug(b, null, d, c) : Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), Yi(a, b, d, e, c);
        case 7:
            return Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                G(Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if (He(f.value, g)) {
                        if (f.children === e.children && !Wf.current) {
                            b = Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error(p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, ch(b, c), e = eh(e), d = d(e), b.flags |= 1, Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = Ci(d, b.pendingProps), e = Ci(d.type, e), $i(a, b, d, e, c);
        case 15:
            return bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), ij(a, b), b.tag = 1, Zf(d) ? (a = !0, cg(b)) : a = !1, ch(b, c), Gi(b, d, e), Ii(b, d, e, c), jj(null, b, d, !0, a, c);
        case 19:
            return xj(a, b, c);
        case 22:
            return dj(a, b, c);
    }
    throw Error(p(156, b.tag));
};
function Fk(a, b) {
    return ac(a, b);
}
function $k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function Bg(a, b, c, d) {
    return new $k(a, b, c, d);
}
function aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function Zk(a) {
    if ("function" === typeof a) return aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Da) return 11;
        if (a === Ga) return 14;
    }
    return 2;
}
function Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ya:
            return Tg(c.children, e, f, b);
        case za:
            g = 8;
            e |= 8;
            break;
        case Aa:
            return a = Bg(12, c, b, e | 2), a.elementType = Aa, a.lanes = f, a;
        case Ea:
            return a = Bg(13, c, b, e), a.elementType = Ea, a.lanes = f, a;
        case Fa:
            return a = Bg(19, c, b, e), a.elementType = Fa, a.lanes = f, a;
        case Ia:
            return pj(c, e, f, b);
        default:
            if ("object" === (typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)) && null !== a) switch(a.$$typeof){
                case Ba:
                    g = 10;
                    break a;
                case Ca:
                    g = 9;
                    break a;
                case Da:
                    g = 11;
                    break a;
                case Ga:
                    g = 14;
                    break a;
                case Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error(p(130, null == a ? a : typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a), ""));
    }
    b = Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Tg(a, b, c, d) {
    a = Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function pj(a, b, c, d) {
    a = Bg(22, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function Qg(a, b, c) {
    a = Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function Sg(a, b, c) {
    b = Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = zc(0);
    this.expirationTimes = zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function bl(a, b, c, d, e, f, g, h, k) {
    a = new al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    kh(f);
    return a;
}
function cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function dl(a) {
    if (!a) return Vf;
    a = a._reactInternals;
    a: {
        if (Vb(a) !== a || 1 !== a.tag) throw Error(p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if (Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error(p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if (Zf(c)) return bg(a, c, b);
    }
    return b;
}
function el(a, b, c, d, e, f, g, h, k) {
    a = bl(c, d, !0, a, e, f, g, h, k);
    a.context = dl(null);
    c = a.current;
    d = R();
    e = yi(c);
    f = mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    nh(c, f, e);
    a.current.lanes = e;
    Ac(a, e, d);
    Dk(a, d);
    return a;
}
function fl(a, b, c, d) {
    var e = b.current, f = R(), g = yi(e);
    c = dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = nh(e, b, g);
    null !== a && (gi(a, e, g, f), oh(a, e, g));
    return g;
}
function gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function il(a, b) {
    hl(a, b);
    (a = a.alternate) && hl(a, b);
}
function jl() {
    return null;
}
var kl = "function" === typeof reportError ? reportError : function kl(a) {
    console.error(a);
};
function ll(a) {
    this._internalRoot = a;
}
ml.prototype.render = ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error(p(409));
    fl(a, b, null, null);
};
ml.prototype.unmount = ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        Rk(function() {
            fl(null, a, null, null);
        });
        b[uf] = null;
    }
};
function ml(a) {
    this._internalRoot = a;
}
ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < Qc.length && 0 !== b && b < Qc[c].priority; c++);
        Qc.splice(c, 0, a);
        0 === c && Vc(a);
    }
};
function nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function pl() {}
function ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function d() {
                var _$a = gl(g);
                f.call(_$a);
            };
        }
        var g = el(b, d, a, 0, null, !1, !1, "", pl);
        a._reactRootContainer = g;
        a[uf] = g.current;
        sf(8 === a.nodeType ? a.parentNode : a);
        Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function d() {
            var _$a = gl(k);
            h.call(_$a);
        };
    }
    var k = bl(a, 0, !1, null, null, !1, !1, "", pl);
    a._reactRootContainer = k;
    a[uf] = k.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    Rk(function() {
        fl(b, k, c, d);
    });
    return k;
}
function rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function e() {
                var _$a = gl(g);
                h.call(_$a);
            };
        }
        fl(b, g, a, e);
    } else g = ql(c, b, a, e, d);
    return gl(g);
}
Ec = function Ec(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = tc(b.pendingLanes);
                0 !== c && (Cc(b, c | 1), Dk(b, B()), 0 === (K & 6) && (Gj = B() + 500, jg()));
            }
            break;
        case 13:
            Rk(function() {
                var b = ih(a, 1);
                if (null !== b) {
                    var c = R();
                    gi(b, a, 1, c);
                }
            }), il(a, 1);
    }
};
Fc = function Fc(a) {
    if (13 === a.tag) {
        var b = ih(a, 134217728);
        if (null !== b) {
            var c = R();
            gi(b, a, 134217728, c);
        }
        il(a, 134217728);
    }
};
Gc = function Gc(a) {
    if (13 === a.tag) {
        var b = yi(a), c = ih(a, b);
        if (null !== c) {
            var d = R();
            gi(c, a, b, d);
        }
        il(a, b);
    }
};
Hc = function Hc() {
    return C;
};
Ic = function Ic(a, b) {
    var c = C;
    try {
        return C = a, b();
    } finally{
        C = c;
    }
};
yb = function yb(a, b, c) {
    switch(b){
        case "input":
            bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(p(90));
                        Wa(d);
                        bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Qk;
Hb = Rk;
var sl = {
    usingClientEntryPoint: !1,
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Qk
    ]
}, tl = {
    findFiberByHostInstance: Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var ul = {
    bundleType: tl.bundleType,
    version: tl.version,
    rendererPackageName: tl.rendererPackageName,
    rendererConfig: tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function findHostInstanceByFiber(a) {
        a = Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: tl.findFiberByHostInstance || jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!vl.isDisabled && vl.supportsFiber) try {
        kc = vl.inject(ul), lc = vl;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = sl;
exports.createPortal = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!nl(b)) throw Error(p(200));
    return cl(a, b, null, c);
};
exports.createRoot = function(a, b) {
    if (!nl(a)) throw Error(p(299));
    var c = !1, d = "", e = kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = bl(a, 1, !1, null, null, c, !1, d, e);
    a[uf] = b.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    return new ll(b);
};
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(p(188));
        a = Object.keys(a).join(",");
        throw Error(p(268, a));
    }
    a = Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a) {
    return Rk(a);
};
exports.hydrate = function(a, b, c) {
    if (!ol(b)) throw Error(p(200));
    return rl(null, a, b, !0, c);
};
exports.hydrateRoot = function(a, b, c) {
    if (!nl(a)) throw Error(p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[uf] = b.current;
    sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new ml(b);
};
exports.render = function(a, b, c) {
    if (!ol(b)) throw Error(p(200));
    return rl(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!ol(a)) throw Error(p(40));
    return a._reactRootContainer ? (Rk(function() {
        rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[uf] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Qk;
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!ol(c)) throw Error(p(200));
    if (null == a || void 0 === a._reactInternals) throw Error(p(38));
    return rl(a, b, c, !1, d);
};
exports.version = "18.3.1-next-f1338f8080-20240426";

},{"@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_type_of":"iFJdx","bd7f3b4998918581":"ltHCL","653854775ab22d43":"NHulo"}],"NHulo":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("839efe1522e0edb9");

},{"839efe1522e0edb9":"flVYN"}],"flVYN":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
function f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function h(a) {
    return 0 === a.length ? null : a[0];
}
function k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > g(C, c)) n < e && 0 > g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === (typeof performance === "undefined" ? "undefined" : (0, _typeOf._)(performance)) && "function" === typeof performance.now) {
    var l = performance;
    exports.unstable_now = function() {
        return l.now();
    };
} else {
    var p = Date, q = p.now();
    exports.unstable_now = function() {
        return p.now() - q;
    };
}
var r = [], t = [], u = 1, v = null, y = 3, z = !1, A = !1, B = !1, D = "function" === typeof setTimeout ? setTimeout : null, E = "function" === typeof clearTimeout ? clearTimeout : null, F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function G(a) {
    for(var b = h(t); null !== b;){
        if (null === b.callback) k(t);
        else if (b.startTime <= a) k(t), b.sortIndex = b.expirationTime, f(r, b);
        else break;
        b = h(t);
    }
}
function H(a) {
    B = !1;
    G(a);
    if (!A) {
        if (null !== h(r)) A = !0, I(J);
        else {
            var b = h(t);
            null !== b && K(H, b.startTime - a);
        }
    }
}
function J(a, b) {
    A = !1;
    B && (B = !1, E(L), L = -1);
    z = !0;
    var c = y;
    try {
        G(b);
        for(v = h(r); null !== v && (!(v.expirationTime > b) || a && !M());){
            var d = v.callback;
            if ("function" === typeof d) {
                v.callback = null;
                y = v.priorityLevel;
                var e = d(v.expirationTime <= b);
                b = exports.unstable_now();
                "function" === typeof e ? v.callback = e : v === h(r) && k(r);
                G(b);
            } else k(r);
            v = h(r);
        }
        if (null !== v) var w = !0;
        else {
            var m = h(t);
            null !== m && K(H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        v = null, y = c, z = !1;
    }
}
var N = !1, O = null, L = -1, P = 5, Q = -1;
function M() {
    return exports.unstable_now() - Q < P ? !1 : !0;
}
function R() {
    if (null !== O) {
        var a = exports.unstable_now();
        Q = a;
        var b = !0;
        try {
            b = O(!0, a);
        } finally{
            b ? S() : (N = !1, O = null);
        }
    } else N = !1;
}
var S;
if ("function" === typeof F) S = function S() {
    F(R);
};
else if ("undefined" !== typeof MessageChannel) {
    var T = new MessageChannel, U = T.port2;
    T.port1.onmessage = R;
    S = function S() {
        U.postMessage(null);
    };
} else S = function S() {
    D(R, 0);
};
function I(a) {
    O = a;
    N || (N = !0, S());
}
function K(a, b) {
    L = D(function() {
        a(exports.unstable_now());
    }, b);
}
exports.unstable_IdlePriority = 5;
exports.unstable_ImmediatePriority = 1;
exports.unstable_LowPriority = 4;
exports.unstable_NormalPriority = 3;
exports.unstable_Profiling = null;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_cancelCallback = function(a) {
    a.callback = null;
};
exports.unstable_continueExecution = function() {
    A || z || (A = !0, I(J));
};
exports.unstable_forceFrameRate = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : P = 0 < a ? Math.floor(1E3 / a) : 5;
};
exports.unstable_getCurrentPriorityLevel = function() {
    return y;
};
exports.unstable_getFirstCallbackNode = function() {
    return h(r);
};
exports.unstable_next = function(a) {
    switch(y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = y;
    }
    var c = y;
    y = b;
    try {
        return a();
    } finally{
        y = c;
    }
};
exports.unstable_pauseExecution = function() {};
exports.unstable_requestPaint = function() {};
exports.unstable_runWithPriority = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = y;
    y = a;
    try {
        return b();
    } finally{
        y = c;
    }
};
exports.unstable_scheduleCallback = function(a, b, c) {
    var d = exports.unstable_now();
    "object" === (typeof c === "undefined" ? "undefined" : (0, _typeOf._)(c)) && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, f(t, a), null === h(r) && a === h(t) && (B ? (E(L), L = -1) : B = !0, K(H, c - d))) : (a.sortIndex = e, f(r, a), A || z || (A = !0, I(J)));
    return a;
};
exports.unstable_shouldYield = M;
exports.unstable_wrapCallback = function(a) {
    var b = y;
    return function() {
        var c = y;
        y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            y = c;
        }
    };
};

},{"@swc/helpers/_/_type_of":"iFJdx"}],"kO5t9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * This creates a boolean flag resolver that allows calls to `getBooleanFF` inside of Platform components to use a Product's
 * feature flag client and LD project, rather than installing a feature flag client of their own, or passing those flags in via props.
 *
 * @param flagResolver
 */ parcelHelpers.export(exports, "setBooleanFeatureFlagResolver", function() {
    return setBooleanFeatureFlagResolver;
});
/**
 * Returns the value of a feature flag. If the flag does not resolve, it returns the "false" as a default value.
 *
 * @deprecated Use {@link fg} function instead.
 * @param name
 */ parcelHelpers.export(exports, "getBooleanFF", function() {
    return getBooleanFF;
});
/**
 * Returns the value of a feature flag. If the flag does not resolve, it returns the "false" as a default value.
 *
 * @param name
 */ parcelHelpers.export(exports, "fg", function() {
    return fg;
});
var _resolvers = require("./resolvers");
function setBooleanFeatureFlagResolver(flagResolver) {
    (0, _resolvers.setBooleanResolver)(flagResolver);
}
function getBooleanFF(name) {
    return (0, _resolvers.resolveBooleanFlag)(name);
}
function fg(name) {
    return (0, _resolvers.resolveBooleanFlag)(name);
}

},{"./resolvers":"2lDiA","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2lDiA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PFF_GLOBAL_KEY", function() {
    return PFF_GLOBAL_KEY;
});
parcelHelpers.export(exports, "setBooleanResolver", function() {
    return setBooleanResolver;
});
parcelHelpers.export(exports, "resolveBooleanFlag", function() {
    return resolveBooleanFlag;
});
var _featureGateJsClient = require("@atlaskit/feature-gate-js-client");
var _featureGateJsClientDefault = parcelHelpers.interopDefault(_featureGateJsClient);
var _debug = require("./debug");
var process = require("a5c3b9743285fc99");
var pkgName = '@atlaskit/platform-feature-flags';
var PFF_GLOBAL_KEY = '__PLATFORM_FEATURE_FLAGS__';
var hasProcessEnv = typeof process !== 'undefined' && typeof process.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var ENV_ENABLE_PLATFORM_FF = hasProcessEnv ? false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var ENV_STORYBOOK_ENABLE_PLATFORM_FF = hasProcessEnv ? false : false;
var ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = ENV_ENABLE_PLATFORM_FF || ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var globalVar = typeof window !== 'undefined' ? window : globalThis;
globalVar[PFF_GLOBAL_KEY] = globalVar[PFF_GLOBAL_KEY] || DEFAULT_PFF_GLOBAL;
function setBooleanResolver(resolver) {
    globalVar[PFF_GLOBAL_KEY].booleanResolver = resolver;
}
function resolveBooleanFlag(flagKey) {
    if (ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, _debug.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar_PFF_GLOBAL_KEY, _globalVar_PFF_GLOBAL_KEY1, _globalVar_PFF_GLOBAL_KEY2;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar_PFF_GLOBAL_KEY = globalVar[PFF_GLOBAL_KEY]) === null || _globalVar_PFF_GLOBAL_KEY === void 0 ? void 0 : _globalVar_PFF_GLOBAL_KEY.booleanResolver) === undefined || ((_globalVar_PFF_GLOBAL_KEY1 = globalVar[PFF_GLOBAL_KEY]) === null || _globalVar_PFF_GLOBAL_KEY1 === void 0 ? void 0 : _globalVar_PFF_GLOBAL_KEY1.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, _featureGateJsClientDefault.default).checkGate(flagKey);
        var result = (_globalVar_PFF_GLOBAL_KEY2 = globalVar[PFF_GLOBAL_KEY]) === null || _globalVar_PFF_GLOBAL_KEY2 === void 0 ? void 0 : _globalVar_PFF_GLOBAL_KEY2.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

},{"a5c3b9743285fc99":"gNLf3","@atlaskit/feature-gate-js-client":"8JPKt","./debug":"70NTu","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gNLf3":[function(require,module,exports,__globalThis) {
// shim for using process in browser
var process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') cachedSetTimeout = setTimeout;
        else cachedSetTimeout = defaultSetTimout;
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') cachedClearTimeout = clearTimeout;
        else cachedClearTimeout = defaultClearTimeout;
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
    if (!draining || !currentQueue) return;
    draining = false;
    if (currentQueue.length) queue = currentQueue.concat(queue);
    else queueIndex = -1;
    if (queue.length) drainQueue();
}
function drainQueue() {
    if (draining) return;
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while(len){
        currentQueue = queue;
        queue = [];
        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) runTimeout(drainQueue);
};
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};
function noop() {}
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function(name) {
    return [];
};
process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
process.cwd = function() {
    return '/';
};
process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() {
    return 0;
};

},{}],"8JPKt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return 0, _featureGatesDefault.default;
});
parcelHelpers.export(exports, "FeatureGateEnvironment", function() {
    return 0, _featureGates.FeatureGateEnvironment;
});
parcelHelpers.export(exports, "PerimeterType", function() {
    return 0, _featureGates.PerimeterType;
});
parcelHelpers.export(exports, "CLIENT_VERSION", function() {
    return 0, _featureGates.CLIENT_VERSION;
});
parcelHelpers.export(exports, "DynamicConfig", function() {
    return 0, _dynamicConfig.DynamicConfig;
});
parcelHelpers.export(exports, "Layer", function() {
    return 0, _layer.Layer;
});
parcelHelpers.export(exports, "EvaluationReason", function() {
    return 0, _types.EvaluationReason;
});
var _featureGates = require("./client/FeatureGates");
var _featureGatesDefault = parcelHelpers.interopDefault(_featureGates);
var _dynamicConfig = require("./client/compat/DynamicConfig");
var _layer = require("./client/compat/Layer");
var _types = require("./client/compat/types");

},{"./client/FeatureGates":"7ErGU","./client/compat/DynamicConfig":false,"./client/compat/Layer":false,"./client/compat/types":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7ErGU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EvaluationReason", function() {
    return 0, _types.EvaluationReason;
});
parcelHelpers.export(exports, "DynamicConfig", function() {
    return 0, _dynamicConfig.DynamicConfig;
});
parcelHelpers.export(exports, "FeatureGateEnvironment", function() {
    return 0, _types1.FeatureGateEnvironment;
});
parcelHelpers.export(exports, "PerimeterType", function() {
    return 0, _types1.PerimeterType;
});
parcelHelpers.export(exports, "CLIENT_VERSION", function() {
    return 0, _version.CLIENT_VERSION;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _client = require("./Client");
var _version = require("./version");
var _types = require("./compat/types");
var _dynamicConfig = require("./compat/DynamicConfig");
var _types1 = require("./types");
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var FeatureGates = /*#__PURE__*/ function() {
    "use strict";
    function FeatureGates() {
        (0, _classCallCheck._)(this, FeatureGates);
    }
    (0, _createClass._)(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
    return FeatureGates;
}();
FeatureGates.client = new (0, _client.Client)();
FeatureGates.hasCheckGateErrorOccurred = false;
FeatureGates.hasGetExperimentValueErrorOccurred = false;
FeatureGates.checkGate = function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return FeatureGates.client.checkGate(gateName, options);
};
FeatureGates.getExperimentValue = function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
};
FeatureGates.initializeCalled = FeatureGates.client.initializeCalled.bind(FeatureGates.client);
FeatureGates.initializeCompleted = FeatureGates.client.initializeCompleted.bind(FeatureGates.client);
FeatureGates.waitUntilInitializeCompleted = FeatureGates.client.waitUntilInitializeCompleted.bind(FeatureGates.client);
FeatureGates.initialize = FeatureGates.client.initialize.bind(FeatureGates.client);
FeatureGates.initializeWithProvider = FeatureGates.client.initializeWithProvider.bind(FeatureGates.client);
FeatureGates.initializeFromValues = FeatureGates.client.initializeFromValues.bind(FeatureGates.client);
FeatureGates.manuallyLogGateExposure = FeatureGates.client.manuallyLogGateExposure.bind(FeatureGates.client);
FeatureGates.getExperiment = FeatureGates.client.getExperiment.bind(FeatureGates.client);
FeatureGates.manuallyLogExperimentExposure = FeatureGates.client.manuallyLogExperimentExposure.bind(FeatureGates.client);
FeatureGates.manuallyLogLayerExposure = FeatureGates.client.manuallyLogLayerExposure.bind(FeatureGates.client);
FeatureGates.shutdownStatsig = FeatureGates.client.shutdownStatsig.bind(FeatureGates.client);
FeatureGates.overrideGate = FeatureGates.client.overrideGate.bind(FeatureGates.client);
FeatureGates.clearGateOverride = FeatureGates.client.clearGateOverride.bind(FeatureGates.client);
FeatureGates.overrideConfig = FeatureGates.client.overrideConfig.bind(FeatureGates.client);
FeatureGates.clearConfigOverride = FeatureGates.client.clearConfigOverride.bind(FeatureGates.client);
FeatureGates.setOverrides = FeatureGates.client.setOverrides.bind(FeatureGates.client);
FeatureGates.getOverrides = FeatureGates.client.getOverrides.bind(FeatureGates.client);
FeatureGates.clearAllOverrides = FeatureGates.client.clearAllOverrides.bind(FeatureGates.client);
FeatureGates.isCurrentUser = FeatureGates.client.isCurrentUser.bind(FeatureGates.client);
FeatureGates.onGateUpdated = FeatureGates.client.onGateUpdated.bind(FeatureGates.client);
FeatureGates.onExperimentValueUpdated = FeatureGates.client.onExperimentValueUpdated.bind(FeatureGates.client);
FeatureGates.onAnyUpdated = FeatureGates.client.onAnyUpdated.bind(FeatureGates.client);
FeatureGates.updateUser = FeatureGates.client.updateUser.bind(FeatureGates.client);
FeatureGates.updateUserWithProvider = FeatureGates.client.updateUserWithProvider.bind(FeatureGates.client);
FeatureGates.updateUserWithValues = FeatureGates.client.updateUserWithValues.bind(FeatureGates.client);
FeatureGates.getPackageVersion = FeatureGates.client.getPackageVersion.bind(FeatureGates.client);
FeatureGates.getLayer = FeatureGates.client.getLayer.bind(FeatureGates.client);
FeatureGates.getLayerValue = FeatureGates.client.getLayerValue.bind(FeatureGates.client);
var boundFGJS = FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = FeatureGates;
    else {
        var _boundFGJS_getPackageVersion;
        boundFGJS = window.__FEATUREGATES_JS__;
        var boundVersion = (boundFGJS === null || boundFGJS === void 0 ? void 0 : (_boundFGJS_getPackageVersion = boundFGJS.getPackageVersion) === null || _boundFGJS_getPackageVersion === void 0 ? void 0 : _boundFGJS_getPackageVersion.call(boundFGJS)) || '4.10.0 or earlier';
        if (boundVersion !== (0, _version.CLIENT_VERSION)) {
            var message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat(boundVersion, " when module version ").concat((0, _version.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn(message);
        }
    }
}
/**
 * @property {FeatureGates} FeatureGate default export
 */ exports.default = boundFGJS;

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","./Client":"86Uho","./version":"4vZAC","./compat/types":false,"./compat/DynamicConfig":false,"./types":"cETze","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5CNCO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _class_call_check;
});
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8eDyv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _create_class;
});
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"86Uho":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Client", function() {
    return Client;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _jsClient = require("@statsig/js-client");
var _subscriptions = require("../subscriptions");
var _subscriptionsDefault = parcelHelpers.interopDefault(_subscriptions);
var _dynamicConfig = require("./compat/DynamicConfig");
var _layer = require("./compat/Layer");
var _types = require("./compat/types");
var _fetcher = require("./fetcher");
var _fetcherDefault = parcelHelpers.interopDefault(_fetcher);
var _noFetchDataAdapter = require("./NoFetchDataAdapter");
var _persistentOverrideAdapter = require("./PersistentOverrideAdapter");
var _types1 = require("./types");
var _utils = require("./utils");
var _version = require("./version");
var DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
var Client = /*#__PURE__*/ function() {
    "use strict";
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_localStorageKey = _ref.localStorageKey, localStorageKey = _ref_localStorageKey === void 0 ? (0, _persistentOverrideAdapter.LOCAL_STORAGE_KEY) : _ref_localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, _classCallCheck._)(this, Client);
        this.initPromise = null;
        /** True if an initialize method was called and completed successfully. */ this.initCompleted = false;
        /**
	 * True if an initialize method was called and completed, meaning the client is now usable.
	 * However if there was an error during initialization it may have initialized with default
	 * values. Use {@link initCompleted} to check for this.
	 */ this.initWithDefaults = false;
        this.hasCheckGateErrorOccurred = false;
        this.hasGetExperimentErrorOccurred = false;
        this.hasGetExperimentValueErrorOccurred = false;
        this.hasGetLayerErrorOccurred = false;
        this.hasGetLayerValueErrorOccurred = false;
        this.subscriptions = new (0, _subscriptionsDefault.default)();
        this.dataAdapter = new (0, _noFetchDataAdapter.NoFetchDataAdapter)();
        /**
	 * Call this if modifying the values being served by the Statsig library since it has its own
	 * memoization cache which will not be updated if the values are changed outside of the library.
	 */ this.statsigValuesUpdated = function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        };
        this.overrideAdapter = overrideAdapter || new (0, _persistentOverrideAdapter.PersistentOverrideAdapter)(localStorageKey);
    }
    (0, _createClass._)(Client, [
        {
            key: "initialize",
            value: /**
	 * @description
	 * This method initializes the client using a network call to fetch the bootstrap values.
	 * If the client is inialized with an `analyticsWebClient`, it will send an operational event
	 * to GASv3 with the following attributes:
	 * - targetApp: the target app of the client
	 * - clientVersion: the version of the client
	 * - success: whether the initialization was successful
	 * - startTime: the time when the initialization started
	 * - totalTime: the total time it took to initialize the client
	 * - apiKey: the api key used to initialize the client
	 * @param clientOptions {ClientOptions}
	 * @param identifiers {Identifiers}
	 * @param customAttributes {CustomAttributes}
	 * @returns {Promise<void>}
	 */ function initialize(clientOptions, identifiers, customAttributes) {
                return (0, _asyncToGenerator._)(function() {
                    var _this, clientOptionsWithDefaults, startTime;
                    return (0, _tsGenerator._)(this, function(_state) {
                        _this = this;
                        clientOptionsWithDefaults = (0, _utils.getOptionsWithDefaults)(clientOptions);
                        if (this.initPromise) {
                            if (!(0, _utils.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                            return [
                                2,
                                this.initPromise
                            ];
                        }
                        startTime = performance.now();
                        this.initOptions = clientOptionsWithDefaults;
                        this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                            _this.initCompleted = true;
                            _this.initWithDefaults = true;
                        }).finally(function() {
                            var endTime = performance.now();
                            var totalTime = endTime - startTime;
                            _this.fireClientEvent(startTime, totalTime, 'initialize', _this.initCompleted, clientOptionsWithDefaults.apiKey);
                        });
                        return [
                            2,
                            this.initPromise
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "initializeWithProvider",
            value: /**
	 * @description
	 * This method initializes the client using the provider given to call to fetch the bootstrap values.
	 * If the client is initialized with an `analyticsWebClient`, it will send an operational event
	 * to GASv3 with the following attributes:
	 * - targetApp: the target app of the client
	 * - clientVersion: the version of the client
	 * - success: whether the initialization was successful
	 * - startTime: the time when the initialization started
	 * - totalTime: the total time it took to initialize the client
	 * - apiKey: the api key used to initialize the client
	 * @param clientOptions {ClientOptions}
	 * @param provider {Provider}
	 * @param identifiers {Identifiers}
	 * @param customAttributes {CustomAttributes}
	 * @returns {Promise<void>}
	 */ function initializeWithProvider(clientOptions, provider, identifiers, customAttributes) {
                return (0, _asyncToGenerator._)(function() {
                    var _this, clientOptionsWithDefaults, startTime;
                    return (0, _tsGenerator._)(this, function(_state) {
                        _this = this;
                        clientOptionsWithDefaults = (0, _utils.getOptionsWithDefaults)(clientOptions);
                        if (this.initPromise) {
                            if (!(0, _utils.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                            return [
                                2,
                                this.initPromise
                            ];
                        }
                        startTime = performance.now();
                        this.initOptions = clientOptionsWithDefaults;
                        this.provider = provider;
                        this.provider.setClientVersion((0, _version.CLIENT_VERSION));
                        if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                        this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                            _this.initCompleted = true;
                            _this.initWithDefaults = true;
                        }).finally(function() {
                            var endTime = performance.now();
                            var totalTime = endTime - startTime;
                            _this.fireClientEvent(startTime, totalTime, 'initializeWithProvider', _this.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                        });
                        return [
                            2,
                            this.initPromise
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error when attempting to apply update', error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success, apiKey) {
                var _this = this;
                var _this_initOptions_analyticsWebClient;
                (_this_initOptions_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _this_initOptions_analyticsWebClient === void 0 ? void 0 : _this_initOptions_analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = (0, _objectSpread._)({
                        targetApp: _this.initOptions.targetApp,
                        clientVersion: (0, _version.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: 'featureGatesClient',
                        attributes: attributes,
                        tags: [
                            'measurement'
                        ],
                        source: '@atlaskit/feature-gate-js-client'
                    });
                }).catch(function(err) {
                    if (_this.initOptions.environment !== (0, _types1.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error('Analytics web client promise did not resolve', err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function initializeFromValues(_0, _1, _2) {
                return (0, _asyncToGenerator._)(function(clientOptions, identifiers, customAttributes) {
                    var _this, initializeValues, clientOptionsWithDefaults, startTime;
                    var _arguments = arguments;
                    return (0, _tsGenerator._)(this, function(_state) {
                        _this = this;
                        initializeValues = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : {};
                        clientOptionsWithDefaults = (0, _utils.getOptionsWithDefaults)(clientOptions);
                        if (this.initPromise) {
                            if (!(0, _utils.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                            return [
                                2,
                                this.initPromise
                            ];
                        }
                        // This makes sure the new Statsig client behaves like the old when bootstrap data is
                        // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                        if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
                        startTime = performance.now();
                        this.initOptions = clientOptionsWithDefaults;
                        this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                            _this.initCompleted = true;
                            _this.initWithDefaults = true;
                        }).finally(function() {
                            var endTime = performance.now();
                            var totalTime = endTime - startTime;
                            _this.fireClientEvent(startTime, totalTime, 'initializeFromValues', _this.initCompleted);
                        });
                        return [
                            2,
                            this.initPromise
                        ];
                    });
                }).apply(this, arguments);
            }
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error('Client must be initialized before using this method');
            }
        },
        {
            key: "updateUser",
            value: /**
	 * This method updates the user using a network call to fetch the new set of values.
	 * @param fetchOptions {FetcherOptions}
	 * @param identifiers {Identifiers}
	 * @param customAttributes {CustomAttributes}
	 */ function updateUser(fetchOptions, identifiers, customAttributes) {
                return (0, _asyncToGenerator._)(function() {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, _utils.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function() {
                                    return (0, _fetcherDefault.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(param) {
                                        var experimentValues = param.experimentValues, _$customAttributes = param.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: _$customAttributes
                                        };
                                    });
                                };
                                return [
                                    4,
                                    this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "updateUserWithProvider",
            value: /**
	 * This method updates the user using the provider given on initialisation to get the new set of
	 * values.
	 * @param identifiers {Identifiers}
	 * @param customAttributes {CustomAttributes}
	 */ function updateUserWithProvider(identifiers, customAttributes) {
                return (0, _asyncToGenerator._)(function() {
                    var _this;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                this.assertInitialized(this.statsigClient);
                                if (!this.provider) throw new Error('Cannot update user using provider as the client was not initialised with a provider');
                                return [
                                    4,
                                    this.provider.setProfile(this.initOptions, identifiers, customAttributes)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this.updateUserUsingInitializeValuesProducer(function() {
                                        return _this.provider.getExperimentValues();
                                    }, identifiers, customAttributes)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "updateUserWithValues",
            value: /**
	 * This method updates the user given a new set of bootstrap values obtained from one of the
	 * server-side SDKs.
	 *
	 * @param identifiers {Identifiers}
	 * @param customAttributes {CustomAttributes}
	 * @param initializeValues {Record<string,unknown>}
	 */ function updateUserWithValues(_0, _1) {
                return (0, _asyncToGenerator._)(function(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer;
                    var _arguments = arguments;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                initializeValues = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                return [
                                    4,
                                    this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "waitUntilInitializeCompleted",
            value: function waitUntilInitializeCompleted() {
                return (0, _asyncToGenerator._)(function() {
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!this.initPromise) throw new Error('The client must be initialized before you can wait until initialized.');
                                if (this.initCompleted) return [
                                    2
                                ];
                                return [
                                    4,
                                    this.initPromise
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
	 * Returns the value for a feature gate. Returns false if there are errors.
	 * @param {string} gateName - The name of the feature gate.
	 * @param {Object} options
	 * @param {boolean} options.fireGateExposure
	 *        Whether or not to fire the exposure event for the gate. Defaults to true.
	 *        To log an exposure event manually at a later time, use {@link Client.manuallyLogGateExposure}
	 *        (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
	 */ key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options_fireGateExposure = options.fireGateExposure, fireGateExposure = _options_fireGateExposure === void 0 ? true : _options_fireGateExposure;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            /**
	 * Manually log a gate exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
	 * This is useful if you have evaluated a gate earlier via {@link Client.checkGate} where
	 * <code>options.fireGateExposure</code> is false.
	 * @param gateName
	 */ key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            /**
	 * Returns the entire config for a given experiment.
	 *
	 * @param {string} experimentName - The name of the experiment
	 * @param {Object} options
	 * @param {boolean} options.fireExperimentExposure - Whether or not to fire the exposure event
	 * for the experiment. Defaults to true. To log an exposure event manually at a later time, use
	 * {@link Client.manuallyLogExperimentExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
	 * @returns The config for an experiment
	 * @example
	 * ```ts
	 * const experimentConfig = client.getExperiment('example-experiment-name');
	 * const backgroundColor: string = experimentConfig.get('backgroundColor', 'yellow');
	 * ```
	 */ key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options_fireExperimentExposure = options.fireExperimentExposure, fireExperimentExposure = _options_fireExperimentExposure === void 0 ? true : _options_fireExperimentExposure;
                    return (0, _dynamicConfig.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, _dynamicConfig.DynamicConfig)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, _types.EvaluationReason).Error
                    });
                }
            }
        },
        {
            /**
	 * Returns the value of a given parameter in an experiment config.
	 *
	 * @template T
	 * @param {string} experimentName - The name of the experiment
	 * @param {string} parameterName - The name of the parameter to fetch from the experiment config
	 * @param {T} defaultValue - The value to serve if the experiment or parameter do not exist, or
	 * if the returned value does not match the expected type.
	 * @param {Object} options
	 * @param {boolean} options.fireExperimentExposure - Whether or not to fire the exposure event
	 * for the experiment. Defaults to true. To log an exposure event manually at a later time, use
	 * {@link Client.manuallyLogExperimentExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-))
	 * @param {function} options.typeGuard - A function that asserts that the return value has the
	 * expected type. If this function returns false, then the default value will be returned
	 * instead. This can be set to protect your code from unexpected values being set remotely. By
	 * default, this will be done by asserting that the default value and value are the same primitive
	 * type.
	 * @returns The value of the parameter if the experiment and parameter both exist, otherwise the
	 * default value.
	 * @example
	 ``` ts
	 type ValidColor = 'blue' | 'red' | 'yellow';
	 type ValidColorTypeCheck = (value: unknown) => value is ValidColor;

	 const isValidColor: ValidColorTypeCheck =
			(value: unknown) => typeof value === 'string' && ['blue', 'red', 'yellow'].includes(value);

	 const buttonColor: ValidColor = client.getExperimentValue(
			'example-experiment-name',
			'backgroundColor',
			'yellow',
			{
					typeGuard: isValidColor
			}
	 );
	 ```
	*/ key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            /**
	 * Manually log an experiment exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
	 * This is useful if you have evaluated an experiment earlier via {@link Client.getExperimentValue} or
	 * {@link Client.getExperiment} where <code>options.fireExperimentExposure</code> is false.
	 * @param experimentName
	 */ key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            /**
	 * Manually log a layer exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
	 * This is useful if you have evaluated a layer earlier via {@link Client.getLayerValue} where <code>options.fireExperimentExposure</code> is false.
	 * @param layerName
	 * @param parameterName
	 */ key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                _this_statsigClient_getLayer;
                this.assertInitialized(this.statsigClient);
                (_this_statsigClient_getLayer = this.statsigClient.getLayer(layerName)) === null || _this_statsigClient_getLayer === void 0 ? void 0 : _this_statsigClient_getLayer.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            /**
	 * Adds a new override for the given gate.
	 *
	 * This method is additive, meaning you can call it multiple times with different gate names to
	 * build your full set of overrides.
	 *
	 * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
	 * will continue to affect every client that is initialized on the same domain after this method
	 * is called. If you are using this API for testing purposes, you should call
	 * {@link Client.clearGateOverride} after your tests are completed to remove this
	 * localStorage entry.
	 *
	 * @param {string} gateName
	 * @param {boolean} value
	 */ key: "overrideGate",
            value: function overrideGate(gateName, value) {
                var _this_statsigClient;
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) (_this_statsigClient = this.statsigClient) === null || _this_statsigClient === void 0 ? void 0 : _this_statsigClient.updateUserSync(this.user, {
                    disableBackgroundCacheRefresh: true
                });
                this.statsigValuesUpdated();
            }
        },
        {
            /**
	 * Removes any overrides that have been set for the given gate.
	 */ key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            /**
	 * Adds a new override for the given config (or experiment).
	 *
	 * This method is additive, meaning you can call it multiple times with different experiment
	 * names to build your full set of overrides.
	 *
	 * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
	 * will continue to affect every client that is initialized on the same domain after this method
	 * is called. If you are using this API for testing purposes, you should call
	 * {@link Client.clearConfigOverride} after your tests are completed to remove this
	 * localStorage entry.
	 *
	 * @param {string} experimentName
	 * @param {object} values
	 */ key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            /**
	 * Removes any overrides that have been set for the given experiment.
	 * @param {string} experimentName
	 */ key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            /**
	 * Set overrides for gates, experiments and layers in batch.
	 *
	 * Note that these overrides are **not** additive and will completely replace any that have been
	 * added via prior calls to {@link Client.overrideConfig} or
	 * {@link Client.overrideGate}.
	 *
	 * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
	 * will continue to affect every client that is initialized on the same domain after this method
	 * is called. If you are using this API for testing purposes, you should call
	 * {@link Client.clearAllOverrides} after your tests are completed to remove this
	 * localStorage entry.
	 */ key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            /**
	 * @returns The current overrides for gates, configs (including experiments) and layers.
	 */ key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            /**
	 * Clears overrides for all gates, configs (including experiments) and layers.
	 */ key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            /**
	 * Returns whether the given identifiers and customAttributes align with the current
	 * set that is being used by the client.
	 *
	 * If this method returns false, then the {@link Client.updateUser},
	 * {@link Client.updateUserWithValues} or {@link Client.updateUserWithProvider}
	 * methods can be used to re-align these values.
	 *
	 * @param identifiers
	 * @param customAttributes
	 * @returns a flag indicating whether the clients current configuration aligns with the given values
	 */ key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, _utils.shallowEquals)(this.currentIdentifiers, identifiers) && (0, _utils.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            /**
	 * Subscribe to updates where the given callback will be called with the current checkGate value
	 * @param gateName
	 * @param callback
	 * @param options
	 * @returns off function to unsubscribe from updates
	 */ key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this = this;
                var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var wrapCallback = function(value) {
                    var _options_fireGateExposure = options.fireGateExposure, fireGateExposure = _options_fireGateExposure === void 0 ? true : _options_fireGateExposure;
                    if (fireGateExposure) _this.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            /**
	 * Subscribe to updates where the given callback will be called with the current experiment value
	 * @param experimentName
	 * @param parameterName
	 * @param defaultValue
	 * @param callback
	 * @param options
	 * @returns off function to unsubscribe from updates
	 */ key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this = this;
                var options = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
                var wrapCallback = function(value) {
                    var _options_fireExperimentExposure = options.fireExperimentExposure, fireExperimentExposure = _options_fireExperimentExposure === void 0 ? true : _options_fireExperimentExposure;
                    if (fireExperimentExposure) _this.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            /**
	 * Subscribe so on any update the callback will be called.
	 * NOTE: The callback will be called whenever the values are updated even if the values have not
	 * changed.
	 * @param callback
	 * @returns off function to unsubscribe from updates
	 */ key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: /**
	 * This method initializes the client using a network call to fetch the bootstrap values for the
	 * given user.
	 *
	 * @param clientOptions
	 * @param identifiers
	 * @param customAttributes
	 * @private
	 */ function init(clientOptions, identifiers, customAttributes) {
                return (0, _asyncToGenerator._)(function() {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _ref, experimentValuesResult, error;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                fromValuesClientOptions = (0, _objectSpread._)({}, clientOptions);
                                if (!clientOptions.localMode) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    this.initFromValues(fromValuesClientOptions, identifiers, customAttributes)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    6
                                ]);
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, _fetcherDefault.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, _fetcherDefault.default).fetchExperimentValues(clientOptions, identifiers, customAttributes);
                                return [
                                    4,
                                    Promise.all([
                                        clientSdkKeyPromise,
                                        experimentValuesPromise
                                    ])
                                ];
                            case 3:
                                _ref = (0, _slicedToArray._).apply(void 0, [
                                    _state.sent(),
                                    2
                                ]), experimentValuesResult = _ref[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                return [
                                    3,
                                    6
                                ];
                            case 4:
                                error = _state.sent();
                                if ((0, _instanceof._)(error, Error)) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(error === null || error === void 0 ? void 0 : error.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                return [
                                    4,
                                    this.initFromValues(fromValuesClientOptions, identifiers, customAttributes)
                                ];
                            case 5:
                                _state.sent();
                                throw error;
                            case 6:
                                return [
                                    2,
                                    this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues)
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "initWithProvider",
            value: function initWithProvider(baseClientOptions, provider, identifiers, customAttributes) {
                return (0, _asyncToGenerator._)(function() {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _ref, experimentValuesResult, error;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                fromValuesClientOptions = (0, _objectSpreadProps._)((0, _objectSpread._)({}, baseClientOptions), {
                                    disableCurrentPageLogging: true
                                });
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    4,
                                    ,
                                    6
                                ]);
                                return [
                                    4,
                                    provider.setProfile(baseClientOptions, identifiers, customAttributes)
                                ];
                            case 2:
                                _state.sent();
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues();
                                return [
                                    4,
                                    Promise.all([
                                        clientSdkKeyPromise,
                                        experimentValuesPromise
                                    ])
                                ];
                            case 3:
                                _ref = (0, _slicedToArray._).apply(void 0, [
                                    _state.sent(),
                                    2
                                ]), experimentValuesResult = _ref[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                return [
                                    3,
                                    6
                                ];
                            case 4:
                                error = _state.sent();
                                if ((0, _instanceof._)(error, Error)) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(error === null || error === void 0 ? void 0 : error.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                return [
                                    4,
                                    this.initFromValues(fromValuesClientOptions, identifiers, customAttributes)
                                ];
                            case 5:
                                _state.sent();
                                throw error;
                            case 6:
                                return [
                                    2,
                                    this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues)
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "initFromValues",
            value: /**
	 * This method initializes the client using a set of boostrap values obtained from one of the
	 * server-side SDKs.
	 *
	 * @param clientOptions
	 * @param identifiers
	 * @param customAttributes
	 * @param initializeValues
	 * @private
	 */ function initFromValues(_0, _1, _2) {
                return (0, _asyncToGenerator._)(function(clientOptions, identifiers, customAttributes) {
                    var initializeValues, _newClientOptions_networkConfig, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, frontendUser, statsigOptions, error;
                    var _arguments = arguments;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                initializeValues = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, _utils.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions_networkConfig = newClientOptions.networkConfig) === null || _newClientOptions_networkConfig === void 0 ? void 0 : _newClientOptions_networkConfig.logEventUrl)) newClientOptions.networkConfig = (0, _objectSpreadProps._)((0, _objectSpread._)({}, newClientOptions.networkConfig), {
                                    logEventUrl: DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, _types1.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, _objectWithoutProperties._)(newClientOptions, [
                                    "sdkKey",
                                    "environment",
                                    "updateUserCompletionCallback",
                                    "perimeter"
                                ]);
                                frontendUser = (0, _utils.toStatsigUser)(identifiers, customAttributes);
                                this.user = (0, _utils.deepAssign)({}, initializeValues.user, frontendUser);
                                statsigOptions = (0, _objectSpreadProps._)((0, _objectSpread._)({}, restClientOptions), {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter,
                                    logEventCompressionMode: (0, _jsClient.LogEventCompressionMode).Forced
                                });
                                // Statsig validates the provided stableId against their own cookie, so we either need
                                // to update the cookie to match, or disable the validation completely.
                                if (identifiers.stableId) (0, _jsClient.StableID).setOverride(identifiers.stableId, sdkKey);
                                else statsigOptions.disableStableID = true;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    5
                                ]);
                                this.statsigClient = new (0, _jsClient.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                return [
                                    4,
                                    this.statsigClient.initializeAsync()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 3:
                                error = _state.sent();
                                if ((0, _instanceof._)(error, Error)) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(error === null || error === void 0 ? void 0 : error.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, _jsClient.StatsigClient)(DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                return [
                                    4,
                                    this.statsigClient.initializeAsync()
                                ];
                            case 4:
                                _state.sent();
                                this.initWithDefaults = true;
                                throw error;
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: /**
	 * This method updates the user for this client with the bootstrap values returned from a given
	 * Promise.
	 * It uses the customAttributes from fetching experiment values to update the Statsig user but
	 * uses the customAttributes from given input to check if the user has changed.
	 *
	 * @param {Identifiers} identifiers
	 * @param {CustomAttributes} customAttributes
	 * @param {Promise<InitializeValues>} getInitializeValues
	 * @private
	 */ function updateUserUsingInitializeValuesProducer(getInitializeValues, identifiers, customAttributes) {
                return (0, _asyncToGenerator._)(function() {
                    var _this, originalInitPromise, err, initializeValuesPromise, updateUserPromise;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                this.assertInitialized(this.statsigClient);
                                if (!this.initPromise) throw new Error('The client must be initialized before you can update the user.');
                                // If the user isn't changing at all, then exit immediately
                                if (this.isCurrentUser(identifiers, customAttributes)) return [
                                    2,
                                    this.initPromise
                                ];
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    this.initPromise
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                err = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes);
                                // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(function() {
                                    return (0, _asyncToGenerator._)(function() {
                                        return (0, _tsGenerator._)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    // If the update failed then it changed nothing, so revert back to the original promise.
                                                    this.initPromise = originalInitPromise;
                                                    if (!this.provider) return [
                                                        3,
                                                        2
                                                    ];
                                                    return [
                                                        4,
                                                        this.provider.setProfile(this.initOptions, this.currentIdentifiers, this.currentAttributes)
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    _state.label = 2;
                                                case 2:
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    }).call(_this);
                                });
                                return [
                                    2,
                                    updateUserPromise
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "updateStatsigClientUser",
            value: /**
	 * This method updates the user on the nested Statsig client
	 *
	 * @param identifiers
	 * @param customAttributes
	 * @param initializeValuesPromise
	 * @private
	 */ function updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes) {
                return (0, _asyncToGenerator._)(function() {
                    var _this_initOptions_updateUserCompletionCallback, _this_initOptions, initializeValues, user, frontendUser, err, _this_initOptions_updateUserCompletionCallback1, _this_initOptions1, errMsg, success, errorMessage, err1;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    initializeValuesPromise
                                ];
                            case 2:
                                initializeValues = _state.sent();
                                frontendUser = (0, _utils.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
                                user = (0, _utils.deepAssign)({}, initializeValues.experimentValues.user, frontendUser);
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                err = _state.sent();
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = (0, _instanceof._)(err, Error) ? err.message : JSON.stringify(err);
                                (_this_initOptions_updateUserCompletionCallback1 = (_this_initOptions1 = this.initOptions).updateUserCompletionCallback) === null || _this_initOptions_updateUserCompletionCallback1 === void 0 ? void 0 : _this_initOptions_updateUserCompletionCallback1.call(_this_initOptions1, false, errMsg);
                                throw err;
                            case 4:
                                success = true;
                                errorMessage = null;
                                _state.label = 5;
                            case 5:
                                _state.trys.push([
                                    5,
                                    8,
                                    ,
                                    9
                                ]);
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                if (!this.user) return [
                                    3,
                                    7
                                ];
                                return [
                                    4,
                                    this.statsigClient.updateUserAsync(this.user)
                                ];
                            case 6:
                                _state.sent();
                                _state.label = 7;
                            case 7:
                                return [
                                    3,
                                    9
                                ];
                            case 8:
                                err1 = _state.sent();
                                success = false;
                                errorMessage = String(err1);
                                return [
                                    3,
                                    9
                                ];
                            case 9:
                                (_this_initOptions = this.initOptions) === null || _this_initOptions === void 0 ? void 0 : (_this_initOptions_updateUserCompletionCallback = _this_initOptions.updateUserCompletionCallback) === null || _this_initOptions_updateUserCompletionCallback === void 0 ? void 0 : _this_initOptions_updateUserCompletionCallback.call(_this_initOptions, success, errorMessage);
                                if (success) {
                                    this.currentIdentifiers = identifiers;
                                    this.currentAttributes = customAttributes;
                                    this.subscriptions.anyUpdated();
                                } else throw new Error('Failed to update user. An unexpected error occured.');
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
	 * @returns string version of the current package in semver style.
	 */ key: "getPackageVersion",
            value: function getPackageVersion() {
                return 0, _version.CLIENT_VERSION;
            }
        },
        {
            /**
	 * Returns a specified layer otherwise returns an empty layer as a default value if the layer doesn't exist.
	 *
	 * @param {string} layerName - The name of the layer
	 * @param {Object} options
	 * @param {boolean} options.fireLayerExposure - Whether or not to fire the exposure event for the
	 * layer. Defaults to true. To log an exposure event manually at a later time, use
	 * {@link Client.manuallyLogLayerExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
	 * @returns A layer
	 * @example
	 * ```ts
	 * const layer = client.getLayer('example-layer-name');
	 * const exampletitle: string = layer.get("title", "Welcome to Statsig!");
	 * ```
	 */ key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options_fireLayerExposure = options.fireLayerExposure, fireLayerExposure = _options_fireLayerExposure === void 0 ? true : _options_fireLayerExposure;
                    return (0, _layer.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, _layer.Layer).fromLayer((0, _jsClient._makeLayer)(layerName, {
                        reason: 'Error'
                    }, null));
                }
            }
        },
        {
            /**
	 * Returns the value of a given parameter in a layer config.
	 *
	 * @template T
	 * @param {string} layerName - The name of the layer
	 * @param {string} parameterName - The name of the parameter to fetch from the layer config
	 * @param {T} defaultValue - The value to serve if the layer or parameter do not exist, or if the
	 * returned value does not match the expected type.
	 * @param {Object} options
	 * @param {boolean} options.fireLayerExposure - Whether or not to fire the exposure event for the
	 * layer. Defaults to true. To log an exposure event manually at a later time, use
	 * {@link Client.manuallyLogLayerExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-))
	 * @param {function} options.typeGuard - A function that asserts that the return value has the expected type. If this function returns false, then the default value will be returned instead. This can be set to protect your code from unexpected values being set remotely. By default, this will be done by asserting that the default value and value are the same primitive type.
	 * @returns The value of the parameter if the layer and parameter both exist, otherwise the default value.
	 * @example
	 * ``` ts
	 * type ValidColor = 'blue' | 'red' | 'yellow';
	 * type ValidColorTypeCheck = (value: unknown) => value is ValidColor;
	 *
	 * const isValidColor: ValidColorTypeCheck =
	 *    (value: unknown) => typeof value === 'string' && ['blue', 'red', 'yellow'].includes(value);
	 *
	 * const buttonColor: ValidColor = client.getLayerValue(
	 *    'example-layer-name',
	 *    'backgroundColor',
	 *    'yellow',
	 *    {
	 *        typeGuard: isValidColor
	 *    }
	 * );
	 * ```
	 */ key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
    return Client;
}();

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_ts_generator":"78Tqx","@statsig/js-client":"7YWtw","../subscriptions":"jr13a","./compat/DynamicConfig":"6MRpM","./compat/Layer":"9xpko","./compat/types":"cakyv","./fetcher":"amtXT","./NoFetchDataAdapter":"kohXZ","./PersistentOverrideAdapter":"63mtU","./types":"cETze","./utils":"dCYmQ","./version":"4vZAC","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9gdrV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _object_spread;
});
var _definePropertyJs = require("./_define_property.js");
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, _definePropertyJs._)(target, key, source[key]);
        });
    }
    return target;
}

},{"./_define_property.js":"e80IS","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"e80IS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _define_property;
});
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kANqQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _object_spread_props;
});
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6HqIM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _object_without_properties;
});
var _objectWithoutPropertiesLooseJs = require("./_object_without_properties_loose.js");
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = (0, _objectWithoutPropertiesLooseJs._)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

},{"./_object_without_properties_loose.js":"26Pwz","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"26Pwz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _object_without_properties_loose;
});
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8PtL6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _sliced_to_array;
});
var _arrayWithHolesJs = require("./_array_with_holes.js");
var _iterableToArrayLimitJs = require("./_iterable_to_array_limit.js");
var _nonIterableRestJs = require("./_non_iterable_rest.js");
var _unsupportedIterableToArrayJs = require("./_unsupported_iterable_to_array.js");
function _sliced_to_array(arr, i) {
    return (0, _arrayWithHolesJs._)(arr) || (0, _iterableToArrayLimitJs._)(arr, i) || (0, _unsupportedIterableToArrayJs._)(arr, i) || (0, _nonIterableRestJs._)();
}

},{"./_array_with_holes.js":"1b6J0","./_iterable_to_array_limit.js":"dHdPd","./_non_iterable_rest.js":"bcYt6","./_unsupported_iterable_to_array.js":"7lOoC","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1b6J0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _array_with_holes;
});
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dHdPd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _iterable_to_array_limit;
});
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bcYt6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _non_iterable_rest;
});
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7YWtw":[function(require,module,exports,__globalThis) {
"use strict";
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) __createBinding(exports1, m, p);
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.StatsigClient = void 0;
var client_core_1 = require("3d3bf38b9d43120b");
var StatsigClient_1 = require("f4bfc8b2cfd2590c");
exports.StatsigClient = StatsigClient_1.default;
__exportStar(require("3d3bf38b9d43120b"), exports);
var __STATSIG__ = Object.assign((0, client_core_1._getStatsigGlobal)(), {
    StatsigClient: StatsigClient_1.default
});
exports.default = __STATSIG__;

},{"3d3bf38b9d43120b":"1MCdW","f4bfc8b2cfd2590c":"ccWNs"}],"1MCdW":[function(require,module,exports,__globalThis) {
"use strict";
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) __createBinding(exports1, m, p);
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Storage = exports.Log = exports.EventLogger = exports.Diagnostics = void 0;
/** Statsig Global should go first */ require("42774f31a1616e13");
var __StatsigGlobal_1 = require("42774f31a1616e13");
var Diagnostics_1 = require("36df617d5a278551");
Object.defineProperty(exports, "Diagnostics", {
    enumerable: true,
    get: function get() {
        return Diagnostics_1.Diagnostics;
    }
});
var EventLogger_1 = require("71a6a45a5689058e");
Object.defineProperty(exports, "EventLogger", {
    enumerable: true,
    get: function get() {
        return EventLogger_1.EventLogger;
    }
});
var Log_1 = require("40412872a906b14e");
Object.defineProperty(exports, "Log", {
    enumerable: true,
    get: function get() {
        return Log_1.Log;
    }
});
var StatsigMetadata_1 = require("eb8b7151fabd9917");
var StorageProvider_1 = require("2fd708d4cd63f0a4");
Object.defineProperty(exports, "Storage", {
    enumerable: true,
    get: function get() {
        return StorageProvider_1.Storage;
    }
});
__exportStar(require("42774f31a1616e13"), exports);
__exportStar(require("a3e14a053ae7e93f"), exports);
__exportStar(require("638bdf858a175a64"), exports);
__exportStar(require("56d2bc222563a7e4"), exports);
__exportStar(require("36df617d5a278551"), exports);
__exportStar(require("9025a1cfceeca017"), exports);
__exportStar(require("28c590708c775ec6"), exports);
__exportStar(require("2bcdaaa10862d79b"), exports);
__exportStar(require("77071a44f5a2af3c"), exports);
__exportStar(require("e4809ebf45fe7eea"), exports);
__exportStar(require("d2aa94537228047c"), exports);
__exportStar(require("40412872a906b14e"), exports);
__exportStar(require("73dcc751accb7cde"), exports);
__exportStar(require("7466fed582e8287d"), exports);
__exportStar(require("30bc33657781e8a4"), exports);
__exportStar(require("dcce1623e636841f"), exports);
__exportStar(require("4ea5cb149a8a5ee0"), exports);
__exportStar(require("9d391107459b25a6"), exports);
__exportStar(require("7f69c82400bf6da"), exports);
__exportStar(require("161ad6fd545d259d"), exports);
__exportStar(require("8774d4b872c6a02b"), exports);
__exportStar(require("8bed2aa646cb0578"), exports);
__exportStar(require("bc9d8dd3fd8a9b2e"), exports);
__exportStar(require("af46beaac6f710cf"), exports);
__exportStar(require("2053a6b4e12fe98d"), exports);
__exportStar(require("6f302d344e852fc5"), exports);
__exportStar(require("eb8b7151fabd9917"), exports);
__exportStar(require("3d2f0ba498f053ea"), exports);
__exportStar(require("66525ad00c06c692"), exports);
__exportStar(require("c619f26e028521b"), exports);
__exportStar(require("780f8cf607a42860"), exports);
__exportStar(require("4b285a3be5236641"), exports);
__exportStar(require("2fd708d4cd63f0a4"), exports);
__exportStar(require("78b01c8c632c9db8"), exports);
__exportStar(require("b2d4bb11634ddc91"), exports);
__exportStar(require("a05c2431f9a10e10"), exports);
__exportStar(require("67c65b125578826d"), exports);
__exportStar(require("14fb07e7590ae895"), exports);
__exportStar(require("f312382bfef1b346"), exports);
__exportStar(require("6ffe1efecdb20993"), exports);
Object.assign((0, __StatsigGlobal_1._getStatsigGlobal)(), {
    Log: Log_1.Log,
    SDK_VERSION: StatsigMetadata_1.SDK_VERSION
});

},{"42774f31a1616e13":"d5W7z","36df617d5a278551":"5Y3Ef","71a6a45a5689058e":"506Fu","40412872a906b14e":"jH0ho","eb8b7151fabd9917":"dJKdX","2fd708d4cd63f0a4":"8hatk","a3e14a053ae7e93f":"eqWfV","638bdf858a175a64":"2olc2","56d2bc222563a7e4":"jzjah","9025a1cfceeca017":"4fkIQ","28c590708c775ec6":"jvCQP","2bcdaaa10862d79b":"hvbPE","77071a44f5a2af3c":"4IBGu","e4809ebf45fe7eea":"6nhM9","d2aa94537228047c":"cLvkE","73dcc751accb7cde":"4FvMU","7466fed582e8287d":"evNAP","30bc33657781e8a4":"1eoAx","dcce1623e636841f":"jjzMX","4ea5cb149a8a5ee0":"kaTYM","9d391107459b25a6":"1m3HT","7f69c82400bf6da":"3UrIZ","161ad6fd545d259d":"5Fh6O","8774d4b872c6a02b":"htdWS","8bed2aa646cb0578":"iu1pY","bc9d8dd3fd8a9b2e":"4DqMB","af46beaac6f710cf":"50bPm","2053a6b4e12fe98d":"iA4hx","6f302d344e852fc5":"iSTt6","3d2f0ba498f053ea":"98Sh7","66525ad00c06c692":"g4gRv","c619f26e028521b":"egpWn","780f8cf607a42860":"6UaT7","4b285a3be5236641":"ddLSf","78b01c8c632c9db8":"bUb5z","b2d4bb11634ddc91":"4UasP","a05c2431f9a10e10":"qCB36","67c65b125578826d":"h64IW","14fb07e7590ae895":"dBhOj","f312382bfef1b346":"l6Jw0","6ffe1efecdb20993":"8kCTX"}],"d5W7z":[function(require,module,exports,__globalThis) {
var global = arguments[3];
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ var _a, _b, _c;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports._getInstance = exports._getStatsigGlobalFlag = exports._getStatsigGlobal = void 0;
var Log_1 = require("72b9026b442600ee");
var _getStatsigGlobal = function() {
    // Avoid ReferenceError, which is happening with Cloudflare pages
    try {
        return typeof __STATSIG__ !== 'undefined' ? __STATSIG__ : statsigGlobal;
    } catch (e) {
        return statsigGlobal;
    }
};
exports._getStatsigGlobal = _getStatsigGlobal;
var _getStatsigGlobalFlag = function(flag) {
    return (0, exports._getStatsigGlobal)()[flag];
};
exports._getStatsigGlobalFlag = _getStatsigGlobalFlag;
var _getInstance = function(sdkKey) {
    var gbl = (0, exports._getStatsigGlobal)();
    if (!sdkKey) {
        if (gbl.instances && Object.keys(gbl.instances).length > 1) Log_1.Log.warn('Call made to Statsig global instance without an SDK key but there is more than one client instance. If you are using mulitple clients, please specify the SDK key.');
        return gbl.firstInstance;
    }
    return gbl.instances && gbl.instances[sdkKey];
};
exports._getInstance = _getInstance;
var GLOBAL_KEY = '__STATSIG__';
var _window = typeof window !== 'undefined' ? window : {};
var _global = typeof global !== 'undefined' ? global : {};
var _globalThis = typeof globalThis !== 'undefined' ? globalThis : {};
var statsigGlobal = (_c = (_b = (_a = _window[GLOBAL_KEY]) !== null && _a !== void 0 ? _a : _global[GLOBAL_KEY]) !== null && _b !== void 0 ? _b : _globalThis[GLOBAL_KEY]) !== null && _c !== void 0 ? _c : {
    instance: exports._getInstance
};
_window[GLOBAL_KEY] = statsigGlobal;
_global[GLOBAL_KEY] = statsigGlobal;
_globalThis[GLOBAL_KEY] = statsigGlobal;

},{"72b9026b442600ee":"jH0ho"}],"jH0ho":[function(require,module,exports,__globalThis) {
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
"use strict";
/* eslint-disable no-console */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Log = exports.LogLevel = void 0;
// intentionally spaced for formatting
var DEBUG = ' DEBUG ';
var _INFO = '  INFO ';
var _WARN = '  WARN ';
var ERROR = ' ERROR ';
function addTag(args) {
    args.unshift('[Statsig]');
    return args; // ['[Statsig]', ...args];
}
exports.LogLevel = {
    None: 0,
    Error: 1,
    Warn: 2,
    Info: 3,
    Debug: 4
};
var Log = /*#__PURE__*/ function() {
    function Log() {
        (0, _classCallCheck._)(this, Log);
    }
    (0, _createClass._)(Log, null, [
        {
            key: "info",
            value: function info() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _console;
                if (Log.level >= exports.LogLevel.Info) (_console = console).info.apply(_console, [
                    _INFO
                ].concat((0, _toConsumableArray._)(addTag(args))));
            }
        },
        {
            key: "debug",
            value: function debug() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _console;
                if (Log.level >= exports.LogLevel.Debug) (_console = console).debug.apply(_console, [
                    DEBUG
                ].concat((0, _toConsumableArray._)(addTag(args))));
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _console;
                if (Log.level >= exports.LogLevel.Warn) (_console = console).warn.apply(_console, [
                    _WARN
                ].concat((0, _toConsumableArray._)(addTag(args))));
            }
        },
        {
            key: "error",
            value: function error() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _console;
                if (Log.level >= exports.LogLevel.Error) (_console = console).error.apply(_console, [
                    ERROR
                ].concat((0, _toConsumableArray._)(addTag(args))));
            }
        }
    ]);
    return Log;
}();
exports.Log = Log;
Log.level = exports.LogLevel.Warn;

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_to_consumable_array":"1eSZf"}],"5Y3Ef":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Diagnostics = void 0;
var MARKER_MAP = new Map();
var ACT_START = 'start';
var ACT_END = 'end';
var DIAGNOSTICS_EVENT = 'statsig::diagnostics';
exports.Diagnostics = {
    _getMarkers: function(sdkKey) {
        return MARKER_MAP.get(sdkKey);
    },
    _markInitOverallStart: function(sdkKey) {
        _addMarker(sdkKey, _createMarker({}, ACT_START, 'overall'));
    },
    _markInitOverallEnd: function(sdkKey, success, evaluationDetails) {
        _addMarker(sdkKey, _createMarker({
            success: success,
            error: success ? undefined : {
                name: 'InitializeError',
                message: 'Failed to initialize'
            },
            evaluationDetails: evaluationDetails
        }, ACT_END, 'overall'));
    },
    _markInitNetworkReqStart: function(sdkKey, data) {
        _addMarker(sdkKey, _createMarker(data, ACT_START, 'initialize', 'network_request'));
    },
    _markInitNetworkReqEnd: function(sdkKey, data) {
        _addMarker(sdkKey, _createMarker(data, ACT_END, 'initialize', 'network_request'));
    },
    _markInitProcessStart: function(sdkKey) {
        _addMarker(sdkKey, _createMarker({}, ACT_START, 'initialize', 'process'));
    },
    _markInitProcessEnd: function(sdkKey, data) {
        _addMarker(sdkKey, _createMarker(data, ACT_END, 'initialize', 'process'));
    },
    _clearMarkers: function(sdkKey) {
        MARKER_MAP.delete(sdkKey);
    },
    _formatError: function _formatError(e) {
        if (!(e && (typeof e === "undefined" ? "undefined" : (0, _typeOf._)(e)) === 'object')) return;
        return {
            code: _safeGetField(e, 'code'),
            name: _safeGetField(e, 'name'),
            message: _safeGetField(e, 'message')
        };
    },
    _getDiagnosticsData: function _getDiagnosticsData(res, attempt, body, e) {
        var _a;
        return {
            success: (res === null || res === void 0 ? void 0 : res.ok) === true,
            statusCode: res === null || res === void 0 ? void 0 : res.status,
            sdkRegion: (_a = res === null || res === void 0 ? void 0 : res.headers) === null || _a === void 0 ? void 0 : _a.get('x-statsig-region'),
            isDelta: body.includes('"is_delta":true') === true ? true : undefined,
            attempt: attempt,
            error: exports.Diagnostics._formatError(e)
        };
    },
    _enqueueDiagnosticsEvent: function _enqueueDiagnosticsEvent(user, logger, sdk, options) {
        var markers = exports.Diagnostics._getMarkers(sdk);
        if (markers == null || markers.length <= 0) return -1;
        var overallInitDuration = markers[markers.length - 1].timestamp - markers[0].timestamp;
        exports.Diagnostics._clearMarkers(sdk);
        var event = _makeDiagnosticsEvent(user, {
            context: 'initialize',
            markers: markers.slice(),
            statsigOptions: options
        });
        logger.enqueue(event);
        return overallInitDuration;
    }
};
function _createMarker(data, action, key, step) {
    return Object.assign({
        key: key,
        action: action,
        step: step,
        timestamp: Date.now()
    }, data);
}
function _makeDiagnosticsEvent(user, data) {
    var latencyEvent = {
        eventName: DIAGNOSTICS_EVENT,
        user: user,
        value: null,
        metadata: data,
        time: Date.now()
    };
    return latencyEvent;
}
function _addMarker(sdkKey, marker) {
    var _a;
    var markers = (_a = MARKER_MAP.get(sdkKey)) !== null && _a !== void 0 ? _a : [];
    markers.push(marker);
    MARKER_MAP.set(sdkKey, markers);
}
function _safeGetField(data, field) {
    if (field in data) return data[field];
    return undefined;
}

},{"@swc/helpers/_/_type_of":"iFJdx"}],"506Fu":[function(require,module,exports,__globalThis) {
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
"use strict";
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return (0, _instanceof._)(value, P) ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EventLogger = void 0;
var CacheKey_1 = require("ea9e7e51b616b9d8");
var Hashing_1 = require("61271087423b1759");
var Log_1 = require("74c9a18f8613ef4c");
var NetworkConfig_1 = require("10c8db90612f1d13");
var SafeJs_1 = require("d984907798e1f9c0");
var StatsigEvent_1 = require("e36f36dcdff98b73");
var StatsigOptionsCommon_1 = require("81d9df7ce8249977");
var StorageProvider_1 = require("66b2b879f40934fe");
var UrlConfiguration_1 = require("9c6e1167ccdc670b");
var VisibilityObserving_1 = require("f159217587a1095c");
var DEFAULT_QUEUE_SIZE = 100;
var DEFAULT_FLUSH_INTERVAL_MS = 10000;
var MAX_DEDUPER_KEYS = 1000;
var DEDUPER_WINDOW_DURATION_MS = 600000;
var MAX_FAILED_LOGS = 500;
var QUICK_FLUSH_WINDOW_MS = 200;
var EVENT_LOGGER_MAP = {};
var EventLogger = /*#__PURE__*/ function() {
    function EventLogger(_sdkKey, _emitter, _network, _options) {
        (0, _classCallCheck._)(this, EventLogger);
        var _a, _b;
        this._sdkKey = _sdkKey;
        this._emitter = _emitter;
        this._network = _network;
        this._options = _options;
        this._queue = [];
        this._lastExposureTimeMap = {};
        this._nonExposedChecks = {};
        this._hasRunQuickFlush = false;
        this._creationTime = Date.now();
        this._loggingEnabled = (_a = _options === null || _options === void 0 ? void 0 : _options.loggingEnabled) !== null && _a !== void 0 ? _a : (_options === null || _options === void 0 ? void 0 : _options.disableLogging) === true ? StatsigOptionsCommon_1.LoggingEnabledOption.disabled : StatsigOptionsCommon_1.LoggingEnabledOption.browserOnly;
        if ((_options === null || _options === void 0 ? void 0 : _options.loggingEnabled) && _options.disableLogging !== undefined) Log_1.Log.warn('Detected both loggingEnabled and disableLogging options. loggingEnabled takes precedence - please remove disableLogging.');
        this._maxQueueSize = (_b = _options === null || _options === void 0 ? void 0 : _options.loggingBufferMaxSize) !== null && _b !== void 0 ? _b : DEFAULT_QUEUE_SIZE;
        var config = _options === null || _options === void 0 ? void 0 : _options.networkConfig;
        this._logEventUrlConfig = new UrlConfiguration_1.UrlConfiguration(NetworkConfig_1.Endpoint._rgstr, config === null || config === void 0 ? void 0 : config.logEventUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.logEventFallbackUrls);
    }
    (0, _createClass._)(EventLogger, [
        {
            key: "setLogEventCompressionMode",
            value: function setLogEventCompressionMode(mode) {
                this._network.setLogEventCompressionMode(mode);
            }
        },
        {
            key: "setLoggingEnabled",
            value: function setLoggingEnabled(loggingEnabled) {
                if (this._loggingEnabled === 'disabled' && loggingEnabled !== 'disabled') {
                    var _this__queue;
                    // load any pre consented events into memory
                    var storageKey = this._getStorageKey();
                    var events = (0, StorageProvider_1._getObjectFromStorage)(storageKey);
                    if (events) (_this__queue = this._queue).push.apply(_this__queue, (0, _toConsumableArray._)(events));
                    StorageProvider_1.Storage.removeItem(storageKey);
                }
                this._loggingEnabled = loggingEnabled;
            }
        },
        {
            key: "enqueue",
            value: function enqueue(event) {
                if (!this._shouldLogEvent(event)) return;
                this._normalizeAndAppendEvent(event);
                this._quickFlushIfNeeded();
                if (this._queue.length > this._maxQueueSize) EventLogger._safeFlushAndForget(this._sdkKey);
            }
        },
        {
            key: "incrementNonExposureCount",
            value: function incrementNonExposureCount(name) {
                var _a;
                var current = (_a = this._nonExposedChecks[name]) !== null && _a !== void 0 ? _a : 0;
                this._nonExposedChecks[name] = current + 1;
            }
        },
        {
            key: "reset",
            value: function reset() {
                // attempt to flush any remaining events
                this.flush().catch(function() {
                // noop
                });
                this._lastExposureTimeMap = {};
            }
        },
        {
            key: "start",
            value: function start() {
                var _this = this;
                var _a;
                var isServerEnv = (0, SafeJs_1._isServerEnv)();
                if (isServerEnv && ((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always') return;
                EVENT_LOGGER_MAP[this._sdkKey] = this;
                if (!isServerEnv) (0, VisibilityObserving_1._subscribeToVisiblityChanged)(function(visibility) {
                    if (visibility === 'background') EventLogger._safeFlushAndForget(_this._sdkKey);
                    else if (visibility === 'foreground') EventLogger._safeRetryFailedLogs(_this._sdkKey);
                });
                this._retryFailedLogs();
                this._startBackgroundFlushInterval();
            }
        },
        {
            key: "stop",
            value: function stop() {
                return __awaiter(this, void 0, void 0, function() {
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (this._flushIntervalId) {
                                    clearInterval(this._flushIntervalId);
                                    this._flushIntervalId = null;
                                }
                                delete EVENT_LOGGER_MAP[this._sdkKey];
                                return [
                                    4,
                                    this.flush()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "flush",
            value: function flush() {
                return __awaiter(this, void 0, void 0, function() {
                    var events;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                this._appendAndResetNonExposedChecks();
                                if (this._queue.length === 0) return [
                                    2
                                ];
                                events = this._queue;
                                this._queue = [];
                                return [
                                    4,
                                    this._sendEvents(events)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            /**
     * We 'Quick Flush' following the very first event enqueued
     * within the quick flush window
     */ key: "_quickFlushIfNeeded",
            value: function _quickFlushIfNeeded() {
                var _this = this;
                if (this._hasRunQuickFlush) return;
                this._hasRunQuickFlush = true;
                if (Date.now() - this._creationTime > QUICK_FLUSH_WINDOW_MS) return;
                setTimeout(function() {
                    return EventLogger._safeFlushAndForget(_this._sdkKey);
                }, QUICK_FLUSH_WINDOW_MS);
            }
        },
        {
            key: "_shouldLogEvent",
            value: function _shouldLogEvent(event) {
                var _a;
                if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always' && (0, SafeJs_1._isServerEnv)()) return false;
                if (!(0, StatsigEvent_1._isExposureEvent)(event)) return true;
                var user = event.user ? event.user : {
                    statsigEnvironment: undefined
                };
                var userKey = (0, CacheKey_1._getUserStorageKey)(this._sdkKey, user);
                var metadata = event.metadata ? event.metadata : {};
                var key = [
                    event.eventName,
                    userKey,
                    metadata['gate'],
                    metadata['config'],
                    metadata['ruleID'],
                    metadata['allocatedExperiment'],
                    metadata['parameterName'],
                    String(metadata['isExplicitParameter']),
                    metadata['reason']
                ].join('|');
                var previous = this._lastExposureTimeMap[key];
                var now = Date.now();
                if (previous && now - previous < DEDUPER_WINDOW_DURATION_MS) return false;
                if (Object.keys(this._lastExposureTimeMap).length > MAX_DEDUPER_KEYS) this._lastExposureTimeMap = {};
                this._lastExposureTimeMap[key] = now;
                return true;
            }
        },
        {
            key: "_sendEvents",
            value: function _sendEvents(events) {
                return __awaiter(this, void 0, void 0, function() {
                    var _a, _b, isClosing, shouldUseBeacon, response, _tmp, _c;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (this._loggingEnabled === 'disabled') {
                                    this._saveFailedLogsToStorage(events);
                                    return [
                                        2,
                                        false
                                    ];
                                }
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    5,
                                    ,
                                    6
                                ]);
                                isClosing = (0, VisibilityObserving_1._isUnloading)();
                                shouldUseBeacon = isClosing && this._network.isBeaconSupported() && ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.networkOverrideFunc) == null;
                                this._emitter({
                                    name: 'pre_logs_flushed',
                                    events: events
                                });
                                if (!shouldUseBeacon) return [
                                    3,
                                    2
                                ];
                                _tmp = this._sendEventsViaBeacon(events);
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                return [
                                    4,
                                    this._sendEventsViaPost(events)
                                ];
                            case 3:
                                _tmp = _state.sent();
                                _state.label = 4;
                            case 4:
                                response = _tmp;
                                if (response.success) {
                                    this._emitter({
                                        name: 'logs_flushed',
                                        events: events
                                    });
                                    return [
                                        2,
                                        true
                                    ];
                                } else {
                                    Log_1.Log.warn('Failed to flush events.');
                                    this._saveFailedLogsToStorage(events);
                                    return [
                                        2,
                                        false
                                    ];
                                }
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                _c = _state.sent();
                                Log_1.Log.warn('Failed to flush events.');
                                return [
                                    2,
                                    false
                                ];
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_sendEventsViaPost",
            value: function _sendEventsViaPost(events) {
                return __awaiter(this, void 0, void 0, function() {
                    var _a, result, code;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this._network.post(this._getRequestData(events))
                                ];
                            case 1:
                                result = _state.sent();
                                code = (_a = result === null || result === void 0 ? void 0 : result.code) !== null && _a !== void 0 ? _a : -1;
                                return [
                                    2,
                                    {
                                        success: code >= 200 && code < 300
                                    }
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_sendEventsViaBeacon",
            value: function _sendEventsViaBeacon(events) {
                return {
                    success: this._network.beacon(this._getRequestData(events))
                };
            }
        },
        {
            key: "_getRequestData",
            value: function _getRequestData(events) {
                return {
                    sdkKey: this._sdkKey,
                    data: {
                        events: events
                    },
                    urlConfig: this._logEventUrlConfig,
                    retries: 3,
                    isCompressable: true,
                    params: (0, _defineProperty._)({}, NetworkConfig_1.NetworkParam.EventCount, String(events.length)),
                    credentials: 'same-origin'
                };
            }
        },
        {
            key: "_saveFailedLogsToStorage",
            value: function _saveFailedLogsToStorage(events) {
                while(events.length > MAX_FAILED_LOGS)events.shift();
                var storageKey = this._getStorageKey();
                try {
                    var savedEvents = this._getFailedLogsFromStorage(storageKey);
                    (0, StorageProvider_1._setObjectInStorage)(storageKey, (0, _toConsumableArray._)(savedEvents).concat((0, _toConsumableArray._)(events)));
                } catch (_a) {
                    Log_1.Log.warn('Unable to save failed logs to storage');
                }
            }
        },
        {
            key: "_getFailedLogsFromStorage",
            value: function _getFailedLogsFromStorage(storageKey) {
                var savedEvents = [];
                try {
                    var retrieved = (0, StorageProvider_1._getObjectFromStorage)(storageKey);
                    if (Array.isArray(retrieved)) savedEvents = retrieved;
                    return savedEvents;
                } catch (_a) {
                    return [];
                }
            }
        },
        {
            key: "_retryFailedLogs",
            value: function _retryFailedLogs() {
                var _this = this;
                var storageKey = this._getStorageKey();
                (function() {
                    return __awaiter(_this, void 0, void 0, function() {
                        var events;
                        return (0, _tsGenerator._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!!StorageProvider_1.Storage.isReady()) return [
                                        3,
                                        2
                                    ];
                                    return [
                                        4,
                                        StorageProvider_1.Storage.isReadyResolver()
                                    ];
                                case 1:
                                    _state.sent();
                                    _state.label = 2;
                                case 2:
                                    events = (0, StorageProvider_1._getObjectFromStorage)(storageKey);
                                    if (!events) return [
                                        2
                                    ];
                                    StorageProvider_1.Storage.removeItem(storageKey);
                                    return [
                                        4,
                                        this._sendEvents(events)
                                    ];
                                case 3:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                })().catch(function() {
                    Log_1.Log.warn('Failed to flush stored logs');
                });
            }
        },
        {
            key: "_getStorageKey",
            value: function _getStorageKey() {
                return "statsig.failed_logs.".concat((0, Hashing_1._DJB2)(this._sdkKey));
            }
        },
        {
            key: "_normalizeAndAppendEvent",
            value: function _normalizeAndAppendEvent(event) {
                if (event.user) {
                    event.user = Object.assign({}, event.user);
                    delete event.user.privateAttributes;
                }
                var extras = {};
                var currentPage = this._getCurrentPageUrl();
                if (currentPage) extras.statsigMetadata = {
                    currentPage: currentPage
                };
                var final = Object.assign(Object.assign({}, event), extras);
                Log_1.Log.debug('Enqueued Event:', final);
                this._queue.push(final);
            }
        },
        {
            key: "_appendAndResetNonExposedChecks",
            value: function _appendAndResetNonExposedChecks() {
                if (Object.keys(this._nonExposedChecks).length === 0) return;
                this._normalizeAndAppendEvent({
                    eventName: 'statsig::non_exposed_checks',
                    user: null,
                    time: Date.now(),
                    metadata: {
                        checks: Object.assign({}, this._nonExposedChecks)
                    }
                });
                this._nonExposedChecks = {};
            }
        },
        {
            key: "_getCurrentPageUrl",
            value: function _getCurrentPageUrl() {
                var _a;
                if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.includeCurrentPageUrlWithEvents) === false) return;
                return (0, SafeJs_1._getCurrentPageUrlSafe)();
            }
        },
        {
            key: "_startBackgroundFlushInterval",
            value: function _startBackgroundFlushInterval() {
                var _this = this;
                var _a, _b;
                var flushInterval = (_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingIntervalMs) !== null && _b !== void 0 ? _b : DEFAULT_FLUSH_INTERVAL_MS;
                var intervalId = setInterval(function() {
                    var logger = EVENT_LOGGER_MAP[_this._sdkKey];
                    if (!logger || logger._flushIntervalId !== intervalId) clearInterval(intervalId);
                    else EventLogger._safeFlushAndForget(_this._sdkKey);
                }, flushInterval);
                this._flushIntervalId = intervalId;
            }
        }
    ], [
        {
            key: "_safeFlushAndForget",
            value: function _safeFlushAndForget(sdkKey) {
                var _a;
                (_a = EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a.flush().catch(function() {
                // noop
                });
            }
        },
        {
            key: "_safeRetryFailedLogs",
            value: function _safeRetryFailedLogs(sdkKey) {
                var _a;
                (_a = EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a._retryFailedLogs();
            }
        }
    ]);
    return EventLogger;
}();
exports.EventLogger = EventLogger;

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_to_consumable_array":"1eSZf","@swc/helpers/_/_ts_generator":"78Tqx","ea9e7e51b616b9d8":"eqWfV","61271087423b1759":"6nhM9","74c9a18f8613ef4c":"jH0ho","10c8db90612f1d13":"evNAP","d984907798e1f9c0":"1m3HT","e36f36dcdff98b73":"iSTt6","81d9df7ce8249977":"98Sh7","66b2b879f40934fe":"8hatk","9c6e1167ccdc670b":"qCB36","f159217587a1095c":"dBhOj"}],"eqWfV":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports._getStorageKey = exports._getUserStorageKey = void 0;
var Hashing_1 = require("e73d0ab2a080df3e");
function _getUserStorageKey(sdkKey, user, customKeyGenerator) {
    var _a;
    if (customKeyGenerator) return customKeyGenerator(sdkKey, user);
    var cids = user && user.customIDs ? user.customIDs : {};
    var parts = [
        "uid:".concat((_a = user === null || user === void 0 ? void 0 : user.userID) !== null && _a !== void 0 ? _a : ''),
        "cids:".concat(Object.keys(cids).sort(function(leftKey, rightKey) {
            return leftKey.localeCompare(rightKey);
        }).map(function(key) {
            return "".concat(key, "-").concat(cids[key]);
        }).join(',')),
        "k:".concat(sdkKey)
    ];
    return (0, Hashing_1._DJB2)(parts.join('|'));
}
exports._getUserStorageKey = _getUserStorageKey;
function _getStorageKey(sdkKey, user, customKeyGenerator) {
    if (user) return _getUserStorageKey(sdkKey, user, customKeyGenerator);
    return (0, Hashing_1._DJB2)("k:".concat(sdkKey));
}
exports._getStorageKey = _getStorageKey;

},{"e73d0ab2a080df3e":"6nhM9"}],"6nhM9":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports._getSortedObject = exports._DJB2Object = exports._DJB2 = void 0;
var TypingUtils_1 = require("1465599b27b747e8");
var _DJB2 = function(value) {
    var hash = 0;
    for(var i = 0; i < value.length; i++){
        var character = value.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash >>> 0);
};
exports._DJB2 = _DJB2;
var _DJB2Object = function(value, maxLevels) {
    return (0, exports._DJB2)(JSON.stringify((0, exports._getSortedObject)(value, maxLevels)));
};
exports._DJB2Object = _DJB2Object;
var _getSortedObject = function(object, maxDepth) {
    if (object == null) return null;
    var keys = Object.keys(object).sort();
    var sortedObject = {};
    keys.forEach(function(key) {
        var value = object[key];
        if (maxDepth === 0 || (0, TypingUtils_1._typeOf)(value) !== 'object') {
            sortedObject[key] = value;
            return;
        }
        sortedObject[key] = (0, exports._getSortedObject)(value, maxDepth != null ? maxDepth - 1 : maxDepth);
    });
    return sortedObject;
};
exports._getSortedObject = _getSortedObject;

},{"1465599b27b747e8":"4UasP"}],"4UasP":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports._isTypeMatch = exports._typeOf = void 0;
function _typeOf1(input) {
    return Array.isArray(input) ? 'array' : typeof input === "undefined" ? "undefined" : (0, _typeOf._)(input);
}
exports._typeOf = _typeOf1;
function _isTypeMatch(a, b) {
    var typeOf = function(x) {
        return Array.isArray(x) ? 'array' : x === null ? 'null' : typeof x === "undefined" ? "undefined" : (0, _typeOf._)(x);
    };
    return typeOf(a) === typeOf(b);
}
exports._isTypeMatch = _isTypeMatch;

},{"@swc/helpers/_/_type_of":"iFJdx"}],"evNAP":[function(require,module,exports,__globalThis) {
var _defineProperty = require("@swc/helpers/_/_define_property");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NetworkParam = exports.NetworkDefault = exports.Endpoint = void 0;
exports.Endpoint = {
    _initialize: 'initialize',
    _rgstr: 'rgstr',
    _download_config_specs: 'download_config_specs'
};
var _obj;
exports.NetworkDefault = (_obj = {}, (0, _defineProperty._)(_obj, exports.Endpoint._rgstr, 'https://prodregistryv2.org/v1'), (0, _defineProperty._)(_obj, exports.Endpoint._initialize, 'https://featureassets.org/v1'), (0, _defineProperty._)(_obj, exports.Endpoint._download_config_specs, 'https://api.statsigcdn.com/v1'), _obj);
exports.NetworkParam = {
    EventCount: 'ec',
    SdkKey: 'k',
    SdkType: 'st',
    SdkVersion: 'sv',
    Time: 't',
    SessionID: 'sid',
    StatsigEncoded: 'se',
    IsGzipped: 'gz'
};

},{"@swc/helpers/_/_define_property":"e80IS"}],"1m3HT":[function(require,module,exports,__globalThis) {
var process = require("a0f18ecaf71a6ee0");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports._getUnloadEvent = exports._getCurrentPageUrlSafe = exports._addDocumentEventListenerSafe = exports._addWindowEventListenerSafe = exports._isServerEnv = exports._getDocumentSafe = exports._getWindowSafe = void 0;
var _getWindowSafe = function() {
    return typeof window !== 'undefined' ? window : null;
};
exports._getWindowSafe = _getWindowSafe;
var _getDocumentSafe = function() {
    var _a;
    var win = (0, exports._getWindowSafe)();
    return (_a = win === null || win === void 0 ? void 0 : win.document) !== null && _a !== void 0 ? _a : null;
};
exports._getDocumentSafe = _getDocumentSafe;
var _isServerEnv = function() {
    if ((0, exports._getDocumentSafe)() !== null) return false;
    var isNode = typeof process !== 'undefined' && process.versions != null && process.versions.node != null;
    var isVercel = typeof EdgeRuntime === 'string';
    return isVercel || isNode;
};
exports._isServerEnv = _isServerEnv;
var _addWindowEventListenerSafe = function(key, listener) {
    var win = (0, exports._getWindowSafe)();
    if (typeof (win === null || win === void 0 ? void 0 : win.addEventListener) === 'function') win.addEventListener(key, listener);
};
exports._addWindowEventListenerSafe = _addWindowEventListenerSafe;
var _addDocumentEventListenerSafe = function(key, listener) {
    var doc = (0, exports._getDocumentSafe)();
    if (typeof (doc === null || doc === void 0 ? void 0 : doc.addEventListener) === 'function') doc.addEventListener(key, listener);
};
exports._addDocumentEventListenerSafe = _addDocumentEventListenerSafe;
var _getCurrentPageUrlSafe = function() {
    var _a;
    try {
        return (_a = (0, exports._getWindowSafe)()) === null || _a === void 0 ? void 0 : _a.location.href.split(/[?#]/)[0];
    } catch (_b) {
        return;
    }
};
exports._getCurrentPageUrlSafe = _getCurrentPageUrlSafe;
var _getUnloadEvent = function() {
    var win = (0, exports._getWindowSafe)();
    if (!win) return 'beforeunload';
    var eventType = 'onpagehide' in win ? 'pagehide' : 'beforeunload';
    return eventType;
};
exports._getUnloadEvent = _getUnloadEvent;

},{"a0f18ecaf71a6ee0":"gNLf3"}],"iSTt6":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports._createLayerParameterExposure = exports._createConfigExposure = exports._mapExposures = exports._createGateExposure = exports._isExposureEvent = void 0;
var CONFIG_EXPOSURE_NAME = 'statsig::config_exposure';
var GATE_EXPOSURE_NAME = 'statsig::gate_exposure';
var LAYER_EXPOSURE_NAME = 'statsig::layer_exposure';
var _createExposure = function(eventName, user, details, metadata, secondaryExposures) {
    if (details.bootstrapMetadata) metadata['bootstrapMetadata'] = details.bootstrapMetadata;
    return {
        eventName: eventName,
        user: user,
        value: null,
        metadata: _addEvaluationDetailsToMetadata(details, metadata),
        secondaryExposures: secondaryExposures,
        time: Date.now()
    };
};
var _isExposureEvent = function(param) {
    var eventName = param.eventName;
    return eventName === GATE_EXPOSURE_NAME || eventName === CONFIG_EXPOSURE_NAME || eventName === LAYER_EXPOSURE_NAME;
};
exports._isExposureEvent = _isExposureEvent;
var _createGateExposure = function(user, gate, exposureMapping) {
    var _a, _b, _c;
    var metadata = {
        gate: gate.name,
        gateValue: String(gate.value),
        ruleID: gate.ruleID
    };
    if (((_a = gate.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = gate.__evaluation.version;
    return _createExposure(GATE_EXPOSURE_NAME, user, gate.details, metadata, _mapExposures((_c = (_b = gate.__evaluation) === null || _b === void 0 ? void 0 : _b.secondary_exposures) !== null && _c !== void 0 ? _c : [], exposureMapping));
};
exports._createGateExposure = _createGateExposure;
function _mapExposures(exposures, exposureMapping) {
    return exposures.map(function(exposure) {
        if (typeof exposure === 'string') return (exposureMapping !== null && exposureMapping !== void 0 ? exposureMapping : {})[exposure];
        return exposure;
    }).filter(function(exposure) {
        return exposure != null;
    });
}
exports._mapExposures = _mapExposures;
var _createConfigExposure = function(user, config, exposureMapping) {
    var _a, _b, _c, _d;
    var metadata = {
        config: config.name,
        ruleID: config.ruleID
    };
    if (((_a = config.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = config.__evaluation.version;
    if (((_b = config.__evaluation) === null || _b === void 0 ? void 0 : _b.passed) != null) metadata['rulePassed'] = String(config.__evaluation.passed);
    return _createExposure(CONFIG_EXPOSURE_NAME, user, config.details, metadata, _mapExposures((_d = (_c = config.__evaluation) === null || _c === void 0 ? void 0 : _c.secondary_exposures) !== null && _d !== void 0 ? _d : [], exposureMapping));
};
exports._createConfigExposure = _createConfigExposure;
var _createLayerParameterExposure = function(user, layer, parameterName, exposureMapping) {
    var _a, _b, _c, _d, _e, _f, _g;
    var evaluation = layer.__evaluation;
    var isExplicit = ((_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.explicit_parameters) === null || _a === void 0 ? void 0 : _a.includes(parameterName)) === true;
    var allocatedExperiment = '';
    var secondaryExposures = (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.undelegated_secondary_exposures) !== null && _b !== void 0 ? _b : [];
    if (isExplicit) {
        allocatedExperiment = (_c = evaluation.allocated_experiment_name) !== null && _c !== void 0 ? _c : '';
        secondaryExposures = (_d = evaluation.secondary_exposures) !== null && _d !== void 0 ? _d : [];
    }
    var parameterRuleIDs = (_e = layer.__evaluation) === null || _e === void 0 ? void 0 : _e.parameter_rule_ids;
    var metadata = {
        config: layer.name,
        parameterName: parameterName,
        ruleID: (_f = parameterRuleIDs === null || parameterRuleIDs === void 0 ? void 0 : parameterRuleIDs[parameterName]) !== null && _f !== void 0 ? _f : layer.ruleID,
        allocatedExperiment: allocatedExperiment,
        isExplicitParameter: String(isExplicit)
    };
    if (((_g = layer.__evaluation) === null || _g === void 0 ? void 0 : _g.version) != null) metadata['configVersion'] = layer.__evaluation.version;
    return _createExposure(LAYER_EXPOSURE_NAME, user, layer.details, metadata, _mapExposures(secondaryExposures, exposureMapping));
};
exports._createLayerParameterExposure = _createLayerParameterExposure;
var _addEvaluationDetailsToMetadata = function(details, metadata) {
    metadata['reason'] = details.reason;
    if (details.lcut) metadata['lcut'] = String(details.lcut);
    if (details.receivedAt) metadata['receivedAt'] = String(details.receivedAt);
    return metadata;
};

},{}],"98Sh7":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LoggingEnabledOption = exports.LogEventCompressionMode = void 0;
exports.LogEventCompressionMode = {
    /** Do not compress request bodies */ Disabled: 'd',
    /** Compress request bodies unless a network proxy is configured */ Enabled: 'e',
    /** Always compress request bodies, even when a proxy is configured */ Forced: 'f'
};
exports.LoggingEnabledOption = {
    disabled: 'disabled',
    browserOnly: 'browser-only',
    always: 'always'
};

},{}],"8hatk":[function(require,module,exports,__globalThis) {
var _instanceof = require("@swc/helpers/_/_instanceof");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports._setObjectInStorage = exports._getObjectFromStorage = exports.Storage = void 0;
var Log_1 = require("28586ab5c5ee4f12");
var SafeJs_1 = require("4a6c3002da1493eb");
var inMemoryStore = {};
var _inMemoryProvider = {
    isReady: function() {
        return true;
    },
    isReadyResolver: function() {
        return null;
    },
    getProviderName: function() {
        return 'InMemory';
    },
    getItem: function(key) {
        return inMemoryStore[key] ? inMemoryStore[key] : null;
    },
    setItem: function(key, value) {
        inMemoryStore[key] = value;
    },
    removeItem: function(key) {
        delete inMemoryStore[key];
    },
    getAllKeys: function() {
        return Object.keys(inMemoryStore);
    }
};
var _localStorageProvider = null;
try {
    var win = (0, SafeJs_1._getWindowSafe)();
    if (win && win.localStorage && typeof win.localStorage.getItem === 'function') _localStorageProvider = {
        isReady: function() {
            return true;
        },
        isReadyResolver: function() {
            return null;
        },
        getProviderName: function() {
            return 'LocalStorage';
        },
        getItem: function(key) {
            return win.localStorage.getItem(key);
        },
        setItem: function(key, value) {
            return win.localStorage.setItem(key, value);
        },
        removeItem: function(key) {
            return win.localStorage.removeItem(key);
        },
        getAllKeys: function() {
            return Object.keys(win.localStorage);
        }
    };
} catch (error) {
    Log_1.Log.warn('Failed to setup localStorageProvider.');
}
var _main = _localStorageProvider !== null && _localStorageProvider !== void 0 ? _localStorageProvider : _inMemoryProvider;
var _current = _main;
function _inMemoryBreaker(action) {
    try {
        return action();
    } catch (error) {
        if ((0, _instanceof._)(error, Error) && error.name === 'SecurityError') {
            exports.Storage._setProvider(_inMemoryProvider);
            return null;
        }
        throw error;
    }
}
exports.Storage = {
    isReady: function() {
        return _current.isReady();
    },
    isReadyResolver: function() {
        return _current.isReadyResolver();
    },
    getProviderName: function() {
        return _current.getProviderName();
    },
    getItem: function(key) {
        return _inMemoryBreaker(function() {
            return _current.getItem(key);
        });
    },
    setItem: function(key, value) {
        return _inMemoryBreaker(function() {
            return _current.setItem(key, value);
        });
    },
    removeItem: function(key) {
        return _current.removeItem(key);
    },
    getAllKeys: function() {
        return _current.getAllKeys();
    },
    // StorageProviderManagment
    _setProvider: function(newProvider) {
        _main = newProvider;
        _current = newProvider;
    },
    _setDisabled: function(isDisabled) {
        if (isDisabled) _current = _inMemoryProvider;
        else _current = _main;
    }
};
function _getObjectFromStorage(key) {
    var value = exports.Storage.getItem(key);
    try {
        return JSON.parse(value !== null && value !== void 0 ? value : 'null');
    } catch (e) {
        Log_1.Log.error('Failed to parse value for key "'.concat(key, '"'));
        return null;
    }
}
exports._getObjectFromStorage = _getObjectFromStorage;
function _setObjectInStorage(key, obj) {
    exports.Storage.setItem(key, JSON.stringify(obj));
}
exports._setObjectInStorage = _setObjectInStorage;

},{"@swc/helpers/_/_instanceof":"h9UKc","28586ab5c5ee4f12":"jH0ho","4a6c3002da1493eb":"1m3HT"}],"qCB36":[function(require,module,exports,__globalThis) {
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UrlConfiguration = void 0;
var Hashing_1 = require("dc20f21457bcfe8a");
var NetworkConfig_1 = require("cc0d9c54e09f93f2");
var _obj;
var ENDPOINT_DNS_KEY_MAP = (_obj = {}, (0, _defineProperty._)(_obj, NetworkConfig_1.Endpoint._initialize, 'i'), (0, _defineProperty._)(_obj, NetworkConfig_1.Endpoint._rgstr, 'e'), (0, _defineProperty._)(_obj, NetworkConfig_1.Endpoint._download_config_specs, 'd'), _obj);
var UrlConfiguration = /*#__PURE__*/ function() {
    function UrlConfiguration(endpoint, customUrl, customApi, fallbackUrls) {
        (0, _classCallCheck._)(this, UrlConfiguration);
        this.customUrl = null;
        this.fallbackUrls = null;
        this.endpoint = endpoint;
        this.endpointDnsKey = ENDPOINT_DNS_KEY_MAP[endpoint];
        if (customUrl) this.customUrl = customUrl;
        if (!customUrl && customApi) this.customUrl = customApi.endsWith('/') ? "".concat(customApi).concat(endpoint) : "".concat(customApi, "/").concat(endpoint);
        if (fallbackUrls) this.fallbackUrls = fallbackUrls;
        var defaultApi = NetworkConfig_1.NetworkDefault[endpoint];
        this.defaultUrl = "".concat(defaultApi, "/").concat(endpoint);
    }
    (0, _createClass._)(UrlConfiguration, [
        {
            key: "getUrl",
            value: function getUrl() {
                var _a;
                return (_a = this.customUrl) !== null && _a !== void 0 ? _a : this.defaultUrl;
            }
        },
        {
            key: "getChecksum",
            value: function getChecksum() {
                var _a;
                var fallbacks = ((_a = this.fallbackUrls) !== null && _a !== void 0 ? _a : []).sort().join(',');
                return (0, Hashing_1._DJB2)(this.customUrl + fallbacks);
            }
        }
    ]);
    return UrlConfiguration;
}();
exports.UrlConfiguration = UrlConfiguration;

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_define_property":"e80IS","dc20f21457bcfe8a":"6nhM9","cc0d9c54e09f93f2":"evNAP"}],"dBhOj":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports._notifyVisibilityChanged = exports._subscribeToVisiblityChanged = exports._isUnloading = exports._isCurrentlyVisible = void 0;
var SafeJs_1 = require("783220254f29c7a8");
var FOREGROUND = 'foreground';
var BACKGROUND = 'background';
var LISTENERS = [];
var current = FOREGROUND;
var isUnloading = false;
var _isCurrentlyVisible = function() {
    return current === FOREGROUND;
};
exports._isCurrentlyVisible = _isCurrentlyVisible;
var _isUnloading = function() {
    return isUnloading;
};
exports._isUnloading = _isUnloading;
var _subscribeToVisiblityChanged = function(listener) {
    LISTENERS.unshift(listener);
};
exports._subscribeToVisiblityChanged = _subscribeToVisiblityChanged;
var _notifyVisibilityChanged = function(visibility) {
    if (visibility === current) return;
    current = visibility;
    LISTENERS.forEach(function(l) {
        return l(visibility);
    });
};
exports._notifyVisibilityChanged = _notifyVisibilityChanged;
(0, SafeJs_1._addWindowEventListenerSafe)('focus', function() {
    isUnloading = false;
    (0, exports._notifyVisibilityChanged)(FOREGROUND);
});
(0, SafeJs_1._addWindowEventListenerSafe)('blur', function() {
    return (0, exports._notifyVisibilityChanged)(BACKGROUND);
});
(0, SafeJs_1._addDocumentEventListenerSafe)('visibilitychange', function() {
    (0, exports._notifyVisibilityChanged)(document.visibilityState === 'visible' ? FOREGROUND : BACKGROUND);
});
(0, SafeJs_1._addWindowEventListenerSafe)((0, SafeJs_1._getUnloadEvent)(), function() {
    isUnloading = true;
    (0, exports._notifyVisibilityChanged)(BACKGROUND);
});

},{"783220254f29c7a8":"1m3HT"}],"dJKdX":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.StatsigMetadataProvider = exports.SDK_VERSION = void 0;
exports.SDK_VERSION = '3.30.2';
var metadata = {
    sdkVersion: exports.SDK_VERSION,
    sdkType: 'js-mono'
};
exports.StatsigMetadataProvider = {
    get: function() {
        return metadata;
    },
    add: function(additions) {
        metadata = Object.assign(Object.assign({}, metadata), additions);
    }
};

},{}],"2olc2":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"jzjah":[function(require,module,exports,__globalThis) {
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _typeOf = require("@swc/helpers/_/_type_of");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
"use strict";
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return (0, _instanceof._)(value, P) ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports._makeDataAdapterResult = exports.DataAdapterCore = void 0;
var Log_1 = require("730162e24827394");
var StableID_1 = require("302b43373d8ee203");
var StatsigUser_1 = require("e70520b380f0d673");
var StorageProvider_1 = require("a18ac851a9b8066");
var TypedJsonParse_1 = require("df40ce55c61d6bf9");
var CACHE_LIMIT = 10;
var MAX_CACHE_WRITE_ATTEMPTS = 8;
var DataAdapterCore = /*#__PURE__*/ function() {
    function DataAdapterCore(_adapterName, _cacheSuffix) {
        (0, _classCallCheck._)(this, DataAdapterCore);
        this._adapterName = _adapterName;
        this._cacheSuffix = _cacheSuffix;
        this._options = null;
        this._sdkKey = null;
        this._cacheLimit = CACHE_LIMIT;
        this._lastModifiedStoreKey = "statsig.last_modified_time.".concat(_cacheSuffix);
        this._inMemoryCache = new InMemoryCache();
    }
    (0, _createClass._)(DataAdapterCore, [
        {
            key: "attach",
            value: function attach(sdkKey, options, _network) {
                this._sdkKey = sdkKey;
                this._options = options;
            }
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                var normalized = user && (0, StatsigUser_1._normalizeUser)(user, this._options);
                var cacheKey = this._getCacheKey(normalized);
                var inMem = this._inMemoryCache.get(cacheKey, normalized);
                if (inMem && this._getIsCacheValueValid(inMem)) return inMem;
                var cache = this._loadFromCache(cacheKey);
                if (cache && this._getIsCacheValueValid(cache)) {
                    this._inMemoryCache.add(cacheKey, cache, this._cacheLimit);
                    return this._inMemoryCache.get(cacheKey, normalized);
                }
                return null;
            }
        },
        {
            key: "setData",
            value: function setData(data, user) {
                var normalized = user && (0, StatsigUser_1._normalizeUser)(user, this._options);
                var cacheKey = this._getCacheKey(normalized);
                this._inMemoryCache.add(cacheKey, _makeDataAdapterResult('Bootstrap', data, null, normalized), this._cacheLimit);
            }
        },
        {
            key: "_getIsCacheValueValid",
            value: function _getIsCacheValueValid(current) {
                return current.stableID == null || current.stableID === StableID_1.StableID.get(this._getSdkKey());
            }
        },
        {
            key: "_getDataAsyncImpl",
            value: function _getDataAsyncImpl(current, user, options) {
                return __awaiter(this, void 0, void 0, function() {
                    var cache, ops;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!StorageProvider_1.Storage.isReady()) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    StorageProvider_1.Storage.isReadyResolver()
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                cache = current !== null && current !== void 0 ? current : this.getDataSync(user);
                                ops = [
                                    this._fetchAndPrepFromNetwork(cache, user, options)
                                ];
                                if (options === null || options === void 0 ? void 0 : options.timeoutMs) ops.push(new Promise(function(r) {
                                    return setTimeout(r, options.timeoutMs);
                                }).then(function() {
                                    Log_1.Log.debug('Fetching latest value timed out');
                                    return null;
                                }));
                                return [
                                    4,
                                    Promise.race(ops)
                                ];
                            case 3:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_prefetchDataImpl",
            value: function _prefetchDataImpl(user, options) {
                return __awaiter(this, void 0, void 0, function() {
                    var normalized, cacheKey, result;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                normalized = user && (0, StatsigUser_1._normalizeUser)(user, this._options);
                                cacheKey = this._getCacheKey(normalized);
                                return [
                                    4,
                                    this._getDataAsyncImpl(null, normalized, options)
                                ];
                            case 1:
                                result = _state.sent();
                                if (result) this._inMemoryCache.add(cacheKey, Object.assign(Object.assign({}, result), {
                                    source: 'Prefetch'
                                }), this._cacheLimit);
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_fetchAndPrepFromNetwork",
            value: function _fetchAndPrepFromNetwork(cachedResult, user, options) {
                return __awaiter(this, void 0, void 0, function() {
                    var _a, cachedData, isCacheValidFor204, latest, response, sdkKey, stableID, result, cacheKey;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                cachedData = (_a = cachedResult === null || cachedResult === void 0 ? void 0 : cachedResult.data) !== null && _a !== void 0 ? _a : null;
                                isCacheValidFor204 = cachedResult != null && this._isCachedResultValidFor204(cachedResult, user);
                                return [
                                    4,
                                    this._fetchFromNetwork(cachedData, user, options, isCacheValidFor204)
                                ];
                            case 1:
                                latest = _state.sent();
                                if (!latest) {
                                    Log_1.Log.debug('No response returned for latest value');
                                    return [
                                        2,
                                        null
                                    ];
                                }
                                response = (0, TypedJsonParse_1._typedJsonParse)(latest, 'has_updates', 'Response');
                                sdkKey = this._getSdkKey();
                                stableID = StableID_1.StableID.get(sdkKey);
                                result = null;
                                if ((response === null || response === void 0 ? void 0 : response.has_updates) === true) result = _makeDataAdapterResult('Network', latest, stableID, user);
                                else if (cachedData && (response === null || response === void 0 ? void 0 : response.has_updates) === false) result = _makeDataAdapterResult('NetworkNotModified', cachedData, stableID, user);
                                else return [
                                    2,
                                    null
                                ];
                                cacheKey = this._getCacheKey(user);
                                this._inMemoryCache.add(cacheKey, result, this._cacheLimit);
                                this._writeToCache(cacheKey, result);
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_getSdkKey",
            value: function _getSdkKey() {
                if (this._sdkKey != null) return this._sdkKey;
                Log_1.Log.error("".concat(this._adapterName, " is not attached to a Client"));
                return '';
            }
        },
        {
            key: "_loadFromCache",
            value: function _loadFromCache(cacheKey) {
                var _a;
                var cache = (_a = StorageProvider_1.Storage.getItem) === null || _a === void 0 ? void 0 : _a.call(StorageProvider_1.Storage, cacheKey);
                if (cache == null) return null;
                var result = (0, TypedJsonParse_1._typedJsonParse)(cache, 'source', 'Cached Result');
                return result ? Object.assign(Object.assign({}, result), {
                    source: 'Cache'
                }) : null;
            }
        },
        {
            key: "_writeToCache",
            value: function _writeToCache(cacheKey, result) {
                var resultString = JSON.stringify(result);
                for(var i = 0; i < MAX_CACHE_WRITE_ATTEMPTS; i++)try {
                    StorageProvider_1.Storage.setItem(cacheKey, resultString);
                    break;
                } catch (error) {
                    if (!(0, _instanceof._)(error, Error) || !(error.toString().includes('QuotaExceededError') || error.toString().includes('QUOTA_EXCEEDED_ERR')) || this._cacheLimit <= 1) throw error;
                    this._cacheLimit = Math.ceil(this._cacheLimit / 2);
                    this._runLocalStorageCacheEviction(cacheKey, this._cacheLimit - 1);
                }
                this._runLocalStorageCacheEviction(cacheKey);
            }
        },
        {
            key: "_runLocalStorageCacheEviction",
            value: function _runLocalStorageCacheEviction(cacheKey) {
                var cacheLimit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this._cacheLimit;
                var _a;
                var lastModifiedTimeMap = (_a = (0, StorageProvider_1._getObjectFromStorage)(this._lastModifiedStoreKey)) !== null && _a !== void 0 ? _a : {};
                lastModifiedTimeMap[cacheKey] = Date.now();
                var evictableKeys = _getEvictableKeys(lastModifiedTimeMap, cacheLimit);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = evictableKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var evictable = _step.value;
                        delete lastModifiedTimeMap[evictable];
                        StorageProvider_1.Storage.removeItem(evictable);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                (0, StorageProvider_1._setObjectInStorage)(this._lastModifiedStoreKey, lastModifiedTimeMap);
            }
        }
    ]);
    return DataAdapterCore;
}();
exports.DataAdapterCore = DataAdapterCore;
function _makeDataAdapterResult(source, data, stableID, user) {
    return {
        source: source,
        data: data,
        receivedAt: Date.now(),
        stableID: stableID,
        fullUserHash: (0, StatsigUser_1._getFullUserHash)(user)
    };
}
exports._makeDataAdapterResult = _makeDataAdapterResult;
var InMemoryCache = /*#__PURE__*/ function() {
    function InMemoryCache() {
        (0, _classCallCheck._)(this, InMemoryCache);
        this._data = {};
    }
    (0, _createClass._)(InMemoryCache, [
        {
            key: "get",
            value: function get(cacheKey, user) {
                var _a;
                var result = this._data[cacheKey];
                var cached = result === null || result === void 0 ? void 0 : result.stableID;
                var provided = (_a = user === null || user === void 0 ? void 0 : user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
                if (provided && cached && provided !== cached) {
                    Log_1.Log.warn("'StatsigUser.customIDs.stableID' mismatch");
                    return null;
                }
                return result;
            }
        },
        {
            key: "add",
            value: function add(cacheKey, value, cacheLimit) {
                var evictableKeys = _getEvictableKeys(this._data, cacheLimit - 1);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = evictableKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var evictable = _step.value;
                        delete this._data[evictable];
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this._data[cacheKey] = value;
            }
        },
        {
            key: "merge",
            value: function merge(values) {
                this._data = Object.assign(Object.assign({}, this._data), values);
            }
        }
    ]);
    return InMemoryCache;
}();
function _getEvictableKeys(data, limit) {
    var keys = Object.keys(data);
    if (keys.length <= limit) return [];
    if (limit === 0) return keys;
    return keys.sort(function(keyA, keyB) {
        var valueA = data[keyA];
        var valueB = data[keyB];
        if ((typeof valueA === "undefined" ? "undefined" : (0, _typeOf._)(valueA)) === 'object' && (typeof valueB === "undefined" ? "undefined" : (0, _typeOf._)(valueB)) === 'object') return valueA.receivedAt - valueB.receivedAt;
        return valueA - valueB;
    }).slice(0, keys.length - limit);
}

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_type_of":"iFJdx","@swc/helpers/_/_ts_generator":"78Tqx","730162e24827394":"jH0ho","302b43373d8ee203":"iu1pY","e70520b380f0d673":"ddLSf","a18ac851a9b8066":"8hatk","df40ce55c61d6bf9":"bUb5z"}],"iu1pY":[function(require,module,exports,__globalThis) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getCookieName = exports.StableID = void 0;
var CacheKey_1 = require("e6a4bd673648ffc0");
var Log_1 = require("e29d0854f09cc751");
var SafeJs_1 = require("c8ff7073fddedb9d");
var StorageProvider_1 = require("d93e0304bcfd3a2f");
var UUID_1 = require("d16013ab8f87266b");
var PROMISE_MAP = {};
var COOKIE_ENABLED_MAP = {};
var DISABLED_MAP = {};
exports.StableID = {
    cookiesEnabled: false,
    randomID: Math.random().toString(36),
    get: function(sdkKey) {
        if (DISABLED_MAP[sdkKey]) return null;
        if (PROMISE_MAP[sdkKey] != null) return PROMISE_MAP[sdkKey];
        var stableID = null;
        stableID = _loadFromCookie(sdkKey);
        if (stableID != null) {
            PROMISE_MAP[sdkKey] = stableID;
            _persistToStorage(stableID, sdkKey);
            return stableID;
        }
        stableID = _loadFromStorage(sdkKey);
        if (stableID == null) stableID = (0, UUID_1.getUUID)();
        _persistToStorage(stableID, sdkKey);
        _persistToCookie(stableID, sdkKey);
        PROMISE_MAP[sdkKey] = stableID;
        return stableID;
    },
    setOverride: function(override, sdkKey) {
        PROMISE_MAP[sdkKey] = override;
        _persistToStorage(override, sdkKey);
        _persistToCookie(override, sdkKey);
    },
    _setCookiesEnabled: function(sdkKey, cookiesEnabled) {
        COOKIE_ENABLED_MAP[sdkKey] = cookiesEnabled;
    },
    _setDisabled: function(sdkKey, disabled) {
        DISABLED_MAP[sdkKey] = disabled;
    }
};
function _getStableIDStorageKey(sdkKey) {
    return "statsig.stable_id.".concat((0, CacheKey_1._getStorageKey)(sdkKey));
}
function _persistToStorage(stableID, sdkKey) {
    var storageKey = _getStableIDStorageKey(sdkKey);
    try {
        (0, StorageProvider_1._setObjectInStorage)(storageKey, stableID);
    } catch (e) {
        Log_1.Log.warn('Failed to save StableID to storage');
    }
}
function _loadFromStorage(sdkKey) {
    var storageKey = _getStableIDStorageKey(sdkKey);
    return (0, StorageProvider_1._getObjectFromStorage)(storageKey);
}
function _loadFromCookie(sdkKey) {
    if (!COOKIE_ENABLED_MAP[sdkKey] || (0, SafeJs_1._getDocumentSafe)() == null) return null;
    var cookies = document.cookie.split(';');
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = cookies[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var cookie = _step.value;
            var _cookie_trim_split = (0, _slicedToArray._)(cookie.trim().split('='), 2), key = _cookie_trim_split[0], value = _cookie_trim_split[1];
            if (key === getCookieName(sdkKey)) return decodeURIComponent(value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
}
function _persistToCookie(stableID, sdkKey) {
    if (!COOKIE_ENABLED_MAP[sdkKey] || (0, SafeJs_1._getDocumentSafe)() == null) return;
    var expiryDate = new Date();
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);
    document.cookie = "".concat(getCookieName(sdkKey), "=").concat(encodeURIComponent(stableID), "; expires=").concat(expiryDate.toUTCString(), "; path=/");
}
function getCookieName(sdkKey) {
    return "statsig.stable_id.".concat((0, CacheKey_1._getStorageKey)(sdkKey));
}
exports.getCookieName = getCookieName;

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","e6a4bd673648ffc0":"eqWfV","e29d0854f09cc751":"jH0ho","c8ff7073fddedb9d":"1m3HT","d93e0304bcfd3a2f":"8hatk","d16013ab8f87266b":"h64IW"}],"h64IW":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getUUID = void 0;
function getUUID() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    var d = new Date().getTime();
    var d2 = typeof performance !== 'undefined' && performance.now && performance.now() * 1000 || 0;
    var y = '89ab'[Math.floor(Math.random() * 4)];
    return "xxxxxxxx-xxxx-4xxx-".concat(y, "xxx-xxxxxxxxxxxx").replace(/[xy]/g, function(c) {
        var r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : r & 0x7 | 0x8).toString(16);
    });
}
exports.getUUID = getUUID;

},{}],"ddLSf":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports._getFullUserHash = exports._normalizeUser = void 0;
var Hashing_1 = require("bf764c282e755948");
var Log_1 = require("2513dc9d625e781f");
function _normalizeUser(original, options, fallbackEnvironment) {
    try {
        var copy = JSON.parse(JSON.stringify(original));
        if (options != null && options.environment != null) copy.statsigEnvironment = options.environment;
        else if (fallbackEnvironment != null) copy.statsigEnvironment = {
            tier: fallbackEnvironment
        };
        return copy;
    } catch (error) {
        Log_1.Log.error('Failed to JSON.stringify user');
        return {
            statsigEnvironment: undefined
        };
    }
}
exports._normalizeUser = _normalizeUser;
function _getFullUserHash(user) {
    return user ? (0, Hashing_1._DJB2Object)(user) : null;
}
exports._getFullUserHash = _getFullUserHash;

},{"bf764c282e755948":"6nhM9","2513dc9d625e781f":"jH0ho"}],"bUb5z":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports._typedJsonParse = void 0;
var Log_1 = require("f6ef0b21eef38827");
/**
 *
 * @param {string} data The values to parse into T
 * @param {string} guard A field that must exists on the parsed object for the parse to be valid
 * @param {string} error An error to print via Log.error() when parsing fails
 * @returns {T | null} The parse object T or null if it failed
 */ function _typedJsonParse(data, guard, typeName) {
    try {
        var result = JSON.parse(data);
        if (result && (typeof result === "undefined" ? "undefined" : (0, _typeOf._)(result)) === 'object' && guard in result) return result;
    } catch (_a) {
    // noop
    }
    Log_1.Log.error("Failed to parse ".concat(typeName));
    return null;
}
exports._typedJsonParse = _typedJsonParse;

},{"@swc/helpers/_/_type_of":"iFJdx","f6ef0b21eef38827":"jH0ho"}],"4fkIQ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"jvCQP":[function(require,module,exports,__globalThis) {
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _typeOf = require("@swc/helpers/_/_type_of");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
"use strict";
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return (0, _instanceof._)(value, P) ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ErrorBoundary = exports.EXCEPTION_ENDPOINT = void 0;
var Log_1 = require("85a7c2baf5aa8c84");
var SDKType_1 = require("d891669493246ec3");
var StatsigMetadata_1 = require("818305d558e94bc7");
exports.EXCEPTION_ENDPOINT = 'https://statsigapi.net/v1/sdk_exception';
var UNKNOWN_ERROR = '[Statsig] UnknownError';
var ErrorBoundary = /*#__PURE__*/ function() {
    function ErrorBoundary(_sdkKey, _options, _emitter, _lastSeenError) {
        (0, _classCallCheck._)(this, ErrorBoundary);
        this._sdkKey = _sdkKey;
        this._options = _options;
        this._emitter = _emitter;
        this._lastSeenError = _lastSeenError;
        this._seen = new Set();
    }
    (0, _createClass._)(ErrorBoundary, [
        {
            key: "wrap",
            value: function wrap(instance, namePrefix) {
                var _this = this;
                try {
                    var obj = instance;
                    _getAllInstanceMethodNames(obj).forEach(function(name) {
                        var _this1 = _this;
                        var original = obj[name];
                        if ('$EB' in original) return;
                        obj[name] = function() {
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                args[_key] = arguments[_key];
                            }
                            return _this1._capture(namePrefix ? "".concat(namePrefix, ":").concat(name) : name, function() {
                                return original.apply(instance, args);
                            });
                        };
                        obj[name].$EB = true;
                    });
                } catch (err) {
                    this._onError('eb:wrap', err);
                }
            }
        },
        {
            key: "logError",
            value: function logError(tag, error) {
                this._onError(tag, error);
            }
        },
        {
            key: "getLastSeenErrorAndReset",
            value: function getLastSeenErrorAndReset() {
                var tempError = this._lastSeenError;
                this._lastSeenError = undefined;
                return tempError !== null && tempError !== void 0 ? tempError : null;
            }
        },
        {
            key: "attachErrorIfNoneExists",
            value: function attachErrorIfNoneExists(error) {
                if (this._lastSeenError) return;
                this._lastSeenError = _resolveError(error);
            }
        },
        {
            key: "_capture",
            value: function _capture(tag, task) {
                var _this = this;
                try {
                    var res = task();
                    if (res && (0, _instanceof._)(res, Promise)) return res.catch(function(err) {
                        return _this._onError(tag, err);
                    });
                    return res;
                } catch (error) {
                    this._onError(tag, error);
                    return null;
                }
            }
        },
        {
            key: "_onError",
            value: function _onError(tag, error) {
                var _this = this;
                try {
                    Log_1.Log.warn("Caught error in ".concat(tag), {
                        error: error
                    });
                    var impl = function() {
                        return __awaiter(_this, void 0, void 0, function() {
                            var _a, _b, _c, _d, _e, _f, _g, unwrapped, isError, name, resolvedError, sdkType, statsigMetadata, info, body, func;
                            return (0, _tsGenerator._)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        unwrapped = error ? error : Error(UNKNOWN_ERROR);
                                        isError = (0, _instanceof._)(unwrapped, Error);
                                        name = isError ? unwrapped.name : 'No Name';
                                        resolvedError = _resolveError(unwrapped);
                                        this._lastSeenError = resolvedError;
                                        if (this._seen.has(name)) return [
                                            2
                                        ];
                                        this._seen.add(name);
                                        if ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.preventAllNetworkTraffic) {
                                            (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                                                name: 'error',
                                                error: error,
                                                tag: tag
                                            });
                                            return [
                                                2
                                            ];
                                        }
                                        sdkType = SDKType_1.SDKType._get(this._sdkKey);
                                        statsigMetadata = StatsigMetadata_1.StatsigMetadataProvider.get();
                                        info = isError ? unwrapped.stack : _getDescription(unwrapped);
                                        body = Object.assign({
                                            tag: tag,
                                            exception: name,
                                            info: info,
                                            statsigOptions: _getStatsigOptionLoggingCopy(this._options)
                                        }, Object.assign(Object.assign({}, statsigMetadata), {
                                            sdkType: sdkType
                                        }));
                                        func = (_f = (_e = (_d = this._options) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.networkOverrideFunc) !== null && _f !== void 0 ? _f : fetch;
                                        return [
                                            4,
                                            func(exports.EXCEPTION_ENDPOINT, {
                                                method: 'POST',
                                                headers: {
                                                    'STATSIG-API-KEY': this._sdkKey,
                                                    'STATSIG-SDK-TYPE': String(sdkType),
                                                    'STATSIG-SDK-VERSION': String(statsigMetadata.sdkVersion),
                                                    'Content-Type': 'application/json'
                                                },
                                                body: JSON.stringify(body)
                                            })
                                        ];
                                    case 1:
                                        _state.sent();
                                        (_g = this._emitter) === null || _g === void 0 || _g.call(this, {
                                            name: 'error',
                                            error: error,
                                            tag: tag
                                        });
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    };
                    impl().then(function() {
                    /* noop */ }).catch(function() {
                    /* noop */ });
                } catch (_error) {
                /* noop */ }
            }
        }
    ]);
    return ErrorBoundary;
}();
exports.ErrorBoundary = ErrorBoundary;
function _resolveError(error) {
    if ((0, _instanceof._)(error, Error)) return error;
    else if (typeof error === 'string') return new Error(error);
    else return new Error('An unknown error occurred.');
}
function _getDescription(obj) {
    try {
        return JSON.stringify(obj);
    } catch (_a) {
        return UNKNOWN_ERROR;
    }
}
function _getAllInstanceMethodNames(instance) {
    var names = new Set();
    var proto = Object.getPrototypeOf(instance);
    while(proto && proto !== Object.prototype){
        Object.getOwnPropertyNames(proto).filter(function(prop) {
            return typeof (proto === null || proto === void 0 ? void 0 : proto[prop]) === 'function';
        }).forEach(function(name) {
            return names.add(name);
        });
        proto = Object.getPrototypeOf(proto);
    }
    return Array.from(names);
}
function _getStatsigOptionLoggingCopy(options) {
    if (!options) return {};
    var loggingCopy = {};
    Object.keys(options).forEach(function(key) {
        var option = key;
        var value = options[option];
        var valueType = typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value);
        switch(valueType){
            case 'number':
            case 'bigint':
            case 'boolean':
                loggingCopy[String(option)] = value;
                break;
            case 'string':
                if (value.length < 50) loggingCopy[String(option)] = value;
                else loggingCopy[String(option)] = 'set';
                break;
            case 'object':
                if (option === 'environment') loggingCopy['environment'] = value;
                else if (option === 'networkConfig') loggingCopy['networkConfig'] = value;
                else loggingCopy[String(option)] = value != null ? 'set' : 'unset';
                break;
            default:
        }
    });
    return loggingCopy;
}

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_type_of":"iFJdx","@swc/helpers/_/_ts_generator":"78Tqx","85a7c2baf5aa8c84":"jH0ho","d891669493246ec3":"3UrIZ","818305d558e94bc7":"dJKdX"}],"3UrIZ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SDKType = void 0;
var SDK_CLIENT = {};
var suffix;
exports.SDKType = {
    _get: function(sdkKey) {
        var _a;
        return ((_a = SDK_CLIENT[sdkKey]) !== null && _a !== void 0 ? _a : 'js-mono') + (suffix !== null && suffix !== void 0 ? suffix : '');
    },
    _setClientType: function _setClientType(sdkKey, client) {
        SDK_CLIENT[sdkKey] = client;
    },
    _setBindingType: function _setBindingType(binding) {
        if (!suffix || suffix === '-react') suffix = '-' + binding;
    }
};

},{}],"hvbPE":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"4IBGu":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"cLvkE":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"4FvMU":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createMemoKey = exports.MemoPrefix = void 0;
exports.MemoPrefix = {
    _gate: 'g',
    _dynamicConfig: 'c',
    _experiment: 'e',
    _configList: 'cl',
    _layer: 'l',
    _paramStore: 'p'
};
var EXIST_KEYS = new Set([]);
var DO_NOT_MEMO_KEYS = new Set([
    // Add keys that if exist, should not be memoized
    'userPersistedValues'
]);
function createMemoKey(prefix, name, options) {
    var cacheKey = "".concat(prefix, "|").concat(name);
    if (!options) return cacheKey;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.keys(options)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (DO_NOT_MEMO_KEYS.has(key)) return undefined;
            if (EXIST_KEYS.has(key)) cacheKey += "|".concat(key, "=true");
            else cacheKey += "|".concat(key, "=").concat(options[key]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return cacheKey;
}
exports.createMemoKey = createMemoKey;

},{}],"1eoAx":[function(require,module,exports,__globalThis) {
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
"use strict";
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return (0, _instanceof._)(value, P) ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NetworkCore = void 0;
require("b7b53b3bb6ffe2e6");
var __StatsigGlobal_1 = require("b7b53b3bb6ffe2e6");
var Diagnostics_1 = require("29a23a4c1e1673f4");
var Log_1 = require("ecb6e18a107a073");
var NetworkConfig_1 = require("2651e07d3cc7fed6");
var NetworkFallbackResolver_1 = require("9369166c37b5d3f4");
var SDKFlags_1 = require("2fd9c0b9892d34e2");
var SDKType_1 = require("1f969a4f163e3dd3");
var SafeJs_1 = require("fcb203a50f0333b2");
var SessionID_1 = require("fc5634ee1e4f49c1");
var StableID_1 = require("7ae5e5ef538bd4da");
var StatsigClientEventEmitter_1 = require("486d61be2d247fa8");
var StatsigMetadata_1 = require("4fe8834821311ab");
var StatsigOptionsCommon_1 = require("b3df4191bd9aa1ed");
var VisibilityObserving_1 = require("573df593302ec4db");
var DEFAULT_TIMEOUT_MS = 10000;
var BACKOFF_BASE_MS = 500;
var BACKOFF_MAX_MS = 30000;
var RATE_LIMIT_WINDOW_MS = 1000;
var RATE_LIMIT_MAX_REQ_COUNT = 50;
var LEAK_RATE = RATE_LIMIT_MAX_REQ_COUNT / RATE_LIMIT_WINDOW_MS;
var RETRYABLE_CODES = new Set([
    408,
    500,
    502,
    503,
    504,
    522,
    524,
    599
]);
var NetworkCore = /*#__PURE__*/ function() {
    function NetworkCore(options, _emitter) {
        (0, _classCallCheck._)(this, NetworkCore);
        this._emitter = _emitter;
        this._errorBoundary = null;
        this._timeout = DEFAULT_TIMEOUT_MS;
        this._netConfig = {};
        this._options = {};
        this._leakyBucket = {};
        this._lastUsedInitUrl = null;
        if (options) this._options = options;
        if (this._options.networkConfig) this._netConfig = this._options.networkConfig;
        if (this._netConfig.networkTimeoutMs) this._timeout = this._netConfig.networkTimeoutMs;
        this._fallbackResolver = new NetworkFallbackResolver_1.NetworkFallbackResolver(this._options);
        this.setLogEventCompressionMode(this._getLogEventCompressionMode(options));
    }
    (0, _createClass._)(NetworkCore, [
        {
            key: "setLogEventCompressionMode",
            value: function setLogEventCompressionMode(mode) {
                this._options.logEventCompressionMode = mode;
            }
        },
        {
            key: "setErrorBoundary",
            value: function setErrorBoundary(errorBoundary) {
                this._errorBoundary = errorBoundary;
                this._errorBoundary.wrap(this);
                this._errorBoundary.wrap(this._fallbackResolver);
                this._fallbackResolver.setErrorBoundary(errorBoundary);
            }
        },
        {
            key: "isBeaconSupported",
            value: function isBeaconSupported() {
                return typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function';
            }
        },
        {
            key: "getLastUsedInitUrlAndReset",
            value: function getLastUsedInitUrlAndReset() {
                var tempUrl = this._lastUsedInitUrl;
                this._lastUsedInitUrl = null;
                return tempUrl;
            }
        },
        {
            key: "beacon",
            value: function beacon(args) {
                if (!_ensureValidSdkKey(args)) return false;
                var argsInternal = this._getInternalRequestArgs('POST', args);
                var url = this._getPopulatedURL(argsInternal);
                var nav = navigator;
                return nav.sendBeacon.bind(nav)(url, argsInternal.body);
            }
        },
        {
            key: "post",
            value: function post(args) {
                return __awaiter(this, void 0, void 0, function() {
                    var argsInternal;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                argsInternal = this._getInternalRequestArgs('POST', args);
                                this._tryEncodeBody(argsInternal);
                                return [
                                    4,
                                    this._tryToCompressBody(argsInternal)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    this._sendRequest(argsInternal)
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "get",
            value: function get(args) {
                var argsInternal = this._getInternalRequestArgs('GET', args);
                return this._sendRequest(argsInternal);
            }
        },
        {
            key: "_sendRequest",
            value: function _sendRequest(args) {
                return __awaiter(this, void 0, void 0, function() {
                    var _this, _a, _b, _c, _d, method, body, retries, attempt, endpoint, currentAttempt, reqTimedOut, populatedUrl, response, keepalive, config, bucket, func, timeoutId, text, err, text1, error, errorMessage, timedOut, fallbackUpdated, formattedErrorMsg;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                if (!_ensureValidSdkKey(args)) return [
                                    2,
                                    null
                                ];
                                if (this._netConfig.preventAllNetworkTraffic) return [
                                    2,
                                    null
                                ];
                                method = args.method, body = args.body, retries = args.retries, attempt = args.attempt;
                                endpoint = args.urlConfig.endpoint;
                                if (this._isRateLimited(endpoint)) {
                                    Log_1.Log.warn("Request to ".concat(endpoint, " was blocked because you are making requests too frequently."));
                                    return [
                                        2,
                                        null
                                    ];
                                }
                                currentAttempt = attempt !== null && attempt !== void 0 ? attempt : 1;
                                reqTimedOut = false;
                                populatedUrl = this._getPopulatedURL(args);
                                response = null;
                                keepalive = (0, VisibilityObserving_1._isUnloading)();
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    ,
                                    9
                                ]);
                                config = {
                                    method: method,
                                    body: body,
                                    headers: Object.assign({}, args.headers),
                                    priority: args.priority,
                                    keepalive: keepalive
                                };
                                _tryMarkInitStart(args, currentAttempt);
                                bucket = this._leakyBucket[endpoint];
                                if (bucket) {
                                    bucket.lastRequestTime = Date.now();
                                    this._leakyBucket[endpoint] = bucket;
                                }
                                func = (_a = this._netConfig.networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch;
                                return [
                                    4,
                                    Promise.race([
                                        func(populatedUrl, config).finally(function() {
                                            return clearTimeout(timeoutId);
                                        }),
                                        new Promise(function(_, reject) {
                                            timeoutId = setTimeout(function() {
                                                reqTimedOut = true;
                                                reject(new Error("Timeout of ".concat(_this._timeout, "ms expired.")));
                                            }, _this._timeout);
                                        })
                                    ])
                                ];
                            case 2:
                                response = _state.sent();
                                if (!!response.ok) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    response.text().catch(function() {
                                        return 'No Text';
                                    })
                                ];
                            case 3:
                                text = _state.sent();
                                err = new Error("NetworkError: ".concat(populatedUrl, " ").concat(text));
                                err.name = 'NetworkError';
                                throw err;
                            case 4:
                                return [
                                    4,
                                    response.text()
                                ];
                            case 5:
                                text1 = _state.sent();
                                _tryMarkInitEnd(args, response, currentAttempt, text1);
                                this._fallbackResolver.tryBumpExpiryTime(args.sdkKey, args.urlConfig);
                                return [
                                    2,
                                    {
                                        body: text1,
                                        code: response.status
                                    }
                                ];
                            case 6:
                                error = _state.sent();
                                errorMessage = _getErrorMessage(error);
                                timedOut = _didTimeout(errorMessage !== null && errorMessage !== void 0 ? errorMessage : '', reqTimedOut);
                                _tryMarkInitEnd(args, response, currentAttempt, '', error);
                                return [
                                    4,
                                    this._fallbackResolver.tryFetchUpdatedFallbackInfo(args.sdkKey, args.urlConfig, errorMessage, timedOut)
                                ];
                            case 7:
                                fallbackUpdated = _state.sent();
                                if (fallbackUpdated) args.fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
                                if (!retries || currentAttempt > retries || !RETRYABLE_CODES.has((_b = response === null || response === void 0 ? void 0 : response.status) !== null && _b !== void 0 ? _b : 500)) {
                                    (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                                        name: 'error',
                                        error: error,
                                        tag: StatsigClientEventEmitter_1.ErrorTag.NetworkError,
                                        requestArgs: args
                                    });
                                    formattedErrorMsg = "A networking error occurred during ".concat(method, " request to ").concat(populatedUrl, ".");
                                    Log_1.Log.error(formattedErrorMsg, errorMessage, error);
                                    (_d = this._errorBoundary) === null || _d === void 0 || _d.attachErrorIfNoneExists(formattedErrorMsg);
                                    return [
                                        2,
                                        null
                                    ];
                                }
                                return [
                                    4,
                                    _exponentialBackoff(currentAttempt)
                                ];
                            case 8:
                                _state.sent();
                                return [
                                    2,
                                    this._sendRequest(Object.assign(Object.assign({}, args), {
                                        retries: retries,
                                        attempt: currentAttempt + 1
                                    }))
                                ];
                            case 9:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_getLogEventCompressionMode",
            value: function _getLogEventCompressionMode(options) {
                // Handle backward compatibility for deprecated disableCompression flag
                var compressionMode = options === null || options === void 0 ? void 0 : options.logEventCompressionMode;
                if (!compressionMode && (options === null || options === void 0 ? void 0 : options.disableCompression) === true) compressionMode = StatsigOptionsCommon_1.LogEventCompressionMode.Disabled;
                // Default to enabled if unset
                if (!compressionMode) compressionMode = StatsigOptionsCommon_1.LogEventCompressionMode.Enabled;
                return compressionMode;
            }
        },
        {
            key: "_isRateLimited",
            value: function _isRateLimited(endpoint) {
                var _a;
                var now = Date.now();
                var bucket = (_a = this._leakyBucket[endpoint]) !== null && _a !== void 0 ? _a : {
                    count: 0,
                    lastRequestTime: now
                };
                var elapsed = now - bucket.lastRequestTime;
                var leakedRequests = Math.floor(elapsed * LEAK_RATE);
                bucket.count = Math.max(0, bucket.count - leakedRequests);
                if (bucket.count >= RATE_LIMIT_MAX_REQ_COUNT) return true;
                bucket.count += 1;
                bucket.lastRequestTime = now;
                this._leakyBucket[endpoint] = bucket;
                return false;
            }
        },
        {
            key: "_getPopulatedURL",
            value: function _getPopulatedURL(args) {
                var _a;
                var url = (_a = args.fallbackUrl) !== null && _a !== void 0 ? _a : args.urlConfig.getUrl();
                if (args.urlConfig.endpoint === NetworkConfig_1.Endpoint._initialize || args.urlConfig.endpoint === NetworkConfig_1.Endpoint._download_config_specs) this._lastUsedInitUrl = url;
                var _obj;
                var params = Object.assign((_obj = {}, (0, _defineProperty._)(_obj, NetworkConfig_1.NetworkParam.SdkKey, args.sdkKey), (0, _defineProperty._)(_obj, NetworkConfig_1.NetworkParam.SdkType, SDKType_1.SDKType._get(args.sdkKey)), (0, _defineProperty._)(_obj, NetworkConfig_1.NetworkParam.SdkVersion, StatsigMetadata_1.SDK_VERSION), (0, _defineProperty._)(_obj, NetworkConfig_1.NetworkParam.Time, String(Date.now())), (0, _defineProperty._)(_obj, NetworkConfig_1.NetworkParam.SessionID, SessionID_1.SessionID.get(args.sdkKey)), _obj), args.params);
                var query = Object.keys(params).map(function(key) {
                    return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(params[key]));
                }).join('&');
                return "".concat(url).concat(query ? "?".concat(query) : '');
            }
        },
        {
            key: "_tryEncodeBody",
            value: function _tryEncodeBody(args) {
                var _a;
                var win = (0, SafeJs_1._getWindowSafe)();
                var body = args.body;
                if (!args.isStatsigEncodable || this._options.disableStatsigEncoding || typeof body !== 'string' || (0, __StatsigGlobal_1._getStatsigGlobalFlag)('no-encode') != null || !(win === null || win === void 0 ? void 0 : win.btoa)) return;
                try {
                    args.body = win.btoa(body).split('').reverse().join('');
                    args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), (0, _defineProperty._)({}, NetworkConfig_1.NetworkParam.StatsigEncoded, '1'));
                } catch (e) {
                    Log_1.Log.warn("Request encoding failed for ".concat(args.urlConfig.getUrl()), e);
                }
            }
        },
        {
            key: "_tryToCompressBody",
            value: function _tryToCompressBody(args) {
                return __awaiter(this, void 0, void 0, function() {
                    var _a, body, bytes, stream, writer, reader, chunks, result, totalLength, combined, offset, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, chunk, e;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                body = args.body;
                                if (typeof body !== 'string' || !_allowCompression(args, this._options)) return [
                                    2
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    5,
                                    ,
                                    6
                                ]);
                                bytes = new TextEncoder().encode(body);
                                stream = new CompressionStream('gzip');
                                writer = stream.writable.getWriter();
                                writer.write(bytes).catch(Log_1.Log.error);
                                writer.close().catch(Log_1.Log.error);
                                reader = stream.readable.getReader();
                                chunks = [];
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    reader.read()
                                ];
                            case 3:
                                if (!!(result = _state.sent()).done) return [
                                    3,
                                    4
                                ];
                                chunks.push(result.value);
                                return [
                                    3,
                                    2
                                ];
                            case 4:
                                totalLength = chunks.reduce(function(acc, chunk) {
                                    return acc + chunk.length;
                                }, 0);
                                combined = new Uint8Array(totalLength);
                                offset = 0;
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(_iterator = chunks[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        chunk = _step.value;
                                        combined.set(chunk, offset);
                                        offset += chunk.length;
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                args.body = combined;
                                args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), (0, _defineProperty._)({}, NetworkConfig_1.NetworkParam.IsGzipped, '1'));
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                e = _state.sent();
                                Log_1.Log.warn("Request compression failed for ".concat(args.urlConfig.getUrl()), e);
                                return [
                                    3,
                                    6
                                ];
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_getInternalRequestArgs",
            value: function _getInternalRequestArgs(method, args) {
                var fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
                var result = Object.assign(Object.assign({}, args), {
                    method: method,
                    fallbackUrl: fallbackUrl
                });
                if ('data' in args) _populateRequestBody(result, args.data);
                return result;
            }
        }
    ]);
    return NetworkCore;
}();
exports.NetworkCore = NetworkCore;
var _ensureValidSdkKey = function(args) {
    if (!args.sdkKey) {
        Log_1.Log.warn('Unable to make request without an SDK key');
        return false;
    }
    return true;
};
var _populateRequestBody = function(args, data) {
    var sdkKey = args.sdkKey, fallbackUrl = args.fallbackUrl;
    var stableID = StableID_1.StableID.get(sdkKey);
    var sessionID = SessionID_1.SessionID.get(sdkKey);
    var sdkType = SDKType_1.SDKType._get(sdkKey);
    args.body = JSON.stringify(Object.assign(Object.assign({}, data), {
        statsigMetadata: Object.assign(Object.assign({}, StatsigMetadata_1.StatsigMetadataProvider.get()), {
            stableID: stableID,
            sessionID: sessionID,
            sdkType: sdkType,
            fallbackUrl: fallbackUrl
        })
    }));
};
function _allowCompression(args, options) {
    if (!args.isCompressable) return false;
    // Never compress if 'no-compress' is set globally or required APIs are unavailable
    if ((0, __StatsigGlobal_1._getStatsigGlobalFlag)('no-compress') != null || typeof CompressionStream === 'undefined' || typeof TextEncoder === 'undefined') return false;
    var isProxy = args.urlConfig.customUrl != null || args.urlConfig.fallbackUrls != null;
    var flagEnabled = SDKFlags_1.SDKFlags.get(args.sdkKey, 'enable_log_event_compression') === true;
    switch(options.logEventCompressionMode){
        case StatsigOptionsCommon_1.LogEventCompressionMode.Disabled:
            return false;
        case StatsigOptionsCommon_1.LogEventCompressionMode.Enabled:
            // Only compress through proxy if flag is explicitly on
            if (isProxy && !flagEnabled) return false;
            return true;
        case StatsigOptionsCommon_1.LogEventCompressionMode.Forced:
            return true;
        default:
            return false;
    }
}
function _getErrorMessage(error) {
    if (typeof error === 'string') return error;
    if ((0, _instanceof._)(error, Error)) return "".concat(error.name, ": ").concat(error.message);
    return 'Unknown Error';
}
function _didTimeout(errorMsg, abortedByTimeout) {
    var timeout = errorMsg.includes('Timeout'); // probably not needed but just in case
    return timeout || abortedByTimeout;
}
function _tryMarkInitStart(args, attempt) {
    if (args.urlConfig.endpoint !== NetworkConfig_1.Endpoint._initialize) return;
    Diagnostics_1.Diagnostics._markInitNetworkReqStart(args.sdkKey, {
        attempt: attempt
    });
}
function _tryMarkInitEnd(args, response, attempt, body, err) {
    if (args.urlConfig.endpoint !== NetworkConfig_1.Endpoint._initialize) return;
    Diagnostics_1.Diagnostics._markInitNetworkReqEnd(args.sdkKey, Diagnostics_1.Diagnostics._getDiagnosticsData(response, attempt, body, err));
}
function _exponentialBackoff(attempt) {
    return __awaiter(this, void 0, void 0, function() {
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    // 1*1*1000 1s
                    // 2*2*1000 4s
                    // 3*3*1000 9s
                    // 4*4*1000 16s
                    // 5*5*1000 25s
                    return [
                        4,
                        new Promise(function(r) {
                            return setTimeout(r, Math.min(BACKOFF_BASE_MS * (attempt * attempt), BACKOFF_MAX_MS));
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
}

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_ts_generator":"78Tqx","b7b53b3bb6ffe2e6":"d5W7z","29a23a4c1e1673f4":"5Y3Ef","ecb6e18a107a073":"jH0ho","2651e07d3cc7fed6":"evNAP","9369166c37b5d3f4":"iQXnn","2fd9c0b9892d34e2":"8kCTX","1f969a4f163e3dd3":"3UrIZ","fcb203a50f0333b2":"1m3HT","fc5634ee1e4f49c1":"5Fh6O","7ae5e5ef538bd4da":"iu1pY","486d61be2d247fa8":"50bPm","4fe8834821311ab":"dJKdX","b3df4191bd9aa1ed":"98Sh7","573df593302ec4db":"dBhOj"}],"iQXnn":[function(require,module,exports,__globalThis) {
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
"use strict";
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return (0, _instanceof._)(value, P) ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports._isDomainFailure = exports.NetworkFallbackResolver = void 0;
var DnsTxtQuery_1 = require("85035aee34a8486");
var Hashing_1 = require("6fd2975ce34dbb7a");
var Log_1 = require("4e1f612a80982c30");
var StorageProvider_1 = require("c1b875ef6477bd9d");
var DEFAULT_TTL_MS = 604800000; // 7 days
var COOLDOWN_TIME_MS = 14400000; // 4 hours
var NetworkFallbackResolver = /*#__PURE__*/ function() {
    function NetworkFallbackResolver(options) {
        (0, _classCallCheck._)(this, NetworkFallbackResolver);
        var _a;
        this._fallbackInfo = null;
        this._errorBoundary = null;
        this._dnsQueryCooldowns = {};
        this._networkOverrideFunc = (_a = options.networkConfig) === null || _a === void 0 ? void 0 : _a.networkOverrideFunc;
    }
    (0, _createClass._)(NetworkFallbackResolver, [
        {
            key: "setErrorBoundary",
            value: function setErrorBoundary(errorBoundary) {
                this._errorBoundary = errorBoundary;
            }
        },
        {
            key: "tryBumpExpiryTime",
            value: function tryBumpExpiryTime(sdkKey, urlConfig) {
                var _a;
                var info = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint];
                if (!info) return;
                info.expiryTime = Date.now() + DEFAULT_TTL_MS;
                _tryWriteFallbackInfoToCache(sdkKey, Object.assign(Object.assign({}, this._fallbackInfo), (0, _defineProperty._)({}, urlConfig.endpoint, info)));
            }
        },
        {
            key: "getActiveFallbackUrl",
            value: function getActiveFallbackUrl(sdkKey, urlConfig) {
                var _a, _b;
                if (urlConfig.customUrl != null && urlConfig.fallbackUrls != null) return null;
                var info = this._fallbackInfo;
                if (info == null) {
                    info = (_a = _readFallbackInfoFromCache(sdkKey)) !== null && _a !== void 0 ? _a : {};
                    this._fallbackInfo = info;
                }
                var entry = info[urlConfig.endpoint];
                if (!entry || Date.now() > ((_b = entry.expiryTime) !== null && _b !== void 0 ? _b : 0) || urlConfig.getChecksum() !== entry.urlConfigChecksum) {
                    delete info[urlConfig.endpoint];
                    this._fallbackInfo = info;
                    _tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
                    return null;
                }
                if (entry.url) return entry.url;
                return null;
            }
        },
        {
            key: "tryFetchUpdatedFallbackInfo",
            value: function tryFetchUpdatedFallbackInfo(sdkKey, urlConfig, errorMessage, timedOut) {
                return __awaiter(this, void 0, void 0, function() {
                    var _a, _b, canUseNetworkFallbacks, urls, _tmp, newUrl, error;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    4,
                                    ,
                                    5
                                ]);
                                if (!_isDomainFailure(errorMessage, timedOut)) return [
                                    2,
                                    false
                                ];
                                canUseNetworkFallbacks = urlConfig.customUrl == null && urlConfig.fallbackUrls == null;
                                if (!canUseNetworkFallbacks) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    this._tryFetchFallbackUrlsFromNetwork(urlConfig)
                                ];
                            case 1:
                                _tmp = _state.sent();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                _tmp = urlConfig.fallbackUrls;
                                _state.label = 3;
                            case 3:
                                urls = _tmp;
                                newUrl = this._pickNewFallbackUrl((_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint], urls);
                                if (!newUrl) return [
                                    2,
                                    false
                                ];
                                this._updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl);
                                return [
                                    2,
                                    true
                                ];
                            case 4:
                                error = _state.sent();
                                (_b = this._errorBoundary) === null || _b === void 0 || _b.logError('tryFetchUpdatedFallbackInfo', error);
                                return [
                                    2,
                                    false
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_updateFallbackInfoWithNewUrl",
            value: function _updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl) {
                var _newFallbackInfo_previous;
                var _a, _b, _c;
                var newFallbackInfo = {
                    urlConfigChecksum: urlConfig.getChecksum(),
                    url: newUrl,
                    expiryTime: Date.now() + DEFAULT_TTL_MS,
                    previous: []
                };
                var endpoint = urlConfig.endpoint;
                var previousInfo = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[endpoint];
                if (previousInfo) (_newFallbackInfo_previous = newFallbackInfo.previous).push.apply(_newFallbackInfo_previous, (0, _toConsumableArray._)(previousInfo.previous));
                if (newFallbackInfo.previous.length > 10) newFallbackInfo.previous = [];
                var previousUrl = (_c = (_b = this._fallbackInfo) === null || _b === void 0 ? void 0 : _b[endpoint]) === null || _c === void 0 ? void 0 : _c.url;
                if (previousUrl != null) newFallbackInfo.previous.push(previousUrl);
                this._fallbackInfo = Object.assign(Object.assign({}, this._fallbackInfo), (0, _defineProperty._)({}, endpoint, newFallbackInfo));
                _tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
            }
        },
        {
            key: "_tryFetchFallbackUrlsFromNetwork",
            value: function _tryFetchFallbackUrlsFromNetwork(urlConfig) {
                return __awaiter(this, void 0, void 0, function() {
                    var _a, cooldown, result, records, path, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, record, parts, baseUrl;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                cooldown = this._dnsQueryCooldowns[urlConfig.endpoint];
                                if (cooldown && Date.now() < cooldown) return [
                                    2,
                                    null
                                ];
                                this._dnsQueryCooldowns[urlConfig.endpoint] = Date.now() + COOLDOWN_TIME_MS;
                                result = [];
                                return [
                                    4,
                                    (0, DnsTxtQuery_1._fetchTxtRecords)((_a = this._networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch)
                                ];
                            case 1:
                                records = _state.sent();
                                path = _extractPathFromUrl(urlConfig.defaultUrl);
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(_iterator = records[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        record = _step.value;
                                        if (!record.startsWith(urlConfig.endpointDnsKey + '=')) continue;
                                        parts = record.split('=');
                                        if (parts.length > 1) {
                                            baseUrl = parts[1];
                                            if (baseUrl.endsWith('/')) baseUrl = baseUrl.slice(0, -1);
                                            result.push("https://".concat(baseUrl).concat(path));
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_pickNewFallbackUrl",
            value: function _pickNewFallbackUrl(currentFallbackInfo, urls) {
                var _a;
                if (urls == null) return null;
                var previouslyUsed = new Set((_a = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.previous) !== null && _a !== void 0 ? _a : []);
                var currentFallbackUrl = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.url;
                var found = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = urls[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var loopUrl = _step.value;
                        var url = loopUrl.endsWith('/') ? loopUrl.slice(0, -1) : loopUrl;
                        if (!previouslyUsed.has(loopUrl) && url !== currentFallbackUrl) {
                            found = url;
                            break;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return found;
            }
        }
    ]);
    return NetworkFallbackResolver;
}();
exports.NetworkFallbackResolver = NetworkFallbackResolver;
function _isDomainFailure(errorMsg, timedOut) {
    var _a;
    var lowerErrorMsg = (_a = errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.toLowerCase()) !== null && _a !== void 0 ? _a : '';
    return timedOut || lowerErrorMsg.includes('uncaught exception') || lowerErrorMsg.includes('failed to fetch') || lowerErrorMsg.includes('networkerror when attempting to fetch resource');
}
exports._isDomainFailure = _isDomainFailure;
function _getFallbackInfoStorageKey(sdkKey) {
    return "statsig.network_fallback.".concat((0, Hashing_1._DJB2)(sdkKey));
}
function _tryWriteFallbackInfoToCache(sdkKey, info) {
    var hashKey = _getFallbackInfoStorageKey(sdkKey);
    if (!info || Object.keys(info).length === 0) {
        StorageProvider_1.Storage.removeItem(hashKey);
        return;
    }
    StorageProvider_1.Storage.setItem(hashKey, JSON.stringify(info));
}
function _readFallbackInfoFromCache(sdkKey) {
    var hashKey = _getFallbackInfoStorageKey(sdkKey);
    var data = StorageProvider_1.Storage.getItem(hashKey);
    if (!data) return null;
    try {
        return JSON.parse(data);
    } catch (_a) {
        Log_1.Log.error('Failed to parse FallbackInfo');
        return null;
    }
}
function _extractPathFromUrl(urlString) {
    try {
        var url = new URL(urlString);
        return url.pathname;
    } catch (error) {
        return null;
    }
}

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_to_consumable_array":"1eSZf","@swc/helpers/_/_ts_generator":"78Tqx","85035aee34a8486":"470Rm","6fd2975ce34dbb7a":"6nhM9","4e1f612a80982c30":"jH0ho","c1b875ef6477bd9d":"8hatk"}],"470Rm":[function(require,module,exports,__globalThis) {
var _instanceof = require("@swc/helpers/_/_instanceof");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
"use strict";
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return (0, _instanceof._)(value, P) ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports._fetchTxtRecords = void 0;
// See example: https://github.com/statsig-io/private-js-client-monorepo/pull/340
var FEATURE_ASSETS_DNS_QUERY = new Uint8Array([
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x0d,
    0x66,
    0x65,
    0x61,
    0x74,
    0x75,
    0x72,
    0x65,
    0x61,
    0x73,
    0x73,
    0x65,
    0x74,
    0x73,
    0x03,
    0x6f,
    0x72,
    0x67,
    0x00,
    0x00,
    0x10,
    0x00,
    0x01
]);
var DNS_QUERY_ENDPOINT = 'https://cloudflare-dns.com/dns-query';
var DOMAIN_CHARS = [
    'i',
    'e',
    'd'
];
var MAX_START_LOOKUP = 200;
function _fetchTxtRecords(networkFunc) {
    return __awaiter(this, void 0, void 0, function() {
        var response, err, data, bytes;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        networkFunc(DNS_QUERY_ENDPOINT, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/dns-message',
                                Accept: 'application/dns-message'
                            },
                            body: FEATURE_ASSETS_DNS_QUERY
                        })
                    ];
                case 1:
                    response = _state.sent();
                    if (!response.ok) {
                        err = new Error('Failed to fetch TXT records from DNS');
                        err.name = 'DnsTxtFetchError';
                        throw err;
                    }
                    return [
                        4,
                        response.arrayBuffer()
                    ];
                case 2:
                    data = _state.sent();
                    bytes = new Uint8Array(data);
                    return [
                        2,
                        _parseDnsResponse(bytes)
                    ];
            }
        });
    });
}
exports._fetchTxtRecords = _fetchTxtRecords;
function _parseDnsResponse(input) {
    // loop until we find the first valid domain char. One of [i=, e=, d=]
    var start = input.findIndex(function(byte, index) {
        return index < MAX_START_LOOKUP && String.fromCharCode(byte) === '=' && DOMAIN_CHARS.includes(String.fromCharCode(input[index - 1]));
    });
    if (start === -1) {
        var err = new Error('Failed to parse TXT records from DNS');
        err.name = 'DnsTxtParseError';
        throw err;
    }
    // decode the remaining bytes as a string
    var result = '';
    for(var i = start - 1; i < input.length; i++)result += String.fromCharCode(input[i]);
    return result.split(',');
}

},{"@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_ts_generator":"78Tqx"}],"8kCTX":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SDKFlags = void 0;
var FLAGMAP = {};
exports.SDKFlags = {
    setFlags: function(sdkKey, flags) {
        FLAGMAP[sdkKey] = flags;
    },
    get: function(sdkKey, flagKey) {
        var _a, _b;
        return (_b = (_a = FLAGMAP[sdkKey]) === null || _a === void 0 ? void 0 : _a[flagKey]) !== null && _b !== void 0 ? _b : false;
    }
};

},{}],"5Fh6O":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.StatsigSession = exports.SessionID = void 0;
var __StatsigGlobal_1 = require("2e15ad46479f9adb");
var CacheKey_1 = require("f9bc1081c1379dc3");
var Log_1 = require("d0069d161455255");
var StorageProvider_1 = require("82c98556216f5032");
var UUID_1 = require("9d82e76f0a309c52");
var MAX_SESSION_IDLE_TIME = 1800000; // 30 minutes
var MAX_SESSION_AGE = 14400000; // 4 hours
var PROMISE_MAP = {};
exports.SessionID = {
    get: function(sdkKey) {
        return exports.StatsigSession.get(sdkKey).data.sessionID;
    }
};
exports.StatsigSession = {
    get: function(sdkKey) {
        if (PROMISE_MAP[sdkKey] == null) PROMISE_MAP[sdkKey] = _loadSession(sdkKey);
        var session = PROMISE_MAP[sdkKey];
        return _bumpSession(session);
    },
    overrideInitialSessionID: function(override, sdkKey) {
        PROMISE_MAP[sdkKey] = _overrideSessionId(override, sdkKey);
    }
};
function _loadSession(sdkKey) {
    var data = _loadFromStorage(sdkKey);
    var now = Date.now();
    if (!data) data = {
        sessionID: (0, UUID_1.getUUID)(),
        startTime: now,
        lastUpdate: now
    };
    return {
        data: data,
        sdkKey: sdkKey
    };
}
function _overrideSessionId(override, sdkKey) {
    var now = Date.now();
    return {
        data: {
            sessionID: override,
            startTime: now,
            lastUpdate: now
        },
        sdkKey: sdkKey
    };
}
function _bumpSession(session) {
    var now = Date.now();
    var data = session.data;
    var sdkKey = session.sdkKey;
    if (_isIdle(data) || _hasRunTooLong(data)) {
        data.sessionID = (0, UUID_1.getUUID)();
        data.startTime = now;
        var client = __STATSIG__ === null || __STATSIG__ === void 0 ? void 0 : __STATSIG__.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }
    data.lastUpdate = now;
    _persistToStorage(data, session.sdkKey);
    clearTimeout(session.idleTimeoutID);
    clearTimeout(session.ageTimeoutID);
    var lifetime = now - data.startTime;
    session.idleTimeoutID = _createSessionTimeout(sdkKey, MAX_SESSION_IDLE_TIME);
    session.ageTimeoutID = _createSessionTimeout(sdkKey, MAX_SESSION_AGE - lifetime);
    return session;
}
function _createSessionTimeout(sdkKey, duration) {
    return setTimeout(function() {
        var _a;
        var client = (_a = (0, __StatsigGlobal_1._getStatsigGlobal)()) === null || _a === void 0 ? void 0 : _a.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }, duration);
}
function _isIdle(param) {
    var lastUpdate = param.lastUpdate;
    return Date.now() - lastUpdate > MAX_SESSION_IDLE_TIME;
}
function _hasRunTooLong(param) {
    var startTime = param.startTime;
    return Date.now() - startTime > MAX_SESSION_AGE;
}
function _getSessionIDStorageKey(sdkKey) {
    return "statsig.session_id.".concat((0, CacheKey_1._getStorageKey)(sdkKey));
}
function _persistToStorage(session, sdkKey) {
    var storageKey = _getSessionIDStorageKey(sdkKey);
    try {
        (0, StorageProvider_1._setObjectInStorage)(storageKey, session);
    } catch (e) {
        Log_1.Log.warn('Failed to save SessionID');
    }
}
function _loadFromStorage(sdkKey) {
    var storageKey = _getSessionIDStorageKey(sdkKey);
    return (0, StorageProvider_1._getObjectFromStorage)(storageKey);
}

},{"2e15ad46479f9adb":"d5W7z","f9bc1081c1379dc3":"eqWfV","d0069d161455255":"jH0ho","82c98556216f5032":"8hatk","9d82e76f0a309c52":"h64IW"}],"50bPm":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ErrorTag = void 0;
exports.ErrorTag = {
    NetworkError: 'NetworkError'
};

},{}],"jjzMX":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"kaTYM":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"htdWS":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports._fastApproxSizeOf = void 0;
var CURLY_AND_SQUARE_BRACKET_SIZE = 2; // [] for array, {} for object
var APPROX_ADDITIONAL_SIZE = 1; // additional size for comma and stuff
var _fastApproxSizeOf = function(obj, max) {
    var size = 0;
    var keys = Object.keys(obj);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var value = obj[key];
        size += key.length;
        if ((typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) === 'object' && value !== null) size += (0, exports._fastApproxSizeOf)(value, max) + CURLY_AND_SQUARE_BRACKET_SIZE;
        else size += String(value).length + APPROX_ADDITIONAL_SIZE;
        if (size >= max) // exit early if we've exceeded the max
        return size;
    }
    return size;
};
exports._fastApproxSizeOf = _fastApproxSizeOf;

},{"@swc/helpers/_/_type_of":"iFJdx"}],"4DqMB":[function(require,module,exports,__globalThis) {
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
"use strict";
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return (0, _instanceof._)(value, P) ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.StatsigClientBase = void 0;
require("c44f8fb3e5374534");
var __StatsigGlobal_1 = require("c44f8fb3e5374534");
var ErrorBoundary_1 = require("4da963955a257fa");
var EventLogger_1 = require("ef8da0094bd51dc6");
var Log_1 = require("135543c111a3beb5");
var MemoKey_1 = require("f3b558c0272910d3");
var SafeJs_1 = require("6eafc79afdbf2226");
var SessionID_1 = require("ba8c260cf5e23799");
var StableID_1 = require("a2f791897100df48");
var StatsigOptionsCommon_1 = require("58a0825917d8f3bf");
var StorageProvider_1 = require("650b86707dd4a4b4");
var MAX_MEMO_CACHE_SIZE = 3000;
var StatsigClientBase = /*#__PURE__*/ function() {
    function StatsigClientBase(sdkKey, adapter, network, options) {
        var _this = this;
        (0, _classCallCheck._)(this, StatsigClientBase);
        var _a, _b, _c, _d;
        this.loadingStatus = 'Uninitialized';
        this._initializePromise = null;
        this._listeners = {};
        var emitter = this.$emt.bind(this);
        (options === null || options === void 0 ? void 0 : options.logLevel) != null && (Log_1.Log.level = options.logLevel);
        (options === null || options === void 0 ? void 0 : options.disableStorage) && StorageProvider_1.Storage._setDisabled(true);
        (options === null || options === void 0 ? void 0 : options.initialSessionID) && SessionID_1.StatsigSession.overrideInitialSessionID(options.initialSessionID, sdkKey);
        (options === null || options === void 0 ? void 0 : options.storageProvider) && StorageProvider_1.Storage._setProvider(options.storageProvider);
        (options === null || options === void 0 ? void 0 : options.enableCookies) && StableID_1.StableID._setCookiesEnabled(sdkKey, options.enableCookies);
        (options === null || options === void 0 ? void 0 : options.disableStableID) && StableID_1.StableID._setDisabled(sdkKey, true);
        this._sdkKey = sdkKey;
        this._options = options !== null && options !== void 0 ? options : {};
        this._memoCache = {};
        this.overrideAdapter = (_a = options === null || options === void 0 ? void 0 : options.overrideAdapter) !== null && _a !== void 0 ? _a : null;
        this._logger = new EventLogger_1.EventLogger(sdkKey, emitter, network, options);
        this._errorBoundary = new ErrorBoundary_1.ErrorBoundary(sdkKey, options, emitter);
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(adapter);
        this._errorBoundary.wrap(this._logger);
        network.setErrorBoundary(this._errorBoundary);
        this.dataAdapter = adapter;
        this.dataAdapter.attach(sdkKey, options, network);
        this.storageProvider = StorageProvider_1.Storage;
        (_d = (_c = (_b = this.overrideAdapter) === null || _b === void 0 ? void 0 : _b.loadFromStorage) === null || _c === void 0 ? void 0 : _c.call(_b)) === null || _d === void 0 || _d.catch(function(e) {
            return _this._errorBoundary.logError('OA::loadFromStorage', e);
        });
        this._primeReadyRipcord();
        _assignGlobalInstance(sdkKey, this);
    }
    (0, _createClass._)(StatsigClientBase, [
        {
            /**
     * Updates runtime configuration options for the SDK, allowing toggling of certain behaviors such as logging and storage to comply with user preferences or regulations such as GDPR.
     *
     * @param {StatsigRuntimeMutableOptions} options - The configuration options that dictate the runtime behavior of the SDK.
     */ key: "updateRuntimeOptions",
            value: function updateRuntimeOptions(options) {
                if (options.loggingEnabled) {
                    this._options.loggingEnabled = options.loggingEnabled;
                    this._logger.setLoggingEnabled(options.loggingEnabled);
                } else if (options.disableLogging != null) {
                    this._options.disableLogging = options.disableLogging;
                    this._logger.setLoggingEnabled(options.disableLogging ? 'disabled' : 'browser-only');
                }
                if (options.disableStorage != null) {
                    this._options.disableStorage = options.disableStorage;
                    StorageProvider_1.Storage._setDisabled(options.disableStorage);
                }
                if (options.enableCookies != null) {
                    this._options.enableCookies = options.enableCookies;
                    StableID_1.StableID._setCookiesEnabled(this._sdkKey, options.enableCookies);
                }
                if (options.logEventCompressionMode) this._logger.setLogEventCompressionMode(options.logEventCompressionMode);
                else if (options.disableCompression) this._logger.setLogEventCompressionMode(StatsigOptionsCommon_1.LogEventCompressionMode.Disabled);
            }
        },
        {
            /**
     * Flushes any currently queued events.
     */ key: "flush",
            value: function flush() {
                return this._logger.flush();
            }
        },
        {
            /**
     * Gracefully shuts down the SDK, ensuring that all pending events are send before the SDK stops.
     * This function emits a 'pre_shutdown' event and then waits for the logger to complete its shutdown process.
     *
     * @returns {Promise<void>} A promise that resolves when all shutdown procedures, including logging shutdown, have been completed.
     */ key: "shutdown",
            value: function shutdown() {
                return __awaiter(this, void 0, void 0, function() {
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                this.$emt({
                                    name: 'pre_shutdown'
                                });
                                this._setStatus('Uninitialized', null);
                                this._initializePromise = null;
                                return [
                                    4,
                                    this._logger.stop()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            /**
     * Subscribes a callback function to a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     * Once subscribed, the listener callback will be invoked whenever the specified event is emitted.
     *
     * @param {StatsigClientEventName} event - The name of the event to subscribe to, or '*' to subscribe to all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to execute when the event occurs. The function receives event-specific data as its parameter.
     * @see {@link off} for unsubscribing from events.
     */ key: "on",
            value: function on(event, listener) {
                if (!this._listeners[event]) this._listeners[event] = [];
                this._listeners[event].push(listener);
            }
        },
        {
            /**
     * Unsubscribes a previously registered callback function from a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     *
     * @param {StatsigClientEventName} event - The name of the event from which to unsubscribe, or '*' to unsubscribe from all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to remove from the event's notification list.
     * @see {@link on} for subscribing to events.
     */ key: "off",
            value: function off(event, listener) {
                if (this._listeners[event]) {
                    var index = this._listeners[event].indexOf(listener);
                    if (index !== -1) this._listeners[event].splice(index, 1);
                }
            }
        },
        {
            key: "$on",
            value: function $on(event, listener) {
                listener.__isInternal = true;
                this.on(event, listener);
            }
        },
        {
            key: "$emt",
            value: function $emt(event) {
                var _this = this;
                var _a;
                var barrier = function(listener) {
                    try {
                        listener(event);
                    } catch (error) {
                        if (listener.__isInternal === true) {
                            _this._errorBoundary.logError("__emit:".concat(event.name), error);
                            return;
                        }
                        Log_1.Log.error("An error occurred in a StatsigClientEvent listener. This is not an issue with Statsig.", event);
                    }
                };
                if (this._listeners[event.name]) this._listeners[event.name].forEach(function(l) {
                    return barrier(l);
                });
                (_a = this._listeners['*']) === null || _a === void 0 || _a.forEach(barrier);
            }
        },
        {
            key: "_setStatus",
            value: function _setStatus(newStatus, values) {
                this.loadingStatus = newStatus;
                this._memoCache = {};
                this.$emt({
                    name: 'values_updated',
                    status: newStatus,
                    values: values
                });
            }
        },
        {
            key: "_enqueueExposure",
            value: function _enqueueExposure(name, exposure, options) {
                if ((options === null || options === void 0 ? void 0 : options.disableExposureLog) === true) {
                    this._logger.incrementNonExposureCount(name);
                    return;
                }
                this._logger.enqueue(exposure);
            }
        },
        {
            key: "_memoize",
            value: function _memoize(prefix, fn) {
                var _this = this;
                return function(name, options) {
                    if (_this._options.disableEvaluationMemoization) return fn(name, options);
                    var memoKey = (0, MemoKey_1.createMemoKey)(prefix, name, options);
                    if (!memoKey) return fn(name, options);
                    if (!(memoKey in _this._memoCache)) {
                        if (Object.keys(_this._memoCache).length >= MAX_MEMO_CACHE_SIZE) _this._memoCache = {};
                        _this._memoCache[memoKey] = fn(name, options);
                    }
                    return _this._memoCache[memoKey];
                };
            }
        }
    ]);
    return StatsigClientBase;
}();
exports.StatsigClientBase = StatsigClientBase;
function _assignGlobalInstance(sdkKey, client) {
    var _a;
    if ((0, SafeJs_1._isServerEnv)()) return;
    var statsigGlobal = (0, __StatsigGlobal_1._getStatsigGlobal)();
    var instances = (_a = statsigGlobal.instances) !== null && _a !== void 0 ? _a : {};
    var inst = client;
    if (instances[sdkKey] != null) Log_1.Log.warn('Creating multiple Statsig clients with the same SDK key can lead to unexpected behavior. Multi-instance support requires different SDK keys.');
    instances[sdkKey] = inst;
    if (!statsigGlobal.firstInstance) statsigGlobal.firstInstance = inst;
    statsigGlobal.instances = instances;
    __STATSIG__ = statsigGlobal;
}

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_ts_generator":"78Tqx","c44f8fb3e5374534":"d5W7z","4da963955a257fa":"jvCQP","ef8da0094bd51dc6":"506Fu","135543c111a3beb5":"jH0ho","f3b558c0272910d3":"4FvMU","6eafc79afdbf2226":"1m3HT","ba8c260cf5e23799":"5Fh6O","a2f791897100df48":"iu1pY","58a0825917d8f3bf":"98Sh7","650b86707dd4a4b4":"8hatk"}],"iA4hx":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DataAdapterCachePrefix = void 0;
exports.DataAdapterCachePrefix = 'statsig.cached';

},{}],"g4gRv":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"egpWn":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports._makeTypedGet = exports._mergeOverride = exports._makeLayer = exports._makeExperiment = exports._makeDynamicConfig = exports._makeFeatureGate = void 0;
var Log_1 = require("c99fc0324dc84901");
var TypingUtils_1 = require("86326d1a0c805af4");
function _makeEvaluation(name, details, evaluation, value) {
    var _a;
    return {
        name: name,
        details: details,
        ruleID: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.rule_id) !== null && _a !== void 0 ? _a : '',
        __evaluation: evaluation,
        value: value
    };
}
function _makeFeatureGate(name, details, evaluation) {
    var _a;
    return Object.assign(Object.assign({}, _makeEvaluation(name, details, evaluation, (evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) === true)), {
        idType: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _a !== void 0 ? _a : null
    });
}
exports._makeFeatureGate = _makeFeatureGate;
function _makeDynamicConfig(name, details, evaluation) {
    var _a, _b;
    var value = (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({}, _makeEvaluation(name, details, evaluation, value)), {
        idType: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _b !== void 0 ? _b : null,
        get: _makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value)
    });
}
exports._makeDynamicConfig = _makeDynamicConfig;
function _makeExperiment(name, details, evaluation) {
    var _a;
    var result = _makeDynamicConfig(name, details, evaluation);
    return Object.assign(Object.assign({}, result), {
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null
    });
}
exports._makeExperiment = _makeExperiment;
function _makeLayer(name, details, evaluation, exposeFunc) {
    var _a, _b;
    return Object.assign(Object.assign({}, _makeEvaluation(name, details, evaluation, undefined)), {
        get: _makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value, exposeFunc),
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null,
        __value: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _b !== void 0 ? _b : {}
    });
}
exports._makeLayer = _makeLayer;
function _mergeOverride(original, overridden, value, exposeFunc) {
    return Object.assign(Object.assign(Object.assign({}, original), overridden), {
        get: _makeTypedGet(original.name, value, exposeFunc)
    });
}
exports._mergeOverride = _mergeOverride;
function _makeTypedGet(name, value, exposeFunc) {
    return function(param, fallback) {
        var _a;
        var found = (_a = value === null || value === void 0 ? void 0 : value[param]) !== null && _a !== void 0 ? _a : null;
        if (found == null) return fallback !== null && fallback !== void 0 ? fallback : null;
        if (fallback != null && !(0, TypingUtils_1._isTypeMatch)(found, fallback)) {
            Log_1.Log.warn("Parameter type mismatch. '".concat(name, ".").concat(param, "' was found to be type '").concat(typeof found === "undefined" ? "undefined" : (0, _typeOf._)(found), "' but fallback/return type is '").concat(typeof fallback === "undefined" ? "undefined" : (0, _typeOf._)(fallback), "'. See https://docs.statsig.com/client/javascript-sdk/#typed-getters"));
            return fallback !== null && fallback !== void 0 ? fallback : null;
        }
        exposeFunc === null || exposeFunc === void 0 || exposeFunc(param);
        return found;
    };
}
exports._makeTypedGet = _makeTypedGet;

},{"@swc/helpers/_/_type_of":"iFJdx","c99fc0324dc84901":"jH0ho","86326d1a0c805af4":"4UasP"}],"6UaT7":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"l6Jw0":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UPDATE_DETAIL_ERROR_MESSAGES = exports.createUpdateDetails = void 0;
var createUpdateDetails = function(success, source, initDuration, error, sourceUrl, warnings) {
    return {
        duration: initDuration,
        source: source,
        success: success,
        error: error,
        sourceUrl: sourceUrl,
        warnings: warnings
    };
};
exports.createUpdateDetails = createUpdateDetails;
exports.UPDATE_DETAIL_ERROR_MESSAGES = {
    NO_NETWORK_DATA: 'No data was returned from the network. This may be due to a network timeout if a timeout value was specified in the options or ad blocker error.'
};

},{}],"ccWNs":[function(require,module,exports,__globalThis) {
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
"use strict";
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return (0, _instanceof._)(value, P) ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
var client_core_1 = require("e0761d782e417a7b");
var EvaluationStore_1 = require("bb4d2d3cd4d58603");
var Network_1 = require("df3cb964060f8da9");
var ParamStoreGetterFactory_1 = require("3896ed2557d65a15");
var StatsigEvaluationsDataAdapter_1 = require("ccd804bf92a192aa");
var StatsigClient = /*#__PURE__*/ function(_client_core_1_StatsigClientBase) {
    (0, _inherits._)(StatsigClient, _client_core_1_StatsigClientBase);
    function StatsigClient(sdkKey, user) {
        var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
        (0, _classCallCheck._)(this, StatsigClient);
        var _this;
        var _a, _b;
        client_core_1.SDKType._setClientType(sdkKey, 'javascript-client');
        var network = new Network_1.default(options, function(e) {
            (0, _assertThisInitialized._)(_this).$emt(e);
        });
        _this = (0, _callSuper._)(this, StatsigClient, [
            sdkKey,
            (_a = options === null || options === void 0 ? void 0 : options.dataAdapter) !== null && _a !== void 0 ? _a : new StatsigEvaluationsDataAdapter_1.StatsigEvaluationsDataAdapter(),
            network,
            options
        ]);
        _this._possibleFirstTouchMetadata = {};
        /**
         * Retrieves the value of a feature gate for the current user, represented as a {@link FeatureGate} object.
         *
         * @param {string} name - The name of the feature gate to retrieve.
         * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {FeatureGate} - The {@link FeatureGate} object representing the gate's current evaluation results for the user.
         */ _this.getFeatureGate = _this._memoize(client_core_1.MemoPrefix._gate, _this._getFeatureGateImpl.bind(_this));
        /**
         * Retrieves the value of a dynamic config for the current user.
         *
         * @param {string} name The name of the dynamic config to get.
         * @param {DynamicConfigEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {DynamicConfig} - The {@link DynamicConfig} object representing the dynamic configs's current evaluation results for the user.
         */ _this.getDynamicConfig = _this._memoize(client_core_1.MemoPrefix._dynamicConfig, _this._getDynamicConfigImpl.bind(_this));
        /**
         * Retrieves the value of a experiment for the current user.
         *
         * @param {string} name The name of the experiment to get.
         * @param {ExperimentEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Experiment} - The {@link Experiment} object representing the experiments's current evaluation results for the user.
         */ _this.getExperiment = _this._memoize(client_core_1.MemoPrefix._experiment, _this._getExperimentImpl.bind(_this));
        /**
         * Retrieves the list of all Dynamic Configs and Experiments for the current user.
         *
         * @returns {string[]} The list of all Dynamic Config and Experiment names for the current user. Note - these will be hashed unless you've disabled hashing.
         * This is intended to be used for debugging.
         */ _this.getConfigList = _this._memoize(client_core_1.MemoPrefix._configList, _this._getConfigListImpl.bind(_this));
        /**
         * Retrieves the value of a layer for the current user.
         *
         * @param {string} name The name of the layer to get.
         * @param {LayerEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Layer} - The {@link Layer} object representing the layers's current evaluation results for the user.
         */ _this.getLayer = _this._memoize(client_core_1.MemoPrefix._layer, _this._getLayerImpl.bind(_this));
        /**
         * Retrieves the value of a parameter store for the current user.
         *
         * @param {string} name The name of the parameter store to get.
         * @param {ParameterStoreEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {ParameterStore} - The {@link ParameterStore} object representing the parameter store's current mappings for the user.
         */ _this.getParameterStore = _this._memoize(client_core_1.MemoPrefix._paramStore, _this._getParameterStoreImpl.bind(_this));
        _this._store = new EvaluationStore_1.default(sdkKey);
        _this._network = network;
        _this._user = _this._configureUser(user, options);
        _this._sdkInstanceID = (0, client_core_1.getUUID)();
        var plugins = (_b = options === null || options === void 0 ? void 0 : options.plugins) !== null && _b !== void 0 ? _b : [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = plugins[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var plugin = _step.value;
                plugin.bind(_this);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return _this;
    }
    (0, _createClass._)(StatsigClient, [
        {
            /**
     * Initializes the StatsigClient using cached values. This method sets up the client synchronously by utilizing previously cached values.
     * After initialization, cache values are updated in the background for future use, either in subsequent sessions or when `updateUser` is called.
     * This is useful for quickly starting with the last-known-good configurations while refreshing data to keep settings up-to-date.
     *
     * @see {@link initializeAsync} for the asynchronous version of this method.
     */ key: "initializeSync",
            value: function initializeSync(options) {
                var _a;
                if (this.loadingStatus !== 'Uninitialized') return (0, client_core_1.createUpdateDetails)(true, this._store.getSource(), -1, null, null, [
                    'MultipleInitializations'
                ].concat((0, _toConsumableArray._)((_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : [])));
                this._logger.start();
                return this.updateUserSync(this._user, options);
            }
        },
        {
            /**
     * Initializes the StatsigClient asynchronously by first using cached values and then updating to the latest values from the network.
     * Once the network values are fetched, they replace the existing cached values. If this method's promise is not awaited,
     * there might be a transition from cached to network values during the session, which can affect consistency.
     * This method is useful when it's acceptable to begin with potentially stale data and switch to the latest configuration as it becomes available.
     *
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully initialized with the latest values from the network or a timeout (if set) is hit.
     * @see {@link initializeSync} for the synchronous version of this method.
     */ key: "initializeAsync",
            value: function initializeAsync(options) {
                return __awaiter(this, void 0, void 0, function() {
                    return (0, _tsGenerator._)(this, function(_state) {
                        if (this._initializePromise) return [
                            2,
                            this._initializePromise
                        ];
                        this._initializePromise = this._initializeAsyncImpl(options);
                        return [
                            2,
                            this._initializePromise
                        ];
                    });
                });
            }
        },
        {
            /**
     * Synchronously updates the user in the Statsig client and switches the internal state to use cached values for the newly specified user.
     * After the initial switch to cached values, this method updates these values in the background, preparing them for future sessions or subsequent calls to updateUser.
     * This method ensures the client is quickly ready with available data.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @see {@link updateUserAsync} for the asynchronous version of this method.
     */ key: "updateUserSync",
            value: function updateUserSync(user, options) {
                var startTime = performance.now();
                try {
                    return this._updateUserSyncImpl(user, options, startTime);
                } catch (e) {
                    var err = (0, _instanceof._)(e, Error) ? e : new Error(String(e));
                    return this._createErrorUpdateDetails(err, startTime);
                }
            }
        },
        {
            key: "_updateUserSyncImpl",
            value: function _updateUserSyncImpl(user, options, startTime) {
                var _a;
                var warnings = (0, _toConsumableArray._)((_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []);
                this._resetForUser(user);
                var result = this.dataAdapter.getDataSync(this._user);
                if (result == null) warnings.push('NoCachedValues');
                this._store.setValues(result, this._user);
                this._finalizeUpdate(result);
                var disable = options === null || options === void 0 ? void 0 : options.disableBackgroundCacheRefresh;
                if (disable === true || disable == null && (result === null || result === void 0 ? void 0 : result.source) === 'Bootstrap') return (0, client_core_1.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
                this._runPostUpdate(result !== null && result !== void 0 ? result : null, this._user);
                return (0, client_core_1.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
            }
        },
        {
            /**
     * Asynchronously updates the user in the Statsig client by initially using cached values and then fetching the latest values from the network.
     * When the latest values are fetched, they replace the cached values. If the promise returned by this method is not awaited,
     * the client's state may shift from cached to updated network values during the session, potentially affecting consistency.
     * This method is best used in scenarios where up-to-date configuration is critical and initial delays are acceptable.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully updated with the latest values from the network or a timeout (if set) is hit.
     * @see {@link updateUserSync} for the synchronous version of this method.
     */ key: "updateUserAsync",
            value: function updateUserAsync(user, options) {
                return __awaiter(this, void 0, void 0, function() {
                    var startTime, e, err;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                startTime = performance.now();
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    this._updateUserAsyncImpl(user, options)
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 3:
                                e = _state.sent();
                                err = (0, _instanceof._)(e, Error) ? e : new Error(String(e));
                                return [
                                    2,
                                    this._createErrorUpdateDetails(err, startTime)
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_updateUserAsyncImpl",
            value: function _updateUserAsyncImpl(user, options) {
                return __awaiter(this, void 0, void 0, function() {
                    var initiator, result, isUsingNetworkValues, initDuration;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                this._resetForUser(user);
                                initiator = this._user;
                                client_core_1.Diagnostics._markInitOverallStart(this._sdkKey);
                                result = this.dataAdapter.getDataSync(initiator);
                                this._store.setValues(result, this._user);
                                this._setStatus('Loading', result);
                                return [
                                    4,
                                    this.dataAdapter.getDataAsync(result, initiator, options)
                                ];
                            case 1:
                                result = _state.sent();
                                // ensure the user hasn't changed while we were waiting
                                if (initiator !== this._user) return [
                                    2,
                                    (0, client_core_1.createUpdateDetails)(false, this._store.getSource(), -1, new Error('User changed during update'), this._network.getLastUsedInitUrlAndReset())
                                ];
                                isUsingNetworkValues = false;
                                if (result != null) {
                                    client_core_1.Diagnostics._markInitProcessStart(this._sdkKey);
                                    isUsingNetworkValues = this._store.setValues(result, this._user);
                                    client_core_1.Diagnostics._markInitProcessEnd(this._sdkKey, {
                                        success: isUsingNetworkValues
                                    });
                                }
                                this._finalizeUpdate(result);
                                if (!isUsingNetworkValues) {
                                    this._errorBoundary.attachErrorIfNoneExists(client_core_1.UPDATE_DETAIL_ERROR_MESSAGES.NO_NETWORK_DATA);
                                    this.$emt({
                                        name: 'initialization_failure'
                                    });
                                }
                                client_core_1.Diagnostics._markInitOverallEnd(this._sdkKey, isUsingNetworkValues, this._store.getCurrentSourceDetails());
                                initDuration = client_core_1.Diagnostics._enqueueDiagnosticsEvent(this._user, this._logger, this._sdkKey, this._options);
                                return [
                                    2,
                                    (0, client_core_1.createUpdateDetails)(isUsingNetworkValues, this._store.getSource(), initDuration, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), this._store.getWarnings())
                                ];
                        }
                    });
                });
            }
        },
        {
            /**
     * Retrieves a synchronous context containing data currently being used by the SDK. Represented as a {@link PrecomputedEvaluationsContext} object.
     *
     * @returns {PrecomputedEvaluationsContext} The current synchronous context for the this StatsigClient instance.
     */ key: "getContext",
            value: function getContext() {
                var user = {};
                try {
                    user = JSON.parse(JSON.stringify(this._user));
                } catch (_a) {
                    client_core_1.Log.error('Failed to parse user');
                }
                return {
                    sdkKey: this._sdkKey,
                    options: this._options,
                    values: this._store.getValues(),
                    user: user,
                    errorBoundary: this._errorBoundary,
                    session: client_core_1.StatsigSession.get(this._sdkKey),
                    stableID: client_core_1.StableID.get(this._sdkKey),
                    sdkInstanceID: this._sdkInstanceID
                };
            }
        },
        {
            /**
     * Retrieves the value of a feature gate for the current user, represented as a simple boolean.
     *
     * @param {string} name - The name of the feature gate to retrieve.
     * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {boolean} - The boolean value representing the gate's current evaluation results for the user.
     */ key: "checkGate",
            value: function checkGate(name, options) {
                return this.getFeatureGate(name, options).value;
            }
        },
        {
            /**
     * Logs an event to the internal logging system. This function allows logging by either passing a fully formed event object or by specifying the event name with optional value and metadata.
     *
     * @param {StatsigEvent|string} eventOrName - The event object conforming to the StatsigEvent interface, or the name of the event as a string.
     * @param {string|number} value - Optional. The value associated with the event, which can be a string or a number. This parameter is ignored if the first parameter is a StatsigEvent object.
     * @param {Record<string, string>} metadata - Optional. A key-value record containing metadata about the event. This is also ignored if the first parameter is an event object.
     */ key: "logEvent",
            value: function logEvent(eventOrName, value, metadata) {
                var event = typeof eventOrName === 'string' ? {
                    eventName: eventOrName,
                    value: value,
                    metadata: metadata
                } : eventOrName;
                this.$emt({
                    name: 'log_event_called',
                    event: event
                });
                this._logger.enqueue(Object.assign(Object.assign({}, event), {
                    user: this._user,
                    time: Date.now()
                }));
            }
        },
        {
            /**
     * Updates the user with analytics only metadata. This will override any existing analytics only metadata.
     *
     * @param {Record<string, string | number | boolean>} metadata - The metadata to add to the user.
     */ key: "updateUserWithAnalyticsOnlyMetadata",
            value: function updateUserWithAnalyticsOnlyMetadata(metadata) {
                this._user = this._configureUser(Object.assign(Object.assign({}, this._user), {
                    analyticsOnlyMetadata: metadata
                }), this._options);
            }
        },
        {
            key: "_primeReadyRipcord",
            value: function _primeReadyRipcord() {
                var _this = this;
                this.$on('error', function() {
                    _this.loadingStatus === 'Loading' && _this._finalizeUpdate(null);
                });
            }
        },
        {
            key: "_initializeAsyncImpl",
            value: function _initializeAsyncImpl(options) {
                return __awaiter(this, void 0, void 0, function() {
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!client_core_1.Storage.isReady()) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    client_core_1.Storage.isReadyResolver()
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                this._logger.start();
                                return [
                                    2,
                                    this.updateUserAsync(this._user, options)
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_createErrorUpdateDetails",
            value: function _createErrorUpdateDetails(error, startTime) {
                var _a;
                return (0, client_core_1.createUpdateDetails)(false, this._store.getSource(), performance.now() - startTime, error, null, (0, _toConsumableArray._)((_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []));
            }
        },
        {
            key: "_finalizeUpdate",
            value: function _finalizeUpdate(values) {
                this._store.finalize();
                this._setStatus('Ready', values);
            }
        },
        {
            key: "_runPostUpdate",
            value: function _runPostUpdate(current, user) {
                this.dataAdapter.getDataAsync(current, user, {
                    priority: 'low'
                }).catch(function(err) {
                    client_core_1.Log.error('An error occurred after update.', err);
                });
            }
        },
        {
            key: "_resetForUser",
            value: function _resetForUser(user) {
                this._logger.reset();
                this._store.reset();
                this._user = this._configureUser(user, this._options);
            }
        },
        {
            key: "_configureUser",
            value: function _configureUser(originalUser, options) {
                var _this = this;
                var _a, _b, _c;
                var user = (0, client_core_1._normalizeUser)(originalUser, options);
                var stableIdOverride = (_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
                if (stableIdOverride) {
                    var readyPromise = (_c = (_b = this.storageProvider).isReadyResolver) === null || _c === void 0 ? void 0 : _c.call(_b);
                    if (readyPromise) readyPromise.then(function() {
                        return client_core_1.StableID.setOverride(stableIdOverride, _this._sdkKey);
                    }, function() {
                        return client_core_1.StableID.setOverride(stableIdOverride, _this._sdkKey);
                    });
                    else client_core_1.StableID.setOverride(stableIdOverride, this._sdkKey);
                }
                // Only attach first touch metadata if it's not empty
                if (Object.keys(this._possibleFirstTouchMetadata).length > 0) user.analyticsOnlyMetadata = Object.assign(Object.assign({}, user.analyticsOnlyMetadata), this._possibleFirstTouchMetadata);
                return user;
            }
        },
        {
            key: "_getFeatureGateImpl",
            value: function _getFeatureGateImpl(name, options) {
                var _a, _b;
                var _this__store_getGate = this._store.getGate(name), evaluation = _this__store_getGate.result, details = _this__store_getGate.details;
                var gate = (0, client_core_1._makeFeatureGate)(name, details, evaluation);
                var overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getGateOverride) === null || _b === void 0 ? void 0 : _b.call(_a, gate, this._user, options);
                var result = overridden !== null && overridden !== void 0 ? overridden : gate;
                this._enqueueExposure(name, (0, client_core_1._createGateExposure)(this._user, result, this._store.getExposureMapping()), options);
                this.$emt({
                    name: 'gate_evaluation',
                    gate: result
                });
                return result;
            }
        },
        {
            key: "_getDynamicConfigImpl",
            value: function _getDynamicConfigImpl(name, options) {
                var _a, _b;
                var _this__store_getConfig = this._store.getConfig(name), evaluation = _this__store_getConfig.result, details = _this__store_getConfig.details;
                var config = (0, client_core_1._makeDynamicConfig)(name, details, evaluation);
                var overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getDynamicConfigOverride) === null || _b === void 0 ? void 0 : _b.call(_a, config, this._user, options);
                var result = overridden !== null && overridden !== void 0 ? overridden : config;
                this._enqueueExposure(name, (0, client_core_1._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
                this.$emt({
                    name: 'dynamic_config_evaluation',
                    dynamicConfig: result
                });
                return result;
            }
        },
        {
            key: "_getExperimentImpl",
            value: function _getExperimentImpl(name, options) {
                var _a, _b, _c, _d;
                var _this__store_getConfig = this._store.getConfig(name), evaluation = _this__store_getConfig.result, details = _this__store_getConfig.details;
                var experiment = (0, client_core_1._makeExperiment)(name, details, evaluation);
                if (experiment.__evaluation != null) experiment.__evaluation.secondary_exposures = (0, client_core_1._mapExposures)((_b = (_a = experiment.__evaluation) === null || _a === void 0 ? void 0 : _a.secondary_exposures) !== null && _b !== void 0 ? _b : [], this._store.getExposureMapping());
                var overridden = (_d = (_c = this.overrideAdapter) === null || _c === void 0 ? void 0 : _c.getExperimentOverride) === null || _d === void 0 ? void 0 : _d.call(_c, experiment, this._user, options);
                var result = overridden !== null && overridden !== void 0 ? overridden : experiment;
                this._enqueueExposure(name, (0, client_core_1._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
                this.$emt({
                    name: 'experiment_evaluation',
                    experiment: result
                });
                return result;
            }
        },
        {
            key: "_getConfigListImpl",
            value: function _getConfigListImpl() {
                return this._store.getConfigList();
            }
        },
        {
            key: "_getLayerImpl",
            value: function _getLayerImpl(name, options) {
                var _this = this;
                var _a, _b, _c;
                var _this__store_getLayer = this._store.getLayer(name), evaluation = _this__store_getLayer.result, details = _this__store_getLayer.details;
                var layer = (0, client_core_1._makeLayer)(name, details, evaluation);
                var overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getLayerOverride) === null || _b === void 0 ? void 0 : _b.call(_a, layer, this._user, options);
                if (options === null || options === void 0 ? void 0 : options.disableExposureLog) this._logger.incrementNonExposureCount(name);
                var result = (0, client_core_1._mergeOverride)(layer, overridden, (_c = overridden === null || overridden === void 0 ? void 0 : overridden.__value) !== null && _c !== void 0 ? _c : layer.__value, function(param) {
                    if (options === null || options === void 0 ? void 0 : options.disableExposureLog) return;
                    _this._enqueueExposure(name, (0, client_core_1._createLayerParameterExposure)(_this._user, result, param, _this._store.getExposureMapping()), options);
                });
                this.$emt({
                    name: 'layer_evaluation',
                    layer: result
                });
                return result;
            }
        },
        {
            key: "_getParameterStoreImpl",
            value: function _getParameterStoreImpl(name, options) {
                var _a, _b;
                var _this__store_getParamStore = this._store.getParamStore(name), configuration = _this__store_getParamStore.result, details = _this__store_getParamStore.details;
                this._logger.incrementNonExposureCount(name);
                var paramStore = {
                    name: name,
                    details: details,
                    __configuration: configuration,
                    get: (0, ParamStoreGetterFactory_1._makeParamStoreGetter)(this, configuration, options)
                };
                var overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getParamStoreOverride) === null || _b === void 0 ? void 0 : _b.call(_a, paramStore, options);
                if (overridden != null) {
                    paramStore.__configuration = overridden.config;
                    paramStore.details = overridden.details;
                    paramStore.get = (0, ParamStoreGetterFactory_1._makeParamStoreGetter)(this, overridden.config, options);
                }
                return paramStore;
            }
        }
    ], [
        {
            key: "instance",
            value: /**
     * Retrieves an instance of the StatsigClient based on the provided SDK key.
     *  If no SDK key is provided, the method returns the most recently created instance of the StatsigClient.
     *  The method ensures that each unique SDK key corresponds to a single instance of StatsigClient, effectively implementing a singleton pattern for each key.
     *  If no instance exists for the given SDK key, a new StatsigClient instance will be created and returned.
     *
     * @param {string} [sdkKey] - Optional. The SDK key used to identify a specific instance of the StatsigClient. If omitted, the method returns the last created instance.
     * @returns {StatsigClient} Returns the StatsigClient instance associated with the given SDK key, creating a new one if needed.
     */ function instance(sdkKey) {
                var instance = (0, client_core_1._getStatsigGlobal)().instance(sdkKey);
                if ((0, _instanceof._)(instance, StatsigClient)) return instance;
                client_core_1.Log.warn((0, client_core_1._isServerEnv)() ? 'StatsigClient.instance is not supported in server environments' : 'Unable to find StatsigClient instance');
                return new StatsigClient(sdkKey !== null && sdkKey !== void 0 ? sdkKey : '', {});
            }
        }
    ]);
    return StatsigClient;
}(client_core_1.StatsigClientBase);
exports.default = StatsigClient;

},{"@swc/helpers/_/_assert_this_initialized":"7fiKT","@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_inherits":"2sfqW","@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_to_consumable_array":"1eSZf","@swc/helpers/_/_ts_generator":"78Tqx","e0761d782e417a7b":"1MCdW","bb4d2d3cd4d58603":"aYNNn","df3cb964060f8da9":"lW7K0","3896ed2557d65a15":"fCorX","ccd804bf92a192aa":"3ffDQ"}],"7fiKT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _assert_this_initialized;
});
function _assert_this_initialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cRy4y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _call_super;
});
var _getPrototypeOfJs = require("./_get_prototype_of.js");
var _isNativeReflectConstructJs = require("./_is_native_reflect_construct.js");
var _possibleConstructorReturnJs = require("./_possible_constructor_return.js");
function _call_super(_this, derived, args) {
    // Super
    derived = (0, _getPrototypeOfJs._)(derived);
    return (0, _possibleConstructorReturnJs._)(_this, (0, _isNativeReflectConstructJs._)() ? Reflect.construct(derived, args || [], (0, _getPrototypeOfJs._)(_this).constructor) : derived.apply(_this, args));
}

},{"./_get_prototype_of.js":"5txK6","./_is_native_reflect_construct.js":"dAPDw","./_possible_constructor_return.js":"fMpPb","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5txK6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _get_prototype_of;
});
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dAPDw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _is_native_reflect_construct;
});
function _is_native_reflect_construct() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fMpPb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _possible_constructor_return;
});
var _assertThisInitializedJs = require("./_assert_this_initialized.js");
var _typeOfJs = require("./_type_of.js");
function _possible_constructor_return(self, call) {
    if (call && ((0, _typeOfJs._)(call) === "object" || typeof call === "function")) return call;
    return (0, _assertThisInitializedJs._)(self);
}

},{"./_assert_this_initialized.js":"7fiKT","./_type_of.js":"iFJdx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2sfqW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _inherits;
});
var _setPrototypeOfJs = require("./_set_prototype_of.js");
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, _setPrototypeOfJs._)(subClass, superClass);
}

},{"./_set_prototype_of.js":"8vuiZ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8vuiZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _set_prototype_of;
});
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aYNNn":[function(require,module,exports,__globalThis) {
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var client_core_1 = require("63e41baa1d8d3d48");
var V1InitializeContainer_1 = require("73b4423abedd5420");
var V2InitializeContainer_1 = require("d4ae3226366e1f7e");
var EvaluationStore = /*#__PURE__*/ function() {
    function EvaluationStore(_sdkKey) {
        (0, _classCallCheck._)(this, EvaluationStore);
        this._sdkKey = _sdkKey;
        this._rawValues = null;
        this._values = null;
        this._source = 'Uninitialized';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings = new Set();
    }
    (0, _createClass._)(EvaluationStore, [
        {
            key: "reset",
            value: function reset() {
                this._values = null;
                this._rawValues = null;
                this._source = 'Loading';
                this._lcut = 0;
                this._receivedAt = 0;
                this._bootstrapMetadata = null;
                this._warnings.clear();
            }
        },
        {
            key: "finalize",
            value: function finalize() {
                if (this._values) return;
                this._source = 'NoValues';
            }
        },
        {
            key: "getValues",
            value: function getValues() {
                return this._rawValues ? (0, client_core_1._typedJsonParse)(this._rawValues, 'has_updates', 'EvaluationStoreValues') : null;
            }
        },
        {
            key: "setValues",
            value: function setValues(result, user) {
                var _a, _b;
                if (!result) return false;
                var values = (0, client_core_1._typedJsonParse)(result.data, 'has_updates', 'EvaluationResponse');
                if (values == null) return false;
                this._source = result.source;
                if ((values === null || values === void 0 ? void 0 : values.has_updates) !== true) return true;
                var updatedLcut = (_a = values.time) !== null && _a !== void 0 ? _a : 0;
                if (updatedLcut < this._lcut) return true;
                this._rawValues = result.data;
                this._lcut = values.time;
                this._receivedAt = result.receivedAt;
                if (values.response_format === 'init-v2') this._values = new V2InitializeContainer_1.V2InitializeContainer(values);
                else this._values = new V1InitializeContainer_1.V1InitializeContainer(values);
                this._bootstrapMetadata = this._extractBootstrapMetadata(result.source, values);
                if (result.source && values.user) this._setWarningState(user, values);
                client_core_1.SDKFlags.setFlags(this._sdkKey, (_b = values.sdk_flags) !== null && _b !== void 0 ? _b : {});
                return true;
            }
        },
        {
            key: "getWarnings",
            value: function getWarnings() {
                if (this._warnings.size === 0) return undefined;
                return Array.from(this._warnings);
            }
        },
        {
            key: "getGate",
            value: function getGate(name) {
                var res = this._values ? this._values.getGate(name) : null;
                return this._getDetailedStoreResult(res);
            }
        },
        {
            key: "getConfig",
            value: function getConfig(name) {
                var res = this._values ? this._values.getConfig(name) : null;
                return this._getDetailedStoreResult(res);
            }
        },
        {
            key: "getConfigList",
            value: function getConfigList() {
                if (!this._values) return [];
                return this._values.getConfigList();
            }
        },
        {
            key: "getLayer",
            value: function getLayer(name) {
                var res = this._values ? this._values.getLayer(name) : null;
                return this._getDetailedStoreResult(res);
            }
        },
        {
            key: "getParamStore",
            value: function getParamStore(name) {
                var res = this._values ? this._values.getParamStore(name) : null;
                return this._getDetailedStoreResult(res);
            }
        },
        {
            key: "getSource",
            value: function getSource() {
                return this._source;
            }
        },
        {
            key: "getExposureMapping",
            value: function getExposureMapping() {
                var _a;
                return (_a = this._values) === null || _a === void 0 ? void 0 : _a.getExposureMapping();
            }
        },
        {
            key: "_extractBootstrapMetadata",
            value: function _extractBootstrapMetadata(source, values) {
                if (source !== 'Bootstrap') return null;
                var bootstrapMetadata = {};
                if (values.user) bootstrapMetadata.user = values.user;
                if (values.sdkInfo) bootstrapMetadata.generatorSDKInfo = values.sdkInfo;
                bootstrapMetadata.lcut = values.time;
                return bootstrapMetadata;
            }
        },
        {
            key: "_getDetailedStoreResult",
            value: function _getDetailedStoreResult(result) {
                return {
                    result: result,
                    details: this._getDetails(result == null)
                };
            }
        },
        {
            key: "_setWarningState",
            value: function _setWarningState(user, values) {
                var _a, _b;
                var stableID = client_core_1.StableID.get(this._sdkKey);
                if (((_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID) !== stableID && // don't throw if they're both undefined
                (((_b = user.customIDs) === null || _b === void 0 ? void 0 : _b.stableID) || stableID)) {
                    this._warnings.add('StableIDMismatch');
                    return;
                }
                if ('user' in values) {
                    var bootstrapUser = values['user'];
                    var userForComparison = Object.assign(Object.assign({}, user), {
                        analyticsOnlyMetadata: undefined,
                        privateAttributes: undefined
                    });
                    if ((0, client_core_1._getFullUserHash)(userForComparison) !== (0, client_core_1._getFullUserHash)(bootstrapUser)) this._warnings.add('PartialUserMatch');
                }
            }
        },
        {
            key: "getCurrentSourceDetails",
            value: function getCurrentSourceDetails() {
                if (this._source === 'Uninitialized' || this._source === 'NoValues') return {
                    reason: this._source
                };
                var sourceDetails = {
                    reason: this._source,
                    lcut: this._lcut,
                    receivedAt: this._receivedAt
                };
                if (this._warnings.size > 0) sourceDetails.warnings = Array.from(this._warnings);
                return sourceDetails;
            }
        },
        {
            key: "_getDetails",
            value: function _getDetails(isUnrecognized) {
                var _a, _b;
                var sourceDetails = this.getCurrentSourceDetails();
                var reason = sourceDetails.reason;
                var warnings = (_a = sourceDetails.warnings) !== null && _a !== void 0 ? _a : [];
                if (this._source === 'Bootstrap' && warnings.length > 0) reason = reason + warnings[0];
                if (reason !== 'Uninitialized' && reason !== 'NoValues') {
                    var subreason = isUnrecognized ? 'Unrecognized' : 'Recognized';
                    reason = "".concat(reason, ":").concat(subreason);
                }
                var bootstrapMetadata = this._source === 'Bootstrap' ? (_b = this._bootstrapMetadata) !== null && _b !== void 0 ? _b : undefined : undefined;
                if (bootstrapMetadata) sourceDetails.bootstrapMetadata = bootstrapMetadata;
                return Object.assign(Object.assign({}, sourceDetails), {
                    reason: reason
                });
            }
        }
    ]);
    return EvaluationStore;
}();
exports.default = EvaluationStore;

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","63e41baa1d8d3d48":"1MCdW","73b4423abedd5420":"wnw8e","d4ae3226366e1f7e":"2hGBJ"}],"wnw8e":[function(require,module,exports,__globalThis) {
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.V1InitializeContainer = void 0;
var client_core_1 = require("9358090b69acd161");
var V1InitializeContainer = /*#__PURE__*/ function() {
    function V1InitializeContainer(_values) {
        (0, _classCallCheck._)(this, V1InitializeContainer);
        this._values = _values;
    }
    (0, _createClass._)(V1InitializeContainer, [
        {
            key: "getGate",
            value: function getGate(name) {
                return this._getResultFromLookup(this._values.feature_gates, name);
            }
        },
        {
            key: "getConfig",
            value: function getConfig(name) {
                return this._getResultFromLookup(this._values.dynamic_configs, name);
            }
        },
        {
            key: "getLayer",
            value: function getLayer(name) {
                return this._getResultFromLookup(this._values.layer_configs, name);
            }
        },
        {
            key: "getParamStore",
            value: function getParamStore(name) {
                return this._getResultFromLookup(this._values.param_stores, name);
            }
        },
        {
            key: "getConfigList",
            value: function getConfigList() {
                return Object.keys(this._values.dynamic_configs);
            }
        },
        {
            key: "getExposureMapping",
            value: function getExposureMapping() {
                return this._values.exposures;
            }
        },
        {
            key: "_getResultFromLookup",
            value: function _getResultFromLookup(lookup, name) {
                var _a, _b;
                if (!lookup) return null;
                return (_b = (_a = lookup[name]) !== null && _a !== void 0 ? _a : lookup[(0, client_core_1._DJB2)(name)]) !== null && _b !== void 0 ? _b : null;
            }
        }
    ]);
    return V1InitializeContainer;
}();
exports.V1InitializeContainer = V1InitializeContainer;

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","9358090b69acd161":"1MCdW"}],"2hGBJ":[function(require,module,exports,__globalThis) {
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.V2InitializeContainer = void 0;
var client_core_1 = require("45a23e44314f17fb");
var V2InitializeContainer = /*#__PURE__*/ function() {
    function V2InitializeContainer(_values) {
        (0, _classCallCheck._)(this, V2InitializeContainer);
        this._values = _values;
    }
    (0, _createClass._)(V2InitializeContainer, [
        {
            key: "getGate",
            value: function getGate(name) {
                var _a, _b, _c;
                var evalV2 = this._getResultFromLookup(this._values.feature_gates, name);
                if (!evalV2) return null;
                return {
                    name: name,
                    value: evalV2.v === true,
                    rule_id: (_a = evalV2.r) !== null && _a !== void 0 ? _a : 'default',
                    secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
                    id_type: (_c = evalV2.i) !== null && _c !== void 0 ? _c : ''
                };
            }
        },
        {
            key: "getConfig",
            value: function getConfig(name) {
                var _a, _b, _c, _d;
                var evalV2 = this._getResultFromLookup(this._values.dynamic_configs, name);
                if (!evalV2) return null;
                return {
                    name: name,
                    value: (_a = this._values.values[evalV2.v]) !== null && _a !== void 0 ? _a : {},
                    rule_id: evalV2.r,
                    secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
                    id_type: (_c = evalV2.i) !== null && _c !== void 0 ? _c : '',
                    is_user_in_experiment: evalV2.ue === true ? true : false,
                    passed: evalV2.p === true,
                    group_name: (_d = evalV2.gn) !== null && _d !== void 0 ? _d : undefined,
                    is_experiment_active: evalV2.ea === true ? true : false,
                    group: evalV2.r,
                    is_device_based: evalV2.i === 'stableID'
                };
            }
        },
        {
            key: "getLayer",
            value: function getLayer(name) {
                var _a, _b, _c, _d, _e, _f;
                var evalV2 = this._getResultFromLookup(this._values.layer_configs, name);
                if (!evalV2) return null;
                return {
                    name: name,
                    value: (_a = this._values.values[evalV2.v]) !== null && _a !== void 0 ? _a : {},
                    rule_id: evalV2.r,
                    secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
                    is_user_in_experiment: evalV2.ue === true ? true : false,
                    group_name: (_c = evalV2.gn) !== null && _c !== void 0 ? _c : undefined,
                    is_experiment_active: evalV2.ea === true ? true : false,
                    group: evalV2.r,
                    is_device_based: evalV2.i === 'stableID',
                    allocated_experiment_name: (_d = evalV2.ae) !== null && _d !== void 0 ? _d : '',
                    explicit_parameters: (_e = evalV2.ep) !== null && _e !== void 0 ? _e : [],
                    undelegated_secondary_exposures: (_f = evalV2.us) !== null && _f !== void 0 ? _f : [],
                    parameter_rule_ids: evalV2.pr
                };
            }
        },
        {
            key: "getParamStore",
            value: function getParamStore(name) {
                return this._getResultFromLookup(this._values.param_stores, name);
            }
        },
        {
            key: "getConfigList",
            value: function getConfigList() {
                return Object.keys(this._values.dynamic_configs);
            }
        },
        {
            key: "getExposureMapping",
            value: function getExposureMapping() {
                return this._values.exposures;
            }
        },
        {
            key: "_getResultFromLookup",
            value: function _getResultFromLookup(lookup, name) {
                var _a, _b;
                if (!lookup) return null;
                return (_b = (_a = lookup[name]) !== null && _a !== void 0 ? _a : lookup[(0, client_core_1._DJB2)(name)]) !== null && _b !== void 0 ? _b : null;
            }
        }
    ]);
    return V2InitializeContainer;
}();
exports.V2InitializeContainer = V2InitializeContainer;

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","45a23e44314f17fb":"1MCdW"}],"lW7K0":[function(require,module,exports,__globalThis) {
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
"use strict";
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return (0, _instanceof._)(value, P) ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
var client_core_1 = require("4962556b5b13a79f");
var EvaluationResponseDeltas_1 = require("7188ad6bd81811a6");
var StatsigNetwork = /*#__PURE__*/ function(_client_core_1_NetworkCore) {
    (0, _inherits._)(StatsigNetwork, _client_core_1_NetworkCore);
    function StatsigNetwork(options, emitter) {
        (0, _classCallCheck._)(this, StatsigNetwork);
        var _this;
        _this = (0, _callSuper._)(this, StatsigNetwork, [
            options,
            emitter
        ]);
        var config = options === null || options === void 0 ? void 0 : options.networkConfig;
        _this._option = options;
        _this._initializeUrlConfig = new client_core_1.UrlConfiguration(client_core_1.Endpoint._initialize, config === null || config === void 0 ? void 0 : config.initializeUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.initializeFallbackUrls);
        return _this;
    }
    (0, _createClass._)(StatsigNetwork, [
        {
            key: "fetchEvaluations",
            value: function fetchEvaluations(sdkKey, current, priority, user, isCacheValidFor204) {
                return __awaiter(this, void 0, void 0, function() {
                    var _a, _b, _c, _d, _e, _f, cache, data, hasHashChanged;
                    return (0, _tsGenerator._)(this, function(_state) {
                        cache = current ? (0, client_core_1._typedJsonParse)(current, 'has_updates', 'InitializeResponse') : null;
                        data = {
                            user: user,
                            hash: (_c = (_b = (_a = this._option) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.initializeHashAlgorithm) !== null && _c !== void 0 ? _c : 'djb2',
                            deltasResponseRequested: false,
                            full_checksum: null
                        };
                        if (cache === null || cache === void 0 ? void 0 : cache.has_updates) {
                            hasHashChanged = (cache === null || cache === void 0 ? void 0 : cache.hash_used) !== ((_f = (_e = (_d = this._option) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.initializeHashAlgorithm) !== null && _f !== void 0 ? _f : 'djb2');
                            data = Object.assign(Object.assign({}, data), {
                                sinceTime: isCacheValidFor204 && !hasHashChanged ? cache.time : 0,
                                previousDerivedFields: 'derived_fields' in cache && isCacheValidFor204 ? cache.derived_fields : {},
                                deltasResponseRequested: true,
                                full_checksum: cache.full_checksum,
                                partialUserMatchSinceTime: !hasHashChanged ? cache.time : 0
                            });
                        }
                        return [
                            2,
                            this._fetchEvaluations(sdkKey, cache, data, priority)
                        ];
                    });
                });
            }
        },
        {
            key: "_fetchEvaluations",
            value: function _fetchEvaluations(sdkKey, cache, data, priority) {
                return __awaiter(this, void 0, void 0, function() {
                    var _a, _b, response, result;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.post({
                                        sdkKey: sdkKey,
                                        urlConfig: this._initializeUrlConfig,
                                        data: data,
                                        retries: 2,
                                        isStatsigEncodable: true,
                                        priority: priority
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                if ((response === null || response === void 0 ? void 0 : response.code) === 204) return [
                                    2,
                                    '{"has_updates": false}'
                                ];
                                if ((response === null || response === void 0 ? void 0 : response.code) !== 200) return [
                                    2,
                                    (_a = response === null || response === void 0 ? void 0 : response.body) !== null && _a !== void 0 ? _a : null
                                ];
                                if ((cache === null || cache === void 0 ? void 0 : cache.has_updates) !== true || ((_b = response.body) === null || _b === void 0 ? void 0 : _b.includes('"is_delta":true')) !== true || data.deltasResponseRequested !== true) return [
                                    2,
                                    response.body
                                ];
                                result = (0, EvaluationResponseDeltas_1._resolveDeltasResponse)(cache, response.body);
                                if (typeof result === 'string') return [
                                    2,
                                    result
                                ];
                                // retry without deltas
                                return [
                                    2,
                                    this._fetchEvaluations(sdkKey, cache, Object.assign(Object.assign(Object.assign({}, data), result), {
                                        deltasResponseRequested: false
                                    }), priority)
                                ];
                        }
                    });
                });
            }
        }
    ]);
    return StatsigNetwork;
}(client_core_1.NetworkCore);
exports.default = StatsigNetwork;

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_inherits":"2sfqW","@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_ts_generator":"78Tqx","4962556b5b13a79f":"1MCdW","7188ad6bd81811a6":"j8k79"}],"j8k79":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports._resolveDeltasResponse = void 0;
var client_core_1 = require("533eb7177f91f531");
var MAX_DELTAS_SORT_DEPTH = 2;
function _resolveDeltasResponse(cache, deltasString) {
    var deltas = (0, client_core_1._typedJsonParse)(deltasString, 'checksum', 'DeltasEvaluationResponse');
    if (!deltas) return {
        hadBadDeltaChecksum: true
    };
    var merged = _mergeDeltasIntoCache(cache, deltas);
    var resolved = _handleDeletedEntries(merged);
    var actualChecksum = (0, client_core_1._DJB2Object)({
        feature_gates: resolved.feature_gates,
        dynamic_configs: resolved.dynamic_configs,
        layer_configs: resolved.layer_configs
    }, MAX_DELTAS_SORT_DEPTH);
    var isMatch = actualChecksum === deltas.checksumV2;
    if (!isMatch) return {
        hadBadDeltaChecksum: true,
        badChecksum: actualChecksum,
        badMergedConfigs: resolved,
        badFullResponse: deltas.deltas_full_response
    };
    return JSON.stringify(resolved);
}
exports._resolveDeltasResponse = _resolveDeltasResponse;
function _mergeDeltasIntoCache(cache, deltas) {
    return Object.assign(Object.assign(Object.assign({}, cache), deltas), {
        feature_gates: Object.assign(Object.assign({}, cache.feature_gates), deltas.feature_gates),
        layer_configs: Object.assign(Object.assign({}, cache.layer_configs), deltas.layer_configs),
        dynamic_configs: Object.assign(Object.assign({}, cache.dynamic_configs), deltas.dynamic_configs)
    });
}
function _handleDeletedEntries(deltas) {
    var result = deltas;
    _deleteEntriesInRecord(deltas.deleted_gates, result.feature_gates);
    delete result.deleted_gates;
    _deleteEntriesInRecord(deltas.deleted_configs, result.dynamic_configs);
    delete result.deleted_configs;
    _deleteEntriesInRecord(deltas.deleted_layers, result.layer_configs);
    delete result.deleted_layers;
    return result;
}
function _deleteEntriesInRecord(keys, values) {
    keys === null || keys === void 0 || keys.forEach(function(key) {
        delete values[key];
    });
}

},{"533eb7177f91f531":"1MCdW"}],"fCorX":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports._makeParamStoreGetter = void 0;
var client_core_1 = require("fa6092abf73a0804");
var NO_EXPOSURE_OPT = {
    disableExposureLog: true
};
function _shouldLogExposure(options) {
    return options == null || options.disableExposureLog === false;
}
function _shouldReturnFallback(value, fallback) {
    return fallback != null && !(0, client_core_1._isTypeMatch)(value, fallback);
}
function _getMappedStaticValue(param, _options) {
    return param.value;
}
function _getMappedGateValue(client, param, options) {
    var gate = client.getFeatureGate(param.gate_name, _shouldLogExposure(options) ? undefined : NO_EXPOSURE_OPT);
    if (gate.value) return param.pass_value;
    return param.fail_value;
}
function _getMappedDynamicConfigValue(client, param, fallback, options) {
    var config = client.getDynamicConfig(param.config_name, _shouldLogExposure(options) ? undefined : NO_EXPOSURE_OPT);
    var value = config.get(param.param_name);
    if (_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function _getMappedExperimentValue(client, param, fallback, options) {
    var experiment = client.getExperiment(param.experiment_name, _shouldLogExposure(options) ? undefined : NO_EXPOSURE_OPT);
    var value = experiment.get(param.param_name);
    if (_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function _getMappedLayerValue(client, param, fallback, options) {
    var layer = client.getLayer(param.layer_name, _shouldLogExposure(options) ? undefined : NO_EXPOSURE_OPT);
    var value = layer.get(param.param_name);
    if (_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function _makeParamStoreGetter(client, config, options) {
    return function(paramName, fallback) {
        if (config == null) return fallback;
        var param = config[paramName];
        if (param == null || fallback != null && (0, client_core_1._typeOf)(fallback) !== param.param_type) return fallback;
        switch(param.ref_type){
            case 'static':
                return _getMappedStaticValue(param, options);
            case 'gate':
                return _getMappedGateValue(client, param, options);
            case 'dynamic_config':
                return _getMappedDynamicConfigValue(client, param, fallback, options);
            case 'experiment':
                return _getMappedExperimentValue(client, param, fallback, options);
            case 'layer':
                return _getMappedLayerValue(client, param, fallback, options);
            default:
                return fallback;
        }
    };
}
exports._makeParamStoreGetter = _makeParamStoreGetter;

},{"fa6092abf73a0804":"1MCdW"}],"3ffDQ":[function(require,module,exports,__globalThis) {
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _get = require("@swc/helpers/_/_get");
var _getPrototypeOf = require("@swc/helpers/_/_get_prototype_of");
var _inherits = require("@swc/helpers/_/_inherits");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
"use strict";
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return (0, _instanceof._)(value, P) ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.StatsigEvaluationsDataAdapter = void 0;
var client_core_1 = require("af59f117077ccbb8");
var Network_1 = require("e2b0d15ace3c0be3");
var StatsigEvaluationsDataAdapter = /*#__PURE__*/ function(_client_core_1_DataAdapterCore) {
    (0, _inherits._)(StatsigEvaluationsDataAdapter, _client_core_1_DataAdapterCore);
    function StatsigEvaluationsDataAdapter() {
        (0, _classCallCheck._)(this, StatsigEvaluationsDataAdapter);
        var _this;
        _this = (0, _callSuper._)(this, StatsigEvaluationsDataAdapter, [
            'EvaluationsDataAdapter',
            'evaluations'
        ]);
        _this._network = null;
        _this._options = null;
        return _this;
    }
    (0, _createClass._)(StatsigEvaluationsDataAdapter, [
        {
            key: "attach",
            value: function attach(sdkKey, options, network) {
                (0, _get._)((0, _getPrototypeOf._)(StatsigEvaluationsDataAdapter.prototype), "attach", this).call(this, sdkKey, options, network);
                if (network !== null && (0, _instanceof._)(network, Network_1.default)) this._network = network;
                else this._network = new Network_1.default(options !== null && options !== void 0 ? options : {});
            }
        },
        {
            key: "getDataAsync",
            value: function getDataAsync(current, user, options) {
                return this._getDataAsyncImpl(current, (0, client_core_1._normalizeUser)(user, this._options), options);
            }
        },
        {
            key: "prefetchData",
            value: function prefetchData(user, options) {
                return this._prefetchDataImpl(user, options);
            }
        },
        {
            key: "setData",
            value: function setData(data) {
                var values = (0, client_core_1._typedJsonParse)(data, 'has_updates', 'data');
                if (values && 'user' in values) (0, _get._)((0, _getPrototypeOf._)(StatsigEvaluationsDataAdapter.prototype), "setData", this).call(this, data, values.user);
                else client_core_1.Log.error('StatsigUser not found. You may be using an older server SDK version. Please upgrade your SDK or use setDataLegacy.');
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                (0, _get._)((0, _getPrototypeOf._)(StatsigEvaluationsDataAdapter.prototype), "setData", this).call(this, data, user);
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function _fetchFromNetwork(current, user, options, isCacheValidFor204) {
                return __awaiter(this, void 0, void 0, function() {
                    var _a, result;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (_a = this._network) === null || _a === void 0 ? void 0 : _a.fetchEvaluations(this._getSdkKey(), current, options === null || options === void 0 ? void 0 : options.priority, user, isCacheValidFor204)
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result !== null && result !== void 0 ? result : null
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                var _a;
                var key = (0, client_core_1._getStorageKey)(this._getSdkKey(), user, (_a = this._options) === null || _a === void 0 ? void 0 : _a.customUserCacheKeyFunc);
                return "".concat(client_core_1.DataAdapterCachePrefix, ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(result, user) {
                return result.fullUserHash != null && result.fullUserHash === (0, client_core_1._getFullUserHash)(user);
            }
        }
    ]);
    return StatsigEvaluationsDataAdapter;
}(client_core_1.DataAdapterCore);
exports.StatsigEvaluationsDataAdapter = StatsigEvaluationsDataAdapter;

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_get":"38TLD","@swc/helpers/_/_get_prototype_of":"5txK6","@swc/helpers/_/_inherits":"2sfqW","@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_ts_generator":"78Tqx","af59f117077ccbb8":"1MCdW","e2b0d15ace3c0be3":"lW7K0"}],"38TLD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _get;
});
var _superPropBaseJs = require("./_super_prop_base.js");
function _get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) _get = Reflect.get;
    else _get = function get(target, property, receiver) {
        var base = (0, _superPropBaseJs._)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return _get(target, property, receiver || target);
}

},{"./_super_prop_base.js":"b5wpP","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"b5wpP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _super_prop_base;
});
var _getPrototypeOfJs = require("./_get_prototype_of.js");
function _super_prop_base(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, _getPrototypeOfJs._)(object);
        if (object === null) break;
    }
    return object;
}

},{"./_get_prototype_of.js":"5txK6","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jr13a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return 0, _subscriptionsDefault.default;
});
var _subscriptions = require("./Subscriptions");
var _subscriptionsDefault = parcelHelpers.interopDefault(_subscriptions);

},{"./Subscriptions":"Pycwl","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"Pycwl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ALL_FEATURE_VALUES", function() {
    return ALL_FEATURE_VALUES;
});
parcelHelpers.export(exports, "default", function() {
    return Subscriptions;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _eventemitter3 = require("eventemitter3");
var _eventemitter3Default = parcelHelpers.interopDefault(_eventemitter3);
var ALL_FEATURE_VALUES = '@all-features';
var Subscriptions = /*#__PURE__*/ function() {
    "use strict";
    function Subscriptions() {
        (0, _classCallCheck._)(this, Subscriptions);
        this.eventToValue = new Map();
        this.emitter = new (0, _eventemitter3Default.default)();
    }
    (0, _createClass._)(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, (0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function() {
                    var value = checkGate(gateName, (0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, (0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, (0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this = this;
                this.emitter.on(ALL_FEATURE_VALUES, callback);
                return function() {
                    _this.emitter.off(ALL_FEATURE_VALUES, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this = this;
                this.emitter.emit(ALL_FEATURE_VALUES);
                this.emitter.eventNames().filter(function(name) {
                    return name !== ALL_FEATURE_VALUES;
                }).forEach(function(event) {
                    _this.emitter.emit(event);
                });
            }
        }
    ]);
    return Subscriptions;
}();

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","eventemitter3":"cVv4h","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cVv4h":[function(require,module,exports,__globalThis) {
'use strict';
var has = Object.prototype.hasOwnProperty, prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new Events().__proto__) prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new EE(fn, context || emitter, once), evt = prefix ? prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function EventEmitter() {
    this._events = new Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ EventEmitter.prototype.listeners = function listeners(event) {
    var evt = prefix ? prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = prefix ? prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = prefix ? prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.on = function on(event, fn, context) {
    return addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.once = function once(event, fn, context) {
    return addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = prefix ? prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = prefix ? prefix + event : event;
        if (this._events[evt]) clearEvent(this, evt);
    } else {
        this._events = new Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;
//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;
module.exports = EventEmitter;

},{}],"6MRpM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DynamicConfig", function() {
    return DynamicConfig;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _typeOf = require("@swc/helpers/_/_type_of");
var _utils = require("../utils");
var DynamicConfig = /*#__PURE__*/ function() {
    "use strict";
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [], allocatedExperimentName = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : '', onDefaultValueFallback = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null;
        (0, _classCallCheck._)(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    (0, _createClass._)(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this__onDefaultValueFallback, _this;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : typeof defaultValue === "undefined" ? "undefined" : (0, _typeOf._)(defaultValue);
                var actualType = Array.isArray(val) ? 'array' : typeof val === "undefined" ? "undefined" : (0, _typeOf._)(val);
                if (typeGuard) {
                    var _this__onDefaultValueFallback1, _this1;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this__onDefaultValueFallback1 = (_this1 = this)._onDefaultValueFallback) === null || _this__onDefaultValueFallback1 === void 0 ? void 0 : _this__onDefaultValueFallback1.call(_this1, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this__onDefaultValueFallback = (_this = this)._onDefaultValueFallback) === null || _this__onDefaultValueFallback === void 0 ? void 0 : _this__onDefaultValueFallback.call(_this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment___evaluation;
                var _experiment___evaluation_secondary_exposures, _experiment_groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, _utils.migrateEvaluationDetails)(experiment.details), (0, _utils.migrateSecondaryExposures)((_experiment___evaluation_secondary_exposures = (_experiment___evaluation = experiment.__evaluation) === null || _experiment___evaluation === void 0 ? void 0 : _experiment___evaluation.secondary_exposures) !== null && _experiment___evaluation_secondary_exposures !== void 0 ? _experiment___evaluation_secondary_exposures : []), (_experiment_groupName = experiment.groupName) !== null && _experiment_groupName !== void 0 ? _experiment_groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
    return DynamicConfig;
}();

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_type_of":"iFJdx","../utils":"dCYmQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dCYmQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOptionsWithDefaults", function() {
    return getOptionsWithDefaults;
});
parcelHelpers.export(exports, "shallowEquals", function() {
    return shallowEquals;
});
parcelHelpers.export(exports, "toStatsigUser", function() {
    return toStatsigUser;
});
parcelHelpers.export(exports, "deepAssign", function() {
    return deepAssign;
});
parcelHelpers.export(exports, "migrateInitializationOptions", function() {
    return migrateInitializationOptions;
});
parcelHelpers.export(exports, "migrateEvaluationDetails", function() {
    return migrateEvaluationDetails;
});
parcelHelpers.export(exports, "migrateSecondaryExposures", function() {
    return migrateSecondaryExposures;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var _atlassianContext = require("@atlaskit/atlassian-context");
var _types = require("./compat/types");
var _types1 = require("./types");
var getOptionsWithDefaults = function(options) {
    return (0, _objectSpread._)({
        /**
	 * If more federal PerimeterTypes are added in the future, this should be updated so
	 * that isFedRamp() === true always returns the strictest perimeter.
	 */ perimeter: (0, _atlassianContext.isFedRamp)() ? (0, _types1.PerimeterType).FEDRAMP_MODERATE : (0, _types1.PerimeterType).COMMERCIAL
    }, options);
};
var shallowEquals = function(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function(param, param1) {
        var _param = (0, _slicedToArray._)(param, 1), key1 = _param[0], _param1 = (0, _slicedToArray._)(param1, 1), key2 = _param1[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries_i = (0, _slicedToArray._)(aEntries[i], 2), aValue = _aEntries_i[1];
        var _bEntries_i = (0, _slicedToArray._)(bEntries[i], 2), bValue = _bEntries_i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};
var toStatsigUser = function(identifiers, customAttributes) {
    var user = {
        customIDs: identifiers,
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
function deepAssign(target) {
    for(var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        sources[_key - 1] = arguments[_key];
    }
    if (!sources.length) return target;
    var source = sources.shift();
    if (source === undefined || source === null) return deepAssign.apply(void 0, [
        target
    ].concat((0, _toConsumableArray._)(sources)));
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(source)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, _slicedToArray._)(_step.value, 2), key = _step_value[0], src = _step_value[1];
            var dst = target[key];
            var srcIsObj = src && (typeof src === "undefined" ? "undefined" : (0, _typeOf._)(src)) === 'object' && !Array.isArray(src);
            var dstIsObj = dst && (typeof dst === "undefined" ? "undefined" : (0, _typeOf._)(dst)) === 'object' && !Array.isArray(dst);
            if (srcIsObj && dstIsObj) target[key] = deepAssign(dst, src);
            else target[key] = src;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return deepAssign.apply(void 0, [
        target
    ].concat((0, _toConsumableArray._)(sources)));
}
var migrateInitializationOptions = function(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, // No equivalent but is pointless anyway since our Statsig init is synchronous
    _initTimeoutMs = options.initTimeoutMs, // No equivalent in new client but probably not important?
    _disableNetworkKeepalive = options.disableNetworkKeepalive, // Needs to be implemented manually but unused according to zoekt
    _overrideStableID = options.overrideStableID, // No equivalent for these but can't see them actually used anywhere in old client?
    _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, _objectWithoutProperties._)(options, [
        "api",
        "disableCurrentPageLogging",
        "loggingIntervalMillis",
        "loggingBufferMaxSize",
        "localMode",
        "eventLoggingApi",
        "eventLoggingApiForRetries",
        "disableLocalStorage",
        "ignoreWindowUndefined",
        "disableAllLogging",
        "initTimeoutMs",
        "disableNetworkKeepalive",
        "overrideStableID",
        "disableErrorLogging",
        "disableAutoMetricsLogging"
    ]);
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, rest), {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};
var evaluationReasonMappings = Object.entries((0, _types.EvaluationReason)).map(function(param) {
    var _param = (0, _slicedToArray._)(param, 2), key = _param[0], value = _param[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var migrateEvaluationDetails = function(details) {
    var _evaluationReasonMappings_find;
    var reasonLower = details.reason.toLowerCase();
    var _evaluationReasonMappings_find_, _details_receivedAt;
    return {
        reason: (_evaluationReasonMappings_find_ = (_evaluationReasonMappings_find = evaluationReasonMappings.find(function(param) {
            var _param = (0, _slicedToArray._)(param, 1), key = _param[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMappings_find === void 0 ? void 0 : _evaluationReasonMappings_find[1]) !== null && _evaluationReasonMappings_find_ !== void 0 ? _evaluationReasonMappings_find_ : (0, _types.EvaluationReason).Unknown,
        time: (_details_receivedAt = details.receivedAt) !== null && _details_receivedAt !== void 0 ? _details_receivedAt : Date.now()
    };
};
var migrateSecondaryExposures = function(secondaryExposures) {
    return secondaryExposures.map(function(exposure) {
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_to_consumable_array":"1eSZf","@swc/helpers/_/_type_of":"iFJdx","@atlaskit/atlassian-context":"82Y9X","./compat/types":"cakyv","./types":"cETze","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"82Y9X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isFedRamp", function() {
    return 0, _isFedramp.isFedRamp;
});
parcelHelpers.export(exports, "getATLContextUrl", function() {
    return 0, _domainLookup.getATLContextUrl;
});
parcelHelpers.export(exports, "getATLContextDomain", function() {
    return 0, _domainLookup.getATLContextDomain;
});
parcelHelpers.export(exports, "isFedrampModerate", function() {
    return 0, _perimeter.isFedrampModerate;
});
parcelHelpers.export(exports, "isIsolatedCloud", function() {
    return 0, _perimeter.isIsolatedCloud;
});
parcelHelpers.export(exports, "isolatedCloudDomain", function() {
    return 0, _perimeter.isolatedCloudDomain;
});
parcelHelpers.export(exports, "isolationContextId", function() {
    return 0, _perimeter.isolationContextId;
});
parcelHelpers.export(exports, "getDomainInContext", function() {
    return 0, _generalizedDomainLookup.getDomainInContext;
});
parcelHelpers.export(exports, "getUrlForDomainInContext", function() {
    return 0, _generalizedDomainLookup.getUrlForDomainInContext;
});
var _isFedramp = require("./services/host-based-lookup/is-fedramp");
var _domainLookup = require("./services/host-based-lookup/domain-lookup");
var _perimeter = require("./services/perimeter");
var _generalizedDomainLookup = require("./services/generalized-domain-lookup");

},{"./services/host-based-lookup/is-fedramp":"4Bxvo","./services/host-based-lookup/domain-lookup":"77w8l","./services/perimeter":"dicLt","./services/generalized-domain-lookup":"dmAO7","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4Bxvo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Caution: Consider Alternatives Use of this function is not recommended as a long term solution, as it creates an assumption
 * there are no other isolated environments than just FedRAMP Moderate. You are encouraged to consider alternate solutions,
 * such as Statsig or environment configuration, that don't require creating a hard dependency between your code features
 * and the FedRAMP environment.
 * See [go-is-fedramp](https://go.atlassian.com/is-fedramp)
 */ parcelHelpers.export(exports, "isFedRamp", function() {
    return isFedRamp;
});
var _constants = require("../../../common/constants/host-based-lookup/constants");
function isFedRamp() {
    var _global_location_hostname, _global_location;
    var global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    var env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, _constants.FEDRAMP_MODERATE);
    var matches = (_global_location = global.location) === null || _global_location === void 0 ? void 0 : (_global_location_hostname = _global_location.hostname) === null || _global_location_hostname === void 0 ? void 0 : _global_location_hostname.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

},{"../../../common/constants/host-based-lookup/constants":"9O8N4","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9O8N4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FEDRAMP_MODERATE", function() {
    return FEDRAMP_MODERATE;
});
parcelHelpers.export(exports, "COMMERCIAL", function() {
    return COMMERCIAL;
});
parcelHelpers.export(exports, "FEDRAMP_FEDEX", function() {
    return FEDRAMP_FEDEX;
});
parcelHelpers.export(exports, "STAGING", function() {
    return STAGING;
});
parcelHelpers.export(exports, "PRODUCTION", function() {
    return PRODUCTION;
});
parcelHelpers.export(exports, "DEV", function() {
    return DEV;
});
var FEDRAMP_MODERATE = 'fedramp-moderate';
var COMMERCIAL = 'commercial';
var FEDRAMP_FEDEX = 'fedramp-fedex';
var STAGING = 'stg';
var PRODUCTION = 'prod';
var DEV = 'dev';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"77w8l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "configure", function() {
    return configure;
});
parcelHelpers.export(exports, "getATLContextDomain", function() {
    return getATLContextDomain;
});
parcelHelpers.export(exports, "getATLContextUrl", function() {
    return getATLContextUrl;
});
parcelHelpers.export(exports, "_getEnvironmentFromDomain", function() {
    return _getEnvironmentFromDomain;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _constants = require("../../../common/constants/host-based-lookup/constants");
var _domains = require("../../../common/constants/host-based-lookup/constants/domains");
var _types = require("../../../common/constants/host-based-lookup/types");
function configure(data) {
    if (!data || Object.keys(data).length < 1) throw new Error('Data are not available');
    // @ts-ignore - This is causing ts errors when this package is being enrolled into jira local consumption so temporarily ts ignoring this line for now
    globalThis.ATL_CONTEXT_DOMAIN = data;
}
function isValidDomainKey(domainKey) {
    if (!(0, _types.AllowedDomains).includes(domainKey)) return false;
    return true;
}
function getATLContextDomain(domain, environment) {
    var // Exact match preferred
    _override_perimeter, _domainMap_perimeter;
    // Validate this is a valid domain
    if (!isValidDomainKey(domain)) throw new Error("Domain ".concat(domain, " is not supported.\n      Supported domains: ").concat((0, _types.AllowedDomains).join(', ')));
    // First priority, always return the global context if the product has onboarded
    // @ts-ignore - This is causing ts errors when this package is being enrolled into jira local consumption so temporarily ts ignoring this line for now
    var data = globalThis.ATL_CONTEXT_DOMAIN;
    if (data) return data[domain];
    var _ref = (0, _slicedToArray._)(environment !== null && environment !== void 0 ? environment : _getEnvironmentFromDomain(), 2), env = _ref[0], perimeter = _ref[1];
    // Second priority, return if there is a full domain override
    var override = (0, _domains.fullDomainOverride)[domain];
    var _override_perimeter_env;
    if (override) return (_override_perimeter_env = (_override_perimeter = override[perimeter]) === null || _override_perimeter === void 0 ? void 0 : _override_perimeter[env]) !== null && _override_perimeter_env !== void 0 ? _override_perimeter_env : override[0, _constants.COMMERCIAL][0, _constants.PRODUCTION] // Fallback to mandatory commercial production
    ;
    var _domainMap_perimeter_env;
    // Third priority, join the subdomain
    var tld = (_domainMap_perimeter_env = (_domainMap_perimeter = (0, _domains.domainMap)[perimeter]) === null || _domainMap_perimeter === void 0 ? void 0 : _domainMap_perimeter[env]) !== null && _domainMap_perimeter_env !== void 0 ? _domainMap_perimeter_env : (0, _domains.domainMap)[0, _constants.COMMERCIAL][0, _constants.PRODUCTION];
    var _subdomainOverride_domain;
    var subdomain = (_subdomainOverride_domain = (0, _domains.subdomainOverride)[domain]) !== null && _subdomainOverride_domain !== void 0 ? _subdomainOverride_domain : domain;
    return "".concat(subdomain, ".").concat(tld);
}
function getATLContextUrl(domain) {
    var _globalThis_location;
    var _globalThis_location_protocol;
    return "".concat((_globalThis_location_protocol = (_globalThis_location = globalThis.location) === null || _globalThis_location === void 0 ? void 0 : _globalThis_location.protocol) !== null && _globalThis_location_protocol !== void 0 ? _globalThis_location_protocol : 'https:', "//").concat(getATLContextDomain(domain));
}
function _getEnvironmentFromDomain() {
    var _globalThis_location;
    var hostname = (_globalThis_location = globalThis.location) === null || _globalThis_location === void 0 ? void 0 : _globalThis_location.hostname;
    if (!hostname) // default if no location available
    return [
        (0, _constants.PRODUCTION),
        (0, _constants.COMMERCIAL)
    ];
    // *.atlassian-fex.com
    if (hostname.match(/atlassian-fex\.com/)) return [
        (0, _constants.STAGING),
        (0, _constants.FEDRAMP_FEDEX)
    ];
    // *.stg.atlassian-us-gov-mod.com OR *.stg.atlassian-us-gov-mod.net
    if (hostname.match(/stg\.atlassian-us-gov-mod\.(com|net)/)) return [
        (0, _constants.STAGING),
        (0, _constants.FEDRAMP_MODERATE)
    ];
    // *.atlassian-stg-fedm.net
    if (hostname.match(/atlassian-stg-fedm\.net/)) return [
        (0, _constants.STAGING),
        (0, _constants.FEDRAMP_MODERATE)
    ];
    // *.atlassian-us-gov-mod.com OR *.atlassian-us-gov-mod.net
    if (hostname.match(/atlassian-us-gov-mod\.(com|net)/)) return [
        (0, _constants.PRODUCTION),
        (0, _constants.FEDRAMP_MODERATE)
    ];
    // *.stg.atlassian.com OR *.stg.internal.atlassian.com
    if (hostname.match(/stg(\.internal)?\.atlassian\.com/)) return [
        (0, _constants.STAGING),
        (0, _constants.COMMERCIAL)
    ];
    // *.jira-dev.com
    if (hostname.match(/jira-dev\.com/)) return [
        (0, _constants.STAGING),
        (0, _constants.COMMERCIAL)
    ];
    // default fallthrough
    return [
        (0, _constants.PRODUCTION),
        (0, _constants.COMMERCIAL)
    ];
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","../../../common/constants/host-based-lookup/constants":"9O8N4","../../../common/constants/host-based-lookup/constants/domains":"7rRWV","../../../common/constants/host-based-lookup/types":"67p9i","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7rRWV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "domainMap", function() {
    return domainMap;
});
parcelHelpers.export(exports, "subdomainOverride", function() {
    return subdomainOverride;
});
parcelHelpers.export(exports, "fullDomainOverride", function() {
    return fullDomainOverride;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _index = require("./index");
var _obj, _obj1, _obj2;
var domainMap = (_obj2 = {}, (0, _defineProperty._)(_obj2, (0, _index.COMMERCIAL), (_obj = {}, (0, _defineProperty._)(_obj, (0, _index.STAGING), 'stg.atlassian.com'), (0, _defineProperty._)(_obj, (0, _index.PRODUCTION), 'atlassian.com'), _obj)), (0, _defineProperty._)(_obj2, (0, _index.FEDRAMP_FEDEX), (0, _defineProperty._)({}, (0, _index.STAGING), 'atlassian-fex.com')), (0, _defineProperty._)(_obj2, (0, _index.FEDRAMP_MODERATE), (_obj1 = {}, (0, _defineProperty._)(_obj1, (0, _index.STAGING), 'stg.atlassian-us-gov-mod.com'), (0, _defineProperty._)(_obj1, (0, _index.PRODUCTION), 'atlassian-us-gov-mod.com'), _obj1)), _obj2);
var subdomainOverride = {};
var _obj3, _obj4, _obj5, _obj6, _obj7, _obj8;
var fullDomainOverride = {
    analytics: (0, _defineProperty._)({}, (0, _index.COMMERCIAL), (0, _defineProperty._)({}, (0, _index.PRODUCTION), 'analytics.atlassian.com')),
    // Marketing site
    confluence: (0, _defineProperty._)({}, (0, _index.COMMERCIAL), (0, _defineProperty._)({}, (0, _index.PRODUCTION), 'confluence.atlassian.com')),
    // Atlassian design system documentation
    design: (0, _defineProperty._)({}, (0, _index.COMMERCIAL), (0, _defineProperty._)({}, (0, _index.PRODUCTION), 'design.atlassian.com')),
    // Old staff intranet (now hello.atlassian.net)
    extranet: (0, _defineProperty._)({}, (0, _index.COMMERCIAL), (0, _defineProperty._)({}, (0, _index.PRODUCTION), 'extranet.atlassian.com')),
    // Go links
    go: (0, _defineProperty._)({}, (0, _index.COMMERCIAL), (0, _defineProperty._)({}, (0, _index.PRODUCTION), 'go.atlassian.com')),
    my: (0, _defineProperty._)({}, (0, _index.COMMERCIAL), (0, _defineProperty._)({}, (0, _index.PRODUCTION), 'my.atlassian.com')),
    schema: (0, _defineProperty._)({}, (0, _index.COMMERCIAL), (0, _defineProperty._)({}, (0, _index.PRODUCTION), 'schema.atlassian.com')),
    start: (_obj5 = {}, (0, _defineProperty._)(_obj5, (0, _index.COMMERCIAL), (_obj3 = {}, (0, _defineProperty._)(_obj3, (0, _index.PRODUCTION), 'start.atlassian.com'), (0, _defineProperty._)(_obj3, (0, _index.STAGING), 'start.stg.atlassian.com'), _obj3)), (0, _defineProperty._)(_obj5, (0, _index.FEDRAMP_MODERATE), (_obj4 = {}, (0, _defineProperty._)(_obj4, (0, _index.PRODUCTION), 'start.atlassian-us-gov-mod.com'), (0, _defineProperty._)(_obj4, (0, _index.STAGING), 'start.stg.atlassian-us-gov-mod.com'), _obj4)), _obj5),
    surveys: (0, _defineProperty._)({}, (0, _index.COMMERCIAL), (0, _defineProperty._)({}, (0, _index.PRODUCTION), 'surveys.atlassian.com')),
    'wac-cdn': (0, _defineProperty._)({}, (0, _index.COMMERCIAL), (0, _defineProperty._)({}, (0, _index.PRODUCTION), 'wac-cdn.atlassian.com')),
    integrations: (0, _defineProperty._)({}, (0, _index.COMMERCIAL), (0, _defineProperty._)({}, (0, _index.PRODUCTION), 'integrations.atlassian.com')),
    permalink: (0, _defineProperty._)({}, (0, _index.COMMERCIAL), (0, _defineProperty._)({}, (0, _index.PRODUCTION), 'permalink.atlassian.com')),
    id: (_obj8 = {}, (0, _defineProperty._)(_obj8, (0, _index.COMMERCIAL), (_obj6 = {}, (0, _defineProperty._)(_obj6, (0, _index.PRODUCTION), 'id.atlassian.com'), (0, _defineProperty._)(_obj6, (0, _index.STAGING), 'id.stg.internal.atlassian.com'), (0, _defineProperty._)(_obj6, (0, _index.DEV), 'id.dev.internal.atlassian.com'), _obj6)), (0, _defineProperty._)(_obj8, (0, _index.FEDRAMP_MODERATE), (_obj7 = {}, (0, _defineProperty._)(_obj7, (0, _index.PRODUCTION), 'id.atlassian-us-gov-mod.com'), (0, _defineProperty._)(_obj7, (0, _index.STAGING), 'id.stg.atlassian-us-gov-mod.com'), _obj7)), _obj8),
    support: (0, _defineProperty._)({}, (0, _index.COMMERCIAL), (0, _defineProperty._)({}, (0, _index.PRODUCTION), 'support.atlassian.com'))
};

},{"@swc/helpers/_/_define_property":"e80IS","./index":"9O8N4","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"67p9i":[function(require,module,exports,__globalThis) {
/* *NOTE*: please ensure any changes made to Perimeter and DomainKey type is copied in typings/atl-context.globals.d.ts */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AllowedDomains", function() {
    return AllowedDomains;
});
var AllowedDomains = [
    'admin',
    'analytics',
    'api',
    'api.media',
    'api-private',
    'as',
    'atl-global',
    'atlaskit',
    'auth',
    'automation',
    'cassi.internal',
    'cc-import-sources.services',
    'confluence',
    'confluence-chats-integr.services',
    'confluence-cloud-bamboo.internal',
    'confluence-questions.services',
    'data-portal.internal',
    'design',
    'developer',
    'extranet',
    'go',
    'id',
    'id-mail-assets',
    'integrations',
    'ja',
    'jira',
    'jsd-widget',
    'jsd-widget-staging',
    'marketplace',
    'my',
    'my-reminders.services',
    'partners',
    'permalink',
    'permalink.stg',
    'schema',
    'start',
    'support',
    'surveys',
    'team',
    'wac-cdn',
    'xxid',
    'home'
];

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dicLt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Determines if the current perimeter is an Isolated Cloud L2 perimeter
 *
 * @returns {boolean} True if the current perimeter is an Isolated Cloud perimeter, false otherwise
 */ parcelHelpers.export(exports, "isIsolatedCloud", function() {
    return isIsolatedCloud;
});
/**
 * Determines if the current perimeter is FedRAMP Moderate.
 * Please note that FedRAMP Moderate is not currently in Isolated Cloud, but when it is, this function will still return true.
 *
 * @returns {boolean} True if the current perimeter is FedRAMP Moderate, false otherwise
 */ parcelHelpers.export(exports, "isFedrampModerate", function() {
    return isFedrampModerate;
});
/**
 * Retrieves the customer selected IC domain name.
 *
 *
 * @returns {string | undefined} The Isolated Cloud domain name if applicable, undefined otherwise (ex. if not in Isolated Cloud)
 */ parcelHelpers.export(exports, "isolatedCloudDomain", function() {
    return isolatedCloudDomain;
});
/**
 * Returns the Isolation Context identifier
 *
 * @returns {string | undefined} The Isolation Context ID if applicable, undefined otherwise (ex. if not in Isolated Cloud)
 */ parcelHelpers.export(exports, "isolationContextId", function() {
    return isolationContextId;
});
/**
 * Returns information about the current environment for internal use
 * @returns {string | undefined} if the current environment is in isolated cloud + what the current perimeter is. Returns undefined when a new cloud environment has been created but not added to this library
 */ parcelHelpers.export(exports, "cloudEnvironment", function() {
    return cloudEnvironment;
});
var _constants = require("../../common/constants");
var _atlCookiesLookup = require("../atl-cookies-lookup");
function isIsolatedCloud() {
    var _globalThis_ssrContext;
    var _globalThis_ssrContext_isInIC;
    if (typeof document === 'undefined') // @ts-ignore
    return (_globalThis_ssrContext_isInIC = (_globalThis_ssrContext = globalThis.ssrContext) === null || _globalThis_ssrContext === void 0 ? void 0 : _globalThis_ssrContext.isInIC) !== null && _globalThis_ssrContext_isInIC !== void 0 ? _globalThis_ssrContext_isInIC : false;
    var atlCtxCookieValues = (0, _atlCookiesLookup.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    // The icDomain check is needed for when federal perimeters are eventually added to Isolated Cloud as well
    return (0, _constants.ISOLATED_CLOUD_PERIMETERS).includes(atlCtxCookieValues.perimeter) && atlCtxCookieValues.icDomain !== undefined;
}
function isFedrampModerate() {
    var _globalThis_ssrContext;
    var _globalThis_ssrContext_isInFedramp;
    if (typeof document === 'undefined') // @ts-ignore
    return (_globalThis_ssrContext_isInFedramp = (_globalThis_ssrContext = globalThis.ssrContext) === null || _globalThis_ssrContext === void 0 ? void 0 : _globalThis_ssrContext.isInFedramp) !== null && _globalThis_ssrContext_isInFedramp !== void 0 ? _globalThis_ssrContext_isInFedramp : false;
    var atlCtxCookieValues = (0, _atlCookiesLookup.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    return atlCtxCookieValues.perimeter === (0, _constants.FEDRAMP_MODERATE);
}
function isolatedCloudDomain() {
    var _globalThis_location;
    if (typeof document === 'undefined') return (_globalThis_location = globalThis.location) === null || _globalThis_location === void 0 ? void 0 : _globalThis_location.hostname;
    var atlCtxCookieValues = (0, _atlCookiesLookup.parseAtlCtxCookies)();
    return atlCtxCookieValues === null || atlCtxCookieValues === void 0 ? void 0 : atlCtxCookieValues.icDomain;
}
function isolationContextId() {
    var _globalThis_ssrContext;
    if (typeof document === 'undefined') // @ts-ignore
    return isIsolatedCloud() ? (_globalThis_ssrContext = globalThis.ssrContext) === null || _globalThis_ssrContext === void 0 ? void 0 : _globalThis_ssrContext.icName : undefined;
    var atlCtxCookieValues = (0, _atlCookiesLookup.parseAtlCtxCookies)();
    return atlCtxCookieValues === null || atlCtxCookieValues === void 0 ? void 0 : atlCtxCookieValues.icId;
}
function cloudEnvironment() {
    if (typeof document === 'undefined') return cloudEnvironmentSsrLookup();
    return cloudEnvironmentCookieLookup();
}
function cloudEnvironmentSsrLookup() {
    var _globalThis_ssrContext, _globalThis_ssrContext1;
    // @ts-ignore
    if (((_globalThis_ssrContext = globalThis.ssrContext) === null || _globalThis_ssrContext === void 0 ? void 0 : _globalThis_ssrContext.isInIC) === true) return {
        type: 'isolated-cloud',
        perimeter: (0, _constants.COMMERCIAL)
    };
    // @ts-ignore
    if (((_globalThis_ssrContext1 = globalThis.ssrContext) === null || _globalThis_ssrContext1 === void 0 ? void 0 : _globalThis_ssrContext1.isInFedramp) === true) return {
        type: 'non-isolated-cloud',
        perimeter: (0, _constants.FEDRAMP_MODERATE)
    };
    return {
        type: 'non-isolated-cloud',
        perimeter: (0, _constants.COMMERCIAL)
    };
}
function cloudEnvironmentCookieLookup() {
    // Avoid calling isFedrampModerate() and isIsolatedCloud() here to avoid repeated cookie parsing
    var atlCtxCookieValues = (0, _atlCookiesLookup.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return {
        type: 'non-isolated-cloud',
        perimeter: (0, _constants.COMMERCIAL)
    };
    var isIc = (0, _constants.ISOLATED_CLOUD_PERIMETERS).includes(atlCtxCookieValues.perimeter) && atlCtxCookieValues.icDomain !== undefined;
    if (isIc) return {
        type: 'isolated-cloud',
        perimeter: (0, _constants.COMMERCIAL)
    };
    if (atlCtxCookieValues.perimeter === (0, _constants.FEDRAMP_MODERATE)) return {
        type: 'non-isolated-cloud',
        perimeter: (0, _constants.FEDRAMP_MODERATE)
    };
    // If a new cloud environment has been created but not added to this library, return undefined
    return undefined;
}

},{"../../common/constants":"2v0It","../atl-cookies-lookup":"38UXz","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2v0It":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FEDRAMP_MODERATE", function() {
    return FEDRAMP_MODERATE;
});
parcelHelpers.export(exports, "COMMERCIAL", function() {
    return COMMERCIAL;
});
parcelHelpers.export(exports, "STAGING", function() {
    return STAGING;
});
parcelHelpers.export(exports, "PRODUCTION", function() {
    return PRODUCTION;
});
parcelHelpers.export(exports, "DEV", function() {
    return DEV;
});
parcelHelpers.export(exports, "ISOLATED_CLOUD_PERIMETERS", function() {
    return ISOLATED_CLOUD_PERIMETERS;
});
parcelHelpers.export(exports, "NON_ISOLATED_CLOUD_PERIMETERS", function() {
    return NON_ISOLATED_CLOUD_PERIMETERS;
});
parcelHelpers.export(exports, "ATL_CTX_PERIMETER", function() {
    return ATL_CTX_PERIMETER;
});
parcelHelpers.export(exports, "ATL_CTX_ISOLATION_CONTEXT_DOMAIN", function() {
    return ATL_CTX_ISOLATION_CONTEXT_DOMAIN;
});
parcelHelpers.export(exports, "ATL_CTX_ISOLATION_CONTEXT_ID", function() {
    return ATL_CTX_ISOLATION_CONTEXT_ID;
});
var FEDRAMP_MODERATE = 'fedramp-moderate';
var COMMERCIAL = 'commercial';
var STAGING = 'staging';
var PRODUCTION = 'prod';
var DEV = 'dev';
var ISOLATED_CLOUD_PERIMETERS = [
    COMMERCIAL
];
var NON_ISOLATED_CLOUD_PERIMETERS = [
    COMMERCIAL,
    FEDRAMP_MODERATE
];
var ATL_CTX_PERIMETER = 'Atl-Ctx-Perimeter';
var ATL_CTX_ISOLATION_CONTEXT_DOMAIN = 'Atl-Ctx-Isolation-Context-Domain';
var ATL_CTX_ISOLATION_CONTEXT_ID = 'Atl-Ctx-Isolation-Context-Id';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"38UXz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Internal helper function used to return the atl-ctx cookies for browser (which contains perimeter and ic_domain information).
 * Cookies are NOT set for regular commercial traffic.
 * @returns {AtlCtxCookieValues | undefined} - The parsed cookie contents or undefined if parsing fails (ex. if the cookies do not exist)
 */ parcelHelpers.export(exports, "parseAtlCtxCookies", function() {
    return parseAtlCtxCookies;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _constants = require("../../common/constants");
/**
 * Internal helper function used to parse cookie values and extract value of provided cookie name
 * @param {AtlCtxCookieName} cookieName - The name of the cookie to extract
 * @param {string} cookieString - The full cookie string
 * @returns {string | undefined} - The cookie value if present, undefined otherwise
 */ function getRawCookieValue(cookieName, cookieString) {
    if (!cookieString) return undefined;
    var cookies = cookieString.split(';');
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = cookies[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var cookie = _step.value;
            var _cookie_trim_split = (0, _slicedToArray._)(cookie.trim().split('='), 2), name = _cookie_trim_split[0], value = _cookie_trim_split[1];
            if (name === cookieName) return value;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return undefined;
}
function parseAtlCtxCookies() {
    var global = globalThis;
    try {
        // HOT-118791: the code below doesn't work on the server, and creates log spam in the catch block - "Cannot read properties of undefined (reading 'cookie')"
        if (typeof globalThis.document === 'undefined') return undefined;
        var cookies = global.document.cookie;
        var perimeter = getRawCookieValue((0, _constants.ATL_CTX_PERIMETER), cookies);
        if (!perimeter) // Indicative of non-isolated commercial perimeter
        return undefined;
        var icDomain = getRawCookieValue((0, _constants.ATL_CTX_ISOLATION_CONTEXT_DOMAIN), cookies);
        var icId = getRawCookieValue((0, _constants.ATL_CTX_ISOLATION_CONTEXT_ID), cookies);
        // The IC Domain and IC Id cookie values are empty strings for non Isolated Cloud
        var emptyIcDomain = !icDomain || icDomain.length === 0;
        var emptyIcId = !icId || icId.length === 0;
        return {
            perimeter: perimeter,
            icDomain: emptyIcDomain ? undefined : icDomain,
            icId: emptyIcId ? undefined : icId
        };
    } catch (e) {
        console.warn('Failed to parse atl-ctx cookies:', e);
        return undefined;
    }
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","../../common/constants":"2v0It","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dmAO7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *
 * Gets the full domain for an Atlassian experience in the context of the current request.
 * Returns undefined only when a new perimeter has been created that is not yet supported by the atlassian-context library or when the ic domain cannot be retrieved.
 *
 * For Non Isolated Cloud, the domain will be determined by the perimeter and environment combination unless the subdomain belongs in the list of global domains or overrides.
 * For Isolated Cloud, the domain type defaults to the vanity name pattern.
 *
 * @param subdomain - The Atlassian experience subdomain
 * @param envType - The environment to get the domain for ('dev', 'staging', or 'prod'). When in Isolated Cloud, the same value will be returned for all env types.
 * @returns The full domain associated with the subdomain for the given environment
 */ parcelHelpers.export(exports, "getDomainInContext", function() {
    return getDomainInContext;
});
/**
 *
 * Gets the full URL for an Atlassian experience in the context of the current request
 * Returns undefined only when a new perimeter has been created that is not yet supported by the atlassian-context library
 *
 * @param subdomain - The Atlassian experience subdomain
 * @param The environment to get the domain for ('dev', 'staging', or 'prod'). When in Isolated Cloud, the same value will be returned for all env types.
 * @returns The full URL for the given subdomain and environment
 */ parcelHelpers.export(exports, "getUrlForDomainInContext", function() {
    return getUrlForDomainInContext;
});
var _constants = require("../../common/constants");
var _domains = require("../../common/constants/domains");
var _perimeter = require("../perimeter");
var _constants1 = require("./constants");
function getDomainInContext(subdomain, envType) {
    var currentCloudEnvironment = (0, _perimeter.cloudEnvironment)();
    if (currentCloudEnvironment === undefined) return undefined;
    if (currentCloudEnvironment.type === 'isolated-cloud') {
        var domain = (0, _perimeter.isolatedCloudDomain)();
        if (domain === undefined) return undefined;
        return getDomainForIsolatedCloud(subdomain, (0, _constants.COMMERCIAL), domain);
    }
    return getDomainForNonIsolatedCloud(subdomain, currentCloudEnvironment.perimeter, envType);
}
/**
 * Gets the full Isolated Cloud domain
 * Returns undefined only if ic_domain cannot be determined from the atl-ctx cookies
 * Defaults to returning the vanity name pattern
 * @param subdomain - The Atlassian experience subdomain
 * @param perimeter - The Isolated Cloud perimeter to get the domain for
 * @param isolatedCloudDomain - The IC domain (ex. "company.atlassian-isolated.net")
 * @returns The full domain associated with the subdomain in a specific IC
 */ function getDomainForIsolatedCloud(subdomain, perimeter, isolatedCloudDomain) {
    var domainMappings = (0, _constants1.isolatedCloudFunctions)[perimeter];
    if ((0, _constants1.ReservedNameMapping)[perimeter].includes(subdomain)) return domainMappings.isolatedCloudReservedNameDomain(subdomain, isolatedCloudDomain);
    if ((0, _constants1.AtlDomainMapping)[perimeter].includes(subdomain)) return domainMappings.isolatedCloudAtlDomain(subdomain, isolatedCloudDomain);
    return domainMappings.isolatedCloudVanityDomain(subdomain, isolatedCloudDomain);
}
/**
 * Gets the full domain in an non-Isolated Cloud perimeter
 *
 * @param subdomain - The Atlassian experience subdomain
 * @param perimeter - The non-isolated cloud perimeter to get the domain for
 * @param The environment to get the domain for ('dev', 'staging', or 'prod'). When in Isolated Cloud, the same value will be returned for all env types.
 * @returns The full domain associated with the subdomain for the given perimeter and environment
 */ function getDomainForNonIsolatedCloud(subdomain, perimeter, envType) {
    var _fullDomainOverride_subdomain_perimeter, _fullDomainOverride_subdomain;
    // First, check if the subdomain is associated with a global domain
    if ((0, _domains.globalDomains)[subdomain]) return (0, _domains.globalDomains)[subdomain];
    // Second, check if the subdomain is associated with a full domain override (ex. a domain that uses a different pattern in other perimeters/environments)
    var override = (_fullDomainOverride_subdomain = (0, _domains.fullDomainOverride)[subdomain]) === null || _fullDomainOverride_subdomain === void 0 ? void 0 : (_fullDomainOverride_subdomain_perimeter = _fullDomainOverride_subdomain[perimeter]) === null || _fullDomainOverride_subdomain_perimeter === void 0 ? void 0 : _fullDomainOverride_subdomain_perimeter[envType];
    if (override) return override;
    // Use default domain ending for the given perimeter
    var domainMappings = (0, _constants1.nonIsolatedCloudFunctions)[perimeter];
    return domainMappings.defaultDomainEnding(subdomain, envType);
}
function getUrlForDomainInContext(subdomain, envType) {
    var _globalThis_location;
    var domain = getDomainInContext(subdomain, envType);
    if (!domain) {
        console.warn("Domain could not be determined for requested subdomain: ".concat(subdomain));
        return undefined;
    }
    var _globalThis_location_protocol;
    return "".concat((_globalThis_location_protocol = (_globalThis_location = globalThis.location) === null || _globalThis_location === void 0 ? void 0 : _globalThis_location.protocol) !== null && _globalThis_location_protocol !== void 0 ? _globalThis_location_protocol : 'https:', "//").concat(domain);
}

},{"../../common/constants":"2v0It","../../common/constants/domains":"guOpw","../perimeter":"dicLt","./constants":"jkmjj","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"guOpw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "globalDomains", function() {
    return globalDomains;
});
parcelHelpers.export(exports, "fullDomainOverride", function() {
    return fullDomainOverride;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _index = require("./index");
var globalDomains = {
    confluence: 'confluence.atlassian.com',
    design: 'design.atlassian.com',
    extranet: 'extranet.atlassian.com',
    go: 'go.atlassian.com',
    my: 'my.atlassian.com',
    surveys: 'surveys.atlassian.com',
    'wac-cdn': 'wac-cdn.atlassian.com',
    integrations: 'integrations.atlassian.com',
    permalink: 'permalink.atlassian.com',
    support: 'support.atlassian.com'
};
var _obj, _obj1, _obj2;
var fullDomainOverride = {
    id: (_obj2 = {}, (0, _defineProperty._)(_obj2, (0, _index.COMMERCIAL), (_obj = {}, (0, _defineProperty._)(_obj, (0, _index.PRODUCTION), 'id.atlassian.com'), (0, _defineProperty._)(_obj, (0, _index.STAGING), 'id.stg.internal.atlassian.com'), (0, _defineProperty._)(_obj, (0, _index.DEV), 'id.dev.internal.atlassian.com'), _obj)), (0, _defineProperty._)(_obj2, (0, _index.FEDRAMP_MODERATE), (_obj1 = {}, (0, _defineProperty._)(_obj1, (0, _index.PRODUCTION), 'id.atlassian-us-gov-mod.com'), (0, _defineProperty._)(_obj1, (0, _index.STAGING), 'id.stg.atlassian-us-gov-mod.com'), _obj1)), _obj2)
};

},{"@swc/helpers/_/_define_property":"e80IS","./index":"2v0It","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jkmjj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReservedNameMapping", function() {
    return ReservedNameMapping;
});
parcelHelpers.export(exports, "AtlDomainMapping", function() {
    return AtlDomainMapping;
});
parcelHelpers.export(exports, "isolatedCloudFunctions", function() {
    return isolatedCloudFunctions;
});
parcelHelpers.export(exports, "nonIsolatedCloudFunctions", function() {
    return nonIsolatedCloudFunctions;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _constants = require("../../common/constants");
var ReservedNameMapping = (0, _defineProperty._)({}, (0, _constants.COMMERCIAL), [
    'home',
    'team',
    'start',
    'id',
    'api',
    'admin',
    'auth',
    'bitbucket'
]);
var AtlDomainMapping = (0, _defineProperty._)({}, (0, _constants.COMMERCIAL), [
    'packages'
]);
var isolatedCloudFunctions = (0, _defineProperty._)({}, (0, _constants.COMMERCIAL), {
    isolatedCloudReservedNameDomain: function(subdomain, isolatedCloudDomain) {
        return "".concat(subdomain, ".").concat(isolatedCloudDomain);
    },
    isolatedCloudAtlDomain: function(subdomain, isolatedCloudDomain) {
        return "".concat(subdomain, ".atl.").concat(isolatedCloudDomain);
    },
    isolatedCloudVanityDomain: function(subdomain, isolatedCloudDomain) {
        return "".concat(subdomain, ".services.").concat(isolatedCloudDomain);
    }
});
var _obj;
var nonIsolatedCloudFunctions = (_obj = {}, (0, _defineProperty._)(_obj, (0, _constants.COMMERCIAL), {
    defaultDomainEnding: function(subdomain, envType) {
        switch(envType){
            case 0, _constants.PRODUCTION:
                return "".concat(subdomain, ".atlassian.com");
            case 0, _constants.STAGING:
                return "".concat(subdomain, ".stg.atlassian.com");
            case 0, _constants.DEV:
                return "".concat(subdomain, ".dev.atlassian.com");
            default:
                console.warn("Cannot get non-isolated commercial domain for provided environment, ".concat(envType, " is unsupported"));
                return '';
        }
    }
}), (0, _defineProperty._)(_obj, (0, _constants.FEDRAMP_MODERATE), {
    defaultDomainEnding: function(subdomain, envType) {
        switch(envType){
            case 0, _constants.PRODUCTION:
                return "".concat(subdomain, ".atlassian-us-gov-mod.com");
            case 0, _constants.STAGING:
                return "".concat(subdomain, ".stg.atlassian-us-gov-mod.com");
            default:
                console.warn("Cannot get fedramp-moderate domain for provided environment, ".concat(envType, " is unsupported"));
                return '';
        }
    }
}), _obj);

},{"@swc/helpers/_/_define_property":"e80IS","../../common/constants":"2v0It","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cakyv":[function(require,module,exports,__globalThis) {
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EvaluationReason", function() {
    return EvaluationReason;
});
var EvaluationReason = {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    Error: 'Error',
    LocalOverride: 'LocalOverride',
    Unrecognized: 'Unrecognized',
    Uninitialized: 'Uninitialized',
    NetworkNotModified: 'NetworkNotModified',
    Network: 'Network',
    InvalidBootstrap: 'InvalidBootstrap',
    Bootstrap: 'Bootstrap',
    Cache: 'Cache',
    // For when we could not migrate the reason from the new client
    Unknown: 'Unknown'
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cETze":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FeatureGateEnvironment", function() {
    return FeatureGateEnvironment;
});
parcelHelpers.export(exports, "PerimeterType", function() {
    return PerimeterType;
});
parcelHelpers.export(exports, "NON_BOOLEAN_VALUE", function() {
    return NON_BOOLEAN_VALUE;
});
var FeatureGateEnvironment = {
    Development: 'development',
    Staging: 'staging',
    Production: 'production'
};
var PerimeterType = {
    COMMERCIAL: 'commercial',
    FEDRAMP_MODERATE: 'fedramp-moderate'
};
var NON_BOOLEAN_VALUE = 'non_boolean';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9xpko":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Layer", function() {
    return Layer;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _typeOf = require("@swc/helpers/_/_type_of");
var _utils = require("../utils");
var Layer = /*#__PURE__*/ function() {
    "use strict";
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, secondaryExposures = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : [], undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : [], allocatedExperimentName = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : '', explicitParameters = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : [];
        (0, _classCallCheck._)(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    (0, _createClass._)(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((typeof val === "undefined" ? "undefined" : (0, _typeOf._)(val)) === (typeof defaultValue === "undefined" ? "undefined" : (0, _typeOf._)(defaultValue)) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this__logParameterFunction, _this;
                (_this__logParameterFunction = (_this = this)._logParameterFunction) === null || _this__logParameterFunction === void 0 ? void 0 : _this__logParameterFunction.call(_this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer___evaluation, _layer___evaluation1, _layer___evaluation2, _layer___evaluation3;
                var _layer___evaluation_secondary_exposures, _layer___evaluation_undelegated_secondary_exposures;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, _utils.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (0, _utils.migrateSecondaryExposures)((_layer___evaluation_secondary_exposures = (_layer___evaluation = layer.__evaluation) === null || _layer___evaluation === void 0 ? void 0 : _layer___evaluation.secondary_exposures) !== null && _layer___evaluation_secondary_exposures !== void 0 ? _layer___evaluation_secondary_exposures : []), (0, _utils.migrateSecondaryExposures)((_layer___evaluation_undelegated_secondary_exposures = (_layer___evaluation1 = layer.__evaluation) === null || _layer___evaluation1 === void 0 ? void 0 : _layer___evaluation1.undelegated_secondary_exposures) !== null && _layer___evaluation_undelegated_secondary_exposures !== void 0 ? _layer___evaluation_undelegated_secondary_exposures : []), (_layer___evaluation2 = layer.__evaluation) === null || _layer___evaluation2 === void 0 ? void 0 : _layer___evaluation2.allocated_experiment_name, (_layer___evaluation3 = layer.__evaluation) === null || _layer___evaluation3 === void 0 ? void 0 : _layer___evaluation3.explicit_parameters);
                return value;
            }
        }
    ]);
    return Layer;
}();

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_type_of":"iFJdx","../utils":"dCYmQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"amtXT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return 0, _fetcherDefault.default;
});
var _fetcher = require("./Fetcher");
var _fetcherDefault = parcelHelpers.interopDefault(_fetcher);

},{"./Fetcher":"6SVsv","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6SVsv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PROD_BASE_URL", function() {
    return PROD_BASE_URL;
});
parcelHelpers.export(exports, "STAGING_BASE_URL", function() {
    return STAGING_BASE_URL;
});
parcelHelpers.export(exports, "DEV_BASE_URL", function() {
    return DEV_BASE_URL;
});
parcelHelpers.export(exports, "FEDM_STAGING_BASE_URL", function() {
    return FEDM_STAGING_BASE_URL;
});
parcelHelpers.export(exports, "FEDM_PROD_BASE_URL", function() {
    return FEDM_PROD_BASE_URL;
});
parcelHelpers.export(exports, "IC_FFS_BASE_URL", function() {
    return IC_FFS_BASE_URL;
});
parcelHelpers.export(exports, "IC_STAGING_BASE_DOMAIN_URL", function() {
    return IC_STAGING_BASE_DOMAIN_URL;
});
parcelHelpers.export(exports, "IC_PROD_BASE_DOMAIN_URL", function() {
    return IC_PROD_BASE_DOMAIN_URL;
});
parcelHelpers.export(exports, "GATEWAY_BASE_URL", function() {
    return GATEWAY_BASE_URL;
});
parcelHelpers.export(exports, "default", function() {
    return Fetcher;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _types = require("../types");
var _version = require("../version");
var _errors = require("./errors");
var DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var PROD_BASE_URL = 'https://api.atlassian.com/flags';
var STAGING_BASE_URL = 'https://api.stg.atlassian.com/flags';
var DEV_BASE_URL = 'https://api.dev.atlassian.com/flags';
var FEDM_STAGING_BASE_URL = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var FEDM_PROD_BASE_URL = 'https://api.atlassian-us-gov-mod.com/flags';
var IC_FFS_BASE_URL = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
var IC_STAGING_BASE_DOMAIN_URL = 'oasis-stg.com/flags';
var IC_PROD_BASE_DOMAIN_URL = 'atlassian-isolated.net/flags';
var GATEWAY_BASE_URL = '/gateway/api/flags';
var Fetcher = /*#__PURE__*/ function() {
    "use strict";
    function Fetcher() {
        (0, _classCallCheck._)(this, Fetcher);
    }
    (0, _createClass._)(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function fetchClientSdk(fetcherOptions) {
                return (0, _asyncToGenerator._)(function() {
                    var targetApp, url, error;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    this.fetchRequest(url, 'GET', fetcherOptions)
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 3:
                                error = _state.sent();
                                if ((0, _instanceof._)(error, Error)) throw error;
                                throw Error('Failed to retrieve client sdk key');
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "fetchExperimentValues",
            value: function fetchExperimentValues(fetcherOptions, identifiers, customAttributes) {
                return (0, _asyncToGenerator._)(function() {
                    var requestBody, error;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody)
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 3:
                                error = _state.sent();
                                if ((0, _instanceof._)(error, Error)) throw error;
                                throw Error('Failed to retrieve experiment values');
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "handleResponseError",
            value: function handleResponseError(response) {
                return (0, _asyncToGenerator._)(function() {
                    var body;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!response.ok) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    response.text()
                                ];
                            case 1:
                                body = _state.sent();
                                throw new (0, _errors.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 2:
                                if (response.status === 204) throw new (0, _errors.ResponseError)('Unexpected 204 response');
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "extractResponseBody",
            value: function extractResponseBody(response) {
                return (0, _asyncToGenerator._)(function() {
                    var value;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    response.text()
                                ];
                            case 1:
                                value = _state.sent();
                                return [
                                    2,
                                    JSON.parse(value)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, perimeter = arguments.length > 2 ? arguments[2] : void 0, isolationContextId = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
                if (useGatewayUrl) return GATEWAY_BASE_URL;
                if (perimeter === (0, _types.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, _types.FeatureGateEnvironment).Production:
                        return FEDM_PROD_BASE_URL;
                    case (0, _types.FeatureGateEnvironment).Staging:
                        return FEDM_STAGING_BASE_URL;
                    default:
                        throw new Error('Invalid environment "'.concat(serviceEnv, '" for "').concat(perimeter, '" perimeter'));
                }
                else if (perimeter === (0, _types.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, _types.FeatureGateEnvironment).Development:
                        return DEV_BASE_URL;
                    case (0, _types.FeatureGateEnvironment).Staging:
                        var apiUrl = this.getApiUrl(isolationContextId);
                        if (apiUrl !== null) return apiUrl;
                        return STAGING_BASE_URL;
                    default:
                        var prodApiUrl = this.getApiUrl(isolationContextId);
                        if (prodApiUrl !== null) return prodApiUrl;
                        return PROD_BASE_URL;
                }
                else throw new Error('Invalid perimeter "'.concat(perimeter, '"'));
            }
        },
        {
            key: "fetchRequest",
            value: function fetchRequest(path, method, fetcherOptions, body) {
                return (0, _asyncToGenerator._)(function() {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                return [
                                    4,
                                    fetch("".concat(baseUrl).concat(path), (0, _objectSpread._)({
                                        method: method,
                                        headers: {
                                            'Content-Type': 'application/json',
                                            'X-Client-Name': 'feature-gate-js-client',
                                            'X-Client-Version': (0, _version.CLIENT_VERSION),
                                            'X-API-KEY': fetcherOptions.apiKey
                                        },
                                        signal: abortSignal
                                    }, body && {
                                        body: JSON.stringify(body)
                                    }))
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    4,
                                    this.handleResponseError(response)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    4,
                                    this.extractResponseBody(response)
                                ];
                            case 3:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getApiUrl",
            value: function getApiUrl(isolationContextId) {
                var window1 = this.getWindowLocation();
                if (window1 === undefined) {
                    //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
                    if (!isolationContextId) return null;
                    return IC_FFS_BASE_URL.replace('%s', isolationContextId);
                }
                var protocol = window1.protocol, hostname = window1.hostname;
                // Match last subdomain fragment before oasis-stg.com
                var oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
                if (oasisMatch) return "".concat(protocol, "//api.").concat(oasisMatch[1], ".").concat(IC_STAGING_BASE_DOMAIN_URL);
                // Match last subdomain fragment before atlassian-isolated.net
                var isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
                if (isolatedMatch) return "".concat(protocol, "//api.").concat(isolatedMatch[1], ".").concat(IC_PROD_BASE_DOMAIN_URL);
                return null;
            }
        },
        {
            key: "getWindowLocation",
            value: function getWindowLocation() {
                if (typeof window !== 'undefined' && window.location) return window.location;
                return undefined;
            }
        }
    ]);
    return Fetcher;
}();

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_ts_generator":"78Tqx","../types":"cETze","../version":"4vZAC","./errors":"b87qi","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4vZAC":[function(require,module,exports,__globalThis) {
/// <reference types="node" />
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CLIENT_VERSION", function() {
    return CLIENT_VERSION;
});
var CLIENT_VERSION = undefined;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"b87qi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResponseError", function() {
    return ResponseError;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _inherits = require("@swc/helpers/_/_inherits");
var _wrapNativeSuper = require("@swc/helpers/_/_wrap_native_super");
var ResponseError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, _inherits._)(ResponseError, Error1);
    function ResponseError(message) {
        (0, _classCallCheck._)(this, ResponseError);
        return (0, _callSuper._)(this, ResponseError, [
            message
        ]);
    }
    return ResponseError;
}((0, _wrapNativeSuper._)(Error));

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_inherits":"2sfqW","@swc/helpers/_/_wrap_native_super":"d0Iin","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"d0Iin":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _wrap_native_super;
});
var _constructJs = require("./_construct.js");
var _getPrototypeOfJs = require("./_get_prototype_of.js");
var _isNativeFunctionJs = require("./_is_native_function.js");
var _setPrototypeOfJs = require("./_set_prototype_of.js");
function _wrap_native_super(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrap_native_super = function(Class) {
        if (Class === null || !(0, _isNativeFunctionJs._)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, _constructJs._)(Class, arguments, (0, _getPrototypeOfJs._)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, _setPrototypeOfJs._)(Wrapper, Class);
    };
    return _wrap_native_super(Class);
}

},{"./_construct.js":"ggvY6","./_get_prototype_of.js":"5txK6","./_is_native_function.js":"ad5DD","./_set_prototype_of.js":"8vuiZ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ggvY6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _construct;
});
var _isNativeReflectConstructJs = require("./_is_native_reflect_construct.js");
var _setPrototypeOfJs = require("./_set_prototype_of.js");
function _construct(Parent, args, Class) {
    if ((0, _isNativeReflectConstructJs._)()) _construct = Reflect.construct;
    else _construct = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, _setPrototypeOfJs._)(instance, Class.prototype);
        return instance;
    };
    return _construct.apply(null, arguments);
}

},{"./_is_native_reflect_construct.js":"dAPDw","./_set_prototype_of.js":"8vuiZ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ad5DD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _is_native_function;
});
function _is_native_function(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kohXZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NoFetchDataAdapter", function() {
    return NoFetchDataAdapter;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _get = require("@swc/helpers/_/_get");
var _getPrototypeOf = require("@swc/helpers/_/_get_prototype_of");
var _inherits = require("@swc/helpers/_/_inherits");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _jsClient = require("@statsig/js-client");
var NoFetchDataAdapter = /*#__PURE__*/ function(DataAdapterCore) {
    "use strict";
    (0, _inherits._)(NoFetchDataAdapter, DataAdapterCore);
    function NoFetchDataAdapter() {
        (0, _classCallCheck._)(this, NoFetchDataAdapter);
        var _this;
        _this = (0, _callSuper._)(this, NoFetchDataAdapter, [
            'NoFetchDataAdapter',
            'nofetch'
        ]), _this.bootstrapResult = null;
        return _this;
    }
    (0, _createClass._)(NoFetchDataAdapter, [
        {
            /**
	 * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
	 * after the Statsig client has been created!
	 */ key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: 'Bootstrap',
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, _jsClient.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function prefetchData(_user, _options) {
                return (0, _asyncToGenerator._)(function() {
                    return (0, _tsGenerator._)(this, function(_state) {
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "getDataAsync",
            value: function getDataAsync(_current, user, _options) {
                return (0, _asyncToGenerator._)(function() {
                    return (0, _tsGenerator._)(this, function(_state) {
                        return [
                            2,
                            this.bootstrapResult && (0, _objectSpreadProps._)((0, _objectSpread._)({}, this.bootstrapResult), {
                                fullUserHash: (0, _jsClient._getFullUserHash)(user)
                            })
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && (0, _objectSpreadProps._)((0, _objectSpread._)({}, this.bootstrapResult), {
                    fullUserHash: (0, _jsClient._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function _fetchFromNetwork(_current, _user, _options) {
                return (0, _asyncToGenerator._)(function() {
                    return (0, _tsGenerator._)(this, function(_state) {
                        return [
                            2,
                            null
                        ];
                    });
                })();
            }
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, _jsClient._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, _jsClient.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                (0, _get._)((0, _getPrototypeOf._)(NoFetchDataAdapter.prototype), "setData", this).call(this, data, user);
            }
        },
        {
            // Do not stringify options property since that includes this adapter and will
            // cause a circular reference when Statsig sends diagnostic events and including
            // values is not necessary and makes the result huge
            key: "toJSON",
            value: function toJSON() {
                var result = (0, _objectSpread._)({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
    return NoFetchDataAdapter;
}((0, _jsClient.DataAdapterCore));

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_get":"38TLD","@swc/helpers/_/_get_prototype_of":"5txK6","@swc/helpers/_/_inherits":"2sfqW","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_ts_generator":"78Tqx","@statsig/js-client":"7YWtw","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"63mtU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LOCAL_STORAGE_KEY", function() {
    return LOCAL_STORAGE_KEY;
});
parcelHelpers.export(exports, "PersistentOverrideAdapter", function() {
    return PersistentOverrideAdapter;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _clientCore = require("@statsig/client-core");
var LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
var LOCAL_STORAGE_KEY = 'STATSIG_OVERRIDES';
var LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var makeEmptyStore = function() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var djb2MapKey = function(hash, kind) {
    return kind + ':' + hash;
};
var PersistentOverrideAdapter = /*#__PURE__*/ function() {
    "use strict";
    function PersistentOverrideAdapter(localStorageKey) {
        (0, _classCallCheck._)(this, PersistentOverrideAdapter);
        this._overrides = makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    (0, _createClass._)(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return makeEmptyStore();
                    return JSON.parse(json);
                } catch (e) {
                    return makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++){
                    allOverrides[_key] = arguments[_key];
                }
                var merged = makeEmptyStore();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = allOverrides[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var overrides = _step.value;
                        var _overrides_gates;
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = Object.entries((_overrides_gates = overrides.gates) !== null && _overrides_gates !== void 0 ? _overrides_gates : {})[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var _step_value = (0, _slicedToArray._)(_step1.value, 2), name = _step_value[0], value = _step_value[1];
                                merged.gates[name] = value;
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                        var _overrides_configs;
                        var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                        try {
                            for(var _iterator2 = Object.entries((_overrides_configs = overrides.configs) !== null && _overrides_configs !== void 0 ? _overrides_configs : {})[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                var _step_value1 = (0, _slicedToArray._)(_step2.value, 2), name1 = _step_value1[0], value1 = _step_value1[1];
                                merged.configs[name1] = value1;
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                    _iterator2.return();
                                }
                            } finally{
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }
                        var _overrides_layers;
                        var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                        try {
                            for(var _iterator3 = Object.entries((_overrides_layers = overrides.layers) !== null && _overrides_layers !== void 0 ? _overrides_layers : {})[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                                var _step_value2 = (0, _slicedToArray._)(_step3.value, 2), name2 = _step_value2[0], value2 = _step_value2[1];
                                merged.layers[name2] = value2;
                            }
                        } catch (err) {
                            _didIteratorError3 = true;
                            _iteratorError3 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                                    _iterator3.return();
                                }
                            } finally{
                                if (_didIteratorError3) {
                                    throw _iteratorError3;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides(LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    window.localStorage.removeItem(LEGACY_LOCAL_STORAGE_KEY);
                } catch (e) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                    // multiple hashes to continue being created. This code here removes these hashes since we've moved
                    // to using a more reliable and easier to maintain map in `_djb2Map`.
                    for(var _iterator = Object.values(storedOverrides)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var container = _step.value;
                        var allKeys = new Set(Object.keys(container));
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = allKeys[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var name = _step1.value;
                                var hash = (0, _clientCore._DJB2)(name);
                                if (allKeys.has(hash)) delete container[hash];
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (e) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = (0, _objectSpread._)({}, makeEmptyStore(), overrides);
                this._djb2Map.clear();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator = Object.entries(newOverrides)[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                        var _step_value = (0, _slicedToArray._)(_step.value, 2), containerName = _step_value[0], container = _step_value[1];
                        try {
                            for(var _iterator1 = Object.entries(container)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                                var _step_value1 = (0, _slicedToArray._)(_step1.value, 2), name = _step_value1[0], value = _step_value1[1];
                                this._djb2Map.set(djb2MapKey((0, _clientCore._DJB2)(name), containerName), value);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set(djb2MapKey((0, _clientCore._DJB2)(name), 'gates'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete(djb2MapKey((0, _clientCore._DJB2)(name), 'gates'));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this__overrides_gates_current_name;
                var overridden = (_this__overrides_gates_current_name = this._overrides.gates[current.name]) !== null && _this__overrides_gates_current_name !== void 0 ? _this__overrides_gates_current_name : this._djb2Map.get(djb2MapKey(current.name, 'gates'));
                if (overridden == null) return null;
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, current), {
                    value: overridden,
                    details: (0, _objectSpreadProps._)((0, _objectSpread._)({}, current.details), {
                        reason: LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set(djb2MapKey((0, _clientCore._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete(djb2MapKey((0, _clientCore._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set(djb2MapKey((0, _clientCore._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete(djb2MapKey((0, _clientCore._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set(djb2MapKey((0, _clientCore._DJB2)(name), 'layers'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete(djb2MapKey((0, _clientCore._DJB2)(name), 'layers'));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = makeEmptyStore();
                try {
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (e) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this__overrides_layers_current_name;
                var overridden = (_this__overrides_layers_current_name = this._overrides.layers[current.name]) !== null && _this__overrides_layers_current_name !== void 0 ? _this__overrides_layers_current_name : this._djb2Map.get(djb2MapKey(current.name, 'layers'));
                if (overridden == null) return null;
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, current), {
                    __value: overridden,
                    get: (0, _clientCore._makeTypedGet)(current.name, overridden),
                    details: (0, _objectSpreadProps._)((0, _objectSpread._)({}, current.details), {
                        reason: LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup_current_name;
                var overridden = (_lookup_current_name = lookup[current.name]) !== null && _lookup_current_name !== void 0 ? _lookup_current_name : this._djb2Map.get(djb2MapKey(current.name, 'configs'));
                if (overridden == null) return null;
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, current), {
                    value: overridden,
                    get: (0, _clientCore._makeTypedGet)(current.name, overridden),
                    details: (0, _objectSpreadProps._)((0, _objectSpread._)({}, current.details), {
                        reason: LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
    return PersistentOverrideAdapter;
}();

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_sliced_to_array":"8PtL6","@statsig/client-core":"1MCdW","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"70NTu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "debug", function() {
    return debug;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _globalThis_process_env, _globalThis_process, _globalThis, _globalThis_process_env1, _globalThis_process1, _globalThis1;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var TESTS_MODE = ((_globalThis = globalThis) === null || _globalThis === void 0 ? void 0 : (_globalThis_process = _globalThis.process) === null || _globalThis_process === void 0 ? void 0 : (_globalThis_process_env = _globalThis_process.env) === null || _globalThis_process_env === void 0 ? void 0 : _globalThis_process_env.JEST_WORKER_ID) !== undefined;
var DEBUG_MODE = !TESTS_MODE && ((_globalThis1 = globalThis) === null || _globalThis1 === void 0 ? void 0 : (_globalThis_process1 = _globalThis1.process) === null || _globalThis_process1 === void 0 ? void 0 : (_globalThis_process_env1 = _globalThis_process1.env) === null || _globalThis_process_env1 === void 0 ? void 0 : _globalThis_process_env1.NODE_ENV) !== 'production';
var debug = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var // eslint-disable-next-line no-console
    _console;
    if (!DEBUG_MODE) return;
    (_console = console).debug.apply(_console, (0, _toConsumableArray._)(args));
};

},{"@swc/helpers/_/_to_consumable_array":"1eSZf","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2dayt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDocument", function() {
    return 0, _getDocument.getDocument;
});
var _getDocument = require("./getDocument");

},{"./getDocument":"01W0K","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"01W0K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDocument", function() {
    return getDocument;
});
var getDocument = function() {
    if (typeof document !== 'undefined') return document;
    return null;
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7XeDp":[function(require,module,exports,__globalThis) {
/* App.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "App", function() {
    return App;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactResourceRouter = require("react-resource-router");
var _appProvider = require("@atlaskit/app-provider");
var _appProviderDefault = parcelHelpers.interopDefault(_appProvider);
var _relayEnvironmentProvider = require("@atlassian/relay-environment-provider");
var _navigationSystem = require("@atlaskit/navigation-system");
var _flag = require("@atlaskit/flag");
var _segment = require("@atlaskit/react-ufo/segment");
var _segmentDefault = parcelHelpers.interopDefault(_segment);
var _routes = require("./routes");
var _useReactUFORouteWatcher = require("../analytics/react-ufo/useReactUFORouteWatcher");
var _twgMicrositeExperience = require("@atlassian/twg-microsite-experience");
var _localeProvider = require("@atlassian/twg-microsite-experience/locale-provider");
var _navigationBar = require("@atlassian/twg-microsite-experience/NavigationBar");
var _userProvider = require("@atlassian/twg-microsite-experience/user-provider");
var _analyticsProvider = require("@atlassian/twg-microsite-experience/analytics-provider");
var _panelProvider = require("@atlassian/twg-microsite-experience/panel-provider");
var _featureFlags = require("../feature-flags");
var _debugPanel = require("@atlassian/twg-microsite-experience/DebugPanel");
// The microsite only registers a single route (`/`), so any other pathname
// (e.g. `/hello`) is rewritten to `/` before the Router subscribes — this
// avoids an extra render pass or loading-state flicker on first mount.
var history = (0, _reactResourceRouter.createBrowserHistory)();
if (history.location.pathname !== '/') history.replace({
    pathname: '/',
    search: history.location.search,
    hash: history.location.hash
});
// Sibling of `<Root>` so it can subscribe to the `Router` context. The hook
// is a no-op on first render (the initial page-load is traced by `initUFO`)
// and fires `traceUFOTransition` on subsequent route name changes.
var RouteWatcher = function() {
    (0, _useReactUFORouteWatcher.useReactUFORouteWatcher)();
    return null;
};
var App = function() {
    var analyticsClient = (0, _react.useMemo)(function() {
        return (0, _twgMicrositeExperience.initAnalyticsClient)();
    }, []);
    var onUserLoginComplete = (0, _react.useCallback)(function(user) {
        return (0, _asyncToGenerator._)(function() {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, _featureFlags.initializeFeatureGates)(user.accountId, user.orgId)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _segmentDefault.default), {
        name: "twg-microsite-root",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _relayEnvironmentProvider.RelayEnvironmentProvider), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _analyticsProvider.AnalyticsProvider), {
                analyticsClient: analyticsClient,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _localeProvider.LocaleProvider), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appProviderDefault.default), {
                        defaultColorMode: "dark",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _flag.FlagsProvider), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userProvider.UserProvider), {
                                onUserLoginComplete: onUserLoginComplete,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _panelProvider.PanelProvider), {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactResourceRouter.Router), {
                                        history: history,
                                        routes: (0, _routes.routes),
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(RouteWatcher, {}),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _navigationSystem.Root), {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _navigationSystem.Main), {
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navigationBar.NavigationBar), {}),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactResourceRouter.RouteComponent), {})
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _debugPanel.DebugPanel), {})
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    });
};

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_ts_generator":"78Tqx","react/jsx-runtime":"bGvcw","react":"ltHCL","react-resource-router":"aVqdw","@atlaskit/app-provider":"cnK0e","@atlassian/relay-environment-provider":"4UlSn","@atlaskit/navigation-system":"fE1Q3","@atlaskit/flag":"blMWC","@atlaskit/react-ufo/segment":"cMGle","./routes":"jqTsg","../analytics/react-ufo/useReactUFORouteWatcher":"hTim7","@atlassian/twg-microsite-experience":"3ciWs","@atlassian/twg-microsite-experience/locale-provider":"jS31Y","@atlassian/twg-microsite-experience/NavigationBar":"6EHQI","@atlassian/twg-microsite-experience/user-provider":"cEVt6","@atlassian/twg-microsite-experience/analytics-provider":"jT3Dw","@atlassian/twg-microsite-experience/panel-provider":"v06Iw","../feature-flags":"6Avht","@atlassian/twg-microsite-experience/DebugPanel":"lf7ae","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aVqdw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createBrowserHistory", function() {
    return 0, _history.createBrowserHistory;
});
parcelHelpers.export(exports, "createMemoryHistory", function() {
    return 0, _history.createMemoryHistory;
});
parcelHelpers.export(exports, "Router", function() {
    return 0, _controllers.Router;
});
parcelHelpers.export(exports, "MemoryRouter", function() {
    return 0, _controllers.MemoryRouter;
});
parcelHelpers.export(exports, "StaticRouter", function() {
    return 0, _controllers.StaticRouter;
});
parcelHelpers.export(exports, "RouterSubscriber", function() {
    return 0, _controllers.RouterSubscriber;
});
parcelHelpers.export(exports, "RouteResourceEnabledSubscriber", function() {
    return 0, _controllers.RouteResourceEnabledSubscriber;
});
parcelHelpers.export(exports, "Redirect", function() {
    return 0, _controllers.Redirect;
});
parcelHelpers.export(exports, "RouterActions", function() {
    return 0, _controllers.RouterActions;
});
parcelHelpers.export(exports, "withRouter", function() {
    return 0, _controllers.withRouter;
});
parcelHelpers.export(exports, "ResourceSubscriber", function() {
    return 0, _controllers.ResourceSubscriber;
});
parcelHelpers.export(exports, "useResource", function() {
    return 0, _controllers.useResource;
});
parcelHelpers.export(exports, "useRouter", function() {
    return 0, _controllers.useRouter;
});
parcelHelpers.export(exports, "useQueryParam", function() {
    return 0, _controllers.useQueryParam;
});
parcelHelpers.export(exports, "usePathParam", function() {
    return 0, _controllers.usePathParam;
});
parcelHelpers.export(exports, "useResourceStoreContext", function() {
    return 0, _controllers.useResourceStoreContext;
});
parcelHelpers.export(exports, "ResourceDependencyError", function() {
    return 0, _controllers.ResourceDependencyError;
});
parcelHelpers.export(exports, "createResource", function() {
    return 0, _controllers.createResource;
});
parcelHelpers.export(exports, "useRouterActions", function() {
    return 0, _controllers.useRouterActions;
});
parcelHelpers.export(exports, "createRouterSelector", function() {
    return 0, _controllers.createRouterSelector;
});
parcelHelpers.export(exports, "RouteComponent", function() {
    return 0, _ui.RouteComponent;
});
parcelHelpers.export(exports, "Link", function() {
    return 0, _ui.Link;
});
parcelHelpers.export(exports, "matchRoute", function() {
    return 0, _utils.matchRoute;
});
parcelHelpers.export(exports, "generatePath", function() {
    return 0, _utils.generatePath;
});
parcelHelpers.export(exports, "createLegacyHistory", function() {
    return 0, _utils.createLegacyHistory;
});
parcelHelpers.export(exports, "createRouterContext", function() {
    return 0, _utils.createRouterContext;
});
parcelHelpers.export(exports, "findRouterContext", function() {
    return 0, _utils.findRouterContext;
});
var _history = require("history");
var _controllers = require("./controllers");
var _ui = require("./ui");
var _utils = require("./common/utils");

},{"history":"de6OM","./controllers":"lGPAy","./ui":"fE23c","./common/utils":"cxuex","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"de6OM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createBrowserHistory", function() {
    return createBrowserHistory;
});
parcelHelpers.export(exports, "createHashHistory", function() {
    return createHashHistory;
});
parcelHelpers.export(exports, "createMemoryHistory", function() {
    return createMemoryHistory;
});
parcelHelpers.export(exports, "createLocation", function() {
    return createLocation;
});
parcelHelpers.export(exports, "locationsAreEqual", function() {
    return locationsAreEqual;
});
parcelHelpers.export(exports, "parsePath", function() {
    return parsePath;
});
parcelHelpers.export(exports, "createPath", function() {
    return createPath;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _resolvePathname = require("resolve-pathname");
var _resolvePathnameDefault = parcelHelpers.interopDefault(_resolvePathname);
var _valueEqual = require("value-equal");
var _valueEqualDefault = parcelHelpers.interopDefault(_valueEqual);
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
function addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
    return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
}
function createPath(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
    return path;
}
function createLocation(path, state, key, currentLocation) {
    var location;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = parsePath(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, _extendsDefault.default)({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if ((0, _instanceof._)(e, URIError)) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, _resolvePathnameDefault.default)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
}
function locationsAreEqual(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqualDefault.default)(a.state, b.state);
}
function createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}
var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';
function getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function createBrowserHistory(props) {
    if (props === void 0) props = {};
    !canUseDOM && (0, _tinyInvariantDefault.default)(false);
    var globalHistory = window.history;
    var canUseHistory = supportsHistory();
    var needsHashChangeListener = !supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = stripBasename(path, basename);
        return createLocation(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = createTransitionManager();
    function setState(nextState) {
        (0, _extendsDefault.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if (isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation(getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation(getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + createPath(location);
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, _$state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: _$state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, _$state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: _$state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener(PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener(PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === '!' ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: stripLeadingSlash,
        decodePath: addLeadingSlash
    },
    slash: {
        encodePath: addLeadingSlash,
        decodePath: addLeadingSlash
    }
};
function stripHash(url) {
    var hashIndex = url.indexOf('#');
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf('#');
    return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}
function pushHashPath(path) {
    window.location.hash = path;
}
function replaceHashPath(path) {
    window.location.replace(stripHash(window.location.href) + '#' + path);
}
function createHashHistory(props) {
    if (props === void 0) props = {};
    !canUseDOM && (0, _tinyInvariantDefault.default)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
    var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
    var _HashPathCoders$hashT = HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath(getHashPath());
        if (basename) path = stripBasename(path, basename);
        return createLocation(path);
    }
    var transitionManager = createTransitionManager();
    function setState(nextState) {
        (0, _extendsDefault.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf(createPath(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        createPath(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector('base');
        var href = '';
        if (baseTag && baseTag.getAttribute('href')) href = stripHash(window.location.href);
        return href + '#' + encodePath(basename + createPath(location));
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = createLocation(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var _$path = createPath(location);
            var encodedPath = encodePath(basename + _$path);
            var hashChanged = getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = _$path;
                pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf(createPath(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(_$path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = createLocation(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var _$path = createPath(location);
            var encodedPath = encodePath(basename + _$path);
            var hashChanged = getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = _$path;
                replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf(createPath(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = _$path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener(HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function createMemoryHistory(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        '/'
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = createTransitionManager();
    function setState(nextState) {
        (0, _extendsDefault.default)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = createPath;
    function push(path, state) {
        var action = 'PUSH';
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
        var action = 'POP';
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: 'POP',
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}

},{"@swc/helpers/_/_instanceof":"h9UKc","@babel/runtime/helpers/esm/extends":"3LZYG","resolve-pathname":"bnyq9","value-equal":"91iMR","tiny-warning":"6MVuu","tiny-invariant":"9VWeJ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3LZYG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _extends;
});
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function _extends(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bnyq9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isAbsolute(pathname) {
    return pathname.charAt(0) === '/';
}
// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
    if (from === undefined) from = '';
    var toParts = to && to.split('/') || [];
    var fromParts = from && from.split('/') || [];
    var isToAbs = to && isAbsolute(to);
    var isFromAbs = from && isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return '/';
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === '.' || last === '..' || last === '';
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === '.') spliceOne(fromParts, i);
        else if (part === '..') {
            spliceOne(fromParts, i);
            up++;
        } else if (up) {
            spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift('..');
    if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');
    var result = fromParts.join('/');
    if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
    return result;
}
exports.default = resolvePathname;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"91iMR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _typeOf = require("@swc/helpers/_/_type_of");
function valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return valueEqual(item, b[index]);
    });
    if ((typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)) === 'object' || (typeof b === "undefined" ? "undefined" : (0, _typeOf._)(b)) === 'object') {
        var aValue = valueOf(a);
        var bValue = valueOf(b);
        if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return valueEqual(a[key], b[key]);
        });
    }
    return false;
}
exports.default = valueEqual;

},{"@swc/helpers/_/_type_of":"iFJdx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6MVuu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var isProduction = true;
function warning(condition, message) {
    if (!isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
exports.default = warning;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9VWeJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return invariant;
});
var isProduction = true;
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) return;
    if (isProduction) throw new Error(prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
    throw new Error(value);
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lGPAy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RouterSubscriber", function() {
    return 0, _subscribers.RouterSubscriber;
});
parcelHelpers.export(exports, "ResourceSubscriber", function() {
    return 0, _subscribers.ResourceSubscriber;
});
parcelHelpers.export(exports, "Router", function() {
    return 0, _router.Router;
});
parcelHelpers.export(exports, "MemoryRouter", function() {
    return 0, _memoryRouter.MemoryRouter;
});
parcelHelpers.export(exports, "StaticRouter", function() {
    return 0, _staticRouter.StaticRouter;
});
parcelHelpers.export(exports, "RouterActions", function() {
    return 0, _routerActions.RouterActions;
});
parcelHelpers.export(exports, "Redirect", function() {
    return 0, _redirect.Redirect;
});
parcelHelpers.export(exports, "withRouter", function() {
    return 0, _withRouter.withRouter;
});
parcelHelpers.export(exports, "useResource", function() {
    return 0, _hooks.useResource;
});
parcelHelpers.export(exports, "useRouter", function() {
    return 0, _hooks.useRouter;
});
parcelHelpers.export(exports, "useRouterActions", function() {
    return 0, _hooks.useRouterActions;
});
parcelHelpers.export(exports, "useQueryParam", function() {
    return 0, _hooks.useQueryParam;
});
parcelHelpers.export(exports, "usePathParam", function() {
    return 0, _hooks.usePathParam;
});
parcelHelpers.export(exports, "useResourceStoreContext", function() {
    return 0, _resourceStore.useResourceStoreContext;
});
parcelHelpers.export(exports, "ResourceDependencyError", function() {
    return 0, _resourceStore.ResourceDependencyError;
});
parcelHelpers.export(exports, "createResource", function() {
    return 0, _resourceUtils.createResource;
});
parcelHelpers.export(exports, "RouteResourceEnabledSubscriber", function() {
    return 0, _routerStore.RouteResourceEnabledSubscriber;
});
parcelHelpers.export(exports, "createRouterSelector", function() {
    return 0, _routerStore.createRouterSelector;
});
var _subscribers = require("./subscribers");
var _router = require("./router");
var _memoryRouter = require("./memory-router");
var _staticRouter = require("./static-router");
var _routerActions = require("./router-actions");
var _redirect = require("./redirect");
var _withRouter = require("./with-router");
var _hooks = require("./hooks");
var _resourceStore = require("./resource-store");
var _resourceUtils = require("./resource-utils");
var _routerStore = require("./router-store");

},{"./subscribers":"b8huL","./router":"jqyTp","./memory-router":"anf9k","./static-router":"lJnVA","./router-actions":"dl0mj","./redirect":"dmfvG","./with-router":"jVZEC","./hooks":"22m5g","./resource-store":"bHILc","./resource-utils":"fCq3I","./router-store":"hf6U0","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"b8huL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResourceSubscriber", function() {
    return 0, _resource.ResourceSubscriber;
});
parcelHelpers.export(exports, "RouterSubscriber", function() {
    return 0, _route.RouterSubscriber;
});
var _resource = require("./resource");
var _route = require("./route");

},{"./resource":"7hitq","./route":"9mmgg","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7hitq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResourceSubscriber", function() {
    return ResourceSubscriber;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _resourceStore = require("../../hooks/resource-store");
var ResourceSubscriber = function(param) {
    var children = param.children, resource = param.resource, options = param.options;
    var result = (0, _resourceStore.useResource)(resource, options);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, children(result));
};

},{"react":"ltHCL","../../hooks/resource-store":"jfek9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jfek9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useResource", function() {
    return useResource;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _resourceStore = require("../../resource-store");
var _routerStore = require("../../router-store");
var _reactSweetState = require("react-sweet-state");
var useResource = function(resource, options) {
    var _useResourceActions = (0, _slicedToArray._)((0, _resourceStore.useResourceActions)(), 2), actions = _useResourceActions[1];
    var _useRouterStoreStatic = (0, _slicedToArray._)((0, _routerStore.useRouterStoreStatic)(), 2), _useRouterStoreStatic_ = _useRouterStoreStatic[1], getRouterContext = _useRouterStoreStatic_.getContext; // Dynamically generate a router subscriber based on the resource:
    // makes the component re-render only when key changes instead of
    // after every route change
    var useKey = (0, _react.useMemo)(function() {
        return (0, _reactSweetState.createHook)((0, _routerStore.RouterStore), {
            selector: function(param, keyArg) {
                var match = param.match, query = param.query, route = param.route;
                return resource.getKey(keyArg != null ? keyArg : {
                    match: match,
                    query: query,
                    route: route
                }, actions.getContext());
            }
        });
    }, [
        resource,
        actions
    ]);
    var key = useKey(options == null ? void 0 : options.routerContext)[0];
    var _useResourceStore = (0, _slicedToArray._)((0, _resourceStore.useResourceStore)({
        type: resource.type,
        key: key
    }), 1), slice = _useResourceStore[0]; // we keep route context bound to key, so route context won't refresh
    // unless key changes. This allows refresh to be called on effect cleanup
    // or asynchronously, when route context might already have changed
    var routerContext = (0, _react.useMemo)(function() {
        return (options == null ? void 0 : options.routerContext) || getRouterContext();
    }, [
        key
    ]);
    var update = (0, _react.useCallback)(function(updater) {
        actions.updateResourceState(resource, routerContext, updater);
    }, [
        resource,
        routerContext,
        actions
    ]);
    var clear = (0, _react.useCallback)(function() {
        actions.clearResource(resource, routerContext);
    }, [
        resource,
        routerContext,
        actions
    ]);
    var clearAll = (0, _react.useCallback)(function() {
        actions.clearResource(resource);
    }, [
        resource,
        actions
    ]);
    var refresh = (0, _react.useCallback)(function() {
        actions.getResourceFromRemote(resource, routerContext, {
            prefetch: false
        });
    }, [
        resource,
        routerContext,
        actions
    ]);
    return (0, _extendsDefault.default)((0, _extendsDefault.default)({}, slice), {}, {
        update: update,
        key: key,
        refresh: refresh,
        clear: clear,
        clearAll: clearAll
    });
};

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","@babel/runtime/helpers/extends":"3LZYG","react":"ltHCL","../../resource-store":"bHILc","../../router-store":"hf6U0","react-sweet-state":"b2YYl","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bHILc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResourceDependencyError", function() {
    return 0, _utils.ResourceDependencyError;
});
parcelHelpers.export(exports, "privateActions", function() {
    return privateActions;
});
parcelHelpers.export(exports, "actions", function() {
    return actions;
});
parcelHelpers.export(exports, "ResourceStore", function() {
    return ResourceStore;
});
parcelHelpers.export(exports, "ResourceContainer", function() {
    return ResourceContainer;
});
parcelHelpers.export(exports, "ResourceActions", function() {
    return ResourceActions;
});
parcelHelpers.export(exports, "ResourceSubscriber", function() {
    return ResourceSubscriber;
});
parcelHelpers.export(exports, "getResourceStore", function() {
    return getResourceStore;
});
parcelHelpers.export(exports, "useResourceStore", function() {
    return useResourceStore;
});
parcelHelpers.export(exports, "useResourceStoreContext", function() {
    return useResourceStoreContext;
});
parcelHelpers.export(exports, "useResourceActions", function() {
    return useResourceActions;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _reactSweetState = require("react-sweet-state");
var _selectors = require("./selectors");
var _utils = require("./utils");
var _privateActions, _privateActions1, _privateActions2;
var PREFETCH_MAX_AGE = 10000;
var privateActions = {
    /**
   * Clears a resource for the current key, or where context is not provided all keys.
   */ clearResource: function(resource, routerStoreContext) {
        return function(param) {
            var getState = param.getState, dispatch = param.dispatch;
            var type = resource.type, getKey = resource.getKey;
            var context = getState().context;
            if (routerStoreContext) {
                var key = getKey(routerStoreContext, context);
                dispatch((0, _utils.deleteResourceState)(type, key));
                dispatch((0, _utils.executeForDependents)(resource, function(dependentResource) {
                    return privateActions.clearResource(dependentResource, routerStoreContext);
                }));
            } else dispatch((0, _utils.deleteResourceState)(type));
        };
    },
    /**
   * Update the data property for a resource in the cache and reset expiresAt based
   * on maxAge.
   */ updateResourceState: function(resource, routerStoreContext, getNewSliceData) {
        return function(param) {
            var getState = param.getState, dispatch = param.dispatch;
            var type = resource.type, getKey = resource.getKey, maxAge = resource.maxAge;
            var _getState = getState(), context = _getState.context, resourceStoreState = (0, _objectWithoutPropertiesLooseDefault.default)(_getState, [
                "context"
            ]);
            var key = getKey(routerStoreContext, context);
            var prevSlice = (0, _selectors.getSliceForResource)(resourceStoreState, {
                type: type,
                key: key
            });
            var data = getNewSliceData(prevSlice.data);
            var changes = prevSlice.loading ? {
                data: data,
                error: null,
                loading: true // promise: existing value retained
            } : {
                data: data,
                error: null,
                loading: false,
                promise: Promise.resolve(data)
            };
            var newSlice = (0, _extendsDefault.default)((0, _extendsDefault.default)((0, _extendsDefault.default)({}, prevSlice), changes), {}, {
                expiresAt: (0, _utils.getExpiresAt)(maxAge),
                accessedAt: (0, _utils.getAccessedAt)()
            });
            dispatch((0, _utils.setResourceState)(type, key, newSlice)); // trigger dependent resources on change
            if (newSlice.data !== prevSlice.data) dispatch((0, _utils.executeForDependents)(resource, function(dependentResource) {
                return privateActions.getResourceFromRemote(dependentResource, routerStoreContext, {});
            }));
        };
    },
    /**
   * Get a single resource, either from the cache if it exists and has not expired, or
   * the remote if it has expired.
   */ getResource: function(resource, routerStoreContext, options) {
        return function(param) {
            var getState = param.getState, dispatch = param.dispatch;
            return (0, _asyncToGenerator._)(function() {
                var type, getKey, maxAge, _getState2, context, resourceStoreState, key, cached, withResolvedPromise;
                return (0, _tsGenerator._)(this, function(_state) {
                    type = resource.type, getKey = resource.getKey, maxAge = resource.maxAge;
                    _getState2 = getState(), context = _getState2.context, resourceStoreState = (0, _objectWithoutPropertiesLooseDefault.default)(_getState2, [
                        "context"
                    ]);
                    key = getKey(routerStoreContext, context);
                    cached = (0, _selectors.getSliceForResource)(resourceStoreState, {
                        type: type,
                        key: key
                    });
                    if ((0, _utils.shouldUseCache)(cached)) {
                        if ((0, _utils.isFromSsr)(cached)) {
                            withResolvedPromise = (0, _utils.setSsrDataPromise)(cached);
                            cached = (0, _utils.setExpiresAt)(withResolvedPromise, maxAge);
                        }
                        cached.accessedAt = (0, _utils.getAccessedAt)();
                        dispatch((0, _utils.setResourceState)(type, key, cached));
                        return [
                            2,
                            cached
                        ];
                    }
                    return [
                        2,
                        dispatch(privateActions.getResourceFromRemote(resource, routerStoreContext, options))
                    ];
                });
            })();
        };
    },
    /**
   * Request a single resource and update the resource cache.
   */ getResourceFromRemote: function(resource, routerStoreContext, options) {
        return function(param) {
            var getState = param.getState, dispatch = param.dispatch;
            return (0, _asyncToGenerator._)(function() {
                var type, getKey, getData, maxAge, prefetch, timeout, _getState3, context, resourceStoreState, key, prevSlice, promiseOrData, resolvedSlice, timeoutGuard, promise, data, error, finalSlice;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            type = resource.type, getKey = resource.getKey, getData = resource.getData, maxAge = resource.maxAge;
                            prefetch = options.prefetch, timeout = options.timeout;
                            _getState3 = getState(), context = _getState3.context, resourceStoreState = (0, _objectWithoutPropertiesLooseDefault.default)(_getState3, [
                                "context"
                            ]);
                            key = getKey(routerStoreContext, context);
                            prevSlice = (0, _selectors.getSliceForResource)(resourceStoreState, {
                                type: type,
                                key: key
                            }); // abort request if already in flight
                            if (prevSlice.loading) return [
                                2,
                                prevSlice
                            ];
                            dispatch((0, _utils.validateLRUCache)(resource, key)); // hard errors in dependencies or getData are converted into softer async error
                            try {
                                promiseOrData = getData((0, _extendsDefault.default)((0, _extendsDefault.default)({}, routerStoreContext), {}, {
                                    isPrefetch: !!prefetch,
                                    dependencies: dispatch((0, _utils.getDependencies)(resource, routerStoreContext))
                                }), context);
                            } catch (error) {
                                promiseOrData = Promise.reject(error);
                            }
                            if (!(promiseOrData === prevSlice.data)) return [
                                3,
                                1
                            ];
                            // same data (by reference) means nothing has changed and we can avoid loading state
                            resolvedSlice = {};
                            return [
                                3,
                                5
                            ];
                        case 1:
                            // ensure the promise includes any timeout error
                            timeoutGuard = timeout ? (0, _utils.generateTimeGuard)(timeout) : null;
                            promise = timeout ? Promise.race([
                                promiseOrData,
                                timeoutGuard == null ? void 0 : timeoutGuard.promise
                            ]).then(function(maybeData) {
                                if (timeoutGuard && !timeoutGuard.isPending) throw new (0, _utils.TimeoutError)(type);
                                (timeoutGuard == null ? void 0 : timeoutGuard.timerId) && clearTimeout(timeoutGuard.timerId);
                                return maybeData;
                            }) : (0, _utils.toPromise)(promiseOrData); // enter loading state
                            dispatch((0, _utils.setResourceState)(type, key, (0, _extendsDefault.default)((0, _extendsDefault.default)({}, prevSlice), {}, {
                                data: maxAge === 0 ? null : prevSlice.data,
                                error: maxAge === 0 ? null : prevSlice.error,
                                loading: true,
                                promise: promise,
                                accessedAt: (0, _utils.getAccessedAt)(),
                                // prevent resource from being cleaned prematurely and trigger more network requests.
                                expiresAt: options.prefetch ? (0, _utils.getExpiresAt)(PREFETCH_MAX_AGE) : prevSlice.expiresAt
                            }))); // trigger dependent resources to also load
                            dispatch((0, _utils.executeForDependents)(resource, function(dependentResource) {
                                return privateActions.getResourceFromRemote(dependentResource, routerStoreContext, options);
                            })); // in case another action occurred while loading promise may not be the one we started with
                            _state.label = 2;
                        case 2:
                            _state.trys.push([
                                2,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4,
                                promise
                            ];
                        case 3:
                            data = _state.sent();
                            resolvedSlice = {
                                data: data,
                                error: null,
                                // any existing error is cleared
                                loading: false,
                                promise: promise
                            };
                            return [
                                3,
                                5
                            ];
                        case 4:
                            error = _state.sent();
                            if ((0, _instanceof._)(error, (0, _utils.TimeoutError))) resolvedSlice = {
                                // data: do not replace existing data
                                error: error,
                                loading: true,
                                // this condition cannot recover so must only be present in static/server router
                                promise: null // special case for timeout
                            };
                            else resolvedSlice = {
                                // data: do not replace existing data
                                error: error,
                                loading: false,
                                promise: promise
                            };
                            return [
                                3,
                                5
                            ];
                        case 5:
                            finalSlice = (0, _extendsDefault.default)((0, _extendsDefault.default)((0, _extendsDefault.default)({}, (0, _selectors.getSliceForResource)(getState(), {
                                type: type,
                                key: key
                            })), resolvedSlice), {}, {
                                accessedAt: (0, _utils.getAccessedAt)(),
                                expiresAt: (0, _utils.getExpiresAt)(options.prefetch && maxAge < PREFETCH_MAX_AGE ? PREFETCH_MAX_AGE : maxAge)
                            });
                            if (dispatch((0, _utils.getResourceState)(type, key))) dispatch((0, _utils.setResourceState)(type, key, finalSlice));
                            return [
                                2,
                                finalSlice
                            ];
                    }
                });
            })();
        };
    }
};
var actions = {
    /**
   * Clears a resource for the current key, or where context is not provided all keys.
   * Execute such that dependencies on current route will be cleared.
   */ clearResource: function(resource, routerStoreContext) {
        return (0, _utils.actionWithDependencies)(routerStoreContext == null ? void 0 : routerStoreContext.route.resources, resource, privateActions.clearResource(resource, routerStoreContext != null ? routerStoreContext : null));
    },
    /**
   * Update the data property for a resource in the cache and reset expiresAt based
   * on maxAge.
   * Execute such that dependencies on current route will be updated.
   */ updateResourceState: function(resource, routerStoreContext) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
            args[_key - 2] = arguments[_key];
        }
        return (0, _utils.actionWithDependencies)(routerStoreContext.route.resources, resource, (_privateActions = privateActions).updateResourceState.apply(_privateActions, [
            resource,
            routerStoreContext
        ].concat((0, _toConsumableArray._)(args))));
    },
    /**
   * Get a single resource, either from the cache if it exists and has not expired, or
   * the remote if it has expired.
   * Execute such that dependencies on current route will be updated.
   */ getResource: function(resource, routerStoreContext) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
            args[_key - 2] = arguments[_key];
        }
        return (0, _utils.actionWithDependencies)(routerStoreContext.route.resources, resource, (_privateActions1 = privateActions).getResource.apply(_privateActions1, [
            resource,
            routerStoreContext
        ].concat((0, _toConsumableArray._)(args))));
    },
    /**
   * Request a single resource and update the resource cache.
   * Execute such that dependencies on current route will be updated.
   */ getResourceFromRemote: function(resource, routerStoreContext) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
            args[_key - 2] = arguments[_key];
        }
        return (0, _utils.actionWithDependencies)(routerStoreContext.route.resources, resource, (_privateActions2 = privateActions).getResourceFromRemote.apply(_privateActions2, [
            resource,
            routerStoreContext
        ].concat((0, _toConsumableArray._)(args))));
    },
    /**
   * Request all resources.
   */ requestAllResources: function(routerStoreContext, options) {
        return function(param) {
            var dispatch = param.dispatch;
            var route = (routerStoreContext || {}).route;
            if (!route || !route.resources) return Promise.all([]);
            return Promise.all(dispatch(actions.requestResources(route.resources, routerStoreContext, options || {})));
        };
    },
    /**
   * Cleans expired resources and resets them back to their initial state.
   * We need to do this when transitioning into a route.
   */ cleanExpiredResources: function(resources, routerStoreContext) {
        return function(param) {
            var getState = param.getState, dispatch = param.dispatch;
            var _getState = getState(), resourceContext = _getState.context;
            resources.forEach(function(resource) {
                var type = resource.type, getKey = resource.getKey;
                var key = getKey(routerStoreContext, resourceContext);
                var slice = dispatch((0, _utils.getResourceState)(type, key));
                if (slice && (!slice.expiresAt || slice.expiresAt < Date.now())) dispatch((0, _utils.deleteResourceState)(type, key));
            });
        };
    },
    /**
   * Requests a specific set of resources.
   */ requestResources: function(resources, routerStoreContext, options) {
        var _routerStoreContext$r;
        var predicate = options.isStatic ? function(param) {
            var isBrowserOnly = param.isBrowserOnly;
            return !isBrowserOnly;
        } : function() {
            return true;
        };
        return (0, _utils.mapActionWithDependencies)((_routerStoreContext$r = routerStoreContext.route.resources) == null ? void 0 : _routerStoreContext$r.filter(predicate), resources.filter(predicate), function(resource) {
            return privateActions.getResource(resource, routerStoreContext, options);
        });
    },
    /**
   * Hydrates the store with state.
   * Will not override pre-hydrated state.
   */ hydrate: function(param) {
        var resourceData = param.resourceData, resourceContext = param.resourceContext;
        return function(param) {
            var getState = param.getState, setState = param.setState;
            var _getState = getState(), data = _getState.data, context = _getState.context;
            function getNextStateValue(prev, next) {
                if (!Object.keys(prev).length && next && Object.keys(next).length) return next;
                return prev;
            }
            var hydratedData = (0, _utils.transformData)(getNextStateValue(data, resourceData), function(_ref) {
                var error = _ref.error, expiresAt = _ref.expiresAt, loading = _ref.loading, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, [
                    "error",
                    "expiresAt",
                    "loading"
                ]);
                var deserializedError = !error ? null : (0, _utils.deserializeError)(error);
                var isTimeoutError = (deserializedError == null ? void 0 : deserializedError.name) === 'TimeoutError';
                return (0, _extendsDefault.default)((0, _extendsDefault.default)({}, rest), {}, {
                    expiresAt: isTimeoutError ? Date.now() - 1 : expiresAt,
                    loading: isTimeoutError ? false : loading,
                    error: deserializedError
                });
            });
            setState({
                data: hydratedData,
                context: getNextStateValue(context, resourceContext)
            });
        };
    },
    /**
   * Gets the store's context
   */ getContext: function() {
        return function(param) {
            var getState = param.getState;
            return getState().context;
        };
    },
    /**
   * Returns safe, portable and rehydratable data.
   */ getSafeData: function() {
        return function(param) {
            var getState = param.getState;
            return (0, _utils.transformData)(getState().data, function(param) {
                var data = param.data, key = param.key, error = param.error, loading = param.loading;
                return {
                    data: data,
                    key: key,
                    promise: null,
                    expiresAt: null,
                    accessedAt: null,
                    error: !error ? null : (0, _utils.serializeError)((0, _instanceof._)(error, Error) ? error : new Error(JSON.stringify(error))),
                    loading: (0, _instanceof._)(error, (0, _utils.TimeoutError)) ? loading : false
                };
            });
        };
    }
};
var ResourceStore = (0, _reactSweetState.createStore)({
    initialState: {
        data: {},
        context: {},
        executing: null
    },
    actions: actions,
    name: 'router-resources'
});
var ResourceContainer = (0, _reactSweetState.createContainer)(ResourceStore, {
    displayName: 'ResourceContainer'
});
var ResourceActions = (0, _reactSweetState.createSubscriber)(ResourceStore, {
    selector: null
});
var ResourceSubscriber = (0, _reactSweetState.createSubscriber)(ResourceStore, {
    displayName: 'ResourceSelectorSubscriber',
    selector: function(state, props) {
        return (0, _selectors.getSliceForResource)(state, {
            type: props.resourceType,
            key: props.resourceKey
        });
    }
});
var getResourceStore = function() {
    return (0, _reactSweetState.defaultRegistry).getStore(ResourceStore);
};
var useResourceStore = (0, _reactSweetState.createHook)(ResourceStore, {
    selector: (0, _selectors.getSliceForResource)
});
var useResourceStoreContext = (0, _reactSweetState.createHook)(ResourceStore, {
    selector: (0, _selectors.getResourceStoreContext)
});
var useResourceActions = (0, _reactSweetState.createHook)(ResourceStore, {
    selector: null
});

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_to_consumable_array":"1eSZf","@swc/helpers/_/_ts_generator":"78Tqx","@babel/runtime/helpers/extends":"3LZYG","@babel/runtime/helpers/objectWithoutPropertiesLoose":"5JG3D","react-sweet-state":"b2YYl","./selectors":"crCaE","./utils":"8XzFG","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5JG3D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _objectWithoutPropertiesLoose;
});
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"b2YYl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createContainer", function() {
    return 0, _container.createContainer;
});
parcelHelpers.export(exports, "createSubscriber", function() {
    return 0, _subscriber.createSubscriber;
});
parcelHelpers.export(exports, "createHook", function() {
    return 0, _hook.createHook;
});
parcelHelpers.export(exports, "createActionsHook", function() {
    return 0, _hook.createActionsHook;
});
parcelHelpers.export(exports, "createStateHook", function() {
    return 0, _hook.createStateHook;
});
parcelHelpers.export(exports, "defaults", function() {
    return 0, _defaultsDefault.default;
});
parcelHelpers.export(exports, "createStore", function() {
    return 0, _store.createStore;
});
parcelHelpers.export(exports, "defaultRegistry", function() {
    return 0, _store.defaultRegistry;
});
parcelHelpers.export(exports, "batch", function() {
    return 0, _batchedUpdates.batch;
});
parcelHelpers.export(exports, "createSelector", function() {
    return 0, _createSelector.createSelector;
});
var _container = require("./components/container");
var _subscriber = require("./components/subscriber");
var _hook = require("./components/hook");
var _defaults = require("./defaults");
var _defaultsDefault = parcelHelpers.interopDefault(_defaults);
var _store = require("./store");
var _batchedUpdates = require("./utils/batched-updates");
var _createSelector = require("./utils/create-selector");

},{"./components/container":"jP0or","./components/subscriber":"8NNQo","./components/hook":"bfSa5","./defaults":false,"./store":"6fmkS","./utils/batched-updates":"9S6Im","./utils/create-selector":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jP0or":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createContainer", function() {
    return createContainer;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _context = require("../context");
var _store = require("../store");
var _shallowEqual = require("../utils/shallow-equal");
var _shallowEqualDefault = parcelHelpers.interopDefault(_shallowEqual);
var _excluded = [
    "children"
], _excluded2 = [
    "scope",
    "isGlobal"
];
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var noop = function() {
    return function() {};
};
function createContainer(StoreOrOptions, _temp) {
    if (StoreOrOptions === void 0) StoreOrOptions = {};
    var _ref = _temp === void 0 ? {} : _temp, tmp = _ref.onInit, _onInit = tmp === void 0 ? noop : tmp, _ref_onUpdate = _ref.onUpdate, onUpdate = _ref_onUpdate === void 0 ? noop : _ref_onUpdate, _ref_onCleanup = _ref.onCleanup, onCleanup = _ref_onCleanup === void 0 ? noop : _ref_onCleanup, _ref_displayName = _ref.displayName, displayName = _ref_displayName === void 0 ? '' : _ref_displayName;
    if ('key' in StoreOrOptions) {
        var Store = StoreOrOptions;
        var dn = displayName || "Container(".concat(Store.key.split('__')[0], ")");
        return createFunctionContainer({
            displayName: dn,
            // compat fields
            override: {
                Store: Store,
                handlers: Object.assign({}, _onInit !== noop && {
                    onInit: function() {
                        return _onInit();
                    }
                }, onCleanup !== noop && {
                    onDestroy: function() {
                        return onCleanup();
                    }
                }, onUpdate !== noop && {
                    onContainerUpdate: function() {
                        return onUpdate();
                    }
                })
            }
        });
    }
    return createFunctionContainer(StoreOrOptions);
}
function useRegistry(scope, isGlobal, _ref) {
    var globalRegistry = _ref.globalRegistry;
    return (0, _react.useMemo)(function() {
        var isLocal = !scope && !isGlobal;
        return isLocal ? new (0, _store.StoreRegistry)('__local__') : globalRegistry;
    }, [
        scope,
        isGlobal,
        globalRegistry
    ]);
}
function useContainedStore(scope, registry, propsRef, check, override) {
    // Store contained scopes in a map, but throwing it away on scope change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var containedStores = (0, _react.useMemo)(function() {
        return new Map();
    }, [
        scope
    ]);
    var getContainedStore = (0, _react.useCallback)(function(Store) {
        var containedStore = containedStores.get(Store); // first time it gets called we add store to contained map bound
        // so we can provide props to actions (only triggered by children)
        if (!containedStore) {
            var isExisting = registry.hasStore(Store, scope);
            var config = {
                props: function() {
                    return propsRef.current.sub;
                },
                contained: check
            };
            var storeState = registry.getStore(Store, scope, config).storeState;
            var actions = (0, _store.bindActions)(Store.actions, storeState, config);
            var handlers = (0, _store.bindActions)(Object.assign({}, Store.handlers, override == null ? void 0 : override.handlers), storeState, config, actions);
            containedStore = {
                storeState: storeState,
                actions: actions,
                handlers: handlers,
                unsubscribe: undefined
            };
            containedStores.set(Store, containedStore); // Signal store is contained and ready now, so by the time
            // consumers subscribe we already have updated the store (if needed).
            // Also if override maintain legacy behaviour, triggered on every mount
            if (!isExisting || override) handlers.onInit == null || handlers.onInit();
        }
        return containedStore;
    }, [
        containedStores,
        scope,
        registry,
        propsRef,
        check,
        override
    ]);
    return [
        containedStores,
        getContainedStore
    ];
}
function useApi(check, getContainedStore, _ref2) {
    var globalRegistry = _ref2.globalRegistry, retrieveStore = _ref2.retrieveStore;
    var retrieveRef = (0, _react.useRef)();
    retrieveRef.current = function(Store) {
        return check(Store) ? getContainedStore(Store) : retrieveStore(Store);
    }; // This api is "frozen", as changing it will trigger re-render across all consumers
    // so we link retrieveStore dynamically and manually call notify() on scope change
    return (0, _react.useMemo)(function() {
        return {
            globalRegistry: globalRegistry,
            retrieveStore: function(s) {
                return retrieveRef.current(s);
            }
        };
    }, [
        globalRegistry
    ]);
}
function createFunctionContainer(_temp2) {
    var _ref = _temp2 === void 0 ? {} : _temp2, displayName = _ref.displayName, override = _ref.override;
    var check = function(store) {
        return override ? store === override.Store : store.containedBy === FunctionContainer;
    };
    function FunctionContainer(props) {
        var children = props.children, restProps = _objectWithoutPropertiesLoose(props, _excluded);
        var scope = restProps.scope, isGlobal = restProps.isGlobal, subProps = _objectWithoutPropertiesLoose(restProps, _excluded2);
        var ctx = (0, _react.useContext)((0, _context.Context));
        var registry = useRegistry(scope, isGlobal, ctx); // Store props in a ref to avoid re-binding actions when they change and re-rendering all
        // consumers unnecessarily. The update is handled by an effect on the component instead
        var propsRef = (0, _react.useRef)({
            prev: null,
            next: restProps,
            sub: subProps
        });
        propsRef.current = {
            prev: propsRef.current.next,
            next: restProps,
            sub: subProps // TODO remove on next major
        };
        var _useContainedStore = (0, _slicedToArray._)(useContainedStore(scope, registry, propsRef, check, override), 2), containedStores = _useContainedStore[0], getContainedStore = _useContainedStore[1]; // Use a stable object as is passed as value to context Provider
        var api = useApi(check, getContainedStore, ctx); // This listens for custom props change, and so we trigger container update actions
        // before the re-render gets to consumers (hence why side effect on render).
        // We do not use React hooks because num of restProps might change and react will throws
        if (!(0, _shallowEqualDefault.default)(propsRef.current.next, propsRef.current.prev)) containedStores.forEach(function(_ref3) {
            var handlers = _ref3.handlers;
            handlers.onContainerUpdate == null || handlers.onContainerUpdate(propsRef.current.next, propsRef.current.prev);
        });
         // Every time we add/remove a contained store, we ensure we are subscribed to the updates
        // as an effect to properly handle strict mode
        (0, _react.useEffect)(function() {
            containedStores.forEach(function(containedStore) {
                if (!containedStore.unsubscribe) {
                    var unsub = containedStore.storeState.subscribe(function() {
                        return containedStore.handlers.onUpdate == null ? void 0 : containedStore.handlers.onUpdate();
                    });
                    containedStore.unsubscribe = function() {
                        unsub();
                        containedStore.unsubscribe = undefined;
                    };
                }
            });
        }, [
            containedStores,
            containedStores.size
        ]); // We support renderding "bootstrap" containers without children with override API
        // so in this case we call getCS to initialize the store globally asap
        if (override && !containedStores.size && (scope || isGlobal)) getContainedStore(override.Store);
         // This listens for scope change or component unmount, to notify all consumers
        // so all work is done on cleanup
        (0, _react.useEffect)(function() {
            return function() {
                containedStores.forEach(function(_ref4, Store) {
                    var storeState = _ref4.storeState, handlers = _ref4.handlers, unsubscribe = _ref4.unsubscribe;
                    // Detatch container from subscription
                    unsubscribe == null || unsubscribe(); // Trigger a forced update on all subscribers as we opted out from context
                    // Some might have already re-rendered naturally, but we "force update" all anyway.
                    // This is sub-optimal as if there are other containers with the same
                    // old scope id we will re-render those too, but still better than context
                    storeState.notify(); // Given unsubscription is handled by useSyncExternalStore, we have no control on when
                    // React decides to do it. So we schedule on next tick to run last
                    Promise.resolve().then(function() {
                        var _registry$getStore;
                        if (!storeState.listeners().size && // ensure registry has not already created a new store with same scope
                        storeState === ((_registry$getStore = registry.getStore(Store, scope, null)) == null ? void 0 : _registry$getStore.storeState)) {
                            handlers.onDestroy == null || handlers.onDestroy(); // We only delete scoped stores, as global shall persist and local are auto-deleted
                            if (!isGlobal) registry.deleteStore(Store, scope);
                        }
                    });
                }); // no need to reset containedStores as the map is already bound to scope
            };
        }, [
            registry,
            scope,
            isGlobal,
            containedStores
        ]);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _context.Context).Provider, {
            value: api
        }, children);
    }
    FunctionContainer.displayName = displayName || "Container";
    FunctionContainer.propTypes = {
        children: (0, _propTypesDefault.default).node,
        scope: (0, _propTypesDefault.default).string,
        isGlobal: (0, _propTypesDefault.default).bool
    };
    return FunctionContainer;
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","react":"ltHCL","prop-types":"3k3Jl","../context":"hPWjQ","../store":"6fmkS","../utils/shallow-equal":"bJC2B","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3k3Jl":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactIs, throwOnDirectAccess;
// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = require("ed6da1efdf0843df")();

},{"ed6da1efdf0843df":"aJ9MT"}],"aJ9MT":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var ReactPropTypesSecret = require("a14ca52499881b1e");
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

},{"a14ca52499881b1e":"fJTIM"}],"fJTIM":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = ReactPropTypesSecret;

},{}],"hPWjQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Context", function() {
    return Context;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _store = require // Provide static calculateChangedBit to opt-out from context updates
("./store");
var Context = /*#__PURE__*/ (0, _reactDefault.default).createContext({
    globalRegistry: (0, _store.defaultRegistry),
    retrieveStore: function(Store) {
        return (0, _store.defaultRegistry).getStore(Store);
    }
}, function() {
    return 0;
});

},{"react":"ltHCL","./store":"6fmkS","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6fmkS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bindAction", function() {
    return 0, _bindActions.bindAction;
});
parcelHelpers.export(exports, "bindActions", function() {
    return 0, _bindActions.bindActions;
});
parcelHelpers.export(exports, "createStore", function() {
    return 0, _create.createStore;
});
parcelHelpers.export(exports, "StoreRegistry", function() {
    return 0, _registry.StoreRegistry;
});
parcelHelpers.export(exports, "defaultRegistry", function() {
    return 0, _registry.defaultRegistry;
});
var _bindActions = require("./bind-actions");
var _create = require("./create");
var _registry = require("./registry");

},{"./bind-actions":"90CyA","./create":"a0rqy","./registry":"bq4Th","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"90CyA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bindAction", function() {
    return bindAction;
});
parcelHelpers.export(exports, "bindActions", function() {
    return bindActions;
});
var _defaults = require("../defaults");
var _defaultsDefault = parcelHelpers.interopDefault(_defaults);
var namedMutator = function(storeState, actionName) {
    return function namedMutator() {
        var _storeState;
        storeState.mutator.actionName = actionName;
        return (_storeState = storeState).mutator.apply(_storeState, arguments);
    };
};
var warnings = new WeakMap();
var bindAction = function(storeState, actionFn, actionKey, config, actions) {
    var callThunk = function(instance, thunkFn, actionName) {
        return thunkFn({
            setState: (0, _defaultsDefault.default).devtools ? namedMutator(instance.storeState, actionName) : instance.storeState.mutator,
            getState: instance.storeState.getState,
            get actions () {
                if (!warnings.has(actionFn)) warnings.set(actionFn, console.warn("react-sweet-state 'actions' property has been deprecated and will be removed in the next mayor. " + "Please check action '".concat(actionName, "' of Store '").concat(instance.storeState.key, "' and use 'dispatch' instead")));
                return actions;
            },
            dispatch: function(tFn) {
                return callThunk(instance, tFn, "".concat(actionName, ".dispatch"));
            }
        }, config.props());
    };
    return function bindAction() {
        return callThunk({
            storeState: storeState,
            actions: actions
        }, actionFn.apply(void 0, arguments), actionKey);
    };
};
var bindActions = function bindActions(actions, storeState, config, boundActions) {
    if (boundActions === void 0) boundActions = null;
    return Object.keys(actions).reduce(function(acc, k) {
        acc[k] = bindAction(storeState, actions[k], k, config, boundActions || acc);
        return acc;
    }, {});
};

},{"../defaults":"8E710","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8E710":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var defaultMutator = function(prevState, partialState) {
    // Merge the partial state and the previous state.
    return Object.assign({}, prevState, partialState);
};
var defaults = {
    batchUpdates: 'useSyncExternalStore' in (0, _reactDefault.default),
    devtools: false,
    middlewares: new Set(),
    mutator: defaultMutator
};
exports.default = defaults;

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"a0rqy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createStore", function() {
    return createStore;
});
var _hash = require("../utils/hash");
var _hashDefault = parcelHelpers.interopDefault(_hash);
function createKey(initialState, actions, name) {
    var src = !name ? Object.keys(actions).reduce(function(acc, k) {
        return acc + actions[k].toString();
    }, '') : '';
    return [
        name,
        (0, _hashDefault.default)(src + JSON.stringify(initialState))
    ].filter(Boolean).join('__');
}
function createStore(_ref) {
    var _ref_name = _ref.name, name = _ref_name === void 0 ? '' : _ref_name, initialState = _ref.initialState, actions = _ref.actions, containedBy = _ref.containedBy, _ref_handlers = _ref.handlers, handlers = _ref_handlers === void 0 ? {} : _ref_handlers;
    var key;
    return {
        get key () {
            // lazy evaluate key on first access
            return key || (key = createKey(initialState, actions, name));
        },
        initialState: initialState,
        actions: actions,
        containedBy: containedBy,
        handlers: handlers
    };
}

},{"../utils/hash":"dp6IL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dp6IL":[function(require,module,exports,__globalThis) {
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return murmurhash2_32_gc;
});
function murmurhash2_32_gc(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bq4Th":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GLOBAL_SCOPE", function() {
    return GLOBAL_SCOPE;
});
parcelHelpers.export(exports, "StoreRegistry", function() {
    return StoreRegistry;
});
parcelHelpers.export(exports, "defaultRegistry", function() {
    return defaultRegistry;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _supportedFeatures = require("../utils/supported-features");
var _supportedFeaturesDefault = parcelHelpers.interopDefault(_supportedFeatures);
var _bindActions = require("./bind-actions");
var _createState = require("./create-state");
var _createStateDefault = parcelHelpers.interopDefault(_createState);
var GLOBAL_SCOPE = '__global__';
var StoreRegistry = function StoreRegistry(defaultScope) {
    "use strict";
    var _this = this;
    (0, _classCallCheck._)(this, StoreRegistry);
    var _this1 = this;
    if (defaultScope === void 0) defaultScope = GLOBAL_SCOPE;
    this.stores = new Map();
    this.initStore = function(key, Store, config) {
        var initialState = Store.initialState, actions = Store.actions;
        if (Store.containedBy && !config.contained(Store)) {
            var err = new Error("Store ".concat(Store.key, " should be contained by a container but it is used globally. ") + "While it might still work, it will likely cause unexpected behaviours.");
            if ((0, _supportedFeaturesDefault.default).scheduling()) Promise.reject(err);
            else throw err;
        }
        var storeState = (0, _createStateDefault.default)(key, initialState);
        var boundActions;
        var store = {
            storeState: storeState,
            // these are used only when container-less, so we generate them on-demand
            get actions () {
                if (!boundActions) boundActions = (0, _bindActions.bindActions)(actions, storeState, config);
                return boundActions;
            }
        };
        _this.stores.set(key, store);
        return store;
    };
    this.hasStore = function(Store, scopeId) {
        if (scopeId === void 0) scopeId = _this1.defaultScope;
        var key = _this1.generateKey(Store, scopeId);
        return _this1.stores.has(key);
    };
    this.getStore = function(Store, scopeId, config) {
        if (scopeId === void 0) scopeId = _this1.defaultScope;
        if (config === void 0) config = {
            props: function() {
                return {};
            },
            contained: function() {
                return false;
            }
        };
        var key = _this1.generateKey(Store, scopeId);
        return _this1.stores.get(key) || config && _this1.initStore(key, Store, config);
    };
    this.deleteStore = function(Store, scopeId) {
        if (scopeId === void 0) scopeId = _this1.defaultScope;
        var key = _this1.generateKey(Store, scopeId);
        _this1.stores.delete(key);
    };
    this.generateKey = function(Store, scopeId) {
        return "".concat(Store.key, "@").concat(scopeId);
    };
    this.defaultScope = defaultScope;
};
var defaultRegistry = new StoreRegistry();

},{"@swc/helpers/_/_class_call_check":"5CNCO","../utils/supported-features":"e93ls","./bind-actions":"90CyA","./create-state":"e1aMx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"e93ls":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var supports = {
    scheduling: function scheduling() {
        return typeof window !== 'undefined' && typeof MessageChannel === 'function';
    }
};
exports.default = supports;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"e1aMx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _middlewares = require("../middlewares");
var _middlewaresDefault = parcelHelpers.interopDefault(_middlewares);
var _devtools = require("../enhancers/devtools");
var _devtoolsDefault = parcelHelpers.interopDefault(_devtools);
var _defaults = require("../defaults");
var _defaultsDefault = parcelHelpers.interopDefault(_defaults);
var _schedule = require("../utils/schedule");
var _scheduleDefault = parcelHelpers.interopDefault(_schedule);
function createStoreState(key, initialState) {
    var listeners = new Set();
    var currentState = initialState;
    var storeState = {
        key: key,
        getState: function getState() {
            return currentState;
        },
        setState: function setState(nextState) {
            currentState = nextState; // Instead of notifying all handlers immediately, we wait next tick
            // so multiple actions affecting the same store gets combined
            (0, _scheduleDefault.default)(storeState.notify);
        },
        resetState: function resetState() {
            storeState.setState(initialState);
        },
        notify: function notify() {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = listeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var listener = _step.value;
                    listener(storeState.getState());
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        },
        subscribe: function subscribe(listener) {
            listeners.add(listener);
            return function unsubscribe() {
                listeners.delete(listener);
            };
        },
        listeners: function listeners1() {
            return listeners;
        }
    };
    storeState.mutator = (0, _middlewaresDefault.default)(storeState, (0, _defaultsDefault.default).middlewares);
    return storeState;
}
exports.default = (0, _devtoolsDefault.default)(createStoreState);

},{"../middlewares":"7LaTP","../enhancers/devtools":"33R4l","../defaults":"8E710","../utils/schedule":"h1md3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7LaTP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaults = require("../defaults");
var _defaultsDefault = parcelHelpers.interopDefault(_defaults);
var _update = require("./update");
var _updateDefault = parcelHelpers.interopDefault(_update);
var applyMiddleware = function(storeState, middlewares) {
    return Array.from(middlewares).concat((0, _updateDefault.default)).reduceRight(function(next, mw) {
        return mw(storeState)(next);
    }, (0, _defaultsDefault.default).mutator);
};
exports.default = applyMiddleware;

},{"../defaults":"8E710","./update":"1sjAO","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1sjAO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _shallowEqual = require("../utils/shallow-equal");
var _shallowEqualDefault = parcelHelpers.interopDefault(_shallowEqual);
var updateMiddleware = function(storeState) {
    return function(next) {
        return function(arg) {
            var output;
            var state = storeState.getState();
            var nextState = next(state, arg, function(out) {
                output = out;
            });
            if (!(0, _shallowEqualDefault.default)(nextState, state)) storeState.setState(nextState);
            return output;
        };
    };
};
exports.default = updateMiddleware;

},{"../utils/shallow-equal":"bJC2B","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bJC2B":[function(require,module,exports,__globalThis) {
// Mostly copied from fbjs/packages/fbjs/src/core/shallowEqual.js
// enhanced with keys cache as might get called multiple times with same args
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return shallowEqual;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var hasOwnProperty = Object.prototype.hasOwnProperty;
var CACHE = new WeakMap();
function shallowEqual(objA, objB) {
    if (objA === objB) return true;
    if ((typeof objA === "undefined" ? "undefined" : (0, _typeOf._)(objA)) !== 'object' || objA === null || (typeof objB === "undefined" ? "undefined" : (0, _typeOf._)(objB)) !== 'object' || objB === null) return false;
    if (Array.isArray(objA) && Array.isArray(objB)) {
        // do array comparison
        if (objA.length !== objB.length) return false;
        for(var i = 0; i < objA.length; i++){
            if (objA[i] !== objB[i]) return false;
        }
        return true;
    } else {
        // Handle Date, RegExp, String, Number, ... and complex objects
        var strA = '' + objA;
        var strB = '' + objB;
        if (strA !== strB || strA[0] === '[' && strA !== '[object Object]') return false;
         // do object comparison
        var keysA;
        if (CACHE.has(objA)) keysA = CACHE.get(objA);
        else {
            keysA = Object.keys(objA);
            CACHE.set(objA, keysA);
        }
        var keysB;
        if (CACHE.has(objB)) keysB = CACHE.get(objB);
        else {
            keysB = Object.keys(objB);
            CACHE.set(objB, keysB);
        }
        if (keysA.length !== keysB.length) return false;
         // Test for A's keys different from B.
        for(var i1 = 0; i1 < keysA.length; i1++){
            if (!hasOwnProperty.call(objB, keysA[i1]) || objA[keysA[i1]] !== objB[keysA[i1]]) return false;
        }
        return true;
    }
}

},{"@swc/helpers/_/_type_of":"iFJdx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"33R4l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaults = require("../defaults");
var _defaultsDefault = parcelHelpers.interopDefault(_defaults);
var connectDevTools = function(storeState, config) {
    var devTools = window.__REDUX_DEVTOOLS_EXTENSION__.connect(Object.assign({
        name: "Store ".concat(storeState.key),
        serialize: true,
        trace: true
    }, config));
    devTools.init(storeState.getState());
    devTools.subscribe(function(message) {
        if (message.type === 'DISPATCH') switch(message.payload.type){
            case 'RESET':
                storeState.resetState();
                devTools.init(storeState.getState());
                return;
            case 'COMMIT':
                devTools.init(storeState.getState());
                return;
            case 'ROLLBACK':
                storeState.setState(JSON.parse(message.state));
                devTools.init(storeState.getState());
                return;
            case 'JUMP_TO_STATE':
            case 'JUMP_TO_ACTION':
                storeState.setState(JSON.parse(message.state));
                return;
        }
        else if (message.type === 'ACTION') {
            var action = JSON.parse(message.payload);
            storeState.setState(action.payload);
        }
    });
    return devTools;
};
var withDevtools = function(createStoreState) {
    return function withDevtools() {
        var storeState = createStoreState.apply(void 0, arguments);
        if ((0, _defaultsDefault.default).devtools && window && window.__REDUX_DEVTOOLS_EXTENSION__) {
            var origMutator = storeState.mutator;
            var devTools;
            var devtoolMutator = function(arg) {
                var result = origMutator(arg);
                try {
                    if (!devTools) {
                        var config = typeof (0, _defaultsDefault.default).devtools === 'function' ? (0, _defaultsDefault.default).devtools(storeState) : {};
                        devTools = connectDevTools(storeState, config);
                    }
                    devTools.send({
                        type: storeState.mutator.actionName,
                        payload: arg
                    }, storeState.getState(), {}, storeState.key);
                } catch (err) {
                /* ignore devtools errors */ }
                return result;
            };
            storeState.mutator = devtoolMutator;
        }
        return storeState;
    };
};
exports.default = withDevtools;

},{"../defaults":"8E710","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"h1md3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return schedule;
});
var _defaults = require("../defaults");
var _defaultsDefault = parcelHelpers.interopDefault(_defaults);
var _batchedUpdates = require("./batched-updates");
var _supportedFeatures = require("./supported-features");
var _supportedFeaturesDefault = parcelHelpers.interopDefault(_supportedFeatures);
var QUEUE = [];
var scheduled;
function schedule(fn) {
    // if we are in node/tests or feature disabled, make updates sync batched
    if (!(0, _defaultsDefault.default).batchUpdates || !(0, _supportedFeaturesDefault.default).scheduling()) return (0, _batchedUpdates.batch)(function() {
        return fn();
    }); // Add to queue if not already there
    // so we avoid multiple notifications to same store listeners
    if (!QUEUE.includes(fn)) QUEUE.push(fn); // if something already started schedule, skip
    if (scheduled) return;
    scheduled = (0, _batchedUpdates.batch)(function() {
        var queueFn;
        while(queueFn = QUEUE.shift())queueFn();
        scheduled = null;
    });
}

},{"../defaults":"8E710","./batched-updates":"9S6Im","./supported-features":"e93ls","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9S6Im":[function(require,module,exports,__globalThis) {
/* eslint-disable import/no-unresolved */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "batch", function() {
    return batch;
});
var _reactDom = require("react-dom");
var _scheduler = require("scheduler");
var _defaults = require("../defaults");
var _defaultsDefault = parcelHelpers.interopDefault(_defaults);
var _supportedFeatures = require("./supported-features");
var _supportedFeaturesDefault = parcelHelpers.interopDefault(_supportedFeatures);
var isInsideBatchedSchedule = false;
function batch(fn) {
    // if we are in node/tests or nested schedule
    if (!(0, _defaultsDefault.default).batchUpdates || !(0, _supportedFeaturesDefault.default).scheduling() || isInsideBatchedSchedule) return (0, _reactDom.unstable_batchedUpdates)(fn);
    isInsideBatchedSchedule = true; // Use ImmediatePriority as it has -1ms timeout
    // https://github.com/facebook/react/blob/main/packages/scheduler/src/forks/Scheduler.js#L65
    return (0, _scheduler.unstable_scheduleCallback)((0, _scheduler.unstable_ImmediatePriority), function scheduleBatchedUpdates() {
        (0, _reactDom.unstable_batchedUpdates)(fn);
        isInsideBatchedSchedule = false;
    });
}

},{"react-dom":"bvX0P","scheduler":"NHulo","../defaults":"8E710","./supported-features":"e93ls","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8NNQo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createSubscriber", function() {
    return createSubscriber;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _hook = require("./hook");
var _excluded = [
    "children"
];
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function hasAdditionalProps(props) {
    for(var i in props)return true;
    return false;
}
function createSubscriber(Store, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, selector = _ref.selector, _ref_displayName = _ref.displayName, displayName = _ref_displayName === void 0 ? '' : _ref_displayName;
    var useStore = (0, _hook.createHook)(Store, {
        selector: selector
    });
    var Subscriber = function Subscriber(_ref) {
        var children = _ref.children, rest = _objectWithoutPropertiesLoose(_ref, _excluded);
        var api = useStore(hasAdditionalProps(rest) ? rest : undefined);
        return children.apply(void 0, (0, _toConsumableArray._)(api));
    };
    Subscriber.displayName = displayName || "Subscriber(".concat(Store.key.split('__')[0], ")");
    return Subscriber;
}

},{"@swc/helpers/_/_to_consumable_array":"1eSZf","./hook":"bfSa5","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bfSa5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createHook", function() {
    return createHook;
});
parcelHelpers.export(exports, "createActionsHook", function() {
    return createActionsHook;
});
parcelHelpers.export(exports, "createStateHook", function() {
    return createStateHook;
});
var _react = require("react");
var _shim = require("use-sync-external-store/shim");
var _context = require("../context");
var _createSelector = require("../utils/create-selector");
var EMPTY_SELECTOR = function() {
    return undefined;
};
var DEFAULT_SELECTOR = function(state) {
    return state;
};
function createHook(Store, _temp) {
    var selector = (_temp === void 0 ? {} : _temp).selector;
    return function useSweetState(propsArg) {
        var retrieveStore = (0, _react.useContext)((0, _context.Context)).retrieveStore;
        var _retrieveStore = retrieveStore(Store), storeState = _retrieveStore.storeState, actions = _retrieveStore.actions;
        var hasPropsArg = propsArg !== undefined;
        var propsArgRef = (0, _react.useRef)(propsArg);
        propsArgRef.current = propsArg;
        var stateSelector = (0, _react.useMemo)(function() {
            return selector ? (0, _createSelector.getSelectorInstance)(selector, storeState, hasPropsArg) : selector === null ? EMPTY_SELECTOR : DEFAULT_SELECTOR;
        }, [
            hasPropsArg,
            storeState
        ]);
        var forceUpdate = (0, _react.useState)({})[1];
        var getSnapshot = (0, _react.useCallback)(function() {
            // parent scope has changed and notify was explicitly triggered by the container
            // we need to force the hook to re-render to listen new storeState
            if (retrieveStore(Store).storeState !== storeState) forceUpdate({});
            var state = storeState.getState();
            return stateSelector(state, propsArgRef.current);
        }, [
            retrieveStore,
            storeState,
            stateSelector,
            forceUpdate
        ]);
        var currentState = (0, _shim.useSyncExternalStore)(storeState.subscribe, getSnapshot, getSnapshot);
        return [
            currentState,
            actions
        ];
    };
}
function createActionsHook(Store) {
    var useHook = createHook(Store, {
        selector: null
    });
    return function useSweetStateActions() {
        return useHook()[1];
    };
}
function createStateHook(Store, _temp2) {
    var selector = (_temp2 === void 0 ? {} : _temp2).selector;
    var useHook = createHook(Store, {
        selector: selector
    });
    return function useSweetStateState(propsArg) {
        return useHook(propsArg)[0];
    };
}

},{"react":"ltHCL","use-sync-external-store/shim":"lEL2n","../context":"hPWjQ","../utils/create-selector":"cx73r","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lEL2n":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("1e1c6acead2dffba");

},{"1e1c6acead2dffba":"7JumU"}],"7JumU":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var React = require("76d9c8c36382bc5e");
function is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var objectIs = "function" === typeof Object.is ? Object.is : is, useState = React.useState, useEffect = React.useEffect, useLayoutEffect = React.useLayoutEffect, useDebugValue = React.useDebugValue;
function useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    useEffect(function() {
        checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    useDebugValue(value);
    return value;
}
function checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? useSyncExternalStore$1 : useSyncExternalStore$2;
exports.useSyncExternalStore = void 0 !== React.useSyncExternalStore ? React.useSyncExternalStore : shim;

},{"76d9c8c36382bc5e":"ltHCL"}],"cx73r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createSelector", function() {
    return createSelector;
});
parcelHelpers.export(exports, "createMemoizedSelector", function() {
    return createMemoizedSelector;
});
parcelHelpers.export(exports, "getSelectorInstance", function() {
    return getSelectorInstance;
});
var _memoize = require // customised version of reselect
("./memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
function createSelector() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    var resultFunc = funcs.pop();
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    var memoizedResultFunc = (0, _memoizeDefault.default)(function() {
        return resultFunc.apply(null, arguments);
    }); // this memoisation is optimised for 2 arguments (state, props)
    var selector = (0, _memoizeDefault.default)(function() {
        // calculate all dependencies results
        var params = [];
        for(var i = 0; i < dependencies.length; i++)params.push(dependencies[i].apply(null, arguments));
         // then call the final func with all them as arguments
        return memoizedResultFunc.apply(null, params);
    }, true); // expose so we can create per scope selectors
    // API compatible with reselect@^4
    selector.resultFunc = resultFunc;
    selector.dependencies = dependencies;
    return selector;
}
function createMemoizedSelector(selector) {
    var isReselector = typeof selector.resultFunc === 'function' && Array.isArray(selector.dependencies);
    var dependencies = isReselector ? selector.dependencies : [
        function(s) {
            return s;
        },
        function(_, p) {
            return p;
        }
    ];
    var resultFunc = isReselector ? selector.resultFunc : selector;
    return createSelector(dependencies, resultFunc);
}
var cache = new WeakMap();
function getSelectorInstance(selector, storeState, hasProps) {
    if (!hasProps) {
        if (!cache.has(storeState)) cache.set(storeState, new WeakMap());
        var scopeSelectors = cache.get(storeState);
        if (!scopeSelectors.has(selector)) scopeSelectors.set(selector, createMemoizedSelector(selector));
        return scopeSelectors.get(selector);
    }
    return createMemoizedSelector(selector);
}

},{"./memoize":"kUSg9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kUSg9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Tailor made memoisation
 */ parcelHelpers.export(exports, "default", function() {
    return function(resultFn, propsMode) {
        if (propsMode === void 0) propsMode = false;
        var lastArgs = [];
        var lastResult;
        var calledOnce = false;
        var result = function result() {
            if (calledOnce && areArgumentsEqual(propsMode, arguments, lastArgs)) return lastResult;
            var nextResult = resultFn.apply(this, arguments);
            if (!propsMode && (0, _shallowEqualDefault.default)(nextResult, lastResult)) return lastResult;
            lastResult = nextResult;
            calledOnce = true;
            lastArgs = arguments;
            return lastResult;
        };
        return result;
    };
});
var _shallowEqual = require("./shallow-equal");
var _shallowEqualDefault = parcelHelpers.interopDefault(_shallowEqual);
function exactEqual(objA, objB) {
    return objA === objB;
}
function areArgumentsEqual(propsMode, prev, next) {
    if (prev === null || next === null || prev.length !== next.length) return false; // If propsMode and 2 arguments, means it is an input selector
    // and we check for shallow equality on 2nd one to optimise props
    if (propsMode && prev.length === 2) return prev[0] === next[0] && (0, _shallowEqualDefault.default)(prev[1], next[1]);
    for(var i = 0; i < prev.length; i++){
        if (!exactEqual(prev[i], next[i])) return false;
    }
    return true;
}

},{"./shallow-equal":"bJC2B","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"crCaE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSliceForResource", function() {
    return getSliceForResource;
});
parcelHelpers.export(exports, "getResourceStoreContext", function() {
    return getResourceStoreContext;
});
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _utils = require("./utils");
var getSliceForResource = function(state, props) {
    var type = props.type, key = props.key;
    var slice = state.data[type] && state.data[type][key];
    return slice ? (0, _extendsDefault.default)({}, slice) : (0, _utils.getDefaultStateSlice)();
};
var getResourceStoreContext = function(state) {
    return state.context;
};

},{"@babel/runtime/helpers/extends":"3LZYG","./utils":"8XzFG","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8XzFG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shouldUseCache", function() {
    return 0, _shouldUseCache.shouldUseCache;
});
parcelHelpers.export(exports, "isFromSsr", function() {
    return 0, _shouldUseCache.isFromSsr;
});
parcelHelpers.export(exports, "getDefaultStateSlice", function() {
    return 0, _getDefaultStateSlice.getDefaultStateSlice;
});
parcelHelpers.export(exports, "getExpiresAt", function() {
    return 0, _expiresAt.getExpiresAt;
});
parcelHelpers.export(exports, "setExpiresAt", function() {
    return 0, _expiresAt.setExpiresAt;
});
parcelHelpers.export(exports, "getAccessedAt", function() {
    return 0, _accessedAt.getAccessedAt;
});
parcelHelpers.export(exports, "getResourceIdentifier", function() {
    return 0, _getResourceIdentifier.getResourceIdentifier;
});
parcelHelpers.export(exports, "getResourcesForNextLocation", function() {
    return 0, _getResourcesForNextLocation.getResourcesForNextLocation;
});
parcelHelpers.export(exports, "generateTimeGuard", function() {
    return 0, _generateTimeGuard.generateTimeGuard;
});
parcelHelpers.export(exports, "serializeError", function() {
    return 0, _serializeError.serializeError;
});
parcelHelpers.export(exports, "deserializeError", function() {
    return 0, _serializeError.deserializeError;
});
parcelHelpers.export(exports, "transformData", function() {
    return 0, _transformData.transformData;
});
parcelHelpers.export(exports, "routeHasChanged", function() {
    return 0, _routeChecks.routeHasChanged;
});
parcelHelpers.export(exports, "routeHasResources", function() {
    return 0, _routeChecks.routeHasResources;
});
parcelHelpers.export(exports, "TimeoutError", function() {
    return 0, _timeoutError.TimeoutError;
});
parcelHelpers.export(exports, "setSsrDataPromise", function() {
    return 0, _ssrDataPromise.setSsrDataPromise;
});
parcelHelpers.export(exports, "validateLRUCache", function() {
    return 0, _lruCache.validateLRUCache;
});
parcelHelpers.export(exports, "deleteResourceState", function() {
    return 0, _manageResourceState.deleteResourceState;
});
parcelHelpers.export(exports, "getResourceState", function() {
    return 0, _manageResourceState.getResourceState;
});
parcelHelpers.export(exports, "setResourceState", function() {
    return 0, _manageResourceState.setResourceState;
});
parcelHelpers.export(exports, "ResourceDependencyError", function() {
    return 0, _dependentResources.ResourceDependencyError;
});
parcelHelpers.export(exports, "actionWithDependencies", function() {
    return 0, _dependentResources.actionWithDependencies;
});
parcelHelpers.export(exports, "mapActionWithDependencies", function() {
    return 0, _dependentResources.mapActionWithDependencies;
});
parcelHelpers.export(exports, "executeForDependents", function() {
    return 0, _dependentResources.executeForDependents;
});
parcelHelpers.export(exports, "getDependencies", function() {
    return 0, _dependentResources.getDependencies;
});
parcelHelpers.export(exports, "toPromise", function() {
    return 0, _toPromise.toPromise;
});
var _shouldUseCache = require("./should-use-cache");
var _getDefaultStateSlice = require("./get-default-state-slice");
var _expiresAt = require("./expires-at");
var _accessedAt = require("./accessed-at");
var _getResourceIdentifier = require("./get-resource-identifier");
var _getResourcesForNextLocation = require("./get-resources-for-next-location");
var _generateTimeGuard = require("./generate-time-guard");
var _serializeError = require("./serialize-error");
var _transformData = require("./transform-data");
var _routeChecks = require("./route-checks");
var _timeoutError = require("./timeout-error");
var _ssrDataPromise = require("./ssr-data-promise");
var _lruCache = require("./lru-cache");
var _manageResourceState = require("./manage-resource-state");
var _dependentResources = require("./dependent-resources");
var _toPromise = require("./to-promise");

},{"./should-use-cache":"725Dv","./get-default-state-slice":"2NsIt","./expires-at":"ixpbP","./accessed-at":"9cbDr","./get-resource-identifier":"4cSta","./get-resources-for-next-location":"dRoid","./generate-time-guard":"bNSjd","./serialize-error":"fGx4l","./transform-data":"f29WY","./route-checks":"6qgsp","./timeout-error":"7MVfM","./ssr-data-promise":"jaUoB","./lru-cache":"bd0Gu","./manage-resource-state":"5NlQm","./dependent-resources":"9al8v","./to-promise":"jLD9I","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"725Dv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isFromSsr", function() {
    return isFromSsr;
});
parcelHelpers.export(exports, "shouldUseCache", function() {
    return shouldUseCache;
});
var isFromSsr = function(param) {
    var expiresAt = param.expiresAt;
    return expiresAt === null;
};
var isFresh = function(resource) {
    if (isFromSsr(resource)) return true;
    return Date.now() < Number(resource.expiresAt);
};
var shouldUseCache = function(resource) {
    var _resource$error;
    if ((resource == null ? void 0 : (_resource$error = resource.error) == null ? void 0 : _resource$error.name) === 'TimeoutError') return false;
    if (resource.loading) return true;
    if (isFresh(resource)) return true;
    return false;
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2NsIt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaultStateSlice", function() {
    return getDefaultStateSlice;
});
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _constants = require("../../constants");
var _expiresAt = require("../expires-at");
var _accessedAt = require("../accessed-at");
var getDefaultStateSlice = function() {
    return (0, _extendsDefault.default)((0, _extendsDefault.default)({}, (0, _constants.BASE_DEFAULT_STATE_SLICE)), {}, {
        expiresAt: (0, _expiresAt.getExpiresAt)((0, _constants.DEFAULT_RESOURCE_MAX_AGE)),
        accessedAt: (0, _accessedAt.getAccessedAt)()
    });
};

},{"@babel/runtime/helpers/extends":"3LZYG","../../constants":"dsFxf","../expires-at":"ixpbP","../accessed-at":"9cbDr","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dsFxf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_RESOURCE_MAX_AGE", function() {
    return DEFAULT_RESOURCE_MAX_AGE;
});
parcelHelpers.export(exports, "DEFAULT_CACHE_MAX_LIMIT", function() {
    return DEFAULT_CACHE_MAX_LIMIT;
});
parcelHelpers.export(exports, "DEFAULT_RESOURCE_BROWSER_ONLY", function() {
    return DEFAULT_RESOURCE_BROWSER_ONLY;
});
parcelHelpers.export(exports, "BASE_DEFAULT_STATE_SLICE", function() {
    return BASE_DEFAULT_STATE_SLICE;
});
var DEFAULT_RESOURCE_MAX_AGE = 0;
var DEFAULT_CACHE_MAX_LIMIT = 100;
var DEFAULT_RESOURCE_BROWSER_ONLY = false;
var BASE_DEFAULT_STATE_SLICE = {
    data: null,
    error: null,
    loading: false,
    promise: null
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ixpbP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getExpiresAt", function() {
    return getExpiresAt;
});
parcelHelpers.export(exports, "setExpiresAt", function() {
    return setExpiresAt;
});
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var getExpiresAt = function(maxAge) {
    return Date.now() + maxAge;
};
var setExpiresAt = function(slice, maxAge) {
    return slice.expiresAt === null ? (0, _extendsDefault.default)((0, _extendsDefault.default)({}, slice), {}, {
        expiresAt: getExpiresAt(maxAge)
    }) : slice;
};

},{"@babel/runtime/helpers/extends":"3LZYG","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9cbDr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAccessedAt", function() {
    return getAccessedAt;
});
var getAccessedAt = function() {
    return Date.now();
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4cSta":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getResourceIdentifier", function() {
    return getResourceIdentifier;
});
parcelHelpers.export(exports, "getResourceIdentifiers", function() {
    return getResourceIdentifiers;
});
var getResourceIdentifier = function(resource, routerStoreContext, resourceStoreContext) {
    var type = resource.type, getKey = resource.getKey;
    var key = getKey(routerStoreContext, resourceStoreContext);
    return "".concat(type, "/").concat(key);
};
var getResourceIdentifiers = function(resources, routerStoreContext, resourceStoreContext) {
    return resources.map(function(resource) {
        return getResourceIdentifier(resource, routerStoreContext, resourceStoreContext);
    });
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dRoid":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getResourcesForNextLocation", function() {
    return getResourcesForNextLocation;
});
var _getResourceIdentifier = require("../get-resource-identifier");
var _routeChecks = require("../route-checks");
var getResourcesForNextLocation = function(prevRouterStoreContext, nextRouterStoreContext, resourceStoreContext) {
    var prevRoute = prevRouterStoreContext.route;
    var _ref = prevRoute || {}, tmp = _ref.resources, prevResources = tmp === void 0 ? [] : tmp;
    var nextRoute = nextRouterStoreContext.route;
    var _ref1 = nextRoute || {}, tmp1 = _ref1.resources, nextResources = tmp1 === void 0 ? [] : tmp1;
    if (!(0, _routeChecks.routeHasResources)(nextRoute)) return [];
    if ((0, _routeChecks.routeHasChanged)(prevRoute, nextRoute)) return nextResources;
    var prevResourceIdentifiers = (0, _getResourceIdentifier.getResourceIdentifiers)(prevResources, prevRouterStoreContext, resourceStoreContext);
    return nextResources.filter(function(resource) {
        return !prevResourceIdentifiers.includes((0, _getResourceIdentifier.getResourceIdentifier)(resource, nextRouterStoreContext, resourceStoreContext));
    });
};

},{"../get-resource-identifier":"4cSta","../route-checks":"6qgsp","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6qgsp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "routeHasResources", function() {
    return routeHasResources;
});
parcelHelpers.export(exports, "routeHasChanged", function() {
    return routeHasChanged;
});
var routeHasResources = function(route) {
    return !!(route && route.resources && route.resources.length > 0);
};
var routeHasChanged = function(prev, next) {
    return prev.name !== next.name || prev.path !== next.path;
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bNSjd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateTimeGuard", function() {
    return generateTimeGuard;
});
var generateTimeGuard = function(duration) {
    var promiseState = {
        timerId: null,
        isPending: true,
        promise: undefined
    };
    promiseState.promise = new Promise(function(r) {
        var timerId = setTimeout(function() {
            promiseState.isPending = false;
            r();
        }, duration);
        promiseState.timerId = timerId;
    });
    return promiseState;
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fGx4l":[function(require,module,exports,__globalThis) {
// NOTE! This has been copy pasted from https://github.com/sindresorhus/serialize-error/blob/master/index.js
// When the router moves to its own package, this must become a dependency
// For now, we have put it here so that we don't need to get it included in Jira's vendor bundle
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializeError", function() {
    return serializeError;
});
parcelHelpers.export(exports, "deserializeError", function() {
    return deserializeError;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _inherits = require("@swc/helpers/_/_inherits");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var _wrapNativeSuper = require("@swc/helpers/_/_wrap_native_super");
var NonError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, _inherits._)(NonError, Error1);
    function NonError(message) {
        (0, _classCallCheck._)(this, NonError);
        var _this;
        _this = (0, _callSuper._)(this, NonError, [
            message
        ]);
        _this.name = 'NonError';
        if (Error.captureStackTrace) Error.captureStackTrace(_this, NonError);
        return _this;
    }
    return NonError;
}((0, _wrapNativeSuper._)(Error));
var commonProperties = [
    'name',
    'message',
    'stack',
    'code'
];
var destroyCircular = function(from, seen, to_) {
    var to = to_ || (Array.isArray(from) ? [] : {});
    seen.push(from);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, _slicedToArray._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            if (typeof value === 'function') continue;
            if (!value || (typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) !== 'object') {
                to[key] = value;
                continue;
            }
            if (!seen.includes(from[key])) {
                to[key] = destroyCircular(from[key], seen.slice());
                continue;
            }
            to[key] = '[Circular]';
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = commonProperties[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var property = _step1.value;
            if (typeof from[property] === 'string') to[property] = from[property];
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return to;
}; // const serializeError = <ErrorType = any>(value: ErrorType) => {
var serializeError = function(value) {
    if ((typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) === 'object' && value !== null) return destroyCircular(value, []);
     // People sometimes throw things besides Error objects…
    if (typeof value === 'function') // `JSON.stringify()` discards functions. We do too, unless a function is thrown directly.
    return "[Function: ".concat(value.name || 'anonymous', "]");
    return value;
};
var deserializeError = function(value) {
    if ((0, _instanceof._)(value, Error)) return value;
    if ((typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) === 'object' && value !== null && !Array.isArray(value)) {
        var newError = new Error();
        destroyCircular(value, [], newError);
        return newError;
    }
    return new NonError(value);
};

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_inherits":"2sfqW","@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_type_of":"iFJdx","@swc/helpers/_/_wrap_native_super":"d0Iin","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"f29WY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "transformData", function() {
    return transformData;
});
var transformData = function(data, transformer) {
    return Object.keys(data).reduce(function(acc, type) {
        if (!acc[type]) acc[type] = {};
        Object.keys(data[type]).forEach(function(key) {
            var slice = data[type][key];
            acc[type][key] = transformer(slice);
        });
        return acc;
    }, {});
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7MVfM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimeoutError", function() {
    return TimeoutError;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _inherits = require("@swc/helpers/_/_inherits");
var _wrapNativeSuper = require("@swc/helpers/_/_wrap_native_super");
var TimeoutError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, _inherits._)(TimeoutError, Error1);
    function TimeoutError(message) {
        (0, _classCallCheck._)(this, TimeoutError);
        var _this;
        _this = (0, _callSuper._)(this, TimeoutError, [
            'Resource timed out: ' + message
        ]);
        _this.name = 'TimeoutError';
        return _this;
    }
    return TimeoutError;
}((0, _wrapNativeSuper._)(Error));

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_inherits":"2sfqW","@swc/helpers/_/_wrap_native_super":"d0Iin","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jaUoB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setSsrDataPromise", function() {
    return setSsrDataPromise;
});
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var setSsrDataPromise = function(slice) {
    return slice.promise === null ? (0, _extendsDefault.default)((0, _extendsDefault.default)({}, slice), {}, {
        promise: Promise.resolve(slice.data)
    }) : slice;
};

},{"@babel/runtime/helpers/extends":"3LZYG","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bd0Gu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getExpiredResourceDataKeys", function() {
    return getExpiredResourceDataKeys;
});
parcelHelpers.export(exports, "getLRUResourceKey", function() {
    return getLRUResourceKey;
});
parcelHelpers.export(exports, "validateLRUCache", function() {
    return validateLRUCache;
});
var _manageResourceState = require("../manage-resource-state");
var getExpiredResourceDataKeys = function(routeResourceDataForType, currentKey) {
    return Object.keys(routeResourceDataForType).filter(function(resourceDataKey) {
        var expiresAt = routeResourceDataForType[resourceDataKey].expiresAt;
        return resourceDataKey !== currentKey && expiresAt && expiresAt <= Date.now();
    });
};
var getLRUResourceKey = function(maxCache, resourceDataForType, currentKey) {
    if (maxCache === Infinity || maxCache < 1) return null;
    var resourceDataKeys = Object.keys(resourceDataForType);
    if (resourceDataKeys.length < maxCache) return null;
    var expiredResourceDataKeys = getExpiredResourceDataKeys(resourceDataForType, currentKey);
    if (expiredResourceDataKeys.length > 0) return expiredResourceDataKeys[0];
    return resourceDataKeys.reduce(function(leastRecentKey, key) {
        var accessedAt = resourceDataForType[key].accessedAt, _resourceDataForType_leastRecentKey = resourceDataForType[leastRecentKey], leastRecentAccessedAt = _resourceDataForType_leastRecentKey.accessedAt;
        if (accessedAt && leastRecentAccessedAt && accessedAt < leastRecentAccessedAt) return key;
        return leastRecentKey;
    }, resourceDataKeys[0]);
};
var validateLRUCache = function(resource, key) {
    return function(param) {
        var getState = param.getState, dispatch = param.dispatch;
        var type = resource.type, maxCache = resource.maxCache;
        var _getState = getState(), _getState_data = _getState.data, resourceDataForType = _getState_data[type];
        if (!resourceDataForType) return;
        var keyTobeDeleted = getLRUResourceKey(maxCache, resourceDataForType, key);
        if (!keyTobeDeleted) return;
        dispatch((0, _manageResourceState.deleteResourceState)(type, keyTobeDeleted));
    };
};

},{"../manage-resource-state":"5NlQm","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5NlQm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setResourceState", function() {
    return setResourceState;
});
parcelHelpers.export(exports, "getResourceState", function() {
    return getResourceState;
});
parcelHelpers.export(exports, "deleteResourceState", function() {
    return deleteResourceState;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _typeOf = require("@swc/helpers/_/_type_of");
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : (0, _typeOf._)(key)) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if ((typeof input === "undefined" ? "undefined" : (0, _typeOf._)(input)) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((typeof res === "undefined" ? "undefined" : (0, _typeOf._)(res)) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var setResourceState = function(type, key, state) {
    return function(param) {
        var setState = param.setState, getState = param.getState;
        var data = getState().data;
        setState({
            data: (0, _extendsDefault.default)((0, _extendsDefault.default)({}, data), {}, (0, _defineProperty._)({}, type, (0, _extendsDefault.default)((0, _extendsDefault.default)({}, data[type] || {}), {}, (0, _defineProperty._)({}, key, state))))
        });
    };
};
var getResourceState = function(type, key) {
    return function(param) {
        var getState = param.getState;
        var _getState = getState(), _getState_data = _getState.data, resourceDataForType = _getState_data[type];
        return resourceDataForType == null ? void 0 : resourceDataForType[key];
    };
};
var deleteResourceState = function(type, key) {
    return function(param) {
        var getState = param.getState, setState = param.setState;
        var data = getState().data;
        var resourceForType = data[type], remainingData = (0, _objectWithoutPropertiesLooseDefault.default)(data, [
            type
        ].map(_toPropertyKey));
        if (key === undefined) setState({
            data: remainingData
        });
        else if (resourceForType) {
            var remainingForType = (0, _objectWithoutPropertiesLooseDefault.default)(resourceForType, [
                key
            ].map(_toPropertyKey));
            setState({
                data: (0, _extendsDefault.default)((0, _extendsDefault.default)({}, remainingData), {}, (0, _defineProperty._)({}, type, remainingForType))
            });
        }
    };
};

},{"@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_type_of":"iFJdx","@babel/runtime/helpers/objectWithoutPropertiesLoose":"5JG3D","@babel/runtime/helpers/extends":"3LZYG","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9al8v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResourceDependencyError", function() {
    return ResourceDependencyError;
});
parcelHelpers.export(exports, "executeTuples", function() {
    return executeTuples;
});
parcelHelpers.export(exports, "actionWithDependencies", function() {
    return actionWithDependencies;
});
parcelHelpers.export(exports, "mapActionWithDependencies", function() {
    return mapActionWithDependencies;
});
parcelHelpers.export(exports, "executeForDependents", function() {
    return executeForDependents;
});
parcelHelpers.export(exports, "getDependencies", function() {
    return getDependencies;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _wrapNativeSuper = require("@swc/helpers/_/_wrap_native_super");
var _selectors = require // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/fromEntries
("../../selectors");
var _Object;
var _Object$fromEntries;
var fromEntries = (_Object$fromEntries = Object.fromEntries) != null ? _Object$fromEntries : function(entries) {
    return (_Object = Object).assign.apply(_Object, [
        {}
    ].concat((0, _toConsumableArray._)(entries.map(function(param) {
        var _param = (0, _slicedToArray._)(param, 2), k = _param[0], v = _param[1];
        return (0, _defineProperty._)({}, k, v);
    }))));
};
var matchType = function(a) {
    return function(b) {
        var _ref = (0, _slicedToArray._)(Array.isArray(a) ? a : [
            a
        ], 1), _ref_ = _ref[0], typeA = _ref_.type;
        var _ref1 = (0, _slicedToArray._)(Array.isArray(b) ? b : [
            b
        ], 1), _ref_1 = _ref1[0], typeB = _ref_1.type;
        return typeA === typeB;
    };
};
var ResourceDependencyError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, _inherits._)(ResourceDependencyError, Error1);
    function ResourceDependencyError(message) {
        (0, _classCallCheck._)(this, ResourceDependencyError);
        var _this;
        _this = (0, _callSuper._)(this, ResourceDependencyError, [
            message
        ]);
        _this.name = 'ResourceDependencyError';
        return _this;
    }
    return ResourceDependencyError;
}((0, _wrapNativeSuper._)(Error));
var executeTuples = function(routeResources, tuples) {
    return function(param) {
        var getState = param.getState, setState = param.setState, dispatch = param.dispatch;
        var _routeResources$some;
        if (getState().executing) throw new Error('execution is already in progress');
         // check if there are resources and if so if there are any resources with dependencies
        var hasDependentResources = (_routeResources$some = routeResources == null ? void 0 : routeResources.some(function(param) {
            var depends = param.depends;
            return depends == null ? void 0 : depends.length;
        })) != null ? _routeResources$some : false;
        if (!hasDependentResources) return tuples.map(function(param) {
            var _param = (0, _slicedToArray._)(param, 2), action = _param[1];
            return dispatch(action);
        });
         // some resources might not be listed on the route resources so must be dispatched separate from executing state
        var listedTuples = tuples.filter(function(param) {
            var _param = (0, _slicedToArray._)(param, 1), resource = _param[0];
            return routeResources == null ? void 0 : routeResources.some(matchType(resource));
        });
        if (listedTuples.length === 0) return tuples.map(function(param) {
            var _param = (0, _slicedToArray._)(param, 2), action = _param[1];
            return dispatch(action);
        });
         // accumulate the dependency types for all executing resources
        // find downstream resources that may also execute and include their dependencies too
        // include the resource type as well in the list
        // we don't validate that these are legal dependencies
        var _routeResources_reduce_filter = (0, _slicedToArray._)(routeResources.reduce(function(acc, param) {
            var type = param.type, depends = param.depends;
            var _acc = (0, _slicedToArray._)(acc, 2), dependencies = _acc[0], executableTypes = _acc[1];
            var isExecutable = executableTypes.includes(type) || !!(depends == null ? void 0 : depends.some(function(dependency) {
                return executableTypes.includes(dependency);
            }));
            return isExecutable ? [
                depends ? (0, _toConsumableArray._)(dependencies).concat((0, _toConsumableArray._)(depends), [
                    type
                ]) : dependencies,
                (0, _toConsumableArray._)(executableTypes).concat([
                    type
                ])
            ] : acc;
        }, [
            [],
            listedTuples.map(function(param) {
                var _param = (0, _slicedToArray._)(param, 1), type = _param[0].type;
                return type;
            })
        ]).filter(function(v, i, a) {
            return a.indexOf(v) === i;
        }), 1), dependentTypes = _routeResources_reduce_filter[0]; // resources that are completely independent are preferable to be dispatched separate from executing state
        var dependentTuples = listedTuples.filter(function(param) {
            var _param = (0, _slicedToArray._)(param, 1), type = _param[0].type;
            return dependentTypes.includes(type);
        });
        if (dependentTuples.length === 0) return tuples.map(function(param) {
            var _param = (0, _slicedToArray._)(param, 2), action = _param[1];
            return dispatch(action);
        });
         // additionally find all direct dependencies of these executing or possibly executing resources
        // we don't validate that these are legal dependencies
        var dependentAndDependencyTypes = routeResources.filter(function(param) {
            var type = param.type;
            return dependentTypes.includes(type);
        }).reduce(function(acc, param) {
            var type = param.type, depends = param.depends;
            return depends ? (0, _toConsumableArray._)(acc).concat((0, _toConsumableArray._)(depends), [
                type
            ]) : (0, _toConsumableArray._)(acc).concat([
                type
            ]);
        }, []).filter(function(v, i, a) {
            return a.indexOf(v) === i;
        }); // setup executing tuples in route resource order
        // this state allows actions to call executeForDependents() to influence actions that follow
        // the list includes dependency resources so that getDependencies() may validate without needing route resources
        // we use the resource definition of the given tuple where present or otherwise the definition from route resources
        var executingTuples = routeResources.filter(function(param) {
            var type = param.type;
            return dependentAndDependencyTypes.includes(type);
        }).map(function(resource) {
            var _tuples$find;
            return (_tuples$find = tuples.find(matchType(resource))) != null ? _tuples$find : [
                resource,
                null
            ];
        });
        setState({
            executing: executingTuples
        }); // dispatch sequentially during which executeForDependents() can cause tuples to change
        var executedResults = executingTuples.map(function(param, i) {
            var _param = (0, _slicedToArray._)(param, 1), _param_ = _param[0], expectedType = _param_.type;
            var _getState$executing;
            var latestTuple = (_getState$executing = getState().executing) == null ? void 0 : _getState$executing[i];
            var _ref = (0, _slicedToArray._)(latestTuple != null ? latestTuple : [
                {}
            ], 2), _ref_ = _ref[0], latestType = _ref_.type, maybeAction = _ref[1];
            if (latestType !== expectedType) {
                setState({
                    executing: null
                });
                throw new Error('execution reached an inconsistent state');
            }
            return maybeAction ? dispatch(maybeAction) : undefined;
        });
        setState({
            executing: null
        }); // pick existing execution result or dispatch any remaining independent actions
        return tuples.map(function(param) {
            var _param = (0, _slicedToArray._)(param, 2), resource = _param[0], action = _param[1];
            var index = executingTuples.findIndex(matchType(resource));
            return index < 0 ? dispatch(action) : executedResults[index];
        });
    };
};
var actionWithDependencies = function(routeResources, resource, action) {
    return function(param) {
        var dispatch = param.dispatch;
        return dispatch(executeTuples(routeResources, [
            [
                resource,
                action
            ]
        ]))[0];
    };
};
var mapActionWithDependencies = function(routeResources, resources, actionCreator) {
    return executeTuples(routeResources, resources.map(function(resource) {
        return [
            resource,
            actionCreator(resource)
        ];
    }));
};
var executeForDependents = function(resource, actionCreator) {
    return function(param) {
        var getState = param.getState, setState = param.setState;
        var _tuples$findIndex;
        var _getState = getState(), tuples = _getState.executing; // find the given resource in the currently executing tuples
        var indexForResource = (_tuples$findIndex = tuples == null ? void 0 : tuples.findIndex(matchType(resource))) != null ? _tuples$findIndex : -1;
        if (indexForResource < 0) return;
         // find dependent resources following given resource and revise their action
        var executing = tuples.map(function(tuple, i) {
            var _tupleResource$depend;
            var _tuple = (0, _slicedToArray._)(tuple, 1), tupleResource = _tuple[0];
            return i > indexForResource && ((_tupleResource$depend = tupleResource.depends) == null ? void 0 : _tupleResource$depend.includes(resource.type)) ? [
                tupleResource,
                actionCreator(tupleResource)
            ] : tuple;
        });
        setState({
            executing: executing
        });
    };
};
var getDependencies = function(resource, routerStoreContext) {
    return function(param) {
        var getState = param.getState;
        var _tuples$findIndex2;
        var type = resource.type, depends = resource.depends; // optimise the case of no dependencies
        if (!(depends == null ? void 0 : depends.length)) return {};
        var _getState = getState(), tuples = _getState.executing, data = _getState.data, resourceStoreContext = _getState.context; // dependent resource cannot be called outside execution state
        // find the given resource type in the currently executing tuples
        var indexForResource = (_tuples$findIndex2 = tuples == null ? void 0 : tuples.findIndex(matchType(resource))) != null ? _tuples$findIndex2 : -1;
        if (indexForResource < 0) throw new ResourceDependencyError('Missing resource: "'.concat(type, '" has dependencies so must not be missing'));
         // find tuples index for all the dependency elements
        var dependencyIndexTuples = depends.map(function(dependency) {
            return [
                dependency,
                tuples.findIndex(matchType({
                    type: dependency
                }))
            ];
        }); // we rely on executing tuples including all dependencies of the caller resource
        dependencyIndexTuples.forEach(function(param) {
            var _param = (0, _slicedToArray._)(param, 2), dependency = _param[0], index = _param[1];
            if (index < 0) throw new ResourceDependencyError('Missing resource: "'.concat(type, '" depends "').concat(dependency, '" which is missing'));
            if (index > indexForResource) throw new ResourceDependencyError('Illegal dependency: "'.concat(type, '" depends "').concat(dependency, '" so "').concat(dependency, '" must precede "').concat(type, '"'));
        });
        return fromEntries(dependencyIndexTuples.map(function(param) {
            var _param = (0, _slicedToArray._)(param, 2), dependency = _param[0], index = _param[1];
            var _tuples_index = (0, _slicedToArray._)(tuples[index], 1), getKey = _tuples_index[0].getKey;
            return [
                dependency,
                (0, _selectors.getSliceForResource)({
                    data: data
                }, {
                    type: dependency,
                    key: getKey(routerStoreContext, resourceStoreContext)
                })
            ];
        }));
    };
};

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_inherits":"2sfqW","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_to_consumable_array":"1eSZf","@swc/helpers/_/_wrap_native_super":"d0Iin","../../selectors":"crCaE","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jLD9I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toPromise", function() {
    return toPromise;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
var toPromise = function(candidate) {
    return (0, _instanceof._)(candidate, Promise) ? candidate : Promise.resolve(candidate);
};

},{"@swc/helpers/_/_instanceof":"h9UKc","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hf6U0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "INITIAL_STATE", function() {
    return INITIAL_STATE;
});
parcelHelpers.export(exports, "RouterStore", function() {
    return RouterStore;
});
parcelHelpers.export(exports, "RouterContainer", function() {
    return RouterContainer;
});
parcelHelpers.export(exports, "UniversalRouterContainer", function() {
    return UniversalRouterContainer;
});
parcelHelpers.export(exports, "RouterSubscriber", function() {
    return RouterSubscriber;
});
parcelHelpers.export(exports, "RouterActionsSubscriber", function() {
    return RouterActionsSubscriber;
});
parcelHelpers.export(exports, "RouteResourceEnabledSubscriber", function() {
    return RouteResourceEnabledSubscriber;
});
parcelHelpers.export(exports, "useRouterStore", function() {
    return useRouterStore;
});
parcelHelpers.export(exports, "useRouterStoreStatic", function() {
    return useRouterStoreStatic;
});
/**
 * Utility to create custom hooks without re-rendering on route change
 */ parcelHelpers.export(exports, "createRouterSelector", function() {
    return createRouterSelector;
});
parcelHelpers.export(exports, "getRouterStore", function() {
    return getRouterStore;
});
parcelHelpers.export(exports, "getRouterState", function() {
    return getRouterState;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _reactSweetState = require("react-sweet-state");
var _history = require("history");
var _constants = require("../../common/constants");
var _utils = require("../../common/utils");
var _resourceStore = require("../resource-store");
var _utils1 = require("../resource-store/utils");
var _utils2 = require("./utils");
var INITIAL_STATE = {
    history: (0, _constants.DEFAULT_HISTORY),
    location: (0, _constants.DEFAULT_HISTORY).location,
    query: {},
    routes: [],
    route: (0, _constants.DEFAULT_ROUTE),
    match: (0, _constants.DEFAULT_MATCH),
    action: (0, _constants.DEFAULT_ACTION),
    unlisten: null,
    basePath: '',
    isStatic: false,
    onPrefetch: undefined
};
var actions = {
    /**
   * Bootstraps the store with initial data.
   *
   */ bootstrapStore: function(props) {
        return function(param) {
            var setState = param.setState, dispatch = param.dispatch;
            var resourceContext = props.resourceContext, resourceData = props.resourceData, _props_basePath = props.basePath, basePath = _props_basePath === void 0 ? '' : _props_basePath, routes = props.routes, initialRoute = props.initialRoute, initialProps = (0, _objectWithoutPropertiesLooseDefault.default)(props, [
                "resourceContext",
                "resourceData",
                "basePath",
                "routes",
                "initialRoute"
            ]);
            var history = initialProps.history, isStatic = initialProps.isStatic;
            var routerContext = (0, _utils.findRouterContext)(initialRoute ? [
                initialRoute
            ] : routes, {
                location: history.location,
                basePath: basePath
            });
            setState((0, _extendsDefault.default)((0, _extendsDefault.default)((0, _extendsDefault.default)({}, initialProps), routerContext), {}, {
                basePath: basePath,
                routes: routes,
                location: history.location,
                action: history.action
            }));
            (0, _resourceStore.getResourceStore)().actions.hydrate({
                resourceContext: resourceContext,
                resourceData: resourceData
            });
            if (!isStatic) dispatch(actions.listen());
        };
    },
    /**
   * Duplicate method that uses isServerEnvironment instead of removed isStatic prop
   * internally. We can remove this when UniversalRouter replaces Router completely.
   */ bootstrapStoreUniversal: function(props) {
        return function(param) {
            var setState = param.setState, dispatch = param.dispatch;
            var resourceContext = props.resourceContext, resourceData = props.resourceData, _props_basePath = props.basePath, basePath = _props_basePath === void 0 ? '' : _props_basePath, initialProps = (0, _objectWithoutPropertiesLooseDefault.default)(props, [
                "resourceContext",
                "resourceData",
                "basePath"
            ]);
            var history = initialProps.history, routes = initialProps.routes;
            var routerContext = (0, _utils.findRouterContext)(routes, {
                location: history.location,
                basePath: basePath
            });
            setState((0, _extendsDefault.default)((0, _extendsDefault.default)((0, _extendsDefault.default)({}, initialProps), routerContext), {}, {
                basePath: basePath,
                location: history.location,
                action: history.action
            }));
            (0, _resourceStore.getResourceStore)().actions.hydrate({
                resourceContext: resourceContext,
                resourceData: resourceData
            });
            if (!(0, _utils.isServerEnvironment)()) dispatch(actions.listen());
        };
    },
    /**
   * Uses the resource store to request resources for the route.
   * Must be dispatched after setting state with the new route context.
   *
   */ requestRouteResources: function() {
        var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return function(param) {
            var getState = param.getState;
            var _getState = getState(), route = _getState.route, match = _getState.match, query = _getState.query;
            return (0, _resourceStore.getResourceStore)().actions.requestAllResources({
                route: route,
                match: match,
                query: query
            }, options);
        };
    },
    prefetchNextRouteResources: function(path, nextContext) {
        return function(param) {
            var getState = param.getState;
            var _getState = getState(), routes = _getState.routes, basePath = _getState.basePath, onPrefetch = _getState.onPrefetch, route = _getState.route, match = _getState.match, query = _getState.query;
            var _getResourceStore_actions = (0, _resourceStore.getResourceStore)().actions, cleanExpiredResources = _getResourceStore_actions.cleanExpiredResources, requestResources = _getResourceStore_actions.requestResources, getResourceStoreContext = _getResourceStore_actions.getContext;
            if (!nextContext && !(0, _utils2.isExternalAbsolutePath)(path)) {
                var location = (0, _history.parsePath)((0, _utils2.getRelativePath)(path, basePath));
                nextContext = (0, _utils.findRouterContext)(routes, {
                    location: location,
                    basePath: basePath
                });
            }
            if (nextContext == null) return;
            var nextLocationContext = nextContext;
            var nextResources = (0, _utils1.getResourcesForNextLocation)({
                route: route,
                match: match,
                query: query
            }, nextLocationContext, getResourceStoreContext());
            (0, _reactSweetState.batch)(function() {
                cleanExpiredResources(nextResources, nextLocationContext);
                requestResources(nextResources, nextLocationContext, {
                    prefetch: true
                });
                if (onPrefetch) onPrefetch(nextLocationContext);
            });
        };
    },
    /**
   * Starts listening to browser history and sets the unlisten function in state.
   * Will request route resources on route change.
   *
   */ listen: function() {
        return function(param) {
            var getState = param.getState, setState = param.setState;
            var history = getState().history;
            var stopListening = history.listen(function() {
                for(var _len = arguments.length, update = new Array(_len), _key = 0; _key < _len; _key++){
                    update[_key] = arguments[_key];
                }
                var location = update.length === 2 ? update[0] : update[0].location;
                var action = update.length === 2 ? update[1] : update[0].action;
                var _getState = getState(), routes = _getState.routes, basePath = _getState.basePath, currentMatch = _getState.match, currentRoute = _getState.route, currentQuery = _getState.query;
                var _getResourceStore_actions = (0, _resourceStore.getResourceStore)().actions, cleanExpiredResources = _getResourceStore_actions.cleanExpiredResources, requestResources = _getResourceStore_actions.requestResources, getResourceStoreContext = _getResourceStore_actions.getContext;
                var nextContext = (0, _utils.findRouterContext)(routes, {
                    location: location,
                    basePath: basePath
                });
                var nextLocationContext = {
                    route: nextContext.route,
                    match: nextContext.match,
                    query: nextContext.query
                };
                var nextResources = (0, _utils1.getResourcesForNextLocation)({
                    route: currentRoute,
                    match: currentMatch,
                    query: currentQuery
                }, nextLocationContext, getResourceStoreContext());
                /* Explicitly batch update
       * as we need resources cleaned + route changed + resource fetch started together
       * If we do not batch, React might be re-render when route changes but resource
       * fetching has not started yet, making the app render with data null */ (0, _reactSweetState.batch)(function() {
                    cleanExpiredResources(nextResources, nextLocationContext);
                    setState((0, _extendsDefault.default)((0, _extendsDefault.default)({}, nextContext), {}, {
                        location: location,
                        action: action
                    }));
                    requestResources(nextResources, nextLocationContext, {});
                });
            });
            setState({
                unlisten: stopListening
            });
        };
    },
    push: function(path) {
        return function(param) {
            var getState = param.getState;
            var _getState = getState(), history = _getState.history, basePath = _getState.basePath;
            if ((0, _utils2.isExternalAbsolutePath)(path)) window.location.assign(path);
            else history.push((0, _utils2.getRelativePath)(path, basePath));
        };
    },
    pushTo: function(route) {
        var attributes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return function(param) {
            var getState = param.getState;
            var _getState = getState(), history = _getState.history, basePath = _getState.basePath;
            var location = (0, _utils.generateLocationFromPath)(route.path, (0, _extendsDefault.default)((0, _extendsDefault.default)({}, attributes), {}, {
                basePath: basePath
            }));
            (0, _utils.warmupMatchRouteCache)(route, location.pathname, attributes.query, basePath);
            history.push(location);
        };
    },
    replace: function(path) {
        return function(param) {
            var getState = param.getState;
            var _getState = getState(), history = _getState.history, basePath = _getState.basePath;
            if ((0, _utils2.isExternalAbsolutePath)(path)) window.location.replace(path);
            else history.replace((0, _utils2.getRelativePath)(path, basePath));
        };
    },
    replaceTo: function(route) {
        var attributes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return function(param) {
            var getState = param.getState;
            var _getState = getState(), history = _getState.history, basePath = _getState.basePath;
            var location = (0, _utils.generateLocationFromPath)(route.path, (0, _extendsDefault.default)((0, _extendsDefault.default)({}, attributes), {}, {
                basePath: basePath
            }));
            (0, _utils.warmupMatchRouteCache)(route, location.pathname, attributes.query, basePath);
            history.replace(location);
        };
    },
    goBack: function() {
        return function(param) {
            var getState = param.getState;
            var history = getState().history;
            history.goBack();
        };
    },
    goForward: function() {
        return function(param) {
            var getState = param.getState;
            var history = getState().history;
            history.goForward();
        };
    },
    registerBlock: function(blocker) {
        return function(param) {
            var getState = param.getState;
            var history = getState().history;
            return history.block(blocker);
        };
    },
    getContext: function() {
        return function(param) {
            var getState = param.getState;
            var _getState = getState(), query = _getState.query, route = _getState.route, match = _getState.match;
            return {
                query: query,
                route: route,
                match: match
            };
        };
    },
    getBasePath: function() {
        return function(param) {
            var getState = param.getState;
            var basePath = getState().basePath;
            return basePath;
        };
    },
    updateQueryParam: function(params) {
        var updateType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'push';
        return function(param) {
            var getState = param.getState;
            var _getState = getState(), existingQueryParams = _getState.query, history = _getState.history, location = _getState.location;
            var updatedQueryParams = (0, _extendsDefault.default)((0, _extendsDefault.default)({}, existingQueryParams), params); // remove undefined keys
            Object.keys(updatedQueryParams).forEach(function(key) {
                return updatedQueryParams[key] === undefined && delete updatedQueryParams[key];
            });
            var existingPath = (0, _utils2.updateQueryParams)(location, existingQueryParams);
            var updatedPath = (0, _utils2.updateQueryParams)(location, updatedQueryParams);
            if (updatedPath !== existingPath) history[updateType](updatedPath);
        };
    },
    updatePathParam: function(params) {
        var updateType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'push';
        return function(param) {
            var getState = param.getState;
            var _getState = getState(), history = _getState.history, location = _getState.location, path = _getState.route.path, _getState_match = _getState.match, existingPathParams = _getState_match.params, basePath = _getState.basePath;
            var pathWithBasePath = basePath + path;
            var updatedPathParams = (0, _extendsDefault.default)((0, _extendsDefault.default)({}, existingPathParams), params);
            var updatedPath = (0, _utils.generatePath)(pathWithBasePath, updatedPathParams);
            var updatedLocation = (0, _extendsDefault.default)((0, _extendsDefault.default)({}, location), {}, {
                pathname: updatedPath
            });
            var existingRelativePath = (0, _utils2.getRelativeURLFromLocation)(location);
            var updatedRelativePath = (0, _utils2.getRelativeURLFromLocation)(updatedLocation);
            if (updatedRelativePath !== existingRelativePath) history[updateType](updatedRelativePath);
        };
    }
};
var RouterStore = (0, _reactSweetState.createStore)({
    initialState: INITIAL_STATE,
    actions: actions,
    name: 'router'
});
var RouterContainer = (0, _reactSweetState.createContainer)(RouterStore, {
    displayName: 'RouterContainer',
    onInit: function() {
        return function(param, props) {
            var dispatch = param.dispatch;
            dispatch(actions.bootstrapStore(props));
            !props.isStatic && dispatch(actions.requestRouteResources());
        };
    },
    onCleanup: function() {
        return function() {};
    }
});
var UniversalRouterContainer = (0, _reactSweetState.createContainer)(RouterStore, {
    displayName: 'UniversalRouterContainer',
    onInit: function() {
        return function(param, props) {
            var dispatch = param.dispatch;
            dispatch(actions.bootstrapStoreUniversal(props));
            !(0, _utils.isServerEnvironment)() && dispatch(actions.requestRouteResources());
        };
    },
    onCleanup: function() {
        return function() {};
    }
});
var RouterSubscriber = (0, _reactSweetState.createSubscriber)(RouterStore, {
    displayName: 'BaseRouterSubscriber'
});
var RouterActionsSubscriber = (0, _reactSweetState.createSubscriber)(RouterStore, {
    displayName: 'RouterActionsSubscriber',
    selector: null
});
var RouteResourceEnabledSubscriber = (0, _reactSweetState.createSubscriber)(RouterStore, {
    selector: function(state) {
        return Boolean(state.route && state.route.resources);
    }
});
var useRouterStore = (0, _reactSweetState.createHook)(RouterStore);
var useRouterStoreStatic = (0, _reactSweetState.createHook)(RouterStore, {
    selector: null
});
function createRouterSelector(selector) {
    var useHook = (0, _reactSweetState.createHook)(RouterStore, {
        selector: selector
    });
    return function useRouterSelector() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return useHook.apply(void 0, (0, _toConsumableArray._)(args))[0];
    };
}
var getRouterStore = function() {
    return (0, _reactSweetState.defaultRegistry).getStore(RouterStore);
}; // @ts-ignore accessing private store property
var getRouterState = function() {
    return getRouterStore().storeState.getState();
};

},{"@swc/helpers/_/_to_consumable_array":"1eSZf","@babel/runtime/helpers/extends":"3LZYG","@babel/runtime/helpers/objectWithoutPropertiesLoose":"5JG3D","react-sweet-state":"b2YYl","history":"de6OM","../../common/constants":"fjgCw","../../common/utils":"cxuex","../resource-store":"bHILc","../resource-store/utils":"8XzFG","./utils":"jhbl4","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fjgCw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_LOCATION", function() {
    return DEFAULT_LOCATION;
});
parcelHelpers.export(exports, "DEFAULT_MATCH", function() {
    return DEFAULT_MATCH;
});
parcelHelpers.export(exports, "DEFAULT_ROUTE", function() {
    return DEFAULT_ROUTE;
});
parcelHelpers.export(exports, "DEFAULT_HISTORY", function() {
    return DEFAULT_HISTORY;
});
parcelHelpers.export(exports, "NOOP_HISTORY", function() {
    return NOOP_HISTORY;
});
parcelHelpers.export(exports, "DEFAULT_ACTION", function() {
    return DEFAULT_ACTION;
});
var _lodashNoop = require("lodash.noop");
var _lodashNoopDefault = parcelHelpers.interopDefault(_lodashNoop);
var _history = require("./utils/history");
var DEFAULT_LOCATION = {
    pathname: '',
    search: '',
    hash: ''
};
var DEFAULT_MATCH = {
    params: {},
    isExact: false,
    path: '',
    url: '',
    query: {}
};
var DEFAULT_ROUTE = {
    path: '',
    component: function() {
        return null;
    },
    name: ''
};
var DEFAULT_HISTORY = (0, _history.createLegacyHistory)();
var NOOP_HISTORY = {
    location: DEFAULT_LOCATION,
    push: (0, _lodashNoopDefault.default),
    replace: (0, _lodashNoopDefault.default),
    goBack: (0, _lodashNoopDefault.default),
    goForward: (0, _lodashNoopDefault.default),
    listen: (0, _lodashNoopDefault.default),
    block: (0, _lodashNoopDefault.default),
    createHref: (0, _lodashNoopDefault.default)
};
var DEFAULT_ACTION = 'POP';

},{"lodash.noop":"d72U3","./utils/history":"a4yvP","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"d72U3":[function(require,module,exports,__globalThis) {
/**
 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize include="noop" exports="npm" -o ./foo`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /**
 * A no-operation function that returns `undefined` regardless of the
 * arguments it receives.
 *
 * @static
 * @memberOf _
 * @category Util
 * @example
 *
 * var object = { 'user': 'fred' };
 *
 * _.noop(object) === undefined;
 * // => true
 */ function noop() {
// No operation performed.
}
module.exports = noop;

},{}],"a4yvP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createLegacyHistory", function() {
    return createLegacyHistory;
});
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _history = require("history");
var _lodashDebounce = require("lodash.debounce");
var _lodashDebounceDefault = parcelHelpers.interopDefault(_lodashDebounce);
var _lodashNoop = require("lodash.noop");
var _lodashNoopDefault = parcelHelpers.interopDefault(_lodashNoop);
var hasWindow = function() {
    return typeof window !== 'undefined';
};
var methodsPlaceholders = {
    push: (0, _lodashNoopDefault.default),
    replace: (0, _lodashNoopDefault.default),
    goBack: (0, _lodashNoopDefault.default),
    goForward: (0, _lodashNoopDefault.default),
    listen: function() {
        return 0, _lodashNoopDefault.default;
    },
    block: function() {
        return 0, _lodashNoopDefault.default;
    }
};
var getLocation = function() {
    // todo - don't force non-optional search and hash
    var _ref = hasWindow() && window.location || {}, _ref_pathname = _ref.pathname, pathname = _ref_pathname === void 0 ? '' : _ref_pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? '' : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? '' : _ref_hash;
    return {
        pathname: pathname,
        search: search,
        hash: hash
    };
};
var createLegacyListener = function(updateExposedLocation) {
    var node = document.querySelector('#content');
    var prevHref = window.location.href;
    var listeners = [];
    var historyStack = [
        prevHref
    ]; // note: window.history.length is capped at 50 entries
    var prevHistoryLength = window.history.length;
    var historyIndex = 0;
    var getAction = function() {
        var currentHref = window.location.href;
        if (prevHistoryLength === window.history.length) {
            if (historyStack[historyIndex - 1] === currentHref) {
                historyIndex -= 1;
                return 'POP';
            }
            if (historyStack[historyIndex + 1] === currentHref) {
                historyIndex += 1;
                return 'POP';
            }
            historyStack[historyStack.length - 1] = currentHref;
            return 'REPLACE';
        }
        historyStack.push(currentHref);
        historyIndex += 1;
        prevHistoryLength = window.history.length;
        return 'PUSH';
    };
    var onNodeChanges = (0, _lodashDebounceDefault.default)(function() {
        if (prevHref !== window.location.href) {
            var newLocation = getLocation();
            var action = getAction();
            updateExposedLocation(newLocation, action);
            listeners.forEach(function(listener) {
                return listener(newLocation, action);
            });
            prevHref = window.location.href;
        }
    }, 50);
    if (node) {
        var observer = new window.MutationObserver(onNodeChanges);
        observer.observe(node, {
            childList: true,
            subtree: true,
            attributes: true,
            characterData: true
        });
    }
    return function(listener) {
        listeners = listeners.concat(listener);
        return function() {
            listeners = listeners.filter(function(lst) {
                return lst !== listener;
            });
        };
    };
};
var createLegacyHistory = function() {
    var currentLocation = getLocation();
    var currentAction = 'PUSH';
    var updateExposedLocation = function(v, a) {
        currentLocation = v;
        currentAction = a;
    };
    return (0, _extendsDefault.default)({
        get location () {
            return currentLocation;
        },
        get length () {
            return hasWindow() ? window.history.length : 1; // default length is 1
        },
        get action () {
            return currentAction;
        }
    }, hasWindow() ? {
        push: function(path) {
            return window.location.assign(path);
        },
        replace: function(path) {
            return window.history.replaceState({}, document.title, path);
        },
        goBack: function() {
            return window.history.back();
        },
        goForward: function() {
            return window.history.forward();
        },
        listen: createLegacyListener(updateExposedLocation),
        block: function() {
            return 0, _lodashNoopDefault.default;
        },
        createHref: function(location) {
            return (0, _history.createPath)(location);
        }
    } : methodsPlaceholders);
};

},{"@babel/runtime/helpers/extends":"3LZYG","history":"de6OM","lodash.debounce":"3LxnQ","lodash.noop":"d72U3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3LxnQ":[function(require,module,exports,__globalThis) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var _typeOf = require("@swc/helpers/_/_type_of");
var global = arguments[3];
var FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var NAN = 0 / 0;
/** `Object#toString` result references. */ var symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var freeGlobal = (typeof global === "undefined" ? "undefined" : (0, _typeOf._)(global)) == 'object' && global && global.Object === Object && global;
/** Detect free variable `self`. */ var freeSelf = (typeof self === "undefined" ? "undefined" : (0, _typeOf._)(self)) == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max, nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var now = function now() {
    return root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    wait = toNumber(wait) || 0;
    if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge(now());
    }
    function debounced() {
        var time = now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value);
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && (typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return (typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function toNumber(value) {
    if (typeof value == 'number') return value;
    if (isSymbol(value)) return NAN;
    if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace(reTrim, '');
    var isBinary = reIsBinary.test(value);
    return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
module.exports = debounce;

},{"@swc/helpers/_/_type_of":"iFJdx"}],"cxuex":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "matchRoute", function() {
    return 0, _matchRouteDefault.default;
});
parcelHelpers.export(exports, "matchInvariantRoute", function() {
    return 0, _matchRoute.matchInvariantRoute;
});
parcelHelpers.export(exports, "warmupMatchRouteCache", function() {
    return 0, _matchRoute.warmupMatchRouteCache;
});
parcelHelpers.export(exports, "generatePath", function() {
    return 0, _generatePathDefault.default;
});
parcelHelpers.export(exports, "generateLocationFromPath", function() {
    return 0, _generateLocation.generateLocationFromPath;
});
parcelHelpers.export(exports, "createLegacyHistory", function() {
    return 0, _history.createLegacyHistory;
});
parcelHelpers.export(exports, "isServerEnvironment", function() {
    return 0, _isServerEnvironment.isServerEnvironment;
});
parcelHelpers.export(exports, "findRouterContext", function() {
    return 0, _routerContext.findRouterContext;
});
parcelHelpers.export(exports, "createRouterContext", function() {
    return 0, _routerContext.createRouterContext;
});
var _matchRoute = require("./match-route");
var _matchRouteDefault = parcelHelpers.interopDefault(_matchRoute);
var _generatePath = require("./generate-path");
var _generatePathDefault = parcelHelpers.interopDefault(_generatePath);
var _generateLocation = require("./generate-location");
var _history = require("./history");
var _isServerEnvironment = require("./is-server-environment");
var _routerContext = require("./router-context");

},{"./match-route":"7plx8","./generate-path":"4POGJ","./generate-location":"zFlxy","./history":"a4yvP","./is-server-environment":"7kEsL","./router-context":"jSm3D","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7plx8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "matchInvariantRoute", function() {
    return matchInvariantRoute;
});
parcelHelpers.export(exports, "warmupMatchRouteCache", function() {
    return warmupMatchRouteCache;
});
var _urlParse = require("url-parse");
var _execRouteMatching = require("./exec-route-matching");
var _execRouteMatchingDefault = parcelHelpers.interopDefault(_execRouteMatching);
var _utils = require("./utils");
/**
 * Does the given `pathname` and `queryStr` match a route in `routes`.
 *
 * Heavily based on https://github.com/ReactTraining/react-router/blob/master/packages/react-router-config/modules/matchRoute.js
 *
 * Note: This does not support nested routes at this stage.
 */ var matchRoute = function(routes, pathname) {
    var queryParams = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, basePath = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : '';
    var queryParamObject = typeof queryParams === 'string' ? (0, _urlParse.qs).parse(queryParams) : queryParams;
    var cachedMatch = (0, _utils.matchRouteCache).get(pathname, queryParamObject, basePath);
    if (cachedMatch && routes.includes(cachedMatch.route)) return cachedMatch;
    for(var i = 0; i < routes.length; i++){
        var matchedRoute = (0, _execRouteMatchingDefault.default)(routes[i], pathname, queryParamObject, basePath);
        if (matchedRoute) {
            (0, _utils.matchRouteCache).set(pathname, queryParamObject, basePath, matchedRoute);
            return matchedRoute;
        }
    }
    return null;
};
var matchInvariantRoute = function(routes, pathname, queryParams) {
    var basePath = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : '';
    return matchRoute(routes, pathname, queryParams, basePath);
};
var warmupMatchRouteCache = function(route, pathname, queryParams) {
    var basePath = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : '';
    matchRoute([
        route
    ], pathname, queryParams, basePath);
};
exports.default = function(routes, pathname, queryParams) {
    var basePath = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : '';
    return matchRoute(routes, pathname, queryParams, basePath);
};

},{"url-parse":"ik7D1","./exec-route-matching":"aabl8","./utils":"baSxR","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ik7D1":[function(require,module,exports,__globalThis) {
var _instanceof = require("@swc/helpers/_/_instanceof");
var _typeOf = require("@swc/helpers/_/_type_of");
var global = arguments[3];
'use strict';
var required = require("329ec8a109bdc597"), qs = require("905a608e5c8dc11d"), controlOrWhitespace = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/, CRHTLF = /[\n\r\t]/g, slashes = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//, port = /:\d+$/, protocolre = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\\/]+)?([\S\s]*)/i, windowsDriveLetter = /^[a-zA-Z]:/;
/**
 * Remove control characters and whitespace from the beginning of a string.
 *
 * @param {Object|String} str String to trim.
 * @returns {String} A new string representing `str` stripped of control
 *     characters and whitespace from its beginning.
 * @public
 */ function trimLeft(str) {
    return (str ? str : '').toString().replace(controlOrWhitespace, '');
}
/**
 * These are the parse rules for the URL parser, it informs the parser
 * about:
 *
 * 0. The char it Needs to parse, if it's a string it should be done using
 *    indexOf, RegExp using exec and NaN means set as current value.
 * 1. The property we should set when parsing this value.
 * 2. Indication if it's backwards or forward parsing, when set as number it's
 *    the value of extra chars that should be split off.
 * 3. Inherit from location if non existing in the parser.
 * 4. `toLowerCase` the resulting value.
 */ var rules = [
    [
        '#',
        'hash'
    ],
    [
        '?',
        'query'
    ],
    function sanitize(address, url) {
        return isSpecial(url.protocol) ? address.replace(/\\/g, '/') : address;
    },
    [
        '/',
        'pathname'
    ],
    [
        '@',
        'auth',
        1
    ],
    [
        NaN,
        'host',
        undefined,
        1,
        1
    ],
    [
        /:(\d*)$/,
        'port',
        undefined,
        1
    ],
    [
        NaN,
        'hostname',
        undefined,
        1,
        1
    ] // Set left over.
];
/**
 * These properties should not be copied or inherited from. This is only needed
 * for all non blob URL's as a blob URL does not include a hash, only the
 * origin.
 *
 * @type {Object}
 * @private
 */ var ignore = {
    hash: 1,
    query: 1
};
/**
 * The location object differs when your code is loaded through a normal page,
 * Worker or through a worker using a blob. And with the blobble begins the
 * trouble as the location object will contain the URL of the blob, not the
 * location of the page where our code is loaded in. The actual origin is
 * encoded in the `pathname` so we can thankfully generate a good "default"
 * location from it so we can generate proper relative URL's again.
 *
 * @param {Object|String} loc Optional default location object.
 * @returns {Object} lolcation object.
 * @public
 */ function lolcation(loc) {
    var globalVar;
    if (typeof window !== 'undefined') globalVar = window;
    else if (typeof global !== 'undefined') globalVar = global;
    else if (typeof self !== 'undefined') globalVar = self;
    else globalVar = {};
    var location = globalVar.location || {};
    loc = loc || location;
    var finaldestination = {}, type = typeof loc === "undefined" ? "undefined" : (0, _typeOf._)(loc), key;
    if ('blob:' === loc.protocol) finaldestination = new Url(unescape(loc.pathname), {});
    else if ('string' === type) {
        finaldestination = new Url(loc, {});
        for(key in ignore)delete finaldestination[key];
    } else if ('object' === type) {
        for(key in loc){
            if (key in ignore) continue;
            finaldestination[key] = loc[key];
        }
        if (finaldestination.slashes === undefined) finaldestination.slashes = slashes.test(loc.href);
    }
    return finaldestination;
}
/**
 * Check whether a protocol scheme is special.
 *
 * @param {String} The protocol scheme of the URL
 * @return {Boolean} `true` if the protocol scheme is special, else `false`
 * @private
 */ function isSpecial(scheme) {
    return scheme === 'file:' || scheme === 'ftp:' || scheme === 'http:' || scheme === 'https:' || scheme === 'ws:' || scheme === 'wss:';
}
/**
 * @typedef ProtocolExtract
 * @type Object
 * @property {String} protocol Protocol matched in the URL, in lowercase.
 * @property {Boolean} slashes `true` if protocol is followed by "//", else `false`.
 * @property {String} rest Rest of the URL that is not part of the protocol.
 */ /**
 * Extract protocol information from a URL with/without double slash ("//").
 *
 * @param {String} address URL we want to extract from.
 * @param {Object} location
 * @return {ProtocolExtract} Extracted information.
 * @private
 */ function extractProtocol(address, location) {
    address = trimLeft(address);
    address = address.replace(CRHTLF, '');
    location = location || {};
    var match = protocolre.exec(address);
    var protocol = match[1] ? match[1].toLowerCase() : '';
    var forwardSlashes = !!match[2];
    var otherSlashes = !!match[3];
    var slashesCount = 0;
    var rest;
    if (forwardSlashes) {
        if (otherSlashes) {
            rest = match[2] + match[3] + match[4];
            slashesCount = match[2].length + match[3].length;
        } else {
            rest = match[2] + match[4];
            slashesCount = match[2].length;
        }
    } else if (otherSlashes) {
        rest = match[3] + match[4];
        slashesCount = match[3].length;
    } else rest = match[4];
    if (protocol === 'file:') {
        if (slashesCount >= 2) rest = rest.slice(2);
    } else if (isSpecial(protocol)) rest = match[4];
    else if (protocol) {
        if (forwardSlashes) rest = rest.slice(2);
    } else if (slashesCount >= 2 && isSpecial(location.protocol)) rest = match[4];
    return {
        protocol: protocol,
        slashes: forwardSlashes || isSpecial(protocol),
        slashesCount: slashesCount,
        rest: rest
    };
}
/**
 * Resolve a relative URL pathname against a base URL pathname.
 *
 * @param {String} relative Pathname of the relative URL.
 * @param {String} base Pathname of the base URL.
 * @return {String} Resolved pathname.
 * @private
 */ function resolve(relative, base) {
    if (relative === '') return base;
    var path = (base || '/').split('/').slice(0, -1).concat(relative.split('/')), i = path.length, last = path[i - 1], unshift = false, up = 0;
    while(i--){
        if (path[i] === '.') path.splice(i, 1);
        else if (path[i] === '..') {
            path.splice(i, 1);
            up++;
        } else if (up) {
            if (i === 0) unshift = true;
            path.splice(i, 1);
            up--;
        }
    }
    if (unshift) path.unshift('');
    if (last === '.' || last === '..') path.push('');
    return path.join('/');
}
/**
 * The actual URL instance. Instead of returning an object we've opted-in to
 * create an actual constructor as it's much more memory efficient and
 * faster and it pleases my OCD.
 *
 * It is worth noting that we should not use `URL` as class name to prevent
 * clashes with the global URL instance that got introduced in browsers.
 *
 * @constructor
 * @param {String} address URL we want to parse.
 * @param {Object|String} [location] Location defaults for relative paths.
 * @param {Boolean|Function} [parser] Parser for the query string.
 * @private
 */ function Url(address, location, parser) {
    address = trimLeft(address);
    address = address.replace(CRHTLF, '');
    if (!(0, _instanceof._)(this, Url)) return new Url(address, location, parser);
    var relative, extracted, parse, instruction, index, key, instructions = rules.slice(), type = typeof location === "undefined" ? "undefined" : (0, _typeOf._)(location), url = this, i = 0;
    //
    // The following if statements allows this module two have compatibility with
    // 2 different API:
    //
    // 1. Node.js's `url.parse` api which accepts a URL, boolean as arguments
    //    where the boolean indicates that the query string should also be parsed.
    //
    // 2. The `URL` interface of the browser which accepts a URL, object as
    //    arguments. The supplied object will be used as default values / fall-back
    //    for relative paths.
    //
    if ('object' !== type && 'string' !== type) {
        parser = location;
        location = null;
    }
    if (parser && 'function' !== typeof parser) parser = qs.parse;
    location = lolcation(location);
    //
    // Extract protocol information before running the instructions.
    //
    extracted = extractProtocol(address || '', location);
    relative = !extracted.protocol && !extracted.slashes;
    url.slashes = extracted.slashes || relative && location.slashes;
    url.protocol = extracted.protocol || location.protocol || '';
    address = extracted.rest;
    //
    // When the authority component is absent the URL starts with a path
    // component.
    //
    if (extracted.protocol === 'file:' && (extracted.slashesCount !== 2 || windowsDriveLetter.test(address)) || !extracted.slashes && (extracted.protocol || extracted.slashesCount < 2 || !isSpecial(url.protocol))) instructions[3] = [
        /(.*)/,
        'pathname'
    ];
    for(; i < instructions.length; i++){
        instruction = instructions[i];
        if (typeof instruction === 'function') {
            address = instruction(address, url);
            continue;
        }
        parse = instruction[0];
        key = instruction[1];
        if (parse !== parse) url[key] = address;
        else if ('string' === typeof parse) {
            index = parse === '@' ? address.lastIndexOf(parse) : address.indexOf(parse);
            if (~index) {
                if ('number' === typeof instruction[2]) {
                    url[key] = address.slice(0, index);
                    address = address.slice(index + instruction[2]);
                } else {
                    url[key] = address.slice(index);
                    address = address.slice(0, index);
                }
            }
        } else if (index = parse.exec(address)) {
            url[key] = index[1];
            address = address.slice(0, index.index);
        }
        url[key] = url[key] || (relative && instruction[3] ? location[key] || '' : '');
        //
        // Hostname, host and protocol should be lowercased so they can be used to
        // create a proper `origin`.
        //
        if (instruction[4]) url[key] = url[key].toLowerCase();
    }
    //
    // Also parse the supplied query string in to an object. If we're supplied
    // with a custom parser as function use that instead of the default build-in
    // parser.
    //
    if (parser) url.query = parser(url.query);
    //
    // If the URL is relative, resolve the pathname against the base URL.
    //
    if (relative && location.slashes && url.pathname.charAt(0) !== '/' && (url.pathname !== '' || location.pathname !== '')) url.pathname = resolve(url.pathname, location.pathname);
    //
    // Default to a / for pathname if none exists. This normalizes the URL
    // to always have a /
    //
    if (url.pathname.charAt(0) !== '/' && isSpecial(url.protocol)) url.pathname = '/' + url.pathname;
    //
    // We should not add port numbers if they are already the default port number
    // for a given protocol. As the host also contains the port number we're going
    // override it with the hostname which contains no port number.
    //
    if (!required(url.port, url.protocol)) {
        url.host = url.hostname;
        url.port = '';
    }
    //
    // Parse down the `auth` for the username and password.
    //
    url.username = url.password = '';
    if (url.auth) {
        index = url.auth.indexOf(':');
        if (~index) {
            url.username = url.auth.slice(0, index);
            url.username = encodeURIComponent(decodeURIComponent(url.username));
            url.password = url.auth.slice(index + 1);
            url.password = encodeURIComponent(decodeURIComponent(url.password));
        } else url.username = encodeURIComponent(decodeURIComponent(url.auth));
        url.auth = url.password ? url.username + ':' + url.password : url.username;
    }
    url.origin = url.protocol !== 'file:' && isSpecial(url.protocol) && url.host ? url.protocol + '//' + url.host : 'null';
    //
    // The href is just the compiled result.
    //
    url.href = url.toString();
}
/**
 * This is convenience method for changing properties in the URL instance to
 * insure that they all propagate correctly.
 *
 * @param {String} part          Property we need to adjust.
 * @param {Mixed} value          The newly assigned value.
 * @param {Boolean|Function} fn  When setting the query, it will be the function
 *                               used to parse the query.
 *                               When setting the protocol, double slash will be
 *                               removed from the final url if it is true.
 * @returns {URL} URL instance for chaining.
 * @public
 */ function set(part, value, fn) {
    var url = this;
    switch(part){
        case 'query':
            if ('string' === typeof value && value.length) value = (fn || qs.parse)(value);
            url[part] = value;
            break;
        case 'port':
            url[part] = value;
            if (!required(value, url.protocol)) {
                url.host = url.hostname;
                url[part] = '';
            } else if (value) url.host = url.hostname + ':' + value;
            break;
        case 'hostname':
            url[part] = value;
            if (url.port) value += ':' + url.port;
            url.host = value;
            break;
        case 'host':
            url[part] = value;
            if (port.test(value)) {
                value = value.split(':');
                url.port = value.pop();
                url.hostname = value.join(':');
            } else {
                url.hostname = value;
                url.port = '';
            }
            break;
        case 'protocol':
            url.protocol = value.toLowerCase();
            url.slashes = !fn;
            break;
        case 'pathname':
        case 'hash':
            if (value) {
                var char = part === 'pathname' ? '/' : '#';
                url[part] = value.charAt(0) !== char ? char + value : value;
            } else url[part] = value;
            break;
        case 'username':
        case 'password':
            url[part] = encodeURIComponent(value);
            break;
        case 'auth':
            var index = value.indexOf(':');
            if (~index) {
                url.username = value.slice(0, index);
                url.username = encodeURIComponent(decodeURIComponent(url.username));
                url.password = value.slice(index + 1);
                url.password = encodeURIComponent(decodeURIComponent(url.password));
            } else url.username = encodeURIComponent(decodeURIComponent(value));
    }
    for(var i = 0; i < rules.length; i++){
        var ins = rules[i];
        if (ins[4]) url[ins[1]] = url[ins[1]].toLowerCase();
    }
    url.auth = url.password ? url.username + ':' + url.password : url.username;
    url.origin = url.protocol !== 'file:' && isSpecial(url.protocol) && url.host ? url.protocol + '//' + url.host : 'null';
    url.href = url.toString();
    return url;
}
/**
 * Transform the properties back in to a valid and full URL string.
 *
 * @param {Function} stringify Optional query stringify function.
 * @returns {String} Compiled version of the URL.
 * @public
 */ function toString(stringify) {
    if (!stringify || 'function' !== typeof stringify) stringify = qs.stringify;
    var query, url = this, host = url.host, protocol = url.protocol;
    if (protocol && protocol.charAt(protocol.length - 1) !== ':') protocol += ':';
    var result = protocol + (url.protocol && url.slashes || isSpecial(url.protocol) ? '//' : '');
    if (url.username) {
        result += url.username;
        if (url.password) result += ':' + url.password;
        result += '@';
    } else if (url.password) {
        result += ':' + url.password;
        result += '@';
    } else if (url.protocol !== 'file:' && isSpecial(url.protocol) && !host && url.pathname !== '/') //
    // Add back the empty userinfo, otherwise the original invalid URL
    // might be transformed into a valid one with `url.pathname` as host.
    //
    result += '@';
    //
    // Trailing colon is removed from `url.host` when it is parsed. If it still
    // ends with a colon, then add back the trailing colon that was removed. This
    // prevents an invalid URL from being transformed into a valid one.
    //
    if (host[host.length - 1] === ':' || port.test(url.hostname) && !url.port) host += ':';
    result += host + url.pathname;
    query = 'object' === (0, _typeOf._)(url.query) ? stringify(url.query) : url.query;
    if (query) result += '?' !== query.charAt(0) ? '?' + query : query;
    if (url.hash) result += url.hash;
    return result;
}
Url.prototype = {
    set: set,
    toString: toString
};
//
// Expose the URL parser and some additional properties that might be useful for
// others or testing.
//
Url.extractProtocol = extractProtocol;
Url.location = lolcation;
Url.trimLeft = trimLeft;
Url.qs = qs;
module.exports = Url;

},{"@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_type_of":"iFJdx","329ec8a109bdc597":"c0hje","905a608e5c8dc11d":"51Vqi"}],"c0hje":[function(require,module,exports,__globalThis) {
'use strict';
/**
 * Check if we're required to add a port number.
 *
 * @see https://url.spec.whatwg.org/#default-port
 * @param {Number|String} port Port number we need to check
 * @param {String} protocol Protocol we need to check against.
 * @returns {Boolean} Is it a default port for the given protocol
 * @api private
 */ module.exports = function required(port, protocol) {
    protocol = protocol.split(':')[0];
    port = +port;
    if (!port) return false;
    switch(protocol){
        case 'http':
        case 'ws':
            return port !== 80;
        case 'https':
        case 'wss':
            return port !== 443;
        case 'ftp':
            return port !== 21;
        case 'gopher':
            return port !== 70;
        case 'file':
            return false;
    }
    return port !== 0;
};

},{}],"51Vqi":[function(require,module,exports,__globalThis) {
'use strict';
var has = Object.prototype.hasOwnProperty, undef;
/**
 * Decode a URI encoded string.
 *
 * @param {String} input The URI encoded string.
 * @returns {String|Null} The decoded string.
 * @api private
 */ function decode(input) {
    try {
        return decodeURIComponent(input.replace(/\+/g, ' '));
    } catch (e) {
        return null;
    }
}
/**
 * Attempts to encode a given input.
 *
 * @param {String} input The string that needs to be encoded.
 * @returns {String|Null} The encoded string.
 * @api private
 */ function encode(input) {
    try {
        return encodeURIComponent(input);
    } catch (e) {
        return null;
    }
}
/**
 * Simple query string parser.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object}
 * @api public
 */ function querystring(query) {
    var parser = /([^=?#&]+)=?([^&]*)/g, result = {}, part;
    while(part = parser.exec(query)){
        var key = decode(part[1]), value = decode(part[2]);
        //
        // Prevent overriding of existing properties. This ensures that build-in
        // methods like `toString` or __proto__ are not overriden by malicious
        // querystrings.
        //
        // In the case if failed decoding, we want to omit the key/value pairs
        // from the result.
        //
        if (key === null || value === null || key in result) continue;
        result[key] = value;
    }
    return result;
}
/**
 * Transform a query string to an object.
 *
 * @param {Object} obj Object that should be transformed.
 * @param {String} prefix Optional prefix.
 * @returns {String}
 * @api public
 */ function querystringify(obj, prefix) {
    prefix = prefix || '';
    var pairs = [], value, key;
    //
    // Optionally prefix with a '?' if needed
    //
    if ('string' !== typeof prefix) prefix = '?';
    for(key in obj)if (has.call(obj, key)) {
        value = obj[key];
        //
        // Edge cases where we actually want to encode the value to an empty
        // string instead of the stringified value.
        //
        if (!value && (value === null || value === undef || isNaN(value))) value = '';
        key = encode(key);
        value = encode(value);
        //
        // If we failed to encode the strings, we should bail out as we don't
        // want to add invalid strings to the query.
        //
        if (key === null || value === null) continue;
        pairs.push(key + '=' + value);
    }
    return pairs.length ? prefix + pairs.join('&') : '';
}
//
// Expose the module.
//
exports.stringify = querystringify;
exports.parse = querystring;

},{}],"aabl8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _matchPath = require("./matchPath");
var _matchPathDefault = parcelHelpers.interopDefault(_matchPath);
var _matchQuery = require("./matchQuery");
var _matchQueryDefault = parcelHelpers.interopDefault(_matchQuery);
/* This should match what react-router does to compute a root match. */ var computeRootMatch = function(pathname) {
    return {
        path: '/',
        url: '/',
        params: {},
        isExact: pathname === '/',
        query: {}
    };
};
function execRouteMatching(route, pathname, queryObj, basePath) {
    var pathMatch = route.path ? (0, _matchPathDefault.default)(pathname, {
        path: route.path,
        exact: route.exact,
        basePath: basePath
    }) : computeRootMatch(pathname);
    var match = pathMatch;
    if (pathMatch && route.query) match = (0, _matchQueryDefault.default)(route.query, queryObj, pathMatch);
    else if (pathMatch) match = (0, _extendsDefault.default)((0, _extendsDefault.default)({}, pathMatch), {}, {
        query: {}
    });
    if (match) return {
        match: match,
        route: route
    };
    return null;
}
exports.default = execRouteMatching;

},{"@babel/runtime/helpers/extends":"3LZYG","./matchPath":"4Qrro","./matchQuery":"3mjZI","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4Qrro":[function(require,module,exports,__globalThis) {
// TAKEN FROM https://github.com/ReactTraining/react-router/blob/master/packages/react-router/modules/matchPath.js
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _toArray = require("@swc/helpers/_/_to_array");
var _pathToRegexp = require("path-to-regexp");
var _pathToRegexpDefault = parcelHelpers.interopDefault(_pathToRegexp);
var cache = {};
var cacheLimit = 10000;
var cacheCount = 0;
function compilePath(path, options) {
    var cacheKey = "".concat(options.end).concat(options.strict).concat(options.sensitive);
    var pathCache = cache[cacheKey] || (cache[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, _pathToRegexpDefault.default)(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if (cacheCount < cacheLimit) {
        pathCache[path] = result;
        cacheCount++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 * TODO: reduce returns Array<never>
 */ function matchPath(pathname) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (typeof options === 'string' || Array.isArray(options)) options = {
        path: options
    };
    var p = options.path, _options_exact = options.exact, exact = _options_exact === void 0 ? false : _options_exact, _options_strict = options.strict, strict = _options_strict === void 0 ? false : _options_strict, _options_sensitive = options.sensitive, sensitive = _options_sensitive === void 0 ? false : _options_sensitive, _options_basePath = options.basePath, basePath = _options_basePath === void 0 ? '' : _options_basePath;
    var paths = [].concat(basePath + p);
    return paths.reduce(function(matched, path) {
        if (!path && path !== '') return null;
        if (matched) return matched;
        var _compilePath = compilePath(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var _match = (0, _toArray._)(match), url = _match[0], values = _match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === '/' && url === '' ? '/' : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
exports.default = matchPath;

},{"@swc/helpers/_/_to_array":"auK39","path-to-regexp":"b3THl","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"auK39":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _to_array;
});
var _arrayWithHolesJs = require("./_array_with_holes.js");
var _iterableToArrayJs = require("./_iterable_to_array.js");
var _nonIterableRestJs = require("./_non_iterable_rest.js");
var _unsupportedIterableToArrayJs = require("./_unsupported_iterable_to_array.js");
function _to_array(arr) {
    return (0, _arrayWithHolesJs._)(arr) || (0, _iterableToArrayJs._)(arr) || (0, _unsupportedIterableToArrayJs._)(arr) || (0, _nonIterableRestJs._)();
}

},{"./_array_with_holes.js":"1b6J0","./_iterable_to_array.js":"cfFdp","./_non_iterable_rest.js":"bcYt6","./_unsupported_iterable_to_array.js":"7lOoC","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"b3THl":[function(require,module,exports,__globalThis) {
var _instanceof = require("@swc/helpers/_/_instanceof");
var _typeOf = require("@swc/helpers/_/_type_of");
var isarray = require("d8dd97c5b50b0083");
/**
 * Expose `pathToRegexp`.
 */ module.exports = pathToRegexp;
module.exports.parse = parse;
module.exports.compile = compile;
module.exports.tokensToFunction = tokensToFunction;
module.exports.tokensToRegExp = tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    '(\\\\.)',
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = '';
    var defaultDelimiter = options && options.delimiter || '/';
    var res;
    while((res = PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = '';
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === '+' || modifier === '*';
        var optional = modifier === '?' || modifier === '*';
        var delimiter = prefix || defaultDelimiter;
        var pattern = capture || group;
        var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '');
        tokens.push({
            name: name || key++,
            prefix: prefix || '',
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? escapeGroup(pattern) : asterisk ? '.*' : restrictBacktrack(delimiter, prevText)
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
function restrictBacktrack(delimiter, prevText) {
    if (!prevText || prevText.indexOf(delimiter) > -1) return '[^' + escapeString(delimiter) + ']+?';
    return escapeString(prevText) + '|(?:(?!' + escapeString(prevText) + ')[^' + escapeString(delimiter) + '])+?';
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function compile(str, options) {
    return tokensToFunction(parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if ((0, _typeOf._)(tokens[i]) === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options));
    return function(obj, opts) {
        var path = '';
        var data = obj || {};
        var _$options = opts || {};
        var encode = _$options.pretty ? encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if (isarray(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, '\\$1');
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push(pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));
    return attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function stringToRegexp(path, keys, options) {
    return tokensToRegExp(parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function tokensToRegExp(tokens, keys, options) {
    if (!isarray(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = '';
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === 'string') route += escapeString(token);
        else {
            var prefix = escapeString(token.prefix);
            var capture = '(?:' + token.pattern + ')';
            keys.push(token);
            if (token.repeat) capture += '(?:' + prefix + capture + ')*';
            if (token.optional) {
                if (!token.partial) capture = '(?:' + prefix + '(' + capture + '))?';
                else capture = prefix + '(' + capture + ')?';
            } else capture = prefix + '(' + capture + ')';
            route += capture;
        }
    }
    var delimiter = escapeString(options.delimiter || '/');
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
    if (end) route += '$';
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
    return attachKeys(new RegExp('^' + route, flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function pathToRegexp(path, keys, options) {
    if (!isarray(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if ((0, _instanceof._)(path, RegExp)) return regexpToRegexp(path, /** @type {!Array} */ keys);
    if (isarray(path)) return arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}

},{"@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_type_of":"iFJdx","d8dd97c5b50b0083":"3EY45"}],"3EY45":[function(require,module,exports,__globalThis) {
module.exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == '[object Array]';
};

},{}],"3mjZI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
/**
 * Matches `queryStr` against config stored in `queryConfig`.
 *
 * Returns `pathMatch` with an additional query prop with query params if the match succeeds,
 * otherwise returns null.
 *
 */ function matchQuery(queryConfig, queryParams, pathMatch) {
    var queryMatch = {};
    var isMatchingQuery = queryConfig.every(function(query) {
        // eslint-disable-next-line prefer-const
        var _query_split = (0, _slicedToArray._)(query.split('='), 2), names = _query_split[0], value = _query_split[1];
        var negation = false;
        /* Check if negative matching query param (eg 'foo!=1') */ if (query.includes('!=')) {
            names = names.substring(0, names.length - 1);
            negation = true;
        }
        /* Allow alternate query params presence (eg 'foo|bar') */ var matched = names.split('|').map(function(name) {
            var isOptional = false;
            /* Check if optional query param (eg 'foo?') */ if (name.includes('?')) {
                // eslint-disable-next-line no-param-reassign
                name = name.substring(0, name.length - 1);
                isOptional = true;
            }
            /* First check if queryParams contains the relevant param */ var match = Object.prototype.hasOwnProperty.call(queryParams, name);
            /* Save actual value so we expose it as part of match object */ if (match) queryMatch[name] = queryParams[name] || '';
            /* If no value matching required or it is optional and the param is missing */ if (!value || isOptional && !match) return isOptional || match;
            if (value.startsWith('(')) /* Handle value being a regexp eg 's=(\\d+)' */ match = new RegExp("^".concat(value, "$")).test(queryParams[name] || '');
            else /* Handle value exact matching eg 's=123' */ match = queryParams[name] === value;
            return negation ? !match : match;
        });
        /* If at least one of alternate query params matches then it is a match */ return matched.includes(true);
    });
    return isMatchingQuery ? (0, _extendsDefault.default)((0, _extendsDefault.default)({}, pathMatch), {}, {
        query: queryMatch
    }) : null;
}
exports.default = matchQuery;

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","@babel/runtime/helpers/extends":"3LZYG","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"baSxR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "matchRouteCache", function() {
    return matchRouteCache;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var hasOwnProperty = Object.prototype.hasOwnProperty;
var MAX_CACHE_SIZE = 1000;
function shallowEqual(objA, objB) {
    if (objA === objB) return true;
    if ((typeof objA === "undefined" ? "undefined" : (0, _typeOf._)(objA)) !== 'object' || objA === null || (typeof objB === "undefined" ? "undefined" : (0, _typeOf._)(objB)) !== 'object' || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
     // Test for A's keys different from B.
    for(var i = 0; i < keysA.length; i++){
        if (!hasOwnProperty.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
    }
    return true;
}
var matchRouteCache = {
    cache: new Map(),
    get: function get(pathname, queryObj, basePath) {
        var pathCache = this.cache.get(basePath + pathname);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (pathCache) try {
            for(var _iterator = pathCache[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, _slicedToArray._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                if (shallowEqual(key, queryObj)) return value;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    },
    set: function set(pathname, queryObj, basePath, matchRoute) {
        if (this.cache.size > MAX_CACHE_SIZE) this.cache.clear();
        var pathCache = this.cache.get(basePath + pathname);
        if (pathCache) {
            if (pathCache.size > MAX_CACHE_SIZE / 10) pathCache.clear();
            pathCache.set(queryObj, matchRoute);
        } else this.cache.set(basePath + pathname, new Map([
            [
                queryObj,
                matchRoute
            ]
        ]));
    }
};

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_type_of":"iFJdx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4POGJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _pathToRegexp = require("path-to-regexp");
var _pathToRegexpDefault = parcelHelpers.interopDefault(_pathToRegexp);
var generatePath = function() {
    var pattern = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '/', params = arguments.length > 1 ? arguments[1] : void 0;
    return pattern === '/' ? pattern : (0, _pathToRegexpDefault.default).compile(pattern)(params);
};
exports.default = generatePath;

},{"path-to-regexp":"b3THl","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"zFlxy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateLocationFromPath", function() {
    return generateLocationFromPath;
});
var _pathToRegexp = require("path-to-regexp");
var _pathToRegexpDefault = parcelHelpers.interopDefault(_pathToRegexp);
var _urlParse = require("url-parse");
function generateLocationFromPath() {
    var pattern = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '/', options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _options_params = options.params, params = _options_params === void 0 ? {} : _options_params, _options_query = options.query, query = _options_query === void 0 ? {} : _options_query, _options_basePath = options.basePath, basePath = _options_basePath === void 0 ? '' : _options_basePath; // @ts-ignore stringify accepts two params but it's type doesn't say so
    var stringifiedQuery = (0, _urlParse.qs).stringify(query, true);
    var pathname = pattern === '/' ? pattern : (0, _pathToRegexpDefault.default).compile(pattern)(params);
    return {
        pathname: "".concat(basePath).concat(pathname),
        search: stringifiedQuery,
        hash: ''
    };
}

},{"path-to-regexp":"b3THl","url-parse":"ik7D1","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7kEsL":[function(require,module,exports,__globalThis) {
/**
 * @see https://github.com/jsdom/jsdom/releases/tag/12.0.0
 * @see https://github.com/jsdom/jsdom/issues/1537
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isServerEnvironment", function() {
    return isServerEnvironment;
});
var process = require("1c958b04a6d85816");
var isJsDomEnvironment = function() {
    return window.name === 'nodejs' || navigator.userAgent.includes('Node.js') || navigator.userAgent.includes('jsdom');
};
var isServerEnvironment = function() {
    if (typeof process !== 'undefined' && process.versions != null && process.versions.node != null) return true;
    if (isJsDomEnvironment()) return true;
    return false;
};

},{"1c958b04a6d85816":"gNLf3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jSm3D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createRouterContext", function() {
    return createRouterContext;
});
parcelHelpers.export(exports, "findRouterContext", function() {
    return findRouterContext;
});
var _urlParse = require("url-parse");
var _constants = require("../../constants");
var _matchRoute = require("../match-route");
var _matchRouteDefault = parcelHelpers.interopDefault(_matchRoute);
var _generatePath = require("../generate-path");
var _generatePathDefault = parcelHelpers.interopDefault(_generatePath);
var createRouterContext = function(route) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _options_params = options.params, params = _options_params === void 0 ? {} : _options_params, _options_query = options.query, query = _options_query === void 0 ? {} : _options_query, _options_basePath = options.basePath, basePath = _options_basePath === void 0 ? '' : _options_basePath;
    var pathname = (0, _generatePathDefault.default)(route.path, params);
    var matchedRoute = (0, _matchRouteDefault.default)([
        route
    ], pathname, query, basePath);
    return {
        route: route,
        match: matchedRoute ? matchedRoute.match : (0, _constants.DEFAULT_MATCH),
        query: query
    };
};
var findRouterContext = function(routes, options) {
    var location = options.location, _options_basePath = options.basePath, basePath = _options_basePath === void 0 ? '' : _options_basePath;
    var pathname = location.pathname, search = location.search;
    var query = (0, _urlParse.qs).parse(search);
    var matchedRoute = (0, _matchRouteDefault.default)(routes, pathname, query, basePath);
    return {
        query: query,
        route: matchedRoute ? matchedRoute.route : (0, _constants.DEFAULT_ROUTE),
        match: matchedRoute ? matchedRoute.match : (0, _constants.DEFAULT_MATCH)
    };
};

},{"url-parse":"ik7D1","../../constants":"fjgCw","../match-route":"7plx8","../generate-path":"4POGJ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jhbl4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isExternalAbsolutePath", function() {
    return 0, _pathUtils.isExternalAbsolutePath;
});
parcelHelpers.export(exports, "getRelativePath", function() {
    return 0, _pathUtils.getRelativePath;
});
parcelHelpers.export(exports, "updateQueryParams", function() {
    return 0, _pathUtils.updateQueryParams;
});
parcelHelpers.export(exports, "getRelativeURLFromLocation", function() {
    return 0, _pathUtils.getRelativeURLFromLocation;
});
var _pathUtils = require("./path-utils");

},{"./path-utils":"7cepb","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7cepb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sanitizePath", function() {
    return sanitizePath;
});
parcelHelpers.export(exports, "isAbsolutePath", function() {
    return isAbsolutePath;
});
parcelHelpers.export(exports, "isExternalAbsolutePath", function() {
    return isExternalAbsolutePath;
});
parcelHelpers.export(exports, "getRelativePath", function() {
    return getRelativePath;
});
parcelHelpers.export(exports, "updateQueryParams", function() {
    return updateQueryParams;
});
parcelHelpers.export(exports, "getRelativeURLFromLocation", function() {
    return getRelativeURLFromLocation;
});
var _urlParse = require("url-parse");
var _urlParseDefault = parcelHelpers.interopDefault(_urlParse);
var stripTrailingSlash = function(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};
var addLeadingSlash = function(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
};
var sanitizePath = function(path) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : '';
    if (prefix) {
        prefix = stripTrailingSlash(prefix);
        prefix = addLeadingSlash(prefix);
        path = addLeadingSlash(path);
    }
    return prefix + path;
};
var isAbsolutePath = function(path) {
    var regex = new RegExp('^([a-z]+://|//)', 'i');
    return regex.test(path);
};
var isExternalAbsolutePath = function(path) {
    if (typeof path !== 'string' || !isAbsolutePath(path)) return false;
    var pathHostname = new (0, _urlParseDefault.default)(path).hostname;
    var currentHostname = new (0, _urlParseDefault.default)(window.location.href).hostname;
    return pathHostname !== currentHostname;
};
var getRelativePath = function(path) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : '';
    if (typeof path !== 'string') return path;
    if (!isAbsolutePath(path)) {
        path = sanitizePath(path, prefix);
        return path;
    }
    var url = new (0, _urlParseDefault.default)(path);
    return "".concat(url.pathname).concat(url.query).concat(url.hash);
};
var updateQueryParams = function(location, query) {
    // @ts-ignore stringify accepts two params but it's type doesn't say so
    var stringifiedQuery = (0, _urlParse.qs).stringify(query, true);
    return "".concat(location.pathname).concat(stringifiedQuery).concat(location.hash);
};
var getRelativeURLFromLocation = function(location) {
    return "".concat(location.pathname).concat(location.search).concat(location.hash);
};

},{"url-parse":"ik7D1","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9mmgg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RouterSubscriber", function() {
    return RouterSubscriber;
});
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _routerStore = require("../../router-store");
var RouterSubscriber = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _routerStore.RouterSubscriber), null, function(state, _ref) {
        var listen = _ref.listen, actions = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, [
            "listen"
        ]);
        if (!state.unlisten && !state.isStatic) listen();
        return children(state, actions);
    });
};

},{"@babel/runtime/helpers/objectWithoutPropertiesLoose":"5JG3D","react":"ltHCL","../../router-store":"hf6U0","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jqyTp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Router", function() {
    return Router;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _constants = require("../../common/constants");
var _routerStore = require("../router-store");
var Router = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, _inherits._)(Router, Component);
    function Router() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, _classCallCheck._)(this, Router);
        var _this;
        _this = (0, _callSuper._)(this, Router, (0, _toConsumableArray._)(args));
        (0, _definePropertyDefault.default)(_this, "unlistenHistory", null);
        return _this;
    }
    (0, _createClass._)(Router, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!this.props.isStatic) {
                    var state = (0, _routerStore.getRouterState)();
                    this.unlistenHistory = state.unlisten;
                }
            }
        },
        {
            /**
   * Ensures that the router store stops listening to history when the Router
   * is unmounted.
   */ key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.unlistenHistory) this.unlistenHistory();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, children = _this_props.children, routes = _this_props.routes, history = _this_props.history, initialRoute = _this_props.initialRoute, isStatic = _this_props.isStatic, isGlobal = _this_props.isGlobal, basePath = _this_props.basePath, resourceContext = _this_props.resourceContext, resourceData = _this_props.resourceData, onPrefetch = _this_props.onPrefetch;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _routerStore.RouterContainer), {
                    basePath: basePath,
                    routes: routes,
                    history: history,
                    initialRoute: initialRoute,
                    isStatic: isStatic,
                    resourceContext: resourceContext,
                    resourceData: resourceData,
                    onPrefetch: onPrefetch,
                    isGlobal: isGlobal
                }, children);
            }
        }
    ]);
    return Router;
}((0, _react.Component));
(0, _definePropertyDefault.default)(Router, "defaultProps", {
    isStatic: false,
    isGlobal: true,
    history: (0, _constants.DEFAULT_HISTORY)
});

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_inherits":"2sfqW","@swc/helpers/_/_to_consumable_array":"1eSZf","@babel/runtime/helpers/defineProperty":"8oXwS","react":"ltHCL","../../common/constants":"fjgCw","../router-store":"hf6U0","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8oXwS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _defineProperty;
});
var _toPropertyKeyJs = require("./toPropertyKey.js");
var _toPropertyKeyJsDefault = parcelHelpers.interopDefault(_toPropertyKeyJs);
function _defineProperty(e, r, t) {
    return (r = (0, _toPropertyKeyJsDefault.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

},{"./toPropertyKey.js":"5Jbo9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5Jbo9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return toPropertyKey;
});
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
var _toPrimitiveJs = require("./toPrimitive.js");
var _toPrimitiveJsDefault = parcelHelpers.interopDefault(_toPrimitiveJs);
function toPropertyKey(t) {
    var i = (0, _toPrimitiveJsDefault.default)(t, "string");
    return "symbol" == (0, _typeofJsDefault.default)(i) ? i : i + "";
}

},{"./typeof.js":"jvCfw","./toPrimitive.js":"g96z4","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jvCfw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _typeof;
});
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"g96z4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return toPrimitive;
});
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
function toPrimitive(t, r) {
    if ("object" != (0, _typeofJsDefault.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, _typeofJsDefault.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

},{"./typeof.js":"jvCfw","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"anf9k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MemoryRouter", function() {
    return MemoryRouter;
});
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _history = require("history");
var _router = require("../router");
var getRouterProps = function(memoryRouterProps) {
    var _memoryRouterProps_isStatic = memoryRouterProps.isStatic, isStatic = _memoryRouterProps_isStatic === void 0 ? false : _memoryRouterProps_isStatic, _memoryRouterProps_isGlobal = memoryRouterProps.isGlobal, isGlobal = _memoryRouterProps_isGlobal === void 0 ? true : _memoryRouterProps_isGlobal, basePath = memoryRouterProps.basePath, routes = memoryRouterProps.routes, resourceData = memoryRouterProps.resourceData, resourceContext = memoryRouterProps.resourceContext;
    var routerProps = {
        basePath: basePath,
        routes: routes,
        isStatic: isStatic,
        isGlobal: isGlobal
    };
    if (resourceData) routerProps = (0, _extendsDefault.default)((0, _extendsDefault.default)({}, routerProps), {}, {
        resourceData: resourceData
    });
    if (resourceContext) routerProps = (0, _extendsDefault.default)((0, _extendsDefault.default)({}, routerProps), {}, {
        resourceContext: resourceContext
    });
    return routerProps;
};
var MemoryRouter = function(props) {
    var location = props.location, children = props.children;
    var config = {};
    if (location) config.initialEntries = [
        location
    ];
    var history = (0, _history.createMemoryHistory)(config);
    var routerProps = getRouterProps(props);
    return(/*#__PURE__*/ // @ts-ignore suppress history will be overwritten warning
    (0, _reactDefault.default).createElement((0, _router.Router), (0, _extendsDefault.default)({
        history: history
    }, routerProps), children));
};

},{"@babel/runtime/helpers/extends":"3LZYG","react":"ltHCL","history":"de6OM","../router":"jqyTp","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lJnVA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StaticRouter", function() {
    return StaticRouter;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _history = require("history");
var _createLocation = require("../../common/utils/create-location");
var _memoryRouter = require("../memory-router");
var _resourceStore = require("../resource-store");
var _routerStore = require("../router-store");
var StaticRouter = function(param) {
    var location = param.location, routes = param.routes, children = param.children, basePath = param.basePath;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _memoryRouter.MemoryRouter), {
        location: location,
        routes: routes,
        basePath: basePath,
        isStatic: true
    }, children);
};
/**
 * The entry point for requesting resource data on the server.
 * Pass the result data into the router as a prop in order to hydrate it.
 * TODO: return type (see imports)
 */ StaticRouter.requestResources = function(props) {
    return (0, _asyncToGenerator._)(function() {
        var _getRouterStore_actions, bootstrapStore, requestRouteResources, location, timeout, bootstrapProps, initialEntries, overrides;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _getRouterStore_actions = (0, _routerStore.getRouterStore)().actions, bootstrapStore = _getRouterStore_actions.bootstrapStore, requestRouteResources = _getRouterStore_actions.requestRouteResources;
                    location = props.location, timeout = props.timeout, bootstrapProps = (0, _objectWithoutPropertiesLooseDefault.default)(props, [
                        "location",
                        "timeout"
                    ]);
                    initialEntries = [
                        location
                    ];
                    overrides = {
                        history: (0, _history.createMemoryHistory)({
                            initialEntries: initialEntries
                        }),
                        location: (0, _createLocation.createLocation)(location),
                        isStatic: true
                    };
                    bootstrapStore((0, _extendsDefault.default)((0, _extendsDefault.default)({}, bootstrapProps), overrides));
                    return [
                        4,
                        requestRouteResources({
                            timeout: timeout,
                            isStatic: true
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        (0, _resourceStore.getResourceStore)().actions.getSafeData()
                    ];
            }
        });
    })();
};
StaticRouter.addResourcesListener = function(fn) {
    return (0, _resourceStore.getResourceStore)().storeState.subscribe(fn);
};

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_ts_generator":"78Tqx","@babel/runtime/helpers/extends":"3LZYG","@babel/runtime/helpers/objectWithoutPropertiesLoose":"5JG3D","react":"ltHCL","history":"de6OM","../../common/utils/create-location":"9XEP9","../memory-router":"anf9k","../resource-store":"bHILc","../router-store":"hf6U0","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9XEP9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createLocation", function() {
    return 0, _createLocation.createLocation;
});
var _createLocation = require("./create-location");

},{"./create-location":"5QxR8","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5QxR8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createLocation", function() {
    return createLocation;
});
var _decodePath = require("./decode-path");
var _parsePath = require("./parse-path");
function createLocation() {
    var path = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '';
    var location = (0, _parsePath.parsePath)(path);
    location.pathname = (0, _decodePath.decodePath)(location.pathname);
    return location;
}

},{"./decode-path":"f3Poc","./parse-path":"8NIjZ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"f3Poc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "decodePath", function() {
    return decodePath;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _inherits = require("@swc/helpers/_/_inherits");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _wrapNativeSuper = require("@swc/helpers/_/_wrap_native_super");
var DecodeUriError = /*#__PURE__*/ function(URIError1) {
    "use strict";
    (0, _inherits._)(DecodeUriError, URIError1);
    function DecodeUriError(path) {
        (0, _classCallCheck._)(this, DecodeUriError);
        return (0, _callSuper._)(this, DecodeUriError, [
            "Pathname ".concat(path, " could not be decoded. This is likely caused by an invalid percent-encoding.")
        ]);
    }
    return DecodeUriError;
}((0, _wrapNativeSuper._)(URIError));
function decodePath(path) {
    try {
        return decodeURI(path);
    } catch (e) {
        if ((0, _instanceof._)(e, URIError)) throw new DecodeUriError(path);
        else throw e;
    }
}

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_inherits":"2sfqW","@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_wrap_native_super":"d0Iin","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8NIjZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parsePath", function() {
    return parsePath;
});
var _urlParse = require("url-parse");
var _urlParseDefault = parcelHelpers.interopDefault(_urlParse);
function parsePath(path) {
    var url = new (0, _urlParseDefault.default)(path, 'ws://a.a');
    var isAbsolute = path.startsWith('/');
    var pathname = isAbsolute || url.pathname === '/' ? url.pathname : url.pathname.slice(1);
    return {
        pathname: pathname,
        search: url.query,
        hash: url.hash
    };
}

},{"url-parse":"ik7D1","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dl0mj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RouterActions", function() {
    return RouterActions;
});
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
/* eslint-disable @typescript-eslint/no-unused-vars */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _routerStore = require("../router-store");
var RouterActions = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _routerStore.RouterActionsSubscriber), null, function(__, _ref) {
        var actions = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, [
            "bootstrapStore",
            "listen",
            "requestRouteResources"
        ]);
        return children(actions);
    });
};
RouterActions.displayName = 'RouterActions';

},{"@babel/runtime/helpers/objectWithoutPropertiesLoose":"5JG3D","react":"ltHCL","../router-store":"hf6U0","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dmfvG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Redirect", function() {
    return Redirect;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _typeOf = require("@swc/helpers/_/_type_of");
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _history = require("history");
var _route = require("../subscribers/route");
var _utils = require("../../common/utils");
var Redirector = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, _inherits._)(Redirector, Component);
    function Redirector() {
        (0, _classCallCheck._)(this, Redirector);
        return (0, _callSuper._)(this, Redirector, arguments);
    }
    (0, _createClass._)(Redirector, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this_props = this.props, to = _this_props.to, location = _this_props.location, push = _this_props.push, params = _this_props.params, query = _this_props.query, actions = _this_props.actions;
                var routeAttributes = {
                    params: params,
                    query: query,
                    basePath: actions.getBasePath()
                };
                var newPath = (typeof to === "undefined" ? "undefined" : (0, _typeOf._)(to)) === 'object' ? 'path' in to ? (0, _history.createPath)((0, _utils.generateLocationFromPath)(to.path, routeAttributes)) : (0, _history.createPath)(to) : to;
                var currentPath = (0, _history.createPath)(location);
                var action = push ? actions.push : actions.replace;
                if (currentPath === newPath) return;
                action(newPath);
            }
        },
        {
            key: "render",
            value: function render() {
                return null;
            }
        }
    ]);
    return Redirector;
}((0, _react.Component));
(0, _definePropertyDefault.default)(Redirector, "defaultProps", {
    push: false
});
var Redirect = function(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _route.RouterSubscriber), null, function(param, actions) {
        var location = param.location;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Redirector, (0, _extendsDefault.default)({
            actions: actions,
            location: location
        }, props));
    });
};

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_inherits":"2sfqW","@swc/helpers/_/_type_of":"iFJdx","@babel/runtime/helpers/extends":"3LZYG","@babel/runtime/helpers/defineProperty":"8oXwS","react":"ltHCL","history":"de6OM","../subscribers/route":"9mmgg","../../common/utils":"cxuex","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jVZEC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "withRouter", function() {
    return withRouter;
});
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _route = require("../subscribers/route");
var getWrappedComponentDisplayName = function(component) {
    var componentDisplayName = 'UNDEFINED';
    var displayName = component.displayName, name = component.name;
    if (displayName) componentDisplayName = displayName;
    if (name) componentDisplayName = name;
    return "withRouter(".concat(componentDisplayName, ")");
};
var withRouter = function(WrappedComponent) {
    var displayName = getWrappedComponentDisplayName(WrappedComponent);
    var Component = WrappedComponent;
    var ComponentWithRouter = function(props) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _route.RouterSubscriber), null, function(param, param1) {
            var route = param.route, location = param.location, query = param.query, match = param.match, action = param.action, history = param.history, push = param1.push, replace = param1.replace;
            return /*#__PURE__*/ (0, _reactDefault.default).createElement(Component, (0, _extendsDefault.default)({}, props, {
                route: route,
                location: location,
                query: query,
                match: match,
                action: action,
                history: history,
                push: push,
                replace: replace
            }));
        });
    };
    ComponentWithRouter.displayName = displayName;
    return ComponentWithRouter;
};

},{"@babel/runtime/helpers/extends":"3LZYG","react":"ltHCL","../subscribers/route":"9mmgg","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"22m5g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useResource", function() {
    return 0, _resourceStore.useResource;
});
parcelHelpers.export(exports, "useRouter", function() {
    return 0, _routerStore.useRouter;
});
parcelHelpers.export(exports, "useRouterActions", function() {
    return 0, _routerStore.useRouterActions;
});
parcelHelpers.export(exports, "useQueryParam", function() {
    return 0, _routerStore.useQueryParam;
});
parcelHelpers.export(exports, "usePathParam", function() {
    return 0, _routerStore.usePathParam;
});
var _resourceStore = require("./resource-store");
var _routerStore = require("./router-store");

},{"./resource-store":"jfek9","./router-store":"aTUeR","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aTUeR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useRouter", function() {
    return useRouter;
});
parcelHelpers.export(exports, "useRouterActions", function() {
    return useRouterActions;
});
parcelHelpers.export(exports, "useQueryParam", function() {
    return useQueryParam;
});
parcelHelpers.export(exports, "usePathParam", function() {
    return usePathParam;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactSweetState = require("react-sweet-state");
var _routerStore = require("../../router-store");
var useRouter = function() {
    var _useRouterStore = (0, _slicedToArray._)((0, _routerStore.useRouterStore)(), 2), entireState = _useRouterStore[0], allActions = _useRouterStore[1];
    return [
        entireState,
        allActions
    ];
};
var useRouterActions = function() {
    var _useRouterStoreStatic = (0, _slicedToArray._)((0, _routerStore.useRouterStoreStatic)(), 2), allActions = _useRouterStoreStatic[1];
    return allActions;
};
var createQueryParamHook = (0, _reactSweetState.createHook)((0, _routerStore.RouterStore), {
    selector: function(param, param1) {
        var query = param.query, paramKey = param1.paramKey;
        return query[paramKey];
    }
});
var createPathParamHook = (0, _reactSweetState.createHook)((0, _routerStore.RouterStore), {
    selector: function(param, param1) {
        var params = param.match.params, paramKey = param1.paramKey;
        return params[paramKey];
    }
});
var useQueryParam = function(paramKey) {
    var _createQueryParamHook = (0, _slicedToArray._)(createQueryParamHook({
        paramKey: paramKey
    }), 2), paramVal = _createQueryParamHook[0], routerActions = _createQueryParamHook[1];
    var setQueryParam = (0, _reactDefault.default).useCallback(function(newValue, updateType) {
        routerActions.updateQueryParam((0, _defineProperty._)({}, paramKey, newValue), updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setQueryParam
    ];
};
var usePathParam = function(paramKey) {
    var _createPathParamHook = (0, _slicedToArray._)(createPathParamHook({
        paramKey: paramKey
    }), 2), paramVal = _createPathParamHook[0], routerActions = _createPathParamHook[1];
    var setPathParam = (0, _reactDefault.default).useCallback(function(newValue, updateType) {
        routerActions.updatePathParam((0, _defineProperty._)({}, paramKey, newValue), updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setPathParam
    ];
};

},{"@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_sliced_to_array":"8PtL6","react":"ltHCL","react-sweet-state":"b2YYl","../../router-store":"hf6U0","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fCq3I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createResource", function() {
    return createResource;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _constants = require("../resource-store/constants");
/**
 * Utility method to created async versions of getData functions
 *
 */ var handleGetDataLoader = function(asyncImport) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return (0, _asyncToGenerator._)(function() {
            var _ref, getDataFn;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            asyncImport()
                        ];
                    case 1:
                        _ref = _state.sent(), getDataFn = _ref.default;
                        return [
                            2,
                            getDataFn.apply(void 0, (0, _toConsumableArray._)(args))
                        ];
                }
            });
        })();
    };
};
var createResource = function(arg) {
    var _getData, _arg$depends;
    return {
        type: arg.type,
        getKey: arg.getKey,
        getData: (_getData = arg.getData) != null ? _getData : handleGetDataLoader(arg.getDataLoader),
        maxAge: typeof arg.maxAge === 'number' ? arg.maxAge : (0, _constants.DEFAULT_RESOURCE_MAX_AGE),
        maxCache: typeof arg.maxCache === 'number' ? arg.maxCache : (0, _constants.DEFAULT_CACHE_MAX_LIMIT),
        isBrowserOnly: typeof arg.isBrowserOnly === 'boolean' ? arg.isBrowserOnly : (0, _constants.DEFAULT_RESOURCE_BROWSER_ONLY),
        depends: (_arg$depends = arg.depends) != null ? _arg$depends : null
    };
};

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_to_consumable_array":"1eSZf","@swc/helpers/_/_ts_generator":"78Tqx","../resource-store/constants":"dsFxf","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fE23c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Link", function() {
    return 0, _linkDefault.default;
});
parcelHelpers.export(exports, "RouteComponent", function() {
    return 0, _routeComponent.RouteComponent;
});
var _link = require("./link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _routeComponent = require("./route-component");

},{"./link":"eIoM8","./route-component":"7nAl1","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eIoM8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _history = require("history");
var _react = require("react");
var _utils = require("../../common/utils");
var _routerStore = require("../../controllers/router-store");
var _utils1 = require("./utils");
var PREFETCH_DELAY = 300;
var Link = (0, _react.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref_target = _ref.target, target = _ref_target === void 0 ? '_self' : _ref_target, _ref_replace = _ref.replace, replace = _ref_replace === void 0 ? false : _ref_replace, href = _ref.href, to = _ref.to, onClick = _ref.onClick, onMouseEnter = _ref.onMouseEnter, onMouseLeave = _ref.onMouseLeave, tmp = _ref.type, linkType = tmp === void 0 ? 'a' : tmp, params = _ref.params, query = _ref.query, _ref_prefetch = _ref.prefetch, prefetch = _ref_prefetch === void 0 ? false : _ref_prefetch, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, [
        "children",
        "target",
        "replace",
        "href",
        "to",
        "onClick",
        "onMouseEnter",
        "onMouseLeave",
        "type",
        "params",
        "query",
        "prefetch"
    ]);
    var routerActions = (0, _routerStore.useRouterStoreStatic)()[1];
    var prefetchRef = (0, _react.useRef)();
    var validLinkType = (0, _utils1.getValidLinkType)(linkType);
    var _useState = (0, _slicedToArray._)((0, _react.useState)(function() {
        if (to && typeof to !== 'string') {
            if ('then' in to) to.then(function(r) {
                return setRoute('default' in r ? r.default : r);
            });
            else return to;
        }
    }), 2), route = _useState[0], setRoute = _useState[1];
    var routeAttributes = {
        params: params,
        query: query,
        basePath: routerActions.getBasePath()
    };
    var linkDestination = href != null ? href : typeof to !== 'string' ? route && (0, _history.createPath)((0, _utils.generateLocationFromPath)(route.path, routeAttributes)) || '' : to;
    var triggerPrefetch = (0, _react.useCallback)(function() {
        prefetchRef.current = undefined; // ignore if async route not ready yet
        if (typeof to !== 'string' && !route) return;
        var context = typeof to !== 'string' && route ? (0, _utils.createRouterContext)(route, {
            params: params,
            query: query
        }) : null;
        routerActions.prefetchNextRouteResources(linkDestination, context); // omit params & query as already in linkDestination
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        route,
        linkDestination,
        routerActions
    ]);
    (0, _react.useEffect)(function() {
        var timeout;
        if (prefetch === 'mount') timeout = setTimeout(triggerPrefetch, PREFETCH_DELAY);
        return function() {
            return clearTimeout(timeout);
        };
    }, [
        prefetch,
        triggerPrefetch
    ]);
    var handleLinkPress = function(e) {
        return (0, _utils1.handleNavigation)(e, {
            onClick: onClick,
            target: target,
            replace: replace,
            routerActions: routerActions,
            href: linkDestination,
            to: route && [
                route,
                {
                    params: params,
                    query: query
                }
            ]
        });
    };
    var handleMouseEnter = function(e) {
        if (prefetch === 'hover') prefetchRef.current = setTimeout(triggerPrefetch, PREFETCH_DELAY);
        onMouseEnter && onMouseEnter(e);
    };
    var handleMouseLeave = function(e) {
        if (prefetch === 'hover' && prefetchRef.current) {
            clearTimeout(prefetchRef.current);
            prefetchRef.current = undefined;
        }
        onMouseLeave && onMouseLeave(e);
    };
    return (0, _react.createElement)(validLinkType, (0, _extendsDefault.default)((0, _extendsDefault.default)({}, rest), {}, {
        href: linkDestination,
        target: target,
        onClick: handleLinkPress,
        onKeyDown: handleLinkPress,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        ref: ref
    }), children);
});
Link.displayName = 'Link';
exports.default = Link;

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","@babel/runtime/helpers/extends":"3LZYG","@babel/runtime/helpers/objectWithoutPropertiesLoose":"5JG3D","history":"de6OM","react":"ltHCL","../../common/utils":"cxuex","../../controllers/router-store":"hf6U0","./utils":"8MFDQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8MFDQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getValidLinkType", function() {
    return 0, _getValidLinkType.getValidLinkType;
});
parcelHelpers.export(exports, "handleNavigation", function() {
    return 0, _handleNavigation.handleNavigation;
});
var _getValidLinkType = require("./get-valid-link-type");
var _handleNavigation = require("./handle-navigation");

},{"./get-valid-link-type":"4N9Rb","./handle-navigation":"2tL4M","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4N9Rb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getValidLinkType", function() {
    return getValidLinkType;
});
var VALID_LINK_TYPES = [
    'a',
    'button'
];
var getValidLinkType = function(type) {
    return VALID_LINK_TYPES.includes(type) ? type : 'a';
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2tL4M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "handleNavigation", function() {
    return handleNavigation;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _event = require("../../../common/utils/event");
var handleNavigation = function(event, param) {
    var onClick = param.onClick, target = param.target, replace = param.replace, routerActions = param.routerActions, href = param.href, to = param.to;
    if ((0, _event.isKeyboardEvent)(event) && event.keyCode !== 13) return;
    onClick && onClick(event);
    if (!event.defaultPrevented && ((0, _event.isKeyboardEvent)(event) && event.keyCode === 13 || event.button === 0) && (!target || target === '_self') && // let browser handle "target=_blank" etc.
    !(0, _event.isModifiedEvent)(event) // ignore clicks with modifier keys
    ) {
        event.preventDefault();
        if (to) {
            var method = replace ? routerActions.replaceTo : routerActions.pushTo;
            method.apply(void 0, (0, _toConsumableArray._)(to));
        } else {
            var method1 = replace ? routerActions.replace : routerActions.push;
            method1(href);
        }
    }
};

},{"@swc/helpers/_/_to_consumable_array":"1eSZf","../../../common/utils/event":"9T9C9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9T9C9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isModifiedEvent", function() {
    return isModifiedEvent;
});
parcelHelpers.export(exports, "isKeyboardEvent", function() {
    return isKeyboardEvent;
});
var isModifiedEvent = function(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};
var isKeyboardEvent = function(event) {
    return [
        'keypress',
        'keydown',
        'keyup'
    ].includes(event.type);
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7nAl1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RouteComponent", function() {
    return RouteComponent;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _controllers = require("../../controllers");
var RouteComponent = function() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _controllers.RouterSubscriber), null, function(param) {
        var route = param.route, location = param.location, query = param.query, match = param.match, action = param.action;
        return !route ? null : /*#__PURE__*/ (0, _reactDefault.default).createElement(route.component, {
            route: route,
            location: location,
            query: query,
            match: match,
            action: action
        });
    });
};

},{"react":"ltHCL","../../controllers":"lGPAy","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cnK0e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return 0, _appProviderDefault.default;
});
// Theme provider
parcelHelpers.export(exports, "UNSAFE_useColorModeForMigration", function() {
    return 0, _useColorModeForMigration.UNSAFE_useColorModeForMigration;
});
parcelHelpers.export(exports, "useColorMode", function() {
    return 0, _useColorMode.useColorMode;
});
parcelHelpers.export(exports, "useSetColorMode", function() {
    return 0, _useSetColorMode.useSetColorMode;
});
parcelHelpers.export(exports, "useSetTheme", function() {
    return 0, _useSetTheme.useSetTheme;
});
parcelHelpers.export(exports, "useTheme", function() {
    return 0, _useTheme.useTheme;
});
parcelHelpers.export(exports, "ThemeProvider", function() {
    return 0, _themeProviderDefault.default;
});
parcelHelpers.export(exports, "useRouterLink", function() {
    return 0, _useRouterLinkDefault.default;
});
var _appProvider = require("./app-provider");
var _appProviderDefault = parcelHelpers.interopDefault(_appProvider);
var _useColorModeForMigration = require("./theme-provider/hooks/use-color-mode-for-migration");
var _useColorMode = require("./theme-provider/hooks/use-color-mode");
var _useSetColorMode = require("./theme-provider/hooks/use-set-color-mode");
var _useSetTheme = require("./theme-provider/hooks/use-set-theme");
var _useTheme = require("./theme-provider/hooks/use-theme");
var _themeProvider = require("./theme-provider");
var _themeProviderDefault = parcelHelpers.interopDefault(_themeProvider);
var _useRouterLink = require("./router-link-provider/hooks/use-router-link");
var _useRouterLinkDefault = parcelHelpers.interopDefault(_useRouterLink);

},{"./app-provider":"fU6rf","./theme-provider/hooks/use-color-mode-for-migration":false,"./theme-provider/hooks/use-color-mode":"ctpOo","./theme-provider/hooks/use-set-color-mode":false,"./theme-provider/hooks/use-set-theme":false,"./theme-provider/hooks/use-theme":false,"./theme-provider":"jBPJE","./router-link-provider/hooks/use-router-link":"bhsWh","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fU6rf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _appProviderThemingEnabledContext = require("./app-provider-theming-enabled-context");
var _context = require("./context");
var _insideAppProviderContext = require("./inside-app-provider-context");
var _routerLinkProvider = require("./router-link-provider");
var _routerLinkProviderDefault = parcelHelpers.interopDefault(_routerLinkProvider);
var _themeProvider = require("./theme-provider");
var _themeProviderDefault = parcelHelpers.interopDefault(_themeProvider);
/**
 * __App provider__
 *
 * An app provider provides app level configuration such as global theming.
 *
 * Place it at the root of your application.
 */ function AppProvider(param) {
    var children = param.children, _param_defaultColorMode = param.defaultColorMode, defaultColorMode = _param_defaultColorMode === void 0 ? 'light' : _param_defaultColorMode, defaultTheme = param.defaultTheme, routerLinkComponent = param.routerLinkComponent, UNSAFE_isThemingDisabled = param.UNSAFE_isThemingDisabled;
    var isInsideAppProvider = (0, _context.useIsInsideAppProvider)();
    if (isInsideAppProvider) throw new Error('App provider should not be nested within another app provider.');
    var routerLinkProvider = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _routerLinkProviderDefault.default), {
        routerLinkComponent: routerLinkComponent,
        children: children
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _insideAppProviderContext.InsideAppProviderContext).Provider, {
        value: true,
        children: UNSAFE_isThemingDisabled ? routerLinkProvider : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appProviderThemingEnabledContext.AppProviderThemingEnabledContext).Provider, {
            value: true,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _themeProviderDefault.default), {
                defaultColorMode: defaultColorMode,
                defaultTheme: defaultTheme,
                children: routerLinkProvider
            })
        })
    });
}
exports.default = AppProvider;

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","./app-provider-theming-enabled-context":"2bANZ","./context":"2TxFh","./inside-app-provider-context":"a04GB","./router-link-provider":"9P2Wk","./theme-provider":"jBPJE","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2bANZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AppProviderThemingEnabledContext", function() {
    return AppProviderThemingEnabledContext;
});
var _react = require("react");
var AppProviderThemingEnabledContext = /*#__PURE__*/ (0, _react.createContext)(false);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2TxFh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIsInsideAppProvider", function() {
    return useIsInsideAppProvider;
});
parcelHelpers.export(exports, "useIsAppProviderThemingEnabled", function() {
    return useIsAppProviderThemingEnabled;
});
var _react = require("react");
var _appProviderThemingEnabledContext = require("./app-provider-theming-enabled-context");
var _insideAppProviderContext = require("./inside-app-provider-context");
var useIsInsideAppProvider = function() {
    return (0, _react.useContext)((0, _insideAppProviderContext.InsideAppProviderContext));
};
var useIsAppProviderThemingEnabled = function() {
    return (0, _react.useContext)((0, _appProviderThemingEnabledContext.AppProviderThemingEnabledContext));
};

},{"react":"ltHCL","./app-provider-theming-enabled-context":"2bANZ","./inside-app-provider-context":"a04GB","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"a04GB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InsideAppProviderContext", function() {
    return InsideAppProviderContext;
});
var _react = require("react");
var InsideAppProviderContext = /*#__PURE__*/ (0, _react.createContext)(false);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9P2Wk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RouterLinkProviderContext", function() {
    return RouterLinkProviderContext;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var RouterLinkProviderContext = /*#__PURE__*/ (0, _react.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ var RouterLinkProvider = function(param) {
    var routerLinkComponent = param.routerLinkComponent, children = param.children;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(RouterLinkProviderContext.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
exports.default = RouterLinkProvider;

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jBPJE":[function(require,module,exports,__globalThis) {
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _jsxRuntime = require("react/jsx-runtime");
var _runtime = require("@compiled/react/runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _bindEventListener = require("bind-event-listener");
var _tokens = require("@atlaskit/tokens");
var _context = require("../context");
var _colorMode = require("./context/color-mode");
var _insideThemeProvider = require("./context/inside-theme-provider");
var _setColorModeContext = require("./context/set-color-mode-context");
var _theme = require("./context/theme");
var _useIsInsideThemeProvider = require("./hooks/use-is-inside-theme-provider");
var _loadAndMountThemes = require("./utils/load-and-mount-themes");
var defaultThemeSettings = {
    dark: 'dark',
    light: 'light',
    spacing: 'spacing',
    typography: 'typography'
};
var isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
var prefersDarkModeMql = isMatchMediaAvailable ? window.matchMedia('(prefers-color-scheme: dark)') : undefined; // TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function getReconciledColorMode(colorMode) {
    if (colorMode === 'auto') return (prefersDarkModeMql === null || prefersDarkModeMql === void 0 ? void 0 : prefersDarkModeMql.matches) ? 'dark' : 'light';
    return colorMode;
}
var contentStyles = {
    body: "_1e0c1bgi"
};
function ThemeProvider(param) {
    var children = param.children, _param_defaultColorMode = param.defaultColorMode, defaultColorMode = _param_defaultColorMode === void 0 ? 'auto' : _param_defaultColorMode, defaultTheme = param.defaultTheme;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(defaultColorMode), 2), chosenColorMode = _useState[0], setChosenColorMode = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(getReconciledColorMode(defaultColorMode)), 2), reconciledColorMode = _useState1[0], setReconciledColorMode = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(function() {
        return (0, _objectSpread._)({}, defaultThemeSettings, defaultTheme);
    }), 2), theme = _useState2[0], setTheme = _useState2[1];
    var setColorMode = (0, _react.useCallback)(function(colorMode) {
        setChosenColorMode(colorMode);
        setReconciledColorMode(getReconciledColorMode(colorMode));
    }, []);
    var setPartialTheme = (0, _react.useCallback)(function(nextTheme) {
        setTheme(function(theme) {
            return (0, _objectSpread._)({}, theme, nextTheme);
        });
    }, []);
    var lastSetGlobalThemePromiseRef = (0, _react.useRef)(null);
    var isInsideAppProvider = (0, _context.useIsInsideAppProvider)();
    var isAppProviderThemingEnabled = (0, _context.useIsAppProviderThemingEnabled)();
    var isInsideThemeProvider = (0, _useIsInsideThemeProvider.useIsInsideThemeProvider)(); /**
                                                             * A top-level ThemeProvider is detected by being the first ThemeProvider inside an AppProvider.
                                                             *
                                                             * This will not use sub-tree theming but instead set the global theme state using the
                                                             * `@atlaskit/tokens` APIs, as it's required for styling root `html` and `body` elements
                                                             * for compatibility with `@atlaskit/css-reset`.
                                                             *
                                                             * In the future we could consider moving away from DOM mutations and require AppProvider to wrap
                                                             * `html` in order to apply global theme state, which would allow a more consistent approach to
                                                             * theme loading.
                                                             */ 
    var isRootThemeProvider = isInsideAppProvider && !isInsideThemeProvider && isAppProviderThemingEnabled;
    (0, _react.useEffect)(function() {
        if (isRootThemeProvider) {
            /**
       * We need to wait for any previous `setGlobalTheme` calls to finish before calling it again.
       * This is to prevent race conditions as `setGlobalTheme` is async and mutates the DOM (e.g. sets the
       * `data-color-mode` attribute on the root element).
       *
       * Since we can't safely abort the `setGlobalTheme` execution, we need to wait for it to properly finish before
       * applying the new theme.
       *
       * Without this, we can end up in the following scenario:
       * 1. app loads with the default 'light' theme, kicking off `setGlobalTheme`
       * 2. app switches to 'dark' theme after retrieving value persisted in local storage, calling `setGlobalTheme` again
       * 3. `setGlobalTheme` function execution for `dark` finishes before the initial `light` execution
       * 4. `setGlobalTheme` function execution for `light` then finishes, resulting in the 'light' theme being applied.
       */ var cleanupLastFnCall = function() {
                return (0, _asyncToGenerator._)(function() {
                    var unbindFn;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!lastSetGlobalThemePromiseRef.current) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    lastSetGlobalThemePromiseRef.current
                                ];
                            case 1:
                                unbindFn = _state.sent();
                                unbindFn();
                                lastSetGlobalThemePromiseRef.current = null;
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
            var safelySetGlobalTheme = function() {
                return (0, _asyncToGenerator._)(function() {
                    var promise;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    cleanupLastFnCall()
                                ];
                            case 1:
                                _state.sent();
                                promise = (0, _tokens.setGlobalTheme)((0, _objectSpreadProps._)((0, _objectSpread._)({}, theme), {
                                    colorMode: reconciledColorMode
                                }));
                                lastSetGlobalThemePromiseRef.current = promise;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
            safelySetGlobalTheme();
            return function cleanup() {
                cleanupLastFnCall();
            };
        } else // For other theme providers (whether outside AppProvider or nested inside a ThemeProvider),
        // we treat them as sub-tree themes that do not load global theme state.
        (0, _loadAndMountThemes.loadAndMountThemes)(theme);
    }, [
        isInsideAppProvider,
        isInsideThemeProvider,
        isRootThemeProvider,
        reconciledColorMode,
        theme
    ]);
    (0, _react.useEffect)(function() {
        if (!prefersDarkModeMql) return;
        var unbindListener = (0, _bindEventListener.bind)(prefersDarkModeMql, {
            type: 'change',
            listener: function(event) {
                if (chosenColorMode === 'auto') setReconciledColorMode(event.matches ? 'dark' : 'light');
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    var attrs = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _tokens.getThemeHtmlAttrs)((0, _objectSpreadProps._)((0, _objectSpread._)({}, theme), {
        colorMode: reconciledColorMode
    }))), (0, _defineProperty._)({}, (0, _tokens.SUBTREE_THEME_ATTRIBUTE), true));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _insideThemeProvider.InsideThemeProviderContext).Provider, {
        value: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _colorMode.ColorModeContext).Provider, {
            value: reconciledColorMode,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _setColorModeContext.SetColorModeContext).Provider, {
                value: setColorMode,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _theme.ThemeContext).Provider, {
                    value: theme,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _theme.SetThemeContext).Provider, {
                        value: setPartialTheme,
                        children: !isRootThemeProvider ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, attrs), {
                            className: (0, _runtime.ax)([
                                contentStyles.body
                            ]),
                            children: children
                        })) : children
                    })
                })
            })
        })
    });
}
exports.default = ThemeProvider;

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_ts_generator":"78Tqx","react/jsx-runtime":"bGvcw","@compiled/react/runtime":"d27Vo","react":"ltHCL","bind-event-listener":"bjeUU","@atlaskit/tokens":"8YPAP","../context":"2TxFh","./context/color-mode":"4wnOE","./context/inside-theme-provider":"bNVV3","./context/set-color-mode-context":"fQzEU","./context/theme":"19H7Y","./hooks/use-is-inside-theme-provider":"i9QZX","./utils/load-and-mount-themes":"6tBml","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"d27Vo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CC", function() {
    return 0, _indexJs.CC;
});
parcelHelpers.export(exports, "CS", function() {
    return 0, _indexJs.CS;
});
parcelHelpers.export(exports, "ax", function() {
    return 0, _indexJs.ax;
});
parcelHelpers.export(exports, "ac", function() {
    return 0, _indexJs.ac;
});
parcelHelpers.export(exports, "clearAcCache", function() {
    return 0, _indexJs.clearAcCache;
});
parcelHelpers.export(exports, "ix", function() {
    return 0, _indexJs.ix;
});
var _indexJs = require("./runtime/index.js");

},{"./runtime/index.js":"joOrm","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"joOrm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CS", function() {
    return 0, _styleJsDefault.default;
});
parcelHelpers.export(exports, "CC", function() {
    return 0, _styleCacheJsDefault.default;
});
parcelHelpers.export(exports, "ax", function() {
    return 0, _axJsDefault.default;
});
parcelHelpers.export(exports, "ac", function() {
    return 0, _acJsDefault.default;
});
parcelHelpers.export(exports, "clearAcCache", function() {
    return 0, _acJs.clearCache;
});
parcelHelpers.export(exports, "ix", function() {
    return 0, _cssCustomPropertyJsDefault.default;
});
var _styleJs = require("./style.js");
var _styleJsDefault = parcelHelpers.interopDefault(_styleJs);
var _styleCacheJs = require("./style-cache.js");
var _styleCacheJsDefault = parcelHelpers.interopDefault(_styleCacheJs);
var _axJs = require("./ax.js");
var _axJsDefault = parcelHelpers.interopDefault(_axJs);
var _acJs = require("./ac.js");
var _acJsDefault = parcelHelpers.interopDefault(_acJs);
var _cssCustomPropertyJs = require("./css-custom-property.js");
var _cssCustomPropertyJsDefault = parcelHelpers.interopDefault(_cssCustomPropertyJs);

},{"./style.js":false,"./style-cache.js":false,"./ax.js":"2JZ8z","./ac.js":false,"./css-custom-property.js":"f8xiQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2JZ8z":[function(require,module,exports,__globalThis) {
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return ax;
});
var ATOMIC_GROUP_LENGTH = 5;
function ax(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    var map = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // Note: using loops to minimize iterations over the collection
        for(var _iterator = classNames[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            // Exclude all falsy values, which leaves us with populated strings
            if (!value) continue;
            // a `value` can contain multiple classnames
            var list = value.split(' ');
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = list[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var className = _step1.value;
                    /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ var key = className.startsWith('_') ? className.slice(0, ATOMIC_GROUP_LENGTH) : className;
                    map[key] = className;
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ var result = '';
    for(var key1 in map)result += map[key1] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"f8xiQ":[function(require,module,exports,__globalThis) {
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return cssCustomPropertyValue;
});
function cssCustomPropertyValue(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bjeUU":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.bindAll = exports.bind = void 0;
var bind_1 = require("1d96ed48d120f8c4");
Object.defineProperty(exports, "bind", {
    enumerable: true,
    get: function get() {
        return bind_1.bind;
    }
});
var bind_all_1 = require("2ee15f5ec1b84604");
Object.defineProperty(exports, "bindAll", {
    enumerable: true,
    get: function get() {
        return bind_all_1.bindAll;
    }
});

},{"1d96ed48d120f8c4":"lR6mT","2ee15f5ec1b84604":"4qXMW"}],"lR6mT":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.bind = void 0;
function bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
exports.bind = bind;

},{}],"4qXMW":[function(require,module,exports,__globalThis) {
"use strict";
var __assign = this && this.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.bindAll = void 0;
var bind_1 = require("82e7134afc84a5c5");
function toOptions(value) {
    if (typeof value === 'undefined') return undefined;
    if (typeof value === 'boolean') return {
        capture: value
    };
    return value;
}
function getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = __assign(__assign({}, original), {
        options: __assign(__assign({}, toOptions(sharedOptions)), toOptions(original.options))
    });
    return binding;
}
function bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = getBinding(original, sharedOptions);
        return (0, bind_1.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
exports.bindAll = bindAll;

},{"82e7134afc84a5c5":"lR6mT"}],"8YPAP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "themeConfig", function() {
    return 0, _themeConfigDefault.default;
});
parcelHelpers.export(exports, "token", function() {
    return 0, _getTokenDefault.default;
});
parcelHelpers.export(exports, "getTokenValue", function() {
    return 0, _getTokenValueDefault.default;
});
parcelHelpers.export(exports, "setGlobalTheme", function() {
    return 0, _setGlobalThemeDefault.default;
});
parcelHelpers.export(exports, "enableGlobalTheme", function() {
    return 0, _enableGlobalThemeDefault.default;
});
parcelHelpers.export(exports, "getThemeStyles", function() {
    return 0, _getThemeStylesDefault.default;
});
parcelHelpers.export(exports, "getThemeHtmlAttrs", function() {
    return 0, _getThemeHtmlAttrsDefault.default;
});
parcelHelpers.export(exports, "getSSRAutoScript", function() {
    return 0, _getSsrAutoScriptDefault.default;
});
parcelHelpers.export(exports, "useThemeObserver", function() {
    return 0, _useThemeObserverDefault.default;
});
parcelHelpers.export(exports, "ThemeMutationObserver", function() {
    return 0, _themeMutationObserverDefault.default;
});
parcelHelpers.export(exports, "getGlobalTheme", function() {
    return 0, _getGlobalThemeDefault.default;
});
parcelHelpers.export(exports, "themeStringToObject", function() {
    return 0, _themeStateTransformer.themeStringToObject;
});
parcelHelpers.export(exports, "themeObjectToString", function() {
    return 0, _themeStateTransformer.themeObjectToString;
});
parcelHelpers.export(exports, "themeImportMap", function() {
    return 0, _themeImportMapDefault.default;
});
parcelHelpers.export(exports, "COLOR_MODE_ATTRIBUTE", function() {
    return 0, _constants.COLOR_MODE_ATTRIBUTE;
});
parcelHelpers.export(exports, "CURRENT_SURFACE_CSS_VAR", function() {
    return 0, _constants.CURRENT_SURFACE_CSS_VAR;
});
parcelHelpers.export(exports, "SUBTREE_THEME_ATTRIBUTE", function() {
    return 0, _constants.SUBTREE_THEME_ATTRIBUTE;
});
parcelHelpers.export(exports, "THEME_DATA_ATTRIBUTE", function() {
    return 0, _constants.THEME_DATA_ATTRIBUTE;
});
var _themeConfig = require("./theme-config");
var _themeConfigDefault = parcelHelpers.interopDefault(_themeConfig);
var _getToken = require("./get-token");
var _getTokenDefault = parcelHelpers.interopDefault(_getToken);
var _getTokenValue = require("./get-token-value");
var _getTokenValueDefault = parcelHelpers.interopDefault(_getTokenValue);
var _setGlobalTheme = require("./set-global-theme");
var _setGlobalThemeDefault = parcelHelpers.interopDefault(_setGlobalTheme);
var _enableGlobalTheme = require("./enable-global-theme");
var _enableGlobalThemeDefault = parcelHelpers.interopDefault(_enableGlobalTheme);
var _getThemeStyles = require("./get-theme-styles");
var _getThemeStylesDefault = parcelHelpers.interopDefault(_getThemeStyles);
var _getThemeHtmlAttrs = require("./get-theme-html-attrs");
var _getThemeHtmlAttrsDefault = parcelHelpers.interopDefault(_getThemeHtmlAttrs);
var _getSsrAutoScript = require("./get-ssr-auto-script");
var _getSsrAutoScriptDefault = parcelHelpers.interopDefault(_getSsrAutoScript);
var _useThemeObserver = require("./use-theme-observer");
var _useThemeObserverDefault = parcelHelpers.interopDefault(_useThemeObserver);
var _themeMutationObserver = require("./theme-mutation-observer");
var _themeMutationObserverDefault = parcelHelpers.interopDefault(_themeMutationObserver);
var _getGlobalTheme = require("./get-global-theme");
var _getGlobalThemeDefault = parcelHelpers.interopDefault(_getGlobalTheme);
var _themeStateTransformer = require("./theme-state-transformer");
var _themeImportMap = require("./artifacts/theme-import-map");
var _themeImportMapDefault = parcelHelpers.interopDefault(_themeImportMap);
var _constants = require("./constants");

},{"./theme-config":false,"./get-token":false,"./get-token-value":false,"./set-global-theme":"X8iEB","./enable-global-theme":false,"./get-theme-styles":false,"./get-theme-html-attrs":"dA7lE","./get-ssr-auto-script":false,"./use-theme-observer":"1cZ4g","./theme-mutation-observer":"foJ0S","./get-global-theme":"hujfP","./theme-state-transformer":false,"./artifacts/theme-import-map":"euHQE","./constants":"lKLNp","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"b5LJ7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "themeColorModes", function() {
    return 0, _themeColorModes.themeColorModes;
});
parcelHelpers.export(exports, "themeIds", function() {
    return 0, _themeIds.themeIds;
});
parcelHelpers.export(exports, "themeIdsWithOverrides", function() {
    return themeIdsWithOverrides;
});
parcelHelpers.export(exports, "themeStateDefaults", function() {
    return themeStateDefaults;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _themeIds = require("./theme-ids");
var _themeColorModes = require("./theme-color-modes");
/**
 * Contrast preferences: The system contrast preference
 */ var themeContrastModes = [
    'more',
    'no-preference',
    'auto'
];
/**
 * Theme override ids: the equivalent of themeIds for theme overrides.
 * Theme overrides are temporary and there may not be any defined at times.
 */ var themeOverrideIds = [];
var themeIdsWithOverrides = (0, _toConsumableArray._)((0, _themeIds.themeIds)).concat((0, _toConsumableArray._)(themeOverrideIds));
var themeConfig = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography': {
        id: 'typography',
        displayName: 'Atlassian Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-motion': {
        id: 'motion',
        displayName: 'Motion',
        palette: 'motionPalette',
        attributes: {
            type: 'motion'
        }
    }
};
function getShapeDefault() {
    if ((0, _platformFeatureFlags.fg)('platform-dst-shape-theme-default')) return 'shape';
    return undefined;
}
function getMotionDefault() {
    if ((0, _platformFeatureFlags.fg)('platform-dst-motion-theme-default')) return 'motion';
    return undefined;
}
var themeStateDefaults = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: getShapeDefault,
    spacing: 'spacing',
    typography: 'typography',
    motion: getMotionDefault,
    UNSAFE_themeOptions: undefined
};
exports.default = themeConfig;

},{"@swc/helpers/_/_to_consumable_array":"1eSZf","@atlaskit/platform-feature-flags":"kO5t9","./theme-ids":"440PH","./theme-color-modes":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"440PH":[function(require,module,exports,__globalThis) {
/**
 * Theme ids: The value that will be mounted to the DOM as a data attr
 * For example: `data-theme="light:light dark:dark spacing:spacing"
 *
 * These ids must be kebab case
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "themeIds", function() {
    return themeIds;
});
var themeIds = [
    'light-increased-contrast',
    'light',
    'light-future',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'spacing',
    'shape',
    'typography',
    'motion'
];

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"h3YW7":[function(require,module,exports,__globalThis) {
/**
 * Theme modes: The general purpose of a theme.
 * This attr is used to apply the appropriate system-preference option
 * It may also be used as a selector for mode-specific overrides such as light/dark images.
 * The idea is there may exist many color themes, but every theme must either fit into light or dark.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "themeColorModes", function() {
    return themeColorModes;
});
var themeColorModes = [
    'light',
    'dark',
    'auto'
];

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"X8iEB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _getGlobalTheme = require("./get-global-theme");
var _getGlobalThemeDefault = parcelHelpers.interopDefault(_getGlobalTheme);
var _themeConfig = require("./theme-config");
var _configurePage = require("./utils/configure-page");
var _configurePageDefault = parcelHelpers.interopDefault(_configurePage);
var _customThemeLoadingUtils = require("./utils/custom-theme-loading-utils");
var _getThemeOverridePreferences = require("./utils/get-theme-override-preferences");
var _getThemePreferences = require("./utils/get-theme-preferences");
var _isValidBrandHex = require("./utils/is-valid-brand-hex");
var _themeLoading = require("./utils/theme-loading");
/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.motion The motion theme to be applied.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ var setGlobalTheme = function() {
    var nextThemeState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, themeLoader = arguments.length > 1 ? arguments[1] : void 0;
    return (0, _asyncToGenerator._)(function() {
        var _ref, _ref_colorMode, colorMode, _ref_contrastMode, contrastMode, _ref_dark, dark, _ref_light, light, _ref_shape, shape, _ref_spacing, spacing, _ref_typography, typography, _ref_motion, motion, _ref_UNSAFE_themeOptions, UNSAFE_themeOptions, themeState, themePreferences, loadingStrategy, loadingTasks, mode, attrOfMissingCustomStyles, themeOverridePreferences, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, themeId, err, autoUnbind;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _ref = typeof nextThemeState === 'function' ? nextThemeState((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _themeConfig.themeStateDefaults)), {
                        typography: (0, _themeConfig.themeStateDefaults)['typography'],
                        shape: (0, _themeConfig.themeStateDefaults)['shape'](),
                        motion: (0, _themeConfig.themeStateDefaults)['motion']()
                    }), (0, _getGlobalThemeDefault.default)())) : nextThemeState, _ref_colorMode = _ref.colorMode, colorMode = _ref_colorMode === void 0 ? (0, _themeConfig.themeStateDefaults)['colorMode'] : _ref_colorMode, _ref_contrastMode = _ref.contrastMode, contrastMode = _ref_contrastMode === void 0 ? (0, _themeConfig.themeStateDefaults)['contrastMode'] : _ref_contrastMode, _ref_dark = _ref.dark, dark = _ref_dark === void 0 ? (0, _themeConfig.themeStateDefaults)['dark'] : _ref_dark, _ref_light = _ref.light, light = _ref_light === void 0 ? (0, _themeConfig.themeStateDefaults)['light'] : _ref_light, _ref_shape = _ref.shape, shape = _ref_shape === void 0 ? (0, _themeConfig.themeStateDefaults)['shape']() : _ref_shape, _ref_spacing = _ref.spacing, spacing = _ref_spacing === void 0 ? (0, _themeConfig.themeStateDefaults)['spacing'] : _ref_spacing, _ref_typography = _ref.typography, typography = _ref_typography === void 0 ? (0, _themeConfig.themeStateDefaults)['typography'] : _ref_typography, _ref_motion = _ref.motion, motion = _ref_motion === void 0 ? (0, _themeConfig.themeStateDefaults)['motion']() : _ref_motion, _ref_UNSAFE_themeOptions = _ref.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref_UNSAFE_themeOptions === void 0 ? (0, _themeConfig.themeStateDefaults)['UNSAFE_themeOptions'] : _ref_UNSAFE_themeOptions;
                    // CLEANUP: Remove. This blocks application of increased contrast themes
                    // without the feature flag enabled.
                    if (!(0, _platformFeatureFlags.fg)('platform_increased-contrast-themes')) {
                        if (light === 'light-increased-contrast') light = 'light';
                        if (dark === 'dark-increased-contrast') dark = 'dark';
                    }
                    themeState = {
                        colorMode: colorMode,
                        contrastMode: contrastMode,
                        dark: dark,
                        light: light,
                        shape: shape,
                        spacing: spacing,
                        typography: typography,
                        motion: motion,
                        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
                    };
                    // Determine what to load and loading strategy
                    themePreferences = (0, _getThemePreferences.getThemePreferences)(themeState);
                    loadingStrategy = themeLoader ? themeLoader : (0, _themeLoading.loadAndAppendThemeCss);
                    // Load standard themes
                    loadingTasks = themePreferences.map(function(themeId) {
                        return (0, _asyncToGenerator._)(function() {
                            return (0, _tsGenerator._)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            loadingStrategy(themeId)
                                        ];
                                    case 1:
                                        return [
                                            2,
                                            _state.sent()
                                        ];
                                }
                            });
                        })();
                    });
                    // Load custom themes if needed
                    if (!themeLoader && UNSAFE_themeOptions && (0, _isValidBrandHex.isValidBrandHex)(UNSAFE_themeOptions === null || UNSAFE_themeOptions === void 0 ? void 0 : UNSAFE_themeOptions.brandColor)) {
                        mode = colorMode || (0, _themeConfig.themeStateDefaults)['colorMode'];
                        attrOfMissingCustomStyles = (0, _customThemeLoadingUtils.findMissingCustomStyleElements)(UNSAFE_themeOptions, mode);
                        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
                        loadingTasks.push(function() {
                            return (0, _asyncToGenerator._)(function() {
                                var loadAndAppendCustomThemeCss;
                                return (0, _tsGenerator._)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                require(/* webpackChunkName: "@atlaskit-internal_atlassian-custom-theme" */ "261b4ec5d9ae8ae9")
                                            ];
                                        case 1:
                                            loadAndAppendCustomThemeCss = _state.sent().loadAndAppendCustomThemeCss;
                                            loadAndAppendCustomThemeCss({
                                                colorMode: attrOfMissingCustomStyles.length === 2 ? 'auto' : attrOfMissingCustomStyles[0],
                                                UNSAFE_themeOptions: UNSAFE_themeOptions
                                            });
                                            return [
                                                2
                                            ];
                                    }
                                });
                            })();
                        }());
                    }
                    return [
                        4,
                        Promise.all(loadingTasks)
                    ];
                case 1:
                    _state.sent();
                    // Load override themes after standard themes
                    themeOverridePreferences = (0, _getThemeOverridePreferences.getThemeOverridePreferences)(themeState);
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        7,
                        8,
                        9
                    ]);
                    _iterator = themeOverridePreferences[Symbol.iterator]();
                    _state.label = 3;
                case 3:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        6
                    ];
                    themeId = _step.value;
                    return [
                        4,
                        loadingStrategy(themeId)
                    ];
                case 4:
                    _state.sent();
                    _state.label = 5;
                case 5:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        3
                    ];
                case 6:
                    return [
                        3,
                        9
                    ];
                case 7:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        9
                    ];
                case 8:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 9:
                    autoUnbind = (0, _configurePageDefault.default)(themeState);
                    return [
                        2,
                        autoUnbind
                    ];
            }
        });
    })();
};
exports.default = setGlobalTheme;

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_ts_generator":"78Tqx","@atlaskit/platform-feature-flags":"kO5t9","./get-global-theme":"hujfP","./theme-config":"b5LJ7","./utils/configure-page":"46Yek","./utils/custom-theme-loading-utils":"efo7d","./utils/get-theme-override-preferences":"hE9r7","./utils/get-theme-preferences":"2ysWl","./utils/is-valid-brand-hex":"64UuD","./utils/theme-loading":"dLOJj","261b4ec5d9ae8ae9":"dui9z","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hujfP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _constants = require("./constants");
var _themeColorModes = require("./theme-color-modes");
var _themeStateTransformer = require("./theme-state-transformer");
var isThemeColorMode = function(colorMode) {
    return (0, _themeColorModes.themeColorModes).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};
var getGlobalTheme = function() {
    if (typeof document === 'undefined') return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, _constants.COLOR_MODE_ATTRIBUTE)) || '';
    var theme = element.getAttribute((0, _constants.THEME_DATA_ATTRIBUTE)) || '';
    return (0, _objectSpread._)({}, (0, _themeStateTransformer.themeStringToObject)(theme), isThemeColorMode(colorMode) && {
        colorMode: colorMode
    });
};
exports.default = getGlobalTheme;

},{"@swc/helpers/_/_object_spread":"9gdrV","./constants":"lKLNp","./theme-color-modes":"h3YW7","./theme-state-transformer":"lPHGT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lKLNp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "THEME_DATA_ATTRIBUTE", function() {
    return THEME_DATA_ATTRIBUTE;
});
parcelHelpers.export(exports, "SUBTREE_THEME_ATTRIBUTE", function() {
    return SUBTREE_THEME_ATTRIBUTE;
});
parcelHelpers.export(exports, "COLOR_MODE_ATTRIBUTE", function() {
    return COLOR_MODE_ATTRIBUTE;
});
parcelHelpers.export(exports, "CONTRAST_MODE_ATTRIBUTE", function() {
    return CONTRAST_MODE_ATTRIBUTE;
});
parcelHelpers.export(exports, "CUSTOM_THEME_ATTRIBUTE", function() {
    return CUSTOM_THEME_ATTRIBUTE;
});
parcelHelpers.export(exports, "CSS_PREFIX", function() {
    return CSS_PREFIX;
});
parcelHelpers.export(exports, "CSS_VAR_FULL", function() {
    return CSS_VAR_FULL;
});
parcelHelpers.export(exports, "TOKEN_NOT_FOUND_CSS_VAR", function() {
    return TOKEN_NOT_FOUND_CSS_VAR;
});
parcelHelpers.export(exports, "CURRENT_SURFACE_CSS_VAR", function() {
    return CURRENT_SURFACE_CSS_VAR;
});
var THEME_DATA_ATTRIBUTE = 'data-theme';
var SUBTREE_THEME_ATTRIBUTE = 'data-subtree-theme';
var COLOR_MODE_ATTRIBUTE = 'data-color-mode';
var CONTRAST_MODE_ATTRIBUTE = 'data-contrast-mode';
var CUSTOM_THEME_ATTRIBUTE = 'data-custom-theme';
var CSS_PREFIX = 'ds';
var CSS_VAR_FULL = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var TOKEN_NOT_FOUND_CSS_VAR = "--".concat(CSS_PREFIX, "-token-not-found");
var CURRENT_SURFACE_CSS_VAR = "--".concat(CSS_PREFIX, "-elevation-surface-current");

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lPHGT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "themeStringToObject", function() {
    return themeStringToObject;
});
parcelHelpers.export(exports, "themeObjectToString", function() {
    return themeObjectToString;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var _themeIds = require("./theme-ids");
var themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape',
    'motion'
];
var customThemeOptions = 'UNSAFE_themeOptions';
var isThemeKind = function(themeKind) {
    return themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};
var isThemeIds = function(themeId) {
    return (0, _themeIds.themeIds).find(function(id) {
        return id === themeId;
    }) !== undefined;
};
var isColorMode = function(modeId) {
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};
var themeStringToObject = function(themeState) {
    return themeState.split(' ')// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .map(function(theme) {
        return theme.split(RegExp(":(.*)", "s"));
    }).reduce(function(themeObject, param) {
        var _param = (0, _slicedToArray._)(param, 2), kind = _param[0], id = _param[1];
        if (kind === 'colorMode' && isColorMode(id)) themeObject[kind] = id;
        if (isThemeKind(kind) && isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === customThemeOptions) try {
            themeObject[customThemeOptions] = JSON.parse(id);
        } catch (e) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};
var themeObjectToString = function(themeState) {
    return Object.entries(themeState).reduce(function(themeString, param) {
        var _param = (0, _slicedToArray._)(param, 2), kind = _param[0], id = _param[1];
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && isColorMode(id) || // custom theme state
        kind === customThemeOptions && (typeof id === "undefined" ? "undefined" : (0, _typeOf._)(id)) === 'object' || // other theme states
        isThemeKind(kind) && typeof id === 'string' && isThemeIds(id)) return themeString + "".concat(themeString ? ' ' : '') + "".concat(kind, ":").concat((typeof id === "undefined" ? "undefined" : (0, _typeOf._)(id)) === 'object' ? JSON.stringify(id) : id);
        return themeString;
    }, '');
};

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_type_of":"iFJdx","./theme-ids":"440PH","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"46Yek":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return configurePage;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _getThemeHtmlAttrs = require("../get-theme-html-attrs");
var _getThemeHtmlAttrsDefault = parcelHelpers.interopDefault(_getThemeHtmlAttrs);
var _colorModeListeners = require("./color-mode-listeners");
var _colorModeListenersDefault = parcelHelpers.interopDefault(_colorModeListeners);
var _contrastModeListeners = require("./contrast-mode-listeners");
var _contrastModeListenersDefault = parcelHelpers.interopDefault(_contrastModeListeners);
function configurePage(themeState) {
    if (themeState.colorMode === 'auto') {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, _colorModeListenersDefault.default).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, _colorModeListenersDefault.default).bind();
    } else (0, _colorModeListenersDefault.default).unbind();
    if ((0, _platformFeatureFlags.fg)('platform_increased-contrast-themes')) {
        if (themeState.contrastMode === 'auto') {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, _contrastModeListenersDefault.default).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, _contrastModeListenersDefault.default).bind();
        } else (0, _contrastModeListenersDefault.default).unbind();
    }
    var themeAttributes = (0, _getThemeHtmlAttrsDefault.default)(themeState);
    Object.entries(themeAttributes).forEach(function(param) {
        var _param = (0, _slicedToArray._)(param, 2), key = _param[0], value = _param[1];
        document.documentElement.setAttribute(key, value);
    });
    return function() {
        (0, _colorModeListenersDefault.default).unbind();
        if ((0, _platformFeatureFlags.fg)('platform_increased-contrast-themes')) (0, _contrastModeListenersDefault.default).unbind();
    };
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","@atlaskit/platform-feature-flags":"kO5t9","../get-theme-html-attrs":"dA7lE","./color-mode-listeners":"8M4Me","./contrast-mode-listeners":"boBuC","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dA7lE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _constants = require("./constants");
var _themeConfig = require("./theme-config");
var _themeStateTransformer = require("./theme-state-transformer");
var _hash = require("./utils/hash");
var _isValidBrandHex = require("./utils/is-valid-brand-hex");
var defaultColorMode = 'light';
var defaultContrastMode = 'no-preference';
/**
 * Server-side rendering utility. Generates the valid HTML attributes for a given theme.
 * Note: this utility does not handle automatic theme switching.
 *
 * @param {Object<string, string>} themeOptions - Theme options object
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.motion The motion theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 *
 * @returns {Object} Object of HTML attributes to be applied to the document root
 */ var getThemeHtmlAttrs = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_colorMode = _ref.colorMode, colorMode = _ref_colorMode === void 0 ? (0, _themeConfig.themeStateDefaults)['colorMode'] : _ref_colorMode, _ref_dark = _ref.dark, dark = _ref_dark === void 0 ? (0, _themeConfig.themeStateDefaults)['dark'] : _ref_dark, _ref_light = _ref.light, light = _ref_light === void 0 ? (0, _themeConfig.themeStateDefaults)['light'] : _ref_light, _ref_contrastMode = _ref.contrastMode, contrastMode = _ref_contrastMode === void 0 ? (0, _themeConfig.themeStateDefaults)['contrastMode'] : _ref_contrastMode, _ref_motion = _ref.motion, motion = _ref_motion === void 0 ? (0, _themeConfig.themeStateDefaults)['motion']() : _ref_motion, _ref_shape = _ref.shape, shape = _ref_shape === void 0 ? (0, _themeConfig.themeStateDefaults)['shape']() : _ref_shape, _ref_spacing = _ref.spacing, spacing = _ref_spacing === void 0 ? (0, _themeConfig.themeStateDefaults)['spacing'] : _ref_spacing, _ref_typography = _ref.typography, typography = _ref_typography === void 0 ? (0, _themeConfig.themeStateDefaults)['typography'] : _ref_typography, _ref_UNSAFE_themeOptions = _ref.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref_UNSAFE_themeOptions === void 0 ? (0, _themeConfig.themeStateDefaults)['UNSAFE_themeOptions'] : _ref_UNSAFE_themeOptions;
    var themeAttribute = (0, _themeStateTransformer.themeObjectToString)({
        dark: dark,
        light: light,
        motion: motion,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    var _obj;
    var result = (_obj = {}, (0, _defineProperty._)(_obj, (0, _constants.THEME_DATA_ATTRIBUTE), themeAttribute), (0, _defineProperty._)(_obj, (0, _constants.COLOR_MODE_ATTRIBUTE), colorMode === 'auto' ? defaultColorMode : colorMode), _obj);
    if ((0, _platformFeatureFlags.fg)('platform_increased-contrast-themes')) result = (0, _objectSpreadProps._)((0, _objectSpread._)({}, result), // CLEANUP: Move this to the initial `result` assignment above
    (0, _defineProperty._)({}, (0, _constants.CONTRAST_MODE_ATTRIBUTE), contrastMode === 'auto' ? defaultContrastMode : contrastMode));
    if (UNSAFE_themeOptions && (0, _isValidBrandHex.isValidBrandHex)(UNSAFE_themeOptions.brandColor)) {
        var optionString = JSON.stringify(UNSAFE_themeOptions);
        var uniqueId = (0, _hash.hash)(optionString);
        result[0, _constants.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
exports.default = getThemeHtmlAttrs;

},{"@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@atlaskit/platform-feature-flags":"kO5t9","./constants":"lKLNp","./theme-config":"b5LJ7","./theme-state-transformer":"lPHGT","./utils/hash":"eye4L","./utils/is-valid-brand-hex":"64UuD","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eye4L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hash", function() {
    return hash;
});
var hash = function(str) {
    var hash = 0;
    for(var i = 0; i < str.length; i++){
        var char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"64UuD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isValidBrandHex", function() {
    return isValidBrandHex;
});
var isValidBrandHex = function(hex) {
    return /^#[0-9A-F]{6}$/i.test(hex);
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8M4Me":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _bindEventListener = require("bind-event-listener");
var _constants = require("../constants");
var _themeLoading = require("./theme-loading");
var isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, _constants.COLOR_MODE_ATTRIBUTE), e.matches ? 'dark' : 'light');
}
var darkModeMql = isMatchMediaAvailable && window.matchMedia((0, _themeLoading.darkModeMediaQuery));
var ColorModeObserver = /*#__PURE__*/ function() {
    "use strict";
    function ColorModeObserver() {
        (0, _classCallCheck._)(this, ColorModeObserver);
        this.unbindThemeChangeListener = null;
    }
    (0, _createClass._)(ColorModeObserver, [
        {
            key: "getColorMode",
            value: function getColorMode() {
                if (!darkModeMql) return 'light';
                return (darkModeMql === null || darkModeMql === void 0 ? void 0 : darkModeMql.matches) ? 'dark' : 'light';
            }
        },
        {
            key: "bind",
            value: function bind() {
                if (darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, _bindEventListener.bind)(darkModeMql, {
                    type: 'change',
                    listener: checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindThemeChangeListener) {
                    this.unbindThemeChangeListener();
                    this.unbindThemeChangeListener = null;
                }
            }
        }
    ]);
    return ColorModeObserver;
}();
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var SingletonColorModeObserver = new ColorModeObserver();
exports.default = SingletonColorModeObserver;

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","bind-event-listener":"bjeUU","../constants":"lKLNp","./theme-loading":"dLOJj","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dLOJj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loadThemeCss", function() {
    return 0, _loadThemeCss.loadThemeCss;
});
parcelHelpers.export(exports, "loadAndAppendThemeCss", function() {
    return loadAndAppendThemeCss;
});
parcelHelpers.export(exports, "darkModeMediaQuery", function() {
    return darkModeMediaQuery;
});
parcelHelpers.export(exports, "moreContrastMediaQuery", function() {
    return moreContrastMediaQuery;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _constants = require("../constants");
var _loadThemeCss = require("./load-theme-css");
var loadAndAppendThemeCss = function(themeId) {
    return (0, _asyncToGenerator._)(function() {
        var themeCss, style;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (document.head.querySelector("style[".concat((0, _constants.THEME_DATA_ATTRIBUTE), '="').concat(themeId, '"]:not([').concat((0, _constants.CUSTOM_THEME_ATTRIBUTE), "])"))) return [
                        2
                    ];
                    // Gracefully handles falsy values like `null` and `undefined` when maker ignore TS
                    // to avoid loading default themes.
                    if (!themeId) return [
                        2
                    ];
                    return [
                        4,
                        (0, _loadThemeCss.loadThemeCss)(themeId)
                    ];
                case 1:
                    themeCss = _state.sent();
                    style = document.createElement('style');
                    style.textContent = themeCss;
                    style.dataset.theme = themeId;
                    document.head.appendChild(style);
                    return [
                        2
                    ];
            }
        });
    })();
};
var darkModeMediaQuery = '(prefers-color-scheme: dark)';
var moreContrastMediaQuery = '(prefers-contrast: more)';

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_ts_generator":"78Tqx","../constants":"lKLNp","./load-theme-css":"dbygr","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dbygr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loadThemeCss", function() {
    return loadThemeCss;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _themeImportMap = require("../artifacts/theme-import-map");
var _themeImportMapDefault = parcelHelpers.interopDefault(_themeImportMap);
var loadThemeCss = function(themeId) {
    return (0, _asyncToGenerator._)(function() {
        var _ref, themeCss;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, _themeImportMapDefault.default)[themeId]()
                    ];
                case 1:
                    _ref = _state.sent(), themeCss = _ref.default;
                    return [
                        2,
                        themeCss
                    ];
            }
        });
    })();
};

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_ts_generator":"78Tqx","../artifacts/theme-import-map":"euHQE","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"euHQE":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::a20c72d683b08b594c5be4160eec5f78>>
 * @codegenCommand yarn build tokens
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var themeImportsMap = {
    'light': function() {
        return require(/* webpackChunkName: "@atlaskit-internal_atlassian-light" */ "922f811c1105b180");
    },
    'light-future': function() {
        return require(/* webpackChunkName: "@atlaskit-internal_atlassian-light-future" */ "d4f0cd5b46a6bea5");
    },
    'light-increased-contrast': function() {
        return require(/* webpackChunkName: "@atlaskit-internal_atlassian-light-increased-contrast" */ "2c278e6ea6c32cdb");
    },
    'dark': function() {
        return require(/* webpackChunkName: "@atlaskit-internal_atlassian-dark" */ "dd969cd9d5e89a1");
    },
    'dark-future': function() {
        return require(/* webpackChunkName: "@atlaskit-internal_atlassian-dark-future" */ "37957162addc0847");
    },
    'dark-increased-contrast': function() {
        return require(/* webpackChunkName: "@atlaskit-internal_atlassian-dark-increased-contrast" */ "71d31c5f8cb6c17d");
    },
    'spacing': function() {
        return require(/* webpackChunkName: "@atlaskit-internal_atlassian-spacing" */ "f2bb887a948c23ab");
    },
    'typography': function() {
        return require(/* webpackChunkName: "@atlaskit-internal_atlassian-typography" */ "dc839e62b6b03a7");
    },
    'shape': function() {
        return require(/* webpackChunkName: "@atlaskit-internal_atlassian-shape" */ "ea43d5c9c62a542a");
    },
    'motion': function() {
        return require(/* webpackChunkName: "@atlaskit-internal_atlassian-motion" */ "4b195725764d0e89");
    }
};
exports.default = themeImportsMap;

},{"922f811c1105b180":"3MaPB","d4f0cd5b46a6bea5":"fQqH9","2c278e6ea6c32cdb":"ie09T","dd969cd9d5e89a1":"90jPQ","37957162addc0847":"7vASU","71d31c5f8cb6c17d":"fDoC5","f2bb887a948c23ab":"loNkg","dc839e62b6b03a7":"aiWIi","ea43d5c9c62a542a":"gCmy8","4b195725764d0e89":"aopAj","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3MaPB":[function(require,module,exports,__globalThis) {
module.exports = require("e3899ba2ed0955bf")(require("5e91401933c6bcc7").resolve("9qRmT")).then(function() {
    return module.bundle.root('fPDUp');
});

},{"e3899ba2ed0955bf":"hkfCW","5e91401933c6bcc7":"l4T2r"}],"hkfCW":[function(require,module,exports,__globalThis) {
"use strict";
var cacheLoader = require("e82306cc835a39a8");
module.exports = cacheLoader(function loadJSBundle(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        var isCurrentBundle = function isCurrentBundle(script) {
            return script.src === bundle;
        };
        if ([].concat(existingScripts).some(isCurrentBundle)) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

},{"e82306cc835a39a8":"62BBR"}],"62BBR":[function(require,module,exports,__globalThis) {
"use strict";
var cachedBundles = {};
var cachedPreloads = {};
var cachedPrefetches = {};
function getCache(type) {
    switch(type){
        case 'preload':
            return cachedPreloads;
        case 'prefetch':
            return cachedPrefetches;
        default:
            return cachedBundles;
    }
}
module.exports = function cacheLoader(loader, type) {
    return function(bundle) {
        var cache = getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

},{}],"l4T2r":[function(require,module,exports,__globalThis) {
"use strict";
var mapping = new Map();
function register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function resolve(id) {
    var resolved = mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
module.exports.register = register;
module.exports.resolve = resolve;

},{}],"fQqH9":[function(require,module,exports,__globalThis) {
module.exports = require("830ab3eb2165947d")(require("1333f91c7801822").resolve("eJCKR")).then(function() {
    return module.bundle.root('kEcIr');
});

},{"830ab3eb2165947d":"hkfCW","1333f91c7801822":"l4T2r"}],"ie09T":[function(require,module,exports,__globalThis) {
module.exports = require("54b3392120b6ca18")(require("2a0969dd2ef2ff34").resolve("4Fan8")).then(function() {
    return module.bundle.root('8Lpmj');
});

},{"54b3392120b6ca18":"hkfCW","2a0969dd2ef2ff34":"l4T2r"}],"90jPQ":[function(require,module,exports,__globalThis) {
module.exports = require("10524f0d4c5ca837")(require("5adc863978f32f35").resolve("db2C2")).then(function() {
    return module.bundle.root('kdlqa');
});

},{"10524f0d4c5ca837":"hkfCW","5adc863978f32f35":"l4T2r"}],"7vASU":[function(require,module,exports,__globalThis) {
module.exports = require("11117bbd6c57baed")(require("f3a7d72d35142ac3").resolve("loB5H")).then(function() {
    return module.bundle.root('jYsqz');
});

},{"11117bbd6c57baed":"hkfCW","f3a7d72d35142ac3":"l4T2r"}],"fDoC5":[function(require,module,exports,__globalThis) {
module.exports = require("9d7dc8c4c3379bb4")(require("ff80d5b236f01400").resolve("doByD")).then(function() {
    return module.bundle.root('5aDlu');
});

},{"9d7dc8c4c3379bb4":"hkfCW","ff80d5b236f01400":"l4T2r"}],"loNkg":[function(require,module,exports,__globalThis) {
module.exports = require("139597f420042d0a")(require("2a5c334afd34ceff").resolve("j64Lg")).then(function() {
    return module.bundle.root('bL5hX');
});

},{"139597f420042d0a":"hkfCW","2a5c334afd34ceff":"l4T2r"}],"aiWIi":[function(require,module,exports,__globalThis) {
module.exports = require("cf6599d8b40b49f0")(require("85656ff165d9076d").resolve("5SAEy")).then(function() {
    return module.bundle.root('iW7TC');
});

},{"cf6599d8b40b49f0":"hkfCW","85656ff165d9076d":"l4T2r"}],"gCmy8":[function(require,module,exports,__globalThis) {
module.exports = require("475d7f7c7ed12661")(require("a57dac2b71c01828").resolve("cda3I")).then(function() {
    return module.bundle.root('dPnks');
});

},{"475d7f7c7ed12661":"hkfCW","a57dac2b71c01828":"l4T2r"}],"aopAj":[function(require,module,exports,__globalThis) {
module.exports = require("830ceb1854fc22ed")(require("e91e41bc628d2175").resolve("gpv5l")).then(function() {
    return module.bundle.root('3ZgA3');
});

},{"830ceb1854fc22ed":"hkfCW","e91e41bc628d2175":"l4T2r"}],"boBuC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _bindEventListener = require("bind-event-listener");
var _constants = require("../constants");
var _themeLoading = require("./theme-loading");
var isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, _constants.CONTRAST_MODE_ATTRIBUTE), e.matches ? 'more' : 'no-preference');
}
var contrastModeMql = isMatchMediaAvailable && window.matchMedia((0, _themeLoading.moreContrastMediaQuery));
var ContrastModeObserver = /*#__PURE__*/ function() {
    "use strict";
    function ContrastModeObserver() {
        (0, _classCallCheck._)(this, ContrastModeObserver);
        this.unbindContrastChangeListener = null;
    }
    (0, _createClass._)(ContrastModeObserver, [
        {
            key: "getContrastMode",
            value: function getContrastMode() {
                if (!contrastModeMql) return 'no-preference';
                return (contrastModeMql === null || contrastModeMql === void 0 ? void 0 : contrastModeMql.matches) ? 'more' : 'no-preference';
            }
        },
        {
            key: "bind",
            value: function bind() {
                if (contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, _bindEventListener.bind)(contrastModeMql, {
                    type: 'change',
                    listener: checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindContrastChangeListener) {
                    this.unbindContrastChangeListener();
                    this.unbindContrastChangeListener = null;
                }
            }
        }
    ]);
    return ContrastModeObserver;
}();
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var SingletonContrastModeObserver = new ContrastModeObserver();
exports.default = SingletonContrastModeObserver;

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","bind-event-listener":"bjeUU","../constants":"lKLNp","./theme-loading":"dLOJj","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"efo7d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "limitSizeOfCustomStyleElements", function() {
    return 0, _limitSizeOfCustomStyleElements.limitSizeOfCustomStyleElements;
});
parcelHelpers.export(exports, "findMissingCustomStyleElements", function() {
    return findMissingCustomStyleElements;
});
parcelHelpers.export(exports, "reduceTokenMap", function() {
    return reduceTokenMap;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _tokenNames = require("../artifacts/token-names");
var _tokenNamesDefault = parcelHelpers.interopDefault(_tokenNames);
var _constants = require("../constants");
var _hash = require("./hash");
var _limitSizeOfCustomStyleElements = require("./limit-size-of-custom-style-elements");
function findMissingCustomStyleElements(UNSAFE_themeOptions, mode) {
    var optionString = JSON.stringify(UNSAFE_themeOptions);
    var uniqueId = (0, _hash.hash)(optionString);
    var attrOfMissingCustomStyles = [];
    (mode === 'auto' ? [
        'light',
        'dark'
    ] : [
        mode
    ]).forEach(function(themeId) {
        var element = document.head.querySelector("style[".concat((0, _constants.CUSTOM_THEME_ATTRIBUTE), '="').concat(uniqueId, '"][').concat((0, _constants.THEME_DATA_ATTRIBUTE), '="').concat(themeId, '"]'));
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}
function reduceTokenMap(tokenMap, themeRamp) {
    return Object.entries(tokenMap).reduce(function(acc, param) {
        var _param = (0, _slicedToArray._)(param, 2), key = _param[0], value = _param[1];
        var cssVar = (0, _tokenNamesDefault.default)[key];
        return cssVar ? "".concat(acc, "\n  ").concat(cssVar, ": ").concat(typeof value === 'string' ? value : themeRamp[value], ";") : acc;
    }, '');
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","../artifacts/token-names":"9JQfB","../constants":"lKLNp","./hash":"eye4L","./limit-size-of-custom-style-elements":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9JQfB":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a1de8a9439d40392e3e4945ecf9d9214>>
 * @codegenCommand yarn build tokens
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var tokens = {
    'motion.avatar.enter': '--ds-avatar-enter',
    'motion.avatar.exit': '--ds-avatar-exit',
    'motion.avatar.hovered': '--ds-avatar-hovered',
    'motion.blanket.enter': '--ds-blanket-enter',
    'motion.blanket.exit': '--ds-blanket-exit',
    'motion.duration.instant': '--ds-duration-instant',
    'motion.duration.long': '--ds-duration-long',
    'motion.duration.medium': '--ds-duration-medium',
    'motion.duration.short': '--ds-duration-short',
    'motion.duration.xlong': '--ds-duration-xlong',
    'motion.duration.xshort': '--ds-duration-xshort',
    'motion.duration.xxlong': '--ds-duration-xxlong',
    'motion.duration.xxshort': '--ds-duration-xxshort',
    'motion.easing.in.practical': '--ds-easing-in-practical',
    'motion.easing.inout.bold': '--ds-easing-inout-bold',
    'motion.easing.out.practical': '--ds-easing-out-practical',
    'motion.easing.out.bold': '--ds-easing-out-bold',
    'motion.easing.spring': '--ds-easing-spring',
    'motion.flag.enter': '--ds-flag-enter',
    'motion.flag.exit': '--ds-flag-exit',
    'motion.flag.reposition': '--ds-flag-reposition',
    'motion.keyframe.fade.in': '--ds-keyframe-fade-in',
    'motion.keyframe.fade.out': '--ds-keyframe-fade-out',
    'motion.keyframe.scale.in.medium': '--ds-keyframe-scale-in-medium',
    'motion.keyframe.scale.in.small': '--ds-keyframe-scale-in-small',
    'motion.keyframe.scale.out.medium': '--ds-keyframe-scale-out-medium',
    'motion.keyframe.scale.out.small': '--ds-keyframe-scale-out-small',
    'motion.keyframe.slide.in.bottom.short': '--ds-keyframe-slide-in-bottom-short',
    'motion.keyframe.slide.in.left.half': '--ds-keyframe-slide-in-left-half',
    'motion.keyframe.slide.in.left.short': '--ds-keyframe-slide-in-left-short',
    'motion.keyframe.slide.in.right.short': '--ds-keyframe-slide-in-right-short',
    'motion.keyframe.slide.in.top.short': '--ds-keyframe-slide-in-top-short',
    'motion.keyframe.slide.out.bottom.short': '--ds-keyframe-slide-out-bottom-short',
    'motion.keyframe.slide.out.left.half': '--ds-keyframe-slide-out-left-half',
    'motion.keyframe.slide.out.left.short': '--ds-keyframe-slide-out-left-short',
    'motion.keyframe.slide.out.right.short': '--ds-keyframe-slide-out-right-short',
    'motion.keyframe.slide.out.top.short': '--ds-keyframe-slide-out-top-short',
    'motion.modal.enter': '--ds-modal-enter',
    'motion.modal.exit': '--ds-modal-exit',
    'motion.popup.enter.bottom': '--ds-popup-enter-bottom',
    'motion.popup.enter.left': '--ds-popup-enter-left',
    'motion.popup.enter.right': '--ds-popup-enter-right',
    'motion.popup.enter.top': '--ds-popup-enter-top',
    'motion.popup.exit.bottom': '--ds-popup-exit-bottom',
    'motion.popup.exit.left': '--ds-popup-exit-left',
    'motion.popup.exit.right': '--ds-popup-exit-right',
    'motion.popup.exit.top': '--ds-popup-exit-top',
    'motion.spotlight.enter': '--ds-spotlight-enter',
    'motion.spotlight.exit': '--ds-spotlight-exit',
    'color.text': '--ds-text',
    'color.text.accent.lime': '--ds-text-accent-lime',
    'color.text.accent.lime.bolder': '--ds-text-accent-lime-bolder',
    'color.text.accent.red': '--ds-text-accent-red',
    'color.text.accent.red.bolder': '--ds-text-accent-red-bolder',
    'color.text.accent.orange': '--ds-text-accent-orange',
    'color.text.accent.orange.bolder': '--ds-text-accent-orange-bolder',
    'color.text.accent.yellow': '--ds-text-accent-yellow',
    'color.text.accent.yellow.bolder': '--ds-text-accent-yellow-bolder',
    'color.text.accent.green': '--ds-text-accent-green',
    'color.text.accent.green.bolder': '--ds-text-accent-green-bolder',
    'color.text.accent.teal': '--ds-text-accent-teal',
    'color.text.accent.teal.bolder': '--ds-text-accent-teal-bolder',
    'color.text.accent.blue': '--ds-text-accent-blue',
    'color.text.accent.blue.bolder': '--ds-text-accent-blue-bolder',
    'color.text.accent.purple': '--ds-text-accent-purple',
    'color.text.accent.purple.bolder': '--ds-text-accent-purple-bolder',
    'color.text.accent.magenta': '--ds-text-accent-magenta',
    'color.text.accent.magenta.bolder': '--ds-text-accent-magenta-bolder',
    'color.text.accent.gray': '--ds-text-accent-gray',
    'color.text.accent.gray.bolder': '--ds-text-accent-gray-bolder',
    'color.text.disabled': '--ds-text-disabled',
    'color.text.inverse': '--ds-text-inverse',
    'color.text.selected': '--ds-text-selected',
    'color.text.brand': '--ds-text-brand',
    'color.text.danger': '--ds-text-danger',
    'color.text.danger.bolder': '--ds-text-danger-bolder',
    'color.text.warning': '--ds-text-warning',
    'color.text.warning.inverse': '--ds-text-warning-inverse',
    'color.text.warning.bolder': '--ds-text-warning-bolder',
    'color.text.success': '--ds-text-success',
    'color.text.success.bolder': '--ds-text-success-bolder',
    'color.text.discovery': '--ds-text-discovery',
    'color.text.discovery.bolder': '--ds-text-discovery-bolder',
    'color.text.information': '--ds-text-information',
    'color.text.information.bolder': '--ds-text-information-bolder',
    'color.text.subtlest': '--ds-text-subtlest',
    'color.text.subtle': '--ds-text-subtle',
    'color.link': '--ds-link',
    'color.link.pressed': '--ds-link-pressed',
    'color.link.visited': '--ds-link-visited',
    'color.link.visited.pressed': '--ds-link-visited-pressed',
    'color.icon': '--ds-icon',
    'color.icon.accent.lime': '--ds-icon-accent-lime',
    'color.icon.accent.red': '--ds-icon-accent-red',
    'color.icon.accent.orange': '--ds-icon-accent-orange',
    'color.icon.accent.yellow': '--ds-icon-accent-yellow',
    'color.icon.accent.green': '--ds-icon-accent-green',
    'color.icon.accent.teal': '--ds-icon-accent-teal',
    'color.icon.accent.blue': '--ds-icon-accent-blue',
    'color.icon.accent.purple': '--ds-icon-accent-purple',
    'color.icon.accent.magenta': '--ds-icon-accent-magenta',
    'color.icon.accent.gray': '--ds-icon-accent-gray',
    'color.icon.disabled': '--ds-icon-disabled',
    'color.icon.inverse': '--ds-icon-inverse',
    'color.icon.selected': '--ds-icon-selected',
    'color.icon.brand': '--ds-icon-brand',
    'color.icon.danger': '--ds-icon-danger',
    'color.icon.warning': '--ds-icon-warning',
    'color.icon.warning.inverse': '--ds-icon-warning-inverse',
    'color.icon.success': '--ds-icon-success',
    'color.icon.discovery': '--ds-icon-discovery',
    'color.icon.information': '--ds-icon-information',
    'color.icon.subtlest': '--ds-icon-subtlest',
    'color.icon.subtle': '--ds-icon-subtle',
    'color.border': '--ds-border',
    'color.border.accent.lime': '--ds-border-accent-lime',
    'color.border.accent.red': '--ds-border-accent-red',
    'color.border.accent.orange': '--ds-border-accent-orange',
    'color.border.accent.yellow': '--ds-border-accent-yellow',
    'color.border.accent.green': '--ds-border-accent-green',
    'color.border.accent.teal': '--ds-border-accent-teal',
    'color.border.accent.blue': '--ds-border-accent-blue',
    'color.border.accent.purple': '--ds-border-accent-purple',
    'color.border.accent.magenta': '--ds-border-accent-magenta',
    'color.border.accent.gray': '--ds-border-accent-gray',
    'color.border.disabled': '--ds-border-disabled',
    'color.border.focused': '--ds-border-focused',
    'color.border.input': '--ds-border-input',
    'color.border.inverse': '--ds-border-inverse',
    'color.border.selected': '--ds-border-selected',
    'color.border.brand': '--ds-border-brand',
    'color.border.danger': '--ds-border-danger',
    'color.border.warning': '--ds-border-warning',
    'color.border.success': '--ds-border-success',
    'color.border.discovery': '--ds-border-discovery',
    'color.border.information': '--ds-border-information',
    'color.border.bold': '--ds-border-bold',
    'color.background.accent.lime.subtlest': '--ds-background-accent-lime-subtlest',
    'color.background.accent.lime.subtlest.hovered': '--ds-background-accent-lime-subtlest-hovered',
    'color.background.accent.lime.subtlest.pressed': '--ds-background-accent-lime-subtlest-pressed',
    'color.background.accent.lime.subtler': '--ds-background-accent-lime-subtler',
    'color.background.accent.lime.subtler.hovered': '--ds-background-accent-lime-subtler-hovered',
    'color.background.accent.lime.subtler.pressed': '--ds-background-accent-lime-subtler-pressed',
    'color.background.accent.lime.subtle': '--ds-background-accent-lime-subtle',
    'color.background.accent.lime.subtle.hovered': '--ds-background-accent-lime-subtle-hovered',
    'color.background.accent.lime.subtle.pressed': '--ds-background-accent-lime-subtle-pressed',
    'color.background.accent.lime.bolder': '--ds-background-accent-lime-bolder',
    'color.background.accent.lime.bolder.hovered': '--ds-background-accent-lime-bolder-hovered',
    'color.background.accent.lime.bolder.pressed': '--ds-background-accent-lime-bolder-pressed',
    'color.background.accent.red.subtlest': '--ds-background-accent-red-subtlest',
    'color.background.accent.red.subtlest.hovered': '--ds-background-accent-red-subtlest-hovered',
    'color.background.accent.red.subtlest.pressed': '--ds-background-accent-red-subtlest-pressed',
    'color.background.accent.red.subtler': '--ds-background-accent-red-subtler',
    'color.background.accent.red.subtler.hovered': '--ds-background-accent-red-subtler-hovered',
    'color.background.accent.red.subtler.pressed': '--ds-background-accent-red-subtler-pressed',
    'color.background.accent.red.subtle': '--ds-background-accent-red-subtle',
    'color.background.accent.red.subtle.hovered': '--ds-background-accent-red-subtle-hovered',
    'color.background.accent.red.subtle.pressed': '--ds-background-accent-red-subtle-pressed',
    'color.background.accent.red.bolder': '--ds-background-accent-red-bolder',
    'color.background.accent.red.bolder.hovered': '--ds-background-accent-red-bolder-hovered',
    'color.background.accent.red.bolder.pressed': '--ds-background-accent-red-bolder-pressed',
    'color.background.accent.orange.subtlest': '--ds-background-accent-orange-subtlest',
    'color.background.accent.orange.subtlest.hovered': '--ds-background-accent-orange-subtlest-hovered',
    'color.background.accent.orange.subtlest.pressed': '--ds-background-accent-orange-subtlest-pressed',
    'color.background.accent.orange.subtler': '--ds-background-accent-orange-subtler',
    'color.background.accent.orange.subtler.hovered': '--ds-background-accent-orange-subtler-hovered',
    'color.background.accent.orange.subtler.pressed': '--ds-background-accent-orange-subtler-pressed',
    'color.background.accent.orange.subtle': '--ds-background-accent-orange-subtle',
    'color.background.accent.orange.subtle.hovered': '--ds-background-accent-orange-subtle-hovered',
    'color.background.accent.orange.subtle.pressed': '--ds-background-accent-orange-subtle-pressed',
    'color.background.accent.orange.bolder': '--ds-background-accent-orange-bolder',
    'color.background.accent.orange.bolder.hovered': '--ds-background-accent-orange-bolder-hovered',
    'color.background.accent.orange.bolder.pressed': '--ds-background-accent-orange-bolder-pressed',
    'color.background.accent.yellow.subtlest': '--ds-background-accent-yellow-subtlest',
    'color.background.accent.yellow.subtlest.hovered': '--ds-background-accent-yellow-subtlest-hovered',
    'color.background.accent.yellow.subtlest.pressed': '--ds-background-accent-yellow-subtlest-pressed',
    'color.background.accent.yellow.subtler': '--ds-background-accent-yellow-subtler',
    'color.background.accent.yellow.subtler.hovered': '--ds-background-accent-yellow-subtler-hovered',
    'color.background.accent.yellow.subtler.pressed': '--ds-background-accent-yellow-subtler-pressed',
    'color.background.accent.yellow.subtle': '--ds-background-accent-yellow-subtle',
    'color.background.accent.yellow.subtle.hovered': '--ds-background-accent-yellow-subtle-hovered',
    'color.background.accent.yellow.subtle.pressed': '--ds-background-accent-yellow-subtle-pressed',
    'color.background.accent.yellow.bolder': '--ds-background-accent-yellow-bolder',
    'color.background.accent.yellow.bolder.hovered': '--ds-background-accent-yellow-bolder-hovered',
    'color.background.accent.yellow.bolder.pressed': '--ds-background-accent-yellow-bolder-pressed',
    'color.background.accent.green.subtlest': '--ds-background-accent-green-subtlest',
    'color.background.accent.green.subtlest.hovered': '--ds-background-accent-green-subtlest-hovered',
    'color.background.accent.green.subtlest.pressed': '--ds-background-accent-green-subtlest-pressed',
    'color.background.accent.green.subtler': '--ds-background-accent-green-subtler',
    'color.background.accent.green.subtler.hovered': '--ds-background-accent-green-subtler-hovered',
    'color.background.accent.green.subtler.pressed': '--ds-background-accent-green-subtler-pressed',
    'color.background.accent.green.subtle': '--ds-background-accent-green-subtle',
    'color.background.accent.green.subtle.hovered': '--ds-background-accent-green-subtle-hovered',
    'color.background.accent.green.subtle.pressed': '--ds-background-accent-green-subtle-pressed',
    'color.background.accent.green.bolder': '--ds-background-accent-green-bolder',
    'color.background.accent.green.bolder.hovered': '--ds-background-accent-green-bolder-hovered',
    'color.background.accent.green.bolder.pressed': '--ds-background-accent-green-bolder-pressed',
    'color.background.accent.teal.subtlest': '--ds-background-accent-teal-subtlest',
    'color.background.accent.teal.subtlest.hovered': '--ds-background-accent-teal-subtlest-hovered',
    'color.background.accent.teal.subtlest.pressed': '--ds-background-accent-teal-subtlest-pressed',
    'color.background.accent.teal.subtler': '--ds-background-accent-teal-subtler',
    'color.background.accent.teal.subtler.hovered': '--ds-background-accent-teal-subtler-hovered',
    'color.background.accent.teal.subtler.pressed': '--ds-background-accent-teal-subtler-pressed',
    'color.background.accent.teal.subtle': '--ds-background-accent-teal-subtle',
    'color.background.accent.teal.subtle.hovered': '--ds-background-accent-teal-subtle-hovered',
    'color.background.accent.teal.subtle.pressed': '--ds-background-accent-teal-subtle-pressed',
    'color.background.accent.teal.bolder': '--ds-background-accent-teal-bolder',
    'color.background.accent.teal.bolder.hovered': '--ds-background-accent-teal-bolder-hovered',
    'color.background.accent.teal.bolder.pressed': '--ds-background-accent-teal-bolder-pressed',
    'color.background.accent.blue.subtlest': '--ds-background-accent-blue-subtlest',
    'color.background.accent.blue.subtlest.hovered': '--ds-background-accent-blue-subtlest-hovered',
    'color.background.accent.blue.subtlest.pressed': '--ds-background-accent-blue-subtlest-pressed',
    'color.background.accent.blue.subtler': '--ds-background-accent-blue-subtler',
    'color.background.accent.blue.subtler.hovered': '--ds-background-accent-blue-subtler-hovered',
    'color.background.accent.blue.subtler.pressed': '--ds-background-accent-blue-subtler-pressed',
    'color.background.accent.blue.subtle': '--ds-background-accent-blue-subtle',
    'color.background.accent.blue.subtle.hovered': '--ds-background-accent-blue-subtle-hovered',
    'color.background.accent.blue.subtle.pressed': '--ds-background-accent-blue-subtle-pressed',
    'color.background.accent.blue.bolder': '--ds-background-accent-blue-bolder',
    'color.background.accent.blue.bolder.hovered': '--ds-background-accent-blue-bolder-hovered',
    'color.background.accent.blue.bolder.pressed': '--ds-background-accent-blue-bolder-pressed',
    'color.background.accent.purple.subtlest': '--ds-background-accent-purple-subtlest',
    'color.background.accent.purple.subtlest.hovered': '--ds-background-accent-purple-subtlest-hovered',
    'color.background.accent.purple.subtlest.pressed': '--ds-background-accent-purple-subtlest-pressed',
    'color.background.accent.purple.subtler': '--ds-background-accent-purple-subtler',
    'color.background.accent.purple.subtler.hovered': '--ds-background-accent-purple-subtler-hovered',
    'color.background.accent.purple.subtler.pressed': '--ds-background-accent-purple-subtler-pressed',
    'color.background.accent.purple.subtle': '--ds-background-accent-purple-subtle',
    'color.background.accent.purple.subtle.hovered': '--ds-background-accent-purple-subtle-hovered',
    'color.background.accent.purple.subtle.pressed': '--ds-background-accent-purple-subtle-pressed',
    'color.background.accent.purple.bolder': '--ds-background-accent-purple-bolder',
    'color.background.accent.purple.bolder.hovered': '--ds-background-accent-purple-bolder-hovered',
    'color.background.accent.purple.bolder.pressed': '--ds-background-accent-purple-bolder-pressed',
    'color.background.accent.magenta.subtlest': '--ds-background-accent-magenta-subtlest',
    'color.background.accent.magenta.subtlest.hovered': '--ds-background-accent-magenta-subtlest-hovered',
    'color.background.accent.magenta.subtlest.pressed': '--ds-background-accent-magenta-subtlest-pressed',
    'color.background.accent.magenta.subtler': '--ds-background-accent-magenta-subtler',
    'color.background.accent.magenta.subtler.hovered': '--ds-background-accent-magenta-subtler-hovered',
    'color.background.accent.magenta.subtler.pressed': '--ds-background-accent-magenta-subtler-pressed',
    'color.background.accent.magenta.subtle': '--ds-background-accent-magenta-subtle',
    'color.background.accent.magenta.subtle.hovered': '--ds-background-accent-magenta-subtle-hovered',
    'color.background.accent.magenta.subtle.pressed': '--ds-background-accent-magenta-subtle-pressed',
    'color.background.accent.magenta.bolder': '--ds-background-accent-magenta-bolder',
    'color.background.accent.magenta.bolder.hovered': '--ds-background-accent-magenta-bolder-hovered',
    'color.background.accent.magenta.bolder.pressed': '--ds-background-accent-magenta-bolder-pressed',
    'color.background.accent.gray.subtlest': '--ds-background-accent-gray-subtlest',
    'color.background.accent.gray.subtlest.hovered': '--ds-background-accent-gray-subtlest-hovered',
    'color.background.accent.gray.subtlest.pressed': '--ds-background-accent-gray-subtlest-pressed',
    'color.background.accent.gray.subtler': '--ds-background-accent-gray-subtler',
    'color.background.accent.gray.subtler.hovered': '--ds-background-accent-gray-subtler-hovered',
    'color.background.accent.gray.subtler.pressed': '--ds-background-accent-gray-subtler-pressed',
    'color.background.accent.gray.subtle': '--ds-background-accent-gray-subtle',
    'color.background.accent.gray.subtle.hovered': '--ds-background-accent-gray-subtle-hovered',
    'color.background.accent.gray.subtle.pressed': '--ds-background-accent-gray-subtle-pressed',
    'color.background.accent.gray.bolder': '--ds-background-accent-gray-bolder',
    'color.background.accent.gray.bolder.hovered': '--ds-background-accent-gray-bolder-hovered',
    'color.background.accent.gray.bolder.pressed': '--ds-background-accent-gray-bolder-pressed',
    'color.background.disabled': '--ds-background-disabled',
    'color.background.input': '--ds-background-input',
    'color.background.input.hovered': '--ds-background-input-hovered',
    'color.background.input.pressed': '--ds-background-input-pressed',
    'color.background.inverse.subtle': '--ds-background-inverse-subtle',
    'color.background.inverse.subtle.hovered': '--ds-background-inverse-subtle-hovered',
    'color.background.inverse.subtle.pressed': '--ds-background-inverse-subtle-pressed',
    'color.background.neutral': '--ds-background-neutral',
    'color.background.neutral.hovered': '--ds-background-neutral-hovered',
    'color.background.neutral.pressed': '--ds-background-neutral-pressed',
    'color.background.neutral.subtle': '--ds-background-neutral-subtle',
    'color.background.neutral.subtle.hovered': '--ds-background-neutral-subtle-hovered',
    'color.background.neutral.subtle.pressed': '--ds-background-neutral-subtle-pressed',
    'color.background.neutral.bold': '--ds-background-neutral-bold',
    'color.background.neutral.bold.hovered': '--ds-background-neutral-bold-hovered',
    'color.background.neutral.bold.pressed': '--ds-background-neutral-bold-pressed',
    'color.background.selected': '--ds-background-selected',
    'color.background.selected.hovered': '--ds-background-selected-hovered',
    'color.background.selected.pressed': '--ds-background-selected-pressed',
    'color.background.selected.bold': '--ds-background-selected-bold',
    'color.background.selected.bold.hovered': '--ds-background-selected-bold-hovered',
    'color.background.selected.bold.pressed': '--ds-background-selected-bold-pressed',
    'color.background.brand.subtlest': '--ds-background-brand-subtlest',
    'color.background.brand.subtlest.hovered': '--ds-background-brand-subtlest-hovered',
    'color.background.brand.subtlest.pressed': '--ds-background-brand-subtlest-pressed',
    'color.background.brand.bold': '--ds-background-brand-bold',
    'color.background.brand.bold.hovered': '--ds-background-brand-bold-hovered',
    'color.background.brand.bold.pressed': '--ds-background-brand-bold-pressed',
    'color.background.brand.boldest': '--ds-background-brand-boldest',
    'color.background.brand.boldest.hovered': '--ds-background-brand-boldest-hovered',
    'color.background.brand.boldest.pressed': '--ds-background-brand-boldest-pressed',
    'color.background.danger': '--ds-background-danger',
    'color.background.danger.hovered': '--ds-background-danger-hovered',
    'color.background.danger.pressed': '--ds-background-danger-pressed',
    'color.background.danger.subtler': '--ds-background-danger-subtler',
    'color.background.danger.subtler.hovered': '--ds-background-danger-subtler-hovered',
    'color.background.danger.subtler.pressed': '--ds-background-danger-subtler-pressed',
    'color.background.danger.bold': '--ds-background-danger-bold',
    'color.background.danger.bold.hovered': '--ds-background-danger-bold-hovered',
    'color.background.danger.bold.pressed': '--ds-background-danger-bold-pressed',
    'color.background.warning': '--ds-background-warning',
    'color.background.warning.hovered': '--ds-background-warning-hovered',
    'color.background.warning.pressed': '--ds-background-warning-pressed',
    'color.background.warning.subtler': '--ds-background-warning-subtler',
    'color.background.warning.subtler.hovered': '--ds-background-warning-subtler-hovered',
    'color.background.warning.subtler.pressed': '--ds-background-warning-subtler-pressed',
    'color.background.warning.bold': '--ds-background-warning-bold',
    'color.background.warning.bold.hovered': '--ds-background-warning-bold-hovered',
    'color.background.warning.bold.pressed': '--ds-background-warning-bold-pressed',
    'color.background.success': '--ds-background-success',
    'color.background.success.hovered': '--ds-background-success-hovered',
    'color.background.success.pressed': '--ds-background-success-pressed',
    'color.background.success.subtler': '--ds-background-success-subtler',
    'color.background.success.subtler.hovered': '--ds-background-success-subtler-hovered',
    'color.background.success.subtler.pressed': '--ds-background-success-subtler-pressed',
    'color.background.success.bold': '--ds-background-success-bold',
    'color.background.success.bold.hovered': '--ds-background-success-bold-hovered',
    'color.background.success.bold.pressed': '--ds-background-success-bold-pressed',
    'color.background.discovery': '--ds-background-discovery',
    'color.background.discovery.hovered': '--ds-background-discovery-hovered',
    'color.background.discovery.pressed': '--ds-background-discovery-pressed',
    'color.background.discovery.subtler': '--ds-background-discovery-subtler',
    'color.background.discovery.subtler.hovered': '--ds-background-discovery-subtler-hovered',
    'color.background.discovery.subtler.pressed': '--ds-background-discovery-subtler-pressed',
    'color.background.discovery.bold': '--ds-background-discovery-bold',
    'color.background.discovery.bold.hovered': '--ds-background-discovery-bold-hovered',
    'color.background.discovery.bold.pressed': '--ds-background-discovery-bold-pressed',
    'color.background.information': '--ds-background-information',
    'color.background.information.hovered': '--ds-background-information-hovered',
    'color.background.information.pressed': '--ds-background-information-pressed',
    'color.background.information.subtler': '--ds-background-information-subtler',
    'color.background.information.subtler.hovered': '--ds-background-information-subtler-hovered',
    'color.background.information.subtler.pressed': '--ds-background-information-subtler-pressed',
    'color.background.information.bold': '--ds-background-information-bold',
    'color.background.information.bold.hovered': '--ds-background-information-bold-hovered',
    'color.background.information.bold.pressed': '--ds-background-information-bold-pressed',
    'color.blanket': '--ds-blanket',
    'color.blanket.selected': '--ds-blanket-selected',
    'color.blanket.danger': '--ds-blanket-danger',
    'color.interaction.hovered': '--ds-interaction-hovered',
    'color.interaction.pressed': '--ds-interaction-pressed',
    'color.skeleton': '--ds-skeleton',
    'color.skeleton.subtle': '--ds-skeleton-subtle',
    'color.chart.categorical.1': '--ds-chart-categorical-1',
    'color.chart.categorical.1.hovered': '--ds-chart-categorical-1-hovered',
    'color.chart.categorical.2': '--ds-chart-categorical-2',
    'color.chart.categorical.2.hovered': '--ds-chart-categorical-2-hovered',
    'color.chart.categorical.3': '--ds-chart-categorical-3',
    'color.chart.categorical.3.hovered': '--ds-chart-categorical-3-hovered',
    'color.chart.categorical.4': '--ds-chart-categorical-4',
    'color.chart.categorical.4.hovered': '--ds-chart-categorical-4-hovered',
    'color.chart.categorical.5': '--ds-chart-categorical-5',
    'color.chart.categorical.5.hovered': '--ds-chart-categorical-5-hovered',
    'color.chart.categorical.6': '--ds-chart-categorical-6',
    'color.chart.categorical.6.hovered': '--ds-chart-categorical-6-hovered',
    'color.chart.categorical.7': '--ds-chart-categorical-7',
    'color.chart.categorical.7.hovered': '--ds-chart-categorical-7-hovered',
    'color.chart.categorical.8': '--ds-chart-categorical-8',
    'color.chart.categorical.8.hovered': '--ds-chart-categorical-8-hovered',
    'color.chart.lime.bold': '--ds-chart-lime-bold',
    'color.chart.lime.bold.hovered': '--ds-chart-lime-bold-hovered',
    'color.chart.lime.bolder': '--ds-chart-lime-bolder',
    'color.chart.lime.bolder.hovered': '--ds-chart-lime-bolder-hovered',
    'color.chart.lime.boldest': '--ds-chart-lime-boldest',
    'color.chart.lime.boldest.hovered': '--ds-chart-lime-boldest-hovered',
    'color.chart.neutral': '--ds-chart-neutral',
    'color.chart.neutral.hovered': '--ds-chart-neutral-hovered',
    'color.chart.red.bold': '--ds-chart-red-bold',
    'color.chart.red.bold.hovered': '--ds-chart-red-bold-hovered',
    'color.chart.red.bolder': '--ds-chart-red-bolder',
    'color.chart.red.bolder.hovered': '--ds-chart-red-bolder-hovered',
    'color.chart.red.boldest': '--ds-chart-red-boldest',
    'color.chart.red.boldest.hovered': '--ds-chart-red-boldest-hovered',
    'color.chart.orange.bold': '--ds-chart-orange-bold',
    'color.chart.orange.bold.hovered': '--ds-chart-orange-bold-hovered',
    'color.chart.orange.bolder': '--ds-chart-orange-bolder',
    'color.chart.orange.bolder.hovered': '--ds-chart-orange-bolder-hovered',
    'color.chart.orange.boldest': '--ds-chart-orange-boldest',
    'color.chart.orange.boldest.hovered': '--ds-chart-orange-boldest-hovered',
    'color.chart.yellow.bold': '--ds-chart-yellow-bold',
    'color.chart.yellow.bold.hovered': '--ds-chart-yellow-bold-hovered',
    'color.chart.yellow.bolder': '--ds-chart-yellow-bolder',
    'color.chart.yellow.bolder.hovered': '--ds-chart-yellow-bolder-hovered',
    'color.chart.yellow.boldest': '--ds-chart-yellow-boldest',
    'color.chart.yellow.boldest.hovered': '--ds-chart-yellow-boldest-hovered',
    'color.chart.green.bold': '--ds-chart-green-bold',
    'color.chart.green.bold.hovered': '--ds-chart-green-bold-hovered',
    'color.chart.green.bolder': '--ds-chart-green-bolder',
    'color.chart.green.bolder.hovered': '--ds-chart-green-bolder-hovered',
    'color.chart.green.boldest': '--ds-chart-green-boldest',
    'color.chart.green.boldest.hovered': '--ds-chart-green-boldest-hovered',
    'color.chart.teal.bold': '--ds-chart-teal-bold',
    'color.chart.teal.bold.hovered': '--ds-chart-teal-bold-hovered',
    'color.chart.teal.bolder': '--ds-chart-teal-bolder',
    'color.chart.teal.bolder.hovered': '--ds-chart-teal-bolder-hovered',
    'color.chart.teal.boldest': '--ds-chart-teal-boldest',
    'color.chart.teal.boldest.hovered': '--ds-chart-teal-boldest-hovered',
    'color.chart.blue.bold': '--ds-chart-blue-bold',
    'color.chart.blue.bold.hovered': '--ds-chart-blue-bold-hovered',
    'color.chart.blue.bolder': '--ds-chart-blue-bolder',
    'color.chart.blue.bolder.hovered': '--ds-chart-blue-bolder-hovered',
    'color.chart.blue.boldest': '--ds-chart-blue-boldest',
    'color.chart.blue.boldest.hovered': '--ds-chart-blue-boldest-hovered',
    'color.chart.purple.bold': '--ds-chart-purple-bold',
    'color.chart.purple.bold.hovered': '--ds-chart-purple-bold-hovered',
    'color.chart.purple.bolder': '--ds-chart-purple-bolder',
    'color.chart.purple.bolder.hovered': '--ds-chart-purple-bolder-hovered',
    'color.chart.purple.boldest': '--ds-chart-purple-boldest',
    'color.chart.purple.boldest.hovered': '--ds-chart-purple-boldest-hovered',
    'color.chart.magenta.bold': '--ds-chart-magenta-bold',
    'color.chart.magenta.bold.hovered': '--ds-chart-magenta-bold-hovered',
    'color.chart.magenta.bolder': '--ds-chart-magenta-bolder',
    'color.chart.magenta.bolder.hovered': '--ds-chart-magenta-bolder-hovered',
    'color.chart.magenta.boldest': '--ds-chart-magenta-boldest',
    'color.chart.magenta.boldest.hovered': '--ds-chart-magenta-boldest-hovered',
    'color.chart.gray.bold': '--ds-chart-gray-bold',
    'color.chart.gray.bold.hovered': '--ds-chart-gray-bold-hovered',
    'color.chart.gray.bolder': '--ds-chart-gray-bolder',
    'color.chart.gray.bolder.hovered': '--ds-chart-gray-bolder-hovered',
    'color.chart.gray.boldest': '--ds-chart-gray-boldest',
    'color.chart.gray.boldest.hovered': '--ds-chart-gray-boldest-hovered',
    'color.chart.brand': '--ds-chart-brand',
    'color.chart.brand.hovered': '--ds-chart-brand-hovered',
    'color.chart.danger': '--ds-chart-danger',
    'color.chart.danger.hovered': '--ds-chart-danger-hovered',
    'color.chart.danger.bold': '--ds-chart-danger-bold',
    'color.chart.danger.bold.hovered': '--ds-chart-danger-bold-hovered',
    'color.chart.warning': '--ds-chart-warning',
    'color.chart.warning.hovered': '--ds-chart-warning-hovered',
    'color.chart.warning.bold': '--ds-chart-warning-bold',
    'color.chart.warning.bold.hovered': '--ds-chart-warning-bold-hovered',
    'color.chart.success': '--ds-chart-success',
    'color.chart.success.hovered': '--ds-chart-success-hovered',
    'color.chart.success.bold': '--ds-chart-success-bold',
    'color.chart.success.bold.hovered': '--ds-chart-success-bold-hovered',
    'color.chart.discovery': '--ds-chart-discovery',
    'color.chart.discovery.hovered': '--ds-chart-discovery-hovered',
    'color.chart.discovery.bold': '--ds-chart-discovery-bold',
    'color.chart.discovery.bold.hovered': '--ds-chart-discovery-bold-hovered',
    'color.chart.information': '--ds-chart-information',
    'color.chart.information.hovered': '--ds-chart-information-hovered',
    'color.chart.information.bold': '--ds-chart-information-bold',
    'color.chart.information.bold.hovered': '--ds-chart-information-bold-hovered',
    'elevation.surface': '--ds-surface',
    'elevation.surface.hovered': '--ds-surface-hovered',
    'elevation.surface.pressed': '--ds-surface-pressed',
    'elevation.surface.overlay': '--ds-surface-overlay',
    'elevation.surface.overlay.hovered': '--ds-surface-overlay-hovered',
    'elevation.surface.overlay.pressed': '--ds-surface-overlay-pressed',
    'elevation.surface.raised': '--ds-surface-raised',
    'elevation.surface.raised.hovered': '--ds-surface-raised-hovered',
    'elevation.surface.raised.pressed': '--ds-surface-raised-pressed',
    'elevation.surface.sunken': '--ds-surface-sunken',
    'elevation.shadow.overflow': '--ds-shadow-overflow',
    'elevation.shadow.overflow.perimeter': '--ds-shadow-overflow-perimeter',
    'elevation.shadow.overflow.spread': '--ds-shadow-overflow-spread',
    'elevation.shadow.overlay': '--ds-shadow-overlay',
    'elevation.shadow.raised': '--ds-shadow-raised',
    'opacity.disabled': '--ds-opacity-disabled',
    'opacity.loading': '--ds-opacity-loading',
    'utility.UNSAFE.transparent': '--ds-UNSAFE-transparent',
    'utility.elevation.surface.current': '--ds-elevation-surface-current',
    'space.0': '--ds-space-0',
    'space.025': '--ds-space-025',
    'space.050': '--ds-space-050',
    'space.075': '--ds-space-075',
    'space.100': '--ds-space-100',
    'space.150': '--ds-space-150',
    'space.200': '--ds-space-200',
    'space.250': '--ds-space-250',
    'space.300': '--ds-space-300',
    'space.400': '--ds-space-400',
    'space.500': '--ds-space-500',
    'space.600': '--ds-space-600',
    'space.800': '--ds-space-800',
    'space.1000': '--ds-space-1000',
    'space.negative.025': '--ds-space-negative-025',
    'space.negative.050': '--ds-space-negative-050',
    'space.negative.075': '--ds-space-negative-075',
    'space.negative.100': '--ds-space-negative-100',
    'space.negative.150': '--ds-space-negative-150',
    'space.negative.200': '--ds-space-negative-200',
    'space.negative.250': '--ds-space-negative-250',
    'space.negative.300': '--ds-space-negative-300',
    'space.negative.400': '--ds-space-negative-400',
    'font.heading.xxlarge': '--ds-font-heading-xxlarge',
    'font.heading.xlarge': '--ds-font-heading-xlarge',
    'font.heading.large': '--ds-font-heading-large',
    'font.heading.medium': '--ds-font-heading-medium',
    'font.heading.small': '--ds-font-heading-small',
    'font.heading.xsmall': '--ds-font-heading-xsmall',
    'font.heading.xxsmall': '--ds-font-heading-xxsmall',
    'font.body.large': '--ds-font-body-large',
    'font.body': '--ds-font-body',
    'font.body.small': '--ds-font-body-small',
    'font.metric.large': '--ds-font-metric-large',
    'font.metric.medium': '--ds-font-metric-medium',
    'font.metric.small': '--ds-font-metric-small',
    'font.code': '--ds-font-code',
    'font.weight.regular': '--ds-font-weight-regular',
    'font.weight.medium': '--ds-font-weight-medium',
    'font.weight.semibold': '--ds-font-weight-semibold',
    'font.weight.bold': '--ds-font-weight-bold',
    'font.family.heading': '--ds-font-family-heading',
    'font.family.body': '--ds-font-family-body',
    'font.family.code': '--ds-font-family-code',
    'font.family.brand.heading': '--ds-font-family-brand-heading',
    'font.family.brand.body': '--ds-font-family-brand-body',
    'radius.xsmall': '--ds-radius-xsmall',
    'radius.small': '--ds-radius-small',
    'radius.medium': '--ds-radius-medium',
    'radius.large': '--ds-radius-large',
    'radius.xlarge': '--ds-radius-xlarge',
    'radius.xxlarge': '--ds-radius-xxlarge',
    'radius.full': '--ds-radius-full',
    'radius.tile': '--ds-radius-tile',
    'border.width': '--ds-border-width',
    'border.width.selected': '--ds-border-width-selected',
    'border.width.focused': '--ds-border-width-focused'
};
exports.default = tokens;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hE9r7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getThemeOverridePreferences", function() {
    return getThemeOverridePreferences;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var getThemeOverridePreferences = function(_themeState) {
    var themeOverridePreferences = [];
    return (0, _toConsumableArray._)(new Set(themeOverridePreferences));
};

},{"@swc/helpers/_/_to_consumable_array":"1eSZf","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2ysWl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getThemeOverridePreferences", function() {
    return 0, _getThemeOverridePreferences.getThemeOverridePreferences;
});
parcelHelpers.export(exports, "getThemePreferences", function() {
    return getThemePreferences;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _getIncreasedContrastTheme = require("./get-increased-contrast-theme");
var _getIncreasedContrastThemeDefault = parcelHelpers.interopDefault(_getIncreasedContrastTheme);
var _getThemeOverridePreferences = require("./get-theme-override-preferences");
var getThemePreferences = function(themeState) {
    var colorMode = themeState.colorMode, contrastMode = themeState.contrastMode, dark = themeState.dark, light = themeState.light, shape = themeState.shape, spacing = themeState.spacing, typography = themeState.typography, motion = themeState.motion;
    var autoColorModeThemes = [
        light,
        dark
    ];
    var themePreferences = [];
    if (colorMode === 'auto') {
        var _themePreferences;
        if (contrastMode !== 'no-preference' && (0, _platformFeatureFlags.fg)('platform_increased-contrast-themes')) autoColorModeThemes.forEach(function(normalTheme) {
            var increasedContrastTheme = (0, _getIncreasedContrastThemeDefault.default)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        (_themePreferences = themePreferences).push.apply(_themePreferences, (0, _toConsumableArray._)(autoColorModeThemes));
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== 'no-preference' && (0, _platformFeatureFlags.fg)('platform_increased-contrast-themes')) {
            var increasedContrastTheme = (0, _getIncreasedContrastThemeDefault.default)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography,
        motion
    ].forEach(function(themeId) {
        if (themeId) themePreferences.push(themeId);
    });
    return (0, _toConsumableArray._)(new Set(themePreferences));
};

},{"@swc/helpers/_/_to_consumable_array":"1eSZf","@atlaskit/platform-feature-flags":"kO5t9","./get-increased-contrast-theme":"1H7ul","./get-theme-override-preferences":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1H7ul":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getIncreasedContrastTheme;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _themeConfig = require("../theme-config");
var _themeConfigDefault = parcelHelpers.interopDefault(_themeConfig);
function getIncreasedContrastTheme(themeId) {
    var _Object_entries_find;
    return (_Object_entries_find = Object.entries((0, _themeConfigDefault.default)).find(function(param) {
        var _param = (0, _slicedToArray._)(param, 2), increasesContrastFor = _param[1].increasesContrastFor;
        return increasesContrastFor === themeId;
    })) === null || _Object_entries_find === void 0 ? void 0 : _Object_entries_find[1].id;
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","../theme-config":"b5LJ7","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dui9z":[function(require,module,exports,__globalThis) {
module.exports = require("d22142347388d743")(require("5ef2fc0ca37aac68").resolve("eLWcw")).then(function() {
    return module.bundle.root('1JPJg');
});

},{"d22142347388d743":"hkfCW","5ef2fc0ca37aac68":"l4T2r"}],"1cZ4g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _getGlobalTheme = require("./get-global-theme");
var _getGlobalThemeDefault = parcelHelpers.interopDefault(_getGlobalTheme);
var _themeMutationObserver = require("./theme-mutation-observer");
var _themeMutationObserverDefault = parcelHelpers.interopDefault(_themeMutationObserver);
/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ var useThemeObserver = function() {
    var _useState = (0, _slicedToArray._)((0, _react.useState)((0, _getGlobalThemeDefault.default)()), 2), theme = _useState[0], setTheme = _useState[1];
    (0, _react.useEffect)(function() {
        var observer = new (0, _themeMutationObserverDefault.default)(function(theme) {
            return setTheme(theme);
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, []);
    return theme;
};
exports.default = useThemeObserver;

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","react":"ltHCL","./get-global-theme":"hujfP","./theme-mutation-observer":"foJ0S","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"foJ0S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A MutationObserver which watches the `<html>` element for changes to the theme.
 *
 * In React, use the {@link useThemeObserver `useThemeObserver`} hook instead.
 *
 * @param {function} callback - A callback function which fires when the theme changes.
 *
 * @example
 * ```
 * const observer = new ThemeMutationObserver((theme) => {});
 * observer.observe();
 * ```
 */ parcelHelpers.export(exports, "default", function() {
    return ThemeMutationObserver;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _constants = require("./constants");
var _getGlobalTheme = require("./get-global-theme");
var _getGlobalThemeDefault = parcelHelpers.interopDefault(_getGlobalTheme);
var ThemeMutationObserver = /*#__PURE__*/ function() {
    "use strict";
    function ThemeMutationObserver(callback) {
        (0, _classCallCheck._)(this, ThemeMutationObserver);
        this.legacyObserver = null;
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    (0, _createClass._)(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, _getGlobalThemeDefault.default)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, _constants.THEME_DATA_ATTRIBUTE),
                            (0, _constants.COLOR_MODE_ATTRIBUTE)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
    return ThemeMutationObserver;
}();
ThemeMutationObserver.observer = null;
ThemeMutationObserver.callbacks = new Set();

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","./constants":"lKLNp","./get-global-theme":"hujfP","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4wnOE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorModeContext", function() {
    return ColorModeContext;
});
var _react = require("react");
var ColorModeContext = /*#__PURE__*/ (0, _react.createContext)(undefined);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bNVV3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InsideThemeProviderContext", function() {
    return InsideThemeProviderContext;
});
var _react = require("react");
var InsideThemeProviderContext = /*#__PURE__*/ (0, _react.createContext)(false);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fQzEU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SetColorModeContext", function() {
    return SetColorModeContext;
});
var _react = require("react");
var SetColorModeContext = /*#__PURE__*/ (0, _react.createContext)(undefined);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"19H7Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ThemeContext", function() {
    return ThemeContext;
});
parcelHelpers.export(exports, "SetThemeContext", function() {
    return SetThemeContext;
});
var _react = require("react");
var ThemeContext = /*#__PURE__*/ (0, _react.createContext)(undefined);
var SetThemeContext = /*#__PURE__*/ (0, _react.createContext)(undefined);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"i9QZX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIsInsideThemeProvider", function() {
    return useIsInsideThemeProvider;
});
var _react = require("react");
var _insideThemeProvider = require("../context/inside-theme-provider");
var useIsInsideThemeProvider = function() {
    var _useContext;
    return (_useContext = (0, _react.useContext)((0, _insideThemeProvider.InsideThemeProviderContext))) !== null && _useContext !== void 0 ? _useContext : false;
};

},{"react":"ltHCL","../context/inside-theme-provider":"bNVV3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6tBml":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loadAndMountThemes", function() {
    return loadAndMountThemes;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _browserApis = require("@atlaskit/browser-apis");
var _tokens = require("@atlaskit/tokens");
var _isThemeMounted = require("./is-theme-mounted");
var loadThemeCss = function(themeId) {
    return (0, _asyncToGenerator._)(function() {
        var _ref, themeCss;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    // Prevent duplicate loading of themes
                    if ((0, _isThemeMounted.isThemeMounted)(themeId)) return [
                        2
                    ];
                    // Gracefully handles falsy values like `null` and `undefined` when makers ignore
                    // TS to avoid loading default themes.
                    if (!themeId) return [
                        2
                    ];
                    return [
                        4,
                        (0, _tokens.themeImportMap)[themeId]()
                    ];
                case 1:
                    _ref = _state.sent(), themeCss = _ref.default;
                    return [
                        2,
                        themeCss
                    ];
            }
        });
    })();
};
var mountThemeCss = function(css, themeId) {
    return (0, _asyncToGenerator._)(function() {
        var doc, style;
        return (0, _tsGenerator._)(this, function(_state) {
            // SSR-safe: Only mount on client side
            doc = (0, _browserApis.getDocument)();
            if (!doc) return [
                2
            ];
            style = doc.createElement('style');
            style.textContent = css;
            style.dataset.theme = themeId;
            // Prevent duplicate mounting of themes.
            // It's possible the theme was already being loaded elsewhere.
            if ((0, _isThemeMounted.isThemeMounted)(themeId)) return [
                2
            ];
            doc.head.appendChild(style);
            return [
                2
            ];
        });
    })();
};
var loadAndMountThemeCss = function(themeId) {
    return (0, _asyncToGenerator._)(function() {
        var themeCss;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        loadThemeCss(themeId)
                    ];
                case 1:
                    themeCss = _state.sent();
                    if (!themeCss) return [
                        2
                    ];
                    mountThemeCss(themeCss, themeId);
                    return [
                        2
                    ];
            }
        });
    })();
};
var loadAndMountThemes = function(theme) {
    return (0, _asyncToGenerator._)(function() {
        var themesToLoad;
        return (0, _tsGenerator._)(this, function(_state) {
            themesToLoad = Object.values(theme).filter(function(themeId) {
                return !!themeId;
            });
            themesToLoad.forEach(loadAndMountThemeCss);
            return [
                2
            ];
        });
    })();
};

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_ts_generator":"78Tqx","@atlaskit/browser-apis":"2dayt","@atlaskit/tokens":"8YPAP","./is-theme-mounted":"kSkv7","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kSkv7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Checks if a theme is mounted in the document head.
 *
 * Eventually this won't be necessary as we'll utilise AppProvider context
 * to track theme loading.
 */ parcelHelpers.export(exports, "isThemeMounted", function() {
    return isThemeMounted;
});
var _browserApis = require("@atlaskit/browser-apis");
var _tokens = require("@atlaskit/tokens");
function isThemeMounted(themeId) {
    var doc = (0, _browserApis.getDocument)();
    if (!doc) return false;
    return doc.head.querySelector("style[".concat((0, _tokens.THEME_DATA_ATTRIBUTE), '="').concat(themeId, '"]'));
}

},{"@atlaskit/browser-apis":"2dayt","@atlaskit/tokens":"8YPAP","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ctpOo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __useColorMode()__
 *
 * Returns the current color mode when inside the app provider.
 */ parcelHelpers.export(exports, "useColorMode", function() {
    return useColorMode;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _tokens = require("@atlaskit/tokens");
var _colorMode = require("../context/color-mode");
function useColorMode() {
    var value = (0, _react.useContext)((0, _colorMode.ColorModeContext));
    // TODO: This will only return 'light' or 'dark' but never 'auto', which in some cases
    // may be desirable. We should consider returning both the reconciled color mode (e.g. 'light' or 'dark') and the selected color mode ("auto").
    var theme = (0, _tokens.getGlobalTheme)();
    var _useState = (0, _slicedToArray._)((0, _react.useState)((theme === null || theme === void 0 ? void 0 : theme.colorMode) || 'light'), 2), resolvedColorMode = _useState[0], setResolvedColorMode = _useState[1];
    (0, _react.useEffect)(function() {
        // We are using theme from context so no need to reference the DOM
        if (value) return;
        var observer = new (0, _tokens.ThemeMutationObserver)(function(theme) {
            setResolvedColorMode((theme === null || theme === void 0 ? void 0 : theme.colorMode) || 'light');
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, [
        value
    ]);
    return value ? value : resolvedColorMode;
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","react":"ltHCL","@atlaskit/tokens":"8YPAP","../context/color-mode":"4wnOE","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bhsWh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _index = require("../index");
/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ var useRouterLink = function() {
    var routerLinkComponent = (0, _react.useContext)((0, _index.RouterLinkProviderContext)).routerLinkComponent;
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
exports.default = useRouterLink;

},{"react":"ltHCL","../index":"9P2Wk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4UlSn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AtlassianRelayEnvironmentProvider", function() {
    return AtlassianRelayEnvironmentProvider;
});
parcelHelpers.export(exports, "RelayEnvironmentProvider", function() {
    return RelayEnvironmentProvider;
});
parcelHelpers.export(exports, "ConditionalRelayEnvironmentProvider", function() {
    return ConditionalRelayEnvironmentProvider;
});
parcelHelpers.export(exports, "useRelayEnvironmentProvider", function() {
    return useRelayEnvironmentProvider;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRelay = require("react-relay");
var _environment = require("./environment");
function AtlassianRelayEnvironmentProvider(param) {
    var children = param.children;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRelay.RelayEnvironmentProvider), {
        environment: (0, _environment.__INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__)
    }, children);
}
var RelayEnvironmentProvider = AtlassianRelayEnvironmentProvider;
var ConditionalRelayEnvironmentProvider = function(param) {
    var children = param.children;
    var isRelayPresent = (0, _react.useContext)((0, _reactRelay.ReactRelayContext));
    if (isRelayPresent) return children;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(AtlassianRelayEnvironmentProvider, null, children);
};
function useRelayEnvironmentProvider() {
    var environment = (0, _reactRelay.useRelayEnvironment)();
    return (0, _react.useMemo)(function() {
        return {
            getEnvironment: function getEnvironment() {
                return environment;
            }
        };
    }, [
        environment
    ]);
}

},{"react":"ltHCL","react-relay":"9HAyN","./environment":"gb3aE","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9HAyN":[function(require,module,exports,__globalThis) {
/**
 * Relay v0.0.0-main-39e79f66
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ module.exports = require("5158af750bd9b316");

},{"5158af750bd9b316":"7G3Xt"}],"7G3Xt":[function(require,module,exports,__globalThis) {
'use strict';
var ReactRelayContext = require("8b308b7c63a6ba30");
var ReactRelayFragmentContainer = require("1da2692b8f4bbe65");
var ReactRelayLocalQueryRenderer = require("b6890125c83438ac");
var ReactRelayPaginationContainer = require("25811d5f63763c93");
var ReactRelayQueryRenderer = require("33e1a30c56cc4f78");
var ReactRelayRefetchContainer = require("be2e8cf4a4114081");
var EntryPointContainer = require("de6ffb3fab52af55");
var loadEntryPoint = require("9845f85fcf4112a9");
var _require = require("80316ccbfd7d3b4"), loadQuery = _require.loadQuery;
var ProfilerContext = require("b4855ef250ebe53");
var RelayEnvironmentProvider = require("48d81c687bd4bbcf");
var useClientQuery = require("c869a23f6f46496");
var useEntryPointLoader = require("7069c72978017b36");
var useFragment = require("2a9ad66c86d65a59");
var useLazyLoadQuery = require("5498c88692bba4fb");
var useMutation = require("86cd9abb4c0a7753");
var usePaginationFragment = require("fd7afa0d04aa1b3e");
var usePreloadedQuery = require("cf041356c3d44a67");
var useQueryLoader = require("1f26946fcc34eb8c");
var useRefetchableFragment = require("d4db1f8e4edd018e");
var useRelayEnvironment = require("b0d0118c2aad16fa");
var useSubscribeToInvalidationState = require("17b32c753d09af4");
var useSubscription = require("8f54404b9202981a");
var RelayRuntime = require("f7a34d92a049ca9b");
module.exports = {
    ConnectionHandler: RelayRuntime.ConnectionHandler,
    QueryRenderer: ReactRelayQueryRenderer,
    LocalQueryRenderer: ReactRelayLocalQueryRenderer,
    MutationTypes: RelayRuntime.MutationTypes,
    RangeOperations: RelayRuntime.RangeOperations,
    ReactRelayContext: ReactRelayContext,
    applyOptimisticMutation: RelayRuntime.applyOptimisticMutation,
    commitLocalUpdate: RelayRuntime.commitLocalUpdate,
    commitMutation: RelayRuntime.commitMutation,
    createFragmentContainer: ReactRelayFragmentContainer.createContainer,
    createPaginationContainer: ReactRelayPaginationContainer.createContainer,
    createRefetchContainer: ReactRelayRefetchContainer.createContainer,
    fetchQuery_DEPRECATED: RelayRuntime.fetchQuery_DEPRECATED,
    graphql: RelayRuntime.graphql,
    readInlineData: RelayRuntime.readInlineData,
    requestSubscription: RelayRuntime.requestSubscription,
    EntryPointContainer: EntryPointContainer,
    RelayEnvironmentProvider: RelayEnvironmentProvider,
    ProfilerContext: ProfilerContext,
    fetchQuery: RelayRuntime.fetchQuery,
    loadQuery: loadQuery,
    loadEntryPoint: loadEntryPoint,
    useClientQuery: useClientQuery,
    useFragment: useFragment,
    useLazyLoadQuery: useLazyLoadQuery,
    useEntryPointLoader: useEntryPointLoader,
    useQueryLoader: useQueryLoader,
    useMutation: useMutation,
    usePaginationFragment: usePaginationFragment,
    usePreloadedQuery: usePreloadedQuery,
    useRefetchableFragment: useRefetchableFragment,
    useRelayEnvironment: useRelayEnvironment,
    useSubscribeToInvalidationState: useSubscribeToInvalidationState,
    useSubscription: useSubscription
};

},{"8b308b7c63a6ba30":"7NW2h","1da2692b8f4bbe65":"ds2RZ","b6890125c83438ac":"33cI7","25811d5f63763c93":"eYnmn","33e1a30c56cc4f78":"l9rE8","be2e8cf4a4114081":"1nKeO","de6ffb3fab52af55":"d2ChJ","9845f85fcf4112a9":"iKwbK","80316ccbfd7d3b4":"4CbeJ","b4855ef250ebe53":"1lEHI","48d81c687bd4bbcf":"aIt8X","c869a23f6f46496":"c5QiX","7069c72978017b36":"lV0xn","2a9ad66c86d65a59":"1zoWc","5498c88692bba4fb":"jPRDt","86cd9abb4c0a7753":"gIJ5I","fd7afa0d04aa1b3e":"cs6Pn","cf041356c3d44a67":"kylpw","1f26946fcc34eb8c":"aiqzn","d4db1f8e4edd018e":"d2wqG","b0d0118c2aad16fa":"bs9Iy","17b32c753d09af4":"dtX5o","8f54404b9202981a":"6fzbF","f7a34d92a049ca9b":"2IxFR"}],"7NW2h":[function(require,module,exports,__globalThis) {
'use strict';
var React = require("b48f9da34f26f544");
var _require = require("a4bce2dbe7496983"), createRelayContext = _require.__internal.createRelayContext;
module.exports = createRelayContext(React);

},{"b48f9da34f26f544":"ltHCL","a4bce2dbe7496983":"2IxFR"}],"2IxFR":[function(require,module,exports,__globalThis) {
/**
 * Relay v0.0.0-main-39e79f66
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ module.exports = require("660d7607c251850d");

},{"660d7607c251850d":"2rcWz"}],"2rcWz":[function(require,module,exports,__globalThis) {
'use strict';
var ConnectionHandler = require("8188ae2e22062c04");
var ConnectionInterface = require("9878f12e4d57f49f");
var MutationHandlers = require("9ab0fc1b93a027fe");
var RelayDefaultHandlerProvider = require("a0ca36000bc16662");
var applyOptimisticMutation = require("1a19e12b86ca7844");
var commitLocalUpdate = require("249b083be6ee863f");
var commitMutation = require("b99aa80d9a0f8cb9");
var RelayDeclarativeMutationConfig = require("3039a513d5fd5c6");
var RelayNetwork = require("110ec4dc4df70756");
var RelayObservable = require("2a50dda6bedbe7de");
var RelayQueryResponseCache = require("b7d8d322db70f6c");
var fetchQuery = require("f836796860310832");
var fetchQuery_DEPRECATED = require("1164e0aeaab3f350");
var fetchQueryInternal = require("735ae29e1c255fcf");
var GraphQLTag = require("4914aafb5f3fdc68");
var PreloadableQueryRegistry = require("6600e0465f3a778e");
var _require = require("34fb914551b4365e"), generateClientID = _require.generateClientID, generateUniqueClientID = _require.generateUniqueClientID, isClientID = _require.isClientID;
var createFragmentSpecResolver = require("438470f4c2d195c5");
var createRelayContext = require("8860e6a31fdca9c4");
var _require2 = require("60fcdad1852680f7"), isSuspenseSentinel = _require2.isSuspenseSentinel, suspenseSentinel = _require2.suspenseSentinel;
var isRelayModernEnvironment = require("6a763e3c852564b8");
var normalizeResponse = require("65fc2de8cd60932e");
var readInlineData = require("567eda9de309f218");
var RelayConcreteVariables = require("dfffbd41fc70cd39");
var RelayModernEnvironment = require("e2b118780d500de1");
var RelayModernOperationDescriptor = require("6b8a7600cdf84a63");
var RelayModernRecord = require("355a821958e8c4e8");
var RelayModernSelector = require("6a9e7721dfd9f016");
var RelayModernStore = require("3e7f0bba202ee3c7");
var RelayOperationTracker = require("a644e396eae6af3b");
var RelayRecordSource = require("1fd48de7cb8e9c88");
var RelayStoreUtils = require("b906b813921f2c6d");
var ResolverFragments = require("ab3e6d75921916ac");
var ViewerPattern = require("b5d41abd377e2ca0");
var requestSubscription = require("93b238f47c124377");
var createPayloadFor3DField = require("2608344a99e76af0");
var deepFreeze = require("1893916e3ddf485c");
var getFragmentIdentifier = require("405665a0329d4c8d");
var getPaginationMetadata = require("80ac10e2a73c55ca");
var getPaginationVariables = require("b635b62bc4b2ab16");
var getPendingOperationsForFragment = require("905d206ed7fa2839");
var getRefetchMetadata = require("7de8e63f749f7420");
var getRelayHandleKey = require("21962ba74ccc19f2");
var getRequestIdentifier = require("478040846eca158a");
var getValueAtPath = require("9f140c3040d5a746");
var handlePotentialSnapshotErrors = require("219749c0671405be");
var isPromise = require("fe54edbcfbee4a28");
var isScalarAndEqual = require("e6b100b95199cf27");
var recycleNodesInto = require("82fee06f336d4fe5");
var RelayConcreteNode = require("50ed2f684de7b1fc");
var RelayDefaultHandleKey = require("16365d33d7b18392");
var RelayError = require("8ec4ed35d2d0a290");
var RelayFeatureFlags = require("1a57c1a19b29c571");
var RelayProfiler = require("de6ed554b2abd02b");
var RelayReplaySubject = require("d12459c61eaba2e5");
var stableCopy = require("342ba6a8b0e785c6");
var withProvidedVariables = require("da70b8312ac5832");
var mapStr, setStr, promiseStr, objStr;
module.exports = {
    Environment: RelayModernEnvironment,
    Network: RelayNetwork,
    Observable: RelayObservable,
    QueryResponseCache: RelayQueryResponseCache,
    RecordSource: RelayRecordSource,
    Record: RelayModernRecord,
    ReplaySubject: RelayReplaySubject,
    Store: RelayModernStore,
    areEqualSelectors: RelayModernSelector.areEqualSelectors,
    createFragmentSpecResolver: createFragmentSpecResolver,
    createNormalizationSelector: RelayModernSelector.createNormalizationSelector,
    createOperationDescriptor: RelayModernOperationDescriptor.createOperationDescriptor,
    createReaderSelector: RelayModernSelector.createReaderSelector,
    createRequestDescriptor: RelayModernOperationDescriptor.createRequestDescriptor,
    getArgumentValues: RelayStoreUtils.getArgumentValues,
    getDataIDsFromFragment: RelayModernSelector.getDataIDsFromFragment,
    getDataIDsFromObject: RelayModernSelector.getDataIDsFromObject,
    getNode: GraphQLTag.getNode,
    getFragment: GraphQLTag.getFragment,
    getInlineDataFragment: GraphQLTag.getInlineDataFragment,
    getModuleComponentKey: RelayStoreUtils.getModuleComponentKey,
    getModuleOperationKey: RelayStoreUtils.getModuleOperationKey,
    getPaginationFragment: GraphQLTag.getPaginationFragment,
    getPluralSelector: RelayModernSelector.getPluralSelector,
    getRefetchableFragment: GraphQLTag.getRefetchableFragment,
    getRequest: GraphQLTag.getRequest,
    getRequestIdentifier: getRequestIdentifier,
    getSelector: RelayModernSelector.getSelector,
    getSelectorsFromObject: RelayModernSelector.getSelectorsFromObject,
    getSingularSelector: RelayModernSelector.getSingularSelector,
    getStorageKey: RelayStoreUtils.getStorageKey,
    getVariablesFromFragment: RelayModernSelector.getVariablesFromFragment,
    getVariablesFromObject: RelayModernSelector.getVariablesFromObject,
    getVariablesFromPluralFragment: RelayModernSelector.getVariablesFromPluralFragment,
    getVariablesFromSingularFragment: RelayModernSelector.getVariablesFromSingularFragment,
    handlePotentialSnapshotErrors: handlePotentialSnapshotErrors,
    graphql: GraphQLTag.graphql,
    isFragment: GraphQLTag.isFragment,
    isInlineDataFragment: GraphQLTag.isInlineDataFragment,
    isSuspenseSentinel: isSuspenseSentinel,
    suspenseSentinel: suspenseSentinel,
    isRequest: GraphQLTag.isRequest,
    readInlineData: readInlineData,
    MutationTypes: RelayDeclarativeMutationConfig.MutationTypes,
    RangeOperations: RelayDeclarativeMutationConfig.RangeOperations,
    DefaultHandlerProvider: RelayDefaultHandlerProvider,
    ConnectionHandler: ConnectionHandler,
    MutationHandlers: MutationHandlers,
    VIEWER_ID: ViewerPattern.VIEWER_ID,
    VIEWER_TYPE: ViewerPattern.VIEWER_TYPE,
    applyOptimisticMutation: applyOptimisticMutation,
    commitLocalUpdate: commitLocalUpdate,
    commitMutation: commitMutation,
    fetchQuery: fetchQuery,
    fetchQuery_DEPRECATED: fetchQuery_DEPRECATED,
    isRelayModernEnvironment: isRelayModernEnvironment,
    requestSubscription: requestSubscription,
    ConnectionInterface: ConnectionInterface,
    PreloadableQueryRegistry: PreloadableQueryRegistry,
    RelayProfiler: RelayProfiler,
    createPayloadFor3DField: createPayloadFor3DField,
    RelayConcreteNode: RelayConcreteNode,
    RelayError: RelayError,
    RelayFeatureFlags: RelayFeatureFlags,
    DEFAULT_HANDLE_KEY: RelayDefaultHandleKey.DEFAULT_HANDLE_KEY,
    FRAGMENTS_KEY: RelayStoreUtils.FRAGMENTS_KEY,
    FRAGMENT_OWNER_KEY: RelayStoreUtils.FRAGMENT_OWNER_KEY,
    ID_KEY: RelayStoreUtils.ID_KEY,
    REF_KEY: RelayStoreUtils.REF_KEY,
    REFS_KEY: RelayStoreUtils.REFS_KEY,
    ROOT_ID: RelayStoreUtils.ROOT_ID,
    ROOT_TYPE: RelayStoreUtils.ROOT_TYPE,
    TYPENAME_KEY: RelayStoreUtils.TYPENAME_KEY,
    deepFreeze: deepFreeze,
    generateClientID: generateClientID,
    generateUniqueClientID: generateUniqueClientID,
    getRelayHandleKey: getRelayHandleKey,
    isClientID: isClientID,
    isPromise: isPromise,
    isScalarAndEqual: isScalarAndEqual,
    recycleNodesInto: recycleNodesInto,
    stableCopy: stableCopy,
    getFragmentIdentifier: getFragmentIdentifier,
    getRefetchMetadata: getRefetchMetadata,
    getPaginationMetadata: getPaginationMetadata,
    getPaginationVariables: getPaginationVariables,
    getPendingOperationsForFragment: getPendingOperationsForFragment,
    getValueAtPath: getValueAtPath,
    __internal: {
        ResolverFragments: ResolverFragments,
        OperationTracker: RelayOperationTracker,
        createRelayContext: createRelayContext,
        getOperationVariables: RelayConcreteVariables.getOperationVariables,
        getLocalVariables: RelayConcreteVariables.getLocalVariables,
        fetchQuery: fetchQueryInternal.fetchQuery,
        fetchQueryDeduped: fetchQueryInternal.fetchQueryDeduped,
        getPromiseForActiveRequest: fetchQueryInternal.getPromiseForActiveRequest,
        getObservableForActiveRequest: fetchQueryInternal.getObservableForActiveRequest,
        normalizeResponse: normalizeResponse,
        withProvidedVariables: withProvidedVariables
    }
};

},{"8188ae2e22062c04":"ccBOd","9878f12e4d57f49f":"dTLQR","9ab0fc1b93a027fe":"egZkc","a0ca36000bc16662":"kUOrY","1a19e12b86ca7844":"8KmZz","249b083be6ee863f":"5KZg6","b99aa80d9a0f8cb9":"1H0OQ","3039a513d5fd5c6":"1lmKe","110ec4dc4df70756":"gtE7n","2a50dda6bedbe7de":"hYmcP","b7d8d322db70f6c":"ejl8F","f836796860310832":"khAY2","1164e0aeaab3f350":"jMRnb","735ae29e1c255fcf":"75uB6","4914aafb5f3fdc68":"8UTII","6600e0465f3a778e":"kmRfk","34fb914551b4365e":"gL1rB","438470f4c2d195c5":"84PBa","8860e6a31fdca9c4":"fJ0BV","60fcdad1852680f7":"kMvlq","6a763e3c852564b8":"bBdVI","65fc2de8cd60932e":"afJiB","567eda9de309f218":"6Td1y","dfffbd41fc70cd39":"138Hd","e2b118780d500de1":"3xHmQ","6b8a7600cdf84a63":"dSeB3","355a821958e8c4e8":"daXOB","6a9e7721dfd9f016":"9k2Dg","3e7f0bba202ee3c7":"UtVKb","a644e396eae6af3b":"5bEuR","1fd48de7cb8e9c88":"6w3KR","b906b813921f2c6d":"3QcrW","ab3e6d75921916ac":"1JmVd","b5d41abd377e2ca0":"i6PYa","93b238f47c124377":"7OgOE","2608344a99e76af0":"7pZoN","1893916e3ddf485c":"eLea7","405665a0329d4c8d":"giGUC","80ac10e2a73c55ca":"idmUY","b635b62bc4b2ab16":"f4llA","905d206ed7fa2839":"ak3d6","7de8e63f749f7420":"5aHRx","21962ba74ccc19f2":"etrZd","478040846eca158a":"h3zzW","9f140c3040d5a746":"6JAxU","219749c0671405be":"kq97W","fe54edbcfbee4a28":"8csDP","e6b100b95199cf27":"fysSA","82fee06f336d4fe5":"ij1IQ","50ed2f684de7b1fc":"jKskk","16365d33d7b18392":"bYgdD","8ec4ed35d2d0a290":"fAMd2","1a57c1a19b29c571":"a0FL5","de6ed554b2abd02b":"j0ygY","d12459c61eaba2e5":"8ePJJ","342ba6a8b0e785c6":"c3NLR","da70b8312ac5832":"1N2Sg"}],"ccBOd":[function(require,module,exports,__globalThis) {
'use strict';
var _require = require("60e01bbce22327e7"), generateClientID = _require.generateClientID;
var _require2 = require("7c959de913c78b67"), getStableStorageKey = _require2.getStableStorageKey;
var getRelayHandleKey = require("4cdb8a1175ec60a0");
var ConnectionInterface = require("7d8f562c63fa1740");
var invariant = require("d275f1a0937a36df");
var warning = require("7e269e3fc97eb8c8");
var CONNECTION = 'connection';
var NEXT_EDGE_INDEX = '__connection_next_edge_index';
function update(store, payload) {
    var record = store.get(payload.dataID);
    if (!record) return;
    var _ConnectionInterface$ = ConnectionInterface.get(), EDGES = _ConnectionInterface$.EDGES, END_CURSOR = _ConnectionInterface$.END_CURSOR, HAS_NEXT_PAGE = _ConnectionInterface$.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$.HAS_PREV_PAGE, PAGE_INFO = _ConnectionInterface$.PAGE_INFO, PAGE_INFO_TYPE = _ConnectionInterface$.PAGE_INFO_TYPE, START_CURSOR = _ConnectionInterface$.START_CURSOR;
    var serverConnection = record.getLinkedRecord(payload.fieldKey);
    var serverPageInfo = serverConnection && serverConnection.getLinkedRecord(PAGE_INFO);
    if (!serverConnection) {
        record.setValue(null, payload.handleKey);
        return;
    }
    var clientConnectionID = generateClientID(record.getDataID(), payload.handleKey);
    var clientConnectionField = record.getLinkedRecord(payload.handleKey);
    var clientConnection = clientConnectionField !== null && clientConnectionField !== void 0 ? clientConnectionField : store.get(clientConnectionID);
    var clientPageInfo = clientConnection && clientConnection.getLinkedRecord(PAGE_INFO);
    if (!clientConnection) {
        var connection = store.create(clientConnectionID, serverConnection.getType());
        connection.setValue(0, NEXT_EDGE_INDEX);
        connection.copyFieldsFrom(serverConnection);
        var serverEdges = serverConnection.getLinkedRecords(EDGES);
        if (serverEdges) {
            serverEdges = serverEdges.map(function(edge) {
                return buildConnectionEdge(store, connection, edge);
            });
            connection.setLinkedRecords(serverEdges, EDGES);
        }
        record.setLinkedRecord(connection, payload.handleKey);
        clientPageInfo = store.create(generateClientID(connection.getDataID(), PAGE_INFO), PAGE_INFO_TYPE);
        clientPageInfo.setValue(false, HAS_NEXT_PAGE);
        clientPageInfo.setValue(false, HAS_PREV_PAGE);
        clientPageInfo.setValue(null, END_CURSOR);
        clientPageInfo.setValue(null, START_CURSOR);
        if (serverPageInfo) clientPageInfo.copyFieldsFrom(serverPageInfo);
        connection.setLinkedRecord(clientPageInfo, PAGE_INFO);
    } else {
        if (clientConnectionField == null) record.setLinkedRecord(clientConnection, payload.handleKey);
        var _connection = clientConnection;
        var _serverEdges = serverConnection.getLinkedRecords(EDGES);
        if (_serverEdges) _serverEdges = _serverEdges.map(function(edge) {
            return buildConnectionEdge(store, _connection, edge);
        });
        var prevEdges = _connection.getLinkedRecords(EDGES);
        var prevPageInfo = _connection.getLinkedRecord(PAGE_INFO);
        _connection.copyFieldsFrom(serverConnection);
        if (prevEdges) _connection.setLinkedRecords(prevEdges, EDGES);
        if (prevPageInfo) _connection.setLinkedRecord(prevPageInfo, PAGE_INFO);
        var nextEdges = [];
        var args = payload.args;
        if (prevEdges && _serverEdges) {
            if (args.after != null) {
                var _clientPageInfo;
                var clientEndCursor = (_clientPageInfo = clientPageInfo) === null || _clientPageInfo === void 0 ? void 0 : _clientPageInfo.getValue(END_CURSOR);
                var serverEndCursor = serverPageInfo === null || serverPageInfo === void 0 ? void 0 : serverPageInfo.getValue(END_CURSOR);
                var isAddingEdgesAfterCurrentPage = clientPageInfo && args.after === clientEndCursor;
                var isFillingOutCurrentPage = clientPageInfo && clientEndCursor === serverEndCursor;
                if (isAddingEdgesAfterCurrentPage || isFillingOutCurrentPage) {
                    var nodeIDs = new Set();
                    mergeEdges(prevEdges, nextEdges, nodeIDs);
                    mergeEdges(_serverEdges, nextEdges, nodeIDs);
                } else return;
            } else if (args.before != null) {
                if (clientPageInfo && args.before === clientPageInfo.getValue(START_CURSOR)) {
                    var _nodeIDs = new Set();
                    mergeEdges(_serverEdges, nextEdges, _nodeIDs);
                    mergeEdges(prevEdges, nextEdges, _nodeIDs);
                } else return;
            } else nextEdges = _serverEdges;
        } else if (_serverEdges) nextEdges = _serverEdges;
        else nextEdges = prevEdges;
        if (nextEdges != null && nextEdges !== prevEdges) _connection.setLinkedRecords(nextEdges, EDGES);
        if (clientPageInfo && serverPageInfo) {
            if (args.after == null && args.before == null) clientPageInfo.copyFieldsFrom(serverPageInfo);
            else if (args.before != null || args.after == null && args.last) {
                clientPageInfo.setValue(!!serverPageInfo.getValue(HAS_PREV_PAGE), HAS_PREV_PAGE);
                var startCursor = serverPageInfo.getValue(START_CURSOR);
                if (typeof startCursor === 'string') clientPageInfo.setValue(startCursor, START_CURSOR);
            } else if (args.after != null || args.before == null && args.first) {
                clientPageInfo.setValue(!!serverPageInfo.getValue(HAS_NEXT_PAGE), HAS_NEXT_PAGE);
                var endCursor = serverPageInfo.getValue(END_CURSOR);
                if (typeof endCursor === 'string') clientPageInfo.setValue(endCursor, END_CURSOR);
            }
        }
    }
}
function getConnection(record, key, filters) {
    var handleKey = getRelayHandleKey(CONNECTION, key, null);
    return record.getLinkedRecord(handleKey, filters);
}
function getConnectionID(recordID, key, filters) {
    var handleKey = getRelayHandleKey(CONNECTION, key, null);
    var storageKey = getStableStorageKey(handleKey, filters);
    return generateClientID(recordID, storageKey);
}
function insertEdgeAfter(record, newEdge, cursor) {
    var _ConnectionInterface$2 = ConnectionInterface.get(), CURSOR = _ConnectionInterface$2.CURSOR, EDGES = _ConnectionInterface$2.EDGES;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) {
        record.setLinkedRecords([
            newEdge
        ], EDGES);
        return;
    }
    var nextEdges;
    if (cursor == null) nextEdges = edges.concat(newEdge);
    else {
        nextEdges = [];
        var foundCursor = false;
        for(var ii = 0; ii < edges.length; ii++){
            var edge = edges[ii];
            nextEdges.push(edge);
            if (edge == null) continue;
            var edgeCursor = edge.getValue(CURSOR);
            if (cursor === edgeCursor) {
                nextEdges.push(newEdge);
                foundCursor = true;
            }
        }
        if (!foundCursor) nextEdges.push(newEdge);
    }
    record.setLinkedRecords(nextEdges, EDGES);
}
function createEdge(store, record, node, edgeType) {
    var _ConnectionInterface$3 = ConnectionInterface.get(), NODE = _ConnectionInterface$3.NODE;
    var edgeID = generateClientID(record.getDataID(), node.getDataID());
    var edge = store.get(edgeID);
    if (!edge) edge = store.create(edgeID, edgeType);
    edge.setLinkedRecord(node, NODE);
    if (edge.getValue('cursor') == null) edge.setValue(null, 'cursor');
    return edge;
}
function insertEdgeBefore(record, newEdge, cursor) {
    var _ConnectionInterface$4 = ConnectionInterface.get(), CURSOR = _ConnectionInterface$4.CURSOR, EDGES = _ConnectionInterface$4.EDGES;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) {
        record.setLinkedRecords([
            newEdge
        ], EDGES);
        return;
    }
    var nextEdges;
    if (cursor == null) nextEdges = [
        newEdge
    ].concat(edges);
    else {
        nextEdges = [];
        var foundCursor = false;
        for(var ii = 0; ii < edges.length; ii++){
            var edge = edges[ii];
            if (edge != null) {
                var edgeCursor = edge.getValue(CURSOR);
                if (cursor === edgeCursor) {
                    nextEdges.push(newEdge);
                    foundCursor = true;
                }
            }
            nextEdges.push(edge);
        }
        if (!foundCursor) nextEdges.unshift(newEdge);
    }
    record.setLinkedRecords(nextEdges, EDGES);
}
function deleteNode(record, nodeID) {
    var _ConnectionInterface$5 = ConnectionInterface.get(), EDGES = _ConnectionInterface$5.EDGES, NODE = _ConnectionInterface$5.NODE;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) return;
    var nextEdges;
    for(var ii = 0; ii < edges.length; ii++){
        var edge = edges[ii];
        var node = edge && edge.getLinkedRecord(NODE);
        if (node != null && node.getDataID() === nodeID) {
            if (nextEdges === undefined) nextEdges = edges.slice(0, ii);
        } else if (nextEdges !== undefined) nextEdges.push(edge);
    }
    if (nextEdges !== undefined) record.setLinkedRecords(nextEdges, EDGES);
}
function buildConnectionEdge(store, connection, edge) {
    if (edge == null) return edge;
    var _ConnectionInterface$6 = ConnectionInterface.get(), EDGES = _ConnectionInterface$6.EDGES;
    var edgeIndex = connection.getValue(NEXT_EDGE_INDEX);
    !(typeof edgeIndex === 'number') && invariant(false);
    var edgeID = generateClientID(connection.getDataID(), EDGES, edgeIndex);
    var connectionEdge = store.create(edgeID, edge.getType());
    connectionEdge.copyFieldsFrom(edge);
    if (connectionEdge.getValue('cursor') == null) connectionEdge.setValue(null, 'cursor');
    connection.setValue(edgeIndex + 1, NEXT_EDGE_INDEX);
    return connectionEdge;
}
function mergeEdges(sourceEdges, targetEdges, nodeIDs) {
    var _ConnectionInterface$7 = ConnectionInterface.get(), NODE = _ConnectionInterface$7.NODE;
    for(var ii = 0; ii < sourceEdges.length; ii++){
        var edge = sourceEdges[ii];
        if (!edge) continue;
        var node = edge.getLinkedRecord(NODE);
        var nodeID = node && node.getDataID();
        if (nodeID) {
            if (nodeIDs.has(nodeID)) continue;
            nodeIDs.add(nodeID);
        }
        targetEdges.push(edge);
    }
}
module.exports = {
    buildConnectionEdge: buildConnectionEdge,
    createEdge: createEdge,
    deleteNode: deleteNode,
    getConnection: getConnection,
    getConnectionID: getConnectionID,
    insertEdgeAfter: insertEdgeAfter,
    insertEdgeBefore: insertEdgeBefore,
    update: update
};

},{"60e01bbce22327e7":"gL1rB","7c959de913c78b67":"3QcrW","4cdb8a1175ec60a0":"etrZd","7d8f562c63fa1740":"dTLQR","d275f1a0937a36df":"e2sci","7e269e3fc97eb8c8":"j64TH"}],"gL1rB":[function(require,module,exports,__globalThis) {
'use strict';
var RelayFeatureFlags = require("85e38f231a95ca06");
var _require = require("5e0db616cadc2e46"), intern = _require.intern;
var PREFIX = 'client:';
function generateClientID(id, storageKey, index) {
    var internedId = RelayFeatureFlags.STRING_INTERN_LEVEL <= 0 ? id : intern(id, RelayFeatureFlags.MAX_DATA_ID_LENGTH);
    var key = internedId + ':' + storageKey;
    if (index != null) key += ':' + index;
    if (key.indexOf(PREFIX) !== 0) key = PREFIX + key;
    return key;
}
function isClientID(id) {
    return id.indexOf(PREFIX) === 0;
}
var localID = 0;
function generateUniqueClientID() {
    return "".concat(PREFIX, "local:").concat(localID++);
}
function generateClientObjectClientID(typename, localId, index) {
    var key = "".concat(PREFIX).concat(typename, ":").concat(localId);
    if (index != null) key += ':' + index;
    return key;
}
module.exports = {
    generateClientID: generateClientID,
    generateClientObjectClientID: generateClientObjectClientID,
    generateUniqueClientID: generateUniqueClientID,
    isClientID: isClientID
};

},{"85e38f231a95ca06":"a0FL5","5e0db616cadc2e46":"3S1QY"}],"a0FL5":[function(require,module,exports,__globalThis) {
'use strict';
var RelayFeatureFlags = {
    ENABLE_VARIABLE_CONNECTION_KEY: false,
    ENABLE_RELAY_RESOLVERS: false,
    ENABLE_GETFRAGMENTIDENTIFIER_OPTIMIZATION: false,
    ENABLE_FRIENDLY_QUERY_NAME_GQL_URL: false,
    ENABLE_LOAD_QUERY_REQUEST_DEDUPING: true,
    ENABLE_DO_NOT_WRAP_LIVE_QUERY: false,
    ENABLE_NOTIFY_SUBSCRIPTION: false,
    BATCH_ASYNC_MODULE_UPDATES_FN: null,
    ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT: false,
    MAX_DATA_ID_LENGTH: null,
    STRING_INTERN_LEVEL: 0,
    LOG_MISSING_RECORDS_IN_PROD: false,
    ENABLE_LOOSE_SUBSCRIPTION_ATTRIBUTION: false,
    ENABLE_OPERATION_TRACKER_OPTIMISTIC_UPDATES: false,
    ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE: false,
    ENABLE_FIELD_ERROR_HANDLING: false,
    ENABLE_FIELD_ERROR_HANDLING_THROW_BY_DEFAULT: false,
    ENABLE_FIELD_ERROR_HANDLING_CATCH_DIRECTIVE: false,
    PROCESS_OPTIMISTIC_UPDATE_BEFORE_SUBSCRIPTION: false,
    MARK_RESOLVER_VALUES_AS_CLEAN_AFTER_FRAGMENT_REREAD: false
};
module.exports = RelayFeatureFlags;

},{}],"3S1QY":[function(require,module,exports,__globalThis) {
'use strict';
var internTable = new Map();
var nextIndex = 1;
var digits = initDigitTable();
var INTERN_PREFIX = '\t';
var ESCAPE_PREFIX = '\v';
function initDigitTable() {
    var digits = new Set();
    for(var i = 0; i < 10; ++i)digits.add(i.toString());
    return digits;
}
function escape(str) {
    if (str[0] === INTERN_PREFIX && digits.has(str[1]) || str[0] === ESCAPE_PREFIX) return ESCAPE_PREFIX + str;
    return str;
}
function intern(str, limit) {
    if (limit == null || str.length < limit) return escape(str);
    var internedString = internTable.get(str);
    if (internedString != null) return internedString;
    internedString = INTERN_PREFIX + nextIndex++;
    internTable.set(str, internedString);
    return internedString;
}
module.exports = {
    intern: intern
};

},{}],"3QcrW":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("9b76c7721777306c")["default"];
var _toConsumableArray2 = _interopRequireDefault(require("a8d0283c12d1f4b7"));
var getRelayHandleKey = require("3c291ab4f1767305");
var RelayConcreteNode = require("95e06ba53de00388");
var stableCopy = require("cd76dd17e18dd8c3");
var invariant = require("16b3884f510a8fd8");
var VARIABLE = RelayConcreteNode.VARIABLE, LITERAL = RelayConcreteNode.LITERAL, OBJECT_VALUE = RelayConcreteNode.OBJECT_VALUE, LIST_VALUE = RelayConcreteNode.LIST_VALUE;
var ERRORS_KEY = '__errors';
var MODULE_COMPONENT_KEY_PREFIX = '__module_component_';
var MODULE_OPERATION_KEY_PREFIX = '__module_operation_';
function getArgumentValue(arg, variables) {
    if (arg.kind === VARIABLE) return getStableVariableValue(arg.variableName, variables);
    else if (arg.kind === LITERAL) return arg.value;
    else if (arg.kind === OBJECT_VALUE) {
        var value = {};
        arg.fields.forEach(function(field) {
            value[field.name] = getArgumentValue(field, variables);
        });
        return value;
    } else if (arg.kind === LIST_VALUE) {
        var _value = [];
        arg.items.forEach(function(item) {
            item != null && _value.push(getArgumentValue(item, variables));
        });
        return _value;
    }
}
function getArgumentValues(args, variables, isWithinUnmatchedTypeRefinement) {
    var values = {};
    if (isWithinUnmatchedTypeRefinement) values[RelayStoreUtils.FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT] = true;
    if (args) args.forEach(function(arg) {
        values[arg.name] = getArgumentValue(arg, variables);
    });
    return values;
}
function getHandleStorageKey(handleField, variables) {
    var dynamicKey = handleField.dynamicKey, handle = handleField.handle, key = handleField.key, name = handleField.name, args = handleField.args, filters = handleField.filters;
    var handleName = getRelayHandleKey(handle, key, name);
    var filterArgs = null;
    if (args && filters && args.length !== 0 && filters.length !== 0) filterArgs = args.filter(function(arg) {
        return filters.indexOf(arg.name) > -1;
    });
    if (dynamicKey) filterArgs = filterArgs != null ? [
        dynamicKey
    ].concat((0, _toConsumableArray2["default"])(filterArgs)) : [
        dynamicKey
    ];
    if (filterArgs === null) return handleName;
    else return formatStorageKey(handleName, getArgumentValues(filterArgs, variables));
}
function getStorageKey(field, variables) {
    if (field.storageKey) return field.storageKey;
    var args = getArguments(field);
    var name = field.name;
    return args && args.length !== 0 ? formatStorageKey(name, getArgumentValues(args, variables)) : name;
}
function getArguments(field) {
    if (field.kind === 'RelayResolver' || field.kind === 'RelayLiveResolver') {
        var _field$fragment2;
        if (field.args == null) {
            var _field$fragment;
            return (_field$fragment = field.fragment) === null || _field$fragment === void 0 ? void 0 : _field$fragment.args;
        }
        if (((_field$fragment2 = field.fragment) === null || _field$fragment2 === void 0 ? void 0 : _field$fragment2.args) == null) return field.args;
        return field.args.concat(field.fragment.args);
    }
    var args = typeof field.args === 'undefined' ? undefined : field.args;
    return args;
}
function getStableStorageKey(name, args) {
    return formatStorageKey(name, stableCopy(args));
}
function formatStorageKey(name, argValues) {
    if (!argValues) return name;
    var values = [];
    for(var argName in argValues)if (argValues.hasOwnProperty(argName)) {
        var value = argValues[argName];
        if (value != null) {
            var _JSON$stringify;
            values.push(argName + ':' + ((_JSON$stringify = JSON.stringify(value)) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : 'undefined'));
        }
    }
    return values.length === 0 ? name : name + "(".concat(values.join(','), ")");
}
function getStableVariableValue(name, variables) {
    !variables.hasOwnProperty(name) && invariant(false);
    return stableCopy(variables[name]);
}
function getModuleComponentKey(documentName) {
    return "".concat(MODULE_COMPONENT_KEY_PREFIX).concat(documentName);
}
function getModuleOperationKey(documentName) {
    return "".concat(MODULE_OPERATION_KEY_PREFIX).concat(documentName);
}
var RelayStoreUtils = {
    ACTOR_IDENTIFIER_KEY: '__actorIdentifier',
    CLIENT_EDGE_TRAVERSAL_PATH: '__clientEdgeTraversalPath',
    FRAGMENTS_KEY: '__fragments',
    FRAGMENT_OWNER_KEY: '__fragmentOwner',
    FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT: '$isWithinUnmatchedTypeRefinement',
    FRAGMENT_PROP_NAME_KEY: '__fragmentPropName',
    MODULE_COMPONENT_KEY: '__module_component',
    ERRORS_KEY: ERRORS_KEY,
    ID_KEY: '__id',
    REF_KEY: '__ref',
    REFS_KEY: '__refs',
    ROOT_ID: 'client:root',
    ROOT_TYPE: '__Root',
    TYPENAME_KEY: '__typename',
    INVALIDATED_AT_KEY: '__invalidated_at',
    RELAY_RESOLVER_VALUE_KEY: '__resolverValue',
    RELAY_RESOLVER_INVALIDATION_KEY: '__resolverValueMayBeInvalid',
    RELAY_RESOLVER_SNAPSHOT_KEY: '__resolverSnapshot',
    RELAY_RESOLVER_ERROR_KEY: '__resolverError',
    RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS: '__resolverOutputTypeRecordIDs',
    formatStorageKey: formatStorageKey,
    getArgumentValue: getArgumentValue,
    getArgumentValues: getArgumentValues,
    getHandleStorageKey: getHandleStorageKey,
    getStorageKey: getStorageKey,
    getStableStorageKey: getStableStorageKey,
    getModuleComponentKey: getModuleComponentKey,
    getModuleOperationKey: getModuleOperationKey
};
module.exports = RelayStoreUtils;

},{"9b76c7721777306c":"590td","a8d0283c12d1f4b7":"7EBX0","3c291ab4f1767305":"etrZd","95e06ba53de00388":"jKskk","cd76dd17e18dd8c3":"c3NLR","16b3884f510a8fd8":"e2sci"}],"590td":[function(require,module,exports,__globalThis) {
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"7EBX0":[function(require,module,exports,__globalThis) {
var arrayWithoutHoles = require("fd560f157b55f0e0");
var iterableToArray = require("ec0ff5d363fedfed");
var unsupportedIterableToArray = require("d80187be8dc82286");
var nonIterableSpread = require("9b8d6603e51a38ae");
function _toConsumableArray(r) {
    return arrayWithoutHoles(r) || iterableToArray(r) || unsupportedIterableToArray(r) || nonIterableSpread();
}
module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"fd560f157b55f0e0":"8kYNU","ec0ff5d363fedfed":"dzwW5","d80187be8dc82286":"i55CV","9b8d6603e51a38ae":"aASV2"}],"8kYNU":[function(require,module,exports,__globalThis) {
var arrayLikeToArray = require("9be48c8bb8238bc0");
function _arrayWithoutHoles(r) {
    if (Array.isArray(r)) return arrayLikeToArray(r);
}
module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"9be48c8bb8238bc0":"ew5Gq"}],"ew5Gq":[function(require,module,exports,__globalThis) {
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"dzwW5":[function(require,module,exports,__globalThis) {
function _iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"i55CV":[function(require,module,exports,__globalThis) {
var arrayLikeToArray = require("9593e59e64aac430");
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? arrayLikeToArray(r, a) : void 0;
    }
}
module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"9593e59e64aac430":"ew5Gq"}],"aASV2":[function(require,module,exports,__globalThis) {
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"etrZd":[function(require,module,exports,__globalThis) {
'use strict';
var _require = require("cf78938049ab07ef"), DEFAULT_HANDLE_KEY = _require.DEFAULT_HANDLE_KEY;
var invariant = require("cfa400fca0a44e4a");
function getRelayHandleKey(handleName, key, fieldName) {
    if (key && key !== DEFAULT_HANDLE_KEY) return "__".concat(key, "_").concat(handleName);
    !(fieldName != null) && invariant(false);
    return "__".concat(fieldName, "_").concat(handleName);
}
module.exports = getRelayHandleKey;

},{"cf78938049ab07ef":"bYgdD","cfa400fca0a44e4a":"e2sci"}],"bYgdD":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = {
    DEFAULT_HANDLE_KEY: ''
};

},{}],"e2sci":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var invariant = function invariant(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
module.exports = invariant;

},{}],"jKskk":[function(require,module,exports,__globalThis) {
'use strict';
var RelayConcreteNode = {
    ACTOR_CHANGE: 'ActorChange',
    CATCH_FIELD: 'CatchField',
    CONDITION: 'Condition',
    CLIENT_COMPONENT: 'ClientComponent',
    CLIENT_EDGE_TO_SERVER_OBJECT: 'ClientEdgeToServerObject',
    CLIENT_EDGE_TO_CLIENT_OBJECT: 'ClientEdgeToClientObject',
    CLIENT_EXTENSION: 'ClientExtension',
    DEFER: 'Defer',
    CONNECTION: 'Connection',
    FRAGMENT: 'Fragment',
    FRAGMENT_SPREAD: 'FragmentSpread',
    INLINE_DATA_FRAGMENT_SPREAD: 'InlineDataFragmentSpread',
    INLINE_DATA_FRAGMENT: 'InlineDataFragment',
    INLINE_FRAGMENT: 'InlineFragment',
    LINKED_FIELD: 'LinkedField',
    LINKED_HANDLE: 'LinkedHandle',
    LITERAL: 'Literal',
    LIST_VALUE: 'ListValue',
    LOCAL_ARGUMENT: 'LocalArgument',
    MODULE_IMPORT: 'ModuleImport',
    ALIASED_FRAGMENT_SPREAD: 'AliasedFragmentSpread',
    ALIASED_INLINE_FRAGMENT_SPREAD: 'AliasedInlineFragmentSpread',
    RELAY_RESOLVER: 'RelayResolver',
    RELAY_LIVE_RESOLVER: 'RelayLiveResolver',
    REQUIRED_FIELD: 'RequiredField',
    OBJECT_VALUE: 'ObjectValue',
    OPERATION: 'Operation',
    REQUEST: 'Request',
    ROOT_ARGUMENT: 'RootArgument',
    SCALAR_FIELD: 'ScalarField',
    SCALAR_HANDLE: 'ScalarHandle',
    SPLIT_OPERATION: 'SplitOperation',
    STREAM: 'Stream',
    TYPE_DISCRIMINATOR: 'TypeDiscriminator',
    UPDATABLE_QUERY: 'UpdatableQuery',
    VARIABLE: 'Variable'
};
module.exports = RelayConcreteNode;

},{}],"c3NLR":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
function stableCopy(value) {
    if (!value || (typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) !== 'object') return value;
    if (Array.isArray(value)) return value.map(stableCopy);
    var keys = Object.keys(value).sort();
    var stable = {};
    for(var i = 0; i < keys.length; i++)stable[keys[i]] = stableCopy(value[keys[i]]);
    return stable;
}
module.exports = stableCopy;

},{"@swc/helpers/_/_type_of":"iFJdx"}],"dTLQR":[function(require,module,exports,__globalThis) {
'use strict';
var CONNECTION_CALLS = {
    after: true,
    before: true,
    find: true,
    first: true,
    last: true,
    surrounds: true
};
var config = {
    CURSOR: 'cursor',
    EDGES: 'edges',
    END_CURSOR: 'endCursor',
    HAS_NEXT_PAGE: 'hasNextPage',
    HAS_PREV_PAGE: 'hasPreviousPage',
    NODE: 'node',
    PAGE_INFO_TYPE: 'PageInfo',
    PAGE_INFO: 'pageInfo',
    START_CURSOR: 'startCursor'
};
var ConnectionInterface = {
    inject: function inject(newConfig) {
        config = newConfig;
    },
    get: function get() {
        return config;
    },
    isConnectionCall: function isConnectionCall(call) {
        return CONNECTION_CALLS.hasOwnProperty(call.name);
    }
};
module.exports = ConnectionInterface;

},{}],"j64TH":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 'use strict';
var emptyFunction = require("26da6f212d2c65fc");
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ function printWarning(format) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function() {
        return args[argIndex++];
    });
    if (typeof console !== 'undefined') console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
}
var warning = emptyFunction;
module.exports = warning;

},{"26da6f212d2c65fc":"caHn0"}],"caHn0":[function(require,module,exports,__globalThis) {
"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ function makeEmptyFunction(arg) {
    return function() {
        return arg;
    };
}
/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */ var emptyFunction = function emptyFunction() {};
emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function() {
    return this;
};
emptyFunction.thatReturnsArgument = function(arg) {
    return arg;
};
module.exports = emptyFunction;

},{}],"egZkc":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("d03d157df1d0d577")["default"];
var _createForOfIteratorHelper2 = _interopRequireDefault(require("96c1c2c1aed03328"));
var ConnectionHandler = require("eee31943aaa350cd");
var ConnectionInterface = require("b5bc3a6bee25ed35");
var invariant = require("16aa9c711c3df27");
var warning = require("2a351171c9e5f420");
var DeleteRecordHandler = {
    update: function update(store, payload) {
        var record = store.get(payload.dataID);
        if (record != null) {
            var idOrIds = record.getValue(payload.fieldKey);
            if (typeof idOrIds === 'string') store["delete"](idOrIds);
            else if (Array.isArray(idOrIds)) idOrIds.forEach(function(id) {
                if (typeof id === 'string') store["delete"](id);
            });
        }
    }
};
var DeleteEdgeHandler = {
    update: function update(store, payload) {
        var record = store.get(payload.dataID);
        if (record == null) return;
        var connections = payload.handleArgs.connections;
        !(connections != null) && invariant(false);
        var idOrIds = record.getValue(payload.fieldKey);
        var idList = Array.isArray(idOrIds) ? idOrIds : [
            idOrIds
        ];
        idList.forEach(function(id) {
            if (typeof id === 'string') {
                var _iterator = (0, _createForOfIteratorHelper2["default"])(connections), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var connectionID = _step.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        ConnectionHandler.deleteNode(connection, id);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
        });
    }
};
var AppendEdgeHandler = {
    update: edgeUpdater(ConnectionHandler.insertEdgeAfter)
};
var PrependEdgeHandler = {
    update: edgeUpdater(ConnectionHandler.insertEdgeBefore)
};
var AppendNodeHandler = {
    update: nodeUpdater(ConnectionHandler.insertEdgeAfter)
};
var PrependNodeHandler = {
    update: nodeUpdater(ConnectionHandler.insertEdgeBefore)
};
function edgeUpdater(insertFn) {
    return function(store, payload) {
        var _serverEdges;
        var record = store.get(payload.dataID);
        if (record == null) return;
        var connections = payload.handleArgs.connections;
        !(connections != null) && invariant(false);
        var singleServerEdge, serverEdges;
        try {
            singleServerEdge = record.getLinkedRecord(payload.fieldKey);
        } catch (_unused) {}
        if (!singleServerEdge) try {
            serverEdges = record.getLinkedRecords(payload.fieldKey);
        } catch (_unused2) {}
        if (singleServerEdge == null && serverEdges == null) return;
        var _ConnectionInterface$ = ConnectionInterface.get(), NODE = _ConnectionInterface$.NODE, EDGES = _ConnectionInterface$.EDGES;
        var serverEdgeList = (_serverEdges = serverEdges) !== null && _serverEdges !== void 0 ? _serverEdges : [
            singleServerEdge
        ];
        var _iterator2 = (0, _createForOfIteratorHelper2["default"])(serverEdgeList), _step2;
        try {
            var _loop = function _loop() {
                var serverEdge = _step2.value;
                if (serverEdge == null) return "continue";
                var serverNode = serverEdge.getLinkedRecord('node');
                if (!serverNode) return "continue";
                var serverNodeId = serverNode.getDataID();
                var _iterator3 = (0, _createForOfIteratorHelper2["default"])(connections), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var connectionID = _step3.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        var nodeAlreadyExistsInConnection = (_connection$getLinked = connection.getLinkedRecords(EDGES)) === null || _connection$getLinked === void 0 ? void 0 : _connection$getLinked.some(function(edge) {
                            var _edge$getLinkedRecord;
                            return (edge === null || edge === void 0 ? void 0 : (_edge$getLinkedRecord = edge.getLinkedRecord(NODE)) === null || _edge$getLinkedRecord === void 0 ? void 0 : _edge$getLinkedRecord.getDataID()) === serverNodeId;
                        });
                        if (nodeAlreadyExistsInConnection) continue;
                        var clientEdge = ConnectionHandler.buildConnectionEdge(store, connection, serverEdge);
                        !(clientEdge != null) && invariant(false);
                        insertFn(connection, clientEdge);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
            };
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var _connection$getLinked;
                var _ret = _loop();
                if (_ret === "continue") continue;
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
    };
}
function nodeUpdater(insertFn) {
    return function(store, payload) {
        var _serverNodes;
        var record = store.get(payload.dataID);
        if (record == null) return;
        var _payload$handleArgs = payload.handleArgs, connections = _payload$handleArgs.connections, edgeTypeName = _payload$handleArgs.edgeTypeName;
        !(connections != null) && invariant(false);
        !(edgeTypeName != null) && invariant(false);
        var singleServerNode;
        var serverNodes;
        try {
            singleServerNode = record.getLinkedRecord(payload.fieldKey);
        } catch (_unused3) {}
        if (!singleServerNode) try {
            serverNodes = record.getLinkedRecords(payload.fieldKey);
        } catch (_unused4) {}
        if (singleServerNode == null && serverNodes == null) return;
        var _ConnectionInterface$2 = ConnectionInterface.get(), NODE = _ConnectionInterface$2.NODE, EDGES = _ConnectionInterface$2.EDGES;
        var serverNodeList = (_serverNodes = serverNodes) !== null && _serverNodes !== void 0 ? _serverNodes : [
            singleServerNode
        ];
        var _iterator4 = (0, _createForOfIteratorHelper2["default"])(serverNodeList), _step4;
        try {
            var _loop2 = function _loop2() {
                var serverNode = _step4.value;
                if (serverNode == null) return "continue";
                var serverNodeId = serverNode.getDataID();
                var _iterator5 = (0, _createForOfIteratorHelper2["default"])(connections), _step5;
                try {
                    for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                        var connectionID = _step5.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        var nodeAlreadyExistsInConnection = (_connection$getLinked2 = connection.getLinkedRecords(EDGES)) === null || _connection$getLinked2 === void 0 ? void 0 : _connection$getLinked2.some(function(edge) {
                            var _edge$getLinkedRecord2;
                            return (edge === null || edge === void 0 ? void 0 : (_edge$getLinkedRecord2 = edge.getLinkedRecord(NODE)) === null || _edge$getLinkedRecord2 === void 0 ? void 0 : _edge$getLinkedRecord2.getDataID()) === serverNodeId;
                        });
                        if (nodeAlreadyExistsInConnection) continue;
                        var clientEdge = ConnectionHandler.createEdge(store, connection, serverNode, edgeTypeName);
                        !(clientEdge != null) && invariant(false);
                        insertFn(connection, clientEdge);
                    }
                } catch (err) {
                    _iterator5.e(err);
                } finally{
                    _iterator5.f();
                }
            };
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var _connection$getLinked2;
                var _ret2 = _loop2();
                if (_ret2 === "continue") continue;
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
    };
}
module.exports = {
    AppendEdgeHandler: AppendEdgeHandler,
    DeleteRecordHandler: DeleteRecordHandler,
    PrependEdgeHandler: PrependEdgeHandler,
    AppendNodeHandler: AppendNodeHandler,
    PrependNodeHandler: PrependNodeHandler,
    DeleteEdgeHandler: DeleteEdgeHandler
};

},{"d03d157df1d0d577":"590td","96c1c2c1aed03328":"fMaLa","eee31943aaa350cd":"ccBOd","b5bc3a6bee25ed35":"dTLQR","16aa9c711c3df27":"e2sci","2a351171c9e5f420":"j64TH"}],"fMaLa":[function(require,module,exports,__globalThis) {
var unsupportedIterableToArray = require("cc141f168bb6bdd6");
function _createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var _$r = t.next();
            return a = _$r.done, _$r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}
module.exports = _createForOfIteratorHelper, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"cc141f168bb6bdd6":"i55CV"}],"kUOrY":[function(require,module,exports,__globalThis) {
'use strict';
var ConnectionHandler = require("88ddeac36e255fd8");
var MutationHandlers = require("28e2d51bf435b8b1");
var invariant = require("9218549c1c36d1cd");
function RelayDefaultHandlerProvider(handle) {
    switch(handle){
        case 'connection':
            return ConnectionHandler;
        case 'deleteRecord':
            return MutationHandlers.DeleteRecordHandler;
        case 'deleteEdge':
            return MutationHandlers.DeleteEdgeHandler;
        case 'appendEdge':
            return MutationHandlers.AppendEdgeHandler;
        case 'prependEdge':
            return MutationHandlers.PrependEdgeHandler;
        case 'appendNode':
            return MutationHandlers.AppendNodeHandler;
        case 'prependNode':
            return MutationHandlers.PrependNodeHandler;
    }
    invariant(false);
}
module.exports = RelayDefaultHandlerProvider;

},{"88ddeac36e255fd8":"ccBOd","28e2d51bf435b8b1":"egZkc","9218549c1c36d1cd":"e2sci"}],"8KmZz":[function(require,module,exports,__globalThis) {
'use strict';
var _require = require("6f2594a96ed55953"), getRequest = _require.getRequest;
var isRelayModernEnvironment = require("964639c49853ca57");
var _require2 = require("64481f29b393a3ed"), createOperationDescriptor = _require2.createOperationDescriptor;
var RelayDeclarativeMutationConfig = require("cccbc2f618f05cbb");
var invariant = require("a2c09bbe09bb7322");
function applyOptimisticMutation(environment, config) {
    !isRelayModernEnvironment(environment) && invariant(false);
    var mutation = getRequest(config.mutation);
    if (mutation.params.operationKind !== 'mutation') throw new Error('commitMutation: Expected mutation operation');
    var optimisticUpdater = config.optimisticUpdater;
    var configs = config.configs, optimisticResponse = config.optimisticResponse, variables = config.variables;
    var operation = createOperationDescriptor(mutation, variables);
    if (configs) {
        var _RelayDeclarativeMuta = RelayDeclarativeMutationConfig.convert(configs, mutation, optimisticUpdater);
        optimisticUpdater = _RelayDeclarativeMuta.optimisticUpdater;
    }
    return environment.applyMutation({
        operation: operation,
        response: optimisticResponse,
        updater: optimisticUpdater
    });
}
module.exports = applyOptimisticMutation;

},{"6f2594a96ed55953":"8UTII","964639c49853ca57":"bBdVI","64481f29b393a3ed":"dSeB3","cccbc2f618f05cbb":"1lmKe","a2c09bbe09bb7322":"e2sci"}],"8UTII":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var RelayConcreteNode = require("215af52733b51617");
var invariant = require("105406c14db77d5");
var warning = require("67b4d2feca4bcbca");
function graphql(strings) {
    invariant(false);
}
function getNode(taggedNode) {
    var node = taggedNode;
    if (typeof node === 'function') node = node();
    else if (node["default"]) node = node["default"];
    return node;
}
function isFragment(node) {
    var fragment = getNode(node);
    return (typeof fragment === "undefined" ? "undefined" : (0, _typeOf._)(fragment)) === 'object' && fragment !== null && fragment.kind === RelayConcreteNode.FRAGMENT;
}
function isRequest(node) {
    var request = getNode(node);
    return (typeof request === "undefined" ? "undefined" : (0, _typeOf._)(request)) === 'object' && request !== null && request.kind === RelayConcreteNode.REQUEST;
}
function isUpdatableQuery(node) {
    var updatableQuery = getNode(node);
    return (typeof updatableQuery === "undefined" ? "undefined" : (0, _typeOf._)(updatableQuery)) === 'object' && updatableQuery !== null && updatableQuery.kind === RelayConcreteNode.UPDATABLE_QUERY;
}
function isInlineDataFragment(node) {
    var fragment = getNode(node);
    return (typeof fragment === "undefined" ? "undefined" : (0, _typeOf._)(fragment)) === 'object' && fragment !== null && fragment.kind === RelayConcreteNode.INLINE_DATA_FRAGMENT;
}
function getFragment(taggedNode) {
    var fragment = getNode(taggedNode);
    !isFragment(fragment) && invariant(false);
    return fragment;
}
function getPaginationFragment(taggedNode) {
    var _fragment$metadata;
    var fragment = getFragment(taggedNode);
    var refetch = (_fragment$metadata = fragment.metadata) === null || _fragment$metadata === void 0 ? void 0 : _fragment$metadata.refetch;
    var connection = refetch === null || refetch === void 0 ? void 0 : refetch.connection;
    if (refetch === null || (typeof refetch === "undefined" ? "undefined" : (0, _typeOf._)(refetch)) !== 'object' || connection === null || (typeof connection === "undefined" ? "undefined" : (0, _typeOf._)(connection)) !== 'object') return null;
    return fragment;
}
function getRefetchableFragment(taggedNode) {
    var _fragment$metadata2;
    var fragment = getFragment(taggedNode);
    var refetch = (_fragment$metadata2 = fragment.metadata) === null || _fragment$metadata2 === void 0 ? void 0 : _fragment$metadata2.refetch;
    if (refetch === null || (typeof refetch === "undefined" ? "undefined" : (0, _typeOf._)(refetch)) !== 'object') return null;
    return fragment;
}
function getRequest(taggedNode) {
    var request = getNode(taggedNode);
    !isRequest(request) && invariant(false);
    return request;
}
function getUpdatableQuery(taggedNode) {
    var updatableQuery = getNode(taggedNode);
    !isUpdatableQuery(updatableQuery) && invariant(false);
    return updatableQuery;
}
function getInlineDataFragment(taggedNode) {
    var fragment = getNode(taggedNode);
    !isInlineDataFragment(fragment) && invariant(false);
    return fragment;
}
module.exports = {
    getFragment: getFragment,
    getNode: getNode,
    getPaginationFragment: getPaginationFragment,
    getRefetchableFragment: getRefetchableFragment,
    getRequest: getRequest,
    getUpdatableQuery: getUpdatableQuery,
    getInlineDataFragment: getInlineDataFragment,
    graphql: graphql,
    isFragment: isFragment,
    isRequest: isRequest,
    isUpdatableQuery: isUpdatableQuery,
    isInlineDataFragment: isInlineDataFragment
};

},{"@swc/helpers/_/_type_of":"iFJdx","215af52733b51617":"jKskk","105406c14db77d5":"e2sci","67b4d2feca4bcbca":"j64TH"}],"bBdVI":[function(require,module,exports,__globalThis) {
'use strict';
function isRelayModernEnvironment(environment) {
    return Boolean(environment && environment['@@RelayModernEnvironment']);
}
module.exports = isRelayModernEnvironment;

},{}],"dSeB3":[function(require,module,exports,__globalThis) {
'use strict';
var deepFreeze = require("653e57175c1c4351");
var getRequestIdentifier = require("1110d9e24d3b7949");
var _require = require("cf874f98c5766775"), getOperationVariables = _require.getOperationVariables;
var _require2 = require("29b660c3c915ce16"), createNormalizationSelector = _require2.createNormalizationSelector, createReaderSelector = _require2.createReaderSelector;
var _require3 = require("9113d30cba7df03c"), ROOT_ID = _require3.ROOT_ID;
function createOperationDescriptor(request, variables, cacheConfig) {
    var dataID = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ROOT_ID;
    var operation = request.operation;
    var operationVariables = getOperationVariables(operation, request.params.providedVariables, variables);
    var requestDescriptor = createRequestDescriptor(request, operationVariables, cacheConfig);
    var operationDescriptor = {
        fragment: createReaderSelector(request.fragment, dataID, operationVariables, requestDescriptor),
        request: requestDescriptor,
        root: createNormalizationSelector(operation, dataID, operationVariables)
    };
    return operationDescriptor;
}
function createRequestDescriptor(request, variables, cacheConfig) {
    var requestDescriptor = {
        identifier: getRequestIdentifier(request.params, variables),
        node: request,
        variables: variables,
        cacheConfig: cacheConfig
    };
    return requestDescriptor;
}
module.exports = {
    createOperationDescriptor: createOperationDescriptor,
    createRequestDescriptor: createRequestDescriptor
};

},{"653e57175c1c4351":"eLea7","1110d9e24d3b7949":"h3zzW","cf874f98c5766775":"138Hd","29b660c3c915ce16":"9k2Dg","9113d30cba7df03c":"3QcrW"}],"eLea7":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
function deepFreeze(object) {
    if (!shouldBeFrozen(object)) return object;
    Object.freeze(object);
    Object.getOwnPropertyNames(object).forEach(function(name) {
        var property = object[name];
        if (property && (typeof property === "undefined" ? "undefined" : (0, _typeOf._)(property)) === 'object' && !Object.isFrozen(property)) deepFreeze(property);
    });
    return object;
}
function shouldBeFrozen(value) {
    return value != null && (Array.isArray(value) || (typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) === 'object' && value.constructor === Object);
}
module.exports = deepFreeze;

},{"@swc/helpers/_/_type_of":"iFJdx"}],"h3zzW":[function(require,module,exports,__globalThis) {
'use strict';
var stableCopy = require("7af3034ed811f4af");
var invariant = require("7bb20374905c2d7d");
function getRequestIdentifier(parameters, variables) {
    var requestID = parameters.cacheID != null ? parameters.cacheID : parameters.id;
    !(requestID != null) && invariant(false);
    return requestID + JSON.stringify(stableCopy(variables));
}
module.exports = getRequestIdentifier;

},{"7af3034ed811f4af":"c3NLR","7bb20374905c2d7d":"e2sci"}],"138Hd":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("67a101b2e385978c")["default"];
var _objectSpread2 = _interopRequireDefault(require("2f18dbe495dc5f1d"));
var _require = require("55099d1f43cc4ced"), getArgumentValues = _require.getArgumentValues;
var invariant = require("dad77247c37d9687");
function getFragmentVariables(fragment, rootVariables, argumentVariables) {
    if (fragment.argumentDefinitions == null) return argumentVariables;
    var variables;
    fragment.argumentDefinitions.forEach(function(definition) {
        if (argumentVariables.hasOwnProperty(definition.name)) return;
        variables = variables || (0, _objectSpread2["default"])({}, argumentVariables);
        switch(definition.kind){
            case 'LocalArgument':
                variables[definition.name] = definition.defaultValue;
                break;
            case 'RootArgument':
                if (!rootVariables.hasOwnProperty(definition.name)) {
                    variables[definition.name] = undefined;
                    break;
                }
                variables[definition.name] = rootVariables[definition.name];
                break;
            default:
                definition;
                invariant(false);
        }
    });
    return variables || argumentVariables;
}
function getOperationVariables(operation, providedVariables, variables) {
    var operationVariables = {};
    operation.argumentDefinitions.forEach(function(def) {
        var value = def.defaultValue;
        if (variables[def.name] != null) value = variables[def.name];
        operationVariables[def.name] = value;
    });
    if (providedVariables != null) Object.keys(providedVariables).forEach(function(varName) {
        operationVariables[varName] = providedVariables[varName].get();
    });
    return operationVariables;
}
function getLocalVariables(currentVariables, argumentDefinitions, args) {
    if (argumentDefinitions == null) return currentVariables;
    var nextVariables = (0, _objectSpread2["default"])({}, currentVariables);
    var nextArgs = args ? getArgumentValues(args, currentVariables) : {};
    argumentDefinitions.forEach(function(def) {
        var _nextArgs$def$name;
        var value = (_nextArgs$def$name = nextArgs[def.name]) !== null && _nextArgs$def$name !== void 0 ? _nextArgs$def$name : def.defaultValue;
        nextVariables[def.name] = value;
    });
    return nextVariables;
}
module.exports = {
    getLocalVariables: getLocalVariables,
    getFragmentVariables: getFragmentVariables,
    getOperationVariables: getOperationVariables
};

},{"67a101b2e385978c":"590td","2f18dbe495dc5f1d":"2Bj1n","55099d1f43cc4ced":"3QcrW","dad77247c37d9687":"e2sci"}],"2Bj1n":[function(require,module,exports,__globalThis) {
var defineProperty = require("b5c9231705b4e48e");
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
module.exports = _objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"b5c9231705b4e48e":"2paQ8"}],"2paQ8":[function(require,module,exports,__globalThis) {
var toPropertyKey = require("f7ac22421bd3394b");
function _defineProperty(e, r, t) {
    return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"f7ac22421bd3394b":"ipoCP"}],"ipoCP":[function(require,module,exports,__globalThis) {
var _typeof = require("389263fe926d4163")["default"];
var toPrimitive = require("2d213a9b2e3e2f98");
function toPropertyKey(t) {
    var i = toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
module.exports = toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"389263fe926d4163":"r9vQs","2d213a9b2e3e2f98":"lDPGd"}],"r9vQs":[function(require,module,exports,__globalThis) {
function _typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"lDPGd":[function(require,module,exports,__globalThis) {
var _typeof = require("cb886826e8f1c745")["default"];
function toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"cb886826e8f1c745":"r9vQs"}],"9k2Dg":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var _require = require("a0169a50ff2fbd9d"), getFragmentVariables = _require.getFragmentVariables;
var _require2 = require("a3b8f7c0e5e243c0"), CLIENT_EDGE_TRAVERSAL_PATH = _require2.CLIENT_EDGE_TRAVERSAL_PATH, FRAGMENT_OWNER_KEY = _require2.FRAGMENT_OWNER_KEY, FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT = _require2.FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT, FRAGMENTS_KEY = _require2.FRAGMENTS_KEY, ID_KEY = _require2.ID_KEY;
var areEqual = require("5f29e20aafea982a");
var invariant = require("db320263417ac2fa");
var warning = require("cfb748599f67db39");
function getSingularSelector(fragment, item) {
    !((typeof item === "undefined" ? "undefined" : (0, _typeOf._)(item)) === 'object' && item !== null && !Array.isArray(item)) && invariant(false);
    var dataID = item[ID_KEY];
    var fragments = item[FRAGMENTS_KEY];
    var mixedOwner = item[FRAGMENT_OWNER_KEY];
    var mixedClientEdgeTraversalPath = item[CLIENT_EDGE_TRAVERSAL_PATH];
    if (typeof dataID === 'string' && (typeof fragments === "undefined" ? "undefined" : (0, _typeOf._)(fragments)) === 'object' && fragments !== null && (0, _typeOf._)(fragments[fragment.name]) === 'object' && fragments[fragment.name] !== null && (typeof mixedOwner === "undefined" ? "undefined" : (0, _typeOf._)(mixedOwner)) === 'object' && mixedOwner !== null && (mixedClientEdgeTraversalPath == null || Array.isArray(mixedClientEdgeTraversalPath))) {
        var owner = mixedOwner;
        var clientEdgeTraversalPath = mixedClientEdgeTraversalPath;
        var argumentVariables = fragments[fragment.name];
        var fragmentVariables = getFragmentVariables(fragment, owner.variables, argumentVariables);
        var isWithinUnmatchedTypeRefinement = argumentVariables[FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT] === true;
        return createReaderSelector(fragment, dataID, fragmentVariables, owner, isWithinUnmatchedTypeRefinement, clientEdgeTraversalPath);
    }
    var stringifiedItem;
    return null;
}
function getPluralSelector(fragment, items) {
    var selectors = null;
    items.forEach(function(item, ii) {
        var selector = item != null ? getSingularSelector(fragment, item) : null;
        if (selector != null) {
            selectors = selectors || [];
            selectors.push(selector);
        }
    });
    if (selectors == null) return null;
    else return {
        kind: 'PluralReaderSelector',
        selectors: selectors
    };
}
function getSelector(fragment, item) {
    if (item == null) return item;
    else if (fragment.metadata && fragment.metadata.plural === true) {
        !Array.isArray(item) && invariant(false);
        return getPluralSelector(fragment, item);
    } else {
        !!Array.isArray(item) && invariant(false);
        return getSingularSelector(fragment, item);
    }
}
function getSelectorsFromObject(fragments, object) {
    var selectors = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        selectors[key] = getSelector(fragment, item);
    }
    return selectors;
}
function getDataIDsFromObject(fragments, object) {
    var ids = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        ids[key] = getDataIDsFromFragment(fragment, item);
    }
    return ids;
}
function getDataIDsFromFragment(fragment, item) {
    if (item == null) return item;
    else if (fragment.metadata && fragment.metadata.plural === true) {
        !Array.isArray(item) && invariant(false);
        return getDataIDs(fragment, item);
    } else {
        !!Array.isArray(item) && invariant(false);
        return getDataID(fragment, item);
    }
}
function getDataIDs(fragment, items) {
    var ids = null;
    items.forEach(function(item) {
        var id = item != null ? getDataID(fragment, item) : null;
        if (id != null) {
            ids = ids || [];
            ids.push(id);
        }
    });
    return ids;
}
function getDataID(fragment, item) {
    !((typeof item === "undefined" ? "undefined" : (0, _typeOf._)(item)) === 'object' && item !== null && !Array.isArray(item)) && invariant(false);
    var dataID = item[ID_KEY];
    if (typeof dataID === 'string') return dataID;
    return null;
}
function getVariablesFromObject(fragments, object) {
    var variables = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        var itemVariables = getVariablesFromFragment(fragment, item);
        Object.assign(variables, itemVariables);
    }
    return variables;
}
function getVariablesFromFragment(fragment, item) {
    var _fragment$metadata;
    if (item == null) return {};
    else if (((_fragment$metadata = fragment.metadata) === null || _fragment$metadata === void 0 ? void 0 : _fragment$metadata.plural) === true) {
        !Array.isArray(item) && invariant(false);
        return getVariablesFromPluralFragment(fragment, item);
    } else {
        !!Array.isArray(item) && invariant(false);
        return getVariablesFromSingularFragment(fragment, item) || {};
    }
}
function getVariablesFromSingularFragment(fragment, item) {
    var selector = getSingularSelector(fragment, item);
    if (!selector) return null;
    return selector.variables;
}
function getVariablesFromPluralFragment(fragment, items) {
    var variables = {};
    items.forEach(function(value, ii) {
        if (value != null) {
            var itemVariables = getVariablesFromSingularFragment(fragment, value);
            if (itemVariables != null) Object.assign(variables, itemVariables);
        }
    });
    return variables;
}
function areEqualSingularSelectors(thisSelector, thatSelector) {
    return thisSelector.dataID === thatSelector.dataID && thisSelector.node === thatSelector.node && areEqual(thisSelector.variables, thatSelector.variables) && areEqualOwners(thisSelector.owner, thatSelector.owner) && thisSelector.isWithinUnmatchedTypeRefinement === thatSelector.isWithinUnmatchedTypeRefinement && areEqualClientEdgeTraversalPaths(thisSelector.clientEdgeTraversalPath, thatSelector.clientEdgeTraversalPath);
}
function areEqualOwners(thisOwner, thatOwner) {
    if (thisOwner === thatOwner) return true;
    else return thisOwner.identifier === thatOwner.identifier && areEqual(thisOwner.cacheConfig, thatOwner.cacheConfig);
}
function areEqualClientEdgeTraversalPaths(thisPath, thatPath) {
    if (thisPath === thatPath) return true;
    if (thisPath == null || thatPath == null || thisPath.length !== thatPath.length) return false;
    var idx = thisPath.length;
    while(idx--){
        var a = thisPath[idx];
        var b = thatPath[idx];
        if (a === b) continue;
        if (a == null || b == null || a.clientEdgeDestinationID !== b.clientEdgeDestinationID || a.readerClientEdge !== b.readerClientEdge) return false;
    }
    return true;
}
function areEqualSelectors(a, b) {
    if (a === b) return true;
    else if (a == null) return b == null;
    else if (b == null) return a == null;
    else if (a.kind === 'SingularReaderSelector' && b.kind === 'SingularReaderSelector') return areEqualSingularSelectors(a, b);
    else if (a.kind === 'PluralReaderSelector' && b.kind === 'PluralReaderSelector') return a.selectors.length === b.selectors.length && a.selectors.every(function(s, i) {
        return areEqualSingularSelectors(s, b.selectors[i]);
    });
    else return false;
}
function createReaderSelector(fragment, dataID, variables, request) {
    var isWithinUnmatchedTypeRefinement = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var clientEdgeTraversalPath = arguments.length > 5 ? arguments[5] : undefined;
    return {
        kind: 'SingularReaderSelector',
        dataID: dataID,
        isWithinUnmatchedTypeRefinement: isWithinUnmatchedTypeRefinement,
        clientEdgeTraversalPath: clientEdgeTraversalPath !== null && clientEdgeTraversalPath !== void 0 ? clientEdgeTraversalPath : null,
        node: fragment,
        variables: variables,
        owner: request
    };
}
function createNormalizationSelector(node, dataID, variables) {
    return {
        dataID: dataID,
        node: node,
        variables: variables
    };
}
module.exports = {
    areEqualSelectors: areEqualSelectors,
    createReaderSelector: createReaderSelector,
    createNormalizationSelector: createNormalizationSelector,
    getDataIDsFromFragment: getDataIDsFromFragment,
    getDataIDsFromObject: getDataIDsFromObject,
    getSingularSelector: getSingularSelector,
    getPluralSelector: getPluralSelector,
    getSelector: getSelector,
    getSelectorsFromObject: getSelectorsFromObject,
    getVariablesFromSingularFragment: getVariablesFromSingularFragment,
    getVariablesFromPluralFragment: getVariablesFromPluralFragment,
    getVariablesFromFragment: getVariablesFromFragment,
    getVariablesFromObject: getVariablesFromObject
};

},{"@swc/helpers/_/_type_of":"iFJdx","a0169a50ff2fbd9d":"138Hd","a3b8f7c0e5e243c0":"3QcrW","5f29e20aafea982a":"eJLuG","db320263417ac2fa":"e2sci","cfb748599f67db39":"j64TH"}],"eJLuG":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ var aStackPool = [];
var bStackPool = [];
/**
 * Checks if two values are equal. Values may be primitives, arrays, or objects.
 * Returns true if both arguments have the same keys and values.
 *
 * @see http://underscorejs.org
 * @copyright 2009-2013 Jeremy Ashkenas, DocumentCloud Inc.
 * @license MIT
 */ function areEqual(a, b) {
    var aStack = aStackPool.length ? aStackPool.pop() : [];
    var bStack = bStackPool.length ? bStackPool.pop() : [];
    var result = eq(a, b, aStack, bStack);
    aStack.length = 0;
    bStack.length = 0;
    aStackPool.push(aStack);
    bStackPool.push(bStack);
    return result;
}
function eq(a, b, aStack, bStack) {
    if (a === b) // Identical objects are equal. `0 === -0`, but they aren't identical.
    return a !== 0 || 1 / a == 1 / b;
    if (a == null || b == null) // a or b can be `null` or `undefined`
    return false;
    if ((typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)) != 'object' || (typeof b === "undefined" ? "undefined" : (0, _typeOf._)(b)) != 'object') return false;
    var objToStr = Object.prototype.toString;
    var className = objToStr.call(a);
    if (className != objToStr.call(b)) return false;
    switch(className){
        case '[object String]':
            return a == String(b);
        case '[object Number]':
            return isNaN(a) || isNaN(b) ? false : a == Number(b);
        case '[object Date]':
        case '[object Boolean]':
            return +a == +b;
        case '[object RegExp]':
            return a.source == b.source && a.global == b.global && a.multiline == b.multiline && a.ignoreCase == b.ignoreCase;
    } // Assume equality for cyclic structures.
    var length = aStack.length;
    while(length--){
        if (aStack[length] == a) return bStack[length] == b;
    }
    aStack.push(a);
    bStack.push(b);
    var size = 0; // Recursively compare objects and arrays.
    if (className === '[object Array]') {
        size = a.length;
        if (size !== b.length) return false;
         // Deep compare the contents, ignoring non-numeric properties.
        while(size--){
            if (!eq(a[size], b[size], aStack, bStack)) return false;
        }
    } else {
        if (a.constructor !== b.constructor) return false;
        if (a.hasOwnProperty('valueOf') && b.hasOwnProperty('valueOf')) return a.valueOf() == b.valueOf();
        var keys = Object.keys(a);
        if (keys.length != Object.keys(b).length) return false;
        for(var i = 0; i < keys.length; i++){
            if (!eq(a[keys[i]], b[keys[i]], aStack, bStack)) return false;
        }
    }
    aStack.pop();
    bStack.pop();
    return true;
}
module.exports = areEqual;

},{"@swc/helpers/_/_type_of":"iFJdx"}],"1lmKe":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var _interopRequireDefault = require("c78afc10dc7f55aa")["default"];
var _createForOfIteratorHelper2 = _interopRequireDefault(require("5b666b6aff03d5af"));
var ConnectionHandler = require("41f218f58f287b70");
var warning = require("a359290e1df6bbbf");
var MutationTypes = Object.freeze({
    RANGE_ADD: 'RANGE_ADD',
    RANGE_DELETE: 'RANGE_DELETE',
    NODE_DELETE: 'NODE_DELETE'
});
var RangeOperations = Object.freeze({
    APPEND: 'append',
    PREPEND: 'prepend'
});
function convert(configs, request, optimisticUpdater, updater) {
    var configOptimisticUpdates = optimisticUpdater ? [
        optimisticUpdater
    ] : [];
    var configUpdates = updater ? [
        updater
    ] : [];
    configs.forEach(function(config) {
        switch(config.type){
            case 'NODE_DELETE':
                var nodeDeleteResult = nodeDelete(config, request);
                if (nodeDeleteResult) {
                    configOptimisticUpdates.push(nodeDeleteResult);
                    configUpdates.push(nodeDeleteResult);
                }
                break;
            case 'RANGE_ADD':
                var rangeAddResult = rangeAdd(config, request);
                if (rangeAddResult) {
                    configOptimisticUpdates.push(rangeAddResult);
                    configUpdates.push(rangeAddResult);
                }
                break;
            case 'RANGE_DELETE':
                var rangeDeleteResult = rangeDelete(config, request);
                if (rangeDeleteResult) {
                    configOptimisticUpdates.push(rangeDeleteResult);
                    configUpdates.push(rangeDeleteResult);
                }
                break;
        }
    });
    return {
        optimisticUpdater: function optimisticUpdater(store, data) {
            configOptimisticUpdates.forEach(function(eachOptimisticUpdater) {
                eachOptimisticUpdater(store, data);
            });
        },
        updater: function updater(store, data) {
            configUpdates.forEach(function(eachUpdater) {
                eachUpdater(store, data);
            });
        }
    };
}
function nodeDelete(config, request) {
    var deletedIDFieldName = config.deletedIDFieldName;
    var rootField = getRootField(request);
    if (!rootField) return null;
    return function(store, data) {
        var payload = store.getRootField(rootField);
        if (!payload) return;
        var deleteID = payload.getValue(deletedIDFieldName);
        var deleteIDs = Array.isArray(deleteID) ? deleteID : [
            deleteID
        ];
        deleteIDs.forEach(function(id) {
            if (id && typeof id === 'string') store["delete"](id);
        });
    };
}
function rangeAdd(config, request) {
    var parentID = config.parentID, connectionInfo = config.connectionInfo, edgeName = config.edgeName;
    if (!parentID) return null;
    var rootField = getRootField(request);
    if (!connectionInfo || !rootField) return null;
    return function(store, data) {
        var parent = store.get(parentID);
        if (!parent) return;
        var payload = store.getRootField(rootField);
        if (!payload) return;
        var serverEdge = payload.getLinkedRecord(edgeName);
        var _iterator = (0, _createForOfIteratorHelper2["default"])(connectionInfo), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var info = _step.value;
                if (!serverEdge) continue;
                var connection = ConnectionHandler.getConnection(parent, info.key, info.filters);
                if (!connection) continue;
                var clientEdge = ConnectionHandler.buildConnectionEdge(store, connection, serverEdge);
                if (!clientEdge) continue;
                switch(info.rangeBehavior){
                    case 'append':
                        ConnectionHandler.insertEdgeAfter(connection, clientEdge);
                        break;
                    case 'prepend':
                        ConnectionHandler.insertEdgeBefore(connection, clientEdge);
                        break;
                    default:
                        break;
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    };
}
function rangeDelete(config, request) {
    var parentID = config.parentID, connectionKeys = config.connectionKeys, pathToConnection = config.pathToConnection, deletedIDFieldName = config.deletedIDFieldName;
    if (!parentID) return null;
    var rootField = getRootField(request);
    if (!rootField) return null;
    return function(store, data) {
        if (!data) return;
        var deleteIDs = [];
        var deletedIDField = data[rootField];
        if (deletedIDField && Array.isArray(deletedIDFieldName)) {
            var _iterator2 = (0, _createForOfIteratorHelper2["default"])(deletedIDFieldName), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var eachField = _step2.value;
                    if (deletedIDField && (typeof deletedIDField === "undefined" ? "undefined" : (0, _typeOf._)(deletedIDField)) === 'object') deletedIDField = deletedIDField[eachField];
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            if (Array.isArray(deletedIDField)) deletedIDField.forEach(function(idObject) {
                if (idObject && idObject.id && (typeof idObject === "undefined" ? "undefined" : (0, _typeOf._)(idObject)) === 'object' && typeof idObject.id === 'string') deleteIDs.push(idObject.id);
            });
            else if (deletedIDField && deletedIDField.id && typeof deletedIDField.id === 'string') deleteIDs.push(deletedIDField.id);
        } else if (deletedIDField && typeof deletedIDFieldName === 'string' && (typeof deletedIDField === "undefined" ? "undefined" : (0, _typeOf._)(deletedIDField)) === 'object') {
            deletedIDField = deletedIDField[deletedIDFieldName];
            if (typeof deletedIDField === 'string') deleteIDs.push(deletedIDField);
            else if (Array.isArray(deletedIDField)) deletedIDField.forEach(function(id) {
                if (typeof id === 'string') deleteIDs.push(id);
            });
        }
        deleteNode(parentID, connectionKeys, pathToConnection, store, deleteIDs);
    };
}
function deleteNode(parentID, connectionKeys, pathToConnection, store, deleteIDs) {
    var parent = store.get(parentID);
    if (!parent) return;
    if (pathToConnection.length < 2) return;
    var recordProxy = parent;
    for(var i = 1; i < pathToConnection.length - 1; i++)if (recordProxy) recordProxy = recordProxy.getLinkedRecord(pathToConnection[i]);
    if (!connectionKeys || !recordProxy) return;
    var _iterator3 = (0, _createForOfIteratorHelper2["default"])(connectionKeys), _step3;
    try {
        var _loop = function _loop() {
            var key = _step3.value;
            var connection = ConnectionHandler.getConnection(recordProxy, key.key, key.filters);
            if (connection) deleteIDs.forEach(function(deleteID) {
                ConnectionHandler.deleteNode(connection, deleteID);
            });
        };
        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;)_loop();
    } catch (err) {
        _iterator3.e(err);
    } finally{
        _iterator3.f();
    }
}
function getRootField(request) {
    if (request.fragment.selections && request.fragment.selections.length > 0 && request.fragment.selections[0].kind === 'LinkedField') return request.fragment.selections[0].name;
    return null;
}
module.exports = {
    MutationTypes: MutationTypes,
    RangeOperations: RangeOperations,
    convert: convert
};

},{"@swc/helpers/_/_type_of":"iFJdx","c78afc10dc7f55aa":"590td","5b666b6aff03d5af":"fMaLa","41f218f58f287b70":"ccBOd","a359290e1df6bbbf":"j64TH"}],"5KZg6":[function(require,module,exports,__globalThis) {
'use strict';
function commitLocalUpdate(environment, updater) {
    environment.commitUpdate(updater);
}
module.exports = commitLocalUpdate;

},{}],"1H0OQ":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("6d39cd0e270b8aec")["default"];
var _toConsumableArray2 = _interopRequireDefault(require("5c9e1274f34388f5"));
var _require = require("67edf200634e6c87"), getRequest = _require.getRequest;
var _require2 = require("bbeed2b28422964"), generateUniqueClientID = _require2.generateUniqueClientID;
var isRelayModernEnvironment = require("c906eac592a2369b");
var _require3 = require("1f0571eb15c24db"), createOperationDescriptor = _require3.createOperationDescriptor;
var RelayDeclarativeMutationConfig = require("5c7d0bf96d99d7a6");
var validateMutation = require("ebb05b416036134c");
var invariant = require("a1c1e4fe2d13d416");
var warning = require("a2d529af2ce20c4f");
function commitMutation(environment, config) {
    !isRelayModernEnvironment(environment) && invariant(false);
    var mutation = getRequest(config.mutation);
    if (mutation.params.operationKind !== 'mutation') throw new Error('commitMutation: Expected mutation operation');
    if (mutation.kind !== 'Request') throw new Error('commitMutation: Expected mutation to be of type request');
    var optimisticResponse = config.optimisticResponse, optimisticUpdater = config.optimisticUpdater, updater = config.updater;
    var configs = config.configs, cacheConfig = config.cacheConfig, onError = config.onError, onUnsubscribe = config.onUnsubscribe, variables = config.variables, uploadables = config.uploadables;
    var operation = createOperationDescriptor(mutation, variables, cacheConfig, generateUniqueClientID());
    if (typeof optimisticResponse === 'function') optimisticResponse = optimisticResponse();
    if (configs) {
        var _RelayDeclarativeMuta = RelayDeclarativeMutationConfig.convert(configs, mutation, optimisticUpdater, updater);
        optimisticUpdater = _RelayDeclarativeMuta.optimisticUpdater;
        updater = _RelayDeclarativeMuta.updater;
    }
    var errors = [];
    var subscription = environment.executeMutation({
        operation: operation,
        optimisticResponse: optimisticResponse,
        optimisticUpdater: optimisticUpdater,
        updater: updater,
        uploadables: uploadables
    }).subscribe({
        next: function next(payload) {
            var _config$onNext;
            if (Array.isArray(payload)) payload.forEach(function(item) {
                if (item.errors) errors.push.apply(errors, (0, _toConsumableArray2["default"])(item.errors));
            });
            else if (payload.errors) errors.push.apply(errors, (0, _toConsumableArray2["default"])(payload.errors));
            (_config$onNext = config.onNext) === null || _config$onNext === void 0 || _config$onNext.call(config);
        },
        complete: function complete() {
            var onCompleted = config.onCompleted;
            if (onCompleted) {
                var snapshot = environment.lookup(operation.fragment);
                onCompleted(snapshot.data, errors.length !== 0 ? errors : null);
            }
        },
        error: onError,
        unsubscribe: onUnsubscribe
    });
    return {
        dispose: subscription.unsubscribe
    };
}
module.exports = commitMutation;

},{"6d39cd0e270b8aec":"590td","5c9e1274f34388f5":"7EBX0","67edf200634e6c87":"8UTII","bbeed2b28422964":"gL1rB","c906eac592a2369b":"bBdVI","1f0571eb15c24db":"dSeB3","5c7d0bf96d99d7a6":"1lmKe","ebb05b416036134c":"5s4Eu","a1c1e4fe2d13d416":"e2sci","a2d529af2ce20c4f":"j64TH"}],"5s4Eu":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("5592140b5bb330fb")["default"];
var _objectSpread2 = _interopRequireDefault(require("57cddd40b9e9c2ee"));
var _require = require("4ed616e826782441"), ACTOR_CHANGE = _require.ACTOR_CHANGE, CLIENT_COMPONENT = _require.CLIENT_COMPONENT, CLIENT_EDGE_TO_CLIENT_OBJECT = _require.CLIENT_EDGE_TO_CLIENT_OBJECT, CLIENT_EXTENSION = _require.CLIENT_EXTENSION, CONDITION = _require.CONDITION, DEFER = _require.DEFER, FRAGMENT_SPREAD = _require.FRAGMENT_SPREAD, INLINE_FRAGMENT = _require.INLINE_FRAGMENT, LINKED_FIELD = _require.LINKED_FIELD, LINKED_HANDLE = _require.LINKED_HANDLE, MODULE_IMPORT = _require.MODULE_IMPORT, RELAY_LIVE_RESOLVER = _require.RELAY_LIVE_RESOLVER, RELAY_RESOLVER = _require.RELAY_RESOLVER, SCALAR_FIELD = _require.SCALAR_FIELD, SCALAR_HANDLE = _require.SCALAR_HANDLE, STREAM = _require.STREAM, TYPE_DISCRIMINATOR = _require.TYPE_DISCRIMINATOR;
var warning = require("a99edeb0085b242e");
var hasOwnProperty = Object.prototype.hasOwnProperty;
var validateMutation = function validateMutation() {};
var addFieldToDiff, validateSelections, validateSelection, validateModuleImport, validateAbstractKey, validateField, validateOptimisticResponse;
module.exports = validateMutation;

},{"5592140b5bb330fb":"590td","57cddd40b9e9c2ee":"2Bj1n","4ed616e826782441":"jKskk","a99edeb0085b242e":"j64TH"}],"gtE7n":[function(require,module,exports,__globalThis) {
'use strict';
var withProvidedVariables = require("29d5e2059830cbf");
var _require = require("619be278d7fcd836"), convertFetch = _require.convertFetch;
var invariant = require("9268cc175a6b6859");
function create(fetchFn, subscribe) {
    var observeFetch = convertFetch(fetchFn);
    function execute(request, variables, cacheConfig, uploadables, logRequestInfo) {
        var operationVariables = withProvidedVariables(variables, request.providedVariables);
        if (request.operationKind === 'subscription') {
            !subscribe && invariant(false);
            !!uploadables && invariant(false);
            return subscribe(request, operationVariables, cacheConfig);
        }
        var pollInterval = cacheConfig.poll;
        if (pollInterval != null) {
            !!uploadables && invariant(false);
            return observeFetch(request, operationVariables, {
                force: true
            }).poll(pollInterval);
        }
        return observeFetch(request, operationVariables, cacheConfig, uploadables, logRequestInfo);
    }
    return {
        execute: execute
    };
}
module.exports = {
    create: create
};

},{"29d5e2059830cbf":"1N2Sg","619be278d7fcd836":"baXis","9268cc175a6b6859":"e2sci"}],"1N2Sg":[function(require,module,exports,__globalThis) {
'use strict';
var areEqual = require("12f707750c3648af");
var warning = require("57d4af0a2ea5673b");
var WEAKMAP_SUPPORTED = typeof WeakMap === 'function';
var debugCache = WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
function withProvidedVariables(userSuppliedVariables, providedVariables) {
    if (providedVariables != null) {
        var operationVariables = {};
        Object.assign(operationVariables, userSuppliedVariables);
        Object.keys(providedVariables).forEach(function(varName) {
            var providerFunction = providedVariables[varName].get;
            var providerResult = providerFunction();
            if (!debugCache.has(providerFunction)) {
                debugCache.set(providerFunction, providerResult);
                operationVariables[varName] = providerResult;
            } else {
                var cachedResult = debugCache.get(providerFunction);
                operationVariables[varName] = cachedResult;
            }
        });
        return operationVariables;
    } else return userSuppliedVariables;
}
withProvidedVariables.tests_only_resetDebugCache = undefined;
module.exports = withProvidedVariables;

},{"12f707750c3648af":"eJLuG","57d4af0a2ea5673b":"j64TH"}],"baXis":[function(require,module,exports,__globalThis) {
var _instanceof = require("@swc/helpers/_/_instanceof");
'use strict';
var RelayObservable = require("a489b440edc36379");
function convertFetch(fn) {
    return function fetch(request, variables, cacheConfig, uploadables, logRequestInfo) {
        var result = fn(request, variables, cacheConfig, uploadables, logRequestInfo);
        if ((0, _instanceof._)(result, Error)) return RelayObservable.create(function(sink) {
            return sink.error(result);
        });
        return RelayObservable.from(result);
    };
}
module.exports = {
    convertFetch: convertFetch
};

},{"@swc/helpers/_/_instanceof":"h9UKc","a489b440edc36379":"hYmcP"}],"hYmcP":[function(require,module,exports,__globalThis) {
var _instanceof = require("@swc/helpers/_/_instanceof");
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var isPromise = require("622f95f90dce29ad");
var hostReportError = swallowError;
var RelayObservable = /*#__PURE__*/ function() {
    RelayObservable.create = function create(source) {
        return new RelayObservable(source);
    };
    function RelayObservable(source) {
        this._source = source;
    }
    RelayObservable.onUnhandledError = function onUnhandledError(callback) {
        hostReportError = callback;
    };
    RelayObservable.from = function from(obj) {
        return isObservable(obj) ? fromObservable(obj) : isPromise(obj) ? fromPromise(obj) : fromValue(obj);
    };
    var _proto = RelayObservable.prototype;
    _proto["catch"] = function _catch(fn) {
        var _this = this;
        return RelayObservable.create(function(sink) {
            var subscription;
            _this.subscribe({
                start: function start(sub) {
                    subscription = sub;
                },
                next: sink.next,
                complete: sink.complete,
                error: function error(_error2) {
                    try {
                        fn(_error2).subscribe({
                            start: function start(sub) {
                                subscription = sub;
                            },
                            next: sink.next,
                            complete: sink.complete,
                            error: sink.error
                        });
                    } catch (error2) {
                        sink.error(error2, true);
                    }
                }
            });
            return function() {
                return subscription.unsubscribe();
            };
        });
    };
    _proto.concat = function concat(next) {
        var _this2 = this;
        return RelayObservable.create(function(sink) {
            var current;
            _this2.subscribe({
                start: function start(subscription) {
                    current = subscription;
                },
                next: sink.next,
                error: sink.error,
                complete: function complete() {
                    current = next.subscribe(sink);
                }
            });
            return function() {
                current && current.unsubscribe();
            };
        });
    };
    _proto["do"] = function _do(observer) {
        var _this3 = this;
        return RelayObservable.create(function(sink) {
            var both = function both(action) {
                return function() {
                    try {
                        observer[action] && observer[action].apply(observer, arguments);
                    } catch (error) {
                        hostReportError(error, true);
                    }
                    sink[action] && sink[action].apply(sink, arguments);
                };
            };
            return _this3.subscribe({
                start: both('start'),
                next: both('next'),
                error: both('error'),
                complete: both('complete'),
                unsubscribe: both('unsubscribe')
            });
        });
    };
    _proto["finally"] = function _finally(fn) {
        var _this4 = this;
        return RelayObservable.create(function(sink) {
            var subscription = _this4.subscribe(sink);
            return function() {
                subscription.unsubscribe();
                fn();
            };
        });
    };
    _proto.ifEmpty = function ifEmpty(alternate) {
        var _this5 = this;
        return RelayObservable.create(function(sink) {
            var hasValue = false;
            var current;
            current = _this5.subscribe({
                next: function next(value) {
                    hasValue = true;
                    sink.next(value);
                },
                error: sink.error,
                complete: function complete() {
                    if (hasValue) sink.complete();
                    else current = alternate.subscribe(sink);
                }
            });
            return function() {
                current && current.unsubscribe();
            };
        });
    };
    _proto.subscribe = function subscribe(observer) {
        return _subscribe(this._source, observer);
    };
    _proto.map = function map(fn) {
        var _this6 = this;
        return RelayObservable.create(function(sink) {
            var subscription = _this6.subscribe({
                complete: sink.complete,
                error: sink.error,
                next: function next(value) {
                    try {
                        var mapValue = fn(value);
                        sink.next(mapValue);
                    } catch (error) {
                        sink.error(error, true);
                    }
                }
            });
            return function() {
                subscription.unsubscribe();
            };
        });
    };
    _proto.mergeMap = function mergeMap(fn) {
        var _this7 = this;
        return RelayObservable.create(function(sink) {
            var subscriptions = [];
            function start(subscription) {
                this._sub = subscription;
                subscriptions.push(subscription);
            }
            function complete() {
                subscriptions.splice(subscriptions.indexOf(this._sub), 1);
                if (subscriptions.length === 0) sink.complete();
            }
            _this7.subscribe({
                start: start,
                next: function next(value) {
                    try {
                        if (!sink.closed) RelayObservable.from(fn(value)).subscribe({
                            start: start,
                            next: sink.next,
                            error: sink.error,
                            complete: complete
                        });
                    } catch (error) {
                        sink.error(error, true);
                    }
                },
                error: sink.error,
                complete: complete
            });
            return function() {
                subscriptions.forEach(function(sub) {
                    return sub.unsubscribe();
                });
                subscriptions.length = 0;
            };
        });
    };
    _proto.poll = function poll(pollInterval) {
        var _this8 = this;
        return RelayObservable.create(function(sink) {
            var subscription;
            var timeout;
            var poll = function poll() {
                subscription = _this8.subscribe({
                    next: sink.next,
                    error: sink.error,
                    complete: function complete() {
                        timeout = setTimeout(poll, pollInterval);
                    }
                });
            };
            poll();
            return function() {
                clearTimeout(timeout);
                subscription.unsubscribe();
            };
        });
    };
    _proto.toPromise = function toPromise() {
        var _this9 = this;
        return new Promise(function(resolve, reject) {
            var resolved = false;
            _this9.subscribe({
                next: function next(val) {
                    if (!resolved) {
                        resolved = true;
                        resolve(val);
                    }
                },
                error: reject,
                complete: resolve
            });
        });
    };
    return RelayObservable;
}();
function isObservable(obj) {
    return (typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj)) === 'object' && obj !== null && typeof obj.subscribe === 'function';
}
function fromObservable(obj) {
    return (0, _instanceof._)(obj, RelayObservable) ? obj : RelayObservable.create(function(sink) {
        return obj.subscribe(sink);
    });
}
function fromPromise(promise) {
    return RelayObservable.create(function(sink) {
        promise.then(function(value) {
            sink.next(value);
            sink.complete();
        }, sink.error);
    });
}
function fromValue(value) {
    return RelayObservable.create(function(sink) {
        sink.next(value);
        sink.complete();
    });
}
function _subscribe(source, observer) {
    var closed = false;
    var cleanup;
    var withClosed = function withClosed(obj) {
        return Object.defineProperty(obj, 'closed', {
            get: function get() {
                return closed;
            }
        });
    };
    function doCleanup() {
        if (cleanup) {
            if (cleanup.unsubscribe) cleanup.unsubscribe();
            else try {
                cleanup();
            } catch (error) {
                hostReportError(error, true);
            }
            cleanup = undefined;
        }
    }
    var subscription = withClosed({
        unsubscribe: function unsubscribe() {
            if (!closed) {
                closed = true;
                try {
                    observer.unsubscribe && observer.unsubscribe(subscription);
                } catch (error) {
                    hostReportError(error, true);
                } finally{
                    doCleanup();
                }
            }
        }
    });
    try {
        observer.start && observer.start(subscription);
    } catch (error) {
        hostReportError(error, true);
    }
    if (closed) return subscription;
    var sink = withClosed({
        next: function next(value) {
            if (!closed && observer.next) try {
                observer.next(value);
            } catch (error) {
                hostReportError(error, true);
            }
        },
        error: function error(_error3, isUncaughtThrownError) {
            if (closed || !observer.error) {
                closed = true;
                hostReportError(_error3, isUncaughtThrownError || false);
                doCleanup();
            } else {
                closed = true;
                try {
                    observer.error(_error3);
                } catch (error2) {
                    hostReportError(error2, true);
                } finally{
                    doCleanup();
                }
            }
        },
        complete: function complete() {
            if (!closed) {
                closed = true;
                try {
                    observer.complete && observer.complete();
                } catch (error) {
                    hostReportError(error, true);
                } finally{
                    doCleanup();
                }
            }
        }
    });
    try {
        cleanup = source(sink);
    } catch (error) {
        sink.error(error, true);
    }
    if (closed) doCleanup();
    return subscription;
}
function swallowError(_error, _isUncaughtThrownError) {}
module.exports = RelayObservable;

},{"@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_type_of":"iFJdx","622f95f90dce29ad":"8csDP"}],"8csDP":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
function isPromise(p) {
    return p != null && (typeof p === "undefined" ? "undefined" : (0, _typeOf._)(p)) === 'object' && typeof p.then === 'function';
}
module.exports = isPromise;

},{"@swc/helpers/_/_type_of":"iFJdx"}],"ejl8F":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("5eb6f02be12a2204")["default"];
var _objectSpread2 = _interopRequireDefault(require("2c3b67d95a9cca5c"));
var stableCopy = require("ba35c3d3c24d6b7a");
var invariant = require("1fbdf4cfed2afc69");
var RelayQueryResponseCache = /*#__PURE__*/ function() {
    function RelayQueryResponseCache(_ref) {
        var size = _ref.size, ttl = _ref.ttl;
        !(size > 0) && invariant(false);
        !(ttl > 0) && invariant(false);
        this._responses = new Map();
        this._size = size;
        this._ttl = ttl;
    }
    var _proto = RelayQueryResponseCache.prototype;
    _proto.clear = function clear() {
        this._responses.clear();
    };
    _proto.get = function get(queryID, variables) {
        var _this = this;
        var cacheKey = getCacheKey(queryID, variables);
        this._responses.forEach(function(response, key) {
            if (!isCurrent(response.fetchTime, _this._ttl)) _this._responses["delete"](key);
        });
        var response = this._responses.get(cacheKey);
        if (response == null) return null;
        if (Array.isArray(response.payload)) return response.payload.map(function(payload) {
            return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, payload), {}, {
                extensions: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, payload.extensions), {}, {
                    cacheTimestamp: response.fetchTime
                })
            });
        });
        return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, response.payload), {}, {
            extensions: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, response.payload.extensions), {}, {
                cacheTimestamp: response.fetchTime
            })
        });
    };
    _proto.set = function set(queryID, variables, payload) {
        var fetchTime = Date.now();
        var cacheKey = getCacheKey(queryID, variables);
        this._responses["delete"](cacheKey);
        this._responses.set(cacheKey, {
            fetchTime: fetchTime,
            payload: payload
        });
        if (this._responses.size > this._size) {
            var firstKey = this._responses.keys().next();
            if (!firstKey.done) this._responses["delete"](firstKey.value);
        }
    };
    return RelayQueryResponseCache;
}();
function getCacheKey(queryID, variables) {
    return JSON.stringify(stableCopy({
        queryID: queryID,
        variables: variables
    }));
}
function isCurrent(fetchTime, ttl) {
    return fetchTime + ttl >= Date.now();
}
module.exports = RelayQueryResponseCache;

},{"5eb6f02be12a2204":"590td","2c3b67d95a9cca5c":"2Bj1n","ba35c3d3c24d6b7a":"c3NLR","1fbdf4cfed2afc69":"e2sci"}],"khAY2":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("2ffe84bd824cbf0")["default"];
var _objectSpread2 = _interopRequireDefault(require("cd90c30c44aa0fdc"));
var RelayObservable = require("ba3953ef4f803526");
var _require = require("cb14f63cc725d8f"), createOperationDescriptor = _require.createOperationDescriptor;
var handlePotentialSnapshotErrors = require("32213b8207276ab5");
var fetchQueryInternal = require("b8582f9e9d2828cc");
var _require2 = require("98b9ff07c67a6501"), getRequest = _require2.getRequest;
var invariant = require("7e0d30b75b47d07b");
function fetchQuery(environment, query, variables, options) {
    var _options$fetchPolicy;
    var queryNode = getRequest(query);
    !(queryNode.params.operationKind === 'query') && invariant(false);
    var networkCacheConfig = (0, _objectSpread2["default"])({
        force: true
    }, options === null || options === void 0 ? void 0 : options.networkCacheConfig);
    var operation = createOperationDescriptor(queryNode, variables, networkCacheConfig);
    var fetchPolicy = (_options$fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy) !== null && _options$fetchPolicy !== void 0 ? _options$fetchPolicy : 'network-only';
    function readData(snapshot) {
        var _queryNode$fragment$m, _queryNode$fragment$m2;
        handlePotentialSnapshotErrors(environment, snapshot.missingRequiredFields, snapshot.relayResolverErrors, snapshot.errorResponseFields, (_queryNode$fragment$m = (_queryNode$fragment$m2 = queryNode.fragment.metadata) === null || _queryNode$fragment$m2 === void 0 ? void 0 : _queryNode$fragment$m2.throwOnFieldError) !== null && _queryNode$fragment$m !== void 0 ? _queryNode$fragment$m : false);
        return snapshot.data;
    }
    switch(fetchPolicy){
        case 'network-only':
            return getNetworkObservable(environment, operation).map(readData);
        case 'store-or-network':
            if (environment.check(operation).status === 'available') return RelayObservable.from(environment.lookup(operation.fragment)).map(readData);
            return getNetworkObservable(environment, operation).map(readData);
        default:
            fetchPolicy;
            throw new Error('fetchQuery: Invalid fetchPolicy ' + fetchPolicy);
    }
}
function getNetworkObservable(environment, operation) {
    return fetchQueryInternal.fetchQuery(environment, operation).map(function() {
        return environment.lookup(operation.fragment);
    });
}
module.exports = fetchQuery;

},{"2ffe84bd824cbf0":"590td","cd90c30c44aa0fdc":"2Bj1n","ba3953ef4f803526":"hYmcP","cb14f63cc725d8f":"dSeB3","32213b8207276ab5":"kq97W","b8582f9e9d2828cc":"75uB6","98b9ff07c67a6501":"8UTII","7e0d30b75b47d07b":"e2sci"}],"kq97W":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("5ab3e0d9eda62480")["default"];
var _createForOfIteratorHelper2 = _interopRequireDefault(require("3a97a807ddb451aa"));
var _RelayErrorTrie = require("cf20c58a9ec4822e");
var _RelayFeatureFlags = _interopRequireDefault(require("c6af40d148164b15"));
function handlePotentialSnapshotErrors(environment, missingRequiredFields, relayResolverErrors, errorResponseFields, throwOnFieldError) {
    var _iterator = (0, _createForOfIteratorHelper2["default"])(relayResolverErrors), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var resolverError = _step.value;
            environment.relayFieldLogger({
                kind: 'relay_resolver.error',
                owner: resolverError.field.owner,
                fieldPath: resolverError.field.path,
                error: resolverError.error
            });
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (relayResolverErrors.length > 0 && (_RelayFeatureFlags["default"].ENABLE_FIELD_ERROR_HANDLING_THROW_BY_DEFAULT || throwOnFieldError)) throw new _RelayErrorTrie.RelayFieldError("Relay: Unexpected resolver exception", relayResolverErrors.map(function(e) {
        return {
            message: e.error.message
        };
    }));
    if ((_RelayFeatureFlags["default"].ENABLE_FIELD_ERROR_HANDLING || throwOnFieldError) && errorResponseFields != null) {
        if (errorResponseFields != null) {
            var _iterator2 = (0, _createForOfIteratorHelper2["default"])(errorResponseFields), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var fieldError = _step2.value;
                    var path = fieldError.path, owner = fieldError.owner, error = fieldError.error;
                    environment.relayFieldLogger({
                        kind: 'relay_field_payload.error',
                        owner: owner,
                        fieldPath: path,
                        error: error
                    });
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        }
        if (_RelayFeatureFlags["default"].ENABLE_FIELD_ERROR_HANDLING_THROW_BY_DEFAULT || throwOnFieldError) throw new _RelayErrorTrie.RelayFieldError("Relay: Unexpected response payload - this object includes an errors property in which you can access the underlying errors", errorResponseFields.map(function(_ref) {
            var error = _ref.error;
            return error;
        }));
    }
    if (missingRequiredFields != null) switch(missingRequiredFields.action){
        case 'THROW':
            var _missingRequiredField = missingRequiredFields.field, _path = _missingRequiredField.path, _owner = _missingRequiredField.owner;
            environment.relayFieldLogger({
                kind: 'missing_field.throw',
                owner: _owner,
                fieldPath: _path
            });
            throw new Error("Relay: Missing @required value at path '".concat(_path, "' in '").concat(_owner, "'."));
        case 'LOG':
            missingRequiredFields.fields.forEach(function(_ref2) {
                var path = _ref2.path, owner = _ref2.owner;
                environment.relayFieldLogger({
                    kind: 'missing_field.log',
                    owner: owner,
                    fieldPath: path
                });
            });
            break;
        default:
            missingRequiredFields.action;
    }
}
module.exports = handlePotentialSnapshotErrors;

},{"5ab3e0d9eda62480":"590td","3a97a807ddb451aa":"fMaLa","cf20c58a9ec4822e":"dj062","c6af40d148164b15":"a0FL5"}],"dj062":[function(require,module,exports,__globalThis) {
var _instanceof = require("@swc/helpers/_/_instanceof");
'use strict';
var _interopRequireDefault = require("1a8a6c412d7b45de")["default"];
var _objectSpread2 = _interopRequireDefault(require("3ad82f5e1735e8de"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("19c9531be19392f3"));
var _createForOfIteratorHelper2 = _interopRequireDefault(require("780cd31b871a2c1e"));
var _inheritsLoose2 = _interopRequireDefault(require("a93f5a0d890ef77d"));
var _wrapNativeSuper2 = _interopRequireDefault(require("964b74a19fd52097"));
var _toConsumableArray2 = _interopRequireDefault(require("d4b725a3935a02a3"));
var _excluded = [
    "path",
    "locations"
];
var RelayFeatureFlags = require("e00cff0572862750");
var SELF = Symbol('$SELF');
var RelayFieldError = /*#__PURE__*/ function(_Error) {
    (0, _inheritsLoose2["default"])(RelayFieldError, _Error);
    function RelayFieldError(message) {
        var _this;
        var errors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        _this = _Error.call(this, message) || this;
        _this.name = 'RelayFieldError';
        _this.message = message;
        _this.errors = errors;
        return _this;
    }
    return RelayFieldError;
}(/*#__PURE__*/ (0, _wrapNativeSuper2["default"])(Error));
function buildErrorTrie(errors) {
    if (errors == null) return null;
    if (!RelayFeatureFlags.ENABLE_FIELD_ERROR_HANDLING) return null;
    var trie = new Map();
    var _iterator = (0, _createForOfIteratorHelper2["default"])(errors), _step;
    try {
        ERRORS: for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _step$value = _step.value, path = _step$value.path, _ = _step$value.locations, error = (0, _objectWithoutPropertiesLoose2["default"])(_step$value, _excluded);
            if (path == null) continue;
            var length = path.length;
            if (length === 0) continue;
            var lastIndex = length - 1;
            var currentTrie = trie;
            for(var index = 0; index < lastIndex; index++){
                var key = path[index];
                var existingValue = currentTrie.get(key);
                if ((0, _instanceof._)(existingValue, Map)) {
                    currentTrie = existingValue;
                    continue;
                }
                var newValue = new Map();
                if (Array.isArray(existingValue)) newValue.set(SELF, existingValue);
                currentTrie.set(key, newValue);
                currentTrie = newValue;
            }
            var lastKey = path[lastIndex];
            var container = currentTrie.get(lastKey);
            if ((0, _instanceof._)(container, Map)) {
                currentTrie = container;
                container = currentTrie.get(lastKey);
                lastKey = SELF;
            }
            if (Array.isArray(container)) container.push(error);
            else currentTrie.set(lastKey, [
                error
            ]);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return trie;
}
function getErrorsByKey(trie, key) {
    var value = trie.get(key);
    if (value == null) return null;
    if (Array.isArray(value)) return value;
    var errors = [];
    recursivelyCopyErrorsIntoArray(value, errors);
    return errors;
}
function recursivelyCopyErrorsIntoArray(trieOrSet, errors) {
    var _iterator2 = (0, _createForOfIteratorHelper2["default"])(trieOrSet), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var _step2$value = _step2.value, childKey = _step2$value[0], value = _step2$value[1];
            var oldLength = errors.length;
            if (Array.isArray(value)) errors.push.apply(errors, (0, _toConsumableArray2["default"])(value));
            else recursivelyCopyErrorsIntoArray(value, errors);
            if (childKey === SELF) continue;
            var newLength = errors.length;
            for(var index = oldLength; index < newLength; index++){
                var error = errors[index];
                if (error.path == null) errors[index] = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, error), {}, {
                    path: [
                        childKey
                    ]
                });
                else error.path.unshift(childKey);
            }
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
}
function getNestedErrorTrieByKey(trie, key) {
    var value = trie.get(key);
    if ((0, _instanceof._)(value, Map)) return value;
    return null;
}
module.exports = {
    SELF: SELF,
    buildErrorTrie: buildErrorTrie,
    getNestedErrorTrieByKey: getNestedErrorTrieByKey,
    getErrorsByKey: getErrorsByKey,
    RelayFieldError: RelayFieldError
};

},{"@swc/helpers/_/_instanceof":"h9UKc","1a8a6c412d7b45de":"590td","3ad82f5e1735e8de":"2Bj1n","19c9531be19392f3":"fkx57","780cd31b871a2c1e":"fMaLa","a93f5a0d890ef77d":"idPlQ","964b74a19fd52097":"81yVj","d4b725a3935a02a3":"7EBX0","e00cff0572862750":"a0FL5"}],"fkx57":[function(require,module,exports,__globalThis) {
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"idPlQ":[function(require,module,exports,__globalThis) {
var setPrototypeOf = require("b4ce3152cb163aa8");
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, setPrototypeOf(t, o);
}
module.exports = _inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"b4ce3152cb163aa8":"57E4d"}],"57E4d":[function(require,module,exports,__globalThis) {
function _setPrototypeOf(t, e) {
    return module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _setPrototypeOf(t, e);
}
module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"81yVj":[function(require,module,exports,__globalThis) {
var getPrototypeOf = require("a2deaa096426daae");
var setPrototypeOf = require("2fcff9b0ebbfbeef");
var isNativeFunction = require("dc13833a8084a49e");
var construct = require("1dd363dc5f6ddad2");
function _wrapNativeSuper(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return module.exports = _wrapNativeSuper = function _wrapNativeSuper(t) {
        if (null === t || !isNativeFunction(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return construct(t, arguments, getPrototypeOf(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), setPrototypeOf(Wrapper, t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _wrapNativeSuper(t);
}
module.exports = _wrapNativeSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"a2deaa096426daae":"175Fp","2fcff9b0ebbfbeef":"57E4d","dc13833a8084a49e":"4X9oz","1dd363dc5f6ddad2":"eBuNw"}],"175Fp":[function(require,module,exports,__globalThis) {
function _getPrototypeOf(t) {
    return module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _getPrototypeOf(t);
}
module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"4X9oz":[function(require,module,exports,__globalThis) {
function _isNativeFunction(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}
module.exports = _isNativeFunction, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"eBuNw":[function(require,module,exports,__globalThis) {
var isNativeReflectConstruct = require("953fcb0ddead270");
var setPrototypeOf = require("b39a8db55b128b08");
function _construct(t, e, r) {
    if (isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && setPrototypeOf(p, r.prototype), p;
}
module.exports = _construct, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"953fcb0ddead270":"hOs3C","b39a8db55b128b08":"57E4d"}],"hOs3C":[function(require,module,exports,__globalThis) {
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (module.exports = _isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = _isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"75uB6":[function(require,module,exports,__globalThis) {
'use strict';
var Observable = require("2163e36dd1f6930c");
var RelayReplaySubject = require("582da384b4907e4b");
var invariant = require("25145deae6b53917");
var WEAKMAP_SUPPORTED = typeof WeakMap === 'function';
var requestCachesByEnvironment = WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
function fetchQuery(environment, operation) {
    return fetchQueryDeduped(environment, operation.request.identifier, function() {
        return environment.execute({
            operation: operation
        });
    });
}
function fetchQueryDeduped(environment, identifier, fetchFn) {
    return Observable.create(function(sink) {
        var requestCache = getRequestCache(environment);
        var cachedRequest = requestCache.get(identifier);
        if (!cachedRequest) fetchFn()["finally"](function() {
            return requestCache["delete"](identifier);
        }).subscribe({
            start: function start(subscription) {
                cachedRequest = {
                    identifier: identifier,
                    subject: new RelayReplaySubject(),
                    subjectForInFlightStatus: new RelayReplaySubject(),
                    subscription: subscription,
                    promise: null
                };
                requestCache.set(identifier, cachedRequest);
            },
            next: function next(response) {
                var cachedReq = getCachedRequest(requestCache, identifier);
                cachedReq.subject.next(response);
                cachedReq.subjectForInFlightStatus.next(response);
            },
            error: function error(_error) {
                var cachedReq = getCachedRequest(requestCache, identifier);
                cachedReq.subject.error(_error);
                cachedReq.subjectForInFlightStatus.error(_error);
            },
            complete: function complete() {
                var cachedReq = getCachedRequest(requestCache, identifier);
                cachedReq.subject.complete();
                cachedReq.subjectForInFlightStatus.complete();
            },
            unsubscribe: function unsubscribe(subscription) {
                var cachedReq = getCachedRequest(requestCache, identifier);
                cachedReq.subject.unsubscribe();
                cachedReq.subjectForInFlightStatus.unsubscribe();
            }
        });
        !(cachedRequest != null) && invariant(false);
        return getObservableForCachedRequest(requestCache, cachedRequest).subscribe(sink);
    });
}
function getObservableForCachedRequest(requestCache, cachedRequest) {
    return Observable.create(function(sink) {
        var subscription = cachedRequest.subject.subscribe(sink);
        return function() {
            subscription.unsubscribe();
            var cachedRequestInstance = requestCache.get(cachedRequest.identifier);
            if (cachedRequestInstance) {
                var requestSubscription = cachedRequestInstance.subscription;
                if (requestSubscription != null && cachedRequestInstance.subject.getObserverCount() === 0) {
                    requestSubscription.unsubscribe();
                    requestCache["delete"](cachedRequest.identifier);
                }
            }
        };
    });
}
function getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest) {
    return Observable.create(function(sink) {
        var subscription = cachedRequest.subjectForInFlightStatus.subscribe({
            error: sink.error,
            next: function next(response) {
                if (!environment.isRequestActive(cachedRequest.identifier)) {
                    sink.complete();
                    return;
                }
                sink.next();
            },
            complete: sink.complete,
            unsubscribe: sink.complete
        });
        return function() {
            subscription.unsubscribe();
        };
    });
}
function getPromiseForActiveRequest(environment, request) {
    var requestCache = getRequestCache(environment);
    var cachedRequest = requestCache.get(request.identifier);
    if (!cachedRequest) return null;
    if (!environment.isRequestActive(cachedRequest.identifier)) return null;
    var promise = new Promise(function(resolve, reject) {
        var resolveOnNext = false;
        getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest).subscribe({
            complete: resolve,
            error: reject,
            next: function next(response) {
                if (resolveOnNext) resolve(response);
            }
        });
        resolveOnNext = true;
    });
    return promise;
}
function getObservableForActiveRequest(environment, request) {
    var requestCache = getRequestCache(environment);
    var cachedRequest = requestCache.get(request.identifier);
    if (!cachedRequest) return null;
    if (!environment.isRequestActive(cachedRequest.identifier)) return null;
    return getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest);
}
function getRequestCache(environment) {
    var cached = requestCachesByEnvironment.get(environment);
    if (cached != null) return cached;
    var requestCache = new Map();
    requestCachesByEnvironment.set(environment, requestCache);
    return requestCache;
}
function getCachedRequest(requestCache, identifier) {
    var cached = requestCache.get(identifier);
    !(cached != null) && invariant(false);
    return cached;
}
module.exports = {
    fetchQuery: fetchQuery,
    fetchQueryDeduped: fetchQueryDeduped,
    getPromiseForActiveRequest: getPromiseForActiveRequest,
    getObservableForActiveRequest: getObservableForActiveRequest
};

},{"2163e36dd1f6930c":"hYmcP","582da384b4907e4b":"8ePJJ","25145deae6b53917":"e2sci"}],"8ePJJ":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("1433172d09a9782e")["default"];
var _createForOfIteratorHelper2 = _interopRequireDefault(require("91e07a75a158d2ed"));
var _defineProperty2 = _interopRequireDefault(require("ea69697b96222e9e"));
var RelayObservable = require("5eecab5c47ccc0f");
var invariant = require("841bc2545ed06ce1");
var RelayReplaySubject = /*#__PURE__*/ function() {
    function RelayReplaySubject() {
        var _this = this;
        (0, _defineProperty2["default"])(this, "_complete", false);
        (0, _defineProperty2["default"])(this, "_events", []);
        (0, _defineProperty2["default"])(this, "_sinks", new Set());
        (0, _defineProperty2["default"])(this, "_subscription", []);
        this._observable = RelayObservable.create(function(sink) {
            _this._sinks.add(sink);
            var events = _this._events;
            for(var i = 0; i < events.length; i++){
                if (sink.closed) break;
                var event = events[i];
                switch(event.kind){
                    case 'complete':
                        sink.complete();
                        break;
                    case 'error':
                        sink.error(event.error);
                        break;
                    case 'next':
                        sink.next(event.data);
                        break;
                    default:
                        event.kind;
                        invariant(false);
                }
            }
            return function() {
                _this._sinks["delete"](sink);
            };
        });
    }
    var _proto = RelayReplaySubject.prototype;
    _proto.complete = function complete() {
        if (this._complete === true) return;
        this._complete = true;
        this._events.push({
            kind: 'complete'
        });
        this._sinks.forEach(function(sink) {
            return sink.complete();
        });
    };
    _proto.error = function error(_error) {
        if (this._complete === true) return;
        this._complete = true;
        this._events.push({
            kind: 'error',
            error: _error
        });
        this._sinks.forEach(function(sink) {
            return sink.error(_error);
        });
    };
    _proto.next = function next(data) {
        if (this._complete === true) return;
        this._events.push({
            kind: 'next',
            data: data
        });
        this._sinks.forEach(function(sink) {
            return sink.next(data);
        });
    };
    _proto.subscribe = function subscribe(observer) {
        var subscription = this._observable.subscribe(observer);
        this._subscription.push(subscription);
        return subscription;
    };
    _proto.unsubscribe = function unsubscribe() {
        var _iterator = (0, _createForOfIteratorHelper2["default"])(this._subscription), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var subscription = _step.value;
                subscription.unsubscribe();
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        this._subscription = [];
    };
    _proto.getObserverCount = function getObserverCount() {
        return this._sinks.size;
    };
    return RelayReplaySubject;
}();
module.exports = RelayReplaySubject;

},{"1433172d09a9782e":"590td","91e07a75a158d2ed":"fMaLa","ea69697b96222e9e":"2paQ8","5eecab5c47ccc0f":"hYmcP","841bc2545ed06ce1":"e2sci"}],"jMRnb":[function(require,module,exports,__globalThis) {
'use strict';
var _require = require("b4015b45e4de24a7"), createOperationDescriptor = _require.createOperationDescriptor;
var _require2 = require("1069830bc1d06686"), getRequest = _require2.getRequest;
function fetchQuery_DEPRECATED(environment, taggedNode, variables, cacheConfig) {
    var query = getRequest(taggedNode);
    if (query.params.operationKind !== 'query') throw new Error('fetchQuery: Expected query operation');
    var operation = createOperationDescriptor(query, variables, cacheConfig);
    return environment.execute({
        operation: operation
    }).map(function() {
        return environment.lookup(operation.fragment).data;
    }).toPromise();
}
module.exports = fetchQuery_DEPRECATED;

},{"b4015b45e4de24a7":"dSeB3","1069830bc1d06686":"8UTII"}],"kmRfk":[function(require,module,exports,__globalThis) {
'use strict';
var PreloadableQueryRegistry = /*#__PURE__*/ function() {
    function PreloadableQueryRegistry() {
        this._preloadableQueries = new Map();
        this._callbacks = new Map();
    }
    var _proto = PreloadableQueryRegistry.prototype;
    _proto.set = function set(key, value) {
        this._preloadableQueries.set(key, value);
        var callbacks = this._callbacks.get(key);
        if (callbacks != null) callbacks.forEach(function(cb) {
            try {
                cb(value);
            } catch (e) {
                setTimeout(function() {
                    throw e;
                }, 0);
            }
        });
    };
    _proto.get = function get(key) {
        return this._preloadableQueries.get(key);
    };
    _proto.onLoad = function onLoad(key, callback) {
        var _this$_callbacks$get;
        var callbacks = (_this$_callbacks$get = this._callbacks.get(key)) !== null && _this$_callbacks$get !== void 0 ? _this$_callbacks$get : new Set();
        callbacks.add(callback);
        var dispose = function dispose() {
            callbacks["delete"](callback);
        };
        this._callbacks.set(key, callbacks);
        return {
            dispose: dispose
        };
    };
    _proto.clear = function clear() {
        this._preloadableQueries.clear();
    };
    return PreloadableQueryRegistry;
}();
var preloadableQueryRegistry = new PreloadableQueryRegistry();
module.exports = preloadableQueryRegistry;

},{}],"84PBa":[function(require,module,exports,__globalThis) {
'use strict';
var RelayModernFragmentSpecResolver = require("45605511b64611e0");
var warning = require("58f3a30a91459ca9");
function createFragmentSpecResolver(context, containerName, fragments, props, rootIsQueryRenderer, callback) {
    var fragmentNames;
    return new RelayModernFragmentSpecResolver(context, fragments, props, callback, rootIsQueryRenderer);
}
module.exports = createFragmentSpecResolver;

},{"45605511b64611e0":"5arEx","58f3a30a91459ca9":"j64TH"}],"5arEx":[function(require,module,exports,__globalThis) {
var _instanceof = require("@swc/helpers/_/_instanceof");
'use strict';
var _interopRequireDefault = require("ad8baba28e3b35dc")["default"];
var _objectSpread2 = _interopRequireDefault(require("266ef77c6cb1398b"));
var _defineProperty2 = _interopRequireDefault(require("f1ddfed2757219b7"));
var getPendingOperationsForFragment = require("6ca91a2ed6422b98");
var handlePotentialSnapshotErrors = require("10d6ed44056564aa");
var isScalarAndEqual = require("60eb81baa99d85bf");
var recycleNodesInto = require("5130119e2b42fda0");
var RelayFeatureFlags = require("c706806a8bac27e2");
var _require = require("546831a14eeefb1c"), createRequestDescriptor = _require.createRequestDescriptor;
var _require2 = require("3a8aec6e2824d4e7"), areEqualSelectors = _require2.areEqualSelectors, createReaderSelector = _require2.createReaderSelector, getSelectorsFromObject = _require2.getSelectorsFromObject;
var areEqual = require("eba19665d75b5d0c");
var invariant = require("4c512455b6aa4960");
var warning = require("fad069af64d062c6");
var RelayModernFragmentSpecResolver = /*#__PURE__*/ function() {
    function RelayModernFragmentSpecResolver(context, fragments, props, callback, rootIsQueryRenderer) {
        var _this = this;
        (0, _defineProperty2["default"])(this, "_onChange", function() {
            _this._stale = true;
            if (typeof _this._callback === 'function') _this._callback();
        });
        this._callback = callback;
        this._context = context;
        this._data = {};
        this._fragments = fragments;
        this._props = {};
        this._resolvers = {};
        this._stale = false;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this.setProps(props);
    }
    var _proto = RelayModernFragmentSpecResolver.prototype;
    _proto.dispose = function dispose() {
        for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) disposeCallback(this._resolvers[key]);
    };
    _proto.resolve = function resolve() {
        if (this._stale) {
            var prevData = this._data;
            var nextData;
            for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) {
                var resolver = this._resolvers[key];
                var prevItem = prevData[key];
                if (resolver) {
                    var nextItem = resolver.resolve();
                    if (nextData || nextItem !== prevItem) {
                        nextData = nextData || (0, _objectSpread2["default"])({}, prevData);
                        nextData[key] = nextItem;
                    }
                } else {
                    var prop = this._props[key];
                    var _nextItem = prop !== undefined ? prop : null;
                    if (nextData || !isScalarAndEqual(_nextItem, prevItem)) {
                        nextData = nextData || (0, _objectSpread2["default"])({}, prevData);
                        nextData[key] = _nextItem;
                    }
                }
            }
            this._data = nextData || prevData;
            this._stale = false;
        }
        return this._data;
    };
    _proto.setCallback = function setCallback(props, callback) {
        this._callback = callback;
        if (RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) this.setProps(props);
    };
    _proto.setProps = function setProps(props) {
        this._props = {};
        var ownedSelectors = getSelectorsFromObject(this._fragments, props);
        for(var key in ownedSelectors)if (ownedSelectors.hasOwnProperty(key)) {
            var ownedSelector = ownedSelectors[key];
            var resolver = this._resolvers[key];
            if (ownedSelector == null) {
                if (resolver != null) resolver.dispose();
                resolver = null;
            } else if (ownedSelector.kind === 'PluralReaderSelector') {
                if (resolver == null) resolver = new SelectorListResolver(this._context.environment, this._rootIsQueryRenderer, ownedSelector, this._callback != null, this._onChange);
                else {
                    !(0, _instanceof._)(resolver, SelectorListResolver) && invariant(false);
                    resolver.setSelector(ownedSelector);
                }
            } else if (resolver == null) resolver = new SelectorResolver(this._context.environment, this._rootIsQueryRenderer, ownedSelector, this._callback != null, this._onChange);
            else {
                !(0, _instanceof._)(resolver, SelectorResolver) && invariant(false);
                resolver.setSelector(ownedSelector);
            }
            this._props[key] = props[key];
            this._resolvers[key] = resolver;
        }
        this._stale = true;
    };
    _proto.setVariables = function setVariables(variables, request) {
        for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) {
            var resolver = this._resolvers[key];
            if (resolver) resolver.setVariables(variables, request);
        }
        this._stale = true;
    };
    return RelayModernFragmentSpecResolver;
}();
var SelectorResolver = /*#__PURE__*/ function() {
    function SelectorResolver(environment, rootIsQueryRenderer, selector, subscribeOnConstruction, callback) {
        var _this2 = this;
        (0, _defineProperty2["default"])(this, "_onChange", function(snapshot) {
            _this2._data = snapshot.data;
            _this2._isMissingData = snapshot.isMissingData;
            _this2._missingRequiredFields = snapshot.missingRequiredFields;
            _this2._errorResponseFields = snapshot.errorResponseFields;
            _this2._relayResolverErrors = snapshot.relayResolverErrors;
            _this2._callback();
        });
        var _snapshot = environment.lookup(selector);
        this._callback = callback;
        this._data = _snapshot.data;
        this._isMissingData = _snapshot.isMissingData;
        this._missingRequiredFields = _snapshot.missingRequiredFields;
        this._errorResponseFields = _snapshot.errorResponseFields;
        this._relayResolverErrors = _snapshot.relayResolverErrors;
        this._environment = environment;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this._selector = selector;
        if (RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) {
            if (subscribeOnConstruction) this._subscription = environment.subscribe(_snapshot, this._onChange);
        } else this._subscription = environment.subscribe(_snapshot, this._onChange);
    }
    var _proto2 = SelectorResolver.prototype;
    _proto2.dispose = function dispose() {
        if (this._subscription) {
            this._subscription.dispose();
            this._subscription = null;
        }
    };
    _proto2.resolve = function resolve() {
        var _this$_selector$node$, _this$_selector$node$2;
        if (this._isMissingData === true) {
            var pendingOperationsResult = getPendingOperationsForFragment(this._environment, this._selector.node, this._selector.owner);
            var promise = pendingOperationsResult === null || pendingOperationsResult === void 0 ? void 0 : pendingOperationsResult.promise;
            if (promise != null) {
                if (this._rootIsQueryRenderer) ;
                else {
                    var _pendingOperationsRes;
                    var pendingOperations = (_pendingOperationsRes = pendingOperationsResult === null || pendingOperationsResult === void 0 ? void 0 : pendingOperationsResult.pendingOperations) !== null && _pendingOperationsRes !== void 0 ? _pendingOperationsRes : [];
                    this._environment.__log({
                        name: 'suspense.fragment',
                        data: this._data,
                        fragment: this._selector.node,
                        isRelayHooks: false,
                        isMissingData: this._isMissingData,
                        isPromiseCached: false,
                        pendingOperations: pendingOperations
                    });
                    throw promise;
                }
            }
        }
        handlePotentialSnapshotErrors(this._environment, this._missingRequiredFields, this._relayResolverErrors, this._errorResponseFields, (_this$_selector$node$ = (_this$_selector$node$2 = this._selector.node.metadata) === null || _this$_selector$node$2 === void 0 ? void 0 : _this$_selector$node$2.throwOnFieldError) !== null && _this$_selector$node$ !== void 0 ? _this$_selector$node$ : false);
        return this._data;
    };
    _proto2.setSelector = function setSelector(selector) {
        if (this._subscription != null && areEqualSelectors(selector, this._selector)) return;
        this.dispose();
        var snapshot = this._environment.lookup(selector);
        this._data = recycleNodesInto(this._data, snapshot.data);
        this._isMissingData = snapshot.isMissingData;
        this._missingRequiredFields = snapshot.missingRequiredFields;
        this._errorResponseFields = snapshot.errorResponseFields;
        this._relayResolverErrors = snapshot.relayResolverErrors;
        this._selector = selector;
        this._subscription = this._environment.subscribe(snapshot, this._onChange);
    };
    _proto2.setVariables = function setVariables(variables, request) {
        if (areEqual(variables, this._selector.variables)) return;
        var requestDescriptor = createRequestDescriptor(request, variables);
        var selector = createReaderSelector(this._selector.node, this._selector.dataID, variables, requestDescriptor);
        this.setSelector(selector);
    };
    return SelectorResolver;
}();
var SelectorListResolver = /*#__PURE__*/ function() {
    function SelectorListResolver(environment, rootIsQueryRenderer, selector, subscribeOnConstruction, callback) {
        var _this3 = this;
        (0, _defineProperty2["default"])(this, "_onChange", function(data) {
            _this3._stale = true;
            _this3._callback();
        });
        this._callback = callback;
        this._data = [];
        this._environment = environment;
        this._resolvers = [];
        this._stale = true;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this._subscribeOnConstruction = subscribeOnConstruction;
        this.setSelector(selector);
    }
    var _proto3 = SelectorListResolver.prototype;
    _proto3.dispose = function dispose() {
        this._resolvers.forEach(disposeCallback);
    };
    _proto3.resolve = function resolve() {
        if (this._stale) {
            var prevData = this._data;
            var nextData;
            for(var ii = 0; ii < this._resolvers.length; ii++){
                var prevItem = prevData[ii];
                var nextItem = this._resolvers[ii].resolve();
                if (nextData || nextItem !== prevItem) {
                    nextData = nextData || prevData.slice(0, ii);
                    nextData.push(nextItem);
                }
            }
            if (!nextData && this._resolvers.length !== prevData.length) nextData = prevData.slice(0, this._resolvers.length);
            this._data = nextData || prevData;
            this._stale = false;
        }
        return this._data;
    };
    _proto3.setSelector = function setSelector(selector) {
        var selectors = selector.selectors;
        while(this._resolvers.length > selectors.length){
            var resolver = this._resolvers.pop();
            resolver.dispose();
        }
        for(var ii = 0; ii < selectors.length; ii++)if (ii < this._resolvers.length) this._resolvers[ii].setSelector(selectors[ii]);
        else this._resolvers[ii] = new SelectorResolver(this._environment, this._rootIsQueryRenderer, selectors[ii], this._subscribeOnConstruction, this._onChange);
        this._stale = true;
    };
    _proto3.setVariables = function setVariables(variables, request) {
        this._resolvers.forEach(function(resolver) {
            return resolver.setVariables(variables, request);
        });
        this._stale = true;
    };
    return SelectorListResolver;
}();
function disposeCallback(disposable) {
    disposable && disposable.dispose();
}
module.exports = RelayModernFragmentSpecResolver;

},{"@swc/helpers/_/_instanceof":"h9UKc","ad8baba28e3b35dc":"590td","266ef77c6cb1398b":"2Bj1n","f1ddfed2757219b7":"2paQ8","6ca91a2ed6422b98":"ak3d6","10d6ed44056564aa":"kq97W","60eb81baa99d85bf":"fysSA","5130119e2b42fda0":"ij1IQ","c706806a8bac27e2":"a0FL5","546831a14eeefb1c":"dSeB3","3a8aec6e2824d4e7":"9k2Dg","eba19665d75b5d0c":"eJLuG","4c512455b6aa4960":"e2sci","fad069af64d062c6":"j64TH"}],"ak3d6":[function(require,module,exports,__globalThis) {
'use strict';
var _require = require("92e4c2c72b8a252a"), getPromiseForActiveRequest = _require.getPromiseForActiveRequest;
function getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner) {
    var _pendingOperations$ma, _pendingOperations;
    var pendingOperations = [];
    var promise = getPromiseForActiveRequest(environment, fragmentOwner);
    if (promise != null) pendingOperations = [
        fragmentOwner
    ];
    else {
        var _result$pendingOperat, _result$promise;
        var result = environment.getOperationTracker().getPendingOperationsAffectingOwner(fragmentOwner);
        pendingOperations = (_result$pendingOperat = result === null || result === void 0 ? void 0 : result.pendingOperations) !== null && _result$pendingOperat !== void 0 ? _result$pendingOperat : [];
        promise = (_result$promise = result === null || result === void 0 ? void 0 : result.promise) !== null && _result$promise !== void 0 ? _result$promise : null;
    }
    if (!promise) return null;
    var pendingOperationName = (_pendingOperations$ma = (_pendingOperations = pendingOperations) === null || _pendingOperations === void 0 ? void 0 : _pendingOperations.map(function(op) {
        return op.node.params.name;
    }).join(',')) !== null && _pendingOperations$ma !== void 0 ? _pendingOperations$ma : null;
    if (pendingOperationName == null || pendingOperationName.length === 0) pendingOperationName = 'Unknown pending operation';
    var fragmentName = fragmentNode.name;
    var promiseDisplayName = pendingOperationName === fragmentName ? "Relay(".concat(pendingOperationName, ")") : "Relay(".concat(pendingOperationName, ":").concat(fragmentName, ")");
    promise.displayName = promiseDisplayName;
    environment.__log({
        name: 'pendingoperation.found',
        fragment: fragmentNode,
        fragmentOwner: fragmentOwner,
        pendingOperations: pendingOperations
    });
    return {
        promise: promise,
        pendingOperations: pendingOperations
    };
}
module.exports = getPendingOperationsForFragment;

},{"92e4c2c72b8a252a":"75uB6"}],"fysSA":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
function isScalarAndEqual(valueA, valueB) {
    return valueA === valueB && (valueA === null || (typeof valueA === "undefined" ? "undefined" : (0, _typeOf._)(valueA)) !== 'object');
}
module.exports = isScalarAndEqual;

},{"@swc/helpers/_/_type_of":"iFJdx"}],"ij1IQ":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
function recycleNodesInto(prevData, nextData) {
    return recycleNodesIntoImpl(prevData, nextData, true);
}
function recycleNodesIntoImpl(prevData, nextData, canMutate) {
    if (prevData === nextData || (typeof prevData === "undefined" ? "undefined" : (0, _typeOf._)(prevData)) !== 'object' || !prevData || prevData.constructor !== Object && !Array.isArray(prevData) || (typeof nextData === "undefined" ? "undefined" : (0, _typeOf._)(nextData)) !== 'object' || !nextData || nextData.constructor !== Object && !Array.isArray(nextData)) return nextData;
    var canRecycle = false;
    var prevArray = Array.isArray(prevData) ? prevData : null;
    var nextArray = Array.isArray(nextData) ? nextData : null;
    if (prevArray && nextArray) {
        var canMutateNext = canMutate && !Object.isFrozen(nextArray);
        canRecycle = nextArray.reduce(function(wasEqual, nextItem, ii) {
            var prevValue = prevArray[ii];
            var nextValue = recycleNodesIntoImpl(prevValue, nextItem, canMutateNext);
            if (nextValue !== nextArray[ii] && canMutateNext) nextArray[ii] = nextValue;
            return wasEqual && nextValue === prevArray[ii];
        }, true) && prevArray.length === nextArray.length;
    } else if (!prevArray && !nextArray) {
        var prevObject = prevData;
        var nextObject = nextData;
        var prevKeys = Object.keys(prevObject);
        var nextKeys = Object.keys(nextObject);
        var _canMutateNext = canMutate && !Object.isFrozen(nextObject);
        canRecycle = nextKeys.reduce(function(wasEqual, key) {
            var prevValue = prevObject[key];
            var nextValue = recycleNodesIntoImpl(prevValue, nextObject[key], _canMutateNext);
            if (nextValue !== nextObject[key] && _canMutateNext) nextObject[key] = nextValue;
            return wasEqual && nextValue === prevObject[key];
        }, true) && prevKeys.length === nextKeys.length;
    }
    return canRecycle ? prevData : nextData;
}
module.exports = recycleNodesInto;

},{"@swc/helpers/_/_type_of":"iFJdx"}],"fJ0BV":[function(require,module,exports,__globalThis) {
'use strict';
var invariant = require("6094b624c44af8ff");
var relayContext;
var firstReact;
function createRelayContext(react) {
    if (!relayContext) {
        relayContext = react.createContext(null);
        firstReact = react;
    }
    !(react === firstReact) && invariant(false);
    return relayContext;
}
module.exports = createRelayContext;

},{"6094b624c44af8ff":"e2sci"}],"kMvlq":[function(require,module,exports,__globalThis) {
'use strict';
var LIVE_RESOLVER_SUSPENSE_SENTINEL = Object.freeze({
    __LIVE_RESOLVER_SUSPENSE_SENTINEL: true
});
function suspenseSentinel() {
    return LIVE_RESOLVER_SUSPENSE_SENTINEL;
}
function isSuspenseSentinel(value) {
    return value === LIVE_RESOLVER_SUSPENSE_SENTINEL;
}
module.exports = {
    isSuspenseSentinel: isSuspenseSentinel,
    suspenseSentinel: suspenseSentinel
};

},{}],"afJiB":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("89a6f60a7fe0471f")["default"];
var _objectSpread2 = _interopRequireDefault(require("5fd80aa7c8d507b7"));
var _RelayModernRecord = _interopRequireDefault(require("abeecd2d3612def0"));
var _RelayRecordSource = _interopRequireDefault(require("6894c9f08269101"));
var _RelayResponseNormalizer = _interopRequireDefault(require("873761baf9790bf9"));
function normalizeResponse(response, selector, typeName, options) {
    var _response$extensions;
    var data = response.data, errors = response.errors;
    var source = _RelayRecordSource["default"].create();
    var record = _RelayModernRecord["default"].create(selector.dataID, typeName);
    source.set(selector.dataID, record);
    var relayPayload = _RelayResponseNormalizer["default"].normalize(source, selector, data, options, errors);
    return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, relayPayload), {}, {
        isFinal: ((_response$extensions = response.extensions) === null || _response$extensions === void 0 ? void 0 : _response$extensions.is_final) === true
    });
}
module.exports = normalizeResponse;

},{"89a6f60a7fe0471f":"590td","5fd80aa7c8d507b7":"2Bj1n","abeecd2d3612def0":"daXOB","6894c9f08269101":"6w3KR","873761baf9790bf9":"1Dhjb"}],"daXOB":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var _interopRequireDefault = require("e20934cce7870264")["default"];
var _defineProperty2 = _interopRequireDefault(require("e08036c033b0f038"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("282f98f2b83101fd"));
var _toPropertyKey2 = _interopRequireDefault(require("12c6bd56199fa732"));
var _objectSpread2 = _interopRequireDefault(require("5f7272e8a766f1ca"));
var deepFreeze = require("bb1eb520f7249af5");
var _require = require("f69f2f81d03f7f45"), generateClientObjectClientID = _require.generateClientObjectClientID, isClientID = _require.isClientID;
var _require2 = require("bd3ef5ac7ada0551"), isSuspenseSentinel = _require2.isSuspenseSentinel;
var _require3 = require("260160fd026eb8a"), ACTOR_IDENTIFIER_KEY = _require3.ACTOR_IDENTIFIER_KEY, ERRORS_KEY = _require3.ERRORS_KEY, ID_KEY = _require3.ID_KEY, INVALIDATED_AT_KEY = _require3.INVALIDATED_AT_KEY, REF_KEY = _require3.REF_KEY, REFS_KEY = _require3.REFS_KEY, RELAY_RESOLVER_VALUE_KEY = _require3.RELAY_RESOLVER_VALUE_KEY, ROOT_ID = _require3.ROOT_ID, TYPENAME_KEY = _require3.TYPENAME_KEY;
var areEqual = require("94ae5de66fe5c308");
var invariant = require("76863a3a6402fa54");
var warning = require("f92f3aed29cf0106");
function clone(record) {
    return (0, _objectSpread2["default"])({}, record);
}
function copyFields(source, sink) {
    for(var key in source){
        if (source.hasOwnProperty(key)) {
            if (key !== ID_KEY && key !== TYPENAME_KEY) sink[key] = source[key];
        }
    }
}
function create(dataID, typeName) {
    var record = {};
    record[ID_KEY] = dataID;
    record[TYPENAME_KEY] = typeName;
    return record;
}
function fromObject(json) {
    return json;
}
function getDataID(record) {
    return record[ID_KEY];
}
function getFields(record) {
    if (ERRORS_KEY in record) return Object.keys(record).filter(function(field) {
        return field !== ERRORS_KEY;
    });
    return Object.keys(record);
}
function getType(record) {
    return record[TYPENAME_KEY];
}
function getErrors(record, storageKey) {
    var _record$ERRORS_KEY;
    return (_record$ERRORS_KEY = record[ERRORS_KEY]) === null || _record$ERRORS_KEY === void 0 ? void 0 : _record$ERRORS_KEY[storageKey];
}
function getValue(record, storageKey) {
    var value = record[storageKey];
    if (value && (typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) === 'object') !(!value.hasOwnProperty(REF_KEY) && !value.hasOwnProperty(REFS_KEY)) && invariant(false);
    return value;
}
function hasValue(record, storageKey) {
    return storageKey in record;
}
function getLinkedRecordID(record, storageKey) {
    var maybeLink = record[storageKey];
    if (maybeLink == null) return maybeLink;
    var link = maybeLink;
    !((typeof link === "undefined" ? "undefined" : (0, _typeOf._)(link)) === 'object' && link && typeof link[REF_KEY] === 'string') && invariant(false);
    return link[REF_KEY];
}
function hasLinkedRecordID(record, storageKey) {
    var maybeLink = record[storageKey];
    if (maybeLink == null) return false;
    var link = maybeLink;
    return (typeof link === "undefined" ? "undefined" : (0, _typeOf._)(link)) === 'object' && link && typeof link[REF_KEY] === 'string';
}
function getLinkedRecordIDs(record, storageKey) {
    var links = record[storageKey];
    if (links == null) return links;
    !((typeof links === "undefined" ? "undefined" : (0, _typeOf._)(links)) === 'object' && Array.isArray(links[REFS_KEY])) && invariant(false);
    return links[REFS_KEY];
}
function hasLinkedRecordIDs(record, storageKey) {
    var links = record[storageKey];
    if (links == null) return false;
    return (typeof links === "undefined" ? "undefined" : (0, _typeOf._)(links)) === 'object' && Array.isArray(links[REFS_KEY]) && links[REFS_KEY].every(function(link) {
        return typeof link === 'string';
    });
}
function getInvalidationEpoch(record) {
    if (record == null) return null;
    var invalidatedAt = record[INVALIDATED_AT_KEY];
    if (typeof invalidatedAt !== 'number') return null;
    return invalidatedAt;
}
function update(prevRecord, nextRecord) {
    var _updated2;
    var _getType, _getType2, prevID, nextID, prevType, nextType;
    var prevErrorsByKey = prevRecord[ERRORS_KEY];
    var nextErrorsByKey = nextRecord[ERRORS_KEY];
    var updated = null;
    if (prevErrorsByKey == null && nextErrorsByKey == null) {
        var _updated;
        for(var storageKey in nextRecord)if (updated || !areEqual(prevRecord[storageKey], nextRecord[storageKey])) {
            updated = updated !== null ? updated : (0, _objectSpread2["default"])({}, prevRecord);
            updated[storageKey] = nextRecord[storageKey];
        }
        return (_updated = updated) !== null && _updated !== void 0 ? _updated : prevRecord;
    }
    for(var _storageKey2 in nextRecord){
        if (_storageKey2 === ERRORS_KEY) continue;
        var nextValue = nextRecord[_storageKey2];
        var nextErrors = nextErrorsByKey === null || nextErrorsByKey === void 0 ? void 0 : nextErrorsByKey[_storageKey2];
        if (updated == null) {
            var prevValue = prevRecord[_storageKey2];
            var prevErrors = prevErrorsByKey === null || prevErrorsByKey === void 0 ? void 0 : prevErrorsByKey[_storageKey2];
            if (areEqual(prevValue, nextValue) && areEqual(prevErrors, nextErrors)) continue;
            updated = (0, _objectSpread2["default"])({}, prevRecord);
            if (prevErrorsByKey != null) updated[ERRORS_KEY] = (0, _objectSpread2["default"])({}, prevErrorsByKey);
        }
        setValue(updated, _storageKey2, nextValue);
        setErrors(updated, _storageKey2, nextErrors);
    }
    return (_updated2 = updated) !== null && _updated2 !== void 0 ? _updated2 : prevRecord;
}
function merge(record1, record2) {
    var _getType3, _getType4, prevID, nextID, prevType, nextType;
    if (ERRORS_KEY in record1 || ERRORS_KEY in record2) {
        var errors1 = record1[ERRORS_KEY], fields1 = (0, _objectWithoutPropertiesLoose2["default"])(record1, [
            ERRORS_KEY
        ].map(_toPropertyKey2["default"]));
        var errors2 = record2[ERRORS_KEY], fields2 = (0, _objectWithoutPropertiesLoose2["default"])(record2, [
            ERRORS_KEY
        ].map(_toPropertyKey2["default"]));
        var updated = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, fields1), fields2);
        if (errors1 == null && errors2 == null) return updated;
        var updatedErrors = {};
        for(var storageKey in errors1){
            if (fields2.hasOwnProperty(storageKey)) continue;
            updatedErrors[storageKey] = errors1[storageKey];
        }
        for(var _storageKey3 in errors2)updatedErrors[_storageKey3] = errors2[_storageKey3];
        for(var _storageKey in updatedErrors){
            updated[ERRORS_KEY] = updatedErrors;
            break;
        }
        return updated;
    } else return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, record1), record2);
}
function freeze(record) {
    deepFreeze(record);
}
function setErrors(record, storageKey, errors) {
    var errorsByStorageKey = record[ERRORS_KEY];
    if (errors != null && errors.length > 0) {
        if (errorsByStorageKey == null) record[ERRORS_KEY] = (0, _defineProperty2["default"])({}, storageKey, errors);
        else errorsByStorageKey[storageKey] = errors;
    } else if (errorsByStorageKey != null) {
        if (delete errorsByStorageKey[storageKey]) {
            for(var otherStorageKey in errorsByStorageKey){
                if (errorsByStorageKey.hasOwnProperty(otherStorageKey)) return;
            }
            delete record[ERRORS_KEY];
        }
    }
}
function setValue(record, storageKey, value) {
    var prevID, _getType5, prevType, nextType;
    record[storageKey] = value;
}
function setLinkedRecordID(record, storageKey, linkedID) {
    var link = {};
    link[REF_KEY] = linkedID;
    record[storageKey] = link;
}
function setLinkedRecordIDs(record, storageKey, linkedIDs) {
    var links = {};
    links[REFS_KEY] = linkedIDs;
    record[storageKey] = links;
}
function setActorLinkedRecordID(record, storageKey, actorIdentifier, linkedID) {
    var link = {};
    link[REF_KEY] = linkedID;
    link[ACTOR_IDENTIFIER_KEY] = actorIdentifier;
    record[storageKey] = link;
}
function getActorLinkedRecordID(record, storageKey) {
    var link = record[storageKey];
    if (link == null) return link;
    !((typeof link === "undefined" ? "undefined" : (0, _typeOf._)(link)) === 'object' && typeof link[REF_KEY] === 'string' && link[ACTOR_IDENTIFIER_KEY] != null) && invariant(false);
    return [
        link[ACTOR_IDENTIFIER_KEY],
        link[REF_KEY]
    ];
}
function getResolverLinkedRecordID(record, typeName) {
    var id = getValue(record, RELAY_RESOLVER_VALUE_KEY);
    if (id == null || isSuspenseSentinel(id)) return null;
    if ((typeof id === "undefined" ? "undefined" : (0, _typeOf._)(id)) === 'object') id = id.id;
    !(typeof id === 'string') && invariant(false);
    return generateClientObjectClientID(typeName, id);
}
function getResolverLinkedRecordIDs(record, typeName) {
    var resolverValue = getValue(record, RELAY_RESOLVER_VALUE_KEY);
    if (resolverValue == null || isSuspenseSentinel(resolverValue)) return null;
    !Array.isArray(resolverValue) && invariant(false);
    return resolverValue.map(function(id) {
        if (id == null) return null;
        if ((typeof id === "undefined" ? "undefined" : (0, _typeOf._)(id)) === 'object') id = id.id;
        !(typeof id === 'string') && invariant(false);
        return generateClientObjectClientID(typeName, id);
    });
}
function toJSON(record) {
    return record;
}
module.exports = {
    clone: clone,
    copyFields: copyFields,
    create: create,
    freeze: freeze,
    fromObject: fromObject,
    getDataID: getDataID,
    getErrors: getErrors,
    getFields: getFields,
    getInvalidationEpoch: getInvalidationEpoch,
    getLinkedRecordID: getLinkedRecordID,
    getLinkedRecordIDs: getLinkedRecordIDs,
    getType: getType,
    getValue: getValue,
    hasValue: hasValue,
    hasLinkedRecordID: hasLinkedRecordID,
    hasLinkedRecordIDs: hasLinkedRecordIDs,
    merge: merge,
    setErrors: setErrors,
    setValue: setValue,
    setLinkedRecordID: setLinkedRecordID,
    setLinkedRecordIDs: setLinkedRecordIDs,
    update: update,
    getActorLinkedRecordID: getActorLinkedRecordID,
    setActorLinkedRecordID: setActorLinkedRecordID,
    getResolverLinkedRecordID: getResolverLinkedRecordID,
    getResolverLinkedRecordIDs: getResolverLinkedRecordIDs,
    toJSON: toJSON
};

},{"@swc/helpers/_/_type_of":"iFJdx","e20934cce7870264":"590td","e08036c033b0f038":"2paQ8","282f98f2b83101fd":"fkx57","12c6bd56199fa732":"ipoCP","5f7272e8a766f1ca":"2Bj1n","bb1eb520f7249af5":"eLea7","f69f2f81d03f7f45":"gL1rB","bd3ef5ac7ada0551":"kMvlq","260160fd026eb8a":"3QcrW","94ae5de66fe5c308":"eJLuG","76863a3a6402fa54":"e2sci","f92f3aed29cf0106":"j64TH"}],"6w3KR":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("2571edd9ed37d478")["default"];
var _createForOfIteratorHelper2 = _interopRequireDefault(require("2f61beb282e04314"));
var RelayModernRecord = require("fdfab58980a672ff");
var RelayRecordState = require("aa2b59f778ea6d7b");
var EXISTENT = RelayRecordState.EXISTENT, NONEXISTENT = RelayRecordState.NONEXISTENT, UNKNOWN = RelayRecordState.UNKNOWN;
var RelayRecordSource = /*#__PURE__*/ function() {
    function RelayRecordSource(records) {
        var _this = this;
        this._records = new Map();
        if (records != null) Object.keys(records).forEach(function(key) {
            var object = records[key];
            var record = RelayModernRecord.fromObject(object);
            _this._records.set(key, record);
        });
    }
    RelayRecordSource.create = function create(records) {
        return new RelayRecordSource(records);
    };
    var _proto = RelayRecordSource.prototype;
    _proto.clear = function clear() {
        this._records = new Map();
    };
    _proto["delete"] = function _delete(dataID) {
        this._records.set(dataID, null);
    };
    _proto.get = function get(dataID) {
        return this._records.get(dataID);
    };
    _proto.getRecordIDs = function getRecordIDs() {
        return Array.from(this._records.keys());
    };
    _proto.getStatus = function getStatus(dataID) {
        if (!this._records.has(dataID)) return UNKNOWN;
        return this._records.get(dataID) == null ? NONEXISTENT : EXISTENT;
    };
    _proto.has = function has(dataID) {
        return this._records.has(dataID);
    };
    _proto.remove = function remove(dataID) {
        this._records["delete"](dataID);
    };
    _proto.set = function set(dataID, record) {
        this._records.set(dataID, record);
    };
    _proto.size = function size() {
        return this._records.size;
    };
    _proto.toJSON = function toJSON() {
        var obj = {};
        var _iterator = (0, _createForOfIteratorHelper2["default"])(this._records), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _step$value = _step.value, key = _step$value[0], record = _step$value[1];
                obj[key] = RelayModernRecord.toJSON(record);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return obj;
    };
    return RelayRecordSource;
}();
module.exports = RelayRecordSource;

},{"2571edd9ed37d478":"590td","2f61beb282e04314":"fMaLa","fdfab58980a672ff":"daXOB","aa2b59f778ea6d7b":"7LnXj"}],"7LnXj":[function(require,module,exports,__globalThis) {
'use strict';
var RelayRecordState = {
    EXISTENT: 'EXISTENT',
    NONEXISTENT: 'NONEXISTENT',
    UNKNOWN: 'UNKNOWN'
};
module.exports = RelayRecordState;

},{}],"1Dhjb":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var _interopRequireDefault = require("df873de760308e88")["default"];
var _createForOfIteratorHelper2 = _interopRequireDefault(require("19e4715e54880d79"));
var _toConsumableArray2 = _interopRequireDefault(require("376bd52f74ec2411"));
var _require = require("1fd477e672927e5d"), ACTOR_IDENTIFIER_FIELD_NAME = _require.ACTOR_IDENTIFIER_FIELD_NAME, getActorIdentifierFromPayload = _require.getActorIdentifierFromPayload;
var _require2 = require("fcb753873f81a608"), ACTOR_CHANGE = _require2.ACTOR_CHANGE, CLIENT_COMPONENT = _require2.CLIENT_COMPONENT, CLIENT_EDGE_TO_CLIENT_OBJECT = _require2.CLIENT_EDGE_TO_CLIENT_OBJECT, CLIENT_EXTENSION = _require2.CLIENT_EXTENSION, CONDITION = _require2.CONDITION, DEFER = _require2.DEFER, FRAGMENT_SPREAD = _require2.FRAGMENT_SPREAD, INLINE_FRAGMENT = _require2.INLINE_FRAGMENT, LINKED_FIELD = _require2.LINKED_FIELD, LINKED_HANDLE = _require2.LINKED_HANDLE, MODULE_IMPORT = _require2.MODULE_IMPORT, RELAY_LIVE_RESOLVER = _require2.RELAY_LIVE_RESOLVER, RELAY_RESOLVER = _require2.RELAY_RESOLVER, SCALAR_FIELD = _require2.SCALAR_FIELD, SCALAR_HANDLE = _require2.SCALAR_HANDLE, STREAM = _require2.STREAM, TYPE_DISCRIMINATOR = _require2.TYPE_DISCRIMINATOR;
var _require3 = require("5e368c51eb018148"), generateClientID = _require3.generateClientID, isClientID = _require3.isClientID;
var _require4 = require("371725a1b48f4443"), getLocalVariables = _require4.getLocalVariables;
var _require5 = require("fc29a7bfd7cc2cca"), buildErrorTrie = _require5.buildErrorTrie, getErrorsByKey = _require5.getErrorsByKey, getNestedErrorTrieByKey = _require5.getNestedErrorTrieByKey;
var RelayModernRecord = require("501de5d45a194d3d");
var _require6 = require("5d77e8646a841006"), createNormalizationSelector = _require6.createNormalizationSelector;
var _require7 = require("a74ea9d1e672473e"), ROOT_ID = _require7.ROOT_ID, TYPENAME_KEY = _require7.TYPENAME_KEY, getArgumentValues = _require7.getArgumentValues, getHandleStorageKey = _require7.getHandleStorageKey, getModuleComponentKey = _require7.getModuleComponentKey, getModuleOperationKey = _require7.getModuleOperationKey, getStorageKey = _require7.getStorageKey;
var _require8 = require("b80a2e178be1bab0"), TYPE_SCHEMA_TYPE = _require8.TYPE_SCHEMA_TYPE, generateTypeID = _require8.generateTypeID;
var areEqual = require("59b07874f96837bc");
var invariant = require("da88fa14bc87d3ff");
var warning = require("54c27045d9023979");
function normalize(recordSource, selector, response, options, errors) {
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var normalizer = new RelayResponseNormalizer(recordSource, variables, options);
    return normalizer.normalizeResponse(node, dataID, response, errors);
}
var RelayResponseNormalizer = /*#__PURE__*/ function() {
    function RelayResponseNormalizer(recordSource, variables, options) {
        this._actorIdentifier = options.actorIdentifier;
        this._getDataId = options.getDataID;
        this._handleFieldPayloads = [];
        this._treatMissingFieldsAsNull = options.treatMissingFieldsAsNull;
        this._incrementalPlaceholders = [];
        this._isClientExtension = false;
        this._isUnmatchedAbstractType = false;
        this._followupPayloads = [];
        this._path = options.path ? (0, _toConsumableArray2["default"])(options.path) : [];
        this._recordSource = recordSource;
        this._variables = variables;
        this._shouldProcessClientComponents = options.shouldProcessClientComponents;
    }
    var _proto = RelayResponseNormalizer.prototype;
    _proto.normalizeResponse = function normalizeResponse(node, dataID, data, errors) {
        var record = this._recordSource.get(dataID);
        !record && invariant(false);
        this._assignClientAbstractTypes(node);
        this._errorTrie = buildErrorTrie(errors);
        this._traverseSelections(node, record, data);
        return {
            errors: errors,
            fieldPayloads: this._handleFieldPayloads,
            incrementalPlaceholders: this._incrementalPlaceholders,
            followupPayloads: this._followupPayloads,
            source: this._recordSource,
            isFinal: false
        };
    };
    _proto._assignClientAbstractTypes = function _assignClientAbstractTypes(node) {
        var clientAbstractTypes = node.clientAbstractTypes;
        if (clientAbstractTypes != null) for(var _i = 0, _Object$keys = Object.keys(clientAbstractTypes); _i < _Object$keys.length; _i++){
            var abstractType = _Object$keys[_i];
            var _iterator = (0, _createForOfIteratorHelper2["default"])(clientAbstractTypes[abstractType]), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var concreteType = _step.value;
                    var typeID = generateTypeID(concreteType);
                    var typeRecord = this._recordSource.get(typeID);
                    if (typeRecord == null) {
                        typeRecord = RelayModernRecord.create(typeID, TYPE_SCHEMA_TYPE);
                        this._recordSource.set(typeID, typeRecord);
                    }
                    RelayModernRecord.setValue(typeRecord, abstractType, true);
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && invariant(false);
        return this._variables[name];
    };
    _proto._getRecordType = function _getRecordType(data) {
        var typeName = data[TYPENAME_KEY];
        !(typeName != null) && invariant(false);
        return typeName;
    };
    _proto._traverseSelections = function _traverseSelections(node, record, data) {
        for(var i = 0; i < node.selections.length; i++){
            var selection = node.selections[i];
            switch(selection.kind){
                case SCALAR_FIELD:
                case LINKED_FIELD:
                    this._normalizeField(selection, record, data);
                    break;
                case CONDITION:
                    var conditionValue = Boolean(this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) this._traverseSelections(selection, record, data);
                    break;
                case FRAGMENT_SPREAD:
                    var prevVariables = this._variables;
                    this._variables = getLocalVariables(this._variables, selection.fragment.argumentDefinitions, selection.args);
                    this._traverseSelections(selection.fragment, record, data);
                    this._variables = prevVariables;
                    break;
                case INLINE_FRAGMENT:
                    var abstractKey = selection.abstractKey;
                    if (abstractKey == null) {
                        var typeName = RelayModernRecord.getType(record);
                        if (typeName === selection.type) this._traverseSelections(selection, record, data);
                    } else {
                        var implementsInterface = data.hasOwnProperty(abstractKey);
                        var _typeName = RelayModernRecord.getType(record);
                        var typeID = generateTypeID(_typeName);
                        var typeRecord = this._recordSource.get(typeID);
                        if (typeRecord == null) {
                            typeRecord = RelayModernRecord.create(typeID, TYPE_SCHEMA_TYPE);
                            this._recordSource.set(typeID, typeRecord);
                        }
                        RelayModernRecord.setValue(typeRecord, abstractKey, implementsInterface);
                        if (implementsInterface) this._traverseSelections(selection, record, data);
                    }
                    break;
                case TYPE_DISCRIMINATOR:
                    var _abstractKey = selection.abstractKey;
                    var _implementsInterface = data.hasOwnProperty(_abstractKey);
                    var _typeName2 = RelayModernRecord.getType(record);
                    var _typeID = generateTypeID(_typeName2);
                    var _typeRecord = this._recordSource.get(_typeID);
                    if (_typeRecord == null) {
                        _typeRecord = RelayModernRecord.create(_typeID, TYPE_SCHEMA_TYPE);
                        this._recordSource.set(_typeID, _typeRecord);
                    }
                    RelayModernRecord.setValue(_typeRecord, _abstractKey, _implementsInterface);
                    break;
                case LINKED_HANDLE:
                case SCALAR_HANDLE:
                    var args = selection.args ? getArgumentValues(selection.args, this._variables) : {};
                    var fieldKey = getStorageKey(selection, this._variables);
                    var handleKey = getHandleStorageKey(selection, this._variables);
                    this._handleFieldPayloads.push({
                        args: args,
                        dataID: RelayModernRecord.getDataID(record),
                        fieldKey: fieldKey,
                        handle: selection.handle,
                        handleKey: handleKey,
                        handleArgs: selection.handleArgs ? getArgumentValues(selection.handleArgs, this._variables) : {}
                    });
                    break;
                case MODULE_IMPORT:
                    this._normalizeModuleImport(selection, record, data);
                    break;
                case DEFER:
                    this._normalizeDefer(selection, record, data);
                    break;
                case STREAM:
                    this._normalizeStream(selection, record, data);
                    break;
                case CLIENT_EXTENSION:
                    var isClientExtension = this._isClientExtension;
                    this._isClientExtension = true;
                    this._traverseSelections(selection, record, data);
                    this._isClientExtension = isClientExtension;
                    break;
                case CLIENT_COMPONENT:
                    if (this._shouldProcessClientComponents === false) break;
                    this._traverseSelections(selection.fragment, record, data);
                    break;
                case ACTOR_CHANGE:
                    this._normalizeActorChange(selection, record, data);
                    break;
                case RELAY_RESOLVER:
                    this._normalizeResolver(selection, record, data);
                    break;
                case RELAY_LIVE_RESOLVER:
                    this._normalizeResolver(selection, record, data);
                    break;
                case CLIENT_EDGE_TO_CLIENT_OBJECT:
                    this._normalizeResolver(selection.backingField, record, data);
                    break;
                default:
                    selection;
                    invariant(false);
            }
        }
    };
    _proto._normalizeResolver = function _normalizeResolver(resolver, record, data) {
        if (resolver.fragment != null) this._traverseSelections(resolver.fragment, record, data);
    };
    _proto._normalizeDefer = function _normalizeDefer(defer, record, data) {
        var isDeferred = defer["if"] === null || this._getVariableValue(defer["if"]);
        if (isDeferred === false) this._traverseSelections(defer, record, data);
        else this._incrementalPlaceholders.push({
            kind: 'defer',
            data: data,
            label: defer.label,
            path: (0, _toConsumableArray2["default"])(this._path),
            selector: createNormalizationSelector(defer, RelayModernRecord.getDataID(record), this._variables),
            typeName: RelayModernRecord.getType(record),
            actorIdentifier: this._actorIdentifier
        });
    };
    _proto._normalizeStream = function _normalizeStream(stream, record, data) {
        this._traverseSelections(stream, record, data);
        var isStreamed = stream["if"] === null || this._getVariableValue(stream["if"]);
        if (isStreamed === true) this._incrementalPlaceholders.push({
            kind: 'stream',
            label: stream.label,
            path: (0, _toConsumableArray2["default"])(this._path),
            parentID: RelayModernRecord.getDataID(record),
            node: stream,
            variables: this._variables,
            actorIdentifier: this._actorIdentifier
        });
    };
    _proto._normalizeModuleImport = function _normalizeModuleImport(moduleImport, record, data) {
        !((typeof data === "undefined" ? "undefined" : (0, _typeOf._)(data)) === 'object' && data) && invariant(false);
        var typeName = RelayModernRecord.getType(record);
        var componentKey = getModuleComponentKey(moduleImport.documentName);
        var componentReference = moduleImport.componentModuleProvider || data[componentKey];
        RelayModernRecord.setValue(record, componentKey, componentReference !== null && componentReference !== void 0 ? componentReference : null);
        var operationKey = getModuleOperationKey(moduleImport.documentName);
        var operationReference = moduleImport.operationModuleProvider || data[operationKey];
        RelayModernRecord.setValue(record, operationKey, operationReference !== null && operationReference !== void 0 ? operationReference : null);
        if (operationReference != null) this._followupPayloads.push({
            kind: 'ModuleImportPayload',
            args: moduleImport.args,
            data: data,
            dataID: RelayModernRecord.getDataID(record),
            operationReference: operationReference,
            path: (0, _toConsumableArray2["default"])(this._path),
            typeName: typeName,
            variables: this._variables,
            actorIdentifier: this._actorIdentifier
        });
    };
    _proto._normalizeField = function _normalizeField(selection, record, data) {
        !((typeof data === "undefined" ? "undefined" : (0, _typeOf._)(data)) === 'object' && data) && invariant(false);
        var responseKey = selection.alias || selection.name;
        var storageKey = getStorageKey(selection, this._variables);
        var fieldValue = data[responseKey];
        if (fieldValue == null) {
            if (fieldValue === undefined) {
                var isOptionalField = this._isClientExtension || this._isUnmatchedAbstractType;
                if (isOptionalField) return;
                else if (!this._treatMissingFieldsAsNull) return;
            }
            RelayModernRecord.setValue(record, storageKey, null);
            var errorTrie = this._errorTrie;
            if (errorTrie != null) {
                var errors = getErrorsByKey(errorTrie, responseKey);
                if (errors != null) RelayModernRecord.setErrors(record, storageKey, errors);
            }
            return;
        }
        if (selection.kind === SCALAR_FIELD) RelayModernRecord.setValue(record, storageKey, fieldValue);
        else if (selection.kind === LINKED_FIELD) {
            this._path.push(responseKey);
            var oldErrorTrie = this._errorTrie;
            this._errorTrie = oldErrorTrie == null ? null : getNestedErrorTrieByKey(oldErrorTrie, responseKey);
            if (selection.plural) this._normalizePluralLink(selection, record, storageKey, fieldValue);
            else this._normalizeLink(selection, record, storageKey, fieldValue);
            this._errorTrie = oldErrorTrie;
            this._path.pop();
        } else {
            selection;
            invariant(false);
        }
    };
    _proto._normalizeActorChange = function _normalizeActorChange(selection, record, data) {
        var _field$concreteType;
        var field = selection.linkedField;
        !((typeof data === "undefined" ? "undefined" : (0, _typeOf._)(data)) === 'object' && data) && invariant(false);
        var responseKey = field.alias || field.name;
        var storageKey = getStorageKey(field, this._variables);
        var fieldValue = data[responseKey];
        if (fieldValue == null) {
            if (fieldValue === undefined) {
                var isOptionalField = this._isClientExtension || this._isUnmatchedAbstractType;
                if (isOptionalField) return;
                else if (!this._treatMissingFieldsAsNull) return;
            }
            RelayModernRecord.setValue(record, storageKey, null);
            return;
        }
        var actorIdentifier = getActorIdentifierFromPayload(fieldValue);
        if (actorIdentifier == null) {
            RelayModernRecord.setValue(record, storageKey, null);
            return;
        }
        var typeName = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : this._getRecordType(fieldValue);
        var nextID = this._getDataId(fieldValue, typeName) || RelayModernRecord.getLinkedRecordID(record, storageKey) || generateClientID(RelayModernRecord.getDataID(record), storageKey);
        !(typeof nextID === 'string') && invariant(false);
        RelayModernRecord.setActorLinkedRecordID(record, storageKey, actorIdentifier, nextID);
        this._followupPayloads.push({
            kind: 'ActorPayload',
            data: fieldValue,
            dataID: nextID,
            path: [].concat((0, _toConsumableArray2["default"])(this._path), [
                responseKey
            ]),
            typeName: typeName,
            variables: this._variables,
            node: field,
            actorIdentifier: actorIdentifier
        });
    };
    _proto._normalizeLink = function _normalizeLink(field, record, storageKey, fieldValue) {
        var _field$concreteType2;
        !((typeof fieldValue === "undefined" ? "undefined" : (0, _typeOf._)(fieldValue)) === 'object' && fieldValue) && invariant(false);
        var nextID = this._getDataId(fieldValue, (_field$concreteType2 = field.concreteType) !== null && _field$concreteType2 !== void 0 ? _field$concreteType2 : this._getRecordType(fieldValue)) || RelayModernRecord.getLinkedRecordID(record, storageKey) || generateClientID(RelayModernRecord.getDataID(record), storageKey);
        !(typeof nextID === 'string') && invariant(false);
        RelayModernRecord.setLinkedRecordID(record, storageKey, nextID);
        var nextRecord = this._recordSource.get(nextID);
        if (!nextRecord) {
            var typeName = field.concreteType || this._getRecordType(fieldValue);
            nextRecord = RelayModernRecord.create(nextID, typeName);
            this._recordSource.set(nextID, nextRecord);
        }
        this._traverseSelections(field, nextRecord, fieldValue);
    };
    _proto._normalizePluralLink = function _normalizePluralLink(field, record, storageKey, fieldValue) {
        var _this = this;
        !Array.isArray(fieldValue) && invariant(false);
        var prevIDs = RelayModernRecord.getLinkedRecordIDs(record, storageKey);
        var nextIDs = [];
        fieldValue.forEach(function(item, nextIndex) {
            var _field$concreteType3;
            if (item == null) {
                nextIDs.push(item);
                return;
            }
            _this._path.push(String(nextIndex));
            var oldErrorTrie = _this._errorTrie;
            _this._errorTrie = oldErrorTrie == null ? null : getNestedErrorTrieByKey(oldErrorTrie, nextIndex);
            !((typeof item === "undefined" ? "undefined" : (0, _typeOf._)(item)) === 'object') && invariant(false);
            var nextID = _this._getDataId(item, (_field$concreteType3 = field.concreteType) !== null && _field$concreteType3 !== void 0 ? _field$concreteType3 : _this._getRecordType(item)) || prevIDs && prevIDs[nextIndex] || generateClientID(RelayModernRecord.getDataID(record), storageKey, nextIndex);
            !(typeof nextID === 'string') && invariant(false);
            nextIDs.push(nextID);
            var nextRecord = _this._recordSource.get(nextID);
            if (!nextRecord) {
                var typeName = field.concreteType || _this._getRecordType(item);
                nextRecord = RelayModernRecord.create(nextID, typeName);
                _this._recordSource.set(nextID, nextRecord);
            }
            _this._traverseSelections(field, nextRecord, item);
            _this._errorTrie = oldErrorTrie;
            _this._path.pop();
        });
        RelayModernRecord.setLinkedRecordIDs(record, storageKey, nextIDs);
    };
    _proto._validateRecordType = function _validateRecordType(record, field, payload) {
        var _field$concreteType4;
        var typeName = (_field$concreteType4 = field.concreteType) !== null && _field$concreteType4 !== void 0 ? _field$concreteType4 : this._getRecordType(payload);
        var dataID = RelayModernRecord.getDataID(record);
    };
    _proto._validateConflictingFieldsWithIdenticalId = function _validateConflictingFieldsWithIdenticalId(record, storageKey, fieldValue) {
        var dataID, previousValue;
    };
    _proto._validateConflictingLinkedFieldsWithIdenticalId = function _validateConflictingLinkedFieldsWithIdenticalId(prevID, nextID, storageKey) {};
    return RelayResponseNormalizer;
}();
module.exports = {
    normalize: normalize
};

},{"@swc/helpers/_/_type_of":"iFJdx","df873de760308e88":"590td","19e4715e54880d79":"fMaLa","376bd52f74ec2411":"7EBX0","1fd477e672927e5d":"fHHco","fcb753873f81a608":"jKskk","5e368c51eb018148":"gL1rB","371725a1b48f4443":"138Hd","fc29a7bfd7cc2cca":"dj062","501de5d45a194d3d":"daXOB","5d77e8646a841006":"9k2Dg","a74ea9d1e672473e":"3QcrW","b80a2e178be1bab0":"32ztQ","59b07874f96837bc":"eJLuG","da88fa14bc87d3ff":"e2sci","54c27045d9023979":"j64TH"}],"fHHco":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var ACTOR_IDENTIFIER_FIELD_NAME = 'actor_key';
var _require = require("6331126f47d7c070"), getActorIdentifier = _require.getActorIdentifier;
function getActorIdentifierFromPayload(payload) {
    if (payload != null && (typeof payload === "undefined" ? "undefined" : (0, _typeOf._)(payload)) === 'object' && typeof payload[ACTOR_IDENTIFIER_FIELD_NAME] === 'string') return getActorIdentifier(payload[ACTOR_IDENTIFIER_FIELD_NAME]);
}
module.exports = {
    ACTOR_IDENTIFIER_FIELD_NAME: ACTOR_IDENTIFIER_FIELD_NAME,
    getActorIdentifierFromPayload: getActorIdentifierFromPayload
};

},{"@swc/helpers/_/_type_of":"iFJdx","6331126f47d7c070":"cFrVW"}],"cFrVW":[function(require,module,exports,__globalThis) {
'use strict';
var invariant = require("defa775d903de379");
var INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = 'INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE';
function assertInternalActorIdentifier(actorIdentifier) {
    !(actorIdentifier === INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE) && invariant(false);
}
module.exports = {
    assertInternalActorIdentifier: assertInternalActorIdentifier,
    getActorIdentifier: function getActorIdentifier(actorID) {
        return actorID;
    },
    getDefaultActorIdentifier: function getDefaultActorIdentifier() {
        throw new Error('Not Implemented');
    },
    INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE: INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE
};

},{"defa775d903de379":"e2sci"}],"32ztQ":[function(require,module,exports,__globalThis) {
'use strict';
var PREFIX = 'client:__type:';
var TYPE_SCHEMA_TYPE = '__TypeSchema';
function generateTypeID(typeName) {
    return PREFIX + typeName;
}
function isTypeID(id) {
    return id.indexOf(PREFIX) === 0;
}
module.exports = {
    generateTypeID: generateTypeID,
    isTypeID: isTypeID,
    TYPE_SCHEMA_TYPE: TYPE_SCHEMA_TYPE
};

},{}],"6Td1y":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var _require = require("dc63f63d5b302131"), getInlineDataFragment = _require.getInlineDataFragment;
var _require2 = require("9f47d4cdd836a0f0"), FRAGMENTS_KEY = _require2.FRAGMENTS_KEY;
var invariant = require("21b0e475cc65ae48");
function readInlineData(fragment, fragmentRef) {
    var _fragmentRef$FRAGMENT;
    var inlineDataFragment = getInlineDataFragment(fragment);
    if (fragmentRef == null) return fragmentRef;
    !((typeof fragmentRef === "undefined" ? "undefined" : (0, _typeOf._)(fragmentRef)) === 'object') && invariant(false);
    var inlineData = (_fragmentRef$FRAGMENT = fragmentRef[FRAGMENTS_KEY]) === null || _fragmentRef$FRAGMENT === void 0 ? void 0 : _fragmentRef$FRAGMENT[inlineDataFragment.name];
    !(inlineData != null) && invariant(false);
    return inlineData;
}
module.exports = readInlineData;

},{"@swc/helpers/_/_type_of":"iFJdx","dc63f63d5b302131":"8UTII","9f47d4cdd836a0f0":"3QcrW","21b0e475cc65ae48":"e2sci"}],"3xHmQ":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("7e7a4d1fbf8c82fe")["default"];
var _objectSpread2 = _interopRequireDefault(require("6b4f3b63f4065ac0"));
var RelayDefaultHandlerProvider = require("7cea7b1ea2aa8697");
var _require = require("bc2448eae6d9e860"), INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = _require.INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, assertInternalActorIdentifier = _require.assertInternalActorIdentifier;
var RelayObservable = require("98122506f5fdd2ff");
var wrapNetworkWithLogObserver = require("f7617b7cd8a4e2b");
var RelayOperationTracker = require("83a7c02ef79bf09f");
var registerEnvironmentWithDevTools = require("e6be5f00728d6970");
var defaultGetDataID = require("b7c0545674dd33ad");
var defaultRelayFieldLogger = require("32f88f20a98f5fb0");
var normalizeResponse = require("7080a5669857b59a");
var OperationExecutor = require("c106ae6e1db32a6");
var RelayPublishQueue = require("dddf5d64bb73e9cf");
var RelayRecordSource = require("c7afdb12a0678cff");
var invariant = require("d019df3102764664");
var RelayModernEnvironment = /*#__PURE__*/ function() {
    function RelayModernEnvironment(config) {
        var _this = this;
        var _config$log, _config$relayFieldLog, _config$UNSTABLE_defa, _config$getDataID, _config$missingFieldH, _config$handlerProvid, _config$scheduler, _config$isServer, _config$normalizeResp, _config$operationTrac;
        this.configName = config.configName;
        this._treatMissingFieldsAsNull = config.treatMissingFieldsAsNull === true;
        var operationLoader = config.operationLoader;
        this.__log = (_config$log = config.log) !== null && _config$log !== void 0 ? _config$log : emptyFunction;
        this.relayFieldLogger = (_config$relayFieldLog = config.relayFieldLogger) !== null && _config$relayFieldLog !== void 0 ? _config$relayFieldLog : defaultRelayFieldLogger;
        this._defaultRenderPolicy = (_config$UNSTABLE_defa = config.UNSTABLE_defaultRenderPolicy) !== null && _config$UNSTABLE_defa !== void 0 ? _config$UNSTABLE_defa : 'partial';
        this._operationLoader = operationLoader;
        this._operationExecutions = new Map();
        this._network = wrapNetworkWithLogObserver(this, config.network);
        this._getDataID = (_config$getDataID = config.getDataID) !== null && _config$getDataID !== void 0 ? _config$getDataID : defaultGetDataID;
        this._missingFieldHandlers = (_config$missingFieldH = config.missingFieldHandlers) !== null && _config$missingFieldH !== void 0 ? _config$missingFieldH : [];
        this._publishQueue = new RelayPublishQueue(config.store, (_config$handlerProvid = config.handlerProvider) !== null && _config$handlerProvid !== void 0 ? _config$handlerProvid : RelayDefaultHandlerProvider, this._getDataID, this._missingFieldHandlers);
        this._scheduler = (_config$scheduler = config.scheduler) !== null && _config$scheduler !== void 0 ? _config$scheduler : null;
        this._store = config.store;
        this.options = config.options;
        this._isServer = (_config$isServer = config.isServer) !== null && _config$isServer !== void 0 ? _config$isServer : false;
        this._normalizeResponse = (_config$normalizeResp = config.normalizeResponse) !== null && _config$normalizeResp !== void 0 ? _config$normalizeResp : normalizeResponse;
        this.__setNet = function(newNet) {
            return _this._network = wrapNetworkWithLogObserver(_this, newNet);
        };
        var _require2, inspect;
        this._operationTracker = (_config$operationTrac = config.operationTracker) !== null && _config$operationTrac !== void 0 ? _config$operationTrac : new RelayOperationTracker();
        this._shouldProcessClientComponents = config.shouldProcessClientComponents;
        registerEnvironmentWithDevTools(this);
    }
    var _proto = RelayModernEnvironment.prototype;
    _proto.getStore = function getStore() {
        return this._store;
    };
    _proto.getNetwork = function getNetwork() {
        return this._network;
    };
    _proto.getOperationTracker = function getOperationTracker() {
        return this._operationTracker;
    };
    _proto.getScheduler = function getScheduler() {
        return this._scheduler;
    };
    _proto.isRequestActive = function isRequestActive(requestIdentifier) {
        var activeState = this._operationExecutions.get(requestIdentifier);
        return activeState === 'active';
    };
    _proto.UNSTABLE_getDefaultRenderPolicy = function UNSTABLE_getDefaultRenderPolicy() {
        return this._defaultRenderPolicy;
    };
    _proto.applyUpdate = function applyUpdate(optimisticUpdate) {
        var _this2 = this;
        var dispose = function dispose() {
            _this2._scheduleUpdates(function() {
                _this2._publishQueue.revertUpdate(optimisticUpdate);
                _this2._publishQueue.run();
            });
        };
        this._scheduleUpdates(function() {
            _this2._publishQueue.applyUpdate(optimisticUpdate);
            _this2._publishQueue.run();
        });
        return {
            dispose: dispose
        };
    };
    _proto.revertUpdate = function revertUpdate(update) {
        var _this3 = this;
        this._scheduleUpdates(function() {
            _this3._publishQueue.revertUpdate(update);
            _this3._publishQueue.run();
        });
    };
    _proto.replaceUpdate = function replaceUpdate(update, newUpdate) {
        var _this4 = this;
        this._scheduleUpdates(function() {
            _this4._publishQueue.revertUpdate(update);
            _this4._publishQueue.applyUpdate(newUpdate);
            _this4._publishQueue.run();
        });
    };
    _proto.applyMutation = function applyMutation(optimisticConfig) {
        var subscription = this._execute({
            createSource: function createSource() {
                return RelayObservable.create(function(_sink) {});
            },
            isClientPayload: false,
            operation: optimisticConfig.operation,
            optimisticConfig: optimisticConfig,
            updater: null
        }).subscribe({});
        return {
            dispose: function dispose() {
                return subscription.unsubscribe();
            }
        };
    };
    _proto.check = function check(operation) {
        if (this._missingFieldHandlers.length === 0 && !operationHasClientAbstractTypes(operation)) return this._store.check(operation);
        return this._checkSelectorAndHandleMissingFields(operation, this._missingFieldHandlers);
    };
    _proto.commitPayload = function commitPayload(operation, payload) {
        this._execute({
            createSource: function createSource() {
                return RelayObservable.from({
                    data: payload
                });
            },
            isClientPayload: true,
            operation: operation,
            optimisticConfig: null,
            updater: null
        }).subscribe({});
    };
    _proto.commitUpdate = function commitUpdate(updater) {
        var _this5 = this;
        this._scheduleUpdates(function() {
            _this5._publishQueue.commitUpdate(updater);
            _this5._publishQueue.run();
        });
    };
    _proto.lookup = function lookup(readSelector) {
        return this._store.lookup(readSelector);
    };
    _proto.subscribe = function subscribe(snapshot, callback) {
        return this._store.subscribe(snapshot, callback);
    };
    _proto.retain = function retain(operation) {
        return this._store.retain(operation);
    };
    _proto.isServer = function isServer() {
        return this._isServer;
    };
    _proto._checkSelectorAndHandleMissingFields = function _checkSelectorAndHandleMissingFields(operation, handlers) {
        var _this6 = this;
        var target = RelayRecordSource.create();
        var source = this._store.getSource();
        var result = this._store.check(operation, {
            handlers: handlers,
            defaultActorIdentifier: INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE,
            getSourceForActor: function getSourceForActor(actorIdentifier) {
                assertInternalActorIdentifier(actorIdentifier);
                return source;
            },
            getTargetForActor: function getTargetForActor(actorIdentifier) {
                assertInternalActorIdentifier(actorIdentifier);
                return target;
            }
        });
        if (target.size() > 0) this._scheduleUpdates(function() {
            _this6._publishQueue.commitSource(target);
            _this6._publishQueue.run();
        });
        return result;
    };
    _proto._scheduleUpdates = function _scheduleUpdates(task) {
        var scheduler = this._scheduler;
        if (scheduler != null) scheduler.schedule(task);
        else task();
    };
    _proto.execute = function execute(_ref) {
        var _this7 = this;
        var operation = _ref.operation;
        return this._execute({
            createSource: function createSource() {
                return _this7.getNetwork().execute(operation.request.node.params, operation.request.variables, operation.request.cacheConfig || {}, null);
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: null
        });
    };
    _proto.executeSubscription = function executeSubscription(_ref2) {
        var _this8 = this;
        var operation = _ref2.operation, updater = _ref2.updater;
        return this._execute({
            createSource: function createSource() {
                return _this8.getNetwork().execute(operation.request.node.params, operation.request.variables, operation.request.cacheConfig || {}, null);
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: updater
        });
    };
    _proto.executeMutation = function executeMutation(_ref3) {
        var _this9 = this;
        var operation = _ref3.operation, optimisticResponse = _ref3.optimisticResponse, optimisticUpdater = _ref3.optimisticUpdater, updater = _ref3.updater, uploadables = _ref3.uploadables;
        var optimisticConfig;
        if (optimisticResponse || optimisticUpdater) optimisticConfig = {
            operation: operation,
            response: optimisticResponse,
            updater: optimisticUpdater
        };
        return this._execute({
            createSource: function createSource() {
                return _this9.getNetwork().execute(operation.request.node.params, operation.request.variables, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, operation.request.cacheConfig), {}, {
                    force: true
                }), uploadables);
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: optimisticConfig,
            updater: updater
        });
    };
    _proto.executeWithSource = function executeWithSource(_ref4) {
        var operation = _ref4.operation, source = _ref4.source;
        return this._execute({
            createSource: function createSource() {
                return source;
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: null
        });
    };
    _proto.toJSON = function toJSON() {
        var _this$configName;
        return "RelayModernEnvironment(".concat((_this$configName = this.configName) !== null && _this$configName !== void 0 ? _this$configName : '', ")");
    };
    _proto._execute = function _execute(_ref5) {
        var _this10 = this;
        var createSource = _ref5.createSource, isClientPayload = _ref5.isClientPayload, operation = _ref5.operation, optimisticConfig = _ref5.optimisticConfig, updater = _ref5.updater;
        var publishQueue = this._publishQueue;
        var store = this._store;
        return RelayObservable.create(function(sink) {
            var executor = OperationExecutor.execute({
                actorIdentifier: INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE,
                getDataID: _this10._getDataID,
                isClientPayload: isClientPayload,
                log: _this10.__log,
                operation: operation,
                operationExecutions: _this10._operationExecutions,
                operationLoader: _this10._operationLoader,
                operationTracker: _this10._operationTracker,
                optimisticConfig: optimisticConfig,
                getPublishQueue: function getPublishQueue(actorIdentifier) {
                    assertInternalActorIdentifier(actorIdentifier);
                    return publishQueue;
                },
                scheduler: _this10._scheduler,
                shouldProcessClientComponents: _this10._shouldProcessClientComponents,
                sink: sink,
                source: createSource(),
                getStore: function getStore(actorIdentifier) {
                    assertInternalActorIdentifier(actorIdentifier);
                    return store;
                },
                treatMissingFieldsAsNull: _this10._treatMissingFieldsAsNull,
                updater: updater,
                normalizeResponse: _this10._normalizeResponse
            });
            return function() {
                return executor.cancel();
            };
        });
    };
    return RelayModernEnvironment;
}();
function operationHasClientAbstractTypes(operation) {
    return operation.root.node.kind === 'Operation' && operation.root.node.clientAbstractTypes != null;
}
RelayModernEnvironment.prototype['@@RelayModernEnvironment'] = true;
function emptyFunction() {}
module.exports = RelayModernEnvironment;

},{"7e7a4d1fbf8c82fe":"590td","6b4f3b63f4065ac0":"2Bj1n","7cea7b1ea2aa8697":"kUOrY","bc2448eae6d9e860":"cFrVW","98122506f5fdd2ff":"hYmcP","f7617b7cd8a4e2b":"7uVpm","83a7c02ef79bf09f":"5bEuR","e6be5f00728d6970":"ffTSI","b7c0545674dd33ad":"febBR","32f88f20a98f5fb0":"h7crC","7080a5669857b59a":"afJiB","c106ae6e1db32a6":"jI7gk","dddf5d64bb73e9cf":"8vVqI","c7afdb12a0678cff":"6w3KR","d019df3102764664":"e2sci"}],"7uVpm":[function(require,module,exports,__globalThis) {
'use strict';
var generateID = require("4a0bfb7e5aa469bd");
function wrapNetworkWithLogObserver(env, network) {
    return {
        execute: function execute(params, variables, cacheConfig, uploadables) {
            var networkRequestId = generateID();
            var logObserver = {
                start: function start(subscription) {
                    env.__log({
                        name: 'network.start',
                        networkRequestId: networkRequestId,
                        params: params,
                        variables: variables,
                        cacheConfig: cacheConfig
                    });
                },
                next: function next(response) {
                    env.__log({
                        name: 'network.next',
                        networkRequestId: networkRequestId,
                        response: response
                    });
                },
                error: function error(_error) {
                    env.__log({
                        name: 'network.error',
                        networkRequestId: networkRequestId,
                        error: _error
                    });
                },
                complete: function complete() {
                    env.__log({
                        name: 'network.complete',
                        networkRequestId: networkRequestId
                    });
                },
                unsubscribe: function unsubscribe() {
                    env.__log({
                        name: 'network.unsubscribe',
                        networkRequestId: networkRequestId
                    });
                }
            };
            var logRequestInfo = function logRequestInfo(info) {
                env.__log({
                    name: 'network.info',
                    networkRequestId: networkRequestId,
                    info: info
                });
            };
            return network.execute(params, variables, cacheConfig, uploadables, logRequestInfo)["do"](logObserver);
        }
    };
}
module.exports = wrapNetworkWithLogObserver;

},{"4a0bfb7e5aa469bd":"cvLlA"}],"cvLlA":[function(require,module,exports,__globalThis) {
'use strict';
var id = 100000;
function generateID() {
    return id++;
}
module.exports = generateID;

},{}],"5bEuR":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("d681fd1d763c54ce")["default"];
var _createForOfIteratorHelper2 = _interopRequireDefault(require("d7dc30eb72da9d66"));
var invariant = require("b22180a8fec7d2d3");
var RelayOperationTracker = /*#__PURE__*/ function() {
    function RelayOperationTracker() {
        this._ownersToPendingOperations = new Map();
        this._pendingOperationsToOwners = new Map();
        this._ownersToPendingPromise = new Map();
    }
    var _proto = RelayOperationTracker.prototype;
    _proto.update = function update(pendingOperation, affectedOwners) {
        if (affectedOwners.size === 0) return;
        var pendingOperationIdentifier = pendingOperation.identifier;
        var newlyAffectedOwnersIdentifier = new Set();
        var _iterator = (0, _createForOfIteratorHelper2["default"])(affectedOwners), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var owner = _step.value;
                var ownerIdentifier = owner.identifier;
                var pendingOperationsAffectingOwner = this._ownersToPendingOperations.get(ownerIdentifier);
                if (pendingOperationsAffectingOwner != null) {
                    if (!pendingOperationsAffectingOwner.has(pendingOperationIdentifier)) {
                        pendingOperationsAffectingOwner.set(pendingOperationIdentifier, pendingOperation);
                        newlyAffectedOwnersIdentifier.add(ownerIdentifier);
                    }
                } else {
                    this._ownersToPendingOperations.set(ownerIdentifier, new Map([
                        [
                            pendingOperationIdentifier,
                            pendingOperation
                        ]
                    ]));
                    newlyAffectedOwnersIdentifier.add(ownerIdentifier);
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        if (newlyAffectedOwnersIdentifier.size === 0) return;
        var ownersAffectedByPendingOperation = this._pendingOperationsToOwners.get(pendingOperationIdentifier) || new Set();
        var _iterator2 = (0, _createForOfIteratorHelper2["default"])(newlyAffectedOwnersIdentifier), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var _ownerIdentifier = _step2.value;
                this._resolveOwnerResolvers(_ownerIdentifier);
                ownersAffectedByPendingOperation.add(_ownerIdentifier);
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        this._pendingOperationsToOwners.set(pendingOperationIdentifier, ownersAffectedByPendingOperation);
    };
    _proto.complete = function complete(pendingOperation) {
        var pendingOperationIdentifier = pendingOperation.identifier;
        var affectedOwnersIdentifier = this._pendingOperationsToOwners.get(pendingOperationIdentifier);
        if (affectedOwnersIdentifier == null) return;
        var completedOwnersIdentifier = new Set();
        var updatedOwnersIdentifier = new Set();
        var _iterator3 = (0, _createForOfIteratorHelper2["default"])(affectedOwnersIdentifier), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var ownerIdentifier = _step3.value;
                var pendingOperationsAffectingOwner = this._ownersToPendingOperations.get(ownerIdentifier);
                if (!pendingOperationsAffectingOwner) continue;
                pendingOperationsAffectingOwner["delete"](pendingOperationIdentifier);
                if (pendingOperationsAffectingOwner.size > 0) updatedOwnersIdentifier.add(ownerIdentifier);
                else completedOwnersIdentifier.add(ownerIdentifier);
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        var _iterator4 = (0, _createForOfIteratorHelper2["default"])(completedOwnersIdentifier), _step4;
        try {
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var _ownerIdentifier2 = _step4.value;
                this._resolveOwnerResolvers(_ownerIdentifier2);
                this._ownersToPendingOperations["delete"](_ownerIdentifier2);
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
        var _iterator5 = (0, _createForOfIteratorHelper2["default"])(updatedOwnersIdentifier), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var _ownerIdentifier3 = _step5.value;
                this._resolveOwnerResolvers(_ownerIdentifier3);
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
        this._pendingOperationsToOwners["delete"](pendingOperationIdentifier);
    };
    _proto._resolveOwnerResolvers = function _resolveOwnerResolvers(ownerIdentifier) {
        var promiseEntry = this._ownersToPendingPromise.get(ownerIdentifier);
        if (promiseEntry != null) promiseEntry.resolve();
        this._ownersToPendingPromise["delete"](ownerIdentifier);
    };
    _proto.getPendingOperationsAffectingOwner = function getPendingOperationsAffectingOwner(owner) {
        var ownerIdentifier = owner.identifier;
        var pendingOperationsForOwner = this._ownersToPendingOperations.get(ownerIdentifier);
        if (pendingOperationsForOwner == null || pendingOperationsForOwner.size === 0) return null;
        var cachedPromiseEntry = this._ownersToPendingPromise.get(ownerIdentifier);
        if (cachedPromiseEntry != null) return {
            promise: cachedPromiseEntry.promise,
            pendingOperations: cachedPromiseEntry.pendingOperations
        };
        var resolve;
        var promise = new Promise(function(r) {
            resolve = r;
        });
        !(resolve != null) && invariant(false);
        var pendingOperations = Array.from(pendingOperationsForOwner.values());
        this._ownersToPendingPromise.set(ownerIdentifier, {
            promise: promise,
            resolve: resolve,
            pendingOperations: pendingOperations
        });
        return {
            promise: promise,
            pendingOperations: pendingOperations
        };
    };
    return RelayOperationTracker;
}();
module.exports = RelayOperationTracker;

},{"d681fd1d763c54ce":"590td","d7dc30eb72da9d66":"fMaLa","b22180a8fec7d2d3":"e2sci"}],"ffTSI":[function(require,module,exports,__globalThis) {
var global = arguments[3];
'use strict';
function registerEnvironmentWithDevTools(environment) {
    var _global = typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : undefined;
    var devToolsHook = _global && _global.__RELAY_DEVTOOLS_HOOK__;
    if (devToolsHook) devToolsHook.registerEnvironment(environment);
}
module.exports = registerEnvironmentWithDevTools;

},{}],"febBR":[function(require,module,exports,__globalThis) {
'use strict';
var _require = require("7f38a4a85e97e8a4"), VIEWER_ID = _require.VIEWER_ID, VIEWER_TYPE = _require.VIEWER_TYPE;
function defaultGetDataID(fieldValue, typeName) {
    if (typeName === VIEWER_TYPE) return fieldValue.id == null ? VIEWER_ID : fieldValue.id;
    return fieldValue.id;
}
module.exports = defaultGetDataID;

},{"7f38a4a85e97e8a4":"i6PYa"}],"i6PYa":[function(require,module,exports,__globalThis) {
'use strict';
var _require = require("c9810fa63539abb4"), generateClientID = _require.generateClientID;
var _require2 = require("4df55ace433cec4f"), ROOT_ID = _require2.ROOT_ID;
var VIEWER_ID = generateClientID(ROOT_ID, 'viewer');
var VIEWER_TYPE = 'Viewer';
module.exports = {
    VIEWER_ID: VIEWER_ID,
    VIEWER_TYPE: VIEWER_TYPE
};

},{"c9810fa63539abb4":"gL1rB","4df55ace433cec4f":"3QcrW"}],"h7crC":[function(require,module,exports,__globalThis) {
'use strict';
var defaultRelayFieldLogger = function defaultRelayFieldLogger(event) {};
module.exports = defaultRelayFieldLogger;

},{}],"jI7gk":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var _interopRequireDefault = require("49580c31bcbf7d59")["default"];
var _createForOfIteratorHelper2 = _interopRequireDefault(require("eeb3dd86519eed11"));
var _toConsumableArray2 = _interopRequireDefault(require("1ad75e1e684ac8da"));
var RelayObservable = require("e0d2f76365dd12f8");
var generateID = require("53effba0aa0a9f3b");
var getOperation = require("63f8b694e282c34e");
var RelayError = require("c563ec7552178872");
var RelayFeatureFlags = require("684c4bb17ec7a904");
var stableCopy = require("756e65a1b1e2b98a");
var withDuration = require("6ad11a88c87d1dd6");
var _require = require("252789120f8e7534"), generateClientID = _require.generateClientID, generateUniqueClientID = _require.generateUniqueClientID;
var _require2 = require("a01ca47262c4e73f"), getLocalVariables = _require2.getLocalVariables;
var RelayModernRecord = require("f9d3e7aecfe62c60");
var _require3 = require("4efc4864b1deda57"), createNormalizationSelector = _require3.createNormalizationSelector, createReaderSelector = _require3.createReaderSelector;
var RelayRecordSource = require("83eea5189beedbbd");
var _require4 = require("792fd666f198e19"), ROOT_TYPE = _require4.ROOT_TYPE, TYPENAME_KEY = _require4.TYPENAME_KEY, getStorageKey = _require4.getStorageKey;
var invariant = require("cdbd9f2d618fa355");
var warning = require("a122a32f941a9238");
function execute(config) {
    return new Executor(config);
}
var Executor = /*#__PURE__*/ function() {
    function Executor(_ref2) {
        var _this = this;
        var actorIdentifier = _ref2.actorIdentifier, getDataID = _ref2.getDataID, getPublishQueue = _ref2.getPublishQueue, getStore = _ref2.getStore, isClientPayload = _ref2.isClientPayload, operation = _ref2.operation, operationExecutions = _ref2.operationExecutions, operationLoader = _ref2.operationLoader, operationTracker = _ref2.operationTracker, optimisticConfig = _ref2.optimisticConfig, scheduler = _ref2.scheduler, shouldProcessClientComponents = _ref2.shouldProcessClientComponents, sink = _ref2.sink, source = _ref2.source, treatMissingFieldsAsNull = _ref2.treatMissingFieldsAsNull, updater = _ref2.updater, log = _ref2.log, normalizeResponse = _ref2.normalizeResponse;
        this._actorIdentifier = actorIdentifier;
        this._getDataID = getDataID;
        this._treatMissingFieldsAsNull = treatMissingFieldsAsNull;
        this._incrementalPayloadsPending = false;
        this._incrementalResults = new Map();
        this._log = log;
        this._executeId = generateID();
        this._nextSubscriptionId = 0;
        this._operation = operation;
        this._operationExecutions = operationExecutions;
        this._operationLoader = operationLoader;
        this._operationTracker = operationTracker;
        this._operationUpdateEpochs = new Map();
        this._optimisticUpdates = null;
        this._pendingModulePayloadsCount = 0;
        this._getPublishQueue = getPublishQueue;
        this._scheduler = scheduler;
        this._sink = sink;
        this._source = new Map();
        this._state = 'started';
        this._getStore = getStore;
        this._subscriptions = new Map();
        this._updater = updater;
        this._isClientPayload = isClientPayload === true;
        this._isSubscriptionOperation = this._operation.request.node.params.operationKind === 'subscription';
        this._shouldProcessClientComponents = shouldProcessClientComponents;
        this._retainDisposables = new Map();
        this._seenActors = new Set();
        this._completeFns = [];
        this._normalizeResponse = normalizeResponse;
        var id = this._nextSubscriptionId++;
        if (RelayFeatureFlags.PROCESS_OPTIMISTIC_UPDATE_BEFORE_SUBSCRIPTION && optimisticConfig != null) this._processOptimisticResponse(optimisticConfig.response != null ? {
            data: optimisticConfig.response
        } : null, optimisticConfig.updater, false);
        source.subscribe({
            complete: function complete() {
                return _this._complete(id);
            },
            error: function error(_error2) {
                return _this._error(_error2);
            },
            next: function next(response) {
                try {
                    _this._next(id, response);
                } catch (error) {
                    sink.error(error);
                }
            },
            start: function start(subscription) {
                var _this$_operation$requ;
                _this._start(id, subscription);
                _this._log({
                    name: 'execute.start',
                    executeId: _this._executeId,
                    params: _this._operation.request.node.params,
                    variables: _this._operation.request.variables,
                    cacheConfig: (_this$_operation$requ = _this._operation.request.cacheConfig) !== null && _this$_operation$requ !== void 0 ? _this$_operation$requ : {}
                });
            }
        });
        if (!RelayFeatureFlags.PROCESS_OPTIMISTIC_UPDATE_BEFORE_SUBSCRIPTION && optimisticConfig != null) this._processOptimisticResponse(optimisticConfig.response != null ? {
            data: optimisticConfig.response
        } : null, optimisticConfig.updater, false);
    }
    var _proto = Executor.prototype;
    _proto.cancel = function cancel() {
        var _this2 = this;
        if (this._state === 'completed') return;
        this._state = 'completed';
        this._operationExecutions["delete"](this._operation.request.identifier);
        if (this._subscriptions.size !== 0) {
            this._subscriptions.forEach(function(sub) {
                return sub.unsubscribe();
            });
            this._subscriptions.clear();
        }
        var optimisticUpdates = this._optimisticUpdates;
        if (optimisticUpdates !== null) {
            this._optimisticUpdates = null;
            optimisticUpdates.forEach(function(update) {
                return _this2._getPublishQueueAndSaveActor().revertUpdate(update);
            });
            this._runPublishQueue();
        }
        this._incrementalResults.clear();
        if (this._asyncStoreUpdateDisposable != null) {
            this._asyncStoreUpdateDisposable.dispose();
            this._asyncStoreUpdateDisposable = null;
        }
        this._completeFns = [];
        this._completeOperationTracker();
        this._disposeRetainedData();
    };
    _proto._updateActiveState = function _updateActiveState() {
        var activeState;
        switch(this._state){
            case 'started':
                activeState = 'active';
                break;
            case 'loading_incremental':
                activeState = 'active';
                break;
            case 'completed':
                activeState = 'inactive';
                break;
            case 'loading_final':
                activeState = this._pendingModulePayloadsCount > 0 ? 'active' : 'inactive';
                break;
            default:
                this._state;
                invariant(false);
        }
        this._operationExecutions.set(this._operation.request.identifier, activeState);
    };
    _proto._schedule = function _schedule(task) {
        var _this3 = this;
        var scheduler = this._scheduler;
        if (scheduler != null) {
            var id = this._nextSubscriptionId++;
            RelayObservable.create(function(sink) {
                var cancellationToken = scheduler.schedule(function() {
                    try {
                        task();
                        sink.complete();
                    } catch (error) {
                        sink.error(error);
                    }
                });
                return function() {
                    return scheduler.cancel(cancellationToken);
                };
            }).subscribe({
                complete: function complete() {
                    return _this3._complete(id);
                },
                error: function error(_error3) {
                    return _this3._error(_error3);
                },
                start: function start(subscription) {
                    return _this3._start(id, subscription);
                }
            });
        } else task();
    };
    _proto._complete = function _complete(id) {
        this._subscriptions["delete"](id);
        if (this._subscriptions.size === 0) {
            this.cancel();
            this._sink.complete();
            this._log({
                name: 'execute.complete',
                executeId: this._executeId
            });
        }
    };
    _proto._error = function _error(error) {
        this.cancel();
        this._sink.error(error);
        this._log({
            name: 'execute.error',
            executeId: this._executeId,
            error: error
        });
    };
    _proto._start = function _start(id, subscription) {
        this._subscriptions.set(id, subscription);
        this._updateActiveState();
    };
    _proto._next = function _next(_id, response) {
        var _this4 = this;
        this._schedule(function() {
            var _withDuration = withDuration(function() {
                _this4._handleNext(response);
                _this4._maybeCompleteSubscriptionOperationTracking();
            }), duration = _withDuration[0];
            _this4._log({
                name: 'execute.next',
                executeId: _this4._executeId,
                response: response,
                duration: duration
            });
        });
    };
    _proto._handleErrorResponse = function _handleErrorResponse(responses) {
        var _this5 = this;
        var results = [];
        responses.forEach(function(response) {
            if (response.data === null && response.extensions != null && !response.hasOwnProperty('errors')) return;
            else if (response.data == null) {
                var errors = response.hasOwnProperty('errors') && response.errors != null ? response.errors : null;
                var messages = errors ? errors.map(function(_ref3) {
                    var message = _ref3.message;
                    return message;
                }).join('\n') : '(No errors)';
                var error = RelayError.create('RelayNetwork', 'No data returned for operation `' + _this5._operation.request.node.params.name + '`, got error(s):\n' + messages + '\n\nSee the error `source` property for more information.');
                error.source = {
                    errors: errors,
                    operation: _this5._operation.request.node,
                    variables: _this5._operation.request.variables
                };
                error.stack;
                throw error;
            } else {
                var responseWithData = response;
                results.push(responseWithData);
            }
        });
        return results;
    };
    _proto._handleOptimisticResponses = function _handleOptimisticResponses(responses) {
        var _response$extensions;
        if (responses.length > 1) {
            if (responses.some(function(responsePart) {
                var _responsePart$extensi;
                return ((_responsePart$extensi = responsePart.extensions) === null || _responsePart$extensi === void 0 ? void 0 : _responsePart$extensi.isOptimistic) === true;
            })) invariant(false);
            return false;
        }
        var response = responses[0];
        var isOptimistic = ((_response$extensions = response.extensions) === null || _response$extensions === void 0 ? void 0 : _response$extensions.isOptimistic) === true;
        if (isOptimistic && this._state !== 'started') invariant(false);
        if (isOptimistic) {
            this._processOptimisticResponse(response, null, this._treatMissingFieldsAsNull);
            this._sink.next(response);
            return true;
        }
        return false;
    };
    _proto._handleNext = function _handleNext(response) {
        if (this._state === 'completed') return;
        this._seenActors.clear();
        var responses = Array.isArray(response) ? response : [
            response
        ];
        var responsesWithData = this._handleErrorResponse(responses);
        if (responsesWithData.length === 0) {
            var isFinal = responses.some(function(x) {
                var _x$extensions;
                return ((_x$extensions = x.extensions) === null || _x$extensions === void 0 ? void 0 : _x$extensions.is_final) === true;
            });
            if (isFinal) {
                this._state = 'loading_final';
                this._updateActiveState();
                this._incrementalPayloadsPending = false;
            }
            this._sink.next(response);
            return;
        }
        var isOptimistic = this._handleOptimisticResponses(responsesWithData);
        if (isOptimistic) return;
        var _partitionGraphQLResp = partitionGraphQLResponses(responsesWithData), nonIncrementalResponses = _partitionGraphQLResp[0], incrementalResponses = _partitionGraphQLResp[1];
        var hasNonIncrementalResponses = nonIncrementalResponses.length > 0;
        if (hasNonIncrementalResponses) {
            if (this._isSubscriptionOperation) {
                var nextID = generateUniqueClientID();
                this._operation = {
                    request: this._operation.request,
                    fragment: createReaderSelector(this._operation.fragment.node, nextID, this._operation.fragment.variables, this._operation.fragment.owner),
                    root: createNormalizationSelector(this._operation.root.node, nextID, this._operation.root.variables)
                };
            }
            var payloadFollowups = this._processResponses(nonIncrementalResponses);
            this._processPayloadFollowups(payloadFollowups);
        }
        if (incrementalResponses.length > 0) {
            var _payloadFollowups = this._processIncrementalResponses(incrementalResponses);
            this._processPayloadFollowups(_payloadFollowups);
        }
        if (this._isSubscriptionOperation) {
            if (responsesWithData[0].extensions == null) responsesWithData[0].extensions = {
                __relay_subscription_root_id: this._operation.fragment.dataID
            };
            else responsesWithData[0].extensions.__relay_subscription_root_id = this._operation.fragment.dataID;
        }
        var updatedOwners = this._runPublishQueue(hasNonIncrementalResponses ? this._operation : undefined);
        if (hasNonIncrementalResponses) {
            if (this._incrementalPayloadsPending) this._retainData();
        }
        this._updateOperationTracker(updatedOwners);
        this._sink.next(response);
    };
    _proto._processOptimisticResponse = function _processOptimisticResponse(response, updater, treatMissingFieldsAsNull) {
        var _this6 = this;
        !(this._optimisticUpdates === null) && invariant(false);
        if (response == null && updater == null) return;
        var optimisticUpdates = [];
        if (response) {
            var payload = this._normalizeResponse(response, this._operation.root, ROOT_TYPE, {
                actorIdentifier: this._actorIdentifier,
                getDataID: this._getDataID,
                path: [],
                shouldProcessClientComponents: this._shouldProcessClientComponents,
                treatMissingFieldsAsNull: treatMissingFieldsAsNull
            });
            validateOptimisticResponsePayload(payload);
            optimisticUpdates.push({
                operation: this._operation,
                payload: payload,
                updater: updater
            });
            this._processOptimisticFollowups(payload, optimisticUpdates);
        } else if (updater) optimisticUpdates.push({
            operation: this._operation,
            payload: {
                errors: null,
                fieldPayloads: null,
                incrementalPlaceholders: null,
                followupPayloads: null,
                source: RelayRecordSource.create(),
                isFinal: false
            },
            updater: updater
        });
        this._optimisticUpdates = optimisticUpdates;
        optimisticUpdates.forEach(function(update) {
            return _this6._getPublishQueueAndSaveActor().applyUpdate(update);
        });
        var updatedOwners = this._runPublishQueue();
        if (RelayFeatureFlags.ENABLE_OPERATION_TRACKER_OPTIMISTIC_UPDATES) this._updateOperationTracker(updatedOwners);
    };
    _proto._processOptimisticFollowups = function _processOptimisticFollowups(payload, optimisticUpdates) {
        if (payload.followupPayloads && payload.followupPayloads.length) {
            var followupPayloads = payload.followupPayloads;
            var _iterator = (0, _createForOfIteratorHelper2["default"])(followupPayloads), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var followupPayload = _step.value;
                    switch(followupPayload.kind){
                        case 'ModuleImportPayload':
                            var operationLoader = this._expectOperationLoader();
                            var operation = operationLoader.get(followupPayload.operationReference);
                            if (operation == null) this._processAsyncOptimisticModuleImport(followupPayload);
                            else {
                                var moduleImportOptimisticUpdates = this._processOptimisticModuleImport(operation, followupPayload);
                                optimisticUpdates.push.apply(optimisticUpdates, (0, _toConsumableArray2["default"])(moduleImportOptimisticUpdates));
                            }
                            break;
                        case 'ActorPayload':
                            break;
                        default:
                            followupPayload;
                            invariant(false);
                    }
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    };
    _proto._normalizeFollowupPayload = function _normalizeFollowupPayload(followupPayload, normalizationNode) {
        var variables;
        if (normalizationNode.kind === 'SplitOperation' && followupPayload.kind === 'ModuleImportPayload') variables = getLocalVariables(followupPayload.variables, normalizationNode.argumentDefinitions, followupPayload.args);
        else variables = followupPayload.variables;
        var selector = createNormalizationSelector(normalizationNode, followupPayload.dataID, variables);
        return this._normalizeResponse({
            data: followupPayload.data
        }, selector, followupPayload.typeName, {
            actorIdentifier: this._actorIdentifier,
            getDataID: this._getDataID,
            path: followupPayload.path,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents
        });
    };
    _proto._processOptimisticModuleImport = function _processOptimisticModuleImport(normalizationRootNode, moduleImportPayload) {
        var operation = getOperation(normalizationRootNode);
        var optimisticUpdates = [];
        var modulePayload = this._normalizeFollowupPayload(moduleImportPayload, operation);
        validateOptimisticResponsePayload(modulePayload);
        optimisticUpdates.push({
            operation: this._operation,
            payload: modulePayload,
            updater: null
        });
        this._processOptimisticFollowups(modulePayload, optimisticUpdates);
        return optimisticUpdates;
    };
    _proto._processAsyncOptimisticModuleImport = function _processAsyncOptimisticModuleImport(moduleImportPayload) {
        var _this7 = this;
        this._expectOperationLoader().load(moduleImportPayload.operationReference).then(function(operation) {
            if (operation == null || _this7._state !== 'started') return;
            var moduleImportOptimisticUpdates = _this7._processOptimisticModuleImport(operation, moduleImportPayload);
            moduleImportOptimisticUpdates.forEach(function(update) {
                return _this7._getPublishQueueAndSaveActor().applyUpdate(update);
            });
            if (_this7._optimisticUpdates == null) ;
            else {
                var _this$_optimisticUpda;
                (_this$_optimisticUpda = _this7._optimisticUpdates).push.apply(_this$_optimisticUpda, (0, _toConsumableArray2["default"])(moduleImportOptimisticUpdates));
                _this7._runPublishQueue();
            }
        });
    };
    _proto._processResponses = function _processResponses(responses) {
        var _this8 = this;
        if (this._optimisticUpdates !== null) {
            this._optimisticUpdates.forEach(function(update) {
                _this8._getPublishQueueAndSaveActor().revertUpdate(update);
            });
            this._optimisticUpdates = null;
        }
        this._incrementalPayloadsPending = false;
        this._incrementalResults.clear();
        this._source.clear();
        return responses.map(function(payloadPart) {
            var relayPayload = _this8._normalizeResponse(payloadPart, _this8._operation.root, ROOT_TYPE, {
                actorIdentifier: _this8._actorIdentifier,
                getDataID: _this8._getDataID,
                path: [],
                treatMissingFieldsAsNull: _this8._treatMissingFieldsAsNull,
                shouldProcessClientComponents: _this8._shouldProcessClientComponents
            });
            _this8._getPublishQueueAndSaveActor().commitPayload(_this8._operation, relayPayload, _this8._updater);
            return relayPayload;
        });
    };
    _proto._processPayloadFollowups = function _processPayloadFollowups(payloads) {
        var _this9 = this;
        if (this._state === 'completed') return;
        payloads.forEach(function(payload) {
            var incrementalPlaceholders = payload.incrementalPlaceholders, followupPayloads = payload.followupPayloads, isFinal = payload.isFinal;
            _this9._state = isFinal ? 'loading_final' : 'loading_incremental';
            _this9._updateActiveState();
            if (isFinal) _this9._incrementalPayloadsPending = false;
            if (followupPayloads && followupPayloads.length !== 0) followupPayloads.forEach(function(followupPayload) {
                var _followupPayload$acto;
                var prevActorIdentifier = _this9._actorIdentifier;
                _this9._actorIdentifier = (_followupPayload$acto = followupPayload.actorIdentifier) !== null && _followupPayload$acto !== void 0 ? _followupPayload$acto : _this9._actorIdentifier;
                _this9._processFollowupPayload(followupPayload);
                _this9._actorIdentifier = prevActorIdentifier;
            });
            if (incrementalPlaceholders && incrementalPlaceholders.length !== 0) {
                _this9._incrementalPayloadsPending = _this9._state !== 'loading_final';
                incrementalPlaceholders.forEach(function(incrementalPlaceholder) {
                    var _incrementalPlacehold;
                    var prevActorIdentifier = _this9._actorIdentifier;
                    _this9._actorIdentifier = (_incrementalPlacehold = incrementalPlaceholder.actorIdentifier) !== null && _incrementalPlacehold !== void 0 ? _incrementalPlacehold : _this9._actorIdentifier;
                    _this9._processIncrementalPlaceholder(payload, incrementalPlaceholder);
                    _this9._actorIdentifier = prevActorIdentifier;
                });
                if (_this9._isClientPayload || _this9._state === 'loading_final') {
                    var relayPayloads = [];
                    incrementalPlaceholders.forEach(function(placeholder) {
                        if (placeholder.kind === 'defer') relayPayloads.push(_this9._processDeferResponse(placeholder.label, placeholder.path, placeholder, {
                            data: placeholder.data
                        }));
                    });
                    if (relayPayloads.length > 0) _this9._processPayloadFollowups(relayPayloads);
                }
            }
        });
    };
    _proto._maybeCompleteSubscriptionOperationTracking = function _maybeCompleteSubscriptionOperationTracking() {
        if (!this._isSubscriptionOperation) return;
        if (this._pendingModulePayloadsCount === 0 && this._incrementalPayloadsPending === false) this._completeOperationTracker();
    };
    _proto._processFollowupPayload = function _processFollowupPayload(followupPayload) {
        var _this10 = this;
        switch(followupPayload.kind){
            case 'ModuleImportPayload':
                var operationLoader = this._expectOperationLoader();
                var node = operationLoader.get(followupPayload.operationReference);
                if (node != null) this._processFollowupPayloadWithNormalizationNode(followupPayload, getOperation(node));
                else {
                    var id = this._nextSubscriptionId++;
                    this._pendingModulePayloadsCount++;
                    var decrementPendingCount = function decrementPendingCount() {
                        _this10._pendingModulePayloadsCount--;
                        _this10._maybeCompleteSubscriptionOperationTracking();
                    };
                    var networkObservable = RelayObservable.from(new Promise(function(resolve, reject) {
                        operationLoader.load(followupPayload.operationReference).then(resolve, reject);
                    }));
                    RelayObservable.create(function(sink) {
                        var cancellationToken;
                        var subscription = networkObservable.subscribe({
                            next: function next(loadedNode) {
                                if (loadedNode != null) {
                                    var publishModuleImportPayload = function publishModuleImportPayload() {
                                        try {
                                            var operation = getOperation(loadedNode);
                                            var batchAsyncModuleUpdatesFN = RelayFeatureFlags.BATCH_ASYNC_MODULE_UPDATES_FN;
                                            var shouldScheduleAsyncStoreUpdate = batchAsyncModuleUpdatesFN != null && _this10._pendingModulePayloadsCount > 1;
                                            var _withDuration2 = withDuration(function() {
                                                _this10._handleFollowupPayload(followupPayload, operation);
                                                if (shouldScheduleAsyncStoreUpdate) _this10._scheduleAsyncStoreUpdate(batchAsyncModuleUpdatesFN, sink.complete);
                                                else {
                                                    var updatedOwners = _this10._runPublishQueue();
                                                    _this10._updateOperationTracker(updatedOwners);
                                                }
                                            }), duration = _withDuration2[0];
                                            _this10._log({
                                                name: 'execute.async.module',
                                                executeId: _this10._executeId,
                                                operationName: operation.name,
                                                duration: duration
                                            });
                                            if (!shouldScheduleAsyncStoreUpdate) sink.complete();
                                        } catch (error) {
                                            sink.error(error);
                                        }
                                    };
                                    var scheduler = _this10._scheduler;
                                    if (scheduler == null) publishModuleImportPayload();
                                    else cancellationToken = scheduler.schedule(publishModuleImportPayload);
                                } else sink.complete();
                            },
                            error: sink.error
                        });
                        return function() {
                            subscription.unsubscribe();
                            if (_this10._scheduler != null && cancellationToken != null) _this10._scheduler.cancel(cancellationToken);
                        };
                    }).subscribe({
                        complete: function complete() {
                            _this10._complete(id);
                            decrementPendingCount();
                        },
                        error: function error(_error4) {
                            _this10._error(_error4);
                            decrementPendingCount();
                        },
                        start: function start(subscription) {
                            return _this10._start(id, subscription);
                        }
                    });
                }
                break;
            case 'ActorPayload':
                this._processFollowupPayloadWithNormalizationNode(followupPayload, followupPayload.node);
                break;
            default:
                followupPayload;
                invariant(false);
        }
    };
    _proto._processFollowupPayloadWithNormalizationNode = function _processFollowupPayloadWithNormalizationNode(followupPayload, normalizationNode) {
        this._handleFollowupPayload(followupPayload, normalizationNode);
        this._maybeCompleteSubscriptionOperationTracking();
    };
    _proto._handleFollowupPayload = function _handleFollowupPayload(followupPayload, normalizationNode) {
        var relayPayload = this._normalizeFollowupPayload(followupPayload, normalizationNode);
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload);
        this._processPayloadFollowups([
            relayPayload
        ]);
    };
    _proto._processIncrementalPlaceholder = function _processIncrementalPlaceholder(relayPayload, placeholder) {
        var _relayPayload$fieldPa;
        var label = placeholder.label, path = placeholder.path;
        var pathKey = path.map(String).join('.');
        var resultForLabel = this._incrementalResults.get(label);
        if (resultForLabel == null) {
            resultForLabel = new Map();
            this._incrementalResults.set(label, resultForLabel);
        }
        var resultForPath = resultForLabel.get(pathKey);
        var pendingResponses = resultForPath != null && resultForPath.kind === 'response' ? resultForPath.responses : null;
        resultForLabel.set(pathKey, {
            kind: 'placeholder',
            placeholder: placeholder
        });
        var parentID;
        if (placeholder.kind === 'stream') parentID = placeholder.parentID;
        else if (placeholder.kind === 'defer') parentID = placeholder.selector.dataID;
        else {
            placeholder;
            invariant(false);
        }
        var parentRecord = relayPayload.source.get(parentID);
        var parentPayloads = ((_relayPayload$fieldPa = relayPayload.fieldPayloads) !== null && _relayPayload$fieldPa !== void 0 ? _relayPayload$fieldPa : []).filter(function(fieldPayload) {
            var fieldID = generateClientID(fieldPayload.dataID, fieldPayload.fieldKey);
            return fieldPayload.dataID === parentID || fieldID === parentID;
        });
        !(parentRecord != null) && invariant(false);
        var nextParentRecord;
        var nextParentPayloads;
        var previousParentEntry = this._source.get(parentID);
        if (previousParentEntry != null) {
            nextParentRecord = RelayModernRecord.update(previousParentEntry.record, parentRecord);
            var handlePayloads = new Map();
            var dedupePayload = function dedupePayload(payload) {
                var key = stableStringify(payload);
                handlePayloads.set(key, payload);
            };
            previousParentEntry.fieldPayloads.forEach(dedupePayload);
            parentPayloads.forEach(dedupePayload);
            nextParentPayloads = Array.from(handlePayloads.values());
        } else {
            nextParentRecord = parentRecord;
            nextParentPayloads = parentPayloads;
        }
        this._source.set(parentID, {
            record: nextParentRecord,
            fieldPayloads: nextParentPayloads
        });
        if (pendingResponses != null) {
            var payloadFollowups = this._processIncrementalResponses(pendingResponses);
            this._processPayloadFollowups(payloadFollowups);
        }
    };
    _proto._processIncrementalResponses = function _processIncrementalResponses(incrementalResponses) {
        var _this11 = this;
        var relayPayloads = [];
        incrementalResponses.forEach(function(incrementalResponse) {
            var label = incrementalResponse.label, path = incrementalResponse.path, response = incrementalResponse.response;
            var resultForLabel = _this11._incrementalResults.get(label);
            if (resultForLabel == null) {
                resultForLabel = new Map();
                _this11._incrementalResults.set(label, resultForLabel);
            }
            if (label.indexOf('$defer$') !== -1) {
                var pathKey = path.map(String).join('.');
                var resultForPath = resultForLabel.get(pathKey);
                if (resultForPath == null) {
                    resultForPath = {
                        kind: 'response',
                        responses: [
                            incrementalResponse
                        ]
                    };
                    resultForLabel.set(pathKey, resultForPath);
                    return;
                } else if (resultForPath.kind === 'response') {
                    resultForPath.responses.push(incrementalResponse);
                    return;
                }
                var placeholder = resultForPath.placeholder;
                !(placeholder.kind === 'defer') && invariant(false);
                relayPayloads.push(_this11._processDeferResponse(label, path, placeholder, response));
            } else {
                var _pathKey = path.slice(0, -2).map(String).join('.');
                var _resultForPath = resultForLabel.get(_pathKey);
                if (_resultForPath == null) {
                    _resultForPath = {
                        kind: 'response',
                        responses: [
                            incrementalResponse
                        ]
                    };
                    resultForLabel.set(_pathKey, _resultForPath);
                    return;
                } else if (_resultForPath.kind === 'response') {
                    _resultForPath.responses.push(incrementalResponse);
                    return;
                }
                var _placeholder = _resultForPath.placeholder;
                !(_placeholder.kind === 'stream') && invariant(false);
                relayPayloads.push(_this11._processStreamResponse(label, path, _placeholder, response));
            }
        });
        return relayPayloads;
    };
    _proto._processDeferResponse = function _processDeferResponse(label, path, placeholder, response) {
        var _placeholder$actorIde;
        var parentID = placeholder.selector.dataID;
        var prevActorIdentifier = this._actorIdentifier;
        this._actorIdentifier = (_placeholder$actorIde = placeholder.actorIdentifier) !== null && _placeholder$actorIde !== void 0 ? _placeholder$actorIde : this._actorIdentifier;
        var relayPayload = this._normalizeResponse(response, placeholder.selector, placeholder.typeName, {
            actorIdentifier: this._actorIdentifier,
            getDataID: this._getDataID,
            path: placeholder.path,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents
        });
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload);
        var parentEntry = this._source.get(parentID);
        !(parentEntry != null) && invariant(false);
        var fieldPayloads = parentEntry.fieldPayloads;
        if (fieldPayloads.length !== 0) {
            var _response$extensions2;
            var handleFieldsRelayPayload = {
                errors: null,
                fieldPayloads: fieldPayloads,
                incrementalPlaceholders: null,
                followupPayloads: null,
                source: RelayRecordSource.create(),
                isFinal: ((_response$extensions2 = response.extensions) === null || _response$extensions2 === void 0 ? void 0 : _response$extensions2.is_final) === true
            };
            this._getPublishQueueAndSaveActor().commitPayload(this._operation, handleFieldsRelayPayload);
        }
        this._actorIdentifier = prevActorIdentifier;
        return relayPayload;
    };
    _proto._processStreamResponse = function _processStreamResponse(label, path, placeholder, response) {
        var parentID = placeholder.parentID, node = placeholder.node, variables = placeholder.variables, actorIdentifier = placeholder.actorIdentifier;
        var prevActorIdentifier = this._actorIdentifier;
        this._actorIdentifier = actorIdentifier !== null && actorIdentifier !== void 0 ? actorIdentifier : this._actorIdentifier;
        var field = node.selections[0];
        !(field != null && field.kind === 'LinkedField' && field.plural === true) && invariant(false);
        var _this$_normalizeStrea = this._normalizeStreamItem(response, parentID, field, variables, path, placeholder.path), fieldPayloads = _this$_normalizeStrea.fieldPayloads, itemID = _this$_normalizeStrea.itemID, itemIndex = _this$_normalizeStrea.itemIndex, prevIDs = _this$_normalizeStrea.prevIDs, relayPayload = _this$_normalizeStrea.relayPayload, storageKey = _this$_normalizeStrea.storageKey;
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload, function(store) {
            var currentParentRecord = store.get(parentID);
            if (currentParentRecord == null) return;
            var currentItems = currentParentRecord.getLinkedRecords(storageKey);
            if (currentItems == null) return;
            if (currentItems.length !== prevIDs.length || currentItems.some(function(currentItem, index) {
                return prevIDs[index] !== (currentItem && currentItem.getDataID());
            })) return;
            var nextItems = (0, _toConsumableArray2["default"])(currentItems);
            nextItems[itemIndex] = store.get(itemID);
            currentParentRecord.setLinkedRecords(nextItems, storageKey);
        });
        if (fieldPayloads.length !== 0) {
            var handleFieldsRelayPayload = {
                errors: null,
                fieldPayloads: fieldPayloads,
                incrementalPlaceholders: null,
                followupPayloads: null,
                source: RelayRecordSource.create(),
                isFinal: false
            };
            this._getPublishQueueAndSaveActor().commitPayload(this._operation, handleFieldsRelayPayload);
        }
        this._actorIdentifier = prevActorIdentifier;
        return relayPayload;
    };
    _proto._normalizeStreamItem = function _normalizeStreamItem(response, parentID, field, variables, path, normalizationPath) {
        var _field$alias, _field$concreteType, _ref, _this$_getDataID;
        var data = response.data;
        !((typeof data === "undefined" ? "undefined" : (0, _typeOf._)(data)) === 'object') && invariant(false);
        var responseKey = (_field$alias = field.alias) !== null && _field$alias !== void 0 ? _field$alias : field.name;
        var storageKey = getStorageKey(field, variables);
        var parentEntry = this._source.get(parentID);
        !(parentEntry != null) && invariant(false);
        var parentRecord = parentEntry.record, fieldPayloads = parentEntry.fieldPayloads;
        var prevIDs = RelayModernRecord.getLinkedRecordIDs(parentRecord, storageKey);
        !(prevIDs != null) && invariant(false);
        var finalPathEntry = path[path.length - 1];
        var itemIndex = parseInt(finalPathEntry, 10);
        !(itemIndex === finalPathEntry && itemIndex >= 0) && invariant(false);
        var typeName = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : data[TYPENAME_KEY];
        !(typeof typeName === 'string') && invariant(false);
        var itemID = (_ref = (_this$_getDataID = this._getDataID(data, typeName)) !== null && _this$_getDataID !== void 0 ? _this$_getDataID : prevIDs === null || prevIDs === void 0 ? void 0 : prevIDs[itemIndex]) !== null && _ref !== void 0 ? _ref : generateClientID(parentID, storageKey, itemIndex);
        !(typeof itemID === 'string') && invariant(false);
        var selector = createNormalizationSelector(field, itemID, variables);
        var nextParentRecord = RelayModernRecord.clone(parentRecord);
        var nextIDs = (0, _toConsumableArray2["default"])(prevIDs);
        nextIDs[itemIndex] = itemID;
        RelayModernRecord.setLinkedRecordIDs(nextParentRecord, storageKey, nextIDs);
        this._source.set(parentID, {
            record: nextParentRecord,
            fieldPayloads: fieldPayloads
        });
        var relayPayload = this._normalizeResponse(response, selector, typeName, {
            actorIdentifier: this._actorIdentifier,
            getDataID: this._getDataID,
            path: [].concat((0, _toConsumableArray2["default"])(normalizationPath), [
                responseKey,
                String(itemIndex)
            ]),
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents
        });
        return {
            fieldPayloads: fieldPayloads,
            itemID: itemID,
            itemIndex: itemIndex,
            prevIDs: prevIDs,
            relayPayload: relayPayload,
            storageKey: storageKey
        };
    };
    _proto._scheduleAsyncStoreUpdate = function _scheduleAsyncStoreUpdate(scheduleFn, completeFn) {
        var _this12 = this;
        this._completeFns.push(completeFn);
        if (this._asyncStoreUpdateDisposable != null) return;
        this._asyncStoreUpdateDisposable = scheduleFn(function() {
            _this12._asyncStoreUpdateDisposable = null;
            var updatedOwners = _this12._runPublishQueue();
            _this12._updateOperationTracker(updatedOwners);
            var _iterator2 = (0, _createForOfIteratorHelper2["default"])(_this12._completeFns), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var complete = _step2.value;
                    complete();
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            _this12._completeFns = [];
        });
    };
    _proto._updateOperationTracker = function _updateOperationTracker(updatedOwners) {
        if (updatedOwners != null && updatedOwners.length > 0) this._operationTracker.update(this._operation.request, new Set(updatedOwners));
    };
    _proto._completeOperationTracker = function _completeOperationTracker() {
        this._operationTracker.complete(this._operation.request);
    };
    _proto._getPublishQueueAndSaveActor = function _getPublishQueueAndSaveActor() {
        this._seenActors.add(this._actorIdentifier);
        return this._getPublishQueue(this._actorIdentifier);
    };
    _proto._getActorsToVisit = function _getActorsToVisit() {
        if (this._seenActors.size === 0) return new Set([
            this._actorIdentifier
        ]);
        else return this._seenActors;
    };
    _proto._runPublishQueue = function _runPublishQueue(operation) {
        var updatedOwners = new Set();
        var _iterator3 = (0, _createForOfIteratorHelper2["default"])(this._getActorsToVisit()), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var actorIdentifier = _step3.value;
                var owners = this._getPublishQueue(actorIdentifier).run(operation);
                owners.forEach(function(owner) {
                    return updatedOwners.add(owner);
                });
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        return Array.from(updatedOwners);
    };
    _proto._retainData = function _retainData() {
        var _iterator4 = (0, _createForOfIteratorHelper2["default"])(this._getActorsToVisit()), _step4;
        try {
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var actorIdentifier = _step4.value;
                if (!this._retainDisposables.has(actorIdentifier)) this._retainDisposables.set(actorIdentifier, this._getStore(actorIdentifier).retain(this._operation));
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
    };
    _proto._disposeRetainedData = function _disposeRetainedData() {
        var _iterator5 = (0, _createForOfIteratorHelper2["default"])(this._retainDisposables.values()), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var disposable = _step5.value;
                disposable.dispose();
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
        this._retainDisposables.clear();
    };
    _proto._expectOperationLoader = function _expectOperationLoader() {
        var operationLoader = this._operationLoader;
        !operationLoader && invariant(false);
        return operationLoader;
    };
    return Executor;
}();
function partitionGraphQLResponses(responses) {
    var nonIncrementalResponses = [];
    var incrementalResponses = [];
    responses.forEach(function(response) {
        if (response.path != null || response.label != null) {
            var label = response.label, path = response.path;
            if (label == null || path == null) invariant(false);
            incrementalResponses.push({
                label: label,
                path: path,
                response: response
            });
        } else nonIncrementalResponses.push(response);
    });
    return [
        nonIncrementalResponses,
        incrementalResponses
    ];
}
function stableStringify(value) {
    var _JSON$stringify;
    return (_JSON$stringify = JSON.stringify(stableCopy(value))) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : '';
}
function validateOptimisticResponsePayload(payload) {
    var incrementalPlaceholders = payload.incrementalPlaceholders;
    if (incrementalPlaceholders != null && incrementalPlaceholders.length !== 0) invariant(false);
}
module.exports = {
    execute: execute
};

},{"@swc/helpers/_/_type_of":"iFJdx","49580c31bcbf7d59":"590td","eeb3dd86519eed11":"fMaLa","1ad75e1e684ac8da":"7EBX0","e0d2f76365dd12f8":"hYmcP","53effba0aa0a9f3b":"cvLlA","63f8b694e282c34e":"4vplj","c563ec7552178872":"fAMd2","684c4bb17ec7a904":"a0FL5","756e65a1b1e2b98a":"c3NLR","6ad11a88c87d1dd6":"bpSpv","252789120f8e7534":"gL1rB","a01ca47262c4e73f":"138Hd","f9d3e7aecfe62c60":"daXOB","4efc4864b1deda57":"9k2Dg","83eea5189beedbbd":"6w3KR","792fd666f198e19":"3QcrW","cdbd9f2d618fa355":"e2sci","a122a32f941a9238":"j64TH"}],"4vplj":[function(require,module,exports,__globalThis) {
'use strict';
var _require = require("684bc1d68b06346"), REQUEST = _require.REQUEST, SPLIT_OPERATION = _require.SPLIT_OPERATION;
function getOperation(node) {
    switch(node.kind){
        case REQUEST:
            return node.operation;
        case SPLIT_OPERATION:
        default:
            return node;
    }
}
module.exports = getOperation;

},{"684bc1d68b06346":"jKskk"}],"fAMd2":[function(require,module,exports,__globalThis) {
'use strict';
function createError(type, name, messageFormat) {
    for(var _len = arguments.length, messageParams = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)messageParams[_key - 3] = arguments[_key];
    var index = 0;
    var message = messageFormat.replace(/%s/g, function() {
        return String(messageParams[index++]);
    });
    var err = new Error(message);
    var error = Object.assign(err, {
        name: name,
        messageFormat: messageFormat,
        messageParams: messageParams,
        type: type,
        taalOpcodes: [
            2,
            2
        ]
    });
    if (error.stack === undefined) try {
        throw error;
    } catch (_unused) {}
    return error;
}
module.exports = {
    create: function create(name, messageFormat) {
        for(var _len2 = arguments.length, messageParams = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++)messageParams[_key2 - 2] = arguments[_key2];
        return createError.apply(void 0, [
            'error',
            name,
            messageFormat
        ].concat(messageParams));
    },
    createWarning: function createWarning(name, messageFormat) {
        for(var _len3 = arguments.length, messageParams = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)messageParams[_key3 - 2] = arguments[_key3];
        return createError.apply(void 0, [
            'warn',
            name,
            messageFormat
        ].concat(messageParams));
    }
};

},{}],"bpSpv":[function(require,module,exports,__globalThis) {
'use strict';
var _window, _window$performance;
var isPerformanceNowAvailable = typeof window !== 'undefined' && typeof ((_window = window) === null || _window === void 0 ? void 0 : (_window$performance = _window.performance) === null || _window$performance === void 0 ? void 0 : _window$performance.now) === 'function';
function currentTimestamp() {
    if (isPerformanceNowAvailable) return window.performance.now();
    return Date.now();
}
function withDuration(cb) {
    var startTime = currentTimestamp();
    var result = cb();
    return [
        currentTimestamp() - startTime,
        result
    ];
}
module.exports = withDuration;

},{}],"8vVqI":[function(require,module,exports,__globalThis) {
var global = arguments[3];
'use strict';
var _global$ErrorUtils$ap, _global$ErrorUtils;
var RelayRecordSourceMutator = require("bfd529e4a41ade2c");
var RelayRecordSourceProxy = require("d6caa5fe5bbd541f");
var RelayRecordSourceSelectorProxy = require("8a05b6ea0b9289f2");
var RelayReader = require("9ac26e7470a958b5");
var RelayRecordSource = require("db9f9633773fc022");
var invariant = require("278061d7bbe08f7");
var warning = require("66f382df70fb6ae5");
var _global = typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : undefined;
var applyWithGuard = (_global$ErrorUtils$ap = _global === null || _global === void 0 ? void 0 : (_global$ErrorUtils = _global.ErrorUtils) === null || _global$ErrorUtils === void 0 ? void 0 : _global$ErrorUtils.applyWithGuard) !== null && _global$ErrorUtils$ap !== void 0 ? _global$ErrorUtils$ap : function applyWithGuard(callback, context, args, onError, name) {
    return callback.apply(context, args);
};
var RelayPublishQueue = /*#__PURE__*/ function() {
    function RelayPublishQueue(store, handlerProvider, getDataID, missingFieldHandlers) {
        this._hasStoreSnapshot = false;
        this._handlerProvider = handlerProvider || null;
        this._pendingBackupRebase = false;
        this._pendingData = new Set();
        this._pendingOptimisticUpdates = new Set();
        this._store = store;
        this._appliedOptimisticUpdates = new Set();
        this._gcHold = null;
        this._getDataID = getDataID;
        this._missingFieldHandlers = missingFieldHandlers;
    }
    var _proto = RelayPublishQueue.prototype;
    _proto.applyUpdate = function applyUpdate(updater) {
        !(!this._appliedOptimisticUpdates.has(updater) && !this._pendingOptimisticUpdates.has(updater)) && invariant(false);
        this._pendingOptimisticUpdates.add(updater);
    };
    _proto.revertUpdate = function revertUpdate(updater) {
        if (this._pendingOptimisticUpdates.has(updater)) this._pendingOptimisticUpdates["delete"](updater);
        else if (this._appliedOptimisticUpdates.has(updater)) {
            this._pendingBackupRebase = true;
            this._appliedOptimisticUpdates["delete"](updater);
        }
    };
    _proto.revertAll = function revertAll() {
        this._pendingBackupRebase = true;
        this._pendingOptimisticUpdates.clear();
        this._appliedOptimisticUpdates.clear();
    };
    _proto.commitPayload = function commitPayload(operation, payload, updater) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: 'payload',
            operation: operation,
            payload: payload,
            updater: updater
        });
    };
    _proto.commitUpdate = function commitUpdate(updater) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: 'updater',
            updater: updater
        });
    };
    _proto.commitSource = function commitSource(source) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: 'source',
            source: source
        });
    };
    _proto.run = function run(sourceOperation) {
        var runWillClearGcHold = this._appliedOptimisticUpdates === 0 && !!this._gcHold;
        var runIsANoop = !this._pendingBackupRebase && this._pendingOptimisticUpdates.size === 0 && !runWillClearGcHold;
        if (runIsANoop) return [];
        if (this._pendingBackupRebase) {
            if (this._hasStoreSnapshot) {
                this._store.restore();
                this._hasStoreSnapshot = false;
            }
        }
        var invalidatedStore = this._commitData();
        if (this._pendingOptimisticUpdates.size || this._pendingBackupRebase && this._appliedOptimisticUpdates.size) {
            if (!this._hasStoreSnapshot) {
                this._store.snapshot();
                this._hasStoreSnapshot = true;
            }
            this._applyUpdates();
        }
        this._pendingBackupRebase = false;
        if (this._appliedOptimisticUpdates.size > 0) {
            if (!this._gcHold) this._gcHold = this._store.holdGC();
        } else if (this._gcHold) {
            this._gcHold.dispose();
            this._gcHold = null;
        }
        return this._store.notify(sourceOperation, invalidatedStore);
    };
    _proto._publishSourceFromPayload = function _publishSourceFromPayload(pendingPayload) {
        var _this = this;
        var payload = pendingPayload.payload, operation = pendingPayload.operation, updater = pendingPayload.updater;
        var source = payload.source, fieldPayloads = payload.fieldPayloads;
        var mutator = new RelayRecordSourceMutator(this._store.getSource(), source);
        var recordSourceProxy = new RelayRecordSourceProxy(mutator, this._getDataID, this._handlerProvider, this._missingFieldHandlers);
        if (fieldPayloads && fieldPayloads.length) fieldPayloads.forEach(function(fieldPayload) {
            var handler = _this._handlerProvider && _this._handlerProvider(fieldPayload.handle);
            !handler && invariant(false);
            handler.update(recordSourceProxy, fieldPayload);
        });
        if (updater) {
            var selector = operation.fragment;
            !(selector != null) && invariant(false);
            var recordSourceSelectorProxy = new RelayRecordSourceSelectorProxy(mutator, recordSourceProxy, selector, this._missingFieldHandlers);
            var selectorData = lookupSelector(source, selector);
            updater(recordSourceSelectorProxy, selectorData);
        }
        var idsMarkedForInvalidation = recordSourceProxy.getIDsMarkedForInvalidation();
        this._store.publish(source, idsMarkedForInvalidation);
        return recordSourceProxy.isStoreMarkedForInvalidation();
    };
    _proto._commitData = function _commitData() {
        var _this2 = this;
        if (!this._pendingData.size) return false;
        var invalidatedStore = false;
        this._pendingData.forEach(function(data) {
            if (data.kind === 'payload') {
                var payloadInvalidatedStore = _this2._publishSourceFromPayload(data);
                invalidatedStore = invalidatedStore || payloadInvalidatedStore;
            } else if (data.kind === 'source') {
                var source = data.source;
                _this2._store.publish(source);
            } else {
                var updater = data.updater;
                var sink = RelayRecordSource.create();
                var mutator = new RelayRecordSourceMutator(_this2._store.getSource(), sink);
                var recordSourceProxy = new RelayRecordSourceProxy(mutator, _this2._getDataID, _this2._handlerProvider, _this2._missingFieldHandlers);
                applyWithGuard(updater, null, [
                    recordSourceProxy
                ], null, 'RelayPublishQueue:commitData');
                invalidatedStore = invalidatedStore || recordSourceProxy.isStoreMarkedForInvalidation();
                var idsMarkedForInvalidation = recordSourceProxy.getIDsMarkedForInvalidation();
                _this2._store.publish(sink, idsMarkedForInvalidation);
            }
        });
        this._pendingData.clear();
        return invalidatedStore;
    };
    _proto._applyUpdates = function _applyUpdates() {
        var _this3 = this;
        var sink = RelayRecordSource.create();
        var mutator = new RelayRecordSourceMutator(this._store.getSource(), sink);
        var recordSourceProxy = new RelayRecordSourceProxy(mutator, this._getDataID, this._handlerProvider, this._missingFieldHandlers);
        var processUpdate = function processUpdate(optimisticUpdate) {
            if (optimisticUpdate.storeUpdater) {
                var storeUpdater = optimisticUpdate.storeUpdater;
                applyWithGuard(storeUpdater, null, [
                    recordSourceProxy
                ], null, 'RelayPublishQueue:applyUpdates');
            } else {
                var operation = optimisticUpdate.operation, payload = optimisticUpdate.payload, updater = optimisticUpdate.updater;
                var source = payload.source, fieldPayloads = payload.fieldPayloads;
                if (source) recordSourceProxy.publishSource(source, fieldPayloads);
                if (updater) {
                    var selectorData;
                    if (source) selectorData = lookupSelector(source, operation.fragment);
                    var recordSourceSelectorProxy = new RelayRecordSourceSelectorProxy(mutator, recordSourceProxy, operation.fragment, _this3._missingFieldHandlers);
                    applyWithGuard(updater, null, [
                        recordSourceSelectorProxy,
                        selectorData
                    ], null, 'RelayPublishQueue:applyUpdates');
                }
            }
        };
        if (this._pendingBackupRebase && this._appliedOptimisticUpdates.size) this._appliedOptimisticUpdates.forEach(processUpdate);
        if (this._pendingOptimisticUpdates.size) {
            this._pendingOptimisticUpdates.forEach(function(optimisticUpdate) {
                processUpdate(optimisticUpdate);
                _this3._appliedOptimisticUpdates.add(optimisticUpdate);
            });
            this._pendingOptimisticUpdates.clear();
        }
        this._store.publish(sink);
    };
    return RelayPublishQueue;
}();
function lookupSelector(source, selector) {
    var selectorData = RelayReader.read(source, selector).data;
    var deepFreeze;
    return selectorData;
}
module.exports = RelayPublishQueue;

},{"bfd529e4a41ade2c":"kKEFB","d6caa5fe5bbd541f":"7OCKP","8a05b6ea0b9289f2":"aHyGd","9ac26e7470a958b5":"hTh0M","db9f9633773fc022":"6w3KR","278061d7bbe08f7":"e2sci","66f382df70fb6ae5":"j64TH"}],"kKEFB":[function(require,module,exports,__globalThis) {
'use strict';
var RelayModernRecord = require("f7566715ac011ace");
var _require = require("cadd642407d15db9"), EXISTENT = _require.EXISTENT;
var invariant = require("15734011101e0993");
var RelayRecordSourceMutator = /*#__PURE__*/ function() {
    function RelayRecordSourceMutator(base, sink) {
        this.__sources = [
            sink,
            base
        ];
        this._base = base;
        this._sink = sink;
    }
    var _proto = RelayRecordSourceMutator.prototype;
    _proto.unstable_getRawRecordWithChanges = function unstable_getRawRecordWithChanges(dataID) {
        var baseRecord = this._base.get(dataID);
        var sinkRecord = this._sink.get(dataID);
        if (sinkRecord === undefined) {
            if (baseRecord == null) return baseRecord;
            var nextRecord = RelayModernRecord.clone(baseRecord);
            return nextRecord;
        } else if (sinkRecord === null) return null;
        else if (baseRecord != null) {
            var _nextRecord = RelayModernRecord.update(baseRecord, sinkRecord);
            return _nextRecord;
        } else {
            var _nextRecord2 = RelayModernRecord.clone(sinkRecord);
            return _nextRecord2;
        }
    };
    _proto._getSinkRecord = function _getSinkRecord(dataID) {
        var sinkRecord = this._sink.get(dataID);
        if (!sinkRecord) {
            var baseRecord = this._base.get(dataID);
            !baseRecord && invariant(false);
            sinkRecord = RelayModernRecord.create(dataID, RelayModernRecord.getType(baseRecord));
            this._sink.set(dataID, sinkRecord);
        }
        return sinkRecord;
    };
    _proto.copyFields = function copyFields(sourceID, sinkID) {
        var sinkSource = this._sink.get(sourceID);
        var baseSource = this._base.get(sourceID);
        !(sinkSource || baseSource) && invariant(false);
        var sink = this._getSinkRecord(sinkID);
        if (baseSource) RelayModernRecord.copyFields(baseSource, sink);
        if (sinkSource) RelayModernRecord.copyFields(sinkSource, sink);
    };
    _proto.copyFieldsFromRecord = function copyFieldsFromRecord(record, sinkID) {
        var sink = this._getSinkRecord(sinkID);
        RelayModernRecord.copyFields(record, sink);
    };
    _proto.create = function create(dataID, typeName) {
        !(this._base.getStatus(dataID) !== EXISTENT && this._sink.getStatus(dataID) !== EXISTENT) && invariant(false);
        var record = RelayModernRecord.create(dataID, typeName);
        this._sink.set(dataID, record);
    };
    _proto["delete"] = function _delete(dataID) {
        this._sink["delete"](dataID);
    };
    _proto.getStatus = function getStatus(dataID) {
        return this._sink.has(dataID) ? this._sink.getStatus(dataID) : this._base.getStatus(dataID);
    };
    _proto.getType = function getType(dataID) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) return RelayModernRecord.getType(record);
            else if (record === null) return null;
        }
    };
    _proto.getValue = function getValue(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var value = RelayModernRecord.getValue(record, storageKey);
                if (value !== undefined) return value;
            } else if (record === null) return null;
        }
    };
    _proto.setValue = function setValue(dataID, storageKey, value) {
        var sinkRecord = this._getSinkRecord(dataID);
        RelayModernRecord.setValue(sinkRecord, storageKey, value);
    };
    _proto.getLinkedRecordID = function getLinkedRecordID(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var linkedID = RelayModernRecord.getLinkedRecordID(record, storageKey);
                if (linkedID !== undefined) return linkedID;
            } else if (record === null) return null;
        }
    };
    _proto.setLinkedRecordID = function setLinkedRecordID(dataID, storageKey, linkedID) {
        var sinkRecord = this._getSinkRecord(dataID);
        RelayModernRecord.setLinkedRecordID(sinkRecord, storageKey, linkedID);
    };
    _proto.getLinkedRecordIDs = function getLinkedRecordIDs(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var linkedIDs = RelayModernRecord.getLinkedRecordIDs(record, storageKey);
                if (linkedIDs !== undefined) return linkedIDs;
            } else if (record === null) return null;
        }
    };
    _proto.setLinkedRecordIDs = function setLinkedRecordIDs(dataID, storageKey, linkedIDs) {
        var sinkRecord = this._getSinkRecord(dataID);
        RelayModernRecord.setLinkedRecordIDs(sinkRecord, storageKey, linkedIDs);
    };
    return RelayRecordSourceMutator;
}();
module.exports = RelayRecordSourceMutator;

},{"f7566715ac011ace":"daXOB","cadd642407d15db9":"7LnXj","15734011101e0993":"e2sci"}],"7OCKP":[function(require,module,exports,__globalThis) {
'use strict';
var RelayModernRecord = require("2d0374478be282f8");
var _require = require("6edb7b533917499f"), EXISTENT = _require.EXISTENT, NONEXISTENT = _require.NONEXISTENT;
var _require2 = require("61ac24ad43bdb688"), ROOT_ID = _require2.ROOT_ID, ROOT_TYPE = _require2.ROOT_TYPE;
var _require3 = require("f12e4092bdced584"), _readUpdatableFragment = _require3.readUpdatableFragment;
var _require4 = require("221b8709f9263d2"), _readUpdatableQuery = _require4.readUpdatableQuery;
var RelayRecordProxy = require("c9b916d38891ead6");
var invariant = require("d73775d13d747a03");
var RelayRecordSourceProxy = /*#__PURE__*/ function() {
    function RelayRecordSourceProxy(mutator, getDataID, handlerProvider, missingFieldHandlers) {
        this.__mutator = mutator;
        this._handlerProvider = handlerProvider || null;
        this._proxies = {};
        this._getDataID = getDataID;
        this._invalidatedStore = false;
        this._idsMarkedForInvalidation = new Set();
        this._missingFieldHandlers = missingFieldHandlers;
    }
    var _proto = RelayRecordSourceProxy.prototype;
    _proto.publishSource = function publishSource(source, fieldPayloads) {
        var _this = this;
        var dataIDs = source.getRecordIDs();
        dataIDs.forEach(function(dataID) {
            var status = source.getStatus(dataID);
            if (status === EXISTENT) {
                var sourceRecord = source.get(dataID);
                if (sourceRecord) {
                    if (_this.__mutator.getStatus(dataID) !== EXISTENT) _this.create(dataID, RelayModernRecord.getType(sourceRecord));
                    _this.__mutator.copyFieldsFromRecord(sourceRecord, dataID);
                }
            } else if (status === NONEXISTENT) _this["delete"](dataID);
        });
        if (fieldPayloads && fieldPayloads.length) fieldPayloads.forEach(function(fieldPayload) {
            var handler = _this._handlerProvider && _this._handlerProvider(fieldPayload.handle);
            !handler && invariant(false);
            handler.update(_this, fieldPayload);
        });
    };
    _proto.create = function create(dataID, typeName) {
        this.__mutator.create(dataID, typeName);
        delete this._proxies[dataID];
        var record = this.get(dataID);
        !record && invariant(false);
        return record;
    };
    _proto["delete"] = function _delete(dataID) {
        !(dataID !== ROOT_ID) && invariant(false);
        delete this._proxies[dataID];
        this.__mutator["delete"](dataID);
    };
    _proto.get = function get(dataID) {
        if (!this._proxies.hasOwnProperty(dataID)) {
            var status = this.__mutator.getStatus(dataID);
            if (status === EXISTENT) this._proxies[dataID] = new RelayRecordProxy(this, this.__mutator, dataID);
            else this._proxies[dataID] = status === NONEXISTENT ? null : undefined;
        }
        return this._proxies[dataID];
    };
    _proto.getRoot = function getRoot() {
        var root = this.get(ROOT_ID);
        if (!root) root = this.create(ROOT_ID, ROOT_TYPE);
        !(root && root.getType() === ROOT_TYPE) && invariant(false);
        return root;
    };
    _proto.invalidateStore = function invalidateStore() {
        this._invalidatedStore = true;
    };
    _proto.isStoreMarkedForInvalidation = function isStoreMarkedForInvalidation() {
        return this._invalidatedStore;
    };
    _proto.markIDForInvalidation = function markIDForInvalidation(dataID) {
        this._idsMarkedForInvalidation.add(dataID);
    };
    _proto.getIDsMarkedForInvalidation = function getIDsMarkedForInvalidation() {
        return this._idsMarkedForInvalidation;
    };
    _proto.readUpdatableQuery = function readUpdatableQuery(query, variables) {
        return _readUpdatableQuery(query, variables, this, this._missingFieldHandlers);
    };
    _proto.readUpdatableFragment = function readUpdatableFragment(fragment, fragmentReference) {
        return _readUpdatableFragment(fragment, fragmentReference, this, this._missingFieldHandlers);
    };
    return RelayRecordSourceProxy;
}();
module.exports = RelayRecordSourceProxy;

},{"2d0374478be282f8":"daXOB","6edb7b533917499f":"7LnXj","61ac24ad43bdb688":"3QcrW","f12e4092bdced584":"oP4is","221b8709f9263d2":"hphRe","c9b916d38891ead6":"1WULY","d73775d13d747a03":"e2sci"}],"oP4is":[function(require,module,exports,__globalThis) {
'use strict';
var _require = require("8d5efcdf4dd4a551"), getFragment = _require.getFragment;
var _require2 = require("9e0c28c3cd543a5f"), getVariablesFromFragment = _require2.getVariablesFromFragment;
var _require3 = require("93299dc71edc4d7f"), ID_KEY = _require3.ID_KEY;
var _require4 = require("339cfb1f00043c83"), createUpdatableProxy = _require4.createUpdatableProxy;
var invariant = require("9186d1d33ea9d2e9");
function readUpdatableFragment(fragment, fragmentReference, proxy, missingFieldHandlers) {
    var updatableFragment = getFragment(fragment);
    var fragmentVariables = getVariablesFromFragment(updatableFragment, fragmentReference);
    var id = fragmentReference[ID_KEY];
    var fragmentRoot = proxy.get(id);
    !(fragmentRoot != null) && invariant(false);
    return {
        updatableData: createUpdatableProxy(fragmentRoot, fragmentVariables, updatableFragment.selections, proxy, missingFieldHandlers)
    };
}
module.exports = {
    readUpdatableFragment: readUpdatableFragment
};

},{"8d5efcdf4dd4a551":"8UTII","9e0c28c3cd543a5f":"9k2Dg","93299dc71edc4d7f":"3QcrW","339cfb1f00043c83":"8HjK2","9186d1d33ea9d2e9":"e2sci"}],"8HjK2":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("8084d420b45658dd")["default"];
var _createForOfIteratorHelper2 = _interopRequireDefault(require("5a16f171a61f13da"));
var _require = require("68b9fda909a9dca9"), getArgumentValues = _require.getArgumentValues;
var _require2 = require("5fc9db6a2424724c"), ACTOR_CHANGE = _require2.ACTOR_CHANGE, ALIASED_FRAGMENT_SPREAD = _require2.ALIASED_FRAGMENT_SPREAD, ALIASED_INLINE_FRAGMENT_SPREAD = _require2.ALIASED_INLINE_FRAGMENT_SPREAD, CATCH_FIELD = _require2.CATCH_FIELD, CLIENT_EDGE_TO_CLIENT_OBJECT = _require2.CLIENT_EDGE_TO_CLIENT_OBJECT, CLIENT_EDGE_TO_SERVER_OBJECT = _require2.CLIENT_EDGE_TO_SERVER_OBJECT, CLIENT_EXTENSION = _require2.CLIENT_EXTENSION, CONDITION = _require2.CONDITION, DEFER = _require2.DEFER, FRAGMENT_SPREAD = _require2.FRAGMENT_SPREAD, INLINE_DATA_FRAGMENT_SPREAD = _require2.INLINE_DATA_FRAGMENT_SPREAD, INLINE_FRAGMENT = _require2.INLINE_FRAGMENT, LINKED_FIELD = _require2.LINKED_FIELD, MODULE_IMPORT = _require2.MODULE_IMPORT, RELAY_LIVE_RESOLVER = _require2.RELAY_LIVE_RESOLVER, RELAY_RESOLVER = _require2.RELAY_RESOLVER, REQUIRED_FIELD = _require2.REQUIRED_FIELD, SCALAR_FIELD = _require2.SCALAR_FIELD, STREAM = _require2.STREAM;
var nonUpdatableKeys = [
    'id',
    '__id',
    '__typename',
    'js'
];
function createUpdatableProxy(updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers) {
    var mutableUpdatableProxy = {};
    updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers);
    return mutableUpdatableProxy;
}
function updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers) {
    var _selection$alias3;
    var _iterator = (0, _createForOfIteratorHelper2["default"])(selections), _step;
    try {
        var _loop = function _loop() {
            var selection = _step.value;
            switch(selection.kind){
                case LINKED_FIELD:
                    if (selection.plural) Object.defineProperty(mutableUpdatableProxy, (_selection$alias = selection.alias) !== null && _selection$alias !== void 0 ? _selection$alias : selection.name, {
                        get: createGetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers),
                        set: createSetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy)
                    });
                    else Object.defineProperty(mutableUpdatableProxy, (_selection$alias2 = selection.alias) !== null && _selection$alias2 !== void 0 ? _selection$alias2 : selection.name, {
                        get: createGetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers),
                        set: createSetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy)
                    });
                    break;
                case SCALAR_FIELD:
                    var scalarFieldName = (_selection$alias3 = selection.alias) !== null && _selection$alias3 !== void 0 ? _selection$alias3 : selection.name;
                    Object.defineProperty(mutableUpdatableProxy, scalarFieldName, {
                        get: function get() {
                            var _selection$args;
                            var newVariables = getArgumentValues((_selection$args = selection.args) !== null && _selection$args !== void 0 ? _selection$args : [], variables);
                            var value = updatableProxyRootRecord.getValue(selection.name, newVariables);
                            if (value == null) value = getScalarUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
                            return value;
                        },
                        set: nonUpdatableKeys.includes(selection.name) ? undefined : function(newValue) {
                            var _selection$args2;
                            var newVariables = getArgumentValues((_selection$args2 = selection.args) !== null && _selection$args2 !== void 0 ? _selection$args2 : [], variables);
                            updatableProxyRootRecord.setValue__UNSAFE(newValue, selection.name, newVariables);
                        }
                    });
                    break;
                case INLINE_FRAGMENT:
                    if (updatableProxyRootRecord.getType() === selection.type) updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                    break;
                case CLIENT_EXTENSION:
                    updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                    break;
                case FRAGMENT_SPREAD:
                    break;
                case CONDITION:
                case ACTOR_CHANGE:
                case ALIASED_FRAGMENT_SPREAD:
                case INLINE_DATA_FRAGMENT_SPREAD:
                case ALIASED_INLINE_FRAGMENT_SPREAD:
                case CLIENT_EDGE_TO_CLIENT_OBJECT:
                case CLIENT_EDGE_TO_SERVER_OBJECT:
                case DEFER:
                case MODULE_IMPORT:
                case RELAY_LIVE_RESOLVER:
                case REQUIRED_FIELD:
                case CATCH_FIELD:
                case STREAM:
                case RELAY_RESOLVER:
                    throw new Error('Encountered an unexpected ReaderSelection variant in RelayRecordSourceProxy. This indicates a bug in Relay.');
                default:
                    selection.kind;
                    throw new Error('Encountered an unexpected ReaderSelection variant in RelayRecordSourceProxy. This indicates a bug in Relay.');
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _selection$alias;
            var _selection$alias2;
            _loop();
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
}
function createSetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy) {
    return function set(newValue) {
        var _selection$args3;
        var newVariables = getArgumentValues((_selection$args3 = selection.args) !== null && _selection$args3 !== void 0 ? _selection$args3 : [], variables);
        if (newValue == null) throw new Error('Do not assign null to plural linked fields; assign an empty array instead.');
        else {
            var recordProxies = newValue.map(function(item) {
                if (item == null) throw new Error('When assigning an array of items, none of the items should be null or undefined.');
                var __id = item.__id;
                if (__id == null) throw new Error('The __id field must be present on each item passed to the setter. This indicates a bug in Relay.');
                var newValueRecord = recordSourceProxy.get(__id);
                if (newValueRecord == null) throw new Error("Did not find item with data id ".concat(__id, " in the store."));
                return newValueRecord;
            });
            updatableProxyRootRecord.setLinkedRecords(recordProxies, selection.name, newVariables);
        }
    };
}
function createSetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy) {
    return function set(newValue) {
        var _selection$args4;
        var newVariables = getArgumentValues((_selection$args4 = selection.args) !== null && _selection$args4 !== void 0 ? _selection$args4 : [], variables);
        if (newValue == null) updatableProxyRootRecord.setValue(newValue, selection.name, newVariables);
        else {
            var __id = newValue.__id;
            if (__id == null) throw new Error('The __id field must be present on the argument. This indicates a bug in Relay.');
            var newValueRecord = recordSourceProxy.get(__id);
            if (newValueRecord == null) throw new Error("Did not find item with data id ".concat(__id, " in the store."));
            updatableProxyRootRecord.setLinkedRecord(newValueRecord, selection.name, newVariables);
        }
    };
}
function createGetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    return function() {
        var _selection$args5;
        var newVariables = getArgumentValues((_selection$args5 = selection.args) !== null && _selection$args5 !== void 0 ? _selection$args5 : [], variables);
        var linkedRecords = updatableProxyRootRecord.getLinkedRecords(selection.name, newVariables);
        if (linkedRecords === undefined) linkedRecords = getPluralLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
        if (linkedRecords != null) return linkedRecords.map(function(linkedRecord) {
            if (linkedRecord != null) {
                var updatableProxy = {};
                updateProxyFromSelections(updatableProxy, linkedRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                return updatableProxy;
            } else return linkedRecord;
        });
        else return linkedRecords;
    };
}
function createGetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    return function() {
        var _selection$args6;
        var newVariables = getArgumentValues((_selection$args6 = selection.args) !== null && _selection$args6 !== void 0 ? _selection$args6 : [], variables);
        var linkedRecord = updatableProxyRootRecord.getLinkedRecord(selection.name, newVariables);
        if (linkedRecord === undefined) linkedRecord = getLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
        if (linkedRecord != null) {
            var updatableProxy = {};
            updateProxyFromSelections(updatableProxy, linkedRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
            return updatableProxy;
        } else return linkedRecord;
    };
}
function getLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator2 = (0, _createForOfIteratorHelper2["default"])(missingFieldHandlers), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var handler = _step2.value;
            if (handler.kind === 'linked') {
                var newId = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (newId != null) return recordSourceProxy.get(newId);
            }
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
}
function getPluralLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator3 = (0, _createForOfIteratorHelper2["default"])(missingFieldHandlers), _step3;
    try {
        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
            var handler = _step3.value;
            if (handler.kind === 'pluralLinked') {
                var newIds = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (newIds != null) return newIds.map(function(newId) {
                    if (newId != null) return recordSourceProxy.get(newId);
                });
            }
        }
    } catch (err) {
        _iterator3.e(err);
    } finally{
        _iterator3.f();
    }
}
function getScalarUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator4 = (0, _createForOfIteratorHelper2["default"])(missingFieldHandlers), _step4;
    try {
        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
            var handler = _step4.value;
            if (handler.kind === 'scalar') {
                var value = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (value !== undefined) return value;
            }
        }
    } catch (err) {
        _iterator4.e(err);
    } finally{
        _iterator4.f();
    }
}
module.exports = {
    createUpdatableProxy: createUpdatableProxy
};

},{"8084d420b45658dd":"590td","5a16f171a61f13da":"fMaLa","68b9fda909a9dca9":"3QcrW","5fc9db6a2424724c":"jKskk"}],"hphRe":[function(require,module,exports,__globalThis) {
'use strict';
var _require = require("2e587e243aaedac3"), getUpdatableQuery = _require.getUpdatableQuery;
var _require2 = require("88520994ffdface7"), createUpdatableProxy = _require2.createUpdatableProxy;
function readUpdatableQuery(query, variables, proxy, missingFieldHandlers) {
    var updatableQuery = getUpdatableQuery(query);
    return {
        updatableData: createUpdatableProxy(proxy.getRoot(), variables, updatableQuery.fragment.selections, proxy, missingFieldHandlers)
    };
}
module.exports = {
    readUpdatableQuery: readUpdatableQuery
};

},{"2e587e243aaedac3":"8UTII","88520994ffdface7":"8HjK2"}],"1WULY":[function(require,module,exports,__globalThis) {
var _instanceof = require("@swc/helpers/_/_instanceof");
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var _require = require("c0b8d105562c9f38"), generateClientID = _require.generateClientID;
var _require2 = require("b98f3126a52a11a6"), getStableStorageKey = _require2.getStableStorageKey;
var invariant = require("428b6ecf6b366ba0");
var RelayRecordProxy = /*#__PURE__*/ function() {
    function RelayRecordProxy(source, mutator, dataID) {
        this._dataID = dataID;
        this._mutator = mutator;
        this._source = source;
    }
    var _proto = RelayRecordProxy.prototype;
    _proto.copyFieldsFrom = function copyFieldsFrom(source) {
        this._mutator.copyFields(source.getDataID(), this._dataID);
    };
    _proto.getDataID = function getDataID() {
        return this._dataID;
    };
    _proto.getType = function getType() {
        var type = this._mutator.getType(this._dataID);
        !(type != null) && invariant(false);
        return type;
    };
    _proto.getValue = function getValue(name, args) {
        var storageKey = getStableStorageKey(name, args);
        return this._mutator.getValue(this._dataID, storageKey);
    };
    _proto.setValue = function setValue(value, name, args) {
        !isValidLeafValue(value) && invariant(false);
        return this.setValue__UNSAFE(value, name, args);
    };
    _proto.setValue__UNSAFE = function setValue__UNSAFE(value, name, args) {
        var storageKey = getStableStorageKey(name, args);
        this._mutator.setValue(this._dataID, storageKey, value);
        return this;
    };
    _proto.getLinkedRecord = function getLinkedRecord(name, args) {
        var storageKey = getStableStorageKey(name, args);
        var linkedID = this._mutator.getLinkedRecordID(this._dataID, storageKey);
        return linkedID != null ? this._source.get(linkedID) : linkedID;
    };
    _proto.setLinkedRecord = function setLinkedRecord(record, name, args) {
        !(0, _instanceof._)(record, RelayRecordProxy) && invariant(false);
        var storageKey = getStableStorageKey(name, args);
        var linkedID = record.getDataID();
        this._mutator.setLinkedRecordID(this._dataID, storageKey, linkedID);
        return this;
    };
    _proto.getOrCreateLinkedRecord = function getOrCreateLinkedRecord(name, typeName, args) {
        var linkedRecord = this.getLinkedRecord(name, args);
        if (!linkedRecord) {
            var _this$_source$get;
            var storageKey = getStableStorageKey(name, args);
            var clientID = generateClientID(this.getDataID(), storageKey);
            linkedRecord = (_this$_source$get = this._source.get(clientID)) !== null && _this$_source$get !== void 0 ? _this$_source$get : this._source.create(clientID, typeName);
            this.setLinkedRecord(linkedRecord, name, args);
        }
        return linkedRecord;
    };
    _proto.getLinkedRecords = function getLinkedRecords(name, args) {
        var _this = this;
        var storageKey = getStableStorageKey(name, args);
        var linkedIDs = this._mutator.getLinkedRecordIDs(this._dataID, storageKey);
        if (linkedIDs == null) return linkedIDs;
        return linkedIDs.map(function(linkedID) {
            return linkedID != null ? _this._source.get(linkedID) : linkedID;
        });
    };
    _proto.setLinkedRecords = function setLinkedRecords(records, name, args) {
        !Array.isArray(records) && invariant(false);
        var storageKey = getStableStorageKey(name, args);
        var linkedIDs = records.map(function(record) {
            return record && record.getDataID();
        });
        this._mutator.setLinkedRecordIDs(this._dataID, storageKey, linkedIDs);
        return this;
    };
    _proto.invalidateRecord = function invalidateRecord() {
        this._source.markIDForInvalidation(this._dataID);
    };
    return RelayRecordProxy;
}();
function isValidLeafValue(value) {
    return value == null || (typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) !== 'object' || Array.isArray(value) && value.every(isValidLeafValue);
}
module.exports = RelayRecordProxy;

},{"@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_type_of":"iFJdx","c0b8d105562c9f38":"gL1rB","b98f3126a52a11a6":"3QcrW","428b6ecf6b366ba0":"e2sci"}],"aHyGd":[function(require,module,exports,__globalThis) {
'use strict';
var _require = require("3525ecde8cb78a4"), ROOT_TYPE = _require.ROOT_TYPE, getStorageKey = _require.getStorageKey;
var _require2 = require("392cc4a3736ed13f"), _readUpdatableFragment = _require2.readUpdatableFragment;
var _require3 = require("ebf57ab694b79ffd"), _readUpdatableQuery = _require3.readUpdatableQuery;
var invariant = require("21796ae00adf6ce3");
var RelayRecordSourceSelectorProxy = /*#__PURE__*/ function() {
    function RelayRecordSourceSelectorProxy(mutator, recordSource, readSelector, missingFieldHandlers) {
        this.__mutator = mutator;
        this.__recordSource = recordSource;
        this._readSelector = readSelector;
        this._missingFieldHandlers = missingFieldHandlers;
    }
    var _proto = RelayRecordSourceSelectorProxy.prototype;
    _proto.create = function create(dataID, typeName) {
        return this.__recordSource.create(dataID, typeName);
    };
    _proto["delete"] = function _delete(dataID) {
        this.__recordSource["delete"](dataID);
    };
    _proto.get = function get(dataID) {
        return this.__recordSource.get(dataID);
    };
    _proto.getRoot = function getRoot() {
        return this.__recordSource.getRoot();
    };
    _proto.getOperationRoot = function getOperationRoot() {
        var root = this.__recordSource.get(this._readSelector.dataID);
        if (!root) root = this.__recordSource.create(this._readSelector.dataID, ROOT_TYPE);
        return root;
    };
    _proto._getRootField = function _getRootField(selector, fieldName, plural) {
        var field = selector.node.selections.find(function(selection) {
            return selection.kind === 'LinkedField' && selection.name === fieldName || selection.kind === 'RequiredField' && selection.field.name === fieldName;
        });
        if (field && field.kind === 'RequiredField') field = field.field;
        !(field && field.kind === 'LinkedField') && invariant(false);
        !(field.plural === plural) && invariant(false);
        return field;
    };
    _proto.getRootField = function getRootField(fieldName) {
        var field = this._getRootField(this._readSelector, fieldName, false);
        var storageKey = getStorageKey(field, this._readSelector.variables);
        return this.getOperationRoot().getLinkedRecord(storageKey);
    };
    _proto.getPluralRootField = function getPluralRootField(fieldName) {
        var field = this._getRootField(this._readSelector, fieldName, true);
        var storageKey = getStorageKey(field, this._readSelector.variables);
        return this.getOperationRoot().getLinkedRecords(storageKey);
    };
    _proto.invalidateStore = function invalidateStore() {
        this.__recordSource.invalidateStore();
    };
    _proto.readUpdatableQuery = function readUpdatableQuery(query, variables) {
        return _readUpdatableQuery(query, variables, this, this._missingFieldHandlers);
    };
    _proto.readUpdatableFragment = function readUpdatableFragment(fragment, fragmentReference) {
        return _readUpdatableFragment(fragment, fragmentReference, this, this._missingFieldHandlers);
    };
    return RelayRecordSourceSelectorProxy;
}();
module.exports = RelayRecordSourceSelectorProxy;

},{"3525ecde8cb78a4":"3QcrW","392cc4a3736ed13f":"oP4is","ebf57ab694b79ffd":"hphRe","21796ae00adf6ce3":"e2sci"}],"hTh0M":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var _interopRequireDefault = require("a3c1fb2c07af9d8f")["default"];
var _defineProperty2 = _interopRequireDefault(require("ecd5938fdccf58d0"));
var _createForOfIteratorHelper2 = _interopRequireDefault(require("9637d3d0c215e422"));
var _toConsumableArray2 = _interopRequireDefault(require("e1d5f18766f34ffd"));
var _require = require("9e5c55714f84bbfd"), ACTOR_CHANGE = _require.ACTOR_CHANGE, ALIASED_FRAGMENT_SPREAD = _require.ALIASED_FRAGMENT_SPREAD, ALIASED_INLINE_FRAGMENT_SPREAD = _require.ALIASED_INLINE_FRAGMENT_SPREAD, CATCH_FIELD = _require.CATCH_FIELD, CLIENT_EDGE_TO_CLIENT_OBJECT = _require.CLIENT_EDGE_TO_CLIENT_OBJECT, CLIENT_EDGE_TO_SERVER_OBJECT = _require.CLIENT_EDGE_TO_SERVER_OBJECT, CLIENT_EXTENSION = _require.CLIENT_EXTENSION, CONDITION = _require.CONDITION, DEFER = _require.DEFER, FRAGMENT_SPREAD = _require.FRAGMENT_SPREAD, INLINE_DATA_FRAGMENT_SPREAD = _require.INLINE_DATA_FRAGMENT_SPREAD, INLINE_FRAGMENT = _require.INLINE_FRAGMENT, LINKED_FIELD = _require.LINKED_FIELD, MODULE_IMPORT = _require.MODULE_IMPORT, RELAY_LIVE_RESOLVER = _require.RELAY_LIVE_RESOLVER, RELAY_RESOLVER = _require.RELAY_RESOLVER, REQUIRED_FIELD = _require.REQUIRED_FIELD, SCALAR_FIELD = _require.SCALAR_FIELD, STREAM = _require.STREAM;
var RelayFeatureFlags = require("e4590f7d0743b994");
var _require2 = require("134060d0435491fc"), isSuspenseSentinel = _require2.isSuspenseSentinel;
var RelayConcreteVariables = require("6aa3e28b2397f0f2");
var RelayModernRecord = require("1474639a77db088c");
var _require3 = require("ceb4056395d53b78"), CLIENT_EDGE_TRAVERSAL_PATH = _require3.CLIENT_EDGE_TRAVERSAL_PATH, FRAGMENT_OWNER_KEY = _require3.FRAGMENT_OWNER_KEY, FRAGMENT_PROP_NAME_KEY = _require3.FRAGMENT_PROP_NAME_KEY, FRAGMENTS_KEY = _require3.FRAGMENTS_KEY, ID_KEY = _require3.ID_KEY, MODULE_COMPONENT_KEY = _require3.MODULE_COMPONENT_KEY, ROOT_ID = _require3.ROOT_ID, getArgumentValues = _require3.getArgumentValues, getModuleComponentKey = _require3.getModuleComponentKey, getStorageKey = _require3.getStorageKey;
var _require4 = require("2ec0ed85284cf22"), NoopResolverCache = _require4.NoopResolverCache;
var _require5 = require("91eb3a4f12b0db94"), RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL = _require5.RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL, withResolverContext = _require5.withResolverContext;
var _require6 = require("c94b24a7feab2434"), generateTypeID = _require6.generateTypeID;
var invariant = require("8bf034bdcb6b97a6");
function read(recordSource, selector, resolverCache) {
    var reader = new RelayReader(recordSource, selector, resolverCache !== null && resolverCache !== void 0 ? resolverCache : new NoopResolverCache());
    return reader.read();
}
var RelayReader = /*#__PURE__*/ function() {
    function RelayReader(recordSource, selector, resolverCache) {
        var _selector$clientEdgeT;
        this._clientEdgeTraversalPath = (_selector$clientEdgeT = selector.clientEdgeTraversalPath) !== null && _selector$clientEdgeT !== void 0 && _selector$clientEdgeT.length ? (0, _toConsumableArray2["default"])(selector.clientEdgeTraversalPath) : [];
        this._missingClientEdges = [];
        this._missingLiveResolverFields = [];
        this._isMissingData = false;
        this._isWithinUnmatchedTypeRefinement = false;
        this._missingRequiredFields = null;
        this._errorResponseFields = null;
        this._owner = selector.owner;
        this._recordSource = recordSource;
        this._seenRecords = new Set();
        this._selector = selector;
        this._variables = selector.variables;
        this._resolverCache = resolverCache;
        this._resolverErrors = [];
        this._fragmentName = selector.node.name;
        this._updatedDataIDs = new Set();
    }
    var _proto = RelayReader.prototype;
    _proto.read = function read() {
        var _this$_selector = this._selector, node = _this$_selector.node, dataID = _this$_selector.dataID, isWithinUnmatchedTypeRefinement = _this$_selector.isWithinUnmatchedTypeRefinement;
        var abstractKey = node.abstractKey;
        var record = this._recordSource.get(dataID);
        var isDataExpectedToBePresent = !isWithinUnmatchedTypeRefinement;
        if (isDataExpectedToBePresent && abstractKey == null && record != null) {
            var recordType = RelayModernRecord.getType(record);
            if (recordType !== node.type && dataID !== ROOT_ID) isDataExpectedToBePresent = false;
        }
        if (isDataExpectedToBePresent && abstractKey != null && record != null) {
            var implementsInterface = this._implementsInterface(record, abstractKey);
            if (implementsInterface === false) isDataExpectedToBePresent = false;
            else if (implementsInterface == null) this._isMissingData = true;
        }
        this._isWithinUnmatchedTypeRefinement = !isDataExpectedToBePresent;
        var data = this._traverse(node, dataID, null);
        if (this._updatedDataIDs.size > 0) {
            this._resolverCache.notifyUpdatedSubscribers(this._updatedDataIDs);
            this._updatedDataIDs.clear();
        }
        return {
            data: data,
            isMissingData: this._isMissingData && isDataExpectedToBePresent,
            missingClientEdges: this._missingClientEdges.length ? this._missingClientEdges : null,
            missingLiveResolverFields: this._missingLiveResolverFields,
            seenRecords: this._seenRecords,
            selector: this._selector,
            missingRequiredFields: this._missingRequiredFields,
            relayResolverErrors: this._resolverErrors,
            errorResponseFields: this._errorResponseFields
        };
    };
    _proto._maybeAddErrorResponseFields = function _maybeAddErrorResponseFields(record, storageKey) {
        if (!RelayFeatureFlags.ENABLE_FIELD_ERROR_HANDLING) return;
        var errors = RelayModernRecord.getErrors(record, storageKey);
        if (errors == null) return;
        var owner = this._fragmentName;
        if (this._errorResponseFields == null) this._errorResponseFields = [];
        var _iterator = (0, _createForOfIteratorHelper2["default"])(errors), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _error$path;
                var error = _step.value;
                this._errorResponseFields.push({
                    owner: owner,
                    path: ((_error$path = error.path) !== null && _error$path !== void 0 ? _error$path : []).join('.'),
                    error: error
                });
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    };
    _proto._markDataAsMissing = function _markDataAsMissing() {
        this._isMissingData = true;
        if (this._clientEdgeTraversalPath.length) {
            var top = this._clientEdgeTraversalPath[this._clientEdgeTraversalPath.length - 1];
            if (top !== null) this._missingClientEdges.push({
                request: top.readerClientEdge.operation,
                clientEdgeDestinationID: top.clientEdgeDestinationID
            });
        }
    };
    _proto._traverse = function _traverse(node, dataID, prevData) {
        var record = this._recordSource.get(dataID);
        this._seenRecords.add(dataID);
        if (record == null) {
            if (record === undefined) this._markDataAsMissing();
            return record;
        }
        var data = prevData || {};
        var hadRequiredData = this._traverseSelections(node.selections, record, data);
        return hadRequiredData ? data : null;
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && invariant(false);
        return this._variables[name];
    };
    _proto._maybeReportUnexpectedNull = function _maybeReportUnexpectedNull(fieldPath, action) {
        var _this$_missingRequire;
        if (((_this$_missingRequire = this._missingRequiredFields) === null || _this$_missingRequire === void 0 ? void 0 : _this$_missingRequire.action) === 'THROW') return;
        var owner = this._fragmentName;
        switch(action){
            case 'THROW':
                this._missingRequiredFields = {
                    action: action,
                    field: {
                        path: fieldPath,
                        owner: owner
                    }
                };
                return;
            case 'LOG':
                if (this._missingRequiredFields == null) this._missingRequiredFields = {
                    action: action,
                    fields: [
                        {
                            path: fieldPath,
                            owner: owner
                        }
                    ]
                };
                else this._missingRequiredFields = {
                    action: action,
                    fields: [].concat((0, _toConsumableArray2["default"])(this._missingRequiredFields.fields), [
                        {
                            path: fieldPath,
                            owner: owner
                        }
                    ])
                };
                return;
            default:
                action;
        }
    };
    _proto._handleCatchFieldValue = function _handleCatchFieldValue(selection, record, data, value) {
        var _selection$field$back, _selection$field, _field$alias, _this$_missingRequire2;
        var to = selection.to;
        var field = (_selection$field$back = (_selection$field = selection.field) === null || _selection$field === void 0 ? void 0 : _selection$field.backingField) !== null && _selection$field$back !== void 0 ? _selection$field$back : selection.field;
        var fieldName = (_field$alias = field === null || field === void 0 ? void 0 : field.alias) !== null && _field$alias !== void 0 ? _field$alias : field === null || field === void 0 ? void 0 : field.name;
        !(fieldName != null) && invariant(false);
        if (this._errorResponseFields != null) for(var i = 0; i < this._errorResponseFields.length; i++)this._errorResponseFields[i].to = to;
        if (((_this$_missingRequire2 = this._missingRequiredFields) === null || _this$_missingRequire2 === void 0 ? void 0 : _this$_missingRequire2.action) === 'THROW') {
            var _this$_missingRequire3;
            if (((_this$_missingRequire3 = this._missingRequiredFields) === null || _this$_missingRequire3 === void 0 ? void 0 : _this$_missingRequire3.field) == null) return;
            if (this._errorResponseFields == null) this._errorResponseFields = [];
            var _this$_missingRequire4 = this._missingRequiredFields.field, owner = _this$_missingRequire4.owner, path = _this$_missingRequire4.path;
            this._errorResponseFields.push({
                owner: owner,
                path: path,
                error: {
                    message: "Relay: Missing @required value at path '".concat(path, "' in '").concat(owner, "'.")
                },
                to: to
            });
            this._missingRequiredFields = null;
            return;
        }
        if (this._errorResponseFields != null) {
            var errors = this._errorResponseFields.map(function(error) {
                return error.error;
            });
            data[fieldName] = {
                ok: false,
                errors: errors
            };
            return;
        }
        data[fieldName] = {
            ok: true,
            value: value
        };
    };
    _proto._handleRequiredFieldValue = function _handleRequiredFieldValue(selection, value) {
        if (value == null) {
            var action = selection.action;
            if (action !== 'NONE') this._maybeReportUnexpectedNull(selection.path, action);
            return false;
        }
        return true;
    };
    _proto._traverseSelections = function _traverseSelections(selections, record, data) {
        for(var i = 0; i < selections.length; i++){
            var selection = selections[i];
            switch(selection.kind){
                case REQUIRED_FIELD:
                    var requiredFieldValue = this._readClientSideDirectiveField(selection, record, data);
                    if (!this._handleRequiredFieldValue(selection, requiredFieldValue)) return false;
                    break;
                case CATCH_FIELD:
                    var catchFieldValue = this._readClientSideDirectiveField(selection, record, data);
                    if (RelayFeatureFlags.ENABLE_FIELD_ERROR_HANDLING_CATCH_DIRECTIVE) {
                        if (selection.to != 'NULL') this._handleCatchFieldValue(selection, record, data, catchFieldValue);
                    }
                    break;
                case SCALAR_FIELD:
                    this._readScalar(selection, record, data);
                    break;
                case LINKED_FIELD:
                    if (selection.plural) this._readPluralLink(selection, record, data);
                    else this._readLink(selection, record, data);
                    break;
                case CONDITION:
                    var conditionValue = Boolean(this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) {
                        var hasExpectedData = this._traverseSelections(selection.selections, record, data);
                        if (!hasExpectedData) return false;
                    }
                    break;
                case INLINE_FRAGMENT:
                    if (this._readInlineFragment(selection, record, data) === false) return false;
                    break;
                case RELAY_LIVE_RESOLVER:
                case RELAY_RESOLVER:
                    if (!RelayFeatureFlags.ENABLE_RELAY_RESOLVERS) throw new Error('Relay Resolver fields are not yet supported.');
                    this._readResolverField(selection, record, data);
                    break;
                case FRAGMENT_SPREAD:
                    this._createFragmentPointer(selection, record, data);
                    break;
                case ALIASED_FRAGMENT_SPREAD:
                    data[selection.name] = this._createAliasedFragmentSpread(selection, record);
                    break;
                case ALIASED_INLINE_FRAGMENT_SPREAD:
                    var fieldValue = this._readInlineFragment(selection.fragment, record, {});
                    if (fieldValue === false) fieldValue = null;
                    data[selection.name] = fieldValue;
                    break;
                case MODULE_IMPORT:
                    this._readModuleImport(selection, record, data);
                    break;
                case INLINE_DATA_FRAGMENT_SPREAD:
                    this._createInlineDataOrResolverFragmentPointer(selection, record, data);
                    break;
                case DEFER:
                case CLIENT_EXTENSION:
                    var isMissingData = this._isMissingData;
                    var alreadyMissingClientEdges = this._missingClientEdges.length;
                    this._clientEdgeTraversalPath.push(null);
                    var _hasExpectedData = this._traverseSelections(selection.selections, record, data);
                    this._isMissingData = isMissingData || this._missingClientEdges.length > alreadyMissingClientEdges || this._missingLiveResolverFields.length > 0;
                    this._clientEdgeTraversalPath.pop();
                    if (!_hasExpectedData) return false;
                    break;
                case STREAM:
                    var _hasExpectedData2 = this._traverseSelections(selection.selections, record, data);
                    if (!_hasExpectedData2) return false;
                    break;
                case ACTOR_CHANGE:
                    this._readActorChange(selection, record, data);
                    break;
                case CLIENT_EDGE_TO_CLIENT_OBJECT:
                case CLIENT_EDGE_TO_SERVER_OBJECT:
                    this._readClientEdge(selection, record, data);
                    break;
                default:
                    selection;
                    invariant(false);
            }
        }
        return true;
    };
    _proto._readClientSideDirectiveField = function _readClientSideDirectiveField(selection, record, data) {
        switch(selection.field.kind){
            case SCALAR_FIELD:
                return this._readScalar(selection.field, record, data);
            case LINKED_FIELD:
                if (selection.field.plural) return this._readPluralLink(selection.field, record, data);
                else return this._readLink(selection.field, record, data);
            case RELAY_RESOLVER:
                if (!RelayFeatureFlags.ENABLE_RELAY_RESOLVERS) throw new Error('Relay Resolver fields are not yet supported.');
                return this._readResolverField(selection.field, record, data);
            case RELAY_LIVE_RESOLVER:
                if (!RelayFeatureFlags.ENABLE_RELAY_RESOLVERS) throw new Error('Relay Resolver fields are not yet supported.');
                return this._readResolverField(selection.field, record, data);
            case CLIENT_EDGE_TO_CLIENT_OBJECT:
            case CLIENT_EDGE_TO_SERVER_OBJECT:
                if (!RelayFeatureFlags.ENABLE_RELAY_RESOLVERS) throw new Error('Relay Resolver fields are not yet supported.');
                return this._readClientEdge(selection.field, record, data);
            default:
                selection.field.kind;
                invariant(false);
        }
    };
    _proto._readResolverField = function _readResolverField(field, record, data) {
        var _field$alias2;
        var parentRecordID = RelayModernRecord.getDataID(record);
        var result = this._readResolverFieldImpl(field, parentRecordID);
        var fieldName = (_field$alias2 = field.alias) !== null && _field$alias2 !== void 0 ? _field$alias2 : field.name;
        data[fieldName] = result;
        return result;
    };
    _proto._readResolverFieldImpl = function _readResolverFieldImpl(field, parentRecordID) {
        var _this = this;
        var fragment = field.fragment;
        var snapshot;
        var getDataForResolverFragment = function getDataForResolverFragment(singularReaderSelector) {
            if (snapshot != null) return {
                data: snapshot.data,
                isMissingData: snapshot.isMissingData
            };
            snapshot = read(_this._recordSource, singularReaderSelector, _this._resolverCache);
            return {
                data: snapshot.data,
                isMissingData: snapshot.isMissingData
            };
        };
        var evaluate = function evaluate() {
            if (fragment != null) {
                var key = {
                    __id: parentRecordID,
                    __fragmentOwner: _this._owner,
                    __fragments: (0, _defineProperty2["default"])({}, fragment.name, fragment.args ? getArgumentValues(fragment.args, _this._variables) : {})
                };
                var resolverContext = {
                    getDataForResolverFragment: getDataForResolverFragment
                };
                return withResolverContext(resolverContext, function() {
                    var _getResolverValue = getResolverValue(field, _this._variables, key), resolverResult = _getResolverValue[0], resolverError = _getResolverValue[1];
                    return {
                        resolverResult: resolverResult,
                        snapshot: snapshot,
                        error: resolverError
                    };
                });
            } else {
                var _getResolverValue2 = getResolverValue(field, _this._variables, null), resolverResult = _getResolverValue2[0], _resolverError = _getResolverValue2[1];
                return {
                    resolverResult: resolverResult,
                    snapshot: undefined,
                    error: _resolverError
                };
            }
        };
        var _this$_resolverCache$ = this._resolverCache.readFromCacheOrEvaluate(parentRecordID, field, this._variables, evaluate, getDataForResolverFragment), result = _this$_resolverCache$[0], seenRecord = _this$_resolverCache$[1], resolverError = _this$_resolverCache$[2], cachedSnapshot = _this$_resolverCache$[3], suspenseID = _this$_resolverCache$[4], updatedDataIDs = _this$_resolverCache$[5];
        this._propogateResolverMetadata(field.path, cachedSnapshot, resolverError, seenRecord, suspenseID, updatedDataIDs);
        return result;
    };
    _proto._propogateResolverMetadata = function _propogateResolverMetadata(fieldPath, cachedSnapshot, resolverError, seenRecord, suspenseID, updatedDataIDs) {
        if (cachedSnapshot != null) {
            if (cachedSnapshot.missingRequiredFields != null) this._addMissingRequiredFields(cachedSnapshot.missingRequiredFields);
            if (cachedSnapshot.missingClientEdges != null) {
                var _iterator2 = (0, _createForOfIteratorHelper2["default"])(cachedSnapshot.missingClientEdges), _step2;
                try {
                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                        var missing = _step2.value;
                        this._missingClientEdges.push(missing);
                    }
                } catch (err) {
                    _iterator2.e(err);
                } finally{
                    _iterator2.f();
                }
            }
            if (cachedSnapshot.missingLiveResolverFields != null) {
                this._isMissingData = this._isMissingData || cachedSnapshot.missingLiveResolverFields.length > 0;
                var _iterator3 = (0, _createForOfIteratorHelper2["default"])(cachedSnapshot.missingLiveResolverFields), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var missingResolverField = _step3.value;
                        this._missingLiveResolverFields.push(missingResolverField);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
            }
            var _iterator4 = (0, _createForOfIteratorHelper2["default"])(cachedSnapshot.relayResolverErrors), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var error = _step4.value;
                    this._resolverErrors.push(error);
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
            this._isMissingData = this._isMissingData || cachedSnapshot.isMissingData;
        }
        if (resolverError) this._resolverErrors.push({
            field: {
                path: fieldPath,
                owner: this._fragmentName
            },
            error: resolverError
        });
        if (seenRecord != null) this._seenRecords.add(seenRecord);
        if (suspenseID != null) {
            this._isMissingData = true;
            this._missingLiveResolverFields.push({
                path: "".concat(this._fragmentName, ".").concat(fieldPath),
                liveStateID: suspenseID
            });
        }
        if (updatedDataIDs != null) {
            var _iterator5 = (0, _createForOfIteratorHelper2["default"])(updatedDataIDs), _step5;
            try {
                for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                    var recordID = _step5.value;
                    this._updatedDataIDs.add(recordID);
                }
            } catch (err) {
                _iterator5.e(err);
            } finally{
                _iterator5.f();
            }
        }
    };
    _proto._readClientEdge = function _readClientEdge(field, record, data) {
        var _this2 = this;
        var _backingField$alias;
        var backingField = field.backingField;
        !(backingField.kind !== 'ClientExtension') && invariant(false);
        var fieldName = (_backingField$alias = backingField.alias) !== null && _backingField$alias !== void 0 ? _backingField$alias : backingField.name;
        var backingFieldData = {};
        this._traverseSelections([
            backingField
        ], record, backingFieldData);
        var clientEdgeResolverResponse = backingFieldData[fieldName];
        if (clientEdgeResolverResponse == null || isSuspenseSentinel(clientEdgeResolverResponse)) {
            data[fieldName] = clientEdgeResolverResponse;
            return clientEdgeResolverResponse;
        }
        if (field.linkedField.plural) {
            !Array.isArray(clientEdgeResolverResponse) && invariant(false);
            var storeIDs;
            !(field.kind === CLIENT_EDGE_TO_CLIENT_OBJECT) && invariant(false);
            if (field.backingField.normalizationInfo == null) storeIDs = clientEdgeResolverResponse.map(function(itemResponse) {
                var _field$concreteType;
                var concreteType = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : itemResponse.__typename;
                !(typeof concreteType === 'string') && invariant(false);
                var localId = extractIdFromResponse(itemResponse);
                var id = _this2._resolverCache.ensureClientRecord(localId, concreteType);
                var modelResolvers = field.modelResolvers;
                if (modelResolvers != null) {
                    var modelResolver = modelResolvers[concreteType];
                    !(modelResolver !== undefined) && invariant(false);
                    var model = _this2._readResolverFieldImpl(modelResolver, id);
                    return model != null ? id : null;
                }
                return id;
            });
            else storeIDs = clientEdgeResolverResponse.map(extractIdFromResponse);
            this._clientEdgeTraversalPath.push(null);
            var edgeValues = this._readLinkedIds(field.linkedField, storeIDs, record, data);
            this._clientEdgeTraversalPath.pop();
            data[fieldName] = edgeValues;
            return edgeValues;
        } else {
            var _field$concreteType2;
            var id = extractIdFromResponse(clientEdgeResolverResponse);
            var storeID;
            var concreteType = (_field$concreteType2 = field.concreteType) !== null && _field$concreteType2 !== void 0 ? _field$concreteType2 : clientEdgeResolverResponse.__typename;
            var traversalPathSegment;
            if (field.kind === CLIENT_EDGE_TO_CLIENT_OBJECT) {
                if (field.backingField.normalizationInfo == null) {
                    !(typeof concreteType === 'string') && invariant(false);
                    storeID = this._resolverCache.ensureClientRecord(id, concreteType);
                    traversalPathSegment = null;
                } else {
                    storeID = id;
                    traversalPathSegment = null;
                }
            } else {
                storeID = id;
                traversalPathSegment = {
                    readerClientEdge: field,
                    clientEdgeDestinationID: id
                };
            }
            var modelResolvers = field.modelResolvers;
            if (modelResolvers != null) {
                !(typeof concreteType === 'string') && invariant(false);
                var modelResolver = modelResolvers[concreteType];
                !(modelResolver !== undefined) && invariant(false);
                var model = this._readResolverFieldImpl(modelResolver, storeID);
                if (model == null) {
                    data[fieldName] = null;
                    return null;
                }
            }
            this._clientEdgeTraversalPath.push(traversalPathSegment);
            var prevData = data[fieldName];
            !(prevData == null || (typeof prevData === "undefined" ? "undefined" : (0, _typeOf._)(prevData)) === 'object') && invariant(false);
            var edgeValue = this._traverse(field.linkedField, storeID, prevData);
            this._clientEdgeTraversalPath.pop();
            data[fieldName] = edgeValue;
            return edgeValue;
        }
    };
    _proto._readScalar = function _readScalar(field, record, data) {
        var _field$alias3;
        var fieldName = (_field$alias3 = field.alias) !== null && _field$alias3 !== void 0 ? _field$alias3 : field.name;
        var storageKey = getStorageKey(field, this._variables);
        var value = RelayModernRecord.getValue(record, storageKey);
        if (value === null) this._maybeAddErrorResponseFields(record, storageKey);
        else if (value === undefined) this._markDataAsMissing();
        data[fieldName] = value;
        return value;
    };
    _proto._readLink = function _readLink(field, record, data) {
        var _field$alias4;
        var fieldName = (_field$alias4 = field.alias) !== null && _field$alias4 !== void 0 ? _field$alias4 : field.name;
        var storageKey = getStorageKey(field, this._variables);
        var linkedID = RelayModernRecord.getLinkedRecordID(record, storageKey);
        if (linkedID == null) {
            data[fieldName] = linkedID;
            if (linkedID === null) this._maybeAddErrorResponseFields(record, storageKey);
            else if (linkedID === undefined) this._markDataAsMissing();
            return linkedID;
        }
        var prevData = data[fieldName];
        !(prevData == null || (typeof prevData === "undefined" ? "undefined" : (0, _typeOf._)(prevData)) === 'object') && invariant(false);
        var value = this._traverse(field, linkedID, prevData);
        data[fieldName] = value;
        return value;
    };
    _proto._readActorChange = function _readActorChange(field, record, data) {
        var _field$alias5;
        var fieldName = (_field$alias5 = field.alias) !== null && _field$alias5 !== void 0 ? _field$alias5 : field.name;
        var storageKey = getStorageKey(field, this._variables);
        var externalRef = RelayModernRecord.getActorLinkedRecordID(record, storageKey);
        if (externalRef == null) {
            data[fieldName] = externalRef;
            if (externalRef === undefined) this._markDataAsMissing();
            else if (externalRef === null) this._maybeAddErrorResponseFields(record, storageKey);
            return data[fieldName];
        }
        var actorIdentifier = externalRef[0], dataID = externalRef[1];
        var fragmentRef = {};
        this._createFragmentPointer(field.fragmentSpread, RelayModernRecord.fromObject({
            __id: dataID
        }), fragmentRef);
        data[fieldName] = {
            __fragmentRef: fragmentRef,
            __viewer: actorIdentifier
        };
        return data[fieldName];
    };
    _proto._readPluralLink = function _readPluralLink(field, record, data) {
        var storageKey = getStorageKey(field, this._variables);
        var linkedIDs = RelayModernRecord.getLinkedRecordIDs(record, storageKey);
        if (linkedIDs === null) this._maybeAddErrorResponseFields(record, storageKey);
        return this._readLinkedIds(field, linkedIDs, record, data);
    };
    _proto._readLinkedIds = function _readLinkedIds(field, linkedIDs, record, data) {
        var _this3 = this;
        var _field$alias6;
        var fieldName = (_field$alias6 = field.alias) !== null && _field$alias6 !== void 0 ? _field$alias6 : field.name;
        if (linkedIDs == null) {
            data[fieldName] = linkedIDs;
            if (linkedIDs === undefined) this._markDataAsMissing();
            return linkedIDs;
        }
        var prevData = data[fieldName];
        !(prevData == null || Array.isArray(prevData)) && invariant(false);
        var linkedArray = prevData || [];
        linkedIDs.forEach(function(linkedID, nextIndex) {
            if (linkedID == null) {
                if (linkedID === undefined) _this3._markDataAsMissing();
                linkedArray[nextIndex] = linkedID;
                return;
            }
            var prevItem = linkedArray[nextIndex];
            !(prevItem == null || (typeof prevItem === "undefined" ? "undefined" : (0, _typeOf._)(prevItem)) === 'object') && invariant(false);
            linkedArray[nextIndex] = _this3._traverse(field, linkedID, prevItem);
        });
        data[fieldName] = linkedArray;
        return linkedArray;
    };
    _proto._readModuleImport = function _readModuleImport(moduleImport, record, data) {
        var componentKey = getModuleComponentKey(moduleImport.documentName);
        var component = RelayModernRecord.getValue(record, componentKey);
        if (component == null) {
            if (component === undefined) this._markDataAsMissing();
            return;
        }
        this._createFragmentPointer({
            kind: 'FragmentSpread',
            name: moduleImport.fragmentName,
            args: moduleImport.args
        }, record, data);
        data[FRAGMENT_PROP_NAME_KEY] = moduleImport.fragmentPropName;
        data[MODULE_COMPONENT_KEY] = component;
    };
    _proto._createAliasedFragmentSpread = function _createAliasedFragmentSpread(namedFragmentSpread, record) {
        var abstractKey = namedFragmentSpread.abstractKey;
        if (abstractKey == null) {
            var typeName = RelayModernRecord.getType(record);
            if (typeName == null || typeName !== namedFragmentSpread.type) return null;
        } else {
            var implementsInterface = this._implementsInterface(record, abstractKey);
            if (implementsInterface === false) return null;
            else if (implementsInterface == null) {
                this._markDataAsMissing();
                return undefined;
            }
        }
        var fieldData = {};
        this._createFragmentPointer(namedFragmentSpread.fragment, record, fieldData);
        return RelayModernRecord.fromObject(fieldData);
    };
    _proto._readInlineFragment = function _readInlineFragment(inlineFragment, record, data) {
        if (inlineFragment.type == null) {
            var hasExpectedData = this._traverseSelections(inlineFragment.selections, record, data);
            if (hasExpectedData === false) return false;
            return data;
        }
        var abstractKey = inlineFragment.abstractKey;
        if (abstractKey == null) {
            var typeName = RelayModernRecord.getType(record);
            if (typeName == null || typeName !== inlineFragment.type) return null;
            else {
                var hasExpectedData = this._traverseSelections(inlineFragment.selections, record, data);
                if (!hasExpectedData) return false;
            }
        } else {
            var implementsInterface = this._implementsInterface(record, abstractKey);
            var parentIsMissingData = this._isMissingData;
            var parentIsWithinUnmatchedTypeRefinement = this._isWithinUnmatchedTypeRefinement;
            this._isWithinUnmatchedTypeRefinement = parentIsWithinUnmatchedTypeRefinement || implementsInterface === false;
            this._traverseSelections(inlineFragment.selections, record, data);
            this._isWithinUnmatchedTypeRefinement = parentIsWithinUnmatchedTypeRefinement;
            if (implementsInterface === false) {
                this._isMissingData = parentIsMissingData;
                return undefined;
            } else if (implementsInterface == null) {
                this._markDataAsMissing();
                return null;
            }
        }
        return data;
    };
    _proto._createFragmentPointer = function _createFragmentPointer(fragmentSpread, record, data) {
        var fragmentPointers = data[FRAGMENTS_KEY];
        if (fragmentPointers == null) fragmentPointers = data[FRAGMENTS_KEY] = {};
        !((typeof fragmentPointers === "undefined" ? "undefined" : (0, _typeOf._)(fragmentPointers)) === 'object' && fragmentPointers != null) && invariant(false);
        if (data[ID_KEY] == null) data[ID_KEY] = RelayModernRecord.getDataID(record);
        fragmentPointers[fragmentSpread.name] = getArgumentValues(fragmentSpread.args, this._variables, this._isWithinUnmatchedTypeRefinement);
        data[FRAGMENT_OWNER_KEY] = this._owner;
        if (this._clientEdgeTraversalPath.length > 0 && this._clientEdgeTraversalPath[this._clientEdgeTraversalPath.length - 1] !== null) data[CLIENT_EDGE_TRAVERSAL_PATH] = (0, _toConsumableArray2["default"])(this._clientEdgeTraversalPath);
    };
    _proto._createInlineDataOrResolverFragmentPointer = function _createInlineDataOrResolverFragmentPointer(fragmentSpreadOrFragment, record, data) {
        var fragmentPointers = data[FRAGMENTS_KEY];
        if (fragmentPointers == null) fragmentPointers = data[FRAGMENTS_KEY] = {};
        !((typeof fragmentPointers === "undefined" ? "undefined" : (0, _typeOf._)(fragmentPointers)) === 'object' && fragmentPointers != null) && invariant(false);
        if (data[ID_KEY] == null) data[ID_KEY] = RelayModernRecord.getDataID(record);
        var inlineData = {};
        var parentFragmentName = this._fragmentName;
        this._fragmentName = fragmentSpreadOrFragment.name;
        var parentVariables = this._variables;
        var argumentVariables = fragmentSpreadOrFragment.args ? getArgumentValues(fragmentSpreadOrFragment.args, this._variables) : {};
        this._variables = RelayConcreteVariables.getFragmentVariables(fragmentSpreadOrFragment, this._owner.variables, argumentVariables);
        this._traverseSelections(fragmentSpreadOrFragment.selections, record, inlineData);
        this._variables = parentVariables;
        this._fragmentName = parentFragmentName;
        fragmentPointers[fragmentSpreadOrFragment.name] = inlineData;
    };
    _proto._addMissingRequiredFields = function _addMissingRequiredFields(additional) {
        if (this._missingRequiredFields == null) {
            this._missingRequiredFields = additional;
            return;
        }
        if (this._missingRequiredFields.action === 'THROW') return;
        if (additional.action === 'THROW') {
            this._missingRequiredFields = additional;
            return;
        }
        this._missingRequiredFields = {
            action: 'LOG',
            fields: [].concat((0, _toConsumableArray2["default"])(this._missingRequiredFields.fields), (0, _toConsumableArray2["default"])(additional.fields))
        };
    };
    _proto._implementsInterface = function _implementsInterface(record, abstractKey) {
        var typeName = RelayModernRecord.getType(record);
        var typeRecord = this._recordSource.get(generateTypeID(typeName));
        var implementsInterface = typeRecord != null ? RelayModernRecord.getValue(typeRecord, abstractKey) : null;
        return implementsInterface;
    };
    return RelayReader;
}();
function getResolverValue(field, variables, fragmentKey) {
    var resolverFunction = typeof field.resolverModule === 'function' ? field.resolverModule : field.resolverModule["default"];
    var resolverResult = null;
    var resolverError = null;
    try {
        var resolverFunctionArgs = [];
        if (field.fragment != null) resolverFunctionArgs.push(fragmentKey);
        var args = field.args ? getArgumentValues(field.args, variables) : undefined;
        resolverFunctionArgs.push(args);
        resolverResult = resolverFunction.apply(null, resolverFunctionArgs);
    } catch (e) {
        if (e === RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL) resolverResult = undefined;
        else resolverError = e;
    }
    return [
        resolverResult,
        resolverError
    ];
}
function extractIdFromResponse(individualResponse) {
    if (typeof individualResponse === 'string') return individualResponse;
    else if ((typeof individualResponse === "undefined" ? "undefined" : (0, _typeOf._)(individualResponse)) === 'object' && individualResponse != null && typeof individualResponse.id === 'string') return individualResponse.id;
    invariant(false);
}
module.exports = {
    read: read
};

},{"@swc/helpers/_/_type_of":"iFJdx","a3c1fb2c07af9d8f":"590td","ecd5938fdccf58d0":"2paQ8","9637d3d0c215e422":"fMaLa","e1d5f18766f34ffd":"7EBX0","9e5c55714f84bbfd":"jKskk","e4590f7d0743b994":"a0FL5","134060d0435491fc":"kMvlq","6aa3e28b2397f0f2":"138Hd","1474639a77db088c":"daXOB","ceb4056395d53b78":"3QcrW","2ec0ed85284cf22":"4eoTv","91eb3a4f12b0db94":"1JmVd","c94b24a7feab2434":"32ztQ","8bf034bdcb6b97a6":"e2sci"}],"4eoTv":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("3615eaa97fbc6f6e")["default"];
var _createForOfIteratorHelper2 = _interopRequireDefault(require("e5450344db8cc1c9"));
var recycleNodesInto = require("eae8b96aa886847");
var _require = require("1f222ceafc09f16f"), RELAY_LIVE_RESOLVER = _require.RELAY_LIVE_RESOLVER;
var RelayFeatureFlags = require("6662f636499fa954");
var shallowFreeze = require("a3d0f64111568462");
var _require2 = require("b51052cfaf34b49f"), generateClientID = _require2.generateClientID;
var RelayModernRecord = require("35bebb0c4717da68");
var _require3 = require("c874d7fc0e5f1e2a"), RELAY_RESOLVER_ERROR_KEY = _require3.RELAY_RESOLVER_ERROR_KEY, RELAY_RESOLVER_INVALIDATION_KEY = _require3.RELAY_RESOLVER_INVALIDATION_KEY, RELAY_RESOLVER_SNAPSHOT_KEY = _require3.RELAY_RESOLVER_SNAPSHOT_KEY, RELAY_RESOLVER_VALUE_KEY = _require3.RELAY_RESOLVER_VALUE_KEY, getStorageKey = _require3.getStorageKey;
var invariant = require("f57ad9485ce87f04");
var warning = require("e49aea05e3196b46");
var emptySet = new Set();
var NoopResolverCache = /*#__PURE__*/ function() {
    function NoopResolverCache() {}
    var _proto = NoopResolverCache.prototype;
    _proto.readFromCacheOrEvaluate = function readFromCacheOrEvaluate(recordID, field, variables, evaluate, getDataForResolverFragment) {
        !(field.kind !== RELAY_LIVE_RESOLVER) && invariant(false);
        var _evaluate = evaluate(), resolverResult = _evaluate.resolverResult, snapshot = _evaluate.snapshot, error = _evaluate.error;
        return [
            resolverResult,
            undefined,
            error,
            snapshot,
            undefined,
            undefined
        ];
    };
    _proto.invalidateDataIDs = function invalidateDataIDs(updatedDataIDs) {};
    _proto.ensureClientRecord = function ensureClientRecord(id, typeName) {
        invariant(false);
    };
    _proto.notifyUpdatedSubscribers = function notifyUpdatedSubscribers(updatedDataIDs) {};
    return NoopResolverCache;
}();
function addDependencyEdge(edges, from, to) {
    var set = edges.get(from);
    if (!set) {
        set = new Set();
        edges.set(from, set);
    }
    set.add(to);
}
var RecordResolverCache = /*#__PURE__*/ function() {
    function RecordResolverCache(getRecordSource) {
        this._resolverIDToRecordIDs = new Map();
        this._recordIDToResolverIDs = new Map();
        this._getRecordSource = getRecordSource;
    }
    var _proto2 = RecordResolverCache.prototype;
    _proto2.readFromCacheOrEvaluate = function readFromCacheOrEvaluate(recordID, field, variables, evaluate, getDataForResolverFragment) {
        var recordSource = this._getRecordSource();
        var record = recordSource.get(recordID);
        !(record != null) && invariant(false);
        var storageKey = getStorageKey(field, variables);
        var linkedID = RelayModernRecord.getLinkedRecordID(record, storageKey);
        var linkedRecord = linkedID == null ? null : recordSource.get(linkedID);
        if (linkedRecord == null || this._isInvalid(linkedRecord, getDataForResolverFragment)) {
            var _linkedID;
            linkedID = (_linkedID = linkedID) !== null && _linkedID !== void 0 ? _linkedID : generateClientID(recordID, storageKey);
            linkedRecord = RelayModernRecord.create(linkedID, '__RELAY_RESOLVER__');
            var evaluationResult = evaluate();
            shallowFreeze(evaluationResult.resolverResult);
            RelayModernRecord.setValue(linkedRecord, RELAY_RESOLVER_VALUE_KEY, evaluationResult.resolverResult);
            RelayModernRecord.setValue(linkedRecord, RELAY_RESOLVER_SNAPSHOT_KEY, evaluationResult.snapshot);
            RelayModernRecord.setValue(linkedRecord, RELAY_RESOLVER_ERROR_KEY, evaluationResult.error);
            recordSource.set(linkedID, linkedRecord);
            var currentRecord = recordSource.get(recordID);
            !(currentRecord != null) && invariant(false);
            var nextRecord = RelayModernRecord.clone(currentRecord);
            RelayModernRecord.setLinkedRecordID(nextRecord, storageKey, linkedID);
            recordSource.set(recordID, nextRecord);
            if (field.fragment != null) {
                var _evaluationResult$sna;
                var fragmentStorageKey = getStorageKey(field.fragment, variables);
                var resolverID = generateClientID(recordID, fragmentStorageKey);
                addDependencyEdge(this._resolverIDToRecordIDs, resolverID, linkedID);
                addDependencyEdge(this._recordIDToResolverIDs, recordID, resolverID);
                var seenRecordIds = (_evaluationResult$sna = evaluationResult.snapshot) === null || _evaluationResult$sna === void 0 ? void 0 : _evaluationResult$sna.seenRecords;
                if (seenRecordIds != null) {
                    var _iterator = (0, _createForOfIteratorHelper2["default"])(seenRecordIds), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var seenRecordID = _step.value;
                            addDependencyEdge(this._recordIDToResolverIDs, seenRecordID, resolverID);
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
            }
        }
        var answer = RelayModernRecord.getValue(linkedRecord, RELAY_RESOLVER_VALUE_KEY);
        var snapshot = RelayModernRecord.getValue(linkedRecord, RELAY_RESOLVER_SNAPSHOT_KEY);
        var error = RelayModernRecord.getValue(linkedRecord, RELAY_RESOLVER_ERROR_KEY);
        return [
            answer,
            linkedID,
            error,
            snapshot,
            undefined,
            undefined
        ];
    };
    _proto2.invalidateDataIDs = function invalidateDataIDs(updatedDataIDs) {
        var recordSource = this._getRecordSource();
        var visited = new Set();
        var recordsToVisit = Array.from(updatedDataIDs);
        while(recordsToVisit.length){
            var recordID = recordsToVisit.pop();
            updatedDataIDs.add(recordID);
            var _iterator2 = (0, _createForOfIteratorHelper2["default"])((_this$_recordIDToReso = this._recordIDToResolverIDs.get(recordID)) !== null && _this$_recordIDToReso !== void 0 ? _this$_recordIDToReso : emptySet), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var _this$_recordIDToReso;
                    var fragment = _step2.value;
                    if (!visited.has(fragment)) {
                        var _iterator3 = (0, _createForOfIteratorHelper2["default"])((_this$_resolverIDToRe = this._resolverIDToRecordIDs.get(fragment)) !== null && _this$_resolverIDToRe !== void 0 ? _this$_resolverIDToRe : emptySet), _step3;
                        try {
                            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                                var _this$_resolverIDToRe;
                                var anotherRecordID = _step3.value;
                                this._markInvalidatedResolverRecord(anotherRecordID, recordSource, updatedDataIDs);
                                if (!visited.has(anotherRecordID)) recordsToVisit.push(anotherRecordID);
                            }
                        } catch (err) {
                            _iterator3.e(err);
                        } finally{
                            _iterator3.f();
                        }
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        }
    };
    _proto2._markInvalidatedResolverRecord = function _markInvalidatedResolverRecord(dataID, recordSource, updatedDataIDs) {
        var record = recordSource.get(dataID);
        if (!record) return;
        var nextRecord = RelayModernRecord.clone(record);
        RelayModernRecord.setValue(nextRecord, RELAY_RESOLVER_INVALIDATION_KEY, true);
        recordSource.set(dataID, nextRecord);
    };
    _proto2._isInvalid = function _isInvalid(record, getDataForResolverFragment) {
        if (!RelayModernRecord.getValue(record, RELAY_RESOLVER_INVALIDATION_KEY)) return false;
        var snapshot = RelayModernRecord.getValue(record, RELAY_RESOLVER_SNAPSHOT_KEY);
        var originalInputs = snapshot === null || snapshot === void 0 ? void 0 : snapshot.data;
        var readerSelector = snapshot === null || snapshot === void 0 ? void 0 : snapshot.selector;
        if (originalInputs == null || readerSelector == null) return true;
        var _getDataForResolverFr = getDataForResolverFragment(readerSelector), latestValues = _getDataForResolverFr.data;
        var recycled = recycleNodesInto(originalInputs, latestValues);
        if (recycled !== originalInputs) return true;
        if (RelayFeatureFlags.MARK_RESOLVER_VALUES_AS_CLEAN_AFTER_FRAGMENT_REREAD) {
            var nextRecord = RelayModernRecord.clone(record);
            RelayModernRecord.setValue(nextRecord, RELAY_RESOLVER_INVALIDATION_KEY, false);
            var recordSource = this._getRecordSource();
            recordSource.set(RelayModernRecord.getDataID(record), nextRecord);
        }
        return false;
    };
    _proto2.ensureClientRecord = function ensureClientRecord(id, typename) {
        invariant(false);
    };
    _proto2.notifyUpdatedSubscribers = function notifyUpdatedSubscribers(updatedDataIDs) {
        invariant(false);
    };
    return RecordResolverCache;
}();
module.exports = {
    NoopResolverCache: NoopResolverCache,
    RecordResolverCache: RecordResolverCache
};

},{"3615eaa97fbc6f6e":"590td","e5450344db8cc1c9":"fMaLa","eae8b96aa886847":"ij1IQ","1f222ceafc09f16f":"jKskk","6662f636499fa954":"a0FL5","a3d0f64111568462":"dB2kC","b51052cfaf34b49f":"gL1rB","35bebb0c4717da68":"daXOB","c874d7fc0e5f1e2a":"3QcrW","f57ad9485ce87f04":"e2sci","e49aea05e3196b46":"j64TH"}],"dB2kC":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
module.exports = function shallowFreeze(value) {
    if ((typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) === 'object' && value != null && (Array.isArray(value) || value.constructor === Object)) Object.freeze(value);
};

},{"@swc/helpers/_/_type_of":"iFJdx"}],"1JmVd":[function(require,module,exports,__globalThis) {
'use strict';
var _require = require("600f6b79f68bca6f"), getFragment = _require.getFragment;
var _require2 = require("ed6a063285578c76"), getSelector = _require2.getSelector;
var invariant = require("5065659723cd98f9");
var contextStack = [];
function withResolverContext(context, cb) {
    contextStack.push(context);
    try {
        return cb();
    } finally{
        contextStack.pop();
    }
}
function readFragment(fragmentInput, fragmentKey) {
    if (!contextStack.length) throw new Error('readFragment should be called only from within a Relay Resolver function.');
    var context = contextStack[contextStack.length - 1];
    var fragmentNode = getFragment(fragmentInput);
    var fragmentSelector = getSelector(fragmentNode, fragmentKey);
    !(fragmentSelector != null) && invariant(false);
    !(fragmentSelector.kind === 'SingularReaderSelector') && invariant(false);
    var _context$getDataForRe = context.getDataForResolverFragment(fragmentSelector, fragmentKey), data = _context$getDataForRe.data, isMissingData = _context$getDataForRe.isMissingData;
    if (isMissingData) throw RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL;
    return data;
}
var RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL = {};
module.exports = {
    readFragment: readFragment,
    withResolverContext: withResolverContext,
    RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL: RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL
};

},{"600f6b79f68bca6f":"8UTII","ed6a063285578c76":"9k2Dg","5065659723cd98f9":"e2sci"}],"UtVKb":[function(require,module,exports,__globalThis) {
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
'use strict';
var _interopRequireDefault = require("f64bad905160f4d3")["default"];
var _createForOfIteratorHelper2 = _interopRequireDefault(require("190ddba815fb3f62"));
var _defineProperty2 = _interopRequireDefault(require("4e19f290ff1978d3"));
var _require = require("f54af5ebfb4311fb"), INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = _require.INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, assertInternalActorIdentifier = _require.assertInternalActorIdentifier;
var deepFreeze = require("18bb9ecbee002a2f");
var RelayFeatureFlags = require("3857e5fc208272f8");
var resolveImmediate = require("78c56959720021c2");
var DataChecker = require("b18862e0e0a93819");
var defaultGetDataID = require("a6ca7ceb1bb7cf83");
var RelayModernRecord = require("7b35a99c396ef879");
var RelayOptimisticRecordSource = require("55c75281919d2ce0");
var RelayReader = require("6230dc04d7f3579e");
var RelayReferenceMarker = require("9a40e7b3af11c655");
var RelayStoreSubscriptions = require("9f472790b702f603");
var RelayStoreUtils = require("6d0b52660284d11");
var _require2 = require("6d0b52660284d11"), ROOT_ID = _require2.ROOT_ID, ROOT_TYPE = _require2.ROOT_TYPE;
var _require3 = require("d8f6f2cd9550d226"), RecordResolverCache = _require3.RecordResolverCache;
var invariant = require("769ab6f0a6ad31c1");
var DEFAULT_RELEASE_BUFFER_SIZE = 10;
var RelayModernStore = /*#__PURE__*/ function() {
    function RelayModernStore(source, options) {
        var _this = this;
        var _options$gcReleaseBuf, _options$gcScheduler, _options$getDataID, _options$log, _options$operationLoa;
        (0, _defineProperty2["default"])(this, "_gcStep", function() {
            if (_this._gcRun) {
                if (_this._gcRun.next().done) _this._gcRun = null;
                else _this._gcScheduler(_this._gcStep);
            }
        });
        var storeIDs, ii, record;
        this._currentWriteEpoch = 0;
        this._gcHoldCounter = 0;
        this._gcReleaseBufferSize = (_options$gcReleaseBuf = options === null || options === void 0 ? void 0 : options.gcReleaseBufferSize) !== null && _options$gcReleaseBuf !== void 0 ? _options$gcReleaseBuf : DEFAULT_RELEASE_BUFFER_SIZE;
        this._gcRun = null;
        this._gcScheduler = (_options$gcScheduler = options === null || options === void 0 ? void 0 : options.gcScheduler) !== null && _options$gcScheduler !== void 0 ? _options$gcScheduler : resolveImmediate;
        this._getDataID = (_options$getDataID = options === null || options === void 0 ? void 0 : options.getDataID) !== null && _options$getDataID !== void 0 ? _options$getDataID : defaultGetDataID;
        this._globalInvalidationEpoch = null;
        this._invalidationSubscriptions = new Set();
        this._invalidatedRecordIDs = new Set();
        this.__log = (_options$log = options === null || options === void 0 ? void 0 : options.log) !== null && _options$log !== void 0 ? _options$log : null;
        this._queryCacheExpirationTime = options === null || options === void 0 ? void 0 : options.queryCacheExpirationTime;
        this._operationLoader = (_options$operationLoa = options === null || options === void 0 ? void 0 : options.operationLoader) !== null && _options$operationLoa !== void 0 ? _options$operationLoa : null;
        this._optimisticSource = null;
        this._recordSource = source;
        this._releaseBuffer = [];
        this._roots = new Map();
        this._shouldScheduleGC = false;
        this._resolverCache = new RecordResolverCache(function() {
            return _this._getMutableRecordSource();
        });
        this._storeSubscriptions = new RelayStoreSubscriptions(options === null || options === void 0 ? void 0 : options.log, this._resolverCache);
        this._updatedRecordIDs = new Set();
        this._shouldProcessClientComponents = options === null || options === void 0 ? void 0 : options.shouldProcessClientComponents;
        initializeRecordSource(this._recordSource);
    }
    var _proto = RelayModernStore.prototype;
    _proto.getSource = function getSource() {
        var _this$_optimisticSour;
        return (_this$_optimisticSour = this._optimisticSource) !== null && _this$_optimisticSour !== void 0 ? _this$_optimisticSour : this._recordSource;
    };
    _proto._getMutableRecordSource = function _getMutableRecordSource() {
        var _this$_optimisticSour2;
        return (_this$_optimisticSour2 = this._optimisticSource) !== null && _this$_optimisticSour2 !== void 0 ? _this$_optimisticSour2 : this._recordSource;
    };
    _proto.check = function check(operation, options) {
        var _options$handlers, _options$getSourceFor, _options$getTargetFor, _options$defaultActor;
        var selector = operation.root;
        var source = this._getMutableRecordSource();
        var globalInvalidationEpoch = this._globalInvalidationEpoch;
        var rootEntry = this._roots.get(operation.request.identifier);
        var operationLastWrittenAt = rootEntry != null ? rootEntry.epoch : null;
        if (globalInvalidationEpoch != null) {
            if (operationLastWrittenAt == null || operationLastWrittenAt <= globalInvalidationEpoch) return {
                status: 'stale'
            };
        }
        var handlers = (_options$handlers = options === null || options === void 0 ? void 0 : options.handlers) !== null && _options$handlers !== void 0 ? _options$handlers : [];
        var getSourceForActor = (_options$getSourceFor = options === null || options === void 0 ? void 0 : options.getSourceForActor) !== null && _options$getSourceFor !== void 0 ? _options$getSourceFor : function getSourceForActor(actorIdentifier) {
            assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var getTargetForActor = (_options$getTargetFor = options === null || options === void 0 ? void 0 : options.getTargetForActor) !== null && _options$getTargetFor !== void 0 ? _options$getTargetFor : function getTargetForActor(actorIdentifier) {
            assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var operationAvailability = DataChecker.check(getSourceForActor, getTargetForActor, (_options$defaultActor = options === null || options === void 0 ? void 0 : options.defaultActorIdentifier) !== null && _options$defaultActor !== void 0 ? _options$defaultActor : INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, selector, handlers, this._operationLoader, this._getDataID, this._shouldProcessClientComponents);
        return getAvailabilityStatus(operationAvailability, operationLastWrittenAt, rootEntry === null || rootEntry === void 0 ? void 0 : rootEntry.fetchTime, this._queryCacheExpirationTime);
    };
    _proto.retain = function retain(operation) {
        var _this2 = this;
        var id = operation.request.identifier;
        var disposed = false;
        var dispose = function dispose() {
            if (disposed) return;
            disposed = true;
            var rootEntry = _this2._roots.get(id);
            if (rootEntry == null) return;
            rootEntry.refCount--;
            if (rootEntry.refCount === 0) {
                var _queryCacheExpirationTime = _this2._queryCacheExpirationTime;
                var rootEntryIsStale = rootEntry.fetchTime != null && _queryCacheExpirationTime != null && rootEntry.fetchTime <= Date.now() - _queryCacheExpirationTime;
                if (rootEntryIsStale) {
                    _this2._roots["delete"](id);
                    _this2.scheduleGC();
                } else {
                    _this2._releaseBuffer.push(id);
                    if (_this2._releaseBuffer.length > _this2._gcReleaseBufferSize) {
                        var _id = _this2._releaseBuffer.shift();
                        _this2._roots["delete"](_id);
                        _this2.scheduleGC();
                    }
                }
            }
        };
        var rootEntry = this._roots.get(id);
        if (rootEntry != null) {
            if (rootEntry.refCount === 0) this._releaseBuffer = this._releaseBuffer.filter(function(_id) {
                return _id !== id;
            });
            rootEntry.refCount += 1;
        } else this._roots.set(id, {
            operation: operation,
            refCount: 1,
            epoch: null,
            fetchTime: null
        });
        return {
            dispose: dispose
        };
    };
    _proto.lookup = function lookup(selector) {
        var source = this.getSource();
        var snapshot = RelayReader.read(source, selector, this._resolverCache);
        return snapshot;
    };
    _proto.notify = function notify(sourceOperation, invalidateStore) {
        var _this3 = this;
        var log = this.__log;
        if (log != null) log({
            name: 'store.notify.start',
            sourceOperation: sourceOperation
        });
        this._currentWriteEpoch++;
        if (invalidateStore === true) this._globalInvalidationEpoch = this._currentWriteEpoch;
        if (RelayFeatureFlags.ENABLE_RELAY_RESOLVERS) this._resolverCache.invalidateDataIDs(this._updatedRecordIDs);
        var source = this.getSource();
        var updatedOwners = [];
        this._storeSubscriptions.updateSubscriptions(source, this._updatedRecordIDs, updatedOwners, sourceOperation);
        this._invalidationSubscriptions.forEach(function(subscription) {
            _this3._updateInvalidationSubscription(subscription, invalidateStore === true);
        });
        if (log != null) log({
            name: 'store.notify.complete',
            sourceOperation: sourceOperation,
            updatedRecordIDs: this._updatedRecordIDs,
            invalidatedRecordIDs: this._invalidatedRecordIDs
        });
        this._updatedRecordIDs.clear();
        this._invalidatedRecordIDs.clear();
        if (sourceOperation != null) {
            var id = sourceOperation.request.identifier;
            var rootEntry = this._roots.get(id);
            if (rootEntry != null) {
                rootEntry.epoch = this._currentWriteEpoch;
                rootEntry.fetchTime = Date.now();
            } else if (sourceOperation.request.node.params.operationKind === 'query' && this._gcReleaseBufferSize > 0 && this._releaseBuffer.length < this._gcReleaseBufferSize) {
                var temporaryRootEntry = {
                    operation: sourceOperation,
                    refCount: 0,
                    epoch: this._currentWriteEpoch,
                    fetchTime: Date.now()
                };
                this._releaseBuffer.push(id);
                this._roots.set(id, temporaryRootEntry);
            }
        }
        return updatedOwners;
    };
    _proto.publish = function publish(source, idsMarkedForInvalidation) {
        var target = this._getMutableRecordSource();
        updateTargetFromSource(target, source, this._currentWriteEpoch + 1, idsMarkedForInvalidation, this._updatedRecordIDs, this._invalidatedRecordIDs);
        var log = this.__log;
        if (log != null) log({
            name: 'store.publish',
            source: source,
            optimistic: target === this._optimisticSource
        });
    };
    _proto.subscribe = function subscribe(snapshot, callback) {
        return this._storeSubscriptions.subscribe(snapshot, callback);
    };
    _proto.holdGC = function holdGC() {
        var _this4 = this;
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._gcHoldCounter++;
        var dispose = function dispose() {
            if (_this4._gcHoldCounter > 0) {
                _this4._gcHoldCounter--;
                if (_this4._gcHoldCounter === 0 && _this4._shouldScheduleGC) {
                    _this4.scheduleGC();
                    _this4._shouldScheduleGC = false;
                }
            }
        };
        return {
            dispose: dispose
        };
    };
    _proto.toJSON = function toJSON() {
        return 'RelayModernStore()';
    };
    _proto.getEpoch = function getEpoch() {
        return this._currentWriteEpoch;
    };
    _proto.__getUpdatedRecordIDs = function __getUpdatedRecordIDs() {
        return this._updatedRecordIDs;
    };
    _proto.lookupInvalidationState = function lookupInvalidationState(dataIDs) {
        var _this5 = this;
        var invalidations = new Map();
        dataIDs.forEach(function(dataID) {
            var _RelayModernRecord$ge;
            var record = _this5.getSource().get(dataID);
            invalidations.set(dataID, (_RelayModernRecord$ge = RelayModernRecord.getInvalidationEpoch(record)) !== null && _RelayModernRecord$ge !== void 0 ? _RelayModernRecord$ge : null);
        });
        invalidations.set('global', this._globalInvalidationEpoch);
        return {
            dataIDs: dataIDs,
            invalidations: invalidations
        };
    };
    _proto.checkInvalidationState = function checkInvalidationState(prevInvalidationState) {
        var latestInvalidationState = this.lookupInvalidationState(prevInvalidationState.dataIDs);
        var currentInvalidations = latestInvalidationState.invalidations;
        var prevInvalidations = prevInvalidationState.invalidations;
        if (currentInvalidations.get('global') !== prevInvalidations.get('global')) return true;
        var _iterator = (0, _createForOfIteratorHelper2["default"])(prevInvalidationState.dataIDs), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var dataID = _step.value;
                if (currentInvalidations.get(dataID) !== prevInvalidations.get(dataID)) return true;
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return false;
    };
    _proto.subscribeToInvalidationState = function subscribeToInvalidationState(invalidationState, callback) {
        var _this6 = this;
        var subscription = {
            callback: callback,
            invalidationState: invalidationState
        };
        var dispose = function dispose() {
            _this6._invalidationSubscriptions["delete"](subscription);
        };
        this._invalidationSubscriptions.add(subscription);
        return {
            dispose: dispose
        };
    };
    _proto._updateInvalidationSubscription = function _updateInvalidationSubscription(subscription, invalidatedStore) {
        var _this7 = this;
        var callback = subscription.callback, invalidationState = subscription.invalidationState;
        var dataIDs = invalidationState.dataIDs;
        var isSubscribedToInvalidatedIDs = invalidatedStore || dataIDs.some(function(dataID) {
            return _this7._invalidatedRecordIDs.has(dataID);
        });
        if (!isSubscribedToInvalidatedIDs) return;
        callback();
    };
    _proto.snapshot = function snapshot() {
        !(this._optimisticSource == null) && invariant(false);
        var log = this.__log;
        if (log != null) log({
            name: 'store.snapshot'
        });
        this._storeSubscriptions.snapshotSubscriptions(this.getSource());
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._optimisticSource = RelayOptimisticRecordSource.create(this.getSource());
    };
    _proto.restore = function restore() {
        !(this._optimisticSource != null) && invariant(false);
        var log = this.__log;
        if (log != null) log({
            name: 'store.restore'
        });
        this._optimisticSource = null;
        if (this._shouldScheduleGC) this.scheduleGC();
        this._storeSubscriptions.restoreSubscriptions();
    };
    _proto.scheduleGC = function scheduleGC() {
        if (this._gcHoldCounter > 0) {
            this._shouldScheduleGC = true;
            return;
        }
        if (this._gcRun) return;
        this._gcRun = this._collect();
        this._gcScheduler(this._gcStep);
    };
    _proto.__gc = function __gc() {
        if (this._optimisticSource != null) return;
        var gcRun = this._collect();
        while(!gcRun.next().done);
    };
    _proto._collect = function _collect() {
        var startEpoch, references, _iterator2, _step2, operation, selector, err, log, storeIDs, ii, dataID;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!true) return [
                        3,
                        9
                    ];
                    startEpoch = this._currentWriteEpoch;
                    references = new Set();
                    _iterator2 = (0, _createForOfIteratorHelper2["default"])(this._roots.values());
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        8
                    ]);
                    _iterator2.s();
                    _state.label = 2;
                case 2:
                    if (!!(_step2 = _iterator2.n()).done) return [
                        3,
                        5
                    ];
                    operation = _step2.value.operation;
                    selector = operation.root;
                    RelayReferenceMarker.mark(this._recordSource, selector, references, this._operationLoader, this._shouldProcessClientComponents);
                    return [
                        4
                    ];
                case 3:
                    _state.sent();
                    if (startEpoch !== this._currentWriteEpoch) return [
                        3,
                        0
                    ];
                    _state.label = 4;
                case 4:
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        8
                    ];
                case 6:
                    err = _state.sent();
                    _iterator2.e(err);
                    return [
                        3,
                        8
                    ];
                case 7:
                    _iterator2.f();
                    return [
                        7
                    ];
                case 8:
                    log = this.__log;
                    if (log != null) log({
                        name: 'store.gc',
                        references: references
                    });
                    if (references.size === 0) this._recordSource.clear();
                    else {
                        storeIDs = this._recordSource.getRecordIDs();
                        for(ii = 0; ii < storeIDs.length; ii++){
                            dataID = storeIDs[ii];
                            if (!references.has(dataID)) this._recordSource.remove(dataID);
                        }
                    }
                    return [
                        2
                    ];
                case 9:
                    return [
                        2
                    ];
            }
        });
    };
    return RelayModernStore;
}();
function initializeRecordSource(target) {
    if (!target.has(ROOT_ID)) {
        var rootRecord = RelayModernRecord.create(ROOT_ID, ROOT_TYPE);
        target.set(ROOT_ID, rootRecord);
    }
}
function updateTargetFromSource(target, source, currentWriteEpoch, idsMarkedForInvalidation, updatedRecordIDs, invalidatedRecordIDs) {
    if (idsMarkedForInvalidation) idsMarkedForInvalidation.forEach(function(dataID) {
        var targetRecord = target.get(dataID);
        var sourceRecord = source.get(dataID);
        if (sourceRecord === null) return;
        var nextRecord;
        if (targetRecord != null) nextRecord = RelayModernRecord.clone(targetRecord);
        else nextRecord = sourceRecord != null ? RelayModernRecord.clone(sourceRecord) : null;
        if (!nextRecord) return;
        RelayModernRecord.setValue(nextRecord, RelayStoreUtils.INVALIDATED_AT_KEY, currentWriteEpoch);
        invalidatedRecordIDs.add(dataID);
        target.set(dataID, nextRecord);
    });
    var dataIDs = source.getRecordIDs();
    for(var ii = 0; ii < dataIDs.length; ii++){
        var dataID = dataIDs[ii];
        var sourceRecord = source.get(dataID);
        var targetRecord = target.get(dataID);
        if (sourceRecord && targetRecord) {
            var nextRecord = RelayModernRecord.update(targetRecord, sourceRecord);
            if (nextRecord !== targetRecord) {
                updatedRecordIDs.add(dataID);
                target.set(dataID, nextRecord);
            }
        } else if (sourceRecord === null) {
            target["delete"](dataID);
            if (targetRecord !== null) updatedRecordIDs.add(dataID);
        } else if (sourceRecord) {
            target.set(dataID, sourceRecord);
            updatedRecordIDs.add(dataID);
        }
    }
}
function getAvailabilityStatus(operationAvailability, operationLastWrittenAt, operationFetchTime, queryCacheExpirationTime) {
    var mostRecentlyInvalidatedAt = operationAvailability.mostRecentlyInvalidatedAt, status = operationAvailability.status;
    if (typeof mostRecentlyInvalidatedAt === 'number') {
        if (operationLastWrittenAt == null || mostRecentlyInvalidatedAt > operationLastWrittenAt) return {
            status: 'stale'
        };
    }
    if (status === 'missing') return {
        status: 'missing'
    };
    if (operationFetchTime != null && queryCacheExpirationTime != null) {
        var isStale = operationFetchTime <= Date.now() - queryCacheExpirationTime;
        if (isStale) return {
            status: 'stale'
        };
    }
    return {
        status: 'available',
        fetchTime: operationFetchTime !== null && operationFetchTime !== void 0 ? operationFetchTime : null
    };
}
module.exports = RelayModernStore;

},{"@swc/helpers/_/_ts_generator":"78Tqx","f64bad905160f4d3":"590td","190ddba815fb3f62":"fMaLa","4e19f290ff1978d3":"2paQ8","f54af5ebfb4311fb":"cFrVW","18bb9ecbee002a2f":"eLea7","3857e5fc208272f8":"a0FL5","78c56959720021c2":"b0sng","b18862e0e0a93819":"hp2zf","a6ca7ceb1bb7cf83":"febBR","7b35a99c396ef879":"daXOB","55c75281919d2ce0":"4BdDg","6230dc04d7f3579e":"hTh0M","9a40e7b3af11c655":"7FTk2","9f472790b702f603":"idAWU","6d0b52660284d11":"3QcrW","d8f6f2cd9550d226":"4eoTv","769ab6f0a6ad31c1":"e2sci"}],"b0sng":[function(require,module,exports,__globalThis) {
'use strict';
var resolvedPromise = Promise.resolve();
function resolveImmediate(callback) {
    resolvedPromise.then(callback)["catch"](throwNext);
}
function throwNext(error) {
    setTimeout(function() {
        throw error;
    }, 0);
}
module.exports = resolveImmediate;

},{}],"hp2zf":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("cacb16c80358f382")["default"];
var _createForOfIteratorHelper2 = _interopRequireDefault(require("c9437aaebe2e50fb"));
var RelayRecordSourceMutator = require("67275ac85415bb64");
var RelayRecordSourceProxy = require("9bc9307a48a617b6");
var getOperation = require("42765387566e697a");
var RelayConcreteNode = require("27b1ee4d87c425ba");
var _require = require("1734def79cf4224f"), isClientID = _require.isClientID;
var cloneRelayHandleSourceField = require("99184f9281e13032");
var cloneRelayScalarHandleSourceField = require("267fdc08bd0843b8");
var _require2 = require("79f7dc7c88f08046"), getLocalVariables = _require2.getLocalVariables;
var RelayModernRecord = require("4cad14c75485f3d5");
var _require3 = require("9fc303a9caffd777"), EXISTENT = _require3.EXISTENT, UNKNOWN = _require3.UNKNOWN;
var RelayStoreUtils = require("cee3709b7a61c6f4");
var _require4 = require("18895cbeaffca9ef"), TYPE_SCHEMA_TYPE = _require4.TYPE_SCHEMA_TYPE, generateTypeID = _require4.generateTypeID;
var invariant = require("f36c90befa49e5c9");
var ACTOR_CHANGE = RelayConcreteNode.ACTOR_CHANGE, CONDITION = RelayConcreteNode.CONDITION, CLIENT_COMPONENT = RelayConcreteNode.CLIENT_COMPONENT, CLIENT_EXTENSION = RelayConcreteNode.CLIENT_EXTENSION, CLIENT_EDGE_TO_CLIENT_OBJECT = RelayConcreteNode.CLIENT_EDGE_TO_CLIENT_OBJECT, DEFER = RelayConcreteNode.DEFER, FRAGMENT_SPREAD = RelayConcreteNode.FRAGMENT_SPREAD, INLINE_FRAGMENT = RelayConcreteNode.INLINE_FRAGMENT, LINKED_FIELD = RelayConcreteNode.LINKED_FIELD, LINKED_HANDLE = RelayConcreteNode.LINKED_HANDLE, MODULE_IMPORT = RelayConcreteNode.MODULE_IMPORT, RELAY_RESOLVER = RelayConcreteNode.RELAY_RESOLVER, RELAY_LIVE_RESOLVER = RelayConcreteNode.RELAY_LIVE_RESOLVER, SCALAR_FIELD = RelayConcreteNode.SCALAR_FIELD, SCALAR_HANDLE = RelayConcreteNode.SCALAR_HANDLE, STREAM = RelayConcreteNode.STREAM, TYPE_DISCRIMINATOR = RelayConcreteNode.TYPE_DISCRIMINATOR;
var getModuleOperationKey = RelayStoreUtils.getModuleOperationKey, getStorageKey = RelayStoreUtils.getStorageKey, getArgumentValues = RelayStoreUtils.getArgumentValues;
function check(getSourceForActor, getTargetForActor, defaultActorIdentifier, selector, handlers, operationLoader, getDataID, shouldProcessClientComponents) {
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var checker = new DataChecker(getSourceForActor, getTargetForActor, defaultActorIdentifier, variables, handlers, operationLoader, getDataID, shouldProcessClientComponents);
    return checker.check(node, dataID);
}
var DataChecker = /*#__PURE__*/ function() {
    function DataChecker(getSourceForActor, getTargetForActor, defaultActorIdentifier, variables, handlers, operationLoader, getDataID, shouldProcessClientComponents) {
        this._getSourceForActor = getSourceForActor;
        this._getTargetForActor = getTargetForActor;
        this._getDataID = getDataID;
        this._source = getSourceForActor(defaultActorIdentifier);
        this._mutatorRecordSourceProxyCache = new Map();
        var _this$_getMutatorAndR = this._getMutatorAndRecordProxyForActor(defaultActorIdentifier), mutator = _this$_getMutatorAndR[0], recordSourceProxy = _this$_getMutatorAndR[1];
        this._mostRecentlyInvalidatedAt = null;
        this._handlers = handlers;
        this._mutator = mutator;
        this._operationLoader = operationLoader !== null && operationLoader !== void 0 ? operationLoader : null;
        this._recordSourceProxy = recordSourceProxy;
        this._recordWasMissing = false;
        this._variables = variables;
        this._shouldProcessClientComponents = shouldProcessClientComponents;
    }
    var _proto = DataChecker.prototype;
    _proto._getMutatorAndRecordProxyForActor = function _getMutatorAndRecordProxyForActor(actorIdentifier) {
        var tuple = this._mutatorRecordSourceProxyCache.get(actorIdentifier);
        if (tuple == null) {
            var target = this._getTargetForActor(actorIdentifier);
            var mutator = new RelayRecordSourceMutator(this._getSourceForActor(actorIdentifier), target);
            var recordSourceProxy = new RelayRecordSourceProxy(mutator, this._getDataID, undefined, this._handlers);
            tuple = [
                mutator,
                recordSourceProxy
            ];
            this._mutatorRecordSourceProxyCache.set(actorIdentifier, tuple);
        }
        return tuple;
    };
    _proto.check = function check(node, dataID) {
        this._assignClientAbstractTypes(node);
        this._traverse(node, dataID);
        return this._recordWasMissing === true ? {
            status: 'missing',
            mostRecentlyInvalidatedAt: this._mostRecentlyInvalidatedAt
        } : {
            status: 'available',
            mostRecentlyInvalidatedAt: this._mostRecentlyInvalidatedAt
        };
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && invariant(false);
        return this._variables[name];
    };
    _proto._handleMissing = function _handleMissing() {
        this._recordWasMissing = true;
    };
    _proto._handleMissingScalarField = function _handleMissingScalarField(field, dataID) {
        if (field.name === 'id' && field.alias == null && isClientID(dataID)) return undefined;
        var args = field.args != undefined ? getArgumentValues(field.args, this._variables) : {};
        var _iterator = (0, _createForOfIteratorHelper2["default"])(this._handlers), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var handler = _step.value;
                if (handler.kind === 'scalar') {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue !== undefined) return newValue;
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        this._handleMissing();
    };
    _proto._handleMissingLinkField = function _handleMissingLinkField(field, dataID) {
        var args = field.args != undefined ? getArgumentValues(field.args, this._variables) : {};
        var _iterator2 = (0, _createForOfIteratorHelper2["default"])(this._handlers), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var handler = _step2.value;
                if (handler.kind === 'linked') {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue !== undefined && (newValue === null || this._mutator.getStatus(newValue) === EXISTENT)) return newValue;
                }
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        this._handleMissing();
    };
    _proto._handleMissingPluralLinkField = function _handleMissingPluralLinkField(field, dataID) {
        var _this = this;
        var args = field.args != undefined ? getArgumentValues(field.args, this._variables) : {};
        var _iterator3 = (0, _createForOfIteratorHelper2["default"])(this._handlers), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var handler = _step3.value;
                if (handler.kind === 'pluralLinked') {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue != null) {
                        var allItemsKnown = newValue.every(function(linkedID) {
                            return linkedID != null && _this._mutator.getStatus(linkedID) === EXISTENT;
                        });
                        if (allItemsKnown) return newValue;
                    } else if (newValue === null) return null;
                }
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        this._handleMissing();
    };
    _proto._traverse = function _traverse(node, dataID) {
        var status = this._mutator.getStatus(dataID);
        if (status === UNKNOWN) this._handleMissing();
        if (status === EXISTENT) {
            var record = this._source.get(dataID);
            var invalidatedAt = RelayModernRecord.getInvalidationEpoch(record);
            if (invalidatedAt != null) this._mostRecentlyInvalidatedAt = this._mostRecentlyInvalidatedAt != null ? Math.max(this._mostRecentlyInvalidatedAt, invalidatedAt) : invalidatedAt;
            this._traverseSelections(node.selections, dataID);
        }
    };
    _proto._traverseSelections = function _traverseSelections(selections, dataID) {
        var _this2 = this;
        selections.forEach(function(selection) {
            switch(selection.kind){
                case SCALAR_FIELD:
                    _this2._checkScalar(selection, dataID);
                    break;
                case LINKED_FIELD:
                    if (selection.plural) _this2._checkPluralLink(selection, dataID);
                    else _this2._checkLink(selection, dataID);
                    break;
                case ACTOR_CHANGE:
                    _this2._checkActorChange(selection.linkedField, dataID);
                    break;
                case CONDITION:
                    var conditionValue = Boolean(_this2._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) _this2._traverseSelections(selection.selections, dataID);
                    break;
                case INLINE_FRAGMENT:
                    var _abstractKey = selection.abstractKey;
                    if (_abstractKey == null) {
                        var typeName = _this2._mutator.getType(dataID);
                        if (typeName === selection.type) _this2._traverseSelections(selection.selections, dataID);
                    } else {
                        var _recordType = _this2._mutator.getType(dataID);
                        !(_recordType != null) && invariant(false);
                        var _typeID = generateTypeID(_recordType);
                        var _implementsInterface = _this2._mutator.getValue(_typeID, _abstractKey);
                        if (_implementsInterface === true) _this2._traverseSelections(selection.selections, dataID);
                        else if (_implementsInterface == null) _this2._handleMissing();
                    }
                    break;
                case LINKED_HANDLE:
                    var handleField = cloneRelayHandleSourceField(selection, selections, _this2._variables);
                    if (handleField.plural) _this2._checkPluralLink(handleField, dataID);
                    else _this2._checkLink(handleField, dataID);
                    break;
                case SCALAR_HANDLE:
                    var _handleField = cloneRelayScalarHandleSourceField(selection, selections, _this2._variables);
                    _this2._checkScalar(_handleField, dataID);
                    break;
                case MODULE_IMPORT:
                    _this2._checkModuleImport(selection, dataID);
                    break;
                case DEFER:
                case STREAM:
                    _this2._traverseSelections(selection.selections, dataID);
                    break;
                case FRAGMENT_SPREAD:
                    var prevVariables = _this2._variables;
                    _this2._variables = getLocalVariables(_this2._variables, selection.fragment.argumentDefinitions, selection.args);
                    _this2._traverseSelections(selection.fragment.selections, dataID);
                    _this2._variables = prevVariables;
                    break;
                case CLIENT_EXTENSION:
                    var recordWasMissing = _this2._recordWasMissing;
                    _this2._traverseSelections(selection.selections, dataID);
                    _this2._recordWasMissing = recordWasMissing;
                    break;
                case TYPE_DISCRIMINATOR:
                    var abstractKey = selection.abstractKey;
                    var recordType = _this2._mutator.getType(dataID);
                    !(recordType != null) && invariant(false);
                    var typeID = generateTypeID(recordType);
                    var implementsInterface = _this2._mutator.getValue(typeID, abstractKey);
                    if (implementsInterface == null) _this2._handleMissing();
                    break;
                case CLIENT_COMPONENT:
                    if (_this2._shouldProcessClientComponents === false) break;
                    _this2._traverseSelections(selection.fragment.selections, dataID);
                    break;
                case RELAY_RESOLVER:
                    _this2._checkResolver(selection, dataID);
                    break;
                case RELAY_LIVE_RESOLVER:
                    _this2._checkResolver(selection, dataID);
                    break;
                case CLIENT_EDGE_TO_CLIENT_OBJECT:
                    _this2._checkResolver(selection.backingField, dataID);
                    break;
                default:
                    selection;
                    invariant(false);
            }
        });
    };
    _proto._checkResolver = function _checkResolver(resolver, dataID) {
        if (resolver.fragment) this._traverseSelections([
            resolver.fragment
        ], dataID);
    };
    _proto._checkModuleImport = function _checkModuleImport(moduleImport, dataID) {
        var operationLoader = this._operationLoader;
        !(operationLoader !== null) && invariant(false);
        var operationKey = getModuleOperationKey(moduleImport.documentName);
        var operationReference = this._mutator.getValue(dataID, operationKey);
        if (operationReference == null) {
            if (operationReference === undefined) this._handleMissing();
            return;
        }
        var normalizationRootNode = operationLoader.get(operationReference);
        if (normalizationRootNode != null) {
            var operation = getOperation(normalizationRootNode);
            var prevVariables = this._variables;
            this._variables = getLocalVariables(this._variables, operation.argumentDefinitions, moduleImport.args);
            this._traverse(operation, dataID);
            this._variables = prevVariables;
        } else this._handleMissing();
    };
    _proto._checkScalar = function _checkScalar(field, dataID) {
        var storageKey = getStorageKey(field, this._variables);
        var fieldValue = this._mutator.getValue(dataID, storageKey);
        if (fieldValue === undefined) {
            fieldValue = this._handleMissingScalarField(field, dataID);
            if (fieldValue !== undefined) this._mutator.setValue(dataID, storageKey, fieldValue);
        }
    };
    _proto._checkLink = function _checkLink(field, dataID) {
        var storageKey = getStorageKey(field, this._variables);
        var linkedID = this._mutator.getLinkedRecordID(dataID, storageKey);
        if (linkedID === undefined) {
            linkedID = this._handleMissingLinkField(field, dataID);
            if (linkedID != null) this._mutator.setLinkedRecordID(dataID, storageKey, linkedID);
            else if (linkedID === null) this._mutator.setValue(dataID, storageKey, null);
        }
        if (linkedID != null) this._traverse(field, linkedID);
    };
    _proto._checkPluralLink = function _checkPluralLink(field, dataID) {
        var _this3 = this;
        var storageKey = getStorageKey(field, this._variables);
        var linkedIDs = this._mutator.getLinkedRecordIDs(dataID, storageKey);
        if (linkedIDs === undefined) {
            linkedIDs = this._handleMissingPluralLinkField(field, dataID);
            if (linkedIDs != null) this._mutator.setLinkedRecordIDs(dataID, storageKey, linkedIDs);
            else if (linkedIDs === null) this._mutator.setValue(dataID, storageKey, null);
        }
        if (linkedIDs) linkedIDs.forEach(function(linkedID) {
            if (linkedID != null) _this3._traverse(field, linkedID);
        });
    };
    _proto._checkActorChange = function _checkActorChange(field, dataID) {
        var storageKey = getStorageKey(field, this._variables);
        var record = this._source.get(dataID);
        var tuple = record != null ? RelayModernRecord.getActorLinkedRecordID(record, storageKey) : record;
        if (tuple == null) {
            if (tuple === undefined) this._handleMissing();
        } else {
            var actorIdentifier = tuple[0], linkedID = tuple[1];
            var prevSource = this._source;
            var prevMutator = this._mutator;
            var prevRecordSourceProxy = this._recordSourceProxy;
            var _this$_getMutatorAndR2 = this._getMutatorAndRecordProxyForActor(actorIdentifier), mutator = _this$_getMutatorAndR2[0], recordSourceProxy = _this$_getMutatorAndR2[1];
            this._source = this._getSourceForActor(actorIdentifier);
            this._mutator = mutator;
            this._recordSourceProxy = recordSourceProxy;
            this._assignClientAbstractTypes(field);
            this._traverse(field, linkedID);
            this._source = prevSource;
            this._mutator = prevMutator;
            this._recordSourceProxy = prevRecordSourceProxy;
        }
    };
    _proto._assignClientAbstractTypes = function _assignClientAbstractTypes(node) {
        var clientAbstractTypes = node.clientAbstractTypes;
        if (clientAbstractTypes != null) for(var _i = 0, _Object$keys = Object.keys(clientAbstractTypes); _i < _Object$keys.length; _i++){
            var abstractType = _Object$keys[_i];
            var _iterator4 = (0, _createForOfIteratorHelper2["default"])(clientAbstractTypes[abstractType]), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var concreteType = _step4.value;
                    var typeID = generateTypeID(concreteType);
                    if (this._source.get(typeID) == null) this._mutator.create(typeID, TYPE_SCHEMA_TYPE);
                    if (this._mutator.getValue(typeID, abstractType) == null) this._mutator.setValue(typeID, abstractType, true);
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
    };
    return DataChecker;
}();
module.exports = {
    check: check
};

},{"cacb16c80358f382":"590td","c9437aaebe2e50fb":"fMaLa","67275ac85415bb64":"kKEFB","9bc9307a48a617b6":"7OCKP","42765387566e697a":"4vplj","27b1ee4d87c425ba":"jKskk","1734def79cf4224f":"gL1rB","99184f9281e13032":"hUbQm","267fdc08bd0843b8":"6XW3k","79f7dc7c88f08046":"138Hd","4cad14c75485f3d5":"daXOB","9fc303a9caffd777":"7LnXj","cee3709b7a61c6f4":"3QcrW","18895cbeaffca9ef":"32ztQ","f36c90befa49e5c9":"e2sci"}],"hUbQm":[function(require,module,exports,__globalThis) {
'use strict';
var _require = require("4f822b4d6fc10cd6"), LINKED_FIELD = _require.LINKED_FIELD;
var _require2 = require("21ceeaf6909b07d8"), getHandleStorageKey = _require2.getHandleStorageKey;
var areEqual = require("582fd0b44b6c2f8a");
var invariant = require("3c1e1ab84715f66e");
function cloneRelayHandleSourceField(handleField, selections, variables) {
    var sourceField = selections.find(function(source) {
        return source.kind === LINKED_FIELD && source.name === handleField.name && source.alias === handleField.alias && areEqual(source.args, handleField.args);
    });
    !(sourceField && sourceField.kind === LINKED_FIELD) && invariant(false);
    var handleKey = getHandleStorageKey(handleField, variables);
    return {
        kind: 'LinkedField',
        alias: sourceField.alias,
        name: handleKey,
        storageKey: handleKey,
        args: null,
        concreteType: sourceField.concreteType,
        plural: sourceField.plural,
        selections: sourceField.selections
    };
}
module.exports = cloneRelayHandleSourceField;

},{"4f822b4d6fc10cd6":"jKskk","21ceeaf6909b07d8":"3QcrW","582fd0b44b6c2f8a":"eJLuG","3c1e1ab84715f66e":"e2sci"}],"6XW3k":[function(require,module,exports,__globalThis) {
'use strict';
var _require = require("40439c33de9184e6"), SCALAR_FIELD = _require.SCALAR_FIELD;
var _require2 = require("d8849a0e1268fc6c"), getHandleStorageKey = _require2.getHandleStorageKey;
var areEqual = require("e28251715f16e299");
var invariant = require("8493e165b7d693af");
function cloneRelayScalarHandleSourceField(handleField, selections, variables) {
    var sourceField = selections.find(function(source) {
        return source.kind === SCALAR_FIELD && source.name === handleField.name && source.alias === handleField.alias && areEqual(source.args, handleField.args);
    });
    !(sourceField && sourceField.kind === SCALAR_FIELD) && invariant(false);
    var handleKey = getHandleStorageKey(handleField, variables);
    return {
        kind: 'ScalarField',
        alias: sourceField.alias,
        name: handleKey,
        storageKey: handleKey,
        args: null
    };
}
module.exports = cloneRelayScalarHandleSourceField;

},{"40439c33de9184e6":"jKskk","d8849a0e1268fc6c":"3QcrW","e28251715f16e299":"eJLuG","8493e165b7d693af":"e2sci"}],"4BdDg":[function(require,module,exports,__globalThis) {
var _instanceof = require("@swc/helpers/_/_instanceof");
'use strict';
var _interopRequireDefault = require("f4f697e764622070")["default"];
var _objectSpread2 = _interopRequireDefault(require("7204df6f35af857f"));
var RelayModernRecord = require("ac6d3680a5c39793");
var RelayRecordSource = require("ac6fe97efdd240d7");
var invariant = require("d162a134142e3c6c");
var UNPUBLISH_RECORD_SENTINEL = RelayModernRecord.fromObject(Object.freeze({
    __UNPUBLISH_RECORD_SENTINEL: true
}));
var RelayOptimisticRecordSource = /*#__PURE__*/ function() {
    function RelayOptimisticRecordSource(base) {
        this._base = base;
        this._sink = RelayRecordSource.create();
    }
    var _proto = RelayOptimisticRecordSource.prototype;
    _proto.has = function has(dataID) {
        if (this._sink.has(dataID)) {
            var sinkRecord = this._sink.get(dataID);
            return sinkRecord !== UNPUBLISH_RECORD_SENTINEL;
        } else return this._base.has(dataID);
    };
    _proto.get = function get(dataID) {
        if (this._sink.has(dataID)) {
            var sinkRecord = this._sink.get(dataID);
            if (sinkRecord === UNPUBLISH_RECORD_SENTINEL) return undefined;
            else return sinkRecord;
        } else return this._base.get(dataID);
    };
    _proto.getStatus = function getStatus(dataID) {
        var record = this.get(dataID);
        if (record === undefined) return 'UNKNOWN';
        else if (record === null) return 'NONEXISTENT';
        else return 'EXISTENT';
    };
    _proto.clear = function clear() {
        this._base = RelayRecordSource.create();
        this._sink.clear();
    };
    _proto["delete"] = function _delete(dataID) {
        this._sink["delete"](dataID);
    };
    _proto.remove = function remove(dataID) {
        this._sink.set(dataID, UNPUBLISH_RECORD_SENTINEL);
    };
    _proto.set = function set(dataID, record) {
        this._sink.set(dataID, record);
    };
    _proto.getRecordIDs = function getRecordIDs() {
        return Object.keys(this.toJSON());
    };
    _proto.size = function size() {
        return Object.keys(this.toJSON()).length;
    };
    _proto.toJSON = function toJSON() {
        var _this = this;
        var merged = (0, _objectSpread2["default"])({}, this._base.toJSON());
        this._sink.getRecordIDs().forEach(function(dataID) {
            var record = _this.get(dataID);
            if (record === undefined) delete merged[dataID];
            else merged[dataID] = RelayModernRecord.toJSON(record);
        });
        return merged;
    };
    _proto.getOptimisticRecordIDs = function getOptimisticRecordIDs() {
        return new Set(this._sink.getRecordIDs());
    };
    return RelayOptimisticRecordSource;
}();
function create(base) {
    return new RelayOptimisticRecordSource(base);
}
function getOptimisticRecordIDs(source) {
    !(0, _instanceof._)(source, RelayOptimisticRecordSource) && invariant(false);
    return source.getOptimisticRecordIDs();
}
module.exports = {
    create: create,
    getOptimisticRecordIDs: getOptimisticRecordIDs
};

},{"@swc/helpers/_/_instanceof":"h9UKc","f4f697e764622070":"590td","7204df6f35af857f":"2Bj1n","ac6d3680a5c39793":"daXOB","ac6fe97efdd240d7":"6w3KR","d162a134142e3c6c":"e2sci"}],"7FTk2":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("cbadddc442b6deaf")["default"];
var _createForOfIteratorHelper2 = _interopRequireDefault(require("96443eecc4a72d7b"));
var getOperation = require("7b06dd03ba2cb4d4");
var RelayConcreteNode = require("a0906813ef84d9cf");
var cloneRelayHandleSourceField = require("c4ea8083a86e020d");
var getOutputTypeRecordIDs = require("dfe2c1afc1aae2c2");
var _require = require("7f246af2ff0d77f5"), getLocalVariables = _require.getLocalVariables;
var RelayModernRecord = require("e00013a27e047068");
var RelayStoreUtils = require("1f42bd1ed1e95682");
var _require2 = require("d74d487411fd9911"), generateTypeID = _require2.generateTypeID;
var invariant = require("1eabded8cbcaaa04");
var ACTOR_CHANGE = RelayConcreteNode.ACTOR_CHANGE, CONDITION = RelayConcreteNode.CONDITION, CLIENT_COMPONENT = RelayConcreteNode.CLIENT_COMPONENT, CLIENT_EXTENSION = RelayConcreteNode.CLIENT_EXTENSION, DEFER = RelayConcreteNode.DEFER, FRAGMENT_SPREAD = RelayConcreteNode.FRAGMENT_SPREAD, INLINE_FRAGMENT = RelayConcreteNode.INLINE_FRAGMENT, LINKED_FIELD = RelayConcreteNode.LINKED_FIELD, MODULE_IMPORT = RelayConcreteNode.MODULE_IMPORT, LINKED_HANDLE = RelayConcreteNode.LINKED_HANDLE, SCALAR_FIELD = RelayConcreteNode.SCALAR_FIELD, SCALAR_HANDLE = RelayConcreteNode.SCALAR_HANDLE, STREAM = RelayConcreteNode.STREAM, TYPE_DISCRIMINATOR = RelayConcreteNode.TYPE_DISCRIMINATOR, RELAY_RESOLVER = RelayConcreteNode.RELAY_RESOLVER, RELAY_LIVE_RESOLVER = RelayConcreteNode.RELAY_LIVE_RESOLVER, CLIENT_EDGE_TO_CLIENT_OBJECT = RelayConcreteNode.CLIENT_EDGE_TO_CLIENT_OBJECT;
var getStorageKey = RelayStoreUtils.getStorageKey, getModuleOperationKey = RelayStoreUtils.getModuleOperationKey;
function mark(recordSource, selector, references, operationLoader, shouldProcessClientComponents) {
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var marker = new RelayReferenceMarker(recordSource, variables, references, operationLoader, shouldProcessClientComponents);
    marker.mark(node, dataID);
}
var RelayReferenceMarker = /*#__PURE__*/ function() {
    function RelayReferenceMarker(recordSource, variables, references, operationLoader, shouldProcessClientComponents) {
        this._operationLoader = operationLoader !== null && operationLoader !== void 0 ? operationLoader : null;
        this._operationName = null;
        this._recordSource = recordSource;
        this._references = references;
        this._variables = variables;
        this._shouldProcessClientComponents = shouldProcessClientComponents;
    }
    var _proto = RelayReferenceMarker.prototype;
    _proto.mark = function mark(node, dataID) {
        if (node.kind === 'Operation' || node.kind === 'SplitOperation') this._operationName = node.name;
        this._traverse(node, dataID);
    };
    _proto._traverse = function _traverse(node, dataID) {
        this._references.add(dataID);
        var record = this._recordSource.get(dataID);
        if (record == null) return;
        this._traverseSelections(node.selections, record);
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && invariant(false);
        return this._variables[name];
    };
    _proto._traverseSelections = function _traverseSelections(selections, record) {
        var _this = this;
        selections.forEach(function(selection) {
            switch(selection.kind){
                case ACTOR_CHANGE:
                    _this._traverseLink(selection.linkedField, record);
                    break;
                case LINKED_FIELD:
                    if (selection.plural) _this._traversePluralLink(selection, record);
                    else _this._traverseLink(selection, record);
                    break;
                case CONDITION:
                    var conditionValue = Boolean(_this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) _this._traverseSelections(selection.selections, record);
                    break;
                case INLINE_FRAGMENT:
                    if (selection.abstractKey == null) {
                        var typeName = RelayModernRecord.getType(record);
                        if (typeName != null && typeName === selection.type || typeName === RelayStoreUtils.ROOT_TYPE) _this._traverseSelections(selection.selections, record);
                    } else {
                        var _typeName = RelayModernRecord.getType(record);
                        var typeID = generateTypeID(_typeName);
                        _this._references.add(typeID);
                        _this._traverseSelections(selection.selections, record);
                    }
                    break;
                case FRAGMENT_SPREAD:
                    var prevVariables = _this._variables;
                    _this._variables = getLocalVariables(_this._variables, selection.fragment.argumentDefinitions, selection.args);
                    _this._traverseSelections(selection.fragment.selections, record);
                    _this._variables = prevVariables;
                    break;
                case LINKED_HANDLE:
                    var handleField = cloneRelayHandleSourceField(selection, selections, _this._variables);
                    if (handleField.plural) _this._traversePluralLink(handleField, record);
                    else _this._traverseLink(handleField, record);
                    break;
                case DEFER:
                case STREAM:
                    _this._traverseSelections(selection.selections, record);
                    break;
                case SCALAR_FIELD:
                case SCALAR_HANDLE:
                    break;
                case TYPE_DISCRIMINATOR:
                    var _typeName2 = RelayModernRecord.getType(record);
                    var _typeID = generateTypeID(_typeName2);
                    _this._references.add(_typeID);
                    break;
                case MODULE_IMPORT:
                    _this._traverseModuleImport(selection, record);
                    break;
                case CLIENT_EXTENSION:
                    _this._traverseSelections(selection.selections, record);
                    break;
                case CLIENT_COMPONENT:
                    if (_this._shouldProcessClientComponents === false) break;
                    _this._traverseSelections(selection.fragment.selections, record);
                    break;
                case RELAY_RESOLVER:
                    _this._traverseResolverField(selection, record);
                    break;
                case RELAY_LIVE_RESOLVER:
                    _this._traverseResolverField(selection, record);
                    break;
                case CLIENT_EDGE_TO_CLIENT_OBJECT:
                    _this._traverseClientEdgeToClientObject(selection, record);
                    break;
                default:
                    selection;
                    invariant(false);
            }
        });
    };
    _proto._traverseClientEdgeToClientObject = function _traverseClientEdgeToClientObject(field, record) {
        var dataID = this._traverseResolverField(field.backingField, record);
        if (dataID == null) return;
        var resolverRecord = this._recordSource.get(dataID);
        if (resolverRecord == null) return;
        if (field.backingField.isOutputType) {
            var outputTypeRecordIDs = getOutputTypeRecordIDs(resolverRecord);
            if (outputTypeRecordIDs != null) {
                var _iterator = (0, _createForOfIteratorHelper2["default"])(outputTypeRecordIDs), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var _dataID = _step.value;
                        this._references.add(_dataID);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
        } else {
            var linkedField = field.linkedField;
            var concreteType = linkedField.concreteType;
            if (concreteType == null) return;
            if (linkedField.plural) {
                var dataIDs = RelayModernRecord.getResolverLinkedRecordIDs(resolverRecord, concreteType);
                if (dataIDs != null) {
                    var _iterator2 = (0, _createForOfIteratorHelper2["default"])(dataIDs), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var _dataID2 = _step2.value;
                            if (_dataID2 != null) this._traverse(linkedField, _dataID2);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            } else {
                var _dataID3 = RelayModernRecord.getResolverLinkedRecordID(resolverRecord, concreteType);
                if (_dataID3 != null) this._traverse(linkedField, _dataID3);
            }
        }
    };
    _proto._traverseResolverField = function _traverseResolverField(field, record) {
        var storageKey = getStorageKey(field, this._variables);
        var dataID = RelayModernRecord.getLinkedRecordID(record, storageKey);
        if (dataID != null) this._references.add(dataID);
        var fragment = field.fragment;
        if (fragment != null) this._traverseSelections([
            fragment
        ], record);
        return dataID;
    };
    _proto._traverseModuleImport = function _traverseModuleImport(moduleImport, record) {
        var _this$_operationName;
        var operationLoader = this._operationLoader;
        !(operationLoader !== null) && invariant(false);
        var operationKey = getModuleOperationKey(moduleImport.documentName);
        var operationReference = RelayModernRecord.getValue(record, operationKey);
        if (operationReference == null) return;
        var normalizationRootNode = operationLoader.get(operationReference);
        if (normalizationRootNode != null) {
            var operation = getOperation(normalizationRootNode);
            var prevVariables = this._variables;
            this._variables = getLocalVariables(this._variables, operation.argumentDefinitions, moduleImport.args);
            this._traverseSelections(operation.selections, record);
            this._variables = prevVariables;
        }
    };
    _proto._traverseLink = function _traverseLink(field, record) {
        var storageKey = getStorageKey(field, this._variables);
        var linkedID = RelayModernRecord.getLinkedRecordID(record, storageKey);
        if (linkedID == null) return;
        this._traverse(field, linkedID);
    };
    _proto._traversePluralLink = function _traversePluralLink(field, record) {
        var _this2 = this;
        var storageKey = getStorageKey(field, this._variables);
        var linkedIDs = RelayModernRecord.getLinkedRecordIDs(record, storageKey);
        if (linkedIDs == null) return;
        linkedIDs.forEach(function(linkedID) {
            if (linkedID != null) _this2._traverse(field, linkedID);
        });
    };
    return RelayReferenceMarker;
}();
module.exports = {
    mark: mark
};

},{"cbadddc442b6deaf":"590td","96443eecc4a72d7b":"fMaLa","7b06dd03ba2cb4d4":"4vplj","a0906813ef84d9cf":"jKskk","c4ea8083a86e020d":"hUbQm","dfe2c1afc1aae2c2":"62CkT","7f246af2ff0d77f5":"138Hd","e00013a27e047068":"daXOB","1f42bd1ed1e95682":"3QcrW","d74d487411fd9911":"32ztQ","1eabded8cbcaaa04":"e2sci"}],"62CkT":[function(require,module,exports,__globalThis) {
var _instanceof = require("@swc/helpers/_/_instanceof");
'use strict';
var RelayModernRecord = require("94c3d2696affa6d");
var _require = require("5055ac128af81574"), RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS = _require.RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS;
var invariant = require("114d2c97305c30be");
function getOutputTypeRecordIDs(record) {
    var maybeOutputTypeRecordIDs = RelayModernRecord.getValue(record, RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS);
    if (maybeOutputTypeRecordIDs == null) return null;
    !(0, _instanceof._)(maybeOutputTypeRecordIDs, Set) && invariant(false);
    return maybeOutputTypeRecordIDs;
}
module.exports = getOutputTypeRecordIDs;

},{"@swc/helpers/_/_instanceof":"h9UKc","94c3d2696affa6d":"daXOB","5055ac128af81574":"3QcrW","114d2c97305c30be":"e2sci"}],"idAWU":[function(require,module,exports,__globalThis) {
'use strict';
var deepFreeze = require("8a95c7fa9dc12fe9");
var recycleNodesInto = require("5e5d7bb6f8bf8b1f");
var RelayFeatureFlags = require("f33204f0bccaed58");
var hasOverlappingIDs = require("5a211ee2f9eb5afa");
var hasSignificantOverlappingIDs = require("250834abcf4a675d");
var RelayReader = require("65e9366da423c0f6");
var RelayStoreSubscriptions = /*#__PURE__*/ function() {
    function RelayStoreSubscriptions(log, resolverCache) {
        this._subscriptions = new Set();
        this.__log = log;
        this._resolverCache = resolverCache;
    }
    var _proto = RelayStoreSubscriptions.prototype;
    _proto.subscribe = function subscribe(snapshot, callback) {
        var _this = this;
        var subscription = {
            backup: null,
            callback: callback,
            snapshot: snapshot,
            stale: false
        };
        var dispose = function dispose() {
            _this._subscriptions["delete"](subscription);
        };
        this._subscriptions.add(subscription);
        return {
            dispose: dispose
        };
    };
    _proto.snapshotSubscriptions = function snapshotSubscriptions(source) {
        var _this2 = this;
        this._subscriptions.forEach(function(subscription) {
            if (!subscription.stale) {
                subscription.backup = subscription.snapshot;
                return;
            }
            var snapshot = subscription.snapshot;
            var backup = RelayReader.read(source, snapshot.selector, _this2._resolverCache);
            var nextData = recycleNodesInto(snapshot.data, backup.data);
            backup.data = nextData;
            subscription.backup = backup;
        });
    };
    _proto.restoreSubscriptions = function restoreSubscriptions() {
        this._subscriptions.forEach(function(subscription) {
            var backup = subscription.backup;
            subscription.backup = null;
            if (backup) {
                if (backup.data !== subscription.snapshot.data) subscription.stale = true;
                subscription.snapshot = {
                    data: subscription.snapshot.data,
                    isMissingData: backup.isMissingData,
                    missingClientEdges: backup.missingClientEdges,
                    missingLiveResolverFields: backup.missingLiveResolverFields,
                    seenRecords: backup.seenRecords,
                    selector: backup.selector,
                    missingRequiredFields: backup.missingRequiredFields,
                    relayResolverErrors: backup.relayResolverErrors,
                    errorResponseFields: backup.errorResponseFields
                };
            } else subscription.stale = true;
        });
    };
    _proto.updateSubscriptions = function updateSubscriptions(source, updatedRecordIDs, updatedOwners, sourceOperation) {
        var _this3 = this;
        var hasUpdatedRecords = updatedRecordIDs.size !== 0;
        this._subscriptions.forEach(function(subscription) {
            var owner = _this3._updateSubscription(source, subscription, updatedRecordIDs, hasUpdatedRecords, sourceOperation);
            if (owner != null) updatedOwners.push(owner);
        });
    };
    _proto._updateSubscription = function _updateSubscription(source, subscription, updatedRecordIDs, hasUpdatedRecords, sourceOperation) {
        var backup = subscription.backup, callback = subscription.callback, snapshot = subscription.snapshot, stale = subscription.stale;
        var hasOverlappingUpdates = hasUpdatedRecords && hasOverlappingIDs(snapshot.seenRecords, updatedRecordIDs);
        if (!stale && !hasOverlappingUpdates) return;
        var nextSnapshot = hasOverlappingUpdates || !backup ? RelayReader.read(source, snapshot.selector, this._resolverCache) : backup;
        var nextData = recycleNodesInto(snapshot.data, nextSnapshot.data);
        nextSnapshot = {
            data: nextData,
            isMissingData: nextSnapshot.isMissingData,
            missingClientEdges: nextSnapshot.missingClientEdges,
            missingLiveResolverFields: nextSnapshot.missingLiveResolverFields,
            seenRecords: nextSnapshot.seenRecords,
            selector: nextSnapshot.selector,
            missingRequiredFields: nextSnapshot.missingRequiredFields,
            relayResolverErrors: nextSnapshot.relayResolverErrors,
            errorResponseFields: nextSnapshot.errorResponseFields
        };
        subscription.snapshot = nextSnapshot;
        subscription.stale = false;
        if (nextSnapshot.data !== snapshot.data) {
            if (this.__log && RelayFeatureFlags.ENABLE_NOTIFY_SUBSCRIPTION) this.__log({
                name: 'store.notify.subscription',
                sourceOperation: sourceOperation,
                snapshot: snapshot,
                nextSnapshot: nextSnapshot
            });
            callback(nextSnapshot);
            return snapshot.selector.owner;
        }
        if (RelayFeatureFlags.ENABLE_LOOSE_SUBSCRIPTION_ATTRIBUTION && (stale || hasSignificantOverlappingIDs(snapshot.seenRecords, updatedRecordIDs))) return snapshot.selector.owner;
    };
    return RelayStoreSubscriptions;
}();
module.exports = RelayStoreSubscriptions;

},{"8a95c7fa9dc12fe9":"eLea7","5e5d7bb6f8bf8b1f":"ij1IQ","f33204f0bccaed58":"a0FL5","5a211ee2f9eb5afa":"czxXZ","250834abcf4a675d":"d1LBu","65e9366da423c0f6":"hTh0M"}],"czxXZ":[function(require,module,exports,__globalThis) {
'use strict';
var ITERATOR_KEY = Symbol.iterator;
function hasOverlappingIDs(seenRecords, updatedRecordIDs) {
    var iterator = seenRecords[ITERATOR_KEY]();
    var next = iterator.next();
    while(!next.done){
        var key = next.value;
        if (updatedRecordIDs.has(key)) return true;
        next = iterator.next();
    }
    return false;
}
module.exports = hasOverlappingIDs;

},{}],"d1LBu":[function(require,module,exports,__globalThis) {
'use strict';
var _require = require("58f1581f3785949d"), ROOT_ID = _require.ROOT_ID;
var _require2 = require("484cb66a6ef0ffa9"), VIEWER_ID = _require2.VIEWER_ID;
var ITERATOR_KEY = Symbol.iterator;
function hasSignificantOverlappingIDs(seenRecords, updatedRecordIDs) {
    var iterator = seenRecords[ITERATOR_KEY]();
    var next = iterator.next();
    while(!next.done){
        var key = next.value;
        if (updatedRecordIDs.has(key) && key !== ROOT_ID && key !== VIEWER_ID) return true;
        next = iterator.next();
    }
    return false;
}
module.exports = hasSignificantOverlappingIDs;

},{"58f1581f3785949d":"3QcrW","484cb66a6ef0ffa9":"i6PYa"}],"7OgOE":[function(require,module,exports,__globalThis) {
'use strict';
var RelayDeclarativeMutationConfig = require("f7be63ed7a4347a6");
var _require = require("c338a1a400b26ef4"), getRequest = _require.getRequest;
var _require2 = require("c86947abc2b5067e"), createOperationDescriptor = _require2.createOperationDescriptor;
var _require3 = require("5ee9d4b50d8dcebc"), createReaderSelector = _require3.createReaderSelector;
var warning = require("657ec1fdceb482e9");
function requestSubscription(environment, config) {
    var subscription = getRequest(config.subscription);
    if (subscription.params.operationKind !== 'subscription') throw new Error('requestSubscription: Must use Subscription operation');
    var configs = config.configs, onCompleted = config.onCompleted, onError = config.onError, onNext = config.onNext, variables = config.variables, cacheConfig = config.cacheConfig;
    var operation = createOperationDescriptor(subscription, variables, cacheConfig);
    var _ref = configs ? RelayDeclarativeMutationConfig.convert(configs, subscription, null, config.updater) : config, updater = _ref.updater;
    var sub = environment.executeSubscription({
        operation: operation,
        updater: updater
    }).subscribe({
        next: function next(responses) {
            if (onNext != null) {
                var selector = operation.fragment;
                var nextID;
                if (Array.isArray(responses)) {
                    var _responses$, _responses$$extension;
                    nextID = (_responses$ = responses[0]) === null || _responses$ === void 0 ? void 0 : (_responses$$extension = _responses$.extensions) === null || _responses$$extension === void 0 ? void 0 : _responses$$extension.__relay_subscription_root_id;
                } else {
                    var _responses$extensions;
                    nextID = (_responses$extensions = responses.extensions) === null || _responses$extensions === void 0 ? void 0 : _responses$extensions.__relay_subscription_root_id;
                }
                if (typeof nextID === 'string') selector = createReaderSelector(selector.node, nextID, selector.variables, selector.owner);
                var data = environment.lookup(selector).data;
                onNext(data);
            }
        },
        error: onError,
        complete: onCompleted
    });
    return {
        dispose: sub.unsubscribe
    };
}
module.exports = requestSubscription;

},{"f7be63ed7a4347a6":"1lmKe","c338a1a400b26ef4":"8UTII","c86947abc2b5067e":"dSeB3","5ee9d4b50d8dcebc":"9k2Dg","657ec1fdceb482e9":"j64TH"}],"7pZoN":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("a92eeab200d64a8e")["default"];
var _objectSpread2 = _interopRequireDefault(require("ce63160f11945f09"));
var _require = require("ba8c3f062b9fefa3"), getModuleComponentKey = _require.getModuleComponentKey, getModuleOperationKey = _require.getModuleOperationKey;
function createPayloadFor3DField(name, operation, component, response) {
    var data = (0, _objectSpread2["default"])({}, response);
    data[getModuleComponentKey(name)] = component;
    data[getModuleOperationKey(name)] = operation;
    return data;
}
module.exports = createPayloadFor3DField;

},{"a92eeab200d64a8e":"590td","ce63160f11945f09":"2Bj1n","ba8c3f062b9fefa3":"3QcrW"}],"giGUC":[function(require,module,exports,__globalThis) {
'use strict';
var _require = require("417a7780e9c3d720"), getDataIDsFromFragment = _require.getDataIDsFromFragment, getSelector = _require.getSelector, getVariablesFromFragment = _require.getVariablesFromFragment;
var isEmptyObject = require("a07dea22d8b81663");
var RelayFeatureFlags = require("6027217066511b7");
var stableCopy = require("221c854743cf59c0");
var _require2 = require("9af55d9653e72871"), intern = _require2.intern;
function getFragmentIdentifier(fragmentNode, fragmentRef) {
    var selector = getSelector(fragmentNode, fragmentRef);
    var fragmentOwnerIdentifier = selector == null ? 'null' : selector.kind === 'SingularReaderSelector' ? selector.owner.identifier : '[' + selector.selectors.map(function(sel) {
        return sel.owner.identifier;
    }).join(',') + ']';
    var fragmentVariables = getVariablesFromFragment(fragmentNode, fragmentRef);
    var dataIDs = getDataIDsFromFragment(fragmentNode, fragmentRef);
    if (RelayFeatureFlags.ENABLE_GETFRAGMENTIDENTIFIER_OPTIMIZATION) {
        var ids = typeof dataIDs === 'undefined' ? 'missing' : dataIDs == null ? 'null' : Array.isArray(dataIDs) ? '[' + dataIDs.join(',') + ']' : dataIDs;
        ids = RelayFeatureFlags.STRING_INTERN_LEVEL <= 1 ? ids : intern(ids, RelayFeatureFlags.MAX_DATA_ID_LENGTH);
        return fragmentOwnerIdentifier + '/' + fragmentNode.name + '/' + (fragmentVariables == null || isEmptyObject(fragmentVariables) ? '{}' : JSON.stringify(stableCopy(fragmentVariables))) + '/' + ids;
    } else {
        var _JSON$stringify;
        var _ids = (_JSON$stringify = JSON.stringify(dataIDs)) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : 'missing';
        _ids = RelayFeatureFlags.STRING_INTERN_LEVEL <= 1 ? _ids : intern(_ids, RelayFeatureFlags.MAX_DATA_ID_LENGTH);
        return fragmentOwnerIdentifier + '/' + fragmentNode.name + '/' + JSON.stringify(stableCopy(fragmentVariables)) + '/' + _ids;
    }
}
module.exports = getFragmentIdentifier;

},{"417a7780e9c3d720":"9k2Dg","a07dea22d8b81663":"3BR95","6027217066511b7":"a0FL5","221c854743cf59c0":"c3NLR","9af55d9653e72871":"3S1QY"}],"3BR95":[function(require,module,exports,__globalThis) {
'use strict';
var hasOwnProperty = Object.prototype.hasOwnProperty;
function isEmptyObject(obj) {
    for(var _key in obj){
        if (hasOwnProperty.call(obj, _key)) return false;
    }
    return true;
}
module.exports = isEmptyObject;

},{}],"idmUY":[function(require,module,exports,__globalThis) {
'use strict';
var getRefetchMetadata = require("27d61340cde3ecc4");
var invariant = require("7c0454ddee6ee684");
function getPaginationMetadata(fragmentNode, componentDisplayName) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var _getRefetchMetadata = getRefetchMetadata(fragmentNode, componentDisplayName), paginationRequest = _getRefetchMetadata.refetchableRequest, refetchMetadata = _getRefetchMetadata.refetchMetadata;
    var paginationMetadata = refetchMetadata.connection;
    !(paginationMetadata != null) && invariant(false);
    var connectionPathInFragmentData = paginationMetadata.path;
    var connectionMetadata = ((_fragmentNode$metadat = (_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.connection) !== null && _fragmentNode$metadat !== void 0 ? _fragmentNode$metadat : [])[0];
    !(connectionMetadata != null) && invariant(false);
    var identifierInfo = refetchMetadata.identifierInfo;
    !((identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) == null || typeof identifierInfo.identifierField === 'string') && invariant(false);
    return {
        connectionPathInFragmentData: connectionPathInFragmentData,
        identifierField: identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField,
        paginationRequest: paginationRequest,
        paginationMetadata: paginationMetadata,
        stream: connectionMetadata.stream === true
    };
}
module.exports = getPaginationMetadata;

},{"27d61340cde3ecc4":"5aHRx","7c0454ddee6ee684":"e2sci"}],"5aHRx":[function(require,module,exports,__globalThis) {
'use strict';
var invariant = require("12d1bea7081530");
function getRefetchMetadata(fragmentNode, componentDisplayName) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    !(((_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) !== true) && invariant(false);
    var refetchMetadata = (_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.refetch;
    !(refetchMetadata != null) && invariant(false);
    var refetchableRequest = refetchMetadata.operation["default"] ? refetchMetadata.operation["default"] : refetchMetadata.operation;
    var fragmentRefPathInResponse = refetchMetadata.fragmentPathInResult;
    !(typeof refetchableRequest !== 'string') && invariant(false);
    var identifierInfo = refetchMetadata.identifierInfo;
    if (identifierInfo != null) {
        !(identifierInfo.identifierField == null || typeof identifierInfo.identifierField === 'string') && invariant(false);
        !(identifierInfo.identifierQueryVariableName == null || typeof identifierInfo.identifierQueryVariableName === 'string') && invariant(false);
    }
    return {
        fragmentRefPathInResponse: fragmentRefPathInResponse,
        identifierInfo: identifierInfo,
        refetchableRequest: refetchableRequest,
        refetchMetadata: refetchMetadata
    };
}
module.exports = getRefetchMetadata;

},{"12d1bea7081530":"e2sci"}],"f4llA":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("5a32e5a1d4422f25")["default"];
var _defineProperty2 = _interopRequireDefault(require("f8d5174bc518aec8"));
var _objectSpread4 = _interopRequireDefault(require("24b7ed39a081f6d6"));
var invariant = require("e65a5dd0a68d69d8");
var warning = require("70c05a45ac29f7d0");
function getPaginationVariables(direction, count, cursor, baseVariables, extraVariables, paginationMetadata) {
    var _objectSpread3;
    var backwardMetadata = paginationMetadata.backward, forwardMetadata = paginationMetadata.forward;
    if (direction === 'backward') {
        var _objectSpread2;
        !(backwardMetadata != null && backwardMetadata.count != null && backwardMetadata.cursor != null) && invariant(false);
        var _paginationVariables = (0, _objectSpread4["default"])((0, _objectSpread4["default"])((0, _objectSpread4["default"])({}, baseVariables), extraVariables), {}, (_objectSpread2 = {}, (0, _defineProperty2["default"])(_objectSpread2, backwardMetadata.cursor, cursor), (0, _defineProperty2["default"])(_objectSpread2, backwardMetadata.count, count), _objectSpread2));
        if (forwardMetadata && forwardMetadata.cursor) _paginationVariables[forwardMetadata.cursor] = null;
        if (forwardMetadata && forwardMetadata.count) _paginationVariables[forwardMetadata.count] = null;
        return _paginationVariables;
    }
    !(forwardMetadata != null && forwardMetadata.count != null && forwardMetadata.cursor != null) && invariant(false);
    var paginationVariables = (0, _objectSpread4["default"])((0, _objectSpread4["default"])((0, _objectSpread4["default"])({}, baseVariables), extraVariables), {}, (_objectSpread3 = {}, (0, _defineProperty2["default"])(_objectSpread3, forwardMetadata.cursor, cursor), (0, _defineProperty2["default"])(_objectSpread3, forwardMetadata.count, count), _objectSpread3));
    if (backwardMetadata && backwardMetadata.cursor) paginationVariables[backwardMetadata.cursor] = null;
    if (backwardMetadata && backwardMetadata.count) paginationVariables[backwardMetadata.count] = null;
    return paginationVariables;
}
module.exports = getPaginationVariables;

},{"5a32e5a1d4422f25":"590td","f8d5174bc518aec8":"2paQ8","24b7ed39a081f6d6":"2Bj1n","e65a5dd0a68d69d8":"e2sci","70c05a45ac29f7d0":"j64TH"}],"6JAxU":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var _interopRequireDefault = require("531f67bfa5115ab2")["default"];
var _createForOfIteratorHelper2 = _interopRequireDefault(require("d113ea0f914a3ecd"));
var invariant = require("f30658fe03c1247c");
function getValueAtPath(data, path) {
    var result = data;
    var _iterator = (0, _createForOfIteratorHelper2["default"])(path), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var key = _step.value;
            if (result == null) return null;
            if (typeof key === 'number') {
                !Array.isArray(result) && invariant(false);
                result = result[key];
            } else {
                !((typeof result === "undefined" ? "undefined" : (0, _typeOf._)(result)) === 'object' && !Array.isArray(result)) && invariant(false);
                result = result[key];
            }
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return result;
}
module.exports = getValueAtPath;

},{"@swc/helpers/_/_type_of":"iFJdx","531f67bfa5115ab2":"590td","d113ea0f914a3ecd":"fMaLa","f30658fe03c1247c":"e2sci"}],"j0ygY":[function(require,module,exports,__globalThis) {
'use strict';
var profileHandlersByName = {};
var defaultProfiler = {
    stop: function stop() {}
};
var RelayProfiler = {
    profile: function profile(name, state) {
        var handlers = profileHandlersByName[name];
        if (handlers && handlers.length > 0) {
            var stopHandlers = [];
            for(var ii = handlers.length - 1; ii >= 0; ii--){
                var stopHandler = handlers[ii](name, state);
                stopHandlers.unshift(stopHandler);
            }
            return {
                stop: function stop(error) {
                    stopHandlers.forEach(function(stopHandler) {
                        return stopHandler(error);
                    });
                }
            };
        }
        return defaultProfiler;
    },
    attachProfileHandler: function attachProfileHandler(name, handler) {
        if (!profileHandlersByName.hasOwnProperty(name)) profileHandlersByName[name] = [];
        profileHandlersByName[name].push(handler);
    },
    detachProfileHandler: function detachProfileHandler(name, handler) {
        if (profileHandlersByName.hasOwnProperty(name)) removeFromArray(profileHandlersByName[name], handler);
    }
};
function removeFromArray(array, element) {
    var index = array.indexOf(element);
    if (index !== -1) array.splice(index, 1);
}
module.exports = RelayProfiler;

},{}],"ds2RZ":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("a1754e095446dd2b")["default"];
var _extends2 = _interopRequireDefault(require("d2dbaebb2768fd4e"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("cda2acd43f202955"));
var _assertThisInitialized2 = _interopRequireDefault(require("6f63235672421dfc"));
var _inheritsLoose2 = _interopRequireDefault(require("f1bdf22fe5f7cf72"));
var _defineProperty2 = _interopRequireDefault(require("7ee058b362ace828"));
var _excluded = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
];
var buildReactRelayContainer = require("9bfe78da60564f11");
var _require = require("8439d55d54328740"), getContainerName = _require.getContainerName;
var _require2 = require("54bdad3c4dc4cd71"), assertRelayContext = _require2.assertRelayContext;
var areEqual = require("63f715741e764d2e");
var React = require("f7a484ce88430d3a");
var _require3 = require("219f2a01cc9728d6"), createFragmentSpecResolver = _require3.createFragmentSpecResolver, getDataIDsFromObject = _require3.getDataIDsFromObject, isScalarAndEqual = _require3.isScalarAndEqual;
function createContainerWithFragments(Component, fragments) {
    var _class;
    var containerName = getContainerName(Component);
    return _class = /*#__PURE__*/ function(_React$Component) {
        (0, _inheritsLoose2["default"])(_class, _React$Component);
        function _class(props) {
            var _props$__rootIsQueryR, _this;
            _this = _React$Component.call(this, props) || this;
            (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
                var resolverFromThisUpdate = _this.state.resolver;
                _this.setState(function(updatedState) {
                    return resolverFromThisUpdate === updatedState.resolver ? {
                        data: updatedState.resolver.resolve(),
                        relayProp: getRelayProp(updatedState.relayProp.environment)
                    } : null;
                });
            });
            var relayContext = assertRelayContext(props.__relayContext);
            var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
            var resolver = createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
            _this.state = {
                data: resolver.resolve(),
                prevProps: props,
                prevPropsContext: relayContext,
                relayProp: getRelayProp(relayContext.environment),
                resolver: resolver
            };
            return _this;
        }
        _class.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            var _nextProps$__rootIsQu;
            var prevProps = prevState.prevProps;
            var relayContext = assertRelayContext(nextProps.__relayContext);
            var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
            var prevIDs = getDataIDsFromObject(fragments, prevProps);
            var nextIDs = getDataIDsFromObject(fragments, nextProps);
            var resolver = prevState.resolver;
            if (prevState.prevPropsContext.environment !== relayContext.environment || !areEqual(prevIDs, nextIDs)) {
                resolver = createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
                return {
                    data: resolver.resolve(),
                    prevPropsContext: relayContext,
                    prevProps: nextProps,
                    relayProp: getRelayProp(relayContext.environment),
                    resolver: resolver
                };
            } else {
                resolver.setProps(nextProps);
                var data = resolver.resolve();
                if (data !== prevState.data) return {
                    data: data,
                    prevProps: nextProps,
                    prevPropsContext: relayContext,
                    relayProp: getRelayProp(relayContext.environment)
                };
            }
            return null;
        };
        var _proto = _class.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if (this.state.resolver !== prevState.resolver) {
                prevState.resolver.dispose();
                this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
            } else this._rerenderIfStoreHasChanged();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.state.resolver.dispose();
        };
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            if (nextState.data !== this.state.data) return true;
            var keys = Object.keys(nextProps);
            for(var ii = 0; ii < keys.length; ii++){
                var key = keys[ii];
                if (key === '__relayContext') {
                    if (nextState.prevPropsContext.environment !== this.state.prevPropsContext.environment) return true;
                } else {
                    if (!fragments.hasOwnProperty(key) && !isScalarAndEqual(nextProps[key], this.props[key])) return true;
                }
            }
            return false;
        };
        _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
            var _this$state = this.state, data = _this$state.data, resolver = _this$state.resolver;
            var maybeNewData = resolver.resolve();
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
            var _this$state2 = this.state, data = _this$state2.data, resolver = _this$state2.resolver;
            var maybeNewData = resolver.resolve();
            resolver.setCallback(this.props, this._handleFragmentDataUpdate);
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto.render = function render() {
            var _this$props = this.props, componentRef = _this$props.componentRef, __relayContext = _this$props.__relayContext, __rootIsQueryRenderer = _this$props.__rootIsQueryRenderer, props = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, _excluded);
            return /*#__PURE__*/ React.createElement(Component, (0, _extends2["default"])({}, props, this.state.data, {
                ref: componentRef,
                relay: this.state.relayProp
            }));
        };
        return _class;
    }(React.Component), (0, _defineProperty2["default"])(_class, "displayName", containerName), _class;
}
function getRelayProp(environment) {
    return {
        environment: environment
    };
}
function createContainer(Component, fragmentSpec) {
    return buildReactRelayContainer(Component, fragmentSpec, createContainerWithFragments);
}
module.exports = {
    createContainer: createContainer
};

},{"a1754e095446dd2b":"590td","d2dbaebb2768fd4e":"ehKSH","cda2acd43f202955":"fkx57","6f63235672421dfc":"k1uP3","f1bdf22fe5f7cf72":"idPlQ","7ee058b362ace828":"2paQ8","9bfe78da60564f11":"hPnUw","8439d55d54328740":"7AyFT","54bdad3c4dc4cd71":"cZlGo","63f715741e764d2e":"eJLuG","f7a484ce88430d3a":"ltHCL","219f2a01cc9728d6":"2IxFR"}],"ehKSH":[function(require,module,exports,__globalThis) {
function _extends() {
    return module.exports = _extends = Object.assign ? Object.assign.bind() : function _extends(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _extends.apply(null, arguments);
}
module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"k1uP3":[function(require,module,exports,__globalThis) {
function _assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"hPnUw":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("aef4a255ec60fb2b")["default"];
var _extends2 = _interopRequireDefault(require("b34e40963b115137"));
var assertFragmentMap = require("9e42a6a2b539f78e");
var _require = require("a4195b13ed1624dc"), getComponentName = _require.getComponentName, getContainerName = _require.getContainerName;
var ReactRelayContext = require("415c0a8bc10f8597");
var ReactRelayQueryRendererContext = require("b204f94aa50ac707");
var invariant = require("d798a86a29f44673");
var React = require("21aac5e17e156ef0");
var _require2 = require("eb347163a35ea7a3"), getFragment = _require2.getFragment;
var useContext = React.useContext;
function buildReactRelayContainer(ComponentClass, fragmentSpec, createContainerWithFragments) {
    var containerName = getContainerName(ComponentClass);
    assertFragmentMap(getComponentName(ComponentClass), fragmentSpec);
    var fragments = {};
    for(var key in fragmentSpec)fragments[key] = getFragment(fragmentSpec[key]);
    var Container = createContainerWithFragments(ComponentClass, fragments);
    Container.displayName = containerName;
    function ForwardRef(props, ref) {
        var _queryRendererContext;
        var context = useContext(ReactRelayContext);
        !(context != null) && invariant(false);
        var queryRendererContext = useContext(ReactRelayQueryRendererContext);
        return /*#__PURE__*/ React.createElement(Container, (0, _extends2["default"])({}, props, {
            __relayContext: context,
            __rootIsQueryRenderer: (_queryRendererContext = queryRendererContext === null || queryRendererContext === void 0 ? void 0 : queryRendererContext.rootIsQueryRenderer) !== null && _queryRendererContext !== void 0 ? _queryRendererContext : false,
            componentRef: props.componentRef || ref
        }));
    }
    ForwardRef.displayName = containerName;
    var ForwardContainer = React.forwardRef(ForwardRef);
    return ForwardContainer;
}
module.exports = buildReactRelayContainer;

},{"aef4a255ec60fb2b":"590td","b34e40963b115137":"ehKSH","9e42a6a2b539f78e":"cm8z5","a4195b13ed1624dc":"7AyFT","415c0a8bc10f8597":"7NW2h","b204f94aa50ac707":"8JS6r","d798a86a29f44673":"e2sci","21aac5e17e156ef0":"ltHCL","eb347163a35ea7a3":"2IxFR"}],"cm8z5":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var invariant = require("c5623a04fc3ed769");
function assertFragmentMap(componentName, fragmentSpec) {
    !(fragmentSpec && (typeof fragmentSpec === "undefined" ? "undefined" : (0, _typeOf._)(fragmentSpec)) === 'object') && invariant(false);
    for(var key in fragmentSpec)if (fragmentSpec.hasOwnProperty(key)) {
        var fragment = fragmentSpec[key];
        !(fragment && ((typeof fragment === "undefined" ? "undefined" : (0, _typeOf._)(fragment)) === 'object' || typeof fragment === 'function')) && invariant(false);
    }
}
module.exports = assertFragmentMap;

},{"@swc/helpers/_/_type_of":"iFJdx","c5623a04fc3ed769":"e2sci"}],"7AyFT":[function(require,module,exports,__globalThis) {
'use strict';
function getComponentName(component) {
    return component.displayName || component.name || 'Component';
}
function getContainerName(Component) {
    return 'Relay(' + getComponentName(Component) + ')';
}
module.exports = {
    getComponentName: getComponentName,
    getContainerName: getContainerName
};

},{}],"8JS6r":[function(require,module,exports,__globalThis) {
'use strict';
var React = require("58bf434f385e0327");
module.exports = React.createContext({
    rootIsQueryRenderer: false
});

},{"58bf434f385e0327":"ltHCL"}],"cZlGo":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var isRelayEnvironment = require("fe19a6b7a040a0df");
var invariant = require("980e8201bfb23cac");
function assertRelayContext(relay) {
    !isRelayContext(relay) && invariant(false);
    return relay;
}
function isRelayContext(context) {
    return (typeof context === "undefined" ? "undefined" : (0, _typeOf._)(context)) === 'object' && context !== null && !Array.isArray(context) && isRelayEnvironment(context.environment);
}
module.exports = {
    assertRelayContext: assertRelayContext,
    isRelayContext: isRelayContext
};

},{"@swc/helpers/_/_type_of":"iFJdx","fe19a6b7a040a0df":"9w8gW","980e8201bfb23cac":"e2sci"}],"9w8gW":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
function isRelayEnvironment(environment) {
    return (typeof environment === "undefined" ? "undefined" : (0, _typeOf._)(environment)) === 'object' && environment !== null && typeof environment.check === 'function' && typeof environment.lookup === 'function' && typeof environment.retain === 'function' && typeof environment.execute === 'function' && typeof environment.subscribe === 'function';
}
module.exports = isRelayEnvironment;

},{"@swc/helpers/_/_type_of":"iFJdx"}],"33cI7":[function(require,module,exports,__globalThis) {
'use strict';
var ReactRelayContext = require("17bdd7b8097df87e");
var ReactRelayQueryRendererContext = require("f04c8fecd16407ea");
var areEqual = require("c903ee88a7ecd95c");
var React = require("6d3a8d9b0216b4de");
var _require = require("381bc9cc2d409827"), createOperationDescriptor = _require.createOperationDescriptor, deepFreeze = _require.deepFreeze, getRequest = _require.getRequest;
var useLayoutEffect = React.useLayoutEffect, useState = React.useState, useRef = React.useRef, useMemo = React.useMemo;
var queryRendererContext = {
    rootIsQueryRenderer: true
};
function useDeepCompare(value) {
    var latestValue = React.useRef(value);
    if (!areEqual(latestValue.current, value)) latestValue.current = value;
    return latestValue.current;
}
function ReactRelayLocalQueryRenderer(props) {
    var environment = props.environment, query = props.query, variables = props.variables, render = props.render;
    var latestVariables = useDeepCompare(variables);
    var operation = useMemo(function() {
        var request = getRequest(query);
        return createOperationDescriptor(request, latestVariables);
    }, [
        query,
        latestVariables
    ]);
    var relayContext = useMemo(function() {
        return {
            environment: environment
        };
    }, [
        environment
    ]);
    var dataRef = useRef(null);
    var _useState = useState(null), forceUpdate = _useState[1];
    var cleanupFnRef = useRef(null);
    var snapshot = useMemo(function() {
        environment.check(operation);
        var res = environment.lookup(operation.fragment);
        dataRef.current = res.data;
        var retainDisposable = environment.retain(operation);
        var subscribeDisposable = environment.subscribe(res, function(newSnapshot) {
            dataRef.current = newSnapshot.data;
            forceUpdate(dataRef.current);
        });
        var disposed = false;
        function nextCleanupFn() {
            if (!disposed) {
                disposed = true;
                cleanupFnRef.current = null;
                retainDisposable.dispose();
                subscribeDisposable.dispose();
            }
        }
        if (cleanupFnRef.current) cleanupFnRef.current();
        cleanupFnRef.current = nextCleanupFn;
        return res;
    }, [
        environment,
        operation
    ]);
    useLayoutEffect(function() {
        var cleanupFn = cleanupFnRef.current;
        return function() {
            cleanupFn && cleanupFn();
        };
    }, [
        snapshot
    ]);
    return /*#__PURE__*/ React.createElement(ReactRelayContext.Provider, {
        value: relayContext
    }, /*#__PURE__*/ React.createElement(ReactRelayQueryRendererContext.Provider, {
        value: queryRendererContext
    }, render({
        props: dataRef.current
    })));
}
module.exports = ReactRelayLocalQueryRenderer;

},{"17bdd7b8097df87e":"7NW2h","f04c8fecd16407ea":"8JS6r","c903ee88a7ecd95c":"eJLuG","6d3a8d9b0216b4de":"ltHCL","381bc9cc2d409827":"2IxFR"}],"eYnmn":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var _interopRequireDefault = require("6e6e7ed4afa8612d")["default"];
var _extends2 = _interopRequireDefault(require("918810cde5ad6fe0"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("3cd79c67fa980491"));
var _assertThisInitialized2 = _interopRequireDefault(require("cd7a7ac1ae1e3ffd"));
var _inheritsLoose2 = _interopRequireDefault(require("4cc5ead00e406c73"));
var _defineProperty2 = _interopRequireDefault(require("a237a7825c97b226"));
var _objectSpread3 = _interopRequireDefault(require("287756abeafdedc8"));
var _excluded = [
    "componentRef"
], _excluded2 = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
], _excluded3 = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
];
var buildReactRelayContainer = require("a8a738316d365cfb");
var getRootVariablesForFragments = require("91c455e00e6a2238");
var _require = require("43d7443ac887d1b3"), getComponentName = _require.getComponentName, getContainerName = _require.getContainerName;
var ReactRelayContext = require("f2b31ff1102bf794");
var ReactRelayQueryFetcher = require("74dd7b526c3f03e4");
var _require2 = require("3c07bd80314624a6"), assertRelayContext = _require2.assertRelayContext;
var areEqual = require("11f996824ce1804e");
var invariant = require("f7248b901251f99d");
var React = require("b12828d89a8ae0e3");
var _require3 = require("e57e7b0f63883a80"), ConnectionInterface = _require3.ConnectionInterface, Observable = _require3.Observable, RelayFeatureFlags = _require3.RelayFeatureFlags, createFragmentSpecResolver = _require3.createFragmentSpecResolver, createOperationDescriptor = _require3.createOperationDescriptor, getDataIDsFromObject = _require3.getDataIDsFromObject, getRequest = _require3.getRequest, getVariablesFromObject = _require3.getVariablesFromObject, isScalarAndEqual = _require3.isScalarAndEqual;
var warning = require("15dd5cec7e06344");
var FORWARD = 'forward';
function createGetConnectionFromProps(metadata) {
    var path = metadata.path;
    !path && invariant(false);
    return function(props) {
        var data = props[metadata.fragmentName];
        for(var i = 0; i < path.length; i++){
            if (!data || (typeof data === "undefined" ? "undefined" : (0, _typeOf._)(data)) !== 'object') return null;
            data = data[path[i]];
        }
        return data;
    };
}
function createGetFragmentVariables(metadata) {
    var countVariable = metadata.count;
    !countVariable && invariant(false);
    return function(prevVars, totalCount) {
        return (0, _objectSpread3["default"])((0, _objectSpread3["default"])({}, prevVars), {}, (0, _defineProperty2["default"])({}, countVariable, totalCount));
    };
}
function findConnectionMetadata(fragments) {
    var foundConnectionMetadata = null;
    var isRelayModern = false;
    for(var fragmentName in fragments){
        var fragment = fragments[fragmentName];
        var connectionMetadata = fragment.metadata && fragment.metadata.connection;
        if (fragment.metadata !== undefined) isRelayModern = true;
        if (connectionMetadata) {
            !(connectionMetadata.length === 1) && invariant(false);
            !!foundConnectionMetadata && invariant(false);
            foundConnectionMetadata = (0, _objectSpread3["default"])((0, _objectSpread3["default"])({}, connectionMetadata[0]), {}, {
                fragmentName: fragmentName
            });
        }
    }
    !(!isRelayModern || foundConnectionMetadata !== null) && invariant(false);
    return foundConnectionMetadata || {};
}
function toObserver(observerOrCallback) {
    return typeof observerOrCallback === 'function' ? {
        error: observerOrCallback,
        complete: observerOrCallback,
        unsubscribe: function unsubscribe(subscription) {
            typeof observerOrCallback === 'function' && observerOrCallback();
        }
    } : observerOrCallback || {};
}
function createContainerWithFragments(Component, fragments, connectionConfig) {
    var _class;
    var componentName = getComponentName(Component);
    var containerName = getContainerName(Component);
    var metadata = findConnectionMetadata(fragments);
    var getConnectionFromProps = connectionConfig.getConnectionFromProps || createGetConnectionFromProps(metadata);
    var direction = connectionConfig.direction || metadata.direction;
    !direction && invariant(false);
    var getFragmentVariables = connectionConfig.getFragmentVariables || createGetFragmentVariables(metadata);
    return _class = /*#__PURE__*/ function(_React$Component) {
        (0, _inheritsLoose2["default"])(_class, _React$Component);
        function _class(props) {
            var _props$__rootIsQueryR, _this;
            _this = _React$Component.call(this, props) || this;
            (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
                _this.setState({
                    data: _this._resolver.resolve()
                });
            });
            (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_hasMore", function() {
                var connectionData = _this._getConnectionData();
                return !!(connectionData && connectionData.hasMore && connectionData.cursor);
            });
            (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_isLoading", function() {
                return !!_this._refetchSubscription;
            });
            (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_refetchConnection", function(totalCount, observerOrCallback, refetchVariables) {
                if (!_this._canFetchPage('refetchConnection')) return {
                    dispose: function dispose() {}
                };
                _this._refetchVariables = refetchVariables;
                var paginatingVariables = {
                    count: totalCount,
                    cursor: null,
                    totalCount: totalCount
                };
                var fetch = _this._fetchPage(paginatingVariables, toObserver(observerOrCallback), {
                    force: true
                });
                return {
                    dispose: fetch.unsubscribe
                };
            });
            (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_loadMore", function(pageSize, observerOrCallback, options) {
                if (!_this._canFetchPage('loadMore')) return {
                    dispose: function dispose() {}
                };
                var observer = toObserver(observerOrCallback);
                var connectionData = _this._getConnectionData();
                if (!connectionData) {
                    Observable.create(function(sink) {
                        return sink.complete();
                    }).subscribe(observer);
                    return null;
                }
                var totalCount = connectionData.edgeCount + pageSize;
                if (options && options.force) return _this._refetchConnection(totalCount, observerOrCallback);
                var _ConnectionInterface$ = ConnectionInterface.get(), END_CURSOR = _ConnectionInterface$.END_CURSOR, START_CURSOR = _ConnectionInterface$.START_CURSOR;
                var cursor = connectionData.cursor;
                var paginatingVariables = {
                    count: pageSize,
                    cursor: cursor,
                    totalCount: totalCount
                };
                var fetch = _this._fetchPage(paginatingVariables, observer, options);
                return {
                    dispose: fetch.unsubscribe
                };
            });
            var relayContext = assertRelayContext(props.__relayContext);
            var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
            _this._isARequestInFlight = false;
            _this._refetchSubscription = null;
            _this._refetchVariables = null;
            if (RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) _this._resolver = createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
            else _this._resolver = createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer, _this._handleFragmentDataUpdate);
            _this.state = {
                data: _this._resolver.resolve(),
                prevContext: relayContext,
                contextForChildren: relayContext,
                relayProp: _this._buildRelayProp(relayContext),
                resolverGeneration: 0
            };
            _this._isUnmounted = false;
            _this._hasFetched = false;
            return _this;
        }
        var _proto = _class.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this._isUnmounted = false;
            if (RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if (RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) {
                if (prevState.resolverGeneration !== this.state.resolverGeneration) this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
                else this._rerenderIfStoreHasChanged();
            }
        };
        _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
            var _this2 = this;
            var _nextProps$__rootIsQu;
            var relayContext = assertRelayContext(nextProps.__relayContext);
            var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
            var prevIDs = getDataIDsFromObject(fragments, this.props);
            var nextIDs = getDataIDsFromObject(fragments, nextProps);
            var prevRootVariables = getRootVariablesForFragments(fragments, this.props);
            var nextRootVariables = getRootVariablesForFragments(fragments, nextProps);
            if (relayContext.environment !== this.state.prevContext.environment || !areEqual(prevRootVariables, nextRootVariables) || !areEqual(prevIDs, nextIDs)) {
                this._cleanup();
                if (RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) this._resolver = createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
                else this._resolver = createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer, this._handleFragmentDataUpdate);
                this.setState(function(prevState) {
                    return {
                        prevContext: relayContext,
                        contextForChildren: relayContext,
                        relayProp: _this2._buildRelayProp(relayContext),
                        resolverGeneration: prevState.resolverGeneration + 1
                    };
                });
            } else if (!this._hasFetched) this._resolver.setProps(nextProps);
            var data = this._resolver.resolve();
            if (data !== this.state.data) this.setState({
                data: data
            });
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this._isUnmounted = true;
            this._cleanup();
        };
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            if (nextState.data !== this.state.data || nextState.relayProp !== this.state.relayProp || nextState.resolverGeneration !== this.state.resolverGeneration) return true;
            var keys = Object.keys(nextProps);
            for(var ii = 0; ii < keys.length; ii++){
                var key = keys[ii];
                if (key === '__relayContext') {
                    if (nextState.prevContext.environment !== this.state.prevContext.environment) return true;
                } else {
                    if (!fragments.hasOwnProperty(key) && !isScalarAndEqual(nextProps[key], this.props[key])) return true;
                }
            }
            return false;
        };
        _proto._buildRelayProp = function _buildRelayProp(relayContext) {
            return {
                hasMore: this._hasMore,
                isLoading: this._isLoading,
                loadMore: this._loadMore,
                refetchConnection: this._refetchConnection,
                environment: relayContext.environment
            };
        };
        _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
            var data = this.state.data;
            var maybeNewData = this._resolver.resolve();
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
            var data = this.state.data;
            var maybeNewData = this._resolver.resolve();
            this._resolver.setCallback(this.props, this._handleFragmentDataUpdate);
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._getConnectionData = function _getConnectionData() {
            var _this$props = this.props, _ = _this$props.componentRef, restProps = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, _excluded);
            var props = (0, _objectSpread3["default"])((0, _objectSpread3["default"])({}, restProps), this.state.data);
            var connectionData = getConnectionFromProps(props);
            if (connectionData == null) return null;
            var _ConnectionInterface$2 = ConnectionInterface.get(), EDGES = _ConnectionInterface$2.EDGES, PAGE_INFO = _ConnectionInterface$2.PAGE_INFO, HAS_NEXT_PAGE = _ConnectionInterface$2.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$2.HAS_PREV_PAGE, END_CURSOR = _ConnectionInterface$2.END_CURSOR, START_CURSOR = _ConnectionInterface$2.START_CURSOR;
            !((typeof connectionData === "undefined" ? "undefined" : (0, _typeOf._)(connectionData)) === 'object') && invariant(false);
            var edges = connectionData[EDGES];
            var pageInfo = connectionData[PAGE_INFO];
            if (edges == null || pageInfo == null) return null;
            !Array.isArray(edges) && invariant(false);
            !((typeof pageInfo === "undefined" ? "undefined" : (0, _typeOf._)(pageInfo)) === 'object') && invariant(false);
            var hasMore = direction === FORWARD ? pageInfo[HAS_NEXT_PAGE] : pageInfo[HAS_PREV_PAGE];
            var cursor = direction === FORWARD ? pageInfo[END_CURSOR] : pageInfo[START_CURSOR];
            if (typeof hasMore !== 'boolean' || edges.length !== 0 && typeof cursor === 'undefined') return null;
            return {
                cursor: cursor,
                edgeCount: edges.length,
                hasMore: hasMore
            };
        };
        _proto._getQueryFetcher = function _getQueryFetcher() {
            if (!this._queryFetcher) this._queryFetcher = new ReactRelayQueryFetcher();
            return this._queryFetcher;
        };
        _proto._canFetchPage = function _canFetchPage(method) {
            if (this._isUnmounted) return false;
            return true;
        };
        _proto._fetchPage = function _fetchPage(paginatingVariables, observer, options) {
            var _this3 = this;
            var _assertRelayContext = assertRelayContext(this.props.__relayContext), environment = _assertRelayContext.environment;
            var _this$props2 = this.props, _ = _this$props2.componentRef, __relayContext = _this$props2.__relayContext, __rootIsQueryRenderer = _this$props2.__rootIsQueryRenderer, restProps = (0, _objectWithoutPropertiesLoose2["default"])(_this$props2, _excluded2);
            var props = (0, _objectSpread3["default"])((0, _objectSpread3["default"])({}, restProps), this.state.data);
            var fragmentVariables;
            var rootVariables = getRootVariablesForFragments(fragments, restProps);
            fragmentVariables = getVariablesFromObject(fragments, restProps);
            fragmentVariables = (0, _objectSpread3["default"])((0, _objectSpread3["default"])((0, _objectSpread3["default"])({}, rootVariables), fragmentVariables), this._refetchVariables);
            var fetchVariables = connectionConfig.getVariables(props, {
                count: paginatingVariables.count,
                cursor: paginatingVariables.cursor
            }, fragmentVariables);
            !((typeof fetchVariables === "undefined" ? "undefined" : (0, _typeOf._)(fetchVariables)) === 'object' && fetchVariables !== null) && invariant(false);
            fetchVariables = (0, _objectSpread3["default"])((0, _objectSpread3["default"])({}, fetchVariables), this._refetchVariables);
            fragmentVariables = (0, _objectSpread3["default"])((0, _objectSpread3["default"])({}, fetchVariables), fragmentVariables);
            var cacheConfig = options ? {
                force: !!options.force
            } : undefined;
            if (cacheConfig != null && (options === null || options === void 0 ? void 0 : options.metadata) != null) cacheConfig.metadata = options === null || options === void 0 ? void 0 : options.metadata;
            var request = getRequest(connectionConfig.query);
            var operation = createOperationDescriptor(request, fetchVariables, cacheConfig);
            var refetchSubscription = null;
            if (this._refetchSubscription) this._refetchSubscription.unsubscribe();
            this._hasFetched = true;
            var onNext = function onNext(payload, complete) {
                var prevData = _this3._resolver.resolve();
                _this3._resolver.setVariables(getFragmentVariables(fragmentVariables, paginatingVariables.totalCount), operation.request.node);
                var nextData = _this3._resolver.resolve();
                if (!areEqual(prevData, nextData)) _this3.setState({
                    data: nextData,
                    contextForChildren: {
                        environment: _this3.props.__relayContext.environment
                    }
                }, complete);
                else complete();
            };
            var cleanup = function cleanup() {
                if (_this3._refetchSubscription === refetchSubscription) {
                    _this3._refetchSubscription = null;
                    _this3._isARequestInFlight = false;
                }
            };
            this._isARequestInFlight = true;
            refetchSubscription = this._getQueryFetcher().execute({
                environment: environment,
                operation: operation,
                preservePreviousReferences: true
            }).mergeMap(function(payload) {
                return Observable.create(function(sink) {
                    onNext(payload, function() {
                        sink.next();
                        sink.complete();
                    });
                });
            })["do"]({
                error: cleanup,
                complete: cleanup,
                unsubscribe: cleanup
            }).subscribe(observer || {});
            this._refetchSubscription = this._isARequestInFlight ? refetchSubscription : null;
            return refetchSubscription;
        };
        _proto._cleanup = function _cleanup() {
            this._resolver.dispose();
            this._refetchVariables = null;
            this._hasFetched = false;
            if (this._refetchSubscription) {
                this._refetchSubscription.unsubscribe();
                this._refetchSubscription = null;
                this._isARequestInFlight = false;
            }
            if (this._queryFetcher) this._queryFetcher.dispose();
        };
        _proto.render = function render() {
            var _this$props3 = this.props, componentRef = _this$props3.componentRef, __relayContext = _this$props3.__relayContext, __rootIsQueryRenderer = _this$props3.__rootIsQueryRenderer, props = (0, _objectWithoutPropertiesLoose2["default"])(_this$props3, _excluded3);
            return /*#__PURE__*/ React.createElement(ReactRelayContext.Provider, {
                value: this.state.contextForChildren
            }, /*#__PURE__*/ React.createElement(Component, (0, _extends2["default"])({}, props, this.state.data, {
                ref: componentRef,
                relay: this.state.relayProp
            })));
        };
        return _class;
    }(React.Component), (0, _defineProperty2["default"])(_class, "displayName", containerName), _class;
}
function createContainer(Component, fragmentSpec, connectionConfig) {
    return buildReactRelayContainer(Component, fragmentSpec, function(ComponentClass, fragments) {
        return createContainerWithFragments(ComponentClass, fragments, connectionConfig);
    });
}
module.exports = {
    createContainer: createContainer
};

},{"@swc/helpers/_/_type_of":"iFJdx","6e6e7ed4afa8612d":"590td","918810cde5ad6fe0":"ehKSH","3cd79c67fa980491":"fkx57","cd7a7ac1ae1e3ffd":"k1uP3","4cc5ead00e406c73":"idPlQ","a237a7825c97b226":"2paQ8","287756abeafdedc8":"2Bj1n","a8a738316d365cfb":"hPnUw","91c455e00e6a2238":"gDiox","43d7443ac887d1b3":"7AyFT","f2b31ff1102bf794":"7NW2h","74dd7b526c3f03e4":"fhl4l","3c07bd80314624a6":"cZlGo","11f996824ce1804e":"eJLuG","f7248b901251f99d":"e2sci","b12828d89a8ae0e3":"ltHCL","e57e7b0f63883a80":"2IxFR","15dd5cec7e06344":"j64TH"}],"gDiox":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("6ce961c058406860")["default"];
var _objectSpread2 = _interopRequireDefault(require("6495af86b903b4dc"));
var _require = require("c43719be5e3ebafb"), getSelector = _require.getSelector;
function getRootVariablesForFragments(fragments, props) {
    var rootVariables = {};
    Object.keys(fragments).forEach(function(key) {
        var _selector$selectors$, _selector$selectors$2, _selector$owner$varia;
        var fragmentNode = fragments[key];
        var fragmentRef = props[key];
        var selector = getSelector(fragmentNode, fragmentRef);
        var fragmentOwnerVariables = selector != null && selector.kind === 'PluralReaderSelector' ? (_selector$selectors$ = (_selector$selectors$2 = selector.selectors[0]) === null || _selector$selectors$2 === void 0 ? void 0 : _selector$selectors$2.owner.variables) !== null && _selector$selectors$ !== void 0 ? _selector$selectors$ : {} : (_selector$owner$varia = selector === null || selector === void 0 ? void 0 : selector.owner.variables) !== null && _selector$owner$varia !== void 0 ? _selector$owner$varia : {};
        rootVariables = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, rootVariables), fragmentOwnerVariables);
    });
    return rootVariables;
}
module.exports = getRootVariablesForFragments;

},{"6ce961c058406860":"590td","6495af86b903b4dc":"2Bj1n","c43719be5e3ebafb":"2IxFR"}],"fhl4l":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("ce346cbd60d80779")["default"];
var _defineProperty2 = _interopRequireDefault(require("93ac89c2e9f81987"));
var invariant = require("c26a5bef78081a84");
var _require = require("63c9940562becb3f"), fetchQuery = _require.__internal.fetchQuery, createOperationDescriptor = _require.createOperationDescriptor, isRelayModernEnvironment = _require.isRelayModernEnvironment;
var ReactRelayQueryFetcher = /*#__PURE__*/ function() {
    function ReactRelayQueryFetcher(args) {
        (0, _defineProperty2["default"])(this, "_selectionReferences", []);
        (0, _defineProperty2["default"])(this, "_didFetchFinish", false);
        if (args != null) {
            this._cacheSelectionReference = args.cacheSelectionReference;
            this._selectionReferences = args.selectionReferences;
        }
    }
    var _proto = ReactRelayQueryFetcher.prototype;
    _proto.getSelectionReferences = function getSelectionReferences() {
        return {
            cacheSelectionReference: this._cacheSelectionReference,
            selectionReferences: this._selectionReferences
        };
    };
    _proto.lookupInStore = function lookupInStore(environment, operation, fetchPolicy) {
        if (fetchPolicy === 'store-and-network' || fetchPolicy === 'store-or-network') {
            if (environment.check(operation).status === 'available') {
                this._retainCachedOperation(environment, operation);
                return environment.lookup(operation.fragment);
            }
        }
        return null;
    };
    _proto.getFetchResult = function getFetchResult() {
        if (this._didFetchFinish) {
            if (this._error != null) return {
                error: this._error
            };
            else if (this._snapshot != null) return {
                snapshot: this._snapshot
            };
        } else return null;
    };
    _proto.execute = function execute(_ref) {
        var _this = this;
        var environment = _ref.environment, operation = _ref.operation, _ref$preservePrevious = _ref.preservePreviousReferences, preservePreviousReferences = _ref$preservePrevious === void 0 ? false : _ref$preservePrevious;
        var reference = environment.retain(operation);
        var error = function error() {
            _this._selectionReferences = _this._selectionReferences.concat(reference);
        };
        var complete = function complete() {
            if (!preservePreviousReferences) _this.disposeSelectionReferences();
            _this._selectionReferences = _this._selectionReferences.concat(reference);
        };
        var unsubscribe = function unsubscribe() {
            _this._selectionReferences = _this._selectionReferences.concat(reference);
        };
        if (!isRelayModernEnvironment(environment)) return environment.execute({
            operation: operation
        })["do"]({
            error: error,
            complete: complete,
            unsubscribe: unsubscribe
        });
        return fetchQuery(environment, operation)["do"]({
            error: error,
            complete: complete,
            unsubscribe: unsubscribe
        });
    };
    _proto.setOnDataChange = function setOnDataChange(onDataChange) {
        !this._fetchOptions && invariant(false);
        if (typeof onDataChange === 'function') {
            this._fetchOptions.onDataChangeCallbacks = this._fetchOptions.onDataChangeCallbacks || [];
            this._fetchOptions.onDataChangeCallbacks.push(onDataChange);
            if (this._didFetchFinish) {
                if (this._error != null) onDataChange({
                    error: this._error
                });
                else if (this._snapshot != null) onDataChange({
                    snapshot: this._snapshot
                });
            }
        }
    };
    _proto.fetch = function fetch(fetchOptions, cacheConfigOverride) {
        var _this2 = this;
        var environment = fetchOptions.environment, operation = fetchOptions.operation, onDataChange = fetchOptions.onDataChange;
        var fetchHasReturned = false;
        var _error;
        this.disposeRequest();
        var oldOnDataChangeCallbacks = this._fetchOptions && this._fetchOptions.onDataChangeCallbacks;
        this._fetchOptions = {
            environment: environment,
            onDataChangeCallbacks: oldOnDataChangeCallbacks || [],
            operation: operation
        };
        if (onDataChange && this._fetchOptions.onDataChangeCallbacks.indexOf(onDataChange) === -1) this._fetchOptions.onDataChangeCallbacks.push(onDataChange);
        var operationOverride = cacheConfigOverride ? createOperationDescriptor(operation.request.node, operation.request.variables, cacheConfigOverride) : operation;
        var request = this.execute({
            environment: environment,
            operation: operationOverride
        })["finally"](function() {
            _this2._pendingRequest = null;
        }).subscribe({
            next: function next() {
                _this2._didFetchFinish = true;
                _this2._error = null;
                _this2._onQueryDataAvailable({
                    notifyFirstResult: fetchHasReturned
                });
            },
            error: function error(err) {
                _this2._didFetchFinish = true;
                _this2._error = err;
                _this2._snapshot = null;
                var onDataChangeCallbacks = _this2._fetchOptions && _this2._fetchOptions.onDataChangeCallbacks;
                if (fetchHasReturned) {
                    if (onDataChangeCallbacks) onDataChangeCallbacks.forEach(function(onDataChange) {
                        onDataChange({
                            error: err
                        });
                    });
                } else _error = err;
            }
        });
        this._pendingRequest = {
            dispose: function dispose() {
                request.unsubscribe();
            }
        };
        fetchHasReturned = true;
        if (_error) throw _error;
        return this._snapshot;
    };
    _proto.retry = function retry(cacheConfigOverride) {
        !this._fetchOptions && invariant(false);
        return this.fetch({
            environment: this._fetchOptions.environment,
            operation: this._fetchOptions.operation,
            onDataChange: null
        }, cacheConfigOverride);
    };
    _proto.dispose = function dispose() {
        this.disposeRequest();
        this.disposeSelectionReferences();
    };
    _proto.disposeRequest = function disposeRequest() {
        this._error = null;
        this._snapshot = null;
        if (this._pendingRequest) this._pendingRequest.dispose();
        if (this._rootSubscription) {
            this._rootSubscription.dispose();
            this._rootSubscription = null;
        }
    };
    _proto._retainCachedOperation = function _retainCachedOperation(environment, operation) {
        this._disposeCacheSelectionReference();
        this._cacheSelectionReference = environment.retain(operation);
    };
    _proto._disposeCacheSelectionReference = function _disposeCacheSelectionReference() {
        this._cacheSelectionReference && this._cacheSelectionReference.dispose();
        this._cacheSelectionReference = null;
    };
    _proto.disposeSelectionReferences = function disposeSelectionReferences() {
        this._disposeCacheSelectionReference();
        this._selectionReferences.forEach(function(r) {
            return r.dispose();
        });
        this._selectionReferences = [];
    };
    _proto._onQueryDataAvailable = function _onQueryDataAvailable(_ref2) {
        var _this3 = this;
        var notifyFirstResult = _ref2.notifyFirstResult;
        !this._fetchOptions && invariant(false);
        var _this$_fetchOptions = this._fetchOptions, environment = _this$_fetchOptions.environment, onDataChangeCallbacks = _this$_fetchOptions.onDataChangeCallbacks, operation = _this$_fetchOptions.operation;
        if (this._snapshot) return;
        this._snapshot = environment.lookup(operation.fragment);
        this._rootSubscription = environment.subscribe(this._snapshot, function(snapshot) {
            if (_this3._fetchOptions != null) {
                var maybeNewOnDataChangeCallbacks = _this3._fetchOptions.onDataChangeCallbacks;
                if (Array.isArray(maybeNewOnDataChangeCallbacks)) maybeNewOnDataChangeCallbacks.forEach(function(onDataChange) {
                    return onDataChange({
                        snapshot: snapshot
                    });
                });
            }
        });
        if (this._snapshot && notifyFirstResult && Array.isArray(onDataChangeCallbacks)) {
            var snapshot = this._snapshot;
            onDataChangeCallbacks.forEach(function(onDataChange) {
                return onDataChange({
                    snapshot: snapshot
                });
            });
        }
    };
    return ReactRelayQueryFetcher;
}();
module.exports = ReactRelayQueryFetcher;

},{"ce346cbd60d80779":"590td","93ac89c2e9f81987":"2paQ8","c26a5bef78081a84":"e2sci","63c9940562becb3f":"2IxFR"}],"l9rE8":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("b334581f34ed6b73")["default"];
var _objectSpread2 = _interopRequireDefault(require("a76878f589512f22"));
var _assertThisInitialized2 = _interopRequireDefault(require("87ef6eb737873255"));
var _inheritsLoose2 = _interopRequireDefault(require("3f89edd1050ec528"));
var _defineProperty2 = _interopRequireDefault(require("61b65da76b6d980"));
var ReactRelayContext = require("c77cf28e5778305d");
var ReactRelayQueryFetcher = require("4580c91be56cd479");
var ReactRelayQueryRendererContext = require("a20152de3a9b7ced");
var areEqual = require("45e2a2a1be611e61");
var React = require("3ef56b065f8f54ba");
var _require = require("bef4ac506cb0ba09"), createOperationDescriptor = _require.createOperationDescriptor, deepFreeze = _require.deepFreeze, getRequest = _require.getRequest;
var requestCache = {};
var queryRendererContext = {
    rootIsQueryRenderer: true
};
var ReactRelayQueryRenderer = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLoose2["default"])(ReactRelayQueryRenderer, _React$Component);
    function ReactRelayQueryRenderer(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleDataChange", function(params) {
            var error = params.error == null ? null : params.error;
            var snapshot = params.snapshot == null ? null : params.snapshot;
            _this.setState(function(prevState) {
                var prevRequestCacheKey = prevState.requestCacheKey;
                if (prevRequestCacheKey) delete requestCache[prevRequestCacheKey];
                if (snapshot === prevState.snapshot && error === prevState.error) return null;
                return {
                    renderProps: getRenderProps(error, snapshot, prevState.queryFetcher, prevState.retryCallbacks),
                    snapshot: snapshot,
                    requestCacheKey: null
                };
            });
        });
        var retryCallbacks = {
            handleDataChange: null,
            handleRetryAfterError: null
        };
        var queryFetcher;
        var requestCacheKey;
        if (props.query) {
            var query = props.query;
            var request = getRequest(query);
            requestCacheKey = getRequestCacheKey(request.params, props.variables);
            queryFetcher = requestCache[requestCacheKey] ? requestCache[requestCacheKey].queryFetcher : new ReactRelayQueryFetcher();
        } else queryFetcher = new ReactRelayQueryFetcher();
        _this._maybeHiddenOrFastRefresh = false;
        _this.state = (0, _objectSpread2["default"])({
            prevPropsEnvironment: props.environment,
            prevPropsVariables: props.variables,
            prevQuery: props.query,
            queryFetcher: queryFetcher,
            retryCallbacks: retryCallbacks
        }, fetchQueryAndComputeStateFromProps(props, queryFetcher, retryCallbacks, requestCacheKey));
        return _this;
    }
    ReactRelayQueryRenderer.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
        if (prevState.prevQuery !== nextProps.query || prevState.prevPropsEnvironment !== nextProps.environment || !areEqual(prevState.prevPropsVariables, nextProps.variables)) return resetQueryStateForUpdate(nextProps, prevState);
        return null;
    };
    var _proto = ReactRelayQueryRenderer.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        if (this._maybeHiddenOrFastRefresh === true) {
            this._maybeHiddenOrFastRefresh = false;
            this.setState(function(prevState) {
                var newState = resetQueryStateForUpdate(_this2.props, prevState);
                var requestCacheKey = newState.requestCacheKey, queryFetcher = newState.queryFetcher;
                if (requestCacheKey != null && requestCache[requestCacheKey] != null) queryFetcher.setOnDataChange(_this2._handleDataChange);
                return newState;
            });
            return;
        }
        var _this$state = this.state, retryCallbacks = _this$state.retryCallbacks, queryFetcher = _this$state.queryFetcher, requestCacheKey = _this$state.requestCacheKey;
        if (requestCacheKey) delete requestCache[requestCacheKey];
        retryCallbacks.handleDataChange = this._handleDataChange;
        retryCallbacks.handleRetryAfterError = function(error) {
            return _this2.setState(function(prevState) {
                var prevRequestCacheKey = prevState.requestCacheKey;
                if (prevRequestCacheKey) delete requestCache[prevRequestCacheKey];
                return {
                    renderProps: getLoadingRenderProps(),
                    requestCacheKey: null
                };
            });
        };
        if (this.props.query) queryFetcher.setOnDataChange(this._handleDataChange);
    };
    _proto.componentDidUpdate = function componentDidUpdate(_prevProps, prevState) {
        var _this$state2 = this.state, queryFetcher = _this$state2.queryFetcher, requestCacheKey = _this$state2.requestCacheKey;
        if (requestCacheKey) {
            delete requestCache[requestCacheKey];
            delete this.state.requestCacheKey;
        }
        if (this.props.query && queryFetcher !== prevState.queryFetcher) queryFetcher.setOnDataChange(this._handleDataChange);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.state.queryFetcher.dispose();
        this._maybeHiddenOrFastRefresh = true;
    };
    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        return nextProps.render !== this.props.render || nextState.renderProps !== this.state.renderProps;
    };
    _proto.render = function render() {
        var _this$state3 = this.state, renderProps = _this$state3.renderProps, relayContext = _this$state3.relayContext;
        return /*#__PURE__*/ React.createElement(ReactRelayContext.Provider, {
            value: relayContext
        }, /*#__PURE__*/ React.createElement(ReactRelayQueryRendererContext.Provider, {
            value: queryRendererContext
        }, this.props.render(renderProps)));
    };
    return ReactRelayQueryRenderer;
}(React.Component);
function getLoadingRenderProps() {
    return {
        error: null,
        props: null,
        retry: null
    };
}
function getEmptyRenderProps() {
    return {
        error: null,
        props: {},
        retry: null
    };
}
function getRenderProps(error, snapshot, queryFetcher, retryCallbacks) {
    return {
        error: error ? error : null,
        props: snapshot ? snapshot.data : null,
        retry: function retry(cacheConfigOverride) {
            var syncSnapshot = queryFetcher.retry(cacheConfigOverride);
            if (syncSnapshot && typeof retryCallbacks.handleDataChange === 'function') retryCallbacks.handleDataChange({
                snapshot: syncSnapshot
            });
            else if (error && typeof retryCallbacks.handleRetryAfterError === 'function') retryCallbacks.handleRetryAfterError(error);
        }
    };
}
function getRequestCacheKey(request, variables) {
    return JSON.stringify({
        id: request.cacheID ? request.cacheID : request.id,
        variables: variables
    });
}
function resetQueryStateForUpdate(props, prevState) {
    var query = props.query;
    var prevSelectionReferences = prevState.queryFetcher.getSelectionReferences();
    prevState.queryFetcher.disposeRequest();
    var queryFetcher;
    if (query) {
        var request = getRequest(query);
        var requestCacheKey = getRequestCacheKey(request.params, props.variables);
        queryFetcher = requestCache[requestCacheKey] ? requestCache[requestCacheKey].queryFetcher : new ReactRelayQueryFetcher(prevSelectionReferences);
    } else queryFetcher = new ReactRelayQueryFetcher(prevSelectionReferences);
    return (0, _objectSpread2["default"])({
        prevQuery: props.query,
        prevPropsEnvironment: props.environment,
        prevPropsVariables: props.variables,
        queryFetcher: queryFetcher
    }, fetchQueryAndComputeStateFromProps(props, queryFetcher, prevState.retryCallbacks));
}
function fetchQueryAndComputeStateFromProps(props, queryFetcher, retryCallbacks, requestCacheKey) {
    var environment = props.environment, query = props.query, variables = props.variables, cacheConfig = props.cacheConfig;
    var genericEnvironment = environment;
    if (query) {
        var request = getRequest(query);
        var operation = createOperationDescriptor(request, variables, cacheConfig);
        var relayContext = {
            environment: genericEnvironment
        };
        if (typeof requestCacheKey === 'string' && requestCache[requestCacheKey]) {
            var snapshot = requestCache[requestCacheKey].snapshot;
            if (snapshot) return {
                error: null,
                relayContext: relayContext,
                renderProps: getRenderProps(null, snapshot, queryFetcher, retryCallbacks),
                snapshot: snapshot,
                requestCacheKey: requestCacheKey
            };
            else return {
                error: null,
                relayContext: relayContext,
                renderProps: getLoadingRenderProps(),
                snapshot: null,
                requestCacheKey: requestCacheKey
            };
        }
        try {
            var storeSnapshot = queryFetcher.lookupInStore(genericEnvironment, operation, props.fetchPolicy);
            var querySnapshot = queryFetcher.fetch({
                environment: genericEnvironment,
                onDataChange: null,
                operation: operation
            });
            var _snapshot = querySnapshot || storeSnapshot;
            requestCacheKey = requestCacheKey || getRequestCacheKey(request.params, props.variables);
            requestCache[requestCacheKey] = {
                queryFetcher: queryFetcher,
                snapshot: _snapshot
            };
            if (!_snapshot) return {
                error: null,
                relayContext: relayContext,
                renderProps: getLoadingRenderProps(),
                snapshot: null,
                requestCacheKey: requestCacheKey
            };
            return {
                error: null,
                relayContext: relayContext,
                renderProps: getRenderProps(null, _snapshot, queryFetcher, retryCallbacks),
                snapshot: _snapshot,
                requestCacheKey: requestCacheKey
            };
        } catch (error) {
            return {
                error: error,
                relayContext: relayContext,
                renderProps: getRenderProps(error, null, queryFetcher, retryCallbacks),
                snapshot: null,
                requestCacheKey: requestCacheKey
            };
        }
    } else {
        queryFetcher.dispose();
        var _relayContext = {
            environment: genericEnvironment
        };
        return {
            error: null,
            relayContext: _relayContext,
            renderProps: getEmptyRenderProps(),
            requestCacheKey: null
        };
    }
}
module.exports = ReactRelayQueryRenderer;

},{"b334581f34ed6b73":"590td","a76878f589512f22":"2Bj1n","87ef6eb737873255":"k1uP3","3f89edd1050ec528":"idPlQ","61b65da76b6d980":"2paQ8","c77cf28e5778305d":"7NW2h","4580c91be56cd479":"fhl4l","a20152de3a9b7ced":"8JS6r","45e2a2a1be611e61":"eJLuG","3ef56b065f8f54ba":"ltHCL","bef4ac506cb0ba09":"2IxFR"}],"1nKeO":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("875aaacd52671239")["default"];
var _extends2 = _interopRequireDefault(require("92541e3bf3b608dd"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("4c184c233b5617e8"));
var _objectSpread2 = _interopRequireDefault(require("ea5d91145532619f"));
var _assertThisInitialized2 = _interopRequireDefault(require("ad66ac1668305503"));
var _inheritsLoose2 = _interopRequireDefault(require("ed120e4e31838a12"));
var _defineProperty2 = _interopRequireDefault(require("b910ba6d3de581bb"));
var _excluded = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
];
var buildReactRelayContainer = require("7a9ac1d4dd3ad3fe");
var getRootVariablesForFragments = require("1150ef319ca0edf6");
var _require = require("410ee9383f755285"), getContainerName = _require.getContainerName;
var ReactRelayContext = require("a4b49dd8d95541cf");
var ReactRelayQueryFetcher = require("4cb643176406cbed");
var _require2 = require("5e074e551e87a797"), assertRelayContext = _require2.assertRelayContext;
var areEqual = require("41e9e65cf6864888");
var React = require("f4f24e93fcda9e07");
var _require3 = require("d4cd814611456f68"), Observable = _require3.Observable, createFragmentSpecResolver = _require3.createFragmentSpecResolver, createOperationDescriptor = _require3.createOperationDescriptor, getDataIDsFromObject = _require3.getDataIDsFromObject, getRequest = _require3.getRequest, getVariablesFromObject = _require3.getVariablesFromObject, isScalarAndEqual = _require3.isScalarAndEqual;
var warning = require("6225b0ef408789c3");
function createContainerWithFragments(Component, fragments, taggedNode) {
    var _class;
    var containerName = getContainerName(Component);
    return _class = /*#__PURE__*/ function(_React$Component) {
        (0, _inheritsLoose2["default"])(_class, _React$Component);
        function _class(props) {
            var _props$__rootIsQueryR, _this;
            _this = _React$Component.call(this, props) || this;
            (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
                var resolverFromThisUpdate = _this.state.resolver;
                _this.setState(function(updatedState) {
                    return resolverFromThisUpdate === updatedState.resolver ? {
                        data: updatedState.resolver.resolve()
                    } : null;
                });
            });
            (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_refetch", function(refetchVariables, renderVariables, observerOrCallback, options) {
                if (_this._isUnmounted) return {
                    dispose: function dispose() {}
                };
                var _assertRelayContext = assertRelayContext(_this.props.__relayContext), environment = _assertRelayContext.environment;
                var rootVariables = getRootVariablesForFragments(fragments, _this.props);
                var fetchVariables = typeof refetchVariables === 'function' ? refetchVariables(_this._getFragmentVariables()) : refetchVariables;
                fetchVariables = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, rootVariables), fetchVariables);
                var fragmentVariables = renderVariables ? (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, fetchVariables), renderVariables) : fetchVariables;
                var cacheConfig = options ? {
                    force: !!options.force
                } : undefined;
                if (cacheConfig != null && (options === null || options === void 0 ? void 0 : options.metadata) != null) cacheConfig.metadata = options === null || options === void 0 ? void 0 : options.metadata;
                var observer = typeof observerOrCallback === 'function' ? {
                    next: observerOrCallback,
                    error: observerOrCallback
                } : observerOrCallback || {};
                var query = getRequest(taggedNode);
                var operation = createOperationDescriptor(query, fetchVariables, cacheConfig);
                _this.state.localVariables = fetchVariables;
                _this._refetchSubscription && _this._refetchSubscription.unsubscribe();
                var refetchSubscription;
                var storeSnapshot = _this._getQueryFetcher().lookupInStore(environment, operation, options === null || options === void 0 ? void 0 : options.fetchPolicy);
                if (storeSnapshot != null) {
                    _this.state.resolver.setVariables(fragmentVariables, operation.request.node);
                    _this.setState(function(latestState) {
                        return {
                            data: latestState.resolver.resolve(),
                            contextForChildren: {
                                environment: _this.props.__relayContext.environment
                            }
                        };
                    }, function() {
                        observer.next && observer.next();
                        observer.complete && observer.complete();
                    });
                    return {
                        dispose: function dispose() {}
                    };
                }
                _this._getQueryFetcher().execute({
                    environment: environment,
                    operation: operation,
                    preservePreviousReferences: true
                }).mergeMap(function(response) {
                    _this.state.resolver.setVariables(fragmentVariables, operation.request.node);
                    return Observable.create(function(sink) {
                        return _this.setState(function(latestState) {
                            return {
                                data: latestState.resolver.resolve(),
                                contextForChildren: {
                                    environment: _this.props.__relayContext.environment
                                }
                            };
                        }, function() {
                            sink.next();
                            sink.complete();
                        });
                    });
                })["finally"](function() {
                    if (_this._refetchSubscription === refetchSubscription) _this._refetchSubscription = null;
                }).subscribe((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, observer), {}, {
                    start: function start(subscription) {
                        _this._refetchSubscription = refetchSubscription = subscription;
                        observer.start && observer.start(subscription);
                    }
                }));
                return {
                    dispose: function dispose() {
                        refetchSubscription && refetchSubscription.unsubscribe();
                    }
                };
            });
            var relayContext = assertRelayContext(props.__relayContext);
            var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
            _this._refetchSubscription = null;
            var resolver = createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
            _this.state = {
                data: resolver.resolve(),
                localVariables: null,
                prevProps: props,
                prevPropsContext: relayContext,
                contextForChildren: relayContext,
                relayProp: getRelayProp(relayContext.environment, _this._refetch),
                resolver: resolver
            };
            _this._isUnmounted = false;
            return _this;
        }
        var _proto = _class.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this._isUnmounted = false;
            this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if (this.state.resolver !== prevState.resolver) {
                prevState.resolver.dispose();
                this._queryFetcher && this._queryFetcher.dispose();
                this._refetchSubscription && this._refetchSubscription.unsubscribe();
                this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
            } else this._rerenderIfStoreHasChanged();
        };
        _class.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            var _nextProps$__rootIsQu;
            var prevProps = prevState.prevProps;
            var relayContext = assertRelayContext(nextProps.__relayContext);
            var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
            var prevIDs = getDataIDsFromObject(fragments, prevProps);
            var nextIDs = getDataIDsFromObject(fragments, nextProps);
            var prevRootVariables = getRootVariablesForFragments(fragments, prevProps);
            var nextRootVariables = getRootVariablesForFragments(fragments, nextProps);
            var resolver = prevState.resolver;
            if (prevState.prevPropsContext.environment !== relayContext.environment || !areEqual(prevRootVariables, nextRootVariables) || !areEqual(prevIDs, nextIDs)) {
                resolver = createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
                return {
                    data: resolver.resolve(),
                    localVariables: null,
                    prevProps: nextProps,
                    prevPropsContext: relayContext,
                    contextForChildren: relayContext,
                    relayProp: getRelayProp(relayContext.environment, prevState.relayProp.refetch),
                    resolver: resolver
                };
            } else if (!prevState.localVariables) resolver.setProps(nextProps);
            var data = resolver.resolve();
            if (data !== prevState.data) return {
                data: data,
                prevProps: nextProps
            };
            return null;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this._isUnmounted = true;
            this.state.resolver.dispose();
            this._queryFetcher && this._queryFetcher.dispose();
            this._refetchSubscription && this._refetchSubscription.unsubscribe();
        };
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            if (nextState.data !== this.state.data || nextState.relayProp !== this.state.relayProp) return true;
            var keys = Object.keys(nextProps);
            for(var ii = 0; ii < keys.length; ii++){
                var key = keys[ii];
                if (key === '__relayContext') {
                    if (this.state.prevPropsContext.environment !== nextState.prevPropsContext.environment) return true;
                } else {
                    if (!fragments.hasOwnProperty(key) && !isScalarAndEqual(nextProps[key], this.props[key])) return true;
                }
            }
            return false;
        };
        _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
            var _this$state = this.state, data = _this$state.data, resolver = _this$state.resolver;
            var maybeNewData = resolver.resolve();
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
            var _this$state2 = this.state, data = _this$state2.data, resolver = _this$state2.resolver;
            var maybeNewData = resolver.resolve();
            resolver.setCallback(this.props, this._handleFragmentDataUpdate);
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._getFragmentVariables = function _getFragmentVariables() {
            return getVariablesFromObject(fragments, this.props);
        };
        _proto._getQueryFetcher = function _getQueryFetcher() {
            if (!this._queryFetcher) this._queryFetcher = new ReactRelayQueryFetcher();
            return this._queryFetcher;
        };
        _proto.render = function render() {
            var _this$props = this.props, componentRef = _this$props.componentRef, __relayContext = _this$props.__relayContext, __rootIsQueryRenderer = _this$props.__rootIsQueryRenderer, props = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, _excluded);
            var _this$state3 = this.state, relayProp = _this$state3.relayProp, contextForChildren = _this$state3.contextForChildren;
            return /*#__PURE__*/ React.createElement(ReactRelayContext.Provider, {
                value: contextForChildren
            }, /*#__PURE__*/ React.createElement(Component, (0, _extends2["default"])({}, props, this.state.data, {
                ref: componentRef,
                relay: relayProp
            })));
        };
        return _class;
    }(React.Component), (0, _defineProperty2["default"])(_class, "displayName", containerName), _class;
}
function getRelayProp(environment, refetch) {
    return {
        environment: environment,
        refetch: refetch
    };
}
function createContainer(Component, fragmentSpec, taggedNode) {
    return buildReactRelayContainer(Component, fragmentSpec, function(ComponentClass, fragments) {
        return createContainerWithFragments(ComponentClass, fragments, taggedNode);
    });
}
module.exports = {
    createContainer: createContainer
};

},{"875aaacd52671239":"590td","92541e3bf3b608dd":"ehKSH","4c184c233b5617e8":"fkx57","ea5d91145532619f":"2Bj1n","ad66ac1668305503":"k1uP3","ed120e4e31838a12":"idPlQ","b910ba6d3de581bb":"2paQ8","7a9ac1d4dd3ad3fe":"hPnUw","1150ef319ca0edf6":"gDiox","410ee9383f755285":"7AyFT","a4b49dd8d95541cf":"7NW2h","4cb643176406cbed":"fhl4l","5e074e551e87a797":"cZlGo","41e9e65cf6864888":"eJLuG","f4f24e93fcda9e07":"ltHCL","d4cd814611456f68":"2IxFR","6225b0ef408789c3":"j64TH"}],"d2ChJ":[function(require,module,exports,__globalThis) {
'use strict';
var ProfilerContext = require("cb9c9590f23f2840");
var useRelayEnvironment = require("afd31edb72068860");
var React = require("33db6349f66f6f62");
var _require = require("33db6349f66f6f62"), useContext = _require.useContext, useEffect = _require.useEffect;
var warning = require("1225c530b4ebf241");
function EntryPointContainer(_ref) {
    var entryPointReference = _ref.entryPointReference, props = _ref.props;
    var getComponent = entryPointReference.getComponent, queries = entryPointReference.queries, entryPoints = entryPointReference.entryPoints, extraProps = entryPointReference.extraProps, rootModuleID = entryPointReference.rootModuleID;
    var Component = getComponent();
    var profilerContext = useContext(ProfilerContext);
    var environment = useRelayEnvironment();
    useEffect(function() {
        environment.__log({
            name: 'entrypoint.root.consume',
            profilerContext: profilerContext,
            rootModuleID: rootModuleID
        });
    }, [
        environment,
        profilerContext,
        rootModuleID
    ]);
    return /*#__PURE__*/ React.createElement(Component, {
        entryPoints: entryPoints,
        extraProps: extraProps,
        props: props,
        queries: queries
    });
}
module.exports = EntryPointContainer;

},{"cb9c9590f23f2840":"1lEHI","afd31edb72068860":"bs9Iy","33db6349f66f6f62":"ltHCL","1225c530b4ebf241":"j64TH"}],"1lEHI":[function(require,module,exports,__globalThis) {
'use strict';
var React = require("79a90bff2d060d5e");
var ProfilerContext = React.createContext({
    wrapPrepareQueryResource: function wrapPrepareQueryResource(cb) {
        return cb();
    }
});
module.exports = ProfilerContext;

},{"79a90bff2d060d5e":"ltHCL"}],"bs9Iy":[function(require,module,exports,__globalThis) {
'use strict';
var ReactRelayContext = require("4ba0705935a2160d");
var invariant = require("2c5854cc981658fe");
var _require = require("8fe0c4d36c362e1d"), useContext = _require.useContext;
function useRelayEnvironment() {
    var context = useContext(ReactRelayContext);
    !(context != null) && invariant(false);
    return context.environment;
}
module.exports = useRelayEnvironment;

},{"4ba0705935a2160d":"7NW2h","2c5854cc981658fe":"e2sci","8fe0c4d36c362e1d":"ltHCL"}],"iKwbK":[function(require,module,exports,__globalThis) {
'use strict';
var _require = require("e32d127cb6364377"), loadQuery = _require.loadQuery;
function loadEntryPoint(environmentProvider, entryPoint, entryPointParams) {
    var loadingPromise = null;
    if (entryPoint.root.getModuleIfRequired() == null) loadingPromise = entryPoint.root.load();
    var preloadProps = entryPoint.getPreloadProps(entryPointParams);
    var queries = preloadProps.queries, entryPoints = preloadProps.entryPoints, extraProps = preloadProps.extraProps;
    var preloadedQueries = {};
    var preloadedEntryPoints = {};
    if (queries != null) {
        var queriesPropNames = Object.keys(queries);
        queriesPropNames.forEach(function(queryPropName) {
            var _queries$queryPropNam = queries[queryPropName], environmentProviderOptions = _queries$queryPropNam.environmentProviderOptions, options = _queries$queryPropNam.options, parameters = _queries$queryPropNam.parameters, variables = _queries$queryPropNam.variables;
            var environment = environmentProvider.getEnvironment(environmentProviderOptions);
            preloadedQueries[queryPropName] = loadQuery(environment, parameters, variables, {
                fetchPolicy: options === null || options === void 0 ? void 0 : options.fetchPolicy,
                networkCacheConfig: options === null || options === void 0 ? void 0 : options.networkCacheConfig,
                __nameForWarning: 'loadEntryPoint'
            }, environmentProviderOptions);
        });
    }
    if (entryPoints != null) {
        var entryPointPropNames = Object.keys(entryPoints);
        entryPointPropNames.forEach(function(entryPointPropName) {
            var entryPointDescription = entryPoints[entryPointPropName];
            if (entryPointDescription == null) return;
            var nestedEntryPoint = entryPointDescription.entryPoint, nestedParams = entryPointDescription.entryPointParams;
            preloadedEntryPoints[entryPointPropName] = loadEntryPoint(environmentProvider, nestedEntryPoint, nestedParams);
        });
    }
    var isDisposed = false;
    return {
        dispose: function dispose() {
            if (isDisposed) return;
            if (preloadedQueries != null) Object.values(preloadedQueries).forEach(function(_ref) {
                var innerDispose = _ref.dispose;
                innerDispose();
            });
            if (preloadedEntryPoints != null) Object.values(preloadedEntryPoints).forEach(function(_ref2) {
                var innerDispose = _ref2.dispose;
                innerDispose();
            });
            isDisposed = true;
        },
        entryPoints: preloadedEntryPoints,
        extraProps: extraProps !== null && extraProps !== void 0 ? extraProps : null,
        getComponent: function getComponent() {
            var componentModule = entryPoint.root.getModuleIfRequired();
            if (componentModule == null) {
                var _loadingPromise;
                loadingPromise = (_loadingPromise = loadingPromise) !== null && _loadingPromise !== void 0 ? _loadingPromise : entryPoint.root.load();
                throw loadingPromise;
            }
            var component = componentModule["default"] != null ? componentModule["default"] : componentModule;
            return component;
        },
        get isDisposed () {
            return isDisposed;
        },
        queries: preloadedQueries,
        rootModuleID: entryPoint.root.getModuleId()
    };
}
module.exports = loadEntryPoint;

},{"e32d127cb6364377":"4CbeJ"}],"4CbeJ":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("626faaec81b8ff9d")["default"];
var _objectSpread2 = _interopRequireDefault(require("a759ea3fa6166602"));
var invariant = require("38af72ba20eb73a5");
var React = require("880c85d6186fffd7");
var _require = require("a3850f77971d5b6d"), fetchQueryDeduped = _require.__internal.fetchQueryDeduped, Observable = _require.Observable, PreloadableQueryRegistry = _require.PreloadableQueryRegistry, RelayFeatureFlags = _require.RelayFeatureFlags, ReplaySubject = _require.ReplaySubject, createOperationDescriptor = _require.createOperationDescriptor, getRequest = _require.getRequest, getRequestIdentifier = _require.getRequestIdentifier;
var warning = require("6114556bc5a63957");
var RenderDispatcher = null;
var fetchKey = 100001;
function useTrackLoadQueryInRender() {
    if (RenderDispatcher === null) {
        var _React$__SECRET_INTER, _React$__SECRET_INTER2;
        RenderDispatcher = (_React$__SECRET_INTER = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React$__SECRET_INTER === void 0 ? void 0 : (_React$__SECRET_INTER2 = _React$__SECRET_INTER.ReactCurrentDispatcher) === null || _React$__SECRET_INTER2 === void 0 ? void 0 : _React$__SECRET_INTER2.current;
    }
}
function loadQuery(environment, preloadableRequest, variables, options, environmentProviderOptions) {
    var _React$__SECRET_INTER3, _React$__SECRET_INTER4, _options$__nameForWar, _options$fetchPolicy;
    var CurrentDispatcher = (_React$__SECRET_INTER3 = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React$__SECRET_INTER3 === void 0 ? void 0 : (_React$__SECRET_INTER4 = _React$__SECRET_INTER3.ReactCurrentDispatcher) === null || _React$__SECRET_INTER4 === void 0 ? void 0 : _React$__SECRET_INTER4.current;
    fetchKey++;
    var fetchPolicy = (_options$fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy) !== null && _options$fetchPolicy !== void 0 ? _options$fetchPolicy : 'store-or-network';
    var networkCacheConfig = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, options === null || options === void 0 ? void 0 : options.networkCacheConfig), {}, {
        force: true
    });
    var retainReference;
    var didExecuteNetworkSource = false;
    var executeWithNetworkSource = function executeWithNetworkSource(operation, networkObservable) {
        didExecuteNetworkSource = true;
        return environment.executeWithSource({
            operation: operation,
            source: networkObservable
        });
    };
    var executionSubject = new ReplaySubject();
    var returnedObservable = Observable.create(function(sink) {
        return executionSubject.subscribe(sink);
    });
    var unsubscribeFromNetworkRequest;
    var networkError = null;
    var didMakeNetworkRequest = false;
    var makeNetworkRequest = function makeNetworkRequest(params) {
        didMakeNetworkRequest = true;
        var observable;
        var subject = new ReplaySubject();
        if (RelayFeatureFlags.ENABLE_LOAD_QUERY_REQUEST_DEDUPING === true) {
            var identifier = 'raw-network-request-' + getRequestIdentifier(params, variables);
            observable = fetchQueryDeduped(environment, identifier, function() {
                var network = environment.getNetwork();
                return network.execute(params, variables, networkCacheConfig);
            });
        } else {
            var network = environment.getNetwork();
            observable = network.execute(params, variables, networkCacheConfig);
        }
        var _observable$subscribe = observable.subscribe({
            error: function error(err) {
                networkError = err;
                subject.error(err);
            },
            next: function next(data) {
                subject.next(data);
            },
            complete: function complete() {
                subject.complete();
            }
        }), unsubscribe = _observable$subscribe.unsubscribe;
        unsubscribeFromNetworkRequest = unsubscribe;
        return Observable.create(function(sink) {
            var subjectSubscription = subject.subscribe(sink);
            return function() {
                subjectSubscription.unsubscribe();
                unsubscribeFromNetworkRequest();
            };
        });
    };
    var unsubscribeFromExecution;
    var executeDeduped = function executeDeduped(operation, fetchFn) {
        if (RelayFeatureFlags.ENABLE_LOAD_QUERY_REQUEST_DEDUPING === true) didMakeNetworkRequest = true;
        var _fetchQueryDeduped$su = fetchQueryDeduped(environment, operation.request.identifier, fetchFn).subscribe({
            error: function error(err) {
                executionSubject.error(err);
            },
            next: function next(data) {
                executionSubject.next(data);
            },
            complete: function complete() {
                executionSubject.complete();
            }
        });
        unsubscribeFromExecution = _fetchQueryDeduped$su.unsubscribe;
    };
    var checkAvailabilityAndExecute = function checkAvailabilityAndExecute(concreteRequest) {
        var operation = createOperationDescriptor(concreteRequest, variables, networkCacheConfig);
        retainReference = environment.retain(operation);
        if (fetchPolicy === 'store-only') return;
        var shouldFetch = fetchPolicy !== 'store-or-network' || environment.check(operation).status !== 'available';
        if (shouldFetch) executeDeduped(operation, function() {
            var networkObservable = makeNetworkRequest(concreteRequest.params);
            var executeObservable = executeWithNetworkSource(operation, networkObservable);
            return executeObservable;
        });
    };
    var params;
    var cancelOnLoadCallback;
    var queryId;
    if (preloadableRequest.kind === 'PreloadableConcreteRequest') {
        var preloadableConcreteRequest = preloadableRequest;
        params = preloadableConcreteRequest.params;
        var _params = params;
        queryId = _params.id;
        !(queryId !== null) && invariant(false);
        var _module = PreloadableQueryRegistry.get(queryId);
        if (_module != null) checkAvailabilityAndExecute(_module);
        else {
            var networkObservable = fetchPolicy === 'store-only' ? null : makeNetworkRequest(params);
            var _PreloadableQueryRegi = PreloadableQueryRegistry.onLoad(queryId, function(preloadedModule) {
                cancelOnLoadCallback();
                var operation = createOperationDescriptor(preloadedModule, variables, networkCacheConfig);
                retainReference = environment.retain(operation);
                if (networkObservable != null) executeDeduped(operation, function() {
                    return executeWithNetworkSource(operation, networkObservable);
                });
            });
            cancelOnLoadCallback = _PreloadableQueryRegi.dispose;
        }
    } else {
        var graphQlTaggedNode = preloadableRequest;
        var request = getRequest(graphQlTaggedNode);
        params = request.params;
        queryId = params.cacheID != null ? params.cacheID : params.id;
        checkAvailabilityAndExecute(request);
    }
    var isDisposed = false;
    var isReleased = false;
    var isNetworkRequestCancelled = false;
    var releaseQuery = function releaseQuery() {
        if (isReleased) return;
        retainReference && retainReference.dispose();
        isReleased = true;
    };
    var cancelNetworkRequest = function cancelNetworkRequest() {
        if (isNetworkRequestCancelled) return;
        if (didExecuteNetworkSource) unsubscribeFromExecution && unsubscribeFromExecution();
        else unsubscribeFromNetworkRequest && unsubscribeFromNetworkRequest();
        cancelOnLoadCallback && cancelOnLoadCallback();
        isNetworkRequestCancelled = true;
    };
    return {
        kind: 'PreloadedQuery',
        environment: environment,
        environmentProviderOptions: environmentProviderOptions,
        dispose: function dispose() {
            if (isDisposed) return;
            releaseQuery();
            cancelNetworkRequest();
            isDisposed = true;
        },
        releaseQuery: releaseQuery,
        cancelNetworkRequest: cancelNetworkRequest,
        fetchKey: fetchKey,
        id: queryId,
        get isDisposed () {
            return isDisposed || isReleased;
        },
        get networkError () {
            return networkError;
        },
        name: params.name,
        networkCacheConfig: networkCacheConfig,
        fetchPolicy: fetchPolicy,
        source: didMakeNetworkRequest ? returnedObservable : undefined,
        variables: variables
    };
}
module.exports = {
    loadQuery: loadQuery,
    useTrackLoadQueryInRender: useTrackLoadQueryInRender
};

},{"626faaec81b8ff9d":"590td","a759ea3fa6166602":"2Bj1n","38af72ba20eb73a5":"e2sci","880c85d6186fffd7":"ltHCL","a3850f77971d5b6d":"2IxFR","6114556bc5a63957":"j64TH"}],"aIt8X":[function(require,module,exports,__globalThis) {
'use strict';
var ReactRelayContext = require("3a8082aa064e367e");
var React = require("52398f158b945db7");
var useMemo = React.useMemo;
function RelayEnvironmentProvider(props) {
    var children = props.children, environment = props.environment, getEnvironmentForActor = props.getEnvironmentForActor;
    var context = useMemo(function() {
        return {
            environment: environment,
            getEnvironmentForActor: getEnvironmentForActor
        };
    }, [
        environment,
        getEnvironmentForActor
    ]);
    return /*#__PURE__*/ React.createElement(ReactRelayContext.Provider, {
        value: context
    }, children);
}
module.exports = RelayEnvironmentProvider;

},{"3a8082aa064e367e":"7NW2h","52398f158b945db7":"ltHCL"}],"c5QiX":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("40c0ac0ef28fe2b3")["default"];
var _objectSpread2 = _interopRequireDefault(require("ffff63f92b982cf0"));
var useLazyLoadQuery = require("529c23f6b4cc7947");
function useClientQuery(gqlQuery, variables, options) {
    var query = gqlQuery;
    return useLazyLoadQuery(query, variables, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, options), {}, {
        fetchPolicy: 'store-only'
    }));
}
module.exports = useClientQuery;

},{"40c0ac0ef28fe2b3":"590td","ffff63f92b982cf0":"2Bj1n","529c23f6b4cc7947":"jPRDt"}],"jPRDt":[function(require,module,exports,__globalThis) {
'use strict';
var _require = require("b68c9a094ac95e51"), useTrackLoadQueryInRender = _require.useTrackLoadQueryInRender;
var useLazyLoadQueryNode = require("2df35e424b93be15");
var useMemoOperationDescriptor = require("bf6ba479675f72c");
var useRelayEnvironment = require("b94d6dfe73016bd9");
var _require2 = require("ce6dffbe96a9ef1a"), fetchQuery = _require2.__internal.fetchQuery;
function useLazyLoadQuery(gqlQuery, variables, options) {
    useTrackLoadQueryInRender();
    var environment = useRelayEnvironment();
    var query = useMemoOperationDescriptor(gqlQuery, variables, options && options.networkCacheConfig ? options.networkCacheConfig : {
        force: true
    });
    var data = useLazyLoadQueryNode({
        componentDisplayName: 'useLazyLoadQuery()',
        fetchKey: options === null || options === void 0 ? void 0 : options.fetchKey,
        fetchObservable: fetchQuery(environment, query),
        fetchPolicy: options === null || options === void 0 ? void 0 : options.fetchPolicy,
        query: query,
        renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
    });
    return data;
}
module.exports = useLazyLoadQuery;

},{"b68c9a094ac95e51":"4CbeJ","2df35e424b93be15":"lkkQW","bf6ba479675f72c":"jnI2X","b94d6dfe73016bd9":"bs9Iy","ce6dffbe96a9ef1a":"2IxFR"}],"lkkQW":[function(require,module,exports,__globalThis) {
'use strict';
var ProfilerContext = require("963e5ae9c2f05d23");
var _require = require("8daf22736d02b4fd"), getQueryCacheIdentifier = _require.getQueryCacheIdentifier, getQueryResourceForEnvironment = _require.getQueryResourceForEnvironment;
var useFetchTrackingRef = require("adf3777d057f6b90");
var useFragmentInternal = require("71439a7e828133cf");
var useRelayEnvironment = require("acabe2ac8edf4d3f");
var React = require("35ffd4423e81259d");
var useContext = React.useContext, useEffect = React.useEffect, useState = React.useState, useRef = React.useRef;
function useLazyLoadQueryNode(_ref) {
    var query = _ref.query, componentDisplayName = _ref.componentDisplayName, fetchObservable = _ref.fetchObservable, fetchPolicy = _ref.fetchPolicy, fetchKey = _ref.fetchKey, renderPolicy = _ref.renderPolicy;
    var environment = useRelayEnvironment();
    var profilerContext = useContext(ProfilerContext);
    var QueryResource = getQueryResourceForEnvironment(environment);
    var _useState = useState(0), forceUpdateKey = _useState[0], forceUpdate = _useState[1];
    var _useFetchTrackingRef = useFetchTrackingRef(), startFetch = _useFetchTrackingRef.startFetch, completeFetch = _useFetchTrackingRef.completeFetch;
    var cacheBreaker = "".concat(forceUpdateKey, "-").concat(fetchKey !== null && fetchKey !== void 0 ? fetchKey : '');
    var cacheIdentifier = getQueryCacheIdentifier(environment, query, fetchPolicy, renderPolicy, cacheBreaker);
    var preparedQueryResult = profilerContext.wrapPrepareQueryResource(function() {
        return QueryResource.prepareWithIdentifier(cacheIdentifier, query, fetchObservable, fetchPolicy, renderPolicy, {
            start: startFetch,
            complete: completeFetch,
            error: completeFetch
        }, profilerContext);
    });
    var maybeHiddenOrFastRefresh = useRef(false);
    useEffect(function() {
        return function() {
            maybeHiddenOrFastRefresh.current = true;
        };
    }, []);
    useEffect(function() {
        if (maybeHiddenOrFastRefresh.current === true) {
            maybeHiddenOrFastRefresh.current = false;
            forceUpdate(function(n) {
                return n + 1;
            });
            return;
        }
        var disposable = QueryResource.retain(preparedQueryResult, profilerContext);
        return function() {
            disposable.dispose();
        };
    }, [
        environment,
        cacheIdentifier
    ]);
    useEffect(function() {
        QueryResource.releaseTemporaryRetain(preparedQueryResult);
    });
    var fragmentNode = preparedQueryResult.fragmentNode, fragmentRef = preparedQueryResult.fragmentRef;
    var data = useFragmentInternal(fragmentNode, fragmentRef, componentDisplayName);
    return data;
}
module.exports = useLazyLoadQueryNode;

},{"963e5ae9c2f05d23":"1lEHI","8daf22736d02b4fd":"gv1jq","adf3777d057f6b90":"inPRo","71439a7e828133cf":"eglKT","acabe2ac8edf4d3f":"bs9Iy","35ffd4423e81259d":"ltHCL"}],"gv1jq":[function(require,module,exports,__globalThis) {
var _instanceof = require("@swc/helpers/_/_instanceof");
'use strict';
var _interopRequireDefault = require("8c74228362cadead")["default"];
var _objectSpread2 = _interopRequireDefault(require("80166d1c304ae95c"));
var _defineProperty2 = _interopRequireDefault(require("29ed99e7fa990ae6"));
var LRUCache = require("e0cee57721c50a5f");
var SuspenseResource = require("9b021e44e4b46980");
var invariant = require("a4fad400719b5e5a");
var _require = require("4055f8e8a24a0bfd"), isPromise = _require.isPromise;
var warning = require("d0fc8ca75b8ebb01");
var CACHE_CAPACITY = 1000;
var DEFAULT_FETCH_POLICY = 'store-or-network';
var DEFAULT_LIVE_FETCH_POLICY = 'store-and-network';
var WEAKMAP_SUPPORTED = typeof WeakMap === 'function';
function operationIsLiveQuery(operation) {
    return operation.request.node.params.metadata.live !== undefined;
}
function getQueryCacheIdentifier(environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker) {
    var fetchPolicy = maybeFetchPolicy !== null && maybeFetchPolicy !== void 0 ? maybeFetchPolicy : operationIsLiveQuery(operation) ? DEFAULT_LIVE_FETCH_POLICY : DEFAULT_FETCH_POLICY;
    var renderPolicy = maybeRenderPolicy !== null && maybeRenderPolicy !== void 0 ? maybeRenderPolicy : environment.UNSTABLE_getDefaultRenderPolicy();
    var cacheIdentifier = "".concat(fetchPolicy, "-").concat(renderPolicy, "-").concat(operation.request.identifier);
    if (cacheBreaker != null) return "".concat(cacheIdentifier, "-").concat(cacheBreaker);
    return cacheIdentifier;
}
function getQueryResult(operation, cacheIdentifier) {
    var rootFragmentRef = {
        __id: operation.fragment.dataID,
        __fragments: (0, _defineProperty2["default"])({}, operation.fragment.node.name, operation.request.variables),
        __fragmentOwner: operation.request
    };
    return {
        cacheIdentifier: cacheIdentifier,
        fragmentNode: operation.request.node.fragment,
        fragmentRef: rootFragmentRef,
        operation: operation
    };
}
var nextID = 200000;
function createCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription, onDispose) {
    var isLiveQuery = operationIsLiveQuery(operation);
    var currentValue = value;
    var currentNetworkSubscription = networkSubscription;
    var suspenseResource = new SuspenseResource(function(environment) {
        var retention = environment.retain(operation);
        return {
            dispose: function dispose() {
                if (isLiveQuery && currentNetworkSubscription != null) currentNetworkSubscription.unsubscribe();
                retention.dispose();
                onDispose(cacheEntry);
            }
        };
    });
    var cacheEntry = {
        cacheIdentifier: cacheIdentifier,
        id: nextID++,
        processedPayloadsCount: 0,
        operationAvailability: operationAvailability,
        getValue: function getValue() {
            return currentValue;
        },
        setValue: function setValue(val) {
            currentValue = val;
        },
        setNetworkSubscription: function setNetworkSubscription(subscription) {
            if (isLiveQuery && currentNetworkSubscription != null) currentNetworkSubscription.unsubscribe();
            currentNetworkSubscription = subscription;
        },
        temporaryRetain: function temporaryRetain(environment) {
            return suspenseResource.temporaryRetain(environment);
        },
        permanentRetain: function permanentRetain(environment) {
            return suspenseResource.permanentRetain(environment);
        },
        releaseTemporaryRetain: function releaseTemporaryRetain() {
            suspenseResource.releaseTemporaryRetain();
        }
    };
    return cacheEntry;
}
var QueryResourceImpl = /*#__PURE__*/ function() {
    function QueryResourceImpl(environment) {
        var _this = this;
        (0, _defineProperty2["default"])(this, "_clearCacheEntry", function(cacheEntry) {
            _this._cache["delete"](cacheEntry.cacheIdentifier);
        });
        this._environment = environment;
        this._cache = LRUCache.create(CACHE_CAPACITY);
    }
    var _proto = QueryResourceImpl.prototype;
    _proto.prepare = function prepare(operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, cacheBreaker, profilerContext) {
        var cacheIdentifier = getQueryCacheIdentifier(this._environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker);
        return this.prepareWithIdentifier(cacheIdentifier, operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, profilerContext);
    };
    _proto.prepareWithIdentifier = function prepareWithIdentifier(cacheIdentifier, operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, profilerContext) {
        var environment = this._environment;
        var fetchPolicy = maybeFetchPolicy !== null && maybeFetchPolicy !== void 0 ? maybeFetchPolicy : operationIsLiveQuery(operation) ? DEFAULT_LIVE_FETCH_POLICY : DEFAULT_FETCH_POLICY;
        var renderPolicy = maybeRenderPolicy !== null && maybeRenderPolicy !== void 0 ? maybeRenderPolicy : environment.UNSTABLE_getDefaultRenderPolicy();
        var cacheEntry = this._cache.get(cacheIdentifier);
        var temporaryRetainDisposable = null;
        var entryWasCached = cacheEntry != null;
        if (cacheEntry == null) cacheEntry = this._fetchAndSaveQuery(cacheIdentifier, operation, fetchObservable, fetchPolicy, renderPolicy, profilerContext, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, observer), {}, {
            unsubscribe: function unsubscribe(subscription) {
                if (temporaryRetainDisposable != null) temporaryRetainDisposable.dispose();
                var observerUnsubscribe = observer === null || observer === void 0 ? void 0 : observer.unsubscribe;
                observerUnsubscribe && observerUnsubscribe(subscription);
            }
        }));
        temporaryRetainDisposable = cacheEntry.temporaryRetain(environment);
        var cachedValue = cacheEntry.getValue();
        if (isPromise(cachedValue)) {
            environment.__log({
                name: 'suspense.query',
                fetchPolicy: fetchPolicy,
                isPromiseCached: entryWasCached,
                operation: operation,
                queryAvailability: cacheEntry.operationAvailability,
                renderPolicy: renderPolicy
            });
            throw cachedValue;
        }
        if ((0, _instanceof._)(cachedValue, Error)) throw cachedValue;
        return cachedValue;
    };
    _proto.retain = function retain(queryResult, profilerContext) {
        var environment = this._environment;
        var cacheIdentifier = queryResult.cacheIdentifier, operation = queryResult.operation;
        var cacheEntry = this._getOrCreateCacheEntry(cacheIdentifier, operation, null, queryResult, null);
        var disposable = cacheEntry.permanentRetain(environment);
        environment.__log({
            name: 'queryresource.retain',
            profilerContext: profilerContext,
            resourceID: cacheEntry.id
        });
        return {
            dispose: function dispose() {
                disposable.dispose();
            }
        };
    };
    _proto.releaseTemporaryRetain = function releaseTemporaryRetain(queryResult) {
        var cacheEntry = this._cache.get(queryResult.cacheIdentifier);
        if (cacheEntry != null) cacheEntry.releaseTemporaryRetain();
    };
    _proto.TESTS_ONLY__getCacheEntry = function TESTS_ONLY__getCacheEntry(operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker) {
        var environment = this._environment;
        var cacheIdentifier = getQueryCacheIdentifier(environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker);
        return this._cache.get(cacheIdentifier);
    };
    _proto._getOrCreateCacheEntry = function _getOrCreateCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription) {
        var cacheEntry = this._cache.get(cacheIdentifier);
        if (cacheEntry == null) {
            cacheEntry = createCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription, this._clearCacheEntry);
            this._cache.set(cacheIdentifier, cacheEntry);
        }
        return cacheEntry;
    };
    _proto._fetchAndSaveQuery = function _fetchAndSaveQuery(cacheIdentifier, operation, fetchObservable, fetchPolicy, renderPolicy, profilerContext, observer) {
        var _this2 = this;
        var environment = this._environment;
        var queryAvailability = environment.check(operation);
        var queryStatus = queryAvailability.status;
        var hasFullQuery = queryStatus === 'available';
        var canPartialRender = hasFullQuery || renderPolicy === 'partial' && queryStatus !== 'stale';
        var shouldFetch;
        var shouldAllowRender;
        var resolveNetworkPromise = function resolveNetworkPromise() {};
        switch(fetchPolicy){
            case 'store-only':
                shouldFetch = false;
                shouldAllowRender = true;
                break;
            case 'store-or-network':
                shouldFetch = !hasFullQuery;
                shouldAllowRender = canPartialRender;
                break;
            case 'store-and-network':
                shouldFetch = true;
                shouldAllowRender = canPartialRender;
                break;
            case 'network-only':
            default:
                shouldFetch = true;
                shouldAllowRender = false;
                break;
        }
        if (shouldAllowRender) {
            var queryResult = getQueryResult(operation, cacheIdentifier);
            var _cacheEntry = createCacheEntry(cacheIdentifier, operation, queryAvailability, queryResult, null, this._clearCacheEntry);
            this._cache.set(cacheIdentifier, _cacheEntry);
        }
        if (shouldFetch) {
            var _queryResult = getQueryResult(operation, cacheIdentifier);
            var networkSubscription;
            fetchObservable.subscribe({
                start: function start(subscription) {
                    networkSubscription = subscription;
                    var cacheEntry = _this2._cache.get(cacheIdentifier);
                    if (cacheEntry) cacheEntry.setNetworkSubscription(networkSubscription);
                    var observerStart = observer === null || observer === void 0 ? void 0 : observer.start;
                    if (observerStart) {
                        var subscriptionWithConditionalCancelation = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, subscription), {}, {
                            unsubscribe: function unsubscribe() {
                                if (operationIsLiveQuery(operation)) subscription.unsubscribe();
                            }
                        });
                        observerStart(subscriptionWithConditionalCancelation);
                    }
                },
                next: function next() {
                    var cacheEntry = _this2._getOrCreateCacheEntry(cacheIdentifier, operation, queryAvailability, _queryResult, networkSubscription);
                    cacheEntry.processedPayloadsCount += 1;
                    cacheEntry.setValue(_queryResult);
                    resolveNetworkPromise();
                    var observerNext = observer === null || observer === void 0 ? void 0 : observer.next;
                    if (observerNext != null) {
                        var snapshot = environment.lookup(operation.fragment);
                        observerNext(snapshot);
                    }
                },
                error: function error(_error) {
                    var cacheEntry = _this2._getOrCreateCacheEntry(cacheIdentifier, operation, queryAvailability, _error, networkSubscription);
                    if (cacheEntry.processedPayloadsCount === 0) cacheEntry.setValue(_error);
                    resolveNetworkPromise();
                    networkSubscription = null;
                    cacheEntry.setNetworkSubscription(null);
                    var observerError = observer === null || observer === void 0 ? void 0 : observer.error;
                    observerError && observerError(_error);
                },
                complete: function complete() {
                    resolveNetworkPromise();
                    networkSubscription = null;
                    var cacheEntry = _this2._cache.get(cacheIdentifier);
                    if (cacheEntry) cacheEntry.setNetworkSubscription(null);
                    var observerComplete = observer === null || observer === void 0 ? void 0 : observer.complete;
                    observerComplete && observerComplete();
                },
                unsubscribe: observer === null || observer === void 0 ? void 0 : observer.unsubscribe
            });
            var _cacheEntry2 = this._cache.get(cacheIdentifier);
            if (!_cacheEntry2) {
                var networkPromise = new Promise(function(resolve) {
                    resolveNetworkPromise = resolve;
                });
                networkPromise.displayName = 'Relay(' + operation.fragment.node.name + ')';
                _cacheEntry2 = createCacheEntry(cacheIdentifier, operation, queryAvailability, networkPromise, networkSubscription, this._clearCacheEntry);
                this._cache.set(cacheIdentifier, _cacheEntry2);
            }
        } else {
            var observerComplete = observer === null || observer === void 0 ? void 0 : observer.complete;
            observerComplete && observerComplete();
        }
        var cacheEntry = this._cache.get(cacheIdentifier);
        !(cacheEntry != null) && invariant(false);
        environment.__log({
            name: 'queryresource.fetch',
            resourceID: cacheEntry.id,
            operation: operation,
            profilerContext: profilerContext,
            fetchPolicy: fetchPolicy,
            renderPolicy: renderPolicy,
            queryAvailability: queryAvailability,
            shouldFetch: shouldFetch
        });
        return cacheEntry;
    };
    return QueryResourceImpl;
}();
function createQueryResource(environment) {
    return new QueryResourceImpl(environment);
}
var dataResources = WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
function getQueryResourceForEnvironment(environment) {
    var cached = dataResources.get(environment);
    if (cached) return cached;
    var newDataResource = createQueryResource(environment);
    dataResources.set(environment, newDataResource);
    return newDataResource;
}
module.exports = {
    createQueryResource: createQueryResource,
    getQueryResourceForEnvironment: getQueryResourceForEnvironment,
    getQueryCacheIdentifier: getQueryCacheIdentifier
};

},{"@swc/helpers/_/_instanceof":"h9UKc","8c74228362cadead":"590td","80166d1c304ae95c":"2Bj1n","29ed99e7fa990ae6":"2paQ8","e0cee57721c50a5f":"9LEGe","9b021e44e4b46980":"dPTmI","a4fad400719b5e5a":"e2sci","4055f8e8a24a0bfd":"2IxFR","d0fc8ca75b8ebb01":"j64TH"}],"9LEGe":[function(require,module,exports,__globalThis) {
'use strict';
var invariant = require("f3b6d9c0bebc71d7");
var LRUCache = /*#__PURE__*/ function() {
    function LRUCache(capacity) {
        this._capacity = capacity;
        !(this._capacity > 0) && invariant(false);
        this._map = new Map();
    }
    var _proto = LRUCache.prototype;
    _proto.set = function set(key, value) {
        this._map["delete"](key);
        this._map.set(key, value);
        if (this._map.size > this._capacity) {
            var firstKey = this._map.keys().next();
            if (!firstKey.done) this._map["delete"](firstKey.value);
        }
    };
    _proto.get = function get(key) {
        var value = this._map.get(key);
        if (value != null) {
            this._map["delete"](key);
            this._map.set(key, value);
        }
        return value;
    };
    _proto.has = function has(key) {
        return this._map.has(key);
    };
    _proto["delete"] = function _delete(key) {
        this._map["delete"](key);
    };
    _proto.size = function size() {
        return this._map.size;
    };
    _proto.capacity = function capacity() {
        return this._capacity - this._map.size;
    };
    _proto.clear = function clear() {
        this._map.clear();
    };
    return LRUCache;
}();
function create(capacity) {
    return new LRUCache(capacity);
}
module.exports = {
    create: create
};

},{"f3b6d9c0bebc71d7":"e2sci"}],"dPTmI":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("a9985309bbbdff86")["default"];
var _defineProperty2 = _interopRequireDefault(require("96df57d9c4d1df35"));
var warning = require("46b029b89b2aec71");
var TEMPORARY_RETAIN_DURATION_MS = 300000;
var SuspenseResource = /*#__PURE__*/ function() {
    function SuspenseResource(retain) {
        var _this = this;
        (0, _defineProperty2["default"])(this, "_retainCount", 0);
        (0, _defineProperty2["default"])(this, "_retainDisposable", null);
        (0, _defineProperty2["default"])(this, "_releaseTemporaryRetain", null);
        this._retain = function(environment) {
            _this._retainCount++;
            if (_this._retainCount === 1) _this._retainDisposable = retain(environment);
            return {
                dispose: function dispose() {
                    _this._retainCount = Math.max(0, _this._retainCount - 1);
                    if (_this._retainCount === 0) {
                        if (_this._retainDisposable != null) {
                            _this._retainDisposable.dispose();
                            _this._retainDisposable = null;
                        }
                    }
                }
            };
        };
    }
    var _proto = SuspenseResource.prototype;
    _proto.temporaryRetain = function temporaryRetain(environment) {
        var _this2 = this;
        var _this$_releaseTempora;
        if (environment.isServer()) return {
            dispose: function dispose() {}
        };
        var retention = this._retain(environment);
        var releaseQueryTimeout = null;
        var releaseTemporaryRetain = function releaseTemporaryRetain() {
            clearTimeout(releaseQueryTimeout);
            releaseQueryTimeout = null;
            _this2._releaseTemporaryRetain = null;
            retention.dispose();
        };
        releaseQueryTimeout = setTimeout(releaseTemporaryRetain, TEMPORARY_RETAIN_DURATION_MS);
        (_this$_releaseTempora = this._releaseTemporaryRetain) === null || _this$_releaseTempora === void 0 || _this$_releaseTempora.call(this);
        this._releaseTemporaryRetain = releaseTemporaryRetain;
        return {
            dispose: function dispose() {
                var _this$_releaseTempora2;
                (_this$_releaseTempora2 = _this2._releaseTemporaryRetain) === null || _this$_releaseTempora2 === void 0 || _this$_releaseTempora2.call(_this2);
            }
        };
    };
    _proto.permanentRetain = function permanentRetain(environment) {
        var disposable = this._retain(environment);
        this.releaseTemporaryRetain();
        return disposable;
    };
    _proto.releaseTemporaryRetain = function releaseTemporaryRetain() {
        var _this$_releaseTempora3;
        (_this$_releaseTempora3 = this._releaseTemporaryRetain) === null || _this$_releaseTempora3 === void 0 || _this$_releaseTempora3.call(this);
        this._releaseTemporaryRetain = null;
    };
    _proto.getRetainCount = function getRetainCount() {
        return this._retainCount;
    };
    return SuspenseResource;
}();
module.exports = SuspenseResource;

},{"a9985309bbbdff86":"590td","96df57d9c4d1df35":"2paQ8","46b029b89b2aec71":"j64TH"}],"inPRo":[function(require,module,exports,__globalThis) {
'use strict';
var useUnsafeRef_DEPRECATED = require("cb5955a09110ebb3");
var _require = require("9a3c8538fc0f0f61"), useCallback = _require.useCallback, useEffect = _require.useEffect;
function useFetchTrackingRef() {
    var subscriptionRef = useUnsafeRef_DEPRECATED(null);
    var isFetchingRef = useUnsafeRef_DEPRECATED(false);
    var disposeFetch = useCallback(function() {
        if (subscriptionRef.current != null) {
            subscriptionRef.current.unsubscribe();
            subscriptionRef.current = null;
        }
        isFetchingRef.current = false;
    }, []);
    var startFetch = useCallback(function(subscription) {
        subscriptionRef.current = subscription;
        isFetchingRef.current = true;
    }, []);
    var completeFetch = useCallback(function() {
        subscriptionRef.current = null;
        isFetchingRef.current = false;
    }, []);
    useEffect(function() {
        return disposeFetch;
    }, [
        disposeFetch
    ]);
    return {
        isFetchingRef: isFetchingRef,
        startFetch: startFetch,
        disposeFetch: disposeFetch,
        completeFetch: completeFetch
    };
}
module.exports = useFetchTrackingRef;

},{"cb5955a09110ebb3":"eslBO","9a3c8538fc0f0f61":"ltHCL"}],"eslBO":[function(require,module,exports,__globalThis) {
'use strict';
var _require = require("e5a44dc070d2f0a"), useMemo = _require.useMemo;
function useUnsafeRef_DEPRECATED(init) {
    return useMemo(function() {
        return {
            current: init
        };
    }, []);
}
module.exports = useUnsafeRef_DEPRECATED;

},{"e5a44dc070d2f0a":"ltHCL"}],"eglKT":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("62731ed9b42ef683")["default"];
var _objectSpread2 = _interopRequireDefault(require("e5aa35c7b20be251"));
var _createForOfIteratorHelper2 = _interopRequireDefault(require("c32b5bceb05c46cc"));
var _toConsumableArray2 = _interopRequireDefault(require("e0275d3545e9d00a"));
var _require = require("5f1b287457b116d7"), getQueryResourceForEnvironment = _require.getQueryResourceForEnvironment;
var useRelayEnvironment = require("a27b086d34e15ad");
var invariant = require("9ea67732067d7684");
var _require2 = require("d627870d9f1af375"), useDebugValue = _require2.useDebugValue, useEffect = _require2.useEffect, useMemo = _require2.useMemo, useRef = _require2.useRef, useState = _require2.useState;
var _require3 = require("e50215f2293434a"), _require3$__internal = _require3.__internal, fetchQueryInternal = _require3$__internal.fetchQuery, getPromiseForActiveRequest = _require3$__internal.getPromiseForActiveRequest, RelayFeatureFlags = _require3.RelayFeatureFlags, areEqualSelectors = _require3.areEqualSelectors, createOperationDescriptor = _require3.createOperationDescriptor, getPendingOperationsForFragment = _require3.getPendingOperationsForFragment, getSelector = _require3.getSelector, getVariablesFromFragment = _require3.getVariablesFromFragment, handlePotentialSnapshotErrors = _require3.handlePotentialSnapshotErrors, recycleNodesInto = _require3.recycleNodesInto;
var warning = require("58f6d927dc08968d");
function isMissingData(state) {
    if (state.kind === 'bailout') return false;
    else if (state.kind === 'singular') return state.snapshot.isMissingData;
    else return state.snapshots.some(function(s) {
        return s.isMissingData;
    });
}
function getMissingClientEdges(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi;
        return (_state$snapshot$missi = state.snapshot.missingClientEdges) !== null && _state$snapshot$missi !== void 0 ? _state$snapshot$missi : null;
    } else {
        var edges = null;
        var _iterator = (0, _createForOfIteratorHelper2["default"])(state.snapshots), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var snapshot = _step.value;
                if (snapshot.missingClientEdges) {
                    var _edges;
                    edges = (_edges = edges) !== null && _edges !== void 0 ? _edges : [];
                    var _iterator2 = (0, _createForOfIteratorHelper2["default"])(snapshot.missingClientEdges), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var edge = _step2.value;
                            edges.push(edge);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return edges;
    }
}
function getSuspendingLiveResolver(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi2;
        return (_state$snapshot$missi2 = state.snapshot.missingLiveResolverFields) !== null && _state$snapshot$missi2 !== void 0 ? _state$snapshot$missi2 : null;
    } else {
        var missingFields = null;
        var _iterator3 = (0, _createForOfIteratorHelper2["default"])(state.snapshots), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var snapshot = _step3.value;
                if (snapshot.missingLiveResolverFields) {
                    var _missingFields;
                    missingFields = (_missingFields = missingFields) !== null && _missingFields !== void 0 ? _missingFields : [];
                    var _iterator4 = (0, _createForOfIteratorHelper2["default"])(snapshot.missingLiveResolverFields), _step4;
                    try {
                        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                            var edge = _step4.value;
                            missingFields.push(edge);
                        }
                    } catch (err) {
                        _iterator4.e(err);
                    } finally{
                        _iterator4.f();
                    }
                }
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        return missingFields;
    }
}
function handlePotentialSnapshotErrorsForState(environment, state) {
    if (state.kind === 'singular') {
        var _state$snapshot$selec, _state$snapshot$selec2;
        handlePotentialSnapshotErrors(environment, state.snapshot.missingRequiredFields, state.snapshot.relayResolverErrors, state.snapshot.errorResponseFields, (_state$snapshot$selec = (_state$snapshot$selec2 = state.snapshot.selector.node.metadata) === null || _state$snapshot$selec2 === void 0 ? void 0 : _state$snapshot$selec2.throwOnFieldError) !== null && _state$snapshot$selec !== void 0 ? _state$snapshot$selec : false);
    } else if (state.kind === 'plural') {
        var _iterator5 = (0, _createForOfIteratorHelper2["default"])(state.snapshots), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var _snapshot$selector$no, _snapshot$selector$no2;
                var snapshot = _step5.value;
                handlePotentialSnapshotErrors(environment, snapshot.missingRequiredFields, snapshot.relayResolverErrors, snapshot.errorResponseFields, (_snapshot$selector$no = (_snapshot$selector$no2 = snapshot.selector.node.metadata) === null || _snapshot$selector$no2 === void 0 ? void 0 : _snapshot$selector$no2.throwOnFieldError) !== null && _snapshot$selector$no !== void 0 ? _snapshot$selector$no : false);
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
    }
}
function handleMissedUpdates(environment, state) {
    if (state.kind === 'bailout') return null;
    var currentEpoch = environment.getStore().getEpoch();
    if (currentEpoch === state.epoch) return null;
    if (state.kind === 'singular') {
        var currentSnapshot = environment.lookup(state.snapshot.selector);
        var updatedData = recycleNodesInto(state.snapshot.data, currentSnapshot.data);
        var updatedCurrentSnapshot = {
            data: updatedData,
            isMissingData: currentSnapshot.isMissingData,
            missingClientEdges: currentSnapshot.missingClientEdges,
            missingLiveResolverFields: currentSnapshot.missingLiveResolverFields,
            seenRecords: currentSnapshot.seenRecords,
            selector: currentSnapshot.selector,
            missingRequiredFields: currentSnapshot.missingRequiredFields,
            relayResolverErrors: currentSnapshot.relayResolverErrors,
            errorResponseFields: currentSnapshot.errorResponseFields
        };
        return [
            updatedData !== state.snapshot.data,
            {
                kind: 'singular',
                snapshot: updatedCurrentSnapshot,
                epoch: currentEpoch
            }
        ];
    } else {
        var didMissUpdates = false;
        var currentSnapshots = [];
        for(var index = 0; index < state.snapshots.length; index++){
            var snapshot = state.snapshots[index];
            var _currentSnapshot = environment.lookup(snapshot.selector);
            var _updatedData = recycleNodesInto(snapshot.data, _currentSnapshot.data);
            var _updatedCurrentSnapshot = {
                data: _updatedData,
                isMissingData: _currentSnapshot.isMissingData,
                missingClientEdges: _currentSnapshot.missingClientEdges,
                missingLiveResolverFields: _currentSnapshot.missingLiveResolverFields,
                seenRecords: _currentSnapshot.seenRecords,
                selector: _currentSnapshot.selector,
                missingRequiredFields: _currentSnapshot.missingRequiredFields,
                relayResolverErrors: _currentSnapshot.relayResolverErrors,
                errorResponseFields: _currentSnapshot.errorResponseFields
            };
            if (_updatedData !== snapshot.data) didMissUpdates = true;
            currentSnapshots.push(_updatedCurrentSnapshot);
        }
        !(currentSnapshots.length === state.snapshots.length) && invariant(false);
        return [
            didMissUpdates,
            {
                kind: 'plural',
                snapshots: currentSnapshots,
                epoch: currentEpoch
            }
        ];
    }
}
function handleMissingClientEdge(environment, parentFragmentNode, parentFragmentRef, missingClientEdgeRequestInfo, queryOptions) {
    var originalVariables = getVariablesFromFragment(parentFragmentNode, parentFragmentRef);
    var variables = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, originalVariables), {}, {
        id: missingClientEdgeRequestInfo.clientEdgeDestinationID
    });
    var queryOperationDescriptor = createOperationDescriptor(missingClientEdgeRequestInfo.request, variables, queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.networkCacheConfig);
    var QueryResource = getQueryResourceForEnvironment(environment);
    var queryResult = QueryResource.prepare(queryOperationDescriptor, fetchQueryInternal(environment, queryOperationDescriptor), queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.fetchPolicy);
    return [
        queryResult,
        getPromiseForActiveRequest(environment, queryOperationDescriptor.request)
    ];
}
function subscribeToSnapshot(environment, state, setState, hasPendingStateChanges) {
    if (state.kind === 'bailout') return function() {};
    else if (state.kind === 'singular') {
        var disposable = environment.subscribe(state.snapshot, function(latestSnapshot) {
            setState(function(prevState) {
                if (prevState.kind !== 'singular' || prevState.snapshot.selector !== latestSnapshot.selector) {
                    var updates = handleMissedUpdates(environment, prevState);
                    if (updates != null) {
                        var dataChanged = updates[0], nextState = updates[1];
                        environment.__log({
                            name: 'useFragment.subscription.missedUpdates',
                            hasDataChanges: dataChanged
                        });
                        hasPendingStateChanges.current = dataChanged;
                        return dataChanged ? nextState : prevState;
                    } else return prevState;
                }
                hasPendingStateChanges.current = true;
                return {
                    kind: 'singular',
                    snapshot: latestSnapshot,
                    epoch: environment.getStore().getEpoch()
                };
            });
        });
        return function() {
            disposable.dispose();
        };
    } else {
        var disposables = state.snapshots.map(function(snapshot, index) {
            return environment.subscribe(snapshot, function(latestSnapshot) {
                setState(function(prevState) {
                    var _prevState$snapshots$;
                    if (prevState.kind !== 'plural' || ((_prevState$snapshots$ = prevState.snapshots[index]) === null || _prevState$snapshots$ === void 0 ? void 0 : _prevState$snapshots$.selector) !== latestSnapshot.selector) {
                        var updates = handleMissedUpdates(environment, prevState);
                        if (updates != null) {
                            var dataChanged = updates[0], nextState = updates[1];
                            environment.__log({
                                name: 'useFragment.subscription.missedUpdates',
                                hasDataChanges: dataChanged
                            });
                            hasPendingStateChanges.current = hasPendingStateChanges.current || dataChanged;
                            return dataChanged ? nextState : prevState;
                        } else return prevState;
                    }
                    var updated = (0, _toConsumableArray2["default"])(prevState.snapshots);
                    updated[index] = latestSnapshot;
                    hasPendingStateChanges.current = true;
                    return {
                        kind: 'plural',
                        snapshots: updated,
                        epoch: environment.getStore().getEpoch()
                    };
                });
            });
        });
        return function() {
            var _iterator6 = (0, _createForOfIteratorHelper2["default"])(disposables), _step6;
            try {
                for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                    var d = _step6.value;
                    d.dispose();
                }
            } catch (err) {
                _iterator6.e(err);
            } finally{
                _iterator6.f();
            }
        };
    }
}
function getFragmentState(environment, fragmentSelector) {
    if (fragmentSelector == null) return {
        kind: 'bailout'
    };
    else if (fragmentSelector.kind === 'PluralReaderSelector') return {
        kind: 'plural',
        snapshots: fragmentSelector.selectors.map(function(s) {
            return environment.lookup(s);
        }),
        epoch: environment.getStore().getEpoch()
    };
    else return {
        kind: 'singular',
        snapshot: environment.lookup(fragmentSelector),
        epoch: environment.getStore().getEpoch()
    };
}
function useFragmentInternal(fragmentNode, fragmentRef, hookDisplayName, queryOptions) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var fragmentSelector = useMemo(function() {
        return getSelector(fragmentNode, fragmentRef);
    }, [
        fragmentNode,
        fragmentRef
    ]);
    var isPlural = (fragmentNode === null || fragmentNode === void 0 ? void 0 : (_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) === true;
    if (isPlural) !(fragmentRef == null || Array.isArray(fragmentRef)) && invariant(false);
    else !!Array.isArray(fragmentRef) && invariant(false);
    !(fragmentRef == null || isPlural && Array.isArray(fragmentRef) && fragmentRef.length === 0 || fragmentSelector != null) && invariant(false);
    var environment = useRelayEnvironment();
    var _useState = useState(function() {
        return getFragmentState(environment, fragmentSelector);
    }), _state = _useState[0], setState = _useState[1];
    var state = _state;
    var _useState2 = useState(state), _subscribedState = _useState2[0], setSubscribedState = _useState2[1];
    var subscribedState = _subscribedState;
    var _useState3 = useState(fragmentSelector), previousFragmentSelector = _useState3[0], setPreviousFragmentSelector = _useState3[1];
    var _useState4 = useState(environment), previousEnvironment = _useState4[0], setPreviousEnvironment = _useState4[1];
    if (!areEqualSelectors(fragmentSelector, previousFragmentSelector) || environment !== previousEnvironment) {
        setPreviousFragmentSelector(fragmentSelector);
        setPreviousEnvironment(environment);
        var newState = getFragmentState(environment, fragmentSelector);
        setState(newState);
        setSubscribedState(newState);
        state = newState;
        subscribedState = newState;
    }
    var committedFragmentSelectorRef = useRef(false);
    useEffect(function() {
        committedFragmentSelectorRef.current = fragmentSelector;
    }, [
        fragmentSelector
    ]);
    if (((_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.hasClientEdges) === true) {
        var _useMemo = useMemo(function() {
            var missingClientEdges = getMissingClientEdges(state);
            var clientEdgeQueries;
            var activeRequestPromises = [];
            if (missingClientEdges !== null && missingClientEdges !== void 0 && missingClientEdges.length) {
                clientEdgeQueries = [];
                var _iterator7 = (0, _createForOfIteratorHelper2["default"])(missingClientEdges), _step7;
                try {
                    for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                        var edge = _step7.value;
                        var _handleMissingClientE = handleMissingClientEdge(environment, fragmentNode, fragmentRef, edge, queryOptions), queryResult = _handleMissingClientE[0], requestPromise = _handleMissingClientE[1];
                        clientEdgeQueries.push(queryResult);
                        if (requestPromise != null) activeRequestPromises.push(requestPromise);
                    }
                } catch (err) {
                    _iterator7.e(err);
                } finally{
                    _iterator7.f();
                }
            }
            return [
                clientEdgeQueries,
                activeRequestPromises
            ];
        }, [
            state,
            environment,
            fragmentNode,
            fragmentRef,
            queryOptions
        ]), clientEdgeQueries = _useMemo[0], activeRequestPromises = _useMemo[1];
        if (activeRequestPromises.length) throw Promise.all(activeRequestPromises);
        useEffect(function() {
            var QueryResource = getQueryResourceForEnvironment(environment);
            if (clientEdgeQueries !== null && clientEdgeQueries !== void 0 && clientEdgeQueries.length) {
                var disposables = [];
                var _iterator8 = (0, _createForOfIteratorHelper2["default"])(clientEdgeQueries), _step8;
                try {
                    for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
                        var query = _step8.value;
                        disposables.push(QueryResource.retain(query));
                    }
                } catch (err) {
                    _iterator8.e(err);
                } finally{
                    _iterator8.f();
                }
                return function() {
                    var _iterator9 = (0, _createForOfIteratorHelper2["default"])(disposables), _step9;
                    try {
                        for(_iterator9.s(); !(_step9 = _iterator9.n()).done;){
                            var disposable = _step9.value;
                            disposable.dispose();
                        }
                    } catch (err) {
                        _iterator9.e(err);
                    } finally{
                        _iterator9.f();
                    }
                };
            }
        }, [
            environment,
            clientEdgeQueries
        ]);
    }
    if (isMissingData(state)) {
        var suspendingLiveResolvers = getSuspendingLiveResolver(state);
        if (suspendingLiveResolvers != null && suspendingLiveResolvers.length > 0) throw Promise.all(suspendingLiveResolvers.map(function(_ref) {
            var liveStateID = _ref.liveStateID;
            return environment.getStore().getLiveResolverPromise(liveStateID);
        }));
        if (RelayFeatureFlags.ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE || environment !== previousEnvironment || !committedFragmentSelectorRef.current || !areEqualSelectors(committedFragmentSelectorRef.current, fragmentSelector)) {
            !(fragmentSelector != null) && invariant(false);
            var fragmentOwner = fragmentSelector.kind === 'PluralReaderSelector' ? fragmentSelector.selectors[0].owner : fragmentSelector.owner;
            var pendingOperationsResult = getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner);
            if (pendingOperationsResult) throw pendingOperationsResult.promise;
        }
    }
    handlePotentialSnapshotErrorsForState(environment, state);
    var hasPendingStateChanges = useRef(false);
    useEffect(function() {
        var currentState = subscribedState;
        var updates = handleMissedUpdates(environment, subscribedState);
        if (updates !== null) {
            var didMissUpdates = updates[0], updatedState = updates[1];
            if (didMissUpdates) setState(updatedState);
            currentState = updatedState;
        }
        return subscribeToSnapshot(environment, currentState, setState, hasPendingStateChanges);
    }, [
        environment,
        subscribedState
    ]);
    if (hasPendingStateChanges.current) {
        var updates = handleMissedUpdates(environment, state);
        if (updates != null) {
            var hasStateUpdates = updates[0], updatedState = updates[1];
            if (hasStateUpdates) {
                setState(updatedState);
                state = updatedState;
            }
        }
        hasPendingStateChanges.current = false;
    }
    var data;
    if (isPlural) {
        var fragmentRefIsNullish = fragmentRef == null;
        data = useMemo(function() {
            if (state.kind === 'bailout') return fragmentRefIsNullish ? null : [];
            else {
                !(state.kind === 'plural') && invariant(false);
                return state.snapshots.map(function(s) {
                    return s.data;
                });
            }
        }, [
            state,
            fragmentRefIsNullish
        ]);
    } else if (state.kind === 'bailout') data = null;
    else {
        !(state.kind === 'singular') && invariant(false);
        data = state.snapshot.data;
    }
    if (RelayFeatureFlags.LOG_MISSING_RECORDS_IN_PROD || false) fragmentRef != null && (data === undefined || Array.isArray(data) && data.length > 0 && data.every(function(d) {
        return d === undefined;
    }));
    return data;
}
module.exports = useFragmentInternal;

},{"62731ed9b42ef683":"590td","e5aa35c7b20be251":"2Bj1n","c32b5bceb05c46cc":"fMaLa","e0275d3545e9d00a":"7EBX0","5f1b287457b116d7":"gv1jq","a27b086d34e15ad":"bs9Iy","9ea67732067d7684":"e2sci","d627870d9f1af375":"ltHCL","e50215f2293434a":"2IxFR","58f6d927dc08968d":"j64TH"}],"jnI2X":[function(require,module,exports,__globalThis) {
'use strict';
var useMemoVariables = require("7aa1a0283d691aaf");
var React = require("b4e529ae1e76e8b");
var _require = require("598b507a467448e1"), createOperationDescriptor = _require.createOperationDescriptor, getRequest = _require.getRequest;
var useMemo = React.useMemo;
function useMemoOperationDescriptor(gqlQuery, variables, cacheConfig) {
    var memoVariables = useMemoVariables(variables);
    var memoCacheConfig = useMemoVariables(cacheConfig || {});
    return useMemo(function() {
        return createOperationDescriptor(getRequest(gqlQuery), memoVariables, memoCacheConfig);
    }, [
        gqlQuery,
        memoVariables,
        memoCacheConfig
    ]);
}
module.exports = useMemoOperationDescriptor;

},{"7aa1a0283d691aaf":"epD46","b4e529ae1e76e8b":"ltHCL","598b507a467448e1":"2IxFR"}],"epD46":[function(require,module,exports,__globalThis) {
'use strict';
var areEqual = require("8411b20d6b142b26");
var _require = require("38edb978daf04434"), useState = _require.useState;
function useMemoVariables(variables) {
    var _useState = useState(variables), mirroredVariables = _useState[0], setMirroredVariables = _useState[1];
    if (areEqual(variables, mirroredVariables)) return mirroredVariables;
    else {
        setMirroredVariables(variables);
        return variables;
    }
}
module.exports = useMemoVariables;

},{"8411b20d6b142b26":"eJLuG","38edb978daf04434":"ltHCL"}],"lV0xn":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("867495428bc05203")["default"];
var _createForOfIteratorHelper2 = _interopRequireDefault(require("e0154b009362727a"));
var loadEntryPoint = require("9c4183e84c0fb000");
var _require = require("481ef8686fb333f6"), useTrackLoadQueryInRender = _require.useTrackLoadQueryInRender;
var useIsMountedRef = require("c734c78036a2e216");
var _require2 = require("2c9267f0906d7021"), useCallback = _require2.useCallback, useEffect = _require2.useEffect, useRef = _require2.useRef, useState = _require2.useState;
var initialNullEntryPointReferenceState = {
    kind: 'NullEntryPointReference'
};
function useLoadEntryPoint(environmentProvider, entryPoint, options) {
    var _options$TEST_ONLY__i, _options$TEST_ONLY__i2, _options$TEST_ONLY__i3, _options$TEST_ONLY__i4;
    useTrackLoadQueryInRender();
    var initialEntryPointReferenceInternal = (_options$TEST_ONLY__i = options === null || options === void 0 ? void 0 : (_options$TEST_ONLY__i2 = options.TEST_ONLY__initialEntryPointData) === null || _options$TEST_ONLY__i2 === void 0 ? void 0 : _options$TEST_ONLY__i2.entryPointReference) !== null && _options$TEST_ONLY__i !== void 0 ? _options$TEST_ONLY__i : initialNullEntryPointReferenceState;
    var initialEntryPointParamsInternal = (_options$TEST_ONLY__i3 = options === null || options === void 0 ? void 0 : (_options$TEST_ONLY__i4 = options.TEST_ONLY__initialEntryPointData) === null || _options$TEST_ONLY__i4 === void 0 ? void 0 : _options$TEST_ONLY__i4.entryPointParams) !== null && _options$TEST_ONLY__i3 !== void 0 ? _options$TEST_ONLY__i3 : null;
    var isMountedRef = useIsMountedRef();
    var undisposedEntryPointReferencesRef = useRef(new Set([
        initialEntryPointReferenceInternal
    ]));
    var _useState = useState(initialEntryPointReferenceInternal), entryPointReference = _useState[0], setEntryPointReference = _useState[1];
    var _useState2 = useState(initialEntryPointParamsInternal), entryPointParams = _useState2[0], setEntryPointParams = _useState2[1];
    var disposeEntryPoint = useCallback(function() {
        if (isMountedRef.current) {
            var nullEntryPointReference = {
                kind: 'NullEntryPointReference'
            };
            undisposedEntryPointReferencesRef.current.add(nullEntryPointReference);
            setEntryPointReference(nullEntryPointReference);
        }
    }, [
        setEntryPointReference,
        isMountedRef
    ]);
    var entryPointLoaderCallback = useCallback(function(params) {
        if (isMountedRef.current) {
            var updatedEntryPointReference = loadEntryPoint(environmentProvider, entryPoint, params);
            undisposedEntryPointReferencesRef.current.add(updatedEntryPointReference);
            setEntryPointReference(updatedEntryPointReference);
            setEntryPointParams(params);
        }
    }, [
        environmentProvider,
        entryPoint,
        setEntryPointReference,
        isMountedRef
    ]);
    var maybeHiddenOrFastRefresh = useRef(false);
    useEffect(function() {
        return function() {
            maybeHiddenOrFastRefresh.current = true;
        };
    }, []);
    useEffect(function() {
        if (maybeHiddenOrFastRefresh.current === true) {
            maybeHiddenOrFastRefresh.current = false;
            if (entryPointReference.kind !== 'NullEntryPointReference' && entryPointParams != null) entryPointLoaderCallback(entryPointParams);
            return;
        }
        var undisposedEntryPointReferences = undisposedEntryPointReferencesRef.current;
        if (isMountedRef.current) {
            var _iterator = (0, _createForOfIteratorHelper2["default"])(undisposedEntryPointReferences), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var undisposedEntryPointReference = _step.value;
                    if (undisposedEntryPointReference === entryPointReference) break;
                    undisposedEntryPointReferences["delete"](undisposedEntryPointReference);
                    if (undisposedEntryPointReference.kind !== 'NullEntryPointReference') undisposedEntryPointReference.dispose();
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    }, [
        entryPointReference,
        entryPointParams,
        entryPointLoaderCallback,
        isMountedRef
    ]);
    useEffect(function() {
        return function disposeAllRemainingEntryPointReferences() {
            var _iterator2 = (0, _createForOfIteratorHelper2["default"])(undisposedEntryPointReferencesRef.current), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var unhandledStateChange = _step2.value;
                    if (unhandledStateChange.kind !== 'NullEntryPointReference') unhandledStateChange.dispose();
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        };
    }, []);
    return [
        entryPointReference.kind === 'NullEntryPointReference' ? null : entryPointReference,
        entryPointLoaderCallback,
        disposeEntryPoint
    ];
}
module.exports = useLoadEntryPoint;

},{"867495428bc05203":"590td","e0154b009362727a":"fMaLa","9c4183e84c0fb000":"iKwbK","481ef8686fb333f6":"4CbeJ","c734c78036a2e216":"bqjPh","2c9267f0906d7021":"ltHCL"}],"bqjPh":[function(require,module,exports,__globalThis) {
'use strict';
var _require = require("fb39348231e9df8"), useEffect = _require.useEffect, useRef = _require.useRef;
function useIsMountedRef() {
    var isMountedRef = useRef(true);
    useEffect(function() {
        isMountedRef.current = true;
        return function() {
            isMountedRef.current = false;
        };
    }, []);
    return isMountedRef;
}
module.exports = useIsMountedRef;

},{"fb39348231e9df8":"ltHCL"}],"1zoWc":[function(require,module,exports,__globalThis) {
'use strict';
var _require = require("bd8c47f5351638d8"), useTrackLoadQueryInRender = _require.useTrackLoadQueryInRender;
var useFragmentInternal = require("b1310ca474cc809");
var useStaticFragmentNodeWarning = require("1e57d8e9e4026e7b");
var _require2 = require("ef62af53b262de55"), useDebugValue = _require2.useDebugValue;
var _require3 = require("fdbcb266aeaa1f2"), getFragment = _require3.getFragment;
function useFragment(fragment, key) {
    useTrackLoadQueryInRender();
    var fragmentNode = getFragment(fragment);
    useStaticFragmentNodeWarning(fragmentNode, 'first argument of useFragment()');
    var data = useFragmentInternal(fragmentNode, key, 'useFragment()');
    return data;
}
module.exports = useFragment;

},{"bd8c47f5351638d8":"4CbeJ","b1310ca474cc809":"eglKT","1e57d8e9e4026e7b":"8SJsi","ef62af53b262de55":"ltHCL","fdbcb266aeaa1f2":"2IxFR"}],"8SJsi":[function(require,module,exports,__globalThis) {
'use strict';
var useUnsafeRef_DEPRECATED = require("92df17c737ee1cde");
var warning = require("df1a3ea00f4bfdb1");
function useStaticFragmentNodeWarning(fragmentNode, warningContext) {
    var initialPropRef;
}
module.exports = useStaticFragmentNodeWarning;

},{"92df17c737ee1cde":"eslBO","df1a3ea00f4bfdb1":"j64TH"}],"gIJ5I":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("1994f82c3167a82f")["default"];
var _objectSpread2 = _interopRequireDefault(require("936fbbf07c5590c8"));
var useIsMountedRef = require("cab1674bb914c082");
var useRelayEnvironment = require("3a2e0417487330ad");
var React = require("d873b37c20a3e87");
var _require = require("f3d3c49bcea96c38"), defaultCommitMutation = _require.commitMutation;
var useState = React.useState, useEffect = React.useEffect, useRef = React.useRef, useCallback = React.useCallback;
function useMutation(mutation) {
    var commitMutationFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultCommitMutation;
    var environment = useRelayEnvironment();
    var isMountedRef = useIsMountedRef();
    var environmentRef = useRef(environment);
    var mutationRef = useRef(mutation);
    var inFlightMutationsRef = useRef(new Set());
    var _useState = useState(false), isMutationInFlight = _useState[0], setMutationInFlight = _useState[1];
    var cleanup = useCallback(function(disposable) {
        if (environmentRef.current === environment && mutationRef.current === mutation) {
            inFlightMutationsRef.current["delete"](disposable);
            if (isMountedRef.current) setMutationInFlight(inFlightMutationsRef.current.size > 0);
        }
    }, [
        environment,
        isMountedRef,
        mutation
    ]);
    useEffect(function() {
        if (environmentRef.current !== environment || mutationRef.current !== mutation) {
            inFlightMutationsRef.current = new Set();
            if (isMountedRef.current) setMutationInFlight(false);
            environmentRef.current = environment;
            mutationRef.current = mutation;
        }
    }, [
        environment,
        isMountedRef,
        mutation
    ]);
    var commit = useCallback(function(config) {
        if (isMountedRef.current) setMutationInFlight(true);
        var disposable = commitMutationFn(environment, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, config), {}, {
            mutation: mutation,
            onCompleted: function onCompleted(response, errors) {
                var _config$onCompleted;
                cleanup(disposable);
                (_config$onCompleted = config.onCompleted) === null || _config$onCompleted === void 0 || _config$onCompleted.call(config, response, errors);
            },
            onError: function onError(error) {
                var _config$onError;
                cleanup(disposable);
                (_config$onError = config.onError) === null || _config$onError === void 0 || _config$onError.call(config, error);
            },
            onUnsubscribe: function onUnsubscribe() {
                var _config$onUnsubscribe;
                cleanup(disposable);
                (_config$onUnsubscribe = config.onUnsubscribe) === null || _config$onUnsubscribe === void 0 || _config$onUnsubscribe.call(config);
            },
            onNext: function onNext() {
                var _config$onNext;
                (_config$onNext = config.onNext) === null || _config$onNext === void 0 || _config$onNext.call(config);
            }
        }));
        inFlightMutationsRef.current.add(disposable);
        return disposable;
    }, [
        cleanup,
        commitMutationFn,
        environment,
        isMountedRef,
        mutation
    ]);
    return [
        commit,
        isMutationInFlight
    ];
}
module.exports = useMutation;

},{"1994f82c3167a82f":"590td","936fbbf07c5590c8":"2Bj1n","cab1674bb914c082":"bqjPh","3a2e0417487330ad":"bs9Iy","d873b37c20a3e87":"ltHCL","f3d3c49bcea96c38":"2IxFR"}],"cs6Pn":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("74260e5d3240ad76")["default"];
var _objectSpread2 = _interopRequireDefault(require("772861931c397aff"));
var useLoadMoreFunction = require("f8f2f7fe49079bf");
var useRefetchableFragmentInternal = require("2e9991357388c7ab");
var useRelayEnvironment = require("862b0db33c4b8c1d");
var useStaticFragmentNodeWarning = require("e009dc1f838d8092");
var _require = require("9421470ba1e7b790"), useCallback = _require.useCallback, useDebugValue = _require.useDebugValue, useState = _require.useState;
var _require2 = require("9d207c4f45729b23"), getFragment = _require2.getFragment, getFragmentIdentifier = _require2.getFragmentIdentifier, getPaginationMetadata = _require2.getPaginationMetadata;
function usePaginationFragment(fragmentInput, parentFragmentRef) {
    var fragmentNode = getFragment(fragmentInput);
    useStaticFragmentNodeWarning(fragmentNode, 'first argument of usePaginationFragment()');
    var componentDisplayName = 'usePaginationFragment()';
    var _getPaginationMetadat = getPaginationMetadata(fragmentNode, componentDisplayName), connectionPathInFragmentData = _getPaginationMetadat.connectionPathInFragmentData, paginationRequest = _getPaginationMetadat.paginationRequest, paginationMetadata = _getPaginationMetadat.paginationMetadata;
    var _useRefetchableFragme = useRefetchableFragmentInternal(fragmentNode, parentFragmentRef, componentDisplayName), fragmentData = _useRefetchableFragme.fragmentData, fragmentRef = _useRefetchableFragme.fragmentRef, refetch = _useRefetchableFragme.refetch;
    var fragmentIdentifier = getFragmentIdentifier(fragmentNode, fragmentRef);
    var _useLoadMore = useLoadMore({
        componentDisplayName: componentDisplayName,
        connectionPathInFragmentData: connectionPathInFragmentData,
        direction: 'backward',
        fragmentData: fragmentData,
        fragmentIdentifier: fragmentIdentifier,
        fragmentNode: fragmentNode,
        fragmentRef: fragmentRef,
        paginationMetadata: paginationMetadata,
        paginationRequest: paginationRequest
    }), loadPrevious = _useLoadMore[0], hasPrevious = _useLoadMore[1], isLoadingPrevious = _useLoadMore[2], disposeFetchPrevious = _useLoadMore[3];
    var _useLoadMore2 = useLoadMore({
        componentDisplayName: componentDisplayName,
        connectionPathInFragmentData: connectionPathInFragmentData,
        direction: 'forward',
        fragmentData: fragmentData,
        fragmentIdentifier: fragmentIdentifier,
        fragmentNode: fragmentNode,
        fragmentRef: fragmentRef,
        paginationMetadata: paginationMetadata,
        paginationRequest: paginationRequest
    }), loadNext = _useLoadMore2[0], hasNext = _useLoadMore2[1], isLoadingNext = _useLoadMore2[2], disposeFetchNext = _useLoadMore2[3];
    var refetchPagination = useCallback(function(variables, options) {
        disposeFetchNext();
        disposeFetchPrevious();
        return refetch(variables, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, options), {}, {
            __environment: undefined
        }));
    }, [
        disposeFetchNext,
        disposeFetchPrevious,
        refetch
    ]);
    return {
        data: fragmentData,
        loadNext: loadNext,
        loadPrevious: loadPrevious,
        hasNext: hasNext,
        hasPrevious: hasPrevious,
        isLoadingNext: isLoadingNext,
        isLoadingPrevious: isLoadingPrevious,
        refetch: refetchPagination
    };
}
function useLoadMore(args) {
    var environment = useRelayEnvironment();
    var _useState = useState(false), isLoadingMore = _useState[0], reallySetIsLoadingMore = _useState[1];
    var setIsLoadingMore = function setIsLoadingMore(value) {
        var _environment$getSched;
        var schedule = (_environment$getSched = environment.getScheduler()) === null || _environment$getSched === void 0 ? void 0 : _environment$getSched.schedule;
        if (schedule) schedule(function() {
            reallySetIsLoadingMore(value);
        });
        else reallySetIsLoadingMore(value);
    };
    var observer = {
        start: function start() {
            return setIsLoadingMore(true);
        },
        complete: function complete() {
            return setIsLoadingMore(false);
        },
        error: function error() {
            return setIsLoadingMore(false);
        }
    };
    var handleReset = function handleReset() {
        return setIsLoadingMore(false);
    };
    var _useLoadMoreFunction = useLoadMoreFunction((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, args), {}, {
        observer: observer,
        onReset: handleReset
    })), loadMore = _useLoadMoreFunction[0], hasMore = _useLoadMoreFunction[1], disposeFetch = _useLoadMoreFunction[2];
    return [
        loadMore,
        hasMore,
        isLoadingMore,
        disposeFetch
    ];
}
module.exports = usePaginationFragment;

},{"74260e5d3240ad76":"590td","772861931c397aff":"2Bj1n","f8f2f7fe49079bf":"12mOd","2e9991357388c7ab":"hXj4k","862b0db33c4b8c1d":"bs9Iy","e009dc1f838d8092":"8SJsi","9421470ba1e7b790":"ltHCL","9d207c4f45729b23":"2IxFR"}],"12mOd":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var _interopRequireDefault = require("3ac2587f9e904957")["default"];
var _objectSpread2 = _interopRequireDefault(require("72489d7554b40490"));
var useFetchTrackingRef = require("d1b67a19bb0e9dfe");
var useIsMountedRef = require("c752c06730124926");
var useIsOperationNodeActive = require("ea77eb8e4c5dc9bc");
var useRelayEnvironment = require("30acdd32f952f70b");
var invariant = require("4a5df82bf0f64915");
var _require = require("74b8166276ceae31"), useCallback = _require.useCallback, useEffect = _require.useEffect, useState = _require.useState;
var _require2 = require("d7d30e261b59c6bd"), fetchQuery = _require2.__internal.fetchQuery, ConnectionInterface = _require2.ConnectionInterface, createOperationDescriptor = _require2.createOperationDescriptor, getPaginationVariables = _require2.getPaginationVariables, getRefetchMetadata = _require2.getRefetchMetadata, getSelector = _require2.getSelector, getValueAtPath = _require2.getValueAtPath;
var warning = require("2b34752cc6db60a3");
function useLoadMoreFunction(args) {
    var direction = args.direction, fragmentNode = args.fragmentNode, fragmentRef = args.fragmentRef, fragmentIdentifier = args.fragmentIdentifier, fragmentData = args.fragmentData, connectionPathInFragmentData = args.connectionPathInFragmentData, paginationRequest = args.paginationRequest, paginationMetadata = args.paginationMetadata, componentDisplayName = args.componentDisplayName, observer = args.observer, onReset = args.onReset;
    var environment = useRelayEnvironment();
    var _useFetchTrackingRef = useFetchTrackingRef(), isFetchingRef = _useFetchTrackingRef.isFetchingRef, startFetch = _useFetchTrackingRef.startFetch, disposeFetch = _useFetchTrackingRef.disposeFetch, completeFetch = _useFetchTrackingRef.completeFetch;
    var _getRefetchMetadata = getRefetchMetadata(fragmentNode, componentDisplayName), identifierInfo = _getRefetchMetadata.identifierInfo;
    var identifierValue = (identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) != null && fragmentData != null && (typeof fragmentData === "undefined" ? "undefined" : (0, _typeOf._)(fragmentData)) === 'object' ? fragmentData[identifierInfo.identifierField] : null;
    var isMountedRef = useIsMountedRef();
    var _useState = useState(environment), mirroredEnvironment = _useState[0], setMirroredEnvironment = _useState[1];
    var _useState2 = useState(fragmentIdentifier), mirroredFragmentIdentifier = _useState2[0], setMirroredFragmentIdentifier = _useState2[1];
    var isParentQueryActive = useIsOperationNodeActive(fragmentNode, fragmentRef);
    var shouldReset = environment !== mirroredEnvironment || fragmentIdentifier !== mirroredFragmentIdentifier;
    if (shouldReset) {
        disposeFetch();
        onReset();
        setMirroredEnvironment(environment);
        setMirroredFragmentIdentifier(fragmentIdentifier);
    }
    var _getConnectionState = getConnectionState(direction, fragmentNode, fragmentData, connectionPathInFragmentData), cursor = _getConnectionState.cursor, hasMore = _getConnectionState.hasMore;
    useEffect(function() {
        return function() {
            disposeFetch();
        };
    }, [
        disposeFetch
    ]);
    var loadMore = useCallback(function(count, options) {
        var onComplete = options === null || options === void 0 ? void 0 : options.onComplete;
        if (isMountedRef.current !== true) return {
            dispose: function dispose() {}
        };
        var fragmentSelector = getSelector(fragmentNode, fragmentRef);
        if (isFetchingRef.current === true || fragmentData == null || isParentQueryActive) {
            fragmentSelector;
            if (onComplete) onComplete(null);
            return {
                dispose: function dispose() {}
            };
        }
        !(fragmentSelector != null && fragmentSelector.kind !== 'PluralReaderSelector') && invariant(false);
        var parentVariables = fragmentSelector.owner.variables;
        var fragmentVariables = fragmentSelector.variables;
        var extraVariables = options === null || options === void 0 ? void 0 : options.UNSTABLE_extraVariables;
        var baseVariables = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, parentVariables), fragmentVariables);
        var paginationVariables = getPaginationVariables(direction, count, cursor, baseVariables, (0, _objectSpread2["default"])({}, extraVariables), paginationMetadata);
        if (identifierInfo != null) {
            typeof identifierValue === "undefined" ? "undefined" : (0, _typeOf._)(identifierValue);
            paginationVariables[identifierInfo.identifierQueryVariableName] = identifierValue;
        }
        var paginationQuery = createOperationDescriptor(paginationRequest, paginationVariables, {
            force: true
        });
        fetchQuery(environment, paginationQuery).subscribe((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, observer), {}, {
            start: function start(subscription) {
                startFetch(subscription);
                observer.start && observer.start(subscription);
            },
            complete: function complete() {
                completeFetch();
                observer.complete && observer.complete();
                onComplete && onComplete(null);
            },
            error: function error(_error) {
                completeFetch();
                observer.error && observer.error(_error);
                onComplete && onComplete(_error);
            }
        }));
        return {
            dispose: disposeFetch
        };
    }, [
        environment,
        identifierValue,
        direction,
        cursor,
        startFetch,
        disposeFetch,
        completeFetch,
        isFetchingRef,
        isParentQueryActive,
        fragmentData,
        fragmentNode.name,
        fragmentRef,
        componentDisplayName
    ]);
    return [
        loadMore,
        hasMore,
        disposeFetch
    ];
}
function getConnectionState(direction, fragmentNode, fragmentData, connectionPathInFragmentData) {
    var _pageInfo$END_CURSOR, _pageInfo$START_CURSO;
    var _ConnectionInterface$ = ConnectionInterface.get(), EDGES = _ConnectionInterface$.EDGES, PAGE_INFO = _ConnectionInterface$.PAGE_INFO, HAS_NEXT_PAGE = _ConnectionInterface$.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$.HAS_PREV_PAGE, END_CURSOR = _ConnectionInterface$.END_CURSOR, START_CURSOR = _ConnectionInterface$.START_CURSOR;
    var connection = getValueAtPath(fragmentData, connectionPathInFragmentData);
    if (connection == null) return {
        cursor: null,
        hasMore: false
    };
    !((typeof connection === "undefined" ? "undefined" : (0, _typeOf._)(connection)) === 'object') && invariant(false);
    var edges = connection[EDGES];
    var pageInfo = connection[PAGE_INFO];
    if (edges == null || pageInfo == null) return {
        cursor: null,
        hasMore: false
    };
    !Array.isArray(edges) && invariant(false);
    !((typeof pageInfo === "undefined" ? "undefined" : (0, _typeOf._)(pageInfo)) === 'object') && invariant(false);
    var cursor = direction === 'forward' ? (_pageInfo$END_CURSOR = pageInfo[END_CURSOR]) !== null && _pageInfo$END_CURSOR !== void 0 ? _pageInfo$END_CURSOR : null : (_pageInfo$START_CURSO = pageInfo[START_CURSOR]) !== null && _pageInfo$START_CURSO !== void 0 ? _pageInfo$START_CURSO : null;
    !(cursor === null || typeof cursor === 'string') && invariant(false);
    var hasMore;
    if (direction === 'forward') hasMore = cursor != null && pageInfo[HAS_NEXT_PAGE] === true;
    else hasMore = cursor != null && pageInfo[HAS_PREV_PAGE] === true;
    return {
        cursor: cursor,
        hasMore: hasMore
    };
}
module.exports = useLoadMoreFunction;

},{"@swc/helpers/_/_type_of":"iFJdx","3ac2587f9e904957":"590td","72489d7554b40490":"2Bj1n","d1b67a19bb0e9dfe":"inPRo","c752c06730124926":"bqjPh","ea77eb8e4c5dc9bc":"e43Xv","30acdd32f952f70b":"bs9Iy","4a5df82bf0f64915":"e2sci","74b8166276ceae31":"ltHCL","d7d30e261b59c6bd":"2IxFR","2b34752cc6db60a3":"j64TH"}],"e43Xv":[function(require,module,exports,__globalThis) {
'use strict';
var useRelayEnvironment = require("34a4af4ec66704d3");
var invariant = require("a9eeef1c36adce8d");
var React = require("7999654593a1e9d0");
var _require = require("5882e5c2a2d502a7"), getObservableForActiveRequest = _require.__internal.getObservableForActiveRequest, getSelector = _require.getSelector;
var useEffect = React.useEffect, useState = React.useState, useMemo = React.useMemo;
function useIsOperationNodeActive(fragmentNode, fragmentRef) {
    var environment = useRelayEnvironment();
    var observable = useMemo(function() {
        var selector = getSelector(fragmentNode, fragmentRef);
        if (selector == null) return null;
        !(selector.kind === 'SingularReaderSelector') && invariant(false);
        return getObservableForActiveRequest(environment, selector.owner);
    }, [
        environment,
        fragmentNode,
        fragmentRef
    ]);
    var _useState = useState(observable != null), isActive = _useState[0], setIsActive = _useState[1];
    useEffect(function() {
        var subscription;
        setIsActive(observable != null);
        if (observable != null) {
            var onCompleteOrError = function onCompleteOrError() {
                setIsActive(false);
            };
            subscription = observable.subscribe({
                complete: onCompleteOrError,
                error: onCompleteOrError
            });
        }
        return function() {
            if (subscription) subscription.unsubscribe();
        };
    }, [
        observable
    ]);
    return isActive;
}
module.exports = useIsOperationNodeActive;

},{"34a4af4ec66704d3":"bs9Iy","a9eeef1c36adce8d":"e2sci","7999654593a1e9d0":"ltHCL","5882e5c2a2d502a7":"2IxFR"}],"hXj4k":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var _interopRequireDefault = require("ac693a74629df594")["default"];
var _objectSpread2 = _interopRequireDefault(require("c2b913b1851b218a"));
var ProfilerContext = require("f6820d7f5df5337b");
var _require = require("9d858f0e1a8ac95c"), getQueryResourceForEnvironment = _require.getQueryResourceForEnvironment;
var readFragmentInternal = require("eb48c040dcb4cd95");
var useFragmentInternal = require("5ab498c4c84970c9");
var useIsMountedRef = require("a1154bcf0d8e0071");
var useQueryLoader = require("9df04fa0964dc0ce");
var useRelayEnvironment = require("8ee3403724de62d9");
var invariant = require("dcd3b70efb9bc004");
var _require2 = require("3bb81a8e463dc0db"), useCallback = _require2.useCallback, useContext = _require2.useContext, useReducer = _require2.useReducer;
var _require3 = require("6a2e661e8095583a"), fetchQuery = _require3.__internal.fetchQuery, createOperationDescriptor = _require3.createOperationDescriptor, getFragmentIdentifier = _require3.getFragmentIdentifier, getRefetchMetadata = _require3.getRefetchMetadata, getSelector = _require3.getSelector, getValueAtPath = _require3.getValueAtPath;
var warning = require("a9824c52910444e6");
function reducer(state, action) {
    switch(action.type){
        case 'refetch':
            var _action$refetchEnviro;
            return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, state), {}, {
                fetchPolicy: action.fetchPolicy,
                mirroredEnvironment: (_action$refetchEnviro = action.refetchEnvironment) !== null && _action$refetchEnviro !== void 0 ? _action$refetchEnviro : state.mirroredEnvironment,
                onComplete: action.onComplete,
                refetchEnvironment: action.refetchEnvironment,
                refetchQuery: action.refetchQuery,
                renderPolicy: action.renderPolicy
            });
        case 'reset':
            return {
                fetchPolicy: undefined,
                mirroredEnvironment: action.environment,
                mirroredFragmentIdentifier: action.fragmentIdentifier,
                onComplete: undefined,
                refetchQuery: null,
                renderPolicy: undefined
            };
        default:
            action.type;
            throw new Error('useRefetchableFragmentNode: Unexpected action type');
    }
}
function useRefetchableFragmentNode(fragmentNode, parentFragmentRef, componentDisplayName) {
    var parentEnvironment = useRelayEnvironment();
    var _getRefetchMetadata = getRefetchMetadata(fragmentNode, componentDisplayName), refetchableRequest = _getRefetchMetadata.refetchableRequest, fragmentRefPathInResponse = _getRefetchMetadata.fragmentRefPathInResponse, identifierInfo = _getRefetchMetadata.identifierInfo;
    var fragmentIdentifier = getFragmentIdentifier(fragmentNode, parentFragmentRef);
    var _useReducer = useReducer(reducer, {
        fetchPolicy: undefined,
        mirroredEnvironment: parentEnvironment,
        mirroredFragmentIdentifier: fragmentIdentifier,
        onComplete: undefined,
        refetchEnvironment: null,
        refetchQuery: null,
        renderPolicy: undefined
    }), refetchState = _useReducer[0], dispatch = _useReducer[1];
    var fetchPolicy = refetchState.fetchPolicy, mirroredEnvironment = refetchState.mirroredEnvironment, mirroredFragmentIdentifier = refetchState.mirroredFragmentIdentifier, onComplete = refetchState.onComplete, refetchEnvironment = refetchState.refetchEnvironment, refetchQuery = refetchState.refetchQuery, renderPolicy = refetchState.renderPolicy;
    var environment = refetchEnvironment !== null && refetchEnvironment !== void 0 ? refetchEnvironment : parentEnvironment;
    var QueryResource = getQueryResourceForEnvironment(environment);
    var profilerContext = useContext(ProfilerContext);
    var shouldReset = environment !== mirroredEnvironment || fragmentIdentifier !== mirroredFragmentIdentifier;
    var _useQueryLoader = useQueryLoader(refetchableRequest), queryRef = _useQueryLoader[0], loadQuery = _useQueryLoader[1], disposeQuery = _useQueryLoader[2];
    var fragmentRef = parentFragmentRef;
    if (shouldReset) {
        dispatch({
            type: 'reset',
            environment: environment,
            fragmentIdentifier: fragmentIdentifier
        });
        disposeQuery();
    } else if (refetchQuery != null && queryRef != null) {
        var debugPreviousIDAndTypename;
        var handleQueryCompleted = function handleQueryCompleted(maybeError) {
            onComplete && onComplete(maybeError !== null && maybeError !== void 0 ? maybeError : null);
        };
        var fetchObservable = queryRef.source != null ? queryRef.source : fetchQuery(environment, refetchQuery);
        var queryResult = profilerContext.wrapPrepareQueryResource(function() {
            return QueryResource.prepare(refetchQuery, fetchObservable, fetchPolicy, renderPolicy, {
                error: handleQueryCompleted,
                complete: function complete() {
                    handleQueryCompleted();
                }
            }, queryRef.fetchKey, profilerContext);
        });
        var queryData = readFragmentInternal(environment, queryResult.fragmentNode, queryResult.fragmentRef, componentDisplayName).data;
        !(queryData != null) && invariant(false);
        var refetchedFragmentRef = getValueAtPath(queryData, fragmentRefPathInResponse);
        fragmentRef = refetchedFragmentRef;
    }
    var fragmentData = useFragmentInternal(fragmentNode, fragmentRef, componentDisplayName);
    var refetch = useRefetchFunction(componentDisplayName, dispatch, disposeQuery, fragmentData, fragmentIdentifier, fragmentNode, fragmentRefPathInResponse, identifierInfo, loadQuery, parentFragmentRef, refetchableRequest);
    return {
        fragmentData: fragmentData,
        fragmentRef: fragmentRef,
        refetch: refetch
    };
}
function useRefetchFunction(componentDisplayName, dispatch, disposeQuery, fragmentData, fragmentIdentifier, fragmentNode, fragmentRefPathInResponse, identifierInfo, loadQuery, parentFragmentRef, refetchableRequest) {
    var isMountedRef = useIsMountedRef();
    var identifierValue = (identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) != null && fragmentData != null && (typeof fragmentData === "undefined" ? "undefined" : (0, _typeOf._)(fragmentData)) === 'object' ? fragmentData[identifierInfo.identifierField] : null;
    return useCallback(function(providedRefetchVariables, options) {
        if (isMountedRef.current !== true) return {
            dispose: function dispose() {}
        };
        parentFragmentRef;
        var refetchEnvironment = options === null || options === void 0 ? void 0 : options.__environment;
        var fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy;
        var renderPolicy = options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy;
        var onComplete = options === null || options === void 0 ? void 0 : options.onComplete;
        var fragmentSelector = getSelector(fragmentNode, parentFragmentRef);
        var parentVariables;
        var fragmentVariables;
        if (fragmentSelector == null) {
            parentVariables = {};
            fragmentVariables = {};
        } else if (fragmentSelector.kind === 'PluralReaderSelector') {
            var _fragmentSelector$sel, _fragmentSelector$sel2, _fragmentSelector$sel3, _fragmentSelector$sel4;
            parentVariables = (_fragmentSelector$sel = (_fragmentSelector$sel2 = fragmentSelector.selectors[0]) === null || _fragmentSelector$sel2 === void 0 ? void 0 : _fragmentSelector$sel2.owner.variables) !== null && _fragmentSelector$sel !== void 0 ? _fragmentSelector$sel : {};
            fragmentVariables = (_fragmentSelector$sel3 = (_fragmentSelector$sel4 = fragmentSelector.selectors[0]) === null || _fragmentSelector$sel4 === void 0 ? void 0 : _fragmentSelector$sel4.variables) !== null && _fragmentSelector$sel3 !== void 0 ? _fragmentSelector$sel3 : {};
        } else {
            parentVariables = fragmentSelector.owner.variables;
            fragmentVariables = fragmentSelector.variables;
        }
        var refetchVariables = (0, _objectSpread2["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, parentVariables), fragmentVariables), providedRefetchVariables);
        if (identifierInfo != null && !providedRefetchVariables.hasOwnProperty(identifierInfo.identifierQueryVariableName)) {
            typeof identifierValue === "undefined" ? "undefined" : (0, _typeOf._)(identifierValue);
            refetchVariables[identifierInfo.identifierQueryVariableName] = identifierValue;
        }
        var refetchQuery = createOperationDescriptor(refetchableRequest, refetchVariables, {
            force: true
        });
        loadQuery(refetchQuery.request.variables, {
            fetchPolicy: fetchPolicy,
            __environment: refetchEnvironment,
            __nameForWarning: 'refetch'
        });
        dispatch({
            type: 'refetch',
            fetchPolicy: fetchPolicy,
            onComplete: onComplete,
            refetchEnvironment: refetchEnvironment,
            refetchQuery: refetchQuery,
            renderPolicy: renderPolicy
        });
        return {
            dispose: disposeQuery
        };
    }, [
        fragmentIdentifier,
        dispatch,
        disposeQuery,
        identifierValue,
        loadQuery
    ]);
}
var debugFunctions;
module.exports = useRefetchableFragmentNode;

},{"@swc/helpers/_/_type_of":"iFJdx","ac693a74629df594":"590td","c2b913b1851b218a":"2Bj1n","f6820d7f5df5337b":"1lEHI","9d858f0e1a8ac95c":"gv1jq","eb48c040dcb4cd95":"j6ktb","5ab498c4c84970c9":"eglKT","a1154bcf0d8e0071":"bqjPh","9df04fa0964dc0ce":"aiqzn","8ee3403724de62d9":"bs9Iy","dcd3b70efb9bc004":"e2sci","3bb81a8e463dc0db":"ltHCL","6a2e661e8095583a":"2IxFR","a9824c52910444e6":"j64TH"}],"j6ktb":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("f9511564d4e9b960")["default"];
var _objectSpread2 = _interopRequireDefault(require("353c94e2095de9f4"));
var _createForOfIteratorHelper2 = _interopRequireDefault(require("55fb6ea8634dae59"));
var _require = require("6f3b0159c357784c"), getQueryResourceForEnvironment = _require.getQueryResourceForEnvironment;
var invariant = require("879622bbb6c4bca3");
var _require2 = require("17db8300b5c33f37"), fetchQueryInternal = _require2.__internal.fetchQuery, RelayFeatureFlags = _require2.RelayFeatureFlags, createOperationDescriptor = _require2.createOperationDescriptor, getPendingOperationsForFragment = _require2.getPendingOperationsForFragment, getSelector = _require2.getSelector, getVariablesFromFragment = _require2.getVariablesFromFragment, handlePotentialSnapshotErrors = _require2.handlePotentialSnapshotErrors;
var warning = require("646f64ee7fb37967");
function isMissingData(state) {
    if (state.kind === 'bailout') return false;
    else if (state.kind === 'singular') return state.snapshot.isMissingData;
    else return state.snapshots.some(function(s) {
        return s.isMissingData;
    });
}
function getMissingClientEdges(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi;
        return (_state$snapshot$missi = state.snapshot.missingClientEdges) !== null && _state$snapshot$missi !== void 0 ? _state$snapshot$missi : null;
    } else {
        var edges = null;
        var _iterator = (0, _createForOfIteratorHelper2["default"])(state.snapshots), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var snapshot = _step.value;
                if (snapshot.missingClientEdges) {
                    var _edges;
                    edges = (_edges = edges) !== null && _edges !== void 0 ? _edges : [];
                    var _iterator2 = (0, _createForOfIteratorHelper2["default"])(snapshot.missingClientEdges), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var edge = _step2.value;
                            edges.push(edge);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return edges;
    }
}
function handlePotentialSnapshotErrorsForState(environment, state) {
    if (state.kind === 'singular') {
        var _state$snapshot$selec, _state$snapshot$selec2;
        handlePotentialSnapshotErrors(environment, state.snapshot.missingRequiredFields, state.snapshot.relayResolverErrors, state.snapshot.errorResponseFields, (_state$snapshot$selec = (_state$snapshot$selec2 = state.snapshot.selector.node.metadata) === null || _state$snapshot$selec2 === void 0 ? void 0 : _state$snapshot$selec2.throwOnFieldError) !== null && _state$snapshot$selec !== void 0 ? _state$snapshot$selec : false);
    } else if (state.kind === 'plural') {
        var _iterator3 = (0, _createForOfIteratorHelper2["default"])(state.snapshots), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var _snapshot$selector$no, _snapshot$selector$no2;
                var snapshot = _step3.value;
                handlePotentialSnapshotErrors(environment, snapshot.missingRequiredFields, snapshot.relayResolverErrors, snapshot.errorResponseFields, (_snapshot$selector$no = (_snapshot$selector$no2 = snapshot.selector.node.metadata) === null || _snapshot$selector$no2 === void 0 ? void 0 : _snapshot$selector$no2.throwOnFieldError) !== null && _snapshot$selector$no !== void 0 ? _snapshot$selector$no : false);
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
    }
}
function handleMissingClientEdge(environment, parentFragmentNode, parentFragmentRef, missingClientEdgeRequestInfo, queryOptions) {
    var originalVariables = getVariablesFromFragment(parentFragmentNode, parentFragmentRef);
    var variables = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, originalVariables), {}, {
        id: missingClientEdgeRequestInfo.clientEdgeDestinationID
    });
    var queryOperationDescriptor = createOperationDescriptor(missingClientEdgeRequestInfo.request, variables, queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.networkCacheConfig);
    var QueryResource = getQueryResourceForEnvironment(environment);
    return QueryResource.prepare(queryOperationDescriptor, fetchQueryInternal(environment, queryOperationDescriptor), queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.fetchPolicy);
}
function getFragmentState(environment, fragmentSelector) {
    if (fragmentSelector == null) return {
        kind: 'bailout'
    };
    else if (fragmentSelector.kind === 'PluralReaderSelector') {
        if (fragmentSelector.selectors.length === 0) return {
            kind: 'bailout'
        };
        else return {
            kind: 'plural',
            snapshots: fragmentSelector.selectors.map(function(s) {
                return environment.lookup(s);
            }),
            epoch: environment.getStore().getEpoch()
        };
    } else return {
        kind: 'singular',
        snapshot: environment.lookup(fragmentSelector),
        epoch: environment.getStore().getEpoch()
    };
}
function readFragmentInternal(environment, fragmentNode, fragmentRef, hookDisplayName, queryOptions, fragmentKey) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var fragmentSelector = getSelector(fragmentNode, fragmentRef);
    var isPlural = (fragmentNode === null || fragmentNode === void 0 ? void 0 : (_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) === true;
    if (isPlural) !(fragmentRef == null || Array.isArray(fragmentRef)) && invariant(false);
    else !!Array.isArray(fragmentRef) && invariant(false);
    !(fragmentRef == null || isPlural && Array.isArray(fragmentRef) && fragmentRef.length === 0 || fragmentSelector != null) && invariant(false);
    var state = getFragmentState(environment, fragmentSelector);
    var clientEdgeQueries = null;
    if (((_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.hasClientEdges) === true) {
        var missingClientEdges = getMissingClientEdges(state);
        if (missingClientEdges !== null && missingClientEdges !== void 0 && missingClientEdges.length) {
            clientEdgeQueries = [];
            var _iterator4 = (0, _createForOfIteratorHelper2["default"])(missingClientEdges), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var edge = _step4.value;
                    clientEdgeQueries.push(handleMissingClientEdge(environment, fragmentNode, fragmentRef, edge, queryOptions));
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
    }
    if (isMissingData(state)) {
        !(fragmentSelector != null) && invariant(false);
        var fragmentOwner = fragmentSelector.kind === 'PluralReaderSelector' ? fragmentSelector.selectors[0].owner : fragmentSelector.owner;
        var pendingOperationsResult = getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner);
        if (pendingOperationsResult) throw pendingOperationsResult.promise;
        handlePotentialSnapshotErrorsForState(environment, state);
    }
    var data;
    if (state.kind === 'bailout') data = isPlural ? [] : null;
    else if (state.kind === 'singular') data = state.snapshot.data;
    else data = state.snapshots.map(function(s) {
        return s.data;
    });
    if (RelayFeatureFlags.LOG_MISSING_RECORDS_IN_PROD || false) fragmentRef != null && (data === undefined || Array.isArray(data) && data.length > 0 && data.every(function(d) {
        return d === undefined;
    }));
    return {
        data: data,
        clientEdgeQueries: clientEdgeQueries
    };
}
module.exports = readFragmentInternal;

},{"f9511564d4e9b960":"590td","353c94e2095de9f4":"2Bj1n","55fb6ea8634dae59":"fMaLa","6f3b0159c357784c":"gv1jq","879622bbb6c4bca3":"e2sci","17db8300b5c33f37":"2IxFR","646f64ee7fb37967":"j64TH"}],"aiqzn":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("6cb2c3ccc52d3e04")["default"];
var _createForOfIteratorHelper2 = _interopRequireDefault(require("4773fb1810474084"));
var _require = require("24bfc0805031a111"), loadQuery = _require.loadQuery, useTrackLoadQueryInRender = _require.useTrackLoadQueryInRender;
var useIsMountedRef = require("da71897690c52194");
var useRelayEnvironment = require("e8162fbbf271eb8b");
var _require2 = require("6a5f1a721fab6555"), useCallback = _require2.useCallback, useEffect = _require2.useEffect, useRef = _require2.useRef, useState = _require2.useState;
var _require3 = require("b2e8a9e462cb557b"), getRequest = _require3.getRequest;
var initialNullQueryReferenceState = {
    kind: 'NullQueryReference'
};
function requestIsLiveQuery(preloadableRequest) {
    if (preloadableRequest.kind === 'PreloadableConcreteRequest') return preloadableRequest.params.metadata.live !== undefined;
    var request = getRequest(preloadableRequest);
    return request.params.metadata.live !== undefined;
}
function useQueryLoader(preloadableRequest, initialQueryReference) {
    var initialQueryReferenceInternal = initialQueryReference !== null && initialQueryReference !== void 0 ? initialQueryReference : initialNullQueryReferenceState;
    var environment = useRelayEnvironment();
    useTrackLoadQueryInRender();
    var isMountedRef = useIsMountedRef();
    var undisposedQueryReferencesRef = useRef(new Set([
        initialQueryReferenceInternal
    ]));
    var _useState = useState(function() {
        return initialQueryReferenceInternal;
    }), queryReference = _useState[0], setQueryReference = _useState[1];
    var _useState2 = useState(function() {
        return initialQueryReferenceInternal;
    }), previousInitialQueryReference = _useState2[0], setPreviousInitialQueryReference = _useState2[1];
    if (initialQueryReferenceInternal !== previousInitialQueryReference) {
        undisposedQueryReferencesRef.current.add(initialQueryReferenceInternal);
        setPreviousInitialQueryReference(initialQueryReferenceInternal);
        setQueryReference(initialQueryReferenceInternal);
    }
    var disposeQuery = useCallback(function() {
        if (isMountedRef.current) {
            undisposedQueryReferencesRef.current.add(initialNullQueryReferenceState);
            setQueryReference(initialNullQueryReferenceState);
        }
    }, [
        isMountedRef
    ]);
    var queryLoaderCallback = useCallback(function(variables, options) {
        var mergedOptions = options != null && options.hasOwnProperty('__environment') ? {
            fetchPolicy: options.fetchPolicy,
            networkCacheConfig: options.networkCacheConfig,
            __nameForWarning: options.__nameForWarning
        } : options;
        if (isMountedRef.current) {
            var _options$__environmen;
            var updatedQueryReference = loadQuery((_options$__environmen = options === null || options === void 0 ? void 0 : options.__environment) !== null && _options$__environmen !== void 0 ? _options$__environmen : environment, preloadableRequest, variables, mergedOptions);
            undisposedQueryReferencesRef.current.add(updatedQueryReference);
            setQueryReference(updatedQueryReference);
        }
    }, [
        environment,
        preloadableRequest,
        setQueryReference,
        isMountedRef
    ]);
    var maybeHiddenOrFastRefresh = useRef(false);
    useEffect(function() {
        return function() {
            maybeHiddenOrFastRefresh.current = true;
        };
    }, []);
    useEffect(function() {
        if (maybeHiddenOrFastRefresh.current === true) {
            maybeHiddenOrFastRefresh.current = false;
            if (queryReference.kind !== 'NullQueryReference') queryLoaderCallback(queryReference.variables, {
                fetchPolicy: queryReference.fetchPolicy,
                networkCacheConfig: queryReference.networkCacheConfig
            });
            return;
        }
        var undisposedQueryReferences = undisposedQueryReferencesRef.current;
        if (isMountedRef.current) {
            var _iterator = (0, _createForOfIteratorHelper2["default"])(undisposedQueryReferences), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var undisposedQueryReference = _step.value;
                    if (undisposedQueryReference === queryReference) break;
                    undisposedQueryReferences["delete"](undisposedQueryReference);
                    if (undisposedQueryReference.kind !== 'NullQueryReference') {
                        if (requestIsLiveQuery(preloadableRequest)) undisposedQueryReference.dispose && undisposedQueryReference.dispose();
                        else undisposedQueryReference.releaseQuery && undisposedQueryReference.releaseQuery();
                    }
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    }, [
        queryReference,
        isMountedRef,
        queryLoaderCallback,
        preloadableRequest
    ]);
    useEffect(function() {
        return function disposeAllRemainingQueryReferences() {
            var _iterator2 = (0, _createForOfIteratorHelper2["default"])(undisposedQueryReferencesRef.current), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var undisposedQueryReference = _step2.value;
                    if (undisposedQueryReference.kind !== 'NullQueryReference') {
                        if (requestIsLiveQuery(preloadableRequest)) undisposedQueryReference.dispose && undisposedQueryReference.dispose();
                        else undisposedQueryReference.releaseQuery && undisposedQueryReference.releaseQuery();
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        };
    }, [
        preloadableRequest
    ]);
    return [
        queryReference.kind === 'NullQueryReference' ? null : queryReference,
        queryLoaderCallback,
        disposeQuery
    ];
}
module.exports = useQueryLoader;

},{"6cb2c3ccc52d3e04":"590td","4773fb1810474084":"fMaLa","24bfc0805031a111":"4CbeJ","da71897690c52194":"bqjPh","e8162fbbf271eb8b":"bs9Iy","6a5f1a721fab6555":"ltHCL","b2e8a9e462cb557b":"2IxFR"}],"kylpw":[function(require,module,exports,__globalThis) {
'use strict';
var _require = require("58ad122c743a392b"), useTrackLoadQueryInRender = _require.useTrackLoadQueryInRender;
var useLazyLoadQueryNode = require("d8c29bce88644c1b");
var useMemoOperationDescriptor = require("7a3bee09b3b68737");
var useRelayEnvironment = require("3accb8a1eda38479");
var invariant = require("b920cef8fdc4e114");
var _require2 = require("f9c9cce025e39e75"), useDebugValue = _require2.useDebugValue;
var _require3 = require("2d5bd0b0adc0aa47"), _require3$__internal = _require3.__internal, fetchQueryDeduped = _require3$__internal.fetchQueryDeduped, fetchQuery = _require3$__internal.fetchQuery;
var warning = require("b3dcf06d284b5853");
function usePreloadedQuery(gqlQuery, preloadedQuery, options) {
    useTrackLoadQueryInRender();
    var environment = useRelayEnvironment();
    var fetchKey = preloadedQuery.fetchKey, fetchPolicy = preloadedQuery.fetchPolicy, source = preloadedQuery.source, variables = preloadedQuery.variables, networkCacheConfig = preloadedQuery.networkCacheConfig;
    var operation = useMemoOperationDescriptor(gqlQuery, variables, networkCacheConfig);
    var useLazyLoadQueryNodeParams;
    if (preloadedQuery.kind === 'PreloadedQuery_DEPRECATED') {
        !(operation.request.node.params.name === preloadedQuery.name) && invariant(false);
        useLazyLoadQueryNodeParams = {
            componentDisplayName: 'usePreloadedQuery()',
            fetchKey: fetchKey,
            fetchObservable: fetchQueryDeduped(environment, operation.request.identifier, function() {
                if (environment === preloadedQuery.environment && source != null) return environment.executeWithSource({
                    operation: operation,
                    source: source
                });
                else return environment.execute({
                    operation: operation
                });
            }),
            fetchPolicy: fetchPolicy,
            query: operation,
            renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
        };
    } else {
        var fallbackFetchObservable = fetchQuery(environment, operation);
        var fetchObservable;
        if (source != null && environment === preloadedQuery.environment) fetchObservable = source.ifEmpty(fallbackFetchObservable);
        else if (environment !== preloadedQuery.environment) fetchObservable = fallbackFetchObservable;
        else fetchObservable = fallbackFetchObservable;
        useLazyLoadQueryNodeParams = {
            componentDisplayName: 'usePreloadedQuery()',
            fetchObservable: fetchObservable,
            fetchKey: fetchKey,
            fetchPolicy: fetchPolicy,
            query: operation,
            renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
        };
    }
    var data = useLazyLoadQueryNode(useLazyLoadQueryNodeParams);
    return data;
}
module.exports = usePreloadedQuery;

},{"58ad122c743a392b":"4CbeJ","d8c29bce88644c1b":"lkkQW","7a3bee09b3b68737":"jnI2X","3accb8a1eda38479":"bs9Iy","b920cef8fdc4e114":"e2sci","f9c9cce025e39e75":"ltHCL","2d5bd0b0adc0aa47":"2IxFR","b3dcf06d284b5853":"j64TH"}],"d2wqG":[function(require,module,exports,__globalThis) {
'use strict';
var useRefetchableFragmentInternal = require("1bb8827613203547");
var useStaticFragmentNodeWarning = require("699e141ab7bb354c");
var _require = require("1bbe14359652b7a7"), useDebugValue = _require.useDebugValue;
var _require2 = require("19361f6b5d849593"), getFragment = _require2.getFragment;
function useRefetchableFragment(fragmentInput, fragmentRef) {
    var fragmentNode = getFragment(fragmentInput);
    useStaticFragmentNodeWarning(fragmentNode, 'first argument of useRefetchableFragment()');
    var _useRefetchableFragme = useRefetchableFragmentInternal(fragmentNode, fragmentRef, 'useRefetchableFragment()'), fragmentData = _useRefetchableFragme.fragmentData, refetch = _useRefetchableFragme.refetch;
    return [
        fragmentData,
        refetch
    ];
}
module.exports = useRefetchableFragment;

},{"1bb8827613203547":"hXj4k","699e141ab7bb354c":"8SJsi","1bbe14359652b7a7":"ltHCL","19361f6b5d849593":"2IxFR"}],"dtX5o":[function(require,module,exports,__globalThis) {
'use strict';
var useRelayEnvironment = require("965b410d6fdf912d");
var _require = require("cf792cab208ff041"), useEffect = _require.useEffect, useRef = _require.useRef;
function useSubscribeToInvalidationState(dataIDs, callback) {
    var environment = useRelayEnvironment();
    var disposableRef = useRef(null);
    var stableDataIDs = Array.from(dataIDs).sort().join('');
    useEffect(function() {
        var store = environment.getStore();
        var invalidationState = store.lookupInvalidationState(dataIDs);
        var disposable = store.subscribeToInvalidationState(invalidationState, callback);
        disposableRef.current = disposable;
        return function() {
            return disposable.dispose();
        };
    }, [
        stableDataIDs,
        callback,
        environment
    ]);
    return {
        dispose: function dispose() {
            if (disposableRef.current != null) disposableRef.current.dispose();
        }
    };
}
module.exports = useSubscribeToInvalidationState;

},{"965b410d6fdf912d":"bs9Iy","cf792cab208ff041":"ltHCL"}],"6fzbF":[function(require,module,exports,__globalThis) {
'use strict';
var useRelayEnvironment = require("6ed4f7e3e22d401f");
var _require = require("e0162fa9badbe1e7"), useEffect = _require.useEffect;
var _require2 = require("86d88eec160104fb"), requestSubscription = _require2.requestSubscription;
function useSubscription(config, requestSubscriptionFn) {
    var actualRequestSubscription = requestSubscriptionFn !== null && requestSubscriptionFn !== void 0 ? requestSubscriptionFn : requestSubscription;
    var environment = useRelayEnvironment();
    useEffect(function() {
        var _actualRequestSubscri = actualRequestSubscription(environment, config), dispose = _actualRequestSubscri.dispose;
        return dispose;
    }, [
        environment,
        config,
        actualRequestSubscription
    ]);
}
module.exports = useSubscription;

},{"6ed4f7e3e22d401f":"bs9Iy","e0162fa9badbe1e7":"ltHCL","86d88eec160104fb":"2IxFR"}],"gb3aE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ssrCache", function() {
    return ssrCache;
});
parcelHelpers.export(exports, "__INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__", function() {
    return __INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__;
});
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _createRelayEnvironment = require("@atlassian/relay-environment/createRelayEnvironment");
var _relayErrors = require("@atlassian/relay-errors");
var _relayQueryResponses = require("@atlassian/relay-query-responses");
var getLoggingAndMetricsHelper = function() {
    return {
        logNonBreakingErrors: function() {},
        logError: function() {},
        logErrorRetry: function() {},
        logQueryFallbackToPost: function() {}
    };
};
var ssrCache = new (0, _relayQueryResponses.SSRQueryResponseCache)({
    cacheName: 'relay-cache/v2/AGG',
    size: Infinity,
    ttl: Infinity
});
var __INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__ = (0, _createRelayEnvironment.createRelayEnvironment)({
    networkOptions: {
        getLoggingAndMetricsHelper: getLoggingAndMetricsHelper,
        withErrorHandling: function(source) {
            return source;
        },
        validateResponse: function(request, response) {
            var errors = 'errors' in response ? response.errors : undefined;
            if (errors != null) {
                var _response_extensions_gateway, _response_extensions;
                var requestId = response === null || response === void 0 ? void 0 : (_response_extensions = response.extensions) === null || _response_extensions === void 0 ? void 0 : (_response_extensions_gateway = _response_extensions.gateway) === null || _response_extensions_gateway === void 0 ? void 0 : _response_extensions_gateway.request_id;
                (0, _relayErrors.captureErrors)(errors, {
                    operationName: request.name,
                    requestId: requestId
                });
                if ((0, _platformFeatureFlags.fg)('platform_relay_redirect_on_step_up_auth_studio')) {
                    var _isStepUpAuthError = (0, _relayErrors.isStepUpAuthError)(errors), hasStepUpAuthError = _isStepUpAuthError.hasStepUpAuthError, stepUpUrl = _isStepUpAuthError.stepUpUrl;
                    // Guard against SSR: window is not defined in server-side rendering environments.
                    // RelayEnvironmentProvider is used by platform components (e.g. GlobalSideNavigation)
                    // during SSR — validateResponse may be called during renderToString where window
                    // does not exist. Without this guard, a step-up auth error would throw
                    // ReferenceError and crash the entire SSR render.
                    if (hasStepUpAuthError && stepUpUrl && typeof window !== 'undefined') window.location.href = stepUpUrl;
                }
            }
            return true;
        },
        onInvalidResponse: function() {},
        queryResponseCache: ssrCache,
        // Use typeof window === 'undefined' for SSR detection rather than globalThis.__SERVER__.
        // __SERVER__ is set in tests but not in Bifrost's actual SSR environment (it's set in
        // init() which runs after module evaluation). typeof window === 'undefined' is the
        // standard pattern and correctly identifies both Bifrost SSR and test environments.
        isServer: typeof window === 'undefined'
    }
});

},{"@atlaskit/platform-feature-flags":"kO5t9","@atlassian/relay-environment/createRelayEnvironment":"9lTB2","@atlassian/relay-errors":"i8pdE","@atlassian/relay-query-responses":"8d2kf","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9lTB2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createRelayEnvironment", function() {
    return createRelayEnvironment;
});
var _relayRuntime = require("relay-runtime");
var _liveResolverStore = require("relay-runtime/lib/store/experimental-live-resolvers/LiveResolverStore");
var _liveResolverStoreDefault = parcelHelpers.interopDefault(_liveResolverStore);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var _relayDataId = require("@atlassian/relay-data-id");
var _relayDataIdDefault = parcelHelpers.interopDefault(_relayDataId);
var _multiFetch = require("@atlassian/relay-fetch/multi-fetch");
var _relayMissingFieldHandlers = require("@atlassian/relay-missing-field-handlers");
var _relayMissingFieldHandlersDefault = parcelHelpers.interopDefault(_relayMissingFieldHandlers);
var _relayScheduler = require("@atlassian/relay-scheduler");
var _relaySchedulerDefault = parcelHelpers.interopDefault(_relayScheduler);
var _relaySubscription = require("@atlassian/relay-subscription");
// Enable Relay Resolvers globally for this module
(0, _relayRuntime.RelayFeatureFlags).ENABLE_RELAY_RESOLVERS = true;
function createNetwork(networkOptions) {
    return (0, _relayRuntime.Network).create(function(request, variables, cacheConfig) {
        return (0, _multiFetch.fetch)(request, variables, cacheConfig, networkOptions);
    }, networkOptions.isServer === false ? (0, _relaySubscription.createSubscribeFn)(networkOptions) : undefined);
}
var createStore = function(source, options) {
    return new (0, _liveResolverStoreDefault.default)(source, options);
};
// Copied from ConnectionHandler.deleteNode implementation with a single change in behaviour:
// nodeID is compared to the `id` field of the node, rather than node.getDataID().
// This is a sane thing to do within the scope of a single connection even in the light of
// id collisions present in AGG for the entities of different types.
// Such change makes @deleteEdge directive usable again.
function deleteNode(record, nodeID) {
    var _ConnectionInterface_get = (0, _relayRuntime.ConnectionInterface).get(), EDGES = _ConnectionInterface_get.EDGES, NODE = _ConnectionInterface_get.NODE;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) return;
    var nextEdges;
    for(var ii = 0; ii < edges.length; ii++){
        var edge = edges[ii];
        var node = edge && edge.getLinkedRecord(NODE);
        // N.B. node.getValue('id') instead of node.getDataID()
        if (node != null && node.getValue('id') === nodeID) {
            if (nextEdges === undefined) nextEdges = edges.slice(0, ii);
        } else if (nextEdges !== undefined) nextEdges.push(edge);
    }
    if (nextEdges !== undefined) record.setLinkedRecords(nextEdges, EDGES);
}
// Copied from DeleteEdgeHandler implementation in Relay with a single change in behaviour:
// it calls deleteNode above instead of ConnectionHandler.deleteNode.
var DeleteEdgeHandler = {
    update: function(store, payload) {
        var record = store.get(payload.dataID);
        if (record == null) return;
        // @types/relay-runtime is broken, handleArgs is present in the original Flow types.
        var connections = payload.handleArgs.connections;
        (0, _tinyInvariantDefault.default)(connections != null, 'MutationHandlers: Expected connection IDs to be specified.');
        var idOrIds = record.getValue(payload.fieldKey);
        var idList = Array.isArray(idOrIds) ? idOrIds : [
            idOrIds
        ];
        idList.forEach(function(id) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            if (typeof id === 'string') try {
                for(var _iterator = connections[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var connectionID = _step.value;
                    var connection = store.get(connectionID);
                    if (connection == null) {
                        (0, _tinyWarningDefault.default)(false, "[Relay] The connection with id ".concat(connectionID, " doesn't exist."));
                        continue;
                    }
                    deleteNode(connection, id);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        });
    }
};
function HandlerProvider(handle) {
    switch(handle){
        case 'deleteEdge':
            return DeleteEdgeHandler;
        default:
            return (0, _relayRuntime.DefaultHandlerProvider)(handle);
    }
}
function createRelayEnvironment(param) {
    var log = param.log, requiredFieldLogger = param.requiredFieldLogger, networkOptions = param.networkOptions, getDataID = param.getDataID;
    return new (0, _relayRuntime.Environment)({
        configName: 'Atlassian Shared Graphql Gateway',
        network: createNetwork(networkOptions || {
            isServer: false
        }),
        store: createStore(new (0, _relayRuntime.RecordSource)(), {
            log: log !== null && log !== void 0 ? log : undefined,
            getDataID: 'getDataID' in arguments[0] ? getDataID : (0, _relayDataIdDefault.default)
        }),
        log: log,
        relayFieldLogger: requiredFieldLogger,
        getDataID: 'getDataID' in arguments[0] ? getDataID : (0, _relayDataIdDefault.default),
        scheduler: (0, _relaySchedulerDefault.default),
        missingFieldHandlers: (0, _relayMissingFieldHandlersDefault.default),
        handlerProvider: HandlerProvider
    });
}

},{"relay-runtime":"2IxFR","relay-runtime/lib/store/experimental-live-resolvers/LiveResolverStore":"8tMrG","tiny-invariant":"9VWeJ","tiny-warning":"6MVuu","@atlassian/relay-data-id":"6yDA9","@atlassian/relay-fetch/multi-fetch":"FjBUX","@atlassian/relay-missing-field-handlers":"i73ck","@atlassian/relay-scheduler":"7QvFn","@atlassian/relay-subscription":"l0yWd","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8tMrG":[function(require,module,exports,__globalThis) {
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
'use strict';
var _interopRequireDefault = require("46662f2aa3d53b4e")["default"];
var _createForOfIteratorHelper2 = _interopRequireDefault(require("cc704fff9dad3834"));
var _defineProperty2 = _interopRequireDefault(require("ca43bbf0ea02a611"));
var _require = require("d77aef395ebb662d"), INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = _require.INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, assertInternalActorIdentifier = _require.assertInternalActorIdentifier;
var deepFreeze = require("215360a0e6b55f8e");
var resolveImmediate = require("78d8c84b42321096");
var DataChecker = require("3ac578e5914565ec");
var defaultGetDataID = require("e8f1075469aab2fa");
var RelayModernRecord = require("3c37ec8e9e9f72ab");
var RelayOptimisticRecordSource = require("ba00229c91838bb");
var RelayReader = require("db8a2e576e5d627f");
var RelayReferenceMarker = require("681b386ef608a45e");
var RelayStoreSubscriptions = require("c98b0315fce7f92e");
var RelayStoreUtils = require("62ee3673b83c0de7");
var _require2 = require("62ee3673b83c0de7"), ROOT_ID = _require2.ROOT_ID, ROOT_TYPE = _require2.ROOT_TYPE;
var _require3 = require("22ded1ecf9b75a12"), LiveResolverCache = _require3.LiveResolverCache, RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY = _require3.RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY, getUpdatedDataIDs = _require3.getUpdatedDataIDs;
var invariant = require("861d7e210f027a6f");
var DEFAULT_RELEASE_BUFFER_SIZE = 10;
var LiveResolverStore = /*#__PURE__*/ function() {
    function LiveResolverStore(source, options) {
        var _this = this;
        var _options$gcReleaseBuf, _options$gcScheduler, _options$getDataID, _options$log, _options$operationLoa, _options$treatMissing, _options$shouldProces;
        (0, _defineProperty2["default"])(this, "_gcStep", function() {
            if (_this._gcRun) {
                if (_this._gcRun.next().done) _this._gcRun = null;
                else _this._gcScheduler(_this._gcStep);
            }
        });
        var storeIDs, ii, record;
        this._currentWriteEpoch = 0;
        this._gcHoldCounter = 0;
        this._gcReleaseBufferSize = (_options$gcReleaseBuf = options === null || options === void 0 ? void 0 : options.gcReleaseBufferSize) !== null && _options$gcReleaseBuf !== void 0 ? _options$gcReleaseBuf : DEFAULT_RELEASE_BUFFER_SIZE;
        this._gcRun = null;
        this._gcScheduler = (_options$gcScheduler = options === null || options === void 0 ? void 0 : options.gcScheduler) !== null && _options$gcScheduler !== void 0 ? _options$gcScheduler : resolveImmediate;
        this._getDataID = (_options$getDataID = options === null || options === void 0 ? void 0 : options.getDataID) !== null && _options$getDataID !== void 0 ? _options$getDataID : defaultGetDataID;
        this._globalInvalidationEpoch = null;
        this._invalidationSubscriptions = new Set();
        this._invalidatedRecordIDs = new Set();
        this.__log = (_options$log = options === null || options === void 0 ? void 0 : options.log) !== null && _options$log !== void 0 ? _options$log : null;
        this._queryCacheExpirationTime = options === null || options === void 0 ? void 0 : options.queryCacheExpirationTime;
        this._operationLoader = (_options$operationLoa = options === null || options === void 0 ? void 0 : options.operationLoader) !== null && _options$operationLoa !== void 0 ? _options$operationLoa : null;
        this._optimisticSource = null;
        this._recordSource = source;
        this._releaseBuffer = [];
        this._roots = new Map();
        this._shouldScheduleGC = false;
        this._resolverCache = new LiveResolverCache(function() {
            return _this._getMutableRecordSource();
        }, this);
        this._storeSubscriptions = new RelayStoreSubscriptions(options === null || options === void 0 ? void 0 : options.log, this._resolverCache);
        this._updatedRecordIDs = new Set();
        this._treatMissingFieldsAsNull = (_options$treatMissing = options === null || options === void 0 ? void 0 : options.treatMissingFieldsAsNull) !== null && _options$treatMissing !== void 0 ? _options$treatMissing : false;
        this._actorIdentifier = options === null || options === void 0 ? void 0 : options.actorIdentifier;
        this._shouldProcessClientComponents = (_options$shouldProces = options === null || options === void 0 ? void 0 : options.shouldProcessClientComponents) !== null && _options$shouldProces !== void 0 ? _options$shouldProces : false;
        initializeRecordSource(this._recordSource);
    }
    var _proto = LiveResolverStore.prototype;
    _proto.getSource = function getSource() {
        var _this$_optimisticSour;
        return (_this$_optimisticSour = this._optimisticSource) !== null && _this$_optimisticSour !== void 0 ? _this$_optimisticSour : this._recordSource;
    };
    _proto._getMutableRecordSource = function _getMutableRecordSource() {
        var _this$_optimisticSour2;
        return (_this$_optimisticSour2 = this._optimisticSource) !== null && _this$_optimisticSour2 !== void 0 ? _this$_optimisticSour2 : this._recordSource;
    };
    _proto.getLiveResolverPromise = function getLiveResolverPromise(recordID) {
        return this._resolverCache.getLiveResolverPromise(recordID);
    };
    _proto.batchLiveStateUpdates = function batchLiveStateUpdates(callback) {
        if (this.__log != null) this.__log({
            name: 'liveresolver.batch.start'
        });
        try {
            this._resolverCache.batchLiveStateUpdates(callback);
        } finally{
            if (this.__log != null) this.__log({
                name: 'liveresolver.batch.end'
            });
        }
    };
    _proto.check = function check(operation, options) {
        var _options$handlers, _options$getSourceFor, _options$getTargetFor, _options$defaultActor;
        var selector = operation.root;
        var source = this._getMutableRecordSource();
        var globalInvalidationEpoch = this._globalInvalidationEpoch;
        var rootEntry = this._roots.get(operation.request.identifier);
        var operationLastWrittenAt = rootEntry != null ? rootEntry.epoch : null;
        if (globalInvalidationEpoch != null) {
            if (operationLastWrittenAt == null || operationLastWrittenAt <= globalInvalidationEpoch) return {
                status: 'stale'
            };
        }
        var handlers = (_options$handlers = options === null || options === void 0 ? void 0 : options.handlers) !== null && _options$handlers !== void 0 ? _options$handlers : [];
        var getSourceForActor = (_options$getSourceFor = options === null || options === void 0 ? void 0 : options.getSourceForActor) !== null && _options$getSourceFor !== void 0 ? _options$getSourceFor : function getSourceForActor(actorIdentifier) {
            assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var getTargetForActor = (_options$getTargetFor = options === null || options === void 0 ? void 0 : options.getTargetForActor) !== null && _options$getTargetFor !== void 0 ? _options$getTargetFor : function getTargetForActor(actorIdentifier) {
            assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var operationAvailability = DataChecker.check(getSourceForActor, getTargetForActor, (_options$defaultActor = options === null || options === void 0 ? void 0 : options.defaultActorIdentifier) !== null && _options$defaultActor !== void 0 ? _options$defaultActor : INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, selector, handlers, this._operationLoader, this._getDataID, this._shouldProcessClientComponents);
        return getAvailabilityStatus(operationAvailability, operationLastWrittenAt, rootEntry === null || rootEntry === void 0 ? void 0 : rootEntry.fetchTime, this._queryCacheExpirationTime);
    };
    _proto.retain = function retain(operation) {
        var _this2 = this;
        var id = operation.request.identifier;
        var disposed = false;
        var dispose = function dispose() {
            if (disposed) return;
            disposed = true;
            var rootEntry = _this2._roots.get(id);
            if (rootEntry == null) return;
            rootEntry.refCount--;
            if (rootEntry.refCount === 0) {
                var _queryCacheExpirationTime = _this2._queryCacheExpirationTime;
                var rootEntryIsStale = rootEntry.fetchTime != null && _queryCacheExpirationTime != null && rootEntry.fetchTime <= Date.now() - _queryCacheExpirationTime;
                if (rootEntryIsStale) {
                    _this2._roots["delete"](id);
                    _this2.scheduleGC();
                } else {
                    _this2._releaseBuffer.push(id);
                    if (_this2._releaseBuffer.length > _this2._gcReleaseBufferSize) {
                        var _id = _this2._releaseBuffer.shift();
                        _this2._roots["delete"](_id);
                        _this2.scheduleGC();
                    }
                }
            }
        };
        var rootEntry = this._roots.get(id);
        if (rootEntry != null) {
            if (rootEntry.refCount === 0) this._releaseBuffer = this._releaseBuffer.filter(function(_id) {
                return _id !== id;
            });
            rootEntry.refCount += 1;
        } else this._roots.set(id, {
            operation: operation,
            refCount: 1,
            epoch: null,
            fetchTime: null
        });
        return {
            dispose: dispose
        };
    };
    _proto.lookup = function lookup(selector) {
        var source = this.getSource();
        var snapshot = RelayReader.read(source, selector, this._resolverCache);
        return snapshot;
    };
    _proto.notify = function notify(sourceOperation, invalidateStore) {
        var _this3 = this;
        var log = this.__log;
        if (log != null) log({
            name: 'store.notify.start',
            sourceOperation: sourceOperation
        });
        this._currentWriteEpoch++;
        if (invalidateStore === true) this._globalInvalidationEpoch = this._currentWriteEpoch;
        this._resolverCache.invalidateDataIDs(this._updatedRecordIDs);
        var source = this.getSource();
        var updatedOwners = [];
        this._storeSubscriptions.updateSubscriptions(source, this._updatedRecordIDs, updatedOwners, sourceOperation);
        this._invalidationSubscriptions.forEach(function(subscription) {
            _this3._updateInvalidationSubscription(subscription, invalidateStore === true);
        });
        if (log != null) log({
            name: 'store.notify.complete',
            sourceOperation: sourceOperation,
            updatedRecordIDs: this._updatedRecordIDs,
            invalidatedRecordIDs: this._invalidatedRecordIDs
        });
        this._updatedRecordIDs.clear();
        this._invalidatedRecordIDs.clear();
        if (sourceOperation != null) {
            var id = sourceOperation.request.identifier;
            var rootEntry = this._roots.get(id);
            if (rootEntry != null) {
                rootEntry.epoch = this._currentWriteEpoch;
                rootEntry.fetchTime = Date.now();
            } else if (sourceOperation.request.node.params.operationKind === 'query' && this._gcReleaseBufferSize > 0 && this._releaseBuffer.length < this._gcReleaseBufferSize) {
                var temporaryRootEntry = {
                    operation: sourceOperation,
                    refCount: 0,
                    epoch: this._currentWriteEpoch,
                    fetchTime: Date.now()
                };
                this._releaseBuffer.push(id);
                this._roots.set(id, temporaryRootEntry);
            }
        }
        return updatedOwners;
    };
    _proto.publish = function publish(source, idsMarkedForInvalidation) {
        var target = this._getMutableRecordSource();
        updateTargetFromSource(target, source, this._currentWriteEpoch + 1, idsMarkedForInvalidation, this._updatedRecordIDs, this._invalidatedRecordIDs);
        var log = this.__log;
        if (log != null) log({
            name: 'store.publish',
            source: source,
            optimistic: target === this._optimisticSource
        });
    };
    _proto.subscribe = function subscribe(snapshot, callback) {
        return this._storeSubscriptions.subscribe(snapshot, callback);
    };
    _proto.holdGC = function holdGC() {
        var _this4 = this;
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._gcHoldCounter++;
        var dispose = function dispose() {
            if (_this4._gcHoldCounter > 0) {
                _this4._gcHoldCounter--;
                if (_this4._gcHoldCounter === 0 && _this4._shouldScheduleGC) {
                    _this4.scheduleGC();
                    _this4._shouldScheduleGC = false;
                }
            }
        };
        return {
            dispose: dispose
        };
    };
    _proto.toJSON = function toJSON() {
        return 'LiveResolverStore()';
    };
    _proto.getEpoch = function getEpoch() {
        return this._currentWriteEpoch;
    };
    _proto.__getUpdatedRecordIDs = function __getUpdatedRecordIDs() {
        return this._updatedRecordIDs;
    };
    _proto.lookupInvalidationState = function lookupInvalidationState(dataIDs) {
        var _this5 = this;
        var invalidations = new Map();
        dataIDs.forEach(function(dataID) {
            var _RelayModernRecord$ge;
            var record = _this5.getSource().get(dataID);
            invalidations.set(dataID, (_RelayModernRecord$ge = RelayModernRecord.getInvalidationEpoch(record)) !== null && _RelayModernRecord$ge !== void 0 ? _RelayModernRecord$ge : null);
        });
        invalidations.set('global', this._globalInvalidationEpoch);
        var invalidationState = {
            dataIDs: dataIDs,
            invalidations: invalidations
        };
        return invalidationState;
    };
    _proto.checkInvalidationState = function checkInvalidationState(prevInvalidationState) {
        var latestInvalidationState = this.lookupInvalidationState(prevInvalidationState.dataIDs);
        var currentInvalidations = latestInvalidationState.invalidations;
        var prevInvalidations = prevInvalidationState.invalidations;
        if (currentInvalidations.get('global') !== prevInvalidations.get('global')) return true;
        var _iterator = (0, _createForOfIteratorHelper2["default"])(prevInvalidationState.dataIDs), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var dataID = _step.value;
                if (currentInvalidations.get(dataID) !== prevInvalidations.get(dataID)) return true;
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return false;
    };
    _proto.subscribeToInvalidationState = function subscribeToInvalidationState(invalidationState, callback) {
        var _this6 = this;
        var subscription = {
            callback: callback,
            invalidationState: invalidationState
        };
        var dispose = function dispose() {
            _this6._invalidationSubscriptions["delete"](subscription);
        };
        this._invalidationSubscriptions.add(subscription);
        return {
            dispose: dispose
        };
    };
    _proto._updateInvalidationSubscription = function _updateInvalidationSubscription(subscription, invalidatedStore) {
        var _this7 = this;
        var callback = subscription.callback, invalidationState = subscription.invalidationState;
        var dataIDs = invalidationState.dataIDs;
        var isSubscribedToInvalidatedIDs = invalidatedStore || dataIDs.some(function(dataID) {
            return _this7._invalidatedRecordIDs.has(dataID);
        });
        if (!isSubscribedToInvalidatedIDs) return;
        callback();
    };
    _proto.snapshot = function snapshot() {
        !(this._optimisticSource == null) && invariant(false);
        var log = this.__log;
        if (log != null) log({
            name: 'store.snapshot'
        });
        this._storeSubscriptions.snapshotSubscriptions(this.getSource());
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._optimisticSource = RelayOptimisticRecordSource.create(this.getSource());
    };
    _proto.restore = function restore() {
        var optimisticSource = this._optimisticSource;
        !optimisticSource && invariant(false);
        var log = this.__log;
        if (log != null) log({
            name: 'store.restore'
        });
        var optimisticIDs = RelayOptimisticRecordSource.getOptimisticRecordIDs(optimisticSource);
        this._resolverCache.unsubscribeFromLiveResolverRecords(optimisticIDs);
        this._optimisticSource = null;
        if (this._shouldScheduleGC) this.scheduleGC();
        this._storeSubscriptions.restoreSubscriptions();
        this._resolverCache.invalidateResolverRecords(optimisticIDs);
    };
    _proto.scheduleGC = function scheduleGC() {
        if (this._gcHoldCounter > 0) {
            this._shouldScheduleGC = true;
            return;
        }
        if (this._gcRun) return;
        this._gcRun = this._collect();
        this._gcScheduler(this._gcStep);
    };
    _proto.__gc = function __gc() {
        if (this._optimisticSource != null) return;
        var gcRun = this._collect();
        while(!gcRun.next().done);
    };
    _proto._collect = function _collect() {
        var startEpoch, references, _iterator2, _step2, operation, selector, err, log, storeIDs, ii, dataID, record, maybeResolverSubscription;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!true) return [
                        3,
                        9
                    ];
                    startEpoch = this._currentWriteEpoch;
                    references = new Set();
                    _iterator2 = (0, _createForOfIteratorHelper2["default"])(this._roots.values());
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        8
                    ]);
                    _iterator2.s();
                    _state.label = 2;
                case 2:
                    if (!!(_step2 = _iterator2.n()).done) return [
                        3,
                        5
                    ];
                    operation = _step2.value.operation;
                    selector = operation.root;
                    RelayReferenceMarker.mark(this._recordSource, selector, references, this._operationLoader, this._shouldProcessClientComponents);
                    return [
                        4
                    ];
                case 3:
                    _state.sent();
                    if (startEpoch !== this._currentWriteEpoch) return [
                        3,
                        0
                    ];
                    _state.label = 4;
                case 4:
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        8
                    ];
                case 6:
                    err = _state.sent();
                    _iterator2.e(err);
                    return [
                        3,
                        8
                    ];
                case 7:
                    _iterator2.f();
                    return [
                        7
                    ];
                case 8:
                    log = this.__log;
                    if (log != null) log({
                        name: 'store.gc',
                        references: references
                    });
                    if (references.size === 0) this._recordSource.clear();
                    else {
                        storeIDs = this._recordSource.getRecordIDs();
                        for(ii = 0; ii < storeIDs.length; ii++){
                            dataID = storeIDs[ii];
                            if (!references.has(dataID)) {
                                record = this._recordSource.get(dataID);
                                if (record != null) {
                                    maybeResolverSubscription = RelayModernRecord.getValue(record, RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY);
                                    if (maybeResolverSubscription != null) maybeResolverSubscription();
                                }
                                this._recordSource.remove(dataID);
                            }
                        }
                    }
                    return [
                        2
                    ];
                case 9:
                    return [
                        2
                    ];
            }
        });
    };
    _proto.__getNormalizationOptions = function __getNormalizationOptions(path) {
        return {
            path: path,
            getDataID: this._getDataID,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents,
            actorIdentifier: this._actorIdentifier
        };
    };
    _proto.__notifyUpdatedSubscribers = function __notifyUpdatedSubscribers(updatedRecords) {
        var nextUpdatedRecordIDs = getUpdatedDataIDs(updatedRecords);
        var prevUpdatedRecordIDs = this._updatedRecordIDs;
        this._updatedRecordIDs = nextUpdatedRecordIDs;
        this.notify();
        this._updatedRecordIDs = prevUpdatedRecordIDs;
    };
    return LiveResolverStore;
}();
function initializeRecordSource(target) {
    if (!target.has(ROOT_ID)) {
        var rootRecord = RelayModernRecord.create(ROOT_ID, ROOT_TYPE);
        target.set(ROOT_ID, rootRecord);
    }
}
function updateTargetFromSource(target, source, currentWriteEpoch, idsMarkedForInvalidation, updatedRecordIDs, invalidatedRecordIDs) {
    if (idsMarkedForInvalidation) idsMarkedForInvalidation.forEach(function(dataID) {
        var targetRecord = target.get(dataID);
        var sourceRecord = source.get(dataID);
        if (sourceRecord === null) return;
        var nextRecord;
        if (targetRecord != null) nextRecord = RelayModernRecord.clone(targetRecord);
        else nextRecord = sourceRecord != null ? RelayModernRecord.clone(sourceRecord) : null;
        if (!nextRecord) return;
        RelayModernRecord.setValue(nextRecord, RelayStoreUtils.INVALIDATED_AT_KEY, currentWriteEpoch);
        invalidatedRecordIDs.add(dataID);
        target.set(dataID, nextRecord);
    });
    var dataIDs = source.getRecordIDs();
    for(var ii = 0; ii < dataIDs.length; ii++){
        var dataID = dataIDs[ii];
        var sourceRecord = source.get(dataID);
        var targetRecord = target.get(dataID);
        if (sourceRecord && targetRecord) {
            var nextRecord = RelayModernRecord.update(targetRecord, sourceRecord);
            if (nextRecord !== targetRecord) {
                updatedRecordIDs.add(dataID);
                target.set(dataID, nextRecord);
            }
        } else if (sourceRecord === null) {
            target["delete"](dataID);
            if (targetRecord !== null) updatedRecordIDs.add(dataID);
        } else if (sourceRecord) {
            target.set(dataID, sourceRecord);
            updatedRecordIDs.add(dataID);
        }
    }
}
function getAvailabilityStatus(operationAvailability, operationLastWrittenAt, operationFetchTime, queryCacheExpirationTime) {
    var mostRecentlyInvalidatedAt = operationAvailability.mostRecentlyInvalidatedAt, status = operationAvailability.status;
    if (typeof mostRecentlyInvalidatedAt === 'number') {
        if (operationLastWrittenAt == null || mostRecentlyInvalidatedAt > operationLastWrittenAt) return {
            status: 'stale'
        };
    }
    if (status === 'missing') return {
        status: 'missing'
    };
    if (operationFetchTime != null && queryCacheExpirationTime != null) {
        var isStale = operationFetchTime <= Date.now() - queryCacheExpirationTime;
        if (isStale) return {
            status: 'stale'
        };
    }
    return {
        status: 'available',
        fetchTime: operationFetchTime !== null && operationFetchTime !== void 0 ? operationFetchTime : null
    };
}
module.exports = LiveResolverStore;

},{"@swc/helpers/_/_ts_generator":"78Tqx","46662f2aa3d53b4e":"590td","cc704fff9dad3834":"fMaLa","ca43bbf0ea02a611":"2paQ8","d77aef395ebb662d":"cFrVW","215360a0e6b55f8e":"eLea7","78d8c84b42321096":"b0sng","3ac578e5914565ec":"hp2zf","e8f1075469aab2fa":"febBR","3c37ec8e9e9f72ab":"daXOB","ba00229c91838bb":"4BdDg","db8a2e576e5d627f":"hTh0M","681b386ef608a45e":"7FTk2","c98b0315fce7f92e":"idAWU","62ee3673b83c0de7":"3QcrW","22ded1ecf9b75a12":"lNlVZ","861d7e210f027a6f":"e2sci"}],"lNlVZ":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var _interopRequireDefault = require("9e42384cfd51f86a")["default"];
var _createForOfIteratorHelper2 = _interopRequireDefault(require("5a4117fe36ad14ed"));
var recycleNodesInto = require("632788162841e3b6");
var _require = require("f3863cc97e1a7aeb"), RELAY_LIVE_RESOLVER = _require.RELAY_LIVE_RESOLVER;
var RelayFeatureFlags = require("fecfc7c2fc7e7240");
var shallowFreeze = require("ef794dc1ed5a5722");
var _require2 = require("2d088bb9148574c4"), generateClientID = _require2.generateClientID, generateClientObjectClientID = _require2.generateClientObjectClientID;
var RelayModernRecord = require("c3aacc2b0539f415");
var _require3 = require("db2c765e000e1677"), createNormalizationSelector = _require3.createNormalizationSelector;
var RelayRecordSource = require("8af71173e2cf5a57");
var _require4 = require("4d65283f98fe9f6c"), normalize = _require4.normalize;
var _require5 = require("163a60f33c8f08d6"), RELAY_RESOLVER_ERROR_KEY = _require5.RELAY_RESOLVER_ERROR_KEY, RELAY_RESOLVER_INVALIDATION_KEY = _require5.RELAY_RESOLVER_INVALIDATION_KEY, RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS = _require5.RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS, RELAY_RESOLVER_SNAPSHOT_KEY = _require5.RELAY_RESOLVER_SNAPSHOT_KEY, RELAY_RESOLVER_VALUE_KEY = _require5.RELAY_RESOLVER_VALUE_KEY, getStorageKey = _require5.getStorageKey;
var getOutputTypeRecordIDs = require("2b3060ddedd91467");
var isLiveStateValue = require("d41061a9c6fa2927");
var _require6 = require("ccd54370780c616f"), isSuspenseSentinel = _require6.isSuspenseSentinel;
var invariant = require("8f0b77395a1ed9e8");
var warning = require("67bd8cb1d610c8bb");
var RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY = '__resolverLiveStateSubscription';
var RELAY_RESOLVER_LIVE_STATE_VALUE = '__resolverLiveStateValue';
var RELAY_RESOLVER_LIVE_STATE_DIRTY = '__resolverLiveStateDirty';
var RELAY_RESOLVER_RECORD_TYPENAME = '__RELAY_RESOLVER__';
var MODEL_PROPERTY_NAME = '__relay_model_instance';
function addDependencyEdge(edges, from, to) {
    var set = edges.get(from);
    if (!set) {
        set = new Set();
        edges.set(from, set);
    }
    set.add(to);
}
var LiveResolverCache = /*#__PURE__*/ function() {
    function LiveResolverCache(getRecordSource, store) {
        this._resolverIDToRecordIDs = new Map();
        this._recordIDToResolverIDs = new Map();
        this._getRecordSource = getRecordSource;
        this._store = store;
        this._handlingBatch = false;
        this._liveResolverBatchRecordSource = null;
    }
    var _proto = LiveResolverCache.prototype;
    _proto.readFromCacheOrEvaluate = function readFromCacheOrEvaluate(recordID, field, variables, evaluate, getDataForResolverFragment) {
        var recordSource = this._getRecordSource();
        var record = expectRecord(recordSource, recordID);
        var storageKey = getStorageKey(field, variables);
        var linkedID = RelayModernRecord.getLinkedRecordID(record, storageKey);
        var linkedRecord = linkedID == null ? null : recordSource.get(linkedID);
        var updatedDataIDs;
        if (linkedRecord == null || this._isInvalid(linkedRecord, getDataForResolverFragment)) {
            var _linkedID;
            if (linkedRecord != null) maybeUnsubscribeFromLiveState(linkedRecord);
            linkedID = (_linkedID = linkedID) !== null && _linkedID !== void 0 ? _linkedID : generateClientID(recordID, storageKey);
            linkedRecord = RelayModernRecord.create(linkedID, RELAY_RESOLVER_RECORD_TYPENAME);
            var evaluationResult = evaluate();
            RelayModernRecord.setValue(linkedRecord, RELAY_RESOLVER_SNAPSHOT_KEY, evaluationResult.snapshot);
            RelayModernRecord.setValue(linkedRecord, RELAY_RESOLVER_ERROR_KEY, evaluationResult.error);
            if (field.kind === RELAY_LIVE_RESOLVER) {
                if (evaluationResult.resolverResult != null) {
                    !(evaluationResult.error == null) && invariant(false);
                    var liveState = evaluationResult.resolverResult;
                    updatedDataIDs = this._setLiveStateValue(linkedRecord, linkedID, liveState, field, variables);
                } else var _evaluationResult$sna;
            } else updatedDataIDs = this._setResolverValue(linkedRecord, evaluationResult.resolverResult, field, variables);
            recordSource.set(linkedID, linkedRecord);
            var currentRecord = expectRecord(recordSource, recordID);
            var nextRecord = RelayModernRecord.clone(currentRecord);
            RelayModernRecord.setLinkedRecordID(nextRecord, storageKey, linkedID);
            recordSource.set(recordID, nextRecord);
            if (field.fragment != null) {
                var _evaluationResult$sna2;
                var fragmentStorageKey = getStorageKey(field.fragment, variables);
                var resolverID = generateClientID(recordID, fragmentStorageKey);
                addDependencyEdge(this._resolverIDToRecordIDs, resolverID, linkedID);
                addDependencyEdge(this._recordIDToResolverIDs, recordID, resolverID);
                var seenRecordIds = (_evaluationResult$sna2 = evaluationResult.snapshot) === null || _evaluationResult$sna2 === void 0 ? void 0 : _evaluationResult$sna2.seenRecords;
                if (seenRecordIds != null) {
                    var _iterator = (0, _createForOfIteratorHelper2["default"])(seenRecordIds), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var seenRecordID = _step.value;
                            addDependencyEdge(this._recordIDToResolverIDs, seenRecordID, resolverID);
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
            }
        } else if (field.kind === RELAY_LIVE_RESOLVER && RelayModernRecord.getValue(linkedRecord, RELAY_RESOLVER_LIVE_STATE_DIRTY)) {
            var _linkedID2;
            linkedID = (_linkedID2 = linkedID) !== null && _linkedID2 !== void 0 ? _linkedID2 : generateClientID(recordID, storageKey);
            linkedRecord = RelayModernRecord.clone(linkedRecord);
            var _liveState = RelayModernRecord.getValue(linkedRecord, RELAY_RESOLVER_LIVE_STATE_VALUE);
            if (!isLiveStateValue(_liveState)) invariant(false);
            updatedDataIDs = this._setLiveResolverValue(linkedRecord, _liveState, field, variables);
            RelayModernRecord.setValue(linkedRecord, RELAY_RESOLVER_LIVE_STATE_DIRTY, false);
            recordSource.set(linkedID, linkedRecord);
        }
        var answer = this._getResolverValue(linkedRecord);
        var snapshot = RelayModernRecord.getValue(linkedRecord, RELAY_RESOLVER_SNAPSHOT_KEY);
        var error = RelayModernRecord.getValue(linkedRecord, RELAY_RESOLVER_ERROR_KEY);
        var suspenseID = null;
        if (isSuspenseSentinel(answer)) {
            var _linkedID3;
            suspenseID = (_linkedID3 = linkedID) !== null && _linkedID3 !== void 0 ? _linkedID3 : generateClientID(recordID, storageKey);
        }
        return [
            answer,
            linkedID,
            error,
            snapshot,
            suspenseID,
            updatedDataIDs
        ];
    };
    _proto.getLiveResolverPromise = function getLiveResolverPromise(liveStateID) {
        var recordSource = this._getRecordSource();
        var liveStateRecord = recordSource.get(liveStateID);
        !(liveStateRecord != null) && invariant(false);
        var liveState = RelayModernRecord.getValue(liveStateRecord, RELAY_RESOLVER_LIVE_STATE_VALUE);
        return new Promise(function(resolve) {
            var unsubscribe = liveState.subscribe(function() {
                unsubscribe();
                resolve();
            });
        });
    };
    _proto._setLiveStateValue = function _setLiveStateValue(linkedRecord, linkedID, liveState, field, variables) {
        var handler = this._makeLiveStateHandler(linkedID);
        var unsubscribe = liveState.subscribe(handler);
        RelayModernRecord.setValue(linkedRecord, RELAY_RESOLVER_LIVE_STATE_VALUE, liveState);
        var updatedDataIDs = this._setLiveResolverValue(linkedRecord, liveState, field, variables);
        RelayModernRecord.setValue(linkedRecord, RELAY_RESOLVER_LIVE_STATE_DIRTY, false);
        RelayModernRecord.setValue(linkedRecord, RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY, unsubscribe);
        return updatedDataIDs;
    };
    _proto._makeLiveStateHandler = function _makeLiveStateHandler(linkedID) {
        var _this = this;
        return function() {
            var currentSource = _this._getRecordSource();
            var currentRecord = currentSource.get(linkedID);
            if (!currentRecord) return;
            if (!RelayModernRecord.hasValue(currentRecord, RELAY_RESOLVER_LIVE_STATE_VALUE)) return;
            var nextRecord = RelayModernRecord.clone(currentRecord);
            RelayModernRecord.setValue(nextRecord, RELAY_RESOLVER_LIVE_STATE_DIRTY, true);
            _this._setLiveResolverUpdate(linkedID, nextRecord);
        };
    };
    _proto._setLiveResolverUpdate = function _setLiveResolverUpdate(linkedId, record) {
        if (this._handlingBatch) {
            if (this._liveResolverBatchRecordSource == null) this._liveResolverBatchRecordSource = RelayRecordSource.create();
            this._liveResolverBatchRecordSource.set(linkedId, record);
        } else {
            var nextSource = RelayRecordSource.create();
            nextSource.set(linkedId, record);
            this._store.publish(nextSource);
            this._store.notify();
        }
    };
    _proto.batchLiveStateUpdates = function batchLiveStateUpdates(callback) {
        !!this._handlingBatch && invariant(false);
        this._handlingBatch = true;
        try {
            callback();
        } finally{
            if (this._liveResolverBatchRecordSource != null) {
                this._store.publish(this._liveResolverBatchRecordSource);
                this._store.notify();
            }
            this._liveResolverBatchRecordSource = null;
            this._handlingBatch = false;
        }
    };
    _proto._setLiveResolverValue = function _setLiveResolverValue(resolverRecord, liveValue, field, variables) {
        var value = null;
        var resolverError = null;
        try {
            value = liveValue.read();
        } catch (e) {
            resolverError = e;
        }
        RelayModernRecord.setValue(resolverRecord, RELAY_RESOLVER_ERROR_KEY, resolverError);
        return this._setResolverValue(resolverRecord, value, field, variables);
    };
    _proto._setResolverValue = function _setResolverValue(resolverRecord, value, field, variables) {
        var normalizationInfo = field.normalizationInfo;
        var updatedDataIDs = null;
        if (value != null && normalizationInfo != null && !isSuspenseSentinel(value)) {
            var resolverValue;
            var prevOutputTypeRecordIDs = getOutputTypeRecordIDs(resolverRecord);
            var nextOutputTypeRecordIDs = new Set();
            var currentSource = this._getRecordSource();
            if (normalizationInfo.plural) {
                !Array.isArray(value) && invariant(false);
                resolverValue = [];
                var nextSource = RelayRecordSource.create();
                for(var ii = 0; ii < value.length; ii++){
                    var currentValue = value[ii];
                    if (currentValue == null) continue;
                    !((typeof currentValue === "undefined" ? "undefined" : (0, _typeOf._)(currentValue)) === 'object') && invariant(false);
                    var typename = getConcreteTypename(normalizationInfo, currentValue);
                    var outputTypeDataID = generateClientObjectClientID(typename, RelayModernRecord.getDataID(resolverRecord), ii);
                    var source = this._normalizeOutputTypeValue(outputTypeDataID, currentValue, variables, normalizationInfo, [
                        field.path,
                        String(ii)
                    ], typename);
                    var _iterator2 = (0, _createForOfIteratorHelper2["default"])(source.getRecordIDs()), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var recordID = _step2.value;
                            nextSource.set(recordID, expectRecord(source, recordID));
                            nextOutputTypeRecordIDs.add(recordID);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                    resolverValue.push(outputTypeDataID);
                }
                updatedDataIDs = updateCurrentSource(currentSource, nextSource, prevOutputTypeRecordIDs);
            } else {
                !((typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) === 'object') && invariant(false);
                var _typename = getConcreteTypename(normalizationInfo, value);
                var _outputTypeDataID = generateClientObjectClientID(_typename, RelayModernRecord.getDataID(resolverRecord));
                var _nextSource = this._normalizeOutputTypeValue(_outputTypeDataID, value, variables, normalizationInfo, [
                    field.path
                ], _typename);
                var _iterator3 = (0, _createForOfIteratorHelper2["default"])(_nextSource.getRecordIDs()), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var _recordID = _step3.value;
                        nextOutputTypeRecordIDs.add(_recordID);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
                resolverValue = _outputTypeDataID;
                updatedDataIDs = updateCurrentSource(currentSource, _nextSource, prevOutputTypeRecordIDs);
            }
            RelayModernRecord.setValue(resolverRecord, RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS, nextOutputTypeRecordIDs);
            shallowFreeze(resolverValue);
            RelayModernRecord.setValue(resolverRecord, RELAY_RESOLVER_VALUE_KEY, resolverValue);
        } else {
            shallowFreeze(value);
            RelayModernRecord.setValue(resolverRecord, RELAY_RESOLVER_VALUE_KEY, value);
        }
        return updatedDataIDs;
    };
    _proto.notifyUpdatedSubscribers = function notifyUpdatedSubscribers(updatedDataIDs) {
        this._store.__notifyUpdatedSubscribers(updatedDataIDs);
    };
    _proto._getResolverValue = function _getResolverValue(resolverRecord) {
        return RelayModernRecord.getValue(resolverRecord, RELAY_RESOLVER_VALUE_KEY);
    };
    _proto.invalidateDataIDs = function invalidateDataIDs(updatedDataIDs) {
        var recordSource = this._getRecordSource();
        var visited = new Set();
        var recordsToVisit = Array.from(updatedDataIDs);
        while(recordsToVisit.length){
            var recordID = recordsToVisit.pop();
            updatedDataIDs.add(recordID);
            var fragmentSet = this._recordIDToResolverIDs.get(recordID);
            if (fragmentSet == null) continue;
            var _iterator4 = (0, _createForOfIteratorHelper2["default"])(fragmentSet), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var fragment = _step4.value;
                    if (!visited.has(fragment)) {
                        var recordSet = this._resolverIDToRecordIDs.get(fragment);
                        if (recordSet == null) continue;
                        var _iterator5 = (0, _createForOfIteratorHelper2["default"])(recordSet), _step5;
                        try {
                            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                                var anotherRecordID = _step5.value;
                                markInvalidatedResolverRecord(anotherRecordID, recordSource);
                                if (!visited.has(anotherRecordID)) recordsToVisit.push(anotherRecordID);
                            }
                        } catch (err) {
                            _iterator5.e(err);
                        } finally{
                            _iterator5.f();
                        }
                    }
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
    };
    _proto._isInvalid = function _isInvalid(record, getDataForResolverFragment) {
        if (!RelayModernRecord.getValue(record, RELAY_RESOLVER_INVALIDATION_KEY)) return false;
        var snapshot = RelayModernRecord.getValue(record, RELAY_RESOLVER_SNAPSHOT_KEY);
        var originalInputs = snapshot === null || snapshot === void 0 ? void 0 : snapshot.data;
        var readerSelector = snapshot === null || snapshot === void 0 ? void 0 : snapshot.selector;
        if (originalInputs == null || readerSelector == null) return true;
        var _getDataForResolverFr = getDataForResolverFragment(readerSelector), latestValues = _getDataForResolverFr.data;
        var recycled = recycleNodesInto(originalInputs, latestValues);
        if (recycled !== originalInputs) return true;
        if (RelayFeatureFlags.MARK_RESOLVER_VALUES_AS_CLEAN_AFTER_FRAGMENT_REREAD) {
            var nextRecord = RelayModernRecord.clone(record);
            RelayModernRecord.setValue(nextRecord, RELAY_RESOLVER_INVALIDATION_KEY, false);
            var recordSource = this._getRecordSource();
            recordSource.set(RelayModernRecord.getDataID(record), nextRecord);
        }
        return false;
    };
    _proto._normalizeOutputTypeValue = function _normalizeOutputTypeValue(outputTypeDataID, value, variables, normalizationInfo, fieldPath, typename) {
        var source = RelayRecordSource.create();
        switch(normalizationInfo.kind){
            case 'OutputType':
                var record = RelayModernRecord.create(outputTypeDataID, typename);
                source.set(outputTypeDataID, record);
                var selector = createNormalizationSelector(normalizationInfo.normalizationNode, outputTypeDataID, variables);
                var normalizationOptions = this._store.__getNormalizationOptions(fieldPath);
                return normalize(source, selector, value, normalizationOptions).source;
            case 'WeakModel':
                var _record = RelayModernRecord.create(outputTypeDataID, typename);
                RelayModernRecord.setValue(_record, MODEL_PROPERTY_NAME, value);
                source.set(outputTypeDataID, _record);
                return source;
            default:
                normalizationInfo.kind;
                invariant(false);
        }
    };
    _proto.ensureClientRecord = function ensureClientRecord(id, typeName) {
        var key = generateClientObjectClientID(typeName, id);
        var recordSource = this._getRecordSource();
        if (!recordSource.has(key)) {
            var newRecord = RelayModernRecord.create(key, typeName);
            RelayModernRecord.setValue(newRecord, 'id', id);
            recordSource.set(key, newRecord);
        }
        return key;
    };
    _proto.unsubscribeFromLiveResolverRecords = function unsubscribeFromLiveResolverRecords(invalidatedDataIDs) {
        return unsubscribeFromLiveResolverRecordsImpl(this._getRecordSource(), invalidatedDataIDs);
    };
    _proto.invalidateResolverRecords = function invalidateResolverRecords(invalidatedDataIDs) {
        if (invalidatedDataIDs.size === 0) return;
        var _iterator6 = (0, _createForOfIteratorHelper2["default"])(invalidatedDataIDs), _step6;
        try {
            for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                var dataID = _step6.value;
                var record = this._getRecordSource().get(dataID);
                if (record != null && isResolverRecord(record)) this._getRecordSource()["delete"](dataID);
            }
        } catch (err) {
            _iterator6.e(err);
        } finally{
            _iterator6.f();
        }
    };
    return LiveResolverCache;
}();
function updateCurrentSource(currentSource, nextSource, prevOutputTypeRecordIDs) {
    var updatedDataIDs = new Set();
    if (prevOutputTypeRecordIDs != null) {
        var _iterator7 = (0, _createForOfIteratorHelper2["default"])(prevOutputTypeRecordIDs), _step7;
        try {
            for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                var recordID = _step7.value;
                if (!nextSource.has(recordID)) {
                    updatedDataIDs.add(recordID);
                    currentSource.remove(recordID);
                }
            }
        } catch (err) {
            _iterator7.e(err);
        } finally{
            _iterator7.f();
        }
    }
    var _iterator8 = (0, _createForOfIteratorHelper2["default"])(nextSource.getRecordIDs()), _step8;
    try {
        for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
            var _recordID2 = _step8.value;
            var nextRecord = expectRecord(nextSource, _recordID2);
            if (currentSource.has(_recordID2)) {
                var currentRecord = expectRecord(currentSource, _recordID2);
                var updatedRecord = RelayModernRecord.update(currentRecord, nextRecord);
                if (updatedRecord !== currentRecord) {
                    updatedDataIDs.add(_recordID2);
                    currentSource.set(_recordID2, updatedRecord);
                    markInvalidatedLinkedResolverRecords(currentRecord, currentSource);
                }
            } else currentSource.set(_recordID2, nextRecord);
        }
    } catch (err) {
        _iterator8.e(err);
    } finally{
        _iterator8.f();
    }
    return updatedDataIDs;
}
function getAllLinkedRecordIds(record) {
    var linkedRecordIDs = new Set();
    RelayModernRecord.getFields(record).forEach(function(field) {
        if (RelayModernRecord.hasLinkedRecordID(record, field)) {
            var linkedRecordID = RelayModernRecord.getLinkedRecordID(record, field);
            if (linkedRecordID != null) linkedRecordIDs.add(linkedRecordID);
        } else if (RelayModernRecord.hasLinkedRecordIDs(record, field)) {
            var _RelayModernRecord$ge;
            (_RelayModernRecord$ge = RelayModernRecord.getLinkedRecordIDs(record, field)) === null || _RelayModernRecord$ge === void 0 || _RelayModernRecord$ge.forEach(function(linkedRecordID) {
                if (linkedRecordID != null) linkedRecordIDs.add(linkedRecordID);
            });
        }
    });
    return linkedRecordIDs;
}
function markInvalidatedResolverRecord(dataID, recordSource) {
    var record = recordSource.get(dataID);
    if (!record) return;
    var nextRecord = RelayModernRecord.clone(record);
    RelayModernRecord.setValue(nextRecord, RELAY_RESOLVER_INVALIDATION_KEY, true);
    recordSource.set(dataID, nextRecord);
}
function markInvalidatedLinkedResolverRecords(record, recordSource) {
    var currentLinkedDataIDs = getAllLinkedRecordIds(record);
    var _iterator9 = (0, _createForOfIteratorHelper2["default"])(currentLinkedDataIDs), _step9;
    try {
        for(_iterator9.s(); !(_step9 = _iterator9.n()).done;){
            var recordID = _step9.value;
            var _record2 = recordSource.get(recordID);
            if (_record2 != null && isResolverRecord(_record2)) markInvalidatedResolverRecord(recordID, recordSource);
        }
    } catch (err) {
        _iterator9.e(err);
    } finally{
        _iterator9.f();
    }
}
function unsubscribeFromLiveResolverRecordsImpl(recordSource, invalidatedDataIDs) {
    if (invalidatedDataIDs.size === 0) return;
    var _iterator10 = (0, _createForOfIteratorHelper2["default"])(invalidatedDataIDs), _step10;
    try {
        for(_iterator10.s(); !(_step10 = _iterator10.n()).done;){
            var dataID = _step10.value;
            var record = recordSource.get(dataID);
            if (record != null && isResolverRecord(record)) maybeUnsubscribeFromLiveState(record);
        }
    } catch (err) {
        _iterator10.e(err);
    } finally{
        _iterator10.f();
    }
}
function isResolverRecord(record) {
    return RelayModernRecord.getType(record) === RELAY_RESOLVER_RECORD_TYPENAME;
}
function maybeUnsubscribeFromLiveState(linkedRecord) {
    var previousUnsubscribe = RelayModernRecord.getValue(linkedRecord, RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY);
    if (previousUnsubscribe != null) previousUnsubscribe();
}
function expectRecord(source, recordID) {
    var record = source.get(recordID);
    !(record != null) && invariant(false);
    return record;
}
function getUpdatedDataIDs(updatedRecords) {
    return updatedRecords;
}
function getConcreteTypename(normalizationInfo, currentValue) {
    var _normalizationInfo$co;
    var typename = (_normalizationInfo$co = normalizationInfo.concreteType) !== null && _normalizationInfo$co !== void 0 ? _normalizationInfo$co : currentValue.__typename;
    !(typename != null) && invariant(false);
    return typename;
}
module.exports = {
    LiveResolverCache: LiveResolverCache,
    getUpdatedDataIDs: getUpdatedDataIDs,
    RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY: RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY
};

},{"@swc/helpers/_/_type_of":"iFJdx","9e42384cfd51f86a":"590td","5a4117fe36ad14ed":"fMaLa","632788162841e3b6":"ij1IQ","f3863cc97e1a7aeb":"jKskk","fecfc7c2fc7e7240":"a0FL5","ef794dc1ed5a5722":"dB2kC","2d088bb9148574c4":"gL1rB","c3aacc2b0539f415":"daXOB","db2c765e000e1677":"9k2Dg","8af71173e2cf5a57":"6w3KR","4d65283f98fe9f6c":"1Dhjb","163a60f33c8f08d6":"3QcrW","2b3060ddedd91467":"62CkT","d41061a9c6fa2927":"2UjxN","ccd54370780c616f":"kMvlq","8f0b77395a1ed9e8":"e2sci","67bd8cb1d610c8bb":"j64TH"}],"2UjxN":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
function isLiveStateValue(v) {
    return v != null && (typeof v === "undefined" ? "undefined" : (0, _typeOf._)(v)) === 'object' && typeof v.read === 'function' && typeof v.subscribe === 'function';
}
module.exports = isLiveStateValue;

},{"@swc/helpers/_/_type_of":"iFJdx"}],"6yDA9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return RelayDataID;
});
function RelayDataID(fieldValue, typeName) {
    var id = fieldValue.id;
    if (id == null) return undefined;
    return "".concat(String(id), ":::::").concat(typeName);
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"FjBUX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fetch", function() {
    return fetch;
});
parcelHelpers.export(exports, "enforceProductNonNullability", function() {
    return enforceProductNonNullability;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _relayRuntime = require("relay-runtime");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _relayCaptureExtensions = require("@atlassian/relay-capture-extensions");
var _relayEndpoint = require("@atlassian/relay-endpoint");
var _relayQueryPromises = require("@atlassian/relay-query-promises");
var _relayTraceid = require("@atlassian/relay-traceid");
var _clientDispatcher = require("@atlassian/server-to-client-comms/client-dispatcher");
var _serverReceiver = require("@atlassian/server-to-client-comms/server-receiver");
var _multipartFetch = require("./multipart-fetch");
var _retries = require("./utils/retries");
var _trace = require("./utils/trace");
var isSsrHandoverIncrementsEnabled = function() {
    return Boolean(globalThis.__SSR_HANDOVER_INCREMENTS);
};
var moduleID = 'relay-fetch';
var fetch = function(request, variables, cacheConfig, dependencies) {
    var _dependencies_getLoggingAndMetricsHelper;
    var queryName = request.name, operationKind = request.operationKind;
    var loggingMetadata = {
        queryName: queryName,
        operationKind: operationKind
    };
    var loggingAndMetrics = dependencies === null || dependencies === void 0 ? void 0 : (_dependencies_getLoggingAndMetricsHelper = dependencies.getLoggingAndMetricsHelper) === null || _dependencies_getLoggingAndMetricsHelper === void 0 ? void 0 : _dependencies_getLoggingAndMetricsHelper.call(dependencies, loggingMetadata);
    function augmentResponse(response) {
        (0, _relayTraceid.addTraceId)(queryName, (0, _trace.getTraceIdFromExtensions)(response));
        (0, _relayCaptureExtensions.putExtensions)(queryName, response.extensions);
    }
    // TODO: This needs to be changed by removing each Product, and only if all keys are empty final output is null
    function enforceNonNullability(response) {
        if (response.data && (response.data.jira === null || response.data.customerService === null || response.data.graphStore === null)) // Enforce non-nullability of the jira and customerService namespaces. This is an intermediary solution to
        // prevent server errors/gateway timeouts from wiping the Relay store. Eventually we'd like this
        // to be enforced at a schema level, see further discussion https://hello.atlassian.net/wiki/spaces/~236031707/pages/2034382845/Top+level+errors+for+namespaces+in+AGG+Relay
        // @ts-expect-error - TS2322 - Relay types do not allow null data for a response with errors, however this is valid according to the spec http://spec.graphql.org/June2018/#sec-Data
        response.data = null;
    }
    return (0, _relayRuntime.Observable).create(function(sink) {
        try {
            var requestID = 'cacheID' in request && request.cacheID != null ? request.cacheID : request.id;
            // Unique identifier for the server-to-client channel.
            var sinkID = "".concat(moduleID, "-").concat(requestID);
            var resolveCompletedResponse;
            var completedResponse = new Promise(function(resolve) {
                resolveCompletedResponse = resolve;
            });
            var finalise = function() {
                resolveCompletedResponse();
                sink.complete();
            };
            var handleResponse = function(response) {
                var payload = null;
                if ('incremental' in response && response.incremental) {
                    if (response.incremental.length) // Relay is expecting the contents of this array rather than the entire array itself. Also, Relay doesn't really care about tracking
                    // the pending versus completed values, so we can just return the array without the extra account keeping.
                    // @ts-expect-error It's hard to type this correctly because the payload sometimes has errors, sometimes not. Relay accounts for it,
                    // TypeScript can't handle the polymorphism.
                    payload = response.incremental;
                    else if (response.hasNext === false) // It's possible for the server to send back an empty final increment.
                    // Attempt to make Relay happy.
                    payload = {
                        data: null,
                        extensions: {
                            is_final: true
                        }
                    };
                } else // @ts-expect-error Typescript isn't happy that sometimes errors is undefined, but relay will manage just fine.
                payload = response;
                // Notify observers that we have more data!
                if (payload) sink.next(payload);
                // Close the stream if there are no more responses.
                if ('hasNext' in response && response.hasNext === false) finalise();
            };
            // handles getting multipart response
            var getData = function() {
                var _dependencies_earlyScriptPromise;
                var endpoint = (0, _relayEndpoint.getAggEndpoint)(request, cacheConfig);
                var body = (0, _relayEndpoint.getRequestBody)(request, variables);
                var options = {
                    body: body
                };
                if (dependencies === null || dependencies === void 0 ? void 0 : dependencies.getHeaders) {
                    var headers = dependencies.getHeaders({
                        endpoint: endpoint,
                        options: options,
                        request: request,
                        variables: variables
                    });
                    options = (0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
                        headers: (0, _objectSpread._)({}, options.headers, headers)
                    });
                }
                if (dependencies === null || dependencies === void 0 ? void 0 : dependencies.getAbortSignal) options.signal = dependencies === null || dependencies === void 0 ? void 0 : dependencies.getAbortSignal();
                var fetchOverNetwork = (0, _multipartFetch.buildGraphqlSmartFetch)({
                    url: (dependencies === null || dependencies === void 0 ? void 0 : dependencies.setEndpoint) ? dependencies === null || dependencies === void 0 ? void 0 : dependencies.setEndpoint(endpoint) : endpoint,
                    options: options,
                    variables: variables,
                    request: request,
                    isServer: (dependencies === null || dependencies === void 0 ? void 0 : dependencies.isServer) || false,
                    cacheConfig: cacheConfig
                });
                var earlyScriptPromise = dependencies === null || dependencies === void 0 ? void 0 : (_dependencies_earlyScriptPromise = dependencies.earlyScriptPromise) === null || _dependencies_earlyScriptPromise === void 0 ? void 0 : _dependencies_earlyScriptPromise.call(dependencies, request, variables);
                var fetchFn = fetchOverNetwork;
                var initialSource = fetchFn;
                if (dependencies === null || dependencies === void 0 ? void 0 : dependencies.withErrorHandling) {
                    var withErrorHandling = dependencies.withErrorHandling;
                    initialSource = function() {
                        return !(dependencies === null || dependencies === void 0 ? void 0 : dependencies.isServer) && earlyScriptPromise ? withErrorHandling(earlyScriptPromise) : withErrorHandling(fetchFn());
                    };
                }
                var responses = (0, _multipartFetch.processMultipartPromise)(function() {
                    return (0, _retries.retryOnError)(initialSource, {
                        retryFunc: fetchFn,
                        retryPredicate: (0, _retries.shouldRetry),
                        retryAttempts: (0, _retries.getRetryAttemptsForQuery)(request),
                        onRetry: loggingAndMetrics === null || loggingAndMetrics === void 0 ? void 0 : loggingAndMetrics.logErrorRetry
                    });
                });
                // Recreate a bizarre behaviour that will cause the observable to hang indefinitely when the user is not authenticated, presumably because we redirect the user to log in...
                // This should be revised; see https://jplat.atlassian.net/browse/MAGMA-3087
                var responseShouldHang = false;
                var firstResponseUsed = false;
                var resolveFirstResponse;
                var firstResponse = new Promise(function(resolve) {
                    resolveFirstResponse = resolve;
                });
                responses.subscribe({
                    start: function() {
                        if (requestID != null) {
                            if (dependencies === null || dependencies === void 0 ? void 0 : dependencies.isServer) {
                                // so that SSR SPA knows it is safe to render
                                var renderAfterThisResponse = isSsrHandoverIncrementsEnabled() ? firstResponse : completedResponse;
                                (0, _relayQueryPromises.QueryPromisesMap).set(requestID, renderAfterThisResponse);
                            } else (0, _relayQueryPromises.QueryPromisesMap).set(requestID, firstResponse);
                            (0, _relayQueryPromises.CompletedQueryPromisesMap).set(requestID, completedResponse);
                        }
                    },
                    next: function(r) {
                        var payload = r;
                        var response = payload || {};
                        if ((dependencies === null || dependencies === void 0 ? void 0 : dependencies.isServer) && isSsrHandoverIncrementsEnabled() && firstResponseUsed) {
                            // Send the response payload to a side-channel.
                            // TODO MAGMA-3204: improve robustness. Should be sending ID of module to communicate with, sinkID should be an argument.
                            (0, _serverReceiver.registerEvent)({
                                id: sinkID,
                                name: 'default',
                                args: [
                                    response
                                ]
                            });
                            if ('hasNext' in response && response.hasNext === false) finalise();
                            // Don't send any further responses to the fetch subscriber, since we'll be sending them through a side-channel.
                            return;
                        }
                        if (!firstResponseUsed) {
                            firstResponseUsed = true;
                            // according to spec, we can assume the first response is a GraphQLSingularResponse.
                            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            var singularResponse = response;
                            augmentResponse(singularResponse);
                            if ((dependencies === null || dependencies === void 0 ? void 0 : dependencies.validateResponse) && !dependencies.validateResponse(request, singularResponse)) {
                                var _dependencies_onInvalidResponse;
                                dependencies === null || dependencies === void 0 ? void 0 : (_dependencies_onInvalidResponse = dependencies.onInvalidResponse) === null || _dependencies_onInvalidResponse === void 0 ? void 0 : _dependencies_onInvalidResponse.call(dependencies, request, singularResponse);
                                responseShouldHang = true;
                                return;
                            }
                            if ((0, _platformFeatureFlags.fg)('platform_relay_use_new_non_nullability')) response = enforceProductNonNullability(singularResponse);
                            else enforceNonNullability(singularResponse);
                            // write cache query response on SSR
                            // only write cache query response once or else this will break the assumption of graphql response being singular response
                            if ((dependencies === null || dependencies === void 0 ? void 0 : dependencies.isServer) && requestID != null && typeof (dependencies === null || dependencies === void 0 ? void 0 : dependencies.queryResponseCache) !== 'undefined') {
                                if ('appendWithMetadata' in dependencies.queryResponseCache) dependencies.queryResponseCache.appendWithMetadata(requestID, variables, singularResponse, loggingMetadata);
                                else dependencies.queryResponseCache.setWithMetadata(requestID, variables, singularResponse, loggingMetadata);
                            }
                        }
                        handleResponse(response);
                        // signal that the initial response has been received
                        resolveFirstResponse();
                        // After the initial response, further responses are sent through a side-channel.
                        if ((dependencies === null || dependencies === void 0 ? void 0 : dependencies.isServer) && isSsrHandoverIncrementsEnabled()) sink.complete();
                    },
                    error: function(error) {
                        if (!firstResponseUsed) firstResponseUsed = true;
                        loggingAndMetrics === null || loggingAndMetrics === void 0 ? void 0 : loggingAndMetrics.logError(error);
                        sink.error(error);
                    },
                    complete: function() {
                        if (responseShouldHang) return;
                        finalise();
                    }
                });
            };
            // On client...
            if (!(dependencies === null || dependencies === void 0 ? void 0 : dependencies.isServer) && requestID != null) {
                var _dependencies_queryResponseCache;
                // read cache from window.SPA_STATE if available
                var ssrCache = dependencies === null || dependencies === void 0 ? void 0 : (_dependencies_queryResponseCache = dependencies.queryResponseCache) === null || _dependencies_queryResponseCache === void 0 ? void 0 : _dependencies_queryResponseCache.get(requestID, variables);
                if (!(0, _isNilDefault.default)(ssrCache)) {
                    var _dependencies_queryResponseCache1;
                    dependencies === null || dependencies === void 0 ? void 0 : (_dependencies_queryResponseCache1 = dependencies.queryResponseCache) === null || _dependencies_queryResponseCache1 === void 0 ? void 0 : _dependencies_queryResponseCache1.delete(requestID, variables);
                    sink.next(ssrCache);
                    if (isSsrHandoverIncrementsEnabled() && 'hasNext' in ssrCache && ssrCache.hasNext) {
                        // TODO MAGMA-3017: what about SSR fallback mode, or scenarios where SSR has partially failed?
                        // TODO MAGMA-3204: improve robustness. Should be using a middle-man module rather than client dispatcher directly.
                        // Receive response events as they are streamed from the server.
                        (0, _clientDispatcher.getClientDispatcher)().register(sinkID, handleResponse);
                        (0, _clientDispatcher.getClientDispatcher)().onAbort(sinkID, function(param) {
                            var reason = param.reason;
                            if (!sink.closed) {
                                var _dependencies_handleAbort;
                                dependencies === null || dependencies === void 0 ? void 0 : (_dependencies_handleAbort = dependencies.handleAbort) === null || _dependencies_handleAbort === void 0 ? void 0 : _dependencies_handleAbort.call(dependencies, request, reason);
                                // if server throws an exception (such as SSR hanging up due to deadline exceeded)
                                // refetch multipart data again via network
                                getData();
                            }
                        });
                    } else finalise();
                    return;
                }
            }
            getData();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            loggingAndMetrics === null || loggingAndMetrics === void 0 ? void 0 : loggingAndMetrics.logError(error);
            sink.error(error);
        }
    });
};
function enforceProductNonNullability(response) {
    if (response.data) {
        // Enforce non-nullability of the product namespaces. This is an intermediary solution to
        // prevent server errors/gateway timeouts from wiping the Relay store. Eventually we'd like this
        // to be enforced at a schema level, see further discussion https://hello.atlassian.net/wiki/spaces/~236031707/pages/2034382845/Top+level+errors+for+namespaces+in+AGG+Relay
        var sanitisedData = Object.assign({}, response.data);
        var productKeys = [
            'jira',
            'customerService',
            'graphStore'
        ];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = productKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var product = _step.value;
                if (sanitisedData[product] === null) delete sanitisedData[product];
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (Object.keys(sanitisedData).length === 0) // @ts-expect-error - TS2322 - Relay types do not allow null data for a response with errors, however this is valid according to the spec http://spec.graphql.org/June2018/#sec-Dataa
        sanitisedData = null;
        response.data = sanitisedData;
    }
    return response;
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","lodash/isNil":"o6Rs9","relay-runtime":"2IxFR","@atlaskit/platform-feature-flags":"kO5t9","@atlassian/relay-capture-extensions":"hHcCg","@atlassian/relay-endpoint":"gtg16","@atlassian/relay-query-promises":"c7ZzC","@atlassian/relay-traceid":"aI1XK","@atlassian/server-to-client-comms/client-dispatcher":"l9g8a","@atlassian/server-to-client-comms/server-receiver":"dQ7r3","./multipart-fetch":"7iLXY","./utils/retries":"hBWnz","./utils/trace":"2Of78","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"o6Rs9":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */ function isNil(value) {
    return value == null;
}
module.exports = isNil;

},{}],"hHcCg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "startCapturingExtensions", function() {
    return startCapturingExtensions;
});
parcelHelpers.export(exports, "stopCapturingExtensions", function() {
    return stopCapturingExtensions;
});
parcelHelpers.export(exports, "putExtensions", function() {
    return putExtensions;
});
parcelHelpers.export(exports, "getExtensions", function() {
    return getExtensions;
});
var OperationExtensionsMap = {};
var startCapturingExtensions = function(operationName) {
    OperationExtensionsMap[operationName] = OperationExtensionsMap[operationName] || [];
};
var stopCapturingExtensions = function(operationName) {
    OperationExtensionsMap[operationName] = undefined;
};
var putExtensions = function(operationName, extension) {
    if (extension !== undefined) {
        var extensionsForOperation = OperationExtensionsMap[operationName];
        if (extensionsForOperation !== undefined) extensionsForOperation.push(extension);
    }
};
var getExtensions = function(operationName) {
    return OperationExtensionsMap[operationName] || [];
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gtg16":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "aggPathname", function() {
    return aggPathname;
});
parcelHelpers.export(exports, "getAggEndpoint", function() {
    return getAggEndpoint;
});
parcelHelpers.export(exports, "getRequestBody", function() {
    return getRequestBody;
});
var process = require("9750eb214532795b");
var branchSlug = typeof process !== 'undefined' && process.env ? undefined : undefined;
var aggPathname = "/gateway/api/graphql".concat(branchSlug ? "/".concat(branchSlug, "/graphql") : '');
var getAggEndpoint = function(request) {
    var cacheConfig = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _cacheConfig_metadata;
    var endpoint = aggPathname;
    if ((_cacheConfig_metadata = cacheConfig.metadata) === null || _cacheConfig_metadata === void 0 ? void 0 : _cacheConfig_metadata.META_SLOW_ENDPOINT) endpoint = "".concat(endpoint, "/slow");
    if (request.id != null) endpoint = "".concat(endpoint, "/pq/").concat(request.id);
    return "".concat(endpoint, "?operation=").concat(request.name);
};
var getRequestBody = function(request, variables) {
    var requestBody = {
        operationName: request.name,
        variables: variables
    };
    return JSON.stringify(requestBody);
};

},{"9750eb214532795b":"gNLf3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"c7ZzC":[function(require,module,exports,__globalThis) {
/**
 * A map of signals that the initial response from the network has been received for a given relay query.
 *
 * This signal is used on the server-side during SSR to prevent React from running a render pass
 * until we can guarantee the data has arrived and is cached in the relay-client.
 *
 * This allows us to make a meaningful an initial render pass, avoiding needless suspense boundaries
 * and avoiding adding noncritical work to the JS call stack.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryPromisesMap", function() {
    return QueryPromisesMap;
});
parcelHelpers.export(exports, "CompletedQueryPromisesMap", function() {
    return CompletedQueryPromisesMap;
});
var QueryPromisesMap = new Map();
var CompletedQueryPromisesMap = new Map();

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aI1XK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "startCapturingTraceIds", function() {
    return startCapturingTraceIds;
});
parcelHelpers.export(exports, "stopCapturingTraceIds", function() {
    return stopCapturingTraceIds;
});
parcelHelpers.export(exports, "addTraceId", function() {
    return addTraceId;
});
parcelHelpers.export(exports, "getTraceIds", function() {
    return getTraceIds;
});
var OperationTraceIdMap = {};
var startCapturingTraceIds = function(operationName) {
    OperationTraceIdMap[operationName] = OperationTraceIdMap[operationName] || [];
};
var stopCapturingTraceIds = function(operationName) {
    OperationTraceIdMap[operationName] = undefined;
};
var addTraceId = function(operationName, traceId) {
    if (traceId !== undefined) {
        var traceIdsForOperation = OperationTraceIdMap[operationName];
        if (traceIdsForOperation !== undefined) traceIdsForOperation.push(traceId);
    }
};
var getTraceIds = function(operationName) {
    return OperationTraceIdMap[operationName] || [];
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"l9g8a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CLIENT_DISPATCHER_MODULE", function() {
    return CLIENT_DISPATCHER_MODULE;
});
parcelHelpers.export(exports, "getClientDispatcher", function() {
    return getClientDispatcher;
});
var _clientDispatcher = require("./client-dispatcher");
var CLIENT_DISPATCHER_MODULE = 'ClientDispatcher';
var dispatcher;
var getClientDispatcher = function() {
    if (!dispatcher) {
        dispatcher = new (0, _clientDispatcher.ClientDispatcher)();
        // Handle the server hangup scenarios
        dispatcher.register(CLIENT_DISPATCHER_MODULE, dispatcher._abort.bind(dispatcher));
    }
    return dispatcher;
};

},{"./client-dispatcher":"jEvNx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jEvNx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClientDispatcher", function() {
    return ClientDispatcher;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var ClientDispatcher = /*#__PURE__*/ function() {
    "use strict";
    function ClientDispatcher() {
        (0, _classCallCheck._)(this, ClientDispatcher);
        this.handlers = new Map();
        this.abortHandlers = new Map();
        this.queuedPayloads = new Map();
    }
    (0, _createClass._)(ClientDispatcher, [
        {
            /**
	 * Ingest a payload from the server.
	 * This will trigger a callback to the component that registered for this event, otherwise the payload will be queued to do so later.
	 * @param payload - The payload to ingest.
	 */ key: "ingest",
            value: function ingest(payload) {
                var handler = this.handlers.get(payload.id);
                if (handler) this.exec(handler, payload);
                else {
                    var queue = this.queuedPayloads.get(payload.id) || [];
                    queue.push(payload);
                    this.queuedPayloads.set(payload.id, queue);
                }
            }
        },
        {
            /**
	 * Register a callback for a given event. If any payloads were queued for this event, they will be processed immediately.
	 * @param id - The event ID to register for.
	 * @param callback - The callback to trigger when the event is ingested.
	 */ key: "register",
            value: function register(id, callback) {
                var _this = this;
                this.handlers.set(id, callback);
                // Process any queued payloads for this handler
                var queuedPayloads = this.queuedPayloads.get(id) || [];
                if (queuedPayloads.length > 0) {
                    queuedPayloads.forEach(function(payload) {
                        return _this.exec(callback, payload);
                    });
                    this.queuedPayloads.delete(id);
                }
            }
        },
        {
            /**
	 * Unregister a callback for a given event.
	 * @param id
	 */ key: "unregister",
            value: function unregister(id) {
                this.handlers.delete(id);
                this.queuedPayloads.delete(id);
            }
        },
        {
            /**
	 * Register an abort handler that will get called if exceptional circmstances arise (such as SSR hanging up due to deadline exceeded)
	 * @param id - The event ID to register for.
	 * @param callback - The callback to trigger when abort detected.
	 */ key: "onAbort",
            value: function onAbort(id, callback) {
                if (this.abortReason) this.exec(callback, {
                    args: [
                        this.abortReason
                    ]
                });
                else this.abortHandlers.set(id, callback);
            }
        },
        {
            /**
	 * Notify any registered abort handlers that the server exceeded its deadline before finishing, so we may not have received all events.
	 * @private
	 * @param props
	 */ key: "_abort",
            value: function _abort(props) {
                var _this = this;
                this.abortReason = props;
                this.abortHandlers.forEach(function(handler) {
                    _this.exec(handler, {
                        args: [
                            props
                        ]
                    });
                });
                // We can delete these now that we've handled the case and remainder will be dealt with immediately.
                this.abortHandlers = new Map();
            }
        },
        {
            key: "exec",
            value: /**
	 * Execute a callback with the given payload.
	 * @param callback - The callback to execute.
	 * @param payload - The payload to execute the callback with.
	 */ function exec(callback, payload) {
                var args = payload.args, error = payload.error;
                try {
                    if (error) throw error;
                    // @ts-expect-error
                    callback.apply(void 0, (0, _toConsumableArray._)(args));
                } catch (err) {
                // TODO: log error
                // console.error(err);
                }
            }
        }
    ]);
    return ClientDispatcher;
}();

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_to_consumable_array":"1eSZf","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dQ7r3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "registerEvent", function() {
    return registerEvent;
});
parcelHelpers.export(exports, "drainEvents", function() {
    return drainEvents;
});
var events = [];
var registerEvent = function(event) {
    events.push(event);
};
var drainEvents = function() {
    return events.splice(0, events.length);
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7iLXY":[function(require,module,exports,__globalThis) {
/**
 * @fileOverview Implements a fetch function that can handle multipart/mixed responses.
 * The multipart response is expected to follow the GraphQL multipart request spec.
 *
 * See https://github.com/graphql/graphql-over-http/blob/main/rfcs/IncrementalDelivery.md#content-type-multipartmixed
 * See https://github.com/graphql/graphql-over-http/blob/main/spec/GraphQLOverHTTP.md#multipart-request-format
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "processStream", function() {
    return processStream;
});
parcelHelpers.export(exports, "buildGraphqlSmartFetch", function() {
    return buildGraphqlSmartFetch;
});
parcelHelpers.export(exports, "processChunk", function() {
    return processChunk;
});
parcelHelpers.export(exports, "processMultipartPromise", function() {
    return(// These are only exported for testing purposes.
    processMultipartPromise);
});
parcelHelpers.export(exports, "calculateHeadersSize", function() {
    return calculateHeadersSize;
});
parcelHelpers.export(exports, "shouldUseGetMethod", function() {
    return shouldUseGetMethod;
});
parcelHelpers.export(exports, "buildGetUrl", function() {
    return buildGetUrl;
});
var _asyncIterator = require("@swc/helpers/_/_async_iterator");
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _awaitAsyncGenerator = require("@swc/helpers/_/_await_async_generator");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _wrapAsyncGenerator = require("@swc/helpers/_/_wrap_async_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _relayRuntime = require("relay-runtime");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _relayExperimentalApis = require("@atlassian/relay-experimental-apis");
var NO_CONTENT = 204;
function getBoundary(contentType) {
    var parts = contentType.split('boundary=');
    if (parts.length < 2) return null;
    return parts[1].trim();
}
function processChunk(chunk, boundaryString, observer) {
    var parts = chunk.split(boundaryString);
    var incompleteChunk = '';
    // Process all complete parts (except the last one which might be incomplete)
    for(var i = 0; i < parts.length - 1; i++){
        var part = parts[i].trim();
        // Skip empty parts and encapsulation boundaries
        if (part && !part.startsWith('--')) {
            // Split content-type header and body
            var _part_split = (0, _slicedToArray._)(part.split(/\r?\n\r?\n/), 2), part1 = _part_split[0], part2 = _part_split[1];
            // when response content has boundary string, part1 is the actual response
            // when response content does not have boundary string, part2 is the actual response
            var body = part2 !== null && part2 !== void 0 ? part2 : part1;
            if (body) try {
                var jsonData = JSON.parse(incompleteChunk + body);
                observer.next(jsonData);
                incompleteChunk = '';
            } catch (e) {
                // add boundary string back to response for cases when response content has boundary string
                // no error is thrown because next part might be a valid JSON object
                incompleteChunk += body + boundaryString;
            }
        }
    }
    // Return the last part which might be incomplete
    return incompleteChunk + parts[parts.length - 1];
}
function processStream(reader, boundary, observer) {
    return (0, _asyncToGenerator._)(function() {
        var boundaryString, incompleteChunk, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, newText, combinedChunk, err;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    boundaryString = "--".concat(boundary);
                    incompleteChunk = '';
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, _asyncIterator._)(reader);
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    newText = _value;
                    combinedChunk = incompleteChunk + newText;
                    // Process the combined chunk and get any incomplete part
                    incompleteChunk = processChunk(combinedChunk, boundaryString, observer);
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator.return()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    // Process any remaining data
                    if (incompleteChunk.length > 0) processChunk(incompleteChunk, boundaryString, observer);
                    observer.complete();
                    return [
                        2
                    ];
            }
        });
    })();
}
function handleMultipartResponse(response, observer) {
    var contentType = response.headers.get('content-type');
    var boundary = getBoundary(contentType || '');
    if (!boundary) {
        observer.error(new Error('Invalid multipart boundary'));
        return;
    }
    var decoder = new TextDecoder('utf-8');
    function streamReader() {
        return (0, _wrapAsyncGenerator._)(function() {
            var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, newText, err;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, _asyncIterator._)(response.body);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, _awaitAsyncGenerator._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        chunk = _value;
                        newText = decoder.decode(chunk, {
                            stream: true
                        });
                        return [
                            4,
                            newText
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, _awaitAsyncGenerator._)(_iterator.return())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    try {
        // Depending on the version of Node we're running in, the Response object may not implement ReadableStream.
        // Here, we treat the response as an async iterator, since both node-fetch and browser implement the response body as a stream.
        // We wrap that iteration in an async generator, which lets us
        processStream(streamReader(), boundary, observer).catch(function(error) {
            return observer.error(error);
        });
    } catch (e) {
        var error = new Error('Failed to read from response body');
        // @ts-ignore: cause property may not be available in all environments
        error.cause = e;
        observer.error(error);
    }
}
function handleJsonResponse(response, observer) {
    response.json().then(function(data) {
        return observer.next(data);
    }).catch(function(error) {
        return observer.error(error);
    }).finally(function() {
        return observer.complete();
    });
}
function handleTextResponse(response, observer) {
    response.text().then(function(data) {
        var maybeJson = data ? JSON.parse(data) : null;
        observer.next(maybeJson);
        observer.complete();
    }).catch(function(error) {
        var _response_headers;
        var traceId = '';
        if ((0, _platformFeatureFlags.fg)('platform_relay_use_shared_relay_env_help_center')) traceId = "(trace-id: ".concat(response.headers.get('atl-traceid'), ") ");
        observer.error(new Error("Error while parsing text response ".concat(traceId, "(Content-Type: ").concat(response === null || response === void 0 ? void 0 : (_response_headers = response.headers) === null || _response_headers === void 0 ? void 0 : _response_headers.get('content-type'), "): ").concat((0, _instanceof._)(error, Error) ? error.message : String(error))));
    });
}
function processMultipartPromise(source) {
    // Cache the result of the source promise to avoid calling it multiple times.
    var result = source();
    // Wrap an observer around the result to handle the response.
    return (0, _relayRuntime.Observable).create(function(observer) {
        result.then(function(response) {
            if (response.status === NO_CONTENT) {
                observer.complete();
                return;
            }
            var contentType = response.headers.get('content-type') || '';
            if (contentType.includes('application/json') || contentType.includes('application/graphql-response+json')) handleJsonResponse(response, observer);
            else if (contentType.includes('text/plain')) handleTextResponse(response, observer);
            else if (contentType.includes('multipart/mixed')) handleMultipartResponse(response, observer);
            else handleTextResponse(response, observer);
        }).catch(function(error) {
            return observer.error(error);
        });
    });
}
var relayDeferAcceptableFormats = [
    'application/graphql-response+json',
    'application/json',
    // there must not be spacing between `multipart/mixed` and `deferSpec=20220824` since the backend assumes no spacing
    'multipart/mixed;deferSpec=20220824'
];
var MAX_QUERY_LENGTH = 2000; // Maximum allowed query length
var MAX_HEADERS_SIZE = 20480; // Maximum header size in bytes (20 KB)
// Calculate the size of the headers
function calculateHeadersSize(headers) {
    var totalBytes = 0;
    var textEncoder = new TextEncoder();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // Iterate over each header entry (name and value)
        for(var _iterator = Object.entries(headers)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, _slicedToArray._)(_step.value, 2), name = _step_value[0], value = _step_value[1];
            var headerSize = textEncoder.encode("".concat(name, ": ").concat(value, "\r\n")).length; // Include CRLF
            totalBytes += headerSize;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return totalBytes;
}
function buildGetUrl(baseUrl, variables) {
    var params = new URLSearchParams();
    params.append('variables', JSON.stringify(variables));
    return baseUrl + "".concat(baseUrl.includes('?') ? '&' : '?').concat(params.toString());
}
function shouldUseGetMethod(param) {
    var baseUrl = param.url, variables = param.variables, request = param.request, headers = param.headers, isServer = param.isServer;
    if (isServer) return {
        isGetRequest: false,
        reason: 'SSR'
    };
    if (request.operationKind !== 'query') return {
        isGetRequest: false,
        reason: request.operationKind
    };
    var queryLength = buildGetUrl(baseUrl, variables).length;
    var headersSize = calculateHeadersSize(headers || {});
    return queryLength <= MAX_QUERY_LENGTH && headersSize <= MAX_HEADERS_SIZE ? {
        isGetRequest: true
    } : {
        isGetRequest: false,
        reason: 'URL length or headers size too large'
    };
}
function buildGraphqlSmartFetch(param) {
    var url = param.url, options = param.options, variables = param.variables, request = param.request, isServer = param.isServer, cacheConfig = param.cacheConfig;
    var _cacheConfig_metadata;
    var headers = (0, _objectSpread._)({
        'atl-client-name': 'atlassian-frontend-monorepo',
        Accept: relayDeferAcceptableFormats.join(', '),
        'X-ExperimentalApi': (0, _relayExperimentalApis.getRelayExperimentalApis)().join(',')
    }, (cacheConfig === null || cacheConfig === void 0 ? void 0 : (_cacheConfig_metadata = cacheConfig.metadata) === null || _cacheConfig_metadata === void 0 ? void 0 : _cacheConfig_metadata.headers) || {});
    var requestOptions = (0, _mergeDefault.default)(options, {
        credentials: 'same-origin',
        headers: headers
    });
    requestOptions.headers['Content-Type'] = 'application/json';
    // Default `atl-attribution` header value for AGG requests
    // https://hello.atlassian.net/wiki/spaces/AGG/pages/5954141702/Metrics+Attribution+Onboarding+Doc+for+AGG+Clients
    if (!requestOptions.headers['atl-attribution']) requestOptions.headers['atl-attribution'] = JSON.stringify({
        service: 'afm-frontend'
    });
    var _shouldUseGetMethod = shouldUseGetMethod({
        url: url,
        variables: variables,
        request: request,
        headers: requestOptions.headers,
        isServer: isServer
    }), isGetRequest = _shouldUseGetMethod.isGetRequest, reason = _shouldUseGetMethod.reason;
    // Nav4ProjectsContentQuery is forced to go POST route to avoid the stale cache issues when transition between issues in Issue-view
    // that's not a permanent fix, but rather an attampt to unblock the team
    // Context: #jiv-navigation-issue channel
    if (isGetRequest && request.name !== 'Nav4ProjectsContentQuery') {
        requestOptions.method = 'GET';
        url = buildGetUrl(url, variables);
        delete requestOptions.body; // Not needed for GET
    } else {
        requestOptions.method = 'POST';
        if (reason) requestOptions.headers['X-Request-Fallback-To-Post-Reason'] = reason;
    }
    return function() {
        return fetch(url, requestOptions);
    };
}

},{"@swc/helpers/_/_async_iterator":"6B313","@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_await_async_generator":"ZoK6H","@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_wrap_async_generator":"l6OQn","@swc/helpers/_/_ts_generator":"78Tqx","lodash/merge":"yJjRX","relay-runtime":"2IxFR","@atlaskit/platform-feature-flags":"kO5t9","@atlassian/relay-experimental-apis":"kAeBy","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6B313":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _async_iterator;
});
function _async_iterator(iterable) {
    var method, async, sync, retry = 2;
    for("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;){
        if (async && null != (method = iterable[async])) return method.call(iterable);
        if (sync && null != (method = iterable[sync])) return new AsyncFromSyncIterator(method.call(iterable));
        async = "@@asyncIterator", sync = "@@iterator";
    }
    throw new TypeError("Object is not async iterable");
}
function AsyncFromSyncIterator(s) {
    function AsyncFromSyncIteratorContinuation(r) {
        if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object."));
        var done = r.done;
        return Promise.resolve(r.value).then(function(value) {
            return {
                value: value,
                done: done
            };
        });
    }
    return AsyncFromSyncIterator = function(s) {
        this.s = s, this.n = s.next;
    }, AsyncFromSyncIterator.prototype = {
        s: null,
        n: null,
        next: function() {
            return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments));
        },
        return: function(value) {
            var ret = this.s.return;
            return void 0 === ret ? Promise.resolve({
                value: value,
                done: !0
            }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments));
        },
        throw: function(value) {
            var thr = this.s.return;
            return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments));
        }
    }, new AsyncFromSyncIterator(s);
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ZoK6H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _await_async_generator;
});
var _overloadYieldJs = require("./_overload_yield.js");
function _await_async_generator(value) {
    return new (0, _overloadYieldJs._)(value, /* kind: await */ 0);
}

},{"./_overload_yield.js":"jWEF0","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jWEF0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _overload_yield;
});
function _overload_yield(value, /** 0: await 1: delegate */ kind) {
    this.v = value;
    this.k = kind;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"l6OQn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _wrap_async_generator;
});
var _asyncGeneratorJs = require("./_async_generator.js");
function _wrap_async_generator(fn) {
    return function() {
        return new (0, _asyncGeneratorJs._)(fn.apply(this, arguments));
    };
}

},{"./_async_generator.js":"b3t2v","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"b3t2v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _async_generator;
});
var _overloadYieldJs = require("./_overload_yield.js");
function _async_generator(gen) {
    var front, back;
    function send(key, arg) {
        return new Promise(function(resolve, reject) {
            var request = {
                key: key,
                arg: arg,
                resolve: resolve,
                reject: reject,
                next: null
            };
            if (back) back = back.next = request;
            else {
                front = back = request;
                resume(key, arg);
            }
        });
    }
    function resume(key, arg) {
        try {
            var result = gen[key](arg);
            var value = result.value;
            var overloaded = value instanceof (0, _overloadYieldJs._);
            Promise.resolve(overloaded ? value.v : value).then(function(arg) {
                if (overloaded) {
                    var nextKey = key === "return" ? "return" : "next";
                    if (!value.k || arg.done) return resume(nextKey, arg);
                    else arg = gen[nextKey](arg).value;
                }
                settle(result.done ? "return" : "normal", arg);
            }, function(err) {
                resume("throw", err);
            });
        } catch (err) {
            settle("throw", err);
        }
    }
    function settle(type, value) {
        switch(type){
            case "return":
                front.resolve({
                    value: value,
                    done: true
                });
                break;
            case "throw":
                front.reject(value);
                break;
            default:
                front.resolve({
                    value: value,
                    done: false
                });
                break;
        }
        front = front.next;
        if (front) resume(front.key, front.arg);
        else back = null;
    }
    this._invoke = send;
    if (typeof gen.return !== "function") this.return = undefined;
}
_async_generator.prototype[typeof Symbol === "function" && Symbol.asyncIterator || "@@asyncIterator"] = function() {
    return this;
};
_async_generator.prototype.next = function(arg) {
    return this._invoke("next", arg);
};
_async_generator.prototype.throw = function(arg) {
    return this._invoke("throw", arg);
};
_async_generator.prototype.return = function(arg) {
    return this._invoke("return", arg);
};

},{"./_overload_yield.js":"jWEF0","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"yJjRX":[function(require,module,exports,__globalThis) {
var baseMerge = require("437a4ba6f4b8d0f8"), createAssigner = require("bac51cc9cc20662e");
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var merge = createAssigner(function(object, source, srcIndex) {
    baseMerge(object, source, srcIndex);
});
module.exports = merge;

},{"437a4ba6f4b8d0f8":"8M7ww","bac51cc9cc20662e":"biT2Z"}],"8M7ww":[function(require,module,exports,__globalThis) {
var Stack = require("2e14d7430cab0d3b"), assignMergeValue = require("7f6a5ab09465a048"), baseFor = require("17266b5db9438eb"), baseMergeDeep = require("323195e81ac9bf48"), isObject = require("945540e4a412e520"), keysIn = require("60e98c7e28e452f3"), safeGet = require("6cf52da84dfc5152");
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            assignMergeValue(object, key, newValue);
        }
    }, keysIn);
}
module.exports = baseMerge;

},{"2e14d7430cab0d3b":"klKXc","7f6a5ab09465a048":"5L61B","17266b5db9438eb":"8lORV","323195e81ac9bf48":"aNX3B","945540e4a412e520":"cGl8g","60e98c7e28e452f3":"jke6l","6cf52da84dfc5152":"4SOk0"}],"klKXc":[function(require,module,exports,__globalThis) {
var ListCache = require("87cc126d86eb4ab7"), stackClear = require("e1919e4b7ad7f4bb"), stackDelete = require("b127d0b08dacac2c"), stackGet = require("2a349e691867c700"), stackHas = require("17d159e23594520a"), stackSet = require("feae6d753331380c");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
module.exports = Stack;

},{"87cc126d86eb4ab7":"16MdZ","e1919e4b7ad7f4bb":"70dIe","b127d0b08dacac2c":"k1L1w","2a349e691867c700":"6bBkJ","17d159e23594520a":"kFmld","feae6d753331380c":"7Yj9R"}],"16MdZ":[function(require,module,exports,__globalThis) {
var listCacheClear = require("b71d75d4acf9d7eb"), listCacheDelete = require("a926e646705440b3"), listCacheGet = require("34815e5c91501dd1"), listCacheHas = require("630f4e79cd11ac37"), listCacheSet = require("7463d569c4a09448");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
module.exports = ListCache;

},{"b71d75d4acf9d7eb":"aYCka","a926e646705440b3":"eqplm","34815e5c91501dd1":"j7r4n","630f4e79cd11ac37":"6Xuxr","7463d569c4a09448":"4JBNu"}],"aYCka":[function(require,module,exports,__globalThis) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = listCacheClear;

},{}],"eqplm":[function(require,module,exports,__globalThis) {
var assocIndexOf = require("ec997521b4cc6f54");
/** Used for built-in method references. */ var arrayProto = Array.prototype;
/** Built-in value references. */ var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = listCacheDelete;

},{"ec997521b4cc6f54":"6wCl3"}],"6wCl3":[function(require,module,exports,__globalThis) {
var eq = require("4546935c2f35fbd9");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = assocIndexOf;

},{"4546935c2f35fbd9":"cZv4K"}],"cZv4K":[function(require,module,exports,__globalThis) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = eq;

},{}],"j7r4n":[function(require,module,exports,__globalThis) {
var assocIndexOf = require("4a0faf37d4fefe47");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = listCacheGet;

},{"4a0faf37d4fefe47":"6wCl3"}],"6Xuxr":[function(require,module,exports,__globalThis) {
var assocIndexOf = require("e5d21baa4555ebc9");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
module.exports = listCacheHas;

},{"e5d21baa4555ebc9":"6wCl3"}],"4JBNu":[function(require,module,exports,__globalThis) {
var assocIndexOf = require("5ccd320c1b72467f");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = listCacheSet;

},{"5ccd320c1b72467f":"6wCl3"}],"70dIe":[function(require,module,exports,__globalThis) {
var ListCache = require("e0ce0a3712ddf917");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
module.exports = stackClear;

},{"e0ce0a3712ddf917":"16MdZ"}],"k1L1w":[function(require,module,exports,__globalThis) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
module.exports = stackDelete;

},{}],"6bBkJ":[function(require,module,exports,__globalThis) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
module.exports = stackGet;

},{}],"kFmld":[function(require,module,exports,__globalThis) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
module.exports = stackHas;

},{}],"7Yj9R":[function(require,module,exports,__globalThis) {
var _instanceof = require("@swc/helpers/_/_instanceof");
var ListCache = require("efe48d836c19061f"), Map = require("e389201705577ae4"), MapCache = require("76501d422cd6f2fa");
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if ((0, _instanceof._)(data, ListCache)) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = stackSet;

},{"@swc/helpers/_/_instanceof":"h9UKc","efe48d836c19061f":"16MdZ","e389201705577ae4":"ddZHY","76501d422cd6f2fa":"bRb09"}],"ddZHY":[function(require,module,exports,__globalThis) {
var getNative = require("eb532942a00857cb"), root = require("bab57800dedcf18");
/* Built-in method references that are verified to be native. */ var Map = getNative(root, 'Map');
module.exports = Map;

},{"eb532942a00857cb":"bCwni","bab57800dedcf18":"J0J3B"}],"bCwni":[function(require,module,exports,__globalThis) {
var baseIsNative = require("f3ea5cb499788536"), getValue = require("fefe7a576e864dfa");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
module.exports = getNative;

},{"f3ea5cb499788536":"g3kur","fefe7a576e864dfa":"fNxok"}],"g3kur":[function(require,module,exports,__globalThis) {
var isFunction = require("f40733f620f1b80c"), isMasked = require("329a124b9731f600"), isObject = require("993a407aabe61bf8"), toSource = require("3e89fecd5e9373b9");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
module.exports = baseIsNative;

},{"f40733f620f1b80c":"3d98s","329a124b9731f600":"lPxmg","993a407aabe61bf8":"cGl8g","3e89fecd5e9373b9":"gZQCn"}],"3d98s":[function(require,module,exports,__globalThis) {
var baseGetTag = require("dadf40f87eaa441"), isObject = require("17283b6429b6418b");
/** `Object#toString` result references. */ var asyncTag = '[object AsyncFunction]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
module.exports = isFunction;

},{"dadf40f87eaa441":"5NOi0","17283b6429b6418b":"cGl8g"}],"5NOi0":[function(require,module,exports,__globalThis) {
var Symbol = require("3cb98bf9c668e127"), getRawTag = require("a890e443a6f63268"), objectToString = require("f7eacc55b23a363d");
/** `Object#toString` result references. */ var nullTag = '[object Null]', undefinedTag = '[object Undefined]';
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
module.exports = baseGetTag;

},{"3cb98bf9c668e127":"c4qDk","a890e443a6f63268":"35s1v","f7eacc55b23a363d":"ixMi2"}],"c4qDk":[function(require,module,exports,__globalThis) {
var root = require("5958f3272a74759c");
/** Built-in value references. */ var Symbol = root.Symbol;
module.exports = Symbol;

},{"5958f3272a74759c":"J0J3B"}],"J0J3B":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
var freeGlobal = require("6ef3f2a7d95f0e9c");
/** Detect free variable `self`. */ var freeSelf = (typeof self === "undefined" ? "undefined" : (0, _typeOf._)(self)) == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
module.exports = root;

},{"@swc/helpers/_/_type_of":"iFJdx","6ef3f2a7d95f0e9c":"7le4G"}],"7le4G":[function(require,module,exports,__globalThis) {
/** Detect free variable `global` from Node.js. */ var _typeOf = require("@swc/helpers/_/_type_of");
var global = arguments[3];
var freeGlobal = (typeof global === "undefined" ? "undefined" : (0, _typeOf._)(global)) == 'object' && global && global.Object === Object && global;
module.exports = freeGlobal;

},{"@swc/helpers/_/_type_of":"iFJdx"}],"35s1v":[function(require,module,exports,__globalThis) {
var Symbol = require("932ce2caebcad844");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
module.exports = getRawTag;

},{"932ce2caebcad844":"c4qDk"}],"ixMi2":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
module.exports = objectToString;

},{}],"cGl8g":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ var _typeOf = require("@swc/helpers/_/_type_of");
function isObject(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value);
    return value != null && (type == 'object' || type == 'function');
}
module.exports = isObject;

},{"@swc/helpers/_/_type_of":"iFJdx"}],"lPxmg":[function(require,module,exports,__globalThis) {
var coreJsData = require("e047657f967c70ba");
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
module.exports = isMasked;

},{"e047657f967c70ba":"kxrkS"}],"kxrkS":[function(require,module,exports,__globalThis) {
var root = require("e5b83e425b8616ab");
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
module.exports = coreJsData;

},{"e5b83e425b8616ab":"J0J3B"}],"gZQCn":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = toSource;

},{}],"fNxok":[function(require,module,exports,__globalThis) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = getValue;

},{}],"bRb09":[function(require,module,exports,__globalThis) {
var mapCacheClear = require("eca41cec9d1a8d64"), mapCacheDelete = require("171ab6cd80f56036"), mapCacheGet = require("20aae7204f55fc7e"), mapCacheHas = require("cdbfb0efad84062c"), mapCacheSet = require("d69da3af899858a8");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
module.exports = MapCache;

},{"eca41cec9d1a8d64":"f6wAn","171ab6cd80f56036":"cK1SO","20aae7204f55fc7e":"5dWaY","cdbfb0efad84062c":"9f8o2","d69da3af899858a8":"lbC5d"}],"f6wAn":[function(require,module,exports,__globalThis) {
var Hash = require("506417564ee3161b"), ListCache = require("f2e413efad8ea8cf"), Map = require("5437ca7a29f4bc77");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
module.exports = mapCacheClear;

},{"506417564ee3161b":"gUs1X","f2e413efad8ea8cf":"16MdZ","5437ca7a29f4bc77":"ddZHY"}],"gUs1X":[function(require,module,exports,__globalThis) {
var hashClear = require("6481539823ca8950"), hashDelete = require("6c05e6226adc292f"), hashGet = require("6e2d3dd823ec0e77"), hashHas = require("3a427f94863b9c10"), hashSet = require("4be22030e06ca330");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
module.exports = Hash;

},{"6481539823ca8950":"bCfdP","6c05e6226adc292f":"6SkdX","6e2d3dd823ec0e77":"5B4bf","3a427f94863b9c10":"jEfsM","4be22030e06ca330":"ywX7S"}],"bCfdP":[function(require,module,exports,__globalThis) {
var nativeCreate = require("a7ea255eaa79442e");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
module.exports = hashClear;

},{"a7ea255eaa79442e":"9u5hO"}],"9u5hO":[function(require,module,exports,__globalThis) {
var getNative = require("daeeff9a870ee4a");
/* Built-in method references that are verified to be native. */ var nativeCreate = getNative(Object, 'create');
module.exports = nativeCreate;

},{"daeeff9a870ee4a":"bCwni"}],"6SkdX":[function(require,module,exports,__globalThis) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = hashDelete;

},{}],"5B4bf":[function(require,module,exports,__globalThis) {
var nativeCreate = require("b7faaa6a88154935");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = hashGet;

},{"b7faaa6a88154935":"9u5hO"}],"jEfsM":[function(require,module,exports,__globalThis) {
var nativeCreate = require("85efa9aac148c890");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
module.exports = hashHas;

},{"85efa9aac148c890":"9u5hO"}],"ywX7S":[function(require,module,exports,__globalThis) {
var nativeCreate = require("e469e7c3f514318e");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
module.exports = hashSet;

},{"e469e7c3f514318e":"9u5hO"}],"cK1SO":[function(require,module,exports,__globalThis) {
var getMapData = require("74825ed5833ef6b9");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = mapCacheDelete;

},{"74825ed5833ef6b9":"j7hIy"}],"j7hIy":[function(require,module,exports,__globalThis) {
var isKeyable = require("18bcdd78709075b6");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = getMapData;

},{"18bcdd78709075b6":"bKvxr"}],"bKvxr":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ var _typeOf = require("@swc/helpers/_/_type_of");
function isKeyable(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value);
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = isKeyable;

},{"@swc/helpers/_/_type_of":"iFJdx"}],"5dWaY":[function(require,module,exports,__globalThis) {
var getMapData = require("efc637365e213bed");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
module.exports = mapCacheGet;

},{"efc637365e213bed":"j7hIy"}],"9f8o2":[function(require,module,exports,__globalThis) {
var getMapData = require("b85f72e2a889a5e1");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
module.exports = mapCacheHas;

},{"b85f72e2a889a5e1":"j7hIy"}],"lbC5d":[function(require,module,exports,__globalThis) {
var getMapData = require("41ed7e34f8452705");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = mapCacheSet;

},{"41ed7e34f8452705":"j7hIy"}],"5L61B":[function(require,module,exports,__globalThis) {
var baseAssignValue = require("fe599186a88388a2"), eq = require("8a971c10e65740b4");
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignMergeValue(object, key, value) {
    if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
module.exports = assignMergeValue;

},{"fe599186a88388a2":"g5uWh","8a971c10e65740b4":"cZv4K"}],"g5uWh":[function(require,module,exports,__globalThis) {
var defineProperty = require("904bd1a355ae3276");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == '__proto__' && defineProperty) defineProperty(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
module.exports = baseAssignValue;

},{"904bd1a355ae3276":"8uJO6"}],"8uJO6":[function(require,module,exports,__globalThis) {
var getNative = require("9d7533243ab33474");
var defineProperty = function() {
    try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
module.exports = defineProperty;

},{"9d7533243ab33474":"bCwni"}],"8lORV":[function(require,module,exports,__globalThis) {
var createBaseFor = require("89add122c7c33df0");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
module.exports = baseFor;

},{"89add122c7c33df0":"hX3BU"}],"hX3BU":[function(require,module,exports,__globalThis) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = createBaseFor;

},{}],"aNX3B":[function(require,module,exports,__globalThis) {
var assignMergeValue = require("c94a11e8b8c350cc"), cloneBuffer = require("8d693ac5d256514a"), cloneTypedArray = require("902e5391d95df522"), copyArray = require("ddb42bd934c905d2"), initCloneObject = require("46ae1620f449ef7"), isArguments = require("c84b7597418dce36"), isArray = require("7a1dc61084bf6179"), isArrayLikeObject = require("ada7b25f08ba0a09"), isBuffer = require("cbeff241b1d58e6"), isFunction = require("2a7d80465d8f5bbd"), isObject = require("5fbd431708cf37a3"), isPlainObject = require("60cf99b47159fbd1"), isTypedArray = require("6015fd7060284a5e"), safeGet = require("f375afab775ffa9"), toPlainObject = require("b0c3c4152961c9a2");
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if (isArray(objValue)) newValue = objValue;
            else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
            } else newValue = [];
        } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) newValue = toPlainObject(objValue);
            else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
    }
    assignMergeValue(object, key, newValue);
}
module.exports = baseMergeDeep;

},{"c94a11e8b8c350cc":"5L61B","8d693ac5d256514a":"dZ1Ok","902e5391d95df522":"j0AQ4","ddb42bd934c905d2":"a6FPd","46ae1620f449ef7":"4Ax51","c84b7597418dce36":"8QyUt","7a1dc61084bf6179":"7eHCl","ada7b25f08ba0a09":"fB5QR","cbeff241b1d58e6":"chGID","2a7d80465d8f5bbd":"3d98s","5fbd431708cf37a3":"cGl8g","60cf99b47159fbd1":"kQ0vI","6015fd7060284a5e":"3JUwD","f375afab775ffa9":"4SOk0","b0c3c4152961c9a2":"1I2He"}],"dZ1Ok":[function(require,module,exports,__globalThis) {
var root = require("489d138e70b3cb18");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

},{"489d138e70b3cb18":"J0J3B"}],"j0AQ4":[function(require,module,exports,__globalThis) {
var cloneArrayBuffer = require("3659c8461d307f88");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = cloneTypedArray;

},{"3659c8461d307f88":"iINWl"}],"iINWl":[function(require,module,exports,__globalThis) {
var Uint8Array = require("3ea45460e4370dda");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
module.exports = cloneArrayBuffer;

},{"3ea45460e4370dda":"8RJdf"}],"8RJdf":[function(require,module,exports,__globalThis) {
var root = require("5f3272ac1c6427d3");
/** Built-in value references. */ var Uint8Array = root.Uint8Array;
module.exports = Uint8Array;

},{"5f3272ac1c6427d3":"J0J3B"}],"a6FPd":[function(require,module,exports,__globalThis) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
module.exports = copyArray;

},{}],"4Ax51":[function(require,module,exports,__globalThis) {
var baseCreate = require("9a4af657acb4e69b"), getPrototype = require("d1220476b44fe74b"), isPrototype = require("da1f5ecd056bea63");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
module.exports = initCloneObject;

},{"9a4af657acb4e69b":"9cE55","d1220476b44fe74b":"yFmWQ","da1f5ecd056bea63":"flb0y"}],"9cE55":[function(require,module,exports,__globalThis) {
var isObject = require("1e8a7aa91552dc69");
/** Built-in value references. */ var objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!isObject(proto)) return {};
        if (objectCreate) return objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
module.exports = baseCreate;

},{"1e8a7aa91552dc69":"cGl8g"}],"yFmWQ":[function(require,module,exports,__globalThis) {
var overArg = require("d8b8ed7420c88021");
/** Built-in value references. */ var getPrototype = overArg(Object.getPrototypeOf, Object);
module.exports = getPrototype;

},{"d8b8ed7420c88021":"1iwkr"}],"1iwkr":[function(require,module,exports,__globalThis) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = overArg;

},{}],"flb0y":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
module.exports = isPrototype;

},{}],"8QyUt":[function(require,module,exports,__globalThis) {
var baseIsArguments = require("e6a6a615dab5a023"), isObjectLike = require("282ffad55172636f");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function isArguments(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};
module.exports = isArguments;

},{"e6a6a615dab5a023":"eABvh","282ffad55172636f":"eoT9f"}],"eABvh":[function(require,module,exports,__globalThis) {
var baseGetTag = require("20bb2badda4bf28e"), isObjectLike = require("49a052186032281");
/** `Object#toString` result references. */ var argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
module.exports = baseIsArguments;

},{"20bb2badda4bf28e":"5NOi0","49a052186032281":"eoT9f"}],"eoT9f":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ var _typeOf = require("@swc/helpers/_/_type_of");
function isObjectLike(value) {
    return value != null && (typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) == 'object';
}
module.exports = isObjectLike;

},{"@swc/helpers/_/_type_of":"iFJdx"}],"7eHCl":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
module.exports = isArray;

},{}],"fB5QR":[function(require,module,exports,__globalThis) {
var isArrayLike = require("ea07d6e9ec9cc082"), isObjectLike = require("e73c9bb470f1a40e");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
module.exports = isArrayLikeObject;

},{"ea07d6e9ec9cc082":"d4PO7","e73c9bb470f1a40e":"eoT9f"}],"d4PO7":[function(require,module,exports,__globalThis) {
var isFunction = require("87fbba5fdd05275b"), isLength = require("236b61174fa9ad31");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
module.exports = isArrayLike;

},{"87fbba5fdd05275b":"3d98s","236b61174fa9ad31":"axBps"}],"axBps":[function(require,module,exports,__globalThis) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
module.exports = isLength;

},{}],"chGID":[function(require,module,exports,__globalThis) {
var root = require("24ee364a4c69a957"), stubFalse = require("8263c4f23efad726");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
module.exports = isBuffer;

},{"24ee364a4c69a957":"J0J3B","8263c4f23efad726":"8q6IA"}],"8q6IA":[function(require,module,exports,__globalThis) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = stubFalse;

},{}],"kQ0vI":[function(require,module,exports,__globalThis) {
var _instanceof = require("@swc/helpers/_/_instanceof");
var baseGetTag = require("241fad2c49e8a90f"), getPrototype = require("9c6d1b2265f2da98"), isObjectLike = require("78456322c636bc69");
/** `Object#toString` result references. */ var objectTag = '[object Object]';
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
    var proto = getPrototype(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && (0, _instanceof._)(Ctor, Ctor) && funcToString.call(Ctor) == objectCtorString;
}
module.exports = isPlainObject;

},{"@swc/helpers/_/_instanceof":"h9UKc","241fad2c49e8a90f":"5NOi0","9c6d1b2265f2da98":"yFmWQ","78456322c636bc69":"eoT9f"}],"3JUwD":[function(require,module,exports,__globalThis) {
var baseIsTypedArray = require("f5b04ce2c2fe315c"), baseUnary = require("da2dcc2c8cc96f81"), nodeUtil = require("dcb0828e51780b27");
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
module.exports = isTypedArray;

},{"f5b04ce2c2fe315c":"9YuPZ","da2dcc2c8cc96f81":"a0ZXx","dcb0828e51780b27":"7dIbc"}],"9YuPZ":[function(require,module,exports,__globalThis) {
var baseGetTag = require("fa3f68ca211d314a"), isLength = require("a344ba57eae592fc"), isObjectLike = require("57790d11669978df");
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
module.exports = baseIsTypedArray;

},{"fa3f68ca211d314a":"5NOi0","a344ba57eae592fc":"axBps","57790d11669978df":"eoT9f"}],"a0ZXx":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = baseUnary;

},{}],"7dIbc":[function(require,module,exports,__globalThis) {
var freeGlobal = require("2463dd2c8ce28574");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

},{"2463dd2c8ce28574":"7le4G"}],"4SOk0":[function(require,module,exports,__globalThis) {
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') return;
    if (key == '__proto__') return;
    return object[key];
}
module.exports = safeGet;

},{}],"1I2He":[function(require,module,exports,__globalThis) {
var copyObject = require("427c1e183d0a7183"), keysIn = require("844e38b8e53fceb8");
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function toPlainObject(value) {
    return copyObject(value, keysIn(value));
}
module.exports = toPlainObject;

},{"427c1e183d0a7183":"8WoZN","844e38b8e53fceb8":"jke6l"}],"8WoZN":[function(require,module,exports,__globalThis) {
var assignValue = require("b65151970ca99cdb"), baseAssignValue = require("29990736f7880d30");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) baseAssignValue(object, key, newValue);
        else assignValue(object, key, newValue);
    }
    return object;
}
module.exports = copyObject;

},{"b65151970ca99cdb":"gVboZ","29990736f7880d30":"g5uWh"}],"gVboZ":[function(require,module,exports,__globalThis) {
var baseAssignValue = require("647968c96639d3e9"), eq = require("e454804d534f6e80");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
module.exports = assignValue;

},{"647968c96639d3e9":"g5uWh","e454804d534f6e80":"cZv4K"}],"jke6l":[function(require,module,exports,__globalThis) {
var arrayLikeKeys = require("eb5816a5c4bda01a"), baseKeysIn = require("3f661d9d4f298e28"), isArrayLike = require("1cb842d1fda9061e");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
module.exports = keysIn;

},{"eb5816a5c4bda01a":"b0EPV","3f661d9d4f298e28":"4Ky6j","1cb842d1fda9061e":"d4PO7"}],"b0EPV":[function(require,module,exports,__globalThis) {
var baseTimes = require("71f5e47cf09f4ee2"), isArguments = require("b6a480f1ccb92235"), isArray = require("f6451f22aff01079"), isBuffer = require("35e02109f4ce6ebc"), isIndex = require("63d12643a6b45538"), isTypedArray = require("3b2dc20eae96ba9e");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
module.exports = arrayLikeKeys;

},{"71f5e47cf09f4ee2":"k044f","b6a480f1ccb92235":"8QyUt","f6451f22aff01079":"7eHCl","35e02109f4ce6ebc":"chGID","63d12643a6b45538":"7YwKX","3b2dc20eae96ba9e":"3JUwD"}],"k044f":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = baseTimes;

},{}],"7YwKX":[function(require,module,exports,__globalThis) {
/** Used as references for various `Number` constants. */ var _typeOf = require("@swc/helpers/_/_type_of");
var MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value);
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = isIndex;

},{"@swc/helpers/_/_type_of":"iFJdx"}],"4Ky6j":[function(require,module,exports,__globalThis) {
var isObject = require("55035c5a6d2bf429"), isPrototype = require("c03353ee57c174f2"), nativeKeysIn = require("46e2dc9ed626244b");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!isObject(object)) return nativeKeysIn(object);
    var isProto = isPrototype(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = baseKeysIn;

},{"55035c5a6d2bf429":"cGl8g","c03353ee57c174f2":"flb0y","46e2dc9ed626244b":"c5Mct"}],"c5Mct":[function(require,module,exports,__globalThis) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = nativeKeysIn;

},{}],"biT2Z":[function(require,module,exports,__globalThis) {
var baseRest = require("9c5cb8d67d1c627e"), isIterateeCall = require("e9a6a475ab12e84b");
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function createAssigner(assigner) {
    return baseRest(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
module.exports = createAssigner;

},{"9c5cb8d67d1c627e":"lv6wt","e9a6a475ab12e84b":"ikHo3"}],"lv6wt":[function(require,module,exports,__globalThis) {
var identity = require("5e233ded47909374"), overRest = require("4a259694d1a0a8fc"), setToString = require("4f3af83026c84060");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + '');
}
module.exports = baseRest;

},{"5e233ded47909374":"j4SfH","4a259694d1a0a8fc":"7gwIQ","4f3af83026c84060":"2lyVe"}],"j4SfH":[function(require,module,exports,__globalThis) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
module.exports = identity;

},{}],"7gwIQ":[function(require,module,exports,__globalThis) {
var apply = require("615b28151d71be5d");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
    };
}
module.exports = overRest;

},{"615b28151d71be5d":"acB9Y"}],"acB9Y":[function(require,module,exports,__globalThis) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = apply;

},{}],"2lyVe":[function(require,module,exports,__globalThis) {
var baseSetToString = require("46f3d6b7d1ef6b35"), shortOut = require("cd56625481ed641e");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var setToString = shortOut(baseSetToString);
module.exports = setToString;

},{"46f3d6b7d1ef6b35":"9O06a","cd56625481ed641e":"7Rh37"}],"9O06a":[function(require,module,exports,__globalThis) {
var constant = require("4aa3c49195edbb75"), defineProperty = require("1b075781a42b6ba3"), identity = require("8227706c9967b910");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var baseSetToString = !defineProperty ? identity : function baseSetToString(func, string) {
    return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
    });
};
module.exports = baseSetToString;

},{"4aa3c49195edbb75":"hb618","1b075781a42b6ba3":"8uJO6","8227706c9967b910":"j4SfH"}],"hb618":[function(require,module,exports,__globalThis) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function constant(value) {
    return function() {
        return value;
    };
}
module.exports = constant;

},{}],"7Rh37":[function(require,module,exports,__globalThis) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = shortOut;

},{}],"ikHo3":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
var eq = require("5fb1ef43861dba97"), isArrayLike = require("c1aed03080e2f1bd"), isIndex = require("3fb98bb9ba544a70"), isObject = require("f3d889c9663e6d49");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function isIterateeCall(value, index, object) {
    if (!isObject(object)) return false;
    var type = typeof index === "undefined" ? "undefined" : (0, _typeOf._)(index);
    if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
    return false;
}
module.exports = isIterateeCall;

},{"@swc/helpers/_/_type_of":"iFJdx","5fb1ef43861dba97":"cZv4K","c1aed03080e2f1bd":"d4PO7","3fb98bb9ba544a70":"7YwKX","f3d889c9663e6d49":"cGl8g"}],"kAeBy":[function(require,module,exports,__globalThis) {
// Please add your Experimental API name below
// You do not need to wait for approval to add to this list
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RelayExperimentalApis", function() {
    return RelayExperimentalApis;
});
parcelHelpers.export(exports, "getRelayExperimentalApis", function() {
    return getRelayExperimentalApis;
});
var RelayExperimentalApis = [
    'ariGraph',
    'boardCardMove',
    'deleteCard',
    'JiraJqlBuilder',
    'SoftwareCardTypeTransitions',
    'jira-releases-v0',
    'JiraDevOps',
    'JiraDevOpsProviders',
    'createCustomFilter',
    'updateCustomFilter',
    'deleteCustomFilter',
    'customFilters',
    'PermissionScheme',
    'JiraIssue',
    'projectStyle',
    'startSprintPrototype',
    'AddIssuesToFixVersion',
    'JiraVersionResult',
    'JiraIssueConnectionJql',
    'JiraFieldOptionSearching',
    'JiraIssueFieldMutations',
    'JiraIssueDevInfoDetails',
    'JiraIssueDevSummaryCache',
    'JiraVersionWarningConfig',
    'JiraReleaseNotesConfiguration',
    'JiraUpdateReleaseNotesConfiguration',
    'ReleaseNotes',
    'ReleaseNotesOptions',
    'DeploymentsFeaturePrecondition',
    'UpdateVersionWarningConfig',
    'UpdateVersionName',
    'UpdateVersionDescription',
    'UpdateVersionStartDate',
    'UpdateVersionReleaseDate',
    'VersionsForProject',
    'RelatedWork',
    'SuggestedRelatedWorkCategories',
    'setIssueMediaVisibility',
    'toggleBoardFeature',
    'DevOpsProvider',
    'DevOpsSummarisedDeployments',
    'JiraProject',
    'DevOpsSummarisedEntities',
    'RoadmapsMutation',
    'RoadmapsQuery',
    'JiraApplicationProperties',
    'JiraIssueSearch',
    'JiraFilter',
    'featureGroups',
    'setBoardEstimationType',
    'devOps',
    'softwareBoards',
    'name',
    'AddRelatedWorkToVersion',
    'RemoveRelatedWorkFromVersion',
    'admins',
    'canAdministerBoard',
    'jql',
    'globalCardCreateAdditionalFields',
    'GlobalTimeTrackingSettings',
    'ReleaseNotesOptions',
    'search-experience',
    'MoveOrRemoveIssuesToFixVersion',
    'compass-beta',
    'JiraIssueSearchStatus',
    'Townsquare',
    'JiraNavigationItems',
    'JiraVersionsForProjects',
    'columnConfigs',
    'help-object-store-agg-beta',
    'HelpCenterReorderTopics',
    'polaris-v0'
];
var getRelayExperimentalApis = function() {
    return RelayExperimentalApis;
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hBWnz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RETRY_ATTEMPTS_LIMIT", function() {
    return RETRY_ATTEMPTS_LIMIT;
});
parcelHelpers.export(exports, "retryOnError", function() {
    return retryOnError;
});
parcelHelpers.export(exports, "shouldRetry", function() {
    return shouldRetry;
});
parcelHelpers.export(exports, "getRetryAttemptsForQuery", function() {
    return getRetryAttemptsForQuery;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var RETRY_ATTEMPTS_LIMIT = 1;
var retryOnError = function(initialPromiseGetter, param) {
    var retryFunc = param.retryFunc, retryPredicate = param.retryPredicate, _param_retryAttempts = param.retryAttempts, retryAttempts = _param_retryAttempts === void 0 ? RETRY_ATTEMPTS_LIMIT : _param_retryAttempts, onRetry = param.onRetry;
    // Eventually we might like to make max attempts configurable.
    // To do so, we'll need to support jitter & exponential back-off
    var maxAttempts = retryAttempts > RETRY_ATTEMPTS_LIMIT ? RETRY_ATTEMPTS_LIMIT : retryAttempts;
    var execute = function(getPromise) {
        var retryAttempt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        return (0, _asyncToGenerator._)(function() {
            var error, shouldAttemptRetry;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            getPromise()
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                    case 2:
                        error = _state.sent();
                        // If no retry predicate is passed, retry on every error
                        shouldAttemptRetry = retryPredicate ? retryPredicate(error) : true;
                        if (retryAttempt < maxAttempts && shouldAttemptRetry) {
                            onRetry && onRetry(error, retryAttempt + 1);
                            return [
                                2,
                                execute(retryFunc, retryAttempt + 1)
                            ];
                        }
                        throw error;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    return execute(initialPromiseGetter);
};
var shouldRetry = function(error) {
    if ('statusCode' in error && typeof error.statusCode === 'number') return [
        502,
        503,
        504
    ].includes(error.statusCode);
    return false;
};
var getRetryAttemptsForQuery = function(request) {
    if (request.operationKind === 'query') return RETRY_ATTEMPTS_LIMIT;
    return 0;
};

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_ts_generator":"78Tqx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2Of78":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTraceIdFromExtensions", function() {
    return getTraceIdFromExtensions;
});
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var getTraceIdFromExtensions = function(param) {
    var extensions = param.extensions;
    if (extensions === undefined || extensions.gateway === undefined || extensions.gateway === null) return undefined;
    if ((0, _platformFeatureFlags.fg)('platform_relay_fetch_use_tid_property')) {
        if (typeof extensions.gateway.tId === 'string') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return extensions.gateway.tId;
    } else {
        if (typeof extensions.gateway.trace_id === 'string') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return extensions.gateway.trace_id;
    }
    return undefined;
};

},{"@atlaskit/platform-feature-flags":"kO5t9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"i73ck":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JiraQueryFilterMissingFieldHandler", function() {
    return JiraQueryFilterMissingFieldHandler;
});
var _filter = require("@atlassian/ari/jira/filter");
var _relayDataId = require("@atlassian/relay-data-id");
var _relayDataIdDefault = parcelHelpers.interopDefault(_relayDataId);
var isCustomFilter = function(filterId) {
    return /^\d+$/.test(filterId);
};
var isSystemFilter = function(filterId) {
    return /^-\d+$/.test(filterId);
};
var JiraQueryFilterMissingFieldHandler = {
    handle: function(field, record, argValues) {
        // https://relay.dev/docs/guided-tour/reusing-cached-data/filling-in-missing-data/
        // This lets relay know that a query of
        // JiraQuery.filter(id: ID!)
        // can return:
        //   - a JiraCustomFilter object
        //   - a JiraSystemFilter object
        // determined by the type encoded within the id field (which is an ARI type).
        // By providing the id that relay would refer to those objects by, it is able to check it's
        // store to see if they are already fetched, and avoid refetching them if it is unnecessary
        if (record != null && record.getType() === 'JiraQuery' && field.name === 'filter' && argValues.id != null) {
            var id = argValues.id;
            var filterId = (0, _filter.JiraFilterAri).parse(id).filterId;
            if (isCustomFilter(filterId)) return (0, _relayDataIdDefault.default)({
                id: id
            }, 'JiraCustomFilter');
            if (isSystemFilter(filterId)) return (0, _relayDataIdDefault.default)({
                id: id
            }, 'JiraSystemFilter');
            return undefined;
        }
        return undefined;
    },
    kind: 'linked'
};
var MissingFieldHandlers = [
    JiraQueryFilterMissingFieldHandler
];
exports.default = MissingFieldHandlers;

},{"@atlassian/ari/jira/filter":"hdGN8","@atlassian/relay-data-id":"6yDA9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hdGN8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JiraFilterAri", function() {
    return 0, _chunkXXJMI7KOMjs.JiraFilterAri;
});
parcelHelpers.export(exports, "JiraFilterAriResourceOwner", function() {
    return 0, _chunkNQBZEVCSMjs.JiraFilterAriResourceOwner;
});
parcelHelpers.export(exports, "JiraFilterAriResourceType", function() {
    return 0, _chunkNQBZEVCSMjs.JiraFilterAriResourceType;
});
var _chunkXXJMI7KOMjs = require("../../chunk-XXJMI7KO.mjs");
var _chunkNQBZEVCSMjs = require("../../chunk-NQBZEVCS.mjs");
var _chunkAB4PPISIMjs = require("../../chunk-AB4PPISI.mjs");
var _chunkYFR5EBRKMjs = require("../../chunk-YFR5EBRK.mjs");
var _chunkS7RIZVFIMjs = require("../../chunk-S7RIZVFI.mjs");
var _chunkGAA5ADPBMjs = require("../../chunk-GAA5ADPB.mjs");
var _chunkFAZYALZ2Mjs = require("../../chunk-FAZYALZ2.mjs");

},{"../../chunk-XXJMI7KO.mjs":"4sBq2","../../chunk-NQBZEVCS.mjs":false,"../../chunk-AB4PPISI.mjs":false,"../../chunk-YFR5EBRK.mjs":false,"../../chunk-S7RIZVFI.mjs":false,"../../chunk-GAA5ADPB.mjs":false,"../../chunk-FAZYALZ2.mjs":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4sBq2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JiraFilterAri", function() {
    return JiraFilterAri;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _chunkNQBZEVCSMjs = require("./chunk-NQBZEVCS.mjs");
var _chunkAB4PPISIMjs = require("./chunk-AB4PPISI.mjs");
var _chunkS7RIZVFIMjs = require("./chunk-S7RIZVFI.mjs");
// src/jira/filter/manifest.ts
var jiraFilterAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, _chunkNQBZEVCSMjs.JiraFilterAriResourceOwner),
    resourceType: (0, _chunkNQBZEVCSMjs.JiraFilterAriResourceType),
    resourceIdSlug: "activation/{activationId}/{filterId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        filterId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/filter/index.ts
var JiraFilterAri = /*#__PURE__*/ function(RegisteredAri) {
    "use strict";
    (0, _inherits._)(_JiraFilterAri, RegisteredAri);
    function _JiraFilterAri(opts) {
        (0, _classCallCheck._)(this, _JiraFilterAri);
        var _this;
        _this = (0, _callSuper._)(this, _JiraFilterAri, [
            opts
        ]), _this._siteId = opts.cloudId || "", _this._activationId = opts.resourceIdSegmentValues.activationId, _this._filterId = opts.resourceIdSegmentValues.filterId;
        return _this;
    }
    (0, _createClass._)(_JiraFilterAri, [
        {
            key: "siteId",
            get: function get() {
                return this._siteId;
            }
        },
        {
            key: "activationId",
            get: function get() {
                return this._activationId;
            }
        },
        {
            key: "filterId",
            get: function get() {
                return this._filterId;
            }
        },
        {
            key: "getVariables",
            value: function getVariables() {
                return {
                    siteId: this.siteId,
                    activationId: this.activationId,
                    filterId: this.filterId
                };
            }
        }
    ], [
        {
            key: "create",
            value: function create(opts) {
                var derivedOpts = {
                    qualifier: jiraFilterAriStaticOpts.qualifier,
                    platformQualifier: jiraFilterAriStaticOpts.platformQualifier,
                    cloudId: opts.siteId,
                    resourceOwner: jiraFilterAriStaticOpts.resourceOwner,
                    resourceType: jiraFilterAriStaticOpts.resourceType,
                    resourceId: "activation/".concat(opts.activationId, "/").concat(opts.filterId),
                    resourceIdSegmentValues: {
                        activationId: opts.activationId,
                        filterId: opts.filterId
                    }
                }, ariOpts = (0, _chunkS7RIZVFIMjs.AriParser).fromOpts(derivedOpts, jiraFilterAriStaticOpts);
                return new _JiraFilterAri(ariOpts);
            }
        },
        {
            key: "parse",
            value: function parse(maybeAri) {
                var opts = (0, _chunkS7RIZVFIMjs.AriParser).fromString(maybeAri, jiraFilterAriStaticOpts);
                return new _JiraFilterAri(opts);
            }
        }
    ]);
    return _JiraFilterAri;
}((0, _chunkAB4PPISIMjs.RegisteredAri));

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_inherits":"2sfqW","./chunk-NQBZEVCS.mjs":"eNlkT","./chunk-AB4PPISI.mjs":"19mDr","./chunk-S7RIZVFI.mjs":"h8qPM","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eNlkT":[function(require,module,exports,__globalThis) {
// src/jira/filter/types.ts
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JiraFilterAriResourceOwner", function() {
    return JiraFilterAriResourceOwner;
});
parcelHelpers.export(exports, "JiraFilterAriResourceType", function() {
    return JiraFilterAriResourceType;
});
var JiraFilterAriResourceOwner = "jira", JiraFilterAriResourceType = "filter";

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"19mDr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RegisteredAri", function() {
    return RegisteredAri;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _chunkYFR5EBRKMjs = require("./chunk-YFR5EBRK.mjs");
// src/core/registered-ari.ts
var RegisteredAri = /*#__PURE__*/ function(Ari) {
    "use strict";
    (0, _inherits._)(RegisteredAri, Ari);
    function RegisteredAri() {
        (0, _classCallCheck._)(this, RegisteredAri);
        return (0, _callSuper._)(this, RegisteredAri, arguments);
    }
    (0, _createClass._)(RegisteredAri, [
        {
            key: "asAnyAri",
            value: function asAnyAri() {
                return (0, _chunkYFR5EBRKMjs.AnyAri).parse(this.toString());
            }
        }
    ], [
        {
            key: "check",
            value: function check(maybeAri) {
                try {
                    return this.parse(maybeAri.toString()), !0;
                } catch (err) {
                    return !1;
                }
            }
        }
    ]);
    return RegisteredAri;
}((0, _chunkYFR5EBRKMjs.Ari));

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_inherits":"2sfqW","./chunk-YFR5EBRK.mjs":"jzCcT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jzCcT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Ari", function() {
    return Ari;
});
parcelHelpers.export(exports, "AnyAri", function() {
    return AnyAri;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _chunkS7RIZVFIMjs = require("./chunk-S7RIZVFI.mjs");
// src/core/ari.ts
var Ari = /*#__PURE__*/ function() {
    "use strict";
    function Ari(opts) {
        (0, _classCallCheck._)(this, Ari);
        this._ati = (0, _chunkS7RIZVFIMjs.Ati).create({
            platformQualifier: opts.platformQualifier || "cloud",
            resourceOwner: opts.resourceOwner,
            resourceType: opts.resourceType
        }), this._cloudId = opts.cloudId !== "" ? opts.cloudId : void 0, this._resourceId = opts.resourceId;
    }
    (0, _createClass._)(Ari, [
        {
            key: "platformQualifier",
            get: function get() {
                return this._ati.platformQualifier;
            }
        },
        {
            key: "cloudId",
            get: function get() {
                return this._cloudId;
            }
        },
        {
            key: "resourceOwner",
            get: function get() {
                return this._ati.resourceOwner;
            }
        },
        {
            key: "resourceType",
            get: function get() {
                return this._ati.resourceType;
            }
        },
        {
            key: "resourceId",
            get: function get() {
                return this._resourceId;
            }
        },
        {
            key: "ati",
            get: function get() {
                return this._ati;
            }
        },
        {
            key: "equals",
            value: function equals(other) {
                return this.toString() === other.toString();
            }
        },
        {
            key: "toString",
            value: function toString() {
                return "ari:".concat(this.platformQualifier, ":").concat(this.resourceOwner, ":").concat(this.cloudId || "", ":").concat(this.resourceType, "/").concat(this.resourceId);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return this.toString();
            }
        },
        {
            key: "toOpts",
            value: function toOpts() {
                return {
                    platformQualifier: this.platformQualifier,
                    resourceOwner: this.resourceOwner,
                    cloudId: this.cloudId,
                    resourceType: this.resourceType,
                    resourceId: this.resourceId
                };
            }
        }
    ]);
    return Ari;
}();
// src/any-ari.ts
var AnyAri = /*#__PURE__*/ function(Ari) {
    "use strict";
    (0, _inherits._)(_AnyAri, Ari);
    function _AnyAri(opts) {
        (0, _classCallCheck._)(this, _AnyAri);
        return (0, _callSuper._)(this, _AnyAri, [
            opts
        ]);
    }
    (0, _createClass._)(_AnyAri, [
        {
            key: "asAnyAri",
            value: function asAnyAri() {
                return this;
            }
        }
    ], [
        {
            key: "create",
            value: function create(ariOpts, ariStaticOpts) {
                var ariOptsWithDefaults = (0, _objectSpreadProps._)((0, _objectSpread._)({}, ariOpts), {
                    resourceIdSegmentValues: {}
                }), validatedOpts = (0, _chunkS7RIZVFIMjs.AriParser).fromOpts(ariOptsWithDefaults, ariStaticOpts);
                return new _AnyAri(validatedOpts);
            }
        },
        {
            key: "parse",
            value: function parse(maybeAri, ariStaticOpts) {
                var validatedOpts = (0, _chunkS7RIZVFIMjs.AriParser).fromString(maybeAri, ariStaticOpts);
                return new _AnyAri(validatedOpts);
            }
        },
        {
            key: "check",
            value: function check(maybeAri) {
                try {
                    return _AnyAri.parse(maybeAri.toString()), !0;
                } catch (err) {
                    return !1;
                }
            }
        }
    ]);
    return _AnyAri;
}(Ari);

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_inherits":"2sfqW","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","./chunk-S7RIZVFI.mjs":"h8qPM","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"h8qPM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AriParser", function() {
    return AriParser;
});
parcelHelpers.export(exports, "Ati", function() {
    return Ati;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toArray = require("@swc/helpers/_/_to_array");
var _chunkGAA5ADPBMjs = require("./chunk-GAA5ADPB.mjs");
var _chunkFAZYALZ2Mjs = require("./chunk-FAZYALZ2.mjs");
// src/core/rules/cloud-id.ts
function validateCloudId(cloudId) {
    var format = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new RegExp("^[a-zA-Z0-9_\\-.]{0,255}$");
    if (!cloudId.match(format)) throw new (0, _chunkFAZYALZ2Mjs.ValidationError)("Invalid cloud ID, expected ID of format ".concat(format, "."));
}
// src/core/rules/resource-id.ts
function validateResourceId(id) {
    var format = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new RegExp("[!a-zA-Z0-9\\-_.~@:;{}=]+(/[!a-zA-Z0-9\\-_.~@:;{}=]+)*" /* ANY_RESOURCE_ID */ ), key = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "resourceId";
    var formatWithCarets = new RegExp("^".concat(format.source, "$"));
    if (!id.match(formatWithCarets)) throw new (0, _chunkFAZYALZ2Mjs.ValidationError)("Invalid ".concat(key, " - ").concat(id, ", expected ID of format ").concat(formatWithCarets, "."));
}
// src/core/rules/resource-id-segments.ts
function validateResourceIdSegments(resourceIdSegmentValues, resourceIdSegmentFormats) {
    Object.entries(resourceIdSegmentValues).forEach(function(param) {
        var _param = (0, _slicedToArray._)(param, 2), resourceIdKey = _param[0], resourceIdValue = _param[1];
        validateResourceId(resourceIdValue, resourceIdSegmentFormats == null ? void 0 : resourceIdSegmentFormats[resourceIdKey], resourceIdKey);
    });
}
// src/core/rules/resource-owner.ts
function validateResourceOwner(owner, expectedResourceOwner) {
    if (expectedResourceOwner && owner !== expectedResourceOwner) throw new (0, _chunkFAZYALZ2Mjs.ValidationError)("Invalid resource owner - ".concat(owner, ", expected ").concat(expectedResourceOwner, "."));
}
// src/core/rules/resource-type.ts
function validateResourceType(type, expectedResourceType) {
    if (expectedResourceType && type !== expectedResourceType) throw new (0, _chunkFAZYALZ2Mjs.ValidationError)("Invalid resource type - ".concat(type, ", expected ").concat(expectedResourceType, "."));
}
// src/core/parser/ari.ts
var NUMBER_OF_ARI_SEGMENTS = 5, AriParser = /*#__PURE__*/ function(BaseParser) {
    "use strict";
    (0, _inherits._)(AriParser, BaseParser);
    function AriParser() {
        (0, _classCallCheck._)(this, AriParser);
        return (0, _callSuper._)(this, AriParser, arguments);
    }
    (0, _createClass._)(AriParser, null, [
        {
            key: "fromString",
            value: function fromString(maybeAri, ariProperties) {
                var segments = this.getIdentifierSegments(maybeAri, NUMBER_OF_ARI_SEGMENTS), _segments = (0, _slicedToArray._)(segments, 5), qualifier = _segments[0], platformQualifier = _segments[1], resourceOwner = _segments[2], cloudId = _segments[3], resourceTypeAndId = _segments[4], _resourceTypeAndId_split = (0, _toArray._)(resourceTypeAndId.split("/")), resourceType = _resourceTypeAndId_split[0], resourceIdSegments = _resourceTypeAndId_split.slice(1), maybeAriDerivedProperties = {
                    qualifier: qualifier,
                    platformQualifier: platformQualifier,
                    cloudId: cloudId,
                    resourceOwner: resourceOwner,
                    resourceType: resourceType,
                    resourceId: resourceIdSegments.join("/"),
                    resourceIdSegmentValues: ariProperties != null && ariProperties.resourceIdSlug ? this.ariSegmentValuesFromSlug(ariProperties.resourceIdSlug, resourceIdSegments.join("/"), Object.keys(ariProperties.resourceIdSegmentFormats)) : {}
                };
                return this.fromOpts(maybeAriDerivedProperties, ariProperties);
            }
        },
        {
            key: "fromOpts",
            value: function fromOpts(maybeAriOpts, ariProperties) {
                var _maybeAriOpts_qualifier = maybeAriOpts.qualifier, qualifier = _maybeAriOpts_qualifier === void 0 ? "ari" : _maybeAriOpts_qualifier, _maybeAriOpts_platformQualifier = maybeAriOpts.platformQualifier, platformQualifier = _maybeAriOpts_platformQualifier === void 0 ? "cloud" : _maybeAriOpts_platformQualifier, resourceOwner = maybeAriOpts.resourceOwner, cloudId = maybeAriOpts.cloudId, resourceId = maybeAriOpts.resourceId, resourceIdSegmentValues = maybeAriOpts.resourceIdSegmentValues, resourceType = maybeAriOpts.resourceType;
                return (0, _chunkGAA5ADPBMjs.validateAriQualifier)(qualifier), (0, _chunkGAA5ADPBMjs.validatePlatformQualifier)(platformQualifier), validateCloudId(maybeAriOpts.cloudId || "", ariProperties == null ? void 0 : ariProperties.cloudId), validateResourceOwner(resourceOwner, ariProperties == null ? void 0 : ariProperties.resourceOwner), validateResourceType(resourceType, ariProperties == null ? void 0 : ariProperties.resourceType), validateResourceIdSegments(resourceIdSegmentValues, ariProperties == null ? void 0 : ariProperties.resourceIdSegmentFormats), {
                    qualifier: qualifier,
                    resourceOwner: resourceOwner,
                    resourceType: resourceType,
                    platformQualifier: platformQualifier,
                    cloudId: cloudId,
                    resourceId: resourceId,
                    resourceIdSegmentValues: resourceIdSegmentValues
                };
            }
        },
        {
            key: "ariSegmentValuesFromSlug",
            value: function ariSegmentValuesFromSlug(slug, incomingSegments, expectedKeys) {
                var regexpResult = new RegExp("^" + slug.replace(/\{(.*?)\}/g, "(?<$1>.*?)") + "$").exec(incomingSegments);
                if (!regexpResult) throw new (0, _chunkFAZYALZ2Mjs.ValidationError)("Segment '".concat(incomingSegments, "' don't match expected slug: ").concat(slug));
                return expectedKeys.forEach(function(expectedKey) {
                    var _a;
                    if (!((_a = regexpResult.groups) != null && _a[expectedKey])) throw new (0, _chunkFAZYALZ2Mjs.ValidationError)("No value supplied for '".concat(expectedKey, "' based on slug ").concat(slug));
                }), regexpResult.groups || {};
            }
        }
    ]);
    return AriParser;
}((0, _chunkGAA5ADPBMjs.BaseParser));
// src/core/parser/ati.ts
var NUMBER_OF_ATI_SEGMENTS = 4, AtiParser = /*#__PURE__*/ function(BaseParser) {
    "use strict";
    (0, _inherits._)(AtiParser, BaseParser);
    function AtiParser() {
        (0, _classCallCheck._)(this, AtiParser);
        return (0, _callSuper._)(this, AtiParser, arguments);
    }
    (0, _createClass._)(AtiParser, null, [
        {
            key: "fromString",
            value: function fromString(inputStr, atiOpts) {
                var segments = this.getIdentifierSegments(inputStr, NUMBER_OF_ATI_SEGMENTS), _segments = (0, _slicedToArray._)(segments, 4), tmp = _segments[0], qualifier = tmp === void 0 ? "ati" : tmp, tmp1 = _segments[1], platformQualifier = tmp1 === void 0 ? "cloud" : tmp1, resourceOwner = _segments[2], resourceType = _segments[3];
                return (0, _chunkGAA5ADPBMjs.validateAtiQualifier)(qualifier), (0, _chunkGAA5ADPBMjs.validatePlatformQualifier)(platformQualifier), validateResourceOwner(resourceOwner, atiOpts == null ? void 0 : atiOpts.resourceOwner), validateResourceType(resourceType, atiOpts == null ? void 0 : atiOpts.resourceType), {
                    platformQualifier: platformQualifier,
                    resourceOwner: resourceOwner,
                    resourceType: resourceType
                };
            }
        },
        {
            key: "fromOpts",
            value: function fromOpts(maybeAtiOpts, atiOpts) {
                var qualifier = maybeAtiOpts.qualifier, platformQualifier = maybeAtiOpts.platformQualifier, resourceOwner = maybeAtiOpts.resourceOwner, resourceType = maybeAtiOpts.resourceType;
                return (0, _chunkGAA5ADPBMjs.validateAtiQualifier)(qualifier), (0, _chunkGAA5ADPBMjs.validatePlatformQualifier)(platformQualifier), validateResourceOwner(resourceOwner, atiOpts == null ? void 0 : atiOpts.resourceOwner), validateResourceType(resourceType, atiOpts == null ? void 0 : atiOpts.resourceType), {
                    platformQualifier: platformQualifier,
                    resourceOwner: resourceOwner,
                    resourceType: resourceType
                };
            }
        }
    ]);
    return AtiParser;
}((0, _chunkGAA5ADPBMjs.BaseParser));
// src/ati.ts
var Ati = /*#__PURE__*/ function() {
    "use strict";
    function _Ati(platformQualifier, resourceOwner, resourceType) {
        (0, _classCallCheck._)(this, _Ati);
        this._platformQualifier = platformQualifier, this._resourceOwner = resourceOwner, this._resourceType = resourceType;
    }
    (0, _createClass._)(_Ati, [
        {
            key: "platformQualifier",
            get: function get() {
                return this._platformQualifier;
            }
        },
        {
            key: "resourceOwner",
            get: function get() {
                return this._resourceOwner;
            }
        },
        {
            key: "resourceType",
            get: function get() {
                return this._resourceType;
            }
        },
        {
            key: "toString",
            value: function toString() {
                return "ati:".concat(this.platformQualifier, ":").concat(this.resourceOwner, ":").concat(this.resourceType);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return this.toString();
            }
        },
        {
            key: "toOpts",
            value: function toOpts() {
                return {
                    platformQualifier: this._platformQualifier,
                    resourceOwner: this._resourceOwner,
                    resourceType: this._resourceType
                };
            }
        }
    ], [
        {
            key: "create",
            value: function create(opts) {
                return new _Ati(opts.platformQualifier || "cloud", opts.resourceOwner, opts.resourceType);
            }
        },
        {
            key: "parse",
            value: function parse(maybeAti, atiOpts) {
                var opts = AtiParser.fromString(maybeAti, atiOpts);
                return new _Ati(opts.platformQualifier, opts.resourceOwner, opts.resourceType);
            }
        }
    ]);
    return _Ati;
}();

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_inherits":"2sfqW","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_to_array":"auK39","./chunk-GAA5ADPB.mjs":"cvdgR","./chunk-FAZYALZ2.mjs":"7nviT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cvdgR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "validatePlatformQualifier", function() {
    return validatePlatformQualifier;
});
parcelHelpers.export(exports, "validateAtiQualifier", function() {
    return validateAtiQualifier;
});
parcelHelpers.export(exports, "validateAriQualifier", function() {
    return validateAriQualifier;
});
parcelHelpers.export(exports, "validateArmQualifier", function() {
    return validateArmQualifier;
});
parcelHelpers.export(exports, "BaseParser", function() {
    return BaseParser;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _chunkFAZYALZ2Mjs = require("./chunk-FAZYALZ2.mjs");
// src/core/rules/platform-qualifier.ts
function validatePlatformQualifier(qualifier) {
    if (qualifier !== "cloud" && qualifier !== "third-party") throw new (0, _chunkFAZYALZ2Mjs.ValidationError)("Identifier must have a qualifier of 'cloud' or 'third-party'. Received: ".concat(qualifier));
}
// src/core/rules/qualifier.ts
function validateAtiQualifier(qualifier) {
    if (qualifier !== "ati") throw new (0, _chunkFAZYALZ2Mjs.ValidationError)("ATI must have a qualifier of 'ati'. Received: ".concat(qualifier));
}
function validateAriQualifier(qualifier) {
    if (qualifier !== "ari") throw new (0, _chunkFAZYALZ2Mjs.ValidationError)("ARI must have a qualifier of 'ari'. Received: ".concat(qualifier));
}
function validateArmQualifier(qualifier) {
    if (qualifier !== "arm") throw new (0, _chunkFAZYALZ2Mjs.ValidationError)("ARM must have a qualifier of 'arm'. Received: ".concat(qualifier));
}
// src/core/parser/base.ts
var NUMBER_OF_BASE_SEGMENTS = 5, SEGMENT_SEPARATOR = ":", BaseParser = /*#__PURE__*/ function() {
    "use strict";
    function BaseParser() {
        (0, _classCallCheck._)(this, BaseParser);
    }
    (0, _createClass._)(BaseParser, null, [
        {
            key: "getIdentifierSegments",
            value: function getIdentifierSegments(inputStr, numberOfSegmentsRequired) {
                var allSegments = inputStr.split(SEGMENT_SEPARATOR);
                if (allSegments.length < numberOfSegmentsRequired) throw new (0, _chunkFAZYALZ2Mjs.ValidationError)("Input string must have ".concat(numberOfSegmentsRequired, " segments."));
                if (allSegments.length > numberOfSegmentsRequired) {
                    var segments = allSegments.slice(0, NUMBER_OF_BASE_SEGMENTS - 1), segmentsForResourceId = allSegments.slice(NUMBER_OF_BASE_SEGMENTS - 1, allSegments.length);
                    return (0, _toConsumableArray._)(segments).concat([
                        segmentsForResourceId.join(SEGMENT_SEPARATOR)
                    ]);
                }
                return allSegments;
            }
        }
    ]);
    return BaseParser;
}();

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_to_consumable_array":"1eSZf","./chunk-FAZYALZ2.mjs":"7nviT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7nviT":[function(require,module,exports,__globalThis) {
// src/errors.ts
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ValidationError", function() {
    return ValidationError;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _inherits = require("@swc/helpers/_/_inherits");
var _wrapNativeSuper = require("@swc/helpers/_/_wrap_native_super");
var ValidationError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, _inherits._)(ValidationError, Error1);
    function ValidationError() {
        (0, _classCallCheck._)(this, ValidationError);
        return (0, _callSuper._)(this, ValidationError, arguments);
    }
    return ValidationError;
}((0, _wrapNativeSuper._)(Error));

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_inherits":"2sfqW","@swc/helpers/_/_wrap_native_super":"d0Iin","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7QvFn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
exports.default = {
    cancel: function() {},
    schedule: function(fn) {
        // react 16.x
        if (// `unstable_batchedUpdates` is defined in all currently supported versions
        // but could be removed in the future.
        // This check is defensive and not currently necessary.
        typeof (0, _reactDomDefault.default).unstable_batchedUpdates === 'function' && // The version export was only introduced in `react-dom@16.13.0`
        // but we need to support `react-dom@^16.8.0`
        // so we need to handle when the version is `undefined`
        (typeof (0, _reactDom.version) === 'undefined' || (0, _reactDom.version).startsWith('16'))) (0, _reactDomDefault.default).unstable_batchedUpdates(function() {
            fn();
        });
        else if (typeof (0, _reactDefault.default).startTransition === 'function') // @ts-ignore -error React.startTransition does not exist in react-16
        (0, _reactDefault.default).startTransition(function() {
            fn();
        });
        else fn();
        return '';
    }
};

},{"react":"ltHCL","react-dom":"bvX0P","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"l0yWd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createSubscribeFn", function() {
    return createSubscribeFn;
});
parcelHelpers.export(exports, "subscribe", function() {
    return subscribe;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _typeOf = require("@swc/helpers/_/_type_of");
var _relayRuntime = require("relay-runtime");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _graphqlSubscription = require("@atlassian/graphql-subscription");
var cachedDefaultSubscribe;
function createSubscribeFn(subscribeOptions) {
    if (typeof subscribeOptions === 'undefined' && typeof cachedDefaultSubscribe !== 'undefined') return cachedDefaultSubscribe;
    var fn = function(param, variables, cacheConfig) {
        var id = param.id, operationName = param.name;
        return (0, _relayRuntime.Observable).create(function(sink) {
            var _cacheConfig_metadata, _subscribeOptions_onSubscribeTrigger;
            var client = (0, _graphqlSubscription.getClient)();
            if (!client) return sink.error(new Error('Unable to create subscription client'));
            var replayConfig = (cacheConfig === null || cacheConfig === void 0 ? void 0 : (_cacheConfig_metadata = cacheConfig.metadata) === null || _cacheConfig_metadata === void 0 ? void 0 : _cacheConfig_metadata.replay) || undefined;
            // When the fix gate is ON and the caller supplies a `command` key inside
            // replayConfig, hoist it to extensions.command (flat) to match AGG's
            // expected wire shape. AGG reads extensions["command"] directly; the
            // previous extensions.replay.command nesting was silently dropped and no
            // Replay ChannelCommand was ever issued. See CRCS-3291.
            // When the gate is OFF the old extensions.replay: {...} shape is preserved,
            // which is the broken-but-stable status-quo for consumers not using replay.
            var replayCommand = replayConfig !== null && (typeof replayConfig === "undefined" ? "undefined" : (0, _typeOf._)(replayConfig)) === 'object' && 'command' in replayConfig ? replayConfig.command : undefined;
            var replayExtensions = replayCommand && (0, _platformFeatureFlags.fg)('platform_relay_subscription_fix_replay_command') ? {
                command: replayCommand
            } : replayConfig ? {
                replay: replayConfig
            } : {};
            var payload = {
                query: '',
                operationName: operationName,
                variables: variables,
                extensions: (0, _objectSpread._)({
                    pq: id
                }, (subscribeOptions === null || subscribeOptions === void 0 ? void 0 : subscribeOptions.subscribeExtensions) || {}, replayExtensions)
            };
            var requestId = null;
            subscribeOptions === null || subscribeOptions === void 0 ? void 0 : (_subscribeOptions_onSubscribeTrigger = subscribeOptions.onSubscribeTrigger) === null || _subscribeOptions_onSubscribeTrigger === void 0 ? void 0 : _subscribeOptions_onSubscribeTrigger.call(subscribeOptions, payload);
            return client.subscribe(payload, (0, _objectSpreadProps._)((0, _objectSpread._)({}, sink), {
                next: function(value) {
                    var _value_extensions_gateway, _value_extensions;
                    // @ts-expect-error agg prop is missing on generic "extensions" type
                    var aggRequestId = value === null || value === void 0 ? void 0 : (_value_extensions = value.extensions) === null || _value_extensions === void 0 ? void 0 : (_value_extensions_gateway = _value_extensions.gateway) === null || _value_extensions_gateway === void 0 ? void 0 : _value_extensions_gateway.request_id;
                    requestId = aggRequestId !== null && aggRequestId !== void 0 ? aggRequestId : requestId;
                    // @ts-expect-error incompatible types between two libraries
                    sink.next(value);
                },
                error: function(sinkError) {
                    var _subscribeOptions_onSubscribeError;
                    var errorInfo = (0, _graphqlSubscription.getSinkError)(sinkError);
                    sink.error(errorInfo);
                    subscribeOptions === null || subscribeOptions === void 0 ? void 0 : (_subscribeOptions_onSubscribeError = subscribeOptions.onSubscribeError) === null || _subscribeOptions_onSubscribeError === void 0 ? void 0 : _subscribeOptions_onSubscribeError.call(subscribeOptions, (0, _objectSpreadProps._)((0, _objectSpread._)({}, payload), {
                        requestId: requestId
                    }));
                }
            }));
        });
    };
    if (typeof subscribeOptions === 'undefined') cachedDefaultSubscribe = fn;
    return fn;
}
var subscribe = createSubscribeFn();

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_type_of":"iFJdx","relay-runtime":"2IxFR","@atlaskit/platform-feature-flags":"kO5t9","@atlassian/graphql-subscription":"dImBY","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dImBY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSubscribe", function() {
    return 0, _subscribe.useSubscribe;
});
parcelHelpers.export(exports, "getClient", function() {
    return 0, _client.getClient;
});
parcelHelpers.export(exports, "getSinkError", function() {
    return 0, _sink.getSinkError;
});
var _subscribe = require("./services/subscribe");
var _client = require("./utils/client");
var _sink = require("./utils/sink");

},{"./services/subscribe":false,"./utils/client":"4rrvm","./utils/sink":"62IKu","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4rrvm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getClient", function() {
    return getClient;
});
parcelHelpers.export(exports, "cleanUpClient", function() {
    return cleanUpClient;
});
var _graphqlWs = require("graphql-ws");
var _relayExperimentalApis = require("@atlassian/relay-experimental-apis");
var _constants = require("../../constants");
var _index = require("../index");
var client;
var getClient = function() {
    var _window, _window1;
    if ((0, _index.isSSR)()) return null;
    var _window_BUILD_KEY, _window_SSR_BUILD_KEY;
    if (!client) client = (0, _graphqlWs.createClient)({
        url: (0, _index.getAggSubscriptionEndpoint)(),
        lazy: true,
        keepAlive: (0, _constants.WS_CLIENT_KEEP_ALIVE),
        retryAttempts: (0, _constants.WS_CLIENT_RETRIES),
        connectionParams: {
            'atl-client-name': 'jira-frontend',
            'atl-client-version': "".concat((_window_BUILD_KEY = (_window = window) === null || _window === void 0 ? void 0 : _window.BUILD_KEY) !== null && _window_BUILD_KEY !== void 0 ? _window_BUILD_KEY : '', "::").concat((_window_SSR_BUILD_KEY = (_window1 = window) === null || _window1 === void 0 ? void 0 : _window1.SSR_BUILD_KEY) !== null && _window_SSR_BUILD_KEY !== void 0 ? _window_SSR_BUILD_KEY : ''),
            'X-ExperimentalApi': (0, _relayExperimentalApis.getRelayExperimentalApis)().join(',')
        }
    });
    return client;
};
var cleanUpClient = function() {
    client = null;
};

},{"graphql-ws":"eDBVp","@atlassian/relay-experimental-apis":"kAeBy","../../constants":"8AQSH","../index":"lbiag","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eDBVp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _clientMjs = require("./client.mjs");
parcelHelpers.exportAll(_clientMjs, exports);
var _serverMjs = require("./server.mjs");
parcelHelpers.exportAll(_serverMjs, exports);
var _commonMjs = require("./common.mjs");
parcelHelpers.exportAll(_commonMjs, exports);

},{"./client.mjs":"ebcMP","./server.mjs":false,"./common.mjs":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ebcMP":[function(require,module,exports,__globalThis) {
/**
 *
 * client
 *
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Creates a disposable GraphQL over WebSocket client.
 *
 * @category Client
 */ parcelHelpers.export(exports, "createClient", function() {
    return createClient;
});
parcelHelpers.export(exports, "TerminatedCloseEvent", function() {
    return TerminatedCloseEvent;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _inherits = require("@swc/helpers/_/_inherits");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var _wrapNativeSuper = require("@swc/helpers/_/_wrap_native_super");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _tsValues = require("@swc/helpers/_/_ts_values");
var _commonMjs = require("./common.mjs");
var _utilsMjs = require("./utils.mjs");
/** This file is the entry point for browsers, re-export common elements. */ parcelHelpers.exportAll(_commonMjs, exports);
var global = arguments[3];
var __await = undefined && undefined.__await || function(v) {
    return (0, _instanceof._)(this, __await) ? (this.v = v, this) : new __await(v);
};
var __asyncGenerator = undefined && undefined.__asyncGenerator || function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        (0, _instanceof._)(r.value, __await) ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
function createClient(options) {
    var url = options.url, connectionParams = options.connectionParams, _options_lazy = options.lazy, lazy = _options_lazy === void 0 ? true : _options_lazy, _options_onNonLazyError = options.onNonLazyError, onNonLazyError = _options_onNonLazyError === void 0 ? console.error : _options_onNonLazyError, tmp = options.lazyCloseTimeout, lazyCloseTimeoutMs = tmp === void 0 ? 0 : tmp, _options_keepAlive = options.keepAlive, keepAlive = _options_keepAlive === void 0 ? 0 : _options_keepAlive, disablePong = options.disablePong, _options_connectionAckWaitTimeout = options.connectionAckWaitTimeout, connectionAckWaitTimeout = _options_connectionAckWaitTimeout === void 0 ? 0 : _options_connectionAckWaitTimeout, _options_retryAttempts = options.retryAttempts, retryAttempts = _options_retryAttempts === void 0 ? 5 : _options_retryAttempts, _options_retryWait = options.retryWait, retryWait = _options_retryWait === void 0 ? function randomisedExponentialBackoff(retries) {
        return (0, _asyncToGenerator._)(function() {
            var retryDelay, i;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        retryDelay = 1000; // start with 1s delay
                        for(i = 0; i < retries; i++)retryDelay *= 2;
                        return [
                            4,
                            new Promise(function(resolve) {
                                return setTimeout(resolve, retryDelay + // add random timeout from 300ms to 3s
                                Math.floor(Math.random() * 2700 + 300));
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    } : _options_retryWait, _options_shouldRetry = options.shouldRetry, shouldRetry = _options_shouldRetry === void 0 ? isLikeCloseEvent : _options_shouldRetry, isFatalConnectionProblem = options.isFatalConnectionProblem, on = options.on, webSocketImpl = options.webSocketImpl, _options_generateID = options./**
     * Generates a v4 UUID to be used as the ID using `Math`
     * as the random number generator. Supply your own generator
     * in case you need more uniqueness.
     *
     * Reference: https://gist.github.com/jed/982883
     */ generateID, generateID = _options_generateID === void 0 ? function generateUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
            return v.toString(16);
        });
    } : _options_generateID, replacer = options.jsonMessageReplacer, reviver = options.jsonMessageReviver;
    var ws;
    if (webSocketImpl) {
        if (!isWebSocket(webSocketImpl)) throw new Error('Invalid WebSocket implementation provided');
        ws = webSocketImpl;
    } else if (typeof WebSocket !== 'undefined') ws = WebSocket;
    else if (typeof global !== 'undefined') ws = global.WebSocket || // @ts-expect-error: Support more browsers
    global.MozWebSocket;
    else if (typeof window !== 'undefined') ws = window.WebSocket || // @ts-expect-error: Support more browsers
    window.MozWebSocket;
    if (!ws) throw new Error("WebSocket implementation missing; on Node you can `import WebSocket from 'ws';` and pass `webSocketImpl: WebSocket` to `createClient`");
    var WebSocketImpl = ws;
    // websocket status emitter, subscriptions are handled differently
    var emitter = function() {
        var message = function() {
            var listeners = {};
            return {
                on: function on(id, listener) {
                    listeners[id] = listener;
                    return function() {
                        delete listeners[id];
                    };
                },
                emit: function emit(message) {
                    var _a;
                    if ('id' in message) (_a = listeners[message.id]) === null || _a === void 0 || _a.call(listeners, message);
                }
            };
        }();
        var listeners = {
            connecting: (on === null || on === void 0 ? void 0 : on.connecting) ? [
                on.connecting
            ] : [],
            opened: (on === null || on === void 0 ? void 0 : on.opened) ? [
                on.opened
            ] : [],
            connected: (on === null || on === void 0 ? void 0 : on.connected) ? [
                on.connected
            ] : [],
            ping: (on === null || on === void 0 ? void 0 : on.ping) ? [
                on.ping
            ] : [],
            pong: (on === null || on === void 0 ? void 0 : on.pong) ? [
                on.pong
            ] : [],
            message: (on === null || on === void 0 ? void 0 : on.message) ? [
                message.emit,
                on.message
            ] : [
                message.emit
            ],
            closed: (on === null || on === void 0 ? void 0 : on.closed) ? [
                on.closed
            ] : [],
            error: (on === null || on === void 0 ? void 0 : on.error) ? [
                on.error
            ] : []
        };
        return {
            onMessage: message.on,
            on: function on(event, listener) {
                var l = listeners[event];
                l.push(listener);
                return function() {
                    l.splice(l.indexOf(listener), 1);
                };
            },
            emit: function emit(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // we copy the listeners so that unlistens dont "pull the rug under our feet"
                    for(var _iterator = (0, _toConsumableArray._)(listeners[event])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var listener = _step.value;
                        // @ts-expect-error: The args should fit
                        listener.apply(void 0, (0, _toConsumableArray._)(args));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        };
    }();
    // invokes the callback either when an error or closed event is emitted,
    // first one that gets called prevails, other emissions are ignored
    function errorOrClosed(cb) {
        var listening = [
            // errors are fatal and more critical than close events, throw them first
            emitter.on('error', function(err) {
                listening.forEach(function(unlisten) {
                    return unlisten();
                });
                cb(err);
            }),
            // closes can be graceful and not fatal, throw them second (if error didnt throw)
            emitter.on('closed', function(event) {
                listening.forEach(function(unlisten) {
                    return unlisten();
                });
                cb(event);
            })
        ];
    }
    var connecting, locks = 0, lazyCloseTimeout, retrying = false, retries = 0, disposed = false;
    function connect() {
        return (0, _asyncToGenerator._)(function() {
            var _ref, socket, throwOnClose, release, released;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // clear the lazy close timeout immediatelly so that close gets debounced
                        // see: https://github.com/enisdenjo/graphql-ws/issues/388
                        clearTimeout(lazyCloseTimeout);
                        return [
                            4,
                            connecting !== null && connecting !== void 0 ? connecting : connecting = new Promise(function(connected, denied) {
                                return function() {
                                    return (0, _asyncToGenerator._)(function() {
                                        var socket, _, _tmp, connectionAckTimeout, queuedPing, acknowledged;
                                        function enqueuePing() {
                                            if (isFinite(keepAlive) && keepAlive > 0) {
                                                clearTimeout(queuedPing); // in case where a pong was received before a ping (this is valid behaviour)
                                                queuedPing = setTimeout(function() {
                                                    if (socket.readyState === WebSocketImpl.OPEN) {
                                                        socket.send((0, _commonMjs.stringifyMessage)({
                                                            type: (0, _commonMjs.MessageType).Ping
                                                        }));
                                                        emitter.emit('ping', false, undefined);
                                                    }
                                                }, keepAlive);
                                            }
                                        }
                                        return (0, _tsGenerator._)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    if (!retrying) return [
                                                        3,
                                                        2
                                                    ];
                                                    return [
                                                        4,
                                                        retryWait(retries)
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    // subscriptions might complete while waiting for retry
                                                    if (!locks) {
                                                        connecting = undefined;
                                                        return [
                                                            2,
                                                            denied({
                                                                code: 1000,
                                                                reason: 'All Subscriptions Gone'
                                                            })
                                                        ];
                                                    }
                                                    retries++;
                                                    _state.label = 2;
                                                case 2:
                                                    emitter.emit('connecting', retrying);
                                                    _ = WebSocketImpl.bind;
                                                    if (!(typeof url === 'function')) return [
                                                        3,
                                                        4
                                                    ];
                                                    return [
                                                        4,
                                                        url()
                                                    ];
                                                case 3:
                                                    _tmp = _state.sent();
                                                    return [
                                                        3,
                                                        5
                                                    ];
                                                case 4:
                                                    _tmp = url;
                                                    _state.label = 5;
                                                case 5:
                                                    socket = new (_.apply(WebSocketImpl, [
                                                        void 0,
                                                        _tmp,
                                                        (0, _commonMjs.GRAPHQL_TRANSPORT_WS_PROTOCOL)
                                                    ]));
                                                    errorOrClosed(function(errOrEvent) {
                                                        connecting = undefined;
                                                        clearTimeout(connectionAckTimeout);
                                                        clearTimeout(queuedPing);
                                                        denied(errOrEvent);
                                                        if ((0, _instanceof._)(errOrEvent, TerminatedCloseEvent)) {
                                                            socket.close(4499, 'Terminated'); // close event is artificial and emitted manually, see `Client.terminate()` below
                                                            socket.onerror = null;
                                                            socket.onclose = null;
                                                        }
                                                    });
                                                    socket.onerror = function(err) {
                                                        return emitter.emit('error', err);
                                                    };
                                                    socket.onclose = function(event) {
                                                        return emitter.emit('closed', event);
                                                    };
                                                    socket.onopen = function() {
                                                        return (0, _asyncToGenerator._)(function() {
                                                            var payload, _tmp, err;
                                                            return (0, _tsGenerator._)(this, function(_state) {
                                                                switch(_state.label){
                                                                    case 0:
                                                                        _state.trys.push([
                                                                            0,
                                                                            4,
                                                                            ,
                                                                            5
                                                                        ]);
                                                                        emitter.emit('opened', socket);
                                                                        if (!(typeof connectionParams === 'function')) return [
                                                                            3,
                                                                            2
                                                                        ];
                                                                        return [
                                                                            4,
                                                                            connectionParams()
                                                                        ];
                                                                    case 1:
                                                                        _tmp = _state.sent();
                                                                        return [
                                                                            3,
                                                                            3
                                                                        ];
                                                                    case 2:
                                                                        _tmp = connectionParams;
                                                                        _state.label = 3;
                                                                    case 3:
                                                                        payload = _tmp;
                                                                        // connectionParams might take too long causing the server to kick off the client
                                                                        // the necessary error/close event is already reported - simply stop execution
                                                                        if (socket.readyState !== WebSocketImpl.OPEN) return [
                                                                            2
                                                                        ];
                                                                        socket.send((0, _commonMjs.stringifyMessage)(payload ? {
                                                                            type: (0, _commonMjs.MessageType).ConnectionInit,
                                                                            payload: payload
                                                                        } : {
                                                                            type: (0, _commonMjs.MessageType).ConnectionInit
                                                                        }, replacer));
                                                                        if (isFinite(connectionAckWaitTimeout) && connectionAckWaitTimeout > 0) connectionAckTimeout = setTimeout(function() {
                                                                            socket.close((0, _commonMjs.CloseCode).ConnectionAcknowledgementTimeout, 'Connection acknowledgement timeout');
                                                                        }, connectionAckWaitTimeout);
                                                                        enqueuePing(); // enqueue ping (noop if disabled)
                                                                        return [
                                                                            3,
                                                                            5
                                                                        ];
                                                                    case 4:
                                                                        err = _state.sent();
                                                                        emitter.emit('error', err);
                                                                        socket.close((0, _commonMjs.CloseCode).InternalClientError, (0, _utilsMjs.limitCloseReason)((0, _instanceof._)(err, Error) ? err.message : new Error(err).message, 'Internal client error'));
                                                                        return [
                                                                            3,
                                                                            5
                                                                        ];
                                                                    case 5:
                                                                        return [
                                                                            2
                                                                        ];
                                                                }
                                                            });
                                                        })();
                                                    };
                                                    acknowledged = false;
                                                    socket.onmessage = function(param) {
                                                        var data = param.data;
                                                        try {
                                                            var message = (0, _commonMjs.parseMessage)(data, reviver);
                                                            emitter.emit('message', message);
                                                            if (message.type === 'ping' || message.type === 'pong') {
                                                                emitter.emit(message.type, true, message.payload); // received
                                                                if (message.type === 'pong') enqueuePing(); // enqueue next ping (noop if disabled)
                                                                else if (!disablePong) {
                                                                    // respond with pong on ping
                                                                    socket.send((0, _commonMjs.stringifyMessage)(message.payload ? {
                                                                        type: (0, _commonMjs.MessageType).Pong,
                                                                        payload: message.payload
                                                                    } : {
                                                                        type: (0, _commonMjs.MessageType).Pong
                                                                    }));
                                                                    emitter.emit('pong', false, message.payload);
                                                                }
                                                                return; // ping and pongs can be received whenever
                                                            }
                                                            if (acknowledged) return; // already connected and acknowledged
                                                            if (message.type !== (0, _commonMjs.MessageType).ConnectionAck) throw new Error("First message cannot be of type ".concat(message.type));
                                                            clearTimeout(connectionAckTimeout);
                                                            acknowledged = true;
                                                            emitter.emit('connected', socket, message.payload, retrying); // connected = socket opened + acknowledged
                                                            retrying = false; // future lazy connects are not retries
                                                            retries = 0; // reset the retries on connect
                                                            connected([
                                                                socket,
                                                                new Promise(function(_, reject) {
                                                                    return errorOrClosed(reject);
                                                                })
                                                            ]);
                                                        } catch (err) {
                                                            socket.onmessage = null; // stop reading messages as soon as reading breaks once
                                                            emitter.emit('error', err);
                                                            socket.close((0, _commonMjs.CloseCode).BadResponse, (0, _utilsMjs.limitCloseReason)((0, _instanceof._)(err, Error) ? err.message : new Error(err).message, 'Bad response'));
                                                        }
                                                    };
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    })();
                                }();
                            })
                        ];
                    case 1:
                        _ref = (0, _slicedToArray._).apply(void 0, [
                            _state.sent(),
                            2
                        ]), socket = _ref[0], throwOnClose = _ref[1];
                        if (!(socket.readyState === WebSocketImpl.CLOSING)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            throwOnClose
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        release = function() {
                        // releases this connection
                        };
                        released = new Promise(function(resolve) {
                            return release = resolve;
                        });
                        return [
                            2,
                            [
                                socket,
                                release,
                                Promise.race([
                                    // wait for
                                    released.then(function() {
                                        if (!locks) {
                                            // and if no more locks are present, complete the connection
                                            var complete = function() {
                                                return socket.close(1000, 'Normal Closure');
                                            };
                                            if (isFinite(lazyCloseTimeoutMs) && lazyCloseTimeoutMs > 0) // if the keepalive is set, allow for the specified calmdown time and
                                            // then complete if the socket is still open.
                                            lazyCloseTimeout = setTimeout(function() {
                                                if (socket.readyState === WebSocketImpl.OPEN) complete();
                                            }, lazyCloseTimeoutMs);
                                            else // otherwise complete immediately
                                            complete();
                                        }
                                    }),
                                    // or
                                    throwOnClose
                                ])
                            ]
                        ];
                }
            });
        })();
    }
    /**
     * Checks the `connect` problem and evaluates if the client should retry.
     */ function shouldRetryConnectOrThrow(errOrCloseEvent) {
        // some close codes are worth reporting immediately
        if (isLikeCloseEvent(errOrCloseEvent) && (isFatalInternalCloseCode(errOrCloseEvent.code) || [
            (0, _commonMjs.CloseCode).InternalServerError,
            (0, _commonMjs.CloseCode).InternalClientError,
            (0, _commonMjs.CloseCode).BadRequest,
            (0, _commonMjs.CloseCode).BadResponse,
            (0, _commonMjs.CloseCode).Unauthorized,
            // CloseCode.Forbidden, might grant access out after retry
            (0, _commonMjs.CloseCode).SubprotocolNotAcceptable,
            // CloseCode.ConnectionInitialisationTimeout, might not time out after retry
            // CloseCode.ConnectionAcknowledgementTimeout, might not time out after retry
            (0, _commonMjs.CloseCode).SubscriberAlreadyExists,
            (0, _commonMjs.CloseCode).TooManyInitialisationRequests
        ].includes(errOrCloseEvent.code))) throw errOrCloseEvent;
        // client was disposed, no retries should proceed regardless
        if (disposed) return false;
        // normal closure (possibly all subscriptions have completed)
        // if no locks were acquired in the meantime, shouldnt try again
        if (isLikeCloseEvent(errOrCloseEvent) && errOrCloseEvent.code === 1000) return locks > 0;
        // retries are not allowed or we tried to many times, report error
        if (!retryAttempts || retries >= retryAttempts) throw errOrCloseEvent;
        // throw non-retryable connection problems
        if (!shouldRetry(errOrCloseEvent)) throw errOrCloseEvent;
        // @deprecated throw fatal connection problems immediately
        if (isFatalConnectionProblem === null || isFatalConnectionProblem === void 0 ? void 0 : isFatalConnectionProblem(errOrCloseEvent)) throw errOrCloseEvent;
        // looks good, start retrying
        return retrying = true;
    }
    // in non-lazy (hot?) mode always hold one connection lock to persist the socket
    if (!lazy) (function() {
        return (0, _asyncToGenerator._)(function() {
            var _ref, throwOnClose, errOrCloseEvent;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        locks++;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            connect()
                        ];
                    case 2:
                        _ref = (0, _slicedToArray._).apply(void 0, [
                            _state.sent(),
                            3
                        ]), throwOnClose = _ref[2];
                        return [
                            4,
                            throwOnClose
                        ];
                    case 3:
                        _state.sent(); // will always throw because releaser is not used
                        return [
                            3,
                            5
                        ];
                    case 4:
                        errOrCloseEvent = _state.sent();
                        try {
                            if (!shouldRetryConnectOrThrow(errOrCloseEvent)) return [
                                2
                            ];
                        } catch (errOrCloseEvent) {
                            // report thrown error, no further retries
                            return [
                                2,
                                onNonLazyError === null || onNonLazyError === void 0 ? void 0 : onNonLazyError(errOrCloseEvent)
                            ];
                        }
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            3,
                            1
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    })();
    function subscribe(payload, sink) {
        var id = generateID(payload);
        var done = false, errored = false, releaser = function() {
            // for handling completions before connect
            locks--;
            done = true;
        };
        (function() {
            return (0, _asyncToGenerator._)(function() {
                var _loop, _ret;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _loop = function() {
                                var _ref, socket, release, waitForReleaseOrThrowOnClose, unlisten, errOrCloseEvent;
                                return (0, _tsGenerator._)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            _state.trys.push([
                                                0,
                                                3,
                                                ,
                                                4
                                            ]);
                                            return [
                                                4,
                                                connect()
                                            ];
                                        case 1:
                                            _ref = (0, _slicedToArray._).apply(void 0, [
                                                _state.sent(),
                                                3
                                            ]), socket = _ref[0], release = _ref[1], waitForReleaseOrThrowOnClose = _ref[2];
                                            // if done while waiting for connect, release the connection lock right away
                                            if (done) return [
                                                2,
                                                {
                                                    v: release()
                                                }
                                            ];
                                            unlisten = emitter.onMessage(id, function(message) {
                                                switch(message.type){
                                                    case (0, _commonMjs.MessageType).Next:
                                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- payload will fit type
                                                        sink.next(message.payload);
                                                        return;
                                                    case (0, _commonMjs.MessageType).Error:
                                                        errored = true, done = true;
                                                        sink.error(message.payload);
                                                        releaser();
                                                        return;
                                                    case (0, _commonMjs.MessageType).Complete:
                                                        done = true;
                                                        releaser(); // release completes the sink
                                                        return;
                                                }
                                            });
                                            socket.send((0, _commonMjs.stringifyMessage)({
                                                id: id,
                                                type: (0, _commonMjs.MessageType).Subscribe,
                                                payload: payload
                                            }, replacer));
                                            releaser = function() {
                                                if (!done && socket.readyState === WebSocketImpl.OPEN) // if not completed already and socket is open, send complete message to server on release
                                                socket.send((0, _commonMjs.stringifyMessage)({
                                                    id: id,
                                                    type: (0, _commonMjs.MessageType).Complete
                                                }, replacer));
                                                locks--;
                                                done = true;
                                                release();
                                            };
                                            // either the releaser will be called, connection completed and
                                            // the promise resolved or the socket closed and the promise rejected.
                                            // whatever happens though, we want to stop listening for messages
                                            return [
                                                4,
                                                waitForReleaseOrThrowOnClose.finally(unlisten)
                                            ];
                                        case 2:
                                            _state.sent();
                                            return [
                                                2,
                                                {
                                                    v: void void 0
                                                } // completed, shouldnt try again
                                            ];
                                        case 3:
                                            errOrCloseEvent = _state.sent();
                                            if (!shouldRetryConnectOrThrow(errOrCloseEvent)) return [
                                                2,
                                                {
                                                    v: void void 0
                                                }
                                            ];
                                            return [
                                                3,
                                                4
                                            ];
                                        case 4:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            };
                            locks++;
                            _state.label = 1;
                        case 1:
                            return [
                                5,
                                (0, _tsValues._)(_loop())
                            ];
                        case 2:
                            _ret = _state.sent();
                            if ((0, _typeOf._)(_ret) === "object") return [
                                2,
                                _ret.v
                            ];
                            _state.label = 3;
                        case 3:
                            return [
                                3,
                                1
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            })();
        })().then(function() {
            // delivering either an error or a complete terminates the sequence
            if (!errored) sink.complete();
        }) // resolves on release or normal closure
        .catch(function(err) {
            sink.error(err);
        }); // rejects on close events and errors
        return function() {
            // dispose only of active subscriptions
            if (!done) releaser();
        };
    }
    return {
        on: emitter.on,
        subscribe: subscribe,
        iterate: function iterate(request) {
            var pending = [];
            var deferred = {
                done: false,
                error: null,
                resolve: function() {
                // noop
                }
            };
            var dispose = subscribe(request, {
                next: function next(val) {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- payload will fit type
                    pending.push(val);
                    deferred.resolve();
                },
                error: function error(err) {
                    deferred.done = true;
                    deferred.error = err;
                    deferred.resolve();
                },
                complete: function complete() {
                    deferred.done = true;
                    deferred.resolve();
                }
            });
            var iterator = function iterator() {
                return __asyncGenerator(this, arguments, function iterator_1() {
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!pending.length) return [
                                    3,
                                    2
                                ];
                                // only wait if there are no pending messages available
                                return [
                                    4,
                                    __await(new Promise(function(resolve) {
                                        return deferred.resolve = resolve;
                                    }))
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                if (!pending.length) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    __await(pending.shift())
                                ];
                            case 3:
                                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                return [
                                    4,
                                    _state.sent()
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    3,
                                    2
                                ];
                            case 5:
                                // then error
                                if (deferred.error) throw deferred.error;
                                if (!deferred.done) return [
                                    3,
                                    7
                                ];
                                return [
                                    4,
                                    __await(void 0)
                                ];
                            case 6:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 7:
                                return [
                                    3,
                                    0
                                ];
                            case 8:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }();
            iterator.throw = function(err) {
                return (0, _asyncToGenerator._)(function() {
                    return (0, _tsGenerator._)(this, function(_state) {
                        if (!deferred.done) {
                            deferred.done = true;
                            deferred.error = err;
                            deferred.resolve();
                        }
                        return [
                            2,
                            {
                                done: true,
                                value: undefined
                            }
                        ];
                    });
                })();
            };
            iterator.return = function() {
                return (0, _asyncToGenerator._)(function() {
                    return (0, _tsGenerator._)(this, function(_state) {
                        dispose();
                        return [
                            2,
                            {
                                done: true,
                                value: undefined
                            }
                        ];
                    });
                })();
            };
            return iterator;
        },
        dispose: function dispose() {
            return (0, _asyncToGenerator._)(function() {
                var _ref, socket;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            disposed = true;
                            if (!connecting) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                connecting
                            ];
                        case 1:
                            _ref = (0, _slicedToArray._).apply(void 0, [
                                _state.sent(),
                                1
                            ]), socket = _ref[0];
                            socket.close(1000, 'Normal Closure');
                            _state.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        terminate: function terminate() {
            if (connecting) // only if there is a connection
            emitter.emit('closed', new TerminatedCloseEvent());
        }
    };
}
var TerminatedCloseEvent = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, _inherits._)(TerminatedCloseEvent, Error1);
    function TerminatedCloseEvent() {
        (0, _classCallCheck._)(this, TerminatedCloseEvent);
        var _this;
        _this = (0, _callSuper._)(this, TerminatedCloseEvent, arguments);
        _this.name = 'TerminatedCloseEvent';
        _this.message = '4499: Terminated';
        _this.code = 4499;
        _this.reason = 'Terminated';
        _this.wasClean = false;
        return _this;
    }
    return TerminatedCloseEvent;
}((0, _wrapNativeSuper._)(Error));
function isLikeCloseEvent(val) {
    return (0, _utilsMjs.isObject)(val) && 'code' in val && 'reason' in val;
}
function isFatalInternalCloseCode(code) {
    if ([
        1000,
        1001,
        1006,
        1005,
        1012,
        1013,
        1014
    ].includes(code)) return false;
    // all other internal errors are fatal
    return code >= 1000 && code <= 1999;
}
function isWebSocket(val) {
    return typeof val === 'function' && 'constructor' in val && 'CLOSED' in val && 'CLOSING' in val && 'CONNECTING' in val && 'OPEN' in val;
}

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_inherits":"2sfqW","@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_to_consumable_array":"1eSZf","@swc/helpers/_/_type_of":"iFJdx","@swc/helpers/_/_wrap_native_super":"d0Iin","@swc/helpers/_/_ts_generator":"78Tqx","@swc/helpers/_/_ts_values":"kCgKO","./common.mjs":"hLPMI","./utils.mjs":"79Gt7","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kCgKO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return 0, _tslib.__values;
});
var _tslib = require("tslib");

},{"tslib":"6MhhU","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hLPMI":[function(require,module,exports,__globalThis) {
/**
 *
 * common
 *
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GRAPHQL_TRANSPORT_WS_PROTOCOL", function() {
    return GRAPHQL_TRANSPORT_WS_PROTOCOL;
});
parcelHelpers.export(exports, "DEPRECATED_GRAPHQL_WS_PROTOCOL", function() {
    return DEPRECATED_GRAPHQL_WS_PROTOCOL;
});
parcelHelpers.export(exports, "CloseCode", function() {
    return CloseCode;
});
parcelHelpers.export(exports, "MessageType", function() {
    return MessageType;
});
/**
 * Validates the message against the GraphQL over WebSocket Protocol.
 *
 * Invalid messages will throw descriptive errors.
 *
 * @category Common
 */ parcelHelpers.export(exports, "validateMessage", function() {
    return validateMessage;
});
/**
 * Checks if the provided value is a valid GraphQL over WebSocket message.
 *
 * @deprecated Use `validateMessage` instead.
 *
 * @category Common
 */ parcelHelpers.export(exports, "isMessage", function() {
    return isMessage;
});
/**
 * Parses the raw websocket message data to a valid message.
 *
 * @category Common
 */ parcelHelpers.export(exports, "parseMessage", function() {
    return parseMessage;
});
/**
 * Stringifies a valid message ready to be sent through the socket.
 *
 * @category Common
 */ parcelHelpers.export(exports, "stringifyMessage", function() {
    return stringifyMessage;
});
var _utilsMjs = require("./utils.mjs");
var GRAPHQL_TRANSPORT_WS_PROTOCOL = 'graphql-transport-ws';
var DEPRECATED_GRAPHQL_WS_PROTOCOL = 'graphql-ws';
var CloseCode;
(function(CloseCode) {
    CloseCode[CloseCode["InternalServerError"] = 4500] = "InternalServerError";
    CloseCode[CloseCode["InternalClientError"] = 4005] = "InternalClientError";
    CloseCode[CloseCode["BadRequest"] = 4400] = "BadRequest";
    CloseCode[CloseCode["BadResponse"] = 4004] = "BadResponse";
    /** Tried subscribing before connect ack */ CloseCode[CloseCode["Unauthorized"] = 4401] = "Unauthorized";
    CloseCode[CloseCode["Forbidden"] = 4403] = "Forbidden";
    CloseCode[CloseCode["SubprotocolNotAcceptable"] = 4406] = "SubprotocolNotAcceptable";
    CloseCode[CloseCode["ConnectionInitialisationTimeout"] = 4408] = "ConnectionInitialisationTimeout";
    CloseCode[CloseCode["ConnectionAcknowledgementTimeout"] = 4504] = "ConnectionAcknowledgementTimeout";
    /** Subscriber distinction is very important */ CloseCode[CloseCode["SubscriberAlreadyExists"] = 4409] = "SubscriberAlreadyExists";
    CloseCode[CloseCode["TooManyInitialisationRequests"] = 4429] = "TooManyInitialisationRequests";
})(CloseCode || (CloseCode = {}));
var MessageType;
(function(MessageType) {
    MessageType["ConnectionInit"] = "connection_init";
    MessageType["ConnectionAck"] = "connection_ack";
    MessageType["Ping"] = "ping";
    MessageType["Pong"] = "pong";
    MessageType["Subscribe"] = "subscribe";
    MessageType["Next"] = "next";
    MessageType["Error"] = "error";
    MessageType["Complete"] = "complete";
})(MessageType || (MessageType = {}));
function validateMessage(val) {
    if (!(0, _utilsMjs.isObject)(val)) throw new Error("Message is expected to be an object, but got ".concat((0, _utilsMjs.extendedTypeof)(val)));
    if (!val.type) throw new Error("Message is missing the 'type' property");
    if (typeof val.type !== 'string') throw new Error("Message is expects the 'type' property to be a string, but got ".concat((0, _utilsMjs.extendedTypeof)(val.type)));
    switch(val.type){
        case MessageType.ConnectionInit:
        case MessageType.ConnectionAck:
        case MessageType.Ping:
        case MessageType.Pong:
            if (val.payload != null && !(0, _utilsMjs.isObject)(val.payload)) throw new Error('"'.concat(val.type, "\" message expects the 'payload' property to be an object or nullish or missing, but got \"").concat(val.payload, '"'));
            break;
        case MessageType.Subscribe:
            if (typeof val.id !== 'string') throw new Error('"'.concat(val.type, "\" message expects the 'id' property to be a string, but got ").concat((0, _utilsMjs.extendedTypeof)(val.id)));
            if (!val.id) throw new Error('"'.concat(val.type, "\" message requires a non-empty 'id' property"));
            if (!(0, _utilsMjs.isObject)(val.payload)) throw new Error('"'.concat(val.type, "\" message expects the 'payload' property to be an object, but got ").concat((0, _utilsMjs.extendedTypeof)(val.payload)));
            if (typeof val.payload.query !== 'string') throw new Error('"'.concat(val.type, "\" message payload expects the 'query' property to be a string, but got ").concat((0, _utilsMjs.extendedTypeof)(val.payload.query)));
            if (val.payload.variables != null && !(0, _utilsMjs.isObject)(val.payload.variables)) throw new Error('"'.concat(val.type, "\" message payload expects the 'variables' property to be a an object or nullish or missing, but got ").concat((0, _utilsMjs.extendedTypeof)(val.payload.variables)));
            if (val.payload.operationName != null && (0, _utilsMjs.extendedTypeof)(val.payload.operationName) !== 'string') throw new Error('"'.concat(val.type, "\" message payload expects the 'operationName' property to be a string or nullish or missing, but got ").concat((0, _utilsMjs.extendedTypeof)(val.payload.operationName)));
            if (val.payload.extensions != null && !(0, _utilsMjs.isObject)(val.payload.extensions)) throw new Error('"'.concat(val.type, "\" message payload expects the 'extensions' property to be a an object or nullish or missing, but got ").concat((0, _utilsMjs.extendedTypeof)(val.payload.extensions)));
            break;
        case MessageType.Next:
            if (typeof val.id !== 'string') throw new Error('"'.concat(val.type, "\" message expects the 'id' property to be a string, but got ").concat((0, _utilsMjs.extendedTypeof)(val.id)));
            if (!val.id) throw new Error('"'.concat(val.type, "\" message requires a non-empty 'id' property"));
            if (!(0, _utilsMjs.isObject)(val.payload)) throw new Error('"'.concat(val.type, "\" message expects the 'payload' property to be an object, but got ").concat((0, _utilsMjs.extendedTypeof)(val.payload)));
            break;
        case MessageType.Error:
            if (typeof val.id !== 'string') throw new Error('"'.concat(val.type, "\" message expects the 'id' property to be a string, but got ").concat((0, _utilsMjs.extendedTypeof)(val.id)));
            if (!val.id) throw new Error('"'.concat(val.type, "\" message requires a non-empty 'id' property"));
            if (!(0, _utilsMjs.areGraphQLErrors)(val.payload)) throw new Error('"'.concat(val.type, "\" message expects the 'payload' property to be an array of GraphQL errors, but got ").concat(JSON.stringify(val.payload)));
            break;
        case MessageType.Complete:
            if (typeof val.id !== 'string') throw new Error('"'.concat(val.type, "\" message expects the 'id' property to be a string, but got ").concat((0, _utilsMjs.extendedTypeof)(val.id)));
            if (!val.id) throw new Error('"'.concat(val.type, "\" message requires a non-empty 'id' property"));
            break;
        default:
            throw new Error("Invalid message 'type' property \"".concat(val.type, '"'));
    }
    return val;
}
function isMessage(val) {
    try {
        validateMessage(val);
        return true;
    } catch (_a) {
        return false;
    }
}
function parseMessage(data, reviver) {
    return validateMessage(typeof data === 'string' ? JSON.parse(data, reviver) : data);
}
function stringifyMessage(msg, replacer) {
    validateMessage(msg);
    return JSON.stringify(msg, replacer);
}

},{"./utils.mjs":"79Gt7","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"79Gt7":[function(require,module,exports,__globalThis) {
/** @private */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extendedTypeof", function() {
    return extendedTypeof;
});
/** @private */ parcelHelpers.export(exports, "isObject", function() {
    return isObject;
});
/** @private */ parcelHelpers.export(exports, "isAsyncIterable", function() {
    return isAsyncIterable;
});
/** @private */ parcelHelpers.export(exports, "isAsyncGenerator", function() {
    return isAsyncGenerator;
});
/** @private */ parcelHelpers.export(exports, "areGraphQLErrors", function() {
    return areGraphQLErrors;
});
/**
 * Limits the WebSocket close event reason to not exceed a length of one frame.
 * Reference: https://datatracker.ietf.org/doc/html/rfc6455#section-5.2.
 *
 * @private
 */ parcelHelpers.export(exports, "limitCloseReason", function() {
    return limitCloseReason;
});
var _typeOf = require("@swc/helpers/_/_type_of");
function extendedTypeof(val) {
    if (val === null) return 'null';
    if (Array.isArray(val)) return 'array';
    return typeof val === "undefined" ? "undefined" : (0, _typeOf._)(val);
}
function isObject(val) {
    return extendedTypeof(val) === 'object';
}
function isAsyncIterable(val) {
    return typeof Object(val)[Symbol.asyncIterator] === 'function';
}
function isAsyncGenerator(val) {
    return isObject(val) && typeof Object(val)[Symbol.asyncIterator] === 'function' && typeof val.return === 'function';
}
function areGraphQLErrors(obj) {
    return Array.isArray(obj) && // must be at least one error
    obj.length > 0 && // error has at least a message
    obj.every(function(ob) {
        return 'message' in ob;
    });
}
function limitCloseReason(reason, whenTooLong) {
    return reason.length < 124 ? reason : whenTooLong;
}

},{"@swc/helpers/_/_type_of":"iFJdx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8AQSH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WS_CLIENT_KEEP_ALIVE", function() {
    return WS_CLIENT_KEEP_ALIVE;
});
parcelHelpers.export(exports, "WS_CLIENT_RETRIES", function() {
    return WS_CLIENT_RETRIES;
});
parcelHelpers.export(exports, "WS_CLOSE_ON_IDLE", function() {
    return WS_CLOSE_ON_IDLE;
});
var WS_CLIENT_KEEP_ALIVE = 580000; // 9m 40 - timeframe needed for UCT token refresh: https://developer.atlassian.com/platform/graphql-gateway/subscriptions/security/#long-lived-user-context-token
var WS_CLIENT_RETRIES = 100;
var WS_CLOSE_ON_IDLE = 300000; // 5m

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lbiag":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isSSR", function() {
    return isSSR;
});
parcelHelpers.export(exports, "getAggSubscriptionEndpoint", function() {
    return getAggSubscriptionEndpoint;
});
var isSSR = function() {
    var _globalThis___SERVER__;
    return (_globalThis___SERVER__ = globalThis.__SERVER__) !== null && _globalThis___SERVER__ !== void 0 ? _globalThis___SERVER__ : false;
};
var getAggSubscriptionEndpoint = function() {
    return "".concat(window.location.origin.replace('http', 'ws'), "/gateway/api/graphql/subscriptions");
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"62IKu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSinkError", function() {
    return getSinkError;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var getSinkError = function(error) {
    var errorInfo;
    var ref;
    if (Array.isArray(error)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    ref = (0, _slicedToArray._)(error, 1), errorInfo = ref[0], ref;
    else if ((0, _instanceof._)(error, Error)) errorInfo = error;
    else if ((typeof error === "undefined" ? "undefined" : (0, _typeOf._)(error)) === 'object' && 'type' in error && error.type === 'close') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    errorInfo = new Error("CloseEvent: ".concat(error.reason));
    else if ((typeof error === "undefined" ? "undefined" : (0, _typeOf._)(error)) === 'object' && 'type' in error && error.type === 'error') {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        var errorEvent = error;
        errorInfo = new Error('ErrorEvent: "'.concat(errorEvent.error, '"'));
    } else if ((0, _instanceof._)(error, Event)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    errorInfo = new Error("Event: ".concat(error.type));
    else errorInfo = new Error("Unknown sink error: ".concat(error));
    if ((0, _instanceof._)(error, Error) && error.stack) errorInfo.stack = error.stack;
    return errorInfo;
};

},{"@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_type_of":"iFJdx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"i8pdE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CLEAN_UP_TIMEOUT", function() {
    return CLEAN_UP_TIMEOUT;
});
parcelHelpers.export(exports, "startCaptureGraphQlErrors", function() {
    return startCaptureGraphQlErrors;
});
parcelHelpers.export(exports, "stopCaptureGraphQlErrors", function() {
    return stopCaptureGraphQlErrors;
});
parcelHelpers.export(exports, "captureErrors", function() {
    return captureErrors;
});
parcelHelpers.export(exports, "isUnauthenticated", function() {
    return isUnauthenticated;
});
parcelHelpers.export(exports, "isStepUpAuthError", function() {
    return isStepUpAuthError;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
var _uuid = require("uuid");
var errorCollector = new Map();
var CLEAN_UP_TIMEOUT = 120000; // 2min
var scheduleCleanup = function(key) {
    setTimeout(function() {
        errorCollector.delete(key);
    }, CLEAN_UP_TIMEOUT);
};
var startCaptureGraphQlErrors = function() {
    var key = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, _uuid.v4)();
    errorCollector.set(key, []);
    scheduleCleanup(key);
    return key;
};
var stopCaptureGraphQlErrors = function(key) {
    var errors = errorCollector.get(key);
    errorCollector.delete(key);
    return errors || [];
};
var captureErrors = function(errors, meta) {
    if (errors) errorCollector.forEach(function(value, key) {
        errorCollector.set(key, (0, _toConsumableArray._)(value).concat([
            {
                errors: errors,
                meta: meta
            }
        ]));
    });
};
var isUnauthenticated = function(errors) {
    if (errors.length > 0) return errors.some(function(error) {
        return error.message.startsWith('Auth category: UNAUTHENTICATED');
    });
    return false;
};
var isStepUpAuthError = function(errors) {
    var _stepUpError_extensions;
    var stepUpError = errors.find(function(error) {
        var _error_extensions, _error_extensions1;
        return error.message.startsWith('Step-up authentication is required.') && ((_error_extensions = error.extensions) === null || _error_extensions === void 0 ? void 0 : _error_extensions.statusCode) === 303 && ((_error_extensions1 = error.extensions) === null || _error_extensions1 === void 0 ? void 0 : _error_extensions1.stepUpUrl);
    });
    var _stepUpError_extensions_stepUpUrl;
    return {
        hasStepUpAuthError: !!stepUpError,
        stepUpUrl: (_stepUpError_extensions_stepUpUrl = stepUpError === null || stepUpError === void 0 ? void 0 : (_stepUpError_extensions = stepUpError.extensions) === null || _stepUpError_extensions === void 0 ? void 0 : _stepUpError_extensions.stepUpUrl) !== null && _stepUpError_extensions_stepUpUrl !== void 0 ? _stepUpError_extensions_stepUpUrl : undefined
    };
};

},{"@swc/helpers/_/_to_consumable_array":"1eSZf","uuid":"5elg8","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5elg8":[function(require,module,exports,__globalThis) {
var v1 = require("d2d48e4dfb01c5c3");
var v4 = require("f9cde9eaad80431a");
var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;
module.exports = uuid;

},{"d2d48e4dfb01c5c3":"5HupF","f9cde9eaad80431a":"gUwCJ"}],"5HupF":[function(require,module,exports,__globalThis) {
var rng = require("a3551f36bebcd2d0");
var bytesToUuid = require("3fcd61e388bbc0a3");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var _nodeId;
var _clockseq;
// Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || _nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = rng();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = _nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    _lastMSecs = msecs;
    _lastNSecs = nsecs;
    _clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : bytesToUuid(b);
}
module.exports = v1;

},{"a3551f36bebcd2d0":"aM37N","3fcd61e388bbc0a3":"2dNNI"}],"aM37N":[function(require,module,exports,__globalThis) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
if (getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        getRandomValues(rnds8);
        return rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return rnds;
    };
}

},{}],"2dNNI":[function(require,module,exports,__globalThis) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var byteToHex = [];
for(var i = 0; i < 256; ++i)byteToHex[i] = (i + 0x100).toString(16).substr(1);
function bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join('');
}
module.exports = bytesToUuid;

},{}],"gUwCJ":[function(require,module,exports,__globalThis) {
var rng = require("f08f39ba8b6d6261");
var bytesToUuid = require("9d6ef2cb3a85b612");
function v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
        buf = options === 'binary' ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || rng)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || bytesToUuid(rnds);
}
module.exports = v4;

},{"f08f39ba8b6d6261":"aM37N","9d6ef2cb3a85b612":"2dNNI"}],"8d2kf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCacheKey", function() {
    return getCacheKey;
});
parcelHelpers.export(exports, "getQueryIDFromCacheKey", function() {
    return getQueryIDFromCacheKey;
});
parcelHelpers.export(exports, "SSRQueryResponseCache", function() {
    return SSRQueryResponseCache;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _relayRuntime = require("relay-runtime");
function getCacheKey(queryID, variables) {
    return JSON.stringify((0, _relayRuntime.stableCopy)({
        queryID: queryID,
        variables: variables
    }));
}
function getQueryIDFromCacheKey(cacheKey) {
    return JSON.parse(cacheKey).queryID;
}
var SSRQueryResponseCache = /*#__PURE__*/ function(RelayQueryResponseCache) {
    "use strict";
    (0, _inherits._)(SSRQueryResponseCache, RelayQueryResponseCache);
    function SSRQueryResponseCache(param) {
        var cacheName = param.cacheName, size = param.size, ttl = param.ttl, timeoutCallback = param.timeoutCallback;
        (0, _classCallCheck._)(this, SSRQueryResponseCache);
        var _this;
        var _window_SPA_STATE, _window, _window_SKELETON_NAVIGATION, _window1, _window___PLATFORM_SSR_AGG_CACHE__, _window2;
        _this = (0, _callSuper._)(this, SSRQueryResponseCache, [
            {
                size: size,
                ttl: ttl
            }
        ]);
        var isServer = typeof window === 'undefined';
        var cachedData = isServer ? {} : ((_window = window) === null || _window === void 0 ? void 0 : (_window_SPA_STATE = _window.SPA_STATE) === null || _window_SPA_STATE === void 0 ? void 0 : _window_SPA_STATE[cacheName]) || ((_window1 = window) === null || _window1 === void 0 ? void 0 : (_window_SKELETON_NAVIGATION = _window1.SKELETON_NAVIGATION) === null || _window_SKELETON_NAVIGATION === void 0 ? void 0 : _window_SKELETON_NAVIGATION[cacheName]) || ((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window___PLATFORM_SSR_AGG_CACHE__ = _window2.__PLATFORM_SSR_AGG_CACHE__) === null || _window___PLATFORM_SSR_AGG_CACHE__ === void 0 ? void 0 : _window___PLATFORM_SSR_AGG_CACHE__[cacheName]) || {};
        _this.cacheName = cacheName;
        _this.requestMetadata = new Map(cachedData.requestMetadata);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        _this._responses = new Map(cachedData.responses);
        if (!isServer) setTimeout(function() {
            // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
            timeoutCallback === null || timeoutCallback === void 0 ? void 0 : timeoutCallback(_this._responses, _this.requestMetadata);
            // cleanup leftover data to reduce unnecessary memory usage
            _this.requestMetadata.clear();
            // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
            _this._responses.clear();
        }, 60000 /* 1 minute */ );
        return _this;
    }
    (0, _createClass._)(SSRQueryResponseCache, [
        {
            /**
	 * @deprecated only sets a single response; does not work well if requests use defer or stream.
	 *             use {@link appendWithMetadata} or, better still, use {@link "@atlassian/server-to-client-comms/server-dispatcher"}.
	 */ key: "setWithMetadata",
            value: function setWithMetadata(queryID, variables, payload, metadata) {
                this.requestMetadata.set(queryID, metadata);
                this.set(queryID, variables, payload);
            }
        },
        {
            /**
	 * Stores a GraphQLRepsonse along with metadata about the call.
	 * If called multiple times (such as when incremental payloads are received),
	 * will update the stored response to be an array of GraphQLSingularResponse objects,
	 * which Relay is happy to handle.
	 * @deprecated works, but does not work well if requests use defer or stream.
	 *             use {@link appendWithMetadata} or, better still, use {@link "@atlassian/server-to-client-comms/server-dispatcher"}.
	 */ key: "appendWithMetadata",
            value: function appendWithMetadata(queryID, variables, payload, metadata) {
                this.requestMetadata.set(queryID, metadata);
                var currentResponse = this.get(queryID, variables);
                if (!currentResponse) this.set(queryID, variables, payload);
                else if ((0, _instanceof._)(currentResponse, Array)) {
                    var newResponse = (0, _toConsumableArray._)(currentResponse).concat(payload);
                    this.set(queryID, variables, newResponse);
                } else {
                    var newResponse1 = [
                        currentResponse
                    ].concat(payload);
                    this.set(queryID, variables, newResponse1);
                }
            }
        },
        {
            /**
	 * Deletes a request from the store, if found.
	 *
	 * IMPORTANT: Make sure DELETE method always has tests that include get/set
	 * to ensure our `getCacheKey` matches Relay's.
	 *
	 * @returns {boolean} indicating if an entry in the cache was deleted
	 */ key: "delete",
            value: function _delete(queryID, variables) {
                var cacheKey = getCacheKey(queryID, variables);
                // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
                return this._responses.delete(cacheKey);
            }
        },
        {
            key: "serialize",
            value: function serialize() {
                return (0, _defineProperty._)({}, this.cacheName, {
                    // @ts-expect-error - TS2322 - Type '{ [x: string]: { requestMetadata: [string, RequestMetadata][]; responses: unknown[]; }; }' is not assignable to type 'Partial<Record<string, [string, GraphQLResponse][]>>'.
                    requestMetadata: Array.from(this.requestMetadata.entries()),
                    // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
                    responses: Array.from(this._responses.entries())
                });
            }
        }
    ]);
    return SSRQueryResponseCache;
}((0, _relayRuntime.QueryResponseCache));

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_inherits":"2sfqW","@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_to_consumable_array":"1eSZf","relay-runtime":"2IxFR","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fE1Q3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IsFhsEnabledContext", function() {
    return 0, _isFhsEnabledContext.IsFhsEnabledContext;
});
parcelHelpers.export(exports, "IsFhsEnabledProvider", function() {
    return 0, _isFhsEnabledProvider.IsFhsEnabledProvider;
});
parcelHelpers.export(exports, "useIsFhsEnabled", function() {
    return 0, _useIsFhsEnabled.useIsFhsEnabled;
});
parcelHelpers.export(exports, "Aside", function() {
    return 0, _aside.Aside;
});
parcelHelpers.export(exports, "Banner", function() {
    return 0, _banner.Banner;
});
parcelHelpers.export(exports, "Main", function() {
    return 0, _main.Main;
});
parcelHelpers.export(exports, "Panel", function() {
    return 0, _panel.Panel;
});
parcelHelpers.export(exports, "Root", function() {
    return 0, _root.Root;
});
parcelHelpers.export(exports, "SideNav", function() {
    return 0, _sideNav.SideNav;
});
parcelHelpers.export(exports, "TopNav", function() {
    return 0, _topNav.TopNav;
});
parcelHelpers.export(exports, "MainStickyHeader", function() {
    return 0, _mainStickyHeader.MainStickyHeader;
});
parcelHelpers.export(exports, "SideNavToggleButton", function() {
    return 0, _toggleButton.SideNavToggleButton;
});
parcelHelpers.export(exports, "useToggleSideNav", function() {
    return 0, _useToggleSideNav.useToggleSideNav;
});
parcelHelpers.export(exports, "SideNavHeader", function() {
    return 0, _sideNavHeader.SideNavHeader;
});
parcelHelpers.export(exports, "SideNavBody", function() {
    return 0, _sideNavContent.SideNavBody;
});
parcelHelpers.export(exports, "SideNavFooter", function() {
    return 0, _sideNavFooter.SideNavFooter;
});
parcelHelpers.export(exports, "PanelSplitter", function() {
    return 0, _panelSplitter.PanelSplitter;
});
parcelHelpers.export(exports, "PanelSplitterProvider", function() {
    return 0, _provider.PanelSplitterProvider;
});
parcelHelpers.export(exports, "TopNavStart", function() {
    return 0, _topNavStart.TopNavStart;
});
parcelHelpers.export(exports, "AppSwitcher", function() {
    return 0, _appSwitcher.AppSwitcher;
});
parcelHelpers.export(exports, "CustomLogo", function() {
    return 0, _customLogo.CustomLogo;
});
parcelHelpers.export(exports, "AppLogo", function() {
    return 0, _appLogo.AppLogo;
});
parcelHelpers.export(exports, "TopNavMiddle", function() {
    return 0, _topNavMiddle.TopNavMiddle;
});
parcelHelpers.export(exports, "Search", function() {
    return 0, _search.Search;
});
parcelHelpers.export(exports, "ChatButton", function() {
    return 0, _chatButton.ChatButton;
});
parcelHelpers.export(exports, "TopNavEnd", function() {
    return 0, _topNavEnd.TopNavEnd;
});
parcelHelpers.export(exports, "EndItem", function() {
    return 0, _endItem.EndItem;
});
parcelHelpers.export(exports, "CreateButton", function() {
    return 0, _createButton.CreateButton;
});
parcelHelpers.export(exports, "Help", function() {
    return 0, _help.Help;
});
parcelHelpers.export(exports, "Notifications", function() {
    return 0, _notifications.Notifications;
});
parcelHelpers.export(exports, "Profile", function() {
    return 0, _profile.Profile;
});
parcelHelpers.export(exports, "Settings", function() {
    return 0, _settings.Settings;
});
parcelHelpers.export(exports, "LogIn", function() {
    return 0, _logIn.LogIn;
});
var _isFhsEnabledContext = require("./ui/fhs-rollout/is-fhs-enabled-context");
var _isFhsEnabledProvider = require("./ui/fhs-rollout/is-fhs-enabled-provider");
var _useIsFhsEnabled = require("./ui/fhs-rollout/use-is-fhs-enabled");
var _aside = require("./ui/page-layout/aside");
var _banner = require("./ui/page-layout/banner");
var _main = require("./ui/page-layout/main/main");
var _panel = require("./ui/page-layout/panel");
var _root = require("./ui/page-layout/root");
var _sideNav = require("./ui/page-layout/side-nav/side-nav");
var _topNav = require("./ui/page-layout/top-nav/top-nav");
var _mainStickyHeader = require("./ui/page-layout/main/main-sticky-header");
var _toggleButton = require("./ui/page-layout/side-nav/toggle-button");
var _useToggleSideNav = require("./ui/page-layout/side-nav/use-toggle-side-nav");
var _sideNavHeader = require("./ui/page-layout/side-nav/side-nav-header");
var _sideNavContent = require("./ui/page-layout/side-nav/side-nav-content");
var _sideNavFooter = require("./ui/page-layout/side-nav/side-nav-footer");
var _panelSplitter = require("./ui/page-layout/panel-splitter/panel-splitter");
var _provider = require("./ui/page-layout/panel-splitter/provider");
var _topNavStart = require("./ui/page-layout/top-nav/top-nav-start");
var _appSwitcher = require("./ui/top-nav-items/app-switcher");
var _customLogo = require("./ui/top-nav-items/nav-logo/custom-logo");
var _appLogo = require("./ui/top-nav-items/nav-logo/app-logo");
var _topNavMiddle = require("./ui/page-layout/top-nav/top-nav-middle");
var _search = require("./ui/top-nav-items/search");
var _chatButton = require("./ui/top-nav-items/chat-button");
var _topNavEnd = require("./ui/page-layout/top-nav/top-nav-end");
var _endItem = require("./ui/top-nav-items/end-item");
var _createButton = require("./ui/top-nav-items/create-button");
var _help = require("./ui/top-nav-items/help");
var _notifications = require("./ui/top-nav-items/notifications");
var _profile = require("./ui/top-nav-items/profile");
var _settings = require("./ui/top-nav-items/settings");
var _logIn = require("./ui/top-nav-items/log-in");

},{"./ui/fhs-rollout/is-fhs-enabled-context":false,"./ui/fhs-rollout/is-fhs-enabled-provider":false,"./ui/fhs-rollout/use-is-fhs-enabled":false,"./ui/page-layout/aside":false,"./ui/page-layout/banner":false,"./ui/page-layout/main/main":"bnADM","./ui/page-layout/panel":"aqc7R","./ui/page-layout/root":"j49hL","./ui/page-layout/side-nav/side-nav":false,"./ui/page-layout/top-nav/top-nav":false,"./ui/page-layout/main/main-sticky-header":false,"./ui/page-layout/side-nav/toggle-button":false,"./ui/page-layout/side-nav/use-toggle-side-nav":false,"./ui/page-layout/side-nav/side-nav-header":false,"./ui/page-layout/side-nav/side-nav-content":false,"./ui/page-layout/side-nav/side-nav-footer":false,"./ui/page-layout/panel-splitter/panel-splitter":false,"./ui/page-layout/panel-splitter/provider":false,"./ui/page-layout/top-nav/top-nav-start":false,"./ui/top-nav-items/app-switcher":false,"./ui/top-nav-items/nav-logo/custom-logo":false,"./ui/top-nav-items/nav-logo/app-logo":false,"./ui/page-layout/top-nav/top-nav-middle":false,"./ui/top-nav-items/search":false,"./ui/top-nav-items/chat-button":false,"./ui/page-layout/top-nav/top-nav-end":false,"./ui/top-nav-items/end-item":false,"./ui/top-nav-items/create-button":false,"./ui/top-nav-items/help":false,"./ui/top-nav-items/notifications":false,"./ui/top-nav-items/profile":false,"./ui/top-nav-items/settings":false,"./ui/top-nav-items/log-in":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bnADM":[function(require,module,exports,__globalThis) {
/* main.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Use the Main area for the main page content. It has a fluid width and will expand to fill available space.
 */ parcelHelpers.export(exports, "Main", function() {
    return Main;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _useSkipLink = require("../../../context/skip-links/use-skip-link");
var _useLayoutId = require("../use-layout-id");
var mainElementStyles = {
    root: "_nd5l1gzg _1reo1wug _18m91wug _19121cl4 _152timx3 _qwfh1wug _165teqxy _13wn1if8"
};
function Main(param) {
    var children = param.children, xcss = param.xcss, _param_skipLinkLabel = param.skipLinkLabel, skipLinkLabel = _param_skipLinkLabel === void 0 ? (0, _platformFeatureFlags.fg)('platform_dst_nav4_skip_link_a11y_1') ? 'Main content' : 'Main Content' : _param_skipLinkLabel, testId = param.testId, providedId = param.id;
    var id = (0, _useLayoutId.useLayoutId)({
        providedId: providedId
    });
    (0, _useSkipLink.useSkipLink)(id, skipLinkLabel);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            id: id,
            "data-layout-slot": true,
            className: (0, _runtime.ax)([
                mainElementStyles.root,
                xcss
            ]),
            role: "main",
            "data-testid": testId,
            children: children
        })
    });
}

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/platform-feature-flags":"kO5t9","../../../context/skip-links/use-skip-link":"2dLaH","../use-layout-id":"lIPxI","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2dLaH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSkipLink", function() {
    return useSkipLink;
});
var _useSkipLinkInternal = require("./use-skip-link-internal");
var useSkipLink = function(/**
	 * The unique ID for the skip link.
	 * You can use the `useSkipLinkId` hook to generate a unique ID.
	 */ id, /**
	 * The label for the skip link.
	 */ label, /**
	 * You can optionally set the position of the skip link in the list of skip links.
	 * Positions are zero-indexed.
	 */ listIndex) {
    (0, _useSkipLinkInternal.useSkipLinkInternal)({
        id: id,
        label: label,
        listIndex: listIndex
    });
};

},{"./use-skip-link-internal":"kDmSF","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kDmSF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSkipLinkInternal", function() {
    return useSkipLinkInternal;
});
var _react = require("react");
var _skipLinksContext = require("./skip-links-context");
var useSkipLinkInternal = function(param) {
    var id = param.id, label = param.label, listIndex = param.listIndex, onBeforeNavigate = param.onBeforeNavigate, isHidden = param.isHidden;
    var _useContext = (0, _react.useContext)((0, _skipLinksContext.SkipLinksContext)), registerSkipLink = _useContext.registerSkipLink, unregisterSkipLink = _useContext.unregisterSkipLink;
    (0, _react.useEffect)(function() {
        if (isHidden) /**
			 * Skip links are hidden for slots with 0 height or width.
			 * They should not be registered.
			 */ return;
        registerSkipLink({
            id: id,
            label: label,
            listIndex: listIndex,
            onBeforeNavigate: onBeforeNavigate,
            isHidden: isHidden
        });
        return function() {
            unregisterSkipLink(id);
        };
    }, [
        id,
        isHidden,
        label,
        listIndex,
        onBeforeNavigate,
        registerSkipLink,
        unregisterSkipLink
    ]);
};

},{"react":"ltHCL","./skip-links-context":"f9dli","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"f9dli":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SkipLinksContext", function() {
    return SkipLinksContext;
});
var _react = require("react");
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var SkipLinksContext = /*#__PURE__*/ (0, _react.createContext)({
    registerSkipLink: (0, _noopDefault.default),
    unregisterSkipLink: (0, _noopDefault.default)
});

},{"react":"ltHCL","@atlaskit/ds-lib/noop":"2f3bg","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2f3bg":[function(require,module,exports,__globalThis) {
/**
 * An empty function which does nothing.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return noop;
});
function noop() {}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lIPxI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns an ID for use by the layout element and skip links.
 *
 * If the consumer has already provided an ID, it will be used instead.
 * Otherwise, a unique ID will be returned.
 */ parcelHelpers.export(exports, "useLayoutId", function() {
    return useLayoutId;
});
var _useSkipLinkId = require("./use-skip-link-id");
function useLayoutId() {
    var providedId = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).providedId;
    var uniqueId = (0, _useSkipLinkId.useSkipLinkId)();
    var id = providedId ? providedId : uniqueId;
    return id;
}

},{"./use-skip-link-id":"evXI1","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"evXI1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Exposing a hook as a convenience for consumers, so they don't need to import
// from ds-lib themselves.
/**
 * Returns a unique ID for use by layout elements and skip links.
 * You can use this for custom skip links.
 */ parcelHelpers.export(exports, "useSkipLinkId", function() {
    return useSkipLinkId;
});
var _useId = require("@atlaskit/ds-lib/use-id");
function useSkipLinkId() {
    var uniqueId = (0, _useId.useId)();
    return uniqueId;
}

},{"@atlaskit/ds-lib/use-id":"axFod","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"axFod":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useId", function() {
    return useId;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function useId() {
    // React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`.
    // Replace with `_` to match future React 19 functionality.
    return (0, _reactDefault.default).useId().replace(/[:«»]/g, '_');
}

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aqc7R":[function(require,module,exports,__globalThis) {
/* panel.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The Panel layout area is rendered to the right (inline end) of the Main area, or the Aside area if it is present.
 *
 * On small viewports (below 64rem, or 1024px), the Panel slot will become an overlay.
 *
 * You can optionally render a `PanelSplitter` as a child to make the panel area resizable.
 */ parcelHelpers.export(exports, "Panel", function() {
    return Panel;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _responsive = require("@atlaskit/primitives/responsive");
var _useSkipLinkInternal = require("../../context/skip-links/use-skip-link-internal");
var _constants = require("./constants");
var _dangerouslyHoistCssVarToDocumentRoot = require("./dangerously-hoist-css-var-to-document-root");
var _hoistSlotSizesContext = require("./hoist-slot-sizes-context");
var _provider = require("./panel-splitter/provider");
var _useSideNavRef = require("./side-nav/use-side-nav-ref");
var _useLayoutId = require("./use-layout-id");
var _useResizingWidthCssVarOnRootElement = require("./use-resizing-width-css-var-on-root-element");
var _useSafeDefaultWidth = require("./use-safe-default-width");
var panelSplitterResizingVar = '--n_pnlRsz';
var fallbackDefaultWidth = 365;
/**
 * We typically use the `defaultWidth` as the minimum resizing width,
 * but for large default widths we fallback to a standard value.
 *
 * This standard value of `400px` is to align with the Global Preview Panels.
 */ var fallbackResizeMinWidth = 400;
var styles = {
    root: "_nd5l1b6c _10fph9n0 _vchhusvi _1pbykb7n _4t3ieqxy _kqsw1if8 _152timx3 _bfhk1bhr _1bsb1dxx _14b54rrg _4ap3vuon _1dhy1c6w _9sns1wug",
    border: "_191wglyw _16qs130s _1w6eia51 _scbpglyw",
    scrollContainer: "_1reo1wug _18m91wug _4t3i1osq",
    hidden: "_1e0cglyw"
};
function Panel(param) {
    var children = param.children, tmp = param.defaultWidth, defaultWidthProp = tmp === void 0 ? fallbackDefaultWidth : tmp, _param_label = param.label, label = _param_label === void 0 ? 'Panel' : _param_label, _param_skipLinkLabel = param.skipLinkLabel, skipLinkLabel = _param_skipLinkLabel === void 0 ? label : _param_skipLinkLabel, testId = param.testId, providedId = param.id, xcss = param.xcss, _param_hasBorder = param.hasBorder, hasBorder = _param_hasBorder === void 0 ? true : _param_hasBorder;
    var dangerouslyHoistSlotSizes = (0, _react.useContext)((0, _hoistSlotSizesContext.DangerouslyHoistSlotSizes));
    var id = (0, _useLayoutId.useLayoutId)({
        providedId: providedId
    });
    var defaultWidth = (0, _useSafeDefaultWidth.useSafeDefaultWidth)({
        defaultWidthProp: defaultWidthProp,
        fallbackDefaultWidth: fallbackDefaultWidth,
        slotName: 'Panel'
    });
    /**
   * Don't show the skip link if the slot has 0 width.
   *
   * Remove `isHidden` usage after https://jplat.atlassian.net/browse/BLU-3951
   *
   * TODO: when cleaning up 'platform_dst_nav4_skip_link_a11y_1' remove this call entirely
   */ (0, _useSkipLinkInternal.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        isHidden: defaultWidth === 0 || (0, _platformFeatureFlags.fg)('platform_dst_nav4_skip_link_a11y_1')
    });
    var ref = (0, _react.useRef)(null);
    var _useState = (0, _slicedToArray._)((0, _react.useState)(defaultWidth), 2), width = _useState[0], setWidth = _useState[1];
    // Used to track the previous value of the `defaultWidth` prop, for logging dev warnings when it changes.
    var defaultWidthRef = (0, _react.useRef)(defaultWidth);
    /**
   * TODO: Remove this useEffect once the `width: 0` usage is removed from Jira.
   * It updates the width state based on changes to `defaultWidth`, as a temporary stopgap to support Jira's current usage.
   * https://jplat.atlassian.net/browse/BLU-3951
   */ (0, _react.useEffect)(function() {
        if (defaultWidthRef.current === defaultWidth) return;
        defaultWidthRef.current = defaultWidth;
        setWidth(defaultWidth);
    }, [
        defaultWidth
    ]);
    var sideNavRef = (0, _useSideNavRef.useSideNavRef)();
    /**
   * The minimum width that the panel can be resized to by the user.
   *
   * We only use the `defaultWidth` up to a point to avoid huge panels.
   */ var minWidth = Math.min(defaultWidth, fallbackResizeMinWidth);
    /**
   * Returns the bounds for resizing, evaluated lazily when needed.
   *
   * Defined separately to the slot bounds because the resizing bounds need to be resolvable to a pixel value,
   * and the panel's slot bounds use a complex CSS expression.
   */ var getResizeBounds = (0, _react.useCallback)(function() {
        var _sideNavRef_current;
        var _sideNavRef_current_offsetWidth;
        var sideNavWidth = (_sideNavRef_current_offsetWidth = (_sideNavRef_current = sideNavRef.current) === null || _sideNavRef_current === void 0 ? void 0 : _sideNavRef_current.offsetWidth) !== null && _sideNavRef_current_offsetWidth !== void 0 ? _sideNavRef_current_offsetWidth : 0;
        /**
     * The panel should not resize larger than the page content, equivalent to the `Main` + `Aside` slots.
     *
     * This maximum width is equivalent to half the viewport width, after removing the sidebar width.
     */ var maxWidth = Math.round((window.innerWidth - sideNavWidth) / 2);
        return {
            min: "".concat(minWidth, "px"),
            max: "".concat(maxWidth, "px")
        };
    }, [
        minWidth,
        sideNavRef
    ]);
    var panelWidthSlotBounds = {
        min: "".concat(minWidth, "px"),
        // `sideNavLiveWidthVar` is not defined if the `SideNav` is not mounted, so we fallback to `0px`.
        max: "round(nearest, calc((100vw - var(".concat((0, _constants.sideNavLiveWidthVar), ", 0px)) / 2), 1px)")
    };
    var panelVariableWidth = "clamp(".concat(panelWidthSlotBounds.min, ", ").concat(width, "px, ").concat(panelWidthSlotBounds.max, ")");
    (0, _useResizingWidthCssVarOnRootElement.useResizingWidthCssVarOnRootElement)({
        isEnabled: dangerouslyHoistSlotSizes,
        cssVar: panelSplitterResizingVar,
        panelId: (0, _constants.panelPanelSplitterId)
    });
    var _obj;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
        id: id,
        "data-layout-slot": true,
        "aria-label": label,
        className: (0, _runtime.ax)([
            styles.root,
            defaultWidth === 0 && styles.hidden,
            hasBorder && styles.border,
            xcss
        ]),
        style: (_obj = {}, // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
        (0, _defineProperty._)(_obj, (0, _constants.panelVar), panelVariableWidth), (0, _defineProperty._)(_obj, '--minWidth', "".concat(minWidth, "px")), _obj),
        "data-testid": testId,
        ref: ref,
        children: [
            dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
            // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
            // When they aren't needed anymore we can delete them wholesale.
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dangerouslyHoistCssVarToDocumentRoot.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, _constants.UNSAFE_panelLayoutVar),
                value: "0px",
                mediaQuery: (0, _responsive.media).above.lg,
                responsiveValue: "var(".concat(panelSplitterResizingVar, ", ").concat(panelVariableWidth, ")")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _provider.PanelSplitterProvider), {
                panelId: (0, _constants.panelPanelSplitterId),
                panelRef: ref,
                panelWidth: width,
                onCompleteResize: setWidth,
                getResizeBounds: getResizeBounds,
                resizingCssVar: panelSplitterResizingVar,
                position: "start",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: (0, _runtime.ax)([
                        styles.scrollContainer
                    ]),
                    children: children
                })
            })
        ]
    });
}

},{"@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_sliced_to_array":"8PtL6","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/platform-feature-flags":"kO5t9","@atlaskit/primitives/responsive":"81rD3","../../context/skip-links/use-skip-link-internal":"kDmSF","./constants":"1IWIQ","./dangerously-hoist-css-var-to-document-root":"5aqtO","./hoist-slot-sizes-context":"7n3AN","./panel-splitter/provider":"3Oc6r","./side-nav/use-side-nav-ref":"Gj3BG","./use-layout-id":"lIPxI","./use-resizing-width-css-var-on-root-element":"2qCDM","./use-safe-default-width":"cOVYJ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"81rD3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "media", function() {
    return 0, _mediaHelper.media;
});
parcelHelpers.export(exports, "UNSAFE_media", function() {
    return 0, _mediaHelper.UNSAFE_media;
});
parcelHelpers.export(exports, "UNSAFE_buildAboveMediaQueryCSS", function() {
    return 0, _buildMediaQueryCss.UNSAFE_buildAboveMediaQueryCSS;
});
parcelHelpers.export(exports, "UNSAFE_BREAKPOINTS_ORDERED_LIST", function() {
    return 0, _constants.UNSAFE_BREAKPOINTS_ORDERED_LIST;
});
parcelHelpers.export(exports, "UNSAFE_BREAKPOINTS_CONFIG", function() {
    return 0, _constants.UNSAFE_BREAKPOINTS_CONFIG;
});
parcelHelpers.export(exports, "UNSAFE_useMediaQuery", function() {
    return 0, _useMediaQuery.UNSAFE_useMediaQuery;
});
parcelHelpers.export(exports, "Show", function() {
    return 0, _show.Show;
});
parcelHelpers.export(exports, "Hide", function() {
    return 0, _hide.Hide;
});
var _mediaHelper = require("./media-helper");
var _buildMediaQueryCss = require("./build-media-query-css");
var _constants = require("./constants");
var _useMediaQuery = require("./use-media-query");
var _show = require("./show");
var _hide = require("./hide");

},{"./media-helper":"asxr6","./build-media-query-css":false,"./constants":false,"./use-media-query":false,"./show":false,"./hide":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"asxr6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "media", function() {
    return 0, _media.media;
});
parcelHelpers.export(exports, "UNSAFE_media", function() {
    return UNSAFE_media;
});
var _media = require("./media");
var UNSAFE_media = (0, _media.media);

},{"./media":"bcy5C","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bcy5C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "media", function() {
    return media;
});
var media = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1IWIQ":[function(require,module,exports,__globalThis) {
/**
 * These variables are shared across the different page layout slots.
 * This violates the [UI styling standard](https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-imported-style-values/usage).
 * We have chosen to ignore this rule to prevent duplicating them across the different slots, and to provide a high level view of them and how they relate.
 */ // These are "compressed" to discourage usage.
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sideNavVar", function() {
    return sideNavVar;
});
parcelHelpers.export(exports, "asideVar", function() {
    return asideVar;
});
parcelHelpers.export(exports, "panelVar", function() {
    return panelVar;
});
parcelHelpers.export(exports, "bannerMountedVar", function() {
    return bannerMountedVar;
});
parcelHelpers.export(exports, "topNavMountedVar", function() {
    return topNavMountedVar;
});
parcelHelpers.export(exports, "ribbonVar", function() {
    return ribbonVar;
});
parcelHelpers.export(exports, "sideNavLiveWidthVar", function() {
    return sideNavLiveWidthVar;
});
parcelHelpers.export(exports, "sideNavPanelSplitterId", function() {
    return sideNavPanelSplitterId;
});
parcelHelpers.export(exports, "asidePanelSplitterId", function() {
    return asidePanelSplitterId;
});
parcelHelpers.export(exports, "panelPanelSplitterId", function() {
    return panelPanelSplitterId;
});
parcelHelpers.export(exports, "contentHeightWhenFixed", function() {
    return contentHeightWhenFixed;
});
parcelHelpers.export(exports, "contentInsetBlockStart", function() {
    return contentInsetBlockStart;
});
parcelHelpers.export(exports, "UNSAFE_topNavVar", function() {
    return UNSAFE_topNavVar;
});
parcelHelpers.export(exports, "UNSAFE_bannerVar", function() {
    return UNSAFE_bannerVar;
});
parcelHelpers.export(exports, "UNSAFE_sideNavLayoutVar", function() {
    return UNSAFE_sideNavLayoutVar;
});
parcelHelpers.export(exports, "UNSAFE_ribbonVar", function() {
    return UNSAFE_ribbonVar;
});
parcelHelpers.export(exports, "UNSAFE_asideLayoutVar", function() {
    return UNSAFE_asideLayoutVar;
});
parcelHelpers.export(exports, "UNSAFE_panelLayoutVar", function() {
    return UNSAFE_panelLayoutVar;
});
parcelHelpers.export(exports, "UNSAFE_MAIN_BLOCK_START_FOR_LEGACY_PAGES_ONLY", function() {
    return UNSAFE_MAIN_BLOCK_START_FOR_LEGACY_PAGES_ONLY;
});
parcelHelpers.export(exports, "UNSAFE_MAIN_INLINE_START_FOR_LEGACY_PAGES_ONLY", function() {
    return UNSAFE_MAIN_INLINE_START_FOR_LEGACY_PAGES_ONLY;
});
parcelHelpers.export(exports, "UNSAFE_MAIN_INLINE_END_FOR_LEGACY_PAGES_ONLY", function() {
    return UNSAFE_MAIN_INLINE_END_FOR_LEGACY_PAGES_ONLY;
});
parcelHelpers.export(exports, "localSlotLayers", function() {
    return localSlotLayers;
});
parcelHelpers.export(exports, "openLayerObserverSideNavNamespace", function() {
    return openLayerObserverSideNavNamespace;
});
parcelHelpers.export(exports, "openLayerObserverTopNavStartNamespace", function() {
    return openLayerObserverTopNavStartNamespace;
});
parcelHelpers.export(exports, "openLayerObserverTopNavMiddleNamespace", function() {
    return openLayerObserverTopNavMiddleNamespace;
});
parcelHelpers.export(exports, "openLayerObserverTopNavEndNamespace", function() {
    return openLayerObserverTopNavEndNamespace;
});
var sideNavVar = '--n_sNvw';
var asideVar = '--n_asDw';
var panelVar = '--n_pnlW';
var bannerMountedVar = '--n_bnrM';
var topNavMountedVar = '--n_tNvM';
var ribbonVar = '--n_rbnW';
var sideNavLiveWidthVar = '--n_sNvlw';
var sideNavPanelSplitterId = Symbol('SideNav PanelSplitter');
var asidePanelSplitterId = Symbol('Aside PanelSplitter');
var panelPanelSplitterId = Symbol('Panel PanelSplitter');
var contentHeightWhenFixed = "calc(100vh - var(--n_bnrM, 0px) - var(--n_tNvM, 0px))";
var contentInsetBlockStart = "calc(var(--n_bnrM, 0px) + var(--n_tNvM, 0px))";
var UNSAFE_topNavVar = '--topNavigationHeight';
var UNSAFE_bannerVar = '--bannerHeight';
var UNSAFE_sideNavLayoutVar = '--leftSidebarWidth';
var UNSAFE_ribbonVar = '--leftPanelWidth';
var UNSAFE_asideLayoutVar = '--rightSidebarWidth';
var UNSAFE_panelLayoutVar = '--rightPanelWidth';
var UNSAFE_MAIN_BLOCK_START_FOR_LEGACY_PAGES_ONLY = "calc(var(".concat(UNSAFE_bannerVar, ", 0px) + var(").concat(UNSAFE_topNavVar, ", 0px))");
var UNSAFE_MAIN_INLINE_START_FOR_LEGACY_PAGES_ONLY = "calc(var(".concat(UNSAFE_ribbonVar, ", 0px) + var(").concat(UNSAFE_sideNavLayoutVar, ", 0px))");
var UNSAFE_MAIN_INLINE_END_FOR_LEGACY_PAGES_ONLY = "calc(var(".concat(UNSAFE_asideLayoutVar, ", 0px) + var(").concat(UNSAFE_panelLayoutVar, ", 0px))");
var localSlotLayers = {
    ribbon: 4,
    // The side nav panel splitter is layered above the top nav when FHS is enabled.
    // It has the same z-index value, but is rendered after the top nav in the DOM so is stacked above.
    sideNavPanelSplitterFHS: 4,
    topBar: 4,
    banner: 4,
    // When FHS is enabled, the side nav is layered below the top nav,
    // but above the panel
    bannerFHS: 3,
    topNavFHS: 3,
    sideNav: 2,
    panelSmallViewports: 1
};
var openLayerObserverSideNavNamespace = 'side-nav';
var openLayerObserverTopNavStartNamespace = 'top-nav-start';
var openLayerObserverTopNavMiddleNamespace = 'top-nav-middle';
var openLayerObserverTopNavEndNamespace = 'top-nav-end';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5aqtO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DangerouslyHoistCssVarToDocumentRoot", function() {
    return DangerouslyHoistCssVarToDocumentRoot;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var getCssStringValue = function(value) {
    return typeof value === 'number' ? "".concat(value, "px") : value;
};
var DangerouslyHoistCssVarToDocumentRoot = function(param) {
    var variableName = param.variableName, value = param.value, mediaQuery = param.mediaQuery, responsiveValue = param.responsiveValue;
    /**
	 * Note don't put multiple variables in multiple lines. eg
	 * <style>
	 *   {css1}
	 *   {css2}
	 * </style>
	 *
	 * React will insert an empty HTML comment in between the text in SSR.
	 * This is not a valid tag and will break the page.
	 * <style>foo<!-- -->bar</style>
	 */ var style = ":root { ".concat(variableName, ": ").concat(getCssStringValue(value), " }");
    if (mediaQuery && responsiveValue) style += " ".concat(mediaQuery, " { :root { ").concat(variableName, ": ").concat(getCssStringValue(responsiveValue), " } }");
    return(// Using a global style is required for SSR, as we can't use React hooks
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
    /*#__PURE__*/ (0, _jsxRuntime.jsx)("style", {
        children: style
    }));
};

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7n3AN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DangerouslyHoistSlotSizes", function() {
    return DangerouslyHoistSlotSizes;
});
var _react = require("react");
var DangerouslyHoistSlotSizes = /*#__PURE__*/ (0, _react.createContext)(false);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3Oc6r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PanelSplitterProvider", function() {
    return PanelSplitterProvider;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _panelSplitterContext = require("./panel-splitter-context");
var PanelSplitterProvider = function(param) {
    var panelId = param.panelId, panelWidth = param.panelWidth, onCompleteResize = param.onCompleteResize, getResizeBounds = param.getResizeBounds, resizingCssVar = param.resizingCssVar, panelRef = param.panelRef, providedPortalRef = param.portalRef, _param_position = param.position, position = _param_position === void 0 ? 'end' : _param_position, _param_isEnabled = param.isEnabled, isEnabled = _param_isEnabled === void 0 ? true : _param_isEnabled, shortcut = param.shortcut, children = param.children;
    var portalRef = (0, _react.useRef)(null);
    var context = (0, _react.useMemo)(function() {
        return {
            panelId: panelId,
            panelWidth: panelWidth,
            onCompleteResize: onCompleteResize,
            getResizeBounds: getResizeBounds,
            resizingCssVar: resizingCssVar,
            position: position,
            panelRef: panelRef,
            isEnabled: isEnabled,
            portalRef: typeof providedPortalRef !== 'undefined' ? providedPortalRef : portalRef,
            shortcut: shortcut
        };
    }, [
        panelId,
        panelWidth,
        onCompleteResize,
        getResizeBounds,
        resizingCssVar,
        position,
        panelRef,
        isEnabled,
        providedPortalRef,
        shortcut
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _panelSplitterContext.PanelSplitterContext).Provider, {
                value: context,
                children: children
            }),
            typeof providedPortalRef !== 'undefined' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                ref: portalRef
            })
        ]
    });
};

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","./panel-splitter-context":"61sRQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"61sRQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PanelSplitterContext", function() {
    return PanelSplitterContext;
});
var _react = require("react");
var PanelSplitterContext = /*#__PURE__*/ (0, _react.createContext)(null);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"Gj3BG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns a ref for the side navigation that is accessible to other Page Layout slots.
 *
 * Used by the Panel to measure the SideNav when it is calculating its resize bounds.
 */ parcelHelpers.export(exports, "useSideNavRef", function() {
    return useSideNavRef;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _sideNavRefContext = require("./side-nav-ref-context");
function useSideNavRef() {
    return (0, _react.useContext)((0, _sideNavRefContext.SideNavRefContext));
}

},{"react":"ltHCL","./side-nav-ref-context":"4rob5","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4rob5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SideNavRefContext", function() {
    return SideNavRefContext;
});
var _react = require("react");
var SideNavRefContext = /*#__PURE__*/ (0, _react.createContext)({
    current: null
});

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2qCDM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Monitors resizing on the panel splitter with the provided `panelId`
 * and writes the resizing width to the `cssVar` on the root element (`<html>`).
 */ parcelHelpers.export(exports, "useResizingWidthCssVarOnRootElement", function() {
    return useResizingWidthCssVarOnRootElement;
});
var _react = require("react");
var _combine = require("@atlaskit/pragmatic-drag-and-drop/combine");
var _adapter = require("@atlaskit/pragmatic-drag-and-drop/element/adapter");
var _isPanelSplitterDragData = require("./panel-splitter/is-panel-splitter-drag-data");
function useResizingWidthCssVarOnRootElement(param) {
    var _param_isEnabled = param.isEnabled, isEnabled = _param_isEnabled === void 0 ? true : _param_isEnabled, cssVar = param.cssVar, panelId = param.panelId;
    (0, _react.useEffect)(function() {
        if (!isEnabled) return;
        return (0, _combine.combine)((0, _adapter.monitorForElements)({
            canMonitor: function canMonitor(param) {
                var source = param.source;
                return source.data.panelId === panelId;
            },
            onDrag: function onDrag(param) {
                var source = param.source;
                if (!(0, _isPanelSplitterDragData.isPanelSplitterDragData)(source.data)) return;
                /**
					 * Copies the resizing width value to the `<html>` element.
					 *
					 * Required to reflect the live width of the side navigation.
					 *
					 * Used by:
					 *   - Legacy `--leftSidebarWidth` variable
					 *   - Panel slot max-width constraint
					 *
					 * When the legacy `--leftSidebarWidth` variable is no longer needed,
					 * we could consider writing to the `Panel` element instead.
					 */ document.documentElement.style.setProperty(cssVar, source.data.resizingWidth);
            },
            onDrop: function onDrop() {
                document.documentElement.style.removeProperty(cssVar);
            }
        }));
    }, [
        cssVar,
        isEnabled,
        panelId
    ]);
    (0, _react.useEffect)(function() {
        if (!isEnabled) return;
        /**
		 * Ensures that the resizing CSS var on the `<html>` element is cleaned up properly
		 * if the component unmounts during a drag.
		 */ return function cleanupGlobalResizingCssVar() {
            document.documentElement.style.removeProperty(cssVar);
        };
    }, [
        cssVar,
        isEnabled
    ]);
}

},{"react":"ltHCL","@atlaskit/pragmatic-drag-and-drop/combine":"ajFdY","@atlaskit/pragmatic-drag-and-drop/element/adapter":"9mWL4","./panel-splitter/is-panel-splitter-drag-data":"ffb6W","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ajFdY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "combine", function() {
    return 0, _combine.combine;
});
var _combine = require("../public-utils/combine");

},{"../public-utils/combine":"hR4cH","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hR4cH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Create a new combined function that will call all the provided functions */ parcelHelpers.export(exports, "combine", function() {
    return combine;
});
function combine() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++){
        fns[_key] = arguments[_key];
    }
    return function cleanup() {
        fns.forEach(function(fn) {
            return fn();
        });
    };
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9mWL4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "draggable", function() {
    return 0, _elementAdapter.draggable;
});
parcelHelpers.export(exports, "dropTargetForElements", function() {
    return 0, _elementAdapter.dropTargetForElements;
});
parcelHelpers.export(exports, "monitorForElements", function() {
    return 0, _elementAdapter.monitorForElements;
});
var _elementAdapter = require("../../adapter/element-adapter");

},{"../../adapter/element-adapter":"7JUXT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7JUXT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dropTargetForElements", function() {
    return dropTargetForElements;
});
parcelHelpers.export(exports, "monitorForElements", function() {
    return monitorForElements;
});
parcelHelpers.export(exports, "draggable", function() {
    return draggable;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _bindEventListener = require("bind-event-listener");
var _getElementFromPointWithoutHoneyPot = require("../honey-pot-fix/get-element-from-point-without-honey-pot");
var _makeHoneyPotFix = require("../honey-pot-fix/make-honey-pot-fix");
var _makeAdapter = require("../make-adapter/make-adapter");
var _combine = require("../public-utils/combine");
var _once = require("../public-utils/once");
var _addAttribute = require("../util/add-attribute");
var _android = require("../util/android");
var _getInput = require("../util/get-input");
var _textMediaType = require("../util/media-types/text-media-type");
var _urlMediaType = require("../util/media-types/url-media-type");
var _elementAdapterNativeDataKey = require("./element-adapter-native-data-key");
var draggableRegistry = new WeakMap();
function addToRegistry(args) {
    draggableRegistry.set(args.element, args);
    return function cleanup() {
        draggableRegistry.delete(args.element);
    };
}
var honeyPotFix = (0, _makeHoneyPotFix.makeHoneyPotFix)();
var adapter = (0, _makeAdapter.makeAdapter)({
    typeKey: 'element',
    defaultDropEffect: 'move',
    mount: function mount(api) {
        /**  Binding event listeners the `document` rather than `window` so that
		 * this adapter always gets preference over the text adapter.
		 * `document` is the first `EventTarget` under `window`
		 * https://twitter.com/alexandereardon/status/1604658588311465985
		 */ return (0, _combine.combine)(honeyPotFix.bindEvents(), (0, _bindEventListener.bind)(document, {
            type: 'dragstart',
            listener: function listener(event) {
                var _entry_getInitialDataForExternal, _entry_getInitialData;
                if (!api.canStart(event)) return;
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Technically `dataTransfer` can be `null` according to the types
                // But that behaviour does not seem to appear in the spec.
                // If there is not `dataTransfer`, we can assume something is wrong and not
                // start a drag
                if (!event.dataTransfer) return;
                // the closest parent that is a draggable element will be marked as
                // the `event.target` for the event
                var target = event.target;
                // this source is only for elements
                // Note: only HTMLElements can have the "draggable" attribute
                if (!(0, _instanceof._)(target, HTMLElement)) return;
                // see if the thing being dragged is owned by us
                var entry = draggableRegistry.get(target);
                // no matching element found
                // → dragging an element with `draggable="true"` that is not controlled by us
                if (!entry) return;
                /**
					 * A text selection drag _can_ have the `draggable` element be
					 * the `event.target` if the user is dragging the text selection
					 * from the `draggable`.
					 *
					 * To know if the `draggable` is being dragged, we look at whether any
					 * `"text/plain"` data is being dragged. If it is, then a text selection
					 * drag is occurring.
					 *
					 * This behaviour has been validated on:
					 *
					 * - Chrome@128 on Android@14
					 * - Chrome@128 on iOS@17.6.1
					 * - Chrome@128 on Windows@11
					 * - Chrome@128 on MacOS@14.6.1
					 * - Firefox@129 on Windows@11 (not possible for user to select text in a draggable)
					 * - Firefox@129 on MacOS@14.6.1 (not possible for user to select text in a draggable)
					 *
					 * Note: Could usually just use: `event.dataTransfer.types.includes(textMediaType)`
					 * but unfortunately ProseMirror is always setting `""` as the dragged text
					 *
					 * Note: Unfortunately editor is (heavily) leaning on the current functionality today
					 * and unwinding it will be a decent amount of effort. So for now, a text selection
					 * where the `event.target` is a `draggable` element will still trigger the
					 * element adapter.
					 *
					 * // Future state:
					 * if(event.dataTransfer.getData(textMediaType)) {
					 * 	return;
					 * }
					 *
					 */ var input = (0, _getInput.getInput)(event);
                var _entry_dragHandle;
                var feedback = {
                    element: entry.element,
                    dragHandle: (_entry_dragHandle = entry.dragHandle) !== null && _entry_dragHandle !== void 0 ? _entry_dragHandle : null,
                    input: input
                };
                // Check: does the draggable want to allow dragging?
                if (entry.canDrag && !entry.canDrag(feedback)) {
                    // cancel drag operation if we cannot drag
                    event.preventDefault();
                    return;
                }
                // Check: is there a drag handle and is the user using it?
                if (entry.dragHandle) {
                    // technically don't need this util, but just being
                    // consistent with how we look up what is under the users
                    // cursor.
                    var over = (0, _getElementFromPointWithoutHoneyPot.getElementFromPointWithoutHoneypot)({
                        x: input.clientX,
                        y: input.clientY
                    });
                    // if we are not dragging from the drag handle (or something inside the drag handle)
                    // then we will cancel the active drag
                    if (!entry.dragHandle.contains(over)) {
                        event.preventDefault();
                        return;
                    }
                }
                var _entry_getInitialDataForExternal1;
                /**
					 *  **Goal**
					 *  Pass information to other applications
					 *
					 * **Approach**
					 *  Put data into the native data store
					 *
					 *  **What about the native adapter?**
					 *  When the element adapter puts native data into the native data store
					 *  the native adapter is not triggered in the current window,
					 *  but a native adapter in an external window _can_ be triggered
					 *
					 *  **Why bake this into core?**
					 *  This functionality could be pulled out and exposed inside of
					 *  `onGenerateDragPreview`. But decided to make it a part of the
					 *  base API as it felt like a common enough use case and ended
					 *  up being a similar amount of code to include this function as
					 *  it was to expose the hook for it
					 */ var nativeData = (_entry_getInitialDataForExternal1 = (_entry_getInitialDataForExternal = entry.getInitialDataForExternal) === null || _entry_getInitialDataForExternal === void 0 ? void 0 : _entry_getInitialDataForExternal.call(entry, feedback)) !== null && _entry_getInitialDataForExternal1 !== void 0 ? _entry_getInitialDataForExternal1 : null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (nativeData) try {
                    for(var _iterator = Object.entries(nativeData)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, _slicedToArray._)(_step.value, 2), key = _step_value[0], data = _step_value[1];
                        event.dataTransfer.setData(key, data !== null && data !== void 0 ? data : '');
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                /**
					 *  📱 For Android devices, a drag operation will not start unless
					 * "text/plain" or "text/uri-list" data exists in the native data store
					 * https://twitter.com/alexandereardon/status/1732189803754713424
					 *
					 * Tested on:
					 * Device: Google Pixel 5
					 * Android version: 14 (November 5, 2023)
					 * Chrome version: 120.0
					 */ if ((0, _android.isAndroid)() && !event.dataTransfer.types.includes((0, _textMediaType.textMediaType)) && !event.dataTransfer.types.includes((0, _urlMediaType.URLMediaType))) event.dataTransfer.setData((0, _textMediaType.textMediaType), (0, _android.androidFallbackText));
                /**
					 * 1. Must set any media type for `iOS15` to work
					 * 2. We are also doing adding data so that the native adapter
					 * can know that the element adapter has handled this drag
					 *
					 * We used to wrap this `setData()` in a `try/catch` for Firefox,
					 * but it looks like that was not needed.
					 *
					 * Tested using: https://codesandbox.io/s/checking-firefox-throw-behaviour-on-dragstart-qt8h4f
					 *
					 * - ✅ Firefox@70.0 (Oct 2019) on macOS Sonoma
					 * - ✅ Firefox@70.0 (Oct 2019) on macOS Big Sur
					 * - ✅ Firefox@70.0 (Oct 2019) on Windows 10
					 *
					 * // just checking a few more combinations to be super safe
					 *
					 * - ✅ Chrome@78 (Oct 2019) on macOS Big Sur
					 * - ✅ Chrome@78 (Oct 2019) on Windows 10
					 * - ✅ Safari@14.1 on macOS Big Sur
					 */ event.dataTransfer.setData((0, _elementAdapterNativeDataKey.elementAdapterNativeDataKey), '');
                var _entry_dragHandle1, _entry_getInitialData1;
                var payload = {
                    element: entry.element,
                    dragHandle: (_entry_dragHandle1 = entry.dragHandle) !== null && _entry_dragHandle1 !== void 0 ? _entry_dragHandle1 : null,
                    data: (_entry_getInitialData1 = (_entry_getInitialData = entry.getInitialData) === null || _entry_getInitialData === void 0 ? void 0 : _entry_getInitialData.call(entry, feedback)) !== null && _entry_getInitialData1 !== void 0 ? _entry_getInitialData1 : {}
                };
                var dragType = {
                    type: 'element',
                    payload: payload,
                    startedFrom: 'internal'
                };
                api.start({
                    event: event,
                    dragType: dragType
                });
            }
        }));
    },
    dispatchEventToSource: function(param) {
        var eventName = param.eventName, payload = param.payload;
        var // During a drag operation, a draggable can be:
        // - remounted with different functions
        // - removed completely
        // So we need to get the latest entry from the registry in order
        // to call the latest event functions
        _draggableRegistry_get_eventName, _draggableRegistry_get;
        (_draggableRegistry_get = draggableRegistry.get(payload.source.element)) === null || _draggableRegistry_get === void 0 ? void 0 : (_draggableRegistry_get_eventName = _draggableRegistry_get[eventName]) === null || _draggableRegistry_get_eventName === void 0 ? void 0 : _draggableRegistry_get_eventName.call(_draggableRegistry_get, // I cannot seem to get the types right here.
        // TS doesn't seem to like that one event can need `nativeSetDragImage`
        // @ts-expect-error
        payload);
    },
    onPostDispatch: honeyPotFix.getOnPostDispatch()
});
var dropTargetForElements = adapter.dropTarget;
var monitorForElements = adapter.monitor;
function draggable(args) {
    var cleanup = (0, _combine.combine)(// making the draggable register the adapter rather than drop targets
    // this is because you *must* have a draggable element to start a drag
    // but you _might_ not have any drop targets immediately
    // (You might create drop targets async)
    adapter.registerUsage(), addToRegistry(args), (0, _addAttribute.addAttribute)(args.element, {
        attribute: 'draggable',
        value: 'true'
    }));
    // Wrapping in `once` to prevent unexpected side effects if consumers call
    // the clean up function multiple times.
    return (0, _once.once)(cleanup);
}

},{"@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_sliced_to_array":"8PtL6","bind-event-listener":"bjeUU","../honey-pot-fix/get-element-from-point-without-honey-pot":"h7BUI","../honey-pot-fix/make-honey-pot-fix":"cMBuo","../make-adapter/make-adapter":"ibq8J","../public-utils/combine":"hR4cH","../public-utils/once":"17t1P","../util/add-attribute":"28GTp","../util/android":"dls44","../util/get-input":"eC2su","../util/media-types/text-media-type":"7cAH9","../util/media-types/url-media-type":"aGF3O","./element-adapter-native-data-key":"dJH0T","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"h7BUI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getElementFromPointWithoutHoneypot", function() {
    return getElementFromPointWithoutHoneypot;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _isHoneyPotElement = require("./is-honey-pot-element");
function getElementFromPointWithoutHoneypot(client) {
    // eslint-disable-next-line no-restricted-syntax
    var _document_elementsFromPoint = (0, _slicedToArray._)(document.elementsFromPoint(client.x, client.y), 2), top = _document_elementsFromPoint[0], second = _document_elementsFromPoint[1];
    if (!top) return null;
    if ((0, _isHoneyPotElement.isHoneyPotElement)(top)) return second !== null && second !== void 0 ? second : null;
    return top;
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","./is-honey-pot-element":"3CYqW","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3CYqW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isHoneyPotElement", function() {
    return isHoneyPotElement;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
var _honeyPotDataAttribute = require("./honey-pot-data-attribute");
function isHoneyPotElement(target) {
    return (0, _instanceof._)(target, Element) && target.hasAttribute((0, _honeyPotDataAttribute.honeyPotDataAttribute));
}

},{"@swc/helpers/_/_instanceof":"h9UKc","./honey-pot-data-attribute":"5PLHD","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5PLHD":[function(require,module,exports,__globalThis) {
// pulling this into a separate file so adapter(s) that don't
// need the honey pot can pay as little as possible for it.
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "honeyPotDataAttribute", function() {
    return honeyPotDataAttribute;
});
var honeyPotDataAttribute = 'data-pdnd-honey-pot';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cMBuo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeHoneyPotFix", function() {
    return makeHoneyPotFix;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _bindEventListener = require("bind-event-listener");
var _maxZIndex = require("../util/max-z-index");
var _popoverResetStyles = require("../util/popover-reset-styles");
var _supportsPopover = require("../util/supports-popover");
var _honeyPotDataAttribute = require("./honey-pot-data-attribute");
var honeyPotSize = 2;
var halfHoneyPotSize = honeyPotSize / 2;
/**
 * `clientX` and `clientY` can be in sub pixels (eg `2.332`)
 * However, browser hitbox testing is commonly do to the closest pixel.
 *
 * → https://issues.chromium.org/issues/40940531
 *
 * To be sure that the honey pot will be over the `client` position,
 * we `.floor()` `clientX` and`clientY` and then make it `2px` in size.
 **/ function floorToClosestPixel(point) {
    return {
        x: Math.floor(point.x),
        y: Math.floor(point.y)
    };
}
/**
 * We want to make sure the honey pot sits around the users position.
 * This seemed to be the most resilient while testing.
 */ function pullBackByHalfHoneyPotSize(point) {
    return {
        x: point.x - halfHoneyPotSize,
        y: point.y - halfHoneyPotSize
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function preventGoingBackwardsOffScreen(point) {
    return {
        x: Math.max(point.x, 0),
        y: Math.max(point.y, 0)
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function preventGoingForwardsOffScreen(point) {
    return {
        x: Math.min(point.x, window.innerWidth - honeyPotSize),
        y: Math.min(point.y, window.innerHeight - honeyPotSize)
    };
}
/**
 * Create a `2x2` `DOMRect` around the `client` position
 */ function getHoneyPotRectFor(param) {
    var client = param.client;
    var point = preventGoingForwardsOffScreen(preventGoingBackwardsOffScreen(pullBackByHalfHoneyPotSize(floorToClosestPixel(client))));
    // When debugging, it is helpful to
    // make this element a bit bigger
    return DOMRect.fromRect({
        x: point.x,
        y: point.y,
        width: honeyPotSize,
        height: honeyPotSize
    });
}
function getRectStyles(param) {
    var clientRect = param.clientRect;
    return {
        left: "".concat(clientRect.left, "px"),
        top: "".concat(clientRect.top, "px"),
        width: "".concat(clientRect.width, "px"),
        height: "".concat(clientRect.height, "px")
    };
}
function isWithin(param) {
    var client = param.client, clientRect = param.clientRect;
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}
/**
 * The honey pot fix is designed to get around a painful bug in all browsers.
 *
 * [Overview](https://www.youtube.com/watch?v=udE9qbFTeQg)
 *
 * **Background**
 *
 * When a drag starts, browsers incorrectly think that the users pointer is
 * still depressed where the drag started. Any element that goes under this position
 * will be entered into, causing `"mouseenter"` events and `":hover"` styles to be applied.
 *
 * _This is a violation of the spec_
 *
 * > "From the moment that the user agent is to initiate the drag-and-drop operation,
 * > until the end 	of the drag-and-drop operation, device input events
 * > (e.g. mouse and keyboard events) must be suppressed."
 * >
 * > - https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
 *
 * _Some impacts_
 *
 * - `":hover"` styles being applied where they shouldn't (looks messy)
 * - components such as tooltips responding to `"mouseenter"` can show during a drag,
 *   and on an element the user isn't even over
 *
 * Bug: https://issues.chromium.org/issues/41129937
 *
 * **Honey pot fix**
 *
 * 1. Create an element where the browser thinks the depressed pointer is
 *    to absorb the incorrect pointer events
 * 2. Remove that element when it is no longer needed
 */ function mountHoneyPot(param) {
    var initial = param.initial;
    var element = document.createElement('div');
    element.setAttribute((0, _honeyPotDataAttribute.honeyPotDataAttribute), 'true');
    // Using popover="manual" to place the element in the browser's top layer.
    // This ensures the honey pot is visually on top of everything else,
    // including elements using z-index and other stacking contexts.
    // "manual" means no light dismiss — we manage the lifecycle ourselves.
    // Falls back to position:fixed + maxZIndex when the popover API is not available.
    if ((0, _supportsPopover.supportsPopover)()) element.setAttribute('popover', 'manual');
    // can shift during the drag thanks to Firefox
    var clientRect = getHoneyPotRectFor({
        client: initial
    });
    Object.assign(element.style, (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({
        position: 'fixed'
    }, (0, _supportsPopover.supportsPopover)() ? // needs to be overridden by our top / left values
    (0, _popoverResetStyles.popoverResetUserAgentStyles) : {
        // Fallback: using maximum possible z-index so that this element
        // will always be on top of other positioned content.
        zIndex: (0, _maxZIndex.maxZIndex)
    }), {
        // Setting a background color explicitly to avoid any inherited styles.
        // Looks like this could be `opacity: 0`, but worried that _might_
        // cause the element to be ignored on some platforms.
        // When debugging, set backgroundColor to something like "red".
        backgroundColor: 'transparent',
        // Being explicit to avoid inheriting styles
        padding: 0,
        margin: 0,
        boxSizing: 'border-box',
        // We want this element to absorb pointer events,
        // it's kind of the whole point 😉
        pointerEvents: 'auto'
    }), getRectStyles({
        clientRect: clientRect
    })));
    document.body.appendChild(element);
    if ((0, _supportsPopover.supportsPopover)()) element.showPopover();
    /**
	 *  🦊 In firefox we can get `"pointermove"` events after the drag
	 * has started, which is a spec violation.
	 * The final `"pointermove"` will reveal where the "depressed" position
	 * is for our honey pot fix.
	 */ var unbindPointerMove = (0, _bindEventListener.bind)(window, {
        type: 'pointermove',
        listener: function listener(event) {
            var client = {
                x: event.clientX,
                y: event.clientY
            };
            clientRect = getHoneyPotRectFor({
                client: client
            });
            Object.assign(element.style, getRectStyles({
                clientRect: clientRect
            }));
        },
        // using capture so we are less likely to be impacted by event stopping
        options: {
            capture: true
        }
    });
    return function finish(param) {
        var current = param.current;
        // Don't need this any more
        unbindPointerMove();
        // If the user is hover the honey pot, we remove it
        // so that the user can continue to interact with the page normally.
        if (isWithin({
            client: current,
            clientRect: clientRect
        })) {
            element.remove();
            return;
        }
        function cleanup() {
            unbindPostDragEvents();
            element.remove();
        }
        var unbindPostDragEvents = (0, _bindEventListener.bindAll)(window, [
            {
                type: 'pointerdown',
                listener: cleanup
            },
            {
                type: 'pointermove',
                listener: cleanup
            },
            {
                type: 'focusin',
                listener: cleanup
            },
            {
                type: 'focusout',
                listener: cleanup
            },
            // a 'pointerdown' should happen before 'dragstart', but just being super safe
            {
                type: 'dragstart',
                listener: cleanup
            },
            // if the user has dragged something out of the window
            // and then is dragging something back into the window
            // the first events we will see are "dragenter" (and then "dragover").
            // So if we see any of these we need to clear the post drag fix.
            {
                type: 'dragenter',
                listener: cleanup
            },
            {
                type: 'dragover',
                listener: cleanup
            }
        ], {
            // Using `capture` so less likely to be impacted by other code stopping events
            capture: true
        });
    };
}
function makeHoneyPotFix() {
    var latestPointerMove = null;
    function bindEvents() {
        // For sanity, only collecting this value from when events are first bound.
        // This prevents the case where a super old "pointermove" could be used
        // from a prior interaction.
        latestPointerMove = null;
        return (0, _bindEventListener.bind)(window, {
            type: 'pointermove',
            listener: function listener(event) {
                latestPointerMove = {
                    x: event.clientX,
                    y: event.clientY
                };
            },
            // listening for pointer move in capture phase
            // so we are less likely to be impacted by events being stopped.
            options: {
                capture: true
            }
        });
    }
    function getOnPostDispatch() {
        var finish = null;
        return function onPostEvent(param) {
            var eventName = param.eventName, payload = param.payload;
            // We are adding the honey pot `onDragStart` so we don't
            // impact the creation of the native drag preview.
            if (eventName === 'onDragStart') {
                var input = payload.location.initial.input;
                // Sometimes there will be no latest "pointermove" (eg iOS).
                // In which case, we use the start position of the drag.
                var initial = latestPointerMove !== null && latestPointerMove !== void 0 ? latestPointerMove : {
                    x: input.clientX,
                    y: input.clientY
                };
                // Don't need to defensively call `finish()` as `onDrop` from
                // one interaction is guaranteed to be called before `onDragStart`
                // of the next.
                finish = mountHoneyPot({
                    initial: initial
                });
            }
            if (eventName === 'onDrop') {
                var input1 = payload.location.current.input;
                finish === null || finish === void 0 ? void 0 : finish({
                    current: {
                        x: input1.clientX,
                        y: input1.clientY
                    }
                });
                finish = null;
                // this interaction is finished, we want to use
                // the latest "pointermove" for each interaction
                latestPointerMove = null;
            }
        };
    }
    return {
        bindEvents: bindEvents,
        getOnPostDispatch: getOnPostDispatch
    };
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","bind-event-listener":"bjeUU","../util/max-z-index":"hwzTL","../util/popover-reset-styles":"04sX0","../util/supports-popover":"eql5s","./honey-pot-data-attribute":"5PLHD","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hwzTL":[function(require,module,exports,__globalThis) {
// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "maxZIndex", function() {
    return maxZIndex;
});
var maxZIndex = 2147483647;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"04sX0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "popoverResetUserAgentStyles", function() {
    return popoverResetUserAgentStyles;
});
var popoverResetUserAgentStyles = {
    inset: 'unset',
    border: 'none',
    padding: 0,
    margin: 0,
    overflow: 'visible',
    color: 'inherit',
    background: 'transparent'
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eql5s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "supportsPopover", function() {
    return supportsPopover;
});
var _once = require("../public-utils/once");
var supportsPopover = (0, _once.once)(function supportsPopover() {
    return typeof HTMLElement !== 'undefined' && typeof HTMLElement.prototype.showPopover === 'function';
});

},{"../public-utils/once":"17t1P","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"17t1P":[function(require,module,exports,__globalThis) {
/** Provide a function that you only ever want to be called a single time */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "once", function() {
    return once;
});
function once(fn) {
    var cache = null;
    return function wrapped() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (!cache) {
            var result = fn.apply(this, args);
            cache = {
                result: result
            };
        }
        return cache.result;
    };
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ibq8J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeAdapter", function() {
    return makeAdapter;
});
var _lifecycleManager = require("../ledger/lifecycle-manager");
var _usageLedger = require("../ledger/usage-ledger");
var _makeDropTarget = require("./make-drop-target");
var _makeMonitor = require("./make-monitor");
function makeAdapter(param) {
    var typeKey = param.typeKey, mount = param.mount, dispatchEventToSource = param.dispatchEventToSource, onPostDispatch = param.onPostDispatch, defaultDropEffect = param.defaultDropEffect;
    var monitorAPI = (0, _makeMonitor.makeMonitor)();
    var dropTargetAPI = (0, _makeDropTarget.makeDropTarget)({
        typeKey: typeKey,
        defaultDropEffect: defaultDropEffect
    });
    function dispatchEvent(args) {
        // 1. forward the event to source
        dispatchEventToSource === null || dispatchEventToSource === void 0 ? void 0 : dispatchEventToSource(args);
        // 2. forward the event to relevant dropTargets
        dropTargetAPI.dispatchEvent(args);
        // 3. forward event to monitors
        monitorAPI.dispatchEvent(args);
        // 4. post consumer dispatch (used for honey pot fix)
        onPostDispatch === null || onPostDispatch === void 0 ? void 0 : onPostDispatch(args);
    }
    function start(param) {
        var event = param.event, dragType = param.dragType;
        (0, _lifecycleManager.lifecycle).start({
            event: event,
            dragType: dragType,
            getDropTargetsOver: dropTargetAPI.getIsOver,
            dispatchEvent: dispatchEvent
        });
    }
    function registerUsage() {
        function mountAdapter() {
            var api = {
                canStart: (0, _lifecycleManager.lifecycle).canStart,
                start: start
            };
            return mount(api);
        }
        return (0, _usageLedger.register)({
            typeKey: typeKey,
            mount: mountAdapter
        });
    }
    return {
        registerUsage: registerUsage,
        dropTarget: dropTargetAPI.dropTargetForConsumers,
        monitor: monitorAPI.monitorForConsumers
    };
}

},{"../ledger/lifecycle-manager":"9NdCX","../ledger/usage-ledger":"bB7G7","./make-drop-target":"bgj4T","./make-monitor":"fyeyg","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9NdCX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lifecycle", function() {
    return lifecycle;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _bindEventListener = require("bind-event-listener");
var _getElementFromPointWithoutHoneyPot = require("../honey-pot-fix/get-element-from-point-without-honey-pot");
var _isHoneyPotElement = require("../honey-pot-fix/is-honey-pot-element");
var _isLeavingWindow = require("../util/changing-window/is-leaving-window");
var _detectBrokenDrag = require("../util/detect-broken-drag");
var _getInput = require("../util/get-input");
var _dispatchConsumerEvent = require("./dispatch-consumer-event");
var globalState = {
    isActive: false
};
function canStart() {
    return !globalState.isActive;
}
function getNativeSetDragImage(event) {
    if (event.dataTransfer) // need to use `.bind` as `setDragImage` is required
    // to be run with `event.dataTransfer` as the "this" context
    return event.dataTransfer.setDragImage.bind(event.dataTransfer);
    return null;
}
function hasHierarchyChanged(param) {
    var current = param.current, next = param.next;
    if (current.length !== next.length) return true;
    // not checking stickiness, data or dropEffect,
    // just whether the hierarchy has changed
    for(var i = 0; i < current.length; i++){
        if (current[i].element !== next[i].element) return true;
    }
    return false;
}
function start(param) {
    var event = param.event, dragType = param.dragType, getDropTargetsOver = param.getDropTargetsOver, dispatchEvent = param.dispatchEvent;
    if (!canStart()) return;
    var initial = getStartLocation({
        event: event,
        dragType: dragType,
        getDropTargetsOver: getDropTargetsOver
    });
    globalState.isActive = true;
    var state = {
        current: initial
    };
    // Setting initial drop effect for the drag
    setDropEffectOnEvent({
        event: event,
        current: initial.dropTargets
    });
    var dispatch = (0, _dispatchConsumerEvent.makeDispatch)({
        source: dragType.payload,
        dispatchEvent: dispatchEvent,
        initial: initial
    });
    function updateState(next) {
        // only looking at whether hierarchy has changed to determine whether something as 'changed'
        var hasChanged = hasHierarchyChanged({
            current: state.current.dropTargets,
            next: next.dropTargets
        });
        // Always updating the state to include latest data, dropEffect and stickiness
        // Only updating consumers if the hierarchy has changed in some way
        // Consumers can get the latest data by using `onDrag`
        state.current = next;
        if (hasChanged) dispatch.dragUpdate({
            current: state.current
        });
    }
    function onUpdateEvent(event) {
        var input = (0, _getInput.getInput)(event);
        // If we are over the honey pot, we need to get the element
        // that the user would have been over if not for the honey pot
        var target = (0, _isHoneyPotElement.isHoneyPotElement)(event.target) ? (0, _getElementFromPointWithoutHoneyPot.getElementFromPointWithoutHoneypot)({
            x: input.clientX,
            y: input.clientY
        }) : event.target;
        var nextDropTargets = getDropTargetsOver({
            target: target,
            input: input,
            source: dragType.payload,
            current: state.current.dropTargets
        });
        if (nextDropTargets.length) {
            // 🩸 must call `event.preventDefault()` to allow a browser drop to occur
            event.preventDefault();
            setDropEffectOnEvent({
                event: event,
                current: nextDropTargets
            });
        }
        updateState({
            dropTargets: nextDropTargets,
            input: input
        });
    }
    function cancel() {
        // The spec behaviour is that when a drag is cancelled, or when dropping on no drop targets,
        // a "dragleave" event is fired on the active drop target before a "dragend" event.
        // We are replicating that behaviour in `cancel` if there are any active drop targets to
        // ensure consistent behaviour.
        //
        // Note: When cancelling, or dropping on no drop targets, a "dragleave" event
        // will have already cleared the dropTargets to `[]` (as that particular "dragleave" has a `relatedTarget` of `null`)
        if (state.current.dropTargets.length) updateState({
            dropTargets: [],
            input: state.current.input
        });
        dispatch.drop({
            current: state.current,
            updatedSourcePayload: null
        });
        finish();
    }
    function finish() {
        globalState.isActive = false;
        unbindEvents();
    }
    var unbindEvents = (0, _bindEventListener.bindAll)(window, [
        {
            // 👋 Note: we are repurposing the `dragover` event as our `drag` event
            // this is because firefox does not publish pointer coordinates during
            // a `drag` event, but does for every other type of drag event
            // `dragover` fires on all elements that are being dragged over
            // Because we are binding to `window` - our `dragover` is effectively the same as a `drag`
            // 🦊😤
            type: 'dragover',
            listener: function listener(event) {
                // We need to regularly calculate the drop targets in order to allow:
                //  - dynamic `canDrop()` checks
                //  - rapid updating `getData()` calls to attach data in response to user input (eg for edge detection)
                // Sadly we cannot schedule inspecting changes resulting from this event
                // we need to be able to conditionally cancel the event with `event.preventDefault()`
                // to enable the correct native drop experience.
                // 1. check to see if anything has changed
                onUpdateEvent(event);
                // 2. let consumers know a move has occurred
                // This will include the latest 'input' values
                dispatch.drag({
                    current: state.current
                });
            }
        },
        {
            type: 'dragenter',
            listener: onUpdateEvent
        },
        {
            type: 'dragleave',
            listener: function listener(event) {
                if (!(0, _isLeavingWindow.isLeavingWindow)({
                    dragLeave: event
                })) return;
                /**
					 * At this point we don't know if a drag is being cancelled,
					 * or if a drag is leaving the `window`.
					 *
					 * Both have:
					 *   1. "dragleave" (with `relatedTarget: null`)
					 *   2. "dragend" (a "dragend" can occur when outside the `window`)
					 *
					 * **Clearing drop targets**
					 *
					 * For either case we are clearing the the drop targets
					 *
					 * - cancelling: we clear drop targets in `"dragend"` anyway
					 * - leaving the `window`: we clear the drop targets (to clear stickiness)
					 *
					 * **Leaving the window and finishing the drag**
					 *
					 * _internal drags_
					 *
					 * - The drag continues when the user is outside the `window`
					 *   and can resume if the user drags back over the `window`,
					 *   or end when the user drops in an external `window`.
					 * - We will get a `"dragend"`, or we can listen for other
					 *   events to determine the drag is finished when the user re-enters the `window`).
					 *
					 * _external drags_
					 *
					 * - We conclude the drag operation.
					 * - We have no idea if the user will drag back over the `window`,
					 *   or if the drag ends elsewhere.
					 * - We will create a new drag if the user re-enters the `window`.
					 *
					 * **Not updating `input`**
					 *
					 * 🐛 Bug[Chrome] the final `"dragleave"` has default input values (eg `clientX == 0`)
					 * Workaround: intentionally not updating `input` in "dragleave"
					 * rather than the users current input values
					 * - [Conversation](https://twitter.com/alexandereardon/status/1642697633864241152)
					 * - [Bug](https://bugs.chromium.org/p/chromium/issues/detail?id=1429937)
					 **/ updateState({
                    input: state.current.input,
                    dropTargets: []
                });
                if (dragType.startedFrom === 'external') cancel();
            }
        },
        {
            // A "drop" can only happen if the browser allowed the drop
            type: 'drop',
            listener: function listener(event) {
                // Capture the final input.
                // We are capturing the final `input` for the
                // most accurate honey pot experience
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, _getInput.getInput)(event)
                };
                /** If there are no drop targets, then we will get
					 * a "drop" event if:
					 * - `preventUnhandled()` is being used
					 * - there is an unmanaged drop target (eg another library)
					 * In these cases, it's up to the consumer
					 * to handle the drop if it's not over one of our drop targets
					 * - `preventUnhandled()` will cancel the "drop"
					 * - unmanaged drop targets can handle the "drop" how they want to
					 * We won't call `event.preventDefault()` in this call path */ if (!state.current.dropTargets.length) {
                    cancel();
                    return;
                }
                event.preventDefault();
                // applying the latest drop effect to the event
                setDropEffectOnEvent({
                    event: event,
                    current: state.current.dropTargets
                });
                dispatch.drop({
                    current: state.current,
                    // When dropping something native, we need to extract the latest
                    // `.items` from the "drop" event as it is now accessible
                    updatedSourcePayload: dragType.type === 'external' ? dragType.getDropPayload(event) : null
                });
                finish();
            }
        },
        {
            // "dragend" fires when on the drag source (eg a draggable element)
            // when the drag is finished.
            // "dragend" will fire after "drop" (if there was a successful drop)
            // "dragend" does not fire if the draggable source has been removed during the drag
            // or for external drag sources (eg files)
            // This "dragend" listener will not fire if there was a successful drop
            // as we will have already removed the event listener
            type: 'dragend',
            listener: function listener(event) {
                // In firefox, the position of the "dragend" event can
                // be a bit different to the last "dragover" event.
                // Updating the input so we can get the best possible
                // information for the honey pot.
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, _getInput.getInput)(event)
                };
                cancel();
            }
        }
    ].concat((0, _toConsumableArray._)((0, _detectBrokenDrag.getBindingsForBrokenDrags)({
        onDragEnd: cancel
    }))), // Once we have started a managed drag operation it is important that we see / own all drag events
    // We got one adoption bug pop up where some code was stopping (`event.stopPropagation()`)
    // all "drop" events in the bubble phase on the `document.body`.
    // This meant that we never saw the "drop" event.
    {
        capture: true
    });
    dispatch.start({
        nativeSetDragImage: getNativeSetDragImage(event)
    });
}
function setDropEffectOnEvent(param) {
    var event = param.event, current = param.current;
    var _current_;
    // setting the `dropEffect` to be the innerMost drop targets dropEffect
    var innerMost = (_current_ = current[0]) === null || _current_ === void 0 ? void 0 : _current_.dropEffect;
    if (innerMost != null && event.dataTransfer) event.dataTransfer.dropEffect = innerMost;
}
function getStartLocation(param) {
    var event = param.event, dragType = param.dragType, getDropTargetsOver = param.getDropTargetsOver;
    var input = (0, _getInput.getInput)(event);
    // When dragging from outside of the browser,
    // the drag is not being sourced from any local drop targets
    if (dragType.startedFrom === 'external') return {
        input: input,
        dropTargets: []
    };
    var dropTargets = getDropTargetsOver({
        input: input,
        source: dragType.payload,
        target: event.target,
        current: []
    });
    return {
        input: input,
        dropTargets: dropTargets
    };
}
var lifecycle = {
    canStart: canStart,
    start: start
};

},{"@swc/helpers/_/_to_consumable_array":"1eSZf","bind-event-listener":"bjeUU","../honey-pot-fix/get-element-from-point-without-honey-pot":"h7BUI","../honey-pot-fix/is-honey-pot-element":"3CYqW","../util/changing-window/is-leaving-window":"eM6ar","../util/detect-broken-drag":"bwqjB","../util/get-input":"eC2su","./dispatch-consumer-event":"3rUjc","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eM6ar":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isLeavingWindow", function() {
    return isLeavingWindow;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
var _isFirefox = require("../is-firefox");
var _isSafari = require("../is-safari");
var _countEventsForSafari = require("./count-events-for-safari");
var _isFromAnotherWindow = require("./is-from-another-window");
function isLeavingWindow(param) {
    var dragLeave = param.dragLeave;
    var type = dragLeave.type, relatedTarget = dragLeave.relatedTarget;
    if (type !== 'dragleave') return false;
    if ((0, _isSafari.isSafari)()) return (0, _countEventsForSafari.isLeavingWindowInSafari)({
        dragLeave: dragLeave
    });
    // Standard check: if going to `null` we are leaving the `window`
    if (relatedTarget == null) return true;
    /**
	 * 🦊 Exception: `iframe` in Firefox (`125.0`)
	 *
	 * Case 1: parent `window` → child `iframe`
	 * `dragLeave.relatedTarget` is element _inside_ the child `iframe`
	 * (foreign element)
	 *
	 * Case 2: child `iframe` → parent `window`
	 * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
	 * (foreign element)
	 */ if ((0, _isFirefox.isFirefox)()) return (0, _isFromAnotherWindow.isFromAnotherWindow)(relatedTarget);
    /**
	 * 🌏 Exception: `iframe` in Chrome (`124.0`)
	 *
	 * Case 1: parent `window` → child `iframe`
	 * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
	 *
	 * Case 2: child `iframe` → parent `window`
	 * `dragLeave.relatedTarget` is `null` *(standard check)*
	 */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return (0, _instanceof._)(relatedTarget, HTMLIFrameElement);
}

},{"@swc/helpers/_/_instanceof":"h9UKc","../is-firefox":"e1jES","../is-safari":"dBlxP","./count-events-for-safari":"l6xRq","./is-from-another-window":"7KjZz","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"e1jES":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isFirefox", function() {
    return isFirefox;
});
var _once = require("../public-utils/once");
var isFirefox = (0, _once.once)(function isFirefox() {
    return navigator.userAgent.includes('Firefox');
});

},{"../public-utils/once":"17t1P","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dBlxP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isSafari", function() {
    return isSafari;
});
var _once = require("../public-utils/once");
var isSafari = (0, _once.once)(function isSafari() {
    var userAgent = navigator.userAgent;
    return userAgent.includes('AppleWebKit') && !userAgent.includes('Chrome');
});

},{"../public-utils/once":"17t1P","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"l6xRq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isEnteringWindowInSafari", function() {
    return isEnteringWindowInSafari;
});
parcelHelpers.export(exports, "isLeavingWindowInSafari", function() {
    return isLeavingWindowInSafari;
});
var _bindEventListener = require("bind-event-listener");
var _isSafari = require("../is-safari");
/* For "dragenter" events, the browser should set `relatedTarget` to the previous element.
 * For external drag operations, our first "dragenter" event should have a `event.relatedTarget` of `null`.
 *
 *  Unfortunately in Safari `event.relatedTarget` is *always* set to `null`
 *  Safari bug: https://bugs.webkit.org/show_bug.cgi?id=242627
 *  To work around this we count "dragenter" and "dragleave" events */ // Using symbols for event properties so we don't clash with
// anything on the `event` object
var symbols = {
    isLeavingWindow: Symbol('leaving'),
    isEnteringWindow: Symbol('entering')
};
function isEnteringWindowInSafari(param) {
    var dragEnter = param.dragEnter;
    if (!(0, _isSafari.isSafari)()) return false;
    return dragEnter.hasOwnProperty(symbols.isEnteringWindow);
}
function isLeavingWindowInSafari(param) {
    var dragLeave = param.dragLeave;
    if (!(0, _isSafari.isSafari)()) return false;
    return dragLeave.hasOwnProperty(symbols.isLeavingWindow);
}
(function fixSafari() {
    // Don't do anything when server side rendering
    if (typeof window === 'undefined') return;
    if (!(0, _isSafari.isSafari)()) return;
    function getInitialState() {
        return {
            enterCount: 0,
            isOverWindow: false
        };
    }
    var state = getInitialState();
    function resetState() {
        state = getInitialState();
    }
    // These event listeners are bound _forever_ and _never_ removed
    // We don't bother cleaning up these event listeners (for now)
    // as this workaround is only for Safari
    // This is how the event count works:
    //
    // lift (+1 enterCount)
    // - dragstart(draggable) [enterCount: 0]
    // - dragenter(draggable) [enterCount: 1]
    // leaving draggable (+0 enterCount)
    // - dragenter(document.body) [enterCount: 2]
    // - dragleave(draggable) [enterCount: 1]
    // leaving window (-1 enterCount)
    // - dragleave(document.body) [enterCount: 0] {leaving the window}
    // Things to note:
    // - dragenter and dragleave bubble
    // - the first dragenter when entering a window might not be on `window`
    //   - it could be on an element that is pressed up against the window
    //   - (so we cannot rely on `event.target` values)
    (0, _bindEventListener.bindAll)(window, [
        {
            type: 'dragstart',
            listener: function() {
                state.enterCount = 0;
                // drag start occurs in the source window
                state.isOverWindow = true;
            // When a drag first starts it will also trigger a "dragenter" on the draggable element
            }
        },
        {
            type: 'drop',
            listener: resetState
        },
        {
            type: 'dragend',
            listener: resetState
        },
        {
            type: 'dragenter',
            listener: function(event) {
                if (!state.isOverWindow && state.enterCount === 0) // Patching the `event` object
                // The `event` object is shared with all event listeners for the event
                event[symbols.isEnteringWindow] = true;
                state.isOverWindow = true;
                state.enterCount++;
            }
        },
        {
            type: 'dragleave',
            listener: function(event) {
                state.enterCount--;
                if (state.isOverWindow && state.enterCount === 0) {
                    // Patching the `event` object as it is shared with all event listeners
                    // The `event` object is shared with all event listeners for the event
                    event[symbols.isLeavingWindow] = true;
                    state.isOverWindow = false;
                }
            }
        }
    ], // using `capture: true` so that adding event listeners
    // in bubble phase will have the correct symbols
    {
        capture: true
    });
})();

},{"bind-event-listener":"bjeUU","../is-safari":"dBlxP","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7KjZz":[function(require,module,exports,__globalThis) {
/**
 * Does the `EventTarget` look like a `Node` based on "duck typing".
 *
 * Helpful when the `Node` might be outside of the current document
 * so we cannot to an `target instanceof Node` check.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Is an `EventTarget` a `Node` from another `window`?
 */ parcelHelpers.export(exports, "isFromAnotherWindow", function() {
    return isFromAnotherWindow;
});
function isNodeLike(target) {
    return 'nodeName' in target;
}
function isFromAnotherWindow(eventTarget) {
    return isNodeLike(eventTarget) && eventTarget.ownerDocument !== document;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bwqjB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getBindingsForBrokenDrags", function() {
    return getBindingsForBrokenDrags;
});
function getBindingsForBrokenDrags(param) {
    var onDragEnd = param.onDragEnd;
    return [
        // ## Detecting drag ending for removed draggables
        //
        // If a draggable element is removed during a drag and the user drops:
        // 1. if over a valid drop target: we get a "drop" event to know the drag is finished
        // 2. if not over a valid drop target (or cancelled): we get nothing
        // The "dragend" event will not fire on the source draggable if it has been
        // removed from the DOM.
        // So we need to figure out if a drag operation has finished by looking at other events
        // We can do this by looking at other events
        // ### First detection: "pointermove" events
        // 1. "pointermove" events cannot fire during a drag and drop operation
        // according to the spec. So if we get a "pointermove" it means that
        // the drag and drop operations has finished. So if we get a "pointermove"
        // we know that the drag is over
        // 2. 🦊😤 Drag and drop operations are _supposed_ to suppress
        // other pointer events. However, firefox will allow a few
        // pointer event to get through after a drag starts.
        // The most I've seen is 3
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    onDragEnd();
                };
            }()
        },
        // ### Second detection: "pointerdown" events
        // If we receive this event then we know that a drag operation has finished
        // and potentially another one is about to start.
        // Note: `pointerdown` fires on all browsers / platforms before "dragstart"
        {
            type: 'pointerdown',
            listener: onDragEnd
        }
    ];
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eC2su":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getInput", function() {
    return getInput;
});
function getInput(event) {
    return {
        altKey: event.altKey,
        button: event.button,
        buttons: event.buttons,
        ctrlKey: event.ctrlKey,
        metaKey: event.metaKey,
        shiftKey: event.shiftKey,
        clientX: event.clientX,
        clientY: event.clientY,
        pageX: event.pageX,
        pageY: event.pageY
    };
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3rUjc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeDispatch", function() {
    return makeDispatch;
});
var _rafSchd = require("raf-schd");
var _rafSchdDefault = parcelHelpers.interopDefault(_rafSchd);
var scheduleOnDrag = (0, _rafSchdDefault.default)(function(fn) {
    return fn();
});
var dragStart = function() {
    var scheduled = null;
    function schedule(fn) {
        var frameId = requestAnimationFrame(function() {
            scheduled = null;
            fn();
        });
        scheduled = {
            frameId: frameId,
            fn: fn
        };
    }
    function flush() {
        if (scheduled) {
            cancelAnimationFrame(scheduled.frameId);
            scheduled.fn();
            scheduled = null;
        }
    }
    return {
        schedule: schedule,
        flush: flush
    };
}();
function makeDispatch(param) {
    var source = param.source, initial = param.initial, dispatchEvent = param.dispatchEvent;
    var previous = {
        dropTargets: []
    };
    function safeDispatch(args) {
        dispatchEvent(args);
        previous = {
            dropTargets: args.payload.location.current.dropTargets
        };
    }
    var dispatch = {
        start: function start(param) {
            var nativeSetDragImage = param.nativeSetDragImage;
            // Ensuring that both `onGenerateDragPreview` and `onDragStart` get the same location.
            // We do this so that `previous` is`[]` in `onDragStart` (which is logical)
            var location = {
                current: initial,
                previous: previous,
                initial: initial
            };
            // a `onGenerateDragPreview` does _not_ add another entry for `previous`
            // onDragPreview
            safeDispatch({
                eventName: 'onGenerateDragPreview',
                payload: {
                    source: source,
                    location: location,
                    nativeSetDragImage: nativeSetDragImage
                }
            });
            dragStart.schedule(function() {
                safeDispatch({
                    eventName: 'onDragStart',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        dragUpdate: function dragUpdate(param) {
            var current = param.current;
            dragStart.flush();
            scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDropTargetChange',
                payload: {
                    source: source,
                    location: {
                        initial: initial,
                        previous: previous,
                        current: current
                    }
                }
            });
        },
        drag: function drag(param) {
            var current = param.current;
            scheduleOnDrag(function() {
                dragStart.flush();
                var location = {
                    initial: initial,
                    previous: previous,
                    current: current
                };
                safeDispatch({
                    eventName: 'onDrag',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        drop: function drop(param) {
            var current = param.current, updatedSourcePayload = param.updatedSourcePayload;
            dragStart.flush();
            scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDrop',
                payload: {
                    source: updatedSourcePayload !== null && updatedSourcePayload !== void 0 ? updatedSourcePayload : source,
                    location: {
                        current: current,
                        previous: previous,
                        initial: initial
                    }
                }
            });
        }
    };
    return dispatch;
}

},{"raf-schd":"oiTmD","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"oiTmD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
exports.default = rafSchd;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bB7G7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "register", function() {
    return register;
});
var ledger = new Map();
function registerUsage(param) {
    var typeKey = param.typeKey, mount = param.mount;
    var entry = ledger.get(typeKey);
    if (entry) {
        entry.usageCount++;
        return entry;
    }
    var initial = {
        typeKey: typeKey,
        unmount: mount(),
        usageCount: 1
    };
    ledger.set(typeKey, initial);
    return initial;
}
function register(args) {
    var entry = registerUsage(args);
    return function unregister() {
        entry.usageCount--;
        if (entry.usageCount > 0) return;
        // Only a single usage left, remove it
        entry.unmount();
        ledger.delete(args.typeKey);
    };
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bgj4T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeDropTarget", function() {
    return makeDropTarget;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _combine = require("../public-utils/combine");
var _once = require("../public-utils/once");
var _addAttribute = require("../util/add-attribute");
function copyReverse(array) {
    return array.slice(0).reverse();
}
function makeDropTarget(param) {
    var typeKey = param.typeKey, defaultDropEffect = param.defaultDropEffect;
    var registry = new WeakMap();
    var dropTargetDataAtt = "data-drop-target-for-".concat(typeKey);
    var dropTargetSelector = "[".concat(dropTargetDataAtt, "]");
    function addToRegistry(args) {
        registry.set(args.element, args);
        return function() {
            return registry.delete(args.element);
        };
    }
    function dropTargetForConsumers(args) {
        var cleanup = (0, _combine.combine)((0, _addAttribute.addAttribute)(args.element, {
            attribute: dropTargetDataAtt,
            value: 'true'
        }), addToRegistry(args));
        // Wrapping in `once` to prevent unexpected side effects if consumers call
        // the clean up function multiple times.
        return (0, _once.once)(cleanup);
    }
    function getActualDropTargets(param) {
        var source = param.source, target = param.target, input = param.input, _param_result = param.result, result = _param_result === void 0 ? [] : _param_result;
        var _args_getData, _args_getDropEffect;
        if (target == null) return result;
        if (!(0, _instanceof._)(target, Element)) {
            // For "text-selection" drags, the original `target`
            // is not an `Element`, so we need to start looking from
            // the parent element
            if ((0, _instanceof._)(target, Node)) return getActualDropTargets({
                source: source,
                target: target.parentElement,
                input: input,
                result: result
            });
            // not sure what we are working with,
            // so we can exit.
            return result;
        }
        var closest = target.closest(dropTargetSelector);
        // Cannot find anything else
        if (closest == null) return result;
        var args = registry.get(closest);
        // error: something had a dropTargetSelector but we could not
        // find a match. For now, failing silently
        if (args == null) return result;
        var feedback = {
            input: input,
            source: source,
            element: args.element
        };
        // if dropping is not allowed, skip this drop target
        // and continue looking up the DOM tree
        if (args.canDrop && !args.canDrop(feedback)) return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            result: result
        });
        var _args_getData1;
        // calculate our new record
        var data = (_args_getData1 = (_args_getData = args.getData) === null || _args_getData === void 0 ? void 0 : _args_getData.call(args, feedback)) !== null && _args_getData1 !== void 0 ? _args_getData1 : {};
        var _args_getDropEffect1;
        var dropEffect = (_args_getDropEffect1 = (_args_getDropEffect = args.getDropEffect) === null || _args_getDropEffect === void 0 ? void 0 : _args_getDropEffect.call(args, feedback)) !== null && _args_getDropEffect1 !== void 0 ? _args_getDropEffect1 : defaultDropEffect;
        var record = {
            data: data,
            element: args.element,
            dropEffect: dropEffect,
            // we are collecting _actual_ drop targets, so these are
            // being applied _not_ due to stickiness
            isActiveDueToStickiness: false
        };
        return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            // Using bubble ordering. Same ordering as `event.getPath()`
            result: (0, _toConsumableArray._)(result).concat([
                record
            ])
        });
    }
    function notifyCurrent(param) {
        var eventName = param.eventName, payload = param.payload;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = payload.location.current.dropTargets[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var record = _step.value;
                var _entry_eventName;
                var entry = registry.get(record.element);
                var args = (0, _objectSpreadProps._)((0, _objectSpread._)({}, payload), {
                    self: record
                });
                entry === null || entry === void 0 ? void 0 : (_entry_eventName = entry[eventName]) === null || _entry_eventName === void 0 ? void 0 : _entry_eventName.call(entry, // I cannot seem to get the types right here.
                // TS doesn't seem to like that one event can need `nativeSetDragImage`
                // @ts-expect-error
                args);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    var actions = {
        onGenerateDragPreview: notifyCurrent,
        onDrag: notifyCurrent,
        onDragStart: notifyCurrent,
        onDrop: notifyCurrent,
        onDropTargetChange: function(param) {
            var payload = param.payload;
            var isCurrent = new Set(payload.location.current.dropTargets.map(function(record) {
                return record.element;
            }));
            var visited = new Set();
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = payload.location.previous.dropTargets[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var record = _step.value;
                    var _entry_onDropTargetChange, _entry_onDragLeave;
                    visited.add(record.element);
                    var entry = registry.get(record.element);
                    var isOver = isCurrent.has(record.element);
                    var args = (0, _objectSpreadProps._)((0, _objectSpread._)({}, payload), {
                        self: record
                    });
                    entry === null || entry === void 0 ? void 0 : (_entry_onDropTargetChange = entry.onDropTargetChange) === null || _entry_onDropTargetChange === void 0 ? void 0 : _entry_onDropTargetChange.call(entry, args);
                    // if we cannot find the drop target in the current array, then it has been left
                    if (!isOver) entry === null || entry === void 0 ? void 0 : (_entry_onDragLeave = entry.onDragLeave) === null || _entry_onDragLeave === void 0 ? void 0 : _entry_onDragLeave.call(entry, args);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = payload.location.current.dropTargets[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var record1 = _step1.value;
                    var _entry_onDropTargetChange1, _entry_onDragEnter;
                    // already published an update to this drop target
                    if (visited.has(record1.element)) continue;
                    // at this point we have a new drop target that is being entered into
                    var args1 = (0, _objectSpreadProps._)((0, _objectSpread._)({}, payload), {
                        self: record1
                    });
                    var entry1 = registry.get(record1.element);
                    entry1 === null || entry1 === void 0 ? void 0 : (_entry_onDropTargetChange1 = entry1.onDropTargetChange) === null || _entry_onDropTargetChange1 === void 0 ? void 0 : _entry_onDropTargetChange1.call(entry1, args1);
                    entry1 === null || entry1 === void 0 ? void 0 : (_entry_onDragEnter = entry1.onDragEnter) === null || _entry_onDragEnter === void 0 ? void 0 : _entry_onDragEnter.call(entry1, args1);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    };
    function dispatchEvent(args) {
        actions[args.eventName](args);
    }
    function getIsOver(param) {
        var source = param.source, target = param.target, input = param.input, current = param.current;
        var actual = getActualDropTargets({
            source: source,
            target: target,
            input: input
        });
        // stickiness is only relevant when we have less
        // drop targets than we did before
        if (actual.length >= current.length) return actual;
        // less 'actual' drop targets than before,
        // we need to see if 'stickiness' applies
        // An old drop target will continue to be dropped on if:
        // 1. it has the same parent
        // 2. nothing exists in it's previous index
        var lastCaptureOrdered = copyReverse(current);
        var actualCaptureOrdered = copyReverse(actual);
        var resultCaptureOrdered = [];
        for(var index = 0; index < lastCaptureOrdered.length; index++){
            var _argsForLast_getIsSticky;
            var last = lastCaptureOrdered[index];
            var fresh = actualCaptureOrdered[index];
            // if a record is in the new index -> use that
            // it will have the latest data + dropEffect
            if (fresh != null) {
                resultCaptureOrdered.push(fresh);
                continue;
            }
            // At this point we have no drop target in the old spot
            // Check to see if we can use a previous sticky drop target
            // The "parent" is the one inside of `resultCaptureOrdered`
            // (the parent might be a drop target that was sticky)
            var parent = resultCaptureOrdered[index - 1];
            var lastParent = lastCaptureOrdered[index - 1];
            // Stickiness is based on parent relationships, so if the parent relationship has change
            // then we can stop our search
            if ((parent === null || parent === void 0 ? void 0 : parent.element) !== (lastParent === null || lastParent === void 0 ? void 0 : lastParent.element)) break;
            // We need to check whether the old drop target can still be dropped on
            var argsForLast = registry.get(last.element);
            // We cannot drop on a drop target that is no longer mounted
            if (!argsForLast) break;
            var feedback = {
                input: input,
                source: source,
                element: argsForLast.element
            };
            // We cannot drop on a drop target that no longer allows being dropped on
            if (argsForLast.canDrop && !argsForLast.canDrop(feedback)) break;
            // We cannot drop on a drop target that is no longer sticky
            if (!((_argsForLast_getIsSticky = argsForLast.getIsSticky) === null || _argsForLast_getIsSticky === void 0 ? void 0 : _argsForLast_getIsSticky.call(argsForLast, feedback))) break;
            // Note: intentionally not recollecting `getData()` or `getDropEffect()`
            // Previous values for `data` and `dropEffect` will be borrowed
            // This is to prevent things like the 'closest edge' changing when
            // no longer over a drop target.
            // We could change our mind on this behaviour in the future
            resultCaptureOrdered.push((0, _objectSpreadProps._)((0, _objectSpread._)({}, last), {
                // making it clear to consumers this drop target is active due to stickiness
                isActiveDueToStickiness: true
            }));
        }
        // return bubble ordered result
        return copyReverse(resultCaptureOrdered);
    }
    return {
        dropTargetForConsumers: dropTargetForConsumers,
        getIsOver: getIsOver,
        dispatchEvent: dispatchEvent
    };
}

},{"@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_to_consumable_array":"1eSZf","../public-utils/combine":"hR4cH","../public-utils/once":"17t1P","../util/add-attribute":"28GTp","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"28GTp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addAttribute", function() {
    return addAttribute;
});
function addAttribute(element, param) {
    var attribute = param.attribute, value = param.value;
    element.setAttribute(attribute, value);
    return function() {
        return element.removeAttribute(attribute);
    };
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fyeyg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeMonitor", function() {
    return makeMonitor;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _once = require("../public-utils/once");
function makeMonitor() {
    var registry = new Set();
    var dragging = null;
    function tryAddToActive(monitor) {
        if (!dragging) return;
        // Monitor is allowed to monitor events if:
        // 1. It has no `canMonitor` function (default is that a monitor can listen to everything)
        // 2. `canMonitor` returns true
        if (!monitor.canMonitor || monitor.canMonitor(dragging.canMonitorArgs)) dragging.active.add(monitor);
    }
    function monitorForConsumers(args) {
        // We are giving each `args` a new reference so that you
        // can create multiple monitors with the same `args`.
        var entry = (0, _objectSpread._)({}, args);
        registry.add(entry);
        // if there is an active drag we need to see if this new monitor is relevant
        tryAddToActive(entry);
        function cleanup() {
            registry.delete(entry);
            // We need to stop publishing events during a drag to this monitor!
            if (dragging) dragging.active.delete(entry);
        }
        // Wrapping in `once` to prevent unexpected side effects if consumers call
        // the clean up function multiple times.
        return (0, _once.once)(cleanup);
    }
    function dispatchEvent(param) {
        var eventName = param.eventName, payload = param.payload;
        var // @ts-expect-error: I cannot get this type working!
        _monitor_eventName;
        if (eventName === 'onGenerateDragPreview') {
            dragging = {
                canMonitorArgs: {
                    initial: payload.location.initial,
                    source: payload.source
                },
                active: new Set()
            };
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = registry[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var monitor = _step.value;
                    tryAddToActive(monitor);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        // This should never happen.
        if (!dragging) return;
        // Creating an array from the set _before_ iterating
        // This is so that monitors added during the current event will not be called.
        // This behaviour matches native EventTargets where an event listener
        // cannot add another event listener during an active event to the same
        // event target in the same event (for us we have a single global event target)
        var active = Array.from(dragging.active);
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = active[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var monitor1 = _step1.value;
                // A monitor can be removed by another monitor during an event.
                // We need to check that the monitor is still registered before calling it
                if (dragging.active.has(monitor1)) (_monitor_eventName = monitor1[eventName]) === null || _monitor_eventName === void 0 ? void 0 : _monitor_eventName.call(monitor1, payload);
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        if (eventName === 'onDrop') {
            dragging.active.clear();
            dragging = null;
        }
    }
    return {
        dispatchEvent: dispatchEvent,
        monitorForConsumers: monitorForConsumers
    };
}

},{"@swc/helpers/_/_object_spread":"9gdrV","../public-utils/once":"17t1P","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dls44":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isAndroid", function() {
    return isAndroid;
});
parcelHelpers.export(exports, "androidFallbackText", function() {
    return androidFallbackText;
});
var _once = require("../public-utils/once");
var isAndroid = (0, _once.once)(function isAndroid() {
    return navigator.userAgent.toLocaleLowerCase().includes('android');
});
var androidFallbackText = 'pdnd:android-fallback';

},{"../public-utils/once":"17t1P","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7cAH9":[function(require,module,exports,__globalThis) {
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "textMediaType", function() {
    return textMediaType;
});
var textMediaType = 'text/plain';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aGF3O":[function(require,module,exports,__globalThis) {
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "URLMediaType", function() {
    return URLMediaType;
});
var URLMediaType = 'text/uri-list';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dJH0T":[function(require,module,exports,__globalThis) {
/**
 * This key has been pulled into a separate module
 * so that the external adapter does not need to import
 * the element adapter
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "elementAdapterNativeDataKey", function() {
    return elementAdapterNativeDataKey;
});
var elementAdapterNativeDataKey = 'application/vnd.pdnd';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ffb6W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isPanelSplitterDragData", function() {
    return isPanelSplitterDragData;
});
var _panelSplitterDragSymbol = require("./panel-splitter-drag-symbol");
function isPanelSplitterDragData(data) {
    return data[0, _panelSplitterDragSymbol.panelSplitterDragDataSymbol] === true;
}

},{"./panel-splitter-drag-symbol":"54k9C","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"54k9C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "panelSplitterDragDataSymbol", function() {
    return panelSplitterDragDataSymbol;
});
var panelSplitterDragDataSymbol = Symbol('panel-splitter-drag-data');

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cOVYJ":[function(require,module,exports,__globalThis) {
/**
 * Returns the `fallbackWidth` if the provided `defaultWidthProp` is not an integer value.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSafeDefaultWidth", function() {
    return useSafeDefaultWidth;
});
function useSafeDefaultWidth(param) {
    var defaultWidthProp = param.defaultWidthProp, fallbackDefaultWidth = param.fallbackDefaultWidth, slotName = param.slotName;
    // If the provided `defaultWidth` is invalid then we use our fallback.
    // We are using a runtime check because some invalid numbers like `NaN` are not caught by types,
    // and we saw some issues in products where our experience broke due to this.
    if (!Number.isInteger(defaultWidthProp)) return fallbackDefaultWidth;
    return defaultWidthProp;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"j49hL":[function(require,module,exports,__globalThis) {
/* root.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gridRootId", function() {
    return gridRootId;
});
/**
 * The root component of the navigation system. It wraps the underlying components with the necessary contexts allowing to use certain data and hooks
 * @param skipLinksLabel - The very first element of the layout is a skip links container that can be accessed by pressing Tab button and holds the links to the other sections of the layout thus improving accessibility. This parameter defines the header text for this container
 */ parcelHelpers.export(exports, "Root", function() {
    return Root;
});
var _jsxRuntime = require("react/jsx-runtime");
var _runtime = require("@compiled/react/runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _openLayerObserver = require("@atlaskit/layering/experimental/open-layer-observer");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _skipLinksProvider = require("../../context/skip-links/skip-links-provider");
var _topNavStartContextProvider = require("../../context/top-nav-start/top-nav-start-context-provider");
var _hoistSlotSizesContext = require("./hoist-slot-sizes-context");
var _isSideNavShortcutEnabledProvider = require("./side-nav/is-side-nav-shortcut-enabled-provider");
var _sideNavElementProvider = require("./side-nav/side-nav-element-provider");
var _toggleButtonProvider = require("./side-nav/toggle-button-provider");
var _visibilityProvider = require("./side-nav/visibility-provider");
var gridRootId = 'unsafe-design-system-page-layout-root';
var styles = {
    root: "_1e0c11p5 _1tke1kxc _1lmcq9em _yv0ei47z _2z0516ab _1ciragmp _12fk1aio _12qzrxre _1rqteala _xkmgks3h _jbc7rxre _tyve1nco"
};
function Root(param) {
    var children = param.children, xcss = param.xcss, _param_UNSAFE_dangerouslyHoistSlotSizes = param.UNSAFE_dangerouslyHoistSlotSizes, UNSAFE_dangerouslyHoistSlotSizes = _param_UNSAFE_dangerouslyHoistSlotSizes === void 0 ? false : _param_UNSAFE_dangerouslyHoistSlotSizes, _param_skipLinksLabel = param.skipLinksLabel, skipLinksLabel = _param_skipLinksLabel === void 0 ? (0, _platformFeatureFlags.fg)('platform_dst_nav4_skip_link_a11y_1') ? 'Skip to' : 'Skip to:' : _param_skipLinksLabel, _param_skipLinksTriggerLabel = param.skipLinksTriggerLabel, skipLinksTriggerLabel = _param_skipLinksTriggerLabel === void 0 ? 'Skip to' : _param_skipLinksTriggerLabel, testId = param.testId, defaultSideNavCollapsed = param.defaultSideNavCollapsed, _param_isSideNavShortcutEnabled = param.isSideNavShortcutEnabled, isSideNavShortcutEnabled = _param_isSideNavShortcutEnabled === void 0 ? false : _param_isSideNavShortcutEnabled;
    var ref = (0, _react.useRef)(null);
    (0, _react.useEffect)(function() {}, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _visibilityProvider.SideNavVisibilityProvider), {
        defaultCollapsed: defaultSideNavCollapsed,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleButtonProvider.SideNavToggleButtonProvider), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sideNavElementProvider.SideNavElementProvider), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _isSideNavShortcutEnabledProvider.IsSideNavShortcutEnabledProvider), {
                    isSideNavShortcutEnabled: isSideNavShortcutEnabled,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _topNavStartContextProvider.TopNavStartProvider), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _openLayerObserver.OpenLayerObserver), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hoistSlotSizesContext.DangerouslyHoistSlotSizes).Provider, {
                                value: UNSAFE_dangerouslyHoistSlotSizes,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skipLinksProvider.SkipLinksProvider), {
                                    label: skipLinksLabel,
                                    triggerLabel: skipLinksTriggerLabel,
                                    testId: testId,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        ref: ref,
                                        className: (0, _runtime.ax)([
                                            styles.root,
                                            xcss
                                        ]),
                                        id: gridRootId,
                                        "data-testid": testId,
                                        children: children
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    });
}

},{"react/jsx-runtime":"bGvcw","@compiled/react/runtime":"d27Vo","react":"ltHCL","@atlaskit/layering/experimental/open-layer-observer":"iPCuE","@atlaskit/platform-feature-flags":"kO5t9","../../context/skip-links/skip-links-provider":"bVZJV","../../context/top-nav-start/top-nav-start-context-provider":"744Eh","./hoist-slot-sizes-context":"7n3AN","./side-nav/is-side-nav-shortcut-enabled-provider":"gFQUJ","./side-nav/side-nav-element-provider":"jRv8h","./side-nav/toggle-button-provider":"dZ7P8","./side-nav/visibility-provider":"jIc5u","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iPCuE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OpenLayerObserver", function() {
    return 0, _openLayerObserver.OpenLayerObserver;
});
parcelHelpers.export(exports, "useNotifyOpenLayerObserver", function() {
    return 0, _useNotifyOpenLayerObserver.useNotifyOpenLayerObserver;
});
parcelHelpers.export(exports, "useOpenLayerObserver", function() {
    return 0, _useOpenLayerObserver.useOpenLayerObserver;
});
parcelHelpers.export(exports, "OpenLayerObserverNamespaceProvider", function() {
    return 0, _openLayerObserverNamespaceProvider.OpenLayerObserverNamespaceProvider;
});
var _openLayerObserver = require("../../components/open-layer-observer/open-layer-observer");
var _useNotifyOpenLayerObserver = require("../../components/open-layer-observer/use-notify-open-layer-observer");
var _useOpenLayerObserver = require("../../components/open-layer-observer/use-open-layer-observer");
var _openLayerObserverNamespaceProvider = require("../../components/open-layer-observer/open-layer-observer-namespace-provider");

},{"../../components/open-layer-observer/open-layer-observer":"5yUzC","../../components/open-layer-observer/use-notify-open-layer-observer":"2bPG9","../../components/open-layer-observer/use-open-layer-observer":false,"../../components/open-layer-observer/open-layer-observer-namespace-provider":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5yUzC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Context provider for observing the number of __open__ layering components (e.g. popups, dropdown menus) under the observer.
 * It uses a stable object to keep track of the number of open layered components - which means the observer will not re-render
 * when the number of layers changes.
 *
 * There should only be one `OpenLayerObserver` in the application. If there are more, the component will throw an error.
 * To track the number of layers in a section of the application, use the `OpenLayerObserverNamespaceProvider` to create a new
 * namespace to group layers.
 *
 * It is intended for use with the `useOpenLayerObserver` hook.
 */ parcelHelpers.export(exports, "OpenLayerObserver", function() {
    return OpenLayerObserver;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
var _openLayerObserverContext = require("./open-layer-observer-context");
/**
 * Layers that are registered without a namespace are grouped under this fallback namespace.
 */ var noNamespaceSymbol = Symbol('no-namespace');
/**
 * Returns the number of open layers across all namespaces.
 * It calculates the sum of the set sizes in the map, which corresponds to the number of open layers.
 */ function getTotalOpenLayerCount(registry) {
    return Array.from(registry.values()).reduce(function(acc, listeners) {
        return acc + listeners.size;
    }, 0);
}
/**
 * Returns the number of layers in the set that match the type filter.
 */ function getLayerCountWithFilter(param) {
    var layers = param.layers, type = param.type;
    return Array.from(layers.values()).filter(function(layer) {
        return layer.type === type;
    }).length;
}
/**
 * Returns the layer count change listeners set for the namespace.
 * If there are no listeners registered for the namespace yet, it creates a new set
 * and adds it to the registry, then returns the new set.
 */ function getListeners(param) {
    var registry = param.registry, namespace = param.namespace;
    // 1. If there are existing listeners for this namespace, return the existing set.
    var existingListeners = registry.get(namespace);
    if (existingListeners) return existingListeners;
    // 2. If there are no existing listeners for this namespace, create a new set for this namespace
    // and add it to the registry, then return the new set.
    var newSet = new Set();
    registry.set(namespace, newSet);
    return newSet;
}
/**
 * Returns an instance of the open layer observer API. It internally keeps track of the number of open layers and
 * exposes methods to get the current count, increment/decrement the count, and subscribe to changes.
 */ function createInternalAPI() {
    /**
	 * The layer count change listeners for each namespace.
	 */ var namespaceToChangeListenerRegistry = new Map();
    /**
	 * The registered layers for each namespace.
	 * Each layer registers with an `onClose` callback, and optionally with a layer type (`type`).
	 * **When the layer is open**, its `onClose`
	 * callback is registered in this set along with its type.
	 *
	 * This data structure is also used determine the number of open layers.
	 */ var namespaceToLayerRegistry = new Map();
    /**
	 * Calls the appropriate layer count change listeners after the number of open layers has changed.
	 */ function callChangeListeners(param) {
        var namespace = param.namespace, newCount = param.newCount;
        // 1. Call listeners registered to the specific namespace
        if (namespace) {
            var listenersForNamespace = namespaceToChangeListenerRegistry.get(namespace);
            // Using `Array.from` to ensure we iterate over a stable list - e.g. in case a listener adds to the registry while we are
            // iterating over it.
            Array.from(listenersForNamespace !== null && listenersForNamespace !== void 0 ? listenersForNamespace : []).forEach(function(listener) {
                return listener({
                    count: newCount
                });
            });
        }
        // 2. Call listeners registered without a specific namespace
        var noNamespaceListeners = namespaceToChangeListenerRegistry.get(noNamespaceSymbol);
        // Return early if no listeners
        if (!noNamespaceListeners) return;
        // For the listeners without a specific namespace, we need to provide the sum of all namespace counts
        // as the callback `count` arg.
        var totalCount = getTotalOpenLayerCount(namespaceToLayerRegistry);
        Array.from(noNamespaceListeners).forEach(function(listener) {
            return listener({
                count: totalCount
            });
        });
    }
    /**
	 * Returns the current count of open layers.
	 *
	 * - If a namespace is provided, the count for that namespace is returned.
	 * - If a type is provided, only layers of that type are counted.
	 * - If both are provided, only layers matching both criteria are counted.
	 * - Otherwise, the sum of all namespace counts is returned.
	 */ function getCount() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, namespace = _ref.namespace, type = _ref.type;
        if (namespace) {
            // 1. A namespace was requested, so we count only layers in that namespace
            var layersForNamespace = namespaceToLayerRegistry.get(namespace);
            if (!layersForNamespace) return 0;
            if (type) // Count layers in the namespace that match the type filter
            return getLayerCountWithFilter({
                layers: layersForNamespace,
                type: type
            });
            // No type filter - just return the size of the set
            return layersForNamespace.size;
        }
        // 2. A specific namespace was not requested, so we count across all namespaces
        if (type) // Count layers in each namespace that match the type filter
        return Array.from(namespaceToLayerRegistry.values()).reduce(function(acc, layers) {
            return acc + getLayerCountWithFilter({
                layers: layers,
                type: type
            });
        }, 0);
        // No type filter - count all layers across all namespaces
        return getTotalOpenLayerCount(namespaceToLayerRegistry);
    }
    /**
	 * Adds a listener that will be called when the number of open layers changes.
	 *
	 * @returns a cleanup function to unsubscribe, which should be called when the component unmounts.
	 */ function onChange(listener) {
        var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, providedNamespace = _ref.namespace;
        /**
		 * We are wrapping the passed listener in a function to ensure that each call to `onChange` creates a unique
		 * function reference. This is to handle scenarios where the same function is provided to several different `onChange`
		 * calls - we want to ensure that each call to `unsubscribe` only removes the specific listener registration that was added.
		 */ function wrapped() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            listener.apply(void 0, (0, _toConsumableArray._)(args));
        }
        var namespace = providedNamespace !== null && providedNamespace !== void 0 ? providedNamespace : noNamespaceSymbol;
        var listenersForNamespace = getListeners({
            namespace: namespace,
            registry: namespaceToChangeListenerRegistry
        });
        listenersForNamespace.add(wrapped);
        return function unsubscribe() {
            listenersForNamespace.delete(wrapped);
            // If there are no listeners for this namespace, remove the registry entry.
            if (listenersForNamespace.size === 0) namespaceToChangeListenerRegistry.delete(namespace);
        };
    }
    /**
	 * Adds a listener to the registry that tells the observer how to close the layer component.
	 * The listener should only be added if the layer is open. This is handled by `useNotifyOpenLayerObserver`.
	 *
	 * All close listeners will be called by the observer when `closeLayers` is called.
	 *
	 * @returns a cleanup function to unsubscribe, which should be called when the component unmounts.
	 */ function onClose(listener, param) {
        var providedNamespace = param.namespace, type = param.type;
        var wrapped = {
            listener: listener,
            type: type
        };
        var namespace = providedNamespace !== null && providedNamespace !== void 0 ? providedNamespace : noNamespaceSymbol;
        var listenersForNamespace = getListeners({
            namespace: namespace,
            registry: namespaceToLayerRegistry
        });
        listenersForNamespace.add(wrapped);
        callChangeListeners({
            namespace: providedNamespace,
            newCount: listenersForNamespace.size
        });
        return function unsubscribe() {
            listenersForNamespace.delete(wrapped);
            callChangeListeners({
                namespace: providedNamespace,
                newCount: listenersForNamespace.size
            });
            // If there are no listeners for this namespace, remove the registry entry.
            if (listenersForNamespace.size === 0) namespaceToLayerRegistry.delete(namespace);
        };
    }
    /**
	 * Closes all open layers registered across all namespaces.
	 */ function closeLayers() {
        // Using `Array.from` to ensure we iterate over a stable list - e.g. in case a listener adds to the registry while we are
        // iterating over it.
        Array.from(namespaceToLayerRegistry.values()).forEach(function(listeners) {
            Array.from(listeners).forEach(function(param) {
                var listener = param.listener;
                return listener();
            });
        });
    }
    var internalAPI = {
        getCount: getCount,
        onChange: onChange,
        onClose: onClose,
        closeLayers: closeLayers
    };
    return internalAPI;
}
function OpenLayerObserver(param) {
    var children = param.children;
    // Using state to ensure a stable reference to a single instance.
    var _useState = (0, _slicedToArray._)((0, _react.useState)(function() {
        return createInternalAPI();
    }), 1), internalAPI = _useState[0];
    var parentContext = (0, _react.useContext)((0, _openLayerObserverContext.OpenLayerObserverContext));
    // We don't expect a parent context. If there is one, that means this component is nested within another `OpenLayerObserver`
    // - which we don't support.
    (0, _tinyInvariantDefault.default)(parentContext === null, '`OpenLayerObserver` cannot be nested within another `OpenLayerObserver`.');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _openLayerObserverContext.OpenLayerObserverContext).Provider, {
        value: internalAPI,
        children: children
    });
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_to_consumable_array":"1eSZf","react/jsx-runtime":"bGvcw","react":"ltHCL","tiny-invariant":"9VWeJ","./open-layer-observer-context":"WWHTl","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"WWHTl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OpenLayerObserverContext", function() {
    return OpenLayerObserverContext;
});
var _react = require("react");
var OpenLayerObserverContext = /*#__PURE__*/ (0, _react.createContext)(null);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2bPG9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Hook that increments/decrements the open layer count when the component mounts/unmounts or becomes visible/hidden.
 * It is used to "notify" the layer observer(s) that a new layer has been added/opened.
 *
 * It takes an object with two arguments:
 * - `isOpen` - used to conditionally update the layer count based on the visibility of the layered component.
 * - `onClose` - callback used to close this layer when the OpenLayerObserver has called `closeLayers`.
 *
 * Example usage:
 * ```tsx
 * const [isOpen, setIsOpen] = useState(false); // State for controlling layer visibility
 * useNotifyLayerObserver({
 *   isOpen,
 *   onClose: () => setIsOpen(false) // Optional callback to close this layer
 * });
 * ```
 */ parcelHelpers.export(exports, "useNotifyOpenLayerObserver", function() {
    return useNotifyOpenLayerObserver;
});
var _react = require("react");
var _openLayerObserverContext = require("./open-layer-observer-context");
var _useOpenLayerObserverNamespace = require("./use-open-layer-observer-namespace");
function useNotifyOpenLayerObserver(param) {
    var isOpen = param.isOpen, type = param.type, onClose = param.onClose;
    var context = (0, _react.useContext)((0, _openLayerObserverContext.OpenLayerObserverContext));
    var namespace = (0, _useOpenLayerObserverNamespace.useOpenLayerObserverNamespace)();
    (0, _react.useEffect)(function() {
        /**
		 * Registers the `onClose` callback with the OpenLayerObserver.
		 */ if (context === null) return;
        if (!isOpen) /**
			 * If the layer is not open, we are not registering the `onClose` callback.
			 * This is important to prevent the `onClose` from being called for layers that
			 * are not open.
			 *
			 * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
			 * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
			 */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}

},{"react":"ltHCL","./open-layer-observer-context":"WWHTl","./use-open-layer-observer-namespace":"6ii9S","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6ii9S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A hook for use within an `OpenLayerObserver` component. It provides access to the namespace of the
 * `OpenLayerObserver`.
 *
 * This is useful for determining the number of layers open within a section of the page, e.g. the SideNav.
 */ parcelHelpers.export(exports, "useOpenLayerObserverNamespace", function() {
    return useOpenLayerObserverNamespace;
});
var _react = require("react");
var _openLayerObserverNamespaceContext = require("./open-layer-observer-namespace-context");
function useOpenLayerObserverNamespace() {
    var namespace = (0, _react.useContext)((0, _openLayerObserverNamespaceContext.OpenLayerObserverNamespaceContext));
    return namespace;
}

},{"react":"ltHCL","./open-layer-observer-namespace-context":"c1GPx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"c1GPx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OpenLayerObserverNamespaceContext", function() {
    return OpenLayerObserverNamespaceContext;
});
var _react = require("react");
var OpenLayerObserverNamespaceContext = /*#__PURE__*/ (0, _react.createContext)(null);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bVZJV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provider for skip links. Should be rendered at the top level of the application.
 *
 * - Provides the context to register/unregister skip links
 * - Renders the skip links container
 */ parcelHelpers.export(exports, "SkipLinksProvider", function() {
    return SkipLinksProvider;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _skipLinksContainer = require("../../components/skip-links/skip-links-container");
var _skipLinksContext = require("./skip-links-context");
var getByDomOrderSortFunction = function() {
    var layoutSlots = Array.from(document.querySelectorAll("[data-layout-slot]"));
    return function(a, b) {
        var _a_listIndex;
        var indexA = (_a_listIndex = a.listIndex) !== null && _a_listIndex !== void 0 ? _a_listIndex : layoutSlots.indexOf(document.getElementById(a.id));
        var _b_listIndex;
        var indexB = (_b_listIndex = b.listIndex) !== null && _b_listIndex !== void 0 ? _b_listIndex : layoutSlots.indexOf(document.getElementById(b.id));
        /**
		 * If they are tied it is because one (or both) is
		 * a custom skiplink with a set index.
		 *
		 * Give the custom skiplink priority.
		 */ if (indexA === indexB) {
            if (a.listIndex !== undefined) return -1;
            else return 1;
        }
        return indexA - indexB;
    };
};
function SkipLinksProvider(param) {
    var children = param.children, label = param.label, triggerLabel = param.triggerLabel, testId = param.testId;
    var _useState = (0, _slicedToArray._)((0, _react.useState)([]), 2), links = _useState[0], setLinks = _useState[1];
    var registerSkipLink = (0, _react.useCallback)(function(skipLinkData) {
        // Don't add duplicate skip links
        setLinks(function(oldLinks) {
            if (oldLinks.some(function(param) {
                var id = param.id;
                return id === skipLinkData.id;
            })) return oldLinks;
            return (0, _toConsumableArray._)(oldLinks).concat([
                skipLinkData
            ]).sort(getByDomOrderSortFunction());
        });
    }, []);
    var unregisterSkipLink = (0, _react.useCallback)(function(id) {
        setLinks(function(links) {
            return links.filter(function(link) {
                return link.id !== id;
            });
        });
    }, []);
    var contextValue = (0, _react.useMemo)(function() {
        var data = {
            registerSkipLink: registerSkipLink,
            unregisterSkipLink: unregisterSkipLink
        };
        return data;
    }, [
        registerSkipLink,
        unregisterSkipLink
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _skipLinksContext.SkipLinksContext).Provider, {
        value: contextValue,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skipLinksContainer.SkipLinksContainer), {
                label: label,
                triggerLabel: triggerLabel,
                testId: testId,
                links: links
            }),
            children
        ]
    });
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_to_consumable_array":"1eSZf","react/jsx-runtime":"bGvcw","react":"ltHCL","../../components/skip-links/skip-links-container":"1IAul","./skip-links-context":"f9dli","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1IAul":[function(require,module,exports,__globalThis) {
/* skip-links-container.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A container element for the skip links.
 *
 * The container element is always rendered in the DOM, but is only visible when
 * focus is within the container.
 *
 * The label is used as the heading of the skip links container. If the provided label is a string
 * comprised only of only whitespace (e.g. '' or ' '), the skip link heading element will be removed.
 *
 * When `platform_dst_nav4_skip_link_a11y_1` is enabled, rendering is delegated to `SkipLinksPopup`.
 */ parcelHelpers.export(exports, "SkipLinksContainer", function() {
    return SkipLinksContainer;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _compiled = require("@atlaskit/primitives/compiled");
var _skipLink = require("./skip-link");
var _skipLinksPopup = require("./skip-links-popup");
var styles = {
    root: "_zulp1b66 _2rko12b0 _1rjcutpp _18zrutpp _1e0c1txw _2lx21bp4 _kqsw1n9t _1e02v47k _152tv47k _bfhk1bhr _16qs130s _1pby1mrw _tzy4idpf _lcxvglyw _1digjh3g _1mygkb7n _18eu1wug",
    skipLinkList: "_zulp1b66 _1e0c1txw _2lx21bp4 _1x8w11lx _2mzuglyw _1pfhze3t _bozgze3t"
};
/**
 * Keydown handler to hide the skip links when escape is pressed.
 *
 * TODO: consider removing this, it doesn't make a lot of sense.
 * The skip links look like a popup but in reality they aren't.
 * Even though we hide them when the user presses Escape, when
 * they press TAB it will reopen the list and move to the next one...
 *
 * One potential option is to use a tree walker to focus on the
 * next focusable element in the DOM (outside the skip links
 * container).
 */ var closeOnEscape = function(event) {
    if (event.key !== 'Escape') return;
    var activeElement = document.activeElement;
    if ((0, _instanceof._)(activeElement, HTMLElement)) activeElement.blur();
};
var assignIndex = function(num, arr) {
    if (!arr.includes(num)) return num;
    return assignIndex(num + 1, arr);
};
/**
 * Sorts an array of skip links by list indexes.
 *
 * Skip links with custom list indexes are positioned first, followed by regular skip links,
 * which are automatically assigned available index positions to avoid conflicts.
 */ function sortSkipLinks(arr) {
    var customLinks = arr.filter(function(link) {
        return Number.isInteger(link.listIndex);
    });
    if (customLinks.length === 0) return arr;
    var usedIndexes = customLinks.map(function(a) {
        return a.listIndex;
    });
    var regularLinksWithIndex = arr.filter(function(link) {
        return link.listIndex === undefined;
    }).map(function(link, index) {
        var listIndex = assignIndex(index, usedIndexes);
        usedIndexes.push(listIndex);
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, link), {
            listIndex: listIndex
        });
    });
    return (0, _toConsumableArray._)(customLinks).concat((0, _toConsumableArray._)(regularLinksWithIndex)).sort(function(a, b) {
        return a.listIndex - b.listIndex;
    });
}
var isOnlyWhitespaceRegex = /^\s*$/;
function SkipLinksContainer(param) {
    var label = param.label, triggerLabel = param.triggerLabel, testId = param.testId, links = param.links;
    var sortedLinks = (0, _react.useMemo)(function() {
        return sortSkipLinks(links);
    }, [
        links
    ]);
    if (sortedLinks.length === 0) return null;
    var isEmptyLabel = isOnlyWhitespaceRegex.test(label);
    if ((0, _platformFeatureFlags.fg)('platform_dst_nav4_skip_link_a11y_1')) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skipLinksPopup.SkipLinksPopup), {
        label: label,
        triggerLabel: triggerLabel,
        testId: testId,
        links: sortedLinks
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        onKeyDown: closeOnEscape,
        "data-testid": testId ? "".concat(testId, "--skip-links-container") : undefined,
        className: (0, _runtime.ax)([
            styles.root
        ]),
        children: [
            !isEmptyLabel && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _compiled.Text), {
                weight: "bold",
                testId: testId ? "".concat(testId, "--skip-links-container--label") : undefined,
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("ol", {
                className: (0, _runtime.ax)([
                    styles.skipLinkList
                ]),
                children: sortedLinks.map(function(param) {
                    var id = param.id, label = param.label, onBeforeNavigate = param.onBeforeNavigate;
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skipLink.SkipLink), {
                        id: id,
                        onBeforeNavigate: onBeforeNavigate,
                        children: label
                    }, id);
                })
            })
        ]
    });
}

},{"@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_to_consumable_array":"1eSZf","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/platform-feature-flags":"kO5t9","@atlaskit/primitives/compiled":"jhQE8","./skip-link":"kAtzi","./skip-links-popup":"i35EU","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jhQE8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Box", function() {
    return 0, _boxDefault.default;
});
parcelHelpers.export(exports, "Inline", function() {
    return 0, _inlineDefault.default;
});
parcelHelpers.export(exports, "Stack", function() {
    return 0, _stackDefault.default;
});
parcelHelpers.export(exports, "Flex", function() {
    return 0, _flexDefault.default;
});
parcelHelpers.export(exports, "Grid", function() {
    return 0, _gridDefault.default;
});
parcelHelpers.export(exports, "Bleed", function() {
    return 0, _bleedDefault.default;
});
parcelHelpers.export(exports, "Text", function() {
    return 0, _textDefault.default;
});
parcelHelpers.export(exports, "MetricText", function() {
    return 0, _metricTextDefault.default;
});
parcelHelpers.export(exports, "Pressable", function() {
    return 0, _pressableDefault.default;
});
parcelHelpers.export(exports, "Anchor", function() {
    return 0, _anchorDefault.default;
});
parcelHelpers.export(exports, "media", function() {
    return 0, _responsive.media;
});
parcelHelpers.export(exports, "UNSAFE_useMediaQuery", function() {
    return 0, _responsive.UNSAFE_useMediaQuery;
});
parcelHelpers.export(exports, "Show", function() {
    return 0, _responsive.Show;
});
parcelHelpers.export(exports, "Hide", function() {
    return 0, _responsive.Hide;
});
parcelHelpers.export(exports, "Focusable", function() {
    return 0, _focusableDefault.default;
});
// TODO: This is still not figured out from before…
parcelHelpers.export(exports, "UNSAFE_useSurface", function() {
    return 0, _surfaceProvider.useSurface;
});
parcelHelpers.export(exports, "UNSAFE_SurfaceContext", function() {
    return 0, _surfaceProvider.SurfaceContext;
});
var _box = require("./components/box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _inline = require("./components/inline");
var _inlineDefault = parcelHelpers.interopDefault(_inline);
var _stack = require("./components/stack");
var _stackDefault = parcelHelpers.interopDefault(_stack);
var _flex = require("./components/flex");
var _flexDefault = parcelHelpers.interopDefault(_flex);
var _grid = require("./components/grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _bleed = require("./components/bleed");
var _bleedDefault = parcelHelpers.interopDefault(_bleed);
var _text = require("./components/text");
var _textDefault = parcelHelpers.interopDefault(_text);
var _metricText = require("./components/metric-text");
var _metricTextDefault = parcelHelpers.interopDefault(_metricText);
var _pressable = require("./components/pressable");
var _pressableDefault = parcelHelpers.interopDefault(_pressable);
var _anchor = require("./components/anchor");
var _anchorDefault = parcelHelpers.interopDefault(_anchor);
var _responsive = require("./responsive");
var _focusable = require("./components/focusable");
var _focusableDefault = parcelHelpers.interopDefault(_focusable);
var _surfaceProvider = require("../utils/surface-provider");

},{"./components/box":"1DFqV","./components/inline":"flxuu","./components/stack":"eQMZ4","./components/flex":"fBTfY","./components/grid":false,"./components/bleed":false,"./components/text":"dz1NT","./components/metric-text":false,"./components/pressable":"6DVHJ","./components/anchor":"6COXQ","./responsive":"wWWmD","./components/focusable":"a1sGT","../utils/surface-provider":"iHj78","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1DFqV":[function(require,module,exports,__globalThis) {
/* box.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _surfaceContext = require("../../utils/surface-context");
var baseStyles = null;
var backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhkkuup",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1gf0",
    'color.background.accent.lime.subtler.pressed': "_bfhk2kxc",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhk1jbd",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhkh0j0",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhknbir",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkaffd",
    'color.background.accent.red.subtler.pressed': "_bfhk1j5a",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1fnn",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhk1cl6",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtlest.hovered': "_bfhk19yr",
    'color.background.accent.orange.subtlest.pressed': "_bfhkf90x",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtler.hovered': "_bfhk1ei0",
    'color.background.accent.orange.subtler.pressed': "_bfhkdpo3",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.subtle.hovered': "_bfhk9mfs",
    'color.background.accent.orange.subtle.pressed': "_bfhkaxpp",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.orange.bolder.hovered': "_bfhk12qo",
    'color.background.accent.orange.bolder.pressed': "_bfhk1fyq",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtlest.hovered': "_bfhkaetg",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk1o1l",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtler.hovered': "_bfhk1uw7",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1r9w",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.subtle.hovered': "_bfhk819w",
    'color.background.accent.yellow.subtle.pressed': "_bfhk1jx0",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk1okt",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkyfny",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhk1e2h",
    'color.background.accent.green.subtler.pressed': "_bfhkybhx",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk1g86",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1j68",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1cxp",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkkwwr",
    'color.background.accent.teal.subtler.pressed': "_bfhk1jb0",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk16zl",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhktor0",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtlest.hovered': "_bfhkdaj9",
    'color.background.accent.blue.subtlest.pressed': "_bfhkxm0g",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtler.hovered': "_bfhk815t",
    'color.background.accent.blue.subtler.pressed': "_bfhkrwxf",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.subtle.hovered': "_bfhk9pr4",
    'color.background.accent.blue.subtle.pressed': "_bfhknpx7",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.blue.bolder.hovered': "_bfhk1vbm",
    'color.background.accent.blue.bolder.pressed': "_bfhk1xwi",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtlest.hovered': "_bfhkkca2",
    'color.background.accent.purple.subtlest.pressed': "_bfhk1jbm",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtler.hovered': "_bfhkattl",
    'color.background.accent.purple.subtler.pressed': "_bfhk3nfk",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.subtle.hovered': "_bfhk8bp1",
    'color.background.accent.purple.subtle.pressed': "_bfhk1cd2",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.purple.bolder.hovered': "_bfhk1af5",
    'color.background.accent.purple.bolder.pressed': "_bfhk6cze",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1ckf",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1axx",
    'color.background.accent.magenta.subtler.pressed': "_bfhk42ri",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk6c15",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkeawv",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtlest.hovered': "_bfhkwejn",
    'color.background.accent.gray.subtlest.pressed': "_bfhk18ut",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtler.hovered': "_bfhk10ef",
    'color.background.accent.gray.subtler.pressed': "_bfhk1rk9",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.subtle.hovered': "_bfhk1nv3",
    'color.background.accent.gray.subtle.pressed': "_bfhkq9tj",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.accent.gray.bolder.hovered': "_bfhkbyip",
    'color.background.accent.gray.bolder.pressed': "_bfhk1van",
    'color.background.disabled': "_bfhkby5v",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhkl4ek",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.hovered': "_bfhkplhp",
    'color.background.neutral.pressed': "_bfhk1gdz",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk1dpa",
    'color.background.neutral.subtle.pressed': "_bfhkfcek",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.neutral.bold.hovered': "_bfhk1ibz",
    'color.background.neutral.bold.pressed': "_bfhkof27",
    'color.background.selected': "_bfhk15s3",
    'color.background.selected.hovered': "_bfhkufnl",
    'color.background.selected.pressed': "_bfhknozp",
    'color.background.selected.bold': "_bfhkjmqp",
    'color.background.selected.bold.hovered': "_bfhk1q28",
    'color.background.selected.bold.pressed': "_bfhk12kk",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.subtlest.hovered': "_bfhk3v15",
    'color.background.brand.subtlest.pressed': "_bfhku02c",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.bold.hovered': "_bfhkhf2y",
    'color.background.brand.bold.pressed': "_bfhkg6ey",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.brand.boldest.hovered': "_bfhklefx",
    'color.background.brand.boldest.pressed': "_bfhk16k6",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1r4b",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk13a9",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.hovered': "_bfhk19zu",
    'color.background.warning.pressed': "_bfhkzr32",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.warning.bold.hovered': "_bfhk1spp",
    'color.background.warning.bold.pressed': "_bfhk4m4m",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.hovered': "_bfhk1vfx",
    'color.background.success.pressed': "_bfhk1wl5",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.success.bold.hovered': "_bfhky7x8",
    'color.background.success.bold.pressed': "_bfhkwcbh",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.hovered': "_bfhk12eq",
    'color.background.discovery.pressed': "_bfhk18vq",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.discovery.bold.hovered': "_bfhkfqeg",
    'color.background.discovery.bold.pressed': "_bfhk1f1m",
    'color.background.information': "_bfhk19ip",
    'color.background.information.hovered': "_bfhk86z5",
    'color.background.information.pressed': "_bfhk1c1j",
    'color.background.information.bold': "_bfhkx4w0",
    'color.background.information.bold.hovered': "_bfhkq2ii",
    'color.background.information.bold.pressed': "_bfhkf89v",
    'color.blanket': "_bfhk1i5c",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkizff",
    'color.skeleton.subtle': "_bfhkvkf5",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk19i6",
    'elevation.surface.pressed': "_bfhk13ro",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk6o2t",
    'elevation.surface.overlay.pressed': "_bfhkm8nx",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk116u",
    'elevation.surface.raised.pressed': "_bfhk14aj",
    'elevation.surface.sunken': "_bfhkhfxm",
    'utility.elevation.surface.current': "_bfhkchd4"
};
var CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l19i6",
    'elevation.surface.pressed': "_1q1l13ro",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l6o2t",
    'elevation.surface.overlay.pressed': "_1q1lm8nx",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l116u",
    'elevation.surface.raised.pressed': "_1q1l14aj",
    'elevation.surface.sunken': "_1q1lhfxm"
};
var paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
var paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
var paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
var paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var Box = /*#__PURE__*/ (0, _react.forwardRef)(function(_param, ref) {
    var tmp = _param.as, Component = tmp === void 0 ? 'div' : tmp, children = _param.children, backgroundColor = _param.backgroundColor, padding = _param.padding, _param_paddingBlock = _param.paddingBlock, paddingBlock = _param_paddingBlock === void 0 ? padding : _param_paddingBlock, _param_paddingBlockStart = _param.paddingBlockStart, paddingBlockStart = _param_paddingBlockStart === void 0 ? paddingBlock : _param_paddingBlockStart, _param_paddingBlockEnd = _param.paddingBlockEnd, paddingBlockEnd = _param_paddingBlockEnd === void 0 ? paddingBlock : _param_paddingBlockEnd, _param_paddingInline = _param.paddingInline, paddingInline = _param_paddingInline === void 0 ? padding : _param_paddingInline, _param_paddingInlineStart = _param.paddingInlineStart, paddingInlineStart = _param_paddingInlineStart === void 0 ? paddingInline : _param_paddingInlineStart, _param_paddingInlineEnd = _param.paddingInlineEnd, paddingInlineEnd = _param_paddingInlineEnd === void 0 ? paddingInline : _param_paddingInlineEnd, style = _param.style, testId = _param.testId, xcss = _param.xcss, htmlAttributes = (0, _objectWithoutProperties._)(_param, [
        "as",
        "children",
        "backgroundColor",
        "padding",
        "paddingBlock",
        "paddingBlockStart",
        "paddingBlockEnd",
        "paddingInline",
        "paddingInlineStart",
        "paddingInlineEnd",
        "style",
        "testId",
        "xcss"
    ]);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, _objectWithoutProperties._)(htmlAttributes, [
        "className"
    ]);
    var node = /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, (0, _objectSpreadProps._)((0, _objectSpread._)({
        style: style,
        // @ts-ignore -- Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, _runtime.ax)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && backgroundColorMap[backgroundColor],
            backgroundColor && isSurfaceToken(backgroundColor) && setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes), {
        "data-testid": testId,
        children: children
    }));
    if (backgroundColor) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _surfaceContext.SurfaceContext).Provider, {
        value: backgroundColor,
        children: node
    });
    return node;
});
exports.default = Box;
function isSurfaceToken(backgroundColor) {
    return backgroundColor in setSurfaceTokenMap;
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","../../utils/surface-context":"gVKA0","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gVKA0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SurfaceContext", function() {
    return SurfaceContext;
});
var _react = require("react");
var SurfaceContext = /*#__PURE__*/ (0, _react.createContext)('elevation.surface');

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"flxuu":[function(require,module,exports,__globalThis) {
/* inline.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _css = require("@atlaskit/css");
var _flex = require("./flex");
var _flexDefault = parcelHelpers.interopDefault(_flex);
var styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
var Separator = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: (0, _runtime.ax)([
            styles.separator
        ]),
        children: children
    });
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var Inline = /*#__PURE__*/ (0, _react.memo)(/*#__PURE__*/ (0, _react.forwardRef)(function(_param, ref) {
    var as = _param.as, alignInline = _param.alignInline, tmp = _param.alignBlock, alignItems = tmp === void 0 ? 'start' : tmp, _param_shouldWrap = _param.shouldWrap, shouldWrap = _param_shouldWrap === void 0 ? false : _param_shouldWrap, spread = _param.spread, grow = _param.grow, space = _param.space, rowSpace = _param.rowSpace, separator = _param.separator, xcss = _param.xcss, testId = _param.testId, role = _param.role, rawChildren = _param.children, ariaAttributes = (0, _objectWithoutProperties._)(_param, [
        "as",
        "alignInline",
        "alignBlock",
        "shouldWrap",
        "spread",
        "grow",
        "space",
        "rowSpace",
        "separator",
        "xcss",
        "testId",
        "role",
        "children"
    ]);
    var separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(Separator, {
        children: separator
    }) : separator;
    var children = separatorComponent ? (0, _react.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
            children: [
                separator && index > 0 ? separatorComponent : null,
                child
            ]
        }, index);
    }) : rawChildren;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _flexDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, ariaAttributes), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: (0, _css.cx)(grow === 'hug' && styles.hug, grow === 'fill' && styles.fill, xcss),
        testId: testId,
        ref: ref,
        children: children
    }));
}));
Inline.displayName = 'Inline';
exports.default = Inline;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/css":"fiaHp","./flex":"fBTfY","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fiaHp":[function(require,module,exports,__globalThis) {
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "jsx", function() {
    return 0, _react1.jsx;
});
parcelHelpers.export(exports, "css", function() {
    return css;
});
parcelHelpers.export(exports, "cssMap", function() {
    return cssMap;
});
parcelHelpers.export(exports, "cx", function() {
    return cx;
});
var _react = require("react");
var _react1 = require("@compiled/react");
var strictApi = (0, _react1.createStrictAPI)();
var css = strictApi.css;
var cssMap = strictApi.cssMap;
strictApi.cssMap;
var cx = strictApi.cx;
var XCSSProp = strictApi.XCSSProp;

},{"react":"ltHCL","@compiled/react":"MfI9Z","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"MfI9Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClassNames", function() {
    return 0, _indexJs.ClassNames;
});
parcelHelpers.export(exports, "createStrictAPI", function() {
    return 0, _indexJs1.createStrictAPI;
});
parcelHelpers.export(exports, "css", function() {
    return 0, _indexJsDefault.default;
});
parcelHelpers.export(exports, "cssMap", function() {
    return 0, _indexJsDefault1.default;
});
parcelHelpers.export(exports, "keyframes", function() {
    return 0, _indexJs4.keyframes;
});
parcelHelpers.export(exports, "styled", function() {
    return 0, _indexJs5.styled;
});
parcelHelpers.export(exports, "cx", function() {
    return 0, _indexJs6.cx;
});
parcelHelpers.export(exports, "jsx", function() {
    return jsx;
});
var _react = require("react");
var _indexJs = require("./class-names/index.js");
var _indexJs1 = require("./create-strict-api/index.js");
var _indexJs2 = require("./css/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./css-map/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./keyframes/index.js");
var _indexJs5 = require("./styled/index.js");
var _indexJs6 = require("./xcss-prop/index.js");
var jsx = (0, _react.createElement);

},{"react":"ltHCL","./class-names/index.js":false,"./create-strict-api/index.js":"asN8e","./css/index.js":false,"./css-map/index.js":false,"./keyframes/index.js":false,"./styled/index.js":false,"./xcss-prop/index.js":"1GqFw","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"asN8e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * ## Create Strict API
 *
 * Returns a strict subset of Compiled APIs augmented by a type definition.
 * This API does not change Compileds build time behavior — merely augmenting
 * the returned API types which enforce:
 *
 * - all APIs use object types
 * - property values declared in the type definition must be used (else fallback to defaults)
 * - a strict subset of pseudo states/selectors
 * - unknown properties to be a type violation
 *
 * To set up:
 *
 * 1. Declare the API in a module (either local or in a package), optionally declaring accepted media queries.
 *
 * @example
 * ```tsx
 * // ./foo.ts
 * interface Schema {
 *   color: 'var(--ds-text)',
 *   '&:hover': { color: 'var(--ds-text-hover)' }
 * }
 *
 * const { css, cssMap, XCSSProp, cx } = createStrictAPI<Schema, { media: '(min-width: 30rem)' }>();
 *
 * export { css, cssMap, XCSSProp, cx };
 * ```
 *
 * 2. Configure Compiled to pick up this module:
 *
 * @example
 * ```diff
 * // .compiledcssrc
 * {
 * +  "importSources": ["./foo.ts"]
 * }
 * ```
 *
 * 3. Use the module in your application code:
 *
 * @example
 * ```tsx
 * import { css } from './foo';
 *
 * const styles = css({ color: 'var(--ds-text)' });
 *
 * <div css={styles} />
 * ```
 */ parcelHelpers.export(exports, "createStrictAPI", function() {
    return createStrictAPI;
});
var _errorJs = require("../utils/error.js");
var _indexJs = require("../xcss-prop/index.js");
function createStrictAPI() {
    return {
        css: function css() {
            throw (0, _errorJs.createStrictSetupError)();
        },
        cssMap: function cssMap() {
            throw (0, _errorJs.createStrictSetupError)();
        },
        cx: (0, _indexJs.cx),
        XCSSProp: function XCSSProp() {
            throw (0, _errorJs.createStrictSetupError)();
        }
    };
}

},{"../utils/error.js":"oNbvf","../xcss-prop/index.js":"1GqFw","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"oNbvf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createSetupError", function() {
    return createSetupError;
});
parcelHelpers.export(exports, "createStrictSetupError", function() {
    return createStrictSetupError;
});
var createSetupError = function() {
    return new Error("\n \u2588\u2588\u2588\u2588\u2588\u2588\u2557 \u2588\u2588\u2588\u2588\u2588\u2588\u2557 \u2588\u2588\u2588\u2557   \u2588\u2588\u2588\u2557\u2588\u2588\u2588\u2588\u2588\u2588\u2557 \u2588\u2588\u2557\u2588\u2588\u2557     \u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2557\u2588\u2588\u2588\u2588\u2588\u2588\u2557\n\u2588\u2588\u2554\u2550\u2550\u2550\u2550\u255D\u2588\u2588\u2554\u2550\u2550\u2550\u2588\u2588\u2557\u2588\u2588\u2588\u2588\u2557 \u2588\u2588\u2588\u2588\u2551\u2588\u2588\u2554\u2550\u2550\u2588\u2588\u2557\u2588\u2588\u2551\u2588\u2588\u2551     \u2588\u2588\u2554\u2550\u2550\u2550\u2550\u255D\u2588\u2588\u2554\u2550\u2550\u2588\u2588\u2557\n\u2588\u2588\u2551     \u2588\u2588\u2551   \u2588\u2588\u2551\u2588\u2588\u2554\u2588\u2588\u2588\u2588\u2554\u2588\u2588\u2551\u2588\u2588\u2588\u2588\u2588\u2588\u2554\u255D\u2588\u2588\u2551\u2588\u2588\u2551     \u2588\u2588\u2588\u2588\u2588\u2557  \u2588\u2588\u2551  \u2588\u2588\u2551\n\u2588\u2588\u2551     \u2588\u2588\u2551   \u2588\u2588\u2551\u2588\u2588\u2551\u255A\u2588\u2588\u2554\u255D\u2588\u2588\u2551\u2588\u2588\u2554\u2550\u2550\u2550\u255D \u2588\u2588\u2551\u2588\u2588\u2551     \u2588\u2588\u2554\u2550\u2550\u255D  \u2588\u2588\u2551  \u2588\u2588\u2551\n\u255A\u2588\u2588\u2588\u2588\u2588\u2588\u2557\u255A\u2588\u2588\u2588\u2588\u2588\u2588\u2554\u255D\u2588\u2588\u2551 \u255A\u2550\u255D \u2588\u2588\u2551\u2588\u2588\u2551     \u2588\u2588\u2551\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2557\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2557\u2588\u2588\u2588\u2588\u2588\u2588\u2554\u255D\n \u255A\u2550\u2550\u2550\u2550\u2550\u255D \u255A\u2550\u2550\u2550\u2550\u2550\u255D \u255A\u2550\u255D     \u255A\u2550\u255D\u255A\u2550\u255D     \u255A\u2550\u255D\u255A\u2550\u2550\u2550\u2550\u2550\u2550\u255D\u255A\u2550\u2550\u2550\u2550\u2550\u2550\u255D\u255A\u2550\u2550\u2550\u2550\u2550\u255D\n\n  @compiled/react\n\n  Code was executed when it shouldn't have. This could have happened because:\n\n  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.\n  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.\n\n  Good luck!\n");
};
var createStrictSetupError = function() {
    return new Error("\n \u2588\u2588\u2588\u2588\u2588\u2588\u2557 \u2588\u2588\u2588\u2588\u2588\u2588\u2557 \u2588\u2588\u2588\u2557   \u2588\u2588\u2588\u2557\u2588\u2588\u2588\u2588\u2588\u2588\u2557 \u2588\u2588\u2557\u2588\u2588\u2557     \u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2557\u2588\u2588\u2588\u2588\u2588\u2588\u2557\n\u2588\u2588\u2554\u2550\u2550\u2550\u2550\u255D\u2588\u2588\u2554\u2550\u2550\u2550\u2588\u2588\u2557\u2588\u2588\u2588\u2588\u2557 \u2588\u2588\u2588\u2588\u2551\u2588\u2588\u2554\u2550\u2550\u2588\u2588\u2557\u2588\u2588\u2551\u2588\u2588\u2551     \u2588\u2588\u2554\u2550\u2550\u2550\u2550\u255D\u2588\u2588\u2554\u2550\u2550\u2588\u2588\u2557\n\u2588\u2588\u2551     \u2588\u2588\u2551   \u2588\u2588\u2551\u2588\u2588\u2554\u2588\u2588\u2588\u2588\u2554\u2588\u2588\u2551\u2588\u2588\u2588\u2588\u2588\u2588\u2554\u255D\u2588\u2588\u2551\u2588\u2588\u2551     \u2588\u2588\u2588\u2588\u2588\u2557  \u2588\u2588\u2551  \u2588\u2588\u2551\n\u2588\u2588\u2551     \u2588\u2588\u2551   \u2588\u2588\u2551\u2588\u2588\u2551\u255A\u2588\u2588\u2554\u255D\u2588\u2588\u2551\u2588\u2588\u2554\u2550\u2550\u2550\u255D \u2588\u2588\u2551\u2588\u2588\u2551     \u2588\u2588\u2554\u2550\u2550\u255D  \u2588\u2588\u2551  \u2588\u2588\u2551\n\u255A\u2588\u2588\u2588\u2588\u2588\u2588\u2557\u255A\u2588\u2588\u2588\u2588\u2588\u2588\u2554\u255D\u2588\u2588\u2551 \u255A\u2550\u255D \u2588\u2588\u2551\u2588\u2588\u2551     \u2588\u2588\u2551\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2557\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2557\u2588\u2588\u2588\u2588\u2588\u2588\u2554\u255D\n \u255A\u2550\u2550\u2550\u2550\u2550\u255D \u255A\u2550\u2550\u2550\u2550\u2550\u255D \u255A\u2550\u255D     \u255A\u2550\u255D\u255A\u2550\u255D     \u255A\u2550\u255D\u255A\u2550\u2550\u2550\u2550\u2550\u2550\u255D\u255A\u2550\u2550\u2550\u2550\u2550\u2550\u255D\u255A\u2550\u2550\u2550\u2550\u2550\u255D\n\n  @compiled/react\n\n  Code was executed when it shouldn't have. To resolve make sure to:\n\n  1. Set up Compiled.\n  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().\n\n  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.\n");
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1GqFw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cx", function() {
    return cx;
});
var _runtimeJs = require("../runtime.js");
var cx = function() {
    for(var _len = arguments.length, styles = new Array(_len), _key = 0; _key < _len; _key++){
        styles[_key] = arguments[_key];
    }
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    var actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, _runtimeJs.ax)(actualStyles);
};

},{"../runtime.js":"d27Vo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fBTfY":[function(require,module,exports,__globalThis) {
/* flex.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
var columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
var justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
var flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
var flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
var alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
var styles = {
    root: "_1e0c1txw _vchhusvi"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var Flex = /*#__PURE__*/ (0, _react.memo)(/*#__PURE__*/ (0, _react.forwardRef)(function(_param, ref) {
    var tmp = _param.as, Component = tmp === void 0 ? 'div' : tmp, role = _param.role, alignItems = _param.alignItems, justifyContent = _param.justifyContent, gap = _param.gap, columnGap = _param.columnGap, rowGap = _param.rowGap, children = _param.children, testId = _param.testId, direction = _param.direction, wrap = _param.wrap, xcss = _param.xcss, ariaAttributes = (0, _objectWithoutProperties._)(_param, [
        "as",
        "role",
        "alignItems",
        "justifyContent",
        "gap",
        "columnGap",
        "rowGap",
        "children",
        "testId",
        "direction",
        "wrap",
        "xcss"
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, (0, _objectSpreadProps._)((0, _objectSpread._)({}, ariaAttributes), {
        role: role,
        className: (0, _runtime.ax)([
            styles.root,
            gap && columnGapMap[gap],
            columnGap && columnGapMap[columnGap],
            gap && rowGapMap[gap],
            rowGap && rowGapMap[rowGap],
            alignItems && alignItemsMap[alignItems],
            direction && flexDirectionMap[direction],
            justifyContent && justifyContentMap[justifyContent],
            wrap && flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref,
        children: children
    }));
}));
Flex.displayName = 'Flex';
exports.default = Flex;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eQMZ4":[function(require,module,exports,__globalThis) {
/* stack.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _css = require("@atlaskit/css");
var _flex = require("./flex");
var _flexDefault = parcelHelpers.interopDefault(_flex);
var styles = {
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var Stack = /*#__PURE__*/ (0, _react.memo)(/*#__PURE__*/ (0, _react.forwardRef)(function(_param, ref) {
    var as = _param.as, alignItems = _param.alignInline, _param_alignBlock = _param.alignBlock, alignBlock = _param_alignBlock === void 0 ? 'stretch' : _param_alignBlock, spread = _param.spread, grow = _param.grow, space = _param.space, children = _param.children, testId = _param.testId, xcss = _param.xcss, role = _param.role, ariaAttributes = (0, _objectWithoutProperties._)(_param, [
        "as",
        "alignInline",
        "alignBlock",
        "spread",
        "grow",
        "space",
        "children",
        "testId",
        "xcss",
        "role"
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _flexDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, ariaAttributes), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: spread || alignBlock,
        xcss: (0, _css.cx)(grow === 'hug' && styles.hug, grow === 'fill' && styles.fill, xcss),
        testId: testId,
        ref: ref,
        children: children
    }));
}));
Stack.displayName = 'Stack';
exports.default = Stack;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react/jsx-runtime":"bGvcw","react":"ltHCL","@atlaskit/css":"fiaHp","./flex":"fBTfY","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dz1NT":[function(require,module,exports,__globalThis) {
/* text.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "inverseColorMap", function() {
    return inverseColorMap;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
var _hasTextAncestorContext = require("../../utils/has-text-ancestor-context");
var _surfaceProvider = require("../../utils/surface-provider");
var asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var useColor = function(colorProp, hasTextAncestor) {
    var surface = (0, _surfaceProvider.useSurface)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if (inverseColorMap.hasOwnProperty(surface)) return inverseColorMap[surface];
    return 'color.text';
};
var styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    'as.strong': "_k48pwu06",
    'as.em': "_zg8l1m30",
    'textAlign.center': "_y3gn1h6o",
    'textAlign.end': "_y3gnh9n0",
    'textAlign.start': "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
var fontSizeMap = {
    medium: "_11c8fhey",
    large: "_11c81d4k",
    small: "_11c8wadc"
};
var fontWeightMap = {
    bold: "_k48pwu06",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
var textColorMap = {
    'color.text': "_syazi7uo",
    'color.text.accent.lime': "_syaz1tco",
    'color.text.accent.lime.bolder': "_syaz1ik3",
    'color.text.accent.red': "_syaz9lu1",
    'color.text.accent.red.bolder': "_syazhwvp",
    'color.text.accent.orange': "_syazp1lv",
    'color.text.accent.orange.bolder': "_syaz7i1p",
    'color.text.accent.yellow': "_syazfb2s",
    'color.text.accent.yellow.bolder': "_syazekll",
    'color.text.accent.green': "_syazh55r",
    'color.text.accent.green.bolder': "_syaz1y78",
    'color.text.accent.teal': "_syaz17qg",
    'color.text.accent.teal.bolder': "_syaz12v7",
    'color.text.accent.blue': "_syaz16jw",
    'color.text.accent.blue.bolder': "_syaz1kyx",
    'color.text.accent.purple': "_syazqmo9",
    'color.text.accent.purple.bolder': "_syaz1mn1",
    'color.text.accent.magenta': "_syaz1s8m",
    'color.text.accent.magenta.bolder': "_syaz1qur",
    'color.text.accent.gray': "_syaz1sqi",
    'color.text.accent.gray.bolder': "_syaz1tmo",
    'color.text.disabled': "_syaz1gmx",
    'color.text.inverse': "_syaz15cr",
    'color.text.selected': "_syaz6x5g",
    'color.text.brand': "_syaz1oa5",
    'color.text.danger': "_syaz1tmw",
    'color.text.warning': "_syaz1xn9",
    'color.text.warning.inverse': "_syaz1yd3",
    'color.text.success': "_syazgsak",
    'color.text.discovery': "_syazdv2p",
    'color.text.information': "_syazu3tg",
    'color.text.subtlest': "_syaz1rpy",
    'color.text.subtle': "_syazazsu",
    'color.link': "_syaz13af",
    'color.link.pressed': "_syaz12zz",
    'color.link.visited': "_syaz1ra0",
    'color.link.visited.pressed': "_syaz17z1"
};
var inverseColorMap = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var Text = /*#__PURE__*/ (0, _react.forwardRef)(function(param, ref) {
    var tmp = param.as, Component = tmp === void 0 ? 'span' : tmp, colorProp = param.color, align = param.align, testId = param.testId, id = param.id, size = param.size, weight = param.weight, maxLines = param.maxLines, xcss = param.xcss, children = param.children;
    (0, _tinyInvariantDefault.default)(asAllowlist.includes(Component), '@atlaskit/primitives: Text received an invalid "as" value of "'.concat(Component, '"'));
    var hasTextAncestor = (0, _hasTextAncestorContext.useHasTextAncestor)();
    var color = useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    var component = /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        id: id,
        className: (0, _runtime.ax)([
            styles.root,
            size && fontSizeMap[size],
            color && textColorMap[color],
            maxLines && styles.truncation,
            maxLines === 1 && styles.breakAll,
            align && styles["textAlign.".concat(align)],
            weight && fontWeightMap[weight],
            Component === 'em' && styles['as.em'],
            Component === 'strong' && styles['as.strong'],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref,
        children: children
    });
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hasTextAncestorContext.HasTextAncestorProvider), {
        value: true,
        children: component
    });
});
exports.default = Text;

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","tiny-invariant":"9VWeJ","../../utils/has-text-ancestor-context":"3E9w3","../../utils/surface-provider":"iHj78","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3E9w3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useHasTextAncestor", function() {
    return useHasTextAncestor;
});
parcelHelpers.export(exports, "HasTextAncestorProvider", function() {
    return HasTextAncestorProvider;
});
var _react = require("react");
var HasTextAncestorContext = /*#__PURE__*/ (0, _react.createContext)(false);
var useHasTextAncestor = function() {
    return (0, _react.useContext)(HasTextAncestorContext);
};
var HasTextAncestorProvider = HasTextAncestorContext.Provider;

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iHj78":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SurfaceContext", function() {
    return 0, _surfaceContext.SurfaceContext;
});
parcelHelpers.export(exports, "useSurface", function() {
    return useSurface;
});
var _react = require("react");
var _surfaceContext = require("./surface-context");
var useSurface = function() {
    return (0, _react.useContext)((0, _surfaceContext.SurfaceContext));
};
(0, _surfaceContext.SurfaceContext).displayName = 'SurfaceProvider';

},{"react":"ltHCL","./surface-context":"gVKA0","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6DVHJ":[function(require,module,exports,__globalThis) {
/* pressable.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _react1 = require("@compiled/react");
var _analyticsNext = require("@atlaskit/analytics-next");
var _isSafari = require("@atlaskit/ds-lib/is-safari");
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var _interactionContext = require("@atlaskit/interaction-context");
var _interactionContextDefault = parcelHelpers.interopDefault(_interactionContext);
var _focusable = require("./focusable");
var _focusableDefault = parcelHelpers.interopDefault(_focusable);
var styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var Pressable = /*#__PURE__*/ (0, _react.forwardRef)(function(_param, ref) {
    var children = _param.children, isDisabled = _param.isDisabled, _param_type = _param.type, type = _param_type === void 0 ? 'button' : _param_type, tmp = _param.onClick, providedOnClick = tmp === void 0 ? (0, _noopDefault.default) : tmp, interactionName = _param.interactionName, componentName = _param.componentName, analyticsContext = _param.analyticsContext, style = _param.style, testId = _param.testId, xcss = _param.xcss, tabIndex = _param.tabIndex, htmlAttributes = (0, _objectWithoutProperties._)(_param, [
        "children",
        "isDisabled",
        "type",
        "onClick",
        "interactionName",
        "componentName",
        "analyticsContext",
        "style",
        "testId",
        "xcss",
        "tabIndex"
    ]);
    var interactionContext = (0, _react.useContext)((0, _interactionContextDefault.default));
    var handleClick = (0, _react.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, _analyticsNext.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: undefined,
        packageVersion: undefined,
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, _objectWithoutProperties._)(htmlAttributes, [
        "className"
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _focusableDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({
        // @ts-ignore -- not using expect since it causes issues with help-center local consumption - we don't allow `button` on Focusable for makers as they should use Pressable instead
        as: "button",
        // Safari does not apply focus to buttons on click like other browsers, which means click events will not be fired.
        // Adding a tabIndex of 0 to the button will allow it to be focused on click.
        // This is a known issue in Safari that is meant to be "intended", see https://bugs.webkit.org/show_bug.cgi?id=22261
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, _isSafari.isSafari)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes), {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, _react1.cx)(styles.root, isDisabled && styles.disabled, xcss),
        testId: testId,
        ref: ref,
        children: children
    }));
});
exports.default = Pressable;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react":"MfI9Z","@atlaskit/analytics-next":"auH4u","@atlaskit/ds-lib/is-safari":"1P4BQ","@atlaskit/ds-lib/noop":"2f3bg","@atlaskit/interaction-context":"4Lyu9","./focusable":"a1sGT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"auH4u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Analytics event classes
parcelHelpers.export(exports, "AnalyticsEvent", function() {
    return 0, _analyticsEventDefault.default;
});
parcelHelpers.export(exports, "isAnalyticsEvent", function() {
    return 0, _analyticsEvent.isAnalyticsEvent;
});
parcelHelpers.export(exports, "UIAnalyticsEvent", function() {
    return 0, _uianalyticsEventDefault.default;
});
parcelHelpers.export(exports, "isUIAnalyticsEvent", function() {
    return 0, _uianalyticsEvent.isUIAnalyticsEvent;
});
// AnalyticsListener component
parcelHelpers.export(exports, "AnalyticsListener", function() {
    return 0, _indexDefault.default;
});
// AnalyticsContext component and HOC
parcelHelpers.export(exports, "AnalyticsContext", function() {
    return 0, _indexDefault1.default;
});
parcelHelpers.export(exports, "withAnalyticsContext", function() {
    return 0, _withAnalyticsContextDefault.default;
});
// AnalyticsErrorBoundary component
parcelHelpers.export(exports, "AnalyticsErrorBoundary", function() {
    return 0, _analyticsErrorBoundaryDefault.default;
});
// createAnalyticsEvent HOC
parcelHelpers.export(exports, "withAnalyticsEvents", function() {
    return 0, _withAnalyticsEventsDefault.default;
});
// React context
parcelHelpers.export(exports, "AnalyticsReactContext", function() {
    return 0, _analyticsReactContextDefault.default;
});
// Hook for creating and firing analytics events
parcelHelpers.export(exports, "useAnalyticsEvents", function() {
    return 0, _useAnalyticsEvents.useAnalyticsEvents;
});
parcelHelpers.export(exports, "useCallbackWithAnalytics", function() {
    return 0, _useCallbackWithAnalytics.useCallbackWithAnalytics;
});
parcelHelpers.export(exports, "usePlatformLeafEventHandler", function() {
    return 0, _usePlatformLeafEventHandler.usePlatformLeafEventHandler;
});
parcelHelpers.export(exports, "usePlatformLeafSyntheticEventHandler", function() {
    return 0, _usePlatformLeafSyntheticEventHandler.usePlatformLeafSyntheticEventHandler;
});
// Helper functions
parcelHelpers.export(exports, "createAndFireEvent", function() {
    return 0, _createAndFireEventDefault.default;
});
parcelHelpers.export(exports, "cleanProps", function() {
    return 0, _cleanPropsDefault.default;
});
// Moved from deprecated @atlaskit/analytics
parcelHelpers.export(exports, "AnalyticsDecorator", function() {
    return 0, _analyticsDecoratorDefault.default;
});
parcelHelpers.export(exports, "AnalyticsDelegate", function() {
    return 0, _analyticsDelegateDefault.default;
});
parcelHelpers.export(exports, "withAnalytics", function() {
    return 0, _withAnalyticsDefault.default;
});
var _analyticsEvent = require("./events/AnalyticsEvent");
var _analyticsEventDefault = parcelHelpers.interopDefault(_analyticsEvent);
var _uianalyticsEvent = require("./events/UIAnalyticsEvent");
var _uianalyticsEventDefault = parcelHelpers.interopDefault(_uianalyticsEvent);
var _index = require("./components/AnalyticsListener/index");
var _indexDefault = parcelHelpers.interopDefault(_index);
var _index1 = require("./components/AnalyticsContext/index");
var _indexDefault1 = parcelHelpers.interopDefault(_index1);
var _withAnalyticsContext = require("./hocs/withAnalyticsContext");
var _withAnalyticsContextDefault = parcelHelpers.interopDefault(_withAnalyticsContext);
var _analyticsErrorBoundary = require("./components/AnalyticsErrorBoundary");
var _analyticsErrorBoundaryDefault = parcelHelpers.interopDefault(_analyticsErrorBoundary);
var _withAnalyticsEvents = require("./hocs/withAnalyticsEvents");
var _withAnalyticsEventsDefault = parcelHelpers.interopDefault(_withAnalyticsEvents);
var _analyticsReactContext = require("./components/AnalyticsReactContext");
var _analyticsReactContextDefault = parcelHelpers.interopDefault(_analyticsReactContext);
var _useAnalyticsEvents = require("./hooks/useAnalyticsEvents");
var _useCallbackWithAnalytics = require("./hooks/useCallbackWithAnalytics");
var _usePlatformLeafEventHandler = require("./hooks/usePlatformLeafEventHandler");
var _usePlatformLeafSyntheticEventHandler = require("./hooks/usePlatformLeafSyntheticEventHandler");
var _createAndFireEvent = require("./utils/createAndFireEvent");
var _createAndFireEventDefault = parcelHelpers.interopDefault(_createAndFireEvent);
var _cleanProps = require("./utils/cleanProps");
var _cleanPropsDefault = parcelHelpers.interopDefault(_cleanProps);
var _analyticsDecorator = require("./components/AnalyticsDecorator");
var _analyticsDecoratorDefault = parcelHelpers.interopDefault(_analyticsDecorator);
var _analyticsDelegate = require("./components/AnalyticsDelegate");
var _analyticsDelegateDefault = parcelHelpers.interopDefault(_analyticsDelegate);
var _withAnalytics = require("./utils/withAnalytics");
var _withAnalyticsDefault = parcelHelpers.interopDefault(_withAnalytics);

},{"./events/AnalyticsEvent":false,"./events/UIAnalyticsEvent":false,"./components/AnalyticsListener/index":"f3eBX","./components/AnalyticsContext/index":"87BMj","./hocs/withAnalyticsContext":"i2AWG","./components/AnalyticsErrorBoundary":false,"./hocs/withAnalyticsEvents":"bEG87","./components/AnalyticsReactContext":false,"./hooks/useAnalyticsEvents":"hjDXL","./hooks/useCallbackWithAnalytics":"5e8JW","./hooks/usePlatformLeafEventHandler":"8d2dv","./hooks/usePlatformLeafSyntheticEventHandler":"gcnSm","./utils/createAndFireEvent":"a2kp8","./utils/cleanProps":false,"./components/AnalyticsDecorator":false,"./components/AnalyticsDelegate":false,"./utils/withAnalytics":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6E4dw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isAnalyticsEvent", function() {
    return isAnalyticsEvent;
});
parcelHelpers.export(exports, "default", function() {
    return AnalyticsEvent;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _typeOf = require("@swc/helpers/_/_type_of");
var isAnalyticsEvent = function(obj) {
    var // Backwards compatibility with older analytics-next packages
    _obj_constructor;
    return (0, _instanceof._)(obj, AnalyticsEvent) || !!(obj === null || obj === void 0 ? void 0 : obj._isAnalyticsEvent) || (obj === null || obj === void 0 ? void 0 : (_obj_constructor = obj.constructor) === null || _obj_constructor === void 0 ? void 0 : _obj_constructor.name) === 'AnalyticsEvent';
};
var AnalyticsEvent = /*#__PURE__*/ function() {
    "use strict";
    function AnalyticsEvent(props) {
        var _this = this;
        (0, _classCallCheck._)(this, AnalyticsEvent);
        this._isAnalyticsEvent = true;
        this.clone = function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = (0, _objectSpread._)({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        };
        this.payload = props.payload;
    }
    (0, _createClass._)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((typeof updater === "undefined" ? "undefined" : (0, _typeOf._)(updater)) === 'object') this.payload = (0, _objectSpread._)({}, this.payload, updater);
                return this;
            }
        }
    ]);
    return AnalyticsEvent;
}();

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_type_of":"iFJdx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"koSmN":[function(require,module,exports,__globalThis) {
/// <reference types="node" />
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isUIAnalyticsEvent", function() {
    return isUIAnalyticsEvent;
});
parcelHelpers.export(exports, "default", function() {
    return UIAnalyticsEvent;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _get = require("@swc/helpers/_/_get");
var _getPrototypeOf = require("@swc/helpers/_/_get_prototype_of");
var _inherits = require("@swc/helpers/_/_inherits");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _analyticsEvent = require("./AnalyticsEvent");
var _analyticsEventDefault = parcelHelpers.interopDefault(_analyticsEvent);
var isUIAnalyticsEvent = function(obj) {
    var // Backwards compatibility with older analytics-next packages
    _obj_constructor;
    return (0, _instanceof._)(obj, UIAnalyticsEvent) || !!(obj === null || obj === void 0 ? void 0 : obj._isUIAnalyticsEvent) || (obj === null || obj === void 0 ? void 0 : (_obj_constructor = obj.constructor) === null || _obj_constructor === void 0 ? void 0 : _obj_constructor.name) === 'UIAnalyticsEvent';
};
var UIAnalyticsEvent = /*#__PURE__*/ function(AnalyticsEvent) {
    "use strict";
    (0, _inherits._)(UIAnalyticsEvent, AnalyticsEvent);
    function UIAnalyticsEvent(props) {
        (0, _classCallCheck._)(this, UIAnalyticsEvent);
        var _this;
        _this = (0, _callSuper._)(this, UIAnalyticsEvent, [
            props
        ]), _this._isUIAnalyticsEvent = true, _this.clone = function() {
            if (_this.hasFired) return null;
            var context = (0, _toConsumableArray._)(_this.context);
            var handlers = (0, _toConsumableArray._)(_this.handlers);
            /**
		 * A hacky "deep clone" of the object. This is limited in that it wont
		 * support functions, regexs, Maps, Sets, etc, but none of those need to
		 * be represented in our payload.
		 */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        }, _this.fire = function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        };
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, _createClass._)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return (0, _get._)((0, _getPrototypeOf._)(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
            }
        }
    ]);
    return UIAnalyticsEvent;
}((0, _analyticsEventDefault.default));

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_get":"38TLD","@swc/helpers/_/_get_prototype_of":"5txK6","@swc/helpers/_/_inherits":"2sfqW","@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_to_consumable_array":"1eSZf","./AnalyticsEvent":"6E4dw","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"f3eBX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _isModernContextEnabledEnv = require("../../utils/isModernContextEnabledEnv");
var _isModernContextEnabledEnvDefault = parcelHelpers.interopDefault(_isModernContextEnabledEnv);
var _legacyAnalyticsListener = require("./LegacyAnalyticsListener");
var _legacyAnalyticsListenerDefault = parcelHelpers.interopDefault(_legacyAnalyticsListener);
var _modernAnalyticsListener = require("./ModernAnalyticsListener");
var _modernAnalyticsListenerDefault = parcelHelpers.interopDefault(_modernAnalyticsListener);
var AnalyticsListener = function(props) {
    var isModernContext = (0, _isModernContextEnabledEnvDefault.default) || (0, _platformFeatureFlags.fg)('analytics-next-use-legacy-context') === false;
    return isModernContext ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modernAnalyticsListenerDefault.default), (0, _objectSpread._)({}, props)) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _legacyAnalyticsListenerDefault.default), (0, _objectSpread._)({}, props));
};
exports.default = AnalyticsListener;

},{"@swc/helpers/_/_object_spread":"9gdrV","react/jsx-runtime":"bGvcw","react":"ltHCL","@atlaskit/platform-feature-flags":"kO5t9","../../utils/isModernContextEnabledEnv":"kI67V","./LegacyAnalyticsListener":"1cGdB","./ModernAnalyticsListener":"796Fa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kI67V":[function(require,module,exports,__globalThis) {
/// <reference types="node" />
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _process_env;
var process = require("17db7e89e8d35eff");
var _default_1 = typeof process !== 'undefined' && process !== null && ((_process_env = process.env) === null || _process_env === void 0 ? void 0 : _process_env['ANALYTICS_NEXT_MODERN_CONTEXT']);
exports.default = _default_1;

},{"17db7e89e8d35eff":"gNLf3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1cGdB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _analyticsNextStableReactContext = require("@atlaskit/analytics-next-stable-react-context");
var _analyticsNextStableReactContextDefault = parcelHelpers.interopDefault(_analyticsNextStableReactContext);
var ContextTypes = {
    getAtlaskitAnalyticsEventHandlers: (0, _propTypesDefault.default).func,
    getAtlaskitAnalyticsContext: (0, _propTypesDefault.default).func
};
var noop = function() {
    return [];
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var AnalyticsListener = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, _inherits._)(AnalyticsListener, Component);
    function AnalyticsListener(props) {
        (0, _classCallCheck._)(this, AnalyticsListener);
        var _this;
        _this = (0, _callSuper._)(this, AnalyticsListener, [
            props
        ]), _this.getChildContext = function() {
            return {
                getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers,
                getAtlaskitAnalyticsContext: _this.getAtlaskitAnalyticsContext
            };
        }, _this.getAnalyticsEventHandlers = function() {
            var _this_props = _this.props, channel = _this_props.channel, onEvent = _this_props.onEvent;
            var _this_context = _this.context, _this_context_getAtlaskitAnalyticsEventHandlers = _this_context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this_context_getAtlaskitAnalyticsEventHandlers === void 0 ? noop : _this_context_getAtlaskitAnalyticsEventHandlers;
            var handler = function(event, eventChannel) {
                if (channel === '*' || channel === eventChannel) onEvent(event, eventChannel);
            };
            return [
                handler
            ].concat((0, _toConsumableArray._)(getAtlaskitAnalyticsEventHandlers()));
        }, _this.getAtlaskitAnalyticsContext = function() {
            var _this_context = _this.context, _this_context_getAtlaskitAnalyticsContext = _this_context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this_context_getAtlaskitAnalyticsContext === void 0 ? noop : _this_context_getAtlaskitAnalyticsContext;
            return getAtlaskitAnalyticsContext();
        };
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, _createClass._)(AnalyticsListener, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _analyticsNextStableReactContextDefault.default).Provider, {
                    value: this.contextValue,
                    children: children
                });
            }
        }
    ]);
    return AnalyticsListener;
}((0, _react.Component));
AnalyticsListener.contextTypes = ContextTypes;
AnalyticsListener.childContextTypes = ContextTypes;
exports.default = AnalyticsListener;

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_inherits":"2sfqW","@swc/helpers/_/_to_consumable_array":"1eSZf","react/jsx-runtime":"bGvcw","react":"ltHCL","prop-types":"3k3Jl","@atlaskit/analytics-next-stable-react-context":"3ToEo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3ToEo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _context = require("./context");
var _contextDefault = parcelHelpers.interopDefault(_context);
exports.default = (0, _contextDefault.default);

},{"./context":"cZSj1","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cZSj1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var AnalyticsNextContext = (0, _react.createContext)({
    getAtlaskitAnalyticsContext: function getAtlaskitAnalyticsContext() {
        return [];
    },
    getAtlaskitAnalyticsEventHandlers: function getAtlaskitAnalyticsEventHandlers() {
        return [];
    }
});
exports.default = AnalyticsNextContext;

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"796Fa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _analyticsNextStableReactContext = require("@atlaskit/analytics-next-stable-react-context");
var _analyticsNextStableReactContextDefault = parcelHelpers.interopDefault(_analyticsNextStableReactContext);
var _useAnalyticsContext = require("../../hooks/useAnalyticsContext");
var _useTrackedRef = require("../../hooks/useTrackedRef");
var AnalyticsListener = function(param) {
    var children = param.children, channel = param.channel, onEvent = param.onEvent;
    var _useAnalyticsContext1 = (0, _useAnalyticsContext.useAnalyticsContext)(), _useAnalyticsContext_getAtlaskitAnalyticsEventHandlers = _useAnalyticsContext1.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _useAnalyticsContext_getAtlaskitAnalyticsEventHandlers === void 0 ? function() {
        return [];
    } : _useAnalyticsContext_getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsContext = _useAnalyticsContext1.getAtlaskitAnalyticsContext;
    var onEventRef = (0, _useTrackedRef.useTrackedRef)(onEvent);
    var channelRef = (0, _useTrackedRef.useTrackedRef)(channel);
    var getAnalyticsEventHandlers = (0, _react.useCallback)(function() {
        var thisHandler = function(event, eventChannel) {
            if (channelRef.current === '*' || channelRef.current === eventChannel) onEventRef.current(event, eventChannel);
        };
        return [
            thisHandler
        ].concat((0, _toConsumableArray._)(getAtlaskitAnalyticsEventHandlers()));
    }, [
        channelRef,
        onEventRef,
        getAtlaskitAnalyticsEventHandlers
    ]);
    var value = (0, _react.useMemo)(function() {
        return {
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAnalyticsEventHandlers
        };
    }, [
        getAtlaskitAnalyticsContext,
        getAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _analyticsNextStableReactContextDefault.default).Provider, {
        value: value,
        children: children
    });
};
exports.default = AnalyticsListener;

},{"@swc/helpers/_/_to_consumable_array":"1eSZf","react/jsx-runtime":"bGvcw","react":"ltHCL","@atlaskit/analytics-next-stable-react-context":"3ToEo","../../hooks/useAnalyticsContext":"e9SXW","../../hooks/useTrackedRef":"kziOv","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"e9SXW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAnalyticsContext", function() {
    return useAnalyticsContext;
});
var _react = require("react");
var _analyticsNextStableReactContext = require("@atlaskit/analytics-next-stable-react-context");
var _analyticsNextStableReactContextDefault = parcelHelpers.interopDefault(_analyticsNextStableReactContext);
var useAnalyticsContext = function() {
    return (0, _react.useContext)((0, _analyticsNextStableReactContextDefault.default));
};

},{"react":"ltHCL","@atlaskit/analytics-next-stable-react-context":"3ToEo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kziOv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useTrackedRef", function() {
    return useTrackedRef;
});
var _react = require("react");
var useTrackedRef = function(value) {
    var ref = (0, _react.useRef)(value);
    ref.current = value;
    return ref;
};

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"87BMj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _isModernContextEnabledEnv = require("../../utils/isModernContextEnabledEnv");
var _isModernContextEnabledEnvDefault = parcelHelpers.interopDefault(_isModernContextEnabledEnv);
var _legacyAnalyticsContext = require("./LegacyAnalyticsContext");
var _legacyAnalyticsContextDefault = parcelHelpers.interopDefault(_legacyAnalyticsContext);
var _modernAnalyticsContext = require("./ModernAnalyticsContext");
var _modernAnalyticsContextDefault = parcelHelpers.interopDefault(_modernAnalyticsContext);
var AnalyticsContext = function(props) {
    var isModernContext = (0, _isModernContextEnabledEnvDefault.default) || (0, _platformFeatureFlags.fg)('analytics-next-use-legacy-context') === false;
    return isModernContext ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modernAnalyticsContextDefault.default), (0, _objectSpread._)({}, props)) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _legacyAnalyticsContextDefault.default), (0, _objectSpread._)({}, props));
};
exports.default = AnalyticsContext;

},{"@swc/helpers/_/_object_spread":"9gdrV","react/jsx-runtime":"bGvcw","react":"ltHCL","@atlaskit/platform-feature-flags":"kO5t9","../../utils/isModernContextEnabledEnv":"kI67V","./LegacyAnalyticsContext":"3rAmC","./ModernAnalyticsContext":"Ihbnc","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3rAmC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _analyticsNextStableReactContext = require("@atlaskit/analytics-next-stable-react-context");
var _analyticsNextStableReactContextDefault = parcelHelpers.interopDefault(_analyticsNextStableReactContext);
var ContextTypes = {
    getAtlaskitAnalyticsContext: (0, _propTypesDefault.default).func,
    getAtlaskitAnalyticsEventHandlers: (0, _propTypesDefault.default).func
};
var noop = function() {
    return [];
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var AnalyticsContext = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, _inherits._)(AnalyticsContext, Component);
    function AnalyticsContext(props) {
        (0, _classCallCheck._)(this, AnalyticsContext);
        var _this;
        _this = (0, _callSuper._)(this, AnalyticsContext, [
            props
        ]), _this.getChildContext = function() {
            return {
                getAtlaskitAnalyticsContext: _this.getAnalyticsContext
            };
        }, _this.getAnalyticsContext = function() {
            var data = _this.props.data;
            var _this_context = _this.context, _this_context_getAtlaskitAnalyticsContext = _this_context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this_context_getAtlaskitAnalyticsContext === void 0 ? noop : _this_context_getAtlaskitAnalyticsContext;
            return (0, _toConsumableArray._)(getAtlaskitAnalyticsContext()).concat([
                data
            ]);
        }, _this.getAnalyticsEventHandlers = function() {
            var _this_context = _this.context, _this_context_getAtlaskitAnalyticsEventHandlers = _this_context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this_context_getAtlaskitAnalyticsEventHandlers === void 0 ? noop : _this_context_getAtlaskitAnalyticsEventHandlers;
            return getAtlaskitAnalyticsEventHandlers();
        };
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, _createClass._)(AnalyticsContext, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _analyticsNextStableReactContextDefault.default).Provider, {
                    value: this.contextValue,
                    children: children
                });
            }
        }
    ]);
    return AnalyticsContext;
}((0, _react.Component));
AnalyticsContext.contextTypes = ContextTypes;
AnalyticsContext.childContextTypes = ContextTypes;
exports.default = AnalyticsContext;

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_inherits":"2sfqW","@swc/helpers/_/_to_consumable_array":"1eSZf","react/jsx-runtime":"bGvcw","react":"ltHCL","prop-types":"3k3Jl","@atlaskit/analytics-next-stable-react-context":"3ToEo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"Ihbnc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _analyticsNextStableReactContext = require("@atlaskit/analytics-next-stable-react-context");
var _analyticsNextStableReactContextDefault = parcelHelpers.interopDefault(_analyticsNextStableReactContext);
var _useAnalyticsContext = require("../../hooks/useAnalyticsContext");
var _useTrackedRef = require("../../hooks/useTrackedRef");
var AnalyticsContext = function(param) {
    var data = param.data, children = param.children;
    var dataRef = (0, _useTrackedRef.useTrackedRef)(data);
    var _useAnalyticsContext1 = (0, _useAnalyticsContext.useAnalyticsContext)(), getAtlaskitAnalyticsEventHandlers = _useAnalyticsContext1.getAtlaskitAnalyticsEventHandlers, getOriginalAnalyticsContext = _useAnalyticsContext1.getAtlaskitAnalyticsContext;
    var getAtlaskitAnalyticsContext = (0, _react.useCallback)(function() {
        return (0, _toConsumableArray._)(getOriginalAnalyticsContext()).concat([
            dataRef.current
        ]);
    }, [
        getOriginalAnalyticsContext,
        dataRef
    ]);
    var value = (0, _react.useMemo)(function() {
        return {
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers
        };
    }, [
        getAtlaskitAnalyticsContext,
        getAtlaskitAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _analyticsNextStableReactContextDefault.default).Provider, {
        value: value,
        children: children
    });
};
exports.default = AnalyticsContext;

},{"@swc/helpers/_/_to_consumable_array":"1eSZf","react/jsx-runtime":"bGvcw","react":"ltHCL","@atlaskit/analytics-next-stable-react-context":"3ToEo","../../hooks/useAnalyticsContext":"e9SXW","../../hooks/useTrackedRef":"kziOv","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"i2AWG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _analyticsContext = require("../components/AnalyticsContext");
var _analyticsContextDefault = parcelHelpers.interopDefault(_analyticsContext);
var withAnalyticsContext = function(defaultData) {
    return function(WrappedComponent) {
        var WithAnalyticsContext = /*#__PURE__*/ (0, _react.forwardRef)(function(_param, ref) {
            var analyticsContext = _param.analyticsContext, rest = (0, _objectWithoutProperties._)(_param, [
                "analyticsContext"
            ]);
            var analyticsData = (0, _react.useMemo)(function() {
                return (0, _objectSpread._)({}, defaultData, analyticsContext);
            }, [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _analyticsContextDefault.default), {
                data: analyticsData,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(WrappedComponent, (0, _objectSpreadProps._)((0, _objectSpread._)({}, rest), {
                    ref: ref
                }))
            });
        });
        WithAnalyticsContext.displayName = "WithAnalyticsContext(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsContext;
    };
};
exports.default = withAnalyticsContext;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react/jsx-runtime":"bGvcw","react":"ltHCL","../components/AnalyticsContext":"87BMj","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bEG87":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useAnalyticsEvents = require("../hooks/useAnalyticsEvents");
var _usePatchedProps = require("../hooks/usePatchedProps");
var withAnalyticsEvents = function() {
    var createEventMap = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(WrappedComponent) {
        var WithAnalyticsEvents = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
            var patchedEventProps = (0, _usePatchedProps.usePatchedProps)(createEventMap, props).patchedEventProps;
            var createAnalyticsEvent = (0, _useAnalyticsEvents.useAnalyticsEvents)().createAnalyticsEvent;
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(WrappedComponent, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props, patchedEventProps), {
                createAnalyticsEvent: createAnalyticsEvent,
                ref: ref
            }));
        });
        WithAnalyticsEvents.displayName = "WithAnalyticsEvents(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsEvents;
    };
};
exports.default = withAnalyticsEvents;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","../hooks/useAnalyticsEvents":"hjDXL","../hooks/usePatchedProps":"j00Iv","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hjDXL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAnalyticsEvents", function() {
    return useAnalyticsEvents;
});
var _useMemoOne = require("use-memo-one");
var _uianalyticsEvent = require("../events/UIAnalyticsEvent");
var _uianalyticsEventDefault = parcelHelpers.interopDefault(_uianalyticsEvent);
var _useAnalyticsContext = require("./useAnalyticsContext");
function useAnalyticsEvents() {
    var analyticsContext = (0, _useAnalyticsContext.useAnalyticsContext)();
    var createAnalyticsEvent = (0, _useMemoOne.useCallbackOne)(function(payload) {
        return new (0, _uianalyticsEventDefault.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

},{"use-memo-one":"aSYah","../events/UIAnalyticsEvent":"koSmN","./useAnalyticsContext":"e9SXW","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aSYah":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCallback", function() {
    return useCallback;
});
parcelHelpers.export(exports, "useCallbackOne", function() {
    return useCallbackOne;
});
parcelHelpers.export(exports, "useMemo", function() {
    return useMemo;
});
parcelHelpers.export(exports, "useMemoOne", function() {
    return useMemoOne;
});
var _react = require("react");
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function useMemoOne(getResult, inputs) {
    var initial = (0, _react.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    })[0];
    var isFirstRun = (0, _react.useRef)(true);
    var committed = (0, _react.useRef)(initial);
    var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && areInputsEqual(inputs, committed.current.inputs));
    var cache = useCache ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, _react.useEffect)(function() {
        isFirstRun.current = false;
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function useCallbackOne(callback, inputs) {
    return useMemoOne(function() {
        return callback;
    }, inputs);
}
var useMemo = useMemoOne;
var useCallback = useCallbackOne;

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"j00Iv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "usePatchedProps", function() {
    return usePatchedProps;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var _react = require("react");
var _useAnalyticsEvents = require("./useAnalyticsEvents");
function usePatchedProps() {
    var createEventMap = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, wrappedComponentProps = arguments.length > 1 ? arguments[1] : void 0;
    var createAnalyticsEvent = (0, _useAnalyticsEvents.useAnalyticsEvents)().createAnalyticsEvent;
    var handlerCache = (0, _react.useRef)({});
    var patchedProps = (0, _react.useMemo)(function() {
        var cache = handlerCache.current;
        // Clean up no longer used handlers in cache
        Object.keys(cache).filter(function(key) {
            return !(key in createEventMap);
        }).forEach(function(key) {
            return delete cache[key];
        });
        return Object.keys(createEventMap).reduce(function(p, k) {
            var eventCreator = createEventMap[k];
            if (![
                'object',
                'function'
            ].includes(typeof eventCreator === "undefined" ? "undefined" : (0, _typeOf._)(eventCreator))) return p;
            var propValue = wrappedComponentProps[k];
            if (k in cache && cache[k].eventCreator === eventCreator && cache[k].propValue === propValue) return (0, _objectSpreadProps._)((0, _objectSpread._)({}, p), (0, _defineProperty._)({}, k, cache[k].wrappedCallback));
            var wrappedCallback = function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var analyticsEvent = typeof eventCreator === 'function' ? eventCreator(createAnalyticsEvent, wrappedComponentProps) : createAnalyticsEvent(eventCreator);
                if (propValue && typeof propValue === 'function') propValue.apply(void 0, (0, _toConsumableArray._)(args).concat([
                    analyticsEvent
                ]));
            };
            cache[k] = {
                eventCreator: eventCreator,
                wrappedCallback: wrappedCallback,
                propValue: propValue
            };
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, p), (0, _defineProperty._)({}, k, wrappedCallback));
        }, {});
    }, [
        createEventMap,
        wrappedComponentProps,
        createAnalyticsEvent,
        handlerCache
    ]);
    return {
        patchedEventProps: patchedProps
    };
}

},{"@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_to_consumable_array":"1eSZf","@swc/helpers/_/_type_of":"iFJdx","react":"ltHCL","./useAnalyticsEvents":"hjDXL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5e8JW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCallbackWithAnalytics", function() {
    return useCallbackWithAnalytics;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _react = require("react");
var _useAnalyticsEvents = require("./useAnalyticsEvents");
var _useTrackedRef = require("./useTrackedRef");
var useCallbackWithAnalytics = function(method, payload, channel) {
    var createAnalyticsEvent = (0, _useAnalyticsEvents.useAnalyticsEvents)().createAnalyticsEvent;
    var methodRef = (0, _useTrackedRef.useTrackedRef)(method);
    var payloadRef = (0, _useTrackedRef.useTrackedRef)(payload);
    return (0, _react.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _payloadRef, _methodRef;
        var pload = typeof payloadRef.current === 'function' ? (_payloadRef = payloadRef).current.apply(_payloadRef, (0, _toConsumableArray._)(args)) : payloadRef.current;
        createAnalyticsEvent(pload).fire(channel);
        (_methodRef = methodRef).current.apply(_methodRef, (0, _toConsumableArray._)(args));
    }, [
        createAnalyticsEvent,
        methodRef,
        payloadRef,
        channel
    ]);
};

},{"@swc/helpers/_/_to_consumable_array":"1eSZf","react":"ltHCL","./useAnalyticsEvents":"hjDXL","./useTrackedRef":"kziOv","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8d2dv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// WARNING: This hook will only function correctly for leaf node components - as in
// no children inside the component will require analytics themselves.
// Ignoring this warning will mean the analytics context of child components will not
// include the context of this component, .e.g, lost data.
// If you are going to have child components that require analytics use withAnalytics
// or AnalyticsContext component instead.
parcelHelpers.export(exports, "usePlatformLeafEventHandler", function() {
    return usePlatformLeafEventHandler;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _react = require("react");
var _useAnalyticsEvents = require("./useAnalyticsEvents");
var _useTrackedRef = require("./useTrackedRef");
function usePlatformLeafEventHandler(param) {
    var fn = param.fn, action = param.action, componentName = param.componentName, actionSubject = param.actionSubject, packageName = param.packageName, packageVersion = param.packageVersion, analyticsData = param.analyticsData;
    var createAnalyticsEvent = (0, _useAnalyticsEvents.useAnalyticsEvents)().createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, _useTrackedRef.useTrackedRef)(analyticsData);
    var fnRef = (0, _useTrackedRef.useTrackedRef)(fn);
    var handler = (0, _react.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = (0, _objectSpread._)({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

},{"@swc/helpers/_/_object_spread":"9gdrV","react":"ltHCL","./useAnalyticsEvents":"hjDXL","./useTrackedRef":"kziOv","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gcnSm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// WARNING: This hook will only function correctly for leaf node components - as in
// no children inside the component will require analytics themselves.
// Ignoring this warning will mean the analytics context of child components will not
// include the context of this component, .e.g, lost data.
// If you are going to have child components that require analytics use withAnalytics
// or AnalyticsContext component instead.
parcelHelpers.export(exports, "usePlatformLeafSyntheticEventHandler", function() {
    return usePlatformLeafSyntheticEventHandler;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _react = require("react");
var _useAnalyticsEvents = require("./useAnalyticsEvents");
var _useTrackedRef = require("./useTrackedRef");
function usePlatformLeafSyntheticEventHandler(param) {
    var fn = param.fn, action = param.action, componentName = param.componentName, packageName = param.packageName, packageVersion = param.packageVersion, analyticsData = param.analyticsData;
    var createAnalyticsEvent = (0, _useAnalyticsEvents.useAnalyticsEvents)().createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, _useTrackedRef.useTrackedRef)(analyticsData);
    var fnRef = (0, _useTrackedRef.useTrackedRef)(fn);
    var handler = (0, _react.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = (0, _objectSpread._)({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

},{"@swc/helpers/_/_object_spread":"9gdrV","react":"ltHCL","./useAnalyticsEvents":"hjDXL","./useTrackedRef":"kziOv","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"a2kp8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = function(channel) {
    return function(payload) {
        return function(createAnalyticsEvent) {
            var consumerEvent = createAnalyticsEvent(payload);
            var clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };
    };
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1P4BQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isSafari", function() {
    return isSafari;
});
function isSafari() {
    if (typeof window !== 'undefined' && window.navigator != null) {
        var _window_navigator_userAgent;
        var ua = (_window_navigator_userAgent = window.navigator.userAgent) === null || _window_navigator_userAgent === void 0 ? void 0 : _window_navigator_userAgent.toLowerCase();
        return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
    }
    return false;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4Lyu9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var interactionContext = (0, _react.createContext)(null);
exports.default = interactionContext;

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"a1sGT":[function(require,module,exports,__globalThis) {
/* focusable.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var focusRingStyles = null;
var insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var Focusable = /*#__PURE__*/ (0, _react.forwardRef)(function(_param, ref) {
    var tmp = _param.as, Component = tmp === void 0 ? 'button' : tmp, children = _param.children, isInset = _param.isInset, testId = _param.testId, style = _param.style, xcss = _param.xcss, htmlAttributes = (0, _objectWithoutProperties._)(_param, [
        "as",
        "children",
        "isInset",
        "testId",
        "style",
        "xcss"
    ]);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, _objectWithoutProperties._)(htmlAttributes, [
        "className"
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, (0, _objectSpreadProps._)((0, _objectSpread._)({}, safeHtmlAttributes), {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, _runtime.ax)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId,
        children: children
    }));
});
exports.default = Focusable;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6COXQ":[function(require,module,exports,__globalThis) {
/* anchor.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _typeOf = require("@swc/helpers/_/_type_of");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _react1 = require("@compiled/react");
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
var _analyticsNext = require("@atlaskit/analytics-next");
var _appProvider = require("@atlaskit/app-provider");
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var _useId = require("@atlaskit/ds-lib/use-id");
var _interactionContext = require("@atlaskit/interaction-context");
var _interactionContextDefault = parcelHelpers.interopDefault(_interactionContext);
var _visuallyHidden = require("@atlaskit/visually-hidden");
var _visuallyHiddenDefault = parcelHelpers.interopDefault(_visuallyHidden);
var _focusable = require("./focusable");
var _focusableDefault = parcelHelpers.interopDefault(_focusable);
var styles = {
    root: "_4bfu1r31 _1hms8stv _ajmmnqa1 _vchhusvi",
    position: "_kqswh2mm"
};
var IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var AnchorNoRef = function(_param, ref) {
    var href = _param.href, children = _param.children, tmp = _param.onClick, providedOnClick = tmp === void 0 ? (0, _noopDefault.default) : tmp, interactionName = _param.interactionName, componentName = _param.componentName, analyticsContext = _param.analyticsContext, ariaLabel = _param['aria-label'], ariaLabelledBy = _param['aria-labelledby'], style = _param.style, target = _param.target, testId = _param.testId, xcss = _param.xcss, _param_newWindowLabel = _param.newWindowLabel, newWindowLabel = _param_newWindowLabel === void 0 ? '(opens new window)' : _param_newWindowLabel, htmlAttributes = (0, _objectWithoutProperties._)(_param, [
        "href",
        "children",
        "onClick",
        "interactionName",
        "componentName",
        "analyticsContext",
        'aria-label',
        'aria-labelledby',
        "style",
        "target",
        "testId",
        "xcss",
        "newWindowLabel"
    ]);
    var interactionContext = (0, _react.useContext)((0, _interactionContextDefault.default));
    var handleClick = (0, _react.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var opensNewWindowLabelId = (0, _useId.useId)();
    var onClick = (0, _analyticsNext.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: undefined,
        packageVersion: undefined,
        analyticsData: analyticsContext,
        actionSubject: 'link'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, _objectWithoutProperties._)(htmlAttributes, [
        "className"
    ]);
    var RouterLink = (0, _appProvider.useRouterLink)();
    var isExternal = typeof href === 'string' && IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === 'string' && IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ var isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    var hrefObjectUsedWithoutRouterLink = RouterLink === undefined && (typeof href === "undefined" ? "undefined" : (0, _typeOf._)(href)) === 'object';
    (0, _tinyInvariantDefault.default)(!hrefObjectUsedWithoutRouterLink, "@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider");
    var Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _focusableDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({
        // @ts-expect-error we don't allow `a` on Focusable for makers as they should use Anchor instead
        as: Component,
        className: xcss,
        style: style,
        ref: ref
    }, safeHtmlAttributes), {
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? "".concat(ariaLabel, " , ").concat(newWindowLabel) : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? "".concat(ariaLabelledBy, " ").concat(opensNewWindowLabelId) : ariaLabelledBy,
        xcss: (0, _react1.cx)(styles.root, styles.position, xcss),
        testId: testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
        children: [
            children,
            target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _visuallyHiddenDefault.default), {
                id: opensNewWindowLabelId,
                children: ", ".concat(newWindowLabel)
            })
        ]
    }));
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var Anchor = /*#__PURE__*/ (0, _react.forwardRef)(AnchorNoRef);
exports.default = Anchor;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","@swc/helpers/_/_type_of":"iFJdx","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react":"MfI9Z","tiny-invariant":"9VWeJ","@atlaskit/analytics-next":"auH4u","@atlaskit/app-provider":"cnK0e","@atlaskit/ds-lib/noop":"2f3bg","@atlaskit/ds-lib/use-id":"axFod","@atlaskit/interaction-context":"4Lyu9","@atlaskit/visually-hidden":"lj6Zq","./focusable":"a1sGT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lj6Zq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return 0, _visuallyHiddenDefault.default;
});
var _visuallyHidden = require("./visually-hidden");
var _visuallyHiddenDefault = parcelHelpers.interopDefault(_visuallyHidden);

},{"./visually-hidden":"bMmIH","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bMmIH":[function(require,module,exports,__globalThis) {
/* visually-hidden.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var VisuallyHidden = function(param) {
    var children = param.children, testId = param.testId, role = param.role, id = param.id;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, _runtime.ax)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _uiztglyw _o5721q9c"
        ]),
        children: children
    });
};
VisuallyHidden.displayName = 'VisuallyHidden';
exports.default = VisuallyHidden;

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"wWWmD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "media", function() {
    return 0, _mediaHelper.media;
});
parcelHelpers.export(exports, "UNSAFE_useMediaQuery", function() {
    return 0, _useMediaQuery.UNSAFE_useMediaQuery;
});
parcelHelpers.export(exports, "Show", function() {
    return 0, _show.Show;
});
parcelHelpers.export(exports, "Hide", function() {
    return 0, _hide.Hide;
});
var _mediaHelper = require("./media-helper");
var _useMediaQuery = require("./use-media-query");
var _show = require("./show");
var _hide = require("./hide");

},{"./media-helper":false,"./use-media-query":"hj0Ye","./show":false,"./hide":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1hBrw":[function(require,module,exports,__globalThis) {
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "media", function() {
    return media;
});
var media = {
    above: {
        // TODO: Should this even exist, we don't want `css({ [media.above.xxs]: { … } })` because that just adds duplicates styles!
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hj0Ye":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UNSAFE_useMediaQuery", function() {
    return UNSAFE_useMediaQuery;
});
var _react = require("react");
var _bindEventListener = require("bind-event-listener");
var _mediaHelper = require("./media-helper");
var _window_matchMedia, _window, _window_matchMedia1, _window1, _window_matchMedia2, _window2, _window_matchMedia3, _window3, _window_matchMedia4, _window4, _window_matchMedia5, _window5, _window_matchMedia6, _window6, _window_matchMedia7, _window7, _window_matchMedia8, _window8, _window_matchMedia9, _window9, _window_matchMedia10, _window10;
var queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : (_window = window) === null || _window === void 0 ? void 0 : (_window_matchMedia = _window.matchMedia) === null || _window_matchMedia === void 0 ? void 0 : _window_matchMedia.call(_window, (0, _mediaHelper.media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : (_window1 = window) === null || _window1 === void 0 ? void 0 : (_window_matchMedia1 = _window1.matchMedia) === null || _window_matchMedia1 === void 0 ? void 0 : _window_matchMedia1.call(_window1, (0, _mediaHelper.media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window_matchMedia2 = _window2.matchMedia) === null || _window_matchMedia2 === void 0 ? void 0 : _window_matchMedia2.call(_window2, (0, _mediaHelper.media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : (_window3 = window) === null || _window3 === void 0 ? void 0 : (_window_matchMedia3 = _window3.matchMedia) === null || _window_matchMedia3 === void 0 ? void 0 : _window_matchMedia3.call(_window3, (0, _mediaHelper.media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : (_window4 = window) === null || _window4 === void 0 ? void 0 : (_window_matchMedia4 = _window4.matchMedia) === null || _window_matchMedia4 === void 0 ? void 0 : _window_matchMedia4.call(_window4, (0, _mediaHelper.media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : (_window5 = window) === null || _window5 === void 0 ? void 0 : (_window_matchMedia5 = _window5.matchMedia) === null || _window_matchMedia5 === void 0 ? void 0 : _window_matchMedia5.call(_window5, (0, _mediaHelper.media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : (_window6 = window) === null || _window6 === void 0 ? void 0 : (_window_matchMedia6 = _window6.matchMedia) === null || _window_matchMedia6 === void 0 ? void 0 : _window_matchMedia6.call(_window6, (0, _mediaHelper.media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : (_window7 = window) === null || _window7 === void 0 ? void 0 : (_window_matchMedia7 = _window7.matchMedia) === null || _window_matchMedia7 === void 0 ? void 0 : _window_matchMedia7.call(_window7, (0, _mediaHelper.media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : (_window8 = window) === null || _window8 === void 0 ? void 0 : (_window_matchMedia8 = _window8.matchMedia) === null || _window_matchMedia8 === void 0 ? void 0 : _window_matchMedia8.call(_window8, (0, _mediaHelper.media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : (_window9 = window) === null || _window9 === void 0 ? void 0 : (_window_matchMedia9 = _window9.matchMedia) === null || _window_matchMedia9 === void 0 ? void 0 : _window_matchMedia9.call(_window9, (0, _mediaHelper.media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : (_window10 = window) === null || _window10 === void 0 ? void 0 : (_window_matchMedia10 = _window10.matchMedia) === null || _window_matchMedia10 === void 0 ? void 0 : _window_matchMedia10.call(_window10, (0, _mediaHelper.media).below.xl.replace('@media ', '').trim())
};
var UNSAFE_useMediaQuery = function(queryString, listener) {
    var listenerRef = (0, _react.useRef)(listener);
    (0, _react.useEffect)(function() {
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
	 * We explicitly only react to boolean changes for binding our listener
	 * Changes to the functional reference are ignored.
	 */ var hasListener = !!listener;
    /**
	 * The `matchMedia(…)` return value for our breakpoint query.
	 */ var mq = queries[queryString];
    (0, _react.useLayoutEffect)(function() {
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, _bindEventListener.bind)(mq, {
            type: 'change',
            listener: function(event) {
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};

},{"react":"ltHCL","bind-event-listener":"bjeUU","./media-helper":"1hBrw","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kAtzi":[function(require,module,exports,__globalThis) {
/* skip-link.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SkipLink", function() {
    return SkipLink;
});
var _jsxRuntime = require("react/jsx-runtime");
var _runtime = require("@compiled/react/runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _bindEventListener = require("bind-event-listener");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
var _compiled = require("@atlaskit/primitives/compiled");
var styles = {
    skipLinkListItem: "_1pfhze3t",
    skipLinkListItemNew: "_1rjcu2gc"
};
/**
 * Used for moving focus to the corresponding slot or custom target after clicking on a skip link.
 */ function focusElement(element) {
    /**
   * Elements without an explicit `tabindex` attribute are not guaranteed to be focusable:
   * https://html.spec.whatwg.org/multipage/interaction.html#attr-tabindex
   *
   * Our slots are not interactive, so this is required.
   *
   * In the future we may want to check if there is an existing `tabindex` attribute,
   * as custom skip linked elements might already have one.
   */ element.setAttribute('tabindex', '-1');
    /**
   * Cleanup the `tabindex` attribute we set when the slot or custom target loses focus.
   *
   * This is preferable to always having `tabindex="-1"` because always applying the tab index can:
   *
   * - mess with click events
   * - potentially cause a focus ring to be always visible
   */ (0, _bindEventListener.bind)(element, {
        type: 'blur',
        listener: function listener() {
            element.removeAttribute('tabindex');
        },
        options: {
            // Using a one-time listener so it cleans itself up
            once: true
        }
    });
    /**
   * Move focus to the slot or custom target.
   *
   * Calling `.focus()` will also scroll the element into view:
   * https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus
   */ element.focus({
        // Forces the focus ring to appear after moving focus to the slot
        // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus#focusvisible
        // @ts-expect-error - new and not in types yet
        focusVisible: true
    });
}
var SkipLink = function(param) {
    var id = param.id, children = param.children, onBeforeNavigate = param.onBeforeNavigate;
    var href = "#".concat(id);
    var onClick = (0, _react.useCallback)(function(event) {
        event.preventDefault();
        // Intentionally not using `document.querySelector` because many valid IDs are not valid selectors.
        var target = document.getElementById(id);
        if (!target) return;
        /**
     * Internal slots can attach an `onBeforeNavigate` callback.
     *
     * Side nav uses this to ensure it is expanded.
     */ onBeforeNavigate === null || onBeforeNavigate === void 0 ? void 0 : onBeforeNavigate();
        focusElement(target);
        /**
     * We should look into removing this, or only calling it in specific cases.
     *
     * It means if the skip link element is in the window scroll container
     * then it might not get scrolled into view properly.
     *
     * This is not an issue for the default slots on desktop, but could break custom skip links or
     * even `Aside` on mobile.
     *
     * Keeping existing behavior for now because resetting the window scroll is actually good for some cases.
     * E.g. jumping to main / aside it makes sense to look at the start of the content.
     */ window.scrollTo(0, 0);
    }, [
        id,
        onBeforeNavigate
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
        className: (0, _runtime.ax)([
            styles.skipLinkListItem,
            (0, _platformFeatureFlags.fg)('platform_dst_nav4_skip_link_a11y_1') && styles.skipLinkListItemNew
        ]),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _compiled.Anchor), {
            /**
     * It looks like Safari handles link clicks during `pointerdown` unless it has an explicit `tabIndex={0}` :/
     *
     * Adding this explicitly makes the behavior consistent between browsers and lets us `event.preventDefault()`
     * in the `onClick` handler.
     */ tabIndex: 0,
            href: href,
            onClick: onClick,
            children: children
        })
    });
};

},{"react/jsx-runtime":"bGvcw","@compiled/react/runtime":"d27Vo","react":"ltHCL","bind-event-listener":"bjeUU","@atlaskit/platform-feature-flags":"kO5t9","@atlaskit/primitives/compiled":"jhQE8","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"i35EU":[function(require,module,exports,__globalThis) {
/* skip-links-popup.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Skip links shown behind `platform_dst_nav4_skip_link_a11y_1`: a single focus-revealed
 * control opens a dialog listing skip targets.
 */ parcelHelpers.export(exports, "SkipLinksPopup", function() {
    return SkipLinksPopup;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _reactDom = require("react-dom");
var _new = require("@atlaskit/button/new");
var _newDefault = parcelHelpers.interopDefault(_new);
var _mergeRefs = require("@atlaskit/ds-lib/merge-refs");
var _mergeRefsDefault = parcelHelpers.interopDefault(_mergeRefs);
var _popup = require("@atlaskit/popup");
var _popupDefault = parcelHelpers.interopDefault(_popup);
var _skipLink = require("./skip-link");
var contentStyles = {
    root: "_1rjcu2gc _18zrpxbi _1e0c1txw _2lx21bp4 _1pbyjh3g",
    skipLinkList: "_1e0c1txw _2lx21bp4 _1x8w11lx _2mzuglyw _1pfhze3t _bozgze3t",
    label: "_11c8i4vh _1rjcu2gc _syazazsu"
};
var triggerStyles = {
    root: "_2rko12b0 _1dqoglyw _kqsw1n9t _1e02utpp _152tutpp _1pby1mrw _tzy4idpf _bfhk1bhr _4ojojh3g _c8j0kb7n",
    isOpen: "_tzy4idpf _t9ecz6y5"
};
var popupOffset = [
    0,
    0
];
function SkipLinksPopup(param) {
    var title = param.label, triggerLabel = param.triggerLabel, testId = param.testId, links = param.links;
    var titleId = (0, _react.useId)();
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), isOpen = _useState[0], setIsOpen = _useState[1];
    var triggerRef = (0, _react.useRef)(null);
    var openPopup = (0, _react.useCallback)(function() {
        setIsOpen(true);
    }, []);
    /**
   * Closes the popup.
   *
   * Uses `flushSync` to avoid issues with focus management.
   * This ensures the popup's focus lock is fully released by the time skip links or our `onClose` try to move focus.
   */ var closePopup = (0, _react.useCallback)(function() {
        (0, _reactDom.flushSync)(function() {
            setIsOpen(false);
        });
    }, []);
    /**
   * Restores focus to the trigger on close, if it hasn't moved to another element, such as when Esc is pressed instead of a skip link.
   *
   * We need this because using the standard `shouldReturnFocus` on the popup would break the skip link focus behaviour,
   * as focus would always move back to the trigger.
   */ var onClose = (0, _react.useCallback)(function() {
        var _triggerRef_current;
        closePopup();
        // Focus on the body implies a skip link was not clicked
        if (document.activeElement === document.body) (_triggerRef_current = triggerRef.current) === null || _triggerRef_current === void 0 ? void 0 : _triggerRef_current.focus();
    }, [
        closePopup
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popupDefault.default), {
        isOpen: isOpen,
        onClose: onClose,
        placement: "bottom-start",
        shouldRenderToParent: true,
        shouldReturnFocus: false,
        role: "dialog",
        titleId: titleId,
        testId: testId ? "".concat(testId, "--skip-links-container") : undefined,
        offset: popupOffset,
        content: function() {
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: (0, _runtime.ax)([
                    contentStyles.root
                ]),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        "data-testid": testId ? "".concat(testId, "--skip-links-container--label") : undefined,
                        id: titleId,
                        className: (0, _runtime.ax)([
                            contentStyles.label
                        ]),
                        children: title
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("ol", {
                        className: (0, _runtime.ax)([
                            contentStyles.skipLinkList
                        ]),
                        children: links.map(function(param) {
                            var id = param.id, label = param.label, onBeforeNavigate = param.onBeforeNavigate;
                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skipLink.SkipLink), {
                                id: id,
                                onBeforeNavigate: function() {
                                    closePopup();
                                    onBeforeNavigate === null || onBeforeNavigate === void 0 ? void 0 : onBeforeNavigate();
                                },
                                children: label
                            }, id);
                        })
                    })
                ]
            });
        },
        trigger: function(triggerProps) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: (0, _runtime.ax)([
                    triggerStyles.root,
                    isOpen && triggerStyles.isOpen
                ]),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _newDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, triggerProps), {
                    ref: (0, _mergeRefsDefault.default)([
                        triggerProps.ref,
                        triggerRef
                    ]),
                    appearance: "primary",
                    isSelected: isOpen,
                    testId: testId ? "".concat(testId, "--skip-links-trigger") : undefined,
                    onClick: openPopup,
                    children: triggerLabel
                }))
            });
        }
    });
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_sliced_to_array":"8PtL6","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","react-dom":"bvX0P","@atlaskit/button/new":"2LnSZ","@atlaskit/ds-lib/merge-refs":"bhv2L","@atlaskit/popup":"9PMZe","./skip-link":"kAtzi","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2LnSZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return 0, _buttonDefault.default;
});
parcelHelpers.export(exports, "LinkButton", function() {
    return 0, _linkDefault.default;
});
parcelHelpers.export(exports, "IconButton", function() {
    return 0, _buttonDefault1.default;
});
parcelHelpers.export(exports, "LinkIconButton", function() {
    return 0, _linkDefault1.default;
});
parcelHelpers.export(exports, "SplitButton", function() {
    return 0, _splitButton.SplitButton;
});
var _button = require("../new-button/variants/default/button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _link = require("../new-button/variants/default/link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _button1 = require("../new-button/variants/icon/button");
var _buttonDefault1 = parcelHelpers.interopDefault(_button1);
var _link1 = require("../new-button/variants/icon/link");
var _linkDefault1 = parcelHelpers.interopDefault(_link1);
var _splitButton = require("../new-button/containers/split-button/split-button");

},{"../new-button/variants/default/button":"fw5DP","../new-button/variants/default/link":false,"../new-button/variants/icon/button":"eXHSj","../new-button/variants/icon/link":false,"../new-button/containers/split-button/split-button":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fw5DP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _buttonBase = require("../shared/button-base");
var _buttonBaseDefault = parcelHelpers.interopDefault(_buttonBase);
var _content = require("../shared/content");
var _contentDefault = parcelHelpers.interopDefault(_content);
var _iconRenderer = require("../shared/icon-renderer");
var _iconRendererDefault = parcelHelpers.interopDefault(_iconRenderer);
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ var Button = /*#__PURE__*/ (0, _reactDefault.default).memo(/*#__PURE__*/ (0, _reactDefault.default).forwardRef(function Button(_param, ref) {
    var analyticsContext = _param.analyticsContext, appearance = _param.appearance, ariaLabel = _param['aria-label'], ariaLabelledBy = _param['aria-labelledby'], autoFocus = _param.autoFocus, children = _param.children, iconAfter = _param.iconAfter, iconBefore = _param.iconBefore, interactionName = _param.interactionName, isDisabled = _param.isDisabled, _param_isLoading = _param.isLoading, isLoading = _param_isLoading === void 0 ? false : _param_isLoading, isSelected = _param.isSelected, onClick = _param.onClick, onClickCapture = _param.onClickCapture, onKeyDownCapture = _param.onKeyDownCapture, onKeyUpCapture = _param.onKeyUpCapture, onMouseDownCapture = _param.onMouseDownCapture, onMouseUpCapture = _param.onMouseUpCapture, onPointerDownCapture = _param.onPointerDownCapture, onPointerUpCapture = _param.onPointerUpCapture, onTouchEndCapture = _param.onTouchEndCapture, onTouchStartCapture = _param.onTouchStartCapture, shouldFitContainer = _param.shouldFitContainer, spacing = _param.spacing, testId = _param.testId, _param_type = _param.type, type = _param_type === void 0 ? 'button' : _param_type, unsafeRest = (0, _objectWithoutProperties._)(_param, [
        "analyticsContext",
        "appearance",
        'aria-label',
        'aria-labelledby',
        "autoFocus",
        "children",
        "iconAfter",
        "iconBefore",
        "interactionName",
        "isDisabled",
        "isLoading",
        "isSelected",
        "onClick",
        "onClickCapture",
        "onKeyDownCapture",
        "onKeyUpCapture",
        "onMouseDownCapture",
        "onMouseUpCapture",
        "onPointerDownCapture",
        "onPointerUpCapture",
        "onTouchEndCapture",
        "onTouchStartCapture",
        "shouldFitContainer",
        "spacing",
        "testId",
        "type"
    ]);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, _objectWithoutProperties._)(unsafeRest, [
        "className",
        "css",
        "as",
        "style"
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _buttonBaseDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({
        analyticsContext: analyticsContext,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        hasIconBefore: Boolean(iconBefore),
        hasIconAfter: Boolean(iconAfter),
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "Button",
        type: type,
        interactionName: interactionName
    }, saferRest), {
        children: [
            iconBefore && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _contentDefault.default), {
                type: "icon",
                position: "before",
                isLoading: isLoading,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconRendererDefault.default), {
                    icon: iconBefore
                })
            }),
            children && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _contentDefault.default), {
                isLoading: isLoading,
                children: children
            }),
            iconAfter && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _contentDefault.default), {
                type: "icon",
                position: "after",
                isLoading: isLoading,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconRendererDefault.default), {
                    icon: iconAfter
                })
            })
        ]
    }));
}));
Button.displayName = 'Button';
exports.default = Button;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react/jsx-runtime":"bGvcw","react":"ltHCL","../shared/button-base":"110EZ","../shared/content":"fpGG7","../shared/icon-renderer":"7uYJp","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"110EZ":[function(require,module,exports,__globalThis) {
/* button-base.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _runtime = require("@compiled/react/runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _css = require("@atlaskit/css");
var _mergeRefs = require("@atlaskit/ds-lib/merge-refs");
var _mergeRefsDefault = parcelHelpers.interopDefault(_mergeRefs);
var _useAutoFocus = require("@atlaskit/ds-lib/use-auto-focus");
var _useAutoFocusDefault = parcelHelpers.interopDefault(_useAutoFocus);
var _useId = require("@atlaskit/ds-lib/use-id");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _compiled = require("@atlaskit/primitives/compiled");
var _visuallyHidden = require("@atlaskit/visually-hidden");
var _visuallyHiddenDefault = parcelHelpers.interopDefault(_visuallyHidden);
var _splitButtonContext = require("../../containers/split-button/split-button-context");
var _useSplitButtonContext = require("../../containers/split-button/use-split-button-context");
var _blockEvents = require("./block-events");
var _blockEventsDefault = parcelHelpers.interopDefault(_blockEvents);
var _loadingOverlay = require("./loading-overlay");
var _loadingOverlayDefault = parcelHelpers.interopDefault(_loadingOverlay);
var LOADING_LABEL = ', Loading';
var styles = {
    base: "_2rkofajl _11c8fhey _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    baseT26Shape: "_2rko1qi0",
    linkDecorationUnset: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _syaz1gmx _30l31gmx _9h8h1gmx",
    sharedDisabled: "_bfhkby5v _irr3by5v _1di6by5v",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    spacingCompactT26Shape: "_2rko12b0",
    circle: "_2rko1rr0",
    fullWidth: "_1bsb1osq",
    loading: "_80om15jw",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    iconButtonCompact: "_4t3i1k8s _1bsb1k8s",
    buttonIconBefore: "_bozgutpp _gy1p12x7",
    buttonIconAfter: "_y4tiutpp _gy1p12x7",
    splitButton: "_g0pbb4wl",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t",
    navigationSplitButton: "_1bsb1tcg _bfhksm61 _y4ti12x7 _bozg12x7"
};
var defaultStyles = {
    root: "_bfhksm61 _syazazsu _8l3m1l7x _aetrb3bt _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
var primaryStyles = {
    root: "_bfhk1856 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3hf2y _9h8h15cr _1di6g6ey"
};
var warningStyles = {
    root: "_bfhk1kmu _syaz1yd3 _10531yd3 _f8pj1yd3 _30l31yd3 _9h8h1yd3",
    interactive: "_30l31yd3 _irr31spp _9h8h1yd3 _1di64m4m"
};
var dangerStyles = {
    root: "_bfhkybec _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3s9hg _9h8h15cr _1di613a9"
};
var discoveryStyles = {
    root: "_bfhku5tj _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3fqeg _9h8h15cr _1di61f1m"
};
var subtleStyles = {
    root: "_bfhksm61 _syazazsu _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
var selectedStyles = {
    root: "_bfhk15s3 _syaz6x5g _8l3mq98m _aetrb3bt _10536x5g _f8pj6x5g _30l36x5g _9h8h6x5g",
    insideSplitButton: "_1pbycs5v",
    interactive: "_irr3ufnl _30l36x5g _1di6nozp _9h8h6x5g",
    warning: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    danger: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    discovery: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3"
};
/**
 * __button base__
 *
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var ButtonBase = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
function(_param, ref) {
    var propAppearance = _param.appearance, _param_autoFocus = _param.autoFocus, autoFocus = _param_autoFocus === void 0 ? false : _param_autoFocus, tmp = _param.isDisabled, propIsDisabled = tmp === void 0 ? false : tmp, _param_isLoading = _param.isLoading, isLoading = _param_isLoading === void 0 ? false : _param_isLoading, tmp1 = _param.isSelected, propIsSelected = tmp1 === void 0 ? false : tmp1, _param_isIconButton = _param.isIconButton, isIconButton = _param_isIconButton === void 0 ? false : _param_isIconButton, _param_isCircle = _param.isCircle, isCircle = _param_isCircle === void 0 ? false : _param_isCircle, _param_hasIconBefore = _param.hasIconBefore, hasIconBefore = _param_hasIconBefore === void 0 ? false : _param_hasIconBefore, _param_hasIconAfter = _param.hasIconAfter, hasIconAfter = _param_hasIconAfter === void 0 ? false : _param_hasIconAfter, _param_shouldFitContainer = _param.shouldFitContainer, shouldFitContainer = _param_shouldFitContainer === void 0 ? false : _param_shouldFitContainer, tmp2 = _param.spacing, propSpacing = tmp2 === void 0 ? 'default' : tmp2, ariaLabel = _param.ariaLabel, ariaLabelledBy = _param.ariaLabelledBy, children = _param.children, interactionName = _param.interactionName, onClick = _param.onClick, onMouseDown = _param.onMouseDown, onMouseDownCapture = _param.onMouseDownCapture, onMouseUp = _param.onMouseUp, onMouseUpCapture = _param.onMouseUpCapture, onKeyDown = _param.onKeyDown, onKeyDownCapture = _param.onKeyDownCapture, onKeyUp = _param.onKeyUp, onKeyUpCapture = _param.onKeyUpCapture, onTouchStart = _param.onTouchStart, onTouchStartCapture = _param.onTouchStartCapture, onTouchEnd = _param.onTouchEnd, onTouchEndCapture = _param.onTouchEndCapture, onPointerDown = _param.onPointerDown, onPointerDownCapture = _param.onPointerDownCapture, onPointerUp = _param.onPointerUp, onPointerUpCapture = _param.onPointerUpCapture, onClickCapture = _param.onClickCapture, testId = _param.testId, analyticsContext = _param.analyticsContext, componentName = _param.componentName, role = _param.role, onMouseOver = _param.onMouseOver, onMouseOut = _param.onMouseOut, onFocus = _param.onFocus, onBlur = _param.onBlur, onMouseMove = _param.onMouseMove, type = _param.type, unsafeRest = (0, _objectWithoutProperties._)(_param, [
        "appearance",
        "autoFocus",
        "isDisabled",
        "isLoading",
        "isSelected",
        "isIconButton",
        "isCircle",
        "hasIconBefore",
        "hasIconAfter",
        "shouldFitContainer",
        "spacing",
        "ariaLabel",
        "ariaLabelledBy",
        "children",
        "interactionName",
        "onClick",
        "onMouseDown",
        "onMouseDownCapture",
        "onMouseUp",
        "onMouseUpCapture",
        "onKeyDown",
        "onKeyDownCapture",
        "onKeyUp",
        "onKeyUpCapture",
        "onTouchStart",
        "onTouchStartCapture",
        "onTouchEnd",
        "onTouchEndCapture",
        "onPointerDown",
        "onPointerDownCapture",
        "onPointerUp",
        "onPointerUpCapture",
        "onClickCapture",
        "testId",
        "analyticsContext",
        "componentName",
        "role",
        "onMouseOver",
        "onMouseOut",
        "onFocus",
        "onBlur",
        "onMouseMove",
        "type"
    ]);
    var localRef = (0, _react.useRef)(null);
    var splitButtonContext = (0, _useSplitButtonContext.useSplitButtonContext)();
    var loadingLabelId = (0, _useId.useId)();
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === 'default';
    var appearance = isDefaultAppearanceSplitButton ? 'subtle' : propAppearance || (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || 'default';
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    var isEffectivelyDisabled = isDisabled || isLoading;
    var isSelected = propIsSelected && !isDisabled;
    (0, _useAutoFocusDefault.default)(localRef, autoFocus);
    // @ts-expect-error
    var _className = unsafeRest.className, _css1 = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, _objectWithoutProperties._)(unsafeRest, [
        "className",
        "css",
        "as",
        "style"
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _compiled.Pressable), (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, saferRest), {
        componentName: componentName || 'button',
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, _mergeRefsDefault.default)([
            localRef,
            ref
        ]),
        xcss: (0, _css.cx)(styles.base, (0, _platformFeatureFlags.fg)('platform-dst-shape-theme-default') && styles.baseT26Shape, appearance === 'default' && defaultStyles.root, appearance === 'default' && isInteractive && defaultStyles.interactive, appearance === 'primary' && primaryStyles.root, appearance === 'primary' && isInteractive && primaryStyles.interactive, appearance === 'warning' && warningStyles.root, appearance === 'warning' && isInteractive && warningStyles.interactive, appearance === 'danger' && dangerStyles.root, appearance === 'danger' && isInteractive && dangerStyles.interactive, appearance === 'discovery' && discoveryStyles.root, appearance === 'discovery' && isInteractive && discoveryStyles.interactive, appearance === 'subtle' && subtleStyles.root, appearance === 'subtle' && isInteractive && subtleStyles.interactive, styles.linkDecorationUnset, isSelected && selectedStyles.root, isSelected && isSplitButton && selectedStyles.insideSplitButton, isSelected && isInteractive && selectedStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'danger' && selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'warning' && selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && selectedStyles.discovery, isDisabled && styles.disabled, isDisabled && appearance !== 'default' && appearance !== 'subtle' && styles.sharedDisabled, isDisabled && appearance === 'default' && defaultStyles.disabled, isCircle && !isSplitButton && styles.circle, spacing === 'compact' && styles.spacingCompact, spacing === 'compact' && (0, _platformFeatureFlags.fg)('platform-dst-shape-theme-default') && styles.spacingCompactT26Shape, shouldFitContainer && styles.fullWidth, hasIconBefore && styles.buttonIconBefore, hasIconAfter && styles.buttonIconAfter, isIconButton && styles.iconButton, isIconButton && spacing === 'compact' && styles.iconButtonCompact, isLoading && styles.loading, isSplitButton && styles.splitButton, isNavigationSplitButton && styles.navigationSplitButton),
        isDisabled: (0, _platformFeatureFlags.fg)('platform-dst_fix_not_focusable_loading_button') ? isDisabled : isEffectivelyDisabled
    }), (0, _platformFeatureFlags.fg)('platform-dst_fix_not_focusable_loading_button') && {
        'aria-live': 'polite'
    }, isLoading && (0, _platformFeatureFlags.fg)('platform-dst_fix_not_focusable_loading_button') && {
        'aria-disabled': true
    }), {
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? "".concat(ariaLabel, " ").concat(LOADING_LABEL) : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? "".concat(ariaLabelledBy, " ").concat(loadingLabelId) : ariaLabelledBy,
        onClick: onClick
    }), (0, _blockEventsDefault.default)(isEffectivelyDisabled, {
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    })), {
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _splitButtonContext.SplitButtonContext).Provider, {
            value: undefined,
            children: [
                children,
                isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: (0, _runtime.ax)([
                        styles.loadingOverlay
                    ]),
                    children: (0, _loadingOverlayDefault.default)({
                        spacing: spacing,
                        appearance: appearance,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        testId: testId
                    })
                }),
                isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _visuallyHiddenDefault.default), {
                    id: loadingLabelId,
                    children: LOADING_LABEL
                })
            ]
        })
    }));
});
exports.default = ButtonBase;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react/jsx-runtime":"bGvcw","@compiled/react/runtime":"d27Vo","react":"ltHCL","@atlaskit/css":"fiaHp","@atlaskit/ds-lib/merge-refs":"bhv2L","@atlaskit/ds-lib/use-auto-focus":"2jsXQ","@atlaskit/ds-lib/use-id":"axFod","@atlaskit/platform-feature-flags":"kO5t9","@atlaskit/primitives/compiled":"jhQE8","@atlaskit/visually-hidden":"lj6Zq","../../containers/split-button/split-button-context":"alRa3","../../containers/split-button/use-split-button-context":"4TC10","./block-events":"8i2mf","./loading-overlay":"hKQ4S","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bhv2L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return mergeRefs;
});
var _typeOf = require("@swc/helpers/_/_type_of");
function mergeRefs(refs) {
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === 'function') ref(value);
            else if (ref !== null && (typeof ref === "undefined" ? "undefined" : (0, _typeOf._)(ref)) === 'object') ref.current = value;
        });
    };
}

},{"@swc/helpers/_/_type_of":"iFJdx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2jsXQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return useAutoFocus;
});
var _react = require("react");
function useAutoFocus(ref, autoFocus) {
    var initialMount = (0, _react.useRef)(true);
    (0, _react.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"alRa3":[function(require,module,exports,__globalThis) {
/* eslint-disable @repo/internal/react/require-jsdoc */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SplitButtonContext", function() {
    return SplitButtonContext;
});
var _react = require("react");
var SplitButtonContext = /*#__PURE__*/ (0, _react.createContext)(undefined);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4TC10":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSplitButtonContext", function() {
    return useSplitButtonContext;
});
var _react = require("react");
var _splitButtonContext = require("./split-button-context");
var useSplitButtonContext = function() {
    var context = (0, _react.useContext)((0, _splitButtonContext.SplitButtonContext));
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        var newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

},{"react":"ltHCL","./split-button-context":"alRa3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8i2mf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return blockEvents;
});
function abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var tabKeyCode = 9;
function onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === tabKeyCode) return;
    abort(event);
}
function blockEvents(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: abort,
        onMouseUpCapture: abort,
        onKeyDownCapture: onKey,
        onKeyUpCapture: onKey,
        onTouchStartCapture: abort,
        onTouchEndCapture: abort,
        onPointerDownCapture: abort,
        onPointerUpCapture: abort,
        onClickCapture: abort,
        // Just smashing the existing onClick for good measure
        onClick: abort
    } : events;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hKQ4S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return renderLoadingOverlay;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _spinner = require("@atlaskit/spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
function getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        default:
            return 'medium';
    }
}
function getSpinnerAppearance(param) {
    var appearance = param.appearance, isDisabled = param.isDisabled, isSelected = param.isSelected;
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function renderLoadingOverlay(param) {
    var appearance = param.appearance, spacing = param.spacing, isDisabled = param.isDisabled, isSelected = param.isSelected, testId = param.testId;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {
        size: getIconSpacing(spacing),
        appearance: getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    });
}

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","@atlaskit/spinner":"04ZYE","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"04ZYE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return 0, _spinnerDefault.default;
});
var _spinner = require("./spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);

},{"./spinner":"clJd3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"clJd3":[function(require,module,exports,__globalThis) {
/* spinner.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _runtime = require("@compiled/react/runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _interactionContext = require("@atlaskit/interaction-context");
var _interactionContextDefault = parcelHelpers.interopDefault(_interactionContext);
var _constants = require("./constants");
/**
 * Returns the appropriate circle stroke color.
 */ function getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-inverse, #FFFFFF)";
}
var rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ var loadIn = null;
var styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o51q7pw",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var useLayoutEffect = typeof window === 'undefined' ? (0, _react.useEffect) : (0, _react.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var Spinner = /*#__PURE__*/ (0, _reactDefault.default).memo(/*#__PURE__*/ (0, _reactDefault.default).forwardRef(function Spinner(param, ref) {
    var _param_appearance = param.appearance, appearance = _param_appearance === void 0 ? 'inherit' : _param_appearance, _param_delay = param.delay, delay = _param_delay === void 0 ? 0 : _param_delay, interactionName = param.interactionName, label = param.label, tmp = param.size, providedSize = tmp === void 0 ? 'medium' : tmp, testId = param.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, _constants.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = getStrokeColor(appearance);
    var context = (0, _react.useContext)((0, _interactionContextDefault.default));
    useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        /**
   * This span exists to off-load animations from the circle element,
   * which were causing performance issues (style recalculations)
   * on Safari and older versions of Chrome.
   *
   * This can be removed and styles placed back on the circle element once
   * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
   */ "data-testid": testId ? "".concat(testId, "-wrapper") : 'spinner-wrapper',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, _runtime.ax)([
            styles.wrapperStyles,
            styles.rotateStyles
        ]),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
            height: size,
            width: size,
            viewBox: "0 0 16 16",
            xmlns: "http://www.w3.org/2000/svg",
            "data-testid": testId,
            ref: ref,
            "aria-label": label || undefined,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                animationDelay: animationDelay
            },
            role: label ? 'img' : 'none',
            className: (0, _runtime.ax)([
                styles.loadInStyles
            ]),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: "8",
                cy: "8",
                r: "7",
                style: {
                    stroke: stroke
                },
                className: (0, _runtime.ax)([
                    styles.circleStyles
                ])
            })
        })
    });
}));
exports.default = Spinner;

},{"react/jsx-runtime":"bGvcw","@compiled/react/runtime":"d27Vo","react":"ltHCL","@atlaskit/interaction-context":"4Lyu9","./constants":"icyjx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"icyjx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "presetSizes", function() {
    return presetSizes;
});
var presetSizes = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fpGG7":[function(require,module,exports,__globalThis) {
/* content.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _runtime = require("@compiled/react/runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var styles = {
    text: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1bto1l2s _o5721q9c",
    icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _1wybidpf _vwz4idpf _uiztglyw",
    common: "_v564g17y",
    fade: "_tzy4idpf"
};
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ var Content = function(param) {
    var children = param.children, _param_type = param.type, type = _param_type === void 0 ? 'text' : _param_type, isLoading = param.isLoading;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: (0, _runtime.ax)([
            styles.common,
            type === 'text' && styles.text,
            type === 'icon' && styles.icon,
            isLoading && styles.fade
        ]),
        children: children
    });
};
exports.default = Content;

},{"react/jsx-runtime":"bGvcw","@compiled/react/runtime":"d27Vo","react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7uYJp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
function isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ var IconRenderer = function(param) {
    var Icon = param.icon;
    var isRenderProp = isIconRenderProp(Icon);
    var iconProps = {
        label: '',
        color: 'currentColor',
        size: (0, _platformFeatureFlags.fg)('platform_dst_button_chevron_sizing') ? function(iconName) {
            return iconName.startsWith('Chevron') ? 'small' : 'medium';
        } : undefined
    };
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(Icon, (0, _objectSpread._)({}, iconProps))
    });
};
exports.default = IconRenderer;

},{"@swc/helpers/_/_object_spread":"9gdrV","react/jsx-runtime":"bGvcw","react":"ltHCL","@atlaskit/platform-feature-flags":"kO5t9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eXHSj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _mergeRefs = require("@atlaskit/ds-lib/merge-refs");
var _mergeRefsDefault = parcelHelpers.interopDefault(_mergeRefs);
var _tooltip = require("@atlaskit/tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _visuallyHidden = require("@atlaskit/visually-hidden");
var _visuallyHiddenDefault = parcelHelpers.interopDefault(_visuallyHidden);
var _buttonBase = require("../shared/button-base");
var _buttonBaseDefault = parcelHelpers.interopDefault(_buttonBase);
var _content = require("../shared/content");
var _contentDefault = parcelHelpers.interopDefault(_content);
var _iconRenderer = require("../shared/icon-renderer");
var _iconRendererDefault = parcelHelpers.interopDefault(_iconRenderer);
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ var IconButton = /*#__PURE__*/ (0, _reactDefault.default).memo(/*#__PURE__*/ (0, _reactDefault.default).forwardRef(function Button(_param, ref) {
    var // Prevent duplicate labels being added.
    preventedAriaLabel = _param['aria-label'], ariaLabelledBy = _param['aria-labelledby'], analyticsContext = _param.analyticsContext, appearance = _param.appearance, autoFocus = _param.autoFocus, icon = _param.icon, interactionName = _param.interactionName, isDisabled = _param.isDisabled, _param_isLoading = _param.isLoading, isLoading = _param_isLoading === void 0 ? false : _param_isLoading, isSelected = _param.isSelected, _param_isTooltipDisabled = _param.isTooltipDisabled, isTooltipDisabled = _param_isTooltipDisabled === void 0 ? true : _param_isTooltipDisabled, label = _param.label, onClick = _param.onClick, onClickCapture = _param.onClickCapture, onKeyDownCapture = _param.onKeyDownCapture, onKeyUpCapture = _param.onKeyUpCapture, onMouseDownCapture = _param.onMouseDownCapture, onMouseUpCapture = _param.onMouseUpCapture, onPointerDownCapture = _param.onPointerDownCapture, onPointerUpCapture = _param.onPointerUpCapture, onTouchEndCapture = _param.onTouchEndCapture, onTouchStartCapture = _param.onTouchStartCapture, shape = _param.shape, spacing = _param.spacing, testId = _param.testId, tooltip = _param.tooltip, _param_type = _param.type, type = _param_type === void 0 ? 'button' : _param_type, unsafeRest = (0, _objectWithoutProperties._)(_param, [
        'aria-label',
        'aria-labelledby',
        "analyticsContext",
        "appearance",
        "autoFocus",
        "icon",
        "interactionName",
        "isDisabled",
        "isLoading",
        "isSelected",
        "isTooltipDisabled",
        "label",
        "onClick",
        "onClickCapture",
        "onKeyDownCapture",
        "onKeyUpCapture",
        "onMouseDownCapture",
        "onMouseUpCapture",
        "onPointerDownCapture",
        "onPointerUpCapture",
        "onTouchEndCapture",
        "onTouchStartCapture",
        "shape",
        "spacing",
        "testId",
        "tooltip",
        "type"
    ]);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, _objectWithoutProperties._)(unsafeRest, [
        "className",
        "css",
        "as",
        "style"
    ]);
    if (isTooltipDisabled) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonBaseDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, saferRest), {
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: shape === 'circle',
        hasIconBefore: !!icon,
        spacing: spacing,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        type: type,
        interactionName: interactionName,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _contentDefault.default), {
            type: "icon",
            isLoading: isLoading,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconRendererDefault.default), {
                    icon: icon
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _visuallyHiddenDefault.default), {
                    children: label
                })
            ]
        })
    }));
    var _tooltip_content;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
        content: (_tooltip_content = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip_content !== void 0 ? _tooltip_content : label,
        testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
        position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
        delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
        onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
        onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
        mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
        analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
        strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
        tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
        truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
        component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
        hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents,
        shortcut: tooltip === null || tooltip === void 0 ? void 0 : tooltip.shortcut,
        children: function(triggerProps) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonBaseDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, saferRest), {
                appearance: appearance,
                autoFocus: autoFocus,
                isDisabled: isDisabled,
                isLoading: isLoading,
                isSelected: isSelected,
                isIconButton: true,
                isCircle: shape === 'circle',
                hasIconBefore: false,
                spacing: spacing,
                ariaLabelledBy: ariaLabelledBy,
                onClick: function(e, analyticsEvent) {
                    var _triggerProps_onClick;
                    onClick === null || onClick === void 0 ? void 0 : onClick(e, analyticsEvent);
                    (_triggerProps_onClick = triggerProps.onClick) === null || _triggerProps_onClick === void 0 ? void 0 : _triggerProps_onClick.call(triggerProps, e);
                },
                onMouseOver: function(e) {
                    var _triggerProps_onMouseOver, _saferRest_onMouseOver;
                    (_triggerProps_onMouseOver = triggerProps.onMouseOver) === null || _triggerProps_onMouseOver === void 0 ? void 0 : _triggerProps_onMouseOver.call(triggerProps, e);
                    (_saferRest_onMouseOver = saferRest.onMouseOver) === null || _saferRest_onMouseOver === void 0 ? void 0 : _saferRest_onMouseOver.call(saferRest, e);
                },
                onMouseOut: function(e) {
                    var _triggerProps_onMouseOut, _saferRest_onMouseOut;
                    (_triggerProps_onMouseOut = triggerProps.onMouseOut) === null || _triggerProps_onMouseOut === void 0 ? void 0 : _triggerProps_onMouseOut.call(triggerProps, e);
                    (_saferRest_onMouseOut = saferRest.onMouseOut) === null || _saferRest_onMouseOut === void 0 ? void 0 : _saferRest_onMouseOut.call(saferRest, e);
                },
                onMouseMove: function(e) {
                    var _triggerProps_onMouseMove, _saferRest_onMouseMove;
                    (_triggerProps_onMouseMove = triggerProps.onMouseMove) === null || _triggerProps_onMouseMove === void 0 ? void 0 : _triggerProps_onMouseMove.call(triggerProps, e);
                    (_saferRest_onMouseMove = saferRest.onMouseMove) === null || _saferRest_onMouseMove === void 0 ? void 0 : _saferRest_onMouseMove.call(saferRest, e);
                },
                onMouseDown: function(e) {
                    var _triggerProps_onMouseDown, _saferRest_onMouseDown;
                    (_triggerProps_onMouseDown = triggerProps.onMouseDown) === null || _triggerProps_onMouseDown === void 0 ? void 0 : _triggerProps_onMouseDown.call(triggerProps, e);
                    (_saferRest_onMouseDown = saferRest.onMouseDown) === null || _saferRest_onMouseDown === void 0 ? void 0 : _saferRest_onMouseDown.call(saferRest, e);
                },
                onFocus: function(e) {
                    var _triggerProps_onFocus, _saferRest_onFocus;
                    (_triggerProps_onFocus = triggerProps.onFocus) === null || _triggerProps_onFocus === void 0 ? void 0 : _triggerProps_onFocus.call(triggerProps, e);
                    (_saferRest_onFocus = saferRest.onFocus) === null || _saferRest_onFocus === void 0 ? void 0 : _saferRest_onFocus.call(saferRest, e);
                },
                onBlur: function(e) {
                    var _triggerProps_onBlur, _saferRest_onBlur;
                    (_triggerProps_onBlur = triggerProps.onBlur) === null || _triggerProps_onBlur === void 0 ? void 0 : _triggerProps_onBlur.call(triggerProps, e);
                    (_saferRest_onBlur = saferRest.onBlur) === null || _saferRest_onBlur === void 0 ? void 0 : _saferRest_onBlur.call(saferRest, e);
                },
                ref: (0, _mergeRefsDefault.default)([
                    ref,
                    triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.ref
                ].filter(Boolean)),
                onMouseDownCapture: onMouseDownCapture,
                onMouseUpCapture: onMouseUpCapture,
                onKeyDownCapture: onKeyDownCapture,
                onKeyUpCapture: onKeyUpCapture,
                onTouchStartCapture: onTouchStartCapture,
                onTouchEndCapture: onTouchEndCapture,
                onPointerDownCapture: onPointerDownCapture,
                onPointerUpCapture: onPointerUpCapture,
                onClickCapture: onClickCapture,
                type: type,
                testId: testId,
                analyticsContext: analyticsContext,
                interactionName: interactionName,
                componentName: "IconButton",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _contentDefault.default), {
                    type: "icon",
                    isLoading: isLoading,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconRendererDefault.default), {
                            icon: icon
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _visuallyHiddenDefault.default), {
                            children: label
                        })
                    ]
                })
            }));
        }
    });
}));
IconButton.displayName = 'IconButton';
exports.default = IconButton;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react/jsx-runtime":"bGvcw","react":"ltHCL","@atlaskit/ds-lib/merge-refs":"bhv2L","@atlaskit/tooltip":"47wSA","@atlaskit/visually-hidden":"lj6Zq","../shared/button-base":"110EZ","../shared/content":"fpGG7","../shared/icon-renderer":"7uYJp","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"47wSA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return 0, _tooltipDefault.default;
});
parcelHelpers.export(exports, "TooltipPrimitive", function() {
    return 0, _tooltipPrimitiveDefault.default;
});
var _tooltip = require("./tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _tooltipPrimitive = require("./tooltip-primitive");
var _tooltipPrimitiveDefault = parcelHelpers.interopDefault(_tooltipPrimitive);

},{"./tooltip":"9J0yo","./tooltip-primitive":"46h4l","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9J0yo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _bindEventListener = require("bind-event-listener");
var _analyticsNext = require("@atlaskit/analytics-next");
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var _useCloseOnEscapePress = require("@atlaskit/ds-lib/use-close-on-escape-press");
var _useCloseOnEscapePressDefault = parcelHelpers.interopDefault(_useCloseOnEscapePress);
var _useStableRef = require("@atlaskit/ds-lib/use-stable-ref");
var _useStableRefDefault = parcelHelpers.interopDefault(_useStableRef);
var _openLayerObserver = require("@atlaskit/layering/experimental/open-layer-observer");
var _motion = require("@atlaskit/motion");
var _popper = require("@atlaskit/popper");
var _portal = require("@atlaskit/portal");
var _portalDefault = parcelHelpers.interopDefault(_portal);
var _constants = require("@atlaskit/theme/constants");
var _dragManager = require("./internal/drag-manager");
var _getVirtualElementFromMousePos = require("./internal/get-virtual-element-from-mouse-pos");
var _tooltipManager = require("./internal/tooltip-manager");
var _useUniqueId = require("./internal/use-unique-id");
var _useUniqueIdDefault = parcelHelpers.interopDefault(_useUniqueId);
var _tooltipContainer = require("./tooltip-container");
var _tooltipContainerDefault = parcelHelpers.interopDefault(_tooltipContainer);
var tooltipZIndex = (0, _constants.layers).tooltip();
var analyticsAttributes = {
    componentName: 'tooltip',
    packageName: undefined,
    packageVersion: undefined
};
// Inverts motion direction
var invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var getDirectionFromPlacement = function(placement) {
    return placement.split('-')[0];
};
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function Tooltip(param) {
    var children = param.children, _param_position = param.position, position = _param_position === void 0 ? 'bottom' : _param_position, _param_mousePosition = param.mousePosition, mousePosition = _param_mousePosition === void 0 ? 'bottom' : _param_mousePosition, content = param.content, _param_truncate = param.truncate, truncate = _param_truncate === void 0 ? false : _param_truncate, tmp = param.// @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
    component, Container = tmp === void 0 ? (0, _tooltipContainerDefault.default) : tmp, tmp1 = param.tag, TargetContainer = tmp1 === void 0 ? 'div' : tmp1, testId = param.testId, _param_delay = param.delay, delay = _param_delay === void 0 ? 300 : _param_delay, _param_onShow = param.onShow, onShow = _param_onShow === void 0 ? (0, _noopDefault.default) : _param_onShow, _param_onHide = param.onHide, onHide = _param_onHide === void 0 ? (0, _noopDefault.default) : _param_onHide, canAppear = param.canAppear, _param_hideTooltipOnClick = param.hideTooltipOnClick, hideTooltipOnClick = _param_hideTooltipOnClick === void 0 ? false : _param_hideTooltipOnClick, _param_hideTooltipOnMouseDown = param.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _param_hideTooltipOnMouseDown === void 0 ? false : _param_hideTooltipOnMouseDown, analyticsContext = param.analyticsContext, _param_strategy = param.strategy, strategy = _param_strategy === void 0 ? 'fixed' : _param_strategy, _param_ignoreTooltipPointerEvents = param.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _param_ignoreTooltipPointerEvents === void 0 ? false : _param_ignoreTooltipPointerEvents, _param_isScreenReaderAnnouncementDisabled = param.isScreenReaderAnnouncementDisabled, isScreenReaderAnnouncementDisabled = _param_isScreenReaderAnnouncementDisabled === void 0 ? false : _param_isScreenReaderAnnouncementDisabled, shortcut = param.shortcut, _param_shouldAlwaysFadeIn = param.shouldAlwaysFadeIn, shouldAlwaysFadeIn = _param_shouldAlwaysFadeIn === void 0 ? false : _param_shouldAlwaysFadeIn, _param_shouldRenderToParent = param.shouldRenderToParent, shouldRenderToParent = _param_shouldRenderToParent === void 0 ? false : _param_shouldRenderToParent;
    // Not using a gate for this check. When the gate is disabled `mouse-y` and `mouse-x` are treated as `mouse`.
    var isMousePosition = position === 'mouse' || position === 'mouse-y' || position === 'mouse-x';
    var tooltipPosition = isMousePosition ? mousePosition : position;
    var onShowHandler = (0, _analyticsNext.usePlatformLeafSyntheticEventHandler)((0, _objectSpread._)({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext
    }, analyticsAttributes));
    var onHideHandler = (0, _analyticsNext.usePlatformLeafSyntheticEventHandler)((0, _objectSpread._)({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext
    }, analyticsAttributes));
    var apiRef = (0, _react.useRef)(null);
    var _useState = (0, _slicedToArray._)((0, _react.useState)('hide'), 2), state = _useState[0], setState = _useState[1];
    var targetRef = (0, _react.useRef)(null);
    var containerRef = (0, _react.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, _react.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var stableState = (0, _useStableRefDefault.default)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    var onShowHandlerStable = (0, _useStableRefDefault.default)(onShowHandler);
    var onHideHandlerStable = (0, _useStableRefDefault.default)(onHideHandler);
    var delayStable = (0, _useStableRefDefault.default)(delay);
    var canAppearStable = (0, _useStableRefDefault.default)(canAppear);
    var hasCalledShowHandler = (0, _react.useRef)(false);
    var shouldAlwaysFadeInStable = (0, _useStableRefDefault.default)(shouldAlwaysFadeIn);
    var start = (0, _react.useCallback)(function(api) {
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, _react.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        apiRef.current = null;
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    var abort = (0, _react.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, _react.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, _react.useRef)(false);
    (0, _react.useEffect)(function() {
        return (0, _dragManager.register)({
            onRegister: function onRegister(param) {
                var isDragging = param.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var /**
				 * Hiding any visible tooltips when a drag starts because otherwise it
				 * looks janky (disappears and reappears), and is not required.
				 */ _apiRef_current;
                (_apiRef_current = apiRef.current) === null || _apiRef_current === void 0 ? void 0 : _apiRef_current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var tryShowTooltip = (0, _react.useCallback)(function(source) {
        var _canAppearStable_current;
        /**
			 * Prevent tooltips from being shown during a drag. This can occur with
			 * the native drag and drop API, where some pointer events can fire
			 * when they should not and lead to jank with tooltips.
			 */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
			 * Check if tooltip is allowed to show.
			 *
			 * Once a tooltip has started, or has scheduled to start
			 * we won't be checking `canAppear` again.
			 *
			 * - We don't want tooltips to disappear once they are shown
			 * - For consistency, we start after a single positive `canAppear`.
			 *   Otherwise the amount of times we ask consumers would depend on
			 *   how many times we get a "mousemove", which _could_ lead to situations
			 *   where moving the mouse could result in a different outcome to if
			 *   the mouse was not moved.
			 */ if (canAppearStable.current && !((_canAppearStable_current = canAppearStable.current) === null || _canAppearStable_current === void 0 ? void 0 : _canAppearStable_current.call(canAppearStable))) return;
        var entry = {
            source: source,
            delay: delayStable.current,
            show: function(param) {
                var isImmediate = param.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(!isImmediate ? 'fade-in' : 'show-immediate');
            },
            hide: function(param) {
                var isImmediate = param.isImmediate;
                if (isImmediate) setState('hide');
                else setState('before-fade-out');
            },
            done: done,
            shouldAlwaysFadeIn: shouldAlwaysFadeInStable.current
        };
        var api = (0, _tooltipManager.show)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable,
        shouldAlwaysFadeInStable
    ]);
    var hideTooltipOnEsc = (0, _react.useCallback)(function() {
        var _apiRef_current;
        (_apiRef_current = apiRef.current) === null || _apiRef_current === void 0 ? void 0 : _apiRef_current.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, _useCloseOnEscapePressDefault.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out'
    });
    (0, _react.useEffect)(function() {
        if (state === 'hide') return 0, _noopDefault.default;
        if (state === 'before-fade-out') setState('fade-out');
        var unbind = (0, _bindEventListener.bind)(window, {
            type: 'scroll',
            listener: function() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, _react.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, _react.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, _react.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = isMousePosition ? {
            type: 'mouse',
            clientX: event.clientX,
            clientY: event.clientY
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        isMousePosition,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, _react.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = isMousePosition ? function(event) {
        var _apiRef_current;
        if ((_apiRef_current = apiRef.current) === null || _apiRef_current === void 0 ? void 0 : _apiRef_current.isActive()) apiRef.current.mousePos = {
            clientX: event.clientX,
            clientY: event.clientY
        };
    } : undefined;
    var onMouseOverTooltip = (0, _react.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, _react.useCallback)(function(e) {
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (!e.target.matches(':focus-visible')) return;
        } catch (e) {
        // Ignore errors from environments that don't support :focus-visible
        }
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    var onBlur = (0, _react.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, _react.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    var shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    var shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out';
    var handleOpenLayerObserverCloseSignal = (0, _react.useCallback)(function() {
        var _apiRef_current;
        (_apiRef_current = apiRef.current) === null || _apiRef_current === void 0 ? void 0 : _apiRef_current.requestHide({
            isImmediate: true
        });
    }, []);
    (0, _openLayerObserver.useNotifyOpenLayerObserver)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: shouldRenderTooltipPopup && shouldRenderTooltipChildren,
        /**
		 * We don't strictly need to provide an onClose callback at this time, as there is
		 * already code that handles hiding the tooltip when a drag is started (and the only
		 * usage right now is closing all layers when the user resizes the side nav).
		 *
		 * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
		 * whenever the open layer observer requests a close.
		 */ onClose: handleOpenLayerObserverCloseSignal
    });
    var getReferenceElement = function() {
        var _apiRef_current;
        if (isMousePosition && ((_apiRef_current = apiRef.current) === null || _apiRef_current === void 0 ? void 0 : _apiRef_current.mousePos) && targetRef.current) return (0, _getVirtualElementFromMousePos.getVirtualElementFromMousePos)(apiRef.current.mousePos, {
            targetElement: targetRef.current,
            tooltipPosition: position
        });
        return targetRef.current || undefined;
    };
    var tooltipIdForHiddenContent = (0, _useUniqueIdDefault.default)('tooltip', shouldRenderHiddenContent);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // Adding `data-testid` to the TriggerProps interface breaks Buttons, so we use type assertion
    tooltipTriggerProps['data-testid'] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    var isChildrenAFunction = typeof children === 'function';
    (0, _react.useEffect)(function() {
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        var target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return function() {
            return target.removeAttribute('aria-describedby');
        };
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    var hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent,
        children: typeof content === 'function' ? content({}) : content
    }) : null;
    var PopperWrapper = shouldRenderToParent ? (0, _react.Fragment) : TooltipPortal;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            typeof children === 'function' ? // once we deprecate the wrapped approach, we can put the aria
            // attribute back into the tooltipTriggerProps and make it required
            // instead of optional in `types`
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    children((0, _objectSpreadProps._)((0, _objectSpread._)({}, tooltipTriggerProps), {
                        'aria-describedby': tooltipIdForHiddenContent,
                        ref: setDirectRef
                    })),
                    hiddenContent
                ]
            }) : // @ts-ignore
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(CastTargetContainer, (0, _objectSpreadProps._)((0, _objectSpread._)({}, tooltipTriggerProps), {
                ref: setImplicitRefFromChildren,
                /**
					 * TODO: Why is role="presentation" added?
					 * - Is it only to "remove" the `Container` from screen readers?
					 * - Why is it added only to the `Container` but not to `tooltipTriggerProps`?
					 * - Should `role="presentation"` only be used if `shouldRenderHiddenContent == false`?
					 */ role: "presentation",
                children: [
                    children,
                    hiddenContent
                ]
            })),
            shouldRenderTooltipPopup ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(PopperWrapper, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popper.Popper), {
                    placement: tooltipPosition,
                    referenceElement: getReferenceElement(),
                    strategy: strategy,
                    children: function(param) {
                        var ref = param.ref, style = param.style, update = param.update, placement = param.placement;
                        // Invert the entrance and exit directions.
                        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
                        // This gives the effect the tooltip is appearing from the target
                        var direction = isMousePosition ? undefined : invertedDirection[getDirectionFromPlacement(placement)];
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _motion.ExitingPersistence), {
                            appear: true,
                            children: shouldRenderTooltipChildren && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _motion.FadeIn), {
                                distance: "constant",
                                entranceDirection: direction,
                                exitDirection: direction,
                                onFinish: onAnimationFinished,
                                duration: state !== 'show-immediate' ? 'medium' : 'none',
                                children: function(param) {
                                    var className = param.className;
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Container, {
                                        ref: ref,
                                        /**
													 * "Tooltip" classname is a hook used by tests to manipulate
													 * and hide tooltips, including in VR snapshots
													 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                        className: "Tooltip ".concat(className),
                                        style: (0, _objectSpread._)({}, style, ignoreTooltipPointerEvents && {
                                            pointerEvents: 'none'
                                        }),
                                        truncate: truncate,
                                        placement: tooltipPosition,
                                        testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                                        onMouseOut: onMouseOut,
                                        onMouseOver: onMouseOverTooltip,
                                        shortcut: shortcut,
                                        children: typeof content === 'function' ? content({
                                            update: update
                                        }) : content
                                    });
                                }
                            })
                        });
                    }
                })
            }) : null
        ]
    });
}
exports.default = Tooltip;
var TooltipPortal = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _portalDefault.default), {
        zIndex: tooltipZIndex,
        children: children
    });
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_sliced_to_array":"8PtL6","react/jsx-runtime":"bGvcw","react":"ltHCL","bind-event-listener":"bjeUU","@atlaskit/analytics-next":"auH4u","@atlaskit/ds-lib/noop":"2f3bg","@atlaskit/ds-lib/use-close-on-escape-press":"8IHoR","@atlaskit/ds-lib/use-stable-ref":"3aVRZ","@atlaskit/layering/experimental/open-layer-observer":"iPCuE","@atlaskit/motion":"gQd69","@atlaskit/popper":"bMYOE","@atlaskit/portal":"kqyHU","@atlaskit/theme/constants":"3DRjL","./internal/drag-manager":"cEys7","./internal/get-virtual-element-from-mouse-pos":"7uCDv","./internal/tooltip-manager":"c28bS","./internal/use-unique-id":"6kLTI","./tooltip-container":"d8DXj","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8IHoR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return useCloseOnEscapePress;
});
var _react = require("react");
var _bindEventListener = require("bind-event-listener");
var _keycodes = require("../utils/keycodes");
function useCloseOnEscapePress(param) {
    var onClose = param.onClose, isDisabled = param.isDisabled;
    var escapePressed = (0, _react.useRef)(false);
    var onKeyDown = (0, _react.useCallback)(function(e) {
        if (isDisabled || escapePressed.current || e.key !== (0, _keycodes.ESCAPE)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    var onKeyUp = (0, _react.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, _react.useEffect)(function() {
        // Don't attach document event listeners if the hook is disabled
        if (isDisabled) return;
        return (0, _bindEventListener.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp,
        isDisabled
    ]);
}

},{"react":"ltHCL","bind-event-listener":"bjeUU","../utils/keycodes":"fHxyW","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fHxyW":[function(require,module,exports,__globalThis) {
/**
 * Character key codes which can be used in keyboard events.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "KEY_UP", function() {
    return KEY_UP;
});
parcelHelpers.export(exports, "KEY_DOWN", function() {
    return KEY_DOWN;
});
parcelHelpers.export(exports, "KEY_LEFT", function() {
    return KEY_LEFT;
});
parcelHelpers.export(exports, "KEY_RIGHT", function() {
    return KEY_RIGHT;
});
parcelHelpers.export(exports, "KEY_HOME", function() {
    return KEY_HOME;
});
parcelHelpers.export(exports, "KEY_END", function() {
    return KEY_END;
});
parcelHelpers.export(exports, "KEY_TAB", function() {
    return KEY_TAB;
});
parcelHelpers.export(exports, "KEY_ENTER", function() {
    return KEY_ENTER;
});
parcelHelpers.export(exports, "KEY_SPACE", function() {
    return KEY_SPACE;
});
parcelHelpers.export(exports, "ESCAPE", function() {
    return ESCAPE;
});
var KEY_UP = 'ArrowUp';
var KEY_DOWN = 'ArrowDown';
var KEY_LEFT = 'ArrowLeft';
var KEY_RIGHT = 'ArrowRight';
var KEY_HOME = 'Home';
var KEY_END = 'End';
var KEY_TAB = 'Tab';
var KEY_ENTER = 'Enter';
var KEY_SPACE = 'Space';
var ESCAPE = 'Escape';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3aVRZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return useStableRef;
});
var _react = require("react");
function useStableRef(value) {
    var ref = (0, _react.useRef)(value);
    (0, _react.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gQd69":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "durations", function() {
    return 0, _durations.durations;
});
parcelHelpers.export(exports, "exitingDurations", function() {
    return 0, _durations.exitingDurations;
});
parcelHelpers.export(exports, "durationStep", function() {
    return 0, _durations.durationStep;
});
parcelHelpers.export(exports, "easeIn", function() {
    return 0, _curves.easeIn;
});
parcelHelpers.export(exports, "easeInOut", function() {
    return 0, _curves.easeInOut;
});
parcelHelpers.export(exports, "easeOut", function() {
    return 0, _curves.easeOut;
});
parcelHelpers.export(exports, "linear", function() {
    return 0, _curves.linear;
});
parcelHelpers.export(exports, "isReducedMotion", function() {
    return 0, _accessibility.isReducedMotion;
});
parcelHelpers.export(exports, "useIsReducedMotion", function() {
    return 0, _accessibility.useIsReducedMotion;
});
parcelHelpers.export(exports, "prefersReducedMotion", function() {
    return 0, _accessibility.prefersReducedMotion;
});
parcelHelpers.export(exports, "reduceMotionAsPerUserPreference", function() {
    return 0, _reduceMotionAsPerUserPreference.reduceMotionAsPerUserPreference;
});
parcelHelpers.export(exports, "FadeIn", function() {
    return 0, _fadeInDefault.default;
});
parcelHelpers.export(exports, "AnimateIn", function() {
    return 0, _animateInDefault.default;
});
parcelHelpers.export(exports, "StaggeredEntrance", function() {
    return 0, _staggeredEntranceDefault.default;
});
parcelHelpers.export(exports, "useResizingHeight", function() {
    return 0, _height.useResizingHeight;
});
parcelHelpers.export(exports, "ResizingHeight", function() {
    return 0, _height.ResizingHeight;
});
parcelHelpers.export(exports, "ExitingPersistence", function() {
    return 0, _exitingPersistenceDefault.default;
});
parcelHelpers.export(exports, "useExitingPersistence", function() {
    return 0, _exitingPersistence.useExitingPersistence;
});
parcelHelpers.export(exports, "ZoomIn", function() {
    return 0, _zoomInDefault.default;
});
parcelHelpers.export(exports, "SlideIn", function() {
    return 0, _slideInDefault.default;
});
parcelHelpers.export(exports, "ShrinkOut", function() {
    return 0, _shrinkOutDefault.default;
});
parcelHelpers.export(exports, "Motion", function() {
    return 0, _motionDefault.default;
});
parcelHelpers.export(exports, "Reanimate", function() {
    return 0, _motion.Reanimate;
});
var _durations = require("./utils/durations");
var _curves = require("./utils/curves");
var _accessibility = require("./utils/accessibility");
var _reduceMotionAsPerUserPreference = require("./utils/reduce-motion-as-per-user-preference");
var _fadeIn = require("./entering/fade-in");
var _fadeInDefault = parcelHelpers.interopDefault(_fadeIn);
var _animateIn = require("./entering/animate-in");
var _animateInDefault = parcelHelpers.interopDefault(_animateIn);
var _staggeredEntrance = require("./entering/staggered-entrance");
var _staggeredEntranceDefault = parcelHelpers.interopDefault(_staggeredEntrance);
var _height = require("./resizing/height");
var _exitingPersistence = require("./entering/exiting-persistence");
var _exitingPersistenceDefault = parcelHelpers.interopDefault(_exitingPersistence);
var _zoomIn = require("./entering/zoom-in");
var _zoomInDefault = parcelHelpers.interopDefault(_zoomIn);
var _slideIn = require("./entering/slide-in");
var _slideInDefault = parcelHelpers.interopDefault(_slideIn);
var _shrinkOut = require("./entering/shrink-out");
var _shrinkOutDefault = parcelHelpers.interopDefault(_shrinkOut);
var _motion = require("./entering/motion");
var _motionDefault = parcelHelpers.interopDefault(_motion);

},{"./utils/durations":false,"./utils/curves":false,"./utils/accessibility":false,"./utils/reduce-motion-as-per-user-preference":false,"./entering/fade-in":"iIUo1","./entering/animate-in":false,"./entering/staggered-entrance":false,"./resizing/height":false,"./entering/exiting-persistence":"bLTYm","./entering/zoom-in":false,"./entering/slide-in":"4bJg2","./entering/shrink-out":"26eoi","./entering/motion":"fPIXS","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1dp5g":[function(require,module,exports,__globalThis) {
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "durationStep", function() {
    return durationStep;
});
parcelHelpers.export(exports, "durations", function() {
    return durations;
});
parcelHelpers.export(exports, "exitingDurations", function() {
    return exitingDurations;
});
var durationStep = 25;
var durations = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};
/**
 * Used to multiply the initial duration for exiting motions.
 */ var EXITING_MOTION_MULTIPLIER = 0.5;
var exitingDurations = {
    none: durations.none,
    small: durations.small * EXITING_MOTION_MULTIPLIER,
    medium: durations.medium * EXITING_MOTION_MULTIPLIER,
    large: durations.large * EXITING_MOTION_MULTIPLIER
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1YfC6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "easeInOut", function() {
    return easeInOut;
});
parcelHelpers.export(exports, "easeOut", function() {
    return easeOut;
});
parcelHelpers.export(exports, "easeIn", function() {
    return easeIn;
});
parcelHelpers.export(exports, "easeIn40Out", function() {
    return easeIn40Out;
});
parcelHelpers.export(exports, "easeIn60Out", function() {
    return easeIn60Out;
});
parcelHelpers.export(exports, "easeIn80Out", function() {
    return easeIn80Out;
});
parcelHelpers.export(exports, "linear", function() {
    return linear;
});
var easeInOut = 'cubic-bezier(0.15,1,0.3,1)';
var easeOut = 'cubic-bezier(0.2,0,0,1)';
var easeIn = 'cubic-bezier(0.8,0,0,0.8)';
var easeIn40Out = 'cubic-bezier(0.4,0,0,1)';
var easeIn60Out = 'cubic-bezier(0.6,0,0,1)';
var easeIn80Out = 'cubic-bezier(0.8,0,0,1)';
var linear = 'cubic-bezier(0,0,1,1)';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ek4Xd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isReducedMotion", function() {
    return isReducedMotion;
});
parcelHelpers.export(exports, "useIsReducedMotion", function() {
    return useIsReducedMotion;
});
parcelHelpers.export(exports, "prefersReducedMotion", function() {
    return prefersReducedMotion;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _bindEventListener = require("bind-event-listener");
var _reduceMotionAsPerUserPreference = require("./reduce-motion-as-per-user-preference");
var isMatchMediaAvailable = function() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};
var isReducedMotion = function() {
    if (!isMatchMediaAvailable()) return false;
    var matches = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    return matches;
};
var useIsReducedMotion = function() {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(isReducedMotion), 2), prefersReducedMotion = _useState[0], setPrefersReducedMotion = _useState[1];
    (0, _react.useEffect)(function() {
        if (!isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        var onChange = function(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, _bindEventListener.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var prefersReducedMotion = function() {
    return 0, _reduceMotionAsPerUserPreference.reduceMotionAsPerUserPreference;
};

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","react":"ltHCL","bind-event-listener":"bjeUU","./reduce-motion-as-per-user-preference":"1kFjU","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1kFjU":[function(require,module,exports,__globalThis) {
/**
 * Use for any CSS based motion (animation or transition).
 * Always put at the end of your declaration for correct use of the cascade.
 * Reduced motion preference is generally set through OS preferences/settings.
 *
 * @deprecated This is not fully compatible with Compiled CSS and will be removed in the future.
 * You should hardcode the `prefers-reduced-motion` media query in your file instead.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reduceMotionAsPerUserPreference", function() {
    return reduceMotionAsPerUserPreference;
});
var reduceMotionAsPerUserPreference = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iIUo1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _keyframesMotion = require("./keyframes-motion");
var _keyframesMotionDefault = parcelHelpers.interopDefault(_keyframesMotion);
var invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ var FadeIn = function(param) {
    var children = param.children, _param_duration = param.duration, duration = _param_duration === void 0 ? 'large' : _param_duration, entranceDirection = param.entranceDirection, exitDirection = param.exitDirection, _param_distance = param.distance, distance = _param_distance === void 0 ? 'proportional' : _param_distance, onFinish = param.onFinish, isPaused = param.isPaused;
    var invertedEntranceDirection = entranceDirection !== undefined ? invertedDirection[entranceDirection] : undefined;
    var isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? "fade-out-from-".concat(exitDirection || invertedEntranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-out';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _keyframesMotionDefault.default), {
        duration: duration,
        enteringAnimation: entranceDirection ? "fade-in-from-".concat(entranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-in',
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused,
        children: children
    });
};
exports.default = FadeIn;

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","./keyframes-motion":"5J7jP","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5J7jP":[function(require,module,exports,__globalThis) {
/* keyframes-motion.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _runtime = require("@compiled/react/runtime");
var _accessibility = require("../utils/accessibility");
var _durations = require("../utils/durations");
var _timerHooks = require("../utils/timer-hooks");
var _exitingPersistence = require("./exiting-persistence");
var _staggeredEntrance = require("./staggered-entrance");
var zoomIn = null;
var zoomOut = null;
var fadeIn = null;
var fadeOut = null;
var fadeInFromTop = null;
var fadeOutFromTop = null;
var fadeInFromLeft = null;
var fadeOutFromLeft = null;
var fadeInFromBottom = null;
var fadeOutFromBottom = null;
var fadeInFromRight = null;
var fadeOutFromRight = null;
var fadeInFromTopConstant = null;
var fadeOutFromTopConstant = null;
var fadeInFromLeftConstant = null;
var fadeOutFromLeftConstant = null;
var fadeInFromBottomConstant = null;
var fadeOutFromBottomConstant = null;
var fadeInFromRightConstant = null;
var fadeOutFromRightConstant = null;
var slideInFromTop = null;
var slideOutFromTop = null;
var slideInFromRight = null;
var slideOutFromRight = null;
var slideInFromBottom = null;
var slideOutFromBottom = null;
var slideInFromLeft = null;
var slideOutFromLeft = null;
/**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var EnteringMotion = function(param) {
    var children = param.children, animationTimingFunction = param.animationTimingFunction, _param_animationTimingFunctionExiting = param.animationTimingFunctionExiting, animationTimingFunctionExiting = _param_animationTimingFunctionExiting === void 0 ? animationTimingFunction : _param_animationTimingFunctionExiting, enteringAnimation = param.enteringAnimation, _param_exitingAnimation = param.exitingAnimation, exitingAnimation = _param_exitingAnimation === void 0 ? enteringAnimation : _param_exitingAnimation, isPaused = param.isPaused, onFinishMotion = param.onFinish, _param_duration = param.duration, duration = _param_duration === void 0 ? 'large' : _param_duration;
    var staggered = (0, _staggeredEntrance.useStaggeredEntrance)();
    var _useExitingPersistence = (0, _exitingPersistence.useExitingPersistence)(), isExiting = _useExitingPersistence.isExiting, onExitFinished = _useExitingPersistence.onFinish, appear = _useExitingPersistence.appear;
    var setTimeout = (0, _timerHooks.useSetTimeout)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? 'exiting' : 'entering';
    var _useState = (0, _slicedToArray._)((0, _react.useState)(appear), 2), hasAnimationStyles = _useState[0], setHasAnimationStyles = _useState[1];
    (0, _react.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */ var onAnimationEnd = function() {
            if (state === 'exiting') // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 ? void 0 : onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion === null || onFinishMotion === void 0 ? void 0 : onFinishMotion(state);
        };
        if ((0, _accessibility.isReducedMotion)()) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, _durations.exitingDurations)[duration] : (0, _durations.durations)[duration] + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, _runtime.ax)([
            (0, _runtime.ax)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, _runtime.ax)([
                "_1y0ctrqk"
            ]),
            duration === 'small' && (0, _runtime.ax)([
                "_5sag1yx9"
            ]),
            duration === 'medium' && (0, _runtime.ax)([
                "_5sag1ttt"
            ]),
            duration === 'large' && (0, _runtime.ax)([
                "_5sagpwmj"
            ]),
            isExiting && duration === 'small' && (0, _runtime.ax)([
                "_5sag14ed"
            ]),
            isExiting && duration === 'medium' && (0, _runtime.ax)([
                "_5sagluct"
            ]),
            isExiting && duration === 'large' && (0, _runtime.ax)([
                "_5sag1ttt"
            ]),
            isExiting && (0, _runtime.ax)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === 'linear' && (0, _runtime.ax)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === 'ease-out' && (0, _runtime.ax)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in' && (0, _runtime.ax)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-40-out' && (0, _runtime.ax)([
                "_1pgl5y64"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-60-out' && (0, _runtime.ax)([
                "_1pgl1ddy"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-80-out' && (0, _runtime.ax)([
                "_1pglannl"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-out' && (0, _runtime.ax)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === 'linear' && (0, _runtime.ax)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-out' && (0, _runtime.ax)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in' && (0, _runtime.ax)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-40-out' && (0, _runtime.ax)([
                "_1pgl5y64"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-60-out' && (0, _runtime.ax)([
                "_1pgl1ddy"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-80-out' && (0, _runtime.ax)([
                "_1pglannl"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-out' && (0, _runtime.ax)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === 'fade-in' || isExiting && exitingAnimation === 'fade-in') && (0, _runtime.ax)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === 'fade-out' || isExiting && exitingAnimation === 'fade-out') && (0, _runtime.ax)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === 'zoom-in' || isExiting && exitingAnimation === 'zoom-in') && (0, _runtime.ax)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === 'zoom-out' || isExiting && exitingAnimation === 'zoom-out') && (0, _runtime.ax)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-top' || isExiting && exitingAnimation === 'slide-in-from-top') && (0, _runtime.ax)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-top' || isExiting && exitingAnimation === 'slide-out-from-top') && (0, _runtime.ax)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-right' || isExiting && exitingAnimation === 'slide-in-from-right') && (0, _runtime.ax)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-right' || isExiting && exitingAnimation === 'slide-out-from-right') && (0, _runtime.ax)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-bottom' || isExiting && exitingAnimation === 'slide-in-from-bottom') && (0, _runtime.ax)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-bottom' || isExiting && exitingAnimation === 'slide-out-from-bottom') && (0, _runtime.ax)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-left' || isExiting && exitingAnimation === 'slide-in-from-left') && (0, _runtime.ax)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-left' || isExiting && exitingAnimation === 'slide-out-from-left') && (0, _runtime.ax)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top' || isExiting && exitingAnimation === 'fade-in-from-top') && (0, _runtime.ax)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top' || isExiting && exitingAnimation === 'fade-out-from-top') && (0, _runtime.ax)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left' || isExiting && exitingAnimation === 'fade-in-from-left') && (0, _runtime.ax)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left' || isExiting && exitingAnimation === 'fade-out-from-left') && (0, _runtime.ax)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom' || isExiting && exitingAnimation === 'fade-in-from-bottom') && (0, _runtime.ax)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom' || isExiting && exitingAnimation === 'fade-out-from-bottom') && (0, _runtime.ax)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right' || isExiting && exitingAnimation === 'fade-in-from-right') && (0, _runtime.ax)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right' || isExiting && exitingAnimation === 'fade-out-from-right') && (0, _runtime.ax)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top-constant' || isExiting && exitingAnimation === 'fade-in-from-top-constant') && (0, _runtime.ax)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top-constant' || isExiting && exitingAnimation === 'fade-out-from-top-constant') && (0, _runtime.ax)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left-constant' || isExiting && exitingAnimation === 'fade-in-from-left-constant') && (0, _runtime.ax)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left-constant' || isExiting && exitingAnimation === 'fade-out-from-left-constant') && (0, _runtime.ax)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom-constant' || isExiting && exitingAnimation === 'fade-in-from-bottom-constant') && (0, _runtime.ax)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom-constant' || isExiting && exitingAnimation === 'fade-out-from-bottom-constant') && (0, _runtime.ax)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right-constant' || isExiting && exitingAnimation === 'fade-in-from-right-constant') && (0, _runtime.ax)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right-constant' || isExiting && exitingAnimation === 'fade-out-from-right-constant') && (0, _runtime.ax)([
                "_j7hq1pgp"
            ])
        ]) : '',
        style: {
            animationDelay: "".concat(delay, "ms")
        }
    }, state);
};
exports.default = EnteringMotion;

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","react":"ltHCL","@compiled/react/runtime":"d27Vo","../utils/accessibility":"ek4Xd","../utils/durations":"1dp5g","../utils/timer-hooks":"NzLQz","./exiting-persistence":"bLTYm","./staggered-entrance":"8HynE","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"NzLQz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useRequestAnimationFrame", function() {
    return useRequestAnimationFrame;
});
parcelHelpers.export(exports, "useSetTimeout", function() {
    return useSetTimeout;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _react = require("react");
var getHookDeps = function(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var useRequestAnimationFrame = function() {
    var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        cleanup: 'unmount'
    };
    var frames = (0, _react.useRef)([]);
    (0, _react.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, getHookDeps(opts));
    return (0, _react.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var useSetTimeout = function() {
    var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        cleanup: 'unmount'
    };
    var timeouts = (0, _react.useRef)([]);
    (0, _react.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, getHookDeps(opts));
    return (0, _react.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
            args[_key - 2] = arguments[_key];
        }
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat((0, _toConsumableArray._)(args)));
        timeouts.current.push(id);
    }, []);
};

},{"@swc/helpers/_/_to_consumable_array":"1eSZf","react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bLTYm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useExitingPersistence", function() {
    return useExitingPersistence;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
// We define empty context here so the object doesn't change.
var emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ var ExitingContext = /*#__PURE__*/ (0, _react.createContext)(emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var wrapChildWithContextProvider = function(child) {
    var value = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : emptyContext;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ExitingContext.Provider, {
        value: value,
        children: child
    }, "".concat(child.key, "-provider"));
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var childrenToArray = function(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, _react.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var spliceNewElementsIntoPrevious = function(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var childrenToObj = function(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var getMissingKeys = function(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var key = element.key;
        if (!currentMapKeys.has(key)) missing.add(key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ var ExitingPersistence = /*#__PURE__*/ (0, _react.memo)(function(param) {
    var _param_appear = param.appear, appear = _param_appear === void 0 ? false : _param_appear, children = param.children, exitThenEnter = param.exitThenEnter;
    var _useState = (0, _slicedToArray._)((0, _react.useState)([
        null,
        children
    ]), 2), stateChildren = _useState[0], setChildren = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)([]), 2), exitingChildren = _useState1[0], setExitingChildren = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), 2), defaultContext = _useState2[0], setDefaultContext = _useState2[1];
    (0, _react.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
	 * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
	 * useState is mocked to return a boolean value.
	 */ if (typeof stateChildren === 'boolean') return children;
    var _stateChildren = (0, _slicedToArray._)(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = childrenToArray(previousChildren);
    var current = childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = (0, _platformFeatureFlags.fg)('platform-dst-motion-uplift') ? previous : exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var useExitingPersistence = function() {
    return (0, _react.useContext)(ExitingContext);
};
ExitingPersistence.displayName = 'ExitingPersistence';
exports.default = ExitingPersistence;

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","react/jsx-runtime":"bGvcw","react":"ltHCL","@atlaskit/platform-feature-flags":"kO5t9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8HynE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useStaggeredEntrance", function() {
    return useStaggeredEntrance;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var _useLayoutEffect = require("../utils/use-layout-effect");
var _useUniqueId = require("../utils/use-unique-id");
var StaggeredEntranceContext = /*#__PURE__*/ (0, _react.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, _noopDefault.default)
    };
});
var useStaggeredEntrance = function() {
    var indentifier = (0, _useUniqueId.useUniqueId)();
    var context = (0, _react.useContext)(StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var StaggeredEntrance = function(param) {
    var children = param.children, column = param.column, _param_columns = param.columns, columns = _param_columns === void 0 ? 'responsive' : _param_columns, _param_delayStep = param.delayStep, delayStep = _param_delayStep === void 0 ? 50 : _param_delayStep;
    var elementRefs = (0, _react.useRef)([]);
    var indexes = [];
    var _useState = (0, _slicedToArray._)((0, _react.useState)(function() {
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), 2), actualColumns = _useState[0], setActualColumns = _useState[1];
    (0, _useLayoutEffect.useLayoutEffect)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StaggeredEntranceContext.Provider, {
        value: function(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function(element) {
                    return elementRefs.current[index] = element;
                }
            };
        },
        children: children
    });
};
exports.default = StaggeredEntrance;

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","react/jsx-runtime":"bGvcw","react":"ltHCL","@atlaskit/ds-lib/noop":"2f3bg","../utils/use-layout-effect":"1IyB9","../utils/use-unique-id":"hbHVf","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1IyB9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useLayoutEffect", function() {
    return useLayoutEffect;
});
var _react = require("react");
var useLayoutEffect = typeof window === 'undefined' ? (0, _react.useEffect) : (0, _react.useLayoutEffect);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hbHVf":[function(require,module,exports,__globalThis) {
/* eslint-disable @repo/internal/react/disallow-unstable-values */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Will return a unique id that does not change between renders.
 * Try not use this to render DOM markup (attributes or otherwise)
 * as you will probably not get the same result on the Server vs. Client.
 */ parcelHelpers.export(exports, "useUniqueId", function() {
    return useUniqueId;
});
var _react = require("react");
function useUniqueId() {
    var identifier = (0, _react.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4bJg2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _keyframesMotion = require("./keyframes-motion");
var _keyframesMotionDefault = parcelHelpers.interopDefault(_keyframesMotion);
/**
 * __SlideIn__
 *
 * Will slide an element into position, generally used for things that appear from outside of the viewport into view.
 *
 * See [examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion).
 */ var SlideIn = function(param) {
    var children = param.children, enterFrom = param.enterFrom, exitTo = param.exitTo, _param_duration = param.duration, duration = _param_duration === void 0 ? 'medium' : _param_duration, isPaused = param.isPaused, onFinish = param.onFinish, _param_animationTimingFunction = param.animationTimingFunction, animationTimingFunction = _param_animationTimingFunction === void 0 ? 'ease-out' : _param_animationTimingFunction, _param_animationTimingFunctionExiting = param.animationTimingFunctionExiting, animationTimingFunctionExiting = _param_animationTimingFunctionExiting === void 0 ? 'ease-in' : _param_animationTimingFunctionExiting;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _keyframesMotionDefault.default), {
        duration: duration,
        enteringAnimation: "slide-in-from-".concat(enterFrom),
        exitingAnimation: "slide-out-from-".concat(exitTo || enterFrom),
        animationTimingFunction: animationTimingFunction,
        animationTimingFunctionExiting: animationTimingFunctionExiting,
        isPaused: isPaused,
        onFinish: onFinish,
        children: children
    });
};
exports.default = SlideIn;

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","./keyframes-motion":"5J7jP","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"26eoi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _accessibility = require("../utils/accessibility");
var _durations = require("../utils/durations");
var _timerHooks = require("../utils/timer-hooks");
var _useElementRef = require("../utils/use-element-ref");
var _useLayoutEffect = require("../utils/use-layout-effect");
var _exitingPersistence = require("./exiting-persistence");
/**
 * __ShrinkOut__
 *
 * Will shrink an element down to nothing when exiting.
 * Works best with flex children as collapsing margins can come with undesired behaviour.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ var ShrinkOut = function(param) {
    var children = param.children, _param_duration = param.duration, duration = _param_duration === void 0 ? 'small' : _param_duration, onFinish = param.onFinish;
    var _useElementRef1 = (0, _slicedToArray._)((0, _useElementRef.useElementRef)(), 2), element = _useElementRef1[0], setElementRef = _useElementRef1[1];
    var exiting = (0, _exitingPersistence.useExitingPersistence)();
    var requestAnimationFrame = (0, _timerHooks.useRequestAnimationFrame)();
    var setTimeout = (0, _timerHooks.useSetTimeout)();
    var direction = exiting.isExiting ? 'exiting' : 'entering';
    (0, _useLayoutEffect.useLayoutEffect)(function() {
        if (exiting.isExiting && element) {
            if ((0, _accessibility.isReducedMotion)()) {
                exiting.onFinish && exiting.onFinish();
                onFinish && onFinish('exiting');
                return;
            }
            var newStyles = {
                // We fix both width and height because when changing box sizing to border-box.
                width: "".concat(element.offsetWidth, "px"),
                height: "".concat(element.offsetHeight, "px"),
                boxSizing: 'border-box',
                willChange: 'width,margin'
            };
            Object.assign(element.style, newStyles);
            requestAnimationFrame(function() {
                requestAnimationFrame(function() {
                    var newStyles = {
                        width: '0px',
                        margin: '0px',
                        transitionTimingFunction: 'cubic-bezier(0.8,0,0,0.8)',
                        transitionDuration: (0, _durations.durations)[duration] + 'ms',
                        transitionProperty: 'width,margin'
                    };
                    Object.assign(element.style, newStyles);
                    setTimeout(function() {
                        exiting.onFinish && exiting.onFinish();
                        onFinish && onFinish('exiting');
                    }, (0, _durations.durations)[duration]);
                });
            });
        }
    });
    return children({
        ref: setElementRef
    }, direction);
};
exports.default = ShrinkOut;

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","../utils/accessibility":"ek4Xd","../utils/durations":"1dp5g","../utils/timer-hooks":"NzLQz","../utils/use-element-ref":"fVKiA","../utils/use-layout-effect":"1IyB9","./exiting-persistence":"bLTYm","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fVKiA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useElementRef", function() {
    return useElementRef;
});
var _react = require("react");
var useElementRef = function() {
    var elementRef = (0, _react.useRef)(null);
    var setRef = (0, _react.useCallback)(function(ref) {
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fPIXS":[function(require,module,exports,__globalThis) {
/* motion.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Reanimate", function() {
    return Reanimate;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _runtime = require("@compiled/react/runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _css = require("@atlaskit/css");
var _mergeRefs = require("@atlaskit/ds-lib/merge-refs");
var _mergeRefsDefault = parcelHelpers.interopDefault(_mergeRefs);
var _accessibility = require("../utils/accessibility");
var _convertToMs = require("../utils/convert-to-ms");
var _getDurationMs = require("../utils/get-duration-ms");
var _resolveMotionToken = require("../utils/resolve-motion-token");
var _exitingPersistence = require("./exiting-persistence");
var _staggeredEntrance = require("./staggered-entrance");
var styles = {
    base: "_1y0co91m _1bumglyw _sedtglyw",
    hidden: "_3um015vq",
    entering: "_1o51eoah",
    exiting: "_1o51q7pw"
}; /**
    * Supported reanimate values.
    * 'enter' will re-enter the animation.
    * 'exit-then-enter' will exit the animation and then enter it again.
    */ 
var Reanimate = /*#__PURE__*/ function(Reanimate) {
    Reanimate["enter"] = "enter";
    Reanimate["exit_then_enter"] = "exit_then_enter";
    return Reanimate;
}({});
/**
 * __Motion__
 *
 * A motion primitive that can be used to animate the entry and exit of components.
 */ var Motion = /*#__PURE__*/ (0, _react.forwardRef)(function(param, ref) {
    var children = param.children, enteringAnimation = param.enteringAnimation, enteringAnimationXcss = param.enteringAnimationXcss, exitingAnimation = param.exitingAnimation, exitingAnimationXcss = param.exitingAnimationXcss, onFinishMotion = param.onFinish, xcss = param.xcss, testId = param.testId;
    var staggered = (0, _staggeredEntrance.useStaggeredEntrance)();
    var _useExitingPersistence = (0, _exitingPersistence.useExitingPersistence)(), isExiting = _useExitingPersistence.isExiting, onExitFinished = _useExitingPersistence.onFinish, appear = _useExitingPersistence.appear;
    var staggeredDelay = isExiting ? 0 : staggered.delay;
    var staggedIsReady = staggered.isReady;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(appear ? staggedIsReady && !staggeredDelay ? 'entering' : 'init' : 'idle'), 2), state = _useState[0], setState = _useState[1];
    var elementRef = (0, _react.useRef)(null);
    var reanimateRef = (0, _react.useRef)();
    var animationRef = (0, _react.useRef)();
    var staggeredEntryRef = (0, _react.useRef)();
    (0, _react.useEffect)(function() {
        if (isExiting) setState('exiting');
    }, [
        isExiting
    ]); // Handles staggered entry
    (0, _react.useEffect)(function() {
        if (state !== 'init') return; // We delay the entry animation by the stagger delay
        staggeredEntryRef.current = setTimeout(function() {
            setState('entering');
        }, staggeredDelay);
        return function() {
            if (staggeredEntryRef.current) clearTimeout(staggeredEntryRef.current);
        };
    }, [
        state,
        staggedIsReady,
        staggeredDelay
    ]); /**
                                                * Updates relevant state.
                                                * Called when the animation is finished, or immediately with reduced motion.
                                                */ 
    var onAnimationEnd = (0, _react.useCallback)(function(state, cancelled) {
        // We are done animating, so we set the state to idle
        var newState = 'idle';
        if (state === 'exiting') {
            if (!reanimateRef.current) // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 ? void 0 : onExitFinished();
            onFinishMotion === null || onFinishMotion === void 0 ? void 0 : onFinishMotion('exiting');
        }
        if (state === 'entering') onFinishMotion === null || onFinishMotion === void 0 ? void 0 : onFinishMotion('entering');
        if (reanimateRef.current === "exit_then_enter") {
            // We are done exiting, so we set the state to entering
            reanimateRef.current = "enter";
            newState = 'entering';
        } else if (reanimateRef.current) // We are done reanimating, so we clear the reanimate state
        reanimateRef.current = undefined;
        if (!cancelled) setState(newState);
         // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        onExitFinished
    ]);
    (0, _react.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (!staggedIsReady) return;
         // On initial mount if elements aren't set to animate on appear, we return early and callback
        // This only occurs on initial mount, as appear will be true once the component is mounted
        if (!appear) {
            onFinishMotion && onFinishMotion('entering');
            return;
        } // If the state is idle or init, we don't need to do anything
        if (state === 'idle' || state === 'init') return;
         // If there is reduced motion or no exit animation, we call the onAnimationEnd function immediately
        if ((0, _accessibility.isReducedMotion)() || !exitingAnimation && !exitingAnimationXcss) {
            onAnimationEnd(state, isCancelled);
            return;
        }
        var animationDuration = 0;
        var animationDelay = 0;
        if (state === 'entering' || state === 'exiting') {
            if (elementRef.current) {
                if (elementRef.current.style.animation) {
                    // Motion token
                    var animationTimings = (0, _getDurationMs.getDurationMs)((0, _resolveMotionToken.resolveMotionToken)(elementRef.current.style.animation));
                    animationDuration = animationTimings.duration;
                    animationDelay = animationTimings.delay;
                } else {
                    // Custom motion
                    var styles = window.getComputedStyle(elementRef.current);
                    if (styles.animationDuration) animationDuration = (0, _convertToMs.convertToMs)(styles.animationDuration);
                    if (styles.animationDelay) animationDelay = (0, _convertToMs.convertToMs)(styles.animationDelay);
                }
            }
        } // Queue `onAnimationEnd` for after the animation has finished
        if (state === 'exiting' && (exitingAnimation || exitingAnimationXcss)) animationRef.current = setTimeout(function() {
            return onAnimationEnd(state, isCancelled);
        }, animationDuration + animationDelay);
        else if (state === 'entering' && (enteringAnimation || enteringAnimationXcss)) animationRef.current = setTimeout(function() {
            return onAnimationEnd(state, isCancelled);
        }, animationDuration + animationDelay);
        return function() {
            isCancelled = true;
            if (animationRef.current) clearTimeout(animationRef.current);
        }; // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onAnimationEnd,
        state,
        exitingAnimation,
        enteringAnimation,
        exitingAnimationXcss,
        enteringAnimationXcss,
        staggeredDelay,
        staggedIsReady
    ]);
    (0, _react.useImperativeHandle)(ref, function() {
        return {
            reanimate: function(value) {
                animationRef.current && clearTimeout(animationRef.current);
                reanimateRef.current = value;
                if (value === "exit_then_enter") setState('exiting');
                else if (value === "enter") setState('entering');
            }
        };
    });
    var style = {};
    var customAnimation;
    if (state === 'entering') {
        if (enteringAnimation) style.animation = "".concat(enteringAnimation, " backwards");
        else if (enteringAnimationXcss) customAnimation = enteringAnimationXcss;
    } else if (state === 'exiting') {
        if (exitingAnimation) style.animation = "".concat(exitingAnimation, " forwards");
        else if (exitingAnimationXcss) customAnimation = exitingAnimationXcss;
    }
    var hasAnimationStyles = state !== 'idle' && state !== 'init';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
    , {
        className: (0, _runtime.ax)([
            hasAnimationStyles && styles.base,
            state === 'init' && styles.hidden,
            state === 'entering' && styles.entering,
            state === 'exiting' && styles.exiting,
            (0, _css.cx)(xcss, customAnimation)
        ]),
        ref: (0, _mergeRefsDefault.default)([
            staggered.ref,
            elementRef
        ]),
        style: hasAnimationStyles ? style : undefined,
        "data-testid": testId,
        children: children
    });
});
exports.default = Motion;

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","react/jsx-runtime":"bGvcw","@compiled/react/runtime":"d27Vo","react":"ltHCL","@atlaskit/css":"fiaHp","@atlaskit/ds-lib/merge-refs":"bhv2L","../utils/accessibility":"ek4Xd","../utils/convert-to-ms":"clHwt","../utils/get-duration-ms":"iI28q","../utils/resolve-motion-token":"7hOjn","./exiting-persistence":"bLTYm","./staggered-entrance":"8HynE","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"clHwt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "convertToMs", function() {
    return convertToMs;
});
var convertToMs = function(duration) {
    // Use regex to separate the number and the unit
    var matches = duration.match(/^(\d+\.?\d*)(s|ms)$/);
    if (!matches) return 0; // Or return for invalid format
    var value = parseFloat(matches[1]);
    var unit = matches[2];
    if (unit === 's') return value * 1000; // Convert seconds to milliseconds
    else return value; // Already in milliseconds
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iI28q":[function(require,module,exports,__globalThis) {
/**
 * Gets the duration in milliseconds for an animation property.
 * @param animation - The animation property to get the duration for.
 * @returns The duration in milliseconds.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDurationMs", function() {
    return getDurationMs;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var getDurationMs = function(animation) {
    var match = (0, _toConsumableArray._)(animation.trim().matchAll(/(-?\d*\.?\d+)(ms|s)\b/g));
    if (match.length === 0) return {
        duration: 0,
        delay: 0
    };
    var durationValue = parseFloat(match[0][1]);
    var durationUnit = match[0][2];
    var duration = durationUnit === 's' ? durationValue * 1000 : durationValue;
    var delay = 0;
    if (match[1]) {
        var delayValue = parseFloat(match[1][1]);
        var delayUnit = match[1][2];
        delay = delayUnit === 's' ? delayValue * 1000 : delayValue;
    }
    return {
        duration: duration,
        delay: delay
    };
};

},{"@swc/helpers/_/_to_consumable_array":"1eSZf","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7hOjn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveMotionToken", function() {
    return resolveMotionToken;
});
var _browserApis = require("@atlaskit/browser-apis");
var resolveMotionToken = function(token) {
    var cssVarMatch = token.match(/var\(\s*(--[^,\s)]+)/);
    var cssVar = cssVarMatch ? cssVarMatch[1] : null;
    if (cssVar) {
        var _getDocument;
        var documentElement = (_getDocument = (0, _browserApis.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.documentElement;
        if (documentElement) return getComputedStyle(documentElement).getPropertyValue(cssVar);
    }
    return '';
};

},{"@atlaskit/browser-apis":"2dayt","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bMYOE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Popper", function() {
    return 0, _popper.Popper;
});
parcelHelpers.export(exports, "placements", function() {
    return 0, _popper.placements;
});
parcelHelpers.export(exports, "Manager", function() {
    return 0, _reactPopper.Manager;
});
parcelHelpers.export(exports, "Reference", function() {
    return 0, _reactPopper.Reference;
});
var _popper = require("./popper");
var _reactPopper = require("react-popper");

},{"./popper":"1ucI9","react-popper":"bGSxp","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1ucI9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "placements", function() {
    return 0, _core.placements;
});
parcelHelpers.export(exports, "Popper", function() {
    return Popper;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactPopper = require("react-popper");
var _maxSize = require("./max-size");
var _core = require("@popperjs/core");
var viewportPadding = 5;
var constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: viewportPadding,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
function defaultChildrenFn() {
    return null;
}
var defaultOffset = [
    0,
    8
];
function Popper(param) {
    var _param_children = param.children, children = _param_children === void 0 ? defaultChildrenFn : _param_children, _param_offset = param.offset, offset = _param_offset === void 0 ? defaultOffset : _param_offset, _param_placement = param.placement, placement = _param_placement === void 0 ? 'bottom-start' : _param_placement, referenceElement = param.referenceElement, modifiers = param.modifiers, _param_strategy = param.strategy, strategy = _param_strategy === void 0 ? 'fixed' : _param_strategy, _param_shouldFitViewport = param.shouldFitViewport, shouldFitViewport = _param_shouldFitViewport === void 0 ? false : _param_shouldFitViewport;
    var _offset = (0, _slicedToArray._)(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    var internalModifiers = (0, _react.useMemo)(function() {
        var preventOverflowModifier = {
            name: 'preventOverflow',
            options: {
                padding: viewportPadding,
                rootBoundary: shouldFitViewport ? 'viewport' : 'document'
            }
        };
        var offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        var maxSizeModifiers = shouldFitViewport ? (0, _maxSize.getMaxSizeModifiers)({
            viewportPadding: viewportPadding
        }) : [];
        // @ts-ignore Type errors from incompatible @popperjs/core versions between Jira and AFM Platform... we are using ts-ignore here because ts-expect-error will cause an "Unused '@ts-expect-error' directive." error
        return (0, _toConsumableArray._)(constantModifiers).concat([
            preventOverflowModifier,
            offsetModifier
        ], (0, _toConsumableArray._)(maxSizeModifiers));
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, _react.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return (0, _toConsumableArray._)(internalModifiers).concat((0, _toConsumableArray._)(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactPopper.Popper), {
        // @ts-expect-error - No overload matches this call
        // This error was introduced after upgrading to TypeScript 5
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement,
        children: children
    });
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_to_consumable_array":"1eSZf","react/jsx-runtime":"bGvcw","react":"ltHCL","react-popper":"bGSxp","./max-size":"25oTb","@popperjs/core":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bGSxp":[function(require,module,exports,__globalThis) {
// Public components
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Popper", function() {
    return 0, _popper.Popper;
}); // Public types
parcelHelpers.export(exports, "Manager", function() {
    return 0, _manager.Manager;
});
parcelHelpers.export(exports, "Reference", function() {
    return 0, _reference.Reference;
});
parcelHelpers.export(exports, "usePopper", function() {
    return 0, _usePopper.usePopper;
});
var _popper = require("./Popper");
var _manager = require("./Manager");
var _reference = require("./Reference");
var _usePopper = require("./usePopper");

},{"./Popper":"g9n8m","./Manager":"ltEqg","./Reference":"c68RF","./usePopper":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"g9n8m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Popper", function() {
    return Popper;
});
var _react = require("react");
var _manager = require("./Manager");
var _utils = require("./utils");
var _usePopper = require("./usePopper");
var NOOP = function NOOP() {
    return void 0;
};
var NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var EMPTY_MODIFIERS = [];
function Popper(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = _react.useContext((0, _manager.ManagerReferenceNodeContext));
    var _React$useState = _react.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = _react.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    _react.useEffect(function() {
        (0, _utils.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = _react.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper1 = (0, _usePopper.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper1.state, styles = _usePopper1.styles, forceUpdate = _usePopper1.forceUpdate, update = _usePopper1.update;
    var childrenProps = _react.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || NOOP,
            update: update || NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, _utils.unwrapArray)(children)(childrenProps);
}

},{"react":"ltHCL","./Manager":"ltEqg","./utils":"9X8cu","./usePopper":"eTy54","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ltEqg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ManagerReferenceNodeContext", function() {
    return ManagerReferenceNodeContext;
});
parcelHelpers.export(exports, "ManagerReferenceNodeSetterContext", function() {
    return ManagerReferenceNodeSetterContext;
});
parcelHelpers.export(exports, "Manager", function() {
    return Manager;
});
var _react = require("react");
var ManagerReferenceNodeContext = _react.createContext();
var ManagerReferenceNodeSetterContext = _react.createContext();
function Manager(_ref) {
    var children = _ref.children;
    var _React$useState = _react.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = _react.useRef(false);
    _react.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = _react.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ _react.createElement(ManagerReferenceNodeContext.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ _react.createElement(ManagerReferenceNodeSetterContext.Provider, {
        value: handleSetReferenceNode
    }, children));
}

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9X8cu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unwrapArray", function() {
    return unwrapArray;
});
parcelHelpers.export(exports, "safeInvoke", function() {
    return safeInvoke;
});
parcelHelpers.export(exports, "setRef", function() {
    return setRef;
});
parcelHelpers.export(exports, "fromEntries", function() {
    return fromEntries;
});
parcelHelpers.export(exports, "useIsomorphicLayoutEffect", function() {
    return useIsomorphicLayoutEffect;
});
var _react = require("react");
var unwrapArray = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var safeInvoke = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var setRef = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return safeInvoke(ref, node);
    else if (ref != null) ref.current = node;
};
var fromEntries = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var useIsomorphicLayoutEffect = typeof window !== 'undefined' && window.document && window.document.createElement ? _react.useLayoutEffect : _react.useEffect;

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eTy54":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "usePopper", function() {
    return usePopper;
});
var _react = require("react");
var _reactDom = require("react-dom");
var _core = require("@popperjs/core");
var _reactFastCompare = require("react-fast-compare");
var _reactFastCompareDefault = parcelHelpers.interopDefault(_reactFastCompare);
var _utils = require("./utils");
var EMPTY_MODIFIERS = [];
var usePopper = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = _react.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || EMPTY_MODIFIERS
    };
    var _React$useState = _react.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = _react.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                _reactDom.flushSync(function() {
                    setState({
                        styles: (0, _utils.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, _utils.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = _react.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, _reactFastCompareDefault.default)(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = _react.useRef();
    (0, _utils.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, _utils.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, _core.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

},{"react":"ltHCL","react-dom":"bvX0P","@popperjs/core":"lQ6Il","react-fast-compare":"8GPFg","./utils":"9X8cu","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lQ6Il":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "popperGenerator", function() {
    return 0, _createPopperJs.popperGenerator;
}); // eslint-disable-next-line import/no-unused-modules
parcelHelpers.export(exports, "detectOverflow", function() {
    return 0, _createPopperJs.detectOverflow;
});
parcelHelpers.export(exports, "createPopperBase", function() {
    return 0, _createPopperJs.createPopper;
});
parcelHelpers.export(exports, "createPopper", function() {
    return 0, _popperJs.createPopper;
}); // eslint-disable-next-line import/no-unused-modules
parcelHelpers.export(exports, "createPopperLite", function() {
    return 0, _popperLiteJs.createPopper;
});
var _enumsJs = require("./enums.js");
parcelHelpers.exportAll(_enumsJs, exports);
var _indexJs = require // eslint-disable-next-line import/no-unused-modules
("./modifiers/index.js");
parcelHelpers.exportAll(_indexJs, exports);
var _createPopperJs = require("./createPopper.js");
var _popperJs = require("./popper.js");
var _popperLiteJs = require("./popper-lite.js");

},{"./enums.js":false,"./modifiers/index.js":false,"./createPopper.js":false,"./popper.js":"dOvVs","./popper-lite.js":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1lwWm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "top", function() {
    return top;
});
parcelHelpers.export(exports, "bottom", function() {
    return bottom;
});
parcelHelpers.export(exports, "right", function() {
    return right;
});
parcelHelpers.export(exports, "left", function() {
    return left;
});
parcelHelpers.export(exports, "auto", function() {
    return auto;
});
parcelHelpers.export(exports, "basePlacements", function() {
    return basePlacements;
});
parcelHelpers.export(exports, "start", function() {
    return start;
});
parcelHelpers.export(exports, "end", function() {
    return end;
});
parcelHelpers.export(exports, "clippingParents", function() {
    return clippingParents;
});
parcelHelpers.export(exports, "viewport", function() {
    return viewport;
});
parcelHelpers.export(exports, "popper", function() {
    return popper;
});
parcelHelpers.export(exports, "reference", function() {
    return reference;
});
parcelHelpers.export(exports, "variationPlacements", function() {
    return variationPlacements;
});
parcelHelpers.export(exports, "placements", function() {
    return placements;
});
parcelHelpers.export(exports, "beforeRead", function() {
    return beforeRead;
});
parcelHelpers.export(exports, "read", function() {
    return read;
});
parcelHelpers.export(exports, "afterRead", function() {
    return afterRead;
});
parcelHelpers.export(exports, "beforeMain", function() {
    return beforeMain;
});
parcelHelpers.export(exports, "main", function() {
    return main;
});
parcelHelpers.export(exports, "afterMain", function() {
    return afterMain;
});
parcelHelpers.export(exports, "beforeWrite", function() {
    return beforeWrite;
});
parcelHelpers.export(exports, "write", function() {
    return write;
});
parcelHelpers.export(exports, "afterWrite", function() {
    return afterWrite;
});
parcelHelpers.export(exports, "modifierPhases", function() {
    return modifierPhases;
});
var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [
    top,
    bottom,
    right,
    left
];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/ basePlacements.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + start,
        placement + "-" + end
    ]);
}, []);
var placements = /*#__PURE__*/ [].concat(basePlacements, [
    auto
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + start,
        placement + "-" + end
    ]);
}, []); // modifiers that need to read the DOM
var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers
var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [
    beforeRead,
    read,
    afterRead,
    beforeMain,
    main,
    afterMain,
    beforeWrite,
    write,
    afterWrite
];

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fg8fT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "popperGenerator", function() {
    return popperGenerator;
});
parcelHelpers.export(exports, "createPopper", function() {
    return createPopper;
});
parcelHelpers.export(exports, "detectOverflow", function() {
    return 0, _detectOverflowJsDefault.default;
});
var _getCompositeRectJs = require("./dom-utils/getCompositeRect.js");
var _getCompositeRectJsDefault = parcelHelpers.interopDefault(_getCompositeRectJs);
var _getLayoutRectJs = require("./dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _listScrollParentsJs = require("./dom-utils/listScrollParents.js");
var _listScrollParentsJsDefault = parcelHelpers.interopDefault(_listScrollParentsJs);
var _getOffsetParentJs = require("./dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _orderModifiersJs = require("./utils/orderModifiers.js");
var _orderModifiersJsDefault = parcelHelpers.interopDefault(_orderModifiersJs);
var _debounceJs = require("./utils/debounce.js");
var _debounceJsDefault = parcelHelpers.interopDefault(_debounceJs);
var _mergeByNameJs = require("./utils/mergeByName.js");
var _mergeByNameJsDefault = parcelHelpers.interopDefault(_mergeByNameJs);
var _detectOverflowJs = require("./utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _instanceOfJs = require("./dom-utils/instanceOf.js");
var DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function popperGenerator(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var _$options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, _$options);
                state.scrollParents = {
                    reference: (0, _instanceOfJs.isElement)(reference) ? (0, _listScrollParentsJsDefault.default)(reference) : reference.contextElement ? (0, _listScrollParentsJsDefault.default)(reference.contextElement) : [],
                    popper: (0, _listScrollParentsJsDefault.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, _orderModifiersJsDefault.default)((0, _mergeByNameJsDefault.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, _$reference = _state$elements.reference, _$popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!areValidElements(_$reference, _$popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, _getCompositeRectJsDefault.default)(_$reference, (0, _getOffsetParentJsDefault.default)(_$popper), state.options.strategy === 'fixed'),
                    popper: (0, _getLayoutRectJsDefault.default)(_$popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, _debounceJsDefault.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, _$options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: _$options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var createPopper = /*#__PURE__*/ popperGenerator(); // eslint-disable-next-line import/no-unused-modules

},{"./dom-utils/getCompositeRect.js":"Enf03","./dom-utils/getLayoutRect.js":"8pwV1","./dom-utils/listScrollParents.js":"8lPAs","./dom-utils/getOffsetParent.js":"eIa18","./utils/orderModifiers.js":"5CPmb","./utils/debounce.js":"e8ZGY","./utils/mergeByName.js":"arn2H","./utils/detectOverflow.js":false,"./dom-utils/instanceOf.js":"qMR4O","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"Enf03":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getCompositeRect;
});
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getNodeScrollJs = require("./getNodeScroll.js");
var _getNodeScrollJsDefault = parcelHelpers.interopDefault(_getNodeScrollJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _instanceOfJs = require("./instanceOf.js");
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
var _mathJs = require("../utils/math.js");
function isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, _mathJs.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, _mathJs.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, _instanceOfJs.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, _instanceOfJs.isHTMLElement)(offsetParent) && isElementScaled(offsetParent);
    var documentElement = (0, _getDocumentElementJsDefault.default)(offsetParent);
    var rect = (0, _getBoundingClientRectJsDefault.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, _getNodeNameJsDefault.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, _isScrollParentJsDefault.default)(documentElement)) scroll = (0, _getNodeScrollJsDefault.default)(offsetParent);
        if ((0, _instanceOfJs.isHTMLElement)(offsetParent)) {
            offsets = (0, _getBoundingClientRectJsDefault.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, _getWindowScrollBarXJsDefault.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

},{"./getBoundingClientRect.js":"iNomO","./getNodeScroll.js":"jZhQ2","./getNodeName.js":"iwIho","./instanceOf.js":"qMR4O","./getWindowScrollBarX.js":"6tSvX","./getDocumentElement.js":"5KI4G","./isScrollParent.js":"3Easg","../utils/math.js":"9Qz9r","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iNomO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getBoundingClientRect;
});
var _instanceOfJs = require("./instanceOf.js");
var _mathJs = require("../utils/math.js");
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _isLayoutViewportJs = require("./isLayoutViewport.js");
var _isLayoutViewportJsDefault = parcelHelpers.interopDefault(_isLayoutViewportJs);
function getBoundingClientRect(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, _instanceOfJs.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, _mathJs.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, _mathJs.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, _instanceOfJs.isElement)(element) ? (0, _getWindowJsDefault.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, _isLayoutViewportJsDefault.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

},{"./instanceOf.js":"qMR4O","../utils/math.js":"9Qz9r","./getWindow.js":"iIOiw","./isLayoutViewport.js":"2i0W9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"qMR4O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isElement", function() {
    return isElement;
});
parcelHelpers.export(exports, "isHTMLElement", function() {
    return isHTMLElement;
});
parcelHelpers.export(exports, "isShadowRoot", function() {
    return isShadowRoot;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function isElement(node) {
    var OwnElement = (0, _getWindowJsDefault.default)(node).Element;
    return (0, _instanceof._)(node, OwnElement) || (0, _instanceof._)(node, Element);
}
function isHTMLElement(node) {
    var OwnElement = (0, _getWindowJsDefault.default)(node).HTMLElement;
    return (0, _instanceof._)(node, OwnElement) || (0, _instanceof._)(node, HTMLElement);
}
function isShadowRoot(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, _getWindowJsDefault.default)(node).ShadowRoot;
    return (0, _instanceof._)(node, OwnElement) || (0, _instanceof._)(node, ShadowRoot);
}

},{"@swc/helpers/_/_instanceof":"h9UKc","./getWindow.js":"iIOiw","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iIOiw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getWindow;
});
function getWindow(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9Qz9r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "max", function() {
    return max;
});
parcelHelpers.export(exports, "min", function() {
    return min;
});
parcelHelpers.export(exports, "round", function() {
    return round;
});
var max = Math.max;
var min = Math.min;
var round = Math.round;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2i0W9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isLayoutViewport;
});
var _userAgentJs = require("../utils/userAgent.js");
var _userAgentJsDefault = parcelHelpers.interopDefault(_userAgentJs);
function isLayoutViewport() {
    return !/^((?!chrome|android).)*safari/i.test((0, _userAgentJsDefault.default)());
}

},{"../utils/userAgent.js":"6VLDh","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6VLDh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getUAString;
});
function getUAString() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jZhQ2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getNodeScroll;
});
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _instanceOfJs = require("./instanceOf.js");
var _getHTMLElementScrollJs = require("./getHTMLElementScroll.js");
var _getHTMLElementScrollJsDefault = parcelHelpers.interopDefault(_getHTMLElementScrollJs);
function getNodeScroll(node) {
    if (node === (0, _getWindowJsDefault.default)(node) || !(0, _instanceOfJs.isHTMLElement)(node)) return (0, _getWindowScrollJsDefault.default)(node);
    else return (0, _getHTMLElementScrollJsDefault.default)(node);
}

},{"./getWindowScroll.js":"7FUFj","./getWindow.js":"iIOiw","./instanceOf.js":"qMR4O","./getHTMLElementScroll.js":"gcXl1","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7FUFj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getWindowScroll;
});
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function getWindowScroll(node) {
    var win = (0, _getWindowJsDefault.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

},{"./getWindow.js":"iIOiw","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gcXl1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getHTMLElementScroll;
});
function getHTMLElementScroll(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iwIho":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getNodeName;
});
function getNodeName(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6tSvX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getWindowScrollBarX;
});
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
function getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, _getBoundingClientRectJsDefault.default)((0, _getDocumentElementJsDefault.default)(element)).left + (0, _getWindowScrollJsDefault.default)(element).scrollLeft;
}

},{"./getBoundingClientRect.js":"iNomO","./getDocumentElement.js":"5KI4G","./getWindowScroll.js":"7FUFj","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5KI4G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getDocumentElement;
});
var _instanceOfJs = require("./instanceOf.js");
function getDocumentElement(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, _instanceOfJs.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

},{"./instanceOf.js":"qMR4O","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3Easg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isScrollParent;
});
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
function isScrollParent(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, _getComputedStyleJsDefault.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

},{"./getComputedStyle.js":"eoRQF","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eoRQF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getComputedStyle;
});
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function getComputedStyle(element) {
    return (0, _getWindowJsDefault.default)(element).getComputedStyle(element);
}

},{"./getWindow.js":"iIOiw","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8pwV1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getLayoutRect;
});
var _getBoundingClientRectJs = require // Returns the layout rect of an element relative to its offsetParent. Layout
("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
function getLayoutRect(element) {
    var clientRect = (0, _getBoundingClientRectJsDefault.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

},{"./getBoundingClientRect.js":"iNomO","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8lPAs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return listScrollParents;
});
var _getScrollParentJs = require("./getScrollParent.js");
var _getScrollParentJsDefault = parcelHelpers.interopDefault(_getScrollParentJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
function listScrollParents(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, _getScrollParentJsDefault.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, _getWindowJsDefault.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, _isScrollParentJsDefault.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat(listScrollParents((0, _getParentNodeJsDefault.default)(target)));
}

},{"./getScrollParent.js":"jAvRf","./getParentNode.js":"1WvAu","./getWindow.js":"iIOiw","./isScrollParent.js":"3Easg","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jAvRf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getScrollParent;
});
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _instanceOfJs = require("./instanceOf.js");
function getScrollParent(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, _getNodeNameJsDefault.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, _instanceOfJs.isHTMLElement)(node) && (0, _isScrollParentJsDefault.default)(node)) return node;
    return getScrollParent((0, _getParentNodeJsDefault.default)(node));
}

},{"./getParentNode.js":"1WvAu","./isScrollParent.js":"3Easg","./getNodeName.js":"iwIho","./instanceOf.js":"qMR4O","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1WvAu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getParentNode;
});
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _instanceOfJs = require("./instanceOf.js");
function getParentNode(element) {
    if ((0, _getNodeNameJsDefault.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, _instanceOfJs.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, _getDocumentElementJsDefault.default)(element) // fallback
    );
}

},{"./getNodeName.js":"iwIho","./getDocumentElement.js":"5KI4G","./instanceOf.js":"qMR4O","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eIa18":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getOffsetParent;
});
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _instanceOfJs = require("./instanceOf.js");
var _isTableElementJs = require("./isTableElement.js");
var _isTableElementJsDefault = parcelHelpers.interopDefault(_isTableElementJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _userAgentJs = require("../utils/userAgent.js");
var _userAgentJsDefault = parcelHelpers.interopDefault(_userAgentJs);
function getTrueOffsetParent(element) {
    if (!(0, _instanceOfJs.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, _getComputedStyleJsDefault.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, _userAgentJsDefault.default)());
    var isIE = /Trident/i.test((0, _userAgentJsDefault.default)());
    if (isIE && (0, _instanceOfJs.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, _getComputedStyleJsDefault.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, _getParentNodeJsDefault.default)(element);
    if ((0, _instanceOfJs.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, _instanceOfJs.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, _getNodeNameJsDefault.default)(currentNode)) < 0){
        var css = (0, _getComputedStyleJsDefault.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function getOffsetParent(element) {
    var window = (0, _getWindowJsDefault.default)(element);
    var offsetParent = getTrueOffsetParent(element);
    while(offsetParent && (0, _isTableElementJsDefault.default)(offsetParent) && (0, _getComputedStyleJsDefault.default)(offsetParent).position === 'static')offsetParent = getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, _getNodeNameJsDefault.default)(offsetParent) === 'html' || (0, _getNodeNameJsDefault.default)(offsetParent) === 'body' && (0, _getComputedStyleJsDefault.default)(offsetParent).position === 'static')) return window;
    return offsetParent || getContainingBlock(element) || window;
}

},{"./getWindow.js":"iIOiw","./getNodeName.js":"iwIho","./getComputedStyle.js":"eoRQF","./instanceOf.js":"qMR4O","./isTableElement.js":"4TvaP","./getParentNode.js":"1WvAu","../utils/userAgent.js":"6VLDh","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4TvaP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isTableElement;
});
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
function isTableElement(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, _getNodeNameJsDefault.default)(element)) >= 0;
}

},{"./getNodeName.js":"iwIho","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5CPmb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return orderModifiers;
});
var _enumsJs = require // source: https://stackoverflow.com/questions/49875255
("../enums.js");
function order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function orderModifiers(modifiers) {
    // order based on dependencies
    var orderedModifiers = order(modifiers); // order based on phase
    return (0, _enumsJs.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

},{"../enums.js":"1lwWm","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"e8ZGY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return debounce;
});
function debounce(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"arn2H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return mergeByName;
});
function mergeByName(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"a7bOO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return detectOverflow;
});
var _getClippingRectJs = require("../dom-utils/getClippingRect.js");
var _getClippingRectJsDefault = parcelHelpers.interopDefault(_getClippingRectJs);
var _getDocumentElementJs = require("../dom-utils/getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getBoundingClientRectJs = require("../dom-utils/getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _computeOffsetsJs = require("./computeOffsets.js");
var _computeOffsetsJsDefault = parcelHelpers.interopDefault(_computeOffsetsJs);
var _rectToClientRectJs = require("./rectToClientRect.js");
var _rectToClientRectJsDefault = parcelHelpers.interopDefault(_rectToClientRectJs);
var _enumsJs = require("../enums.js");
var _instanceOfJs = require("../dom-utils/instanceOf.js");
var _mergePaddingObjectJs = require("./mergePaddingObject.js");
var _mergePaddingObjectJsDefault = parcelHelpers.interopDefault(_mergePaddingObjectJs);
var _expandToHashMapJs = require // eslint-disable-next-line import/no-unused-modules
("./expandToHashMap.js");
var _expandToHashMapJsDefault = parcelHelpers.interopDefault(_expandToHashMapJs);
function detectOverflow(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, _enumsJs.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, _enumsJs.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, _enumsJs.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, _mergePaddingObjectJsDefault.default)(typeof padding !== 'number' ? padding : (0, _expandToHashMapJsDefault.default)(padding, (0, _enumsJs.basePlacements)));
    var altContext = elementContext === (0, _enumsJs.popper) ? (0, _enumsJs.reference) : (0, _enumsJs.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, _getClippingRectJsDefault.default)((0, _instanceOfJs.isElement)(element) ? element : element.contextElement || (0, _getDocumentElementJsDefault.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, _getBoundingClientRectJsDefault.default)(state.elements.reference);
    var popperOffsets = (0, _computeOffsetsJsDefault.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, _rectToClientRectJsDefault.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, _enumsJs.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, _enumsJs.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, _enumsJs.right),
                (0, _enumsJs.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, _enumsJs.top),
                (0, _enumsJs.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

},{"../dom-utils/getClippingRect.js":"jg7fG","../dom-utils/getDocumentElement.js":"5KI4G","../dom-utils/getBoundingClientRect.js":"iNomO","./computeOffsets.js":"1VqQs","./rectToClientRect.js":"decNn","../enums.js":"1lwWm","../dom-utils/instanceOf.js":"qMR4O","./mergePaddingObject.js":"7STG4","./expandToHashMap.js":"4p7fS","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jg7fG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getClippingRect;
});
var _enumsJs = require("../enums.js");
var _getViewportRectJs = require("./getViewportRect.js");
var _getViewportRectJsDefault = parcelHelpers.interopDefault(_getViewportRectJs);
var _getDocumentRectJs = require("./getDocumentRect.js");
var _getDocumentRectJsDefault = parcelHelpers.interopDefault(_getDocumentRectJs);
var _listScrollParentsJs = require("./listScrollParents.js");
var _listScrollParentsJsDefault = parcelHelpers.interopDefault(_listScrollParentsJs);
var _getOffsetParentJs = require("./getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _instanceOfJs = require("./instanceOf.js");
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _containsJs = require("./contains.js");
var _containsJsDefault = parcelHelpers.interopDefault(_containsJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _rectToClientRectJs = require("../utils/rectToClientRect.js");
var _rectToClientRectJsDefault = parcelHelpers.interopDefault(_rectToClientRectJs);
var _mathJs = require("../utils/math.js");
function getInnerBoundingClientRect(element, strategy) {
    var rect = (0, _getBoundingClientRectJsDefault.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, _enumsJs.viewport) ? (0, _rectToClientRectJsDefault.default)((0, _getViewportRectJsDefault.default)(element, strategy)) : (0, _instanceOfJs.isElement)(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : (0, _rectToClientRectJsDefault.default)((0, _getDocumentRectJsDefault.default)((0, _getDocumentElementJsDefault.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function getClippingParents(element) {
    var clippingParents = (0, _listScrollParentsJsDefault.default)((0, _getParentNodeJsDefault.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, _getComputedStyleJsDefault.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, _instanceOfJs.isHTMLElement)(element) ? (0, _getOffsetParentJsDefault.default)(element) : element;
    if (!(0, _instanceOfJs.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, _instanceOfJs.isElement)(clippingParent) && (0, _containsJsDefault.default)(clippingParent, clipperElement) && (0, _getNodeNameJsDefault.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function getClippingRect(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, _mathJs.max)(rect.top, accRect.top);
        accRect.right = (0, _mathJs.min)(rect.right, accRect.right);
        accRect.bottom = (0, _mathJs.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, _mathJs.max)(rect.left, accRect.left);
        return accRect;
    }, getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

},{"../enums.js":"1lwWm","./getViewportRect.js":"5GMYq","./getDocumentRect.js":"6N1Xe","./listScrollParents.js":"8lPAs","./getOffsetParent.js":"eIa18","./getDocumentElement.js":"5KI4G","./getComputedStyle.js":"eoRQF","./instanceOf.js":"qMR4O","./getBoundingClientRect.js":"iNomO","./getParentNode.js":"1WvAu","./contains.js":"fTuMy","./getNodeName.js":"iwIho","../utils/rectToClientRect.js":"decNn","../utils/math.js":"9Qz9r","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5GMYq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getViewportRect;
});
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _isLayoutViewportJs = require("./isLayoutViewport.js");
var _isLayoutViewportJsDefault = parcelHelpers.interopDefault(_isLayoutViewportJs);
function getViewportRect(element, strategy) {
    var win = (0, _getWindowJsDefault.default)(element);
    var html = (0, _getDocumentElementJsDefault.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, _isLayoutViewportJsDefault.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, _getWindowScrollBarXJsDefault.default)(element),
        y: y
    };
}

},{"./getWindow.js":"iIOiw","./getDocumentElement.js":"5KI4G","./getWindowScrollBarX.js":"6tSvX","./isLayoutViewport.js":"2i0W9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6N1Xe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getDocumentRect;
});
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
var _mathJs = require // Gets the entire size of the scrollable document area, even extending outside
("../utils/math.js");
function getDocumentRect(element) {
    var _element$ownerDocumen;
    var html = (0, _getDocumentElementJsDefault.default)(element);
    var winScroll = (0, _getWindowScrollJsDefault.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, _mathJs.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, _mathJs.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, _getWindowScrollBarXJsDefault.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, _getComputedStyleJsDefault.default)(body || html).direction === 'rtl') x += (0, _mathJs.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

},{"./getDocumentElement.js":"5KI4G","./getComputedStyle.js":"eoRQF","./getWindowScrollBarX.js":"6tSvX","./getWindowScroll.js":"7FUFj","../utils/math.js":"9Qz9r","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fTuMy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return contains;
});
var _instanceOfJs = require("./instanceOf.js");
function contains(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, _instanceOfJs.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

},{"./instanceOf.js":"qMR4O","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"decNn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return rectToClientRect;
});
function rectToClientRect(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1VqQs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return computeOffsets;
});
var _getBasePlacementJs = require("./getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getVariationJs = require("./getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _getMainAxisFromPlacementJs = require("./getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _enumsJs = require("../enums.js");
function computeOffsets(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, _getBasePlacementJsDefault.default)(placement) : null;
    var variation = placement ? (0, _getVariationJsDefault.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, _enumsJs.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, _enumsJs.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, _enumsJs.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, _enumsJs.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, _enumsJs.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, _enumsJs.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

},{"./getBasePlacement.js":"etRI4","./getVariation.js":"bnPY8","./getMainAxisFromPlacement.js":"baABc","../enums.js":"1lwWm","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"etRI4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getBasePlacement;
});
var _enumsJs = require("../enums.js");
function getBasePlacement(placement) {
    return placement.split('-')[0];
}

},{"../enums.js":"1lwWm","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bnPY8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getVariation;
});
function getVariation(placement) {
    return placement.split('-')[1];
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"baABc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getMainAxisFromPlacement;
});
function getMainAxisFromPlacement(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7STG4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return mergePaddingObject;
});
var _getFreshSideObjectJs = require("./getFreshSideObject.js");
var _getFreshSideObjectJsDefault = parcelHelpers.interopDefault(_getFreshSideObjectJs);
function mergePaddingObject(paddingObject) {
    return Object.assign({}, (0, _getFreshSideObjectJsDefault.default)(), paddingObject);
}

},{"./getFreshSideObject.js":"eT6Tx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eT6Tx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getFreshSideObject;
});
function getFreshSideObject() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4p7fS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return expandToHashMap;
});
function expandToHashMap(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dOvVs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createPopperLite", function() {
    return 0, _popperLiteJs.createPopper;
}); // eslint-disable-next-line import/no-unused-modules
parcelHelpers.export(exports, "createPopper", function() {
    return createPopper;
}); // eslint-disable-next-line import/no-unused-modules
parcelHelpers.export(exports, "popperGenerator", function() {
    return 0, _createPopperJs.popperGenerator;
});
parcelHelpers.export(exports, "defaultModifiers", function() {
    return defaultModifiers;
});
parcelHelpers.export(exports, "detectOverflow", function() {
    return 0, _createPopperJs.detectOverflow;
});
var _createPopperJs = require("./createPopper.js");
var _eventListenersJs = require("./modifiers/eventListeners.js");
var _eventListenersJsDefault = parcelHelpers.interopDefault(_eventListenersJs);
var _popperOffsetsJs = require("./modifiers/popperOffsets.js");
var _popperOffsetsJsDefault = parcelHelpers.interopDefault(_popperOffsetsJs);
var _computeStylesJs = require("./modifiers/computeStyles.js");
var _computeStylesJsDefault = parcelHelpers.interopDefault(_computeStylesJs);
var _applyStylesJs = require("./modifiers/applyStyles.js");
var _applyStylesJsDefault = parcelHelpers.interopDefault(_applyStylesJs);
var _offsetJs = require("./modifiers/offset.js");
var _offsetJsDefault = parcelHelpers.interopDefault(_offsetJs);
var _flipJs = require("./modifiers/flip.js");
var _flipJsDefault = parcelHelpers.interopDefault(_flipJs);
var _preventOverflowJs = require("./modifiers/preventOverflow.js");
var _preventOverflowJsDefault = parcelHelpers.interopDefault(_preventOverflowJs);
var _arrowJs = require("./modifiers/arrow.js");
var _arrowJsDefault = parcelHelpers.interopDefault(_arrowJs);
var _hideJs = require("./modifiers/hide.js");
var _hideJsDefault = parcelHelpers.interopDefault(_hideJs);
var _popperLiteJs = require("./popper-lite.js");
var _indexJs = require("./modifiers/index.js");
parcelHelpers.exportAll(_indexJs, exports);
var defaultModifiers = [
    (0, _eventListenersJsDefault.default),
    (0, _popperOffsetsJsDefault.default),
    (0, _computeStylesJsDefault.default),
    (0, _applyStylesJsDefault.default),
    (0, _offsetJsDefault.default),
    (0, _flipJsDefault.default),
    (0, _preventOverflowJsDefault.default),
    (0, _arrowJsDefault.default),
    (0, _hideJsDefault.default)
];
var createPopper = /*#__PURE__*/ (0, _createPopperJs.popperGenerator)({
    defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

},{"./createPopper.js":"fg8fT","./modifiers/eventListeners.js":"lSylz","./modifiers/popperOffsets.js":"7I9U7","./modifiers/computeStyles.js":"Fio91","./modifiers/applyStyles.js":"fODnH","./modifiers/offset.js":"lkdHi","./modifiers/flip.js":"k4dec","./modifiers/preventOverflow.js":"iGv9c","./modifiers/arrow.js":"2mT2H","./modifiers/hide.js":"ewdTW","./popper-lite.js":false,"./modifiers/index.js":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lSylz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getWindowJs = require // eslint-disable-next-line import/no-unused-modules
("../dom-utils/getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var passive = {
    passive: true
};
function effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, _getWindowJsDefault.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, passive);
    });
    if (resize) window.addEventListener('resize', instance.update, passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, passive);
    };
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: effect,
    data: {}
};

},{"../dom-utils/getWindow.js":"iIOiw","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7I9U7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _computeOffsetsJs = require("../utils/computeOffsets.js");
var _computeOffsetsJsDefault = parcelHelpers.interopDefault(_computeOffsetsJs);
function popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, _computeOffsetsJsDefault.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: popperOffsets,
    data: {}
};

},{"../utils/computeOffsets.js":"1VqQs","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"Fio91":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapToStyles", function() {
    return mapToStyles;
});
var _enumsJs = require("../enums.js");
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getWindowJs = require("../dom-utils/getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getDocumentElementJs = require("../dom-utils/getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("../dom-utils/getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getVariationJs = require("../utils/getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _mathJs = require // eslint-disable-next-line import/no-unused-modules
("../utils/math.js");
var unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, _mathJs.round)(x * dpr) / dpr || 0,
        y: (0, _mathJs.round)(y * dpr) / dpr || 0
    };
}
function mapToStyles(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, _enumsJs.left);
    var sideY = (0, _enumsJs.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, _getOffsetParentJsDefault.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, _getWindowJsDefault.default)(popper)) {
            offsetParent = (0, _getDocumentElementJsDefault.default)(popper);
            if ((0, _getComputedStyleJsDefault.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, _enumsJs.top) || (placement === (0, _enumsJs.left) || placement === (0, _enumsJs.right)) && variation === (0, _enumsJs.end)) {
            sideY = (0, _enumsJs.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, _enumsJs.left) || (placement === (0, _enumsJs.top) || placement === (0, _enumsJs.bottom)) && variation === (0, _enumsJs.end)) {
            sideX = (0, _enumsJs.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && unsetSides);
    var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, _getWindowJsDefault.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, _getBasePlacementJsDefault.default)(state.placement),
        variation: (0, _getVariationJsDefault.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: computeStyles,
    data: {}
};

},{"../enums.js":"1lwWm","../dom-utils/getOffsetParent.js":"eIa18","../dom-utils/getWindow.js":"iIOiw","../dom-utils/getDocumentElement.js":"5KI4G","../dom-utils/getComputedStyle.js":"eoRQF","../utils/getBasePlacement.js":"etRI4","../utils/getVariation.js":"bnPY8","../utils/math.js":"9Qz9r","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fODnH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNodeNameJs = require("../dom-utils/getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _instanceOfJs = require // This modifier takes the styles prepared by the `computeStyles` modifier
("../dom-utils/instanceOf.js");
// and applies them to the HTMLElements such as popper and arrow
function applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, _instanceOfJs.isHTMLElement)(element) || !(0, _getNodeNameJsDefault.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, _instanceOfJs.isHTMLElement)(element) || !(0, _getNodeNameJsDefault.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: applyStyles,
    effect: effect,
    requires: [
        'computeStyles'
    ]
};

},{"../dom-utils/getNodeName.js":"iwIho","../dom-utils/instanceOf.js":"qMR4O","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lkdHi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "distanceAndSkiddingToXY", function() {
    return distanceAndSkiddingToXY;
});
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _enumsJs = require // eslint-disable-next-line import/no-unused-modules
("../enums.js");
function distanceAndSkiddingToXY(placement, rects, offset) {
    var basePlacement = (0, _getBasePlacementJsDefault.default)(placement);
    var invertDistance = [
        (0, _enumsJs.left),
        (0, _enumsJs.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, _enumsJs.left),
        (0, _enumsJs.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, _$offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, _enumsJs.placements).reduce(function(acc, placement) {
        acc[placement] = distanceAndSkiddingToXY(placement, state.rects, _$offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: offset
};

},{"../utils/getBasePlacement.js":"etRI4","../enums.js":"1lwWm","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"k4dec":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getOppositePlacementJs = require("../utils/getOppositePlacement.js");
var _getOppositePlacementJsDefault = parcelHelpers.interopDefault(_getOppositePlacementJs);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getOppositeVariationPlacementJs = require("../utils/getOppositeVariationPlacement.js");
var _getOppositeVariationPlacementJsDefault = parcelHelpers.interopDefault(_getOppositeVariationPlacementJs);
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _computeAutoPlacementJs = require("../utils/computeAutoPlacement.js");
var _computeAutoPlacementJsDefault = parcelHelpers.interopDefault(_computeAutoPlacementJs);
var _enumsJs = require("../enums.js");
var _getVariationJs = require // eslint-disable-next-line import/no-unused-modules
("../utils/getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
function getExpandedFallbackPlacements(placement) {
    if ((0, _getBasePlacementJsDefault.default)(placement) === (0, _enumsJs.auto)) return [];
    var oppositePlacement = (0, _getOppositePlacementJsDefault.default)(placement);
    return [
        (0, _getOppositeVariationPlacementJsDefault.default)(placement),
        oppositePlacement,
        (0, _getOppositeVariationPlacementJsDefault.default)(oppositePlacement)
    ];
}
function flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, _getBasePlacementJsDefault.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, _getOppositePlacementJsDefault.default)(preferredPlacement)
    ] : getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, _getBasePlacementJsDefault.default)(placement) === (0, _enumsJs.auto) ? (0, _computeAutoPlacementJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, _getBasePlacementJsDefault.default)(placement);
        var isStartVariation = (0, _getVariationJsDefault.default)(placement) === (0, _enumsJs.start);
        var isVertical = [
            (0, _enumsJs.top),
            (0, _enumsJs.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, _detectOverflowJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, _enumsJs.right) : (0, _enumsJs.left) : isStartVariation ? (0, _enumsJs.bottom) : (0, _enumsJs.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, _getOppositePlacementJsDefault.default)(mainVariationSide);
        var altVariationSide = (0, _getOppositePlacementJsDefault.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

},{"../utils/getOppositePlacement.js":"8eVxc","../utils/getBasePlacement.js":"etRI4","../utils/getOppositeVariationPlacement.js":"cH7ZM","../utils/detectOverflow.js":"a7bOO","../utils/computeAutoPlacement.js":"ja6QN","../enums.js":"1lwWm","../utils/getVariation.js":"bnPY8","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8eVxc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getOppositePlacement;
});
var hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return hash[matched];
    });
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cH7ZM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getOppositeVariationPlacement;
});
var hash = {
    start: 'end',
    end: 'start'
};
function getOppositeVariationPlacement(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return hash[matched];
    });
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ja6QN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return computeAutoPlacement;
});
var _getVariationJs = require("./getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _enumsJs = require("../enums.js");
var _detectOverflowJs = require("./detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _getBasePlacementJs = require("./getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
function computeAutoPlacement(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, _enumsJs.placements) : _options$allowedAutoP;
    var variation = (0, _getVariationJsDefault.default)(placement);
    var placements = variation ? flipVariations ? (0, _enumsJs.variationPlacements) : (0, _enumsJs.variationPlacements).filter(function(placement) {
        return (0, _getVariationJsDefault.default)(placement) === variation;
    }) : (0, _enumsJs.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, _detectOverflowJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, _getBasePlacementJsDefault.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

},{"./getVariation.js":"bnPY8","../enums.js":"1lwWm","./detectOverflow.js":"a7bOO","./getBasePlacement.js":"etRI4","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iGv9c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _enumsJs = require("../enums.js");
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getMainAxisFromPlacementJs = require("../utils/getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _getAltAxisJs = require("../utils/getAltAxis.js");
var _getAltAxisJsDefault = parcelHelpers.interopDefault(_getAltAxisJs);
var _withinJs = require("../utils/within.js");
var _getLayoutRectJs = require("../dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _getVariationJs = require("../utils/getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _getFreshSideObjectJs = require("../utils/getFreshSideObject.js");
var _getFreshSideObjectJsDefault = parcelHelpers.interopDefault(_getFreshSideObjectJs);
var _mathJs = require("../utils/math.js");
function preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, _detectOverflowJsDefault.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, _getBasePlacementJsDefault.default)(state.placement);
    var variation = (0, _getVariationJsDefault.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement);
    var altAxis = (0, _getAltAxisJsDefault.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, _enumsJs.top) : (0, _enumsJs.left);
        var altSide = mainAxis === 'y' ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, _enumsJs.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, _enumsJs.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, _getLayoutRectJsDefault.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, _getFreshSideObjectJsDefault.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, _withinJs.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, _getOffsetParentJsDefault.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, _withinJs.within)(tether ? (0, _mathJs.min)(min, tetherMin) : min, offset, tether ? (0, _mathJs.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, _enumsJs.top) : (0, _enumsJs.left);
        var _altSide = mainAxis === 'x' ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, _enumsJs.top),
            (0, _enumsJs.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, _withinJs.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, _withinJs.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

},{"../enums.js":"1lwWm","../utils/getBasePlacement.js":"etRI4","../utils/getMainAxisFromPlacement.js":"baABc","../utils/getAltAxis.js":"hc9jw","../utils/within.js":"h1Nzj","../dom-utils/getLayoutRect.js":"8pwV1","../dom-utils/getOffsetParent.js":"eIa18","../utils/detectOverflow.js":"a7bOO","../utils/getVariation.js":"bnPY8","../utils/getFreshSideObject.js":"eT6Tx","../utils/math.js":"9Qz9r","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hc9jw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getAltAxis;
});
function getAltAxis(axis) {
    return axis === 'x' ? 'y' : 'x';
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"h1Nzj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "within", function() {
    return within;
});
parcelHelpers.export(exports, "withinMaxClamp", function() {
    return withinMaxClamp;
});
var _mathJs = require("./math.js");
function within(min, value, max) {
    return (0, _mathJs.max)(min, (0, _mathJs.min)(value, max));
}
function withinMaxClamp(min, value, max) {
    var v = within(min, value, max);
    return v > max ? max : v;
}

},{"./math.js":"9Qz9r","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2mT2H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getLayoutRectJs = require("../dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _containsJs = require("../dom-utils/contains.js");
var _containsJsDefault = parcelHelpers.interopDefault(_containsJs);
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getMainAxisFromPlacementJs = require("../utils/getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _withinJs = require("../utils/within.js");
var _mergePaddingObjectJs = require("../utils/mergePaddingObject.js");
var _mergePaddingObjectJsDefault = parcelHelpers.interopDefault(_mergePaddingObjectJs);
var _expandToHashMapJs = require("../utils/expandToHashMap.js");
var _expandToHashMapJsDefault = parcelHelpers.interopDefault(_expandToHashMapJs);
var _enumsJs = require // eslint-disable-next-line import/no-unused-modules
("../enums.js");
var toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, _mergePaddingObjectJsDefault.default)(typeof padding !== 'number' ? padding : (0, _expandToHashMapJsDefault.default)(padding, (0, _enumsJs.basePlacements)));
};
function arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, _getBasePlacementJsDefault.default)(state.placement);
    var axis = (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement);
    var isVertical = [
        (0, _enumsJs.left),
        (0, _enumsJs.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = toPaddingObject(options.padding, state);
    var arrowRect = (0, _getLayoutRectJsDefault.default)(arrowElement);
    var minProp = axis === 'y' ? (0, _enumsJs.top) : (0, _enumsJs.left);
    var maxProp = axis === 'y' ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, _getOffsetParentJsDefault.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, _withinJs.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, _containsJsDefault.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: arrow,
    effect: effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

},{"../utils/getBasePlacement.js":"etRI4","../dom-utils/getLayoutRect.js":"8pwV1","../dom-utils/contains.js":"fTuMy","../dom-utils/getOffsetParent.js":"eIa18","../utils/getMainAxisFromPlacement.js":"baABc","../utils/within.js":"h1Nzj","../utils/mergePaddingObject.js":"7STG4","../utils/expandToHashMap.js":"4p7fS","../enums.js":"1lwWm","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ewdTW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _enumsJs = require("../enums.js");
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
function getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function isAnySideFullyClipped(overflow) {
    return [
        (0, _enumsJs.top),
        (0, _enumsJs.right),
        (0, _enumsJs.bottom),
        (0, _enumsJs.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, _detectOverflowJsDefault.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, _detectOverflowJsDefault.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: hide
};

},{"../enums.js":"1lwWm","../utils/detectOverflow.js":"a7bOO","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8GPFg":[function(require,module,exports,__globalThis) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var _instanceof = require("@swc/helpers/_/_instanceof");
var _typeOf = require("@swc/helpers/_/_type_of");
var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && (typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)) == 'object' && (typeof b === "undefined" ? "undefined" : (0, _typeOf._)(b)) == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if (hasMap && (0, _instanceof._)(a, Map) && (0, _instanceof._)(b, Map)) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if (hasSet && (0, _instanceof._)(a, Set) && (0, _instanceof._)(b, Set)) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if (hasElementType && (0, _instanceof._)(a, Element)) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

},{"@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_type_of":"iFJdx"}],"c68RF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Reference", function() {
    return Reference;
});
var _react = require("react");
var _warning = require("warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _manager = require("./Manager");
var _utils = require("./utils");
function Reference(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = _react.useContext((0, _manager.ManagerReferenceNodeSetterContext));
    var refHandler = _react.useCallback(function(node) {
        (0, _utils.setRef)(innerRef, node);
        (0, _utils.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    _react.useEffect(function() {
        return function() {
            return (0, _utils.setRef)(innerRef, null);
        };
    }, []);
    _react.useEffect(function() {
        (0, _warningDefault.default)(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, _utils.unwrapArray)(children)({
        ref: refHandler
    });
}

},{"react":"ltHCL","warning":"5WfJp","./Manager":"ltEqg","./utils":"9X8cu","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5WfJp":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var __DEV__ = false;
var warning = function warning() {};
if (__DEV__) {
    var printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    warning = function warning(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = warning;

},{}],"25oTb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getMaxSizeModifiers", function() {
    return getMaxSizeModifiers;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
function getMaxSizeModifiers(param) {
    var viewportPadding = param.viewportPadding;
    return [
        {
            /**
			 * Performing DOM measurements in the 'read' phase,
			 * which is the convention for popper modifiers
			 */ name: 'maxSizeData',
            enabled: true,
            phase: 'read',
            fn: function fn(param) {
                var state = param.state, name = param.name;
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
			 * Applying max size CSS
			 */ name: 'maxSize',
            enabled: true,
            phase: 'beforeWrite',
            requiresIfExists: [
                'offset',
                'preventOverflow',
                'flip'
            ],
            fn: function fn(param) {
                var state = param.state;
                var _data_viewport, _data_viewport1, _state_modifiersData_offset, _state_modifiersData;
                var data = state.modifiersData.maxSizeData;
                if (typeof (data === null || data === void 0 ? void 0 : (_data_viewport = data.viewport) === null || _data_viewport === void 0 ? void 0 : _data_viewport.width) !== 'number' || typeof (data === null || data === void 0 ? void 0 : (_data_viewport1 = data.viewport) === null || _data_viewport1 === void 0 ? void 0 : _data_viewport1.height) !== 'number') // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                var viewport = data.viewport;
                var _state_modifiersData1 = state.modifiersData, _state_modifiersData_popperOffsets = _state_modifiersData1.popperOffsets, popperOffsets = _state_modifiersData_popperOffsets === void 0 ? {
                    x: 0,
                    y: 0
                } : _state_modifiersData_popperOffsets;
                var _state_placement_split = (0, _slicedToArray._)(state.placement.split('-'), 1), basePlacement = _state_placement_split[0];
                var _state_modifiersData_offset_state_placement;
                var placementOffset = (_state_modifiersData_offset_state_placement = (_state_modifiersData = state.modifiersData) === null || _state_modifiersData === void 0 ? void 0 : (_state_modifiersData_offset = _state_modifiersData.offset) === null || _state_modifiersData_offset === void 0 ? void 0 : _state_modifiersData_offset[state.placement]) !== null && _state_modifiersData_offset_state_placement !== void 0 ? _state_modifiersData_offset_state_placement : {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                var maxWidth = viewport.width - 2 * viewportPadding;
                var maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === 'top') maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'bottom') maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === 'left') maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'right') maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = "".concat(maxWidth, "px");
                state.styles.popper.maxHeight = "".concat(maxHeight, "px");
            }
        }
    ];
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kqyHU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return 0, _portalDefault.default;
});
parcelHelpers.export(exports, "PORTAL_MOUNT_EVENT", function() {
    return 0, _constants.PORTAL_MOUNT_EVENT;
});
parcelHelpers.export(exports, "PORTAL_UNMOUNT_EVENT", function() {
    return 0, _constants.PORTAL_UNMOUNT_EVENT;
});
var _portal = require("./portal");
var _portalDefault = parcelHelpers.interopDefault(_portal);
var _constants = require("./constants");

},{"./portal":"5sqv1","./constants":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5sqv1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return Portal;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _internalPortal = require("./internal/components/internal-portal");
var _internalPortalDefault = parcelHelpers.interopDefault(_internalPortal);
var _internalPortalNew = require("./internal/components/internal-portal-new");
var _internalPortalNewDefault = parcelHelpers.interopDefault(_internalPortalNew);
var _useIsSubsequentRender = require("./internal/hooks/use-is-subsequent-render");
var _useIsSubsequentRenderDefault = parcelHelpers.interopDefault(_useIsSubsequentRender);
var _usePortalEvent = require("./internal/hooks/use-portal-event");
var _usePortalEventDefault = parcelHelpers.interopDefault(_usePortalEvent);
function Portal(param) {
    var _param_zIndex = param.zIndex, zIndex = _param_zIndex === void 0 ? 0 : _param_zIndex, children = param.children, _param_mountStrategy = param.mountStrategy, mountStrategy = _param_mountStrategy === void 0 ? 'effect' : _param_mountStrategy, _param_isClosed = param.isClosed, isClosed = _param_isClosed === void 0 ? false : _param_isClosed;
    var isSubsequentRender = (0, _useIsSubsequentRenderDefault.default)(mountStrategy);
    (0, _usePortalEventDefault.default)(zIndex);
    return !(0, _platformFeatureFlags.fg)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _internalPortalDefault.default), {
        zIndex: zIndex,
        isClosed: isClosed,
        children: children
    }) : null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _internalPortalNewDefault.default), {
        zIndex: zIndex,
        isClosed: isClosed,
        children: children
    });
}

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","@atlaskit/platform-feature-flags":"kO5t9","./internal/components/internal-portal":"lAQsC","./internal/components/internal-portal-new":"js96B","./internal/hooks/use-is-subsequent-render":"cQEKH","./internal/hooks/use-portal-event":"m97ty","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lAQsC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return InternalPortal;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _appProvider = require("@atlaskit/app-provider");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _appendPortalContainerIfNotAppended = require("../utils/append-portal-container-if-not-appended");
var _createContainer = require("../utils/create-container");
var _removePortalContainer = require("../utils/remove-portal-container");
function InternalPortal(props) {
    var zIndex = props.zIndex, children = props.children, _props_isClosed = props.isClosed, isClosed = _props_isClosed === void 0 ? false : _props_isClosed;
    var container = (0, _react.useMemo)(function() {
        return (0, _createContainer.createContainer)(zIndex);
    }, [
        zIndex
    ]);
    var colorMode = (0, _appProvider.useColorMode)();
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, _appendPortalContainerIfNotAppended.appendPortalContainerIfNotAppended)(container);
    (0, _react.useEffect)(function() {
        if ((0, _platformFeatureFlags.fg)('import_into_jsm_in_template_gallery_killswitch')) {
            if (isClosed) (0, _removePortalContainer.removePortalContainer)(container);
        }
    }, [
        isClosed,
        container
    ]);
    (0, _react.useEffect)(function() {
        return function() {
            (0, _removePortalContainer.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, _reactDom.createPortal)(colorMode ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appProvider.ThemeProvider), {
        defaultColorMode: colorMode,
        children: children
    }) : children, container);
}

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","react-dom":"bvX0P","@atlaskit/app-provider":"cnK0e","@atlaskit/platform-feature-flags":"kO5t9","../utils/append-portal-container-if-not-appended":"763K1","../utils/create-container":"dpGGR","../utils/remove-portal-container":"9Dnf1","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"763K1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "appendPortalContainerIfNotAppended", function() {
    return appendPortalContainerIfNotAppended;
});
var _constants = require("../constants");
var _getBody = require("./get-body");
var getPortalParent = function() {
    var parentElement = document.querySelector((0, _constants.portalParentSelector));
    if (!parentElement) {
        var _getBody1;
        var parent = document.createElement('div');
        parent.className = (0, _constants.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody1 = (0, _getBody.getBody)()) === null || _getBody1 === void 0 ? void 0 : _getBody1.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var appendPortalContainerIfNotAppended = function(container) {
    if (!container.parentElement) getPortalParent().appendChild(container);
};

},{"../constants":"qzO8D","./get-body":"fFidZ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"qzO8D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "portalParentClassName", function() {
    return portalParentClassName;
});
parcelHelpers.export(exports, "portalParentSelector", function() {
    return portalParentSelector;
});
parcelHelpers.export(exports, "portalClassName", function() {
    return portalClassName;
});
var portalParentClassName = 'atlaskit-portal-container';
var portalParentSelector = 'body > .atlaskit-portal-container';
var portalClassName = 'atlaskit-portal';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fFidZ":[function(require,module,exports,__globalThis) {
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getBody", function() {
    return getBody;
});
var getBody = function() {
    return document.body;
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dpGGR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createContainer", function() {
    return createContainer;
});
var _constants = require("../constants");
var createContainer = function(zIndex) {
    var container = document.createElement('div');
    container.className = (0, _constants.portalClassName);
    container.style.zIndex = "".concat(zIndex);
    return container;
};

},{"../constants":"qzO8D","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9Dnf1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "removePortalContainer", function() {
    return removePortalContainer;
});
var _constants = require("../constants");
var _getBody = require("./get-body");
var getPortalParent = function() {
    var parentElement = document.querySelector((0, _constants.portalParentSelector));
    if (!parentElement) {
        var _getBody1;
        var parent = document.createElement('div');
        parent.className = (0, _constants.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody1 = (0, _getBody.getBody)()) === null || _getBody1 === void 0 ? void 0 : _getBody1.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var removePortalContainer = function(container) {
    var parent = getPortalParent();
    if (parent.contains(container)) parent.removeChild(container);
};

},{"../constants":"qzO8D","./get-body":"fFidZ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"js96B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return InternalPortalNew;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _appProvider = require("@atlaskit/app-provider");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _useIsomorphicLayoutEffect = require("../hooks/use-isomorphic-layout-effect");
var _createAtlaskitPortal = require("../utils/create-atlaskit-portal");
var _createPortalParent = require("../utils/create-portal-parent");
var _removePortalParent = require("../utils/remove-portal-parent");
function InternalPortalNew(props) {
    var zIndex = props.zIndex, children = props.children, isClosed = props.isClosed;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(null), 2), atlaskitPortal = _useState[0], setAtlaskitPortal = _useState[1];
    var colorMode = (0, _appProvider.useColorMode)();
    (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function() {
        if ((0, _platformFeatureFlags.fg)('import_into_jsm_in_template_gallery_killswitch')) {
            if (!isClosed) {
                var tempPortalContainer = (0, _createAtlaskitPortal.createAtlaskitPortal)(zIndex);
                setAtlaskitPortal(tempPortalContainer);
                var portalParent = (0, _createPortalParent.createPortalParent)();
                if (!tempPortalContainer || !portalParent) return;
                portalParent.appendChild(tempPortalContainer);
                return function() {
                    if (portalParent) {
                        portalParent.removeChild(tempPortalContainer);
                        !portalParent.hasChildNodes() && (0, _removePortalParent.removePortalParent)(portalParent);
                    }
                    setAtlaskitPortal(null);
                };
            }
        } else {
            var tempPortalContainer1 = (0, _createAtlaskitPortal.createAtlaskitPortal)(zIndex);
            setAtlaskitPortal(tempPortalContainer1);
            var portalParent1 = (0, _createPortalParent.createPortalParent)();
            if (!tempPortalContainer1 || !portalParent1) return;
            portalParent1.appendChild(tempPortalContainer1);
            return function() {
                if (tempPortalContainer1) portalParent1.removeChild(tempPortalContainer1);
                setAtlaskitPortal(null);
            };
        }
    }, [
        zIndex,
        isClosed,
        (0, _platformFeatureFlags.fg)
    ]);
    /**
	 * We wrap portal children with a Suspense boundary because in React 18 concurrent,
	 * if you suspend from _within_ a portal to a Suspense boundary _outside_ the portal,
	 * our portal gets in an infinite loop of rendering.
	 */ var suspendedChildren = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Suspense), {
        fallback: null,
        children: colorMode ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appProvider.ThemeProvider), {
            defaultColorMode: colorMode,
            children: children
        }) : children
    });
    return atlaskitPortal ? /*#__PURE__*/ (0, _reactDom.createPortal)(suspendedChildren, atlaskitPortal) : null;
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","react/jsx-runtime":"bGvcw","react":"ltHCL","react-dom":"bvX0P","@atlaskit/app-provider":"cnK0e","@atlaskit/platform-feature-flags":"kO5t9","../hooks/use-isomorphic-layout-effect":"cazU0","../utils/create-atlaskit-portal":"8Cflv","../utils/create-portal-parent":"baFMD","../utils/remove-portal-parent":"bhbUX","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cazU0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIsomorphicLayoutEffect", function() {
    return useIsomorphicLayoutEffect;
});
var _react = require("react");
var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? (0, _react.useLayoutEffect) : (0, _react.useEffect);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8Cflv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createAtlaskitPortal", function() {
    return createAtlaskitPortal;
});
var _constants = require("../constants");
var isDocumentDefined = function() {
    return document !== undefined;
};
var createAtlaskitPortal = function(zIndex) {
    //atlaskit-portal div
    if (isDocumentDefined()) {
        var atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, _constants.portalClassName);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
    return;
};

},{"../constants":"qzO8D","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"baFMD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createPortalParent", function() {
    return createPortalParent;
});
var _constants = require("../constants");
var _getBody = require("./get-body");
var isDocumentDefined = function() {
    return document !== undefined;
};
var createPortalParent = function() {
    //atlaskit-portal-container div
    if (isDocumentDefined()) {
        var parentElement = document.querySelector((0, _constants.portalParentSelector));
        if (!parentElement) {
            var _getBody1;
            var parent = document.createElement('div');
            parent.className = (0, _constants.portalParentClassName);
            parent.style.display = 'flex';
            (_getBody1 = (0, _getBody.getBody)()) === null || _getBody1 === void 0 ? void 0 : _getBody1.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
    return;
};

},{"../constants":"qzO8D","./get-body":"fFidZ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bhbUX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "removePortalParent", function() {
    return removePortalParent;
});
var _getBody = require("./get-body");
var isDocumentDefined = function() {
    return document !== undefined;
};
var removePortalParent = function(parentElement) {
    var _getBody1;
    if (isDocumentDefined()) {
        if (parentElement) (_getBody1 = (0, _getBody.getBody)()) === null || _getBody1 === void 0 ? void 0 : _getBody1.removeChild(parentElement);
    }
};

},{"./get-body":"fFidZ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cQEKH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _useIsomorphicLayoutEffect = require("./use-isomorphic-layout-effect");
var useIsSubsequentRender = function(mountStrategy) {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), isSubsequentRender = _useState[0], setIsSubsequentRender = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(function() {
        return mountStrategy === 'layoutEffect' ? (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect) : (0, _react.useEffect);
    }), 1), useMountEffect = _useState1[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
exports.default = useIsSubsequentRender;

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","react":"ltHCL","./use-isomorphic-layout-effect":"cazU0","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"m97ty":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _constants = require("../../constants");
var _portalCustomEvent = require("../utils/portal-custom-event");
var _portalCustomEventDefault = parcelHelpers.interopDefault(_portalCustomEvent);
var useFirePortalEvent = function(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, _react.useEffect)(function() {
        (0, _portalCustomEventDefault.default)((0, _constants.PORTAL_MOUNT_EVENT), zIndexNumber);
        return function() {
            (0, _portalCustomEventDefault.default)((0, _constants.PORTAL_UNMOUNT_EVENT), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
exports.default = useFirePortalEvent;

},{"react":"ltHCL","../../constants":"gghpS","../utils/portal-custom-event":"cGhLD","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gghpS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PORTAL_MOUNT_EVENT", function() {
    return PORTAL_MOUNT_EVENT;
});
parcelHelpers.export(exports, "PORTAL_UNMOUNT_EVENT", function() {
    return PORTAL_UNMOUNT_EVENT;
});
var PORTAL_MOUNT_EVENT = 'akPortalMount';
var PORTAL_UNMOUNT_EVENT = 'akPortalUnmount';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cGhLD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return firePortalEvent;
});
var zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var getLayerName = function(zIndex) {
    return zIndexToName.hasOwnProperty(zIndex) ? zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var getEvent = function(eventName, zIndex) {
    var detail = {
        layer: getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function firePortalEvent(eventName, zIndex) {
    var event = getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3DRjL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CHANNEL", function() {
    return CHANNEL;
});
parcelHelpers.export(exports, "DEFAULT_THEME_MODE", function() {
    return DEFAULT_THEME_MODE;
});
parcelHelpers.export(exports, "THEME_MODES", function() {
    return THEME_MODES;
});
parcelHelpers.export(exports, "focusRing", function() {
    return focusRing;
});
parcelHelpers.export(exports, "noFocusRing", function() {
    return noFocusRing;
});
parcelHelpers.export(exports, "layers", function() {
    return layers;
});
parcelHelpers.export(exports, "visuallyHidden", function() {
    return visuallyHidden;
});
parcelHelpers.export(exports, "assistive", function() {
    return assistive;
});
parcelHelpers.export(exports, "skeletonShimmer", function() {
    return skeletonShimmer;
});
var _deprecationWarning = require("@atlaskit/ds-lib/deprecation-warning");
var _deprecationWarningDefault = parcelHelpers.interopDefault(_deprecationWarning);
var CHANNEL = '__ATLASKIT_THEME__';
var DEFAULT_THEME_MODE = 'light';
var THEME_MODES = [
    'light',
    'dark'
];
var focusRing = function() {
    var color = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "var(--ds-border-focused, #4688EC)", outlineWidth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    (0, _deprecationWarningDefault.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var noFocusRing = function() {
    return "\n  box-shadow: none;\n";
};
var layers = {
    card: function() {
        return 100;
    },
    navigation: function() {
        return 200;
    },
    dialog: function() {
        return 300;
    },
    layer: function() {
        return 400;
    },
    blanket: function() {
        return 500;
    },
    modal: function() {
        return 510;
    },
    flag: function() {
        return 600;
    },
    spotlight: function() {
        return 700;
    },
    tooltip: function() {
        return 9999;
    }
};
var visuallyHidden = function() {
    (0, _deprecationWarningDefault.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var assistive = visuallyHidden;
var skeletonShimmer = function() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, #0515240F)",
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, #0515240F)"
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, #17171708)"
            }
        }
    };
};

},{"@atlaskit/ds-lib/deprecation-warning":"7fz9O","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7fz9O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return deprecationWarning;
});
var _warnOnce = require("./warn-once");
var _warnOnceDefault = parcelHelpers.interopDefault(_warnOnce);
function deprecationWarning(packageName, api, additionalMessage) {
    (0, _warnOnceDefault.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}

},{"./warn-once":"7x6u7","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7x6u7":[function(require,module,exports,__globalThis) {
/* eslint-disable no-console */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return warnOnce;
});
var printed = {};
function warnOnce(message) {
    if (printed[message]) return;
    printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cEys7":[function(require,module,exports,__globalThis) {
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every app.
 *
 * We can reconsider this choice in the future.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "register", function() {
    return register;
});
var _bindEventListener = require("bind-event-listener");
var registrations = new Set();
var cleanupEndEventListeners = null;
function onDragStart() {
    if (cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    cleanupEndEventListeners = (0, _bindEventListener.bindAll)(window, [
        {
            type: 'dragend',
            listener: onDragEnd
        },
        {
            type: 'pointerdown',
            listener: onDragEnd
        },
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from(registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function onDragEnd() {
    cleanupEndEventListeners === null || cleanupEndEventListeners === void 0 ? void 0 : cleanupEndEventListeners();
    cleanupEndEventListeners = null;
    var clone = Array.from(registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function bindStartEvents() {
    return (0, _bindEventListener.bindAll)(window, [
        {
            type: 'dragstart',
            listener: onDragStart
        },
        {
            type: 'dragenter',
            listener: onDragStart
        }
    ]);
}
var cleanupStartEventListeners = null;
function register(registration) {
    // if first registration, bind event listeners
    if (!cleanupStartEventListeners) // note: currently never unbinding these event listeners
    cleanupStartEventListeners = bindStartEvents();
    registrations.add(registration);
    /**
	 * The reasoning for this behavior is so that if a tooltip mounts during
	 * a drag it can still be suppressed.
	 *
	 * We use a separate callback instead of onDragStart to avoid infinite loops.
	 */ registration.onRegister({
        isDragging: cleanupEndEventListeners !== null
    });
    return function unregister() {
        registrations.delete(registration);
        if (registrations.size === 0) {
            cleanupStartEventListeners === null || cleanupStartEventListeners === void 0 ? void 0 : cleanupStartEventListeners();
            cleanupStartEventListeners = null;
        }
    };
}

},{"bind-event-listener":"bjeUU","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7uCDv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getVirtualElementFromMousePos", function() {
    return getVirtualElementFromMousePos;
});
function getVirtualElementFromMousePos(mousePos, param) {
    var targetElement = param.targetElement, tooltipPosition = param.tooltipPosition;
    if (tooltipPosition === 'mouse') return {
        getBoundingClientRect: function() {
            return DOMRect.fromRect({
                x: mousePos.clientX,
                y: mousePos.clientY,
                width: 0,
                height: 0
            });
        }
    };
    var targetRect = targetElement.getBoundingClientRect();
    if (tooltipPosition === 'mouse-x') return {
        getBoundingClientRect: function() {
            return DOMRect.fromRect({
                x: mousePos.clientX,
                y: targetRect.top,
                width: 0,
                height: targetRect.height
            });
        }
    };
    if (tooltipPosition === 'mouse-y') return {
        getBoundingClientRect: function() {
            return DOMRect.fromRect({
                x: targetRect.left,
                y: mousePos.clientY,
                width: targetRect.width,
                height: 0
            });
        }
    };
    throw new Error("Invalid tooltip position for virtual element: ".concat(tooltipPosition));
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"c28bS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "show", function() {
    return show;
});
var delayId = null;
function clearScheduled() {
    if (delayId != null) {
        window.clearTimeout(delayId);
        delayId = null;
    }
}
function scheduleTimeout(fn, delay) {
    clearScheduled();
    delayId = window.setTimeout(function() {
        delayId = null;
        fn();
    }, delay);
}
var active = null;
function show(entry) {
    var phase = 'waiting-to-show';
    function isActive() {
        return Boolean(active && active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            clearScheduled();
            active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            clearScheduled();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            clearScheduled();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(param) {
        var isImmediate = param.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === 'waiting-to-hide') return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        scheduleTimeout(function() {
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function start() {
        var shouldAlwaysFadeIn = entry.shouldAlwaysFadeIn;
        var showImmediately = Boolean(active && active.isVisible()) && !shouldAlwaysFadeIn;
        // If there was an active tooltip; we tell it to remove itself at once!
        if (active) {
            clearScheduled();
            active.entry.hide({
                isImmediate: true
            });
            active.entry.done();
            active = null;
        }
        // this tooltip is now the active tooltip
        active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        scheduleTimeout(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePos: entry.source.type === 'mouse' ? {
            clientX: entry.source.clientX,
            clientY: entry.source.clientY
        } : null
    };
    return result;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6kLTI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return useUniqueId;
});
var _useIdSeed = require("@atlaskit/ds-lib/use-id-seed");
function useUniqueId(prefix, shouldRenderId) {
    var seed = (0, _useIdSeed.useIdSeed)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}

},{"@atlaskit/ds-lib/use-id-seed":"1cbS4","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1cbS4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Generates a seed for the useId hook.
 */ parcelHelpers.export(exports, "useIdSeed", function() {
    return useIdSeed;
});
var _useId = require("./use-id");
function useIdSeed() {
    var uid = (0, _useId.useId)();
    return function(id) {
        return "".concat(uid, "-").concat(id.toString());
    };
}

},{"./use-id":"axFod","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"d8DXj":[function(require,module,exports,__globalThis) {
/* tooltip-container.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _tooltipPrimitive = require("./tooltip-primitive");
var _tooltipPrimitiveDefault = parcelHelpers.interopDefault(_tooltipPrimitive);
var styles = {
    base: "_2rkofajl _11c8wadc _vchhusvi _p12fp3fh _bfhk1aqn _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _1q511b66 _85i51b66 _y4ti12x7 _bozg12x7 _slp31hna",
    truncate: "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c"
};
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ var TooltipContainer = /*#__PURE__*/ (0, _react.forwardRef)(function TooltipContainer(param, ref) {
    var style = param.style, className = param.className, children = param.children, truncate = param.truncate, placement = param.placement, testId = param.testId, onMouseOut = param.onMouseOut, onMouseOver = param.onMouseOver, id = param.id, shortcut = param.shortcut;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipPrimitiveDefault.default), {
        ref: ref,
        style: style,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, _runtime.ax)([
            styles.base,
            truncate && styles.truncate,
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        shortcut: shortcut,
        children: children
    });
});
TooltipContainer.displayName = 'TooltipContainer';
exports.default = TooltipContainer;

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","./tooltip-primitive":"46h4l","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"46h4l":[function(require,module,exports,__globalThis) {
/* tooltip-primitive.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _tooltipShortcut = require("./tooltip-shortcut");
var primitiveStyles = null;
/**
 * The lower level component for rendering a tooltip.
 */ var TooltipPrimitive = /*#__PURE__*/ (0, _react.forwardRef)(function TooltipPrimitive(param, ref) {
    var style = param.style, className = param.className, children = param.children, placement = param.placement, testId = param.testId, onMouseOut = param.onMouseOut, onMouseOver = param.onMouseOver, id = param.id, shortcut = param.shortcut;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ref: ref,
        style: style,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            role: "tooltip",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, _runtime.ax)([
                "_80om73ad",
                className
            ]),
            // Because the tooltip should not be focusable, there is no reason to have key events.
            /* eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events */ onMouseOut: onMouseOut,
            /* eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events */ onMouseOver: onMouseOver,
            "data-placement": placement,
            "data-testid": testId,
            id: id,
            children: [
                children,
                shortcut && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipShortcut.TooltipShortcut), {
                    shortcut: shortcut
                })
            ]
        })
    });
});
TooltipPrimitive.displayName = 'TooltipPrimitive';
exports.default = TooltipPrimitive;

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","./tooltip-shortcut":"cIJZw","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cIJZw":[function(require,module,exports,__globalThis) {
/* tooltip-shortcut.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TooltipShortcut", function() {
    return TooltipShortcut;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var styles = {
    shortcutSegmentsContainer: "_zulpv77o _1e0c1txw _1q511b66 _85i5v77o",
    shortcutSegment: "_11c8wadc _2rkolb4i _1dqonqa1 _189ee4h9 _1h6d1ihb _1e0c1txw _4cvr1h6o _4t3i1k92 _vchhusvi _1q51v77o _85i5v77o _bozg12x7 _y4ti12x7 _16qsn7od _1254n7od _cgnln7od _syazn7od _ahbqn7od _12l2n7od _1pfhn7od _6rthn7od _1ul9n7od _w19jn7od _bfhk261p"
};
var TooltipShortcut = function(param) {
    var shortcut = param.shortcut;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: (0, _runtime.ax)([
            styles.shortcutSegmentsContainer
        ]),
        children: shortcut.map(function(segment, index) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("kbd", {
                className: (0, _runtime.ax)([
                    styles.shortcutSegment
                ]),
                children: segment
            }, "".concat(segment, "-").concat(index));
        })
    });
};

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9PMZe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Popup", function() {
    return 0, _popup.Popup;
});
var _popup = require("./popup");
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = (0, _popup.Popup);

},{"./popup":"e9u0b","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"e9u0b":[function(require,module,exports,__globalThis) {
/* popup.tsx generated by @compiled/babel-plugin v0.39.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Popup", function() {
    return Popup;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _useId = require("@atlaskit/ds-lib/use-id");
var _layering = require("@atlaskit/layering");
var _openLayerObserver = require("@atlaskit/layering/experimental/open-layer-observer");
var _exitingPersistence = require("@atlaskit/motion/exiting-persistence");
var _exitingPersistenceDefault = parcelHelpers.interopDefault(_exitingPersistence);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _popper = require("@atlaskit/popper");
var _portal = require("@atlaskit/portal");
var _portalDefault = parcelHelpers.interopDefault(_portal);
var _compiled = require("@atlaskit/primitives/compiled");
var _popperWrapper = require("./popper-wrapper");
var _popperWrapperDefault = parcelHelpers.interopDefault(_popperWrapper);
var _useAppearance = require("./use-appearance");
var _useGetMemoizedMergedTriggerRef = require("./use-get-memoized-merged-trigger-ref");
var _useGetMemoizedMergedTriggerRefNew = require("./use-get-memoized-merged-trigger-ref-new");
var defaultLayer = 400;
var wrapperStyles = {
    root: "_kqswh2mm"
};
var Popup = /*#__PURE__*/ (0, _react.memo)(function(param) {
    var xcss = param.xcss, tmp = param.appearance, inAppearance = tmp === void 0 ? 'default' : tmp, isOpen = param.isOpen, providedId = param.id, offset = param.offset, testId = param.testId, trigger = param.trigger, content = param.content, onClose = param.onClose, boundary = param.boundary, _param_rootBoundary = param.rootBoundary, rootBoundary = _param_rootBoundary === void 0 ? 'viewport' : _param_rootBoundary, _param_shouldFlip = param.shouldFlip, shouldFlip = _param_shouldFlip === void 0 ? true : _param_shouldFlip, _param_placement = param.placement, placement = _param_placement === void 0 ? 'auto' : _param_placement, fallbackPlacements = param.fallbackPlacements, PopupContainer = param.popupComponent, _param_autoFocus = param.autoFocus, autoFocus = _param_autoFocus === void 0 ? true : _param_autoFocus, _param_zIndex = param.zIndex, zIndex = _param_zIndex === void 0 ? defaultLayer : _param_zIndex, _param_shouldUseCaptureOnOutsideClick = param.shouldUseCaptureOnOutsideClick, shouldUseCaptureOnOutsideClick = _param_shouldUseCaptureOnOutsideClick === void 0 ? false : _param_shouldUseCaptureOnOutsideClick, tmp1 = param.shouldRenderToParent, inShouldRenderToParent = tmp1 === void 0 ? false : tmp1, _param_shouldFitContainer = param.shouldFitContainer, shouldFitContainer = _param_shouldFitContainer === void 0 ? false : _param_shouldFitContainer, _param_shouldDisableFocusLock = param.shouldDisableFocusLock, shouldDisableFocusLock = _param_shouldDisableFocusLock === void 0 ? false : _param_shouldDisableFocusLock, _param_shouldReturnFocus = param.shouldReturnFocus, shouldReturnFocus = _param_shouldReturnFocus === void 0 ? true : _param_shouldReturnFocus, strategy = param.strategy, role = param.role, label = param.label, titleId = param.titleId, modifiers = param.modifiers, shouldFitViewport = param.shouldFitViewport;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(null), 2), triggerRef = _useState[0], setTriggerRef = _useState[1];
    var getMergedTriggerRef = (0, _useGetMemoizedMergedTriggerRef.useGetMemoizedMergedTriggerRef)();
    var getMergedTriggerRefNew = (0, _useGetMemoizedMergedTriggerRefNew.useGetMemoizedMergedTriggerRefNew)();
    var generatedId = (0, _useId.useId)();
    var _usePopupAppearance = (0, _useAppearance.usePopupAppearance)({
        appearance: inAppearance,
        shouldRenderToParent: inShouldRenderToParent
    }), appearance = _usePopupAppearance.appearance, shouldRenderToParent = _usePopupAppearance.shouldRenderToParent;
    var id = providedId || generatedId;
    var handleOpenLayerObserverCloseSignal = (0, _react.useCallback)(function() {
        onClose === null || onClose === void 0 ? void 0 : onClose(null);
    }, [
        onClose
    ]);
    (0, _openLayerObserver.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: handleOpenLayerObserverCloseSignal,
        type: 'popup'
    });
    var renderPopperWrapper = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layering.Layering), {
        isDisabled: false,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popperWrapperDefault.default), {
            xcss: xcss,
            appearance: appearance,
            content: content,
            isOpen: isOpen,
            placement: placement,
            fallbackPlacements: fallbackPlacements,
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: shouldFlip,
            offset: offset,
            popupComponent: PopupContainer,
            id: id,
            testId: testId,
            onClose: onClose,
            autoFocus: autoFocus,
            shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
            shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
            shouldFitContainer: shouldFitContainer,
            shouldDisableFocusLock: shouldDisableFocusLock,
            shouldReturnFocus: shouldReturnFocus,
            triggerRef: triggerRef,
            strategy: shouldFitContainer ? 'absolute' : strategy,
            role: role,
            label: label,
            titleId: titleId,
            modifiers: modifiers,
            shouldFitViewport: shouldFitViewport
        })
    });
    var popupContent = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _popper.Manager), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popper.Reference), {
                children: function(param) {
                    var ref = param.ref;
                    return trigger({
                        ref: !(0, _platformFeatureFlags.fg)('platform-design-system-popup-ref') ? getMergedTriggerRef(ref, setTriggerRef, isOpen) : getMergedTriggerRefNew(ref, setTriggerRef),
                        'aria-controls': isOpen ? id : undefined,
                        'aria-expanded': isOpen,
                        'aria-haspopup': role === 'dialog' && (0, _platformFeatureFlags.fg)('platform_dst_popup-disable-focuslock') ? 'dialog' : true
                    });
                }
            }),
            !(0, _platformFeatureFlags.fg)('platform-dst-motion-uplift') && isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _portalDefault.default), {
                zIndex: zIndex,
                children: renderPopperWrapper
            })),
            (0, _platformFeatureFlags.fg)('platform-dst-motion-uplift') && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _exitingPersistenceDefault.default), {
                children: isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _portalDefault.default), {
                    zIndex: zIndex,
                    children: renderPopperWrapper
                }))
            })
        ]
    });
    if (shouldFitContainer) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _compiled.Box), {
        xcss: wrapperStyles.root,
        children: popupContent
    });
    return popupContent;
});

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","react/jsx-runtime":"bGvcw","react":"ltHCL","@atlaskit/ds-lib/use-id":"axFod","@atlaskit/layering":"laO1Y","@atlaskit/layering/experimental/open-layer-observer":"iPCuE","@atlaskit/motion/exiting-persistence":"kQCSw","@atlaskit/platform-feature-flags":"kO5t9","@atlaskit/popper":"bMYOE","@atlaskit/portal":"kqyHU","@atlaskit/primitives/compiled":"jhQE8","./popper-wrapper":"aeE4u","./use-appearance":"13ljX","./use-get-memoized-merged-trigger-ref":"clhFp","./use-get-memoized-merged-trigger-ref-new":"b3Mpu","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"laO1Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Layering", function() {
    return 0, _layering.Layering;
});
parcelHelpers.export(exports, "useCloseOnEscapePress", function() {
    return 0, _useCloseOnEscapePress.useCloseOnEscapePress;
});
parcelHelpers.export(exports, "useLayering", function() {
    return 0, _useLayering.useLayering;
});
var _layering = require("./components/layering");
var _useCloseOnEscapePress = require("./hooks/use-close-on-escape-press");
var _useLayering = require("./hooks/use-layering");

},{"./components/layering":"5rKZM","./hooks/use-close-on-escape-press":"3uNe7","./hooks/use-layering":"doZnn","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5rKZM":[function(require,module,exports,__globalThis) {
/* eslint-disable @repo/internal/react/require-jsdoc */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Layering", function() {
    return Layering;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _layerNode = require("../classes/layer-node");
var _levelContext = require("./level-context");
var _levelNodeContext = require("./level-node-context");
var _rootNodeContext = require("./root-node-context");
var LevelProvider = function(param) {
    var children = param.children, currentLevel = param.currentLevel, levelNode = param.node;
    (0, _react.useEffect)(function() {
        var levelNodeSafe = levelNode.current;
        var parentNode = levelNodeSafe.parent;
        parentNode === null || parentNode === void 0 ? void 0 : parentNode.addChild(levelNodeSafe);
        return function() {
            parentNode === null || parentNode === void 0 ? void 0 : parentNode.removeChild(levelNodeSafe);
        };
    }, [
        levelNode
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _levelContext.LevelContext).Provider, {
        value: currentLevel,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _levelNodeContext.LevelNodeContext).Provider, {
            value: levelNode,
            children: children
        })
    });
};
var Layering = function(param) {
    var children = param.children, _param_isDisabled = param.isDisabled, isDisabled = _param_isDisabled === void 0 ? true : _param_isDisabled;
    var currentLevel = (0, _react.useContext)((0, _levelContext.LevelContext));
    var parentNode = (0, _react.useContext)((0, _levelNodeContext.LevelNodeContext));
    // eslint-disable-next-line  @repo/internal/react/disallow-unstable-values
    var newNode = (0, _react.useRef)(new (0, _layerNode.LayerNode)(Math.random().toString(36), parentNode.current));
    if (isDisabled) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: children
    });
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, _jsxRuntime.jsx)(LevelProvider, {
        currentLevel: currentLevel + 1,
        node: newNode,
        children: children
    });
    return isNested ? content : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rootNodeContext.RootNodeContext).Provider, {
        value: newNode,
        children: content
    });
};

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","../classes/layer-node":"51Yc6","./level-context":"7VWGx","./level-node-context":"7WbTH","./root-node-context":"6vYuu","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"51Yc6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LayerNode", function() {
    return LayerNode;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var LayerNode = /*#__PURE__*/ function() {
    "use strict";
    function LayerNode(id, parent) {
        (0, _classCallCheck._)(this, LayerNode);
        this.id = id;
        this.childNodes = [];
        this.parent = parent;
    }
    (0, _createClass._)(LayerNode, [
        {
            key: "addChild",
            value: function addChild(node) {
                this.childNodes.push(node);
            }
        },
        {
            key: "removeChild",
            value: function removeChild(node) {
                this.childNodes = this.childNodes.filter(function(child) {
                    return child.id !== node.id;
                });
            }
        },
        {
            key: "getLevel",
            value: function getLevel() {
                if (!this.parent) return 1;
                return this.parent.getLevel() + 1;
            }
        },
        {
            key: "getHeight",
            value: function getHeight() {
                var _Math;
                if (this.childNodes.length === 0) return 1;
                return (_Math = Math).max.apply(_Math, (0, _toConsumableArray._)(this.childNodes.map(function(child) {
                    return child.getHeight();
                }))) + 1;
            }
        }
    ]);
    return LayerNode;
}();

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_to_consumable_array":"1eSZf","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7VWGx":[function(require,module,exports,__globalThis) {
/* eslint-disable @repo/internal/react/require-jsdoc */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LevelContext", function() {
    return LevelContext;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var LevelContext = /*#__PURE__*/ (0, _react.createContext)(0);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7WbTH":[function(require,module,exports,__globalThis) {
/* eslint-disable @repo/internal/react/require-jsdoc */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LevelNodeContext", function() {
    return LevelNodeContext;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var LevelNodeContext = /*#__PURE__*/ (0, _react.createContext)({
    current: null
});

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6vYuu":[function(require,module,exports,__globalThis) {
/* eslint-disable @repo/internal/react/require-jsdoc */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RootNodeContext", function() {
    return RootNodeContext;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var RootNodeContext = /*#__PURE__*/ (0, _react.createContext)({
    current: null
});

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3uNe7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Calls back when the escape key is pressed.
 * To be used exclusively for closing layered components.
 * Use the `isDisabled` argument to ignore closing events.
 *
 * ```js
 * useCloseOnEscapePress({
 *   onClose: () => {},
 *   isDisabled: false,
 * });
 * ```
 */ parcelHelpers.export(exports, "useCloseOnEscapePress", function() {
    return useCloseOnEscapePress;
});
var _react = require("react");
var _bindEventListener = require("bind-event-listener");
var _useLayering = require("./use-layering");
var ESCAPE = 'Escape';
function useCloseOnEscapePress(param) {
    var onClose = param.onClose, isDisabled = param.isDisabled;
    var escapePressed = (0, _react.useRef)(false);
    var isLayerDisabled = (0, _useLayering.useLayering)().isLayerDisabled;
    var onKeyDown = (0, _react.useCallback)(function(e) {
        var isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    var onKeyUp = (0, _react.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, _react.useEffect)(function() {
        return (0, _bindEventListener.bindAll)(window, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}

},{"react":"ltHCL","bind-event-listener":"bjeUU","./use-layering":"doZnn","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"doZnn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *
 * Layering hook to get layering info like the current level, the top level of the given component
 *
 */ parcelHelpers.export(exports, "useLayering", function() {
    return useLayering;
});
var _react = require("react");
var _levelContext = require("../components/level-context");
var _levelNodeContext = require("../components/level-node-context");
var _rootNodeContext = require("../components/root-node-context");
function useLayering() {
    var currentLevel = (0, _react.useContext)((0, _levelContext.LevelContext));
    var layerNode = (0, _react.useContext)((0, _levelNodeContext.LevelNodeContext));
    var rootNode = (0, _react.useContext)((0, _rootNodeContext.RootNodeContext));
    var isLayerDisabled = (0, _react.useCallback)(function() {
        // This is an impossible case, added for type safety
        if (!(layerNode === null || layerNode === void 0 ? void 0 : layerNode.current) || !(rootNode === null || rootNode === void 0 ? void 0 : rootNode.current)) return false;
        return layerNode.current.getLevel() < rootNode.current.getHeight();
    }, [
        layerNode,
        rootNode
    ]);
    var getTopLevel = (0, _react.useCallback)(function() {
        return (rootNode === null || rootNode === void 0 ? void 0 : rootNode.current) ? rootNode.current.getHeight() : null;
    }, [
        rootNode
    ]);
    return {
        currentLevel: currentLevel,
        isLayerDisabled: isLayerDisabled,
        getTopLevel: getTopLevel
    };
}

},{"react":"ltHCL","../components/level-context":"7VWGx","../components/level-node-context":"7WbTH","../components/root-node-context":"6vYuu","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kQCSw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useExitingPersistence", function() {
    return 0, _exitingPersistence.useExitingPersistence;
});
parcelHelpers.export(exports, "default", function() {
    return 0, _exitingPersistenceDefault.default;
});
var _exitingPersistence = require("../entering/exiting-persistence");
var _exitingPersistenceDefault = parcelHelpers.interopDefault(_exitingPersistence);

},{"../entering/exiting-persistence":"bLTYm","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aeE4u":[function(require,module,exports,__globalThis) {
/* popper-wrapper.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _layering = require("@atlaskit/layering");
var _motion = require("@atlaskit/motion");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _popper = require("@atlaskit/popper");
var _repositionOnUpdate = require("./reposition-on-update");
var _useCloseManager = require("./use-close-manager");
var _useFocusManager = require("./use-focus-manager");
var LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
var fullWidthStyles = null;
var wrapperStyles = {
    root: "_2rko12b0 _1e0c1ule _vchhusvi _1pby1nn1 _bfhk1bhr _16qs130s _syazi7uo _1q1l1bhr _nt751r31 _49pcglyw _1hvw1o36",
    rootT26Shape: "_2rko1mok",
    rootLayer: "_1pby1nn1",
    fullWidth: "_1bsb1osq"
};
var scrollableStyles = null;
var blanketStyles = null;
var modalStyles = null;
var newModalStyles = null;
var focusRingStyles = {
    root: "_mizu1v1w _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y"
};
var placementMap = {
    top: {
        enter: "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'top-start': {
        enter: "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'top-end': {
        enter: "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    bottom: {
        enter: "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'bottom-start': {
        enter: "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'bottom-end': {
        enter: "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    left: {
        enter: "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'left-start': {
        enter: "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'left-end': {
        enter: "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    right: {
        enter: "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'right-start': {
        enter: "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'right-end': {
        enter: "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    }
};
var DefaultPopupComponent = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    var shouldRenderToParent = props.shouldRenderToParent, shouldFitContainer = props.shouldFitContainer, children = props.children, appearance = props.appearance, className = props.className, _isReferenceHidden = props.isReferenceHidden, shouldFitViewport = props.shouldFitViewport, htmlAttributes = (0, _objectWithoutProperties._)(props, [
        "shouldRenderToParent",
        "shouldFitContainer",
        "children",
        "appearance",
        "className",
        "isReferenceHidden",
        "shouldFitViewport"
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , (0, _objectSpreadProps._)((0, _objectSpread._)({
        className: (0, _runtime.ax)([
            wrapperStyles.root,
            (0, _platformFeatureFlags.fg)('platform-dst-shape-theme-default') && wrapperStyles.rootT26Shape,
            appearance === 'UNSAFE_modal-below-sm' && !(0, _platformFeatureFlags.fg)('platform_dst_nav4_flyout_menu_slots_close_button') && "_dk5d1b66 _c71ldtre _kqsw1n9t _152t1b66",
            appearance === 'UNSAFE_modal-below-sm' && (0, _platformFeatureFlags.fg)('platform_dst_nav4_flyout_menu_slots_close_button') && "_dk5d1b66 _c71l1ei0 _kqsw1n9t _152t1b66",
            (!shouldRenderToParent || shouldFitViewport) && "_1reo1wug _18m91wug",
            shouldFitContainer && "_1bsb1osq",
            className
        ])
    }, htmlAttributes), {
        ref: !(0, _platformFeatureFlags.fg)('platform-dst-motion-uplift') ? ref : undefined,
        children: children
    }));
});
function PopperWrapper(param) {
    var xcss = param.xcss, isOpen = param.isOpen, id = param.id, offset = param.offset, testId = param.testId, content = param.content, fallbackPlacements = param.fallbackPlacements, onClose = param.onClose, boundary = param.boundary, rootBoundary = param.rootBoundary, shouldFlip = param.shouldFlip, _param_placement = param.placement, placement = _param_placement === void 0 ? 'auto' : _param_placement, tmp = param.// @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
    popupComponent, PopupContainer = tmp === void 0 ? DefaultPopupComponent : tmp, _param_autoFocus = param.autoFocus, autoFocus = _param_autoFocus === void 0 ? true : _param_autoFocus, triggerRef = param.triggerRef, shouldUseCaptureOnOutsideClick = param.shouldUseCaptureOnOutsideClick, shouldRenderToParent = param.shouldRenderToParent, shouldFitContainer = param.shouldFitContainer, shouldDisableFocusLock = param.shouldDisableFocusLock, _param_shouldReturnFocus = param.shouldReturnFocus, shouldReturnFocus = _param_shouldReturnFocus === void 0 ? true : _param_shouldReturnFocus, strategy = param.strategy, role = param.role, label = param.label, titleId = param.titleId, modifiers = param.modifiers, shouldFitViewport = param.shouldFitViewport, _param_appearance = param.appearance, appearance = _param_appearance === void 0 ? 'default' : _param_appearance;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(null), 2), popupRef = _useState[0], setPopupRef = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(null), 2), initialFocusRef = _useState1[0], setInitialFocusRef = _useState1[1]; // We have cases where we need to close the Popup on Tab press, e.g. DropdownMenu
    var shouldCloseOnTab = shouldRenderToParent && shouldDisableFocusLock;
    var shouldDisableFocusTrap = role !== 'dialog';
    (0, _useFocusManager.useFocusManager)({
        initialFocusRef: initialFocusRef,
        popupRef: popupRef,
        shouldCloseOnTab: shouldCloseOnTab,
        triggerRef: triggerRef,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldReturnFocus: shouldReturnFocus
    });
    (0, _useCloseManager.useCloseManager)({
        isOpen: isOpen,
        onClose: onClose,
        popupRef: popupRef,
        triggerRef: triggerRef,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldCloseOnTab: shouldCloseOnTab,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldRenderToParent: shouldRenderToParent
    });
    var currentLevel = (0, _layering.useLayering)().currentLevel;
    var mergedModifiers = (0, _react.useMemo)(function() {
        return [
            {
                name: 'flip',
                enabled: shouldFlip,
                options: {
                    rootBoundary: rootBoundary,
                    boundary: boundary,
                    fallbackPlacements: fallbackPlacements
                }
            }
        ].concat((0, _toConsumableArray._)(modifiers || []));
    }, [
        shouldFlip,
        rootBoundary,
        boundary,
        fallbackPlacements,
        modifiers
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popper.Popper), {
        placement: placement,
        offset: offset,
        modifiers: mergedModifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport,
        children: function(param) {
            var ref = param.ref, style = param.style, placement = param.placement, update = param.update, isReferenceHidden = param.isReferenceHidden;
            var popupContainer = /*#__PURE__*/ (0, _jsxRuntime.jsx)(PopupContainer // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            , {
                className: (0, _runtime.ax)([
                    xcss,
                    // @ts-expect-error: `ax` is not typed correctly
                    !initialFocusRef && (0, _platformFeatureFlags.fg)('platform-design-system-apply-popup-wrapper-focus') && focusRingStyles.root
                ]),
                appearance: appearance,
                id: id,
                "data-ds--level": currentLevel,
                "data-placement": placement,
                "data-testid": testId,
                role: role,
                "aria-label": label,
                "aria-labelledby": titleId,
                ref: !(0, _platformFeatureFlags.fg)('platform-dst-motion-uplift') ? function(node) {
                    if (node) {
                        if (typeof ref === 'function') ref(node);
                        else ref.current = node;
                        setPopupRef(node);
                    }
                } : undefined,
                style: (0, _platformFeatureFlags.fg)('platform-dst-motion-uplift') || appearance === 'UNSAFE_modal-below-sm' ? {} : style,
                // first on the browser address bar when using keyboard
                tabIndex: autoFocus ? 0 : undefined,
                shouldRenderToParent: shouldRenderToParent,
                shouldFitContainer: shouldFitContainer,
                shouldFitViewport: shouldFitViewport,
                isReferenceHidden: isReferenceHidden,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _repositionOnUpdate.RepositionOnUpdate), {
                    update: update,
                    children: content({
                        update: update,
                        isOpen: isOpen,
                        onClose: onClose,
                        setInitialFocusRef: setInitialFocusRef
                    })
                })
            });
            var container = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            , {
                style: style,
                // first on the browser address bar when using keyboard
                ref: function(node) {
                    if (node) {
                        if (typeof ref === 'function') ref(node);
                        else ref.current = node;
                        setPopupRef(node);
                    }
                },
                "data-testid": "".concat(testId, "--container"),
                className: (0, _runtime.ax)([
                    wrapperStyles.rootLayer,
                    shouldFitContainer && wrapperStyles.fullWidth
                ]),
                children: placement === 'auto' || placement === 'auto-start' || placement === 'auto-end' ? popupContainer : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _motion.Motion), {
                    enteringAnimation: placementMap[placement].enter,
                    exitingAnimation: placementMap[placement].exit,
                    children: popupContainer
                })
            });
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
                children: [
                    (0, _platformFeatureFlags.fg)('platform-dst-motion-uplift') ? container : popupContainer,
                    appearance === 'UNSAFE_modal-below-sm' && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _runtime.ax)([
                            "_1r04idpf _kqsw1n9t _bfhk1i5c"
                        ])
                    })
                ]
            });
        }
    });
}
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = PopperWrapper;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_to_consumable_array":"1eSZf","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/layering":"laO1Y","@atlaskit/motion":"gQd69","@atlaskit/platform-feature-flags":"kO5t9","@atlaskit/popper":"bMYOE","./reposition-on-update":"1Ip2x","./use-close-manager":"vb21T","./use-focus-manager":"6gNoF","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1Ip2x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RepositionOnUpdate", function() {
    return RepositionOnUpdate;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var RepositionOnUpdate = function(param) {
    var children = param.children, update = param.update;
    // Ref used here to skip update on first render (when refs haven't been set)
    var isFirstRenderRef = (0, _react.useRef)(true);
    (0, _react.useLayoutEffect)(function() {
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update
        update();
    }, [
        update
    ]);
    // wrapping in fragment to make TS happy (known issue with FC returning children)
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Fragment), {
        children: children
    });
};

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"vb21T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCloseManager", function() {
    return useCloseManager;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
// eslint-disable-next-line no-duplicate-imports
var _react = require("react");
var _bindEventListener = require("bind-event-listener");
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var _layering = require("@atlaskit/layering");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _isElementInteractive = require("./utils/is-element-interactive");
var _useAnimationFrame = require("./utils/use-animation-frame");
var useCloseManager = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose, popupRef = param.popupRef, triggerRef = param.triggerRef, autoFocus = param.autoFocus, shouldDisableFocusTrap = param.shouldDisableFocusTrap, capture = param.shouldUseCaptureOnOutsideClick, shouldCloseOnTab = param.shouldCloseOnTab, shouldRenderToParent = param.shouldRenderToParent;
    var _useLayering = (0, _layering.useLayering)(), isLayerDisabled = _useLayering.isLayerDisabled, currentLevel = _useLayering.currentLevel;
    var _useAnimationFrame1 = (0, _useAnimationFrame.useAnimationFrame)(), requestFrame = _useAnimationFrame1.requestFrame, cancelAllFrames = _useAnimationFrame1.cancelAllFrames;
    var mouseDownTarget = (0, _react.useRef)(null);
    (0, _react.useEffect)(function() {
        if (!isOpen || !popupRef) return 0, _noopDefault.default;
        var closePopup = function(event) {
            if (onClose) {
                var _event_target_closest;
                var currentLevel = null;
                var _event_target_closest_getAttribute;
                if ((0, _instanceof._)(event.target, HTMLElement)) currentLevel = (_event_target_closest_getAttribute = (_event_target_closest = event.target.closest("[data-ds--level]")) === null || _event_target_closest === void 0 ? void 0 : _event_target_closest.getAttribute('data-ds--level')) !== null && _event_target_closest_getAttribute !== void 0 ? _event_target_closest_getAttribute : null;
                currentLevel ? onClose(event, Number(currentLevel)) : onClose(event);
            }
            if (shouldDisableFocusTrap && (0, _platformFeatureFlags.fg)('platform_dst_popup-disable-focuslock')) // Restoring the normal focus order for trigger.
            requestFrame(function() {
                triggerRef === null || triggerRef === void 0 ? void 0 : triggerRef.setAttribute('tabindex', '0');
                if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '0');
            });
        };
        // This check is required for cases where components like
        // Select or DDM are placed inside a Popup. A click
        // on a MenuItem or Option would close the Popup, without registering
        // a click on DDM/Select.
        // Users would have to call `onClose` manually to close the Popup in these cases.
        // You can see the bug in action here:
        // https://codesandbox.io/s/atlaskitpopup-default-forked-2eb87?file=/example.tsx:0-1788
        var onClick = function(event) {
            var target = event.target;
            var doesDomNodeExist = document.body.contains(target);
            if (!doesDomNodeExist) return;
            if (isLayerDisabled()) {
                if ((0, _instanceof._)(target, HTMLElement)) {
                    var _target_closest;
                    var layeredElement = (_target_closest = target.closest) === null || _target_closest === void 0 ? void 0 : _target_closest.call(target, "[data-ds--level]");
                    if (layeredElement) {
                        var closeType = layeredElement.getAttribute('[data-ds--close--type]');
                        if (closeType === 'single') // if the close type is single, we won't close other disabled layers when clicking outside
                        return;
                        var levelOfClickedLayer = layeredElement.getAttribute('data-ds--level');
                        if (levelOfClickedLayer && Number(levelOfClickedLayer) > currentLevel) // won't trigger onClick event when we click in a higher layer.
                        return;
                    }
                }
            }
            var isClickOnPopup = popupRef && popupRef.contains(target);
            var isClickOnTrigger = triggerRef && triggerRef.contains(target);
            var didClickStartInsidePopup = popupRef && (0, _instanceof._)(mouseDownTarget.current, Node) && popupRef.contains(mouseDownTarget.current);
            if (!isClickOnPopup && !isClickOnTrigger && !didClickStartInsidePopup) {
                closePopup(event);
                // If there was an outside click on a non-interactive element, the focus should be on the trigger.
                if (document.activeElement && !(0, _isElementInteractive.isInteractiveElement)(document.activeElement) && (0, _platformFeatureFlags.fg)('platform_dst_popup-disable-focuslock')) triggerRef === null || triggerRef === void 0 ? void 0 : triggerRef.focus();
            }
        };
        var onMouseDown = function(event) {
            /**
			 * Tracking the target of the mouse down event.
			 * This is used to prevent the popup from closing when the user mouses down inside the popup, but then
			 * moves the mouse outside the popup before releasing the mouse button.
			 *
			 * This is a common user interaction - users may have mistakenly clicked on something, or changed their mind,
			 * so they try to cancel their click by moving their mouse away from what they had moused down on.
			 *
			 * Blanket uses the same technique.
			 */ mouseDownTarget.current = event.target;
        };
        var onKeyDown = function(event) {
            var key = event.key;
            if ((key === 'Escape' || key === 'Esc') && (0, _platformFeatureFlags.fg)('platform_dst_nested_escape')) {
                var _eventTarget_closest;
                var eventTarget = (0, _instanceof._)(event.target, HTMLElement) ? event.target : null;
                var layeredAncestor = eventTarget === null || eventTarget === void 0 ? void 0 : (_eventTarget_closest = eventTarget.closest) === null || _eventTarget_closest === void 0 ? void 0 : _eventTarget_closest.call(eventTarget, '[data-ds--level]');
                var levelStr = layeredAncestor === null || layeredAncestor === void 0 ? void 0 : layeredAncestor.getAttribute('data-ds--level');
                if (levelStr && Number(levelStr) > currentLevel) return;
            }
            if ((0, _platformFeatureFlags.fg)('platform_dst_popup-disable-focuslock')) {
                var shiftKey = event.shiftKey;
                if (shiftKey && key === 'Tab' && !shouldRenderToParent) {
                    if (isLayerDisabled()) return;
                    // We need to move the focus to the popup trigger when the popup is displayed in React.Portal.
                    requestFrame(function() {
                        var isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                        if (isPopupFocusOut) {
                            closePopup(event);
                            if (currentLevel === 1) triggerRef === null || triggerRef === void 0 ? void 0 : triggerRef.focus();
                        }
                    });
                    return;
                }
                if (key === 'Tab') {
                    var _document_activeElement;
                    // We have cases where we need to close the Popup on Tab press.
                    // Example: DropdownMenu
                    if (shouldCloseOnTab) {
                        if (isLayerDisabled()) return;
                        closePopup(event);
                        return;
                    }
                    if (isLayerDisabled() && ((_document_activeElement = document.activeElement) === null || _document_activeElement === void 0 ? void 0 : _document_activeElement.closest('[aria-modal]'))) return;
                    if (shouldDisableFocusTrap) {
                        if (shouldRenderToParent) // We need to move the focus to the previous interactive element before popup trigger
                        requestFrame(function() {
                            var isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                            if (isPopupFocusOut) closePopup(event);
                        });
                        else requestFrame(function() {
                            if (!document.hasFocus()) closePopup(event);
                        });
                        return;
                    }
                }
                if (isLayerDisabled()) return;
                if (key === 'Escape' || key === 'Esc') {
                    if (triggerRef && autoFocus) triggerRef.focus();
                    closePopup(event);
                }
            } else {
                if (isLayerDisabled()) return;
                if (key === 'Escape' || key === 'Esc' || shouldCloseOnTab && key === 'Tab') closePopup(event);
            }
        };
        var unbind = (0, _noopDefault.default);
        if ((0, _platformFeatureFlags.fg)('popup-onclose-fix')) setTimeout(function() {
            unbind = (0, _bindEventListener.bindAll)(window, [
                {
                    type: 'click',
                    listener: onClick,
                    options: {
                        capture: capture
                    }
                },
                {
                    type: 'keydown',
                    listener: onKeyDown
                },
                {
                    type: 'mousedown',
                    listener: onMouseDown
                }
            ]);
        }, 0);
        else unbind = (0, _bindEventListener.bindAll)(window, [
            {
                type: 'click',
                listener: onClick,
                options: {
                    capture: capture
                }
            },
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'mousedown',
                listener: onMouseDown
            }
        ]);
        // bind onBlur event listener to fix popup not close when clicking on iframe outside
        var unbindBlur = (0, _noopDefault.default);
        unbindBlur = (0, _bindEventListener.bind)(window, {
            type: 'blur',
            listener: function onBlur(e) {
                if (isLayerDisabled() || !(0, _instanceof._)(document.activeElement, HTMLIFrameElement)) return;
                closePopup(e);
            }
        });
        return function() {
            if ((0, _platformFeatureFlags.fg)('popup-onclose-fix')) setTimeout(function() {
                unbind();
            }, 0);
            else unbind();
            cancelAllFrames();
            unbindBlur();
        };
    }, [
        isOpen,
        onClose,
        popupRef,
        triggerRef,
        autoFocus,
        shouldDisableFocusTrap,
        capture,
        isLayerDisabled,
        shouldCloseOnTab,
        currentLevel,
        shouldRenderToParent,
        requestFrame,
        cancelAllFrames
    ]);
};

},{"@swc/helpers/_/_instanceof":"h9UKc","react":"ltHCL","bind-event-listener":"bjeUU","@atlaskit/ds-lib/noop":"2f3bg","@atlaskit/layering":"laO1Y","@atlaskit/platform-feature-flags":"kO5t9","./utils/is-element-interactive":"lXjlf","./utils/use-animation-frame":"hZe2I","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lXjlf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isInteractiveElement", function() {
    return isInteractiveElement;
});
var interactiveTags = [
    'button',
    'a',
    'input',
    'select',
    'textarea'
];
var isInteractiveElement = function(element) {
    if (interactiveTags.includes(element.tagName.toLowerCase())) return true;
    if (element.getAttribute('tabindex') !== null || element.hasAttribute('contenteditable')) return true;
    return false;
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hZe2I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAnimationFrame", function() {
    return useAnimationFrame;
});
var _react = require("react");
var useAnimationFrame = function() {
    var animationsRef = (0, _react.useRef)([]);
    var requestFrame = (0, _react.useCallback)(function(callback) {
        var id = requestAnimationFrame(callback);
        animationsRef.current.push(id);
        return id;
    }, []);
    var cancelFrame = (0, _react.useCallback)(function(id) {
        cancelAnimationFrame(id);
        animationsRef.current = animationsRef.current.filter(function(frameId) {
            return frameId !== id;
        });
    }, []);
    var cancelAllFrames = (0, _react.useCallback)(function() {
        animationsRef.current.forEach(function(id) {
            return cancelAnimationFrame(id);
        });
        animationsRef.current = [];
    }, []);
    return {
        requestFrame: requestFrame,
        cancelFrame: cancelFrame,
        cancelAllFrames: cancelAllFrames
    };
};

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6gNoF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useFocusManager", function() {
    return useFocusManager;
});
var _react = require("react");
var _focusTrap = require("focus-trap");
var _focusTrapDefault = parcelHelpers.interopDefault(_focusTrap);
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var _layering = require("@atlaskit/layering");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _useAnimationFrame = require("./utils/use-animation-frame");
var useFocusManager = function(param) {
    var initialFocusRef = param.initialFocusRef, popupRef = param.popupRef, triggerRef = param.triggerRef, autoFocus = param.autoFocus, shouldCloseOnTab = param.shouldCloseOnTab, shouldDisableFocusTrap = param.shouldDisableFocusTrap, shouldReturnFocus = param.shouldReturnFocus, shouldRenderToParent = param.shouldRenderToParent;
    var _useAnimationFrame1 = (0, _useAnimationFrame.useAnimationFrame)(), requestFrame = _useAnimationFrame1.requestFrame, cancelAllFrames = _useAnimationFrame1.cancelAllFrames;
    var currentLevel = (0, _layering.useLayering)().currentLevel;
    (0, _react.useEffect)(function() {
        if (!popupRef || shouldCloseOnTab) return 0, _noopDefault.default;
        if (shouldDisableFocusTrap && (0, _platformFeatureFlags.fg)('platform_dst_popup-disable-focuslock')) {
            var isDropdown = popupRef.matches('[id^=ds--dropdown--]');
            var popups = document.querySelectorAll('[data-ds--level="'.concat(currentLevel - 1, '"]'));
            if (!(popups[popups.length - 1] && !shouldRenderToParent && isDropdown)) {
                // Plucking trigger & popup content container from the tab order so that
                // when we Shift+Tab, the focus moves to the element before trigger
                requestFrame(function() {
                    triggerRef === null || triggerRef === void 0 ? void 0 : triggerRef.setAttribute('tabindex', '-1');
                    if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '-1');
                    (initialFocusRef || popupRef).focus();
                });
                return 0, _noopDefault.default;
            }
        }
        var trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: (0, _platformFeatureFlags.fg)('platform_dst_nested_escape') ? false : true,
            initialFocus: initialFocusRef || popupRef,
            fallbackFocus: popupRef,
            returnFocusOnDeactivate: shouldReturnFocus
        };
        var focusTrap = (0, _focusTrapDefault.default)(popupRef, trapConfig);
        // Wait for the popup to reposition itself before we focus
        requestFrame(function() {
            focusTrap.activate();
        });
        return function() {
            cancelAllFrames();
            focusTrap.deactivate();
        };
    }, [
        popupRef,
        triggerRef,
        autoFocus,
        initialFocusRef,
        shouldCloseOnTab,
        shouldDisableFocusTrap,
        requestFrame,
        cancelAllFrames,
        shouldReturnFocus,
        shouldRenderToParent,
        currentLevel
    ]);
};

},{"react":"ltHCL","focus-trap":"bqSDP","@atlaskit/ds-lib/noop":"2f3bg","@atlaskit/layering":"laO1Y","@atlaskit/platform-feature-flags":"kO5t9","./utils/use-animation-frame":"hZe2I","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bqSDP":[function(require,module,exports,__globalThis) {
var tabbable = require("47166d9411d6e599");
var listeningFocusTrap = null;
function focusTrap(element, userOptions) {
    var tabbableNodes = [];
    var firstTabbableNode = null;
    var lastTabbableNode = null;
    var nodeFocusedBeforeActivation = null;
    var active = false;
    var paused = false;
    var tabEvent = null;
    var container = typeof element === 'string' ? document.querySelector(element) : element;
    var config = userOptions || {};
    config.returnFocusOnDeactivate = userOptions && userOptions.returnFocusOnDeactivate !== undefined ? userOptions.returnFocusOnDeactivate : true;
    config.escapeDeactivates = userOptions && userOptions.escapeDeactivates !== undefined ? userOptions.escapeDeactivates : true;
    var trap = {
        activate: activate,
        deactivate: deactivate,
        pause: pause,
        unpause: unpause
    };
    return trap;
    function activate(activateOptions) {
        if (active) return;
        var defaultedActivateOptions = {
            onActivate: activateOptions && activateOptions.onActivate !== undefined ? activateOptions.onActivate : config.onActivate
        };
        active = true;
        paused = false;
        nodeFocusedBeforeActivation = document.activeElement;
        if (defaultedActivateOptions.onActivate) defaultedActivateOptions.onActivate();
        addListeners();
        return trap;
    }
    function deactivate(deactivateOptions) {
        if (!active) return;
        var defaultedDeactivateOptions = {
            returnFocus: deactivateOptions && deactivateOptions.returnFocus !== undefined ? deactivateOptions.returnFocus : config.returnFocusOnDeactivate,
            onDeactivate: deactivateOptions && deactivateOptions.onDeactivate !== undefined ? deactivateOptions.onDeactivate : config.onDeactivate
        };
        removeListeners();
        if (defaultedDeactivateOptions.onDeactivate) defaultedDeactivateOptions.onDeactivate();
        if (defaultedDeactivateOptions.returnFocus) setTimeout(function() {
            tryFocus(nodeFocusedBeforeActivation);
        }, 0);
        active = false;
        paused = false;
        return this;
    }
    function pause() {
        if (paused || !active) return;
        paused = true;
        removeListeners();
    }
    function unpause() {
        if (!paused || !active) return;
        paused = false;
        addListeners();
    }
    function addListeners() {
        if (!active) return;
        // There can be only one listening focus trap at a time
        if (listeningFocusTrap) listeningFocusTrap.pause();
        listeningFocusTrap = trap;
        updateTabbableNodes();
        tryFocus(firstFocusNode());
        document.addEventListener('focus', checkFocus, true);
        document.addEventListener('click', checkClick, true);
        document.addEventListener('mousedown', checkPointerDown, true);
        document.addEventListener('touchstart', checkPointerDown, true);
        document.addEventListener('keydown', checkKey, true);
        return trap;
    }
    function removeListeners() {
        if (!active || listeningFocusTrap !== trap) return;
        document.removeEventListener('focus', checkFocus, true);
        document.removeEventListener('click', checkClick, true);
        document.removeEventListener('mousedown', checkPointerDown, true);
        document.removeEventListener('touchstart', checkPointerDown, true);
        document.removeEventListener('keydown', checkKey, true);
        listeningFocusTrap = null;
        return trap;
    }
    function getNodeForOption(optionName) {
        var optionValue = config[optionName];
        var node = optionValue;
        if (!optionValue) return null;
        if (typeof optionValue === 'string') {
            node = document.querySelector(optionValue);
            if (!node) throw new Error('`' + optionName + '` refers to no known node');
        }
        if (typeof optionValue === 'function') {
            node = optionValue();
            if (!node) throw new Error('`' + optionName + '` did not return a node');
        }
        return node;
    }
    function firstFocusNode() {
        var node;
        if (getNodeForOption('initialFocus') !== null) node = getNodeForOption('initialFocus');
        else if (container.contains(document.activeElement)) node = document.activeElement;
        else node = tabbableNodes[0] || getNodeForOption('fallbackFocus');
        if (!node) throw new Error('You can\'t have a focus-trap without at least one focusable element');
        return node;
    }
    // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event
    function checkPointerDown(e) {
        if (config.clickOutsideDeactivates && !container.contains(e.target)) deactivate({
            returnFocus: false
        });
    }
    function checkClick(e) {
        if (config.clickOutsideDeactivates) return;
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    }
    function checkFocus(e) {
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        // Checking for a blur method here resolves a Firefox issue (#15)
        if (typeof e.target.blur === 'function') e.target.blur();
        if (tabEvent) readjustFocus(tabEvent);
    }
    function checkKey(e) {
        if (e.key === 'Tab' || e.keyCode === 9) handleTab(e);
        if (config.escapeDeactivates !== false && isEscapeEvent(e)) deactivate();
    }
    function handleTab(e) {
        updateTabbableNodes();
        if (e.target.hasAttribute('tabindex') && Number(e.target.getAttribute('tabindex')) < 0) return tabEvent = e;
        e.preventDefault();
        var currentFocusIndex = tabbableNodes.indexOf(e.target);
        if (e.shiftKey) {
            if (e.target === firstTabbableNode || tabbableNodes.indexOf(e.target) === -1) return tryFocus(lastTabbableNode);
            return tryFocus(tabbableNodes[currentFocusIndex - 1]);
        }
        if (e.target === lastTabbableNode) return tryFocus(firstTabbableNode);
        tryFocus(tabbableNodes[currentFocusIndex + 1]);
    }
    function updateTabbableNodes() {
        tabbableNodes = tabbable(container);
        firstTabbableNode = tabbableNodes[0];
        lastTabbableNode = tabbableNodes[tabbableNodes.length - 1];
    }
    function readjustFocus(e) {
        if (e.shiftKey) return tryFocus(lastTabbableNode);
        tryFocus(firstTabbableNode);
    }
}
function isEscapeEvent(e) {
    return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
}
function tryFocus(node) {
    if (!node || !node.focus) return;
    if (node === document.activeElement) return;
    node.focus();
    if (node.tagName.toLowerCase() === 'input') node.select();
}
module.exports = focusTrap;

},{"47166d9411d6e599":"2tteG"}],"2tteG":[function(require,module,exports,__globalThis) {
module.exports = function(el, options) {
    options = options || {};
    var elementDocument = el.ownerDocument || el;
    var basicTabbables = [];
    var orderedTabbables = [];
    // A node is "available" if
    // - it's computed style
    var isUnavailable = createIsUnavailable(elementDocument);
    var candidateSelectors = [
        'input',
        'select',
        'a[href]',
        'textarea',
        'button',
        '[tabindex]'
    ];
    var candidates = el.querySelectorAll(candidateSelectors.join(','));
    if (options.includeContainer) {
        var matches = Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
        if (candidateSelectors.some(function(candidateSelector) {
            return matches.call(el, candidateSelector);
        })) {
            candidates = Array.prototype.slice.apply(candidates);
            candidates.unshift(el);
        }
    }
    var candidate, candidateIndexAttr, candidateIndex;
    for(var i = 0, l = candidates.length; i < l; i++){
        candidate = candidates[i];
        candidateIndexAttr = parseInt(candidate.getAttribute('tabindex'), 10);
        candidateIndex = isNaN(candidateIndexAttr) ? candidate.tabIndex : candidateIndexAttr;
        if (candidateIndex < 0 || candidate.tagName === 'INPUT' && candidate.type === 'hidden' || candidate.disabled || isUnavailable(candidate, elementDocument)) continue;
        if (candidateIndex === 0) basicTabbables.push(candidate);
        else orderedTabbables.push({
            index: i,
            tabIndex: candidateIndex,
            node: candidate
        });
    }
    var tabbableNodes = orderedTabbables.sort(function(a, b) {
        return a.tabIndex === b.tabIndex ? a.index - b.index : a.tabIndex - b.tabIndex;
    }).map(function(a) {
        return a.node;
    });
    Array.prototype.push.apply(tabbableNodes, basicTabbables);
    return tabbableNodes;
};
function createIsUnavailable(elementDocument) {
    // Node cache must be refreshed on every check, in case
    // the content of the element has changed
    var isOffCache = [];
    // "off" means `display: none;`, as opposed to "hidden",
    // which means `visibility: hidden;`. getComputedStyle
    // accurately reflects visiblity in context but not
    // "off" state, so we need to recursively check parents.
    function isOff(node, nodeComputedStyle) {
        if (node === elementDocument.documentElement) return false;
        // Find the cached node (Array.prototype.find not available in IE9)
        for(var i = 0, length = isOffCache.length; i < length; i++){
            if (isOffCache[i][0] === node) return isOffCache[i][1];
        }
        nodeComputedStyle = nodeComputedStyle || elementDocument.defaultView.getComputedStyle(node);
        var result = false;
        if (nodeComputedStyle.display === 'none') result = true;
        else if (node.parentNode) result = isOff(node.parentNode);
        isOffCache.push([
            node,
            result
        ]);
        return result;
    }
    return function isUnavailable(node) {
        if (node === elementDocument.documentElement) return false;
        var computedStyle = elementDocument.defaultView.getComputedStyle(node);
        if (isOff(node, computedStyle)) return true;
        return computedStyle.visibility === 'hidden';
    };
}

},{}],"13ljX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * **usePopupAppearance()**
 *
 * Abstracts away calculating the appearance for a popup including if it should
 * be portalled or not, this is done to ensure that if the popup needs to render
 * as a modal that it is also forcibly portalled. If it's not portalled when rendering
 * as a modal it will appear below the top bar.
 */ parcelHelpers.export(exports, "usePopupAppearance", function() {
    return usePopupAppearance;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _compiled = require("@atlaskit/primitives/compiled");
function usePopupAppearance(param) {
    var _appearance = param.appearance, _shouldRenderToParent = param.shouldRenderToParent;
    var mq = (0, _compiled.UNSAFE_useMediaQuery)('below.sm', function(e) {
        setIsSmallViewport(!!e.matches);
    });
    var _useState = (0, _slicedToArray._)((0, _react.useState)(!!(mq === null || mq === void 0 ? void 0 : mq.matches)), 2), isSmallViewport = _useState[0], setIsSmallViewport = _useState[1];
    var appearance = _appearance === 'UNSAFE_modal-below-sm' && isSmallViewport ? 'UNSAFE_modal-below-sm' : 'default';
    var shouldRenderToParent = _shouldRenderToParent && appearance === 'default';
    return {
        appearance: appearance,
        shouldRenderToParent: shouldRenderToParent
    };
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","react":"ltHCL","@atlaskit/primitives/compiled":"jhQE8","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"clhFp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGetMemoizedMergedTriggerRef", function() {
    return useGetMemoizedMergedTriggerRef;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _memoizeOne = require("memoize-one");
var _memoizeOneDefault = parcelHelpers.interopDefault(_memoizeOne);
var useGetMemoizedMergedTriggerRef = function() {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(function() {
        return (0, _memoizeOneDefault.default)(function(ref, setTriggerRef, isOpen) {
            return function(node) {
                if (node && isOpen) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), 1), getMemoizedMergedTriggerRef = _useState[0];
    return getMemoizedMergedTriggerRef;
};

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","react":"ltHCL","memoize-one":"5rJro","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5rJro":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return memoizeOne;
});
var safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function isEqual(first, second) {
    if (first === second) return true;
    if (safeIsNaN(first) && safeIsNaN(second)) return true;
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"b3Mpu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGetMemoizedMergedTriggerRefNew", function() {
    return useGetMemoizedMergedTriggerRefNew;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _memoizeOne = require("memoize-one");
var _memoizeOneDefault = parcelHelpers.interopDefault(_memoizeOne);
var useGetMemoizedMergedTriggerRefNew = function() {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(function() {
        return (0, _memoizeOneDefault.default)(function(ref, setTriggerRef) {
            return function(node) {
                if (node) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), 1), getMemoizedMergedTriggerRefNew = _useState[0];
    return getMemoizedMergedTriggerRefNew;
};

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","react":"ltHCL","memoize-one":"5rJro","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"744Eh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TopNavStartProvider", function() {
    return TopNavStartProvider;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _topNavStartAttachRef = require("./top-nav-start-attach-ref");
var _topNavStartElement = require("./top-nav-start-element");
var TopNavStartProvider = function(param) {
    var children = param.children;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(null), 2), element = _useState[0], setElement = _useState[1];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _topNavStartElement.TopNavStartElement).Provider, {
        value: element,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _topNavStartAttachRef.TopNavStartAttachRef).Provider, {
            value: setElement,
            children: children
        })
    });
};

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","react/jsx-runtime":"bGvcw","react":"ltHCL","./top-nav-start-attach-ref":"bl1VV","./top-nav-start-element":"eAxVY","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bl1VV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TopNavStartAttachRef", function() {
    return TopNavStartAttachRef;
});
var _react = require("react");
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var TopNavStartAttachRef = /*#__PURE__*/ (0, _react.createContext)((0, _noopDefault.default));

},{"react":"ltHCL","@atlaskit/ds-lib/noop":"2f3bg","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eAxVY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TopNavStartElement", function() {
    return TopNavStartElement;
});
var _react = require("react");
var TopNavStartElement = /*#__PURE__*/ (0, _react.createContext)(null);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gFQUJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IsSideNavShortcutEnabledProvider", function() {
    return IsSideNavShortcutEnabledProvider;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _isSideNavShortcutEnabledContext = require("./is-side-nav-shortcut-enabled-context");
function IsSideNavShortcutEnabledProvider(param) {
    var children = param.children, isSideNavShortcutEnabled = param.isSideNavShortcutEnabled;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _isSideNavShortcutEnabledContext.IsSideNavShortcutEnabledContext).Provider, {
        value: isSideNavShortcutEnabled,
        children: children
    });
}

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","./is-side-nav-shortcut-enabled-context":"1bXyM","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1bXyM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IsSideNavShortcutEnabledContext", function() {
    return IsSideNavShortcutEnabledContext;
});
var _react = require("react");
var IsSideNavShortcutEnabledContext = /*#__PURE__*/ (0, _react.createContext)(false);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jRv8h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SideNavElementProvider", function() {
    return SideNavElementProvider;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _sideNavRefContext = require("./side-nav-ref-context");
function SideNavElementProvider(param) {
    var children = param.children;
    var sideNavRef = (0, _react.useRef)(null);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sideNavRefContext.SideNavRefContext).Provider, {
        value: sideNavRef,
        children: children
    });
}

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","./side-nav-ref-context":"4rob5","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dZ7P8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SideNavToggleButtonProvider", function() {
    return SideNavToggleButtonProvider;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _sideNavToggleButtonAttachRef = require("./side-nav-toggle-button-attach-ref");
var _sideNavToggleButtonElement = require("./side-nav-toggle-button-element");
var SideNavToggleButtonProvider = function(param) {
    var children = param.children;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(null), 2), element = _useState[0], setElement = _useState[1];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sideNavToggleButtonElement.SideNavToggleButtonElement).Provider, {
        value: element,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sideNavToggleButtonAttachRef.SideNavToggleButtonAttachRef).Provider, {
            value: setElement,
            children: children
        })
    });
};

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","react/jsx-runtime":"bGvcw","react":"ltHCL","./side-nav-toggle-button-attach-ref":"70Rbq","./side-nav-toggle-button-element":"5jb6G","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"70Rbq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SideNavToggleButtonAttachRef", function() {
    return SideNavToggleButtonAttachRef;
});
var _react = require("react");
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var SideNavToggleButtonAttachRef = /*#__PURE__*/ (0, _react.createContext)((0, _noopDefault.default));

},{"react":"ltHCL","@atlaskit/ds-lib/noop":"2f3bg","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5jb6G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SideNavToggleButtonElement", function() {
    return SideNavToggleButtonElement;
});
var _react = require("react");
var SideNavToggleButtonElement = /*#__PURE__*/ (0, _react.createContext)(null);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jIc5u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SideNavVisibilityProvider", function() {
    return SideNavVisibilityProvider;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _setSideNavVisibilityState = require("./set-side-nav-visibility-state");
var _sideNavVisibilityState = require("./side-nav-visibility-state");
var SideNavVisibilityProvider = function(param) {
    var children = param.children, defaultCollapsed = param.defaultCollapsed;
    var initialState = typeof defaultCollapsed === 'boolean' ? {
        desktop: defaultCollapsed ? 'collapsed' : 'expanded',
        mobile: 'collapsed',
        flyout: 'closed',
        lastTrigger: null
    } : null;
    // Defaults to null so we can determine if the value has been set yet (for SSR)
    var _useState = (0, _slicedToArray._)((0, _react.useState)(initialState), 2), sideNavState = _useState[0], setSideNavState = _useState[1];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sideNavVisibilityState.SideNavVisibilityState).Provider, {
        value: sideNavState,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _setSideNavVisibilityState.SetSideNavVisibilityState).Provider, {
            value: setSideNavState,
            children: children
        })
    });
};

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","react/jsx-runtime":"bGvcw","react":"ltHCL","./set-side-nav-visibility-state":"d5UzO","./side-nav-visibility-state":"kC3kg","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"d5UzO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SetSideNavVisibilityState", function() {
    return SetSideNavVisibilityState;
});
var _react = require("react");
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var SetSideNavVisibilityState = /*#__PURE__*/ (0, _react.createContext)((0, _noopDefault.default));

},{"react":"ltHCL","@atlaskit/ds-lib/noop":"2f3bg","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kC3kg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SideNavVisibilityState", function() {
    return SideNavVisibilityState;
});
var _react = require("react");
var SideNavVisibilityState = /*#__PURE__*/ (0, _react.createContext)(null);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"blMWC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return 0, _flagDefault.default;
});
parcelHelpers.export(exports, "AutoDismissFlag", function() {
    return 0, _autoDismissFlagDefault.default;
});
parcelHelpers.export(exports, "FlagGroup", function() {
    return 0, _flagGroupDefault.default;
});
parcelHelpers.export(exports, "useFlags", function() {
    return 0, _flagProvider.useFlags;
});
parcelHelpers.export(exports, "withFlagsProvider", function() {
    return 0, _flagProvider.withFlagsProvider;
});
parcelHelpers.export(exports, "FlagsProvider", function() {
    return 0, _flagProvider.FlagsProvider;
});
var _flag = require("./flag");
var _flagDefault = parcelHelpers.interopDefault(_flag);
var _autoDismissFlag = require("./auto-dismiss-flag");
var _autoDismissFlagDefault = parcelHelpers.interopDefault(_autoDismissFlag);
var _flagGroup = require("./flag-group");
var _flagGroupDefault = parcelHelpers.interopDefault(_flagGroup);
var _flagProvider = require("./flag-provider");

},{"./flag":false,"./auto-dismiss-flag":"4UMEU","./flag-group":"jPpAU","./flag-provider":"eQp7n","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jMyfe":[function(require,module,exports,__globalThis) {
/* flag.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _usePlatformLeafEventHandler = require("@atlaskit/analytics-next/usePlatformLeafEventHandler");
var _css = require("@atlaskit/css");
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var _heading = require("@atlaskit/heading");
var _headingDefault = parcelHelpers.interopDefault(_heading);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _compiled = require("@atlaskit/primitives/compiled");
var _visuallyHidden = require("@atlaskit/visually-hidden");
var _visuallyHiddenDefault = parcelHelpers.interopDefault(_visuallyHidden);
var _constants = require("./constants");
var _flagActions = require("./flag-actions");
var _flagActionsDefault = parcelHelpers.interopDefault(_flagActions);
var _flagBackgroundColor = require("./flag-background-color");
var _flagIconColor = require("./flag-icon-color");
var _flagIconGlyph = require("./flag-icon-glyph");
var _flagTextColor = require("./flag-text-color");
var _flagTextColorToken = require("./flag-text-color-token");
var _internal = require("./internal");
var _useFlagGroup = require("./internal/use-flag-group");
var styles = {
    overflowWrap: "_1i4qfg65",
    flag: "_2rkofajl _1reo15vq _18m915vq _v564z97a _16qs130s _1pbyni7l _1bsb1osq",
    flagT26Shape: "_2rko1mok"
};
var CSS_VAR_ICON_COLOR = '--flag-icon-color';
var descriptionStyles = null;
var iconWrapperStyles = null;
var flagWrapperStyles = null;
var analyticsAttributes = {
    componentName: 'flag',
    packageName: undefined,
    packageVersion: undefined
};
var transitionStyles = null;
/**
 * __Flag__
 *
 * A flag is used for confirmations, alerts, and acknowledgments that require minimal user interaction,
 * often displayed using a flag group.
 *
 * - [Examples](https://atlassian.design/components/flag/examples)
 * - [Code](https://atlassian.design/components/flag/code)
 * - [Usage](https://atlassian.design/components/flag/usage)
 */ var Flag = function(props) {
    var _props_actions = props.actions, actions = _props_actions === void 0 ? [] : _props_actions, _props_appearance = props.appearance, appearance = _props_appearance === void 0 ? (0, _constants.DEFAULT_APPEARANCE) : _props_appearance, icon = props.icon, title = props.title, description = props.description, linkComponent = props.linkComponent, onMouseOver = props.onMouseOver, _props_onFocus = props.onFocus, onFocus = _props_onFocus === void 0 ? (0, _noopDefault.default) : _props_onFocus, onMouseOut = props.onMouseOut, _props_onBlur = props.onBlur, onBlur = _props_onBlur === void 0 ? (0, _noopDefault.default) : _props_onBlur, tmp = props.onDismissed, onDismissedProp = tmp === void 0 ? (0, _noopDefault.default) : tmp, testId = props.testId, id = props.id, analyticsContext = props.analyticsContext, delayAnnouncement = props.delayAnnouncement, _props_headingLevel = props.headingLevel, headingLevel = _props_headingLevel === void 0 ? 2 : _props_headingLevel;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), isDelayToAnnounce = _useState[0], setIsDelayToAnnounce = _useState[1];
    var _useFlagGroup1 = (0, _useFlagGroup.useFlagGroup)(), onDismissedFromFlagGroup = _useFlagGroup1.onDismissed, isDismissAllowed = _useFlagGroup1.isDismissAllowed;
    var onDismissed = (0, _react.useCallback)(function(id, analyticsEvent) {
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(false), 2), isExpanded = _useState1[0], setIsExpanded = _useState1[1];
    var onDismissedAnalytics = (0, _usePlatformLeafEventHandler.usePlatformLeafEventHandler)((0, _objectSpread._)({
        fn: onDismissed,
        action: 'dismissed',
        analyticsData: analyticsContext
    }, analyticsAttributes));
    var isBold = appearance !== (0, _constants.DEFAULT_APPEARANCE);
    var toggleExpand = (0, _react.useCallback)(function() {
        setIsExpanded(function(previous) {
            return !previous;
        });
    }, []);
    var buttonActionCallback = (0, _react.useCallback)(function() {
        if (isDismissAllowed) onDismissedAnalytics(id);
    }, [
        onDismissedAnalytics,
        id,
        isDismissAllowed
    ]);
    (0, _react.useEffect)(function() {
        // If buttons are removed as a prop, update isExpanded to be false
        if (isBold && isExpanded && !description && !actions.length) setIsExpanded(false);
    }, [
        actions.length,
        description,
        isBold,
        isExpanded
    ]);
    (0, _react.useEffect)(function() {
        if (!delayAnnouncement) return;
        setTimeout(function() {
            setIsDelayToAnnounce(true);
        }, delayAnnouncement);
    }, [
        delayAnnouncement
    ]);
    var onFocusAnalytics = (0, _usePlatformLeafEventHandler.usePlatformLeafEventHandler)((0, _objectSpread._)({
        fn: onFocus,
        action: 'focused',
        analyticsData: analyticsContext
    }, analyticsAttributes));
    var onBlurAnalytics = (0, _usePlatformLeafEventHandler.usePlatformLeafEventHandler)((0, _objectSpread._)({
        fn: onBlur,
        action: 'blurred',
        analyticsData: analyticsContext
    }, analyticsAttributes));
    var autoDismissProps = {
        onMouseOver: onMouseOver,
        onFocus: onFocusAnalytics,
        onMouseOut: onMouseOut,
        onBlur: onBlurAnalytics
    };
    var textColor = (0, _flagTextColor.flagTextColor)[appearance];
    var iconColor = (0, _flagIconColor.flagIconColor)[appearance];
    var iconGlyph = (0, _flagIconGlyph.flagIconGlyph)[appearance];
    var isDismissable = isBold || isDismissAllowed;
    var shouldRenderGap = !isBold && (description || actions.length) || isExpanded;
    // when delayAnnouncement is available we will use a hidden content for announcement
    var delayedAnnouncement = delayAnnouncement ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _visuallyHiddenDefault.default), {
        children: [
            title,
            description
        ]
    }) : undefined;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({
        role: "alert",
        "data-testid": testId
    }, autoDismissProps), {
        className: (0, _runtime.ax)([
            "_1bsb1osq"
        ]),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _compiled.Box), {
            padding: "space.200",
            backgroundColor: (0, _flagBackgroundColor.flagBackgroundColor)[appearance],
            xcss: (0, _css.cx)(styles.flag, (0, _platformFeatureFlags.fg)('platform-dst-shape-theme-default') && styles.flagT26Shape),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _compiled.Inline), {
                alignBlock: "start",
                space: "space.200",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        style: (0, _defineProperty._)({}, CSS_VAR_ICON_COLOR, iconColor),
                        "data-testid": testId && "".concat(testId, "-icon-container"),
                        className: (0, _runtime.ax)([
                            "_1e0c1txw _1ul91tcg _1tke1tcg _4cvr1h6o _1bah1h6o _1o9zidpf _syaz1jn0"
                        ]),
                        children: icon || iconGlyph
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: (0, _runtime.ax)([
                            "_v5641hdc _16jlkb7n"
                        ]),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _compiled.Stack), {
                            space: shouldRenderGap ? 'space.100' : 'space.0',
                            children: [
                                isDelayToAnnounce && delayedAnnouncement,
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _compiled.Inline), {
                                    alignBlock: "stretch",
                                    space: "space.100",
                                    spread: "space-between",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _compiled.Box), {
                                            paddingBlockStart: "space.050",
                                            paddingBlockEnd: "space.025",
                                            xcss: styles.overflowWrap,
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headingDefault.default), {
                                                as: "h".concat(headingLevel),
                                                size: "xsmall",
                                                color: textColor,
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    /* if isDelayToAnnounce is true, we will hide the content form screen reader to avoid duplicate announcement */ "aria-hidden": isDelayToAnnounce,
                                                    children: title
                                                })
                                            })
                                        }),
                                        isDismissable ? !(isBold && !description && !actions.length) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _internal.DismissButton), {
                                            testId: testId,
                                            appearance: appearance,
                                            isBold: isBold,
                                            isExpanded: isExpanded,
                                            onClick: isBold ? toggleExpand : buttonActionCallback
                                        }) : null
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _internal.Expander), {
                                    isExpanded: !isBold || isExpanded,
                                    testId: testId,
                                    children: [
                                        description && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                            style: {
                                                color: (0, _flagTextColorToken.flagTextColorToken)[appearance]
                                            },
                                            "data-testid": testId && "".concat(testId, "-description"),
                                            /* if isDelayToAnnounce is true, we will hide the content form screen reader to avoid duplicate announcement */ "aria-hidden": isDelayToAnnounce,
                                            className: (0, _runtime.ax)([
                                                "_11c8fhey _1reo1wug _18m91wug _c71l53f4 _1i4qfg65"
                                            ]),
                                            children: description
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _flagActionsDefault.default), {
                                            actions: actions,
                                            appearance: appearance,
                                            linkComponent: linkComponent,
                                            testId: testId
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    }));
};
exports.default = Flag;

},{"@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_sliced_to_array":"8PtL6","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/analytics-next/usePlatformLeafEventHandler":"8d2dv","@atlaskit/css":"fiaHp","@atlaskit/ds-lib/noop":"2f3bg","@atlaskit/heading":"dsM8C","@atlaskit/platform-feature-flags":"kO5t9","@atlaskit/primitives/compiled":"jhQE8","@atlaskit/visually-hidden":"lj6Zq","./constants":"gOcDT","./flag-actions":"5Tmta","./flag-background-color":"hDj5f","./flag-icon-color":"hndBM","./flag-icon-glyph":"f3Owk","./flag-text-color":"atkIS","./flag-text-color-token":"3GzjM","./internal":"j9h2i","./internal/use-flag-group":"d7hCa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dsM8C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return 0, _headingDefault.default;
});
parcelHelpers.export(exports, "HeadingContextProvider", function() {
    return 0, _headingContextDefault.default;
});
var _heading = require("./heading");
var _headingDefault = parcelHelpers.interopDefault(_heading);
var _headingContext = require("./heading-context");
var _headingContextDefault = parcelHelpers.interopDefault(_headingContext);

},{"./heading":"khTmM","./heading-context":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"khTmM":[function(require,module,exports,__globalThis) {
/* heading.tsx generated by @compiled/babel-plugin v0.39.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
var _primitives = require("@atlaskit/primitives");
var _compiled = require("@atlaskit/primitives/compiled");
var _useHeading = require("./use-heading");
var process = require("7fc2691839b09c1c");
var sizeTagMap = {
    xxlarge: 'h1',
    xlarge: 'h1',
    large: 'h2',
    medium: 'h3',
    small: 'h4',
    xsmall: 'h5',
    xxsmall: 'h6'
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ var styles = {
    reset: "_dxsyidpf _1i144jg8 _nmk4glyw"
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ var headingColorStyles = {
    'color.text': "_1w90i7uo",
    'color.text.inverse': "_1w9015cr",
    'color.text.warning.inverse': "_1w901yd3"
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ var headingSizeStyles = {
    xxlarge: "_fqox1iff",
    xlarge: "_fqox12ln",
    large: "_fqox10sd",
    medium: "_fqox1af2",
    small: "_fqox1e3o",
    xsmall: "_fqox1qyo",
    xxsmall: "_fqoxi4vh"
};
/**
 * @codegenEnd
 */ var useColor = function(colorProp) {
    var surface = (0, _compiled.UNSAFE_useSurface)();
    if (colorProp) return colorProp;
    if ((0, _primitives.UNSAFE_inverseColorMap).hasOwnProperty(surface)) return (0, _primitives.UNSAFE_inverseColorMap)[surface];
    return 'color.text';
};
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ var Heading = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    var children = props.children, size = props.size, id = props.id, testId = props.testId, as = props.as, colorProp = props.color;
    typeof process === "undefined" ? "undefined" : (0, _typeOf._)(process);
    var _useHeading1 = (0, _slicedToArray._)((0, _useHeading.useHeading)(sizeTagMap[size]), 2), hLevel = _useHeading1[0], inferredElement = _useHeading1[1];
    var Component = as || inferredElement;
    var needsAriaRole = Component === 'div' && hLevel;
    var color = useColor(colorProp);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        id: id,
        ref: ref,
        "data-testid": testId,
        role: needsAriaRole ? 'heading' : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        className: (0, _runtime.ax)([
            styles.reset,
            headingSizeStyles[size],
            headingColorStyles[color]
        ]),
        children: children
    });
});
exports.default = Heading;

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_type_of":"iFJdx","7fc2691839b09c1c":"gNLf3","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/primitives":"fuLpB","@atlaskit/primitives/compiled":"jhQE8","./use-heading":"jyCwr","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fuLpB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Box", function() {
    return 0, _boxDefault.default;
});
parcelHelpers.export(exports, "Inline", function() {
    return 0, _inlineDefault.default;
});
parcelHelpers.export(exports, "xcss", function() {
    return 0, _xcss.xcss;
});
parcelHelpers.export(exports, "tokensMap", function() {
    return 0, _xcss.tokensMap;
});
parcelHelpers.export(exports, "Stack", function() {
    return 0, _stackDefault.default;
});
parcelHelpers.export(exports, "Flex", function() {
    return 0, _flexDefault.default;
});
parcelHelpers.export(exports, "Grid", function() {
    return 0, _gridDefault.default;
});
parcelHelpers.export(exports, "Bleed", function() {
    return 0, _bleedDefault.default;
});
parcelHelpers.export(exports, "Text", function() {
    return 0, _textDefault.default;
});
parcelHelpers.export(exports, "MetricText", function() {
    return 0, _metricTextDefault.default;
});
parcelHelpers.export(exports, "Pressable", function() {
    return 0, _pressableDefault.default;
});
parcelHelpers.export(exports, "Anchor", function() {
    return 0, _anchorDefault.default;
});
parcelHelpers.export(exports, "media", function() {
    return 0, _responsive.media;
});
parcelHelpers.export(exports, "UNSAFE_media", function() {
    return 0, _responsive.UNSAFE_media;
});
parcelHelpers.export(exports, "UNSAFE_BREAKPOINTS_CONFIG", function() {
    return 0, _responsive.UNSAFE_BREAKPOINTS_CONFIG;
});
parcelHelpers.export(exports, "UNSAFE_useSurface", function() {
    return 0, _surfaceProvider.useSurface;
});
parcelHelpers.export(exports, "UNSAFE_inverseColorMap", function() {
    return 0, _styleMapsPartial.inverseColorMap;
});
var _box = require("./components/box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _inline = require("./components/inline");
var _inlineDefault = parcelHelpers.interopDefault(_inline);
var _xcss = require("./xcss/xcss");
var _stack = require("./components/stack");
var _stackDefault = parcelHelpers.interopDefault(_stack);
var _flex = require("./components/flex");
var _flexDefault = parcelHelpers.interopDefault(_flex);
var _grid = require("./components/grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _bleed = require("./components/bleed");
var _bleedDefault = parcelHelpers.interopDefault(_bleed);
var _text = require("./components/text");
var _textDefault = parcelHelpers.interopDefault(_text);
var _metricText = require("./components/metric-text");
var _metricTextDefault = parcelHelpers.interopDefault(_metricText);
var _pressable = require("./components/pressable");
var _pressableDefault = parcelHelpers.interopDefault(_pressable);
var _anchor = require("./components/anchor");
var _anchorDefault = parcelHelpers.interopDefault(_anchor);
var _responsive = require("./responsive");
var _surfaceProvider = require("./utils/surface-provider");
var _styleMapsPartial = require("./xcss/style-maps.partial");

},{"./components/box":"gILo3","./components/inline":false,"./xcss/xcss":"hIvbk","./components/stack":false,"./components/flex":false,"./components/grid":false,"./components/bleed":false,"./components/text":"aJstV","./components/metric-text":false,"./components/pressable":false,"./components/anchor":false,"./responsive":false,"./utils/surface-provider":false,"./xcss/style-maps.partial":"jsPtG","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gILo3":[function(require,module,exports,__globalThis) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Box", function() {
    return Box;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
var _react1 = require("@emotion/react");
var _surfaceContext = require("../utils/surface-context");
var _styleMapsPartial = require("../xcss/style-maps.partial");
var _xcss = require("../xcss/xcss");
var Box = /*#__PURE__*/ (0, _react.forwardRef)(function(_param, ref) {
    var tmp = _param.as, Component = tmp === void 0 ? 'div' : tmp, children = _param.children, backgroundColor = _param.backgroundColor, padding = _param.padding, paddingBlock = _param.paddingBlock, paddingBlockStart = _param.paddingBlockStart, paddingBlockEnd = _param.paddingBlockEnd, paddingInline = _param.paddingInline, paddingInlineStart = _param.paddingInlineStart, paddingInlineEnd = _param.paddingInlineEnd, style = _param.style, testId = _param.testId, xcss = _param.xcss, htmlAttributes = (0, _objectWithoutProperties._)(_param, [
        "as",
        "children",
        "backgroundColor",
        "padding",
        "paddingBlock",
        "paddingBlockStart",
        "paddingBlockEnd",
        "paddingInline",
        "paddingInlineStart",
        "paddingInlineEnd",
        "style",
        "testId",
        "xcss"
    ]);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, _objectWithoutProperties._)(htmlAttributes, [
        "className"
    ]);
    var resolvedStyles = (0, _xcss.parseXcss)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    /*#__PURE__*/ (0, _react1.jsx)(Component, (0, _objectSpreadProps._)((0, _objectSpread._)({
        style: style,
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static
    }, safeHtmlAttributes), {
        css: [
            baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, _styleMapsPartial.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, _styleMapsPartial.isSurfaceColorToken)(backgroundColor) && (0, _styleMapsPartial.surfaceColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, _styleMapsPartial.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, _styleMapsPartial.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, _styleMapsPartial.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, _styleMapsPartial.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, _styleMapsPartial.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, _styleMapsPartial.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, _styleMapsPartial.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? /*#__PURE__*/ (0, _react1.jsx)((0, _surfaceContext.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
exports.default = Box;
var baseStyles = (0, _react1.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","@emotion/react":"cCAhJ","../utils/surface-context":"gVKA0","../xcss/style-maps.partial":"jsPtG","../xcss/xcss":"hIvbk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cCAhJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CacheProvider", function() {
    return 0, _emotionElement43C6Fea0BrowserEsmJs.C;
});
parcelHelpers.export(exports, "ThemeContext", function() {
    return 0, _emotionElement43C6Fea0BrowserEsmJs.T;
});
parcelHelpers.export(exports, "ThemeProvider", function() {
    return 0, _emotionElement43C6Fea0BrowserEsmJs.a;
});
parcelHelpers.export(exports, "__unsafe_useEmotionCache", function() {
    return 0, _emotionElement43C6Fea0BrowserEsmJs._;
});
parcelHelpers.export(exports, "useTheme", function() {
    return 0, _emotionElement43C6Fea0BrowserEsmJs.u;
});
parcelHelpers.export(exports, "withEmotionCache", function() {
    return 0, _emotionElement43C6Fea0BrowserEsmJs.w;
});
parcelHelpers.export(exports, "withTheme", function() {
    return 0, _emotionElement43C6Fea0BrowserEsmJs.b;
});
parcelHelpers.export(exports, "ClassNames", function() {
    return ClassNames;
});
parcelHelpers.export(exports, "Global", function() {
    return Global;
});
parcelHelpers.export(exports, "createElement", function() {
    return jsx;
});
parcelHelpers.export(exports, "css", function() {
    return css;
});
parcelHelpers.export(exports, "jsx", function() {
    return jsx;
});
parcelHelpers.export(exports, "keyframes", function() {
    return keyframes;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _emotionElement43C6Fea0BrowserEsmJs = require("./emotion-element-43c6fea0.browser.esm.js");
var _react = require("react");
var _utils = require("@emotion/utils");
var _useInsertionEffectWithFallbacks = require("@emotion/use-insertion-effect-with-fallbacks");
var _serialize = require("@emotion/serialize");
var _cache = require("@emotion/cache");
var _extends = require("@babel/runtime/helpers/extends");
var _weakMemoize = require("@emotion/weak-memoize");
var _emotionReactIsolatedHnrsBrowserEsmJs = require("../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js");
var _hoistNonReactStatics = require("hoist-non-react-statics");
var pkg = {
    name: "@emotion/react",
    version: "11.11.4",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.3",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.2",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var jsx = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, _emotionElement43C6Fea0BrowserEsmJs.h).call(props, 'css')) // $FlowFixMe
    return _react.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, _emotionElement43C6Fea0BrowserEsmJs.E);
    createElementArgArray[1] = (0, _emotionElement43C6Fea0BrowserEsmJs.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return _react.createElement.apply(null, createElementArgArray);
};
var warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var Global = /* #__PURE__ */ (0, _emotionElement43C6Fea0BrowserEsmJs.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, _serialize.serializeStyles)([
        styles
    ], undefined, _react.useContext((0, _emotionElement43C6Fea0BrowserEsmJs.T)));
    if (!(0, _emotionElement43C6Fea0BrowserEsmJs.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ _react.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = _react.useRef();
    (0, _useInsertionEffectWithFallbacks.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, _useInsertionEffectWithFallbacks.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, _utils.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function css() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, _serialize.serializeStyles)(args);
}
var keyframes = function keyframes() {
    var insertable = css.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg === "undefined" ? "undefined" : (0, _typeOf._)(arg)){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, _utils.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, _useInsertionEffectWithFallbacks.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, _utils.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var ClassNames = /* #__PURE__ */ (0, _emotionElement43C6Fea0BrowserEsmJs.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, _serialize.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, _utils.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return merge(cache.registered, css, classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: _react.useContext((0, _emotionElement43C6Fea0BrowserEsmJs.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var isBrowser, isTestEnv, globalContext, globalKey;

},{"@swc/helpers/_/_type_of":"iFJdx","./emotion-element-43c6fea0.browser.esm.js":"hN1rQ","react":"ltHCL","@emotion/utils":"9m6eO","@emotion/use-insertion-effect-with-fallbacks":"6a6BT","@emotion/serialize":"7NJwA","@emotion/cache":"6fGRf","@babel/runtime/helpers/extends":"3LZYG","@emotion/weak-memoize":"aJNMy","../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js":"gUQuF","hoist-non-react-statics":"nZLnq","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hN1rQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "C", function() {
    return CacheProvider;
});
parcelHelpers.export(exports, "E", function() {
    return Emotion$1;
});
parcelHelpers.export(exports, "T", function() {
    return ThemeContext;
});
parcelHelpers.export(exports, "_", function() {
    return __unsafe_useEmotionCache;
});
parcelHelpers.export(exports, "a", function() {
    return ThemeProvider;
});
parcelHelpers.export(exports, "b", function() {
    return withTheme;
});
parcelHelpers.export(exports, "c", function() {
    return createEmotionProps;
});
parcelHelpers.export(exports, "h", function() {
    return hasOwn;
});
parcelHelpers.export(exports, "i", function() {
    return isBrowser;
});
parcelHelpers.export(exports, "u", function() {
    return useTheme;
});
parcelHelpers.export(exports, "w", function() {
    return withEmotionCache;
});
var _react = require("react");
var _cache = require("@emotion/cache");
var _cacheDefault = parcelHelpers.interopDefault(_cache);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _weakMemoize = require("@emotion/weak-memoize");
var _weakMemoizeDefault = parcelHelpers.interopDefault(_weakMemoize);
var _emotionReactIsolatedHnrsBrowserEsmJs = require("../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js");
var _emotionReactIsolatedHnrsBrowserEsmJsDefault = parcelHelpers.interopDefault(_emotionReactIsolatedHnrsBrowserEsmJs);
var _utils = require("@emotion/utils");
var _serialize = require("@emotion/serialize");
var _useInsertionEffectWithFallbacks = require("@emotion/use-insertion-effect-with-fallbacks");
var isBrowser = true;
var hasOwn = {}.hasOwnProperty;
var EmotionCacheContext = /* #__PURE__ */ _react.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, _cacheDefault.default)({
    key: 'css'
}) : null);
var CacheProvider = EmotionCacheContext.Provider;
var __unsafe_useEmotionCache = function useEmotionCache() {
    return (0, _react.useContext)(EmotionCacheContext);
};
var withEmotionCache = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, _react.useContext)(EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!isBrowser) withEmotionCache = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, _react.useContext)(EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, _cacheDefault.default)({
                key: 'css'
            });
            return /*#__PURE__*/ _react.createElement(EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var ThemeContext = /* #__PURE__ */ _react.createContext({});
var useTheme = function useTheme() {
    return _react.useContext(ThemeContext);
};
var getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, _extendsDefault.default)({}, outerTheme, theme);
};
var createCacheWithTheme = /* #__PURE__ */ (0, _weakMemoizeDefault.default)(function(outerTheme) {
    return (0, _weakMemoizeDefault.default)(function(theme) {
        return getTheme(outerTheme, theme);
    });
});
var ThemeProvider = function ThemeProvider(props) {
    var theme = _react.useContext(ThemeContext);
    if (props.theme !== theme) theme = createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ _react.createElement(ThemeContext.Provider, {
        value: theme
    }, props.children);
};
function withTheme(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var render = function render(props, ref) {
        var theme = _react.useContext(ThemeContext);
        return /*#__PURE__*/ _react.createElement(Component, (0, _extendsDefault.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ _react.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, _emotionReactIsolatedHnrsBrowserEsmJsDefault.default)(WithTheme, Component);
}
var getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split('.');
    return parts[parts.length - 1];
};
var getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return getLastPart(match[1]);
    return undefined;
};
var internalReactFunctionNames = /* #__PURE__ */ new Set([
    'renderWithHooks',
    'processChild',
    'finishClassComponent',
    'renderToString'
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, '-');
};
var getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split('\n');
    for(var i = 0; i < lines.length; i++){
        var functionName = getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if (internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return sanitizeIdentifier(functionName);
    }
    return undefined;
};
var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if (hasOwn.call(props, key)) newProps[key] = props[key];
    newProps[typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, _utils.registerStyles)(cache, serialized, isStringTag);
    (0, _useInsertionEffectWithFallbacks.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, _utils.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var Emotion = /* #__PURE__ */ withEmotionCache(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, _utils.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, _serialize.serializeStyles)(registeredStyles, undefined, _react.useContext(ThemeContext));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if (hasOwn.call(props, key) && key !== 'css' && key !== typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ _react.createElement(WrappedComponent, newProps));
});
var Emotion$1 = Emotion;

},{"react":"ltHCL","@emotion/cache":"6fGRf","@babel/runtime/helpers/esm/extends":"3LZYG","@emotion/weak-memoize":"aJNMy","../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js":"gUQuF","@emotion/utils":"9m6eO","@emotion/serialize":"7NJwA","@emotion/use-insertion-effect-with-fallbacks":"6a6BT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6fGRf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return createCache;
});
var _sheet = require("@emotion/sheet");
var _stylis = require("stylis");
var _weakMemoize = require("@emotion/weak-memoize");
var _memoize = require("@emotion/memoize");
var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, _stylis.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, _stylis.token)(character)) break;
        (0, _stylis.next)();
    }
    return (0, _stylis.slice)(begin, (0, _stylis.position));
};
var toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, _stylis.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, _stylis.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += identifierWithPointTracking((0, _stylis.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, _stylis.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, _stylis.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, _stylis.from)(character);
    }
    while (character = (0, _stylis.next)());
    return parsed;
};
var getRules = function getRules(value, points) {
    return (0, _stylis.dealloc)(toRules((0, _stylis.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var fixedElements = /* #__PURE__ */ new WeakMap();
var compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    fixedElements.set(element, true);
    var points = [];
    var rules = getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
var ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';
var isIgnoringComment = function isIgnoringComment(element) {
    return element.type === 'comm' && element.children.indexOf(ignoreFlag) > -1;
};
var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== 'rule' || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if (isIgnoringComment(node)) return;
                    break;
                }
            }
        }
    };
};
var isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var nullifyElement = function nullifyElement(element) {
    element.type = '';
    element.value = '';
    element["return"] = '';
    element.children = '';
    element.props = '';
};
var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        nullifyElement(element);
    } else if (isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function prefix(value, length) {
    switch((0, _stylis.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, _stylis.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, _stylis.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MOZ) + value + (0, _stylis.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + value + value;
        // order
        case 6165:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.replace)(value, /(\w+).+(:[^]+)/, (0, _stylis.WEBKIT) + 'box-$1$2' + (0, _stylis.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + 'flex-item-' + (0, _stylis.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + 'flex-line-pack' + (0, _stylis.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, _stylis.WEBKIT) + 'box-' + (0, _stylis.replace)(value, '-grow', '') + (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, _stylis.WEBKIT) + (0, _stylis.replace)(value, /([^-])(transform)/g, '$1' + (0, _stylis.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, _stylis.replace)((0, _stylis.replace)((0, _stylis.replace)(value, /(zoom-|grab)/, (0, _stylis.WEBKIT) + '$1'), /(image-set)/, (0, _stylis.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, _stylis.replace)(value, /(image-set\([^]*)/, (0, _stylis.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, _stylis.replace)((0, _stylis.replace)(value, /(.+:)(flex-)?(.*)/, (0, _stylis.WEBKIT) + 'box-pack:$3' + (0, _stylis.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, _stylis.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, _stylis.replace)(value, /(.+)-inline(.+)/, (0, _stylis.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, _stylis.strlen)(value) - 1 - length > 6) switch((0, _stylis.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, _stylis.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, _stylis.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, _stylis.WEBKIT) + '$2-$3' + '$1' + (0, _stylis.MOZ) + ((0, _stylis.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, _stylis.indexof)(value, 'stretch') ? prefix((0, _stylis.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, _stylis.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, _stylis.charat)(value, (0, _stylis.strlen)(value) - 3 - (~(0, _stylis.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, _stylis.replace)(value, ':', ':' + (0, _stylis.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, _stylis.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, _stylis.WEBKIT) + ((0, _stylis.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, _stylis.WEBKIT) + '$2$3' + '$1' + (0, _stylis.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, _stylis.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + value + value;
    }
    return value;
}
var prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, _stylis.DECLARATION:
                element["return"] = prefix(element.value, element.length);
                break;
            case 0, _stylis.KEYFRAMES:
                return (0, _stylis.serialize)([
                    (0, _stylis.copy)(element, {
                        value: (0, _stylis.replace)(element.value, '@', '@' + (0, _stylis.WEBKIT))
                    })
                ], callback);
            case 0, _stylis.RULESET:
                if (element.length) return (0, _stylis.combine)(element.props, function(value) {
                    switch((0, _stylis.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, _stylis.serialize)([
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(read-\w+)/, ':' + (0, _stylis.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, _stylis.serialize)([
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(plac\w+)/, ':' + (0, _stylis.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(plac\w+)/, ':' + (0, _stylis.MOZ) + '$1')
                                    ]
                                }),
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(plac\w+)/, (0, _stylis.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var defaultStylisPlugins = [
    prefixer
];
var createCache = function createCache(options) {
    var key = options.key;
    if (key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
        var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        compat,
        removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, _stylis.stringify),
        (0, _stylis.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, _stylis.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, _stylis.serialize)((0, _stylis.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, _sheet.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

},{"@emotion/sheet":"eRyXR","stylis":"lMHey","@emotion/weak-memoize":"aJNMy","@emotion/memoize":"4Sq1M","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eRyXR":[function(require,module,exports,__globalThis) {
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyleSheet", function() {
    return StyleSheet;
});
function sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var StyleSheet = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag(createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lMHey":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _enumJs = require("./src/Enum.js");
parcelHelpers.exportAll(_enumJs, exports);
var _utilityJs = require("./src/Utility.js");
parcelHelpers.exportAll(_utilityJs, exports);
var _parserJs = require("./src/Parser.js");
parcelHelpers.exportAll(_parserJs, exports);
var _prefixerJs = require("./src/Prefixer.js");
parcelHelpers.exportAll(_prefixerJs, exports);
var _tokenizerJs = require("./src/Tokenizer.js");
parcelHelpers.exportAll(_tokenizerJs, exports);
var _serializerJs = require("./src/Serializer.js");
parcelHelpers.exportAll(_serializerJs, exports);
var _middlewareJs = require("./src/Middleware.js");
parcelHelpers.exportAll(_middlewareJs, exports);

},{"./src/Enum.js":"hzPck","./src/Utility.js":"gIM69","./src/Parser.js":"lJO3j","./src/Prefixer.js":false,"./src/Tokenizer.js":"hrdBx","./src/Serializer.js":"4JWcU","./src/Middleware.js":"lrOJv","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hzPck":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MS", function() {
    return MS;
});
parcelHelpers.export(exports, "MOZ", function() {
    return MOZ;
});
parcelHelpers.export(exports, "WEBKIT", function() {
    return WEBKIT;
});
parcelHelpers.export(exports, "COMMENT", function() {
    return COMMENT;
});
parcelHelpers.export(exports, "RULESET", function() {
    return RULESET;
});
parcelHelpers.export(exports, "DECLARATION", function() {
    return DECLARATION;
});
parcelHelpers.export(exports, "PAGE", function() {
    return PAGE;
});
parcelHelpers.export(exports, "MEDIA", function() {
    return MEDIA;
});
parcelHelpers.export(exports, "IMPORT", function() {
    return IMPORT;
});
parcelHelpers.export(exports, "CHARSET", function() {
    return CHARSET;
});
parcelHelpers.export(exports, "VIEWPORT", function() {
    return VIEWPORT;
});
parcelHelpers.export(exports, "SUPPORTS", function() {
    return SUPPORTS;
});
parcelHelpers.export(exports, "DOCUMENT", function() {
    return DOCUMENT;
});
parcelHelpers.export(exports, "NAMESPACE", function() {
    return NAMESPACE;
});
parcelHelpers.export(exports, "KEYFRAMES", function() {
    return KEYFRAMES;
});
parcelHelpers.export(exports, "FONT_FACE", function() {
    return FONT_FACE;
});
parcelHelpers.export(exports, "COUNTER_STYLE", function() {
    return COUNTER_STYLE;
});
parcelHelpers.export(exports, "FONT_FEATURE_VALUES", function() {
    return FONT_FEATURE_VALUES;
});
parcelHelpers.export(exports, "LAYER", function() {
    return LAYER;
});
var MS = '-ms-';
var MOZ = '-moz-';
var WEBKIT = '-webkit-';
var COMMENT = 'comm';
var RULESET = 'rule';
var DECLARATION = 'decl';
var PAGE = '@page';
var MEDIA = '@media';
var IMPORT = '@import';
var CHARSET = '@charset';
var VIEWPORT = '@viewport';
var SUPPORTS = '@supports';
var DOCUMENT = '@document';
var NAMESPACE = '@namespace';
var KEYFRAMES = '@keyframes';
var FONT_FACE = '@font-face';
var COUNTER_STYLE = '@counter-style';
var FONT_FEATURE_VALUES = '@font-feature-values';
var LAYER = '@layer';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gIM69":[function(require,module,exports,__globalThis) {
/**
 * @param {number}
 * @return {number}
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "abs", function() {
    return abs;
});
parcelHelpers.export(exports, "from", function() {
    return from;
});
parcelHelpers.export(exports, "assign", function() {
    return assign;
});
/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */ parcelHelpers.export(exports, "hash", function() {
    return hash;
});
/**
 * @param {string} value
 * @return {string}
 */ parcelHelpers.export(exports, "trim", function() {
    return trim;
});
/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */ parcelHelpers.export(exports, "match", function() {
    return match;
});
/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */ parcelHelpers.export(exports, "replace", function() {
    return replace;
});
/**
 * @param {string} value
 * @param {string} search
 * @return {number}
 */ parcelHelpers.export(exports, "indexof", function() {
    return indexof;
});
/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */ parcelHelpers.export(exports, "charat", function() {
    return charat;
});
/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */ parcelHelpers.export(exports, "substr", function() {
    return substr;
});
/**
 * @param {string} value
 * @return {number}
 */ parcelHelpers.export(exports, "strlen", function() {
    return strlen;
});
/**
 * @param {any[]} value
 * @return {number}
 */ parcelHelpers.export(exports, "sizeof", function() {
    return sizeof;
});
/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */ parcelHelpers.export(exports, "append", function() {
    return append;
});
/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */ parcelHelpers.export(exports, "combine", function() {
    return combine;
});
var abs = Math.abs;
var from = String.fromCharCode;
var assign = Object.assign;
function hash(value, length) {
    return charat(value, 0) ^ 45 ? (((length << 2 ^ charat(value, 0)) << 2 ^ charat(value, 1)) << 2 ^ charat(value, 2)) << 2 ^ charat(value, 3) : 0;
}
function trim(value) {
    return value.trim();
}
function match(value, pattern) {
    return (value = pattern.exec(value)) ? value[0] : value;
}
function replace(value, pattern, replacement) {
    return value.replace(pattern, replacement);
}
function indexof(value, search) {
    return value.indexOf(search);
}
function charat(value, index) {
    return value.charCodeAt(index) | 0;
}
function substr(value, begin, end) {
    return value.slice(begin, end);
}
function strlen(value) {
    return value.length;
}
function sizeof(value) {
    return value.length;
}
function append(value, array) {
    return array.push(value), value;
}
function combine(array, callback) {
    return array.map(callback).join('');
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lJO3j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @param {string} value
 * @return {object[]}
 */ parcelHelpers.export(exports, "compile", function() {
    return compile;
});
/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */ parcelHelpers.export(exports, "parse", function() {
    return parse;
});
/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */ parcelHelpers.export(exports, "ruleset", function() {
    return ruleset;
});
/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */ parcelHelpers.export(exports, "comment", function() {
    return comment;
});
/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */ parcelHelpers.export(exports, "declaration", function() {
    return declaration;
});
var _enumJs = require("./Enum.js");
var _utilityJs = require("./Utility.js");
var _tokenizerJs = require("./Tokenizer.js");
function compile(value) {
    return (0, _tokenizerJs.dealloc)(parse('', null, null, null, [
        ''
    ], value = (0, _tokenizerJs.alloc)(value), 0, [
        0
    ], value));
}
function parse(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
    var index = 0;
    var offset = 0;
    var length = pseudo;
    var atrule = 0;
    var property = 0;
    var previous = 0;
    var variable = 1;
    var scanning = 1;
    var ampersand = 1;
    var character = 0;
    var type = '';
    var props = rules;
    var children = rulesets;
    var reference = rule;
    var characters = type;
    while(scanning)switch(previous = character, character = (0, _tokenizerJs.next)()){
        // (
        case 40:
            if (previous != 108 && (0, _utilityJs.charat)(characters, length - 1) == 58) {
                if ((0, _utilityJs.indexof)(characters += (0, _utilityJs.replace)((0, _tokenizerJs.delimit)(character), '&', '&\f'), '&\f') != -1) ampersand = -1;
                break;
            }
        // " ' [
        case 34:
        case 39:
        case 91:
            characters += (0, _tokenizerJs.delimit)(character);
            break;
        // \t \n \r \s
        case 9:
        case 10:
        case 13:
        case 32:
            characters += (0, _tokenizerJs.whitespace)(previous);
            break;
        // \
        case 92:
            characters += (0, _tokenizerJs.escaping)((0, _tokenizerJs.caret)() - 1, 7);
            continue;
        // /
        case 47:
            switch((0, _tokenizerJs.peek)()){
                case 42:
                case 47:
                    (0, _utilityJs.append)(comment((0, _tokenizerJs.commenter)((0, _tokenizerJs.next)(), (0, _tokenizerJs.caret)()), root, parent), declarations);
                    break;
                default:
                    characters += '/';
            }
            break;
        // {
        case 123 * variable:
            points[index++] = (0, _utilityJs.strlen)(characters) * ampersand;
        // } ; \0
        case 125 * variable:
        case 59:
        case 0:
            switch(character){
                // \0 }
                case 0:
                case 125:
                    scanning = 0;
                // ;
                case 59 + offset:
                    if (ampersand == -1) characters = (0, _utilityJs.replace)(characters, /\f/g, '');
                    if (property > 0 && (0, _utilityJs.strlen)(characters) - length) (0, _utilityJs.append)(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration((0, _utilityJs.replace)(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
                    break;
                // @ ;
                case 59:
                    characters += ';';
                // { rule/at-rule
                default:
                    (0, _utilityJs.append)(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);
                    if (character === 123) {
                        if (offset === 0) parse(characters, root, reference, reference, props, rulesets, length, points, children);
                        else switch(atrule === 99 && (0, _utilityJs.charat)(characters, 3) === 110 ? 100 : atrule){
                            // d l m s
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                parse(value, reference, reference, rule && (0, _utilityJs.append)(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
                                break;
                            default:
                                parse(characters, reference, reference, reference, [
                                    ''
                                ], children, 0, points, children);
                        }
                    }
            }
            index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
            break;
        // :
        case 58:
            length = 1 + (0, _utilityJs.strlen)(characters), property = previous;
        default:
            if (variable < 1) {
                if (character == 123) --variable;
                else if (character == 125 && variable++ == 0 && (0, _tokenizerJs.prev)() == 125) continue;
            }
            switch(characters += (0, _utilityJs.from)(character), character * variable){
                // &
                case 38:
                    ampersand = offset > 0 ? 1 : (characters += '\f', -1);
                    break;
                // ,
                case 44:
                    points[index++] = ((0, _utilityJs.strlen)(characters) - 1) * ampersand, ampersand = 1;
                    break;
                // @
                case 64:
                    // -
                    if ((0, _tokenizerJs.peek)() === 45) characters += (0, _tokenizerJs.delimit)((0, _tokenizerJs.next)());
                    atrule = (0, _tokenizerJs.peek)(), offset = length = (0, _utilityJs.strlen)(type = characters += (0, _tokenizerJs.identifier)((0, _tokenizerJs.caret)())), character++;
                    break;
                // -
                case 45:
                    if (previous === 45 && (0, _utilityJs.strlen)(characters) == 2) variable = 0;
            }
    }
    return rulesets;
}
function ruleset(value, root, parent, index, offset, rules, points, type, props, children, length) {
    var post = offset - 1;
    var rule = offset === 0 ? rules : [
        ''
    ];
    var size = (0, _utilityJs.sizeof)(rule);
    for(var i = 0, j = 0, k = 0; i < index; ++i)for(var x = 0, y = (0, _utilityJs.substr)(value, post + 1, post = (0, _utilityJs.abs)(j = points[i])), z = value; x < size; ++x)if (z = (0, _utilityJs.trim)(j > 0 ? rule[x] + ' ' + y : (0, _utilityJs.replace)(y, /&\f/g, rule[x]))) props[k++] = z;
    return (0, _tokenizerJs.node)(value, root, parent, offset === 0 ? (0, _enumJs.RULESET) : type, props, children, length);
}
function comment(value, root, parent) {
    return (0, _tokenizerJs.node)(value, root, parent, (0, _enumJs.COMMENT), (0, _utilityJs.from)((0, _tokenizerJs.char)()), (0, _utilityJs.substr)(value, 2, -2), 0);
}
function declaration(value, root, parent, length) {
    return (0, _tokenizerJs.node)(value, root, parent, (0, _enumJs.DECLARATION), (0, _utilityJs.substr)(value, 0, length), (0, _utilityJs.substr)(value, length + 1, -1), length);
}

},{"./Enum.js":"hzPck","./Utility.js":"gIM69","./Tokenizer.js":"hrdBx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hrdBx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "line", function() {
    return line;
});
parcelHelpers.export(exports, "column", function() {
    return column;
});
parcelHelpers.export(exports, "length", function() {
    return length;
});
parcelHelpers.export(exports, "position", function() {
    return position;
});
parcelHelpers.export(exports, "character", function() {
    return character;
});
parcelHelpers.export(exports, "characters", function() {
    return characters;
});
/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {number} length
 */ parcelHelpers.export(exports, "node", function() {
    return node;
});
/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */ parcelHelpers.export(exports, "copy", function() {
    return copy;
});
/**
 * @return {number}
 */ parcelHelpers.export(exports, "char", function() {
    return char;
});
/**
 * @return {number}
 */ parcelHelpers.export(exports, "prev", function() {
    return prev;
});
/**
 * @return {number}
 */ parcelHelpers.export(exports, "next", function() {
    return next;
});
/**
 * @return {number}
 */ parcelHelpers.export(exports, "peek", function() {
    return peek;
});
/**
 * @return {number}
 */ parcelHelpers.export(exports, "caret", function() {
    return caret;
});
/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */ parcelHelpers.export(exports, "slice", function() {
    return slice;
});
/**
 * @param {number} type
 * @return {number}
 */ parcelHelpers.export(exports, "token", function() {
    return token;
});
/**
 * @param {string} value
 * @return {any[]}
 */ parcelHelpers.export(exports, "alloc", function() {
    return alloc;
});
/**
 * @param {any} value
 * @return {any}
 */ parcelHelpers.export(exports, "dealloc", function() {
    return dealloc;
});
/**
 * @param {number} type
 * @return {string}
 */ parcelHelpers.export(exports, "delimit", function() {
    return delimit;
});
/**
 * @param {string} value
 * @return {string[]}
 */ parcelHelpers.export(exports, "tokenize", function() {
    return tokenize;
});
/**
 * @param {number} type
 * @return {string}
 */ parcelHelpers.export(exports, "whitespace", function() {
    return whitespace;
});
/**
 * @param {string[]} children
 * @return {string[]}
 */ parcelHelpers.export(exports, "tokenizer", function() {
    return tokenizer;
});
/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */ parcelHelpers.export(exports, "escaping", function() {
    return escaping;
});
/**
 * @param {number} type
 * @return {number}
 */ parcelHelpers.export(exports, "delimiter", function() {
    return delimiter;
});
/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */ parcelHelpers.export(exports, "commenter", function() {
    return commenter;
});
/**
 * @param {number} index
 * @return {string}
 */ parcelHelpers.export(exports, "identifier", function() {
    return identifier;
});
var _utilityJs = require("./Utility.js");
var line = 1;
var column = 1;
var length = 0;
var position = 0;
var character = 0;
var characters = '';
function node(value, root, parent, type, props, children, length) {
    return {
        value: value,
        root: root,
        parent: parent,
        type: type,
        props: props,
        children: children,
        line: line,
        column: column,
        length: length,
        return: ''
    };
}
function copy(root, props) {
    return (0, _utilityJs.assign)(node('', null, null, '', null, null, 0), root, {
        length: -root.length
    }, props);
}
function char() {
    return character;
}
function prev() {
    character = position > 0 ? (0, _utilityJs.charat)(characters, --position) : 0;
    if (column--, character === 10) column = 1, line--;
    return character;
}
function next() {
    character = position < length ? (0, _utilityJs.charat)(characters, position++) : 0;
    if (column++, character === 10) column = 1, line++;
    return character;
}
function peek() {
    return (0, _utilityJs.charat)(characters, position);
}
function caret() {
    return position;
}
function slice(begin, end) {
    return (0, _utilityJs.substr)(characters, begin, end);
}
function token(type) {
    switch(type){
        // \0 \t \n \r \s whitespace token
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        // ! + , / > @ ~ isolate token
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        // ; { } breakpoint token
        case 59:
        case 123:
        case 125:
            return 4;
        // : accompanied token
        case 58:
            return 3;
        // " ' ( [ opening delimit token
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        // ) ] closing delimit token
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function alloc(value) {
    return line = column = 1, length = (0, _utilityJs.strlen)(characters = value), position = 0, [];
}
function dealloc(value) {
    return characters = '', value;
}
function delimit(type) {
    return (0, _utilityJs.trim)(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function tokenize(value) {
    return dealloc(tokenizer(alloc(value)));
}
function whitespace(type) {
    while(character = peek())if (character < 33) next();
    else break;
    return token(type) > 2 || token(character) > 3 ? '' : ' ';
}
function tokenizer(children) {
    while(next())switch(token(character)){
        case 0:
            (0, _utilityJs.append)(identifier(position - 1), children);
            break;
        case 2:
            (0, _utilityJs.append)(delimit(character), children);
            break;
        default:
            (0, _utilityJs.append)((0, _utilityJs.from)(character), children);
    }
    return children;
}
function escaping(index, count) {
    while(--count && next())// not 0-9 A-F a-f
    if (character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97) break;
    return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32));
}
function delimiter(type) {
    while(next())switch(character){
        // ] ) " '
        case type:
            return position;
        // " '
        case 34:
        case 39:
            if (type !== 34 && type !== 39) delimiter(character);
            break;
        // (
        case 40:
            if (type === 41) delimiter(type);
            break;
        // \
        case 92:
            next();
            break;
    }
    return position;
}
function commenter(type, index) {
    while(next())// //
    if (type + character === 57) break;
    else if (type + character === 84 && peek() === 47) break;
    return '/*' + slice(index, position - 1) + '*' + (0, _utilityJs.from)(type === 47 ? type : next());
}
function identifier(index) {
    while(!token(peek()))next();
    return slice(index, position);
}

},{"./Utility.js":"gIM69","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"M3Jge":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @param {string} value
 * @param {number} length
 * @param {object[]} children
 * @return {string}
 */ parcelHelpers.export(exports, "prefix", function() {
    return prefix;
});
var _enumJs = require("./Enum.js");
var _utilityJs = require("./Utility.js");
function prefix(value, length, children) {
    switch((0, _utilityJs.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, _enumJs.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, _enumJs.WEBKIT) + value + value;
        // tab-size
        case 4789:
            return (0, _enumJs.MOZ) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, _enumJs.WEBKIT) + value + (0, _enumJs.MOZ) + value + (0, _enumJs.MS) + value + value;
        // writing-mode
        case 5936:
            switch((0, _utilityJs.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, _enumJs.WEBKIT) + value + (0, _enumJs.MS) + (0, _utilityJs.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, _enumJs.WEBKIT) + value + (0, _enumJs.MS) + (0, _utilityJs.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, _enumJs.WEBKIT) + value + (0, _enumJs.MS) + (0, _utilityJs.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
        // flex, flex-direction, scroll-snap-type, writing-mode
        case 6828:
        case 4268:
        case 2903:
            return (0, _enumJs.WEBKIT) + value + (0, _enumJs.MS) + value + value;
        // order
        case 6165:
            return (0, _enumJs.WEBKIT) + value + (0, _enumJs.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, _enumJs.WEBKIT) + value + (0, _utilityJs.replace)(value, /(\w+).+(:[^]+)/, (0, _enumJs.WEBKIT) + 'box-$1$2' + (0, _enumJs.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, _enumJs.WEBKIT) + value + (0, _enumJs.MS) + 'flex-item-' + (0, _utilityJs.replace)(value, /flex-|-self/g, '') + (!(0, _utilityJs.match)(value, /flex-|baseline/) ? (0, _enumJs.MS) + 'grid-row-' + (0, _utilityJs.replace)(value, /flex-|-self/g, '') : '') + value;
        // align-content
        case 4675:
            return (0, _enumJs.WEBKIT) + value + (0, _enumJs.MS) + 'flex-line-pack' + (0, _utilityJs.replace)(value, /align-content|flex-|-self/g, '') + value;
        // flex-shrink
        case 5548:
            return (0, _enumJs.WEBKIT) + value + (0, _enumJs.MS) + (0, _utilityJs.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, _enumJs.WEBKIT) + value + (0, _enumJs.MS) + (0, _utilityJs.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, _enumJs.WEBKIT) + 'box-' + (0, _utilityJs.replace)(value, '-grow', '') + (0, _enumJs.WEBKIT) + value + (0, _enumJs.MS) + (0, _utilityJs.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, _enumJs.WEBKIT) + (0, _utilityJs.replace)(value, /([^-])(transform)/g, '$1' + (0, _enumJs.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, _utilityJs.replace)((0, _utilityJs.replace)((0, _utilityJs.replace)(value, /(zoom-|grab)/, (0, _enumJs.WEBKIT) + '$1'), /(image-set)/, (0, _enumJs.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, _utilityJs.replace)(value, /(image-set\([^]*)/, (0, _enumJs.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, _utilityJs.replace)((0, _utilityJs.replace)(value, /(.+:)(flex-)?(.*)/, (0, _enumJs.WEBKIT) + 'box-pack:$3' + (0, _enumJs.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, _enumJs.WEBKIT) + value + value;
        // justify-self
        case 4200:
            if (!(0, _utilityJs.match)(value, /flex-|baseline/)) return (0, _enumJs.MS) + 'grid-column-align' + (0, _utilityJs.substr)(value, length) + value;
            break;
        // grid-template-(columns|rows)
        case 2592:
        case 3360:
            return (0, _enumJs.MS) + (0, _utilityJs.replace)(value, 'template-', '') + value;
        // grid-(row|column)-start
        case 4384:
        case 3616:
            if (children && children.some(function(element, index) {
                return length = index, (0, _utilityJs.match)(element.props, /grid-\w+-end/);
            })) return ~(0, _utilityJs.indexof)(value + (children = children[length].value), 'span') ? value : (0, _enumJs.MS) + (0, _utilityJs.replace)(value, '-start', '') + value + (0, _enumJs.MS) + 'grid-row-span:' + (~(0, _utilityJs.indexof)(children, 'span') ? (0, _utilityJs.match)(children, /\d+/) : +(0, _utilityJs.match)(children, /\d+/) - +(0, _utilityJs.match)(value, /\d+/)) + ';';
            return (0, _enumJs.MS) + (0, _utilityJs.replace)(value, '-start', '') + value;
        // grid-(row|column)-end
        case 4896:
        case 4128:
            return children && children.some(function(element) {
                return (0, _utilityJs.match)(element.props, /grid-\w+-start/);
            }) ? value : (0, _enumJs.MS) + (0, _utilityJs.replace)((0, _utilityJs.replace)(value, '-end', '-span'), 'span ', '') + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, _utilityJs.replace)(value, /(.+)-inline(.+)/, (0, _enumJs.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, _utilityJs.strlen)(value) - 1 - length > 6) switch((0, _utilityJs.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, _utilityJs.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, _utilityJs.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, _enumJs.WEBKIT) + '$2-$3' + '$1' + (0, _enumJs.MOZ) + ((0, _utilityJs.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, _utilityJs.indexof)(value, 'stretch') ? prefix((0, _utilityJs.replace)(value, 'stretch', 'fill-available'), length, children) + value : value;
            }
            break;
        // grid-(column|row)
        case 5152:
        case 5920:
            return (0, _utilityJs.replace)(value, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(_, a, b, c, d, e, f) {
                return (0, _enumJs.MS) + a + ':' + b + f + (c ? (0, _enumJs.MS) + a + '-span:' + (d ? e : +e - +b) + f : '') + value;
            });
        // position: sticky
        case 4949:
            // stick(y)?
            if ((0, _utilityJs.charat)(value, length + 6) === 121) return (0, _utilityJs.replace)(value, ':', ':' + (0, _enumJs.WEBKIT)) + value;
            break;
        // display: (flex|inline-flex|grid|inline-grid)
        case 6444:
            switch((0, _utilityJs.charat)(value, (0, _utilityJs.charat)(value, 14) === 45 ? 18 : 11)){
                // (inline-)?fle(x)
                case 120:
                    return (0, _utilityJs.replace)(value, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, '$1' + (0, _enumJs.WEBKIT) + ((0, _utilityJs.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, _enumJs.WEBKIT) + '$2$3' + '$1' + (0, _enumJs.MS) + '$2box$3') + value;
                // (inline-)?gri(d)
                case 100:
                    return (0, _utilityJs.replace)(value, ':', ':' + (0, _enumJs.MS)) + value;
            }
            break;
        // scroll-margin, scroll-margin-(top|right|bottom|left)
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return (0, _utilityJs.replace)(value, 'scroll-', 'scroll-snap-') + value;
    }
    return value;
}

},{"./Enum.js":"hzPck","./Utility.js":"gIM69","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4JWcU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */ parcelHelpers.export(exports, "serialize", function() {
    return serialize;
});
/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */ parcelHelpers.export(exports, "stringify", function() {
    return stringify;
});
var _enumJs = require("./Enum.js");
var _utilityJs = require("./Utility.js");
function serialize(children, callback) {
    var output = '';
    var length = (0, _utilityJs.sizeof)(children);
    for(var i = 0; i < length; i++)output += callback(children[i], i, children, callback) || '';
    return output;
}
function stringify(element, index, children, callback) {
    switch(element.type){
        case 0, _enumJs.LAYER:
            if (element.children.length) break;
        case 0, _enumJs.IMPORT:
        case 0, _enumJs.DECLARATION:
            return element.return = element.return || element.value;
        case 0, _enumJs.COMMENT:
            return '';
        case 0, _enumJs.KEYFRAMES:
            return element.return = element.value + '{' + serialize(element.children, callback) + '}';
        case 0, _enumJs.RULESET:
            element.value = element.props.join(',');
    }
    return (0, _utilityJs.strlen)(children = serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : '';
}

},{"./Enum.js":"hzPck","./Utility.js":"gIM69","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lrOJv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @param {function[]} collection
 * @return {function}
 */ parcelHelpers.export(exports, "middleware", function() {
    return middleware;
});
/**
 * @param {function} callback
 * @return {function}
 */ parcelHelpers.export(exports, "rulesheet", function() {
    return rulesheet;
});
/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 */ parcelHelpers.export(exports, "prefixer", function() {
    return prefixer;
});
/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 */ parcelHelpers.export(exports, "namespace", function() {
    return namespace;
});
var _enumJs = require("./Enum.js");
var _utilityJs = require("./Utility.js");
var _tokenizerJs = require("./Tokenizer.js");
var _serializerJs = require("./Serializer.js");
var _prefixerJs = require("./Prefixer.js");
function middleware(collection) {
    var length = (0, _utilityJs.sizeof)(collection);
    return function(element, index, children, callback) {
        var output = '';
        for(var i = 0; i < length; i++)output += collection[i](element, index, children, callback) || '';
        return output;
    };
}
function rulesheet(callback) {
    return function(element) {
        if (!element.root) {
            if (element = element.return) callback(element);
        }
    };
}
function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element.return) switch(element.type){
            case 0, _enumJs.DECLARATION:
                element.return = (0, _prefixerJs.prefix)(element.value, element.length, children);
                return;
            case 0, _enumJs.KEYFRAMES:
                return (0, _serializerJs.serialize)([
                    (0, _tokenizerJs.copy)(element, {
                        value: (0, _utilityJs.replace)(element.value, '@', '@' + (0, _enumJs.WEBKIT))
                    })
                ], callback);
            case 0, _enumJs.RULESET:
                if (element.length) return (0, _utilityJs.combine)(element.props, function(value) {
                    switch((0, _utilityJs.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, _serializerJs.serialize)([
                                (0, _tokenizerJs.copy)(element, {
                                    props: [
                                        (0, _utilityJs.replace)(value, /:(read-\w+)/, ':' + (0, _enumJs.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, _serializerJs.serialize)([
                                (0, _tokenizerJs.copy)(element, {
                                    props: [
                                        (0, _utilityJs.replace)(value, /:(plac\w+)/, ':' + (0, _enumJs.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, _tokenizerJs.copy)(element, {
                                    props: [
                                        (0, _utilityJs.replace)(value, /:(plac\w+)/, ':' + (0, _enumJs.MOZ) + '$1')
                                    ]
                                }),
                                (0, _tokenizerJs.copy)(element, {
                                    props: [
                                        (0, _utilityJs.replace)(value, /:(plac\w+)/, (0, _enumJs.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
}
function namespace(element) {
    switch(element.type){
        case 0, _enumJs.RULESET:
            element.props = element.props.map(function(value) {
                return (0, _utilityJs.combine)((0, _tokenizerJs.tokenize)(value), function(value, index, children) {
                    switch((0, _utilityJs.charat)(value, 0)){
                        // \f
                        case 12:
                            return (0, _utilityJs.substr)(value, 1, (0, _utilityJs.strlen)(value));
                        // \0 ( + > ~
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return value;
                        // :
                        case 58:
                            if (children[++index] === 'global') children[index] = '', children[++index] = '\f' + (0, _utilityJs.substr)(children[index], index = 1, -1);
                        // \s
                        case 32:
                            return index === 1 ? '' : value;
                        default:
                            switch(index){
                                case 0:
                                    element = value;
                                    return (0, _utilityJs.sizeof)(children) > 1 ? '' : value;
                                case index = (0, _utilityJs.sizeof)(children) - 1:
                                case 2:
                                    return index === 2 ? value + element + element : value + element;
                                default:
                                    return value;
                            }
                    }
                });
            });
    }
}

},{"./Enum.js":"hzPck","./Utility.js":"gIM69","./Tokenizer.js":"hrdBx","./Serializer.js":"4JWcU","./Prefixer.js":"M3Jge","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aJNMy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return weakMemoize;
});
var weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4Sq1M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return memoize;
});
function memoize(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gUQuF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return hoistNonReactStatics;
});
var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var hoistNonReactStatics = function hoistNonReactStatics(targetComponent, sourceComponent) {
    return (0, _hoistNonReactStaticsDefault.default)(targetComponent, sourceComponent);
};

},{"hoist-non-react-statics":"nZLnq","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"nZLnq":[function(require,module,exports,__globalThis) {
'use strict';
var reactIs = require("5214e2ea36cfd2c8");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
function getStatics(component) {
    // React v16.11 and below
    if (reactIs.isMemo(component)) return MEMO_STATICS;
     // React v16.12 and above
    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}
var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = getOwnPropertyNames(sourceComponent);
        if (getOwnPropertySymbols) keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = hoistNonReactStatics;

},{"5214e2ea36cfd2c8":"aBLra"}],"aBLra":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("3216a58d2c9ca429");

},{"3216a58d2c9ca429":"kr4g9"}],"kr4g9":[function(require,module,exports,__globalThis) {
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
function z(a) {
    if ("object" === (typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)) && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case c:
                switch(a = a.type, a){
                    case l:
                    case m:
                    case e:
                    case g:
                    case f:
                    case p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case k:
                            case n:
                            case t:
                            case r:
                            case h:
                                return a;
                            default:
                                return u;
                        }
                }
            case d:
                return u;
        }
    }
}
function A(a) {
    return z(a) === m;
}
exports.AsyncMode = l;
exports.ConcurrentMode = m;
exports.ContextConsumer = k;
exports.ContextProvider = h;
exports.Element = c;
exports.ForwardRef = n;
exports.Fragment = e;
exports.Lazy = t;
exports.Memo = r;
exports.Portal = d;
exports.Profiler = g;
exports.StrictMode = f;
exports.Suspense = p;
exports.isAsyncMode = function(a) {
    return A(a) || z(a) === l;
};
exports.isConcurrentMode = A;
exports.isContextConsumer = function(a) {
    return z(a) === k;
};
exports.isContextProvider = function(a) {
    return z(a) === h;
};
exports.isElement = function(a) {
    return "object" === (typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)) && null !== a && a.$$typeof === c;
};
exports.isForwardRef = function(a) {
    return z(a) === n;
};
exports.isFragment = function(a) {
    return z(a) === e;
};
exports.isLazy = function(a) {
    return z(a) === t;
};
exports.isMemo = function(a) {
    return z(a) === r;
};
exports.isPortal = function(a) {
    return z(a) === d;
};
exports.isProfiler = function(a) {
    return z(a) === g;
};
exports.isStrictMode = function(a) {
    return z(a) === f;
};
exports.isSuspense = function(a) {
    return z(a) === p;
};
exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === (typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)) && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};
exports.typeOf = z;

},{"@swc/helpers/_/_type_of":"iFJdx"}],"9m6eO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRegisteredStyles", function() {
    return getRegisteredStyles;
});
parcelHelpers.export(exports, "insertStyles", function() {
    return insertStyles;
});
parcelHelpers.export(exports, "registerStyles", function() {
    return registerStyles;
});
var isBrowser = true;
function getRegisteredStyles(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
    registerStyles(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7NJwA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializeStyles", function() {
    return serializeStyles;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _hash = require("@emotion/hash");
var _hashDefault = parcelHelpers.interopDefault(_hash);
var _unitless = require("@emotion/unitless");
var _unitlessDefault = parcelHelpers.interopDefault(_unitless);
var _memoize = require("@emotion/memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
var isDevelopment = false;
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var processStyleName = /* #__PURE__ */ (0, _memoizeDefault.default)(function(styleName) {
    return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});
var processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace(animationRegex, function(match, p1, p2) {
                cursor = {
                    name: p1,
                    styles: p2,
                    next: cursor
                };
                return p1;
            });
    }
    if ((0, _unitlessDefault.default)[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation === "undefined" ? "undefined" : (0, _typeOf._)(interpolation)){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = cursor;
                var result = interpolation(mergedProps);
                cursor = previousCursor;
                return handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if ((typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if (isProcessableValue(asString)) string += processStyleName(key) + ":" + processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && isDevelopment) throw new Error(noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if (isProcessableValue(value[_i])) string += processStyleName(key) + ":" + processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var cursor;
function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && (0, _typeOf._)(args[0]) === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, _hashDefault.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: cursor
    };
}

},{"@swc/helpers/_/_type_of":"iFJdx","@emotion/hash":"aWxID","@emotion/unitless":"TdH6b","@emotion/memoize":"7iowJ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aWxID":[function(require,module,exports,__globalThis) {
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return murmur2;
});
function murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"TdH6b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return unitlessKeys;
});
var unitlessKeys = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7iowJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return memoize;
});
function memoize(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6a6BT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useInsertionEffectAlwaysWithSyncFallback", function() {
    return useInsertionEffectAlwaysWithSyncFallback;
});
parcelHelpers.export(exports, "useInsertionEffectWithLayoutFallback", function() {
    return useInsertionEffectWithLayoutFallback;
});
var _react = require("react");
var syncFallback = function syncFallback(create) {
    return create();
};
var useInsertionEffect = false;
var useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect || syncFallback;
var useInsertionEffectWithLayoutFallback = useInsertionEffect || _react.useLayoutEffect;

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jsPtG":[function(require,module,exports,__globalThis) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dimensionMap", function() {
    return dimensionMap;
});
parcelHelpers.export(exports, "positiveSpaceMap", function() {
    return positiveSpaceMap;
});
parcelHelpers.export(exports, "negativeSpaceMap", function() {
    return negativeSpaceMap;
});
parcelHelpers.export(exports, "allSpaceMap", function() {
    return allSpaceMap;
});
parcelHelpers.export(exports, "inverseColorMap", function() {
    return inverseColorMap;
});
parcelHelpers.export(exports, "opacityMap", function() {
    return opacityMap;
});
parcelHelpers.export(exports, "shadowMap", function() {
    return shadowMap;
});
parcelHelpers.export(exports, "surfaceColorMap", function() {
    return surfaceColorMap;
});
parcelHelpers.export(exports, "borderColorMap", function() {
    return borderColorMap;
});
parcelHelpers.export(exports, "backgroundColorMap", function() {
    return backgroundColorMap;
});
parcelHelpers.export(exports, "textColorMap", function() {
    return textColorMap;
});
parcelHelpers.export(exports, "fillMap", function() {
    return fillMap;
});
parcelHelpers.export(exports, "layerMap", function() {
    return layerMap;
});
parcelHelpers.export(exports, "borderWidthMap", function() {
    return borderWidthMap;
});
parcelHelpers.export(exports, "borderRadiusMap", function() {
    return borderRadiusMap;
});
parcelHelpers.export(exports, "fontMap", function() {
    return fontMap;
});
parcelHelpers.export(exports, "fontWeightMap", function() {
    return fontWeightMap;
});
parcelHelpers.export(exports, "fontFamilyMap", function() {
    return fontFamilyMap;
});
parcelHelpers.export(exports, "textSizeMap", function() {
    return textSizeMap;
});
parcelHelpers.export(exports, "textWeightMap", function() {
    return textWeightMap;
});
parcelHelpers.export(exports, "metricTextSizeMap", function() {
    return metricTextSizeMap;
});
parcelHelpers.export(exports, "getSerializedStylesMap", function() {
    return getSerializedStylesMap;
});
parcelHelpers.export(exports, "paddingStylesMap", function() {
    return paddingStylesMap;
});
parcelHelpers.export(exports, "spaceStylesMap", function() {
    return spaceStylesMap;
});
parcelHelpers.export(exports, "backgroundColorStylesMap", function() {
    return backgroundColorStylesMap;
});
parcelHelpers.export(exports, "textColorStylesMap", function() {
    return textColorStylesMap;
});
parcelHelpers.export(exports, "fontWeightStylesMap", function() {
    return fontWeightStylesMap;
});
parcelHelpers.export(exports, "fontFamilyStylesMap", function() {
    return fontFamilyStylesMap;
});
parcelHelpers.export(exports, "fontStylesMap", function() {
    return fontStylesMap;
});
parcelHelpers.export(exports, "textSizeStylesMap", function() {
    return textSizeStylesMap;
});
parcelHelpers.export(exports, "textWeightStylesMap", function() {
    return textWeightStylesMap;
});
parcelHelpers.export(exports, "surfaceColorStylesMap", function() {
    return surfaceColorStylesMap;
});
parcelHelpers.export(exports, "isSurfaceColorToken", function() {
    return isSurfaceColorToken;
});
parcelHelpers.export(exports, "metricTextSizeStylesMap", function() {
    return metricTextSizeStylesMap;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _react = require("@emotion/react");
var _tokens = require("@atlaskit/tokens");
var dimensionMap = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var positiveSpaceMap = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var negativeSpaceMap = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var allSpaceMap = (0, _objectSpread._)({}, positiveSpaceMap, negativeSpaceMap);
var inverseColorMap = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var opacityMap = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var shadowMap = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #1E1F211f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #1E1F2129)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #1E1F21, 0px 0px 1px #1E1F21)"
};
var surfaceColorMap = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)"
};
var borderColorMap = {
    'color.border': "var(--ds-border, #0B120E24)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #E2483D)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #E06C00)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #B38600)",
    'color.border.accent.green': "var(--ds-border-accent-green, #22A06B)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #2898BD)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #357DE8)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #AF59E1)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #7D818A)",
    'color.border.disabled': "var(--ds-border-disabled, #0515240F)",
    'color.border.focused': "var(--ds-border-focused, #4688EC)",
    'color.border.input': "var(--ds-border-input, #8C8F97)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #1868DB)",
    'color.border.brand': "var(--ds-border-brand, #1868DB)",
    'color.border.danger': "var(--ds-border-danger, #E2483D)",
    'color.border.warning': "var(--ds-border-warning, #E06C00)",
    'color.border.success': "var(--ds-border-success, #6A9A23)",
    'color.border.discovery': "var(--ds-border-discovery, #AF59E1)",
    'color.border.information': "var(--ds-border-information, #357DE8)",
    'color.border.bold': "var(--ds-border-bold, #7D818A)"
};
var backgroundColorMap = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #BDE97C)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #BDE97C)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #BDE97C)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #3F5224)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FFECEB)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FFB8B2)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FFD5D2)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FFB8B2)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #F87168)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FD9891)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FFB8B2)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #C9372C)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #872821)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FCE4A6)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FBD779)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #FBD779)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #FCA700)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #FBC828)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #FBD779)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #BD5B00)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #9E4C00)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #7A3B00)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #F5E989)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #EED12B)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #DDB30E)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #EFDD4E)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #946F00)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #614A05)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #97EDC9)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #BAF3DB)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #97EDC9)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #4BCE97)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #7EE2B8)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #97EDC9)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #1F845A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #19573D)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #B1E4F7)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #9DD9EE)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #B1E4F7)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #227D9B)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #1A5265)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #ADCBFB)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #669DF1)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #8FB8F6)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #ADCBFB)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #1868DB)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #1558BC)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #144794)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #EED7FC)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #E3BDFA)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #EED7FC)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #C97CF4)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #D8A0F7)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #E3BDFA)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #964AC0)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #803FA5)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #673286)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FCB6E1)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #77325B)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #8C8F97)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #8C8F97)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #B7B9BE)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #DDDEE1)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #6B6E76)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #505258)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #3B3D42)",
    'color.background.disabled': "var(--ds-background-disabled, #17171708)",
    'color.background.input': "var(--ds-background-input, #FFFFFF)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #F8F8F8)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #0515240F)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #0B120E24)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #080F214A)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, #00000000)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #0515240F)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #292A2E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #3B3D42)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #505258)",
    'color.background.selected': "var(--ds-background-selected, #E9F2FE)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #CFE1FD)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #8FB8F6)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #1868DB)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #1558BC)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #123263)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #E9F2FE)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #CFE1FD)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #ADCBFB)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #1868DB)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #1558BC)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #144794)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #1C2B42)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #123263)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #144794)",
    'color.background.danger': "var(--ds-background-danger, #FFECEB)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFD5D2)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FFB8B2)",
    'color.background.danger.subtler': "var(--ds-background-danger-subtler, #FFD5D2)",
    'color.background.danger.subtler.hovered': "var(--ds-background-danger-subtler-hovered, #FFB8B2)",
    'color.background.danger.subtler.pressed': "var(--ds-background-danger-subtler-pressed, #FD9891)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #C9372C)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #AE2E24)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #872821)",
    'color.background.warning': "var(--ds-background-warning, #FFF5DB)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FCE4A6)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FBD779)",
    'color.background.warning.subtler': "var(--ds-background-warning-subtler, #FCE4A6)",
    'color.background.warning.subtler.hovered': "var(--ds-background-warning-subtler-hovered, #FBD779)",
    'color.background.warning.subtler.pressed': "var(--ds-background-warning-subtler-pressed, #FBC828)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FBC828)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FCA700)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #F68909)",
    'color.background.success': "var(--ds-background-success, #EFFFD6)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #D3F1A7)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #BDE97C)",
    'color.background.success.subtler': "var(--ds-background-success-subtler, #D3F1A7)",
    'color.background.success.subtler.hovered': "var(--ds-background-success-subtler-hovered, #BDE97C)",
    'color.background.success.subtler.pressed': "var(--ds-background-success-subtler-pressed, #B3DF72)",
    'color.background.success.bold': "var(--ds-background-success-bold, #5B7F24)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #4C6B1F)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #3F5224)",
    'color.background.discovery': "var(--ds-background-discovery, #F8EEFE)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #EED7FC)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #E3BDFA)",
    'color.background.discovery.subtler': "var(--ds-background-discovery-subtler, #EED7FC)",
    'color.background.discovery.subtler.hovered': "var(--ds-background-discovery-subtler-hovered, #E3BDFA)",
    'color.background.discovery.subtler.pressed': "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #964AC0)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #803FA5)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #673286)",
    'color.background.information': "var(--ds-background-information, #E9F2FE)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #CFE1FD)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #ADCBFB)",
    'color.background.information.subtler': "var(--ds-background-information-subtler, #CFE1FD)",
    'color.background.information.subtler.hovered': "var(--ds-background-information-subtler-hovered, #ADCBFB)",
    'color.background.information.subtler.pressed': "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    'color.background.information.bold': "var(--ds-background-information-bold, #1868DB)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #1558BC)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #144794)",
    'color.blanket': "var(--ds-blanket, #050C1F75)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #0515240F)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #17171708)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var textColorMap = {
    'color.text': "var(--ds-text, #292A2E)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #AE2E24)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #5D1F1A)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #9E4C00)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #693200)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #7F5F01)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #533F04)",
    'color.text.accent.green': "var(--ds-text-accent-green, #216E4E)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #164B35)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #206A83)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #164555)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #1558BC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #123263)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #803FA5)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #48245D)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #943D73)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #50253F)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505258)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #1E1F21)",
    'color.text.disabled': "var(--ds-text-disabled, #080F214A)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #1868DB)",
    'color.text.brand': "var(--ds-text-brand, #1868DB)",
    'color.text.danger': "var(--ds-text-danger, #AE2E24)",
    'color.text.danger.bolder': "var(--ds-text-danger-bolder, #5D1F1A)",
    'color.text.warning': "var(--ds-text-warning, #9E4C00)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #292A2E)",
    'color.text.warning.bolder': "var(--ds-text-warning-bolder, #693200)",
    'color.text.success': "var(--ds-text-success, #4C6B1F)",
    'color.text.success.bolder': "var(--ds-text-success-bolder, #37471F)",
    'color.text.discovery': "var(--ds-text-discovery, #803FA5)",
    'color.text.discovery.bolder': "var(--ds-text-discovery-bolder, #48245D)",
    'color.text.information': "var(--ds-text-information, #1558BC)",
    'color.text.information.bolder': "var(--ds-text-information-bolder, #123263)",
    'color.text.subtlest': "var(--ds-text-subtlest, #6B6E76)",
    'color.text.subtle': "var(--ds-text-subtle, #505258)",
    'color.link': "var(--ds-link, #1868DB)",
    'color.link.pressed': "var(--ds-link-pressed, #1558BC)",
    'color.link.visited': "var(--ds-link-visited, #803FA5)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #48245D)"
};
var fillMap = {
    'color.icon': "var(--ds-icon, #292A2E)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #C9372C)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #E06C00)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #B38600)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #22A06B)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #2898BD)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #357DE8)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #AF59E1)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #7D818A)",
    'color.icon.disabled': "var(--ds-icon-disabled, #080F214A)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #1868DB)",
    'color.icon.brand': "var(--ds-icon-brand, #1868DB)",
    'color.icon.danger': "var(--ds-icon-danger, #C9372C)",
    'color.icon.warning': "var(--ds-icon-warning, #E06C00)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #292A2E)",
    'color.icon.success': "var(--ds-icon-success, #6A9A23)",
    'color.icon.discovery': "var(--ds-icon-discovery, #AF59E1)",
    'color.icon.information': "var(--ds-icon-information, #357DE8)",
    'color.icon.subtlest': "var(--ds-icon-subtlest, #6B6E76)",
    'color.icon.subtle': "var(--ds-icon-subtle, #505258)"
};
var layerMap = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var borderWidthMap = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.selected': "var(--ds-border-width-selected, 2px)",
    'border.width.focused': "var(--ds-border-width-focused, 2px)"
};
var borderRadiusMap = {
    'radius.xsmall': "var(--ds-radius-xsmall, 2px)",
    'radius.small': "var(--ds-radius-small, 3px)",
    'radius.medium': "var(--ds-radius-medium, 6px)",
    'radius.large': "var(--ds-radius-large, 8px)",
    'radius.xlarge': "var(--ds-radius-xlarge, 12px)",
    'radius.xxlarge': "var(--ds-radius-xxlarge, 16px)",
    'radius.full': "var(--ds-radius-full, 9999px)",
    'radius.tile': "var(--ds-radius-tile, 25%)"
};
var fontMap = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 653 20px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 653 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 653 32px/36px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 653 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.large': "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.medium': "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.small': "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var fontWeightMap = {
    'font.weight.bold': "var(--ds-font-weight-bold, 653)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
var fontFamilyMap = {
    'font.family.body': "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var textSizeMap = {
    medium: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var textWeightMap = {
    bold: "var(--ds-font-weight-bold, 653)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var metricTextSizeMap = {
    large: "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    medium: "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
// Generate maps for Box props. backgroundColor, padding, etc
var spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var getSerializedStylesMap = function(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, _react.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        (0, _defineProperty._)({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var paddingStylesMap = spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = getSerializedStylesMap(spacingProperty, positiveSpaceMap);
    return styleMap;
}, {});
var spaceStylesMap = spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = getSerializedStylesMap(spacingProperty, positiveSpaceMap);
    return styleMap;
}, {});
var backgroundColorStylesMap = getSerializedStylesMap('backgroundColor', backgroundColorMap);
var textColorStylesMap = getSerializedStylesMap('color', textColorMap);
var fontWeightStylesMap = getSerializedStylesMap('fontWeight', fontWeightMap);
var fontFamilyStylesMap = getSerializedStylesMap('fontFamily', fontFamilyMap);
var fontStylesMap = getSerializedStylesMap('font', fontMap);
var textSizeStylesMap = getSerializedStylesMap('font', textSizeMap);
var textWeightStylesMap = getSerializedStylesMap('fontWeight', textWeightMap);
var surfaceColorStylesMap = getSerializedStylesMap((0, _tokens.CURRENT_SURFACE_CSS_VAR), surfaceColorMap);
var isSurfaceColorToken = function(color) {
    return surfaceColorMap[color] !== undefined;
};
var metricTextSizeStylesMap = getSerializedStylesMap('font', metricTextSizeMap);

},{"@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_object_spread":"9gdrV","@emotion/react":"cCAhJ","@atlaskit/tokens":"8YPAP","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hIvbk":[function(require,module,exports,__globalThis) {
/* xcss.tsx generated by @compiled/babel-plugin v0.39.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "tokensMap", function() {
    return tokensMap;
});
parcelHelpers.export(exports, "parseXcss", function() {
    return parseXcss;
});
/**
 * ### xcss
 *
 * `xcss` is a safer, tokens-first approach to CSS-in-JS. It allows token-backed values for
 * CSS application.
 *
 * ```tsx
 * const styles = xcss({
 *   padding: 'space.100'
 * })
 * ```
 *
 * @deprecated Use `@atlaskit/css` with `@atlaskit/primitives/compiled` instead.
 * {@link https://hello.atlassian.net/wiki/spaces/DST/pages/4992259434/Guidance+Migrating+to+atlaskit+css+from+xcss Internal documentation for migration; no external access}
 */ parcelHelpers.export(exports, "xcss", function() {
    return xcss;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var _react = require("react");
var _react1 = require("@emotion/react");
var _styleMapsPartial = require("./style-maps.partial");
var process = require("fe3c175ba1f04d5a");
var tokensMap = {
    backgroundColor: (0, _styleMapsPartial.backgroundColorMap),
    blockSize: (0, _styleMapsPartial.dimensionMap),
    borderBlockColor: (0, _styleMapsPartial.borderColorMap),
    borderBlockEndColor: (0, _styleMapsPartial.borderColorMap),
    borderBlockEndWidth: (0, _styleMapsPartial.borderWidthMap),
    borderBlockStartColor: (0, _styleMapsPartial.borderColorMap),
    borderBlockStartWidth: (0, _styleMapsPartial.borderWidthMap),
    borderBlockWidth: (0, _styleMapsPartial.borderWidthMap),
    borderBottomColor: (0, _styleMapsPartial.borderColorMap),
    borderBottomLeftRadius: (0, _styleMapsPartial.borderRadiusMap),
    borderBottomRightRadius: (0, _styleMapsPartial.borderRadiusMap),
    borderBottomWidth: (0, _styleMapsPartial.borderWidthMap),
    borderColor: (0, _styleMapsPartial.borderColorMap),
    borderEndEndRadius: (0, _styleMapsPartial.borderRadiusMap),
    borderEndStartRadius: (0, _styleMapsPartial.borderRadiusMap),
    borderInlineColor: (0, _styleMapsPartial.borderColorMap),
    borderInlineEndColor: (0, _styleMapsPartial.borderColorMap),
    borderInlineEndWidth: (0, _styleMapsPartial.borderWidthMap),
    borderInlineStartColor: (0, _styleMapsPartial.borderColorMap),
    borderInlineStartWidth: (0, _styleMapsPartial.borderWidthMap),
    borderInlineWidth: (0, _styleMapsPartial.borderWidthMap),
    borderLeftColor: (0, _styleMapsPartial.borderColorMap),
    borderLeftWidth: (0, _styleMapsPartial.borderWidthMap),
    borderRadius: (0, _styleMapsPartial.borderRadiusMap),
    borderRightColor: (0, _styleMapsPartial.borderColorMap),
    borderRightWidth: (0, _styleMapsPartial.borderWidthMap),
    borderStartEndRadius: (0, _styleMapsPartial.borderRadiusMap),
    borderStartStartRadius: (0, _styleMapsPartial.borderRadiusMap),
    borderTopColor: (0, _styleMapsPartial.borderColorMap),
    borderTopLeftRadius: (0, _styleMapsPartial.borderRadiusMap),
    borderTopRightRadius: (0, _styleMapsPartial.borderRadiusMap),
    borderTopWidth: (0, _styleMapsPartial.borderWidthMap),
    borderWidth: (0, _styleMapsPartial.borderWidthMap),
    bottom: (0, _styleMapsPartial.allSpaceMap),
    boxShadow: (0, _styleMapsPartial.shadowMap),
    color: (0, _styleMapsPartial.textColorMap),
    columnGap: (0, _styleMapsPartial.positiveSpaceMap),
    font: (0, _styleMapsPartial.fontMap),
    fontFamily: (0, _styleMapsPartial.fontFamilyMap),
    fontWeight: (0, _styleMapsPartial.fontWeightMap),
    gap: (0, _styleMapsPartial.positiveSpaceMap),
    height: (0, _styleMapsPartial.dimensionMap),
    inlineSize: (0, _styleMapsPartial.dimensionMap),
    inset: (0, _styleMapsPartial.allSpaceMap),
    insetBlock: (0, _styleMapsPartial.allSpaceMap),
    insetBlockEnd: (0, _styleMapsPartial.allSpaceMap),
    insetBlockStart: (0, _styleMapsPartial.allSpaceMap),
    insetInline: (0, _styleMapsPartial.allSpaceMap),
    insetInlineEnd: (0, _styleMapsPartial.allSpaceMap),
    insetInlineStart: (0, _styleMapsPartial.allSpaceMap),
    left: (0, _styleMapsPartial.allSpaceMap),
    margin: (0, _styleMapsPartial.allSpaceMap),
    marginBlock: (0, _styleMapsPartial.allSpaceMap),
    marginBlockEnd: (0, _styleMapsPartial.allSpaceMap),
    marginBlockStart: (0, _styleMapsPartial.allSpaceMap),
    marginBottom: (0, _styleMapsPartial.allSpaceMap),
    marginInline: (0, _styleMapsPartial.allSpaceMap),
    marginInlineEnd: (0, _styleMapsPartial.allSpaceMap),
    marginInlineStart: (0, _styleMapsPartial.allSpaceMap),
    marginLeft: (0, _styleMapsPartial.allSpaceMap),
    marginRight: (0, _styleMapsPartial.allSpaceMap),
    marginTop: (0, _styleMapsPartial.allSpaceMap),
    maxBlockSize: (0, _styleMapsPartial.dimensionMap),
    maxHeight: (0, _styleMapsPartial.dimensionMap),
    maxInlineSize: (0, _styleMapsPartial.dimensionMap),
    maxWidth: (0, _styleMapsPartial.dimensionMap),
    minBlockSize: (0, _styleMapsPartial.dimensionMap),
    minHeight: (0, _styleMapsPartial.dimensionMap),
    minInlineSize: (0, _styleMapsPartial.dimensionMap),
    minWidth: (0, _styleMapsPartial.dimensionMap),
    opacity: (0, _styleMapsPartial.opacityMap),
    outlineColor: (0, _styleMapsPartial.borderColorMap),
    outlineOffset: (0, _styleMapsPartial.allSpaceMap),
    outlineWidth: (0, _styleMapsPartial.borderWidthMap),
    padding: (0, _styleMapsPartial.positiveSpaceMap),
    paddingBlock: (0, _styleMapsPartial.positiveSpaceMap),
    paddingBlockEnd: (0, _styleMapsPartial.positiveSpaceMap),
    paddingBlockStart: (0, _styleMapsPartial.positiveSpaceMap),
    paddingBottom: (0, _styleMapsPartial.positiveSpaceMap),
    paddingInline: (0, _styleMapsPartial.positiveSpaceMap),
    paddingInlineEnd: (0, _styleMapsPartial.positiveSpaceMap),
    paddingInlineStart: (0, _styleMapsPartial.positiveSpaceMap),
    paddingLeft: (0, _styleMapsPartial.positiveSpaceMap),
    paddingRight: (0, _styleMapsPartial.positiveSpaceMap),
    paddingTop: (0, _styleMapsPartial.positiveSpaceMap),
    right: (0, _styleMapsPartial.allSpaceMap),
    rowGap: (0, _styleMapsPartial.positiveSpaceMap),
    top: (0, _styleMapsPartial.allSpaceMap),
    width: (0, _styleMapsPartial.dimensionMap),
    zIndex: (0, _styleMapsPartial.layerMap)
};
var uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
var isSafeEnvToThrow = function() {
    return (typeof process === "undefined" ? "undefined" : (0, _typeOf._)(process)) === 'object' && (0, _typeOf._)(process.env) === 'object' && false;
};
var reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var transformStyles = function(styleObj) {
    if (!styleObj || (typeof styleObj === "undefined" ? "undefined" : (0, _typeOf._)(styleObj)) !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map(transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(param) {
        var _param = (0, _slicedToArray._)(param, 2), key = _param[0], value = _param[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) === 'object' && safeSelectors.test(key)) {
            styleObj[key] = transformStyles(value);
            return;
        }
        if (isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if (reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in tokensMap)) return;
        var tokenValue = tokensMap[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var baseXcss = function(style) {
    var transformedStyles = transformStyles(style);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, _defineProperty._)({}, uniqueSymbol, (0, _react1.css)(transformedStyles)));
};
var parseXcss = function(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = args[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var arg = _step.value;
                var _emotion;
                var result = parseXcss(arg);
                if (result.emotion) (_emotion = emotion).push.apply(_emotion, (0, _toConsumableArray._)(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    var objArgs = args;
    var _ref = objArgs || {}, styles = _ref[uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function xcss(style) {
    return baseXcss(style);
}

},{"@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_to_consumable_array":"1eSZf","@swc/helpers/_/_type_of":"iFJdx","fe3c175ba1f04d5a":"gNLf3","react":"ltHCL","@emotion/react":"cCAhJ","./style-maps.partial":"jsPtG","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aJstV":[function(require,module,exports,__globalThis) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
var _react1 = require("@emotion/react");
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
var _hasTextAncestorContext = require("../utils/has-text-ancestor-context");
var _surfaceProvider = require("../utils/surface-provider");
var _styleMapsPartial = require("../xcss/style-maps.partial");
var asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
var resetStyles = (0, _react1.css)({
    margin: 0,
    overflowWrap: 'anywhere'
});
var strongStyles = (0, _react1.css)({
    fontWeight: "var(--ds-font-weight-bold, 653)"
});
var emStyles = (0, _react1.css)({
    fontStyle: 'italic'
});
var textAlignMap = {
    center: (0, _react1.css)({
        textAlign: 'center'
    }),
    end: (0, _react1.css)({
        textAlign: 'end'
    }),
    start: (0, _react1.css)({
        textAlign: 'start'
    })
};
var truncationStyles = (0, _react1.css)({
    display: '-webkit-box',
    overflow: 'hidden',
    WebkitBoxOrient: 'vertical'
});
var wordBreakMap = {
    breakAll: (0, _react1.css)({
        wordBreak: 'break-all'
    })
};
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var useColor = function(colorProp, hasTextAncestor) {
    var surface = (0, _surfaceProvider.useSurface)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ((0, _styleMapsPartial.inverseColorMap).hasOwnProperty(surface)) return (0, _styleMapsPartial.inverseColorMap)[surface];
    return 'color.text';
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var Text = /*#__PURE__*/ (0, _react.forwardRef)(function(param, ref) {
    var tmp = param.as, Component = tmp === void 0 ? 'span' : tmp, colorProp = param.color, align = param.align, testId = param.testId, id = param.id, size = param.size, weight = param.weight, maxLines = param.maxLines, children = param.children;
    (0, _tinyInvariantDefault.default)(asAllowlist.includes(Component), '@atlaskit/primitives: Text received an invalid "as" value of "'.concat(Component, '"'));
    var hasTextAncestor = (0, _hasTextAncestorContext.useHasTextAncestor)();
    var color = useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    var component = /*#__PURE__*/ (0, _react1.jsx)(Component, {
        ref: ref,
        css: [
            resetStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            size && (0, _styleMapsPartial.textSizeStylesMap)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            color && (0, _styleMapsPartial.textColorStylesMap)[color],
            maxLines && truncationStyles,
            maxLines === 1 && wordBreakMap.breakAll,
            align && textAlignMap[align],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            weight && (0, _styleMapsPartial.textWeightStylesMap)[weight],
            Component === 'em' && emStyles,
            Component === 'strong' && strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return hasTextAncestor ? // no need to re-apply context if the text is already wrapped
    component : /*#__PURE__*/ (0, _react1.jsx)((0, _hasTextAncestorContext.HasTextAncestorProvider), {
        value: true
    }, component);
});
exports.default = Text;

},{"react":"ltHCL","@emotion/react":"cCAhJ","tiny-invariant":"9VWeJ","../utils/has-text-ancestor-context":"3E9w3","../utils/surface-provider":"iHj78","../xcss/style-maps.partial":"jsPtG","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"508Dd":[function(require,module,exports,__globalThis) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _react = require("react");
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
var _react1 = require("@emotion/react");
var _analyticsNext = require("@atlaskit/analytics-next");
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var _interactionContext = require("@atlaskit/interaction-context");
var _interactionContextDefault = parcelHelpers.interopDefault(_interactionContext);
var _styleMapsPartial = require("../xcss/style-maps.partial");
var _xcss = require("../xcss/xcss");
// This duplicates FocusRing styles from `@atlaskit/focus-ring`.
var focusRingStyles = (0, _react1.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, _styleMapsPartial.borderColorMap)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, _styleMapsPartial.positiveSpaceMap)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, _styleMapsPartial.borderWidthMap)['border.width.focused']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            outline: "".concat((0, _styleMapsPartial.borderWidthMap)['border.width'], " solid")
        }
    }
});
var baseStyles = (0, _react1.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});
var enabledStyles = (0, _react1.css)({
    cursor: 'pointer'
});
var disabledStyles = (0, _react1.css)({
    cursor: 'not-allowed'
});
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var Pressable = /*#__PURE__*/ (0, _react.forwardRef)(function(_param, ref) {
    var children = _param.children, backgroundColor = _param.backgroundColor, padding = _param.padding, paddingBlock = _param.paddingBlock, paddingBlockStart = _param.paddingBlockStart, paddingBlockEnd = _param.paddingBlockEnd, paddingInline = _param.paddingInline, paddingInlineStart = _param.paddingInlineStart, paddingInlineEnd = _param.paddingInlineEnd, isDisabled = _param.isDisabled, _param_type = _param.type, type = _param_type === void 0 ? 'button' : _param_type, tmp = _param.onClick, providedOnClick = tmp === void 0 ? (0, _noopDefault.default) : tmp, interactionName = _param.interactionName, componentName = _param.componentName, analyticsContext = _param.analyticsContext, style = _param.style, testId = _param.testId, xcss = _param.xcss, htmlAttributes = (0, _objectWithoutProperties._)(_param, [
        "children",
        "backgroundColor",
        "padding",
        "paddingBlock",
        "paddingBlockStart",
        "paddingBlockEnd",
        "paddingInline",
        "paddingInlineStart",
        "paddingInlineEnd",
        "isDisabled",
        "type",
        "onClick",
        "interactionName",
        "componentName",
        "analyticsContext",
        "style",
        "testId",
        "xcss"
    ]);
    var interactionContext = (0, _react.useContext)((0, _interactionContextDefault.default));
    var handleClick = (0, _react.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, _analyticsNext.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: undefined,
        packageVersion: undefined,
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, _objectWithoutProperties._)(htmlAttributes, [
        "className"
    ]);
    var resolvedStyles = (0, _xcss.parseXcss)(xcss);
    return /*#__PURE__*/ (0, _react1.jsx)("button", (0, _objectSpreadProps._)((0, _objectSpread._)({
        style: style,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static
    }, safeHtmlAttributes), {
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        css: [
            baseStyles,
            focusRingStyles,
            isDisabled ? disabledStyles : enabledStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, _styleMapsPartial.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, _styleMapsPartial.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, _styleMapsPartial.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, _styleMapsPartial.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, _styleMapsPartial.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, _styleMapsPartial.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, _styleMapsPartial.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, _styleMapsPartial.paddingStylesMap).paddingInlineEnd[paddingInlineEnd]
        ].concat((0, _toConsumableArray._)(resolvedStyles.emotion || [])),
        "data-testid": testId
    }), children);
});
exports.default = Pressable;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","@swc/helpers/_/_to_consumable_array":"1eSZf","react":"ltHCL","@emotion/react":"cCAhJ","@atlaskit/analytics-next":"auH4u","@atlaskit/ds-lib/noop":"2f3bg","@atlaskit/interaction-context":"4Lyu9","../xcss/style-maps.partial":"jsPtG","../xcss/xcss":"hIvbk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jyCwr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useHeading", function() {
    return useHeading;
});
var _useHeadingLevel = require("./use-heading-level");
var useHeading = function(fallback) {
    var hLevel = (0, _useHeadingLevel.useHeadingLevel)();
    /**
	 * Order here is important, we for now apply
	 * 1. inferred a11y level (this only applies if context is present)
	 * 2. default final fallback
	 */ return [
        hLevel,
        hLevel && (hLevel > 6 ? 'div' : "h".concat(hLevel)) || fallback
    ];
};

},{"./use-heading-level":"i3L5d","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"i3L5d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useHeadingLevel", function() {
    return useHeadingLevel;
});
var _react = require("react");
var _headingLevelContext = require("./heading-level-context");
var useHeadingLevel = function() {
    return (0, _react.useContext)((0, _headingLevelContext.HeadingLevelContext));
};

},{"react":"ltHCL","./heading-level-context":"fmex5","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fmex5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HeadingLevelContext", function() {
    return HeadingLevelContext;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var HeadingLevelContext = /*#__PURE__*/ (0, _react.createContext)(0);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gOcDT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_APPEARANCE", function() {
    return DEFAULT_APPEARANCE;
});
var DEFAULT_APPEARANCE = 'normal';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5Tmta":[function(require,module,exports,__globalThis) {
/* flag-actions.tsx generated by @compiled/babel-plugin v0.39.1 */ /* eslint-disable @atlaskit/design-system/no-nested-styles */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _customThemeButton = require("@atlaskit/button/custom-theme-button");
var _customThemeButtonDefault = parcelHelpers.interopDefault(_customThemeButton);
var _compiled = require("@atlaskit/primitives/compiled");
var _actionTextColor = require("./action-text-color");
var _constants = require("./constants");
var _theme = require("./theme");
var buttonStyles = null;
var fontStyles = null;
var appearanceNormalButtonStyles = null;
var appearanceNormalActionsContainerStyles = null;
var FlagActions = function(props) {
    var _props_appearance = props.appearance, appearance = _props_appearance === void 0 ? (0, _constants.DEFAULT_APPEARANCE) : _props_appearance, _props_actions = props.actions, actions = _props_actions === void 0 ? [] : _props_actions, linkComponent = props.linkComponent, testId = props.testId;
    if (!actions.length) return null;
    var isBold = appearance !== (0, _constants.DEFAULT_APPEARANCE);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: (0, _runtime.ax)([
            !isBold && "_1g4l107e _y8dn107e",
            "_11c8fhey"
        ]),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _compiled.Inline), {
            space: "space.100",
            shouldWrap: true,
            alignBlock: "center",
            separator: isBold ? undefined : "\xb7",
            testId: testId && "".concat(testId, "-actions"),
            children: actions.map(function(action, index) {
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customThemeButtonDefault.default), {
                    onClick: action.onClick,
                    href: action.href,
                    target: action.target,
                    appearance: isBold ? 'default' : 'link',
                    component: linkComponent,
                    spacing: "compact",
                    testId: action.testId,
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        '--color': (0, _actionTextColor.actionTextColor)[appearance],
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color': (0, _theme.actionBackgroundColor)[appearance].default,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color-hover': (0, _theme.actionBackgroundColor)[appearance].pressed,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color-active': (0, _theme.actionBackgroundColor)[appearance].active
                    },
                    className: (0, _runtime.ax)([
                        "_nup91zz4 _u4iq1zz4 _1w901pkf _qkwg1pkf _12r21wq8 _il101wq8 _1ku2grf3 _1v8mgrf3 _gbuigrf3 _1dwvgrf3 _1bk61a66 _1wy61a66 _b3g31a66 _eqps1a66 _ow071r31 _1p6b1r31 _8dbm1r31 _77mc1r31 _17rj8stv _1p6m8stv _5kwq8stv _1pd88stv _1iqunqa1 _1ejunqa1 _b6ztnqa1 _1rsgnqa1 _u1mb14jz _10fu17w4",
                        appearance === (0, _constants.DEFAULT_APPEARANCE) && "_1dltgrf3 _h03xgrf3 _w8sqgrf3 _1iysgrf3 _fjwrgrf3 _cwkngrf3 _1yxxgrf3 _z7cdgrf3"
                    ]),
                    children: action.content
                }, index);
            })
        })
    });
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = FlagActions;

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/button/custom-theme-button":"iQ8Ms","@atlaskit/primitives/compiled":"jhQE8","./action-text-color":"dJ80M","./constants":"gOcDT","./theme":"e9Z3r","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iQ8Ms":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Theme", function() {
    return 0, _themeDefault.default;
});
parcelHelpers.export(exports, "default", function() {
    return 0, _customThemeButtonDefault.default;
});
var _theme = require("../old-button/custom-theme-button/theme");
var _themeDefault = parcelHelpers.interopDefault(_theme);
var _customThemeButton = require("../old-button/custom-theme-button/custom-theme-button");
var _customThemeButtonDefault = parcelHelpers.interopDefault(_customThemeButton);

},{"../old-button/custom-theme-button/theme":false,"../old-button/custom-theme-button/custom-theme-button":"ktBrq","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"etwdB":[function(require,module,exports,__globalThis) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _components = require("@atlaskit/theme/components");
var _getCustomCss = require("./get-custom-css");
var Theme = (0, _components.createTheme)(function(themeProps) {
    return {
        buttonStyles: (0, _getCustomCss.getCustomCss)(themeProps),
        // No styles being applied directly to spinner by default
        // Keeping this for legacy compat. We could remove it, but given
        // that we are changing theme soon there is no point
        spinnerStyles: {}
    };
});
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = Theme;

},{"@atlaskit/theme/components":"ftkOB","./get-custom-css":"9Wneg","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ftkOB":[function(require,module,exports,__globalThis) {
/*
   This file will become the new index for theme once the codemod is mature enough.
   For now we're keeping the index file to avoid having to do a major change.
   Once the codemod is done and all the AK modules have been codeshifted, we delete index.js and rename this file to index + update all the imports
*/ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTheme", function() {
    return 0, _getThemeDefault.default;
});
parcelHelpers.export(exports, "default", function() {
    return 0, _themeDefault.default;
});
parcelHelpers.export(exports, "createTheme", function() {
    return 0, _createTheme.createTheme;
});
var _getTheme = require("./utils/get-theme");
var _getThemeDefault = parcelHelpers.interopDefault(_getTheme);
var _theme = require("./components/theme");
var _themeDefault = parcelHelpers.interopDefault(_theme);
var _createTheme = require("./utils/create-theme");

},{"./utils/get-theme":false,"./components/theme":"5VDwZ","./utils/create-theme":"g5wQI","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5VDwZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGlobalTheme", function() {
    return useTheme;
});
var _createTheme = require("../utils/create-theme");
// Create default global light theme
var dest = (0, _createTheme.createTheme)(function() {
    return {
        mode: 'light'
    };
});
var Provider = dest.Provider;
var Consumer = dest.Consumer;
var useTheme = dest.useTheme;
var Theme = {
    Provider: Provider,
    Consumer: Consumer
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = Theme;

},{"../utils/create-theme":"g5wQI","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"g5wQI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * createTheme is used to create a set of Providers and Consumers for theming components.
 * - Takes a default theme function; this theme function gets a set of props, and returns tokens
 *  based on those props. An example of this default theme function is one that produces the standard
 *  appearance of the component
 * - Returns three things - a Provider that allow for additional themes to be applied, a Consumer
 *  that can get the current theme and fetch it, and a custom hook - useTheme which provides an alternate (although functionally the same) API
 *  to the Consumer.
 */ parcelHelpers.export(exports, "createTheme", function() {
    return createTheme;
});
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function createTheme(defaultGetTokens) {
    var emptyThemeFn = function(getTokens, props) {
        return getTokens(props);
    };
    /**
	 * Internally, Theme uses React Context, with internal providers and consumers.
	 * The React Context passes only a function that gets props, and turns them into tokens. This
	 * function gets mixed as more Providers with their own themes are added. This mixed function
	 * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
	 * the theme.
	 */ var ThemeContext = /*#__PURE__*/ (0, _react.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, _react.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, _objectWithoutProperties._)(props, [
            "children"
        ]);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
            children: children(tokens)
        });
    }
    /**
	 * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
	 * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
	 * - The getTokens function isn't called immediately - instead the props are passed
	 *    through a mix of parent theming functions
	 * Children of this provider will receive this mixed theme
	 */ function Provider(props) {
        var themeFn = (0, _react.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, _react.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ThemeContext.Provider, {
            value: mixedFn,
            children: props.children
        });
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

},{"@swc/helpers/_/_object_without_properties":"6HqIM","react/jsx-runtime":"bGvcw","react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9Wneg":[function(require,module,exports,__globalThis) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Mapping the new clean css back to the legacy theme format.
// The legacy theme format has all styles at the top level (no nested selectors)
// and uses `getSpecifiers()` to apply the style to all pseudo states
parcelHelpers.export(exports, "getCustomCss", function() {
    return getCustomCss;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _getCss = require("../shared/get-css");
var stateToSelectorMap = {
    focus: '&:focus',
    focusSelected: '&:focus',
    hover: '&:hover',
    active: '&:active',
    disabled: '&[disabled]'
};
function getCustomCss(param) {
    var _param_appearance = param.appearance, appearance = _param_appearance === void 0 ? 'default' : _param_appearance, _param_spacing = param.spacing, spacing = _param_spacing === void 0 ? 'default' : _param_spacing, _param_isSelected = param.isSelected, isSelected = _param_isSelected === void 0 ? false : _param_isSelected, _param_shouldFitContainer = param.shouldFitContainer, shouldFitContainer = _param_shouldFitContainer === void 0 ? false : _param_shouldFitContainer, _param_iconIsOnlyChild = param.iconIsOnlyChild, iconIsOnlyChild = _param_iconIsOnlyChild === void 0 ? false : _param_iconIsOnlyChild, _param_isLoading = param.isLoading, isLoading = _param_isLoading === void 0 ? false : _param_isLoading, state = param.state;
    var result = (0, _getCss.getCss)({
        appearance: appearance,
        spacing: spacing,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        isOnlySingleIcon: iconIsOnlyChild
    });
    // we need to disable the default browser focus styles always
    // this is because we are not expressing that we can have two pseudo states at a time
    result.outline = 'none';
    // Pulling relevant styles up to the top level
    var selector = stateToSelectorMap[state];
    if (selector) result = (0, _objectSpread._)({}, result, result[selector]);
    if (isLoading) result = (0, _objectSpread._)({}, result, result['&[data-has-overlay="true"]']);
    // Delete all selectors and just keep root styles
    Object.keys(result).forEach(function(key) {
        // want to keep this one
        if (key === '&::-moz-focus-inner') return;
        // Not using .startsWith for ie11
        if (key.indexOf('&') === 0) delete result[key];
    });
    return result;
}

},{"@swc/helpers/_/_object_spread":"9gdrV","../shared/get-css":"34ado","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"34ado":[function(require,module,exports,__globalThis) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCss", function() {
    return getCss;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var gridSize = 8;
var HAS_DISABLED_BACKGROUND = [
    'default',
    'primary',
    'danger',
    'warning'
];
var heights = {
    default: "".concat(32 / 14, "em"),
    // 32px
    compact: "".concat(24 / 14, "em"),
    none: 'auto'
};
var lineHeights = {
    default: heights.default,
    compact: heights.compact,
    none: 'inherit'
};
var padding = {
    // 10px gutter
    default: "0 ".concat(gridSize + gridSize / 4, "px"),
    compact: "0 ".concat(gridSize + gridSize / 4, "px"),
    none: '0'
};
var singleIconPadding = {
    // 2px gutter
    compact: "0 ".concat(gridSize / 4, "px"),
    default: "0 ".concat(gridSize / 4, "px"),
    none: '0'
};
var verticalAlign = {
    default: 'middle',
    compact: 'middle',
    none: 'baseline'
};
var defaultAfterStyles = {
    borderRadius: 'inherit',
    inset: "var(--ds-space-0, 0px)",
    borderStyle: 'solid',
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: 'none',
    position: 'absolute'
};
var defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #292A2E)",
    '&::after': (0, _objectSpreadProps._)((0, _objectSpread._)({}, defaultAfterStyles), {
        content: '""',
        borderColor: "var(--ds-border, #0B120E24)"
    }),
    '&:hover': {
        background: "var(--ds-background-neutral-hovered, #0B120E24)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-pressed, #080F214A)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:active': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    }
};
var primaryStyles = {
    background: "var(--ds-background-brand-bold, #1868DB)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-brand-bold-hovered, #1558BC)"
    },
    '&:active': {
        background: "var(--ds-background-brand-bold-pressed, #144794)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-brand-bold, #1868DB)"
    }
};
var linkStyles = {
    background: 'transparent',
    color: "var(--ds-link, #1868DB)",
    '&:hover': {
        color: "var(--ds-link, #1868DB)",
        textDecoration: 'underline'
    },
    '&:active': {
        color: "var(--ds-link-pressed, #1558BC)",
        textDecoration: 'underline'
    }
};
var subtleStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-subtle-pressed, #0B120E24)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: 'transparent'
    }
};
var subtleLinkStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: 'transparent',
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'underline'
    },
    '&:active': {
        background: 'transparent',
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'underline'
    }
};
var warningStyles = {
    background: "var(--ds-background-warning-bold, #FBC828)",
    color: "var(--ds-text-warning-inverse, #292A2E)",
    '&:hover': {
        background: "var(--ds-background-warning-bold-hovered, #FCA700)"
    },
    '&:active': {
        background: "var(--ds-background-warning-bold-pressed, #F68909)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-warning-bold, #FBC828)"
    }
};
var dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)"
    },
    '&:active': {
        background: "var(--ds-background-danger-bold-pressed, #872821)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-danger-bold, #C9372C)"
    }
};
var selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FE)",
    color: "var(--ds-text-selected, #1868DB)",
    '&:not([disabled])::after': (0, _objectSpreadProps._)((0, _objectSpread._)({}, defaultAfterStyles), {
        content: '""',
        borderColor: "var(--ds-border-selected, #1868DB)"
    })
};
var hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: 'default',
        textDecoration: 'none'
    }
};
function getCss(param) {
    var appearance = param.appearance, spacing = param.spacing, isSelected = param.isSelected, shouldFitContainer = param.shouldFitContainer, isOnlySingleIcon = param.isOnlySingleIcon;
    return (0, _objectSpreadProps._)((0, _objectSpread._)({
        // 0px margin added to css-reset
        alignItems: 'baseline',
        borderWidth: 0,
        borderRadius: (0, _platformFeatureFlags.fg)('platform-dst-shape-theme-default') ? "var(--ds-radius-medium, 6px)" : "var(--ds-radius-small, 3px)",
        boxSizing: 'border-box',
        display: 'inline-flex',
        fontSize: 'inherit',
        fontStyle: 'normal',
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: 'inherit',
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // margin for button has been applied to css reset
        maxWidth: '100%',
        // Needed to position overlay
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        height: heights[spacing],
        lineHeight: lineHeights[spacing],
        padding: isOnlySingleIcon ? singleIconPadding[spacing] : padding[spacing],
        verticalAlign: verticalAlign[spacing],
        width: shouldFitContainer ? '100%' : 'auto',
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: 'center'
    }, isSelected ? selectedStyles : (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, appearance === 'default' && defaultStyles, appearance === 'primary' && primaryStyles, appearance === 'link' && linkStyles, appearance === 'subtle' && subtleStyles, appearance === 'subtle-link' && subtleLinkStyles, appearance === 'warning' && warningStyles, appearance === 'danger' && dangerStyles), {
        '&[disabled]': {
            color: "var(--ds-text-disabled, #080F214A)",
            backgroundColor: HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #17171708)" : 'transparent',
            cursor: 'not-allowed',
            textDecoration: 'none',
            '&:hovered': {
                backgroundColor: HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #17171708)" : 'transparent'
            },
            '&:active': {
                backgroundColor: HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #17171708)" : 'transparent'
            }
        }
    }), hasOverlayStyles)), {
        '&::-moz-focus-inner': {
            border: 0,
            margin: 0,
            padding: 0
        }
    });
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@atlaskit/platform-feature-flags":"kO5t9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ktBrq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _components = require("@atlaskit/theme/components");
var _componentsDefault = parcelHelpers.interopDefault(_components);
var _buttonBase = require("../shared/button-base");
var _buttonBaseDefault = parcelHelpers.interopDefault(_buttonBase);
var _getIsOnlySingleIcon = require("../shared/get-is-only-single-icon");
var _getIsOnlySingleIconDefault = parcelHelpers.interopDefault(_getIsOnlySingleIcon);
var _loadingSpinner = require("../shared/loading-spinner");
var _loadingSpinnerDefault = parcelHelpers.interopDefault(_loadingSpinner);
var _defaultThemeFn = require("./default-theme-fn");
var _getSpecifiers = require("./get-specifiers");
var _theme = require("./theme");
var _themeDefault = parcelHelpers.interopDefault(_theme);
function getInteractionState(param) {
    var _param_isDisabled = param.isDisabled, isDisabled = _param_isDisabled === void 0 ? false : _param_isDisabled, _param_isActive = param.isActive, isActive = _param_isActive === void 0 ? false : _param_isActive, _param_isFocus = param.isFocus, isFocus = _param_isFocus === void 0 ? false : _param_isFocus, _param_isHover = param.isHover, isHover = _param_isHover === void 0 ? false : _param_isHover, _param_isSelected = param.isSelected, isSelected = _param_isSelected === void 0 ? false : _param_isSelected, _param_isLoading = param.isLoading, isLoading = _param_isLoading === void 0 ? false : _param_isLoading;
    if (isDisabled) return 'disabled';
    if (isSelected && isFocus) return 'focusSelected';
    if (isSelected) return 'selected';
    // not allowing active or focus style changes while loading
    if (!isLoading && isActive) return 'active';
    if (!isLoading && isHover) return 'hover';
    if (isFocus) return 'focus';
    return 'default';
}
var initial = {
    isHover: false,
    isActive: false,
    isFocus: false
};
/**
 * __Custom theme button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A custom theme button. Avoid using this component. It exists for those already using custom theming, which is hard to use and has performance issues.
 *
 * - [Examples](https://atlassian.design/components/button/examples#custom-theme-button)
 */ var CustomThemeButton = /*#__PURE__*/ (0, _reactDefault.default).memo(/*#__PURE__*/ (0, _reactDefault.default).forwardRef(function CustomThemeButton(_param, ref) {
    var _param_appearance = _param.// Calculate default props for use in custom themes
    appearance, appearance = _param_appearance === void 0 ? 'default' : _param_appearance, _param_autoFocus = _param.autoFocus, autoFocus = _param_autoFocus === void 0 ? false : _param_autoFocus, _param_isDisabled = _param.isDisabled, isDisabled = _param_isDisabled === void 0 ? false : _param_isDisabled, _param_isSelected = _param.isSelected, isSelected = _param_isSelected === void 0 ? false : _param_isSelected, _param_shouldFitContainer = _param.shouldFitContainer, shouldFitContainer = _param_shouldFitContainer === void 0 ? false : _param_shouldFitContainer, _param_spacing = _param.spacing, spacing = _param_spacing === void 0 ? 'default' : _param_spacing, _param_isLoading = _param.isLoading, isLoading = _param_isLoading === void 0 ? false : _param_isLoading, providedOnMouseEnter = _param.onMouseEnter, providedOnMouseLeave = _param.onMouseLeave, providedOnMouseDown = _param.onMouseDown, providedOnMouseUp = _param.onMouseUp, providedOnFocus = _param.onFocus, providedOnBlur = _param.onBlur, _param_theme = _param.theme, theme = _param_theme === void 0 ? (0, _defaultThemeFn.defaultThemeFn) : _param_theme, rest = (0, _objectWithoutProperties._)(_param, [
        "appearance",
        "autoFocus",
        "isDisabled",
        "isSelected",
        "shouldFitContainer",
        "spacing",
        "isLoading",
        "onMouseEnter",
        "onMouseLeave",
        "onMouseDown",
        "onMouseUp",
        "onFocus",
        "onBlur",
        "theme"
    ]);
    // TODO is there a nicer way to do this?
    // Add default props back into object for spreading
    var restProps = (0, _objectSpread._)({
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing
    }, rest);
    var _useState = (0, _slicedToArray._)((0, _react.useState)(initial), 2), state = _useState[0], setState = _useState[1];
    var onMouseEnter = (0, _react.useCallback)(function(event) {
        setState(function(current) {
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, current), {
                isHover: true
            });
        });
        if (providedOnMouseEnter) providedOnMouseEnter(event);
    }, [
        providedOnMouseEnter
    ]);
    var onMouseLeave = (0, _react.useCallback)(function(event) {
        setState(function(current) {
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, current), {
                isHover: false,
                isActive: false
            });
        });
        if (providedOnMouseLeave) providedOnMouseLeave(event);
    }, [
        providedOnMouseLeave
    ]);
    var onMouseDown = (0, _react.useCallback)(function(event) {
        setState(function(current) {
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, current), {
                isActive: true
            });
        });
        if (providedOnMouseDown) providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    var onMouseUp = (0, _react.useCallback)(function(event) {
        setState(function(current) {
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, current), {
                isActive: false
            });
        });
        if (providedOnMouseUp) providedOnMouseUp(event);
    }, [
        providedOnMouseUp
    ]);
    var onFocus = (0, _react.useCallback)(function(event) {
        setState(function(current) {
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, current), {
                isFocus: true
            });
        });
        if (providedOnFocus) providedOnFocus(event);
    }, [
        providedOnFocus
    ]);
    var onBlur = (0, _react.useCallback)(function(event) {
        setState(function(current) {
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, current), {
                isFocus: false
            });
        });
        if (providedOnBlur) providedOnBlur(event);
    }, [
        providedOnBlur
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _themeDefault.default).Provider, {
        value: theme,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _componentsDefault.default).Consumer, {
            children: function(param) {
                var mode = param.mode;
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _themeDefault.default).Consumer, (0, _objectSpreadProps._)((0, _objectSpread._)({
                    mode: mode,
                    state: getInteractionState((0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                        isLoading: isLoading,
                        isSelected: restProps.isSelected,
                        isDisabled: restProps.isDisabled
                    })),
                    iconIsOnlyChild: (0, _getIsOnlySingleIconDefault.default)(restProps),
                    isLoading: isLoading
                }, restProps), {
                    children: function(param) {
                        var buttonStyles = param.buttonStyles;
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonBaseDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, restProps), {
                            ref: ref,
                            overlay: isLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loadingSpinnerDefault.default), (0, _objectSpread._)({}, restProps)) : null,
                            // No need to render aria-disabled when it is false
                            "aria-disabled": isLoading || restProps['aria-disabled'],
                            onMouseEnter: onMouseEnter,
                            onMouseLeave: onMouseLeave,
                            onMouseDown: onMouseDown,
                            onMouseUp: onMouseUp,
                            onFocus: onFocus,
                            onBlur: onBlur,
                            buttonCss: (0, _getSpecifiers.getSpecifiers)(buttonStyles)
                        }));
                    }
                }));
            }
        })
    });
}));
// Tools including enzyme rely on components having a display name
CustomThemeButton.displayName = 'CustomThemeButton';
exports.default = CustomThemeButton;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","@swc/helpers/_/_sliced_to_array":"8PtL6","react/jsx-runtime":"bGvcw","react":"ltHCL","@atlaskit/theme/components":"ftkOB","../shared/button-base":"7LoHE","../shared/get-is-only-single-icon":"icn9U","../shared/loading-spinner":"9QmIR","./default-theme-fn":"kZEd8","./get-specifiers":"gSv04","./theme":"etwdB","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7LoHE":[function(require,module,exports,__globalThis) {
/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
var _react1 = require("@emotion/react");
var _analyticsNext = require("@atlaskit/analytics-next");
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var _useAutoFocus = require("@atlaskit/ds-lib/use-auto-focus");
var _useAutoFocusDefault = parcelHelpers.interopDefault(_useAutoFocus);
var _focusRing = require("@atlaskit/focus-ring");
var _focusRingDefault = parcelHelpers.interopDefault(_focusRing);
// eslint-disable-next-line no-duplicate-imports
var _interactionContext = require("@atlaskit/interaction-context");
var _interactionContextDefault = parcelHelpers.interopDefault(_interactionContext);
var _blockEvents = require("./block-events");
var _blockEventsDefault = parcelHelpers.interopDefault(_blockEvents);
var _getContentStyle = require("./get-content-style");
var _getFadingCss = require("./get-fading-css");
var _getIconStyle = require("./get-icon-style");
var _getIfVisuallyHiddenChildren = require("./get-if-visually-hidden-children");
var _overlayCss = require("./overlay-css");
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
var noPointerEventsOnChildrenCss = {
    '> *': {
        pointerEvents: 'none'
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform-visual-refresh-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ var iconBeforeSpacingFixStyle = (0, _react1.css)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-025, 2px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-negative-025, -2px)"
});
var iconAfterSpacingFixStyle = (0, _react1.css)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-050, 4px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-025, 2px)",
    marginInlineEnd: "var(--ds-space-negative-025, -2px)"
});
var getSpacingFix = function(children, spacingStyles) {
    if (!children || (0, _getIfVisuallyHiddenChildren.getIfVisuallyHiddenChildren)(children)) return null;
    return spacingStyles;
};
var getChildren = function(children, childrenStyles) {
    if ((0, _getIfVisuallyHiddenChildren.getIfVisuallyHiddenChildren)(children)) return children;
    return children ? /*#__PURE__*/ (0, _react1.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
var ButtonBase = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(function ButtonBase(props, ref) {
    var // I don't think analytics should be in button, but for now it is
    analyticsContext = props.analyticsContext, _props_appearance = props.appearance, appearance = _props_appearance === void 0 ? 'default' : _props_appearance, _props_autoFocus = props.autoFocus, autoFocus = _props_autoFocus === void 0 ? false : _props_autoFocus, buttonCss = props.buttonCss, children = props.children, className = props.className, href = props.href, tmp = props.// use the provided component prop,
    // else default to anchor if there is a href, and button if there is no href
    component, Component = tmp === void 0 ? href ? 'a' : 'button' : tmp, iconAfter = props.iconAfter, iconBefore = props.iconBefore, interactionName = props.interactionName, _props_isDisabled = props.isDisabled, isDisabled = _props_isDisabled === void 0 ? false : _props_isDisabled, _props_isSelected = props.isSelected, isSelected = _props_isSelected === void 0 ? false : _props_isSelected, onBlur = props.onBlur, tmp1 = props.onClick, providedOnClick = tmp1 === void 0 ? (0, _noopDefault.default) : tmp1, onFocus = props.onFocus, tmp2 = props.onMouseDown, providedOnMouseDown = tmp2 === void 0 ? (0, _noopDefault.default) : tmp2, overlay = props.overlay, // Pulling out so it doesn't spread on rendered component
    shouldFitContainer = props.shouldFitContainer, _props_spacing = props.spacing, spacing = _props_spacing === void 0 ? 'default' : _props_spacing, _props_tabIndex = props.tabIndex, tabIndex = _props_tabIndex === void 0 ? 0 : _props_tabIndex, _props_type = props.type, type = _props_type === void 0 ? !href ? 'button' : undefined : _props_type, testId = props.testId, rest = (0, _objectWithoutProperties._)(props, [
        "analyticsContext",
        "appearance",
        "autoFocus",
        "buttonCss",
        "children",
        "className",
        "href",
        "component",
        "iconAfter",
        "iconBefore",
        "interactionName",
        "isDisabled",
        "isSelected",
        "onBlur",
        "onClick",
        "onFocus",
        "onMouseDown",
        "overlay",
        "shouldFitContainer",
        "spacing",
        "tabIndex",
        "type",
        "testId"
    ]);
    var ourRef = (0, _react.useRef)();
    var setRef = (0, _react.useCallback)(function(node) {
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === 'function') {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, _useAutoFocusDefault.default)(ourRef, autoFocus);
    var interactionContext = (0, _react.useContext)((0, _interactionContextDefault.default));
    var handleClick = (0, _react.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, _analyticsNext.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: 'button',
        packageName: undefined,
        packageVersion: undefined,
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    var onMouseDown = (0, _react.useCallback)(function(event) {
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, _react.useEffect)(function() {
        var el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    var hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    var fadeStyles = (0, _react1.css)((0, _getFadingCss.getFadingCss)({
        hasOverlay: hasOverlay
    }));
    var isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === 'warning') spinnerHackCss = {
        '[data-theme] & circle': {
            stroke: "".concat(isSelected || isDisabled ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-warning-inverse, #292A2E)", " !important")
        }
    };
    return /*#__PURE__*/ (0, _react1.jsx)((0, _focusRingDefault.default), null, /*#__PURE__*/ (0, _react1.jsx)(Component, (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, rest), {
        ref: setRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : noPointerEventsOnChildrenCss
        ],
        // using undefined so that the property doesn't exist when false
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        // Adding a tab index so element is always focusable, even when not a <button> or <a>
        // Disabling focus via keyboard navigation when disabled
        // as this is standard button behaviour
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }), (0, _blockEventsDefault.default)({
        isInteractive: isInteractive
    })), iconBefore ? /*#__PURE__*/ (0, _react1.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, _getIconStyle.getIconStyle)({
                spacing: spacing
            }),
            getSpacingFix(children, iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, getChildren(children, [
        fadeStyles,
        (0, _getContentStyle.getContentStyle)({
            spacing: spacing
        })
    ]), iconAfter ? /*#__PURE__*/ (0, _react1.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, _getIconStyle.getIconStyle)({
                spacing: spacing
            }),
            getSpacingFix(children, iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? /*#__PURE__*/ (0, _react1.jsx)("span", {
        css: [
            (0, _overlayCss.overlayCss),
            spinnerHackCss
        ]
    }, overlay) : null));
});
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = ButtonBase;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","@emotion/react":"cCAhJ","@atlaskit/analytics-next":"auH4u","@atlaskit/ds-lib/noop":"2f3bg","@atlaskit/ds-lib/use-auto-focus":"2jsXQ","@atlaskit/focus-ring":"c5RUk","@atlaskit/interaction-context":"4Lyu9","./block-events":"ba3s3","./get-content-style":"aevS3","./get-fading-css":"5eazp","./get-icon-style":"2KJAQ","./get-if-visually-hidden-children":"jN0s6","./overlay-css":"kSsMk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"c5RUk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return 0, _focusRingDefault.default;
});
parcelHelpers.export(exports, "useFocusRing", function() {
    return 0, _useFocusRingDefault.default;
});
var _focusRing = require("./focus-ring");
var _focusRingDefault = parcelHelpers.interopDefault(_focusRing);
var _useFocusRing = require("./use-focus-ring");
var _useFocusRingDefault = parcelHelpers.interopDefault(_useFocusRing);

},{"./focus-ring":"3lhMg","./use-focus-ring":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3lhMg":[function(require,module,exports,__globalThis) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
var _react1 = require("@emotion/react");
var BORDER_WIDTH = 2;
var baseFocusOutsideStyles = (0, _react1.css)({
    outline: "var(--ds-border-width-focused, 2px) solid var(--ds-border-focused, #4688EC)",
    outlineOffset: BORDER_WIDTH
});
var baseInsetStyles = (0, _react1.css)({
    outlineColor: "var(--ds-border-focused, #4688EC)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -BORDER_WIDTH,
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width-focused, 2px)"
});
var focusRingStyles = (0, _react1.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: "var(--ds-border-width, 1px) solid"
        }
    }
});
var insetFocusRingStyles = (0, _react1.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: "var(--ds-border-width, 1px) solid",
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: '-1px'
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ var FocusRing = /*#__PURE__*/ (0, _react.memo)(function(param) {
    var children = param.children, isInset = param.isInset, focus = param.focus;
    var controlledStyles = isInset ? baseInsetStyles : baseFocusOutsideStyles;
    var uncontrolledStyles = isInset ? insetFocusRingStyles : focusRingStyles;
    var focusCls = typeof focus === 'undefined' ? uncontrolledStyles : focus === 'on' && controlledStyles;
    return /*#__PURE__*/ (0, _react1.jsx)((0, _react1.ClassNames), null, function(param) {
        var _$css = param.css, cx = param.cx;
        return (0, _react.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? // eslint-disable-next-line @repo/internal/react/no-clone-element
        /*#__PURE__*/ (0, _react.cloneElement)(children, {
            className: cx([
                _$css(focusCls),
                children.props.className
            ])
        }) : children);
    });
});
FocusRing.displayName = 'FocusRing';
exports.default = FocusRing;

},{"react":"ltHCL","@emotion/react":"cCAhJ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ba3s3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return blockEvents;
});
function abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var tabKeyCode = 9;
function onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === tabKeyCode) return;
    abort(event);
}
var block = {
    onMouseDownCapture: abort,
    onMouseUpCapture: abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: onKey,
    onKeyUpCapture: onKey,
    onTouchStartCapture: abort,
    onTouchEndCapture: abort,
    onPointerDownCapture: abort,
    onPointerUpCapture: abort,
    onClickCapture: abort,
    // Just smashing the existing onClick for good measure
    onClick: abort
};
var doNotBlock = {};
function blockEvents(param) {
    var isInteractive = param.isInteractive;
    return isInteractive ? doNotBlock : block;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aevS3":[function(require,module,exports,__globalThis) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getContentStyle", function() {
    return getContentStyle;
});
var _react = require("@emotion/react");
function getContentStyle(param) {
    var spacing = param.spacing;
    return (0, _react.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : '0 2px',
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
}

},{"@emotion/react":"cCAhJ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5eazp":[function(require,module,exports,__globalThis) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFadingCss", function() {
    return getFadingCss;
});
var _react = require("@emotion/react");
function getFadingCss(param) {
    var hasOverlay = param.hasOverlay;
    return (0, _react.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: 'opacity 0.3s'
    });
}

},{"@emotion/react":"cCAhJ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2KJAQ":[function(require,module,exports,__globalThis) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getIconStyle", function() {
    return getIconStyle;
});
var _react = require("@emotion/react");
function getIconStyle(param) {
    var spacing = param.spacing;
    return (0, _react.css)({
        display: 'flex',
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : "0 2px",
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'center',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        userSelect: 'none'
    });
}

},{"@emotion/react":"cCAhJ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jN0s6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getIfVisuallyHiddenChildren", function() {
    return getIfVisuallyHiddenChildren;
});
var _react = require("react");
var _visuallyHidden = require("@atlaskit/visually-hidden");
var _visuallyHiddenDefault = parcelHelpers.interopDefault(_visuallyHidden);
var getIfVisuallyHiddenChildren = function(children) {
    return children && /*#__PURE__*/ (0, _react.isValidElement)(children) && children.type === (0, _visuallyHiddenDefault.default);
};

},{"react":"ltHCL","@atlaskit/visually-hidden":"lj6Zq","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kSsMk":[function(require,module,exports,__globalThis) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "overlayCss", function() {
    return overlayCss;
});
var overlayCss = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"icn9U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getIsOnlySingleIcon;
});
var _getIfVisuallyHiddenChildren = require("./get-if-visually-hidden-children");
function getIsOnlySingleIcon(param) {
    var children = param.children, iconBefore = param.iconBefore, iconAfter = param.iconAfter;
    if ((0, _getIfVisuallyHiddenChildren.getIfVisuallyHiddenChildren)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}

},{"./get-if-visually-hidden-children":"jN0s6","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9QmIR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return LoadingSpinner;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _spinner = require("@atlaskit/spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
function getSpinnerAppearance(param) {
    var appearance = param.appearance, isDisabled = param.isDisabled, isSelected = param.isSelected;
    if (isDisabled) return 'inherit';
    if (isSelected) return 'invert';
    if (appearance === 'primary' || appearance === 'danger') return 'invert';
    return 'inherit';
}
function LoadingSpinner(param) {
    var appearance = param.appearance, isDisabled = param.isDisabled, isSelected = param.isSelected, _param_spacing = param.spacing, spacing = _param_spacing === void 0 ? 'default' : _param_spacing;
    var size = spacing === 'default' ? 'medium' : 'small';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {
        size: size,
        label: ", Loading",
        appearance: getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","@atlaskit/spinner":"04ZYE","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kZEd8":[function(require,module,exports,__globalThis) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultThemeFn", function() {
    return defaultThemeFn;
});
function defaultThemeFn(current, values) {
    return current(values);
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gSv04":[function(require,module,exports,__globalThis) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// This styling approach works by generating a 'style' and applying with maximum specificity
// To do this we are overwriting all pseudo selectors
parcelHelpers.export(exports, "getSpecifiers", function() {
    return getSpecifiers;
});
function getSpecifiers(styles) {
    return {
        '&, &:hover, &:active, &:focus, &:focus-visible, &:visited, &:disabled, &[disabled]': styles
    };
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dJ80M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "actionTextColor", function() {
    return actionTextColor;
});
var actionTextColor = {
    success: "var(--ds-text-inverse, #FFFFFF)",
    info: "var(--ds-text-inverse, #FFFFFF)",
    error: "var(--ds-text-inverse, #FFFFFF)",
    warning: "var(--ds-text-warning-inverse, #292A2E)",
    normal: "var(--ds-link, #1868DB)"
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"e9Z3r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "flagBackgroundColor", function() {
    return 0, _flagBackgroundColor.flagBackgroundColor;
});
parcelHelpers.export(exports, "flagIconColor", function() {
    return 0, _flagIconColor.flagIconColor;
});
parcelHelpers.export(exports, "flagIconGlyph", function() {
    return 0, _flagIconGlyph.flagIconGlyph;
});
parcelHelpers.export(exports, "flagTextColor", function() {
    return 0, _flagTextColor.flagTextColor;
});
parcelHelpers.export(exports, "flagTextColorToken", function() {
    return 0, _flagTextColorToken.flagTextColorToken;
});
parcelHelpers.export(exports, "actionTextColor", function() {
    return 0, _actionTextColor.actionTextColor;
});
parcelHelpers.export(exports, "actionBackgroundColor", function() {
    return actionBackgroundColor;
});
var _flagBackgroundColor = require("./flag-background-color");
var _flagIconColor = require("./flag-icon-color");
var _flagIconGlyph = require("./flag-icon-glyph");
var _flagTextColor = require("./flag-text-color");
var _flagTextColorToken = require("./flag-text-color-token");
var _actionTextColor = require("./action-text-color");
var actionBackgroundColor = {
    success: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    info: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    error: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    warning: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    normal: {
        default: 'none',
        active: 'none',
        pressed: 'none'
    }
};

},{"./flag-background-color":false,"./flag-icon-color":false,"./flag-icon-glyph":false,"./flag-text-color":false,"./flag-text-color-token":false,"./action-text-color":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hDj5f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "flagBackgroundColor", function() {
    return flagBackgroundColor;
});
var flagBackgroundColor = {
    error: 'color.background.danger.bold',
    info: 'color.background.neutral.bold',
    normal: 'elevation.surface.overlay',
    success: 'color.background.success.bold',
    warning: 'color.background.warning.bold'
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hndBM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "flagIconColor", function() {
    return flagIconColor;
});
var flagIconColor = {
    error: "var(--ds-icon-inverse, #FFFFFF)",
    info: "var(--ds-icon-inverse, #FFFFFF)",
    normal: "var(--ds-icon-subtle, #505258)",
    success: "var(--ds-icon-inverse, #FFFFFF)",
    warning: "var(--ds-icon-warning-inverse, #292A2E)"
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"f3Owk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "flagIconGlyph", function() {
    return flagIconGlyph;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _statusError = require("@atlaskit/icon/core/status-error");
var _statusErrorDefault = parcelHelpers.interopDefault(_statusError);
var _statusInformation = require("@atlaskit/icon/core/status-information");
var _statusInformationDefault = parcelHelpers.interopDefault(_statusInformation);
var _statusSuccess = require("@atlaskit/icon/core/status-success");
var _statusSuccessDefault = parcelHelpers.interopDefault(_statusSuccess);
var _statusWarning = require("@atlaskit/icon/core/status-warning");
var _statusWarningDefault = parcelHelpers.interopDefault(_statusWarning);
var flagIconGlyph = {
    error: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusErrorDefault.default), {
        label: ""
    }),
    info: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusInformationDefault.default), {
        label: ""
    }),
    normal: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusInformationDefault.default), {
        label: ""
    }),
    success: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusSuccessDefault.default), {
        label: ""
    }),
    warning: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusWarningDefault.default), {
        label: ""
    })
};

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","@atlaskit/icon/core/status-error":"gJMKC","@atlaskit/icon/core/status-information":"631pM","@atlaskit/icon/core/status-success":"4HNQp","@atlaskit/icon/core/status-warning":"h2k3M","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gJMKC":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f93f06e22108e36edaead143b4f646b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("6c306b77bdeedec7"));
var _baseNew = _interopRequireDefault(require("9256d019d2a0d999"));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ var StatusErrorIcon = function(props) {
    return /*#__PURE__*/ _react.default.createElement(_baseNew.default, Object.assign({
        name: "StatusErrorIcon",
        dangerouslySetGlyph: '<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>'
    }, props));
};
StatusErrorIcon.displayName = 'StatusErrorIcon';
var _default = exports.default = StatusErrorIcon;

},{"6c306b77bdeedec7":"ltHCL","9256d019d2a0d999":"kuGeY"}],"kuGeY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return 0, _iconNewDefault.default;
});
parcelHelpers.export(exports, "Icon", function() {
    return 0, _iconNew.Icon;
});
var _iconNew = require("../components/icon-new");
var _iconNewDefault = parcelHelpers.interopDefault(_iconNew);

},{"../components/icon-new":"hlhjH","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hlhjH":[function(require,module,exports,__globalThis) {
/* icon-new.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Icon", function() {
    return Icon;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var svgStyles = null;
var iconStyles = null;
var smallIconStyles = null;
var scaleStyles = null;
/**
 * For windows high contrast mode
 */ var baseHcmStyles = null;
var scaleSize = null;
var coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var Icon = /*#__PURE__*/ (0, _react.memo)(function Icon(props) {
    var _props_color = props.color, color = _props_color === void 0 ? 'currentColor' : _props_color, testId = props.testId, label = props.label, // Used to set icon dimensions/behaviour in codegen
    // Used to set icon glyphs in codegen
    dangerouslySetGlyph = props.dangerouslySetGlyph, // Used with iconTile to scale icon up and down
    shouldScale = props.shouldScale, _props_spacing = props.spacing, spacing = _props_spacing === void 0 ? 'none' : _props_spacing, name = props.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, _runtime.ax)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ]),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
            fill: "none",
            // Adjusting the viewBox allows the icon padding to scale with the contents of the SVG, which
            // we want for Icon Tile
            viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
            role: "presentation",
            dangerouslySetInnerHTML: dangerouslySetInnerHTML,
            className: (0, _runtime.ax)([
                "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
                shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? coreSizeSmall[spacing] : coreSizeMedium[spacing]
            ])
        })
    });
});
exports.default = Icon;

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"631pM":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::456639fbdc991aefe1af05acf697365d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("98a74d7ce1d14bc3"));
var _baseNew = _interopRequireDefault(require("44f3c647d01a142d"));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusInformation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ var StatusInformationIcon = function(props) {
    return /*#__PURE__*/ _react.default.createElement(_baseNew.default, Object.assign({
        name: "StatusInformationIcon",
        dangerouslySetGlyph: '<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.5 6.75v1.5h.75v4.25h1.5v-5A.75.75 0 0 0 8 6.75zM8 3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>'
    }, props));
};
StatusInformationIcon.displayName = 'StatusInformationIcon';
var _default = exports.default = StatusInformationIcon;

},{"98a74d7ce1d14bc3":"ltHCL","44f3c647d01a142d":"kuGeY"}],"4HNQp":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::174472a7e38932dc7a97866e0be8034a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("c89d374a1ac475f9"));
var _baseNew = _interopRequireDefault(require("bee70f6bb5bf3ff5"));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ var StatusSuccessIcon = function(props) {
    return /*#__PURE__*/ _react.default.createElement(_baseNew.default, Object.assign({
        name: "StatusSuccessIcon",
        dangerouslySetGlyph: '<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>'
    }, props));
};
StatusSuccessIcon.displayName = 'StatusSuccessIcon';
var _default = exports.default = StatusSuccessIcon;

},{"c89d374a1ac475f9":"ltHCL","bee70f6bb5bf3ff5":"kuGeY"}],"h2k3M":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2ee7b3f114c675eea0f953c33a485bcf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("dc24f1d117098a40"));
var _baseNew = _interopRequireDefault(require("e9fe1f860bba21cf"));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWarning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ var StatusWarningIcon = function(props) {
    return /*#__PURE__*/ _react.default.createElement(_baseNew.default, Object.assign({
        name: "StatusWarningIcon",
        dangerouslySetGlyph: '<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.756-1.395 2.76-1.395 3.516 0l5.9 10.878c.723 1.333-.242 2.953-1.758 2.953H2.1C.584 15-.38 13.38.342 12.046zM8 10.75a1 1 0 1 0 0 2.001 1 1 0 0 0 0-2M7.25 4.5v5h1.5v-5z" clip-rule="evenodd"/>'
    }, props));
};
StatusWarningIcon.displayName = 'StatusWarningIcon';
var _default = exports.default = StatusWarningIcon;

},{"dc24f1d117098a40":"ltHCL","e9fe1f860bba21cf":"kuGeY"}],"atkIS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "flagTextColor", function() {
    return flagTextColor;
});
var flagTextColor = {
    error: 'color.text.inverse',
    info: 'color.text.inverse',
    normal: 'color.text',
    success: 'color.text.inverse',
    warning: 'color.text.warning.inverse'
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3GzjM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "flagTextColorToken", function() {
    return flagTextColorToken;
});
var flagTextColorToken = {
    error: "var(--ds-text-inverse, #FFFFFF)",
    info: "var(--ds-text-inverse, #FFFFFF)",
    normal: "var(--ds-text, #292A2E)",
    success: "var(--ds-text-inverse, #FFFFFF)",
    warning: "var(--ds-text-warning-inverse, #292A2E)"
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"j9h2i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Expander", function() {
    return 0, _expanderDefault.default;
});
parcelHelpers.export(exports, "DismissButton", function() {
    return 0, _dismissButtonDefault.default;
});
var _expander = require("./expander");
var _expanderDefault = parcelHelpers.interopDefault(_expander);
var _dismissButton = require("./dismiss-button");
var _dismissButtonDefault = parcelHelpers.interopDefault(_dismissButton);

},{"./expander":"8fwG1","./dismiss-button":"1AE1K","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8fwG1":[function(require,module,exports,__globalThis) {
/* expander.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _motion = require("@atlaskit/motion");
var _compiled = require("@atlaskit/primitives/compiled");
var styles = {
    expander: "_1bsb1osq",
    container: "_v5641xzp"
};
var Expander = function(param) {
    var children = param.children, isExpanded = param.isExpanded, testId = param.testId;
    // Need to always render the ExpanderInternal otherwise the
    // reveal transition doesn't happen. We can't use CSS animation for
    // the the reveal because we don't know the height of the content.
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _compiled.Box), {
        xcss: styles.expander,
        style: {
            maxHeight: isExpanded ? 150 : 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flex: '1 1 100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            minWidth: 0
        },
        "aria-hidden": !isExpanded,
        testId: testId && "".concat(testId, "-expander"),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _motion.ExitingPersistence), {
            appear: true,
            children: isExpanded && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _motion.FadeIn), {
                children: function(props) {
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _compiled.Box), (0, _objectSpreadProps._)((0, _objectSpread._)({
                        xcss: styles.container
                    }, props), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _compiled.Stack), {
                            space: "space.100",
                            children: children
                        })
                    }));
                }
            })
        })
    });
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = Expander;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","@atlaskit/motion":"gQd69","@atlaskit/primitives/compiled":"jhQE8","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1AE1K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _new = require("@atlaskit/button/new");
var _chevronDown = require("@atlaskit/icon/core/chevron-down");
var _chevronDownDefault = parcelHelpers.interopDefault(_chevronDown);
var _chevronUp = require("@atlaskit/icon/core/chevron-up");
var _chevronUpDefault = parcelHelpers.interopDefault(_chevronUp);
var _cross = require("@atlaskit/icon/core/cross");
var _crossDefault = parcelHelpers.interopDefault(_cross);
var _flagTextColorToken = require("../flag-text-color-token");
var DismissButtonComponent = function(param) {
    var appearance = param.appearance, onClick = param.onClick, isBold = param.isBold, isExpanded = param.isExpanded, testId = param.testId;
    var ButtonIcon = (0, _crossDefault.default);
    var buttonLabel = 'Dismiss';
    var buttonTestId = testId && "".concat(testId, "-dismiss");
    if (isBold) {
        ButtonIcon = isExpanded ? (0, _chevronUpDefault.default) : (0, _chevronDownDefault.default);
        buttonLabel = isExpanded ? 'Collapse' : 'Expand';
        buttonTestId = testId && "".concat(testId, "-toggle");
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _new.IconButton), {
        icon: function(iconProps) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ButtonIcon, (0, _objectSpreadProps._)((0, _objectSpread._)({}, iconProps), {
                size: "small",
                label: "",
                color: (0, _flagTextColorToken.flagTextColorToken)[appearance]
            }));
        },
        appearance: "subtle",
        spacing: "compact",
        label: buttonLabel,
        onClick: onClick,
        "aria-expanded": isBold ? isExpanded : undefined,
        testId: buttonTestId
    });
};
var DismissButton = /*#__PURE__*/ (0, _react.memo)(DismissButtonComponent);
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = DismissButton;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","@atlaskit/button/new":"2LnSZ","@atlaskit/icon/core/chevron-down":"6b1ia","@atlaskit/icon/core/chevron-up":"hWcbE","@atlaskit/icon/core/cross":"cnbEZ","../flag-text-color-token":"3GzjM","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6b1ia":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d56e8662eb8a8d2462ec3a39ff3aa40b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("abce93695ee1057b"));
var _baseNew = _interopRequireDefault(require("8fb04f61ca04dee3"));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ var ChevronDownIcon = function(props) {
    return /*#__PURE__*/ _react.default.createElement(_baseNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: '<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>'
    }, props));
};
ChevronDownIcon.displayName = 'ChevronDownIcon';
var _default = exports.default = ChevronDownIcon;

},{"abce93695ee1057b":"ltHCL","8fb04f61ca04dee3":"kuGeY"}],"hWcbE":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b6f832dcdc2d7a1f91afd5e9b90e10b9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("543a1ae602b9df54"));
var _baseNew = _interopRequireDefault(require("5b07b96b241cb72c"));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Close dropdown menu
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ var ChevronUpIcon = function(props) {
    return /*#__PURE__*/ _react.default.createElement(_baseNew.default, Object.assign({
        name: "ChevronUpIcon",
        dangerouslySetGlyph: '<path fill="currentcolor" d="m14.53 9.97-6-6a.75.75 0 0 0-1.004-.052l-.056.052-6 6 1.06 1.06L8 5.56l5.47 5.47z"/>'
    }, props));
};
ChevronUpIcon.displayName = 'ChevronUpIcon';
var _default = exports.default = ChevronUpIcon;

},{"543a1ae602b9df54":"ltHCL","5b07b96b241cb72c":"kuGeY"}],"cnbEZ":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13080645a1b889dca339823c8ecd9929>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("4cca120169860228"));
var _baseNew = _interopRequireDefault(require("d67b342fcc9b8f15"));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ var CrossIcon = function(props) {
    return /*#__PURE__*/ _react.default.createElement(_baseNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: '<path fill="currentcolor" d="M14.03 3.03 9.06 8l4.97 4.97-1.06 1.06L8 9.06l-4.97 4.97-1.06-1.06L6.94 8 1.97 3.03l1.06-1.06L8 6.94l4.97-4.97z"/>'
    }, props));
};
CrossIcon.displayName = 'CrossIcon';
var _default = exports.default = CrossIcon;

},{"4cca120169860228":"ltHCL","d67b342fcc9b8f15":"kuGeY"}],"d7hCa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// eslint-disable-next-line @repo/internal/react/require-jsdoc
parcelHelpers.export(exports, "useFlagGroup", function() {
    return useFlagGroup;
});
var _react = require("react");
var _flagGroupContext = require("./flag-group-context");
function useFlagGroup() {
    return (0, _react.useContext)((0, _flagGroupContext.FlagGroupContext));
}

},{"react":"ltHCL","./flag-group-context":"d7GH8","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"d7GH8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FlagGroupContext", function() {
    return FlagGroupContext;
});
var _react = require("react");
var _defaultFlagGroupContext = require("./default-flag-group-context");
var FlagGroupContext = /*#__PURE__*/ (0, _react.createContext)((0, _defaultFlagGroupContext.defaultFlagGroupContext));

},{"react":"ltHCL","./default-flag-group-context":"9RaBE","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9RaBE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultFlagGroupContext", function() {
    return defaultFlagGroupContext;
});
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var defaultFlagGroupContext = {
    onDismissed: (0, _noopDefault.default),
    isDismissAllowed: false
};

},{"@atlaskit/ds-lib/noop":"2f3bg","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4UMEU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AUTO_DISMISS_SECONDS", function() {
    return AUTO_DISMISS_SECONDS;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _usePlatformLeafEventHandler = require("@atlaskit/analytics-next/usePlatformLeafEventHandler");
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var _flag = require("./flag");
var _flagDefault = parcelHelpers.interopDefault(_flag);
var _useFlagGroup = require("./internal/use-flag-group");
var packageName = undefined;
var packageVersion = undefined;
var AUTO_DISMISS_SECONDS = 8;
/**
 * __Auto dismiss flag__
 *
 * An auto dismiss flag is dismissed automatically after eight seconds.
 *
 * - [Examples](https://atlassian.design/components/flag/auto-dismiss-flag/examples)
 * - [Code](https://atlassian.design/components/flag/auto-dismiss-flag/code)
 */ var AutoDismissFlag = function(props) {
    var id = props.id, analyticsContext = props.analyticsContext, tmp = props.onDismissed, onDismissedProp = tmp === void 0 ? (0, _noopDefault.default) : tmp, _props_autoDismissSeconds = props.autoDismissSeconds, autoDismissSeconds = _props_autoDismissSeconds === void 0 ? AUTO_DISMISS_SECONDS : _props_autoDismissSeconds;
    var autoDismissTimer = (0, _react.useRef)(null);
    var _useFlagGroup1 = (0, _useFlagGroup.useFlagGroup)(), onDismissedFromFlagGroup = _useFlagGroup1.onDismissed, isDismissAllowed = _useFlagGroup1.isDismissAllowed;
    var onDismissed = (0, _react.useCallback)(function(id, analyticsEvent) {
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    var onDismissedAnalytics = (0, _usePlatformLeafEventHandler.usePlatformLeafEventHandler)({
        fn: onDismissed,
        action: 'dismissed',
        analyticsData: analyticsContext,
        componentName: 'flag',
        packageName: packageName,
        packageVersion: packageVersion
    });
    var isAutoDismissAllowed = isDismissAllowed && onDismissed;
    var dismissFlag = (0, _react.useCallback)(function() {
        if (isAutoDismissAllowed) onDismissedAnalytics(id);
    }, [
        id,
        onDismissedAnalytics,
        isAutoDismissAllowed
    ]);
    var stopAutoDismissTimer = (0, _react.useCallback)(function() {
        if (autoDismissTimer.current) {
            clearTimeout(autoDismissTimer.current);
            autoDismissTimer.current = null;
        }
    }, []);
    var startAutoDismissTimer = (0, _react.useCallback)(function() {
        if (!isAutoDismissAllowed) return;
        stopAutoDismissTimer();
        autoDismissTimer.current = window.setTimeout(dismissFlag, autoDismissSeconds * 1000);
    }, [
        dismissFlag,
        stopAutoDismissTimer,
        isAutoDismissAllowed,
        autoDismissSeconds
    ]);
    (0, _react.useEffect)(function() {
        startAutoDismissTimer();
        return stopAutoDismissTimer;
    }, [
        startAutoDismissTimer,
        stopAutoDismissTimer
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _flagDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        onMouseOver: stopAutoDismissTimer,
        onFocus: stopAutoDismissTimer,
        onMouseOut: startAutoDismissTimer,
        onBlur: startAutoDismissTimer
    }));
};
exports.default = AutoDismissFlag;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","@atlaskit/analytics-next/usePlatformLeafEventHandler":"8d2dv","@atlaskit/ds-lib/noop":"2f3bg","./flag":"jMyfe","./internal/use-flag-group":"d7hCa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jPpAU":[function(require,module,exports,__globalThis) {
/* flag-group.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "flagWidth", function() {
    return flagWidth;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _bindEventListener = require("bind-event-listener");
var _analyticsNext = require("@atlaskit/analytics-next");
var _browserApis = require("@atlaskit/browser-apis");
var _css = require("@atlaskit/css");
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var _motion = require("@atlaskit/motion");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _portal = require("@atlaskit/portal");
var _portalDefault = parcelHelpers.interopDefault(_portal);
var _compiled = require("@atlaskit/primitives/compiled");
var _constants = require("@atlaskit/theme/constants");
var _visuallyHidden = require("@atlaskit/visually-hidden");
var _visuallyHiddenDefault = parcelHelpers.interopDefault(_visuallyHidden);
var _defaultFlagGroupContext = require("./internal/default-flag-group-context");
var _flagGroupContext = require("./internal/flag-group-context");
var flagWidth = 400;
// transition: none is set on first-of-type to prevent a bug in Firefox
// that causes a broken transition
var groupStyles = {
    root: "_v5641b8g _1bsb1kdj _kqswstnw _u7coidpf _1eqkauwl",
    first: "_v564glyw _t9ec1ygq _1pbyqfx8",
    second: "_1pbyegat",
    nth: "_5sag5cps _t9ec1hw2",
    hidden: "_3um015vq"
};
// transition: none is set on first-of-type to prevent a bug in Firefox
// that causes a broken transition
var groupStylesNew = {
    root: "_v564t8bh _kqswstnw _u7coidpf _1bsb1kdj _1eqkauwl",
    first: "_t9ec1ygq _1pbyqfx8",
    second: "_t9ec1pi4 _1pbyegat",
    nth: "_t9ec15wd",
    hidden: "_3um015vq"
};
// Transform needed to push up while 1st flag is leaving
// Exiting time should match the exiting time of motion so is halved
var dismissAllowedStyles = null;
var flagGroupContainerStyles = null;
/**
 * __Flag group__
 *
 * A flag group is used to group a set of related flags, with entry and exit animations.
 *
 * - [Examples](https://atlassian.design/components/flag/flag-group/examples)
 * - [Code](https://atlassian.design/components/flag/flag-group/code)
 */ var FlagGroup = function(props) {
    var id = props.id, _props_label = props.label, label = _props_label === void 0 ? 'Flag notifications' : _props_label, tmp = props.labelTag, LabelTag = tmp === void 0 ? 'h2' : tmp, _props_shouldRenderToParent = props.shouldRenderToParent, shouldRenderToParent = _props_shouldRenderToParent === void 0 ? false : _props_shouldRenderToParent, children = props.children, _props_onDismissed = props.onDismissed, onDismissed = _props_onDismissed === void 0 ? (0, _noopDefault.default) : _props_onDismissed;
    var hasFlags = Array.isArray(children) ? children.length > 0 : Boolean(children);
    var dismissFlagContext = (0, _react.useMemo)(function() {
        return {
            onDismissed: onDismissed,
            isDismissAllowed: true
        };
    }, [
        onDismissed
    ]);
    // Keep a stable reference to the latest children, dismiss handler, and
    // analytics creator so the keydown listener never reads stale closures.
    var createAnalyticsEvent = (0, _analyticsNext.useAnalyticsEvents)().createAnalyticsEvent;
    var latestRef = (0, _react.useRef)({
        children: children,
        onDismissed: onDismissed,
        createAnalyticsEvent: createAnalyticsEvent
    });
    latestRef.current = {
        children: children,
        onDismissed: onDismissed,
        createAnalyticsEvent: createAnalyticsEvent
    };
    // Accessibility (JRACLOUD-97876): allow keyboard-only and assistive
    // technology users to dismiss the topmost (and only dismissable) flag with
    // the Escape key, without having to tab through the entire page to reach
    // the dismiss button. Behaviour is gated behind a feature flag so it can
    // be rolled out and validated incrementally.
    (0, _react.useEffect)(function() {
        if (!(0, _platformFeatureFlags.fg)('platform_dst_flag_keyboard_dismiss')) return;
        if (!hasFlags) return;
        var doc = (0, _browserApis.getDocument)();
        if (!doc) return;
        return (0, _bindEventListener.bind)(doc, {
            type: 'keydown',
            listener: function(event) {
                var _firstFlag_props, _latestRef_current_onDismissed, _latestRef_current;
                if (event.key !== 'Escape' || event.defaultPrevented) return;
                var currentChildren = latestRef.current.children;
                var firstFlag = Array.isArray(currentChildren) ? currentChildren.find(Boolean) : currentChildren;
                if (!firstFlag || (typeof firstFlag === "undefined" ? "undefined" : (0, _typeOf._)(firstFlag)) !== 'object') return;
                var id = (_firstFlag_props = firstFlag.props) === null || _firstFlag_props === void 0 ? void 0 : _firstFlag_props.id;
                if (id === undefined || id === null || id === '') return;
                var analyticsEvent = latestRef.current.createAnalyticsEvent({
                    action: 'dismissed',
                    actionSubject: 'flag',
                    attributes: {
                        dismissedVia: 'keyboardShortcut',
                        key: 'Escape'
                    }
                });
                event.preventDefault();
                (_latestRef_current_onDismissed = (_latestRef_current = latestRef.current).onDismissed) === null || _latestRef_current_onDismissed === void 0 ? void 0 : _latestRef_current_onDismissed.call(_latestRef_current, id, analyticsEvent);
            }
        });
    }, [
        hasFlags
    ]);
    var renderChildren = function() {
        return children && (typeof children === "undefined" ? "undefined" : (0, _typeOf._)(children)) === 'object' ? (0, _react.Children).map(children, function(flag, index) {
            var isDismissAllowed = index === 0;
            return (0, _platformFeatureFlags.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _compiled.Box), {
                xcss: (0, _css.cx)(groupStylesNew.root, index === 0 && groupStylesNew.first, index === 1 && groupStylesNew.second, index >= 2 && groupStylesNew.nth, index >= 3 && groupStylesNew.hidden),
                "data-vc-oob": true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _motion.Motion), {
                    enteringAnimation: "var(--ds-flag-enter, 250ms cubic-bezier(0, 0.4, 0, 1) SlideIn50PercentLeft, 250ms cubic-bezier(0, 0.4, 0, 1) FadeIn0to100)",
                    exitingAnimation: "var(--ds-flag-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOut15PercentLeft, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _flagGroupContext.FlagGroupContext).Provider, {
                        value: // Only the first flag should be able to be dismissed.
                        isDismissAllowed ? dismissFlagContext : (0, _defaultFlagGroupContext.defaultFlagGroupContext),
                        children: flag
                    })
                })
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _motion.SlideIn), {
                enterFrom: "left",
                fade: "inout",
                duration: "medium",
                animationTimingFunction: "ease-in",
                children: function(param) {
                    var className = param.className, ref = param.ref;
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, _runtime.ax)([
                            groupStyles.root,
                            index === 0 && groupStyles.first,
                            index === 1 && groupStyles.second,
                            index >= 1 && groupStyles.nth,
                            index >= 2 && groupStyles.hidden,
                            isDismissAllowed && "_12a7luct",
                            className
                        ]),
                        ref: ref,
                        "data-vc-oob": true,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _flagGroupContext.FlagGroupContext).Provider, {
                            value: // Only the first flag should be able to be dismissed.
                            isDismissAllowed ? dismissFlagContext : (0, _defaultFlagGroupContext.defaultFlagGroupContext),
                            children: flag
                        })
                    });
                }
            });
        }) : false;
    };
    var isKeyboardDismissEnabled = (0, _platformFeatureFlags.fg)('platform_dst_flag_keyboard_dismiss');
    // When the keyboard dismiss shortcut is available, surface it to assistive
    // technology users via the existing visually-hidden landmark heading so they
    // know they can press Escape to dismiss the topmost flag.
    var screenReaderLabel = isKeyboardDismissEnabled ? "".concat(label, ". Press Escape to dismiss.") : label;
    var flags = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        id: id,
        "data-vc-oob": true,
        className: (0, _runtime.ax)([
            "_kqsw1n9t _1pbyxejw _u7cooahv _1e021epz _1iafidpf _il0widpf"
        ]),
        children: [
            hasFlags ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _visuallyHiddenDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LabelTag, {
                    children: screenReaderLabel
                })
            }) : null,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _motion.ExitingPersistence), {
                appear: false,
                children: renderChildren()
            })
        ]
    });
    return shouldRenderToParent ? flags : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _portalDefault.default), {
        zIndex: (0, _constants.layers).flag(),
        children: flags
    });
};
exports.default = FlagGroup;

},{"@swc/helpers/_/_type_of":"iFJdx","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","bind-event-listener":"bjeUU","@atlaskit/analytics-next":"auH4u","@atlaskit/browser-apis":"2dayt","@atlaskit/css":"fiaHp","@atlaskit/ds-lib/noop":"2f3bg","@atlaskit/motion":"gQd69","@atlaskit/platform-feature-flags":"kO5t9","@atlaskit/portal":"kqyHU","@atlaskit/primitives/compiled":"jhQE8","@atlaskit/theme/constants":"3DRjL","@atlaskit/visually-hidden":"lj6Zq","./internal/default-flag-group-context":"9RaBE","./internal/flag-group-context":"d7GH8","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eQp7n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * useFlags is used to access the `showFlags` function which can be used to programatically display flags.
 * - [Examples](https://atlassian.design/components/flag/flags-provider/examples#using-showflags)
 */ parcelHelpers.export(exports, "useFlags", function() {
    return useFlags;
});
parcelHelpers.export(exports, "FlagsProvider", function() {
    return FlagsProvider;
});
parcelHelpers.export(exports, "withFlagsProvider", function() {
    return withFlagsProvider;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _autoDismissFlag = require("./auto-dismiss-flag");
var _autoDismissFlagDefault = parcelHelpers.interopDefault(_autoDismissFlag);
var _flag = require("./flag");
var _flagDefault = parcelHelpers.interopDefault(_flag);
var _flagGroup = require("./flag-group");
var _flagGroupDefault = parcelHelpers.interopDefault(_flagGroup);
var FlagContext = /*#__PURE__*/ (0, _reactDefault.default).createContext(null);
function useFlags() {
    var api = (0, _react.useContext)(FlagContext);
    if (api == null) throw new Error('Unable to find FlagProviderContext');
    return api;
}
var getUniqueId = function() {
    var count = 0;
    return function() {
        return "flag-provider-unique-id:".concat(count++);
    };
}();
function FlagsProvider(param) {
    var children = param.children, shouldRenderToParent = param.shouldRenderToParent;
    var _useState = (0, _slicedToArray._)((0, _react.useState)([]), 2), flags = _useState[0], setFlags = _useState[1];
    var removeFlag = (0, _react.useCallback)(function(id) {
        setFlags(function(current) {
            return current.slice(0).filter(function(flag) {
                return flag.id !== id;
            });
        });
    }, []);
    var api = (0, _react.useMemo)(function() {
        return {
            showFlag: function show(value) {
                var flag = (0, _objectSpreadProps._)((0, _objectSpread._)({}, value), {
                    id: value.id || getUniqueId()
                });
                setFlags(function(current) {
                    var index = current.findIndex(function(value) {
                        return value.id === flag.id;
                    });
                    // If flag is not found add it
                    if (index === -1) return [
                        flag
                    ].concat((0, _toConsumableArray._)(current));
                    // If flag already exists with the same id, then replace it
                    var shallow = (0, _toConsumableArray._)(current);
                    shallow[index] = flag;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag.id);
                };
            }
        };
    }, [
        removeFlag
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(FlagContext.Provider, {
                value: api,
                children: children
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _flagGroupDefault.default), {
                onDismissed: removeFlag,
                shouldRenderToParent: shouldRenderToParent,
                children: flags.map(function(flag) {
                    var isAutoDismiss = flag.isAutoDismiss, restProps = (0, _objectWithoutProperties._)(flag, [
                        "isAutoDismiss"
                    ]);
                    var FlagType = isAutoDismiss ? (0, _autoDismissFlagDefault.default) : (0, _flagDefault.default);
                    return /*#__PURE__*/ (0, _react.createElement)(FlagType, (0, _objectSpreadProps._)((0, _objectSpread._)({}, restProps), {
                        key: flag.id
                    }));
                })
            })
        ]
    });
}
var withFlagsProvider = function(fn) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(FlagsProvider, {
        children: fn()
    });
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_to_consumable_array":"1eSZf","react/jsx-runtime":"bGvcw","react":"ltHCL","./auto-dismiss-flag":"4UMEU","./flag":"jMyfe","./flag-group":"jPpAU","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cMGle":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UFOThirdPartySegment", function() {
    return 0, _thirdPartySegment.UFOThirdPartySegment;
});
parcelHelpers.export(exports, "flushSsrRenderProfilerTraces", function() {
    return 0, _ssrRenderProfiler.flushSsrRenderProfilerTraces;
});
var _segment = require("./segment");
var _segmentDefault = parcelHelpers.interopDefault(_segment);
var _thirdPartySegment = require("./third-party-segment");
var _ssrRenderProfiler = require("./ssr-render-profiler");
exports.default = (0, _segmentDefault.default);

},{"./segment":"aAOBf","./third-party-segment":false,"./ssr-render-profiler":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aAOBf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _scheduler = require("scheduler");
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
var _uuid = require("uuid");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _coinflip = require("../coinflip");
var _coinflipDefault = parcelHelpers.interopDefault(_coinflip);
var _config = require("../config");
var _experienceTraceIdContext = require("../experience-trace-id-context");
var _interactionContext = require("../interaction-context");
var _interactionContextDefault = parcelHelpers.interopDefault(_interactionContext);
var _interactionIdContext = require("../interaction-id-context");
var _interactionIdContextDefault = parcelHelpers.interopDefault(_interactionIdContext);
var _interactionMetrics = require("../interaction-metrics");
var _routeNameContext = require("../route-name-context");
var _routeNameContextDefault = parcelHelpers.interopDefault(_routeNameContext);
var _shortId = require("../short-id");
var _shortIdDefault = parcelHelpers.interopDefault(_shortId);
var _scheduleOnPaint = require("./schedule-on-paint");
var _scheduleOnPaintDefault = parcelHelpers.interopDefault(_scheduleOnPaint);
var _ssrRenderProfiler = require("./ssr-render-profiler");
var _ssrRenderProfilerDefault = parcelHelpers.interopDefault(_ssrRenderProfiler);
var tryCompleteHandle;
var hasMarkedFirstSegmentLoad = false;
/** A portion of the page we apply measurement to */ var UFOSegment = function(param) {
    var segmentName = param.name, children = param.children, _param_mode = param.mode, mode = _param_mode === void 0 ? 'single' : _param_mode, _param_type = param.type, type = _param_type === void 0 ? 'first-party' : _param_type;
    // If UFO is disabled, render children without any tracking overhead
    // Note: isUFOEnabled() returns a stable value based on config, so it's safe to call before hooks
    var ufoEnabled = (0, _config.isUFOEnabled)();
    var parentContext = (0, _react.useContext)((0, _interactionContextDefault.default));
    var segmentIdMap = (0, _react.useMemo)(function() {
        if (!(parentContext === null || parentContext === void 0 ? void 0 : parentContext.segmentIdMap)) return new Map();
        return parentContext.segmentIdMap;
    }, [
        parentContext
    ]);
    var segmentId = (0, _react.useMemo)(function() {
        if (mode === 'single') return (0, _shortIdDefault.default)();
        if (segmentIdMap.has(segmentName)) return segmentIdMap.get(segmentName);
        var newSegmentId = (0, _shortIdDefault.default)();
        segmentIdMap.set(segmentName, newSegmentId);
        return newSegmentId;
    }, [
        mode,
        segmentName,
        segmentIdMap
    ]);
    var labelStack = (0, _react.useMemo)(function() {
        return (parentContext === null || parentContext === void 0 ? void 0 : parentContext.labelStack) ? (0, _toConsumableArray._)(parentContext.labelStack).concat([
            (0, _objectSpread._)({
                name: segmentName,
                segmentId: segmentId
            }, type !== 'first-party' ? {
                type: type
            } : {})
        ]) : [
            (0, _objectSpread._)({
                name: segmentName,
                segmentId: segmentId
            }, type !== 'first-party' ? {
                type: type
            } : {})
        ];
    }, [
        parentContext,
        segmentName,
        segmentId,
        type
    ]);
    var interactionId = (0, _react.useContext)((0, _interactionIdContextDefault.default));
    if (interactionId.current != null && !hasMarkedFirstSegmentLoad) {
        (0, _interactionMetrics.markFirstSegmentLoad)(interactionId.current, labelStack, performance.now());
        hasMarkedFirstSegmentLoad = true;
    }
    var interactionContext = (0, _react.useMemo)(function() {
        var lastCompleteEndTime = 0;
        function complete() {
            var endTime = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : performance.now();
            if (interactionId.current) {
                if (parentContext) parentContext.complete();
                else {
                    var _cancelAnimationFrame;
                    var capturedInteractionId = interactionId.current;
                    if (endTime > lastCompleteEndTime) lastCompleteEndTime = endTime;
                    if (tryCompleteHandle) (_cancelAnimationFrame = cancelAnimationFrame) === null || _cancelAnimationFrame === void 0 ? void 0 : _cancelAnimationFrame(tryCompleteHandle);
                    var onComplete = function() {
                        if (capturedInteractionId === interactionId.current) {
                            var _globalThis_document, _globalThis;
                            var isPageVisible = ((_globalThis = globalThis) === null || _globalThis === void 0 ? void 0 : (_globalThis_document = _globalThis.document) === null || _globalThis_document === void 0 ? void 0 : _globalThis_document.visibilityState) === 'visible';
                            var canDoRAF = typeof requestAnimationFrame !== 'undefined';
                            if (isPageVisible && canDoRAF) tryCompleteHandle = requestAnimationFrame(function() {
                                tryCompleteHandle = requestAnimationFrame(function() {
                                    if (capturedInteractionId === interactionId.current) (0, _interactionMetrics.tryComplete)(interactionId.current, lastCompleteEndTime);
                                });
                            });
                            else (0, _interactionMetrics.tryComplete)(interactionId.current, lastCompleteEndTime);
                        }
                    };
                    (0, _scheduler.unstable_scheduleCallback)((0, _scheduler.unstable_NormalPriority), onComplete);
                }
            }
        }
        function _internalHold(labelStack, name) {
            var experimental = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
            if (interactionId.current != null) {
                if (parentContext) return parentContext._internalHold(labelStack, name, (0, _platformFeatureFlags.fg)('platform_ufo_remove_experimental_holds') ? false : experimental);
                else {
                    var capturedInteractionId = interactionId.current;
                    var disposeHold = (0, _interactionMetrics.addHold)(interactionId.current, labelStack, name, (0, _platformFeatureFlags.fg)('platform_ufo_remove_experimental_holds') ? false : experimental);
                    return function() {
                        if (capturedInteractionId === interactionId.current) disposeHold();
                    };
                }
            }
        }
        function _internalHoldByID(labelStack, id, name, remove) {
            if (interactionId.current != null) {
                if (parentContext) {
                    parentContext._internalHoldByID(labelStack, name, id, remove);
                    return;
                }
                if (!remove) (0, _interactionMetrics.addHoldByID)(interactionId.current, labelStack, name, id);
                else (0, _interactionMetrics.removeHoldByID)(interactionId.current, id);
            }
        }
        if (parentContext) return (0, _objectSpreadProps._)((0, _objectSpread._)({}, parentContext), {
            labelStack: labelStack,
            complete: complete
        });
        return {
            labelStack: labelStack,
            segmentIdMap: segmentIdMap,
            hold: function hold() {
                var name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'unknown';
                return this._internalHold(this.labelStack, name);
            },
            holdExperimental: function holdExperimental() {
                var name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'unknown';
                if ((0, _platformFeatureFlags.fg)('platform_ufo_remove_experimental_holds')) return this._internalHold(this.labelStack, name);
                return this._internalHold(this.labelStack, name, true);
            },
            addHoldByID: function addHoldByID(labelStack, id) {
                var name = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'unknown';
                this._internalHoldByID(labelStack, id, name, false);
            },
            removeHoldByID: function removeHoldByID(labelStack, id) {
                var name = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'unknown';
                this._internalHoldByID(labelStack, id, name, true);
            },
            tracePress: function tracePress() {
                var name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'unknown', timestamp = arguments.length > 1 ? arguments[1] : void 0;
                var _getDoNotAbortActivePressInteraction, _getMinorInteractions;
                var minorInteractions = (0, _toConsumableArray._)((_getDoNotAbortActivePressInteraction = (0, _config.getDoNotAbortActivePressInteraction)()) !== null && _getDoNotAbortActivePressInteraction !== void 0 ? _getDoNotAbortActivePressInteraction : []).concat((0, _toConsumableArray._)((_getMinorInteractions = (0, _config.getMinorInteractions)()) !== null && _getMinorInteractions !== void 0 ? _getMinorInteractions : []));
                if (minorInteractions.includes(name)) {
                    var _activeInteraction_minorInteractions;
                    var activeInteraction = (0, _interactionMetrics.getActiveInteraction)();
                    activeInteraction === null || activeInteraction === void 0 ? void 0 : (_activeInteraction_minorInteractions = activeInteraction.minorInteractions) === null || _activeInteraction_minorInteractions === void 0 ? void 0 : _activeInteraction_minorInteractions.push({
                        name: name,
                        startTime: timestamp !== null && timestamp !== void 0 ? timestamp : performance.now()
                    });
                    return;
                } else if (interactionId.current != null) (0, _interactionMetrics.abortByNewInteraction)(interactionId.current, name);
                var rate = (0, _config.getInteractionRate)(name, 'press');
                if ((0, _coinflipDefault.default)(rate)) {
                    var startTimestamp = timestamp !== null && timestamp !== void 0 ? timestamp : performance.now();
                    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                    var newId = (0, _uuid.v4)();
                    interactionId.current = newId;
                    // covered experiences with tracing instrumentation:
                    // inline-result.global-issue.create-modal.submit
                    // inline-result.global-issue.create-modal-subsequent
                    (0, _experienceTraceIdContext.setInteractionActiveTrace)(newId, 'press');
                    (0, _interactionMetrics.addNewInteraction)(newId, name, 'press', startTimestamp, rate, this.labelStack, (0, _routeNameContextDefault.default).current, (0, _experienceTraceIdContext.getActiveTrace)());
                }
            },
            retainQuery: function retainQuery(info) {
                if (interactionId.current != null) (0, _interactionMetrics.addRequestInfo)(interactionId.current, this.labelStack, info);
            },
            addPreload: function addPreload(moduleId, timestamp) {
                if (interactionId.current != null) (0, _interactionMetrics.addMark)(interactionId.current, 'bundle_preload', moduleId, this.labelStack, timestamp);
            },
            addLoad: function addLoad(identifier, start, end) {
                if (interactionId.current != null) {
                    var _this = this, _this_labelStack = _this.labelStack, labelStack = _this_labelStack === void 0 ? [] : _this_labelStack;
                    (0, _interactionMetrics.addSpan)(interactionId.current, 'bundle_load', identifier, labelStack, start, end);
                }
            },
            addMark: function addMark(name, timestamp) {
                if (interactionId.current != null) {
                    var time = timestamp !== null && timestamp !== void 0 ? timestamp : performance.now();
                    (0, _interactionMetrics.addMark)(interactionId.current, 'custom', name, this.labelStack, time);
                }
            },
            addCustomData: function addCustomData(customData) {
                if (interactionId.current != null) (0, _interactionMetrics.addCustomData)(interactionId.current, this.labelStack, customData);
            },
            addCustomTimings: function addCustomTimings(customTimings) {
                if (interactionId.current != null) (0, _interactionMetrics.addCustomTiming)(interactionId.current, this.labelStack, customTimings);
            },
            addApdex: function addApdex(apdexInfo) {
                if (interactionId.current != null) {
                    var key = apdexInfo.key, stopTime = apdexInfo.stopTime, startTime = apdexInfo.startTime;
                    (0, _interactionMetrics.addApdex)(interactionId.current, {
                        key: key,
                        stopTime: stopTime,
                        startTime: startTime,
                        labelStack: this.labelStack
                    });
                }
            },
            onRender: function onRender(phase, actualDuration, baseDuration, startTime, commitTime) {
                var _this = this;
                if (interactionId.current !== null) {
                    (0, _interactionMetrics.addProfilerTimings)(interactionId.current, this.labelStack, phase, actualDuration, baseDuration, startTime, commitTime);
                    (0, _scheduleOnPaintDefault.default)(function() {
                        var paintedTime = performance.now();
                        _this.complete(paintedTime);
                    });
                }
            },
            _internalHold: _internalHold,
            _internalHoldByID: _internalHoldByID,
            complete: complete
        };
    }, [
        parentContext,
        labelStack,
        segmentIdMap,
        interactionId
    ]);
    var hasMounted = (0, _react.useRef)(false);
    var onRender = (0, _react.useCallback)(function(_id, phase, actualDuration, baseDuration, startTime, commitTime) {
        var _getConfig;
        // Manually keep track of mount-phase, and ensure that every segment is always mounted at least once
        if (((_getConfig = (0, _config.getConfig)()) === null || _getConfig === void 0 ? void 0 : _getConfig.manuallyTrackReactProfilerMounts) && !hasMounted.current) {
            interactionContext.onRender('mount', actualDuration, baseDuration, startTime, commitTime);
            hasMounted.current = true;
        } else interactionContext.onRender(phase, actualDuration, baseDuration, startTime, commitTime);
    }, [
        interactionContext
    ]);
    (0, _react.useEffect)(function() {
        (0, _interactionMetrics.addSegment)(labelStack);
        return function() {
            (0, _interactionMetrics.removeSegment)(labelStack);
        };
    }, [
        interactionId,
        parentContext,
        interactionContext,
        labelStack
    ]);
    var reactProfilerId = (0, _react.useMemo)(function() {
        return labelStack.map(function(l) {
            return l.name;
        }).join('/');
    }, [
        labelStack
    ]);
    // If UFO is disabled, just render children without tracking overhead
    if (!ufoEnabled) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: children
    });
    var ufoSegment = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _interactionContextDefault.default).Provider, {
        value: interactionContext,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Profiler), {
            id: reactProfilerId,
            onRender: onRender,
            children: children
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ssrRenderProfilerDefault.default), {
        labelStack: labelStack,
        onRender: function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return interactionContext.onRender.apply(interactionContext, args);
        },
        children: ufoSegment
    });
};
UFOSegment.displayName = 'UFOSegment';
exports.default = UFOSegment;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_to_consumable_array":"1eSZf","react/jsx-runtime":"bGvcw","react":"ltHCL","scheduler":"NHulo","uuid":"5elg8","@atlaskit/platform-feature-flags":"kO5t9","../coinflip":"cHdgG","../config":"1BZI5","../experience-trace-id-context":"7SDPo","../interaction-context":"6ICC9","../interaction-id-context":"eh9Yb","../interaction-metrics":"diQdd","../route-name-context":"61t5e","../short-id":"7VrCG","./schedule-on-paint":"72vVv","./ssr-render-profiler":"1naJ6","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cHdgG":[function(require,module,exports,__globalThis) {
/**
 * A random function that passes one in rate times.
 * E.g. coinflip(2) is the same as if you flipped a coin.
 * It will pass 50% of the time
 * @param rate The change that it will pass (1 in <rate> times)
 * @returns bool, if it passes or not
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function coinflip(rate) {
    if (rate === 0) return false;
    else if (rate === 1) return true;
    else return Math.random() * rate <= 1;
}
exports.default = coinflip;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1BZI5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @internal Test-only helper. Do not use outside unit tests.
 */ parcelHelpers.export(exports, "__resetFedrampOverrideCacheForTests", function() {
    return __resetFedrampOverrideCacheForTests;
});
/**
 * Returns true when react-ufo should apply its FedRAMP-Moderate hardening:
 *
 *   - all `selectorConfig` fields forced to `false`
 *   - `rawData.att`, `obs[].att`, `rawData.lbl`, `rawData.lblMode` scrubbed
 *     from the `raw-handler` revision payload
 *
 * Centralising the perimeter check here ensures every FedRAMP code path in
 * react-ufo is gated by the same `isFedrampModerate()` result.
 *
 * Defensive against `isFedrampModerate()` ever throwing — falls back to
 * `false` so the metrics pipeline never breaks because of perimeter
 * detection.
 */ parcelHelpers.export(exports, "isFedrampOverrideActive", function() {
    return isFedrampOverrideActive;
});
parcelHelpers.export(exports, "DEFAULT_TTVC_REVISION", function() {
    return DEFAULT_TTVC_REVISION;
});
parcelHelpers.export(exports, "getDefaultTTVCRevision", function() {
    return getDefaultTTVCRevision;
});
parcelHelpers.export(exports, "UNKNOWN_INTERACTION_RATE", function() {
    return UNKNOWN_INTERACTION_RATE;
});
parcelHelpers.export(exports, "setUFOConfig", function() {
    return setUFOConfig;
});
parcelHelpers.export(exports, "getConfig", function() {
    return getConfig;
});
/**
 * Centralised resolver for the active `SelectorConfig` for the VC observer.
 *
 * Precedence (highest first):
 *   1. **FedRAMP override** — when `isFedrampModerate()` is true, every
 *      selector field is forced to `false` regardless of any other input.
 *      This guarantees that no `id`, `testId`, `role`, `className`, or
 *      `data-vc` selectors escape the FedRAMP perimeter via the
 *      raw-handler payload.
 *   2. **Caller-provided override** — `callerOverride` argument (e.g. an
 *      explicit `selectorConfig` passed by a per-interaction VC observer
 *      consumer).
 *   3. **Centrally configured value** — `config.vc.selectorConfig` as set
 *      via `setUFOConfig`.
 *   4. **Caller-provided default** — `defaultConfig` argument (used by call
 *      sites that have a historical hard-coded fallback they want to keep
 *      when nothing else is available).
 *   5. `undefined` — when no caller default is supplied either.
 *
 * @param callerOverride Explicit per-call-site selectorConfig override.
 * @param defaultConfig  Hard-coded fallback used only when nothing else
 *                       provided a value.
 */ parcelHelpers.export(exports, "getSelectorConfig", function() {
    return getSelectorConfig;
});
/**
 * Check if UFO is enabled based on the config.enabled field.
 *
 * @returns true if UFO is enabled, false if disabled
 */ parcelHelpers.export(exports, "isUFOEnabled", function() {
    return isUFOEnabled;
});
parcelHelpers.export(exports, "getEnabledVCRevisions", function() {
    return getEnabledVCRevisions;
});
parcelHelpers.export(exports, "isVCRevisionEnabled", function() {
    return isVCRevisionEnabled;
});
parcelHelpers.export(exports, "getMostRecentVCRevision", function() {
    return getMostRecentVCRevision;
});
parcelHelpers.export(exports, "getReactHydrationStats", function() {
    return getReactHydrationStats;
});
parcelHelpers.export(exports, "getInteractionRate", function() {
    return getInteractionRate;
});
parcelHelpers.export(exports, "getExperimentalInteractionRate", function() {
    return getExperimentalInteractionRate;
});
parcelHelpers.export(exports, "getVCRawDataInteractionRate", function() {
    return getVCRawDataInteractionRate;
});
parcelHelpers.export(exports, "shouldUseRawDataThirdPartyBehavior", function() {
    return shouldUseRawDataThirdPartyBehavior;
});
parcelHelpers.export(exports, "getPostInteractionRate", function() {
    return getPostInteractionRate;
});
parcelHelpers.export(exports, "getCapabilityRate", function() {
    return getCapabilityRate;
});
parcelHelpers.export(exports, "getExtraInteractionRate", function() {
    return getExtraInteractionRate;
});
parcelHelpers.export(exports, "getTypingPerformanceTracingMethod", function() {
    return getTypingPerformanceTracingMethod;
});
// Will ask UFO to wait for BM3 TTI for all events on this list
parcelHelpers.export(exports, "getAwaitBM3TTIList", function() {
    return getAwaitBM3TTIList;
});
// Will ask UFO to override ufoName => experienceKey to the apdex key
// This is to cover use cases where one rUFO route is split into multiple BM3 keys (1:N)
// This workaround should only be used as last resource,
// when we find router limitations preventing teams from splliting these routes
parcelHelpers.export(exports, "getUfoNameOverrides", function() {
    return getUfoNameOverrides;
});
parcelHelpers.export(exports, "getMinorInteractions", function() {
    return getMinorInteractions;
});
// Contains the list of interactions that do not abort existing known interactions
parcelHelpers.export(exports, "getDoNotAbortActivePressInteraction", function() {
    return getDoNotAbortActivePressInteraction;
});
// Contains the list of interactions that do not abort on transitions
parcelHelpers.export(exports, "getDoNotAbortActivePressInteractionOnTransition", function() {
    return getDoNotAbortActivePressInteractionOnTransition;
});
// Contains the list of interactions that do not abort on transitions
parcelHelpers.export(exports, "getFinishInteractionOnTransition", function() {
    return getFinishInteractionOnTransition;
});
parcelHelpers.export(exports, "CLEANUP_TIMEOUT", function() {
    return CLEANUP_TIMEOUT;
});
parcelHelpers.export(exports, "getInteractionTimeout", function() {
    return getInteractionTimeout;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var _atlassianContext = require("@atlaskit/atlassian-context");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var config;
/**
 * Cached result of `isFedrampModerate()` so we don't re-parse cookies on
 * every selector lookup. Reset via `__resetFedrampOverrideCacheForTests` in
 * unit tests only.
 */ var cachedIsFedrampModerate;
function detectIsFedrampModerate() {
    if (cachedIsFedrampModerate !== undefined) return cachedIsFedrampModerate;
    try {
        cachedIsFedrampModerate = (0, _atlassianContext.isFedrampModerate)();
    } catch (e) {
        // Defensive default: if perimeter detection throws, treat as non-FedRAMP
        // so UFO behaviour is unchanged. Mirrors `analyticsWebClient` pattern.
        cachedIsFedrampModerate = false;
    }
    return cachedIsFedrampModerate;
}
function __resetFedrampOverrideCacheForTests() {
    cachedIsFedrampModerate = undefined;
}
function isFedrampOverrideActive() {
    try {
        return detectIsFedrampModerate();
    } catch (e) {
        return false;
    }
}
var FEDRAMP_DISABLED_SELECTOR_CONFIG = Object.freeze({
    id: false,
    testId: false,
    role: false,
    className: false,
    dataVC: false
});
var DEFAULT_TTVC_REVISION = 'fy26.04';
function getDefaultTTVCRevision() {
    return DEFAULT_TTVC_REVISION;
}
var UNKNOWN_INTERACTION_RATE = 1000;
function setUFOConfig(newConfig) {
    var _newConfig_vc;
    // Handle edge cases with `enabledVCRevisions`
    var enabledVCRevisions = ((_newConfig_vc = newConfig === null || newConfig === void 0 ? void 0 : newConfig.vc) !== null && _newConfig_vc !== void 0 ? _newConfig_vc : {}).enabledVCRevisions;
    if (enabledVCRevisions) {
        var byExperience = (0, _typeOf._)(enabledVCRevisions === null || enabledVCRevisions === void 0 ? void 0 : enabledVCRevisions.byExperience) === 'object' ? enabledVCRevisions.byExperience : {};
        var _enabledVCRevisions_all;
        var allRevisions = // Products control their own revisions.
        (0, _toConsumableArray._)((_enabledVCRevisions_all = enabledVCRevisions === null || enabledVCRevisions === void 0 ? void 0 : enabledVCRevisions.all) !== null && _enabledVCRevisions_all !== void 0 ? _enabledVCRevisions_all : []).concat((0, _toConsumableArray._)(Object.values(byExperience).flat()));
        config = (0, _objectSpreadProps._)((0, _objectSpread._)({}, newConfig), {
            vc: (0, _objectSpreadProps._)((0, _objectSpread._)({}, newConfig.vc), {
                enabledVCRevisions: {
                    all: Array.from(new Set(allRevisions)),
                    byExperience: byExperience
                }
            })
        });
    } else config = newConfig;
}
function getConfig() {
    return config;
}
function getSelectorConfig(callerOverride, defaultConfig) {
    var _config_vc;
    // 1. FedRAMP override always wins.
    if (detectIsFedrampModerate()) return FEDRAMP_DISABLED_SELECTOR_CONFIG;
    var _ref;
    // 2. Then caller-provided.
    // 3. Then centrally configured.
    // 4. Then caller-provided default.
    return (_ref = callerOverride !== null && callerOverride !== void 0 ? callerOverride : config === null || config === void 0 ? void 0 : (_config_vc = config.vc) === null || _config_vc === void 0 ? void 0 : _config_vc.selectorConfig) !== null && _ref !== void 0 ? _ref : defaultConfig;
}
function isUFOEnabled() {
    // Default to enabled if config is not set or enabled is not explicitly false
    return (config === null || config === void 0 ? void 0 : config.enabled) !== false;
}
var isValidConfigArray = function(array) {
    return Array.isArray(array) && array.length > 0;
};
function getEnabledVCRevisions() {
    var experienceKey = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '';
    try {
        var _config_vc;
        if (!config) return [];
        if ((_config_vc = config.vc) === null || _config_vc === void 0 ? void 0 : _config_vc.enabled) {
            var _enabledVCRevisions_byExperience, _enabledVCRevisions_byExperience1;
            var _config_vc1;
            var enabledVCRevisions = ((_config_vc1 = config.vc) !== null && _config_vc1 !== void 0 ? _config_vc1 : {}).enabledVCRevisions;
            if (isValidConfigArray(enabledVCRevisions === null || enabledVCRevisions === void 0 ? void 0 : (_enabledVCRevisions_byExperience = enabledVCRevisions.byExperience) === null || _enabledVCRevisions_byExperience === void 0 ? void 0 : _enabledVCRevisions_byExperience[experienceKey])) return (_enabledVCRevisions_byExperience1 = enabledVCRevisions.byExperience) === null || _enabledVCRevisions_byExperience1 === void 0 ? void 0 : _enabledVCRevisions_byExperience1[experienceKey];
            // When the disable flag is on, treat an explicitly-set empty array as
            // "no client-side revisions" rather than falling back to the default revision.
            var allRevisions = enabledVCRevisions === null || enabledVCRevisions === void 0 ? void 0 : enabledVCRevisions.all;
            if (Array.isArray(allRevisions) && allRevisions.length === 0 && (0, _platformFeatureFlags.fg)('ufo_disable_ttvc_v4')) return allRevisions;
            if (isValidConfigArray(allRevisions)) return allRevisions;
            return [
                getDefaultTTVCRevision()
            ];
        }
        return [];
    } catch (e) {
        return [];
    }
}
function isVCRevisionEnabled(revision, experienceKey) {
    return getEnabledVCRevisions(experienceKey).includes(revision);
}
function getMostRecentVCRevision() {
    var experienceKey = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '';
    var enabledVCRevisions = getEnabledVCRevisions(experienceKey);
    if (enabledVCRevisions.length === 0) return getDefaultTTVCRevision();
    return enabledVCRevisions[enabledVCRevisions.length - 1];
}
function getReactHydrationStats() {
    if (!config) return undefined;
    try {
        var _config_getReactHydrationStats;
        var stats = config === null || config === void 0 ? void 0 : (_config_getReactHydrationStats = config.getReactHydrationStats) === null || _config_getReactHydrationStats === void 0 ? void 0 : _config_getReactHydrationStats.call(config);
        return stats !== null && stats !== void 0 ? stats : undefined;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('getReactHydrationStats threw an error: ', e);
        return undefined;
    }
}
function getInteractionRate(name, interactionKind) {
    try {
        if (!config) return 0;
        var killswitch = config.killswitch, rates = config.rates, rules = config.rules, kind = config.kind, autoGeneratedRate = config.autoGeneratedRate;
        if (killswitch != null) {
            // Specifically kill certain events
            if (killswitch.includes(name)) return 0;
        }
        var isUnknown = name === 'unknown';
        if (isUnknown) {
            if ((rates === null || rates === void 0 ? void 0 : rates[name]) != null) return rates[name];
            // Return default rate for unknown events when no explicit rate is configured
            return UNKNOWN_INTERACTION_RATE;
        }
        if (rates != null) {
            // Decide the rate explicitly
            if (rates[name] != null) return rates[name];
        }
        if (rules != null) for(var i = 0; i < rules.length; i++){
            var rule = rules[i];
            var test = rule.test, rate = rule.rate;
            if (test != null && rate != null) {
                var regexp = new RegExp(test, 'ig');
                if (regexp.test(name)) return rate;
            }
        }
        var isAutogenerated = name === null || name === void 0 ? void 0 : name.startsWith('auto-generated');
        if (isAutogenerated) {
            var rate1 = autoGeneratedRate;
            if (rate1 != null) return rate1;
        }
        if (kind != null) {
            var rate2 = kind[interactionKind];
            if (rate2 != null) return rate2;
        }
        return 0;
    } catch (e) {
        // Fallback
        return 0;
    }
}
function getExperimentalInteractionRate(name, interactionType) {
    try {
        if ((0, _platformFeatureFlags.fg)('platform_ufo_remove_experimental_holds')) return 0;
        if (!config) return 0;
        var experimentalInteractionMetrics = config.experimentalInteractionMetrics;
        if (!(experimentalInteractionMetrics === null || experimentalInteractionMetrics === void 0 ? void 0 : experimentalInteractionMetrics.enabled)) return 0;
        if (experimentalInteractionMetrics.rates && typeof experimentalInteractionMetrics.rates[name] === 'number') return experimentalInteractionMetrics.rates[name];
        if (experimentalInteractionMetrics.kind && typeof experimentalInteractionMetrics.kind[interactionType] === 'number') return experimentalInteractionMetrics.kind[interactionType];
        return 0;
    } catch (e) {
        return 0;
    }
}
function getVCRawDataInteractionRate(name, interactionType) {
    return getConfigRate(name, interactionType, 'enableVCRawDataRates');
}
function shouldUseRawDataThirdPartyBehavior(name, interactionType) {
    return getVCRawDataInteractionRate(name, interactionType) > 0;
}
function getPostInteractionRate(name, interactionType) {
    return getConfigRate(name, interactionType, 'postInteractionLog');
}
function getCapabilityRate(capability) {
    if ((0, _platformFeatureFlags.fg)('platform_ufo_remove_deprecated_config_fields')) return 1;
    try {
        if (!config) return 0;
        var capabilityRate = config.capability;
        if (capabilityRate != null) {
            var rate = capabilityRate[capability];
            if (rate != null) return rate;
        }
        return 0;
    } catch (e) {
        return 0;
    }
}
function getConfigRate(name, interactionType, configName) {
    try {
        if (!config) return 0;
        var gotConfig = config[configName];
        if (!(gotConfig === null || gotConfig === void 0 ? void 0 : gotConfig.enabled)) return 0;
        if (interactionType !== 'page_load' && interactionType !== 'transition') return 0;
        if (gotConfig.rates && typeof gotConfig.rates[name] === 'number') return gotConfig.rates[name];
        if ('kind' in gotConfig && gotConfig.kind && typeof gotConfig.kind[interactionType] === 'number') return gotConfig.kind[interactionType];
        return 0;
    } catch (e) {
        return 0;
    }
}
function getExtraInteractionRate(name, interactionType) {
    return getConfigRate(name, interactionType, 'extraInteractionMetrics');
}
var validTypingMethods = [
    'timeout',
    'timeoutNoAlloc',
    'mutationObserver'
];
function getTypingPerformanceTracingMethod() {
    var defaultMethod = 'timeout';
    try {
        if (!config) return defaultMethod;
        var typingMethod = config.typingMethod;
        if (typingMethod != null && validTypingMethods.find(function(m) {
            return m === typingMethod;
        })) return typingMethod;
        else return defaultMethod;
    } catch (e) {
        return defaultMethod;
    }
}
function getAwaitBM3TTIList() {
    try {
        if (!config) return [];
        var awaitBM3TTI = config.awaitBM3TTI;
        if (awaitBM3TTI != null) return awaitBM3TTI;
        else return [];
    } catch (e) {
        return [];
    }
}
function getUfoNameOverrides() {
    try {
        if (!config) return undefined;
        var ufoNameOverrides = config.ufoNameOverrides;
        if (ufoNameOverrides != null) return ufoNameOverrides;
        return undefined;
    } catch (e) {
        return undefined;
    }
}
function getMinorInteractions() {
    try {
        if (!config) return undefined;
        var minorInteractions = config.minorInteractions;
        return minorInteractions;
    } catch (e) {
        return undefined;
    }
}
function getDoNotAbortActivePressInteraction() {
    try {
        if (!config) return undefined;
        var doNotAbortActivePressInteraction = config.doNotAbortActivePressInteraction;
        return doNotAbortActivePressInteraction;
    } catch (e) {
        return undefined;
    }
}
function getDoNotAbortActivePressInteractionOnTransition() {
    try {
        if (!config) return undefined;
        var doNotAbortActivePressInteractionOnTransition = config.doNotAbortActivePressInteractionOnTransition;
        return doNotAbortActivePressInteractionOnTransition;
    } catch (e) {
        return undefined;
    }
}
function getFinishInteractionOnTransition() {
    try {
        if (!config) return undefined;
        var finishInteractionOnTransition = config.finishInteractionOnTransition;
        return finishInteractionOnTransition;
    } catch (e) {
        return undefined;
    }
}
var CLEANUP_TIMEOUT = 60000;
function getInteractionTimeout(ufoName) {
    try {
        if (!config) return CLEANUP_TIMEOUT;
        var interactionTimeout = config.interactionTimeout;
        if (interactionTimeout != null && interactionTimeout[ufoName] != null) return interactionTimeout[ufoName];
        if (interactionTimeout != null && interactionTimeout.__globalInteractionTimeout != null) return interactionTimeout.__globalInteractionTimeout;
        else return CLEANUP_TIMEOUT;
    } catch (e) {
        return CLEANUP_TIMEOUT;
    }
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_to_consumable_array":"1eSZf","@swc/helpers/_/_type_of":"iFJdx","@atlaskit/atlassian-context":"82Y9X","@atlaskit/platform-feature-flags":"kO5t9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7SDPo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// DO NOT CALL THIS FUNCTION DIRECTLY!!!!
// It is only to be called by React UFO libraries for the automatic handling of trace context for experiences.
// Calling this may cause trace context to be broken
parcelHelpers.export(exports, "generateSpanId", function() {
    return generateSpanId;
});
// DO NOT CALL THIS FUNCTION DIRECTLY!!!!
// It is only to be called by React UFO libraries for the automatic handling of trace context for experiences.
// Calling this may cause trace context to be broken
parcelHelpers.export(exports, "setInteractionActiveTrace", function() {
    return setInteractionActiveTrace;
});
// DO NOT CALL THIS FUNCTION DIRECTLY!!!!
// It is only to be called by React UFO libraries for the automatic handling of trace context for experiences.
// Calling this may cause trace context to be broken
parcelHelpers.export(exports, "setActiveTrace", function() {
    return setActiveTrace;
});
parcelHelpers.export(exports, "getActiveTrace", function() {
    return getActiveTrace;
});
// DO NOT CALL THIS FUNCTION DIRECTLY!!!!
// It is only to be called by React UFO libraries for the automatic handling of trace context for experiences.
// Calling this may cause trace context to be broken
parcelHelpers.export(exports, "clearActiveTrace", function() {
    return clearActiveTrace;
});
parcelHelpers.export(exports, "getActiveTraceHttpRequestHeaders", function() {
    return getActiveTraceHttpRequestHeaders;
});
parcelHelpers.export(exports, "getActiveTraceAsQueryParams", function() {
    return getActiveTraceAsQueryParams;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
var _api = require("@opentelemetry/api");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _contextManager = require("./context-manager");
var _makeTraceHttpRequestHeaders = require("./utils/make-trace-http-request-headers");
var state = {
    context: null
};
var traceIdKey = (0, _api.createContextKey)('traceId');
var spanIdKey = (0, _api.createContextKey)('spanId');
var experienceTypeKey = (0, _api.createContextKey)('type');
function generateSpanId() {
    return Array.from(new Array(16), function() {
        return Math.floor(Math.random() * 16).toString(16);
    }).join('');
}
function setInteractionActiveTrace(interactionId, experienceType) {
    setActiveTrace(interactionId.replace(/-/g, ''), generateSpanId(), experienceType);
}
function setActiveTrace(traceId, spanId, type) {
    if ((0, _platformFeatureFlags.fg)('platform_ufo_enable_otel_context_manager')) {
        var activeTraceContext = (0, _api.ROOT_CONTEXT).setValue(traceIdKey, traceId).setValue(spanIdKey, spanId).setValue(experienceTypeKey, type);
        // Now we need to get the global Context Manager and set the active context
        // Using type assertion because we've "extended" the ContextManager type
        if ((0, _instanceof._)((0, _contextManager.getContextManager)(), (0, _contextManager.UFOContextManager))) {
            var contextManager = (0, _contextManager.getContextManager)();
            contextManager.setActive(activeTraceContext);
        }
    } else state.context = {
        traceId: traceId,
        spanId: spanId,
        type: type
    };
}
function getActiveTrace() {
    if ((0, _platformFeatureFlags.fg)('platform_ufo_enable_otel_context_manager')) {
        // Get trace context from active context
        var activeTraceContext = {
            traceId: String((0, _api.context).active().getValue(traceIdKey)),
            spanId: String((0, _api.context).active().getValue(spanIdKey)),
            type: String((0, _api.context).active().getValue(experienceTypeKey))
        };
        // Return activeTraceContext if traceId and spanId are not "undefined"
        return activeTraceContext.traceId !== 'undefined' && activeTraceContext.spanId !== 'undefined' ? activeTraceContext : undefined;
    } else return state.context || undefined;
}
function clearActiveTrace() {
    if ((0, _platformFeatureFlags.fg)('platform_ufo_enable_otel_context_manager')) // Now we need to get the global Context Manager and set the active context
    // Using type assertion because we've "extended" the ContextManager type
    {
        if ((0, _instanceof._)((0, _contextManager.getContextManager)(), (0, _contextManager.UFOContextManager))) {
            var contextManager = (0, _contextManager.getContextManager)();
            // ROOT_CONTEXT is an empty context used to initialise ContextManagers
            contextManager.setActive((0, _api.ROOT_CONTEXT));
        }
    } else state.context = null;
}
function getActiveTraceHttpRequestHeaders(_url) {
    if (getActiveTrace() === undefined) return null;
    var _getActiveTrace = getActiveTrace(), traceId = _getActiveTrace.traceId, spanId = _getActiveTrace.spanId;
    return (0, _makeTraceHttpRequestHeaders.makeTraceHttpRequestHeaders)(traceId, spanId);
}
function getActiveTraceAsQueryParams(_url) {
    var traceHeaders = getActiveTraceHttpRequestHeaders();
    return traceHeaders ? new URLSearchParams(traceHeaders).toString().toLowerCase() : null;
}

},{"@swc/helpers/_/_instanceof":"h9UKc","@opentelemetry/api":"9lCa7","@atlaskit/platform-feature-flags":"kO5t9","./context-manager":"8G8ci","./utils/make-trace-http-request-headers":"lEkeb","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9lCa7":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "baggageEntryMetadataFromString", function() {
    return 0, _utils.baggageEntryMetadataFromString;
});
// Context APIs
parcelHelpers.export(exports, "createContextKey", function() {
    return 0, _context.createContextKey;
});
parcelHelpers.export(exports, "ROOT_CONTEXT", function() {
    return 0, _context.ROOT_CONTEXT;
});
// Diag APIs
parcelHelpers.export(exports, "DiagConsoleLogger", function() {
    return 0, _consoleLogger.DiagConsoleLogger;
});
parcelHelpers.export(exports, "DiagLogLevel", function() {
    return 0, _types.DiagLogLevel;
});
// Metrics APIs
parcelHelpers.export(exports, "createNoopMeter", function() {
    return 0, _noopMeter.createNoopMeter;
});
parcelHelpers.export(exports, "ValueType", function() {
    return 0, _metric.ValueType;
});
// Propagation APIs
parcelHelpers.export(exports, "defaultTextMapGetter", function() {
    return 0, _textMapPropagator.defaultTextMapGetter;
});
parcelHelpers.export(exports, "defaultTextMapSetter", function() {
    return 0, _textMapPropagator.defaultTextMapSetter;
});
parcelHelpers.export(exports, "ProxyTracer", function() {
    return 0, _proxyTracer.ProxyTracer;
});
parcelHelpers.export(exports, "ProxyTracerProvider", function() {
    return 0, _proxyTracerProvider.ProxyTracerProvider;
});
parcelHelpers.export(exports, "SamplingDecision", function() {
    return 0, _samplingResult.SamplingDecision;
});
parcelHelpers.export(exports, "SpanKind", function() {
    return 0, _spanKind.SpanKind;
});
parcelHelpers.export(exports, "SpanStatusCode", function() {
    return 0, _status.SpanStatusCode;
});
parcelHelpers.export(exports, "TraceFlags", function() {
    return 0, _traceFlags.TraceFlags;
});
parcelHelpers.export(exports, "createTraceState", function() {
    return 0, _utils1.createTraceState;
});
parcelHelpers.export(exports, "isSpanContextValid", function() {
    return 0, _spancontextUtils.isSpanContextValid;
});
parcelHelpers.export(exports, "isValidTraceId", function() {
    return 0, _spancontextUtils.isValidTraceId;
});
parcelHelpers.export(exports, "isValidSpanId", function() {
    return 0, _spancontextUtils.isValidSpanId;
});
parcelHelpers.export(exports, "INVALID_SPANID", function() {
    return 0, _invalidSpanConstants.INVALID_SPANID;
});
parcelHelpers.export(exports, "INVALID_TRACEID", function() {
    return 0, _invalidSpanConstants.INVALID_TRACEID;
});
parcelHelpers.export(exports, "INVALID_SPAN_CONTEXT", function() {
    return 0, _invalidSpanConstants.INVALID_SPAN_CONTEXT;
});
// Named export.
parcelHelpers.export(exports, "context", function() {
    return 0, _contextApi.context;
});
parcelHelpers.export(exports, "diag", function() {
    return 0, _diagApi.diag;
});
parcelHelpers.export(exports, "metrics", function() {
    return 0, _metricsApi.metrics;
});
parcelHelpers.export(exports, "propagation", function() {
    return 0, _propagationApi.propagation;
});
parcelHelpers.export(exports, "trace", function() {
    return 0, _traceApi.trace;
});
var _utils = require("./baggage/utils");
var _context = require("./context/context");
var _consoleLogger = require("./diag/consoleLogger");
var _types = require("./diag/types");
var _noopMeter = require("./metrics/NoopMeter");
var _metric = require("./metrics/Metric");
var _textMapPropagator = require("./propagation/TextMapPropagator");
var _proxyTracer = require("./trace/ProxyTracer");
var _proxyTracerProvider = require("./trace/ProxyTracerProvider");
var _samplingResult = require("./trace/SamplingResult");
var _spanKind = require("./trace/span_kind");
var _status = require("./trace/status");
var _traceFlags = require("./trace/trace_flags");
var _utils1 = require("./trace/internal/utils");
var _spancontextUtils = require("./trace/spancontext-utils");
var _invalidSpanConstants = require("./trace/invalid-span-constants");
// Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.
var _contextApi = require("./context-api");
var _diagApi = require("./diag-api");
var _metricsApi = require("./metrics-api");
var _propagationApi = require("./propagation-api");
var _traceApi = require("./trace-api");
// Default export.
exports.default = {
    context: (0, _contextApi.context),
    diag: (0, _diagApi.diag),
    metrics: (0, _metricsApi.metrics),
    propagation: (0, _propagationApi.propagation),
    trace: (0, _traceApi.trace)
};

},{"./baggage/utils":false,"./context/context":"amn9k","./diag/consoleLogger":false,"./diag/types":false,"./metrics/NoopMeter":false,"./metrics/Metric":false,"./propagation/TextMapPropagator":false,"./trace/ProxyTracer":false,"./trace/ProxyTracerProvider":false,"./trace/SamplingResult":false,"./trace/span_kind":false,"./trace/status":false,"./trace/trace_flags":false,"./trace/internal/utils":false,"./trace/spancontext-utils":false,"./trace/invalid-span-constants":false,"./context-api":"l4IpC","./diag-api":"ca71U","./metrics-api":"flr8Y","./propagation-api":"7haOh","./trace-api":"31pDO","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7Z76g":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Create a new Baggage with optional entries
 *
 * @param entries An array of baggage entries the new baggage should contain
 */ parcelHelpers.export(exports, "createBaggage", function() {
    return createBaggage;
});
/**
 * Create a serializable BaggageEntryMetadata object from a string.
 *
 * @param str string metadata. Format is currently not defined by the spec and has no special meaning.
 *
 */ parcelHelpers.export(exports, "baggageEntryMetadataFromString", function() {
    return baggageEntryMetadataFromString;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _diag = require("../api/diag");
var _baggageImpl = require("./internal/baggage-impl");
var _symbol = require("./internal/symbol");
var diag = (0, _diag.DiagAPI).instance();
function createBaggage(entries) {
    if (entries === void 0) entries = {};
    return new (0, _baggageImpl.BaggageImpl)(new Map(Object.entries(entries)));
}
function baggageEntryMetadataFromString(str) {
    if (typeof str !== 'string') {
        diag.error("Cannot create baggage metadata from unknown type: " + (typeof str === "undefined" ? "undefined" : (0, _typeOf._)(str)));
        str = '';
    }
    return {
        __TYPE__: (0, _symbol.baggageEntryMetadataSymbol),
        toString: function toString() {
            return str;
        }
    };
}

},{"@swc/helpers/_/_type_of":"iFJdx","../api/diag":"h9doG","./internal/baggage-impl":"gkjXV","./internal/symbol":"3n72C","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"h9doG":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DiagAPI", function() {
    return DiagAPI;
});
var _componentLogger = require("../diag/ComponentLogger");
var _logLevelLogger = require("../diag/internal/logLevelLogger");
var _types = require("../diag/types");
var _globalUtils = require("../internal/global-utils");
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var __spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var API_NAME = 'diag';
/**
 * Singleton object which represents the entry point to the OpenTelemetry internal
 * diagnostic API
 */ var DiagAPI = /** @class */ function() {
    /**
     * Private internal constructor
     * @private
     */ function DiagAPI() {
        function _logProxy(funcName) {
            return function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var logger = (0, _globalUtils.getGlobal)('diag');
                // shortcut if logger not set
                if (!logger) return;
                return logger[funcName].apply(logger, __spreadArray([], __read(args), false));
            };
        }
        // Using self local variable for minification purposes as 'this' cannot be minified
        var self = this;
        // DiagAPI specific functions
        var setLogger = function setLogger(logger, optionsOrLogLevel) {
            var _a, _b, _c;
            if (optionsOrLogLevel === void 0) optionsOrLogLevel = {
                logLevel: (0, _types.DiagLogLevel).INFO
            };
            if (logger === self) {
                // There isn't much we can do here.
                // Logging to the console might break the user application.
                // Try to log to self. If a logger was previously registered it will receive the log.
                var err = new Error('Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation');
                self.error((_a = err.stack) !== null && _a !== void 0 ? _a : err.message);
                return false;
            }
            if (typeof optionsOrLogLevel === 'number') optionsOrLogLevel = {
                logLevel: optionsOrLogLevel
            };
            var oldLogger = (0, _globalUtils.getGlobal)('diag');
            var newLogger = (0, _logLevelLogger.createLogLevelDiagLogger)((_b = optionsOrLogLevel.logLevel) !== null && _b !== void 0 ? _b : (0, _types.DiagLogLevel).INFO, logger);
            // There already is an logger registered. We'll let it know before overwriting it.
            if (oldLogger && !optionsOrLogLevel.suppressOverrideMessage) {
                var stack = (_c = new Error().stack) !== null && _c !== void 0 ? _c : '<failed to generate stacktrace>';
                oldLogger.warn("Current logger will be overwritten from " + stack);
                newLogger.warn("Current logger will overwrite one already registered from " + stack);
            }
            return (0, _globalUtils.registerGlobal)('diag', newLogger, self, true);
        };
        self.setLogger = setLogger;
        self.disable = function() {
            (0, _globalUtils.unregisterGlobal)(API_NAME, self);
        };
        self.createComponentLogger = function(options) {
            return new (0, _componentLogger.DiagComponentLogger)(options);
        };
        self.verbose = _logProxy('verbose');
        self.debug = _logProxy('debug');
        self.info = _logProxy('info');
        self.warn = _logProxy('warn');
        self.error = _logProxy('error');
    }
    /** Get the singleton instance of the DiagAPI API */ DiagAPI.instance = function() {
        if (!this._instance) this._instance = new DiagAPI();
        return this._instance;
    };
    return DiagAPI;
}();

},{"../diag/ComponentLogger":"lEkPr","../diag/internal/logLevelLogger":"lmfou","../diag/types":"llRAn","../internal/global-utils":"4g6BY","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lEkPr":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DiagComponentLogger", function() {
    return DiagComponentLogger;
});
var _globalUtils = require("../internal/global-utils");
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var __spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * Component Logger which is meant to be used as part of any component which
 * will add automatically additional namespace in front of the log message.
 * It will then forward all message to global diag logger
 * @example
 * const cLogger = diag.createComponentLogger({ namespace: '@opentelemetry/instrumentation-http' });
 * cLogger.debug('test');
 * // @opentelemetry/instrumentation-http test
 */ var DiagComponentLogger = /** @class */ function() {
    function DiagComponentLogger(props) {
        this._namespace = props.namespace || 'DiagComponentLogger';
    }
    DiagComponentLogger.prototype.debug = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return logProxy('debug', this._namespace, args);
    };
    DiagComponentLogger.prototype.error = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return logProxy('error', this._namespace, args);
    };
    DiagComponentLogger.prototype.info = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return logProxy('info', this._namespace, args);
    };
    DiagComponentLogger.prototype.warn = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return logProxy('warn', this._namespace, args);
    };
    DiagComponentLogger.prototype.verbose = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return logProxy('verbose', this._namespace, args);
    };
    return DiagComponentLogger;
}();
function logProxy(funcName, namespace, args) {
    var logger = (0, _globalUtils.getGlobal)('diag');
    // shortcut if logger not set
    if (!logger) return;
    args.unshift(namespace);
    return logger[funcName].apply(logger, __spreadArray([], __read(args), false));
}

},{"../internal/global-utils":"4g6BY","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4g6BY":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "registerGlobal", function() {
    return registerGlobal;
});
parcelHelpers.export(exports, "getGlobal", function() {
    return getGlobal;
});
parcelHelpers.export(exports, "unregisterGlobal", function() {
    return unregisterGlobal;
});
var _platform = require("../platform");
var _version = require("../version");
var _semver = require("./semver");
var major = (0, _version.VERSION).split('.')[0];
var GLOBAL_OPENTELEMETRY_API_KEY = Symbol.for("opentelemetry.js.api." + major);
var _global = (0, _platform._globalThis);
function registerGlobal(type, instance, diag, allowOverride) {
    var _a;
    if (allowOverride === void 0) allowOverride = false;
    var api = _global[GLOBAL_OPENTELEMETRY_API_KEY] = (_a = _global[GLOBAL_OPENTELEMETRY_API_KEY]) !== null && _a !== void 0 ? _a : {
        version: (0, _version.VERSION)
    };
    if (!allowOverride && api[type]) {
        // already registered an API of this type
        var err = new Error("@opentelemetry/api: Attempted duplicate registration of API: " + type);
        diag.error(err.stack || err.message);
        return false;
    }
    if (api.version !== (0, _version.VERSION)) {
        // All registered APIs must be of the same version exactly
        var err = new Error("@opentelemetry/api: Registration of version v" + api.version + " for " + type + " does not match previously registered API v" + (0, _version.VERSION));
        diag.error(err.stack || err.message);
        return false;
    }
    api[type] = instance;
    diag.debug("@opentelemetry/api: Registered a global for " + type + " v" + (0, _version.VERSION) + ".");
    return true;
}
function getGlobal(type) {
    var _a, _b;
    var globalVersion = (_a = _global[GLOBAL_OPENTELEMETRY_API_KEY]) === null || _a === void 0 ? void 0 : _a.version;
    if (!globalVersion || !(0, _semver.isCompatible)(globalVersion)) return;
    return (_b = _global[GLOBAL_OPENTELEMETRY_API_KEY]) === null || _b === void 0 ? void 0 : _b[type];
}
function unregisterGlobal(type, diag) {
    diag.debug("@opentelemetry/api: Unregistering a global for " + type + " v" + (0, _version.VERSION) + ".");
    var api = _global[GLOBAL_OPENTELEMETRY_API_KEY];
    if (api) delete api[type];
}

},{"../platform":"aOLF6","../version":"bmtug","./semver":"akR6S","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aOLF6":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _globalThis = require("./globalThis");
parcelHelpers.exportAll(_globalThis, exports);

},{"./globalThis":"fxXZa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fxXZa":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Updates to this file should also be replicated to @opentelemetry/core too.
/**
 * - globalThis (New standard)
 * - self (Will return the current window instance for supported browsers)
 * - window (fallback for older browser implementations)
 * - global (NodeJS implementation)
 * - <object> (When all else fails)
 */ /** only globals that common to node and browsers are allowed */ // eslint-disable-next-line node/no-unsupported-features/es-builtins, no-undef
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_globalThis", function() {
    return _globalThis;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var global = arguments[3];
var _globalThis = (typeof globalThis === "undefined" ? "undefined" : (0, _typeOf._)(globalThis)) === 'object' ? globalThis : (typeof self === "undefined" ? "undefined" : (0, _typeOf._)(self)) === 'object' ? self : (typeof window === "undefined" ? "undefined" : (0, _typeOf._)(window)) === 'object' ? window : (typeof global === "undefined" ? "undefined" : (0, _typeOf._)(global)) === 'object' ? global : {};

},{"@swc/helpers/_/_type_of":"iFJdx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bmtug":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // this is autogenerated file, see scripts/version-update.js
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VERSION", function() {
    return VERSION;
});
var VERSION = '1.9.0';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"akR6S":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Create a function to test an API version to see if it is compatible with the provided ownVersion.
 *
 * The returned function has the following semantics:
 * - Exact match is always compatible
 * - Major versions must match exactly
 *    - 1.x package cannot use global 2.x package
 *    - 2.x package cannot use global 1.x package
 * - The minor version of the API module requesting access to the global API must be less than or equal to the minor version of this API
 *    - 1.3 package may use 1.4 global because the later global contains all functions 1.3 expects
 *    - 1.4 package may NOT use 1.3 global because it may try to call functions which don't exist on 1.3
 * - If the major version is 0, the minor version is treated as the major and the patch is treated as the minor
 * - Patch and build tag differences are not considered at this time
 *
 * @param ownVersion version which should be checked against
 */ parcelHelpers.export(exports, "_makeCompatibilityCheck", function() {
    return _makeCompatibilityCheck;
});
parcelHelpers.export(exports, "isCompatible", function() {
    return isCompatible;
});
var _version = require("../version");
var re = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/;
function _makeCompatibilityCheck(ownVersion) {
    var acceptedVersions = new Set([
        ownVersion
    ]);
    var rejectedVersions = new Set();
    var myVersionMatch = ownVersion.match(re);
    if (!myVersionMatch) // we cannot guarantee compatibility so we always return noop
    return function() {
        return false;
    };
    var ownVersionParsed = {
        major: +myVersionMatch[1],
        minor: +myVersionMatch[2],
        patch: +myVersionMatch[3],
        prerelease: myVersionMatch[4]
    };
    // if ownVersion has a prerelease tag, versions must match exactly
    if (ownVersionParsed.prerelease != null) return function isExactmatch(globalVersion) {
        return globalVersion === ownVersion;
    };
    function _reject(v) {
        rejectedVersions.add(v);
        return false;
    }
    function _accept(v) {
        acceptedVersions.add(v);
        return true;
    }
    return function isCompatible(globalVersion) {
        if (acceptedVersions.has(globalVersion)) return true;
        if (rejectedVersions.has(globalVersion)) return false;
        var globalVersionMatch = globalVersion.match(re);
        if (!globalVersionMatch) // cannot parse other version
        // we cannot guarantee compatibility so we always noop
        return _reject(globalVersion);
        var globalVersionParsed = {
            major: +globalVersionMatch[1],
            minor: +globalVersionMatch[2],
            patch: +globalVersionMatch[3],
            prerelease: globalVersionMatch[4]
        };
        // if globalVersion has a prerelease tag, versions must match exactly
        if (globalVersionParsed.prerelease != null) return _reject(globalVersion);
        // major versions must match
        if (ownVersionParsed.major !== globalVersionParsed.major) return _reject(globalVersion);
        if (ownVersionParsed.major === 0) {
            if (ownVersionParsed.minor === globalVersionParsed.minor && ownVersionParsed.patch <= globalVersionParsed.patch) return _accept(globalVersion);
            return _reject(globalVersion);
        }
        if (ownVersionParsed.minor <= globalVersionParsed.minor) return _accept(globalVersion);
        return _reject(globalVersion);
    };
}
var isCompatible = _makeCompatibilityCheck((0, _version.VERSION));

},{"../version":"bmtug","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lmfou":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createLogLevelDiagLogger", function() {
    return createLogLevelDiagLogger;
});
var _types = require("../types");
function createLogLevelDiagLogger(maxLevel, logger) {
    if (maxLevel < (0, _types.DiagLogLevel).NONE) maxLevel = (0, _types.DiagLogLevel).NONE;
    else if (maxLevel > (0, _types.DiagLogLevel).ALL) maxLevel = (0, _types.DiagLogLevel).ALL;
    // In case the logger is null or undefined
    logger = logger || {};
    function _filterFunc(funcName, theLevel) {
        var theFunc = logger[funcName];
        if (typeof theFunc === 'function' && maxLevel >= theLevel) return theFunc.bind(logger);
        return function() {};
    }
    return {
        error: _filterFunc('error', (0, _types.DiagLogLevel).ERROR),
        warn: _filterFunc('warn', (0, _types.DiagLogLevel).WARN),
        info: _filterFunc('info', (0, _types.DiagLogLevel).INFO),
        debug: _filterFunc('debug', (0, _types.DiagLogLevel).DEBUG),
        verbose: _filterFunc('verbose', (0, _types.DiagLogLevel).VERBOSE)
    };
}

},{"../types":"llRAn","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"llRAn":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Defines the available internal logging levels for the diagnostic logger, the numeric values
 * of the levels are defined to match the original values from the initial LogLevel to avoid
 * compatibility/migration issues for any implementation that assume the numeric ordering.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DiagLogLevel", function() {
    return DiagLogLevel;
});
var DiagLogLevel;
(function(DiagLogLevel) {
    /** Diagnostic Logging level setting to disable all logging (except and forced logs) */ DiagLogLevel[DiagLogLevel["NONE"] = 0] = "NONE";
    /** Identifies an error scenario */ DiagLogLevel[DiagLogLevel["ERROR"] = 30] = "ERROR";
    /** Identifies a warning scenario */ DiagLogLevel[DiagLogLevel["WARN"] = 50] = "WARN";
    /** General informational log message */ DiagLogLevel[DiagLogLevel["INFO"] = 60] = "INFO";
    /** General debug log message */ DiagLogLevel[DiagLogLevel["DEBUG"] = 70] = "DEBUG";
    /**
     * Detailed trace level logging should only be used for development, should only be set
     * in a development environment.
     */ DiagLogLevel[DiagLogLevel["VERBOSE"] = 80] = "VERBOSE";
    /** Used to set the logging level to include all logging */ DiagLogLevel[DiagLogLevel["ALL"] = 9999] = "ALL";
})(DiagLogLevel || (DiagLogLevel = {}));

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gkjXV":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BaggageImpl", function() {
    return BaggageImpl;
});
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var __values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var BaggageImpl = /** @class */ function() {
    function BaggageImpl(entries) {
        this._entries = entries ? new Map(entries) : new Map();
    }
    BaggageImpl.prototype.getEntry = function(key) {
        var entry = this._entries.get(key);
        if (!entry) return undefined;
        return Object.assign({}, entry);
    };
    BaggageImpl.prototype.getAllEntries = function() {
        return Array.from(this._entries.entries()).map(function(_a) {
            var _b = __read(_a, 2), k = _b[0], v = _b[1];
            return [
                k,
                v
            ];
        });
    };
    BaggageImpl.prototype.setEntry = function(key, entry) {
        var newBaggage = new BaggageImpl(this._entries);
        newBaggage._entries.set(key, entry);
        return newBaggage;
    };
    BaggageImpl.prototype.removeEntry = function(key) {
        var newBaggage = new BaggageImpl(this._entries);
        newBaggage._entries.delete(key);
        return newBaggage;
    };
    BaggageImpl.prototype.removeEntries = function() {
        var e_1, _a;
        var keys = [];
        for(var _i = 0; _i < arguments.length; _i++)keys[_i] = arguments[_i];
        var newBaggage = new BaggageImpl(this._entries);
        try {
            for(var keys_1 = __values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()){
                var key = keys_1_1.value;
                newBaggage._entries.delete(key);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return newBaggage;
    };
    BaggageImpl.prototype.clear = function() {
        return new BaggageImpl();
    };
    return BaggageImpl;
}();

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3n72C":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Symbol used to make BaggageEntryMetadata an opaque type
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "baggageEntryMetadataSymbol", function() {
    return baggageEntryMetadataSymbol;
});
var baggageEntryMetadataSymbol = Symbol('BaggageEntryMetadata');

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"amn9k":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Get a key to uniquely identify a context value */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createContextKey", function() {
    return createContextKey;
});
parcelHelpers.export(exports, "ROOT_CONTEXT", function() {
    return ROOT_CONTEXT;
});
function createContextKey(description) {
    // The specification states that for the same input, multiple calls should
    // return different keys. Due to the nature of the JS dependency management
    // system, this creates problems where multiple versions of some package
    // could hold different keys for the same property.
    //
    // Therefore, we use Symbol.for which returns the same key for the same input.
    return Symbol.for(description);
}
var BaseContext = /** @class */ function() {
    /**
     * Construct a new context which inherits values from an optional parent context.
     *
     * @param parentContext a context from which to inherit values
     */ function BaseContext(parentContext) {
        // for minification
        var self = this;
        self._currentContext = parentContext ? new Map(parentContext) : new Map();
        self.getValue = function(key) {
            return self._currentContext.get(key);
        };
        self.setValue = function(key, value) {
            var context = new BaseContext(self._currentContext);
            context._currentContext.set(key, value);
            return context;
        };
        self.deleteValue = function(key) {
            var context = new BaseContext(self._currentContext);
            context._currentContext.delete(key);
            return context;
        };
    }
    return BaseContext;
}();
var ROOT_CONTEXT = new BaseContext();

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"irnKi":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NoopMeter", function() {
    return NoopMeter;
});
parcelHelpers.export(exports, "NoopMetric", function() {
    return NoopMetric;
});
parcelHelpers.export(exports, "NoopCounterMetric", function() {
    return NoopCounterMetric;
});
parcelHelpers.export(exports, "NoopUpDownCounterMetric", function() {
    return NoopUpDownCounterMetric;
});
parcelHelpers.export(exports, "NoopGaugeMetric", function() {
    return NoopGaugeMetric;
});
parcelHelpers.export(exports, "NoopHistogramMetric", function() {
    return NoopHistogramMetric;
});
parcelHelpers.export(exports, "NoopObservableMetric", function() {
    return NoopObservableMetric;
});
parcelHelpers.export(exports, "NoopObservableCounterMetric", function() {
    return NoopObservableCounterMetric;
});
parcelHelpers.export(exports, "NoopObservableGaugeMetric", function() {
    return NoopObservableGaugeMetric;
});
parcelHelpers.export(exports, "NoopObservableUpDownCounterMetric", function() {
    return NoopObservableUpDownCounterMetric;
});
parcelHelpers.export(exports, "NOOP_METER", function() {
    return NOOP_METER;
});
parcelHelpers.export(exports, "NOOP_COUNTER_METRIC", function() {
    return NOOP_COUNTER_METRIC;
});
parcelHelpers.export(exports, "NOOP_GAUGE_METRIC", function() {
    return NOOP_GAUGE_METRIC;
});
parcelHelpers.export(exports, "NOOP_HISTOGRAM_METRIC", function() {
    return NOOP_HISTOGRAM_METRIC;
});
parcelHelpers.export(exports, "NOOP_UP_DOWN_COUNTER_METRIC", function() {
    return NOOP_UP_DOWN_COUNTER_METRIC;
});
parcelHelpers.export(exports, "NOOP_OBSERVABLE_COUNTER_METRIC", function() {
    return NOOP_OBSERVABLE_COUNTER_METRIC;
});
parcelHelpers.export(exports, "NOOP_OBSERVABLE_GAUGE_METRIC", function() {
    return NOOP_OBSERVABLE_GAUGE_METRIC;
});
parcelHelpers.export(exports, "NOOP_OBSERVABLE_UP_DOWN_COUNTER_METRIC", function() {
    return NOOP_OBSERVABLE_UP_DOWN_COUNTER_METRIC;
});
/**
 * Create a no-op Meter
 */ parcelHelpers.export(exports, "createNoopMeter", function() {
    return createNoopMeter;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
var __extends = undefined && undefined.__extends || function() {
    var extendStatics = function extendStatics1(d, b) {
        extendStatics = Object.setPrototypeOf || (0, _instanceof._)({
            __proto__: []
        }, Array) && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * NoopMeter is a noop implementation of the {@link Meter} interface. It reuses
 * constant NoopMetrics for all of its methods.
 */ var NoopMeter = /** @class */ function() {
    function NoopMeter() {}
    /**
     * @see {@link Meter.createGauge}
     */ NoopMeter.prototype.createGauge = function(_name, _options) {
        return NOOP_GAUGE_METRIC;
    };
    /**
     * @see {@link Meter.createHistogram}
     */ NoopMeter.prototype.createHistogram = function(_name, _options) {
        return NOOP_HISTOGRAM_METRIC;
    };
    /**
     * @see {@link Meter.createCounter}
     */ NoopMeter.prototype.createCounter = function(_name, _options) {
        return NOOP_COUNTER_METRIC;
    };
    /**
     * @see {@link Meter.createUpDownCounter}
     */ NoopMeter.prototype.createUpDownCounter = function(_name, _options) {
        return NOOP_UP_DOWN_COUNTER_METRIC;
    };
    /**
     * @see {@link Meter.createObservableGauge}
     */ NoopMeter.prototype.createObservableGauge = function(_name, _options) {
        return NOOP_OBSERVABLE_GAUGE_METRIC;
    };
    /**
     * @see {@link Meter.createObservableCounter}
     */ NoopMeter.prototype.createObservableCounter = function(_name, _options) {
        return NOOP_OBSERVABLE_COUNTER_METRIC;
    };
    /**
     * @see {@link Meter.createObservableUpDownCounter}
     */ NoopMeter.prototype.createObservableUpDownCounter = function(_name, _options) {
        return NOOP_OBSERVABLE_UP_DOWN_COUNTER_METRIC;
    };
    /**
     * @see {@link Meter.addBatchObservableCallback}
     */ NoopMeter.prototype.addBatchObservableCallback = function(_callback, _observables) {};
    /**
     * @see {@link Meter.removeBatchObservableCallback}
     */ NoopMeter.prototype.removeBatchObservableCallback = function(_callback) {};
    return NoopMeter;
}();
var NoopMetric = /** @class */ function() {
    function NoopMetric() {}
    return NoopMetric;
}();
var NoopCounterMetric = /** @class */ function(_super) {
    __extends(NoopCounterMetric, _super);
    function NoopCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopCounterMetric.prototype.add = function(_value, _attributes) {};
    return NoopCounterMetric;
}(NoopMetric);
var NoopUpDownCounterMetric = /** @class */ function(_super) {
    __extends(NoopUpDownCounterMetric, _super);
    function NoopUpDownCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopUpDownCounterMetric.prototype.add = function(_value, _attributes) {};
    return NoopUpDownCounterMetric;
}(NoopMetric);
var NoopGaugeMetric = /** @class */ function(_super) {
    __extends(NoopGaugeMetric, _super);
    function NoopGaugeMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopGaugeMetric.prototype.record = function(_value, _attributes) {};
    return NoopGaugeMetric;
}(NoopMetric);
var NoopHistogramMetric = /** @class */ function(_super) {
    __extends(NoopHistogramMetric, _super);
    function NoopHistogramMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopHistogramMetric.prototype.record = function(_value, _attributes) {};
    return NoopHistogramMetric;
}(NoopMetric);
var NoopObservableMetric = /** @class */ function() {
    function NoopObservableMetric() {}
    NoopObservableMetric.prototype.addCallback = function(_callback) {};
    NoopObservableMetric.prototype.removeCallback = function(_callback) {};
    return NoopObservableMetric;
}();
var NoopObservableCounterMetric = /** @class */ function(_super) {
    __extends(NoopObservableCounterMetric, _super);
    function NoopObservableCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableCounterMetric;
}(NoopObservableMetric);
var NoopObservableGaugeMetric = /** @class */ function(_super) {
    __extends(NoopObservableGaugeMetric, _super);
    function NoopObservableGaugeMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableGaugeMetric;
}(NoopObservableMetric);
var NoopObservableUpDownCounterMetric = /** @class */ function(_super) {
    __extends(NoopObservableUpDownCounterMetric, _super);
    function NoopObservableUpDownCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableUpDownCounterMetric;
}(NoopObservableMetric);
var NOOP_METER = new NoopMeter();
var NOOP_COUNTER_METRIC = new NoopCounterMetric();
var NOOP_GAUGE_METRIC = new NoopGaugeMetric();
var NOOP_HISTOGRAM_METRIC = new NoopHistogramMetric();
var NOOP_UP_DOWN_COUNTER_METRIC = new NoopUpDownCounterMetric();
var NOOP_OBSERVABLE_COUNTER_METRIC = new NoopObservableCounterMetric();
var NOOP_OBSERVABLE_GAUGE_METRIC = new NoopObservableGaugeMetric();
var NOOP_OBSERVABLE_UP_DOWN_COUNTER_METRIC = new NoopObservableUpDownCounterMetric();
function createNoopMeter() {
    return NOOP_METER;
}

},{"@swc/helpers/_/_instanceof":"h9UKc","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3L3VX":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultTextMapGetter", function() {
    return defaultTextMapGetter;
});
parcelHelpers.export(exports, "defaultTextMapSetter", function() {
    return defaultTextMapSetter;
});
var defaultTextMapGetter = {
    get: function get(carrier, key) {
        if (carrier == null) return undefined;
        return carrier[key];
    },
    keys: function keys(carrier) {
        if (carrier == null) return [];
        return Object.keys(carrier);
    }
};
var defaultTextMapSetter = {
    set: function set(carrier, key, value) {
        if (carrier == null) return;
        carrier[key] = value;
    }
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kQ0Z4":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProxyTracer", function() {
    return ProxyTracer;
});
var _noopTracer = require("./NoopTracer");
var NOOP_TRACER = new (0, _noopTracer.NoopTracer)();
/**
 * Proxy tracer provided by the proxy tracer provider
 */ var ProxyTracer = /** @class */ function() {
    function ProxyTracer(_provider, name, version, options) {
        this._provider = _provider;
        this.name = name;
        this.version = version;
        this.options = options;
    }
    ProxyTracer.prototype.startSpan = function(name, options, context) {
        return this._getTracer().startSpan(name, options, context);
    };
    ProxyTracer.prototype.startActiveSpan = function(_name, _options, _context, _fn) {
        var tracer = this._getTracer();
        return Reflect.apply(tracer.startActiveSpan, tracer, arguments);
    };
    /**
     * Try to get a tracer from the proxy tracer provider.
     * If the proxy tracer provider has no delegate, return a noop tracer.
     */ ProxyTracer.prototype._getTracer = function() {
        if (this._delegate) return this._delegate;
        var tracer = this._provider.getDelegateTracer(this.name, this.version, this.options);
        if (!tracer) return NOOP_TRACER;
        this._delegate = tracer;
        return this._delegate;
    };
    return ProxyTracer;
}();

},{"./NoopTracer":"gCsUG","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gCsUG":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NoopTracer", function() {
    return NoopTracer;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _context = require("../api/context");
var _contextUtils = require("../trace/context-utils");
var _nonRecordingSpan = require("./NonRecordingSpan");
var _spancontextUtils = require("./spancontext-utils");
var contextApi = (0, _context.ContextAPI).getInstance();
/**
 * No-op implementations of {@link Tracer}.
 */ var NoopTracer = /** @class */ function() {
    function NoopTracer() {}
    // startSpan starts a noop span.
    NoopTracer.prototype.startSpan = function(name, options, context) {
        if (context === void 0) context = contextApi.active();
        var root = Boolean(options === null || options === void 0 ? void 0 : options.root);
        if (root) return new (0, _nonRecordingSpan.NonRecordingSpan)();
        var parentFromContext = context && (0, _contextUtils.getSpanContext)(context);
        if (isSpanContext(parentFromContext) && (0, _spancontextUtils.isSpanContextValid)(parentFromContext)) return new (0, _nonRecordingSpan.NonRecordingSpan)(parentFromContext);
        else return new (0, _nonRecordingSpan.NonRecordingSpan)();
    };
    NoopTracer.prototype.startActiveSpan = function(name, arg2, arg3, arg4) {
        var opts;
        var ctx;
        var fn;
        if (arguments.length < 2) return;
        else if (arguments.length === 2) fn = arg2;
        else if (arguments.length === 3) {
            opts = arg2;
            fn = arg3;
        } else {
            opts = arg2;
            ctx = arg3;
            fn = arg4;
        }
        var parentContext = ctx !== null && ctx !== void 0 ? ctx : contextApi.active();
        var span = this.startSpan(name, opts, parentContext);
        var contextWithSpanSet = (0, _contextUtils.setSpan)(parentContext, span);
        return contextApi.with(contextWithSpanSet, fn, undefined, span);
    };
    return NoopTracer;
}();
function isSpanContext(spanContext) {
    return (typeof spanContext === "undefined" ? "undefined" : (0, _typeOf._)(spanContext)) === 'object' && typeof spanContext['spanId'] === 'string' && typeof spanContext['traceId'] === 'string' && typeof spanContext['traceFlags'] === 'number';
}

},{"@swc/helpers/_/_type_of":"iFJdx","../api/context":"f7atw","../trace/context-utils":"1ENWh","./NonRecordingSpan":"enlTB","./spancontext-utils":"bv17A","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"f7atw":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ContextAPI", function() {
    return ContextAPI;
});
var _noopContextManager = require("../context/NoopContextManager");
var _globalUtils = require("../internal/global-utils");
var _diag = require("./diag");
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var __spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var API_NAME = 'context';
var NOOP_CONTEXT_MANAGER = new (0, _noopContextManager.NoopContextManager)();
/**
 * Singleton object which represents the entry point to the OpenTelemetry Context API
 */ var ContextAPI = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function ContextAPI() {}
    /** Get the singleton instance of the Context API */ ContextAPI.getInstance = function() {
        if (!this._instance) this._instance = new ContextAPI();
        return this._instance;
    };
    /**
     * Set the current context manager.
     *
     * @returns true if the context manager was successfully registered, else false
     */ ContextAPI.prototype.setGlobalContextManager = function(contextManager) {
        return (0, _globalUtils.registerGlobal)(API_NAME, contextManager, (0, _diag.DiagAPI).instance());
    };
    /**
     * Get the currently active context
     */ ContextAPI.prototype.active = function() {
        return this._getContextManager().active();
    };
    /**
     * Execute a function with an active context
     *
     * @param context context to be active during function execution
     * @param fn function to execute in a context
     * @param thisArg optional receiver to be used for calling fn
     * @param args optional arguments forwarded to fn
     */ ContextAPI.prototype.with = function(context, fn, thisArg) {
        var _a;
        var args = [];
        for(var _i = 3; _i < arguments.length; _i++)args[_i - 3] = arguments[_i];
        return (_a = this._getContextManager()).with.apply(_a, __spreadArray([
            context,
            fn,
            thisArg
        ], __read(args), false));
    };
    /**
     * Bind a context to a target function or event emitter
     *
     * @param context context to bind to the event emitter or function. Defaults to the currently active context
     * @param target function or event emitter to bind
     */ ContextAPI.prototype.bind = function(context, target) {
        return this._getContextManager().bind(context, target);
    };
    ContextAPI.prototype._getContextManager = function() {
        return (0, _globalUtils.getGlobal)(API_NAME) || NOOP_CONTEXT_MANAGER;
    };
    /** Disable and remove the global context manager */ ContextAPI.prototype.disable = function() {
        this._getContextManager().disable();
        (0, _globalUtils.unregisterGlobal)(API_NAME, (0, _diag.DiagAPI).instance());
    };
    return ContextAPI;
}();

},{"../context/NoopContextManager":"5hGhU","../internal/global-utils":"4g6BY","./diag":"h9doG","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5hGhU":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NoopContextManager", function() {
    return NoopContextManager;
});
var _context = require("./context");
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var __spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var NoopContextManager = /** @class */ function() {
    function NoopContextManager() {}
    NoopContextManager.prototype.active = function() {
        return 0, _context.ROOT_CONTEXT;
    };
    NoopContextManager.prototype.with = function(_context, fn, thisArg) {
        var args = [];
        for(var _i = 3; _i < arguments.length; _i++)args[_i - 3] = arguments[_i];
        return fn.call.apply(fn, __spreadArray([
            thisArg
        ], __read(args), false));
    };
    NoopContextManager.prototype.bind = function(_context, target) {
        return target;
    };
    NoopContextManager.prototype.enable = function() {
        return this;
    };
    NoopContextManager.prototype.disable = function() {
        return this;
    };
    return NoopContextManager;
}();

},{"./context":"amn9k","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1ENWh":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Return the span if one exists
 *
 * @param context context to get span from
 */ parcelHelpers.export(exports, "getSpan", function() {
    return getSpan;
});
/**
 * Gets the span from the current context, if one exists.
 */ parcelHelpers.export(exports, "getActiveSpan", function() {
    return getActiveSpan;
});
/**
 * Set the span on a context
 *
 * @param context context to use as parent
 * @param span span to set active
 */ parcelHelpers.export(exports, "setSpan", function() {
    return setSpan;
});
/**
 * Remove current span stored in the context
 *
 * @param context context to delete span from
 */ parcelHelpers.export(exports, "deleteSpan", function() {
    return deleteSpan;
});
/**
 * Wrap span context in a NoopSpan and set as span in a new
 * context
 *
 * @param context context to set active span on
 * @param spanContext span context to be wrapped
 */ parcelHelpers.export(exports, "setSpanContext", function() {
    return setSpanContext;
});
/**
 * Get the span context of the span if it exists.
 *
 * @param context context to get values from
 */ parcelHelpers.export(exports, "getSpanContext", function() {
    return getSpanContext;
});
var _context = require("../context/context");
var _nonRecordingSpan = require("./NonRecordingSpan");
var _context1 = require("../api/context");
/**
 * span key
 */ var SPAN_KEY = (0, _context.createContextKey)('OpenTelemetry Context Key SPAN');
function getSpan(context) {
    return context.getValue(SPAN_KEY) || undefined;
}
function getActiveSpan() {
    return getSpan((0, _context1.ContextAPI).getInstance().active());
}
function setSpan(context, span) {
    return context.setValue(SPAN_KEY, span);
}
function deleteSpan(context) {
    return context.deleteValue(SPAN_KEY);
}
function setSpanContext(context, spanContext) {
    return setSpan(context, new (0, _nonRecordingSpan.NonRecordingSpan)(spanContext));
}
function getSpanContext(context) {
    var _a;
    return (_a = getSpan(context)) === null || _a === void 0 ? void 0 : _a.spanContext();
}

},{"../context/context":"amn9k","./NonRecordingSpan":"enlTB","../api/context":"f7atw","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"enlTB":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NonRecordingSpan", function() {
    return NonRecordingSpan;
});
var _invalidSpanConstants = require("./invalid-span-constants");
/**
 * The NonRecordingSpan is the default {@link Span} that is used when no Span
 * implementation is available. All operations are no-op including context
 * propagation.
 */ var NonRecordingSpan = /** @class */ function() {
    function NonRecordingSpan(_spanContext) {
        if (_spanContext === void 0) _spanContext = (0, _invalidSpanConstants.INVALID_SPAN_CONTEXT);
        this._spanContext = _spanContext;
    }
    // Returns a SpanContext.
    NonRecordingSpan.prototype.spanContext = function() {
        return this._spanContext;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setAttribute = function(_key, _value) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setAttributes = function(_attributes) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.addEvent = function(_name, _attributes) {
        return this;
    };
    NonRecordingSpan.prototype.addLink = function(_link) {
        return this;
    };
    NonRecordingSpan.prototype.addLinks = function(_links) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setStatus = function(_status) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.updateName = function(_name) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.end = function(_endTime) {};
    // isRecording always returns false for NonRecordingSpan.
    NonRecordingSpan.prototype.isRecording = function() {
        return false;
    };
    // By default does nothing
    NonRecordingSpan.prototype.recordException = function(_exception, _time) {};
    return NonRecordingSpan;
}();

},{"./invalid-span-constants":"jdt5C","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jdt5C":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "INVALID_SPANID", function() {
    return INVALID_SPANID;
});
parcelHelpers.export(exports, "INVALID_TRACEID", function() {
    return INVALID_TRACEID;
});
parcelHelpers.export(exports, "INVALID_SPAN_CONTEXT", function() {
    return INVALID_SPAN_CONTEXT;
});
var _traceFlags = require("./trace_flags");
var INVALID_SPANID = '0000000000000000';
var INVALID_TRACEID = '00000000000000000000000000000000';
var INVALID_SPAN_CONTEXT = {
    traceId: INVALID_TRACEID,
    spanId: INVALID_SPANID,
    traceFlags: (0, _traceFlags.TraceFlags).NONE
};

},{"./trace_flags":"jhO1Z","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jhO1Z":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TraceFlags", function() {
    return TraceFlags;
});
var TraceFlags;
(function(TraceFlags) {
    /** Represents no flag set. */ TraceFlags[TraceFlags["NONE"] = 0] = "NONE";
    /** Bit to represent whether trace is sampled in trace flags. */ TraceFlags[TraceFlags["SAMPLED"] = 1] = "SAMPLED";
})(TraceFlags || (TraceFlags = {}));

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bv17A":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isValidTraceId", function() {
    return isValidTraceId;
});
parcelHelpers.export(exports, "isValidSpanId", function() {
    return isValidSpanId;
});
/**
 * Returns true if this {@link SpanContext} is valid.
 * @return true if this {@link SpanContext} is valid.
 */ parcelHelpers.export(exports, "isSpanContextValid", function() {
    return isSpanContextValid;
});
/**
 * Wrap the given {@link SpanContext} in a new non-recording {@link Span}
 *
 * @param spanContext span context to be wrapped
 * @returns a new non-recording {@link Span} with the provided context
 */ parcelHelpers.export(exports, "wrapSpanContext", function() {
    return wrapSpanContext;
});
var _invalidSpanConstants = require("./invalid-span-constants");
var _nonRecordingSpan = require("./NonRecordingSpan");
var VALID_TRACEID_REGEX = /^([0-9a-f]{32})$/i;
var VALID_SPANID_REGEX = /^[0-9a-f]{16}$/i;
function isValidTraceId(traceId) {
    return VALID_TRACEID_REGEX.test(traceId) && traceId !== (0, _invalidSpanConstants.INVALID_TRACEID);
}
function isValidSpanId(spanId) {
    return VALID_SPANID_REGEX.test(spanId) && spanId !== (0, _invalidSpanConstants.INVALID_SPANID);
}
function isSpanContextValid(spanContext) {
    return isValidTraceId(spanContext.traceId) && isValidSpanId(spanContext.spanId);
}
function wrapSpanContext(spanContext) {
    return new (0, _nonRecordingSpan.NonRecordingSpan)(spanContext);
}

},{"./invalid-span-constants":"jdt5C","./NonRecordingSpan":"enlTB","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iWUmK":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProxyTracerProvider", function() {
    return ProxyTracerProvider;
});
var _proxyTracer = require("./ProxyTracer");
var _noopTracerProvider = require("./NoopTracerProvider");
var NOOP_TRACER_PROVIDER = new (0, _noopTracerProvider.NoopTracerProvider)();
/**
 * Tracer provider which provides {@link ProxyTracer}s.
 *
 * Before a delegate is set, tracers provided are NoOp.
 *   When a delegate is set, traces are provided from the delegate.
 *   When a delegate is set after tracers have already been provided,
 *   all tracers already provided will use the provided delegate implementation.
 */ var ProxyTracerProvider = /** @class */ function() {
    function ProxyTracerProvider() {}
    /**
     * Get a {@link ProxyTracer}
     */ ProxyTracerProvider.prototype.getTracer = function(name, version, options) {
        var _a;
        return (_a = this.getDelegateTracer(name, version, options)) !== null && _a !== void 0 ? _a : new (0, _proxyTracer.ProxyTracer)(this, name, version, options);
    };
    ProxyTracerProvider.prototype.getDelegate = function() {
        var _a;
        return (_a = this._delegate) !== null && _a !== void 0 ? _a : NOOP_TRACER_PROVIDER;
    };
    /**
     * Set the delegate tracer provider
     */ ProxyTracerProvider.prototype.setDelegate = function(delegate) {
        this._delegate = delegate;
    };
    ProxyTracerProvider.prototype.getDelegateTracer = function(name, version, options) {
        var _a;
        return (_a = this._delegate) === null || _a === void 0 ? void 0 : _a.getTracer(name, version, options);
    };
    return ProxyTracerProvider;
}();

},{"./ProxyTracer":"kQ0Z4","./NoopTracerProvider":"3Ht8v","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3Ht8v":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NoopTracerProvider", function() {
    return NoopTracerProvider;
});
var _noopTracer = require("./NoopTracer");
/**
 * An implementation of the {@link TracerProvider} which returns an impotent
 * Tracer for all calls to `getTracer`.
 *
 * All operations are no-op.
 */ var NoopTracerProvider = /** @class */ function() {
    function NoopTracerProvider() {}
    NoopTracerProvider.prototype.getTracer = function(_name, _version, _options) {
        return new (0, _noopTracer.NoopTracer)();
    };
    return NoopTracerProvider;
}();

},{"./NoopTracer":"gCsUG","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"l4IpC":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "context", function() {
    return context;
});
var _context = require("./api/context");
var context = (0, _context.ContextAPI).getInstance();

},{"./api/context":"f7atw","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ca71U":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "diag", function() {
    return diag;
});
var _diag = require("./api/diag");
var diag = (0, _diag.DiagAPI).instance();

},{"./api/diag":"h9doG","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"flr8Y":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "metrics", function() {
    return metrics;
});
var _metrics = require("./api/metrics");
var metrics = (0, _metrics.MetricsAPI).getInstance();

},{"./api/metrics":"b45r5","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"b45r5":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MetricsAPI", function() {
    return MetricsAPI;
});
var _noopMeterProvider = require("../metrics/NoopMeterProvider");
var _globalUtils = require("../internal/global-utils");
var _diag = require("./diag");
var API_NAME = 'metrics';
/**
 * Singleton object which represents the entry point to the OpenTelemetry Metrics API
 */ var MetricsAPI = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function MetricsAPI() {}
    /** Get the singleton instance of the Metrics API */ MetricsAPI.getInstance = function() {
        if (!this._instance) this._instance = new MetricsAPI();
        return this._instance;
    };
    /**
     * Set the current global meter provider.
     * Returns true if the meter provider was successfully registered, else false.
     */ MetricsAPI.prototype.setGlobalMeterProvider = function(provider) {
        return (0, _globalUtils.registerGlobal)(API_NAME, provider, (0, _diag.DiagAPI).instance());
    };
    /**
     * Returns the global meter provider.
     */ MetricsAPI.prototype.getMeterProvider = function() {
        return (0, _globalUtils.getGlobal)(API_NAME) || (0, _noopMeterProvider.NOOP_METER_PROVIDER);
    };
    /**
     * Returns a meter from the global meter provider.
     */ MetricsAPI.prototype.getMeter = function(name, version, options) {
        return this.getMeterProvider().getMeter(name, version, options);
    };
    /** Remove the global meter provider */ MetricsAPI.prototype.disable = function() {
        (0, _globalUtils.unregisterGlobal)(API_NAME, (0, _diag.DiagAPI).instance());
    };
    return MetricsAPI;
}();

},{"../metrics/NoopMeterProvider":"57xUb","../internal/global-utils":"4g6BY","./diag":"h9doG","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"57xUb":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NoopMeterProvider", function() {
    return NoopMeterProvider;
});
parcelHelpers.export(exports, "NOOP_METER_PROVIDER", function() {
    return NOOP_METER_PROVIDER;
});
var _noopMeter = require("./NoopMeter");
/**
 * An implementation of the {@link MeterProvider} which returns an impotent Meter
 * for all calls to `getMeter`
 */ var NoopMeterProvider = /** @class */ function() {
    function NoopMeterProvider() {}
    NoopMeterProvider.prototype.getMeter = function(_name, _version, _options) {
        return 0, _noopMeter.NOOP_METER;
    };
    return NoopMeterProvider;
}();
var NOOP_METER_PROVIDER = new NoopMeterProvider();

},{"./NoopMeter":"irnKi","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7haOh":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "propagation", function() {
    return propagation;
});
var _propagation = require("./api/propagation");
var propagation = (0, _propagation.PropagationAPI).getInstance();

},{"./api/propagation":"kuWG7","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kuWG7":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PropagationAPI", function() {
    return PropagationAPI;
});
var _globalUtils = require("../internal/global-utils");
var _noopTextMapPropagator = require("../propagation/NoopTextMapPropagator");
var _textMapPropagator = require("../propagation/TextMapPropagator");
var _contextHelpers = require("../baggage/context-helpers");
var _utils = require("../baggage/utils");
var _diag = require("./diag");
var API_NAME = 'propagation';
var NOOP_TEXT_MAP_PROPAGATOR = new (0, _noopTextMapPropagator.NoopTextMapPropagator)();
/**
 * Singleton object which represents the entry point to the OpenTelemetry Propagation API
 */ var PropagationAPI = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function PropagationAPI() {
        this.createBaggage = (0, _utils.createBaggage);
        this.getBaggage = (0, _contextHelpers.getBaggage);
        this.getActiveBaggage = (0, _contextHelpers.getActiveBaggage);
        this.setBaggage = (0, _contextHelpers.setBaggage);
        this.deleteBaggage = (0, _contextHelpers.deleteBaggage);
    }
    /** Get the singleton instance of the Propagator API */ PropagationAPI.getInstance = function() {
        if (!this._instance) this._instance = new PropagationAPI();
        return this._instance;
    };
    /**
     * Set the current propagator.
     *
     * @returns true if the propagator was successfully registered, else false
     */ PropagationAPI.prototype.setGlobalPropagator = function(propagator) {
        return (0, _globalUtils.registerGlobal)(API_NAME, propagator, (0, _diag.DiagAPI).instance());
    };
    /**
     * Inject context into a carrier to be propagated inter-process
     *
     * @param context Context carrying tracing data to inject
     * @param carrier carrier to inject context into
     * @param setter Function used to set values on the carrier
     */ PropagationAPI.prototype.inject = function(context, carrier, setter) {
        if (setter === void 0) setter = (0, _textMapPropagator.defaultTextMapSetter);
        return this._getGlobalPropagator().inject(context, carrier, setter);
    };
    /**
     * Extract context from a carrier
     *
     * @param context Context which the newly created context will inherit from
     * @param carrier Carrier to extract context from
     * @param getter Function used to extract keys from a carrier
     */ PropagationAPI.prototype.extract = function(context, carrier, getter) {
        if (getter === void 0) getter = (0, _textMapPropagator.defaultTextMapGetter);
        return this._getGlobalPropagator().extract(context, carrier, getter);
    };
    /**
     * Return a list of all fields which may be used by the propagator.
     */ PropagationAPI.prototype.fields = function() {
        return this._getGlobalPropagator().fields();
    };
    /** Remove the global propagator */ PropagationAPI.prototype.disable = function() {
        (0, _globalUtils.unregisterGlobal)(API_NAME, (0, _diag.DiagAPI).instance());
    };
    PropagationAPI.prototype._getGlobalPropagator = function() {
        return (0, _globalUtils.getGlobal)(API_NAME) || NOOP_TEXT_MAP_PROPAGATOR;
    };
    return PropagationAPI;
}();

},{"../internal/global-utils":"4g6BY","../propagation/NoopTextMapPropagator":"aeUcj","../propagation/TextMapPropagator":"3L3VX","../baggage/context-helpers":"l2i5x","../baggage/utils":"7Z76g","./diag":"h9doG","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aeUcj":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * No-op implementations of {@link TextMapPropagator}.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NoopTextMapPropagator", function() {
    return NoopTextMapPropagator;
});
var NoopTextMapPropagator = /** @class */ function() {
    function NoopTextMapPropagator() {}
    /** Noop inject function does nothing */ NoopTextMapPropagator.prototype.inject = function(_context, _carrier) {};
    /** Noop extract function does nothing and returns the input context */ NoopTextMapPropagator.prototype.extract = function(context, _carrier) {
        return context;
    };
    NoopTextMapPropagator.prototype.fields = function() {
        return [];
    };
    return NoopTextMapPropagator;
}();

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"l2i5x":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Retrieve the current baggage from the given context
 *
 * @param {Context} Context that manage all context values
 * @returns {Baggage} Extracted baggage from the context
 */ parcelHelpers.export(exports, "getBaggage", function() {
    return getBaggage;
});
/**
 * Retrieve the current baggage from the active/current context
 *
 * @returns {Baggage} Extracted baggage from the context
 */ parcelHelpers.export(exports, "getActiveBaggage", function() {
    return getActiveBaggage;
});
/**
 * Store a baggage in the given context
 *
 * @param {Context} Context that manage all context values
 * @param {Baggage} baggage that will be set in the actual context
 */ parcelHelpers.export(exports, "setBaggage", function() {
    return setBaggage;
});
/**
 * Delete the baggage stored in the given context
 *
 * @param {Context} Context that manage all context values
 */ parcelHelpers.export(exports, "deleteBaggage", function() {
    return deleteBaggage;
});
var _context = require("../api/context");
var _context1 = require("../context/context");
/**
 * Baggage key
 */ var BAGGAGE_KEY = (0, _context1.createContextKey)('OpenTelemetry Baggage Key');
function getBaggage(context) {
    return context.getValue(BAGGAGE_KEY) || undefined;
}
function getActiveBaggage() {
    return getBaggage((0, _context.ContextAPI).getInstance().active());
}
function setBaggage(context, baggage) {
    return context.setValue(BAGGAGE_KEY, baggage);
}
function deleteBaggage(context) {
    return context.deleteValue(BAGGAGE_KEY);
}

},{"../api/context":"f7atw","../context/context":"amn9k","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"31pDO":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "trace", function() {
    return trace;
});
var _trace = require("./api/trace");
var trace = (0, _trace.TraceAPI).getInstance();

},{"./api/trace":"lxVxY","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lxVxY":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TraceAPI", function() {
    return TraceAPI;
});
var _globalUtils = require("../internal/global-utils");
var _proxyTracerProvider = require("../trace/ProxyTracerProvider");
var _spancontextUtils = require("../trace/spancontext-utils");
var _contextUtils = require("../trace/context-utils");
var _diag = require("./diag");
var API_NAME = 'trace';
/**
 * Singleton object which represents the entry point to the OpenTelemetry Tracing API
 */ var TraceAPI = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function TraceAPI() {
        this._proxyTracerProvider = new (0, _proxyTracerProvider.ProxyTracerProvider)();
        this.wrapSpanContext = (0, _spancontextUtils.wrapSpanContext);
        this.isSpanContextValid = (0, _spancontextUtils.isSpanContextValid);
        this.deleteSpan = (0, _contextUtils.deleteSpan);
        this.getSpan = (0, _contextUtils.getSpan);
        this.getActiveSpan = (0, _contextUtils.getActiveSpan);
        this.getSpanContext = (0, _contextUtils.getSpanContext);
        this.setSpan = (0, _contextUtils.setSpan);
        this.setSpanContext = (0, _contextUtils.setSpanContext);
    }
    /** Get the singleton instance of the Trace API */ TraceAPI.getInstance = function() {
        if (!this._instance) this._instance = new TraceAPI();
        return this._instance;
    };
    /**
     * Set the current global tracer.
     *
     * @returns true if the tracer provider was successfully registered, else false
     */ TraceAPI.prototype.setGlobalTracerProvider = function(provider) {
        var success = (0, _globalUtils.registerGlobal)(API_NAME, this._proxyTracerProvider, (0, _diag.DiagAPI).instance());
        if (success) this._proxyTracerProvider.setDelegate(provider);
        return success;
    };
    /**
     * Returns the global tracer provider.
     */ TraceAPI.prototype.getTracerProvider = function() {
        return (0, _globalUtils.getGlobal)(API_NAME) || this._proxyTracerProvider;
    };
    /**
     * Returns a tracer from the global tracer provider.
     */ TraceAPI.prototype.getTracer = function(name, version) {
        return this.getTracerProvider().getTracer(name, version);
    };
    /** Remove the global tracer provider */ TraceAPI.prototype.disable = function() {
        (0, _globalUtils.unregisterGlobal)(API_NAME, (0, _diag.DiagAPI).instance());
        this._proxyTracerProvider = new (0, _proxyTracerProvider.ProxyTracerProvider)();
    };
    return TraceAPI;
}();

},{"../internal/global-utils":"4g6BY","../trace/ProxyTracerProvider":"iWUmK","../trace/spancontext-utils":"bv17A","../trace/context-utils":"1ENWh","./diag":"h9doG","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8G8ci":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setContextManager", function() {
    return setContextManager;
});
parcelHelpers.export(exports, "getContextManager", function() {
    return getContextManager;
});
parcelHelpers.export(exports, "UFOContextManager", function() {
    return UFOContextManager;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _api = require("@opentelemetry/api");
/**
 * We need to store a reference to the Context manager so that we can get it later.
 * This is because the OTel JS API doesn't allow us to get the registered context manager,
 * and we need to get it because we need to call a function that's not available in the OTel API:
 * `setActive`. The OTel JS API design doesn't allow us to manually set the active context
 * despite the spec allowing for the capability. Sigh.
 *
 * I imagine this situation might not be permanent if we can move to a system were we can rely
 * solely on the API, but for the purposes of the first change being React UFO API compatible,
 * we'll need to do this.
 */ var contextManager;
function setContextManager(ctxMgr) {
    contextManager = ctxMgr;
}
function getContextManager() {
    return contextManager;
}
var UFOContextManager = /*#__PURE__*/ function() {
    "use strict";
    function UFOContextManager() {
        (0, _classCallCheck._)(this, UFOContextManager);
        /**
	 * whether the context manager is enabled or not
	 */ this._enabled = false;
        /**
	 * Keeps the reference to current context
	 */ this._currentContext = (0, _api.ROOT_CONTEXT);
    }
    (0, _createClass._)(UFOContextManager, [
        {
            key: "_bindFunction",
            value: /**
	 *
	 * @param context
	 * @param target Function to be executed within the context
	 */ // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
            function _bindFunction() {
                var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, _api.ROOT_CONTEXT), target = arguments.length > 1 ? arguments[1] : void 0;
                // eslint-disable-next-line @typescript-eslint/no-this-alias
                var manager = this;
                var contextWrapper = function contextWrapper() {
                    var _this = this;
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    return manager.with(context, function() {
                        return target.apply(_this, args);
                    });
                };
                Object.defineProperty(contextWrapper, 'length', {
                    enumerable: false,
                    configurable: true,
                    writable: false,
                    value: target.length
                });
                return contextWrapper;
            }
        },
        {
            /**
	 * Returns the active context
	 */ key: "active",
            value: function active() {
                return this._currentContext;
            }
        },
        {
            /**
	 * Binds a the certain context or the active one to the target function and then returns the target
	 * @param context A context (span) to be bind to target
	 * @param target a function or event emitter. When target or one of its callbacks is called,
	 *  the provided context will be used as the active context for the duration of the call.
	 */ key: "bind",
            value: function bind(context, target) {
                // if no specific context to propagate is given, we use the current one
                if (context === undefined) context = this.active();
                if (typeof target === 'function') return this._bindFunction(context, target);
                return target;
            }
        },
        {
            /**
	 * Disable the context manager (clears the current context)
	 */ key: "disable",
            value: function disable() {
                this._currentContext = (0, _api.ROOT_CONTEXT);
                this._enabled = false;
                return this;
            }
        },
        {
            /**
	 * Enables the context manager and creates a default(root) context
	 */ key: "enable",
            value: function enable() {
                if (this._enabled) return this;
                this._enabled = true;
                this._currentContext = (0, _api.ROOT_CONTEXT);
                return this;
            }
        },
        {
            /**
	 * Calls the callback function [fn] with the provided [context]. If [context] is undefined then it will use the window.
	 * The context will be set as active
	 * @param context
	 * @param fn Callback function
	 * @param thisArg optional receiver to be used for calling fn
	 * @param args optional arguments forwarded to fn
	 */ key: "with",
            value: function _with(context, fn, thisArg) {
                for(var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++){
                    args[_key - 3] = arguments[_key];
                }
                var previousContext = this._currentContext;
                this._currentContext = context || (0, _api.ROOT_CONTEXT);
                try {
                    var _fn;
                    return (_fn = fn).call.apply(_fn, [
                        thisArg
                    ].concat((0, _toConsumableArray._)(args)));
                } finally{
                    this._currentContext = previousContext;
                }
            }
        },
        {
            /**
	 * Sets the active context.
	 * This function is an extension of the OTel spec, in order to facilitate the current API of React UFO trace context handling.
	 * It doesn't keep track of any previously set active contexts, because it's assumed (for now) that only one trace context
	 * will ever exist at a time.
	 * The next step in the work to improve tracing in the FE will likely remove this function as we need to track the
	 * hierarchy of contexts (likely using the `with()` function above).
	 * @param context The context to be made the globally active one
	 */ key: "setActive",
            value: function setActive(context) {
                if (this._enabled) this._currentContext = context;
            }
        }
    ]);
    return UFOContextManager;
}();

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_to_consumable_array":"1eSZf","@opentelemetry/api":"9lCa7","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lEkeb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeTraceHttpRequestHeaders", function() {
    return makeTraceHttpRequestHeaders;
});
function makeTraceHttpRequestHeaders(traceId, spanId) {
    return {
        'X-B3-TraceId': traceId,
        'X-B3-SpanId': spanId
    };
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6ICC9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useInteractionContext", function() {
    return useInteractionContext;
});
var _react = require("react");
var _interactionContext = require("@atlaskit/interaction-context");
var _interactionContextDefault = parcelHelpers.interopDefault(_interactionContext);
exports.default = (0, _interactionContextDefault.default);
function useInteractionContext() {
    return (0, _react.useContext)((0, _interactionContextDefault.default));
}

},{"react":"ltHCL","@atlaskit/interaction-context":"4Lyu9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eh9Yb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DefaultInteractionID", function() {
    return DefaultInteractionID;
});
parcelHelpers.export(exports, "subscribeToInteractionIdChanges", function() {
    return subscribeToInteractionIdChanges;
});
parcelHelpers.export(exports, "getInteractionId", function() {
    return getInteractionId;
});
parcelHelpers.export(exports, "useInteractionId", function() {
    return useInteractionId;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _react = require("react");
var listeners = new Set();
// Observable interaction ID implementation
var ObservableInteractionID = /*#__PURE__*/ function() {
    "use strict";
    function ObservableInteractionID() {
        (0, _classCallCheck._)(this, ObservableInteractionID);
        this._current = null;
    }
    (0, _createClass._)(ObservableInteractionID, [
        {
            key: "current",
            get: function get() {
                return this._current;
            },
            set: function set(newId) {
                var oldId = this._current;
                this._current = newId;
                // Notify all listeners if the ID actually changed
                if (oldId !== newId) listeners.forEach(function(listener) {
                    return listener(newId);
                });
            }
        }
    ]);
    return ObservableInteractionID;
}();
// Ensures a single DefaultInteractionID instance exists across the entire application,
// even when the module is loaded multiple times in different contexts
var initializeGlobalDefaultInteractionID = function() {
    // Return existing instance if already initialized
    if (globalThis.__UFO_DEFAULT_INTERACTION_ID__) return globalThis.__UFO_DEFAULT_INTERACTION_ID__;
    // Create and store new instance globally
    var instance = new ObservableInteractionID();
    globalThis.__UFO_DEFAULT_INTERACTION_ID__ = instance;
    return instance;
};
var DefaultInteractionID = initializeGlobalDefaultInteractionID();
var subscribeToInteractionIdChanges = function(listener) {
    listeners.add(listener);
    return function() {
        listeners.delete(listener);
    };
};
// We use a context to allow modals to have their own lifecycle
var interactionContext = (0, _react.createContext)(DefaultInteractionID);
exports.default = interactionContext;
var getInteractionId = function() {
    return DefaultInteractionID;
};
var useInteractionId = function() {
    return DefaultInteractionID;
};

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"diQdd":[function(require,module,exports,__globalThis) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PreviousInteractionLog", function() {
    return PreviousInteractionLog;
});
parcelHelpers.export(exports, "postInteractionLog", function() {
    return postInteractionLog;
});
parcelHelpers.export(exports, "interactionExtraMetrics", function() {
    return interactionExtraMetrics;
});
parcelHelpers.export(exports, "segmentUnmountCache", function() {
    return segmentUnmountCache;
});
parcelHelpers.export(exports, "getActiveInteraction", function() {
    return getActiveInteraction;
});
parcelHelpers.export(exports, "getPerformanceObserver", function() {
    return getPerformanceObserver;
});
parcelHelpers.export(exports, "setInteractionPerformanceEvent", function() {
    return setInteractionPerformanceEvent;
});
parcelHelpers.export(exports, "remove", function() {
    return remove;
});
parcelHelpers.export(exports, "updatePageLoadInteractionName", function() {
    return updatePageLoadInteractionName;
});
parcelHelpers.export(exports, "addMetadata", function() {
    return addMetadata;
});
parcelHelpers.export(exports, "addCustomData", function() {
    return addCustomData;
});
parcelHelpers.export(exports, "addIframeSegmentData", function() {
    return addIframeSegmentData;
});
parcelHelpers.export(exports, "addCohortingCustomData", function() {
    return addCohortingCustomData;
});
parcelHelpers.export(exports, "addCustomTiming", function() {
    return addCustomTiming;
});
parcelHelpers.export(exports, "addMark", function() {
    return addMark;
});
parcelHelpers.export(exports, "markFirstSegmentLoad", function() {
    return markFirstSegmentLoad;
});
parcelHelpers.export(exports, "addMarkToAll", function() {
    return addMarkToAll;
});
parcelHelpers.export(exports, "addSpan", function() {
    return addSpan;
});
parcelHelpers.export(exports, "addSpanToAll", function() {
    return addSpanToAll;
});
parcelHelpers.export(exports, "addPreload", function() {
    return addPreload;
});
parcelHelpers.export(exports, "addLoad", function() {
    return addLoad;
});
parcelHelpers.export(exports, "extractModuleName", function() {
    return extractModuleName;
});
parcelHelpers.export(exports, "addHold", function() {
    return addHold;
});
parcelHelpers.export(exports, "addHoldByID", function() {
    return addHoldByID;
});
parcelHelpers.export(exports, "removeHoldByID", function() {
    return removeHoldByID;
});
parcelHelpers.export(exports, "getCurrentInteractionType", function() {
    return getCurrentInteractionType;
});
parcelHelpers.export(exports, "ModuleLoadingProfiler", function() {
    return ModuleLoadingProfiler;
});
parcelHelpers.export(exports, "addError", function() {
    return addError;
});
parcelHelpers.export(exports, "addErrorToAll", function() {
    return addErrorToAll;
});
parcelHelpers.export(exports, "addProfilerTimings", function() {
    return addProfilerTimings;
});
parcelHelpers.export(exports, "sinkInteractionHandler", function() {
    return sinkInteractionHandler;
});
parcelHelpers.export(exports, "sinkPostInteractionLogHandler", function() {
    return sinkPostInteractionLogHandler;
});
parcelHelpers.export(exports, "tryComplete", function() {
    return tryComplete;
});
parcelHelpers.export(exports, "abort", function() {
    return abort;
});
parcelHelpers.export(exports, "abortByNewInteraction", function() {
    return abortByNewInteraction;
});
parcelHelpers.export(exports, "abortAll", function() {
    return abortAll;
});
parcelHelpers.export(exports, "addOnCancelCallback", function() {
    return addOnCancelCallback;
});
parcelHelpers.export(exports, "addNewInteraction", function() {
    return addNewInteraction;
});
parcelHelpers.export(exports, "addBrowserMetricEvent", function() {
    return addBrowserMetricEvent;
});
parcelHelpers.export(exports, "addApdexToAll", function() {
    return addApdexToAll;
});
parcelHelpers.export(exports, "addApdex", function() {
    return addApdex;
});
parcelHelpers.export(exports, "addRequestInfo", function() {
    return addRequestInfo;
});
parcelHelpers.export(exports, "addSegment", function() {
    return addSegment;
});
parcelHelpers.export(exports, "removeSegment", function() {
    return removeSegment;
});
parcelHelpers.export(exports, "addRedirect", function() {
    return addRedirect;
});
parcelHelpers.export(exports, "interactionSpans", function() {
    return interactionSpans;
});
parcelHelpers.export(exports, "addCustomSpans", function() {
    return addCustomSpans;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _uuid = require("uuid");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _coinflip = require("../coinflip");
var _coinflipDefault = parcelHelpers.interopDefault(_coinflip);
var _timingName = require("../common/utils/timing-name");
var _config = require("../config");
var _createExperimentalInteractionMetricsPayload = require("../create-experimental-interaction-metrics-payload");
var _createExtraSearchPageInteractionPayload = require("../create-extra-search-page-interaction-payload");
var _utils = require("../create-payload/common/utils");
var _experienceTraceIdContext = require("../experience-trace-id-context");
var _featureFlagsAccessed = require("../feature-flags-accessed");
var _interactionIdContext = require("../interaction-id-context");
var _ssrRenderProfiler = require("../segment/ssr-render-profiler");
var _vc = require("../vc");
var _constants = require("./common/constants");
var _interactionExtraMetrics = require("./interaction-extra-metrics");
var _interactionExtraMetricsDefault = parcelHelpers.interopDefault(_interactionExtraMetrics);
var _postInteractionLog = require("./post-interaction-log");
var _postInteractionLogDefault = parcelHelpers.interopDefault(_postInteractionLog);
var PreviousInteractionLog = {
    id: undefined,
    name: undefined,
    type: undefined,
    isAborted: undefined,
    timestamp: undefined
};
var postInteractionLog = new (0, _postInteractionLogDefault.default)();
var interactionExtraMetrics = new (0, _interactionExtraMetricsDefault.default)();
var interactionQueue = [];
var segmentCache = new Map();
var segmentUnmountCache = new Map(); // Temporarily store segment unmount counts
var firstSegmentLoadMarked = false;
var segmentObservers = [];
function getActiveInteraction() {
    var interactionId = (0, _interactionIdContext.getInteractionId)();
    if (!interactionId.current) return;
    return (0, _constants.interactions).get(interactionId.current);
}
function isPerformanceTracingEnabled() {
    var _getConfig;
    return ((_getConfig = (0, _config.getConfig)()) === null || _getConfig === void 0 ? void 0 : _getConfig.enableAdditionalPerformanceMarks) || window.__REACT_UFO_ENABLE_PERF_TRACING || false;
}
var performanceEventObserver;
var getPerformanceObserver = function() {
    performanceEventObserver = performanceEventObserver || new PerformanceObserver(function(entries) {
        var list = entries.getEntries();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entry = _step.value;
                if (entry.name === 'click') setInteractionPerformanceEvent(entry);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    return performanceEventObserver;
};
var setInteractionPerformanceEvent = function(entry) {
    var interaction = getActiveInteraction();
    if ((interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'press') {
        var responsiveness = interaction.responsiveness || {};
        // if happens there is another event interaction that has started after
        // the initial one, we don't want to replace the values if they have already
        // been set up
        responsiveness.experimentalInputToNextPaint = responsiveness.experimentalInputToNextPaint || entry.duration;
        responsiveness.inputDelay = responsiveness.experimentalInputToNextPaint || entry.processingStart - entry.startTime;
        interaction.responsiveness = responsiveness;
        // if the entry start time is lower than the one in the interaction
        // it means the interaction start time is not accurate, we assign
        // this value which will match the timestamp in the event
        if (entry.startTime < interaction.start) interaction.start = entry.startTime;
    }
};
function labelStackToString(labelStack, name) {
    var _stack_map;
    var stack = (0, _toConsumableArray._)(labelStack !== null && labelStack !== void 0 ? labelStack : []);
    if (name) stack.push({
        name: name
    });
    return (_stack_map = stack.map(function(l) {
        return l.name;
    })) === null || _stack_map === void 0 ? void 0 : _stack_map.join('/');
}
function labelStackToIdString(labelStack) {
    var _labelStack_map;
    return labelStack === null || labelStack === void 0 ? void 0 : (_labelStack_map = labelStack.map(function(l) {
        return 'segmentId' in l ? "".concat(l.name, ":").concat(l.segmentId) : "".concat(l.name);
    })) === null || _labelStack_map === void 0 ? void 0 : _labelStack_map.join('/');
}
function addSegmentObserver(observer) {
    segmentObservers.push(observer);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = segmentCache.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var segmentInfo = _step.value;
            observer.onAdd(segmentInfo);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function removeSegmentObserver(observer) {
    var index = segmentObservers.findIndex(function(obs) {
        return obs === observer;
    });
    if (index !== -1) segmentObservers.splice(index, 1);
}
function remove(interactionId) {
    (0, _constants.interactions).delete(interactionId);
}
function updatePageLoadInteractionName(ufoName) {
    var routeName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ufoName;
    var interaction = getActiveInteraction();
    if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
    interaction.ufoName = ufoName;
    interaction.routeName = routeName;
}
function addMetadata(interactionId, data) {
    var interaction = (0, _constants.interactions).get(interactionId);
    if (interaction != null) Object.keys(data).forEach(function(key) {
        interaction.metaData[key] = data[key];
    });
}
function addCustomData(interactionId, labelStack, data) {
    var interaction = (0, _constants.interactions).get(interactionId);
    if (interaction != null) Object.keys(data).forEach(function(i) {
        interaction.customData.push({
            labelStack: labelStack,
            data: (0, _defineProperty._)({}, i, data[i])
        });
    });
}
function addIframeSegmentData(interactionId, segmentId, entry) {
    var interaction = (0, _constants.interactions).get(interactionId);
    if (interaction != null && (0, _platformFeatureFlags.fg)('platform_ufo_3p_segment_timings')) {
        if (!interaction.segment3pTimings) interaction.segment3pTimings = {};
        if (!interaction.segment3pTimings[segmentId]) interaction.segment3pTimings[segmentId] = [];
        interaction.segment3pTimings[segmentId].push(entry);
    }
}
function addCohortingCustomData(interactionId, key, value) {
    var interaction = (0, _constants.interactions).get(interactionId);
    if (interaction == null) return;
    // Allow null and undefined values
    if (value === null || value === undefined) {
        interaction.cohortingCustomData.set(key, value);
        return;
    }
    // Validate that the value is a primitive (number, boolean, or string)
    if (typeof value !== 'number' && typeof value !== 'boolean' && typeof value !== 'string') return;
    // Validate string length (max 50 characters)
    if (typeof value === 'string' && value.length > 50) return;
    interaction.cohortingCustomData.set(key, value);
}
function addCustomTiming(interactionId, labelStack, data) {
    var interaction = (0, _constants.interactions).get(interactionId);
    if (interaction != null) {
        var sanitizedData = Object.fromEntries(Object.entries(data).map(function(param) {
            var _param = (0, _slicedToArray._)(param, 2), key = _param[0], timingData = _param[1];
            return [
                (0, _timingName.sanitizeTimingName)(key),
                timingData
            ];
        }));
        interaction.customTimings.push({
            labelStack: labelStack,
            data: sanitizedData
        });
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (isPerformanceTracingEnabled()) try {
            for(var _iterator = Object.entries(sanitizedData)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, _slicedToArray._)(_step.value, 2), key = _step_value[0], timingData = _step_value[1];
                var startTime = timingData.startTime, endTime = timingData.endTime;
                try {
                    // for Firefox 102 and older
                    performance.measure("\uD83D\uDEF8 ".concat(labelStackToString(labelStack, key), " [custom_timing]"), {
                        start: startTime,
                        end: endTime,
                        detail: {
                            devtools: {
                                track: "\uD83D\uDEF8 reactUFO detailed timings",
                                color: 'tertiary-light'
                            }
                        }
                    });
                } catch (e) {
                // do nothing
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
}
function addMark(interactionId, type, name, labelStack) {
    var time = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : performance.now();
    var interaction = (0, _constants.interactions).get(interactionId);
    if (interaction != null) interaction.marks.push({
        type: type,
        name: name,
        labelStack: labelStack,
        time: time
    });
    if (isPerformanceTracingEnabled()) performance.mark("\uD83D\uDEF8 ".concat(labelStackToString(labelStack, name), " [").concat(type, "]"), {
        startTime: time
    });
}
function markFirstSegmentLoad(interactionId, labelStack) {
    var time = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : performance.now();
    if (!(0, _platformFeatureFlags.fg)('platform_mark_ufo_segment_first_load')) return;
    var interaction = (0, _constants.interactions).get(interactionId);
    if (interaction != null && !firstSegmentLoadMarked) {
        firstSegmentLoadMarked = true;
        interaction.marks.push({
            type: 'first_segment_load',
            name: 'first_segment_load',
            labelStack: labelStack,
            time: time
        });
    }
}
function addMarkToAll(type, name, labelStack) {
    var time = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : performance.now();
    (0, _constants.interactions).forEach(function(interaction) {
        interaction.marks.push({
            type: type,
            name: name,
            labelStack: labelStack,
            time: time
        });
    });
    if (isPerformanceTracingEnabled()) performance.mark("\uD83D\uDEF8 ".concat(labelStackToString(labelStack, name), " [").concat(type, "]"), {
        startTime: time
    });
}
function addSpan(interactionId, type, name, labelStack, start) {
    var end = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : performance.now(), size = arguments.length > 6 ? arguments[6] : void 0;
    var interaction = (0, _constants.interactions).get(interactionId);
    if (interaction != null) {
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
        if (isPerformanceTracingEnabled()) try {
            // for Firefox 102 and older
            performance.measure("\uD83D\uDEF8 ".concat(labelStackToString(labelStack, name), " [").concat(type, "]"), {
                start: start,
                end: end,
                detail: {
                    devtools: {
                        track: "\uD83D\uDEF8 reactUFO detailed timings",
                        color: 'secondary'
                    }
                }
            });
        } catch (e) {
        // do nothing
        }
    }
}
function addSpanToAll(type, name, labelStack, start) {
    var end = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : performance.now(), size = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0;
    (0, _constants.interactions).forEach(function(interaction) {
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
    });
    if (isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure("\uD83D\uDEF8 ".concat(labelStackToString(labelStack, name), " [").concat(type, "]"), {
            start: start,
            end: end,
            detail: {
                devtools: {
                    track: "\uD83D\uDEF8 reactUFO detailed timings",
                    color: 'secondary'
                }
            }
        });
    } catch (e) {
    // do nothing
    }
}
function addPreload(moduleId, timestamp) {
    addMarkToAll('bundle_preload', moduleId, null, timestamp);
}
function addLoad(identifier, start, end) {
    addSpanToAll('bundle_load', identifier, null, start, end - start);
}
var moduleLoadingRequests = {};
function extractModuleName(input) {
    var result = input !== null && input !== void 0 ? input : '';
    result = result.replace(/^\.\/src\/packages\//, '');
    result = result.replace(/^\.\/node_modules\//, '');
    result = result.replace(/(\/src)?\/(index|main)\.(tsx|ts|js|jsx)$/, '');
    return result;
}
function addHoldCriterion(id, labelStack, name, startTime) {
    var _window___CRITERION__;
    if (!((_window___CRITERION__ = window.__CRITERION__) === null || _window___CRITERION__ === void 0 ? void 0 : _window___CRITERION__.addUFOHold)) return;
    window.__CRITERION__.addUFOHold(id, labelStackToString(labelStack), name, startTime);
}
function removeHoldCriterion(id) {
    var _window___CRITERION__;
    if (!((_window___CRITERION__ = window.__CRITERION__) === null || _window___CRITERION__ === void 0 ? void 0 : _window___CRITERION__.removeUFOHold)) return;
    window.__CRITERION__.removeUFOHold(id);
}
function addHold(interactionId, labelStack, name, _experimental) {
    var interaction = (0, _constants.interactions).get(interactionId);
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    var id = (0, _uuid.v4)();
    if (!interaction) // add hold timestamp to post interaction log if interaction is complete
    postInteractionLog.addHoldInfo(labelStack, name, performance.now());
    if (interaction != null) {
        var start = performance.now();
        var holdActive = {
            labelStack: labelStack,
            name: name,
            start: start
        };
        var is3pHold = labelStack.some(function(l) {
            return 'type' in l && l.type === 'third-party';
        });
        if (is3pHold) {
            if (!interaction.hold3pActive) interaction.hold3pActive = new Map();
            interaction.hold3pActive.set(id, (0, _objectSpreadProps._)((0, _objectSpread._)({}, holdActive), {
                start: start
            }));
        } else {
            interaction.holdActive.set(id, (0, _objectSpreadProps._)((0, _objectSpread._)({}, holdActive), {
                start: start
            }));
            addHoldCriterion(id, labelStack, name, start);
        }
        return function() {
            var end = performance.now();
            if (isPerformanceTracingEnabled()) try {
                // for Firefox 102 and older
                performance.measure("\uD83D\uDEF8 ".concat(labelStackToString(labelStack, name), " [hold]"), {
                    start: start,
                    end: end,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'secondary-light'
                        }
                    }
                });
            } catch (e) {
            // do nothing
            }
            removeHoldCriterion(id);
            var currentInteraction = (0, _constants.interactions).get(interactionId);
            var currentHold = interaction.holdActive.get(id);
            if (currentInteraction != null) {
                if (currentHold != null) {
                    currentInteraction.holdInfo.push((0, _objectSpreadProps._)((0, _objectSpread._)({}, currentHold), {
                        end: end
                    }));
                    interaction.holdActive.delete(id);
                }
                if (!(0, _platformFeatureFlags.fg)('platform_ufo_remove_experimental_holds')) {
                    var expHold = interaction.holdExpActive.get(id);
                    if (expHold != null) {
                        currentInteraction.holdExpInfo.push((0, _objectSpreadProps._)((0, _objectSpread._)({}, expHold), {
                            end: end
                        }));
                        interaction.holdExpActive.delete(id);
                    }
                }
                if (interaction.hold3pActive) {
                    var current3pHold = interaction.hold3pActive.get(id);
                    if (current3pHold != null) {
                        if (!currentInteraction.hold3pInfo) currentInteraction.hold3pInfo = [];
                        currentInteraction.hold3pInfo.push((0, _objectSpreadProps._)((0, _objectSpread._)({}, current3pHold), {
                            end: end
                        }));
                        interaction.hold3pActive.delete(id);
                    }
                }
            }
        };
    }
    return function() {};
}
function addHoldByID(interactionId, labelStack, name, id, ignoreOnSubmit) {
    var interaction = (0, _constants.interactions).get(interactionId);
    if (interaction != null) {
        var start = performance.now();
        var is3pHold = labelStack.some(function(l) {
            return 'type' in l && l.type === 'third-party';
        });
        if (is3pHold) {
            if (!interaction.hold3pActive) interaction.hold3pActive = new Map();
            interaction.hold3pActive.set(id, {
                labelStack: labelStack,
                name: name,
                start: start,
                ignoreOnSubmit: ignoreOnSubmit
            });
        } else {
            interaction.holdActive.set(id, {
                labelStack: labelStack,
                name: name,
                start: start,
                ignoreOnSubmit: ignoreOnSubmit
            });
            addHoldCriterion(id, labelStack, name, start);
        }
    }
    return function() {};
}
function removeHoldByID(interactionId, id) {
    var interaction = (0, _constants.interactions).get(interactionId);
    if (interaction != null) {
        var end = performance.now();
        var currentInteraction = (0, _constants.interactions).get(interactionId);
        var currentHold = interaction.holdActive.get(id);
        if (currentInteraction != null && currentHold != null) {
            currentInteraction.holdInfo.push((0, _objectSpreadProps._)((0, _objectSpread._)({}, currentHold), {
                end: end
            }));
            interaction.holdActive.delete(id);
            removeHoldCriterion(id);
        }
        if (interaction.hold3pActive) {
            var current3pHold = interaction.hold3pActive.get(id);
            if (currentInteraction != null && current3pHold != null) {
                if (!currentInteraction.hold3pInfo) currentInteraction.hold3pInfo = [];
                currentInteraction.hold3pInfo.push((0, _objectSpreadProps._)((0, _objectSpread._)({}, current3pHold), {
                    end: end
                }));
                interaction.hold3pActive.delete(id);
            }
        }
    }
}
function getCurrentInteractionType(interactionId) {
    var interaction = (0, _constants.interactions).get(interactionId);
    if (interaction) return interaction.type;
    return null;
}
var ModuleLoadingProfiler = {
    onPreload: function onPreload(moduleId, _priority) {
        addPreload(extractModuleName(moduleId), performance.now());
    },
    onLoadStart: function onLoadStart(info) {
        var timeoutId = setTimeout(function() {
            delete moduleLoadingRequests[info.identifier];
        }, 30000);
        var request = {
            start: performance.now(),
            timeoutId: timeoutId
        };
        moduleLoadingRequests[info.identifier] = request;
    },
    onLoadComplete: function onLoadComplete(info) {
        var request = moduleLoadingRequests[info.identifier];
        if (request) {
            clearTimeout(request.timeoutId);
            delete moduleLoadingRequests[info.identifier];
            addLoad(extractModuleName(info.identifier), request.start, performance.now());
        }
    },
    placeholderFallBackMounted: function placeholderFallBackMounted(id, moduleId) {
        var interactionId = (0, _interactionIdContext.getInteractionId)();
        var currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        addHoldByID(currentInteractionId, [], moduleId, id);
    },
    placeholderFallBackUnmounted: function placeholderFallBackUnmounted(id) {
        var interactionId = (0, _interactionIdContext.getInteractionId)();
        var currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        removeHoldByID(currentInteractionId, id);
    }
};
function addError(interactionId, name, labelStack, errorType, errorMessage, errorStack, forcedError, errorHash, errorStatusCode) {
    var interaction = (0, _constants.interactions).get(interactionId);
    if (interaction != null) interaction.errors.push({
        name: name,
        labelStack: labelStack,
        errorType: errorType,
        errorMessage: errorMessage,
        errorStack: errorStack,
        forcedError: forcedError,
        errorHash: errorHash,
        errorStatusCode: errorStatusCode
    });
}
function addErrorToAll(name, labelStack, errorType, errorMessage, errorStack, errorHash, errorStatusCode) {
    (0, _constants.interactions).forEach(function(interaction) {
        interaction.errors.push({
            name: name,
            labelStack: labelStack,
            errorType: errorType,
            errorMessage: errorMessage,
            errorStack: errorStack,
            errorHash: errorHash,
            errorStatusCode: errorStatusCode
        });
    });
}
function addProfilerTimings(interactionId, labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
    var _getConfig_postInteractionLog, _getConfig;
    if (isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure("\uD83D\uDEF8 ".concat(labelStackToString(labelStack), " [react-profiler] ").concat(type), {
            start: startTime,
            duration: actualDuration,
            detail: {
                devtools: {
                    track: "\uD83D\uDEF8 reactUFO detailed timings",
                    color: 'secondary-dark'
                }
            }
        });
    } catch (e) {
    // do nothing
    }
    var interaction = (0, _constants.interactions).get(interactionId);
    if (interaction != null) interaction.reactProfilerTimings.push({
        labelStack: labelStack,
        type: type,
        actualDuration: actualDuration,
        baseDuration: baseDuration,
        startTime: startTime,
        commitTime: commitTime
    });
    else if ((_getConfig = (0, _config.getConfig)()) === null || _getConfig === void 0 ? void 0 : (_getConfig_postInteractionLog = _getConfig.postInteractionLog) === null || _getConfig_postInteractionLog === void 0 ? void 0 : _getConfig_postInteractionLog.enabled) postInteractionLog.addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime);
}
function pushToQueue(id, data) {
    interactionQueue.push({
        id: id,
        data: data
    });
}
var handleInteraction = pushToQueue;
function ensureMetricWindows(interaction) {
    if (!(0, _platformFeatureFlags.fg)('platform_ufo_metric_variants')) return;
    if (interaction.end === 0) return;
    interaction.metricWindows = (0, _objectSpreadProps._)((0, _objectSpread._)({}, interaction.metricWindows), {
        standard: {
            start: interaction.start,
            end: interaction.end,
            includeCategories: [],
            excludeCategories: [
                'third-party'
            ]
        }
    });
    if (interaction.end3p !== undefined) interaction.metricWindows['include-third-party'] = {
        start: interaction.start,
        end: interaction.end3p,
        includeCategories: [
            'third-party'
        ],
        excludeCategories: []
    };
}
function addLifecycleObservation(interaction, observation) {
    if (!(0, _platformFeatureFlags.fg)('platform_ufo_metric_variants')) return;
    var _interaction_lifecycleObservations;
    interaction.lifecycleObservations = (_interaction_lifecycleObservations = interaction.lifecycleObservations) !== null && _interaction_lifecycleObservations !== void 0 ? _interaction_lifecycleObservations : [];
    interaction.lifecycleObservations.push(observation);
}
function callCleanUpCallbacks(interaction) {
    interaction.cleanupCallbacks.reverse().forEach(function(cleanUpCallback) {
        cleanUpCallback();
    });
}
function finishInteraction(id, data) {
    var endTime = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : performance.now();
    var _getConfig_experimentalInteractionMetrics, _getConfig, _interactionExtraMetrics_finishedInteraction;
    data.end = endTime;
    ensureMetricWindows(data);
    try {
        // for Firefox 102 and older
        performance.measure("\uD83D\uDEF8 [".concat(data.type, "] ").concat(data.ufoName, " [ttai]"), {
            start: data.start,
            end: data.end,
            detail: {
                devtools: {
                    track: 'main metrics',
                    trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                    color: 'tertiary'
                }
            }
        });
        performance.mark("TTAI", {
            startTime: data.end,
            detail: {
                devtools: {
                    dataType: 'marker'
                }
            }
        });
    } catch (e) {
    // do nothing
    }
    if (data.featureFlags) data.featureFlags.during = Object.fromEntries((0, _featureFlagsAccessed.currentFeatureFlagsAccessed));
    (0, _experienceTraceIdContext.clearActiveTrace)();
    callCleanUpCallbacks(data);
    (0, _ssrRenderProfiler.flushSsrRenderProfilerTraces)();
    if (data.type === 'page_load') data.hydration = (0, _config.getReactHydrationStats)();
    // By this time, stop the post interaction log observer if coinflip rate is 0
    var sanitisedUfoName = (0, _utils.sanitizeUfoName)(data.ufoName);
    if (!(0, _coinflipDefault.default)((0, _config.getPostInteractionRate)(sanitisedUfoName, data.type))) postInteractionLog.stopVCObserver();
    if (!(0, _coinflipDefault.default)((0, _config.getExtraInteractionRate)(sanitisedUfoName, data.type))) interactionExtraMetrics.stopAll(id);
    else if (!data.hold3pActive || data.hold3pActive.size === 0) {
        if ((0, _platformFeatureFlags.fg)('platform_ufo_remove_experimental_holds') || !((_getConfig = (0, _config.getConfig)()) === null || _getConfig === void 0 ? void 0 : (_getConfig_experimentalInteractionMetrics = _getConfig.experimentalInteractionMetrics) === null || _getConfig_experimentalInteractionMetrics === void 0 ? void 0 : _getConfig_experimentalInteractionMetrics.enabled)) remove(id);
    }
    if ((0, _platformFeatureFlags.fg)('platform_ufo_enable_terminal_errors')) {
        PreviousInteractionLog.id = data.id;
        PreviousInteractionLog.type = data.type;
        PreviousInteractionLog.timestamp = data.end;
    }
    PreviousInteractionLog.name = data.ufoName || 'unknown';
    PreviousInteractionLog.isAborted = data.abortReason != null;
    if (data.ufoName) {
        if (((_interactionExtraMetrics_finishedInteraction = interactionExtraMetrics.finishedInteraction) === null || _interactionExtraMetrics_finishedInteraction === void 0 ? void 0 : _interactionExtraMetrics_finishedInteraction.id) !== id) // If this same interaction was not already handled, handle it
        handleInteraction(id, data);
    }
    if (isPerformanceTracingEnabled()) {
        var profilerTimingMap = new Map();
        data.reactProfilerTimings.forEach(function(profilerTiming) {
            var labelStackId = labelStackToIdString(profilerTiming.labelStack);
            if (labelStackId) {
                var _profilerTimingMap_get;
                var timing = (_profilerTimingMap_get = profilerTimingMap.get(labelStackId)) !== null && _profilerTimingMap_get !== void 0 ? _profilerTimingMap_get : {
                    labelStack: profilerTiming.labelStack
                };
                var _timing_start;
                timing.start = profilerTiming.startTime < ((_timing_start = timing.start) !== null && _timing_start !== void 0 ? _timing_start : Number.MAX_SAFE_INTEGER) ? profilerTiming.startTime : timing.start;
                var _timing_end;
                timing.end = profilerTiming.commitTime > ((_timing_end = timing.end) !== null && _timing_end !== void 0 ? _timing_end : Number.MIN_SAFE_INTEGER) ? profilerTiming.commitTime : timing.end;
                profilerTimingMap.set(labelStackId, timing);
            }
        });
        try {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                // for Firefox 102 and older
                for(var _iterator = profilerTimingMap.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, _slicedToArray._)(_step.value, 2), _step_value_ = _step_value[1], labelStack = _step_value_.labelStack, start = _step_value_.start, end = _step_value_.end;
                    performance.measure("\uD83D\uDEF8 ".concat(labelStackToString(labelStack), " [segment_ttai]"), {
                        start: start,
                        end: end,
                        detail: {
                            devtools: {
                                track: "\uD83D\uDEF8 reactUFO detailed timings",
                                color: 'secondary-dark'
                            }
                        }
                    });
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        } catch (e) {
        // do nothing
        }
    }
    try {
        // dispatch a global window event to notify the measure is completed
        window.dispatchEvent(new CustomEvent('UFO_FINISH_INTERACTION', {
            detail: data
        }));
    } catch (e) {
    // do nothing
    }
}
function sinkInteractionHandler(sinkFn) {
    if (handleInteraction === pushToQueue) {
        handleInteraction = sinkFn;
        interactionQueue.forEach(function(interaction) {
            sinkFn(interaction.id, interaction.data);
        });
        interactionQueue.length = 0;
    }
}
function sinkPostInteractionLogHandler(sinkFn) {
    postInteractionLog.sinkHandler(sinkFn);
}
// a flag to prevent multiple submitting
var activeSubmitted = false;
function tryComplete(interactionId, endTime) {
    var interaction = (0, _constants.interactions).get(interactionId);
    if (interaction != null) {
        var _interaction_hold3pActive;
        var noMoreActiveHolds = interaction.holdActive.size === 0;
        var noMoreExpHolds = (0, _platformFeatureFlags.fg)('platform_ufo_remove_experimental_holds') ? true : interaction.holdExpActive.size === 0;
        var shouldUseRawDataThirdParty = (0, _config.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        var postInteraction = function() {
            return (0, _asyncToGenerator._)(function() {
                var _getConfig_postInteractionLog, _getConfig, _interactionExtraMetrics_finishedInteraction, _getConfig_experimentalInteractionMetrics, _getConfig1, _getConfig_experimentalInteractionMetrics1, _getConfig2, experimentalVC90, experimentalTTAI, _this, start, end;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!((_getConfig = (0, _config.getConfig)()) === null || _getConfig === void 0 ? void 0 : (_getConfig_postInteractionLog = _getConfig.postInteractionLog) === null || _getConfig_postInteractionLog === void 0 ? void 0 : _getConfig_postInteractionLog.enabled)) return [
                                3,
                                3
                            ];
                            if (!(!(0, _platformFeatureFlags.fg)('platform_ufo_remove_experimental_holds') && ((_getConfig2 = (0, _config.getConfig)()) === null || _getConfig2 === void 0 ? void 0 : (_getConfig_experimentalInteractionMetrics1 = _getConfig2.experimentalInteractionMetrics) === null || _getConfig_experimentalInteractionMetrics1 === void 0 ? void 0 : _getConfig_experimentalInteractionMetrics1.enabled))) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                (0, _createExperimentalInteractionMetricsPayload.getExperimentalVCMetrics)(interaction)
                            ];
                        case 1:
                            experimentalVC90 = (_this = _state.sent()) === null || _this === void 0 ? void 0 : _this['metric:experimental:vc90'];
                            start = interaction.start, end = interaction.end;
                            experimentalTTAI = !interaction.abortReason ? Math.round(end - start) : undefined;
                            _state.label = 2;
                        case 2:
                            postInteractionLog.onInteractionComplete((0, _objectSpreadProps._)((0, _objectSpread._)({}, interaction), {
                                experimentalTTAI: experimentalTTAI,
                                experimentalVC90: experimentalVC90
                            }));
                            _state.label = 3;
                        case 3:
                            if (((_interactionExtraMetrics_finishedInteraction = interactionExtraMetrics.finishedInteraction) === null || _interactionExtraMetrics_finishedInteraction === void 0 ? void 0 : _interactionExtraMetrics_finishedInteraction.id) !== interactionId) // If interactionExtraMetrics is not waiting for measuring this interaction
                            {
                                if (!(0, _platformFeatureFlags.fg)('platform_ufo_remove_experimental_holds') && ((_getConfig1 = (0, _config.getConfig)()) === null || _getConfig1 === void 0 ? void 0 : (_getConfig_experimentalInteractionMetrics = _getConfig1.experimentalInteractionMetrics) === null || _getConfig_experimentalInteractionMetrics === void 0 ? void 0 : _getConfig_experimentalInteractionMetrics.enabled)) remove(interactionId);
                            }
                            activeSubmitted = false;
                            return [
                                2
                            ];
                    }
                });
            })();
        };
        var noMoreActive3pHolds = ((_interaction_hold3pActive = interaction.hold3pActive) === null || _interaction_hold3pActive === void 0 ? void 0 : _interaction_hold3pActive.size) === 0 || interaction.hold3pActive === undefined;
        // If using raw data third party behavior, wait for 3p holds to clear
        if (shouldUseRawDataThirdParty) {
            // If there are no non-3p holds active, mark the interaction as successful
            // but don't finish until 3p holds are cleared
            if (noMoreActiveHolds && !noMoreActive3pHolds) {
                // Mark interaction as successful by setting endTime, but don't finish yet
                if (endTime !== undefined && interaction.end === 0) interaction.end = endTime;
                ensureMetricWindows(interaction);
                // Wait for 3p holds to clear before finishing
                return;
            }
            // If all holds (including 3p) are cleared, finish the interaction
            if (noMoreActiveHolds && noMoreActive3pHolds) {
                if (!activeSubmitted) {
                    var _getConfig_extraInteractionMetrics, _getConfig, _getConfig_extraSearchPageInteraction, _getConfig1, _getConfig_extraSearchPageInteraction1, _getConfig2;
                    // Set end3p to current time when 3p holds cleared, but ensure it's at least interaction.end
                    var currentTime = endTime !== null && endTime !== void 0 ? endTime : performance.now();
                    interaction.end3p = interaction.end !== 0 && currentTime < interaction.end ? interaction.end : currentTime;
                    ensureMetricWindows(interaction);
                    finishInteraction(interactionId, interaction, interaction.end !== 0 ? interaction.end : endTime);
                    if ((_getConfig = (0, _config.getConfig)()) === null || _getConfig === void 0 ? void 0 : (_getConfig_extraInteractionMetrics = _getConfig.extraInteractionMetrics) === null || _getConfig_extraInteractionMetrics === void 0 ? void 0 : _getConfig_extraInteractionMetrics.enabled) interactionExtraMetrics.updateFinishedInteraction(interaction);
                    if (((_getConfig1 = (0, _config.getConfig)()) === null || _getConfig1 === void 0 ? void 0 : (_getConfig_extraSearchPageInteraction = _getConfig1.extraSearchPageInteraction) === null || _getConfig_extraSearchPageInteraction === void 0 ? void 0 : _getConfig_extraSearchPageInteraction.enabled) && interaction.ufoName === ((_getConfig2 = (0, _config.getConfig)()) === null || _getConfig2 === void 0 ? void 0 : (_getConfig_extraSearchPageInteraction1 = _getConfig2.extraSearchPageInteraction) === null || _getConfig_extraSearchPageInteraction1 === void 0 ? void 0 : _getConfig_extraSearchPageInteraction1.searchPageMetricName)) (0, _createExtraSearchPageInteractionPayload.onSearchPageInteractionComplete)(interactionId, interaction);
                    activeSubmitted = true;
                }
                if (noMoreExpHolds) {
                    var _getConfig_experimentalInteractionMetrics, _getConfig3;
                    if (!(0, _platformFeatureFlags.fg)('platform_ufo_remove_experimental_holds') && ((_getConfig3 = (0, _config.getConfig)()) === null || _getConfig3 === void 0 ? void 0 : (_getConfig_experimentalInteractionMetrics = _getConfig3.experimentalInteractionMetrics) === null || _getConfig_experimentalInteractionMetrics === void 0 ? void 0 : _getConfig_experimentalInteractionMetrics.enabled)) (0, _createExperimentalInteractionMetricsPayload.onExperimentalInteractionComplete)(interactionId, interaction, endTime || interaction.end);
                    postInteraction();
                }
            }
            // Send separated third-party event even when feature flag is active
            if (noMoreActiveHolds && noMoreActive3pHolds) {
                var data = (0, _objectSpreadProps._)((0, _objectSpread._)({}, interaction), {
                    end: endTime || interaction.end
                });
                interactionExtraMetrics.onInteractionComplete(interactionId, data);
            }
        } else {
            var _interactionExtraMetrics_finishedInteraction;
            // Original behavior when feature flag is not active
            if (noMoreActiveHolds && ((_interactionExtraMetrics_finishedInteraction = interactionExtraMetrics.finishedInteraction) === null || _interactionExtraMetrics_finishedInteraction === void 0 ? void 0 : _interactionExtraMetrics_finishedInteraction.id) !== interactionId) {
                // If it's not waiting for extra metrics to complete, finish the interaction as normal
                if (!activeSubmitted) {
                    var _getConfig_extraInteractionMetrics1, _getConfig4, _getConfig_extraSearchPageInteraction2, _getConfig5, _getConfig_extraSearchPageInteraction3, _getConfig6;
                    finishInteraction(interactionId, interaction, endTime);
                    if ((_getConfig4 = (0, _config.getConfig)()) === null || _getConfig4 === void 0 ? void 0 : (_getConfig_extraInteractionMetrics1 = _getConfig4.extraInteractionMetrics) === null || _getConfig_extraInteractionMetrics1 === void 0 ? void 0 : _getConfig_extraInteractionMetrics1.enabled) interactionExtraMetrics.updateFinishedInteraction(interaction);
                    if (((_getConfig5 = (0, _config.getConfig)()) === null || _getConfig5 === void 0 ? void 0 : (_getConfig_extraSearchPageInteraction2 = _getConfig5.extraSearchPageInteraction) === null || _getConfig_extraSearchPageInteraction2 === void 0 ? void 0 : _getConfig_extraSearchPageInteraction2.enabled) && interaction.ufoName === ((_getConfig6 = (0, _config.getConfig)()) === null || _getConfig6 === void 0 ? void 0 : (_getConfig_extraSearchPageInteraction3 = _getConfig6.extraSearchPageInteraction) === null || _getConfig_extraSearchPageInteraction3 === void 0 ? void 0 : _getConfig_extraSearchPageInteraction3.searchPageMetricName)) (0, _createExtraSearchPageInteractionPayload.onSearchPageInteractionComplete)(interactionId, interaction);
                    activeSubmitted = true;
                }
                if (noMoreExpHolds) {
                    var _getConfig_experimentalInteractionMetrics1, _getConfig7;
                    if (!(0, _platformFeatureFlags.fg)('platform_ufo_remove_experimental_holds') && ((_getConfig7 = (0, _config.getConfig)()) === null || _getConfig7 === void 0 ? void 0 : (_getConfig_experimentalInteractionMetrics1 = _getConfig7.experimentalInteractionMetrics) === null || _getConfig_experimentalInteractionMetrics1 === void 0 ? void 0 : _getConfig_experimentalInteractionMetrics1.enabled)) (0, _createExperimentalInteractionMetricsPayload.onExperimentalInteractionComplete)(interactionId, interaction, endTime);
                    postInteraction();
                }
            }
            if (noMoreActiveHolds && noMoreActive3pHolds) {
                var data1 = (0, _objectSpreadProps._)((0, _objectSpread._)({}, interaction), {
                    end: endTime
                });
                interactionExtraMetrics.onInteractionComplete(interactionId, data1);
            }
        }
    }
}
function callCancelCallbacks(interaction) {
    interaction.cancelCallbacks.reverse().forEach(function(cancelCallback) {
        cancelCallback();
    });
}
function abort(interactionId, abortReason) {
    var interaction = (0, _constants.interactions).get(interactionId);
    if (interaction != null) {
        var _interaction_hold3pActive;
        var shouldUseRawDataThirdParty = (0, _config.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        var noMoreActiveHolds = interaction.holdActive.size === 0;
        var has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        // If only third-party holds are active, finish as successful instead of aborting
        if (shouldUseRawDataThirdParty && noMoreActiveHolds && has3pHoldsActive) {
            var _interaction_hold3pActive1;
            var endTime = interaction.end !== 0 ? interaction.end : performance.now();
            interaction.end3p = performance.now();
            var _interaction_hold3pActive_size;
            addLifecycleObservation(interaction, {
                type: abortReason === 'timeout' ? 'timeout_expired' : 'page_unloaded',
                timestamp: interaction.end3p,
                activeHoldCount: (_interaction_hold3pActive_size = (_interaction_hold3pActive1 = interaction.hold3pActive) === null || _interaction_hold3pActive1 === void 0 ? void 0 : _interaction_hold3pActive1.size) !== null && _interaction_hold3pActive_size !== void 0 ? _interaction_hold3pActive_size : 0
            });
            ensureMetricWindows(interaction);
            finishInteraction(interactionId, interaction, endTime);
            postInteractionLog.reset();
            postInteractionLog.stopVCObserver();
            interactionExtraMetrics.stopAll(interactionId);
            if (!(0, _platformFeatureFlags.fg)('platform_ufo_remove_experimental_holds') && (0, _coinflipDefault.default)((0, _config.getExperimentalInteractionRate)(interaction.ufoName, interaction.type))) {
                (0, _createExperimentalInteractionMetricsPayload.onExperimentalInteractionComplete)(interactionId, interaction, endTime);
                remove(interactionId);
            }
            return;
        }
        callCancelCallbacks(interaction);
        interaction.abortReason = abortReason;
        var _interaction_hold3pActive_size1;
        addLifecycleObservation(interaction, {
            type: abortReason === 'timeout' ? 'timeout_expired' : 'page_unloaded',
            timestamp: performance.now(),
            activeHoldCount: interaction.holdActive.size + ((_interaction_hold3pActive_size1 = (_interaction_hold3pActive = interaction.hold3pActive) === null || _interaction_hold3pActive === void 0 ? void 0 : _interaction_hold3pActive.size) !== null && _interaction_hold3pActive_size1 !== void 0 ? _interaction_hold3pActive_size1 : 0)
        });
        finishInteraction(interactionId, interaction);
        postInteractionLog.reset();
        postInteractionLog.stopVCObserver();
        interactionExtraMetrics.stopAll(interactionId);
        if (!(0, _platformFeatureFlags.fg)('platform_ufo_remove_experimental_holds') && (0, _coinflipDefault.default)((0, _config.getExperimentalInteractionRate)(interaction.ufoName, interaction.type))) {
            (0, _createExperimentalInteractionMetricsPayload.onExperimentalInteractionComplete)(interactionId, interaction);
            remove(interactionId);
        }
    }
}
function abortByNewInteraction(interactionId, interactionName) {
    var interaction = (0, _constants.interactions).get(interactionId);
    if (interaction != null) {
        var shouldUseRawDataThirdParty = (0, _config.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        var noMoreActiveHolds = interaction.holdActive.size === 0;
        var has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        // If only third-party holds are active, finish as successful instead of aborting
        if (shouldUseRawDataThirdParty && noMoreActiveHolds && has3pHoldsActive) {
            var endTime = interaction.end !== 0 ? interaction.end : performance.now();
            // Set end3p to current time, but ensure it's at least interaction.end
            interaction.end3p = performance.now();
            addLifecycleObservation(interaction, {
                type: 'new_interaction_started',
                timestamp: interaction.end3p,
                triggerName: interactionName
            });
            ensureMetricWindows(interaction);
            finishInteraction(interactionId, interaction, endTime);
            postInteractionLog.reset();
            postInteractionLog.stopVCObserver();
            interactionExtraMetrics.stopAll(interactionId);
            if (!(0, _platformFeatureFlags.fg)('platform_ufo_remove_experimental_holds') && (0, _coinflipDefault.default)((0, _config.getExperimentalInteractionRate)(interaction.ufoName, interaction.type))) {
                (0, _createExperimentalInteractionMetricsPayload.onExperimentalInteractionComplete)(interactionId, interaction, endTime);
                remove(interactionId);
            }
            return;
        }
        callCancelCallbacks(interaction);
        interaction.abortReason = 'new_interaction';
        interaction.abortedByInteractionName = interactionName;
        addLifecycleObservation(interaction, {
            type: 'new_interaction_started',
            timestamp: performance.now(),
            triggerName: interactionName
        });
        finishInteraction(interactionId, interaction);
        postInteractionLog.reset();
        postInteractionLog.stopVCObserver();
        interactionExtraMetrics.stopAll(interactionId);
        if (!(0, _platformFeatureFlags.fg)('platform_ufo_remove_experimental_holds') && (0, _coinflipDefault.default)((0, _config.getExperimentalInteractionRate)(interaction.ufoName, interaction.type))) {
            (0, _createExperimentalInteractionMetricsPayload.onExperimentalInteractionComplete)(interactionId, interaction);
            remove(interactionId);
        }
    } else if ((0, _platformFeatureFlags.fg)('platform_reset_post_interaction_on_new_interaction')) {
        // post-interaction log is active after interaction is aborted by new one
        postInteractionLog.reset();
        postInteractionLog.stopVCObserver();
    }
}
function abortAll(abortReason, abortedByInteractionName) {
    var activeInteraction = getActiveInteraction();
    var finishInteractions = (0, _config.getFinishInteractionOnTransition)();
    (0, _constants.interactions).forEach(function(interaction, interactionId) {
        var isActiveInteraction = activeInteraction === interaction;
        var hasFinished = interaction.holdActive.size === 0;
        if (isActiveInteraction && abortReason === 'transition' && interaction.type === 'press' && (finishInteractions === null || finishInteractions === void 0 ? void 0 : finishInteractions.includes(interaction.ufoName))) hasFinished = true;
        var shouldUseRawDataThirdParty = (0, _config.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        var noMoreActiveHolds = interaction.holdActive.size === 0;
        var has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        // If only third-party holds are active, finish as successful instead of aborting
        if (shouldUseRawDataThirdParty && noMoreActiveHolds && has3pHoldsActive) {
            var endTime = interaction.end !== 0 ? interaction.end : performance.now();
            interaction.end3p = performance.now();
            addLifecycleObservation(interaction, {
                type: abortReason === 'transition' ? 'transition_started' : 'new_interaction_started',
                timestamp: interaction.end3p,
                triggerName: abortedByInteractionName
            });
            ensureMetricWindows(interaction);
            finishInteraction(interactionId, interaction, endTime);
            postInteractionLog.reset();
            postInteractionLog.stopVCObserver();
            interactionExtraMetrics.stopAll(interactionId);
            if (!(0, _platformFeatureFlags.fg)('platform_ufo_remove_experimental_holds') && (0, _coinflipDefault.default)((0, _config.getExperimentalInteractionRate)(interaction.ufoName, interaction.type))) {
                (0, _createExperimentalInteractionMetricsPayload.onExperimentalInteractionComplete)(interactionId, interaction, endTime);
                remove(interactionId);
            }
            return;
        }
        if (!hasFinished) {
            callCancelCallbacks(interaction);
            interaction.abortReason = abortReason;
            if (abortedByInteractionName != null) interaction.abortedByInteractionName = abortedByInteractionName;
            addLifecycleObservation(interaction, {
                type: abortReason === 'transition' ? 'transition_started' : 'new_interaction_started',
                timestamp: performance.now(),
                triggerName: abortedByInteractionName
            });
        }
        finishInteraction(interactionId, interaction);
        postInteractionLog.reset();
        postInteractionLog.stopVCObserver();
        interactionExtraMetrics.stopAll(interactionId);
        if (!(0, _platformFeatureFlags.fg)('platform_ufo_remove_experimental_holds') && (0, _coinflipDefault.default)((0, _config.getExperimentalInteractionRate)(interaction.ufoName, interaction.type))) {
            (0, _createExperimentalInteractionMetricsPayload.onExperimentalInteractionComplete)(interactionId, interaction);
            remove(interactionId);
        }
    });
}
function addOnCancelCallback(id, cancelCallback) {
    var interaction = (0, _constants.interactions).get(id);
    interaction === null || interaction === void 0 ? void 0 : interaction.cancelCallbacks.push(cancelCallback);
}
function addNewInteraction(interactionId, ufoName, type, startTime, rate, labelStack, routeName) {
    var trace = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : null;
    var _config_extraSearchPageInteraction, _config_extraSearchPageInteraction1;
    interactionExtraMetrics.reset();
    postInteractionLog.reset();
    var vcObserver;
    var previousTime = startTime;
    var timeoutTime = (0, _config.getInteractionTimeout)(ufoName);
    var timerID = setTimeout(function() {
        abort(interactionId, 'timeout');
    }, timeoutTime);
    function changeTimeout(newTime) {
        // we compare if the time left is lower than the new time to no
        // extend the timeout beyond the initial waiting time
        var currentTime = performance.now();
        var timeLeft = timeoutTime - (currentTime - previousTime);
        if (timeLeft < newTime) return;
        clearTimeout(this.timerID);
        var newTimerID = setTimeout(function() {
            abort(interactionId, 'timeout');
        }, newTime);
        timeoutTime = newTime;
        previousTime = currentTime;
        this.timerID = newTimerID;
    }
    var addFeatureFlagsToInteraction = (0, _coinflipDefault.default)((0, _config.getCapabilityRate)('feature_flag_access'));
    var config = (0, _config.getConfig)();
    var searchPageConfig = {
        enableSmartAnswersMutations: config === null || config === void 0 ? void 0 : (_config_extraSearchPageInteraction = config.extraSearchPageInteraction) === null || _config_extraSearchPageInteraction === void 0 ? void 0 : _config_extraSearchPageInteraction.enabled,
        searchPageRoute: config === null || config === void 0 ? void 0 : (_config_extraSearchPageInteraction1 = config.extraSearchPageInteraction) === null || _config_extraSearchPageInteraction1 === void 0 ? void 0 : _config_extraSearchPageInteraction1.searchPageRoute
    };
    if (config && config.vc) {
        var vcOptions = {
            heatmapSize: config.vc.heatmapSize,
            oldDomUpdates: config.vc.oldDomUpdates,
            devToolsEnabled: config.vc.devToolsEnabled,
            // Use centralised getter so the FedRAMP override (forces every
            // selector field to false) is applied consistently.
            selectorConfig: (0, _config.getSelectorConfig)(),
            ssrEnablePageLayoutPlaceholder: config.vc.ssrEnablePageLayoutPlaceholder,
            trackLayoutShiftOffenders: config.vc.trackLayoutShiftOffenders,
            searchPageConfig: searchPageConfig
        };
        vcObserver = (0, _vc.newVCObserver)(vcOptions);
    }
    var priorAccessedFg = type === 'press' && (0, _platformFeatureFlags.fg)('platform_ufo_drop_prior_fg_interactions') ? {} : Object.fromEntries((0, _featureFlagsAccessed.allFeatureFlagsAccessed));
    var metrics = {
        id: interactionId,
        start: startTime,
        end: 0,
        ufoName: ufoName,
        type: type,
        previousInteractionName: PreviousInteractionLog.name,
        isPreviousInteractionAborted: PreviousInteractionLog.isAborted === true,
        marks: [],
        customData: [],
        cohortingCustomData: new Map(),
        customTimings: [],
        spans: [],
        requestInfo: [],
        reactProfilerTimings: [],
        holdInfo: [],
        holdExpInfo: [],
        holdActive: new Map(),
        holdExpActive: new Map(),
        // measure when we execute this code
        // from this, we can measure the input delay -
        // how long the browser took to hand execution back to JS)
        measureStart: performance.now(),
        rate: rate,
        cancelCallbacks: [],
        metaData: {},
        errors: [],
        apdex: [],
        labelStack: labelStack,
        routeName: routeName !== null && routeName !== void 0 ? routeName : ufoName,
        featureFlags: addFeatureFlagsToInteraction ? {
            prior: priorAccessedFg,
            during: {}
        } : undefined,
        knownSegments: [],
        cleanupCallbacks: [],
        awaitReactProfilerCount: 0,
        redirects: [],
        timerID: timerID,
        changeTimeout: changeTimeout,
        trace: trace,
        vcObserver: vcObserver,
        hold3pActive: new Map(),
        hold3pInfo: [],
        minorInteractions: []
    };
    if (addFeatureFlagsToInteraction) (0, _featureFlagsAccessed.currentFeatureFlagsAccessed).clear();
    (0, _constants.interactions).set(interactionId, metrics);
    var segmentObserver = {
        onAdd: function onAdd(segment) {
            metrics.knownSegments.push(segment);
        },
        onRemove: function onRemove() {}
    };
    addSegmentObserver(segmentObserver);
    metrics.cleanupCallbacks.push(function() {
        removeSegmentObserver(segmentObserver);
    });
    metrics.cleanupCallbacks.push(function() {
        clearTimeout(metrics.timerID);
    });
    // Add cleanup for per-interaction VC observer
    if (vcObserver) metrics.cleanupCallbacks.push(function() {
        vcObserver.stop(ufoName);
    });
    var awaitBM3TTIList = (0, _config.getAwaitBM3TTIList)();
    if (awaitBM3TTIList.includes(ufoName)) addHoldByID(interactionId, [], ufoName, ufoName, true);
    if (type === 'transition' || type === 'page_load') {
        var _getConfig_postInteractionLog, _getConfig, _config_extraInteractionMetrics;
        // Use per-interaction VC observer if available, otherwise fall back to global
        var observer = vcObserver;
        if (observer) observer.start({
            startTime: startTime,
            experienceKey: ufoName
        });
        // Start post interaction observer for all if config is enabled
        // in case ufoName is updated at later time
        if ((_getConfig = (0, _config.getConfig)()) === null || _getConfig === void 0 ? void 0 : (_getConfig_postInteractionLog = _getConfig.postInteractionLog) === null || _getConfig_postInteractionLog === void 0 ? void 0 : _getConfig_postInteractionLog.enabled) postInteractionLog.startVCObserver({
            startTime: startTime
        });
        if (!(0, _platformFeatureFlags.fg)('platform_ufo_remove_experimental_holds') && (0, _coinflipDefault.default)((0, _config.getExperimentalInteractionRate)(ufoName, type))) (0, _createExperimentalInteractionMetricsPayload.experimentalVC).start({
            startTime: startTime
        });
        if (config === null || config === void 0 ? void 0 : (_config_extraInteractionMetrics = config.extraInteractionMetrics) === null || _config_extraInteractionMetrics === void 0 ? void 0 : _config_extraInteractionMetrics.enabled) interactionExtraMetrics.startVCObserver({
            startTime: startTime
        }, interactionId);
    }
    if (type === 'press') {
        // Use per-interaction VC observer if available, otherwise fall back to global
        var observer1 = vcObserver;
        if (observer1) observer1.start({
            startTime: startTime,
            experienceKey: ufoName
        });
    }
}
function addBrowserMetricEvent(event) {
    var interaction = getActiveInteraction();
    if (interaction) {
        var _event_config;
        interaction.legacyMetrics = interaction.legacyMetrics || [];
        interaction.legacyMetrics.push(event);
        if ((interaction.type === 'page_load' || interaction.type === 'transition') && ((_event_config = event.config) === null || _event_config === void 0 ? void 0 : _event_config.type) === 'PAGE_LOAD') removeHoldByID(interaction.id, interaction.ufoName);
    }
}
function addApdexToAll(apdex) {
    (0, _constants.interactions).forEach(function(interaction, key) {
        interaction.apdex.push(apdex);
        try {
            var _apdex_startTime;
            // for Firefox 102 and older
            performance.measure("\uD83D\uDEF8 ".concat(apdex.key, " [bm3_tti]"), {
                start: (_apdex_startTime = apdex.startTime) !== null && _apdex_startTime !== void 0 ? _apdex_startTime : interaction.start,
                end: apdex.stopTime,
                detail: {
                    devtools: {
                        track: 'main metrics',
                        trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                        color: 'primary-dark'
                    }
                }
            });
            performance.mark("[bm3] TTI", {
                startTime: apdex.stopTime,
                detail: {
                    devtools: {
                        dataType: 'marker'
                    }
                }
            });
        } catch (e) {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') removeHoldByID(key, interaction.ufoName);
    });
}
function addApdex(interactionId, apdexInfo) {
    var interaction = (0, _constants.interactions).get(interactionId);
    if (interaction != null) {
        interaction.apdex.push(apdexInfo);
        try {
            var _apdexInfo_startTime;
            // for Firefox 102 and older
            performance.measure("\uD83D\uDEF8 ".concat(apdexInfo.key, " [bm3_tti]"), {
                start: (_apdexInfo_startTime = apdexInfo.startTime) !== null && _apdexInfo_startTime !== void 0 ? _apdexInfo_startTime : interaction.start,
                end: apdexInfo.stopTime,
                detail: {
                    devtools: {
                        track: 'main metrics',
                        trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                        color: 'primary-dark'
                    }
                }
            });
            performance.mark("[bm3] TTI", {
                startTime: apdexInfo.stopTime,
                detail: {
                    devtools: {
                        dataType: 'marker'
                    }
                }
            });
        } catch (e) {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') removeHoldByID(interactionId, interaction.ufoName);
    }
}
function addRequestInfo(interactionId, labelStack, requestInfo) {
    var interaction = (0, _constants.interactions).get(interactionId);
    if (interaction != null) interaction.requestInfo.push((0, _objectSpread._)({
        labelStack: labelStack
    }, requestInfo));
}
function isSegmentLabel(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}
function getSegmentCacheKey(labelStack) {
    return labelStack.map(function(l) {
        if (isSegmentLabel(l)) return "".concat(l.name, "_").concat(l.segmentId);
        return l.name;
    }).join('|');
}
function addSegment(labelStack) {
    var key = getSegmentCacheKey(labelStack);
    var existingSegment = segmentCache.get(key);
    if (!existingSegment) {
        var segmentInfo = {
            labelStack: labelStack
        };
        segmentCache.set(key, segmentInfo);
        segmentObservers.forEach(function(observer) {
            observer.onAdd(segmentInfo);
        });
    }
}
function removeSegment(labelStack) {
    var key = getSegmentCacheKey(labelStack);
    var segmentInfo = segmentCache.get(key);
    if (segmentInfo) {
        segmentCache.delete(JSON.stringify(labelStack));
        var cacheKey = (0, _utils.stringifyLabelStackFully)(labelStack);
        segmentUnmountCache.set(cacheKey, (segmentUnmountCache.get(cacheKey) || 0) + 1);
        segmentObservers.forEach(function(observer) {
            observer.onRemove(segmentInfo);
        });
    }
}
function addRedirect(interactionId, fromUfoName, nextUfoName, nextRouteName, time) {
    var interaction = (0, _constants.interactions).get(interactionId);
    if (interaction != null) {
        interaction.ufoName = nextUfoName;
        interaction.routeName = nextRouteName;
        interaction.redirects.push({
            fromInteractionName: fromUfoName,
            time: time
        });
        if (isPerformanceTracingEnabled()) {
            var prevRedirect = interaction.redirects.at(-2);
            try {
                var _prevRedirect_time;
                // for Firefox 102 and older
                performance.measure("\uD83D\uDEF8 ".concat(nextUfoName, " [redirect]"), {
                    start: (_prevRedirect_time = prevRedirect === null || prevRedirect === void 0 ? void 0 : prevRedirect.time) !== null && _prevRedirect_time !== void 0 ? _prevRedirect_time : interaction.start,
                    end: time,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'tertiary'
                        }
                    }
                });
            } catch (e) {
            // do nothing
            }
        }
    }
}
var interactionSpans = [];
var defaultLabelStack = [
    {
        name: 'custom'
    }
];
function addCustomSpans(name, start) {
    var end = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : performance.now(), size = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, labelStack = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : defaultLabelStack;
    var customSpan = {
        type: 'custom',
        name: name,
        start: start,
        end: end,
        labelStack: labelStack,
        size: size
    };
    interactionSpans.push(customSpan);
}

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_to_consumable_array":"1eSZf","@swc/helpers/_/_ts_generator":"78Tqx","uuid":"5elg8","@atlaskit/platform-feature-flags":"kO5t9","../coinflip":"cHdgG","../common/utils/timing-name":"2SHBw","../config":"1BZI5","../create-experimental-interaction-metrics-payload":"c2BXB","../create-extra-search-page-interaction-payload":"hcmdv","../create-payload/common/utils":"li4VQ","../experience-trace-id-context":"7SDPo","../feature-flags-accessed":"kHUgA","../interaction-id-context":"eh9Yb","../segment/ssr-render-profiler":"1naJ6","../vc":"3cXH4","./common/constants":"7CDIL","./interaction-extra-metrics":"71ANZ","./post-interaction-log":"1Ho6H","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2SHBw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MAX_TIMING_NAME_LENGTH", function() {
    return MAX_TIMING_NAME_LENGTH;
});
parcelHelpers.export(exports, "sanitizeTimingName", function() {
    return sanitizeTimingName;
});
var MAX_TIMING_NAME_LENGTH = 255;
function sanitizeTimingName(name) {
    if (name.length <= MAX_TIMING_NAME_LENGTH) return name;
    return name.slice(0, MAX_TIMING_NAME_LENGTH);
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"c2BXB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "installInteractionSink", function() {
    return installInteractionSink;
});
parcelHelpers.export(exports, "sinkExperimentalHandler", function() {
    return sinkExperimentalHandler;
});
parcelHelpers.export(exports, "onExperimentalInteractionComplete", function() {
    return onExperimentalInteractionComplete;
});
parcelHelpers.export(exports, "ExperimentalVCMetrics", function() {
    return ExperimentalVCMetrics;
});
parcelHelpers.export(exports, "experimentalVC", function() {
    return experimentalVC;
});
parcelHelpers.export(exports, "getExperimentalVCMetrics", function() {
    return getExperimentalVCMetrics;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _hiddenTiming = require("../hidden-timing");
var _vcObserver = require("../vc/vc-observer");
var interactionBuffer = [];
var bufferInteractionData = function(interactionId, data) {
    interactionBuffer.push({
        interactionId: interactionId,
        data: data
    });
};
function clearInteractionBuffer() {
    interactionBuffer.length = 0;
}
function appendInteractionData(interactionId, data) {
    bufferInteractionData(interactionId, data);
}
function installInteractionSink(handler) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = interactionBuffer[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = _step.value, interactionId = _step_value.interactionId, data = _step_value.data;
            handler(interactionId, data);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    clearInteractionBuffer();
    bufferInteractionData = handler;
}
function sinkExperimentalHandler(sinkFn) {
    installInteractionSink(sinkFn);
}
function onExperimentalInteractionComplete(interactionId, data) {
    var endTime = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : performance.now();
    if (data.ufoName) {
        data.end = endTime;
        appendInteractionData(interactionId, data);
        clearInteractionBuffer();
    }
}
var ExperimentalVCMetrics = /*#__PURE__*/ function() {
    "use strict";
    function ExperimentalVCMetrics() {
        (0, _classCallCheck._)(this, ExperimentalVCMetrics);
        this.vcObserver = null;
    }
    (0, _createClass._)(ExperimentalVCMetrics, [
        {
            key: "initialize",
            value: function initialize(options) {
                if (this.vcObserver === null) this.vcObserver = new (0, _vcObserver.VCObserver)((0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
                    isPostInteraction: true
                }));
                return this;
            }
        },
        {
            key: "start",
            value: function start(param) {
                var startTime = param.startTime;
                var _this_vcObserver;
                (_this_vcObserver = this.vcObserver) === null || _this_vcObserver === void 0 ? void 0 : _this_vcObserver.start({
                    startTime: startTime
                });
            }
        }
    ]);
    return ExperimentalVCMetrics;
}();
var experimentalVC = new ExperimentalVCMetrics();
function getExperimentalVCMetrics(interaction) {
    return (0, _asyncToGenerator._)(function() {
        var vcObserver, pageVisibilityUpToTTAI, _interaction_apdex_, _interaction_apdex, prefix, result, VC;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    // Use per-interaction VC observer if available, otherwise fall back to global experimentalVC
                    vcObserver = interaction.experimentalVCObserver || experimentalVC.vcObserver;
                    pageVisibilityUpToTTAI = (0, _hiddenTiming.getPageVisibilityState)(interaction.start, interaction.end);
                    if (!vcObserver) return [
                        3,
                        2
                    ];
                    prefix = 'ufo-experimental';
                    return [
                        4,
                        vcObserver.getVCResult({
                            start: interaction.start,
                            stop: interaction.end,
                            tti: (_interaction_apdex = interaction.apdex) === null || _interaction_apdex === void 0 ? void 0 : (_interaction_apdex_ = _interaction_apdex[0]) === null || _interaction_apdex_ === void 0 ? void 0 : _interaction_apdex_.stopTime,
                            isEventAborted: !!interaction.abortReason,
                            prefix: prefix,
                            vc: interaction.vc,
                            experienceKey: interaction.ufoName,
                            interactionId: interaction.id,
                            interactionType: interaction.type,
                            isPageVisible: pageVisibilityUpToTTAI === 'visible',
                            interactionAbortReason: interaction.abortReason
                        })
                    ];
                case 1:
                    result = _state.sent();
                    VC = result === null || result === void 0 ? void 0 : result['metrics:vc'];
                    if (!VC || !(result === null || result === void 0 ? void 0 : result["".concat(prefix, ":vc:clean")])) return [
                        2,
                        result
                    ];
                    if (interaction.abortReason || pageVisibilityUpToTTAI !== 'visible') return [
                        2,
                        result
                    ];
                    return [
                        2,
                        (0, _objectSpreadProps._)((0, _objectSpread._)({}, result), {
                            'metric:experimental:vc90': VC['90']
                        })
                    ];
                case 2:
                    return [
                        2,
                        null
                    ];
            }
        });
    })();
}

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_ts_generator":"78Tqx","../hidden-timing":"lV0ww","../vc/vc-observer":"2fRJ3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lV0ww":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getEarliestHiddenTiming", function() {
    return getEarliestHiddenTiming;
});
parcelHelpers.export(exports, "isOpenedInBackground", function() {
    return isOpenedInBackground;
});
parcelHelpers.export(exports, "getHasHiddenTimingBeforeSetup", function() {
    return getHasHiddenTimingBeforeSetup;
});
parcelHelpers.export(exports, "setupHiddenTimingCapture", function() {
    return setupHiddenTimingCapture;
});
parcelHelpers.export(exports, "getPageVisibilityState", function() {
    return getPageVisibilityState;
});
/**
 * Sets up the throttle detection mechanism.
 * This should be called early in the page lifecycle.
 * Uses a periodic timer to detect browser throttling by measuring timer drift.
 */ parcelHelpers.export(exports, "setupThrottleDetection", function() {
    return setupThrottleDetection;
});
/**
 * Stops the throttle detection mechanism.
 * Useful for cleanup in tests or when the feature is no longer needed.
 */ parcelHelpers.export(exports, "stopThrottleDetection", function() {
    return stopThrottleDetection;
});
/**
 * Checks if the tab was throttled at any point during the specified time window.
 * Returns true if any timer measurement showed significant drift (throttling).
 *
 * @param startTime - The start timestamp of the window to check (DOMHighResTimeStamp)
 * @param endTime - The end timestamp of the window to check (DOMHighResTimeStamp)
 * @returns boolean - true if throttling was detected during the time window, false otherwise
 */ parcelHelpers.export(exports, "isTabThrottled", function() {
    return isTabThrottled;
});
/**
 * Gets detailed throttle information for debugging purposes.
 * Returns all throttle measurements within the specified time window.
 *
 * @param startTime - The start timestamp of the window to check
 * @param endTime - The end timestamp of the window to check
 * @returns Array of throttle measurements within the time window
 */ parcelHelpers.export(exports, "getThrottleMeasurements", function() {
    return getThrottleMeasurements;
});
/**
 * Injects a fake throttle measurement for testing purposes.
 * This allows integration tests to simulate throttling scenarios.
 *
 * @param measurement - The throttle measurement to inject
 */ parcelHelpers.export(exports, "__injectThrottleMeasurementForTesting", function() {
    return __injectThrottleMeasurementForTesting;
});
/**
 * Returns the page visibility timeline entries within the specified time window.
 * Each entry contains the time (relative to startTime) and whether the page was hidden.
 *
 * @param startTime - The start timestamp of the window (DOMHighResTimeStamp)
 * @param endTime - The end timestamp of the window (DOMHighResTimeStamp)
 * @returns Array of HiddenTimingItem entries within the time window, with times relative to startTime
 */ parcelHelpers.export(exports, "getPageVisibilityTimeline", function() {
    return getPageVisibilityTimeline;
});
var _bindEventListener = require("bind-event-listener");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var timings = [];
var wasHiddenFlag;
var setupFlag = false;
// Threshold for determining if page was opened in background.
// If setup runs within this time and page is hidden, we assume it was opened in a background tab.
var OPENED_IN_BACKGROUND_THRESHOLD_MS = 100;
var openedInBackground = null;
function isPageHidden() {
    if ('visibilityState' in document) return document.visibilityState === 'hidden';
    else // @ts-expect-error - Property 'hidden' does not exist on type 'never'.
    return document.hidden;
}
var SIZE = 50;
var insertIndex = 0;
function getEarliestHiddenTiming(startTime, endTime) {
    var _timings_find;
    var earliestHiddenTiming = (_timings_find = timings.find(function(param) {
        var hidden = param.hidden, time = param.time;
        return hidden && time > 0 && time >= startTime && time <= endTime;
    })) === null || _timings_find === void 0 ? void 0 : _timings_find.time;
    if (typeof earliestHiddenTiming === 'number') return Math.round(earliestHiddenTiming - startTime);
}
function isOpenedInBackground(interactionType) {
    if (interactionType !== 'page_load') return false;
    // Check native visibility-state entries first (most reliable, Chromium only)
    try {
        var entries = performance.getEntriesByType('visibility-state');
        if (entries.length > 0) return entries.some(function(entry) {
            return entry.name === 'hidden' && entry.startTime <= OPENED_IN_BACKGROUND_THRESHOLD_MS;
        });
    } catch (e) {
    // visibility-state not supported (Firefox/Safari)
    }
    // Fallback to cached value from setup (determined using time threshold)
    return openedInBackground === true;
}
function pushHidden(isPageHiddenFlag, time) {
    timings[insertIndex] = {
        time: time !== null && time !== void 0 ? time : performance.now(),
        hidden: isPageHiddenFlag
    };
    insertIndex = (insertIndex + 1) % SIZE;
    wasHiddenFlag = isPageHiddenFlag;
}
function handleChange() {
    var isPageHiddenFlag = isPageHidden();
    if (isPageHiddenFlag) {
        if (!wasHiddenFlag) pushHidden(isPageHiddenFlag);
        wasHiddenFlag = true;
    } else {
        if (wasHiddenFlag) pushHidden(isPageHiddenFlag);
        wasHiddenFlag = false;
    }
}
var hasHiddenTimingBeforeSetup = false;
function getHasHiddenTimingBeforeSetup() {
    return hasHiddenTimingBeforeSetup;
}
function setup() {
    try {
        var results = performance.getEntriesByType('visibility-state');
        results === null || results === void 0 ? void 0 : results.forEach(function(result) {
            if ((0, _platformFeatureFlags.fg)('platform_ufo_use_native_page_visibility_api')) pushHidden(result.name === 'hidden', result.startTime);
            if (result.name === 'hidden') hasHiddenTimingBeforeSetup = true;
        });
    } catch (e) {
    /* do nothing */ /* note: visibility-state entry types are not available in Firefox/Safari: https://developer.mozilla.org/en-US/docs/Web/API/VisibilityStateEntry#browser_compatibility */ }
    (0, _bindEventListener.bind)(window, {
        type: 'pageshow',
        listener: handleChange
    });
    (0, _bindEventListener.bind)(window, {
        type: 'pagehide',
        listener: handleChange
    });
    (0, _bindEventListener.bind)(document, {
        type: 'visibilitychange',
        listener: handleChange
    });
}
function setupHiddenTimingCapture() {
    if (!setupFlag) {
        var isPageHiddenFlag = isPageHidden();
        var setupTime = performance.now();
        // Determine if page was opened in background.
        // If we're early in page lifecycle (< threshold) and page is hidden,
        // it's likely the page was opened in a background tab.
        if (openedInBackground === null) openedInBackground = isPageHiddenFlag && setupTime < OPENED_IN_BACKGROUND_THRESHOLD_MS;
        pushHidden(isPageHiddenFlag, 0);
        setup();
        setupFlag = true;
    }
}
function getPageVisibilityState(start, end) {
    // Input validation - return default for invalid inputs
    if (!Number.isFinite(start) || !Number.isFinite(end)) return 'visible';
    // Desirable default value is visible
    if (timings.length === 0) return 'visible';
    var currentSize = timings.length;
    var hiddenState = 'mixed';
    var startIdx = insertIndex;
    var endIdx = insertIndex;
    // currentSize is capped at SIZE.
    for(var i = 0; i < currentSize; i++){
        var tmpIdx = (insertIndex + i) % currentSize;
        // Add bounds checking before accessing array element
        if (timings[tmpIdx] && timings[tmpIdx].time <= end) {
            endIdx = tmpIdx;
            if (timings[tmpIdx].time <= start) startIdx = tmpIdx;
        }
    }
    // Add bounds checking before accessing timings array
    if (endIdx - startIdx === 0 && timings[startIdx]) hiddenState = timings[startIdx].hidden ? 'hidden' : 'visible';
    return hiddenState;
}
// Throttle detection configuration
// Expected interval for timer checks (in milliseconds)
var THROTTLE_CHECK_INTERVAL_MS = 1000;
// Threshold for considering a timer as throttled (50% drift tolerance)
var THROTTLE_DRIFT_THRESHOLD = 1.5;
// Maximum number of throttle measurements to store (circular buffer)
var THROTTLE_BUFFER_SIZE = 120;
// Circular buffer to store throttle measurements
var throttleMeasurements = [];
var throttleInsertIndex = 0;
var throttleIntervalId = null;
var lastThrottleCheckTime = null;
var throttleSetupDone = false;
function recordThrottleMeasurement(expectedElapsed, actualElapsed) {
    var isThrottled = actualElapsed > expectedElapsed * THROTTLE_DRIFT_THRESHOLD;
    throttleMeasurements[throttleInsertIndex] = {
        time: performance.now(),
        expectedElapsed: expectedElapsed,
        actualElapsed: actualElapsed,
        isThrottled: isThrottled
    };
    throttleInsertIndex = (throttleInsertIndex + 1) % THROTTLE_BUFFER_SIZE;
}
function throttleCheckCallback() {
    var currentTime = performance.now();
    if (lastThrottleCheckTime !== null) {
        var actualElapsed = currentTime - lastThrottleCheckTime;
        recordThrottleMeasurement(THROTTLE_CHECK_INTERVAL_MS, actualElapsed);
    }
    lastThrottleCheckTime = currentTime;
}
function setupThrottleDetection() {
    if (throttleSetupDone) return;
    throttleSetupDone = true;
    // Record the initial timestamp
    lastThrottleCheckTime = performance.now();
    // Start the periodic timer for throttle detection
    throttleIntervalId = setInterval(throttleCheckCallback, THROTTLE_CHECK_INTERVAL_MS);
}
function stopThrottleDetection() {
    if (throttleIntervalId !== null) {
        clearInterval(throttleIntervalId);
        throttleIntervalId = null;
    }
    lastThrottleCheckTime = null;
    throttleSetupDone = false;
    throttleMeasurements.length = 0;
    throttleInsertIndex = 0;
}
function isTabThrottled(startTime, endTime) {
    // Input validation
    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || startTime >= endTime) return false;
    // No measurements available
    if (throttleMeasurements.length === 0) return false;
    // Check if any measurement within the time window indicates throttling
    for(var i = 0; i < throttleMeasurements.length; i++){
        var measurement = throttleMeasurements[i];
        if (measurement && measurement.time >= startTime && measurement.time <= endTime && measurement.isThrottled) return true;
    }
    return false;
}
function getThrottleMeasurements(startTime, endTime) {
    // Input validation
    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || startTime >= endTime) return [];
    return throttleMeasurements.filter(function(measurement) {
        return measurement && measurement.time >= startTime && measurement.time <= endTime;
    });
}
function __injectThrottleMeasurementForTesting(measurement) {
    throttleMeasurements[throttleInsertIndex] = measurement;
    throttleInsertIndex = (throttleInsertIndex + 1) % THROTTLE_BUFFER_SIZE;
}
function getPageVisibilityTimeline(startTime, endTime) {
    // Input validation
    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || startTime >= endTime) return [];
    if (timings.length === 0) return [];
    var result = [];
    // Find the most recent entry at or before startTime to establish initial state
    var initialEntry;
    var currentSize = timings.length;
    for(var i = 0; i < currentSize; i++){
        var idx = (insertIndex + i) % currentSize;
        var entry = timings[idx];
        if (entry && entry.time <= startTime) initialEntry = entry;
    }
    // Add the initial visibility state at the start of the window
    if (initialEntry) result.push({
        time: 0,
        hidden: initialEntry.hidden
    });
    // Add all entries within the time window
    for(var i1 = 0; i1 < currentSize; i1++){
        var idx1 = (insertIndex + i1) % currentSize;
        var entry1 = timings[idx1];
        if (entry1 && entry1.time > startTime && entry1.time <= endTime) result.push({
            time: Math.round(entry1.time - startTime),
            hidden: entry1.hidden
        });
    }
    return result;
}
// Expose testing API on window for integration tests
if (typeof window !== 'undefined') window.__reactUfoHiddenTiming = {
    __injectThrottleMeasurementForTesting: __injectThrottleMeasurementForTesting
};

},{"bind-event-listener":"bjeUU","@atlaskit/platform-feature-flags":"kO5t9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2fRJ3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VCObserver", function() {
    return VCObserver;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _config = require("../../config");
var _interactionMetrics = require("../../interaction-metrics");
var _attachAbortListeners = require("./attachAbortListeners");
var _getVCRevisionDebugDetails = require("./getVCRevisionDebugDetails");
var _getVCRevisionsData = require("./getVCRevisionsData");
var _getViewport = require("./getViewport");
var _observers = require("./observers");
var abortReason = {
    scroll: 'scroll',
    keypress: 'keypress',
    resize: 'resize',
    error: 'error'
};
var UNUSED_SECTOR = 0;
function filterComponentsLog(log) {
    return Object.fromEntries(Object.entries(log).map(function(param) {
        var _param = (0, _slicedToArray._)(param, 2), timestamp = _param[0], entries = _param[1];
        return [
            Number(timestamp),
            entries.map(function(entry) {
                var __debug__element = entry.__debug__element, rest = (0, _objectWithoutProperties._)(entry, [
                    "__debug__element"
                ]);
                return rest;
            })
        ];
    }));
}
var VCObserver = /*#__PURE__*/ function() {
    "use strict";
    function VCObserver(options) {
        var _this = this;
        (0, _classCallCheck._)(this, VCObserver);
        /* abort logic */ this.abortReason = {
            reason: null,
            info: '',
            timestamp: -1,
            blocking: false
        };
        this.outOfBoundaryInfo = '';
        this.viewport = {
            w: 0,
            h: 0
        };
        /* heatmap */ this.arraySize = 0;
        this.componentsLog = {};
        this.vcRatios = {};
        this.active = false;
        this.totalTime = 0;
        this.startTime = 0;
        this._startMeasureTimestamp = -1;
        this.ssr = {
            reactRendered: -1
        };
        this.unbind = [];
        this.getAbortReasonInfo = function() {
            if (_this.abortReason.reason === null) return null;
            var info = _this.abortReason.info !== '' ? " ".concat(_this.abortReason.info) : '';
            return "".concat(_this.abortReason.reason).concat(info);
        };
        this.getVCRawData = function() {
            _this.measureStart();
            if (!_this.active) {
                _this.measureStop();
                return null;
            }
            _this.stop();
            var abortReasonInfo = _this.getAbortReasonInfo();
            _this.measureStop();
            return {
                abortReasonInfo: abortReasonInfo,
                abortReason: (0, _objectSpread._)({}, _this.abortReason),
                heatmap: _this.heatmap,
                heatmapNext: _this.heatmapNext,
                outOfBoundaryInfo: _this.outOfBoundaryInfo,
                totalTime: Math.round(_this.totalTime + _this.observers.getTotalTime()),
                componentsLog: (0, _objectSpread._)({}, _this.componentsLog),
                viewport: (0, _objectSpread._)({}, _this.viewport),
                oldDomUpdatesEnabled: _this.oldDomUpdatesEnabled,
                devToolsEnabled: _this.devToolsEnabled,
                ratios: _this.vcRatios
            };
        };
        this.getVCResult = function(param) {
            var start = param.start, stop = param.stop, tti = param.tti, prefix = param.prefix, ssr = param.ssr, vc = param.vc, isEventAborted = param.isEventAborted, experienceKey = param.experienceKey, interactionId = param.interactionId, includeSSRRatio = param.includeSSRRatio;
            return (0, _asyncToGenerator._)(function() {
                var startTime, fullPrefix, rawData, abortReason, abortReasonInfo, heatmap, heatmapNext, outOfBoundaryInfo, totalTime, componentsLog, viewport, devToolsEnabled, ratios, isTTVCv1Disabled, vcAbortedResultWithRevisions, ttvcV1Result, VC, VCBox, VCEntries, totalPainted, _componentsLog, vcNext, outOfBoundary, stopTime, ttvcV1DevToolInfo, ttvcV2DevToolInfo, shouldCreateDebugDetails, v1RevisionDebugDetails, v2RevisionDebugDetails, _window___ufo_devtool_onVCRevisionReady__, _window, // Handle v2
                _window___ufo_devtool_onVCRevisionReady__1, _window1, _window___on_ufo_vc_debug_data_ready, _window2, _window___on_ufo_vc_debug_data_ready1, _window3, isVCClean, revisionsData, _obj, speedIndex, SSRRatio, SSRRatioNext, _obj1, SSRRatioPayload, _obj2, isTTVCv3Enabled, _obj3, _obj4;
                return (0, _tsGenerator._)(this, function(_state) {
                    startTime = performance.now();
                    // add local measurement
                    fullPrefix = prefix !== undefined && prefix !== '' ? "".concat(prefix, ":") : '';
                    rawData = vc !== undefined ? vc : this.getVCRawData();
                    if (rawData === null) return [
                        2,
                        {}
                    ];
                    abortReason = rawData.abortReason, abortReasonInfo = rawData.abortReasonInfo, heatmap = rawData.heatmap, heatmapNext = rawData.heatmapNext, outOfBoundaryInfo = rawData.outOfBoundaryInfo, totalTime = rawData.totalTime, componentsLog = rawData.componentsLog, viewport = rawData.viewport, devToolsEnabled = rawData.devToolsEnabled, ratios = rawData.ratios;
                    isTTVCv1Disabled = !(0, _config.isVCRevisionEnabled)('fy25.01', experienceKey);
                    if (abortReasonInfo !== null) {
                        // exposing data to devtools
                        try {
                            if (devToolsEnabled && !this.isPostInteraction) window.__vcNotAvailableReason = abortReasonInfo;
                        } catch (e) {}
                        vcAbortedResultWithRevisions = (0, _defineProperty._)({}, "".concat(fullPrefix, "vc:rev"), [
                            {
                                revision: 'fy25.02',
                                clean: false,
                                'metric:vc90': null,
                                abortReason: abortReason.reason,
                                abortTimestamp: Math.round(abortReason.timestamp)
                            }
                        ]);
                        if (!isTTVCv1Disabled) vcAbortedResultWithRevisions["".concat(fullPrefix, "vc:rev")].push({
                            revision: 'fy25.01',
                            clean: false,
                            'metric:vc90': null,
                            abortReason: abortReason.reason,
                            abortTimestamp: Math.round(abortReason.timestamp)
                        });
                        return [
                            2,
                            vcAbortedResultWithRevisions
                        ];
                    }
                    ttvcV1Result = isTTVCv1Disabled ? {
                        VC: {},
                        VCBox: {},
                        VCEntries: {
                            abs: [],
                            rel: [],
                            speedIndex: -1
                        },
                        totalPainted: -1
                    } : VCObserver.calculateVC({
                        heatmap: heatmap,
                        ssr: ssr,
                        componentsLog: (0, _objectSpread._)({}, componentsLog),
                        viewport: viewport,
                        fixSSRAttribution: includeSSRRatio
                    });
                    VC = ttvcV1Result.VC, VCBox = ttvcV1Result.VCBox, VCEntries = ttvcV1Result.VCEntries, totalPainted = ttvcV1Result.totalPainted;
                    _componentsLog = {};
                    Object.entries(this.componentsLog).forEach(function(param) {
                        var _param = (0, _slicedToArray._)(param, 2), _timestamp = _param[0], value = _param[1];
                        var timestamp = Number(_timestamp);
                        if (stop > timestamp) _componentsLog[timestamp] = value;
                    });
                    vcNext = VCObserver.calculateVC({
                        heatmap: heatmapNext,
                        ssr: ssr,
                        componentsLog: _componentsLog,
                        viewport: viewport,
                        fixSSRAttribution: includeSSRRatio
                    });
                    outOfBoundary = outOfBoundaryInfo ? (0, _defineProperty._)({}, "".concat(fullPrefix, "vc:oob"), outOfBoundaryInfo) : {};
                    //const oldDomUpdates = oldDomUpdatesEnabled ? { [`${fullPrefix}vc:old:dom`]: vcNext.VCBox } : {};
                    stopTime = performance.now();
                    // exposing data to devtools
                    try {
                        if (!this.isPostInteraction && devToolsEnabled) {
                            ttvcV1DevToolInfo = isTTVCv1Disabled ? undefined : {
                                entries: VCEntries.rel,
                                log: componentsLog,
                                metrics: {
                                    '75': VC['75'],
                                    '80': VC['80'],
                                    '85': VC['85'],
                                    '90': VC['90'],
                                    '95': VC['95'],
                                    '98': VC['98'],
                                    '99': VC['99'],
                                    tti: tti,
                                    ttai: stop - start
                                },
                                start: start,
                                stop: stop,
                                heatmap: heatmap,
                                ratios: ratios
                            };
                            ttvcV2DevToolInfo = {
                                entries: vcNext.VCEntries.rel,
                                log: componentsLog,
                                metrics: {
                                    '75': vcNext.VC['75'],
                                    '80': vcNext.VC['80'],
                                    '85': vcNext.VC['85'],
                                    '90': vcNext.VC['90'],
                                    '95': vcNext.VC['95'],
                                    '98': vcNext.VC['98'],
                                    '99': vcNext.VC['99'],
                                    tti: tti,
                                    ttai: stop - start
                                },
                                start: start,
                                stop: stop,
                                heatmap: heatmapNext,
                                ratios: ratios
                            };
                            if (isTTVCv1Disabled) {
                                window.__vc = ttvcV2DevToolInfo;
                                window.__vcNext = ttvcV2DevToolInfo;
                            } else {
                                window.__vc = ttvcV1DevToolInfo;
                                window.__vcNext = ttvcV2DevToolInfo;
                            }
                            // Emitting a custom event to make it available in the Chrome extension
                            window.dispatchEvent(new CustomEvent('vcReady', {
                                detail: {
                                    log: filterComponentsLog(componentsLog),
                                    entries: isTTVCv1Disabled ? vcNext.VCEntries.rel : VCEntries.rel
                                }
                            }));
                        }
                        if (!this.isPostInteraction) {
                            // Only create revision debug details if callbacks exist
                            shouldCreateDebugDetails = typeof window.__ufo_devtool_onVCRevisionReady__ === 'function' || typeof window.__on_ufo_vc_debug_data_ready === 'function';
                            if (shouldCreateDebugDetails) {
                                v1RevisionDebugDetails = (0, _getVCRevisionDebugDetails.getVCRevisionDebugDetails)({
                                    revision: 'fy25.01',
                                    isClean: !abortReasonInfo,
                                    abortReason: abortReason.reason,
                                    VCEntries: VCEntries.rel,
                                    componentsLog: componentsLog,
                                    interactionId: interactionId
                                });
                                v2RevisionDebugDetails = (0, _getVCRevisionDebugDetails.getVCRevisionDebugDetails)({
                                    revision: 'fy25.02',
                                    isClean: !abortReasonInfo,
                                    abortReason: abortReason.reason,
                                    VCEntries: vcNext.VCEntries.rel,
                                    componentsLog: componentsLog,
                                    interactionId: interactionId
                                });
                                // Add devtool callback for both v1 and v2
                                if (typeof window.__ufo_devtool_onVCRevisionReady__ === 'function') {
                                    ;
                                    // Handle v1 if not disabled
                                    if (!isTTVCv1Disabled) (_window___ufo_devtool_onVCRevisionReady__ = (_window = window).__ufo_devtool_onVCRevisionReady__) === null || _window___ufo_devtool_onVCRevisionReady__ === void 0 ? void 0 : _window___ufo_devtool_onVCRevisionReady__.call(_window, v1RevisionDebugDetails);
                                    (_window___ufo_devtool_onVCRevisionReady__1 = (_window1 = window).__ufo_devtool_onVCRevisionReady__) === null || _window___ufo_devtool_onVCRevisionReady__1 === void 0 ? void 0 : _window___ufo_devtool_onVCRevisionReady__1.call(_window1, v2RevisionDebugDetails);
                                }
                                if (typeof window.__on_ufo_vc_debug_data_ready === 'function') {
                                    ;
                                    if (!isTTVCv1Disabled) (_window___on_ufo_vc_debug_data_ready = (_window2 = window).__on_ufo_vc_debug_data_ready) === null || _window___on_ufo_vc_debug_data_ready === void 0 ? void 0 : _window___on_ufo_vc_debug_data_ready.call(_window2, v1RevisionDebugDetails);
                                    (_window___on_ufo_vc_debug_data_ready1 = (_window3 = window).__on_ufo_vc_debug_data_ready) === null || _window___on_ufo_vc_debug_data_ready1 === void 0 ? void 0 : _window___on_ufo_vc_debug_data_ready1.call(_window3, v2RevisionDebugDetails);
                                }
                            }
                        }
                    } catch (e) {
                    /*  do nothing */ }
                    isVCClean = !abortReasonInfo;
                    revisionsData = (0, _getVCRevisionsData.getVCRevisionsData)({
                        fullPrefix: fullPrefix,
                        interaction: {
                            start: start,
                            end: stop
                        },
                        isVCClean: isVCClean,
                        calculatedVC: {
                            VC: VC,
                            VCBox: VCBox
                        },
                        calculatedVCNext: {
                            VC: vcNext.VC,
                            VCBox: vcNext.VCBox
                        },
                        isEventAborted: isEventAborted,
                        experienceKey: experienceKey,
                        ratios: ratios
                    });
                    speedIndex = (_obj = {}, (0, _defineProperty._)(_obj, "ufo:speedIndex", isTTVCv1Disabled ? vcNext.VCEntries.speedIndex : VCEntries.speedIndex), (0, _defineProperty._)(_obj, "ufo:next:speedIndex", vcNext.VCEntries.speedIndex), _obj);
                    SSRRatio = VCObserver.getSSRRatio(VCEntries.rel, ssr);
                    SSRRatioNext = VCObserver.getSSRRatio(vcNext.VCEntries.rel, ssr);
                    SSRRatioPayload = includeSSRRatio ? (_obj1 = {}, (0, _defineProperty._)(_obj1, "".concat(fullPrefix, "vc:ssrRatio"), isTTVCv1Disabled ? SSRRatioNext : SSRRatio), (0, _defineProperty._)(_obj1, "".concat(fullPrefix, "vc:next:ssrRatio"), SSRRatioNext), _obj1) : {};
                    if (isTTVCv1Disabled) return [
                        2,
                        (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)((_obj2 = {}, (0, _defineProperty._)(_obj2, "".concat(fullPrefix, "vc:size"), viewport), (0, _defineProperty._)(_obj2, "".concat(fullPrefix, "vc:time"), Math.round(totalTime + (stopTime - startTime))), (0, _defineProperty._)(_obj2, "".concat(fullPrefix, "vc:ratios"), ratios), _obj2), outOfBoundary), (0, _defineProperty._)({}, "".concat(fullPrefix, "vc:ignored"), this.getIgnoredElements(componentsLog))), SSRRatioPayload), (0, _defineProperty._)({}, "".concat(fullPrefix, "vc:ssrRatio"), SSRRatioNext)), revisionsData, speedIndex)
                    ];
                    isTTVCv3Enabled = (0, _config.isVCRevisionEnabled)('fy25.03', experienceKey);
                    return [
                        2,
                        (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)((_obj3 = {
                            'metrics:vc': VC
                        }, (0, _defineProperty._)(_obj3, "".concat(fullPrefix, "vc:state"), true), (0, _defineProperty._)(_obj3, "".concat(fullPrefix, "vc:clean"), isVCClean), (0, _defineProperty._)(_obj3, "".concat(fullPrefix, "vc:dom"), VCBox), (0, _defineProperty._)(_obj3, "".concat(fullPrefix, "vc:updates"), isTTVCv3Enabled ? undefined : VCEntries.rel.slice(0, 50)), (0, _defineProperty._)(_obj3, "".concat(fullPrefix, "vc:size"), viewport), (0, _defineProperty._)(_obj3, "".concat(fullPrefix, "vc:time"), Math.round(totalTime + (stopTime - startTime))), (0, _defineProperty._)(_obj3, "".concat(fullPrefix, "vc:total"), totalPainted), (0, _defineProperty._)(_obj3, "".concat(fullPrefix, "vc:ratios"), ratios), (0, _defineProperty._)(_obj3, "".concat(fullPrefix, "vc:ssrRatio"), SSRRatio), _obj3), outOfBoundary), (_obj4 = {}, (0, _defineProperty._)(_obj4, "".concat(fullPrefix, "vc:next"), vcNext.VC), (0, _defineProperty._)(_obj4, "".concat(fullPrefix, "vc:next:updates"), isTTVCv3Enabled ? undefined : vcNext.VCEntries.rel.slice(0, 50)), (0, _defineProperty._)(_obj4, "".concat(fullPrefix, "vc:next:dom"), vcNext.VCBox), _obj4)), SSRRatioPayload), (0, _defineProperty._)({}, "".concat(fullPrefix, "vc:ignored"), this.getIgnoredElements(componentsLog))), revisionsData, speedIndex)
                    ];
                });
            }).call(_this);
        };
        this.handleUpdate = function(rawTime, intersectionRect, targetName, element, type, ignoreReason, attributeName, oldValue, newValue) {
            if (_this.abortReason.reason === null || _this.abortReason.blocking === false) {
                var time = Math.round(rawTime - _this.startTime);
                var mappedValues = _this.mapPixelsToHeatmap(intersectionRect.left, intersectionRect.top, intersectionRect.width, intersectionRect.height);
                _this.vcRatios[targetName] = _this.getElementRatio(mappedValues);
                if (!ignoreReason) _this.applyChangesToHeatMap(mappedValues, time, _this.heatmapNext);
                var interaction = (0, _interactionMetrics.getActiveInteraction)();
                var isTTVCv1Disabled = !(0, _config.isVCRevisionEnabled)('fy25.01', interaction === null || interaction === void 0 ? void 0 : interaction.ufoName);
                if (!isTTVCv1Disabled && (!ignoreReason || ignoreReason === 'not-visible') && type !== 'attr') _this.applyChangesToHeatMap(mappedValues, time, _this.heatmap);
                if (!_this.componentsLog[time]) _this.componentsLog[time] = [];
                _this.componentsLog[time].push({
                    __debug__element: _this.devToolsEnabled ? new WeakRef(element) : null,
                    type: type,
                    intersectionRect: intersectionRect,
                    targetName: targetName,
                    ignoreReason: ignoreReason,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                });
            }
        };
        this.mapPixelsToHeatmap = function(left, top, width, height) {
            var _this_viewport = _this.viewport, w = _this_viewport.w, h = _this_viewport.h;
            var l = Math.floor(left / w * _this.arraySize);
            var t = Math.floor(top / h * _this.arraySize);
            var r = Math.ceil((left + width) / w * _this.arraySize);
            var b = Math.ceil((top + height) / h * _this.arraySize);
            // that info is temporary to get info why it goes over boundary
            if (_this.outOfBoundaryInfo === '') {
                var outOfBoundaryInfo = '';
                if (r > _this.arraySize) outOfBoundaryInfo += " r ".concat(r, " ! ").concat(left, " ").concat(width);
                if (b > _this.arraySize) outOfBoundaryInfo += " r ".concat(r, " ! ").concat(top, " ").concat(height);
                _this.outOfBoundaryInfo = outOfBoundaryInfo;
            }
            // correct values to min - 0, max - arraySize
            var result = {
                l: Math.max(0, l),
                t: Math.max(0, t),
                r: Math.min(_this.arraySize, r),
                b: Math.min(_this.arraySize, b)
            };
            return result;
        };
        this.getElementRatio = function(mappedValues) {
            var r = mappedValues.r, l = mappedValues.l, b = mappedValues.b, t = mappedValues.t;
            return (r - l) * (b - t) / (_this.arraySize * _this.arraySize);
        };
        this.abortReasonCallback = function(key, time) {
            switch(key){
                case 'wheel':
                    _this.setAbortReason(abortReason.scroll, time);
                    break;
                case 'keydown':
                    // Don't abort press interactions on keydown events, as keydown is expected
                    // when users press Enter/Space to activate buttons or other interactive elements
                    if ((0, _platformFeatureFlags.fg)('platform_ufo_keypress_interaction_abort')) {
                        var interaction = (0, _interactionMetrics.getActiveInteraction)();
                        if ((interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'press') break;
                    }
                    _this.setAbortReason(abortReason.keypress, time);
                    break;
                case 'resize':
                    _this.setAbortReason(abortReason.resize, time);
                    break;
            }
        };
        this.attachAbortListeners = function() {
            var _window;
            _this.detachAbortListeners();
            var unbinds = (0, _attachAbortListeners.attachAbortListeners)(window, _this.viewport, _this.abortReasonCallback);
            if ((_window = window) === null || _window === void 0 ? void 0 : _window.__SSR_ABORT_LISTENERS__) Object.entries(window.__SSR_ABORT_LISTENERS__.aborts).forEach(function(param) {
                var _param = (0, _slicedToArray._)(param, 2), key = _param[0], time = _param[1];
                if (time) _this.abortReasonCallback(key, time);
            });
            _this.unbind = unbinds;
        };
        this.arraySize = options.heatmapSize || 200;
        this.devToolsEnabled = options.devToolsEnabled || false;
        this.oldDomUpdatesEnabled = options.oldDomUpdates || false;
        var ssrEnablePageLayoutPlaceholder = options.ssrEnablePageLayoutPlaceholder, ssrPlaceholderHandler = options.ssrPlaceholderHandler;
        // Selector-config resolution is centralised in `getSelectorConfig()`
        // (`../../config`). It enforces FedRAMP-override > caller-override >
        // centrally configured > caller default. When `getSelectorConfig()`
        // returns `undefined` we fall back to the legacy hard-coded default
        // to preserve pre-existing behaviour for callers that don't pass an
        // explicit `selectorConfig`.
        var LEGACY_DEFAULT_SELECTOR_CONFIG = {
            id: false,
            testId: false,
            role: false,
            className: true,
            dataVC: true
        };
        this.observers = new (0, _observers.Observers)({
            selectorConfig: (0, _config.getSelectorConfig)(options.selectorConfig, LEGACY_DEFAULT_SELECTOR_CONFIG) || options.selectorConfig || LEGACY_DEFAULT_SELECTOR_CONFIG,
            SSRConfig: {
                enablePageLayoutPlaceholder: ssrEnablePageLayoutPlaceholder || false
            },
            ssrPlaceholderHandler: ssrPlaceholderHandler
        });
        this.heatmap = !(0, _config.isVCRevisionEnabled)('fy25.01') ? [] : this.getCleanHeatmap();
        this.heatmapNext = this.getCleanHeatmap();
        this.isPostInteraction = options.isPostInteraction || false;
    }
    (0, _createClass._)(VCObserver, [
        {
            key: "start",
            value: function start(param) {
                var startTime = param.startTime;
                this.active = true;
                if (this.observers.isBrowserSupported()) {
                    this.setViewportSize();
                    this.resetState();
                    this.startTime = startTime;
                    this.attachAbortListeners();
                    this.observers.subscribeResults(this.handleUpdate);
                    this.observers.observe();
                } else this.setAbortReason('not-supported', startTime);
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.observers.disconnect();
                this.detachAbortListeners();
            }
        },
        {
            key: "getIgnoredElements",
            value: function getIgnoredElements(componentsLog) {
                return Object.values(componentsLog).flat().filter(function(param) {
                    var ignoreReason = param.ignoreReason;
                    return Boolean(ignoreReason);
                }).map(function(param) {
                    var targetName = param.targetName, ignoreReason = param.ignoreReason;
                    return {
                        targetName: targetName,
                        ignoreReason: ignoreReason
                    };
                });
            }
        },
        {
            key: "setSSRElement",
            value: function setSSRElement(element) {
                this.observers.setReactRootElement(element);
            }
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart() {
                var startTime = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : performance.now();
                this.observers.setReactRootRenderStart(startTime);
            }
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop() {
                var stopTime = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : performance.now();
                this.observers.setReactRootRenderStop(stopTime);
            }
        },
        {
            key: "collectSSRPlaceholders",
            value: function collectSSRPlaceholders() {
            // This is handled by the shared SSRPlaceholderHandlers in VCObserverWrapper
            // Individual observers don't need to implement this
            }
        },
        {
            key: "setAbortReason",
            value: function setAbortReason(abort, timestamp) {
                var info = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : '';
                if (this.abortReason.reason === null || this.abortReason.blocking === false) {
                    this.abortReason.reason = abort;
                    this.abortReason.info = info;
                    this.abortReason.timestamp = timestamp;
                    this.abortReason.blocking = abort !== abortReason.scroll;
                    if (this.abortReason.blocking) this.detachAbortListeners();
                }
            }
        },
        {
            key: "resetState",
            value: function resetState() {
                this.abortReason = {
                    reason: null,
                    info: '',
                    timestamp: -1,
                    blocking: false
                };
                this.detachAbortListeners();
                this.heatmap = !(0, _config.isVCRevisionEnabled)('fy25.01') ? [] : this.getCleanHeatmap();
                this.heatmapNext = this.getCleanHeatmap();
                this.totalTime = 0;
                this.componentsLog = {};
                this.vcRatios = {};
            }
        },
        {
            key: "getCleanHeatmap",
            value: function getCleanHeatmap() {
                var _this = this;
                return Array(this.arraySize).fill('').map(function() {
                    return Array(_this.arraySize).fill(UNUSED_SECTOR);
                });
            }
        },
        {
            key: "setViewportSize",
            value: function setViewportSize() {
                this.viewport.w = (0, _getViewport.getViewportWidth)();
                this.viewport.h = (0, _getViewport.getViewportHeight)();
            }
        },
        {
            key: "applyChangesToHeatMap",
            value: function applyChangesToHeatMap(a, time, heatmap) {
                var l = a.l, t = a.t, r = a.r, b = a.b;
                var localHeatmap = heatmap;
                for(var row = t; row < b; row++){
                    for(var col = l; col < r; col++)if (localHeatmap[row] === undefined) {
                        try {
                            this.setAbortReason(abortReason.error, time, "index - ".concat(row));
                        } catch (e) {
                            this.setAbortReason(abortReason.error, time, 'row error');
                        }
                        return;
                    } else localHeatmap[row][col] = time;
                }
            }
        },
        {
            key: "detachAbortListeners",
            value: function detachAbortListeners() {
                if (this.unbind) {
                    var unbind = this.unbind;
                    for(var i = 0; i < unbind.length; i++)unbind[i]();
                    this.unbind.length = 0;
                }
            }
        },
        {
            key: "measureStart",
            value: function measureStart() {
                this._startMeasureTimestamp = performance.now();
            }
        },
        {
            key: "measureStop",
            value: function measureStop() {
                if (this._startMeasureTimestamp === -1) return;
                this.totalTime += performance.now() - this._startMeasureTimestamp;
                this._startMeasureTimestamp = -1;
            }
        }
    ], [
        {
            key: "getSSRRatio",
            value: function getSSRRatio(entries, ssr) {
                if (ssr === undefined || entries.length === 0) return undefined;
                var maybeSSR = entries[0];
                if (maybeSSR.elements[0] === 'SSR') return maybeSSR.vc;
                return 0;
            }
        },
        {
            key: "calculateVC",
            value: function calculateVC(param) {
                var heatmap = param.heatmap, _param_ssr = param.ssr, ssr = _param_ssr === void 0 ? UNUSED_SECTOR : _param_ssr, componentsLog = param.componentsLog, viewport = param.viewport, fixSSRAttribution = param.fixSSRAttribution;
                var lastUpdate = {};
                var totalPainted = 0;
                var ssrTime = fixSSRAttribution ? Math.floor(ssr) : ssr;
                if (ssrTime !== UNUSED_SECTOR) {
                    var _window_document;
                    var element = {
                        __debug__element: new WeakRef((_window_document = window.document) === null || _window_document === void 0 ? void 0 : _window_document.body),
                        intersectionRect: {
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            x: 0,
                            y: 0,
                            width: viewport.w,
                            height: viewport.h,
                            toJSON: function toJSON() {
                                return {};
                            }
                        },
                        targetName: 'SSR'
                    };
                    if (!componentsLog[ssrTime]) componentsLog[ssrTime] = [];
                    componentsLog[ssrTime].push(element);
                }
                heatmap.forEach(function(line) {
                    line.forEach(function(entry) {
                        var rounded = Math.floor(entry === UNUSED_SECTOR && ssrTime !== UNUSED_SECTOR ? ssrTime : entry);
                        totalPainted += rounded !== UNUSED_SECTOR ? 1 : 0;
                        if (rounded !== UNUSED_SECTOR) lastUpdate[rounded] = lastUpdate[rounded] ? lastUpdate[rounded] + 1 : 1;
                    });
                });
                var entries = Object.entries(lastUpdate).map(function(a) {
                    return [
                        parseInt(a[0], 10),
                        a[1]
                    ];
                }).sort(function(a, b) {
                    return a[0] > b[0] ? 1 : -1;
                });
                var VC = VCObserver.makeVCReturnObj();
                var VCBox = VCObserver.makeVCReturnObj();
                entries.reduce(function() {
                    var acc = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, v = arguments.length > 1 ? arguments[1] : void 0;
                    var currRatio = v[1] / totalPainted;
                    var VCRatio = currRatio + acc;
                    var preciseCurrRatio = Math.round(100 * (v[1] / totalPainted));
                    var preciseAccRatio = Math.round(acc * 100);
                    VCRatio = (preciseCurrRatio + preciseAccRatio) / 100;
                    var time = v[0];
                    VCObserver.VCParts.forEach(function(key) {
                        var value = parseInt(key, 10);
                        if ((VC[key] === null || VC[key] === undefined) && VCRatio >= value / 100) {
                            var _componentsLog_time;
                            VC[key] = time;
                            VCBox[key] = (0, _toConsumableArray._)(new Set((_componentsLog_time = componentsLog[time]) === null || _componentsLog_time === void 0 ? void 0 : _componentsLog_time.filter(function(v) {
                                return !v.ignoreReason;
                            }).map(function(v) {
                                return v.targetName;
                            })));
                        }
                    });
                    return VCRatio;
                }, 0);
                var VCEntries = entries.reduce(function(acc, param, i) {
                    var _param = (0, _slicedToArray._)(param, 2), timestamp = _param[0], entryPainted = _param[1];
                    var _acc_abs_, _componentsLog_timestamp, _acc_rel_;
                    var currentlyPainted = entryPainted + (((_acc_abs_ = acc.abs[i - 1]) === null || _acc_abs_ === void 0 ? void 0 : _acc_abs_[1]) || 0);
                    var currentlyPaintedRatio = Math.round(currentlyPainted / totalPainted * 1000) / 10;
                    var logEntry = (0, _toConsumableArray._)(new Set((_componentsLog_timestamp = componentsLog[timestamp]) === null || _componentsLog_timestamp === void 0 ? void 0 : _componentsLog_timestamp.filter(function(v) {
                        return !v.ignoreReason;
                    }).map(function(v) {
                        return v.targetName;
                    })));
                    var _acc_rel__vc;
                    var ratioDelta = (currentlyPaintedRatio - ((_acc_rel__vc = (_acc_rel_ = acc.rel[i - 1]) === null || _acc_rel_ === void 0 ? void 0 : _acc_rel_.vc) !== null && _acc_rel__vc !== void 0 ? _acc_rel__vc : 0)) / 100;
                    var speedIndex = timestamp * ratioDelta;
                    acc.speedIndex += speedIndex;
                    acc.abs.push([
                        timestamp,
                        currentlyPainted
                    ]);
                    acc.rel.push({
                        time: timestamp,
                        vc: currentlyPaintedRatio,
                        elements: logEntry
                    });
                    return acc;
                }, {
                    abs: [],
                    rel: [],
                    speedIndex: 0
                });
                VCEntries.speedIndex = Math.round(VCEntries.speedIndex);
                return {
                    VC: VC,
                    VCBox: VCBox,
                    VCEntries: VCEntries,
                    totalPainted: totalPainted
                };
            }
        },
        {
            key: "makeVCReturnObj",
            value: function makeVCReturnObj() {
                var vc = {};
                VCObserver.VCParts.forEach(function(v) {
                    vc[v] = null;
                });
                return vc;
            }
        }
    ]);
    return VCObserver;
}();
/** config * */ VCObserver.VCParts = [
    '25',
    '50',
    '75',
    '80',
    '85',
    '90',
    '95',
    '98',
    '99'
];

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_to_consumable_array":"1eSZf","@swc/helpers/_/_ts_generator":"78Tqx","@atlaskit/platform-feature-flags":"kO5t9","../../config":"1BZI5","../../interaction-metrics":"diQdd","./attachAbortListeners":"1G0au","./getVCRevisionDebugDetails":"kFwcB","./getVCRevisionsData":"2sm8t","./getViewport":"iUEco","./observers":"lJ5p1","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1G0au":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "attachAbortListeners", function() {
    return attachAbortListeners;
});
var _bindEventListener = require("bind-event-listener");
var _types = require("../../common/vc/types");
var _getViewport = require("./getViewport");
function attachAbortListeners(window, initialViewPort, callback) {
    var unbindWheel = (0, _bindEventListener.bind)(window, {
        type: (0, _types.AbortEvent).wheel,
        listener: function(e) {
            callback((0, _types.AbortEvent).wheel, e.timeStamp);
        },
        options: {
            passive: true,
            once: true
        }
    });
    var unbindKeydown = (0, _bindEventListener.bind)(window, {
        type: (0, _types.AbortEvent).keydown,
        listener: function(e) {
            callback((0, _types.AbortEvent).keydown, e.timeStamp);
        },
        options: {
            once: true
        }
    });
    var unbindResize = (0, _bindEventListener.bind)(window, {
        type: (0, _types.AbortEvent).resize,
        listener: function(e) {
            if ((0, _getViewport.getViewportWidth)() !== initialViewPort.w || (0, _getViewport.getViewportHeight)() !== initialViewPort.h) {
                callback((0, _types.AbortEvent).resize, e.timeStamp);
                unbindResize();
            }
        }
    });
    return [
        unbindWheel,
        unbindKeydown,
        unbindResize
    ];
}

},{"bind-event-listener":"bjeUU","../../common/vc/types":"bJ3HM","./getViewport":"iUEco","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bJ3HM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbortEvent", function() {
    return AbortEvent;
});
var AbortEvent = {
    wheel: 'wheel',
    keydown: 'keydown',
    resize: 'resize'
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iUEco":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getViewportWidth", function() {
    return getViewportWidth;
});
parcelHelpers.export(exports, "getViewportHeight", function() {
    return getViewportHeight;
});
function getViewportWidth() {
    var document = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.document;
    var documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch (e) {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}
function getViewportHeight() {
    var document = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.document;
    var documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch (e) {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kFwcB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getVCRevisionDebugDetails", function() {
    return getVCRevisionDebugDetails;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
function getVCRevisionDebugDetails(param) {
    var revision = param.revision, isClean = param.isClean, abortReason = param.abortReason, VCEntries = param.VCEntries, componentsLog = param.componentsLog, interactionId = param.interactionId;
    // Pre-sort VCEntries by time for efficient lookups
    var sortedVCEntries = (0, _toConsumableArray._)(VCEntries).sort(function(a, b) {
        return a.time - b.time;
    });
    // Pre-calculate max viewport percentage up to each time for efficient lookups
    var maxViewportPercentageAtTime = new Map();
    var maxSoFar = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = sortedVCEntries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var entry = _step.value;
            maxSoFar = Math.max(maxSoFar, entry.vc);
            maxViewportPercentageAtTime.set(entry.time, maxSoFar);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Helper function to find the biggest previous viewport percentage
    var getBiggestPreviousViewportPercentage = function(targetTime) {
        // Binary search for the largest time <= targetTime
        var left = 0;
        var right = sortedVCEntries.length - 1;
        var result = -1;
        while(left <= right){
            var mid = Math.floor((left + right) / 2);
            if (sortedVCEntries[mid].time <= targetTime) {
                result = mid;
                left = mid + 1;
            } else right = mid - 1;
        }
        return result >= 0 ? maxViewportPercentageAtTime.get(sortedVCEntries[result].time) || null : null;
    };
    var allVcLogs = [];
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        var _loop = function() {
            var entry = _step1.value;
            var timeLogEntries = componentsLog[entry.time];
            allVcLogs.push({
                time: entry.time,
                viewportPercentage: entry.vc,
                entries: entry.elements.map(function(element) {
                    var logEntry = timeLogEntries === null || timeLogEntries === void 0 ? void 0 : timeLogEntries.find(function(log) {
                        return log.targetName === element;
                    });
                    return {
                        elementName: element,
                        type: logEntry === null || logEntry === void 0 ? void 0 : logEntry.type,
                        rect: logEntry === null || logEntry === void 0 ? void 0 : logEntry.intersectionRect,
                        visible: true,
                        attributeName: logEntry === null || logEntry === void 0 ? void 0 : logEntry.attributeName,
                        oldValue: logEntry === null || logEntry === void 0 ? void 0 : logEntry.oldValue,
                        newValue: logEntry === null || logEntry === void 0 ? void 0 : logEntry.newValue,
                        ignoreReason: logEntry === null || logEntry === void 0 ? void 0 : logEntry.ignoreReason
                    };
                })
            });
        };
        // Add regular VC entries
        for(var _iterator1 = VCEntries[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true)_loop();
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
    try {
        // Add ignored elements - only process timestamps that have ignored elements
        for(var _iterator2 = Object.entries(componentsLog)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var _step_value = (0, _slicedToArray._)(_step2.value, 2), timestamp = _step_value[0], timeLogEntries = _step_value[1];
            var ignoredElements = timeLogEntries.filter(function(log) {
                return log.ignoreReason;
            });
            if (ignoredElements.length === 0) continue;
            var time = Number(timestamp);
            var viewportPercentage = getBiggestPreviousViewportPercentage(time);
            allVcLogs.push({
                time: time,
                viewportPercentage: viewportPercentage,
                entries: ignoredElements.map(function(logEntry) {
                    return {
                        elementName: logEntry.targetName,
                        type: logEntry.type,
                        rect: logEntry.intersectionRect,
                        visible: false,
                        attributeName: logEntry.attributeName,
                        oldValue: logEntry.oldValue,
                        newValue: logEntry.newValue,
                        ignoreReason: logEntry.ignoreReason
                    };
                })
            });
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
            }
        } finally{
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }
    // Sort once at the end
    allVcLogs.sort(function(a, b) {
        return a.time - b.time;
    });
    return {
        revision: revision,
        isClean: isClean,
        abortReason: abortReason,
        vcLogs: allVcLogs,
        interactionId: interactionId
    };
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_to_consumable_array":"1eSZf","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2sm8t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Optimized implementation (current one)
parcelHelpers.export(exports, "getVCRevisionsData", function() {
    return getVCRevisionsData;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _config = require("../../config");
var _hiddenTiming = require("../../hidden-timing");
var VCParts = [
    '25',
    '50',
    '75',
    '80',
    '85',
    '90',
    '95',
    '98',
    '99'
];
var READONLY_EMPTY_ARRAY = Array.from({
    length: 0
});
// Helper function to create vcDetails object to avoid code duplication
function createVCDetails(calculatedVC, shouldHaveVCmetric) {
    if (!shouldHaveVCmetric || !calculatedVC || !calculatedVC.VC || !calculatedVC.VCBox) return {};
    var details = {};
    var VC = calculatedVC.VC, VCBox = calculatedVC.VCBox; // Destructure once to avoid repeated property access
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = VCParts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            details[key] = {
                t: VC[key] || -1,
                e: VCBox[key] || READONLY_EMPTY_ARRAY
            };
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return details;
}
function getVCRevisionsData(param) {
    var fullPrefix = param.fullPrefix, interaction = param.interaction, isVCClean = param.isVCClean, isEventAborted = param.isEventAborted, calculatedVC = param.calculatedVC, calculatedVCNext = param.calculatedVCNext, experienceKey = param.experienceKey, ratios = param.ratios;
    var pageVisibilityUpToTTAI = (0, _hiddenTiming.getPageVisibilityState)(interaction.start, interaction.end);
    var isVisiblePageVisibleUpToTTAI = pageVisibilityUpToTTAI === 'visible';
    var shouldHaveVCmetric = isVCClean && !isEventAborted && isVisiblePageVisibleUpToTTAI;
    var availableVCRevisionPayloads = [];
    if ((0, _config.isVCRevisionEnabled)('fy25.01', experienceKey)) {
        var revision = {
            revision: 'fy25.01',
            clean: isVCClean,
            'metric:vc90': shouldHaveVCmetric ? calculatedVC.VC['90'] : null,
            vcDetails: createVCDetails(calculatedVC, shouldHaveVCmetric)
        };
        if (shouldHaveVCmetric) revision.ratios = ratios;
        availableVCRevisionPayloads.push(revision);
    }
    if ((0, _config.isVCRevisionEnabled)('fy25.02', experienceKey)) {
        var revision1 = {
            revision: 'fy25.02',
            clean: isVCClean,
            'metric:vc90': shouldHaveVCmetric ? calculatedVCNext.VC['90'] : null,
            vcDetails: createVCDetails(calculatedVCNext, shouldHaveVCmetric)
        };
        if (shouldHaveVCmetric) revision1.ratios = ratios;
        availableVCRevisionPayloads.push(revision1);
    }
    return (0, _defineProperty._)({}, "".concat(fullPrefix, "vc:rev"), availableVCRevisionPayloads);
}

},{"@swc/helpers/_/_define_property":"e80IS","../../config":"1BZI5","../../hidden-timing":"lV0ww","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lJ5p1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Observers", function() {
    return Observers;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _config = require("../../../config");
var _vcUtils = require("../media-wrapper/vc-utils");
var _isNonVisualStyleMutation = require("./non-visual-styles/is-non-visual-style-mutation");
var _isNonVisualStyleMutationDefault = parcelHelpers.interopDefault(_isNonVisualStyleMutation);
var _rllPlaceholders = require("./rll-placeholders");
var _ssrPlaceholders = require("./ssr-placeholders");
var state = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
function isElementVisible(target) {
    if (!target || typeof target.checkVisibility !== 'function') return true;
    var isVisible = target.checkVisibility({
        contentVisibilityAuto: true,
        opacityProperty: true,
        visibilityProperty: true
    });
    return isVisible;
}
var Observers = /*#__PURE__*/ function() {
    "use strict";
    function Observers(opts) {
        var _this = this;
        var _this1 = this;
        (0, _classCallCheck._)(this, Observers);
        var _opts_SSRConfig;
        this.observedMutations = new WeakMap();
        this.elementsInView = new Set();
        this.callbacks = new Set();
        this.totalTime = 0;
        this._startMeasureTimestamp = -1;
        this.ssr = {
            state: state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        this.selectorConfig = {
            id: false,
            testId: false,
            role: false,
            className: true,
            dataVC: true
        };
        this.subscribeResults = function(cb) {
            _this.callbacks.add(cb);
        };
        this.observeElement = function(node, mutation, type, ignoreReason, attributeName) {
            var oldValue = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null, newValue = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null;
            var _this_intersectionObserver;
            (_this_intersectionObserver = _this1.intersectionObserver) === null || _this_intersectionObserver === void 0 ? void 0 : _this_intersectionObserver.observe(node);
            _this1.observedMutations.set(node, {
                mutation: mutation,
                ignoreReason: ignoreReason,
                type: type,
                attributeName: attributeName,
                oldValue: oldValue,
                newValue: newValue
            });
        };
        // Selector-config resolution is centralised in `getSelectorConfig()`.
        // It enforces FedRAMP-override > caller-override > centrally
        // configured > caller default.
        var resolved = (0, _config.getSelectorConfig)(opts.selectorConfig, this.selectorConfig);
        this.selectorConfig = resolved !== null && resolved !== void 0 ? resolved : (0, _objectSpread._)({}, this.selectorConfig, opts.selectorConfig);
        this.intersectionObserver = this.getIntersectionObserver();
        this.mutationObserver = this.getMutationObserver();
        // Use shared SSR placeholder handler if provided, otherwise create new one
        if (opts.ssrPlaceholderHandler) this.ssrPlaceholderHandler = opts.ssrPlaceholderHandler;
        else this.ssrPlaceholderHandler = new (0, _ssrPlaceholders.SSRPlaceholderHandlers)({
            enablePageLayoutPlaceholder: (_opts_SSRConfig = opts.SSRConfig) === null || _opts_SSRConfig === void 0 ? void 0 : _opts_SSRConfig.enablePageLayoutPlaceholder
        });
    }
    (0, _createClass._)(Observers, [
        {
            key: "isBrowserSupported",
            value: function isBrowserSupported() {
                return typeof window.IntersectionObserver === 'function' && typeof window.MutationObserver === 'function';
            }
        },
        {
            key: "observe",
            value: function observe() {
                var _this_mutationObserver;
                this.totalTime = 0;
                this.ssr = {
                    state: state.normal,
                    reactRootElement: null,
                    renderStart: -1,
                    renderStop: -1
                };
                (_this_mutationObserver = this.mutationObserver) === null || _this_mutationObserver === void 0 ? void 0 : _this_mutationObserver.observe(document.body, {
                    attributeFilter: [
                        'hidden',
                        'style',
                        'src',
                        'class'
                    ],
                    attributeOldValue: true,
                    attributes: true,
                    childList: true,
                    subtree: true
                });
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                var _this_mutationObserver, _this_intersectionObserver;
                (_this_mutationObserver = this.mutationObserver) === null || _this_mutationObserver === void 0 ? void 0 : _this_mutationObserver.disconnect();
                (_this_intersectionObserver = this.intersectionObserver) === null || _this_intersectionObserver === void 0 ? void 0 : _this_intersectionObserver.disconnect();
                this.observedMutations = new WeakMap();
                this.elementsInView.clear();
                this.callbacks.clear();
                this.ssr.reactRootElement = null;
                this.ssrPlaceholderHandler.clear();
            }
        },
        {
            key: "getTotalTime",
            value: function getTotalTime() {
                return this.totalTime;
            }
        },
        {
            key: "setReactRootElement",
            value: function setReactRootElement(element) {
                this.ssr.reactRootElement = element;
            }
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart() {
                var startTime = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : performance.now();
                this.ssr.renderStart = startTime;
                this.ssr.state = state.waitingForFirstRender;
            }
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop() {
                var stopTime = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : performance.now();
                this.ssr.renderStop = stopTime;
            }
        },
        {
            key: "getMutationObserver",
            value: function getMutationObserver() {
                var _this = this;
                if (!this.isBrowserSupported()) return null;
                return new MutationObserver(function(mutations) {
                    _this.measureStart();
                    mutations.forEach(function(mutation) {
                        // patching element if timestamp not automatically added
                        // eslint-disable-next-line no-param-reassign
                        mutation.timestamp = mutation.timestamp === undefined ? performance.now() : mutation.timestamp;
                        var ignoreReason = '';
                        if (_this.ssr.state === state.waitingForFirstRender && mutation.timestamp > _this.ssr.renderStart && mutation.target === _this.ssr.reactRootElement) {
                            _this.ssr.state = state.ignoring;
                            if (_this.ssr.renderStop === -1) // arbitrary 500ms DOM update window
                            _this.ssr.renderStop = mutation.timestamp + 500;
                            ignoreReason = 'ssr-hydration';
                        }
                        if (_this.ssr.state === state.ignoring && mutation.timestamp > _this.ssr.renderStart && mutation.target === _this.ssr.reactRootElement) {
                            if (mutation.timestamp <= _this.ssr.renderStop) ignoreReason = 'ssr-hydration';
                            else _this.ssr.state = state.normal;
                        }
                        if (mutation.type === 'childList') {
                            mutation.addedNodes.forEach(function(node) {
                                if ((0, _vcUtils.isContainedWithinMediaWrapper)(node)) ignoreReason = 'image';
                                if ((0, _instanceof._)(node, HTMLElement)) {
                                    if (_this.ssrPlaceholderHandler.isPlaceholder(node) || _this.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                        _this.ssrPlaceholderHandler.checkIfExistedAndSizeMatching(node).then(function(result) {
                                            if (result === false) _this.observeElement(node, mutation, 'html', ignoreReason);
                                        });
                                        return;
                                    }
                                    if (_this.ssrPlaceholderHandler.isPlaceholderReplacement(node) || _this.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                        _this.ssrPlaceholderHandler.validateReactComponentMatchToPlaceholder(node).then(function(result) {
                                            if (result === false) _this.observeElement(node, mutation, 'html', ignoreReason);
                                        });
                                        return;
                                    }
                                    _this.observeElement(node, mutation, 'html', ignoreReason);
                                }
                                if ((0, _instanceof._)(node, Text) && node.parentElement != null) _this.observeElement(node.parentElement, mutation, 'text', ignoreReason);
                            });
                            mutation.removedNodes.forEach(function(node) {
                                if ((0, _instanceof._)(node, Element)) {
                                    var _this_intersectionObserver;
                                    _this.elementsInView.delete(node);
                                    (_this_intersectionObserver = _this.intersectionObserver) === null || _this_intersectionObserver === void 0 ? void 0 : _this_intersectionObserver.unobserve(node);
                                }
                            });
                        } else if (mutation.type === 'attributes') {
                            if ((0, _instanceof._)(mutation.target, HTMLElement)) {
                                var attributeName = mutation.attributeName;
                                var _mutation_oldValue;
                                /*
							"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
							I think it might have been something along the lines that for consistency every setAttribute call should create a record.
							Conceptually there is after all a mutation: there is an old value replaced with a new one,
							and whether or not they are the same doesn't really matter.
							And Custom elements should work the same way as MutationObserver."
							https://github.com/whatwg/dom/issues/520#issuecomment-336574796
						*/ var oldValue = (_mutation_oldValue = mutation.oldValue) !== null && _mutation_oldValue !== void 0 ? _mutation_oldValue : undefined;
                                var newValue = attributeName ? mutation.target.getAttribute(attributeName) : undefined;
                                if (oldValue !== newValue) {
                                    if ((0, _isNonVisualStyleMutationDefault.default)(mutation)) ignoreReason = 'non-visual-style';
                                    if ((0, _vcUtils.isContainedWithinMediaWrapper)(mutation.target)) ignoreReason = 'image';
                                    _this.observeElement(mutation.target, mutation, 'attr', ignoreReason, attributeName, oldValue, newValue);
                                }
                            }
                        }
                    });
                });
            }
        },
        {
            key: "getElementName",
            value: function getElementName(element) {
                try {
                    var tagName = element.localName;
                    var dataVCAttr = element.getAttribute('data-vc');
                    var dataVC = this.selectorConfig.dataVC && dataVCAttr ? '[data-vc="'.concat(dataVCAttr, '"]') : '';
                    var id = this.selectorConfig.id && element.id ? "#".concat(element.id) : '';
                    var testId = this.selectorConfig.testId ? element.getAttribute('data-testid') || element.getAttribute('data-test-id') : '';
                    testId = testId ? "[testid=".concat(testId, "]") : '';
                    var role = this.selectorConfig.role ? element.getAttribute('role') : '';
                    role = role ? "[role=".concat(role, "]") : '';
                    var classList = this.selectorConfig.className ? Array.from(element.classList).join('.') : '';
                    classList = classList === '' ? '' : ".".concat(classList);
                    var attrs = dataVC ? dataVC : [
                        id,
                        testId,
                        role
                    ].join('');
                    var idString = '';
                    if (attrs === '' && classList === '') {
                        var parent = element.parentElement ? this.getElementName(element.parentElement) : 'unknown';
                        idString = "".concat(parent, " > ").concat(tagName);
                    } else idString = [
                        tagName,
                        attrs || classList
                    ].join('');
                    return idString;
                } catch (e) {
                    return 'error';
                }
            }
        },
        {
            key: "getIntersectionObserver",
            value: function getIntersectionObserver() {
                var _this = this;
                if (!this.isBrowserSupported()) return null;
                return new IntersectionObserver(function(entries) {
                    _this.measureStart();
                    entries.forEach(function(param) {
                        var isIntersecting = param.isIntersecting, ir = param.intersectionRect, target = param.target;
                        var data = _this.observedMutations.get(target);
                        _this.observedMutations.delete(target);
                        if (isIntersecting && ir.width > 0 && ir.height > 0) {
                            if (!(0, _instanceof._)(target, HTMLElement)) return;
                            if (!(data === null || data === void 0 ? void 0 : data.mutation)) // ignore intersection report without recent mutation
                            return;
                            if (!isElementVisible(target)) data.ignoreReason = 'not-visible';
                            if ((0, _rllPlaceholders.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(ir)) data.ignoreReason = 'rll-placeholder';
                            _this.callbacks.forEach(function(callback) {
                                var elementName;
                                try {
                                    elementName = _this.getElementName(target);
                                } catch (e) {
                                    elementName = 'error';
                                }
                                callback(data.mutation.timestamp || performance.now(), ir, elementName, target, data.type, data.ignoreReason, data.attributeName, data.oldValue, data.newValue);
                            });
                            _this.elementsInView.add(target);
                        } else _this.elementsInView.delete(target);
                    });
                    _this.measureStop();
                });
            }
        },
        {
            key: "measureStart",
            value: function measureStart() {
                this._startMeasureTimestamp = performance.now();
            }
        },
        {
            key: "measureStop",
            value: function measureStop() {
                if (this._startMeasureTimestamp === -1) return;
                this.totalTime += performance.now() - this._startMeasureTimestamp;
                this._startMeasureTimestamp = -1;
            }
        }
    ]);
    return Observers;
}();

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_object_spread":"9gdrV","../../../config":"1BZI5","../media-wrapper/vc-utils":"1GvIy","./non-visual-styles/is-non-visual-style-mutation":"jffPE","./rll-placeholders":"a7mKq","./ssr-placeholders":"dvNDb","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1GvIy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isContainedWithinMediaWrapper", function() {
    return isContainedWithinMediaWrapper;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
var _index = require("./index");
function isContainedWithinMediaWrapper(node) {
    while(node){
        if ((0, _instanceof._)(node, Element) && node.hasAttribute((0, _index.MEDIA_WRAPPER_TAG))) return true;
        node = node.parentNode;
    }
    return false;
}

},{"@swc/helpers/_/_instanceof":"h9UKc","./index":"68R1l","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"68R1l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return 0, _mediaWrapperDefault.default;
});
parcelHelpers.export(exports, "MEDIA_WRAPPER_TAG", function() {
    return 0, _mediaWrapper.MEDIA_WRAPPER_TAG;
});
parcelHelpers.export(exports, "VcMediaWrapperProps", function() {
    return 0, _mediaWrapper.VcMediaWrapperProps;
});
var _mediaWrapper = require("./MediaWrapper");
var _mediaWrapperDefault = parcelHelpers.interopDefault(_mediaWrapper);

},{"./MediaWrapper":"g2itv","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"g2itv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MEDIA_WRAPPER_TAG", function() {
    return MEDIA_WRAPPER_TAG;
});
parcelHelpers.export(exports, "VcMediaWrapperProps", function() {
    return VcMediaWrapperProps;
});
parcelHelpers.export(exports, "default", function() {
    return MediaWrapper;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var MEDIA_WRAPPER_TAG = 'data-media-vc-wrapper';
var VcMediaWrapperProps = (0, _defineProperty._)({}, MEDIA_WRAPPER_TAG, true);
function MediaWrapper(param) {
    var children = param.children;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, VcMediaWrapperProps), {
        children: children
    }));
}

},{"@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jffPE":[function(require,module,exports,__globalThis) {
/**
 * Checks if a mutation record represents a non-visual style change
 * @param mutation - The mutation record to check
 * @returns boolean indicating if this is a non-visual style mutation
 *
 * A mutation is considered non-visual if:
 * - The target has data-	vc-nvs="true" attribute
 * - The changed attribute is either 'class' or 'style'
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _instanceof = require("@swc/helpers/_/_instanceof");
function isNonVisualStyleMutation(param) {
    var target = param.target, attributeName = param.attributeName;
    if (!(0, _instanceof._)(target, Element)) return false;
    if (attributeName !== 'class' && attributeName !== 'style') return false;
    if (target.getAttribute('data-vc-nvs') !== 'true') return false;
    return true;
}
exports.default = isNonVisualStyleMutation;

},{"@swc/helpers/_/_instanceof":"h9UKc","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"a7mKq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RLLPlaceholderHandlers", function() {
    return RLLPlaceholderHandlers;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var GLOBAL_RLL_HANDLERS_KEY = '__REACT_UFO_RLL_PLACEHOLDER_HANDLERS__';
var RLLPlaceholderHandlers = /*#__PURE__*/ function() {
    "use strict";
    function RLLPlaceholderHandlers() {
        (0, _classCallCheck._)(this, RLLPlaceholderHandlers);
        this.placeholders = [];
        if (typeof window !== 'undefined' && typeof document !== 'undefined' && typeof window.document !== 'undefined') this.collectRLLPlaceholders();
    }
    (0, _createClass._)(RLLPlaceholderHandlers, [
        {
            key: "reset",
            value: function reset() {
                this.placeholders = [];
            }
        },
        {
            key: "collectRLLPlaceholders",
            value: /**
   * Collects all React Loosely Lazy (RLL) placeholders from the DOM and caches their viewport intersecting rectangles.
   * RLL placeholders are marked with data-lazy-begin and data-lazy-end attributes on hidden input elements.
   * Performance optimized to batch getBoundingClientRect calls and minimize layout thrashing.
   * Only stores the intersecting portions of rectangles that are currently visible in the viewport.
   */ function collectRLLPlaceholders() {
                if (typeof window === 'undefined' || typeof document === 'undefined' || typeof window.document === 'undefined') return;
                var beginElements = document.querySelectorAll('input[data-lazy-begin]');
                var beginCount = beginElements.length;
                if (beginCount === 0) return;
                // Performance optimization: pre-allocate array with estimated size
                var allElements = [];
                // Performance optimization: use traditional for loop instead of forEach
                for(var i = 0; i < beginCount; i++){
                    var _allElements;
                    var beginEl = beginElements[i];
                    var id = beginEl.getAttribute('data-lazy-begin');
                    if (!id) continue;
                    var elements = this.refElements(beginEl, id);
                    if (elements.length > 0) (_allElements = allElements).push.apply(_allElements, (0, _toConsumableArray._)(elements));
                }
                // Second pass: batch all getBoundingClientRect calls to minimize reflow cycles
                var allElementsLength = allElements.length;
                if (allElementsLength > 0) {
                    // Performance optimization: pre-allocate array with exact size
                    var intersectingRects = [];
                    var windowWidth = window.innerWidth;
                    var windowHeight = window.innerHeight;
                    for(var i1 = 0; i1 < allElementsLength; i1++){
                        var rect = allElements[i1].getBoundingClientRect();
                        // Performance optimization: inline intersection calculation to avoid function call overhead
                        var left = Math.max(rect.left, 0);
                        var top = Math.max(rect.top, 0);
                        var right = Math.min(rect.right, windowWidth);
                        var bottom = Math.min(rect.bottom, windowHeight);
                        // Check if there's a valid intersection with non-zero width and height
                        if (left < right && top < bottom) intersectingRects.push(new DOMRect(left, top, right - left, bottom - top));
                    }
                    this.placeholders = intersectingRects;
                }
            }
        },
        {
            key: "refElements",
            value: /**
   * Traverses DOM siblings to find all elements between RLL begin and end markers.
   * Based on the refElements pattern from react-loosely-lazy's platform/packages/async/react-loosely-lazy/src/collect/hydrate.ts
   * Performance optimized to minimize iterations and early exit conditions.
   *
   * @param fromEl - The input element with data-lazy-begin attribute
   * @param id - The placeholder ID to match against data-lazy-end
   * @returns Array of DOM elements between the begin/end markers
   */ function refElements(fromEl, id) {
                var result = [];
                var el = fromEl.nextSibling;
                // Performance optimization: use while loop instead of recursive calls
                while(el){
                    var _el_dataset;
                    if (((_el_dataset = el.dataset) === null || _el_dataset === void 0 ? void 0 : _el_dataset.lazyEnd) === id) break;
                    if (el.nodeType === Node.ELEMENT_NODE) result.push(el);
                    el = el.nextSibling;
                }
                return result;
            }
        },
        {
            key: "getPlaceholders",
            value: /**
   * Returns the cached intersecting viewport rectangles for all RLL placeholder elements.
   * @returns Array of DOMRect objects representing the intersecting portions of placeholders within the viewport
   */ function getPlaceholders() {
                return this.placeholders;
            }
        },
        {
            key: "isRLLPlaceholderHydration",
            value: /**
   * Checks if the given intersecting rectangle matches any of the cached RLL placeholder intersecting rectangles.
   * This is designed to be called from IntersectionObserver with the intersectionRect.
   * Performance optimized with early exits and minimal calculations.
   * @param intersectingRect - The intersecting rectangle from IntersectionObserver
   * @returns true if the intersecting rectangle matches a cached placeholder rectangle and hasn't exceeded match limit, false otherwise
   */ function isRLLPlaceholderHydration(intersectingRect) {
                var placeholdersLength = this.placeholders.length;
                if (placeholdersLength === 0) return false;
                // Performance optimization: cache array length and use traditional for loop
                for(var i = 0; i < placeholdersLength; i++){
                    var placeholderRect = this.placeholders[i];
                    if (this.areRectsEqual(intersectingRect, placeholderRect)) return true;
                }
                return false;
            }
        },
        {
            key: "areRectsEqual",
            value: /**
   * Compares two DOMRect objects for equality with ±1 pixel tolerance.
   * Performance optimized to minimize calculations and early exit on major differences.
   * @param rect1 - First rectangle to compare
   * @param rect2 - Second rectangle to compare
   * @returns true if rectangles are within 1 pixel tolerance for all properties
   */ function areRectsEqual(rect1, rect2) {
                // Early exit for exact matches (most common case)
                if (rect1.left === rect2.left && rect1.top === rect2.top && rect1.right === rect2.right && rect1.bottom === rect2.bottom) return true;
                // Performance optimization: check largest differences first for early exit
                var leftDiff = rect1.left - rect2.left;
                if (leftDiff > 1 || leftDiff < -1) return false;
                var rightDiff = rect1.right - rect2.right;
                if (rightDiff > 1 || rightDiff < -1) return false;
                var topDiff = rect1.top - rect2.top;
                if (topDiff > 1 || topDiff < -1) return false;
                var bottomDiff = rect1.bottom - rect2.bottom;
                if (bottomDiff > 1 || bottomDiff < -1) return false;
                return true;
            }
        }
    ], [
        {
            key: "getInstance",
            value: /**
   * Gets the global singleton instance of RLLPlaceholderHandlers.
   * Creates the instance if it doesn't exist and stores it in globalThis.
   * @returns The singleton instance of RLLPlaceholderHandlers
   */ function getInstance() {
                if (typeof globalThis !== 'undefined') {
                    if (!globalThis[GLOBAL_RLL_HANDLERS_KEY]) globalThis[GLOBAL_RLL_HANDLERS_KEY] = new RLLPlaceholderHandlers();
                    return globalThis[GLOBAL_RLL_HANDLERS_KEY];
                }
                // Fallback for environments without globalThis (should be rare)
                return new RLLPlaceholderHandlers();
            }
        }
    ]);
    return RLLPlaceholderHandlers;
}();

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_to_consumable_array":"1eSZf","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dvNDb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SSRPlaceholderHandlers", function() {
    return SSRPlaceholderHandlers;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _instanceof = require("@swc/helpers/_/_instanceof");
var ANCESTOR_LOOKUP_LIMIT = 10;
var PAGE_LAYOUT_ID = 'page-layout.root';
var SSRPlaceholderHandlers = /*#__PURE__*/ function() {
    "use strict";
    function SSRPlaceholderHandlers(param) {
        var _this = this;
        var _param_enablePageLayoutPlaceholder = param.enablePageLayoutPlaceholder, enablePageLayoutPlaceholder = _param_enablePageLayoutPlaceholder === void 0 ? false : _param_enablePageLayoutPlaceholder;
        (0, _classCallCheck._)(this, SSRPlaceholderHandlers);
        this.staticPlaceholders = new Map();
        this.callbacks = new Map();
        this.getSizeCallbacks = new Map();
        this.reactValidateCallbacks = new Map();
        this.EQUALITY_THRESHOLD = 1;
        this.getPlaceholderId = function(el) {
            var _el_dataset;
            var ssrPlaceholderId = el === null || el === void 0 ? void 0 : (_el_dataset = el.dataset) === null || _el_dataset === void 0 ? void 0 : _el_dataset.ssrPlaceholder;
            if (!!ssrPlaceholderId) return ssrPlaceholderId;
            if (_this.enablePageLayoutPlaceholder && (el === null || el === void 0 ? void 0 : el.dataset.testid) === PAGE_LAYOUT_ID) return PAGE_LAYOUT_ID;
            return '';
        };
        this.getPlaceholderReplacementId = function(el) {
            var _el_dataset;
            var ssrPlaceholderReplaceId = el === null || el === void 0 ? void 0 : (_el_dataset = el.dataset) === null || _el_dataset === void 0 ? void 0 : _el_dataset.ssrPlaceholderReplace;
            if (!!ssrPlaceholderReplaceId) return ssrPlaceholderReplaceId;
            if (_this.enablePageLayoutPlaceholder && (el === null || el === void 0 ? void 0 : el.dataset.testid) === PAGE_LAYOUT_ID) return PAGE_LAYOUT_ID;
            return '';
        };
        this.intersectionObserverCallback = function(param) {
            var target = param.target, boundingClientRect = param.boundingClientRect;
            var _this_intersectionObserver;
            (_this_intersectionObserver = _this.intersectionObserver) === null || _this_intersectionObserver === void 0 ? void 0 : _this_intersectionObserver.unobserve(target);
            if (!(0, _instanceof._)(target, HTMLElement)) // impossible case - keep typescript healthy
            return;
            var staticKey = _this.getPlaceholderId(target);
            if (staticKey) {
                if (_this.staticPlaceholders.has(staticKey) && _this.callbacks.has(staticKey)) {
                    // validation
                    var resolve = _this.callbacks.get(staticKey);
                    if (!resolve) return;
                    var rect = _this.staticPlaceholders.get(staticKey);
                    var hasSameSizePosition = _this.hasSameSizePosition(rect, boundingClientRect);
                    if (hasSameSizePosition || _this.isDummyRect(rect)) resolve(hasSameSizePosition);
                    else requestAnimationFrame(function() {
                        var targetRect = _this.getEffectiveBoundingRect(target);
                        var hasSameSizePosition = _this.hasSameSizePosition(rect, targetRect);
                        resolve(hasSameSizePosition);
                    });
                    _this.callbacks.delete(staticKey);
                }
            } else {
                var key = _this.getPlaceholderReplacementId(target);
                var resolve1 = _this.reactValidateCallbacks.get(key);
                if (!resolve1) return;
                var rect1 = _this.staticPlaceholders.get(key);
                var hasSameSizePosition1 = _this.hasSameSizePosition(rect1, boundingClientRect);
                if (hasSameSizePosition1 || _this.isDummyRect(rect1)) resolve1(hasSameSizePosition1);
                else requestAnimationFrame(function() {
                    var targetRect = _this.getEffectiveBoundingRect(target);
                    var hasSameSizePosition = _this.hasSameSizePosition(rect1, targetRect);
                    resolve1(hasSameSizePosition);
                });
                _this.staticPlaceholders.delete(staticKey);
                _this.reactValidateCallbacks.delete(staticKey);
            }
        };
        if (typeof IntersectionObserver === 'function') // Only instantiate the IntersectionObserver if it's supported
        this.intersectionObserver = new IntersectionObserver(function(entries) {
            return entries.filter(function(entry) {
                return entry.intersectionRatio > 0;
            }).forEach(_this.intersectionObserverCallback);
        });
        this.enablePageLayoutPlaceholder = enablePageLayoutPlaceholder;
        if (window.document) try {
            // Collect initial placeholders using SSR dimensions
            this.collectPlaceholdersInternal();
        } catch (e) {} finally{
            delete window.__SSR_PLACEHOLDERS_DIMENSIONS__;
        }
    }
    (0, _createClass._)(SSRPlaceholderHandlers, [
        {
            key: "clear",
            value: function clear() {
                this.staticPlaceholders = new Map();
                this.callbacks = new Map();
                this.getSizeCallbacks = new Map();
                this.reactValidateCallbacks = new Map();
            }
        },
        {
            key: "collectPlaceholdersInternal",
            value: function collectPlaceholdersInternal() {
                var _this = this;
                var selector = this.enablePageLayoutPlaceholder ? '[data-ssr-placeholder],[data-testid="page-layout.root"]' : '[data-ssr-placeholder]';
                var existingElements = document.querySelectorAll(selector);
                existingElements.forEach(function(el) {
                    var placeholderId = (0, _instanceof._)(el, HTMLElement) && _this.getPlaceholderId(el);
                    if (placeholderId && !_this.staticPlaceholders.has(placeholderId)) {
                        var _window___SSR_PLACEHOLDERS_DIMENSIONS__, _this_intersectionObserver;
                        var width = -1;
                        var height = -1;
                        var x = -1;
                        var y = -1;
                        // Use SSR dimensions from window global if available
                        var boundingClientRect = (_window___SSR_PLACEHOLDERS_DIMENSIONS__ = window.__SSR_PLACEHOLDERS_DIMENSIONS__) === null || _window___SSR_PLACEHOLDERS_DIMENSIONS__ === void 0 ? void 0 : _window___SSR_PLACEHOLDERS_DIMENSIONS__[placeholderId];
                        if (boundingClientRect) {
                            width = boundingClientRect.width;
                            height = boundingClientRect.height;
                            x = boundingClientRect.x;
                            y = boundingClientRect.y;
                        } else {
                            // Fallback to current bounding rect if SSR dimensions not available
                            var rect = el.getBoundingClientRect();
                            width = rect.width;
                            height = rect.height;
                            x = rect.x;
                            y = rect.y;
                        }
                        _this.staticPlaceholders.set(placeholderId, {
                            width: width,
                            height: height,
                            x: x,
                            y: y
                        });
                        (_this_intersectionObserver = _this.intersectionObserver) === null || _this_intersectionObserver === void 0 ? void 0 : _this_intersectionObserver.observe(el);
                    }
                });
            }
        },
        {
            /**
	 * Added this method to be utilised for testing purposes.
	 * In production it collection placeholder should only happens on constructor
	 */ key: "collectExistingPlaceholders",
            value: function collectExistingPlaceholders() {
                if (!window.document) return;
                try {
                    // Collect placeholders using SSR dimensions or fallback to live dimensions
                    this.collectPlaceholdersInternal();
                } catch (e) {
                // Silently fail if there are any issues
                } finally{
                    delete window.__SSR_PLACEHOLDERS_DIMENSIONS__;
                }
            }
        },
        {
            key: "isPlaceholder",
            value: function isPlaceholder(element) {
                return Boolean(this.getPlaceholderId(element));
            }
        },
        {
            key: "isPlaceholderReplacement",
            value: function isPlaceholderReplacement(element) {
                return Boolean(this.getPlaceholderReplacementId(element));
            }
        },
        {
            key: "isPlaceholderIgnored",
            value: function isPlaceholderIgnored(element) {
                // data-ssr-placeholder-ignored doesn't have a value.
                return 'ssrPlaceholderIgnored' in element.dataset;
            }
        },
        {
            key: "isPlaceholderV4",
            value: function isPlaceholderV4(element) {
                var currentElement = element;
                var i = 0;
                while(currentElement && i < ANCESTOR_LOOKUP_LIMIT){
                    if (Boolean(this.getPlaceholderId(currentElement))) return true;
                    currentElement = currentElement.parentElement;
                    i++;
                }
                return false;
            }
        },
        {
            key: "isPlaceholderReplacementV4",
            value: function isPlaceholderReplacementV4(element) {
                var currentElement = element;
                var i = 0;
                while(currentElement && i < ANCESTOR_LOOKUP_LIMIT){
                    if (Boolean(this.getPlaceholderReplacementId(currentElement))) return true;
                    currentElement = currentElement.parentElement;
                    i++;
                }
                return false;
            }
        },
        {
            key: "findNearestPlaceholderContainerIfIgnored",
            value: function findNearestPlaceholderContainerIfIgnored(element) {
                if (!this.isPlaceholderIgnored(element)) return element;
                var ancestor = element.parentElement;
                var i = 0;
                while(ancestor && i < ANCESTOR_LOOKUP_LIMIT){
                    if (this.isPlaceholder(ancestor) || this.isPlaceholderReplacement(ancestor)) return ancestor;
                    ancestor = ancestor.parentElement;
                    i++;
                }
                return element;
            }
        },
        {
            key: "findNearestPlaceholderOrContainer",
            value: function findNearestPlaceholderOrContainer(element) {
                var limit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ANCESTOR_LOOKUP_LIMIT;
                var ancestor = element;
                if (this.isPlaceholderIgnored(element) && element.parentElement) ancestor = element.parentElement;
                var i = 0;
                while(ancestor && i < limit){
                    if (this.isPlaceholder(ancestor) || this.isPlaceholderReplacement(ancestor)) return ancestor;
                    if (ancestor.parentElement) {
                        ancestor = ancestor.parentElement;
                        i++;
                    } else break;
                }
                return element;
            }
        },
        {
            // Validates placeholder match using asynchronous observation and resolves with the result
            key: "checkIfExistedAndSizeMatching",
            value: function checkIfExistedAndSizeMatching(el) {
                var _this = this;
                el = this.findNearestPlaceholderContainerIfIgnored(el);
                var id = this.getPlaceholderId(el);
                return new Promise(function(resolve) {
                    if (!_this.staticPlaceholders.has(id)) {
                        resolve(false);
                        return;
                    } else {
                        var _this_intersectionObserver;
                        _this.callbacks.set(id, resolve);
                        (_this_intersectionObserver = _this.intersectionObserver) === null || _this_intersectionObserver === void 0 ? void 0 : _this_intersectionObserver.observe(el);
                    }
                });
            }
        },
        {
            // Validates placeholder match synchronously using stored SSR dimensions and current bounds
            key: "checkIfExistedAndSizeMatchingV3",
            value: function checkIfExistedAndSizeMatchingV3(el) {
                el = this.findNearestPlaceholderContainerIfIgnored(el);
                var id = this.getPlaceholderId(el);
                var placeholderRects = this.staticPlaceholders.get(id);
                if (!placeholderRects) return false;
                return this.hasSameSizePosition(placeholderRects, this.getEffectiveBoundingRect(el));
            }
        },
        {
            key: "getSize",
            value: function getSize(el) {
                var _this = this;
                return new Promise(function(resolve) {
                    var _this_intersectionObserver;
                    _this.getSizeCallbacks.set(_this.getPlaceholderId(el), resolve);
                    (_this_intersectionObserver = _this.intersectionObserver) === null || _this_intersectionObserver === void 0 ? void 0 : _this_intersectionObserver.observe(el);
                });
            }
        },
        {
            key: "validateReactComponentMatchToPlaceholder",
            value: function validateReactComponentMatchToPlaceholder(el) {
                var _this = this;
                el = this.findNearestPlaceholderContainerIfIgnored(el);
                var id = this.getPlaceholderReplacementId(el);
                return new Promise(function(resolve) {
                    if (!_this.staticPlaceholders.has(id)) {
                        resolve(false);
                        return;
                    } else {
                        var _this_intersectionObserver;
                        _this.reactValidateCallbacks.set(id, resolve);
                        (_this_intersectionObserver = _this.intersectionObserver) === null || _this_intersectionObserver === void 0 ? void 0 : _this_intersectionObserver.observe(el);
                    }
                });
            }
        },
        {
            key: "validateReactComponentMatchToPlaceholderV4",
            value: function validateReactComponentMatchToPlaceholderV4(el) {
                el = this.findNearestPlaceholderOrContainer(el, 2); // We are using 2 due to over-eagerness of the default, only check itself and 1 ancestor
                var id = this.getPlaceholderReplacementId(el);
                return this.staticPlaceholders.has(id);
            }
        },
        {
            key: "hasSameSizePosition",
            value: function hasSameSizePosition(rect, boundingClientRect) {
                if (!rect) return false;
                var horizontalCheck = Math.abs(rect.x - boundingClientRect.x) < this.EQUALITY_THRESHOLD && Math.abs(rect.width - boundingClientRect.width) < this.EQUALITY_THRESHOLD;
                var verticalCheck = Math.abs(rect.y - boundingClientRect.y) < this.EQUALITY_THRESHOLD && Math.abs(rect.height - boundingClientRect.height) < this.EQUALITY_THRESHOLD;
                return horizontalCheck && verticalCheck || false;
            }
        },
        {
            key: "getEffectiveBoundingRect",
            value: /**
	 * Gets the effective bounding rectangle for an element, handling display: contents elements
	 * by collecting dimensions from their children instead
	 */ function getEffectiveBoundingRect(el) {
                var computedStyle = window.getComputedStyle(el);
                // If element has display: contents, collect bounding rect from children
                if (computedStyle.display === 'contents') {
                    var children = Array.from(el.children);
                    if (children.length === 0) // No children, return zero rect
                    return new DOMRect(0, 0, 0, 0);
                    // Calculate union of all children's bounding rects
                    var minX = Infinity;
                    var minY = Infinity;
                    var maxX = -Infinity;
                    var maxY = -Infinity;
                    children.forEach(function(child) {
                        var childRect = child.getBoundingClientRect();
                        // Skip children with zero dimensions (likely also display: contents)
                        if (childRect.width > 0 || childRect.height > 0) {
                            minX = Math.min(minX, childRect.left);
                            minY = Math.min(minY, childRect.top);
                            maxX = Math.max(maxX, childRect.right);
                            maxY = Math.max(maxY, childRect.bottom);
                        }
                    });
                    // If no children with dimensions found, return zero rect
                    if (minX === Infinity) return new DOMRect(0, 0, 0, 0);
                    return new DOMRect(minX, minY, maxX - minX, maxY - minY);
                }
                // Normal element, return its bounding rect
                return el.getBoundingClientRect();
            }
        },
        {
            key: "isDummyRect",
            value: function isDummyRect(rect) {
                return rect && rect.width < 0 && rect.height < 0 || false;
            }
        }
    ]);
    return SSRPlaceholderHandlers;
}();

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_instanceof":"h9UKc","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hcmdv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sinkExtraSearchPageInteractionHandler", function() {
    return sinkExtraSearchPageInteractionHandler;
});
parcelHelpers.export(exports, "onSearchPageInteractionComplete", function() {
    return onSearchPageInteractionComplete;
});
var interactionBuffer = [];
var bufferInteractionData = function(interactionId, data) {
    interactionBuffer.push({
        interactionId: interactionId,
        data: data
    });
};
function clearInteractionBuffer() {
    interactionBuffer.length = 0;
}
function appendInteractionData(interactionId, data) {
    bufferInteractionData(interactionId, data);
}
function installInteractionSink(handler) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = interactionBuffer[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = _step.value, interactionId = _step_value.interactionId, data = _step_value.data;
            handler(interactionId, data);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    clearInteractionBuffer();
    bufferInteractionData = handler;
}
function sinkExtraSearchPageInteractionHandler(sinkFn) {
    installInteractionSink(sinkFn);
}
function onSearchPageInteractionComplete(interactionId, data) {
    if (data.ufoName) {
        appendInteractionData(interactionId, data);
        clearInteractionBuffer();
    }
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"li4VQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sanitizeUfoName", function() {
    return sanitizeUfoName;
});
parcelHelpers.export(exports, "isSegmentLabel", function() {
    return isSegmentLabel;
});
parcelHelpers.export(exports, "buildSegmentTree", function() {
    return buildSegmentTree;
});
parcelHelpers.export(exports, "stringifyLabelStackFully", function() {
    return stringifyLabelStackFully;
});
parcelHelpers.export(exports, "stringifyLabelStackWithoutId", function() {
    return stringifyLabelStackWithoutId;
});
parcelHelpers.export(exports, "labelStackStartWith", function() {
    return labelStackStartWith;
});
parcelHelpers.export(exports, "optimizeLabelStack", function() {
    return optimizeLabelStack;
});
/**
 * Optimizes a labelStack with registry-based deduplication.
 * When a registry is provided and the version is '2.0.0', the labelStack string
 * is registered in the lookup table and a numeric index is returned instead of the full string.
 * Falls back to regular optimizeLabelStack when no registry is provided.
 */ parcelHelpers.export(exports, "optimizeLabelStackWithRegistry", function() {
    return optimizeLabelStackWithRegistry;
});
parcelHelpers.export(exports, "getOldSegmentsLabelStack", function() {
    return getOldSegmentsLabelStack;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _config = require("../../../config");
function sanitizeUfoName(name) {
    return name.replace(/_/g, '-');
}
function isSegmentLabel(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}
function buildSegmentTree(labelStacks) {
    var r = {
        n: 'segment-tree-root',
        c: {}
    };
    var config = (0, _config.getConfig)();
    var segmentThreshold = config === null || config === void 0 ? void 0 : config.segmentsThreshold;
    var addSegmentsMap = new Map();
    labelStacks.forEach(function(labelStack) {
        var stringifiedLabelStack = stringifyLabelStackWithoutId(labelStack);
        var currentNode = r;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = labelStack[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var label = _step.value;
                var isSegment = isSegmentLabel(label);
                var name = label.name;
                if (isSegment && segmentThreshold && segmentThreshold[name]) {
                    var threshold = segmentThreshold[name];
                    var count = addSegmentsMap.get(stringifiedLabelStack) || 0;
                    if (count < threshold) addSegmentsMap.set(stringifiedLabelStack, count + 1);
                    else break;
                }
                var id = isSegment ? label.segmentId : undefined;
                var key = id !== undefined ? id : name;
                var type = isSegment ? label.type : undefined;
                if (!currentNode.c) currentNode.c = {};
                if (!currentNode.c[key]) currentNode.c[key] = (0, _objectSpread._)({
                    n: name
                }, type ? {
                    t: type
                } : {});
                currentNode = currentNode.c[key];
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    return {
        r: r
    };
}
function stringifyLabelStackFully(labelStack) {
    return labelStack.map(function(l) {
        if (isSegmentLabel(l)) return "".concat(l.name, ":").concat(l.segmentId);
        return l.name;
    }).join('/');
}
function stringifyLabelStackWithoutId(labelStack) {
    return labelStack.map(function(l) {
        if (isSegmentLabel(l)) return "".concat(l.name, ":segment");
        return l.name;
    }).join('/');
}
function getLabelStackReference(labelStack) {
    return labelStack.map(function(l) {
        return isSegmentLabel(l) ? l.segmentId : l.name;
    }).join('/');
}
function labelStackStartWith(labelStack, startWith) {
    return stringifyLabelStackFully(labelStack).startsWith(stringifyLabelStackFully(startWith));
}
function optimizeLabelStack(labelStack, reactUFOVersion) {
    return reactUFOVersion === '2.0.0' ? getLabelStackReference(labelStack) : labelStack.map(function(ls) {
        return (0, _objectSpread._)({
            n: ls.name
        }, ls.segmentId ? {
            s: ls.segmentId
        } : {}, ls.type ? {
            t: ls.type
        } : {});
    });
}
function optimizeLabelStackWithRegistry(labelStack, reactUFOVersion, registry) {
    if (registry && reactUFOVersion === '2.0.0') {
        var ref = getLabelStackReference(labelStack);
        return registry.register(ref);
    }
    return optimizeLabelStack(labelStack, reactUFOVersion);
}
function getOldSegmentsLabelStack(segments, _interactionType) {
    var config = (0, _config.getConfig)();
    var addSegmentsMap = new Map();
    var segmentThreshold = config === null || config === void 0 ? void 0 : config.segmentsThreshold;
    return segments.map(function(_param) {
        var labelStack = _param.labelStack, others = (0, _objectWithoutProperties._)(_param, [
            "labelStack"
        ]);
        var stringifiedLabelStack = stringifyLabelStackWithoutId(labelStack);
        var segmentsInfo = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = labelStack[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var ls = _step.value;
                var isSegment = isSegmentLabel(ls);
                if (isSegment && segmentThreshold && segmentThreshold[ls.name]) {
                    var threshold = segmentThreshold[ls.name];
                    var count = addSegmentsMap.get(stringifiedLabelStack) || 0;
                    if (count < threshold) addSegmentsMap.set(stringifiedLabelStack, count + 1);
                    else break;
                }
                segmentsInfo.push((0, _objectSpread._)({
                    n: ls.name
                }, ls.segmentId ? {
                    s: ls.segmentId
                } : {}, ls.type ? {
                    t: ls.type
                } : {}));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, others), {
            labelStack: segmentsInfo
        });
    });
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","../../../config":"1BZI5","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kHUgA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "redactValue", function() {
    return 0, _utils.redactValue;
});
parcelHelpers.export(exports, "allFeatureFlagsAccessed", function() {
    return allFeatureFlagsAccessed;
});
parcelHelpers.export(exports, "currentFeatureFlagsAccessed", function() {
    return currentFeatureFlagsAccessed;
});
/**
 * Used for tracking accessed feature flags in "@atlassian/jira-feature-flagging".
 * */ parcelHelpers.export(exports, "addFeatureFlagAccessed", function() {
    return addFeatureFlagAccessed;
});
var _utils = require("./common/utils");
var allFeatureFlagsAccessed = new Map();
var currentFeatureFlagsAccessed = new Map();
function addFeatureFlagAccessed(featureFlagName, featureFlagValue) {
    try {
        // Inform Criterion about FF being accessed
        if (globalThis.__CRITERION__ && typeof globalThis.__CRITERION__.addFeatureFlagAccessed === 'function') globalThis.__CRITERION__.addFeatureFlagAccessed(featureFlagName, featureFlagValue);
    } catch (_e) {
    // ignore the criterion error
    }
    var value = (0, _utils.redactValue)(featureFlagValue);
    allFeatureFlagsAccessed.set(featureFlagName, value);
    currentFeatureFlagsAccessed.set(featureFlagName, value);
}

},{"./common/utils":"3skie","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3skie":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shouldRedactValue", function() {
    return shouldRedactValue;
});
parcelHelpers.export(exports, "redactValue", function() {
    return redactValue;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
var _typeOf = require("@swc/helpers/_/_type_of");
var _constants = require("../constants");
function startsAsObject(value) {
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
}
function isObject(value) {
    return value && (typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) === 'object' && value.constructor === Object;
}
function isString(input) {
    var result;
    try {
        result = typeof input === 'string' || (0, _instanceof._)(input, String);
    } catch (e) {
        // swallow any errors
        result = false;
    }
    return result;
}
function shouldRedactValue(value) {
    return isString(value) && startsAsObject(value) || isObject(value);
}
function redactValue(featureFlagValue) {
    return shouldRedactValue(featureFlagValue) ? (0, _constants.NON_BOOLEAN_VALUE) : featureFlagValue;
}

},{"@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_type_of":"iFJdx","../constants":"k8siT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"k8siT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NON_BOOLEAN_VALUE", function() {
    return NON_BOOLEAN_VALUE;
});
var NON_BOOLEAN_VALUE = 'non_boolean';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1naJ6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clearState", function() {
    return clearState;
});
parcelHelpers.export(exports, "flushSsrRenderProfilerTraces", function() {
    return flushSsrRenderProfilerTraces;
});
parcelHelpers.export(exports, "SsrRenderProfilerInner", function() {
    return SsrRenderProfilerInner;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _config = require("../config");
var _interactionMetrics = require("../interaction-metrics");
var _process_env;
var process = require("cb8f24e5ab481a45");
// These are stored outside react context to be resilient to concurrent mode
// restarting the start marker from a suspense and losing the initial render
var startTimes = new Map();
var spanStates = new Map();
var clearState = function() {
    startTimes.clear();
    spanStates.clear();
};
// Keep track of the last interaction id and reset the start timers if it ever changes.
// This is to allow multi-step ssr to track the render timers from different "interaction"s seperately
var lastActiveInteraction;
function checkActiveInteractionAndResetStartMarksIfSet() {
    var _getActiveInteraction;
    var activeInteractionId = (_getActiveInteraction = (0, _interactionMetrics.getActiveInteraction)()) === null || _getActiveInteraction === void 0 ? void 0 : _getActiveInteraction.id;
    if (!!lastActiveInteraction && lastActiveInteraction !== activeInteractionId) clearState();
    lastActiveInteraction = activeInteractionId;
}
var getIsNativeTracingEnabled = function() {
    var _getConfig_ssr, _getConfig;
    var _getConfig_ssr_enableNativeTracing;
    return (_getConfig_ssr_enableNativeTracing = (_getConfig = (0, _config.getConfig)()) === null || _getConfig === void 0 ? void 0 : (_getConfig_ssr = _getConfig.ssr) === null || _getConfig_ssr === void 0 ? void 0 : _getConfig_ssr.enableNativeTracing) !== null && _getConfig_ssr_enableNativeTracing !== void 0 ? _getConfig_ssr_enableNativeTracing : false;
};
var onStartRender = function(id, currentSegmentName, parentContext) {
    var _startTimes_get, _globalThis___vm_internals___telemetry, _globalThis___vm_internals__;
    if (!startTimes.has(id)) startTimes.set(id, []);
    (_startTimes_get = startTimes.get(id)) === null || _startTimes_get === void 0 ? void 0 : _startTimes_get.push(performance.now());
    if (!getIsNativeTracingEnabled()) return null;
    var startSpan = (_globalThis___vm_internals__ = globalThis.__vm_internals__) === null || _globalThis___vm_internals__ === void 0 ? void 0 : (_globalThis___vm_internals___telemetry = _globalThis___vm_internals__.telemetry) === null || _globalThis___vm_internals___telemetry === void 0 ? void 0 : _globalThis___vm_internals___telemetry.startSpan;
    var _spanStates_get;
    var spanState = (_spanStates_get = spanStates.get(id)) !== null && _spanStates_get !== void 0 ? _spanStates_get : null;
    if (!spanState && startSpan) {
        var span = startSpan(currentSegmentName, {
            parentSpanId: parentContext === null || parentContext === void 0 ? void 0 : parentContext.spanId
        });
        spanState = {
            span: span
        };
        spanStates.set(id, spanState);
    }
    return spanState;
};
var isInSSR = typeof __SERVER__ !== 'undefined' && __SERVER__ || typeof process !== 'undefined' && Boolean((process === null || process === void 0 ? void 0 : (_process_env = process.env) === null || _process_env === void 0 ? void 0 : _process_env.REACT_SSR) || false);
var ProfilerMarker = function(param) {
    var onRender = param.onRender;
    onRender === null || onRender === void 0 ? void 0 : onRender();
    return null;
};
var ParentSpanContext = /*#__PURE__*/ (0, _react.createContext)(null);
var flushSsrRenderProfilerTraces = function() {
    spanStates.forEach(function(spanState) {
        if (spanState.latestEndTime != null) spanState.span.end(spanState.latestEndTime);
    });
    spanStates.clear();
};
var SsrRenderProfilerInner = function(param) {
    var children = param.children, labelStack = param.labelStack, onRender = param.onRender;
    var reactProfilerId = (0, _react.useMemo)(function() {
        return labelStack.map(function(l) {
            return l.name;
        }).join('/');
    }, [
        labelStack
    ]);
    checkActiveInteractionAndResetStartMarksIfSet();
    var parentSpan = (0, _react.useContext)(ParentSpanContext);
    var currentSpanState = onStartRender(reactProfilerId, labelStack[labelStack.length - 1].name, parentSpan);
    var _currentSpanState_span_getSpanContext;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ParentSpanContext.Provider, {
            value: (_currentSpanState_span_getSpanContext = currentSpanState === null || currentSpanState === void 0 ? void 0 : currentSpanState.span.getSpanContext()) !== null && _currentSpanState_span_getSpanContext !== void 0 ? _currentSpanState_span_getSpanContext : null,
            children: [
                children,
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(ProfilerMarker, {
                    onRender: function() {
                        var startTimesForId = startTimes.get(reactProfilerId);
                        if (startTimesForId === null || startTimesForId === void 0 ? void 0 : startTimesForId.length) {
                            var endTime = performance.now();
                            var firstStartTime = startTimesForId[0];
                            var lastStartTime = startTimesForId[startTimesForId.length - 1];
                            var baseDuration = endTime - lastStartTime;
                            var actualDuration = endTime - firstStartTime;
                            onRender('mount', actualDuration, baseDuration, firstStartTime, endTime);
                        }
                        var spanState = spanStates.get(reactProfilerId);
                        if (spanState) spanState.latestEndTime = performance.now();
                    }
                })
            ]
        })
    });
};
var SsrRenderProfiler = function(props) {
    if (isInSSR) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SsrRenderProfilerInner, (0, _objectSpread._)({}, props));
    // ensure structure similar to SSR implementation
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ProfilerMarker, {}),
            props.children
        ]
    });
};
exports.default = SsrRenderProfiler;

},{"@swc/helpers/_/_object_spread":"9gdrV","cb8f24e5ab481a45":"gNLf3","react/jsx-runtime":"bGvcw","react":"ltHCL","../config":"1BZI5","../interaction-metrics":"diQdd","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3cXH4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VCObserverWrapper", function() {
    return VCObserverWrapper;
});
parcelHelpers.export(exports, "isEnvironmentSupported", function() {
    return isEnvironmentSupported;
});
parcelHelpers.export(exports, "getVCObserver", function() {
    return getVCObserver;
});
parcelHelpers.export(exports, "newVCObserver", function() {
    return newVCObserver;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _config = require("../config");
var _noOpVcObserver = require("./no-op-vc-observer");
var _vcObserver = require("./vc-observer");
var _vcObserverNew = require("./vc-observer-new");
var _vcObserverNewDefault = parcelHelpers.interopDefault(_vcObserverNew);
var _rllPlaceholders = require("./vc-observer/observers/rll-placeholders");
var _ssrPlaceholders = require("./vc-observer/observers/ssr-placeholders");
var _globalThis, _process_env;
var process = require("53bb1a9c72cfc523");
var VCObserverWrapper = /*#__PURE__*/ function() {
    "use strict";
    function VCObserverWrapper() {
        var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, _classCallCheck._)(this, VCObserverWrapper);
        this.newVCObserver = null;
        this.oldVCObserver = null;
        var _opts_ssrEnablePageLayoutPlaceholder;
        // Initialize SSR placeholder handler once
        this.ssrPlaceholderHandler = new (0, _ssrPlaceholders.SSRPlaceholderHandlers)({
            enablePageLayoutPlaceholder: (_opts_ssrEnablePageLayoutPlaceholder = opts.ssrEnablePageLayoutPlaceholder) !== null && _opts_ssrEnablePageLayoutPlaceholder !== void 0 ? _opts_ssrEnablePageLayoutPlaceholder : false
        });
        var _opts_ssrEnablePageLayoutPlaceholder1, _opts_trackLayoutShiftOffenders;
        if (VCObserverWrapper.shouldUseNewVCObserver()) this.newVCObserver = new (0, _vcObserverNewDefault.default)({
            selectorConfig: opts.selectorConfig,
            isPostInteraction: opts.isPostInteraction,
            SSRConfig: {
                enablePageLayoutPlaceholder: (_opts_ssrEnablePageLayoutPlaceholder1 = opts.ssrEnablePageLayoutPlaceholder) !== null && _opts_ssrEnablePageLayoutPlaceholder1 !== void 0 ? _opts_ssrEnablePageLayoutPlaceholder1 : false
            },
            ssrPlaceholderHandler: this.ssrPlaceholderHandler,
            trackLayoutShiftOffenders: (_opts_trackLayoutShiftOffenders = opts.trackLayoutShiftOffenders) !== null && _opts_trackLayoutShiftOffenders !== void 0 ? _opts_trackLayoutShiftOffenders : false,
            searchPageConfig: opts.searchPageConfig
        });
        if ((0, _config.isVCRevisionEnabled)('fy25.01') || (0, _config.isVCRevisionEnabled)('fy25.02')) this.oldVCObserver = new (0, _vcObserver.VCObserver)((0, _objectSpreadProps._)((0, _objectSpread._)({}, opts), {
            ssrPlaceholderHandler: this.ssrPlaceholderHandler
        }));
    }
    (0, _createClass._)(VCObserverWrapper, [
        {
            key: "processSsrAbortListeners",
            value: // Helper method to process SSR abort listeners
            function processSsrAbortListeners() {
                var _window;
                // Process any SSR abort listeners that remain
                if ((_window = window) === null || _window === void 0 ? void 0 : _window.__SSR_ABORT_LISTENERS__) {
                    // Clean up any event listeners that may have been registered during SSR
                    // This is centralized here so only the wrapper handles unbinding, not individual observers
                    if (window.__SSR_ABORT_LISTENERS__.unbinds && Array.isArray(window.__SSR_ABORT_LISTENERS__.unbinds)) window.__SSR_ABORT_LISTENERS__.unbinds.forEach(function(unbind) {
                        if (typeof unbind === 'function') unbind();
                    });
                    // After all observers had a chance to process abort events,
                    // we can safely delete the SSR_ABORT_LISTENERS object
                    delete window.__SSR_ABORT_LISTENERS__;
                }
            }
        },
        {
            key: "start",
            value: function start(param) {
                var startTime = param.startTime, experienceKey = param.experienceKey;
                var _this_oldVCObserver, _this_newVCObserver;
                if ((0, _config.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, _config.isVCRevisionEnabled)('fy25.02', experienceKey)) (_this_oldVCObserver = this.oldVCObserver) === null || _this_oldVCObserver === void 0 ? void 0 : _this_oldVCObserver.start({
                    startTime: startTime
                });
                if (VCObserverWrapper.shouldUseNewVCObserver(experienceKey)) (_this_newVCObserver = this.newVCObserver) === null || _this_newVCObserver === void 0 ? void 0 : _this_newVCObserver.start({
                    startTime: startTime
                });
                // Clean up any remaining SSR abort listeners after all observers have been started
                this.processSsrAbortListeners();
            }
        },
        {
            key: "stop",
            value: function stop(experienceKey) {
                var _this_oldVCObserver, _this_newVCObserver;
                if ((0, _config.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, _config.isVCRevisionEnabled)('fy25.02', experienceKey)) (_this_oldVCObserver = this.oldVCObserver) === null || _this_oldVCObserver === void 0 ? void 0 : _this_oldVCObserver.stop();
                if (VCObserverWrapper.shouldUseNewVCObserver(experienceKey)) (_this_newVCObserver = this.newVCObserver) === null || _this_newVCObserver === void 0 ? void 0 : _this_newVCObserver.stop();
                (0, _rllPlaceholders.RLLPlaceholderHandlers).getInstance().reset();
                // Clear shared SSR placeholder handler
                this.ssrPlaceholderHandler.clear();
            }
        },
        {
            key: "getVCRawData",
            value: function getVCRawData() {
                var _this_oldVCObserver;
                var _this_oldVCObserver_getVCRawData;
                return (_this_oldVCObserver_getVCRawData = (_this_oldVCObserver = this.oldVCObserver) === null || _this_oldVCObserver === void 0 ? void 0 : _this_oldVCObserver.getVCRawData()) !== null && _this_oldVCObserver_getVCRawData !== void 0 ? _this_oldVCObserver_getVCRawData : null;
            }
        },
        {
            key: "getVCResult",
            value: function getVCResult(param) {
                return (0, _asyncToGenerator._)(function() {
                    var _this_oldVCObserver, _this_newVCObserver, _v3v4Result_, experienceKey, include3p, excludeSmartAnswersInSearch, includeSSRRatio, includeRawData, v1v2Result, _tmp, v3v4Result, _tmp1, ssrRatio, _v1v2Result_ufovcrev;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                experienceKey = param.experienceKey, include3p = param.include3p, excludeSmartAnswersInSearch = param.excludeSmartAnswersInSearch, includeSSRRatio = param.includeSSRRatio, includeRawData = param.includeRawData;
                                if (!((0, _config.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, _config.isVCRevisionEnabled)('fy25.02', experienceKey))) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    (_this_oldVCObserver = this.oldVCObserver) === null || _this_oldVCObserver === void 0 ? void 0 : _this_oldVCObserver.getVCResult(param)
                                ];
                            case 1:
                                _tmp = _state.sent();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                _tmp = {};
                                _state.label = 3;
                            case 3:
                                v1v2Result = _tmp;
                                if (!VCObserverWrapper.shouldUseNewVCObserver(experienceKey)) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    (_this_newVCObserver = this.newVCObserver) === null || _this_newVCObserver === void 0 ? void 0 : _this_newVCObserver.getVCResult({
                                        start: param.start,
                                        stop: param.stop,
                                        interactionId: param.interactionId,
                                        ssr: param.ssr,
                                        include3p: include3p,
                                        excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
                                        includeSSRRatio: includeSSRRatio,
                                        interactionType: param.interactionType,
                                        isPageVisible: param.isPageVisible,
                                        interactionAbortReason: param.interactionAbortReason,
                                        includeRawData: includeRawData,
                                        includeSSRInV3: param.includeSSRInV3,
                                        rawDataStopTime: param.rawDataStopTime,
                                        reportLayoutShiftOffenders: param.reportLayoutShiftOffenders
                                    })
                                ];
                            case 4:
                                _tmp1 = _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                _tmp1 = [];
                                _state.label = 6;
                            case 6:
                                v3v4Result = _tmp1;
                                if (!v3v4Result || v3v4Result.length === 0) return [
                                    2,
                                    v1v2Result !== null && v1v2Result !== void 0 ? v1v2Result : {}
                                ];
                                ssrRatio = v3v4Result === null || v3v4Result === void 0 ? void 0 : (_v3v4Result_ = v3v4Result[0]) === null || _v3v4Result_ === void 0 ? void 0 : _v3v4Result_.ssrRatio;
                                return [
                                    2,
                                    (0, _objectSpreadProps._)((0, _objectSpread._)({}, includeSSRRatio && ssrRatio !== undefined ? {
                                        'ufo:vc:ssrRatio': ssrRatio
                                    } : {}, v1v2Result), {
                                        'ufo:vc:rev': (0, _toConsumableArray._)((_v1v2Result_ufovcrev = v1v2Result === null || v1v2Result === void 0 ? void 0 : v1v2Result['ufo:vc:rev']) !== null && _v1v2Result_ufovcrev !== void 0 ? _v1v2Result_ufovcrev : []).concat((0, _toConsumableArray._)(v3v4Result !== null && v3v4Result !== void 0 ? v3v4Result : []))
                                    })
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "setSSRElement",
            value: function setSSRElement(element) {
                var _this_oldVCObserver, _this_newVCObserver;
                (_this_oldVCObserver = this.oldVCObserver) === null || _this_oldVCObserver === void 0 ? void 0 : _this_oldVCObserver.setSSRElement(element);
                (_this_newVCObserver = this.newVCObserver) === null || _this_newVCObserver === void 0 ? void 0 : _this_newVCObserver.setReactRootElement(element);
            }
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart(startTime) {
                var _this_oldVCObserver, _this_newVCObserver;
                (_this_oldVCObserver = this.oldVCObserver) === null || _this_oldVCObserver === void 0 ? void 0 : _this_oldVCObserver.setReactRootRenderStart(startTime || performance.now());
                (_this_newVCObserver = this.newVCObserver) === null || _this_newVCObserver === void 0 ? void 0 : _this_newVCObserver.setReactRootRenderStart(startTime || performance.now());
            }
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop(stopTime) {
                var _this_oldVCObserver, _this_newVCObserver;
                (_this_oldVCObserver = this.oldVCObserver) === null || _this_oldVCObserver === void 0 ? void 0 : _this_oldVCObserver.setReactRootRenderStop(stopTime || performance.now());
                (_this_newVCObserver = this.newVCObserver) === null || _this_newVCObserver === void 0 ? void 0 : _this_newVCObserver.setReactRootRenderStop(stopTime || performance.now());
            }
        },
        {
            key: "collectSSRPlaceholders",
            value: function collectSSRPlaceholders() {
                this.ssrPlaceholderHandler.collectExistingPlaceholders();
            }
        }
    ], [
        {
            key: "shouldUseNewVCObserver",
            value: /**
	 * Returns true if the new VC observer pipeline should be active.
	 * This is needed even when no client-side revisions are enabled, because
	 * the raw-handler must still collect observations for server-side TTVC
	 * recalculation when the server-side sync gate is on.
	 */ function shouldUseNewVCObserver(experienceKey) {
                return (0, _config.isVCRevisionEnabled)('fy25.03', experienceKey) || (0, _config.isVCRevisionEnabled)('fy26.04', experienceKey) || (0, _platformFeatureFlags.fg)('ufo_disable_ttvc_v4');
            }
        }
    ]);
    return VCObserverWrapper;
}();
// Some products set this variable to indicate it is running in SSR
var isServer = Boolean((_globalThis = globalThis) === null || _globalThis === void 0 ? void 0 : _globalThis.__SERVER__);
// Other products set this other variable to indicate it is running in SSR
var isReactSSR = typeof process !== 'undefined' && Boolean((process === null || process === void 0 ? void 0 : (_process_env = process.env) === null || _process_env === void 0 ? void 0 : _process_env.REACT_SSR) || false);
function isEnvironmentSupported() {
    var _globalThis, _globalThis1, _globalThis2, _globalThis3;
    // SSR environment aren't supported
    if (isReactSSR || isServer) return false;
    // Legacy browsers that doesn't support WeakRef
    // aren't valid
    if (typeof ((_globalThis = globalThis) === null || _globalThis === void 0 ? void 0 : _globalThis.WeakRef) !== 'function') return false;
    if (typeof ((_globalThis1 = globalThis) === null || _globalThis1 === void 0 ? void 0 : _globalThis1.MutationObserver) !== 'function' || typeof ((_globalThis2 = globalThis) === null || _globalThis2 === void 0 ? void 0 : _globalThis2.IntersectionObserver) !== 'function' || typeof ((_globalThis3 = globalThis) === null || _globalThis3 === void 0 ? void 0 : _globalThis3.PerformanceObserver) !== 'function') return false;
    return true;
}
function getVCObserver() {
    var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!globalThis.__vcObserver) {
        var shouldMockVCObserver = !isEnvironmentSupported();
        globalThis.__vcObserver = shouldMockVCObserver ? new (0, _noOpVcObserver.VCObserverNOOP)() : new VCObserverWrapper(opts);
    }
    return globalThis.__vcObserver;
}
function newVCObserver() {
    var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var shouldMockVCObserver = !isEnvironmentSupported();
    var observer = shouldMockVCObserver ? new (0, _noOpVcObserver.VCObserverNOOP)() : new VCObserverWrapper(opts);
    return observer;
}

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_to_consumable_array":"1eSZf","@swc/helpers/_/_ts_generator":"78Tqx","53bb1a9c72cfc523":"gNLf3","@atlaskit/platform-feature-flags":"kO5t9","../config":"1BZI5","./no-op-vc-observer":"2S16Z","./vc-observer":"2fRJ3","./vc-observer-new":"bvpAO","./vc-observer/observers/rll-placeholders":"a7mKq","./vc-observer/observers/ssr-placeholders":"dvNDb","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2S16Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VCObserverNOOP", function() {
    return VCObserverNOOP;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var VCObserverNOOP = /*#__PURE__*/ function() {
    "use strict";
    function VCObserverNOOP() {
        (0, _classCallCheck._)(this, VCObserverNOOP);
    }
    (0, _createClass._)(VCObserverNOOP, [
        {
            key: "start",
            value: function start(_) {}
        },
        {
            key: "stop",
            value: function stop() {}
        },
        {
            key: "getVCRawData",
            value: function getVCRawData() {
                return null;
            }
        },
        {
            key: "getVCResult",
            value: function getVCResult(_) {
                return Promise.resolve({
                    'ufo:vc:noop': true
                });
            }
        },
        {
            key: "setSSRElement",
            value: function setSSRElement(_) {}
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart(_) {}
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop(_) {}
        }
    ]);
    return VCObserverNOOP;
}();

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bvpAO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getHasAbortingEventDuringSSR", function() {
    return getHasAbortingEventDuringSSR;
});
parcelHelpers.export(exports, "default", function() {
    return VCObserverNew;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _config = require("../../config");
var _interactionMetrics = require("../../interaction-metrics");
var _ssrPlaceholders = require("../vc-observer/observers/ssr-placeholders");
var _entriesTimeline = require("./entries-timeline");
var _entriesTimelineDefault = parcelHelpers.interopDefault(_entriesTimeline);
var _getElementName = require("./get-element-name");
var _getElementNameDefault = parcelHelpers.interopDefault(_getElementName);
var _fy2503 = require("./metric-calculator/fy25_03");
var _fy2503Default = parcelHelpers.interopDefault(_fy2503);
var _fy2604 = require("./metric-calculator/fy26_04");
var _fy2604Default = parcelHelpers.interopDefault(_fy2604);
var _getViewportHeight = require("./metric-calculator/utils/get-viewport-height");
var _getViewportHeightDefault = parcelHelpers.interopDefault(_getViewportHeight);
var _getViewportWidth = require("./metric-calculator/utils/get-viewport-width");
var _getViewportWidthDefault = parcelHelpers.interopDefault(_getViewportWidth);
var _vcNext = require("./metric-calculator/vc-next");
var _vcNextDefault = parcelHelpers.interopDefault(_vcNext);
var _rawDataHandler = require("./raw-data-handler");
var _rawDataHandlerDefault = parcelHelpers.interopDefault(_rawDataHandler);
var _viewportObserver = require("./viewport-observer");
var _viewportObserverDefault = parcelHelpers.interopDefault(_viewportObserver);
var _windowEventObserver = require("./window-event-observer");
var _windowEventObserverDefault = parcelHelpers.interopDefault(_windowEventObserver);
var SSRState = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
var DEFAULT_SELECTOR_CONFIG = {
    id: false,
    testId: true,
    role: false,
    className: false,
    dataVC: true
};
var hasAbortingEventDuringSSR = false;
function getHasAbortingEventDuringSSR() {
    return hasAbortingEventDuringSSR;
}
var VCObserverNew = /*#__PURE__*/ function() {
    "use strict";
    function VCObserverNew(config) {
        var _this = this;
        (0, _classCallCheck._)(this, VCObserverNew);
        var _config_SSRConfig;
        this.viewportObserver = null;
        this.windowEventObserver = null;
        // SSR related properties
        this.ssrPlaceholderHandler = null;
        this.ssr = {
            state: SSRState.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        this.entriesTimeline = new (0, _entriesTimelineDefault.default)();
        var _config_isPostInteraction;
        this.isPostInteraction = (_config_isPostInteraction = config.isPostInteraction) !== null && _config_isPostInteraction !== void 0 ? _config_isPostInteraction : false;
        var _getSelectorConfig, _ref;
        // Selector-config resolution is centralised in `getSelectorConfig()`
        // (`../../config`). It applies the FedRAMP all-`false` override when
        // `isFedrampModerate()` is true; otherwise it returns `caller-override
        // → setUFOConfig value → historical default`.
        this.selectorConfig = (_ref = (_getSelectorConfig = (0, _config.getSelectorConfig)(config.selectorConfig, DEFAULT_SELECTOR_CONFIG)) !== null && _getSelectorConfig !== void 0 ? _getSelectorConfig : config.selectorConfig) !== null && _ref !== void 0 ? _ref : DEFAULT_SELECTOR_CONFIG;
        var _config_SSRConfig_enablePageLayoutPlaceholder;
        // Use shared SSR placeholder handler if provided, otherwise create new one if feature flag is enabled
        if (config.ssrPlaceholderHandler) this.ssrPlaceholderHandler = config.ssrPlaceholderHandler;
        else this.ssrPlaceholderHandler = new (0, _ssrPlaceholders.SSRPlaceholderHandlers)({
            enablePageLayoutPlaceholder: (_config_SSRConfig_enablePageLayoutPlaceholder = (_config_SSRConfig = config.SSRConfig) === null || _config_SSRConfig === void 0 ? void 0 : _config_SSRConfig.enablePageLayoutPlaceholder) !== null && _config_SSRConfig_enablePageLayoutPlaceholder !== void 0 ? _config_SSRConfig_enablePageLayoutPlaceholder : false
        });
        var _config_trackLayoutShiftOffenders;
        this.trackLayoutShiftOffenders = (_config_trackLayoutShiftOffenders = config.trackLayoutShiftOffenders) !== null && _config_trackLayoutShiftOffenders !== void 0 ? _config_trackLayoutShiftOffenders : false;
        this.viewportObserver = new (0, _viewportObserverDefault.default)({
            onChange: function(onChangeArg) {
                var time = onChangeArg.time, type = onChangeArg.type, elementRef = onChangeArg.elementRef, visible = onChangeArg.visible, rect = onChangeArg.rect, previousRect = onChangeArg.previousRect, mutationData = onChangeArg.mutationData;
                var elementName = 'unknown';
                var element = elementRef.deref();
                if (element) elementName = _this.getElementName(element);
                var data = {
                    type: type,
                    elementName: elementName,
                    rect: rect,
                    previousRect: previousRect,
                    visible: visible,
                    attributeName: mutationData === null || mutationData === void 0 ? void 0 : mutationData.attributeName,
                    oldValue: mutationData === null || mutationData === void 0 ? void 0 : mutationData.oldValue,
                    newValue: mutationData === null || mutationData === void 0 ? void 0 : mutationData.newValue,
                    originalMutationTimestamp: mutationData === null || mutationData === void 0 ? void 0 : mutationData.timestamp
                };
                if (element) {
                    var labelStacks = getLabelStacks(element);
                    if (labelStacks) Object.assign(data, {
                        labelStacks: labelStacks
                    });
                }
                _this.entriesTimeline.push({
                    time: time,
                    data: data
                });
            },
            // Pass SSR context to ViewportObserver
            getSSRState: function() {
                return _this.getSSRState();
            },
            getSSRPlaceholderHandler: function() {
                return _this.getSSRPlaceholderHandler();
            },
            searchPageConfig: config.searchPageConfig,
            trackLayoutShiftOffenders: this.trackLayoutShiftOffenders
        });
        this.windowEventObserver = new (0, _windowEventObserverDefault.default)({
            onEvent: function(param) {
                var time = param.time, type = param.type;
                // Don't abort press interactions on keydown events, as keydown is expected
                // when users press Enter/Space to activate buttons or other interactive elements
                if (type === 'keydown' && (0, _platformFeatureFlags.fg)('platform_ufo_keypress_interaction_abort')) {
                    var interaction = (0, _interactionMetrics.getActiveInteraction)();
                    if ((interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'press') return;
                }
                _this.entriesTimeline.push({
                    time: time,
                    data: {
                        type: 'window:event',
                        eventType: type
                    }
                });
            }
        });
    }
    (0, _createClass._)(VCObserverNew, [
        {
            key: "start",
            value: function start(_) {
                var _this = this;
                var _this_viewportObserver;
                // Reset SSR state on start (matches old VCObserver behavior)
                this.ssr = {
                    state: SSRState.normal,
                    reactRootElement: null,
                    renderStart: -1,
                    renderStop: -1
                };
                (_this_viewportObserver = this.viewportObserver) === null || _this_viewportObserver === void 0 ? void 0 : _this_viewportObserver.start();
                if ((0, _platformFeatureFlags.fg)('ufo_fix_aborting_interaction_detection_during_ssr')) {
                    var _window, _this_windowEventObserver;
                    this.entriesTimeline.clear();
                    if ((_window = window) === null || _window === void 0 ? void 0 : _window.__SSR_ABORT_LISTENERS__) {
                        var abortListeners = window.__SSR_ABORT_LISTENERS__;
                        var aborts = abortListeners.aborts;
                        if (aborts && (typeof aborts === "undefined" ? "undefined" : (0, _typeOf._)(aborts)) === 'object') Object.entries(aborts).forEach(function(param) {
                            var _param = (0, _slicedToArray._)(param, 2), key = _param[0], time = _param[1];
                            if (typeof time === 'number') _this.entriesTimeline.push({
                                time: time,
                                data: {
                                    type: 'window:event',
                                    eventType: key
                                }
                            });
                        });
                    }
                    (_this_windowEventObserver = this.windowEventObserver) === null || _this_windowEventObserver === void 0 ? void 0 : _this_windowEventObserver.start();
                } else {
                    var _window1, _this_windowEventObserver1;
                    if ((_window1 = window) === null || _window1 === void 0 ? void 0 : _window1.__SSR_ABORT_LISTENERS__) {
                        var abortListeners1 = window.__SSR_ABORT_LISTENERS__;
                        var aborts1 = abortListeners1.aborts;
                        if (aborts1 && (typeof aborts1 === "undefined" ? "undefined" : (0, _typeOf._)(aborts1)) === 'object') Object.entries(aborts1).forEach(function(param) {
                            var _param = (0, _slicedToArray._)(param, 2), key = _param[0], time = _param[1];
                            if (typeof time === 'number') {
                                _this.entriesTimeline.push({
                                    time: time,
                                    data: {
                                        type: 'window:event',
                                        eventType: key
                                    }
                                });
                                if ((0, _platformFeatureFlags.fg)('ufo_detect_aborting_interaction_during_ssr')) hasAbortingEventDuringSSR = true;
                            }
                        });
                    }
                    (_this_windowEventObserver1 = this.windowEventObserver) === null || _this_windowEventObserver1 === void 0 ? void 0 : _this_windowEventObserver1.start();
                    this.entriesTimeline.clear();
                }
            }
        },
        {
            key: "stop",
            value: function stop() {
                var _this_viewportObserver, _this_windowEventObserver;
                (_this_viewportObserver = this.viewportObserver) === null || _this_viewportObserver === void 0 ? void 0 : _this_viewportObserver.stop();
                (_this_windowEventObserver = this.windowEventObserver) === null || _this_windowEventObserver === void 0 ? void 0 : _this_windowEventObserver.stop();
                // Clear SSR state on stop (matches old VCObserver behavior)
                this.ssr.reactRootElement = null;
            }
        },
        {
            // SSR related methods
            key: "setReactRootElement",
            value: function setReactRootElement(element) {
                this.ssr.reactRootElement = element;
            }
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart() {
                var startTime = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : performance.now();
                this.ssr.renderStart = startTime;
                this.ssr.state = SSRState.waitingForFirstRender;
            }
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop() {
                var stopTime = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : performance.now();
                this.ssr.renderStop = stopTime;
            }
        },
        {
            key: "collectSSRPlaceholders",
            value: function collectSSRPlaceholders() {
            // This is handled by the shared SSRPlaceholderHandlers in VCObserverWrapper
            // Individual observers don't need to implement this
            }
        },
        {
            // Internal methods for ViewportObserver to access SSR state
            key: "getSSRState",
            value: function getSSRState() {
                return this.ssr;
            }
        },
        {
            key: "getSSRPlaceholderHandler",
            value: function getSSRPlaceholderHandler() {
                return this.ssrPlaceholderHandler;
            }
        },
        {
            key: "addSSR",
            value: function addSSR(ssr) {
                this.entriesTimeline.push({
                    time: ssr,
                    data: {
                        elementName: 'SSR',
                        type: 'mutation:element',
                        rect: {
                            height: (0, _getViewportHeightDefault.default)(),
                            width: (0, _getViewportWidthDefault.default)(),
                            left: 0,
                            top: 0,
                            x: 0,
                            y: 0,
                            bottom: (0, _getViewportHeightDefault.default)(),
                            right: (0, _getViewportWidthDefault.default)(),
                            toJSON: function toJSON() {
                                return null;
                            }
                        },
                        visible: true
                    }
                });
            }
        },
        {
            key: "getVCResult",
            value: function getVCResult(param) {
                return (0, _asyncToGenerator._)(function() {
                    var start, stop, interactionId, interactionType, interactionAbortReason, isPageVisible, include3p, includeSSRRatio, excludeSmartAnswersInSearch, includeRawData, rawDataStopTime, results, feVCCalculationStartTime, calculator_fy25_03, orderedEntries, fy25_03, _tmp, calculator_fy26_04, calculator_next, calculatorParams, isFy2604Enabled, _ref, fy26_04, vcNext, feVCCalculationEndTime, shouldIncludeRawData, rawVCCalculationStartTime, rawHandler, rawStopTime, rawOrderedEntries, raw;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                start = param.start, stop = param.stop, interactionId = param.interactionId, interactionType = param.interactionType, interactionAbortReason = param.interactionAbortReason, isPageVisible = param.isPageVisible, include3p = param.include3p, includeSSRRatio = param.includeSSRRatio, excludeSmartAnswersInSearch = param.excludeSmartAnswersInSearch, includeRawData = param.includeRawData, rawDataStopTime = param.rawDataStopTime;
                                results = [];
                                this.addStartEntry(start);
                                feVCCalculationStartTime = performance.now();
                                calculator_fy25_03 = new (0, _fy2503Default.default)();
                                if (param.includeSSRInV3 && param.ssr) this.addSSR(param.ssr);
                                orderedEntries = this.entriesTimeline.getOrderedEntries({
                                    start: start,
                                    stop: stop
                                });
                                if (!(0, _config.isVCRevisionEnabled)('fy25.03')) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    calculator_fy25_03.calculate({
                                        orderedEntries: orderedEntries,
                                        startTime: start,
                                        stopTime: stop,
                                        interactionId: interactionId,
                                        interactionType: interactionType,
                                        isPostInteraction: this.isPostInteraction,
                                        include3p: include3p,
                                        excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
                                        includeSSRRatio: includeSSRRatio,
                                        isPageVisible: isPageVisible,
                                        interactionAbortReason: interactionAbortReason,
                                        reportLayoutShiftOffenders: this.trackLayoutShiftOffenders
                                    })
                                ];
                            case 1:
                                _tmp = _state.sent();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                _tmp = null;
                                _state.label = 3;
                            case 3:
                                fy25_03 = _tmp;
                                if (fy25_03) results.push(fy25_03);
                                // From TTVC v4 onwards, ensuring that SSR entry is always auto-added, whenever it is configured.
                                if (param.ssr) this.addSSR(param.ssr);
                                calculator_fy26_04 = new (0, _fy2604Default.default)();
                                calculator_next = new (0, _vcNextDefault.default)();
                                calculatorParams = {
                                    orderedEntries: orderedEntries,
                                    startTime: start,
                                    stopTime: stop,
                                    interactionId: interactionId,
                                    interactionType: interactionType,
                                    isPostInteraction: this.isPostInteraction,
                                    include3p: include3p,
                                    excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
                                    includeSSRRatio: includeSSRRatio,
                                    isPageVisible: isPageVisible,
                                    interactionAbortReason: interactionAbortReason,
                                    reportLayoutShiftOffenders: this.trackLayoutShiftOffenders
                                };
                                isFy2604Enabled = (0, _config.isVCRevisionEnabled)('fy26.04');
                                return [
                                    4,
                                    Promise.all([
                                        isFy2604Enabled ? calculator_fy26_04.calculate(calculatorParams) : null,
                                        (0, _config.isVCRevisionEnabled)('next') ? calculator_next.calculate(calculatorParams) : null
                                    ])
                                ];
                            case 4:
                                _ref = (0, _slicedToArray._).apply(void 0, [
                                    _state.sent(),
                                    2
                                ]), fy26_04 = _ref[0], vcNext = _ref[1];
                                if (fy26_04) results.push(fy26_04);
                                if (vcNext) results.push(vcNext);
                                feVCCalculationEndTime = performance.now();
                                // Always include raw data when fy26.04 is not in the client config so the server
                                // can recalculate fy26.04 metrics (ssrRatio, labelStacks, speedIndex) from raw observations.
                                shouldIncludeRawData = includeRawData || !isFy2604Enabled;
                                if (!shouldIncludeRawData) return [
                                    3,
                                    6
                                ];
                                rawVCCalculationStartTime = performance.now();
                                rawHandler = new (0, _rawDataHandlerDefault.default)();
                                // Use rawDataStopTime (end3p) when available to capture observations during 3p holds
                                rawStopTime = rawDataStopTime !== null && rawDataStopTime !== void 0 ? rawDataStopTime : stop;
                                rawOrderedEntries = rawDataStopTime ? this.entriesTimeline.getOrderedEntries({
                                    start: start,
                                    stop: rawStopTime
                                }) : orderedEntries;
                                return [
                                    4,
                                    rawHandler.getRawData({
                                        entries: rawOrderedEntries,
                                        startTime: start,
                                        stopTime: rawStopTime,
                                        isPageVisible: isPageVisible
                                    })
                                ];
                            case 5:
                                raw = _state.sent();
                                results.forEach(function(result) {
                                    delete result.vcDetails;
                                    delete result.ratios;
                                });
                                if (raw) {
                                    raw.rawVCTime = Number((performance.now() - rawVCCalculationStartTime).toFixed(2));
                                    raw.feVCTime = Number((feVCCalculationEndTime - feVCCalculationStartTime).toFixed(2));
                                    results.push(raw);
                                }
                                _state.label = 6;
                            case 6:
                                return [
                                    2,
                                    results
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "addStartEntry",
            value: function addStartEntry(startTime) {
                this.entriesTimeline.push({
                    time: startTime,
                    data: {
                        type: 'mutation:element',
                        elementName: 'START',
                        visible: true,
                        rect: {
                            x: 0,
                            y: 0,
                            width: window.innerWidth,
                            height: window.innerHeight,
                            top: 0,
                            left: 0,
                            bottom: window.innerHeight,
                            right: window.innerWidth,
                            toJSON: function toJSON() {
                                return {
                                    x: this.x,
                                    y: this.y,
                                    width: this.width,
                                    height: this.height,
                                    top: this.top,
                                    left: this.left,
                                    bottom: this.bottom,
                                    right: this.right
                                };
                            }
                        }
                    }
                });
            }
        },
        {
            key: "getElementName",
            value: function getElementName(element) {
                return (0, _getElementNameDefault.default)(this.selectorConfig, element);
            }
        }
    ]);
    return VCObserverNew;
}();
function labelStackFromFiber(fiber) {
    var _fiber_child_memoizedProps, _fiber_child;
    var value = fiber === null || fiber === void 0 ? void 0 : (_fiber_child = fiber.child) === null || _fiber_child === void 0 ? void 0 : (_fiber_child_memoizedProps = _fiber_child.memoizedProps) === null || _fiber_child_memoizedProps === void 0 ? void 0 : _fiber_child_memoizedProps.value;
    return Array.isArray(value === null || value === void 0 ? void 0 : value.labelStack) ? value.labelStack : [];
}
function labelStackToString(labelStack) {
    return labelStack.map(function(label) {
        return label.name;
    }).join('/');
}
function labelStackToSegment(labelStack) {
    var segmentIndex = -1;
    for(var i = labelStack.length - 1; i >= 0; i--)if (labelStack[i].segmentId) {
        segmentIndex = i;
        break;
    }
    return labelStack.slice(0, segmentIndex + 1).map(function(label) {
        return label.name;
    }).join('/');
}
function traverseFiber(fiber) {
    var segment = 'unknown';
    var labelStackString = 'unknown';
    var currentFiber = fiber;
    while(currentFiber){
        if (currentFiber.type) {
            var componentName = currentFiber.type.displayName || currentFiber.type.name;
            if (componentName === 'UFOSegment' || componentName === 'UFOLabel') {
                var labelStack = labelStackFromFiber(currentFiber);
                labelStackString = labelStackToString(labelStack) || 'unknown';
                segment = labelStackToSegment(labelStack) || 'unknown';
                break;
            }
        }
        currentFiber = currentFiber.return;
    }
    return {
        segment: segment,
        labelStack: labelStackString
    };
}
function getLabelStacks(element) {
    var reactFiberKey = Object.keys(element).find(function(key) {
        return key.startsWith('__reactFiber$');
    });
    if (!reactFiberKey) return null;
    var fiber = element[reactFiberKey];
    return fiber ? traverseFiber(fiber) : null;
}

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_type_of":"iFJdx","@swc/helpers/_/_ts_generator":"78Tqx","@atlaskit/platform-feature-flags":"kO5t9","../../config":"1BZI5","../../interaction-metrics":"diQdd","../vc-observer/observers/ssr-placeholders":"dvNDb","./entries-timeline":"2RHFP","./get-element-name":"lcaGB","./metric-calculator/fy25_03":"gZahN","./metric-calculator/fy26_04":"lcK2n","./metric-calculator/utils/get-viewport-height":"fuG5Y","./metric-calculator/utils/get-viewport-width":"lY1vD","./metric-calculator/vc-next":"csGNx","./raw-data-handler":"dyEU1","./viewport-observer":"fXAxE","./window-event-observer":"9FDxe","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2RHFP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return EntriesTimeline;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var EntriesTimeline = /*#__PURE__*/ function() {
    "use strict";
    function EntriesTimeline() {
        (0, _classCallCheck._)(this, EntriesTimeline);
        this.unorderedEntries = [];
        this.sortedEntriesCache = new Map();
    }
    (0, _createClass._)(EntriesTimeline, [
        {
            key: "push",
            value: function push(entry) {
                this.unorderedEntries.push(entry);
                this.sortedEntriesCache.clear();
            }
        },
        {
            key: "getCacheKey",
            value: function getCacheKey(start, stop) {
                return "".concat(start !== null && start !== void 0 ? start : 'null', "_").concat(stop !== null && stop !== void 0 ? stop : 'null');
            }
        },
        {
            key: "getOrderedEntries",
            value: function getOrderedEntries(param) {
                var start = param.start, stop = param.stop;
                var _this_sortedEntriesCache_get;
                var cacheKey = this.getCacheKey(start, stop);
                var cachedSortedEntries = (_this_sortedEntriesCache_get = this.sortedEntriesCache.get(cacheKey)) === null || _this_sortedEntriesCache_get === void 0 ? void 0 : _this_sortedEntriesCache_get.deref();
                if (cachedSortedEntries) return cachedSortedEntries;
                var filteredEntries = this.unorderedEntries.filter(function(e) {
                    return e.time >= (start !== null && start !== void 0 ? start : 0) && e.time <= (stop !== null && stop !== void 0 ? stop : performance.now());
                });
                var sortedEntries = filteredEntries.sort(function(a, b) {
                    return a.time - b.time;
                });
                this.sortedEntriesCache.set(cacheKey, new WeakRef(sortedEntries));
                return sortedEntries;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.unorderedEntries = [];
                this.sortedEntriesCache.clear();
            }
        }
    ]);
    return EntriesTimeline;
}();

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lcaGB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _instanceof = require("@swc/helpers/_/_instanceof");
var nameCache = new WeakMap();
function getElementName(selectorConfig, element) {
    if (!(0, _instanceof._)(element, HTMLElement)) {
        var elementInstance = 'Unknown';
        // Types of elements according to LLM
        if ((0, _instanceof._)(element, Text)) elementInstance = 'Text';
        else if ((0, _instanceof._)(element, DocumentFragment)) elementInstance = 'DocumentFragment';
        else if ((0, _instanceof._)(element, Document)) elementInstance = 'Document';
        else if ((0, _instanceof._)(element, Comment)) elementInstance = 'Comment';
        else if ((0, _instanceof._)(element, ProcessingInstruction)) elementInstance = 'ProcessingInstruction';
        else if ((0, _instanceof._)(element, Attr)) elementInstance = 'Attr';
        else if ((0, _instanceof._)(element, CDATASection)) elementInstance = 'CDATASection';
        if (element.parentElement && (0, _instanceof._)(element.parentElement, HTMLElement)) {
            var parentElementSelector = getElementName(selectorConfig, element.parentElement);
            return "".concat(parentElementSelector, " > ").concat(elementInstance);
        } else return elementInstance;
    }
    var cachedName = nameCache.get(element);
    if (cachedName) return cachedName;
    // Get the tag name of the element.
    var tagName = element.localName;
    var encodeValue = function(s) {
        if (typeof encodeURIComponent !== 'function') return '';
        try {
            return encodeURIComponent(s);
        } catch (e) {
            return 'malformed_value';
        }
    };
    // Helper function to construct attribute selectors.
    var getAttributeSelector = function(attributeName) {
        var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : '';
        if (element && typeof element.getAttribute !== 'function') return '';
        var attrValue = element.getAttribute(attributeName);
        if (!attrValue) return '';
        var encondedAttrValue = encodeValue(attrValue);
        return "".concat(prefix, "[").concat(attributeName, '="').concat(encondedAttrValue, '"]');
    };
    // Construct the data-vc attribute selector if specified in the config.
    var dataVC = selectorConfig.dataVC !== false ? getAttributeSelector('data-vc') : '';
    // Construct the ID selector if specified in the config and the element has an ID.
    var id = selectorConfig.id && element.id ? "#".concat(encodeValue(element.id)) : '';
    // Construct the test ID selector if specified in the config.
    var testId = selectorConfig.testId ? getAttributeSelector('data-testid') || getAttributeSelector('data-test-id') : '';
    // Construct the role selector if specified in the config.
    var role = selectorConfig.role ? getAttributeSelector('role') : '';
    var classNames = Array.from(element.classList).map(encodeValue).join('.');
    // Construct the class list selector if specified in the config.
    var classList = selectorConfig.className && classNames ? ".".concat(classNames) : '';
    // Combine primary attribute selectors (id, testId, role) into a single string.
    var primaryAttributes = [
        id,
        testId,
        role
    ].filter(Boolean).join('');
    // Use dataVC if available, otherwise use the primary attributes.
    var attributes = dataVC || primaryAttributes;
    // If no attributes or class list, recursively get the parent's name.
    if (!attributes && !classList) {
        var parentName = element.parentElement ? getElementName(selectorConfig, element.parentElement) : 'unknown';
        return "".concat(parentName, " > ").concat(tagName);
    }
    // Return the final constructed name: tagName + attributes or classList.
    var name = "".concat(tagName).concat(attributes || classList);
    nameCache.set(element, name);
    return name;
}
exports.default = getElementName;

},{"@swc/helpers/_/_instanceof":"h9UKc","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gZahN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return VCCalculator_FY25_03;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _expVal = require("../../../expVal");
var _isDndStyleMutation = require("../../../vc-observer/observers/non-visual-styles/is-dnd-style-mutation");
var _abstractBaseVcCalculator = require("../abstract-base-vc-calculator");
var _abstractBaseVcCalculatorDefault = parcelHelpers.interopDefault(_abstractBaseVcCalculator);
var _constants = require("../utils/constants");
var _isViewportEntryData = require("../utils/is-viewport-entry-data");
var _isViewportEntryDataDefault = parcelHelpers.interopDefault(_isViewportEntryData);
var ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize'
];
var REVISION_NO = 'fy25.03';
var getConsideredEntryTypes = function(include3p, excludeSmartAnswersInSearch) {
    var entryTypes = [
        'mutation:child-element',
        'mutation:element',
        'mutation:attribute',
        'layout-shift',
        'layout-shift:same-rect',
        'window:event'
    ];
    // Only include third-party elements in TTVC calculation when explicitly requested
    if (include3p) {
        entryTypes.push('mutation:third-party-element');
        entryTypes.push('mutation:third-party-attribute');
    }
    if (!excludeSmartAnswersInSearch) {
        entryTypes.push('mutation:smart-answers-element');
        entryTypes.push('mutation:smart-answers-attribute');
    }
    entryTypes.push('mutation:media');
    // Still included as part of TTVC v3
    entryTypes.push('mutation:attribute:non-visual-input-name');
    return entryTypes;
};
var VCCalculator_FY25_03 = /*#__PURE__*/ function(AbstractVCCalculatorBase) {
    "use strict";
    (0, _inherits._)(VCCalculator_FY25_03, AbstractVCCalculatorBase);
    function VCCalculator_FY25_03(revisionNo) {
        (0, _classCallCheck._)(this, VCCalculator_FY25_03);
        return (0, _callSuper._)(this, VCCalculator_FY25_03, [
            revisionNo !== null && revisionNo !== void 0 ? revisionNo : REVISION_NO
        ]);
    }
    (0, _createClass._)(VCCalculator_FY25_03, [
        {
            key: "isEntryIncluded",
            value: function isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
                if (!getConsideredEntryTypes(include3p, excludeSmartAnswersInSearch).includes(entry.data.type)) return false;
                if (entry.data.type === 'mutation:attribute:framework-routing') return false;
                if (entry.data.type === 'mutation:media' && (0, _platformFeatureFlags.fg)('media-perf-uplift-mutation-fix')) {
                    var entryData = entry.data;
                    var attributeName = entryData.attributeName;
                    if (attributeName && (/data-(test|file|context)-\S+/g.test(attributeName) || attributeName === 'data-cursor' || attributeName === 'alt' || (attributeName === 'localid' || attributeName === 'contenteditable' || attributeName === 'anchor-name') && (0, _expVal.expVal)('platform_editor_media_vc_fixes', 'isEnabled', false))) return false;
                    // special case for style attribute to ignore only anchor-name changes
                    if ((0, _expVal.expVal)('platform_editor_media_vc_fixes', 'isEnabled', false)) {
                        if ((0, _isDndStyleMutation.containsDnDMutationInStyle)({
                            attributeName: entryData.attributeName,
                            oldValue: entryData.oldValue,
                            newValue: entryData.newValue
                        })) return false;
                    }
                }
                if (entry.data.type === 'mutation:attribute') {
                    var entryData1 = entry.data;
                    var attributeName1 = entryData1.attributeName;
                    if (!attributeName1 || (0, _constants.KNOWN_ATTRIBUTES_THAT_DOES_NOT_CAUSE_LAYOUT_SHIFTS).includes(attributeName1)) return false;
                    if (attributeName1.startsWith('data-test') || (0, _constants.NON_VISUAL_ARIA_ATTRIBUTES).includes(attributeName1) || (0, _constants.THIRD_PARTY_BROWSER_EXTENSION_ATTRIBUTES).includes(attributeName1) && (0, _platformFeatureFlags.fg)('platform_ufo_exclude_3p_extensions_from_ttvc') || (0, _constants.DARK_READER_BROWSER_EXTENSION_ATTRIBUTES).includes(attributeName1) && (0, _platformFeatureFlags.fg)('platform_ufo_exclude_dark_reader_extension') || (0, _constants.MORE_THIRD_PARTY_EXTENSION_ATTRIBUTES).includes(attributeName1) && (0, _platformFeatureFlags.fg)('platform_ufo_exclude_fdprocessedid_attribute')) return false;
                    return true;
                }
                if ((0, _isViewportEntryDataDefault.default)(entry.data) && !entry.data.visible) return false;
                return true;
            }
        },
        {
            key: "getVCCleanStatus",
            value: function getVCCleanStatus(filteredEntries) {
                var dirtyReason = '';
                var abortTimestamp = -1;
                var hasAbortEvent = filteredEntries.some(function(entry) {
                    if (entry.data.type === 'window:event') {
                        var data = entry.data;
                        var eventType = data.eventType;
                        if (ABORTING_WINDOW_EVENT.includes(eventType)) {
                            dirtyReason = eventType === 'keydown' ? 'keypress' : eventType;
                            abortTimestamp = Math.round(entry.time);
                            return true;
                        }
                    }
                    return false;
                });
                if (hasAbortEvent && dirtyReason) return {
                    isVCClean: false,
                    dirtyReason: dirtyReason,
                    abortTimestamp: abortTimestamp
                };
                return {
                    isVCClean: true
                };
            }
        }
    ]);
    return VCCalculator_FY25_03;
}((0, _abstractBaseVcCalculatorDefault.default));

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_inherits":"2sfqW","@atlaskit/platform-feature-flags":"kO5t9","../../../expVal":"10m7B","../../../vc-observer/observers/non-visual-styles/is-dnd-style-mutation":"1SaMe","../abstract-base-vc-calculator":"S8CE5","../utils/constants":"fGnX3","../utils/is-viewport-entry-data":"kvOc1","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"10m7B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "expVal", function() {
    return expVal;
});
var _featureGateJsClient = require("@atlaskit/feature-gate-js-client");
var _featureGateJsClientDefault = parcelHelpers.interopDefault(_featureGateJsClient);
var _featureFlagsAccessed = require("../feature-flags-accessed");
var expVal = function(experimentName, experimentParam, defaultValue) {
    // If client is not initialized, we return the default value
    if (!(0, _featureGateJsClientDefault.default).initializeCompleted()) return defaultValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    var experimentValue = (0, _featureGateJsClientDefault.default).getExperimentValue(experimentName, experimentParam, defaultValue);
    (0, _featureFlagsAccessed.addFeatureFlagAccessed)("".concat(experimentName, ":").concat(experimentParam), experimentValue);
    return experimentValue;
};

},{"@atlaskit/feature-gate-js-client":"8JPKt","../feature-flags-accessed":"kHUgA","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1SaMe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isDnDStyleMutation", function() {
    return isDnDStyleMutation;
});
parcelHelpers.export(exports, "containsDnDMutationInStyle", function() {
    return containsDnDMutationInStyle;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
var isDnDStyleChange = function(style) {
    return style.startsWith('anchor-name: --node-anchor');
};
var parseStyleSet = function(style) {
    if (!style) return null;
    var set = new Set();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = style.split(';')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var part = _step.value;
            var t = part.trim();
            if (t) set.add(t);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return set;
};
/**
 * Checks if a mutation record represents a style change from Editor's
 * drag and drop feature, which don't cause visual shifts.
 * This should be removed once DnD has been fixed.
 * @param mutation - The mutation record to check
 * @returns boolean indicating if this is a DnD style mutation
 */ function isDnDStyleMutation(param) {
    var target = param.target, attributeName = param.attributeName, oldValue = param.oldValue, newValue = param.newValue;
    if (!(0, _instanceof._)(target, Element)) return false;
    return containsDnDMutationInStyle({
        attributeName: attributeName,
        oldValue: oldValue,
        newValue: newValue
    });
}
function containsDnDMutationInStyle(param) {
    var attributeName = param.attributeName, oldValue = param.oldValue, newValue = param.newValue;
    if (attributeName !== 'style') return false;
    var oldStyles = parseStyleSet(oldValue);
    var newStyles = parseStyleSet(newValue);
    var isDnDMutation = false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = (oldStyles !== null && oldStyles !== void 0 ? oldStyles : [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var s = _step.value;
            if (!(newStyles === null || newStyles === void 0 ? void 0 : newStyles.has(s))) {
                if (!isDnDStyleChange(s)) return false;
                isDnDMutation = true;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = (newStyles !== null && newStyles !== void 0 ? newStyles : [])[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var s1 = _step1.value;
            if (!(oldStyles === null || oldStyles === void 0 ? void 0 : oldStyles.has(s1))) {
                if (!isDnDStyleChange(s1)) return false;
                isDnDMutation = true;
            }
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return isDnDMutation;
}
exports.default = isDnDStyleMutation;

},{"@swc/helpers/_/_instanceof":"h9UKc","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"S8CE5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return AbstractVCCalculatorBase;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _percentileCalc = require("./percentile-calc");
var _detectLayoutShiftCause = require("./utils/detect-layout-shift-cause");
var _getViewportHeight = require("./utils/get-viewport-height");
var _getViewportHeightDefault = parcelHelpers.interopDefault(_getViewportHeight);
var _getViewportWidth = require("./utils/get-viewport-width");
var _getViewportWidthDefault = parcelHelpers.interopDefault(_getViewportWidth);
// Helper function for reporting ratios
function roundDecimal(value) {
    var decimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 3;
    var factor = Math.pow(10, decimals);
    return Math.round(value * factor) / factor;
}
var AbstractVCCalculatorBase = /*#__PURE__*/ function() {
    "use strict";
    function AbstractVCCalculatorBase(revisionNo) {
        (0, _classCallCheck._)(this, AbstractVCCalculatorBase);
        this.revisionNo = revisionNo;
    }
    (0, _createClass._)(AbstractVCCalculatorBase, [
        {
            key: "filterViewportEntries",
            value: function filterViewportEntries(entries) {
                return entries.filter(function(entry) {
                    return 'rect' in entry.data;
                });
            }
        },
        {
            key: "calculateRatios",
            value: /**
	 * Calculate ratios for each element based on their viewport coverage.
	 */ function calculateRatios(filteredEntries) {
                var ratios = {};
                var viewportWidth = (0, _getViewportWidthDefault.default)();
                var viewportHeight = (0, _getViewportHeightDefault.default)();
                var totalViewportArea = viewportWidth * viewportHeight;
                if (totalViewportArea === 0) return ratios;
                var elementRects = new Map();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = filteredEntries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var entry = _step.value;
                        if ('rect' in entry.data) {
                            var viewportEntry = entry.data;
                            elementRects.set(viewportEntry.elementName, viewportEntry.rect);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = elementRects[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var _step_value = (0, _slicedToArray._)(_step1.value, 2), elementName = _step_value[0], rect = _step_value[1];
                        var elementArea = rect.width * rect.height;
                        ratios[elementName] = roundDecimal(elementArea / totalViewportArea);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                return ratios;
            }
        },
        {
            key: "getLabelStacks",
            value: function getLabelStacks(filteredEntries, isPostInteraction) {
                var labelStacks = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = filteredEntries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var entry = _step.value;
                        if ('elementName' in entry.data && entry.data.labelStacks) {
                            if (isPostInteraction) labelStacks[entry.data.elementName] = {
                                segment: entry.data.labelStacks.segment,
                                labelStack: entry.data.labelStacks.labelStack
                            };
                            else labelStacks[entry.data.elementName] = entry.data.labelStacks.labelStack;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return labelStacks;
            }
        },
        {
            key: "calculateWithDebugInfo",
            value: function calculateWithDebugInfo(filteredEntries, startTime, stopTime, isPostInteraction, isVCClean, interactionType, isPageVisible, interactionId, dirtyReason, allEntries, include3p, excludeSmartAnswersInSearch, interactionAbortReason, includeSSRRatio, reportLayoutShiftOffenders) {
                return (0, _asyncToGenerator._)(function() {
                    var _window, _window1, _window2, _window3, _window4, percentiles, viewportEntries, _ref, vcLogs, speedIndex, vcDetails, percentileIndex, entryDataBuffer, ssrRatio, layoutShiftInsights, previousViewportPercentage, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, entry, time, viewportPercentage, entries, elementNames, layoutShiftEntries, previousResult, i, percentile, enhancedVcLogs, shouldCalculate3p, shouldCalculateDebugDetails, sortedVcLogs, maxViewportPercentageAtTime, maxSoFar, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, log, getBiggestPreviousViewportPercentage, ignoredEntriesByTime, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, entry1, _viewportData_rect, _viewportData_previousRect, _ignoredEntriesByTime_get, viewportData, timestamp, additionalVcLogs, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, _step_value, timestamp1, ignoredEntries, viewportPercentage1, v3RevisionDebugDetails, _window___ufo_devtool_onVCRevisionReady__, _window5, _window___on_ufo_vc_debug_data_ready, _window6;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                percentiles = [
                                    25,
                                    50,
                                    75,
                                    80,
                                    85,
                                    90,
                                    95,
                                    98,
                                    99,
                                    100
                                ];
                                viewportEntries = this.filterViewportEntries(filteredEntries);
                                return [
                                    4,
                                    (0, _percentileCalc.calculateTTVCPercentilesWithDebugInfo)({
                                        viewport: {
                                            width: (0, _getViewportWidthDefault.default)(),
                                            height: (0, _getViewportHeightDefault.default)()
                                        },
                                        startTime: startTime,
                                        stopTime: stopTime,
                                        orderedEntries: viewportEntries
                                    })
                                ];
                            case 1:
                                _ref = _state.sent(), vcLogs = _ref.entries, speedIndex = _ref.speedIndex;
                                vcDetails = {};
                                percentileIndex = 0;
                                entryDataBuffer = new Set();
                                ssrRatio = -1;
                                layoutShiftInsights = null;
                                previousViewportPercentage = 0;
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                if (vcLogs) try {
                                    for(_iterator = vcLogs[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        entry = _step.value;
                                        time = entry.time, viewportPercentage = entry.viewportPercentage, entries = entry.entries;
                                        if (includeSSRRatio && ssrRatio === -1 && entries.some(function(e) {
                                            return e.elementName === 'SSR';
                                        })) ssrRatio = viewportPercentage;
                                        // Only process entries if we haven't reached all percentiles
                                        if (percentileIndex >= percentiles.length) break;
                                        // Check if this entry matches any checkpoint percentiles
                                        if (viewportPercentage >= percentiles[percentileIndex]) {
                                            elementNames = (0, _toConsumableArray._)(new Set(entries.map(function(e) {
                                                return e.elementName;
                                            })));
                                            // Process all matching percentiles in one go
                                            while(percentileIndex < percentiles.length && viewportPercentage >= percentiles[percentileIndex]){
                                                vcDetails["".concat(percentiles[percentileIndex])] = {
                                                    t: Math.round(time),
                                                    e: elementNames
                                                };
                                                if (reportLayoutShiftOffenders && percentiles[percentileIndex] === 90 && entries.some(function(e) {
                                                    return e.type === 'layout-shift';
                                                })) {
                                                    layoutShiftEntries = entries.filter(function(e) {
                                                        return e.type === 'layout-shift';
                                                    });
                                                    layoutShiftInsights = {
                                                        layoutShiftOffendersResult: (0, _detectLayoutShiftCause.detectLayoutShiftCause)({
                                                            viewportEntries: viewportEntries,
                                                            layoutShiftEntries: layoutShiftEntries,
                                                            time: time,
                                                            startTime: startTime
                                                        }),
                                                        layoutShiftEntriesCount: layoutShiftEntries.length,
                                                        layoutShiftImpact: viewportPercentage - previousViewportPercentage
                                                    };
                                                }
                                                percentileIndex++;
                                            }
                                            // Clear buffer after processing all matching percentiles
                                            entryDataBuffer.clear();
                                        } else // Only add to buffer if we haven't reached all percentiles
                                        entries.forEach(function(e) {
                                            return entryDataBuffer.add(e);
                                        });
                                        previousViewportPercentage = viewportPercentage;
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                // Fill in any missing percentiles with the last known values
                                previousResult = {
                                    t: 0,
                                    e: []
                                };
                                for(i = 0; i < percentiles.length; i++){
                                    percentile = percentiles[i];
                                    if (!(percentile in vcDetails)) vcDetails["".concat(percentile)] = previousResult;
                                    else previousResult = vcDetails["".concat(percentile)];
                                }
                                enhancedVcLogs = vcLogs ? vcLogs.map(function(log) {
                                    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, log), {
                                        entries: log.entries.map(function(entry) {
                                            var _entry_rect, _entry_previousRect;
                                            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, entry), {
                                                rect: (_entry_rect = entry.rect) === null || _entry_rect === void 0 ? void 0 : _entry_rect.toJSON(),
                                                previousRect: (_entry_previousRect = entry.previousRect) === null || _entry_previousRect === void 0 ? void 0 : _entry_previousRect.toJSON()
                                            });
                                        }),
                                        viewportPercentage: log.viewportPercentage
                                    });
                                }) : [];
                                // If 3p metric enabled - calculate the debug details
                                shouldCalculate3p = include3p;
                                // Only calculate enhanced debug details if devtool callbacks exist
                                shouldCalculateDebugDetails = !isPostInteraction && (typeof ((_window = window) === null || _window === void 0 ? void 0 : _window.__ufo_devtool_onVCRevisionReady__) === 'function' || typeof ((_window1 = window) === null || _window1 === void 0 ? void 0 : _window1.__on_ufo_vc_debug_data_ready) === 'function' || typeof ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.__ufo_devtool_vc_3p_debug_data) === 'function');
                                if (shouldCalculateDebugDetails && allEntries && vcLogs) {
                                    // Pre-sort vcLogs by time for efficient lookups
                                    sortedVcLogs = (0, _toConsumableArray._)(vcLogs).sort(function(a, b) {
                                        return a.time - b.time;
                                    });
                                    // Pre-calculate max viewport percentage up to each time for efficient lookups
                                    maxViewportPercentageAtTime = new Map();
                                    maxSoFar = 0;
                                    _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                    try {
                                        for(_iterator1 = sortedVcLogs[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                            log = _step1.value;
                                            if (log.viewportPercentage !== null) {
                                                maxSoFar = Math.max(maxSoFar, log.viewportPercentage);
                                                maxViewportPercentageAtTime.set(log.time, maxSoFar);
                                            }
                                        }
                                    } catch (err) {
                                        _didIteratorError1 = true;
                                        _iteratorError1 = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                                _iterator1.return();
                                            }
                                        } finally{
                                            if (_didIteratorError1) {
                                                throw _iteratorError1;
                                            }
                                        }
                                    }
                                    // Helper function to find the biggest previous viewport percentage
                                    getBiggestPreviousViewportPercentage = function(targetTime) {
                                        // Binary search for the largest time <= targetTime
                                        var left = 0;
                                        var right = sortedVcLogs.length - 1;
                                        var result = -1;
                                        while(left <= right){
                                            var mid = Math.floor((left + right) / 2);
                                            if (sortedVcLogs[mid].time <= targetTime) {
                                                result = mid;
                                                left = mid + 1;
                                            } else right = mid - 1;
                                        }
                                        return result >= 0 ? maxViewportPercentageAtTime.get(sortedVcLogs[result].time) || null : null;
                                    };
                                    // Group ignored entries by timestamp
                                    ignoredEntriesByTime = new Map();
                                    _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                                    try {
                                        for(_iterator2 = allEntries[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                            entry1 = _step2.value;
                                            if ('rect' in entry1.data && !this.isEntryIncluded(entry1, include3p, excludeSmartAnswersInSearch)) {
                                                ;
                                                viewportData = entry1.data;
                                                timestamp = Math.round(entry1.time);
                                                if (!ignoredEntriesByTime.has(timestamp)) ignoredEntriesByTime.set(timestamp, []);
                                                (_ignoredEntriesByTime_get = ignoredEntriesByTime.get(timestamp)) === null || _ignoredEntriesByTime_get === void 0 ? void 0 : _ignoredEntriesByTime_get.push((0, _objectSpreadProps._)((0, _objectSpread._)({}, viewportData), {
                                                    rect: (_viewportData_rect = viewportData.rect) === null || _viewportData_rect === void 0 ? void 0 : _viewportData_rect.toJSON(),
                                                    previousRect: (_viewportData_previousRect = viewportData.previousRect) === null || _viewportData_previousRect === void 0 ? void 0 : _viewportData_previousRect.toJSON(),
                                                    ignoreReason: viewportData.visible ? viewportData.type : 'not-visible'
                                                }));
                                            }
                                        }
                                    } catch (err) {
                                        _didIteratorError2 = true;
                                        _iteratorError2 = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                                _iterator2.return();
                                            }
                                        } finally{
                                            if (_didIteratorError2) {
                                                throw _iteratorError2;
                                            }
                                        }
                                    }
                                    // Add ignored entries to vcLogs
                                    additionalVcLogs = [];
                                    _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                                    try {
                                        for(_iterator3 = ignoredEntriesByTime[Symbol.iterator](); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                                            _step_value = (0, _slicedToArray._)(_step3.value, 2), timestamp1 = _step_value[0], ignoredEntries = _step_value[1];
                                            if (ignoredEntries.length > 0) {
                                                viewportPercentage1 = getBiggestPreviousViewportPercentage(timestamp1);
                                                additionalVcLogs.push({
                                                    time: timestamp1,
                                                    viewportPercentage: viewportPercentage1,
                                                    entries: ignoredEntries
                                                });
                                            }
                                        }
                                    } catch (err) {
                                        _didIteratorError3 = true;
                                        _iteratorError3 = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                                                _iterator3.return();
                                            }
                                        } finally{
                                            if (_didIteratorError3) {
                                                throw _iteratorError3;
                                            }
                                        }
                                    }
                                    // Combine and sort all vcLogs
                                    enhancedVcLogs = (0, _toConsumableArray._)(enhancedVcLogs).concat((0, _toConsumableArray._)(additionalVcLogs)).sort(function(a, b) {
                                        return a.time - b.time;
                                    });
                                }
                                // Only create debug details if callbacks exist
                                v3RevisionDebugDetails = null;
                                if (shouldCalculateDebugDetails) v3RevisionDebugDetails = {
                                    revision: this.revisionNo,
                                    isClean: isVCClean && !interactionAbortReason && isPageVisible,
                                    abortReason: !isPageVisible ? 'browser_backgrounded' : dirtyReason !== null && dirtyReason !== void 0 ? dirtyReason : interactionAbortReason,
                                    vcLogs: enhancedVcLogs,
                                    interactionId: interactionId,
                                    interactionType: interactionType
                                };
                                // Handle devtool callback
                                if (v3RevisionDebugDetails && typeof ((_window3 = window) === null || _window3 === void 0 ? void 0 : _window3.__ufo_devtool_onVCRevisionReady__) === 'function' && !include3p) try {
                                    ;
                                    (_window5 = window) === null || _window5 === void 0 ? void 0 : (_window___ufo_devtool_onVCRevisionReady__ = _window5.__ufo_devtool_onVCRevisionReady__) === null || _window___ufo_devtool_onVCRevisionReady__ === void 0 ? void 0 : _window___ufo_devtool_onVCRevisionReady__.call(_window5, v3RevisionDebugDetails);
                                } catch (e) {
                                    // if any error communicating with devtool, we don't want to break the app
                                    // eslint-disable-next-line no-console
                                    console.error('Error in onVCRevisionReady', e);
                                }
                                if (v3RevisionDebugDetails && typeof ((_window4 = window) === null || _window4 === void 0 ? void 0 : _window4.__on_ufo_vc_debug_data_ready) === 'function' && !include3p) try {
                                    ;
                                    (_window6 = window) === null || _window6 === void 0 ? void 0 : (_window___on_ufo_vc_debug_data_ready = _window6.__on_ufo_vc_debug_data_ready) === null || _window___on_ufo_vc_debug_data_ready === void 0 ? void 0 : _window___on_ufo_vc_debug_data_ready.call(_window6, v3RevisionDebugDetails);
                                } catch (e) {
                                    // eslint-disable-next-line no-console
                                    console.error('Error in onVCRevisionReady', e);
                                }
                                if (v3RevisionDebugDetails && shouldCalculate3p) try {
                                    // Log vc details with 3p for debugging
                                    window.__ufo_devtool_vc_3p_debug_data = v3RevisionDebugDetails;
                                } catch (e) {
                                    // eslint-disable-next-line no-console
                                    console.error('Error in 3pDebugData', e);
                                }
                                return [
                                    2,
                                    {
                                        vcDetails: vcDetails,
                                        ssrRatio: ssrRatio,
                                        speedIndex: speedIndex,
                                        VC90layoutShiftInsights: layoutShiftInsights
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "calculate",
            value: function calculate(_0) {
                return (0, _asyncToGenerator._)(function(param) {
                    var _this, startTime, stopTime, orderedEntries, interactionId, isPostInteraction, include3p, excludeSmartAnswersInSearch, includeSSRRatio, interactionType, isPageVisible, interactionAbortReason, reportLayoutShiftOffenders, _vcDetails_90, filteredEntries, isVCClean, dirtyReason, getVCCleanStatusResult, _ref, vcDetails, ssrRatio, speedIndex, VC90layoutShiftInsights, layoutShiftInsightsPayload, layoutShiftOffendersResult, layoutShiftEntriesCount, layoutShiftImpact, _layoutShiftOffendersResult_layoutShiftVariables_allMovedSameWay, _layoutShiftOffendersResult_layoutShiftVariables_allMovedSameAmount, _layoutShiftOffendersResult_layoutShiftOffenders_length, _vcDetails_90_t, result;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                startTime = param.startTime, stopTime = param.stopTime, orderedEntries = param.orderedEntries, interactionId = param.interactionId, isPostInteraction = param.isPostInteraction, include3p = param.include3p, excludeSmartAnswersInSearch = param.excludeSmartAnswersInSearch, includeSSRRatio = param.includeSSRRatio, interactionType = param.interactionType, isPageVisible = param.isPageVisible, interactionAbortReason = param.interactionAbortReason, reportLayoutShiftOffenders = param.reportLayoutShiftOffenders;
                                filteredEntries = orderedEntries.filter(function(entry) {
                                    return _this.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch);
                                });
                                getVCCleanStatusResult = this.getVCCleanStatus(filteredEntries);
                                isVCClean = getVCCleanStatusResult.isVCClean;
                                dirtyReason = getVCCleanStatusResult.dirtyReason;
                                if (!isVCClean) return [
                                    2,
                                    {
                                        revision: this.revisionNo,
                                        'metric:vc90': null,
                                        clean: false,
                                        abortReason: dirtyReason,
                                        abortTimestamp: getVCCleanStatusResult.abortTimestamp
                                    }
                                ];
                                return [
                                    4,
                                    this.calculateWithDebugInfo(filteredEntries, startTime, stopTime, isPostInteraction, isVCClean, interactionType, isPageVisible, interactionId, dirtyReason, orderedEntries, include3p, excludeSmartAnswersInSearch, interactionAbortReason, includeSSRRatio, reportLayoutShiftOffenders)
                                ];
                            case 1:
                                _ref = _state.sent(), vcDetails = _ref.vcDetails, ssrRatio = _ref.ssrRatio, speedIndex = _ref.speedIndex, VC90layoutShiftInsights = _ref.VC90layoutShiftInsights;
                                if (VC90layoutShiftInsights !== null && reportLayoutShiftOffenders) {
                                    layoutShiftOffendersResult = VC90layoutShiftInsights.layoutShiftOffendersResult, layoutShiftEntriesCount = VC90layoutShiftInsights.layoutShiftEntriesCount, layoutShiftImpact = VC90layoutShiftInsights.layoutShiftImpact;
                                    ;
                                    layoutShiftInsightsPayload = {
                                        impact: layoutShiftImpact,
                                        sources: layoutShiftEntriesCount !== null && layoutShiftEntriesCount !== void 0 ? layoutShiftEntriesCount : 0,
                                        same: {
                                            dir: (_layoutShiftOffendersResult_layoutShiftVariables_allMovedSameWay = layoutShiftOffendersResult === null || layoutShiftOffendersResult === void 0 ? void 0 : layoutShiftOffendersResult.layoutShiftVariables.allMovedSameWay) !== null && _layoutShiftOffendersResult_layoutShiftVariables_allMovedSameWay !== void 0 ? _layoutShiftOffendersResult_layoutShiftVariables_allMovedSameWay : false,
                                            dist: (_layoutShiftOffendersResult_layoutShiftVariables_allMovedSameAmount = layoutShiftOffendersResult === null || layoutShiftOffendersResult === void 0 ? void 0 : layoutShiftOffendersResult.layoutShiftVariables.allMovedSameAmount) !== null && _layoutShiftOffendersResult_layoutShiftVariables_allMovedSameAmount !== void 0 ? _layoutShiftOffendersResult_layoutShiftVariables_allMovedSameAmount : false
                                        },
                                        total_mut: (_layoutShiftOffendersResult_layoutShiftOffenders_length = layoutShiftOffendersResult === null || layoutShiftOffendersResult === void 0 ? void 0 : layoutShiftOffendersResult.layoutShiftOffenders.length) !== null && _layoutShiftOffendersResult_layoutShiftOffenders_length !== void 0 ? _layoutShiftOffendersResult_layoutShiftOffenders_length : 0,
                                        mut: layoutShiftOffendersResult === null || layoutShiftOffendersResult === void 0 ? void 0 : layoutShiftOffendersResult.layoutShiftOffenders.sort(function(a, b) {
                                            return Math.abs(a.distanceToLS) - Math.abs(b.distanceToLS);
                                        }).slice(0, 5).map(function(offender) {
                                            return {
                                                e: offender.offender,
                                                size: -1,
                                                attr: {
                                                    t_before: offender.happenedBefore,
                                                    t_distance: offender.distanceToLS,
                                                    p_above: offender.isAbove,
                                                    p_left: offender.isLeft,
                                                    p_right: offender.isRight,
                                                    p_h_overlap: offender.hasHorizontalOverlap,
                                                    p_v_overlap: offender.hasVerticalOverlap,
                                                    p_same_offset: offender.matchesLayoutShiftDelta ? 'all' : 'none'
                                                }
                                            };
                                        })
                                    };
                                }
                                result = {
                                    revision: this.revisionNo,
                                    clean: true,
                                    'metric:vc90': (_vcDetails_90_t = vcDetails === null || vcDetails === void 0 ? void 0 : (_vcDetails_90 = vcDetails['90']) === null || _vcDetails_90 === void 0 ? void 0 : _vcDetails_90.t) !== null && _vcDetails_90_t !== void 0 ? _vcDetails_90_t : null,
                                    vcDetails: vcDetails !== null && vcDetails !== void 0 ? vcDetails : undefined,
                                    'vc90:ls': layoutShiftInsightsPayload !== null && layoutShiftInsightsPayload !== void 0 ? layoutShiftInsightsPayload : undefined
                                };
                                result.ratios = this.calculateRatios(filteredEntries);
                                if (ssrRatio !== -1) result.ssrRatio = ssrRatio;
                                // speedIndex is only included in the result when it has a meaningful value (> 0)
                                if (speedIndex > 0) result.speedIndex = speedIndex;
                                result.labelStacks = this.getLabelStacks(filteredEntries, isPostInteraction);
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        }
    ]);
    return AbstractVCCalculatorBase;
}();

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_to_consumable_array":"1eSZf","@swc/helpers/_/_ts_generator":"78Tqx","./percentile-calc":"d24pC","./utils/detect-layout-shift-cause":"aHM0N","./utils/get-viewport-height":"fuG5Y","./utils/get-viewport-width":"lY1vD","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"d24pC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateTTVCPercentiles", function() {
    return 0, _canvasHeatmapDefault.default;
});
parcelHelpers.export(exports, "calculateTTVCPercentilesWithDebugInfo", function() {
    return 0, _canvasHeatmap.calculateTTVCPercentilesWithDebugInfo;
});
var _canvasHeatmap = require("./canvas-heatmap");
var _canvasHeatmapDefault = parcelHelpers.interopDefault(_canvasHeatmap);

},{"./canvas-heatmap":"akz13","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"akz13":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculatePercentiles", function() {
    return calculatePercentiles;
});
parcelHelpers.export(exports, "calculatePercentilesWithDebugInfo", function() {
    return calculatePercentilesWithDebugInfo;
});
parcelHelpers.export(exports, "calculateTTVCPercentilesWithDebugInfo", function() {
    return calculateTTVCPercentilesWithDebugInfo;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _canvasPixel = require("./canvas-pixel");
function calculateTTVCPercentiles(_0) {
    return (0, _asyncToGenerator._)(function(param) {
        var viewport, orderedEntries, percentiles, startTime, canvas, elementMap, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, entry, rect, elementName, timePixelCounts, canvasDimenstions, totalPixels;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    viewport = param.viewport, orderedEntries = param.orderedEntries, percentiles = param.percentiles, startTime = param.startTime;
                    canvas = new (0, _canvasPixel.ViewportCanvas)(viewport, (0, _platformFeatureFlags.fg)('platform_ufo_canvas_heatmap_full_precision') ? 1 : 0.25);
                    elementMap = new Map();
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(_iterator = orderedEntries[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            entry = _step.value;
                            if (!('rect' in entry.data)) continue;
                            rect = entry.data.rect;
                            elementName = entry.data.elementName;
                            canvas.drawRect(rect, entry.time);
                            if (!elementMap.has(entry.time)) elementMap.set(entry.time, new Set());
                            elementMap.get(entry.time).add(elementName);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return [
                        4,
                        canvas.getPixelCounts()
                    ];
                case 1:
                    timePixelCounts = _state.sent();
                    canvasDimenstions = canvas.getScaledDimensions();
                    totalPixels = canvasDimenstions.width * canvasDimenstions.height;
                    return [
                        2,
                        calculatePercentiles(timePixelCounts, elementMap, percentiles, totalPixels, startTime)
                    ];
            }
        });
    }).apply(this, arguments);
}
function calculateTTVCPercentilesWithDebugInfo(_0) {
    return (0, _asyncToGenerator._)(function(param) {
        var viewport, orderedEntries, startTime, canvas, elementMap, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, entry, rect, timePixelCounts, canvasDimensions, totalPixels;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    viewport = param.viewport, orderedEntries = param.orderedEntries, startTime = param.startTime;
                    canvas = new (0, _canvasPixel.ViewportCanvas)(viewport, (0, _platformFeatureFlags.fg)('platform_ufo_canvas_heatmap_full_precision') ? 1 : 0.25);
                    elementMap = new Map();
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(_iterator = orderedEntries[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            entry = _step.value;
                            if (!('rect' in entry.data)) continue;
                            rect = entry.data.rect;
                            canvas.drawRect(rect, entry.time);
                            if (!elementMap.has(entry.time)) elementMap.set(entry.time, []);
                            elementMap.get(entry.time).push(entry.data);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return [
                        4,
                        canvas.getPixelCounts()
                    ];
                case 1:
                    timePixelCounts = _state.sent();
                    canvasDimensions = canvas.getScaledDimensions();
                    totalPixels = canvasDimensions.width * canvasDimensions.height;
                    return [
                        2,
                        calculatePercentilesWithDebugInfo(timePixelCounts, elementMap, totalPixels, startTime)
                    ];
            }
        });
    }).apply(this, arguments);
}
exports.default = calculateTTVCPercentiles;
function calculatePercentiles(timePixelCounts, elementMap, unorderedPercentiles, totalPixels, startTime) {
    var results = {};
    var cumulativePixels = 0;
    var percentiles = unorderedPercentiles.sort(function(a, b) {
        return a - b;
    });
    // Sort entries by timestamp for consistent processing
    var sortedEntries = Array.from(timePixelCounts.entries()).sort(function(param, param1) {
        var _param = (0, _slicedToArray._)(param, 1), timeA = _param[0], _param1 = (0, _slicedToArray._)(param1, 1), timeB = _param1[0];
        return Number(timeA) - Number(timeB);
    });
    var percentileIndex = 0;
    var domElementsBuffer = new Set();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = sortedEntries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, _slicedToArray._)(_step.value, 2), time = _step_value[0], pixelCount = _step_value[1];
            cumulativePixels += pixelCount;
            var percentCovered = cumulativePixels / totalPixels * 100;
            var elementNames = elementMap.get(time) || new Set();
            elementNames.forEach(function(elName) {
                return domElementsBuffer.add(elName);
            });
            var matchesAnyCheckpoints = false;
            while(percentileIndex < percentiles.length && percentCovered >= percentiles[percentileIndex]){
                results["".concat(percentiles[percentileIndex])] = {
                    t: Math.round(Number(time - startTime)),
                    e: Array.from(domElementsBuffer)
                };
                percentileIndex++;
                matchesAnyCheckpoints = true;
            }
            if (matchesAnyCheckpoints) domElementsBuffer.clear();
            if (percentileIndex >= percentiles.length) break;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var previousResult = {
        t: 0,
        e: []
    };
    for(var i = 0; i < percentiles.length; i++){
        var percentile = percentiles[i];
        if (!(percentile in results)) results["".concat(percentile)] = previousResult;
        previousResult = results["".concat(percentile)];
    }
    return results;
}
function calculatePercentilesWithDebugInfo(timePixelCounts, elementMap, totalPixels, startTime) {
    var entries = new Array(elementMap.size);
    var cumulativePixels = 0;
    var speedIndex = 0;
    var previousPercentCovered = 0;
    var sortedEntries = Array.from(timePixelCounts.entries()).sort(function(param, param1) {
        var _param = (0, _slicedToArray._)(param, 1), timeA = _param[0], _param1 = (0, _slicedToArray._)(param1, 1), timeB = _param1[0];
        return Number(timeA) - Number(timeB);
    });
    for(var i = 0; i < sortedEntries.length; i++){
        var _sortedEntries_i = (0, _slicedToArray._)(sortedEntries[i], 2), time = _sortedEntries_i[0], pixelCount = _sortedEntries_i[1];
        cumulativePixels += pixelCount;
        var percentCovered = cumulativePixels / totalPixels * 100;
        var entryDatas = elementMap.get(time) || [];
        var relativeTime = Math.round(Number(time - startTime));
        entries[i] = {
            time: relativeTime,
            viewportPercentage: percentCovered,
            entries: Array.from(entryDatas)
        };
        // Speed index calculation: sum of (time × incremental viewport percentage)
        var ratioDelta = (percentCovered - previousPercentCovered) / 100;
        speedIndex += relativeTime * ratioDelta;
        previousPercentCovered = percentCovered;
    }
    return {
        entries: entries,
        speedIndex: Math.round(speedIndex)
    };
}

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_ts_generator":"78Tqx","@atlaskit/platform-feature-flags":"kO5t9","./canvas-pixel":"b98Pp","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"b98Pp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ViewportCanvas", function() {
    return ViewportCanvas;
});
/**
 * Converts a number into RGB components in such a way that they can be recombined
 * to form the original number using bitwise operations.
 * @param number - The input number to be split into RGB components.
 * @returns The RGB color string in the format "rgb(r, g, b)".
 */ parcelHelpers.export(exports, "getRGBComponents", function() {
    return getRGBComponents;
});
/**
 * Calculates the number of pixels drawn for each color in the image data.
 * @param imageData - The image data to analyze.
 * @param scaleFactor - The scale factor applied to the canvas.
 * @param arraySize - The amount of timestamps that were drawn in the viewport
 * @returns A Map containing color to pixel count mappings.
 */ parcelHelpers.export(exports, "calculateDrawnPixelsRaw", function() {
    return calculateDrawnPixelsRaw;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _taskYield = require("../../utils/task-yield");
var _taskYieldDefault = parcelHelpers.interopDefault(_taskYield);
var ViewportCanvas = /*#__PURE__*/ function() {
    "use strict";
    function ViewportCanvas(viewport) {
        var scaleFactor = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
        (0, _classCallCheck._)(this, ViewportCanvas);
        this.scaleFactor = scaleFactor;
        this.colorCounter = 1;
        this.colorTimeMap = new Map();
        var safeViewportWidth = Math.max(viewport.width, 1);
        var safeViewportHeight = Math.max(viewport.height, 1);
        // Calculate scaled dimensions
        this.scaledWidth = Math.max(Math.ceil(safeViewportWidth * scaleFactor), 1);
        this.scaledHeight = Math.max(Math.ceil(safeViewportHeight * scaleFactor), 1);
        this.scaleX = this.scaledWidth / safeViewportWidth;
        this.scaleY = this.scaledHeight / safeViewportHeight;
        // Initialize canvas with scaled dimensions
        this.canvas = this.createCanvas(this.scaledWidth, this.scaledHeight);
        var ctx = this.canvas.getContext('2d', {
            alpha: false,
            willReadFrequently: true,
            colorSpace: 'srgb'
        });
        if (!ctx) throw new Error('Could not get canvas context');
        this.ctx = ctx;
        this.ctx.globalCompositeOperation = 'source-over';
        this.ctx.imageSmoothingEnabled = false; // Disable image smoothing for better performance
        this.clear();
    }
    (0, _createClass._)(ViewportCanvas, [
        {
            key: "createCanvas",
            value: /**
	 * Creates a canvas instance, falling back to HTMLCanvasElement if OffscreenCanvas is not available
	 */ function createCanvas(width, height) {
                if (typeof OffscreenCanvas !== 'undefined') return new OffscreenCanvas(width, height);
                var canvas = document.createElement('canvas');
                canvas.width = width;
                canvas.height = height;
                return canvas;
            }
        },
        {
            key: "getScaledDimensions",
            value: function getScaledDimensions() {
                return {
                    width: this.scaledWidth,
                    height: this.scaledHeight
                };
            }
        },
        {
            key: "clear",
            value: /**
	 * Clears the entire canvas by removing all drawn content.
	 * @private
	 */ function clear() {
                this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
            }
        },
        {
            key: "generateColor",
            value: /**
	 * Generates a unique RGB color from an incrementing counter.
	 * Uses a 24-bit color space (16,777,216 possible colors).
	 *
	 * @private
	 * @returns A unique RGB color string
	 *
	 * @example
	 * // Example bit operations for color 0x00FF8040:
	 * // Red:   (0x00FF8040 >> 16) & 0xFF = 0xFF = 255
	 * // Green: (0x00FF8040 >> 8) & 0xFF  = 0x80 = 128
	 * // Blue:   0x00FF8040 & 0xFF        = 0x40 = 64
	 */ function generateColor() {
                // Wrap around at 16,777,215 (0x00FFFFFF) to stay within 24-bit color space
                var rgbColor = this.colorCounter++ % 0x00ffffff;
                return getRGBComponents(rgbColor);
            }
        },
        {
            key: "drawRect",
            value: /**
	 * Draws a rectangle on the canvas with a unique color and associates it with a timestamp.
	 * Each drawn rectangle gets a unique color which is mapped to the provided timestamp.
	 *
	 * @param rect - The rectangle dimensions to draw
	 * @param timestamp - The timestamp to associate with this drawing operation
	 */ function drawRect(rect, timestamp) {
                var color = this.generateColor();
                this.colorTimeMap.set(color, timestamp);
                this.ctx.fillStyle = color;
                if (this.scaleFactor === 1) return this.ctx.fillRect(rect.x, rect.y, rect.width, rect.height);
                var scaledX = rect.x * this.scaleX;
                var scaledY = rect.y * this.scaleY;
                var scaledWidth = rect.width * this.scaleX;
                var scaledHeight = rect.height * this.scaleY;
                this.ctx.fillRect(Math.floor(scaledX), Math.ceil(scaledY), Math.max(scaledWidth, 1), Math.max(scaledHeight, 1));
            }
        },
        {
            key: "getPixelCounts",
            value: /**
	 * Calculates the number of pixels drawn for each timestamp.
	 * This method:
	 * 1. Reads the pixel data from the canvas
	 * 2. Counts pixels of each unique color
	 * 3. Maps colors back to their timestamps
	 * 4. Adjusts counts based on the scale factor
	 *
	 * @returns A Map containing timestamp to pixel count mappings
	 */ function getPixelCounts() {
                return (0, _asyncToGenerator._)(function() {
                    var imageData, timestampsAmount, pixelCounts, timePixelCounts, i, count, color, rgbColor, timestamp;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                imageData = this.ctx.getImageData(0, 0, this.canvas.width, this.canvas.height);
                                timestampsAmount = this.colorTimeMap.size;
                                return [
                                    4,
                                    calculateDrawnPixelsRaw(imageData, this.scaleFactor, timestampsAmount)
                                ];
                            case 1:
                                pixelCounts = _state.sent();
                                // Convert color counts to timestamp counts
                                timePixelCounts = new Map();
                                for(i = 0; i < pixelCounts.length; i++){
                                    count = pixelCounts[i];
                                    if (typeof count !== 'number') continue;
                                    color = i + 1;
                                    rgbColor = getRGBComponents(color);
                                    timestamp = this.colorTimeMap.get(rgbColor);
                                    if (timestamp !== undefined) timePixelCounts.set(timestamp, (timePixelCounts.get(timestamp) || 0) + count);
                                }
                                return [
                                    2,
                                    timePixelCounts
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ViewportCanvas;
}();
function getRGBComponents(n) {
    // Ensure the input is within the valid range for a 24-bit color
    if (n < 0 || n > 0xffffff) throw new Error('Input number must be between 0 and 16777215 (inclusive).');
    // Extract blue component (bits 0-7)
    var blue = n & 0xff;
    // Extract green component (bits 8-15)
    var green = n >> 8 & 0xff;
    // Extract red component (bits 16-23)
    var red = n >> 16 & 0xff;
    return "rgb(".concat(red, ", ").concat(green, ", ").concat(blue, ")");
}
function calculateDrawnPixelsRaw(imageData, _, arraySize) {
    return (0, _asyncToGenerator._)(function() {
        var data, arr, i, color, colorIndex;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    data = imageData.data;
                    arr = new Uint32Array(arraySize);
                    i = 0;
                    _state.label = 1;
                case 1:
                    if (!(i < data.length)) return [
                        3,
                        4
                    ];
                    // Check alpha
                    if (data[i + 3] !== 0) {
                        // Combine RGB components into a single 24-bit color value:
                        // (data[i] << 16)   - Shift red component left 16 bits   (bits 16-23)
                        // (data[i + 1] << 8) - Shift green component left 8 bits (bits 8-15)
                        // data[i + 2]       - Blue component stays as is         (bits 0-7)
                        // The | operator combines all bits together
                        color = data[i] << 16 | data[i + 1] << 8 | data[i + 2];
                        colorIndex = color - 1;
                        arr[colorIndex] = (arr[colorIndex] || 0) + 1;
                    }
                    if (!(i % 10000 === 0)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        (0, _taskYieldDefault.default)()
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    i += 4;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2,
                        arr
                    ];
            }
        });
    })();
}

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_ts_generator":"78Tqx","../../utils/task-yield":"fKeBT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fKeBT":[function(require,module,exports,__globalThis) {
// See https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
function taskYield() {
    return (0, _asyncToGenerator._)(function() {
        var resolve, p;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!('scheduler' in globalThis && // @ts-ignore
                    'yield' in globalThis.scheduler)) return [
                        3,
                        2
                    ];
                    // @ts-ignore
                    return [
                        4,
                        scheduler.yield()
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
                case 2:
                    resolve = function() {};
                    p = new Promise(function(a) {
                        resolve = a;
                    });
                    setTimeout(resolve, 0);
                    return [
                        4,
                        p
                    ];
                case 3:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
}
exports.default = taskYield;

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_ts_generator":"78Tqx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aHM0N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "detectLayoutShiftCause", function() {
    return detectLayoutShiftCause;
});
var calculateOffenderState = function(current, matchesCurrentEntry) {
    // Once we know it's mixed across entries, we can short-circuit.
    if (current === 'some') return 'some';
    var entryState = matchesCurrentEntry ? 'all' : 'none';
    if (current == null) return entryState;
    // If the state flips between entries (all <-> none), it's "some".
    if (current !== entryState) return 'some';
    return current;
};
var calculateLayoutShiftMovement = function(layoutShiftEntries) {
    var movements = layoutShiftEntries.map(function(lsEntry) {
        var rect = lsEntry.rect;
        var previousRect = lsEntry.previousRect;
        if (!rect || !previousRect) return null;
        var dx = rect.x - previousRect.x;
        var dy = rect.y - previousRect.y;
        return {
            dx: dx,
            dy: dy,
            movedX: dx !== 0,
            movedY: dy !== 0,
            dirX: Math.sign(dx),
            dirY: Math.sign(dy),
            absDx: Math.abs(dx),
            absDy: Math.abs(dy)
        };
    });
    var hasMovement = function(m) {
        return m !== null;
    };
    var validMovements = movements.filter(hasMovement);
    var allHaveRects = layoutShiftEntries.length > 0 && validMovements.length === layoutShiftEntries.length;
    if (!allHaveRects) return {
        allHaveRects: allHaveRects,
        allMovedSameWay: false,
        allMovedSameAmount: false
    };
    var first = validMovements[0];
    var allMovedSameWay = validMovements.every(function(m) {
        return m.movedX === first.movedX && m.movedY === first.movedY && m.dirX === first.dirX && m.dirY === first.dirY;
    });
    var allMovedSameAmount = allMovedSameWay && validMovements.every(function(m) {
        return m.absDx === first.absDx && m.absDy === first.absDy;
    });
    return {
        allHaveRects: allHaveRects,
        allMovedSameWay: allMovedSameWay,
        allMovedSameAmount: allMovedSameAmount,
        deltaX: first.dx,
        deltaY: first.dy
    };
};
var detectLayoutShiftCause = function(param) {
    var viewportEntries = param.viewportEntries, layoutShiftEntries = param.layoutShiftEntries, time = param.time, startTime = param.startTime, _param_offenderWindowMs = param.offenderWindowMs, offenderWindowMs = _param_offenderWindowMs === void 0 ? 250 : _param_offenderWindowMs;
    var checkpointTimestamp = startTime + time;
    var filteredLSPotentialOffenders = viewportEntries.filter(function(viewportEntry) {
        return (viewportEntry.time < checkpointTimestamp && viewportEntry.time > checkpointTimestamp - offenderWindowMs || viewportEntry.time > checkpointTimestamp && viewportEntry.time < checkpointTimestamp + offenderWindowMs) && viewportEntry.data.type !== 'layout-shift';
    });
    // Summarize whether all layout-shift entries moved in a consistent direction and by the same amount.
    var layoutShiftVariables = calculateLayoutShiftMovement(layoutShiftEntries);
    // Classify each offender against *all* layout-shift entries when the layout shift is consistently moving in a
    // single axis (pure X or pure Y) so we can reason about whether an offender could have caused the movement.
    var layoutShiftOffenders = filteredLSPotentialOffenders.reduce(function(acc, offender) {
        var offenderData = offender.data;
        var offenderRect = offenderData.rect;
        if (!offenderRect) return acc;
        var _offenderData_originalMutationTimestamp;
        var offenderTimestamp = (_offenderData_originalMutationTimestamp = offenderData.originalMutationTimestamp) !== null && _offenderData_originalMutationTimestamp !== void 0 ? _offenderData_originalMutationTimestamp : offender.time;
        var happenedBefore = offenderTimestamp <= checkpointTimestamp;
        var offenderLeft = offenderRect.x;
        var offenderRight = offenderRect.x + offenderRect.width;
        var offenderTop = offenderRect.y;
        var offenderBottom = offenderRect.y + offenderRect.height;
        var shouldClassifyAgainstAllEntries = layoutShiftVariables.allMovedSameWay && 'deltaX' in layoutShiftVariables && 'deltaY' in layoutShiftVariables && layoutShiftVariables.deltaX === 0 !== (layoutShiftVariables.deltaY === 0);
        var isAbove = null;
        var isLeft = null;
        var isRight = null;
        var hasHorizontalOverlap = null;
        var hasVerticalOverlap = null;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (shouldClassifyAgainstAllEntries) try {
            for(var _iterator = layoutShiftEntries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var lsEntry = _step.value;
                var lsRect = lsEntry.rect;
                if (!lsRect) continue;
                var lsLeft = lsRect.x;
                var lsRight = lsRect.x + lsRect.width;
                var lsTop = lsRect.y;
                var lsBottom = lsRect.y + lsRect.height;
                isAbove = calculateOffenderState(isAbove, offenderBottom <= lsTop);
                isLeft = calculateOffenderState(isLeft, offenderRight <= lsLeft);
                isRight = calculateOffenderState(isRight, offenderLeft >= lsRight);
                hasHorizontalOverlap = calculateOffenderState(hasHorizontalOverlap, offenderLeft < lsRight && offenderRight > lsLeft);
                hasVerticalOverlap = calculateOffenderState(hasVerticalOverlap, offenderTop < lsBottom && offenderBottom > lsTop);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var matchesLayoutShiftDelta = false;
        if (shouldClassifyAgainstAllEntries && layoutShiftVariables.allMovedSameAmount && offenderData.previousRect) {
            var dx = offenderRect.x - offenderData.previousRect.x;
            var dy = offenderRect.y - offenderData.previousRect.y;
            var isPureX = layoutShiftVariables.deltaX !== 0 && layoutShiftVariables.deltaY === 0;
            var isPureY = layoutShiftVariables.deltaY !== 0 && layoutShiftVariables.deltaX === 0;
            if (isPureX) matchesLayoutShiftDelta = dx === layoutShiftVariables.deltaX && dy === 0;
            else if (isPureY) matchesLayoutShiftDelta = dy === layoutShiftVariables.deltaY && dx === 0;
        }
        acc.push({
            offender: offenderData.elementName,
            happenedBefore: happenedBefore,
            distanceToLS: Math.round(offenderTimestamp - checkpointTimestamp),
            isAbove: isAbove !== null && isAbove !== void 0 ? isAbove : 'none',
            isLeft: isLeft !== null && isLeft !== void 0 ? isLeft : 'none',
            isRight: isRight !== null && isRight !== void 0 ? isRight : 'none',
            hasHorizontalOverlap: hasHorizontalOverlap !== null && hasHorizontalOverlap !== void 0 ? hasHorizontalOverlap : 'none',
            hasVerticalOverlap: hasVerticalOverlap !== null && hasVerticalOverlap !== void 0 ? hasVerticalOverlap : 'none',
            matchesLayoutShiftDelta: matchesLayoutShiftDelta
        });
        return acc;
    }, []);
    return {
        layoutShiftVariables: layoutShiftVariables,
        layoutShiftOffenders: layoutShiftOffenders
    };
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fuG5Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function getViewportHeight() {
    var document = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.document;
    var documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch (e) {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}
exports.default = getViewportHeight;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lY1vD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function getViewportWidth() {
    var document = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.document;
    var documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch (e) {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}
exports.default = getViewportWidth;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fGnX3":[function(require,module,exports,__globalThis) {
// TODO: AFO-3523
// Those are the attributes we have found when testing the 'fy25.03' manually.
// We still need to replace this hardcoded list with a proper automation
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "KNOWN_ATTRIBUTES_THAT_DOES_NOT_CAUSE_LAYOUT_SHIFTS", function() {
    return KNOWN_ATTRIBUTES_THAT_DOES_NOT_CAUSE_LAYOUT_SHIFTS;
});
parcelHelpers.export(exports, "NON_VISUAL_ARIA_ATTRIBUTES", function() {
    return NON_VISUAL_ARIA_ATTRIBUTES;
});
parcelHelpers.export(exports, "THIRD_PARTY_BROWSER_EXTENSION_ATTRIBUTES", function() {
    return THIRD_PARTY_BROWSER_EXTENSION_ATTRIBUTES;
});
parcelHelpers.export(exports, "MORE_THIRD_PARTY_EXTENSION_ATTRIBUTES", function() {
    return MORE_THIRD_PARTY_EXTENSION_ATTRIBUTES;
});
parcelHelpers.export(exports, "DARK_READER_BROWSER_EXTENSION_ATTRIBUTES", function() {
    return DARK_READER_BROWSER_EXTENSION_ATTRIBUTES;
});
var KNOWN_ATTRIBUTES_THAT_DOES_NOT_CAUSE_LAYOUT_SHIFTS = [
    'data-drop-target-for-element',
    'data-drop-target-for-external',
    'draggable',
    'data-is-observed',
    'data-aui-version',
    'data-testid',
    'data-vc',
    'data-ssr-placeholder',
    'data-ssr-placeholder-replace',
    'data-vc-nvs',
    'data-media-vc-wrapper',
    'data-renderer-start-pos',
    'data-table-local-id',
    'spellcheck',
    'data-auto-scrollable',
    'id',
    'tabindex',
    'data-is-ttvc-ready',
    'contenteditable',
    'data-has-collab-initialised',
    'translate',
    'data-comment-id'
];
var NON_VISUAL_ARIA_ATTRIBUTES = [
    'aria-label',
    'aria-labelledby',
    'aria-describedby',
    'aria-hidden',
    'aria-expanded',
    'aria-controls',
    'aria-selected',
    'aria-checked',
    'aria-disabled',
    'aria-required',
    'aria-current',
    'aria-haspopup',
    'aria-pressed',
    'aria-atomic',
    'aria-live'
];
var THIRD_PARTY_BROWSER_EXTENSION_ATTRIBUTES = [
    'bis_skin_checked',
    'cz-shortcut-listen',
    'monica-version',
    'data-gr-ext-installed',
    'data-dashlane-rid',
    'sapling-installed',
    'data-gptw',
    // grammarly extensions
    'data-new-gr-c-s-loaded',
    'data-gr-aaa-notch-connection-id',
    'data-gr-aaa-loaded'
];
var MORE_THIRD_PARTY_EXTENSION_ATTRIBUTES = [
    'fdprocessedid',
    'data-dashlane-classification'
];
var DARK_READER_BROWSER_EXTENSION_ATTRIBUTES = [
    // dark reader extension
    'data-darkreader-inline-bgcolor',
    'data-darkreader-inline-bgimage',
    'data-darkreader-inline-border',
    'data-darkreader-inline-border-bottom',
    'data-darkreader-inline-border-left',
    'data-darkreader-inline-border-right',
    'data-darkreader-inline-border-top',
    'data-darkreader-inline-boxshadow',
    'data-darkreader-inline-color',
    'data-darkreader-inline-fill',
    'data-darkreader-inline-stroke',
    'data-darkreader-inline-outline',
    'data-darkreader-inline-stopcolor',
    'data-darkreader-inline-bg',
    'data-darkreader-inline-border-short',
    'data-darkreader-inline-border-bottom-short',
    'data-darkreader-inline-border-left-short',
    'data-darkreader-inline-border-right-short',
    'data-darkreader-inline-border-top-short'
];

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kvOc1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isViewportEntryData(data) {
    if (data) {
        var hasElementName = typeof data.elementName === 'string';
        var hasRect = typeof data.rect !== 'undefined';
        if (hasRect && hasElementName) return true;
    }
    return false;
}
exports.default = isViewportEntryData;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lcK2n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return VCCalculator_FY26_04;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _get = require("@swc/helpers/_/_get");
var _getPrototypeOf = require("@swc/helpers/_/_get_prototype_of");
var _inherits = require("@swc/helpers/_/_inherits");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _fy2503 = require("../fy25_03");
var _fy2503Default = parcelHelpers.interopDefault(_fy2503);
var _constants = require("../utils/constants");
var getConsideredEntryTypes = function() {
    var consideredEntryTypes = [
        'mutation:display-contents-children-element'
    ];
    consideredEntryTypes.push('mutation:display-contents-children-attribute');
    return consideredEntryTypes;
};
var getExcludedEntryTypes = function() {
    var excludedEntryTypes = [
        'layout-shift:same-rect',
        'mutation:attribute:non-visual-input-name'
    ];
    return excludedEntryTypes;
};
var fy26_04_excluded_attributes = [
    'data-is-hovered'
];
var VCCalculator_FY26_04 = /*#__PURE__*/ function(VCCalculator_FY25_03) {
    "use strict";
    (0, _inherits._)(VCCalculator_FY26_04, VCCalculator_FY25_03);
    function VCCalculator_FY26_04() {
        var revisionNo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'fy26.04';
        (0, _classCallCheck._)(this, VCCalculator_FY26_04);
        return (0, _callSuper._)(this, VCCalculator_FY26_04, [
            revisionNo
        ]);
    }
    (0, _createClass._)(VCCalculator_FY26_04, [
        {
            key: "isEntryIncluded",
            value: function isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
                var extra_fy26_04_excluded_attributes = (0, _platformFeatureFlags.fg)('platform_ufo_ignore_data_fabric_mode') ? [
                    'data-fabric-mode'
                ] : [];
                var entryData = entry.data;
                var attributeName = entryData.attributeName;
                if (entry.data.type === 'mutation:attribute' && attributeName && extra_fy26_04_excluded_attributes.includes(attributeName)) return false;
                var isEntryIncludedInV3 = (0, _get._)((0, _getPrototypeOf._)(VCCalculator_FY26_04.prototype), "isEntryIncluded", this).call(this, entry, include3p, excludeSmartAnswersInSearch);
                if (isEntryIncludedInV3 && !getExcludedEntryTypes().includes(entry.data.type)) return true;
                if (entry.data.type === 'mutation:attribute' && (!attributeName || fy26_04_excluded_attributes.includes(attributeName) && (0, _platformFeatureFlags.fg)('platform_ufo_data-is-hovered-v4-exclusion'))) return false;
                var thirdPartyAttributes = (0, _toConsumableArray._)((0, _constants.THIRD_PARTY_BROWSER_EXTENSION_ATTRIBUTES)).concat((0, _toConsumableArray._)((0, _platformFeatureFlags.fg)('platform_ufo_exclude_dark_reader_extension') ? (0, _constants.DARK_READER_BROWSER_EXTENSION_ATTRIBUTES) : []), (0, _toConsumableArray._)((0, _platformFeatureFlags.fg)('platform_ufo_exclude_fdprocessedid_attribute') ? (0, _constants.MORE_THIRD_PARTY_EXTENSION_ATTRIBUTES) : []));
                if (entryData.type === 'mutation:display-contents-children-attribute') {
                    if (!attributeName || attributeName.startsWith('data-test') || (0, _constants.KNOWN_ATTRIBUTES_THAT_DOES_NOT_CAUSE_LAYOUT_SHIFTS).includes(attributeName) || (0, _constants.NON_VISUAL_ARIA_ATTRIBUTES).includes(attributeName) || thirdPartyAttributes.includes(attributeName)) return false;
                    return true;
                }
                return getConsideredEntryTypes().includes(entry.data.type);
            }
        }
    ]);
    return VCCalculator_FY26_04;
}((0, _fy2503Default.default));

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_get":"38TLD","@swc/helpers/_/_get_prototype_of":"5txK6","@swc/helpers/_/_inherits":"2sfqW","@swc/helpers/_/_to_consumable_array":"1eSZf","@atlaskit/platform-feature-flags":"kO5t9","../fy25_03":"gZahN","../utils/constants":"fGnX3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"csGNx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return VCCalculator_Next;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _get = require("@swc/helpers/_/_get");
var _getPrototypeOf = require("@swc/helpers/_/_get_prototype_of");
var _inherits = require("@swc/helpers/_/_inherits");
var _fy2604 = require("../fy26_04");
var _fy2604Default = parcelHelpers.interopDefault(_fy2604);
var ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize',
    'scroll-container'
];
var getConsideredEntryTypes = function() {
    var consideredEntryTypes = [];
    return consideredEntryTypes;
};
var getExcludedEntryTypes = function() {
    var excludedEntryTypes = [];
    return excludedEntryTypes;
};
var VCCalculator_Next = /*#__PURE__*/ function(VCCalculator_FY26_04) {
    "use strict";
    (0, _inherits._)(VCCalculator_Next, VCCalculator_FY26_04);
    function VCCalculator_Next() {
        (0, _classCallCheck._)(this, VCCalculator_Next);
        return (0, _callSuper._)(this, VCCalculator_Next, [
            'next'
        ]);
    }
    (0, _createClass._)(VCCalculator_Next, [
        {
            key: "isEntryIncluded",
            value: function isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
                var isEntryIncludedInV4 = (0, _get._)((0, _getPrototypeOf._)(VCCalculator_Next.prototype), "isEntryIncluded", this).call(this, entry, include3p, excludeSmartAnswersInSearch);
                if (isEntryIncludedInV4 && !getExcludedEntryTypes().includes(entry.data.type)) return true;
                return getConsideredEntryTypes().includes(entry.data.type);
            }
        },
        {
            key: "getVCCleanStatus",
            value: function getVCCleanStatus(filteredEntries) {
                var dirtyReason = '';
                var abortTimestamp = -1;
                var hasAbortEvent = filteredEntries.some(function(entry) {
                    if (entry.data.type === 'window:event') {
                        var data = entry.data;
                        var eventType = data.eventType;
                        if (ABORTING_WINDOW_EVENT.includes(eventType)) {
                            if (eventType === 'keydown') dirtyReason = 'keypress';
                            else if (eventType === 'scroll-container') dirtyReason = 'scroll';
                            else dirtyReason = eventType;
                            abortTimestamp = Math.round(entry.time);
                            return true;
                        }
                    }
                    return false;
                });
                if (hasAbortEvent && dirtyReason) return {
                    isVCClean: false,
                    dirtyReason: dirtyReason,
                    abortTimestamp: abortTimestamp
                };
                return {
                    isVCClean: true
                };
            }
        }
    ]);
    return VCCalculator_Next;
}((0, _fy2604Default.default));

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_get":"38TLD","@swc/helpers/_/_get_prototype_of":"5txK6","@swc/helpers/_/_inherits":"2sfqW","../fy26_04":"lcK2n","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dyEU1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return RawDataHandler;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _config = require("../../../config");
var _hiddenTiming = require("../../../hidden-timing");
var _getViewportHeight = require("../metric-calculator/utils/get-viewport-height");
var _getViewportHeightDefault = parcelHelpers.interopDefault(_getViewportHeight);
var _getViewportWidth = require("../metric-calculator/utils/get-viewport-width");
var _getViewportWidthDefault = parcelHelpers.interopDefault(_getViewportWidth);
var ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize'
];
var MAX_OBSERVATIONS = 200;
var encodeRect = function(rect) {
    return [
        Math.round(rect.left * 10) / 10,
        Math.round(rect.top * 10) / 10,
        Math.round(rect.right * 10) / 10,
        Math.round(rect.bottom * 10) / 10
    ];
};
var areRectsEqual = function(left, right) {
    return left.every(function(value, index) {
        return value === right[index];
    });
};
function isWindowEventEntryData(data) {
    return data.type === 'window:event' && 'eventType' in data;
}
var RawDataHandler = /*#__PURE__*/ function() {
    "use strict";
    function RawDataHandler() {
        (0, _classCallCheck._)(this, RawDataHandler);
        this.revisionNo = 'raw-handler';
    }
    (0, _createClass._)(RawDataHandler, [
        {
            key: "getVCCleanStatus",
            value: function getVCCleanStatus(filteredEntries) {
                var dirtyReason = '';
                var abortTimestamp = -1;
                var hasAbortEvent = filteredEntries.some(function(entry) {
                    if (entry.data.type === 'window:event') {
                        var data = entry.data;
                        var eventType = data.eventType;
                        if (ABORTING_WINDOW_EVENT.includes(eventType)) {
                            dirtyReason = eventType === 'keydown' ? 'keypress' : eventType;
                            abortTimestamp = Math.round(entry.time);
                            return true;
                        }
                    }
                    return false;
                });
                if (hasAbortEvent && dirtyReason) return {
                    isVCClean: false,
                    dirtyReason: dirtyReason,
                    abortTimestamp: abortTimestamp
                };
                return {
                    isVCClean: true
                };
            }
        },
        {
            key: "getRawData",
            value: function getRawData(_0) {
                return (0, _asyncToGenerator._)(function(param) {
                    var entries, startTime, stopTime, isPageVisible, isVCClean, dirtyReason, getVCCleanStatusResult, _getEarliestHiddenTiming, viewportEntries, windowEventEntries, targetNameToIdMap, elementMapEntriesMap, nextElementId, typeMap, typeMapEntriesMap, nextTypeId, attributeMap, attributeEntriesMap, nextAttributeId, eventTypeMap, eventTypeMapEntriesMap, nextEventTypeId, labelStacksMap, rawObservations, rawEventObservations, firstObservation, lastObservations, ssrEid, ssrObservation, ssrAlreadyIncluded, referencedEids, referencedChgs, referencedAtts, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, observation, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, eid, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, chg, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, att, firstEventObservation, lastEventObservations, referencedEvts, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, observation1, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, evt, isFedrampScrubbed, scrubbedObservations, result;
                    return (0, _tsGenerator._)(this, function(_state) {
                        entries = param.entries, startTime = param.startTime, stopTime = param.stopTime, isPageVisible = param.isPageVisible;
                        getVCCleanStatusResult = this.getVCCleanStatus(entries);
                        isVCClean = getVCCleanStatusResult.isVCClean;
                        dirtyReason = getVCCleanStatusResult.dirtyReason;
                        if (!isPageVisible) return [
                            2,
                            {
                                revision: this.revisionNo,
                                clean: false,
                                'metric:vc90': null,
                                abortReason: 'browser_backgrounded',
                                abortTimestamp: (_getEarliestHiddenTiming = (0, _hiddenTiming.getEarliestHiddenTiming)(startTime, stopTime)) !== null && _getEarliestHiddenTiming !== void 0 ? _getEarliestHiddenTiming : -1,
                                viewport: {
                                    w: (0, _getViewportWidthDefault.default)(),
                                    h: (0, _getViewportHeightDefault.default)()
                                }
                            }
                        ];
                        viewportEntries = entries.filter(function(entry) {
                            return entry.time >= startTime && entry.time <= stopTime && entry.data && entry.data.visible;
                        });
                        windowEventEntries = entries.filter(function(entry) {
                            return entry.time >= startTime && entry.time <= stopTime && entry.data && isWindowEventEntryData(entry.data);
                        });
                        targetNameToIdMap = new Map();
                        elementMapEntriesMap = {};
                        nextElementId = 1;
                        typeMap = new Map();
                        typeMapEntriesMap = {};
                        nextTypeId = 1;
                        attributeMap = new Map();
                        attributeEntriesMap = {};
                        nextAttributeId = 1;
                        eventTypeMap = new Map();
                        eventTypeMapEntriesMap = {};
                        nextEventTypeId = 1;
                        labelStacksMap = {};
                        rawObservations = viewportEntries.map(function(entry) {
                            var viewportEntry = entry.data;
                            var targetName = viewportEntry.elementName || '';
                            var type = viewportEntry.type || '';
                            var rect = viewportEntry.rect;
                            var attributeName = viewportEntry.attributeName || '';
                            var eid = targetNameToIdMap.get(viewportEntry.elementName || '') || 0;
                            if (eid === 0) {
                                eid = nextElementId;
                                nextElementId += 1;
                                targetNameToIdMap.set(targetName, eid);
                                elementMapEntriesMap[eid] = targetName;
                            }
                            // Capture labelStacks per element (only stored once per unique element)
                            if (viewportEntry.labelStacks && !(eid in labelStacksMap)) {
                                var labelInfo = {
                                    s: viewportEntry.labelStacks.segment,
                                    l: viewportEntry.labelStacks.labelStack
                                };
                                var shouldCompactImplicitUnknown = labelInfo.s === 'unknown' && labelInfo.l === 'unknown';
                                labelStacksMap[eid] = shouldCompactImplicitUnknown ? 'u' : labelInfo;
                            }
                            var chg = typeMap.get(type || '') || 0;
                            if (chg === 0) {
                                chg = nextTypeId;
                                nextTypeId += 1;
                                typeMap.set(type, chg);
                                typeMapEntriesMap[chg] = type;
                            }
                            var att = 0;
                            if (attributeName) {
                                att = attributeMap.get(attributeName) || 0;
                                if (att === 0) {
                                    att = nextAttributeId;
                                    nextAttributeId += 1;
                                    attributeMap.set(attributeName, att);
                                    attributeEntriesMap[att] = attributeName;
                                }
                            }
                            var encodedRect = encodeRect(rect);
                            var encodedPreviousRect = viewportEntry.previousRect ? encodeRect(viewportEntry.previousRect) : null;
                            var shouldIncludePreviousRect = encodedPreviousRect === null || !areRectsEqual(encodedRect, encodedPreviousRect);
                            var observation = (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({
                                t: Math.round(entry.time - startTime),
                                r: encodedRect
                            }, shouldIncludePreviousRect ? {
                                pr: encodedPreviousRect
                            } : {}), {
                                chg: chg,
                                eid: eid || 0
                            }), att > 0 ? {
                                att: att
                            } : {});
                            return observation;
                        });
                        rawEventObservations = windowEventEntries.map(function(entry) {
                            var windowEventEntry = entry.data;
                            var eventType = windowEventEntry.eventType;
                            var evtId = eventTypeMap.get(eventType) || 0;
                            if (evtId === 0) {
                                evtId = nextEventTypeId;
                                nextEventTypeId += 1;
                                eventTypeMap.set(eventType, evtId);
                                eventTypeMapEntriesMap[evtId] = eventType;
                            }
                            var eventObservation = {
                                t: Math.round(entry.time - startTime),
                                evt: evtId
                            };
                            return eventObservation;
                        });
                        // If the number of observations is greater than the maximum allowed, we need to trim the observations to the maximum allowed.
                        // We do this by keeping the first observation, the SSR observation (if present), and the last MAX_OBSERVATIONS observations.
                        // We then collect the referenced IDs from the remaining observations and remove the unreferenced entries from the maps
                        if (rawObservations.length > MAX_OBSERVATIONS) {
                            firstObservation = rawObservations[0];
                            lastObservations = rawObservations.slice(-MAX_OBSERVATIONS);
                            // Find the SSR observation by looking up the eid that corresponds to 'SSR' element name
                            ssrEid = targetNameToIdMap.get('SSR');
                            ssrObservation = ssrEid ? rawObservations.find(function(obs) {
                                return obs.eid === ssrEid && obs !== firstObservation;
                            }) : undefined;
                            // Include SSR observation if it exists and is not already in the kept observations
                            ssrAlreadyIncluded = ssrObservation && lastObservations.some(function(obs) {
                                return obs === ssrObservation;
                            });
                            rawObservations = [
                                firstObservation
                            ].concat((0, _toConsumableArray._)(ssrObservation && !ssrAlreadyIncluded ? [
                                ssrObservation
                            ] : []), (0, _toConsumableArray._)(lastObservations));
                            // Collect referenced IDs from remaining observations
                            referencedEids = new Set();
                            referencedChgs = new Set();
                            referencedAtts = new Set();
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(_iterator = rawObservations[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    observation = _step.value;
                                    if (observation.eid > 0) referencedEids.add(observation.eid);
                                    if (typeof observation.chg === 'number' && observation.chg > 0) referencedChgs.add(observation.chg);
                                    if (observation.att !== undefined && observation.att > 0) referencedAtts.add(observation.att);
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            try {
                                // Remove unreferenced entries from maps
                                for(_iterator1 = Object.keys(elementMapEntriesMap).map(Number)[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                    eid = _step1.value;
                                    if (!referencedEids.has(eid)) {
                                        delete elementMapEntriesMap[eid];
                                        delete labelStacksMap[eid];
                                    }
                                }
                            } catch (err) {
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                        _iterator1.return();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                            }
                            _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                            try {
                                for(_iterator2 = Object.keys(typeMapEntriesMap).map(Number)[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                    chg = _step2.value;
                                    if (!referencedChgs.has(chg)) delete typeMapEntriesMap[chg];
                                }
                            } catch (err) {
                                _didIteratorError2 = true;
                                _iteratorError2 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                        _iterator2.return();
                                    }
                                } finally{
                                    if (_didIteratorError2) {
                                        throw _iteratorError2;
                                    }
                                }
                            }
                            _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                            try {
                                for(_iterator3 = Object.keys(attributeEntriesMap).map(Number)[Symbol.iterator](); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                                    att = _step3.value;
                                    if (!referencedAtts.has(att)) delete attributeEntriesMap[att];
                                }
                            } catch (err) {
                                _didIteratorError3 = true;
                                _iteratorError3 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                                        _iterator3.return();
                                    }
                                } finally{
                                    if (_didIteratorError3) {
                                        throw _iteratorError3;
                                    }
                                }
                            }
                        }
                        // If the number of event observations is greater than the maximum allowed, we need to trim the event observations to the maximum allowed.
                        // We do this by keeping the first observation and the last MAX_OBSERVATIONS observations.
                        // We then collect the referenced IDs from the remaining observations and remove the unreferenced entries from the maps
                        if (rawEventObservations.length > MAX_OBSERVATIONS) {
                            firstEventObservation = rawEventObservations[0];
                            lastEventObservations = rawEventObservations.slice(-MAX_OBSERVATIONS);
                            rawEventObservations = [
                                firstEventObservation
                            ].concat((0, _toConsumableArray._)(lastEventObservations));
                            // Collect referenced IDs from remaining observations
                            referencedEvts = new Set();
                            _iteratorNormalCompletion4 = true, _didIteratorError4 = false, _iteratorError4 = undefined;
                            try {
                                for(_iterator4 = rawEventObservations[Symbol.iterator](); !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true){
                                    observation1 = _step4.value;
                                    if (observation1.evt > 0) referencedEvts.add(observation1.evt);
                                }
                            } catch (err) {
                                _didIteratorError4 = true;
                                _iteratorError4 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                                        _iterator4.return();
                                    }
                                } finally{
                                    if (_didIteratorError4) {
                                        throw _iteratorError4;
                                    }
                                }
                            }
                            _iteratorNormalCompletion5 = true, _didIteratorError5 = false, _iteratorError5 = undefined;
                            try {
                                // Remove unreferenced entries from maps
                                for(_iterator5 = Object.keys(eventTypeMapEntriesMap).map(Number)[Symbol.iterator](); !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true){
                                    evt = _step5.value;
                                    if (!referencedEvts.has(evt)) delete eventTypeMapEntriesMap[evt];
                                }
                            } catch (err) {
                                _didIteratorError5 = true;
                                _iteratorError5 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
                                        _iterator5.return();
                                    }
                                } finally{
                                    if (_didIteratorError5) {
                                        throw _iteratorError5;
                                    }
                                }
                            }
                        }
                        // FedRAMP-Moderate scrubbing.
                        //
                        // In commercial environments the raw-handler payload includes:
                        //   - `rawData.att` / `obs[].att`  → DOM attribute names from
                        //     `MutationRecord.attributeName`. These are *names* (not values),
                        //     but custom product attributes can in principle embed
                        //     identifiers (e.g. `data-user-{id}-state`).
                        //   - `rawData.lbl`                → UFO labelStacks. Generally
                        //     curated product paths but in poorly-instrumented call sites
                        //     could embed dynamic identifiers.
                        //
                        // Server-side TTVC reconstruction does not require these fields
                        // (it is driven by timestamps, rectangles, and mutation kind),
                        // so dropping them in FedRAMP is safe and removes residual PII risk.
                        isFedrampScrubbed = (0, _config.isFedrampOverrideActive)();
                        scrubbedObservations = isFedrampScrubbed ? rawObservations.map(function(_param) {
                            var _att = _param.att, rest = (0, _objectWithoutProperties._)(_param, [
                                "att"
                            ]);
                            return rest;
                        }) : rawObservations;
                        result = {
                            revision: this.revisionNo,
                            clean: isVCClean,
                            'metric:vc90': null,
                            rawData: {
                                obs: scrubbedObservations !== null && scrubbedObservations !== void 0 ? scrubbedObservations : undefined,
                                eid: elementMapEntriesMap !== null && elementMapEntriesMap !== void 0 ? elementMapEntriesMap : undefined,
                                chg: typeMapEntriesMap !== null && typeMapEntriesMap !== void 0 ? typeMapEntriesMap : undefined,
                                att: isFedrampScrubbed ? undefined : attributeEntriesMap !== null && attributeEntriesMap !== void 0 ? attributeEntriesMap : undefined,
                                evts: rawEventObservations.length > 0 ? rawEventObservations : undefined,
                                evt: Object.keys(eventTypeMapEntriesMap).length > 0 ? eventTypeMapEntriesMap : undefined,
                                lbl: isFedrampScrubbed ? undefined : Object.keys(labelStacksMap).length > 0 ? labelStacksMap : undefined,
                                lblMode: isFedrampScrubbed ? undefined : Object.keys(labelStacksMap).length > 0 ? 'sentinel-v1' : undefined
                            },
                            abortReason: dirtyReason,
                            abortTimestamp: getVCCleanStatusResult.abortTimestamp,
                            viewport: {
                                w: (0, _getViewportWidthDefault.default)(),
                                h: (0, _getViewportHeightDefault.default)()
                            }
                        };
                        return [
                            2,
                            result
                        ];
                    });
                }).apply(this, arguments);
            }
        }
    ]);
    return RawDataHandler;
}();

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","@swc/helpers/_/_to_consumable_array":"1eSZf","@swc/helpers/_/_ts_generator":"78Tqx","../../../config":"1BZI5","../../../hidden-timing":"lV0ww","../metric-calculator/utils/get-viewport-height":"fuG5Y","../metric-calculator/utils/get-viewport-width":"lY1vD","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fXAxE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return ViewportObserver;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _vcUtils = require("../../vc-observer/media-wrapper/vc-utils");
var _isDndStyleMutation = require("../../vc-observer/observers/non-visual-styles/is-dnd-style-mutation");
var _isDndStyleMutationDefault = parcelHelpers.interopDefault(_isDndStyleMutation);
var _isNonVisualStyleMutation = require("../../vc-observer/observers/non-visual-styles/is-non-visual-style-mutation");
var _isNonVisualStyleMutationDefault = parcelHelpers.interopDefault(_isNonVisualStyleMutation);
var _isPdndAttribute = require("../../vc-observer/observers/non-visual-styles/is-pdnd-attribute");
var _isPdndAttributeDefault = parcelHelpers.interopDefault(_isPdndAttribute);
var _rllPlaceholders = require("../../vc-observer/observers/rll-placeholders");
var _intersectionObserver = require("./intersection-observer");
var _mutationObserver = require("./mutation-observer");
var _mutationObserverDefault = parcelHelpers.interopDefault(_mutationObserver);
var _performanceObserver = require("./performance-observer");
var _performanceObserverDefault = parcelHelpers.interopDefault(_performanceObserver);
var _checkWithinComponent = require("./utils/check-within-component");
var _checkWithinComponentDefault = parcelHelpers.interopDefault(_checkWithinComponent);
var _isContainedWithinSmartAnswers = require("./utils/is-contained-within-smart-answers");
var _isElementVisible = require("./utils/is-element-visible");
var _isInVcIgnoreIfNoLayoutShiftMarker = require("./utils/is-in-vc-ignore-if-no-layout-shift-marker");
var _isInVcIgnoreIfNoLayoutShiftMarkerDefault = parcelHelpers.interopDefault(_isInVcIgnoreIfNoLayoutShiftMarker);
var _isInputNameMutation = require("./utils/is-input-name-mutation");
var _isSameRectDimensions = require("./utils/is-same-rect-dimensions");
var _isSameRectSize = require("./utils/is-same-rect-size");
var createElementMutationsWatcher = function(removedNodeRects, isWithinThirdPartySegment, isWithinSmartAnswersSegment, hasSameDeletedNode, timestamp, isTargetReactRoot, getSSRState, getSSRPlaceholderHandler) {
    return function(param) {
        var target = param.target, rect = param.rect;
        if (getSSRState) {
            var ssrState = getSSRState();
            var SSRStateEnum = {
                normal: 1,
                waitingForFirstRender: 2,
                ignoring: 3
            };
            if (ssrState.state === SSRStateEnum.waitingForFirstRender && timestamp > ssrState.renderStart && isTargetReactRoot) {
                ssrState.state = SSRStateEnum.ignoring;
                if (ssrState.renderStop === -1) // arbitrary 500ms DOM update window
                ssrState.renderStop = timestamp + 500;
                return 'ssr-hydration';
            }
            if (ssrState.state === SSRStateEnum.ignoring && timestamp > ssrState.renderStart && isTargetReactRoot) {
                if (timestamp <= ssrState.renderStop) return 'ssr-hydration';
                else ssrState.state = SSRStateEnum.normal;
            }
        }
        if (getSSRPlaceholderHandler) {
            var ssrPlaceholderHandler = getSSRPlaceholderHandler();
            if (ssrPlaceholderHandler) {
                if ((ssrPlaceholderHandler.isPlaceholderV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.checkIfExistedAndSizeMatchingV3(target)) return 'mutation:ssr-placeholder';
                if ((ssrPlaceholderHandler.isPlaceholderReplacementV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.validateReactComponentMatchToPlaceholderV4(target)) return 'mutation:ssr-placeholder';
            }
        }
        if (hasSameDeletedNode && (0, _isInVcIgnoreIfNoLayoutShiftMarkerDefault.default)(target)) return 'mutation:remount';
        if ((0, _vcUtils.isContainedWithinMediaWrapper)(target)) return 'mutation:media';
        if (isWithinThirdPartySegment) return 'mutation:third-party-element';
        if (isWithinSmartAnswersSegment) return 'mutation:smart-answers-element';
        var isInIgnoreLsMarker = (0, _isInVcIgnoreIfNoLayoutShiftMarkerDefault.default)(target);
        if (!isInIgnoreLsMarker) return 'mutation:element';
        var isRLLPlaceholder = (0, _rllPlaceholders.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
        if (isRLLPlaceholder && isInIgnoreLsMarker) return 'mutation:rll-placeholder';
        var wasDeleted = removedNodeRects.some(function(nr) {
            return (0, _isSameRectDimensions.isSameRectDimensions)(nr, rect);
        });
        if (wasDeleted && isInIgnoreLsMarker) return 'mutation:element-replacement';
        return 'mutation:element';
    };
};
var createElementMutationsWatcherNew = function(removedNodeRects, isWithinThirdPartySegment, isWithinSmartAnswersSegment, hasSameDeletedNode, timestamp, isTargetReactRoot, getSSRState, getSSRPlaceholderHandler) {
    return function(param) {
        var target = param.target, rect = param.rect;
        if (getSSRState) {
            var ssrState = getSSRState();
            var SSRStateEnum = {
                normal: 1,
                waitingForFirstRender: 2,
                ignoring: 3
            };
            if (ssrState.state === SSRStateEnum.waitingForFirstRender && timestamp > ssrState.renderStart && isTargetReactRoot) {
                ssrState.state = SSRStateEnum.ignoring;
                if (ssrState.renderStop === -1) // arbitrary 500ms DOM update window
                ssrState.renderStop = timestamp + 500;
                return {
                    type: 'ssr-hydration',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
            }
            if (ssrState.state === SSRStateEnum.ignoring && timestamp > ssrState.renderStart && isTargetReactRoot) {
                if (timestamp <= ssrState.renderStop) return {
                    type: 'ssr-hydration',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
                else ssrState.state = SSRStateEnum.normal;
            }
        }
        if (getSSRPlaceholderHandler) {
            var ssrPlaceholderHandler = getSSRPlaceholderHandler();
            if (ssrPlaceholderHandler) {
                if ((ssrPlaceholderHandler.isPlaceholderV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.checkIfExistedAndSizeMatchingV3(target)) return {
                    type: 'mutation:ssr-placeholder',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
                if ((ssrPlaceholderHandler.isPlaceholderReplacementV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.validateReactComponentMatchToPlaceholderV4(target)) return {
                    type: 'mutation:ssr-placeholder',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
            }
        }
        if (hasSameDeletedNode && (0, _isInVcIgnoreIfNoLayoutShiftMarkerDefault.default)(target)) return {
            type: 'mutation:remount',
            mutationData: {
                timestamp: timestamp
            }
        };
        if ((0, _vcUtils.isContainedWithinMediaWrapper)(target)) return {
            type: 'mutation:media',
            mutationData: {
                timestamp: timestamp
            }
        };
        if (isWithinThirdPartySegment) return {
            type: 'mutation:third-party-element',
            mutationData: {
                timestamp: timestamp
            }
        };
        if (isWithinSmartAnswersSegment) return {
            type: 'mutation:smart-answers-element',
            mutationData: {
                timestamp: timestamp
            }
        };
        var isInIgnoreLsMarker = (0, _isInVcIgnoreIfNoLayoutShiftMarkerDefault.default)(target);
        if (!isInIgnoreLsMarker) return {
            type: 'mutation:element',
            mutationData: {
                timestamp: timestamp
            }
        };
        var isRLLPlaceholder = (0, _rllPlaceholders.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
        if (isRLLPlaceholder && isInIgnoreLsMarker) return {
            type: 'mutation:rll-placeholder',
            mutationData: {
                timestamp: timestamp
            }
        };
        var wasDeleted = removedNodeRects.some(function(nr) {
            return (0, _isSameRectDimensions.isSameRectDimensions)(nr, rect);
        });
        if (wasDeleted && isInIgnoreLsMarker) return {
            type: 'mutation:element-replacement',
            mutationData: {
                timestamp: timestamp
            }
        };
        return {
            type: 'mutation:element',
            mutationData: {
                timestamp: timestamp
            }
        };
    };
};
var ViewportObserver = /*#__PURE__*/ function() {
    "use strict";
    function ViewportObserver(param) {
        var _this = this;
        var onChange = param.onChange, getSSRState = param.getSSRState, getSSRPlaceholderHandler = param.getSSRPlaceholderHandler, _param_trackLayoutShiftOffenders = param.trackLayoutShiftOffenders, trackLayoutShiftOffenders = _param_trackLayoutShiftOffenders === void 0 ? false : _param_trackLayoutShiftOffenders, searchPageConfig = param.searchPageConfig;
        (0, _classCallCheck._)(this, ViewportObserver);
        this.handleIntersectionEntry = function(param) {
            var target = param.target, rect = param.rect, time = param.time, type = param.type, mutationData = param.mutationData;
            if (!target) return;
            var visible = (0, _isElementVisible.isElementVisible)(target);
            var lastElementRect = _this.mapVisibleNodeRects.get(target);
            _this.mapVisibleNodeRects.set(target, rect);
            _this.onChange({
                time: time,
                type: type,
                elementRef: new WeakRef(target),
                visible: visible,
                rect: rect,
                previousRect: lastElementRect,
                mutationData: mutationData
            });
        };
        this.handleChildListMutation = function(param) {
            var target = param.target, addedNodes = param.addedNodes, removedNodes = param.removedNodes, timestamp = param.timestamp;
            return (0, _asyncToGenerator._)(function() {
                var _this, removedNodeRects, targetNode, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _this1, _loop, _iterator, _step;
                return (0, _tsGenerator._)(this, function(_state) {
                    _this = this;
                    removedNodeRects = removedNodes.map(function(ref) {
                        var n = ref.deref();
                        if (!n) return;
                        return _this.mapVisibleNodeRects.get(n);
                    });
                    targetNode = target.deref();
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        _loop = function() {
                            var addedNodeRef = _step.value;
                            var _this_getSSRState, _this_getSSRState1, _this, _this_intersectionObserver;
                            var addedNode = addedNodeRef.deref();
                            if (!addedNode) return "continue";
                            var hasSameDeletedNode = removedNodes.find(function(ref) {
                                var n = ref.deref();
                                if (!n || !addedNode) return false;
                                return n.isEqualNode(addedNode);
                            });
                            var _checkWithinComponent = (0, _checkWithinComponentDefault.default)(addedNode, 'UFOThirdPartySegment', _this1.mapIs3pResult), isWithinThirdPartySegment = _checkWithinComponent.isWithin;
                            var isWithinSmartAnswersSegment = Boolean(_this1.shouldCheckSmartAnswersMutations() && (0, _isContainedWithinSmartAnswers.isContainedWithinSmartAnswers)(addedNode));
                            var isTargetReactRoot = targetNode === ((_this_getSSRState1 = (_this = _this1).getSSRState) === null || _this_getSSRState1 === void 0 ? void 0 : (_this_getSSRState = _this_getSSRState1.call(_this)) === null || _this_getSSRState === void 0 ? void 0 : _this_getSSRState.reactRootElement);
                            (_this_intersectionObserver = _this1.intersectionObserver) === null || _this_intersectionObserver === void 0 ? void 0 : _this_intersectionObserver.watchAndTag(addedNode, (_this1.trackLayoutShiftOffenders ? createElementMutationsWatcherNew : createElementMutationsWatcher)(removedNodeRects, isWithinThirdPartySegment, isWithinSmartAnswersSegment, !!hasSameDeletedNode, timestamp, isTargetReactRoot, _this1.getSSRState, _this1.getSSRPlaceholderHandler));
                        };
                        for(_iterator = addedNodes[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_this1 = this, _loop();
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return [
                        2
                    ];
                });
            }).call(_this);
        };
        this.handleAttributeMutation = function(param) {
            var target = param.target, attributeName = param.attributeName, oldValue = param.oldValue, newValue = param.newValue, timestamp = param.timestamp;
            var _this_intersectionObserver;
            (_this_intersectionObserver = _this.intersectionObserver) === null || _this_intersectionObserver === void 0 ? void 0 : _this_intersectionObserver.watchAndTag(target, function(param) {
                var target = param.target, rect = param.rect;
                if ((0, _vcUtils.isContainedWithinMediaWrapper)(target)) return {
                    type: 'mutation:media',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                var _checkWithinComponent = (0, _checkWithinComponentDefault.default)(target, 'UFOThirdPartySegment', _this.mapIs3pResult), isWithinThirdPartySegment = _checkWithinComponent.isWithin;
                if (isWithinThirdPartySegment) return {
                    type: 'mutation:third-party-attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if (_this.shouldCheckSmartAnswersMutations() && (0, _isContainedWithinSmartAnswers.isContainedWithinSmartAnswers)(target)) return {
                    type: 'mutation:smart-answers-attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue
                    }
                };
                if ((0, _isDndStyleMutationDefault.default)({
                    target: target,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                })) return {
                    type: 'mutation:attribute:non-visual-style',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if ((0, _isNonVisualStyleMutationDefault.default)({
                    target: target,
                    attributeName: attributeName,
                    type: 'attributes'
                })) return {
                    type: 'mutation:attribute:non-visual-style',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                // Pragmatic Drag and Drop attributes added during post-paint
                // registration; do not affect layout or paint.
                if ((0, _isPdndAttributeDefault.default)({
                    target: target,
                    attributeName: attributeName
                }) && (0, _platformFeatureFlags.fg)('platform_ufo_exclude_pdnd_attributes_from_vc')) return {
                    type: 'mutation:attribute:non-visual-style',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if ((0, _isInputNameMutation.isInputNameMutation)({
                    target: target,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                })) return {
                    type: 'mutation:attribute:non-visual-input-name',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                var isRLLPlaceholder = (0, _rllPlaceholders.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
                if (isRLLPlaceholder) return {
                    type: 'mutation:rll-placeholder',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                var lastElementRect = _this.mapVisibleNodeRects.get(target);
                if (lastElementRect && (0, _isSameRectSize.isSameRectSize)(rect, lastElementRect)) return {
                    type: 'mutation:attribute:no-layout-shift',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                return {
                    type: 'mutation:attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
            });
        };
        this.handleLayoutShift = function(param) {
            var time = param.time, changedRects = param.changedRects;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = changedRects[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var changedRect = _step.value;
                    var target = changedRect.node;
                    if (target) {
                        var isSameCurrentAndPreviousRects = (0, _isSameRectDimensions.isSameRectDimensions)(changedRect.rect, changedRect.previousRect);
                        _this.onChange({
                            time: time,
                            elementRef: new WeakRef(target),
                            visible: true,
                            rect: changedRect.rect,
                            previousRect: changedRect.previousRect,
                            type: isSameCurrentAndPreviousRects ? 'layout-shift:same-rect' : 'layout-shift'
                        });
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        };
        this.shouldCheckSmartAnswersMutations = function() {
            var _this_searchPageConfig, _this_searchPageConfig1, _window_location, _window;
            return ((_this_searchPageConfig = _this.searchPageConfig) === null || _this_searchPageConfig === void 0 ? void 0 : _this_searchPageConfig.enableSmartAnswersMutations) && ((_this_searchPageConfig1 = _this.searchPageConfig) === null || _this_searchPageConfig1 === void 0 ? void 0 : _this_searchPageConfig1.searchPageRoute) && ((_window = window) === null || _window === void 0 ? void 0 : (_window_location = _window.location) === null || _window_location === void 0 ? void 0 : _window_location.pathname) && window.location.pathname === _this.searchPageConfig.searchPageRoute;
        };
        this.mapVisibleNodeRects = new WeakMap();
        this.mapIs3pResult = new WeakMap();
        this.onChange = onChange;
        this.isStarted = false;
        this.intersectionObserver = null;
        this.mutationObserver = null;
        this.performanceObserver = null;
        this.trackLayoutShiftOffenders = trackLayoutShiftOffenders;
        // Initialize SSR context functions
        this.getSSRState = getSSRState;
        this.getSSRPlaceholderHandler = getSSRPlaceholderHandler;
        this.searchPageConfig = searchPageConfig;
    }
    (0, _createClass._)(ViewportObserver, [
        {
            key: "initializeObservers",
            value: function initializeObservers() {
                if (this.isStarted) return;
                this.intersectionObserver = (0, _intersectionObserver.createIntersectionObserver)({
                    onEntry: this.handleIntersectionEntry
                });
                this.mutationObserver = (0, _mutationObserverDefault.default)({
                    onChildListMutation: this.handleChildListMutation,
                    onAttributeMutation: this.handleAttributeMutation
                });
                this.performanceObserver = (0, _performanceObserverDefault.default)({
                    onLayoutShift: this.handleLayoutShift
                });
            }
        },
        {
            key: "start",
            value: function start() {
                var _this_mutationObserver, _this_performanceObserver;
                if (this.isStarted) return;
                this.initializeObservers();
                (_this_mutationObserver = this.mutationObserver) === null || _this_mutationObserver === void 0 ? void 0 : _this_mutationObserver.observe(document.body, {
                    attributeOldValue: true,
                    attributes: true,
                    childList: true,
                    subtree: true
                });
                (_this_performanceObserver = this.performanceObserver) === null || _this_performanceObserver === void 0 ? void 0 : _this_performanceObserver.observe({
                    type: 'layout-shift',
                    buffered: true,
                    // @ts-ignore -error
                    durationThreshold: 30
                });
                this.isStarted = true;
            }
        },
        {
            key: "stop",
            value: function stop() {
                var _this_mutationObserver, _this_intersectionObserver, _this_performanceObserver;
                if (!this.isStarted) return;
                (_this_mutationObserver = this.mutationObserver) === null || _this_mutationObserver === void 0 ? void 0 : _this_mutationObserver.disconnect();
                (_this_intersectionObserver = this.intersectionObserver) === null || _this_intersectionObserver === void 0 ? void 0 : _this_intersectionObserver.disconnect();
                (_this_performanceObserver = this.performanceObserver) === null || _this_performanceObserver === void 0 ? void 0 : _this_performanceObserver.disconnect();
                this.isStarted = false;
                // Clean up caches when stopping
                (0, _checkWithinComponent.cleanupCaches)(this.mapIs3pResult);
            }
        }
    ]);
    return ViewportObserver;
}();

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_ts_generator":"78Tqx","@atlaskit/platform-feature-flags":"kO5t9","../../vc-observer/media-wrapper/vc-utils":"1GvIy","../../vc-observer/observers/non-visual-styles/is-dnd-style-mutation":"1SaMe","../../vc-observer/observers/non-visual-styles/is-non-visual-style-mutation":"jffPE","../../vc-observer/observers/non-visual-styles/is-pdnd-attribute":"7EfhA","../../vc-observer/observers/rll-placeholders":"a7mKq","./intersection-observer":"cxesk","./mutation-observer":"gfu17","./performance-observer":"4oRx9","./utils/check-within-component":"bMxoT","./utils/is-contained-within-smart-answers":"9ZTah","./utils/is-element-visible":"4Psgg","./utils/is-in-vc-ignore-if-no-layout-shift-marker":"cJpaR","./utils/is-input-name-mutation":"lv8g2","./utils/is-same-rect-dimensions":"kXTZh","./utils/is-same-rect-size":"aq51F","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7EfhA":[function(require,module,exports,__globalThis) {
/**
 * Attributes that Pragmatic Drag and Drop adds via `setAttribute` during its
 * post-paint registration step. They are used purely for hit testing and
 * registration bookkeeping, and do not affect layout, paint, or visible
 * styling, so they are safe to ignore for VC measurement.
 *
 * Drop target attributes follow `data-drop-target-for-<typeKey>` and are
 * handled by the prefix below (covers shipped and custom adapters).
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PDND_REGISTRATION_ATTRIBUTES", function() {
    return PDND_REGISTRATION_ATTRIBUTES;
});
parcelHelpers.export(exports, "DROP_TARGET_ATTRIBUTE_PREFIX", function() {
    return DROP_TARGET_ATTRIBUTE_PREFIX;
});
parcelHelpers.export(exports, "default", function() {
    return isPdndAttribute;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
var PDND_REGISTRATION_ATTRIBUTES = new Set([
    // @atlaskit/pragmatic-drag-and-drop (core)
    'draggable',
    // Honey pot lives on a transient element; included for completeness.
    'data-pdnd-honey-pot',
    // @atlaskit/pragmatic-drag-and-drop-auto-scroll
    'data-auto-scrollable',
    // @atlaskit/pragmatic-drag-and-drop/react-beautiful-dnd-migration
    'data-rbd-draggable-droppable-id',
    'data-rbd-draggable-index',
    'data-rbd-droppable-type',
    'data-rbd-droppable-direction',
    'data-rbd-droppable-id',
    'data-rbd-droppable-context-id',
    'data-rbd-style-context-id'
]);
var DROP_TARGET_ATTRIBUTE_PREFIX = 'data-drop-target-for-';
function isPdndAttribute(param) {
    var target = param.target, attributeName = param.attributeName;
    if (!(0, _instanceof._)(target, Element)) return false;
    if (!attributeName) return false;
    if (PDND_REGISTRATION_ATTRIBUTES.has(attributeName)) return true;
    if (attributeName.startsWith(DROP_TARGET_ATTRIBUTE_PREFIX)) return true;
    return false;
}

},{"@swc/helpers/_/_instanceof":"h9UKc","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cxesk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createIntersectionObserver", function() {
    return createIntersectionObserver;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
var _isZeroDimensionRectangle = require("../utils/is-zero-dimension-rectangle");
function isValidEntry(entry) {
    return entry.isIntersecting && entry.intersectionRect.width > 0 && entry.intersectionRect.height > 0;
}
function createIntersectionObserver(param) {
    var onEntry = param.onEntry, onObserved = param.onObserved;
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    var callbacksPerElement = new WeakMap();
    var intersectionObserverCallback = function(entries) {
        var validEntries = [];
        var startTime = performance.now();
        entries.forEach(function(entry) {
            if (!(0, _instanceof._)(entry.target, HTMLElement)) return;
            var tagOrCallback = callbacksPerElement.get(entry.target);
            if ((0, _isZeroDimensionRectangle.isZeroDimensionRectangle)(entry.intersectionRect)) {
                var zeroDimensionRectangleTagCallback = function(props) {
                    var tagOrCallbackResult = typeof tagOrCallback === 'function' ? tagOrCallback(props) : tagOrCallback;
                    // override as display-contents mutation
                    if (tagOrCallbackResult === 'mutation:element') return 'mutation:display-contents-children-element';
                    // override as display-contents mutation
                    if (tagOrCallbackResult && typeof tagOrCallbackResult !== 'string' && tagOrCallbackResult.type === 'mutation:attribute' && 'oldValue' in tagOrCallbackResult.mutationData) {
                        var _tagOrCallbackResult_mutationData = tagOrCallbackResult.mutationData, attributeName = _tagOrCallbackResult_mutationData.attributeName, oldValue = _tagOrCallbackResult_mutationData.oldValue, newValue = _tagOrCallbackResult_mutationData.newValue;
                        var isRoutingMutation = attributeName === 'style' && (!oldValue && newValue === 'display: none !important;' || oldValue === 'display: none !important;' && !newValue);
                        if (isRoutingMutation) return {
                            type: 'mutation:attribute:framework-routing',
                            mutationData: tagOrCallbackResult.mutationData
                        };
                        return {
                            type: 'mutation:display-contents-children-attribute',
                            mutationData: tagOrCallbackResult.mutationData
                        };
                    }
                    return tagOrCallbackResult;
                };
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Array.from(entry.target.children)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var child = _step.value;
                        observer.observe(child);
                        callbacksPerElement.set(child, zeroDimensionRectangleTagCallback);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return;
            }
            if (!isValidEntry(entry)) return;
            var mutationTag = null;
            var mutationData = null;
            if (typeof tagOrCallback === 'function') {
                var tagOrCallbackResult = tagOrCallback({
                    target: entry.target,
                    rect: entry.intersectionRect
                });
                if (!tagOrCallbackResult) mutationTag = 'unknown';
                else if (typeof tagOrCallbackResult === 'string') mutationTag = tagOrCallbackResult;
                else {
                    mutationTag = tagOrCallbackResult.type;
                    mutationData = tagOrCallbackResult.mutationData;
                }
            } else if (typeof tagOrCallback === 'string') mutationTag = tagOrCallback;
            onEntry({
                target: entry.target,
                rect: entry.intersectionRect,
                time: entry.time,
                type: mutationTag !== null && mutationTag !== void 0 ? mutationTag : 'unknown',
                mutationData: mutationData
            });
            validEntries.push(new WeakRef(entry.target));
            callbacksPerElement.delete(entry.target);
            observer.unobserve(entry.target);
        });
        onObserved === null || onObserved === void 0 ? void 0 : onObserved({
            time: startTime,
            elements: validEntries
        });
    };
    var observer = new IntersectionObserver(intersectionObserverCallback);
    return {
        disconnect: function() {
            observer.disconnect();
        },
        unobserve: function(target) {
            observer.unobserve(target);
        },
        watchAndTag: function(target, tagOrCallback) {
            callbacksPerElement.set(target, tagOrCallback);
            observer.observe(target);
        }
    };
}

},{"@swc/helpers/_/_instanceof":"h9UKc","../utils/is-zero-dimension-rectangle":"iyAaT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iyAaT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isZeroDimensionRectangle", function() {
    return isZeroDimensionRectangle;
});
function isZeroDimensionRectangle(rect) {
    return rect.bottom === 0 && rect.top === 0 && rect.left === 0 && rect.right === 0 && rect.x === 0 && rect.y === 0 && rect.width === 0 && rect.height === 0;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gfu17":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _instanceof = require("@swc/helpers/_/_instanceof");
var _typeOf = require("@swc/helpers/_/_type_of");
var _expVal = require("../../../expVal");
function createMutationObserver(param) {
    var onAttributeMutation = param.onAttributeMutation, onChildListMutation = param.onChildListMutation, onMutationFinished = param.onMutationFinished;
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    var mutationObserverCallback = function(mutations) {
        var targets = [];
        // Use nested Maps for O(1) batching performance
        // Short-lived Maps are safe since they're discarded after each callback
        var batchedMutations = new Map();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var mut = _step.value;
                if (!(0, _instanceof._)(mut.target, HTMLElement)) return "continue";
                if ((0, _expVal.expVal)('cc_editor_vc_exclude_flags', 'isEnabled', false)) {
                    // Intended for excluding out of band mutations such as tooltips on hover, and page flags
                    // Currently being tested in Confluence
                    // Skip elements with data-vc-oob attribute
                    if (mut.target.dataset.vcOob) return {
                        v: void void 0
                    };
                }
                if (mut.type === 'attributes') {
                    var _mut_oldValue;
                    /*
					"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
					I think it might have been something along the lines that for consistency every setAttribute call should create a record.
					Conceptually there is after all a mutation: there is an old value replaced with a new one,
					and whether or not they are the same doesn't really matter.
					And Custom elements should work the same way as MutationObserver."
					https://github.com/whatwg/dom/issues/520#issuecomment-336574796
				*/ var oldValue = (_mut_oldValue = mut.oldValue) !== null && _mut_oldValue !== void 0 ? _mut_oldValue : undefined;
                    var newValue = mut.attributeName ? mut.target.getAttribute(mut.attributeName) : undefined;
                    var _mut_attributeName;
                    if (oldValue !== newValue) onAttributeMutation({
                        target: mut.target,
                        attributeName: (_mut_attributeName = mut.attributeName) !== null && _mut_attributeName !== void 0 ? _mut_attributeName : 'unknown',
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: mut.timestamp || performance.now()
                    });
                    return "continue";
                } else if (mut.type === 'childList') {
                    // In chromium browser MutationRecord has timestamp field, which we should use.
                    var timestamp = Math.round(mut.timestamp || performance.now());
                    // Get or create timestamp bucket
                    var timestampBucket = batchedMutations.get(timestamp);
                    if (!timestampBucket) {
                        timestampBucket = new Map();
                        batchedMutations.set(timestamp, timestampBucket);
                    }
                    // Get or create target batch within timestamp bucket
                    var batch = timestampBucket.get(mut.target);
                    if (!batch) {
                        batch = {
                            target: new WeakRef(mut.target),
                            addedNodes: [],
                            removedNodes: [],
                            timestamp: timestamp
                        };
                        timestampBucket.set(mut.target, batch);
                    }
                    var // Accumulate added nodes
                    _mut_addedNodes;
                    ((_mut_addedNodes = mut.addedNodes) !== null && _mut_addedNodes !== void 0 ? _mut_addedNodes : []).forEach(function(node) {
                        if ((0, _instanceof._)(node, HTMLElement)) batch.addedNodes.push(new WeakRef(node));
                    });
                    var // Accumulate removed nodes
                    _mut_removedNodes;
                    ((_mut_removedNodes = mut.removedNodes) !== null && _mut_removedNodes !== void 0 ? _mut_removedNodes : []).forEach(function(node) {
                        if ((0, _instanceof._)(node, HTMLElement)) batch.removedNodes.push(new WeakRef(node));
                    });
                }
                targets.push(mut.target);
            };
            for(var _iterator = mutations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _ret = _loop();
                if ((0, _typeOf._)(_ret) === "object") return _ret.v;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined, _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
        try {
            // Process all batched childList mutations
            for(var _iterator1 = batchedMutations.values()[Symbol.iterator](), _step1; !(_iteratorNormalCompletion2 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion2 = true){
                var timestampBucket = _step1.value;
                try {
                    for(var _iterator2 = timestampBucket.values()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion1 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion1 = true){
                        var batch = _step2.value;
                        onChildListMutation({
                            target: batch.target,
                            addedNodes: batch.addedNodes,
                            removedNodes: batch.removedNodes,
                            timestamp: batch.timestamp
                        });
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator2.return != null) {
                            _iterator2.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion2 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }
        onMutationFinished === null || onMutationFinished === void 0 ? void 0 : onMutationFinished({
            targets: targets
        });
    };
    var observer = new MutationObserver(mutationObserverCallback);
    return observer;
}
exports.default = createMutationObserver;

},{"@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_type_of":"iFJdx","../../../expVal":"10m7B","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4oRx9":[function(require,module,exports,__globalThis) {
// The LayoutShiftAttribution API is returning the numbers on physical dimension
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "convertPhysicalToLogicalResolution", function() {
    return convertPhysicalToLogicalResolution;
});
function convertPhysicalToLogicalResolution(rect) {
    if (typeof window.devicePixelRatio !== 'number') return rect;
    if (window.devicePixelRatio === 1) return rect;
    // eslint-disable-next-line compat/compat
    return new DOMRect(rect.x / window.devicePixelRatio, rect.y / window.devicePixelRatio, rect.width / window.devicePixelRatio, rect.height / window.devicePixelRatio);
}
function createPerformanceObserver(param) {
    var onLayoutShift = param.onLayoutShift;
    if (!window || typeof window.PerformanceObserver !== 'function') return null;
    var performanceObserverCallback = function(entries) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = entries.getEntries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entry = _step.value;
                if (entry.entryType === 'layout-shift' && 'sources' in entry) {
                    // see https://developer.mozilla.org/en-US/docs/Web/API/LayoutShiftAttribution for more info
                    var changedRects = entry.sources.reduceRight(function(acc, attr) {
                        acc.push({
                            rect: convertPhysicalToLogicalResolution(attr.currentRect),
                            previousRect: convertPhysicalToLogicalResolution(attr.previousRect),
                            node: attr.node
                        });
                        return acc;
                    }, []);
                    onLayoutShift({
                        time: entry.startTime,
                        changedRects: changedRects
                    });
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
    var observer = new PerformanceObserver(performanceObserverCallback);
    return observer;
}
exports.default = createPerformanceObserver;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bMxoT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cleanupCaches", function() {
    return cleanupCaches;
});
parcelHelpers.export(exports, "default", function() {
    return checkWithinComponent;
});
var _coinflip = require("../../../../coinflip");
var _coinflipDefault = parcelHelpers.interopDefault(_coinflip);
var _checkFiberWithinComponent = require("./check-fiber-within-component");
var _checkFiberWithinComponentDefault = parcelHelpers.interopDefault(_checkFiberWithinComponent);
var _findFiberWithCache = require("./find-fiber-with-cache");
var _findFiberWithCacheDefault = parcelHelpers.interopDefault(_findFiberWithCache);
var DOM_WALK_MAX_LEVEL = 40;
var FIBER_WALK_MAX_LEVEL = 40;
// Cache cleanup
var callCount = 0;
var CLEANUP_THRESHOLD = 50;
function maybeCleanup(resultCache) {
    callCount++;
    if (callCount >= CLEANUP_THRESHOLD && (0, _coinflipDefault.default)(0.3)) cleanupCaches(resultCache);
}
function cleanupCaches(resultCache) {
    resultCache = new WeakMap();
    callCount = 0;
    return resultCache;
}
function checkWithinComponent(node, targetComponentName, resultCache) {
    maybeCleanup(resultCache);
    var _resultCache_get;
    if (resultCache.has(node)) return {
        isWithin: (_resultCache_get = resultCache.get(node)) !== null && _resultCache_get !== void 0 ? _resultCache_get : false
    };
    var fiber = null;
    var checkedNodes = [];
    // Always use cached fiber strategy to handle non-React elements reliably
    fiber = (0, _findFiberWithCacheDefault.default)(node, DOM_WALK_MAX_LEVEL, checkedNodes);
    if (!fiber) {
        checkedNodes.forEach(function(checkedNode) {
            resultCache.set(checkedNode, false);
        });
        return {
            isWithin: false
        };
    }
    var isWithin = (0, _checkFiberWithinComponentDefault.default)(fiber, targetComponentName, FIBER_WALK_MAX_LEVEL);
    checkedNodes.forEach(function(checkedNode) {
        resultCache.set(checkedNode, isWithin);
    });
    return {
        isWithin: isWithin
    };
}

},{"../../../../coinflip":"cHdgG","./check-fiber-within-component":"hvy2f","./find-fiber-with-cache":"3Nj2g","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hvy2f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return checkFiberWithinComponent;
});
var _getComponentName = require("./get-component-name");
var _getComponentNameDefault = parcelHelpers.interopDefault(_getComponentName);
function checkFiberWithinComponent(fiber, targetComponentName, maxLevel) {
    // Stop when no more levels to traverse
    if (maxLevel <= 0) return false;
    if (!fiber) return false;
    var componentName = (0, _getComponentNameDefault.default)(fiber);
    if (componentName === targetComponentName) return true;
    // Recursively traverse up the fiber tree
    return checkFiberWithinComponent(fiber.return, targetComponentName, maxLevel - 1);
}

},{"./get-component-name":"9NbnT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9NbnT":[function(require,module,exports,__globalThis) {
// Helper function to extract component name from fiber
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getComponentName;
});
var _typeOf = require("@swc/helpers/_/_type_of");
function getComponentName(fiber) {
    var type = fiber === null || fiber === void 0 ? void 0 : fiber.type;
    if (!type) return undefined;
    if (typeof type === 'function' || (typeof type === "undefined" ? "undefined" : (0, _typeOf._)(type)) === 'object') return type.displayName || type.name;
    return undefined;
}

},{"@swc/helpers/_/_type_of":"iFJdx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3Nj2g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return findFiberWithCache;
});
var _findReactFiber = require("./find-react-fiber");
var _findReactFiberDefault = parcelHelpers.interopDefault(_findReactFiber);
function findFiberWithCache(element, maxLevel, checkedNodes) {
    // Stop when no more levels to traverse
    if (maxLevel <= 0) return null;
    checkedNodes.push(element);
    var fiber = (0, _findReactFiberDefault.default)(element);
    if (fiber) return fiber;
    // Walk up the DOM tree to find the fiber
    var parent = element.parentElement;
    if (!parent) return null;
    // Recursively check parent
    return findFiberWithCache(parent, maxLevel - 1, checkedNodes);
}

},{"./find-react-fiber":"5tJCD","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5tJCD":[function(require,module,exports,__globalThis) {
// Helper function to find React fiber on an element
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return findReactFiber;
});
function findReactFiber(element) {
    // Use for...in loop instead of Object.keys().find() to avoid creating an array
    for(var key in element){
        if (key.startsWith('__reactFiber$') || key.startsWith('__reactInternalInstance$')) return element[key];
    }
    return null;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9ZTah":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isContainedWithinSmartAnswers", function() {
    return isContainedWithinSmartAnswers;
});
var _browserApis = require("@atlaskit/browser-apis");
function isContainedWithinSmartAnswers(node) {
    var doc = (0, _browserApis.getDocument)();
    if (!doc) return false;
    var smartAnswersElement = doc.getElementById('search-page-smart-answers');
    if (!smartAnswersElement) return false;
    // When the node is the smart answer element, .contains() still returns true
    return smartAnswersElement.contains(node);
}

},{"@atlaskit/browser-apis":"2dayt","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4Psgg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isElementVisible", function() {
    return isElementVisible;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
function isElementVisible(element) {
    if (!(0, _instanceof._)(element, HTMLElement)) return true;
    try {
        var visible = element.checkVisibility({
            // @ts-ignore - visibilityProperty may not exist in all TS environments
            visibilityProperty: true,
            contentVisibilityAuto: true,
            opacityProperty: true
        });
        return visible;
    } catch (e) {
        // there is no support for checkVisibility
        return true;
    }
}

},{"@swc/helpers/_/_instanceof":"h9UKc","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cJpaR":[function(require,module,exports,__globalThis) {
/**
 * Check if the element is in the VC ignore if no layout shift marker.
 * @param element - The element to check.
 * @returns True if the element has the data-vc-ignore-if-no-layout-shift attribute == 'true or its parent has it, false otherwise.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isInVCIgnoreIfNoLayoutShiftMarker;
});
function isInVCIgnoreIfNoLayoutShiftMarker(element) {
    if (!element) return false;
    return element.getAttribute('data-vc-ignore-if-no-layout-shift') === 'true' || isInVCIgnoreIfNoLayoutShiftMarker(element.parentElement);
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lv8g2":[function(require,module,exports,__globalThis) {
// Detecting this is required due to a React/Chromium bug, where React itself triggers an attribute mutation for input elements
// Reference: https://atlassian.slack.com/archives/C08EK6TCUP6/p1764129900970719
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isInputNameMutation", function() {
    return isInputNameMutation;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
function isInputNameMutation(param) {
    var target = param.target, attributeName = param.attributeName, oldValue = param.oldValue, newValue = param.newValue;
    return (0, _instanceof._)(target, HTMLInputElement) && attributeName === 'name' && (oldValue === '' || newValue === '');
}

},{"@swc/helpers/_/_instanceof":"h9UKc","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kXTZh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isSameRectDimensions", function() {
    return isSameRectDimensions;
});
var DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX = 1;
function isSameRectDimensions(a, b) {
    if (!a || !b) return false;
    return Math.abs(a.width - b.width) <= DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.height - b.height) <= DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.x - b.x) <= DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.y - b.y) <= DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aq51F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isSameRectSize", function() {
    return isSameRectSize;
});
var SIZE_CHECK_TOLERANCE_MARGIN_IN_PX = 1;
function isSameRectSize(a, b) {
    if (!a || !b) return false;
    return Math.abs(a.width - b.width) <= SIZE_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.height - b.height) <= SIZE_CHECK_TOLERANCE_MARGIN_IN_PX;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9FDxe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return WindowEventObserver;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _bindEventListener = require("bind-event-listener");
var WindowEventObserver = /*#__PURE__*/ function() {
    "use strict";
    function WindowEventObserver(opts) {
        (0, _classCallCheck._)(this, WindowEventObserver);
        this.unbindFns = [];
        this.onEvent = opts.onEvent;
    }
    (0, _createClass._)(WindowEventObserver, [
        {
            key: "bindEvent",
            value: function bindEvent(type) {
                var _this = this;
                var unbindCallback = (0, _bindEventListener.bind)(window, {
                    type: type,
                    listener: function(event) {
                        if (!event.isTrusted) return;
                        _this.onEvent({
                            time: event.timeStamp,
                            type: type,
                            event: event
                        });
                    },
                    options: {
                        passive: true,
                        once: true
                    }
                });
                this.unbindFns.push(unbindCallback);
            }
        },
        {
            key: "bindCaptureScrollEvent",
            value: /**
	 * Binds a scroll listener on `document` using the capture phase.
	 * The `scroll` event does not bubble, so listening on `window` only catches
	 * document-level scrolls. By using `{ capture: true }` on `document`, we can
	 * detect scroll events from any element in the DOM tree, including inner
	 * scrollable containers (e.g. when the user drags a scrollbar).
	 */ function bindCaptureScrollEvent() {
                var _this = this;
                var unbindCallback = (0, _bindEventListener.bind)(document, {
                    type: 'scroll',
                    listener: function(event) {
                        if (!event.isTrusted) return;
                        _this.onEvent({
                            time: event.timeStamp,
                            type: 'scroll-container',
                            event: event
                        });
                    },
                    options: {
                        capture: true,
                        passive: true,
                        once: true
                    }
                });
                this.unbindFns.push(unbindCallback);
            }
        },
        {
            key: "start",
            value: function start() {
                this.bindEvent('wheel');
                this.bindEvent('scroll');
                this.bindEvent('keydown');
                this.bindEvent('resize');
                this.bindCaptureScrollEvent();
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.unbindFns.forEach(function(cb) {
                    cb();
                });
                this.unbindFns = [];
            }
        }
    ]);
    return WindowEventObserver;
}();

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","bind-event-listener":"bjeUU","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7CDIL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "interactions", function() {
    return interactions;
});
var interactions = new Map();

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"71ANZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return InteractionExtraMetrics;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _vc = require("../vc");
var _constants = require("./common/constants");
var _index = require("./index");
var InteractionExtraMetrics = /*#__PURE__*/ function() {
    "use strict";
    function InteractionExtraMetrics() {
        (0, _classCallCheck._)(this, InteractionExtraMetrics);
        // Store the finished interaction (as non-3p interaction)
        this.finishedInteraction = null;
        // independent VC observer, that observes until `custom.post-interaction-logs` event is sent
        this.vcObserver = null;
        this.sinkHandlerFn = function() {};
    }
    (0, _createClass._)(InteractionExtraMetrics, [
        {
            key: "initializeVCObserver",
            value: function initializeVCObserver(options) {
                this.vcObserver = new (0, _vc.VCObserverWrapper)((0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
                    isPostInteraction: true
                }));
            }
        },
        {
            key: "startVCObserver",
            value: function startVCObserver(param, interactionId) {
                var startTime = param.startTime;
                var _this_vcObserver;
                if (this.eligibleToMeasure(interactionId)) (_this_vcObserver = this.vcObserver) === null || _this_vcObserver === void 0 ? void 0 : _this_vcObserver.start({
                    startTime: startTime
                });
            }
        },
        {
            key: "stopVCObserver",
            value: function stopVCObserver() {
                var _this_vcObserver;
                (_this_vcObserver = this.vcObserver) === null || _this_vcObserver === void 0 ? void 0 : _this_vcObserver.stop();
            }
        },
        {
            // Check if the current interaction is eligible for measurement
            key: "eligibleToMeasure",
            value: function eligibleToMeasure(interactionId) {
                var interaction = (0, _constants.interactions).get(interactionId);
                return (interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'page_load' || (interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'transition';
            }
        },
        {
            key: "updateFinishedInteraction",
            value: function updateFinishedInteraction(interaction) {
                if ((interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'page_load' || (interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'transition') this.finishedInteraction = interaction;
            }
        },
        {
            key: "setLastInteractionFinishVCResult",
            value: function setLastInteractionFinishVCResult(result) {
                this.lastInteractionFinishVCResult = result;
            }
        },
        {
            key: "sinkHandler",
            value: function sinkHandler(fn) {
                this.sinkHandlerFn = fn;
            }
        },
        {
            key: "onInteractionComplete",
            value: function onInteractionComplete(id, data) {
                if (data.ufoName) {
                    var _this_vcObserver;
                    var updatedData = (0, _objectSpreadProps._)((0, _objectSpread._)({}, data), {
                        vcObserver: (_this_vcObserver = this.vcObserver) !== null && _this_vcObserver !== void 0 ? _this_vcObserver : undefined
                    });
                    this.sinkHandlerFn(id, updatedData, this.finishedInteraction, this.lastInteractionFinishVCResult);
                }
                this.stopVCObserver();
                (0, _index.remove)(id);
                this.reset();
            }
        },
        {
            key: "reset",
            value: function reset() {
                var _this_finishedInteraction;
                this.stopVCObserver();
                if ((_this_finishedInteraction = this.finishedInteraction) === null || _this_finishedInteraction === void 0 ? void 0 : _this_finishedInteraction.id) (0, _index.remove)(this.finishedInteraction.id);
                this.finishedInteraction = null;
                this.lastInteractionFinishVCResult = undefined;
            }
        },
        {
            key: "stopAll",
            value: function stopAll(id) {
                (0, _index.remove)(id);
                this.reset();
            }
        }
    ]);
    return InteractionExtraMetrics;
}();

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","../vc":"3cXH4","./common/constants":"7CDIL","./index":"diQdd","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1Ho6H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return PostInteractionLog;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _config = require("../config");
var _hiddenTiming = require("../hidden-timing");
var _vc = require("../vc");
var POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT = 3000;
var PostInteractionLog = /*#__PURE__*/ function() {
    "use strict";
    function PostInteractionLog() {
        (0, _classCallCheck._)(this, PostInteractionLog);
        /**
	 * Basic info about interaction that has just finished
	 */ this.lastInteractionFinish = null;
        /**
	 * Array of observed react render timings
	 */ this.reactProfilerTimings = [];
        /**
	 * Store the scheduled sink timeout Id so that it can be cancelled when needed
	 */ this.sinkTimeoutId = null;
        this.holdInfo = [];
        /**
	 * independent VC observer, that observes until `custom.post-interaction-logs` event is sent
	 */ this.vcObserver = null;
        this.vcObserverSSRConfig = null;
        /**
	 * Handler function to process / send the observation data
	 */ this.sinkHandlerFn = function() {};
    }
    (0, _createClass._)(PostInteractionLog, [
        {
            key: "initializeVCObserver",
            value: function initializeVCObserver(options) {
                this.vcObserver = new (0, _vc.VCObserverWrapper)((0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
                    isPostInteraction: true
                }));
            }
        },
        {
            key: "startVCObserver",
            value: function startVCObserver(param) {
                var startTime = param.startTime;
                var _this_vcObserver;
                (_this_vcObserver = this.vcObserver) === null || _this_vcObserver === void 0 ? void 0 : _this_vcObserver.start({
                    startTime: startTime
                });
            }
        },
        {
            key: "stopVCObserver",
            value: function stopVCObserver() {
                var _this_vcObserver;
                (_this_vcObserver = this.vcObserver) === null || _this_vcObserver === void 0 ? void 0 : _this_vcObserver.stop();
            }
        },
        {
            key: "setVCObserverSSRConfig",
            value: function setVCObserverSSRConfig(vcObserverSSRConfig) {
                this.vcObserverSSRConfig = vcObserverSSRConfig;
            }
        },
        {
            /**
	 * Set the VC result as per the last interaction
	 * Used to compare diffs of VC updates vs post interaction VC observer
	 * @param result - VC result as calculated by UFO create payload
	 */ key: "setLastInteractionFinishVCResult",
            value: function setLastInteractionFinishVCResult(result) {
                this.lastInteractionFinishVCResult = result;
            }
        },
        {
            /**
	 * Set the fn that would be invoked to process / send the observation data
	 */ key: "sinkHandler",
            value: function sinkHandler(sinkHandlerFn) {
                this.sinkHandlerFn = sinkHandlerFn;
            }
        },
        {
            /**
	 * Reset state of the log
	 */ key: "reset",
            value: function reset() {
                this.lastInteractionFinish = null;
                this.reactProfilerTimings = [];
                this.holdInfo = [];
                if (this.sinkTimeoutId != null) {
                    clearTimeout(this.sinkTimeoutId);
                    this.sinkTimeoutId = null;
                }
                this.setVCObserverSSRConfig(null);
            }
        },
        {
            /**
	 * Check if there is data in the log
	 */ key: "hasData",
            value: function hasData() {
                var _this_reactProfilerTimings;
                return ((_this_reactProfilerTimings = this.reactProfilerTimings) === null || _this_reactProfilerTimings === void 0 ? void 0 : _this_reactProfilerTimings.length) > 0;
            }
        },
        {
            key: "sendPostInteractionLog",
            value: /**
	 * Send the log if there is data
	 */ function sendPostInteractionLog() {
                return (0, _asyncToGenerator._)(function() {
                    var _config_vc, _config_vc1, _this_vcObserver, _this_vcObserver1, _this_vcObserver2, pageVisibilityState, isPageVisible, config, postInteractionFinishVCResult;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!this.lastInteractionFinish || !this.sinkHandlerFn) {
                                    ;
                                    this.reset();
                                    (_this_vcObserver2 = this.vcObserver) === null || _this_vcObserver2 === void 0 ? void 0 : _this_vcObserver2.stop();
                                    return [
                                        2
                                    ];
                                }
                                pageVisibilityState = (0, _hiddenTiming.getPageVisibilityState)(this.lastInteractionFinish.start, this.lastInteractionFinish.end);
                                isPageVisible = pageVisibilityState === 'visible';
                                config = (0, _config.getConfig)();
                                return [
                                    4,
                                    (_this_vcObserver = this.vcObserver) === null || _this_vcObserver === void 0 ? void 0 : _this_vcObserver.getVCResult((0, _objectSpreadProps._)((0, _objectSpread._)({
                                        start: this.lastInteractionFinish.start,
                                        stop: performance.now(),
                                        tti: -1,
                                        isEventAborted: !!this.lastInteractionFinish.abortReason,
                                        prefix: 'ufo',
                                        experienceKey: this.lastInteractionFinish.ufoName,
                                        interactionId: this.lastInteractionFinish.id,
                                        includeSSRInV3: config === null || config === void 0 ? void 0 : (_config_vc = config.vc) === null || _config_vc === void 0 ? void 0 : _config_vc.includeSSRInV3,
                                        includeSSRRatio: config === null || config === void 0 ? void 0 : (_config_vc1 = config.vc) === null || _config_vc1 === void 0 ? void 0 : _config_vc1.includeSSRRatio
                                    }, this.vcObserverSSRConfig), {
                                        interactionType: this.lastInteractionFinish.type,
                                        isPageVisible: isPageVisible,
                                        interactionAbortReason: this.lastInteractionFinish.abortReason
                                    }))
                                ];
                            case 1:
                                postInteractionFinishVCResult = _state.sent();
                                (_this_vcObserver1 = this.vcObserver) === null || _this_vcObserver1 === void 0 ? void 0 : _this_vcObserver1.stop();
                                this.sinkHandlerFn({
                                    lastInteractionFinish: this.lastInteractionFinish,
                                    reactProfilerTimings: this.reactProfilerTimings,
                                    postInteractionFinishVCResult: postInteractionFinishVCResult,
                                    lastInteractionFinishVCResult: this.lastInteractionFinishVCResult,
                                    postInteractionHoldInfo: this.holdInfo
                                });
                                this.reset();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
	 * This fn should be invoked when an interaction has finished
	 * Basic details about the finished interaction will be recorded
	 * A timeout will be setup to send the post interaction observation after some time.
	 */ key: "onInteractionComplete",
            value: function onInteractionComplete(param) {
                var _this = this;
                var ufoName = param.ufoName, start = param.start, end = param.end, id = param.id, abortReason = param.abortReason, abortedByInteractionName = param.abortedByInteractionName, routeName = param.routeName, type = param.type, experimentalTTAI = param.experimentalTTAI, experimentalVC90 = param.experimentalVC90, errors = param.errors;
                var _getConfig;
                this.lastInteractionFinish = {
                    ufoName: ufoName,
                    start: start,
                    end: end,
                    id: id,
                    abortReason: abortReason,
                    abortedByInteractionName: abortedByInteractionName,
                    routeName: routeName,
                    type: type,
                    experimentalTTAI: experimentalTTAI,
                    experimentalVC90: experimentalVC90,
                    errors: errors
                };
                var timeout = ((_getConfig = (0, _config.getConfig)()) === null || _getConfig === void 0 ? void 0 : _getConfig.timeWindowForLateMutationsInMilliseconds) || POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT;
                this.sinkTimeoutId = window.setTimeout(function() {
                    return (0, _asyncToGenerator._)(function() {
                        return (0, _tsGenerator._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        this.sendPostInteractionLog()
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    }).call(_this);
                }, timeout);
            }
        },
        {
            /**
	 * This fn should be invoked when a React render happens after interaction has finished
	 */ key: "addProfilerTimings",
            value: function addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
                if (this.lastInteractionFinish != null) this.reactProfilerTimings.push({
                    type: type,
                    actualDuration: actualDuration,
                    baseDuration: baseDuration,
                    startTime: startTime,
                    commitTime: commitTime,
                    labelStack: labelStack
                });
            }
        },
        {
            key: "addHoldInfo",
            value: function addHoldInfo(labelStack, name, start) {
                this.holdInfo.push({
                    name: name,
                    labelStack: labelStack,
                    start: start
                });
            }
        }
    ]);
    return PostInteractionLog;
}();

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_ts_generator":"78Tqx","../config":"1BZI5","../hidden-timing":"lV0ww","../vc":"3cXH4","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"61t5e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// The UFORouteName object is a global singleton
var UFORouteName = {
    current: null
};
exports.default = UFORouteName;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7VrCG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function generateId() {
    var length = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 7;
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var result = '';
    for(var i = 0; i < length; i++)result += characters.charAt(Math.floor(Math.random() * characters.length));
    return result;
}
exports.default = generateId;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"72vVv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var process = require("a340461195b27765");
function scheduleOnPaint(callback) {
    var _globalThis, _process_env, _globalThis_document;
    var isSSR = typeof window === 'undefined' || Boolean((_globalThis = globalThis) === null || _globalThis === void 0 ? void 0 : _globalThis.__SERVER__) || typeof process !== 'undefined' && Boolean(process === null || process === void 0 ? void 0 : (_process_env = process.env) === null || _process_env === void 0 ? void 0 : _process_env.REACT_SSR);
    if (isSSR) {
        // In SSR, execute callback immediately (no paint event exists)
        callback();
        return;
    }
    if (((_globalThis_document = globalThis.document) === null || _globalThis_document === void 0 ? void 0 : _globalThis_document.visibilityState) !== 'visible') {
        // last resort fallback
        setTimeout(callback, 100);
        return;
    }
    // Check if the Scheduler API is available
    if (typeof window.scheduler !== 'undefined' && typeof window.scheduler.postTask === 'function') // Use scheduler.postTask if available
    // https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
    // Make sure we are scheduling this task before the browser paint the next frame
    requestAnimationFrame(function() {
        window.scheduler.postTask(callback, {
            priority: 'user-visible'
        });
    });
    else if (typeof requestAnimationFrame !== 'undefined') // Fallback to using double requestAnimationFrame
    requestAnimationFrame(function() {
        requestAnimationFrame(function() {
            callback();
        });
    });
}
exports.default = scheduleOnPaint;

},{"a340461195b27765":"gNLf3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jqTsg":[function(require,module,exports,__globalThis) {
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "routes", function() {
    return routes;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactResourceRouter = require("react-resource-router");
var _twgMicrositeExperience = require("@atlassian/twg-microsite-experience");
var homeRoute = {
    name: 'HOME',
    path: '/',
    exact: true,
    component: (0, _twgMicrositeExperience.Home)
};
var catchAllRoute = {
    name: 'not-found-redirect',
    path: '*',
    // Matches anything not caught above
    component: function() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactResourceRouter.Redirect), {
            to: "/"
        });
    }
};
var routes = [
    homeRoute,
    catchAllRoute
];

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","react-resource-router":"aVqdw","@atlassian/twg-microsite-experience":"3ciWs","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3ciWs":[function(require,module,exports,__globalThis) {
// Components
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Home", function() {
    return 0, _homeDefault.default;
});
// Utilities
parcelHelpers.export(exports, "initAnalyticsClient", function() {
    return 0, _analyticsClient.initAnalyticsClient;
});
parcelHelpers.export(exports, "initSentry", function() {
    return 0, _sentry.initSentry;
});
var _home = require("./ui/pages/home");
var _homeDefault = parcelHelpers.interopDefault(_home);
var _analyticsClient = require("./common/analytics/analytics-client");
var _sentry = require("./common/sentry");

},{"./ui/pages/home":"6FEWV","./common/analytics/analytics-client":"aVBNX","./common/sentry":"lc1oo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6FEWV":[function(require,module,exports,__globalThis) {
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Home", function() {
    return Home;
});
parcelHelpers.export(exports, "default", function() {
    return HomeWithErrorBoundary;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _segment = require("@atlaskit/react-ufo/segment");
var _segmentDefault = parcelHelpers.interopDefault(_segment);
var _useScrollDepthEvent = require("../../../common/analytics/hooks/useScrollDepthEvent");
var _useTierShownEvent = require("../../../common/analytics/hooks/useTierShownEvent");
var _sessionTracker = require("../../../common/analytics/SessionTracker");
var _types = require("../../../common/analytics/types");
var _sentry = require("../../../common/sentry");
var _useUserContext = require("../../../hooks/use-user-context");
var _collectFeedback = require("../../components/CollectFeedback");
var _errorView = require("../../components/ErrorView");
var _loadingView = require("../../components/LoadingView");
/**
 * Lazy-loaded gating component that resolves the user's `cloudId` and primes
 * the shared atoms before the logged-in view mounts. Code-split out so the
 * App Switcher / cloudId resolution logic and the heavy LoggedInView modules
 * are only fetched once we know the user is authenticated.
 */ var LoggedInGate = /*#__PURE__*/ (0, _react.lazy)(function() {
    return require(/* webpackChunkName: "@atlassian/twg-microsite-experience_logged-in-gate" */ "afb60335713d2a78");
});
/**
 * Lazy-loaded marketing/logged-out experience. Code-split out so the
 * landing-page assets are only fetched when the visitor is unauthenticated
 * (or has toggled the dev "Logged Out View" switcher).
 */ var LoggedOutView = /*#__PURE__*/ (0, _react.lazy)(function() {
    return require(/* webpackChunkName: "@atlassian/twg-microsite-experience_logged-out-view" */ "35ad362b5f16f612").then(function(m) {
        return {
            default: m.LoggedOutView
        };
    });
});
function Home() {
    var _useAtlassianUserContext = (0, _useUserContext.useAtlassianUserContext)(), loading = _useAtlassianUserContext.loading, isAuthed = _useAtlassianUserContext.isAuthed, identity = _useAtlassianUserContext.identity;
    // Fire `track.twgMicrositeTier.shown` for the logged-out tier as
    // soon as we know the user is not authenticated. The hook safely
    // no-ops when called with `tier === undefined` (loading / blocked /
    // authed branches), so we can call it unconditionally at the top
    // without violating Rules of Hooks.
    (0, _useTierShownEvent.useTierShownEvent)({
        tier: !loading && !isAuthed ? (0, _types.MicrositeTier).LoggedOut : undefined,
        resolution: (0, _types.TierResolution).Organic,
        hasUserMetrics: false,
        hasOrgMetrics: false,
        metricCount: 0
    });
    // Track scroll-depth across the entire home shell. The hook is mounted
    // here (top-level Home component) so the same instance covers both the
    // logged-out and logged-in views — once a bucket fires for the current
    // session it stays fired even if the user signs in mid-scroll.
    (0, _useScrollDepthEvent.useScrollDepthEvent)();
    if (loading) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _segmentDefault.default), {
        name: "twg-microsite.home"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _loadingView.LoadingView), {
        holdName: "twg-microsite.home.user-context-loading",
        appearance: "shell"
    }));
    var _identity_name;
    if (!isAuthed) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _segmentDefault.default), {
        name: "twg-microsite.home"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _sessionTracker.SessionTracker), {
        authState: "loggedOut",
        tier: (0, _types.MicrositeTier).LoggedOut
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _segmentDefault.default), {
        name: "twg-microsite.home.logged-out"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Suspense), {
        fallback: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _loadingView.LoadingView), {
            holdName: "twg-microsite.home.user-context-loading",
            appearance: "shell"
        })
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(LoggedOutView, null))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collectFeedback.CollectFeedback), {
        atlassianAccountId: "",
        entrypointId: "5cc48fe0-977e-45ce-9c7d-bbd5ee4a00ce",
        name: (_identity_name = identity.name) !== null && _identity_name !== void 0 ? _identity_name : undefined,
        locale: 'en'
    }));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _segmentDefault.default), {
        name: "twg-microsite.home"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _sessionTracker.SessionTracker), {
        authState: "loggedIn"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _segmentDefault.default), {
        name: "twg-microsite.home.logged-in"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Suspense), {
        fallback: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _loadingView.LoadingView), {
            holdName: "twg-microsite.home.user-context-loading"
        })
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(LoggedInGate, null))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collectFeedback.CollectFeedback), {
        atlassianAccountId: identity.accountId,
        entrypointId: "5cc48fe0-977e-45ce-9c7d-bbd5ee4a00ce",
        name: identity.name,
        locale: 'en'
    }));
}
function HomeWithErrorBoundary() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _sentry.SentryErrorBoundary), {
        fallback: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _errorView.ErrorView), null),
        loggerName: "home.errorBoundary"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Home, null));
}

},{"react":"ltHCL","@atlaskit/react-ufo/segment":"cMGle","../../../common/analytics/hooks/useScrollDepthEvent":"7yjxx","../../../common/analytics/hooks/useTierShownEvent":"4SS5v","../../../common/analytics/SessionTracker":"fWBfP","../../../common/analytics/types":"9GPzn","../../../common/sentry":"lc1oo","../../../hooks/use-user-context":"6Qevx","../../components/CollectFeedback":"bVqUv","../../components/ErrorView":"fyYwD","../../components/LoadingView":"1rBZb","afb60335713d2a78":"1Dovo","35ad362b5f16f612":"b9phQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7yjxx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useScrollDepthEvent", function() {
    return useScrollDepthEvent;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _react = require("react");
var _bindEventListener = require("bind-event-listener");
var _browserApis = require("@atlaskit/browser-apis");
var _useUserContext = require("../../../hooks/use-user-context");
var _attribution = require("../attribution");
var _useAnalyticsEvents = require("../generated/use-analytics-events");
var _types = require("../types");
var BUCKET_PERCENTAGE = {
    '25': 25,
    '50': 50,
    '75': 75,
    '100': 100
};
var SCROLL_THROTTLE_MS = 200;
var computeDepthPercent = function() {
    var doc = (0, _browserApis.getDocument)();
    var win = doc === null || doc === void 0 ? void 0 : doc.defaultView;
    if (!doc || !win) return 0;
    var _win_scrollY, _ref, _ref1;
    var scrollTop = (_ref1 = (_ref = (_win_scrollY = win.scrollY) !== null && _win_scrollY !== void 0 ? _win_scrollY : doc.documentElement.scrollTop) !== null && _ref !== void 0 ? _ref : doc.body.scrollTop) !== null && _ref1 !== void 0 ? _ref1 : 0;
    var _win_innerHeight, _ref2;
    var viewport = (_ref2 = (_win_innerHeight = win.innerHeight) !== null && _win_innerHeight !== void 0 ? _win_innerHeight : doc.documentElement.clientHeight) !== null && _ref2 !== void 0 ? _ref2 : 0;
    var _doc_documentElement_scrollHeight, _ref3;
    var scrollHeight = (_ref3 = (_doc_documentElement_scrollHeight = doc.documentElement.scrollHeight) !== null && _doc_documentElement_scrollHeight !== void 0 ? _doc_documentElement_scrollHeight : doc.body.scrollHeight) !== null && _ref3 !== void 0 ? _ref3 : 0;
    var scrollable = Math.max(0, scrollHeight - viewport);
    if (scrollable === 0) // Page fits in the viewport: anything visible is effectively the
    // top of the document. Reporting `100` here would inflate the
    // metric — treat it as "saw the top" only.
    return 0;
    return Math.min(100, Math.max(0, scrollTop / scrollable * 100));
};
var useScrollDepthEvent = function() {
    var fireEvent = (0, _useAnalyticsEvents.useAnalyticsEvents)().fireEvent;
    var isAuthed = (0, _useUserContext.useAtlassianUserContext)().isAuthed;
    var authState = isAuthed ? 'loggedIn' : 'loggedOut';
    var firedBucketsRef = (0, _react.useRef)(new Set());
    var authStateRef = (0, _react.useRef)(authState);
    (0, _react.useEffect)(function() {
        authStateRef.current = authState;
    }, [
        authState
    ]);
    (0, _react.useEffect)(function() {
        var _getDocument;
        var win = (_getDocument = (0, _browserApis.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.defaultView;
        if (!win) return;
        var throttleHandle = null;
        var pending = false;
        var unbindScroll = null;
        var onScroll = function() {
            if (throttleHandle !== null) {
                pending = true;
                return;
            }
            throttleHandle = setTimeout(function() {
                throttleHandle = null;
                if (pending) {
                    pending = false;
                    onScroll();
                }
            }, SCROLL_THROTTLE_MS);
            var depthPercent = computeDepthPercent();
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = (0, _types.SCROLL_DEPTH_BUCKETS_IN_ORDER)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var bucket = _step.value;
                    if (firedBucketsRef.current.has(bucket)) continue;
                    if (depthPercent >= BUCKET_PERCENTAGE[bucket]) {
                        firedBucketsRef.current.add(bucket);
                        fireEvent('ui.scrollDepth.reached.twgMicrositeHome', (0, _objectSpread._)({
                            depthBucket: bucket,
                            authState: authStateRef.current
                        }, (0, _attribution.getAttribution)()));
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            if (firedBucketsRef.current.size === (0, _types.SCROLL_DEPTH_BUCKETS_IN_ORDER).length && unbindScroll) {
                unbindScroll();
                unbindScroll = null;
            }
        };
        unbindScroll = (0, _bindEventListener.bind)(win, {
            type: 'scroll',
            listener: onScroll,
            options: {
                passive: true
            }
        });
        // Fire-once on mount in case the page was already scrolled (e.g.
        // reload-with-scroll-restoration).
        onScroll();
        return function() {
            if (unbindScroll) unbindScroll();
            if (throttleHandle !== null) clearTimeout(throttleHandle);
        };
    }, [
        fireEvent
    ]);
};

},{"@swc/helpers/_/_object_spread":"9gdrV","react":"ltHCL","bind-event-listener":"bjeUU","@atlaskit/browser-apis":"2dayt","../../../hooks/use-user-context":"6Qevx","../attribution":"dTmHb","../generated/use-analytics-events":"hpATH","../types":"9GPzn","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6Qevx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAtlassianUserContext", function() {
    return useAtlassianUserContext;
});
var _react = require("react");
var _userProvider = require("../../providers/user-provider");
var useAtlassianUserContext = function() {
    var context = (0, _react.useContext)((0, _userProvider.UserContext));
    if (!context) throw new Error('useAtlassianUserContext must be used within UserProvider');
    return context;
};

},{"react":"ltHCL","../../providers/user-provider":"cEVt6","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cEVt6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UserContext", function() {
    return UserContext;
});
/**
 * UserProvider manages the authentication state and user profile data.
 *
 * Authentication Flow:
 * 1. On mount, attempts to fetch user profile data
 * 2. If profile data is incomplete or fetch fails, triggers handleAuthFailure
 * 3. handleAuthFailure will:
 *    - If automatic auth fails, show a flag to user to manually clear cookies
 *
 * The heartbeat component also triggers handleAuthFailure if session becomes invalid.
 */ parcelHelpers.export(exports, "UserProvider", function() {
    return UserProvider;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRelay = require("react-relay");
var _flag = require("@atlaskit/flag");
var _analyticsClient = require("../../common/analytics/analytics-client");
var _useAnalyticsEvents = require("../../common/analytics/generated/use-analytics-events");
var _sentry = require("../../common/sentry");
var _authFlow = require("./auth-flow");
var _utils = require("./utils");
var UserContext = /*#__PURE__*/ (0, _react.createContext)(undefined);
function UserProvider(param) {
    var children = param.children, onUserLoginComplete = param.onUserLoginComplete;
    var _useState = (0, _slicedToArray._)((0, _react.useState)({
        id: '',
        picture: '',
        accountId: '',
        name: '',
        nickname: '',
        email: '',
        staffId: '',
        isAtlassianEmployee: false,
        organisation: '',
        jobTitle: '',
        orgId: '',
        createdAt: ''
    }), 2), identity = _useState[0], setIdentity = _useState[1];
    var loginRedirectFailed = (0, _react.useRef)(false);
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(true), 2), loading = _useState1[0], setLoading = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(false), 2), error = _useState2[0], setError = _useState2[1];
    var environment = (0, _reactRelay.useRelayEnvironment)();
    var showFlag = (0, _flag.useFlags)().showFlag;
    var fireEvent = (0, _useAnalyticsEvents.useAnalyticsEvents)().fireEvent;
    var handleAuthFailure = (0, _react.useCallback)(function() {
        return (0, _asyncToGenerator._)(function() {
            return (0, _tsGenerator._)(this, function(_state) {
                if ((0, _authFlow.hasAutomaticAuthFailed)()) {
                    loginRedirectFailed.current = true;
                    return [
                        2
                    ];
                }
                return [
                    2
                ];
            });
        })();
    }, []);
    var fetchUserProfile = (0, _react.useCallback)(function() {
        return (0, _asyncToGenerator._)(function() {
            var res, identity;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, _utils.queryUserProfile)(environment)
                        ];
                    case 1:
                        res = _state.sent();
                        if (!res.success) return [
                            3,
                            6
                        ];
                        identity = res.identity;
                        if (!identity.accountId) return [
                            3,
                            4
                        ];
                        if (!onUserLoginComplete) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            onUserLoginComplete === null || onUserLoginComplete === void 0 ? void 0 : onUserLoginComplete(identity)
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        setIdentity(identity);
                        (0, _analyticsClient.setMicrositeUser)(identity.accountId, identity.orgId, null);
                        (0, _sentry.setSentryUser)(identity.accountId);
                        if ((0, _authFlow.consumeLoginPendingMarker)()) fireEvent('track.user.loggedIn', {});
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setIdentity(identity);
                        _state.label = 5;
                    case 5:
                        return [
                            3,
                            8
                        ];
                    case 6:
                        setError(true);
                        return [
                            4,
                            handleAuthFailure()
                        ];
                    case 7:
                        _state.sent();
                        _state.label = 8;
                    case 8:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        environment,
        handleAuthFailure,
        onUserLoginComplete,
        fireEvent
    ]);
    (0, _react.useEffect)(function() {
        fetchUserProfile().finally(function() {
            return setLoading(false);
        });
    }, [
        fetchUserProfile
    ]);
    (0, _react.useEffect)(function() {
        if (!loginRedirectFailed.current) return;
        // For whatever reason, attempting to redirect to login has failed and we need
        // to provide a way for the user to manually resolve their issue.
        showFlag({
            id: 'redirection-failed',
            title: 'Automatic login has failed',
            description: 'Please clear your cookies and try again, or use incognito mode.'
        });
        (0, _authFlow.cleanupClientAuthFlow)();
    }, [
        loginRedirectFailed,
        showFlag
    ]);
    // `isAuthed` is the single boolean source of truth for "the user is
    // signed in and we know who they are". Pre-computed here so consumers
    // (analytics hooks, route gating in `home/index.tsx`, etc.) don't have
    // to re-derive it on every render.
    var isAuthed = !loading && !error && identity.accountId.length > 0;
    var value = (0, _react.useMemo)(function() {
        return {
            identity: identity,
            loading: loading,
            error: error,
            isAuthed: isAuthed,
            attemptUserLogin: (0, _authFlow.attemptClientLogin),
            handleAuthFailure: handleAuthFailure
        };
    }, [
        identity,
        loading,
        error,
        isAuthed,
        handleAuthFailure
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(UserContext.Provider, {
        value: value
    }, children);
}

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_ts_generator":"78Tqx","react":"ltHCL","react-relay":"9HAyN","@atlaskit/flag":"blMWC","../../common/analytics/analytics-client":"aVBNX","../../common/analytics/generated/use-analytics-events":"hpATH","../../common/sentry":"lc1oo","./auth-flow":"b9HLV","./utils":"04ND0","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aVBNX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initAnalyticsClient", function() {
    return initAnalyticsClient;
});
parcelHelpers.export(exports, "getAnalyticsClient", function() {
    return getAnalyticsClient;
});
parcelHelpers.export(exports, "setMicrositeUser", function() {
    return setMicrositeUser;
});
parcelHelpers.export(exports, "__resetAnalyticsClientForTests", function() {
    return __resetAnalyticsClientForTests;
});
var _analyticsWebClient = require("@atlassiansox/analytics-web-client");
var _analyticsWebClientDefault = parcelHelpers.interopDefault(_analyticsWebClient);
var _config = require("../../config");
var product = 'teamworkGraph';
var getIdentityEnv = function(env) {
    switch(env){
        case 'production':
            return 'prod';
        case 'staging':
            return 'staging';
        case 'development':
        case 'local':
        default:
            return 'dev';
    }
};
var getGasApiHost = function(env) {
    switch(env){
        case 'production':
            return "".concat(window.location.host, "/gateway/api/gasv3/api/v1");
        case 'staging':
        case 'development':
        case 'local':
        default:
            return 'team.stg.atlassian.com/gateway/api/gasv3/api/v1';
    }
};
var _client = null;
var initAnalyticsClient = function() {
    if (_client) return _client;
    var _getConfig = (0, _config.getConfig)(), env = _getConfig.env, isLocalDev = _getConfig.isLocalDev;
    _client = new (0, _analyticsWebClientDefault.default)({
        env: getIdentityEnv(env),
        origin: (0, _analyticsWebClient.originType).WEB,
        product: product,
        subproduct: 'twg-microsite-experience'
    }, {
        apiHost: getGasApiHost(env),
        apiHostProtocol: isLocalDev ? 'http' : 'https',
        disableCookiePersistence: true,
        // Default is 500ms; reduce to 100ms to increase reliability of
        // events fired immediately before navigation/redirect (e.g. app
        // switcher, sign-out, cross-origin links). Mirrors WAC's setting
        // in `wac/services/wac-web/src/analytics/wac-analytics/get-analytics-web-client.tsx`.
        flushWaitInterval: 100
    });
    return _client;
};
var getAnalyticsClient = function() {
    if (!_client) throw new Error("AnalyticsWebClient not initialised \u2014 call initAnalyticsClient() first.");
    return _client;
};
var setMicrositeUser = function(aaid, orgId, cloudId) {
    if (!_client) return;
    if (aaid) _client.setUserInfo((0, _analyticsWebClient.userType).ATLASSIAN_ACCOUNT, aaid);
    if (orgId) _client.setTenantInfo((0, _analyticsWebClient.tenantType).ORG_ID, orgId);
    else if (cloudId) _client.setTenantInfo((0, _analyticsWebClient.tenantType).CLOUD_ID, cloudId);
};
var __resetAnalyticsClientForTests = function() {
    _client = null;
};

},{"@atlassiansox/analytics-web-client":"6Epz1","../../config":"sjwAz","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6Epz1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return 0, _analyticsWebClientDefault.default;
});
parcelHelpers.export(exports, "apdexType", function() {
    return 0, _analyticsWebTypes.apdexType;
});
parcelHelpers.export(exports, "envType", function() {
    return 0, _analyticsWebTypes.envType;
});
parcelHelpers.export(exports, "eventType", function() {
    return 0, _analyticsWebTypes.eventType;
});
parcelHelpers.export(exports, "originType", function() {
    return 0, _analyticsWebTypes.originType;
});
parcelHelpers.export(exports, "platformType", function() {
    return 0, _analyticsWebTypes.platformType;
});
parcelHelpers.export(exports, "tenantType", function() {
    return 0, _analyticsWebTypes.tenantType;
});
parcelHelpers.export(exports, "userType", function() {
    return 0, _analyticsWebTypes.userType;
});
parcelHelpers.export(exports, "originTracingType", function() {
    return 0, _analyticsWebTypes.originTracingType;
});
parcelHelpers.export(exports, "TypeAheadHelper", function() {
    return(// Helpers
    0, _typeAheadHelperDefault.default);
});
parcelHelpers.export(exports, "DwellTimeHelper", function() {
    return 0, _dwellTimeHelperDefault.default;
});
parcelHelpers.export(exports, "DwellTimeHelperWithBrowserInteraction", function() {
    return 0, _dwellTimeHelperWithBrowserInteractionDefault.default;
});
parcelHelpers.export(exports, "CompressionRule", function() {
    return 0, _eventDelay.CompressionRule;
});
parcelHelpers.export(exports, "ResilienceMechanism", function() {
    return 0, _resilienceQueue.ResilienceMechanism;
});
parcelHelpers.export(exports, "StopLowPriorityEventDelayReason", function() {
    return 0, _eventDelay.StopLowPriorityEventDelayReason;
});
parcelHelpers.export(exports, "STARGATE_PROXY_PATH", function() {
    return 0, _selectHost.STARGATE_PROXY_PATH;
});
parcelHelpers.export(exports, "perimeterType", function() {
    return 0, _analyticsWebTypes.perimeterType;
});
parcelHelpers.export(exports, "aliasType", function() {
    return 0, _analyticsWebTypes.aliasType;
});
parcelHelpers.export(exports, "groupType", function() {
    return 0, _analyticsWebTypes.groupType;
});
parcelHelpers.export(exports, "productEmbedType", function() {
    return 0, _analyticsWebTypes.productEmbedType;
});
var _analyticsWebClient = require("./analyticsWebClient");
var _analyticsWebClientDefault = parcelHelpers.interopDefault(_analyticsWebClient);
var _analyticsWebTypes = require("./analyticsWebTypes");
var _dwellTimeHelper = require("./dwellTimeHelper");
var _dwellTimeHelperDefault = parcelHelpers.interopDefault(_dwellTimeHelper);
var _dwellTimeHelperWithBrowserInteraction = require("./DwellTimeHelperWithBrowserInteraction");
var _dwellTimeHelperWithBrowserInteractionDefault = parcelHelpers.interopDefault(_dwellTimeHelperWithBrowserInteraction);
var _eventDelay = require("./eventDelay");
var _resilienceQueue = require("./resilienceQueue");
var _selectHost = require("./selectHost");
var _typeAheadHelper = require("./typeAheadHelper");
var _typeAheadHelperDefault = parcelHelpers.interopDefault(_typeAheadHelper);

},{"./analyticsWebClient":"7jOcL","./analyticsWebTypes":"iDbK2","./dwellTimeHelper":false,"./DwellTimeHelperWithBrowserInteraction":false,"./eventDelay":false,"./resilienceQueue":false,"./selectHost":false,"./typeAheadHelper":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7jOcL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LoggingResponseCallback", function() {
    return LoggingResponseCallback;
});
parcelHelpers.export(exports, "default", function() {
    return AnalyticsWebClient;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var _atlassianContext = require("@atlaskit/atlassian-context");
var _analyticsWebTypes = require("./analyticsWebTypes");
var _apdexEvent = require("./apdexEvent");
var _apdexEventDefault = parcelHelpers.interopDefault(_apdexEvent);
var _createGetter = require("./createGetter");
var _createGetterDefault = parcelHelpers.interopDefault(_createGetter);
var _crossProductInteractionTracking = require("./crossProductInteractionTracking");
var _crossProductInteractionTrackingDefault = parcelHelpers.interopDefault(_crossProductInteractionTracking);
var _embedContext = require("./embedContext");
var _eventBuilder = require("./eventBuilder");
var _eventDelay = require("./eventDelay");
var _eventDelayDefault = parcelHelpers.interopDefault(_eventDelay);
var _eventValidation = require("./eventValidation");
var _integration = require("./integration");
var _integrationDefault = parcelHelpers.interopDefault(_integration);
var _metadataClient = require("./integration/metadataClient");
var _originTracing = require("./originTracing");
var _originTracingDefault = parcelHelpers.interopDefault(_originTracing);
var _pageVisibility = require("./pageVisibility");
var _pageVisibilityDefault = parcelHelpers.interopDefault(_pageVisibility);
var _selectHost = require("./selectHost");
var _sessionTracking = require("./sessionTracking");
var _sessionTrackingDefault = parcelHelpers.interopDefault(_sessionTracking);
var _safeSessionStorage = require("./storage/SafeSessionStorage");
var _safeSessionStorageDefault = parcelHelpers.interopDefault(_safeSessionStorage);
var _tabTracking = require("./tabTracking");
var _tabTrackingDefault = parcelHelpers.interopDefault(_tabTracking);
var _taskSessionStore = require("./taskSessionStore");
var _taskSessionStoreDefault = parcelHelpers.interopDefault(_taskSessionStore);
var _testingCache = require("./testingCache");
var _testingCacheDefault = parcelHelpers.interopDefault(_testingCache);
var _uiViewedEvent = require("./uiViewedEvent");
var _uiViewedEventDefault = parcelHelpers.interopDefault(_uiViewedEvent);
var _urlUtils = require("./urlUtils");
var _testSupport = require("./util/testSupport");
var _uuid = require("./uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
var _wrapCallback = require("./wrapCallback");
var _wrapCallbackDefault = parcelHelpers.interopDefault(_wrapCallback);
var _xid = require("./xid");
var LAST_SCREEN_EVENT_STORAGE_KEY = 'last.screen.event';
var LoggingResponseCallback = /*#__PURE__*/ function() {
    "use strict";
    function LoggingResponseCallback() {
        (0, _classCallCheck._)(this, LoggingResponseCallback);
    }
    (0, _createClass._)(LoggingResponseCallback, null, [
        {
            key: "getCallback",
            value: function getCallback(logger) {
                logger = logger || console;
                return function(response) {
                    LoggingResponseCallback.callback(response, logger);
                };
            }
        },
        {
            key: "callback",
            value: function callback(response, logger) {
                var statusCode = response.getStatusCode();
                if (statusCode >= 200 && statusCode <= 299) response.getEventResponseList().forEach(function(eventResponse) {
                    logger.warn('Validation report for event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
                });
                else if (statusCode === 400 || statusCode === 404) {
                    logger.warn('GASv3 submission failed with HTTP Status Code %d: %s', response.getStatusCode(), response.getMessage());
                    response.getEventResponseList().forEach(function(eventResponse) {
                        logger.warn('Event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
                    });
                } else {
                    logger.log('GASv3 submission failed with HTTP Status Code %d: %s', response.getStatusCode(), response.getMessage());
                    response.eventResponseList.forEach(function(eventResponse) {
                        logger.debug('Event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
                    });
                }
            }
        }
    ]);
    return LoggingResponseCallback;
}();
var AnalyticsWebClient = /*#__PURE__*/ function() {
    "use strict";
    function AnalyticsWebClient(productInfo) {
        var _this = this;
        var settings = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, _classCallCheck._)(this, AnalyticsWebClient);
        this._useStargate = function(useStargate) {
            if (useStargate == null) return true;
            return useStargate;
        };
        this._changeInternalUserId = function(userId, anonymousId) {
            _this._eventProcessor.getUser().setUserId(userId);
            if (anonymousId && anonymousId !== _this._eventProcessor.getUser().getAnonymousId()) // Setting anonymous id can take a long time. Reading is a lot faster.
            // Only update if it has changed.
            _this._eventProcessor.getUser().setAnonymousId(anonymousId);
        };
        this._createSubproductGetter = function(subproduct) {
            return (0, _createGetterDefault.default)(subproduct, 'Cannot get subproduct from the callback. Proceeding without it.');
        };
        this._createEmbeddedProductGetter = function(embeddedProduct) {
            return (0, _createGetterDefault.default)(embeddedProduct, 'Cannot get embeddedProduct from the callback. Proceeding without it.');
        };
        this._getLastScreenEvent = function() {
            try {
                return JSON.parse(_this._safeSessionStorage.getItem(LAST_SCREEN_EVENT_STORAGE_KEY) || '');
            } catch (e) {
                _this._safeSessionStorage.removeItem(LAST_SCREEN_EVENT_STORAGE_KEY);
                return null;
            }
        };
        this._setLastScreenEvent = function(event) {
            _this._safeSessionStorage.setItem(LAST_SCREEN_EVENT_STORAGE_KEY, JSON.stringify({
                name: event.name,
                attributes: event.attributes
            }));
        };
        this._shouldEventBeDelayed = function(event) {
            // TODO: this is a temporary restriction for the purposes of the Track All Changes project
            // The delay mechanism has a chance of event loss, which we can only accept for our own data at this point.
            // Once the delay queue implementation has been improved and measured to confirm that it is reliable enough,
            // then we will be able to open it up for other products to use by removing this check.
            if (!event.tags || event.tags.indexOf('measurement') === -1) return false;
            var isEventHighPriority = event.highPriority !== false; // defaults to true if excluded
            return _this._eventDelayQueue.isDelayingLowPriorityEvents() && !isEventHighPriority;
        };
        this._fireEvent = function(identifier, builtEvent, context, callback) {
            switch(builtEvent.eventType){
                case (0, _analyticsWebTypes.eventType).UI:
                case (0, _analyticsWebTypes.eventType).OPERATIONAL:
                case (0, _analyticsWebTypes.eventType).TRACK:
                    return _this._eventProcessor.track(identifier, builtEvent, context, callback);
                case (0, _analyticsWebTypes.eventType).SCREEN:
                    return _this._eventProcessor.page(identifier, builtEvent, context, callback);
                case (0, _analyticsWebTypes.eventType).IDENTIFY:
                    return _this._eventProcessor.identify(identifier, builtEvent, context, callback);
                default:
                    throw new Error("No handler has been defined for events of type ".concat(builtEvent.eventType));
            }
        };
        this._fireDelayedEvent = function(identifier, builtEvent, context, userInfo) {
            try {
                // User information can change while the delay period is active, so we need to restore the values that
                // were active when the event was originally fired.
                _this._changeInternalUserId(userInfo.userId, userInfo.anonymousId);
                builtEvent.tags = (0, _toConsumableArray._)(builtEvent.tags || []).concat([
                    'sentWithDelay'
                ]);
                // The callbacks for delayed events are fired immediately, so there is nothing to pass through for this argument.
                _this._fireEvent(identifier, builtEvent, context, undefined);
            } finally{
                _this._changeInternalUserId(_this._userInfo.userId, _this._userInfo.anonymousId);
            }
        };
        this._delayEvent = function(identifier, builtEvent, context, userInfo, callback) {
            _this._eventDelayQueue.push(identifier, builtEvent, context, userInfo);
            // Fire the callback immediately, as we can consider the event successfully processed at this point
            if (callback) callback();
        };
        this._processEvent = function(identifier, builtEvent, context, callback) {
            _this._testingCache.saveEvent(builtEvent);
            if (_this._shouldEventBeDelayed(builtEvent)) {
                _this._delayEvent(identifier, builtEvent, context, _this._userInfo, callback);
                return Promise.resolve();
            } else return _this._fireEvent(identifier, builtEvent, context, callback);
        };
        this.setEmbeddedProduct = function(embeddedProduct) {
            _this._internalProductInfo.embeddedProduct = _this._createEmbeddedProductGetter(embeddedProduct);
            _this.resetUIViewedTimers();
        };
        this.clearEmbeddedProduct = function() {
            _this._internalProductInfo.embeddedProduct = _this._createEmbeddedProductGetter(null);
        };
        this.setSubproduct = function(subproduct) {
            _this._internalProductInfo.subproduct = _this._createSubproductGetter(subproduct);
            _this.resetUIViewedTimers();
        };
        /**
   * Calling this function in the intialisation of the client in product
   * captures specified 'origin tracing' URL params and fires a single origin landed event
   * <p>
   * This function expects a mapping between the keys for any URL parameters
   *  that should be captured and removed for origin tracing
   * Multiple parameters may be captured simultaneously if multiple key: handler function pairs are provided
   * Each handler function should return an object with two items
   * a) 'originTracingAttributes' - an object that will be added to the 'origin landed' event's attributes under 'originTracing
   * b) 'taskSessionId' (optional) - an Id string that will be added to the tasksessions for any event that fires from the tab, with the key
   *    matching the URL parameter, for the purpose of attributing subsequent analytics event to the origin land.
   * </p>
   * The general use case for this feature is for allowing attributation of user behaviour to a out of product or cross product link,
   * e.g. from a share or email
   *
   * An example calling this function using an external decoding library, with taskSessionId specified to persist
   * analyticsWebClient.setOriginTracingHandlers({
        atlOrigin: encodedOrigin => {
            const { id, product } = OriginTracing.fromEncoded(encodedOrigin);
            return { originTracingAttributes: {'id': id, 'product': product}, taskSessionId: id };
        },
    });
   *
   * @param  {Object} originParamHandlerMapping a dictionary of mappings between origin url param keys and handler functions
   * @this {AnalyticsWebClient}
   */ this.setOriginTracingHandlers = function(originParamHandlerMapping) {
            var capturedOriginTraces = _this._originTracing.handleOriginParameters(originParamHandlerMapping, _this._historyReplaceFn);
            var keys = Object.keys(capturedOriginTraces);
            keys.forEach(function(x) {
                if (typeof capturedOriginTraces[x].taskSessionId !== 'undefined') _this._task.createTaskSessionWithProvidedId(x, capturedOriginTraces[x].taskSessionId);
            });
            var originAttributes = {};
            keys.forEach(function(x) {
                if (capturedOriginTraces[x].originTracingAttributes) originAttributes[x] = capturedOriginTraces[x].originTracingAttributes;
                else // eslint-disable-next-line no-console
                console.warn("Handling method for origin parameter ".concat(x, " has not returned any attributes"));
            });
            if (keys.length > 0) return _this.sendOperationalEvent({
                action: 'landed',
                actionSubject: 'origin',
                source: 'webClient',
                attributes: {
                    originTracesLanded: originAttributes
                }
            }, // eslint-disable-next-line @typescript-eslint/no-empty-function
            function() {});
            return Promise.resolve();
        };
        this.setTenantInfo = function(tenantIdType, tenantId) {
            if (!tenantIdType) throw new Error('Missing tenantIdType');
            if (tenantIdType !== (0, _analyticsWebTypes.tenantType).NONE && !tenantId) throw new Error('Missing tenantId');
            if (!(0, _analyticsWebTypes.isType)((0, _analyticsWebTypes.tenantType), tenantIdType)) throw new Error("Invalid tenantIdType '".concat(tenantIdType, "', ") + "must be an tenantType: [".concat((0, _analyticsWebTypes.objectValues)((0, _analyticsWebTypes.tenantType)), "]"));
            _this._tenantInfo = {
                tenantIdType: tenantIdType,
                tenantId: tenantId
            };
            _this._eventProcessor.refreshMetadata(_this._userInfo, _this._tenantInfo);
        };
        this.clearTenantInfo = function() {
            _this._tenantInfo = {};
            _this._eventProcessor.refreshMetadata(_this._userInfo, _this._tenantInfo);
        };
        this.setOrgInfo = function(orgId) {
            if (!orgId) throw new Error('Missing orgId');
            _this._orgInfo = {
                orgId: orgId
            };
        };
        this.clearOrgInfo = function() {
            _this._orgInfo = {};
        };
        this.setWorkspaceInfo = function(workspaceId) {
            if (!workspaceId) throw new Error('Missing workspaceId');
            _this._workspaceInfo = {
                workspaceId: workspaceId
            };
        };
        this.clearWorkspaceInfo = function() {
            _this._workspaceInfo = {};
        };
        this.setCollaborationContextInfo = function(collaborationContextAri) {
            if (!collaborationContextAri) throw new Error('Missing collaborationContextAri');
            _this._collaborationContextInfo = {
                collaborationContextAri: collaborationContextAri
            };
        };
        this.clearCollaborationContextInfo = function() {
            _this._collaborationContextInfo = {};
        };
        this.setUserInfo = function(userIdType, userId) {
            (0, _eventValidation.validateIdentifyEvent)(userIdType, userId);
            _this._changeInternalUserId(userId);
            _this._userInfo = {
                userIdType: userIdType,
                userId: userId,
                anonymousId: _this._eventProcessor.getUser().getAnonymousId()
            };
            _this._eventProcessor.refreshMetadata(_this._userInfo, _this._tenantInfo);
        };
        this.clearUserInfo = function() {
            _this._changeInternalUserId(undefined);
            _this._userInfo = {
                anonymousId: _this._eventProcessor.getUser().getAnonymousId()
            };
            _this._eventProcessor.refreshMetadata(_this._userInfo, _this._tenantInfo);
        };
        this.setAlias = function(aliasKeyType, alias) {
            if (!aliasKeyType) throw new Error('Missing aliasType');
            if (!(0, _analyticsWebTypes.isType)((0, _analyticsWebTypes.aliasType), aliasKeyType)) throw new Error("Invalid aliasType '".concat(aliasKeyType, "', ") + "must be an aliasType: [".concat((0, _analyticsWebTypes.objectValues)((0, _analyticsWebTypes.aliasType)), "]"));
            _this._aliases[aliasKeyType] = alias;
        };
        this.clearAlias = function() {
            _this._aliases = {};
        };
        this.setGroup = function(groupsKeyType, group) {
            if (!groupsKeyType) throw new Error('Missing groupType');
            if (!(0, _analyticsWebTypes.isType)((0, _analyticsWebTypes.groupType), groupsKeyType)) throw new Error("Invalid groupType '".concat(groupsKeyType, "', ") + "must be an groupType: [".concat((0, _analyticsWebTypes.objectValues)((0, _analyticsWebTypes.groupType)), "]"));
            _this._groups[groupsKeyType] = group;
        };
        this.clearGroup = function() {
            _this._groups = {};
        };
        this.getAnonymousId = function() {
            return _this._userInfo.anonymousId;
        };
        this.getCurrentSessionId = function() {
            return _this._sessionTracking.getCurrentSessionId();
        };
        this.setUIViewedAttributes = function(uiViewedAttributes) {
            if (!uiViewedAttributes) throw new Error('Missing uiViewedAttributes');
            if ((typeof uiViewedAttributes === "undefined" ? "undefined" : (0, _typeOf._)(uiViewedAttributes)) !== 'object' || Array.isArray(uiViewedAttributes)) throw new Error('Invalid uiViewedAttributes type, should be a non array object');
            _this._uiViewedAttributes = (0, _objectSpread._)({}, uiViewedAttributes);
        };
        this.getUIViewedAttributes = function() {
            return _this._uiViewedAttributes;
        };
        this.clearUIViewedAttributes = function() {
            _this._uiViewedAttributes = {};
        };
        this.appendUIViewedAttributes = function(attributes) {
            if (!_this._uiViewedAttributes) _this._uiViewedAttributes = attributes;
            else _this._uiViewedAttributes = (0, _objectSpread._)({}, _this._uiViewedAttributes, attributes);
        };
        this.sendIdentifyEvent = function(userIdType, userId, callback) {
            _this.setUserInfo(userIdType, userId);
            var builtEvent = {
                userIdType: userIdType,
                eventType: (0, _analyticsWebTypes.eventType).IDENTIFY
            };
            return _this._processEvent(userId, builtEvent, _this._context, callback);
        };
        /**
	 * @deprecated
	 * please use {@link sendScreenEvent instead)
	 */ this.sendPageEvent = function(name, callback) {
            return _this.sendScreenEvent(name, callback);
        };
        /**
	 * send screen event
	 * @param event The event / For retrocompatibility event name is still supported here.
	 * @param callback
	 * @param attributes. Deprecated, will get ignored if using an event object as first param.
	 */ this.sendScreenEvent = function(event, callback, attributes) {
            var screenName;
            var screenAttributes;
            var screenContainers;
            var screenTags;
            if ((typeof event === "undefined" ? "undefined" : (0, _typeOf._)(event)) === 'object') {
                /* This is for retrocompatibility */ screenName = event.name;
                screenAttributes = event.attributes;
                screenContainers = event.containers;
                screenTags = event.tags;
            } else {
                screenName = event;
                screenAttributes = attributes;
            }
            (0, _eventValidation.validateScreenEvent)(screenName);
            (0, _eventValidation.validateContainers)(screenContainers);
            var builtEvent = (0, _eventBuilder.buildScreenEvent)(_this._internalProductInfo, _this._tenantInfo, _this._userInfo, screenAttributes, // TODO: Remove the as any and move into a place where we know event is an object
            event.nonPrivacySafeAttributes, screenTags, _this._tabTracking.getCurrentTabId(), _this._sessionTracking.getCurrentSessionId(), _this._task.getAllTaskSessions(), _this._crossProductInteractionTracking.getInteractionSession(), _this._orgInfo, _this._pageLoadId, _this._workspaceInfo, _this._collaborationContextInfo, event, screenContainers, _this._aliases, _this._groups);
            var builtEventWithName = (0, _objectSpread._)({
                name: screenName
            }, builtEvent);
            _this._setLastScreenEvent(builtEventWithName);
            return _this._processEvent(screenName, builtEventWithName, _this._context, (0, _wrapCallbackDefault.default)(callback, builtEventWithName));
        };
        this.sendTrackEvent = function(event, callback) {
            (0, _eventValidation.validateTrackEvent)(event);
            var builtEvent = (0, _eventBuilder.buildActionEvent)(_this._internalProductInfo, _this._tenantInfo, _this._userInfo, event, (0, _analyticsWebTypes.eventType).TRACK, _this._tabTracking.getCurrentTabId(), _this._sessionTracking.getCurrentSessionId(), _this._task.getAllTaskSessions(), _this._crossProductInteractionTracking.getInteractionSession(), _this._orgInfo, _this._pageLoadId, _this._workspaceInfo, _this._collaborationContextInfo, _this._aliases, _this._groups);
            return _this._processEvent((0, _eventBuilder.buildActionName)(event), builtEvent, _this._context, (0, _wrapCallbackDefault.default)(callback, builtEvent));
        };
        this.sendUIEvent = function(event, callback) {
            (0, _eventValidation.validateUIEvent)(event);
            var builtEvent = (0, _eventBuilder.buildActionEvent)(_this._internalProductInfo, _this._tenantInfo, _this._userInfo, event, (0, _analyticsWebTypes.eventType).UI, _this._tabTracking.getCurrentTabId(), _this._sessionTracking.getCurrentSessionId(), _this._task.getAllTaskSessions(), _this._crossProductInteractionTracking.getInteractionSession(), _this._orgInfo, _this._pageLoadId, _this._workspaceInfo, _this._collaborationContextInfo, _this._aliases, _this._groups);
            return _this._processEvent((0, _eventBuilder.buildActionName)(event), builtEvent, _this._context, (0, _wrapCallbackDefault.default)(callback, builtEvent));
        };
        this.sendOperationalEvent = function(event, callback) {
            (0, _eventValidation.validateOperationalEvent)(event);
            var builtEvent = (0, _eventBuilder.buildActionEvent)(_this._internalProductInfo, _this._tenantInfo, _this._userInfo, event, (0, _analyticsWebTypes.eventType).OPERATIONAL, _this._tabTracking.getCurrentTabId(), _this._sessionTracking.getCurrentSessionId(), _this._task.getAllTaskSessions(), _this._crossProductInteractionTracking.getInteractionSession(), _this._orgInfo, _this._pageLoadId, _this._workspaceInfo, _this._collaborationContextInfo, _this._aliases, _this._groups);
            return _this._processEvent((0, _eventBuilder.buildActionName)(event), builtEvent, _this._context, (0, _wrapCallbackDefault.default)(callback, builtEvent));
        };
        this.startUIViewedEvent = function(callback) {
            _this.stopUIViewedEvent();
            _this._uiViewedEvent = _this.createUIViewedEvent(callback);
            _this._uiViewedEvent.start();
        };
        this.stopUIViewedEvent = function() {
            if (_this._uiViewedEvent) {
                _this._uiViewedEvent.stop();
                _this._uiViewedEvent = null;
            }
        };
        this.resetUIViewedTimers = function() {
            if (_this._uiViewedEvent) _this._uiViewedEvent.resetTimers();
        };
        this.signalUserActive = function() {
            var uiViewedEvent = _this._uiViewedEvent || _this.createUIViewedEvent(null);
            uiViewedEvent.signalUserActive();
        };
        this.createUIViewedEvent = function(callback) {
            return new (0, _uiViewedEventDefault.default)(_this._internalProductInfo, function() {
                return {
                    embeddedProduct: _this._internalProductInfo.embeddedProduct(),
                    subproduct: _this._internalProductInfo.subproduct(),
                    tenantIdType: _this._tenantInfo.tenantIdType,
                    tenantId: _this._tenantInfo.tenantId,
                    userId: _this._userInfo.userId,
                    lastScreenEvent: _this._getLastScreenEvent(),
                    attributes: _this._uiViewedAttributes
                };
            }, function(event) {
                return _this.sendUIEvent(event, callback);
            });
        };
        this.startApdexEvent = function(apdexEvent) {
            _this._apdexEvent.start(apdexEvent);
        };
        this.getApdexStart = function(apdexEvent) {
            return _this._apdexEvent.getStart(apdexEvent);
        };
        this.stopApdexEvent = function(apdexEvent, callback) {
            _this._apdexEvent.stop(apdexEvent, callback);
        };
        // TODO If we ever make another breaking change, merge these two optional args into an `options` object arg.
        this.startLowPriorityEventDelay = function(timeout, callback) {
            _this._eventDelayQueue.startLowPriorityEventDelay(timeout, callback);
        };
        this.stopLowPriorityEventDelay = function() {
            _this._eventDelayQueue.stopLowPriorityEventDelay();
        };
        this.onEvent = function(_analyticsId, analyticsData) {
            if (!analyticsData) throw new Error('Missing analyticsData');
            if (!analyticsData.eventType) throw new Error('Missing analyticsData.eventType');
            if (analyticsData.eventType === (0, _analyticsWebTypes.eventType).TRACK) return _this.sendTrackEvent(analyticsData);
            else if (analyticsData.eventType === (0, _analyticsWebTypes.eventType).UI) return _this.sendUIEvent(analyticsData);
            else if (analyticsData.eventType === (0, _analyticsWebTypes.eventType).OPERATIONAL) return _this.sendOperationalEvent(analyticsData);
            else if (analyticsData.eventType === (0, _analyticsWebTypes.eventType).SCREEN) return _this.sendScreenEvent(analyticsData.name, null, analyticsData.attributes);
            else if (analyticsData.eventType === (0, _analyticsWebTypes.eventType).IDENTIFY) return _this.sendIdentifyEvent(analyticsData.userIdType, analyticsData.userId);
            throw new Error("Invalid analyticsData.eventType '".concat(analyticsData.eventType, "', ") + "must be an eventType: [".concat((0, _analyticsWebTypes.objectValues)((0, _analyticsWebTypes.eventType)), "]"));
        };
        this.setResponseCallback = function(responseCallback) {
            _this._eventProcessor.setResponseCallback(responseCallback);
        };
        if (!productInfo) throw new Error('Missing productInfo');
        if (!productInfo.env) throw new Error('Missing productInfo.env');
        if (!productInfo.product) throw new Error('Missing productInfo.product');
        if (!(0, _analyticsWebTypes.isType)((0, _analyticsWebTypes.envType), productInfo.env)) throw new Error("Invalid productInfo.env '".concat(productInfo.env, "', ") + "must be an envType: [".concat((0, _analyticsWebTypes.objectValues)((0, _analyticsWebTypes.envType)), "]"));
        if (!productInfo.origin) productInfo.origin = (0, _analyticsWebTypes.originType).WEB;
        else if (!(0, _analyticsWebTypes.isType)((0, _analyticsWebTypes.originType), productInfo.origin)) throw new Error("Invalid productInfo.origin '".concat(productInfo.origin, "', ") + "must be an originType: [".concat((0, _analyticsWebTypes.objectValues)((0, _analyticsWebTypes.originType)), "]"));
        if (!productInfo.platform) productInfo.platform = productInfo.origin === (0, _analyticsWebTypes.originType).WEB ? (0, _analyticsWebTypes.platformType).WEB : (0, _analyticsWebTypes.platformType).DESKTOP;
        else (0, _eventValidation.validatePlatform)(productInfo);
        this._logger = settings.logger || console;
        // Auto-detect Oasis perimeter (e.g. FedRAMP Moderate) when the consumer hasn't explicitly provided a perimeter.
        if (!productInfo.perimeter) try {
            if ((0, _atlassianContext.isFedrampModerate)()) productInfo.perimeter = (0, _analyticsWebTypes.perimeterType).FEDRAMP_MODERATE;
        } catch (e) {
            this._logger.warn('Failed to auto-detect perimeter: %s', (0, _instanceof._)(e, Error) ? e.message : String(e));
        }
        // Default to commercial perimeter if not explicitly provided and not auto-detected.
        if (!productInfo.perimeter) productInfo.perimeter = (0, _analyticsWebTypes.perimeterType).COMMERCIAL;
        if (!(0, _analyticsWebTypes.isType)((0, _analyticsWebTypes.perimeterType), productInfo.perimeter)) throw new Error("Invalid productInfo.perimeter '".concat(productInfo.perimeter, "', ") + "must be a perimeterType: [".concat((0, _analyticsWebTypes.objectValues)((0, _analyticsWebTypes.perimeterType)), "]"));
        // Auto-detect Oasis Isolated Cloud (IC) environment when the consumer hasn't explicitly provided an `ic` value.
        if (!productInfo.ic) try {
            var icId = (0, _atlassianContext.isolationContextId)();
            if (icId && icId.length > 0) productInfo.ic = icId;
        } catch (e) {
            this._logger.warn('Failed to auto-detect isolation context: %s', (0, _instanceof._)(e, Error) ? e.message : String(e));
        }
        this._internalProductInfo = (0, _objectSpreadProps._)((0, _objectSpread._)({}, productInfo), {
            subproduct: this._createSubproductGetter(productInfo.subproduct),
            embeddedProduct: this._createEmbeddedProductGetter(productInfo.embeddedProduct)
        });
        this._tenantInfo = {};
        this._orgInfo = {};
        this._uiViewedAttributes = {};
        if (productInfo === null || productInfo === void 0 ? void 0 : productInfo.embeddedContext) {
            this._embeddedContext = productInfo.embeddedContext;
            if ((0, _embedContext.isFirstParty)(this._embeddedContext)) this.setUIViewedAttributes({
                embeddedType: this._embeddedContext['embeddedType'],
                embeddedFromProduct: this._embeddedContext['embeddedFromProduct'],
                embeddedFromSubproduct: this._embeddedContext['embeddedFromSubproduct'],
                embeddedFromTopLevelDomain: this._embeddedContext['embeddedFromTopLevelDomain']
            });
            if ((0, _embedContext.isThirdParty)(this._embeddedContext)) this.setUIViewedAttributes({
                embeddedType: this._embeddedContext['embeddedType'],
                embeddedFromTopLevelDomain: this._embeddedContext['embeddedFromTopLevelDomain']
            });
        }
        this._context = (0, _eventBuilder.buildContext)(this._internalProductInfo);
        this._safeSessionStorage = new (0, _safeSessionStorageDefault.default)();
        var useStargate = this._useStargate(settings.useStargate);
        var apiHost = (0, _selectHost.selectHost)({
            useStargate: useStargate,
            env: productInfo.env,
            useLegacyUrl: settings.useLegacyUrl,
            perimeter: productInfo.perimeter,
            ic: productInfo.ic,
            envOverride: productInfo.envOverride,
            apiHost: settings.apiHost
        });
        var apiHostProtocol = settings.apiHostProtocol || 'https';
        var minRetryDelay = settings.minRetryDelay || 1000;
        var maxAttempts = settings.maxRetryAttempts !== undefined && Number.isInteger(settings.maxRetryAttempts) && settings.maxRetryAttempts >= 0 ? settings.maxRetryAttempts + 1 : undefined;
        var retryQueueOptions = {
            maxRetryDelay: 60000,
            minRetryDelay: minRetryDelay,
            backoffFactor: 2,
            flushWaitMs: settings.flushWaitInterval,
            flushBeforeUnload: settings.flushBeforeUnload,
            maxAttempts: maxAttempts,
            maxQueueSize: settings.maxQueueSize
        };
        var retryQueuePrefix = "awc-".concat(productInfo.env);
        var xidPromiseGetter = function() {
            return (0, _xid.XIDPromise)(settings.xidConsent, settings.xidPromiseFn);
        };
        var disableCookiePersistence = settings.disableCookiePersistence || false;
        var metadataClientFactory = settings.metadataClientFactory || (0, _metadataClient.MetadataClient).Factory;
        var metadataClient = metadataClientFactory(apiHostProtocol, apiHost, productInfo.product);
        this._eventProcessor = new (0, _integrationDefault.default)({
            apiHost: apiHost,
            apiHostProtocol: apiHostProtocol,
            product: productInfo.product,
            retryQueuePrefix: retryQueuePrefix,
            retryQueueOptions: retryQueueOptions,
            xidPromiseGetter: xidPromiseGetter,
            logger: this._logger,
            metadataClient: metadataClient,
            disableCookiePersistence: disableCookiePersistence,
            responseCallback: LoggingResponseCallback.getCallback(this._logger),
            env: productInfo.env,
            perimeter: productInfo.perimeter,
            enableMetadataCalls: this.metadataCallsEnabled(settings),
            enableEventCalls: this.eventCallsEnabled(settings)
        });
        this._userInfo = {
            anonymousId: this._eventProcessor.getUser().getAnonymousId(settings === null || settings === void 0 ? void 0 : settings.customAnonymousIdGenerator)
        };
        this._pageVisibility = new (0, _pageVisibilityDefault.default)();
        this._tabTracking = new (0, _tabTrackingDefault.default)();
        this._sessionTracking = new (0, _sessionTrackingDefault.default)({
            sessionExpiryTime: settings.sessionExpiryTime,
            onNewSessionStarted: settings.onNewSessionStarted
        });
        this._task = new (0, _taskSessionStoreDefault.default)();
        this._originTracing = new (0, _originTracingDefault.default)();
        this._eventProcessor.setOriginTracingClient(this._originTracing);
        // Init Apdex
        this._apdexEvent = new (0, _apdexEventDefault.default)(this.sendOperationalEvent, this._pageVisibility);
        this._historyReplaceFn = typeof settings.historyReplaceFn === 'function' ? settings.historyReplaceFn : (0, _urlUtils.defaultHistoryReplaceFn);
        this._eventDelayQueue = new (0, _eventDelayDefault.default)(this._fireDelayedEvent, settings.delayQueueCompressors || []);
        this._testingCache = new (0, _testingCacheDefault.default)(settings.isSynthetic, settings.enableTestingCache);
        this._pageLoadId = (0, _uuidDefault.default)();
        this._workspaceInfo = {};
        this._collaborationContextInfo = {};
        this._aliases = {};
        this._groups = {};
        this._crossProductInteractionTracking = new (0, _crossProductInteractionTrackingDefault.default)({
            perimeter: productInfo.perimeter,
            product: productInfo.product,
            sendEventCallback: this.sendOperationalEvent,
            historyReplaceFn: this._historyReplaceFn
        });
        this._crossProductInteractionTracking.validateInteractionSession();
    }
    (0, _createClass._)(AnalyticsWebClient, [
        {
            key: "metadataCallsEnabled",
            value: function metadataCallsEnabled(settings) {
                if (typeof settings.disableMetadataCalls === 'boolean') return !settings.disableMetadataCalls;
                return !(0, _testSupport.TestSupport).isGeminiVREnvironment() && !(0, _testSupport.TestSupport).areFetchCallsDisabled();
            }
        },
        {
            key: "eventCallsEnabled",
            value: function eventCallsEnabled(settings) {
                if (typeof settings.disableEventCalls === 'boolean') return !settings.disableEventCalls;
                return !(0, _testSupport.TestSupport).isGeminiVREnvironment() && !(0, _testSupport.TestSupport).areFetchCallsDisabled();
            }
        },
        {
            key: "setEventValidationMode",
            value: function setEventValidationMode(eventValidationMode) {
                this._context.context.validationMode = eventValidationMode;
            }
        },
        {
            key: "task",
            get: /**
	 * @private
	 * @deprecated
	 * Please avoid using internal properties. They are not part of the public
	 * API and may change without notice.
	 *
	 * This property has been exposed for backward compatibility with existing
	 * tests in external code
	 */ function get() {
                return this._task;
            }
        },
        {
            key: "_productInfo",
            get: /**
	 * @private
	 * @deprecated
	 * Please avoid using internal properties.
	 * They are not part of the public API and may change without notice.
	 *
	 * This property has been exposed for backward compatibility with existing
	 * tests in external code
	 */ function get() {
                return this._internalProductInfo;
            }
        }
    ]);
    return AnalyticsWebClient;
}();

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_to_consumable_array":"1eSZf","@swc/helpers/_/_type_of":"iFJdx","@atlaskit/atlassian-context":"82Y9X","./analyticsWebTypes":"iDbK2","./apdexEvent":"abz10","./createGetter":"c0byT","./crossProductInteractionTracking":"ifCzG","./embedContext":"iau6s","./eventBuilder":"l3Cu2","./eventDelay":"hXyCv","./eventValidation":"eBvzD","./integration":"efpMW","./integration/metadataClient":"hIjKw","./originTracing":"c5maO","./pageVisibility":"a4f88","./selectHost":"1oSN0","./sessionTracking":"fAITv","./storage/SafeSessionStorage":"kOhYp","./tabTracking":"aX3f1","./taskSessionStore":"2z4RG","./testingCache":"cfbrE","./uiViewedEvent":"zoaIm","./urlUtils":"6G7Ig","./util/testSupport":"g7FOR","./uuid":"gL2xH","./wrapCallback":"fzAu5","./xid":"54XC1","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iDbK2":[function(require,module,exports,__globalThis) {
// These types have been converted from frozen objects to enums.
// We cannot change their name, or even capitalise them without breaking API.
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "envType", function() {
    return envType;
});
parcelHelpers.export(exports, "eventType", function() {
    return eventType;
});
parcelHelpers.export(exports, "platformType", function() {
    return platformType;
});
parcelHelpers.export(exports, "originType", function() {
    return originType;
});
parcelHelpers.export(exports, "tenantType", function() {
    return tenantType;
});
parcelHelpers.export(exports, "productEmbedType", function() {
    return productEmbedType;
});
parcelHelpers.export(exports, "userType", function() {
    return userType;
});
parcelHelpers.export(exports, "apdexType", function() {
    return apdexType;
});
parcelHelpers.export(exports, "desktopPlatforms", function() {
    return desktopPlatforms;
});
parcelHelpers.export(exports, "webPlatforms", function() {
    return webPlatforms;
});
parcelHelpers.export(exports, "originTracingType", function() {
    return originTracingType;
});
parcelHelpers.export(exports, "objectValues", function() {
    return objectValues;
});
parcelHelpers.export(exports, "isType", function() {
    return isType;
});
parcelHelpers.export(exports, "perimeterType", function() {
    return perimeterType;
});
parcelHelpers.export(exports, "aliasType", function() {
    return aliasType;
});
parcelHelpers.export(exports, "groupType", function() {
    return groupType;
});
parcelHelpers.export(exports, "envOverrides", function() {
    return envOverrides;
});
var envType = /*#__PURE__*/ function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
    return envType;
}({});
var eventType = /*#__PURE__*/ function(eventType) {
    eventType["TRACK"] = "track";
    eventType["UI"] = "ui";
    eventType["OPERATIONAL"] = "operational";
    eventType["SCREEN"] = "screen";
    eventType["IDENTIFY"] = "identify";
    return eventType;
}({});
var platformType = /*#__PURE__*/ function(platformType) {
    platformType["MAC"] = "mac";
    platformType["LINUX"] = "linux";
    platformType["WINDOWS"] = "windows";
    /**
	 *  @deprecated desktop is here for retrocompatibility, please select one of the above OS instead.
	 */ platformType["DESKTOP"] = "desktop";
    platformType["WEB"] = "web";
    platformType["MOBILE_WEB"] = "mobileWeb";
    return platformType;
}({});
var originType = /*#__PURE__*/ function(originType) {
    originType["DESKTOP"] = "desktop";
    originType["WEB"] = "web";
    return originType;
}({});
var tenantType = /*#__PURE__*/ function(tenantType) {
    tenantType["CLOUD_ID"] = "cloudId";
    tenantType["ORG_ID"] = "orgId";
    tenantType["OPSGENIE_CUSTOMER_ID"] = "opsgenieCustomerId";
    tenantType["HALP_TEAM_ID"] = "halpTeamId";
    tenantType["LOOM_ORG_ID"] = "loomOrgId";
    tenantType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    tenantType["TRELLO_WORKSPACE_ID"] = "trelloWorkspaceId";
    tenantType["JA_WORKSPACE_ID"] = "jiraAlignWorkspaceId";
    tenantType["STUDIO_WORKSPACE_ID"] = "studioWorkspaceId";
    tenantType["NONE"] = "none";
    return tenantType;
}({});
var productEmbedType = /*#__PURE__*/ function(productEmbedType) {
    productEmbedType["FIRST_PARTY"] = "FIRST_PARTY";
    productEmbedType["THIRD_PARTY"] = "THIRD_PARTY";
    return productEmbedType;
}({});
var userType = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["LOOM"] = "loom";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["JA_USER_ID"] = "jiraAlign";
    userType["HALP"] = "halp";
    return userType;
}({});
var apdexType = /*#__PURE__*/ function(apdexType) {
    apdexType["TRANSITION"] = "transition";
    apdexType["INITIAL_LOAD"] = "initialLoad";
    return apdexType;
}({});
var desktopPlatforms = Object.freeze([
    "desktop",
    "mac",
    "linux",
    "windows"
]);
var webPlatforms = Object.freeze([
    "web",
    "mobileWeb"
]);
var originTracingType = /*#__PURE__*/ function(originTracingType) {
    originTracingType["ATL_ORIGIN"] = "atlOrigin";
    return originTracingType;
}({});
function objectValues(object) {
    return Object.values(object);
}
function isType(type, value) {
    return Object.values(type).indexOf(value) > -1;
}
var perimeterType = /*#__PURE__*/ function(perimeterType) {
    perimeterType["C5"] = "c5";
    perimeterType["COMMERCIAL"] = "commercial";
    perimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    perimeterType["FEDRAMP_HIGH"] = "fedramp-high";
    return perimeterType;
}({});
var aliasType = /*#__PURE__*/ function(aliasType) {
    return aliasType;
}({});
var groupType = /*#__PURE__*/ function(groupType) {
    groupType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    return groupType;
}({});
var envOverrides = /*#__PURE__*/ function(envOverrides) {
    return envOverrides;
}({});

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"abz10":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return ApdexEvent;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _analyticsWebTypes = require("./analyticsWebTypes");
var _pageVisibility = require("./pageVisibility");
var _pageVisibilityDefault = parcelHelpers.interopDefault(_pageVisibility);
var _performance = require("./performance");
var _performanceDefault = parcelHelpers.interopDefault(_performance);
var ApdexEvent = /*#__PURE__*/ function() {
    "use strict";
    function ApdexEvent(onEvent, pageVisibility) {
        var _this = this;
        (0, _classCallCheck._)(this, ApdexEvent);
        this._getEventKey = function(param) {
            var task = param.task, taskId = param.taskId;
            return taskId ? "".concat(task, ".").concat(taskId) : task;
        };
        this._getEventTimingByName = function(name) {
            var eventTimings = _this._performance.getEntriesByName(name);
            var eventTiming = eventTimings[eventTimings.length - 1];
            return eventTiming;
        };
        this._getApdexFields = function(event) {
            var apdexTimings = _this._getApdexTimings(event);
            var apdexScore = _this._calculateApdex({
                duration: apdexTimings.duration,
                threshold: event.threshold
            });
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, apdexTimings), {
                apdex: apdexScore
            });
        };
        this._getApdexTimings = function(event) {
            var eventKey = _this._getEventKey(event);
            var eventStartName = "".concat(eventKey, "-start");
            var startTime = event.startTime || _this._getStartTime(event, eventStartName);
            var stopTime = event.stopTime || _this._getStopTime();
            // We do some clean up of the marks and started events
            _this._cleanApdexState(eventKey);
            return {
                startTime: startTime,
                stopTime: stopTime,
                duration: stopTime - startTime
            };
        };
        this._getStartTime = function(event, eventName) {
            var startTime;
            var timeOrigin = _this._performance.getTimeOrigin();
            if (event.type === (0, _analyticsWebTypes.apdexType).INITIAL_LOAD) startTime = timeOrigin;
            else {
                var eventTiming = _this._getEventTimingByName(eventName);
                startTime = timeOrigin + eventTiming.startTime;
            }
            return startTime;
        };
        this._getStopTime = function() {
            return _this._performance.getTimeOrigin() + _this._performance.now();
        };
        this._cleanApdexState = function(eventKey) {
            _this._performance.clearMarks("".concat(eventKey, "-start"));
            _this._performance.clearMarks("".concat(eventKey, "-stop"));
            _this._startedEvents.delete(eventKey);
        };
        this._getVisibilityFields = function(event) {
            var isActiveTab;
            /**
		 * For initialLoad type:
		 * 1. if tab was not ever hidden (!_wasPreviouslyHidden)
		 *
		 * For transition type:
		 * 1. active status is tracked in active events map (_isActiveEvents)
		 *
		 * For any type, if startTime or stopTime is specified:
		 * 1. If currently active (!_isHidden)
		 */ if (event.type === (0, _analyticsWebTypes.apdexType).INITIAL_LOAD) isActiveTab = !_this._wasPreviouslyHidden;
            else if (event.type === (0, _analyticsWebTypes.apdexType).TRANSITION) {
                var eventKey = _this._getEventKey(event);
                isActiveTab = _this._isActiveEvents.get(eventKey);
            }
            if (event.startTime || event.stopTime) isActiveTab = !_this._pageVisibility.getIsHidden();
            return {
                isActiveTab: isActiveTab
            };
        };
        this._calculateApdex = function(param) {
            var duration = param.duration, _param_threshold = param.threshold, threshold = _param_threshold === void 0 ? _this._threshold : _param_threshold;
            var apdex;
            var satisfiedThreshold = threshold;
            var tolerableThreshold = threshold * 4;
            if (duration <= satisfiedThreshold) apdex = 1;
            else if (duration <= tolerableThreshold) apdex = 0.5;
            else apdex = 0;
            return apdex;
        };
        this._validateStartEvent = function(event) {
            if (!event) throw new Error('Missing "event" in Apdex start event');
            if (!event.task) throw new Error('Missing "task" in Apdex start event');
            if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex start event');
            if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex start event');
        };
        this._validateStopEvent = function(event) {
            if (!event) throw new Error('Missing "event" in Apdex stop event');
            if (!event.task) throw new Error('Missing "task" in Apdex stop event');
            if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex stop event');
            if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex stop event');
            if (!event.type) throw new Error('Missing "type" in Apdex stop event');
            if (event.type && !(0, _analyticsWebTypes.isType)((0, _analyticsWebTypes.apdexType), event.type)) throw new Error('Invalid "type" in Apdex stop event');
            if (event.threshold && typeof event.threshold !== 'number') throw new Error('Invalid "threshold" in Apdex stop event');
            /*
		 * For a transition, if the startTime was not specified,
		 * the start event should have been present.
		 */ if (!event.startTime && event.type === (0, _analyticsWebTypes.apdexType).TRANSITION) {
                var eventKey = _this._getEventKey(event);
                if (!_this._startedEvents.has(eventKey)) throw new Error('Apdex event transition "'.concat(eventKey, '" was not started'));
            }
            if (event.startTime && !(typeof event.startTime === 'number' && event.startTime >= 0)) throw new Error('Invalid "startTime" in Apdex stop event');
            if (event.stopTime && typeof event.stopTime !== 'number') throw new Error('Invalid "stopTime" in Apdex stop event');
            if (event.stopTime <= event.startTime) throw new Error('"stopTime" should be greater than "startTime" in Apdex stop event');
        };
        this._shouldSendEvent = function(event) {
            if (!event) return false;
            if (typeof event.apdex !== 'number') return false;
            return true;
        };
        this._sendEvent = function(event, callback) {
            if (_this._shouldSendEvent(event)) _this._onEvent({
                source: 'ui',
                action: 'readyForUser',
                actionSubject: 'ui',
                attributes: (0, _objectSpreadProps._)((0, _objectSpread._)({}, event.additionalAttributes), {
                    task: event.task,
                    taskId: event.taskId,
                    type: event.type,
                    threshold: event.threshold || _this._threshold,
                    apdex: event.apdex,
                    startTime: event.startTime,
                    stopTime: event.stopTime,
                    duration: event.duration,
                    isActiveTab: event.isActiveTab
                })
            }, callback);
        };
        if (!onEvent) throw new Error('Missing onEvent callback');
        if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
        if (!(0, _instanceof._)(pageVisibility, (0, _pageVisibilityDefault.default))) throw new Error('Invalid pageVisibility, must be PageVisibility class');
        this._startedEvents = new Map();
        this._performance = new (0, _performanceDefault.default)();
        this._onEvent = onEvent;
        this._threshold = 1000;
        this._wasPreviouslyHidden = pageVisibility.getIsHidden();
        this._isActiveEvents = new Map();
        this._pageVisibility = pageVisibility;
        this._pageVisibility.addCallback('apdexEvent', function(isHidden) {
            _this.onVisibilityChange(!isHidden);
        });
    }
    (0, _createClass._)(ApdexEvent, [
        {
            key: "start",
            value: function start(event) {
                this._validateStartEvent(event);
                if (!this._performance.isAvailable()) return;
                var eventKey = this._getEventKey(event);
                var eventStartName = "".concat(eventKey, "-start");
                this._startedEvents.set(eventKey, true);
                this._isActiveEvents.set(eventKey, !this._pageVisibility.getIsHidden());
                this._performance.clearMarks(eventStartName);
                this._performance.mark(eventStartName);
            }
        },
        {
            key: "getStart",
            value: function getStart(event) {
                this._validateStartEvent(event);
                if (!this._performance.isAvailable()) return undefined;
                var eventKey = this._getEventKey(event);
                var eventStartName = "".concat(eventKey, "-start");
                return this._getEventTimingByName(eventStartName);
            }
        },
        {
            key: "stop",
            value: function stop(event, callback) {
                this._validateStopEvent(event);
                if (!this._performance.isAvailable()) return;
                var apdexFields = this._getApdexFields(event);
                var visibilityFields = this._getVisibilityFields(event);
                this._sendEvent((0, _objectSpread._)({}, event, apdexFields, visibilityFields), callback);
            }
        },
        {
            key: "onVisibilityChange",
            value: function onVisibilityChange(isActive) {
                var _this = this;
                if (!isActive) {
                    this._wasPreviouslyHidden = true;
                    Array.from(this._isActiveEvents.keys()).forEach(function(key) {
                        return _this._isActiveEvents.set(key, false);
                    });
                }
            }
        }
    ]);
    return ApdexEvent;
}();

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","./analyticsWebTypes":"iDbK2","./pageVisibility":"a4f88","./performance":"3csHB","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"a4f88":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return PageVisibility;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var PageVisibility = /*#__PURE__*/ function() {
    "use strict";
    function PageVisibility() {
        var _this = this;
        (0, _classCallCheck._)(this, PageVisibility);
        this._bindEventListeners = function() {
            document.addEventListener(_this._visibilityChange, _this._handleVisibilityChange, false);
        };
        this._handleVisibilityChange = function() {
            var isHidden = document[_this._hidden];
            _this._isHidden = isHidden;
            _this._callbacks.forEach(function(callbackFn) {
                return callbackFn(isHidden);
            });
        };
        this._isHidden = false;
        this._callbacks = new Map();
        this._hidden = undefined;
        this._visibilityChange = undefined;
        if (typeof document !== 'undefined') {
            if (typeof document.hidden !== 'undefined') {
                // Opera 12.10 and Firefox 18 and later support
                this._isHidden = document.hidden;
                this._hidden = 'hidden';
                this._visibilityChange = 'visibilitychange';
            } else if (typeof document.msHidden !== 'undefined') {
                this._isHidden = document.msHidden;
                this._hidden = 'msHidden';
                this._visibilityChange = 'msvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                this._isHidden = document.webkitHidden;
                this._hidden = 'webkitHidden';
                this._visibilityChange = 'webkitvisibilitychange';
            }
            if (typeof document.addEventListener !== 'undefined' && this._hidden !== undefined) this._bindEventListeners();
        }
    }
    (0, _createClass._)(PageVisibility, [
        {
            key: "addCallback",
            value: function addCallback(name, fn) {
                if (typeof name !== 'string') throw new Error('Invalid name, must be string');
                if (typeof fn !== 'function') throw new Error('Invalid callback, must be function');
                this._callbacks.set(name, fn);
            }
        },
        {
            key: "removeCallback",
            value: function removeCallback(name) {
                if (this._callbacks.has(name)) this._callbacks.delete(name);
            }
        },
        {
            key: "getIsHidden",
            value: function getIsHidden() {
                return this._isHidden;
            }
        }
    ]);
    return PageVisibility;
}();

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3csHB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return Performance;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var Performance = /*#__PURE__*/ function() {
    "use strict";
    function Performance() {
        (0, _classCallCheck._)(this, Performance);
        this._performance = window.performance;
    }
    (0, _createClass._)(Performance, [
        {
            key: "clearMarks",
            value: function clearMarks() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _this__performance;
                if (!this._performance || !this._performance.clearMarks) return;
                (_this__performance = this._performance).clearMarks.apply(_this__performance, (0, _toConsumableArray._)(args));
            }
        },
        {
            key: "mark",
            value: function mark() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _this__performance;
                if (!this._performance || !this._performance.mark) return;
                (_this__performance = this._performance).mark.apply(_this__performance, (0, _toConsumableArray._)(args));
            }
        },
        {
            key: "getEntriesByName",
            value: function getEntriesByName() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _this__performance;
                if (!this._performance || !this._performance.getEntriesByName) return [];
                return (_this__performance = this._performance).getEntriesByName.apply(_this__performance, (0, _toConsumableArray._)(args));
            }
        },
        {
            key: "getTimeOrigin",
            value: function getTimeOrigin() {
                if (!this._performance || !this._performance.timeOrigin && !this._performance.timing) return 0;
                return this._performance.timeOrigin || this._performance.timing.navigationStart;
            }
        },
        {
            key: "now",
            value: function now() {
                if (!this._performance || !this._performance.now) return Date.now ? Date.now() : +new Date();
                return this._performance.now();
            }
        },
        {
            key: "isAvailable",
            value: function isAvailable() {
                return !!this._performance && !!this._performance.clearMarks && !!this._performance.mark && !!this._performance.getEntriesByName && !!this._performance.timing;
            }
        }
    ]);
    return Performance;
}();

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_to_consumable_array":"1eSZf","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"c0byT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _instanceof = require("@swc/helpers/_/_instanceof");
/**
 * Wraps {possibleFn} into a error-safe function and handles cases where {possibleFn}
 * is a function or object
 *
 * @param possibleFn - function that returns and object or the object itself
 * @param errorMessage - error message to log if {possibleFn} is a function and
 *                        throws an error when called
 * @returns {Function}
 */ var isFunction = function(possibleFn) {
    return typeof possibleFn === 'function';
};
exports.default = function(possibleFn, errorMessage) {
    return function() {
        if (isFunction(possibleFn)) try {
            return possibleFn();
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error("".concat(errorMessage, " - ").concat((0, _instanceof._)(e, Error) ? e.message : String(e)));
            return undefined;
        }
        return possibleFn;
    };
};

},{"@swc/helpers/_/_instanceof":"h9UKc","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ifCzG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * This class initialises the Analytics Cross Product Interaction Client, which keeps track of the
 * interactionSessionId we use to track cross-product user journeys.
 *
 * It parses URL query parameters for any previous interaction session attributes.
 * If none exist, the Analytics Cross Product Interaction Client will generate a new
 * interactionSessionId, and the class will expose a method for retrieving this from Session Storage
 *
 * @param sendEventCallback: Expects a callback function that can send an analytics event
 */ parcelHelpers.export(exports, "default", function() {
    return CrossProductInteractionTracking;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _analyticsCrossProductInteractionClient = require("@atlassiansox/analytics-cross-product-interaction-client");
var _analyticsCrossProductInteractionClientDefault = parcelHelpers.interopDefault(_analyticsCrossProductInteractionClient);
var _analyticsWebTypes = require("./analyticsWebTypes");
var _urlUtils = require("./urlUtils");
var _urlUtilsDefault = parcelHelpers.interopDefault(_urlUtils);
var isCrossProductInteractionAttribute = function(_, paramName) {
    return paramName === (0, _analyticsCrossProductInteractionClient.URL_QUERY_PARAM_INTERACTION_SESSION);
};
var CrossProductInteractionTracking = /*#__PURE__*/ function() {
    "use strict";
    function CrossProductInteractionTracking(options) {
        (0, _classCallCheck._)(this, CrossProductInteractionTracking);
        this.validProduct = false;
        this.isEnabled = options.perimeter !== (0, _analyticsWebTypes.perimeterType).FEDRAMP_MODERATE;
        this.urlValidation = {
            result: true,
            url: ''
        };
        this.sendEventCallback = options.sendEventCallback;
        if (this.isEnabled) {
            var bridge;
            var interactionSessionId;
            var interactionSource;
            var interactionSessionOptions;
            this.urlValidation.url = window.location.href;
            // Validate product
            //
            // Various UI components in the page might initialize their own AWC instances but some of those
            // instances might be associated with subordinate products that are of no interest to XPC tracking. We
            // want to avoid XPC meta analytics being fired against uninteresting products.
            //
            // Some products (e.g. Confluence) also have custom URL replace functions passed into AWC settings,
            // and we need to use those to ensure our query parameter is correctly processed.
            //
            // TODO - this is currently the best way we can try and guarantee that the most relevant product's AWC
            // is passing in the options. Down the line we ideally want the relevant products themselves to opt-in
            // to initialising cross product tracking via a flag in their AWC init options.
            this.validProduct = (0, _analyticsCrossProductInteractionClient.validProducts).includes(options.product);
            if (this.validProduct) {
                // Only parse URL parameters if we are in a valid product
                var crossProductUrlPramater = (0, _urlUtilsDefault.default)(isCrossProductInteractionAttribute, options.historyReplaceFn);
                var interactionSessionBlob = (0, _analyticsCrossProductInteractionClient.URL_QUERY_PARAM_INTERACTION_SESSION) in crossProductUrlPramater ? crossProductUrlPramater[0, _analyticsCrossProductInteractionClient.URL_QUERY_PARAM_INTERACTION_SESSION] : null;
                if (interactionSessionBlob) try {
                    var interactionSession = JSON.parse(atob(interactionSessionBlob));
                    if (interactionSession.bridge && interactionSession.id && interactionSession.source) {
                        // All 3 fields must be present from a valid query param
                        bridge = interactionSession.bridge;
                        interactionSessionId = interactionSession.id;
                        interactionSource = interactionSession.source;
                    } else this.urlValidation.result = false;
                } catch (e) {
                    // Gracefully fail through if parameter has been corrupted
                    this.urlValidation.result = false;
                }
                interactionSessionOptions = {
                    analyticsEventCallback: this.sendEventCallback,
                    persistedSessionId: interactionSessionId
                };
            }
            // Initialise interaction session client with parsed values if they exist
            this.analyticsCrossProductInteractionClient = new (0, _analyticsCrossProductInteractionClientDefault.default)(interactionSessionOptions, bridge, interactionSource);
        }
    }
    (0, _createClass._)(CrossProductInteractionTracking, [
        {
            key: "getInteractionSession",
            value: function getInteractionSession() {
                if (this.isEnabled && this.analyticsCrossProductInteractionClient) return {
                    bridge: this.analyticsCrossProductInteractionClient.getBridge(),
                    id: this.analyticsCrossProductInteractionClient.getCurrentInteractionSessionId(),
                    prevId: this.analyticsCrossProductInteractionClient.getPreviousInteractionSessionId(),
                    source: this.analyticsCrossProductInteractionClient.getInteractionSource()
                };
                else return {
                    bridge: null,
                    id: null,
                    prevId: null,
                    source: null
                };
            }
        },
        {
            /**
	 * Validates the cross product interaction session parameters parsed from the URL (if present)
	 * If the Base64-encoded URL does not decode into a valid JSON object
	 *
	 * This method must be called out of the constructor, as the sendEventCallback we expect here
	 * depends on crossProductInteractionTracking.getInteractionSession() so the class must be initialised
	 */ key: "validateInteractionSession",
            value: function validateInteractionSession() {
                if (!this.urlValidation.result) this.sendEventCallback({
                    action: 'corrupted',
                    actionSubject: 'interactionSession',
                    attributes: {
                        url: this.urlValidation.url
                    },
                    source: 'interactionComponent',
                    tags: [
                        'navigationExperiences'
                    ]
                });
            }
        }
    ]);
    return CrossProductInteractionTracking;
}();

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@atlassiansox/analytics-cross-product-interaction-client":"66GCY","./analyticsWebTypes":"iDbK2","./urlUtils":"6G7Ig","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"66GCY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return 0, _analyticsCrossProductInteractionClientDefault.default;
});
parcelHelpers.export(exports, "useCrossProductUrlWrapper", function() {
    return 0, _useCrossProductUrlWrapperDefault.default;
});
parcelHelpers.export(exports, "URL_QUERY_PARAM_INTERACTION_SESSION", function() {
    return 0, _generateUrlWithParams.URL_QUERY_PARAM_INTERACTION_SESSION;
});
parcelHelpers.export(exports, "validProducts", function() {
    return 0, _productList.validProducts;
});
var _analyticsCrossProductInteractionClient = require("./analyticsCrossProductInteractionClient");
var _analyticsCrossProductInteractionClientDefault = parcelHelpers.interopDefault(_analyticsCrossProductInteractionClient);
var _productList = require("./config/productList");
var _generateUrlWithParams = require("./generateUrlWithParams");
var _useCrossProductUrlWrapper = require("./useCrossProductUrlWrapper");
var _useCrossProductUrlWrapperDefault = parcelHelpers.interopDefault(_useCrossProductUrlWrapper);

},{"./analyticsCrossProductInteractionClient":"zZpZV","./config/productList":"2BQQj","./generateUrlWithParams":"lF5r7","./useCrossProductUrlWrapper":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"zZpZV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "INTERACTION_SESSION_SOURCE_KEY", function() {
    return INTERACTION_SESSION_SOURCE_KEY;
});
parcelHelpers.export(exports, "INTERACTION_SESSION_BRIDGE_KEY", function() {
    return INTERACTION_SESSION_BRIDGE_KEY;
});
/**
 * AnalyticsCrossProductInteractionClient is a wrapper for the InteractionSessionTracking class.
 * It is designed to be used internally within the Atlassian Analytics Pipeline as well as useCrossProductUrlWrapper hook.
 * It is not intended to be used directly by end-users.
 *
 * This will create an instance of the interaction session tracker on the window object, which can be shared across different parts of a document.
 * If the internal client already exists, it will use the existing instance. Creating the client in a singleton manner like this enables us
 * to debounce updates to Session Storage, which is important when a large number of links using our hook are rendered on a page.
 *
 * The other interaction session parameters are written directly to session storage as they are predominantly read-only,
 * with the only update being the initialisation of the client
 */ parcelHelpers.export(exports, "default", function() {
    return AnalyticsCrossProductInteractionClient;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _frontendFeatureEncoding = require("@atlassiansox/frontend-feature-encoding");
var _atlassianContext = require("@atlaskit/atlassian-context");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _globalInteractionSessionTracking = require("./globalInteractionSessionTracking");
var _globalInteractionSessionTrackingDefault = parcelHelpers.interopDefault(_globalInteractionSessionTracking);
var _safeSessionStorage = require("./storage/SafeSessionStorage");
var _safeSessionStorageDefault = parcelHelpers.interopDefault(_safeSessionStorage);
var INTERACTION_SESSION_SOURCE_KEY = 'interactionSession.source';
var INTERACTION_SESSION_BRIDGE_KEY = 'interactionSession.bridge';
var AnalyticsCrossProductInteractionClient = function AnalyticsCrossProductInteractionClient(interactionSessionOptions, bridge, interactionSource) {
    "use strict";
    var _this = this;
    (0, _classCallCheck._)(this, AnalyticsCrossProductInteractionClient);
    this.getCurrentInteractionSessionId = function() {
        return _this.isEnabled && _this.interactionSessionTracking ? _this.interactionSessionTracking.getCurrentInteractionSessionId() : null;
    };
    this.getPreviousInteractionSessionId = function() {
        return _this.isEnabled && _this.interactionSessionTracking ? _this.interactionSessionTracking.getPreviousInteractionSessionId() : null;
    };
    this.getBridge = function() {
        return _this.isEnabled && _this.safeSessionStorage ? _this.safeSessionStorage.getItem(INTERACTION_SESSION_BRIDGE_KEY) : null;
    };
    this.getInteractionSource = function() {
        return _this.isEnabled && _this.safeSessionStorage ? _this.safeSessionStorage.getItem(INTERACTION_SESSION_SOURCE_KEY) : null;
    };
    var shouldDisable = (0, _platformFeatureFlags.fg)('use_frontend_feature_encoding_sdk_platform') ? !(0, _frontendFeatureEncoding.isFeatureEnabled)('atlassian-analytics', 'atlassian-analytics-cross-product-interaction-client') : (0, _atlassianContext.isFedrampModerate)();
    this.isEnabled = !shouldDisable;
    if (this.isEnabled) {
        // Get singleton interaction session tracking instance
        this.interactionSessionTracking = (0, _globalInteractionSessionTrackingDefault.default).getInstance();
        var isValidPersistedId = false;
        if (this.interactionSessionTracking) {
            if (interactionSessionOptions) {
                this.interactionSessionTracking.setAnalyticsCallback(interactionSessionOptions.analyticsEventCallback);
                isValidPersistedId = this.interactionSessionTracking.setInteractionSessionId(interactionSessionOptions.persistedSessionId);
            }
        }
        this.safeSessionStorage = new (0, _safeSessionStorageDefault.default)();
        // Store other interaction session parameters directly in session storage if ID has been validated
        if (isValidPersistedId) {
            bridge && this.safeSessionStorage.setItem(INTERACTION_SESSION_BRIDGE_KEY, bridge);
            interactionSource && this.safeSessionStorage.setItem(INTERACTION_SESSION_SOURCE_KEY, interactionSource);
        }
    }
};

},{"@swc/helpers/_/_class_call_check":"5CNCO","@atlassiansox/frontend-feature-encoding":"diVt0","@atlaskit/atlassian-context":"82Y9X","@atlaskit/platform-feature-flags":"kO5t9","./globalInteractionSessionTracking":"jpb52","./storage/SafeSessionStorage":"2qCeB","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"diVt0":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isFeatureEnabled = exports.isEnvironmentBlockEnabled = void 0;
var FeatureEncoding_1 = require("ad32032723832785");
Object.defineProperty(exports, "isEnvironmentBlockEnabled", {
    enumerable: true,
    get: function get() {
        return FeatureEncoding_1.isEnvironmentBlockEnabled;
    }
});
Object.defineProperty(exports, "isFeatureEnabled", {
    enumerable: true,
    get: function get() {
        return FeatureEncoding_1.isFeatureEnabled;
    }
});

},{"ad32032723832785":"9YIH5"}],"9YIH5":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isFeatureEnabled = exports.isEnvironmentBlockEnabled = void 0;
var atlassian_context_1 = require("32f7ff7b62b9a35c");
var feature_encoding_core_1 = require("4968bddbafafeb34");
var FeatureOverrides_1 = require("b61437912681e209");
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM
 * @returns if the environment block is available in the current cloud environment
 */ function isEnvironmentBlockEnabled(environmentBlockName) {
    var boundaryKey = getBoundaryKey();
    return (0, feature_encoding_core_1.isEnvironmentBlockEnabledForBoundary)(environmentBlockName, boundaryKey);
}
exports.isEnvironmentBlockEnabled = isEnvironmentBlockEnabled;
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM (the environment block that the feature belongs to)
 * @param featureName Name of feature as encoded in AEM
 * @param offeringPredicates Optional map of boundary keys to predicate functions. When a predicate
 *   is provided for the current boundary, the feature is only considered enabled if both
 *   the AEM state and the predicate return true.
 * @returns if the feature is available in the current cloud environment
 */ function isFeatureEnabled(environmentBlockName, featureName, offeringPredicates) {
    var override = (0, FeatureOverrides_1.getFeatureOverride)(environmentBlockName, featureName);
    if (override !== null) return override;
    var boundaryKey = getBoundaryKey();
    var aemResult = (0, feature_encoding_core_1.isFeatureEnabledForBoundary)(environmentBlockName, featureName, boundaryKey);
    if (!aemResult) return false;
    var predicate = offeringPredicates ? offeringPredicates[boundaryKey] : undefined;
    return predicate ? predicate() : true;
}
exports.isFeatureEnabled = isFeatureEnabled;
function getBoundaryKey() {
    if ((0, atlassian_context_1.isFedrampModerate)()) return feature_encoding_core_1.FED_MOD_KEY;
    if ((0, atlassian_context_1.isIsolatedCloud)()) return feature_encoding_core_1.ISOLATED_CLOUD_COMMERCIAL_KEY;
    return feature_encoding_core_1.COMMERCIAL_KEY;
}
// Register global API on window for browser dev tools usage
if (typeof window !== "undefined") window.__AEM_FEATURE_JS__ = {
    checkFeature: isFeatureEnabled,
    overrideFeature: FeatureOverrides_1.overrideFeature,
    clearFeatureOverride: FeatureOverrides_1.clearFeatureOverride,
    clearAllOverrides: FeatureOverrides_1.clearAllOverrides
};

},{"32f7ff7b62b9a35c":"82Y9X","4968bddbafafeb34":"kQyGS","b61437912681e209":"3gD30"}],"kQyGS":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ISOLATED_CLOUD_COMMERCIAL_KEY = exports.FED_MOD_KEY = exports.COMMERCIAL_KEY = exports.UnderAuditPhase = exports.BOUNDARY_KEYS_LIST = exports.getFeatureAvailabilityMetadataForBoundary = exports.isFeatureEnabledForBoundary = exports.isEnvironmentBlockEnabledForBoundary = void 0;
var FeatureEncoding_1 = require("4c976524b619360f");
Object.defineProperty(exports, "isEnvironmentBlockEnabledForBoundary", {
    enumerable: true,
    get: function get() {
        return FeatureEncoding_1.isEnvironmentBlockEnabledForBoundary;
    }
});
var FeatureEncoding_2 = require("4c976524b619360f");
Object.defineProperty(exports, "isFeatureEnabledForBoundary", {
    enumerable: true,
    get: function get() {
        return FeatureEncoding_2.isFeatureEnabledForBoundary;
    }
});
var FeatureEncoding_3 = require("4c976524b619360f");
Object.defineProperty(exports, "getFeatureAvailabilityMetadataForBoundary", {
    enumerable: true,
    get: function get() {
        return FeatureEncoding_3.getFeatureAvailabilityMetadataForBoundary;
    }
});
var types_1 = require("716e3c5ac9618d44");
Object.defineProperty(exports, "BOUNDARY_KEYS_LIST", {
    enumerable: true,
    get: function get() {
        return types_1.BOUNDARY_KEYS_LIST;
    }
});
Object.defineProperty(exports, "UnderAuditPhase", {
    enumerable: true,
    get: function get() {
        return types_1.UnderAuditPhase;
    }
});
Object.defineProperty(exports, "COMMERCIAL_KEY", {
    enumerable: true,
    get: function get() {
        return types_1.COMMERCIAL_KEY;
    }
});
Object.defineProperty(exports, "FED_MOD_KEY", {
    enumerable: true,
    get: function get() {
        return types_1.FED_MOD_KEY;
    }
});
Object.defineProperty(exports, "ISOLATED_CLOUD_COMMERCIAL_KEY", {
    enumerable: true,
    get: function get() {
        return types_1.ISOLATED_CLOUD_COMMERCIAL_KEY;
    }
});

},{"4c976524b619360f":"9VaAb","716e3c5ac9618d44":"f15HN"}],"9VaAb":[function(require,module,exports,__globalThis) {
"use strict";
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getFeatureAvailabilityMetadataForBoundary = exports.isFeatureEnabledForBoundary = exports.isEnvironmentBlockEnabledForBoundary = void 0;
var sdk_data_json_1 = __importDefault(require("9bea491fbe77c7ac"));
var aemEnvironmentBlockData = sdk_data_json_1.default;
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM
 * @param boundaryKey The boundary to evaluate for.
 *
 * @returns if the environment block is available in the current cloud environment
 */ function isEnvironmentBlockEnabledForBoundary(environmentBlockName, boundaryKey) {
    return environmentBlockInBoundary(environmentBlockName, boundaryKey);
}
exports.isEnvironmentBlockEnabledForBoundary = isEnvironmentBlockEnabledForBoundary;
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM (the environment block that the feature belongs to)
 * @param featureName Name of feature as encoded in AEM
 * @param boundaryKey The boundary to evaluate for
 *
 * @returns if the feature is available in the current cloud environment
 */ function isFeatureEnabledForBoundary(environmentBlockName, featureName, boundaryKey) {
    if (environmentBlockInBoundary(environmentBlockName, boundaryKey)) {
        var environmentBlockData = aemEnvironmentBlockData.environmentBlocks[environmentBlockName];
        var feature = environmentBlockData.features[featureName];
        if (!feature) return false;
        return feature.compositions[boundaryKey] === true;
    }
    return false;
}
exports.isFeatureEnabledForBoundary = isFeatureEnabledForBoundary;
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM (the environment block that the feature belongs to)
 * @param featureName Name of feature as encoded in AEM
 * @param boundaryKey The boundary to evaluate for
 *
 * @returns the availability metadata for the feature in the given boundary, or undefined if none
 */ function getFeatureAvailabilityMetadataForBoundary(environmentBlockName, featureName, boundaryKey) {
    var block = aemEnvironmentBlockData.environmentBlocks[environmentBlockName];
    if (!block) return undefined;
    var feature = block.features[featureName];
    if (!feature) return undefined;
    return feature.availabilityMetadata && feature.availabilityMetadata[boundaryKey];
}
exports.getFeatureAvailabilityMetadataForBoundary = getFeatureAvailabilityMetadataForBoundary;
function environmentBlockInBoundary(environmentBlockName, boundaryKey) {
    var block = aemEnvironmentBlockData.environmentBlocks[environmentBlockName];
    if (!block) return false;
    return block.compositions[boundaryKey] === true;
}

},{"9bea491fbe77c7ac":"by4vc"}],"by4vc":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"environmentBlocks\":{\"adminhub\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"adminhub-access-requests\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-add-app-beta-grid\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-add-app-collections-grid\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-add-app-discover-grid\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-add-app-enterprise-grid\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-add-app-standalone-apps-grid\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-add-product\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-admin-insights\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-api-token-controls\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-app-requests\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-app-updates\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-application-tunnels\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-apps-discovery\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-audit-log\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-authentication-policies\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-backup-and-restore\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-billing-console\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-byok\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-cmk-encryption\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-connected-emoji\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-connected-sources\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-contacts\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-custom-domain-email-notification\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-custom-domains\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-data-classifications\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-data-management\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-data-residency\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-data-security-policies\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-data-transfer\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-discover-apps-shadow-it\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-discover-new-products\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-experiment-controls\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-external-user-security\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-guard-detect-alerts\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-guard-detect-detections\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-help\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-hippa-compliance\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-jsm-scim\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-link-bitbucket\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-llm\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-managed-accounts-export\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-mobile-app-policy\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-nested-side-navigation\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-org-audit-logs\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-org-create\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-org-deletion\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-org-transfer\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-product-insights\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-product-links\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-product-recommendation\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-release-tracks\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-revamped-organization-overview\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-saml-sso\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-sandbox\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-site-rename\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-site-transfer\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-system-health\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-use-available-apps\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-user-access-invites\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-user-access-settings\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-user-counts\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-user-last-active-timestamp\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-workspaces-table-plans\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}}}},\"assets\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{\"assets-data-manager\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"assets-recent-items\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"assets-reports\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}}}},\"atlassian-analytics\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"atlassian-analytics-3p-data-source-connections\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"atlassian-analytics-chart-dashboard-pdf-png-exports\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"atlassian-analytics-chart-templates\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"atlassian-analytics-charts\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"atlassian-analytics-comments\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"atlassian-analytics-commerce-sentry\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"atlassian-analytics-cross-product-interaction-client\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"atlassian-analytics-dashboard-subscriptions\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"atlassian-analytics-dashboard-templates\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"atlassian-analytics-dashboards\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"atlassian-analytics-data-lake-connections\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"atlassian-analytics-data-shares\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"atlassian-analytics-jira-align-enterprise-insights-connections\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}}}},\"bitbucket\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{\"bitbucket-slack-app\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"pipelines\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}}}},\"chat\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"compass\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"confluence\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"ccma\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-ai\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"confluence-anonymous-access\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"confluence-comment-and-header-links\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-company-hub\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"confluence-content-archiving\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-content-manager\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-databases\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"confluence-editing-experience\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-editor-offline-storage\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"confluence-employee-directory\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-forge-apps-sidebar\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-inline-comments-in-edit-mode\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-inspect-permissions\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-invitations\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-loom-integration\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"confluence-mission-control\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-mobile-app\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"confluence-ms-teams-integration\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-page-analytics\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-pages-blogs-folders\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-presenter-mode\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-public-links\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"confluence-questions-native-experience\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"confluence-questions\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-search\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-server\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-share-to-slack-button\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"confluence-single-space-guests\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"confluence-slack-integration\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-slides\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"confluence-smart-links\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-space-analytics\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-team-calendars\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"confluence-update-page-owners\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-whiteboards\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}}}},\"customer-service-management\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"dx\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"focus\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"goals\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"guard-premium\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"guard-standard\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"home\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{\"home-status-backend\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}}}},\"jira\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"jcma-x2c\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jcma\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-apps-menu\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-atlassian-intelligence\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-atlassian-vs-code-extension\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-audit-log\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-backlogs\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-boards-and-views\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-calendar-view\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-company-managed-projects\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-components\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jira-development-tab-druid-metric-cards\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jira-development-tab\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-forms\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-github-for-jira\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-github-workflows\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jira-in-product-help\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jira-insights\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-issue\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-loom-banner\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jira-mobile-app\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jira-oasis-reports\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-opsgenie\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jira-plans\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-project-archiving\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-project-issue-navigator\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-project-templates\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-quickstart-pages\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jira-releases\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-share\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-site-optimiser\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-slack\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-smart-links\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-team-managed-projects\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-work-item-archiving\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-workflow-configuration\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-your-work-dashboard\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}}}},\"jira-align\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"jira-product-discovery\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"jira-service-management\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"jira-service-management-help-center\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-ai-ops\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-ai-services\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-alert-notifications\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-approvals\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-automation-playbook\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-boysenberry\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-canned-responses\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-change-calendar\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-change-risk-assessment\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-chat-ops\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-chat\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-cloud-megatron\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-csat\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-csm-functionality\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-customer-access-internal-account\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-customer-notifications\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-customer-service-management\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-deployment-gating\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-deployment-tracking\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-developer-escalations\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-email-requests\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-embeddable-widget\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-entity-migration\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-err-governance-api\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-external-customer-accounts\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-external-customer-single-sign-on\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-external-customer-user-provisioning\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-forms\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-help-center-change-password\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-help-center-password-login\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-help-center-rovo-agent\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-help-center-virtual-agent\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-help-center\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-incident-conference-calls\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-incident-management-integration\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-issue\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-journey-builder\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-knowledge-base\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-multi-language-support\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-on-call-schedule\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-ops-genie-reporting\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-opsgenie-devops\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-portal-only-account-scim\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-post-incident-reviews\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-queues\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-related-issues\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-reports-operations\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-request-intake\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-services\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-shield\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-sla-management\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-status-page-integration\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-surveys\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-templates-and-views\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-virtual-service-agent\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"opsgenie\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}}}},\"loom\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"projects\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"rovo\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{\"rovo-ai-app-availability\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"rovo-ai-atlassian-intelligence-app-availability\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"rovo-ai-generative-ai-editor\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"rovo-ai-machine-learning\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"rovo-ai-natural-language-in-automation-rule-creation\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"rovo-ai-projects\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"rovo-ai-smart-features-based-on-machine-learning-tecton-ai\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"rovo-editor-ai-panels\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}}}},\"rovo-dev\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"statuspage\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"studio\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"talent\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"teams\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"teams-platform\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"teams-profile-media-token-fetch\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"teams-third-party-invites\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"user-provided-banners-on-profile-pictures\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}}}},\"trello\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"anti-abuse-platform\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"application-tunnels\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"atlassian-cli\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"atlassian-visualization-platform\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"atlassian-visualization-platform-kamino\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"atlassian-visualization-platform-manifold\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}}}},\"central-ai\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"ai-3p-connections\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"ai-safety\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"collaboration-graph\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"gen-ai\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"knowledge-ai\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"knowledge-discovery\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"machine-learning-platform\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"user-recommendations\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}}}},\"collaboration-platform\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"commerce-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"commerce-platform-pls-changes-for-hams-cofs-in-boundary-deployment\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"commerce-platform-self-serve\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}}}},\"customer-data-lake\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"customer-support-platform\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"ecosystem-forge\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"ecosystem-oauth\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"forge-cli\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"forge-remote-capabilities\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"forge-storage-service-rockmelon\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"forge-system-apps\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"forge-ui-ic-cdn-auth\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":false,\"fedramp-moderate\":false}}}},\"editor-collaboration-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"block-service\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"real-time-presence\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}}}},\"experience-platform\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"growth-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"bxp-signup\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}}}},\"identity\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"identity-mail-proxy\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"identity-virality\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}}}},\"marketplace\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"marketplace-app-discovery\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"marketplace-app-migrations\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"marketplace-atlassian-labs\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"marketplace-audit-logs\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"marketplace-self-service-purchase-provision-install\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}}}},\"migrations\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"agc-migrations\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"commercial-cloud-to-agc\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"data-center-to-agc\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"migration-link-fixing\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}}}},\"migrations-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"brie\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"media-migration\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}}}},\"navigation\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"navigation-home-entry-mode\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"navigation-identity-ic-routing\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":false,\"fedramp-moderate\":false}},\"navigation-switcher-discovery\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"navigation-switcher-rovo-scas-visibility\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}}}},\"notification-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"notifications-fpn-link\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}}}},\"post-office\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"product-integrations-platform\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"search\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"search-townsquare-tab\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}}}},\"smartlinks\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"user-management\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"atlassian-graphql-gateway\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"atlassian-platform-deployer\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"automation-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"automation-platform-actions\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"automation-platform-automation-templates\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"automation-platform-branches\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"automation-platform-conditions\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"automation-platform-event-processing\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"automation-platform-frontend\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"automation-platform-natural-language-rule-builder\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"automation-platform-rule-builder\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"automation-platform-templates\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"automation-platform-triggers\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}}}},\"aws-cloud-management\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"bifrost\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"build-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"cell-platform\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"cloud-security\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"compliance-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"consent-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"consenthub\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}}}},\"core-network-automation\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"core-network-automation-cna-theia\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"cross-gateway\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"data-access-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"data-classification-governance-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"data-depot-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"data-exchange-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"aqui\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"eureka\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"kamino\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"shipyard\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"topic-osb\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}}}},\"data-management-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"ers-import\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"ers\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"sql\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}}}},\"data-platform-services\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"data-telemetry-platform\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"decisions-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"detection-and-response-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"disaster-recovery\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"edge\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"edge-cloudfront\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}}}},\"encryption-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"cryptor\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}}}},\"environment-management-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"flight-deck-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"golden-ami\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"incident-management-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"infrastructure\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"internal-data-lake\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"internal-edge\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"internal-edge-httpbin\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"job-execution-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"kitt-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"media-platform\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"media-cdn-delivery\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}}}},\"messaging-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"micros-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"network-fabric\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"observability-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"pollinator\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"provisioning\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"resiliency-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"secrets\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"security-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"service-to-service-fabric\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"sliver\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"staff-authentication-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"streamhub\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"targeting-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"teamwork-graph-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"flock\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}}}},\"tenant-platform\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"tenant-platform-tenant-data-destroyer\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"vdi\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"workplace-technology-solutions\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}}}}");

},{}],"f15HN":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UnderAuditPhase = exports.BOUNDARY_KEYS_LIST = exports.ISOLATED_CLOUD_COMMERCIAL_KEY = exports.FED_MOD_KEY = exports.COMMERCIAL_KEY = void 0;
// Each BoundaryKey is a key in the sdk data
exports.COMMERCIAL_KEY = "commercial-cloud";
exports.FED_MOD_KEY = "fedramp-moderate";
exports.ISOLATED_CLOUD_COMMERCIAL_KEY = "isolated-cloud-commercial";
exports.BOUNDARY_KEYS_LIST = [
    exports.COMMERCIAL_KEY,
    exports.FED_MOD_KEY,
    exports.ISOLATED_CLOUD_COMMERCIAL_KEY
];
var UnderAuditPhase;
(function(UnderAuditPhase) {
    UnderAuditPhase["INTERNAL_AUDIT"] = "internal-audit";
    UnderAuditPhase["EXTERNAL_AUDIT"] = "external-audit";
})(UnderAuditPhase || (exports.UnderAuditPhase = UnderAuditPhase = {}));

},{}],"3gD30":[function(require,module,exports,__globalThis) {
"use strict";
/**
 * Manages feature overrides stored in browser localStorage.
 * No-ops when not in a browser context.
 *
 * localStorage key: "AEM_FEATURE_OVERRIDES"
 * localStorage value: JSON-encoded string mapping "{environmentBlockName}::{featureName}" to boolean
 *
 * Example:
 *   "AEM_FEATURE_OVERRIDES": "{\"confluence::my_feature\":true,\"jira::other_feature\":false}"
 */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.clearAllOverrides = exports.clearFeatureOverride = exports.overrideFeature = exports.getFeatureOverride = exports.STORAGE_KEY = void 0;
exports.STORAGE_KEY = "AEM_FEATURE_OVERRIDES";
function buildKey(environmentBlockName, featureName) {
    return "".concat(environmentBlockName, "::").concat(featureName);
}
function isBrowserEnvironment() {
    return typeof window !== "undefined" && typeof window.localStorage !== "undefined";
}
function getOverridesMap() {
    var featureOverrideValue = window.localStorage.getItem(exports.STORAGE_KEY);
    if (featureOverrideValue) try {
        return JSON.parse(featureOverrideValue);
    } catch (e) {
        console.warn("Failed to parse AEM_FEATURE_OVERRIDES from localStorage", e);
    }
    return {};
}
function setOverridesMap(map) {
    window.localStorage.setItem(exports.STORAGE_KEY, JSON.stringify(map));
}
/**
 * Returns the override value for a feature if one exists, or null if no override is set.
 * Returns null in non-browser environments.
 */ function getFeatureOverride(environmentBlockName, featureName) {
    if (!isBrowserEnvironment()) return null;
    var map = getOverridesMap();
    var key = buildKey(environmentBlockName, featureName);
    if (key in map) return map[key];
    return null;
}
exports.getFeatureOverride = getFeatureOverride;
/**
 * Sets a feature override in localStorage.
 */ function overrideFeature(environmentBlockName, featureName, value) {
    if (!isBrowserEnvironment()) return;
    var map = getOverridesMap();
    map[buildKey(environmentBlockName, featureName)] = value;
    setOverridesMap(map);
}
exports.overrideFeature = overrideFeature;
/**
 * Removes a single feature override from localStorage. Removes the key entirely if no overrides are left.
 */ function clearFeatureOverride(environmentBlockName, featureName) {
    if (!isBrowserEnvironment()) return;
    var map = getOverridesMap();
    delete map[buildKey(environmentBlockName, featureName)];
    if (Object.keys(map).length === 0) window.localStorage.removeItem(exports.STORAGE_KEY);
    else setOverridesMap(map);
}
exports.clearFeatureOverride = clearFeatureOverride;
/**
 * Clears all feature overrides from localStorage.
 */ function clearAllOverrides() {
    if (!isBrowserEnvironment()) return;
    window.localStorage.removeItem(exports.STORAGE_KEY);
}
exports.clearAllOverrides = clearAllOverrides;

},{}],"jpb52":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "INTERNAL_CLIENT_WINDOW_KEY", function() {
    return INTERNAL_CLIENT_WINDOW_KEY;
});
parcelHelpers.export(exports, "default", function() {
    return GlobalInteractionSessionTracking;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _interactionSessionTracking = require("./interactionSessionTracking");
var _interactionSessionTrackingDefault = parcelHelpers.interopDefault(_interactionSessionTracking);
var INTERNAL_CLIENT_WINDOW_KEY = 'analyticsInteractionSesssionTrackingClient';
var GlobalInteractionSessionTracking = /*#__PURE__*/ function() {
    "use strict";
    function GlobalInteractionSessionTracking() {
        (0, _classCallCheck._)(this, GlobalInteractionSessionTracking);
    }
    (0, _createClass._)(GlobalInteractionSessionTracking, null, [
        {
            key: "getInstance",
            value: function getInstance() {
                var interactionSessionTracking;
                try {
                    // Check if InteractionSessionTracking in global window object
                    if (INTERNAL_CLIENT_WINDOW_KEY in window) interactionSessionTracking = window[INTERNAL_CLIENT_WINDOW_KEY];
                    else {
                        // Initialise InteractionSessionTracking on global window object
                        window[INTERNAL_CLIENT_WINDOW_KEY] = new (0, _interactionSessionTrackingDefault.default)();
                        interactionSessionTracking = window[INTERNAL_CLIENT_WINDOW_KEY];
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error initialising InteractionSessionTracking - ".concat((0, _instanceof._)(error, Error) ? error.message : String(error)));
                }
                return interactionSessionTracking;
            }
        }
    ]);
    return GlobalInteractionSessionTracking;
}();

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_instanceof":"h9UKc","./interactionSessionTracking":"7Dpa3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7Dpa3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_SESSION_EXPIRY_TIME_MS", function() {
    return DEFAULT_SESSION_EXPIRY_TIME_MS;
});
parcelHelpers.export(exports, "DEFAULT_PERSISTED_SESSION_TTL_MS", function() {
    return DEFAULT_PERSISTED_SESSION_TTL_MS;
});
parcelHelpers.export(exports, "DEFAULT_EXPIRY_DEBOUNCE", function() {
    return DEFAULT_EXPIRY_DEBOUNCE;
});
parcelHelpers.export(exports, "DEFAULT_DEBOUNCE_THRESHOLD_PERCENTAGE", function() {
    return DEFAULT_DEBOUNCE_THRESHOLD_PERCENTAGE;
});
parcelHelpers.export(exports, "INTERACTION_SESSION_ID_UPDATED_EVENT", function() {
    return INTERACTION_SESSION_ID_UPDATED_EVENT;
});
/**
 * This class is essentially a wrapper around SessionStorage that introduces some failsafes (such as switching to InMemoryStorage if SessionStorage is not available)
 * and providing resilient methods for accessing and updating the interaction session ID.
 * This class can be initialised anywhere within a document, and `getCurrentInteractionSessionId` will always return the latest interaction session ID.
 *
 * The `setAnalyticsCallback` method must be called with a valid analytics event callback function provided by an Analytics Web Client before any other methods are used.
 * This is to ensure that any generated or renewed session IDs can be reported via an analytics event.
 *
 * The `setInteractionSessionId` method will write the SessionStorage with the persisted session ID, and is only intended to be used by the Analytics Web Client
 */ parcelHelpers.export(exports, "default", function() {
    return InteractionSessionTracking;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _safeSessionStorage = require("./storage/SafeSessionStorage");
var _safeSessionStorageDefault = parcelHelpers.interopDefault(_safeSessionStorage);
// WARNING: The value of INTERACTION_SESSION_ID_STORAGE_KEY will be used by Analytics Web Client to attach the session ID to events.
// If you change this, you will need to update the Analytics Web Client code as well.
var INTERACTION_SESSION_ID_STORAGE_KEY = 'interactionSession.id';
var INTERACTION_SESSION_ID_PREV_STORAGE_KEY = 'interactionSession.id.prev';
var INTERACTION_SESSION_EXPIRY_STORAGE_KEY = 'interactionSession.expiry';
var DEFAULT_SESSION_EXPIRY_TIME_MS = 1800000; // 30 minutes
var DEFAULT_PERSISTED_SESSION_TTL_MS = 86400000; // 24 hours
var DEFAULT_EXPIRY_DEBOUNCE = 5000; // 5 seconds
var DEFAULT_DEBOUNCE_THRESHOLD_PERCENTAGE = 0.9; // 90% of expiry
var INTEGER_REGEX = /^\d+$/;
var INTERACTION_SESSION_ID_UPDATED_EVENT = 'interactionSessionIdUpdated';
var InteractionSessionTracking = /*#__PURE__*/ function() {
    "use strict";
    function InteractionSessionTracking() {
        var _this = this;
        (0, _classCallCheck._)(this, InteractionSessionTracking);
        this.analyticsReady = false;
        this.generateNewSessionId = function() {
            if (!_this.analyticsReady) return null;
            var currentSessionId = _this.safeSessionStorage.getItem(INTERACTION_SESSION_ID_STORAGE_KEY);
            var newSessionId = Date.now().toString();
            _this.safeSessionStorage.setItem(INTERACTION_SESSION_ID_STORAGE_KEY, newSessionId);
            var isValidSession = _this.getCurrentSessionParams().isValidSession;
            if (!isValidSession) // If session is not valid at this point, something has gone wrong with Session Storage access
            // Calling sendInteractionSessionEvent now would result in an infinite loop, so we terminate
            return null;
            if (currentSessionId) {
                // Store a copy of the current session ID so we can link sessions if needed
                _this.safeSessionStorage.setItem(INTERACTION_SESSION_ID_PREV_STORAGE_KEY, currentSessionId);
                _this.sendInteractionSessionEvent('renewed');
            } else _this.sendInteractionSessionEvent('started');
            // Event listener is in useCrossProductUrl.tsx to update URL query params
            document.dispatchEvent(new Event(INTERACTION_SESSION_ID_UPDATED_EVENT));
            return newSessionId;
        };
        this.updateSessionExpiry = function() {
            var expiry = Date.now() + _this.sessionExpiryTime;
            _this.safeSessionStorage.setItem(INTERACTION_SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        };
        this.debouncedUpdateSessionExpiry = function(currentExpiry) {
            var updateSessionExpiry = _this.updateSessionExpiry;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + _this.sessionExpiryDebounceThresholdPercentage * _this.sessionExpiryTime) updateSessionExpiry();
            else {
                if (_this.sessionExpiryDebounceTimer) clearTimeout(_this.sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                _this.sessionExpiryDebounceTimer = setTimeout(function() {
                    updateSessionExpiry();
                }, _this.sessionExpiryDebounce);
            }
        };
        this.sessionExpiryTime = DEFAULT_SESSION_EXPIRY_TIME_MS;
        this.sessionExpiryDebounce = DEFAULT_EXPIRY_DEBOUNCE;
        this.sessionExpiryDebounceThresholdPercentage = DEFAULT_DEBOUNCE_THRESHOLD_PERCENTAGE;
        this.safeSessionStorage = new (0, _safeSessionStorageDefault.default)();
    }
    (0, _createClass._)(InteractionSessionTracking, [
        {
            key: "getCurrentInteractionSessionId",
            value: function getCurrentInteractionSessionId() {
                try {
                    var _this_getCurrentSessionParams = this.getCurrentSessionParams(), isValidSession = _this_getCurrentSessionParams.isValidSession, sessionExpiry = _this_getCurrentSessionParams.sessionExpiry, sessionId = _this_getCurrentSessionParams.sessionId;
                    // If we have an existing valid session we can return the sessionId straight away
                    if (isValidSession) {
                        this.debouncedUpdateSessionExpiry(sessionExpiry);
                        return sessionId;
                    }
                    // To generate a new session ID we must ensure analytics is ready
                    if (this.analyticsReady) {
                        // Session expiry update must occur before generateNewSessionId. Otherwise we were running
                        // into issues of calls attempting to read the session ID before a valid expiry had been set
                        this.debouncedUpdateSessionExpiry(sessionExpiry);
                        return this.generateNewSessionId();
                    }
                } catch (err) {
                    // eslint-disable-next-line no-console
                    console.error("Error retrieving interaction session ID - ".concat((0, _instanceof._)(err, Error) ? err.message : String(err)));
                }
                return null;
            }
        },
        {
            key: "getPreviousInteractionSessionId",
            value: function getPreviousInteractionSessionId() {
                return this.safeSessionStorage.getItem(INTERACTION_SESSION_ID_PREV_STORAGE_KEY);
            }
        },
        {
            key: "setInteractionSessionId",
            value: function setInteractionSessionId(persistedSessionId) {
                if (this.validateSessionId(persistedSessionId)) {
                    var currentSessionId = this.safeSessionStorage.getItem(INTERACTION_SESSION_ID_STORAGE_KEY);
                    // If we are already on the required session ID, just return true and make no changes
                    // This can happen if the persisted session ID in options is the same as the current session ID
                    // We noticed this happening in some cases where Confluence's own URL redirect logic was causing
                    // race conditions with our URL stripping, resulting in the same query parameter being processed multiple times
                    if (currentSessionId === persistedSessionId) return false;
                    // Session expiry update must occur before we fire off the dispatchEvent. Otherwise we were running
                    // into issues of the event consumer attempting to read the session ID before a valid expiry had been set
                    this.debouncedUpdateSessionExpiry(0);
                    this.safeSessionStorage.setItem(INTERACTION_SESSION_ID_STORAGE_KEY, persistedSessionId);
                    this.safeSessionStorage.removeItem(INTERACTION_SESSION_ID_PREV_STORAGE_KEY);
                    document.dispatchEvent(new Event(INTERACTION_SESSION_ID_UPDATED_EVENT));
                    return true;
                }
                return false;
            }
        },
        {
            // Must be called with a valid sendEvent function for other methods to work
            key: "setAnalyticsCallback",
            value: function setAnalyticsCallback(sendEventCallback) {
                if (this.analyticsReady) // If we already have a valid callback, don't over-write it
                return;
                if (sendEventCallback && typeof sendEventCallback === 'function') {
                    this.sendEventCallback = sendEventCallback;
                    this.analyticsReady = true;
                } else this.analyticsReady = false;
            }
        },
        {
            key: "validateSessionId",
            value: function validateSessionId(sessionId) {
                // Check if persisted session ID can parse as valid Unix timestamp
                if (sessionId && INTEGER_REGEX.test(sessionId)) {
                    var sessionAge = Date.now() - parseInt(sessionId, 10);
                    // Validate that timestamp is not a future time, and is also within the TTL
                    if (sessionAge >= 0 && sessionAge <= DEFAULT_PERSISTED_SESSION_TTL_MS) return true;
                }
                return false;
            }
        },
        {
            key: "getCurrentSessionParams",
            value: /*
	 * This function retrieves the current session ID and expiry from SessionStorage
	 * It runs the necessary checks to ensure the session ID is valid and within expiry
	 *
	 * It returns the values along with a `validSession` boolean
	 */ function getCurrentSessionParams() {
                var sessionId = this.safeSessionStorage.getItem(INTERACTION_SESSION_ID_STORAGE_KEY);
                var sessionExpiry = parseInt(this.safeSessionStorage.getItem(INTERACTION_SESSION_EXPIRY_STORAGE_KEY) || '0', 10) || 0;
                if (sessionId && !Number.isNaN(sessionExpiry) && sessionExpiry > Date.now()) return {
                    isValidSession: true,
                    sessionExpiry: sessionExpiry,
                    sessionId: sessionId
                };
                return {
                    isValidSession: false,
                    sessionExpiry: sessionExpiry,
                    sessionId: sessionId
                };
            }
        },
        {
            key: "sendInteractionSessionEvent",
            value: /*
	 * This function sends a GASv3 analytics event indicating the interaction session has started or renewed
	 * It requires this.sendEventCallback to be set via Analytics Web Client to a valid operational event sender function
	 *
	 * Note that Analytics Web Client's callback function will make its own call to getCurrentInteractionSessionId to retrieve the session ID
	 * to attach to the event, so a valid session ID/expiry must be retrievable from SessionStorage before this function is called to avoid infinite loops.
	 *
	 * This is not an ideal solution but it works with the current architecture of Analytics Web Client.
	 */ function sendInteractionSessionEvent(action) {
                this.sendEventCallback && this.sendEventCallback({
                    action: action,
                    actionSubject: 'interactionSession',
                    source: 'interactionComponent',
                    tags: [
                        'navigationExperiences'
                    ]
                });
            }
        }
    ]);
    return InteractionSessionTracking;
}();

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_instanceof":"h9UKc","./storage/SafeSessionStorage":"2qCeB","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2qCeB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// eslint-disable-next-line import/no-anonymous-default-export
parcelHelpers.export(exports, "default", function() {
    return _class;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _inherits = require("@swc/helpers/_/_inherits");
var _inMemoryStorage = require("./InMemoryStorage");
var _inMemoryStorageDefault = parcelHelpers.interopDefault(_inMemoryStorage);
var _safeStorage = require("./SafeStorage");
var _safeStorageDefault = parcelHelpers.interopDefault(_safeStorage);
var _class = /*#__PURE__*/ function(SafeStorage) {
    "use strict";
    (0, _inherits._)(_class, SafeStorage);
    function _class(options) {
        (0, _classCallCheck._)(this, _class);
        var storageToUse;
        try {
            storageToUse = window.sessionStorage || (0, _inMemoryStorageDefault.default);
        } catch (err) {
            storageToUse = (0, _inMemoryStorageDefault.default);
        }
        return (0, _callSuper._)(this, _class, [
            storageToUse,
            options
        ]);
    }
    return _class;
}((0, _safeStorageDefault.default));

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_inherits":"2sfqW","./InMemoryStorage":"lFJvp","./SafeStorage":"58bfR","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lFJvp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InMemoryStore", function() {
    return InMemoryStore;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var InMemoryStore = function InMemoryStore() {
    "use strict";
    var _this = this;
    (0, _classCallCheck._)(this, InMemoryStore);
    this.data = {};
    this.length = 0;
    this.setItem = function(key, value) {
        _this.data[key] = value;
        _this.length = Object.keys(_this.data).length;
        return value;
    };
    this.getItem = function(key) {
        if (key in _this.data) return _this.data[key];
        return null;
    };
    this.removeItem = function(key) {
        if (key in _this.data) delete _this.data[key];
        _this.length = Object.keys(_this.data).length;
        return null;
    };
    this.clear = function() {
        _this.data = {};
        _this.length = 0;
    };
    this.key = function(index) {
        return Object.keys(_this.data)[index];
    };
};
// eslint-disable-next-line import/no-anonymous-default-export
var inmemorystorage = new InMemoryStore();
exports.default = inmemorystorage;

},{"@swc/helpers/_/_class_call_check":"5CNCO","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"58bfR":[function(require,module,exports,__globalThis) {
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWC_STORAGE_PREFIX", function() {
    return AWC_STORAGE_PREFIX;
});
parcelHelpers.export(exports, "GLOBAL_IN_MEMORY_NAME", function() {
    return GLOBAL_IN_MEMORY_NAME;
});
parcelHelpers.export(exports, "envType", function() {
    return envType;
});
parcelHelpers.export(exports, "isSupported", function() {
    return isSupported;
});
parcelHelpers.export(exports, "default", function() {
    return SafeStorage;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _inMemoryStorage = require("./InMemoryStorage");
var _inMemoryStorageDefault = parcelHelpers.interopDefault(_inMemoryStorage);
var AWC_STORAGE_PREFIX = 'awc';
var GLOBAL_IN_MEMORY_NAME = 'awcInMemoryStorageFallback';
var envType = /*#__PURE__*/ function(envType) {
    envType["DEV"] = "dev";
    envType["LOCAL"] = "local";
    envType["PROD"] = "prod";
    envType["STAGING"] = "staging";
    return envType;
}({});
function isSupported(store) {
    var TEST_VALUE = 'test_value';
    if (!store) return false;
    try {
        var key = 'awc.storage.support';
        store.setItem(key, TEST_VALUE);
        var value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}
var SafeStorage = function SafeStorage(storageToUse) {
    "use strict";
    var _this = this;
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    (0, _classCallCheck._)(this, SafeStorage);
    this.getStore = function() {
        return _this.store;
    };
    this.getItem = function(key) {
        return _this.store.getItem(_this.createKey(key));
    };
    this.removeItem = function(key) {
        return _this.store.removeItem(_this.createKey(key));
    };
    this.setItem = function(key, value) {
        try {
            _this.store.setItem(_this.createKey(key), value);
        } catch (err) {
            // Theoretically should only be QuotaExceededError, but keeping 'err' generic
            // https://developer.mozilla.org/en-US/docs/Web/API/Storage/setItem
            _this.swapToInMemory();
            _this.store.setItem(_this.createKey(key), value);
        }
    };
    this.swapToInMemory = function() {
        if (_this.store === (0, _inMemoryStorageDefault.default) || typeof window === 'undefined') return;
        var keys = Object.keys(_this.store || {});
        var inMemoryStorage;
        if (isSupported(window[GLOBAL_IN_MEMORY_NAME])) inMemoryStorage = window[GLOBAL_IN_MEMORY_NAME];
        else {
            inMemoryStorage = (0, _inMemoryStorageDefault.default);
            if (!window[GLOBAL_IN_MEMORY_NAME]) // If not already attached to window then attach our instance of InMemoryStorage
            // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
            // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
            window[GLOBAL_IN_MEMORY_NAME] = (0, _inMemoryStorageDefault.default);
        }
        keys.forEach(function(key) {
            if (key.indexOf(_this.getPrefix()) === 0) {
                var value = _this.store.getItem(key);
                if (value) inMemoryStorage.setItem(key, value);
            }
        });
        _this.store = inMemoryStorage;
    };
    this.clear = function() {
        return _this.store.clear();
    };
    this.key = function(index) {
        return _this.store.key(index);
    };
    this.getPrefix = function() {
        return _this.prefix;
    };
    this.createKey = function(key) {
        if (_this.prefix) return "".concat(_this.getPrefix(), ".").concat(key);
        return key;
    };
    this.options = options;
    var prefixes = [];
    if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push(AWC_STORAGE_PREFIX);
    if (options.envPrefix && options.envPrefix !== "prod") prefixes.push(options.envPrefix);
    this.prefix = prefixes.join('-');
    if (isSupported(storageToUse)) this.store = storageToUse;
    else this.swapToInMemory();
};

},{"@swc/helpers/_/_class_call_check":"5CNCO","./InMemoryStorage":"lFJvp","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2BQQj":[function(require,module,exports,__globalThis) {
// Add products that will participate in cross-product interaction tracking here
// TODO: Down the line this should ideally be synced with ECS product list but that
// will take significant engineering effort
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "validProducts", function() {
    return validProducts;
});
var validProducts = [
    'jira',
    'confluence',
    'townsquare',
    'loom'
];

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lF5r7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "URL_QUERY_PARAM_INTERACTION_SESSION", function() {
    return URL_QUERY_PARAM_INTERACTION_SESSION;
});
parcelHelpers.export(exports, "generateUrlWithParams", function() {
    return generateUrlWithParams;
});
var URL_QUERY_PARAM_INTERACTION_SESSION = 'xpis';
var generateUrlWithParams = function(url, bridge, interactionSessionId, product, subProduct) {
    var interactionSource = subProduct ? "".concat(product, "-").concat(subProduct) : product;
    var interactionSession = {
        bridge: bridge,
        id: interactionSessionId,
        source: interactionSource
    };
    var paramValueEncoded = btoa(JSON.stringify(interactionSession));
    var partialUrl = false;
    var urlObj;
    // If relative URL provided, add localhost as placeholder base, to be stripped later
    try {
        urlObj = new URL(url);
    } catch (e) {
        urlObj = new URL(url, 'http://localhost/');
        partialUrl = true;
    }
    urlObj.searchParams.set(URL_QUERY_PARAM_INTERACTION_SESSION, paramValueEncoded);
    if (partialUrl) return urlObj.pathname + urlObj.search;
    else return urlObj.toString();
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6G7Ig":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultHistoryReplaceFn", function() {
    return defaultHistoryReplaceFn;
});
var _queryString = require("query-string");
var _objectUtils = require("./objectUtils");
var defaultHistoryReplaceFn = function(newUrl) {
    return window.history.replaceState({}, '', newUrl);
};
var urlParamExtractor = function(isCaptureParam) {
    var historyReplaceFn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultHistoryReplaceFn;
    // Extract target parameters and values from URL if present
    var originalUrl = window.location.href;
    var fragmentHash = window.location.hash;
    var removedFragmentURL = fragmentHash !== '' ? originalUrl.replace(fragmentHash, '') : originalUrl;
    var _parseUrl = (0, _queryString.parseUrl)(removedFragmentURL), url = _parseUrl.url, query = _parseUrl.query;
    var captureParams = (0, _objectUtils.pickBy)(query, isCaptureParam);
    // Do not modify URL if no matches
    if (Object.keys(captureParams).length > 0) {
        var queryWithoutCaptureParams = (0, _objectUtils.omitBy)(query, isCaptureParam);
        // Replace the URL minus captured parameters
        if (Object.keys(queryWithoutCaptureParams).length > 0) {
            var newUrl = "".concat(url, "?").concat((0, _queryString.stringify)(queryWithoutCaptureParams)).concat(fragmentHash);
            historyReplaceFn(newUrl);
        } else historyReplaceFn("".concat(url).concat(fragmentHash));
    }
    return captureParams;
};
exports.default = urlParamExtractor;

},{"query-string":"jcXMO","./objectUtils":"3kJkz","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jcXMO":[function(require,module,exports,__globalThis) {
var _defineProperty = require("@swc/helpers/_/_define_property");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var strictUriEncode = require("28f2a5db4c2c5f85");
var decodeComponent = require("23b9b0bc871f5d7f");
var splitOnFirst = require("4a6bd761f28c8889");
var filterObject = require("da01a3953af7489c");
var isNullOrUndefined = function(value) {
    return value === null || value === undefined;
};
var encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
function encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case 'index':
            return function(key) {
                return function(result, value) {
                    var index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return (0, _toConsumableArray._)(result).concat([
                        [
                            encode(key, options),
                            '[',
                            index,
                            ']'
                        ].join('')
                    ]);
                    return (0, _toConsumableArray._)(result).concat([
                        [
                            encode(key, options),
                            '[',
                            encode(index, options),
                            ']=',
                            encode(value, options)
                        ].join('')
                    ]);
                };
            };
        case 'bracket':
            return function(key) {
                return function(result, value) {
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return (0, _toConsumableArray._)(result).concat([
                        [
                            encode(key, options),
                            '[]'
                        ].join('')
                    ]);
                    return (0, _toConsumableArray._)(result).concat([
                        [
                            encode(key, options),
                            '[]=',
                            encode(value, options)
                        ].join('')
                    ]);
                };
            };
        case 'colon-list-separator':
            return function(key) {
                return function(result, value) {
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return (0, _toConsumableArray._)(result).concat([
                        [
                            encode(key, options),
                            ':list='
                        ].join('')
                    ]);
                    return (0, _toConsumableArray._)(result).concat([
                        [
                            encode(key, options),
                            ':list=',
                            encode(value, options)
                        ].join('')
                    ]);
                };
            };
        case 'comma':
        case 'separator':
        case 'bracket-separator':
            {
                var keyValueSep = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
                return function(key) {
                    return function(result, value) {
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? '' : value;
                        if (result.length === 0) return [
                            [
                                encode(key, options),
                                keyValueSep,
                                encode(value, options)
                            ].join('')
                        ];
                        return [
                            [
                                result,
                                encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
                };
            }
        default:
            return function(key) {
                return function(result, value) {
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return (0, _toConsumableArray._)(result).concat([
                        encode(key, options)
                    ]);
                    return (0, _toConsumableArray._)(result).concat([
                        [
                            encode(key, options),
                            '=',
                            encode(value, options)
                        ].join('')
                    ]);
                };
            };
    }
}
function parserForArrayFormat(options) {
    var result;
    switch(options.arrayFormat){
        case 'index':
            return function(key, value, accumulator) {
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return function(key, value, accumulator) {
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'colon-list-separator':
            return function(key, value, accumulator) {
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'comma':
        case 'separator':
            return function(key, value, accumulator) {
                var isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
                var isEncodedArray = typeof value === 'string' && !isArray && decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? decode(value, options) : value;
                var newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map(function(item) {
                    return decode(item, options);
                }) : value === null ? value : decode(value, options);
                accumulator[key] = newValue;
            };
        case 'bracket-separator':
            return function(key, value, accumulator) {
                var isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, '');
                if (!isArray) {
                    accumulator[key] = value ? decode(value, options) : value;
                    return;
                }
                var arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map(function(item) {
                    return decode(item, options);
                });
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return function(key, value, accumulator) {
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) throw new TypeError('arrayFormatSeparator must be single character string');
}
function encode(value, options) {
    if (options.encode) return options.strict ? strictUriEncode(value) : encodeURIComponent(value);
    return value;
}
function decode(value, options) {
    if (options.decode) return decodeComponent(value);
    return value;
}
function keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if ((typeof input === "undefined" ? "undefined" : (0, _typeOf._)(input)) === 'object') return keysSorter(Object.keys(input)).sort(function(a, b) {
        return Number(a) - Number(b);
    }).map(function(key) {
        return input[key];
    });
    return input;
}
function removeHash(input) {
    var hashStart = input.indexOf('#');
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function getHash(url) {
    var hash = '';
    var hashStart = url.indexOf('#');
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function extract(input) {
    input = removeHash(input);
    var queryStart = input.indexOf('?');
    if (queryStart === -1) return '';
    return input.slice(queryStart + 1);
}
function parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) value = value.toLowerCase() === 'true';
    return value;
}
function parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        parseNumbers: false,
        parseBooleans: false
    }, options);
    validateArrayFormatSeparator(options.arrayFormatSeparator);
    var formatter = parserForArrayFormat(options);
    // Create an object with no prototype
    var ret = Object.create(null);
    if (typeof query !== 'string') return ret;
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) return ret;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = query.split('&')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var param = _step.value;
            if (param === '') continue;
            var _splitOnFirst = (0, _slicedToArray._)(splitOnFirst(options.decode ? param.replace(/\+/g, ' ') : param, '='), 2), key = _splitOnFirst[0], value = _splitOnFirst[1];
            // Missing `=` should be `null`:
            // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
            value = value === undefined ? null : [
                'comma',
                'separator',
                'bracket-separator'
            ].includes(options.arrayFormat) ? value : decode(value, options);
            formatter(decode(key, options), value, ret);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = Object.keys(ret)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var key1 = _step1.value;
            var value1 = ret[key1];
            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
            if ((typeof value1 === "undefined" ? "undefined" : (0, _typeOf._)(value1)) === 'object' && value1 !== null) try {
                for(var _iterator2 = Object.keys(value1)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                    var k = _step2.value;
                    value1[k] = parseValue(value1[k], options);
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                        _iterator2.return();
                    }
                } finally{
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
            else ret[key1] = parseValue(value1, options);
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce(function(result, key) {
        var value = ret[key];
        if (Boolean(value) && (typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) === 'object' && !Array.isArray(value)) // Sort object keys, not values
        result[key] = keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
exports.extract = extract;
exports.parse = parse;
exports.stringify = function(object, options) {
    if (!object) return '';
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ','
    }, options);
    validateArrayFormatSeparator(options.arrayFormatSeparator);
    var shouldFilter = function(key) {
        return options.skipNull && isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    };
    var formatter = encoderForArrayFormat(options);
    var objectCopy = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.keys(object)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (!shouldFilter(key)) objectCopy[key] = object[key];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map(function(key) {
        var value = object[key];
        if (value === undefined) return '';
        if (value === null) return encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === 'bracket-separator') return encode(key, options) + '[]';
            return value.reduce(formatter(key), []).join('&');
        }
        return encode(key, options) + '=' + encode(value, options);
    }).filter(function(x) {
        return x.length > 0;
    }).join('&');
};
exports.parseUrl = function(url, options) {
    options = Object.assign({
        decode: true
    }, options);
    var _splitOnFirst = (0, _slicedToArray._)(splitOnFirst(url, '#'), 2), url_ = _splitOnFirst[0], hash = _splitOnFirst[1];
    return Object.assign({
        url: url_.split('?')[0] || '',
        query: parse(extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: decode(hash, options)
    } : {});
};
exports.stringifyUrl = function(object, options) {
    options = Object.assign((0, _defineProperty._)({
        encode: true,
        strict: true
    }, encodeFragmentIdentifier, true), options);
    var url = removeHash(object.url).split('?')[0] || '';
    var queryFromUrl = exports.extract(object.url);
    var parsedQueryFromUrl = exports.parse(queryFromUrl, {
        sort: false
    });
    var query = Object.assign(parsedQueryFromUrl, object.query);
    var queryString = exports.stringify(query, options);
    if (queryString) queryString = "?".concat(queryString);
    var hash = getHash(object.url);
    if (object.fragmentIdentifier) hash = "#".concat(options[encodeFragmentIdentifier] ? encode(object.fragmentIdentifier, options) : object.fragmentIdentifier);
    return "".concat(url).concat(queryString).concat(hash);
};
exports.pick = function(input, filter, options) {
    options = Object.assign((0, _defineProperty._)({
        parseFragmentIdentifier: true
    }, encodeFragmentIdentifier, false), options);
    var _exports_parseUrl = exports.parseUrl(input, options), url = _exports_parseUrl.url, query = _exports_parseUrl.query, fragmentIdentifier = _exports_parseUrl.fragmentIdentifier;
    return exports.stringifyUrl({
        url: url,
        query: filterObject(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
exports.exclude = function(input, filter, options) {
    var exclusionFilter = Array.isArray(filter) ? function(key) {
        return !filter.includes(key);
    } : function(key, value) {
        return !filter(key, value);
    };
    return exports.pick(input, exclusionFilter, options);
};

},{"@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_to_consumable_array":"1eSZf","@swc/helpers/_/_type_of":"iFJdx","28f2a5db4c2c5f85":"f2Q8t","23b9b0bc871f5d7f":"a7KiN","4a6bd761f28c8889":"hJbUR","da01a3953af7489c":"iYIt6"}],"f2Q8t":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = function(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(x) {
        return "%".concat(x.charCodeAt(0).toString(16).toUpperCase());
    });
};

},{}],"a7KiN":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp('(' + token + ')|([^%]+?)', 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');
function decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(''))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}
function decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match(singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = decodeComponents(tokens, i).join('');
            tokens = input.match(singleMatcher) || [];
        }
        return input;
    }
}
function customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        '%FE%FF': '\uFFFD\uFFFD',
        '%FF%FE': '\uFFFD\uFFFD'
    };
    var match = multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap['%C2'] = '\uFFFD';
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
    }
    return input;
}
module.exports = function(encodedURI) {
    if (typeof encodedURI !== 'string') throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + (typeof encodedURI === "undefined" ? "undefined" : (0, _typeOf._)(encodedURI)) + '`');
    try {
        encodedURI = encodedURI.replace(/\+/g, ' ');
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return customDecodeURIComponent(encodedURI);
    }
};

},{"@swc/helpers/_/_type_of":"iFJdx"}],"hJbUR":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = function(string, separator) {
    if (!(typeof string === 'string' && typeof separator === 'string')) throw new TypeError('Expected the arguments to be of type `string`');
    if (separator === '') return [
        string
    ];
    var separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};

},{}],"iYIt6":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};

},{}],"3kJkz":[function(require,module,exports,__globalThis) {
/* eslint-disable no-return-assign, no-sequences */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapKeys", function() {
    return mapKeys;
});
parcelHelpers.export(exports, "pick", function() {
    return pick;
});
parcelHelpers.export(exports, "pickBy", function() {
    return pickBy;
});
parcelHelpers.export(exports, "omitBy", function() {
    return omitBy;
});
parcelHelpers.export(exports, "omit", function() {
    return omit;
});
parcelHelpers.export(exports, "equals", function() {
    return equals;
});
parcelHelpers.export(exports, "partition", function() {
    return partition;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
var _typeOf = require("@swc/helpers/_/_type_of");
// https://www.30secondsofcode.org/js/s/map-keys
var mapKeys = function(obj, fn) {
    return Object.keys(obj).reduce(function(acc, k) {
        var key = fn(obj[k], k, obj);
        acc[key] = obj[k];
        return acc;
    }, {});
};
// https://www.30secondsofcode.org/js/s/pick
var pick = function(obj, arr) {
    return arr.reduce(function(acc, curr) {
        return curr in obj && (acc[curr] = obj[curr]), acc;
    }, {});
};
// https://www.30secondsofcode.org/js/s/omit-by
var omitBy = function(obj, fn) {
    return Object.keys(obj).filter(function(k) {
        return !fn(obj[k], k);
    }).reduce(function(acc, key) {
        return acc[key] = obj[key], acc;
    }, {});
};
// https://www.30secondsofcode.org/js/s/pick-by
var pickBy = function(obj, fn) {
    return Object.keys(obj).filter(function(k) {
        return fn(obj[k], k);
    }).reduce(function(acc, key) {
        return acc[key] = obj[key], acc;
    }, {});
};
// https://www.30secondsofcode.org/js/s/omit
var omit = function(obj, arr) {
    return Object.keys(obj).filter(function(k) {
        return arr.indexOf(k) < 0;
    }).reduce(function(acc, key) {
        return acc[key] = obj[key], acc;
    }, {});
};
// https://www.30secondsofcode.org/js/s/equals
var equals = function(a, b) {
    if (a === b) return true;
    if ((0, _instanceof._)(a, Date) && (0, _instanceof._)(b, Date)) return a.getTime() === b.getTime();
    if (!a || !b || (typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)) !== 'object' && (typeof b === "undefined" ? "undefined" : (0, _typeOf._)(b)) !== 'object') return a === b;
    if (a.prototype !== b.prototype) return false;
    var keys = Object.keys(a);
    if (keys.length !== Object.keys(b).length) return false;
    return keys.every(function(k) {
        return equals(a[k], b[k]);
    });
};
// https://www.30secondsofcode.org/js/s/partition
var partition = function(arr, fn) {
    return arr.reduce(// eslint-disable-next-line no-shadow
    function(acc, val, i, arr) {
        acc[fn(val, i, arr) ? 0 : 1].push(val);
        return acc;
    }, [
        [],
        []
    ]);
};

},{"@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_type_of":"iFJdx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iau6s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isFirstParty", function() {
    return isFirstParty;
});
parcelHelpers.export(exports, "isThirdParty", function() {
    return isThirdParty;
});
var _analyticsWebTypes = require("./analyticsWebTypes");
var isFirstParty = function(input) {
    return input.embeddedType === (0, _analyticsWebTypes.productEmbedType).FIRST_PARTY && input.embeddedFromProduct !== undefined;
};
var isThirdParty = function(input) {
    return input.embeddedType === (0, _analyticsWebTypes.productEmbedType).THIRD_PARTY && input.embeddedFromTopLevelDomain !== undefined;
};

},{"./analyticsWebTypes":"iDbK2","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"l3Cu2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "filterAndBuildContainers", function() {
    return filterAndBuildContainers;
});
parcelHelpers.export(exports, "buildContainersWithName", function() {
    return buildContainersWithName;
});
parcelHelpers.export(exports, "buildActionFields", function() {
    return buildActionFields;
});
parcelHelpers.export(exports, "buildScreenEvent", function() {
    return buildScreenEvent;
});
parcelHelpers.export(exports, "buildActionName", function() {
    return buildActionName;
});
parcelHelpers.export(exports, "validationMode", function() {
    return validationMode;
});
parcelHelpers.export(exports, "buildContext", function() {
    return buildContext;
});
parcelHelpers.export(exports, "extractProductOverrides", function() {
    return extractProductOverrides;
});
parcelHelpers.export(exports, "buildActionEvent", function() {
    return buildActionEvent;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _analyticsWebTypes = require("./analyticsWebTypes");
var _objectUtils = require("./util/object-utils");
var libraryVersion = undefined;
function buildTenantFields(tenantInfo) {
    return {
        tenantIdType: tenantInfo.tenantIdType,
        tenantId: tenantInfo.tenantId
    };
}
function buildUserFields(userInfo) {
    return {
        userIdType: userInfo.userIdType
    };
}
function buildOrgFields(orgInfo) {
    return {
        orgId: orgInfo.orgId
    };
}
function buildWorkspaceFields(workspaceInfo) {
    return {
        workspaceId: workspaceInfo.workspaceId
    };
}
function buildCollaborationContextFields(collaborationContextInfo) {
    if (!(0, _platformFeatureFlags.fg)('analytics_cdp_csp_collaborationcontextari')) return {};
    return {
        collaborationContextAri: collaborationContextInfo.collaborationContextAri
    };
}
function buildAliases(aliases) {
    if (isNotEmptyObject(aliases)) return {
        aliases: aliases
    };
    return undefined;
}
function buildGroups(groups) {
    if (isNotEmptyObject(groups)) return {
        groups: groups
    };
    return undefined;
}
function buildEventOverrides(event) {
    var result = {};
    if (event.anonymousId) result.anonymousId = event.anonymousId;
    if (event.excludedProperties) result.excludedProperties = event.excludedProperties;
    if (event.userConsents) result.userConsents = event.userConsents;
    return result;
}
function getProductField(field, override) {
    return override === undefined ? field : override;
}
function buildProductFields(productInfo, productOverrides) {
    var overrides = productOverrides || {};
    var env = getProductField(productInfo.env, overrides.env);
    var product = getProductField(productInfo.product, overrides.product);
    var subproduct = getProductField(productInfo.subproduct(), overrides.subproduct);
    var version = getProductField(productInfo.version, overrides.version);
    var origin = getProductField(productInfo.origin, overrides.origin);
    var platform = getProductField(productInfo.platform, overrides.platform);
    var ic = productInfo.ic; // ic should not be overriden once set
    var cdp = (0, _platformFeatureFlags.fg)('analytics_cdp_csp_collaborationcontextari') ? productInfo.cdp : undefined;
    var csp = (0, _platformFeatureFlags.fg)('analytics_cdp_csp_collaborationcontextari') ? productInfo.csp : undefined;
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform,
        ic: ic,
        cdp: cdp,
        csp: csp
    };
}
function isNotEmptyObject(obj) {
    return (0, _objectUtils.isPlainObject)(obj) && Object.keys(obj).length > 0;
}
function buildAttributesWithName(name, attrObject) {
    return isNotEmptyObject(attrObject) ? (0, _defineProperty._)({}, name, attrObject) : undefined;
}
function buildAttributes(attributes) {
    return buildAttributesWithName('attributes', attributes);
}
function filterAndBuildContainers(containers) {
    var validContainers = {};
    Object.keys(containers).forEach(function(key) {
        var value = containers[key];
        validContainers[key] = {
            id: value.id,
            type: value.type
        };
    });
    return validContainers;
}
function buildContainersWithName(containers) {
    if (isNotEmptyObject(containers)) {
        var validContainers = filterAndBuildContainers(containers);
        return buildAttributesWithName('containers', validContainers);
    }
    return undefined;
}
function buildActionFields(event, actionEventType) {
    return (0, _objectSpread._)({
        containerType: event.containerType,
        containerId: event.containerId,
        source: event.source,
        objectType: event.objectType,
        objectId: event.objectId,
        actionSubject: event.actionSubject,
        action: event.action,
        actionSubjectId: event.actionSubjectId,
        attributes: event.attributes,
        nonPrivacySafeAttributes: event.nonPrivacySafeAttributes,
        tags: event.tags,
        highPriority: event.highPriority,
        eventType: actionEventType
    }, buildContainersWithName(event.containers));
}
function buildNonPrivacySafeAttributes(nonPrivacySafeAttributes) {
    return buildAttributesWithName('nonPrivacySafeAttributes', nonPrivacySafeAttributes);
}
function buildScreenEvent(productInfo, tenantInfo, userInfo, attributes, nonPrivacySafeAttributes, tags, tabId, sessionId, taskSessions, interactionSession, orgInfo, pageLoadId, workspaceInfo, collaborationContextInfo, event, containers, aliases, groups) {
    var productFields = buildProductFields(productInfo);
    var tenantFields = buildTenantFields(tenantInfo);
    var userFields = buildUserFields(userInfo);
    var orgFields = buildOrgFields(orgInfo);
    var workspaceFields = buildWorkspaceFields(workspaceInfo);
    var collaborationContextFields = buildCollaborationContextFields(collaborationContextInfo);
    var overrides = {
        title: '',
        path: '',
        url: '',
        referrer: '',
        search: '',
        eventType: (0, _analyticsWebTypes.eventType).SCREEN
    };
    return (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, productFields, tenantFields, userFields, orgFields, overrides, buildAttributes(attributes), buildNonPrivacySafeAttributes(nonPrivacySafeAttributes), buildContainersWithName(containers), buildEventOverrides(event)), {
        tags: tags,
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        interactionSession: interactionSession,
        pageLoadId: pageLoadId
    }), workspaceFields, collaborationContextFields, buildAliases(aliases), buildGroups(groups));
}
function buildActionName(event) {
    return "".concat(event.actionSubject, " ").concat(event.action);
}
var validationMode = /*#__PURE__*/ function(validationMode) {
    validationMode["QUIET"] = "quiet";
    validationMode["STANDARD"] = "standard";
    validationMode["COMPLETE"] = "complete";
    return validationMode;
}({});
function getDefaultValidationMode(productInfo) {
    var environment = productInfo.env;
    if (environment === undefined) return "quiet";
    if (environment.includes('prod')) return "quiet";
    return "complete";
}
function buildContext(productInfo) {
    var screen = window.screen || {};
    return {
        context: {
            locale: productInfo.locale,
            screen: {
                width: screen.width,
                height: screen.height,
                density: window.devicePixelRatio
            },
            library: {
                name: 'analytics.js',
                version: libraryVersion
            },
            validationMode: getDefaultValidationMode(productInfo)
        }
    };
}
function extractProductOverrides(event) {
    var env = event.env, product = event.product, subproduct = event.subproduct, version = event.version, origin = event.origin, platform = event.platform;
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}
function buildActionEvent(productInfo, tenantInfo, userInfo, event, actionEventType, tabId, sessionId, taskSessions, interactionSession, orgInfo, pageLoadId, workspaceInfo, collaborationContextInfo, aliases, groups) {
    var productFields = buildProductFields(productInfo, extractProductOverrides(event));
    var tenantFields = buildTenantFields(tenantInfo);
    var orgFields = buildOrgFields(orgInfo);
    var workspaceFields = buildWorkspaceFields(workspaceInfo);
    var collaborationContextFields = buildCollaborationContextFields(collaborationContextInfo);
    var userFields = buildUserFields(userInfo);
    var actionFields = buildActionFields(event, actionEventType);
    return (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, productFields, tenantFields, orgFields, userFields, actionFields, buildEventOverrides(event)), {
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        interactionSession: interactionSession,
        pageLoadId: pageLoadId
    }), workspaceFields, collaborationContextFields, buildAliases(aliases), buildGroups(groups));
}

},{"@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@atlaskit/platform-feature-flags":"kO5t9","./analyticsWebTypes":"iDbK2","./util/object-utils":"gKNMa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gKNMa":[function(require,module,exports,__globalThis) {
// Modified from https://github.com/jonschlinkert/is-plain-object/blob/master/index.js
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isPlainObject", function() {
    return(// eslint-disable-next-line import/prefer-default-export
    isPlainObject);
});
var _typeOf = require("@swc/helpers/_/_type_of");
function isObject(val) {
    return val !== null && (typeof val === "undefined" ? "undefined" : (0, _typeOf._)(val)) === 'object' && Array.isArray(val) === false;
}
function isObjectObject(o) {
    return isObject(o) === true && Object.prototype.toString.call(o) === '[object Object]';
}
function isPlainObject(o) {
    if (isObjectObject(o) === false) return false;
    // If has modified constructor
    var ctor = o.constructor;
    if (typeof ctor !== 'function') return false;
    // If has modified prototype
    var prot = ctor.prototype;
    if (isObjectObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (!('isPrototypeOf' in prot)) return false;
    // Most likely a plain Object
    return true;
}

},{"@swc/helpers/_/_type_of":"iFJdx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hXyCv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CompressionRule", function() {
    return 0, _compressionRule.CompressionRule;
});
parcelHelpers.export(exports, "default", function() {
    return 0, _eventDelayCoordinatorDefault.default;
});
parcelHelpers.export(exports, "StopLowPriorityEventDelayReason", function() {
    return 0, _types.StopLowPriorityEventDelayReason;
});
var _compressionRule = require("./compressionRule");
var _eventDelayCoordinator = require("./eventDelayCoordinator");
var _eventDelayCoordinatorDefault = parcelHelpers.interopDefault(_eventDelayCoordinator);
var _types = require("./types");

},{"./compressionRule":false,"./eventDelayCoordinator":"csaIJ","./types":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"koogr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CompressionRule", function() {
    return CompressionRule;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _eventValidation = require("../eventValidation");
var _objectUtils = require("../objectUtils");
var CompressionRule = function CompressionRule(predicate, compressFn) {
    "use strict";
    var _this = this;
    (0, _classCallCheck._)(this, CompressionRule);
    /**
	 * This function returns a flag indicating whether or not this instance is capable of compressing the given event.
	 * @param event
	 * @returns {boolean}
	 */ this.canCompress = function(event) {
        try {
            return event && (0, _eventValidation.isActionEventType)(event.eventType) && _this.predicate(event);
        } catch (e) {
            return false;
        }
    };
    /**
	 * This function compresses as many events in the given collection as possible.<p>
	 * Any events in the given collection that do not match the conditions of {@link canCompress} will be left uncompressed and
	 * appended to the end of the resulting array.
	 *
	 * @param events A collection of analytic events to compress
	 * @returns {Array.<Object>} The action fields for the resulting compressed events
	 */ this.compress = function(events) {
        var _partition = (0, _slicedToArray._)((0, _objectUtils.partition)(events, function(event) {
            return _this.canCompress(event);
        }), 2), compatibleEvents = _partition[0], incompatibleEvents = _partition[1];
        var compressedEvents = _this.compressFn(compatibleEvents);
        if (!compressedEvents) throw new Error('No events were returned from the compression function');
        compressedEvents.forEach(function(event) {
            (0, _eventValidation.validateActionEventType)(event.eventType);
            (0, _eventValidation.validateActionEvent)(event);
        });
        return compressedEvents.concat(incompatibleEvents);
    };
    if (typeof predicate !== 'function') throw new Error('Invalid predicate, must be a function that accepts an event and returns a boolean');
    if (typeof compressFn !== 'function') throw new Error('Invalid compressFn, must be a function that both accepts and returns an array of events');
    this.predicate = predicate;
    this.compressFn = compressFn;
};

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_sliced_to_array":"8PtL6","../eventValidation":"eBvzD","../objectUtils":"3kJkz","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eBvzD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "validateContainersObject", function() {
    return validateContainersObject;
});
// the validation logic is documented here
// https://hello.atlassian.net/wiki/spaces/MEASURE/pages/545900273/Validating+containers+object
parcelHelpers.export(exports, "validateContainers", function() {
    return validateContainers;
});
parcelHelpers.export(exports, "isActionEventType", function() {
    return isActionEventType;
});
parcelHelpers.export(exports, "validateActionEventType", function() {
    return validateActionEventType;
});
parcelHelpers.export(exports, "validateActionEvent", function() {
    return validateActionEvent;
});
parcelHelpers.export(exports, "validateScreenEvent", function() {
    return validateScreenEvent;
});
parcelHelpers.export(exports, "validateTrackEvent", function() {
    return validateTrackEvent;
});
parcelHelpers.export(exports, "validateDwellBaseEvent", function() {
    return validateDwellBaseEvent;
});
parcelHelpers.export(exports, "validateUIEvent", function() {
    return validateUIEvent;
});
parcelHelpers.export(exports, "validateOperationalEvent", function() {
    return validateOperationalEvent;
});
parcelHelpers.export(exports, "validateIdentifyEvent", function() {
    return validateIdentifyEvent;
});
parcelHelpers.export(exports, "validatePlatform", function() {
    return validatePlatform;
});
var _analyticsWebTypes = require("./analyticsWebTypes");
var _objectUtils = require("./util/object-utils");
var actionEventTypes = Object.freeze([
    (0, _analyticsWebTypes.eventType).OPERATIONAL,
    (0, _analyticsWebTypes.eventType).TRACK,
    (0, _analyticsWebTypes.eventType).UI
]);
function validateContainersObject(container) {
    if (!(0, _objectUtils.isPlainObject)(container)) throw new Error('properties.containers must be an Object');
    if (!('id' in container)) throw new Error("properties.containers is missing field 'id'");
    if (typeof container.id !== 'string') throw new Error('properties.containers.id must be of type String');
    if ('type' in container && typeof container.type !== 'string') throw new Error('properties.containers.type must be of type String');
}
function validateContainers(containers) {
    if (!containers) return;
    if (containers && containers.constructor !== Object) throw new Error('properties.containers must be an Object');
    Object.values(containers).forEach(function(container) {
        return validateContainersObject(container);
    });
}
function isActionEventType(type) {
    switch(type){
        case (0, _analyticsWebTypes.eventType).OPERATIONAL:
        case (0, _analyticsWebTypes.eventType).TRACK:
        case (0, _analyticsWebTypes.eventType).UI:
            return true;
        default:
            return false;
    }
}
function validateActionEventType(type) {
    if (!isActionEventType(type)) throw new Error("Invalid action event type: ".concat(type, ", must be one of: [").concat(actionEventTypes, "]"));
    return true;
}
function validateActionEvent(event) {
    if (!event) throw new Error('Missing event');
    if (!event.source) throw new Error('Missing event.source');
    if (!event.actionSubject) throw new Error('Missing event.actionSubject');
    if (!event.action) throw new Error('Missing event.action');
    validateContainers(event.containers);
}
function validateScreenEvent(name) {
    if (!name) throw new Error('Missing name');
}
function validateTrackEvent(event) {
    validateActionEvent(event);
}
function validateDwellBaseEvent(event) {
    if (!event) throw new Error('Missing event');
    if (!event.source) throw new Error('Missing event.source');
    if (!event.actionSubject) throw new Error('Missing event.actionSubject');
}
function validateUIEvent(event) {
    validateActionEvent(event);
}
function validateOperationalEvent(event) {
    validateActionEvent(event);
}
function validateIdentifyEvent(userIdType, userId) {
    if (!userIdType) throw new Error('Missing userIdType');
    if (!userId) throw new Error('Missing userId');
    if (!(0, _analyticsWebTypes.isType)((0, _analyticsWebTypes.userType), userIdType)) throw new Error("Invalid userIdType '".concat(userIdType, "', ") + "must be an userType: [".concat((0, _analyticsWebTypes.objectValues)((0, _analyticsWebTypes.userType)), "]"));
}
function validatePlatform(productInfo) {
    if (!(0, _analyticsWebTypes.isType)((0, _analyticsWebTypes.platformType), productInfo.platform)) throw new Error("Invalid productInfo.platform '".concat(productInfo.platform, "', ") + "must be a platformType: [".concat((0, _analyticsWebTypes.objectValues)((0, _analyticsWebTypes.platformType)), "]"));
    if (productInfo.origin === (0, _analyticsWebTypes.originType).DESKTOP && !(0, _analyticsWebTypes.isType)((0, _analyticsWebTypes.desktopPlatforms), productInfo.platform)) throw new Error("Invalid productInfo.platform '".concat(productInfo.platform, "', ") + 'must be one of [mac, linux, windows]');
    if (productInfo.origin === (0, _analyticsWebTypes.originType).WEB && !(0, _analyticsWebTypes.isType)((0, _analyticsWebTypes.webPlatforms), productInfo.platform)) throw new Error("Invalid productInfo.platform '".concat(productInfo.platform, "', must be one of [web, mobileWeb]"));
}

},{"./analyticsWebTypes":"iDbK2","./util/object-utils":"gKNMa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"csaIJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return EventDelayCoordinator;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _defaults = require("./defaults");
var _eventDelayQueue = require("./eventDelayQueue");
var _eventDelayQueueDefault = parcelHelpers.interopDefault(_eventDelayQueue);
var _types = require("./types");
var EventDelayCoordinator = function EventDelayCoordinator(fireDelayedEvent, compressors) {
    "use strict";
    var _this = this;
    var _this1 = this;
    (0, _classCallCheck._)(this, EventDelayCoordinator);
    this.push = function(identifier, builtEvent, context, userInfo) {
        _this.delayQueue.push(identifier, builtEvent, context, userInfo);
    };
    this.startLowPriorityEventDelay = function() {
        var timeout = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, _defaults.DEFAULT_DELAY_TIMEOUT), callback = arguments.length > 1 ? arguments[1] : void 0;
        if (Number.isNaN(timeout) || timeout <= 0) throw new Error("Invalid timeout period: ".concat(timeout, ", must be a number greater than 0"));
        if (_this1.delayTimeout) clearTimeout(_this1.delayTimeout);
        var delayTimeoutPeriod = timeout ? Math.min(timeout, (0, _defaults.MAX_DELAY_TIMEOUT)) : (0, _defaults.MAX_DELAY_TIMEOUT);
        _this1.delayCallback = callback;
        _this1.delayTimeout = setTimeout(function() {
            return _this1.stopLowPriorityEventDelay((0, _types.StopLowPriorityEventDelayReason).TIMEOUT);
        }, delayTimeoutPeriod);
        // If the queue is still flushing from a previous delay period, then we should cancel that flush
        // to stop it from negatively impacting the performance of the new critical section
        _this1.delayQueue.cancelFlush();
        _this1.isDelaying = true;
    };
    this.stopLowPriorityEventDelay = function() {
        var reason = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, _types.StopLowPriorityEventDelayReason).MANUAL;
        var _this_delayCallback, _this;
        if (_this1.delayTimeout) {
            clearTimeout(_this1.delayTimeout);
            _this1.delayTimeout = undefined;
        }
        _this1.delayQueue.startFlush();
        _this1.isDelaying = false;
        (_this_delayCallback = (_this = _this1).delayCallback) === null || _this_delayCallback === void 0 ? void 0 : _this_delayCallback.call(_this, reason);
        _this1.delayCallback = undefined;
    };
    this.isDelayingLowPriorityEvents = function() {
        return _this.isDelaying;
    };
    this.isDelaying = false;
    this.delayQueue = new (0, _eventDelayQueueDefault.default)(fireDelayedEvent, compressors);
};

},{"@swc/helpers/_/_class_call_check":"5CNCO","./defaults":"8cDH8","./eventDelayQueue":"7lR8t","./types":"3CcLb","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8cDH8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_DELAY_TIMEOUT", function() {
    return DEFAULT_DELAY_TIMEOUT;
});
parcelHelpers.export(exports, "MAX_DELAY_TIMEOUT", function() {
    return MAX_DELAY_TIMEOUT;
});
var DEFAULT_DELAY_TIMEOUT = 10000;
var MAX_DELAY_TIMEOUT = 30000;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7lR8t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return EventDelayQueue;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _eventBuilder = require("../eventBuilder");
var _objectUtils = require("../objectUtils");
var _eventCompressor = require("./eventCompressor");
var _eventCompressorDefault = parcelHelpers.interopDefault(_eventCompressor);
// We want to throttle the flush rate so that we don't have a huge upfront performance hit from starting the flush,
// and so that the underlying Segment client has some time to process some events in its queue before more are added.
var FLUSH_BATCH_SIZE = 7; // aligns with the default batch size of Segment's BatchableQueue
var FLUSH_BATCH_BACKOFF_PERIOD = 100;
var EventDelayQueue = function EventDelayQueue(processFn, compressionRules) {
    "use strict";
    var _this = this;
    (0, _classCallCheck._)(this, EventDelayQueue);
    this.push = function(identifier, builtEvent, context, userInfo) {
        _this.eventArgs.push({
            identifier: identifier,
            builtEvent: builtEvent,
            context: context,
            userInfo: userInfo
        });
    };
    this.size = function() {
        return _this.eventArgs.length;
    };
    this.startFlush = function() {
        try {
            _this.eventArgs = _this.compressEventArgs(_this.eventArgs);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.warn('Failed to perform compression on the delayed analytics events. ' + "Error: ".concat(e.message, ". Sending ").concat(_this.eventArgs.length, " uncompressed events instead"));
        }
        _this.flushNextBatch();
    };
    this.cancelFlush = function() {
        if (_this.flushBatchTimeout) {
            clearTimeout(_this.flushBatchTimeout);
            _this.flushBatchTimeout = null;
        }
    };
    this.flushNextBatch = function() {
        var batch = _this.eventArgs.splice(0, FLUSH_BATCH_SIZE);
        batch.forEach(function(item) {
            return _this.processFn(item.identifier, item.builtEvent, item.context, item.userInfo);
        });
        if (_this.eventArgs.length > 0) _this.flushBatchTimeout = setTimeout(function() {
            return _this.flushNextBatch();
        }, FLUSH_BATCH_BACKOFF_PERIOD);
        else _this.flushBatchTimeout = null;
    };
    this.compressEventArgs = function(eventArgs) {
        var _partition = (0, _slicedToArray._)((0, _objectUtils.partition)(eventArgs, function(args) {
            return _this.compressor.canCompress(args.builtEvent);
        }), 2), compressibleEventArgs = _partition[0], incompressibleEventArgs = _partition[1];
        // Events can only be compressed together if they share the same context and user info, since these are top-level
        // fields that need to exist on the fired event and can only be set to a single value.
        // We can achieve this by grouping our events by context prior to passing them to the compressor.
        var contextGroups = compressibleEventArgs.reduce(function(groups, args) {
            var matchingGroup = groups.find(function(group) {
                return (0, _objectUtils.equals)(group.userInfo, args.userInfo) && (0, _objectUtils.equals)(group.context, args.context);
            });
            if (matchingGroup) matchingGroup.eventArgs.push(args);
            else groups.push({
                userInfo: args.userInfo,
                context: args.context,
                eventArgs: [
                    args
                ]
            });
            return groups;
        }, []);
        // Run the compressor on each group
        var allCompressedEventArgs = contextGroups.reduce(function(acc, group) {
            try {
                var events = group.eventArgs.map(function(args) {
                    return args.builtEvent;
                });
                var compressedEvents = _this.compressor.compress(events);
                var compressedEventArgs = compressedEvents.map(function(compressedEvent) {
                    return {
                        identifier: (0, _eventBuilder.buildActionName)(compressedEvent),
                        builtEvent: compressedEvent,
                        userInfo: group.userInfo,
                        context: group.context
                    };
                });
                return acc.concat(compressedEventArgs);
            } catch (e) {
                // If anything goes wrong while compressing this group, then just fall back on the
                // uncompressed events instead. The event compressor already handles errors with invalid
                // generator functions or results, but this is an extra layer of defense to prevent data
                // loss in the event of an unexpected error.
                // eslint-disable-next-line no-console
                console.warn('Failed to compress some analytics events. ' + "Error: ".concat(e.message, ". Sending ").concat(group.eventArgs.length, " uncompressed events instead"));
                return group.eventArgs;
            }
        }, []);
        incompressibleEventArgs.forEach(function(args) {
            return allCompressedEventArgs.push(args);
        });
        return allCompressedEventArgs;
    };
    this.processFn = processFn;
    this.flushBatchTimeout = null;
    this.eventArgs = [];
    this.compressor = new (0, _eventCompressorDefault.default)(compressionRules);
};

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_sliced_to_array":"8PtL6","../eventBuilder":"l3Cu2","../objectUtils":"3kJkz","./eventCompressor":"4cpFu","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4cpFu":[function(require,module,exports,__globalThis) {
/* eslint-disable implicit-arrow-linebreak */ /* eslint-disable max-classes-per-file */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return EventCompressor;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _eventBuilder = require("../eventBuilder");
var _objectUtils = require("../objectUtils");
var _compressionRule = require("./compressionRule");
var EventCompressor = function EventCompressor() {
    "use strict";
    var _this = this;
    var compressionRules = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    (0, _classCallCheck._)(this, EventCompressor);
    this.canCompress = function(event) {
        return _this.compressionRules.some(function(compressionRule) {
            return compressionRule.canCompress(event);
        });
    };
    this.compress = function(events) {
        var groups = _this.createGroups(events);
        return groups.reduce(function(allCompressedEvents, group) {
            var groupCompressedEvents = _this.compressGroup(group);
            return allCompressedEvents.concat(groupCompressedEvents);
        }, []);
    };
    this.createGroups = function(events) {
        return(// Group events based on contextual fields. These fields are anything that is added by the client itself,
        // rather than passed in by the caller (eg. product, org. and tenant info)
        events.reduce(function(groups, event) {
            var matchingCompressor = _this.compressionRules.find(function(compressor) {
                return compressor.canCompress(event);
            });
            var contextFields;
            if (matchingCompressor) {
                var actionFields = (0, _eventBuilder.buildActionFields)(event, event.eventType);
                contextFields = (0, _objectUtils.omit)(event, Object.keys(actionFields));
            }
            var matchingGroup = groups.find(function(group) {
                return matchingCompressor === group.compressor && (0, _objectUtils.equals)(contextFields, group.contextFields);
            });
            if (matchingGroup) matchingGroup.events.push(event);
            else groups.push({
                contextFields: contextFields,
                compressor: matchingCompressor,
                events: [
                    event
                ]
            });
            return groups;
        }, []));
    };
    this.compressGroup = function(group) {
        // If this group doesn't have any compressor, then the event args are already in their final format
        if (!group.compressor) return group.events;
        try {
            // Run the compressor on the group to generate some new events.
            // The compression function is only expected to return the action fields for each
            // event that it generates, since all other fields are generated by the client.
            var compressedEventActionFields = group.compressor.compress(group.events);
            // Add the context fields to each of the resulting events to inflate them into a full action event
            return compressedEventActionFields.map(function(actionFields) {
                return (0, _objectSpread._)({}, actionFields, group.contextFields);
            });
        } catch (e) {
            // If we fail to compress the events, then just fall back the uncompressed events
            // so that no data is lost. This can happen if the compression function throws an error
            // or returns some invalid event payloads.
            // eslint-disable-next-line no-console
            // console.warn(
            // 	'Failed to compress some analytics events. ' +
            // 		`Error: ${(e as Error).message}. Sending ${
            // 			group.events.length
            // 		} uncompressed events instead`,
            // );
            return group.events;
        }
    };
    if (!Array.isArray(compressionRules)) throw new Error('Event compressors must be constructed with an array of CompressionRules');
    if (!compressionRules.every(function(rule) {
        return (0, _instanceof._)(rule, (0, _compressionRule.CompressionRule));
    })) throw new Error('Event compressors can only be constructed with instances of CompressionRule');
    this.compressionRules = compressionRules;
};

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_object_spread":"9gdrV","../eventBuilder":"l3Cu2","../objectUtils":"3kJkz","./compressionRule":"koogr","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3CcLb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StopLowPriorityEventDelayReason", function() {
    return StopLowPriorityEventDelayReason;
});
var StopLowPriorityEventDelayReason = /*#__PURE__*/ function(StopLowPriorityEventDelayReason) {
    StopLowPriorityEventDelayReason["TIMEOUT"] = "timeout";
    StopLowPriorityEventDelayReason["MANUAL"] = "manual";
    return StopLowPriorityEventDelayReason;
}({});

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"efpMW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return 0, _eventProcessorDefault.default;
});
var _eventProcessor = require("./eventProcessor");
var _eventProcessorDefault = parcelHelpers.interopDefault(_eventProcessor);

},{"./eventProcessor":"5wPVu","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5wPVu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AnalyticsResponse", function() {
    return AnalyticsResponse;
});
parcelHelpers.export(exports, "default", function() {
    return EventProcessor;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _resilienceQueue = require("../resilienceQueue");
var _resilienceQueueDefault = parcelHelpers.interopDefault(_resilienceQueue);
var _metrics = require("../resilienceQueue/Metrics");
var _metricsDefault = parcelHelpers.interopDefault(_metrics);
var _uuid = require("../uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
var _xid = require("../xid");
var _defaults = require("./defaults");
var _httpStatusCode = require("./HttpStatusCode");
var _sendEvents = require("./sendEvents");
var _types = require("./types");
var _user = require("./user");
var _userDefault = parcelHelpers.interopDefault(_user);
var _util = require("./util");
var AnalyticsAPIResponse = /*#__PURE__*/ function() {
    "use strict";
    function AnalyticsAPIResponse(success, validationErrors, message, code, validationReports) {
        (0, _classCallCheck._)(this, AnalyticsAPIResponse);
        this.success = success;
        this.validationErrors = validationErrors;
        this.message = message;
        this.code = code;
        this.validationReports = validationReports;
    }
    (0, _createClass._)(AnalyticsAPIResponse, [
        {
            key: "isSuccess",
            value: function isSuccess() {
                return this.success;
            }
        },
        {
            key: "getValidationErrors",
            value: function getValidationErrors() {
                return this.validationErrors;
            }
        },
        {
            key: "getMessage",
            value: function getMessage() {
                return this.message;
            }
        },
        {
            key: "getCode",
            value: function getCode() {
                return this.code;
            }
        },
        {
            key: "getValidationReports",
            value: function getValidationReports() {
                return this.validationReports === undefined ? null : this.validationReports;
            }
        }
    ]);
    return AnalyticsAPIResponse;
}();
var Message = function Message(error) {
    "use strict";
    (0, _classCallCheck._)(this, Message);
    this.error = error;
};
var EventValidationReport = /*#__PURE__*/ function() {
    "use strict";
    function EventValidationReport(messageId, results) {
        (0, _classCallCheck._)(this, EventValidationReport);
        this.messageId = messageId;
        this.results = results;
    }
    (0, _createClass._)(EventValidationReport, [
        {
            key: "getMessageId",
            value: function getMessageId() {
                return this.messageId;
            }
        },
        {
            key: "getResults",
            value: function getResults() {
                return this.results;
            }
        }
    ]);
    return EventValidationReport;
}();
var AnalyticsResponse = /*#__PURE__*/ function() {
    "use strict";
    function AnalyticsResponse(success, statusCode, message, eventResponseList) {
        (0, _classCallCheck._)(this, AnalyticsResponse);
        this.success = success;
        this.statusCode = statusCode;
        this.message = message;
        this.eventResponseList = eventResponseList;
    }
    (0, _createClass._)(AnalyticsResponse, [
        {
            key: "isSuccess",
            value: function isSuccess() {
                return this.success;
            }
        },
        {
            key: "getStatusCode",
            value: function getStatusCode() {
                return this.statusCode;
            }
        },
        {
            key: "getMessage",
            value: function getMessage() {
                return this.message;
            }
        },
        {
            key: "getEventResponseList",
            value: function getEventResponseList() {
                return this.eventResponseList;
            }
        }
    ]);
    return AnalyticsResponse;
}();
var EventResponse = /*#__PURE__*/ function() {
    "use strict";
    function EventResponse(messageId, results, segmentEvent) {
        (0, _classCallCheck._)(this, EventResponse);
        this.messageId = messageId;
        this.results = results;
        this.segmentEvent = segmentEvent;
    }
    (0, _createClass._)(EventResponse, [
        {
            key: "getMessageId",
            value: function getMessageId() {
                return this.messageId;
            }
        },
        {
            key: "getResults",
            value: function getResults() {
                return this.results;
            }
        },
        {
            key: "getSegmentEvent",
            value: function getSegmentEvent() {
                return this.segmentEvent;
            }
        }
    ]);
    return EventResponse;
}();
var EventValidationResult = /*#__PURE__*/ function() {
    "use strict";
    function EventValidationResult(type, severity, propertyPath, message) {
        (0, _classCallCheck._)(this, EventValidationResult);
        this.type = type;
        this.severity = severity;
        this.propertyPath = propertyPath;
        this.message = message;
    }
    (0, _createClass._)(EventValidationResult, [
        {
            key: "getType",
            value: function getType() {
                return this.type;
            }
        },
        {
            key: "getSeverity",
            value: function getSeverity() {
                return this.severity;
            }
        },
        {
            key: "getPropertyPath",
            value: function getPropertyPath() {
                return this.propertyPath;
            }
        },
        {
            key: "getMessage",
            value: function getMessage() {
                return this.message;
            }
        }
    ]);
    return EventValidationResult;
}();
var EventProcessor = /*#__PURE__*/ function() {
    "use strict";
    function EventProcessor(options) {
        var _this = this;
        (0, _classCallCheck._)(this, EventProcessor);
        var _this_options;
        this.originTracingClient = null;
        // Using anonymous function so it can have the BatchFlushCallback type associated with it
        // And to allow it to not need bind when passing through to ResilieceQueue.
        this.sendEvents = function(items, callback) {
            return (0, _asyncToGenerator._)(function() {
                var _this, _this_lastSendEventsError, _this_metadataClient, httpRetryCount, metricsPayload, eventsWithXID, sentAt, metadataInfo, _this_getEventUrl, eventUrl, isFallbackUrl, metadata, unpackagedEvents, batchBody, _this_originTracingClient, response, error, errorName, _this_getEventUrl1, _, willUseFallbackUrl;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this = this;
                            if (this.options.enableEventCalls === false) return [
                                2
                            ];
                            httpRetryCount = this.resilienceQueue.getGlobalRetryCount();
                            metricsPayload = this.metrics.getMetricsPayload();
                            return [
                                4,
                                this.attachXIDs(items)
                            ];
                        case 1:
                            eventsWithXID = _state.sent();
                            // Calculating sentAt after the XID generation as this may take some time.
                            sentAt = new Date().toISOString();
                            return [
                                4,
                                this.metadataClient.getMetadataAsync()
                            ];
                        case 2:
                            metadataInfo = _state.sent();
                            _this_getEventUrl = (0, _slicedToArray._)(this.getEventUrl(metadataInfo), 2), eventUrl = _this_getEventUrl[0], isFallbackUrl = _this_getEventUrl[1];
                            metadata = (0, _objectSpreadProps._)((0, _objectSpread._)({}, metricsPayload), {
                                httpRetryCount: httpRetryCount,
                                lastSendEventsErrorReason: ((_this_lastSendEventsError = this.lastSendEventsError) === null || _this_lastSendEventsError === void 0 ? void 0 : _this_lastSendEventsError.message) || null,
                                lastSendEventsError: this.lastSendEventsError,
                                lastUrlFallbackError: this.lastUrlFallbackError,
                                isUsingFallbackUrl: isFallbackUrl,
                                props: (metadataInfo === null || metadataInfo === void 0 ? void 0 : metadataInfo.props) || null,
                                metadataClientMetrics: ((_this_metadataClient = this.metadataClient) === null || _this_metadataClient === void 0 ? void 0 : _this_metadataClient.metrics) || null
                            });
                            // Remove default values from metadata to save space
                            this.cleanLibraryMetadata(metadata);
                            unpackagedEvents = eventsWithXID.map(function(item) {
                                _this.applyExclusions(item);
                                item.msg.sentAt = sentAt;
                                return item.msg;
                            });
                            batchBody = {
                                batch: unpackagedEvents,
                                sentAt: sentAt,
                                metadata: metadata
                            };
                            _state.label = 3;
                        case 3:
                            _state.trys.push([
                                3,
                                6,
                                ,
                                8
                            ]);
                            return [
                                4,
                                (0, _sendEvents.sendEvents)({
                                    url: eventUrl,
                                    batch: batchBody,
                                    timeout: this.options.requestTimeout
                                })
                            ];
                        case 4:
                            response = _state.sent();
                            this.lastSendEventsError = null;
                            this.lastUrlFallbackError = null;
                            this.metrics.subtractFromMetrics(metricsPayload);
                            callback(null, response);
                            (_this_originTracingClient = this.originTracingClient) === null || _this_originTracingClient === void 0 ? void 0 : _this_originTracingClient.cleanupOriginParameters(items);
                            return [
                                4,
                                this.invokeLocalResponseCallbackAsync(items, response, null)
                            ];
                        case 5:
                            _state.sent();
                            return [
                                3,
                                8
                            ];
                        case 6:
                            error = _state.sent();
                            // If there's an error, other than one which indicates a temporary problem with the service,
                            // we'll stop using the URL from the metadata and fall back to the default URL. After a time
                            // we'll fall forward again in case the problem has been resolved.
                            if ((0, _instanceof._)(error, (0, _types.FetchError)) && [
                                429,
                                503
                            ].includes(error.statusCode)) // Ignore 429 and 503 errors since they're considered to indicate a temporary
                            // issue with the service, rather than a network failure due to blocked requests.
                            this.lastSendEventsError = new (0, _types.LastError)('ServerBusyError', error);
                            else {
                                errorName = (0, _instanceof._)(error, Error) && (0, _types.ALLOW_LISTED_FETCH_ERROR_NAMES).includes(error.name) ? error.name : 'Unknown';
                                this.lastSendEventsError = new (0, _types.LastError)(errorName, error);
                                // Handle falling back to the default URL if we're using the metadata URL.
                                this.useUrlFromMetadata = false;
                                // If we're now using the fallback URL, and the last attempt wasn't,
                                // we'll record this as the error that triggered the fallback.
                                _this_getEventUrl1 = (0, _slicedToArray._)(this.getEventUrl(metadataInfo), 2), _ = _this_getEventUrl1[0], willUseFallbackUrl = _this_getEventUrl1[1];
                                if (willUseFallbackUrl && willUseFallbackUrl !== isFallbackUrl) this.lastUrlFallbackError = this.lastSendEventsError;
                            }
                            callback(error, null);
                            return [
                                4,
                                this.invokeLocalResponseCallbackAsync(items, null, error)
                            ];
                        case 7:
                            _state.sent();
                            return [
                                3,
                                8
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }).call(_this);
        };
        this.options = (0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
            requestTimeout: options.requestTimeout || (0, _defaults.DEFAULT_REQUEST_TIMEOUT),
            retryQueueOptions: options.retryQueueOptions || {},
            logger: options.logger || console,
            disableCookiePersistence: options.disableCookiePersistence || false,
            env: options.env,
            perimeter: options.perimeter || '',
            enableMetadataCalls: typeof options.enableMetadataCalls === 'boolean' ? options.enableMetadataCalls : true,
            enableEventCalls: typeof options.enableEventCalls === 'boolean' ? options.enableEventCalls : true
        });
        this.user = new (0, _userDefault.default)((_this_options = this.options) === null || _this_options === void 0 ? void 0 : _this_options.disableCookiePersistence);
        this.xidPromiseCallback = options.xidPromiseGetter();
        this.gasv3BatchUrl = "".concat(options.apiHostProtocol, "://").concat(options.apiHost, "/batch");
        this.metrics = (0, _metricsDefault.default)();
        this.responseCallback = options.responseCallback;
        this.resilienceQueue = (0, _resilienceQueueDefault.default)(options.retryQueuePrefix, options.product, this.options.retryQueueOptions, this.options.logger);
        this.metadataClient = options.metadataClient;
        this.useUrlFromMetadata = true;
        this.lastSendEventsError = null;
        this.lastUrlFallbackError = null;
        setInterval(function() {
            _this.useUrlFromMetadata = true;
        }, 600000);
        this.resilienceQueue.start(this.sendEvents);
    }
    (0, _createClass._)(EventProcessor, [
        {
            key: "getUser",
            value: function getUser() {
                return this.user;
            }
        },
        {
            key: "track",
            value: function track(eventName, builtEvent, context, callback) {
                return (0, _asyncToGenerator._)(function() {
                    var baseEvent, eventWithoutMessageId, event, packagedEvent;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                baseEvent = this.buildBaseEvent(context, (0, _types.SegmentEventTypes).TRACK, builtEvent);
                                eventWithoutMessageId = (0, _objectSpreadProps._)((0, _objectSpread._)({}, baseEvent), {
                                    type: (0, _types.SegmentEventTypes).TRACK,
                                    properties: (0, _util.prepareEventProperties)(builtEvent),
                                    event: eventName
                                });
                                event = (0, _objectSpreadProps._)((0, _objectSpread._)({}, eventWithoutMessageId), {
                                    messageId: this.createMessageId()
                                });
                                packagedEvent = this.packageEvent(event);
                                return [
                                    4,
                                    this.enqueueEvent(packagedEvent)
                                ];
                            case 1:
                                _state.sent();
                                if (callback) callback();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "page",
            value: function page(eventName, builtEvent, context, callback) {
                return (0, _asyncToGenerator._)(function() {
                    var baseEvent, eventWithoutMessageId, event, packagedEvent;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                baseEvent = this.buildBaseEvent(context, (0, _types.SegmentEventTypes).PAGE, builtEvent);
                                eventWithoutMessageId = (0, _objectSpreadProps._)((0, _objectSpread._)({}, baseEvent), {
                                    type: (0, _types.SegmentEventTypes).PAGE,
                                    properties: (0, _util.prepareEventProperties)(builtEvent),
                                    name: eventName
                                });
                                event = (0, _objectSpreadProps._)((0, _objectSpread._)({}, eventWithoutMessageId), {
                                    messageId: this.createMessageId()
                                });
                                packagedEvent = this.packageEvent(event);
                                return [
                                    4,
                                    this.enqueueEvent(packagedEvent)
                                ];
                            case 1:
                                _state.sent();
                                if (callback) callback();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "identify",
            value: // Segment uses the identifier to update user id which we have already done in the analyticsWebClient.ts
            function identify(_identifier, builtEvent, context, callback) {
                return (0, _asyncToGenerator._)(function() {
                    var baseEvent, eventWithoutMessageId, event, packagedEvent;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                baseEvent = this.buildBaseEvent(context, (0, _types.SegmentEventTypes).IDENTIFY, builtEvent);
                                eventWithoutMessageId = (0, _objectSpreadProps._)((0, _objectSpread._)({}, baseEvent), {
                                    type: (0, _types.SegmentEventTypes).IDENTIFY,
                                    traits: (0, _util.prepareEventProperties)(builtEvent)
                                });
                                event = (0, _objectSpreadProps._)((0, _objectSpread._)({}, eventWithoutMessageId), {
                                    messageId: this.createMessageId()
                                });
                                packagedEvent = this.packageEvent(event);
                                return [
                                    4,
                                    this.enqueueEvent(packagedEvent)
                                ];
                            case 1:
                                _state.sent();
                                if (callback) callback();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "enqueueEvent",
            value: function enqueueEvent(packagedEvent) {
                return (0, _asyncToGenerator._)(function() {
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (this.options.enableMetadataCalls) this.metadataClient.start(false); // Start the metadata client if needed
                                return [
                                    4,
                                    this.resilienceQueue.addItem(packagedEvent)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "buildBaseEvent",
            value: function buildBaseEvent(context, type, overrides) {
                var clonedContext = (0, _util.prepareEventContext)(context);
                var segmentContext = (0, _util.buildContext)(clonedContext, overrides);
                return {
                    context: segmentContext,
                    timestamp: new Date().toISOString(),
                    type: type,
                    userId: this.user.getUserId(),
                    anonymousId: overrides.anonymousId || this.user.getAnonymousId()
                };
            }
        },
        {
            key: "createMessageId",
            value: function createMessageId() {
                return "ajs-".concat((0, _uuidDefault.default)());
            }
        },
        {
            key: "packageEvent",
            value: function packageEvent(event) {
                var _this_options = this.options, apiHost = _this_options.apiHost, apiHostProtocol = _this_options.apiHostProtocol;
                return {
                    headers: {
                        'Content-Type': 'text/plain'
                    },
                    msg: event,
                    url: "".concat(apiHostProtocol, "://").concat(apiHost, "/").concat(event.type.charAt(0))
                };
            }
        },
        {
            key: "applyExclusions",
            value: function applyExclusions(item) {
                var _msg_context;
                var msg = item.msg;
                var properties = msg.properties;
                var traits = msg.traits;
                var excluded = (_msg_context = msg.context) === null || _msg_context === void 0 ? void 0 : _msg_context.excludedProperties;
                if (!excluded) return;
                if (excluded.anonymousId === true) msg.anonymousId = undefined;
                if (excluded.interactionSession === true) {
                    if (properties) properties.interactionSession = undefined;
                }
                if (excluded.sessionId === true) {
                    if (properties) properties.sessionId = undefined;
                }
                if (excluded.pageLoadId === true) {
                    if (properties) properties.pageLoadId = undefined;
                }
                if (excluded.tabId === true) {
                    if (properties) properties.tabId = undefined;
                }
                if (excluded.taskSessions === true) {
                    if (properties) properties.taskSessions = undefined;
                }
                if (excluded.userId === true) {
                    msg.userId = undefined;
                    if (properties) properties.userIdType = undefined;
                }
                if (excluded.xid === true) {
                    if (properties) properties.xid = undefined;
                    if (traits) traits.xid = undefined;
                }
            }
        },
        {
            key: "getEventUrl",
            value: function getEventUrl(metadataInfo) {
                var preferredBatchUrl = (metadataInfo === null || metadataInfo === void 0 ? void 0 : metadataInfo.url) ? metadataInfo.url : this.gasv3BatchUrl;
                var finalBatchUrl = this.useUrlFromMetadata ? preferredBatchUrl : this.gasv3BatchUrl;
                var isFallbackUrl = preferredBatchUrl === this.gasv3BatchUrl ? null : finalBatchUrl !== preferredBatchUrl;
                return [
                    finalBatchUrl,
                    isFallbackUrl
                ];
            }
        },
        {
            key: "cleanLibraryMetadata",
            value: function cleanLibraryMetadata(obj) {
                var _this = this;
                // skip if the parameter is not an object
                if (obj === null || (typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj)) !== 'object') return;
                for(var key in obj){
                    // Skip cleaning up props object and its keys
                    // to avoid having to check the existence of the fields in props object
                    // and manipulate them to calculate metadata signature in analytics service
                    if (key === 'props') continue;
                    var value = obj[key];
                    // Remove null or undefined values
                    if (value === null || value === undefined) delete obj[key];
                    else if (typeof value === 'number' && value === 0) delete obj[key];
                    else if (Array.isArray(value)) {
                        if (value.length === 0) delete obj[key];
                        else value.forEach(function(item) {
                            _this.cleanLibraryMetadata(item);
                        });
                    } else if ((typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) === 'object') this.cleanLibraryMetadata(obj[key]);
                }
            }
        },
        {
            key: "invokeLocalResponseCallbackAsync",
            value: function invokeLocalResponseCallbackAsync(items, response, error) {
                return (0, _asyncToGenerator._)(function() {
                    var localResponseCallback, analyticsAPIResponse, _responseObject_message, responseObject, e, analyticsResponse;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                localResponseCallback = this.responseCallback;
                                if (!localResponseCallback) return [
                                    3,
                                    6
                                ];
                                // If we have a response, we'll parse it and create an AnalyticsAPIResponse from it.
                                analyticsAPIResponse = null;
                                if (!response) return [
                                    3,
                                    5
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    response.clone().json()
                                ];
                            case 2:
                                responseObject = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                // Ensure we've got a valid object to work with, filling in any missing
                                // properties as best we can.
                                responseObject = responseObject || {};
                                responseObject.code = Number.parseInt(responseObject.code) > 0 ? Number.parseInt(responseObject.code) : response.status;
                                responseObject.success = responseObject.success || responseObject.code >= 200 && responseObject.code <= 299;
                                analyticsAPIResponse = new AnalyticsAPIResponse(responseObject.success, responseObject.validationErrors || new Map(), new Message(((_responseObject_message = responseObject.message) === null || _responseObject_message === void 0 ? void 0 : _responseObject_message.error) || ''), responseObject.code, responseObject.validationReports || null);
                                _state.label = 5;
                            case 5:
                                // If we have an error, but it's not an instance of Error (e.g. it's a string), we'll convert it to an Error object.
                                if (error && !(0, _instanceof._)(error, Error)) error = new Error(String(error));
                                analyticsResponse = BatchInterceptor.toAnalyticsResponse(items || [], error || null, analyticsAPIResponse);
                                localResponseCallback(analyticsResponse);
                                _state.label = 6;
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "attachXIDs",
            value: function attachXIDs(items) {
                return (0, _asyncToGenerator._)(function() {
                    return (0, _tsGenerator._)(this, function(_state) {
                        if (this.xidPromiseCallback) return [
                            2,
                            (0, _xid.attachXidToMultipleEvents)(items, this.xidPromiseCallback)
                        ];
                        return [
                            2,
                            Promise.resolve(items)
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "setOriginTracingClient",
            value: /** @internal Used by AnalyticsWebClient to wire up origin tracing cleanup. */ function setOriginTracingClient(client) {
                this.originTracingClient = client;
            }
        },
        {
            key: "setResponseCallback",
            value: function setResponseCallback(responseCallback) {
                this.responseCallback = responseCallback;
            }
        },
        {
            key: "refreshMetadata",
            value: function refreshMetadata(userInfo, tenantInfo) {
                this.metadataClient.userInfo = userInfo;
                this.metadataClient.tenantInfo = tenantInfo;
            }
        }
    ]);
    return EventProcessor;
}();
var BatchInterceptor = /*#__PURE__*/ function() {
    "use strict";
    function BatchInterceptor() {
        (0, _classCallCheck._)(this, BatchInterceptor);
    }
    (0, _createClass._)(BatchInterceptor, null, [
        {
            key: "toAnalyticsResponse",
            value: function toAnalyticsResponse(items, error, analyticsAPIResponse) {
                var eventResponseList = [];
                if (analyticsAPIResponse !== null) {
                    var _ref = [
                        analyticsAPIResponse.code,
                        analyticsAPIResponse.success
                    ], statusCode = _ref[0], success = _ref[1];
                    if (statusCode >= 200 && statusCode <= 299) {
                        var _analyticsAPIResponse_validationReports;
                        (_analyticsAPIResponse_validationReports = analyticsAPIResponse.validationReports) === null || _analyticsAPIResponse_validationReports === void 0 ? void 0 : _analyticsAPIResponse_validationReports.forEach(function(report) {
                            var matchedEvent = items.find(function(item) {
                                return item.msg.messageId === report.messageId;
                            });
                            if (matchedEvent) eventResponseList.push(new EventResponse(matchedEvent.msg.messageId, report.results, matchedEvent.msg));
                        });
                        return new AnalyticsResponse(success, statusCode, (0, _httpStatusCode.HTTP_STATUS_CODE_MAP).get(statusCode), eventResponseList);
                    } else if (statusCode >= 400 && statusCode <= 499) {
                        var _analyticsAPIResponse_message;
                        // not exluding "HTTP 429 Too Many Requests error" as it is thrown as an error and handled below
                        var errorMessage = ((_analyticsAPIResponse_message = analyticsAPIResponse.message) === null || _analyticsAPIResponse_message === void 0 ? void 0 : _analyticsAPIResponse_message.error) !== null ? analyticsAPIResponse.message.error : (0, _httpStatusCode.HTTP_STATUS_CODE_MAP).has(statusCode) ? (0, _httpStatusCode.HTTP_STATUS_CODE_MAP).get(statusCode) : (0, _httpStatusCode.HTTP_STATUS_CODE_MAP).get(-1);
                        items.forEach(function(item) {
                            eventResponseList.push(new EventResponse(item.msg.messageId, [], item.msg));
                        });
                        return new AnalyticsResponse(success, statusCode, errorMessage, eventResponseList);
                    }
                } else if (error === null || error === void 0 ? void 0 : error.message) {
                    var match = error.message.match(BatchInterceptor.http_error_regex);
                    if (match) {
                        items.forEach(function(item) {
                            eventResponseList.push(new EventResponse(item.msg.messageId, [], item.msg));
                        });
                        return new AnalyticsResponse(false, Number(match[1]), match[2], eventResponseList);
                    }
                }
                items.forEach(function(item) {
                    eventResponseList.push(new EventResponse(item.msg.messageId, [], item.msg));
                });
                return new AnalyticsResponse(false, -1, (0, _httpStatusCode.HTTP_STATUS_CODE_MAP).get(-1), eventResponseList);
            }
        }
    ]);
    return BatchInterceptor;
}();
BatchInterceptor.http_error_regex = /HTTP Error\s([0-9]{3})\s\((.+)\)/;

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_type_of":"iFJdx","@swc/helpers/_/_ts_generator":"78Tqx","../resilienceQueue":"2H0ot","../resilienceQueue/Metrics":"al9gp","../uuid":"gL2xH","../xid":"54XC1","./defaults":"fC7BS","./HttpStatusCode":"dZsiM","./sendEvents":"5EkXo","./types":"iaCPD","./user":"9uV6H","./util":"ibHGi","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2H0ot":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Enum isnt just a type, its also an object that needs to be
// exported as an object.
parcelHelpers.export(exports, "ResilienceMechanism", function() {
    return 0, _types.ResilienceMechanism;
});
var _pullBatchableQueue = require("./PullBatchableQueue");
var _pullBatchableQueueDefault = parcelHelpers.interopDefault(_pullBatchableQueue);
var _types = require("./types");
exports.default = function(retryQueuePrefix, product, options, logger) {
    return new (0, _pullBatchableQueueDefault.default)(retryQueuePrefix, product, options || {}, logger);
};

},{"./PullBatchableQueue":"1S9sK","./types":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1S9sK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_POLLING_OPTIONS", function() {
    return DEFAULT_POLLING_OPTIONS;
});
parcelHelpers.export(exports, "default", function() {
    return PullBatchableQueue;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _localstorageRetry = require("../localstorage-retry");
var _resiliencedb = require("../resiliencedb");
var _resiliencedbDefault = parcelHelpers.interopDefault(_resiliencedb);
var _metrics = require("./Metrics");
var _metricsDefault = parcelHelpers.interopDefault(_metrics);
var _networkStatus = require("./NetworkStatus");
var _networkStatusDefault = parcelHelpers.interopDefault(_networkStatus);
var _scheduler = require("./scheduler");
var _schedulerDefault = parcelHelpers.interopDefault(_scheduler);
var _types = require("./types");
var ONE_MINUTE = 60000;
var LONG_POLLING_OPTIONS = {
    backoffFactor: 0,
    backoffJitterPercentage: 0,
    flushWaitMs: ONE_MINUTE,
    minRetryDelay: ONE_MINUTE,
    maxRetryDelay: ONE_MINUTE
};
var DEFAULT_POLLING_OPTIONS = {
    backoffFactor: 2,
    backoffJitterPercentage: 0.2,
    batchFlushSize: 7,
    flushBeforeUnload: false,
    flushWaitMs: 500,
    maxAttempts: 10,
    // The maximum number of events that can be stored in the resilience queue (IndexedDB/memory).
    // This limit is per product and is enforced by the EventCountGuard in the resilience layer.
    maxQueueSize: 8000,
    maxRetryDelay: 30000,
    minRetryDelay: 1000
};
var PullBatchableQueue = /*#__PURE__*/ function() {
    "use strict";
    function PullBatchableQueue(queuePrefix, product, options, logger) {
        var _this = this;
        (0, _classCallCheck._)(this, PullBatchableQueue);
        this.queuePrefix = queuePrefix;
        // Avoiding using options in ResilienceDB at this stage as
        // the options are optimised for the PushBatchableQueue
        this.resilience = new (0, _resiliencedbDefault.default)(product, {
            logger: logger,
            maxAttempts: options === null || options === void 0 ? void 0 : options.maxAttempts,
            maxEventLimit: (options === null || options === void 0 ? void 0 : options.maxQueueSize) || DEFAULT_POLLING_OPTIONS.maxQueueSize
        });
        this.options = this.buildOptions(options);
        this.scheduler = new (0, _schedulerDefault.default)((0, _objectSpreadProps._)((0, _objectSpread._)({}, this.options), {
            waitInterval: (options === null || options === void 0 ? void 0 : options.flushBeforeUnload) ? 0 : this.options.flushWaitMs
        }), this.scheduleCallback.bind(this));
        this.longPollingScheduler = new (0, _schedulerDefault.default)((0, _objectSpreadProps._)((0, _objectSpread._)({}, LONG_POLLING_OPTIONS), {
            waitInterval: LONG_POLLING_OPTIONS.flushWaitMs
        }), this.scheduleLongCallBack.bind(this));
        this.metricsCollector = (0, _metricsDefault.default)();
        this.networkStatus = new (0, _networkStatusDefault.default)(function(status) {
            if (status === (0, _types.NetworkStatusEnum).OFFLINE) _this.scheduler.stop();
            else _this.checkEventCountAndReschedule();
        });
    }
    (0, _createClass._)(PullBatchableQueue, [
        {
            key: "start",
            value: function start(flushCallback) {
                this.batchFlushCallback = flushCallback;
                this.longPollingScheduler.schedule();
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.scheduler.stop();
                this.longPollingScheduler.stop();
            }
        },
        {
            key: "addItem",
            value: function addItem(item) {
                return (0, _asyncToGenerator._)(function() {
                    var jsonStringifiedAndParsedItem, numberOfEvictedItems;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Since Jira and Confluence use `.toJSON` on objects that should be strings
                                // And expect us to use `JSON.stringify` on these objects,
                                // And indexeddb strips these functions from the objects when adding them to the DB,
                                // We must run this silly stringify and parse before passing the event to the resilience meechanism.
                                // Planning on removing this in v4
                                jsonStringifiedAndParsedItem = JSON.parse(JSON.stringify(item));
                                return [
                                    4,
                                    this.resilience.addItem(jsonStringifiedAndParsedItem, {}, (0, _resiliencedb.GuardPolicy).EVICT)
                                ];
                            case 1:
                                numberOfEvictedItems = _state.sent().numberOfEvictedItems;
                                this.scheduler.schedule();
                                this.metricsCollector.addToEventCount();
                                if (numberOfEvictedItems > 0) this.metricsCollector.addToItemsDiscardedByOverflowCounter(numberOfEvictedItems);
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getGlobalRetryCount",
            value: function getGlobalRetryCount() {
                return this.scheduler.getFailureCount();
            }
        },
        {
            key: "scheduleCallback",
            value: function scheduleCallback(done) {
                return (0, _asyncToGenerator._)(function() {
                    var result, error;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Even though we stopped the scheduler, it can be restarted with a call to schedule.
                                // This could be triggered by a new event or the longPollingScheduler
                                if (this.networkStatus.getNetworkStatus() === (0, _types.NetworkStatusEnum).OFFLINE) {
                                    done((0, _scheduler.DoneState).NOOP);
                                    return [
                                        2
                                    ];
                                }
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    4,
                                    6
                                ]);
                                return [
                                    4,
                                    this.resilience.processItems(this.flush.bind(this), this.options.batchFlushSize)
                                ];
                            case 2:
                                result = _state.sent();
                                done(result);
                                return [
                                    3,
                                    6
                                ];
                            case 3:
                                error = _state.sent();
                                if (error.name === (0, _resiliencedb.CallbackProcessingErrorName)) {
                                    done((0, _scheduler.DoneState).ERROR);
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    3,
                                    6
                                ];
                            case 4:
                                return [
                                    4,
                                    this.checkEventCountAndReschedule()
                                ];
                            case 5:
                                _state.sent();
                                return [
                                    7
                                ];
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "checkEventCountAndReschedule",
            value: function checkEventCountAndReschedule() {
                return (0, _asyncToGenerator._)(function() {
                    var eventWaitingCount;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.resilience.getItemCount()
                                ];
                            case 1:
                                eventWaitingCount = _state.sent();
                                if (eventWaitingCount > 0) this.scheduler.schedule({
                                    immediate: eventWaitingCount >= this.options.batchFlushSize
                                });
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "scheduleLongCallBack",
            value: function scheduleLongCallBack(done) {
                return (0, _asyncToGenerator._)(function() {
                    var _this, numberOfQueuesPurged, reclaimMetrics;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                // Eventually we will want to send data about how many queues were purged
                                numberOfQueuesPurged = (0, _localstorageRetry.purgeOrphanedQueues)(this.queuePrefix);
                                this.metricsCollector.addToPurgedQueuesMetrics(numberOfQueuesPurged);
                                return [
                                    4,
                                    (0, _localstorageRetry.reclaimEvents)(this.queuePrefix, function(localStorageItems) {
                                        return (0, _asyncToGenerator._)(function() {
                                            var itemsToAdd, _ref, addedEvents;
                                            return (0, _tsGenerator._)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        itemsToAdd = localStorageItems.map(function(localStorageItem) {
                                                            return {
                                                                item: localStorageItem.item,
                                                                retryAttempts: localStorageItem.attemptNumber,
                                                                id: localStorageItem.id
                                                            };
                                                        });
                                                        return [
                                                            4,
                                                            this.resilience.bulkAddItem(itemsToAdd, (0, _resiliencedb.GuardPolicy).IGNORE)
                                                        ];
                                                    case 1:
                                                        _ref = _state.sent(), addedEvents = _ref.items;
                                                        if (addedEvents.length === itemsToAdd.length) return [
                                                            2,
                                                            {
                                                                status: 'successful'
                                                            }
                                                        ];
                                                        else return [
                                                            2,
                                                            {
                                                                status: 'partial',
                                                                acceptedItemIds: addedEvents.map(function(event) {
                                                                    return event.id;
                                                                })
                                                            }
                                                        ];
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        }).call(_this);
                                    })
                                ];
                            case 1:
                                reclaimMetrics = _state.sent();
                                this.metricsCollector.addToReclaimMetrics(reclaimMetrics);
                                // We dont want to flush events from here as there maybe issues with analytics-service
                                // Scheduler has all the context and can schedule the next batch accordingly
                                return [
                                    4,
                                    this.checkEventCountAndReschedule()
                                ];
                            case 2:
                                _state.sent();
                                done((0, _scheduler.DoneState).SUCCESS);
                                this.longPollingScheduler.schedule();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "flush",
            value: function flush(wrappedItems, otherMetadata) {
                var _this = this;
                this.metricsCollector.setResilienceMechanism(this.resilience.storeType());
                var batchFlushCallback = this.batchFlushCallback;
                if (!batchFlushCallback) throw new Error('batchFlushCallback has not been set. Call PullBatchableQueue#start first.');
                return new Promise(function(resolve, reject) {
                    if (wrappedItems.length <= 0) {
                        resolve((0, _scheduler.DoneState).NOOP);
                        return;
                    }
                    var items = wrappedItems.map(function(wrappedItem) {
                        var item = wrappedItem.item;
                        if (wrappedItem.retryAttempts > 0 && item.msg) {
                            if (!item.msg._metadata) item.msg._metadata = {};
                            item.msg._metadata.failedAttempts = wrappedItem.retryAttempts;
                        }
                        return item;
                    });
                    batchFlushCallback(items, function(error) {
                        if (error) {
                            if (otherMetadata.numberOfDeletedItems > 0) _this.metricsCollector.addToItemsDiscardedByRetryCounter(otherMetadata.numberOfDeletedItems);
                            reject(error);
                        } else resolve((0, _scheduler.DoneState).SUCCESS);
                    });
                });
            }
        },
        {
            key: "buildOptions",
            value: function buildOptions(options) {
                return {
                    backoffFactor: (options === null || options === void 0 ? void 0 : options.backoffFactor) || DEFAULT_POLLING_OPTIONS.backoffFactor,
                    backoffJitterPercentage: (options === null || options === void 0 ? void 0 : options.backoffJitterPercentage) !== undefined ? options.backoffJitterPercentage : DEFAULT_POLLING_OPTIONS.backoffJitterPercentage,
                    batchFlushSize: (options === null || options === void 0 ? void 0 : options.batchFlushSize) || DEFAULT_POLLING_OPTIONS.batchFlushSize,
                    flushBeforeUnload: (options === null || options === void 0 ? void 0 : options.flushBeforeUnload) || DEFAULT_POLLING_OPTIONS.flushBeforeUnload,
                    flushWaitMs: (options === null || options === void 0 ? void 0 : options.flushWaitMs) || DEFAULT_POLLING_OPTIONS.flushWaitMs,
                    maxQueueSize: (options === null || options === void 0 ? void 0 : options.maxQueueSize) || DEFAULT_POLLING_OPTIONS.maxQueueSize,
                    maxAttempts: (options === null || options === void 0 ? void 0 : options.maxAttempts) || DEFAULT_POLLING_OPTIONS.maxAttempts,
                    maxRetryDelay: (options === null || options === void 0 ? void 0 : options.maxRetryDelay) || DEFAULT_POLLING_OPTIONS.maxRetryDelay,
                    minRetryDelay: (options === null || options === void 0 ? void 0 : options.minRetryDelay) || DEFAULT_POLLING_OPTIONS.minRetryDelay
                };
            }
        }
    ]);
    return PullBatchableQueue;
}();

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_ts_generator":"78Tqx","../localstorage-retry":"3Nn0D","../resiliencedb":"lHsuJ","./Metrics":"al9gp","./NetworkStatus":"5TM92","./scheduler":"3kKmD","./types":"g24Es","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3Nn0D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reclaimEvents", function() {
    return 0, _reclaimEventsDefault.default;
});
parcelHelpers.export(exports, "purgeOrphanedQueues", function() {
    return 0, _purgeOrphanedQueuesDefault.default;
});
var _reclaimEvents = require("./reclaimEvents");
var _reclaimEventsDefault = parcelHelpers.interopDefault(_reclaimEvents);
var _purgeOrphanedQueues = require("./purgeOrphanedQueues");
var _purgeOrphanedQueuesDefault = parcelHelpers.interopDefault(_purgeOrphanedQueues);

},{"./reclaimEvents":"9byAy","./purgeOrphanedQueues":"5qzoi","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9byAy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _uuid = require("../uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
var _types = require("./types");
var _utils = require("./utils");
var promisedSetTimeout = function(msToWait) {
    return new Promise(function(resolve) {
        setTimeout(resolve, msToWait);
    });
};
var findOtherQueues = function(queuePrefix) {
    try {
        return Object.keys(localStorage).filter(function(key) {
            return key.startsWith(queuePrefix);
        }).map(function(key) {
            return key.split('.');
        }).filter(function(split) {
            if (split.length === 3 && split[0] === queuePrefix && split[2] === (0, _types.LocalStorageKeySuffix).ACK) try {
                var ackTimestamp = localStorage.getItem(split.join('.'));
                if (ackTimestamp) {
                    var ackTimestampNumber = parseInt(ackTimestamp);
                    return (0, _types.Timers).RECLAIM_TIMEOUT + ackTimestampNumber < Date.now();
                }
            } catch (e) {
            // ignore and drop value
            }
            return false;
        }).map(function(split) {
            return split[1];
        });
    } catch (e) {
    // Ignore errors from accessing localStorage.
    }
    return [];
};
var tryReclaim = function(options, callback) {
    return (0, _asyncToGenerator._)(function() {
        var _options_storageKeys, ack, reclaimStart, reclaimEnd, start;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _options_storageKeys = options.storageKeys, ack = _options_storageKeys.ack, reclaimStart = _options_storageKeys.reclaimStart, reclaimEnd = _options_storageKeys.reclaimEnd;
                    start = Date.now();
                    localStorage.setItem(reclaimStart, options.reclaimProcessId);
                    localStorage.setItem(ack, start.toString());
                    return [
                        4,
                        promisedSetTimeout((0, _types.Timers).RECLAIM_WAIT)
                    ];
                case 1:
                    _state.sent();
                    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
                    Date.now() > start + (0, _types.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
                    localStorage.getItem(reclaimStart) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimStart.');
                    localStorage.setItem(reclaimEnd, options.reclaimProcessId);
                    return [
                        4,
                        promisedSetTimeout((0, _types.Timers).RECLAIM_WAIT)
                    ];
                case 2:
                    _state.sent();
                    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
                    Date.now() > start + (0, _types.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
                    localStorage.getItem(reclaimStart) !== options.reclaimProcessId || localStorage.getItem(reclaimEnd) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimEnd.');
                    return [
                        2,
                        reclaim(options, callback)
                    ];
            }
        });
    })();
};
var reclaim = function(options, callback) {
    return (0, _asyncToGenerator._)(function() {
        var _options_storageKeys, queue, inProgress, eventsInQueue, eventsInProgress, arrayOfEventsInProgress, eventsToProcess, result, leftover;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _options_storageKeys = options.storageKeys, queue = _options_storageKeys.queue, inProgress = _options_storageKeys.inProgress;
                    // Queue is an array of events while inProgress is an object with a uuid for key
                    // Either of these queues may legitimately be missing.
                    eventsInQueue = JSON.parse(localStorage.getItem(queue) || '[]');
                    eventsInProgress = JSON.parse(localStorage.getItem(inProgress) || '{}');
                    arrayOfEventsInProgress = Object.entries(eventsInProgress).map(function(param) {
                        var _param = (0, _slicedToArray._)(param, 2), key = _param[0], item = _param[1];
                        var itemWithId = (0, _objectSpreadProps._)((0, _objectSpread._)({}, item), {
                            // LocalStorage-retry would add the attemptCounter after failure, rather than
                            // as it was being processed
                            attemptNumber: item.attemptNumber + 1,
                            id: key
                        });
                        return itemWithId;
                    });
                    eventsToProcess = (0, _toConsumableArray._)(eventsInQueue).concat((0, _toConsumableArray._)(arrayOfEventsInProgress));
                    if (!(eventsToProcess.length > 0)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        callback(eventsToProcess)
                    ];
                case 1:
                    result = _state.sent();
                    if (result.status === 'successful') clearLocalStorageKeys(options.storageKeys);
                    else if (result.status === 'partial') {
                        // Dont delete all events if we are only able to take some of them.
                        leftover = eventsToProcess.filter(function(event) {
                            return !result.acceptedItemIds.includes(event.id);
                        });
                        // This way around, we can almost ensure that we wont hit memory quota exceeded errors.
                        // However, there is a very small chance that we may lose events if the process exits between these two commands.
                        localStorage.removeItem(inProgress);
                        localStorage.setItem(queue, JSON.stringify(leftover));
                        return [
                            2,
                            {
                                fullReclaim: false
                            }
                        ];
                    }
                    return [
                        3,
                        3
                    ];
                case 2:
                    clearLocalStorageKeys(options.storageKeys);
                    _state.label = 3;
                case 3:
                    return [
                        2,
                        {
                            fullReclaim: true
                        }
                    ];
            }
        });
    })();
};
// Exterminate
var clearLocalStorageKeys = function(keys) {
    // Always good to do queue and inprogress first to reduce duplications
    // and to free up more space in localstorage
    localStorage.removeItem(keys.queue);
    localStorage.removeItem(keys.inProgress);
    localStorage.removeItem(keys.reclaimEnd);
    localStorage.removeItem(keys.reclaimStart);
    // This has to be last or we risk leaving things in localStorage that have to be purged
    localStorage.removeItem(keys.ack);
};
exports.default = function(queuePrefix, callback) {
    return (0, _asyncToGenerator._)(function() {
        var reclaimProcessId, queuesToReclaim, claims, settledClaims, failedReclaims, successfulClaims, fullReclaims, partialReclaims;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof queuePrefix !== 'string' || queuePrefix.length === 0) // We do not want to start deleting everything in localstorage
                    return [
                        2,
                        {
                            fullReclaims: 0,
                            partialReclaims: 0,
                            failedReclaims: 0
                        }
                    ];
                    reclaimProcessId = (0, _uuidDefault.default)();
                    queuesToReclaim = findOtherQueues(queuePrefix);
                    claims = queuesToReclaim.map(function(id) {
                        return tryReclaim({
                            queuePrefix: queuePrefix,
                            reclaimProcessId: reclaimProcessId,
                            storageKeys: (0, _utils.createLocalStorageKeys)(queuePrefix, id)
                        }, callback);
                    });
                    return [
                        4,
                        Promise.allSettled(claims)
                    ];
                case 1:
                    settledClaims = _state.sent();
                    failedReclaims = settledClaims.filter(function(claim) {
                        return claim.status === 'rejected';
                    });
                    successfulClaims = settledClaims.filter(function(settledValue) {
                        return settledValue.status === 'fulfilled';
                    }).map(function(result) {
                        return result.value;
                    });
                    fullReclaims = successfulClaims.filter(function(claim) {
                        return claim.fullReclaim;
                    });
                    partialReclaims = successfulClaims.filter(function(claim) {
                        return !claim.fullReclaim;
                    });
                    return [
                        2,
                        {
                            failedReclaims: failedReclaims.length,
                            partialReclaims: partialReclaims.length,
                            fullReclaims: fullReclaims.length
                        }
                    ];
            }
        });
    })();
};

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_to_consumable_array":"1eSZf","@swc/helpers/_/_ts_generator":"78Tqx","../uuid":"gL2xH","./types":"kBtM8","./utils":"jrGy7","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gL2xH":[function(require,module,exports,__globalThis) {
// UUID v4 generator with fallback for non-secure contexts
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return uuid;
});
function uuid() {
    var g = globalThis;
    try {
        if (g.crypto && typeof g.crypto.randomUUID === 'function') return g.crypto.randomUUID();
    } catch (e) {
    // ignore and fallback
    }
    // Fallback to Math.random-based v4 UUID
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.floor(Math.random() * 16);
        var v = c === 'x' ? r : r & 0x3 | 0x8; // x => random hex digit; y => set RFC 4122 variant bits (10xx), yielding 8, 9, a, or b
        return v.toString(16);
    });
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kBtM8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocalStorageKeySuffix", function() {
    return LocalStorageKeySuffix;
});
parcelHelpers.export(exports, "Timers", function() {
    return Timers;
});
var LocalStorageKeySuffix = /*#__PURE__*/ function(LocalStorageKeySuffix) {
    LocalStorageKeySuffix["IN_PROGRESS"] = "inProgress";
    LocalStorageKeySuffix["QUEUE"] = "queue";
    LocalStorageKeySuffix["RECLAIM_START"] = "reclaimStart";
    LocalStorageKeySuffix["RECLAIM_END"] = "reclaimEnd";
    LocalStorageKeySuffix["ACK"] = "ack";
    return LocalStorageKeySuffix;
}({});
var Timers = /*#__PURE__*/ function(Timers) {
    Timers[Timers["RECLAIM_TIMEOUT"] = 10000] = "RECLAIM_TIMEOUT";
    Timers[Timers["RECLAIM_WAIT"] = 500] = "RECLAIM_WAIT";
    Timers[Timers["RECLAIM_WAIT_THRESHOLD"] = 2000] = "RECLAIM_WAIT_THRESHOLD";
    return Timers;
}({});

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jrGy7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createLocalStorageKeys", function() {
    return createLocalStorageKeys;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _types = require("./types");
var createLocalStorageKeys = function(queuePrefix, queueId) {
    var _obj;
    return _obj = {}, (0, _defineProperty._)(_obj, (0, _types.LocalStorageKeySuffix).ACK, "".concat(queuePrefix, ".").concat(queueId, ".").concat((0, _types.LocalStorageKeySuffix).ACK)), (0, _defineProperty._)(_obj, (0, _types.LocalStorageKeySuffix).QUEUE, "".concat(queuePrefix, ".").concat(queueId, ".").concat((0, _types.LocalStorageKeySuffix).QUEUE)), (0, _defineProperty._)(_obj, (0, _types.LocalStorageKeySuffix).IN_PROGRESS, "".concat(queuePrefix, ".").concat(queueId, ".").concat((0, _types.LocalStorageKeySuffix).IN_PROGRESS)), (0, _defineProperty._)(_obj, (0, _types.LocalStorageKeySuffix).RECLAIM_START, "".concat(queuePrefix, ".").concat(queueId, ".").concat((0, _types.LocalStorageKeySuffix).RECLAIM_START)), (0, _defineProperty._)(_obj, (0, _types.LocalStorageKeySuffix).RECLAIM_END, "".concat(queuePrefix, ".").concat(queueId, ".").concat((0, _types.LocalStorageKeySuffix).RECLAIM_END)), _obj;
};

},{"@swc/helpers/_/_define_property":"e80IS","./types":"kBtM8","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5qzoi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _types = require("./types");
var _utils = require("./utils");
// For more details on this funciton, see https://hello.atlassian.net/wiki/spaces/MEASURE/pages/585086028/Investigation+Local+storage+full
// TL;DR
// If a queue looses its `ack` key in localstorage, it will never get claimed.
// There is a small chance that this can happen.
// This function is to run through queues and clean any that have been orphaned.
// Keys stolen from https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L55
var validSuffixs = Object.values((0, _types.LocalStorageKeySuffix));
exports.default = function(prefix) {
    if (typeof prefix !== 'string' || prefix.length === 0) // We do not want to start deleting everything in localstorage
    return 0;
    try {
        var queueStates = Object.keys(localStorage).filter(function(key) {
            return key && key.startsWith("".concat(prefix, ".")) || false;
        }).map(function(key) {
            return key.split('.');
        }).filter(function(splitKeys) {
            return splitKeys.length === 3 && validSuffixs.includes(splitKeys[2]);
        }).reduce(function(accumulator, currentKeys) {
            var _currentKeys = (0, _slicedToArray._)(currentKeys, 3), id = _currentKeys[1], suffix = _currentKeys[2];
            if (accumulator[id] === undefined) accumulator[id] = {};
            accumulator[id][suffix] = true;
            return accumulator;
        }, {});
        var queuesToPurge = Object.keys(queueStates).filter(function(id) {
            return queueStates[id][(0, _types.LocalStorageKeySuffix).ACK] !== true;
        });
        queuesToPurge.forEach(function(id) {
            var _createLocalStorageKeys = (0, _utils.createLocalStorageKeys)(prefix, id), queue = _createLocalStorageKeys.queue, inProgress = _createLocalStorageKeys.inProgress, reclaimStart = _createLocalStorageKeys.reclaimStart, reclaimEnd = _createLocalStorageKeys.reclaimEnd;
            localStorage.removeItem(inProgress);
            localStorage.removeItem(queue);
            localStorage.removeItem(reclaimStart);
            localStorage.removeItem(reclaimEnd);
        });
        return queuesToPurge.length;
    } catch (_error) {
    // Ignore errors from localStorage.
    }
    return 0;
};

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","./types":"kBtM8","./utils":"jrGy7","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lHsuJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GuardPolicy", function() {
    return 0, _constants.GuardPolicy;
});
parcelHelpers.export(exports, "StoreType", function() {
    return 0, _constants.StoreType;
});
parcelHelpers.export(exports, "CallbackProcessingErrorName", function() {
    return 0, _errors.CallbackProcessingErrorName;
});
var _dbDelegator = require("./DbDelegator");
var _dbDelegatorDefault = parcelHelpers.interopDefault(_dbDelegator);
var _constants = require("./constants");
var _errors = require("./errors");
exports.default = (0, _dbDelegatorDefault.default);

},{"./DbDelegator":"cvtIN","./constants":"kwkNw","./errors":"iNyLx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cvtIN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return DbDelegator;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _constants = require("./constants");
var _errors = require("./errors");
var _indexedDbConnector = require("./IndexedDbConnector");
var _indexedDbConnectorDefault = parcelHelpers.interopDefault(_indexedDbConnector);
var _memoryDb = require("./MemoryDb");
var _memoryDbDefault = parcelHelpers.interopDefault(_memoryDb);
var _util = require("./util");
var DbDelegator = /*#__PURE__*/ function() {
    "use strict";
    function DbDelegator(namespace) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, _classCallCheck._)(this, DbDelegator);
        this.namespace = namespace;
        this.options = (0, _util.createOptionsWithDefaults)(options);
        if (!namespace || namespace.length === 0 || typeof namespace !== 'string') throw new Error('Invalid namespace provided');
        this.resilience = this.getResilienceMechanism(namespace, options);
    }
    (0, _createClass._)(DbDelegator, [
        {
            key: "getResilienceMechanism",
            value: function getResilienceMechanism(namespace, options) {
                if (!options.useMemory) try {
                    return new (0, _indexedDbConnectorDefault.default)(namespace, options);
                } catch (error) {
                    var _options_logger;
                    if (!(0, _instanceof._)(error, (0, _errors.NoIndexedDbError))) (_options_logger = options.logger) === null || _options_logger === void 0 ? void 0 : _options_logger.warn('Attempted to create IndexedDbResilience but failed. Using memory instead.');
                }
                return new (0, _memoryDbDefault.default)(this.namespace, options);
            }
        },
        {
            key: "addItem",
            value: function addItem(item, options) {
                var _this = this;
                var policy = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, _constants.GuardPolicy).ABANDON;
                return this.runOrFailOver(function() {
                    return _this.resilience.addItem(item, options, policy);
                });
            }
        },
        {
            key: "bulkAddItem",
            value: function bulkAddItem(itemOptions) {
                var _this = this;
                var policy = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, _constants.GuardPolicy).ABANDON;
                return this.runOrFailOver(function() {
                    return _this.resilience.bulkAddItem(itemOptions, policy);
                });
            }
        },
        {
            key: "getItems",
            value: function getItems(count) {
                var _this = this;
                return this.runOrFailOver(function() {
                    return _this.resilience.getItems(count);
                });
            }
        },
        {
            key: "deleteItems",
            value: function deleteItems(itemIds) {
                var _this = this;
                return this.runOrFailOver(function() {
                    return _this.resilience.deleteItems(itemIds);
                });
            }
        },
        {
            key: "getItemCount",
            value: function getItemCount() {
                var _this = this;
                return this.runOrFailOver(function() {
                    return _this.resilience.getItemCount();
                });
            }
        },
        {
            key: "processItems",
            value: function processItems(processFn, count) {
                var _this = this;
                return this.runOrFailOver(function() {
                    return _this.resilience.processItems(processFn, count);
                });
            }
        },
        {
            key: "storeType",
            value: function storeType() {
                return this.resilience.storeType();
            }
        },
        {
            key: "runOrFailOver",
            value: function runOrFailOver(runnable) {
                return (0, _asyncToGenerator._)(function() {
                    var error;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    6
                                ]);
                                return [
                                    4,
                                    runnable()
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                error = _state.sent();
                                if (!(0, _errors.shouldIgnoreResilienceDbError)(error)) return [
                                    3,
                                    3
                                ];
                                throw error;
                            case 3:
                                if (!(this.resilience.storeType() === (0, _constants.StoreType).INDEXEDDB)) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    this.failOver()
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                return [
                                    2,
                                    runnable()
                                ];
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "failOver",
            value: function failOver() {
                return (0, _asyncToGenerator._)(function() {
                    var oldResilience, newResilience, items, bulkAddItemsResponse, addedItemIds, error;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Attempt to get any events we can and put them into memory
                                oldResilience = this.resilience;
                                newResilience = new (0, _memoryDbDefault.default)(this.namespace, this.options);
                                this.resilience = newResilience;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    ,
                                    7
                                ]);
                                return [
                                    4,
                                    oldResilience.getItems(this.options.maxEventLimit)
                                ];
                            case 2:
                                items = _state.sent().items;
                                if (!(items.length > 0)) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    newResilience.bulkAddItemWrapperType(items, (0, _constants.GuardPolicy).IGNORE)
                                ];
                            case 3:
                                bulkAddItemsResponse = _state.sent();
                                addedItemIds = bulkAddItemsResponse.items.map(function(item) {
                                    return item.id;
                                });
                                return [
                                    4,
                                    oldResilience.deleteItems(addedItemIds)
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                error = _state.sent();
                                this.options.logger.warn('Unexpected error from ResilienceDb, switching to MemoryDb');
                                return [
                                    3,
                                    7
                                ];
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return DbDelegator;
}();

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_ts_generator":"78Tqx","./constants":"kwkNw","./errors":"iNyLx","./IndexedDbConnector":"6flO2","./MemoryDb":"2MT2U","./util":"j9P90","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kwkNw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NAMESPACE_AND_TIME_ADDED_INDEX", function() {
    return NAMESPACE_AND_TIME_ADDED_INDEX;
});
parcelHelpers.export(exports, "RESILIENCE_DB_NAME", function() {
    return RESILIENCE_DB_NAME;
});
parcelHelpers.export(exports, "RESILIENCE_STORE_NAME", function() {
    return RESILIENCE_STORE_NAME;
});
parcelHelpers.export(exports, "TIME_TO_PROCESS_AFTER_INDEX", function() {
    return TIME_TO_PROCESS_AFTER_INDEX;
});
parcelHelpers.export(exports, "TIME_ADDED_INDEX", function() {
    return TIME_ADDED_INDEX;
});
parcelHelpers.export(exports, "RETRY_INDEX", function() {
    return RETRY_INDEX;
});
parcelHelpers.export(exports, "INDEXEDDB_TIMEOUT", function() {
    return INDEXEDDB_TIMEOUT;
});
parcelHelpers.export(exports, "StoreType", function() {
    return StoreType;
});
parcelHelpers.export(exports, "GuardPolicy", function() {
    return GuardPolicy;
});
var NAMESPACE_AND_TIME_ADDED_INDEX = 'namespace-timeAdded';
var RESILIENCE_DB_NAME = 'analytics-web-client';
var RESILIENCE_STORE_NAME = 'analytics-resilience';
var TIME_TO_PROCESS_AFTER_INDEX = 'timeToBeProcessedAfter';
var TIME_ADDED_INDEX = 'timeAdded';
var RETRY_INDEX = 'retryAttempts';
var INDEXEDDB_TIMEOUT = 15000;
var StoreType = /*#__PURE__*/ function(StoreType) {
    StoreType["INDEXEDDB"] = "indexeddb";
    StoreType["MEMORY"] = "memory";
    return StoreType;
}({});
var GuardPolicy = /*#__PURE__*/ function(GuardPolicy) {
    // Adds as many items as possible and IGONRES the rest.
    // Only to be used with BulkAdd
    GuardPolicy["IGNORE"] = "ignore";
    // ABANDON the request if not all items can be added.
    GuardPolicy["ABANDON"] = "abandon";
    // EVICT old items to make room for new items if space is tight.
    GuardPolicy["EVICT"] = "evict";
    return GuardPolicy;
}({});

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iNyLx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbandonWriteError", function() {
    return 0, _abandonWriteErrorDefault.default;
});
parcelHelpers.export(exports, "AbandonWriteErrorName", function() {
    return 0, _abandonWriteError.AbandonWriteErrorName;
});
parcelHelpers.export(exports, "CallbackProcessingError", function() {
    return 0, _callbackProcessingErrorDefault.default;
});
parcelHelpers.export(exports, "CallbackProcessingErrorName", function() {
    return 0, _callbackProcessingError.CallbackProcessingErrorName;
});
parcelHelpers.export(exports, "InvalidPolicyError", function() {
    return 0, _invalidPolicyErrorDefault.default;
});
parcelHelpers.export(exports, "InvalidPolicyErrorName", function() {
    return 0, _invalidPolicyError.InvalidPolicyErrorName;
});
parcelHelpers.export(exports, "NoIndexedDbError", function() {
    return 0, _noIndexedDbErrorDefault.default;
});
parcelHelpers.export(exports, "NoIndexedDbErrorName", function() {
    return 0, _noIndexedDbError.NoIndexedDbErrorName;
});
parcelHelpers.export(exports, "shouldIgnoreResilienceDbError", function() {
    return 0, _util.shouldIgnoreResilienceDbError;
});
var _abandonWriteError = require("./AbandonWriteError");
var _abandonWriteErrorDefault = parcelHelpers.interopDefault(_abandonWriteError);
var _callbackProcessingError = require("./CallbackProcessingError");
var _callbackProcessingErrorDefault = parcelHelpers.interopDefault(_callbackProcessingError);
var _invalidPolicyError = require("./InvalidPolicyError");
var _invalidPolicyErrorDefault = parcelHelpers.interopDefault(_invalidPolicyError);
var _noIndexedDbError = require("./NoIndexedDbError");
var _noIndexedDbErrorDefault = parcelHelpers.interopDefault(_noIndexedDbError);
var _util = require("./util");

},{"./AbandonWriteError":"bbfB5","./CallbackProcessingError":"dZi0T","./InvalidPolicyError":"5khxT","./NoIndexedDbError":"iPNAc","./util":"4jSAM","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bbfB5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbandonWriteErrorName", function() {
    return AbandonWriteErrorName;
});
parcelHelpers.export(exports, "default", function() {
    return AbandonWriteError;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _inherits = require("@swc/helpers/_/_inherits");
var _wrapNativeSuper = require("@swc/helpers/_/_wrap_native_super");
var AbandonWriteErrorName = 'AbandonWriteError';
var AbandonWriteError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, _inherits._)(AbandonWriteError, Error1);
    function AbandonWriteError(source) {
        (0, _classCallCheck._)(this, AbandonWriteError);
        var _this;
        _this = (0, _callSuper._)(this, AbandonWriteError, [
            "Event Limit reached. Abandoning write to: ".concat(source)
        ]);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(_this, AbandonWriteError.prototype);
        _this.name = AbandonWriteErrorName;
        return _this;
    }
    return AbandonWriteError;
}((0, _wrapNativeSuper._)(Error));

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_inherits":"2sfqW","@swc/helpers/_/_wrap_native_super":"d0Iin","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dZi0T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CallbackProcessingErrorName", function() {
    return CallbackProcessingErrorName;
});
parcelHelpers.export(exports, "default", function() {
    return CallbackProcessingError;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _inherits = require("@swc/helpers/_/_inherits");
var _typeOf = require("@swc/helpers/_/_type_of");
var _wrapNativeSuper = require("@swc/helpers/_/_wrap_native_super");
var CallbackProcessingErrorName = 'CallbackProcessingError';
var CallbackProcessingError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, _inherits._)(CallbackProcessingError, Error1);
    function CallbackProcessingError(error) {
        (0, _classCallCheck._)(this, CallbackProcessingError);
        var _this;
        var messageFromError = error && (typeof error === "undefined" ? "undefined" : (0, _typeOf._)(error)) === 'object' && 'toString' in error && typeof error.toString === 'function' && error.toString();
        var messageFromString = typeof error === 'string' && error;
        var message = messageFromError || messageFromString || 'Argument passed to CallbackProcessingError was not an Error or string.';
        _this = (0, _callSuper._)(this, CallbackProcessingError, [
            "Error thrown while processing events in callback: ".concat(message)
        ]);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(_this, CallbackProcessingError.prototype);
        _this.name = CallbackProcessingErrorName;
        return _this;
    }
    return CallbackProcessingError;
}((0, _wrapNativeSuper._)(Error));

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_inherits":"2sfqW","@swc/helpers/_/_type_of":"iFJdx","@swc/helpers/_/_wrap_native_super":"d0Iin","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5khxT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InvalidPolicyErrorName", function() {
    return InvalidPolicyErrorName;
});
parcelHelpers.export(exports, "default", function() {
    return InvalidPolicyError;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _inherits = require("@swc/helpers/_/_inherits");
var _wrapNativeSuper = require("@swc/helpers/_/_wrap_native_super");
var InvalidPolicyErrorName = 'InvalidPolicyError';
var InvalidPolicyError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, _inherits._)(InvalidPolicyError, Error1);
    function InvalidPolicyError(policy, method) {
        (0, _classCallCheck._)(this, InvalidPolicyError);
        var _this;
        _this = (0, _callSuper._)(this, InvalidPolicyError, [
            "Method '".concat(method, "' cannot be called with policy '").concat(policy, "'.")
        ]);
        _this.name = InvalidPolicyErrorName;
        return _this;
    }
    return InvalidPolicyError;
}((0, _wrapNativeSuper._)(Error));

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_inherits":"2sfqW","@swc/helpers/_/_wrap_native_super":"d0Iin","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iPNAc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NoIndexedDbErrorName", function() {
    return NoIndexedDbErrorName;
});
/*
 Only to be used with window.indexeddb is undefined.
 This will prevent DbDelegator from logging errors, but will not prevent swapping to memoryDB
*/ parcelHelpers.export(exports, "default", function() {
    return NoIndexedDbError;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _inherits = require("@swc/helpers/_/_inherits");
var _wrapNativeSuper = require("@swc/helpers/_/_wrap_native_super");
var NoIndexedDbErrorName = 'NoIndexedDbError';
var NoIndexedDbError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, _inherits._)(NoIndexedDbError, Error1);
    function NoIndexedDbError() {
        (0, _classCallCheck._)(this, NoIndexedDbError);
        var _this;
        _this = (0, _callSuper._)(this, NoIndexedDbError, [
            'window.indexeddb is undefined.'
        ]);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(_this, NoIndexedDbError.prototype);
        _this.name = NoIndexedDbErrorName;
        return _this;
    }
    return NoIndexedDbError;
}((0, _wrapNativeSuper._)(Error));

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_inherits":"2sfqW","@swc/helpers/_/_wrap_native_super":"d0Iin","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4jSAM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shouldIgnoreResilienceDbError", function() {
    return shouldIgnoreResilienceDbError;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _abandonWriteError = require("./AbandonWriteError");
var _callbackProcessingError = require("./CallbackProcessingError");
var _invalidPolicyError = require("./InvalidPolicyError");
var shouldIgnoreResilienceDbError = function(error) {
    if (error && (typeof error === "undefined" ? "undefined" : (0, _typeOf._)(error)) === 'object' && 'name' in error) {
        var errorWithName = error;
        return typeof errorWithName.name === 'string' && (errorWithName.name === (0, _abandonWriteError.AbandonWriteErrorName) || errorWithName.name === (0, _callbackProcessingError.CallbackProcessingErrorName) || errorWithName.name === (0, _invalidPolicyError.InvalidPolicyErrorName));
    }
    return false;
};

},{"@swc/helpers/_/_type_of":"iFJdx","./AbandonWriteError":"bbfB5","./CallbackProcessingError":"dZi0T","./InvalidPolicyError":"5khxT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6flO2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * We have rolled our own client for IndexedDb as many Indexeddb libraries are
 * not flexible enough for our use case of:
 * 1. Adding specific indexes for time,
 * 2. Getting items on a specific index,
 * 3. Updating a field on an event while getting the event inside of a single ACID compliant transaction.
 */ parcelHelpers.export(exports, "default", function() {
    return IndexedDbConnector;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _constants = require("./constants");
var _defaults = require("./defaults");
var _errors = require("./errors");
var _indexedDbEventCountGuard = require("./IndexedDbEventCountGuard");
var _indexedDbEventCountGuardDefault = parcelHelpers.interopDefault(_indexedDbEventCountGuard);
var _util = require("./util");
var IndexedDbConnector = /*#__PURE__*/ function() {
    "use strict";
    function IndexedDbConnector(namespace) {
        var _this = this;
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var _this1 = this;
        (0, _classCallCheck._)(this, IndexedDbConnector);
        this.startDB = function() {
            return (0, _asyncToGenerator._)(function() {
                var _this;
                return (0, _tsGenerator._)(this, function(_state) {
                    _this = this;
                    return [
                        2,
                        new Promise(function(resolve, reject) {
                            return (0, _asyncToGenerator._)(function() {
                                var _this, dbTimeout, request, error;
                                return (0, _tsGenerator._)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            _this = this;
                                            if (!(typeof window !== 'undefined')) return [
                                                3,
                                                6
                                            ];
                                            dbTimeout = window.setTimeout(function() {
                                                _this.logger.warn('IndexedDB timed out.');
                                                reject(new (0, _errors.NoIndexedDbError)());
                                            }, (0, _constants.INDEXEDDB_TIMEOUT));
                                            /*
				 * The database version number can never change.
				 * An upgrade transaction is limited to only one connection to the database.
				 * Once this is done, we cannot open any connections with older versions of the schema.
				 * https://www.w3.org/TR/IndexedDB/#upgrade-transaction-construct
				 *
				 * Due to the nature of how AWC is used (multiple tabs that are very long lived),
				 * we will not be able to run version upgrades via indexeddb.
				 *
				 * This does not mean we cant change what is stored in the tables,
				 * this limitation just prevents us from:
				 *   - Creating new ObjectStores in this database connection, and
				 *   - Creating new indexes on our ObjectStores
				 *
				 * Any upgrades we wish to run in the future will have to create a new database,
				 * and migrate all the data from older databases.
				 *
				 * This also means any migrations we make will have to be supported until we have evidence
				 * that no events are coming from old versions of the database.
				 * This may take a long time.
				 */ request = window.indexedDB.open((0, _constants.RESILIENCE_DB_NAME), 1);
                                            request.onupgradeneeded = function(event) {
                                                if (event.oldVersion !== 0) throw new Error('We cannot upgrade the database. Do not do this.');
                                                var db = request.result;
                                                var store = db.createObjectStore((0, _constants.RESILIENCE_STORE_NAME), {
                                                    keyPath: 'id'
                                                });
                                                store.createIndex((0, _constants.TIME_TO_PROCESS_AFTER_INDEX), (0, _constants.TIME_TO_PROCESS_AFTER_INDEX), {
                                                    unique: false
                                                });
                                                store.createIndex((0, _constants.RETRY_INDEX), (0, _constants.RETRY_INDEX), {
                                                    unique: false
                                                });
                                                store.createIndex((0, _constants.TIME_ADDED_INDEX), (0, _constants.TIME_ADDED_INDEX), {
                                                    unique: false
                                                });
                                                // Compound key index of product - timeAdded.
                                                store.createIndex((0, _constants.NAMESPACE_AND_TIME_ADDED_INDEX), [
                                                    'namespace',
                                                    'timeAdded'
                                                ], {
                                                    unique: false
                                                });
                                            };
                                            request.onerror = function() {
                                                reject(new (0, _errors.NoIndexedDbError)());
                                            };
                                            _state.label = 1;
                                        case 1:
                                            _state.trys.push([
                                                1,
                                                3,
                                                4,
                                                5
                                            ]);
                                            return [
                                                4,
                                                (0, _util.requestToPromise)(request)
                                            ];
                                        case 2:
                                            _state.sent();
                                            return [
                                                2,
                                                resolve(request.result)
                                            ];
                                        case 3:
                                            error = _state.sent();
                                            this.logger.warn('IndexedDB failed to initialise.', error);
                                            reject(new (0, _errors.NoIndexedDbError)());
                                            return [
                                                3,
                                                5
                                            ];
                                        case 4:
                                            window.clearTimeout(dbTimeout);
                                            return [
                                                7
                                            ];
                                        case 5:
                                            return [
                                                3,
                                                7
                                            ];
                                        case 6:
                                            this.logger.warn("IndexedDB failed to initialise. No 'window' object.");
                                            reject(new (0, _errors.NoIndexedDbError)());
                                            _state.label = 7;
                                        case 7:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            }).call(_this);
                        })
                    ];
                });
            }).call(_this);
        };
        this.addItem = function(item) {
            var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, policy = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, _constants.GuardPolicy).ABANDON;
            return (0, _asyncToGenerator._)(function() {
                var _this, logger, _$namespace, value, objectStore, bulkAddResult, error;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this = this, logger = _this.logger, _$namespace = _this.namespace;
                            value = (0, _util.convertToItemWrapper)(item, _$namespace, options);
                            return [
                                4,
                                this.getObjectStoreAndTransaction('readwrite')
                            ];
                        case 1:
                            objectStore = _state.sent().objectStore;
                            if (policy === (0, _constants.GuardPolicy).IGNORE) throw new (0, _errors.InvalidPolicyError)(policy, 'IndexedDbConnector#addItem');
                            _state.label = 2;
                        case 2:
                            _state.trys.push([
                                2,
                                4,
                                ,
                                5
                            ]);
                            if (!value.namespace || value.namespace.length === 0 || typeof value.namespace !== 'string') throw new Error('Namespace not specified');
                            return [
                                4,
                                this.globalEventLimitGuard.insertItems(objectStore, [
                                    value
                                ], policy)
                            ];
                        case 3:
                            bulkAddResult = _state.sent();
                            if (bulkAddResult.items.length === 1) return [
                                2,
                                {
                                    item: bulkAddResult.items[0],
                                    numberOfEvictedItems: bulkAddResult.numberOfEvictedItems
                                }
                            ];
                            // Should never happen as the Policy and EventCountGuard should cause another pathway
                            throw new Error("Incorrect number of items added. Expected: 1, got: ".concat(bulkAddResult.items.length));
                        case 4:
                            error = _state.sent();
                            if ((0, _errors.shouldIgnoreResilienceDbError)(error)) throw error;
                            logger.log('Failed to add item to table', error);
                            throw new Error('Request to add item to table failed');
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            }).call(_this1);
        };
        this.bulkAddItem = function(itemOptions) {
            var policy = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, _constants.GuardPolicy).ABANDON;
            return (0, _asyncToGenerator._)(function() {
                var _this, logger, _$namespace, items, objectStore, error;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this = this, logger = _this.logger, _$namespace = _this.namespace;
                            items = itemOptions.map(function(_param) {
                                var item = _param.item, options = (0, _objectWithoutProperties._)(_param, [
                                    "item"
                                ]);
                                return (0, _util.convertToItemWrapper)(item, _$namespace, options);
                            });
                            return [
                                4,
                                this.getObjectStoreAndTransaction('readwrite')
                            ];
                        case 1:
                            objectStore = _state.sent().objectStore;
                            _state.label = 2;
                        case 2:
                            _state.trys.push([
                                2,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4,
                                this.globalEventLimitGuard.insertItems(objectStore, items, policy)
                            ];
                        case 3:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 4:
                            error = _state.sent();
                            if ((0, _errors.shouldIgnoreResilienceDbError)(error)) throw error;
                            logger.log('Failed to add item to table', error);
                            throw new Error('Request to add item to table failed');
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            }).call(_this1);
        };
        this.getItems = function() {
            var count = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, _defaults.GET_ITEM_COUNT);
            return (0, _asyncToGenerator._)(function() {
                var fixedCount, logger, maxAttempts, _ref, transaction, objectStore, timeIndex, upperBoundOpenKeyRange, request, getResult;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            fixedCount = count > 0 ? count : (0, _defaults.GET_ITEM_COUNT);
                            logger = this.logger;
                            maxAttempts = this.options.maxAttempts;
                            return [
                                4,
                                this.getObjectStoreAndTransaction('readwrite')
                            ];
                        case 1:
                            _ref = _state.sent(), transaction = _ref.transaction, objectStore = _ref.objectStore;
                            timeIndex = objectStore.index((0, _constants.TIME_TO_PROCESS_AFTER_INDEX));
                            upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
                            request = timeIndex.openCursor(upperBoundOpenKeyRange);
                            return [
                                4,
                                new Promise(function(resolve, reject) {
                                    return (0, _asyncToGenerator._)(function() {
                                        var items, numberOfDeletedItems;
                                        return (0, _tsGenerator._)(this, function(_state) {
                                            items = [];
                                            numberOfDeletedItems = 0;
                                            request.onerror = function(error) {
                                                logger.error('Failed to open cursor:', error);
                                                reject('Failed to open cursor');
                                            };
                                            // Requests for Cursors call onsuccess multiple times and cannot be converted to promises
                                            request.onsuccess = function(event) {
                                                var cursor = event.target.result;
                                                if (cursor) {
                                                    // Prevent mutation of the value we are returning
                                                    var value = (0, _objectSpread._)({}, cursor.value);
                                                    items.push(value);
                                                    // Mutations seem to be required for testing indexeddb library
                                                    var updatedValue = cursor.value;
                                                    updatedValue.retryAttempts += 1;
                                                    updatedValue.timeToBeProcessedAfter = Date.now() + (0, _defaults.VISIBILITY_TIMEOUT);
                                                    if (updatedValue.retryAttempts >= maxAttempts) {
                                                        ++numberOfDeletedItems;
                                                        var request = cursor.delete();
                                                        (0, _util.monitorErrorsOnRequest)(request, logger);
                                                    } else {
                                                        var request1 = cursor.update(updatedValue);
                                                        (0, _util.monitorErrorsOnRequest)(request1, logger);
                                                    }
                                                    if (items.length < fixedCount) cursor.continue();
                                                    else resolve({
                                                        items: items,
                                                        numberOfDeletedItems: numberOfDeletedItems
                                                    });
                                                } else resolve({
                                                    items: items,
                                                    numberOfDeletedItems: numberOfDeletedItems
                                                });
                                            };
                                            return [
                                                2
                                            ];
                                        });
                                    })();
                                })
                            ];
                        case 2:
                            getResult = _state.sent();
                            return [
                                4,
                                (0, _util.commitTransaction)(transaction, this.logger)
                            ];
                        case 3:
                            _state.sent();
                            return [
                                2,
                                getResult
                            ];
                    }
                });
            }).call(_this1);
        };
        this.deleteItems = function(itemIds) {
            return (0, _asyncToGenerator._)(function() {
                var _this, _ref, transaction, objectStore, deletePromises, error;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this = this;
                            return [
                                4,
                                this.getObjectStoreAndTransaction('readwrite')
                            ];
                        case 1:
                            _ref = _state.sent(), transaction = _ref.transaction, objectStore = _ref.objectStore;
                            _state.label = 2;
                        case 2:
                            _state.trys.push([
                                2,
                                5,
                                ,
                                6
                            ]);
                            deletePromises = itemIds.map(function(id) {
                                return _this.deleteItem(objectStore, id);
                            });
                            return [
                                4,
                                (0, _util.commitTransaction)(transaction, this.logger)
                            ];
                        case 3:
                            _state.sent();
                            return [
                                4,
                                Promise.all(deletePromises)
                            ];
                        case 4:
                            _state.sent();
                            return [
                                3,
                                6
                            ];
                        case 5:
                            error = _state.sent();
                            this.logger.warn('Failed to delete items from indexeddb.', error);
                            throw error;
                        case 6:
                            return [
                                2
                            ];
                    }
                });
            }).call(_this);
        };
        this.getItemCount = function() {
            return (0, _asyncToGenerator._)(function() {
                var _ref, transaction, objectStore, timeIndex, upperBoundOpenKeyRange, request, event;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                this.getObjectStoreAndTransaction('readonly')
                            ];
                        case 1:
                            _ref = _state.sent(), transaction = _ref.transaction, objectStore = _ref.objectStore;
                            timeIndex = objectStore.index((0, _constants.TIME_TO_PROCESS_AFTER_INDEX));
                            upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
                            request = timeIndex.count(upperBoundOpenKeyRange);
                            return [
                                4,
                                (0, _util.requestToPromise)(request)
                            ];
                        case 2:
                            event = _state.sent();
                            return [
                                4,
                                (0, _util.commitTransaction)(transaction, this.logger)
                            ];
                        case 3:
                            _state.sent();
                            return [
                                2,
                                event.target.result
                            ];
                    }
                });
            }).call(_this);
        };
        this.processItems = function(processFn) {
            var count = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, _defaults.GET_ITEM_COUNT);
            return (0, _asyncToGenerator._)(function() {
                var _ref, items, partialResult, result, itemIds, error;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                this.getItems(count)
                            ];
                        case 1:
                            _ref = _state.sent(), items = _ref.items, partialResult = (0, _objectWithoutProperties._)(_ref, [
                                "items"
                            ]);
                            _state.label = 2;
                        case 2:
                            _state.trys.push([
                                2,
                                5,
                                ,
                                6
                            ]);
                            return [
                                4,
                                processFn(items, partialResult)
                            ];
                        case 3:
                            result = _state.sent();
                            itemIds = items.map(function(item) {
                                return item.id;
                            });
                            // We should not await this delete as a rejected promise would get caught by the catch statement
                            return [
                                4,
                                this.deleteItems(itemIds)
                            ];
                        case 4:
                            _state.sent();
                            return [
                                2,
                                result
                            ];
                        case 5:
                            error = _state.sent();
                            // Eventually we will need a intermediate class to catch all errors but we should ignore this error
                            // This allows libraries beneath to distinguish between a success or failure in processing to update schedulers or anything else
                            // To provide back off or any other mechanism to allow what ever is cauing the errors to recover
                            throw new (0, _errors.CallbackProcessingError)(error);
                        case 6:
                            return [
                                2
                            ];
                    }
                });
            }).call(_this1);
        };
        this.deleteItem = function(objectStore, id) {
            return (0, _asyncToGenerator._)(function() {
                var logger, error;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            logger = this.logger;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                (0, _util.requestToPromise)(objectStore.delete(id))
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            logger.error('Failed to delete item:', id, error);
                            throw error;
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }).call(_this);
        };
        this.getObjectStoreAndTransaction = function(mode) {
            return (0, _asyncToGenerator._)(function() {
                var transaction, objectStore;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                this.db
                            ];
                        case 1:
                            transaction = _state.sent().transaction((0, _constants.RESILIENCE_STORE_NAME), mode);
                            objectStore = transaction.objectStore((0, _constants.RESILIENCE_STORE_NAME));
                            return [
                                2,
                                {
                                    transaction: transaction,
                                    objectStore: objectStore
                                }
                            ];
                    }
                });
            }).call(_this);
        };
        this.options = (0, _util.createOptionsWithDefaults)(options);
        this.namespace = namespace;
        this.logger = this.options.logger;
        if (!window.indexedDB) throw new (0, _errors.NoIndexedDbError)();
        this.db = this.startDB();
        // We just swallow any errors as we know that these are intermittent errors
        // when switching from indexeddb -> localStorage
        this.db.catch(function() {});
        /**
		 *
		 * This class will enforce the number of analytics events we can store in our IndexedDB object store
		 * if asked before adding items to the object store.
		 */ this.globalEventLimitGuard = new (0, _indexedDbEventCountGuardDefault.default)(this.options.maxEventLimit, this.namespace, this.logger, this.deleteItem);
    }
    (0, _createClass._)(IndexedDbConnector, [
        {
            key: "storeType",
            value: function storeType() {
                return (0, _constants.StoreType).INDEXEDDB;
            }
        }
    ]);
    return IndexedDbConnector;
}();

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_without_properties":"6HqIM","@swc/helpers/_/_ts_generator":"78Tqx","./constants":"kwkNw","./defaults":"jil8p","./errors":"iNyLx","./IndexedDbEventCountGuard":"1dOis","./util":"j9P90","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jil8p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GET_ITEM_COUNT", function() {
    return GET_ITEM_COUNT;
});
parcelHelpers.export(exports, "VISIBILITY_TIMEOUT", function() {
    return VISIBILITY_TIMEOUT;
});
parcelHelpers.export(exports, "MAX_ATTEMPTS", function() {
    return MAX_ATTEMPTS;
});
parcelHelpers.export(exports, "EVENT_COUNT_LIMIT", function() {
    return EVENT_COUNT_LIMIT;
});
var GET_ITEM_COUNT = 7;
var VISIBILITY_TIMEOUT = 60000;
var MAX_ATTEMPTS = 10;
var EVENT_COUNT_LIMIT = 8000;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1dOis":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A class to enforce a limit on the amount of Analytics Events stored in AWC IndexedDb.
 */ parcelHelpers.export(exports, "default", function() {
    return IndexedDbEventCountGuard;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _constants = require("./constants");
var _errors = require("./errors");
var _util = require("./util");
var IndexedDbEventCountGuard = /*#__PURE__*/ function() {
    "use strict";
    function IndexedDbEventCountGuard(eventLimit, namespace, logger, deleteItemHandler) {
        var _this = this;
        (0, _classCallCheck._)(this, IndexedDbEventCountGuard);
        /**
	 * This query fetches the oldest events currently stored in AWC IndexedDb object store
	 * and deletes them sequentially
	 */ this.deleteOldestNEvents = function(objectStore, count) {
            return (0, _asyncToGenerator._)(function() {
                var _this, _event_target, productTimeAddedIndex, keyRangeValues, getAllRequest, event, result, deletePromises, error;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this = this;
                            productTimeAddedIndex = objectStore.index((0, _constants.NAMESPACE_AND_TIME_ADDED_INDEX));
                            keyRangeValues = IDBKeyRange.bound([
                                this.namespace,
                                0
                            ], [
                                this.namespace,
                                Date.now()
                            ]);
                            getAllRequest = productTimeAddedIndex.getAllKeys(keyRangeValues, count);
                            return [
                                4,
                                (0, _util.requestToPromise)(getAllRequest)
                            ];
                        case 1:
                            event = _state.sent();
                            result = event === null || event === void 0 ? void 0 : (_event_target = event.target) === null || _event_target === void 0 ? void 0 : _event_target.result;
                            if (!(result && Array.isArray(result) && result.length > 0)) return [
                                3,
                                5
                            ];
                            _state.label = 2;
                        case 2:
                            _state.trys.push([
                                2,
                                4,
                                ,
                                5
                            ]);
                            deletePromises = result.map(function(item) {
                                return _this.deleteItemHandler(objectStore, item);
                            });
                            return [
                                4,
                                Promise.all(deletePromises)
                            ];
                        case 3:
                            _state.sent();
                            return [
                                3,
                                5
                            ];
                        case 4:
                            error = _state.sent();
                            this.logger.warn('Failed to delete items from indexeddb.', error);
                            throw error;
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            }).call(_this);
        };
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.namespace = namespace;
        this.logger = logger;
        this.deleteItemHandler = deleteItemHandler;
    }
    (0, _createClass._)(IndexedDbEventCountGuard, [
        {
            key: "insertItems",
            value: /**
	 * This function checks the number of events currently in AWC IndexedDB object store and if necessary,
	 * will evict the oldest events in favour of the events we want to add.
	 *
	 * The indexed is treated as effectively: partitioned by product and sorted by timeAdded.
	 *
	 * This function can be re-used when the bulk add functionality is added in IndexedDbConnector.
	 *
	 * @param countOfEventsToAdd - The number of events we are proposing to add.
	 */ function insertItems(_0, _1) {
                return (0, _asyncToGenerator._)(function(objectStore, items) {
                    var policy, itemsToAdd, numberOfEvictedItems, promises;
                    var _arguments = arguments;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                policy = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : (0, _constants.GuardPolicy).ABANDON;
                                itemsToAdd = (0, _toConsumableArray._)(items);
                                numberOfEvictedItems = 0;
                                switch(policy){
                                    case (0, _constants.GuardPolicy).ABANDON:
                                        return [
                                            3,
                                            1
                                        ];
                                    case (0, _constants.GuardPolicy).EVICT:
                                        return [
                                            3,
                                            3
                                        ];
                                    case (0, _constants.GuardPolicy).IGNORE:
                                        return [
                                            3,
                                            5
                                        ];
                                }
                                return [
                                    3,
                                    7
                                ];
                            case 1:
                                return [
                                    4,
                                    this.throwIfNotEnoughSpace(objectStore, items.length)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    7
                                ];
                            case 3:
                                return [
                                    4,
                                    this.evictIfNotEnoughSpace(objectStore, items.length)
                                ];
                            case 4:
                                numberOfEvictedItems = _state.sent();
                                return [
                                    3,
                                    7
                                ];
                            case 5:
                                // Removed items from `itemsToAdd` if there is insufficient space
                                return [
                                    4,
                                    this.calculateHowManyEventsWeCanAdd(objectStore, itemsToAdd)
                                ];
                            case 6:
                                _state.sent();
                                return [
                                    3,
                                    7
                                ];
                            case 7:
                                promises = itemsToAdd.map(function(item) {
                                    return (0, _util.requestToPromise)(objectStore.add(item));
                                });
                                return [
                                    4,
                                    Promise.all(promises)
                                ];
                            case 8:
                                _state.sent();
                                return [
                                    4,
                                    (0, _util.commitTransaction)(objectStore.transaction, this.logger)
                                ];
                            case 9:
                                _state.sent();
                                return [
                                    2,
                                    {
                                        items: itemsToAdd,
                                        numberOfEvictedItems: numberOfEvictedItems
                                    }
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        },
        {
            key: "throwIfNotEnoughSpace",
            value: function throwIfNotEnoughSpace(objectStore, requiredSpace) {
                return (0, _asyncToGenerator._)(function() {
                    var freeSpace;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.calculateFreeSpace(objectStore)
                                ];
                            case 1:
                                freeSpace = _state.sent();
                                if (freeSpace < requiredSpace) throw new (0, _errors.AbandonWriteError)("Not enough space in IndexedDb. Needed ".concat(requiredSpace, " but only had ").concat(freeSpace));
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "evictIfNotEnoughSpace",
            value: function evictIfNotEnoughSpace(objectStore, requiredSpace) {
                return (0, _asyncToGenerator._)(function() {
                    var freeSpace, extraSpace;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.calculateFreeSpace(objectStore)
                                ];
                            case 1:
                                freeSpace = _state.sent();
                                if (!(freeSpace < requiredSpace)) return [
                                    3,
                                    3
                                ];
                                extraSpace = requiredSpace - freeSpace;
                                return [
                                    4,
                                    this.deleteOldestNEvents(objectStore, extraSpace)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2,
                                    extraSpace
                                ];
                            case 3:
                                return [
                                    2,
                                    0
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "calculateHowManyEventsWeCanAdd",
            value: function calculateHowManyEventsWeCanAdd(objectStore, items) {
                return (0, _asyncToGenerator._)(function() {
                    var freeSpace, numberOfItemsToRemove, start;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.calculateFreeSpace(objectStore)
                                ];
                            case 1:
                                freeSpace = _state.sent();
                                if (freeSpace < items.length) {
                                    numberOfItemsToRemove = items.length - freeSpace;
                                    start = items.length - numberOfItemsToRemove;
                                    items.splice(start, numberOfItemsToRemove);
                                }
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "calculateFreeSpace",
            value: function calculateFreeSpace(objectStore) {
                return (0, _asyncToGenerator._)(function() {
                    var numberOfEventsInDb;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getCountofEventsInObjectStore(objectStore)
                                ];
                            case 1:
                                numberOfEventsInDb = _state.sent();
                                return [
                                    2,
                                    this.eventLimit - numberOfEventsInDb
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getCountofEventsInObjectStore",
            value: /**
	 * This query returns the count of items held in AWC IndexedDB object store per product.
	 */ function getCountofEventsInObjectStore(objectStore) {
                return (0, _asyncToGenerator._)(function() {
                    var productTimeAddedIndex, keyRangeValues, request, event;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                productTimeAddedIndex = objectStore.index((0, _constants.NAMESPACE_AND_TIME_ADDED_INDEX));
                                keyRangeValues = IDBKeyRange.bound([
                                    this.namespace,
                                    0
                                ], [
                                    this.namespace,
                                    Date.now()
                                ]);
                                request = productTimeAddedIndex.count(keyRangeValues);
                                return [
                                    4,
                                    (0, _util.requestToPromise)(request)
                                ];
                            case 1:
                                event = _state.sent();
                                return [
                                    2,
                                    event.target.result
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return IndexedDbEventCountGuard;
}();

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_to_consumable_array":"1eSZf","@swc/helpers/_/_ts_generator":"78Tqx","./constants":"kwkNw","./errors":"iNyLx","./util":"j9P90","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"j9P90":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "convertToItemWrapper", function() {
    return convertToItemWrapper;
});
parcelHelpers.export(exports, "createOptionsWithDefaults", function() {
    return createOptionsWithDefaults;
});
parcelHelpers.export(exports, "requestToPromise", function() {
    return requestToPromise;
});
parcelHelpers.export(exports, "transactionToPromise", function() {
    return transactionToPromise;
});
parcelHelpers.export(exports, "commitTransaction", function() {
    return commitTransaction;
});
parcelHelpers.export(exports, "monitorErrorsOnRequest", function() {
    return monitorErrorsOnRequest;
});
var _uuid = require("../uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
var _defaults = require("./defaults");
var convertToItemWrapper = function(item, namespace, param) {
    var id = param.id, retryAttempts = param.retryAttempts, timeToProcessOffset = param.timeToProcessOffset;
    return {
        item: item,
        id: id || (0, _uuidDefault.default)(),
        retryAttempts: retryAttempts || 0,
        timeToBeProcessedAfter: Date.now() + (timeToProcessOffset || 0),
        namespace: namespace,
        timeAdded: Date.now()
    };
};
var createOptionsWithDefaults = function(options) {
    return {
        logger: options.logger || console,
        useMemory: options.useMemory || false,
        maxAttempts: options.maxAttempts || (0, _defaults.MAX_ATTEMPTS),
        // This is so that we can customise `maxEventLimit`, primarily for testing.
        maxEventLimit: options.maxEventLimit || (0, _defaults.EVENT_COUNT_LIMIT)
    };
};
var requestToPromise = function(request) {
    return new Promise(function(resolve, reject) {
        request.onsuccess = function(event) {
            resolve(event);
        };
        request.onerror = function(event) {
            reject(event);
        };
    });
};
var transactionToPromise = function(transaction) {
    return new Promise(function(resolve, reject) {
        // We will have to see how much cost there is to waiting for the transaction to complete in the real world.
        // In theory in some cases we could return as soon as the request is complete and
        // just monitor errors on transactions with the logger.
        // This maybe more of an issue in Safari and other older browsers where commit isnt available
        // and we would have to wait for the transaction to complete itself.
        transaction.oncomplete = function() {
            resolve();
        };
        transaction.onerror = function(event) {
            reject(event);
        };
        transaction.onabort = function(event) {
            reject(event);
        };
    });
};
var commitTransaction = function(transaction, logger) {
    try {
        if (typeof transaction.commit === 'function') transaction.commit();
    } catch (error) {
        logger.error('Failed to force commit transaction:', error);
        throw error;
    }
    return transactionToPromise(transaction);
};
var monitorErrorsOnRequest = function(request, logger) {
    request.onerror = function(event) {
        logger.warn('Error thrown from request:', event);
    };
};

},{"../uuid":"gL2xH","./defaults":"jil8p","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2MT2U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return MemoryDb;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _constants = require("./constants");
var _defaults = require("./defaults");
var _errors = require("./errors");
var _memoryDbEventCountGuard = require("./MemoryDbEventCountGuard");
var _memoryDbEventCountGuardDefault = parcelHelpers.interopDefault(_memoryDbEventCountGuard);
var _util = require("./util");
var MemoryDb = /*#__PURE__*/ function() {
    "use strict";
    function MemoryDb(namespace) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, _classCallCheck._)(this, MemoryDb);
        this.namespace = namespace;
        this.memoryStore = [];
        this.options = (0, _util.createOptionsWithDefaults)(options);
        /**
		 * This class will enforce the number of analytics events we can store in our MemoryDb
		 */ this.globalEventLimitGuard = new (0, _memoryDbEventCountGuardDefault.default)(this.options.maxEventLimit, {
            addItems: this.addItems.bind(this),
            getItemCount: this.getItemCount.bind(this),
            evictEventsIfNeeded: this.evictEventsIfNeeded.bind(this)
        });
    }
    (0, _createClass._)(MemoryDb, [
        {
            key: "addItem",
            value: /**
	 * This method is used mainly to write new events to MemoryDB and uses the MEMORY_DB_GUARD_POLICY.EVICT_OLDEST_IF_LIMIT_EXECEEDED policy
	 * to removes oldest events when limit is reached.
	 */ function addItem(_0) {
                return (0, _asyncToGenerator._)(function(item) {
                    var options, policy, storedValue, bulkAddItemsResult;
                    var _arguments = arguments;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {}, policy = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : (0, _constants.GuardPolicy).ABANDON;
                                if (policy === (0, _constants.GuardPolicy).IGNORE) throw new (0, _errors.InvalidPolicyError)(policy, 'IndexedDbConnector#addItem');
                                storedValue = (0, _util.convertToItemWrapper)(item, this.namespace, options);
                                return [
                                    4,
                                    this.globalEventLimitGuard.insertItemsToMemoryStore([
                                        storedValue
                                    ], policy)
                                ];
                            case 1:
                                bulkAddItemsResult = _state.sent();
                                return [
                                    2,
                                    Promise.resolve({
                                        item: bulkAddItemsResult.items[0],
                                        numberOfEvictedItems: bulkAddItemsResult.numberOfEvictedItems
                                    })
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        },
        {
            key: "bulkAddItem",
            value: function bulkAddItem(itemOptions) {
                var _this = this;
                var policy = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, _constants.GuardPolicy).ABANDON;
                var items = itemOptions.map(function(_param) {
                    var item = _param.item, addOptions = (0, _objectWithoutProperties._)(_param, [
                        "item"
                    ]);
                    return (0, _util.convertToItemWrapper)(item, _this.namespace, addOptions);
                });
                return this.bulkAddItemWrapperType(items, policy);
            }
        },
        {
            /**
	 * This method is used mainly to write events to MemoryDB when unknown errors are thrown from IndexedDB.
	 */ key: "bulkAddItemWrapperType",
            value: function bulkAddItemWrapperType(items) {
                var policy = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, _constants.GuardPolicy).ABANDON;
                return Promise.resolve(this.globalEventLimitGuard.insertItemsToMemoryStore(items, policy));
            }
        },
        {
            key: "getItems",
            value: function getItems() {
                var count = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, _defaults.GET_ITEM_COUNT);
                return Promise.resolve(this.synchronousGetItems(count));
            }
        },
        {
            key: "synchronousGetItems",
            value: function synchronousGetItems() {
                var _this = this;
                var count = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, _defaults.GET_ITEM_COUNT);
                var fixedCount = count > 0 ? count : (0, _defaults.GET_ITEM_COUNT);
                var now = Date.now();
                var wrappedItems = [];
                var itemsToRemove = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.memoryStore[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var wrappedItem = _step.value;
                        if (wrappedItem.timeToBeProcessedAfter <= now) {
                            wrappedItems.push((0, _objectSpread._)({}, wrappedItem));
                            // Mutates the item in the memoryStore array, but not whats inside of wrappedItems
                            wrappedItem.timeToBeProcessedAfter += (0, _defaults.VISIBILITY_TIMEOUT);
                            wrappedItem.retryAttempts += 1;
                            if (wrappedItem.retryAttempts >= this.options.maxAttempts) itemsToRemove.push(wrappedItem);
                        }
                        if (wrappedItems.length >= fixedCount) break;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                itemsToRemove.forEach(function(item) {
                    var index = _this.memoryStore.indexOf(item);
                    _this.memoryStore.splice(index, 1);
                });
                return {
                    items: wrappedItems,
                    numberOfDeletedItems: itemsToRemove.length
                };
            }
        },
        {
            key: "deleteItems",
            value: function deleteItems(itemIds) {
                this.memoryStore = this.memoryStore.filter(function(item) {
                    return !itemIds.includes(item.id);
                });
                return Promise.resolve(void 0);
            }
        },
        {
            key: "getItemCount",
            value: function getItemCount() {
                var now = Date.now();
                var count = this.memoryStore.filter(function(item) {
                    return item.timeToBeProcessedAfter <= now;
                }).length;
                return Promise.resolve(count);
            }
        },
        {
            key: "processItems",
            value: function processItems(processFn, count) {
                return (0, _asyncToGenerator._)(function() {
                    var _this_synchronousGetItems, items, partialGetResult, itemIds, result, error;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this_synchronousGetItems = this.synchronousGetItems(count), items = _this_synchronousGetItems.items, partialGetResult = (0, _objectWithoutProperties._)(_this_synchronousGetItems, [
                                    "items"
                                ]);
                                itemIds = items.map(function(i) {
                                    return i.id;
                                });
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    processFn(items, partialGetResult)
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    4,
                                    this.deleteItems(itemIds)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 4:
                                error = _state.sent();
                                throw new (0, _errors.CallbackProcessingError)(error);
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "storeType",
            value: function storeType() {
                return (0, _constants.StoreType).MEMORY;
            }
        },
        {
            key: "addItems",
            value: /**
	 * This function is adding items to the tail of the memoryStore and as it adds new items it keeps the
	 * memory store sorted by timeAdded property. This makes evictions easier and adding elements to
	 * memoryStore much faster.
	 *
	 * @param itemsToAdd
	 */ function addItems(itemsToAdd) {
                var _this_memoryStore;
                (_this_memoryStore = this.memoryStore).push.apply(_this_memoryStore, (0, _toConsumableArray._)(itemsToAdd));
                // Sorting everytime, intentionally.
                this.memoryStore.sort(function(a, b) {
                    return a.timeAdded - b.timeAdded;
                });
            }
        },
        {
            key: "evictEventsIfNeeded",
            value: /**
	 * This function checks the number of events currently in AWC MemoryDb and if necessary,
	 * will evict the oldest events in favour of the events we want to add.
	 *
	 * @param countOfEventsToAdd - The number of events we are proposing to add.
	 */ function evictEventsIfNeeded(eventLimit) {
                var numberOfEventsInDb = this.memoryStore.length;
                // The number of analytics events currently in MemoryDb and
                // the Z events we are proposing to add will exceed our event count limit.
                if (numberOfEventsInDb > eventLimit) {
                    var m = numberOfEventsInDb - eventLimit;
                    // Removing oldest M events
                    this.memoryStore.splice(0, m);
                    return m;
                }
                return 0;
            }
        }
    ]);
    return MemoryDb;
}();

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_without_properties":"6HqIM","@swc/helpers/_/_to_consumable_array":"1eSZf","@swc/helpers/_/_ts_generator":"78Tqx","./constants":"kwkNw","./defaults":"jil8p","./errors":"iNyLx","./MemoryDbEventCountGuard":"yewgg","./util":"j9P90","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"yewgg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return MemoryDbEventCountGuard;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _constants = require("./constants");
var _errors = require("./errors");
var MemoryDbEventCountGuard = /*#__PURE__*/ function() {
    "use strict";
    function MemoryDbEventCountGuard(eventLimit, memoryItemHandlers) {
        var _this = this;
        (0, _classCallCheck._)(this, MemoryDbEventCountGuard);
        /**
	 * Unlike IndexedDb, we cannot take advantage of any index. So we are,
	 * treating the memory store as a sorted set when adding items.
	 */ this.insertItemsToMemoryStore = function(itemsToAdd, policy) {
            switch(policy){
                case (0, _constants.GuardPolicy).ABANDON:
                    return _this.handleAbandonIfLimitWillExceedPolicy(itemsToAdd);
                case (0, _constants.GuardPolicy).EVICT:
                    return Promise.resolve(_this.handleEvictOldestIfLimitExceededPolicy(itemsToAdd));
                case (0, _constants.GuardPolicy).IGNORE:
                    return _this.handleAddAsManyAsPossible(itemsToAdd);
            }
        };
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.memoryItemHandlers = memoryItemHandlers;
    }
    (0, _createClass._)(MemoryDbEventCountGuard, [
        {
            key: "handleAbandonIfLimitWillExceedPolicy",
            value: function handleAbandonIfLimitWillExceedPolicy(itemsToAdd) {
                return (0, _asyncToGenerator._)(function() {
                    var itemCount;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.memoryItemHandlers.getItemCount()
                                ];
                            case 1:
                                itemCount = _state.sent();
                                if (itemCount + itemsToAdd.length > this.eventLimit) throw new (0, _errors.AbandonWriteError)((0, _constants.StoreType).MEMORY);
                                this.memoryItemHandlers.addItems(itemsToAdd);
                                return [
                                    2,
                                    {
                                        items: itemsToAdd,
                                        numberOfEvictedItems: 0
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "handleEvictOldestIfLimitExceededPolicy",
            value: function handleEvictOldestIfLimitExceededPolicy(itemsToAdd) {
                this.memoryItemHandlers.addItems(itemsToAdd);
                var numberOfEvictedItems = this.memoryItemHandlers.evictEventsIfNeeded(this.eventLimit);
                return {
                    items: itemsToAdd,
                    numberOfEvictedItems: numberOfEvictedItems
                };
            }
        },
        {
            key: "handleAddAsManyAsPossible",
            value: function handleAddAsManyAsPossible(itemsToAdd) {
                return (0, _asyncToGenerator._)(function() {
                    var freeSpace, _, partialEventsToAdd;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _ = this.eventLimit;
                                return [
                                    4,
                                    this.memoryItemHandlers.getItemCount()
                                ];
                            case 1:
                                freeSpace = _ - _state.sent();
                                partialEventsToAdd = freeSpace > itemsToAdd.length ? itemsToAdd : itemsToAdd.slice(0, freeSpace);
                                this.memoryItemHandlers.addItems(partialEventsToAdd);
                                return [
                                    2,
                                    {
                                        items: partialEventsToAdd,
                                        numberOfEvictedItems: 0
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return MemoryDbEventCountGuard;
}();

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_ts_generator":"78Tqx","./constants":"kwkNw","./errors":"iNyLx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"al9gp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MetricsCollector", function() {
    return MetricsCollector;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _types = require("./types");
var MetricsCollector = /*#__PURE__*/ function() {
    "use strict";
    function MetricsCollector() {
        (0, _classCallCheck._)(this, MetricsCollector);
        // Number of events discarded due to exceeding retry limits.
        this.itemsDiscardedByRetry = 0;
        // Number of events created by the product in current tab.
        this.eventCount = 0;
        // Number of events discarded due to reaching queue max size.
        this.itemsDiscardedByOverflow = 0;
        // Will be used in the future when we get more resilience mechanisms
        this.resilienceMechanism = (0, _types.ResilienceMechanism).INDEXEDDB;
        /* --- LocalStorage specific metrics --- */ // Emitted by purgeOrphanedQueues to tell us how many queues we have had to clean up due to
        // https://github.com/segmentio/localstorage-retry/pull/17
        this.localstorageNumberOfQueuesPurged = 0;
        // Emitted by reclaimEvents to tell us how many queues were seen in the process of reclaim.
        // We will only emit metrics for queues that are not currently being maintained (i.e. `ack` is not being updated).
        // Queue was found, all events removed and put into resilienceDb.
        this.localstorageNumberOfFullReclaims = 0;
        // Queue was found but not all events were able to be put into resilienceDb.
        this.localstorageNumberOfPartialReclaims = 0;
        // Reclaim failed for a queue and reclaim was abandonded.
        this.localstorageNumberOfFailedReclaims = 0;
    }
    (0, _createClass._)(MetricsCollector, [
        {
            key: "addToItemsDiscardedByRetryCounter",
            value: function addToItemsDiscardedByRetryCounter() {
                var numberOfDeletedEvents = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
                this.itemsDiscardedByRetry += numberOfDeletedEvents;
            }
        },
        {
            key: "addToEventCount",
            value: function addToEventCount() {
                this.eventCount++;
            }
        },
        {
            key: "addToItemsDiscardedByOverflowCounter",
            value: function addToItemsDiscardedByOverflowCounter() {
                var numberOfDeletedEvents = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
                this.itemsDiscardedByOverflow += numberOfDeletedEvents;
            }
        },
        {
            key: "setResilienceMechanism",
            value: function setResilienceMechanism(mechanism) {
                this.resilienceMechanism = mechanism;
            }
        },
        {
            /* <Localstorage specific> */ key: "addToReclaimMetrics",
            value: function addToReclaimMetrics(reclaimMetrics) {
                this.localstorageNumberOfFullReclaims += reclaimMetrics.fullReclaims;
                this.localstorageNumberOfPartialReclaims += reclaimMetrics.partialReclaims;
                this.localstorageNumberOfFailedReclaims += reclaimMetrics.failedReclaims;
            }
        },
        {
            key: "addToPurgedQueuesMetrics",
            value: function addToPurgedQueuesMetrics(numberOfQueuesPurged) {
                this.localstorageNumberOfQueuesPurged += numberOfQueuesPurged;
            }
        },
        {
            /* </Localstorage specific> */ key: "subtractFromMetrics",
            value: function subtractFromMetrics(sentMetrics) {
                this.itemsDiscardedByRetry = this.subtractFromCount(this.itemsDiscardedByRetry, sentMetrics.itemsDiscardedByRetry);
                this.eventCount = this.subtractFromCount(this.eventCount, sentMetrics.eventCount);
                this.itemsDiscardedByOverflow = this.subtractFromCount(this.itemsDiscardedByOverflow, sentMetrics.itemsDiscardedByOverflow);
                // Localstorage specific
                this.localstorageNumberOfFullReclaims = this.subtractFromCount(this.localstorageNumberOfFullReclaims, sentMetrics.fullReclaims);
                this.localstorageNumberOfPartialReclaims = this.subtractFromCount(this.localstorageNumberOfPartialReclaims, sentMetrics.partialReclaims);
                this.localstorageNumberOfFailedReclaims = this.subtractFromCount(this.localstorageNumberOfFailedReclaims, sentMetrics.failedReclaims);
                this.localstorageNumberOfQueuesPurged = this.subtractFromCount(this.localstorageNumberOfQueuesPurged, sentMetrics.localstorageQueuesPurged);
            }
        },
        {
            key: "subtractFromCount",
            value: function subtractFromCount(count, subtract) {
                return Math.max(count - (subtract || 0), 0);
            }
        },
        {
            key: "getMetricsPayload",
            value: function getMetricsPayload() {
                return {
                    itemsDiscardedByRetry: this.itemsDiscardedByRetry,
                    eventCount: this.eventCount,
                    itemsDiscardedByOverflow: this.itemsDiscardedByOverflow,
                    resilienceMechanism: this.resilienceMechanism,
                    // Localstorage specific
                    localstorageQueuesPurged: this.localstorageNumberOfQueuesPurged,
                    fullReclaims: this.localstorageNumberOfFullReclaims,
                    partialReclaims: this.localstorageNumberOfPartialReclaims,
                    failedReclaims: this.localstorageNumberOfFailedReclaims
                };
            }
        }
    ]);
    return MetricsCollector;
}();
var cachedMetricsClient = null;
exports.default = function() {
    if (!cachedMetricsClient) cachedMetricsClient = new MetricsCollector();
    return cachedMetricsClient;
};

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","./types":"g24Es","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"g24Es":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResilienceMechanism", function() {
    return ResilienceMechanism;
});
parcelHelpers.export(exports, "NetworkStatusEnum", function() {
    return NetworkStatusEnum;
});
var ResilienceMechanism = /*#__PURE__*/ function(ResilienceMechanism) {
    ResilienceMechanism["INDEXEDDB"] = "indexeddb";
    ResilienceMechanism["MEMORY"] = "memory";
    return ResilienceMechanism;
}({});
var NetworkStatusEnum = /*#__PURE__*/ function(NetworkStatusEnum) {
    NetworkStatusEnum[NetworkStatusEnum["ONLINE"] = 0] = "ONLINE";
    NetworkStatusEnum[NetworkStatusEnum["OFFLINE"] = 1] = "OFFLINE";
    return NetworkStatusEnum;
}({});

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5TM92":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return NetworkStatus;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _types = require("./types");
var NetworkStatus = /*#__PURE__*/ function() {
    "use strict";
    function NetworkStatus(networkChangeCallback) {
        var _this = this;
        (0, _classCallCheck._)(this, NetworkStatus);
        this._networkChangeCallback = networkChangeCallback;
        if (typeof window !== 'undefined') {
            window.addEventListener('offline', function() {
                return _this._networkChangeCallback((0, _types.NetworkStatusEnum).OFFLINE);
            });
            window.addEventListener('online', function() {
                return _this._networkChangeCallback((0, _types.NetworkStatusEnum).ONLINE);
            });
        }
    }
    (0, _createClass._)(NetworkStatus, [
        {
            key: "removeListeners",
            value: function removeListeners() {
                var _this = this;
                if (typeof window !== 'undefined') {
                    window.addEventListener('offline', function() {
                        return _this._networkChangeCallback((0, _types.NetworkStatusEnum).OFFLINE);
                    });
                    window.addEventListener('online', function() {
                        return _this._networkChangeCallback((0, _types.NetworkStatusEnum).ONLINE);
                    });
                }
            }
        },
        {
            key: "getNetworkStatus",
            value: function getNetworkStatus() {
                if (window.navigator.onLine) return (0, _types.NetworkStatusEnum).ONLINE;
                return (0, _types.NetworkStatusEnum).OFFLINE;
            }
        }
    ]);
    return NetworkStatus;
}();

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","./types":"g24Es","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3kKmD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return 0, _schedulerDefault.default;
});
parcelHelpers.export(exports, "DoneState", function() {
    return 0, _types.DoneState;
});
var _scheduler = require("./Scheduler");
var _schedulerDefault = parcelHelpers.interopDefault(_scheduler);
var _types = require("./types");

},{"./Scheduler":"jzlhe","./types":"cXt8Z","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jzlhe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueuedScheduleTypes", function() {
    return QueuedScheduleTypes;
});
parcelHelpers.export(exports, "default", function() {
    return Scheduler;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _callbackWithTimeout = require("./CallbackWithTimeout");
var _types = require("./types");
var SCHEDULER_OPTIONS_DEFAULT = {
    minRetryDelay: 1000,
    maxRetryDelay: 30000,
    backoffFactor: 2,
    backoffJitterPercentage: 0,
    waitInterval: 500,
    callbackTimeoutPeriod: 5000
};
var QueuedScheduleTypes = /*#__PURE__*/ function(QueuedScheduleTypes) {
    QueuedScheduleTypes[QueuedScheduleTypes["NONE"] = 0] = "NONE";
    QueuedScheduleTypes[QueuedScheduleTypes["IMMEDIATE"] = 1] = "IMMEDIATE";
    QueuedScheduleTypes[QueuedScheduleTypes["WAIT"] = 2] = "WAIT";
    return QueuedScheduleTypes;
}({});
var Scheduler = function Scheduler(retryOptions, callback) {
    "use strict";
    var _this = this;
    var _this1 = this;
    (0, _classCallCheck._)(this, Scheduler);
    this.schedule = function() {
        var immediate = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).immediate;
        if (typeof window === 'undefined') return;
        if (_this1.operationInFlight) {
            if (immediate) _this1.queuedSchedule = 1;
            else if (_this1.queuedSchedule !== 1) _this1.queuedSchedule = 2;
        // Only run immediately if we have no failures
        } else if ((immediate || _this1.options.waitInterval <= 0) && _this1.failureCount === 0) {
            _this1.clearTimeout();
            _this1.run();
        // Calculate backoff for normal or failure scenario
        } else if (_this1.scheduledTimeout === null) _this1.scheduledTimeout = window.setTimeout(_this1.run, _this1.calculateBackoff());
    };
    this.stop = function() {
        _this.clearTimeout();
        _this.queuedSchedule = 0;
    };
    this.getFailureCount = function() {
        return _this.failureCount;
    };
    this.getCallbackStatus = function() {
        return _this.callbackTimer.getCallbackStatus();
    };
    this.clearTimeout = function() {
        if (typeof window !== 'undefined' && _this.scheduledTimeout !== null) {
            window.clearTimeout(_this.scheduledTimeout);
            _this.scheduledTimeout = null;
        }
    };
    this.run = function() {
        _this.operationInFlight = true;
        _this.clearTimeout();
        try {
            _this.callbackTimer.executeCallbackWithTimeout(// callback to execute
            _this.callback, // when callback completes, call this function
            _this.done, // on timeout, do this instead
            function() {
                return _this.done((0, _types.DoneState).ERROR);
            });
        } catch (err) {
            _this.done(err);
        }
    };
    this.done = function(state) {
        _this.operationInFlight = false;
        if (state === (0, _types.DoneState).ERROR || _this.callbackTimer.getCallbackStatus() === (0, _callbackWithTimeout.CallbackStatus).TIMED_OUT) {
            _this.failureCount++;
            _this.clearTimeout();
        } else if (state === (0, _types.DoneState).SUCCESS) _this.failureCount = 0;
        _this.processQueuedSchedule();
    };
    this.processQueuedSchedule = function() {
        if (_this.queuedSchedule !== 0) {
            var immediate = _this.queuedSchedule === 1;
            _this.queuedSchedule = 0;
            _this.schedule({
                immediate: immediate
            });
        } else if (_this.failureCount > 0) // This will schedule tasks when this._done was called with a truthy value
        // For example, when this.callback(this._done) was not called within
        // this.callbackTimeoutPeriod
        _this.schedule();
    };
    this.calculateBackoff = function() {
        var _this_options = _this.options, minRetryDelay = _this_options.minRetryDelay, maxRetryDelay = _this_options.maxRetryDelay, backoffFactor = _this_options.backoffFactor, backoffJitterPercentage = _this_options.backoffJitterPercentage, waitInterval = _this_options.waitInterval;
        // Helper for deviation based on a single random sample
        var jitter = function(base, symmetric) {
            if (!backoffJitterPercentage || base <= 0) return 0;
            var r = (Math.random() - 0.5) * 2;
            var frac = symmetric ? r : Math.abs(r);
            return Math.floor(frac * backoffJitterPercentage * base);
        };
        // No failures: wait interval with positive-only jitter
        if (_this.failureCount === 0) return waitInterval + jitter(waitInterval, false);
        // Failures: exponential backoff with symmetric jitter
        var base = Math.min(minRetryDelay * Math.pow(backoffFactor, _this.failureCount), maxRetryDelay);
        var withJitter = base + jitter(base, true);
        return Math.max(minRetryDelay, Math.min(withJitter, maxRetryDelay));
    };
    this.options = {
        minRetryDelay: retryOptions.minRetryDelay || SCHEDULER_OPTIONS_DEFAULT.minRetryDelay,
        maxRetryDelay: retryOptions.maxRetryDelay || SCHEDULER_OPTIONS_DEFAULT.maxRetryDelay,
        backoffFactor: retryOptions.backoffFactor || SCHEDULER_OPTIONS_DEFAULT.backoffFactor,
        backoffJitterPercentage: retryOptions.backoffJitterPercentage || SCHEDULER_OPTIONS_DEFAULT.backoffJitterPercentage,
        waitInterval: retryOptions.waitInterval !== undefined ? retryOptions.waitInterval : SCHEDULER_OPTIONS_DEFAULT.waitInterval,
        callbackTimeoutPeriod: retryOptions.callbackTimeoutPeriod || SCHEDULER_OPTIONS_DEFAULT.callbackTimeoutPeriod
    };
    this.scheduledTimeout = null;
    this.failureCount = 0;
    this.callback = callback;
    this.operationInFlight = false;
    this.queuedSchedule = 0;
    this.callbackTimer = new (0, _callbackWithTimeout.CallbackWithTimeout)(this.options.callbackTimeoutPeriod);
};

},{"@swc/helpers/_/_class_call_check":"5CNCO","./CallbackWithTimeout":"2qh2W","./types":"cXt8Z","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2qh2W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CallbackStatus", function() {
    return CallbackStatus;
});
parcelHelpers.export(exports, "CallbackEvent", function() {
    return CallbackEvent;
});
parcelHelpers.export(exports, "CallbackWithTimeout", function() {
    return CallbackWithTimeout;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var CallbackStatus = /*#__PURE__*/ function(CallbackStatus) {
    CallbackStatus["IDLE"] = "idle";
    CallbackStatus["RUNNING"] = "running";
    CallbackStatus["COMPLETED"] = "completed";
    CallbackStatus["TIMED_OUT"] = "timedOut";
    return CallbackStatus;
}({});
var CallbackEvent = /*#__PURE__*/ function(CallbackEvent) {
    CallbackEvent["EXECUTE"] = "execute";
    CallbackEvent["COMPLETE"] = "complete";
    CallbackEvent["TIMEOUT"] = "timeout";
    return CallbackEvent;
}({});
var CallbackWithTimeout = /*#__PURE__*/ function() {
    "use strict";
    function CallbackWithTimeout(timeoutPeriod) {
        (0, _classCallCheck._)(this, CallbackWithTimeout);
        // Tracks the settimeout; so that we can clear the timeout
        this.timeoutHandle = undefined;
        this.callbackStatus = "idle";
        if (timeoutPeriod > 0) {
            this.timeoutPeriod = timeoutPeriod;
            return;
        }
        throw new Error('CallbackWithTimeout requires timeout period higher than 0');
    }
    (0, _createClass._)(CallbackWithTimeout, [
        {
            // This is a state machine to control the flow of execution.
            // IDLE -> RUNNING -> COMPLETED
            // IDLE -> RUNNING -> TIMEDOUT
            key: "transitionCallbackStatus",
            value: function transitionCallbackStatus(currentStatus, event) {
                switch(currentStatus){
                    case "idle":
                    case "timedOut":
                    case "completed":
                        if (event === "execute") this.callbackStatus = "running";
                        break;
                    case "running":
                        switch(event){
                            case "complete":
                                this.callbackStatus = "completed";
                                break;
                            case "timeout":
                                this.callbackStatus = "timedOut";
                                break;
                        }
                        break;
                    default:
                        this.callbackStatus = currentStatus;
                }
            }
        },
        {
            // Start a timeout. If this.callback(this._done) does not finish
            // by this.options.callbackTimeoutPeriod time period,
            // we will call done with a true value.
            key: "executeCallbackWithTimeout",
            value: function executeCallbackWithTimeout(callback, onDone, onTimeout) {
                var _this = this;
                if (typeof window === 'undefined') return;
                this.transitionCallbackStatus(this.callbackStatus, "execute");
                // Setting timeout
                this.timeoutHandle = window.setTimeout(function() {
                    _this.transitionCallbackStatus(_this.callbackStatus, "timeout");
                    onTimeout();
                }, this.timeoutPeriod);
                // Executing callback
                callback(function(state) {
                    _this.cancelTimeout();
                    if (_this.getCallbackStatus() !== "timedOut") {
                        _this.transitionCallbackStatus(_this.callbackStatus, "complete");
                        onDone(state);
                    }
                });
            }
        },
        {
            key: "getCallbackStatus",
            value: function getCallbackStatus() {
                return this.callbackStatus;
            }
        },
        {
            // This allows us to cancel the timeout function, for example, if the callback finishes before the timeout period
            // or, if the user wants to manually cancel the timeout
            key: "cancelTimeout",
            value: function cancelTimeout() {
                if (typeof window !== 'undefined' && this.timeoutPeriod > 0 && this.timeoutHandle) {
                    window.clearTimeout(this.timeoutHandle);
                    this.timeoutHandle = undefined;
                }
            }
        }
    ]);
    return CallbackWithTimeout;
}();

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cXt8Z":[function(require,module,exports,__globalThis) {
// Clients can optionally provide the callbackTimeoutPeriod parameter
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DoneState", function() {
    return DoneState;
});
var DoneState = /*#__PURE__*/ function(DoneState) {
    DoneState[DoneState["NOOP"] = 0] = "NOOP";
    DoneState[DoneState["SUCCESS"] = 1] = "SUCCESS";
    DoneState[DoneState["ERROR"] = 2] = "ERROR";
    return DoneState;
}({});

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"54XC1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createUnknownXid", function() {
    return 0, _constants.createUnknownXid;
});
parcelHelpers.export(exports, "XIDItemType", function() {
    return 0, _enums.XIDItemType;
});
parcelHelpers.export(exports, "XIDState", function() {
    return 0, _enums.XIDState;
});
parcelHelpers.export(exports, "XIDPromise", function() {
    return 0, _xidpromise.XIDPromise;
});
parcelHelpers.export(exports, "attachXidToSingleEvent", function() {
    return 0, _attachXID.attachXidToSingleEvent;
});
parcelHelpers.export(exports, "attachXidToMultipleEvents", function() {
    return 0, _attachXID.attachXidToMultipleEvents;
});
var _constants = require("./constants");
var _enums = require("./enums");
var _xidpromise = require("./XIDPromise");
var _attachXID = require("./AttachXID");

},{"./constants":false,"./enums":false,"./XIDPromise":"ePbRn","./AttachXID":"6kERe","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2mufX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "XID_TIMEOUT", function() {
    return XID_TIMEOUT;
});
parcelHelpers.export(exports, "createTimeoutXid", function() {
    return createTimeoutXid;
});
parcelHelpers.export(exports, "createUnknownXid", function() {
    return createUnknownXid;
});
var _enums = require("./enums");
var XID_TIMEOUT = 5000;
var createTimeoutXid = function() {
    return [
        {
            type: (0, _enums.XIDItemType).XC,
            state: 'TIMEOUT'
        },
        {
            type: (0, _enums.XIDItemType).UID,
            state: 'TIMEOUT'
        }
    ];
};
var createUnknownXid = function() {
    return [
        {
            type: (0, _enums.XIDItemType).XC,
            state: 'UNKNOWN'
        },
        {
            type: (0, _enums.XIDItemType).UID,
            state: 'UNKNOWN'
        }
    ];
};

},{"./enums":"kducG","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kducG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "XIDItemType", function() {
    return XIDItemType;
});
parcelHelpers.export(exports, "XIDState", function() {
    return XIDState;
});
var XIDItemType = /*#__PURE__*/ function(XIDItemType) {
    XIDItemType["XC"] = "xc";
    XIDItemType["UID"] = "uid";
    return XIDItemType;
}({});
var XIDState = /*#__PURE__*/ function(XIDState) {
    XIDState["NEW"] = "NEW";
    XIDState["CHANGED"] = "CHANGED";
    XIDState["EXISTING"] = "EXISTING";
    XIDState["TIMEOUT"] = "TIMEOUT";
    XIDState["ERROR"] = "ERROR";
    XIDState["UNAVAILABLE"] = "UNAVAILABLE";
    XIDState["MALFORMED"] = "MALFORMED";
    XIDState["UNKNOWN"] = "UNKNOWN";
    return XIDState;
}({});

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ePbRn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "XIDPromise", function() {
    return XIDPromise;
});
var _constants = require("./constants");
var XIDPromise = function(xidConsent, xidPromiseFn) {
    if (xidConsent && xidPromiseFn && typeof xidPromiseFn === 'function') {
        var timeoutPromise = function() {
            return new Promise(function(resolve) {
                setTimeout(function() {
                    return resolve(function() {
                        return (0, _constants.createTimeoutXid)();
                    });
                }, (0, _constants.XID_TIMEOUT));
            });
        };
        var xidPromise = function() {
            return xidPromiseFn().catch(function() {
                return function() {
                    return (0, _constants.createUnknownXid)();
                };
            });
        };
        return Promise.race([
            xidPromise(),
            timeoutPromise()
        ]);
    }
    return undefined;
};

},{"./constants":"2mufX","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6kERe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "attachXidToSingleEvent", function() {
    return attachXidToSingleEvent;
});
parcelHelpers.export(exports, "attachXidToMultipleEvents", function() {
    return attachXidToMultipleEvents;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _types = require("../integration/types");
function attachXidToSingleEvent(item, xidCallback) {
    if (!(xidCallback && (0, _instanceof._)(xidCallback, Function))) return item;
    if (item.msg.type === (0, _types.SegmentEventTypes).PAGE || item.msg.type === (0, _types.SegmentEventTypes).TRACK) {
        var xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.properties = (0, _objectSpreadProps._)((0, _objectSpread._)({}, item.msg.properties), {
            xid: xid
        });
    } else if (item.msg.traits && item.msg.type === (0, _types.SegmentEventTypes).IDENTIFY) {
        var xid1 = xidCallback();
        if (xid1 && Array.isArray(xid1)) item.msg.traits = (0, _objectSpreadProps._)((0, _objectSpread._)({}, item.msg.traits), {
            xid: xid1
        });
    }
    return item;
}
function attachXidToMultipleEvents(items, xidItemPromiseCallback) {
    return (0, _asyncToGenerator._)(function() {
        var xidCallback, error;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        xidItemPromiseCallback
                    ];
                case 1:
                    xidCallback = _state.sent();
                    return [
                        2,
                        items.map(function(item) {
                            return attachXidToSingleEvent(item, xidCallback);
                        })
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        2,
                        items
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
}

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_ts_generator":"78Tqx","../integration/types":"iaCPD","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iaCPD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LastError", function() {
    return LastError;
});
parcelHelpers.export(exports, "SegmentEventTypes", function() {
    return SegmentEventTypes;
});
parcelHelpers.export(exports, "CrossDomainIdentifierType", function() {
    return CrossDomainIdentifierType;
});
parcelHelpers.export(exports, "CrossDomainIdentifierState", function() {
    return CrossDomainIdentifierState;
});
parcelHelpers.export(exports, "MetadataResponse", function() {
    return MetadataResponse;
});
parcelHelpers.export(exports, "FetchError", function() {
    return FetchError;
});
parcelHelpers.export(exports, "ALLOW_LISTED_FETCH_ERROR_NAMES", function() {
    return ALLOW_LISTED_FETCH_ERROR_NAMES;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _wrapNativeSuper = require("@swc/helpers/_/_wrap_native_super");
var LastError = function LastError(reason, error) {
    "use strict";
    (0, _classCallCheck._)(this, LastError);
    this.reason = reason;
    this.message = (0, _instanceof._)(error, Error) ? error.message : null;
    this.statusCode = (0, _instanceof._)(error, FetchError) ? error.statusCode : null;
};
var SegmentEventTypes = /*#__PURE__*/ function(SegmentEventTypes) {
    SegmentEventTypes["IDENTIFY"] = "identify";
    SegmentEventTypes["PAGE"] = "page";
    // Dont need Screen as page and screen are the same and we only use page
    SegmentEventTypes["TRACK"] = "track";
    return SegmentEventTypes;
}({});
var CrossDomainIdentifierType = /*#__PURE__*/ function(CrossDomainIdentifierType) {
    CrossDomainIdentifierType["XC"] = "xc";
    CrossDomainIdentifierType["UID"] = "uid";
    return CrossDomainIdentifierType;
}({});
var CrossDomainIdentifierState = /*#__PURE__*/ function(CrossDomainIdentifierState) {
    CrossDomainIdentifierState["NEW"] = "NEW";
    CrossDomainIdentifierState["CHANGED"] = "CHANGED";
    CrossDomainIdentifierState["EXISTING"] = "EXISTING";
    CrossDomainIdentifierState["TIMEOUT"] = "TIMEOUT";
    CrossDomainIdentifierState["ERROR"] = "ERROR";
    CrossDomainIdentifierState["UNAVAILABLE"] = "UNAVAILABLE";
    CrossDomainIdentifierState["MALFORMED"] = "MALFORMED";
    CrossDomainIdentifierState["UNKNOWN"] = "UNKNOWN";
    return CrossDomainIdentifierState;
}({});
var MetadataResponse = /*#__PURE__*/ function() {
    "use strict";
    function MetadataResponse(props, url) {
        (0, _classCallCheck._)(this, MetadataResponse);
        this.props = props;
        this.url = url;
    }
    (0, _createClass._)(MetadataResponse, null, [
        {
            key: "fromJson",
            value: function fromJson(json) {
                var isString = function(value) {
                    return typeof value === 'string' || (0, _instanceof._)(value, String);
                };
                var url = isString(json === null || json === void 0 ? void 0 : json.url) ? json.url.trim() : '';
                return new MetadataResponse((json === null || json === void 0 ? void 0 : json.props) || null, url.startsWith('http') ? url : null);
            }
        }
    ]);
    return MetadataResponse;
}();
var FetchError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, _inherits._)(FetchError, Error1);
    function FetchError(message, statusCode, statusText) {
        (0, _classCallCheck._)(this, FetchError);
        var _this;
        _this = (0, _callSuper._)(this, FetchError, [
            message
        ]);
        _this.statusCode = statusCode;
        _this.statusText = statusText;
        return _this;
    }
    return FetchError;
}((0, _wrapNativeSuper._)(Error));
var ALLOW_LISTED_FETCH_ERROR_NAMES = [
    'FetchError',
    'AbortError',
    'TypeError'
];

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_inherits":"2sfqW","@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_wrap_native_super":"d0Iin","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fC7BS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_REQUEST_TIMEOUT", function() {
    return DEFAULT_REQUEST_TIMEOUT;
});
parcelHelpers.export(exports, "DEFAULT_METADATA_REQUEST_TIMEOUT", function() {
    return DEFAULT_METADATA_REQUEST_TIMEOUT;
});
parcelHelpers.export(exports, "DEFAULT_METADATA_REFRESH_INTERVAL", function() {
    return DEFAULT_METADATA_REFRESH_INTERVAL;
});
parcelHelpers.export(exports, "DEFAULT_METADATA_MIN_RETRY_DELAY", function() {
    return DEFAULT_METADATA_MIN_RETRY_DELAY;
});
parcelHelpers.export(exports, "DEFAULT_METADATA_MAX_RETRY_DELAY", function() {
    return DEFAULT_METADATA_MAX_RETRY_DELAY;
});
parcelHelpers.export(exports, "DEFAULT_METADATA_PROPERTY_CHANGE_REFRESH_INTERVAL", function() {
    return DEFAULT_METADATA_PROPERTY_CHANGE_REFRESH_INTERVAL;
});
var DEFAULT_REQUEST_TIMEOUT = 10000; // 10 seconds
var DEFAULT_METADATA_REQUEST_TIMEOUT = 60000; // 60 seconds
var DEFAULT_METADATA_REFRESH_INTERVAL = 600000; // 10 minutes
var DEFAULT_METADATA_MIN_RETRY_DELAY = 5000; // 5 seconds
var DEFAULT_METADATA_MAX_RETRY_DELAY = 3600000; // 60 minutes
var DEFAULT_METADATA_PROPERTY_CHANGE_REFRESH_INTERVAL = 10; // 10 milliseconds

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dZsiM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HTTP_STATUS_CODE_MAP", function() {
    return HTTP_STATUS_CODE_MAP;
});
var HTTP_STATUS_CODE_MAP = new Map([
    [
        200,
        'OK'
    ],
    [
        400,
        'Bad Request'
    ],
    [
        401,
        'Unauthorized'
    ],
    [
        402,
        'Payment Required'
    ],
    [
        403,
        'Forbidden'
    ],
    [
        404,
        'Not Found'
    ],
    [
        405,
        'Method Not Allowed'
    ],
    [
        406,
        'Not Acceptable'
    ],
    [
        407,
        'Proxy Authentication Required'
    ],
    [
        408,
        'Request Timeout'
    ],
    [
        409,
        'Conflict'
    ],
    [
        410,
        'Gone'
    ],
    [
        411,
        'Length Required'
    ],
    [
        412,
        'Precondition Failed'
    ],
    [
        413,
        'Payload Too Large'
    ],
    [
        414,
        'URI Too Long'
    ],
    [
        415,
        'Unsupported Media Type'
    ],
    [
        416,
        'Requested range not satisfiable'
    ],
    [
        417,
        'Expectation Failed'
    ],
    [
        418,
        "I'm a teapot"
    ],
    [
        422,
        'Unprocessable Entity'
    ],
    [
        423,
        'Locked'
    ],
    [
        424,
        'Failed Dependency'
    ],
    [
        425,
        'Too Early'
    ],
    [
        426,
        'Upgrade Required'
    ],
    [
        428,
        'Precondition Required'
    ],
    [
        429,
        'Too Many Requests'
    ],
    [
        431,
        'Request Header Fields Too Large'
    ],
    [
        451,
        'Unavailable For Legal Reasons'
    ],
    [
        500,
        'Internal Server Error'
    ],
    [
        501,
        'Not Implemented'
    ],
    [
        502,
        'Bad Gateway'
    ],
    [
        503,
        'Service Unavailable'
    ],
    [
        504,
        'Gateway Timeout'
    ],
    [
        505,
        'HTTP Version not supported'
    ],
    [
        506,
        'Variant Also Negotiates'
    ],
    [
        507,
        'Insufficient Storage'
    ],
    [
        508,
        'Loop Detected'
    ],
    [
        509,
        'Bandwidth Limit Exceeded'
    ],
    [
        510,
        'Not Extended'
    ],
    [
        511,
        'Network Authentication Required'
    ],
    [
        -1,
        'Unknown Status'
    ]
]);

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5EkXo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sendEvents", function() {
    return sendEvents;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _memoizeOne = require("memoize-one");
var _memoizeOneDefault = parcelHelpers.interopDefault(_memoizeOne);
var _types = require("./types");
var sendEvents = function(options) {
    return (0, _asyncToGenerator._)(function() {
        var _createOrGetAbortController, signal, corsOptions, response, responseBody, e;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    signal = (_createOrGetAbortController = createOrGetAbortController(options)) === null || _createOrGetAbortController === void 0 ? void 0 : _createOrGetAbortController.signal;
                    corsOptions = getCorsForUrl(options.url);
                    return [
                        4,
                        fetch(options.url, (0, _objectSpread._)({
                            method: 'POST',
                            // Content-type has to be text/plain in order to prevent unnecessary `OPTIONS` requests.
                            headers: {
                                'Content-Type': 'text/plain'
                            },
                            body: JSON.stringify(options.batch),
                            signal: signal
                        }, corsOptions))
                    ];
                case 1:
                    response = _state.sent();
                    if (response.status !== 200) throw new (0, _types.FetchError)("HTTP Error ".concat(response.status, " (").concat(response.statusText, ")"), response.status, response.statusText);
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        response.clone().json()
                    ];
                case 3:
                    responseBody = _state.sent();
                    if (responseBody.success === true) return [
                        2,
                        response
                    ];
                    return [
                        3,
                        5
                    ];
                case 4:
                    e = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 5:
                    throw new (0, _types.FetchError)('Invalid HTTP Response (Invalid response body)', 200, 'Invalid response body');
            }
        });
    })();
};
var createOrGetAbortController = function(options) {
    if (options.abortController) return options.abortController;
    else if (options.timeout) {
        var abortController = new AbortController();
        // After a fetch has completed, calling abort is ignored.
        setTimeout(function() {
            abortController.abort();
        }, options.timeout);
        return abortController;
    }
    return undefined;
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
var getCorsForUrl = (0, _memoizeOneDefault.default)(function(url) {
    var origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: 'cors',
        credentials: 'include'
    };
});

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_ts_generator":"78Tqx","memoize-one":"5rJro","./types":"iaCPD","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9uV6H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return User;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _differenceInDays = require("date-fns/differenceInDays");
var _differenceInDaysDefault = parcelHelpers.interopDefault(_differenceInDays);
var _cookie = require("../cookie");
var _cookieDefault = parcelHelpers.interopDefault(_cookie);
var _safeLocalStorage = require("../storage/SafeLocalStorage");
var _safeLocalStorageDefault = parcelHelpers.interopDefault(_safeLocalStorage);
var _uuid = require("../uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
// Cookie is stale, if anonymousId was generated 7 days ago.
var ANONYMOUS_ID_COOKIE_STALE_DAYS = 7;
var SAFE = 'SAFE';
var UNSAFE = 'UNSAFE';
var NOT_FOUND = 'NOT_FOUND';
var COOKIE = 'COOKIE';
var LOCAL_STORAGE = 'LOCAL_STORAGE';
var User = /*#__PURE__*/ function() {
    "use strict";
    function User(disableCookiePersistence) {
        (0, _classCallCheck._)(this, User);
        this.store = new (0, _safeLocalStorageDefault.default)({
            useStoragePrefix: false
        });
        this.cookie = new (0, _cookieDefault.default)(disableCookiePersistence);
    }
    (0, _createClass._)(User, [
        {
            key: "getUserId",
            value: function getUserId() {
                return this.userId || null;
            }
        },
        {
            key: "setUserId",
            value: function setUserId(userId) {
                this.userId = userId;
            }
        },
        {
            key: "getAnonymousId",
            value: function getAnonymousId(customAnonymousIdGenerator) {
                /**
		 * Prefer localStorage as there cant be duplicate keys, and its faster. Also update cookie, if stale.
		 * If not set in localStorage, check cookies. Also set localStorage for future attempts.
		 * If not in cookies, generate a new one. Set both cookie and localStorage keys.
		 */ return this.getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() || this.getAnonymousIdFromCookieAndUpdateLocalStorage() || this.generateNewAnonymousId(customAnonymousIdGenerator);
            }
        },
        {
            key: "setAnonymousId",
            value: function setAnonymousId(anonymousId) {
                var stringifyAnonymosId = JSON.stringify(anonymousId);
                this.cookie.set((0, _cookie.AWCCookiesKeys).AJS_ANONYMOUS_ID, stringifyAnonymosId);
                this.lastAnonymousIdCookieUpdate = Date.now();
                return this.store.setItem((0, _cookie.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), stringifyAnonymosId);
            }
        },
        {
            key: "getAnonymousIdFromStorage",
            value: function getAnonymousIdFromStorage(source) {
                var rawStorageAnonidValue = source === LOCAL_STORAGE ? this.store.getItem((0, _cookie.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey()) : this.cookie.get((0, _cookie.AWCCookiesKeys).AJS_ANONYMOUS_ID);
                if (rawStorageAnonidValue) {
                    var unsafeValue = {
                        type: UNSAFE,
                        anonymousId: rawStorageAnonidValue
                    };
                    try {
                        var parsedAnonId = JSON.parse(rawStorageAnonidValue);
                        if (parsedAnonId && typeof parsedAnonId === 'string') return {
                            type: SAFE,
                            anonymousId: parsedAnonId
                        };
                        return unsafeValue;
                    } catch (e) {
                        /*
				 * Segments new Analytics-next client will store strings as strings without stringifing.
				 * The legacy Segment client and AWC always stringify and parse cookies and values.
				 * If the new Segment analytics-client stores a cookie and local storage value first, it will
				 * breaking old clients.
				 *
				 * Additionally, JSON.parse can cause exceptions to be thrown in some browsers; see AAP-324.
				 *
				 * Intentionally swalling errors here and returning the original value found in storage to avoid ping-pong.
				 */ return unsafeValue;
                    }
                }
                return {
                    type: NOT_FOUND
                };
            }
        },
        {
            key: "getAnonymousIdFromLocalStorageAndUpdateCookieIfStale",
            value: function getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() {
                var localStorageValue = this.getAnonymousIdFromStorage(LOCAL_STORAGE);
                var shouldUpdateCookie = false;
                if (!this.lastAnonymousIdCookieUpdate || (0, _differenceInDaysDefault.default)(new Date(), new Date(this.lastAnonymousIdCookieUpdate)) >= ANONYMOUS_ID_COOKIE_STALE_DAYS) shouldUpdateCookie = true;
                switch(localStorageValue.type){
                    case SAFE:
                        if (shouldUpdateCookie) this.setAnonymousId(localStorageValue.anonymousId);
                        return localStorageValue.anonymousId;
                    case UNSAFE:
                        return localStorageValue.anonymousId;
                    case NOT_FOUND:
                    default:
                        return null;
                }
            }
        },
        {
            key: "getAnonymousIdFromCookieAndUpdateLocalStorage",
            value: function getAnonymousIdFromCookieAndUpdateLocalStorage() {
                var cookieValue = this.getAnonymousIdFromStorage(COOKIE);
                switch(cookieValue.type){
                    case SAFE:
                    case UNSAFE:
                        this.store.setItem((0, _cookie.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), JSON.stringify(cookieValue.anonymousId));
                        return cookieValue.anonymousId;
                    case NOT_FOUND:
                    default:
                        return null;
                }
            }
        },
        {
            key: "generateNewAnonymousId",
            value: function generateNewAnonymousId(customAnonymousIdGenerator) {
                var generator = typeof customAnonymousIdGenerator === 'function' ? customAnonymousIdGenerator : function() {
                    return (0, _uuidDefault.default)();
                };
                var newAnonId = generator();
                this.setAnonymousId(newAnonId);
                return newAnonId;
            }
        }
    ]);
    return User;
}();

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","date-fns/differenceInDays":"ll6Hh","../cookie":"5MOfC","../storage/SafeLocalStorage":"lSDeu","../uuid":"gL2xH","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ll6Hh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return differenceInDays;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../differenceInCalendarDays/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require // Like `compareAsc` but uses local time not UTC, which is needed
("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
function differenceInDays(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault2.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    var sign = compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, _indexJsDefault1.default)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number(compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

},{"../toDate/index.js":"cZAgO","../differenceInCalendarDays/index.js":"6D8SH","../_lib/requiredArgs/index.js":"hXH6a","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cZAgO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return toDate;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function toDate(argument) {
    (0, _indexJsDefault.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if ((0, _instanceof._)(argument, Date) || (0, _typeofDefault.default)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

},{"@swc/helpers/_/_instanceof":"h9UKc","@babel/runtime/helpers/esm/typeof":"jvCfw","../_lib/requiredArgs/index.js":"hXH6a","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hXH6a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return requiredArgs;
});
function requiredArgs(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6D8SH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return differenceInCalendarDays;
});
var _indexJs = require("../_lib/getTimezoneOffsetInMilliseconds/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfDay/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var MILLISECONDS_IN_DAY = 86400000;
function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault2.default)(2, arguments);
    var startOfDayLeft = (0, _indexJsDefault1.default)(dirtyDateLeft);
    var startOfDayRight = (0, _indexJsDefault1.default)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, _indexJsDefault.default)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, _indexJsDefault.default)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}

},{"../_lib/getTimezoneOffsetInMilliseconds/index.js":"5EVhm","../startOfDay/index.js":"agpXm","../_lib/requiredArgs/index.js":"hXH6a","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5EVhm":[function(require,module,exports,__globalThis) {
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getTimezoneOffsetInMilliseconds;
});
function getTimezoneOffsetInMilliseconds(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"agpXm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return startOfDay;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfDay(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{"../toDate/index.js":"cZAgO","../_lib/requiredArgs/index.js":"hXH6a","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5MOfC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return 0, _cookieWrapperDefault.default;
});
parcelHelpers.export(exports, "AllAnalyticsCookies", function() {
    return 0, _allAnalyticsCookies.AllAnalyticsCookies;
});
parcelHelpers.export(exports, "AWCCookiesKeys", function() {
    return 0, _allAnalyticsCookies.AWCCookiesKeys;
});
var _cookieWrapper = require("./cookieWrapper");
var _cookieWrapperDefault = parcelHelpers.interopDefault(_cookieWrapper);
var _allAnalyticsCookies = require("./AllAnalyticsCookies");

},{"./cookieWrapper":"eH8zu","./AllAnalyticsCookies":"e6wMv","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eH8zu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return CookieWrapper;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsCookie = require("js-cookie");
var _jsCookieDefault = parcelHelpers.interopDefault(_jsCookie);
var _allAnalyticsCookies = require("./AllAnalyticsCookies");
var _localStorageAlt = require("./localStorageAlt");
var _localStorageAltDefault = parcelHelpers.interopDefault(_localStorageAlt);
var _util = require("./util");
var CookieWrapper = /*#__PURE__*/ function() {
    "use strict";
    function CookieWrapper(disableCookiePersistence) {
        (0, _classCallCheck._)(this, CookieWrapper);
        this.cookieLike = (0, _util.canUseCookie)(disableCookiePersistence) ? (0, _jsCookieDefault.default) : new (0, _localStorageAltDefault.default)();
    }
    (0, _createClass._)(CookieWrapper, [
        {
            key: "set",
            value: function set(name, value, options) {
                // no-op
                if (!(0, _allAnalyticsCookies.AllAnalyticsCookies)[name]) {
                    // eslint-disable-next-line no-console
                    console.warn("Unknown cookie key ".concat(name, " provided, not set."));
                    return;
                }
                return this.cookieLike.set((0, _allAnalyticsCookies.AllAnalyticsCookies)[name].getKey(), value, (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _allAnalyticsCookies.AllAnalyticsCookies)[name].getAttributes()), {
                    // Function is memoized so we only calculate this once per page load
                    domain: (0, _util.getTld)()
                }), options));
            }
        },
        {
            key: "get",
            value: function get(name) {
                if (!(0, _allAnalyticsCookies.AllAnalyticsCookies)[name]) {
                    // eslint-disable-next-line no-console
                    console.warn("Unknown cookie key ".concat(name, " provided, not fetched."));
                    return;
                }
                return this.cookieLike.get((0, _allAnalyticsCookies.AllAnalyticsCookies)[name].getKey());
            }
        },
        {
            key: "remove",
            value: function remove(name, options) {
                if (!(0, _allAnalyticsCookies.AllAnalyticsCookies)[name]) {
                    // eslint-disable-next-line no-console
                    console.warn("Unknown cookie key ".concat(name, " provided, not removed."));
                    return;
                }
                this.cookieLike.remove((0, _allAnalyticsCookies.AllAnalyticsCookies)[name].getKey(), (0, _objectSpread._)({}, options));
            }
        }
    ]);
    return CookieWrapper;
}();

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","js-cookie":"kEATS","./AllAnalyticsCookies":"e6wMv","./localStorageAlt":"3iNpu","./util":"6C00w","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kEATS":[function(require,module,exports,__globalThis) {
/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */ (function(factory) {
    var registeredInModuleLoader;
    if (typeof define === 'function' && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    module.exports = factory();
    registeredInModuleLoader = true;
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function() {
    function extend() {
        var i = 0;
        var result = {};
        for(; i < arguments.length; i++){
            var attributes = arguments[i];
            for(var key in attributes)result[key] = attributes[key];
        }
        return result;
    }
    function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
        function api() {}
        function set(key, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = extend({
                path: '/'
            }, api.defaults, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
            try {
                var result = JSON.stringify(value);
                if (/^[\{\[]/.test(result)) value = result;
            } catch (e) {}
            value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
            key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = key + '=' + value + stringifiedAttributes;
        }
        function get(key, json) {
            if (typeof document === 'undefined') return;
            var jar = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var i = 0;
            for(; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var cookie = parts.slice(1).join('=');
                if (!json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                try {
                    var name = decode(parts[0]);
                    cookie = (converter.read || converter)(cookie, name) || decode(cookie);
                    if (json) try {
                        cookie = JSON.parse(cookie);
                    } catch (e) {}
                    jar[name] = cookie;
                    if (key === name) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        api.set = set;
        api.get = function(key) {
            return get(key, false);
        };
        api.getJSON = function(key) {
            return get(key, true);
        };
        api.remove = function(key, attributes) {
            set(key, '', extend(attributes, {
                expires: -1
            }));
        };
        api.defaults = {};
        api.withConverter = init;
        return api;
    }
    return init(function() {});
});

},{}],"e6wMv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWCCookiesKeys", function() {
    return AWCCookiesKeys;
});
parcelHelpers.export(exports, "AllAnalyticsCookies", function() {
    return AllAnalyticsCookies;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var AWCCookiesKeys = /*#__PURE__*/ function(AWCCookiesKeys) {
    AWCCookiesKeys["AWC_TLD_TEST"] = "AWC_TLD_TEST";
    AWCCookiesKeys["AWC_ANALYTICS_DEBUG"] = "AWC_ANALYTICS_DEBUG";
    AWCCookiesKeys["AJS_ANONYMOUS_ID"] = "AJS_ANONYMOUS_ID";
    return AWCCookiesKeys;
}({});
var CookieSchema = /*#__PURE__*/ function() {
    "use strict";
    function CookieSchema(key, options) {
        (0, _classCallCheck._)(this, CookieSchema);
        this.key = key;
        this.options = options;
    }
    (0, _createClass._)(CookieSchema, [
        {
            key: "getAttributes",
            value: function getAttributes() {
                return this.options;
            }
        },
        {
            key: "getKey",
            value: function getKey() {
                return this.key;
            }
        }
    ]);
    return CookieSchema;
}();
var isSecure = function() {
    try {
        return globalThis && globalThis.location && globalThis.location.protocol === 'https:';
    } catch (err) {
        return false;
    }
};
var _obj;
var AllAnalyticsCookies = (_obj = {}, (0, _defineProperty._)(_obj, "AWC_TLD_TEST", new CookieSchema('__awc_tld_test__', {
    expires: 365,
    secure: isSecure(),
    path: '/'
})), (0, _defineProperty._)(_obj, "AWC_ANALYTICS_DEBUG", new CookieSchema('atlassian_analytics_debug', {
    expires: 365,
    secure: isSecure(),
    path: '/'
})), (0, _defineProperty._)(_obj, "AJS_ANONYMOUS_ID", new CookieSchema('ajs_anonymous_id', {
    expires: 365,
    secure: isSecure(),
    path: '/'
})), _obj);

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_define_property":"e80IS","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3iNpu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return LocalStorageAlt;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _safeLocalStorage = require("../storage/SafeLocalStorage");
var _safeLocalStorageDefault = parcelHelpers.interopDefault(_safeLocalStorage);
var LocalStorageAlt = /*#__PURE__*/ function() {
    "use strict";
    function LocalStorageAlt() {
        (0, _classCallCheck._)(this, LocalStorageAlt);
        this.safeStorage = new (0, _safeLocalStorageDefault.default)({
            useStoragePrefix: false
        });
    }
    (0, _createClass._)(LocalStorageAlt, [
        {
            key: "set",
            value: function set(name, value) {
                this.safeStorage.setItem(name, value);
                return value;
            }
        },
        {
            key: "get",
            value: function get(name) {
                var value = this.safeStorage.getItem(name);
                return value || undefined;
            }
        },
        {
            key: "remove",
            value: function remove(name) {
                this.safeStorage.removeItem(name);
            }
        }
    ]);
    return LocalStorageAlt;
}();

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","../storage/SafeLocalStorage":"lSDeu","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lSDeu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// eslint-disable-next-line import/no-anonymous-default-export
parcelHelpers.export(exports, "default", function() {
    return _class;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _inherits = require("@swc/helpers/_/_inherits");
var _inMemoryStorage = require("./InMemoryStorage");
var _inMemoryStorageDefault = parcelHelpers.interopDefault(_inMemoryStorage);
var _safeStorage = require("./SafeStorage");
var _safeStorageDefault = parcelHelpers.interopDefault(_safeStorage);
var _class = /*#__PURE__*/ function(SafeStorage) {
    "use strict";
    (0, _inherits._)(_class, SafeStorage);
    function _class(options) {
        (0, _classCallCheck._)(this, _class);
        var storageToUse;
        try {
            storageToUse = globalThis.localStorage || (0, _inMemoryStorageDefault.default);
        } catch (err) {
            storageToUse = (0, _inMemoryStorageDefault.default);
        }
        return (0, _callSuper._)(this, _class, [
            storageToUse,
            options
        ]);
    }
    return _class;
}((0, _safeStorageDefault.default));

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_inherits":"2sfqW","./InMemoryStorage":"e2Hlk","./SafeStorage":"04ZCw","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"e2Hlk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InMemoryStore", function() {
    return InMemoryStore;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var InMemoryStore = function InMemoryStore() {
    "use strict";
    var _this = this;
    (0, _classCallCheck._)(this, InMemoryStore);
    this._data = {};
    this.length = 0;
    this.setItem = function(key, value) {
        _this._data[key] = value;
        _this.length = Object.keys(_this._data).length;
        return value;
    };
    this.getItem = function(key) {
        if (key in _this._data) return _this._data[key];
        return null;
    };
    this.removeItem = function(key) {
        if (key in _this._data) delete _this._data[key];
        _this.length = Object.keys(_this._data).length;
        return null;
    };
    this.clear = function() {
        _this._data = {};
        _this.length = 0;
    };
    this.key = function(index) {
        return Object.keys(_this._data)[index];
    };
};
// eslint-disable-next-line import/no-anonymous-default-export
var inmemorystorage = new InMemoryStore();
exports.default = inmemorystorage;

},{"@swc/helpers/_/_class_call_check":"5CNCO","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"04ZCw":[function(require,module,exports,__globalThis) {
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWC_STORAGE_PREFIX", function() {
    return AWC_STORAGE_PREFIX;
});
parcelHelpers.export(exports, "GLOBAL_IN_MEMORY_NAME", function() {
    return GLOBAL_IN_MEMORY_NAME;
});
parcelHelpers.export(exports, "isSupported", function() {
    return isSupported;
});
parcelHelpers.export(exports, "default", function() {
    return SafeStorage;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _analyticsWebTypes = require("../analyticsWebTypes");
var _inMemoryStorage = require("./InMemoryStorage");
var _inMemoryStorageDefault = parcelHelpers.interopDefault(_inMemoryStorage);
var AWC_STORAGE_PREFIX = 'awc';
var GLOBAL_IN_MEMORY_NAME = 'awcInMemoryStorageFallback';
function isSupported(store) {
    var TEST_VALUE = 'test_value';
    if (!store) return false;
    try {
        var key = 'awc.storage.support';
        store.setItem(key, TEST_VALUE);
        var value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}
var SafeStorage = function SafeStorage(storageToUse) {
    "use strict";
    var _this = this;
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    (0, _classCallCheck._)(this, SafeStorage);
    this.getStore = function() {
        return _this._store;
    };
    this.getItem = function(key) {
        return _this._store.getItem(_this.createKey(key));
    };
    this.removeItem = function(key) {
        return _this._store.removeItem(_this.createKey(key));
    };
    this.setItem = function(key, value) {
        try {
            _this._store.setItem(_this.createKey(key), value);
        } catch (err) {
            // Theoretically should only be QuotaExceededError, but keeping 'err' generic
            // https://developer.mozilla.org/en-US/docs/Web/API/Storage/setItem
            _this.swapToInMemory();
            _this._store.setItem(_this.createKey(key), value);
        }
    };
    this.swapToInMemory = function() {
        if (_this._store === (0, _inMemoryStorageDefault.default) || typeof globalThis === 'undefined') return;
        var keys = Object.keys(_this._store || {});
        var inMemoryStorage;
        if (isSupported(globalThis[GLOBAL_IN_MEMORY_NAME])) inMemoryStorage = globalThis[GLOBAL_IN_MEMORY_NAME];
        else {
            inMemoryStorage = (0, _inMemoryStorageDefault.default);
            if (!globalThis[GLOBAL_IN_MEMORY_NAME]) // If not already attached to globalThis then attach our instance of InMemoryStorage
            // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
            // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
            globalThis[GLOBAL_IN_MEMORY_NAME] = (0, _inMemoryStorageDefault.default);
        }
        keys.forEach(function(key) {
            if (key.indexOf(_this.getPrefix()) === 0) {
                var value = _this._store.getItem(key);
                if (value) inMemoryStorage.setItem(key, value);
            }
        });
        _this._store = inMemoryStorage;
    };
    this.clear = function() {
        return _this._store.clear();
    };
    this.key = function(index) {
        return _this._store.key(index);
    };
    this.getPrefix = function() {
        return _this._prefix;
    };
    this.createKey = function(key) {
        if (_this._prefix) return "".concat(_this.getPrefix(), ".").concat(key);
        return key;
    };
    this.options = options;
    var prefixes = [];
    if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push(AWC_STORAGE_PREFIX);
    if (options.envPrefix && options.envPrefix !== (0, _analyticsWebTypes.envType).PROD) prefixes.push(options.envPrefix);
    this._prefix = prefixes.join('-');
    if (isSupported(storageToUse)) this._store = storageToUse;
    else this.swapToInMemory();
};

},{"@swc/helpers/_/_class_call_check":"5CNCO","../analyticsWebTypes":"iDbK2","./InMemoryStorage":"e2Hlk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6C00w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "canUseCookie", function() {
    return canUseCookie;
});
parcelHelpers.export(exports, "COOKIE_NAME", function() {
    return COOKIE_NAME;
});
parcelHelpers.export(exports, "COOKIE_VALUE", function() {
    return COOKIE_VALUE;
});
parcelHelpers.export(exports, "getTld", function() {
    return getTld;
});
var _jsCookie = require("js-cookie");
var _jsCookieDefault = parcelHelpers.interopDefault(_jsCookie);
var _memoizeOne = require("memoize-one");
var _memoizeOneDefault = parcelHelpers.interopDefault(_memoizeOne);
var _allAnalyticsCookies = require("./AllAnalyticsCookies");
var canUseCookie = function() {
    var disableCookiePersistence = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    if (disableCookiePersistence) return false;
    return !(location.protocol === 'file:' || location.protocol === 'chrome-extension:');
};
var COOKIE_NAME = (0, _allAnalyticsCookies.AllAnalyticsCookies).AWC_TLD_TEST.getKey();
var COOKIE_VALUE = 'tld_test';
var getTld = (0, _memoizeOneDefault.default)(function() {
    if (typeof location === 'undefined') return '';
    var hostname = location.hostname;
    var splitHostname = hostname.split('.');
    for(var i = 1; i <= splitHostname.length; i++){
        var domainParts = splitHostname.slice(i * -1);
        var domain = ".".concat(domainParts.join('.'));
        (0, _jsCookieDefault.default).set(COOKIE_NAME, COOKIE_VALUE, {
            domain: domain
        });
        if ((0, _jsCookieDefault.default).get(COOKIE_NAME) === COOKIE_VALUE) {
            (0, _jsCookieDefault.default).remove(COOKIE_NAME, {
                domain: domain
            });
            return domain;
        }
    }
    return hostname;
});

},{"js-cookie":"kEATS","memoize-one":"5rJro","./AllAnalyticsCookies":"e6wMv","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ibHGi":[function(require,module,exports,__globalThis) {
// @ts-ignore
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildContext", function() {
    return buildContext;
});
parcelHelpers.export(exports, "prepareEventContext", function() {
    return prepareEventContext;
});
parcelHelpers.export(exports, "prepareEventProperties", function() {
    return prepareEventProperties;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _typeOf = require("@swc/helpers/_/_type_of");
var _isodateTraverse = require("@segment/isodate-traverse");
var _isodateTraverseDefault = parcelHelpers.interopDefault(_isodateTraverse);
var buildContext = function(context, overrides) {
    var result = (0, _objectSpreadProps._)((0, _objectSpread._)({}, context.context), {
        userAgent: navigator.userAgent
    });
    // use nestedRemoveUndefinedValues to strip undefined properties before
    // spreading the override object since we want properties that explicitly
    // set to 'undefined' to not overwrite any values, just like properties
    // that are 'undefined' because they're not set at all will.
    if (overrides === null || overrides === void 0 ? void 0 : overrides.excludedProperties) result.excludedProperties = (0, _objectSpread._)({}, result.excludedProperties, nestedRemoveUndefinedValues(overrides.excludedProperties, '$.excludedProperties'));
    if (overrides === null || overrides === void 0 ? void 0 : overrides.userConsents) result.userConsents = (0, _objectSpread._)({}, result.userConsents, nestedRemoveUndefinedValues(overrides.userConsents, '$.userConsents'));
    // Remove any falsey properties since we only want to have exclusions
    // that were explicitly declared as excluded.
    if (result.excludedProperties) result.excludedProperties = removeFalseyProperties(result.excludedProperties);
    return result;
};
var prepareEventContext = function(context) {
    var propertiesWithoutUndefined = nestedRemoveUndefinedValues(context, '$.context');
    return (0, _isodateTraverseDefault.default)(propertiesWithoutUndefined);
};
var prepareEventProperties = function(properties) {
    var propertiesWithoutUndefined = nestedRemoveUndefinedValues(properties, '$.properties');
    // Remove any override properties that shouldn't be included in the event body
    delete propertiesWithoutUndefined.excludedProperties;
    delete propertiesWithoutUndefined.userConsents;
    return (0, _isodateTraverseDefault.default)(propertiesWithoutUndefined);
};
// Shallow removal of all falsey properties from an object, returning a new object.
var removeFalseyProperties = function(obj) {
    var result = {};
    for(var key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) // If the value is not strictly true, map it to undefined
        {
            if (obj[key]) result[key] = obj[key];
        }
    }
    return result;
};
// This function will essentially deepClone as well
var nestedRemoveUndefinedValues = function(obj, path) {
    var recursionDepthLimit = 512;
    var nestedRemoveUndefinedValuesImpl = function(source, processedReferences, path, depth) {
        if (source === null || (typeof source === "undefined" ? "undefined" : (0, _typeOf._)(source)) !== 'object') return source;
        // If the level of nesting is egregiously excessive we'll stop processing any further to
        // avoid crashing due to stack exhaustion, instead we return a note object.
        if (depth > recursionDepthLimit) return {
            _depthLimitExceeded: true,
            message: "Object nesting depth limit exceeded at path '".concat(path, "' with depth '").concat(depth, "'")
        };
        // If this object has already been seen then processing it would create a circular reference,
        // instead we return a note object.
        if (processedReferences.has(source)) {
            var originalPath = processedReferences.get(source);
            return {
                _circularReference: true,
                message: "Circular reference to object at original path '".concat(originalPath, "' detected at path '").concat(path, "'"),
                originalPath: originalPath
            };
        }
        processedReferences.set(source, path);
        var clone = {};
        Object.keys(source).forEach(function(key) {
            var value = source[key];
            if (value !== undefined) {
                if (Array.isArray(value)) {
                    var newArray = [];
                    value.forEach(function(v, i) {
                        var newValue = nestedRemoveUndefinedValuesImpl(v, processedReferences, "".concat(path, ".").concat(key, "[").concat(i, "]"), depth + 1);
                        if (newValue !== undefined) newArray.push(newValue);
                    });
                    clone[key] = newArray;
                } else {
                    var newValue = nestedRemoveUndefinedValuesImpl(value, processedReferences, "".concat(path, ".").concat(key), depth + 1);
                    if (newValue !== undefined) clone[key] = newValue;
                }
            }
        });
        processedReferences.delete(source);
        return clone;
    };
    return nestedRemoveUndefinedValuesImpl(obj, new Map(), path, 0);
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_type_of":"iFJdx","@segment/isodate-traverse":"9wK1R","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9wK1R":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var isodate = require("b6877ceeddde8e9c");
/**
 * Expose `traverse`.
 */ module.exports = traverse;
/**
 * Recursively traverse an object or array, and convert
 * all ISO date strings parse into Date objects.
 *
 * @param {Object} input - object, array, or string to convert
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function traverse(input, strict) {
    if (strict === undefined) strict = true;
    if (input && (typeof input === "undefined" ? "undefined" : (0, _typeOf._)(input)) === 'object') return traverseObject(input, strict);
    else if (Array.isArray(input)) return traverseArray(input, strict);
    else if (isodate.is(input, strict)) return isodate.parse(input);
    return input;
}
/**
 * Object traverser helper function.
 *
 * @param {Object} obj - object to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function traverseObject(obj, strict) {
    Object.keys(obj).forEach(function(key) {
        obj[key] = traverse(obj[key], strict);
    });
    return obj;
}
/**
 * Array traverser helper function
 *
 * @param {Array} arr - array to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Array}
 */ function traverseArray(arr, strict) {
    arr.forEach(function(value, index) {
        arr[index] = traverse(value, strict);
    });
    return arr;
}

},{"@swc/helpers/_/_type_of":"iFJdx","b6877ceeddde8e9c":"kdUmX"}],"kdUmX":[function(require,module,exports,__globalThis) {
'use strict';
/**
 * Matcher, slightly modified from:
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 */ var matcher = /^(\d{4})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:([ T])(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
/**
 * Convert an ISO date string to a date. Fallback to native `Date.parse`.
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 *
 * @param {String} iso
 * @return {Date}
 */ exports.parse = function(iso) {
    var numericKeys = [
        1,
        5,
        6,
        7,
        11,
        12
    ];
    var arr = matcher.exec(iso);
    var offset = 0;
    // fallback to native parsing
    if (!arr) return new Date(iso);
    /* eslint-disable no-cond-assign */ // remove undefined values
    for(var i = 0, val; val = numericKeys[i]; i++)arr[val] = parseInt(arr[val], 10) || 0;
    /* eslint-enable no-cond-assign */ // allow undefined days and months
    arr[2] = parseInt(arr[2], 10) || 1;
    arr[3] = parseInt(arr[3], 10) || 1;
    // month is 0-11
    arr[2]--;
    // allow abitrary sub-second precision
    arr[8] = arr[8] ? (arr[8] + '00').substring(0, 3) : 0;
    // apply timezone if one exists
    if (arr[4] === ' ') offset = new Date().getTimezoneOffset();
    else if (arr[9] !== 'Z' && arr[10]) {
        offset = arr[11] * 60 + arr[12];
        if (arr[10] === '+') offset = 0 - offset;
    }
    var millis = Date.UTC(arr[1], arr[2], arr[3], arr[5], arr[6] + offset, arr[7], arr[8]);
    return new Date(millis);
};
/**
 * Checks whether a `string` is an ISO date string. `strict` mode requires that
 * the date string at least have a year, month and date.
 *
 * @param {String} string
 * @param {Boolean} strict
 * @return {Boolean}
 */ exports.is = function(string, strict) {
    if (typeof string !== 'string') return false;
    if (strict && /^\d{4}-\d{2}-\d{2}/.test(string) === false) return false;
    return matcher.test(string);
};

},{}],"hIjKw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MetadataClient", function() {
    return MetadataClient;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _networkStatus = require("../resilienceQueue/NetworkStatus");
var _networkStatusDefault = parcelHelpers.interopDefault(_networkStatus);
var _pullBatchableQueue = require("../resilienceQueue/PullBatchableQueue");
var _scheduler = require("../resilienceQueue/scheduler");
var _schedulerDefault = parcelHelpers.interopDefault(_scheduler);
var _types = require("../resilienceQueue/types");
var _selectHost = require("../selectHost");
var _testSupport = require("../util/testSupport");
var _defaults = require("./defaults");
var _fetchMetadata = require("./fetchMetadata");
var _types1 = require("./types");
var MetadataClient = /*#__PURE__*/ function() {
    "use strict";
    function MetadataClient(apiHostProtocol, apiHost, product) {
        (0, _classCallCheck._)(this, MetadataClient);
        this._userInfo = {
            anonymousId: ''
        };
        this._tenantInfo = {};
        this._url = "".concat(apiHostProtocol, "://").concat(apiHost, "/metadata");
        this._product = product;
        this._metadataInfo = null;
        this._requestStatus = 'PENDING';
        this._lastFetchRequestCount = 0;
        this._lastErrorReason = null;
        this._fetchAbortController = null;
        this._hasBeenStopped = false;
        this._isEnabled = false;
        this._propertyChangeRefreshTimeout = null;
        var isStargateProxy = (0, _selectHost.isStargateProxyPath)({
            apiHost: apiHost
        });
        this._metadataHost = isStargateProxy ? 'PRODUCT_HOST' : apiHost;
        this._options = this.buildOptions({
            backoffFactor: 2,
            backoffJitterPercentage: 0.8,
            flushBeforeUnload: false,
            flushWaitMs: 500,
            maxAttempts: 10,
            minRetryDelay: (0, _defaults.DEFAULT_METADATA_MIN_RETRY_DELAY),
            maxRetryDelay: (0, _defaults.DEFAULT_METADATA_MAX_RETRY_DELAY)
        });
        this._scheduler = new (0, _schedulerDefault.default)((0, _objectSpreadProps._)((0, _objectSpread._)({}, this._options), {
            waitInterval: (0, _defaults.DEFAULT_METADATA_REFRESH_INTERVAL)
        }), this.scheduleCallback.bind(this));
        this._networkStatus = null;
    }
    (0, _createClass._)(MetadataClient, [
        {
            key: "start",
            value: /**
	 * Starts the metadata client. This will start the scheduler and begin
	 * fetching metadata.
	 *
	 * @param allowRestart - If false, the client will not be restarted if it has already been stopped
	 *						 by a call to stop().
	 */ function start(allowRestart) {
                var _this = this;
                if (this._isEnabled || this._hasBeenStopped && !allowRestart) return;
                this._isEnabled = true;
                this.startNetworkStatusMonitor();
                setTimeout(function() {
                    _this._scheduler.schedule({
                        immediate: true
                    });
                }, MetadataClient.INITIAL_REFRESH_DELAY);
            }
        },
        {
            key: "stop",
            value: function stop() {
                var _this__fetchAbortController;
                if (!this._isEnabled) return;
                this._hasBeenStopped = true;
                this._isEnabled = false;
                this.stopNetworkStatusMonitor();
                this._scheduler.stop();
                (_this__fetchAbortController = this._fetchAbortController) === null || _this__fetchAbortController === void 0 ? void 0 : _this__fetchAbortController.abort();
                this.resetPropertyChangeRefresh();
            }
        },
        {
            key: "startNetworkStatusMonitor",
            value: function startNetworkStatusMonitor() {
                var _this = this;
                if (this._networkStatus) return;
                this._networkStatus = new (0, _networkStatusDefault.default)(function(status) {
                    if (status === (0, _types.NetworkStatusEnum).OFFLINE) _this._scheduler.stop();
                    else if (_this._isEnabled) _this._scheduler.schedule({
                        immediate: _this._metadataInfo === null
                    });
                });
            }
        },
        {
            key: "stopNetworkStatusMonitor",
            value: function stopNetworkStatusMonitor() {
                if (this._networkStatus) {
                    this._networkStatus.removeListeners();
                    this._networkStatus = null;
                }
            }
        },
        {
            key: "refreshMetadataAsync",
            value: function refreshMetadataAsync() {
                return (0, _asyncToGenerator._)(function() {
                    var _this, _this__fetchAbortController, fetchAbortSignal;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                if ((0, _testSupport.TestSupport).areFetchCallsDisabled() || !this._isEnabled) return [
                                    2,
                                    Promise.resolve()
                                ];
                                (_this__fetchAbortController = this._fetchAbortController) === null || _this__fetchAbortController === void 0 ? void 0 : _this__fetchAbortController.abort();
                                this._fetchAbortController = new AbortController();
                                fetchAbortSignal = this._fetchAbortController.signal;
                                this._lastFetchRequestCount = this._scheduler.getFailureCount();
                                return [
                                    4,
                                    (0, _fetchMetadata.fetchMetadata)(this._url, {
                                        product: this._product,
                                        userInfo: this._userInfo,
                                        tenantInfo: this._tenantInfo
                                    }, (0, _defaults.DEFAULT_METADATA_REQUEST_TIMEOUT), fetchAbortSignal).then(function(response) {
                                        return (0, _asyncToGenerator._)(function() {
                                            var metadata;
                                            return (0, _tsGenerator._)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        return [
                                                            4,
                                                            response.json()
                                                        ];
                                                    case 1:
                                                        metadata = _state.sent();
                                                        this._metadataInfo = (0, _types1.MetadataResponse).fromJson(metadata);
                                                        this._lastFetchRequestCount++;
                                                        this._requestStatus = 'FETCHED';
                                                        this._lastErrorReason = null;
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        }).call(_this);
                                    }).catch(function(error) {
                                        if (fetchAbortSignal.aborted) // This request was aborted, so we don't need to handle it.
                                        return;
                                        _this._requestStatus = 'FAILED';
                                        if ((0, _instanceof._)(error, (0, _types1.FetchError)) && [
                                            429,
                                            503
                                        ].includes(error.statusCode)) _this._lastErrorReason = 'ServerBusyError';
                                        else _this._lastErrorReason = (0, _instanceof._)(error, Error) && (0, _types1.ALLOW_LISTED_FETCH_ERROR_NAMES).includes(error.name) ? error.name : 'Unknown';
                                        throw error;
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getMetadataAsync",
            value: function getMetadataAsync() {
                return Promise.resolve(this._metadataInfo);
            }
        },
        {
            key: "status",
            get: function get() {
                return this._requestStatus;
            }
        },
        {
            key: "lastErrorReason",
            get: function get() {
                return this._lastErrorReason;
            }
        },
        {
            key: "lastFetchRequestCount",
            get: function get() {
                return this._lastFetchRequestCount;
            }
        },
        {
            key: "userInfo",
            get: function get() {
                return this._userInfo;
            },
            set: function set(userInfo) {
                var _this__userInfo, _this__userInfo1;
                if (((_this__userInfo = this._userInfo) === null || _this__userInfo === void 0 ? void 0 : _this__userInfo.userId) === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userId) && ((_this__userInfo1 = this._userInfo) === null || _this__userInfo1 === void 0 ? void 0 : _this__userInfo1.userIdType) === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userIdType)) return;
                this._userInfo = userInfo;
                this.schedulePropertyChangeRefresh();
            }
        },
        {
            key: "tenantInfo",
            get: function get() {
                return this._tenantInfo;
            },
            set: function set(tenantInfo) {
                var _this__tenantInfo, _this__tenantInfo1;
                if (((_this__tenantInfo = this._tenantInfo) === null || _this__tenantInfo === void 0 ? void 0 : _this__tenantInfo.tenantId) === (tenantInfo === null || tenantInfo === void 0 ? void 0 : tenantInfo.tenantId) && ((_this__tenantInfo1 = this._tenantInfo) === null || _this__tenantInfo1 === void 0 ? void 0 : _this__tenantInfo1.tenantIdType) === (tenantInfo === null || tenantInfo === void 0 ? void 0 : tenantInfo.tenantIdType)) return;
                this._tenantInfo = tenantInfo;
                this.schedulePropertyChangeRefresh();
            }
        },
        {
            key: "metrics",
            get: function get() {
                return {
                    host: this._metadataHost,
                    status: this.status,
                    lastErrorReason: this.lastErrorReason,
                    lastRefreshRequestCount: this.lastFetchRequestCount
                };
            }
        },
        {
            key: "scheduleCallback",
            value: function scheduleCallback(done) {
                return (0, _asyncToGenerator._)(function() {
                    var _this__networkStatus, e;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (((_this__networkStatus = this._networkStatus) === null || _this__networkStatus === void 0 ? void 0 : _this__networkStatus.getNetworkStatus()) === (0, _types.NetworkStatusEnum).OFFLINE) {
                                    done((0, _scheduler.DoneState).NOOP);
                                    return [
                                        2
                                    ];
                                }
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    this.refreshMetadataAsync()
                                ];
                            case 2:
                                _state.sent();
                                done((0, _scheduler.DoneState).SUCCESS);
                                this._scheduler.schedule();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                done((0, _scheduler.DoneState).ERROR);
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "schedulePropertyChangeRefresh",
            value: /**
	 * Schedules a refresh of the metadata when the user or tenant info changes. There is
	 * a short delay to allow for multiple changes to be batched together, such as when the
	 * callers sets the user info and tenant info in quick succession.
	 */ function schedulePropertyChangeRefresh() {
                var _this = this;
                if (!this._isEnabled) return;
                this.resetPropertyChangeRefresh();
                this._propertyChangeRefreshTimeout = setTimeout(function() {
                    _this.resetPropertyChangeRefresh();
                    _this._scheduler.schedule({
                        immediate: true
                    });
                }, (0, _defaults.DEFAULT_METADATA_PROPERTY_CHANGE_REFRESH_INTERVAL));
            }
        },
        {
            key: "resetPropertyChangeRefresh",
            value: function resetPropertyChangeRefresh() {
                if (this._propertyChangeRefreshTimeout) {
                    clearTimeout(this._propertyChangeRefreshTimeout);
                    this._propertyChangeRefreshTimeout = null;
                }
            }
        },
        {
            key: "buildOptions",
            value: function buildOptions(options) {
                return {
                    backoffFactor: (options === null || options === void 0 ? void 0 : options.backoffFactor) || (0, _pullBatchableQueue.DEFAULT_POLLING_OPTIONS).backoffFactor,
                    backoffJitterPercentage: (options === null || options === void 0 ? void 0 : options.backoffJitterPercentage) !== undefined ? options.backoffJitterPercentage : (0, _pullBatchableQueue.DEFAULT_POLLING_OPTIONS).backoffJitterPercentage,
                    maxRetryDelay: (options === null || options === void 0 ? void 0 : options.maxRetryDelay) || (0, _pullBatchableQueue.DEFAULT_POLLING_OPTIONS).maxRetryDelay,
                    minRetryDelay: (options === null || options === void 0 ? void 0 : options.minRetryDelay) || (0, _pullBatchableQueue.DEFAULT_POLLING_OPTIONS).minRetryDelay
                };
            }
        }
    ]);
    return MetadataClient;
}();
MetadataClient.INITIAL_REFRESH_DELAY = 1;
MetadataClient.Factory = function(apiHostProtocol, apiHost, product) {
    return new MetadataClient(apiHostProtocol, apiHost, product);
};

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_ts_generator":"78Tqx","../resilienceQueue/NetworkStatus":"5TM92","../resilienceQueue/PullBatchableQueue":"1S9sK","../resilienceQueue/scheduler":"3kKmD","../resilienceQueue/types":"g24Es","../selectHost":"1oSN0","../util/testSupport":"g7FOR","./defaults":"fC7BS","./fetchMetadata":"3HKvs","./types":"iaCPD","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1oSN0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "STARGATE_PROXY_PATH", function() {
    return STARGATE_PROXY_PATH;
});
/**
 * Resolves the GASv3 API host based on environment, perimeter and IC context.
 *
 * If an explicit `apiHost` is provided, it is always used as-is regardless of
 * other settings.
 *
 * When `ic` is present (either explicitly provided or auto-detected), the function
 * routes through the Stargate proxy path on the current host.
 *
 * For non-IC environments the function delegates to the existing perimeter-specific
 * handlers (Commercial / FedRAMP Moderate).
 */ parcelHelpers.export(exports, "selectHost", function() {
    return selectHost;
});
parcelHelpers.export(exports, "isStargateProxyPath", function() {
    return isStargateProxyPath;
});
var _analyticsWebTypes = require("./analyticsWebTypes");
var PROD_HOST = 'as.atlassian.com/api/v1';
var STARGATE_PROD_HOST = 'api-private.atlassian.com/gasv3/api/v1';
var STAGING_HOST = 'as.staging.atl-paas.net/api/v1';
var STARGATE_STAGING_HOST = 'api-private.stg.atlassian.com/gasv3/api/v1';
var FEDRAMP_STAGING_HOST = 'as.staging.atl-paas-us-gov-mod.net/api/v1';
var FEDRAMP_PROD_HOST = 'as.atlassian-us-gov-mod.com/api/v1';
var STARGATE_FEDRAMP_STAGING_HOST = 'api.stg.atlassian-us-gov-mod.com/gasv3/api/v1';
var STARGATE_FEDRAMP_PROD_HOST = 'api.atlassian-us-gov-mod.com/gasv3/api/v1';
var STARGATE_PROXY_PATH = '/gateway/api/gasv3/api/v1';
/**
 * Returns the full Stargate proxy URL (host + proxy path) for the current host.
 *
 * This is the default endpoint for Commercial, FedRAMP Moderate (with Stargate),
 * and Oasis IC environments. Using the first-party proxy works around browser
 * restrictions with third-party cookies.
 *
 * In non-browser environments (e.g. SSR) where `window` is not defined, the host
 * portion is omitted and the function returns only `STARGATE_PROXY_PATH`
 * (i.e. `/gateway/api/gasv3/api/v1`).
 */ function stargateProxyUrl() {
    return (typeof window !== 'undefined' ? window.location.host : '') + STARGATE_PROXY_PATH;
}
var handleFedRampModerate = function(param) {
    var useStargate = param.useStargate, env = param.env, useLegacyUrl = param.useLegacyUrl, envOverride = param.envOverride;
    if (env === (0, _analyticsWebTypes.envType).LOCAL || env === (0, _analyticsWebTypes.envType).DEV) throw Error('No LOCAL or DEV environments for FedRAMP.');
    if (env === (0, _analyticsWebTypes.envType).PROD && envOverride) throw Error('Cannot override to FedRAMP Sandbox for Prod.');
    if (!useStargate) return env === (0, _analyticsWebTypes.envType).PROD ? FEDRAMP_PROD_HOST : FEDRAMP_STAGING_HOST;
    if (useLegacyUrl) return env === (0, _analyticsWebTypes.envType).PROD ? STARGATE_FEDRAMP_PROD_HOST : STARGATE_FEDRAMP_STAGING_HOST;
    return stargateProxyUrl();
};
var handleCommercial = function(param) {
    var useStargate = param.useStargate, env = param.env, useLegacyUrl = param.useLegacyUrl;
    if (!useStargate) return env === (0, _analyticsWebTypes.envType).PROD ? PROD_HOST : STAGING_HOST;
    if (useLegacyUrl) return env === (0, _analyticsWebTypes.envType).PROD ? STARGATE_PROD_HOST : STARGATE_STAGING_HOST;
    return stargateProxyUrl();
};
function selectHost(param) {
    var useStargate = param.useStargate, env = param.env, useLegacyUrl = param.useLegacyUrl, perimeter = param.perimeter, ic = param.ic, envOverride = param.envOverride, apiHost = param.apiHost;
    // If the caller has explicitly set an apiHost, use it as the endpoint.
    if (apiHost) return apiHost;
    // When running inside an IC, events are routed through the Stargate proxy.
    if (ic) {
        if (useLegacyUrl) throw Error('IC is set but useLegacyUrl is true. Legacy URLs are not supported in IC environments.');
        return stargateProxyUrl();
    }
    if (perimeter === (0, _analyticsWebTypes.perimeterType).FEDRAMP_MODERATE) return handleFedRampModerate({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl,
        envOverride: envOverride
    });
    return handleCommercial({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl
    });
}
function isStargateProxyPath(param) {
    var apiHost = param.apiHost;
    return apiHost === stargateProxyUrl();
}

},{"./analyticsWebTypes":"iDbK2","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"g7FOR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TestSupport", function() {
    return TestSupport;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var TestSupport = /*#__PURE__*/ function() {
    "use strict";
    function TestSupport() {
        (0, _classCallCheck._)(this, TestSupport);
    }
    (0, _createClass._)(TestSupport, null, [
        {
            key: "isGeminiVREnvironment",
            value: function isGeminiVREnvironment() {
                try {
                    for(var k in globalThis){
                        if (k.startsWith('__gemini_') && k.endsWith('__')) return true;
                    }
                } catch (e) {
                // ignore
                }
                return false;
            }
        },
        {
            key: "areMetadataCallsDisabled",
            value: function areMetadataCallsDisabled() {
                return this.areFetchCallsDisabled() || this.getGlobalBooleanProperty(TestSupport.DISABLE_METADATA_CALLS_PROPERTY);
            }
        },
        {
            key: "areEventCallsDisabled",
            value: function areEventCallsDisabled() {
                return this.areFetchCallsDisabled() || this.getGlobalBooleanProperty(TestSupport.DISABLE_EVENT_CALLS_PROPERTY);
            }
        },
        {
            key: "areFetchCallsDisabled",
            value: function areFetchCallsDisabled() {
                return this.getGlobalBooleanProperty(TestSupport.DISABLE_FETCH_CALLS_PROPERTY);
            }
        },
        {
            key: "getSyntheticFlagOverride",
            value: function getSyntheticFlagOverride() {
                return this.getGlobalTriStateProperty(TestSupport.SYNTHETIC_FLAG_OVERRIDE_PROPERTY);
            }
        },
        {
            key: "getGlobalBooleanProperty",
            value: function getGlobalBooleanProperty(propertyName) {
                if (globalThis && globalThis.hasOwnProperty(propertyName)) return globalThis[propertyName] === true;
                return false;
            }
        },
        {
            key: "getGlobalTriStateProperty",
            value: function getGlobalTriStateProperty(propertyName) {
                if (globalThis && globalThis.hasOwnProperty(propertyName)) {
                    var value = globalThis[propertyName];
                    if (typeof value === 'boolean') return value;
                }
                return undefined;
            }
        }
    ]);
    return TestSupport;
}();
TestSupport.DISABLE_METADATA_CALLS_PROPERTY = '__awc_disable_metadata_calls__';
TestSupport.DISABLE_EVENT_CALLS_PROPERTY = '__awc_disable_event_calls__';
TestSupport.DISABLE_FETCH_CALLS_PROPERTY = '__awc_disable_fetch_calls__';
TestSupport.SYNTHETIC_FLAG_OVERRIDE_PROPERTY = '__awc_synthetic_flag_override__';

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3HKvs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fetchMetadata", function() {
    return fetchMetadata;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _memoizeOne = require("memoize-one");
var _memoizeOneDefault = parcelHelpers.interopDefault(_memoizeOne);
var _types = require("./types");
var fetchMetadata = function(url, params, timeout, signal) {
    return (0, _asyncToGenerator._)(function() {
        var _params_userInfo, _params_userInfo1, _params_tenantInfo, _params_tenantInfo1, requestAbortController, corsOptions, metadataUrl, response;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    requestAbortController = createRequestAbortController(timeout, signal);
                    corsOptions = getCorsForUrl(url);
                    metadataUrl = url + '?' + new URLSearchParams({
                        product: "".concat(params.product),
                        userId: "".concat(((_params_userInfo = params.userInfo) === null || _params_userInfo === void 0 ? void 0 : _params_userInfo.userId) || ''),
                        userIdType: "".concat(((_params_userInfo1 = params.userInfo) === null || _params_userInfo1 === void 0 ? void 0 : _params_userInfo1.userIdType) || ''),
                        tenantId: "".concat(((_params_tenantInfo = params.tenantInfo) === null || _params_tenantInfo === void 0 ? void 0 : _params_tenantInfo.tenantId) || ''),
                        tenantIdType: "".concat(((_params_tenantInfo1 = params.tenantInfo) === null || _params_tenantInfo1 === void 0 ? void 0 : _params_tenantInfo1.tenantIdType) || '')
                    }).toString();
                    return [
                        4,
                        fetch(metadataUrl, (0, _objectSpread._)({
                            method: 'GET',
                            signal: requestAbortController.signal
                        }, corsOptions))
                    ];
                case 1:
                    response = _state.sent();
                    // Response must be a 200 (we expect a JSON response, so 204 is not valid for instance)
                    if (response.status !== 200) throw new (0, _types.FetchError)("Metadata: HTTP Error ".concat(response.status, " (").concat(response.statusText, ")"), response.status, response.statusText);
                    return [
                        2,
                        response
                    ];
            }
        });
    })();
};
var createRequestAbortController = function(timeout, signal) {
    var abortController = new AbortController();
    setTimeout(function() {
        abortController.abort();
    }, timeout || 30000);
    signal === null || signal === void 0 ? void 0 : signal.addEventListener('abort', function() {
        abortController.abort();
    });
    return abortController;
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
var getCorsForUrl = (0, _memoizeOneDefault.default)(function(url) {
    var origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: 'cors',
        credentials: 'include'
    };
});

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_ts_generator":"78Tqx","memoize-one":"5rJro","./types":"iaCPD","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"c5maO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return OriginTracing;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _analyticsWebTypes = require("./analyticsWebTypes");
var _urlUtils = require("./urlUtils");
var _urlUtilsDefault = parcelHelpers.interopDefault(_urlUtils);
var OriginTracing = /*#__PURE__*/ function() {
    "use strict";
    function OriginTracing() {
        var _this = this;
        (0, _classCallCheck._)(this, OriginTracing);
        this.pendingCleanup = null;
        this.handleOriginParameters = function(originParamHandlerMapping, historyReplaceFn) {
            // Collect all the parameter labels to be handled
            var originParamLabelList = Object.keys(originParamHandlerMapping);
            if (!(originParamLabelList.length > 0)) throw new Error('Empty parameter mapping provided');
            // Check if the parameter labels are valid. If any invalid labels are found throw an exception.
            var invalidParams = originParamLabelList.filter(function(x) {
                return Object.values((0, _analyticsWebTypes.originTracingType)).indexOf(x) < 0;
            });
            if (invalidParams.length > 0) throw new Error("Invalid Origin Tracing Parameter(s) supplied: ".concat(invalidParams.join(), "!"));
            var isCaptureParam = function(_, key) {
                return originParamLabelList.indexOf(key) >= 0;
            };
            // Capture params WITHOUT removing from URL (explicit no-op required because
            // urlParamExtractor defaults to calling history.replaceState if omitted)
            var paramExtractorReplace = (0, _platformFeatureFlags.fg)('puma-1542-preserve-origin-params') ? function() {} : historyReplaceFn;
            var capturedURLParams = (0, _urlUtilsDefault.default)(isCaptureParam, paramExtractorReplace);
            // Apply provided handler function to extract origin trace ID from each URL parameter
            var applyHandlerFunction = function(key) {
                var x = originParamHandlerMapping[key](capturedURLParams[key]);
                return (0, _defineProperty._)({}, key, x);
            };
            var capturedOriginTraces = Object.keys(capturedURLParams).map(applyHandlerFunction).reduce(function(accumulator, currentValue) {
                return Object.assign(accumulator, currentValue);
            }, {});
            // Store cleanup function internally if we captured any params
            if ((0, _platformFeatureFlags.fg)('puma-1542-preserve-origin-params')) {
                if (Object.keys(capturedOriginTraces).length > 0) _this.pendingCleanup = function() {
                    (0, _urlUtilsDefault.default)(isCaptureParam, historyReplaceFn);
                };
            }
            return capturedOriginTraces;
        };
        this._originStore = {};
    }
    (0, _createClass._)(OriginTracing, [
        {
            key: "_cleanupOriginParams",
            value: /** Executes and clears any pending origin param cleanup. No-op if nothing is pending. */ function _cleanupOriginParams() {
                if (this.pendingCleanup) {
                    var cleanup = this.pendingCleanup;
                    this.pendingCleanup = null;
                    cleanup();
                }
            }
        },
        {
            key: "cleanupOriginParameters",
            value: /**
	 * Designed to be invoked after a successful flush with the batch of flushed events.
	 */ function cleanupOriginParameters(events) {
                try {
                    if ((0, _platformFeatureFlags.fg)('puma-1542-preserve-origin-params')) {
                        if (this.pendingCleanup) {
                            var hasOriginLanded = events.some(function(item) {
                                return 'event' in item.msg && item.msg.event === OriginTracing.messageEvent;
                            });
                            if (hasOriginLanded) this._cleanupOriginParams();
                        }
                    }
                } catch (e) {
                // Silently ignore cleanup errors to avoid disrupting the flush cycle
                }
            }
        }
    ]);
    return OriginTracing;
}();
OriginTracing.messageEvent = 'origin landed';

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_define_property":"e80IS","@atlaskit/platform-feature-flags":"kO5t9","./analyticsWebTypes":"iDbK2","./urlUtils":"6G7Ig","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fAITv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_SESSION_EXPIRY_TIME_MS", function() {
    return DEFAULT_SESSION_EXPIRY_TIME_MS;
});
parcelHelpers.export(exports, "DEFAULT_EXPIRY_DEBOUNCE", function() {
    return DEFAULT_EXPIRY_DEBOUNCE;
});
parcelHelpers.export(exports, "DEFAULT_DEBOUNCE_THRESHOLD_PERCENTAGE", function() {
    return DEFAULT_DEBOUNCE_THRESHOLD_PERCENTAGE;
});
parcelHelpers.export(exports, "NOOP", function() {
    return NOOP;
});
parcelHelpers.export(exports, "default", function() {
    return SessionTracking;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _safeLocalStorage = require("./storage/SafeLocalStorage");
var _safeLocalStorageDefault = parcelHelpers.interopDefault(_safeLocalStorage);
// WARNING: The value of SESSION_ID_STORAGE_KEY is relied upon by other Platform packages
// (eg. search-page, product-search-dialog). If you need to change this key, you MUST
// notify the dependant Platform teams and update all dependent packages accordingly.
var SESSION_ID_STORAGE_KEY = 'session.id';
var SESSION_EXPIRY_STORAGE_KEY = 'session.expiry';
var ONLY_NUMBERS_REGEX = /^\d+$/;
var DEFAULT_SESSION_EXPIRY_TIME_MS = 1800000; // 30 minutes
var DEFAULT_EXPIRY_DEBOUNCE = 5000; // 5 seconds
var DEFAULT_DEBOUNCE_THRESHOLD_PERCENTAGE = 0.9; // 90% of expiry
var NOOP = function() {};
var SessionTracking = /*#__PURE__*/ function() {
    "use strict";
    function SessionTracking() {
        var _this = this;
        var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, _classCallCheck._)(this, SessionTracking);
        this._generateNewSessionId = function() {
            var newSessionId = Date.now().toString();
            _this._safeLocalStorage.setItem(SESSION_ID_STORAGE_KEY, newSessionId);
            // COMMENTS-123 - When a new session starts, call the callback if it is given
            _this._onNewSessionStarted && _this._onNewSessionStarted();
            return newSessionId;
        };
        this._updateSessionExpiry = function() {
            var expiry = Date.now() + _this._sessionExpiryTime;
            _this._safeLocalStorage.setItem(SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        };
        this._debouncedUpdateSessionExpiry = function(currentExpiry) {
            var _updateSessionExpiry = _this._updateSessionExpiry;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + _this._sessionExpiryDebounceThresholdPercentage * _this._sessionExpiryTime) _updateSessionExpiry();
            else {
                if (_this._sessionExpiryDebounceTimer) clearTimeout(_this._sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                _this._sessionExpiryDebounceTimer = setTimeout(function() {
                    _updateSessionExpiry();
                }, _this._sessionExpiryDebounce);
            }
        };
        this._sessionExpiryTime = options.sessionExpiryTime || DEFAULT_SESSION_EXPIRY_TIME_MS;
        this._sessionExpiryDebounce = options.sessionExpiryDebounce || DEFAULT_EXPIRY_DEBOUNCE;
        this._sessionExpiryDebounceThresholdPercentage = options.sessionExpiryDebounceThresholdPercentage || DEFAULT_DEBOUNCE_THRESHOLD_PERCENTAGE;
        this._onNewSessionStarted = options.onNewSessionStarted ? options.onNewSessionStarted : NOOP;
        this._safeLocalStorage = new (0, _safeLocalStorageDefault.default)();
    }
    (0, _createClass._)(SessionTracking, [
        {
            key: "getCurrentSessionId",
            value: function getCurrentSessionId() {
                var sessionId = this._safeLocalStorage.getItem(SESSION_ID_STORAGE_KEY);
                var sessionExpiry = parseInt(this._safeLocalStorage.getItem(SESSION_EXPIRY_STORAGE_KEY) || '0', 10) || 0;
                this._debouncedUpdateSessionExpiry(sessionExpiry);
                if (!sessionId || sessionExpiry <= Date.now() || Number.isNaN(sessionExpiry)) return this._generateNewSessionId();
                // Old versions of sessionId were UUIDs which caused issues for Amplitude which only accepts
                // integers for this field. In these scenarios we want to regenerate the sessionId as an integer
                if (!ONLY_NUMBERS_REGEX.test(sessionId)) return this._generateNewSessionId();
                return sessionId;
            }
        }
    ]);
    return SessionTracking;
}();

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","./storage/SafeLocalStorage":"lSDeu","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kOhYp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// eslint-disable-next-line import/no-anonymous-default-export
parcelHelpers.export(exports, "default", function() {
    return _class;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _inherits = require("@swc/helpers/_/_inherits");
var _inMemoryStorage = require("./InMemoryStorage");
var _inMemoryStorageDefault = parcelHelpers.interopDefault(_inMemoryStorage);
var _safeStorage = require("./SafeStorage");
var _safeStorageDefault = parcelHelpers.interopDefault(_safeStorage);
var _class = /*#__PURE__*/ function(SafeStorage) {
    "use strict";
    (0, _inherits._)(_class, SafeStorage);
    function _class(options) {
        (0, _classCallCheck._)(this, _class);
        var storageToUse;
        try {
            storageToUse = globalThis.sessionStorage || (0, _inMemoryStorageDefault.default);
        } catch (err) {
            storageToUse = (0, _inMemoryStorageDefault.default);
        }
        return (0, _callSuper._)(this, _class, [
            storageToUse,
            options
        ]);
    }
    return _class;
}((0, _safeStorageDefault.default));

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_inherits":"2sfqW","./InMemoryStorage":"e2Hlk","./SafeStorage":"04ZCw","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aX3f1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return TabTracking;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _safeSessionStorage = require("./storage/SafeSessionStorage");
var _safeSessionStorageDefault = parcelHelpers.interopDefault(_safeSessionStorage);
var _uuid = require("./uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
var STORAGE_KEY = 'tab.id';
var TabTracking = /*#__PURE__*/ function() {
    "use strict";
    function TabTracking() {
        var _this = this;
        (0, _classCallCheck._)(this, TabTracking);
        this._generateNewTabId = function() {
            var newTabId = (0, _uuidDefault.default)();
            _this._safeSessionStorage.setItem(STORAGE_KEY, newTabId);
            return newTabId;
        };
        this._safeSessionStorage = new (0, _safeSessionStorageDefault.default)();
    }
    (0, _createClass._)(TabTracking, [
        {
            key: "getCurrentTabId",
            value: function getCurrentTabId() {
                var tabId = this._safeSessionStorage.getItem(STORAGE_KEY);
                if (!tabId) tabId = this._generateNewTabId();
                return tabId;
            }
        }
    ]);
    return TabTracking;
}();

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","./storage/SafeSessionStorage":"kOhYp","./uuid":"gL2xH","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2z4RG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return TaskSessionStore;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _queryString = require("query-string");
var _analyticsWebTypes = require("./analyticsWebTypes");
var _objectUtils = require("./objectUtils");
var _safeSessionStorage = require("./storage/SafeSessionStorage");
var _safeSessionStorageDefault = parcelHelpers.interopDefault(_safeSessionStorage);
var _urlUtils = require("./urlUtils");
var _urlUtilsDefault = parcelHelpers.interopDefault(_urlUtils);
var _uuid = require("./uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
var STORAGE_KEY = 'taskSessions';
var INIT_KEY = 'taskSessionsInit';
var AWC_PARAM_PREFIX = 'awc.';
var TASK_SESSION_RELOAD_TIME = 3000;
var TaskSessionStore = function TaskSessionStore() {
    "use strict";
    var _this = this;
    (0, _classCallCheck._)(this, TaskSessionStore);
    this._taskSessionsNotRecentlyInitialised = function(currentTimestamp) {
        return _this._safeSessionStorage.getItem(STORAGE_KEY) === null || _this._safeSessionStorage.getItem(INIT_KEY) === null || parseInt(_this._safeSessionStorage.getItem(INIT_KEY) || '0', 10) < currentTimestamp - TASK_SESSION_RELOAD_TIME;
    };
    this._removeTaskSessionPrefix = function(_, taskSessionName) {
        return taskSessionName.split(AWC_PARAM_PREFIX)[1];
    };
    this._isTaskSessionQueryParam = function(_, taskSessionName) {
        return taskSessionName.startsWith(AWC_PARAM_PREFIX);
    };
    this.getAllTaskSessions = function() {
        try {
            return JSON.parse(_this._safeSessionStorage.getItem(STORAGE_KEY) || '');
        } catch (e) {
            return {};
        }
    };
    this._writeToSessionStorage = function(taskSessions) {
        try {
            _this._safeSessionStorage.setItem(STORAGE_KEY, JSON.stringify(taskSessions));
        // eslint-disable-next-line no-empty
        } catch (e) {}
    };
    this._appendTaskSessions = function(newTaskSessions) {
        var currentState = _this.getAllTaskSessions();
        var newState = currentState === null ? newTaskSessions : Object.assign(currentState, newTaskSessions);
        _this._writeToSessionStorage(newState);
    };
    this._safelyRemoveKey = function(currentState, taskSessionName) {
        if (currentState === null) return {};
        delete currentState[taskSessionName];
        return currentState;
    };
    this.createTaskSession = function(taskSessionName) {
        var taskSessionId = (0, _uuidDefault.default)();
        var newTaskSessions = {};
        newTaskSessions[taskSessionName] = taskSessionId;
        _this._appendTaskSessions(newTaskSessions);
        return taskSessionId;
    };
    this.createTaskSessionWithProvidedId = function(taskSessionName, taskSessionId) {
        if (typeof taskSessionId !== 'string') throw new TypeError('invalid taskSessionId, must be string');
        var newTaskSessions = {};
        newTaskSessions[taskSessionName] = taskSessionId;
        _this._appendTaskSessions(newTaskSessions);
    };
    this.completeTaskSession = function(taskSessionName) {
        var currentState = _this.getAllTaskSessions();
        var updatedState = _this._safelyRemoveKey(currentState, taskSessionName);
        _this._writeToSessionStorage(updatedState);
    };
    this.formatTaskSessionQueryString = function(param) {
        var uri = param.uri, includedTaskSessions = param.includedTaskSessions;
        var _parseUrl = (0, _queryString.parseUrl)(uri), url = _parseUrl.url, query = _parseUrl.query;
        var currentState = _this.getAllTaskSessions();
        // Use specified task sessions, otherwise all tasksessions excluding originTracing sessions
        var filteredTaskSessions = includedTaskSessions ? (0, _objectUtils.pick)(currentState, includedTaskSessions) : (0, _objectUtils.omit)(currentState, Object.values((0, _analyticsWebTypes.originTracingType)));
        if (Object.keys(filteredTaskSessions).length === 0) return uri;
        var queryWithTaskSessions = (0, _objectSpread._)({}, (0, _objectUtils.mapKeys)(filteredTaskSessions, function(_, taskSessionName) {
            return AWC_PARAM_PREFIX + taskSessionName;
        }), query);
        return "".concat(url, "?").concat((0, _queryString.stringify)(queryWithTaskSessions));
    };
    this.stripQueryParameters = function() {
        var extractedTaskSessions = (0, _objectUtils.mapKeys)((0, _urlUtilsDefault.default)(_this._isTaskSessionQueryParam), _this._removeTaskSessionPrefix);
        _this._appendTaskSessions(extractedTaskSessions);
    };
    var currentTimestamp = Date.now();
    this._safeSessionStorage = new (0, _safeSessionStorageDefault.default)();
    // Wrapping all sessionStorage calls in try catch to stop any error propogation, taskSessions should gracefully fail.
    try {
        if (this._taskSessionsNotRecentlyInitialised(currentTimestamp)) {
            this._writeToSessionStorage({});
            this._safeSessionStorage.setItem(INIT_KEY, currentTimestamp.toString());
        }
    // eslint-disable-next-line no-empty
    } catch (e) {}
};

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_object_spread":"9gdrV","query-string":"jcXMO","./analyticsWebTypes":"iDbK2","./objectUtils":"3kJkz","./storage/SafeSessionStorage":"kOhYp","./urlUtils":"6G7Ig","./uuid":"gL2xH","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cfbrE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _jsCookie = require("js-cookie");
var _jsCookieDefault = parcelHelpers.interopDefault(_jsCookie);
var _cookie = require("./cookie");
var _testSupport = require("./util/testSupport");
var MAX_CACHE_SIZE = 100;
var COOKIE_NAME = (0, _cookie.AllAnalyticsCookies).AWC_ANALYTICS_DEBUG.getKey();
var DEBUG_TAG = 'synthetic';
var TestingCache = /*#__PURE__*/ function() {
    "use strict";
    function TestingCache(syntheticFlagOverride, enableTestingCache) {
        (0, _classCallCheck._)(this, TestingCache);
        this._syntheticFlagOverride = typeof syntheticFlagOverride === 'boolean' ? syntheticFlagOverride : undefined;
        this._enableTestingCache = typeof enableTestingCache === 'boolean' ? enableTestingCache : undefined;
        this._isDebugCookieEnabled = TestingCache.getDebugCookie();
        this.bind();
    }
    (0, _createClass._)(TestingCache, [
        {
            key: "saveEvent",
            value: function saveEvent(event) {
                try {
                    if (!event) return;
                    this.bind();
                    this.addSyntheticTag(event);
                    this.cache(event);
                } catch (e) {
                // Ignore errors from testing cache.
                }
            }
        },
        {
            key: "bind",
            value: function bind() {
                if (!this.shouldCacheEvent() || typeof window === 'undefined' || window.testAnalytics) return;
                window.testAnalytics = {
                    eventCache: [],
                    events: function() {
                        return window.testAnalytics.eventCache;
                    },
                    clear: function() {
                        window.testAnalytics.eventCache = [];
                        try {
                            localStorage.removeItem('awc.ui.viewed.last.sent');
                            localStorage.removeItem('awc-staging.ui.viewed.last.sent');
                            localStorage.removeItem('awc-dev.ui.viewed.last.sent');
                            localStorage.removeItem('awc-local.ui.viewed.last.sent');
                        } catch (e) {
                        // Ignore errors from localStorage.
                        }
                    }
                };
            }
        },
        {
            key: "cache",
            value: function cache(event) {
                if (!this.shouldCacheEvent() || typeof window === 'undefined' || !window.testAnalytics) return;
                if (window.testAnalytics.eventCache.length >= MAX_CACHE_SIZE) window.testAnalytics.eventCache = window.testAnalytics.eventCache.slice(1, window.testAnalytics.eventCache.length);
                window.testAnalytics.eventCache.push(event);
            }
        },
        {
            key: "addSyntheticTag",
            value: function addSyntheticTag(event) {
                if (!this.shouldSetSyntheticFlag()) return;
                if ((0, _instanceof._)(event.tags, Array)) {
                    if (!event.tags.includes(DEBUG_TAG)) event.tags.push(DEBUG_TAG);
                } else event.tags = [
                    DEBUG_TAG
                ];
            }
        },
        {
            key: "shouldCacheEvent",
            value: function shouldCacheEvent() {
                return this._enableTestingCache ? this._enableTestingCache : this._isDebugCookieEnabled;
            }
        },
        {
            key: "shouldSetSyntheticFlag",
            value: function shouldSetSyntheticFlag() {
                if (this._syntheticFlagOverride !== undefined) return this._syntheticFlagOverride;
                var globalSyntheticOverride = (0, _testSupport.TestSupport).getSyntheticFlagOverride();
                if (globalSyntheticOverride !== undefined) return globalSyntheticOverride;
                return this.shouldCacheEvent();
            }
        }
    ], [
        {
            key: "getDebugCookie",
            value: function getDebugCookie() {
                try {
                    return JSON.parse((0, _jsCookieDefault.default).get(COOKIE_NAME) || 'false') === true;
                } catch (e) {
                    (0, _jsCookieDefault.default).remove(COOKIE_NAME);
                }
                return false;
            }
        }
    ]);
    return TestingCache;
}();
exports.default = TestingCache;

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_instanceof":"h9UKc","js-cookie":"kEATS","./cookie":"5MOfC","./util/testSupport":"g7FOR","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"zoaIm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return UIViewedEvent;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _analyticsWebTypes = require("./analyticsWebTypes");
var _getDocument = require("./getDocument");
var _safeLocalStorage = require("./storage/SafeLocalStorage");
var _safeLocalStorageDefault = parcelHelpers.interopDefault(_safeLocalStorage);
var DEFAULT_DELAY = 2000; // 2 seconds
var DEFAULT_THROTTLE = 3600000; // 1 hour
var DEFAULT_STORAGE_KEY = 'ui.viewed.last.sent';
var DEFAULT_MALFORMED_UIVIEWED_EVENT = 'malformed.uiviewed.last.sent';
var SendEventDecision = /*#__PURE__*/ function(SendEventDecision) {
    SendEventDecision[SendEventDecision["FocusLost"] = 0] = "FocusLost";
    SendEventDecision[SendEventDecision["UserOrTenantIncomplete"] = 1] = "UserOrTenantIncomplete";
    SendEventDecision[SendEventDecision["MalformedUiViewedRateLimited"] = 2] = "MalformedUiViewedRateLimited";
    SendEventDecision[SendEventDecision["EligibleToSend"] = 3] = "EligibleToSend";
    SendEventDecision[SendEventDecision["UiViewedRateLimited"] = 4] = "UiViewedRateLimited";
    return SendEventDecision;
}(SendEventDecision || {});
var UIViewedEvent = function UIViewedEvent(productInfo, getContext, onEvent) {
    "use strict";
    var _this = this;
    var settings = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    (0, _classCallCheck._)(this, UIViewedEvent);
    this.start = function() {
        _this._startInterval();
        _this._bindEventListeners();
    };
    this.stop = function() {
        _this._stopInterval();
        _this._unbindEventListeners();
    };
    this.resetTimers = function() {
        if (_this._intervalId) {
            _this.stop();
            _this.start();
        }
    };
    this.signalUserActive = function() {
        _this._sendUserActiveEvents();
    };
    this._bindEventListeners = function() {
        if (typeof window !== 'undefined') {
            window.addEventListener('focus', _this._focusListener);
            window.addEventListener('blur', _this._blurListener);
        }
    };
    this._unbindEventListeners = function() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('focus', _this._focusListener);
            window.removeEventListener('blur', _this._blurListener);
        }
    };
    this._startInterval = function() {
        clearInterval(_this._intervalId);
        _this._intervalId = setInterval(_this._handleDwellTimerTriggered, _this._delay);
    };
    this._stopInterval = function() {
        if (_this._intervalId) {
            clearInterval(_this._intervalId);
            _this._intervalId = null;
        }
    };
    this._getProductKey = function(product, subproduct) {
        var productKey = product;
        if (subproduct) productKey += "-".concat(subproduct);
        return productKey;
    };
    this._getLastSentTimestamp = function(productKey, tenantId, userId) {
        var json = _this._parseLocalStorageData(_this._storageKey) || {};
        var u = json[userId] || {};
        var t = u[tenantId] || {};
        var p = t[productKey] || null;
        return p;
    };
    this._parseLocalStorageData = function(key) {
        var data = _this._safeLocalStorage.getItem(key);
        try {
            return JSON.parse(data || '');
        } catch (e) {
            _this._safeLocalStorage.removeItem(key);
            return null;
        }
    };
    this._getMalformedLastSentTimestamp = function(productKey, tenantId, userId) {
        var json = _this._parseLocalStorageData(_this._malformedEventStorageKey) || {};
        var finalUserId = userId || 'NOT_SET';
        var finalTenantId = tenantId || 'NOT_SET';
        var u = json[finalUserId] || {};
        var t = u[finalTenantId] || {};
        var p = t[productKey] || null;
        return p;
    };
    this._setLastSentTimestamp = function(productKey, tenantId, userId) {
        var json = _this._parseLocalStorageData(_this._storageKey) || {};
        var u = json[userId] || {};
        var t = u[tenantId] || {};
        t[productKey] = Date.now();
        u[tenantId] = t;
        json[userId] = u;
        _this._safeLocalStorage.setItem(_this._storageKey, JSON.stringify(json));
    };
    this._setMalformedLastSentTimestamp = function(productKey, tenantId, userId) {
        var json = _this._parseLocalStorageData(_this._malformedEventStorageKey) || {};
        var finalUserId = userId || 'NOT_SET';
        var finalTenantId = tenantId || 'NOT_SET';
        var u = json[finalUserId] || {};
        var t = u[finalTenantId] || {};
        t[productKey] = Date.now();
        u[finalTenantId] = t;
        json[finalUserId] = u;
        _this._safeLocalStorage.setItem(_this._malformedEventStorageKey, JSON.stringify(json));
    };
    this._handleDwellTimerTriggered = function() {
        var document = (0, _getDocument.getDocument)();
        if (document && !document.hasFocus()) return;
        _this._sendUserActiveEvents();
    };
    this._sendUserActiveEvents = function() {
        var _this__getContext = _this._getContext(), embeddedProduct = _this__getContext.embeddedProduct, context = (0, _objectWithoutProperties._)(_this__getContext, [
            "embeddedProduct"
        ]);
        _this._sendEvent(_this._product, context, false);
        if (embeddedProduct) _this._sendEvent(embeddedProduct, context, true);
    };
    this._sendEvent = function(product, context, isEmbeddedProduct) {
        var subproduct = context.subproduct, tenantIdType = context.tenantIdType, tenantId = context.tenantId, userId = context.userId, lastScreenEvent = context.lastScreenEvent, attributes = context.attributes;
        var productKey = _this._getProductKey(product, subproduct);
        var sendEventDecision = _this._shouldSendEvent(productKey, tenantIdType, tenantId, userId);
        switch(sendEventDecision){
            case 3:
                _this._setLastSentTimestamp(productKey, tenantId, userId);
                _this._onEvent(_this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes, 'ui', 'viewed'));
                break;
            case 1:
                _this._setMalformedLastSentTimestamp(productKey, tenantId, userId);
                _this._onEvent(_this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes, 'malformed', 'uiviewed'));
                break;
            default:
                break;
        }
    };
    this._shouldSendEvent = function(productKey, tenantIdType, tenantId, userId) {
        // TENANT OR USER ID NOT SET
        if (tenantIdType !== (0, _analyticsWebTypes.tenantType).NONE && !tenantId || !userId) {
            var sinceLastSent = Date.now() - _this._getMalformedLastSentTimestamp(productKey, tenantId, userId);
            if (sinceLastSent === null || sinceLastSent > _this._throttle) return 1;
            return 2;
        }
        var sinceLastSent1 = Date.now() - _this._getLastSentTimestamp(productKey, tenantId, userId);
        if (sinceLastSent1 === null || sinceLastSent1 > _this._throttle) return 3;
        return 4;
    };
    this._createEvent = function(product, subproduct, isEmbeddedProduct, lastScreenEvent, extraAttributes, actionSubject, action) {
        var event = {
            product: product,
            source: 'ui',
            action: action,
            actionSubject: actionSubject,
            attributes: extraAttributes
        };
        if (isEmbeddedProduct) {
            // Clear the subproduct and version as they don't relate to the embedded product
            event.subproduct = null;
            event.version = null;
            event.attributes = (0, _objectSpreadProps._)((0, _objectSpread._)({}, event.attributes), {
                embeddedInEnv: _this._productInfo.env,
                embeddedInProduct: _this._productInfo.product,
                embeddedInSubproduct: subproduct,
                embeddedInVersion: _this._productInfo.version,
                embeddedInOrigin: _this._productInfo.origin,
                embeddedInPlatform: _this._productInfo.platform
            });
        }
        if (lastScreenEvent) event.attributes = (0, _objectSpreadProps._)((0, _objectSpread._)({}, event.attributes), {
            lastScreenEvent: {
                name: lastScreenEvent.name,
                attributes: lastScreenEvent.attributes
            }
        });
        return event;
    };
    if (!productInfo) throw new Error('Missing productInfo');
    if (!productInfo.product) throw new Error('Missing productInfo.product');
    if (!getContext) throw new Error('Missing getContext callback');
    if (typeof getContext !== 'function') throw new Error('Invalid getContext, must be function');
    if (!onEvent) throw new Error('Missing onEvent callback');
    if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
    this._productInfo = productInfo;
    this._product = productInfo.product;
    this._getContext = getContext;
    this._onEvent = onEvent;
    this._delay = settings.delay || DEFAULT_DELAY;
    this._throttle = settings.throttle || DEFAULT_THROTTLE;
    this._storageKey = settings.storageKey || DEFAULT_STORAGE_KEY;
    this._malformedEventStorageKey = settings.malformedStorageKey || DEFAULT_MALFORMED_UIVIEWED_EVENT;
    this._safeLocalStorage = new (0, _safeLocalStorageDefault.default)({
        envPrefix: this._productInfo.env
    });
    this._focusListener = function() {
        _this._startInterval();
    };
    this._blurListener = function() {
        _this._stopInterval();
    };
};

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","./analyticsWebTypes":"iDbK2","./getDocument":"lAIax","./storage/SafeLocalStorage":"lSDeu","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lAIax":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDocument", function() {
    return getDocument;
});
var getDocument = function() {
    if (typeof document !== 'undefined') return document;
    return null;
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fzAu5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return wrapCallback;
});
function wrapCallback(callback, event) {
    if (!callback || typeof callback !== 'function') return null;
    return function() {
        callback(event);
    };
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"sjwAz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PUG_CLOUD_ID", function() {
    return PUG_CLOUD_ID;
});
parcelHelpers.export(exports, "HELLO_CLOUD_ID", function() {
    return HELLO_CLOUD_ID;
});
parcelHelpers.export(exports, "getConfig", function() {
    return getConfig;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _env = require("@atlassian/pillar/runtime/env");
var PUG_CLOUD_ID = 'DUMMY-a5a01d21-1cc3-4f29-9565-f2bb8cd969f5';
var HELLO_CLOUD_ID = 'a436116f-02ce-4520-8fbb-7301462a1674';
// TODO: review what we actually need and remove prod values that point to internal domains
var config = {
    atlassianHomeUrl: 'https://home.stg.atlassian.com',
    atlassianAccountUrl: 'https://id.stg.internal.atlassian.com',
    serviceUrl: 'https://twg-microsite-bifrost.stg-east.frontend.public.atl-paas.net',
    graphStoreUrl: 'https://ari-graph-store.staging.atl-paas.net',
    featureGateApiKey: 'bbd011eb-3e73-42d4-8212-724f450bbb29',
    region: 'stg-east'
};
// When running locally (via pillar dev), always route graph-store through the local proxy to
// avoid CORS issues. The proxy target (staging vs production) is configured in pillar.config.ts.
var isLocalDev = typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname.includes('localhost'));
var environmentOverrides = {
    staging: {
        atlassianHomeUrl: 'https://home.stg.atlassian.com',
        atlassianAccountUrl: 'https://id.stg.internal.atlassian.com',
        serviceUrl: 'https://twg-microsite-bifrost.stg-east.frontend.public.atl-paas.net',
        graphStoreUrl: 'https://ari-graph-store.staging.atl-paas.net',
        featureGateApiKey: 'bbd011eb-3e73-42d4-8212-724f450bbb29',
        region: 'stg-east'
    },
    production: {
        atlassianHomeUrl: 'https://home.atlassian.com',
        atlassianAccountUrl: 'https://id.atlassian.com',
        serviceUrl: 'https://teamworkgraph.com',
        graphStoreUrl: isLocalDev ? '/api/graph-store' : 'https://ari-graph-store.staging.atl-paas.net',
        featureGateApiKey: 'f8f89beb-985a-4fd3-8f5c-1768050e61d8',
        region: 'prod-east'
    },
    development: {
        // Use local proxy to avoid CORS issues
        graphStoreUrl: '/api/graph-store'
    },
    local: {
        // Use local proxy to avoid CORS issues
        graphStoreUrl: '/api/graph-store'
    }
};
var getConfig = function() {
    var env = (0, _env.getEnv)();
    return (0, _objectSpreadProps._)((0, _objectSpread._)({
        env: env
    }, config, environmentOverrides[env]), {
        isLocalDev: isLocalDev
    });
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@atlassian/pillar/runtime/env":"aTPIA","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aTPIA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getIdentityLoginUrl", function() {
    return getIdentityLoginUrl;
});
parcelHelpers.export(exports, "getIdentityLogoutUrl", function() {
    return getIdentityLogoutUrl;
});
parcelHelpers.export(exports, "isStagingDomain", function() {
    return isStagingDomain;
});
parcelHelpers.export(exports, "isDevOrStagingDomain", function() {
    return isDevOrStagingDomain;
});
parcelHelpers.export(exports, "getRedirectUrl", function() {
    return getRedirectUrl;
});
parcelHelpers.export(exports, "getEnv", function() {
    return getEnv;
});
function getIdentityActionUrl(action, env) {
    var identityDomain = getIdentityDomain(env);
    var redirectUrl = getRedirectUrl(env);
    return "https://".concat(identityDomain, "/").concat(action, "?continue=").concat(encodeURIComponent(redirectUrl));
}
function getIdentityDomain(env) {
    if (env !== 'production') return 'id.stg.internal.atlassian.com';
    return 'id.atlassian.com';
}
function getIdentityLoginUrl() {
    var env = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getEnv();
    return getIdentityActionUrl('login', env);
}
function getIdentityLogoutUrl() {
    var env = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getEnv();
    return getIdentityActionUrl('logout', env);
}
function isStagingDomain() {
    var env = getEnv();
    return env === 'staging';
}
function isDevOrStagingDomain() {
    var env = getEnv();
    return [
        'staging',
        'development',
        'local'
    ].includes(env);
}
function getRedirectUrl() {
    var env = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getEnv();
    var currentUrl = globalThis.location.href;
    if (env === 'local') // Redirect via the local CST proxy.
    return "".concat(globalThis.origin, "/_pillar/auth/success?redirect=").concat(encodeURIComponent(currentUrl));
    return currentUrl;
}
function getEnv() {
    var _production;
    return (_production = "production") !== null && _production !== void 0 ? _production : 'local';
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hpATH":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::219614de08f6f0bf961b71c223f7a3c3>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen twg-microsite-experience
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAnalyticsEvents", function() {
    return useAnalyticsEvents;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _react = require("react");
var _analyticsNext = require("@atlaskit/analytics-next");
var _constants = require("../constants");
var _createEventPayload = require("./create-event-payload");
var _createEventPayloadDefault = parcelHelpers.interopDefault(_createEventPayload);
var useAnalyticsEvents = function() {
    var createAnalyticsEvent = (0, _analyticsNext.useAnalyticsEvents)().createAnalyticsEvent;
    var fireEvent = (0, _react.useCallback)(function() {
        for(var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++){
            params[_key] = arguments[_key];
        }
        var event = createAnalyticsEvent((0, _createEventPayloadDefault.default).apply(void 0, (0, _toConsumableArray._)(params)));
        event.fire((0, _constants.EVENT_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};

},{"@swc/helpers/_/_to_consumable_array":"1eSZf","react":"ltHCL","@atlaskit/analytics-next":"auH4u","../constants":"7H6IQ","./create-event-payload":"bwu8g","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7H6IQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EVENT_CHANNEL", function() {
    return EVENT_CHANNEL;
});
var EVENT_CHANNEL = 'teamworkGraph';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bwu8g":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::8e1e95aac18dffd6a7145ab81db3ee56>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen twg-microsite-experience
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var createEventPayload = function(eventKey) {
    for(var _len = arguments.length, _tmp = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        _tmp[_key - 1] = arguments[_key];
    }
    var _tmp1 = (0, _slicedToArray._)(_tmp, 1), attributes = _tmp1[0];
    var _eventKey_split = (0, _slicedToArray._)(eventKey.split('.'), 4), eventType = _eventKey_split[0], actionSubject = _eventKey_split[1], action = _eventKey_split[2], actionSubjectId = _eventKey_split[3];
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
exports.default = createEventPayload;

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lc1oo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initSentry", function() {
    return 0, _utils.initSentry;
});
parcelHelpers.export(exports, "logException", function() {
    return 0, _utils.logException;
});
parcelHelpers.export(exports, "logMessage", function() {
    return 0, _utils.logMessage;
});
parcelHelpers.export(exports, "setSentryUser", function() {
    return 0, _utils.setSentryUser;
});
parcelHelpers.export(exports, "SentryErrorBoundary", function() {
    return 0, _sentryErrorBoundary.SentryErrorBoundary;
});
var _utils = require("./utils");
var _sentryErrorBoundary = require("./SentryErrorBoundary");

},{"./utils":"dKdnr","./SentryErrorBoundary":"eB5lC","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dKdnr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initSentry", function() {
    return initSentry;
});
parcelHelpers.export(exports, "setSentryUser", function() {
    return setSentryUser;
});
parcelHelpers.export(exports, "logException", function() {
    return logException;
});
parcelHelpers.export(exports, "logMessage", function() {
    return logMessage;
});
var _react = require("@sentry/react");
var _config = require("../../config");
var DEFAULT_SENTRY_DSN = 'https://8b156bc879d5d53284bbaab24c837162@o55978.ingest.us.sentry.io/4511232360710144';
var DEFAULT_PACKAGE_NAME = 'twg-microsite';
var DEFAULT_TEAM_NAME = 'twg-graphyte';
var DEFAULT_PRODUCT = 'twgMicrosite';
var DEFAULT_LOGGER = 'logger.default';
var getEnvironment = function() {
    var env = (0, _config.getConfig)().env;
    switch(env){
        case 'production':
            return 'production';
        case 'staging':
            return 'staging';
        case 'development':
        case 'local':
        default:
            return 'dev';
    }
};
var initSentry = function() {
    var environment = getEnvironment();
    _react.init({
        dsn: DEFAULT_SENTRY_DSN,
        environment: environment,
        enabled: environment !== 'dev',
        integrations: [
            _react.browserTracingIntegration()
        ],
        // Capture 100% of transactions for performance monitoring.
        // Revisit and lower in production once traffic baselines are known.
        tracesSampleRate: 1.0,
        beforeSend: function(event) {
            var _event_tags;
            // Only filter *error* events — let non-error events (e.g. transactions
            // emitted by browserTracingIntegration) through so performance
            // monitoring data still reaches Sentry. Sentry sets `event.type` to
            // values like 'transaction' / 'replay_event' for non-error events;
            // it is `undefined` for error events.
            if (event.type === undefined && ((_event_tags = event.tags) === null || _event_tags === void 0 ? void 0 : _event_tags.name) === undefined) // Only capture error events that were explicitly tagged via
            // logException / logMessage, to avoid unwanted global errors.
            return null;
            return event;
        },
        initialScope: {
            user: {
                id: 'UNKNOWN_AAID'
            },
            tags: {
                packageName: DEFAULT_PACKAGE_NAME,
                teamName: DEFAULT_TEAM_NAME,
                product: DEFAULT_PRODUCT,
                logger: DEFAULT_LOGGER
            }
        }
    });
};
var setTagsFromExtras = function(scope, extrasAndTags) {
    scope.setTag('name', DEFAULT_PRODUCT);
    if (extrasAndTags.loggerName !== undefined && extrasAndTags.loggerName.length !== 0) scope.setTag('logger', "logger.".concat(extrasAndTags.loggerName));
    if (extrasAndTags.accountId !== undefined && extrasAndTags.accountId.length !== 0) scope.setUser({
        id: extrasAndTags.accountId
    });
    if (extrasAndTags.teamName !== undefined && extrasAndTags.teamName.length !== 0) scope.setTag('teamName', extrasAndTags.teamName);
    if (extrasAndTags.touchpointId !== undefined && extrasAndTags.touchpointId.length !== 0) scope.setTag('touchpointId', extrasAndTags.touchpointId);
};
var setSentryUser = function(accountId) {
    _react.setUser({
        id: accountId
    });
};
var logException = function(exception, extrasAndTags) {
    _react.withScope(function(scope) {
        scope.setTag('name', DEFAULT_PRODUCT);
        if (extrasAndTags) {
            scope.setExtras(extrasAndTags);
            setTagsFromExtras(scope, extrasAndTags);
        }
        _react.captureException(exception);
    });
};
var logMessage = function(message, extrasAndTags) {
    _react.withScope(function(scope) {
        scope.setTag('name', DEFAULT_PRODUCT);
        if (extrasAndTags) {
            scope.setExtras(extrasAndTags);
            setTagsFromExtras(scope, extrasAndTags);
        }
        _react.captureMessage(message);
    });
};

},{"@sentry/react":"1nLXU","../../config":"sjwAz","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1nLXU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "init", function() {
    return 0, _sdkJs.init;
});
parcelHelpers.export(exports, "captureReactException", function() {
    return 0, _errorJs.captureReactException;
});
parcelHelpers.export(exports, "reactErrorHandler", function() {
    return 0, _errorJs.reactErrorHandler;
});
parcelHelpers.export(exports, "Profiler", function() {
    return 0, _profilerJs.Profiler;
});
parcelHelpers.export(exports, "useProfiler", function() {
    return 0, _profilerJs.useProfiler;
});
parcelHelpers.export(exports, "withProfiler", function() {
    return 0, _profilerJs.withProfiler;
});
parcelHelpers.export(exports, "ErrorBoundary", function() {
    return 0, _errorboundaryJs.ErrorBoundary;
});
parcelHelpers.export(exports, "withErrorBoundary", function() {
    return 0, _errorboundaryJs.withErrorBoundary;
});
parcelHelpers.export(exports, "createReduxEnhancer", function() {
    return 0, _reduxJs.createReduxEnhancer;
});
parcelHelpers.export(exports, "reactRouterV3BrowserTracingIntegration", function() {
    return 0, _reactrouterv3Js.reactRouterV3BrowserTracingIntegration;
});
parcelHelpers.export(exports, "tanstackRouterBrowserTracingIntegration", function() {
    return 0, _tanstackrouterJs.tanstackRouterBrowserTracingIntegration;
});
parcelHelpers.export(exports, "reactRouterV4BrowserTracingIntegration", function() {
    return 0, _reactrouterJs.reactRouterV4BrowserTracingIntegration;
});
parcelHelpers.export(exports, "reactRouterV5BrowserTracingIntegration", function() {
    return 0, _reactrouterJs.reactRouterV5BrowserTracingIntegration;
});
parcelHelpers.export(exports, "withSentryRouting", function() {
    return 0, _reactrouterJs.withSentryRouting;
});
parcelHelpers.export(exports, "reactRouterV6BrowserTracingIntegration", function() {
    return 0, _reactrouterv6Js.reactRouterV6BrowserTracingIntegration;
});
parcelHelpers.export(exports, "withSentryReactRouterV6Routing", function() {
    return 0, _reactrouterv6Js.withSentryReactRouterV6Routing;
});
parcelHelpers.export(exports, "wrapCreateBrowserRouterV6", function() {
    return 0, _reactrouterv6Js.wrapCreateBrowserRouterV6;
});
parcelHelpers.export(exports, "wrapCreateMemoryRouterV6", function() {
    return 0, _reactrouterv6Js.wrapCreateMemoryRouterV6;
});
parcelHelpers.export(exports, "wrapUseRoutesV6", function() {
    return 0, _reactrouterv6Js.wrapUseRoutesV6;
});
parcelHelpers.export(exports, "reactRouterV7BrowserTracingIntegration", function() {
    return 0, _reactrouterv7Js.reactRouterV7BrowserTracingIntegration;
});
parcelHelpers.export(exports, "withSentryReactRouterV7Routing", function() {
    return 0, _reactrouterv7Js.withSentryReactRouterV7Routing;
});
parcelHelpers.export(exports, "wrapCreateBrowserRouterV7", function() {
    return 0, _reactrouterv7Js.wrapCreateBrowserRouterV7;
});
parcelHelpers.export(exports, "wrapCreateMemoryRouterV7", function() {
    return 0, _reactrouterv7Js.wrapCreateMemoryRouterV7;
});
parcelHelpers.export(exports, "wrapUseRoutesV7", function() {
    return 0, _reactrouterv7Js.wrapUseRoutesV7;
});
var _browser = require("@sentry/browser");
parcelHelpers.exportAll(_browser, exports);
var _sdkJs = require("./sdk.js");
var _errorJs = require("./error.js");
var _profilerJs = require("./profiler.js");
var _errorboundaryJs = require("./errorboundary.js");
var _reduxJs = require("./redux.js");
var _reactrouterv3Js = require("./reactrouterv3.js");
var _tanstackrouterJs = require("./tanstackrouter.js");
var _reactrouterJs = require("./reactrouter.js");
var _reactrouterv6Js = require("./reactrouterv6.js");
var _reactrouterv7Js = require("./reactrouterv7.js");

},{"@sentry/browser":"fdZ8u","./sdk.js":"klgia","./error.js":"gF5NP","./profiler.js":"9iBn8","./errorboundary.js":"aacW2","./redux.js":"eJSs2","./reactrouterv3.js":"f44ZV","./tanstackrouter.js":"d9MzP","./reactrouter.js":"9H8A3","./reactrouterv6.js":"lIgVp","./reactrouterv7.js":"i9jdX","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fdZ8u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "feedbackAsyncIntegration", function() {
    return 0, _feedbackAsyncJs.feedbackAsyncIntegration;
});
parcelHelpers.export(exports, "feedbackIntegration", function() {
    return 0, _feedbackSyncJs.feedbackSyncIntegration;
});
parcelHelpers.export(exports, "feedbackSyncIntegration", function() {
    return 0, _feedbackSyncJs.feedbackSyncIntegration;
});
parcelHelpers.export(exports, "SDK_VERSION", function() {
    return 0, _core.SDK_VERSION;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_OP", function() {
    return 0, _core.SEMANTIC_ATTRIBUTE_SENTRY_OP;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN", function() {
    return 0, _core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE", function() {
    return 0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE", function() {
    return 0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE;
});
parcelHelpers.export(exports, "Scope", function() {
    return 0, _core.Scope;
});
parcelHelpers.export(exports, "addBreadcrumb", function() {
    return 0, _core.addBreadcrumb;
});
parcelHelpers.export(exports, "addEventProcessor", function() {
    return 0, _core.addEventProcessor;
});
parcelHelpers.export(exports, "addIntegration", function() {
    return 0, _core.addIntegration;
});
parcelHelpers.export(exports, "captureConsoleIntegration", function() {
    return 0, _core.captureConsoleIntegration;
});
parcelHelpers.export(exports, "captureEvent", function() {
    return 0, _core.captureEvent;
});
parcelHelpers.export(exports, "captureException", function() {
    return 0, _core.captureException;
});
parcelHelpers.export(exports, "captureFeedback", function() {
    return 0, _core.captureFeedback;
});
parcelHelpers.export(exports, "captureMessage", function() {
    return 0, _core.captureMessage;
});
parcelHelpers.export(exports, "captureSession", function() {
    return 0, _core.captureSession;
});
parcelHelpers.export(exports, "close", function() {
    return 0, _core.close;
});
parcelHelpers.export(exports, "consoleLoggingIntegration", function() {
    return 0, _core.consoleLoggingIntegration;
});
parcelHelpers.export(exports, "continueTrace", function() {
    return 0, _core.continueTrace;
});
parcelHelpers.export(exports, "createConsolaReporter", function() {
    return 0, _core.createConsolaReporter;
});
parcelHelpers.export(exports, "createTransport", function() {
    return 0, _core.createTransport;
});
parcelHelpers.export(exports, "dedupeIntegration", function() {
    return 0, _core.dedupeIntegration;
});
parcelHelpers.export(exports, "endSession", function() {
    return 0, _core.endSession;
});
parcelHelpers.export(exports, "eventFiltersIntegration", function() {
    return 0, _core.eventFiltersIntegration;
});
parcelHelpers.export(exports, "extraErrorDataIntegration", function() {
    return 0, _core.extraErrorDataIntegration;
});
parcelHelpers.export(exports, "featureFlagsIntegration", function() {
    return 0, _core.featureFlagsIntegration;
});
parcelHelpers.export(exports, "flush", function() {
    return 0, _core.flush;
});
parcelHelpers.export(exports, "functionToStringIntegration", function() {
    return 0, _core.functionToStringIntegration;
});
parcelHelpers.export(exports, "getActiveSpan", function() {
    return 0, _core.getActiveSpan;
});
parcelHelpers.export(exports, "getClient", function() {
    return 0, _core.getClient;
});
parcelHelpers.export(exports, "getCurrentScope", function() {
    return 0, _core.getCurrentScope;
});
parcelHelpers.export(exports, "getGlobalScope", function() {
    return 0, _core.getGlobalScope;
});
parcelHelpers.export(exports, "getIsolationScope", function() {
    return 0, _core.getIsolationScope;
});
parcelHelpers.export(exports, "getRootSpan", function() {
    return 0, _core.getRootSpan;
});
parcelHelpers.export(exports, "getSpanDescendants", function() {
    return 0, _core.getSpanDescendants;
});
parcelHelpers.export(exports, "getSpanStatusFromHttpCode", function() {
    return 0, _core.getSpanStatusFromHttpCode;
});
parcelHelpers.export(exports, "getTraceData", function() {
    return 0, _core.getTraceData;
});
parcelHelpers.export(exports, "inboundFiltersIntegration", function() {
    return 0, _core.inboundFiltersIntegration;
});
parcelHelpers.export(exports, "instrumentAnthropicAiClient", function() {
    return 0, _core.instrumentAnthropicAiClient;
});
parcelHelpers.export(exports, "instrumentGoogleGenAIClient", function() {
    return 0, _core.instrumentGoogleGenAIClient;
});
parcelHelpers.export(exports, "instrumentOpenAiClient", function() {
    return 0, _core.instrumentOpenAiClient;
});
parcelHelpers.export(exports, "instrumentSupabaseClient", function() {
    return 0, _core.instrumentSupabaseClient;
});
parcelHelpers.export(exports, "isEnabled", function() {
    return 0, _core.isEnabled;
});
parcelHelpers.export(exports, "isInitialized", function() {
    return 0, _core.isInitialized;
});
parcelHelpers.export(exports, "lastEventId", function() {
    return 0, _core.lastEventId;
});
parcelHelpers.export(exports, "logger", function() {
    return 0, _core.logger;
});
parcelHelpers.export(exports, "makeMultiplexedTransport", function() {
    return 0, _core.makeMultiplexedTransport;
});
parcelHelpers.export(exports, "metrics", function() {
    return 0, _core.metrics;
});
parcelHelpers.export(exports, "moduleMetadataIntegration", function() {
    return 0, _core.moduleMetadataIntegration;
});
parcelHelpers.export(exports, "parameterize", function() {
    return 0, _core.parameterize;
});
parcelHelpers.export(exports, "registerSpanErrorInstrumentation", function() {
    return 0, _core.registerSpanErrorInstrumentation;
});
parcelHelpers.export(exports, "rewriteFramesIntegration", function() {
    return 0, _core.rewriteFramesIntegration;
});
parcelHelpers.export(exports, "setContext", function() {
    return 0, _core.setContext;
});
parcelHelpers.export(exports, "setCurrentClient", function() {
    return 0, _core.setCurrentClient;
});
parcelHelpers.export(exports, "setExtra", function() {
    return 0, _core.setExtra;
});
parcelHelpers.export(exports, "setExtras", function() {
    return 0, _core.setExtras;
});
parcelHelpers.export(exports, "setHttpStatus", function() {
    return 0, _core.setHttpStatus;
});
parcelHelpers.export(exports, "setMeasurement", function() {
    return 0, _core.setMeasurement;
});
parcelHelpers.export(exports, "setTag", function() {
    return 0, _core.setTag;
});
parcelHelpers.export(exports, "setTags", function() {
    return 0, _core.setTags;
});
parcelHelpers.export(exports, "setUser", function() {
    return 0, _core.setUser;
});
parcelHelpers.export(exports, "spanToBaggageHeader", function() {
    return 0, _core.spanToBaggageHeader;
});
parcelHelpers.export(exports, "spanToJSON", function() {
    return 0, _core.spanToJSON;
});
parcelHelpers.export(exports, "spanToTraceHeader", function() {
    return 0, _core.spanToTraceHeader;
});
parcelHelpers.export(exports, "startInactiveSpan", function() {
    return 0, _core.startInactiveSpan;
});
parcelHelpers.export(exports, "startNewTrace", function() {
    return 0, _core.startNewTrace;
});
parcelHelpers.export(exports, "startSession", function() {
    return 0, _core.startSession;
});
parcelHelpers.export(exports, "startSpan", function() {
    return 0, _core.startSpan;
});
parcelHelpers.export(exports, "startSpanManual", function() {
    return 0, _core.startSpanManual;
});
parcelHelpers.export(exports, "supabaseIntegration", function() {
    return 0, _core.supabaseIntegration;
});
parcelHelpers.export(exports, "suppressTracing", function() {
    return 0, _core.suppressTracing;
});
parcelHelpers.export(exports, "thirdPartyErrorFilterIntegration", function() {
    return 0, _core.thirdPartyErrorFilterIntegration;
});
parcelHelpers.export(exports, "updateSpanName", function() {
    return 0, _core.updateSpanName;
});
parcelHelpers.export(exports, "withActiveSpan", function() {
    return 0, _core.withActiveSpan;
});
parcelHelpers.export(exports, "withIsolationScope", function() {
    return 0, _core.withIsolationScope;
});
parcelHelpers.export(exports, "withScope", function() {
    return 0, _core.withScope;
});
parcelHelpers.export(exports, "zodErrorsIntegration", function() {
    return 0, _core.zodErrorsIntegration;
});
parcelHelpers.export(exports, "WINDOW", function() {
    return 0, _helpersJs.WINDOW;
});
parcelHelpers.export(exports, "BrowserClient", function() {
    return 0, _clientJs.BrowserClient;
});
parcelHelpers.export(exports, "makeFetchTransport", function() {
    return 0, _fetchJs.makeFetchTransport;
});
parcelHelpers.export(exports, "uiProfiler", function() {
    return 0, _indexJs.uiProfiler;
});
parcelHelpers.export(exports, "chromeStackLineParser", function() {
    return 0, _stackParsersJs.chromeStackLineParser;
});
parcelHelpers.export(exports, "defaultStackLineParsers", function() {
    return 0, _stackParsersJs.defaultStackLineParsers;
});
parcelHelpers.export(exports, "defaultStackParser", function() {
    return 0, _stackParsersJs.defaultStackParser;
});
parcelHelpers.export(exports, "geckoStackLineParser", function() {
    return 0, _stackParsersJs.geckoStackLineParser;
});
parcelHelpers.export(exports, "opera10StackLineParser", function() {
    return 0, _stackParsersJs.opera10StackLineParser;
});
parcelHelpers.export(exports, "opera11StackLineParser", function() {
    return 0, _stackParsersJs.opera11StackLineParser;
});
parcelHelpers.export(exports, "winjsStackLineParser", function() {
    return 0, _stackParsersJs.winjsStackLineParser;
});
parcelHelpers.export(exports, "eventFromException", function() {
    return 0, _eventbuilderJs.eventFromException;
});
parcelHelpers.export(exports, "eventFromMessage", function() {
    return 0, _eventbuilderJs.eventFromMessage;
});
parcelHelpers.export(exports, "exceptionFromError", function() {
    return 0, _eventbuilderJs.exceptionFromError;
});
parcelHelpers.export(exports, "createUserFeedbackEnvelope", function() {
    return 0, _userfeedbackJs.createUserFeedbackEnvelope;
});
parcelHelpers.export(exports, "forceLoad", function() {
    return 0, _sdkJs.forceLoad;
});
parcelHelpers.export(exports, "getDefaultIntegrations", function() {
    return 0, _sdkJs.getDefaultIntegrations;
});
parcelHelpers.export(exports, "init", function() {
    return 0, _sdkJs.init;
});
parcelHelpers.export(exports, "onLoad", function() {
    return 0, _sdkJs.onLoad;
});
parcelHelpers.export(exports, "showReportDialog", function() {
    return 0, _reportDialogJs.showReportDialog;
});
parcelHelpers.export(exports, "breadcrumbsIntegration", function() {
    return 0, _breadcrumbsJs.breadcrumbsIntegration;
});
parcelHelpers.export(exports, "globalHandlersIntegration", function() {
    return 0, _globalhandlersJs.globalHandlersIntegration;
});
parcelHelpers.export(exports, "httpContextIntegration", function() {
    return 0, _httpcontextJs.httpContextIntegration;
});
parcelHelpers.export(exports, "linkedErrorsIntegration", function() {
    return 0, _linkederrorsJs.linkedErrorsIntegration;
});
parcelHelpers.export(exports, "browserApiErrorsIntegration", function() {
    return 0, _browserapierrorsJs.browserApiErrorsIntegration;
});
parcelHelpers.export(exports, "lazyLoadIntegration", function() {
    return 0, _lazyLoadIntegrationJs.lazyLoadIntegration;
});
parcelHelpers.export(exports, "reportingObserverIntegration", function() {
    return 0, _reportingobserverJs.reportingObserverIntegration;
});
parcelHelpers.export(exports, "httpClientIntegration", function() {
    return 0, _httpclientJs.httpClientIntegration;
});
parcelHelpers.export(exports, "contextLinesIntegration", function() {
    return 0, _contextlinesJs.contextLinesIntegration;
});
parcelHelpers.export(exports, "graphqlClientIntegration", function() {
    return 0, _graphqlClientJs.graphqlClientIntegration;
});
parcelHelpers.export(exports, "getReplay", function() {
    return 0, _replay.getReplay;
});
parcelHelpers.export(exports, "replayIntegration", function() {
    return 0, _replay.replayIntegration;
});
parcelHelpers.export(exports, "replayCanvasIntegration", function() {
    return 0, _replayCanvas.replayCanvasIntegration;
});
parcelHelpers.export(exports, "getFeedback", function() {
    return 0, _feedback.getFeedback;
});
parcelHelpers.export(exports, "sendFeedback", function() {
    return 0, _feedback.sendFeedback;
});
parcelHelpers.export(exports, "defaultRequestInstrumentationOptions", function() {
    return 0, _requestJs.defaultRequestInstrumentationOptions;
});
parcelHelpers.export(exports, "instrumentOutgoingRequests", function() {
    return 0, _requestJs.instrumentOutgoingRequests;
});
parcelHelpers.export(exports, "browserTracingIntegration", function() {
    return 0, _browserTracingIntegrationJs.browserTracingIntegration;
});
parcelHelpers.export(exports, "startBrowserTracingNavigationSpan", function() {
    return 0, _browserTracingIntegrationJs.startBrowserTracingNavigationSpan;
});
parcelHelpers.export(exports, "startBrowserTracingPageLoadSpan", function() {
    return 0, _browserTracingIntegrationJs.startBrowserTracingPageLoadSpan;
});
parcelHelpers.export(exports, "reportPageLoaded", function() {
    return 0, _reportPageLoadedJs.reportPageLoaded;
});
parcelHelpers.export(exports, "setActiveSpanInBrowser", function() {
    return 0, _setActiveSpanJs.setActiveSpanInBrowser;
});
parcelHelpers.export(exports, "makeBrowserOfflineTransport", function() {
    return 0, _offlineJs.makeBrowserOfflineTransport;
});
parcelHelpers.export(exports, "browserProfilingIntegration", function() {
    return 0, _integrationJs.browserProfilingIntegration;
});
parcelHelpers.export(exports, "spotlightBrowserIntegration", function() {
    return 0, _spotlightJs.spotlightBrowserIntegration;
});
parcelHelpers.export(exports, "browserSessionIntegration", function() {
    return 0, _browsersessionJs.browserSessionIntegration;
});
parcelHelpers.export(exports, "buildLaunchDarklyFlagUsedHandler", function() {
    return 0, _integrationJs1.buildLaunchDarklyFlagUsedHandler;
});
parcelHelpers.export(exports, "launchDarklyIntegration", function() {
    return 0, _integrationJs1.launchDarklyIntegration;
});
parcelHelpers.export(exports, "OpenFeatureIntegrationHook", function() {
    return 0, _integrationJs2.OpenFeatureIntegrationHook;
});
parcelHelpers.export(exports, "openFeatureIntegration", function() {
    return 0, _integrationJs2.openFeatureIntegration;
});
parcelHelpers.export(exports, "unleashIntegration", function() {
    return 0, _integrationJs3.unleashIntegration;
});
parcelHelpers.export(exports, "growthbookIntegration", function() {
    return 0, _integrationJs4.growthbookIntegration;
});
parcelHelpers.export(exports, "statsigIntegration", function() {
    return 0, _integrationJs5.statsigIntegration;
});
parcelHelpers.export(exports, "diagnoseSdkConnectivity", function() {
    return 0, _diagnoseSdkJs.diagnoseSdkConnectivity;
});
parcelHelpers.export(exports, "registerWebWorker", function() {
    return 0, _webWorkerJs.registerWebWorker;
});
parcelHelpers.export(exports, "webWorkerIntegration", function() {
    return 0, _webWorkerJs.webWorkerIntegration;
});
var _feedbackAsyncJs = require("./feedbackAsync.js");
var _feedbackSyncJs = require("./feedbackSync.js");
var _core = require("@sentry/core");
var _helpersJs = require("./helpers.js");
var _clientJs = require("./client.js");
var _fetchJs = require("./transports/fetch.js");
var _indexJs = require("./profiling/index.js");
var _stackParsersJs = require("./stack-parsers.js");
var _eventbuilderJs = require("./eventbuilder.js");
var _userfeedbackJs = require("./userfeedback.js");
var _sdkJs = require("./sdk.js");
var _reportDialogJs = require("./report-dialog.js");
var _breadcrumbsJs = require("./integrations/breadcrumbs.js");
var _globalhandlersJs = require("./integrations/globalhandlers.js");
var _httpcontextJs = require("./integrations/httpcontext.js");
var _linkederrorsJs = require("./integrations/linkederrors.js");
var _browserapierrorsJs = require("./integrations/browserapierrors.js");
var _lazyLoadIntegrationJs = require("./utils/lazyLoadIntegration.js");
var _reportingobserverJs = require("./integrations/reportingobserver.js");
var _httpclientJs = require("./integrations/httpclient.js");
var _contextlinesJs = require("./integrations/contextlines.js");
var _graphqlClientJs = require("./integrations/graphqlClient.js");
var _replay = require("@sentry-internal/replay");
var _replayCanvas = require("@sentry-internal/replay-canvas");
var _feedback = require("@sentry-internal/feedback");
var _requestJs = require("./tracing/request.js");
var _browserTracingIntegrationJs = require("./tracing/browserTracingIntegration.js");
var _reportPageLoadedJs = require("./tracing/reportPageLoaded.js");
var _setActiveSpanJs = require("./tracing/setActiveSpan.js");
var _offlineJs = require("./transports/offline.js");
var _integrationJs = require("./profiling/integration.js");
var _spotlightJs = require("./integrations/spotlight.js");
var _browsersessionJs = require("./integrations/browsersession.js");
var _integrationJs1 = require("./integrations/featureFlags/launchdarkly/integration.js");
var _integrationJs2 = require("./integrations/featureFlags/openfeature/integration.js");
var _integrationJs3 = require("./integrations/featureFlags/unleash/integration.js");
var _integrationJs4 = require("./integrations/featureFlags/growthbook/integration.js");
var _integrationJs5 = require("./integrations/featureFlags/statsig/integration.js");
var _diagnoseSdkJs = require("./diagnose-sdk.js");
var _webWorkerJs = require("./integrations/webWorker.js");

},{"./feedbackAsync.js":"c8RhX","./feedbackSync.js":"78329","@sentry/core":"lqtxA","./helpers.js":"45G1f","./client.js":"k9FBA","./transports/fetch.js":"6NfhH","./profiling/index.js":"8qS5R","./stack-parsers.js":"82YO9","./eventbuilder.js":"gS96Q","./userfeedback.js":"7O5e0","./sdk.js":"8Y6ls","./report-dialog.js":"1iWb1","./integrations/breadcrumbs.js":"dGpRx","./integrations/globalhandlers.js":"1Jyt8","./integrations/httpcontext.js":"kBg3j","./integrations/linkederrors.js":"1L5lO","./integrations/browserapierrors.js":"hsRAR","./utils/lazyLoadIntegration.js":"Y9Rnv","./integrations/reportingobserver.js":"lITBT","./integrations/httpclient.js":"iYWTa","./integrations/contextlines.js":"aTnWH","./integrations/graphqlClient.js":"3DhuF","@sentry-internal/replay":"eIDrB","@sentry-internal/replay-canvas":"aasNs","@sentry-internal/feedback":"inibQ","./tracing/request.js":"iYAFH","./tracing/browserTracingIntegration.js":"hs3de","./tracing/reportPageLoaded.js":"4gdAj","./tracing/setActiveSpan.js":"5QjiO","./transports/offline.js":"k5FyM","./profiling/integration.js":"jt2uL","./integrations/spotlight.js":"eCM3r","./integrations/browsersession.js":"80LXs","./integrations/featureFlags/launchdarkly/integration.js":"hCiRd","./integrations/featureFlags/openfeature/integration.js":"asldQ","./integrations/featureFlags/unleash/integration.js":"cqtF8","./integrations/featureFlags/growthbook/integration.js":"7OGqW","./integrations/featureFlags/statsig/integration.js":"bxBEx","./diagnose-sdk.js":"1E4Re","./integrations/webWorker.js":"aDjEx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"c8RhX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "feedbackAsyncIntegration", function() {
    return feedbackAsyncIntegration;
});
var _feedback = require("@sentry-internal/feedback");
var _lazyLoadIntegrationJs = require("./utils/lazyLoadIntegration.js");
/**
 * An integration to add user feedback to your application,
 * while loading most of the code lazily only when it's needed.
 */ var feedbackAsyncIntegration = (0, _feedback.buildFeedbackIntegration)({
    lazyLoadIntegration: (0, _lazyLoadIntegrationJs.lazyLoadIntegration)
});

},{"@sentry-internal/feedback":"inibQ","./utils/lazyLoadIntegration.js":"Y9Rnv","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"inibQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildFeedbackIntegration", function() {
    return buildFeedbackIntegration;
});
parcelHelpers.export(exports, "feedbackModalIntegration", function() {
    return feedbackModalIntegration;
});
parcelHelpers.export(exports, "feedbackScreenshotIntegration", function() {
    return feedbackScreenshotIntegration;
});
parcelHelpers.export(exports, "getFeedback", function() {
    return getFeedback;
});
parcelHelpers.export(exports, "sendFeedback", function() {
    return sendFeedback;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _core = require("@sentry/core");
// exporting a separate copy of `WINDOW` rather than exporting the one from `@sentry/browser`
// prevents the browser package from being bundled in the CDN bundle, and avoids a
// circular dependency between the browser and feedback packages
var WINDOW = (0, _core.GLOBAL_OBJ);
var DOCUMENT = WINDOW.document;
var NAVIGATOR = WINDOW.navigator;
var TRIGGER_LABEL = 'Report a Bug';
var CANCEL_BUTTON_LABEL = 'Cancel';
var SUBMIT_BUTTON_LABEL = 'Send Bug Report';
var CONFIRM_BUTTON_LABEL = 'Confirm';
var FORM_TITLE = 'Report a Bug';
var EMAIL_PLACEHOLDER = 'your.email@example.org';
var EMAIL_LABEL = 'Email';
var MESSAGE_PLACEHOLDER = "What's the bug? What did you expect?";
var MESSAGE_LABEL = 'Description';
var NAME_PLACEHOLDER = 'Your Name';
var NAME_LABEL = 'Name';
var SUCCESS_MESSAGE_TEXT = 'Thank you for your report!';
var IS_REQUIRED_LABEL = '(required)';
var ADD_SCREENSHOT_LABEL = 'Add a screenshot';
var REMOVE_SCREENSHOT_LABEL = 'Remove screenshot';
var HIGHLIGHT_TOOL_TEXT = 'Highlight';
var HIDE_TOOL_TEXT = 'Hide';
var REMOVE_HIGHLIGHT_TEXT = 'Remove';
var FEEDBACK_WIDGET_SOURCE = 'widget';
var FEEDBACK_API_SOURCE = 'api';
var SUCCESS_MESSAGE_TIMEOUT = 5000;
/**
 * Public API to send a Feedback item to Sentry
 */ var sendFeedback = function(params) {
    var hint = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        includeReplay: true
    };
    if (!params.message) throw new Error('Unable to submit feedback with empty message');
    // We want to wait for the feedback to be sent (or not)
    var client = (0, _core.getClient)();
    if (!client) throw new Error('No client setup, cannot send feedback.');
    if (params.tags && Object.keys(params.tags).length) (0, _core.getCurrentScope)().setTags(params.tags);
    var eventId = (0, _core.captureFeedback)((0, _objectSpread._)({
        source: FEEDBACK_API_SOURCE,
        url: (0, _core.getLocationHref)()
    }, params), hint);
    // We want to wait for the feedback to be sent (or not)
    return new Promise(function(resolve, reject) {
        // After 30s, we want to clear anyhow
        var timeout = setTimeout(function() {
            return reject('Unable to determine if Feedback was correctly sent.');
        }, 30000);
        var cleanup = client.on('afterSendEvent', function(event, response) {
            if (event.event_id !== eventId) return;
            clearTimeout(timeout);
            cleanup();
            // Require valid status codes, otherwise can assume feedback was not sent successfully
            if ((response === null || response === void 0 ? void 0 : response.statusCode) && response.statusCode >= 200 && response.statusCode < 300) return resolve(eventId);
            if ((response === null || response === void 0 ? void 0 : response.statusCode) === 403) return reject('Unable to send feedback. This could be because this domain is not in your list of allowed domains.');
            return reject('Unable to send feedback. This could be because of network issues, or because you are using an ad-blocker.');
        });
    });
};
/*
 * For reference, the fully built event looks something like this:
 * {
 *     "type": "feedback",
 *     "event_id": "d2132d31b39445f1938d7e21b6bf0ec4",
 *     "timestamp": 1597977777.6189718,
 *     "dist": "1.12",
 *     "platform": "javascript",
 *     "environment": "production",
 *     "release": 42,
 *     "tags": {"transaction": "/organizations/:orgId/performance/:eventSlug/"},
 *     "sdk": {"name": "name", "version": "version"},
 *     "user": {
 *         "id": "123",
 *         "username": "user",
 *         "email": "user@site.com",
 *         "ip_address": "192.168.11.12",
 *     },
 *     "request": {
 *         "url": None,
 *         "headers": {
 *             "user-Agent": "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/15.5 Safari/605.1.15"
 *         },
 *     },
 *     "contexts": {
 *         "feedback": {
 *             "message": "test message",
 *             "contact_email": "test@example.com",
 *             "type": "feedback",
 *         },
 *         "trace": {
 *             "trace_id": "4C79F60C11214EB38604F4AE0781BFB2",
 *             "span_id": "FA90FDEAD5F74052",
 *             "type": "trace",
 *         },
 *         "replay": {
 *             "replay_id": "e2d42047b1c5431c8cba85ee2a8ab25d",
 *         },
 *     },
 *   }
 */ /**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ var DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;
/**
 * Mobile browsers do not support `mediaDevices.getDisplayMedia` even though they have the api implemented
 * Instead they return things like `NotAllowedError` when called.
 *
 * It's simpler for us to browser sniff first, and avoid loading the integration if we can.
 *
 * https://stackoverflow.com/a/58879212
 * https://stackoverflow.com/a/3540295
 *
 * `mediaDevices.getDisplayMedia` is also only supported in secure contexts, and return a `mediaDevices is not supported` error, so we should also avoid loading the integration if we can.
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getDisplayMedia
 */ function isScreenshotSupported() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(NAVIGATOR.userAgent)) return false;
    /**
   * User agent on iPads show as Macintosh, so we need extra checks
   *
   * https://forums.developer.apple.com/forums/thread/119186
   * https://stackoverflow.com/questions/60482650/how-to-detect-ipad-useragent-on-safari-browser
   */ if (/Macintosh/i.test(NAVIGATOR.userAgent) && NAVIGATOR.maxTouchPoints && NAVIGATOR.maxTouchPoints > 1) return false;
    if (!isSecureContext) return false;
    return true;
}
/**
 * Quick and dirty deep merge for the Feedback integration options
 */ function mergeOptions(defaultOptions, optionOverrides) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, defaultOptions, optionOverrides), {
        tags: (0, _objectSpread._)({}, defaultOptions.tags, optionOverrides.tags),
        onFormOpen: function() {
            var _optionOverrides_onFormOpen, _defaultOptions_onFormOpen;
            (_optionOverrides_onFormOpen = optionOverrides.onFormOpen) === null || _optionOverrides_onFormOpen === void 0 ? void 0 : _optionOverrides_onFormOpen.call(optionOverrides);
            (_defaultOptions_onFormOpen = defaultOptions.onFormOpen) === null || _defaultOptions_onFormOpen === void 0 ? void 0 : _defaultOptions_onFormOpen.call(defaultOptions);
        },
        onFormClose: function() {
            var _optionOverrides_onFormClose, _defaultOptions_onFormClose;
            (_optionOverrides_onFormClose = optionOverrides.onFormClose) === null || _optionOverrides_onFormClose === void 0 ? void 0 : _optionOverrides_onFormClose.call(optionOverrides);
            (_defaultOptions_onFormClose = defaultOptions.onFormClose) === null || _defaultOptions_onFormClose === void 0 ? void 0 : _defaultOptions_onFormClose.call(defaultOptions);
        },
        onSubmitSuccess: function(data, eventId) {
            var _optionOverrides_onSubmitSuccess, _defaultOptions_onSubmitSuccess;
            (_optionOverrides_onSubmitSuccess = optionOverrides.onSubmitSuccess) === null || _optionOverrides_onSubmitSuccess === void 0 ? void 0 : _optionOverrides_onSubmitSuccess.call(optionOverrides, data, eventId);
            (_defaultOptions_onSubmitSuccess = defaultOptions.onSubmitSuccess) === null || _defaultOptions_onSubmitSuccess === void 0 ? void 0 : _defaultOptions_onSubmitSuccess.call(defaultOptions, data, eventId);
        },
        onSubmitError: function(error) {
            var _optionOverrides_onSubmitError, _defaultOptions_onSubmitError;
            (_optionOverrides_onSubmitError = optionOverrides.onSubmitError) === null || _optionOverrides_onSubmitError === void 0 ? void 0 : _optionOverrides_onSubmitError.call(optionOverrides, error);
            (_defaultOptions_onSubmitError = defaultOptions.onSubmitError) === null || _defaultOptions_onSubmitError === void 0 ? void 0 : _defaultOptions_onSubmitError.call(defaultOptions, error);
        },
        onFormSubmitted: function() {
            var _optionOverrides_onFormSubmitted, _defaultOptions_onFormSubmitted;
            (_optionOverrides_onFormSubmitted = optionOverrides.onFormSubmitted) === null || _optionOverrides_onFormSubmitted === void 0 ? void 0 : _optionOverrides_onFormSubmitted.call(optionOverrides);
            (_defaultOptions_onFormSubmitted = defaultOptions.onFormSubmitted) === null || _defaultOptions_onFormSubmitted === void 0 ? void 0 : _defaultOptions_onFormSubmitted.call(defaultOptions);
        },
        themeDark: (0, _objectSpread._)({}, defaultOptions.themeDark, optionOverrides.themeDark),
        themeLight: (0, _objectSpread._)({}, defaultOptions.themeLight, optionOverrides.themeLight)
    });
}
/**
 * Creates <style> element for widget actor (button that opens the dialog)
 */ function createActorStyles(styleNonce) {
    var style = DOCUMENT.createElement('style');
    style.textContent = '\n.widget__actor {\n  position: fixed;\n  z-index: var(--z-index);\n  margin: var(--page-margin);\n  inset: var(--actor-inset);\n\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 16px;\n\n  font-family: inherit;\n  font-size: var(--font-size);\n  font-weight: 600;\n  line-height: 1.14em;\n  text-decoration: none;\n\n  background: var(--actor-background, var(--background));\n  border-radius: var(--actor-border-radius, 1.7em/50%);\n  border: var(--actor-border, var(--border));\n  box-shadow: var(--actor-box-shadow, var(--box-shadow));\n  color: var(--actor-color, var(--foreground));\n  fill: var(--actor-color, var(--foreground));\n  cursor: pointer;\n  opacity: 1;\n  transition: transform 0.2s ease-in-out;\n  transform: translate(0, 0) scale(1);\n}\n.widget__actor[aria-hidden="true"] {\n  opacity: 0;\n  pointer-events: none;\n  visibility: hidden;\n  transform: translate(0, 16px) scale(0.98);\n}\n\n.widget__actor:hover {\n  background: var(--actor-hover-background, var(--background));\n  filter: var(--interactive-filter);\n}\n\n.widget__actor svg {\n  width: 1.14em;\n  height: 1.14em;\n}\n\n@media (max-width: 600px) {\n  .widget__actor span {\n    display: none;\n  }\n}\n';
    if (styleNonce) style.setAttribute('nonce', styleNonce);
    return style;
}
/**
 * Helper function to set a dict of attributes on element (w/ specified namespace)
 */ function setAttributesNS(el, attributes) {
    Object.entries(attributes).forEach(function(param) {
        var _param = (0, _slicedToArray._)(param, 2), key = _param[0], val = _param[1];
        el.setAttributeNS(null, key, val);
    });
    return el;
}
var SIZE = 20;
var XMLNS$2 = 'http://www.w3.org/2000/svg';
/**
 * Feedback Icon
 */ function FeedbackIcon() {
    var createElementNS = function(tagName) {
        return WINDOW.document.createElementNS(XMLNS$2, tagName);
    };
    var svg = setAttributesNS(createElementNS('svg'), {
        width: "".concat(SIZE),
        height: "".concat(SIZE),
        viewBox: "0 0 ".concat(SIZE, " ").concat(SIZE),
        fill: 'var(--actor-color, var(--foreground))'
    });
    var _$g = setAttributesNS(createElementNS('g'), {
        clipPath: 'url(#clip0_57_80)'
    });
    var _obj;
    var path = setAttributesNS(createElementNS('path'), (_obj = {}, (0, _defineProperty._)(_obj, 'fill-rule', 'evenodd'), (0, _defineProperty._)(_obj, 'clip-rule', 'evenodd'), (0, _defineProperty._)(_obj, "d", 'M15.6622 15H12.3997C12.2129 14.9959 12.031 14.9396 11.8747 14.8375L8.04965 12.2H7.49956V19.1C7.4875 19.3348 7.3888 19.5568 7.22256 19.723C7.05632 19.8892 6.83435 19.9879 6.59956 20H2.04956C1.80193 19.9968 1.56535 19.8969 1.39023 19.7218C1.21511 19.5467 1.1153 19.3101 1.11206 19.0625V12.2H0.949652C0.824431 12.2017 0.700142 12.1783 0.584123 12.1311C0.468104 12.084 0.362708 12.014 0.274155 11.9255C0.185602 11.8369 0.115689 11.7315 0.0685419 11.6155C0.0213952 11.4995 -0.00202913 11.3752 -0.00034808 11.25V3.75C-0.00900498 3.62067 0.0092504 3.49095 0.0532651 3.36904C0.0972798 3.24712 0.166097 3.13566 0.255372 3.04168C0.344646 2.94771 0.452437 2.87327 0.571937 2.82307C0.691437 2.77286 0.82005 2.74798 0.949652 2.75H8.04965L11.8747 0.1625C12.031 0.0603649 12.2129 0.00407221 12.3997 0H15.6622C15.9098 0.00323746 16.1464 0.103049 16.3215 0.278167C16.4966 0.453286 16.5964 0.689866 16.5997 0.9375V3.25269C17.3969 3.42959 18.1345 3.83026 18.7211 4.41679C19.5322 5.22788 19.9878 6.32796 19.9878 7.47502C19.9878 8.62209 19.5322 9.72217 18.7211 10.5333C18.1345 11.1198 17.3969 11.5205 16.5997 11.6974V14.0125C16.6047 14.1393 16.5842 14.2659 16.5395 14.3847C16.4948 14.5035 16.4268 14.6121 16.3394 14.7042C16.252 14.7962 16.147 14.8698 16.0307 14.9206C15.9144 14.9714 15.7891 14.9984 15.6622 15ZM1.89695 10.325H1.88715V4.625H8.33715C8.52423 4.62301 8.70666 4.56654 8.86215 4.4625L12.6872 1.875H14.7247V13.125H12.6872L8.86215 10.4875C8.70666 10.3835 8.52423 10.327 8.33715 10.325H2.20217C2.15205 10.3167 2.10102 10.3125 2.04956 10.3125C1.9981 10.3125 1.94708 10.3167 1.89695 10.325ZM2.98706 12.2V18.1625H5.66206V12.2H2.98706ZM16.5997 9.93612V5.01393C16.6536 5.02355 16.7072 5.03495 16.7605 5.04814C17.1202 5.13709 17.4556 5.30487 17.7425 5.53934C18.0293 5.77381 18.2605 6.06912 18.4192 6.40389C18.578 6.73866 18.6603 7.10452 18.6603 7.47502C18.6603 7.84552 18.578 8.21139 18.4192 8.54616C18.2605 8.88093 18.0293 9.17624 17.7425 9.41071C17.4556 9.64518 17.1202 9.81296 16.7605 9.90191C16.7072 9.91509 16.6536 9.9265 16.5997 9.93612Z'), _obj));
    svg.appendChild(_$g).appendChild(path);
    var speakerDefs = createElementNS('defs');
    var speakerClipPathDef = setAttributesNS(createElementNS('clipPath'), {
        id: 'clip0_57_80'
    });
    var speakerRect = setAttributesNS(createElementNS('rect'), {
        width: "".concat(SIZE),
        height: "".concat(SIZE),
        fill: 'white'
    });
    speakerClipPathDef.appendChild(speakerRect);
    speakerDefs.appendChild(speakerClipPathDef);
    svg.appendChild(speakerDefs).appendChild(speakerClipPathDef).appendChild(speakerRect);
    return svg;
}
/**
 * The sentry-provided button to open the feedback modal
 */ function Actor(param) {
    var triggerLabel = param.triggerLabel, triggerAriaLabel = param.triggerAriaLabel, shadow = param.shadow, styleNonce = param.styleNonce;
    var el = DOCUMENT.createElement('button');
    el.type = 'button';
    el.className = 'widget__actor';
    el.ariaHidden = 'false';
    el.ariaLabel = triggerAriaLabel || triggerLabel || TRIGGER_LABEL;
    el.appendChild(FeedbackIcon());
    if (triggerLabel) {
        var label = DOCUMENT.createElement('span');
        label.appendChild(DOCUMENT.createTextNode(triggerLabel));
        el.appendChild(label);
    }
    var style = createActorStyles(styleNonce);
    return {
        el: el,
        appendToDom: function appendToDom() {
            shadow.appendChild(style);
            shadow.appendChild(el);
        },
        removeFromDom: function removeFromDom() {
            el.remove();
            style.remove();
        },
        show: function show() {
            el.ariaHidden = 'false';
        },
        hide: function hide() {
            el.ariaHidden = 'true';
        }
    };
}
var PURPLE = 'rgba(88, 74, 192, 1)';
var DEFAULT_LIGHT = {
    foreground: '#2b2233',
    background: '#ffffff',
    accentForeground: 'white',
    accentBackground: PURPLE,
    successColor: '#268d75',
    errorColor: '#df3338',
    border: '1.5px solid rgba(41, 35, 47, 0.13)',
    boxShadow: '0px 4px 24px 0px rgba(43, 34, 51, 0.12)',
    outline: '1px auto var(--accent-background)',
    interactiveFilter: 'brightness(95%)'
};
var DEFAULT_DARK = {
    foreground: '#ebe6ef',
    background: '#29232f',
    accentForeground: 'white',
    accentBackground: PURPLE,
    successColor: '#2da98c',
    errorColor: '#f55459',
    border: '1.5px solid rgba(235, 230, 239, 0.15)',
    boxShadow: '0px 4px 24px 0px rgba(43, 34, 51, 0.12)',
    outline: '1px auto var(--accent-background)',
    interactiveFilter: 'brightness(150%)'
};
function getThemedCssVariables(theme) {
    return "\n  --foreground: ".concat(theme.foreground, ";\n  --background: ").concat(theme.background, ";\n  --accent-foreground: ").concat(theme.accentForeground, ";\n  --accent-background: ").concat(theme.accentBackground, ";\n  --success-color: ").concat(theme.successColor, ";\n  --error-color: ").concat(theme.errorColor, ";\n  --border: ").concat(theme.border, ";\n  --box-shadow: ").concat(theme.boxShadow, ";\n  --outline: ").concat(theme.outline, ";\n  --interactive-filter: ").concat(theme.interactiveFilter, ";\n  ");
}
/**
 * Creates <style> element for widget actor (button that opens the dialog)
 */ function createMainStyles(param) {
    var colorScheme = param.colorScheme, themeDark = param.themeDark, themeLight = param.themeLight, styleNonce = param.styleNonce;
    var style = DOCUMENT.createElement('style');
    style.textContent = "\n:host {\n  --font-family: system-ui, 'Helvetica Neue', Arial, sans-serif;\n  --font-size: 14px;\n  --z-index: 100000;\n\n  --page-margin: 16px;\n  --inset: auto 0 0 auto;\n  --actor-inset: var(--inset);\n\n  font-family: var(--font-family);\n  font-size: var(--font-size);\n\n  ".concat(colorScheme !== 'system' ? 'color-scheme: only light;' : '', "\n\n  ").concat(getThemedCssVariables(colorScheme === 'dark' ? (0, _objectSpread._)({}, DEFAULT_DARK, themeDark) : (0, _objectSpread._)({}, DEFAULT_LIGHT, themeLight)), "\n}\n\n").concat(colorScheme === 'system' ? "\n@media (prefers-color-scheme: dark) {\n  :host {\n    ".concat(getThemedCssVariables((0, _objectSpread._)({}, DEFAULT_DARK, themeDark)), "\n  }\n}") : '', "\n}\n");
    if (styleNonce) style.setAttribute('nonce', styleNonce);
    return style;
}
var buildFeedbackIntegration = function(param) {
    var lazyLoadIntegration = param.lazyLoadIntegration, getModalIntegration = param.getModalIntegration, getScreenshotIntegration = param.getScreenshotIntegration;
    var feedbackIntegration = function() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_id = _ref.// FeedbackGeneralConfiguration
        id, id = _ref_id === void 0 ? 'sentry-feedback' : _ref_id, _ref_autoInject = _ref.autoInject, autoInject = _ref_autoInject === void 0 ? true : _ref_autoInject, _ref_showBranding = _ref.showBranding, showBranding = _ref_showBranding === void 0 ? true : _ref_showBranding, _ref_isEmailRequired = _ref.isEmailRequired, isEmailRequired = _ref_isEmailRequired === void 0 ? false : _ref_isEmailRequired, _ref_isNameRequired = _ref.isNameRequired, isNameRequired = _ref_isNameRequired === void 0 ? false : _ref_isNameRequired, _ref_showEmail = _ref.showEmail, showEmail = _ref_showEmail === void 0 ? true : _ref_showEmail, _ref_showName = _ref.showName, showName = _ref_showName === void 0 ? true : _ref_showName, _ref_enableScreenshot = _ref.enableScreenshot, enableScreenshot = _ref_enableScreenshot === void 0 ? true : _ref_enableScreenshot, _ref_useSentryUser = _ref.useSentryUser, useSentryUser = _ref_useSentryUser === void 0 ? {
            email: 'email',
            name: 'username'
        } : _ref_useSentryUser, tags = _ref.tags, styleNonce = _ref.styleNonce, scriptNonce = _ref.scriptNonce, _ref_colorScheme = _ref.// FeedbackThemeConfiguration
        colorScheme, colorScheme = _ref_colorScheme === void 0 ? 'system' : _ref_colorScheme, _ref_themeLight = _ref.themeLight, themeLight = _ref_themeLight === void 0 ? {} : _ref_themeLight, _ref_themeDark = _ref.themeDark, themeDark = _ref_themeDark === void 0 ? {} : _ref_themeDark, _ref_addScreenshotButtonLabel = _ref.// FeedbackTextConfiguration
        addScreenshotButtonLabel, addScreenshotButtonLabel = _ref_addScreenshotButtonLabel === void 0 ? ADD_SCREENSHOT_LABEL : _ref_addScreenshotButtonLabel, _ref_cancelButtonLabel = _ref.cancelButtonLabel, cancelButtonLabel = _ref_cancelButtonLabel === void 0 ? CANCEL_BUTTON_LABEL : _ref_cancelButtonLabel, _ref_confirmButtonLabel = _ref.confirmButtonLabel, confirmButtonLabel = _ref_confirmButtonLabel === void 0 ? CONFIRM_BUTTON_LABEL : _ref_confirmButtonLabel, _ref_emailLabel = _ref.emailLabel, emailLabel = _ref_emailLabel === void 0 ? EMAIL_LABEL : _ref_emailLabel, _ref_emailPlaceholder = _ref.emailPlaceholder, emailPlaceholder = _ref_emailPlaceholder === void 0 ? EMAIL_PLACEHOLDER : _ref_emailPlaceholder, _ref_formTitle = _ref.formTitle, formTitle = _ref_formTitle === void 0 ? FORM_TITLE : _ref_formTitle, _ref_isRequiredLabel = _ref.isRequiredLabel, isRequiredLabel = _ref_isRequiredLabel === void 0 ? IS_REQUIRED_LABEL : _ref_isRequiredLabel, _ref_messageLabel = _ref.messageLabel, messageLabel = _ref_messageLabel === void 0 ? MESSAGE_LABEL : _ref_messageLabel, _ref_messagePlaceholder = _ref.messagePlaceholder, messagePlaceholder = _ref_messagePlaceholder === void 0 ? MESSAGE_PLACEHOLDER : _ref_messagePlaceholder, _ref_nameLabel = _ref.nameLabel, nameLabel = _ref_nameLabel === void 0 ? NAME_LABEL : _ref_nameLabel, _ref_namePlaceholder = _ref.namePlaceholder, namePlaceholder = _ref_namePlaceholder === void 0 ? NAME_PLACEHOLDER : _ref_namePlaceholder, _ref_removeScreenshotButtonLabel = _ref.removeScreenshotButtonLabel, removeScreenshotButtonLabel = _ref_removeScreenshotButtonLabel === void 0 ? REMOVE_SCREENSHOT_LABEL : _ref_removeScreenshotButtonLabel, _ref_submitButtonLabel = _ref.submitButtonLabel, submitButtonLabel = _ref_submitButtonLabel === void 0 ? SUBMIT_BUTTON_LABEL : _ref_submitButtonLabel, _ref_successMessageText = _ref.successMessageText, successMessageText = _ref_successMessageText === void 0 ? SUCCESS_MESSAGE_TEXT : _ref_successMessageText, _ref_triggerLabel = _ref.triggerLabel, triggerLabel = _ref_triggerLabel === void 0 ? TRIGGER_LABEL : _ref_triggerLabel, _ref_triggerAriaLabel = _ref.triggerAriaLabel, triggerAriaLabel = _ref_triggerAriaLabel === void 0 ? '' : _ref_triggerAriaLabel, _ref_highlightToolText = _ref.highlightToolText, highlightToolText = _ref_highlightToolText === void 0 ? HIGHLIGHT_TOOL_TEXT : _ref_highlightToolText, _ref_hideToolText = _ref.hideToolText, hideToolText = _ref_hideToolText === void 0 ? HIDE_TOOL_TEXT : _ref_hideToolText, _ref_removeHighlightText = _ref.removeHighlightText, removeHighlightText = _ref_removeHighlightText === void 0 ? REMOVE_HIGHLIGHT_TEXT : _ref_removeHighlightText, // FeedbackCallbacks
        onFormOpen = _ref.onFormOpen, onFormClose = _ref.onFormClose, onSubmitSuccess = _ref.onSubmitSuccess, onSubmitError = _ref.onSubmitError, onFormSubmitted = _ref.onFormSubmitted;
        var _options = {
            id: id,
            autoInject: autoInject,
            showBranding: showBranding,
            isEmailRequired: isEmailRequired,
            isNameRequired: isNameRequired,
            showEmail: showEmail,
            showName: showName,
            enableScreenshot: enableScreenshot,
            useSentryUser: useSentryUser,
            tags: tags,
            styleNonce: styleNonce,
            scriptNonce: scriptNonce,
            colorScheme: colorScheme,
            themeDark: themeDark,
            themeLight: themeLight,
            triggerLabel: triggerLabel,
            triggerAriaLabel: triggerAriaLabel,
            cancelButtonLabel: cancelButtonLabel,
            submitButtonLabel: submitButtonLabel,
            confirmButtonLabel: confirmButtonLabel,
            formTitle: formTitle,
            emailLabel: emailLabel,
            emailPlaceholder: emailPlaceholder,
            messageLabel: messageLabel,
            messagePlaceholder: messagePlaceholder,
            nameLabel: nameLabel,
            namePlaceholder: namePlaceholder,
            successMessageText: successMessageText,
            isRequiredLabel: isRequiredLabel,
            addScreenshotButtonLabel: addScreenshotButtonLabel,
            removeScreenshotButtonLabel: removeScreenshotButtonLabel,
            highlightToolText: highlightToolText,
            hideToolText: hideToolText,
            removeHighlightText: removeHighlightText,
            onFormClose: onFormClose,
            onFormOpen: onFormOpen,
            onSubmitError: onSubmitError,
            onSubmitSuccess: onSubmitSuccess,
            onFormSubmitted: onFormSubmitted
        };
        var _shadow = null;
        var _subscriptions = [];
        /**
     * Get the shadow root where we will append css
     */ var _createShadow = function(options) {
            if (!_shadow) {
                var host = DOCUMENT.createElement('div');
                host.id = String(options.id);
                DOCUMENT.body.appendChild(host);
                _shadow = host.attachShadow({
                    mode: 'open'
                });
                _shadow.appendChild(createMainStyles(options));
            }
            return _shadow;
        };
        var _loadAndRenderDialog = function(options) {
            return (0, _asyncToGenerator._)(function() {
                var screenshotRequired, modalIntegration, screenshotIntegration, modalIntegrationFn, _tmp, e, screenshotIntegrationFn, _tmp1, _tmp2, e1, dialog;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            screenshotRequired = options.enableScreenshot && isScreenshotSupported();
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                5,
                                ,
                                6
                            ]);
                            if (!getModalIntegration) return [
                                3,
                                2
                            ];
                            _tmp = getModalIntegration();
                            return [
                                3,
                                4
                            ];
                        case 2:
                            return [
                                4,
                                lazyLoadIntegration('feedbackModalIntegration', scriptNonce)
                            ];
                        case 3:
                            _tmp = _state.sent();
                            _state.label = 4;
                        case 4:
                            modalIntegrationFn = _tmp;
                            modalIntegration = modalIntegrationFn();
                            (0, _core.addIntegration)(modalIntegration);
                            return [
                                3,
                                6
                            ];
                        case 5:
                            e = _state.sent();
                            DEBUG_BUILD && (0, _core.debug).error('[Feedback] Error when trying to load feedback integrations. Try using `feedbackSyncIntegration` in your `Sentry.init`.');
                            throw new Error('[Feedback] Missing feedback modal integration!');
                        case 6:
                            _state.trys.push([
                                6,
                                12,
                                ,
                                13
                            ]);
                            if (!screenshotRequired) return [
                                3,
                                10
                            ];
                            if (!getScreenshotIntegration) return [
                                3,
                                7
                            ];
                            _tmp2 = getScreenshotIntegration();
                            return [
                                3,
                                9
                            ];
                        case 7:
                            return [
                                4,
                                lazyLoadIntegration('feedbackScreenshotIntegration', scriptNonce)
                            ];
                        case 8:
                            _tmp2 = _state.sent();
                            _state.label = 9;
                        case 9:
                            _tmp1 = _tmp2;
                            return [
                                3,
                                11
                            ];
                        case 10:
                            _tmp1 = undefined;
                            _state.label = 11;
                        case 11:
                            screenshotIntegrationFn = _tmp1;
                            if (screenshotIntegrationFn) {
                                screenshotIntegration = screenshotIntegrationFn();
                                (0, _core.addIntegration)(screenshotIntegration);
                            }
                            return [
                                3,
                                13
                            ];
                        case 12:
                            e1 = _state.sent();
                            DEBUG_BUILD && (0, _core.debug).error('[Feedback] Missing feedback screenshot integration. Proceeding without screenshots.');
                            return [
                                3,
                                13
                            ];
                        case 13:
                            dialog = modalIntegration.createDialog({
                                options: (0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
                                    onFormClose: function() {
                                        var _options_onFormClose;
                                        dialog === null || dialog === void 0 ? void 0 : dialog.close();
                                        (_options_onFormClose = options.onFormClose) === null || _options_onFormClose === void 0 ? void 0 : _options_onFormClose.call(options);
                                    },
                                    onFormSubmitted: function() {
                                        var _options_onFormSubmitted;
                                        dialog === null || dialog === void 0 ? void 0 : dialog.close();
                                        (_options_onFormSubmitted = options.onFormSubmitted) === null || _options_onFormSubmitted === void 0 ? void 0 : _options_onFormSubmitted.call(options);
                                    }
                                }),
                                screenshotIntegration: screenshotIntegration,
                                sendFeedback: sendFeedback,
                                shadow: _createShadow(options)
                            });
                            return [
                                2,
                                dialog
                            ];
                    }
                });
            })();
        };
        var _attachTo = function(el) {
            var optionOverrides = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            var mergedOptions = mergeOptions(_options, optionOverrides);
            var targetEl = typeof el === 'string' ? DOCUMENT.querySelector(el) : typeof el.addEventListener === 'function' ? el : null;
            if (!targetEl) {
                DEBUG_BUILD && (0, _core.debug).error('[Feedback] Unable to attach to target element');
                throw new Error('Unable to attach to target element');
            }
            var dialog = null;
            var handleClick = function() {
                return (0, _asyncToGenerator._)(function() {
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!dialog) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _loadAndRenderDialog((0, _objectSpreadProps._)((0, _objectSpread._)({}, mergedOptions), {
                                        onFormSubmitted: function() {
                                            var _mergedOptions_onFormSubmitted;
                                            dialog === null || dialog === void 0 ? void 0 : dialog.removeFromDom();
                                            (_mergedOptions_onFormSubmitted = mergedOptions.onFormSubmitted) === null || _mergedOptions_onFormSubmitted === void 0 ? void 0 : _mergedOptions_onFormSubmitted.call(mergedOptions);
                                        }
                                    }))
                                ];
                            case 1:
                                dialog = _state.sent();
                                _state.label = 2;
                            case 2:
                                dialog.appendToDom();
                                dialog.open();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
            targetEl.addEventListener('click', handleClick);
            var unsubscribe = function() {
                _subscriptions = _subscriptions.filter(function(sub) {
                    return sub !== unsubscribe;
                });
                dialog === null || dialog === void 0 ? void 0 : dialog.removeFromDom();
                dialog = null;
                targetEl.removeEventListener('click', handleClick);
            };
            _subscriptions.push(unsubscribe);
            return unsubscribe;
        };
        var _createActor = function() {
            var optionOverrides = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            var mergedOptions = mergeOptions(_options, optionOverrides);
            var shadow = _createShadow(mergedOptions);
            var actor = Actor({
                triggerLabel: mergedOptions.triggerLabel,
                triggerAriaLabel: mergedOptions.triggerAriaLabel,
                shadow: shadow,
                styleNonce: styleNonce
            });
            _attachTo(actor.el, (0, _objectSpreadProps._)((0, _objectSpread._)({}, mergedOptions), {
                onFormOpen: function onFormOpen() {
                    actor.hide();
                },
                onFormClose: function onFormClose() {
                    actor.show();
                },
                onFormSubmitted: function onFormSubmitted() {
                    actor.show();
                }
            }));
            return actor;
        };
        return {
            name: 'Feedback',
            setupOnce: function setupOnce() {
                if (!(0, _core.isBrowser)() || !_options.autoInject) return;
                if (DOCUMENT.readyState === 'loading') DOCUMENT.addEventListener('DOMContentLoaded', function() {
                    return _createActor().appendToDom();
                });
                else _createActor().appendToDom();
            },
            /**
       * Adds click listener to the element to open a feedback dialog
       *
       * The returned function can be used to remove the click listener
       */ attachTo: _attachTo,
            /**
       * Creates a new widget which is composed of a Button which triggers a Dialog.
       * Accepts partial options to override any options passed to constructor.
       */ createWidget: function createWidget() {
                var optionOverrides = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var actor = _createActor(mergeOptions(_options, optionOverrides));
                actor.appendToDom();
                return actor;
            },
            createForm: /**
       * Creates a new Form which you can
       * Accepts partial options to override any options passed to constructor.
       */ function createForm() {
                return (0, _asyncToGenerator._)(function() {
                    var optionOverrides;
                    var _arguments = arguments;
                    return (0, _tsGenerator._)(this, function(_state) {
                        optionOverrides = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                        return [
                            2,
                            _loadAndRenderDialog(mergeOptions(_options, optionOverrides))
                        ];
                    });
                }).apply(this, arguments);
            },
            /**
       * Removes the Feedback integration (including host, shadow DOM, and all widgets)
       */ remove: function remove() {
                if (_shadow) {
                    var _shadow_parentElement;
                    (_shadow_parentElement = _shadow.parentElement) === null || _shadow_parentElement === void 0 ? void 0 : _shadow_parentElement.remove();
                    _shadow = null;
                }
                // Remove any lingering subscriptions
                _subscriptions.forEach(function(sub) {
                    return sub();
                });
                _subscriptions = [];
            }
        };
    };
    return feedbackIntegration;
};
/**
 * This is a small utility to get a type-safe instance of the Feedback integration.
 */ function getFeedback() {
    var client = (0, _core.getClient)();
    return client === null || client === void 0 ? void 0 : client.getIntegrationByName('Feedback');
}
var n, l$1, u$1, i$1, o$1, r$1, f$1, c$1 = {}, s$1 = [], a$1 = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, h$1 = Array.isArray;
function v$1(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function p$1(n) {
    var l = n.parentNode;
    l && l.removeChild(n);
}
function y$1(l, u, t) {
    var i, o, r, f = {};
    for(r in u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];
    if (arguments.length > 2 && (f.children = arguments.length > 3 ? n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(r in l.defaultProps)void 0 === f[r] && (f[r] = l.defaultProps[r]);
    return d$1(l, f, i, o, null);
}
function d$1(n, t, i, o, r) {
    var f = {
        type: n,
        props: t,
        key: i,
        ref: o,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        constructor: void 0,
        __v: null == r ? ++u$1 : r,
        __i: -1,
        __u: 0
    };
    return null == r && null != l$1.vnode && l$1.vnode(f), f;
}
function g$1(n) {
    return n.children;
}
function b$1(n, l) {
    this.props = n, this.context = l;
}
function m$1(n, l) {
    if (null == l) return n.__ ? m$1(n.__, n.__i + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? m$1(n) : null;
}
function w$1(n, u, t) {
    var i, o = n.__v, r = o.__e, f = n.__P;
    if (f) return (i = v$1({}, o)).__v = o.__v + 1, l$1.vnode && l$1.vnode(i), M(f, i, o, n.__n, void 0 !== f.ownerSVGElement, 32 & o.__u ? [
        r
    ] : null, u, null == r ? m$1(o) : r, !!(32 & o.__u), t), i.__.__k[i.__i] = i, i.__d = void 0, i.__e != r && k$1(i), i;
}
function k$1(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return k$1(n);
    }
}
function x$1(n) {
    (!n.__d && (n.__d = true) && i$1.push(n) && !C$1.__r++ || o$1 !== l$1.debounceRendering) && ((o$1 = l$1.debounceRendering) || r$1)(C$1);
}
function C$1() {
    var n, u, t, o = [], r = [];
    for(i$1.sort(f$1); n = i$1.shift();)n.__d && (t = i$1.length, u = w$1(n, o, r) || u, 0 === t || i$1.length > t ? (j$1(o, u, r), r.length = o.length = 0, u = void 0, i$1.sort(f$1)) : u && l$1.__c && l$1.__c(u, s$1));
    u && j$1(o, u, r), C$1.__r = 0;
}
function P$1(n, l, u, t, i, o, r, f, e, a, h) {
    var v, _$p, _$y, d, _$_, _$g = t && t.__k || s$1, _$b = l.length;
    for(u.__d = e, S(u, l, _$g), e = u.__d, v = 0; v < _$b; v++)null != (_$y = u.__k[v]) && "boolean" != typeof _$y && "function" != typeof _$y && (_$p = -1 === _$y.__i ? c$1 : _$g[_$y.__i] || c$1, _$y.__i = v, M(n, _$y, _$p, i, o, r, f, e, a, h), d = _$y.__e, _$y.ref && _$p.ref != _$y.ref && (_$p.ref && N(_$p.ref, null, _$y), h.push(_$y.ref, _$y.__c || d, _$y)), null == _$_ && null != d && (_$_ = d), 65536 & _$y.__u || _$p.__k === _$y.__k ? e = $(_$y, e, n) : "function" == typeof _$y.type && void 0 !== _$y.__d ? e = _$y.__d : d && (e = d.nextSibling), _$y.__d = void 0, _$y.__u &= -196609);
    u.__d = e, u.__e = _$_;
}
function S(n, l, u) {
    var t, i, o, r, f, e = l.length, c = u.length, s = c, a = 0;
    for(n.__k = [], t = 0; t < e; t++)null != (i = n.__k[t] = null == (i = l[t]) || "boolean" == typeof i || "function" == typeof i ? null : "string" == typeof i || "number" == typeof i || "bigint" == (typeof i === "undefined" ? "undefined" : (0, _typeOf._)(i)) || i.constructor == String ? d$1(null, i, null, null, i) : h$1(i) ? d$1(g$1, {
        children: i
    }, null, null, null) : void 0 === i.constructor && i.__b > 0 ? d$1(i.type, i.props, i.key, i.ref ? i.ref : null, i.__v) : i) ? (i.__ = n, i.__b = n.__b + 1, f = I(i, u, r = t + a, s), i.__i = f, o = null, -1 !== f && (s--, (o = u[f]) && (o.__u |= 131072)), null == o || null === o.__v ? (-1 == f && a--, "function" != typeof i.type && (i.__u |= 65536)) : f !== r && (f === r + 1 ? a++ : f > r ? s > e - r ? a += f - r : a-- : a = f < r && f == r - 1 ? f - r : 0, f !== t + a && (i.__u |= 65536))) : (o = u[t]) && null == o.key && o.__e && (o.__e == n.__d && (n.__d = m$1(o)), O(o, o, false), u[t] = null, s--);
    if (s) for(t = 0; t < c; t++)null != (o = u[t]) && 0 == (131072 & o.__u) && (o.__e == n.__d && (n.__d = m$1(o)), O(o, o));
}
function $(n, l, u) {
    var t, i;
    if ("function" == typeof n.type) {
        for(t = n.__k, i = 0; t && i < t.length; i++)t[i] && (t[i].__ = n, l = $(t[i], l, u));
        return l;
    }
    n.__e != l && (u.insertBefore(n.__e, l || null), l = n.__e);
    do l = l && l.nextSibling;
    while (null != l && 8 === l.nodeType);
    return l;
}
function I(n, l, u, t) {
    var i = n.key, o = n.type, r = u - 1, f = u + 1, e = l[u];
    if (null === e || e && i == e.key && o === e.type) return u;
    if (t > (null != e && 0 == (131072 & e.__u) ? 1 : 0)) for(; r >= 0 || f < l.length;){
        if (r >= 0) {
            if ((e = l[r]) && 0 == (131072 & e.__u) && i == e.key && o === e.type) return r;
            r--;
        }
        if (f < l.length) {
            if ((e = l[f]) && 0 == (131072 & e.__u) && i == e.key && o === e.type) return f;
            f++;
        }
    }
    return -1;
}
function T$1(n, l, u) {
    "-" === l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || a$1.test(l) ? u : u + "px";
}
function A$1(n, l, u, t, i) {
    var o;
    n: if ("style" === l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || T$1(n.style, l, "");
            if (u) for(l in u)t && u[l] === t[l] || T$1(n.style, l, u[l]);
        }
    } else if ("o" === l[0] && "n" === l[1]) o = l !== (l = l.replace(/(PointerCapture)$|Capture$/i, "$1")), l = l.toLowerCase() in n ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + o] = u, u ? t ? u.u = t.u : (u.u = Date.now(), n.addEventListener(l, o ? L : D$1, o)) : n.removeEventListener(l, o ? L : D$1, o);
    else {
        if (i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" !== l && "height" !== l && "href" !== l && "list" !== l && "form" !== l && "tabIndex" !== l && "download" !== l && "rowSpan" !== l && "colSpan" !== l && "role" !== l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || false === u && "-" !== l[4] ? n.removeAttribute(l) : n.setAttribute(l, u));
    }
}
function D$1(n) {
    if (this.l) {
        var u = this.l[n.type + false];
        if (n.t) {
            if (n.t <= u.u) return;
        } else n.t = Date.now();
        return u(l$1.event ? l$1.event(n) : n);
    }
}
function L(n) {
    if (this.l) return this.l[n.type + true](l$1.event ? l$1.event(n) : n);
}
function M(n, u, t, i, o, r, f, e, c, s) {
    var a, _$p, _$y, d, _$_, m, w, k, _$x, C, S, $, H, I, _$T, _$A = u.type;
    if (void 0 !== u.constructor) return null;
    128 & t.__u && (c = !!(32 & t.__u), r = [
        e = u.__e = t.__e
    ]), (a = l$1.__b) && a(u);
    n: if ("function" == typeof _$A) try {
        if (k = u.props, _$x = (a = _$A.contextType) && i[a.__c], C = a ? _$x ? _$x.props.value : a.__ : i, t.__c ? w = (_$p = u.__c = t.__c).__ = _$p.__E : ("prototype" in _$A && _$A.prototype.render ? u.__c = _$p = new _$A(k, C) : (u.__c = _$p = new b$1(k, C), _$p.constructor = _$A, _$p.render = q$1), _$x && _$x.sub(_$p), _$p.props = k, _$p.state || (_$p.state = {}), _$p.context = C, _$p.__n = i, _$y = _$p.__d = !0, _$p.__h = [], _$p._sb = []), null == _$p.__s && (_$p.__s = _$p.state), null != _$A.getDerivedStateFromProps && (_$p.__s == _$p.state && (_$p.__s = v$1({}, _$p.__s)), v$1(_$p.__s, _$A.getDerivedStateFromProps(k, _$p.__s))), d = _$p.props, _$_ = _$p.state, _$p.__v = u, _$y) null == _$A.getDerivedStateFromProps && null != _$p.componentWillMount && _$p.componentWillMount(), null != _$p.componentDidMount && _$p.__h.push(_$p.componentDidMount);
        else {
            if (null == _$A.getDerivedStateFromProps && k !== d && null != _$p.componentWillReceiveProps && _$p.componentWillReceiveProps(k, C), !_$p.__e && (null != _$p.shouldComponentUpdate && !1 === _$p.shouldComponentUpdate(k, _$p.__s, C) || u.__v === t.__v)) {
                for(u.__v !== t.__v && (_$p.props = k, _$p.state = _$p.__s, _$p.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.forEach(function(n) {
                    n && (n.__ = u);
                }), S = 0; S < _$p._sb.length; S++)_$p.__h.push(_$p._sb[S]);
                _$p._sb = [], _$p.__h.length && f.push(_$p);
                break n;
            }
            null != _$p.componentWillUpdate && _$p.componentWillUpdate(k, _$p.__s, C), null != _$p.componentDidUpdate && _$p.__h.push(function() {
                _$p.componentDidUpdate(d, _$_, m);
            });
        }
        if (_$p.context = C, _$p.props = k, _$p.__P = n, _$p.__e = !1, $ = l$1.__r, H = 0, "prototype" in _$A && _$A.prototype.render) {
            for(_$p.state = _$p.__s, _$p.__d = !1, $ && $(u), a = _$p.render(_$p.props, _$p.state, _$p.context), I = 0; I < _$p._sb.length; I++)_$p.__h.push(_$p._sb[I]);
            _$p._sb = [];
        } else do _$p.__d = !1, $ && $(u), a = _$p.render(_$p.props, _$p.state, _$p.context), _$p.state = _$p.__s;
        while (_$p.__d && ++H < 25);
        _$p.state = _$p.__s, null != _$p.getChildContext && (i = v$1(v$1({}, i), _$p.getChildContext())), _$y || null == _$p.getSnapshotBeforeUpdate || (m = _$p.getSnapshotBeforeUpdate(d, _$_)), P$1(n, h$1(_$T = null != a && a.type === g$1 && null == a.key ? a.props.children : a) ? _$T : [
            _$T
        ], u, t, i, o, r, f, e, c, s), _$p.base = u.__e, u.__u &= -161, _$p.__h.length && f.push(_$p), w && (_$p.__E = _$p.__ = null);
    } catch (n) {
        u.__v = null, c || null != r ? (u.__e = e, u.__u |= c ? 160 : 32, r[r.indexOf(e)] = null) : (u.__e = t.__e, u.__k = t.__k), l$1.__e(n, u, t);
    }
    else null == r && u.__v === t.__v ? (u.__k = t.__k, u.__e = t.__e) : u.__e = z$1(t.__e, u, t, i, o, r, f, c, s);
    (a = l$1.diffed) && a(u);
}
function j$1(n, u, t) {
    for(var i = 0; i < t.length; i++)N(t[i], t[++i], t[++i]);
    l$1.__c && l$1.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            l$1.__e(n, u.__v);
        }
    });
}
function z$1(l, u, t, i, o, r, f, e, s) {
    var a, v, _$y, d, _$_, _$g, _$b, w = t.props, k = u.props, _$x = u.type;
    if ("svg" === _$x && (o = true), null != r) {
        for(a = 0; a < r.length; a++)if ((_$_ = r[a]) && "setAttribute" in _$_ == !!_$x && (_$x ? _$_.localName === _$x : 3 === _$_.nodeType)) {
            l = _$_, r[a] = null;
            break;
        }
    }
    if (null == l) {
        if (null === _$x) return document.createTextNode(k);
        l = o ? document.createElementNS("http://www.w3.org/2000/svg", _$x) : document.createElement(_$x, k.is && k), r = null, e = false;
    }
    if (null === _$x) w === k || e && l.data === k || (l.data = k);
    else {
        if (r = r && n.call(l.childNodes), w = t.props || c$1, !e && null != r) for(w = {}, a = 0; a < l.attributes.length; a++)w[(_$_ = l.attributes[a]).name] = _$_.value;
        for(a in w)_$_ = w[a], "children" == a || ("dangerouslySetInnerHTML" == a ? _$y = _$_ : "key" === a || a in k || A$1(l, a, null, _$_, o));
        for(a in k)_$_ = k[a], "children" == a ? d = _$_ : "dangerouslySetInnerHTML" == a ? v = _$_ : "value" == a ? _$g = _$_ : "checked" == a ? _$b = _$_ : "key" === a || e && "function" != typeof _$_ || w[a] === _$_ || A$1(l, a, _$_, w[a], o);
        if (v) e || _$y && (v.__html === _$y.__html || v.__html === l.innerHTML) || (l.innerHTML = v.__html), u.__k = [];
        else if (_$y && (l.innerHTML = ""), P$1(l, h$1(d) ? d : [
            d
        ], u, t, i, o && "foreignObject" !== _$x, r, f, r ? r[0] : t.__k && m$1(t, 0), e, s), null != r) for(a = r.length; a--;)null != r[a] && p$1(r[a]);
        e || (a = "value", void 0 !== _$g && (_$g !== l[a] || "progress" === _$x && !_$g || "option" === _$x && _$g !== w[a]) && A$1(l, a, _$g, w[a], false), a = "checked", void 0 !== _$b && _$b !== l[a] && A$1(l, a, _$b, w[a], false));
    }
    return l;
}
function N(n, u, t) {
    try {
        "function" == typeof n ? n(u) : n.current = u;
    } catch (n) {
        l$1.__e(n, t);
    }
}
function O(n, u, t) {
    var i, o;
    if (l$1.unmount && l$1.unmount(n), (i = n.ref) && (i.current && i.current !== n.__e || N(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            l$1.__e(n, u);
        }
        i.base = i.__P = null, n.__c = void 0;
    }
    if (i = n.__k) for(o = 0; o < i.length; o++)i[o] && O(i[o], u, t || "function" != typeof n.type);
    t || null == n.__e || p$1(n.__e), n.__ = n.__e = n.__d = void 0;
}
function q$1(n, l, u) {
    return this.constructor(n, u);
}
function B$1(u, t, i) {
    var o, r, f, e;
    l$1.__ && l$1.__(u, t), r = (o = false, t.__k), f = [], e = [], M(t, u = t.__k = y$1(g$1, null, [
        u
    ]), r || c$1, c$1, void 0 !== t.ownerSVGElement, r ? null : t.firstChild ? n.call(t.childNodes) : null, f, r ? r.__e : t.firstChild, o, e), u.__d = void 0, j$1(f, u, e);
}
n = s$1.slice, l$1 = {
    __e: function __e(n, l, u, t) {
        for(var i, o, r; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((o = i.constructor) && null != o.getDerivedStateFromError && (i.setState(o.getDerivedStateFromError(n)), r = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), r = i.__d), r) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, u$1 = 0, b$1.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = v$1({}, this.state), "function" == typeof n && (n = n(v$1({}, u), this.props)), n && v$1(u, n), null != n && this.__v && (l && this._sb.push(l), x$1(this));
}, b$1.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = true, n && this.__h.push(n), x$1(this));
}, b$1.prototype.render = g$1, i$1 = [], r$1 = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, f$1 = function f$1(n, l) {
    return n.__v.__b - l.__v.__b;
}, C$1.__r = 0;
var t, r, u, i, o = 0, f = [], c = [], e = l$1, a = e.__b, v = e.__r, l = e.diffed, m = e.__c, s = e.unmount, d = e.__;
function h(n, t) {
    e.__h && e.__h(r, n, o || t), o = 0;
    var u = r.__H || (r.__H = {
        __: [],
        __h: []
    });
    return n >= u.__.length && u.__.push({
        __V: c
    }), u.__[n];
}
function p(n) {
    return o = 1, y(D, n);
}
function y(n, u, i) {
    var o = h(t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : D(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = r, !r.u)) {
        var f = function f(n, t, r) {
            if (!o.__c.__H) return true;
            var _$u = o.__c.__H.__.filter(function(n) {
                return !!n.__c;
            });
            if (_$u.every(function(n) {
                return !n.__N;
            })) return !c || c.call(this, n, t, r);
            var _$i = false;
            return _$u.forEach(function(n) {
                if (n.__N) {
                    var _$t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, _$t !== n.__[0] && (_$i = true);
                }
            }), !(!_$i && o.__c.props === n) && (!c || c.call(this, n, t, r));
        };
        r.u = true;
        var c = r.shouldComponentUpdate, e = r.componentWillUpdate;
        r.componentWillUpdate = function(n, t, r) {
            if (this.__e) {
                var _$u = c;
                c = void 0, f(n, t, r), c = _$u;
            }
            e && e.call(this, n, t, r);
        }, r.shouldComponentUpdate = f;
    }
    return o.__N || o.__;
}
function _(n, u) {
    var i = h(t++, 3);
    !e.__s && C(i.__H, u) && (i.__ = n, i.i = u, r.__H.__h.push(i));
}
function A(n, u) {
    var i = h(t++, 4);
    !e.__s && C(i.__H, u) && (i.__ = n, i.i = u, r.__h.push(i));
}
function F(n) {
    return o = 5, q(function() {
        return {
            current: n
        };
    }, []);
}
function T(n, t, r) {
    o = 6, A(function() {
        return "function" == typeof n ? (n(t()), function() {
            return n(null);
        }) : n ? (n.current = t(), function() {
            return n.current = null;
        }) : void 0;
    }, null == r ? r : r.concat(n));
}
function q(n, r) {
    var u = h(t++, 7);
    return C(u.__H, r) ? (u.__V = n(), u.i = r, u.__h = n, u.__V) : u.__;
}
function x(n, t) {
    return o = 8, q(function() {
        return n;
    }, t);
}
function P(n) {
    var u = r.context[n.__c], i = h(t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = true, u.sub(r)), u.props.value) : n.__;
}
function V(n, t) {
    e.useDebugValue && e.useDebugValue(t ? t(n) : n);
}
function b(n) {
    var u = h(t++, 10), i = p();
    return u.__ = n, r.componentDidCatch || (r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function g() {
    var n = h(t++, 11);
    if (!n.__) {
        for(var u = r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return n.__;
}
function j() {
    for(var n; n = f.shift();)if (n.__P && n.__H) try {
        n.__H.__h.forEach(z), n.__H.__h.forEach(B), n.__H.__h = [];
    } catch (t) {
        n.__H.__h = [], e.__e(t, n.__v);
    }
}
e.__b = function(n) {
    r = null, a && a(n);
}, e.__ = function(n, t) {
    t.__k && t.__k.__m && (n.__m = t.__k.__m), d && d(n, t);
}, e.__r = function(n) {
    v && v(n), t = 0;
    var i = (r = n.__c).__H;
    i && (u === r ? (i.__h = [], r.__h = [], i.__.forEach(function(n) {
        n.__N && (n.__ = n.__N), n.__V = c, n.__N = n.i = void 0;
    })) : (i.__h.forEach(z), i.__h.forEach(B), i.__h = [], t = 0)), u = r;
}, e.diffed = function(n) {
    l && l(n);
    var t = n.__c;
    t && t.__H && (t.__H.__h.length && (1 !== f.push(t) && i === e.requestAnimationFrame || ((i = e.requestAnimationFrame) || w)(j)), t.__H.__.forEach(function(n) {
        n.i && (n.__H = n.i), n.__V !== c && (n.__ = n.__V), n.i = void 0, n.__V = c;
    })), u = r = null;
}, e.__c = function(n, t) {
    t.some(function(n) {
        try {
            n.__h.forEach(z), n.__h = n.__h.filter(function(n) {
                return !n.__ || B(n);
            });
        } catch (r) {
            t.some(function(n) {
                n.__h && (n.__h = []);
            }), t = [], e.__e(r, n.__v);
        }
    }), m && m(n, t);
}, e.unmount = function(n) {
    s && s(n);
    var t, r = n.__c;
    r && r.__H && (r.__H.__.forEach(function(n) {
        try {
            z(n);
        } catch (n) {
            t = n;
        }
    }), r.__H = void 0, t && e.__e(t, r.__v));
};
var k = "function" == typeof requestAnimationFrame;
function w(n) {
    var t, r = function r() {
        clearTimeout(u), k && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 100);
    k && (t = requestAnimationFrame(r));
}
function z(n) {
    var t = r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), r = t;
}
function B(n) {
    var t = r;
    n.__c = n.__(), r = t;
}
function C(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function D(n, t) {
    return "function" == typeof t ? t(n) : t;
}
var hooks = /*#__PURE__*/ Object.defineProperty({
    __proto__: null,
    useCallback: x,
    useContext: P,
    useDebugValue: V,
    useEffect: _,
    useErrorBoundary: b,
    useId: g,
    useImperativeHandle: T,
    useLayoutEffect: A,
    useMemo: q,
    useReducer: y,
    useRef: F,
    useState: p
}, Symbol.toStringTag, {
    value: 'Module'
});
var XMLNS$1 = 'http://www.w3.org/2000/svg';
/**
 * Sentry Logo
 */ function SentryLogo() {
    var createElementNS = function(tagName) {
        return DOCUMENT.createElementNS(XMLNS$1, tagName);
    };
    var svg = setAttributesNS(createElementNS('svg'), {
        width: '32',
        height: '30',
        viewBox: '0 0 72 66',
        fill: 'inherit'
    });
    var path = setAttributesNS(createElementNS('path'), {
        transform: 'translate(11, 11)',
        d: 'M29,2.26a4.67,4.67,0,0,0-8,0L14.42,13.53A32.21,32.21,0,0,1,32.17,40.19H27.55A27.68,27.68,0,0,0,12.09,17.47L6,28a15.92,15.92,0,0,1,9.23,12.17H4.62A.76.76,0,0,1,4,39.06l2.94-5a10.74,10.74,0,0,0-3.36-1.9l-2.91,5a4.54,4.54,0,0,0,1.69,6.24A4.66,4.66,0,0,0,4.62,44H19.15a19.4,19.4,0,0,0-8-17.31l2.31-4A23.87,23.87,0,0,1,23.76,44H36.07a35.88,35.88,0,0,0-16.41-31.8l4.67-8a.77.77,0,0,1,1.05-.27c.53.29,20.29,34.77,20.66,35.17a.76.76,0,0,1-.68,1.13H40.6q.09,1.91,0,3.81h4.78A4.59,4.59,0,0,0,50,39.43a4.49,4.49,0,0,0-.62-2.28Z'
    });
    svg.appendChild(path);
    return svg;
}
function DialogHeader(param) {
    var options = param.options;
    var logoHtml = q(function() {
        return {
            __html: SentryLogo().outerHTML
        };
    }, []);
    return y$1('h2', {
        class: "dialog__header"
    }, y$1('span', {
        class: "dialog__title"
    }, options.formTitle), options.showBranding ? y$1('a', {
        class: "brand-link",
        target: "_blank",
        href: "https://sentry.io/welcome/",
        title: "Powered by Sentry",
        rel: "noopener noreferrer",
        dangerouslySetInnerHTML: logoHtml
    }) : null);
}
/**
 * Validate that a given feedback submission has the required fields
 */ function getMissingFields(feedback, props) {
    var emptyFields = [];
    if (props.isNameRequired && !feedback.name) emptyFields.push(props.nameLabel);
    if (props.isEmailRequired && !feedback.email) emptyFields.push(props.emailLabel);
    if (!feedback.message) emptyFields.push(props.messageLabel);
    return emptyFields;
}
function retrieveStringValue(formData, key) {
    var value = formData.get(key);
    if (typeof value === 'string') return value.trim();
    return '';
}
function Form(param) {
    var options = param.options, defaultEmail = param.defaultEmail, defaultName = param.defaultName, onFormClose = param.onFormClose, onSubmit = param.onSubmit, onSubmitSuccess = param.onSubmitSuccess, onSubmitError = param.onSubmitError, showEmail = param.showEmail, showName = param.showName, screenshotInput = param.screenshotInput;
    var tags = options.tags, addScreenshotButtonLabel = options.addScreenshotButtonLabel, removeScreenshotButtonLabel = options.removeScreenshotButtonLabel, cancelButtonLabel = options.cancelButtonLabel, emailLabel = options.emailLabel, emailPlaceholder = options.emailPlaceholder, isEmailRequired = options.isEmailRequired, isNameRequired = options.isNameRequired, messageLabel = options.messageLabel, messagePlaceholder = options.messagePlaceholder, nameLabel = options.nameLabel, namePlaceholder = options.namePlaceholder, submitButtonLabel = options.submitButtonLabel, isRequiredLabel = options.isRequiredLabel;
    var _p = (0, _slicedToArray._)(p(false), 2), isSubmitting = _p[0], setIsSubmitting = _p[1];
    // TODO: set a ref on the form, and whenever an input changes call processForm() and setError()
    var _p1 = (0, _slicedToArray._)(p(null), 2), error = _p1[0], setError = _p1[1];
    var _p2 = (0, _slicedToArray._)(p(false), 2), showScreenshotInput = _p2[0], setShowScreenshotInput = _p2[1];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var ScreenshotInputComponent = screenshotInput === null || screenshotInput === void 0 ? void 0 : screenshotInput.input;
    var _p3 = (0, _slicedToArray._)(p(null), 2), screenshotError = _p3[0], setScreenshotError = _p3[1];
    var onScreenshotError = x(function(error) {
        setScreenshotError(error);
        setShowScreenshotInput(false);
    }, []);
    var hasAllRequiredFields = x(function(data) {
        var missingFields = getMissingFields(data, {
            emailLabel: emailLabel,
            isEmailRequired: isEmailRequired,
            isNameRequired: isNameRequired,
            messageLabel: messageLabel,
            nameLabel: nameLabel
        });
        if (missingFields.length > 0) setError("Please enter in the following required fields: ".concat(missingFields.join(', ')));
        else setError(null);
        return missingFields.length === 0;
    }, [
        emailLabel,
        isEmailRequired,
        isNameRequired,
        messageLabel,
        nameLabel
    ]);
    var handleSubmit = x(function(e) {
        return (0, _asyncToGenerator._)(function() {
            var formData, attachment, data, eventId, error;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsSubmitting(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            7,
                            8
                        ]);
                        e.preventDefault();
                        if (!(0, _instanceof._)(e.target, HTMLFormElement)) return [
                            2
                        ];
                        formData = new FormData(e.target);
                        return [
                            4,
                            screenshotInput && showScreenshotInput ? screenshotInput.value() : undefined
                        ];
                    case 2:
                        attachment = _state.sent();
                        data = {
                            name: retrieveStringValue(formData, 'name'),
                            email: retrieveStringValue(formData, 'email'),
                            message: retrieveStringValue(formData, 'message'),
                            attachments: attachment ? [
                                attachment
                            ] : undefined
                        };
                        if (!hasAllRequiredFields(data)) return [
                            2
                        ];
                        _state.label = 3;
                    case 3:
                        _state.trys.push([
                            3,
                            5,
                            ,
                            6
                        ]);
                        return [
                            4,
                            onSubmit({
                                name: data.name,
                                email: data.email,
                                message: data.message,
                                source: FEEDBACK_WIDGET_SOURCE,
                                tags: tags
                            }, {
                                attachments: data.attachments
                            })
                        ];
                    case 4:
                        eventId = _state.sent();
                        onSubmitSuccess(data, eventId);
                        return [
                            3,
                            6
                        ];
                    case 5:
                        error = _state.sent();
                        DEBUG_BUILD && (0, _core.debug).error(error);
                        setError(error);
                        onSubmitError(error);
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            3,
                            8
                        ];
                    case 7:
                        setIsSubmitting(false);
                        return [
                            7
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        screenshotInput && showScreenshotInput,
        onSubmitSuccess,
        onSubmitError
    ]);
    return y$1('form', {
        class: "form",
        onSubmit: handleSubmit
    }, ScreenshotInputComponent && showScreenshotInput ? y$1(ScreenshotInputComponent, {
        onError: onScreenshotError
    }) : null, y$1('fieldset', {
        class: "form__right",
        'data-sentry-feedback': true,
        disabled: isSubmitting
    }, y$1('div', {
        class: "form__top"
    }, error ? y$1('div', {
        class: "form__error-container"
    }, error) : null, showName ? y$1('label', {
        for: "name",
        class: "form__label"
    }, y$1(LabelText, {
        label: nameLabel,
        isRequiredLabel: isRequiredLabel,
        isRequired: isNameRequired
    }), y$1('input', {
        class: "form__input",
        defaultValue: defaultName,
        id: "name",
        name: "name",
        placeholder: namePlaceholder,
        required: isNameRequired,
        type: "text"
    })) : y$1('input', {
        'aria-hidden': true,
        value: defaultName,
        name: "name",
        type: "hidden"
    }), showEmail ? y$1('label', {
        for: "email",
        class: "form__label"
    }, y$1(LabelText, {
        label: emailLabel,
        isRequiredLabel: isRequiredLabel,
        isRequired: isEmailRequired
    }), y$1('input', {
        class: "form__input",
        defaultValue: defaultEmail,
        id: "email",
        name: "email",
        placeholder: emailPlaceholder,
        required: isEmailRequired,
        type: "email"
    })) : y$1('input', {
        'aria-hidden': true,
        value: defaultEmail,
        name: "email",
        type: "hidden"
    }), y$1('label', {
        for: "message",
        class: "form__label"
    }, y$1(LabelText, {
        label: messageLabel,
        isRequiredLabel: isRequiredLabel,
        isRequired: true
    }), y$1('textarea', {
        autoFocus: true,
        class: "form__input form__input--textarea",
        id: "message",
        name: "message",
        placeholder: messagePlaceholder,
        required: true,
        rows: 5
    })), ScreenshotInputComponent ? y$1('label', {
        for: "screenshot",
        class: "form__label"
    }, y$1('button', {
        class: "btn btn--default",
        disabled: isSubmitting,
        type: "button",
        onClick: function() {
            setScreenshotError(null);
            setShowScreenshotInput(function(prev) {
                return !prev;
            });
        }
    }, showScreenshotInput ? removeScreenshotButtonLabel : addScreenshotButtonLabel), screenshotError ? y$1('div', {
        class: "form__error-container"
    }, screenshotError.message) : null) : null), y$1('div', {
        class: "btn-group"
    }, y$1('button', {
        class: "btn btn--primary",
        disabled: isSubmitting,
        type: "submit"
    }, submitButtonLabel), y$1('button', {
        class: "btn btn--default",
        disabled: isSubmitting,
        type: "button",
        onClick: onFormClose
    }, cancelButtonLabel))));
}
function LabelText(param) {
    var label = param.label, isRequired = param.isRequired, isRequiredLabel = param.isRequiredLabel;
    return y$1('span', {
        class: "form__label__text"
    }, label, isRequired && y$1('span', {
        class: "form__label__text--required"
    }, isRequiredLabel));
}
var WIDTH = 16;
var HEIGHT = 17;
var XMLNS = 'http://www.w3.org/2000/svg';
/**
 * Success Icon (checkmark)
 */ function SuccessIcon() {
    var createElementNS = function(tagName) {
        return WINDOW.document.createElementNS(XMLNS, tagName);
    };
    var svg = setAttributesNS(createElementNS('svg'), {
        width: "".concat(WIDTH),
        height: "".concat(HEIGHT),
        viewBox: "0 0 ".concat(WIDTH, " ").concat(HEIGHT),
        fill: 'inherit'
    });
    var _$g = setAttributesNS(createElementNS('g'), {
        clipPath: 'url(#clip0_57_156)'
    });
    var _obj;
    var path2 = setAttributesNS(createElementNS('path'), (_obj = {}, (0, _defineProperty._)(_obj, 'fill-rule', 'evenodd'), (0, _defineProperty._)(_obj, 'clip-rule', 'evenodd'), (0, _defineProperty._)(_obj, "d", 'M3.55544 15.1518C4.87103 16.0308 6.41775 16.5 8 16.5C10.1217 16.5 12.1566 15.6571 13.6569 14.1569C15.1571 12.6566 16 10.6217 16 8.5C16 6.91775 15.5308 5.37103 14.6518 4.05544C13.7727 2.73985 12.5233 1.71447 11.0615 1.10897C9.59966 0.503466 7.99113 0.34504 6.43928 0.653721C4.88743 0.962403 3.46197 1.72433 2.34315 2.84315C1.22433 3.96197 0.462403 5.38743 0.153721 6.93928C-0.15496 8.49113 0.00346625 10.0997 0.608967 11.5615C1.21447 13.0233 2.23985 14.2727 3.55544 15.1518ZM4.40546 3.1204C5.46945 2.40946 6.72036 2.03 8 2.03C9.71595 2.03 11.3616 2.71166 12.575 3.92502C13.7883 5.13838 14.47 6.78405 14.47 8.5C14.47 9.77965 14.0905 11.0306 13.3796 12.0945C12.6687 13.1585 11.6582 13.9878 10.476 14.4775C9.29373 14.9672 7.99283 15.0953 6.73777 14.8457C5.48271 14.596 4.32987 13.9798 3.42502 13.075C2.52018 12.1701 1.90397 11.0173 1.65432 9.76224C1.40468 8.50718 1.5328 7.20628 2.0225 6.02404C2.5122 4.8418 3.34148 3.83133 4.40546 3.1204Z'), _obj));
    var path = setAttributesNS(createElementNS('path'), {
        d: 'M6.68775 12.4297C6.78586 12.4745 6.89218 12.4984 7 12.5C7.11275 12.4955 7.22315 12.4664 7.32337 12.4145C7.4236 12.3627 7.51121 12.2894 7.58 12.2L12 5.63999C12.0848 5.47724 12.1071 5.28902 12.0625 5.11098C12.0178 4.93294 11.9095 4.77744 11.7579 4.67392C11.6064 4.57041 11.4221 4.52608 11.24 4.54931C11.0579 4.57254 10.8907 4.66173 10.77 4.79999L6.88 10.57L5.13 8.56999C5.06508 8.49566 4.98613 8.43488 4.89768 8.39111C4.80922 8.34735 4.713 8.32148 4.61453 8.31498C4.51605 8.30847 4.41727 8.32147 4.32382 8.35322C4.23038 8.38497 4.14413 8.43484 4.07 8.49999C3.92511 8.63217 3.83692 8.81523 3.82387 9.01092C3.81083 9.2066 3.87393 9.39976 4 9.54999L6.43 12.24C6.50187 12.3204 6.58964 12.385 6.68775 12.4297Z'
    });
    svg.appendChild(_$g).append(path, path2);
    var speakerDefs = createElementNS('defs');
    var speakerClipPathDef = setAttributesNS(createElementNS('clipPath'), {
        id: 'clip0_57_156'
    });
    var speakerRect = setAttributesNS(createElementNS('rect'), {
        width: "".concat(WIDTH),
        height: "".concat(WIDTH),
        fill: 'white',
        transform: 'translate(0 0.5)'
    });
    speakerClipPathDef.appendChild(speakerRect);
    speakerDefs.appendChild(speakerClipPathDef);
    svg.appendChild(speakerDefs).appendChild(speakerClipPathDef).appendChild(speakerRect);
    return svg;
}
function Dialog(_param) {
    var open = _param.open, onFormSubmitted = _param.onFormSubmitted, props = (0, _objectWithoutProperties._)(_param, [
        "open",
        "onFormSubmitted"
    ]);
    var options = props.options;
    var successIconHtml = q(function() {
        return {
            __html: SuccessIcon().outerHTML
        };
    }, []);
    var _p = (0, _slicedToArray._)(p(null), 2), timeoutId = _p[0], setTimeoutId = _p[1];
    var handleOnSuccessClick = x(function() {
        if (timeoutId) {
            clearTimeout(timeoutId);
            setTimeoutId(null);
        }
        onFormSubmitted();
    }, [
        timeoutId
    ]);
    var onSubmitSuccess = x(function(data, eventId) {
        props.onSubmitSuccess(data, eventId);
        setTimeoutId(setTimeout(function() {
            onFormSubmitted();
            setTimeoutId(null);
        }, SUCCESS_MESSAGE_TIMEOUT));
    }, [
        onFormSubmitted
    ]);
    return y$1(g$1, null, timeoutId ? y$1('div', {
        class: "success__position",
        onClick: handleOnSuccessClick
    }, y$1('div', {
        class: "success__content"
    }, options.successMessageText, y$1('span', {
        class: "success__icon",
        dangerouslySetInnerHTML: successIconHtml
    }))) : y$1('dialog', {
        class: "dialog",
        onClick: options.onFormClose,
        open: open
    }, y$1('div', {
        class: "dialog__position"
    }, y$1('div', {
        class: "dialog__content",
        onClick: function(e) {
            // Stop event propagation so clicks on content modal do not propagate to dialog (which will close dialog)
            e.stopPropagation();
        }
    }, y$1(DialogHeader, {
        options: options
    }), y$1(Form, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        onSubmitSuccess: onSubmitSuccess
    }))))));
}
var DIALOG = "\n.dialog {\n  position: fixed;\n  z-index: var(--z-index);\n  margin: 0;\n  inset: 0;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  height: 100vh;\n  width: 100vw;\n\n  color: var(--dialog-color, var(--foreground));\n  fill: var(--dialog-color, var(--foreground));\n  line-height: 1.75em;\n\n  background-color: rgba(0, 0, 0, 0.05);\n  border: none;\n  inset: 0;\n  opacity: 1;\n  transition: opacity 0.2s ease-in-out;\n}\n\n.dialog__position {\n  position: fixed;\n  z-index: var(--z-index);\n  inset: var(--dialog-inset);\n  padding: var(--page-margin);\n  display: flex;\n  max-height: calc(100vh - (2 * var(--page-margin)));\n}\n@media (max-width: 600px) {\n  .dialog__position {\n    inset: var(--page-margin);\n    padding: 0;\n  }\n}\n\n.dialog__position:has(.editor) {\n  inset: var(--page-margin);\n  padding: 0;\n}\n\n.dialog:not([open]) {\n  opacity: 0;\n  pointer-events: none;\n  visibility: hidden;\n}\n.dialog:not([open]) .dialog__content {\n  transform: translate(0, -16px) scale(0.98);\n}\n\n.dialog__content {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: var(--dialog-padding, 24px);\n  max-width: 100%;\n  width: 100%;\n  max-height: 100%;\n  overflow: auto;\n\n  background: var(--dialog-background, var(--background));\n  border-radius: var(--dialog-border-radius, 20px);\n  border: var(--dialog-border, var(--border));\n  box-shadow: var(--dialog-box-shadow, var(--box-shadow));\n  transform: translate(0, 0) scale(1);\n  transition: transform 0.2s ease-in-out;\n}\n\n";
var DIALOG_HEADER = "\n.dialog__header {\n  display: flex;\n  gap: 4px;\n  justify-content: space-between;\n  font-weight: var(--dialog-header-weight, 600);\n  margin: 0;\n}\n.dialog__title {\n  align-self: center;\n  width: var(--form-width, 272px);\n}\n\n@media (max-width: 600px) {\n  .dialog__title {\n    width: auto;\n  }\n}\n\n.dialog__position:has(.editor) .dialog__title {\n  width: auto;\n}\n\n\n.brand-link {\n  display: inline-flex;\n}\n.brand-link:focus-visible {\n  outline: var(--outline);\n}\n";
var FORM = "\n.form {\n  display: flex;\n  overflow: auto;\n  flex-direction: row;\n  gap: 16px;\n  flex: 1 0;\n}\n\n.form fieldset {\n  border: none;\n  margin: 0;\n  padding: 0;\n}\n\n.form__right {\n  flex: 0 0 auto;\n  display: flex;\n  overflow: auto;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 20px;\n  width: var(--form-width, 100%);\n}\n\n.dialog__position:has(.editor) .form__right {\n  width: var(--form-width, 272px);\n}\n\n.form__top {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.form__error-container {\n  color: var(--error-color);\n  fill: var(--error-color);\n}\n\n.form__label {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin: 0px;\n}\n\n.form__label__text {\n  display: flex;\n  gap: 4px;\n  align-items: center;\n}\n\n.form__label__text--required {\n  font-size: 0.85em;\n}\n\n.form__input {\n  font-family: inherit;\n  line-height: inherit;\n  background: transparent;\n  box-sizing: border-box;\n  border: var(--input-border, var(--border));\n  border-radius: var(--input-border-radius, 6px);\n  color: var(--input-color, inherit);\n  fill: var(--input-color, inherit);\n  font-size: var(--input-font-size, inherit);\n  font-weight: var(--input-font-weight, 500);\n  padding: 6px 12px;\n}\n\n.form__input::placeholder {\n  opacity: 0.65;\n  color: var(--input-placeholder-color, inherit);\n  filter: var(--interactive-filter);\n}\n\n.form__input:focus-visible {\n  outline: var(--input-focus-outline, var(--outline));\n}\n\n.form__input--textarea {\n  font-family: inherit;\n  resize: vertical;\n}\n\n.error {\n  color: var(--error-color);\n  fill: var(--error-color);\n}\n";
var BUTTON = "\n.btn-group {\n  display: grid;\n  gap: 8px;\n}\n\n.btn {\n  line-height: inherit;\n  border: var(--button-border, var(--border));\n  border-radius: var(--button-border-radius, 6px);\n  cursor: pointer;\n  font-family: inherit;\n  font-size: var(--button-font-size, inherit);\n  font-weight: var(--button-font-weight, 600);\n  padding: var(--button-padding, 6px 16px);\n}\n.btn[disabled] {\n  opacity: 0.6;\n  pointer-events: none;\n}\n\n.btn--primary {\n  color: var(--button-primary-color, var(--accent-foreground));\n  fill: var(--button-primary-color, var(--accent-foreground));\n  background: var(--button-primary-background, var(--accent-background));\n  border: var(--button-primary-border, var(--border));\n  border-radius: var(--button-primary-border-radius, 6px);\n  font-weight: var(--button-primary-font-weight, 500);\n}\n.btn--primary:hover {\n  color: var(--button-primary-hover-color, var(--accent-foreground));\n  fill: var(--button-primary-hover-color, var(--accent-foreground));\n  background: var(--button-primary-hover-background, var(--accent-background));\n  filter: var(--interactive-filter);\n}\n.btn--primary:focus-visible {\n  background: var(--button-primary-hover-background, var(--accent-background));\n  filter: var(--interactive-filter);\n  outline: var(--button-primary-focus-outline, var(--outline));\n}\n\n.btn--default {\n  color: var(--button-color, var(--foreground));\n  fill: var(--button-color, var(--foreground));\n  background: var(--button-background, var(--background));\n  border: var(--button-border, var(--border));\n  border-radius: var(--button-border-radius, 6px);\n  font-weight: var(--button-font-weight, 500);\n}\n.btn--default:hover {\n  color: var(--button-color, var(--foreground));\n  fill: var(--button-color, var(--foreground));\n  background: var(--button-hover-background, var(--background));\n  filter: var(--interactive-filter);\n}\n.btn--default:focus-visible {\n  background: var(--button-hover-background, var(--background));\n  filter: var(--interactive-filter);\n  outline: var(--button-focus-outline, var(--outline));\n}\n";
var SUCCESS = "\n.success__position {\n  position: fixed;\n  inset: var(--dialog-inset);\n  padding: var(--page-margin);\n  z-index: var(--z-index);\n}\n.success__content {\n  background: var(--success-background, var(--background));\n  border: var(--success-border, var(--border));\n  border-radius: var(--success-border-radius, 1.7em/50%);\n  box-shadow: var(--success-box-shadow, var(--box-shadow));\n  font-weight: var(--success-font-weight, 600);\n  color: var(--success-color);\n  fill: var(--success-color);\n  padding: 12px 24px;\n  line-height: 1.75em;\n\n  display: grid;\n  align-items: center;\n  grid-auto-flow: column;\n  gap: 6px;\n  cursor: default;\n}\n\n.success__icon {\n  display: flex;\n}\n";
/**
 * Creates <style> element for widget dialog
 */ function createDialogStyles(styleNonce) {
    var style = DOCUMENT.createElement('style');
    style.textContent = "\n:host {\n  --dialog-inset: var(--inset);\n}\n\n".concat(DIALOG, "\n").concat(DIALOG_HEADER, "\n").concat(FORM, "\n").concat(BUTTON, "\n").concat(SUCCESS, "\n");
    if (styleNonce) style.setAttribute('nonce', styleNonce);
    return style;
}
function getUser() {
    var currentUser = (0, _core.getCurrentScope)().getUser();
    var isolationUser = (0, _core.getIsolationScope)().getUser();
    var globalUser = (0, _core.getGlobalScope)().getUser();
    if (currentUser && Object.keys(currentUser).length) return currentUser;
    if (isolationUser && Object.keys(isolationUser).length) return isolationUser;
    return globalUser;
}
var feedbackModalIntegration = function() {
    return {
        name: 'FeedbackModal',
        setupOnce: function setupOnce() {},
        createDialog: function(param) {
            var options = param.options, screenshotIntegration = param.screenshotIntegration, sendFeedback = param.sendFeedback, shadow = param.shadow;
            var shadowRoot = shadow;
            var userKey = options.useSentryUser;
            var user = getUser();
            var el = DOCUMENT.createElement('div');
            var style = createDialogStyles(options.styleNonce);
            var originalOverflow = '';
            var dialog = {
                get el () {
                    return el;
                },
                appendToDom: function appendToDom() {
                    if (!shadowRoot.contains(style) && !shadowRoot.contains(el)) {
                        shadowRoot.appendChild(style);
                        shadowRoot.appendChild(el);
                    }
                },
                removeFromDom: function removeFromDom() {
                    el.remove();
                    style.remove();
                    DOCUMENT.body.style.overflow = originalOverflow;
                },
                open: function open() {
                    var _options_onFormOpen, _getClient;
                    renderContent(true);
                    (_options_onFormOpen = options.onFormOpen) === null || _options_onFormOpen === void 0 ? void 0 : _options_onFormOpen.call(options);
                    (_getClient = (0, _core.getClient)()) === null || _getClient === void 0 ? void 0 : _getClient.emit('openFeedbackWidget');
                    originalOverflow = DOCUMENT.body.style.overflow;
                    DOCUMENT.body.style.overflow = 'hidden';
                },
                close: function close() {
                    renderContent(false);
                    DOCUMENT.body.style.overflow = originalOverflow;
                }
            };
            var screenshotInput = screenshotIntegration === null || screenshotIntegration === void 0 ? void 0 : screenshotIntegration.createInput({
                h: y$1,
                hooks: hooks,
                dialog: dialog,
                options: options
            });
            var renderContent = function(open) {
                B$1(y$1(Dialog, {
                    options: options,
                    screenshotInput: screenshotInput,
                    showName: options.showName || options.isNameRequired,
                    showEmail: options.showEmail || options.isEmailRequired,
                    defaultName: userKey && (user === null || user === void 0 ? void 0 : user[userKey.name]) || '',
                    defaultEmail: userKey && (user === null || user === void 0 ? void 0 : user[userKey.email]) || '',
                    onFormClose: function() {
                        var _options_onFormClose;
                        renderContent(false);
                        (_options_onFormClose = options.onFormClose) === null || _options_onFormClose === void 0 ? void 0 : _options_onFormClose.call(options);
                    },
                    onSubmit: sendFeedback,
                    onSubmitSuccess: function(data, eventId) {
                        var _options_onSubmitSuccess;
                        renderContent(false);
                        (_options_onSubmitSuccess = options.onSubmitSuccess) === null || _options_onSubmitSuccess === void 0 ? void 0 : _options_onSubmitSuccess.call(options, data, eventId);
                    },
                    onSubmitError: function(error) {
                        var _options_onSubmitError;
                        (_options_onSubmitError = options.onSubmitError) === null || _options_onSubmitError === void 0 ? void 0 : _options_onSubmitError.call(options, error);
                    },
                    onFormSubmitted: function() {
                        var _options_onFormSubmitted;
                        (_options_onFormSubmitted = options.onFormSubmitted) === null || _options_onFormSubmitted === void 0 ? void 0 : _options_onFormSubmitted.call(options);
                    },
                    open: open
                }), el);
            };
            return dialog;
        }
    };
};
function IconCloseFactory(param) {
    var h = param.h;
    return function IconClose() {
        return h('svg', {
            'data-test-id': "icon-close",
            viewBox: "0 0 16 16",
            fill: "#2B2233",
            height: "25px",
            width: "25px"
        }, h('circle', {
            r: "7",
            cx: "8",
            cy: "8",
            fill: "white"
        }), h('path', {
            strokeWidth: "1.5",
            d: "M8,16a8,8,0,1,1,8-8A8,8,0,0,1,8,16ZM8,1.53A6.47,6.47,0,1,0,14.47,8,6.47,6.47,0,0,0,8,1.53Z"
        }), h('path', {
            strokeWidth: "1.5",
            d: "M5.34,11.41a.71.71,0,0,1-.53-.22.74.74,0,0,1,0-1.06l5.32-5.32a.75.75,0,0,1,1.06,1.06L5.87,11.19A.74.74,0,0,1,5.34,11.41Z"
        }), h('path', {
            strokeWidth: "1.5",
            d: "M10.66,11.41a.74.74,0,0,1-.53-.22L4.81,5.87A.75.75,0,0,1,5.87,4.81l5.32,5.32a.74.74,0,0,1,0,1.06A.71.71,0,0,1,10.66,11.41Z"
        }));
    };
}
/**
 * Creates <style> element for widget dialog
 */ function createScreenshotInputStyles(styleNonce) {
    var style = DOCUMENT.createElement('style');
    var surface200 = '#1A141F';
    var gray100 = '#302735';
    style.textContent = "\n.editor {\n  display: flex;\n  flex-grow: 1;\n  flex-direction: column;\n}\n\n.editor__image-container {\n  justify-items: center;\n  padding: 15px;\n  position: relative;\n  height: 100%;\n  border-radius: var(--menu-border-radius, 6px);\n\n  background-color: ".concat(surface200, ";\n  background-image: repeating-linear-gradient(\n      -145deg,\n      transparent,\n      transparent 8px,\n      ").concat(surface200, " 8px,\n      ").concat(surface200, " 11px\n    ),\n    repeating-linear-gradient(\n      -45deg,\n      transparent,\n      transparent 15px,\n      ").concat(gray100, " 15px,\n      ").concat(gray100, " 16px\n    );\n}\n\n.editor__canvas-container {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.editor__canvas-container > * {\n  object-fit: contain;\n  position: absolute;\n}\n\n.editor__tool-container {\n  padding-top: 8px;\n  display: flex;\n  justify-content: center;\n}\n\n.editor__tool-bar {\n  display: flex;\n  gap: 8px;\n}\n\n.editor__tool {\n  display: flex;\n  padding: 8px 12px;\n  justify-content: center;\n  align-items: center;\n  border: var(--button-border, var(--border));\n  border-radius: var(--button-border-radius, 6px);\n  background: var(--button-background, var(--background));\n  color: var(--button-color, var(--foreground));\n}\n\n.editor__tool--active {\n  background: var(--button-primary-background, var(--accent-background));\n  color: var(--button-primary-color, var(--accent-foreground));\n}\n\n.editor__rect {\n  position: absolute;\n  z-index: 2;\n}\n\n.editor__rect button {\n  opacity: 0;\n  position: absolute;\n  top: -12px;\n  right: -12px;\n  cursor: pointer;\n  padding: 0;\n  z-index: 3;\n  border: none;\n  background: none;\n}\n\n.editor__rect:hover button {\n  opacity: 1;\n}\n");
    if (styleNonce) style.setAttribute('nonce', styleNonce);
    return style;
}
function ToolbarFactory(param) {
    var h = param.h;
    return function Toolbar(param) {
        var action = param.action, setAction = param.setAction, options = param.options;
        return h('div', {
            class: "editor__tool-container"
        }, h('div', {
            class: "editor__tool-bar"
        }, h('button', {
            type: "button",
            class: "editor__tool ".concat(action === 'highlight' ? 'editor__tool--active' : ''),
            onClick: function() {
                setAction(action === 'highlight' ? '' : 'highlight');
            }
        }, options.highlightToolText), h('button', {
            type: "button",
            class: "editor__tool ".concat(action === 'hide' ? 'editor__tool--active' : ''),
            onClick: function() {
                setAction(action === 'hide' ? '' : 'hide');
            }
        }, options.hideToolText)));
    };
}
function useTakeScreenshotFactory(param) {
    var hooks = param.hooks;
    function useDpi() {
        var _WINDOW_devicePixelRatio;
        var _hooks_useState = (0, _slicedToArray._)(hooks.useState((_WINDOW_devicePixelRatio = WINDOW.devicePixelRatio) !== null && _WINDOW_devicePixelRatio !== void 0 ? _WINDOW_devicePixelRatio : 1), 2), dpi = _hooks_useState[0], setDpi = _hooks_useState[1];
        hooks.useEffect(function() {
            var onChange = function() {
                setDpi(WINDOW.devicePixelRatio);
            };
            var media = matchMedia("(resolution: ".concat(WINDOW.devicePixelRatio, "dppx)"));
            media.addEventListener('change', onChange);
            return function() {
                media.removeEventListener('change', onChange);
            };
        }, []);
        return dpi;
    }
    return function useTakeScreenshot(param) {
        var onBeforeScreenshot = param.onBeforeScreenshot, onScreenshot = param.onScreenshot, onAfterScreenshot = param.onAfterScreenshot, onError = param.onError;
        var dpi = useDpi();
        hooks.useEffect(function() {
            var takeScreenshot = function() {
                return (0, _asyncToGenerator._)(function() {
                    var stream, video;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                onBeforeScreenshot();
                                return [
                                    4,
                                    NAVIGATOR.mediaDevices.getDisplayMedia({
                                        video: {
                                            width: WINDOW.innerWidth * dpi,
                                            height: WINDOW.innerHeight * dpi
                                        },
                                        audio: false,
                                        // @ts-expect-error experimental flags: https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getDisplayMedia#prefercurrenttab
                                        monitorTypeSurfaces: 'exclude',
                                        preferCurrentTab: true,
                                        selfBrowserSurface: 'include',
                                        surfaceSwitching: 'exclude'
                                    })
                                ];
                            case 1:
                                stream = _state.sent();
                                video = DOCUMENT.createElement('video');
                                return [
                                    4,
                                    new Promise(function(resolve, reject) {
                                        video.srcObject = stream;
                                        video.onloadedmetadata = function() {
                                            onScreenshot(video, dpi);
                                            stream.getTracks().forEach(function(track) {
                                                return track.stop();
                                            });
                                            resolve();
                                        };
                                        video.play().catch(reject);
                                    })
                                ];
                            case 2:
                                _state.sent();
                                onAfterScreenshot();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
            takeScreenshot().catch(onError);
        }, []);
    };
}
function drawRect(command, ctx, color) {
    switch(command.type){
        case 'highlight':
            // creates a shadow around
            ctx.shadowColor = 'rgba(0, 0, 0, 0.7)';
            ctx.shadowBlur = 50;
            // draws a rectangle first with a shadow
            ctx.fillStyle = color;
            ctx.fillRect(command.x - 1, command.y - 1, command.w + 2, command.h + 2);
            // cut out the inside of the rectangle
            ctx.clearRect(command.x, command.y, command.w, command.h);
            break;
        case 'hide':
            ctx.fillStyle = 'rgb(0, 0, 0)';
            ctx.fillRect(command.x, command.y, command.w, command.h);
            break;
    }
}
function with2dContext(canvas, options, callback) {
    if (!canvas) return;
    var ctx = canvas.getContext('2d', options);
    if (!ctx) return;
    callback(canvas, ctx);
}
function paintImage(maybeDest, source) {
    with2dContext(maybeDest, {
        alpha: true
    }, function(destCanvas, destCtx) {
        destCtx.drawImage(source, 0, 0, source.width, source.height, 0, 0, destCanvas.width, destCanvas.height);
    });
}
// Paint the array of drawCommands into a canvas.
// Assuming this is the canvas foreground, and the background is cleaned.
function paintForeground(maybeCanvas, strokeColor, drawCommands) {
    with2dContext(maybeCanvas, {
        alpha: true
    }, function(canvas, ctx) {
        // If there's anything to draw, then we'll first clear the canvas with
        // a transparent grey background
        if (drawCommands.length) {
            ctx.fillStyle = 'rgba(0, 0, 0, 0.25)';
            ctx.fillRect(0, 0, canvas.width, canvas.height);
        }
        drawCommands.forEach(function(command) {
            drawRect(command, ctx, strokeColor);
        });
    });
}
function ScreenshotEditorFactory(param) {
    var h = param.h, hooks = param.hooks, outputBuffer = param.outputBuffer, dialog = param.dialog, options = param.options;
    var useTakeScreenshot = useTakeScreenshotFactory({
        hooks: hooks
    });
    var Toolbar = ToolbarFactory({
        h: h
    });
    var IconClose = IconCloseFactory({
        h: h
    });
    var editorStyleInnerText = {
        __html: createScreenshotInputStyles(options.styleNonce).innerText
    };
    var dialogStyle = dialog.el.style;
    var ScreenshotEditor = function(param) {
        var screenshot = param.screenshot;
        // Data for rendering:
        var _hooks_useState = (0, _slicedToArray._)(hooks.useState('highlight'), 2), action = _hooks_useState[0], setAction = _hooks_useState[1];
        var _hooks_useState1 = (0, _slicedToArray._)(hooks.useState([]), 2), drawCommands = _hooks_useState1[0], setDrawCommands = _hooks_useState1[1];
        // Refs to our html components:
        var measurementRef = hooks.useRef(null);
        var backgroundRef = hooks.useRef(null);
        var foregroundRef = hooks.useRef(null);
        var mouseRef = hooks.useRef(null);
        // The size of our window, relative to the imageSource
        var _hooks_useState2 = (0, _slicedToArray._)(hooks.useState(1), 2), scaleFactor = _hooks_useState2[0], setScaleFactor = _hooks_useState2[1];
        var strokeColor = hooks.useMemo(function() {
            var sentryFeedback = DOCUMENT.getElementById(options.id);
            if (!sentryFeedback) return 'white';
            var computedStyle = getComputedStyle(sentryFeedback);
            return computedStyle.getPropertyValue('--button-primary-background') || computedStyle.getPropertyValue('--accent-background');
        }, [
            options.id
        ]);
        // The initial resize, to measure the area and set the children to the correct size
        hooks.useLayoutEffect(function() {
            var handleResize = function() {
                var measurementDiv = measurementRef.current;
                if (!measurementDiv) return;
                with2dContext(screenshot.canvas, {
                    alpha: false
                }, function(canvas) {
                    var scale = Math.min(measurementDiv.clientWidth / canvas.width, measurementDiv.clientHeight / canvas.height);
                    setScaleFactor(scale);
                });
                // For Firefox, the canvas is not yet measured, so we need to wait for it to get the correct size
                if (measurementDiv.clientHeight === 0 || measurementDiv.clientWidth === 0) setTimeout(handleResize, 0);
            };
            handleResize();
            WINDOW.addEventListener('resize', handleResize);
            return function() {
                WINDOW.removeEventListener('resize', handleResize);
            };
        }, [
            screenshot
        ]);
        // Set the size of the canvas element to match our screenshot
        var setCanvasSize = hooks.useCallback(function(maybeCanvas, scale) {
            with2dContext(maybeCanvas, {
                alpha: true
            }, function(canvas, ctx) {
                // Must call `scale()` before setting `width` & `height`
                ctx.scale(scale, scale);
                canvas.width = screenshot.canvas.width;
                canvas.height = screenshot.canvas.height;
            });
        }, [
            screenshot
        ]);
        // Draw the screenshot into the background
        hooks.useEffect(function() {
            setCanvasSize(backgroundRef.current, screenshot.dpi);
            paintImage(backgroundRef.current, screenshot.canvas);
        }, [
            screenshot
        ]);
        // Draw the commands into the foreground
        hooks.useEffect(function() {
            setCanvasSize(foregroundRef.current, screenshot.dpi);
            with2dContext(foregroundRef.current, {
                alpha: true
            }, function(canvas, ctx) {
                ctx.clearRect(0, 0, canvas.width, canvas.height);
            });
            paintForeground(foregroundRef.current, strokeColor, drawCommands);
        }, [
            drawCommands,
            strokeColor
        ]);
        // Draw into the output outputBuffer
        hooks.useEffect(function() {
            setCanvasSize(outputBuffer, screenshot.dpi);
            paintImage(outputBuffer, screenshot.canvas);
            with2dContext(DOCUMENT.createElement('canvas'), {
                alpha: true
            }, function(foreground, ctx) {
                ctx.scale(screenshot.dpi, screenshot.dpi); // The scale needs to be set before we set the width/height and paint
                foreground.width = screenshot.canvas.width;
                foreground.height = screenshot.canvas.height;
                paintForeground(foreground, strokeColor, drawCommands);
                paintImage(outputBuffer, foreground);
            });
        }, [
            drawCommands,
            screenshot,
            strokeColor
        ]);
        var handleMouseDown = function(e) {
            if (!action || !mouseRef.current) return;
            var boundingRect = mouseRef.current.getBoundingClientRect();
            var startingPoint = {
                type: action,
                x: e.offsetX / scaleFactor,
                y: e.offsetY / scaleFactor
            };
            var getDrawCommand = function(startingPoint, e) {
                var _$x = (e.clientX - boundingRect.x) / scaleFactor;
                var _$y = (e.clientY - boundingRect.y) / scaleFactor;
                return {
                    type: startingPoint.type,
                    x: Math.min(startingPoint.x, _$x),
                    y: Math.min(startingPoint.y, _$y),
                    w: Math.abs(_$x - startingPoint.x),
                    h: Math.abs(_$y - startingPoint.y)
                };
            };
            var handleMouseMove = function(e) {
                with2dContext(foregroundRef.current, {
                    alpha: true
                }, function(canvas, ctx) {
                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                });
                paintForeground(foregroundRef.current, strokeColor, (0, _toConsumableArray._)(drawCommands).concat([
                    getDrawCommand(startingPoint, e)
                ]));
            };
            var handleMouseUp = function(e) {
                var drawCommand = getDrawCommand(startingPoint, e);
                // Prevent just clicking onto the canvas, mouse has to move at least 1 pixel
                if (drawCommand.w * scaleFactor >= 1 && drawCommand.h * scaleFactor >= 1) setDrawCommands(function(prev) {
                    return (0, _toConsumableArray._)(prev).concat([
                        drawCommand
                    ]);
                });
                DOCUMENT.removeEventListener('mousemove', handleMouseMove);
                DOCUMENT.removeEventListener('mouseup', handleMouseUp);
            };
            DOCUMENT.addEventListener('mousemove', handleMouseMove);
            DOCUMENT.addEventListener('mouseup', handleMouseUp);
        };
        var deleteRect = hooks.useCallback(function(index) {
            return function(e) {
                e.preventDefault();
                e.stopPropagation();
                setDrawCommands(function(prev) {
                    var updatedRects = (0, _toConsumableArray._)(prev);
                    updatedRects.splice(index, 1);
                    return updatedRects;
                });
            };
        }, []);
        var dimensions = {
            width: "".concat(screenshot.canvas.width * scaleFactor, "px"),
            height: "".concat(screenshot.canvas.height * scaleFactor, "px")
        };
        var handleStopPropagation = function(e) {
            e.stopPropagation();
        };
        return h('div', {
            class: "editor"
        }, h('style', {
            nonce: options.styleNonce,
            dangerouslySetInnerHTML: editorStyleInnerText
        }), h('div', {
            class: "editor__image-container"
        }, h('div', {
            class: "editor__canvas-container",
            ref: measurementRef
        }, h('canvas', {
            ref: backgroundRef,
            id: "background",
            style: dimensions
        }), h('canvas', {
            ref: foregroundRef,
            id: "foreground",
            style: dimensions
        }), h('div', {
            ref: mouseRef,
            onMouseDown: handleMouseDown,
            style: dimensions
        }, drawCommands.map(function(rect, index) {
            return h('div', {
                key: index,
                class: "editor__rect",
                style: {
                    top: "".concat(rect.y * scaleFactor, "px"),
                    left: "".concat(rect.x * scaleFactor, "px"),
                    width: "".concat(rect.w * scaleFactor, "px"),
                    height: "".concat(rect.h * scaleFactor, "px")
                }
            }, h('button', {
                'aria-label': options.removeHighlightText,
                onClick: deleteRect(index),
                onMouseDown: handleStopPropagation,
                onMouseUp: handleStopPropagation,
                type: "button"
            }, h(IconClose, null)));
        })))), h(Toolbar, {
            options: options,
            action: action,
            setAction: setAction
        }));
    };
    return function Wrapper(param) {
        var onError = param.onError;
        var _hooks_useState = (0, _slicedToArray._)(hooks.useState(), 2), screenshot = _hooks_useState[0], setScreenshot = _hooks_useState[1];
        useTakeScreenshot({
            onBeforeScreenshot: hooks.useCallback(function() {
                dialogStyle.display = 'none';
            }, []),
            onScreenshot: hooks.useCallback(function(screenshotVideo, dpi) {
                // Stash the original screenshot image so we can (re)draw it multiple times
                with2dContext(DOCUMENT.createElement('canvas'), {
                    alpha: false
                }, function(canvas, ctx) {
                    ctx.scale(dpi, dpi); // The scale needs to be set before we set the width/height and paint
                    canvas.width = screenshotVideo.videoWidth;
                    canvas.height = screenshotVideo.videoHeight;
                    ctx.drawImage(screenshotVideo, 0, 0, canvas.width, canvas.height);
                    setScreenshot({
                        canvas: canvas,
                        dpi: dpi
                    });
                });
                // The output buffer, we only need to set the width/height on this once, it stays the same forever
                outputBuffer.width = screenshotVideo.videoWidth;
                outputBuffer.height = screenshotVideo.videoHeight;
            }, []),
            onAfterScreenshot: hooks.useCallback(function() {
                dialogStyle.display = 'block';
            }, []),
            onError: hooks.useCallback(function(error) {
                dialogStyle.display = 'block';
                onError(error);
            }, [])
        });
        if (screenshot) return h(ScreenshotEditor, {
            screenshot: screenshot
        });
        return h('div', null);
    };
}
var feedbackScreenshotIntegration = function() {
    return {
        name: 'FeedbackScreenshot',
        setupOnce: function setupOnce() {},
        createInput: function(param) {
            var h = param.h, hooks = param.hooks, dialog = param.dialog, options = param.options;
            var outputBuffer = DOCUMENT.createElement('canvas');
            return {
                input: ScreenshotEditorFactory({
                    h: h,
                    hooks: hooks,
                    outputBuffer: outputBuffer,
                    dialog: dialog,
                    options: options
                }),
                value: function() {
                    return (0, _asyncToGenerator._)(function() {
                        var blob, data, _, attachment;
                        return (0, _tsGenerator._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        new Promise(function(resolve) {
                                            outputBuffer.toBlob(resolve, 'image/png');
                                        })
                                    ];
                                case 1:
                                    blob = _state.sent();
                                    if (!blob) return [
                                        3,
                                        3
                                    ];
                                    _ = Uint8Array.bind;
                                    return [
                                        4,
                                        blob.arrayBuffer()
                                    ];
                                case 2:
                                    data = new (_.apply(Uint8Array, [
                                        void 0,
                                        _state.sent()
                                    ]));
                                    attachment = {
                                        data: data,
                                        filename: 'screenshot.png',
                                        contentType: 'application/png'
                                    };
                                    return [
                                        2,
                                        attachment
                                    ];
                                case 3:
                                    return [
                                        2,
                                        undefined
                                    ];
                            }
                        });
                    })();
                }
            };
        }
    };
};

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_to_consumable_array":"1eSZf","@swc/helpers/_/_type_of":"iFJdx","@swc/helpers/_/_ts_generator":"78Tqx","@sentry/core":"lqtxA","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lqtxA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "registerSpanErrorInstrumentation", function() {
    return 0, _errorsJs.registerSpanErrorInstrumentation;
});
parcelHelpers.export(exports, "getCapturedScopesOnSpan", function() {
    return 0, _utilsJs.getCapturedScopesOnSpan;
});
parcelHelpers.export(exports, "setCapturedScopesOnSpan", function() {
    return 0, _utilsJs.setCapturedScopesOnSpan;
});
parcelHelpers.export(exports, "TRACING_DEFAULTS", function() {
    return 0, _idleSpanJs.TRACING_DEFAULTS;
});
parcelHelpers.export(exports, "startIdleSpan", function() {
    return 0, _idleSpanJs.startIdleSpan;
});
parcelHelpers.export(exports, "SentrySpan", function() {
    return 0, _sentrySpanJs.SentrySpan;
});
parcelHelpers.export(exports, "SentryNonRecordingSpan", function() {
    return 0, _sentryNonRecordingSpanJs.SentryNonRecordingSpan;
});
parcelHelpers.export(exports, "SPAN_STATUS_ERROR", function() {
    return 0, _spanstatusJs.SPAN_STATUS_ERROR;
});
parcelHelpers.export(exports, "SPAN_STATUS_OK", function() {
    return 0, _spanstatusJs.SPAN_STATUS_OK;
});
parcelHelpers.export(exports, "SPAN_STATUS_UNSET", function() {
    return 0, _spanstatusJs.SPAN_STATUS_UNSET;
});
parcelHelpers.export(exports, "getSpanStatusFromHttpCode", function() {
    return 0, _spanstatusJs.getSpanStatusFromHttpCode;
});
parcelHelpers.export(exports, "setHttpStatus", function() {
    return 0, _spanstatusJs.setHttpStatus;
});
parcelHelpers.export(exports, "continueTrace", function() {
    return 0, _traceJs.continueTrace;
});
parcelHelpers.export(exports, "startInactiveSpan", function() {
    return 0, _traceJs.startInactiveSpan;
});
parcelHelpers.export(exports, "startNewTrace", function() {
    return 0, _traceJs.startNewTrace;
});
parcelHelpers.export(exports, "startSpan", function() {
    return 0, _traceJs.startSpan;
});
parcelHelpers.export(exports, "startSpanManual", function() {
    return 0, _traceJs.startSpanManual;
});
parcelHelpers.export(exports, "suppressTracing", function() {
    return 0, _traceJs.suppressTracing;
});
parcelHelpers.export(exports, "withActiveSpan", function() {
    return 0, _traceJs.withActiveSpan;
});
parcelHelpers.export(exports, "getDynamicSamplingContextFromClient", function() {
    return 0, _dynamicSamplingContextJs.getDynamicSamplingContextFromClient;
});
parcelHelpers.export(exports, "getDynamicSamplingContextFromScope", function() {
    return 0, _dynamicSamplingContextJs.getDynamicSamplingContextFromScope;
});
parcelHelpers.export(exports, "getDynamicSamplingContextFromSpan", function() {
    return 0, _dynamicSamplingContextJs.getDynamicSamplingContextFromSpan;
});
parcelHelpers.export(exports, "spanToBaggageHeader", function() {
    return 0, _dynamicSamplingContextJs.spanToBaggageHeader;
});
parcelHelpers.export(exports, "setMeasurement", function() {
    return 0, _measurementJs.setMeasurement;
});
parcelHelpers.export(exports, "timedEventsToMeasurements", function() {
    return 0, _measurementJs.timedEventsToMeasurements;
});
parcelHelpers.export(exports, "sampleSpan", function() {
    return 0, _samplingJs.sampleSpan;
});
parcelHelpers.export(exports, "logSpanEnd", function() {
    return 0, _logSpansJs.logSpanEnd;
});
parcelHelpers.export(exports, "logSpanStart", function() {
    return 0, _logSpansJs.logSpanStart;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_CACHE_HIT", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_CACHE_HIT;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_CACHE_KEY", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_CACHE_KEY;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_PROFILE_ID", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_PROFILE_ID;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_OP", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_URL_FULL", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_URL_FULL;
});
parcelHelpers.export(exports, "SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE", function() {
    return 0, _semanticAttributesJs.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE;
});
parcelHelpers.export(exports, "createEventEnvelope", function() {
    return 0, _envelopeJs.createEventEnvelope;
});
parcelHelpers.export(exports, "createSessionEnvelope", function() {
    return 0, _envelopeJs.createSessionEnvelope;
});
parcelHelpers.export(exports, "createSpanEnvelope", function() {
    return 0, _envelopeJs.createSpanEnvelope;
});
parcelHelpers.export(exports, "addEventProcessor", function() {
    return 0, _exportsJs.addEventProcessor;
});
parcelHelpers.export(exports, "captureCheckIn", function() {
    return 0, _exportsJs.captureCheckIn;
});
parcelHelpers.export(exports, "captureEvent", function() {
    return 0, _exportsJs.captureEvent;
});
parcelHelpers.export(exports, "captureException", function() {
    return 0, _exportsJs.captureException;
});
parcelHelpers.export(exports, "captureMessage", function() {
    return 0, _exportsJs.captureMessage;
});
parcelHelpers.export(exports, "captureSession", function() {
    return 0, _exportsJs.captureSession;
});
parcelHelpers.export(exports, "close", function() {
    return 0, _exportsJs.close;
});
parcelHelpers.export(exports, "endSession", function() {
    return 0, _exportsJs.endSession;
});
parcelHelpers.export(exports, "flush", function() {
    return 0, _exportsJs.flush;
});
parcelHelpers.export(exports, "isEnabled", function() {
    return 0, _exportsJs.isEnabled;
});
parcelHelpers.export(exports, "isInitialized", function() {
    return 0, _exportsJs.isInitialized;
});
parcelHelpers.export(exports, "lastEventId", function() {
    return 0, _exportsJs.lastEventId;
});
parcelHelpers.export(exports, "setContext", function() {
    return 0, _exportsJs.setContext;
});
parcelHelpers.export(exports, "setExtra", function() {
    return 0, _exportsJs.setExtra;
});
parcelHelpers.export(exports, "setExtras", function() {
    return 0, _exportsJs.setExtras;
});
parcelHelpers.export(exports, "setTag", function() {
    return 0, _exportsJs.setTag;
});
parcelHelpers.export(exports, "setTags", function() {
    return 0, _exportsJs.setTags;
});
parcelHelpers.export(exports, "setUser", function() {
    return 0, _exportsJs.setUser;
});
parcelHelpers.export(exports, "startSession", function() {
    return 0, _exportsJs.startSession;
});
parcelHelpers.export(exports, "withMonitor", function() {
    return 0, _exportsJs.withMonitor;
});
parcelHelpers.export(exports, "getClient", function() {
    return 0, _currentScopesJs.getClient;
});
parcelHelpers.export(exports, "getCurrentScope", function() {
    return 0, _currentScopesJs.getCurrentScope;
});
parcelHelpers.export(exports, "getGlobalScope", function() {
    return 0, _currentScopesJs.getGlobalScope;
});
parcelHelpers.export(exports, "getIsolationScope", function() {
    return 0, _currentScopesJs.getIsolationScope;
});
parcelHelpers.export(exports, "getTraceContextFromScope", function() {
    return 0, _currentScopesJs.getTraceContextFromScope;
});
parcelHelpers.export(exports, "withIsolationScope", function() {
    return 0, _currentScopesJs.withIsolationScope;
});
parcelHelpers.export(exports, "withScope", function() {
    return 0, _currentScopesJs.withScope;
});
parcelHelpers.export(exports, "getDefaultCurrentScope", function() {
    return 0, _defaultScopesJs.getDefaultCurrentScope;
});
parcelHelpers.export(exports, "getDefaultIsolationScope", function() {
    return 0, _defaultScopesJs.getDefaultIsolationScope;
});
parcelHelpers.export(exports, "setAsyncContextStrategy", function() {
    return 0, _indexJs.setAsyncContextStrategy;
});
parcelHelpers.export(exports, "getGlobalSingleton", function() {
    return 0, _carrierJs.getGlobalSingleton;
});
parcelHelpers.export(exports, "getMainCarrier", function() {
    return 0, _carrierJs.getMainCarrier;
});
parcelHelpers.export(exports, "closeSession", function() {
    return 0, _sessionJs.closeSession;
});
parcelHelpers.export(exports, "makeSession", function() {
    return 0, _sessionJs.makeSession;
});
parcelHelpers.export(exports, "updateSession", function() {
    return 0, _sessionJs.updateSession;
});
parcelHelpers.export(exports, "Scope", function() {
    return 0, _scopeJs.Scope;
});
parcelHelpers.export(exports, "notifyEventProcessors", function() {
    return 0, _eventProcessorsJs.notifyEventProcessors;
});
parcelHelpers.export(exports, "getEnvelopeEndpointWithUrlEncodedAuth", function() {
    return 0, _apiJs.getEnvelopeEndpointWithUrlEncodedAuth;
});
parcelHelpers.export(exports, "getReportDialogEndpoint", function() {
    return 0, _apiJs.getReportDialogEndpoint;
});
parcelHelpers.export(exports, "Client", function() {
    return 0, _clientJs.Client;
});
parcelHelpers.export(exports, "ServerRuntimeClient", function() {
    return 0, _serverRuntimeClientJs.ServerRuntimeClient;
});
parcelHelpers.export(exports, "initAndBind", function() {
    return 0, _sdkJs.initAndBind;
});
parcelHelpers.export(exports, "setCurrentClient", function() {
    return 0, _sdkJs.setCurrentClient;
});
parcelHelpers.export(exports, "createTransport", function() {
    return 0, _baseJs.createTransport;
});
parcelHelpers.export(exports, "makeOfflineTransport", function() {
    return 0, _offlineJs.makeOfflineTransport;
});
parcelHelpers.export(exports, "makeMultiplexedTransport", function() {
    return 0, _multiplexedJs.makeMultiplexedTransport;
});
parcelHelpers.export(exports, "addIntegration", function() {
    return 0, _integrationJs.addIntegration;
});
parcelHelpers.export(exports, "defineIntegration", function() {
    return 0, _integrationJs.defineIntegration;
});
parcelHelpers.export(exports, "getIntegrationsToSetup", function() {
    return 0, _integrationJs.getIntegrationsToSetup;
});
parcelHelpers.export(exports, "installedIntegrations", function() {
    return 0, _integrationJs.installedIntegrations;
});
parcelHelpers.export(exports, "_INTERNAL_clearAiProviderSkips", function() {
    return 0, _providerSkipJs._INTERNAL_clearAiProviderSkips;
});
parcelHelpers.export(exports, "_INTERNAL_shouldSkipAiProviderWrapping", function() {
    return 0, _providerSkipJs._INTERNAL_shouldSkipAiProviderWrapping;
});
parcelHelpers.export(exports, "_INTERNAL_skipAiProviderWrapping", function() {
    return 0, _providerSkipJs._INTERNAL_skipAiProviderWrapping;
});
parcelHelpers.export(exports, "applyScopeDataToEvent", function() {
    return 0, _applyScopeDataToEventJs.applyScopeDataToEvent;
});
parcelHelpers.export(exports, "mergeScopeData", function() {
    return 0, _applyScopeDataToEventJs.mergeScopeData;
});
parcelHelpers.export(exports, "prepareEvent", function() {
    return 0, _prepareEventJs.prepareEvent;
});
parcelHelpers.export(exports, "createCheckInEnvelope", function() {
    return 0, _checkinJs.createCheckInEnvelope;
});
parcelHelpers.export(exports, "hasSpansEnabled", function() {
    return 0, _hasSpansEnabledJs.hasSpansEnabled;
});
parcelHelpers.export(exports, "isSentryRequestUrl", function() {
    return 0, _isSentryRequestUrlJs.isSentryRequestUrl;
});
parcelHelpers.export(exports, "handleCallbackErrors", function() {
    return 0, _handleCallbackErrorsJs.handleCallbackErrors;
});
parcelHelpers.export(exports, "fmt", function() {
    return 0, _parameterizeJs.fmt;
});
parcelHelpers.export(exports, "parameterize", function() {
    return 0, _parameterizeJs.parameterize;
});
parcelHelpers.export(exports, "addAutoIpAddressToSession", function() {
    return 0, _ipAddressJs.addAutoIpAddressToSession;
});
parcelHelpers.export(exports, "addAutoIpAddressToUser", function() {
    return 0, _ipAddressJs.addAutoIpAddressToUser;
});
parcelHelpers.export(exports, "addChildSpanToSpan", function() {
    return 0, _spanUtilsJs.addChildSpanToSpan;
});
parcelHelpers.export(exports, "convertSpanLinksForEnvelope", function() {
    return 0, _spanUtilsJs.convertSpanLinksForEnvelope;
});
parcelHelpers.export(exports, "getActiveSpan", function() {
    return 0, _spanUtilsJs.getActiveSpan;
});
parcelHelpers.export(exports, "getRootSpan", function() {
    return 0, _spanUtilsJs.getRootSpan;
});
parcelHelpers.export(exports, "getSpanDescendants", function() {
    return 0, _spanUtilsJs.getSpanDescendants;
});
parcelHelpers.export(exports, "getStatusMessage", function() {
    return 0, _spanUtilsJs.getStatusMessage;
});
parcelHelpers.export(exports, "spanIsSampled", function() {
    return 0, _spanUtilsJs.spanIsSampled;
});
parcelHelpers.export(exports, "spanTimeInputToSeconds", function() {
    return 0, _spanUtilsJs.spanTimeInputToSeconds;
});
parcelHelpers.export(exports, "spanToJSON", function() {
    return 0, _spanUtilsJs.spanToJSON;
});
parcelHelpers.export(exports, "spanToTraceContext", function() {
    return 0, _spanUtilsJs.spanToTraceContext;
});
parcelHelpers.export(exports, "spanToTraceHeader", function() {
    return 0, _spanUtilsJs.spanToTraceHeader;
});
parcelHelpers.export(exports, "updateSpanName", function() {
    return 0, _spanUtilsJs.updateSpanName;
});
parcelHelpers.export(exports, "_INTERNAL_setSpanForScope", function() {
    return 0, _spanOnScopeJs._setSpanForScope;
});
parcelHelpers.export(exports, "parseSampleRate", function() {
    return 0, _parseSampleRateJs.parseSampleRate;
});
parcelHelpers.export(exports, "applySdkMetadata", function() {
    return 0, _sdkMetadataJs.applySdkMetadata;
});
parcelHelpers.export(exports, "getTraceData", function() {
    return 0, _traceDataJs.getTraceData;
});
parcelHelpers.export(exports, "getTraceMetaTags", function() {
    return 0, _metaJs.getTraceMetaTags;
});
parcelHelpers.export(exports, "debounce", function() {
    return 0, _debounceJs.debounce;
});
parcelHelpers.export(exports, "extractQueryParamsFromUrl", function() {
    return 0, _requestJs.extractQueryParamsFromUrl;
});
parcelHelpers.export(exports, "headersToDict", function() {
    return 0, _requestJs.headersToDict;
});
parcelHelpers.export(exports, "httpHeadersToSpanAttributes", function() {
    return 0, _requestJs.httpHeadersToSpanAttributes;
});
parcelHelpers.export(exports, "httpRequestToRequestData", function() {
    return 0, _requestJs.httpRequestToRequestData;
});
parcelHelpers.export(exports, "winterCGHeadersToDict", function() {
    return 0, _requestJs.winterCGHeadersToDict;
});
parcelHelpers.export(exports, "winterCGRequestToRequestData", function() {
    return 0, _requestJs.winterCGRequestToRequestData;
});
parcelHelpers.export(exports, "DEFAULT_ENVIRONMENT", function() {
    return 0, _constantsJs.DEFAULT_ENVIRONMENT;
});
parcelHelpers.export(exports, "addBreadcrumb", function() {
    return 0, _breadcrumbsJs.addBreadcrumb;
});
parcelHelpers.export(exports, "functionToStringIntegration", function() {
    return 0, _functiontostringJs.functionToStringIntegration;
});
parcelHelpers.export(exports, "eventFiltersIntegration", function() {
    return 0, _eventFiltersJs.eventFiltersIntegration;
});
parcelHelpers.export(exports, "inboundFiltersIntegration", function() {
    return 0, _eventFiltersJs.inboundFiltersIntegration;
});
parcelHelpers.export(exports, "linkedErrorsIntegration", function() {
    return 0, _linkederrorsJs.linkedErrorsIntegration;
});
parcelHelpers.export(exports, "moduleMetadataIntegration", function() {
    return 0, _moduleMetadataJs.moduleMetadataIntegration;
});
parcelHelpers.export(exports, "requestDataIntegration", function() {
    return 0, _requestdataJs.requestDataIntegration;
});
parcelHelpers.export(exports, "captureConsoleIntegration", function() {
    return 0, _captureconsoleJs.captureConsoleIntegration;
});
parcelHelpers.export(exports, "dedupeIntegration", function() {
    return 0, _dedupeJs.dedupeIntegration;
});
parcelHelpers.export(exports, "extraErrorDataIntegration", function() {
    return 0, _extraerrordataJs.extraErrorDataIntegration;
});
parcelHelpers.export(exports, "rewriteFramesIntegration", function() {
    return 0, _rewriteframesJs.rewriteFramesIntegration;
});
parcelHelpers.export(exports, "instrumentSupabaseClient", function() {
    return 0, _supabaseJs.instrumentSupabaseClient;
});
parcelHelpers.export(exports, "supabaseIntegration", function() {
    return 0, _supabaseJs.supabaseIntegration;
});
parcelHelpers.export(exports, "zodErrorsIntegration", function() {
    return 0, _zoderrorsJs.zodErrorsIntegration;
});
parcelHelpers.export(exports, "thirdPartyErrorFilterIntegration", function() {
    return 0, _thirdPartyErrorsFilterJs.thirdPartyErrorFilterIntegration;
});
parcelHelpers.export(exports, "consoleIntegration", function() {
    return 0, _consoleJs.consoleIntegration;
});
parcelHelpers.export(exports, "featureFlagsIntegration", function() {
    return 0, _featureFlagsIntegrationJs.featureFlagsIntegration;
});
parcelHelpers.export(exports, "growthbookIntegration", function() {
    return 0, _growthbookJs.growthbookIntegration;
});
parcelHelpers.export(exports, "profiler", function() {
    return 0, _profilingJs.profiler;
});
parcelHelpers.export(exports, "instrumentFetchRequest", function() {
    return 0, _fetchJs.instrumentFetchRequest;
});
parcelHelpers.export(exports, "trpcMiddleware", function() {
    return 0, _trpcJs.trpcMiddleware;
});
parcelHelpers.export(exports, "wrapMcpServerWithSentry", function() {
    return 0, _indexJs1.wrapMcpServerWithSentry;
});
parcelHelpers.export(exports, "captureFeedback", function() {
    return 0, _feedbackJs.captureFeedback;
});
parcelHelpers.export(exports, "_INTERNAL_captureLog", function() {
    return 0, _internalJs._INTERNAL_captureLog;
});
parcelHelpers.export(exports, "_INTERNAL_captureSerializedLog", function() {
    return 0, _internalJs._INTERNAL_captureSerializedLog;
});
parcelHelpers.export(exports, "_INTERNAL_flushLogsBuffer", function() {
    return 0, _internalJs._INTERNAL_flushLogsBuffer;
});
parcelHelpers.export(exports, "consoleLoggingIntegration", function() {
    return 0, _consoleIntegrationJs.consoleLoggingIntegration;
});
parcelHelpers.export(exports, "_INTERNAL_captureMetric", function() {
    return 0, _internalJs1._INTERNAL_captureMetric;
});
parcelHelpers.export(exports, "_INTERNAL_captureSerializedMetric", function() {
    return 0, _internalJs1._INTERNAL_captureSerializedMetric;
});
parcelHelpers.export(exports, "_INTERNAL_flushMetricsBuffer", function() {
    return 0, _internalJs1._INTERNAL_flushMetricsBuffer;
});
parcelHelpers.export(exports, "createConsolaReporter", function() {
    return 0, _consolaJs.createConsolaReporter;
});
parcelHelpers.export(exports, "addVercelAiProcessors", function() {
    return 0, _indexJs2.addVercelAiProcessors;
});
parcelHelpers.export(exports, "_INTERNAL_cleanupToolCallSpan", function() {
    return 0, _utilsJs1._INTERNAL_cleanupToolCallSpan;
});
parcelHelpers.export(exports, "_INTERNAL_getSpanForToolCallId", function() {
    return 0, _utilsJs1._INTERNAL_getSpanForToolCallId;
});
parcelHelpers.export(exports, "instrumentOpenAiClient", function() {
    return 0, _indexJs3.instrumentOpenAiClient;
});
parcelHelpers.export(exports, "OPENAI_INTEGRATION_NAME", function() {
    return 0, _constantsJs1.OPENAI_INTEGRATION_NAME;
});
parcelHelpers.export(exports, "instrumentAnthropicAiClient", function() {
    return 0, _indexJs4.instrumentAnthropicAiClient;
});
parcelHelpers.export(exports, "ANTHROPIC_AI_INTEGRATION_NAME", function() {
    return 0, _constantsJs2.ANTHROPIC_AI_INTEGRATION_NAME;
});
parcelHelpers.export(exports, "instrumentGoogleGenAIClient", function() {
    return 0, _indexJs5.instrumentGoogleGenAIClient;
});
parcelHelpers.export(exports, "GOOGLE_GENAI_INTEGRATION_NAME", function() {
    return 0, _constantsJs3.GOOGLE_GENAI_INTEGRATION_NAME;
});
parcelHelpers.export(exports, "createLangChainCallbackHandler", function() {
    return 0, _indexJs6.createLangChainCallbackHandler;
});
parcelHelpers.export(exports, "LANGCHAIN_INTEGRATION_NAME", function() {
    return 0, _constantsJs4.LANGCHAIN_INTEGRATION_NAME;
});
parcelHelpers.export(exports, "instrumentLangGraph", function() {
    return 0, _indexJs7.instrumentLangGraph;
});
parcelHelpers.export(exports, "instrumentStateGraphCompile", function() {
    return 0, _indexJs7.instrumentStateGraphCompile;
});
parcelHelpers.export(exports, "LANGGRAPH_INTEGRATION_NAME", function() {
    return 0, _constantsJs5.LANGGRAPH_INTEGRATION_NAME;
});
parcelHelpers.export(exports, "_INTERNAL_FLAG_BUFFER_SIZE", function() {
    return 0, _featureFlagsJs._INTERNAL_FLAG_BUFFER_SIZE;
});
parcelHelpers.export(exports, "_INTERNAL_MAX_FLAGS_PER_SPAN", function() {
    return 0, _featureFlagsJs._INTERNAL_MAX_FLAGS_PER_SPAN;
});
parcelHelpers.export(exports, "_INTERNAL_addFeatureFlagToActiveSpan", function() {
    return 0, _featureFlagsJs._INTERNAL_addFeatureFlagToActiveSpan;
});
parcelHelpers.export(exports, "_INTERNAL_copyFlagsFromScopeToEvent", function() {
    return 0, _featureFlagsJs._INTERNAL_copyFlagsFromScopeToEvent;
});
parcelHelpers.export(exports, "_INTERNAL_insertFlagToScope", function() {
    return 0, _featureFlagsJs._INTERNAL_insertFlagToScope;
});
parcelHelpers.export(exports, "applyAggregateErrorsToEvent", function() {
    return 0, _aggregateErrorsJs.applyAggregateErrorsToEvent;
});
parcelHelpers.export(exports, "getBreadcrumbLogLevelFromHttpStatusCode", function() {
    return 0, _breadcrumbLogLevelJs.getBreadcrumbLogLevelFromHttpStatusCode;
});
parcelHelpers.export(exports, "getComponentName", function() {
    return 0, _browserJs.getComponentName;
});
parcelHelpers.export(exports, "getLocationHref", function() {
    return 0, _browserJs.getLocationHref;
});
parcelHelpers.export(exports, "htmlTreeAsString", function() {
    return 0, _browserJs.htmlTreeAsString;
});
parcelHelpers.export(exports, "dsnFromString", function() {
    return 0, _dsnJs.dsnFromString;
});
parcelHelpers.export(exports, "dsnToString", function() {
    return 0, _dsnJs.dsnToString;
});
parcelHelpers.export(exports, "makeDsn", function() {
    return 0, _dsnJs.makeDsn;
});
parcelHelpers.export(exports, "SentryError", function() {
    return 0, _errorJs.SentryError;
});
parcelHelpers.export(exports, "GLOBAL_OBJ", function() {
    return 0, _worldwideJs.GLOBAL_OBJ;
});
parcelHelpers.export(exports, "addConsoleInstrumentationHandler", function() {
    return 0, _consoleJs1.addConsoleInstrumentationHandler;
});
parcelHelpers.export(exports, "addFetchEndInstrumentationHandler", function() {
    return 0, _fetchJs1.addFetchEndInstrumentationHandler;
});
parcelHelpers.export(exports, "addFetchInstrumentationHandler", function() {
    return 0, _fetchJs1.addFetchInstrumentationHandler;
});
parcelHelpers.export(exports, "addGlobalErrorInstrumentationHandler", function() {
    return 0, _globalErrorJs.addGlobalErrorInstrumentationHandler;
});
parcelHelpers.export(exports, "addGlobalUnhandledRejectionInstrumentationHandler", function() {
    return 0, _globalUnhandledRejectionJs.addGlobalUnhandledRejectionInstrumentationHandler;
});
parcelHelpers.export(exports, "addHandler", function() {
    return 0, _handlersJs.addHandler;
});
parcelHelpers.export(exports, "maybeInstrument", function() {
    return 0, _handlersJs.maybeInstrument;
});
parcelHelpers.export(exports, "resetInstrumentationHandlers", function() {
    return 0, _handlersJs.resetInstrumentationHandlers;
});
parcelHelpers.export(exports, "triggerHandlers", function() {
    return 0, _handlersJs.triggerHandlers;
});
parcelHelpers.export(exports, "isDOMError", function() {
    return 0, _isJs.isDOMError;
});
parcelHelpers.export(exports, "isDOMException", function() {
    return 0, _isJs.isDOMException;
});
parcelHelpers.export(exports, "isElement", function() {
    return 0, _isJs.isElement;
});
parcelHelpers.export(exports, "isError", function() {
    return 0, _isJs.isError;
});
parcelHelpers.export(exports, "isErrorEvent", function() {
    return 0, _isJs.isErrorEvent;
});
parcelHelpers.export(exports, "isEvent", function() {
    return 0, _isJs.isEvent;
});
parcelHelpers.export(exports, "isInstanceOf", function() {
    return 0, _isJs.isInstanceOf;
});
parcelHelpers.export(exports, "isParameterizedString", function() {
    return 0, _isJs.isParameterizedString;
});
parcelHelpers.export(exports, "isPlainObject", function() {
    return 0, _isJs.isPlainObject;
});
parcelHelpers.export(exports, "isPrimitive", function() {
    return 0, _isJs.isPrimitive;
});
parcelHelpers.export(exports, "isRegExp", function() {
    return 0, _isJs.isRegExp;
});
parcelHelpers.export(exports, "isString", function() {
    return 0, _isJs.isString;
});
parcelHelpers.export(exports, "isSyntheticEvent", function() {
    return 0, _isJs.isSyntheticEvent;
});
parcelHelpers.export(exports, "isThenable", function() {
    return 0, _isJs.isThenable;
});
parcelHelpers.export(exports, "isVueViewModel", function() {
    return 0, _isJs.isVueViewModel;
});
parcelHelpers.export(exports, "isBrowser", function() {
    return 0, _isBrowserJs.isBrowser;
});
parcelHelpers.export(exports, "CONSOLE_LEVELS", function() {
    return 0, _debugLoggerJs.CONSOLE_LEVELS;
});
parcelHelpers.export(exports, "consoleSandbox", function() {
    return 0, _debugLoggerJs.consoleSandbox;
});
parcelHelpers.export(exports, "debug", function() {
    return 0, _debugLoggerJs.debug;
});
parcelHelpers.export(exports, "originalConsoleMethods", function() {
    return 0, _debugLoggerJs.originalConsoleMethods;
});
parcelHelpers.export(exports, "addContextToFrame", function() {
    return 0, _miscJs.addContextToFrame;
});
parcelHelpers.export(exports, "addExceptionMechanism", function() {
    return 0, _miscJs.addExceptionMechanism;
});
parcelHelpers.export(exports, "addExceptionTypeValue", function() {
    return 0, _miscJs.addExceptionTypeValue;
});
parcelHelpers.export(exports, "checkOrSetAlreadyCaught", function() {
    return 0, _miscJs.checkOrSetAlreadyCaught;
});
parcelHelpers.export(exports, "getEventDescription", function() {
    return 0, _miscJs.getEventDescription;
});
parcelHelpers.export(exports, "parseSemver", function() {
    return 0, _miscJs.parseSemver;
});
parcelHelpers.export(exports, "uuid4", function() {
    return 0, _miscJs.uuid4;
});
parcelHelpers.export(exports, "isNodeEnv", function() {
    return 0, _nodeJs.isNodeEnv;
});
parcelHelpers.export(exports, "loadModule", function() {
    return 0, _nodeJs.loadModule;
});
parcelHelpers.export(exports, "normalize", function() {
    return 0, _normalizeJs.normalize;
});
parcelHelpers.export(exports, "normalizeToSize", function() {
    return 0, _normalizeJs.normalizeToSize;
});
parcelHelpers.export(exports, "normalizeUrlToBase", function() {
    return 0, _normalizeJs.normalizeUrlToBase;
});
parcelHelpers.export(exports, "addNonEnumerableProperty", function() {
    return 0, _objectJs.addNonEnumerableProperty;
});
parcelHelpers.export(exports, "convertToPlainObject", function() {
    return 0, _objectJs.convertToPlainObject;
});
parcelHelpers.export(exports, "dropUndefinedKeys", function() {
    return 0, _objectJs.dropUndefinedKeys;
});
parcelHelpers.export(exports, "extractExceptionKeysForMessage", function() {
    return 0, _objectJs.extractExceptionKeysForMessage;
});
parcelHelpers.export(exports, "fill", function() {
    return 0, _objectJs.fill;
});
parcelHelpers.export(exports, "getOriginalFunction", function() {
    return 0, _objectJs.getOriginalFunction;
});
parcelHelpers.export(exports, "markFunctionWrapped", function() {
    return 0, _objectJs.markFunctionWrapped;
});
parcelHelpers.export(exports, "objectify", function() {
    return 0, _objectJs.objectify;
});
parcelHelpers.export(exports, "basename", function() {
    return 0, _pathJs.basename;
});
parcelHelpers.export(exports, "dirname", function() {
    return 0, _pathJs.dirname;
});
parcelHelpers.export(exports, "isAbsolute", function() {
    return 0, _pathJs.isAbsolute;
});
parcelHelpers.export(exports, "join", function() {
    return 0, _pathJs.join;
});
parcelHelpers.export(exports, "normalizePath", function() {
    return 0, _pathJs.normalizePath;
});
parcelHelpers.export(exports, "relative", function() {
    return 0, _pathJs.relative;
});
parcelHelpers.export(exports, "resolve", function() {
    return 0, _pathJs.resolve;
});
parcelHelpers.export(exports, "SENTRY_BUFFER_FULL_ERROR", function() {
    return 0, _promisebufferJs.SENTRY_BUFFER_FULL_ERROR;
});
parcelHelpers.export(exports, "makePromiseBuffer", function() {
    return 0, _promisebufferJs.makePromiseBuffer;
});
parcelHelpers.export(exports, "severityLevelFromString", function() {
    return 0, _severityJs.severityLevelFromString;
});
parcelHelpers.export(exports, "replaceExports", function() {
    return 0, _exportsJs1.replaceExports;
});
parcelHelpers.export(exports, "UNKNOWN_FUNCTION", function() {
    return 0, _stacktraceJs.UNKNOWN_FUNCTION;
});
parcelHelpers.export(exports, "createStackParser", function() {
    return 0, _stacktraceJs.createStackParser;
});
parcelHelpers.export(exports, "getFramesFromEvent", function() {
    return 0, _stacktraceJs.getFramesFromEvent;
});
parcelHelpers.export(exports, "getFunctionName", function() {
    return 0, _stacktraceJs.getFunctionName;
});
parcelHelpers.export(exports, "stackParserFromStackParserOptions", function() {
    return 0, _stacktraceJs.stackParserFromStackParserOptions;
});
parcelHelpers.export(exports, "stripSentryFramesAndReverse", function() {
    return 0, _stacktraceJs.stripSentryFramesAndReverse;
});
parcelHelpers.export(exports, "filenameIsInApp", function() {
    return 0, _nodeStackTraceJs.filenameIsInApp;
});
parcelHelpers.export(exports, "node", function() {
    return 0, _nodeStackTraceJs.node;
});
parcelHelpers.export(exports, "nodeStackLineParser", function() {
    return 0, _nodeStackTraceJs.nodeStackLineParser;
});
parcelHelpers.export(exports, "isMatchingPattern", function() {
    return 0, _stringJs.isMatchingPattern;
});
parcelHelpers.export(exports, "safeJoin", function() {
    return 0, _stringJs.safeJoin;
});
parcelHelpers.export(exports, "snipLine", function() {
    return 0, _stringJs.snipLine;
});
parcelHelpers.export(exports, "stringMatchesSomePattern", function() {
    return 0, _stringJs.stringMatchesSomePattern;
});
parcelHelpers.export(exports, "truncate", function() {
    return 0, _stringJs.truncate;
});
parcelHelpers.export(exports, "isNativeFunction", function() {
    return 0, _supportsJs.isNativeFunction;
});
parcelHelpers.export(exports, "supportsDOMError", function() {
    return 0, _supportsJs.supportsDOMError;
});
parcelHelpers.export(exports, "supportsDOMException", function() {
    return 0, _supportsJs.supportsDOMException;
});
parcelHelpers.export(exports, "supportsErrorEvent", function() {
    return 0, _supportsJs.supportsErrorEvent;
});
parcelHelpers.export(exports, "supportsFetch", function() {
    return 0, _supportsJs.supportsFetch;
});
parcelHelpers.export(exports, "supportsHistory", function() {
    return 0, _supportsJs.supportsHistory;
});
parcelHelpers.export(exports, "supportsNativeFetch", function() {
    return 0, _supportsJs.supportsNativeFetch;
});
parcelHelpers.export(exports, "supportsReferrerPolicy", function() {
    return 0, _supportsJs.supportsReferrerPolicy;
});
parcelHelpers.export(exports, "supportsReportingObserver", function() {
    return 0, _supportsJs.supportsReportingObserver;
});
parcelHelpers.export(exports, "SyncPromise", function() {
    return 0, _syncpromiseJs.SyncPromise;
});
parcelHelpers.export(exports, "rejectedSyncPromise", function() {
    return 0, _syncpromiseJs.rejectedSyncPromise;
});
parcelHelpers.export(exports, "resolvedSyncPromise", function() {
    return 0, _syncpromiseJs.resolvedSyncPromise;
});
parcelHelpers.export(exports, "browserPerformanceTimeOrigin", function() {
    return 0, _timeJs.browserPerformanceTimeOrigin;
});
parcelHelpers.export(exports, "dateTimestampInSeconds", function() {
    return 0, _timeJs.dateTimestampInSeconds;
});
parcelHelpers.export(exports, "timestampInSeconds", function() {
    return 0, _timeJs.timestampInSeconds;
});
parcelHelpers.export(exports, "TRACEPARENT_REGEXP", function() {
    return 0, _tracingJs.TRACEPARENT_REGEXP;
});
parcelHelpers.export(exports, "extractTraceparentData", function() {
    return 0, _tracingJs.extractTraceparentData;
});
parcelHelpers.export(exports, "generateSentryTraceHeader", function() {
    return 0, _tracingJs.generateSentryTraceHeader;
});
parcelHelpers.export(exports, "propagationContextFromHeaders", function() {
    return 0, _tracingJs.propagationContextFromHeaders;
});
parcelHelpers.export(exports, "shouldContinueTrace", function() {
    return 0, _tracingJs.shouldContinueTrace;
});
parcelHelpers.export(exports, "getSDKSource", function() {
    return 0, _envJs.getSDKSource;
});
parcelHelpers.export(exports, "isBrowserBundle", function() {
    return 0, _envJs.isBrowserBundle;
});
parcelHelpers.export(exports, "addItemToEnvelope", function() {
    return 0, _envelopeJs1.addItemToEnvelope;
});
parcelHelpers.export(exports, "createAttachmentEnvelopeItem", function() {
    return 0, _envelopeJs1.createAttachmentEnvelopeItem;
});
parcelHelpers.export(exports, "createEnvelope", function() {
    return 0, _envelopeJs1.createEnvelope;
});
parcelHelpers.export(exports, "createEventEnvelopeHeaders", function() {
    return 0, _envelopeJs1.createEventEnvelopeHeaders;
});
parcelHelpers.export(exports, "createSpanEnvelopeItem", function() {
    return 0, _envelopeJs1.createSpanEnvelopeItem;
});
parcelHelpers.export(exports, "envelopeContainsItemType", function() {
    return 0, _envelopeJs1.envelopeContainsItemType;
});
parcelHelpers.export(exports, "envelopeItemTypeToDataCategory", function() {
    return 0, _envelopeJs1.envelopeItemTypeToDataCategory;
});
parcelHelpers.export(exports, "forEachEnvelopeItem", function() {
    return 0, _envelopeJs1.forEachEnvelopeItem;
});
parcelHelpers.export(exports, "getSdkMetadataForEnvelopeHeader", function() {
    return 0, _envelopeJs1.getSdkMetadataForEnvelopeHeader;
});
parcelHelpers.export(exports, "parseEnvelope", function() {
    return 0, _envelopeJs1.parseEnvelope;
});
parcelHelpers.export(exports, "serializeEnvelope", function() {
    return 0, _envelopeJs1.serializeEnvelope;
});
parcelHelpers.export(exports, "createClientReportEnvelope", function() {
    return 0, _clientreportJs.createClientReportEnvelope;
});
parcelHelpers.export(exports, "DEFAULT_RETRY_AFTER", function() {
    return 0, _ratelimitJs.DEFAULT_RETRY_AFTER;
});
parcelHelpers.export(exports, "disabledUntil", function() {
    return 0, _ratelimitJs.disabledUntil;
});
parcelHelpers.export(exports, "isRateLimited", function() {
    return 0, _ratelimitJs.isRateLimited;
});
parcelHelpers.export(exports, "parseRetryAfterHeader", function() {
    return 0, _ratelimitJs.parseRetryAfterHeader;
});
parcelHelpers.export(exports, "updateRateLimits", function() {
    return 0, _ratelimitJs.updateRateLimits;
});
parcelHelpers.export(exports, "MAX_BAGGAGE_STRING_LENGTH", function() {
    return 0, _baggageJs.MAX_BAGGAGE_STRING_LENGTH;
});
parcelHelpers.export(exports, "SENTRY_BAGGAGE_KEY_PREFIX", function() {
    return 0, _baggageJs.SENTRY_BAGGAGE_KEY_PREFIX;
});
parcelHelpers.export(exports, "SENTRY_BAGGAGE_KEY_PREFIX_REGEX", function() {
    return 0, _baggageJs.SENTRY_BAGGAGE_KEY_PREFIX_REGEX;
});
parcelHelpers.export(exports, "baggageHeaderToDynamicSamplingContext", function() {
    return 0, _baggageJs.baggageHeaderToDynamicSamplingContext;
});
parcelHelpers.export(exports, "dynamicSamplingContextToSentryBaggageHeader", function() {
    return 0, _baggageJs.dynamicSamplingContextToSentryBaggageHeader;
});
parcelHelpers.export(exports, "objectToBaggageHeader", function() {
    return 0, _baggageJs.objectToBaggageHeader;
});
parcelHelpers.export(exports, "parseBaggageHeader", function() {
    return 0, _baggageJs.parseBaggageHeader;
});
parcelHelpers.export(exports, "getHttpSpanDetailsFromUrlObject", function() {
    return 0, _urlJs.getHttpSpanDetailsFromUrlObject;
});
parcelHelpers.export(exports, "getSanitizedUrlString", function() {
    return 0, _urlJs.getSanitizedUrlString;
});
parcelHelpers.export(exports, "getSanitizedUrlStringFromUrlObject", function() {
    return 0, _urlJs.getSanitizedUrlStringFromUrlObject;
});
parcelHelpers.export(exports, "isURLObjectRelative", function() {
    return 0, _urlJs.isURLObjectRelative;
});
parcelHelpers.export(exports, "parseStringToURLObject", function() {
    return 0, _urlJs.parseStringToURLObject;
});
parcelHelpers.export(exports, "parseUrl", function() {
    return 0, _urlJs.parseUrl;
});
parcelHelpers.export(exports, "stripUrlQueryAndFragment", function() {
    return 0, _urlJs.stripUrlQueryAndFragment;
});
parcelHelpers.export(exports, "eventFromMessage", function() {
    return 0, _eventbuilderJs.eventFromMessage;
});
parcelHelpers.export(exports, "eventFromUnknownInput", function() {
    return 0, _eventbuilderJs.eventFromUnknownInput;
});
parcelHelpers.export(exports, "exceptionFromError", function() {
    return 0, _eventbuilderJs.exceptionFromError;
});
parcelHelpers.export(exports, "parseStackFrames", function() {
    return 0, _eventbuilderJs.parseStackFrames;
});
parcelHelpers.export(exports, "callFrameToStackFrame", function() {
    return 0, _anrJs.callFrameToStackFrame;
});
parcelHelpers.export(exports, "watchdogTimer", function() {
    return 0, _anrJs.watchdogTimer;
});
parcelHelpers.export(exports, "LRUMap", function() {
    return 0, _lruJs.LRUMap;
});
parcelHelpers.export(exports, "generateSpanId", function() {
    return 0, _propagationContextJs.generateSpanId;
});
parcelHelpers.export(exports, "generateTraceId", function() {
    return 0, _propagationContextJs.generateTraceId;
});
parcelHelpers.export(exports, "vercelWaitUntil", function() {
    return 0, _vercelWaitUntilJs.vercelWaitUntil;
});
parcelHelpers.export(exports, "flushIfServerless", function() {
    return 0, _flushIfServerlessJs.flushIfServerless;
});
parcelHelpers.export(exports, "SDK_VERSION", function() {
    return 0, _versionJs.SDK_VERSION;
});
parcelHelpers.export(exports, "getDebugImagesForResources", function() {
    return 0, _debugIdsJs.getDebugImagesForResources;
});
parcelHelpers.export(exports, "getFilenameToDebugIdMap", function() {
    return 0, _debugIdsJs.getFilenameToDebugIdMap;
});
parcelHelpers.export(exports, "escapeStringForRegex", function() {
    return 0, _escapeStringForRegexJs.escapeStringForRegex;
});
parcelHelpers.export(exports, "logger", function() {
    return _publicApiJs;
});
parcelHelpers.export(exports, "metrics", function() {
    return _publicApiJs1;
});
var _errorsJs = require("./tracing/errors.js");
var _utilsJs = require("./tracing/utils.js");
var _idleSpanJs = require("./tracing/idleSpan.js");
var _sentrySpanJs = require("./tracing/sentrySpan.js");
var _sentryNonRecordingSpanJs = require("./tracing/sentryNonRecordingSpan.js");
var _spanstatusJs = require("./tracing/spanstatus.js");
var _traceJs = require("./tracing/trace.js");
var _dynamicSamplingContextJs = require("./tracing/dynamicSamplingContext.js");
var _measurementJs = require("./tracing/measurement.js");
var _samplingJs = require("./tracing/sampling.js");
var _logSpansJs = require("./tracing/logSpans.js");
var _semanticAttributesJs = require("./semanticAttributes.js");
var _envelopeJs = require("./envelope.js");
var _exportsJs = require("./exports.js");
var _currentScopesJs = require("./currentScopes.js");
var _defaultScopesJs = require("./defaultScopes.js");
var _indexJs = require("./asyncContext/index.js");
var _carrierJs = require("./carrier.js");
var _sessionJs = require("./session.js");
var _scopeJs = require("./scope.js");
var _eventProcessorsJs = require("./eventProcessors.js");
var _apiJs = require("./api.js");
var _clientJs = require("./client.js");
var _serverRuntimeClientJs = require("./server-runtime-client.js");
var _sdkJs = require("./sdk.js");
var _baseJs = require("./transports/base.js");
var _offlineJs = require("./transports/offline.js");
var _multiplexedJs = require("./transports/multiplexed.js");
var _integrationJs = require("./integration.js");
var _providerSkipJs = require("./utils/ai/providerSkip.js");
var _applyScopeDataToEventJs = require("./utils/applyScopeDataToEvent.js");
var _prepareEventJs = require("./utils/prepareEvent.js");
var _checkinJs = require("./checkin.js");
var _hasSpansEnabledJs = require("./utils/hasSpansEnabled.js");
var _isSentryRequestUrlJs = require("./utils/isSentryRequestUrl.js");
var _handleCallbackErrorsJs = require("./utils/handleCallbackErrors.js");
var _parameterizeJs = require("./utils/parameterize.js");
var _ipAddressJs = require("./utils/ipAddress.js");
var _spanUtilsJs = require("./utils/spanUtils.js");
var _spanOnScopeJs = require("./utils/spanOnScope.js");
var _parseSampleRateJs = require("./utils/parseSampleRate.js");
var _sdkMetadataJs = require("./utils/sdkMetadata.js");
var _traceDataJs = require("./utils/traceData.js");
var _metaJs = require("./utils/meta.js");
var _debounceJs = require("./utils/debounce.js");
var _requestJs = require("./utils/request.js");
var _constantsJs = require("./constants.js");
var _breadcrumbsJs = require("./breadcrumbs.js");
var _functiontostringJs = require("./integrations/functiontostring.js");
var _eventFiltersJs = require("./integrations/eventFilters.js");
var _linkederrorsJs = require("./integrations/linkederrors.js");
var _moduleMetadataJs = require("./integrations/moduleMetadata.js");
var _requestdataJs = require("./integrations/requestdata.js");
var _captureconsoleJs = require("./integrations/captureconsole.js");
var _dedupeJs = require("./integrations/dedupe.js");
var _extraerrordataJs = require("./integrations/extraerrordata.js");
var _rewriteframesJs = require("./integrations/rewriteframes.js");
var _supabaseJs = require("./integrations/supabase.js");
var _zoderrorsJs = require("./integrations/zoderrors.js");
var _thirdPartyErrorsFilterJs = require("./integrations/third-party-errors-filter.js");
var _consoleJs = require("./integrations/console.js");
var _featureFlagsIntegrationJs = require("./integrations/featureFlags/featureFlagsIntegration.js");
var _growthbookJs = require("./integrations/featureFlags/growthbook.js");
var _profilingJs = require("./profiling.js");
var _fetchJs = require("./fetch.js");
var _trpcJs = require("./trpc.js");
var _indexJs1 = require("./integrations/mcp-server/index.js");
var _feedbackJs = require("./feedback.js");
var _internalJs = require("./logs/internal.js");
var _publicApiJs = require("./logs/public-api.js");
var _consoleIntegrationJs = require("./logs/console-integration.js");
var _internalJs1 = require("./metrics/internal.js");
var _publicApiJs1 = require("./metrics/public-api.js");
var _consolaJs = require("./integrations/consola.js");
var _indexJs2 = require("./tracing/vercel-ai/index.js");
var _utilsJs1 = require("./tracing/vercel-ai/utils.js");
var _indexJs3 = require("./tracing/openai/index.js");
var _constantsJs1 = require("./tracing/openai/constants.js");
var _indexJs4 = require("./tracing/anthropic-ai/index.js");
var _constantsJs2 = require("./tracing/anthropic-ai/constants.js");
var _indexJs5 = require("./tracing/google-genai/index.js");
var _constantsJs3 = require("./tracing/google-genai/constants.js");
var _indexJs6 = require("./tracing/langchain/index.js");
var _constantsJs4 = require("./tracing/langchain/constants.js");
var _indexJs7 = require("./tracing/langgraph/index.js");
var _constantsJs5 = require("./tracing/langgraph/constants.js");
var _featureFlagsJs = require("./utils/featureFlags.js");
var _aggregateErrorsJs = require("./utils/aggregate-errors.js");
var _breadcrumbLogLevelJs = require("./utils/breadcrumb-log-level.js");
var _browserJs = require("./utils/browser.js");
var _dsnJs = require("./utils/dsn.js");
var _errorJs = require("./utils/error.js");
var _worldwideJs = require("./utils/worldwide.js");
var _consoleJs1 = require("./instrument/console.js");
var _fetchJs1 = require("./instrument/fetch.js");
var _globalErrorJs = require("./instrument/globalError.js");
var _globalUnhandledRejectionJs = require("./instrument/globalUnhandledRejection.js");
var _handlersJs = require("./instrument/handlers.js");
var _isJs = require("./utils/is.js");
var _isBrowserJs = require("./utils/isBrowser.js");
var _debugLoggerJs = require("./utils/debug-logger.js");
var _miscJs = require("./utils/misc.js");
var _nodeJs = require("./utils/node.js");
var _normalizeJs = require("./utils/normalize.js");
var _objectJs = require("./utils/object.js");
var _pathJs = require("./utils/path.js");
var _promisebufferJs = require("./utils/promisebuffer.js");
var _severityJs = require("./utils/severity.js");
var _exportsJs1 = require("./utils/exports.js");
var _stacktraceJs = require("./utils/stacktrace.js");
var _nodeStackTraceJs = require("./utils/node-stack-trace.js");
var _stringJs = require("./utils/string.js");
var _supportsJs = require("./utils/supports.js");
var _syncpromiseJs = require("./utils/syncpromise.js");
var _timeJs = require("./utils/time.js");
var _tracingJs = require("./utils/tracing.js");
var _envJs = require("./utils/env.js");
var _envelopeJs1 = require("./utils/envelope.js");
var _clientreportJs = require("./utils/clientreport.js");
var _ratelimitJs = require("./utils/ratelimit.js");
var _baggageJs = require("./utils/baggage.js");
var _urlJs = require("./utils/url.js");
var _eventbuilderJs = require("./utils/eventbuilder.js");
var _anrJs = require("./utils/anr.js");
var _lruJs = require("./utils/lru.js");
var _propagationContextJs = require("./utils/propagationContext.js");
var _vercelWaitUntilJs = require("./utils/vercelWaitUntil.js");
var _flushIfServerlessJs = require("./utils/flushIfServerless.js");
var _versionJs = require("./utils/version.js");
var _debugIdsJs = require("./utils/debug-ids.js");
var _escapeStringForRegexJs = require("./vendor/escapeStringForRegex.js");

},{"./tracing/errors.js":"e2sL3","./tracing/utils.js":"1QtCb","./tracing/idleSpan.js":"3nu8c","./tracing/sentrySpan.js":"aWoC1","./tracing/sentryNonRecordingSpan.js":"j8tB0","./tracing/spanstatus.js":"WiYVV","./tracing/trace.js":"eu0PU","./tracing/dynamicSamplingContext.js":"5RiCd","./tracing/measurement.js":"guYPr","./tracing/sampling.js":"3ygwj","./tracing/logSpans.js":"fGZ3g","./semanticAttributes.js":"7WRPE","./envelope.js":"8mEkR","./exports.js":"1Xqap","./currentScopes.js":"3GE4v","./defaultScopes.js":"rVids","./asyncContext/index.js":"8OVZH","./carrier.js":"abKK3","./session.js":"7bmuG","./scope.js":"gbShS","./eventProcessors.js":"1o4fb","./api.js":"9GGAx","./client.js":"f0QJY","./server-runtime-client.js":"92f5Y","./sdk.js":"aRdc0","./transports/base.js":"fZU08","./transports/offline.js":"2JFdH","./transports/multiplexed.js":"gwCcj","./integration.js":"brH19","./utils/ai/providerSkip.js":"Hjmw6","./utils/applyScopeDataToEvent.js":"jd7cV","./utils/prepareEvent.js":"gVd7T","./checkin.js":"1x4do","./utils/hasSpansEnabled.js":"klZEt","./utils/isSentryRequestUrl.js":"s5mmt","./utils/handleCallbackErrors.js":"g30DX","./utils/parameterize.js":"2z7TO","./utils/ipAddress.js":"iYZFY","./utils/spanUtils.js":"fPRKj","./utils/spanOnScope.js":"rJBOp","./utils/parseSampleRate.js":"e0bLP","./utils/sdkMetadata.js":"9SY37","./utils/traceData.js":"1Pg6b","./utils/meta.js":"5KnUB","./utils/debounce.js":"gc533","./utils/request.js":"eSNLU","./constants.js":"7XllJ","./breadcrumbs.js":"d8fz5","./integrations/functiontostring.js":"aMTOV","./integrations/eventFilters.js":"5sYiA","./integrations/linkederrors.js":"j9IHf","./integrations/moduleMetadata.js":"kYhBC","./integrations/requestdata.js":"l0uoE","./integrations/captureconsole.js":"7gtky","./integrations/dedupe.js":"1WgfN","./integrations/extraerrordata.js":"iBvh1","./integrations/rewriteframes.js":"cAyki","./integrations/supabase.js":"i6x5v","./integrations/zoderrors.js":"7B14I","./integrations/third-party-errors-filter.js":"6fktY","./integrations/console.js":"Jf7TC","./integrations/featureFlags/featureFlagsIntegration.js":"52WJQ","./integrations/featureFlags/growthbook.js":"eSQGk","./profiling.js":"7leUb","./fetch.js":"3u3sW","./trpc.js":"5ivG0","./integrations/mcp-server/index.js":"h79GQ","./feedback.js":"lIJvr","./logs/internal.js":"3IZl8","./logs/public-api.js":"k7EX4","./logs/console-integration.js":"6dcOp","./metrics/internal.js":"acYCr","./metrics/public-api.js":"hTrNs","./integrations/consola.js":"jwQCw","./tracing/vercel-ai/index.js":"astYj","./tracing/vercel-ai/utils.js":"7ZXP3","./tracing/openai/index.js":"hXFQb","./tracing/openai/constants.js":"7kmW5","./tracing/anthropic-ai/index.js":"fkwxA","./tracing/anthropic-ai/constants.js":"9BrtT","./tracing/google-genai/index.js":"N6cF7","./tracing/google-genai/constants.js":"82pKK","./tracing/langchain/index.js":"bIGl1","./tracing/langchain/constants.js":"ccscT","./tracing/langgraph/index.js":"2zQDc","./tracing/langgraph/constants.js":"h6j6H","./utils/featureFlags.js":"7Ay9H","./utils/aggregate-errors.js":"anvAD","./utils/breadcrumb-log-level.js":"kjugJ","./utils/browser.js":"fv4f7","./utils/dsn.js":"jNv3f","./utils/error.js":"7rXdg","./utils/worldwide.js":"3qnNR","./instrument/console.js":"eEuZ3","./instrument/fetch.js":"7S2h2","./instrument/globalError.js":"ao6Fy","./instrument/globalUnhandledRejection.js":"jeqG8","./instrument/handlers.js":"imb6z","./utils/is.js":"kSqSf","./utils/isBrowser.js":"cknCE","./utils/debug-logger.js":"3X9Vf","./utils/misc.js":"8kac1","./utils/node.js":"bvQbS","./utils/normalize.js":"k9k7R","./utils/object.js":"9SKe9","./utils/path.js":"hJr1O","./utils/promisebuffer.js":"1vxH2","./utils/severity.js":"bgJKP","./utils/exports.js":"6TQa7","./utils/stacktrace.js":"5srWn","./utils/node-stack-trace.js":"hs5Jm","./utils/string.js":"j38bn","./utils/supports.js":"63xuU","./utils/syncpromise.js":"lxdDX","./utils/time.js":"i4V6H","./utils/tracing.js":"f5SYf","./utils/env.js":"3gTEJ","./utils/envelope.js":"fDBh0","./utils/clientreport.js":"gxGzt","./utils/ratelimit.js":"4EbXl","./utils/baggage.js":"8aTvT","./utils/url.js":"5Wd7K","./utils/eventbuilder.js":"kg8hW","./utils/anr.js":"eErp3","./utils/lru.js":"ad42A","./utils/propagationContext.js":"4NKEi","./utils/vercelWaitUntil.js":"2ra8i","./utils/flushIfServerless.js":"h8O8y","./utils/version.js":"q6Wm7","./utils/debug-ids.js":"luKB1","./vendor/escapeStringForRegex.js":"e5qMa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"e2sL3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "registerSpanErrorInstrumentation", function() {
    return registerSpanErrorInstrumentation;
});
var _debugBuildJs = require("../debug-build.js");
var _globalErrorJs = require("../instrument/globalError.js");
var _globalUnhandledRejectionJs = require("../instrument/globalUnhandledRejection.js");
var _debugLoggerJs = require("../utils/debug-logger.js");
var _spanUtilsJs = require("../utils/spanUtils.js");
var _spanstatusJs = require("./spanstatus.js");
var errorsInstrumented = false;
/**
 * Ensure that global errors automatically set the active span status.
 */ function registerSpanErrorInstrumentation() {
    if (errorsInstrumented) return;
    /**
   * If an error or unhandled promise occurs, we mark the active root span as failed
   */ function errorCallback() {
        var activeSpan = (0, _spanUtilsJs.getActiveSpan)();
        var rootSpan = activeSpan && (0, _spanUtilsJs.getRootSpan)(activeSpan);
        if (rootSpan) {
            var message = 'internal_error';
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log("[Tracing] Root span: ".concat(message, " -> Global error occurred"));
            rootSpan.setStatus({
                code: (0, _spanstatusJs.SPAN_STATUS_ERROR),
                message: message
            });
        }
    }
    // The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
    // node.js default exit behaviour
    errorCallback.tag = 'sentry_tracingErrorCallback';
    errorsInstrumented = true;
    (0, _globalErrorJs.addGlobalErrorInstrumentationHandler)(errorCallback);
    (0, _globalUnhandledRejectionJs.addGlobalUnhandledRejectionInstrumentationHandler)(errorCallback);
}

},{"../debug-build.js":"ejIQP","../instrument/globalError.js":"ao6Fy","../instrument/globalUnhandledRejection.js":"jeqG8","../utils/debug-logger.js":"3X9Vf","../utils/spanUtils.js":"fPRKj","./spanstatus.js":"WiYVV","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ejIQP":[function(require,module,exports,__globalThis) {
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEBUG_BUILD", function() {
    return DEBUG_BUILD;
});
var DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ao6Fy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addGlobalErrorInstrumentationHandler", function() {
    return addGlobalErrorInstrumentationHandler;
});
var _worldwideJs = require("../utils/worldwide.js");
var _handlersJs = require("./handlers.js");
var _oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function addGlobalErrorInstrumentationHandler(handler) {
    var type = 'error';
    (0, _handlersJs.addHandler)(type, handler);
    (0, _handlersJs.maybeInstrument)(type, instrumentError);
}
function instrumentError() {
    _oldOnErrorHandler = (0, _worldwideJs.GLOBAL_OBJ).onerror;
    // Note: The reason we are doing window.onerror instead of window.addEventListener('error')
    // is that we are using this handler in the Loader Script, to handle buffered errors consistently
    (0, _worldwideJs.GLOBAL_OBJ).onerror = function(msg, url, line, column, error) {
        var handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, _handlersJs.triggerHandlers)('error', handlerData);
        if (_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return _oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, _worldwideJs.GLOBAL_OBJ).onerror.__SENTRY_INSTRUMENTED__ = true;
}

},{"../utils/worldwide.js":"3qnNR","./handlers.js":"imb6z","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3qnNR":[function(require,module,exports,__globalThis) {
/** Internal global with common properties and Sentry extensions  */ /** Get's the global object for the current JavaScript runtime */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GLOBAL_OBJ", function() {
    return GLOBAL_OBJ;
});
var GLOBAL_OBJ = globalThis;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"imb6z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addHandler", function() {
    return addHandler;
});
parcelHelpers.export(exports, "maybeInstrument", function() {
    return maybeInstrument;
});
parcelHelpers.export(exports, "resetInstrumentationHandlers", function() {
    return resetInstrumentationHandlers;
});
parcelHelpers.export(exports, "triggerHandlers", function() {
    return triggerHandlers;
});
var _debugBuildJs = require("../debug-build.js");
var _debugLoggerJs = require("../utils/debug-logger.js");
var _stacktraceJs = require("../utils/stacktrace.js");
// We keep the handlers globally
var handlers = {};
var instrumented = {};
/** Add a handler function. */ function addHandler(type, handler) {
    handlers[type] = handlers[type] || [];
    handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function resetInstrumentationHandlers() {
    Object.keys(handlers).forEach(function(key) {
        handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function maybeInstrument(type, instrumentFn) {
    if (!instrumented[type]) {
        instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).error("Error while instrumenting ".concat(type), e);
        }
    }
}
/** Trigger handlers for a given instrumentation type. */ function triggerHandlers(type, data) {
    var typeHandlers = type && handlers[type];
    if (!typeHandlers) return;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = typeHandlers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var handler = _step.value;
            try {
                handler(data);
            } catch (e) {
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).error("Error while triggering instrumentation handler.\nType: ".concat(type, "\nName: ").concat((0, _stacktraceJs.getFunctionName)(handler), "\nError:"), e);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}

},{"../debug-build.js":"ejIQP","../utils/debug-logger.js":"3X9Vf","../utils/stacktrace.js":"5srWn","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3X9Vf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CONSOLE_LEVELS", function() {
    return CONSOLE_LEVELS;
});
parcelHelpers.export(exports, "consoleSandbox", function() {
    return consoleSandbox;
});
parcelHelpers.export(exports, "debug", function() {
    return debug;
});
parcelHelpers.export(exports, "originalConsoleMethods", function() {
    return originalConsoleMethods;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _carrierJs = require("../carrier.js");
var _debugBuildJs = require("../debug-build.js");
var _worldwideJs = require("./worldwide.js");
var CONSOLE_LEVELS = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/** Prefix for logging strings */ var PREFIX = 'Sentry Logger ';
/** This may be mutated by the console instrumentation. */ var originalConsoleMethods = {};
/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function consoleSandbox(callback) {
    if (!('console' in (0, _worldwideJs.GLOBAL_OBJ))) return callback();
    var console = (0, _worldwideJs.GLOBAL_OBJ).console;
    var wrappedFuncs = {};
    var wrappedLevels = Object.keys(originalConsoleMethods);
    // Restore all wrapped console methods
    wrappedLevels.forEach(function(level) {
        var originalConsoleMethod = originalConsoleMethods[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach(function(level) {
            console[level] = wrappedFuncs[level];
        });
    }
}
function enable() {
    _getLoggerSettings().enabled = true;
}
function disable() {
    _getLoggerSettings().enabled = false;
}
function isEnabled() {
    return _getLoggerSettings().enabled;
}
function log() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    _maybeLog.apply(void 0, [
        'log'
    ].concat((0, _toConsumableArray._)(args)));
}
function warn() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    _maybeLog.apply(void 0, [
        'warn'
    ].concat((0, _toConsumableArray._)(args)));
}
function error() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    _maybeLog.apply(void 0, [
        'error'
    ].concat((0, _toConsumableArray._)(args)));
}
function _maybeLog(level) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    if (!(0, _debugBuildJs.DEBUG_BUILD)) return;
    if (isEnabled()) consoleSandbox(function() {
        var _GLOBAL_OBJ_console;
        (_GLOBAL_OBJ_console = (0, _worldwideJs.GLOBAL_OBJ).console)[level].apply(_GLOBAL_OBJ_console, [
            "".concat(PREFIX, "[").concat(level, "]:")
        ].concat((0, _toConsumableArray._)(args)));
    });
}
function _getLoggerSettings() {
    if (!(0, _debugBuildJs.DEBUG_BUILD)) return {
        enabled: false
    };
    return (0, _carrierJs.getGlobalSingleton)('loggerSettings', function() {
        return {
            enabled: false
        };
    });
}
/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 */ var debug = {
    /** Enable logging. */ enable: enable,
    /** Disable logging. */ disable: disable,
    /** Check if logging is enabled. */ isEnabled: isEnabled,
    /** Log a message. */ log: log,
    /** Log a warning. */ warn: warn,
    /** Log an error. */ error: error
};

},{"@swc/helpers/_/_to_consumable_array":"1eSZf","../carrier.js":"abKK3","../debug-build.js":"ejIQP","./worldwide.js":"3qnNR","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"abKK3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getGlobalSingleton", function() {
    return getGlobalSingleton;
});
parcelHelpers.export(exports, "getMainCarrier", function() {
    return getMainCarrier;
});
parcelHelpers.export(exports, "getSentryCarrier", function() {
    return getSentryCarrier;
});
var _versionJs = require("./utils/version.js");
var _worldwideJs = require("./utils/worldwide.js");
/**
 * An object that contains globally accessible properties and maintains a scope stack.
 * @hidden
 */ /**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function getMainCarrier() {
    // This ensures a Sentry carrier exists
    getSentryCarrier((0, _worldwideJs.GLOBAL_OBJ));
    return 0, _worldwideJs.GLOBAL_OBJ;
}
/** Will either get the existing sentry carrier, or create a new one. */ function getSentryCarrier(carrier) {
    var __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    // For now: First SDK that sets the .version property wins
    __SENTRY__.version = __SENTRY__.version || (0, _versionJs.SDK_VERSION);
    // Intentionally populating and returning the version of "this" SDK instance
    // rather than what's set in .version so that "this" SDK always gets its carrier
    return __SENTRY__[0, _versionJs.SDK_VERSION] = __SENTRY__[0, _versionJs.SDK_VERSION] || {};
}
/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function getGlobalSingleton(name, creator) {
    var obj = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, _worldwideJs.GLOBAL_OBJ);
    var __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    var carrier = __SENTRY__[0, _versionJs.SDK_VERSION] = __SENTRY__[0, _versionJs.SDK_VERSION] || {};
    // Note: We do not want to set `carrier.version` here, as this may be called before any `init` is called, e.g. for the default scopes
    return carrier[name] || (carrier[name] = creator());
}

},{"./utils/version.js":"q6Wm7","./utils/worldwide.js":"3qnNR","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"q6Wm7":[function(require,module,exports,__globalThis) {
// This is a magic string replaced by rollup
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SDK_VERSION", function() {
    return SDK_VERSION;
});
var SDK_VERSION = "10.27.0";

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5srWn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UNKNOWN_FUNCTION", function() {
    return UNKNOWN_FUNCTION;
});
parcelHelpers.export(exports, "createStackParser", function() {
    return createStackParser;
});
parcelHelpers.export(exports, "getFramesFromEvent", function() {
    return getFramesFromEvent;
});
parcelHelpers.export(exports, "getFunctionName", function() {
    return getFunctionName;
});
parcelHelpers.export(exports, "getVueInternalName", function() {
    return getVueInternalName;
});
parcelHelpers.export(exports, "stackParserFromStackParserOptions", function() {
    return stackParserFromStackParserOptions;
});
parcelHelpers.export(exports, "stripSentryFramesAndReverse", function() {
    return stripSentryFramesAndReverse;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var STACKTRACE_FRAME_LIMIT = 50;
var UNKNOWN_FUNCTION = '?';
// Used to sanitize webpack (error: *) wrapped stack errors
var WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
var STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function createStackParser() {
    for(var _len = arguments.length, parsers = new Array(_len), _key = 0; _key < _len; _key++){
        parsers[_key] = arguments[_key];
    }
    var sortedParsers = parsers.sort(function(a, b) {
        return a[0] - b[0];
    }).map(function(p) {
        return p[1];
    });
    return function(stack) {
        var skipFirstLines = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, framesToPop = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
        var frames = [];
        var lines = stack.split('\n');
        for(var i = skipFirstLines; i < lines.length; i++){
            var line = lines[i];
            // Truncate lines over 1kb because many of the regular expressions use
            // backtracking which results in run time that increases exponentially
            // with input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) line = line.slice(0, 1024);
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            var cleanedLine = WEBPACK_ERROR_REGEXP.test(line) ? line.replace(WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = sortedParsers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var parser = _step.value;
                    var frame = parser(cleanedLine);
                    if (frame) {
                        frames.push(frame);
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            if (frames.length >= STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return stripSentryFramesAndReverse(frames.slice(framesToPop));
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function stackParserFromStackParserOptions(stackParser) {
    if (Array.isArray(stackParser)) return createStackParser.apply(void 0, (0, _toConsumableArray._)(stackParser));
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function stripSentryFramesAndReverse(stack) {
    if (!stack.length) return [];
    var localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(getLastStackFrame(localStack).function || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (STRIP_FRAME_REGEXP.test(getLastStackFrame(localStack).function || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the scope itself, making it:
        //
        //   Sentry.captureException()
        //   scope.captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if (STRIP_FRAME_REGEXP.test(getLastStackFrame(localStack).function || '')) localStack.pop();
    }
    return localStack.slice(0, STACKTRACE_FRAME_LIMIT).map(function(frame) {
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, frame), {
            filename: frame.filename || getLastStackFrame(localStack).filename,
            function: frame.function || UNKNOWN_FUNCTION
        });
    });
}
function getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
var defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function getFunctionName(fn) {
    try {
        if (!fn || typeof fn !== 'function') return defaultFunctionName;
        return fn.name || defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return defaultFunctionName;
    }
}
/**
 * Get's stack frames from an event without needing to check for undefined properties.
 */ function getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) {
        var frames = [];
        try {
            // @ts-expect-error Object could be undefined
            exception.values.forEach(function(value) {
                var // @ts-expect-error Value could be undefined
                _frames;
                // @ts-expect-error Value could be undefined
                if (value.stacktrace.frames) (_frames = frames).push.apply(_frames, (0, _toConsumableArray._)(value.stacktrace.frames));
            });
            return frames;
        } catch (e) {
            return undefined;
        }
    }
    return undefined;
}
/**
 * Get the internal name of an internal Vue value, to represent it in a stacktrace.
 *
 * @param value The value to get the internal name of.
 */ function getVueInternalName(value) {
    // Check if it's a VNode (has __v_isVNode) or a component instance (has _isVue/__isVue)
    var isVNode = '__v_isVNode' in value && value.__v_isVNode;
    return isVNode ? '[VueVNode]' : '[VueViewModel]';
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_to_consumable_array":"1eSZf","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jeqG8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addGlobalUnhandledRejectionInstrumentationHandler", function() {
    return addGlobalUnhandledRejectionInstrumentationHandler;
});
var _worldwideJs = require("../utils/worldwide.js");
var _handlersJs = require("./handlers.js");
var _oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function addGlobalUnhandledRejectionInstrumentationHandler(handler) {
    var type = 'unhandledrejection';
    (0, _handlersJs.addHandler)(type, handler);
    (0, _handlersJs.maybeInstrument)(type, instrumentUnhandledRejection);
}
function instrumentUnhandledRejection() {
    _oldOnUnhandledRejectionHandler = (0, _worldwideJs.GLOBAL_OBJ).onunhandledrejection;
    // Note: The reason we are doing window.onunhandledrejection instead of window.addEventListener('unhandledrejection')
    // is that we are using this handler in the Loader Script, to handle buffered rejections consistently
    (0, _worldwideJs.GLOBAL_OBJ).onunhandledrejection = function(e) {
        var handlerData = e;
        (0, _handlersJs.triggerHandlers)('unhandledrejection', handlerData);
        if (_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return _oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, _worldwideJs.GLOBAL_OBJ).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}

},{"../utils/worldwide.js":"3qnNR","./handlers.js":"imb6z","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fPRKj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TRACE_FLAG_NONE", function() {
    return TRACE_FLAG_NONE;
});
parcelHelpers.export(exports, "TRACE_FLAG_SAMPLED", function() {
    return TRACE_FLAG_SAMPLED;
});
parcelHelpers.export(exports, "addChildSpanToSpan", function() {
    return addChildSpanToSpan;
});
parcelHelpers.export(exports, "convertSpanLinksForEnvelope", function() {
    return convertSpanLinksForEnvelope;
});
parcelHelpers.export(exports, "getActiveSpan", function() {
    return getActiveSpan;
});
parcelHelpers.export(exports, "getRootSpan", function() {
    return getRootSpan;
});
parcelHelpers.export(exports, "getSpanDescendants", function() {
    return getSpanDescendants;
});
parcelHelpers.export(exports, "getStatusMessage", function() {
    return getStatusMessage;
});
parcelHelpers.export(exports, "removeChildSpanFromSpan", function() {
    return removeChildSpanFromSpan;
});
parcelHelpers.export(exports, "showSpanDropWarning", function() {
    return showSpanDropWarning;
});
parcelHelpers.export(exports, "spanIsSampled", function() {
    return spanIsSampled;
});
parcelHelpers.export(exports, "spanTimeInputToSeconds", function() {
    return spanTimeInputToSeconds;
});
parcelHelpers.export(exports, "spanToJSON", function() {
    return spanToJSON;
});
parcelHelpers.export(exports, "spanToTraceContext", function() {
    return spanToTraceContext;
});
parcelHelpers.export(exports, "spanToTraceHeader", function() {
    return spanToTraceHeader;
});
parcelHelpers.export(exports, "spanToTraceparentHeader", function() {
    return spanToTraceparentHeader;
});
parcelHelpers.export(exports, "spanToTransactionTraceContext", function() {
    return spanToTransactionTraceContext;
});
parcelHelpers.export(exports, "updateSpanName", function() {
    return updateSpanName;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _indexJs = require("../asyncContext/index.js");
var _carrierJs = require("../carrier.js");
var _currentScopesJs = require("../currentScopes.js");
var _semanticAttributesJs = require("../semanticAttributes.js");
var _spanstatusJs = require("../tracing/spanstatus.js");
var _utilsJs = require("../tracing/utils.js");
var _objectJs = require("./object.js");
var _propagationContextJs = require("./propagationContext.js");
var _timeJs = require("./time.js");
var _tracingJs = require("./tracing.js");
var _debugLoggerJs = require("./debug-logger.js");
var _spanOnScopeJs = require("./spanOnScope.js");
// These are aligned with OpenTelemetry trace flags
var TRACE_FLAG_NONE = 0x0;
var TRACE_FLAG_SAMPLED = 0x1;
var hasShownSpanDropWarning = false;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 * By default, this will only include trace_id, span_id & parent_span_id.
 * If `includeAllData` is true, it will also include data, op, status & origin.
 */ function spanToTransactionTraceContext(span) {
    var _span_spanContext = span.spanContext(), span_id = _span_spanContext.spanId, trace_id = _span_spanContext.traceId;
    var _spanToJSON = spanToJSON(span), data = _spanToJSON.data, op = _spanToJSON.op, parent_span_id = _spanToJSON.parent_span_id, status = _spanToJSON.status, origin = _spanToJSON.origin, links = _spanToJSON.links;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in a non-transaction event.
 */ function spanToTraceContext(span) {
    var _span_spanContext = span.spanContext(), spanId = _span_spanContext.spanId, trace_id = _span_spanContext.traceId, isRemote = _span_spanContext.isRemote;
    // If the span is remote, we use a random/virtual span as span_id to the trace context,
    // and the remote span as parent_span_id
    var parent_span_id = isRemote ? spanId : spanToJSON(span).parent_span_id;
    var scope = (0, _utilsJs.getCapturedScopesOnSpan)(span).scope;
    var span_id = isRemote ? (scope === null || scope === void 0 ? void 0 : scope.getPropagationContext().propagationSpanId) || (0, _propagationContextJs.generateSpanId)() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
/**
 * Convert a Span to a Sentry trace header.
 */ function spanToTraceHeader(span) {
    var _span_spanContext = span.spanContext(), traceId = _span_spanContext.traceId, spanId = _span_spanContext.spanId;
    var sampled = spanIsSampled(span);
    return (0, _tracingJs.generateSentryTraceHeader)(traceId, spanId, sampled);
}
/**
 * Convert a Span to a W3C traceparent header.
 */ function spanToTraceparentHeader(span) {
    var _span_spanContext = span.spanContext(), traceId = _span_spanContext.traceId, spanId = _span_spanContext.spanId;
    var sampled = spanIsSampled(span);
    return (0, _tracingJs.generateTraceparentHeader)(traceId, spanId, sampled);
}
/**
 *  Converts the span links array to a flattened version to be sent within an envelope.
 *
 *  If the links array is empty, it returns `undefined` so the empty value can be dropped before it's sent.
 */ function convertSpanLinksForEnvelope(links) {
    if (links && links.length > 0) return links.map(function(_param) {
        var _param_context = _param.context, spanId = _param_context.spanId, traceId = _param_context.traceId, traceFlags = _param_context.traceFlags, attributes = _param.attributes, restContext = (0, _objectWithoutProperties._)(_param.context, [
            "spanId",
            "traceId",
            "traceFlags"
        ]);
        return (0, _objectSpread._)({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === TRACE_FLAG_SAMPLED,
            attributes: attributes
        }, restContext);
    });
    else return undefined;
}
/**
 * Convert a span time input into a timestamp in seconds.
 */ function spanTimeInputToSeconds(input) {
    if (typeof input === 'number') return ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if ((0, _instanceof._)(input, Date)) return ensureTimestampInSeconds(input.getTime());
    return (0, _timeJs.timestampInSeconds)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function ensureTimestampInSeconds(timestamp) {
    var isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 */ // Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
// This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
// And `spanToJSON` needs the Span class from `span.ts` to check here.
function spanToJSON(span) {
    if (spanIsSentrySpan(span)) return span.getSpanJSON();
    var _span_spanContext = span.spanContext(), span_id = _span_spanContext.spanId, trace_id = _span_spanContext.traceId;
    // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
    if (spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        var _span_parentSpanContext;
        var attributes = span.attributes, startTime = span.startTime, name = span.name, endTime = span.endTime, status = span.status, links = span.links;
        // In preparation for the next major of OpenTelemetry, we want to support
        // looking up the parent span id according to the new API
        // In OTel v1, the parent span id is accessed as `parentSpanId`
        // In OTel v2, the parent span id is accessed as `spanId` on the `parentSpanContext`
        var parentSpanId = 'parentSpanId' in span ? span.parentSpanId : 'parentSpanContext' in span ? (_span_parentSpanContext = span.parentSpanContext) === null || _span_parentSpanContext === void 0 ? void 0 : _span_parentSpanContext.spanId : undefined;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: parentSpanId,
            start_timestamp: spanTimeInputToSeconds(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: spanTimeInputToSeconds(endTime) || undefined,
            status: getStatusMessage(status),
            op: attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            origin: attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            links: convertSpanLinksForEnvelope(links)
        };
    }
    // Finally, at least we have `spanContext()`....
    // This should not actually happen in reality, but we need to handle it for type safety.
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
function spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    var castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
/** Exported only for tests. */ /**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === 'function';
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function spanIsSampled(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    var traceFlags = span.spanContext().traceFlags;
    return traceFlags === TRACE_FLAG_SAMPLED;
}
/** Get the status message to use for a JSON representation of a span. */ function getStatusMessage(status) {
    if (!status || status.code === (0, _spanstatusJs.SPAN_STATUS_UNSET)) return undefined;
    if (status.code === (0, _spanstatusJs.SPAN_STATUS_OK)) return 'ok';
    return status.message || 'internal_error';
}
var CHILD_SPANS_FIELD = '_sentryChildSpans';
var ROOT_SPAN_FIELD = '_sentryRootSpan';
/**
 * Adds an opaque child span reference to a span.
 */ function addChildSpanToSpan(span, childSpan) {
    // We store the root span reference on the child span
    // We need this for `getRootSpan()` to work
    var rootSpan = span[ROOT_SPAN_FIELD] || span;
    (0, _objectJs.addNonEnumerableProperty)(childSpan, ROOT_SPAN_FIELD, rootSpan);
    // We store a list of child spans on the parent span
    // We need this for `getSpanDescendants()` to work
    if (span[CHILD_SPANS_FIELD]) span[CHILD_SPANS_FIELD].add(childSpan);
    else (0, _objectJs.addNonEnumerableProperty)(span, CHILD_SPANS_FIELD, new Set([
        childSpan
    ]));
}
/** This is only used internally by Idle Spans. */ function removeChildSpanFromSpan(span, childSpan) {
    if (span[CHILD_SPANS_FIELD]) span[CHILD_SPANS_FIELD].delete(childSpan);
}
/**
 * Returns an array of the given span and all of its descendants.
 */ function getSpanDescendants(span) {
    var resultSet = new Set();
    function addSpanChildren(span) {
        // This exit condition is required to not infinitely loop in case of a circular dependency.
        if (resultSet.has(span)) return;
        else if (spanIsSampled(span)) {
            resultSet.add(span);
            var childSpans = span[CHILD_SPANS_FIELD] ? Array.from(span[CHILD_SPANS_FIELD]) : [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = childSpans[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var childSpan = _step.value;
                    addSpanChildren(childSpan);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
/**
 * Returns the root span of a given span.
 */ function getRootSpan(span) {
    return span[ROOT_SPAN_FIELD] || span;
}
/**
 * Returns the currently active span.
 */ function getActiveSpan() {
    var carrier = (0, _carrierJs.getMainCarrier)();
    var acs = (0, _indexJs.getAsyncContextStrategy)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, _spanOnScopeJs._getSpanForScope)((0, _currentScopesJs.getCurrentScope)());
}
/**
 * Logs a warning once if `beforeSendSpan` is used to drop spans.
 */ function showSpanDropWarning() {
    if (!hasShownSpanDropWarning) {
        (0, _debugLoggerJs.consoleSandbox)(function() {
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly or use `ignoreSpans`.');
        });
        hasShownSpanDropWarning = true;
    }
}
/**
 * Updates the name of the given span and ensures that the span name is not
 * overwritten by the Sentry SDK.
 *
 * Use this function instead of `span.updateName()` if you want to make sure that
 * your name is kept. For some spans, for example root `http.server` spans the
 * Sentry SDK would otherwise overwrite the span name with a high-quality name
 * it infers when the span ends.
 *
 * Use this function in server code or when your span is started on the server
 * and on the client (browser). If you only update a span name on the client,
 * you can also use `span.updateName()` the SDK does not overwrite the name.
 *
 * @param span - The span to update the name of.
 * @param name - The name to set on the span.
 */ function updateSpanName(span, name) {
    span.updateName(name);
    var _obj;
    span.setAttributes((_obj = {}, (0, _defineProperty._)(_obj, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), 'custom'), (0, _defineProperty._)(_obj, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME), name), _obj));
}

},{"@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_without_properties":"6HqIM","../asyncContext/index.js":"8OVZH","../carrier.js":"abKK3","../currentScopes.js":"3GE4v","../semanticAttributes.js":"7WRPE","../tracing/spanstatus.js":"WiYVV","../tracing/utils.js":"1QtCb","./object.js":"9SKe9","./propagationContext.js":"4NKEi","./time.js":"i4V6H","./tracing.js":"f5SYf","./debug-logger.js":"3X9Vf","./spanOnScope.js":"rJBOp","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8OVZH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAsyncContextStrategy", function() {
    return getAsyncContextStrategy;
});
parcelHelpers.export(exports, "setAsyncContextStrategy", function() {
    return setAsyncContextStrategy;
});
var _carrierJs = require("../carrier.js");
var _stackStrategyJs = require("./stackStrategy.js");
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function setAsyncContextStrategy(strategy) {
    // Get main carrier (global for every environment)
    var registry = (0, _carrierJs.getMainCarrier)();
    var sentry = (0, _carrierJs.getSentryCarrier)(registry);
    sentry.acs = strategy;
}
/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */ function getAsyncContextStrategy(carrier) {
    var sentry = (0, _carrierJs.getSentryCarrier)(carrier);
    if (sentry.acs) return sentry.acs;
    // Otherwise, use the default one (stack)
    return (0, _stackStrategyJs.getStackAsyncContextStrategy)();
}

},{"../carrier.js":"abKK3","./stackStrategy.js":"8wUfd","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8wUfd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsyncContextStack", function() {
    return AsyncContextStack;
});
parcelHelpers.export(exports, "getStackAsyncContextStrategy", function() {
    return getStackAsyncContextStrategy;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defaultScopesJs = require("../defaultScopes.js");
var _scopeJs = require("../scope.js");
var _isJs = require("../utils/is.js");
var _carrierJs = require("../carrier.js");
/**
 * This is an object that holds a stack of scopes.
 */ var AsyncContextStack = /*#__PURE__*/ function() {
    "use strict";
    function AsyncContextStack(scope, isolationScope) {
        (0, _classCallCheck._)(this, AsyncContextStack);
        var assignedScope;
        if (!scope) assignedScope = new (0, _scopeJs.Scope)();
        else assignedScope = scope;
        var assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, _scopeJs.Scope)();
        else assignedIsolationScope = isolationScope;
        // scope stack for domains or the process
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    (0, _createClass._)(AsyncContextStack, [
        {
            /**
   * Fork a scope for the stack.
   */ key: "withScope",
            value: function withScope(callback) {
                var _this = this;
                var scope = this._pushScope();
                var maybePromiseResult;
                try {
                    maybePromiseResult = callback(scope);
                } catch (e) {
                    this._popScope();
                    throw e;
                }
                if ((0, _isJs.isThenable)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
                return maybePromiseResult.then(function(res) {
                    _this._popScope();
                    return res;
                }, function(e) {
                    _this._popScope();
                    throw e;
                });
                this._popScope();
                return maybePromiseResult;
            }
        },
        {
            /**
   * Get the client of the stack.
   */ key: "getClient",
            value: function getClient() {
                return this.getStackTop().client;
            }
        },
        {
            /**
   * Returns the scope of the top stack.
   */ key: "getScope",
            value: function getScope() {
                return this.getStackTop().scope;
            }
        },
        {
            /**
   * Get the isolation scope for the stack.
   */ key: "getIsolationScope",
            value: function getIsolationScope() {
                return this._isolationScope;
            }
        },
        {
            /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ key: "getStackTop",
            value: function getStackTop() {
                return this._stack[this._stack.length - 1];
            }
        },
        {
            /**
   * Push a scope to the stack.
   */ key: "_pushScope",
            value: function _pushScope() {
                // We want to clone the content of prev scope
                var scope = this.getScope().clone();
                this._stack.push({
                    client: this.getClient(),
                    scope: scope
                });
                return scope;
            }
        },
        {
            /**
   * Pop a scope from the stack.
   */ key: "_popScope",
            value: function _popScope() {
                if (this._stack.length <= 1) return false;
                return !!this._stack.pop();
            }
        }
    ]);
    return AsyncContextStack;
}();
/**
 * Get the global async context stack.
 * This will be removed during the v8 cycle and is only here to make migration easier.
 */ function getAsyncContextStack() {
    var registry = (0, _carrierJs.getMainCarrier)();
    var sentry = (0, _carrierJs.getSentryCarrier)(registry);
    return sentry.stack = sentry.stack || new AsyncContextStack((0, _defaultScopesJs.getDefaultCurrentScope)(), (0, _defaultScopesJs.getDefaultIsolationScope)());
}
function withScope(callback) {
    return getAsyncContextStack().withScope(callback);
}
function withSetScope(scope, callback) {
    var stack = getAsyncContextStack();
    return stack.withScope(function() {
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function withIsolationScope(callback) {
    return getAsyncContextStack().withScope(function() {
        return callback(getAsyncContextStack().getIsolationScope());
    });
}
/**
 * Get the stack-based async context strategy.
 */ function getStackAsyncContextStrategy() {
    return {
        withIsolationScope: withIsolationScope,
        withScope: withScope,
        withSetScope: withSetScope,
        withSetIsolationScope: function(_isolationScope, callback) {
            return withIsolationScope(callback);
        },
        getCurrentScope: function() {
            return getAsyncContextStack().getScope();
        },
        getIsolationScope: function() {
            return getAsyncContextStack().getIsolationScope();
        }
    };
}

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","../defaultScopes.js":"rVids","../scope.js":"gbShS","../utils/is.js":"kSqSf","../carrier.js":"abKK3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"rVids":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaultCurrentScope", function() {
    return getDefaultCurrentScope;
});
parcelHelpers.export(exports, "getDefaultIsolationScope", function() {
    return getDefaultIsolationScope;
});
var _carrierJs = require("./carrier.js");
var _scopeJs = require("./scope.js");
/** Get the default current scope. */ function getDefaultCurrentScope() {
    return (0, _carrierJs.getGlobalSingleton)('defaultCurrentScope', function() {
        return new (0, _scopeJs.Scope)();
    });
}
/** Get the default isolation scope. */ function getDefaultIsolationScope() {
    return (0, _carrierJs.getGlobalSingleton)('defaultIsolationScope', function() {
        return new (0, _scopeJs.Scope)();
    });
}

},{"./carrier.js":"abKK3","./scope.js":"gbShS","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gbShS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Scope", function() {
    return Scope;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _debugBuildJs = require("./debug-build.js");
var _sessionJs = require("./session.js");
var _debugLoggerJs = require("./utils/debug-logger.js");
var _isJs = require("./utils/is.js");
var _mergeJs = require("./utils/merge.js");
var _miscJs = require("./utils/misc.js");
var _propagationContextJs = require("./utils/propagationContext.js");
var _spanOnScopeJs = require("./utils/spanOnScope.js");
var _stringJs = require("./utils/string.js");
var _timeJs = require("./utils/time.js");
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ var DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * A context to be used for capturing an event.
 * This can either be a Scope, or a partial ScopeContext,
 * or a callback that receives the current scope and returns a new scope to use.
 */ /**
 * Holds additional event information.
 */ var Scope = /*#__PURE__*/ function() {
    "use strict";
    function Scope() {
        (0, _classCallCheck._)(this, Scope);
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: (0, _propagationContextJs.generateTraceId)(),
            sampleRand: Math.random()
        };
    }
    (0, _createClass._)(Scope, [
        {
            /**
   * Clone all data from this scope into a new scope.
   */ key: "clone",
            value: function clone() {
                var newScope = new Scope();
                newScope._breadcrumbs = (0, _toConsumableArray._)(this._breadcrumbs);
                newScope._tags = (0, _objectSpread._)({}, this._tags);
                newScope._attributes = (0, _objectSpread._)({}, this._attributes);
                newScope._extra = (0, _objectSpread._)({}, this._extra);
                newScope._contexts = (0, _objectSpread._)({}, this._contexts);
                if (this._contexts.flags) // We need to copy the `values` array so insertions on a cloned scope
                // won't affect the original array.
                newScope._contexts.flags = {
                    values: (0, _toConsumableArray._)(this._contexts.flags.values)
                };
                newScope._user = this._user;
                newScope._level = this._level;
                newScope._session = this._session;
                newScope._transactionName = this._transactionName;
                newScope._fingerprint = this._fingerprint;
                newScope._eventProcessors = (0, _toConsumableArray._)(this._eventProcessors);
                newScope._attachments = (0, _toConsumableArray._)(this._attachments);
                newScope._sdkProcessingMetadata = (0, _objectSpread._)({}, this._sdkProcessingMetadata);
                newScope._propagationContext = (0, _objectSpread._)({}, this._propagationContext);
                newScope._client = this._client;
                newScope._lastEventId = this._lastEventId;
                (0, _spanOnScopeJs._setSpanForScope)(newScope, (0, _spanOnScopeJs._getSpanForScope)(this));
                return newScope;
            }
        },
        {
            /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ key: "setClient",
            value: function setClient(client) {
                this._client = client;
            }
        },
        {
            /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ key: "setLastEventId",
            value: function setLastEventId(lastEventId) {
                this._lastEventId = lastEventId;
            }
        },
        {
            /**
   * Get the client assigned to this scope.
   */ key: "getClient",
            value: function getClient() {
                return this._client;
            }
        },
        {
            /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ key: "lastEventId",
            value: function lastEventId() {
                return this._lastEventId;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "addScopeListener",
            value: function addScopeListener(callback) {
                this._scopeListeners.push(callback);
            }
        },
        {
            /**
   * Add an event processor that will be called before an event is sent.
   */ key: "addEventProcessor",
            value: function addEventProcessor(callback) {
                this._eventProcessors.push(callback);
                return this;
            }
        },
        {
            /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ key: "setUser",
            value: function setUser(user) {
                // If null is passed we want to unset everything, but still define keys,
                // so that later down in the pipeline any existing values are cleared.
                this._user = user || {
                    email: undefined,
                    id: undefined,
                    ip_address: undefined,
                    username: undefined
                };
                if (this._session) (0, _sessionJs.updateSession)(this._session, {
                    user: user
                });
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Get the user from this scope.
   */ key: "getUser",
            value: function getUser() {
                return this._user;
            }
        },
        {
            /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ key: "setTags",
            value: function setTags(tags) {
                this._tags = (0, _objectSpread._)({}, this._tags, tags);
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Set a single tag that will be sent as tags data with the event.
   */ key: "setTag",
            value: function setTag(key, value) {
                return this.setTags((0, _defineProperty._)({}, key, value));
            }
        },
        {
            /**
   * Sets attributes onto the scope.
   *
   * TODO:
   * Currently, these attributes are not applied to any telemetry data but they will be in the future.
   *
   * @param newAttributes - The attributes to set on the scope. You can either pass in key-value pairs, or
   * an object with a `value` and an optional `unit` (if applicable to your attribute).
   *
   * @example
   * ```typescript
   * scope.setAttributes({
   *   is_admin: true,
   *   payment_selection: 'credit_card',
   *   clicked_products: [130, 554, 292],
   *   render_duration: { value: 'render_duration', unit: 'ms' },
   * });
   * ```
   */ key: "setAttributes",
            value: function setAttributes(newAttributes) {
                this._attributes = (0, _objectSpread._)({}, this._attributes, newAttributes);
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Sets an attribute onto the scope.
   *
   * TODO:
   * Currently, these attributes are not applied to any telemetry data but they will be in the future.
   *
   * @param key - The attribute key.
   * @param value - the attribute value. You can either pass in a raw value, or an attribute
   * object with a `value` and an optional `unit` (if applicable to your attribute).
   *
   * @example
   * ```typescript
   * scope.setAttribute('is_admin', true);
   * scope.setAttribute('clicked_products', [130, 554, 292]);
   * scope.setAttribute('render_duration', { value: 'render_duration', unit: 'ms' });
   * ```
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
            key: "setAttribute",
            value: function setAttribute(key, value) {
                return this.setAttributes((0, _defineProperty._)({}, key, value));
            }
        },
        {
            /**
   * Removes the attribute with the given key from the scope.
   *
   * @param key - The attribute key.
   *
   * @example
   * ```typescript
   * scope.removeAttribute('is_admin');
   * ```
   */ key: "removeAttribute",
            value: function removeAttribute(key) {
                if (key in this._attributes) {
                    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                    delete this._attributes[key];
                    this._notifyScopeListeners();
                }
                return this;
            }
        },
        {
            /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ key: "setExtras",
            value: function setExtras(extras) {
                this._extra = (0, _objectSpread._)({}, this._extra, extras);
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ key: "setExtra",
            value: function setExtra(key, extra) {
                this._extra = (0, _objectSpreadProps._)((0, _objectSpread._)({}, this._extra), (0, _defineProperty._)({}, key, extra));
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ key: "setFingerprint",
            value: function setFingerprint(fingerprint) {
                this._fingerprint = fingerprint;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Sets the level on the scope for future events.
   */ key: "setLevel",
            value: function setLevel(level) {
                this._level = level;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ key: "setTransactionName",
            value: function setTransactionName(name) {
                this._transactionName = name;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ key: "setContext",
            value: function setContext(key, context) {
                if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                delete this._contexts[key];
                else this._contexts[key] = context;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Set the session for the scope.
   */ key: "setSession",
            value: function setSession(session) {
                if (!session) delete this._session;
                else this._session = session;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Get the session from the scope.
   */ key: "getSession",
            value: function getSession() {
                return this._session;
            }
        },
        {
            /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ key: "update",
            value: function update(captureContext) {
                if (!captureContext) return this;
                var scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;
                var scopeInstance = (0, _instanceof._)(scopeToMerge, Scope) ? scopeToMerge.getScopeData() : (0, _isJs.isPlainObject)(scopeToMerge) ? captureContext : undefined;
                var _ref = scopeInstance || {}, tags = _ref.tags, attributes = _ref.attributes, extra = _ref.extra, user = _ref.user, contexts = _ref.contexts, level = _ref.level, _ref_fingerprint = _ref.fingerprint, fingerprint = _ref_fingerprint === void 0 ? [] : _ref_fingerprint, propagationContext = _ref.propagationContext;
                this._tags = (0, _objectSpread._)({}, this._tags, tags);
                this._attributes = (0, _objectSpread._)({}, this._attributes, attributes);
                this._extra = (0, _objectSpread._)({}, this._extra, extra);
                this._contexts = (0, _objectSpread._)({}, this._contexts, contexts);
                if (user && Object.keys(user).length) this._user = user;
                if (level) this._level = level;
                if (fingerprint.length) this._fingerprint = fingerprint;
                if (propagationContext) this._propagationContext = propagationContext;
                return this;
            }
        },
        {
            /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */ key: "clear",
            value: function clear() {
                // client is not cleared here on purpose!
                this._breadcrumbs = [];
                this._tags = {};
                this._attributes = {};
                this._extra = {};
                this._user = {};
                this._contexts = {};
                this._level = undefined;
                this._transactionName = undefined;
                this._fingerprint = undefined;
                this._session = undefined;
                (0, _spanOnScopeJs._setSpanForScope)(this, undefined);
                this._attachments = [];
                this.setPropagationContext({
                    traceId: (0, _propagationContextJs.generateTraceId)(),
                    sampleRand: Math.random()
                });
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ key: "addBreadcrumb",
            value: function addBreadcrumb(breadcrumb, maxBreadcrumbs) {
                var maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : DEFAULT_MAX_BREADCRUMBS;
                // No data has been changed, so don't notify scope listeners
                if (maxCrumbs <= 0) return this;
                var mergedBreadcrumb = (0, _objectSpreadProps._)((0, _objectSpread._)({
                    timestamp: (0, _timeJs.dateTimestampInSeconds)()
                }, breadcrumb), {
                    // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
                    message: breadcrumb.message ? (0, _stringJs.truncate)(breadcrumb.message, 2048) : breadcrumb.message
                });
                this._breadcrumbs.push(mergedBreadcrumb);
                if (this._breadcrumbs.length > maxCrumbs) {
                    var _this__client;
                    this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
                    (_this__client = this._client) === null || _this__client === void 0 ? void 0 : _this__client.recordDroppedEvent('buffer_overflow', 'log_item');
                }
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Get the last breadcrumb of the scope.
   */ key: "getLastBreadcrumb",
            value: function getLastBreadcrumb() {
                return this._breadcrumbs[this._breadcrumbs.length - 1];
            }
        },
        {
            /**
   * Clear all breadcrumbs from the scope.
   */ key: "clearBreadcrumbs",
            value: function clearBreadcrumbs() {
                this._breadcrumbs = [];
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Add an attachment to the scope.
   */ key: "addAttachment",
            value: function addAttachment(attachment) {
                this._attachments.push(attachment);
                return this;
            }
        },
        {
            /**
   * Clear all attachments from the scope.
   */ key: "clearAttachments",
            value: function clearAttachments() {
                this._attachments = [];
                return this;
            }
        },
        {
            /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ key: "getScopeData",
            value: function getScopeData() {
                return {
                    breadcrumbs: this._breadcrumbs,
                    attachments: this._attachments,
                    contexts: this._contexts,
                    tags: this._tags,
                    attributes: this._attributes,
                    extra: this._extra,
                    user: this._user,
                    level: this._level,
                    fingerprint: this._fingerprint || [],
                    eventProcessors: this._eventProcessors,
                    propagationContext: this._propagationContext,
                    sdkProcessingMetadata: this._sdkProcessingMetadata,
                    transactionName: this._transactionName,
                    span: (0, _spanOnScopeJs._getSpanForScope)(this)
                };
            }
        },
        {
            /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ key: "setSDKProcessingMetadata",
            value: function setSDKProcessingMetadata(newData) {
                this._sdkProcessingMetadata = (0, _mergeJs.merge)(this._sdkProcessingMetadata, newData, 2);
                return this;
            }
        },
        {
            /**
   * Add propagation context to the scope, used for distributed tracing
   */ key: "setPropagationContext",
            value: function setPropagationContext(context) {
                this._propagationContext = context;
                return this;
            }
        },
        {
            /**
   * Get propagation context from the scope, used for distributed tracing
   */ key: "getPropagationContext",
            value: function getPropagationContext() {
                return this._propagationContext;
            }
        },
        {
            /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ key: "captureException",
            value: function captureException(exception, hint) {
                var eventId = (hint === null || hint === void 0 ? void 0 : hint.event_id) || (0, _miscJs.uuid4)();
                if (!this._client) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn('No client configured on scope - will not capture exception!');
                    return eventId;
                }
                var syntheticException = new Error('Sentry syntheticException');
                this._client.captureException(exception, (0, _objectSpreadProps._)((0, _objectSpread._)({
                    originalException: exception,
                    syntheticException: syntheticException
                }, hint), {
                    event_id: eventId
                }), this);
                return eventId;
            }
        },
        {
            /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ key: "captureMessage",
            value: function captureMessage(message, level, hint) {
                var eventId = (hint === null || hint === void 0 ? void 0 : hint.event_id) || (0, _miscJs.uuid4)();
                if (!this._client) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn('No client configured on scope - will not capture message!');
                    return eventId;
                }
                var _hint_syntheticException;
                var syntheticException = (_hint_syntheticException = hint === null || hint === void 0 ? void 0 : hint.syntheticException) !== null && _hint_syntheticException !== void 0 ? _hint_syntheticException : new Error(message);
                this._client.captureMessage(message, level, (0, _objectSpreadProps._)((0, _objectSpread._)({
                    originalException: message,
                    syntheticException: syntheticException
                }, hint), {
                    event_id: eventId
                }), this);
                return eventId;
            }
        },
        {
            /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ key: "captureEvent",
            value: function captureEvent(event, hint) {
                var eventId = (hint === null || hint === void 0 ? void 0 : hint.event_id) || (0, _miscJs.uuid4)();
                if (!this._client) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn('No client configured on scope - will not capture event!');
                    return eventId;
                }
                this._client.captureEvent(event, (0, _objectSpreadProps._)((0, _objectSpread._)({}, hint), {
                    event_id: eventId
                }), this);
                return eventId;
            }
        },
        {
            /**
   * This will be called on every set call.
   */ key: "_notifyScopeListeners",
            value: function _notifyScopeListeners() {
                var _this = this;
                // We need this check for this._notifyingListeners to be able to work on scope during updates
                // If this check is not here we'll produce endless recursion when something is done with the scope
                // during the callback.
                if (!this._notifyingListeners) {
                    this._notifyingListeners = true;
                    this._scopeListeners.forEach(function(callback) {
                        callback(_this);
                    });
                    this._notifyingListeners = false;
                }
            }
        }
    ]);
    return Scope;
}();

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_to_consumable_array":"1eSZf","./debug-build.js":"ejIQP","./session.js":"7bmuG","./utils/debug-logger.js":"3X9Vf","./utils/is.js":"kSqSf","./utils/merge.js":"UyyHX","./utils/misc.js":"8kac1","./utils/propagationContext.js":"4NKEi","./utils/spanOnScope.js":"rJBOp","./utils/string.js":"j38bn","./utils/time.js":"i4V6H","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7bmuG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "closeSession", function() {
    return closeSession;
});
parcelHelpers.export(exports, "makeSession", function() {
    return makeSession;
});
parcelHelpers.export(exports, "updateSession", function() {
    return updateSession;
});
var _miscJs = require("./utils/misc.js");
var _timeJs = require("./utils/time.js");
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function makeSession(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    var startingTime = (0, _timeJs.timestampInSeconds)();
    var session = {
        sid: (0, _miscJs.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: function() {
            return sessionToJSON(session);
        }
    };
    if (context) updateSession(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see Client.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function updateSession(session) {
    var context = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, _timeJs.timestampInSeconds)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, _miscJs.uuid4)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = "".concat(context.did);
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        var duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function closeSession(session, status) {
    var context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    updateSession(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function sessionToJSON(session) {
    return {
        sid: "".concat(session.sid),
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? "".concat(session.did) : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}

},{"./utils/misc.js":"8kac1","./utils/time.js":"i4V6H","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8kac1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addContextToFrame", function() {
    return addContextToFrame;
});
parcelHelpers.export(exports, "addExceptionMechanism", function() {
    return addExceptionMechanism;
});
parcelHelpers.export(exports, "addExceptionTypeValue", function() {
    return addExceptionTypeValue;
});
parcelHelpers.export(exports, "checkOrSetAlreadyCaught", function() {
    return checkOrSetAlreadyCaught;
});
parcelHelpers.export(exports, "getEventDescription", function() {
    return getEventDescription;
});
parcelHelpers.export(exports, "parseSemver", function() {
    return parseSemver;
});
parcelHelpers.export(exports, "uuid4", function() {
    return uuid4;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectJs = require("./object.js");
var _stringJs = require("./string.js");
var _worldwideJs = require("./worldwide.js");
function getCrypto() {
    var gbl = (0, _worldwideJs.GLOBAL_OBJ);
    return gbl.crypto || gbl.msCrypto;
}
var emptyUuid;
function getRandomByte() {
    return Math.random() * 16;
}
/**
 * UUID4 generator
 * @param crypto Object that provides the crypto API.
 * @returns string Generated UUID4.
 */ function uuid4() {
    var crypto = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getCrypto();
    try {
        if (crypto === null || crypto === void 0 ? void 0 : crypto.randomUUID) return crypto.randomUUID().replace(/-/g, '');
    } catch (e) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    if (!emptyUuid) // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    emptyUuid = "10000000100040008000100000000000";
    return emptyUuid.replace(/[018]/g, function(c) {
        return(// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
    });
}
function getFirstException(event) {
    var _event_exception_values, _event_exception;
    return (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values[0];
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function getEventDescription(event) {
    var message = event.message, eventId = event.event_id;
    if (message) return message;
    var firstException = getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return "".concat(firstException.type, ": ").concat(firstException.value);
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function addExceptionTypeValue(event, value, type) {
    var exception = event.exception = event.exception || {};
    var values = exception.values = exception.values || [];
    var firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function addExceptionMechanism(event, newMechanism) {
    var firstException = getFirstException(event);
    if (!firstException) return;
    var defaultMechanism = {
        type: 'generic',
        handled: true
    };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = (0, _objectSpread._)({}, defaultMechanism, currentMechanism, newMechanism);
    if (newMechanism && 'data' in newMechanism) {
        var mergedData = (0, _objectSpread._)({}, currentMechanism === null || currentMechanism === void 0 ? void 0 : currentMechanism.data, newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ function _parseInt(input) {
    return parseInt(input || '', 10);
}
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function parseSemver(input) {
    var match = input.match(SEMVER_REGEXP) || [];
    var major = _parseInt(match[1]);
    var minor = _parseInt(match[2]);
    var patch = _parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function addContextToFrame(lines, frame) {
    var linesOfContext = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 5;
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map(function(line) {
        return (0, _stringJs.snipLine)(line, 0);
    });
    // We guard here to ensure this is not larger than the existing number of lines
    var lineIndex = Math.min(maxLines - 1, sourceLine);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    frame.context_line = (0, _stringJs.snipLine)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map(function(line) {
        return (0, _stringJs.snipLine)(line, 0);
    });
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function checkOrSetAlreadyCaught(exception) {
    if (isAlreadyCaptured(exception)) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, _objectJs.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (e) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
function isAlreadyCaptured(exception) {
    try {
        return exception.__sentry_captured__;
    } catch (e) {} // eslint-disable-line no-empty
}

},{"@swc/helpers/_/_object_spread":"9gdrV","./object.js":"9SKe9","./string.js":"j38bn","./worldwide.js":"3qnNR","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9SKe9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addNonEnumerableProperty", function() {
    return addNonEnumerableProperty;
});
parcelHelpers.export(exports, "convertToPlainObject", function() {
    return convertToPlainObject;
});
parcelHelpers.export(exports, "dropUndefinedKeys", function() {
    return dropUndefinedKeys;
});
parcelHelpers.export(exports, "extractExceptionKeysForMessage", function() {
    return extractExceptionKeysForMessage;
});
parcelHelpers.export(exports, "fill", function() {
    return fill;
});
parcelHelpers.export(exports, "getOriginalFunction", function() {
    return getOriginalFunction;
});
parcelHelpers.export(exports, "markFunctionWrapped", function() {
    return markFunctionWrapped;
});
parcelHelpers.export(exports, "objectify", function() {
    return objectify;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _typeOf = require("@swc/helpers/_/_type_of");
var _debugBuildJs = require("../debug-build.js");
var _browserJs = require("./browser.js");
var _debugLoggerJs = require("./debug-logger.js");
var _isJs = require("./is.js");
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Replace a method in an object with a wrapped version of itself.
 *
 * If the method on the passed object is not a function, the wrapper will not be applied.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function fill(source, name, replacementFactory) {
    if (!(name in source)) return;
    // explicitly casting to unknown because we don't know the type of the method initially at all
    var original = source[name];
    if (typeof original !== 'function') return;
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') markFunctionWrapped(wrapped, original);
    try {
        source[name] = wrapped;
    } catch (e) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log('Failed to replace method "'.concat(name, '" in object'), source);
    }
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function addNonEnumerableProperty(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (e) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log('Failed to add non-enumerable property "'.concat(name, '" to object'), obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function markFunctionWrapped(wrapped, original) {
    try {
        var proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        addNonEnumerableProperty(wrapped, '__sentry_original__', original);
    } catch (e) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function getOriginalFunction(func) {
    return func.__sentry_original__;
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argument itself, when value is neither an Event nor
 *  an Error.
 */ function convertToPlainObject(value) {
    if ((0, _isJs.isError)(value)) return (0, _objectSpread._)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, getOwnProperties(value));
    else if ((0, _isJs.isEvent)(value)) {
        var newObj = (0, _objectSpread._)({
            type: value.type,
            target: serializeEventTarget(value.target),
            currentTarget: serializeEventTarget(value.currentTarget)
        }, getOwnProperties(value));
        if (typeof CustomEvent !== 'undefined' && (0, _isJs.isInstanceOf)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function serializeEventTarget(target) {
    try {
        return (0, _isJs.isElement)(target) ? (0, _browserJs.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (e) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function getOwnProperties(obj) {
    if ((typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj)) === 'object' && obj !== null) {
        var extractedProps = {};
        for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function extractExceptionKeysForMessage(exception) {
    var keys = Object.keys(convertToPlainObject(exception));
    keys.sort();
    return !keys[0] ? '[object has no keys]' : keys.join(', ');
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 *
 * @deprecated This function is no longer used by the SDK and will be removed in a future major version.
 */ function dropUndefinedKeys(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    var memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return _dropUndefinedKeys(inputValue, memoizationMap);
}
function _dropUndefinedKeys(inputValue, memoizationMap) {
    // Early return for primitive values
    if (inputValue === null || (typeof inputValue === "undefined" ? "undefined" : (0, _typeOf._)(inputValue)) !== 'object') return inputValue;
    // Check memo map first for all object types
    var memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) return memoVal;
    // handle arrays
    if (Array.isArray(inputValue)) {
        var returnValue = [];
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach(function(value) {
            returnValue.push(_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if (isPojo(inputValue)) {
        var returnValue1 = {};
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue1);
        var keys = Object.keys(inputValue);
        keys.forEach(function(key) {
            var val = inputValue[key];
            if (val !== undefined) returnValue1[key] = _dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue1;
    }
    // For other object types, return as is
    return inputValue;
}
function isPojo(input) {
    // Plain objects have Object as constructor or no constructor
    var constructor = input.constructor;
    return constructor === Object || constructor === undefined;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function objectify(wat) {
    var objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == undefined:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case (typeof wat === "undefined" ? "undefined" : (0, _typeOf._)(wat)) === 'symbol' || (typeof wat === "undefined" ? "undefined" : (0, _typeOf._)(wat)) === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, _isJs.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_type_of":"iFJdx","../debug-build.js":"ejIQP","./browser.js":"fv4f7","./debug-logger.js":"3X9Vf","./is.js":"kSqSf","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fv4f7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getComponentName", function() {
    return getComponentName;
});
parcelHelpers.export(exports, "getLocationHref", function() {
    return getLocationHref;
});
parcelHelpers.export(exports, "htmlTreeAsString", function() {
    return htmlTreeAsString;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
var _isJs = require("./is.js");
var _worldwideJs = require("./worldwide.js");
var WINDOW = (0, _worldwideJs.GLOBAL_OBJ);
var DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function htmlTreeAsString(elem) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!elem) return '<unknown>';
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr;
        var keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        var maxStringLength = !Array.isArray(options) && options.maxStringLength || DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = _htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (e) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function _htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    if (!(elem === null || elem === void 0 ? void 0 : elem.tagName)) return '';
    // @ts-expect-error WINDOW has HTMLElement
    if (WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if ((0, _instanceof._)(elem, HTMLElement) && elem.dataset) {
            if (elem.dataset['sentryComponent']) return elem.dataset['sentryComponent'];
            if (elem.dataset['sentryElement']) return elem.dataset['sentryElement'];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = (keyAttrs === null || keyAttrs === void 0 ? void 0 : keyAttrs.length) ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs === null || keyAttrPairs === void 0 ? void 0 : keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push("[".concat(keyAttrPair[0], '="').concat(keyAttrPair[1], '"]'));
    });
    else {
        if (elem.id) out.push("#".concat(elem.id));
        var className = elem.className;
        if (className && (0, _isJs.isString)(className)) {
            var classes = className.split(/\s+/);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = classes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var c = _step.value;
                    out.push(".".concat(c));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }
    var allowedAttrs = [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ];
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = allowedAttrs[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var k = _step1.value;
            var attr = elem.getAttribute(k);
            if (attr) out.push("[".concat(k, '="').concat(attr, '"]'));
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function getLocationHref() {
    try {
        return WINDOW.document.location.href;
    } catch (e) {
        return '';
    }
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precedence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function getComponentName(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!WINDOW.HTMLElement) return null;
    var currentElem = elem;
    var MAX_TRAVERSE_HEIGHT = 5;
    for(var i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if ((0, _instanceof._)(currentElem, HTMLElement)) {
            if (currentElem.dataset['sentryComponent']) return currentElem.dataset['sentryComponent'];
            if (currentElem.dataset['sentryElement']) return currentElem.dataset['sentryElement'];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}

},{"@swc/helpers/_/_instanceof":"h9UKc","./is.js":"kSqSf","./worldwide.js":"3qnNR","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kSqSf":[function(require,module,exports,__globalThis) {
// eslint-disable-next-line @typescript-eslint/unbound-method
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isDOMError", function() {
    return isDOMError;
});
parcelHelpers.export(exports, "isDOMException", function() {
    return isDOMException;
});
parcelHelpers.export(exports, "isElement", function() {
    return isElement;
});
parcelHelpers.export(exports, "isError", function() {
    return isError;
});
parcelHelpers.export(exports, "isErrorEvent", function() {
    return isErrorEvent;
});
parcelHelpers.export(exports, "isEvent", function() {
    return isEvent;
});
parcelHelpers.export(exports, "isInstanceOf", function() {
    return isInstanceOf;
});
parcelHelpers.export(exports, "isParameterizedString", function() {
    return isParameterizedString;
});
parcelHelpers.export(exports, "isPlainObject", function() {
    return isPlainObject;
});
parcelHelpers.export(exports, "isPrimitive", function() {
    return isPrimitive;
});
parcelHelpers.export(exports, "isRegExp", function() {
    return isRegExp;
});
parcelHelpers.export(exports, "isRequest", function() {
    return isRequest;
});
parcelHelpers.export(exports, "isString", function() {
    return isString;
});
parcelHelpers.export(exports, "isSyntheticEvent", function() {
    return isSyntheticEvent;
});
parcelHelpers.export(exports, "isThenable", function() {
    return isThenable;
});
parcelHelpers.export(exports, "isVueViewModel", function() {
    return isVueViewModel;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
var _typeOf = require("@swc/helpers/_/_type_of");
var objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isError(wat) {
    switch(objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
        case '[object WebAssembly.Exception]':
            return true;
        default:
            return isInstanceOf(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function isBuiltin(wat, className) {
    return objectToString.call(wat) === "[object ".concat(className, "]");
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isErrorEvent(wat) {
    return isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isDOMError(wat) {
    return isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isDOMException(wat) {
    return isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isString(wat) {
    return isBuiltin(wat, 'String');
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isParameterizedString(wat) {
    return (typeof wat === "undefined" ? "undefined" : (0, _typeOf._)(wat)) === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isPrimitive(wat) {
    return wat === null || isParameterizedString(wat) || (typeof wat === "undefined" ? "undefined" : (0, _typeOf._)(wat)) !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isPlainObject(wat) {
    return isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isEvent(wat) {
    return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isElement(wat) {
    return typeof Element !== 'undefined' && isInstanceOf(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isRegExp(wat) {
    return isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function isThenable(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean((wat === null || wat === void 0 ? void 0 : wat.then) && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isSyntheticEvent(wat) {
    return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function isInstanceOf(wat, base) {
    try {
        return (0, _instanceof._)(wat, base);
    } catch (e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel or a VNode.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isVueViewModel(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    // We also need to check for __v_isVNode because Vue 3 component render instances have an internal __v_isVNode property.
    return !!((typeof wat === "undefined" ? "undefined" : (0, _typeOf._)(wat)) === 'object' && wat !== null && (wat.__isVue || wat._isVue || wat.__v_isVNode));
}
/**
 * Checks whether the given parameter is a Standard Web API Request instance.
 *
 * Returns false if Request is not available in the current runtime.
 */ function isRequest(request) {
    return typeof Request !== 'undefined' && isInstanceOf(request, Request);
}

},{"@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_type_of":"iFJdx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"j38bn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isMatchingPattern", function() {
    return isMatchingPattern;
});
parcelHelpers.export(exports, "safeJoin", function() {
    return safeJoin;
});
parcelHelpers.export(exports, "snipLine", function() {
    return snipLine;
});
parcelHelpers.export(exports, "stringMatchesSomePattern", function() {
    return stringMatchesSomePattern;
});
parcelHelpers.export(exports, "truncate", function() {
    return truncate;
});
var _isJs = require("./is.js");
var _stacktraceJs = require("./stacktrace.js");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function truncate(str) {
    var max = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : "".concat(str.slice(0, max), "...");
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function snipLine(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} ".concat(newLine);
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ function safeJoin(input, delimiter) {
    if (!Array.isArray(input)) return '';
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, _isJs.isVueViewModel)(value)) output.push((0, _stacktraceJs.getVueInternalName)(value));
            else output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function isMatchingPattern(value, pattern) {
    var requireExactStringMatch = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (!(0, _isJs.isString)(value)) return false;
    if ((0, _isJs.isRegExp)(pattern)) return pattern.test(value);
    if ((0, _isJs.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function stringMatchesSomePattern(testString) {
    var patterns = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], requireExactStringMatch = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return patterns.some(function(pattern) {
        return isMatchingPattern(testString, pattern, requireExactStringMatch);
    });
}

},{"./is.js":"kSqSf","./stacktrace.js":"5srWn","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"i4V6H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "browserPerformanceTimeOrigin", function() {
    return browserPerformanceTimeOrigin;
});
parcelHelpers.export(exports, "dateTimestampInSeconds", function() {
    return dateTimestampInSeconds;
});
parcelHelpers.export(exports, "timestampInSeconds", function() {
    return timestampInSeconds;
});
var _worldwideJs = require("./worldwide.js");
var ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */ function dateTimestampInSeconds() {
    return Date.now() / ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function createUnixTimestampInSecondsFunc() {
    var performance = (0, _worldwideJs.GLOBAL_OBJ).performance;
    // Some browser and environments don't have a performance or timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    if (!(performance === null || performance === void 0 ? void 0 : performance.now) || !performance.timeOrigin) return dateTimestampInSeconds;
    var timeOrigin = performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return function() {
        return (timeOrigin + performance.now()) / ONE_SECOND_IN_MS;
    };
}
var _cachedTimestampInSeconds;
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ function timestampInSeconds() {
    // We store this in a closure so that we don't have to create a new function every time this is called.
    var func = _cachedTimestampInSeconds !== null && _cachedTimestampInSeconds !== void 0 ? _cachedTimestampInSeconds : _cachedTimestampInSeconds = createUnixTimestampInSecondsFunc();
    return func();
}
/**
 * Cached result of getBrowserTimeOrigin.
 */ var cachedTimeOrigin;
/**
 * Gets the time origin and the mode used to determine it.
 */ function getBrowserTimeOrigin() {
    var _performance_timing;
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0, _worldwideJs.GLOBAL_OBJ).performance;
    if (!(performance === null || performance === void 0 ? void 0 : performance.now)) return [
        undefined,
        'none'
    ];
    var threshold = 3600000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = (_performance_timing = performance.timing) === null || _performance_timing === void 0 ? void 0 : _performance_timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) return [
            performance.timeOrigin,
            'timeOrigin'
        ];
        else return [
            navigationStart,
            'navigationStart'
        ];
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    return [
        dateNow,
        'dateNow'
    ];
}
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ function browserPerformanceTimeOrigin() {
    if (!cachedTimeOrigin) cachedTimeOrigin = getBrowserTimeOrigin();
    return cachedTimeOrigin[0];
}

},{"./worldwide.js":"3qnNR","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"UyyHX":[function(require,module,exports,__globalThis) {
/**
 * Shallow merge two objects.
 * Does not mutate the passed in objects.
 * Undefined/empty values in the merge object will overwrite existing values.
 *
 * By default, this merges 2 levels deep.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "merge", function() {
    return merge;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _typeOf = require("@swc/helpers/_/_type_of");
function merge(initialObj, mergeObj) {
    var levels = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 2;
    // If the merge value is not an object, or we have no merge levels left,
    // we just set the value to the merge value
    if (!mergeObj || (typeof mergeObj === "undefined" ? "undefined" : (0, _typeOf._)(mergeObj)) !== 'object' || levels <= 0) return mergeObj;
    // If the merge object is an empty object, and the initial object is not undefined, we return the initial object
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    // Clone object
    var output = (0, _objectSpread._)({}, initialObj);
    // Merge values into output, resursively
    for(var key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = merge(output[key], mergeObj[key], levels - 1);
    return output;
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_type_of":"iFJdx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4NKEi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateSpanId", function() {
    return generateSpanId;
});
parcelHelpers.export(exports, "generateTraceId", function() {
    return generateTraceId;
});
var _miscJs = require("./misc.js");
/**
 * Generate a random, valid trace ID.
 */ function generateTraceId() {
    return (0, _miscJs.uuid4)();
}
/**
 * Generate a random, valid span ID.
 */ function generateSpanId() {
    return (0, _miscJs.uuid4)().substring(16);
}

},{"./misc.js":"8kac1","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"rJBOp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_getSpanForScope", function() {
    return _getSpanForScope;
});
parcelHelpers.export(exports, "_setSpanForScope", function() {
    return _setSpanForScope;
});
var _objectJs = require("./object.js");
var SCOPE_SPAN_FIELD = '_sentrySpan';
/**
 * Set the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function _setSpanForScope(scope, span) {
    if (span) (0, _objectJs.addNonEnumerableProperty)(scope, SCOPE_SPAN_FIELD, span);
    else // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete scope[SCOPE_SPAN_FIELD];
}
/**
 * Get the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function _getSpanForScope(scope) {
    return scope[SCOPE_SPAN_FIELD];
}

},{"./object.js":"9SKe9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3GE4v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getClient", function() {
    return getClient;
});
parcelHelpers.export(exports, "getCurrentScope", function() {
    return getCurrentScope;
});
parcelHelpers.export(exports, "getGlobalScope", function() {
    return getGlobalScope;
});
parcelHelpers.export(exports, "getIsolationScope", function() {
    return getIsolationScope;
});
parcelHelpers.export(exports, "getTraceContextFromScope", function() {
    return getTraceContextFromScope;
});
parcelHelpers.export(exports, "withIsolationScope", function() {
    return withIsolationScope;
});
parcelHelpers.export(exports, "withScope", function() {
    return withScope;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _indexJs = require("./asyncContext/index.js");
var _carrierJs = require("./carrier.js");
var _scopeJs = require("./scope.js");
var _propagationContextJs = require("./utils/propagationContext.js");
/**
 * Get the currently active scope.
 */ function getCurrentScope() {
    var carrier = (0, _carrierJs.getMainCarrier)();
    var acs = (0, _indexJs.getAsyncContextStrategy)(carrier);
    return acs.getCurrentScope();
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current execution context.
 */ function getIsolationScope() {
    var carrier = (0, _carrierJs.getMainCarrier)();
    var acs = (0, _indexJs.getAsyncContextStrategy)(carrier);
    return acs.getIsolationScope();
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function getGlobalScope() {
    return (0, _carrierJs.getGlobalSingleton)('globalScope', function() {
        return new (0, _scopeJs.Scope)();
    });
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function withScope() {
    for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++){
        rest[_key] = arguments[_key];
    }
    var carrier = (0, _carrierJs.getMainCarrier)();
    var acs = (0, _indexJs.getAsyncContextStrategy)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        var _rest = (0, _slicedToArray._)(rest, 2), scope = _rest[0], callback = _rest[1];
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 */ /**
 * Either creates a new active isolation scope, or sets the given isolation scope as active scope in the given callback.
 */ function withIsolationScope() {
    for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++){
        rest[_key] = arguments[_key];
    }
    var carrier = (0, _carrierJs.getMainCarrier)();
    var acs = (0, _indexJs.getAsyncContextStrategy)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        var _rest = (0, _slicedToArray._)(rest, 2), isolationScope = _rest[0], callback = _rest[1];
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
/**
 * Get the currently active client.
 */ function getClient() {
    return getCurrentScope().getClient();
}
/**
 * Get a trace context for the given scope.
 */ function getTraceContextFromScope(scope) {
    var propagationContext = scope.getPropagationContext();
    var traceId = propagationContext.traceId, parentSpanId = propagationContext.parentSpanId, propagationSpanId = propagationContext.propagationSpanId;
    var traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || (0, _propagationContextJs.generateSpanId)()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","./asyncContext/index.js":"8OVZH","./carrier.js":"abKK3","./scope.js":"gbShS","./utils/propagationContext.js":"4NKEi","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7WRPE":[function(require,module,exports,__globalThis) {
/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_CACHE_HIT", function() {
    return SEMANTIC_ATTRIBUTE_CACHE_HIT;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE", function() {
    return SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_CACHE_KEY", function() {
    return SEMANTIC_ATTRIBUTE_CACHE_KEY;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME", function() {
    return SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD", function() {
    return SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_PROFILE_ID", function() {
    return SEMANTIC_ATTRIBUTE_PROFILE_ID;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME", function() {
    return SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON", function() {
    return SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT", function() {
    return SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE", function() {
    return SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_OP", function() {
    return SEMANTIC_ATTRIBUTE_SENTRY_OP;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN", function() {
    return SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE", function() {
    return SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE", function() {
    return SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE", function() {
    return SEMANTIC_ATTRIBUTE_SENTRY_SOURCE;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_URL_FULL", function() {
    return SEMANTIC_ATTRIBUTE_URL_FULL;
});
parcelHelpers.export(exports, "SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE", function() {
    return SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE;
});
var SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = 'sentry.source';
/**
 * Attributes that holds the sample rate that was locally applied to a span.
 * If this attribute is not defined, it means that the span inherited a sampling decision.
 *
 * NOTE: Is only defined on root spans.
 */ var SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = 'sentry.sample_rate';
/**
 * Attribute holding the sample rate of the previous trace.
 * This is used to sample consistently across subsequent traces in the browser SDK.
 *
 * Note: Only defined on root spans, if opted into consistent sampling
 */ var SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE = 'sentry.previous_trace_sample_rate';
/**
 * Use this attribute to represent the operation of a span.
 */ var SEMANTIC_ATTRIBUTE_SENTRY_OP = 'sentry.op';
/**
 * Use this attribute to represent the origin of a span.
 */ var SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = 'sentry.origin';
/** The reason why an idle span finished. */ var SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON = 'sentry.idle_span_finish_reason';
/** The unit of a measurement, which may be stored as a TimedEvent. */ var SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT = 'sentry.measurement_unit';
/** The value of a measurement, which may be stored as a TimedEvent. */ var SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE = 'sentry.measurement_value';
/**
 * A custom span name set by users guaranteed to be taken over any automatically
 * inferred name. This attribute is removed before the span is sent.
 *
 * @internal only meant for internal SDK usage
 * @hidden
 */ var SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME = 'sentry.custom_span_name';
/**
 * The id of the profile that this span occurred in.
 */ var SEMANTIC_ATTRIBUTE_PROFILE_ID = 'sentry.profile_id';
var SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME = 'sentry.exclusive_time';
var SEMANTIC_ATTRIBUTE_CACHE_HIT = 'cache.hit';
var SEMANTIC_ATTRIBUTE_CACHE_KEY = 'cache.key';
var SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE = 'cache.item_size';
/** TODO: Remove these once we update to latest semantic conventions */ var SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD = 'http.request.method';
var SEMANTIC_ATTRIBUTE_URL_FULL = 'url.full';
/**
 * A span link attribute to mark the link as a special span link.
 *
 * Known values:
 * - `previous_trace`: The span links to the frontend root span of the previous trace.
 * - `next_trace`: The span links to the frontend root span of the next trace. (Not set by the SDK)
 *
 * Other values may be set as appropriate.
 * @see https://develop.sentry.dev/sdk/telemetry/traces/span-links/#link-types
 */ var SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE = 'sentry.link.type';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"WiYVV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SPAN_STATUS_ERROR", function() {
    return SPAN_STATUS_ERROR;
});
parcelHelpers.export(exports, "SPAN_STATUS_OK", function() {
    return SPAN_STATUS_OK;
});
parcelHelpers.export(exports, "SPAN_STATUS_UNSET", function() {
    return SPAN_STATUS_UNSET;
});
parcelHelpers.export(exports, "getSpanStatusFromHttpCode", function() {
    return getSpanStatusFromHttpCode;
});
parcelHelpers.export(exports, "setHttpStatus", function() {
    return setHttpStatus;
});
var SPAN_STATUS_UNSET = 0;
var SPAN_STATUS_OK = 1;
var SPAN_STATUS_ERROR = 2;
/**
 * Converts a HTTP status code into a sentry status with a message.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or internal_error.
 */ // https://develop.sentry.dev/sdk/event-payloads/span/
function getSpanStatusFromHttpCode(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: SPAN_STATUS_OK
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: SPAN_STATUS_ERROR,
                message: 'unauthenticated'
            };
        case 403:
            return {
                code: SPAN_STATUS_ERROR,
                message: 'permission_denied'
            };
        case 404:
            return {
                code: SPAN_STATUS_ERROR,
                message: 'not_found'
            };
        case 409:
            return {
                code: SPAN_STATUS_ERROR,
                message: 'already_exists'
            };
        case 413:
            return {
                code: SPAN_STATUS_ERROR,
                message: 'failed_precondition'
            };
        case 429:
            return {
                code: SPAN_STATUS_ERROR,
                message: 'resource_exhausted'
            };
        case 499:
            return {
                code: SPAN_STATUS_ERROR,
                message: 'cancelled'
            };
        default:
            return {
                code: SPAN_STATUS_ERROR,
                message: 'invalid_argument'
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: SPAN_STATUS_ERROR,
                message: 'unimplemented'
            };
        case 503:
            return {
                code: SPAN_STATUS_ERROR,
                message: 'unavailable'
            };
        case 504:
            return {
                code: SPAN_STATUS_ERROR,
                message: 'deadline_exceeded'
            };
        default:
            return {
                code: SPAN_STATUS_ERROR,
                message: 'internal_error'
            };
    }
    return {
        code: SPAN_STATUS_ERROR,
        message: 'internal_error'
    };
}
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function setHttpStatus(span, httpStatus) {
    span.setAttribute('http.response.status_code', httpStatus);
    var spanStatus = getSpanStatusFromHttpCode(httpStatus);
    if (spanStatus.message !== 'unknown_error') span.setStatus(spanStatus);
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1QtCb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCapturedScopesOnSpan", function() {
    return getCapturedScopesOnSpan;
});
parcelHelpers.export(exports, "setCapturedScopesOnSpan", function() {
    return setCapturedScopesOnSpan;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _objectJs = require("../utils/object.js");
var _worldwideJs = require("../utils/worldwide.js");
var SCOPE_ON_START_SPAN_FIELD = '_sentryScope';
var ISOLATION_SCOPE_ON_START_SPAN_FIELD = '_sentryIsolationScope';
/** Wrap a scope with a WeakRef if available, falling back to a direct scope. */ function wrapScopeWithWeakRef(scope) {
    try {
        // @ts-expect-error - WeakRef is not available in all environments
        var WeakRefClass = (0, _worldwideJs.GLOBAL_OBJ).WeakRef;
        if (typeof WeakRefClass === 'function') return new WeakRefClass(scope);
    } catch (e) {
    // WeakRef not available or failed to create
    // We'll fall back to a direct scope
    }
    return scope;
}
/** Try to unwrap a scope from a potential WeakRef wrapper. */ function unwrapScopeFromWeakRef(scopeRef) {
    if (!scopeRef) return undefined;
    if ((typeof scopeRef === "undefined" ? "undefined" : (0, _typeOf._)(scopeRef)) === 'object' && 'deref' in scopeRef && typeof scopeRef.deref === 'function') try {
        return scopeRef.deref();
    } catch (e) {
        return undefined;
    }
    // Fallback to a direct scope
    return scopeRef;
}
/** Store the scope & isolation scope for a span, which can the be used when it is finished. */ function setCapturedScopesOnSpan(span, scope, isolationScope) {
    if (span) {
        (0, _objectJs.addNonEnumerableProperty)(span, ISOLATION_SCOPE_ON_START_SPAN_FIELD, wrapScopeWithWeakRef(isolationScope));
        // We don't wrap the scope with a WeakRef here because webkit aggressively garbage collects
        // and scopes are not held in memory for long periods of time.
        (0, _objectJs.addNonEnumerableProperty)(span, SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 * If WeakRef was used and scopes have been garbage collected, returns undefined for those scopes.
 */ function getCapturedScopesOnSpan(span) {
    var spanWithScopes = span;
    return {
        scope: spanWithScopes[SCOPE_ON_START_SPAN_FIELD],
        isolationScope: unwrapScopeFromWeakRef(spanWithScopes[ISOLATION_SCOPE_ON_START_SPAN_FIELD])
    };
}

},{"@swc/helpers/_/_type_of":"iFJdx","../utils/object.js":"9SKe9","../utils/worldwide.js":"3qnNR","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"f5SYf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TRACEPARENT_REGEXP", function() {
    return TRACEPARENT_REGEXP;
});
parcelHelpers.export(exports, "extractTraceparentData", function() {
    return extractTraceparentData;
});
parcelHelpers.export(exports, "generateSentryTraceHeader", function() {
    return generateSentryTraceHeader;
});
parcelHelpers.export(exports, "generateTraceparentHeader", function() {
    return generateTraceparentHeader;
});
parcelHelpers.export(exports, "propagationContextFromHeaders", function() {
    return propagationContextFromHeaders;
});
parcelHelpers.export(exports, "shouldContinueTrace", function() {
    return shouldContinueTrace;
});
var _debugLoggerJs = require("./debug-logger.js");
var _baggageJs = require("./baggage.js");
var _dsnJs = require("./dsn.js");
var _parseSampleRateJs = require("./parseSampleRate.js");
var _propagationContextJs = require("./propagationContext.js");
// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
var TRACEPARENT_REGEXP = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * This is terrible naming but the function has nothing to do with the W3C traceparent header.
 * It can only parse the `sentry-trace` header and extract the "trace parent" data.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function extractTraceparentData(traceparent) {
    if (!traceparent) return undefined;
    var matches = traceparent.match(TRACEPARENT_REGEXP);
    if (!matches) return undefined;
    var parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create a propagation context from incoming headers or
 * creates a minimal new one if the headers are undefined.
 */ function propagationContextFromHeaders(sentryTrace, baggage) {
    var traceparentData = extractTraceparentData(sentryTrace);
    var dynamicSamplingContext = (0, _baggageJs.baggageHeaderToDynamicSamplingContext)(baggage);
    if (!(traceparentData === null || traceparentData === void 0 ? void 0 : traceparentData.traceId)) return {
        traceId: (0, _propagationContextJs.generateTraceId)(),
        sampleRand: Math.random()
    };
    var sampleRand = getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    // The sample_rand on the DSC needs to be generated based on traceparent + baggage.
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    var traceId = traceparentData.traceId, parentSpanId = traceparentData.parentSpanId, parentSampled = traceparentData.parentSampled;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: sampleRand
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function generateSentryTraceHeader() {
    var traceId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, _propagationContextJs.generateTraceId)(), spanId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, _propagationContextJs.generateSpanId)(), sampled = arguments.length > 2 ? arguments[2] : void 0;
    var sampledString = '';
    if (sampled !== undefined) sampledString = sampled ? '-1' : '-0';
    return "".concat(traceId, "-").concat(spanId).concat(sampledString);
}
/**
 * Creates a W3C traceparent header from the given trace and span ids.
 */ function generateTraceparentHeader() {
    var traceId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, _propagationContextJs.generateTraceId)(), spanId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, _propagationContextJs.generateSpanId)(), sampled = arguments.length > 2 ? arguments[2] : void 0;
    return "00-".concat(traceId, "-").concat(spanId, "-").concat(sampled ? '01' : '00');
}
/**
 * Given any combination of an incoming trace, generate a sample rand based on its defined semantics.
 *
 * Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
 */ function getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    // When there is an incoming sample rand use it.
    var parsedSampleRand = (0, _parseSampleRateJs.parseSampleRate)(dsc === null || dsc === void 0 ? void 0 : dsc.sample_rand);
    if (parsedSampleRand !== undefined) return parsedSampleRand;
    // Otherwise, if there is an incoming sampling decision + sample rate, generate a sample rand that would lead to the same sampling decision.
    var parsedSampleRate = (0, _parseSampleRateJs.parseSampleRate)(dsc === null || dsc === void 0 ? void 0 : dsc.sample_rate);
    if (parsedSampleRate && (traceparentData === null || traceparentData === void 0 ? void 0 : traceparentData.parentSampled) !== undefined) return traceparentData.parentSampled ? Math.random() * parsedSampleRate : parsedSampleRate + Math.random() * (1 - parsedSampleRate);
    else // If nothing applies, return a random sample rand.
    return Math.random();
}
/**
 * Determines whether a new trace should be continued based on the provided baggage org ID and the client's `strictTraceContinuation` option.
 * If the trace should not be continued, a new trace will be started.
 *
 * The result is dependent on the `strictTraceContinuation` option in the client.
 * See https://develop.sentry.dev/sdk/telemetry/traces/#stricttracecontinuation
 */ function shouldContinueTrace(client, baggageOrgId) {
    var clientOrgId = (0, _dsnJs.extractOrgIdFromClient)(client);
    // Case: baggage orgID and Client orgID don't match - always start new trace
    if (baggageOrgId && clientOrgId && baggageOrgId !== clientOrgId) {
        (0, _debugLoggerJs.debug).log("Won't continue trace because org IDs don't match (incoming baggage: ".concat(baggageOrgId, ", SDK options: ").concat(clientOrgId, ")"));
        return false;
    }
    var strictTraceContinuation = client.getOptions().strictTraceContinuation || false; // default for `strictTraceContinuation` is `false`
    if (strictTraceContinuation) // With strict continuation enabled, don't continue trace if:
    // - Baggage has orgID, but Client doesn't have one
    // - Client has orgID, but baggage doesn't have one
    {
        if (baggageOrgId && !clientOrgId || !baggageOrgId && clientOrgId) {
            (0, _debugLoggerJs.debug).log("Starting a new trace because strict trace continuation is enabled but one org ID is missing (incoming baggage: ".concat(baggageOrgId, ", Sentry client: ").concat(clientOrgId, ")"));
            return false;
        }
    }
    return true;
}

},{"./debug-logger.js":"3X9Vf","./baggage.js":"8aTvT","./dsn.js":"jNv3f","./parseSampleRate.js":"e0bLP","./propagationContext.js":"4NKEi","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8aTvT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MAX_BAGGAGE_STRING_LENGTH", function() {
    return MAX_BAGGAGE_STRING_LENGTH;
});
parcelHelpers.export(exports, "SENTRY_BAGGAGE_KEY_PREFIX", function() {
    return SENTRY_BAGGAGE_KEY_PREFIX;
});
parcelHelpers.export(exports, "SENTRY_BAGGAGE_KEY_PREFIX_REGEX", function() {
    return SENTRY_BAGGAGE_KEY_PREFIX_REGEX;
});
parcelHelpers.export(exports, "baggageHeaderToDynamicSamplingContext", function() {
    return baggageHeaderToDynamicSamplingContext;
});
parcelHelpers.export(exports, "dynamicSamplingContextToSentryBaggageHeader", function() {
    return dynamicSamplingContextToSentryBaggageHeader;
});
parcelHelpers.export(exports, "objectToBaggageHeader", function() {
    return objectToBaggageHeader;
});
parcelHelpers.export(exports, "parseBaggageHeader", function() {
    return parseBaggageHeader;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _debugBuildJs = require("../debug-build.js");
var _debugLoggerJs = require("./debug-logger.js");
var _isJs = require("./is.js");
var SENTRY_BAGGAGE_KEY_PREFIX = 'sentry-';
var SENTRY_BAGGAGE_KEY_PREFIX_REGEX = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ var MAX_BAGGAGE_STRING_LENGTH = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function baggageHeaderToDynamicSamplingContext(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    var baggageObject = parseBaggageHeader(baggageHeader);
    if (!baggageObject) return undefined;
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    var dynamicSamplingContext = Object.entries(baggageObject).reduce(function(acc, param) {
        var _param = (0, _slicedToArray._)(param, 2), key = _param[0], value = _param[1];
        if (key.match(SENTRY_BAGGAGE_KEY_PREFIX_REGEX)) {
            var nonPrefixedKey = key.slice(SENTRY_BAGGAGE_KEY_PREFIX.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function dynamicSamplingContextToSentryBaggageHeader(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    var sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce(function(acc, param) {
        var _param = (0, _slicedToArray._)(param, 2), dscKey = _param[0], dscValue = _param[1];
        if (dscValue) acc["".concat(SENTRY_BAGGAGE_KEY_PREFIX).concat(dscKey)] = dscValue;
        return acc;
    }, {});
    return objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Take a baggage header and parse it into an object.
 */ function parseBaggageHeader(baggageHeader) {
    if (!baggageHeader || !(0, _isJs.isString)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    return baggageHeader.reduce(function(acc, curr) {
        var currBaggageObject = baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(function(param) {
            var _param = (0, _slicedToArray._)(param, 2), key = _param[0], value = _param[1];
            acc[key] = value;
        });
        return acc;
    }, {});
    return baggageHeaderToObject(baggageHeader);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map(function(baggageEntry) {
        var eqIdx = baggageEntry.indexOf('=');
        if (eqIdx === -1) // Likely an invalid entry
        return [];
        var key = baggageEntry.slice(0, eqIdx);
        var value = baggageEntry.slice(eqIdx + 1);
        return [
            key,
            value
        ].map(function(keyOrValue) {
            try {
                return decodeURIComponent(keyOrValue.trim());
            } catch (e) {
                // We ignore errors here, e.g. if the value cannot be URL decoded.
                // This will then be skipped in the next step
                return;
            }
        });
    }).reduce(function(acc, param) {
        var _param = (0, _slicedToArray._)(param, 2), key = _param[0], value = _param[1];
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce(function(baggageHeader, param, currentIndex) {
        var _param = (0, _slicedToArray._)(param, 2), objectKey = _param[0], objectValue = _param[1];
        var baggageEntry = "".concat(encodeURIComponent(objectKey), "=").concat(encodeURIComponent(objectValue));
        var newBaggageHeader = currentIndex === 0 ? baggageEntry : "".concat(baggageHeader, ",").concat(baggageEntry);
        if (newBaggageHeader.length > MAX_BAGGAGE_STRING_LENGTH) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn("Not adding key: ".concat(objectKey, " with val: ").concat(objectValue, " to baggage header due to exceeding baggage size limits."));
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","../debug-build.js":"ejIQP","./debug-logger.js":"3X9Vf","./is.js":"kSqSf","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jNv3f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dsnFromString", function() {
    return dsnFromString;
});
parcelHelpers.export(exports, "dsnToString", function() {
    return dsnToString;
});
parcelHelpers.export(exports, "extractOrgIdFromClient", function() {
    return extractOrgIdFromClient;
});
parcelHelpers.export(exports, "extractOrgIdFromDsnHost", function() {
    return extractOrgIdFromDsnHost;
});
parcelHelpers.export(exports, "makeDsn", function() {
    return makeDsn;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _debugBuildJs = require("../debug-build.js");
var _debugLoggerJs = require("./debug-logger.js");
/** Regular expression used to extract org ID from a DSN host. */ var ORG_ID_REGEX = /^o(\d+)\./;
/** Regular expression used to parse a Dsn. */ var DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function dsnToString(dsn) {
    var withPassword = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var host = dsn.host, path = dsn.path, pass = dsn.pass, port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol, publicKey = dsn.publicKey;
    return "".concat(protocol, "://").concat(publicKey).concat(withPassword && pass ? ":".concat(pass) : '') + "@".concat(host).concat(port ? ":".concat(port) : '', "/").concat(path ? "".concat(path, "/") : path).concat(projectId);
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function dsnFromString(str) {
    var match = DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, _debugLoggerJs.consoleSandbox)(function() {
            // eslint-disable-next-line no-console
            console.error("Invalid Sentry Dsn: ".concat(str));
        });
        return undefined;
    }
    var _match_slice = (0, _slicedToArray._)(match.slice(1), 6), protocol = _match_slice[0], publicKey = _match_slice[1], tmp = _match_slice[2], pass = tmp === void 0 ? '' : tmp, tmp1 = _match_slice[3], host = tmp1 === void 0 ? '' : tmp1, tmp2 = _match_slice[4], port = tmp2 === void 0 ? '' : tmp2, tmp3 = _match_slice[5], lastPath = tmp3 === void 0 ? '' : tmp3;
    var path = '';
    var projectId = lastPath;
    var split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        var projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function validateDsn(dsn) {
    if (!(0, _debugBuildJs.DEBUG_BUILD)) return true;
    var port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol;
    var requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    var hasMissingRequiredComponent = requiredComponents.find(function(component) {
        if (!dsn[component]) {
            (0, _debugLoggerJs.debug).error("Invalid Sentry Dsn: ".concat(component, " missing"));
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, _debugLoggerJs.debug).error("Invalid Sentry Dsn: Invalid projectId ".concat(projectId));
        return false;
    }
    if (!isValidProtocol(protocol)) {
        (0, _debugLoggerJs.debug).error("Invalid Sentry Dsn: Invalid protocol ".concat(protocol));
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, _debugLoggerJs.debug).error("Invalid Sentry Dsn: Invalid port ".concat(port));
        return false;
    }
    return true;
}
/**
 * Extract the org ID from a DSN host.
 *
 * @param host The host from a DSN
 * @returns The org ID if found, undefined otherwise
 */ function extractOrgIdFromDsnHost(host) {
    var match = host.match(ORG_ID_REGEX);
    return match === null || match === void 0 ? void 0 : match[1];
}
/**
 *  Returns the organization ID of the client.
 *
 *  The organization ID is extracted from the DSN. If the client options include a `orgId`, this will always take precedence.
 */ function extractOrgIdFromClient(client) {
    var options = client.getOptions();
    var host = (client.getDsn() || {}).host;
    var org_id;
    if (options.orgId) org_id = String(options.orgId);
    else if (host) org_id = extractOrgIdFromDsnHost(host);
    return org_id;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function makeDsn(from) {
    var components = typeof from === 'string' ? dsnFromString(from) : dsnFromComponents(from);
    if (!components || !validateDsn(components)) return undefined;
    return components;
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","../debug-build.js":"ejIQP","./debug-logger.js":"3X9Vf","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"e0bLP":[function(require,module,exports,__globalThis) {
/**
 * Parse a sample rate from a given value.
 * This will either return a boolean or number sample rate, if the sample rate is valid (between 0 and 1).
 * If a string is passed, we try to convert it to a number.
 *
 * Any invalid sample rate will return `undefined`.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseSampleRate", function() {
    return parseSampleRate;
});
function parseSampleRate(sampleRate) {
    if (typeof sampleRate === 'boolean') return Number(sampleRate);
    var rate = typeof sampleRate === 'string' ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== 'number' || isNaN(rate) || rate < 0 || rate > 1) return undefined;
    return rate;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3nu8c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TRACING_DEFAULTS", function() {
    return TRACING_DEFAULTS;
});
parcelHelpers.export(exports, "startIdleSpan", function() {
    return startIdleSpan;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _toArray = require("@swc/helpers/_/_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _currentScopesJs = require("../currentScopes.js");
var _debugBuildJs = require("../debug-build.js");
var _semanticAttributesJs = require("../semanticAttributes.js");
var _debugLoggerJs = require("../utils/debug-logger.js");
var _hasSpansEnabledJs = require("../utils/hasSpansEnabled.js");
var _shouldIgnoreSpanJs = require("../utils/should-ignore-span.js");
var _spanOnScopeJs = require("../utils/spanOnScope.js");
var _spanUtilsJs = require("../utils/spanUtils.js");
var _timeJs = require("../utils/time.js");
var _dynamicSamplingContextJs = require("./dynamicSamplingContext.js");
var _sentryNonRecordingSpanJs = require("./sentryNonRecordingSpan.js");
var _sentrySpanJs = require("./sentrySpan.js");
var _spanstatusJs = require("./spanstatus.js");
var _traceJs = require("./trace.js");
var TRACING_DEFAULTS = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    childSpanTimeout: 15000
};
var FINISH_REASON_HEARTBEAT_FAILED = 'heartbeatFailed';
var FINISH_REASON_IDLE_TIMEOUT = 'idleTimeout';
var FINISH_REASON_FINAL_TIMEOUT = 'finalTimeout';
var FINISH_REASON_EXTERNAL_FINISH = 'externalFinish';
/**
 * An idle span is a span that automatically finishes. It does this by tracking child spans as activities.
 * An idle span is always the active span.
 */ function startIdleSpan(startSpanOptions) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    // Activities store a list of active spans
    var activities = new Map();
    // We should not use heartbeat if we finished a span
    var _finished = false;
    // Timer that tracks idleTimeout
    var _idleTimeoutID;
    // The reason why the span was finished
    var _finishReason = FINISH_REASON_EXTERNAL_FINISH;
    var _autoFinishAllowed = !options.disableAutoFinish;
    var _cleanupHooks = [];
    var _options_idleTimeout = options.idleTimeout, idleTimeout = _options_idleTimeout === void 0 ? TRACING_DEFAULTS.idleTimeout : _options_idleTimeout, _options_finalTimeout = options.finalTimeout, finalTimeout = _options_finalTimeout === void 0 ? TRACING_DEFAULTS.finalTimeout : _options_finalTimeout, _options_childSpanTimeout = options.childSpanTimeout, childSpanTimeout = _options_childSpanTimeout === void 0 ? TRACING_DEFAULTS.childSpanTimeout : _options_childSpanTimeout, beforeSpanEnd = options.beforeSpanEnd, _options_trimIdleSpanEndTimestamp = options.trimIdleSpanEndTimestamp, trimIdleSpanEndTimestamp = _options_trimIdleSpanEndTimestamp === void 0 ? true : _options_trimIdleSpanEndTimestamp;
    var client = (0, _currentScopesJs.getClient)();
    if (!client || !(0, _hasSpansEnabledJs.hasSpansEnabled)()) {
        var span = new (0, _sentryNonRecordingSpanJs.SentryNonRecordingSpan)();
        var dsc = (0, _objectSpread._)({
            sample_rate: '0',
            sampled: 'false'
        }, (0, _dynamicSamplingContextJs.getDynamicSamplingContextFromSpan)(span));
        (0, _dynamicSamplingContextJs.freezeDscOnSpan)(span, dsc);
        return span;
    }
    var scope = (0, _currentScopesJs.getCurrentScope)();
    var previousActiveSpan = (0, _spanUtilsJs.getActiveSpan)();
    var span1 = _startIdleSpan(startSpanOptions);
    // We patch span.end to ensure we can run some things before the span is ended
    // eslint-disable-next-line @typescript-eslint/unbound-method
    span1.end = new Proxy(span1.end, {
        apply: function apply(target, thisArg, args) {
            if (beforeSpanEnd) beforeSpanEnd(span1);
            // If the span is non-recording, nothing more to do here...
            // This is the case if tracing is enabled but this specific span was not sampled
            if ((0, _instanceof._)(thisArg, (0, _sentryNonRecordingSpanJs.SentryNonRecordingSpan))) return;
            // Just ensuring that this keeps working, even if we ever have more arguments here
            var _args = (0, _toArray._)(args), definedEndTimestamp = _args[0], rest = _args.slice(1);
            var timestamp = definedEndTimestamp || (0, _timeJs.timestampInSeconds)();
            var spanEndTimestamp = (0, _spanUtilsJs.spanTimeInputToSeconds)(timestamp);
            // Ensure we end with the last span timestamp, if possible
            var spans = (0, _spanUtilsJs.getSpanDescendants)(span1).filter(function(child) {
                return child !== span1;
            });
            var spanJson = (0, _spanUtilsJs.spanToJSON)(span1);
            // If we have no spans, we just end, nothing else to do here
            // Likewise, if users explicitly ended the span, we simply end the span without timestamp adjustment
            if (!spans.length || !trimIdleSpanEndTimestamp) {
                onIdleSpanEnded(spanEndTimestamp);
                return Reflect.apply(target, thisArg, [
                    spanEndTimestamp
                ].concat((0, _toConsumableArray._)(rest)));
            }
            var ignoreSpans = client.getOptions().ignoreSpans;
            var latestSpanEndTimestamp = spans === null || spans === void 0 ? void 0 : spans.reduce(function(acc, current) {
                var currentSpanJson = (0, _spanUtilsJs.spanToJSON)(current);
                if (!currentSpanJson.timestamp) return acc;
                // Ignored spans will get dropped later (in the client) but since we already adjust
                // the idle span end timestamp here, we can already take to-be-ignored spans out of
                // the calculation here.
                if (ignoreSpans && (0, _shouldIgnoreSpanJs.shouldIgnoreSpan)(currentSpanJson, ignoreSpans)) return acc;
                return acc ? Math.max(acc, currentSpanJson.timestamp) : currentSpanJson.timestamp;
            }, undefined);
            // In reality this should always exist here, but type-wise it may be undefined...
            var spanStartTimestamp = spanJson.start_timestamp;
            // The final endTimestamp should:
            // * Never be before the span start timestamp
            // * Be the latestSpanEndTimestamp, if there is one, and it is smaller than the passed span end timestamp
            // * Otherwise be the passed end timestamp
            // Final timestamp can never be after finalTimeout
            var endTimestamp = Math.min(spanStartTimestamp ? spanStartTimestamp + finalTimeout / 1000 : Infinity, Math.max(spanStartTimestamp || -Infinity, Math.min(spanEndTimestamp, latestSpanEndTimestamp || Infinity)));
            onIdleSpanEnded(endTimestamp);
            return Reflect.apply(target, thisArg, [
                endTimestamp
            ].concat((0, _toConsumableArray._)(rest)));
        }
    });
    /**
   * Cancels the existing idle timeout, if there is one.
   */ function _cancelIdleTimeout() {
        if (_idleTimeoutID) {
            clearTimeout(_idleTimeoutID);
            _idleTimeoutID = undefined;
        }
    }
    /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ function _restartIdleTimeout(endTimestamp) {
        _cancelIdleTimeout();
        _idleTimeoutID = setTimeout(function() {
            if (!_finished && activities.size === 0 && _autoFinishAllowed) {
                _finishReason = FINISH_REASON_IDLE_TIMEOUT;
                span1.end(endTimestamp);
            }
        }, idleTimeout);
    }
    /**
   * Restarts child span timeout, if there is none running it will start one.
   */ function _restartChildSpanTimeout(endTimestamp) {
        _idleTimeoutID = setTimeout(function() {
            if (!_finished && _autoFinishAllowed) {
                _finishReason = FINISH_REASON_HEARTBEAT_FAILED;
                span1.end(endTimestamp);
            }
        }, childSpanTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ function _pushActivity(spanId) {
        _cancelIdleTimeout();
        activities.set(spanId, true);
        var endTimestamp = (0, _timeJs.timestampInSeconds)();
        // We need to add the timeout here to have the real endtimestamp of the idle span
        // Remember timestampInSeconds is in seconds, timeout is in ms
        _restartChildSpanTimeout(endTimestamp + childSpanTimeout / 1000);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ function _popActivity(spanId) {
        if (activities.has(spanId)) activities.delete(spanId);
        if (activities.size === 0) {
            var endTimestamp = (0, _timeJs.timestampInSeconds)();
            // We need to add the timeout here to have the real endtimestamp of the idle span
            // Remember timestampInSeconds is in seconds, timeout is in ms
            _restartIdleTimeout(endTimestamp + idleTimeout / 1000);
        }
    }
    function onIdleSpanEnded(endTimestamp) {
        _finished = true;
        activities.clear();
        _cleanupHooks.forEach(function(cleanup) {
            return cleanup();
        });
        (0, _spanOnScopeJs._setSpanForScope)(scope, previousActiveSpan);
        var spanJSON = (0, _spanUtilsJs.spanToJSON)(span1);
        var startTimestamp = spanJSON.start_timestamp;
        // This should never happen, but to make TS happy...
        if (!startTimestamp) return;
        var attributes = spanJSON.data;
        if (!attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON]) span1.setAttribute((0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON), _finishReason);
        // Set span status to 'ok' if it hasn't been explicitly set to an error status
        var currentStatus = spanJSON.status;
        if (!currentStatus || currentStatus === 'unknown') span1.setStatus({
            code: (0, _spanstatusJs.SPAN_STATUS_OK)
        });
        (0, _debugLoggerJs.debug).log('[Tracing] Idle span "'.concat(spanJSON.op, '" finished'));
        var childSpans = (0, _spanUtilsJs.getSpanDescendants)(span1).filter(function(child) {
            return child !== span1;
        });
        var discardedSpans = 0;
        childSpans.forEach(function(childSpan) {
            // We cancel all pending spans with status "cancelled" to indicate the idle span was finished early
            if (childSpan.isRecording()) {
                childSpan.setStatus({
                    code: (0, _spanstatusJs.SPAN_STATUS_ERROR),
                    message: 'cancelled'
                });
                childSpan.end(endTimestamp);
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log('[Tracing] Cancelling span since span ended early', JSON.stringify(childSpan, undefined, 2));
            }
            var childSpanJSON = (0, _spanUtilsJs.spanToJSON)(childSpan);
            var tmp = childSpanJSON.timestamp, childEndTimestamp = tmp === void 0 ? 0 : tmp, tmp1 = childSpanJSON.start_timestamp, childStartTimestamp = tmp1 === void 0 ? 0 : tmp1;
            var spanStartedBeforeIdleSpanEnd = childStartTimestamp <= endTimestamp;
            // Add a delta with idle timeout so that we prevent false positives
            var timeoutWithMarginOfError = (finalTimeout + idleTimeout) / 1000;
            var spanEndedBeforeFinalTimeout = childEndTimestamp - childStartTimestamp <= timeoutWithMarginOfError;
            if (0, _debugBuildJs.DEBUG_BUILD) {
                var stringifiedSpan = JSON.stringify(childSpan, undefined, 2);
                if (!spanStartedBeforeIdleSpanEnd) (0, _debugLoggerJs.debug).log('[Tracing] Discarding span since it happened after idle span was finished', stringifiedSpan);
                else if (!spanEndedBeforeFinalTimeout) (0, _debugLoggerJs.debug).log('[Tracing] Discarding span since it finished after idle span final timeout', stringifiedSpan);
            }
            if (!spanEndedBeforeFinalTimeout || !spanStartedBeforeIdleSpanEnd) {
                (0, _spanUtilsJs.removeChildSpanFromSpan)(span1, childSpan);
                discardedSpans++;
            }
        });
        if (discardedSpans > 0) span1.setAttribute('sentry.idle_span_discarded_spans', discardedSpans);
    }
    _cleanupHooks.push(client.on('spanStart', function(startedSpan) {
        // If we already finished the idle span,
        // or if this is the idle span itself being started,
        // or if the started span has already been closed,
        // we don't care about it for activity
        if (_finished || startedSpan === span1 || !!(0, _spanUtilsJs.spanToJSON)(startedSpan).timestamp || (0, _instanceof._)(startedSpan, (0, _sentrySpanJs.SentrySpan)) && startedSpan.isStandaloneSpan()) return;
        var allSpans = (0, _spanUtilsJs.getSpanDescendants)(span1);
        // If the span that was just started is a child of the idle span, we should track it
        if (allSpans.includes(startedSpan)) _pushActivity(startedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on('spanEnd', function(endedSpan) {
        if (_finished) return;
        _popActivity(endedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on('idleSpanEnableAutoFinish', function(spanToAllowAutoFinish) {
        if (spanToAllowAutoFinish === span1) {
            _autoFinishAllowed = true;
            _restartIdleTimeout();
            if (activities.size) _restartChildSpanTimeout();
        }
    }));
    // We only start the initial idle timeout if we are not delaying the auto finish
    if (!options.disableAutoFinish) _restartIdleTimeout();
    setTimeout(function() {
        if (!_finished) {
            span1.setStatus({
                code: (0, _spanstatusJs.SPAN_STATUS_ERROR),
                message: 'deadline_exceeded'
            });
            _finishReason = FINISH_REASON_FINAL_TIMEOUT;
            span1.end();
        }
    }, finalTimeout);
    return span1;
}
function _startIdleSpan(options) {
    var span = (0, _traceJs.startInactiveSpan)(options);
    (0, _spanOnScopeJs._setSpanForScope)((0, _currentScopesJs.getCurrentScope)(), span);
    (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log('[Tracing] Started span is an idle span');
    return span;
}

},{"@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_to_array":"auK39","@swc/helpers/_/_to_consumable_array":"1eSZf","../currentScopes.js":"3GE4v","../debug-build.js":"ejIQP","../semanticAttributes.js":"7WRPE","../utils/debug-logger.js":"3X9Vf","../utils/hasSpansEnabled.js":"klZEt","../utils/should-ignore-span.js":"kyChD","../utils/spanOnScope.js":"rJBOp","../utils/spanUtils.js":"fPRKj","../utils/time.js":"i4V6H","./dynamicSamplingContext.js":"5RiCd","./sentryNonRecordingSpan.js":"j8tB0","./sentrySpan.js":"aWoC1","./spanstatus.js":"WiYVV","./trace.js":"eu0PU","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"klZEt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasSpansEnabled", function() {
    return hasSpansEnabled;
});
var _currentScopesJs = require("../currentScopes.js");
// Treeshakable guard to remove all code related to tracing
/**
 * Determines if span recording is currently enabled.
 *
 * Spans are recorded when at least one of `tracesSampleRate` and `tracesSampler`
 * is defined in the SDK config. This function does not make any assumption about
 * sampling decisions, it only checks if the SDK is configured to record spans.
 *
 * Important: This function only determines if span recording is enabled. Trace
 * continuation and propagation is separately controlled and not covered by this function.
 * If this function returns `false`, traces can still be propagated (which is what
 * we refer to by "Tracing without Performance")
 * @see https://develop.sentry.dev/sdk/telemetry/traces/tracing-without-performance/
 *
 * @param maybeOptions An SDK options object to be passed to this function.
 * If this option is not provided, the function will use the current client's options.
 */ function hasSpansEnabled(maybeOptions) {
    var _getClient;
    if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) return false;
    var options = maybeOptions || ((_getClient = (0, _currentScopesJs.getClient)()) === null || _getClient === void 0 ? void 0 : _getClient.getOptions());
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}

},{"../currentScopes.js":"3GE4v","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kyChD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reparentChildSpans", function() {
    return reparentChildSpans;
});
parcelHelpers.export(exports, "shouldIgnoreSpan", function() {
    return shouldIgnoreSpan;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
var _debugBuildJs = require("../debug-build.js");
var _debugLoggerJs = require("./debug-logger.js");
var _stringJs = require("./string.js");
function logIgnoredSpan(droppedSpan) {
    (0, _debugLoggerJs.debug).log("Ignoring span ".concat(droppedSpan.op, " - ").concat(droppedSpan.description, " because it matches `ignoreSpans`."));
}
/**
 * Check if a span should be ignored based on the ignoreSpans configuration.
 */ function shouldIgnoreSpan(span, ignoreSpans) {
    if (!(ignoreSpans === null || ignoreSpans === void 0 ? void 0 : ignoreSpans.length) || !span.description) return false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = ignoreSpans[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var pattern = _step.value;
            if (isStringOrRegExp(pattern)) {
                if ((0, _stringJs.isMatchingPattern)(span.description, pattern)) {
                    (0, _debugBuildJs.DEBUG_BUILD) && logIgnoredSpan(span);
                    return true;
                }
                continue;
            }
            if (!pattern.name && !pattern.op) continue;
            var nameMatches = pattern.name ? (0, _stringJs.isMatchingPattern)(span.description, pattern.name) : true;
            var opMatches = pattern.op ? span.op && (0, _stringJs.isMatchingPattern)(span.op, pattern.op) : true;
            // This check here is only correct because we can guarantee that we ran `isMatchingPattern`
            // for at least one of `nameMatches` and `opMatches`. So in contrary to how this looks,
            // not both op and name actually have to match. This is the most efficient way to check
            // for all combinations of name and op patterns.
            if (nameMatches && opMatches) {
                (0, _debugBuildJs.DEBUG_BUILD) && logIgnoredSpan(span);
                return true;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
/**
 * Takes a list of spans, and a span that was dropped, and re-parents the child spans of the dropped span to the parent of the dropped span, if possible.
 * This mutates the spans array in place!
 */ function reparentChildSpans(spans, dropSpan) {
    var droppedSpanParentId = dropSpan.parent_span_id;
    var droppedSpanId = dropSpan.span_id;
    // This should generally not happen, as we do not apply this on root spans
    // but to be safe, we just bail in this case
    if (!droppedSpanParentId) return;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = spans[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var span = _step.value;
            if (span.parent_span_id === droppedSpanId) span.parent_span_id = droppedSpanParentId;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function isStringOrRegExp(value) {
    return typeof value === 'string' || (0, _instanceof._)(value, RegExp);
}

},{"@swc/helpers/_/_instanceof":"h9UKc","../debug-build.js":"ejIQP","./debug-logger.js":"3X9Vf","./string.js":"j38bn","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5RiCd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "freezeDscOnSpan", function() {
    return freezeDscOnSpan;
});
parcelHelpers.export(exports, "getDynamicSamplingContextFromClient", function() {
    return getDynamicSamplingContextFromClient;
});
parcelHelpers.export(exports, "getDynamicSamplingContextFromScope", function() {
    return getDynamicSamplingContextFromScope;
});
parcelHelpers.export(exports, "getDynamicSamplingContextFromSpan", function() {
    return getDynamicSamplingContextFromSpan;
});
parcelHelpers.export(exports, "spanToBaggageHeader", function() {
    return spanToBaggageHeader;
});
var _constantsJs = require("../constants.js");
var _currentScopesJs = require("../currentScopes.js");
var _semanticAttributesJs = require("../semanticAttributes.js");
var _baggageJs = require("../utils/baggage.js");
var _dsnJs = require("../utils/dsn.js");
var _hasSpansEnabledJs = require("../utils/hasSpansEnabled.js");
var _objectJs = require("../utils/object.js");
var _spanUtilsJs = require("../utils/spanUtils.js");
var _utilsJs = require("./utils.js");
/**
 * If you change this value, also update the terser plugin config to
 * avoid minification of the object property!
 */ var FROZEN_DSC_FIELD = '_frozenDsc';
/**
 * Freeze the given DSC on the given span.
 */ function freezeDscOnSpan(span, dsc) {
    var spanWithMaybeDsc = span;
    (0, _objectJs.addNonEnumerableProperty)(spanWithMaybeDsc, FROZEN_DSC_FIELD, dsc);
}
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function getDynamicSamplingContextFromClient(trace_id, client) {
    var options = client.getOptions();
    var _ref = client.getDsn() || {}, public_key = _ref.publicKey;
    // Instead of conditionally adding non-undefined values, we add them and then remove them if needed
    // otherwise, the order of baggage entries changes, which "breaks" a bunch of tests etc.
    var dsc = {
        environment: options.environment || (0, _constantsJs.DEFAULT_ENVIRONMENT),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id,
        org_id: (0, _dsnJs.extractOrgIdFromClient)(client)
    };
    client.emit('createDsc', dsc);
    return dsc;
}
/**
 * Get the dynamic sampling context for the currently active scopes.
 */ function getDynamicSamplingContextFromScope(client, scope) {
    var propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || getDynamicSamplingContextFromClient(propagationContext.traceId, client);
}
/**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function getDynamicSamplingContextFromSpan(span) {
    var client = (0, _currentScopesJs.getClient)();
    if (!client) return {};
    var rootSpan = (0, _spanUtilsJs.getRootSpan)(span);
    var rootSpanJson = (0, _spanUtilsJs.spanToJSON)(rootSpan);
    var rootSpanAttributes = rootSpanJson.data;
    var traceState = rootSpan.spanContext().traceState;
    var _traceState_get, _ref;
    // The span sample rate that was locally applied to the root span should also always be applied to the DSC, even if the DSC is frozen.
    // This is so that the downstream traces/services can use parentSampleRate in their `tracesSampler` to make consistent sampling decisions across the entire trace.
    var rootSpanSampleRate = (_ref = (_traceState_get = traceState === null || traceState === void 0 ? void 0 : traceState.get('sentry.sample_rate')) !== null && _traceState_get !== void 0 ? _traceState_get : rootSpanAttributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE]) !== null && _ref !== void 0 ? _ref : rootSpanAttributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE];
    function applyLocalSampleRateToDsc(dsc) {
        if (typeof rootSpanSampleRate === 'number' || typeof rootSpanSampleRate === 'string') dsc.sample_rate = "".concat(rootSpanSampleRate);
        return dsc;
    }
    // For core implementation, we freeze the DSC onto the span as a non-enumerable property
    var frozenDsc = rootSpan[FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    // For OpenTelemetry, we freeze the DSC on the trace state
    var traceStateDsc = traceState === null || traceState === void 0 ? void 0 : traceState.get('sentry.dsc');
    // If the span has a DSC, we want it to take precedence
    var dscOnTraceState = traceStateDsc && (0, _baggageJs.baggageHeaderToDynamicSamplingContext)(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    // Else, we generate it from the span
    var dsc = getDynamicSamplingContextFromClient(span.spanContext().traceId, client);
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    var source = rootSpanAttributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // after JSON conversion, txn.name becomes jsonSpan.description
    var name = rootSpanJson.description;
    if (source !== 'url' && name) dsc.transaction = name;
    // How can we even land here with hasSpansEnabled() returning false?
    // Otel creates a Non-recording span in Tracing Without Performance mode when handling incoming requests
    // So we end up with an active span that is not sampled (neither positively nor negatively)
    if ((0, _hasSpansEnabledJs.hasSpansEnabled)()) {
        var // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        _getCapturedScopesOnSpan_scope;
        dsc.sampled = String((0, _spanUtilsJs.spanIsSampled)(rootSpan));
        var // In OTEL we store the sample rand on the trace state because we cannot access scopes for NonRecordingSpans
        // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        _traceState_get1;
        dsc.sample_rand = (_traceState_get1 = traceState === null || traceState === void 0 ? void 0 : traceState.get('sentry.sample_rand')) !== null && _traceState_get1 !== void 0 ? _traceState_get1 : (_getCapturedScopesOnSpan_scope = (0, _utilsJs.getCapturedScopesOnSpan)(rootSpan).scope) === null || _getCapturedScopesOnSpan_scope === void 0 ? void 0 : _getCapturedScopesOnSpan_scope.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit('createDsc', dsc, rootSpan);
    return dsc;
}
/**
 * Convert a Span to a baggage header.
 */ function spanToBaggageHeader(span) {
    var dsc = getDynamicSamplingContextFromSpan(span);
    return (0, _baggageJs.dynamicSamplingContextToSentryBaggageHeader)(dsc);
}

},{"../constants.js":"7XllJ","../currentScopes.js":"3GE4v","../semanticAttributes.js":"7WRPE","../utils/baggage.js":"8aTvT","../utils/dsn.js":"jNv3f","../utils/hasSpansEnabled.js":"klZEt","../utils/object.js":"9SKe9","../utils/spanUtils.js":"fPRKj","./utils.js":"1QtCb","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7XllJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_ENVIRONMENT", function() {
    return DEFAULT_ENVIRONMENT;
});
var DEFAULT_ENVIRONMENT = 'production';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"j8tB0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SentryNonRecordingSpan", function() {
    return SentryNonRecordingSpan;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _propagationContextJs = require("../utils/propagationContext.js");
var _spanUtilsJs = require("../utils/spanUtils.js");
/**
 * A Sentry Span that is non-recording, meaning it will not be sent to Sentry.
 */ var SentryNonRecordingSpan = /*#__PURE__*/ function() {
    "use strict";
    function SentryNonRecordingSpan() {
        var spanContext = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, _classCallCheck._)(this, SentryNonRecordingSpan);
        this._traceId = spanContext.traceId || (0, _propagationContextJs.generateTraceId)();
        this._spanId = spanContext.spanId || (0, _propagationContextJs.generateSpanId)();
    }
    (0, _createClass._)(SentryNonRecordingSpan, [
        {
            /** @inheritdoc */ key: "spanContext",
            value: function spanContext() {
                return {
                    spanId: this._spanId,
                    traceId: this._traceId,
                    traceFlags: (0, _spanUtilsJs.TRACE_FLAG_NONE)
                };
            }
        },
        {
            /** @inheritdoc */ key: "end",
            value: function end(_timestamp) {}
        },
        {
            /** @inheritdoc */ key: "setAttribute",
            value: function setAttribute(_key, _value) {
                return this;
            }
        },
        {
            /** @inheritdoc */ key: "setAttributes",
            value: function setAttributes(_values) {
                return this;
            }
        },
        {
            /** @inheritdoc */ key: "setStatus",
            value: function setStatus(_status) {
                return this;
            }
        },
        {
            /** @inheritdoc */ key: "updateName",
            value: function updateName(_name) {
                return this;
            }
        },
        {
            /** @inheritdoc */ key: "isRecording",
            value: function isRecording() {
                return false;
            }
        },
        {
            /** @inheritdoc */ key: "addEvent",
            value: function addEvent(_name, _attributesOrStartTime, _startTime) {
                return this;
            }
        },
        {
            /** @inheritDoc */ key: "addLink",
            value: function addLink(_link) {
                return this;
            }
        },
        {
            /** @inheritDoc */ key: "addLinks",
            value: function addLinks(_links) {
                return this;
            }
        },
        {
            /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ key: "recordException",
            value: function recordException(_exception, _time) {
            // noop
            }
        }
    ]);
    return SentryNonRecordingSpan;
}();

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","../utils/propagationContext.js":"4NKEi","../utils/spanUtils.js":"fPRKj","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aWoC1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SentrySpan", function() {
    return SentrySpan;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _currentScopesJs = require("../currentScopes.js");
var _debugBuildJs = require("../debug-build.js");
var _envelopeJs = require("../envelope.js");
var _semanticAttributesJs = require("../semanticAttributes.js");
var _debugLoggerJs = require("../utils/debug-logger.js");
var _propagationContextJs = require("../utils/propagationContext.js");
var _spanUtilsJs = require("../utils/spanUtils.js");
var _timeJs = require("../utils/time.js");
var _dynamicSamplingContextJs = require("./dynamicSamplingContext.js");
var _logSpansJs = require("./logSpans.js");
var _measurementJs = require("./measurement.js");
var _utilsJs = require("./utils.js");
var MAX_SPAN_COUNT = 1000;
/**
 * Span contains all data about a span
 */ var SentrySpan = /*#__PURE__*/ function() {
    "use strict";
    function SentrySpan() {
        var spanContext = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, _classCallCheck._)(this, SentrySpan);
        this._traceId = spanContext.traceId || (0, _propagationContextJs.generateTraceId)();
        this._spanId = spanContext.spanId || (0, _propagationContextJs.generateSpanId)();
        this._startTime = spanContext.startTimestamp || (0, _timeJs.timestampInSeconds)();
        this._links = spanContext.links;
        this._attributes = {};
        var _obj;
        this.setAttributes((0, _objectSpread._)((_obj = {}, (0, _defineProperty._)(_obj, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), 'manual'), (0, _defineProperty._)(_obj, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP), spanContext.op), _obj), spanContext.attributes));
        this._name = spanContext.name;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ('sampled' in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        this._events = [];
        this._isStandaloneSpan = spanContext.isStandalone;
        // If the span is already ended, ensure we finalize the span immediately
        if (this._endTime) this._onSpanEnded();
    }
    (0, _createClass._)(SentrySpan, [
        {
            /** @inheritDoc */ key: "addLink",
            value: function addLink(link) {
                if (this._links) this._links.push(link);
                else this._links = [
                    link
                ];
                return this;
            }
        },
        {
            /** @inheritDoc */ key: "addLinks",
            value: function addLinks(links) {
                var _this__links;
                if (this._links) (_this__links = this._links).push.apply(_this__links, (0, _toConsumableArray._)(links));
                else this._links = links;
                return this;
            }
        },
        {
            /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ key: "recordException",
            value: function recordException(_exception, _time) {
            // noop
            }
        },
        {
            /** @inheritdoc */ key: "spanContext",
            value: function spanContext() {
                var _this = this, spanId = _this._spanId, traceId = _this._traceId, sampled = _this._sampled;
                return {
                    spanId: spanId,
                    traceId: traceId,
                    traceFlags: sampled ? (0, _spanUtilsJs.TRACE_FLAG_SAMPLED) : (0, _spanUtilsJs.TRACE_FLAG_NONE)
                };
            }
        },
        {
            /** @inheritdoc */ key: "setAttribute",
            value: function setAttribute(key, value) {
                if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                delete this._attributes[key];
                else this._attributes[key] = value;
                return this;
            }
        },
        {
            /** @inheritdoc */ key: "setAttributes",
            value: function setAttributes(attributes) {
                var _this = this;
                Object.keys(attributes).forEach(function(key) {
                    return _this.setAttribute(key, attributes[key]);
                });
                return this;
            }
        },
        {
            /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */ key: "updateStartTime",
            value: function updateStartTime(timeInput) {
                this._startTime = (0, _spanUtilsJs.spanTimeInputToSeconds)(timeInput);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setStatus",
            value: function setStatus(value) {
                this._status = value;
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "updateName",
            value: function updateName(name) {
                this._name = name;
                this.setAttribute((0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), 'custom');
                return this;
            }
        },
        {
            /** @inheritdoc */ key: "end",
            value: function end(endTimestamp) {
                // If already ended, skip
                if (this._endTime) return;
                this._endTime = (0, _spanUtilsJs.spanTimeInputToSeconds)(endTimestamp);
                (0, _logSpansJs.logSpanEnd)(this);
                this._onSpanEnded();
            }
        },
        {
            /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ key: "getSpanJSON",
            value: function getSpanJSON() {
                return {
                    data: this._attributes,
                    description: this._name,
                    op: this._attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP],
                    parent_span_id: this._parentSpanId,
                    span_id: this._spanId,
                    start_timestamp: this._startTime,
                    status: (0, _spanUtilsJs.getStatusMessage)(this._status),
                    timestamp: this._endTime,
                    trace_id: this._traceId,
                    origin: this._attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
                    profile_id: this._attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_PROFILE_ID],
                    exclusive_time: this._attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
                    measurements: (0, _measurementJs.timedEventsToMeasurements)(this._events),
                    is_segment: this._isStandaloneSpan && (0, _spanUtilsJs.getRootSpan)(this) === this || undefined,
                    segment_id: this._isStandaloneSpan ? (0, _spanUtilsJs.getRootSpan)(this).spanContext().spanId : undefined,
                    links: (0, _spanUtilsJs.convertSpanLinksForEnvelope)(this._links)
                };
            }
        },
        {
            /** @inheritdoc */ key: "isRecording",
            value: function isRecording() {
                return !this._endTime && !!this._sampled;
            }
        },
        {
            /**
   * @inheritdoc
   */ key: "addEvent",
            value: function addEvent(name, attributesOrStartTime, startTime) {
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log('[Tracing] Adding an event to span:', name);
                var time = isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || (0, _timeJs.timestampInSeconds)();
                var attributes = isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
                var event = {
                    name: name,
                    time: (0, _spanUtilsJs.spanTimeInputToSeconds)(time),
                    attributes: attributes
                };
                this._events.push(event);
                return this;
            }
        },
        {
            /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */ key: "isStandaloneSpan",
            value: function isStandaloneSpan() {
                return !!this._isStandaloneSpan;
            }
        },
        {
            /** Emit `spanEnd` when the span is ended. */ key: "_onSpanEnded",
            value: function _onSpanEnded() {
                var client = (0, _currentScopesJs.getClient)();
                if (client) client.emit('spanEnd', this);
                // A segment span is basically the root span of a local span tree.
                // So for now, this is either what we previously refer to as the root span,
                // or a standalone span.
                var isSegmentSpan = this._isStandaloneSpan || this === (0, _spanUtilsJs.getRootSpan)(this);
                if (!isSegmentSpan) return;
                // if this is a standalone span, we send it immediately
                if (this._isStandaloneSpan) {
                    if (this._sampled) sendSpanEnvelope((0, _envelopeJs.createSpanEnvelope)([
                        this
                    ], client));
                    else {
                        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log('[Tracing] Discarding standalone span because its trace was not chosen to be sampled.');
                        if (client) client.recordDroppedEvent('sample_rate', 'span');
                    }
                    return;
                }
                var transactionEvent = this._convertSpanToTransaction();
                if (transactionEvent) {
                    var scope = (0, _utilsJs.getCapturedScopesOnSpan)(this).scope || (0, _currentScopesJs.getCurrentScope)();
                    scope.captureEvent(transactionEvent);
                }
            }
        },
        {
            /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ key: "_convertSpanToTransaction",
            value: function _convertSpanToTransaction() {
                var _this = this;
                var _capturedSpanScope_getScopeData_sdkProcessingMetadata;
                // We can only convert finished spans
                if (!isFullFinishedSpan((0, _spanUtilsJs.spanToJSON)(this))) return undefined;
                if (!this._name) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
                    this._name = '<unlabeled transaction>';
                }
                var _getCapturedScopesOnSpan = (0, _utilsJs.getCapturedScopesOnSpan)(this), capturedSpanScope = _getCapturedScopesOnSpan.scope, capturedSpanIsolationScope = _getCapturedScopesOnSpan.isolationScope;
                var normalizedRequest = capturedSpanScope === null || capturedSpanScope === void 0 ? void 0 : (_capturedSpanScope_getScopeData_sdkProcessingMetadata = capturedSpanScope.getScopeData().sdkProcessingMetadata) === null || _capturedSpanScope_getScopeData_sdkProcessingMetadata === void 0 ? void 0 : _capturedSpanScope_getScopeData_sdkProcessingMetadata.normalizedRequest;
                if (this._sampled !== true) return undefined;
                // The transaction span itself as well as any potential standalone spans should be filtered out
                var finishedSpans = (0, _spanUtilsJs.getSpanDescendants)(this).filter(function(span) {
                    return span !== _this && !isStandaloneSpan(span);
                });
                var spans = finishedSpans.map(function(span) {
                    return (0, _spanUtilsJs.spanToJSON)(span);
                }).filter(isFullFinishedSpan);
                var source = this._attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
                // remove internal root span attributes we don't need to send.
                /* eslint-disable @typescript-eslint/no-dynamic-delete */ delete this._attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
                spans.forEach(function(span) {
                    delete span.data[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
                });
                // eslint-enabled-next-line @typescript-eslint/no-dynamic-delete
                var transaction = (0, _objectSpread._)({
                    contexts: {
                        trace: (0, _spanUtilsJs.spanToTransactionTraceContext)(this)
                    },
                    spans: // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
                    // we do not use spans anymore after this point
                    spans.length > MAX_SPAN_COUNT ? spans.sort(function(a, b) {
                        return a.start_timestamp - b.start_timestamp;
                    }).slice(0, MAX_SPAN_COUNT) : spans,
                    start_timestamp: this._startTime,
                    timestamp: this._endTime,
                    transaction: this._name,
                    type: 'transaction',
                    sdkProcessingMetadata: {
                        capturedSpanScope: capturedSpanScope,
                        capturedSpanIsolationScope: capturedSpanIsolationScope,
                        dynamicSamplingContext: (0, _dynamicSamplingContextJs.getDynamicSamplingContextFromSpan)(this)
                    },
                    request: normalizedRequest
                }, source && {
                    transaction_info: {
                        source: source
                    }
                });
                var measurements = (0, _measurementJs.timedEventsToMeasurements)(this._events);
                var hasMeasurements = measurements && Object.keys(measurements).length;
                if (hasMeasurements) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log('[Measurements] Adding measurements to transaction event', JSON.stringify(measurements, undefined, 2));
                    transaction.measurements = measurements;
                }
                return transaction;
            }
        }
    ]);
    return SentrySpan;
}();
function isSpanTimeInput(value) {
    return value && typeof value === 'number' || (0, _instanceof._)(value, Date) || Array.isArray(value);
}
// We want to filter out any incomplete SpanJSON objects
function isFullFinishedSpan(input) {
    return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}
/** `SentrySpan`s can be sent as a standalone span rather than belonging to a transaction */ function isStandaloneSpan(span) {
    return (0, _instanceof._)(span, SentrySpan) && span.isStandaloneSpan();
}
/**
 * Sends a `SpanEnvelope`.
 *
 * Note: If the envelope's spans are dropped, e.g. via `beforeSendSpan`,
 * the envelope will not be sent either.
 */ function sendSpanEnvelope(envelope) {
    var client = (0, _currentScopesJs.getClient)();
    if (!client) return;
    var spanItems = envelope[1];
    if (!spanItems || spanItems.length === 0) {
        client.recordDroppedEvent('before_send', 'span');
        return;
    }
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_to_consumable_array":"1eSZf","../currentScopes.js":"3GE4v","../debug-build.js":"ejIQP","../envelope.js":"8mEkR","../semanticAttributes.js":"7WRPE","../utils/debug-logger.js":"3X9Vf","../utils/propagationContext.js":"4NKEi","../utils/spanUtils.js":"fPRKj","../utils/time.js":"i4V6H","./dynamicSamplingContext.js":"5RiCd","./logSpans.js":"fGZ3g","./measurement.js":"guYPr","./utils.js":"1QtCb","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8mEkR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_enhanceEventWithSdkInfo", function() {
    return _enhanceEventWithSdkInfo;
});
parcelHelpers.export(exports, "createEventEnvelope", function() {
    return createEventEnvelope;
});
parcelHelpers.export(exports, "createSessionEnvelope", function() {
    return createSessionEnvelope;
});
parcelHelpers.export(exports, "createSpanEnvelope", function() {
    return createSpanEnvelope;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _dynamicSamplingContextJs = require("./tracing/dynamicSamplingContext.js");
var _dsnJs = require("./utils/dsn.js");
var _envelopeJs = require("./utils/envelope.js");
var _shouldIgnoreSpanJs = require("./utils/should-ignore-span.js");
var _spanUtilsJs = require("./utils/spanUtils.js");
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 *
 * @internal, exported only for testing
 **/ function _enhanceEventWithSdkInfo(event, newSdkInfo) {
    var _event_sdk, _event_sdk1, _event_sdk2, _event_sdk3;
    if (!newSdkInfo) return event;
    var eventSdkInfo = event.sdk || {};
    event.sdk = (0, _objectSpreadProps._)((0, _objectSpread._)({}, eventSdkInfo), {
        name: eventSdkInfo.name || newSdkInfo.name,
        version: eventSdkInfo.version || newSdkInfo.version,
        integrations: (0, _toConsumableArray._)(((_event_sdk = event.sdk) === null || _event_sdk === void 0 ? void 0 : _event_sdk.integrations) || []).concat((0, _toConsumableArray._)(newSdkInfo.integrations || [])),
        packages: (0, _toConsumableArray._)(((_event_sdk1 = event.sdk) === null || _event_sdk1 === void 0 ? void 0 : _event_sdk1.packages) || []).concat((0, _toConsumableArray._)(newSdkInfo.packages || [])),
        settings: ((_event_sdk2 = event.sdk) === null || _event_sdk2 === void 0 ? void 0 : _event_sdk2.settings) || newSdkInfo.settings ? (0, _objectSpread._)({}, (_event_sdk3 = event.sdk) === null || _event_sdk3 === void 0 ? void 0 : _event_sdk3.settings, newSdkInfo.settings) : undefined
    });
    return event;
}
/** Creates an envelope from a Session */ function createSessionEnvelope(session, dsn, metadata, tunnel) {
    var sdkInfo = (0, _envelopeJs.getSdkMetadataForEnvelopeHeader)(metadata);
    var envelopeHeaders = (0, _objectSpread._)({
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }, !!tunnel && dsn && {
        dsn: (0, _dsnJs.dsnToString)(dsn)
    });
    var envelopeItem = 'aggregates' in session ? [
        {
            type: 'sessions'
        },
        session
    ] : [
        {
            type: 'session'
        },
        session.toJSON()
    ];
    return (0, _envelopeJs.createEnvelope)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function createEventEnvelope(event, dsn, metadata, tunnel) {
    var sdkInfo = (0, _envelopeJs.getSdkMetadataForEnvelopeHeader)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjust a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ var eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';
    _enhanceEventWithSdkInfo(event, metadata === null || metadata === void 0 ? void 0 : metadata.sdk);
    var envelopeHeaders = (0, _envelopeJs.createEventEnvelopeHeaders)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    var eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, _envelopeJs.createEnvelope)(envelopeHeaders, [
        eventItem
    ]);
}
/**
 * Create envelope from Span item.
 *
 * Takes an optional client and runs spans through `beforeSendSpan` if available.
 */ function createSpanEnvelope(spans, client) {
    function dscHasRequiredProps(dsc) {
        return !!dsc.trace_id && !!dsc.public_key;
    }
    // For the moment we'll obtain the DSC from the first span in the array
    // This might need to be changed if we permit sending multiple spans from
    // different segments in one envelope
    var dsc = (0, _dynamicSamplingContextJs.getDynamicSamplingContextFromSpan)(spans[0]);
    var dsn = client === null || client === void 0 ? void 0 : client.getDsn();
    var tunnel = client === null || client === void 0 ? void 0 : client.getOptions().tunnel;
    var headers = (0, _objectSpread._)({
        sent_at: new Date().toISOString()
    }, dscHasRequiredProps(dsc) && {
        trace: dsc
    }, !!tunnel && dsn && {
        dsn: (0, _dsnJs.dsnToString)(dsn)
    });
    var _ref = (client === null || client === void 0 ? void 0 : client.getOptions()) || {}, beforeSendSpan = _ref.beforeSendSpan, ignoreSpans = _ref.ignoreSpans;
    var filteredSpans = (ignoreSpans === null || ignoreSpans === void 0 ? void 0 : ignoreSpans.length) ? spans.filter(function(span) {
        return !(0, _shouldIgnoreSpanJs.shouldIgnoreSpan)((0, _spanUtilsJs.spanToJSON)(span), ignoreSpans);
    }) : spans;
    var droppedSpans = spans.length - filteredSpans.length;
    if (droppedSpans) client === null || client === void 0 ? void 0 : client.recordDroppedEvent('before_send', 'span', droppedSpans);
    var convertToSpanJSON = beforeSendSpan ? function(span) {
        var spanJson = (0, _spanUtilsJs.spanToJSON)(span);
        var processedSpan = beforeSendSpan(spanJson);
        if (!processedSpan) {
            (0, _spanUtilsJs.showSpanDropWarning)();
            return spanJson;
        }
        return processedSpan;
    } : (0, _spanUtilsJs.spanToJSON);
    var items = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = filteredSpans[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var span = _step.value;
            var spanJson = convertToSpanJSON(span);
            if (spanJson) items.push((0, _envelopeJs.createSpanEnvelopeItem)(spanJson));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return (0, _envelopeJs.createEnvelope)(headers, items);
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_to_consumable_array":"1eSZf","./tracing/dynamicSamplingContext.js":"5RiCd","./utils/dsn.js":"jNv3f","./utils/envelope.js":"fDBh0","./utils/should-ignore-span.js":"kyChD","./utils/spanUtils.js":"fPRKj","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fDBh0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addItemToEnvelope", function() {
    return addItemToEnvelope;
});
parcelHelpers.export(exports, "createAttachmentEnvelopeItem", function() {
    return createAttachmentEnvelopeItem;
});
parcelHelpers.export(exports, "createEnvelope", function() {
    return createEnvelope;
});
parcelHelpers.export(exports, "createEventEnvelopeHeaders", function() {
    return createEventEnvelopeHeaders;
});
parcelHelpers.export(exports, "createSpanEnvelopeItem", function() {
    return createSpanEnvelopeItem;
});
parcelHelpers.export(exports, "envelopeContainsItemType", function() {
    return envelopeContainsItemType;
});
parcelHelpers.export(exports, "envelopeItemTypeToDataCategory", function() {
    return envelopeItemTypeToDataCategory;
});
parcelHelpers.export(exports, "forEachEnvelopeItem", function() {
    return forEachEnvelopeItem;
});
parcelHelpers.export(exports, "getSdkMetadataForEnvelopeHeader", function() {
    return getSdkMetadataForEnvelopeHeader;
});
parcelHelpers.export(exports, "parseEnvelope", function() {
    return parseEnvelope;
});
parcelHelpers.export(exports, "serializeEnvelope", function() {
    return serializeEnvelope;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _carrierJs = require("../carrier.js");
var _dsnJs = require("./dsn.js");
var _normalizeJs = require("./normalize.js");
var _worldwideJs = require("./worldwide.js");
/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function createEnvelope(headers) {
    var items = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function addItemToEnvelope(envelope, newItem) {
    var _envelope = (0, _slicedToArray._)(envelope, 2), headers = _envelope[0], items = _envelope[1];
    return [
        headers,
        (0, _toConsumableArray._)(items).concat([
            newItem
        ])
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function forEachEnvelopeItem(envelope, callback) {
    var envelopeItems = envelope[1];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = envelopeItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var envelopeItem = _step.value;
            var envelopeItemType = envelopeItem[0].type;
            var result = callback(envelopeItem, envelopeItemType);
            if (result) return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function envelopeContainsItemType(envelope, types) {
    return forEachEnvelopeItem(envelope, function(_, type) {
        return types.includes(type);
    });
}
/**
 * Encode a string to UTF8 array.
 */ function encodeUTF8(input) {
    var carrier = (0, _carrierJs.getSentryCarrier)((0, _worldwideJs.GLOBAL_OBJ));
    return carrier.encodePolyfill ? carrier.encodePolyfill(input) : new TextEncoder().encode(input);
}
/**
 * Decode a UTF8 array to string.
 */ function decodeUTF8(input) {
    var carrier = (0, _carrierJs.getSentryCarrier)((0, _worldwideJs.GLOBAL_OBJ));
    return carrier.decodePolyfill ? carrier.decodePolyfill(input) : new TextDecoder().decode(input);
}
/**
 * Serializes an envelope.
 */ function serializeEnvelope(envelope) {
    var _envelope = (0, _slicedToArray._)(envelope, 2), envHeaders = _envelope[0], items = _envelope[1];
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    var parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === 'string') parts = typeof next === 'string' ? parts + next : [
            encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === 'string' ? encodeUTF8(next) : next);
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            var _item = (0, _slicedToArray._)(item, 2), itemHeaders = _item[0], payload = _item[1];
            append("\n".concat(JSON.stringify(itemHeaders), "\n"));
            if (typeof payload === 'string' || (0, _instanceof._)(payload, Uint8Array)) append(payload);
            else {
                var stringifiedPayload = void 0;
                try {
                    stringifiedPayload = JSON.stringify(payload);
                } catch (e) {
                    // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.stringify()` still
                    // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                    // performance impact but in this case a performance hit is better than throwing.
                    stringifiedPayload = JSON.stringify((0, _normalizeJs.normalize)(payload));
                }
                append(stringifiedPayload);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return typeof parts === 'string' ? parts : concatBuffers(parts);
}
function concatBuffers(buffers) {
    var totalLength = buffers.reduce(function(acc, buf) {
        return acc + buf.length;
    }, 0);
    var merged = new Uint8Array(totalLength);
    var offset = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = buffers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var buffer = _step.value;
            merged.set(buffer, offset);
            offset += buffer.length;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return merged;
}
/**
 * Parses an envelope
 */ function parseEnvelope(env) {
    var buffer = typeof env === 'string' ? encodeUTF8(env) : env;
    function readBinary(length) {
        var bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        var i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse(decodeUTF8(readBinary(i)));
    }
    var envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var items = [];
    while(buffer.length){
        var itemHeader = readJson();
        var binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates envelope item for a single span
 */ function createSpanEnvelopeItem(spanJson) {
    var spanHeaders = {
        type: 'span'
    };
    return [
        spanHeaders,
        spanJson
    ];
}
/**
 * Creates attachment envelope items
 */ function createAttachmentEnvelopeItem(attachment) {
    var buffer = typeof attachment.data === 'string' ? encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: 'attachment',
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
var ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: 'session',
    sessions: 'session',
    attachment: 'attachment',
    transaction: 'transaction',
    event: 'error',
    client_report: 'internal',
    user_report: 'default',
    profile: 'profile',
    profile_chunk: 'profile',
    replay_event: 'replay',
    replay_recording: 'replay',
    check_in: 'monitor',
    feedback: 'feedback',
    span: 'span',
    raw_security: 'security',
    log: 'log_item',
    metric: 'metric',
    trace_metric: 'metric'
};
/**
 * Maps the type of an envelope item to a data category.
 */ function envelopeItemTypeToDataCategory(type) {
    return ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function getSdkMetadataForEnvelopeHeader(metadataOrEvent) {
    if (!(metadataOrEvent === null || metadataOrEvent === void 0 ? void 0 : metadataOrEvent.sdk)) return;
    var _metadataOrEvent_sdk = metadataOrEvent.sdk, name = _metadataOrEvent_sdk.name, version = _metadataOrEvent_sdk.version;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn) {
    var _event_sdkProcessingMetadata;
    var dynamicSamplingContext = (_event_sdkProcessingMetadata = event.sdkProcessingMetadata) === null || _event_sdkProcessingMetadata === void 0 ? void 0 : _event_sdkProcessingMetadata.dynamicSamplingContext;
    return (0, _objectSpread._)({
        event_id: event.event_id,
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }, !!tunnel && dsn && {
        dsn: (0, _dsnJs.dsnToString)(dsn)
    }, dynamicSamplingContext && {
        trace: dynamicSamplingContext
    });
}

},{"@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_to_consumable_array":"1eSZf","../carrier.js":"abKK3","./dsn.js":"jNv3f","./normalize.js":"k9k7R","./worldwide.js":"3qnNR","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"k9k7R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "normalize", function() {
    return normalize;
});
parcelHelpers.export(exports, "normalizeToSize", function() {
    return normalizeToSize;
});
parcelHelpers.export(exports, "normalizeUrlToBase", function() {
    return normalizeUrlToBase;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var _isJs = require("./is.js");
var _objectJs = require("./object.js");
var _stacktraceJs = require("./stacktrace.js");
var global = arguments[3];
/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normalized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function normalize(input) {
    var depth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100, maxProperties = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Infinity;
    try {
        // since we're at the outermost level, we don't provide a key
        return visit('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: "**non-serializable** (".concat(err, ")")
        };
    }
}
/** JSDoc */ function normalizeToSize(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object) {
    var // Default Node.js REPL depth
    depth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
    maxSize = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 102400;
    var normalized = normalize(object, depth);
    if (jsonSize(normalized) > maxSize) return normalizeToSize(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function visit(key, value) {
    var depth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Infinity, maxProperties = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Infinity, memo = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : memoBuilder();
    var _memo = (0, _slicedToArray._)(memo, 2), memoize = _memo[0], unmemoize = _memo[1];
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        'boolean',
        'string'
    ].includes(typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) || typeof value === 'number' && Number.isFinite(value)) return value;
    var stringified = stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value['__sentry_skip_normalization__']) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    var remainingDepth = typeof value['__sentry_override_normalization_depth__'] === 'number' ? value['__sentry_override_normalization_depth__'] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    var valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        var jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return visit('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (e) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    var normalized = Array.isArray(value) ? [] : {};
    var numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    var visitable = (0, _objectJs.convertToPlainObject)(value);
    for(var visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        var visitValue = visitable[visitKey];
        normalized[visitKey] = visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && (typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof global !== 'undefined' && value === global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        if ((0, _isJs.isVueViewModel)(value)) return (0, _stacktraceJs.getVueInternalName)(value);
        // React's SyntheticEvent thingy
        if ((0, _isJs.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && !Number.isFinite(value)) return "[".concat(value, "]");
        if (typeof value === 'function') return "[Function: ".concat((0, _stacktraceJs.getFunctionName)(value), "]");
        if ((typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) === 'symbol') return "[".concat(String(value), "]");
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if ((typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) === 'bigint') return "[BigInt: ".concat(String(value), "]");
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        var objName = getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return "[HTMLElement: ".concat(objName, "]");
        return "[object ".concat(objName, "]");
    } catch (err) {
        return "**non-serializable** (".concat(err, ")");
    }
}
/* eslint-enable complexity */ function getConstructorName(value) {
    var prototype = Object.getPrototypeOf(value);
    return (prototype === null || prototype === void 0 ? void 0 : prototype.constructor) ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function jsonSize(value) {
    return utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function normalizeUrlToBase(url, basePath) {
    var escapedBase = basePath// Backslash to forward
    .replace(/\\/g, '/')// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    var newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (e) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, '/').replace(/webpack:\/?/g, '') // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp("(file://)?/*".concat(escapedBase, "/*"), 'ig'), 'app:///');
}
/**
 * Helper to decycle json objects
 */ function memoBuilder() {
    var inner = new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_type_of":"iFJdx","./is.js":"kSqSf","./object.js":"9SKe9","./stacktrace.js":"5srWn","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fGZ3g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "logSpanEnd", function() {
    return logSpanEnd;
});
parcelHelpers.export(exports, "logSpanStart", function() {
    return logSpanStart;
});
var _debugBuildJs = require("../debug-build.js");
var _debugLoggerJs = require("../utils/debug-logger.js");
var _spanUtilsJs = require("../utils/spanUtils.js");
/**
 * Print a log message for a started span.
 */ function logSpanStart(span) {
    if (!(0, _debugBuildJs.DEBUG_BUILD)) return;
    var _spanToJSON = (0, _spanUtilsJs.spanToJSON)(span), _spanToJSON_description = _spanToJSON.description, description = _spanToJSON_description === void 0 ? '< unknown name >' : _spanToJSON_description, _spanToJSON_op = _spanToJSON.op, op = _spanToJSON_op === void 0 ? '< unknown op >' : _spanToJSON_op, parentSpanId = _spanToJSON.parent_span_id;
    var spanId = span.spanContext().spanId;
    var sampled = (0, _spanUtilsJs.spanIsSampled)(span);
    var rootSpan = (0, _spanUtilsJs.getRootSpan)(span);
    var isRootSpan = rootSpan === span;
    var header = "[Tracing] Starting ".concat(sampled ? 'sampled' : 'unsampled', " ").concat(isRootSpan ? 'root ' : '', "span");
    var infoParts = [
        "op: ".concat(op),
        "name: ".concat(description),
        "ID: ".concat(spanId)
    ];
    if (parentSpanId) infoParts.push("parent ID: ".concat(parentSpanId));
    if (!isRootSpan) {
        var _spanToJSON1 = (0, _spanUtilsJs.spanToJSON)(rootSpan), op1 = _spanToJSON1.op, description1 = _spanToJSON1.description;
        infoParts.push("root ID: ".concat(rootSpan.spanContext().spanId));
        if (op1) infoParts.push("root op: ".concat(op1));
        if (description1) infoParts.push("root description: ".concat(description1));
    }
    (0, _debugLoggerJs.debug).log("".concat(header, "\n  ").concat(infoParts.join('\n  ')));
}
/**
 * Print a log message for an ended span.
 */ function logSpanEnd(span) {
    if (!(0, _debugBuildJs.DEBUG_BUILD)) return;
    var _spanToJSON = (0, _spanUtilsJs.spanToJSON)(span), _spanToJSON_description = _spanToJSON.description, description = _spanToJSON_description === void 0 ? '< unknown name >' : _spanToJSON_description, _spanToJSON_op = _spanToJSON.op, op = _spanToJSON_op === void 0 ? '< unknown op >' : _spanToJSON_op;
    var spanId = span.spanContext().spanId;
    var rootSpan = (0, _spanUtilsJs.getRootSpan)(span);
    var isRootSpan = rootSpan === span;
    var msg = '[Tracing] Finishing "'.concat(op, '" ').concat(isRootSpan ? 'root ' : '', 'span "').concat(description, '" with ID ').concat(spanId);
    (0, _debugLoggerJs.debug).log(msg);
}

},{"../debug-build.js":"ejIQP","../utils/debug-logger.js":"3X9Vf","../utils/spanUtils.js":"fPRKj","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"guYPr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setMeasurement", function() {
    return setMeasurement;
});
parcelHelpers.export(exports, "timedEventsToMeasurements", function() {
    return timedEventsToMeasurements;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _debugBuildJs = require("../debug-build.js");
var _semanticAttributesJs = require("../semanticAttributes.js");
var _debugLoggerJs = require("../utils/debug-logger.js");
var _spanUtilsJs = require("../utils/spanUtils.js");
/**
 * Adds a measurement to the active transaction on the current global scope. You can optionally pass in a different span
 * as the 4th parameter.
 */ function setMeasurement(name, value, unit) {
    var activeSpan = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : (0, _spanUtilsJs.getActiveSpan)();
    var rootSpan = activeSpan && (0, _spanUtilsJs.getRootSpan)(activeSpan);
    if (rootSpan) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log("[Measurement] Setting measurement on root span: ".concat(name, " = ").concat(value, " ").concat(unit));
        var _obj;
        rootSpan.addEvent(name, (_obj = {}, (0, _defineProperty._)(_obj, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE), value), (0, _defineProperty._)(_obj, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT), unit), _obj));
    }
}
/**
 * Convert timed events to measurements.
 */ function timedEventsToMeasurements(events) {
    if (!events || events.length === 0) return undefined;
    var measurements = {};
    events.forEach(function(event) {
        var attributes = event.attributes || {};
        var unit = attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT];
        var value = attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE];
        if (typeof unit === 'string' && typeof value === 'number') measurements[event.name] = {
            value: value,
            unit: unit
        };
    });
    return measurements;
}

},{"@swc/helpers/_/_define_property":"e80IS","../debug-build.js":"ejIQP","../semanticAttributes.js":"7WRPE","../utils/debug-logger.js":"3X9Vf","../utils/spanUtils.js":"fPRKj","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eu0PU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "continueTrace", function() {
    return continueTrace;
});
parcelHelpers.export(exports, "startInactiveSpan", function() {
    return startInactiveSpan;
});
parcelHelpers.export(exports, "startNewTrace", function() {
    return startNewTrace;
});
parcelHelpers.export(exports, "startSpan", function() {
    return startSpan;
});
parcelHelpers.export(exports, "startSpanManual", function() {
    return startSpanManual;
});
parcelHelpers.export(exports, "suppressTracing", function() {
    return suppressTracing;
});
parcelHelpers.export(exports, "withActiveSpan", function() {
    return withActiveSpan;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _indexJs = require("../asyncContext/index.js");
var _carrierJs = require("../carrier.js");
var _currentScopesJs = require("../currentScopes.js");
var _debugBuildJs = require("../debug-build.js");
var _semanticAttributesJs = require("../semanticAttributes.js");
var _baggageJs = require("../utils/baggage.js");
var _debugLoggerJs = require("../utils/debug-logger.js");
var _handleCallbackErrorsJs = require("../utils/handleCallbackErrors.js");
var _hasSpansEnabledJs = require("../utils/hasSpansEnabled.js");
var _parseSampleRateJs = require("../utils/parseSampleRate.js");
var _propagationContextJs = require("../utils/propagationContext.js");
var _spanOnScopeJs = require("../utils/spanOnScope.js");
var _spanUtilsJs = require("../utils/spanUtils.js");
var _tracingJs = require("../utils/tracing.js");
var _dynamicSamplingContextJs = require("./dynamicSamplingContext.js");
var _logSpansJs = require("./logSpans.js");
var _samplingJs = require("./sampling.js");
var _sentryNonRecordingSpanJs = require("./sentryNonRecordingSpan.js");
var _sentrySpanJs = require("./sentrySpan.js");
var _spanstatusJs = require("./spanstatus.js");
var _utilsJs = require("./utils.js");
/* eslint-disable max-lines */ var SUPPRESS_TRACING_KEY = '__SENTRY_SUPPRESS_TRACING__';
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function startSpan(options, callback) {
    var acs = getAcs();
    if (acs.startSpan) return acs.startSpan(options, callback);
    var spanArguments = parseSentrySpanArguments(options);
    var forceTransaction = options.forceTransaction, customParentSpan = options.parentSpan, customScope = options.scope;
    // We still need to fork a potentially passed scope, as we set the active span on it
    // and we need to ensure that it is cleaned up properly once the span ends.
    var customForkedScope = customScope === null || customScope === void 0 ? void 0 : customScope.clone();
    return (0, _currentScopesJs.withScope)(customForkedScope, function() {
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        var wrapper = getActiveSpanWrapper(customParentSpan);
        return wrapper(function() {
            var scope = (0, _currentScopesJs.getCurrentScope)();
            var parentSpan = getParentSpan(scope, customParentSpan);
            var shouldSkipSpan = options.onlyIfParent && !parentSpan;
            var activeSpan = shouldSkipSpan ? new (0, _sentryNonRecordingSpanJs.SentryNonRecordingSpan)() : createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            (0, _spanOnScopeJs._setSpanForScope)(scope, activeSpan);
            return (0, _handleCallbackErrorsJs.handleCallbackErrors)(function() {
                return callback(activeSpan);
            }, function() {
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                var status = (0, _spanUtilsJs.spanToJSON)(activeSpan).status;
                if (activeSpan.isRecording() && (!status || status === 'ok')) activeSpan.setStatus({
                    code: (0, _spanstatusJs.SPAN_STATUS_ERROR),
                    message: 'internal_error'
                });
            }, function() {
                activeSpan.end();
            });
        });
    });
}
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. Use `span.end()` to end the span.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function startSpanManual(options, callback) {
    var acs = getAcs();
    if (acs.startSpanManual) return acs.startSpanManual(options, callback);
    var spanArguments = parseSentrySpanArguments(options);
    var forceTransaction = options.forceTransaction, customParentSpan = options.parentSpan, customScope = options.scope;
    var customForkedScope = customScope === null || customScope === void 0 ? void 0 : customScope.clone();
    return (0, _currentScopesJs.withScope)(customForkedScope, function() {
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        var wrapper = getActiveSpanWrapper(customParentSpan);
        return wrapper(function() {
            var scope = (0, _currentScopesJs.getCurrentScope)();
            var parentSpan = getParentSpan(scope, customParentSpan);
            var shouldSkipSpan = options.onlyIfParent && !parentSpan;
            var activeSpan = shouldSkipSpan ? new (0, _sentryNonRecordingSpanJs.SentryNonRecordingSpan)() : createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            (0, _spanOnScopeJs._setSpanForScope)(scope, activeSpan);
            return (0, _handleCallbackErrorsJs.handleCallbackErrors)(// We pass the `finish` function to the callback, so the user can finish the span manually
            // this is mainly here for historic purposes because previously, we instructed users to call
            // `finish` instead of `span.end()` to also clean up the scope. Nowadays, calling `span.end()`
            // or `finish` has the same effect and we simply leave it here to avoid breaking user code.
            function() {
                return callback(activeSpan, function() {
                    return activeSpan.end();
                });
            }, function() {
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                var status = (0, _spanUtilsJs.spanToJSON)(activeSpan).status;
                if (activeSpan.isRecording() && (!status || status === 'ok')) activeSpan.setStatus({
                    code: (0, _spanstatusJs.SPAN_STATUS_ERROR),
                    message: 'internal_error'
                });
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getActiveSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * This function will always return a span,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function startInactiveSpan(options) {
    var acs = getAcs();
    if (acs.startInactiveSpan) return acs.startInactiveSpan(options);
    var spanArguments = parseSentrySpanArguments(options);
    var forceTransaction = options.forceTransaction, customParentSpan = options.parentSpan;
    // If `options.scope` is defined, we use this as as a wrapper,
    // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
    var wrapper = options.scope ? function(callback) {
        return (0, _currentScopesJs.withScope)(options.scope, callback);
    } : customParentSpan !== undefined ? function(callback) {
        return withActiveSpan(customParentSpan, callback);
    } : function(callback) {
        return callback();
    };
    return wrapper(function() {
        var scope = (0, _currentScopesJs.getCurrentScope)();
        var parentSpan = getParentSpan(scope, customParentSpan);
        var shouldSkipSpan = options.onlyIfParent && !parentSpan;
        if (shouldSkipSpan) return new (0, _sentryNonRecordingSpanJs.SentryNonRecordingSpan)();
        return createChildOrRootSpan({
            parentSpan: parentSpan,
            spanArguments: spanArguments,
            forceTransaction: forceTransaction,
            scope: scope
        });
    });
}
/**
 * Continue a trace from `sentry-trace` and `baggage` values.
 * These values can be obtained from incoming request headers, or in the browser from `<meta name="sentry-trace">`
 * and `<meta name="baggage">` HTML tags.
 *
 * Spans started with `startSpan`, `startSpanManual` and `startInactiveSpan`, within the callback will automatically
 * be attached to the incoming trace.
 */ var continueTrace = function(options, callback) {
    var carrier = (0, _carrierJs.getMainCarrier)();
    var acs = (0, _indexJs.getAsyncContextStrategy)(carrier);
    if (acs.continueTrace) return acs.continueTrace(options, callback);
    var sentryTrace = options.sentryTrace, baggage = options.baggage;
    var client = (0, _currentScopesJs.getClient)();
    var incomingDsc = (0, _baggageJs.baggageHeaderToDynamicSamplingContext)(baggage);
    if (client && !(0, _tracingJs.shouldContinueTrace)(client, incomingDsc === null || incomingDsc === void 0 ? void 0 : incomingDsc.org_id)) return startNewTrace(callback);
    return (0, _currentScopesJs.withScope)(function(scope) {
        var propagationContext = (0, _tracingJs.propagationContextFromHeaders)(sentryTrace, baggage);
        scope.setPropagationContext(propagationContext);
        return callback();
    });
};
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback. Can be
 * passed `null` to start an entirely new span tree.
 *
 * @param span Spans started in the context of the provided callback will be children of this span. If `null` is passed,
 * spans started within the callback will not be attached to a parent span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function withActiveSpan(span, callback) {
    var acs = getAcs();
    if (acs.withActiveSpan) return acs.withActiveSpan(span, callback);
    return (0, _currentScopesJs.withScope)(function(scope) {
        (0, _spanOnScopeJs._setSpanForScope)(scope, span || undefined);
        return callback(scope);
    });
}
/** Suppress tracing in the given callback, ensuring no spans are generated inside of it. */ function suppressTracing(callback) {
    var acs = getAcs();
    if (acs.suppressTracing) return acs.suppressTracing(callback);
    return (0, _currentScopesJs.withScope)(function(scope) {
        // Note: We do not wait for the callback to finish before we reset the metadata
        // the reason for this is that otherwise, in the browser this can lead to very weird behavior
        // as there is only a single top scope, if the callback takes longer to finish,
        // other, unrelated spans may also be suppressed, which we do not want
        // so instead, we only suppress tracing synchronoysly in the browser
        scope.setSDKProcessingMetadata((0, _defineProperty._)({}, SUPPRESS_TRACING_KEY, true));
        var res = callback();
        scope.setSDKProcessingMetadata((0, _defineProperty._)({}, SUPPRESS_TRACING_KEY, undefined));
        return res;
    });
}
/**
 * Starts a new trace for the duration of the provided callback. Spans started within the
 * callback will be part of the new trace instead of a potentially previously started trace.
 *
 * Important: Only use this function if you want to override the default trace lifetime and
 * propagation mechanism of the SDK for the duration and scope of the provided callback.
 * The newly created trace will also be the root of a new distributed trace, for example if
 * you make http requests within the callback.
 * This function might be useful if the operation you want to instrument should not be part
 * of a potentially ongoing trace.
 *
 * Default behavior:
 * - Server-side: A new trace is started for each incoming request.
 * - Browser: A new trace is started for each page our route. Navigating to a new route
 *            or page will automatically create a new trace.
 */ function startNewTrace(callback) {
    return (0, _currentScopesJs.withScope)(function(scope) {
        scope.setPropagationContext({
            traceId: (0, _propagationContextJs.generateTraceId)(),
            sampleRand: Math.random()
        });
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log("Starting a new trace with id ".concat(scope.getPropagationContext().traceId));
        return withActiveSpan(null, callback);
    });
}
function createChildOrRootSpan(param) {
    var parentSpan = param.parentSpan, spanArguments = param.spanArguments, forceTransaction = param.forceTransaction, scope = param.scope;
    if (!(0, _hasSpansEnabledJs.hasSpansEnabled)()) {
        var span = new (0, _sentryNonRecordingSpanJs.SentryNonRecordingSpan)();
        // If this is a root span, we ensure to freeze a DSC
        // So we can have at least partial data here
        if (forceTransaction || !parentSpan) {
            var dsc = (0, _objectSpread._)({
                sampled: 'false',
                sample_rate: '0',
                transaction: spanArguments.name
            }, (0, _dynamicSamplingContextJs.getDynamicSamplingContextFromSpan)(span));
            (0, _dynamicSamplingContextJs.freezeDscOnSpan)(span, dsc);
        }
        return span;
    }
    var isolationScope = (0, _currentScopesJs.getIsolationScope)();
    var span1;
    if (parentSpan && !forceTransaction) {
        span1 = _startChildSpan(parentSpan, scope, spanArguments);
        (0, _spanUtilsJs.addChildSpanToSpan)(parentSpan, span1);
    } else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        var dsc1 = (0, _dynamicSamplingContextJs.getDynamicSamplingContextFromSpan)(parentSpan);
        var _parentSpan_spanContext = parentSpan.spanContext(), traceId = _parentSpan_spanContext.traceId, parentSpanId = _parentSpan_spanContext.spanId;
        var parentSampled = (0, _spanUtilsJs.spanIsSampled)(parentSpan);
        span1 = _startRootSpan((0, _objectSpread._)({
            traceId: traceId,
            parentSpanId: parentSpanId
        }, spanArguments), scope, parentSampled);
        (0, _dynamicSamplingContextJs.freezeDscOnSpan)(span1, dsc1);
    } else {
        var _$_object_spread = (0, _objectSpread._)({}, isolationScope.getPropagationContext(), scope.getPropagationContext()), traceId1 = _$_object_spread.traceId, dsc2 = _$_object_spread.dsc, parentSpanId1 = _$_object_spread.parentSpanId, parentSampled1 = _$_object_spread.sampled;
        span1 = _startRootSpan((0, _objectSpread._)({
            traceId: traceId1,
            parentSpanId: parentSpanId1
        }, spanArguments), scope, parentSampled1);
        if (dsc2) (0, _dynamicSamplingContextJs.freezeDscOnSpan)(span1, dsc2);
    }
    (0, _logSpansJs.logSpanStart)(span1);
    (0, _utilsJs.setCapturedScopesOnSpan)(span1, scope, isolationScope);
    return span1;
}
/**
 * This converts StartSpanOptions to SentrySpanArguments.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 */ function parseSentrySpanArguments(options) {
    var exp = options.experimental || {};
    var initialCtx = (0, _objectSpread._)({
        isStandalone: exp.standalone
    }, options);
    if (options.startTime) {
        var ctx = (0, _objectSpread._)({}, initialCtx);
        ctx.startTimestamp = (0, _spanUtilsJs.spanTimeInputToSeconds)(options.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return initialCtx;
}
function getAcs() {
    var carrier = (0, _carrierJs.getMainCarrier)();
    return (0, _indexJs.getAsyncContextStrategy)(carrier);
}
function _startRootSpan(spanArguments, scope, parentSampled) {
    var _currentPropagationContext_dsc;
    var client = (0, _currentScopesJs.getClient)();
    var options = (client === null || client === void 0 ? void 0 : client.getOptions()) || {};
    var _spanArguments_name = spanArguments.name, name = _spanArguments_name === void 0 ? '' : _spanArguments_name;
    var mutableSpanSamplingData = {
        spanAttributes: (0, _objectSpread._)({}, spanArguments.attributes),
        spanName: name,
        parentSampled: parentSampled
    };
    // we don't care about the decision for the moment; this is just a placeholder
    client === null || client === void 0 ? void 0 : client.emit('beforeSampling', mutableSpanSamplingData, {
        decision: false
    });
    var _mutableSpanSamplingData_parentSampled;
    // If hook consumers override the parentSampled flag, we will use that value instead of the actual one
    var finalParentSampled = (_mutableSpanSamplingData_parentSampled = mutableSpanSamplingData.parentSampled) !== null && _mutableSpanSamplingData_parentSampled !== void 0 ? _mutableSpanSamplingData_parentSampled : parentSampled;
    var finalAttributes = mutableSpanSamplingData.spanAttributes;
    var currentPropagationContext = scope.getPropagationContext();
    var _ref = (0, _slicedToArray._)(scope.getScopeData().sdkProcessingMetadata[SUPPRESS_TRACING_KEY] ? [
        false
    ] : (0, _samplingJs.sampleSpan)(options, {
        name: name,
        parentSampled: finalParentSampled,
        attributes: finalAttributes,
        parentSampleRate: (0, _parseSampleRateJs.parseSampleRate)((_currentPropagationContext_dsc = currentPropagationContext.dsc) === null || _currentPropagationContext_dsc === void 0 ? void 0 : _currentPropagationContext_dsc.sample_rate)
    }, currentPropagationContext.sampleRand), 3), sampled = _ref[0], sampleRate = _ref[1], localSampleRateWasApplied = _ref[2];
    var _obj;
    var rootSpan = new (0, _sentrySpanJs.SentrySpan)((0, _objectSpreadProps._)((0, _objectSpread._)({}, spanArguments), {
        attributes: (0, _objectSpread._)((_obj = {}, (0, _defineProperty._)(_obj, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), 'custom'), (0, _defineProperty._)(_obj, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), sampleRate !== undefined && localSampleRateWasApplied ? sampleRate : undefined), _obj), finalAttributes),
        sampled: sampled
    }));
    if (!sampled && client) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log('[Tracing] Discarding root span because its trace was not chosen to be sampled.');
        client.recordDroppedEvent('sample_rate', 'transaction');
    }
    if (client) client.emit('spanStart', rootSpan);
    return rootSpan;
}
/**
 * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
 * This inherits the sampling decision from the parent span.
 */ function _startChildSpan(parentSpan, scope, spanArguments) {
    var _parentSpan_spanContext = parentSpan.spanContext(), spanId = _parentSpan_spanContext.spanId, traceId = _parentSpan_spanContext.traceId;
    var sampled = scope.getScopeData().sdkProcessingMetadata[SUPPRESS_TRACING_KEY] ? false : (0, _spanUtilsJs.spanIsSampled)(parentSpan);
    var childSpan = sampled ? new (0, _sentrySpanJs.SentrySpan)((0, _objectSpreadProps._)((0, _objectSpread._)({}, spanArguments), {
        parentSpanId: spanId,
        traceId: traceId,
        sampled: sampled
    })) : new (0, _sentryNonRecordingSpanJs.SentryNonRecordingSpan)({
        traceId: traceId
    });
    (0, _spanUtilsJs.addChildSpanToSpan)(parentSpan, childSpan);
    var client = (0, _currentScopesJs.getClient)();
    if (client) {
        client.emit('spanStart', childSpan);
        // If it has an endTimestamp, it's already ended
        if (spanArguments.endTimestamp) client.emit('spanEnd', childSpan);
    }
    return childSpan;
}
function getParentSpan(scope, customParentSpan) {
    // always use the passed in span directly
    if (customParentSpan) return customParentSpan;
    // This is different from `undefined` as it means the user explicitly wants no parent span
    if (customParentSpan === null) return undefined;
    var span = (0, _spanOnScopeJs._getSpanForScope)(scope);
    if (!span) return undefined;
    var client = (0, _currentScopesJs.getClient)();
    var options = client ? client.getOptions() : {};
    if (options.parentSpanIsAlwaysRootSpan) return (0, _spanUtilsJs.getRootSpan)(span);
    return span;
}
function getActiveSpanWrapper(parentSpan) {
    return parentSpan !== undefined ? function(callback) {
        return withActiveSpan(parentSpan, callback);
    } : function(callback) {
        return callback();
    };
}

},{"@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_sliced_to_array":"8PtL6","../asyncContext/index.js":"8OVZH","../carrier.js":"abKK3","../currentScopes.js":"3GE4v","../debug-build.js":"ejIQP","../semanticAttributes.js":"7WRPE","../utils/baggage.js":"8aTvT","../utils/debug-logger.js":"3X9Vf","../utils/handleCallbackErrors.js":"g30DX","../utils/hasSpansEnabled.js":"klZEt","../utils/parseSampleRate.js":"e0bLP","../utils/propagationContext.js":"4NKEi","../utils/spanOnScope.js":"rJBOp","../utils/spanUtils.js":"fPRKj","../utils/tracing.js":"f5SYf","./dynamicSamplingContext.js":"5RiCd","./logSpans.js":"fGZ3g","./sampling.js":"3ygwj","./sentryNonRecordingSpan.js":"j8tB0","./sentrySpan.js":"aWoC1","./spanstatus.js":"WiYVV","./utils.js":"1QtCb","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"g30DX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "handleCallbackErrors", function() {
    return handleCallbackErrors;
});
var _isJs = require("./is.js");
/* eslint-disable */ // Vendor "Awaited" in to be TS 3.8 compatible
/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function handleCallbackErrors(fn, onError) {
    var onFinally = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function() {}, onSuccess = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : function() {};
    var maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally, onSuccess);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */ function maybeHandlePromiseRejection(value, onError, onFinally, onSuccess) {
    if ((0, _isJs.isThenable)(value)) // @ts-expect-error - the isThenable check returns the "wrong" type here
    return value.then(function(res) {
        onFinally();
        onSuccess(res);
        return res;
    }, function(e) {
        onError(e);
        onFinally();
        throw e;
    });
    onFinally();
    onSuccess(value);
    return value;
}

},{"./is.js":"kSqSf","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3ygwj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sampleSpan", function() {
    return sampleSpan;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _typeOf = require("@swc/helpers/_/_type_of");
var _debugBuildJs = require("../debug-build.js");
var _debugLoggerJs = require("../utils/debug-logger.js");
var _hasSpansEnabledJs = require("../utils/hasSpansEnabled.js");
var _parseSampleRateJs = require("../utils/parseSampleRate.js");
/**
 * Makes a sampling decision for the given options.
 *
 * Called every time a root span is created. Only root spans which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 */ function sampleSpan(options, samplingContext, sampleRand) {
    // nothing to do if span recording is not enabled
    if (!(0, _hasSpansEnabledJs.hasSpansEnabled)(options)) return [
        false
    ];
    var localSampleRateWasApplied = undefined;
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` were defined, so one of these should
    // work; prefer the hook if so
    var sampleRate;
    if (typeof options.tracesSampler === 'function') {
        sampleRate = options.tracesSampler((0, _objectSpreadProps._)((0, _objectSpread._)({}, samplingContext), {
            inheritOrSampleWith: function(fallbackSampleRate) {
                // If we have an incoming parent sample rate, we'll just use that one.
                // The sampling decision will be inherited because of the sample_rand that was generated when the trace reached the incoming boundaries of the SDK.
                if (typeof samplingContext.parentSampleRate === 'number') return samplingContext.parentSampleRate;
                // Fallback if parent sample rate is not on the incoming trace (e.g. if there is no baggage)
                // This is to provide backwards compatibility if there are incoming traces from older SDKs that don't send a parent sample rate or a sample rand. In these cases we just want to force either a sampling decision on the downstream traces via the sample rate.
                if (typeof samplingContext.parentSampled === 'boolean') return Number(samplingContext.parentSampled);
                return fallbackSampleRate;
            }
        }));
        localSampleRateWasApplied = true;
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== 'undefined') {
        sampleRate = options.tracesSampleRate;
        localSampleRateWasApplied = true;
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get.
    // (The only valid values are booleans or numbers between 0 and 1.)
    var parsedSampleRate = (0, _parseSampleRateJs.parseSampleRate)(sampleRate);
    if (parsedSampleRate === undefined) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn("[Tracing] Discarding root span because of invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ".concat(JSON.stringify(sampleRate), " of type ").concat(JSON.stringify(typeof sampleRate === "undefined" ? "undefined" : (0, _typeOf._)(sampleRate)), "."));
        return [
            false
        ];
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!parsedSampleRate) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log("[Tracing] Discarding transaction because ".concat(typeof options.tracesSampler === 'function' ? 'tracesSampler returned 0 or false' : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'));
        return [
            false,
            parsedSampleRate,
            localSampleRateWasApplied
        ];
    }
    // We always compare the sample rand for the current execution context against the chosen sample rate.
    // Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
    var shouldSample = sampleRand < parsedSampleRate;
    // if we're not going to keep it, we're done
    if (!shouldSample) (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log("[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ".concat(Number(sampleRate), ")"));
    return [
        shouldSample,
        parsedSampleRate,
        localSampleRateWasApplied
    ];
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_type_of":"iFJdx","../debug-build.js":"ejIQP","../utils/debug-logger.js":"3X9Vf","../utils/hasSpansEnabled.js":"klZEt","../utils/parseSampleRate.js":"e0bLP","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1Xqap":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addEventProcessor", function() {
    return addEventProcessor;
});
parcelHelpers.export(exports, "captureCheckIn", function() {
    return captureCheckIn;
});
parcelHelpers.export(exports, "captureEvent", function() {
    return captureEvent;
});
parcelHelpers.export(exports, "captureException", function() {
    return captureException;
});
parcelHelpers.export(exports, "captureMessage", function() {
    return captureMessage;
});
parcelHelpers.export(exports, "captureSession", function() {
    return captureSession;
});
parcelHelpers.export(exports, "close", function() {
    return close;
});
parcelHelpers.export(exports, "endSession", function() {
    return endSession;
});
parcelHelpers.export(exports, "flush", function() {
    return flush;
});
parcelHelpers.export(exports, "isEnabled", function() {
    return isEnabled;
});
parcelHelpers.export(exports, "isInitialized", function() {
    return isInitialized;
});
parcelHelpers.export(exports, "lastEventId", function() {
    return lastEventId;
});
parcelHelpers.export(exports, "setContext", function() {
    return setContext;
});
parcelHelpers.export(exports, "setExtra", function() {
    return setExtra;
});
parcelHelpers.export(exports, "setExtras", function() {
    return setExtras;
});
parcelHelpers.export(exports, "setTag", function() {
    return setTag;
});
parcelHelpers.export(exports, "setTags", function() {
    return setTags;
});
parcelHelpers.export(exports, "setUser", function() {
    return setUser;
});
parcelHelpers.export(exports, "startSession", function() {
    return startSession;
});
parcelHelpers.export(exports, "withMonitor", function() {
    return withMonitor;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _currentScopesJs = require("./currentScopes.js");
var _debugBuildJs = require("./debug-build.js");
var _sessionJs = require("./session.js");
var _debugLoggerJs = require("./utils/debug-logger.js");
var _isJs = require("./utils/is.js");
var _miscJs = require("./utils/misc.js");
var _prepareEventJs = require("./utils/prepareEvent.js");
var _timeJs = require("./utils/time.js");
var _worldwideJs = require("./utils/worldwide.js");
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function captureException(exception, hint) {
    return (0, _currentScopesJs.getCurrentScope)().captureException(exception, (0, _prepareEventJs.parseEventHintOrCaptureContext)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function captureMessage(message, captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    var level = typeof captureContext === 'string' ? captureContext : undefined;
    var hint = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    return (0, _currentScopesJs.getCurrentScope)().captureMessage(message, level, hint);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function captureEvent(event, hint) {
    return (0, _currentScopesJs.getCurrentScope)().captureEvent(event, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ function setContext(name, context) {
    (0, _currentScopesJs.getIsolationScope)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function setExtras(extras) {
    (0, _currentScopesJs.getIsolationScope)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function setExtra(key, extra) {
    (0, _currentScopesJs.getIsolationScope)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function setTags(tags) {
    (0, _currentScopesJs.getIsolationScope)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function setTag(key, value) {
    (0, _currentScopesJs.getIsolationScope)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function setUser(user) {
    (0, _currentScopesJs.getIsolationScope)().setUser(user);
}
/**
 * The last error event id of the isolation scope.
 *
 * Warning: This function really returns the last recorded error event id on the current
 * isolation scope. If you call this function after handling a certain error and another error
 * is captured in between, the last one is returned instead of the one you might expect.
 * Also, ids of events that were never sent to Sentry (for example because
 * they were dropped in `beforeSend`) could be returned.
 *
 * @returns The last event id of the isolation scope.
 */ function lastEventId() {
    return (0, _currentScopesJs.getIsolationScope)().lastEventId();
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function captureCheckIn(checkIn, upsertMonitorConfig) {
    var scope = (0, _currentScopesJs.getCurrentScope)();
    var client = (0, _currentScopesJs.getClient)();
    if (!client) (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn('Cannot capture check-in. No client defined.');
    else if (!client.captureCheckIn) (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn('Cannot capture check-in. Client does not support sending check-ins.');
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, _miscJs.uuid4)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param callback Callback to be monitored
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function withMonitor(monitorSlug, callback, upsertMonitorConfig) {
    var checkInId = captureCheckIn({
        monitorSlug: monitorSlug,
        status: 'in_progress'
    }, upsertMonitorConfig);
    var now = (0, _timeJs.timestampInSeconds)();
    function finishCheckIn(status) {
        captureCheckIn({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, _timeJs.timestampInSeconds)() - now
        });
    }
    return (0, _currentScopesJs.withIsolationScope)(function() {
        var maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn('error');
            throw e;
        }
        if ((0, _isJs.isThenable)(maybePromiseResult)) return maybePromiseResult.then(function(r) {
            finishCheckIn('ok');
            return r;
        }, function(e) {
            finishCheckIn('error');
            throw e;
        });
        finishCheckIn('ok');
        return maybePromiseResult;
    });
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ function flush(timeout) {
    return (0, _asyncToGenerator._)(function() {
        var client;
        return (0, _tsGenerator._)(this, function(_state) {
            client = (0, _currentScopesJs.getClient)();
            if (client) return [
                2,
                client.flush(timeout)
            ];
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn('Cannot flush events. No client defined.');
            return [
                2,
                Promise.resolve(false)
            ];
        });
    })();
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ function close(timeout) {
    return (0, _asyncToGenerator._)(function() {
        var client;
        return (0, _tsGenerator._)(this, function(_state) {
            client = (0, _currentScopesJs.getClient)();
            if (client) return [
                2,
                client.close(timeout)
            ];
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn('Cannot flush events and disable SDK. No client defined.');
            return [
                2,
                Promise.resolve(false)
            ];
        });
    })();
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function isInitialized() {
    return !!(0, _currentScopesJs.getClient)();
}
/** If the SDK is initialized & enabled. */ function isEnabled() {
    var client = (0, _currentScopesJs.getClient)();
    return (client === null || client === void 0 ? void 0 : client.getOptions().enabled) !== false && !!(client === null || client === void 0 ? void 0 : client.getTransport());
}
/**
 * Add an event processor.
 * This will be added to the current isolation scope, ensuring any event that is processed in the current execution
 * context will have the processor applied.
 */ function addEventProcessor(callback) {
    (0, _currentScopesJs.getIsolationScope)().addEventProcessor(callback);
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function startSession(context) {
    var isolationScope = (0, _currentScopesJs.getIsolationScope)();
    var currentScope = (0, _currentScopesJs.getCurrentScope)();
    // Will fetch userAgent if called from browser sdk
    var userAgent = ((0, _worldwideJs.GLOBAL_OBJ).navigator || {}).userAgent;
    var session = (0, _sessionJs.makeSession)((0, _objectSpread._)({
        user: currentScope.getUser() || isolationScope.getUser()
    }, userAgent && {
        userAgent: userAgent
    }, context));
    // End existing session if there's one
    var currentSession = isolationScope.getSession();
    if ((currentSession === null || currentSession === void 0 ? void 0 : currentSession.status) === 'ok') (0, _sessionJs.updateSession)(currentSession, {
        status: 'exited'
    });
    endSession();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function endSession() {
    var isolationScope = (0, _currentScopesJs.getIsolationScope)();
    var currentScope = (0, _currentScopesJs.getCurrentScope)();
    var session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, _sessionJs.closeSession)(session);
    _sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function _sendSessionUpdate() {
    var isolationScope = (0, _currentScopesJs.getIsolationScope)();
    var client = (0, _currentScopesJs.getClient)();
    var session = isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function captureSession() {
    var end = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    // both send the update and pull the session from the scope
    if (end) {
        endSession();
        return;
    }
    // only send the update
    _sendSessionUpdate();
}

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_ts_generator":"78Tqx","./currentScopes.js":"3GE4v","./debug-build.js":"ejIQP","./session.js":"7bmuG","./utils/debug-logger.js":"3X9Vf","./utils/is.js":"kSqSf","./utils/misc.js":"8kac1","./utils/prepareEvent.js":"gVd7T","./utils/time.js":"i4V6H","./utils/worldwide.js":"3qnNR","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gVd7T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applyClientOptions", function() {
    return applyClientOptions;
});
parcelHelpers.export(exports, "applyDebugIds", function() {
    return applyDebugIds;
});
parcelHelpers.export(exports, "applyDebugMeta", function() {
    return applyDebugMeta;
});
parcelHelpers.export(exports, "parseEventHintOrCaptureContext", function() {
    return parseEventHintOrCaptureContext;
});
parcelHelpers.export(exports, "prepareEvent", function() {
    return prepareEvent;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _constantsJs = require("../constants.js");
var _currentScopesJs = require("../currentScopes.js");
var _eventProcessorsJs = require("../eventProcessors.js");
var _scopeJs = require("../scope.js");
var _applyScopeDataToEventJs = require("./applyScopeDataToEvent.js");
var _debugIdsJs = require("./debug-ids.js");
var _miscJs = require("./misc.js");
var _normalizeJs = require("./normalize.js");
var _stringJs = require("./string.js");
var _timeJs = require("./time.js");
/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function prepareEvent(options, event, hint, scope, client, isolationScope) {
    var _options_normalizeDepth = options.normalizeDepth, normalizeDepth = _options_normalizeDepth === void 0 ? 3 : _options_normalizeDepth, _options_normalizeMaxBreadth = options.normalizeMaxBreadth, normalizeMaxBreadth = _options_normalizeMaxBreadth === void 0 ? 1000 : _options_normalizeMaxBreadth;
    var prepared = (0, _objectSpreadProps._)((0, _objectSpread._)({}, event), {
        event_id: event.event_id || hint.event_id || (0, _miscJs.uuid4)(),
        timestamp: event.timestamp || (0, _timeJs.dateTimestampInSeconds)()
    });
    var integrations = hint.integrations || options.integrations.map(function(i) {
        return i.name;
    });
    applyClientOptions(prepared, options);
    applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit('applyFrameMetadata', event);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) applyDebugIds(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    var finalScope = getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, _miscJs.addExceptionMechanism)(prepared, hint.mechanism);
    var clientEventProcessors = client ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Scope.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    var data = (0, _currentScopesJs.getGlobalScope)().getScopeData();
    if (isolationScope) {
        var isolationData = isolationScope.getScopeData();
        (0, _applyScopeDataToEventJs.mergeScopeData)(data, isolationData);
    }
    if (finalScope) {
        var finalScopeData = finalScope.getScopeData();
        (0, _applyScopeDataToEventJs.mergeScopeData)(data, finalScopeData);
    }
    var attachments = (0, _toConsumableArray._)(hint.attachments || []).concat((0, _toConsumableArray._)(data.attachments));
    if (attachments.length) hint.attachments = attachments;
    (0, _applyScopeDataToEventJs.applyScopeDataToEvent)(prepared, data);
    var eventProcessors = (0, _toConsumableArray._)(clientEventProcessors).concat(// Run scope event processors _after_ all other processors
    (0, _toConsumableArray._)(data.eventProcessors));
    var result = (0, _eventProcessorsJs.notifyEventProcessors)(eventProcessors, prepared, hint);
    return result.then(function(evt) {
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        applyDebugMeta(evt);
        if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 * Enhances event using the client configuration.
 * It takes care of all "static" values like environment, release and `dist`,
 * as well as truncating overly long values.
 *
 * Only exported for tests.
 *
 * @param event event instance to be enhanced
 */ function applyClientOptions(event, options) {
    var _event_exception_values, _event_exception;
    var environment = options.environment, release = options.release, dist = options.dist, maxValueLength = options.maxValueLength;
    // empty strings do not make sense for environment, release, and dist
    // so we handle them the same as if they were not provided
    event.environment = event.environment || environment || (0, _constantsJs.DEFAULT_ENVIRONMENT);
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    var request = event.request;
    if ((request === null || request === void 0 ? void 0 : request.url) && maxValueLength) request.url = (0, _stringJs.truncate)(request.url, maxValueLength);
    if (maxValueLength) (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values.forEach(function(exception) {
        if (exception.value) // Truncates error messages
        exception.value = (0, _stringJs.truncate)(exception.value, maxValueLength);
    });
}
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function applyDebugIds(event, stackParser) {
    var _event_exception_values, _event_exception;
    // Build a map of filename -> debug_id
    var filenameDebugIdMap = (0, _debugIdsJs.getFilenameToDebugIdMap)(stackParser);
    (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values.forEach(function(exception) {
        var _exception_stacktrace_frames, _exception_stacktrace;
        (_exception_stacktrace = exception.stacktrace) === null || _exception_stacktrace === void 0 ? void 0 : (_exception_stacktrace_frames = _exception_stacktrace.frames) === null || _exception_stacktrace_frames === void 0 ? void 0 : _exception_stacktrace_frames.forEach(function(frame) {
            if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
        });
    });
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function applyDebugMeta(event) {
    var _event_exception_values, _event_exception;
    // Extract debug IDs and filenames from the stack frames on the event.
    var filenameDebugIdMap = {};
    (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values.forEach(function(exception) {
        var _exception_stacktrace_frames, _exception_stacktrace;
        (_exception_stacktrace = exception.stacktrace) === null || _exception_stacktrace === void 0 ? void 0 : (_exception_stacktrace_frames = _exception_stacktrace.frames) === null || _exception_stacktrace_frames === void 0 ? void 0 : _exception_stacktrace_frames.forEach(function(frame) {
            if (frame.debug_id) {
                if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                delete frame.debug_id;
            }
        });
    });
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    var images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(function(param) {
        var _param = (0, _slicedToArray._)(param, 2), filename = _param[0], debug_id = _param[1];
        images.push({
            type: 'sourcemap',
            code_file: filename,
            debug_id: debug_id
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = (0, _toConsumableArray._)(event.sdk.integrations || []).concat((0, _toConsumableArray._)(integrationNames));
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function normalizeEvent(event, depth, maxBreadth) {
    var _event_contexts, _event_contexts1;
    if (!event) return null;
    var normalized = (0, _objectSpread._)({}, event, event.breadcrumbs && {
        breadcrumbs: event.breadcrumbs.map(function(b) {
            return (0, _objectSpread._)({}, b, b.data && {
                data: (0, _normalizeJs.normalize)(b.data, depth, maxBreadth)
            });
        })
    }, event.user && {
        user: (0, _normalizeJs.normalize)(event.user, depth, maxBreadth)
    }, event.contexts && {
        contexts: (0, _normalizeJs.normalize)(event.contexts, depth, maxBreadth)
    }, event.extra && {
        extra: (0, _normalizeJs.normalize)(event.extra, depth, maxBreadth)
    });
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (((_event_contexts = event.contexts) === null || _event_contexts === void 0 ? void 0 : _event_contexts.trace) && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, _normalizeJs.normalize)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map(function(span) {
        return (0, _objectSpread._)({}, span, span.data && {
            data: (0, _normalizeJs.normalize)(span.data, depth, maxBreadth)
        });
    });
    // event.contexts.flags (FeatureFlagContext) stores context for our feature
    // flag integrations. It has a greater nesting depth than our other typed
    // Contexts, so we re-normalize with a fixed depth of 3 here. We do not want
    // to skip this in case of conflicting, user-provided context.
    if (((_event_contexts1 = event.contexts) === null || _event_contexts1 === void 0 ? void 0 : _event_contexts1.flags) && normalized.contexts) normalized.contexts.flags = (0, _normalizeJs.normalize)(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    var finalScope = scope ? scope.clone() : new (0, _scopeJs.Scope)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function parseEventHintOrCaptureContext(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if (hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if (hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function hintIsScopeOrFunction(hint) {
    return (0, _instanceof._)(hint, (0, _scopeJs.Scope)) || typeof hint === 'function';
}
var captureContextKeys = [
    'user',
    'level',
    'extra',
    'contexts',
    'tags',
    'fingerprint',
    'propagationContext'
];
function hintIsScopeContext(hint) {
    return Object.keys(hint).some(function(key) {
        return captureContextKeys.includes(key);
    });
}

},{"@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_to_consumable_array":"1eSZf","../constants.js":"7XllJ","../currentScopes.js":"3GE4v","../eventProcessors.js":"1o4fb","../scope.js":"gbShS","./applyScopeDataToEvent.js":"jd7cV","./debug-ids.js":"luKB1","./misc.js":"8kac1","./normalize.js":"k9k7R","./string.js":"j38bn","./time.js":"i4V6H","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1o4fb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "notifyEventProcessors", function() {
    return notifyEventProcessors;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _debugBuildJs = require("./debug-build.js");
var _debugLoggerJs = require("./utils/debug-logger.js");
var _isJs = require("./utils/is.js");
var _syncpromiseJs = require("./utils/syncpromise.js");
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function notifyEventProcessors(processors, event, hint) {
    var index = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    try {
        var result = _notifyEventProcessors(event, hint, processors, index);
        return (0, _isJs.isThenable)(result) ? result : (0, _syncpromiseJs.resolvedSyncPromise)(result);
    } catch (error) {
        return (0, _syncpromiseJs.rejectedSyncPromise)(error);
    }
}
function _notifyEventProcessors(event, hint, processors, index) {
    var processor = processors[index];
    if (!event || !processor) return event;
    var result = processor((0, _objectSpread._)({}, event), hint);
    (0, _debugBuildJs.DEBUG_BUILD) && result === null && (0, _debugLoggerJs.debug).log('Event processor "'.concat(processor.id || '?', '" dropped event'));
    if ((0, _isJs.isThenable)(result)) return result.then(function(final) {
        return _notifyEventProcessors(final, hint, processors, index + 1);
    });
    return _notifyEventProcessors(result, hint, processors, index + 1);
}

},{"@swc/helpers/_/_object_spread":"9gdrV","./debug-build.js":"ejIQP","./utils/debug-logger.js":"3X9Vf","./utils/is.js":"kSqSf","./utils/syncpromise.js":"lxdDX","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lxdDX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SyncPromise", function() {
    return SyncPromise;
});
parcelHelpers.export(exports, "rejectedSyncPromise", function() {
    return rejectedSyncPromise;
});
parcelHelpers.export(exports, "resolvedSyncPromise", function() {
    return resolvedSyncPromise;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _isJs = require("./is.js");
/* eslint-disable @typescript-eslint/no-explicit-any */ /** SyncPromise internal states */ var STATE_PENDING = 0;
var STATE_RESOLVED = 1;
var STATE_REJECTED = 2;
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function resolvedSyncPromise(value) {
    return new SyncPromise(function(resolve) {
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function rejectedSyncPromise(reason) {
    return new SyncPromise(function(_, reject) {
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ var SyncPromise = /*#__PURE__*/ function() {
    "use strict";
    function SyncPromise(executor) {
        (0, _classCallCheck._)(this, SyncPromise);
        this._state = STATE_PENDING;
        this._handlers = [];
        this._runExecutor(executor);
    }
    (0, _createClass._)(SyncPromise, [
        {
            /** @inheritdoc */ key: "then",
            value: function then(onfulfilled, onrejected) {
                var _this = this;
                return new SyncPromise(function(resolve, reject) {
                    _this._handlers.push([
                        false,
                        function(result) {
                            if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                            // TODO: FIXME
                            resolve(result);
                            else try {
                                resolve(onfulfilled(result));
                            } catch (e) {
                                reject(e);
                            }
                        },
                        function(reason) {
                            if (!onrejected) reject(reason);
                            else try {
                                resolve(onrejected(reason));
                            } catch (e) {
                                reject(e);
                            }
                        }
                    ]);
                    _this._executeHandlers();
                });
            }
        },
        {
            /** @inheritdoc */ key: "catch",
            value: function _catch(onrejected) {
                return this.then(function(val) {
                    return val;
                }, onrejected);
            }
        },
        {
            /** @inheritdoc */ key: "finally",
            value: function _finally(onfinally) {
                var _this = this;
                return new SyncPromise(function(resolve, reject) {
                    var val;
                    var isRejected;
                    return _this.then(function(value) {
                        isRejected = false;
                        val = value;
                        if (onfinally) onfinally();
                    }, function(reason) {
                        isRejected = true;
                        val = reason;
                        if (onfinally) onfinally();
                    }).then(function() {
                        if (isRejected) {
                            reject(val);
                            return;
                        }
                        resolve(val);
                    });
                });
            }
        },
        {
            /** Excute the resolve/reject handlers. */ key: "_executeHandlers",
            value: function _executeHandlers() {
                var _this = this;
                if (this._state === STATE_PENDING) return;
                var cachedHandlers = this._handlers.slice();
                this._handlers = [];
                cachedHandlers.forEach(function(handler) {
                    if (handler[0]) return;
                    if (_this._state === STATE_RESOLVED) handler[1](_this._value);
                    if (_this._state === STATE_REJECTED) handler[2](_this._value);
                    handler[0] = true;
                });
            }
        },
        {
            /** Run the executor for the SyncPromise. */ key: "_runExecutor",
            value: function _runExecutor(executor) {
                var _this = this;
                var setResult = function(state, value) {
                    if (_this._state !== STATE_PENDING) return;
                    if ((0, _isJs.isThenable)(value)) {
                        value.then(resolve, reject);
                        return;
                    }
                    _this._state = state;
                    _this._value = value;
                    _this._executeHandlers();
                };
                var resolve = function(value) {
                    setResult(STATE_RESOLVED, value);
                };
                var reject = function(reason) {
                    setResult(STATE_REJECTED, reason);
                };
                try {
                    executor(resolve, reject);
                } catch (e) {
                    reject(e);
                }
            }
        }
    ]);
    return SyncPromise;
}();

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","./is.js":"kSqSf","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jd7cV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applyScopeDataToEvent", function() {
    return applyScopeDataToEvent;
});
parcelHelpers.export(exports, "mergeAndOverwriteScopeData", function() {
    return mergeAndOverwriteScopeData;
});
parcelHelpers.export(exports, "mergeScopeData", function() {
    return mergeScopeData;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _dynamicSamplingContextJs = require("../tracing/dynamicSamplingContext.js");
var _mergeJs = require("./merge.js");
var _spanUtilsJs = require("./spanUtils.js");
/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function applyScopeDataToEvent(event, data) {
    var fingerprint = data.fingerprint, span = data.span, breadcrumbs = data.breadcrumbs, sdkProcessingMetadata = data.sdkProcessingMetadata;
    // Apply general data
    applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) applySpanToEvent(event, span);
    applyFingerprintToEvent(event, fingerprint);
    applyBreadcrumbsToEvent(event, breadcrumbs);
    applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function mergeScopeData(data, mergeData) {
    var extra = mergeData.extra, tags = mergeData.tags, user = mergeData.user, contexts = mergeData.contexts, level = mergeData.level, sdkProcessingMetadata = mergeData.sdkProcessingMetadata, breadcrumbs = mergeData.breadcrumbs, fingerprint = mergeData.fingerprint, eventProcessors = mergeData.eventProcessors, attachments = mergeData.attachments, propagationContext = mergeData.propagationContext, transactionName = mergeData.transactionName, span = mergeData.span;
    mergeAndOverwriteScopeData(data, 'extra', extra);
    mergeAndOverwriteScopeData(data, 'tags', tags);
    mergeAndOverwriteScopeData(data, 'user', user);
    mergeAndOverwriteScopeData(data, 'contexts', contexts);
    data.sdkProcessingMetadata = (0, _mergeJs.merge)(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = (0, _toConsumableArray._)(data.breadcrumbs).concat((0, _toConsumableArray._)(breadcrumbs));
    if (fingerprint.length) data.fingerprint = (0, _toConsumableArray._)(data.fingerprint).concat((0, _toConsumableArray._)(fingerprint));
    if (eventProcessors.length) data.eventProcessors = (0, _toConsumableArray._)(data.eventProcessors).concat((0, _toConsumableArray._)(eventProcessors));
    if (attachments.length) data.attachments = (0, _toConsumableArray._)(data.attachments).concat((0, _toConsumableArray._)(attachments));
    data.propagationContext = (0, _objectSpread._)({}, data.propagationContext, propagationContext);
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function mergeAndOverwriteScopeData(data, prop, mergeVal) {
    data[prop] = (0, _mergeJs.merge)(data[prop], mergeVal, 1);
}
function applyDataToEvent(event, data) {
    var extra = data.extra, tags = data.tags, user = data.user, contexts = data.contexts, level = data.level, transactionName = data.transactionName;
    if (Object.keys(extra).length) event.extra = (0, _objectSpread._)({}, extra, event.extra);
    if (Object.keys(tags).length) event.tags = (0, _objectSpread._)({}, tags, event.tags);
    if (Object.keys(user).length) event.user = (0, _objectSpread._)({}, user, event.user);
    if (Object.keys(contexts).length) event.contexts = (0, _objectSpread._)({}, contexts, event.contexts);
    if (level) event.level = level;
    // transaction events get their `transaction` from the root span name
    if (transactionName && event.type !== 'transaction') event.transaction = transactionName;
}
function applyBreadcrumbsToEvent(event, breadcrumbs) {
    var mergedBreadcrumbs = (0, _toConsumableArray._)(event.breadcrumbs || []).concat((0, _toConsumableArray._)(breadcrumbs));
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = (0, _objectSpread._)({}, event.sdkProcessingMetadata, sdkProcessingMetadata);
}
function applySpanToEvent(event, span) {
    event.contexts = (0, _objectSpread._)({
        trace: (0, _spanUtilsJs.spanToTraceContext)(span)
    }, event.contexts);
    event.sdkProcessingMetadata = (0, _objectSpread._)({
        dynamicSamplingContext: (0, _dynamicSamplingContextJs.getDynamicSamplingContextFromSpan)(span)
    }, event.sdkProcessingMetadata);
    var rootSpan = (0, _spanUtilsJs.getRootSpan)(span);
    var transactionName = (0, _spanUtilsJs.spanToJSON)(rootSpan).description;
    if (transactionName && !event.transaction && event.type === 'transaction') event.transaction = transactionName;
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (!event.fingerprint.length) delete event.fingerprint;
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_to_consumable_array":"1eSZf","../tracing/dynamicSamplingContext.js":"5RiCd","./merge.js":"UyyHX","./spanUtils.js":"fPRKj","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"luKB1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDebugImagesForResources", function() {
    return getDebugImagesForResources;
});
parcelHelpers.export(exports, "getFilenameToDebugIdMap", function() {
    return getFilenameToDebugIdMap;
});
var _worldwideJs = require("./worldwide.js");
var parsedStackResults;
var lastSentryKeysCount;
var lastNativeKeysCount;
var cachedFilenameDebugIds;
/**
 * Returns a map of filenames to debug identifiers.
 * Supports both proprietary _sentryDebugIds and native _debugIds (e.g., from Vercel) formats.
 */ function getFilenameToDebugIdMap(stackParser) {
    var sentryDebugIdMap = (0, _worldwideJs.GLOBAL_OBJ)._sentryDebugIds;
    var nativeDebugIdMap = (0, _worldwideJs.GLOBAL_OBJ)._debugIds;
    if (!sentryDebugIdMap && !nativeDebugIdMap) return {};
    var sentryDebugIdKeys = sentryDebugIdMap ? Object.keys(sentryDebugIdMap) : [];
    var nativeDebugIdKeys = nativeDebugIdMap ? Object.keys(nativeDebugIdMap) : [];
    // If the count of registered globals hasn't changed since the last call, we
    // can just return the cached result.
    if (cachedFilenameDebugIds && sentryDebugIdKeys.length === lastSentryKeysCount && nativeDebugIdKeys.length === lastNativeKeysCount) return cachedFilenameDebugIds;
    lastSentryKeysCount = sentryDebugIdKeys.length;
    lastNativeKeysCount = nativeDebugIdKeys.length;
    // Build a map of filename -> debug_id from both sources
    cachedFilenameDebugIds = {};
    if (!parsedStackResults) parsedStackResults = {};
    var processDebugIds = function(debugIdKeys, debugIdMap) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = debugIdKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var debugId = debugIdMap[key];
                var result = parsedStackResults === null || parsedStackResults === void 0 ? void 0 : parsedStackResults[key];
                if (result && cachedFilenameDebugIds && debugId) {
                    // Use cached filename but update with current debug ID
                    cachedFilenameDebugIds[result[0]] = debugId;
                    // Update cached result with new debug ID
                    if (parsedStackResults) parsedStackResults[key] = [
                        result[0],
                        debugId
                    ];
                } else if (debugId) {
                    var parsedStack = stackParser(key);
                    for(var i = parsedStack.length - 1; i >= 0; i--){
                        var stackFrame = parsedStack[i];
                        var filename = stackFrame === null || stackFrame === void 0 ? void 0 : stackFrame.filename;
                        if (filename && cachedFilenameDebugIds && parsedStackResults) {
                            cachedFilenameDebugIds[filename] = debugId;
                            parsedStackResults[key] = [
                                filename,
                                debugId
                            ];
                            break;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
    if (sentryDebugIdMap) processDebugIds(sentryDebugIdKeys, sentryDebugIdMap);
    // Native _debugIds will override _sentryDebugIds if same file
    if (nativeDebugIdMap) processDebugIds(nativeDebugIdKeys, nativeDebugIdMap);
    return cachedFilenameDebugIds;
}
/**
 * Returns a list of debug images for the given resources.
 */ function getDebugImagesForResources(stackParser, resource_paths) {
    var filenameDebugIdMap = getFilenameToDebugIdMap(stackParser);
    if (!filenameDebugIdMap) return [];
    var images = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = resource_paths[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var path = _step.value;
            if (path && filenameDebugIdMap[path]) images.push({
                type: 'sourcemap',
                code_file: path,
                debug_id: filenameDebugIdMap[path]
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return images;
}

},{"./worldwide.js":"3qnNR","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9GGAx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getEnvelopeEndpointWithUrlEncodedAuth", function() {
    return getEnvelopeEndpointWithUrlEncodedAuth;
});
parcelHelpers.export(exports, "getReportDialogEndpoint", function() {
    return getReportDialogEndpoint;
});
var _dsnJs = require("./utils/dsn.js");
var SENTRY_API_VERSION = '7';
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function getBaseApiEndpoint(dsn) {
    var protocol = dsn.protocol ? "".concat(dsn.protocol, ":") : '';
    var port = dsn.port ? ":".concat(dsn.port) : '';
    return "".concat(protocol, "//").concat(dsn.host).concat(port).concat(dsn.path ? "/".concat(dsn.path) : '', "/api/");
}
/** Returns the ingest API endpoint for target. */ function _getIngestEndpoint(dsn) {
    return "".concat(getBaseApiEndpoint(dsn)).concat(dsn.projectId, "/envelope/");
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function _encodedAuth(dsn, sdkInfo) {
    var params = {
        sentry_version: SENTRY_API_VERSION
    };
    if (dsn.publicKey) // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    params.sentry_key = dsn.publicKey;
    if (sdkInfo) params.sentry_client = "".concat(sdkInfo.name, "/").concat(sdkInfo.version);
    return new URLSearchParams(params).toString();
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function getEnvelopeEndpointWithUrlEncodedAuth(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : "".concat(_getIngestEndpoint(dsn), "?").concat(_encodedAuth(dsn, sdkInfo));
}
/** Returns the url to the report dialog endpoint. */ function getReportDialogEndpoint(dsnLike, dialogOptions) {
    var dsn = (0, _dsnJs.makeDsn)(dsnLike);
    if (!dsn) return '';
    var endpoint = "".concat(getBaseApiEndpoint(dsn), "embed/error-page/");
    var encodedOptions = "dsn=".concat((0, _dsnJs.dsnToString)(dsn));
    for(var key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'onClose') continue;
        if (key === 'user') {
            var user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += "&name=".concat(encodeURIComponent(user.name));
            if (user.email) encodedOptions += "&email=".concat(encodeURIComponent(user.email));
        } else encodedOptions += "&".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(dialogOptions[key]));
    }
    return "".concat(endpoint, "?").concat(encodedOptions);
}

},{"./utils/dsn.js":"jNv3f","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"f0QJY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Client", function() {
    return Client;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _apiJs = require("./api.js");
var _constantsJs = require("./constants.js");
var _currentScopesJs = require("./currentScopes.js");
var _debugBuildJs = require("./debug-build.js");
var _envelopeJs = require("./envelope.js");
var _integrationJs = require("./integration.js");
var _internalJs = require("./logs/internal.js");
var _internalJs1 = require("./metrics/internal.js");
var _sessionJs = require("./session.js");
var _dynamicSamplingContextJs = require("./tracing/dynamicSamplingContext.js");
var _baseJs = require("./transports/base.js");
var _clientreportJs = require("./utils/clientreport.js");
var _debugLoggerJs = require("./utils/debug-logger.js");
var _dsnJs = require("./utils/dsn.js");
var _envelopeJs1 = require("./utils/envelope.js");
var _eventUtilsJs = require("./utils/eventUtils.js");
var _isJs = require("./utils/is.js");
var _mergeJs = require("./utils/merge.js");
var _miscJs = require("./utils/misc.js");
var _parseSampleRateJs = require("./utils/parseSampleRate.js");
var _prepareEventJs = require("./utils/prepareEvent.js");
var _promisebufferJs = require("./utils/promisebuffer.js");
var _shouldIgnoreSpanJs = require("./utils/should-ignore-span.js");
var _spanUtilsJs = require("./utils/spanUtils.js");
var _syncpromiseJs = require("./utils/syncpromise.js");
var _transactionEventJs = require("./utils/transactionEvent.js");
/* eslint-disable max-lines */ var ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
var MISSING_RELEASE_FOR_SESSION_ERROR = 'Discarded session because of missing or non-string release';
var INTERNAL_ERROR_SYMBOL = Symbol.for('SentryInternalError');
var DO_NOT_SEND_EVENT_SYMBOL = Symbol.for('SentryDoNotSendEventError');
// Default interval for flushing logs and metrics (5 seconds)
var DEFAULT_FLUSH_INTERVAL = 5000;
function _makeInternalError(message) {
    return (0, _defineProperty._)({
        message: message
    }, INTERNAL_ERROR_SYMBOL, true);
}
function _makeDoNotSendEventError(message) {
    return (0, _defineProperty._)({
        message: message
    }, DO_NOT_SEND_EVENT_SYMBOL, true);
}
function _isInternalError(error) {
    return !!error && (typeof error === "undefined" ? "undefined" : (0, _typeOf._)(error)) === 'object' && INTERNAL_ERROR_SYMBOL in error;
}
function _isDoNotSendEventError(error) {
    return !!error && (typeof error === "undefined" ? "undefined" : (0, _typeOf._)(error)) === 'object' && DO_NOT_SEND_EVENT_SYMBOL in error;
}
/**
 * Sets up weight-based flushing for logs or metrics.
 * This helper function encapsulates the common pattern of:
 * 1. Tracking accumulated weight of items
 * 2. Flushing when weight exceeds threshold (800KB)
 * 3. Flushing after timeout period from the first item
 *
 * Uses closure variables to track weight and timeout state.
 */ function setupWeightBasedFlushing(client, afterCaptureHook, flushHook, estimateSizeFn, flushFn) {
    // Track weight and timeout in closure variables
    var weight = 0;
    var flushTimeout;
    var isTimerActive = false;
    // @ts-expect-error - TypeScript can't narrow generic hook types to match specific overloads, but we know this is type-safe
    client.on(flushHook, function() {
        weight = 0;
        clearTimeout(flushTimeout);
        isTimerActive = false;
    });
    // @ts-expect-error - TypeScript can't narrow generic hook types to match specific overloads, but we know this is type-safe
    client.on(afterCaptureHook, function(item) {
        weight += estimateSizeFn(item);
        // We flush the buffer if it exceeds 0.8 MB
        // The weight is a rough estimate, so we flush way before the payload gets too big.
        if (weight >= 800000) flushFn(client);
        else if (!isTimerActive) {
            // Only start timer if one isn't already running.
            // This prevents flushing being delayed by items that arrive close to the timeout limit
            // and thus resetting the flushing timeout and delaying items being flushed.
            isTimerActive = true;
            flushTimeout = setTimeout(function() {
                flushFn(client);
            // Note: isTimerActive is reset by the flushHook handler above, not here,
            // to avoid race conditions when new items arrive during the flush.
            }, DEFAULT_FLUSH_INTERVAL);
        }
    });
    client.on('flush', function() {
        flushFn(client);
    });
}
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link Client._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends Client<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ var Client = /*#__PURE__*/ function() {
    "use strict";
    function Client(options) {
        (0, _classCallCheck._)(this, Client);
        var _options_transportOptions, _this__options__experiments, _this__options__experiments1;
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        var _options_transportOptions_bufferSize;
        this._promiseBuffer = (0, _promisebufferJs.makePromiseBuffer)((_options_transportOptions_bufferSize = (_options_transportOptions = options.transportOptions) === null || _options_transportOptions === void 0 ? void 0 : _options_transportOptions.bufferSize) !== null && _options_transportOptions_bufferSize !== void 0 ? _options_transportOptions_bufferSize : (0, _baseJs.DEFAULT_TRANSPORT_BUFFER_SIZE));
        if (options.dsn) this._dsn = (0, _dsnJs.makeDsn)(options.dsn);
        else (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn('No DSN provided, client will not send events.');
        if (this._dsn) {
            var url = (0, _apiJs.getEnvelopeEndpointWithUrlEncodedAuth)(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : undefined);
            this._transport = options.transport((0, _objectSpreadProps._)((0, _objectSpread._)({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this)
            }, options.transportOptions), {
                url: url
            }));
        }
        var _this__options_enableLogs;
        // Backfill enableLogs option from _experiments.enableLogs
        // TODO(v11): Remove or change default value
        // eslint-disable-next-line deprecation/deprecation
        this._options.enableLogs = (_this__options_enableLogs = this._options.enableLogs) !== null && _this__options_enableLogs !== void 0 ? _this__options_enableLogs : (_this__options__experiments = this._options._experiments) === null || _this__options__experiments === void 0 ? void 0 : _this__options__experiments.enableLogs;
        // Setup log flushing with weight and timeout tracking
        if (this._options.enableLogs) setupWeightBasedFlushing(this, 'afterCaptureLog', 'flushLogs', estimateLogSizeInBytes, (0, _internalJs._INTERNAL_flushLogsBuffer));
        var _this__options_enableMetrics, _ref;
        // todo(v11): Remove the experimental flag
        // eslint-disable-next-line deprecation/deprecation
        var enableMetrics = (_ref = (_this__options_enableMetrics = this._options.enableMetrics) !== null && _this__options_enableMetrics !== void 0 ? _this__options_enableMetrics : (_this__options__experiments1 = this._options._experiments) === null || _this__options__experiments1 === void 0 ? void 0 : _this__options__experiments1.enableMetrics) !== null && _ref !== void 0 ? _ref : true;
        // Setup metric flushing with weight and timeout tracking
        if (enableMetrics) setupWeightBasedFlushing(this, 'afterCaptureMetric', 'flushMetrics', estimateMetricSizeInBytes, (0, _internalJs1._INTERNAL_flushMetricsBuffer));
    }
    (0, _createClass._)(Client, [
        {
            /**
   * Captures an exception event and sends it to Sentry.
   *
   * Unlike `captureException` exported from every SDK, this method requires that you pass it the current scope.
   */ key: "captureException",
            value: function captureException(exception, hint, scope) {
                var _this = this;
                var eventId = (0, _miscJs.uuid4)();
                // ensure we haven't captured this very object before
                if ((0, _miscJs.checkOrSetAlreadyCaught)(exception)) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log(ALREADY_SEEN_ERROR);
                    return eventId;
                }
                var hintWithEventId = (0, _objectSpread._)({
                    event_id: eventId
                }, hint);
                this._process(function() {
                    return _this.eventFromException(exception, hintWithEventId).then(function(event) {
                        return _this._captureEvent(event, hintWithEventId, scope);
                    }).then(function(res) {
                        return res;
                    });
                }, 'error');
                return hintWithEventId.event_id;
            }
        },
        {
            /**
   * Captures a message event and sends it to Sentry.
   *
   * Unlike `captureMessage` exported from every SDK, this method requires that you pass it the current scope.
   */ key: "captureMessage",
            value: function captureMessage(message, level, hint, currentScope) {
                var _this = this;
                var hintWithEventId = (0, _objectSpread._)({
                    event_id: (0, _miscJs.uuid4)()
                }, hint);
                var eventMessage = (0, _isJs.isParameterizedString)(message) ? message : String(message);
                var isMessage = (0, _isJs.isPrimitive)(message);
                var promisedEvent = isMessage ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
                this._process(function() {
                    return promisedEvent.then(function(event) {
                        return _this._captureEvent(event, hintWithEventId, currentScope);
                    });
                }, isMessage ? 'unknown' : 'error');
                return hintWithEventId.event_id;
            }
        },
        {
            /**
   * Captures a manually created event and sends it to Sentry.
   *
   * Unlike `captureEvent` exported from every SDK, this method requires that you pass it the current scope.
   */ key: "captureEvent",
            value: function captureEvent(event, hint, currentScope) {
                var _this = this;
                var eventId = (0, _miscJs.uuid4)();
                // ensure we haven't captured this very object before
                if ((hint === null || hint === void 0 ? void 0 : hint.originalException) && (0, _miscJs.checkOrSetAlreadyCaught)(hint.originalException)) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log(ALREADY_SEEN_ERROR);
                    return eventId;
                }
                var hintWithEventId = (0, _objectSpread._)({
                    event_id: eventId
                }, hint);
                var sdkProcessingMetadata = event.sdkProcessingMetadata || {};
                var capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
                var capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
                var dataCategory = getDataCategoryByType(event.type);
                this._process(function() {
                    return _this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope, capturedSpanIsolationScope);
                }, dataCategory);
                return hintWithEventId.event_id;
            }
        },
        {
            /**
   * Captures a session.
   */ key: "captureSession",
            value: function captureSession(session) {
                this.sendSession(session);
                // After sending, we set init false to indicate it's not the first occurrence
                (0, _sessionJs.updateSession)(session, {
                    init: false
                });
            }
        },
        {
            /**
   * Create a cron monitor check in and send it to Sentry. This method is not available on all clients.
   *
   * @param checkIn An object that describes a check in.
   * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
   * to create a monitor automatically when sending a check in.
   * @param scope An optional scope containing event metadata.
   * @returns A string representing the id of the check in.
   */ /**
   * Get the current Dsn.
   */ key: "getDsn",
            value: function getDsn() {
                return this._dsn;
            }
        },
        {
            /**
   * Get the current options.
   */ key: "getOptions",
            value: function getOptions() {
                return this._options;
            }
        },
        {
            /**
   * Get the SDK metadata.
   * @see SdkMetadata
   */ key: "getSdkMetadata",
            value: function getSdkMetadata() {
                return this._options._metadata;
            }
        },
        {
            /**
   * Returns the transport that is used by the client.
   * Please note that the transport gets lazy initialized so it will only be there once the first event has been sent.
   */ key: "getTransport",
            value: function getTransport() {
                return this._transport;
            }
        },
        {
            key: "flush",
            value: /**
   * Wait for all events to be sent or the timeout to expire, whichever comes first.
   *
   * @param timeout Maximum time in ms the client should wait for events to be flushed. Omitting this parameter will
   *   cause the client to wait until all events are sent before resolving the promise.
   * @returns A promise that will resolve with `true` if all events are sent before the timeout, or `false` if there are
   * still events in the queue when the timeout is reached.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
            function flush(timeout) {
                return (0, _asyncToGenerator._)(function() {
                    var transport, clientFinished, transportFlushed;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                transport = this._transport;
                                if (!transport) return [
                                    2,
                                    true
                                ];
                                this.emit('flush');
                                return [
                                    4,
                                    this._isClientDoneProcessing(timeout)
                                ];
                            case 1:
                                clientFinished = _state.sent();
                                return [
                                    4,
                                    transport.flush(timeout)
                                ];
                            case 2:
                                transportFlushed = _state.sent();
                                return [
                                    2,
                                    clientFinished && transportFlushed
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "close",
            value: /**
   * Flush the event queue and set the client to `enabled = false`. See {@link Client.flush}.
   *
   * @param {number} timeout Maximum time in ms the client should wait before shutting down. Omitting this parameter will cause
   *   the client to wait until all events are sent before disabling itself.
   * @returns {Promise<boolean>} A promise which resolves to `true` if the flush completes successfully before the timeout, or `false` if
   * it doesn't.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
            function close(timeout) {
                return (0, _asyncToGenerator._)(function() {
                    var result;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.flush(timeout)
                                ];
                            case 1:
                                result = _state.sent();
                                this.getOptions().enabled = false;
                                this.emit('close');
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
   * Get all installed event processors.
   */ key: "getEventProcessors",
            value: function getEventProcessors() {
                return this._eventProcessors;
            }
        },
        {
            /**
   * Adds an event processor that applies to any event processed by this client.
   */ key: "addEventProcessor",
            value: function addEventProcessor(eventProcessor) {
                this._eventProcessors.push(eventProcessor);
            }
        },
        {
            /**
   * Initialize this client.
   * Call this after the client was set on a scope.
   */ key: "init",
            value: function init() {
                if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
                // Spotlight enabled. This is particularly important for browser as we
                // don't support the `spotlight` option there and rely on the users
                // adding the `spotlightBrowserIntegration()` to their integrations which
                // wouldn't get initialized with the check below when there's no DSN set.
                this._options.integrations.some(function(param) {
                    var name = param.name;
                    return name.startsWith('Spotlight');
                })) this._setupIntegrations();
            }
        },
        {
            /**
   * Gets an installed integration by its name.
   *
   * @returns {Integration|undefined} The installed integration or `undefined` if no integration with that `name` was installed.
   */ key: "getIntegrationByName",
            value: function getIntegrationByName(integrationName) {
                return this._integrations[integrationName];
            }
        },
        {
            /**
   * Add an integration to the client.
   * This can be used to e.g. lazy load integrations.
   * In most cases, this should not be necessary,
   * and you're better off just passing the integrations via `integrations: []` at initialization time.
   * However, if you find the need to conditionally load & add an integration, you can use `addIntegration` to do so.
   */ key: "addIntegration",
            value: function addIntegration(integration) {
                var isAlreadyInstalled = this._integrations[integration.name];
                // This hook takes care of only installing if not already installed
                (0, _integrationJs.setupIntegration)(this, integration, this._integrations);
                // Here we need to check manually to make sure to not run this multiple times
                if (!isAlreadyInstalled) (0, _integrationJs.afterSetupIntegrations)(this, [
                    integration
                ]);
            }
        },
        {
            /**
   * Send a fully prepared event to Sentry.
   */ key: "sendEvent",
            value: function sendEvent(event) {
                var _this = this;
                var hint = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                this.emit('beforeSendEvent', event, hint);
                var env = (0, _envelopeJs.createEventEnvelope)(event, this._dsn, this._options._metadata, this._options.tunnel);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (hint.attachments || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var attachment = _step.value;
                        env = (0, _envelopeJs1.addItemToEnvelope)(env, (0, _envelopeJs1.createAttachmentEnvelopeItem)(attachment));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                // sendEnvelope should not throw
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.sendEnvelope(env).then(function(sendResponse) {
                    return _this.emit('afterSendEvent', event, sendResponse);
                });
            }
        },
        {
            /**
   * Send a session or session aggregrates to Sentry.
   */ key: "sendSession",
            value: function sendSession(session) {
                // Backfill release and environment on session
                var _this__options = this._options, clientReleaseOption = _this__options.release, tmp = _this__options.environment, clientEnvironmentOption = tmp === void 0 ? (0, _constantsJs.DEFAULT_ENVIRONMENT) : tmp;
                if ('aggregates' in session) {
                    var sessionAttrs = session.attrs || {};
                    if (!sessionAttrs.release && !clientReleaseOption) {
                        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn(MISSING_RELEASE_FOR_SESSION_ERROR);
                        return;
                    }
                    sessionAttrs.release = sessionAttrs.release || clientReleaseOption;
                    sessionAttrs.environment = sessionAttrs.environment || clientEnvironmentOption;
                    session.attrs = sessionAttrs;
                } else {
                    if (!session.release && !clientReleaseOption) {
                        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn(MISSING_RELEASE_FOR_SESSION_ERROR);
                        return;
                    }
                    session.release = session.release || clientReleaseOption;
                    session.environment = session.environment || clientEnvironmentOption;
                }
                this.emit('beforeSendSession', session);
                var env = (0, _envelopeJs.createSessionEnvelope)(session, this._dsn, this._options._metadata, this._options.tunnel);
                // sendEnvelope should not throw
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.sendEnvelope(env);
            }
        },
        {
            /**
   * Record on the client that an event got dropped (ie, an event that will not be sent to Sentry).
   */ key: "recordDroppedEvent",
            value: function recordDroppedEvent(reason, category) {
                var count = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
                if (this._options.sendClientReports) {
                    // We want to track each category (error, transaction, session, replay_event) separately
                    // but still keep the distinction between different type of outcomes.
                    // We could use nested maps, but it's much easier to read and type this way.
                    // A correct type for map-based implementation if we want to go that route
                    // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
                    // With typescript 4.1 we could even use template literal types
                    var key = "".concat(reason, ":").concat(category);
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log('Recording outcome: "'.concat(key, '"').concat(count > 1 ? " (".concat(count, " times)") : ''));
                    this._outcomes[key] = (this._outcomes[key] || 0) + count;
                }
            }
        },
        {
            /* eslint-disable @typescript-eslint/unified-signatures */ /**
   * Register a callback for whenever a span is started.
   * Receives the span as argument.
   * @returns {() => void} A function that, when executed, removes the registered callback.
   */ /**
   * Register a hook on this client.
   */ key: "on",
            value: function on(hook, callback) {
                var hookCallbacks = this._hooks[hook] = this._hooks[hook] || new Set();
                // Wrap the callback in a function so that registering the same callback instance multiple
                // times results in the callback being called multiple times.
                // @ts-expect-error - The `callback` type is correct and must be a function due to the
                // individual, specific overloads of this function.
                // eslint-disable-next-line @typescript-eslint/ban-types
                var uniqueCallback = function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    return callback.apply(void 0, (0, _toConsumableArray._)(args));
                };
                hookCallbacks.add(uniqueCallback);
                // This function returns a callback execution handler that, when invoked,
                // deregisters a callback. This is crucial for managing instances where callbacks
                // need to be unregistered to prevent self-referencing in callback closures,
                // ensuring proper garbage collection.
                return function() {
                    hookCallbacks.delete(uniqueCallback);
                };
            }
        },
        {
            /** Fire a hook whenever a span starts. */ /**
   * Emit a hook that was previously registered via `on()`.
   */ key: "emit",
            value: function emit(hook) {
                for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    rest[_key - 1] = arguments[_key];
                }
                var callbacks = this._hooks[hook];
                if (callbacks) callbacks.forEach(function(callback) {
                    return callback.apply(void 0, (0, _toConsumableArray._)(rest));
                });
            }
        },
        {
            key: "sendEnvelope",
            value: /**
   * Send an envelope to Sentry.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
            function sendEnvelope(envelope) {
                return (0, _asyncToGenerator._)(function() {
                    var reason;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                this.emit('beforeEnvelope', envelope);
                                if (!(this._isEnabled() && this._transport)) return [
                                    3,
                                    4
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    this._transport.send(envelope)
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 3:
                                reason = _state.sent();
                                (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).error('Error while sending envelope:', reason);
                                return [
                                    2,
                                    {}
                                ];
                            case 4:
                                (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).error('Transport disabled');
                                return [
                                    2,
                                    {}
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ key: "_setupIntegrations",
            value: function _setupIntegrations() {
                var integrations = this._options.integrations;
                this._integrations = (0, _integrationJs.setupIntegrations)(this, integrations);
                (0, _integrationJs.afterSetupIntegrations)(this, integrations);
            }
        },
        {
            /** Updates existing session based on the provided event */ key: "_updateSessionFromEvent",
            value: function _updateSessionFromEvent(session, event) {
                var _event_exception;
                // initially, set `crashed` based on the event level and update from exceptions if there are any later on
                var crashed = event.level === 'fatal';
                var errored = false;
                var exceptions = (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : _event_exception.values;
                if (exceptions) {
                    var _ex_mechanism;
                    errored = true;
                    // reset crashed to false if there are exceptions, to ensure `mechanism.handled` is respected.
                    crashed = false;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = exceptions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var ex = _step.value;
                            if (((_ex_mechanism = ex.mechanism) === null || _ex_mechanism === void 0 ? void 0 : _ex_mechanism.handled) === false) {
                                crashed = true;
                                break;
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                // A session is updated and that session update is sent in only one of the two following scenarios:
                // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
                // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
                var sessionNonTerminal = session.status === 'ok';
                var shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
                if (shouldUpdateAndSend) {
                    (0, _sessionJs.updateSession)(session, (0, _objectSpreadProps._)((0, _objectSpread._)({}, crashed && {
                        status: 'crashed'
                    }), {
                        errors: session.errors || Number(errored || crashed)
                    }));
                    this.captureSession(session);
                }
            }
        },
        {
            key: "_isClientDoneProcessing",
            value: /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ function _isClientDoneProcessing(timeout) {
                return (0, _asyncToGenerator._)(function() {
                    var ticked;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                ticked = 0;
                                _state.label = 1;
                            case 1:
                                if (!(!timeout || ticked < timeout)) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    new Promise(function(resolve) {
                                        return setTimeout(resolve, 1);
                                    })
                                ];
                            case 2:
                                _state.sent();
                                if (!this._numProcessing) return [
                                    2,
                                    true
                                ];
                                ticked++;
                                return [
                                    3,
                                    1
                                ];
                            case 3:
                                return [
                                    2,
                                    false
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /** Determines whether this SDK is enabled and a transport is present. */ key: "_isEnabled",
            value: function _isEnabled() {
                return this.getOptions().enabled !== false && this._transport !== undefined;
            }
        },
        {
            /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ key: "_prepareEvent",
            value: function _prepareEvent(event, hint, currentScope, isolationScope) {
                var _this = this;
                var options = this.getOptions();
                var integrations = Object.keys(this._integrations);
                if (!hint.integrations && (integrations === null || integrations === void 0 ? void 0 : integrations.length)) hint.integrations = integrations;
                this.emit('preprocessEvent', event, hint);
                if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
                return (0, _prepareEventJs.prepareEvent)(options, event, hint, currentScope, this, isolationScope).then(function(evt) {
                    if (evt === null) return evt;
                    _this.emit('postprocessEvent', evt, hint);
                    evt.contexts = (0, _objectSpread._)({
                        trace: (0, _currentScopesJs.getTraceContextFromScope)(currentScope)
                    }, evt.contexts);
                    var dynamicSamplingContext = (0, _dynamicSamplingContextJs.getDynamicSamplingContextFromScope)(_this, currentScope);
                    evt.sdkProcessingMetadata = (0, _objectSpread._)({
                        dynamicSamplingContext: dynamicSamplingContext
                    }, evt.sdkProcessingMetadata);
                    return evt;
                });
            }
        },
        {
            /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ key: "_captureEvent",
            value: function _captureEvent(event) {
                var hint = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, currentScope = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, _currentScopesJs.getCurrentScope)(), isolationScope = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : (0, _currentScopesJs.getIsolationScope)();
                if ((0, _debugBuildJs.DEBUG_BUILD) && isErrorEvent(event)) (0, _debugLoggerJs.debug).log("Captured error event `".concat((0, _eventUtilsJs.getPossibleEventMessages)(event)[0] || '<unknown>', "`"));
                return this._processEvent(event, hint, currentScope, isolationScope).then(function(finalEvent) {
                    return finalEvent.event_id;
                }, function(reason) {
                    if (0, _debugBuildJs.DEBUG_BUILD) {
                        if (_isDoNotSendEventError(reason)) (0, _debugLoggerJs.debug).log(reason.message);
                        else if (_isInternalError(reason)) (0, _debugLoggerJs.debug).warn(reason.message);
                        else (0, _debugLoggerJs.debug).warn(reason);
                    }
                    return undefined;
                });
            }
        },
        {
            /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ key: "_processEvent",
            value: function _processEvent(event, hint, currentScope, isolationScope) {
                var _this = this;
                var options = this.getOptions();
                var sampleRate = options.sampleRate;
                var isTransaction = isTransactionEvent(event);
                var isError = isErrorEvent(event);
                var eventType = event.type || 'error';
                var beforeSendLabel = "before send for type `".concat(eventType, "`");
                // 1.0 === 100% events are sent
                // 0.0 === 0% events are sent
                // Sampling for transaction happens somewhere else
                var parsedSampleRate = typeof sampleRate === 'undefined' ? undefined : (0, _parseSampleRateJs.parseSampleRate)(sampleRate);
                if (isError && typeof parsedSampleRate === 'number' && Math.random() > parsedSampleRate) {
                    this.recordDroppedEvent('sample_rate', 'error');
                    return (0, _syncpromiseJs.rejectedSyncPromise)(_makeDoNotSendEventError("Discarding event because it's not included in the random sample (sampling rate = ".concat(sampleRate, ")")));
                }
                var dataCategory = getDataCategoryByType(event.type);
                return this._prepareEvent(event, hint, currentScope, isolationScope).then(function(prepared) {
                    if (prepared === null) {
                        _this.recordDroppedEvent('event_processor', dataCategory);
                        throw _makeDoNotSendEventError('An event processor returned `null`, will not send event.');
                    }
                    var isInternalException = hint.data && hint.data.__sentry__ === true;
                    if (isInternalException) return prepared;
                    var result = processBeforeSend(_this, options, prepared, hint);
                    return _validateBeforeSendResult(result, beforeSendLabel);
                }).then(function(processedEvent) {
                    if (processedEvent === null) {
                        _this.recordDroppedEvent('before_send', dataCategory);
                        if (isTransaction) {
                            var spans = event.spans || [];
                            // the transaction itself counts as one span, plus all the child spans that are added
                            var spanCount = 1 + spans.length;
                            _this.recordDroppedEvent('before_send', 'span', spanCount);
                        }
                        throw _makeDoNotSendEventError("".concat(beforeSendLabel, " returned `null`, will not send event."));
                    }
                    var session = currentScope.getSession() || isolationScope.getSession();
                    if (isError && session) _this._updateSessionFromEvent(session, processedEvent);
                    if (isTransaction) {
                        var _processedEvent_sdkProcessingMetadata;
                        var spanCountBefore = ((_processedEvent_sdkProcessingMetadata = processedEvent.sdkProcessingMetadata) === null || _processedEvent_sdkProcessingMetadata === void 0 ? void 0 : _processedEvent_sdkProcessingMetadata.spanCountBeforeProcessing) || 0;
                        var spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                        var droppedSpanCount = spanCountBefore - spanCountAfter;
                        if (droppedSpanCount > 0) _this.recordDroppedEvent('before_send', 'span', droppedSpanCount);
                    }
                    // None of the Sentry built event processor will update transaction name,
                    // so if the transaction name has been changed by an event processor, we know
                    // it has to come from custom event processor added by a user
                    var transactionInfo = processedEvent.transaction_info;
                    if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                        var source = 'custom';
                        processedEvent.transaction_info = (0, _objectSpreadProps._)((0, _objectSpread._)({}, transactionInfo), {
                            source: source
                        });
                    }
                    _this.sendEvent(processedEvent, hint);
                    return processedEvent;
                }).then(null, function(reason) {
                    if (_isDoNotSendEventError(reason) || _isInternalError(reason)) throw reason;
                    _this.captureException(reason, {
                        mechanism: {
                            handled: false,
                            type: 'internal'
                        },
                        data: {
                            __sentry__: true
                        },
                        originalException: reason
                    });
                    throw _makeInternalError("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ".concat(reason));
                });
            }
        },
        {
            /**
   * Occupies the client with processing and event
   */ key: "_process",
            value: function _process(taskProducer, dataCategory) {
                var _this = this;
                this._numProcessing++;
                this._promiseBuffer.add(taskProducer).then(function(value) {
                    _this._numProcessing--;
                    return value;
                }, function(reason) {
                    _this._numProcessing--;
                    if (reason === (0, _promisebufferJs.SENTRY_BUFFER_FULL_ERROR)) _this.recordDroppedEvent('queue_overflow', dataCategory);
                    return reason;
                });
            }
        },
        {
            /**
   * Clears outcomes on this client and returns them.
   */ key: "_clearOutcomes",
            value: function _clearOutcomes() {
                var outcomes = this._outcomes;
                this._outcomes = {};
                return Object.entries(outcomes).map(function(param) {
                    var _param = (0, _slicedToArray._)(param, 2), key = _param[0], quantity = _param[1];
                    var _key_split = (0, _slicedToArray._)(key.split(':'), 2), reason = _key_split[0], category = _key_split[1];
                    return {
                        reason: reason,
                        category: category,
                        quantity: quantity
                    };
                });
            }
        },
        {
            /**
   * Sends client reports as an envelope.
   */ key: "_flushOutcomes",
            value: function _flushOutcomes() {
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log('Flushing outcomes...');
                var outcomes = this._clearOutcomes();
                if (outcomes.length === 0) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log('No outcomes to send');
                    return;
                }
                // This is really the only place where we want to check for a DSN and only send outcomes then
                if (!this._dsn) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log('No dsn provided, will not send outcomes');
                    return;
                }
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log('Sending outcomes:', outcomes);
                var envelope = (0, _clientreportJs.createClientReportEnvelope)(outcomes, this._options.tunnel && (0, _dsnJs.dsnToString)(this._dsn));
                // sendEnvelope should not throw
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.sendEnvelope(envelope);
            }
        }
    ]);
    return Client;
}();
function getDataCategoryByType(type) {
    return type === 'replay_event' ? 'replay' : type || 'error';
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function _validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    var invalidValueError = "".concat(beforeSendLabel, " must return `null` or a valid event.");
    if ((0, _isJs.isThenable)(beforeSendResult)) return beforeSendResult.then(function(event) {
        if (!(0, _isJs.isPlainObject)(event) && event !== null) throw _makeInternalError(invalidValueError);
        return event;
    }, function(e) {
        throw _makeInternalError("".concat(beforeSendLabel, " rejected with ").concat(e));
    });
    else if (!(0, _isJs.isPlainObject)(beforeSendResult) && beforeSendResult !== null) throw _makeInternalError(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function processBeforeSend(client, options, event, hint) {
    var beforeSend = options.beforeSend, beforeSendTransaction = options.beforeSendTransaction, beforeSendSpan = options.beforeSendSpan, ignoreSpans = options.ignoreSpans;
    var processedEvent = event;
    if (isErrorEvent(processedEvent) && beforeSend) return beforeSend(processedEvent, hint);
    if (isTransactionEvent(processedEvent)) {
        // Avoid processing if we don't have to
        if (beforeSendSpan || ignoreSpans) {
            // 1. Process root span
            var rootSpanJson = (0, _transactionEventJs.convertTransactionEventToSpanJson)(processedEvent);
            // 1.1 If the root span should be ignored, drop the whole transaction
            if ((ignoreSpans === null || ignoreSpans === void 0 ? void 0 : ignoreSpans.length) && (0, _shouldIgnoreSpanJs.shouldIgnoreSpan)(rootSpanJson, ignoreSpans)) // dropping the whole transaction!
            return null;
            // 1.2 If a `beforeSendSpan` callback is defined, process the root span
            if (beforeSendSpan) {
                var processedRootSpanJson = beforeSendSpan(rootSpanJson);
                if (!processedRootSpanJson) (0, _spanUtilsJs.showSpanDropWarning)();
                else // update event with processed root span values
                processedEvent = (0, _mergeJs.merge)(event, (0, _transactionEventJs.convertSpanJsonToTransactionEvent)(processedRootSpanJson));
            }
            // 2. Process child spans
            if (processedEvent.spans) {
                var processedSpans = [];
                var initialSpans = processedEvent.spans;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = initialSpans[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var span = _step.value;
                        // 2.a If the child span should be ignored, reparent it to the root span
                        if ((ignoreSpans === null || ignoreSpans === void 0 ? void 0 : ignoreSpans.length) && (0, _shouldIgnoreSpanJs.shouldIgnoreSpan)(span, ignoreSpans)) {
                            (0, _shouldIgnoreSpanJs.reparentChildSpans)(initialSpans, span);
                            continue;
                        }
                        // 2.b If a `beforeSendSpan` callback is defined, process the child span
                        if (beforeSendSpan) {
                            var processedSpan = beforeSendSpan(span);
                            if (!processedSpan) {
                                (0, _spanUtilsJs.showSpanDropWarning)();
                                processedSpans.push(span);
                            } else processedSpans.push(processedSpan);
                        } else processedSpans.push(span);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var droppedSpans = processedEvent.spans.length - processedSpans.length;
                if (droppedSpans) client.recordDroppedEvent('before_send', 'span', droppedSpans);
                processedEvent.spans = processedSpans;
            }
        }
        if (beforeSendTransaction) {
            if (processedEvent.spans) {
                // We store the # of spans before processing in SDK metadata,
                // so we can compare it afterwards to determine how many spans were dropped
                var spanCountBefore = processedEvent.spans.length;
                processedEvent.sdkProcessingMetadata = (0, _objectSpreadProps._)((0, _objectSpread._)({}, event.sdkProcessingMetadata), {
                    spanCountBeforeProcessing: spanCountBefore
                });
            }
            return beforeSendTransaction(processedEvent, hint);
        }
    }
    return processedEvent;
}
function isErrorEvent(event) {
    return event.type === undefined;
}
function isTransactionEvent(event) {
    return event.type === 'transaction';
}
/**
 * Estimate the size of a metric in bytes.
 *
 * @param metric - The metric to estimate the size of.
 * @returns The estimated size of the metric in bytes.
 */ function estimateMetricSizeInBytes(metric) {
    var weight = 0;
    // Estimate byte size of 2 bytes per character. This is a rough estimate JS strings are stored as UTF-16.
    if (metric.name) weight += metric.name.length * 2;
    // Add weight for number
    weight += 8;
    return weight + estimateAttributesSizeInBytes(metric.attributes);
}
/**
 * Estimate the size of a log in bytes.
 *
 * @param log - The log to estimate the size of.
 * @returns The estimated size of the log in bytes.
 */ function estimateLogSizeInBytes(log) {
    var weight = 0;
    // Estimate byte size of 2 bytes per character. This is a rough estimate JS strings are stored as UTF-16.
    if (log.message) weight += log.message.length * 2;
    return weight + estimateAttributesSizeInBytes(log.attributes);
}
/**
 * Estimate the size of attributes in bytes.
 *
 * @param attributes - The attributes object to estimate the size of.
 * @returns The estimated size of the attributes in bytes.
 */ function estimateAttributesSizeInBytes(attributes) {
    if (!attributes) return 0;
    var weight = 0;
    Object.values(attributes).forEach(function(value) {
        if (Array.isArray(value)) weight += value.length * estimatePrimitiveSizeInBytes(value[0]);
        else if ((0, _isJs.isPrimitive)(value)) weight += estimatePrimitiveSizeInBytes(value);
        else // For objects values, we estimate the size of the object as 100 bytes
        weight += 100;
    });
    return weight;
}
function estimatePrimitiveSizeInBytes(value) {
    if (typeof value === 'string') return value.length * 2;
    else if (typeof value === 'number') return 8;
    else if (typeof value === 'boolean') return 4;
    return 0;
}

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_to_consumable_array":"1eSZf","@swc/helpers/_/_type_of":"iFJdx","@swc/helpers/_/_ts_generator":"78Tqx","./api.js":"9GGAx","./constants.js":"7XllJ","./currentScopes.js":"3GE4v","./debug-build.js":"ejIQP","./envelope.js":"8mEkR","./integration.js":"brH19","./logs/internal.js":"3IZl8","./metrics/internal.js":"acYCr","./session.js":"7bmuG","./tracing/dynamicSamplingContext.js":"5RiCd","./transports/base.js":"fZU08","./utils/clientreport.js":"gxGzt","./utils/debug-logger.js":"3X9Vf","./utils/dsn.js":"jNv3f","./utils/envelope.js":"fDBh0","./utils/eventUtils.js":"chqjg","./utils/is.js":"kSqSf","./utils/merge.js":"UyyHX","./utils/misc.js":"8kac1","./utils/parseSampleRate.js":"e0bLP","./utils/prepareEvent.js":"gVd7T","./utils/promisebuffer.js":"1vxH2","./utils/should-ignore-span.js":"kyChD","./utils/spanUtils.js":"fPRKj","./utils/syncpromise.js":"lxdDX","./utils/transactionEvent.js":"gyMLu","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"brH19":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addIntegration", function() {
    return addIntegration;
});
parcelHelpers.export(exports, "afterSetupIntegrations", function() {
    return afterSetupIntegrations;
});
parcelHelpers.export(exports, "defineIntegration", function() {
    return defineIntegration;
});
parcelHelpers.export(exports, "getIntegrationsToSetup", function() {
    return getIntegrationsToSetup;
});
parcelHelpers.export(exports, "installedIntegrations", function() {
    return installedIntegrations;
});
parcelHelpers.export(exports, "setupIntegration", function() {
    return setupIntegration;
});
parcelHelpers.export(exports, "setupIntegrations", function() {
    return setupIntegrations;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _currentScopesJs = require("./currentScopes.js");
var _debugBuildJs = require("./debug-build.js");
var _debugLoggerJs = require("./utils/debug-logger.js");
var installedIntegrations = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preserve the order of integrations in the array.
 *
 * @private
 */ function filterDuplicates(integrations) {
    var integrationsByName = {};
    integrations.forEach(function(currentInstance) {
        var name = currentInstance.name;
        var existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
/** Gets integrations to install */ function getIntegrationsToSetup(options) {
    var defaultIntegrations = options.defaultIntegrations || [];
    var userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach(function(integration) {
        integration.isDefaultInstance = true;
    });
    var integrations;
    if (Array.isArray(userIntegrations)) integrations = (0, _toConsumableArray._)(defaultIntegrations).concat((0, _toConsumableArray._)(userIntegrations));
    else if (typeof userIntegrations === 'function') {
        var resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    return filterDuplicates(integrations);
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function setupIntegrations(client, integrations) {
    var integrationIndex = {};
    integrations.forEach(function(integration) {
        // guard against empty provided integrations
        if (integration) setupIntegration(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function afterSetupIntegrations(client, integrations) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = integrations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var integration = _step.value;
            // guard against empty provided integrations
            if (integration === null || integration === void 0 ? void 0 : integration.afterAllSetup) integration.afterAllSetup(client);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
/** Setup a single integration.  */ function setupIntegration(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log("Integration skipped because it was already installed: ".concat(integration.name));
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if (!installedIntegrations.includes(integration.name) && typeof integration.setupOnce === 'function') {
        integration.setupOnce();
        installedIntegrations.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === 'function') integration.setup(client);
    if (typeof integration.preprocessEvent === 'function') {
        var callback = integration.preprocessEvent.bind(integration);
        client.on('preprocessEvent', function(event, hint) {
            return callback(event, hint, client);
        });
    }
    if (typeof integration.processEvent === 'function') {
        var callback1 = integration.processEvent.bind(integration);
        var processor = Object.assign(function(event, hint) {
            return callback1(event, hint, client);
        }, {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log("Integration installed: ".concat(integration.name));
}
/** Add an integration to the current scope's client. */ function addIntegration(integration) {
    var client = (0, _currentScopesJs.getClient)();
    if (!client) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn('Cannot add integration "'.concat(integration.name, '" because no SDK Client is available.'));
        return;
    }
    client.addIntegration(integration);
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function defineIntegration(fn) {
    return fn;
}

},{"@swc/helpers/_/_to_consumable_array":"1eSZf","./currentScopes.js":"3GE4v","./debug-build.js":"ejIQP","./utils/debug-logger.js":"3X9Vf","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3IZl8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_INTERNAL_captureLog", function() {
    return _INTERNAL_captureLog;
});
parcelHelpers.export(exports, "_INTERNAL_captureSerializedLog", function() {
    return _INTERNAL_captureSerializedLog;
});
parcelHelpers.export(exports, "_INTERNAL_flushLogsBuffer", function() {
    return _INTERNAL_flushLogsBuffer;
});
parcelHelpers.export(exports, "_INTERNAL_getLogBuffer", function() {
    return _INTERNAL_getLogBuffer;
});
parcelHelpers.export(exports, "logAttributeToSerializedLogAttribute", function() {
    return logAttributeToSerializedLogAttribute;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var _carrierJs = require("../carrier.js");
var _currentScopesJs = require("../currentScopes.js");
var _debugBuildJs = require("../debug-build.js");
var _applyScopeDataToEventJs = require("../utils/applyScopeDataToEvent.js");
var _debugLoggerJs = require("../utils/debug-logger.js");
var _isJs = require("../utils/is.js");
var _spanOnScopeJs = require("../utils/spanOnScope.js");
var _timeJs = require("../utils/time.js");
var _traceInfoJs = require("../utils/trace-info.js");
var _constantsJs = require("./constants.js");
var _envelopeJs = require("./envelope.js");
var MAX_LOG_BUFFER_SIZE = 100;
/**
 * Converts a log attribute to a serialized log attribute.
 *
 * @param key - The key of the log attribute.
 * @param value - The value of the log attribute.
 * @returns The serialized log attribute.
 */ function logAttributeToSerializedLogAttribute(value) {
    switch(typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)){
        case 'number':
            if (Number.isInteger(value)) return {
                value: value,
                type: 'integer'
            };
            return {
                value: value,
                type: 'double'
            };
        case 'boolean':
            return {
                value: value,
                type: 'boolean'
            };
        case 'string':
            return {
                value: value,
                type: 'string'
            };
        default:
            {
                var stringValue = '';
                try {
                    var _JSON_stringify;
                    stringValue = (_JSON_stringify = JSON.stringify(value)) !== null && _JSON_stringify !== void 0 ? _JSON_stringify : '';
                } catch (e) {
                // Do nothing
                }
                return {
                    value: stringValue,
                    type: 'string'
                };
            }
    }
}
/**
 * Sets a log attribute if the value exists and the attribute key is not already present.
 *
 * @param logAttributes - The log attributes object to modify.
 * @param key - The attribute key to set.
 * @param value - The value to set (only sets if truthy and key not present).
 * @param setEvenIfPresent - Whether to set the attribute if it is present. Defaults to true.
 */ function setLogAttribute(logAttributes, key, value) {
    var setEvenIfPresent = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
    if (value && (!logAttributes[key] || setEvenIfPresent)) logAttributes[key] = value;
}
/**
 * Captures a serialized log event and adds it to the log buffer for the given client.
 *
 * @param client - A client. Uses the current client if not provided.
 * @param serializedLog - The serialized log event to capture.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function _INTERNAL_captureSerializedLog(client, serializedLog) {
    var bufferMap = _getBufferMap();
    var logBuffer = _INTERNAL_getLogBuffer(client);
    if (logBuffer === undefined) bufferMap.set(client, [
        serializedLog
    ]);
    else if (logBuffer.length >= MAX_LOG_BUFFER_SIZE) {
        _INTERNAL_flushLogsBuffer(client, logBuffer);
        bufferMap.set(client, [
            serializedLog
        ]);
    } else bufferMap.set(client, (0, _toConsumableArray._)(logBuffer).concat([
        serializedLog
    ]));
}
/**
 * Captures a log event and sends it to Sentry.
 *
 * @param log - The log event to capture.
 * @param scope - A scope. Uses the current scope if not provided.
 * @param client - A client. Uses the current client if not provided.
 * @param captureSerializedLog - A function to capture the serialized log.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function _INTERNAL_captureLog(beforeLog) {
    var currentScope = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, _currentScopesJs.getCurrentScope)(), captureSerializedLog = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : _INTERNAL_captureSerializedLog;
    var _client_getSdkMetadata;
    var _currentScope_getClient;
    var client = (_currentScope_getClient = currentScope === null || currentScope === void 0 ? void 0 : currentScope.getClient()) !== null && _currentScope_getClient !== void 0 ? _currentScope_getClient : (0, _currentScopesJs.getClient)();
    if (!client) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn('No client available to capture log.');
        return;
    }
    var _client_getOptions = client.getOptions(), release = _client_getOptions.release, environment = _client_getOptions.environment, _client_getOptions_enableLogs = _client_getOptions.enableLogs, enableLogs = _client_getOptions_enableLogs === void 0 ? false : _client_getOptions_enableLogs, beforeSendLog = _client_getOptions.beforeSendLog;
    if (!enableLogs) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn('logging option not enabled, log will not be captured.');
        return;
    }
    var _$_getTraceInfoFromScope = (0, _slicedToArray._)((0, _traceInfoJs._getTraceInfoFromScope)(client, currentScope), 2), traceContext = _$_getTraceInfoFromScope[1];
    var processedLogAttributes = (0, _objectSpread._)({}, beforeLog.attributes);
    var _getMergedScopeData = getMergedScopeData(currentScope), _getMergedScopeData_user = _getMergedScopeData.user, id = _getMergedScopeData_user.id, email = _getMergedScopeData_user.email, username = _getMergedScopeData_user.username;
    setLogAttribute(processedLogAttributes, 'user.id', id, false);
    setLogAttribute(processedLogAttributes, 'user.email', email, false);
    setLogAttribute(processedLogAttributes, 'user.name', username, false);
    setLogAttribute(processedLogAttributes, 'sentry.release', release);
    setLogAttribute(processedLogAttributes, 'sentry.environment', environment);
    var _client_getSdkMetadata_sdk;
    var _ref = (_client_getSdkMetadata_sdk = (_client_getSdkMetadata = client.getSdkMetadata()) === null || _client_getSdkMetadata === void 0 ? void 0 : _client_getSdkMetadata.sdk) !== null && _client_getSdkMetadata_sdk !== void 0 ? _client_getSdkMetadata_sdk : {}, name = _ref.name, version = _ref.version;
    setLogAttribute(processedLogAttributes, 'sentry.sdk.name', name);
    setLogAttribute(processedLogAttributes, 'sentry.sdk.version', version);
    var replay = client.getIntegrationByName('Replay');
    var replayId = replay === null || replay === void 0 ? void 0 : replay.getReplayId(true);
    setLogAttribute(processedLogAttributes, 'sentry.replay_id', replayId);
    if (replayId && (replay === null || replay === void 0 ? void 0 : replay.getRecordingMode()) === 'buffer') // We send this so we can identify cases where the replayId is attached but the replay itself might not have been sent to Sentry
    setLogAttribute(processedLogAttributes, 'sentry._internal.replay_is_buffering', true);
    var beforeLogMessage = beforeLog.message;
    if ((0, _isJs.isParameterizedString)(beforeLogMessage)) {
        var __sentry_template_string__ = beforeLogMessage.__sentry_template_string__, _beforeLogMessage___sentry_template_values__ = beforeLogMessage.__sentry_template_values__, __sentry_template_values__ = _beforeLogMessage___sentry_template_values__ === void 0 ? [] : _beforeLogMessage___sentry_template_values__;
        if (__sentry_template_values__ === null || __sentry_template_values__ === void 0 ? void 0 : __sentry_template_values__.length) processedLogAttributes['sentry.message.template'] = __sentry_template_string__;
        __sentry_template_values__.forEach(function(param, index) {
            processedLogAttributes["sentry.message.parameter.".concat(index)] = param;
        });
    }
    var span = (0, _spanOnScopeJs._getSpanForScope)(currentScope);
    // Add the parent span ID to the log attributes for trace context
    setLogAttribute(processedLogAttributes, 'sentry.trace.parent_span_id', span === null || span === void 0 ? void 0 : span.spanContext().spanId);
    var processedLog = (0, _objectSpreadProps._)((0, _objectSpread._)({}, beforeLog), {
        attributes: processedLogAttributes
    });
    client.emit('beforeCaptureLog', processedLog);
    // We need to wrap this in `consoleSandbox` to avoid recursive calls to `beforeSendLog`
    var log = beforeSendLog ? (0, _debugLoggerJs.consoleSandbox)(function() {
        return beforeSendLog(processedLog);
    }) : processedLog;
    if (!log) {
        client.recordDroppedEvent('before_send', 'log_item', 1);
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn('beforeSendLog returned null, log will not be captured.');
        return;
    }
    var level = log.level, message = log.message, _log_attributes = log.attributes, attributes = _log_attributes === void 0 ? {} : _log_attributes, severityNumber = log.severityNumber;
    var serializedLog = {
        timestamp: (0, _timeJs.timestampInSeconds)(),
        level: level,
        body: message,
        trace_id: traceContext === null || traceContext === void 0 ? void 0 : traceContext.trace_id,
        severity_number: severityNumber !== null && severityNumber !== void 0 ? severityNumber : (0, _constantsJs.SEVERITY_TEXT_TO_SEVERITY_NUMBER)[level],
        attributes: Object.keys(attributes).reduce(function(acc, key) {
            acc[key] = logAttributeToSerializedLogAttribute(attributes[key]);
            return acc;
        }, {})
    };
    captureSerializedLog(client, serializedLog);
    client.emit('afterCaptureLog', log);
}
/**
 * Flushes the logs buffer to Sentry.
 *
 * @param client - A client.
 * @param maybeLogBuffer - A log buffer. Uses the log buffer for the given client if not provided.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function _INTERNAL_flushLogsBuffer(client, maybeLogBuffer) {
    var _ref;
    var logBuffer = (_ref = maybeLogBuffer !== null && maybeLogBuffer !== void 0 ? maybeLogBuffer : _INTERNAL_getLogBuffer(client)) !== null && _ref !== void 0 ? _ref : [];
    if (logBuffer.length === 0) return;
    var clientOptions = client.getOptions();
    var envelope = (0, _envelopeJs.createLogEnvelope)(logBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn());
    // Clear the log buffer after envelopes have been constructed.
    _getBufferMap().set(client, []);
    client.emit('flushLogs');
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}
/**
 * Returns the log buffer for a given client.
 *
 * Exported for testing purposes.
 *
 * @param client - The client to get the log buffer for.
 * @returns The log buffer for the given client.
 */ function _INTERNAL_getLogBuffer(client) {
    return _getBufferMap().get(client);
}
/**
 * Get the scope data for the current scope after merging with the
 * global scope and isolation scope.
 *
 * @param currentScope - The current scope.
 * @returns The scope data.
 */ function getMergedScopeData(currentScope) {
    var scopeData = (0, _currentScopesJs.getGlobalScope)().getScopeData();
    (0, _applyScopeDataToEventJs.mergeScopeData)(scopeData, (0, _currentScopesJs.getIsolationScope)().getScopeData());
    (0, _applyScopeDataToEventJs.mergeScopeData)(scopeData, currentScope.getScopeData());
    return scopeData;
}
function _getBufferMap() {
    // The reference to the Client <> LogBuffer map is stored on the carrier to ensure it's always the same
    return (0, _carrierJs.getGlobalSingleton)('clientToLogBufferMap', function() {
        return new WeakMap();
    });
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_to_consumable_array":"1eSZf","@swc/helpers/_/_type_of":"iFJdx","../carrier.js":"abKK3","../currentScopes.js":"3GE4v","../debug-build.js":"ejIQP","../utils/applyScopeDataToEvent.js":"jd7cV","../utils/debug-logger.js":"3X9Vf","../utils/is.js":"kSqSf","../utils/spanOnScope.js":"rJBOp","../utils/time.js":"i4V6H","../utils/trace-info.js":"iIUvw","./constants.js":"5rc1k","./envelope.js":"81tQU","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iIUvw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_getTraceInfoFromScope", function() {
    return _getTraceInfoFromScope;
});
var _currentScopesJs = require("../currentScopes.js");
var _dynamicSamplingContextJs = require("../tracing/dynamicSamplingContext.js");
var _spanUtilsJs = require("./spanUtils.js");
/** Extract trace information from scope */ function _getTraceInfoFromScope(client, scope) {
    if (!scope) return [
        undefined,
        undefined
    ];
    return (0, _currentScopesJs.withScope)(scope, function() {
        var span = (0, _spanUtilsJs.getActiveSpan)();
        var traceContext = span ? (0, _spanUtilsJs.spanToTraceContext)(span) : (0, _currentScopesJs.getTraceContextFromScope)(scope);
        var dynamicSamplingContext = span ? (0, _dynamicSamplingContextJs.getDynamicSamplingContextFromSpan)(span) : (0, _dynamicSamplingContextJs.getDynamicSamplingContextFromScope)(client, scope);
        return [
            dynamicSamplingContext,
            traceContext
        ];
    });
}

},{"../currentScopes.js":"3GE4v","../tracing/dynamicSamplingContext.js":"5RiCd","./spanUtils.js":"fPRKj","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5rc1k":[function(require,module,exports,__globalThis) {
/**
 * Maps a log severity level to a log severity number.
 *
 * @see LogSeverityLevel
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SEVERITY_TEXT_TO_SEVERITY_NUMBER", function() {
    return SEVERITY_TEXT_TO_SEVERITY_NUMBER;
});
var SEVERITY_TEXT_TO_SEVERITY_NUMBER = {
    trace: 1,
    debug: 5,
    info: 9,
    warn: 13,
    error: 17,
    fatal: 21
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"81tQU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createLogContainerEnvelopeItem", function() {
    return createLogContainerEnvelopeItem;
});
parcelHelpers.export(exports, "createLogEnvelope", function() {
    return createLogEnvelope;
});
var _dsnJs = require("../utils/dsn.js");
var _envelopeJs = require("../utils/envelope.js");
/**
 * Creates a log container envelope item for a list of logs.
 *
 * @param items - The logs to include in the envelope.
 * @returns The created log container envelope item.
 */ function createLogContainerEnvelopeItem(items) {
    return [
        {
            type: 'log',
            item_count: items.length,
            content_type: 'application/vnd.sentry.items.log+json'
        },
        {
            items: items
        }
    ];
}
/**
 * Creates an envelope for a list of logs.
 *
 * Logs from multiple traces can be included in the same envelope.
 *
 * @param logs - The logs to include in the envelope.
 * @param metadata - The metadata to include in the envelope.
 * @param tunnel - The tunnel to include in the envelope.
 * @param dsn - The DSN to include in the envelope.
 * @returns The created envelope.
 */ function createLogEnvelope(logs, metadata, tunnel, dsn) {
    var headers = {};
    if (metadata === null || metadata === void 0 ? void 0 : metadata.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn) headers.dsn = (0, _dsnJs.dsnToString)(dsn);
    return (0, _envelopeJs.createEnvelope)(headers, [
        createLogContainerEnvelopeItem(logs)
    ]);
}

},{"../utils/dsn.js":"jNv3f","../utils/envelope.js":"fDBh0","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"acYCr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_INTERNAL_captureMetric", function() {
    return _INTERNAL_captureMetric;
});
parcelHelpers.export(exports, "_INTERNAL_captureSerializedMetric", function() {
    return _INTERNAL_captureSerializedMetric;
});
parcelHelpers.export(exports, "_INTERNAL_flushMetricsBuffer", function() {
    return _INTERNAL_flushMetricsBuffer;
});
parcelHelpers.export(exports, "_INTERNAL_getMetricBuffer", function() {
    return _INTERNAL_getMetricBuffer;
});
parcelHelpers.export(exports, "metricAttributeToSerializedMetricAttribute", function() {
    return metricAttributeToSerializedMetricAttribute;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var _carrierJs = require("../carrier.js");
var _currentScopesJs = require("../currentScopes.js");
var _debugBuildJs = require("../debug-build.js");
var _applyScopeDataToEventJs = require("../utils/applyScopeDataToEvent.js");
var _debugLoggerJs = require("../utils/debug-logger.js");
var _spanOnScopeJs = require("../utils/spanOnScope.js");
var _timeJs = require("../utils/time.js");
var _traceInfoJs = require("../utils/trace-info.js");
var _envelopeJs = require("./envelope.js");
var MAX_METRIC_BUFFER_SIZE = 1000;
/**
 * Converts a metric attribute to a serialized metric attribute.
 *
 * @param value - The value of the metric attribute.
 * @returns The serialized metric attribute.
 */ function metricAttributeToSerializedMetricAttribute(value) {
    switch(typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)){
        case 'number':
            if (Number.isInteger(value)) return {
                value: value,
                type: 'integer'
            };
            return {
                value: value,
                type: 'double'
            };
        case 'boolean':
            return {
                value: value,
                type: 'boolean'
            };
        case 'string':
            return {
                value: value,
                type: 'string'
            };
        default:
            {
                var stringValue = '';
                try {
                    var _JSON_stringify;
                    stringValue = (_JSON_stringify = JSON.stringify(value)) !== null && _JSON_stringify !== void 0 ? _JSON_stringify : '';
                } catch (e) {
                // Do nothing
                }
                return {
                    value: stringValue,
                    type: 'string'
                };
            }
    }
}
/**
 * Sets a metric attribute if the value exists and the attribute key is not already present.
 *
 * @param metricAttributes - The metric attributes object to modify.
 * @param key - The attribute key to set.
 * @param value - The value to set (only sets if truthy and key not present).
 * @param setEvenIfPresent - Whether to set the attribute if it is present. Defaults to true.
 */ function setMetricAttribute(metricAttributes, key, value) {
    var setEvenIfPresent = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
    if (value && (setEvenIfPresent || !(key in metricAttributes))) metricAttributes[key] = value;
}
/**
 * Captures a serialized metric event and adds it to the metric buffer for the given client.
 *
 * @param client - A client. Uses the current client if not provided.
 * @param serializedMetric - The serialized metric event to capture.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function _INTERNAL_captureSerializedMetric(client, serializedMetric) {
    var bufferMap = _getBufferMap();
    var metricBuffer = _INTERNAL_getMetricBuffer(client);
    if (metricBuffer === undefined) bufferMap.set(client, [
        serializedMetric
    ]);
    else if (metricBuffer.length >= MAX_METRIC_BUFFER_SIZE) {
        _INTERNAL_flushMetricsBuffer(client, metricBuffer);
        bufferMap.set(client, [
            serializedMetric
        ]);
    } else bufferMap.set(client, (0, _toConsumableArray._)(metricBuffer).concat([
        serializedMetric
    ]));
}
/**
 * Options for capturing a metric internally.
 */ /**
 * Enriches metric with all contextual attributes (user, SDK metadata, replay, etc.)
 */ function _enrichMetricAttributes(beforeMetric, client, currentScope) {
    var _client_getSdkMetadata;
    var _client_getOptions = client.getOptions(), release = _client_getOptions.release, environment = _client_getOptions.environment;
    var processedMetricAttributes = (0, _objectSpread._)({}, beforeMetric.attributes);
    // Add user attributes
    var _getMergedScopeData = getMergedScopeData(currentScope), _getMergedScopeData_user = _getMergedScopeData.user, id = _getMergedScopeData_user.id, email = _getMergedScopeData_user.email, username = _getMergedScopeData_user.username;
    setMetricAttribute(processedMetricAttributes, 'user.id', id, false);
    setMetricAttribute(processedMetricAttributes, 'user.email', email, false);
    setMetricAttribute(processedMetricAttributes, 'user.name', username, false);
    // Add Sentry metadata
    setMetricAttribute(processedMetricAttributes, 'sentry.release', release);
    setMetricAttribute(processedMetricAttributes, 'sentry.environment', environment);
    var _client_getSdkMetadata_sdk;
    // Add SDK metadata
    var _ref = (_client_getSdkMetadata_sdk = (_client_getSdkMetadata = client.getSdkMetadata()) === null || _client_getSdkMetadata === void 0 ? void 0 : _client_getSdkMetadata.sdk) !== null && _client_getSdkMetadata_sdk !== void 0 ? _client_getSdkMetadata_sdk : {}, name = _ref.name, version = _ref.version;
    setMetricAttribute(processedMetricAttributes, 'sentry.sdk.name', name);
    setMetricAttribute(processedMetricAttributes, 'sentry.sdk.version', version);
    // Add replay metadata
    var replay = client.getIntegrationByName('Replay');
    var replayId = replay === null || replay === void 0 ? void 0 : replay.getReplayId(true);
    setMetricAttribute(processedMetricAttributes, 'sentry.replay_id', replayId);
    if (replayId && (replay === null || replay === void 0 ? void 0 : replay.getRecordingMode()) === 'buffer') setMetricAttribute(processedMetricAttributes, 'sentry._internal.replay_is_buffering', true);
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, beforeMetric), {
        attributes: processedMetricAttributes
    });
}
/**
 * Creates a serialized metric ready to be sent to Sentry.
 */ function _buildSerializedMetric(metric, client, currentScope) {
    // Serialize attributes
    var serializedAttributes = {};
    for(var key in metric.attributes)if (metric.attributes[key] !== undefined) serializedAttributes[key] = metricAttributeToSerializedMetricAttribute(metric.attributes[key]);
    // Get trace context
    var _$_getTraceInfoFromScope = (0, _slicedToArray._)((0, _traceInfoJs._getTraceInfoFromScope)(client, currentScope), 2), traceContext = _$_getTraceInfoFromScope[1];
    var span = (0, _spanOnScopeJs._getSpanForScope)(currentScope);
    var traceId = span ? span.spanContext().traceId : traceContext === null || traceContext === void 0 ? void 0 : traceContext.trace_id;
    var spanId = span ? span.spanContext().spanId : undefined;
    return {
        timestamp: (0, _timeJs.timestampInSeconds)(),
        trace_id: traceId !== null && traceId !== void 0 ? traceId : '',
        span_id: spanId,
        name: metric.name,
        type: metric.type,
        unit: metric.unit,
        value: metric.value,
        attributes: serializedAttributes
    };
}
/**
 * Captures a metric event and sends it to Sentry.
 *
 * @param metric - The metric event to capture.
 * @param options - Options for capturing the metric.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function _INTERNAL_captureMetric(beforeMetric, options) {
    var _options_scope;
    var currentScope = (_options_scope = options === null || options === void 0 ? void 0 : options.scope) !== null && _options_scope !== void 0 ? _options_scope : (0, _currentScopesJs.getCurrentScope)();
    var _options_captureSerializedMetric;
    var captureSerializedMetric = (_options_captureSerializedMetric = options === null || options === void 0 ? void 0 : options.captureSerializedMetric) !== null && _options_captureSerializedMetric !== void 0 ? _options_captureSerializedMetric : _INTERNAL_captureSerializedMetric;
    var _currentScope_getClient;
    var client = (_currentScope_getClient = currentScope === null || currentScope === void 0 ? void 0 : currentScope.getClient()) !== null && _currentScope_getClient !== void 0 ? _currentScope_getClient : (0, _currentScopesJs.getClient)();
    if (!client) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn('No client available to capture metric.');
        return;
    }
    var _client_getOptions = client.getOptions(), _experiments = _client_getOptions._experiments, enableMetrics = _client_getOptions.enableMetrics, beforeSendMetric = _client_getOptions.beforeSendMetric;
    var _ref;
    // todo(v11): Remove the experimental flag
    // eslint-disable-next-line deprecation/deprecation
    var metricsEnabled = (_ref = enableMetrics !== null && enableMetrics !== void 0 ? enableMetrics : _experiments === null || _experiments === void 0 ? void 0 : _experiments.enableMetrics) !== null && _ref !== void 0 ? _ref : true;
    if (!metricsEnabled) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn('metrics option not enabled, metric will not be captured.');
        return;
    }
    // Enrich metric with contextual attributes
    var enrichedMetric = _enrichMetricAttributes(beforeMetric, client, currentScope);
    client.emit('processMetric', enrichedMetric);
    // todo(v11): Remove the experimental `beforeSendMetric`
    // eslint-disable-next-line deprecation/deprecation
    var beforeSendCallback = beforeSendMetric || (_experiments === null || _experiments === void 0 ? void 0 : _experiments.beforeSendMetric);
    var processedMetric = beforeSendCallback ? beforeSendCallback(enrichedMetric) : enrichedMetric;
    if (!processedMetric) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log('`beforeSendMetric` returned `null`, will not send metric.');
        return;
    }
    var serializedMetric = _buildSerializedMetric(processedMetric, client, currentScope);
    (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log('[Metric]', serializedMetric);
    captureSerializedMetric(client, serializedMetric);
    client.emit('afterCaptureMetric', processedMetric);
}
/**
 * Flushes the metrics buffer to Sentry.
 *
 * @param client - A client.
 * @param maybeMetricBuffer - A metric buffer. Uses the metric buffer for the given client if not provided.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function _INTERNAL_flushMetricsBuffer(client, maybeMetricBuffer) {
    var _ref;
    var metricBuffer = (_ref = maybeMetricBuffer !== null && maybeMetricBuffer !== void 0 ? maybeMetricBuffer : _INTERNAL_getMetricBuffer(client)) !== null && _ref !== void 0 ? _ref : [];
    if (metricBuffer.length === 0) return;
    var clientOptions = client.getOptions();
    var envelope = (0, _envelopeJs.createMetricEnvelope)(metricBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn());
    // Clear the metric buffer after envelopes have been constructed.
    _getBufferMap().set(client, []);
    client.emit('flushMetrics');
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}
/**
 * Returns the metric buffer for a given client.
 *
 * Exported for testing purposes.
 *
 * @param client - The client to get the metric buffer for.
 * @returns The metric buffer for the given client.
 */ function _INTERNAL_getMetricBuffer(client) {
    return _getBufferMap().get(client);
}
/**
 * Get the scope data for the current scope after merging with the
 * global scope and isolation scope.
 *
 * @param currentScope - The current scope.
 * @returns The scope data.
 */ function getMergedScopeData(currentScope) {
    var scopeData = (0, _currentScopesJs.getGlobalScope)().getScopeData();
    (0, _applyScopeDataToEventJs.mergeScopeData)(scopeData, (0, _currentScopesJs.getIsolationScope)().getScopeData());
    (0, _applyScopeDataToEventJs.mergeScopeData)(scopeData, currentScope.getScopeData());
    return scopeData;
}
function _getBufferMap() {
    // The reference to the Client <> MetricBuffer map is stored on the carrier to ensure it's always the same
    return (0, _carrierJs.getGlobalSingleton)('clientToMetricBufferMap', function() {
        return new WeakMap();
    });
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_to_consumable_array":"1eSZf","@swc/helpers/_/_type_of":"iFJdx","../carrier.js":"abKK3","../currentScopes.js":"3GE4v","../debug-build.js":"ejIQP","../utils/applyScopeDataToEvent.js":"jd7cV","../utils/debug-logger.js":"3X9Vf","../utils/spanOnScope.js":"rJBOp","../utils/time.js":"i4V6H","../utils/trace-info.js":"iIUvw","./envelope.js":"2STzb","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2STzb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createMetricContainerEnvelopeItem", function() {
    return createMetricContainerEnvelopeItem;
});
parcelHelpers.export(exports, "createMetricEnvelope", function() {
    return createMetricEnvelope;
});
var _dsnJs = require("../utils/dsn.js");
var _envelopeJs = require("../utils/envelope.js");
/**
 * Creates a metric container envelope item for a list of metrics.
 *
 * @param items - The metrics to include in the envelope.
 * @returns The created metric container envelope item.
 */ function createMetricContainerEnvelopeItem(items) {
    return [
        {
            type: 'trace_metric',
            item_count: items.length,
            content_type: 'application/vnd.sentry.items.trace-metric+json'
        },
        {
            items: items
        }
    ];
}
/**
 * Creates an envelope for a list of metrics.
 *
 * Metrics from multiple traces can be included in the same envelope.
 *
 * @param metrics - The metrics to include in the envelope.
 * @param metadata - The metadata to include in the envelope.
 * @param tunnel - The tunnel to include in the envelope.
 * @param dsn - The DSN to include in the envelope.
 * @returns The created envelope.
 */ function createMetricEnvelope(metrics, metadata, tunnel, dsn) {
    var headers = {};
    if (metadata === null || metadata === void 0 ? void 0 : metadata.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn) headers.dsn = (0, _dsnJs.dsnToString)(dsn);
    return (0, _envelopeJs.createEnvelope)(headers, [
        createMetricContainerEnvelopeItem(metrics)
    ]);
}

},{"../utils/dsn.js":"jNv3f","../utils/envelope.js":"fDBh0","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fZU08":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_TRANSPORT_BUFFER_SIZE", function() {
    return DEFAULT_TRANSPORT_BUFFER_SIZE;
});
parcelHelpers.export(exports, "createTransport", function() {
    return createTransport;
});
var _debugBuildJs = require("../debug-build.js");
var _debugLoggerJs = require("../utils/debug-logger.js");
var _envelopeJs = require("../utils/envelope.js");
var _promisebufferJs = require("../utils/promisebuffer.js");
var _ratelimitJs = require("../utils/ratelimit.js");
var DEFAULT_TRANSPORT_BUFFER_SIZE = 64;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function createTransport(options, makeRequest) {
    var buffer = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, _promisebufferJs.makePromiseBuffer)(options.bufferSize || DEFAULT_TRANSPORT_BUFFER_SIZE);
    var rateLimits = {};
    var flush = function(timeout) {
        return buffer.drain(timeout);
    };
    function send(envelope) {
        var filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, _envelopeJs.forEachEnvelopeItem)(envelope, function(item, type) {
            var dataCategory = (0, _envelopeJs.envelopeItemTypeToDataCategory)(type);
            if ((0, _ratelimitJs.isRateLimited)(rateLimits, dataCategory)) options.recordDroppedEvent('ratelimit_backoff', dataCategory);
            else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return Promise.resolve({});
        var filteredEnvelope = (0, _envelopeJs.createEnvelope)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        var recordEnvelopeLoss = function(reason) {
            (0, _envelopeJs.forEachEnvelopeItem)(filteredEnvelope, function(item, type) {
                options.recordDroppedEvent(reason, (0, _envelopeJs.envelopeItemTypeToDataCategory)(type));
            });
        };
        var requestTask = function() {
            return makeRequest({
                body: (0, _envelopeJs.serializeEnvelope)(filteredEnvelope)
            }).then(function(response) {
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn("Sentry responded with status code ".concat(response.statusCode, " to sent event."));
                rateLimits = (0, _ratelimitJs.updateRateLimits)(rateLimits, response);
                return response;
            }, function(error) {
                recordEnvelopeLoss('network_error');
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).error('Encountered error running transport request:', error);
                throw error;
            });
        };
        return buffer.add(requestTask).then(function(result) {
            return result;
        }, function(error) {
            if (error === (0, _promisebufferJs.SENTRY_BUFFER_FULL_ERROR)) {
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).error('Skipped sending event because buffer is full.');
                recordEnvelopeLoss('queue_overflow');
                return Promise.resolve({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}

},{"../debug-build.js":"ejIQP","../utils/debug-logger.js":"3X9Vf","../utils/envelope.js":"fDBh0","../utils/promisebuffer.js":"1vxH2","../utils/ratelimit.js":"4EbXl","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1vxH2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SENTRY_BUFFER_FULL_ERROR", function() {
    return SENTRY_BUFFER_FULL_ERROR;
});
parcelHelpers.export(exports, "makePromiseBuffer", function() {
    return makePromiseBuffer;
});
var _syncpromiseJs = require("./syncpromise.js");
var SENTRY_BUFFER_FULL_ERROR = Symbol.for('SentryBufferFullError');
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function makePromiseBuffer() {
    var limit = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 100;
    var buffer = new Set();
    function isReady() {
        return buffer.size < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        buffer.delete(task);
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, _syncpromiseJs.rejectedSyncPromise)(SENTRY_BUFFER_FULL_ERROR);
        // start the task and add its promise to the queue
        var task = taskProducer();
        buffer.add(task);
        task.then(function() {
            return remove(task);
        }, function() {
            return remove(task);
        });
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        if (!buffer.size) return (0, _syncpromiseJs.resolvedSyncPromise)(true);
        // We want to resolve even if one of the promises rejects
        var drainPromise = Promise.allSettled(Array.from(buffer)).then(function() {
            return true;
        });
        if (!timeout) return drainPromise;
        var promises = [
            drainPromise,
            new Promise(function(resolve) {
                return setTimeout(function() {
                    return resolve(false);
                }, timeout);
            })
        ];
        // Promise.race will resolve to the first promise that resolves or rejects
        // So if the drainPromise resolves, the timeout promise will be ignored
        return Promise.race(promises);
    }
    return {
        get $ () {
            return Array.from(buffer);
        },
        add: add,
        drain: drain
    };
}

},{"./syncpromise.js":"lxdDX","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4EbXl":[function(require,module,exports,__globalThis) {
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_RETRY_AFTER", function() {
    return DEFAULT_RETRY_AFTER;
});
parcelHelpers.export(exports, "disabledUntil", function() {
    return disabledUntil;
});
parcelHelpers.export(exports, "isRateLimited", function() {
    return isRateLimited;
});
parcelHelpers.export(exports, "parseRetryAfterHeader", function() {
    return parseRetryAfterHeader;
});
parcelHelpers.export(exports, "updateRateLimits", function() {
    return updateRateLimits;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var DEFAULT_RETRY_AFTER = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function parseRetryAfterHeader(header) {
    var now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
    var headerDelay = parseInt("".concat(header), 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    var headerDate = Date.parse("".concat(header));
    if (!isNaN(headerDate)) return headerDate - now;
    return DEFAULT_RETRY_AFTER;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function disabledUntil(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function isRateLimited(limits, dataCategory) {
    var now = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Date.now();
    return disabledUntil(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function updateRateLimits(limits, param) {
    var statusCode = param.statusCode, headers = param.headers, now = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Date.now();
    var updatedRateLimits = (0, _objectSpread._)({}, limits);
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    var rateLimitHeader = headers === null || headers === void 0 ? void 0 : headers['x-sentry-rate-limits'];
    var retryAfterHeader = headers === null || headers === void 0 ? void 0 : headers['retry-after'];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (rateLimitHeader) try {
        /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for(var _iterator = rateLimitHeader.trim().split(',')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var limit = _step.value;
            var _limit_split = (0, _slicedToArray._)(limit.split(':', 5), 5), retryAfter = _limit_split[0], categories = _limit_split[1], namespaces = _limit_split[4];
            var headerDelay = parseInt(retryAfter, 10);
            var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            if (!categories) updatedRateLimits.all = now + delay;
            else try {
                for(var _iterator1 = categories.split(';')[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var category = _step1.value;
                    if (category === 'metric_bucket') // namespaces will be present when category === 'metric_bucket'
                    {
                        if (!namespaces || namespaces.split(';').includes('custom')) updatedRateLimits[category] = now + delay;
                    } else updatedRateLimits[category] = now + delay;
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + parseRetryAfterHeader(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_sliced_to_array":"8PtL6","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gxGzt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createClientReportEnvelope", function() {
    return createClientReportEnvelope;
});
var _envelopeJs = require("./envelope.js");
var _timeJs = require("./time.js");
/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function createClientReportEnvelope(discarded_events, dsn, timestamp) {
    var clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, _timeJs.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, _envelopeJs.createEnvelope)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

},{"./envelope.js":"fDBh0","./time.js":"i4V6H","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"chqjg":[function(require,module,exports,__globalThis) {
/**
 * Get a list of possible event messages from a Sentry event.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPossibleEventMessages", function() {
    return getPossibleEventMessages;
});
function getPossibleEventMessages(event) {
    var possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    try {
        // @ts-expect-error Try catching to save bundle size
        var lastException = event.exception.values[event.exception.values.length - 1];
        if (lastException === null || lastException === void 0 ? void 0 : lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push("".concat(lastException.type, ": ").concat(lastException.value));
        }
    } catch (e) {
    // ignore errors here
    }
    return possibleMessages;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gyMLu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "convertSpanJsonToTransactionEvent", function() {
    return convertSpanJsonToTransactionEvent;
});
parcelHelpers.export(exports, "convertTransactionEventToSpanJson", function() {
    return convertTransactionEventToSpanJson;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _semanticAttributesJs = require("../semanticAttributes.js");
/**
 * Converts a transaction event to a span JSON object.
 */ function convertTransactionEventToSpanJson(event) {
    var _event_contexts;
    var _event_contexts_trace;
    var _ref = (_event_contexts_trace = (_event_contexts = event.contexts) === null || _event_contexts === void 0 ? void 0 : _event_contexts.trace) !== null && _event_contexts_trace !== void 0 ? _event_contexts_trace : {}, trace_id = _ref.trace_id, parent_span_id = _ref.parent_span_id, span_id = _ref.span_id, status = _ref.status, origin = _ref.origin, data = _ref.data, op = _ref.op;
    var _event_start_timestamp;
    return {
        data: data !== null && data !== void 0 ? data : {},
        description: event.transaction,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id !== null && span_id !== void 0 ? span_id : '',
        start_timestamp: (_event_start_timestamp = event.start_timestamp) !== null && _event_start_timestamp !== void 0 ? _event_start_timestamp : 0,
        status: status,
        timestamp: event.timestamp,
        trace_id: trace_id !== null && trace_id !== void 0 ? trace_id : '',
        origin: origin,
        profile_id: data === null || data === void 0 ? void 0 : data[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_PROFILE_ID],
        exclusive_time: data === null || data === void 0 ? void 0 : data[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
        measurements: event.measurements,
        is_segment: true
    };
}
/**
 * Converts a span JSON object to a transaction event.
 */ function convertSpanJsonToTransactionEvent(span) {
    return {
        type: 'transaction',
        timestamp: span.timestamp,
        start_timestamp: span.start_timestamp,
        transaction: span.description,
        contexts: {
            trace: {
                trace_id: span.trace_id,
                span_id: span.span_id,
                parent_span_id: span.parent_span_id,
                op: span.op,
                status: span.status,
                origin: span.origin,
                data: (0, _objectSpread._)({}, span.data, span.profile_id && (0, _defineProperty._)({}, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_PROFILE_ID), span.profile_id), span.exclusive_time && (0, _defineProperty._)({}, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME), span.exclusive_time))
            }
        },
        measurements: span.measurements
    };
}

},{"@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_object_spread":"9gdrV","../semanticAttributes.js":"7WRPE","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"92f5Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ServerRuntimeClient", function() {
    return ServerRuntimeClient;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _get = require("@swc/helpers/_/_get");
var _getPrototypeOf = require("@swc/helpers/_/_get_prototype_of");
var _inherits = require("@swc/helpers/_/_inherits");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _checkinJs = require("./checkin.js");
var _clientJs = require("./client.js");
var _currentScopesJs = require("./currentScopes.js");
var _debugBuildJs = require("./debug-build.js");
var _errorsJs = require("./tracing/errors.js");
var _debugLoggerJs = require("./utils/debug-logger.js");
var _miscJs = require("./utils/misc.js");
var _userAgentJs = require("./transports/userAgent.js");
var _eventbuilderJs = require("./utils/eventbuilder.js");
var _syncpromiseJs = require("./utils/syncpromise.js");
var _traceInfoJs = require("./utils/trace-info.js");
/**
 * The Sentry Server Runtime Client SDK.
 */ var ServerRuntimeClient = /*#__PURE__*/ function(Client) {
    "use strict";
    (0, _inherits._)(ServerRuntimeClient, Client);
    function ServerRuntimeClient(options) {
        (0, _classCallCheck._)(this, ServerRuntimeClient);
        var _this;
        // Server clients always support tracing
        (0, _errorsJs.registerSpanErrorInstrumentation)();
        (0, _userAgentJs.addUserAgentToTransportHeaders)(options);
        _this = (0, _callSuper._)(this, ServerRuntimeClient, [
            options
        ]);
        _this._setUpMetricsProcessing();
        return _this;
    }
    (0, _createClass._)(ServerRuntimeClient, [
        {
            /**
   * @inheritDoc
   */ key: "eventFromException",
            value: function eventFromException(exception, hint) {
                var event = (0, _eventbuilderJs.eventFromUnknownInput)(this, this._options.stackParser, exception, hint);
                event.level = 'error';
                return (0, _syncpromiseJs.resolvedSyncPromise)(event);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "eventFromMessage",
            value: function eventFromMessage(message) {
                var level = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'info', hint = arguments.length > 2 ? arguments[2] : void 0;
                return (0, _syncpromiseJs.resolvedSyncPromise)((0, _eventbuilderJs.eventFromMessage)(this._options.stackParser, message, level, hint, this._options.attachStacktrace));
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "captureException",
            value: function captureException(exception, hint, scope) {
                setCurrentRequestSessionErroredOrCrashed(hint);
                return (0, _get._)((0, _getPrototypeOf._)(ServerRuntimeClient.prototype), "captureException", this).call(this, exception, hint, scope);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "captureEvent",
            value: function captureEvent(event, hint, scope) {
                var _event_exception;
                // If the event is of type Exception, then a request session should be captured
                var isException = !event.type && ((_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : _event_exception.values) && event.exception.values.length > 0;
                if (isException) setCurrentRequestSessionErroredOrCrashed(hint);
                return (0, _get._)((0, _getPrototypeOf._)(ServerRuntimeClient.prototype), "captureEvent", this).call(this, event, hint, scope);
            }
        },
        {
            /**
   * Create a cron monitor check in and send it to Sentry.
   *
   * @param checkIn An object that describes a check in.
   * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
   * to create a monitor automatically when sending a check in.
   */ key: "captureCheckIn",
            value: function captureCheckIn(checkIn, monitorConfig, scope) {
                var id = 'checkInId' in checkIn && checkIn.checkInId ? checkIn.checkInId : (0, _miscJs.uuid4)();
                if (!this._isEnabled()) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn('SDK not enabled, will not capture check-in.');
                    return id;
                }
                var options = this.getOptions();
                var release = options.release, environment = options.environment, tunnel = options.tunnel;
                var serializedCheckIn = {
                    check_in_id: id,
                    monitor_slug: checkIn.monitorSlug,
                    status: checkIn.status,
                    release: release,
                    environment: environment
                };
                if ('duration' in checkIn) serializedCheckIn.duration = checkIn.duration;
                if (monitorConfig) serializedCheckIn.monitor_config = {
                    schedule: monitorConfig.schedule,
                    checkin_margin: monitorConfig.checkinMargin,
                    max_runtime: monitorConfig.maxRuntime,
                    timezone: monitorConfig.timezone,
                    failure_issue_threshold: monitorConfig.failureIssueThreshold,
                    recovery_threshold: monitorConfig.recoveryThreshold
                };
                var _$_getTraceInfoFromScope = (0, _slicedToArray._)((0, _traceInfoJs._getTraceInfoFromScope)(this, scope), 2), dynamicSamplingContext = _$_getTraceInfoFromScope[0], traceContext = _$_getTraceInfoFromScope[1];
                if (traceContext) serializedCheckIn.contexts = {
                    trace: traceContext
                };
                var envelope = (0, _checkinJs.createCheckInEnvelope)(serializedCheckIn, dynamicSamplingContext, this.getSdkMetadata(), tunnel, this.getDsn());
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log('Sending checkin:', checkIn.monitorSlug, checkIn.status);
                // sendEnvelope should not throw
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.sendEnvelope(envelope);
                return id;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "_prepareEvent",
            value: function _prepareEvent(event, hint, currentScope, isolationScope) {
                var _event_contexts;
                if (this._options.platform) event.platform = event.platform || this._options.platform;
                if (this._options.runtime) event.contexts = (0, _objectSpreadProps._)((0, _objectSpread._)({}, event.contexts), {
                    runtime: ((_event_contexts = event.contexts) === null || _event_contexts === void 0 ? void 0 : _event_contexts.runtime) || this._options.runtime
                });
                if (this._options.serverName) event.server_name = event.server_name || this._options.serverName;
                return (0, _get._)((0, _getPrototypeOf._)(ServerRuntimeClient.prototype), "_prepareEvent", this).call(this, event, hint, currentScope, isolationScope);
            }
        },
        {
            /**
   * Process a server-side metric before it is captured.
   */ key: "_setUpMetricsProcessing",
            value: function _setUpMetricsProcessing() {
                var _this = this;
                this.on('processMetric', function(metric) {
                    if (_this._options.serverName) metric.attributes = (0, _objectSpread._)({
                        'server.address': _this._options.serverName
                    }, metric.attributes);
                });
            }
        }
    ]);
    return ServerRuntimeClient;
}((0, _clientJs.Client));
function setCurrentRequestSessionErroredOrCrashed(eventHint) {
    var requestSession = (0, _currentScopesJs.getIsolationScope)().getScopeData().sdkProcessingMetadata.requestSession;
    if (requestSession) {
        var _eventHint_mechanism;
        var _eventHint_mechanism_handled;
        // We mutate instead of doing `setSdkProcessingMetadata` because the http integration stores away a particular
        // isolationScope. If that isolation scope is forked, setting the processing metadata here will not mutate the
        // original isolation scope that the http integration stored away.
        var isHandledException = (_eventHint_mechanism_handled = eventHint === null || eventHint === void 0 ? void 0 : (_eventHint_mechanism = eventHint.mechanism) === null || _eventHint_mechanism === void 0 ? void 0 : _eventHint_mechanism.handled) !== null && _eventHint_mechanism_handled !== void 0 ? _eventHint_mechanism_handled : true;
        // A request session can go from "errored" -> "crashed" but not "crashed" -> "errored".
        // Crashed (unhandled exception) is worse than errored (handled exception).
        if (isHandledException && requestSession.status !== 'crashed') requestSession.status = 'errored';
        else if (!isHandledException) requestSession.status = 'crashed';
    }
}

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_get":"38TLD","@swc/helpers/_/_get_prototype_of":"5txK6","@swc/helpers/_/_inherits":"2sfqW","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_sliced_to_array":"8PtL6","./checkin.js":"1x4do","./client.js":"f0QJY","./currentScopes.js":"3GE4v","./debug-build.js":"ejIQP","./tracing/errors.js":"e2sL3","./utils/debug-logger.js":"3X9Vf","./utils/misc.js":"8kac1","./transports/userAgent.js":"iq4Ke","./utils/eventbuilder.js":"kg8hW","./utils/syncpromise.js":"lxdDX","./utils/trace-info.js":"iIUvw","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1x4do":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createCheckInEnvelope", function() {
    return createCheckInEnvelope;
});
var _dsnJs = require("./utils/dsn.js");
var _envelopeJs = require("./utils/envelope.js");
/**
 * Create envelope from check in item.
 */ function createCheckInEnvelope(checkIn, dynamicSamplingContext, metadata, tunnel, dsn) {
    var headers = {
        sent_at: new Date().toISOString()
    };
    if (metadata === null || metadata === void 0 ? void 0 : metadata.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn) headers.dsn = (0, _dsnJs.dsnToString)(dsn);
    if (dynamicSamplingContext) headers.trace = dynamicSamplingContext;
    var item = createCheckInEnvelopeItem(checkIn);
    return (0, _envelopeJs.createEnvelope)(headers, [
        item
    ]);
}
function createCheckInEnvelopeItem(checkIn) {
    var checkInHeaders = {
        type: 'check_in'
    };
    return [
        checkInHeaders,
        checkIn
    ];
}

},{"./utils/dsn.js":"jNv3f","./utils/envelope.js":"fDBh0","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iq4Ke":[function(require,module,exports,__globalThis) {
/**
 * Takes the SDK metadata and adds the user-agent header to the transport options.
 * This ensures that the SDK sends the user-agent header with SDK name and version to
 * all requests made by the transport.
 *
 * @see https://develop.sentry.dev/sdk/overview/#user-agent
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addUserAgentToTransportHeaders", function() {
    return addUserAgentToTransportHeaders;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
function addUserAgentToTransportHeaders(options) {
    var _options__metadata, _options_transportOptions;
    var sdkMetadata = (_options__metadata = options._metadata) === null || _options__metadata === void 0 ? void 0 : _options__metadata.sdk;
    var sdkUserAgent = (sdkMetadata === null || sdkMetadata === void 0 ? void 0 : sdkMetadata.name) && (sdkMetadata === null || sdkMetadata === void 0 ? void 0 : sdkMetadata.version) ? "".concat(sdkMetadata === null || sdkMetadata === void 0 ? void 0 : sdkMetadata.name, "/").concat(sdkMetadata === null || sdkMetadata === void 0 ? void 0 : sdkMetadata.version) : undefined;
    options.transportOptions = (0, _objectSpreadProps._)((0, _objectSpread._)({}, options.transportOptions), {
        headers: (0, _objectSpread._)({}, sdkUserAgent && {
            'user-agent': sdkUserAgent
        }, (_options_transportOptions = options.transportOptions) === null || _options_transportOptions === void 0 ? void 0 : _options_transportOptions.headers)
    });
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kg8hW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "eventFromMessage", function() {
    return eventFromMessage;
});
parcelHelpers.export(exports, "eventFromUnknownInput", function() {
    return eventFromUnknownInput;
});
parcelHelpers.export(exports, "exceptionFromError", function() {
    return exceptionFromError;
});
parcelHelpers.export(exports, "parseStackFrames", function() {
    return parseStackFrames;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _isJs = require("./is.js");
var _miscJs = require("./misc.js");
var _normalizeJs = require("./normalize.js");
var _objectJs = require("./object.js");
/**
 * Extracts stack frames from the error.stack string
 */ function parseStackFrames(stackParser, error) {
    return stackParser(error.stack || '', 1);
}
/**
 * Extracts stack frames from the error and builds a Sentry Exception
 */ function exceptionFromError(stackParser, error) {
    var exception = {
        type: error.name || error.constructor.name,
        value: error.message
    };
    var frames = parseStackFrames(stackParser, error);
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    return exception;
}
/** If a plain object has a property that is an `Error`, return this error. */ function getErrorPropertyFromObject(obj) {
    for(var prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        var value = obj[prop];
        if ((0, _instanceof._)(value, Error)) return value;
    }
    return undefined;
}
function getMessageForObject(exception) {
    if ('name' in exception && typeof exception.name === 'string') {
        var message = "'".concat(exception.name, "' captured as exception");
        if ('message' in exception && typeof exception.message === 'string') message += " with message '".concat(exception.message, "'");
        return message;
    } else if ('message' in exception && typeof exception.message === 'string') return exception.message;
    var keys = (0, _objectJs.extractExceptionKeysForMessage)(exception);
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, _isJs.isErrorEvent)(exception)) return "Event `ErrorEvent` captured as exception with message `".concat(exception.message, "`");
    var className = getObjectClassName(exception);
    return "".concat(className && className !== 'Object' ? "'".concat(className, "'") : 'Object', " captured as exception with keys: ").concat(keys);
}
function getObjectClassName(obj) {
    try {
        var prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}
function getException(client, mechanism, exception, hint) {
    if ((0, _isJs.isError)(exception)) return [
        exception,
        undefined
    ];
    // Mutate this!
    mechanism.synthetic = true;
    if ((0, _isJs.isPlainObject)(exception)) {
        var normalizeDepth = client === null || client === void 0 ? void 0 : client.getOptions().normalizeDepth;
        var extras = (0, _defineProperty._)({}, '__serialized__', (0, _normalizeJs.normalizeToSize)(exception, normalizeDepth));
        var errorFromProp = getErrorPropertyFromObject(exception);
        if (errorFromProp) return [
            errorFromProp,
            extras
        ];
        var message = getMessageForObject(exception);
        var ex = (hint === null || hint === void 0 ? void 0 : hint.syntheticException) || new Error(message);
        ex.message = message;
        return [
            ex,
            extras
        ];
    }
    // This handles when someone does: `throw "something awesome";`
    // We use synthesized Error here so we can extract a (rough) stack trace.
    var ex1 = (hint === null || hint === void 0 ? void 0 : hint.syntheticException) || new Error(exception);
    ex1.message = "".concat(exception);
    return [
        ex1,
        undefined
    ];
}
/**
 * Builds and Event from a Exception
 * @hidden
 */ function eventFromUnknownInput(client, stackParser, exception, hint) {
    var providedMechanism = (hint === null || hint === void 0 ? void 0 : hint.data) && hint.data.mechanism;
    var mechanism = providedMechanism || {
        handled: true,
        type: 'generic'
    };
    var _getException = (0, _slicedToArray._)(getException(client, mechanism, exception, hint), 2), ex = _getException[0], extras = _getException[1];
    var event = {
        exception: {
            values: [
                exceptionFromError(stackParser, ex)
            ]
        }
    };
    if (extras) event.extra = extras;
    (0, _miscJs.addExceptionTypeValue)(event, undefined, undefined);
    (0, _miscJs.addExceptionMechanism)(event, mechanism);
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, event), {
        event_id: hint === null || hint === void 0 ? void 0 : hint.event_id
    });
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function eventFromMessage(stackParser, message) {
    var level = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'info', hint = arguments.length > 3 ? arguments[3] : void 0, attachStacktrace = arguments.length > 4 ? arguments[4] : void 0;
    var event = {
        event_id: hint === null || hint === void 0 ? void 0 : hint.event_id,
        level: level
    };
    if (attachStacktrace && (hint === null || hint === void 0 ? void 0 : hint.syntheticException)) {
        var frames = parseStackFrames(stackParser, hint.syntheticException);
        if (frames.length) {
            event.exception = {
                values: [
                    {
                        value: message,
                        stacktrace: {
                            frames: frames
                        }
                    }
                ]
            };
            (0, _miscJs.addExceptionMechanism)(event, {
                synthetic: true
            });
        }
    }
    if ((0, _isJs.isParameterizedString)(message)) {
        var __sentry_template_string__ = message.__sentry_template_string__, __sentry_template_values__ = message.__sentry_template_values__;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}

},{"@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_sliced_to_array":"8PtL6","./is.js":"kSqSf","./misc.js":"8kac1","./normalize.js":"k9k7R","./object.js":"9SKe9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aRdc0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initAndBind", function() {
    return initAndBind;
});
parcelHelpers.export(exports, "setCurrentClient", function() {
    return setCurrentClient;
});
var _currentScopesJs = require("./currentScopes.js");
var _debugBuildJs = require("./debug-build.js");
var _debugLoggerJs = require("./utils/debug-logger.js");
/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function initAndBind(clientClass, options) {
    if (options.debug === true) {
        if (0, _debugBuildJs.DEBUG_BUILD) (0, _debugLoggerJs.debug).enable();
        else // use `console.warn` rather than `debug.warn` since by non-debug bundles have all `debug.x` statements stripped
        (0, _debugLoggerJs.consoleSandbox)(function() {
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
        });
    }
    var scope = (0, _currentScopesJs.getCurrentScope)();
    scope.update(options.initialScope);
    var client = new clientClass(options);
    setCurrentClient(client);
    client.init();
    return client;
}
/**
 * Make the given client the current client.
 */ function setCurrentClient(client) {
    (0, _currentScopesJs.getCurrentScope)().setClient(client);
}

},{"./currentScopes.js":"3GE4v","./debug-build.js":"ejIQP","./utils/debug-logger.js":"3X9Vf","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2JFdH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MIN_DELAY", function() {
    return MIN_DELAY;
});
parcelHelpers.export(exports, "START_DELAY", function() {
    return START_DELAY;
});
parcelHelpers.export(exports, "makeOfflineTransport", function() {
    return makeOfflineTransport;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _debugBuildJs = require("../debug-build.js");
var _debugLoggerJs = require("../utils/debug-logger.js");
var _envelopeJs = require("../utils/envelope.js");
var _ratelimitJs = require("../utils/ratelimit.js");
var MIN_DELAY = 100; // 100 ms
var START_DELAY = 5000; // 5 seconds
var MAX_DELAY = 3.6e6; // 1 hour
/**
 * Wraps a transport and stores and retries events when they fail to send.
 *
 * @param createTransport The transport to wrap.
 */ function makeOfflineTransport(createTransport) {
    function log() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _debug;
        (0, _debugBuildJs.DEBUG_BUILD) && (_debug = (0, _debugLoggerJs.debug)).log.apply(_debug, [
            '[Offline]:'
        ].concat((0, _toConsumableArray._)(args)));
    }
    return function(options) {
        var transport = createTransport(options);
        if (!options.createStore) throw new Error('No `createStore` function was provided');
        var store = options.createStore(options);
        var retryDelay = START_DELAY;
        var flushTimer;
        function shouldQueue(env, error, retryDelay) {
            // We want to drop client reports because they can be generated when we retry sending events while offline.
            if ((0, _envelopeJs.envelopeContainsItemType)(env, [
                'client_report'
            ])) return false;
            if (options.shouldStore) return options.shouldStore(env, error, retryDelay);
            return true;
        }
        function flushIn(delay) {
            if (flushTimer) clearTimeout(flushTimer);
            flushTimer = setTimeout(function() {
                return (0, _asyncToGenerator._)(function() {
                    var found;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                flushTimer = undefined;
                                return [
                                    4,
                                    store.shift()
                                ];
                            case 1:
                                found = _state.sent();
                                if (found) {
                                    log('Attempting to send previously queued event');
                                    // We should to update the sent_at timestamp to the current time.
                                    found[0].sent_at = new Date().toISOString();
                                    send(found, true).catch(function(e) {
                                        log('Failed to retry sending', e);
                                    });
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }, delay);
            // We need to unref the timer in node.js, otherwise the node process never exit.
            if (typeof flushTimer !== 'number' && flushTimer.unref) flushTimer.unref();
        }
        function flushWithBackOff() {
            if (flushTimer) return;
            flushIn(retryDelay);
            retryDelay = Math.min(retryDelay * 2, MAX_DELAY);
        }
        function send(envelope) {
            var isRetry = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            return (0, _asyncToGenerator._)(function() {
                var _tmp, result, delay, _result_headers, _result_headers1, e;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(!isRetry && (0, _envelopeJs.envelopeContainsItemType)(envelope, [
                                'replay_event',
                                'replay_recording'
                            ]))) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                store.push(envelope)
                            ];
                        case 1:
                            _state.sent();
                            flushIn(MIN_DELAY);
                            return [
                                2,
                                {}
                            ];
                        case 2:
                            _state.trys.push([
                                2,
                                6,
                                ,
                                14
                            ]);
                            _tmp = options.shouldSend;
                            if (!_tmp) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                options.shouldSend(envelope)
                            ];
                        case 3:
                            _tmp = _state.sent() === false;
                            _state.label = 4;
                        case 4:
                            if (_tmp) throw new Error('Envelope not sent because `shouldSend` callback returned false');
                            return [
                                4,
                                transport.send(envelope)
                            ];
                        case 5:
                            result = _state.sent();
                            delay = MIN_DELAY;
                            if (result) {
                                ;
                                // If there's a retry-after header, use that as the next delay.
                                if ((_result_headers = result.headers) === null || _result_headers === void 0 ? void 0 : _result_headers['retry-after']) delay = (0, _ratelimitJs.parseRetryAfterHeader)(result.headers['retry-after']);
                                else if ((_result_headers1 = result.headers) === null || _result_headers1 === void 0 ? void 0 : _result_headers1['x-sentry-rate-limits']) delay = 60000; // 60 seconds
                                else if ((result.statusCode || 0) >= 400) return [
                                    2,
                                    result
                                ];
                            }
                            flushIn(delay);
                            retryDelay = START_DELAY;
                            return [
                                2,
                                result
                            ];
                        case 6:
                            e = _state.sent();
                            return [
                                4,
                                shouldQueue(envelope, e, retryDelay)
                            ];
                        case 7:
                            if (!_state.sent()) return [
                                3,
                                12
                            ];
                            if (!isRetry) return [
                                3,
                                9
                            ];
                            return [
                                4,
                                store.unshift(envelope)
                            ];
                        case 8:
                            _state.sent();
                            return [
                                3,
                                11
                            ];
                        case 9:
                            return [
                                4,
                                store.push(envelope)
                            ];
                        case 10:
                            _state.sent();
                            _state.label = 11;
                        case 11:
                            flushWithBackOff();
                            log('Error sending. Event queued.', e);
                            return [
                                2,
                                {}
                            ];
                        case 12:
                            throw e;
                        case 13:
                            return [
                                3,
                                14
                            ];
                        case 14:
                            return [
                                2
                            ];
                    }
                });
            })();
        }
        if (options.flushAtStartup) flushWithBackOff();
        return {
            send: send,
            flush: function(timeout) {
                // If there's no timeout, we should attempt to flush the offline queue.
                if (timeout === undefined) {
                    retryDelay = START_DELAY;
                    flushIn(MIN_DELAY);
                }
                return transport.flush(timeout);
            }
        };
    };
}

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_to_consumable_array":"1eSZf","@swc/helpers/_/_ts_generator":"78Tqx","../debug-build.js":"ejIQP","../utils/debug-logger.js":"3X9Vf","../utils/envelope.js":"fDBh0","../utils/ratelimit.js":"4EbXl","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gwCcj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "eventFromEnvelope", function() {
    return eventFromEnvelope;
});
parcelHelpers.export(exports, "makeMultiplexedTransport", function() {
    return makeMultiplexedTransport;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _apiJs = require("../api.js");
var _dsnJs = require("../utils/dsn.js");
var _envelopeJs = require("../utils/envelope.js");
/**
 * Gets an event from an envelope.
 *
 * This is only exported for use in the tests
 */ function eventFromEnvelope(env, types) {
    var event;
    (0, _envelopeJs.forEachEnvelopeItem)(env, function(item, type) {
        if (types.includes(type)) event = Array.isArray(item) ? item[1] : undefined;
        // bail out if we found an event
        return !!event;
    });
    return event;
}
/**
 * Creates a transport that overrides the release on all events.
 */ function makeOverrideReleaseTransport(createTransport, release) {
    return function(options) {
        var transport = createTransport(options);
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, transport), {
            send: function(envelope) {
                return (0, _asyncToGenerator._)(function() {
                    var event;
                    return (0, _tsGenerator._)(this, function(_state) {
                        event = eventFromEnvelope(envelope, [
                            'event',
                            'transaction',
                            'profile',
                            'replay_event'
                        ]);
                        if (event) event.release = release;
                        return [
                            2,
                            transport.send(envelope)
                        ];
                    });
                })();
            }
        });
    };
}
/** Overrides the DSN in the envelope header  */ function overrideDsn(envelope, dsn) {
    return (0, _envelopeJs.createEnvelope)(dsn ? (0, _objectSpreadProps._)((0, _objectSpread._)({}, envelope[0]), {
        dsn: dsn
    }) : envelope[0], envelope[1]);
}
/**
 * Creates a transport that can send events to different DSNs depending on the envelope contents.
 */ function makeMultiplexedTransport(createTransport, matcher) {
    return function(options) {
        var fallbackTransport = createTransport(options);
        var otherTransports = new Map();
        function getTransport(dsn, release) {
            // We create a transport for every unique dsn/release combination as there may be code from multiple releases in
            // use at the same time
            var key = release ? "".concat(dsn, ":").concat(release) : dsn;
            var transport = otherTransports.get(key);
            if (!transport) {
                var validatedDsn = (0, _dsnJs.dsnFromString)(dsn);
                if (!validatedDsn) return undefined;
                var url = (0, _apiJs.getEnvelopeEndpointWithUrlEncodedAuth)(validatedDsn, options.tunnel);
                transport = release ? makeOverrideReleaseTransport(createTransport, release)((0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
                    url: url
                })) : createTransport((0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
                    url: url
                }));
                otherTransports.set(key, transport);
            }
            return [
                dsn,
                transport
            ];
        }
        function send(envelope) {
            return (0, _asyncToGenerator._)(function() {
                var transports, transportsWithFallback, results;
                function getEvent(types) {
                    var eventTypes = (types === null || types === void 0 ? void 0 : types.length) ? types : [
                        'event'
                    ];
                    return eventFromEnvelope(envelope, eventTypes);
                }
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            transports = matcher({
                                envelope: envelope,
                                getEvent: getEvent
                            }).map(function(result) {
                                if (typeof result === 'string') return getTransport(result, undefined);
                                else return getTransport(result.dsn, result.release);
                            }).filter(function(t) {
                                return !!t;
                            });
                            // If we have no transports to send to, use the fallback transport
                            // Don't override the DSN in the header for the fallback transport. '' is falsy
                            transportsWithFallback = transports.length ? transports : [
                                [
                                    '',
                                    fallbackTransport
                                ]
                            ];
                            return [
                                4,
                                Promise.all(transportsWithFallback.map(function(param) {
                                    var _param = (0, _slicedToArray._)(param, 2), dsn = _param[0], transport = _param[1];
                                    return transport.send(overrideDsn(envelope, dsn));
                                }))
                            ];
                        case 1:
                            results = _state.sent();
                            return [
                                2,
                                results[0]
                            ];
                    }
                });
            })();
        }
        function flush(timeout) {
            return (0, _asyncToGenerator._)(function() {
                var allTransports, results;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            allTransports = (0, _toConsumableArray._)(otherTransports.values()).concat([
                                fallbackTransport
                            ]);
                            return [
                                4,
                                Promise.all(allTransports.map(function(transport) {
                                    return transport.flush(timeout);
                                }))
                            ];
                        case 1:
                            results = _state.sent();
                            return [
                                2,
                                results.every(function(r) {
                                    return r;
                                })
                            ];
                    }
                });
            })();
        }
        return {
            send: send,
            flush: flush
        };
    };
}

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_to_consumable_array":"1eSZf","@swc/helpers/_/_ts_generator":"78Tqx","../api.js":"9GGAx","../utils/dsn.js":"jNv3f","../utils/envelope.js":"fDBh0","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"Hjmw6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_INTERNAL_clearAiProviderSkips", function() {
    return _INTERNAL_clearAiProviderSkips;
});
parcelHelpers.export(exports, "_INTERNAL_shouldSkipAiProviderWrapping", function() {
    return _INTERNAL_shouldSkipAiProviderWrapping;
});
parcelHelpers.export(exports, "_INTERNAL_skipAiProviderWrapping", function() {
    return _INTERNAL_skipAiProviderWrapping;
});
var _debugBuildJs = require("../../debug-build.js");
var _debugLoggerJs = require("../debug-logger.js");
/**
 * Registry tracking which AI provider modules should skip instrumentation wrapping.
 *
 * This prevents duplicate spans when a higher-level integration (like LangChain)
 * already instruments AI providers at a higher abstraction level.
 */ var SKIPPED_AI_PROVIDERS = new Set();
/**
 * Mark AI provider modules to skip instrumentation wrapping.
 *
 * This prevents duplicate spans when a higher-level integration (like LangChain)
 * already instruments AI providers at a higher abstraction level.
 *
 * @internal
 * @param modules - Array of npm module names to skip (e.g., '@anthropic-ai/sdk', 'openai')
 *
 * @example
 * ```typescript
 * // In LangChain integration
 * _INTERNAL_skipAiProviderWrapping(['@anthropic-ai/sdk', 'openai', '@google/generative-ai']);
 * ```
 */ function _INTERNAL_skipAiProviderWrapping(modules) {
    modules.forEach(function(module) {
        SKIPPED_AI_PROVIDERS.add(module);
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log('AI provider "'.concat(module, '" wrapping will be skipped'));
    });
}
/**
 * Check if an AI provider module should skip instrumentation wrapping.
 *
 * @internal
 * @param module - The npm module name (e.g., '@anthropic-ai/sdk', 'openai')
 * @returns true if wrapping should be skipped
 *
 * @example
 * ```typescript
 * // In AI provider instrumentation
 * if (_INTERNAL_shouldSkipAiProviderWrapping('@anthropic-ai/sdk')) {
 *   return Reflect.construct(Original, args); // Don't instrument
 * }
 * ```
 */ function _INTERNAL_shouldSkipAiProviderWrapping(module) {
    return SKIPPED_AI_PROVIDERS.has(module);
}
/**
 * Clear all AI provider skip registrations.
 *
 * This is automatically called at the start of Sentry.init() to ensure a clean state
 * between different client initializations.
 *
 * @internal
 */ function _INTERNAL_clearAiProviderSkips() {
    SKIPPED_AI_PROVIDERS.clear();
    (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log('Cleared AI provider skip registrations');
}

},{"../../debug-build.js":"ejIQP","../debug-logger.js":"3X9Vf","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"s5mmt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isSentryRequestUrl", function() {
    return isSentryRequestUrl;
});
var _urlJs = require("./url.js");
/**
 * Checks whether given url points to Sentry server
 *
 * @param url url to verify
 */ function isSentryRequestUrl(url, client) {
    var dsn = client === null || client === void 0 ? void 0 : client.getDsn();
    var tunnel = client === null || client === void 0 ? void 0 : client.getOptions().tunnel;
    return checkDsn(url, dsn) || checkTunnel(url, tunnel);
}
function checkTunnel(url, tunnel) {
    if (!tunnel) return false;
    return removeTrailingSlash(url) === removeTrailingSlash(tunnel);
}
function checkDsn(url, dsn) {
    // Requests to Sentry's ingest endpoint must have a `sentry_key` in the query string
    // This is equivalent to the public_key which is required in the DSN
    // see https://develop.sentry.dev/sdk/overview/#parsing-the-dsn
    // Therefore, a request to the same host and with a `sentry_key` in the query string
    // can be considered a request to the ingest endpoint.
    var urlParts = (0, _urlJs.parseStringToURLObject)(url);
    if (!urlParts || (0, _urlJs.isURLObjectRelative)(urlParts)) return false;
    return dsn ? urlParts.host.includes(dsn.host) && /(^|&|\?)sentry_key=/.test(urlParts.search) : false;
}
function removeTrailingSlash(str) {
    return str[str.length - 1] === '/' ? str.slice(0, -1) : str;
}

},{"./url.js":"5Wd7K","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5Wd7K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getHttpSpanDetailsFromUrlObject", function() {
    return getHttpSpanDetailsFromUrlObject;
});
parcelHelpers.export(exports, "getSanitizedUrlString", function() {
    return getSanitizedUrlString;
});
parcelHelpers.export(exports, "getSanitizedUrlStringFromUrlObject", function() {
    return getSanitizedUrlStringFromUrlObject;
});
parcelHelpers.export(exports, "isURLObjectRelative", function() {
    return isURLObjectRelative;
});
parcelHelpers.export(exports, "parseStringToURLObject", function() {
    return parseStringToURLObject;
});
parcelHelpers.export(exports, "parseUrl", function() {
    return parseUrl;
});
parcelHelpers.export(exports, "stripUrlQueryAndFragment", function() {
    return stripUrlQueryAndFragment;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _semanticAttributesJs = require("../semanticAttributes.js");
// Curious about `thismessage:/`? See: https://www.rfc-editor.org/rfc/rfc2557.html
//  > When the methods above do not yield an absolute URI, a base URL
//  > of "thismessage:/" MUST be employed. This base URL has been
//  > defined for the sole purpose of resolving relative references
//  > within a multipart/related structure when no other base URI is
//  > specified.
//
// We need to provide a base URL to `parseStringToURLObject` because the fetch API gives us a
// relative URL sometimes.
//
// This is the only case where we need to provide a base URL to `parseStringToURLObject`
// because the relative URL is not valid on its own.
var DEFAULT_BASE_URL = 'thismessage:/';
/**
 * Checks if the URL object is relative
 *
 * @param url - The URL object to check
 * @returns True if the URL object is relative, false otherwise
 */ function isURLObjectRelative(url) {
    return 'isRelative' in url;
}
/**
 * Parses string to a URL object
 *
 * @param url - The URL to parse
 * @returns The parsed URL object or undefined if the URL is invalid
 */ function parseStringToURLObject(url, urlBase) {
    var isRelative = url.indexOf('://') <= 0 && url.indexOf('//') !== 0;
    var base = urlBase !== null && urlBase !== void 0 ? urlBase : isRelative ? DEFAULT_BASE_URL : undefined;
    try {
        // Use `canParse` to short-circuit the URL constructor if it's not a valid URL
        // This is faster than trying to construct the URL and catching the error
        // Node 20+, Chrome 120+, Firefox 115+, Safari 17+
        if ('canParse' in URL && !URL.canParse(url, base)) return undefined;
        var fullUrlObject = new URL(url, base);
        if (isRelative) // Because we used a fake base URL, we need to return a relative URL object.
        // We cannot return anything about the origin, host, etc. because it will refer to the fake base URL.
        return {
            isRelative: isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch (e) {
    // empty body
    }
    return undefined;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function getSanitizedUrlStringFromUrlObject(url) {
    if (isURLObjectRelative(url)) return url.pathname;
    var newUrl = new URL(url);
    newUrl.search = '';
    newUrl.hash = '';
    if ([
        '80',
        '443'
    ].includes(newUrl.port)) newUrl.port = '';
    if (newUrl.password) newUrl.password = '%filtered%';
    if (newUrl.username) newUrl.username = '%filtered%';
    return newUrl.toString();
}
function getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName) {
    var _request_method;
    var _request_method_toUpperCase;
    var method = (_request_method_toUpperCase = request === null || request === void 0 ? void 0 : (_request_method = request.method) === null || _request_method === void 0 ? void 0 : _request_method.toUpperCase()) !== null && _request_method_toUpperCase !== void 0 ? _request_method_toUpperCase : 'GET';
    var route = routeName ? routeName : urlObject ? kind === 'client' ? getSanitizedUrlStringFromUrlObject(urlObject) : urlObject.pathname : '/';
    return "".concat(method, " ").concat(route);
}
/**
 * Takes a parsed URL object and returns a set of attributes for the span
 * that represents the HTTP request for that url. This is used for both server
 * and client http spans.
 *
 * Follows https://opentelemetry.io/docs/specs/semconv/http/.
 *
 * @param urlObject - see {@link parseStringToURLObject}
 * @param kind - The type of HTTP operation (server or client)
 * @param spanOrigin - The origin of the span
 * @param request - The request object, see {@link PartialRequest}
 * @param routeName - The name of the route, must be low cardinality
 * @returns The span name and attributes for the HTTP operation
 */ function getHttpSpanDetailsFromUrlObject(urlObject, kind, spanOrigin, request, routeName) {
    var _obj;
    var attributes = (_obj = {}, (0, _defineProperty._)(_obj, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), spanOrigin), (0, _defineProperty._)(_obj, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), 'url'), _obj);
    if (routeName) {
        // This is based on https://opentelemetry.io/docs/specs/semconv/http/http-spans/#name
        attributes[kind === 'server' ? 'http.route' : 'url.template'] = routeName;
        attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = 'route';
    }
    if (request === null || request === void 0 ? void 0 : request.method) attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD] = request.method.toUpperCase();
    if (urlObject) {
        if (urlObject.search) attributes['url.query'] = urlObject.search;
        if (urlObject.hash) attributes['url.fragment'] = urlObject.hash;
        if (urlObject.pathname) {
            attributes['url.path'] = urlObject.pathname;
            if (urlObject.pathname === '/') attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = 'route';
        }
        if (!isURLObjectRelative(urlObject)) {
            attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_URL_FULL] = urlObject.href;
            if (urlObject.port) attributes['url.port'] = urlObject.port;
            if (urlObject.protocol) attributes['url.scheme'] = urlObject.protocol;
            if (urlObject.hostname) attributes[kind === 'server' ? 'server.address' : 'url.domain'] = urlObject.hostname;
        }
    }
    return [
        getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName),
        attributes
    ];
}
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function parseUrl(url) {
    if (!url) return {};
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function stripUrlQueryAndFragment(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function getSanitizedUrlString(url) {
    var protocol = url.protocol, host = url.host, path = url.path;
    var filteredHost = (host === null || host === void 0 ? void 0 : host.replace(/^.*@/, '[filtered]:[filtered]@')// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, '').replace(/(:443)$/, '')) || '';
    return "".concat(protocol ? "".concat(protocol, "://") : '').concat(filteredHost).concat(path);
}

},{"@swc/helpers/_/_define_property":"e80IS","../semanticAttributes.js":"7WRPE","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2z7TO":[function(require,module,exports,__globalThis) {
/**
 * Tagged template function which returns parameterized representation of the message
 * For example: parameterize`This is a log statement with ${x} and ${y} params`, would return:
 * "__sentry_template_string__": 'This is a log statement with %s and %s params',
 * "__sentry_template_values__": ['first', 'second']
 *
 * @param strings An array of string values splitted between expressions
 * @param values Expressions extracted from template string
 *
 * @returns A `ParameterizedString` object that can be passed into `captureMessage` or Sentry.logger.X methods.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fmt", function() {
    return fmt;
});
parcelHelpers.export(exports, "parameterize", function() {
    return parameterize;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
function parameterize(strings) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        values[_key - 1] = arguments[_key];
    }
    var _String;
    var formatted = new String((_String = String).raw.apply(_String, [
        strings
    ].concat((0, _toConsumableArray._)(values))));
    formatted.__sentry_template_string__ = strings.join('\x00').replace(/%/g, '%%').replace(/\0/g, '%s');
    formatted.__sentry_template_values__ = values;
    return formatted;
}
/**
 * Tagged template function which returns parameterized representation of the message.
 *
 * @param strings An array of string values splitted between expressions
 * @param values Expressions extracted from template string
 * @returns A `ParameterizedString` object that can be passed into `captureMessage` or Sentry.logger.X methods.
 */ var fmt = parameterize;

},{"@swc/helpers/_/_to_consumable_array":"1eSZf","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iYZFY":[function(require,module,exports,__globalThis) {
// By default, we want to infer the IP address, unless this is explicitly set to `null`
// We do this after all other processing is done
// If `ip_address` is explicitly set to `null` or a value, we leave it as is
/**
 * @internal
 * @deprecated -- set ip inferral via via SDK metadata options on client instead.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addAutoIpAddressToSession", function() {
    return addAutoIpAddressToSession;
});
parcelHelpers.export(exports, "addAutoIpAddressToUser", function() {
    return addAutoIpAddressToUser;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
function addAutoIpAddressToUser(objWithMaybeUser) {
    var _objWithMaybeUser_user;
    if (((_objWithMaybeUser_user = objWithMaybeUser.user) === null || _objWithMaybeUser_user === void 0 ? void 0 : _objWithMaybeUser_user.ip_address) === undefined) objWithMaybeUser.user = (0, _objectSpreadProps._)((0, _objectSpread._)({}, objWithMaybeUser.user), {
        ip_address: '{{auto}}'
    });
}
/**
 * @internal
 */ function addAutoIpAddressToSession(session) {
    var _session_attrs;
    if ('aggregates' in session) {
        if (((_session_attrs = session.attrs) === null || _session_attrs === void 0 ? void 0 : _session_attrs['ip_address']) === undefined) session.attrs = (0, _objectSpreadProps._)((0, _objectSpread._)({}, session.attrs), {
            ip_address: '{{auto}}'
        });
    } else if (session.ipAddress === undefined) session.ipAddress = '{{auto}}';
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9SY37":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applySdkMetadata", function() {
    return applySdkMetadata;
});
var _versionJs = require("./version.js");
/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function applySdkMetadata(options, name) {
    var names = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [
        name
    ], source = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 'npm';
    var metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: "sentry.javascript.".concat(name),
        packages: names.map(function(name) {
            return {
                name: "".concat(source, ":@sentry/").concat(name),
                version: (0, _versionJs.SDK_VERSION)
            };
        }),
        version: (0, _versionJs.SDK_VERSION)
    };
    options._metadata = metadata;
}

},{"./version.js":"q6Wm7","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1Pg6b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTraceData", function() {
    return getTraceData;
});
var _indexJs = require("../asyncContext/index.js");
var _carrierJs = require("../carrier.js");
var _currentScopesJs = require("../currentScopes.js");
var _exportsJs = require("../exports.js");
var _debugLoggerJs = require("./debug-logger.js");
var _spanUtilsJs = require("./spanUtils.js");
var _dynamicSamplingContextJs = require("../tracing/dynamicSamplingContext.js");
var _baggageJs = require("./baggage.js");
var _tracingJs = require("./tracing.js");
/**
 * Extracts trace propagation data from the current span or from the client's scope (via transaction or propagation
 * context) and serializes it to `sentry-trace` and `baggage` values. These values can be used to propagate
 * a trace via our tracing Http headers or Html `<meta>` tags.
 *
 * This function also applies some validation to the generated sentry-trace and baggage values to ensure that
 * only valid strings are returned.
 *
 * If (@param options.propagateTraceparent) is `true`, the function will also generate a `traceparent` value,
 * following the W3C traceparent header format.
 *
 * @returns an object with the tracing data values. The object keys are the name of the tracing key to be used as header
 * or meta tag name.
 */ function getTraceData() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var client = options.client || (0, _currentScopesJs.getClient)();
    if (!(0, _exportsJs.isEnabled)() || !client) return {};
    var carrier = (0, _carrierJs.getMainCarrier)();
    var acs = (0, _indexJs.getAsyncContextStrategy)(carrier);
    if (acs.getTraceData) return acs.getTraceData(options);
    var scope = options.scope || (0, _currentScopesJs.getCurrentScope)();
    var span = options.span || (0, _spanUtilsJs.getActiveSpan)();
    var sentryTrace = span ? (0, _spanUtilsJs.spanToTraceHeader)(span) : scopeToTraceHeader(scope);
    var dsc = span ? (0, _dynamicSamplingContextJs.getDynamicSamplingContextFromSpan)(span) : (0, _dynamicSamplingContextJs.getDynamicSamplingContextFromScope)(client, scope);
    var baggage = (0, _baggageJs.dynamicSamplingContextToSentryBaggageHeader)(dsc);
    var isValidSentryTraceHeader = (0, _tracingJs.TRACEPARENT_REGEXP).test(sentryTrace);
    if (!isValidSentryTraceHeader) {
        (0, _debugLoggerJs.debug).warn('Invalid sentry-trace data. Cannot generate trace data');
        return {};
    }
    var traceData = {
        'sentry-trace': sentryTrace,
        baggage: baggage
    };
    if (options.propagateTraceparent) {
        var traceparent = span ? (0, _spanUtilsJs.spanToTraceparentHeader)(span) : scopeToTraceparentHeader(scope);
        if (traceparent) traceData.traceparent = traceparent;
    }
    return traceData;
}
/**
 * Get a sentry-trace header value for the given scope.
 */ function scopeToTraceHeader(scope) {
    var _scope_getPropagationContext = scope.getPropagationContext(), traceId = _scope_getPropagationContext.traceId, sampled = _scope_getPropagationContext.sampled, propagationSpanId = _scope_getPropagationContext.propagationSpanId;
    return (0, _tracingJs.generateSentryTraceHeader)(traceId, propagationSpanId, sampled);
}
function scopeToTraceparentHeader(scope) {
    var _scope_getPropagationContext = scope.getPropagationContext(), traceId = _scope_getPropagationContext.traceId, sampled = _scope_getPropagationContext.sampled, propagationSpanId = _scope_getPropagationContext.propagationSpanId;
    return (0, _tracingJs.generateTraceparentHeader)(traceId, propagationSpanId, sampled);
}

},{"../asyncContext/index.js":"8OVZH","../carrier.js":"abKK3","../currentScopes.js":"3GE4v","../exports.js":"1Xqap","./debug-logger.js":"3X9Vf","./spanUtils.js":"fPRKj","../tracing/dynamicSamplingContext.js":"5RiCd","./baggage.js":"8aTvT","./tracing.js":"f5SYf","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5KnUB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTraceMetaTags", function() {
    return getTraceMetaTags;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _traceDataJs = require("./traceData.js");
/**
 * Returns a string of meta tags that represent the current trace data.
 *
 * You can use this to propagate a trace from your server-side rendered Html to the browser.
 * This function returns up to two meta tags, `sentry-trace` and `baggage`, depending on the
 * current trace data state.
 *
 * @example
 * Usage example:
 *
 * ```js
 * function renderHtml() {
 *   return `
 *     <head>
 *       ${getTraceMetaTags()}
 *     </head>
 *   `;
 * }
 * ```
 *
 */ function getTraceMetaTags(traceData) {
    return Object.entries(traceData || (0, _traceDataJs.getTraceData)()).map(function(param) {
        var _param = (0, _slicedToArray._)(param, 2), key = _param[0], value = _param[1];
        return '<meta name="'.concat(key, '" content="').concat(value, '"/>');
    }).join('\n');
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","./traceData.js":"1Pg6b","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gc533":[function(require,module,exports,__globalThis) {
/**
 * Heavily simplified debounce function based on lodash.debounce.
 *
 * This function takes a callback function (@param fun) and delays its invocation
 * by @param wait milliseconds. Optionally, a maxWait can be specified in @param options,
 * which ensures that the callback is invoked at least once after the specified max. wait time.
 *
 * @param func the function whose invocation is to be debounced
 * @param wait the minimum time until the function is invoked after it was called once
 * @param options the options object, which can contain the `maxWait` property
 *
 * @returns the debounced version of the function, which needs to be called at least once to start the
 *          debouncing process. Subsequent calls will reset the debouncing timer and, in case @paramfunc
 *          was already invoked in the meantime, return @param func's return value.
 *          The debounced function has two additional properties:
 *          - `flush`: Invokes the debounced function immediately and returns its return value
 *          - `cancel`: Cancels the debouncing process and resets the debouncing timer
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "debounce", function() {
    return debounce;
});
function debounce(func, wait, options) {
    var callbackReturnValue;
    var timerId;
    var maxTimerId;
    var maxWait = (options === null || options === void 0 ? void 0 : options.maxWait) ? Math.max(options.maxWait, wait) : 0;
    var setTimeoutImpl = (options === null || options === void 0 ? void 0 : options.setTimeoutImpl) || setTimeout;
    function invokeFunc() {
        cancelTimers();
        callbackReturnValue = func();
        return callbackReturnValue;
    }
    function cancelTimers() {
        timerId !== undefined && clearTimeout(timerId);
        maxTimerId !== undefined && clearTimeout(maxTimerId);
        timerId = maxTimerId = undefined;
    }
    function flush() {
        if (timerId !== undefined || maxTimerId !== undefined) return invokeFunc();
        return callbackReturnValue;
    }
    function debounced() {
        if (timerId) clearTimeout(timerId);
        timerId = setTimeoutImpl(invokeFunc, wait);
        if (maxWait && maxTimerId === undefined) maxTimerId = setTimeoutImpl(invokeFunc, maxWait);
        return callbackReturnValue;
    }
    debounced.cancel = cancelTimers;
    debounced.flush = flush;
    return debounced;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eSNLU":[function(require,module,exports,__globalThis) {
/**
 * Transforms a `Headers` object that implements the `Web Fetch API` (https://developer.mozilla.org/en-US/docs/Web/API/Headers) into a simple key-value dict.
 * The header keys will be lower case: e.g. A "Content-Type" header will be stored as "content-type".
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extractQueryParamsFromUrl", function() {
    return extractQueryParamsFromUrl;
});
parcelHelpers.export(exports, "headersToDict", function() {
    return headersToDict;
});
parcelHelpers.export(exports, "httpHeadersToSpanAttributes", function() {
    return httpHeadersToSpanAttributes;
});
parcelHelpers.export(exports, "httpRequestToRequestData", function() {
    return httpRequestToRequestData;
});
parcelHelpers.export(exports, "winterCGHeadersToDict", function() {
    return winterCGHeadersToDict;
});
parcelHelpers.export(exports, "winterCGRequestToRequestData", function() {
    return winterCGRequestToRequestData;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
function winterCGHeadersToDict(winterCGHeaders) {
    var headers = {};
    try {
        winterCGHeaders.forEach(function(value, key) {
            if (typeof value === 'string') // We check that value is a string even though it might be redundant to make sure prototype pollution is not possible.
            headers[key] = value;
        });
    } catch (e) {
    // just return the empty headers
    }
    return headers;
}
/**
 * Convert common request headers to a simple dictionary.
 */ function headersToDict(reqHeaders) {
    var headers = Object.create(null);
    try {
        Object.entries(reqHeaders).forEach(function(param) {
            var _param = (0, _slicedToArray._)(param, 2), key = _param[0], value = _param[1];
            if (typeof value === 'string') headers[key] = value;
        });
    } catch (e) {
    // just return the empty headers
    }
    return headers;
}
/**
 * Converts a `Request` object that implements the `Web Fetch API` (https://developer.mozilla.org/en-US/docs/Web/API/Headers) into the format that the `RequestData` integration understands.
 */ function winterCGRequestToRequestData(req) {
    var headers = winterCGHeadersToDict(req.headers);
    return {
        method: req.method,
        url: req.url,
        query_string: extractQueryParamsFromUrl(req.url),
        headers: headers
    };
}
/**
 * Convert a HTTP request object to RequestEventData to be passed as normalizedRequest.
 * Instead of allowing `PolymorphicRequest` to be passed,
 * we want to be more specific and generally require a http.IncomingMessage-like object.
 */ function httpRequestToRequestData(request) {
    var _request_socket;
    var headers = request.headers || {};
    // Check for x-forwarded-host first, then fall back to host header
    var forwardedHost = typeof headers['x-forwarded-host'] === 'string' ? headers['x-forwarded-host'] : undefined;
    var host = forwardedHost || (typeof headers.host === 'string' ? headers.host : undefined);
    // Check for x-forwarded-proto first, then fall back to existing protocol detection
    var forwardedProto = typeof headers['x-forwarded-proto'] === 'string' ? headers['x-forwarded-proto'] : undefined;
    var protocol = forwardedProto || request.protocol || (((_request_socket = request.socket) === null || _request_socket === void 0 ? void 0 : _request_socket.encrypted) ? 'https' : 'http');
    var url = request.url || '';
    var absoluteUrl = getAbsoluteUrl({
        url: url,
        host: host,
        protocol: protocol
    });
    // This is non-standard, but may be sometimes set
    // It may be overwritten later by our own body handling
    var data = request.body || undefined;
    // This is non-standard, but may be set on e.g. Next.js or Express requests
    var cookies = request.cookies;
    return {
        url: absoluteUrl,
        method: request.method,
        query_string: extractQueryParamsFromUrl(url),
        headers: headersToDict(headers),
        cookies: cookies,
        data: data
    };
}
function getAbsoluteUrl(param) {
    var url = param.url, protocol = param.protocol, host = param.host;
    if (url === null || url === void 0 ? void 0 : url.startsWith('http')) return url;
    if (url && host) return "".concat(protocol, "://").concat(host).concat(url);
    return undefined;
}
// "-user" because otherwise it would match "user-agent"
var SENSITIVE_HEADER_SNIPPETS = [
    'auth',
    'token',
    'secret',
    'cookie',
    '-user',
    'password',
    'key',
    'jwt',
    'bearer',
    'sso',
    'saml'
];
/**
 * Converts incoming HTTP request headers to OpenTelemetry span attributes following semantic conventions.
 * Header names are converted to the format: http.request.header.<key>
 * where <key> is the header name in lowercase with dashes converted to underscores.
 *
 * @see https://opentelemetry.io/docs/specs/semconv/registry/attributes/http/#http-request-header
 */ function httpHeadersToSpanAttributes(headers) {
    var spanAttributes = {};
    try {
        Object.entries(headers).forEach(function(param) {
            var _param = (0, _slicedToArray._)(param, 2), key = _param[0], value = _param[1];
            if (value == null) return;
            var lowerCasedKey = key.toLowerCase();
            var isSensitive = SENSITIVE_HEADER_SNIPPETS.some(function(snippet) {
                return lowerCasedKey.includes(snippet);
            });
            var normalizedKey = "http.request.header.".concat(lowerCasedKey.replace(/-/g, '_'));
            if (isSensitive) spanAttributes[normalizedKey] = '[Filtered]';
            else if (Array.isArray(value)) spanAttributes[normalizedKey] = value.map(function(v) {
                return v != null ? String(v) : v;
            }).join(';');
            else if (typeof value === 'string') spanAttributes[normalizedKey] = value;
        });
    } catch (e) {
    // Return empty object if there's an error
    }
    return spanAttributes;
}
/** Extract the query params from an URL. */ function extractQueryParamsFromUrl(url) {
    // url is path and query string
    if (!url) return;
    try {
        // The `URL` constructor can't handle internal URLs of the form `/some/path/here`, so stick a dummy protocol and
        // hostname as the base. Since the point here is just to grab the query string, it doesn't matter what we use.
        var queryParams = new URL(url, 'http://s.io').search.slice(1);
        return queryParams.length ? queryParams : undefined;
    } catch (e) {
        return undefined;
    }
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"d8fz5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addBreadcrumb", function() {
    return addBreadcrumb;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _currentScopesJs = require("./currentScopes.js");
var _debugLoggerJs = require("./utils/debug-logger.js");
var _timeJs = require("./utils/time.js");
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ var DEFAULT_BREADCRUMBS = 100;
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 */ function addBreadcrumb(breadcrumb, hint) {
    var client = (0, _currentScopesJs.getClient)();
    var isolationScope = (0, _currentScopesJs.getIsolationScope)();
    if (!client) return;
    var _client_getOptions = client.getOptions(), _client_getOptions_beforeBreadcrumb = _client_getOptions.beforeBreadcrumb, beforeBreadcrumb = _client_getOptions_beforeBreadcrumb === void 0 ? null : _client_getOptions_beforeBreadcrumb, _client_getOptions_maxBreadcrumbs = _client_getOptions.maxBreadcrumbs, maxBreadcrumbs = _client_getOptions_maxBreadcrumbs === void 0 ? DEFAULT_BREADCRUMBS : _client_getOptions_maxBreadcrumbs;
    if (maxBreadcrumbs <= 0) return;
    var timestamp = (0, _timeJs.dateTimestampInSeconds)();
    var mergedBreadcrumb = (0, _objectSpread._)({
        timestamp: timestamp
    }, breadcrumb);
    var finalBreadcrumb = beforeBreadcrumb ? (0, _debugLoggerJs.consoleSandbox)(function() {
        return beforeBreadcrumb(mergedBreadcrumb, hint);
    }) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}

},{"@swc/helpers/_/_object_spread":"9gdrV","./currentScopes.js":"3GE4v","./utils/debug-logger.js":"3X9Vf","./utils/time.js":"i4V6H","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aMTOV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "functionToStringIntegration", function() {
    return functionToStringIntegration;
});
var _currentScopesJs = require("../currentScopes.js");
var _integrationJs = require("../integration.js");
var _objectJs = require("../utils/object.js");
var originalFunctionToString;
var INTEGRATION_NAME = 'FunctionToString';
var SETUP_CLIENTS = new WeakMap();
var _functionToStringIntegration = function() {
    return {
        name: INTEGRATION_NAME,
        setupOnce: function setupOnce() {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                Function.prototype.toString = function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    var originalFunction = (0, _objectJs.getOriginalFunction)(this);
                    var context = SETUP_CLIENTS.has((0, _currentScopesJs.getClient)()) && originalFunction !== undefined ? originalFunction : this;
                    return originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup: function setup(client) {
            SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ var functionToStringIntegration = (0, _integrationJs.defineIntegration)(_functionToStringIntegration);

},{"../currentScopes.js":"3GE4v","../integration.js":"brH19","../utils/object.js":"9SKe9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5sYiA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "eventFiltersIntegration", function() {
    return eventFiltersIntegration;
});
parcelHelpers.export(exports, "inboundFiltersIntegration", function() {
    return inboundFiltersIntegration;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _debugBuildJs = require("../debug-build.js");
var _integrationJs = require("../integration.js");
var _debugLoggerJs = require("../utils/debug-logger.js");
var _eventUtilsJs = require("../utils/eventUtils.js");
var _miscJs = require("../utils/misc.js");
var _stringJs = require("../utils/string.js");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
var DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/,
    /^Can't find variable: gmo$/,
    /^undefined is not an object \(evaluating 'a\.[A-Z]'\)$/,
    'can\'t redefine non-configurable property "solana"',
    "vv().getRestrictions is not a function. (In 'vv().getRestrictions(1,a)', 'vv().getRestrictions' is undefined)",
    "Can't find variable: _AutofillCallbackHandler",
    /^Non-Error promise rejection captured with value: Object Not Found Matching Id:\d+, MethodName:simulateEvent, ParamCount:\d+$/,
    /^Java exception was raised during method invocation$/
];
/** Options for the EventFilters integration */ var INTEGRATION_NAME = 'EventFilters';
/**
 * An integration that filters out events (errors and transactions) based on:
 *
 * - (Errors) A curated list of known low-value or irrelevant errors (see {@link DEFAULT_IGNORE_ERRORS})
 * - (Errors) A list of error messages or urls/filenames passed in via
 *   - Top level Sentry.init options (`ignoreErrors`, `denyUrls`, `allowUrls`)
 *   - The same options passed to the integration directly via @param options
 * - (Transactions/Spans) A list of root span (transaction) names passed in via
 *   - Top level Sentry.init option (`ignoreTransactions`)
 *   - The same option passed to the integration directly via @param options
 *
 * Events filtered by this integration will not be sent to Sentry.
 */ var eventFiltersIntegration = (0, _integrationJs.defineIntegration)(function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var mergedOptions;
    return {
        name: INTEGRATION_NAME,
        setup: function setup(client) {
            var clientOptions = client.getOptions();
            mergedOptions = _mergeOptions(options, clientOptions);
        },
        processEvent: function processEvent(event, _hint, client) {
            if (!mergedOptions) {
                var clientOptions = client.getOptions();
                mergedOptions = _mergeOptions(options, clientOptions);
            }
            return _shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
});
/**
 * An integration that filters out events (errors and transactions) based on:
 *
 * - (Errors) A curated list of known low-value or irrelevant errors (see {@link DEFAULT_IGNORE_ERRORS})
 * - (Errors) A list of error messages or urls/filenames passed in via
 *   - Top level Sentry.init options (`ignoreErrors`, `denyUrls`, `allowUrls`)
 *   - The same options passed to the integration directly via @param options
 * - (Transactions/Spans) A list of root span (transaction) names passed in via
 *   - Top level Sentry.init option (`ignoreTransactions`)
 *   - The same option passed to the integration directly via @param options
 *
 * Events filtered by this integration will not be sent to Sentry.
 *
 * @deprecated this integration was renamed and will be removed in a future major version.
 * Use `eventFiltersIntegration` instead.
 */ var inboundFiltersIntegration = (0, _integrationJs.defineIntegration)(function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, eventFiltersIntegration(options)), {
        name: 'InboundFilters'
    });
});
function _mergeOptions() {
    var internalOptions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, clientOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return {
        allowUrls: (0, _toConsumableArray._)(internalOptions.allowUrls || []).concat((0, _toConsumableArray._)(clientOptions.allowUrls || [])),
        denyUrls: (0, _toConsumableArray._)(internalOptions.denyUrls || []).concat((0, _toConsumableArray._)(clientOptions.denyUrls || [])),
        ignoreErrors: (0, _toConsumableArray._)(internalOptions.ignoreErrors || []).concat((0, _toConsumableArray._)(clientOptions.ignoreErrors || []), (0, _toConsumableArray._)(internalOptions.disableErrorDefaults ? [] : DEFAULT_IGNORE_ERRORS)),
        ignoreTransactions: (0, _toConsumableArray._)(internalOptions.ignoreTransactions || []).concat((0, _toConsumableArray._)(clientOptions.ignoreTransactions || []))
    };
}
function _shouldDropEvent(event, options) {
    if (!event.type) {
        // Filter errors
        if (_isIgnoredError(event, options.ignoreErrors)) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: ".concat((0, _miscJs.getEventDescription)(event)));
            return true;
        }
        if (_isUselessError(event)) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn("Event dropped due to not having an error message, error type or stacktrace.\nEvent: ".concat((0, _miscJs.getEventDescription)(event)));
            return true;
        }
        if (_isDeniedUrl(event, options.denyUrls)) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn("Event dropped due to being matched by `denyUrls` option.\nEvent: ".concat((0, _miscJs.getEventDescription)(event), ".\nUrl: ").concat(_getEventFilterUrl(event)));
            return true;
        }
        if (!_isAllowedUrl(event, options.allowUrls)) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn("Event dropped due to not being matched by `allowUrls` option.\nEvent: ".concat((0, _miscJs.getEventDescription)(event), ".\nUrl: ").concat(_getEventFilterUrl(event)));
            return true;
        }
    } else if (event.type === 'transaction') // Filter transactions
    {
        if (_isIgnoredTransaction(event, options.ignoreTransactions)) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn("Event dropped due to being matched by `ignoreTransactions` option.\nEvent: ".concat((0, _miscJs.getEventDescription)(event)));
            return true;
        }
    }
    return false;
}
function _isIgnoredError(event, ignoreErrors) {
    if (!(ignoreErrors === null || ignoreErrors === void 0 ? void 0 : ignoreErrors.length)) return false;
    return (0, _eventUtilsJs.getPossibleEventMessages)(event).some(function(message) {
        return (0, _stringJs.stringMatchesSomePattern)(message, ignoreErrors);
    });
}
function _isIgnoredTransaction(event, ignoreTransactions) {
    if (!(ignoreTransactions === null || ignoreTransactions === void 0 ? void 0 : ignoreTransactions.length)) return false;
    var name = event.transaction;
    return name ? (0, _stringJs.stringMatchesSomePattern)(name, ignoreTransactions) : false;
}
function _isDeniedUrl(event, denyUrls) {
    if (!(denyUrls === null || denyUrls === void 0 ? void 0 : denyUrls.length)) return false;
    var url = _getEventFilterUrl(event);
    return !url ? false : (0, _stringJs.stringMatchesSomePattern)(url, denyUrls);
}
function _isAllowedUrl(event, allowUrls) {
    if (!(allowUrls === null || allowUrls === void 0 ? void 0 : allowUrls.length)) return true;
    var url = _getEventFilterUrl(event);
    return !url ? true : (0, _stringJs.stringMatchesSomePattern)(url, allowUrls);
}
function _getLastValidUrl() {
    var frames = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    for(var i = frames.length - 1; i >= 0; i--){
        var frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function _getEventFilterUrl(event) {
    try {
        var _event_exception, _rootException_stacktrace;
        var _event_exception_values;
        // If there are linked exceptions or exception aggregates we only want to match against the top frame of the "root" (the main exception)
        // The root always comes last in linked exceptions
        var rootException = (0, _toConsumableArray._)((_event_exception_values = (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : _event_exception.values) !== null && _event_exception_values !== void 0 ? _event_exception_values : []).reverse().find(function(value) {
            var _value_mechanism, _value_stacktrace_frames, _value_stacktrace;
            return ((_value_mechanism = value.mechanism) === null || _value_mechanism === void 0 ? void 0 : _value_mechanism.parent_id) === undefined && ((_value_stacktrace = value.stacktrace) === null || _value_stacktrace === void 0 ? void 0 : (_value_stacktrace_frames = _value_stacktrace.frames) === null || _value_stacktrace_frames === void 0 ? void 0 : _value_stacktrace_frames.length);
        });
        var frames = rootException === null || rootException === void 0 ? void 0 : (_rootException_stacktrace = rootException.stacktrace) === null || _rootException_stacktrace === void 0 ? void 0 : _rootException_stacktrace.frames;
        return frames ? _getLastValidUrl(frames) : null;
    } catch (e) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).error("Cannot extract url for event ".concat((0, _miscJs.getEventDescription)(event)));
        return null;
    }
}
function _isUselessError(event) {
    var _event_exception_values, _event_exception;
    // We only want to consider events for dropping that actually have recorded exception values.
    if (!((_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values.length)) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some(function(value) {
        return value.stacktrace || value.type && value.type !== 'Error' || value.value;
    }));
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_to_consumable_array":"1eSZf","../debug-build.js":"ejIQP","../integration.js":"brH19","../utils/debug-logger.js":"3X9Vf","../utils/eventUtils.js":"chqjg","../utils/misc.js":"8kac1","../utils/string.js":"j38bn","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"j9IHf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "linkedErrorsIntegration", function() {
    return linkedErrorsIntegration;
});
var _integrationJs = require("../integration.js");
var _aggregateErrorsJs = require("../utils/aggregate-errors.js");
var _eventbuilderJs = require("../utils/eventbuilder.js");
var DEFAULT_KEY = 'cause';
var DEFAULT_LIMIT = 5;
var INTEGRATION_NAME = 'LinkedErrors';
var _linkedErrorsIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var limit = options.limit || DEFAULT_LIMIT;
    var key = options.key || DEFAULT_KEY;
    return {
        name: INTEGRATION_NAME,
        preprocessEvent: function preprocessEvent(event, hint, client) {
            var options = client.getOptions();
            (0, _aggregateErrorsJs.applyAggregateErrorsToEvent)((0, _eventbuilderJs.exceptionFromError), options.stackParser, key, limit, event, hint);
        }
    };
};
var linkedErrorsIntegration = (0, _integrationJs.defineIntegration)(_linkedErrorsIntegration);

},{"../integration.js":"brH19","../utils/aggregate-errors.js":"anvAD","../utils/eventbuilder.js":"kg8hW","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"anvAD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applyAggregateErrorsToEvent", function() {
    return applyAggregateErrorsToEvent;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _isJs = require("./is.js");
/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function applyAggregateErrorsToEvent(exceptionFromErrorImplementation, parser, key, limit, event, hint) {
    var _event_exception;
    if (!((_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : _event_exception.values) || !hint || !(0, _isJs.isInstanceOf)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    var originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0);
}
function aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    var newExceptions = (0, _toConsumableArray._)(prevExceptions);
    // Recursively call this function in order to walk down a chain of errors
    if ((0, _isJs.isInstanceOf)(error[key], Error)) {
        applyExceptionGroupFieldsForParentException(exception, exceptionId);
        var newException = exceptionFromErrorImplementation(parser, error[key]);
        var newExceptionId = newExceptions.length;
        applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException
        ].concat((0, _toConsumableArray._)(newExceptions)), newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach(function(childError, i) {
        if ((0, _isJs.isInstanceOf)(childError, Error)) {
            applyExceptionGroupFieldsForParentException(exception, exceptionId);
            var newException = exceptionFromErrorImplementation(parser, childError);
            var newExceptionId = newExceptions.length;
            applyExceptionGroupFieldsForChildException(newException, "errors[".concat(i, "]"), newExceptionId, exceptionId);
            newExceptions = aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException
            ].concat((0, _toConsumableArray._)(newExceptions)), newException, newExceptionId);
        }
    });
    return newExceptions;
}
function applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    exception.mechanism = (0, _objectSpreadProps._)((0, _objectSpread._)({
        handled: true,
        type: 'auto.core.linked_errors'
    }, exception.mechanism, exception.type === 'AggregateError' && {
        is_exception_group: true
    }), {
        exception_id: exceptionId
    });
}
function applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    exception.mechanism = (0, _objectSpreadProps._)((0, _objectSpread._)({
        handled: true
    }, exception.mechanism), {
        type: 'chained',
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    });
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_to_consumable_array":"1eSZf","./is.js":"kSqSf","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kYhBC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "moduleMetadataIntegration", function() {
    return moduleMetadataIntegration;
});
var _integrationJs = require("../integration.js");
var _metadataJs = require("../metadata.js");
var _envelopeJs = require("../utils/envelope.js");
/**
 * Adds module metadata to stack frames.
 *
 * Metadata can be injected by the Sentry bundler plugins using the `moduleMetadata` config option.
 *
 * When this integration is added, the metadata passed to the bundler plugin is added to the stack frames of all events
 * under the `module_metadata` property. This can be used to help in tagging or routing of events from different teams
 * our sources
 */ var moduleMetadataIntegration = (0, _integrationJs.defineIntegration)(function() {
    return {
        name: 'ModuleMetadata',
        setup: function setup(client) {
            // We need to strip metadata from stack frames before sending them to Sentry since these are client side only.
            client.on('beforeEnvelope', function(envelope) {
                (0, _envelopeJs.forEachEnvelopeItem)(envelope, function(item, type) {
                    if (type === 'event') {
                        var event = Array.isArray(item) ? item[1] : undefined;
                        if (event) {
                            (0, _metadataJs.stripMetadataFromStackFrames)(event);
                            item[1] = event;
                        }
                    }
                });
            });
            client.on('applyFrameMetadata', function(event) {
                // Only apply stack frame metadata to error events
                if (event.type) return;
                var stackParser = client.getOptions().stackParser;
                (0, _metadataJs.addMetadataToStackFrames)(stackParser, event);
            });
        }
    };
});

},{"../integration.js":"brH19","../metadata.js":"7Sw0A","../utils/envelope.js":"fDBh0","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7Sw0A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addMetadataToStackFrames", function() {
    return addMetadataToStackFrames;
});
parcelHelpers.export(exports, "getMetadataForUrl", function() {
    return getMetadataForUrl;
});
parcelHelpers.export(exports, "stripMetadataFromStackFrames", function() {
    return stripMetadataFromStackFrames;
});
var _worldwideJs = require("./utils/worldwide.js");
/** Keys are source filename/url, values are metadata objects. */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
var filenameMetadataMap = new Map();
/** Set of stack strings that have already been parsed. */ var parsedStacks = new Set();
function ensureMetadataStacksAreParsed(parser) {
    if (!(0, _worldwideJs.GLOBAL_OBJ)._sentryModuleMetadata) return;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.keys((0, _worldwideJs.GLOBAL_OBJ)._sentryModuleMetadata)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var stack = _step.value;
            var metadata = (0, _worldwideJs.GLOBAL_OBJ)._sentryModuleMetadata[stack];
            if (parsedStacks.has(stack)) continue;
            // Ensure this stack doesn't get parsed again
            parsedStacks.add(stack);
            var frames = parser(stack);
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                // Go through the frames starting from the top of the stack and find the first one with a filename
                for(var _iterator1 = frames.reverse()[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var frame = _step1.value;
                    if (frame.filename) {
                        // Save the metadata for this filename
                        filenameMetadataMap.set(frame.filename, metadata);
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
/**
 * Retrieve metadata for a specific JavaScript file URL.
 *
 * Metadata is injected by the Sentry bundler plugins using the `_experiments.moduleMetadata` config option.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function getMetadataForUrl(parser, filename) {
    ensureMetadataStacksAreParsed(parser);
    return filenameMetadataMap.get(filename);
}
/**
 * Adds metadata to stack frames.
 *
 * Metadata is injected by the Sentry bundler plugins using the `_experiments.moduleMetadata` config option.
 */ function addMetadataToStackFrames(parser, event) {
    var _event_exception_values, _event_exception;
    (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values.forEach(function(exception) {
        var _exception_stacktrace_frames, _exception_stacktrace;
        (_exception_stacktrace = exception.stacktrace) === null || _exception_stacktrace === void 0 ? void 0 : (_exception_stacktrace_frames = _exception_stacktrace.frames) === null || _exception_stacktrace_frames === void 0 ? void 0 : _exception_stacktrace_frames.forEach(function(frame) {
            if (!frame.filename || frame.module_metadata) return;
            var metadata = getMetadataForUrl(parser, frame.filename);
            if (metadata) frame.module_metadata = metadata;
        });
    });
}
/**
 * Strips metadata from stack frames.
 */ function stripMetadataFromStackFrames(event) {
    var _event_exception_values, _event_exception;
    (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values.forEach(function(exception) {
        var _exception_stacktrace_frames, _exception_stacktrace;
        (_exception_stacktrace = exception.stacktrace) === null || _exception_stacktrace === void 0 ? void 0 : (_exception_stacktrace_frames = _exception_stacktrace.frames) === null || _exception_stacktrace_frames === void 0 ? void 0 : _exception_stacktrace_frames.forEach(function(frame) {
            delete frame.module_metadata;
        });
    });
}

},{"./utils/worldwide.js":"3qnNR","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"l0uoE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "requestDataIntegration", function() {
    return requestDataIntegration;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _integrationJs = require("../integration.js");
var _cookieJs = require("../utils/cookie.js");
var _getIpAddressJs = require("../vendor/getIpAddress.js");
// TODO(v11): Change defaults based on `sendDefaultPii`
var DEFAULT_INCLUDE = {
    cookies: true,
    data: true,
    headers: true,
    query_string: true,
    url: true
};
var INTEGRATION_NAME = 'RequestData';
var _requestDataIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var include = (0, _objectSpread._)({}, DEFAULT_INCLUDE, options.include);
    return {
        name: INTEGRATION_NAME,
        processEvent: function processEvent(event, _hint, client) {
            var _event_sdkProcessingMetadata = event.sdkProcessingMetadata, sdkProcessingMetadata = _event_sdkProcessingMetadata === void 0 ? {} : _event_sdkProcessingMetadata;
            var normalizedRequest = sdkProcessingMetadata.normalizedRequest, ipAddress = sdkProcessingMetadata.ipAddress;
            var _include_ip;
            var includeWithDefaultPiiApplied = (0, _objectSpreadProps._)((0, _objectSpread._)({}, include), {
                ip: (_include_ip = include.ip) !== null && _include_ip !== void 0 ? _include_ip : client.getOptions().sendDefaultPii
            });
            if (normalizedRequest) addNormalizedRequestDataToEvent(event, normalizedRequest, {
                ipAddress: ipAddress
            }, includeWithDefaultPiiApplied);
            return event;
        }
    };
};
/**
 * Add data about a request to an event. Primarily for use in Node-based SDKs, but included in `@sentry/core`
 * so it can be used in cross-platform SDKs like `@sentry/nextjs`.
 */ var requestDataIntegration = (0, _integrationJs.defineIntegration)(_requestDataIntegration);
/**
 * Add already normalized request data to an event.
 * This mutates the passed in event.
 */ function addNormalizedRequestDataToEvent(event, req, // Data that should not go into `event.request` but is somehow related to requests
additionalData, include) {
    event.request = (0, _objectSpread._)({}, event.request, extractNormalizedRequestData(req, include));
    if (include.ip) {
        var ip = req.headers && (0, _getIpAddressJs.getClientIPAddress)(req.headers) || additionalData.ipAddress;
        if (ip) event.user = (0, _objectSpreadProps._)((0, _objectSpread._)({}, event.user), {
            ip_address: ip
        });
    }
}
function extractNormalizedRequestData(normalizedRequest, include) {
    var requestData = {};
    var headers = (0, _objectSpread._)({}, normalizedRequest.headers);
    if (include.headers) {
        requestData.headers = headers;
        // Remove the Cookie header in case cookie data should not be included in the event
        if (!include.cookies) delete headers.cookie;
        // Remove IP headers in case IP data should not be included in the event
        if (!include.ip) (0, _getIpAddressJs.ipHeaderNames).forEach(function(ipHeaderName) {
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete headers[ipHeaderName];
        });
    }
    requestData.method = normalizedRequest.method;
    if (include.url) requestData.url = normalizedRequest.url;
    if (include.cookies) {
        var cookies = normalizedRequest.cookies || ((headers === null || headers === void 0 ? void 0 : headers.cookie) ? (0, _cookieJs.parseCookie)(headers.cookie) : undefined);
        requestData.cookies = cookies || {};
    }
    if (include.query_string) requestData.query_string = normalizedRequest.query_string;
    if (include.data) requestData.data = normalizedRequest.data;
    return requestData;
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","../integration.js":"brH19","../utils/cookie.js":"ktbig","../vendor/getIpAddress.js":"7xkx4","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ktbig":[function(require,module,exports,__globalThis) {
/**
 * This code was originally copied from the 'cookie` module at v0.5.0 and was simplified for our use case.
 * https://github.com/jshttp/cookie/blob/a0c84147aab6266bdb3996cf4062e93907c0b0fc/index.js
 * It had the following license:
 *
 * (The MIT License)
 *
 * Copyright (c) 2012-2014 Roman Shtylman <shtylman@gmail.com>
 * Copyright (c) 2015 Douglas Christopher Wilson <doug@somethingdoug.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ /**
 * Parses a cookie string
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseCookie", function() {
    return parseCookie;
});
function parseCookie(str) {
    var obj = {};
    var index = 0;
    while(index < str.length){
        var eqIdx = str.indexOf('=', index);
        // no more cookie pairs
        if (eqIdx === -1) break;
        var endIdx = str.indexOf(';', index);
        if (endIdx === -1) endIdx = str.length;
        else if (endIdx < eqIdx) {
            // backtrack on prior semicolon
            index = str.lastIndexOf(';', eqIdx - 1) + 1;
            continue;
        }
        var key = str.slice(index, eqIdx).trim();
        // only assign once
        if (undefined === obj[key]) {
            var val = str.slice(eqIdx + 1, endIdx).trim();
            // quoted values
            if (val.charCodeAt(0) === 0x22) val = val.slice(1, -1);
            try {
                obj[key] = val.indexOf('%') !== -1 ? decodeURIComponent(val) : val;
            } catch (e) {
                obj[key] = val;
            }
        }
        index = endIdx + 1;
    }
    return obj;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7xkx4":[function(require,module,exports,__globalThis) {
// Vendored / modified from @sergiodxa/remix-utils
// https://github.com/sergiodxa/remix-utils/blob/02af80e12829a53696bfa8f3c2363975cf59f55e/src/server/get-client-ip-address.ts
// MIT License
// Copyright (c) 2021 Sergio Xalambrí
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
// The headers to check, in priority order
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getClientIPAddress", function() {
    return getClientIPAddress;
});
parcelHelpers.export(exports, "ipHeaderNames", function() {
    return ipHeaderNames;
});
var ipHeaderNames = [
    'X-Client-IP',
    'X-Forwarded-For',
    'Fly-Client-IP',
    'CF-Connecting-IP',
    'Fastly-Client-Ip',
    'True-Client-Ip',
    'X-Real-IP',
    'X-Cluster-Client-IP',
    'X-Forwarded',
    'Forwarded-For',
    'Forwarded',
    'X-Vercel-Forwarded-For'
];
/**
 * Get the IP address of the client sending a request.
 *
 * It receives a Request headers object and use it to get the
 * IP address from one of the following headers in order.
 *
 * If the IP address is valid, it will be returned. Otherwise, null will be
 * returned.
 *
 * If the header values contains more than one IP address, the first valid one
 * will be returned.
 */ function getClientIPAddress(headers) {
    // This will end up being Array<string | string[] | undefined | null> because of the various possible values a header
    // can take
    var headerValues = ipHeaderNames.map(function(headerName) {
        var rawValue = headers[headerName];
        var value = Array.isArray(rawValue) ? rawValue.join(';') : rawValue;
        if (headerName === 'Forwarded') return parseForwardedHeader(value);
        return value === null || value === void 0 ? void 0 : value.split(',').map(function(v) {
            return v.trim();
        });
    });
    // Flatten the array and filter out any falsy entries
    var flattenedHeaderValues = headerValues.reduce(function(acc, val) {
        if (!val) return acc;
        return acc.concat(val);
    }, []);
    // Find the first value which is a valid IP address, if any
    var ipAddress = flattenedHeaderValues.find(function(ip) {
        return ip !== null && isIP(ip);
    });
    return ipAddress || null;
}
function parseForwardedHeader(value) {
    if (!value) return null;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = value.split(';')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var part = _step.value;
            if (part.startsWith('for=')) return part.slice(4);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
}
//
/**
 * Custom method instead of importing this from `net` package, as this only exists in node
 * Accepts:
 * 127.0.0.1
 * 192.168.1.1
 * 192.168.1.255
 * 255.255.255.255
 * 10.1.1.1
 * 0.0.0.0
 * 2b01:cb19:8350:ed00:d0dd:fa5b:de31:8be5
 *
 * Rejects:
 * 1.1.1.01
 * 30.168.1.255.1
 * 127.1
 * 192.168.1.256
 * -1.2.3.4
 * 1.1.1.1.
 * 3...3
 * 192.168.1.099
 */ function isIP(str) {
    var regex = /(?:^(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}$)|(?:^(?:(?:[a-fA-F\d]{1,4}:){7}(?:[a-fA-F\d]{1,4}|:)|(?:[a-fA-F\d]{1,4}:){6}(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|:[a-fA-F\d]{1,4}|:)|(?:[a-fA-F\d]{1,4}:){5}(?::(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,2}|:)|(?:[a-fA-F\d]{1,4}:){4}(?:(?::[a-fA-F\d]{1,4}){0,1}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,3}|:)|(?:[a-fA-F\d]{1,4}:){3}(?:(?::[a-fA-F\d]{1,4}){0,2}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,4}|:)|(?:[a-fA-F\d]{1,4}:){2}(?:(?::[a-fA-F\d]{1,4}){0,3}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,5}|:)|(?:[a-fA-F\d]{1,4}:){1}(?:(?::[a-fA-F\d]{1,4}){0,4}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,6}|:)|(?::(?:(?::[a-fA-F\d]{1,4}){0,5}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,7}|:)))(?:%[0-9a-zA-Z]{1,})?$)/;
    return regex.test(str);
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7gtky":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "captureConsoleIntegration", function() {
    return captureConsoleIntegration;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
var _currentScopesJs = require("../currentScopes.js");
var _exportsJs = require("../exports.js");
var _consoleJs = require("../instrument/console.js");
var _integrationJs = require("../integration.js");
var _debugLoggerJs = require("../utils/debug-logger.js");
var _miscJs = require("../utils/misc.js");
var _severityJs = require("../utils/severity.js");
var _stringJs = require("../utils/string.js");
var _worldwideJs = require("../utils/worldwide.js");
var INTEGRATION_NAME = 'CaptureConsole';
var _captureConsoleIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var levels = options.levels || (0, _debugLoggerJs.CONSOLE_LEVELS);
    var _options_handled;
    var handled = (_options_handled = options.handled) !== null && _options_handled !== void 0 ? _options_handled : true;
    return {
        name: INTEGRATION_NAME,
        setup: function setup(client) {
            if (!('console' in (0, _worldwideJs.GLOBAL_OBJ))) return;
            (0, _consoleJs.addConsoleInstrumentationHandler)(function(param) {
                var args = param.args, level = param.level;
                if ((0, _currentScopesJs.getClient)() !== client || !levels.includes(level)) return;
                consoleHandler(args, level, handled);
            });
        }
    };
};
/**
 * Send Console API calls as Sentry Events.
 */ var captureConsoleIntegration = (0, _integrationJs.defineIntegration)(_captureConsoleIntegration);
function consoleHandler(args, level, handled) {
    var severityLevel = (0, _severityJs.severityLevelFromString)(level);
    /*
    We create this error here already to attach a stack trace to captured messages,
    if users set `attachStackTrace` to `true` in Sentry.init.
    We do this here already because we want to minimize the number of Sentry SDK stack frames
    within the error. Technically, Client.captureMessage will also do it but this happens several
    stack frames deeper.
  */ var syntheticException = new Error();
    var captureContext = {
        level: (0, _severityJs.severityLevelFromString)(level),
        extra: {
            arguments: args
        }
    };
    (0, _currentScopesJs.withScope)(function(scope) {
        scope.addEventProcessor(function(event) {
            event.logger = 'console';
            (0, _miscJs.addExceptionMechanism)(event, {
                handled: handled,
                type: 'auto.core.capture_console'
            });
            return event;
        });
        if (level === 'assert') {
            if (!args[0]) {
                var message = "Assertion failed: ".concat((0, _stringJs.safeJoin)(args.slice(1), ' ') || 'console.assert');
                scope.setExtra('arguments', args.slice(1));
                scope.captureMessage(message, severityLevel, {
                    captureContext: captureContext,
                    syntheticException: syntheticException
                });
            }
            return;
        }
        var error = args.find(function(arg) {
            return (0, _instanceof._)(arg, Error);
        });
        if (error) {
            (0, _exportsJs.captureException)(error, captureContext);
            return;
        }
        var message1 = (0, _stringJs.safeJoin)(args, ' ');
        scope.captureMessage(message1, severityLevel, {
            captureContext: captureContext,
            syntheticException: syntheticException
        });
    });
}

},{"@swc/helpers/_/_instanceof":"h9UKc","../currentScopes.js":"3GE4v","../exports.js":"1Xqap","../instrument/console.js":"eEuZ3","../integration.js":"brH19","../utils/debug-logger.js":"3X9Vf","../utils/misc.js":"8kac1","../utils/severity.js":"bgJKP","../utils/string.js":"j38bn","../utils/worldwide.js":"3qnNR","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eEuZ3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addConsoleInstrumentationHandler", function() {
    return addConsoleInstrumentationHandler;
});
var _debugLoggerJs = require("../utils/debug-logger.js");
var _objectJs = require("../utils/object.js");
var _worldwideJs = require("../utils/worldwide.js");
var _handlersJs = require("./handlers.js");
/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function addConsoleInstrumentationHandler(handler) {
    var type = 'console';
    (0, _handlersJs.addHandler)(type, handler);
    (0, _handlersJs.maybeInstrument)(type, instrumentConsole);
}
function instrumentConsole() {
    if (!('console' in (0, _worldwideJs.GLOBAL_OBJ))) return;
    (0, _debugLoggerJs.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in (0, _worldwideJs.GLOBAL_OBJ).console)) return;
        (0, _objectJs.fill)((0, _worldwideJs.GLOBAL_OBJ).console, level, function(originalConsoleMethod) {
            (0, _debugLoggerJs.originalConsoleMethods)[level] = originalConsoleMethod;
            return function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var handlerData = {
                    args: args,
                    level: level
                };
                (0, _handlersJs.triggerHandlers)('console', handlerData);
                var log = (0, _debugLoggerJs.originalConsoleMethods)[level];
                log === null || log === void 0 ? void 0 : log.apply((0, _worldwideJs.GLOBAL_OBJ).console, args);
            };
        });
    });
}

},{"../utils/debug-logger.js":"3X9Vf","../utils/object.js":"9SKe9","../utils/worldwide.js":"3qnNR","./handlers.js":"imb6z","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bgJKP":[function(require,module,exports,__globalThis) {
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "severityLevelFromString", function() {
    return severityLevelFromString;
});
function severityLevelFromString(level) {
    return level === 'warn' ? 'warning' : [
        'fatal',
        'error',
        'warning',
        'log',
        'info',
        'debug'
    ].includes(level) ? level : 'log';
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1WgfN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_shouldDropEvent", function() {
    return _shouldDropEvent;
});
parcelHelpers.export(exports, "dedupeIntegration", function() {
    return dedupeIntegration;
});
var _debugBuildJs = require("../debug-build.js");
var _integrationJs = require("../integration.js");
var _debugLoggerJs = require("../utils/debug-logger.js");
var _stacktraceJs = require("../utils/stacktrace.js");
var INTEGRATION_NAME = 'Dedupe';
var _dedupeIntegration = function() {
    var previousEvent;
    return {
        name: INTEGRATION_NAME,
        processEvent: function processEvent(currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if (_shouldDropEvent(currentEvent, previousEvent)) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn('Event dropped due to being a duplicate of previously captured event.');
                    return null;
                }
            } catch (e) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
/**
 * Deduplication filter.
 */ var dedupeIntegration = (0, _integrationJs.defineIntegration)(_dedupeIntegration);
/** only exported for tests. */ function _shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if (_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if (_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function _isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function _isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = _getExceptionFromEvent(previousEvent);
    var currentException = _getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function _isSameStacktrace(currentEvent, previousEvent) {
    var currentFrames = (0, _stacktraceJs.getFramesFromEvent)(currentEvent);
    var previousFrames = (0, _stacktraceJs.getFramesFromEvent)(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(var i = 0; i < previousFrames.length; i++){
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        var frameA = previousFrames[i];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function _isSameFingerprint(currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (e) {
        return false;
    }
}
function _getExceptionFromEvent(event) {
    var _event_exception_values, _event_exception;
    return (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values[0];
}

},{"../debug-build.js":"ejIQP","../integration.js":"brH19","../utils/debug-logger.js":"3X9Vf","../utils/stacktrace.js":"5srWn","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iBvh1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extraErrorDataIntegration", function() {
    return extraErrorDataIntegration;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _debugBuildJs = require("../debug-build.js");
var _integrationJs = require("../integration.js");
var _debugLoggerJs = require("../utils/debug-logger.js");
var _isJs = require("../utils/is.js");
var _normalizeJs = require("../utils/normalize.js");
var _objectJs = require("../utils/object.js");
var _stringJs = require("../utils/string.js");
var INTEGRATION_NAME = 'ExtraErrorData';
/**
 * Extract additional data for from original exceptions.
 */ var _extraErrorDataIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _options_depth = options.depth, depth = _options_depth === void 0 ? 3 : _options_depth, _options_captureErrorCause = options.captureErrorCause, captureErrorCause = _options_captureErrorCause === void 0 ? true : _options_captureErrorCause;
    return {
        name: INTEGRATION_NAME,
        processEvent: function processEvent(event, hint, client) {
            var maxValueLength = client.getOptions().maxValueLength;
            return _enhanceEventWithErrorData(event, hint, depth, captureErrorCause, maxValueLength);
        }
    };
};
var extraErrorDataIntegration = (0, _integrationJs.defineIntegration)(_extraErrorDataIntegration);
function _enhanceEventWithErrorData(event) {
    var hint = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, depth = arguments.length > 2 ? arguments[2] : void 0, captureErrorCause = arguments.length > 3 ? arguments[3] : void 0, maxValueLength = arguments.length > 4 ? arguments[4] : void 0;
    if (!hint.originalException || !(0, _isJs.isError)(hint.originalException)) return event;
    var exceptionName = hint.originalException.name || hint.originalException.constructor.name;
    var errorData = _extractErrorData(hint.originalException, captureErrorCause, maxValueLength);
    if (errorData) {
        var contexts = (0, _objectSpread._)({}, event.contexts);
        var normalizedErrorData = (0, _normalizeJs.normalize)(errorData, depth);
        if ((0, _isJs.isPlainObject)(normalizedErrorData)) {
            // We mark the error data as "already normalized" here, because we don't want other normalization procedures to
            // potentially truncate the data we just already normalized, with a certain depth setting.
            (0, _objectJs.addNonEnumerableProperty)(normalizedErrorData, '__sentry_skip_normalization__', true);
            contexts[exceptionName] = normalizedErrorData;
        }
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, event), {
            contexts: contexts
        });
    }
    return event;
}
/**
 * Extract extra information from the Error object
 */ function _extractErrorData(error, captureErrorCause, maxValueLength) {
    // We are trying to enhance already existing event, so no harm done if it won't succeed
    try {
        var nativeKeys = [
            'name',
            'message',
            'stack',
            'line',
            'column',
            'fileName',
            'lineNumber',
            'columnNumber',
            'toJSON'
        ];
        var extraErrorInfo = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // We want only enumerable properties, thus `getOwnPropertyNames` is redundant here, as we filter keys anyway.
            for(var _iterator = Object.keys(error)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                if (nativeKeys.indexOf(key) !== -1) continue;
                var value = error[key];
                extraErrorInfo[key] = (0, _isJs.isError)(value) || typeof value === 'string' ? maxValueLength ? (0, _stringJs.truncate)("".concat(value), maxValueLength) : "".concat(value) : value;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        // Error.cause is a standard property that is non enumerable, we therefore need to access it separately.
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/cause
        if (captureErrorCause && error.cause !== undefined) {
            if ((0, _isJs.isError)(error.cause)) {
                var errorName = error.cause.name || error.cause.constructor.name;
                extraErrorInfo.cause = (0, _defineProperty._)({}, errorName, _extractErrorData(error.cause, false, maxValueLength));
            } else extraErrorInfo.cause = error.cause;
        }
        // Check if someone attached `toJSON` method to grab even more properties (eg. axios is doing that)
        if (typeof error.toJSON === 'function') {
            var serializedError = error.toJSON();
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = Object.keys(serializedError)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var key1 = _step1.value;
                    var value1 = serializedError[key1];
                    extraErrorInfo[key1] = (0, _isJs.isError)(value1) ? value1.toString() : value1;
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
        return extraErrorInfo;
    } catch (oO) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).error('Unable to extract extra data from the Error object:', oO);
    }
    return null;
}

},{"@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","../debug-build.js":"ejIQP","../integration.js":"brH19","../utils/debug-logger.js":"3X9Vf","../utils/is.js":"kSqSf","../utils/normalize.js":"k9k7R","../utils/object.js":"9SKe9","../utils/string.js":"j38bn","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cAyki":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateIteratee", function() {
    return generateIteratee;
});
parcelHelpers.export(exports, "rewriteFramesIntegration", function() {
    return rewriteFramesIntegration;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _integrationJs = require("../integration.js");
var _pathJs = require("../utils/path.js");
var _worldwideJs = require("../utils/worldwide.js");
var INTEGRATION_NAME = 'RewriteFrames';
/**
 * Rewrite event frames paths.
 */ var rewriteFramesIntegration = (0, _integrationJs.defineIntegration)(function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var root = options.root;
    var prefix = options.prefix || 'app:///';
    var isBrowser = 'window' in (0, _worldwideJs.GLOBAL_OBJ) && !!(0, _worldwideJs.GLOBAL_OBJ).window;
    var iteratee = options.iteratee || generateIteratee({
        isBrowser: isBrowser,
        root: root,
        prefix: prefix
    });
    /** Process an exception event. */ function _processExceptionsEvent(event) {
        try {
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, event), {
                exception: (0, _objectSpreadProps._)((0, _objectSpread._)({}, event.exception), {
                    // The check for this is performed inside `process` call itself, safe to skip here
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    values: event.exception.values.map(function(value) {
                        return (0, _objectSpread._)({}, value, value.stacktrace && {
                            stacktrace: _processStacktrace(value.stacktrace)
                        });
                    })
                })
            });
        } catch (e) {
            return event;
        }
    }
    /** Process a stack trace. */ function _processStacktrace(stacktrace) {
        var _stacktrace_frames;
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, stacktrace), {
            frames: stacktrace === null || stacktrace === void 0 ? void 0 : (_stacktrace_frames = stacktrace.frames) === null || _stacktrace_frames === void 0 ? void 0 : _stacktrace_frames.map(function(f) {
                return iteratee(f);
            })
        });
    }
    return {
        name: INTEGRATION_NAME,
        processEvent: function processEvent(originalEvent) {
            var processedEvent = originalEvent;
            if (originalEvent.exception && Array.isArray(originalEvent.exception.values)) processedEvent = _processExceptionsEvent(processedEvent);
            return processedEvent;
        }
    };
});
/**
 * Exported only for tests.
 */ function generateIteratee(param) {
    var isBrowser = param.isBrowser, root = param.root, prefix = param.prefix;
    return function(frame) {
        if (!frame.filename) return frame;
        // Determine if this is a Windows frame by checking for a Windows-style prefix such as `C:\`
        var isWindowsFrame = /^[a-zA-Z]:\\/.test(frame.filename) || // or the presence of a backslash without a forward slash (which are not allowed on Windows)
        frame.filename.includes('\\') && !frame.filename.includes('/');
        // Check if the frame filename begins with `/`
        var startsWithSlash = /^\//.test(frame.filename);
        if (isBrowser) {
            if (root) {
                var oldFilename = frame.filename;
                if (oldFilename.indexOf(root) === 0) frame.filename = oldFilename.replace(root, prefix);
            }
        } else if (isWindowsFrame || startsWithSlash) {
            var filename = isWindowsFrame ? frame.filename.replace(/^[a-zA-Z]:/, '') // remove Windows-style prefix
            .replace(/\\/g, '/') // replace all `\\` instances with `/`
             : frame.filename;
            var base = root ? (0, _pathJs.relative)(root, filename) : (0, _pathJs.basename)(filename);
            frame.filename = "".concat(prefix).concat(base);
        }
        return frame;
    };
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","../integration.js":"brH19","../utils/path.js":"hJr1O","../utils/worldwide.js":"3qnNR","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hJr1O":[function(require,module,exports,__globalThis) {
// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
// https://github.com/calvinmetcalf/rollup-plugin-node-builtins/blob/63ab8aacd013767445ca299e468d9a60a95328d7/src/es6/path.js
//
// Copyright Joyent, Inc.and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
/** JSDoc */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "basename", function() {
    return basename;
});
parcelHelpers.export(exports, "dirname", function() {
    return dirname;
});
parcelHelpers.export(exports, "isAbsolute", function() {
    return isAbsolute;
});
parcelHelpers.export(exports, "join", function() {
    return join;
});
parcelHelpers.export(exports, "normalizePath", function() {
    return normalizePath;
});
parcelHelpers.export(exports, "relative", function() {
    return relative;
});
parcelHelpers.export(exports, "resolve", function() {
    return resolve;
});
function normalizeArray(parts, allowAboveRoot) {
    // if the path tries to go above the root, `up` ends up > 0
    var up = 0;
    for(var i = parts.length - 1; i >= 0; i--){
        var last = parts[i];
        if (last === '.') parts.splice(i, 1);
        else if (last === '..') {
            parts.splice(i, 1);
            up++;
        } else if (up) {
            parts.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (allowAboveRoot) for(; up--; up)parts.unshift('..');
    return parts;
}
// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
var splitPathRe = /^(\S+:\\|\/?)([\s\S]*?)((?:\.{1,2}|[^/\\]+?|)(\.[^./\\]*|))(?:[/\\]*)$/;
/** JSDoc */ function splitPath(filename) {
    // Truncate files names greater than 1024 characters to avoid regex dos
    // https://github.com/getsentry/sentry-javascript/pull/8737#discussion_r1285719172
    var truncated = filename.length > 1024 ? "<truncated>".concat(filename.slice(-1024)) : filename;
    var parts = splitPathRe.exec(truncated);
    return parts ? parts.slice(1) : [];
}
// path.resolve([from ...], to)
// posix version
/** JSDoc */ function resolve() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var resolvedPath = '';
    var resolvedAbsolute = false;
    for(var i = args.length - 1; i >= -1 && !resolvedAbsolute; i--){
        var path = i >= 0 ? args[i] : '/';
        // Skip empty entries
        if (!path) continue;
        resolvedPath = "".concat(path, "/").concat(resolvedPath);
        resolvedAbsolute = path.charAt(0) === '/';
    }
    // At this point the path should be resolved to a full absolute path, but
    // handle relative paths to be safe (might happen when process.cwd() fails)
    // Normalize the path
    resolvedPath = normalizeArray(resolvedPath.split('/').filter(function(p) {
        return !!p;
    }), !resolvedAbsolute).join('/');
    return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
}
/** JSDoc */ function trim(arr) {
    var start = 0;
    for(; start < arr.length; start++){
        if (arr[start] !== '') break;
    }
    var end = arr.length - 1;
    for(; end >= 0; end--){
        if (arr[end] !== '') break;
    }
    if (start > end) return [];
    return arr.slice(start, end - start + 1);
}
// path.relative(from, to)
// posix version
/** JSDoc */ function relative(from, to) {
    /* eslint-disable no-param-reassign */ from = resolve(from).slice(1);
    to = resolve(to).slice(1);
    /* eslint-enable no-param-reassign */ var fromParts = trim(from.split('/'));
    var toParts = trim(to.split('/'));
    var length = Math.min(fromParts.length, toParts.length);
    var samePartsLength = length;
    for(var i = 0; i < length; i++)if (fromParts[i] !== toParts[i]) {
        samePartsLength = i;
        break;
    }
    var outputParts = [];
    for(var i1 = samePartsLength; i1 < fromParts.length; i1++)outputParts.push('..');
    outputParts = outputParts.concat(toParts.slice(samePartsLength));
    return outputParts.join('/');
}
// path.normalize(path)
// posix version
/** JSDoc */ function normalizePath(path) {
    var isPathAbsolute = isAbsolute(path);
    var trailingSlash = path.slice(-1) === '/';
    // Normalize the path
    var normalizedPath = normalizeArray(path.split('/').filter(function(p) {
        return !!p;
    }), !isPathAbsolute).join('/');
    if (!normalizedPath && !isPathAbsolute) normalizedPath = '.';
    if (normalizedPath && trailingSlash) normalizedPath += '/';
    return (isPathAbsolute ? '/' : '') + normalizedPath;
}
// posix version
/** JSDoc */ function isAbsolute(path) {
    return path.charAt(0) === '/';
}
// posix version
/** JSDoc */ function join() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return normalizePath(args.join('/'));
}
/** JSDoc */ function dirname(path) {
    var result = splitPath(path);
    var root = result[0] || '';
    var dir = result[1];
    if (!root && !dir) // No dirname whatsoever
    return '.';
    if (dir) // It has a dirname, strip trailing slash
    dir = dir.slice(0, dir.length - 1);
    return root + dir;
}
/** JSDoc */ function basename(path, ext) {
    var f = splitPath(path)[2] || '';
    if (ext && f.slice(ext.length * -1) === ext) f = f.slice(0, f.length - ext.length);
    return f;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"i6x5v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DB_OPERATIONS_TO_INSTRUMENT", function() {
    return DB_OPERATIONS_TO_INSTRUMENT;
});
parcelHelpers.export(exports, "FILTER_MAPPINGS", function() {
    return FILTER_MAPPINGS;
});
parcelHelpers.export(exports, "extractOperation", function() {
    return extractOperation;
});
parcelHelpers.export(exports, "instrumentSupabaseClient", function() {
    return instrumentSupabaseClient;
});
parcelHelpers.export(exports, "supabaseIntegration", function() {
    return supabaseIntegration;
});
parcelHelpers.export(exports, "translateFiltersIntoMethods", function() {
    return translateFiltersIntoMethods;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toArray = require("@swc/helpers/_/_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var _breadcrumbsJs = require("../breadcrumbs.js");
var _debugBuildJs = require("../debug-build.js");
var _exportsJs = require("../exports.js");
var _integrationJs = require("../integration.js");
var _semanticAttributesJs = require("../semanticAttributes.js");
var _debugLoggerJs = require("../utils/debug-logger.js");
var _miscJs = require("../utils/misc.js");
var _isJs = require("../utils/is.js");
var _spanstatusJs = require("../tracing/spanstatus.js");
var _traceJs = require("../tracing/trace.js");
// Based on Kamil Ogórek's work on:
// https://github.com/supabase-community/sentry-integration-js
var AUTH_OPERATIONS_TO_INSTRUMENT = [
    'reauthenticate',
    'signInAnonymously',
    'signInWithOAuth',
    'signInWithIdToken',
    'signInWithOtp',
    'signInWithPassword',
    'signInWithSSO',
    'signOut',
    'signUp',
    'verifyOtp'
];
var AUTH_ADMIN_OPERATIONS_TO_INSTRUMENT = [
    'createUser',
    'deleteUser',
    'listUsers',
    'getUserById',
    'updateUserById',
    'inviteUserByEmail'
];
var FILTER_MAPPINGS = {
    eq: 'eq',
    neq: 'neq',
    gt: 'gt',
    gte: 'gte',
    lt: 'lt',
    lte: 'lte',
    like: 'like',
    'like(all)': 'likeAllOf',
    'like(any)': 'likeAnyOf',
    ilike: 'ilike',
    'ilike(all)': 'ilikeAllOf',
    'ilike(any)': 'ilikeAnyOf',
    is: 'is',
    in: 'in',
    cs: 'contains',
    cd: 'containedBy',
    sr: 'rangeGt',
    nxl: 'rangeGte',
    sl: 'rangeLt',
    nxr: 'rangeLte',
    adj: 'rangeAdjacent',
    ov: 'overlaps',
    fts: '',
    plfts: 'plain',
    phfts: 'phrase',
    wfts: 'websearch',
    not: 'not'
};
var DB_OPERATIONS_TO_INSTRUMENT = [
    'select',
    'insert',
    'upsert',
    'update',
    'delete'
];
function markAsInstrumented(fn) {
    try {
        fn.__SENTRY_INSTRUMENTED__ = true;
    } catch (e) {
    // ignore errors here
    }
}
function isInstrumented(fn) {
    try {
        return fn.__SENTRY_INSTRUMENTED__;
    } catch (e) {
        return false;
    }
}
/**
 * Extracts the database operation type from the HTTP method and headers
 * @param method - The HTTP method of the request
 * @param headers - The request headers
 * @returns The database operation type ('select', 'insert', 'upsert', 'update', or 'delete')
 */ function extractOperation(method) {
    var headers = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    switch(method){
        case 'GET':
            return 'select';
        case 'POST':
            var _headers_Prefer;
            if ((_headers_Prefer = headers['Prefer']) === null || _headers_Prefer === void 0 ? void 0 : _headers_Prefer.includes('resolution=')) return 'upsert';
            else return 'insert';
        case 'PATCH':
            return 'update';
        case 'DELETE':
            return 'delete';
        default:
            return '<unknown-op>';
    }
}
/**
 * Translates Supabase filter parameters into readable method names for tracing
 * @param key - The filter key from the URL search parameters
 * @param query - The filter value from the URL search parameters
 * @returns A string representation of the filter as a method call
 */ function translateFiltersIntoMethods(key, query) {
    if (query === '' || query === '*') return 'select(*)';
    if (key === 'select') return "select(".concat(query, ")");
    if (key === 'or' || key.endsWith('.or')) return "".concat(key).concat(query);
    var _query_split = (0, _toArray._)(query.split('.')), filter = _query_split[0], value = _query_split.slice(1);
    var method;
    // Handle optional `configPart` of the filter
    if (filter === null || filter === void 0 ? void 0 : filter.startsWith('fts')) method = 'textSearch';
    else if (filter === null || filter === void 0 ? void 0 : filter.startsWith('plfts')) method = 'textSearch[plain]';
    else if (filter === null || filter === void 0 ? void 0 : filter.startsWith('phfts')) method = 'textSearch[phrase]';
    else if (filter === null || filter === void 0 ? void 0 : filter.startsWith('wfts')) method = 'textSearch[websearch]';
    else method = filter && FILTER_MAPPINGS[filter] || 'filter';
    return "".concat(method, "(").concat(key, ", ").concat(value.join('.'), ")");
}
function instrumentAuthOperation(operation) {
    var isAdmin = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return new Proxy(operation, {
        apply: function apply(target, thisArg, argumentsList) {
            var _obj;
            return (0, _traceJs.startSpan)({
                name: "auth ".concat(isAdmin ? '(admin) ' : '').concat(operation.name),
                attributes: (_obj = {}, (0, _defineProperty._)(_obj, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), 'auto.db.supabase'), (0, _defineProperty._)(_obj, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP), 'db'), (0, _defineProperty._)(_obj, 'db.system', 'postgresql'), (0, _defineProperty._)(_obj, 'db.operation', "auth.".concat(isAdmin ? 'admin.' : '').concat(operation.name)), _obj)
            }, function(span) {
                var _Reflect_apply_then_catch;
                return (_Reflect_apply_then_catch = Reflect.apply(target, thisArg, argumentsList).then(function(res) {
                    if (res && (typeof res === "undefined" ? "undefined" : (0, _typeOf._)(res)) === 'object' && 'error' in res && res.error) {
                        span.setStatus({
                            code: (0, _spanstatusJs.SPAN_STATUS_ERROR)
                        });
                        (0, _exportsJs.captureException)(res.error, {
                            mechanism: {
                                handled: false,
                                type: 'auto.db.supabase.auth'
                            }
                        });
                    } else span.setStatus({
                        code: (0, _spanstatusJs.SPAN_STATUS_OK)
                    });
                    span.end();
                    return res;
                }).catch(function(err) {
                    span.setStatus({
                        code: (0, _spanstatusJs.SPAN_STATUS_ERROR)
                    });
                    span.end();
                    (0, _exportsJs.captureException)(err, {
                        mechanism: {
                            handled: false,
                            type: 'auto.db.supabase.auth'
                        }
                    });
                    throw err;
                })).then.apply(_Reflect_apply_then_catch, (0, _toConsumableArray._)(argumentsList));
            });
        }
    });
}
function instrumentSupabaseAuthClient(supabaseClientInstance) {
    var auth = supabaseClientInstance.auth;
    if (!auth || isInstrumented(supabaseClientInstance.auth)) return;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = AUTH_OPERATIONS_TO_INSTRUMENT[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var operation = _step.value;
            var authOperation = auth[operation];
            if (!authOperation) continue;
            if (typeof supabaseClientInstance.auth[operation] === 'function') supabaseClientInstance.auth[operation] = instrumentAuthOperation(authOperation);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = AUTH_ADMIN_OPERATIONS_TO_INSTRUMENT[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var operation1 = _step1.value;
            var authOperation1 = auth.admin[operation1];
            if (!authOperation1) continue;
            if (typeof supabaseClientInstance.auth.admin[operation1] === 'function') supabaseClientInstance.auth.admin[operation1] = instrumentAuthOperation(authOperation1, true);
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    markAsInstrumented(supabaseClientInstance.auth);
}
function instrumentSupabaseClientConstructor(SupabaseClient) {
    if (isInstrumented(SupabaseClient.prototype.from)) return;
    SupabaseClient.prototype.from = new Proxy(SupabaseClient.prototype.from, {
        apply: function apply(target, thisArg, argumentsList) {
            var rv = Reflect.apply(target, thisArg, argumentsList);
            var PostgRESTQueryBuilder = rv.constructor;
            instrumentPostgRESTQueryBuilder(PostgRESTQueryBuilder);
            return rv;
        }
    });
    markAsInstrumented(SupabaseClient.prototype.from);
}
function instrumentPostgRESTFilterBuilder(PostgRESTFilterBuilder) {
    if (isInstrumented(PostgRESTFilterBuilder.prototype.then)) return;
    PostgRESTFilterBuilder.prototype.then = new Proxy(PostgRESTFilterBuilder.prototype.then, {
        apply: function apply(target, thisArg, argumentsList) {
            var _typedThis_url;
            var operations = DB_OPERATIONS_TO_INSTRUMENT;
            var typedThis = thisArg;
            var operation = extractOperation(typedThis.method, typedThis.headers);
            if (!operations.includes(operation)) return Reflect.apply(target, thisArg, argumentsList);
            if (!(typedThis === null || typedThis === void 0 ? void 0 : (_typedThis_url = typedThis.url) === null || _typedThis_url === void 0 ? void 0 : _typedThis_url.pathname) || typeof typedThis.url.pathname !== 'string') return Reflect.apply(target, thisArg, argumentsList);
            var pathParts = typedThis.url.pathname.split('/');
            var table = pathParts.length > 0 ? pathParts[pathParts.length - 1] : '';
            var queryItems = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = typedThis.url.searchParams.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, _slicedToArray._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                    // It's possible to have multiple entries for the same key, eg. `id=eq.7&id=eq.3`,
                    // so we need to use array instead of object to collect them.
                    queryItems.push(translateFiltersIntoMethods(key, value));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            var body = Object.create(null);
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            if ((0, _isJs.isPlainObject)(typedThis.body)) try {
                for(var _iterator1 = Object.entries(typedThis.body)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var _step_value1 = (0, _slicedToArray._)(_step1.value, 2), key1 = _step_value1[0], value1 = _step_value1[1];
                    body[key1] = value1;
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            // Adding operation to the beginning of the description if it's not a `select` operation
            // For example, it can be an `insert` or `update` operation but the query can be `select(...)`
            // For `select` operations, we don't need repeat it in the description
            var description = "".concat(operation === 'select' ? '' : "".concat(operation).concat(body ? '(...) ' : '')).concat(queryItems.join(' '), " from(").concat(table, ")");
            var _obj;
            var attributes = (_obj = {
                'db.table': table,
                'db.schema': typedThis.schema,
                'db.url': typedThis.url.origin,
                'db.sdk': typedThis.headers['X-Client-Info'],
                'db.system': 'postgresql',
                'db.operation': operation
            }, (0, _defineProperty._)(_obj, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), 'auto.db.supabase'), (0, _defineProperty._)(_obj, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP), 'db'), _obj);
            if (queryItems.length) attributes['db.query'] = queryItems;
            if (Object.keys(body).length) attributes['db.body'] = body;
            return (0, _traceJs.startSpan)({
                name: description,
                attributes: attributes
            }, function(span) {
                var _Reflect_apply_then;
                return (_Reflect_apply_then = Reflect.apply(target, thisArg, []).then(function(res) {
                    if (span) {
                        if (res && (typeof res === "undefined" ? "undefined" : (0, _typeOf._)(res)) === 'object' && 'status' in res) (0, _spanstatusJs.setHttpStatus)(span, res.status || 500);
                        span.end();
                    }
                    if (res.error) {
                        var _$err = new Error(res.error.message);
                        if (res.error.code) _$err.code = res.error.code;
                        if (res.error.details) _$err.details = res.error.details;
                        var supabaseContext = {};
                        if (queryItems.length) supabaseContext.query = queryItems;
                        if (Object.keys(body).length) supabaseContext.body = body;
                        (0, _exportsJs.captureException)(_$err, function(scope) {
                            scope.addEventProcessor(function(e) {
                                (0, _miscJs.addExceptionMechanism)(e, {
                                    handled: false,
                                    type: 'auto.db.supabase.postgres'
                                });
                                return e;
                            });
                            scope.setContext('supabase', supabaseContext);
                            return scope;
                        });
                    }
                    var breadcrumb = {
                        type: 'supabase',
                        category: "db.".concat(operation),
                        message: description
                    };
                    var data = {};
                    if (queryItems.length) data.query = queryItems;
                    if (Object.keys(body).length) data.body = body;
                    if (Object.keys(data).length) breadcrumb.data = data;
                    (0, _breadcrumbsJs.addBreadcrumb)(breadcrumb);
                    return res;
                }, function(err) {
                    // TODO: shouldn't we capture this error?
                    if (span) {
                        (0, _spanstatusJs.setHttpStatus)(span, 500);
                        span.end();
                    }
                    throw err;
                })).then.apply(_Reflect_apply_then, (0, _toConsumableArray._)(argumentsList));
            });
        }
    });
    markAsInstrumented(PostgRESTFilterBuilder.prototype.then);
}
function instrumentPostgRESTQueryBuilder(PostgRESTQueryBuilder) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var operation = _step.value;
            if (isInstrumented(PostgRESTQueryBuilder.prototype[operation])) return "continue";
            PostgRESTQueryBuilder.prototype[operation] = new Proxy(PostgRESTQueryBuilder.prototype[operation], {
                apply: function apply(target, thisArg, argumentsList) {
                    var rv = Reflect.apply(target, thisArg, argumentsList);
                    var PostgRESTFilterBuilder = rv.constructor;
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log("Instrumenting ".concat(operation, " operation's PostgRESTFilterBuilder"));
                    instrumentPostgRESTFilterBuilder(PostgRESTFilterBuilder);
                    return rv;
                }
            });
            markAsInstrumented(PostgRESTQueryBuilder.prototype[operation]);
        };
        // We need to wrap _all_ operations despite them sharing the same `PostgRESTFilterBuilder`
        // constructor, as we don't know which method will be called first, and we don't want to miss any calls.
        for(var _iterator = DB_OPERATIONS_TO_INSTRUMENT[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
var instrumentSupabaseClient = function(supabaseClient) {
    if (!supabaseClient) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn('Supabase integration was not installed because no Supabase client was provided.');
        return;
    }
    var SupabaseClientConstructor = supabaseClient.constructor === Function ? supabaseClient : supabaseClient.constructor;
    instrumentSupabaseClientConstructor(SupabaseClientConstructor);
    instrumentSupabaseAuthClient(supabaseClient);
};
var INTEGRATION_NAME = 'Supabase';
var _supabaseIntegration = function(supabaseClient) {
    return {
        setupOnce: function setupOnce() {
            instrumentSupabaseClient(supabaseClient);
        },
        name: INTEGRATION_NAME
    };
};
var supabaseIntegration = (0, _integrationJs.defineIntegration)(function(options) {
    return _supabaseIntegration(options.supabaseClient);
});

},{"@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_to_array":"auK39","@swc/helpers/_/_to_consumable_array":"1eSZf","@swc/helpers/_/_type_of":"iFJdx","../breadcrumbs.js":"d8fz5","../debug-build.js":"ejIQP","../exports.js":"1Xqap","../integration.js":"brH19","../semanticAttributes.js":"7WRPE","../utils/debug-logger.js":"3X9Vf","../utils/misc.js":"8kac1","../utils/is.js":"kSqSf","../tracing/spanstatus.js":"WiYVV","../tracing/trace.js":"eu0PU","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7B14I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applyZodErrorsToEvent", function() {
    return applyZodErrorsToEvent;
});
parcelHelpers.export(exports, "flattenIssue", function() {
    return flattenIssue;
});
parcelHelpers.export(exports, "flattenIssuePath", function() {
    return flattenIssuePath;
});
parcelHelpers.export(exports, "formatIssueMessage", function() {
    return formatIssueMessage;
});
parcelHelpers.export(exports, "zodErrorsIntegration", function() {
    return zodErrorsIntegration;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _integrationJs = require("../integration.js");
var _isJs = require("../utils/is.js");
var _stringJs = require("../utils/string.js");
var DEFAULT_LIMIT = 10;
var INTEGRATION_NAME = 'ZodErrors';
/**
 * Simplified ZodIssue type definition
 */ function originalExceptionIsZodError(originalException) {
    return (0, _isJs.isError)(originalException) && originalException.name === 'ZodError' && Array.isArray(originalException.issues);
}
/**
 * Formats child objects or arrays to a string
 * that is preserved when sent to Sentry.
 *
 * Without this, we end up with something like this in Sentry:
 *
 * [
 *  [Object],
 *  [Object],
 *  [Object],
 *  [Object]
 * ]
 */ function flattenIssue(issue) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, issue), {
        path: 'path' in issue && Array.isArray(issue.path) ? issue.path.join('.') : undefined,
        keys: 'keys' in issue ? JSON.stringify(issue.keys) : undefined,
        unionErrors: 'unionErrors' in issue ? JSON.stringify(issue.unionErrors) : undefined
    });
}
/**
 * Takes ZodError issue path array and returns a flattened version as a string.
 * This makes it easier to display paths within a Sentry error message.
 *
 * Array indexes are normalized to reduce duplicate entries
 *
 * @param path ZodError issue path
 * @returns flattened path
 *
 * @example
 * flattenIssuePath([0, 'foo', 1, 'bar']) // -> '<array>.foo.<array>.bar'
 */ function flattenIssuePath(path) {
    return path.map(function(p) {
        if (typeof p === 'number') return '<array>';
        else return p;
    }).join('.');
}
/**
 * Zod error message is a stringified version of ZodError.issues
 * This doesn't display well in the Sentry UI. Replace it with something shorter.
 */ function formatIssueMessage(zodError) {
    var errorKeyMap = new Set();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = zodError.issues[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var iss = _step.value;
            var issuePath = flattenIssuePath(iss.path);
            if (issuePath.length > 0) errorKeyMap.add(issuePath);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var errorKeys = Array.from(errorKeyMap);
    if (errorKeys.length === 0) {
        // If there are no keys, then we're likely validating the root
        // variable rather than a key within an object. This attempts
        // to extract what type it was that failed to validate.
        // For example, z.string().parse(123) would return "string" here.
        var rootExpectedType = 'variable';
        if (zodError.issues.length > 0) {
            var iss1 = zodError.issues[0];
            if (iss1 !== undefined && 'expected' in iss1 && typeof iss1.expected === 'string') rootExpectedType = iss1.expected;
        }
        return "Failed to validate ".concat(rootExpectedType);
    }
    return "Failed to validate keys: ".concat((0, _stringJs.truncate)(errorKeys.join(', '), 100));
}
/**
 * Applies ZodError issues to an event extra and replaces the error message
 */ function applyZodErrorsToEvent(limit) {
    var saveZodIssuesAsAttachment = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, event = arguments.length > 2 ? arguments[2] : void 0, hint = arguments.length > 3 ? arguments[3] : void 0;
    var _event_exception;
    if (!((_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : _event_exception.values) || !hint.originalException || !originalExceptionIsZodError(hint.originalException) || hint.originalException.issues.length === 0) return event;
    try {
        var issuesToFlatten = saveZodIssuesAsAttachment ? hint.originalException.issues : hint.originalException.issues.slice(0, limit);
        var flattenedIssues = issuesToFlatten.map(flattenIssue);
        if (saveZodIssuesAsAttachment) {
            // Sometimes having the full error details can be helpful.
            // Attachments have much higher limits, so we can include the full list of issues.
            if (!Array.isArray(hint.attachments)) hint.attachments = [];
            hint.attachments.push({
                filename: 'zod_issues.json',
                data: JSON.stringify({
                    issues: flattenedIssues
                })
            });
        }
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, event), {
            exception: (0, _objectSpreadProps._)((0, _objectSpread._)({}, event.exception), {
                values: [
                    (0, _objectSpreadProps._)((0, _objectSpread._)({}, event.exception.values[0]), {
                        value: formatIssueMessage(hint.originalException)
                    })
                ].concat((0, _toConsumableArray._)(event.exception.values.slice(1)))
            }),
            extra: (0, _objectSpreadProps._)((0, _objectSpread._)({}, event.extra), {
                'zoderror.issues': flattenedIssues.slice(0, limit)
            })
        });
    } catch (e) {
        // Hopefully we never throw errors here, but record it
        // with the event just in case.
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, event), {
            extra: (0, _objectSpreadProps._)((0, _objectSpread._)({}, event.extra), {
                'zoderrors sentry integration parse error': {
                    message: 'an exception was thrown while processing ZodError within applyZodErrorsToEvent()',
                    error: (0, _instanceof._)(e, Error) ? "".concat(e.name, ": ").concat(e.message, "\n").concat(e.stack) : 'unknown'
                }
            })
        });
    }
}
var _zodErrorsIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _options_limit;
    var limit = (_options_limit = options.limit) !== null && _options_limit !== void 0 ? _options_limit : DEFAULT_LIMIT;
    return {
        name: INTEGRATION_NAME,
        processEvent: function processEvent(originalEvent, hint) {
            var processedEvent = applyZodErrorsToEvent(limit, options.saveZodIssuesAsAttachment, originalEvent, hint);
            return processedEvent;
        }
    };
};
/**
 * Sentry integration to process Zod errors, making them easier to work with in Sentry.
 */ var zodErrorsIntegration = (0, _integrationJs.defineIntegration)(_zodErrorsIntegration);

},{"@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_to_consumable_array":"1eSZf","../integration.js":"brH19","../utils/is.js":"kSqSf","../utils/string.js":"j38bn","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6fktY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "thirdPartyErrorFilterIntegration", function() {
    return thirdPartyErrorFilterIntegration;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _integrationJs = require("../integration.js");
var _metadataJs = require("../metadata.js");
var _envelopeJs = require("../utils/envelope.js");
var _stacktraceJs = require("../utils/stacktrace.js");
/**
 * This integration allows you to filter out, or tag error events that do not come from user code marked with a bundle key via the Sentry bundler plugins.
 */ var thirdPartyErrorFilterIntegration = (0, _integrationJs.defineIntegration)(function(options) {
    return {
        name: 'ThirdPartyErrorsFilter',
        setup: function setup(client) {
            // We need to strip metadata from stack frames before sending them to Sentry since these are client side only.
            client.on('beforeEnvelope', function(envelope) {
                (0, _envelopeJs.forEachEnvelopeItem)(envelope, function(item, type) {
                    if (type === 'event') {
                        var event = Array.isArray(item) ? item[1] : undefined;
                        if (event) {
                            (0, _metadataJs.stripMetadataFromStackFrames)(event);
                            item[1] = event;
                        }
                    }
                });
            });
            client.on('applyFrameMetadata', function(event) {
                // Only apply stack frame metadata to error events
                if (event.type) return;
                var stackParser = client.getOptions().stackParser;
                (0, _metadataJs.addMetadataToStackFrames)(stackParser, event);
            });
        },
        processEvent: function processEvent(event) {
            var frameKeys = getBundleKeysForAllFramesWithFilenames(event);
            if (frameKeys) {
                var arrayMethod = options.behaviour === 'drop-error-if-contains-third-party-frames' || options.behaviour === 'apply-tag-if-contains-third-party-frames' ? 'some' : 'every';
                var behaviourApplies = frameKeys[arrayMethod](function(keys) {
                    return !keys.some(function(key) {
                        return options.filterKeys.includes(key);
                    });
                });
                if (behaviourApplies) {
                    var shouldDrop = options.behaviour === 'drop-error-if-contains-third-party-frames' || options.behaviour === 'drop-error-if-exclusively-contains-third-party-frames';
                    if (shouldDrop) return null;
                    else event.tags = (0, _objectSpreadProps._)((0, _objectSpread._)({}, event.tags), {
                        third_party_code: true
                    });
                }
            }
            return event;
        }
    };
});
function getBundleKeysForAllFramesWithFilenames(event) {
    var frames = (0, _stacktraceJs.getFramesFromEvent)(event);
    if (!frames) return undefined;
    return frames// Exclude frames without a filename or without lineno and colno,
    // since these are likely native code or built-ins
    .filter(function(frame) {
        var _frame_lineno;
        return !!frame.filename && ((_frame_lineno = frame.lineno) !== null && _frame_lineno !== void 0 ? _frame_lineno : frame.colno) != null;
    }).map(function(frame) {
        if (frame.module_metadata) return Object.keys(frame.module_metadata).filter(function(key) {
            return key.startsWith(BUNDLER_PLUGIN_APP_KEY_PREFIX);
        }).map(function(key) {
            return key.slice(BUNDLER_PLUGIN_APP_KEY_PREFIX.length);
        });
        return [];
    });
}
var BUNDLER_PLUGIN_APP_KEY_PREFIX = '_sentryBundlerPluginAppKey:';

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","../integration.js":"brH19","../metadata.js":"7Sw0A","../utils/envelope.js":"fDBh0","../utils/stacktrace.js":"5srWn","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"Jf7TC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addConsoleBreadcrumb", function() {
    return addConsoleBreadcrumb;
});
parcelHelpers.export(exports, "consoleIntegration", function() {
    return consoleIntegration;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _breadcrumbsJs = require("../breadcrumbs.js");
var _currentScopesJs = require("../currentScopes.js");
var _consoleJs = require("../instrument/console.js");
var _integrationJs = require("../integration.js");
var _debugLoggerJs = require("../utils/debug-logger.js");
var _severityJs = require("../utils/severity.js");
var _stringJs = require("../utils/string.js");
var _worldwideJs = require("../utils/worldwide.js");
var INTEGRATION_NAME = 'Console';
/**
 * Captures calls to the `console` API as breadcrumbs in Sentry.
 *
 * By default the integration instruments `console.debug`, `console.info`, `console.warn`, `console.error`,
 * `console.log`, `console.trace`, and `console.assert`. You can use the `levels` option to customize which
 * levels are captured.
 *
 * @example
 *
 * ```js
 * Sentry.init({
 *   integrations: [Sentry.consoleIntegration({ levels: ['error', 'warn'] })],
 * });
 * ```
 */ var consoleIntegration = (0, _integrationJs.defineIntegration)(function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var levels = new Set(options.levels || (0, _debugLoggerJs.CONSOLE_LEVELS));
    return {
        name: INTEGRATION_NAME,
        setup: function setup(client) {
            (0, _consoleJs.addConsoleInstrumentationHandler)(function(param) {
                var args = param.args, level = param.level;
                if ((0, _currentScopesJs.getClient)() !== client || !levels.has(level)) return;
                addConsoleBreadcrumb(level, args);
            });
        }
    };
});
/**
 * Capture a console breadcrumb.
 *
 * Exported just for tests.
 */ function addConsoleBreadcrumb(level, args) {
    var breadcrumb = {
        category: 'console',
        data: {
            arguments: args,
            logger: 'console'
        },
        level: (0, _severityJs.severityLevelFromString)(level),
        message: formatConsoleArgs(args)
    };
    if (level === 'assert') {
        if (args[0] === false) {
            var assertionArgs = args.slice(1);
            breadcrumb.message = assertionArgs.length > 0 ? "Assertion failed: ".concat(formatConsoleArgs(assertionArgs)) : 'Assertion failed';
            breadcrumb.data.arguments = assertionArgs;
        } else // Don't capture a breadcrumb for passed assertions
        return;
    }
    (0, _breadcrumbsJs.addBreadcrumb)(breadcrumb, {
        input: args,
        level: level
    });
}
function formatConsoleArgs(values) {
    var _GLOBAL_OBJ_util;
    return 'util' in (0, _worldwideJs.GLOBAL_OBJ) && typeof (0, _worldwideJs.GLOBAL_OBJ).util.format === 'function' ? (_GLOBAL_OBJ_util = (0, _worldwideJs.GLOBAL_OBJ).util).format.apply(_GLOBAL_OBJ_util, (0, _toConsumableArray._)(values)) : (0, _stringJs.safeJoin)(values, ' ');
}

},{"@swc/helpers/_/_to_consumable_array":"1eSZf","../breadcrumbs.js":"d8fz5","../currentScopes.js":"3GE4v","../instrument/console.js":"eEuZ3","../integration.js":"brH19","../utils/debug-logger.js":"3X9Vf","../utils/severity.js":"bgJKP","../utils/string.js":"j38bn","../utils/worldwide.js":"3qnNR","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"52WJQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "featureFlagsIntegration", function() {
    return featureFlagsIntegration;
});
var _integrationJs = require("../../integration.js");
var _featureFlagsJs = require("../../utils/featureFlags.js");
/**
 * Sentry integration for buffering feature flag evaluations manually with an API, and
 * capturing them on error events and spans.
 *
 * See the [feature flag documentation](https://develop.sentry.dev/sdk/expected-features/#feature-flags) for more information.
 *
 * @example
 * ```
 * import * as Sentry from '@sentry/browser';
 * import { type FeatureFlagsIntegration } from '@sentry/browser';
 *
 * // Setup
 * Sentry.init(..., integrations: [Sentry.featureFlagsIntegration()])
 *
 * // Verify
 * const flagsIntegration = Sentry.getClient()?.getIntegrationByName<FeatureFlagsIntegration>('FeatureFlags');
 * if (flagsIntegration) {
 *   flagsIntegration.addFeatureFlag('my-flag', true);
 * } else {
 *   // check your setup
 * }
 * Sentry.captureException(Exception('broke')); // 'my-flag' should be captured to this Sentry event.
 * ```
 */ var featureFlagsIntegration = (0, _integrationJs.defineIntegration)(function() {
    return {
        name: 'FeatureFlags',
        processEvent: function processEvent(event, _hint, _client) {
            return (0, _featureFlagsJs._INTERNAL_copyFlagsFromScopeToEvent)(event);
        },
        addFeatureFlag: function addFeatureFlag(name, value) {
            (0, _featureFlagsJs._INTERNAL_insertFlagToScope)(name, value);
            (0, _featureFlagsJs._INTERNAL_addFeatureFlagToActiveSpan)(name, value);
        }
    };
});

},{"../../integration.js":"brH19","../../utils/featureFlags.js":"7Ay9H","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7Ay9H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_INTERNAL_FLAG_BUFFER_SIZE", function() {
    return _INTERNAL_FLAG_BUFFER_SIZE;
});
parcelHelpers.export(exports, "_INTERNAL_MAX_FLAGS_PER_SPAN", function() {
    return _INTERNAL_MAX_FLAGS_PER_SPAN;
});
parcelHelpers.export(exports, "_INTERNAL_addFeatureFlagToActiveSpan", function() {
    return _INTERNAL_addFeatureFlagToActiveSpan;
});
parcelHelpers.export(exports, "_INTERNAL_copyFlagsFromScopeToEvent", function() {
    return _INTERNAL_copyFlagsFromScopeToEvent;
});
parcelHelpers.export(exports, "_INTERNAL_insertFlagToScope", function() {
    return _INTERNAL_insertFlagToScope;
});
parcelHelpers.export(exports, "_INTERNAL_insertToFlagBuffer", function() {
    return _INTERNAL_insertToFlagBuffer;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _currentScopesJs = require("../currentScopes.js");
var _debugBuildJs = require("../debug-build.js");
var _debugLoggerJs = require("./debug-logger.js");
var _spanUtilsJs = require("./spanUtils.js");
/**
 * Ordered LRU cache for storing feature flags in the scope context. The name
 * of each flag in the buffer is unique, and the output of getAll() is ordered
 * from oldest to newest.
 */ /**
 * Max size of the LRU flag buffer stored in Sentry scope and event contexts.
 */ var _INTERNAL_FLAG_BUFFER_SIZE = 100;
/**
 * Max number of flag evaluations to record per span.
 */ var _INTERNAL_MAX_FLAGS_PER_SPAN = 10;
var SPAN_FLAG_ATTRIBUTE_PREFIX = 'flag.evaluation.';
/**
 * Copies feature flags that are in current scope context to the event context
 */ function _INTERNAL_copyFlagsFromScopeToEvent(event) {
    var scope = (0, _currentScopesJs.getCurrentScope)();
    var flagContext = scope.getScopeData().contexts.flags;
    var flagBuffer = flagContext ? flagContext.values : [];
    if (!flagBuffer.length) return event;
    if (event.contexts === undefined) event.contexts = {};
    event.contexts.flags = {
        values: (0, _toConsumableArray._)(flagBuffer)
    };
    return event;
}
/**
 * Inserts a flag into the current scope's context while maintaining ordered LRU properties.
 * Not thread-safe. After inserting:
 * - The flag buffer is sorted in order of recency, with the newest evaluation at the end.
 * - The names in the buffer are always unique.
 * - The length of the buffer never exceeds `maxSize`.
 *
 * @param name     Name of the feature flag to insert.
 * @param value    Value of the feature flag.
 * @param maxSize  Max number of flags the buffer should store. Default value should always be used in production.
 */ function _INTERNAL_insertFlagToScope(name, value) {
    var maxSize = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : _INTERNAL_FLAG_BUFFER_SIZE;
    var scopeContexts = (0, _currentScopesJs.getCurrentScope)().getScopeData().contexts;
    if (!scopeContexts.flags) scopeContexts.flags = {
        values: []
    };
    var flags = scopeContexts.flags.values;
    _INTERNAL_insertToFlagBuffer(flags, name, value, maxSize);
}
/**
 * Exported for tests only. Currently only accepts boolean values (otherwise no-op).
 * Inserts a flag into a FeatureFlag array while maintaining the following properties:
 * - Flags are sorted in order of recency, with the newest evaluation at the end.
 * - The flag names are always unique.
 * - The length of the array never exceeds `maxSize`.
 *
 * @param flags      The buffer to insert the flag into.
 * @param name       Name of the feature flag to insert.
 * @param value      Value of the feature flag.
 * @param maxSize    Max number of flags the buffer should store. Default value should always be used in production.
 */ function _INTERNAL_insertToFlagBuffer(flags, name, value, maxSize) {
    if (typeof value !== 'boolean') return;
    if (flags.length > maxSize) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).error("[Feature Flags] insertToFlagBuffer called on a buffer larger than maxSize=".concat(maxSize));
        return;
    }
    // Check if the flag is already in the buffer - O(n)
    var index = flags.findIndex(function(f) {
        return f.flag === name;
    });
    if (index !== -1) // The flag was found, remove it from its current position - O(n)
    flags.splice(index, 1);
    if (flags.length === maxSize) // If at capacity, pop the earliest flag - O(n)
    flags.shift();
    // Push the flag to the end - O(1)
    flags.push({
        flag: name,
        result: value
    });
}
/**
 * Records a feature flag evaluation for the active span. This is a no-op for non-boolean values.
 * The flag and its value is stored in span attributes with the `flag.evaluation` prefix. Once the
 * unique flags for a span reaches maxFlagsPerSpan, subsequent flags are dropped.
 *
 * @param name             Name of the feature flag.
 * @param value            Value of the feature flag. Non-boolean values are ignored.
 * @param maxFlagsPerSpan  Max number of flags a buffer should store. Default value should always be used in production.
 */ function _INTERNAL_addFeatureFlagToActiveSpan(name, value) {
    var maxFlagsPerSpan = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : _INTERNAL_MAX_FLAGS_PER_SPAN;
    if (typeof value !== 'boolean') return;
    var span = (0, _spanUtilsJs.getActiveSpan)();
    if (!span) return;
    var attributes = (0, _spanUtilsJs.spanToJSON)(span).data;
    // If the flag already exists, always update it
    if ("".concat(SPAN_FLAG_ATTRIBUTE_PREFIX).concat(name) in attributes) {
        span.setAttribute("".concat(SPAN_FLAG_ATTRIBUTE_PREFIX).concat(name), value);
        return;
    }
    // Else, add the flag to the span if we have not reached the max number of flags
    var numOfAddedFlags = Object.keys(attributes).filter(function(key) {
        return key.startsWith(SPAN_FLAG_ATTRIBUTE_PREFIX);
    }).length;
    if (numOfAddedFlags < maxFlagsPerSpan) span.setAttribute("".concat(SPAN_FLAG_ATTRIBUTE_PREFIX).concat(name), value);
}

},{"@swc/helpers/_/_to_consumable_array":"1eSZf","../currentScopes.js":"3GE4v","../debug-build.js":"ejIQP","./debug-logger.js":"3X9Vf","./spanUtils.js":"fPRKj","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eSQGk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "growthbookIntegration", function() {
    return growthbookIntegration;
});
var _integrationJs = require("../../integration.js");
var _featureFlagsJs = require("../../utils/featureFlags.js");
var _objectJs = require("../../utils/object.js");
/**
 * Sentry integration for capturing feature flag evaluations from GrowthBook.
 *
 * Only boolean results are captured at this time.
 *
 * @example
 * ```typescript
 * import { GrowthBook } from '@growthbook/growthbook';
 * import * as Sentry from '@sentry/browser'; // or '@sentry/node'
 *
 * Sentry.init({
 *   dsn: 'your-dsn',
 *   integrations: [
 *     Sentry.growthbookIntegration({ growthbookClass: GrowthBook })
 *   ]
 * });
 * ```
 */ var growthbookIntegration = (0, _integrationJs.defineIntegration)(function(param) {
    var growthbookClass = param.growthbookClass;
    return {
        name: 'GrowthBook',
        setupOnce: function setupOnce() {
            var proto = growthbookClass.prototype;
            // Type guard and wrap isOn
            if (typeof proto.isOn === 'function') (0, _objectJs.fill)(proto, 'isOn', _wrapAndCaptureBooleanResult);
            // Type guard and wrap getFeatureValue
            if (typeof proto.getFeatureValue === 'function') (0, _objectJs.fill)(proto, 'getFeatureValue', _wrapAndCaptureBooleanResult);
        },
        processEvent: function processEvent(event, _hint, _client) {
            return (0, _featureFlagsJs._INTERNAL_copyFlagsFromScopeToEvent)(event);
        }
    };
});
function _wrapAndCaptureBooleanResult(original) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var flagName = args[0];
        var result = original.apply(this, args);
        if (typeof flagName === 'string' && typeof result === 'boolean') {
            (0, _featureFlagsJs._INTERNAL_insertFlagToScope)(flagName, result);
            (0, _featureFlagsJs._INTERNAL_addFeatureFlagToActiveSpan)(flagName, result);
        }
        return result;
    };
}

},{"../../integration.js":"brH19","../../utils/featureFlags.js":"7Ay9H","../../utils/object.js":"9SKe9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7leUb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "profiler", function() {
    return profiler;
});
var _currentScopesJs = require("./currentScopes.js");
var _debugBuildJs = require("./debug-build.js");
var _debugLoggerJs = require("./utils/debug-logger.js");
function isProfilingIntegrationWithProfiler(integration) {
    return !!integration && typeof integration['_profiler'] !== 'undefined' && typeof integration['_profiler']['start'] === 'function' && typeof integration['_profiler']['stop'] === 'function';
}
/**
 * Starts the Sentry continuous profiler.
 * This mode is exclusive with the transaction profiler and will only work if the profilesSampleRate is set to a falsy value.
 * In continuous profiling mode, the profiler will keep reporting profile chunks to Sentry until it is stopped, which allows for continuous profiling of the application.
 */ function startProfiler() {
    var client = (0, _currentScopesJs.getClient)();
    if (!client) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn('No Sentry client available, profiling is not started');
        return;
    }
    var integration = client.getIntegrationByName('ProfilingIntegration');
    if (!integration) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn('ProfilingIntegration is not available');
        return;
    }
    if (!isProfilingIntegrationWithProfiler(integration)) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn('Profiler is not available on profiling integration.');
        return;
    }
    integration._profiler.start();
}
/**
 * Stops the Sentry continuous profiler.
 * Calls to stop will stop the profiler and flush the currently collected profile data to Sentry.
 */ function stopProfiler() {
    var client = (0, _currentScopesJs.getClient)();
    if (!client) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn('No Sentry client available, profiling is not started');
        return;
    }
    var integration = client.getIntegrationByName('ProfilingIntegration');
    if (!integration) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn('ProfilingIntegration is not available');
        return;
    }
    if (!isProfilingIntegrationWithProfiler(integration)) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn('Profiler is not available on profiling integration.');
        return;
    }
    integration._profiler.stop();
}
/**
 * Profiler namespace for controlling the profiler in 'manual' mode.
 *
 * Requires the `nodeProfilingIntegration` from the `@sentry/profiling-node` package.
 */ var profiler = {
    startProfiler: startProfiler,
    stopProfiler: stopProfiler
};

},{"./currentScopes.js":"3GE4v","./debug-build.js":"ejIQP","./utils/debug-logger.js":"3X9Vf","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3u3sW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_addTracingHeadersToFetchRequest", function() {
    return _addTracingHeadersToFetchRequest;
});
parcelHelpers.export(exports, "_callOnRequestSpanEnd", function() {
    return _callOnRequestSpanEnd;
});
parcelHelpers.export(exports, "instrumentFetchRequest", function() {
    return instrumentFetchRequest;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var _currentScopesJs = require("./currentScopes.js");
var _semanticAttributesJs = require("./semanticAttributes.js");
var _spanUtilsJs = require("./utils/spanUtils.js");
var _spanstatusJs = require("./tracing/spanstatus.js");
var _isJs = require("./utils/is.js");
var _hasSpansEnabledJs = require("./utils/hasSpansEnabled.js");
var _baggageJs = require("./utils/baggage.js");
var _sentryNonRecordingSpanJs = require("./tracing/sentryNonRecordingSpan.js");
var _traceJs = require("./tracing/trace.js");
var _traceDataJs = require("./utils/traceData.js");
var _urlJs = require("./utils/url.js");
/**
 * Create and track fetch request spans for usage in combination with `addFetchInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */ function instrumentFetchRequest(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOriginOrOptions) {
    if (!handlerData.fetchData) return undefined;
    var _handlerData_fetchData = handlerData.fetchData, method = _handlerData_fetchData.method, url = _handlerData_fetchData.url;
    var shouldCreateSpanResult = (0, _hasSpansEnabledJs.hasSpansEnabled)() && shouldCreateSpan(url);
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        var spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        var span = spans[spanId];
        if (span) {
            endSpan(span, handlerData);
            _callOnRequestSpanEnd(span, handlerData, spanOriginOrOptions);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    // Backwards-compatible with the old signature. Needed to introduce the combined optional parameter
    // to avoid API breakage for anyone calling this function with the optional spanOrigin parameter
    // TODO (v11): remove this backwards-compatible code and only accept the options parameter
    var _ref = (typeof spanOriginOrOptions === "undefined" ? "undefined" : (0, _typeOf._)(spanOriginOrOptions)) === 'object' ? spanOriginOrOptions : {
        spanOrigin: spanOriginOrOptions
    }, _ref_spanOrigin = _ref.spanOrigin, spanOrigin = _ref_spanOrigin === void 0 ? 'auto.http.browser' : _ref_spanOrigin, _ref_propagateTraceparent = _ref.propagateTraceparent, propagateTraceparent = _ref_propagateTraceparent === void 0 ? false : _ref_propagateTraceparent;
    var hasParent = !!(0, _spanUtilsJs.getActiveSpan)();
    var span1 = shouldCreateSpanResult && hasParent ? (0, _traceJs.startInactiveSpan)(getSpanStartOptions(url, method, spanOrigin)) : new (0, _sentryNonRecordingSpanJs.SentryNonRecordingSpan)();
    handlerData.fetchData.__span = span1.spanContext().spanId;
    spans[span1.spanContext().spanId] = span1;
    if (shouldAttachHeaders(handlerData.fetchData.url)) {
        var request = handlerData.args[0];
        var options = handlerData.args[1] || {};
        var headers = _addTracingHeadersToFetchRequest(request, options, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
        // we do not want to use the span as base for the trace headers,
        // which means that the headers will be generated from the scope and the sampling decision is deferred
        (0, _hasSpansEnabledJs.hasSpansEnabled)() && hasParent ? span1 : undefined, propagateTraceparent);
        if (headers) {
            // Ensure this is actually set, if no options have been passed previously
            handlerData.args[1] = options;
            options.headers = headers;
        }
    }
    var client = (0, _currentScopesJs.getClient)();
    if (client) {
        var fetchHint = {
            input: handlerData.args,
            response: handlerData.response,
            startTimestamp: handlerData.startTimestamp,
            endTimestamp: handlerData.endTimestamp
        };
        client.emit('beforeOutgoingRequestSpan', span1, fetchHint);
    }
    return span1;
}
/**
 * Calls the onRequestSpanEnd callback if it is defined.
 */ function _callOnRequestSpanEnd(span, handlerData, spanOriginOrOptions) {
    var _handlerData_response;
    var onRequestSpanEnd = (typeof spanOriginOrOptions === "undefined" ? "undefined" : (0, _typeOf._)(spanOriginOrOptions)) === 'object' && spanOriginOrOptions !== null ? spanOriginOrOptions.onRequestSpanEnd : undefined;
    onRequestSpanEnd === null || onRequestSpanEnd === void 0 ? void 0 : onRequestSpanEnd(span, {
        headers: (_handlerData_response = handlerData.response) === null || _handlerData_response === void 0 ? void 0 : _handlerData_response.headers,
        error: handlerData.error
    });
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers.
 * exported only for testing purposes
 *
 * When we determine if we should add a baggage header, there are 3 cases:
 * 1. No previous baggage header -> add baggage
 * 2. Previous baggage header has no sentry baggage values -> add our baggage
 * 3. Previous baggage header has sentry baggage values -> do nothing (might have been added manually by users)
 */ // eslint-disable-next-line complexity -- yup it's this complicated :(
function _addTracingHeadersToFetchRequest(request, fetchOptionsObj, span, propagateTraceparent) {
    var traceHeaders = (0, _traceDataJs.getTraceData)({
        span: span,
        propagateTraceparent: propagateTraceparent
    });
    var sentryTrace = traceHeaders['sentry-trace'];
    var baggage = traceHeaders.baggage;
    var traceparent = traceHeaders.traceparent;
    // Nothing to do, when we return undefined here, the original headers will be used
    if (!sentryTrace) return undefined;
    var originalHeaders = fetchOptionsObj.headers || ((0, _isJs.isRequest)(request) ? request.headers : undefined);
    if (!originalHeaders) return (0, _objectSpread._)({}, traceHeaders);
    else if (isHeaders(originalHeaders)) {
        var newHeaders = new Headers(originalHeaders);
        // We don't want to override manually added sentry headers
        if (!newHeaders.get('sentry-trace')) newHeaders.set('sentry-trace', sentryTrace);
        if (propagateTraceparent && traceparent && !newHeaders.get('traceparent')) newHeaders.set('traceparent', traceparent);
        if (baggage) {
            var prevBaggageHeader = newHeaders.get('baggage');
            if (!prevBaggageHeader) newHeaders.set('baggage', baggage);
            else if (!baggageHeaderHasSentryBaggageValues(prevBaggageHeader)) newHeaders.set('baggage', "".concat(prevBaggageHeader, ",").concat(baggage));
        }
        return newHeaders;
    } else if (Array.isArray(originalHeaders)) {
        var newHeaders1 = (0, _toConsumableArray._)(originalHeaders);
        if (!originalHeaders.find(function(header) {
            return header[0] === 'sentry-trace';
        })) newHeaders1.push([
            'sentry-trace',
            sentryTrace
        ]);
        if (propagateTraceparent && traceparent && !originalHeaders.find(function(header) {
            return header[0] === 'traceparent';
        })) newHeaders1.push([
            'traceparent',
            traceparent
        ]);
        var prevBaggageHeaderWithSentryValues = originalHeaders.find(function(header) {
            return header[0] === 'baggage' && baggageHeaderHasSentryBaggageValues(header[1]);
        });
        if (baggage && !prevBaggageHeaderWithSentryValues) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders1.push([
            'baggage',
            baggage
        ]);
        return newHeaders1;
    } else {
        var existingSentryTraceHeader = 'sentry-trace' in originalHeaders ? originalHeaders['sentry-trace'] : undefined;
        var existingTraceparentHeader = 'traceparent' in originalHeaders ? originalHeaders.traceparent : undefined;
        var existingBaggageHeader = 'baggage' in originalHeaders ? originalHeaders.baggage : undefined;
        var newBaggageHeaders = existingBaggageHeader ? Array.isArray(existingBaggageHeader) ? (0, _toConsumableArray._)(existingBaggageHeader) : [
            existingBaggageHeader
        ] : [];
        var prevBaggageHeaderWithSentryValues1 = existingBaggageHeader && (Array.isArray(existingBaggageHeader) ? existingBaggageHeader.find(function(headerItem) {
            return baggageHeaderHasSentryBaggageValues(headerItem);
        }) : baggageHeaderHasSentryBaggageValues(existingBaggageHeader));
        if (baggage && !prevBaggageHeaderWithSentryValues1) newBaggageHeaders.push(baggage);
        var newHeaders2 = (0, _objectSpreadProps._)((0, _objectSpread._)({}, originalHeaders), {
            'sentry-trace': existingSentryTraceHeader !== null && existingSentryTraceHeader !== void 0 ? existingSentryTraceHeader : sentryTrace,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(',') : undefined
        });
        if (propagateTraceparent && traceparent && !existingTraceparentHeader) newHeaders2.traceparent = traceparent;
        return newHeaders2;
    }
}
function endSpan(span, handlerData) {
    if (handlerData.response) {
        var _handlerData_response_headers, _handlerData_response;
        (0, _spanstatusJs.setHttpStatus)(span, handlerData.response.status);
        var contentLength = (_handlerData_response = handlerData.response) === null || _handlerData_response === void 0 ? void 0 : (_handlerData_response_headers = _handlerData_response.headers) === null || _handlerData_response_headers === void 0 ? void 0 : _handlerData_response_headers.get('content-length');
        if (contentLength) {
            var contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute('http.response_content_length', contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus({
        code: (0, _spanstatusJs.SPAN_STATUS_ERROR),
        message: 'internal_error'
    });
    span.end();
}
function baggageHeaderHasSentryBaggageValues(baggageHeader) {
    return baggageHeader.split(',').some(function(baggageEntry) {
        return baggageEntry.trim().startsWith((0, _baggageJs.SENTRY_BAGGAGE_KEY_PREFIX));
    });
}
function isHeaders(headers) {
    return typeof Headers !== 'undefined' && (0, _isJs.isInstanceOf)(headers, Headers);
}
function getSpanStartOptions(url, method, spanOrigin) {
    var parsedUrl = (0, _urlJs.parseStringToURLObject)(url);
    return {
        name: parsedUrl ? "".concat(method, " ").concat((0, _urlJs.getSanitizedUrlStringFromUrlObject)(parsedUrl)) : method,
        attributes: getFetchSpanAttributes(url, parsedUrl, method, spanOrigin)
    };
}
function getFetchSpanAttributes(url, parsedUrl, method, spanOrigin) {
    var _obj;
    var attributes = (_obj = {
        url: url,
        type: 'fetch',
        'http.method': method
    }, (0, _defineProperty._)(_obj, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), spanOrigin), (0, _defineProperty._)(_obj, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP), 'http.client'), _obj);
    if (parsedUrl) {
        if (!(0, _urlJs.isURLObjectRelative)(parsedUrl)) {
            attributes['http.url'] = parsedUrl.href;
            attributes['server.address'] = parsedUrl.host;
        }
        if (parsedUrl.search) attributes['http.query'] = parsedUrl.search;
        if (parsedUrl.hash) attributes['http.fragment'] = parsedUrl.hash;
    }
    return attributes;
}

},{"@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_to_consumable_array":"1eSZf","@swc/helpers/_/_type_of":"iFJdx","./currentScopes.js":"3GE4v","./semanticAttributes.js":"7WRPE","./utils/spanUtils.js":"fPRKj","./tracing/spanstatus.js":"WiYVV","./utils/is.js":"kSqSf","./utils/hasSpansEnabled.js":"klZEt","./utils/baggage.js":"8aTvT","./tracing/sentryNonRecordingSpan.js":"j8tB0","./tracing/trace.js":"eu0PU","./utils/traceData.js":"1Pg6b","./utils/url.js":"5Wd7K","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5ivG0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "trpcMiddleware", function() {
    return trpcMiddleware;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _typeOf = require("@swc/helpers/_/_type_of");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _currentScopesJs = require("./currentScopes.js");
var _exportsJs = require("./exports.js");
var _semanticAttributesJs = require("./semanticAttributes.js");
var _objectJs = require("./utils/object.js");
var _normalizeJs = require("./utils/normalize.js");
var _traceJs = require("./tracing/trace.js");
var trpcCaptureContext = {
    mechanism: {
        handled: false,
        type: 'auto.rpc.trpc.middleware'
    }
};
function captureIfError(nextResult) {
    // TODO: Set span status based on what TRPCError was encountered
    if ((typeof nextResult === "undefined" ? "undefined" : (0, _typeOf._)(nextResult)) === 'object' && nextResult !== null && 'ok' in nextResult && !nextResult.ok && 'error' in nextResult) (0, _exportsJs.captureException)(nextResult.error, trpcCaptureContext);
}
/**
 * Sentry tRPC middleware that captures errors and creates spans for tRPC procedures.
 */ function trpcMiddleware() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return function(opts) {
        return (0, _asyncToGenerator._)(function() {
            var path, type, next, rawInput, getRawInput, client, clientOptions, trpcContext, // 1 for context.input + the normal normalization depth
            _clientOptions_normalizeDepth, rawRes, e;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        path = opts.path, type = opts.type, next = opts.next, rawInput = opts.rawInput, getRawInput = opts.getRawInput;
                        client = (0, _currentScopesJs.getClient)();
                        clientOptions = client === null || client === void 0 ? void 0 : client.getOptions();
                        trpcContext = {
                            procedure_path: path,
                            procedure_type: type
                        };
                        (0, _objectJs.addNonEnumerableProperty)(trpcContext, '__sentry_override_normalization_depth__', 1 + ((_clientOptions_normalizeDepth = clientOptions === null || clientOptions === void 0 ? void 0 : clientOptions.normalizeDepth) !== null && _clientOptions_normalizeDepth !== void 0 ? _clientOptions_normalizeDepth : 5));
                        if (!(options.attachRpcInput !== undefined ? options.attachRpcInput : clientOptions === null || clientOptions === void 0 ? void 0 : clientOptions.sendDefaultPii)) return [
                            3,
                            4
                        ];
                        if (rawInput !== undefined) trpcContext.input = (0, _normalizeJs.normalize)(rawInput);
                        if (!(getRawInput !== undefined && typeof getRawInput === 'function')) return [
                            3,
                            4
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            getRawInput()
                        ];
                    case 2:
                        rawRes = _state.sent();
                        trpcContext.input = (0, _normalizeJs.normalize)(rawRes);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2,
                            (0, _currentScopesJs.withIsolationScope)(function(scope) {
                                scope.setContext('trpc', trpcContext);
                                var _obj;
                                return (0, _traceJs.startSpanManual)({
                                    name: "trpc/".concat(path),
                                    op: 'rpc.server',
                                    attributes: (_obj = {}, (0, _defineProperty._)(_obj, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), 'route'), (0, _defineProperty._)(_obj, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), 'auto.rpc.trpc'), _obj),
                                    forceTransaction: !!options.forceTransaction
                                }, function(span) {
                                    return (0, _asyncToGenerator._)(function() {
                                        var nextResult, e;
                                        return (0, _tsGenerator._)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    _state.trys.push([
                                                        0,
                                                        2,
                                                        ,
                                                        3
                                                    ]);
                                                    return [
                                                        4,
                                                        next()
                                                    ];
                                                case 1:
                                                    nextResult = _state.sent();
                                                    captureIfError(nextResult);
                                                    span.end();
                                                    return [
                                                        2,
                                                        nextResult
                                                    ];
                                                case 2:
                                                    e = _state.sent();
                                                    (0, _exportsJs.captureException)(e, trpcCaptureContext);
                                                    span.end();
                                                    throw e;
                                                case 3:
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    })();
                                });
                            })
                        ];
                }
            });
        })();
    };
}

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_type_of":"iFJdx","@swc/helpers/_/_ts_generator":"78Tqx","./currentScopes.js":"3GE4v","./exports.js":"1Xqap","./semanticAttributes.js":"7WRPE","./utils/object.js":"9SKe9","./utils/normalize.js":"k9k7R","./tracing/trace.js":"eu0PU","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"h79GQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "wrapMcpServerWithSentry", function() {
    return wrapMcpServerWithSentry;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _objectJs = require("../../utils/object.js");
var _handlersJs = require("./handlers.js");
var _transportJs = require("./transport.js");
var _validationJs = require("./validation.js");
/**
 * Tracks wrapped MCP server instances to prevent double-wrapping
 * @internal
 */ var wrappedMcpServerInstances = new WeakSet();
/**
 * Wraps a MCP Server instance from the `@modelcontextprotocol/sdk` package with Sentry instrumentation.
 *
 * Compatible with versions `^1.9.0` of the `@modelcontextprotocol/sdk` package.
 * Automatically instruments transport methods and handler functions for comprehensive monitoring.
 *
 * @example
 * ```typescript
 * import * as Sentry from '@sentry/core';
 * import { McpServer } from '@modelcontextprotocol/sdk/server/mcp.js';
 * import { StreamableHTTPServerTransport } from '@modelcontextprotocol/sdk/server/streamableHttp.js';
 *
 * const server = Sentry.wrapMcpServerWithSentry(
 *   new McpServer({ name: "my-server", version: "1.0.0" })
 * );
 *
 * const transport = new StreamableHTTPServerTransport();
 * await server.connect(transport);
 * ```
 *
 * @param mcpServerInstance - MCP server instance to instrument
 * @returns Instrumented server instance (same reference)
 */ function wrapMcpServerWithSentry(mcpServerInstance) {
    if (wrappedMcpServerInstances.has(mcpServerInstance)) return mcpServerInstance;
    if (!(0, _validationJs.validateMcpServerInstance)(mcpServerInstance)) return mcpServerInstance;
    var serverInstance = mcpServerInstance;
    (0, _objectJs.fill)(serverInstance, 'connect', function(originalConnect) {
        return function(transport) {
            for(var _len = arguments.length, restArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                restArgs[_key - 1] = arguments[_key];
            }
            return (0, _asyncToGenerator._)(function() {
                var _originalConnect, result;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (_originalConnect = originalConnect).call.apply(_originalConnect, [
                                    this,
                                    transport
                                ].concat((0, _toConsumableArray._)(restArgs)))
                            ];
                        case 1:
                            result = _state.sent();
                            (0, _transportJs.wrapTransportOnMessage)(transport);
                            (0, _transportJs.wrapTransportSend)(transport);
                            (0, _transportJs.wrapTransportOnClose)(transport);
                            (0, _transportJs.wrapTransportError)(transport);
                            return [
                                2,
                                result
                            ];
                    }
                });
            }).call(this);
        };
    });
    (0, _handlersJs.wrapAllMCPHandlers)(serverInstance);
    wrappedMcpServerInstances.add(mcpServerInstance);
    return mcpServerInstance;
}

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_to_consumable_array":"1eSZf","@swc/helpers/_/_ts_generator":"78Tqx","../../utils/object.js":"9SKe9","./handlers.js":"9hzwh","./transport.js":"hj2VQ","./validation.js":"3MmQN","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9hzwh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "wrapAllMCPHandlers", function() {
    return wrapAllMCPHandlers;
});
parcelHelpers.export(exports, "wrapPromptHandlers", function() {
    return wrapPromptHandlers;
});
parcelHelpers.export(exports, "wrapResourceHandlers", function() {
    return wrapResourceHandlers;
});
parcelHelpers.export(exports, "wrapToolHandlers", function() {
    return wrapToolHandlers;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var _debugBuildJs = require("../../debug-build.js");
var _debugLoggerJs = require("../../utils/debug-logger.js");
var _objectJs = require("../../utils/object.js");
var _errorCaptureJs = require("./errorCapture.js");
/**
 * Handler method wrapping for MCP server instrumentation
 *
 * Provides automatic error capture and span correlation for tool, resource,
 * and prompt handlers.
 */ /**
 * Generic function to wrap MCP server method handlers
 * @internal
 * @param serverInstance - MCP server instance
 * @param methodName - Method name to wrap (tool, resource, prompt)
 */ function wrapMethodHandler(serverInstance, methodName) {
    (0, _objectJs.fill)(serverInstance, methodName, function(originalMethod) {
        return function(name) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                args[_key - 1] = arguments[_key];
            }
            var _originalMethod, _originalMethod1;
            var handler = args[args.length - 1];
            if (typeof handler !== 'function') return (_originalMethod = originalMethod).call.apply(_originalMethod, [
                this,
                name
            ].concat((0, _toConsumableArray._)(args)));
            var wrappedHandler = createWrappedHandler(handler, methodName, name);
            return (_originalMethod1 = originalMethod).call.apply(_originalMethod1, [
                this,
                name
            ].concat((0, _toConsumableArray._)(args.slice(0, -1)), [
                wrappedHandler
            ]));
        };
    });
}
/**
 * Creates a wrapped handler with span correlation and error capture
 * @internal
 * @param originalHandler - Original handler function
 * @param methodName - MCP method name
 * @param handlerName - Handler identifier
 * @returns Wrapped handler function
 */ function createWrappedHandler(originalHandler, methodName, handlerName) {
    return function() {
        for(var _len = arguments.length, handlerArgs = new Array(_len), _key = 0; _key < _len; _key++){
            handlerArgs[_key] = arguments[_key];
        }
        try {
            return createErrorCapturingHandler.call(this, originalHandler, methodName, handlerName, handlerArgs);
        } catch (error) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn('MCP handler wrapping failed:', error);
            return originalHandler.apply(this, handlerArgs);
        }
    };
}
/**
 * Creates an error-capturing wrapper for handler execution
 * @internal
 * @param originalHandler - Original handler function
 * @param methodName - MCP method name
 * @param handlerName - Handler identifier
 * @param handlerArgs - Handler arguments
 * @param extraHandlerData - Additional handler context
 * @returns Handler execution result
 */ function createErrorCapturingHandler(originalHandler, methodName, handlerName, handlerArgs) {
    try {
        var result = originalHandler.apply(this, handlerArgs);
        if (result && (typeof result === "undefined" ? "undefined" : (0, _typeOf._)(result)) === 'object' && typeof result.then === 'function') return Promise.resolve(result).catch(function(error) {
            captureHandlerError(error, methodName, handlerName);
            throw error;
        });
        return result;
    } catch (error) {
        captureHandlerError(error, methodName, handlerName);
        throw error;
    }
}
/**
 * Captures handler execution errors based on handler type
 * @internal
 * @param error - Error to capture
 * @param methodName - MCP method name
 * @param handlerName - Handler identifier
 */ function captureHandlerError(error, methodName, handlerName) {
    try {
        var extraData = {};
        if (methodName === 'tool') {
            extraData.tool_name = handlerName;
            if (error.name === 'ProtocolValidationError' || error.message.includes('validation') || error.message.includes('protocol')) (0, _errorCaptureJs.captureError)(error, 'validation', extraData);
            else if (error.name === 'ServerTimeoutError' || error.message.includes('timed out') || error.message.includes('timeout')) (0, _errorCaptureJs.captureError)(error, 'timeout', extraData);
            else (0, _errorCaptureJs.captureError)(error, 'tool_execution', extraData);
        } else if (methodName === 'resource') {
            extraData.resource_uri = handlerName;
            (0, _errorCaptureJs.captureError)(error, 'resource_execution', extraData);
        } else if (methodName === 'prompt') {
            extraData.prompt_name = handlerName;
            (0, _errorCaptureJs.captureError)(error, 'prompt_execution', extraData);
        }
    } catch (captureErr) {
    // noop
    }
}
/**
 * Wraps tool handlers to associate them with request spans
 * @param serverInstance - MCP server instance
 */ function wrapToolHandlers(serverInstance) {
    wrapMethodHandler(serverInstance, 'tool');
}
/**
 * Wraps resource handlers to associate them with request spans
 * @param serverInstance - MCP server instance
 */ function wrapResourceHandlers(serverInstance) {
    wrapMethodHandler(serverInstance, 'resource');
}
/**
 * Wraps prompt handlers to associate them with request spans
 * @param serverInstance - MCP server instance
 */ function wrapPromptHandlers(serverInstance) {
    wrapMethodHandler(serverInstance, 'prompt');
}
/**
 * Wraps all MCP handler types (tool, resource, prompt) for span correlation
 * @param serverInstance - MCP server instance
 */ function wrapAllMCPHandlers(serverInstance) {
    wrapToolHandlers(serverInstance);
    wrapResourceHandlers(serverInstance);
    wrapPromptHandlers(serverInstance);
}

},{"@swc/helpers/_/_to_consumable_array":"1eSZf","@swc/helpers/_/_type_of":"iFJdx","../../debug-build.js":"ejIQP","../../utils/debug-logger.js":"3X9Vf","../../utils/object.js":"9SKe9","./errorCapture.js":"4X1c8","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4X1c8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "captureError", function() {
    return captureError;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _currentScopesJs = require("../../currentScopes.js");
var _exportsJs = require("../../exports.js");
var _spanUtilsJs = require("../../utils/spanUtils.js");
var _spanstatusJs = require("../../tracing/spanstatus.js");
/**
 * Safe error capture utilities for MCP server instrumentation
 *
 * Ensures error reporting never interferes with MCP server operation.
 * All capture operations are wrapped in try-catch to prevent side effects.
 */ /**
 * Captures an error without affecting MCP server operation.
 *
 * The active span already contains all MCP context (method, tool, arguments, etc.)
 * @param error - Error to capture
 * @param errorType - Classification of error type for filtering
 * @param extraData - Additional context data to include
 */ function captureError(error, errorType, extraData) {
    try {
        var client = (0, _currentScopesJs.getClient)();
        if (!client) return;
        var activeSpan = (0, _spanUtilsJs.getActiveSpan)();
        if (activeSpan === null || activeSpan === void 0 ? void 0 : activeSpan.isRecording()) activeSpan.setStatus({
            code: (0, _spanstatusJs.SPAN_STATUS_ERROR),
            message: 'internal_error'
        });
        (0, _exportsJs.captureException)(error, {
            mechanism: {
                type: 'auto.ai.mcp_server',
                handled: false,
                data: (0, _objectSpread._)({
                    error_type: errorType || 'handler_execution'
                }, extraData)
            }
        });
    } catch (e) {
    // noop
    }
}

},{"@swc/helpers/_/_object_spread":"9gdrV","../../currentScopes.js":"3GE4v","../../exports.js":"1Xqap","../../utils/spanUtils.js":"fPRKj","../../tracing/spanstatus.js":"WiYVV","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hj2VQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "wrapTransportError", function() {
    return wrapTransportError;
});
parcelHelpers.export(exports, "wrapTransportOnClose", function() {
    return wrapTransportOnClose;
});
parcelHelpers.export(exports, "wrapTransportOnMessage", function() {
    return wrapTransportOnMessage;
});
parcelHelpers.export(exports, "wrapTransportSend", function() {
    return wrapTransportSend;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _currentScopesJs = require("../../currentScopes.js");
var _objectJs = require("../../utils/object.js");
var _traceJs = require("../../tracing/trace.js");
var _correlationJs = require("./correlation.js");
var _errorCaptureJs = require("./errorCapture.js");
var _sessionExtractionJs = require("./sessionExtraction.js");
var _sessionManagementJs = require("./sessionManagement.js");
var _spansJs = require("./spans.js");
var _validationJs = require("./validation.js");
/**
 * Transport layer instrumentation for MCP server
 *
 * Handles message interception and response correlation.
 * @see https://modelcontextprotocol.io/specification/2025-06-18/basic/transports
 */ /**
 * Wraps transport.onmessage to create spans for incoming messages.
 * For "initialize" requests, extracts and stores client info and protocol version
 * in the session data for the transport.
 * @param transport - MCP transport instance to wrap
 */ function wrapTransportOnMessage(transport) {
    if (transport.onmessage) (0, _objectJs.fill)(transport, 'onmessage', function(originalOnMessage) {
        return function(message, extra) {
            var _this = this;
            if ((0, _validationJs.isJsonRpcRequest)(message)) {
                if (message.method === 'initialize') try {
                    var sessionData = (0, _sessionExtractionJs.extractSessionDataFromInitializeRequest)(message);
                    (0, _sessionManagementJs.storeSessionDataForTransport)(this, sessionData);
                } catch (e) {
                // noop
                }
                var isolationScope = (0, _currentScopesJs.getIsolationScope)().clone();
                return (0, _currentScopesJs.withIsolationScope)(isolationScope, function() {
                    var spanConfig = (0, _spansJs.buildMcpServerSpanConfig)(message, _this, extra);
                    var span = (0, _traceJs.startInactiveSpan)(spanConfig);
                    (0, _correlationJs.storeSpanForRequest)(_this, message.id, span, message.method);
                    return (0, _traceJs.withActiveSpan)(span, function() {
                        return originalOnMessage.call(_this, message, extra);
                    });
                });
            }
            if ((0, _validationJs.isJsonRpcNotification)(message)) return (0, _spansJs.createMcpNotificationSpan)(message, this, extra, function() {
                return originalOnMessage.call(_this, message, extra);
            });
            return originalOnMessage.call(this, message, extra);
        };
    });
}
/**
 * Wraps transport.send to handle outgoing messages and response correlation.
 * For "initialize" responses, extracts and stores protocol version and server info
 * in the session data for the transport.
 * @param transport - MCP transport instance to wrap
 */ function wrapTransportSend(transport) {
    if (transport.send) (0, _objectJs.fill)(transport, 'send', function(originalSend) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return (0, _asyncToGenerator._)(function() {
                var _this, _originalSend, _args, message, serverData;
                return (0, _tsGenerator._)(this, function(_state) {
                    _this = this;
                    _args = (0, _slicedToArray._)(args, 1), message = _args[0];
                    if ((0, _validationJs.isJsonRpcNotification)(message)) return [
                        2,
                        (0, _spansJs.createMcpOutgoingNotificationSpan)(message, this, function() {
                            var _originalSend;
                            return (_originalSend = originalSend).call.apply(_originalSend, [
                                _this
                            ].concat((0, _toConsumableArray._)(args)));
                        })
                    ];
                    if ((0, _validationJs.isJsonRpcResponse)(message)) {
                        if (message.id !== null && message.id !== undefined) {
                            if (message.error) captureJsonRpcErrorResponse(message.error);
                            if ((0, _validationJs.isValidContentItem)(message.result)) {
                                if (message.result.protocolVersion || message.result.serverInfo) try {
                                    serverData = (0, _sessionExtractionJs.extractSessionDataFromInitializeResponse)(message.result);
                                    (0, _sessionManagementJs.updateSessionDataForTransport)(this, serverData);
                                } catch (e) {
                                // noop
                                }
                            }
                            (0, _correlationJs.completeSpanWithResults)(this, message.id, message.result);
                        }
                    }
                    return [
                        2,
                        (_originalSend = originalSend).call.apply(_originalSend, [
                            this
                        ].concat((0, _toConsumableArray._)(args)))
                    ];
                });
            }).call(this);
        };
    });
}
/**
 * Wraps transport.onclose to clean up pending spans for this transport only
 * @param transport - MCP transport instance to wrap
 */ function wrapTransportOnClose(transport) {
    if (transport.onclose) (0, _objectJs.fill)(transport, 'onclose', function(originalOnClose) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _originalOnClose;
            (0, _correlationJs.cleanupPendingSpansForTransport)(this);
            (0, _sessionManagementJs.cleanupSessionDataForTransport)(this);
            return (_originalOnClose = originalOnClose).call.apply(_originalOnClose, [
                this
            ].concat((0, _toConsumableArray._)(args)));
        };
    });
}
/**
 * Wraps transport error handlers to capture connection errors
 * @param transport - MCP transport instance to wrap
 */ function wrapTransportError(transport) {
    if (transport.onerror) (0, _objectJs.fill)(transport, 'onerror', function(originalOnError) {
        return function(error) {
            captureTransportError(error);
            return originalOnError.call(this, error);
        };
    });
}
/**
 * Captures JSON-RPC error responses for server-side errors.
 * @see https://www.jsonrpc.org/specification#error_object
 * @internal
 * @param errorResponse - JSON-RPC error response
 */ function captureJsonRpcErrorResponse(errorResponse) {
    try {
        if (errorResponse && (typeof errorResponse === "undefined" ? "undefined" : (0, _typeOf._)(errorResponse)) === 'object' && 'code' in errorResponse && 'message' in errorResponse) {
            var jsonRpcError = errorResponse;
            var isServerError = jsonRpcError.code === -32603 || jsonRpcError.code >= -32099 && jsonRpcError.code <= -32000;
            if (isServerError) {
                var error = new Error(jsonRpcError.message);
                error.name = "JsonRpcError_".concat(jsonRpcError.code);
                (0, _errorCaptureJs.captureError)(error, 'protocol');
            }
        }
    } catch (e) {
    // noop
    }
}
/**
 * Captures transport connection errors
 * @internal
 * @param error - Transport error
 */ function captureTransportError(error) {
    try {
        (0, _errorCaptureJs.captureError)(error, 'transport');
    } catch (e) {
    // noop
    }
}

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_to_consumable_array":"1eSZf","@swc/helpers/_/_type_of":"iFJdx","@swc/helpers/_/_ts_generator":"78Tqx","../../currentScopes.js":"3GE4v","../../utils/object.js":"9SKe9","../../tracing/trace.js":"eu0PU","./correlation.js":"46ZDu","./errorCapture.js":"4X1c8","./sessionExtraction.js":"6XHlI","./sessionManagement.js":"iwec8","./spans.js":"hFRAj","./validation.js":"3MmQN","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"46ZDu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cleanupPendingSpansForTransport", function() {
    return cleanupPendingSpansForTransport;
});
parcelHelpers.export(exports, "completeSpanWithResults", function() {
    return completeSpanWithResults;
});
parcelHelpers.export(exports, "storeSpanForRequest", function() {
    return storeSpanForRequest;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _currentScopesJs = require("../../currentScopes.js");
var _spanstatusJs = require("../../tracing/spanstatus.js");
var _piiFilteringJs = require("./piiFiltering.js");
var _resultExtractionJs = require("./resultExtraction.js");
/**
 * Request-span correlation system for MCP server instrumentation
 *
 * Handles mapping requestId to span data for correlation with handler execution.
 * Uses WeakMap to scope correlation maps per transport instance, preventing
 * request ID collisions between different MCP sessions.
 */ /**
 * Transport-scoped correlation system that prevents collisions between different MCP sessions
 * @internal Each transport instance gets its own correlation map, eliminating request ID conflicts
 */ var transportToSpanMap = new WeakMap();
/**
 * Gets or creates the span map for a specific transport instance
 * @internal
 * @param transport - MCP transport instance
 * @returns Span map for the transport
 */ function getOrCreateSpanMap(transport) {
    var spanMap = transportToSpanMap.get(transport);
    if (!spanMap) {
        spanMap = new Map();
        transportToSpanMap.set(transport, spanMap);
    }
    return spanMap;
}
/**
 * Stores span context for later correlation with handler execution
 * @param transport - MCP transport instance
 * @param requestId - Request identifier
 * @param span - Active span to correlate
 * @param method - MCP method name
 */ function storeSpanForRequest(transport, requestId, span, method) {
    var spanMap = getOrCreateSpanMap(transport);
    spanMap.set(requestId, {
        span: span,
        method: method,
        startTime: Date.now()
    });
}
/**
 * Completes span with tool results and cleans up correlation
 * @param transport - MCP transport instance
 * @param requestId - Request identifier
 * @param result - Tool execution result for attribute extraction
 */ function completeSpanWithResults(transport, requestId, result) {
    var spanMap = getOrCreateSpanMap(transport);
    var spanData = spanMap.get(requestId);
    if (spanData) {
        var span = spanData.span, method = spanData.method;
        if (method === 'tools/call') {
            var rawToolAttributes = (0, _resultExtractionJs.extractToolResultAttributes)(result);
            var client = (0, _currentScopesJs.getClient)();
            var sendDefaultPii = Boolean(client === null || client === void 0 ? void 0 : client.getOptions().sendDefaultPii);
            var toolAttributes = (0, _piiFilteringJs.filterMcpPiiFromSpanData)(rawToolAttributes, sendDefaultPii);
            span.setAttributes(toolAttributes);
        } else if (method === 'prompts/get') {
            var rawPromptAttributes = (0, _resultExtractionJs.extractPromptResultAttributes)(result);
            var client1 = (0, _currentScopesJs.getClient)();
            var sendDefaultPii1 = Boolean(client1 === null || client1 === void 0 ? void 0 : client1.getOptions().sendDefaultPii);
            var promptAttributes = (0, _piiFilteringJs.filterMcpPiiFromSpanData)(rawPromptAttributes, sendDefaultPii1);
            span.setAttributes(promptAttributes);
        }
        span.end();
        spanMap.delete(requestId);
    }
}
/**
 * Cleans up pending spans for a specific transport (when that transport closes)
 * @param transport - MCP transport instance
 */ function cleanupPendingSpansForTransport(transport) {
    var spanMap = transportToSpanMap.get(transport);
    if (spanMap) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = spanMap[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, _slicedToArray._)(_step.value, 2), spanData = _step_value[1];
                spanData.span.setStatus({
                    code: (0, _spanstatusJs.SPAN_STATUS_ERROR),
                    message: 'cancelled'
                });
                spanData.span.end();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        spanMap.clear();
    }
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","../../currentScopes.js":"3GE4v","../../tracing/spanstatus.js":"WiYVV","./piiFiltering.js":"eYg6E","./resultExtraction.js":"lkEkW","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eYg6E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "filterMcpPiiFromSpanData", function() {
    return filterMcpPiiFromSpanData;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _attributesJs = require("./attributes.js");
/**
 * PII attributes that should be removed when sendDefaultPii is false
 * @internal
 */ var PII_ATTRIBUTES = new Set([
    (0, _attributesJs.CLIENT_ADDRESS_ATTRIBUTE),
    (0, _attributesJs.CLIENT_PORT_ATTRIBUTE),
    (0, _attributesJs.MCP_LOGGING_MESSAGE_ATTRIBUTE),
    (0, _attributesJs.MCP_PROMPT_RESULT_DESCRIPTION_ATTRIBUTE),
    (0, _attributesJs.MCP_PROMPT_RESULT_MESSAGE_CONTENT_ATTRIBUTE),
    (0, _attributesJs.MCP_RESOURCE_URI_ATTRIBUTE),
    (0, _attributesJs.MCP_TOOL_RESULT_CONTENT_ATTRIBUTE)
]);
/**
 * Checks if an attribute key should be considered PII.
 *
 * Returns true for:
 * - Explicit PII attributes (client.address, client.port, mcp.logging.message, etc.)
 * - All request arguments (mcp.request.argument.*)
 * - Tool and prompt result content (mcp.tool.result.*, mcp.prompt.result.*) except metadata
 *
 * Preserves metadata attributes ending with _count, _error, or .is_error as they don't contain sensitive data.
 *
 * @param key - Attribute key to evaluate
 * @returns true if the attribute should be filtered out (is PII), false if it should be preserved
 * @internal
 */ function isPiiAttribute(key) {
    if (PII_ATTRIBUTES.has(key)) return true;
    if (key.startsWith("".concat((0, _attributesJs.MCP_REQUEST_ARGUMENT), "."))) return true;
    if (key.startsWith("".concat((0, _attributesJs.MCP_TOOL_RESULT_PREFIX), ".")) || key.startsWith("".concat((0, _attributesJs.MCP_PROMPT_RESULT_PREFIX), "."))) {
        if (!key.endsWith('_count') && !key.endsWith('_error') && !key.endsWith('.is_error')) return true;
    }
    return false;
}
/**
 * Removes PII attributes from span data when sendDefaultPii is false
 * @param spanData - Raw span attributes
 * @param sendDefaultPii - Whether to include PII data
 * @returns Filtered span attributes
 */ function filterMcpPiiFromSpanData(spanData, sendDefaultPii) {
    if (sendDefaultPii) return spanData;
    return Object.entries(spanData).reduce(function(acc, param) {
        var _param = (0, _slicedToArray._)(param, 2), key = _param[0], value = _param[1];
        if (!isPiiAttribute(key)) acc[key] = value;
        return acc;
    }, {});
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","./attributes.js":"gPGOm","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gPGOm":[function(require,module,exports,__globalThis) {
/**
 * Essential MCP attribute constants for Sentry instrumentation
 *
 * Based on OpenTelemetry MCP semantic conventions
 * @see https://github.com/open-telemetry/semantic-conventions/blob/3097fb0af5b9492b0e3f55dc5f6c21a3dc2be8df/docs/gen-ai/mcp.md
 */ // =============================================================================
// CORE MCP ATTRIBUTES
// =============================================================================
/** The name of the request or notification method */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CLIENT_ADDRESS_ATTRIBUTE", function() {
    return CLIENT_ADDRESS_ATTRIBUTE;
});
parcelHelpers.export(exports, "CLIENT_PORT_ATTRIBUTE", function() {
    return CLIENT_PORT_ATTRIBUTE;
});
parcelHelpers.export(exports, "MCP_FUNCTION_ORIGIN_VALUE", function() {
    return MCP_FUNCTION_ORIGIN_VALUE;
});
parcelHelpers.export(exports, "MCP_LOGGING_DATA_TYPE_ATTRIBUTE", function() {
    return MCP_LOGGING_DATA_TYPE_ATTRIBUTE;
});
parcelHelpers.export(exports, "MCP_LOGGING_LEVEL_ATTRIBUTE", function() {
    return MCP_LOGGING_LEVEL_ATTRIBUTE;
});
parcelHelpers.export(exports, "MCP_LOGGING_LOGGER_ATTRIBUTE", function() {
    return MCP_LOGGING_LOGGER_ATTRIBUTE;
});
parcelHelpers.export(exports, "MCP_LOGGING_MESSAGE_ATTRIBUTE", function() {
    return MCP_LOGGING_MESSAGE_ATTRIBUTE;
});
parcelHelpers.export(exports, "MCP_METHOD_NAME_ATTRIBUTE", function() {
    return MCP_METHOD_NAME_ATTRIBUTE;
});
parcelHelpers.export(exports, "MCP_NOTIFICATION_CLIENT_TO_SERVER_OP_VALUE", function() {
    return MCP_NOTIFICATION_CLIENT_TO_SERVER_OP_VALUE;
});
parcelHelpers.export(exports, "MCP_NOTIFICATION_ORIGIN_VALUE", function() {
    return MCP_NOTIFICATION_ORIGIN_VALUE;
});
parcelHelpers.export(exports, "MCP_NOTIFICATION_SERVER_TO_CLIENT_OP_VALUE", function() {
    return MCP_NOTIFICATION_SERVER_TO_CLIENT_OP_VALUE;
});
parcelHelpers.export(exports, "MCP_PROMPT_NAME_ATTRIBUTE", function() {
    return MCP_PROMPT_NAME_ATTRIBUTE;
});
parcelHelpers.export(exports, "MCP_PROMPT_RESULT_DESCRIPTION_ATTRIBUTE", function() {
    return MCP_PROMPT_RESULT_DESCRIPTION_ATTRIBUTE;
});
parcelHelpers.export(exports, "MCP_PROMPT_RESULT_MESSAGE_CONTENT_ATTRIBUTE", function() {
    return MCP_PROMPT_RESULT_MESSAGE_CONTENT_ATTRIBUTE;
});
parcelHelpers.export(exports, "MCP_PROMPT_RESULT_MESSAGE_COUNT_ATTRIBUTE", function() {
    return MCP_PROMPT_RESULT_MESSAGE_COUNT_ATTRIBUTE;
});
parcelHelpers.export(exports, "MCP_PROMPT_RESULT_PREFIX", function() {
    return MCP_PROMPT_RESULT_PREFIX;
});
parcelHelpers.export(exports, "MCP_PROTOCOL_VERSION_ATTRIBUTE", function() {
    return MCP_PROTOCOL_VERSION_ATTRIBUTE;
});
parcelHelpers.export(exports, "MCP_REQUEST_ARGUMENT", function() {
    return MCP_REQUEST_ARGUMENT;
});
parcelHelpers.export(exports, "MCP_REQUEST_ID_ATTRIBUTE", function() {
    return MCP_REQUEST_ID_ATTRIBUTE;
});
parcelHelpers.export(exports, "MCP_RESOURCE_URI_ATTRIBUTE", function() {
    return MCP_RESOURCE_URI_ATTRIBUTE;
});
parcelHelpers.export(exports, "MCP_ROUTE_SOURCE_VALUE", function() {
    return MCP_ROUTE_SOURCE_VALUE;
});
parcelHelpers.export(exports, "MCP_SERVER_NAME_ATTRIBUTE", function() {
    return MCP_SERVER_NAME_ATTRIBUTE;
});
parcelHelpers.export(exports, "MCP_SERVER_OP_VALUE", function() {
    return MCP_SERVER_OP_VALUE;
});
parcelHelpers.export(exports, "MCP_SERVER_TITLE_ATTRIBUTE", function() {
    return MCP_SERVER_TITLE_ATTRIBUTE;
});
parcelHelpers.export(exports, "MCP_SERVER_VERSION_ATTRIBUTE", function() {
    return MCP_SERVER_VERSION_ATTRIBUTE;
});
parcelHelpers.export(exports, "MCP_SESSION_ID_ATTRIBUTE", function() {
    return MCP_SESSION_ID_ATTRIBUTE;
});
parcelHelpers.export(exports, "MCP_TOOL_NAME_ATTRIBUTE", function() {
    return MCP_TOOL_NAME_ATTRIBUTE;
});
parcelHelpers.export(exports, "MCP_TOOL_RESULT_CONTENT_ATTRIBUTE", function() {
    return MCP_TOOL_RESULT_CONTENT_ATTRIBUTE;
});
parcelHelpers.export(exports, "MCP_TOOL_RESULT_CONTENT_COUNT_ATTRIBUTE", function() {
    return MCP_TOOL_RESULT_CONTENT_COUNT_ATTRIBUTE;
});
parcelHelpers.export(exports, "MCP_TOOL_RESULT_IS_ERROR_ATTRIBUTE", function() {
    return MCP_TOOL_RESULT_IS_ERROR_ATTRIBUTE;
});
parcelHelpers.export(exports, "MCP_TOOL_RESULT_PREFIX", function() {
    return MCP_TOOL_RESULT_PREFIX;
});
parcelHelpers.export(exports, "MCP_TRANSPORT_ATTRIBUTE", function() {
    return MCP_TRANSPORT_ATTRIBUTE;
});
parcelHelpers.export(exports, "NETWORK_PROTOCOL_VERSION_ATTRIBUTE", function() {
    return NETWORK_PROTOCOL_VERSION_ATTRIBUTE;
});
parcelHelpers.export(exports, "NETWORK_TRANSPORT_ATTRIBUTE", function() {
    return NETWORK_TRANSPORT_ATTRIBUTE;
});
var MCP_METHOD_NAME_ATTRIBUTE = 'mcp.method.name';
/** JSON-RPC request identifier for the request. Unique within the MCP session. */ var MCP_REQUEST_ID_ATTRIBUTE = 'mcp.request.id';
/** Identifies the MCP session */ var MCP_SESSION_ID_ATTRIBUTE = 'mcp.session.id';
/** Transport method used for MCP communication */ var MCP_TRANSPORT_ATTRIBUTE = 'mcp.transport';
// =============================================================================
// SERVER ATTRIBUTES
// =============================================================================
/** Name of the MCP server application */ var MCP_SERVER_NAME_ATTRIBUTE = 'mcp.server.name';
/** Display title of the MCP server application */ var MCP_SERVER_TITLE_ATTRIBUTE = 'mcp.server.title';
/** Version of the MCP server application */ var MCP_SERVER_VERSION_ATTRIBUTE = 'mcp.server.version';
/** MCP protocol version used in the session */ var MCP_PROTOCOL_VERSION_ATTRIBUTE = 'mcp.protocol.version';
// =============================================================================
// METHOD-SPECIFIC ATTRIBUTES
// =============================================================================
/** Name of the tool being called */ var MCP_TOOL_NAME_ATTRIBUTE = 'mcp.tool.name';
/** The resource URI being accessed */ var MCP_RESOURCE_URI_ATTRIBUTE = 'mcp.resource.uri';
/** Name of the prompt template */ var MCP_PROMPT_NAME_ATTRIBUTE = 'mcp.prompt.name';
// =============================================================================
// TOOL RESULT ATTRIBUTES
// =============================================================================
/** Whether a tool execution resulted in an error */ var MCP_TOOL_RESULT_IS_ERROR_ATTRIBUTE = 'mcp.tool.result.is_error';
/** Number of content items in the tool result */ var MCP_TOOL_RESULT_CONTENT_COUNT_ATTRIBUTE = 'mcp.tool.result.content_count';
/** Serialized content of the tool result */ var MCP_TOOL_RESULT_CONTENT_ATTRIBUTE = 'mcp.tool.result.content';
/** Prefix for tool result attributes that contain sensitive content */ var MCP_TOOL_RESULT_PREFIX = 'mcp.tool.result';
// =============================================================================
// PROMPT RESULT ATTRIBUTES
// =============================================================================
/** Description of the prompt result */ var MCP_PROMPT_RESULT_DESCRIPTION_ATTRIBUTE = 'mcp.prompt.result.description';
/** Number of messages in the prompt result */ var MCP_PROMPT_RESULT_MESSAGE_COUNT_ATTRIBUTE = 'mcp.prompt.result.message_count';
/** Content of the message in the prompt result (for single message results) */ var MCP_PROMPT_RESULT_MESSAGE_CONTENT_ATTRIBUTE = 'mcp.prompt.result.message_content';
/** Prefix for prompt result attributes that contain sensitive content */ var MCP_PROMPT_RESULT_PREFIX = 'mcp.prompt.result';
// =============================================================================
// REQUEST ARGUMENT ATTRIBUTES
// =============================================================================
/** Prefix for MCP request argument prefix for each argument */ var MCP_REQUEST_ARGUMENT = 'mcp.request.argument';
// =============================================================================
// LOGGING ATTRIBUTES
// =============================================================================
/** Log level for MCP logging operations */ var MCP_LOGGING_LEVEL_ATTRIBUTE = 'mcp.logging.level';
/** Logger name for MCP logging operations */ var MCP_LOGGING_LOGGER_ATTRIBUTE = 'mcp.logging.logger';
/** Data type of the logged message */ var MCP_LOGGING_DATA_TYPE_ATTRIBUTE = 'mcp.logging.data_type';
/** Log message content */ var MCP_LOGGING_MESSAGE_ATTRIBUTE = 'mcp.logging.message';
// =============================================================================
// NETWORK ATTRIBUTES (OpenTelemetry Standard)
// =============================================================================
/** OSI transport layer protocol */ var NETWORK_TRANSPORT_ATTRIBUTE = 'network.transport';
/** The version of JSON RPC protocol used */ var NETWORK_PROTOCOL_VERSION_ATTRIBUTE = 'network.protocol.version';
/** Client address - domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name */ var CLIENT_ADDRESS_ATTRIBUTE = 'client.address';
/** Client port number */ var CLIENT_PORT_ATTRIBUTE = 'client.port';
// =============================================================================
// SENTRY-SPECIFIC MCP ATTRIBUTE VALUES
// =============================================================================
/** Sentry operation value for MCP server spans */ var MCP_SERVER_OP_VALUE = 'mcp.server';
/**
 * Sentry operation value for client-to-server notifications
 * Following OpenTelemetry MCP semantic conventions
 */ var MCP_NOTIFICATION_CLIENT_TO_SERVER_OP_VALUE = 'mcp.notification.client_to_server';
/**
 * Sentry operation value for server-to-client notifications
 * Following OpenTelemetry MCP semantic conventions
 */ var MCP_NOTIFICATION_SERVER_TO_CLIENT_OP_VALUE = 'mcp.notification.server_to_client';
/** Sentry origin value for MCP function spans */ var MCP_FUNCTION_ORIGIN_VALUE = 'auto.function.mcp_server';
/** Sentry origin value for MCP notification spans */ var MCP_NOTIFICATION_ORIGIN_VALUE = 'auto.mcp.notification';
/** Sentry source value for MCP route spans */ var MCP_ROUTE_SOURCE_VALUE = 'route';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lkEkW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extractPromptResultAttributes", function() {
    return extractPromptResultAttributes;
});
parcelHelpers.export(exports, "extractToolResultAttributes", function() {
    return extractToolResultAttributes;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _attributesJs = require("./attributes.js");
var _validationJs = require("./validation.js");
/**
 * Result extraction functions for MCP server instrumentation
 *
 * Handles extraction of attributes from tool and prompt execution results.
 */ /**
 * Build attributes for tool result content items
 * @param content - Array of content items from tool result
 * @returns Attributes extracted from each content item including type, text, mime type, URI, and resource info
 */ function buildAllContentItemAttributes(content) {
    var attributes = (0, _defineProperty._)({}, (0, _attributesJs.MCP_TOOL_RESULT_CONTENT_COUNT_ATTRIBUTE), content.length);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var _step_value = (0, _slicedToArray._)(_step.value, 2), i = _step_value[0], item = _step_value[1];
            if (!(0, _validationJs.isValidContentItem)(item)) return "continue";
            var prefix = content.length === 1 ? 'mcp.tool.result' : "mcp.tool.result.".concat(i);
            var safeSet = function(key, value) {
                if (typeof value === 'string') attributes["".concat(prefix, ".").concat(key)] = value;
            };
            safeSet('content_type', item.type);
            safeSet('mime_type', item.mimeType);
            safeSet('uri', item.uri);
            safeSet('name', item.name);
            if (typeof item.text === 'string') attributes["".concat(prefix, ".content")] = item.text;
            if (typeof item.data === 'string') attributes["".concat(prefix, ".data_size")] = item.data.length;
            var resource = item.resource;
            if ((0, _validationJs.isValidContentItem)(resource)) {
                safeSet('resource_uri', resource.uri);
                safeSet('resource_mime_type', resource.mimeType);
            }
        };
        for(var _iterator = content.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return attributes;
}
/**
 * Extract tool result attributes for span instrumentation
 * @param result - Tool execution result
 * @returns Attributes extracted from tool result content
 */ function extractToolResultAttributes(result) {
    if (!(0, _validationJs.isValidContentItem)(result)) return {};
    var attributes = Array.isArray(result.content) ? buildAllContentItemAttributes(result.content) : {};
    if (typeof result.isError === 'boolean') attributes[0, _attributesJs.MCP_TOOL_RESULT_IS_ERROR_ATTRIBUTE] = result.isError;
    return attributes;
}
/**
 * Extract prompt result attributes for span instrumentation
 * @param result - Prompt execution result
 * @returns Attributes extracted from prompt result
 */ function extractPromptResultAttributes(result) {
    var attributes = {};
    if (!(0, _validationJs.isValidContentItem)(result)) return attributes;
    if (typeof result.description === 'string') attributes[0, _attributesJs.MCP_PROMPT_RESULT_DESCRIPTION_ATTRIBUTE] = result.description;
    if (Array.isArray(result.messages)) {
        attributes[0, _attributesJs.MCP_PROMPT_RESULT_MESSAGE_COUNT_ATTRIBUTE] = result.messages.length;
        var messages = result.messages;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var _step_value = (0, _slicedToArray._)(_step.value, 2), i = _step_value[0], message = _step_value[1];
                if (!(0, _validationJs.isValidContentItem)(message)) return "continue";
                var prefix = messages.length === 1 ? 'mcp.prompt.result' : "mcp.prompt.result.".concat(i);
                var safeSet = function(key, value) {
                    if (typeof value === 'string') {
                        var attrName = messages.length === 1 ? "".concat(prefix, ".message_").concat(key) : "".concat(prefix, ".").concat(key);
                        attributes[attrName] = value;
                    }
                };
                safeSet('role', message.role);
                if ((0, _validationJs.isValidContentItem)(message.content)) {
                    var content = message.content;
                    if (typeof content.text === 'string') {
                        var attrName = messages.length === 1 ? "".concat(prefix, ".message_content") : "".concat(prefix, ".content");
                        attributes[attrName] = content.text;
                    }
                }
            };
            for(var _iterator = messages.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return attributes;
}

},{"@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_sliced_to_array":"8PtL6","./attributes.js":"gPGOm","./validation.js":"3MmQN","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3MmQN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isJsonRpcNotification", function() {
    return isJsonRpcNotification;
});
parcelHelpers.export(exports, "isJsonRpcRequest", function() {
    return isJsonRpcRequest;
});
parcelHelpers.export(exports, "isJsonRpcResponse", function() {
    return isJsonRpcResponse;
});
parcelHelpers.export(exports, "isValidContentItem", function() {
    return isValidContentItem;
});
parcelHelpers.export(exports, "validateMcpServerInstance", function() {
    return validateMcpServerInstance;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _debugBuildJs = require("../../debug-build.js");
var _debugLoggerJs = require("../../utils/debug-logger.js");
/**
 * Message validation functions for MCP server instrumentation
 *
 * Provides JSON-RPC 2.0 message type validation and MCP server instance validation.
 */ /**
 * Validates if a message is a JSON-RPC request
 * @param message - Message to validate
 * @returns True if message is a JSON-RPC request
 */ function isJsonRpcRequest(message) {
    return (typeof message === "undefined" ? "undefined" : (0, _typeOf._)(message)) === 'object' && message !== null && 'jsonrpc' in message && message.jsonrpc === '2.0' && 'method' in message && 'id' in message;
}
/**
 * Validates if a message is a JSON-RPC notification
 * @param message - Message to validate
 * @returns True if message is a JSON-RPC notification
 */ function isJsonRpcNotification(message) {
    return (typeof message === "undefined" ? "undefined" : (0, _typeOf._)(message)) === 'object' && message !== null && 'jsonrpc' in message && message.jsonrpc === '2.0' && 'method' in message && !('id' in message);
}
/**
 * Validates if a message is a JSON-RPC response
 * @param message - Message to validate
 * @returns True if message is a JSON-RPC response
 */ function isJsonRpcResponse(message) {
    return (typeof message === "undefined" ? "undefined" : (0, _typeOf._)(message)) === 'object' && message !== null && 'jsonrpc' in message && message.jsonrpc === '2.0' && 'id' in message && ('result' in message || 'error' in message);
}
/**
 * Validates MCP server instance with type checking
 * @param instance - Object to validate as MCP server instance
 * @returns True if instance has required MCP server methods
 */ function validateMcpServerInstance(instance) {
    if ((typeof instance === "undefined" ? "undefined" : (0, _typeOf._)(instance)) === 'object' && instance !== null && 'resource' in instance && 'tool' in instance && 'prompt' in instance && 'connect' in instance) return true;
    (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn('Did not patch MCP server. Interface is incompatible.');
    return false;
}
/**
 * Check if the item is a valid content item
 * @param item - The item to check
 * @returns True if the item is a valid content item, false otherwise
 */ function isValidContentItem(item) {
    return item != null && (typeof item === "undefined" ? "undefined" : (0, _typeOf._)(item)) === 'object';
}

},{"@swc/helpers/_/_type_of":"iFJdx","../../debug-build.js":"ejIQP","../../utils/debug-logger.js":"3X9Vf","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6XHlI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildTransportAttributes", function() {
    return buildTransportAttributes;
});
parcelHelpers.export(exports, "extractClientInfo", function() {
    return extractClientInfo;
});
parcelHelpers.export(exports, "extractSessionDataFromInitializeRequest", function() {
    return extractSessionDataFromInitializeRequest;
});
parcelHelpers.export(exports, "extractSessionDataFromInitializeResponse", function() {
    return extractSessionDataFromInitializeResponse;
});
parcelHelpers.export(exports, "getClientAttributes", function() {
    return getClientAttributes;
});
parcelHelpers.export(exports, "getServerAttributes", function() {
    return getServerAttributes;
});
parcelHelpers.export(exports, "getTransportTypes", function() {
    return getTransportTypes;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _attributesJs = require("./attributes.js");
var _sessionManagementJs = require("./sessionManagement.js");
var _validationJs = require("./validation.js");
/**
 * Session and party info extraction functions for MCP server instrumentation
 *
 * Handles extraction of client/server info and session data from MCP messages.
 */ /**
 * Extracts and validates PartyInfo from an unknown object
 * @param obj - Unknown object that might contain party info
 * @returns Validated PartyInfo object with only string properties
 */ function extractPartyInfo(obj) {
    var partyInfo = {};
    if ((0, _validationJs.isValidContentItem)(obj)) {
        if (typeof obj.name === 'string') partyInfo.name = obj.name;
        if (typeof obj.title === 'string') partyInfo.title = obj.title;
        if (typeof obj.version === 'string') partyInfo.version = obj.version;
    }
    return partyInfo;
}
/**
 * Extracts session data from "initialize" requests
 * @param request - JSON-RPC "initialize" request containing client info and protocol version
 * @returns Session data extracted from request parameters including protocol version and client info
 */ function extractSessionDataFromInitializeRequest(request) {
    var sessionData = {};
    if ((0, _validationJs.isValidContentItem)(request.params)) {
        if (typeof request.params.protocolVersion === 'string') sessionData.protocolVersion = request.params.protocolVersion;
        if (request.params.clientInfo) sessionData.clientInfo = extractPartyInfo(request.params.clientInfo);
    }
    return sessionData;
}
/**
 * Extracts session data from "initialize" response
 * @param result - "initialize" response result containing server info and protocol version
 * @returns Partial session data extracted from response including protocol version and server info
 */ function extractSessionDataFromInitializeResponse(result) {
    var sessionData = {};
    if ((0, _validationJs.isValidContentItem)(result)) {
        if (typeof result.protocolVersion === 'string') sessionData.protocolVersion = result.protocolVersion;
        if (result.serverInfo) sessionData.serverInfo = extractPartyInfo(result.serverInfo);
    }
    return sessionData;
}
/**
 * Build client attributes from stored client info
 * @param transport - MCP transport instance
 * @returns Client attributes for span instrumentation
 */ function getClientAttributes(transport) {
    var clientInfo = (0, _sessionManagementJs.getClientInfoForTransport)(transport);
    var attributes = {};
    if (clientInfo === null || clientInfo === void 0 ? void 0 : clientInfo.name) attributes['mcp.client.name'] = clientInfo.name;
    if (clientInfo === null || clientInfo === void 0 ? void 0 : clientInfo.title) attributes['mcp.client.title'] = clientInfo.title;
    if (clientInfo === null || clientInfo === void 0 ? void 0 : clientInfo.version) attributes['mcp.client.version'] = clientInfo.version;
    return attributes;
}
/**
 * Build server attributes from stored server info
 * @param transport - MCP transport instance
 * @returns Server attributes for span instrumentation
 */ function getServerAttributes(transport) {
    var _getSessionDataForTransport;
    var serverInfo = (_getSessionDataForTransport = (0, _sessionManagementJs.getSessionDataForTransport)(transport)) === null || _getSessionDataForTransport === void 0 ? void 0 : _getSessionDataForTransport.serverInfo;
    var attributes = {};
    if (serverInfo === null || serverInfo === void 0 ? void 0 : serverInfo.name) attributes[0, _attributesJs.MCP_SERVER_NAME_ATTRIBUTE] = serverInfo.name;
    if (serverInfo === null || serverInfo === void 0 ? void 0 : serverInfo.title) attributes[0, _attributesJs.MCP_SERVER_TITLE_ATTRIBUTE] = serverInfo.title;
    if (serverInfo === null || serverInfo === void 0 ? void 0 : serverInfo.version) attributes[0, _attributesJs.MCP_SERVER_VERSION_ATTRIBUTE] = serverInfo.version;
    return attributes;
}
/**
 * Extracts client connection info from extra handler data
 * @param extra - Extra handler data containing connection info
 * @returns Client address and port information
 */ function extractClientInfo(extra) {
    var _extra_requestInfo, _extra_request, _extra_request_connection, _extra_request1, _extra_requestInfo1, _extra_request_connection1, _extra_request2;
    return {
        address: (extra === null || extra === void 0 ? void 0 : (_extra_requestInfo = extra.requestInfo) === null || _extra_requestInfo === void 0 ? void 0 : _extra_requestInfo.remoteAddress) || (extra === null || extra === void 0 ? void 0 : extra.clientAddress) || (extra === null || extra === void 0 ? void 0 : (_extra_request = extra.request) === null || _extra_request === void 0 ? void 0 : _extra_request.ip) || (extra === null || extra === void 0 ? void 0 : (_extra_request1 = extra.request) === null || _extra_request1 === void 0 ? void 0 : (_extra_request_connection = _extra_request1.connection) === null || _extra_request_connection === void 0 ? void 0 : _extra_request_connection.remoteAddress),
        port: (extra === null || extra === void 0 ? void 0 : (_extra_requestInfo1 = extra.requestInfo) === null || _extra_requestInfo1 === void 0 ? void 0 : _extra_requestInfo1.remotePort) || (extra === null || extra === void 0 ? void 0 : extra.clientPort) || (extra === null || extra === void 0 ? void 0 : (_extra_request2 = extra.request) === null || _extra_request2 === void 0 ? void 0 : (_extra_request_connection1 = _extra_request2.connection) === null || _extra_request_connection1 === void 0 ? void 0 : _extra_request_connection1.remotePort)
    };
}
/**
 * Extracts transport types based on transport constructor name
 * @param transport - MCP transport instance
 * @returns Transport type mapping for span attributes
 */ function getTransportTypes(transport) {
    var _transport_constructor;
    if (!(transport === null || transport === void 0 ? void 0 : transport.constructor)) return {
        mcpTransport: 'unknown',
        networkTransport: 'unknown'
    };
    var transportName = typeof ((_transport_constructor = transport.constructor) === null || _transport_constructor === void 0 ? void 0 : _transport_constructor.name) === 'string' ? transport.constructor.name : 'unknown';
    var networkTransport = 'unknown';
    var lowerTransportName = transportName.toLowerCase();
    if (lowerTransportName.includes('stdio')) networkTransport = 'pipe';
    else if (lowerTransportName.includes('http') || lowerTransportName.includes('sse')) networkTransport = 'tcp';
    return {
        mcpTransport: transportName,
        networkTransport: networkTransport
    };
}
/**
 * Build transport and network attributes
 * @param transport - MCP transport instance
 * @param extra - Optional extra handler data
 * @returns Transport attributes for span instrumentation
 * @note sessionId may be undefined during initial setup - session should be established by client during initialize flow
 */ function buildTransportAttributes(transport, extra) {
    var sessionId = transport && 'sessionId' in transport ? transport.sessionId : undefined;
    var clientInfo = extra ? extractClientInfo(extra) : {};
    var _getTransportTypes = getTransportTypes(transport), mcpTransport = _getTransportTypes.mcpTransport, networkTransport = _getTransportTypes.networkTransport;
    var clientAttributes = getClientAttributes(transport);
    var serverAttributes = getServerAttributes(transport);
    var protocolVersion = (0, _sessionManagementJs.getProtocolVersionForTransport)(transport);
    var _obj;
    var attributes = (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, sessionId && (0, _defineProperty._)({}, (0, _attributesJs.MCP_SESSION_ID_ATTRIBUTE), sessionId), clientInfo.address && (0, _defineProperty._)({}, (0, _attributesJs.CLIENT_ADDRESS_ATTRIBUTE), clientInfo.address), clientInfo.port && (0, _defineProperty._)({}, (0, _attributesJs.CLIENT_PORT_ATTRIBUTE), clientInfo.port)), (_obj = {}, (0, _defineProperty._)(_obj, (0, _attributesJs.MCP_TRANSPORT_ATTRIBUTE), mcpTransport), (0, _defineProperty._)(_obj, (0, _attributesJs.NETWORK_TRANSPORT_ATTRIBUTE), networkTransport), (0, _defineProperty._)(_obj, (0, _attributesJs.NETWORK_PROTOCOL_VERSION_ATTRIBUTE), '2.0'), _obj)), protocolVersion && (0, _defineProperty._)({}, (0, _attributesJs.MCP_PROTOCOL_VERSION_ATTRIBUTE), protocolVersion), clientAttributes, serverAttributes);
    return attributes;
}

},{"@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","./attributes.js":"gPGOm","./sessionManagement.js":"iwec8","./validation.js":"3MmQN","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iwec8":[function(require,module,exports,__globalThis) {
/**
 * Transport-scoped session data storage (only for transports with sessionId)
 * @internal Maps transport instances to session-level data
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cleanupSessionDataForTransport", function() {
    return cleanupSessionDataForTransport;
});
parcelHelpers.export(exports, "getClientInfoForTransport", function() {
    return getClientInfoForTransport;
});
parcelHelpers.export(exports, "getProtocolVersionForTransport", function() {
    return getProtocolVersionForTransport;
});
parcelHelpers.export(exports, "getSessionDataForTransport", function() {
    return getSessionDataForTransport;
});
parcelHelpers.export(exports, "storeSessionDataForTransport", function() {
    return storeSessionDataForTransport;
});
parcelHelpers.export(exports, "updateSessionDataForTransport", function() {
    return updateSessionDataForTransport;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var transportToSessionData = new WeakMap();
/**
 * Stores session data for a transport with sessionId
 * @param transport - MCP transport instance
 * @param sessionData - Session data to store
 */ function storeSessionDataForTransport(transport, sessionData) {
    if (transport.sessionId) transportToSessionData.set(transport, sessionData);
}
/**
 * Updates session data for a transport with sessionId (merges with existing data)
 * @param transport - MCP transport instance
 * @param partialSessionData - Partial session data to merge with existing data
 */ function updateSessionDataForTransport(transport, partialSessionData) {
    if (transport.sessionId) {
        var existingData = transportToSessionData.get(transport) || {};
        transportToSessionData.set(transport, (0, _objectSpread._)({}, existingData, partialSessionData));
    }
}
/**
 * Retrieves client information for a transport
 * @param transport - MCP transport instance
 * @returns Client information if available
 */ function getClientInfoForTransport(transport) {
    var _transportToSessionData_get;
    return (_transportToSessionData_get = transportToSessionData.get(transport)) === null || _transportToSessionData_get === void 0 ? void 0 : _transportToSessionData_get.clientInfo;
}
/**
 * Retrieves protocol version for a transport
 * @param transport - MCP transport instance
 * @returns Protocol version if available
 */ function getProtocolVersionForTransport(transport) {
    var _transportToSessionData_get;
    return (_transportToSessionData_get = transportToSessionData.get(transport)) === null || _transportToSessionData_get === void 0 ? void 0 : _transportToSessionData_get.protocolVersion;
}
/**
 * Retrieves full session data for a transport
 * @param transport - MCP transport instance
 * @returns Complete session data if available
 */ function getSessionDataForTransport(transport) {
    return transportToSessionData.get(transport);
}
/**
 * Cleans up session data for a specific transport (when that transport closes)
 * @param transport - MCP transport instance
 */ function cleanupSessionDataForTransport(transport) {
    transportToSessionData.delete(transport);
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hFRAj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildMcpServerSpanConfig", function() {
    return buildMcpServerSpanConfig;
});
parcelHelpers.export(exports, "createMcpNotificationSpan", function() {
    return createMcpNotificationSpan;
});
parcelHelpers.export(exports, "createMcpOutgoingNotificationSpan", function() {
    return createMcpOutgoingNotificationSpan;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _currentScopesJs = require("../../currentScopes.js");
var _semanticAttributesJs = require("../../semanticAttributes.js");
var _traceJs = require("../../tracing/trace.js");
var _attributeExtractionJs = require("./attributeExtraction.js");
var _attributesJs = require("./attributes.js");
var _methodConfigJs = require("./methodConfig.js");
var _piiFilteringJs = require("./piiFiltering.js");
var _sessionExtractionJs = require("./sessionExtraction.js");
/**
 * Span creation and management functions for MCP server instrumentation
 *
 * Provides unified span creation following OpenTelemetry MCP semantic conventions and our opinitionated take on MCP.
 * Handles both request and notification spans with attribute extraction.
 */ /**
 * Creates a span name based on the method and target
 * @internal
 * @param method - MCP method name
 * @param target - Optional target identifier
 * @returns Formatted span name
 */ function createSpanName(method, target) {
    return target ? "".concat(method, " ").concat(target) : method;
}
/**
 * Build Sentry-specific attributes based on span type
 * @internal
 * @param type - Span type configuration
 * @returns Sentry-specific attributes
 */ function buildSentryAttributes(type) {
    var op;
    var origin;
    switch(type){
        case 'request':
            op = (0, _attributesJs.MCP_SERVER_OP_VALUE);
            origin = (0, _attributesJs.MCP_FUNCTION_ORIGIN_VALUE);
            break;
        case 'notification-incoming':
            op = (0, _attributesJs.MCP_NOTIFICATION_CLIENT_TO_SERVER_OP_VALUE);
            origin = (0, _attributesJs.MCP_NOTIFICATION_ORIGIN_VALUE);
            break;
        case 'notification-outgoing':
            op = (0, _attributesJs.MCP_NOTIFICATION_SERVER_TO_CLIENT_OP_VALUE);
            origin = (0, _attributesJs.MCP_NOTIFICATION_ORIGIN_VALUE);
            break;
    }
    var _obj;
    return _obj = {}, (0, _defineProperty._)(_obj, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP), op), (0, _defineProperty._)(_obj, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), origin), (0, _defineProperty._)(_obj, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), (0, _attributesJs.MCP_ROUTE_SOURCE_VALUE)), _obj;
}
/**
 * Unified builder for creating MCP spans
 * @internal
 * @param config - Span configuration
 * @returns Created span
 */ function createMcpSpan(config) {
    var type = config.type, message = config.message, transport = config.transport, extra = config.extra, callback = config.callback;
    var method = message.method;
    var params = message.params;
    // Determine span name based on type and OTEL conventions
    var spanName;
    if (type === 'request') {
        var targetInfo = (0, _methodConfigJs.extractTargetInfo)(method, params || {});
        spanName = createSpanName(method, targetInfo.target);
    } else // For notifications, use method name directly per OpenTelemetry conventions
    spanName = method;
    var rawAttributes = (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _sessionExtractionJs.buildTransportAttributes)(transport, extra)), (0, _defineProperty._)({}, (0, _attributesJs.MCP_METHOD_NAME_ATTRIBUTE), method)), (0, _attributeExtractionJs.buildTypeSpecificAttributes)(type, message, params), buildSentryAttributes(type));
    var client = (0, _currentScopesJs.getClient)();
    var sendDefaultPii = Boolean(client === null || client === void 0 ? void 0 : client.getOptions().sendDefaultPii);
    var attributes = (0, _piiFilteringJs.filterMcpPiiFromSpanData)(rawAttributes, sendDefaultPii);
    return (0, _traceJs.startSpan)({
        name: spanName,
        forceTransaction: true,
        attributes: attributes
    }, callback);
}
/**
 * Creates a span for incoming MCP notifications
 * @param jsonRpcMessage - Notification message
 * @param transport - MCP transport instance
 * @param extra - Extra handler data
 * @param callback - Span execution callback
 * @returns Span execution result
 */ function createMcpNotificationSpan(jsonRpcMessage, transport, extra, callback) {
    return createMcpSpan({
        type: 'notification-incoming',
        message: jsonRpcMessage,
        transport: transport,
        extra: extra,
        callback: callback
    });
}
/**
 * Creates a span for outgoing MCP notifications
 * @param jsonRpcMessage - Notification message
 * @param transport - MCP transport instance
 * @param callback - Span execution callback
 * @returns Span execution result
 */ function createMcpOutgoingNotificationSpan(jsonRpcMessage, transport, callback) {
    return createMcpSpan({
        type: 'notification-outgoing',
        message: jsonRpcMessage,
        transport: transport,
        callback: callback
    });
}
/**
 * Builds span configuration for MCP server requests
 * @param jsonRpcMessage - Request message
 * @param transport - MCP transport instance
 * @param extra - Optional extra handler data
 * @returns Span configuration object
 */ function buildMcpServerSpanConfig(jsonRpcMessage, transport, extra) {
    var method = jsonRpcMessage.method;
    var params = jsonRpcMessage.params;
    var targetInfo = (0, _methodConfigJs.extractTargetInfo)(method, params || {});
    var spanName = createSpanName(method, targetInfo.target);
    var rawAttributes = (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _sessionExtractionJs.buildTransportAttributes)(transport, extra)), (0, _defineProperty._)({}, (0, _attributesJs.MCP_METHOD_NAME_ATTRIBUTE), method)), (0, _attributeExtractionJs.buildTypeSpecificAttributes)('request', jsonRpcMessage, params), buildSentryAttributes('request'));
    var client = (0, _currentScopesJs.getClient)();
    var sendDefaultPii = Boolean(client === null || client === void 0 ? void 0 : client.getOptions().sendDefaultPii);
    var attributes = (0, _piiFilteringJs.filterMcpPiiFromSpanData)(rawAttributes, sendDefaultPii);
    return {
        name: spanName,
        op: (0, _attributesJs.MCP_SERVER_OP_VALUE),
        forceTransaction: true,
        attributes: attributes
    };
}

},{"@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","../../currentScopes.js":"3GE4v","../../semanticAttributes.js":"7WRPE","../../tracing/trace.js":"eu0PU","./attributeExtraction.js":"aNquS","./attributes.js":"gPGOm","./methodConfig.js":"gU60r","./piiFiltering.js":"eYg6E","./sessionExtraction.js":"6XHlI","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aNquS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildTypeSpecificAttributes", function() {
    return buildTypeSpecificAttributes;
});
parcelHelpers.export(exports, "getNotificationAttributes", function() {
    return getNotificationAttributes;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _typeOf = require("@swc/helpers/_/_type_of");
var _urlJs = require("../../utils/url.js");
var _attributesJs = require("./attributes.js");
var _methodConfigJs = require("./methodConfig.js");
/**
 * Core attribute extraction and building functions for MCP server instrumentation
 */ /**
 * Extracts additional attributes for specific notification types
 * @param method - Notification method name
 * @param params - Notification parameters
 * @returns Method-specific attributes for span instrumentation
 */ function getNotificationAttributes(method, params) {
    var attributes = {};
    switch(method){
        case 'notifications/cancelled':
            if (params === null || params === void 0 ? void 0 : params.requestId) attributes['mcp.cancelled.request_id'] = String(params.requestId);
            if (params === null || params === void 0 ? void 0 : params.reason) attributes['mcp.cancelled.reason'] = String(params.reason);
            break;
        case 'notifications/message':
            if (params === null || params === void 0 ? void 0 : params.level) attributes[0, _attributesJs.MCP_LOGGING_LEVEL_ATTRIBUTE] = String(params.level);
            if (params === null || params === void 0 ? void 0 : params.logger) attributes[0, _attributesJs.MCP_LOGGING_LOGGER_ATTRIBUTE] = String(params.logger);
            if ((params === null || params === void 0 ? void 0 : params.data) !== undefined) {
                attributes[0, _attributesJs.MCP_LOGGING_DATA_TYPE_ATTRIBUTE] = (0, _typeOf._)(params.data);
                if (typeof params.data === 'string') attributes[0, _attributesJs.MCP_LOGGING_MESSAGE_ATTRIBUTE] = params.data;
                else attributes[0, _attributesJs.MCP_LOGGING_MESSAGE_ATTRIBUTE] = JSON.stringify(params.data);
            }
            break;
        case 'notifications/progress':
            if (params === null || params === void 0 ? void 0 : params.progressToken) attributes['mcp.progress.token'] = String(params.progressToken);
            if (typeof (params === null || params === void 0 ? void 0 : params.progress) === 'number') attributes['mcp.progress.current'] = params.progress;
            if (typeof (params === null || params === void 0 ? void 0 : params.total) === 'number') {
                attributes['mcp.progress.total'] = params.total;
                if (typeof (params === null || params === void 0 ? void 0 : params.progress) === 'number') attributes['mcp.progress.percentage'] = params.progress / params.total * 100;
            }
            if (params === null || params === void 0 ? void 0 : params.message) attributes['mcp.progress.message'] = String(params.message);
            break;
        case 'notifications/resources/updated':
            if (params === null || params === void 0 ? void 0 : params.uri) {
                attributes[0, _attributesJs.MCP_RESOURCE_URI_ATTRIBUTE] = String(params.uri);
                var urlObject = (0, _urlJs.parseStringToURLObject)(String(params.uri));
                if (urlObject && !(0, _urlJs.isURLObjectRelative)(urlObject)) attributes['mcp.resource.protocol'] = urlObject.protocol.replace(':', '');
            }
            break;
        case 'notifications/initialized':
            attributes['mcp.lifecycle.phase'] = 'initialization_complete';
            attributes['mcp.protocol.ready'] = 1;
            break;
    }
    return attributes;
}
/**
 * Build type-specific attributes based on message type
 * @param type - Span type (request or notification)
 * @param message - JSON-RPC message
 * @param params - Optional parameters for attribute extraction
 * @returns Type-specific attributes for span instrumentation
 */ function buildTypeSpecificAttributes(type, message, params) {
    if (type === 'request') {
        var request = message;
        var targetInfo = (0, _methodConfigJs.extractTargetInfo)(request.method, params || {});
        return (0, _objectSpread._)({}, request.id !== undefined && (0, _defineProperty._)({}, (0, _attributesJs.MCP_REQUEST_ID_ATTRIBUTE), String(request.id)), targetInfo.attributes, (0, _methodConfigJs.getRequestArguments)(request.method, params || {}));
    }
    return getNotificationAttributes(message.method, params || {});
}

},{"@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_type_of":"iFJdx","../../utils/url.js":"5Wd7K","./attributes.js":"gPGOm","./methodConfig.js":"gU60r","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gU60r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extractTargetInfo", function() {
    return extractTargetInfo;
});
parcelHelpers.export(exports, "getRequestArguments", function() {
    return getRequestArguments;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var _attributesJs = require("./attributes.js");
/**
 * Method configuration and request processing for MCP server instrumentation
 */ /**
 * Configuration for MCP methods to extract targets and arguments
 * @internal Maps method names to their extraction configuration
 */ var METHOD_CONFIGS = {
    'tools/call': {
        targetField: 'name',
        targetAttribute: (0, _attributesJs.MCP_TOOL_NAME_ATTRIBUTE),
        captureArguments: true,
        argumentsField: 'arguments'
    },
    'resources/read': {
        targetField: 'uri',
        targetAttribute: (0, _attributesJs.MCP_RESOURCE_URI_ATTRIBUTE),
        captureUri: true
    },
    'resources/subscribe': {
        targetField: 'uri',
        targetAttribute: (0, _attributesJs.MCP_RESOURCE_URI_ATTRIBUTE)
    },
    'resources/unsubscribe': {
        targetField: 'uri',
        targetAttribute: (0, _attributesJs.MCP_RESOURCE_URI_ATTRIBUTE)
    },
    'prompts/get': {
        targetField: 'name',
        targetAttribute: (0, _attributesJs.MCP_PROMPT_NAME_ATTRIBUTE),
        captureName: true,
        captureArguments: true,
        argumentsField: 'arguments'
    }
};
/**
 * Extracts target info from method and params based on method type
 * @param method - MCP method name
 * @param params - Method parameters
 * @returns Target name and attributes for span instrumentation
 */ function extractTargetInfo(method, params) {
    var config = METHOD_CONFIGS[method];
    if (!config) return {
        attributes: {}
    };
    var target = config.targetField && typeof (params === null || params === void 0 ? void 0 : params[config.targetField]) === 'string' ? params[config.targetField] : undefined;
    return {
        target: target,
        attributes: target && config.targetAttribute ? (0, _defineProperty._)({}, config.targetAttribute, target) : {}
    };
}
/**
 * Extracts request arguments based on method type
 * @param method - MCP method name
 * @param params - Method parameters
 * @returns Arguments as span attributes with mcp.request.argument prefix
 */ function getRequestArguments(method, params) {
    var args = {};
    var config = METHOD_CONFIGS[method];
    if (!config) return args;
    if (config.captureArguments && config.argumentsField && (params === null || params === void 0 ? void 0 : params[config.argumentsField])) {
        var argumentsObj = params[config.argumentsField];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if ((typeof argumentsObj === "undefined" ? "undefined" : (0, _typeOf._)(argumentsObj)) === 'object' && argumentsObj !== null) try {
            for(var _iterator = Object.entries(argumentsObj)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, _slicedToArray._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                args["".concat((0, _attributesJs.MCP_REQUEST_ARGUMENT), ".").concat(key.toLowerCase())] = JSON.stringify(value);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    if (config.captureUri && (params === null || params === void 0 ? void 0 : params.uri)) args["".concat((0, _attributesJs.MCP_REQUEST_ARGUMENT), ".uri")] = JSON.stringify(params.uri);
    if (config.captureName && (params === null || params === void 0 ? void 0 : params.name)) args["".concat((0, _attributesJs.MCP_REQUEST_ARGUMENT), ".name")] = JSON.stringify(params.name);
    return args;
}

},{"@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_type_of":"iFJdx","./attributes.js":"gPGOm","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lIJvr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "captureFeedback", function() {
    return captureFeedback;
});
var _currentScopesJs = require("./currentScopes.js");
/**
 * Send user feedback to Sentry.
 */ function captureFeedback(params) {
    var hint = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, scope = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, _currentScopesJs.getCurrentScope)();
    var message = params.message, name = params.name, email = params.email, url = params.url, source = params.source, associatedEventId = params.associatedEventId, tags = params.tags;
    var feedbackEvent = {
        contexts: {
            feedback: {
                contact_email: email,
                name: name,
                message: message,
                url: url,
                source: source,
                associated_event_id: associatedEventId
            }
        },
        type: 'feedback',
        level: 'info',
        tags: tags
    };
    var client = (scope === null || scope === void 0 ? void 0 : scope.getClient()) || (0, _currentScopesJs.getClient)();
    if (client) client.emit('beforeSendFeedback', feedbackEvent, hint);
    var eventId = scope.captureEvent(feedbackEvent, hint);
    return eventId;
}

},{"./currentScopes.js":"3GE4v","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"k7EX4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fmt", function() {
    return 0, _parameterizeJs.fmt;
});
parcelHelpers.export(exports, "debug", function() {
    return debug;
});
parcelHelpers.export(exports, "error", function() {
    return error;
});
parcelHelpers.export(exports, "fatal", function() {
    return fatal;
});
parcelHelpers.export(exports, "info", function() {
    return info;
});
parcelHelpers.export(exports, "trace", function() {
    return trace;
});
parcelHelpers.export(exports, "warn", function() {
    return warn;
});
var _internalJs = require("./internal.js");
var _parameterizeJs = require("../utils/parameterize.js");
/**
 * Capture a log with the given level.
 *
 * @param level - The level of the log.
 * @param message - The message to log.
 * @param attributes - Arbitrary structured data that stores information about the log - e.g., userId: 100.
 * @param scope - The scope to capture the log with.
 * @param severityNumber - The severity number of the log.
 */ function captureLog(level, message, attributes, scope, severityNumber) {
    (0, _internalJs._INTERNAL_captureLog)({
        level: level,
        message: message,
        attributes: attributes,
        severityNumber: severityNumber
    }, scope);
}
/**
 * Additional metadata to capture the log with.
 */ /**
 * @summary Capture a log with the `trace` level. Requires the `enableLogs` option to be enabled.
 *
 * @param message - The message to log.
 * @param attributes - Arbitrary structured data that stores information about the log - e.g., { userId: 100, route: '/dashboard' }.
 * @param metadata - additional metadata to capture the log with.
 *
 * @example
 *
 * ```
 * Sentry.logger.trace('User clicked submit button', {
 *   buttonId: 'submit-form',
 *   formId: 'user-profile',
 *   timestamp: Date.now()
 * });
 * ```
 *
 * @example With template strings
 *
 * ```
 * Sentry.logger.trace(Sentry.logger.fmt`User ${user} navigated to ${page}`, {
 *   userId: '123',
 *   sessionId: 'abc-xyz'
 * });
 * ```
 */ function trace(message, attributes) {
    var scope = (arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}).scope;
    captureLog('trace', message, attributes, scope);
}
/**
 * @summary Capture a log with the `debug` level. Requires the `enableLogs` option to be enabled.
 *
 * @param message - The message to log.
 * @param attributes - Arbitrary structured data that stores information about the log - e.g., { component: 'Header', state: 'loading' }.
 * @param metadata - additional metadata to capture the log with.
 *
 * @example
 *
 * ```
 * Sentry.logger.debug('Component mounted', {
 *   component: 'UserProfile',
 *   props: { userId: 123 },
 *   renderTime: 150
 * });
 * ```
 *
 * @example With template strings
 *
 * ```
 * Sentry.logger.debug(Sentry.logger.fmt`API request to ${endpoint} failed`, {
 *   statusCode: 404,
 *   requestId: 'req-123',
 *   duration: 250
 * });
 * ```
 */ function debug(message, attributes) {
    var scope = (arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}).scope;
    captureLog('debug', message, attributes, scope);
}
/**
 * @summary Capture a log with the `info` level. Requires the `enableLogs` option to be enabled.
 *
 * @param message - The message to log.
 * @param attributes - Arbitrary structured data that stores information about the log - e.g., { feature: 'checkout', status: 'completed' }.
 * @param metadata - additional metadata to capture the log with.
 *
 * @example
 *
 * ```
 * Sentry.logger.info('User completed checkout', {
 *   orderId: 'order-123',
 *   amount: 99.99,
 *   paymentMethod: 'credit_card'
 * });
 * ```
 *
 * @example With template strings
 *
 * ```
 * Sentry.logger.info(Sentry.logger.fmt`User ${user} updated profile picture`, {
 *   userId: 'user-123',
 *   imageSize: '2.5MB',
 *   timestamp: Date.now()
 * });
 * ```
 */ function info(message, attributes) {
    var scope = (arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}).scope;
    captureLog('info', message, attributes, scope);
}
/**
 * @summary Capture a log with the `warn` level. Requires the `enableLogs` option to be enabled.
 *
 * @param message - The message to log.
 * @param attributes - Arbitrary structured data that stores information about the log - e.g., { browser: 'Chrome', version: '91.0' }.
 * @param metadata - additional metadata to capture the log with.
 *
 * @example
 *
 * ```
 * Sentry.logger.warn('Browser compatibility issue detected', {
 *   browser: 'Safari',
 *   version: '14.0',
 *   feature: 'WebRTC',
 *   fallback: 'enabled'
 * });
 * ```
 *
 * @example With template strings
 *
 * ```
 * Sentry.logger.warn(Sentry.logger.fmt`API endpoint ${endpoint} is deprecated`, {
 *   recommendedEndpoint: '/api/v2/users',
 *   sunsetDate: '2024-12-31',
 *   clientVersion: '1.2.3'
 * });
 * ```
 */ function warn(message, attributes) {
    var scope = (arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}).scope;
    captureLog('warn', message, attributes, scope);
}
/**
 * @summary Capture a log with the `error` level. Requires the `enableLogs` option to be enabled.
 *
 * @param message - The message to log.
 * @param attributes - Arbitrary structured data that stores information about the log - e.g., { error: 'NetworkError', url: '/api/data' }.
 * @param metadata - additional metadata to capture the log with.
 *
 * @example
 *
 * ```
 * Sentry.logger.error('Failed to load user data', {
 *   error: 'NetworkError',
 *   url: '/api/users/123',
 *   statusCode: 500,
 *   retryCount: 3
 * });
 * ```
 *
 * @example With template strings
 *
 * ```
 * Sentry.logger.error(Sentry.logger.fmt`Payment processing failed for order ${orderId}`, {
 *   error: 'InsufficientFunds',
 *   amount: 100.00,
 *   currency: 'USD',
 *   userId: 'user-456'
 * });
 * ```
 */ function error(message, attributes) {
    var scope = (arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}).scope;
    captureLog('error', message, attributes, scope);
}
/**
 * @summary Capture a log with the `fatal` level. Requires the `enableLogs` option to be enabled.
 *
 * @param message - The message to log.
 * @param attributes - Arbitrary structured data that stores information about the log - e.g., { appState: 'corrupted', sessionId: 'abc-123' }.
 * @param metadata - additional metadata to capture the log with.
 *
 * @example
 *
 * ```
 * Sentry.logger.fatal('Application state corrupted', {
 *   lastKnownState: 'authenticated',
 *   sessionId: 'session-123',
 *   timestamp: Date.now(),
 *   recoveryAttempted: true
 * });
 * ```
 *
 * @example With template strings
 *
 * ```
 * Sentry.logger.fatal(Sentry.logger.fmt`Critical system failure in ${service}`, {
 *   service: 'payment-processor',
 *   errorCode: 'CRITICAL_FAILURE',
 *   affectedUsers: 150,
 *   timestamp: Date.now()
 * });
 * ```
 */ function fatal(message, attributes) {
    var scope = (arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}).scope;
    captureLog('fatal', message, attributes, scope);
}

},{"./internal.js":"3IZl8","../utils/parameterize.js":"2z7TO","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6dcOp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "consoleLoggingIntegration", function() {
    return consoleLoggingIntegration;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _currentScopesJs = require("../currentScopes.js");
var _debugBuildJs = require("../debug-build.js");
var _consoleJs = require("../instrument/console.js");
var _integrationJs = require("../integration.js");
var _semanticAttributesJs = require("../semanticAttributes.js");
var _debugLoggerJs = require("../utils/debug-logger.js");
var _internalJs = require("./internal.js");
var _utilsJs = require("./utils.js");
var INTEGRATION_NAME = 'ConsoleLogs';
var DEFAULT_ATTRIBUTES = (0, _defineProperty._)({}, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), 'auto.log.console');
var _consoleLoggingIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var levels = options.levels || (0, _debugLoggerJs.CONSOLE_LEVELS);
    return {
        name: INTEGRATION_NAME,
        setup: function setup(client) {
            var _client_getOptions = client.getOptions(), enableLogs = _client_getOptions.enableLogs, _client_getOptions_normalizeDepth = _client_getOptions.normalizeDepth, normalizeDepth = _client_getOptions_normalizeDepth === void 0 ? 3 : _client_getOptions_normalizeDepth, _client_getOptions_normalizeMaxBreadth = _client_getOptions.normalizeMaxBreadth, normalizeMaxBreadth = _client_getOptions_normalizeMaxBreadth === void 0 ? 1000 : _client_getOptions_normalizeMaxBreadth;
            if (!enableLogs) {
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn('`enableLogs` is not enabled, ConsoleLogs integration disabled');
                return;
            }
            (0, _consoleJs.addConsoleInstrumentationHandler)(function(param) {
                var args = param.args, level = param.level;
                if ((0, _currentScopesJs.getClient)() !== client || !levels.includes(level)) return;
                var firstArg = args[0];
                var followingArgs = args.slice(1);
                if (level === 'assert') {
                    if (!firstArg) {
                        var assertionMessage = followingArgs.length > 0 ? "Assertion failed: ".concat((0, _utilsJs.formatConsoleArgs)(followingArgs, normalizeDepth, normalizeMaxBreadth)) : 'Assertion failed';
                        (0, _internalJs._INTERNAL_captureLog)({
                            level: 'error',
                            message: assertionMessage,
                            attributes: DEFAULT_ATTRIBUTES
                        });
                    }
                    return;
                }
                var isLevelLog = level === 'log';
                var shouldGenerateTemplate = args.length > 1 && typeof args[0] === 'string' && !(0, _utilsJs.hasConsoleSubstitutions)(args[0]);
                var attributes = (0, _objectSpread._)({}, DEFAULT_ATTRIBUTES, shouldGenerateTemplate ? (0, _utilsJs.createConsoleTemplateAttributes)(firstArg, followingArgs) : {});
                (0, _internalJs._INTERNAL_captureLog)({
                    level: isLevelLog ? 'info' : level,
                    message: (0, _utilsJs.formatConsoleArgs)(args, normalizeDepth, normalizeMaxBreadth),
                    severityNumber: isLevelLog ? 10 : undefined,
                    attributes: attributes
                });
            });
        }
    };
};
/**
 * Captures calls to the `console` API as logs in Sentry. Requires the `enableLogs` option to be enabled.
 *
 * @experimental This feature is experimental and may be changed or removed in future versions.
 *
 * By default the integration instruments `console.debug`, `console.info`, `console.warn`, `console.error`,
 * `console.log`, `console.trace`, and `console.assert`. You can use the `levels` option to customize which
 * levels are captured.
 *
 * @example
 *
 * ```ts
 * import * as Sentry from '@sentry/browser';
 *
 * Sentry.init({
 *   enableLogs: true,
 *   integrations: [Sentry.consoleLoggingIntegration({ levels: ['error', 'warn'] })],
 * });
 * ```
 */ var consoleLoggingIntegration = (0, _integrationJs.defineIntegration)(_consoleLoggingIntegration);

},{"@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_object_spread":"9gdrV","../currentScopes.js":"3GE4v","../debug-build.js":"ejIQP","../instrument/console.js":"eEuZ3","../integration.js":"brH19","../semanticAttributes.js":"7WRPE","../utils/debug-logger.js":"3X9Vf","./internal.js":"3IZl8","./utils.js":"7kmIR","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7kmIR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createConsoleTemplateAttributes", function() {
    return createConsoleTemplateAttributes;
});
parcelHelpers.export(exports, "formatConsoleArgs", function() {
    return formatConsoleArgs;
});
parcelHelpers.export(exports, "hasConsoleSubstitutions", function() {
    return hasConsoleSubstitutions;
});
parcelHelpers.export(exports, "safeJoinConsoleArgs", function() {
    return safeJoinConsoleArgs;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _isJs = require("../utils/is.js");
var _normalizeJs = require("../utils/normalize.js");
var _worldwideJs = require("../utils/worldwide.js");
/**
 * Formats the given values into a string.
 *
 * @param values - The values to format.
 * @param normalizeDepth - The depth to normalize the values.
 * @param normalizeMaxBreadth - The max breadth to normalize the values.
 * @returns The formatted string.
 */ function formatConsoleArgs(values, normalizeDepth, normalizeMaxBreadth) {
    var _GLOBAL_OBJ_util;
    return 'util' in (0, _worldwideJs.GLOBAL_OBJ) && typeof (0, _worldwideJs.GLOBAL_OBJ).util.format === 'function' ? (_GLOBAL_OBJ_util = (0, _worldwideJs.GLOBAL_OBJ).util).format.apply(_GLOBAL_OBJ_util, (0, _toConsumableArray._)(values)) : safeJoinConsoleArgs(values, normalizeDepth, normalizeMaxBreadth);
}
/**
 * Joins the given values into a string.
 *
 * @param values - The values to join.
 * @param normalizeDepth - The depth to normalize the values.
 * @param normalizeMaxBreadth - The max breadth to normalize the values.
 * @returns The joined string.
 */ function safeJoinConsoleArgs(values, normalizeDepth, normalizeMaxBreadth) {
    return values.map(function(value) {
        return (0, _isJs.isPrimitive)(value) ? String(value) : JSON.stringify((0, _normalizeJs.normalize)(value, normalizeDepth, normalizeMaxBreadth));
    }).join(' ');
}
/**
 * Checks if a string contains console substitution patterns like %s, %d, %i, %f, %o, %O, %c.
 *
 * @param str - The string to check
 * @returns true if the string contains console substitution patterns
 */ function hasConsoleSubstitutions(str) {
    // Match console substitution patterns: %s, %d, %i, %f, %o, %O, %c
    return /%[sdifocO]/.test(str);
}
/**
 * Creates template attributes for multiple console arguments.
 *
 * @param args - The console arguments
 * @returns An object with template and parameter attributes
 */ function createConsoleTemplateAttributes(firstArg, followingArgs) {
    var attributes = {};
    // Create template with placeholders for each argument
    var template = new Array(followingArgs.length).fill('{}').join(' ');
    attributes['sentry.message.template'] = "".concat(firstArg, " ").concat(template);
    // Add each argument as a parameter
    followingArgs.forEach(function(arg, index) {
        attributes["sentry.message.parameter.".concat(index)] = arg;
    });
    return attributes;
}

},{"@swc/helpers/_/_to_consumable_array":"1eSZf","../utils/is.js":"kSqSf","../utils/normalize.js":"k9k7R","../utils/worldwide.js":"3qnNR","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hTrNs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "count", function() {
    return count;
});
parcelHelpers.export(exports, "distribution", function() {
    return distribution;
});
parcelHelpers.export(exports, "gauge", function() {
    return gauge;
});
var _internalJs = require("./internal.js");
/**
 * Options for capturing a metric.
 */ /**
 * Capture a metric with the given type, name, and value.
 *
 * @param type - The type of the metric.
 * @param name - The name of the metric.
 * @param value - The value of the metric.
 * @param options - Options for capturing the metric.
 */ function captureMetric(type, name, value, options) {
    (0, _internalJs._INTERNAL_captureMetric)({
        type: type,
        name: name,
        value: value,
        unit: options === null || options === void 0 ? void 0 : options.unit,
        attributes: options === null || options === void 0 ? void 0 : options.attributes
    }, {
        scope: options === null || options === void 0 ? void 0 : options.scope
    });
}
/**
 * @summary Increment a counter metric. Requires the `_experiments.enableMetrics` option to be enabled.
 *
 * @param name - The name of the counter metric.
 * @param value - The value to increment by (defaults to 1).
 * @param options - Options for capturing the metric.
 *
 * @example
 *
 * ```
 * Sentry.metrics.count('api.requests', 1, {
 *   attributes: {
 *     endpoint: '/api/users',
 *     method: 'GET',
 *     status: 200
 *   }
 * });
 * ```
 *
 * @example With custom value
 *
 * ```
 * Sentry.metrics.count('items.processed', 5, {
 *   attributes: {
 *     processor: 'batch-processor',
 *     queue: 'high-priority'
 *   }
 * });
 * ```
 */ function count(name) {
    var value = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, options = arguments.length > 2 ? arguments[2] : void 0;
    captureMetric('counter', name, value, options);
}
/**
 * @summary Set a gauge metric to a specific value. Requires the `_experiments.enableMetrics` option to be enabled.
 *
 * @param name - The name of the gauge metric.
 * @param value - The current value of the gauge.
 * @param options - Options for capturing the metric.
 *
 * @example
 *
 * ```
 * Sentry.metrics.gauge('memory.usage', 1024, {
 *   unit: 'megabyte',
 *   attributes: {
 *     process: 'web-server',
 *     region: 'us-east-1'
 *   }
 * });
 * ```
 *
 * @example Without unit
 *
 * ```
 * Sentry.metrics.gauge('active.connections', 42, {
 *   attributes: {
 *     server: 'api-1',
 *     protocol: 'websocket'
 *   }
 * });
 * ```
 */ function gauge(name, value, options) {
    captureMetric('gauge', name, value, options);
}
/**
 * @summary Record a value in a distribution metric. Requires the `_experiments.enableMetrics` option to be enabled.
 *
 * @param name - The name of the distribution metric.
 * @param value - The value to record in the distribution.
 * @param options - Options for capturing the metric.
 *
 * @example
 *
 * ```
 * Sentry.metrics.distribution('task.duration', 500, {
 *   unit: 'millisecond',
 *   attributes: {
 *     task: 'data-processing',
 *     priority: 'high'
 *   }
 * });
 * ```
 *
 * @example Without unit
 *
 * ```
 * Sentry.metrics.distribution('batch.size', 100, {
 *   attributes: {
 *     processor: 'batch-1',
 *     type: 'async'
 *   }
 * });
 * ```
 */ function distribution(name, value, options) {
    captureMetric('distribution', name, value, options);
}

},{"./internal.js":"acYCr","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jwQCw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createConsolaReporter", function() {
    return createConsolaReporter;
});
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _currentScopesJs = require("../currentScopes.js");
var _internalJs = require("../logs/internal.js");
var _utilsJs = require("../logs/utils.js");
/**
 * Options for the Sentry Consola reporter.
 */ var DEFAULT_CAPTURED_LEVELS = [
    'trace',
    'debug',
    'info',
    'warn',
    'error',
    'fatal'
];
/**
 * Creates a new Sentry reporter for Consola that forwards logs to Sentry. Requires the `enableLogs` option to be enabled.
 *
 * **Note: This integration supports Consola v3.x only.** The reporter interface and log object structure
 * may differ in other versions of Consola.
 *
 * @param options - Configuration options for the reporter.
 * @returns A Consola reporter that can be added to consola instances.
 *
 * @example
 * ```ts
 * import * as Sentry from '@sentry/node';
 * import { consola } from 'consola';
 *
 * Sentry.init({
 *   enableLogs: true,
 * });
 *
 * const sentryReporter = Sentry.createConsolaReporter({
 *   // Optional: filter levels to capture
 *   levels: ['error', 'warn', 'info'],
 * });
 *
 * consola.addReporter(sentryReporter);
 *
 * // Now consola logs will be captured by Sentry
 * consola.info('This will be sent to Sentry');
 * consola.error('This error will also be sent to Sentry');
 * ```
 */ function createConsolaReporter() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _options_levels;
    var levels = new Set((_options_levels = options.levels) !== null && _options_levels !== void 0 ? _options_levels : DEFAULT_CAPTURED_LEVELS);
    var providedClient = options.client;
    return {
        log: function log(logObj) {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            var type = logObj.type, level = logObj.level, consolaMessage = logObj.message, args = logObj.args, tag = logObj.tag, _date = logObj.date, attributes = (0, _objectWithoutProperties._)(logObj, [
                "type",
                "level",
                "message",
                "args",
                "tag",
                "date"
            ]);
            // Get client - use provided client or current client
            var client = providedClient || (0, _currentScopesJs.getClient)();
            if (!client) return;
            // Determine the log severity level
            var logSeverityLevel = getLogSeverityLevel(type, level);
            // Early exit if this level should not be captured
            if (!levels.has(logSeverityLevel)) return;
            var _client_getOptions = client.getOptions(), _client_getOptions_normalizeDepth = _client_getOptions.normalizeDepth, normalizeDepth = _client_getOptions_normalizeDepth === void 0 ? 3 : _client_getOptions_normalizeDepth, _client_getOptions_normalizeMaxBreadth = _client_getOptions.normalizeMaxBreadth, normalizeMaxBreadth = _client_getOptions_normalizeMaxBreadth === void 0 ? 1000 : _client_getOptions_normalizeMaxBreadth;
            // Format the log message using the same approach as consola's basic reporter
            var messageParts = [];
            if (consolaMessage) messageParts.push(consolaMessage);
            if (args && args.length > 0) messageParts.push((0, _utilsJs.formatConsoleArgs)(args, normalizeDepth, normalizeMaxBreadth));
            var message = messageParts.join(' ');
            // Build attributes
            attributes['sentry.origin'] = 'auto.log.consola';
            if (tag) attributes['consola.tag'] = tag;
            if (type) attributes['consola.type'] = type;
            // Only add level if it's a valid number (not null/undefined)
            if (level != null && typeof level === 'number') attributes['consola.level'] = level;
            (0, _internalJs._INTERNAL_captureLog)({
                level: logSeverityLevel,
                message: message,
                attributes: attributes
            });
        }
    };
}
// Mapping from consola log types to Sentry log severity levels
var CONSOLA_TYPE_TO_LOG_SEVERITY_LEVEL_MAP = {
    // Consola built-in types
    silent: 'trace',
    fatal: 'fatal',
    error: 'error',
    warn: 'warn',
    log: 'info',
    info: 'info',
    success: 'info',
    fail: 'error',
    ready: 'info',
    start: 'info',
    box: 'info',
    debug: 'debug',
    trace: 'trace',
    verbose: 'debug',
    // Custom types that might exist
    critical: 'fatal',
    notice: 'info'
};
// Mapping from consola log levels (numbers) to Sentry log severity levels
var CONSOLA_LEVEL_TO_LOG_SEVERITY_LEVEL_MAP = {
    0: 'fatal',
    1: 'warn',
    2: 'info',
    3: 'info',
    4: 'debug',
    5: 'trace'
};
/**
 * Determines the log severity level from Consola type and level.
 *
 * @param type - The Consola log type (e.g., 'error', 'warn', 'info')
 * @param level - The Consola numeric log level (0-5) or null for some types like 'verbose'
 * @returns The corresponding Sentry log severity level
 */ function getLogSeverityLevel(type, level) {
    // Handle special case for verbose logs (level can be null with infinite level in Consola)
    if (type === 'verbose') return 'debug';
    // Handle silent logs - these should be at trace level
    if (type === 'silent') return 'trace';
    // First try to map by type (more specific)
    if (type) {
        var mappedLevel = CONSOLA_TYPE_TO_LOG_SEVERITY_LEVEL_MAP[type];
        if (mappedLevel) return mappedLevel;
    }
    // Fallback to level mapping (handle null level)
    if (typeof level === 'number') {
        var mappedLevel1 = CONSOLA_LEVEL_TO_LOG_SEVERITY_LEVEL_MAP[level];
        if (mappedLevel1) return mappedLevel1;
    }
    // Default fallback
    return 'info';
}

},{"@swc/helpers/_/_object_without_properties":"6HqIM","../currentScopes.js":"3GE4v","../logs/internal.js":"3IZl8","../logs/utils.js":"7kmIR","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"astYj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addVercelAiProcessors", function() {
    return addVercelAiProcessors;
});
var _semanticAttributesJs = require("../../semanticAttributes.js");
var _spanUtilsJs = require("../../utils/spanUtils.js");
var _genAiAttributesJs = require("../ai/gen-ai-attributes.js");
var _utilsJs = require("../ai/utils.js");
var _constantsJs = require("./constants.js");
var _utilsJs1 = require("./utils.js");
var _vercelAiAttributesJs = require("./vercel-ai-attributes.js");
function addOriginToSpan(span, origin) {
    span.setAttribute((0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), origin);
}
/**
 * Post-process spans emitted by the Vercel AI SDK.
 * This is supposed to be used in `client.on('spanStart', ...)
 */ function onVercelAiSpanStart(span) {
    var _spanToJSON = (0, _spanUtilsJs.spanToJSON)(span), attributes = _spanToJSON.data, name = _spanToJSON.description;
    if (!name) return;
    // Tool call spans
    // https://ai-sdk.dev/docs/ai-sdk-core/telemetry#tool-call-spans
    if (attributes[0, _vercelAiAttributesJs.AI_TOOL_CALL_NAME_ATTRIBUTE] && attributes[0, _vercelAiAttributesJs.AI_TOOL_CALL_ID_ATTRIBUTE] && name === 'ai.toolCall') {
        processToolCallSpan(span, attributes);
        return;
    }
    // The AI and Provider must be defined for generate, stream, and embed spans.
    // The id of the model
    var aiModelId = attributes[0, _vercelAiAttributesJs.AI_MODEL_ID_ATTRIBUTE];
    // the provider of the model
    var aiModelProvider = attributes[0, _vercelAiAttributesJs.AI_MODEL_PROVIDER_ATTRIBUTE];
    if (typeof aiModelId !== 'string' || typeof aiModelProvider !== 'string' || !aiModelId || !aiModelProvider) return;
    processGenerateSpan(span, name, attributes);
}
function vercelAiEventProcessor(event) {
    if (event.type === 'transaction' && event.spans) {
        var _event_contexts;
        // Map to accumulate token data by parent span ID
        var tokenAccumulator = new Map();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // First pass: process all spans and accumulate token data
            for(var _iterator = event.spans[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var span = _step.value;
                processEndedVercelAiSpan(span);
                // Accumulate token data for parent spans
                (0, _utilsJs1.accumulateTokensForParent)(span, tokenAccumulator);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            // Second pass: apply accumulated token data to parent spans
            for(var _iterator1 = event.spans[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var span1 = _step1.value;
                if (span1.op !== 'gen_ai.invoke_agent') continue;
                (0, _utilsJs1.applyAccumulatedTokens)(span1, tokenAccumulator);
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        // Also apply to root when it is the invoke_agent pipeline
        var trace = (_event_contexts = event.contexts) === null || _event_contexts === void 0 ? void 0 : _event_contexts.trace;
        if (trace && trace.op === 'gen_ai.invoke_agent') (0, _utilsJs1.applyAccumulatedTokens)(trace, tokenAccumulator);
    }
    return event;
}
/**
 * Post-process spans emitted by the Vercel AI SDK.
 */ function processEndedVercelAiSpan(span) {
    var attributes = span.data, origin = span.origin;
    if (origin !== 'auto.vercelai.otel') return;
    renameAttributeKey(attributes, (0, _vercelAiAttributesJs.AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE), (0, _vercelAiAttributesJs.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE));
    renameAttributeKey(attributes, (0, _vercelAiAttributesJs.AI_USAGE_PROMPT_TOKENS_ATTRIBUTE), (0, _vercelAiAttributesJs.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE));
    renameAttributeKey(attributes, (0, _vercelAiAttributesJs.AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE), (0, _genAiAttributesJs.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE));
    if (typeof attributes[0, _vercelAiAttributesJs.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] === 'number' && typeof attributes[0, _vercelAiAttributesJs.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] === 'number') attributes['gen_ai.usage.total_tokens'] = attributes[0, _vercelAiAttributesJs.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] + attributes[0, _vercelAiAttributesJs.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE];
    // Convert the available tools array to a JSON string
    if (attributes[0, _vercelAiAttributesJs.AI_PROMPT_TOOLS_ATTRIBUTE] && Array.isArray(attributes[0, _vercelAiAttributesJs.AI_PROMPT_TOOLS_ATTRIBUTE])) attributes[0, _vercelAiAttributesJs.AI_PROMPT_TOOLS_ATTRIBUTE] = (0, _utilsJs1.convertAvailableToolsToJsonString)(attributes[0, _vercelAiAttributesJs.AI_PROMPT_TOOLS_ATTRIBUTE]);
    // Rename AI SDK attributes to standardized gen_ai attributes
    renameAttributeKey(attributes, (0, _vercelAiAttributesJs.AI_PROMPT_MESSAGES_ATTRIBUTE), 'gen_ai.request.messages');
    renameAttributeKey(attributes, (0, _vercelAiAttributesJs.AI_RESPONSE_TEXT_ATTRIBUTE), 'gen_ai.response.text');
    renameAttributeKey(attributes, (0, _vercelAiAttributesJs.AI_RESPONSE_TOOL_CALLS_ATTRIBUTE), 'gen_ai.response.tool_calls');
    renameAttributeKey(attributes, (0, _vercelAiAttributesJs.AI_RESPONSE_OBJECT_ATTRIBUTE), 'gen_ai.response.object');
    renameAttributeKey(attributes, (0, _vercelAiAttributesJs.AI_PROMPT_TOOLS_ATTRIBUTE), 'gen_ai.request.available_tools');
    renameAttributeKey(attributes, (0, _vercelAiAttributesJs.AI_TOOL_CALL_ARGS_ATTRIBUTE), 'gen_ai.tool.input');
    renameAttributeKey(attributes, (0, _vercelAiAttributesJs.AI_TOOL_CALL_RESULT_ATTRIBUTE), 'gen_ai.tool.output');
    renameAttributeKey(attributes, (0, _vercelAiAttributesJs.AI_SCHEMA_ATTRIBUTE), 'gen_ai.request.schema');
    addProviderMetadataToAttributes(attributes);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // Change attributes namespaced with `ai.X` to `vercel.ai.X`
        for(var _iterator = Object.keys(attributes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (key.startsWith('ai.')) renameAttributeKey(attributes, key, "vercel.".concat(key));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
/**
 * Renames an attribute key in the provided attributes object if the old key exists.
 * This function safely handles null and undefined values.
 */ function renameAttributeKey(attributes, oldKey, newKey) {
    if (attributes[oldKey] != null) {
        attributes[newKey] = attributes[oldKey];
        // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete attributes[oldKey];
    }
}
function processToolCallSpan(span, attributes) {
    addOriginToSpan(span, 'auto.vercelai.otel');
    span.setAttribute((0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP), 'gen_ai.execute_tool');
    renameAttributeKey(attributes, (0, _vercelAiAttributesJs.AI_TOOL_CALL_NAME_ATTRIBUTE), 'gen_ai.tool.name');
    renameAttributeKey(attributes, (0, _vercelAiAttributesJs.AI_TOOL_CALL_ID_ATTRIBUTE), 'gen_ai.tool.call.id');
    // Store the span in our global map using the tool call ID
    // This allows us to capture tool errors and link them to the correct span
    var toolCallId = attributes['gen_ai.tool.call.id'];
    if (typeof toolCallId === 'string') (0, _constantsJs.toolCallSpanMap).set(toolCallId, span);
    // https://opentelemetry.io/docs/specs/semconv/registry/attributes/gen-ai/#gen-ai-tool-type
    if (!attributes['gen_ai.tool.type']) span.setAttribute('gen_ai.tool.type', 'function');
    var toolName = attributes['gen_ai.tool.name'];
    if (toolName) span.updateName("execute_tool ".concat(toolName));
}
function processGenerateSpan(span, name, attributes) {
    addOriginToSpan(span, 'auto.vercelai.otel');
    var nameWthoutAi = name.replace('ai.', '');
    span.setAttribute('ai.pipeline.name', nameWthoutAi);
    span.updateName(nameWthoutAi);
    // If a telemetry name is set and the span represents a pipeline, use it as the operation name.
    // This name can be set at the request level by adding `experimental_telemetry.functionId`.
    var functionId = attributes[0, _vercelAiAttributesJs.AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE];
    if (functionId && typeof functionId === 'string') {
        span.updateName("".concat(nameWthoutAi, " ").concat(functionId));
        span.setAttribute('gen_ai.function_id', functionId);
    }
    if (attributes[0, _vercelAiAttributesJs.AI_PROMPT_ATTRIBUTE]) {
        var truncatedPrompt = (0, _utilsJs.getTruncatedJsonString)(attributes[0, _vercelAiAttributesJs.AI_PROMPT_ATTRIBUTE]);
        span.setAttribute('gen_ai.prompt', truncatedPrompt);
    }
    if (attributes[0, _vercelAiAttributesJs.AI_MODEL_ID_ATTRIBUTE] && !attributes[0, _vercelAiAttributesJs.GEN_AI_RESPONSE_MODEL_ATTRIBUTE]) span.setAttribute((0, _vercelAiAttributesJs.GEN_AI_RESPONSE_MODEL_ATTRIBUTE), attributes[0, _vercelAiAttributesJs.AI_MODEL_ID_ATTRIBUTE]);
    span.setAttribute('ai.streaming', name.includes('stream'));
    // Generate Spans
    if (name === 'ai.generateText') {
        span.setAttribute((0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP), 'gen_ai.invoke_agent');
        return;
    }
    if (name === 'ai.generateText.doGenerate') {
        span.setAttribute((0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP), 'gen_ai.generate_text');
        span.updateName("generate_text ".concat(attributes[0, _vercelAiAttributesJs.AI_MODEL_ID_ATTRIBUTE]));
        return;
    }
    if (name === 'ai.streamText') {
        span.setAttribute((0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP), 'gen_ai.invoke_agent');
        return;
    }
    if (name === 'ai.streamText.doStream') {
        span.setAttribute((0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP), 'gen_ai.stream_text');
        span.updateName("stream_text ".concat(attributes[0, _vercelAiAttributesJs.AI_MODEL_ID_ATTRIBUTE]));
        return;
    }
    if (name === 'ai.generateObject') {
        span.setAttribute((0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP), 'gen_ai.invoke_agent');
        return;
    }
    if (name === 'ai.generateObject.doGenerate') {
        span.setAttribute((0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP), 'gen_ai.generate_object');
        span.updateName("generate_object ".concat(attributes[0, _vercelAiAttributesJs.AI_MODEL_ID_ATTRIBUTE]));
        return;
    }
    if (name === 'ai.streamObject') {
        span.setAttribute((0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP), 'gen_ai.invoke_agent');
        return;
    }
    if (name === 'ai.streamObject.doStream') {
        span.setAttribute((0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP), 'gen_ai.stream_object');
        span.updateName("stream_object ".concat(attributes[0, _vercelAiAttributesJs.AI_MODEL_ID_ATTRIBUTE]));
        return;
    }
    if (name === 'ai.embed') {
        span.setAttribute((0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP), 'gen_ai.invoke_agent');
        return;
    }
    if (name === 'ai.embed.doEmbed') {
        span.setAttribute((0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP), 'gen_ai.embed');
        span.updateName("embed ".concat(attributes[0, _vercelAiAttributesJs.AI_MODEL_ID_ATTRIBUTE]));
        return;
    }
    if (name === 'ai.embedMany') {
        span.setAttribute((0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP), 'gen_ai.invoke_agent');
        return;
    }
    if (name === 'ai.embedMany.doEmbed') {
        span.setAttribute((0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP), 'gen_ai.embed_many');
        span.updateName("embed_many ".concat(attributes[0, _vercelAiAttributesJs.AI_MODEL_ID_ATTRIBUTE]));
        return;
    }
    if (name.startsWith('ai.stream')) {
        span.setAttribute((0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP), 'ai.run');
        return;
    }
}
/**
 * Add event processors to the given client to process Vercel AI spans.
 */ function addVercelAiProcessors(client) {
    client.on('spanStart', onVercelAiSpanStart);
    // Note: We cannot do this on `spanEnd`, because the span cannot be mutated anymore at this point
    client.addEventProcessor(Object.assign(vercelAiEventProcessor, {
        id: 'VercelAiEventProcessor'
    }));
}
function addProviderMetadataToAttributes(attributes) {
    var providerMetadata = attributes[0, _vercelAiAttributesJs.AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE];
    if (providerMetadata) try {
        var _providerMetadataObject_bedrock;
        var providerMetadataObject = JSON.parse(providerMetadata);
        if (providerMetadataObject.openai) {
            setAttributeIfDefined(attributes, (0, _genAiAttributesJs.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE), providerMetadataObject.openai.cachedPromptTokens);
            setAttributeIfDefined(attributes, 'gen_ai.usage.output_tokens.reasoning', providerMetadataObject.openai.reasoningTokens);
            setAttributeIfDefined(attributes, 'gen_ai.usage.output_tokens.prediction_accepted', providerMetadataObject.openai.acceptedPredictionTokens);
            setAttributeIfDefined(attributes, 'gen_ai.usage.output_tokens.prediction_rejected', providerMetadataObject.openai.rejectedPredictionTokens);
            setAttributeIfDefined(attributes, 'gen_ai.conversation.id', providerMetadataObject.openai.responseId);
        }
        if (providerMetadataObject.anthropic) {
            var _providerMetadataObject_anthropic_usage, _providerMetadataObject_anthropic_usage1;
            var _providerMetadataObject_anthropic_usage_cache_read_input_tokens;
            var cachedInputTokens = (_providerMetadataObject_anthropic_usage_cache_read_input_tokens = (_providerMetadataObject_anthropic_usage = providerMetadataObject.anthropic.usage) === null || _providerMetadataObject_anthropic_usage === void 0 ? void 0 : _providerMetadataObject_anthropic_usage.cache_read_input_tokens) !== null && _providerMetadataObject_anthropic_usage_cache_read_input_tokens !== void 0 ? _providerMetadataObject_anthropic_usage_cache_read_input_tokens : providerMetadataObject.anthropic.cacheReadInputTokens;
            setAttributeIfDefined(attributes, (0, _genAiAttributesJs.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE), cachedInputTokens);
            var _providerMetadataObject_anthropic_usage_cache_creation_input_tokens;
            var cacheWriteInputTokens = (_providerMetadataObject_anthropic_usage_cache_creation_input_tokens = (_providerMetadataObject_anthropic_usage1 = providerMetadataObject.anthropic.usage) === null || _providerMetadataObject_anthropic_usage1 === void 0 ? void 0 : _providerMetadataObject_anthropic_usage1.cache_creation_input_tokens) !== null && _providerMetadataObject_anthropic_usage_cache_creation_input_tokens !== void 0 ? _providerMetadataObject_anthropic_usage_cache_creation_input_tokens : providerMetadataObject.anthropic.cacheCreationInputTokens;
            setAttributeIfDefined(attributes, (0, _genAiAttributesJs.GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE), cacheWriteInputTokens);
        }
        if ((_providerMetadataObject_bedrock = providerMetadataObject.bedrock) === null || _providerMetadataObject_bedrock === void 0 ? void 0 : _providerMetadataObject_bedrock.usage) {
            setAttributeIfDefined(attributes, (0, _genAiAttributesJs.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE), providerMetadataObject.bedrock.usage.cacheReadInputTokens);
            setAttributeIfDefined(attributes, (0, _genAiAttributesJs.GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE), providerMetadataObject.bedrock.usage.cacheWriteInputTokens);
        }
        if (providerMetadataObject.deepseek) {
            setAttributeIfDefined(attributes, (0, _genAiAttributesJs.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE), providerMetadataObject.deepseek.promptCacheHitTokens);
            setAttributeIfDefined(attributes, 'gen_ai.usage.input_tokens.cache_miss', providerMetadataObject.deepseek.promptCacheMissTokens);
        }
    } catch (e) {
    // Ignore
    }
}
/**
 * Sets an attribute only if the value is not null or undefined.
 */ function setAttributeIfDefined(attributes, key, value) {
    if (value != null) attributes[key] = value;
}

},{"../../semanticAttributes.js":"7WRPE","../../utils/spanUtils.js":"fPRKj","../ai/gen-ai-attributes.js":"faK6k","../ai/utils.js":"2cEft","./constants.js":"4J5xh","./utils.js":"7ZXP3","./vercel-ai-attributes.js":"3hzGd","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"faK6k":[function(require,module,exports,__globalThis) {
/**
 * OpenAI Integration Telemetry Attributes
 * Based on OpenTelemetry Semantic Conventions for Generative AI
 * @see https://opentelemetry.io/docs/specs/semconv/gen-ai/
 */ // =============================================================================
// OPENTELEMETRY SEMANTIC CONVENTIONS FOR GENAI
// =============================================================================
/**
 * The input messages sent to the model
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ANTHROPIC_AI_RESPONSE_TIMESTAMP_ATTRIBUTE", function() {
    return ANTHROPIC_AI_RESPONSE_TIMESTAMP_ATTRIBUTE;
});
parcelHelpers.export(exports, "GEN_AI_AGENT_NAME_ATTRIBUTE", function() {
    return GEN_AI_AGENT_NAME_ATTRIBUTE;
});
parcelHelpers.export(exports, "GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE", function() {
    return GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE;
});
parcelHelpers.export(exports, "GEN_AI_OPERATION_NAME_ATTRIBUTE", function() {
    return GEN_AI_OPERATION_NAME_ATTRIBUTE;
});
parcelHelpers.export(exports, "GEN_AI_PIPELINE_NAME_ATTRIBUTE", function() {
    return GEN_AI_PIPELINE_NAME_ATTRIBUTE;
});
parcelHelpers.export(exports, "GEN_AI_PROMPT_ATTRIBUTE", function() {
    return GEN_AI_PROMPT_ATTRIBUTE;
});
parcelHelpers.export(exports, "GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE", function() {
    return GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE;
});
parcelHelpers.export(exports, "GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE", function() {
    return GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE;
});
parcelHelpers.export(exports, "GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE", function() {
    return GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE;
});
parcelHelpers.export(exports, "GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE", function() {
    return GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE;
});
parcelHelpers.export(exports, "GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE", function() {
    return GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE;
});
parcelHelpers.export(exports, "GEN_AI_REQUEST_MESSAGES_ATTRIBUTE", function() {
    return GEN_AI_REQUEST_MESSAGES_ATTRIBUTE;
});
parcelHelpers.export(exports, "GEN_AI_REQUEST_MODEL_ATTRIBUTE", function() {
    return GEN_AI_REQUEST_MODEL_ATTRIBUTE;
});
parcelHelpers.export(exports, "GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE", function() {
    return GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE;
});
parcelHelpers.export(exports, "GEN_AI_REQUEST_STREAM_ATTRIBUTE", function() {
    return GEN_AI_REQUEST_STREAM_ATTRIBUTE;
});
parcelHelpers.export(exports, "GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE", function() {
    return GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE;
});
parcelHelpers.export(exports, "GEN_AI_REQUEST_TOP_K_ATTRIBUTE", function() {
    return GEN_AI_REQUEST_TOP_K_ATTRIBUTE;
});
parcelHelpers.export(exports, "GEN_AI_REQUEST_TOP_P_ATTRIBUTE", function() {
    return GEN_AI_REQUEST_TOP_P_ATTRIBUTE;
});
parcelHelpers.export(exports, "GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE", function() {
    return GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE;
});
parcelHelpers.export(exports, "GEN_AI_RESPONSE_ID_ATTRIBUTE", function() {
    return GEN_AI_RESPONSE_ID_ATTRIBUTE;
});
parcelHelpers.export(exports, "GEN_AI_RESPONSE_MODEL_ATTRIBUTE", function() {
    return GEN_AI_RESPONSE_MODEL_ATTRIBUTE;
});
parcelHelpers.export(exports, "GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE", function() {
    return GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE;
});
parcelHelpers.export(exports, "GEN_AI_RESPONSE_STREAMING_ATTRIBUTE", function() {
    return GEN_AI_RESPONSE_STREAMING_ATTRIBUTE;
});
parcelHelpers.export(exports, "GEN_AI_RESPONSE_TEXT_ATTRIBUTE", function() {
    return GEN_AI_RESPONSE_TEXT_ATTRIBUTE;
});
parcelHelpers.export(exports, "GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE", function() {
    return GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE;
});
parcelHelpers.export(exports, "GEN_AI_SYSTEM_ATTRIBUTE", function() {
    return GEN_AI_SYSTEM_ATTRIBUTE;
});
parcelHelpers.export(exports, "GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_ATTRIBUTE", function() {
    return GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_ATTRIBUTE;
});
parcelHelpers.export(exports, "GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_ATTRIBUTE", function() {
    return GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_ATTRIBUTE;
});
parcelHelpers.export(exports, "GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE", function() {
    return GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE;
});
parcelHelpers.export(exports, "GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE", function() {
    return GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE;
});
parcelHelpers.export(exports, "GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE", function() {
    return GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE;
});
parcelHelpers.export(exports, "GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE", function() {
    return GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE;
});
parcelHelpers.export(exports, "GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE", function() {
    return GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE;
});
parcelHelpers.export(exports, "OPENAI_OPERATIONS", function() {
    return OPENAI_OPERATIONS;
});
parcelHelpers.export(exports, "OPENAI_RESPONSE_ID_ATTRIBUTE", function() {
    return OPENAI_RESPONSE_ID_ATTRIBUTE;
});
parcelHelpers.export(exports, "OPENAI_RESPONSE_MODEL_ATTRIBUTE", function() {
    return OPENAI_RESPONSE_MODEL_ATTRIBUTE;
});
parcelHelpers.export(exports, "OPENAI_RESPONSE_TIMESTAMP_ATTRIBUTE", function() {
    return OPENAI_RESPONSE_TIMESTAMP_ATTRIBUTE;
});
parcelHelpers.export(exports, "OPENAI_USAGE_COMPLETION_TOKENS_ATTRIBUTE", function() {
    return OPENAI_USAGE_COMPLETION_TOKENS_ATTRIBUTE;
});
parcelHelpers.export(exports, "OPENAI_USAGE_PROMPT_TOKENS_ATTRIBUTE", function() {
    return OPENAI_USAGE_PROMPT_TOKENS_ATTRIBUTE;
});
var GEN_AI_PROMPT_ATTRIBUTE = 'gen_ai.prompt';
/**
 * The Generative AI system being used
 * For OpenAI, this should always be "openai"
 */ var GEN_AI_SYSTEM_ATTRIBUTE = 'gen_ai.system';
/**
 * The name of the model as requested
 * Examples: "gpt-4", "gpt-3.5-turbo"
 */ var GEN_AI_REQUEST_MODEL_ATTRIBUTE = 'gen_ai.request.model';
/**
 * Whether streaming was enabled for the request
 */ var GEN_AI_REQUEST_STREAM_ATTRIBUTE = 'gen_ai.request.stream';
/**
 * The temperature setting for the model request
 */ var GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE = 'gen_ai.request.temperature';
/**
 * The maximum number of tokens requested
 */ var GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE = 'gen_ai.request.max_tokens';
/**
 * The frequency penalty setting for the model request
 */ var GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE = 'gen_ai.request.frequency_penalty';
/**
 * The presence penalty setting for the model request
 */ var GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE = 'gen_ai.request.presence_penalty';
/**
 * The top_p (nucleus sampling) setting for the model request
 */ var GEN_AI_REQUEST_TOP_P_ATTRIBUTE = 'gen_ai.request.top_p';
/**
 * The top_k setting for the model request
 */ var GEN_AI_REQUEST_TOP_K_ATTRIBUTE = 'gen_ai.request.top_k';
/**
 * The encoding format for the model request
 */ var GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE = 'gen_ai.request.encoding_format';
/**
 * The dimensions for the model request
 */ var GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE = 'gen_ai.request.dimensions';
/**
 * Array of reasons why the model stopped generating tokens
 */ var GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE = 'gen_ai.response.finish_reasons';
/**
 * The name of the model that generated the response
 */ var GEN_AI_RESPONSE_MODEL_ATTRIBUTE = 'gen_ai.response.model';
/**
 * The unique identifier for the response
 */ var GEN_AI_RESPONSE_ID_ATTRIBUTE = 'gen_ai.response.id';
/**
 * The reason why the model stopped generating tokens
 */ var GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE = 'gen_ai.response.stop_reason';
/**
 * The number of tokens used in the prompt
 */ var GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE = 'gen_ai.usage.input_tokens';
/**
 * The number of tokens used in the response
 */ var GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE = 'gen_ai.usage.output_tokens';
/**
 * The total number of tokens used (input + output)
 */ var GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE = 'gen_ai.usage.total_tokens';
/**
 * The operation name
 */ var GEN_AI_OPERATION_NAME_ATTRIBUTE = 'gen_ai.operation.name';
/**
 * The prompt messages
 * Only recorded when recordInputs is enabled
 */ var GEN_AI_REQUEST_MESSAGES_ATTRIBUTE = 'gen_ai.request.messages';
/**
 * The response text
 * Only recorded when recordOutputs is enabled
 */ var GEN_AI_RESPONSE_TEXT_ATTRIBUTE = 'gen_ai.response.text';
/**
 * The available tools from incoming request
 * Only recorded when recordInputs is enabled
 */ var GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE = 'gen_ai.request.available_tools';
/**
 * Whether the response is a streaming response
 */ var GEN_AI_RESPONSE_STREAMING_ATTRIBUTE = 'gen_ai.response.streaming';
/**
 * The tool calls from the response
 * Only recorded when recordOutputs is enabled
 */ var GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = 'gen_ai.response.tool_calls';
/**
 * The agent name
 */ var GEN_AI_AGENT_NAME_ATTRIBUTE = 'gen_ai.agent.name';
/**
 * The pipeline name
 */ var GEN_AI_PIPELINE_NAME_ATTRIBUTE = 'gen_ai.pipeline.name';
/**
 * The number of cache creation input tokens used
 */ var GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_ATTRIBUTE = 'gen_ai.usage.cache_creation_input_tokens';
/**
 * The number of cache read input tokens used
 */ var GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_ATTRIBUTE = 'gen_ai.usage.cache_read_input_tokens';
/**
 * The number of cache write input tokens used
 */ var GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE = 'gen_ai.usage.input_tokens.cache_write';
/**
 * The number of cached input tokens that were used
 */ var GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE = 'gen_ai.usage.input_tokens.cached';
/**
 * The span operation name for invoking an agent
 */ var GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE = 'gen_ai.invoke_agent';
// =============================================================================
// OPENAI-SPECIFIC ATTRIBUTES
// =============================================================================
/**
 * The response ID from OpenAI
 */ var OPENAI_RESPONSE_ID_ATTRIBUTE = 'openai.response.id';
/**
 * The response model from OpenAI
 */ var OPENAI_RESPONSE_MODEL_ATTRIBUTE = 'openai.response.model';
/**
 * The response timestamp from OpenAI (ISO string)
 */ var OPENAI_RESPONSE_TIMESTAMP_ATTRIBUTE = 'openai.response.timestamp';
/**
 * The number of completion tokens used
 */ var OPENAI_USAGE_COMPLETION_TOKENS_ATTRIBUTE = 'openai.usage.completion_tokens';
/**
 * The number of prompt tokens used
 */ var OPENAI_USAGE_PROMPT_TOKENS_ATTRIBUTE = 'openai.usage.prompt_tokens';
// =============================================================================
// OPENAI OPERATIONS
// =============================================================================
/**
 * OpenAI API operations
 */ var OPENAI_OPERATIONS = {
    CHAT: 'chat',
    RESPONSES: 'responses',
    EMBEDDINGS: 'embeddings'
};
// =============================================================================
// ANTHROPIC AI OPERATIONS
// =============================================================================
/**
 * The response timestamp from Anthropic AI (ISO string)
 */ var ANTHROPIC_AI_RESPONSE_TIMESTAMP_ATTRIBUTE = 'anthropic.response.timestamp';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2cEft":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildMethodPath", function() {
    return buildMethodPath;
});
parcelHelpers.export(exports, "getFinalOperationName", function() {
    return getFinalOperationName;
});
parcelHelpers.export(exports, "getSpanOperation", function() {
    return getSpanOperation;
});
parcelHelpers.export(exports, "getTruncatedJsonString", function() {
    return getTruncatedJsonString;
});
parcelHelpers.export(exports, "setTokenUsageAttributes", function() {
    return setTokenUsageAttributes;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _genAiAttributesJs = require("./gen-ai-attributes.js");
var _messageTruncationJs = require("./messageTruncation.js");
/**
 * Maps AI method paths to Sentry operation name
 */ function getFinalOperationName(methodPath) {
    if (methodPath.includes('messages')) return 'messages';
    if (methodPath.includes('completions')) return 'completions';
    if (methodPath.includes('models')) return 'models';
    if (methodPath.includes('chat')) return 'chat';
    return methodPath.split('.').pop() || 'unknown';
}
/**
 * Get the span operation for AI methods
 * Following Sentry's convention: "gen_ai.{operation_name}"
 */ function getSpanOperation(methodPath) {
    return "gen_ai.".concat(getFinalOperationName(methodPath));
}
/**
 * Build method path from current traversal
 */ function buildMethodPath(currentPath, prop) {
    return currentPath ? "".concat(currentPath, ".").concat(prop) : prop;
}
/**
 * Set token usage attributes
 * @param span - The span to add attributes to
 * @param promptTokens - The number of prompt tokens
 * @param completionTokens - The number of completion tokens
 * @param cachedInputTokens - The number of cached input tokens
 * @param cachedOutputTokens - The number of cached output tokens
 */ function setTokenUsageAttributes(span, promptTokens, completionTokens, cachedInputTokens, cachedOutputTokens) {
    if (promptTokens !== undefined) span.setAttributes((0, _defineProperty._)({}, (0, _genAiAttributesJs.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE), promptTokens));
    if (completionTokens !== undefined) span.setAttributes((0, _defineProperty._)({}, (0, _genAiAttributesJs.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE), completionTokens));
    if (promptTokens !== undefined || completionTokens !== undefined || cachedInputTokens !== undefined || cachedOutputTokens !== undefined) {
        /**
     * Total input tokens in a request is the summation of `input_tokens`,
     * `cache_creation_input_tokens`, and `cache_read_input_tokens`.
     */ var totalTokens = (promptTokens !== null && promptTokens !== void 0 ? promptTokens : 0) + (completionTokens !== null && completionTokens !== void 0 ? completionTokens : 0) + (cachedInputTokens !== null && cachedInputTokens !== void 0 ? cachedInputTokens : 0) + (cachedOutputTokens !== null && cachedOutputTokens !== void 0 ? cachedOutputTokens : 0);
        span.setAttributes((0, _defineProperty._)({}, (0, _genAiAttributesJs.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE), totalTokens));
    }
}
/**
 * Get the truncated JSON string for a string or array of strings.
 *
 * @param value - The string or array of strings to truncate
 * @returns The truncated JSON string
 */ function getTruncatedJsonString(value) {
    if (typeof value === 'string') // Some values are already JSON strings, so we don't need to duplicate the JSON parsing
    return (0, _messageTruncationJs.truncateGenAiStringInput)(value);
    if (Array.isArray(value)) {
        // truncateGenAiMessages returns an array of strings, so we need to stringify it
        var truncatedMessages = (0, _messageTruncationJs.truncateGenAiMessages)(value);
        return JSON.stringify(truncatedMessages);
    }
    // value is an object, so we need to stringify it
    return JSON.stringify(value);
}

},{"@swc/helpers/_/_define_property":"e80IS","./gen-ai-attributes.js":"faK6k","./messageTruncation.js":"4zJE9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4zJE9":[function(require,module,exports,__globalThis) {
/**
 * Default maximum size in bytes for GenAI messages.
 * Messages exceeding this limit will be truncated.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT", function() {
    return DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT;
});
parcelHelpers.export(exports, "truncateGenAiMessages", function() {
    return truncateGenAiMessages;
});
parcelHelpers.export(exports, "truncateGenAiStringInput", function() {
    return truncateGenAiStringInput;
});
parcelHelpers.export(exports, "truncateMessagesByBytes", function() {
    return truncateMessagesByBytes;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _typeOf = require("@swc/helpers/_/_type_of");
var DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT = 20000;
/**
 * Message format used by OpenAI and Anthropic APIs.
 */ /**
 * Calculate the UTF-8 byte length of a string.
 */ var utf8Bytes = function(text) {
    return new TextEncoder().encode(text).length;
};
/**
 * Calculate the UTF-8 byte length of a value's JSON representation.
 */ var jsonBytes = function(value) {
    return utf8Bytes(JSON.stringify(value));
};
/**
 * Truncate a string to fit within maxBytes when encoded as UTF-8.
 * Uses binary search for efficiency with multi-byte characters.
 *
 * @param text - The string to truncate
 * @param maxBytes - Maximum byte length (UTF-8 encoded)
 * @returns Truncated string that fits within maxBytes
 */ function truncateTextByBytes(text, maxBytes) {
    if (utf8Bytes(text) <= maxBytes) return text;
    var low = 0;
    var high = text.length;
    var bestFit = '';
    while(low <= high){
        var mid = Math.floor((low + high) / 2);
        var candidate = text.slice(0, mid);
        var byteSize = utf8Bytes(candidate);
        if (byteSize <= maxBytes) {
            bestFit = candidate;
            low = mid + 1;
        } else high = mid - 1;
    }
    return bestFit;
}
/**
 * Extract text content from a Google GenAI message part.
 * Parts are either plain strings or objects with a text property.
 *
 * @returns The text content
 */ function getPartText(part) {
    if (typeof part === 'string') return part;
    return part.text;
}
/**
 * Create a new part with updated text content while preserving the original structure.
 *
 * @param part - Original part (string or object)
 * @param text - New text content
 * @returns New part with updated text
 */ function withPartText(part, text) {
    if (typeof part === 'string') return text;
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, part), {
        text: text
    });
}
/**
 * Check if a message has the OpenAI/Anthropic content format.
 */ function isContentMessage(message) {
    return message !== null && (typeof message === "undefined" ? "undefined" : (0, _typeOf._)(message)) === 'object' && 'content' in message && typeof message.content === 'string';
}
/**
 * Check if a message has the Google GenAI parts format.
 */ function isPartsMessage(message) {
    return message !== null && (typeof message === "undefined" ? "undefined" : (0, _typeOf._)(message)) === 'object' && 'parts' in message && Array.isArray(message.parts) && message.parts.length > 0;
}
/**
 * Truncate a message with `content: string` format (OpenAI/Anthropic).
 *
 * @param message - Message with content property
 * @param maxBytes - Maximum byte limit
 * @returns Array with truncated message, or empty array if it doesn't fit
 */ function truncateContentMessage(message, maxBytes) {
    // Calculate overhead (message structure without content)
    var emptyMessage = (0, _objectSpreadProps._)((0, _objectSpread._)({}, message), {
        content: ''
    });
    var overhead = jsonBytes(emptyMessage);
    var availableForContent = maxBytes - overhead;
    if (availableForContent <= 0) return [];
    var truncatedContent = truncateTextByBytes(message.content, availableForContent);
    return [
        (0, _objectSpreadProps._)((0, _objectSpread._)({}, message), {
            content: truncatedContent
        })
    ];
}
/**
 * Truncate a message with `parts: [...]` format (Google GenAI).
 * Keeps as many complete parts as possible, only truncating the first part if needed.
 *
 * @param message - Message with parts array
 * @param maxBytes - Maximum byte limit
 * @returns Array with truncated message, or empty array if it doesn't fit
 */ function truncatePartsMessage(message, maxBytes) {
    var parts = message.parts;
    // Calculate overhead by creating empty text parts
    var emptyParts = parts.map(function(part) {
        return withPartText(part, '');
    });
    var overhead = jsonBytes((0, _objectSpreadProps._)((0, _objectSpread._)({}, message), {
        parts: emptyParts
    }));
    var remainingBytes = maxBytes - overhead;
    if (remainingBytes <= 0) return [];
    // Include parts until we run out of space
    var includedParts = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = parts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var part = _step.value;
            var text = getPartText(part);
            var textSize = utf8Bytes(text);
            if (textSize <= remainingBytes) {
                // Part fits: include it as-is
                includedParts.push(part);
                remainingBytes -= textSize;
            } else if (includedParts.length === 0) {
                // First part doesn't fit: truncate it
                var truncated = truncateTextByBytes(text, remainingBytes);
                if (truncated) includedParts.push(withPartText(part, truncated));
                break;
            } else break;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return includedParts.length > 0 ? [
        (0, _objectSpreadProps._)((0, _objectSpread._)({}, message), {
            parts: includedParts
        })
    ] : [];
}
/**
 * Truncate a single message to fit within maxBytes.
 *
 * Supports two message formats:
 * - OpenAI/Anthropic: `{ ..., content: string }`
 * - Google GenAI: `{ ..., parts: Array<string | {text: string} | non-text> }`
 *
 * @param message - The message to truncate
 * @param maxBytes - Maximum byte limit for the message
 * @returns Array containing the truncated message, or empty array if truncation fails
 */ function truncateSingleMessage(message, maxBytes) {
    if (!message || (typeof message === "undefined" ? "undefined" : (0, _typeOf._)(message)) !== 'object') return [];
    if (isContentMessage(message)) return truncateContentMessage(message, maxBytes);
    if (isPartsMessage(message)) return truncatePartsMessage(message, maxBytes);
    // Unknown message format: cannot truncate safely
    return [];
}
/**
 * Truncate an array of messages to fit within a byte limit.
 *
 * Strategy:
 * - Keeps the newest messages (from the end of the array)
 * - Uses O(n) algorithm: precompute sizes once, then find largest suffix under budget
 * - If no complete messages fit, attempts to truncate the newest single message
 *
 * @param messages - Array of messages to truncate
 * @param maxBytes - Maximum total byte limit for all messages
 * @returns Truncated array of messages
 *
 * @example
 * ```ts
 * const messages = [msg1, msg2, msg3, msg4]; // newest is msg4
 * const truncated = truncateMessagesByBytes(messages, 10000);
 * // Returns [msg3, msg4] if they fit, or [msg4] if only it fits, etc.
 * ```
 */ function truncateMessagesByBytes(messages, maxBytes) {
    // Early return for empty or invalid input
    if (!Array.isArray(messages) || messages.length === 0) return messages;
    // Fast path: if all messages fit, return as-is
    var totalBytes = jsonBytes(messages);
    if (totalBytes <= maxBytes) return messages;
    // Precompute each message's JSON size once for efficiency
    var messageSizes = messages.map(jsonBytes);
    // Find the largest suffix (newest messages) that fits within the budget
    var bytesUsed = 0;
    var startIndex = messages.length; // Index where the kept suffix starts
    for(var i = messages.length - 1; i >= 0; i--){
        var messageSize = messageSizes[i];
        if (messageSize && bytesUsed + messageSize > maxBytes) break;
        if (messageSize) bytesUsed += messageSize;
        startIndex = i;
    }
    // If no complete messages fit, try truncating just the newest message
    if (startIndex === messages.length) {
        var newestMessage = messages[messages.length - 1];
        return truncateSingleMessage(newestMessage, maxBytes);
    }
    // Return the suffix that fits
    return messages.slice(startIndex);
}
/**
 * Truncate GenAI messages using the default byte limit.
 *
 * Convenience wrapper around `truncateMessagesByBytes` with the default limit.
 *
 * @param messages - Array of messages to truncate
 * @returns Truncated array of messages
 */ function truncateGenAiMessages(messages) {
    return truncateMessagesByBytes(messages, DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT);
}
/**
 * Truncate GenAI string input using the default byte limit.
 *
 * @param input - The string to truncate
 * @returns Truncated string
 */ function truncateGenAiStringInput(input) {
    return truncateTextByBytes(input, DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT);
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_type_of":"iFJdx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4J5xh":[function(require,module,exports,__globalThis) {
// Global Map to track tool call IDs to their corresponding spans
// This allows us to capture tool errors and link them to the correct span
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toolCallSpanMap", function() {
    return toolCallSpanMap;
});
var toolCallSpanMap = new Map();

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7ZXP3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_INTERNAL_cleanupToolCallSpan", function() {
    return _INTERNAL_cleanupToolCallSpan;
});
parcelHelpers.export(exports, "_INTERNAL_getSpanForToolCallId", function() {
    return _INTERNAL_getSpanForToolCallId;
});
parcelHelpers.export(exports, "accumulateTokensForParent", function() {
    return accumulateTokensForParent;
});
parcelHelpers.export(exports, "applyAccumulatedTokens", function() {
    return applyAccumulatedTokens;
});
parcelHelpers.export(exports, "convertAvailableToolsToJsonString", function() {
    return convertAvailableToolsToJsonString;
});
var _genAiAttributesJs = require("../ai/gen-ai-attributes.js");
var _constantsJs = require("./constants.js");
/**
 * Accumulates token data from a span to its parent in the token accumulator map.
 * This function extracts token usage from the current span and adds it to the
 * accumulated totals for its parent span.
 */ function accumulateTokensForParent(span, tokenAccumulator) {
    var parentSpanId = span.parent_span_id;
    if (!parentSpanId) return;
    var inputTokens = span.data[0, _genAiAttributesJs.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE];
    var outputTokens = span.data[0, _genAiAttributesJs.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE];
    if (typeof inputTokens === 'number' || typeof outputTokens === 'number') {
        var existing = tokenAccumulator.get(parentSpanId) || {
            inputTokens: 0,
            outputTokens: 0
        };
        if (typeof inputTokens === 'number') existing.inputTokens += inputTokens;
        if (typeof outputTokens === 'number') existing.outputTokens += outputTokens;
        tokenAccumulator.set(parentSpanId, existing);
    }
}
/**
 * Applies accumulated token data to the `gen_ai.invoke_agent` span.
 * Only immediate children of the `gen_ai.invoke_agent` span are considered,
 * since aggregation will automatically occur for each parent span.
 */ function applyAccumulatedTokens(spanOrTrace, tokenAccumulator) {
    var accumulated = tokenAccumulator.get(spanOrTrace.span_id);
    if (!accumulated || !spanOrTrace.data) return;
    if (accumulated.inputTokens > 0) spanOrTrace.data[0, _genAiAttributesJs.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = accumulated.inputTokens;
    if (accumulated.outputTokens > 0) spanOrTrace.data[0, _genAiAttributesJs.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] = accumulated.outputTokens;
    if (accumulated.inputTokens > 0 || accumulated.outputTokens > 0) spanOrTrace.data['gen_ai.usage.total_tokens'] = accumulated.inputTokens + accumulated.outputTokens;
}
/**
 * Get the span associated with a tool call ID
 */ function _INTERNAL_getSpanForToolCallId(toolCallId) {
    return (0, _constantsJs.toolCallSpanMap).get(toolCallId);
}
/**
 * Clean up the span mapping for a tool call ID
 */ function _INTERNAL_cleanupToolCallSpan(toolCallId) {
    (0, _constantsJs.toolCallSpanMap).delete(toolCallId);
}
/**
 * Convert an array of tool strings to a JSON string
 */ function convertAvailableToolsToJsonString(tools) {
    var toolObjects = tools.map(function(tool) {
        if (typeof tool === 'string') try {
            return JSON.parse(tool);
        } catch (e) {
            return tool;
        }
        return tool;
    });
    return JSON.stringify(toolObjects);
}

},{"../ai/gen-ai-attributes.js":"faK6k","./constants.js":"4J5xh","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3hzGd":[function(require,module,exports,__globalThis) {
/* eslint-disable max-lines */ /**
 * AI SDK Telemetry Attributes
 * Based on https://ai-sdk.dev/docs/ai-sdk-core/telemetry#collected-data
 */ // =============================================================================
// SHARED ATTRIBUTES
// =============================================================================
/**
 * `generateText` function - `ai.generateText` span
 * `streamText` function - `ai.streamText` span
 *
 * The prompt that was used when calling the function
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#generatetext-function
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#streamtext-function
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// =============================================================================
// PROVIDER METADATA
// =============================================================================
/**
 * OpenAI Provider Metadata
 * @see https://ai-sdk.dev/providers/ai-sdk-providers/openai
 * @see https://github.com/vercel/ai/blob/65e042afde6aad4da9d7a62526ece839eb34f9a5/packages/openai/src/openai-chat-language-model.ts#L397-L416
 * @see https://github.com/vercel/ai/blob/65e042afde6aad4da9d7a62526ece839eb34f9a5/packages/openai/src/responses/openai-responses-language-model.ts#L377C7-L384
 */ parcelHelpers.export(exports, "AI_MODEL_ID_ATTRIBUTE", function() {
    return AI_MODEL_ID_ATTRIBUTE;
});
parcelHelpers.export(exports, "AI_MODEL_PROVIDER_ATTRIBUTE", function() {
    return AI_MODEL_PROVIDER_ATTRIBUTE;
});
parcelHelpers.export(exports, "AI_PROMPT_ATTRIBUTE", function() {
    return AI_PROMPT_ATTRIBUTE;
});
parcelHelpers.export(exports, "AI_PROMPT_MESSAGES_ATTRIBUTE", function() {
    return AI_PROMPT_MESSAGES_ATTRIBUTE;
});
parcelHelpers.export(exports, "AI_PROMPT_TOOLS_ATTRIBUTE", function() {
    return AI_PROMPT_TOOLS_ATTRIBUTE;
});
parcelHelpers.export(exports, "AI_RESPONSE_OBJECT_ATTRIBUTE", function() {
    return AI_RESPONSE_OBJECT_ATTRIBUTE;
});
parcelHelpers.export(exports, "AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE", function() {
    return AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE;
});
parcelHelpers.export(exports, "AI_RESPONSE_TEXT_ATTRIBUTE", function() {
    return AI_RESPONSE_TEXT_ATTRIBUTE;
});
parcelHelpers.export(exports, "AI_RESPONSE_TOOL_CALLS_ATTRIBUTE", function() {
    return AI_RESPONSE_TOOL_CALLS_ATTRIBUTE;
});
parcelHelpers.export(exports, "AI_SCHEMA_ATTRIBUTE", function() {
    return AI_SCHEMA_ATTRIBUTE;
});
parcelHelpers.export(exports, "AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE", function() {
    return AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE;
});
parcelHelpers.export(exports, "AI_TOOL_CALL_ARGS_ATTRIBUTE", function() {
    return AI_TOOL_CALL_ARGS_ATTRIBUTE;
});
parcelHelpers.export(exports, "AI_TOOL_CALL_ID_ATTRIBUTE", function() {
    return AI_TOOL_CALL_ID_ATTRIBUTE;
});
parcelHelpers.export(exports, "AI_TOOL_CALL_NAME_ATTRIBUTE", function() {
    return AI_TOOL_CALL_NAME_ATTRIBUTE;
});
parcelHelpers.export(exports, "AI_TOOL_CALL_RESULT_ATTRIBUTE", function() {
    return AI_TOOL_CALL_RESULT_ATTRIBUTE;
});
parcelHelpers.export(exports, "AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE", function() {
    return AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE;
});
parcelHelpers.export(exports, "AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE", function() {
    return AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE;
});
parcelHelpers.export(exports, "AI_USAGE_PROMPT_TOKENS_ATTRIBUTE", function() {
    return AI_USAGE_PROMPT_TOKENS_ATTRIBUTE;
});
parcelHelpers.export(exports, "GEN_AI_RESPONSE_MODEL_ATTRIBUTE", function() {
    return GEN_AI_RESPONSE_MODEL_ATTRIBUTE;
});
parcelHelpers.export(exports, "GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE", function() {
    return GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE;
});
parcelHelpers.export(exports, "GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE", function() {
    return GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE;
});
var AI_PROMPT_ATTRIBUTE = 'ai.prompt';
/**
 * `generateObject` function - `ai.generateObject` span
 * `streamObject` function - `ai.streamObject` span
 *
 * The JSON schema version of the schema that was passed into the function
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#generateobject-function
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#streamobject-function
 */ var AI_SCHEMA_ATTRIBUTE = 'ai.schema';
/**
 * `generateObject` function - `ai.generateObject` span
 * `streamObject` function - `ai.streamObject` span
 *
 * The object that was generated (stringified JSON)
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#generateobject-function
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#streamobject-function
 */ var AI_RESPONSE_OBJECT_ATTRIBUTE = 'ai.response.object';
// =============================================================================
// GENERATETEXT FUNCTION - UNIQUE ATTRIBUTES
// =============================================================================
/**
 * `generateText` function - `ai.generateText` span
 *
 * The text that was generated
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#generatetext-function
 */ var AI_RESPONSE_TEXT_ATTRIBUTE = 'ai.response.text';
/**
 * `generateText` function - `ai.generateText` span
 *
 * The tool calls that were made as part of the generation (stringified JSON)
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#generatetext-function
 */ var AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = 'ai.response.toolCalls';
/**
 * `generateText` function - `ai.generateText.doGenerate` span
 *
 * The messages that were passed into the provider
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#generatetext-function
 */ var AI_PROMPT_MESSAGES_ATTRIBUTE = 'ai.prompt.messages';
/**
 * `generateText` function - `ai.generateText.doGenerate` span
 *
 * Array of stringified tool definitions
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#generatetext-function
 */ var AI_PROMPT_TOOLS_ATTRIBUTE = 'ai.prompt.tools';
/**
 * Basic LLM span information
 * Multiple spans
 *
 * The id of the model
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#basic-llm-span-information
 */ var AI_MODEL_ID_ATTRIBUTE = 'ai.model.id';
/**
 * Basic LLM span information
 * Multiple spans
 *
 * The provider of the model
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#basic-llm-span-information
 */ var AI_MODEL_PROVIDER_ATTRIBUTE = 'ai.model.provider';
/**
 * Basic LLM span information
 * Multiple spans
 *
 * Provider specific metadata returned with the generation response
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#basic-llm-span-information
 */ var AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE = 'ai.response.providerMetadata';
/**
 * Basic LLM span information
 * Multiple spans
 *
 * The number of cached input tokens that were used
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#basic-llm-span-information
 */ var AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE = 'ai.usage.cachedInputTokens';
/**
 * Basic LLM span information
 * Multiple spans
 *
 * The functionId that was set through `telemetry.functionId`
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#basic-llm-span-information
 */ var AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE = 'ai.telemetry.functionId';
/**
 * Basic LLM span information
 * Multiple spans
 *
 * The number of completion tokens that were used
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#basic-llm-span-information
 */ var AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE = 'ai.usage.completionTokens';
/**
 * Basic LLM span information
 * Multiple spans
 *
 * The number of prompt tokens that were used
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#basic-llm-span-information
 */ var AI_USAGE_PROMPT_TOKENS_ATTRIBUTE = 'ai.usage.promptTokens';
/**
 * Semantic Conventions for GenAI operations
 * Individual LLM call spans
 *
 * The model that was used to generate the response
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#call-llm-span-information
 */ var GEN_AI_RESPONSE_MODEL_ATTRIBUTE = 'gen_ai.response.model';
/**
 * Semantic Conventions for GenAI operations
 * Individual LLM call spans
 *
 * The number of prompt tokens that were used
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#call-llm-span-information
 */ var GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE = 'gen_ai.usage.input_tokens';
/**
 * Semantic Conventions for GenAI operations
 * Individual LLM call spans
 *
 * The number of completion tokens that were used
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#call-llm-span-information
 */ var GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE = 'gen_ai.usage.output_tokens';
// =============================================================================
// TOOL CALL SPANS
// =============================================================================
/**
 * Tool call spans
 * `ai.toolCall` span
 *
 * The name of the tool
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#tool-call-spans
 */ var AI_TOOL_CALL_NAME_ATTRIBUTE = 'ai.toolCall.name';
/**
 * Tool call spans
 * `ai.toolCall` span
 *
 * The id of the tool call
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#tool-call-spans
 */ var AI_TOOL_CALL_ID_ATTRIBUTE = 'ai.toolCall.id';
/**
 * Tool call spans
 * `ai.toolCall` span
 *
 * The parameters of the tool call
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#tool-call-spans
 */ var AI_TOOL_CALL_ARGS_ATTRIBUTE = 'ai.toolCall.args';
/**
 * Tool call spans
 * `ai.toolCall` span
 *
 * The result of the tool call
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#tool-call-spans
 */ var AI_TOOL_CALL_RESULT_ATTRIBUTE = 'ai.toolCall.result';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hXFQb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "instrumentOpenAiClient", function() {
    return instrumentOpenAiClient;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _currentScopesJs = require("../../currentScopes.js");
var _exportsJs = require("../../exports.js");
var _semanticAttributesJs = require("../../semanticAttributes.js");
var _spanstatusJs = require("../spanstatus.js");
var _traceJs = require("../trace.js");
var _genAiAttributesJs = require("../ai/gen-ai-attributes.js");
var _utilsJs = require("../ai/utils.js");
var _constantsJs = require("./constants.js");
var _streamingJs = require("./streaming.js");
var _utilsJs1 = require("./utils.js");
/**
 * Extract request attributes from method arguments
 */ function extractRequestAttributes(args, methodPath) {
    var _obj;
    var attributes = (_obj = {}, (0, _defineProperty._)(_obj, (0, _genAiAttributesJs.GEN_AI_SYSTEM_ATTRIBUTE), 'openai'), (0, _defineProperty._)(_obj, (0, _genAiAttributesJs.GEN_AI_OPERATION_NAME_ATTRIBUTE), (0, _utilsJs1.getOperationName)(methodPath)), (0, _defineProperty._)(_obj, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), 'auto.ai.openai'), _obj);
    // Chat completion API accepts web_search_options and tools as parameters
    // we append web search options to the available tools to capture all tool calls
    if (args.length > 0 && (0, _typeOf._)(args[0]) === 'object' && args[0] !== null) {
        var params = args[0];
        var tools = Array.isArray(params.tools) ? params.tools : [];
        var hasWebSearchOptions = params.web_search_options && (0, _typeOf._)(params.web_search_options) === 'object';
        var webSearchOptions = hasWebSearchOptions ? [
            (0, _objectSpread._)({
                type: 'web_search_options'
            }, params.web_search_options)
        ] : [];
        var availableTools = (0, _toConsumableArray._)(tools).concat((0, _toConsumableArray._)(webSearchOptions));
        if (availableTools.length > 0) attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = JSON.stringify(availableTools);
    }
    if (args.length > 0 && (0, _typeOf._)(args[0]) === 'object' && args[0] !== null) {
        var params1 = args[0];
        var _params_model;
        attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = (_params_model = params1.model) !== null && _params_model !== void 0 ? _params_model : 'unknown';
        if ('temperature' in params1) attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE] = params1.temperature;
        if ('top_p' in params1) attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_TOP_P_ATTRIBUTE] = params1.top_p;
        if ('frequency_penalty' in params1) attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE] = params1.frequency_penalty;
        if ('presence_penalty' in params1) attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE] = params1.presence_penalty;
        if ('stream' in params1) attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_STREAM_ATTRIBUTE] = params1.stream;
        if ('encoding_format' in params1) attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE] = params1.encoding_format;
        if ('dimensions' in params1) attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE] = params1.dimensions;
    } else attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = 'unknown';
    return attributes;
}
/**
 * Add response attributes to spans
 * This currently supports both Chat Completion and Responses API responses
 */ function addResponseAttributes(span, result, recordOutputs) {
    if (!result || (typeof result === "undefined" ? "undefined" : (0, _typeOf._)(result)) !== 'object') return;
    var response = result;
    if ((0, _utilsJs1.isChatCompletionResponse)(response)) {
        var _response_choices;
        (0, _utilsJs1.addChatCompletionAttributes)(span, response, recordOutputs);
        if (recordOutputs && ((_response_choices = response.choices) === null || _response_choices === void 0 ? void 0 : _response_choices.length)) {
            var responseTexts = response.choices.map(function(choice) {
                var _choice_message;
                return ((_choice_message = choice.message) === null || _choice_message === void 0 ? void 0 : _choice_message.content) || '';
            });
            span.setAttributes((0, _defineProperty._)({}, (0, _genAiAttributesJs.GEN_AI_RESPONSE_TEXT_ATTRIBUTE), JSON.stringify(responseTexts)));
        }
    } else if ((0, _utilsJs1.isResponsesApiResponse)(response)) {
        (0, _utilsJs1.addResponsesApiAttributes)(span, response, recordOutputs);
        if (recordOutputs && response.output_text) span.setAttributes((0, _defineProperty._)({}, (0, _genAiAttributesJs.GEN_AI_RESPONSE_TEXT_ATTRIBUTE), response.output_text));
    } else if ((0, _utilsJs1.isEmbeddingsResponse)(response)) (0, _utilsJs1.addEmbeddingsAttributes)(span, response);
}
// Extract and record AI request inputs, if present. This is intentionally separate from response attributes.
function addRequestAttributes(span, params) {
    if ('messages' in params) {
        var truncatedMessages = (0, _utilsJs.getTruncatedJsonString)(params.messages);
        span.setAttributes((0, _defineProperty._)({}, (0, _genAiAttributesJs.GEN_AI_REQUEST_MESSAGES_ATTRIBUTE), truncatedMessages));
    }
    if ('input' in params) {
        var truncatedInput = (0, _utilsJs.getTruncatedJsonString)(params.input);
        span.setAttributes((0, _defineProperty._)({}, (0, _genAiAttributesJs.GEN_AI_REQUEST_MESSAGES_ATTRIBUTE), truncatedInput));
    }
}
function getOptionsFromIntegration() {
    var _integration_options, _integration_options1;
    var scope = (0, _currentScopesJs.getCurrentScope)();
    var client = scope.getClient();
    var integration = client === null || client === void 0 ? void 0 : client.getIntegrationByName((0, _constantsJs.OPENAI_INTEGRATION_NAME));
    var shouldRecordInputsAndOutputs = integration ? Boolean(client === null || client === void 0 ? void 0 : client.getOptions().sendDefaultPii) : false;
    var _integration_options_recordInputs, _integration_options_recordOutputs;
    return {
        recordInputs: (_integration_options_recordInputs = integration === null || integration === void 0 ? void 0 : (_integration_options = integration.options) === null || _integration_options === void 0 ? void 0 : _integration_options.recordInputs) !== null && _integration_options_recordInputs !== void 0 ? _integration_options_recordInputs : shouldRecordInputsAndOutputs,
        recordOutputs: (_integration_options_recordOutputs = integration === null || integration === void 0 ? void 0 : (_integration_options1 = integration.options) === null || _integration_options1 === void 0 ? void 0 : _integration_options1.recordOutputs) !== null && _integration_options_recordOutputs !== void 0 ? _integration_options_recordOutputs : shouldRecordInputsAndOutputs
    };
}
/**
 * Instrument a method with Sentry spans
 * Following Sentry AI Agents Manual Instrumentation conventions
 * @see https://docs.sentry.io/platforms/javascript/guides/node/tracing/instrumentation/ai-agents-module/#manual-instrumentation
 */ function instrumentMethod(originalMethod, methodPath, context, options) {
    return function instrumentedMethod() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return (0, _asyncToGenerator._)(function() {
            var finalOptions, requestAttributes, model, operationName, params, isStreamRequested;
            return (0, _tsGenerator._)(this, function(_state) {
                finalOptions = options || getOptionsFromIntegration();
                requestAttributes = extractRequestAttributes(args, methodPath);
                model = requestAttributes[0, _genAiAttributesJs.GEN_AI_REQUEST_MODEL_ATTRIBUTE] || 'unknown';
                operationName = (0, _utilsJs1.getOperationName)(methodPath);
                params = args[0];
                isStreamRequested = params && (typeof params === "undefined" ? "undefined" : (0, _typeOf._)(params)) === 'object' && params.stream === true;
                if (isStreamRequested) // For streaming responses, use manual span management to properly handle the async generator lifecycle
                return [
                    2,
                    (0, _traceJs.startSpanManual)({
                        name: "".concat(operationName, " ").concat(model, " stream-response"),
                        op: (0, _utilsJs1.getSpanOperation)(methodPath),
                        attributes: requestAttributes
                    }, function(span) {
                        return (0, _asyncToGenerator._)(function() {
                            var result, _finalOptions_recordOutputs, error;
                            return (0, _tsGenerator._)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        if (finalOptions.recordInputs && args[0] && (0, _typeOf._)(args[0]) === 'object') addRequestAttributes(span, args[0]);
                                        return [
                                            4,
                                            originalMethod.apply(context, args)
                                        ];
                                    case 1:
                                        result = _state.sent();
                                        return [
                                            2,
                                            (0, _streamingJs.instrumentStream)(result, span, (_finalOptions_recordOutputs = finalOptions.recordOutputs) !== null && _finalOptions_recordOutputs !== void 0 ? _finalOptions_recordOutputs : false)
                                        ];
                                    case 2:
                                        error = _state.sent();
                                        // For streaming requests that fail before stream creation, we still want to record
                                        // them as streaming requests but end the span gracefully
                                        span.setStatus({
                                            code: (0, _spanstatusJs.SPAN_STATUS_ERROR),
                                            message: 'internal_error'
                                        });
                                        (0, _exportsJs.captureException)(error, {
                                            mechanism: {
                                                handled: false,
                                                type: 'auto.ai.openai.stream',
                                                data: {
                                                    function: methodPath
                                                }
                                            }
                                        });
                                        span.end();
                                        throw error;
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    })
                ];
                else //  Non-streaming responses
                return [
                    2,
                    (0, _traceJs.startSpan)({
                        name: "".concat(operationName, " ").concat(model),
                        op: (0, _utilsJs1.getSpanOperation)(methodPath),
                        attributes: requestAttributes
                    }, function(span) {
                        return (0, _asyncToGenerator._)(function() {
                            var result, error;
                            return (0, _tsGenerator._)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        if (finalOptions.recordInputs && args[0] && (0, _typeOf._)(args[0]) === 'object') addRequestAttributes(span, args[0]);
                                        return [
                                            4,
                                            originalMethod.apply(context, args)
                                        ];
                                    case 1:
                                        result = _state.sent();
                                        addResponseAttributes(span, result, finalOptions.recordOutputs);
                                        return [
                                            2,
                                            result
                                        ];
                                    case 2:
                                        error = _state.sent();
                                        (0, _exportsJs.captureException)(error, {
                                            mechanism: {
                                                handled: false,
                                                type: 'auto.ai.openai',
                                                data: {
                                                    function: methodPath
                                                }
                                            }
                                        });
                                        throw error;
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    })
                ];
                return [
                    2
                ];
            });
        })();
    };
}
/**
 * Create a deep proxy for OpenAI client instrumentation
 */ function createDeepProxy(target) {
    var currentPath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : '', options = arguments.length > 2 ? arguments[2] : void 0;
    return new Proxy(target, {
        get: function get(obj, prop) {
            var value = obj[prop];
            var methodPath = (0, _utilsJs1.buildMethodPath)(currentPath, String(prop));
            if (typeof value === 'function' && (0, _utilsJs1.shouldInstrument)(methodPath)) return instrumentMethod(value, methodPath, obj, options);
            if (typeof value === 'function') // Bind non-instrumented functions to preserve the original `this` context,
            // which is required for accessing private class fields (e.g. #baseURL) in OpenAI SDK v5.
            return value.bind(obj);
            if (value && (typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) === 'object') return createDeepProxy(value, methodPath, options);
            return value;
        }
    });
}
/**
 * Instrument an OpenAI client with Sentry tracing
 * Can be used across Node.js, Cloudflare Workers, and Vercel Edge
 */ function instrumentOpenAiClient(client, options) {
    return createDeepProxy(client, '', options);
}

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_to_consumable_array":"1eSZf","@swc/helpers/_/_type_of":"iFJdx","@swc/helpers/_/_ts_generator":"78Tqx","../../currentScopes.js":"3GE4v","../../exports.js":"1Xqap","../../semanticAttributes.js":"7WRPE","../spanstatus.js":"WiYVV","../trace.js":"eu0PU","../ai/gen-ai-attributes.js":"faK6k","../ai/utils.js":"2cEft","./constants.js":"7kmW5","./streaming.js":"e0fGN","./utils.js":"2mipt","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7kmW5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "INSTRUMENTED_METHODS", function() {
    return INSTRUMENTED_METHODS;
});
parcelHelpers.export(exports, "OPENAI_INTEGRATION_NAME", function() {
    return OPENAI_INTEGRATION_NAME;
});
parcelHelpers.export(exports, "RESPONSES_TOOL_CALL_EVENT_TYPES", function() {
    return RESPONSES_TOOL_CALL_EVENT_TYPES;
});
parcelHelpers.export(exports, "RESPONSE_EVENT_TYPES", function() {
    return RESPONSE_EVENT_TYPES;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var OPENAI_INTEGRATION_NAME = 'OpenAI';
// https://platform.openai.com/docs/quickstart?api-mode=responses
// https://platform.openai.com/docs/quickstart?api-mode=chat
var INSTRUMENTED_METHODS = [
    'responses.create',
    'chat.completions.create',
    'embeddings.create'
];
var RESPONSES_TOOL_CALL_EVENT_TYPES = [
    'response.output_item.added',
    'response.function_call_arguments.delta',
    'response.function_call_arguments.done',
    'response.output_item.done'
];
var RESPONSE_EVENT_TYPES = [
    'response.created',
    'response.in_progress',
    'response.failed',
    'response.completed',
    'response.incomplete',
    'response.queued',
    'response.output_text.delta'
].concat((0, _toConsumableArray._)(RESPONSES_TOOL_CALL_EVENT_TYPES));

},{"@swc/helpers/_/_to_consumable_array":"1eSZf","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"e0fGN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "instrumentStream", function() {
    return instrumentStream;
});
var _asyncIterator = require("@swc/helpers/_/_async_iterator");
var _awaitAsyncGenerator = require("@swc/helpers/_/_await_async_generator");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var _wrapAsyncGenerator = require("@swc/helpers/_/_wrap_async_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _exportsJs = require("../../exports.js");
var _spanstatusJs = require("../spanstatus.js");
var _genAiAttributesJs = require("../ai/gen-ai-attributes.js");
var _constantsJs = require("./constants.js");
var _utilsJs = require("./utils.js");
/**
 * State object used to accumulate information from a stream of OpenAI events/chunks.
 */ /**
 * Processes tool calls from a chat completion chunk delta.
 * Follows the pattern: accumulate by index, then convert to array at the end.
 *
 * @param toolCalls - Array of tool calls from the delta.
 * @param state - The current streaming state to update.
 *
 *  @see https://platform.openai.com/docs/guides/function-calling#streaming
 */ function processChatCompletionToolCalls(toolCalls, state) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = toolCalls[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var toolCall = _step.value;
            var index = toolCall.index;
            if (index === undefined || !toolCall.function) continue;
            // Initialize tool call if this is the first chunk for this index
            if (!(index in state.chatCompletionToolCalls)) state.chatCompletionToolCalls[index] = (0, _objectSpreadProps._)((0, _objectSpread._)({}, toolCall), {
                function: {
                    name: toolCall.function.name,
                    arguments: toolCall.function.arguments || ''
                }
            });
            else {
                // Accumulate function arguments from subsequent chunks
                var existingToolCall = state.chatCompletionToolCalls[index];
                if (toolCall.function.arguments && (existingToolCall === null || existingToolCall === void 0 ? void 0 : existingToolCall.function)) existingToolCall.function.arguments += toolCall.function.arguments;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
/**
 * Processes a single OpenAI ChatCompletionChunk event, updating the streaming state.
 *
 * @param chunk - The ChatCompletionChunk event to process.
 * @param state - The current streaming state to update.
 * @param recordOutputs - Whether to record output text fragments.
 */ function processChatCompletionChunk(chunk, state, recordOutputs) {
    var _chunk_id;
    state.responseId = (_chunk_id = chunk.id) !== null && _chunk_id !== void 0 ? _chunk_id : state.responseId;
    var _chunk_model;
    state.responseModel = (_chunk_model = chunk.model) !== null && _chunk_model !== void 0 ? _chunk_model : state.responseModel;
    var _chunk_created;
    state.responseTimestamp = (_chunk_created = chunk.created) !== null && _chunk_created !== void 0 ? _chunk_created : state.responseTimestamp;
    if (chunk.usage) {
        // For stream responses, the input tokens remain constant across all events in the stream.
        // Output tokens, however, are only finalized in the last event.
        // Since we can't guarantee that the last event will include usage data or even be a typed event,
        // we update the output token values on every event that includes them.
        // This ensures that output token usage is always set, even if the final event lacks it.
        state.promptTokens = chunk.usage.prompt_tokens;
        state.completionTokens = chunk.usage.completion_tokens;
        state.totalTokens = chunk.usage.total_tokens;
    }
    var _chunk_choices;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = ((_chunk_choices = chunk.choices) !== null && _chunk_choices !== void 0 ? _chunk_choices : [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var choice = _step.value;
            if (recordOutputs) {
                var _choice_delta, _choice_delta1;
                if ((_choice_delta = choice.delta) === null || _choice_delta === void 0 ? void 0 : _choice_delta.content) state.responseTexts.push(choice.delta.content);
                // Handle tool calls from delta
                if ((_choice_delta1 = choice.delta) === null || _choice_delta1 === void 0 ? void 0 : _choice_delta1.tool_calls) processChatCompletionToolCalls(choice.delta.tool_calls, state);
            }
            if (choice.finish_reason) state.finishReasons.push(choice.finish_reason);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
/**
 * Processes a single OpenAI Responses API streaming event, updating the streaming state and span.
 *
 * @param streamEvent - The event to process (may be an error or unknown object).
 * @param state - The current streaming state to update.
 * @param recordOutputs - Whether to record output text fragments.
 * @param span - The span to update with error status if needed.
 */ function processResponsesApiEvent(streamEvent, state, recordOutputs, span) {
    if (!(streamEvent && (typeof streamEvent === "undefined" ? "undefined" : (0, _typeOf._)(streamEvent)) === 'object')) {
        state.eventTypes.push('unknown:non-object');
        return;
    }
    if ((0, _instanceof._)(streamEvent, Error)) {
        span.setStatus({
            code: (0, _spanstatusJs.SPAN_STATUS_ERROR),
            message: 'internal_error'
        });
        (0, _exportsJs.captureException)(streamEvent, {
            mechanism: {
                handled: false,
                type: 'auto.ai.openai.stream-response'
            }
        });
        return;
    }
    if (!('type' in streamEvent)) return;
    var event = streamEvent;
    if (!(0, _constantsJs.RESPONSE_EVENT_TYPES).includes(event.type)) {
        state.eventTypes.push(event.type);
        return;
    }
    // Handle output text delta
    if (recordOutputs) {
        // Handle tool call events for Responses API
        if (event.type === 'response.output_item.done' && 'item' in event) state.responsesApiToolCalls.push(event.item);
        if (event.type === 'response.output_text.delta' && 'delta' in event && event.delta) {
            state.responseTexts.push(event.delta);
            return;
        }
    }
    if ('response' in event) {
        var response = event.response;
        var _response_id;
        state.responseId = (_response_id = response.id) !== null && _response_id !== void 0 ? _response_id : state.responseId;
        var _response_model;
        state.responseModel = (_response_model = response.model) !== null && _response_model !== void 0 ? _response_model : state.responseModel;
        var _response_created_at;
        state.responseTimestamp = (_response_created_at = response.created_at) !== null && _response_created_at !== void 0 ? _response_created_at : state.responseTimestamp;
        if (response.usage) {
            // For stream responses, the input tokens remain constant across all events in the stream.
            // Output tokens, however, are only finalized in the last event.
            // Since we can't guarantee that the last event will include usage data or even be a typed event,
            // we update the output token values on every event that includes them.
            // This ensures that output token usage is always set, even if the final event lacks it.
            state.promptTokens = response.usage.input_tokens;
            state.completionTokens = response.usage.output_tokens;
            state.totalTokens = response.usage.total_tokens;
        }
        if (response.status) state.finishReasons.push(response.status);
        if (recordOutputs && response.output_text) state.responseTexts.push(response.output_text);
    }
}
/**
 * Instruments a stream of OpenAI events, updating the provided span with relevant attributes and
 * optionally recording output text. This function yields each event from the input stream as it is processed.
 *
 * @template T - The type of events in the stream.
 * @param stream - The async iterable stream of events to instrument.
 * @param span - The span to add attributes to and to finish at the end of the stream.
 * @param recordOutputs - Whether to record output text fragments in the span.
 * @returns An async generator yielding each event from the input stream.
 */ function instrumentStream(stream, span, recordOutputs) {
    return (0, _wrapAsyncGenerator._)(function() {
        var state, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, event, err, chatCompletionToolCallsArray, allToolCalls;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    state = {
                        eventTypes: [],
                        responseTexts: [],
                        finishReasons: [],
                        responseId: '',
                        responseModel: '',
                        responseTimestamp: 0,
                        promptTokens: undefined,
                        completionTokens: undefined,
                        totalTokens: undefined,
                        chatCompletionToolCalls: {},
                        responsesApiToolCalls: []
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        ,
                        15,
                        16
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        8,
                        9,
                        14
                    ]);
                    _iterator = (0, _asyncIterator._)(stream);
                    _state.label = 3;
                case 3:
                    return [
                        4,
                        (0, _awaitAsyncGenerator._)(_iterator.next())
                    ];
                case 4:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        7
                    ];
                    _value = _step.value;
                    event = _value;
                    if ((0, _utilsJs.isChatCompletionChunk)(event)) processChatCompletionChunk(event, state, recordOutputs);
                    else if ((0, _utilsJs.isResponsesApiStreamEvent)(event)) processResponsesApiEvent(event, state, recordOutputs, span);
                    return [
                        4,
                        event
                    ];
                case 5:
                    _state.sent();
                    _state.label = 6;
                case 6:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        3
                    ];
                case 7:
                    return [
                        3,
                        14
                    ];
                case 8:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        14
                    ];
                case 9:
                    _state.trys.push([
                        9,
                        ,
                        12,
                        13
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                        3,
                        11
                    ];
                    return [
                        4,
                        (0, _awaitAsyncGenerator._)(_iterator.return())
                    ];
                case 10:
                    _state.sent();
                    _state.label = 11;
                case 11:
                    return [
                        3,
                        13
                    ];
                case 12:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 13:
                    return [
                        7
                    ];
                case 14:
                    return [
                        3,
                        16
                    ];
                case 15:
                    (0, _utilsJs.setCommonResponseAttributes)(span, state.responseId, state.responseModel, state.responseTimestamp);
                    (0, _utilsJs.setTokenUsageAttributes)(span, state.promptTokens, state.completionTokens, state.totalTokens);
                    span.setAttributes((0, _defineProperty._)({}, (0, _genAiAttributesJs.GEN_AI_RESPONSE_STREAMING_ATTRIBUTE), true));
                    if (state.finishReasons.length) span.setAttributes((0, _defineProperty._)({}, (0, _genAiAttributesJs.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE), JSON.stringify(state.finishReasons)));
                    if (recordOutputs && state.responseTexts.length) span.setAttributes((0, _defineProperty._)({}, (0, _genAiAttributesJs.GEN_AI_RESPONSE_TEXT_ATTRIBUTE), state.responseTexts.join('')));
                    // Set tool calls attribute if any were accumulated
                    chatCompletionToolCallsArray = Object.values(state.chatCompletionToolCalls);
                    allToolCalls = (0, _toConsumableArray._)(chatCompletionToolCallsArray).concat((0, _toConsumableArray._)(state.responsesApiToolCalls));
                    if (allToolCalls.length > 0) span.setAttributes((0, _defineProperty._)({}, (0, _genAiAttributesJs.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE), JSON.stringify(allToolCalls)));
                    span.end();
                    return [
                        7
                    ];
                case 16:
                    return [
                        2
                    ];
            }
        });
    })();
}

},{"@swc/helpers/_/_async_iterator":"6B313","@swc/helpers/_/_await_async_generator":"ZoK6H","@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_to_consumable_array":"1eSZf","@swc/helpers/_/_type_of":"iFJdx","@swc/helpers/_/_wrap_async_generator":"l6OQn","@swc/helpers/_/_ts_generator":"78Tqx","../../exports.js":"1Xqap","../spanstatus.js":"WiYVV","../ai/gen-ai-attributes.js":"faK6k","./constants.js":"7kmW5","./utils.js":"2mipt","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2mipt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addChatCompletionAttributes", function() {
    return addChatCompletionAttributes;
});
parcelHelpers.export(exports, "addEmbeddingsAttributes", function() {
    return addEmbeddingsAttributes;
});
parcelHelpers.export(exports, "addResponsesApiAttributes", function() {
    return addResponsesApiAttributes;
});
parcelHelpers.export(exports, "buildMethodPath", function() {
    return buildMethodPath;
});
parcelHelpers.export(exports, "getOperationName", function() {
    return getOperationName;
});
parcelHelpers.export(exports, "getSpanOperation", function() {
    return getSpanOperation;
});
parcelHelpers.export(exports, "isChatCompletionChunk", function() {
    return isChatCompletionChunk;
});
parcelHelpers.export(exports, "isChatCompletionResponse", function() {
    return isChatCompletionResponse;
});
parcelHelpers.export(exports, "isEmbeddingsResponse", function() {
    return isEmbeddingsResponse;
});
parcelHelpers.export(exports, "isResponsesApiResponse", function() {
    return isResponsesApiResponse;
});
parcelHelpers.export(exports, "isResponsesApiStreamEvent", function() {
    return isResponsesApiStreamEvent;
});
parcelHelpers.export(exports, "setCommonResponseAttributes", function() {
    return setCommonResponseAttributes;
});
parcelHelpers.export(exports, "setTokenUsageAttributes", function() {
    return setTokenUsageAttributes;
});
parcelHelpers.export(exports, "shouldInstrument", function() {
    return shouldInstrument;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _typeOf = require("@swc/helpers/_/_type_of");
var _genAiAttributesJs = require("../ai/gen-ai-attributes.js");
var _constantsJs = require("./constants.js");
/**
 * Maps OpenAI method paths to Sentry operation names
 */ function getOperationName(methodPath) {
    if (methodPath.includes('chat.completions')) return (0, _genAiAttributesJs.OPENAI_OPERATIONS).CHAT;
    if (methodPath.includes('responses')) return (0, _genAiAttributesJs.OPENAI_OPERATIONS).RESPONSES;
    if (methodPath.includes('embeddings')) return (0, _genAiAttributesJs.OPENAI_OPERATIONS).EMBEDDINGS;
    return methodPath.split('.').pop() || 'unknown';
}
/**
 * Get the span operation for OpenAI methods
 * Following Sentry's convention: "gen_ai.{operation_name}"
 */ function getSpanOperation(methodPath) {
    return "gen_ai.".concat(getOperationName(methodPath));
}
/**
 * Check if a method path should be instrumented
 */ function shouldInstrument(methodPath) {
    return (0, _constantsJs.INSTRUMENTED_METHODS).includes(methodPath);
}
/**
 * Build method path from current traversal
 */ function buildMethodPath(currentPath, prop) {
    return currentPath ? "".concat(currentPath, ".").concat(prop) : prop;
}
/**
 * Check if response is a Chat Completion object
 */ function isChatCompletionResponse(response) {
    return response !== null && (typeof response === "undefined" ? "undefined" : (0, _typeOf._)(response)) === 'object' && 'object' in response && response.object === 'chat.completion';
}
/**
 * Check if response is a Responses API object
 */ function isResponsesApiResponse(response) {
    return response !== null && (typeof response === "undefined" ? "undefined" : (0, _typeOf._)(response)) === 'object' && 'object' in response && response.object === 'response';
}
/**
 * Check if response is an Embeddings API object
 */ function isEmbeddingsResponse(response) {
    if (response === null || (typeof response === "undefined" ? "undefined" : (0, _typeOf._)(response)) !== 'object' || !('object' in response)) return false;
    var responseObject = response;
    return responseObject.object === 'list' && typeof responseObject.model === 'string' && responseObject.model.toLowerCase().includes('embedding');
}
/**
 * Check if streaming event is from the Responses API
 */ function isResponsesApiStreamEvent(event) {
    return event !== null && (typeof event === "undefined" ? "undefined" : (0, _typeOf._)(event)) === 'object' && 'type' in event && typeof event.type === 'string' && event.type.startsWith('response.');
}
/**
 * Check if streaming event is a chat completion chunk
 */ function isChatCompletionChunk(event) {
    return event !== null && (typeof event === "undefined" ? "undefined" : (0, _typeOf._)(event)) === 'object' && 'object' in event && event.object === 'chat.completion.chunk';
}
/**
 * Add attributes for Chat Completion responses
 */ function addChatCompletionAttributes(span, response, recordOutputs) {
    setCommonResponseAttributes(span, response.id, response.model, response.created);
    if (response.usage) setTokenUsageAttributes(span, response.usage.prompt_tokens, response.usage.completion_tokens, response.usage.total_tokens);
    if (Array.isArray(response.choices)) {
        var finishReasons = response.choices.map(function(choice) {
            return choice.finish_reason;
        }).filter(function(reason) {
            return reason !== null;
        });
        if (finishReasons.length > 0) span.setAttributes((0, _defineProperty._)({}, (0, _genAiAttributesJs.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE), JSON.stringify(finishReasons)));
        // Extract tool calls from all choices (only if recordOutputs is true)
        if (recordOutputs) {
            var toolCalls = response.choices.map(function(choice) {
                var _choice_message;
                return (_choice_message = choice.message) === null || _choice_message === void 0 ? void 0 : _choice_message.tool_calls;
            }).filter(function(calls) {
                return Array.isArray(calls) && calls.length > 0;
            }).flat();
            if (toolCalls.length > 0) span.setAttributes((0, _defineProperty._)({}, (0, _genAiAttributesJs.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE), JSON.stringify(toolCalls)));
        }
    }
}
/**
 * Add attributes for Responses API responses
 */ function addResponsesApiAttributes(span, response, recordOutputs) {
    setCommonResponseAttributes(span, response.id, response.model, response.created_at);
    if (response.status) span.setAttributes((0, _defineProperty._)({}, (0, _genAiAttributesJs.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE), JSON.stringify([
        response.status
    ])));
    if (response.usage) setTokenUsageAttributes(span, response.usage.input_tokens, response.usage.output_tokens, response.usage.total_tokens);
    // Extract function calls from output (only if recordOutputs is true)
    if (recordOutputs) {
        var responseWithOutput = response;
        if (Array.isArray(responseWithOutput.output) && responseWithOutput.output.length > 0) {
            // Filter for function_call type objects in the output array
            var functionCalls = responseWithOutput.output.filter(function(item) {
                return (typeof item === "undefined" ? "undefined" : (0, _typeOf._)(item)) === 'object' && item !== null && item.type === 'function_call';
            });
            if (functionCalls.length > 0) span.setAttributes((0, _defineProperty._)({}, (0, _genAiAttributesJs.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE), JSON.stringify(functionCalls)));
        }
    }
}
/**
 * Add attributes for Embeddings API responses
 */ function addEmbeddingsAttributes(span, response) {
    var _obj;
    span.setAttributes((_obj = {}, (0, _defineProperty._)(_obj, (0, _genAiAttributesJs.OPENAI_RESPONSE_MODEL_ATTRIBUTE), response.model), (0, _defineProperty._)(_obj, (0, _genAiAttributesJs.GEN_AI_RESPONSE_MODEL_ATTRIBUTE), response.model), _obj));
    if (response.usage) setTokenUsageAttributes(span, response.usage.prompt_tokens, undefined, response.usage.total_tokens);
}
/**
 * Set token usage attributes
 * @param span - The span to add attributes to
 * @param promptTokens - The number of prompt tokens
 * @param completionTokens - The number of completion tokens
 * @param totalTokens - The number of total tokens
 */ function setTokenUsageAttributes(span, promptTokens, completionTokens, totalTokens) {
    var _obj;
    if (promptTokens !== undefined) span.setAttributes((_obj = {}, (0, _defineProperty._)(_obj, (0, _genAiAttributesJs.OPENAI_USAGE_PROMPT_TOKENS_ATTRIBUTE), promptTokens), (0, _defineProperty._)(_obj, (0, _genAiAttributesJs.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE), promptTokens), _obj));
    var _obj1;
    if (completionTokens !== undefined) span.setAttributes((_obj1 = {}, (0, _defineProperty._)(_obj1, (0, _genAiAttributesJs.OPENAI_USAGE_COMPLETION_TOKENS_ATTRIBUTE), completionTokens), (0, _defineProperty._)(_obj1, (0, _genAiAttributesJs.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE), completionTokens), _obj1));
    if (totalTokens !== undefined) span.setAttributes((0, _defineProperty._)({}, (0, _genAiAttributesJs.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE), totalTokens));
}
/**
 * Set common response attributes
 * @param span - The span to add attributes to
 * @param id - The response id
 * @param model - The response model
 * @param timestamp - The response timestamp
 */ function setCommonResponseAttributes(span, id, model, timestamp) {
    var _obj;
    span.setAttributes((_obj = {}, (0, _defineProperty._)(_obj, (0, _genAiAttributesJs.OPENAI_RESPONSE_ID_ATTRIBUTE), id), (0, _defineProperty._)(_obj, (0, _genAiAttributesJs.GEN_AI_RESPONSE_ID_ATTRIBUTE), id), _obj));
    var _obj1;
    span.setAttributes((_obj1 = {}, (0, _defineProperty._)(_obj1, (0, _genAiAttributesJs.OPENAI_RESPONSE_MODEL_ATTRIBUTE), model), (0, _defineProperty._)(_obj1, (0, _genAiAttributesJs.GEN_AI_RESPONSE_MODEL_ATTRIBUTE), model), _obj1));
    span.setAttributes((0, _defineProperty._)({}, (0, _genAiAttributesJs.OPENAI_RESPONSE_TIMESTAMP_ATTRIBUTE), new Date(timestamp * 1000).toISOString()));
}

},{"@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_type_of":"iFJdx","../ai/gen-ai-attributes.js":"faK6k","./constants.js":"7kmW5","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fkwxA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "instrumentAnthropicAiClient", function() {
    return instrumentAnthropicAiClient;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _typeOf = require("@swc/helpers/_/_type_of");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _currentScopesJs = require("../../currentScopes.js");
var _exportsJs = require("../../exports.js");
var _semanticAttributesJs = require("../../semanticAttributes.js");
var _spanstatusJs = require("../spanstatus.js");
var _traceJs = require("../trace.js");
var _handleCallbackErrorsJs = require("../../utils/handleCallbackErrors.js");
var _genAiAttributesJs = require("../ai/gen-ai-attributes.js");
var _utilsJs = require("../ai/utils.js");
var _streamingJs = require("./streaming.js");
var _utilsJs1 = require("./utils.js");
/**
 * Extract request attributes from method arguments
 */ function extractRequestAttributes(args, methodPath) {
    var _obj;
    var attributes = (_obj = {}, (0, _defineProperty._)(_obj, (0, _genAiAttributesJs.GEN_AI_SYSTEM_ATTRIBUTE), 'anthropic'), (0, _defineProperty._)(_obj, (0, _genAiAttributesJs.GEN_AI_OPERATION_NAME_ATTRIBUTE), (0, _utilsJs.getFinalOperationName)(methodPath)), (0, _defineProperty._)(_obj, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), 'auto.ai.anthropic'), _obj);
    if (args.length > 0 && (0, _typeOf._)(args[0]) === 'object' && args[0] !== null) {
        var params = args[0];
        if (params.tools && Array.isArray(params.tools)) attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = JSON.stringify(params.tools);
        var _params_model;
        attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = (_params_model = params.model) !== null && _params_model !== void 0 ? _params_model : 'unknown';
        if ('temperature' in params) attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE] = params.temperature;
        if ('top_p' in params) attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_TOP_P_ATTRIBUTE] = params.top_p;
        if ('stream' in params) attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_STREAM_ATTRIBUTE] = params.stream;
        if ('top_k' in params) attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_TOP_K_ATTRIBUTE] = params.top_k;
        if ('frequency_penalty' in params) attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE] = params.frequency_penalty;
        if ('max_tokens' in params) attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE] = params.max_tokens;
    } else if (methodPath === 'models.retrieve' || methodPath === 'models.get') // models.retrieve(model-id) and models.get(model-id)
    attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = args[0];
    else attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = 'unknown';
    return attributes;
}
/**
 * Add private request attributes to spans.
 * This is only recorded if recordInputs is true.
 */ function addPrivateRequestAttributes(span, params) {
    if ('messages' in params) {
        var truncatedMessages = (0, _utilsJs.getTruncatedJsonString)(params.messages);
        span.setAttributes((0, _defineProperty._)({}, (0, _genAiAttributesJs.GEN_AI_REQUEST_MESSAGES_ATTRIBUTE), truncatedMessages));
    }
    if ('input' in params) {
        var truncatedInput = (0, _utilsJs.getTruncatedJsonString)(params.input);
        span.setAttributes((0, _defineProperty._)({}, (0, _genAiAttributesJs.GEN_AI_REQUEST_MESSAGES_ATTRIBUTE), truncatedInput));
    }
    if ('prompt' in params) span.setAttributes((0, _defineProperty._)({}, (0, _genAiAttributesJs.GEN_AI_PROMPT_ATTRIBUTE), JSON.stringify(params.prompt)));
}
/**
 * Add content attributes when recordOutputs is enabled
 */ function addContentAttributes(span, response) {
    // Messages.create
    if ('content' in response) {
        if (Array.isArray(response.content)) {
            span.setAttributes((0, _defineProperty._)({}, (0, _genAiAttributesJs.GEN_AI_RESPONSE_TEXT_ATTRIBUTE), response.content.map(function(item) {
                return item.text;
            }).filter(function(text) {
                return !!text;
            }).join('')));
            var toolCalls = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = response.content[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var item = _step.value;
                    if (item.type === 'tool_use' || item.type === 'server_tool_use') toolCalls.push(item);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            if (toolCalls.length > 0) span.setAttributes((0, _defineProperty._)({}, (0, _genAiAttributesJs.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE), JSON.stringify(toolCalls)));
        }
    }
    // Completions.create
    if ('completion' in response) span.setAttributes((0, _defineProperty._)({}, (0, _genAiAttributesJs.GEN_AI_RESPONSE_TEXT_ATTRIBUTE), response.completion));
    // Models.countTokens
    if ('input_tokens' in response) span.setAttributes((0, _defineProperty._)({}, (0, _genAiAttributesJs.GEN_AI_RESPONSE_TEXT_ATTRIBUTE), JSON.stringify(response.input_tokens)));
}
/**
 * Add basic metadata attributes from the response
 */ function addMetadataAttributes(span, response) {
    if ('id' in response && 'model' in response) {
        var _obj;
        span.setAttributes((_obj = {}, (0, _defineProperty._)(_obj, (0, _genAiAttributesJs.GEN_AI_RESPONSE_ID_ATTRIBUTE), response.id), (0, _defineProperty._)(_obj, (0, _genAiAttributesJs.GEN_AI_RESPONSE_MODEL_ATTRIBUTE), response.model), _obj));
        if ('created' in response && typeof response.created === 'number') span.setAttributes((0, _defineProperty._)({}, (0, _genAiAttributesJs.ANTHROPIC_AI_RESPONSE_TIMESTAMP_ATTRIBUTE), new Date(response.created * 1000).toISOString()));
        if ('created_at' in response && typeof response.created_at === 'number') span.setAttributes((0, _defineProperty._)({}, (0, _genAiAttributesJs.ANTHROPIC_AI_RESPONSE_TIMESTAMP_ATTRIBUTE), new Date(response.created_at * 1000).toISOString()));
        if ('usage' in response && response.usage) (0, _utilsJs.setTokenUsageAttributes)(span, response.usage.input_tokens, response.usage.output_tokens, response.usage.cache_creation_input_tokens, response.usage.cache_read_input_tokens);
    }
}
/**
 * Add response attributes to spans
 */ function addResponseAttributes(span, response, recordOutputs) {
    if (!response || (typeof response === "undefined" ? "undefined" : (0, _typeOf._)(response)) !== 'object') return;
    // capture error, do not add attributes if error (they shouldn't exist)
    if ('type' in response && response.type === 'error') {
        (0, _utilsJs1.handleResponseError)(span, response);
        return;
    }
    // Private response attributes that are only recorded if recordOutputs is true.
    if (recordOutputs) addContentAttributes(span, response);
    // Add basic metadata attributes
    addMetadataAttributes(span, response);
}
/**
 * Handle common error catching and reporting for streaming requests
 */ function handleStreamingError(error, span, methodPath) {
    (0, _exportsJs.captureException)(error, {
        mechanism: {
            handled: false,
            type: 'auto.ai.anthropic',
            data: {
                function: methodPath
            }
        }
    });
    if (span.isRecording()) {
        span.setStatus({
            code: (0, _spanstatusJs.SPAN_STATUS_ERROR),
            message: 'internal_error'
        });
        span.end();
    }
    throw error;
}
/**
 * Handle streaming cases with common logic
 */ function handleStreamingRequest(originalMethod, target, context, args, requestAttributes, operationName, methodPath, params, options, isStreamRequested, isStreamingMethod) {
    var _requestAttributes_GEN_AI_REQUEST_MODEL_ATTRIBUTE;
    var model = (_requestAttributes_GEN_AI_REQUEST_MODEL_ATTRIBUTE = requestAttributes[0, _genAiAttributesJs.GEN_AI_REQUEST_MODEL_ATTRIBUTE]) !== null && _requestAttributes_GEN_AI_REQUEST_MODEL_ATTRIBUTE !== void 0 ? _requestAttributes_GEN_AI_REQUEST_MODEL_ATTRIBUTE : 'unknown';
    var spanConfig = {
        name: "".concat(operationName, " ").concat(model, " stream-response"),
        op: (0, _utilsJs.getSpanOperation)(methodPath),
        attributes: requestAttributes
    };
    // messages.stream() always returns a sync MessageStream, even with stream: true param
    if (isStreamRequested && !isStreamingMethod) return (0, _traceJs.startSpanManual)(spanConfig, function(span) {
        return (0, _asyncToGenerator._)(function() {
            var result, _options_recordOutputs, error;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        if (options.recordInputs && params) addPrivateRequestAttributes(span, params);
                        return [
                            4,
                            originalMethod.apply(context, args)
                        ];
                    case 1:
                        result = _state.sent();
                        return [
                            2,
                            (0, _streamingJs.instrumentAsyncIterableStream)(result, span, (_options_recordOutputs = options.recordOutputs) !== null && _options_recordOutputs !== void 0 ? _options_recordOutputs : false)
                        ];
                    case 2:
                        error = _state.sent();
                        return [
                            2,
                            handleStreamingError(error, span, methodPath)
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    });
    else return (0, _traceJs.startSpanManual)(spanConfig, function(span) {
        try {
            if (options.recordInputs && params) addPrivateRequestAttributes(span, params);
            var messageStream = target.apply(context, args);
            var _options_recordOutputs;
            return (0, _streamingJs.instrumentMessageStream)(messageStream, span, (_options_recordOutputs = options.recordOutputs) !== null && _options_recordOutputs !== void 0 ? _options_recordOutputs : false);
        } catch (error) {
            return handleStreamingError(error, span, methodPath);
        }
    });
}
/**
 * Instrument a method with Sentry spans
 * Following Sentry AI Agents Manual Instrumentation conventions
 * @see https://docs.sentry.io/platforms/javascript/guides/node/tracing/instrumentation/ai-agents-module/#manual-instrumentation
 */ function instrumentMethod(originalMethod, methodPath, context, options) {
    return new Proxy(originalMethod, {
        apply: function apply(target, thisArg, args) {
            var requestAttributes = extractRequestAttributes(args, methodPath);
            var _requestAttributes_GEN_AI_REQUEST_MODEL_ATTRIBUTE;
            var model = (_requestAttributes_GEN_AI_REQUEST_MODEL_ATTRIBUTE = requestAttributes[0, _genAiAttributesJs.GEN_AI_REQUEST_MODEL_ATTRIBUTE]) !== null && _requestAttributes_GEN_AI_REQUEST_MODEL_ATTRIBUTE !== void 0 ? _requestAttributes_GEN_AI_REQUEST_MODEL_ATTRIBUTE : 'unknown';
            var operationName = (0, _utilsJs.getFinalOperationName)(methodPath);
            var params = (0, _typeOf._)(args[0]) === 'object' ? args[0] : undefined;
            var isStreamRequested = Boolean(params === null || params === void 0 ? void 0 : params.stream);
            var isStreamingMethod = methodPath === 'messages.stream';
            if (isStreamRequested || isStreamingMethod) return handleStreamingRequest(originalMethod, target, context, args, requestAttributes, operationName, methodPath, params, options, isStreamRequested, isStreamingMethod);
            return (0, _traceJs.startSpan)({
                name: "".concat(operationName, " ").concat(model),
                op: (0, _utilsJs.getSpanOperation)(methodPath),
                attributes: requestAttributes
            }, function(span) {
                if (options.recordInputs && params) addPrivateRequestAttributes(span, params);
                return (0, _handleCallbackErrorsJs.handleCallbackErrors)(function() {
                    return target.apply(context, args);
                }, function(error) {
                    (0, _exportsJs.captureException)(error, {
                        mechanism: {
                            handled: false,
                            type: 'auto.ai.anthropic',
                            data: {
                                function: methodPath
                            }
                        }
                    });
                }, function() {}, function(result) {
                    return addResponseAttributes(span, result, options.recordOutputs);
                });
            });
        }
    });
}
/**
 * Create a deep proxy for Anthropic AI client instrumentation
 */ function createDeepProxy(target) {
    var currentPath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : '', options = arguments.length > 2 ? arguments[2] : void 0;
    return new Proxy(target, {
        get: function get(obj, prop) {
            var value = obj[prop];
            var methodPath = (0, _utilsJs.buildMethodPath)(currentPath, String(prop));
            if (typeof value === 'function' && (0, _utilsJs1.shouldInstrument)(methodPath)) return instrumentMethod(value, methodPath, obj, options);
            if (typeof value === 'function') // Bind non-instrumented functions to preserve the original `this` context,
            return value.bind(obj);
            if (value && (typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) === 'object') return createDeepProxy(value, methodPath, options);
            return value;
        }
    });
}
/**
 * Instrument an Anthropic AI client with Sentry tracing
 * Can be used across Node.js, Cloudflare Workers, and Vercel Edge
 *
 * @template T - The type of the client that extends object
 * @param client - The Anthropic AI client to instrument
 * @param options - Optional configuration for recording inputs and outputs
 * @returns The instrumented client with the same type as the input
 */ function instrumentAnthropicAiClient(anthropicAiClient, options) {
    var _getClient;
    var sendDefaultPii = Boolean((_getClient = (0, _currentScopesJs.getClient)()) === null || _getClient === void 0 ? void 0 : _getClient.getOptions().sendDefaultPii);
    var _options = (0, _objectSpread._)({
        recordInputs: sendDefaultPii,
        recordOutputs: sendDefaultPii
    }, options);
    return createDeepProxy(anthropicAiClient, '', _options);
}

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_type_of":"iFJdx","@swc/helpers/_/_ts_generator":"78Tqx","../../currentScopes.js":"3GE4v","../../exports.js":"1Xqap","../../semanticAttributes.js":"7WRPE","../spanstatus.js":"WiYVV","../trace.js":"eu0PU","../../utils/handleCallbackErrors.js":"g30DX","../ai/gen-ai-attributes.js":"faK6k","../ai/utils.js":"2cEft","./streaming.js":"243cd","./utils.js":"aUlsl","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"243cd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "instrumentAsyncIterableStream", function() {
    return instrumentAsyncIterableStream;
});
parcelHelpers.export(exports, "instrumentMessageStream", function() {
    return instrumentMessageStream;
});
var _asyncIterator = require("@swc/helpers/_/_async_iterator");
var _awaitAsyncGenerator = require("@swc/helpers/_/_await_async_generator");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _typeOf = require("@swc/helpers/_/_type_of");
var _wrapAsyncGenerator = require("@swc/helpers/_/_wrap_async_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _exportsJs = require("../../exports.js");
var _spanstatusJs = require("../spanstatus.js");
var _genAiAttributesJs = require("../ai/gen-ai-attributes.js");
var _utilsJs = require("../ai/utils.js");
/**
 * State object used to accumulate information from a stream of Anthropic AI events.
 */ /**
 * Checks if an event is an error event
 * @param event - The event to process
 * @param state - The state of the streaming process
 * @param recordOutputs - Whether to record outputs
 * @param span - The span to update
 * @returns Whether an error occurred
 */ function isErrorEvent(event, span) {
    if ('type' in event && typeof event.type === 'string') // If the event is an error, set the span status and capture the error
    // These error events are not rejected by the API by default, but are sent as metadata of the response
    {
        if (event.type === 'error') {
            var _event_error;
            var _event_error_type;
            span.setStatus({
                code: (0, _spanstatusJs.SPAN_STATUS_ERROR),
                message: (_event_error_type = (_event_error = event.error) === null || _event_error === void 0 ? void 0 : _event_error.type) !== null && _event_error_type !== void 0 ? _event_error_type : 'internal_error'
            });
            (0, _exportsJs.captureException)(event.error, {
                mechanism: {
                    handled: false,
                    type: 'auto.ai.anthropic.anthropic_error'
                }
            });
            return true;
        }
    }
    return false;
}
/**
 * Processes the message metadata of an event
 * @param event - The event to process
 * @param state - The state of the streaming process
 */ function handleMessageMetadata(event, state) {
    // The token counts shown in the usage field of the message_delta event are cumulative.
    // @see https://docs.anthropic.com/en/docs/build-with-claude/streaming#event-types
    if (event.type === 'message_delta' && event.usage) {
        if ('output_tokens' in event.usage && typeof event.usage.output_tokens === 'number') state.completionTokens = event.usage.output_tokens;
    }
    if (event.message) {
        var message = event.message;
        if (message.id) state.responseId = message.id;
        if (message.model) state.responseModel = message.model;
        if (message.stop_reason) state.finishReasons.push(message.stop_reason);
        if (message.usage) {
            if (typeof message.usage.input_tokens === 'number') state.promptTokens = message.usage.input_tokens;
            if (typeof message.usage.cache_creation_input_tokens === 'number') state.cacheCreationInputTokens = message.usage.cache_creation_input_tokens;
            if (typeof message.usage.cache_read_input_tokens === 'number') state.cacheReadInputTokens = message.usage.cache_read_input_tokens;
        }
    }
}
/**
 * Handle start of a content block (e.g., tool_use)
 */ function handleContentBlockStart(event, state) {
    if (event.type !== 'content_block_start' || typeof event.index !== 'number' || !event.content_block) return;
    if (event.content_block.type === 'tool_use' || event.content_block.type === 'server_tool_use') state.activeToolBlocks[event.index] = {
        id: event.content_block.id,
        name: event.content_block.name,
        inputJsonParts: []
    };
}
/**
 * Handle deltas of a content block, including input_json_delta for tool_use
 */ function handleContentBlockDelta(event, state, recordOutputs) {
    if (event.type !== 'content_block_delta' || !event.delta) return;
    // Accumulate tool_use input JSON deltas only when we have an index and an active tool block
    if (typeof event.index === 'number' && 'partial_json' in event.delta && typeof event.delta.partial_json === 'string') {
        var active = state.activeToolBlocks[event.index];
        if (active) active.inputJsonParts.push(event.delta.partial_json);
    }
    // Accumulate streamed response text regardless of index
    if (recordOutputs && typeof event.delta.text === 'string') state.responseTexts.push(event.delta.text);
}
/**
 * Handle stop of a content block; finalize tool_use entries
 */ function handleContentBlockStop(event, state) {
    if (event.type !== 'content_block_stop' || typeof event.index !== 'number') return;
    var active = state.activeToolBlocks[event.index];
    if (!active) return;
    var raw = active.inputJsonParts.join('');
    var parsedInput;
    try {
        parsedInput = raw ? JSON.parse(raw) : {};
    } catch (e) {
        parsedInput = {
            __unparsed: raw
        };
    }
    state.toolCalls.push({
        type: 'tool_use',
        id: active.id,
        name: active.name,
        input: parsedInput
    });
    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete state.activeToolBlocks[event.index];
}
/**
 * Processes an event
 * @param event - The event to process
 * @param state - The state of the streaming process
 * @param recordOutputs - Whether to record outputs
 * @param span - The span to update
 */ function processEvent(event, state, recordOutputs, span) {
    if (!(event && (typeof event === "undefined" ? "undefined" : (0, _typeOf._)(event)) === 'object')) return;
    var isError = isErrorEvent(event, span);
    if (isError) return;
    handleMessageMetadata(event, state);
    // Tool call events are sent via 3 separate events:
    // - content_block_start (start of the tool call)
    // - content_block_delta (delta aka input of the tool call)
    // - content_block_stop (end of the tool call)
    // We need to handle them all to capture the full tool call.
    handleContentBlockStart(event, state);
    handleContentBlockDelta(event, state, recordOutputs);
    handleContentBlockStop(event, state);
}
/**
 * Finalizes span attributes when stream processing completes
 */ function finalizeStreamSpan(state, span, recordOutputs) {
    if (!span.isRecording()) return;
    // Set common response attributes if available
    if (state.responseId) span.setAttributes((0, _defineProperty._)({}, (0, _genAiAttributesJs.GEN_AI_RESPONSE_ID_ATTRIBUTE), state.responseId));
    if (state.responseModel) span.setAttributes((0, _defineProperty._)({}, (0, _genAiAttributesJs.GEN_AI_RESPONSE_MODEL_ATTRIBUTE), state.responseModel));
    (0, _utilsJs.setTokenUsageAttributes)(span, state.promptTokens, state.completionTokens, state.cacheCreationInputTokens, state.cacheReadInputTokens);
    span.setAttributes((0, _defineProperty._)({}, (0, _genAiAttributesJs.GEN_AI_RESPONSE_STREAMING_ATTRIBUTE), true));
    if (state.finishReasons.length > 0) span.setAttributes((0, _defineProperty._)({}, (0, _genAiAttributesJs.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE), JSON.stringify(state.finishReasons)));
    if (recordOutputs && state.responseTexts.length > 0) span.setAttributes((0, _defineProperty._)({}, (0, _genAiAttributesJs.GEN_AI_RESPONSE_TEXT_ATTRIBUTE), state.responseTexts.join('')));
    // Set tool calls if any were captured
    if (recordOutputs && state.toolCalls.length > 0) span.setAttributes((0, _defineProperty._)({}, (0, _genAiAttributesJs.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE), JSON.stringify(state.toolCalls)));
    span.end();
}
/**
 * Instruments an async iterable stream of Anthropic events, updates the span with
 * streaming attributes and (optionally) the aggregated output text, and yields
 * each event from the input stream unchanged.
 */ function instrumentAsyncIterableStream(stream, span, recordOutputs) {
    return (0, _wrapAsyncGenerator._)(function() {
        var state, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, event, err;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    state = {
                        responseTexts: [],
                        finishReasons: [],
                        responseId: '',
                        responseModel: '',
                        promptTokens: undefined,
                        completionTokens: undefined,
                        cacheCreationInputTokens: undefined,
                        cacheReadInputTokens: undefined,
                        toolCalls: [],
                        activeToolBlocks: {}
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        ,
                        15,
                        16
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        8,
                        9,
                        14
                    ]);
                    _iterator = (0, _asyncIterator._)(stream);
                    _state.label = 3;
                case 3:
                    return [
                        4,
                        (0, _awaitAsyncGenerator._)(_iterator.next())
                    ];
                case 4:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        7
                    ];
                    _value = _step.value;
                    event = _value;
                    processEvent(event, state, recordOutputs, span);
                    return [
                        4,
                        event
                    ];
                case 5:
                    _state.sent();
                    _state.label = 6;
                case 6:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        3
                    ];
                case 7:
                    return [
                        3,
                        14
                    ];
                case 8:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        14
                    ];
                case 9:
                    _state.trys.push([
                        9,
                        ,
                        12,
                        13
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                        3,
                        11
                    ];
                    return [
                        4,
                        (0, _awaitAsyncGenerator._)(_iterator.return())
                    ];
                case 10:
                    _state.sent();
                    _state.label = 11;
                case 11:
                    return [
                        3,
                        13
                    ];
                case 12:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 13:
                    return [
                        7
                    ];
                case 14:
                    return [
                        3,
                        16
                    ];
                case 15:
                    // Set common response attributes if available
                    if (state.responseId) span.setAttributes((0, _defineProperty._)({}, (0, _genAiAttributesJs.GEN_AI_RESPONSE_ID_ATTRIBUTE), state.responseId));
                    if (state.responseModel) span.setAttributes((0, _defineProperty._)({}, (0, _genAiAttributesJs.GEN_AI_RESPONSE_MODEL_ATTRIBUTE), state.responseModel));
                    (0, _utilsJs.setTokenUsageAttributes)(span, state.promptTokens, state.completionTokens, state.cacheCreationInputTokens, state.cacheReadInputTokens);
                    span.setAttributes((0, _defineProperty._)({}, (0, _genAiAttributesJs.GEN_AI_RESPONSE_STREAMING_ATTRIBUTE), true));
                    if (state.finishReasons.length > 0) span.setAttributes((0, _defineProperty._)({}, (0, _genAiAttributesJs.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE), JSON.stringify(state.finishReasons)));
                    if (recordOutputs && state.responseTexts.length > 0) span.setAttributes((0, _defineProperty._)({}, (0, _genAiAttributesJs.GEN_AI_RESPONSE_TEXT_ATTRIBUTE), state.responseTexts.join('')));
                    // Set tool calls if any were captured
                    if (recordOutputs && state.toolCalls.length > 0) span.setAttributes((0, _defineProperty._)({}, (0, _genAiAttributesJs.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE), JSON.stringify(state.toolCalls)));
                    span.end();
                    return [
                        7
                    ];
                case 16:
                    return [
                        2
                    ];
            }
        });
    })();
}
/**
 * Instruments a MessageStream by registering event handlers and preserving the original stream API.
 */ function instrumentMessageStream(stream, span, recordOutputs) {
    var state = {
        responseTexts: [],
        finishReasons: [],
        responseId: '',
        responseModel: '',
        promptTokens: undefined,
        completionTokens: undefined,
        cacheCreationInputTokens: undefined,
        cacheReadInputTokens: undefined,
        toolCalls: [],
        activeToolBlocks: {}
    };
    stream.on('streamEvent', function(event) {
        processEvent(event, state, recordOutputs, span);
    });
    // The event fired when a message is done being streamed by the API. Corresponds to the message_stop SSE event.
    // @see https://github.com/anthropics/anthropic-sdk-typescript/blob/d3be31f5a4e6ebb4c0a2f65dbb8f381ae73a9166/helpers.md?plain=1#L42-L44
    stream.on('message', function() {
        finalizeStreamSpan(state, span, recordOutputs);
    });
    stream.on('error', function(error) {
        (0, _exportsJs.captureException)(error, {
            mechanism: {
                handled: false,
                type: 'auto.ai.anthropic.stream_error'
            }
        });
        if (span.isRecording()) {
            span.setStatus({
                code: (0, _spanstatusJs.SPAN_STATUS_ERROR),
                message: 'stream_error'
            });
            span.end();
        }
    });
    return stream;
}

},{"@swc/helpers/_/_async_iterator":"6B313","@swc/helpers/_/_await_async_generator":"ZoK6H","@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_type_of":"iFJdx","@swc/helpers/_/_wrap_async_generator":"l6OQn","@swc/helpers/_/_ts_generator":"78Tqx","../../exports.js":"1Xqap","../spanstatus.js":"WiYVV","../ai/gen-ai-attributes.js":"faK6k","../ai/utils.js":"2cEft","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aUlsl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "handleResponseError", function() {
    return handleResponseError;
});
parcelHelpers.export(exports, "shouldInstrument", function() {
    return shouldInstrument;
});
var _exportsJs = require("../../exports.js");
var _spanstatusJs = require("../spanstatus.js");
var _constantsJs = require("./constants.js");
/**
 * Check if a method path should be instrumented
 */ function shouldInstrument(methodPath) {
    return (0, _constantsJs.ANTHROPIC_AI_INSTRUMENTED_METHODS).includes(methodPath);
}
/**
 * Capture error information from the response
 * @see https://docs.anthropic.com/en/api/errors#error-shapes
 */ function handleResponseError(span, response) {
    if (response.error) {
        span.setStatus({
            code: (0, _spanstatusJs.SPAN_STATUS_ERROR),
            message: response.error.type || 'internal_error'
        });
        (0, _exportsJs.captureException)(response.error, {
            mechanism: {
                handled: false,
                type: 'auto.ai.anthropic.anthropic_error'
            }
        });
    }
}

},{"../../exports.js":"1Xqap","../spanstatus.js":"WiYVV","./constants.js":"9BrtT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9BrtT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ANTHROPIC_AI_INSTRUMENTED_METHODS", function() {
    return ANTHROPIC_AI_INSTRUMENTED_METHODS;
});
parcelHelpers.export(exports, "ANTHROPIC_AI_INTEGRATION_NAME", function() {
    return ANTHROPIC_AI_INTEGRATION_NAME;
});
var ANTHROPIC_AI_INTEGRATION_NAME = 'Anthropic_AI';
// https://docs.anthropic.com/en/api/messages
// https://docs.anthropic.com/en/api/models-list
var ANTHROPIC_AI_INSTRUMENTED_METHODS = [
    'messages.create',
    'messages.stream',
    'messages.countTokens',
    'models.get',
    'completions.create',
    'models.retrieve',
    'beta.messages.create'
];

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"N6cF7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extractModel", function() {
    return extractModel;
});
parcelHelpers.export(exports, "instrumentGoogleGenAIClient", function() {
    return instrumentGoogleGenAIClient;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _currentScopesJs = require("../../currentScopes.js");
var _exportsJs = require("../../exports.js");
var _semanticAttributesJs = require("../../semanticAttributes.js");
var _spanstatusJs = require("../spanstatus.js");
var _traceJs = require("../trace.js");
var _handleCallbackErrorsJs = require("../../utils/handleCallbackErrors.js");
var _genAiAttributesJs = require("../ai/gen-ai-attributes.js");
var _utilsJs = require("../ai/utils.js");
var _constantsJs = require("./constants.js");
var _streamingJs = require("./streaming.js");
var _utilsJs1 = require("./utils.js");
/**
 * Extract model from parameters or chat context object
 * For chat instances, the model is available on the chat object as 'model' (older versions) or 'modelVersion' (newer versions)
 */ function extractModel(params, context) {
    if ('model' in params && typeof params.model === 'string') return params.model;
    // Try to get model from chat context object (chat instance has model property)
    if (context && (typeof context === "undefined" ? "undefined" : (0, _typeOf._)(context)) === 'object') {
        var contextObj = context;
        // Check for 'model' property (older versions, and streaming)
        if ('model' in contextObj && typeof contextObj.model === 'string') return contextObj.model;
        // Check for 'modelVersion' property (newer versions)
        if ('modelVersion' in contextObj && typeof contextObj.modelVersion === 'string') return contextObj.modelVersion;
    }
    return 'unknown';
}
/**
 * Extract generation config parameters
 */ function extractConfigAttributes(config) {
    var attributes = {};
    if ('temperature' in config && typeof config.temperature === 'number') attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE] = config.temperature;
    if ('topP' in config && typeof config.topP === 'number') attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_TOP_P_ATTRIBUTE] = config.topP;
    if ('topK' in config && typeof config.topK === 'number') attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_TOP_K_ATTRIBUTE] = config.topK;
    if ('maxOutputTokens' in config && typeof config.maxOutputTokens === 'number') attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE] = config.maxOutputTokens;
    if ('frequencyPenalty' in config && typeof config.frequencyPenalty === 'number') attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE] = config.frequencyPenalty;
    if ('presencePenalty' in config && typeof config.presencePenalty === 'number') attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE] = config.presencePenalty;
    return attributes;
}
/**
 * Extract request attributes from method arguments
 * Builds the base attributes for span creation including system info, model, and config
 */ function extractRequestAttributes(methodPath, params, context) {
    var _obj;
    var attributes = (_obj = {}, (0, _defineProperty._)(_obj, (0, _genAiAttributesJs.GEN_AI_SYSTEM_ATTRIBUTE), (0, _constantsJs.GOOGLE_GENAI_SYSTEM_NAME)), (0, _defineProperty._)(_obj, (0, _genAiAttributesJs.GEN_AI_OPERATION_NAME_ATTRIBUTE), (0, _utilsJs.getFinalOperationName)(methodPath)), (0, _defineProperty._)(_obj, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), 'auto.ai.google_genai'), _obj);
    if (params) {
        attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = extractModel(params, context);
        // Extract generation config parameters
        if ('config' in params && (0, _typeOf._)(params.config) === 'object' && params.config) {
            var config = params.config;
            Object.assign(attributes, extractConfigAttributes(config));
            // Extract available tools from config
            if ('tools' in config && Array.isArray(config.tools)) {
                var functionDeclarations = config.tools.flatMap(function(tool) {
                    return tool.functionDeclarations;
                });
                attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = JSON.stringify(functionDeclarations);
            }
        }
    } else attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = extractModel({}, context);
    return attributes;
}
/**
 * Add private request attributes to spans.
 * This is only recorded if recordInputs is true.
 * Handles different parameter formats for different Google GenAI methods.
 */ function addPrivateRequestAttributes(span, params) {
    // For models.generateContent: ContentListUnion: Content | Content[] | PartUnion | PartUnion[]
    if ('contents' in params) {
        var contents = params.contents;
        // For models.generateContent: ContentListUnion: Content | Content[] | PartUnion | PartUnion[]
        var truncatedContents = (0, _utilsJs.getTruncatedJsonString)(contents);
        span.setAttributes((0, _defineProperty._)({}, (0, _genAiAttributesJs.GEN_AI_REQUEST_MESSAGES_ATTRIBUTE), truncatedContents));
    }
    // For chat.sendMessage: message can be string or Part[]
    if ('message' in params) {
        var message = params.message;
        var truncatedMessage = (0, _utilsJs.getTruncatedJsonString)(message);
        span.setAttributes((0, _defineProperty._)({}, (0, _genAiAttributesJs.GEN_AI_REQUEST_MESSAGES_ATTRIBUTE), truncatedMessage));
    }
    // For chats.create: history contains the conversation history
    if ('history' in params) {
        var history = params.history;
        var truncatedHistory = (0, _utilsJs.getTruncatedJsonString)(history);
        span.setAttributes((0, _defineProperty._)({}, (0, _genAiAttributesJs.GEN_AI_REQUEST_MESSAGES_ATTRIBUTE), truncatedHistory));
    }
}
/**
 * Add response attributes from the Google GenAI response
 * @see https://github.com/googleapis/js-genai/blob/v1.19.0/src/types.ts#L2313
 */ function addResponseAttributes(span, response, recordOutputs) {
    if (!response || (typeof response === "undefined" ? "undefined" : (0, _typeOf._)(response)) !== 'object') return;
    // Add usage metadata if present
    if (response.usageMetadata && (0, _typeOf._)(response.usageMetadata) === 'object') {
        var usage = response.usageMetadata;
        if (typeof usage.promptTokenCount === 'number') span.setAttributes((0, _defineProperty._)({}, (0, _genAiAttributesJs.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE), usage.promptTokenCount));
        if (typeof usage.candidatesTokenCount === 'number') span.setAttributes((0, _defineProperty._)({}, (0, _genAiAttributesJs.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE), usage.candidatesTokenCount));
        if (typeof usage.totalTokenCount === 'number') span.setAttributes((0, _defineProperty._)({}, (0, _genAiAttributesJs.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE), usage.totalTokenCount));
    }
    // Add response text if recordOutputs is enabled
    if (recordOutputs && Array.isArray(response.candidates) && response.candidates.length > 0) {
        var responseTexts = response.candidates.map(function(candidate) {
            var _candidate_content;
            if (((_candidate_content = candidate.content) === null || _candidate_content === void 0 ? void 0 : _candidate_content.parts) && Array.isArray(candidate.content.parts)) return candidate.content.parts.map(function(part) {
                return typeof part.text === 'string' ? part.text : '';
            }).filter(function(text) {
                return text.length > 0;
            }).join('');
            return '';
        }).filter(function(text) {
            return text.length > 0;
        });
        if (responseTexts.length > 0) span.setAttributes((0, _defineProperty._)({}, (0, _genAiAttributesJs.GEN_AI_RESPONSE_TEXT_ATTRIBUTE), responseTexts.join('')));
    }
    // Add tool calls if recordOutputs is enabled
    if (recordOutputs && response.functionCalls) {
        var functionCalls = response.functionCalls;
        if (Array.isArray(functionCalls) && functionCalls.length > 0) span.setAttributes((0, _defineProperty._)({}, (0, _genAiAttributesJs.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE), JSON.stringify(functionCalls)));
    }
}
/**
 * Instrument any async or synchronous genai method with Sentry spans
 * Handles operations like models.generateContent and chat.sendMessage and chats.create
 * @see https://docs.sentry.io/platforms/javascript/guides/node/tracing/instrumentation/ai-agents-module/#manual-instrumentation
 */ function instrumentMethod(originalMethod, methodPath, context, options) {
    var isSyncCreate = methodPath === (0, _constantsJs.CHATS_CREATE_METHOD);
    return new Proxy(originalMethod, {
        apply: function apply(target, _, args) {
            var params = args[0];
            var requestAttributes = extractRequestAttributes(methodPath, params, context);
            var _requestAttributes_GEN_AI_REQUEST_MODEL_ATTRIBUTE;
            var model = (_requestAttributes_GEN_AI_REQUEST_MODEL_ATTRIBUTE = requestAttributes[0, _genAiAttributesJs.GEN_AI_REQUEST_MODEL_ATTRIBUTE]) !== null && _requestAttributes_GEN_AI_REQUEST_MODEL_ATTRIBUTE !== void 0 ? _requestAttributes_GEN_AI_REQUEST_MODEL_ATTRIBUTE : 'unknown';
            var operationName = (0, _utilsJs.getFinalOperationName)(methodPath);
            // Check if this is a streaming method
            if ((0, _utilsJs1.isStreamingMethod)(methodPath)) // Use startSpanManual for streaming methods to control span lifecycle
            return (0, _traceJs.startSpanManual)({
                name: "".concat(operationName, " ").concat(model, " stream-response"),
                op: (0, _utilsJs.getSpanOperation)(methodPath),
                attributes: requestAttributes
            }, function(span) {
                return (0, _asyncToGenerator._)(function() {
                    var stream, error;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                if (options.recordInputs && params) addPrivateRequestAttributes(span, params);
                                return [
                                    4,
                                    target.apply(context, args)
                                ];
                            case 1:
                                stream = _state.sent();
                                return [
                                    2,
                                    (0, _streamingJs.instrumentStream)(stream, span, Boolean(options.recordOutputs))
                                ];
                            case 2:
                                error = _state.sent();
                                span.setStatus({
                                    code: (0, _spanstatusJs.SPAN_STATUS_ERROR),
                                    message: 'internal_error'
                                });
                                (0, _exportsJs.captureException)(error, {
                                    mechanism: {
                                        handled: false,
                                        type: 'auto.ai.google_genai',
                                        data: {
                                            function: methodPath
                                        }
                                    }
                                });
                                span.end();
                                throw error;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            });
            // Single span for both sync and async operations
            return (0, _traceJs.startSpan)({
                name: isSyncCreate ? "".concat(operationName, " ").concat(model, " create") : "".concat(operationName, " ").concat(model),
                op: (0, _utilsJs.getSpanOperation)(methodPath),
                attributes: requestAttributes
            }, function(span) {
                if (options.recordInputs && params) addPrivateRequestAttributes(span, params);
                return (0, _handleCallbackErrorsJs.handleCallbackErrors)(function() {
                    return target.apply(context, args);
                }, function(error) {
                    (0, _exportsJs.captureException)(error, {
                        mechanism: {
                            handled: false,
                            type: 'auto.ai.google_genai',
                            data: {
                                function: methodPath
                            }
                        }
                    });
                }, function() {}, function(result) {
                    // Only add response attributes for content-producing methods, not for chats.create
                    if (!isSyncCreate) addResponseAttributes(span, result, options.recordOutputs);
                });
            });
        }
    });
}
/**
 * Create a deep proxy for Google GenAI client instrumentation
 * Recursively instruments methods and handles special cases like chats.create
 */ function createDeepProxy(target) {
    var currentPath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : '', options = arguments.length > 2 ? arguments[2] : void 0;
    return new Proxy(target, {
        get: function(t, prop, receiver) {
            var value = Reflect.get(t, prop, receiver);
            var methodPath = (0, _utilsJs.buildMethodPath)(currentPath, String(prop));
            if (typeof value === 'function' && (0, _utilsJs1.shouldInstrument)(methodPath)) {
                // Special case: chats.create is synchronous but needs both instrumentation AND result proxying
                if (methodPath === (0, _constantsJs.CHATS_CREATE_METHOD)) {
                    var instrumentedMethod = instrumentMethod(value, methodPath, t, options);
                    return function instrumentedAndProxiedCreate() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                            args[_key] = arguments[_key];
                        }
                        var result = instrumentedMethod.apply(void 0, (0, _toConsumableArray._)(args));
                        // If the result is an object (like a chat instance), proxy it too
                        if (result && (typeof result === "undefined" ? "undefined" : (0, _typeOf._)(result)) === 'object') return createDeepProxy(result, (0, _constantsJs.CHAT_PATH), options);
                        return result;
                    };
                }
                return instrumentMethod(value, methodPath, t, options);
            }
            if (typeof value === 'function') // Bind non-instrumented functions to preserve the original `this` context
            return value.bind(t);
            if (value && (typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) === 'object') return createDeepProxy(value, methodPath, options);
            return value;
        }
    });
}
/**
 * Instrument a Google GenAI client with Sentry tracing
 * Can be used across Node.js, Cloudflare Workers, and Vercel Edge
 *
 * @template T - The type of the client that extends client object
 * @param client - The Google GenAI client to instrument
 * @param options - Optional configuration for recording inputs and outputs
 * @returns The instrumented client with the same type as the input
 *
 * @example
 * ```typescript
 * import { GoogleGenAI } from '@google/genai';
 * import { instrumentGoogleGenAIClient } from '@sentry/core';
 *
 * const genAI = new GoogleGenAI({ apiKey: process.env.GOOGLE_GENAI_API_KEY });
 * const instrumentedClient = instrumentGoogleGenAIClient(genAI);
 *
 * // Now both chats.create and sendMessage will be instrumented
 * const chat = instrumentedClient.chats.create({ model: 'gemini-1.5-pro' });
 * const response = await chat.sendMessage({ message: 'Hello' });
 * ```
 */ function instrumentGoogleGenAIClient(client, options) {
    var _getClient;
    var sendDefaultPii = Boolean((_getClient = (0, _currentScopesJs.getClient)()) === null || _getClient === void 0 ? void 0 : _getClient.getOptions().sendDefaultPii);
    var _options = (0, _objectSpread._)({
        recordInputs: sendDefaultPii,
        recordOutputs: sendDefaultPii
    }, options);
    return createDeepProxy(client, '', _options);
}

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_to_consumable_array":"1eSZf","@swc/helpers/_/_type_of":"iFJdx","@swc/helpers/_/_ts_generator":"78Tqx","../../currentScopes.js":"3GE4v","../../exports.js":"1Xqap","../../semanticAttributes.js":"7WRPE","../spanstatus.js":"WiYVV","../trace.js":"eu0PU","../../utils/handleCallbackErrors.js":"g30DX","../ai/gen-ai-attributes.js":"faK6k","../ai/utils.js":"2cEft","./constants.js":"82pKK","./streaming.js":"0RhUf","./utils.js":"hXBDv","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"82pKK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CHATS_CREATE_METHOD", function() {
    return CHATS_CREATE_METHOD;
});
parcelHelpers.export(exports, "CHAT_PATH", function() {
    return CHAT_PATH;
});
parcelHelpers.export(exports, "GOOGLE_GENAI_INSTRUMENTED_METHODS", function() {
    return GOOGLE_GENAI_INSTRUMENTED_METHODS;
});
parcelHelpers.export(exports, "GOOGLE_GENAI_INTEGRATION_NAME", function() {
    return GOOGLE_GENAI_INTEGRATION_NAME;
});
parcelHelpers.export(exports, "GOOGLE_GENAI_SYSTEM_NAME", function() {
    return GOOGLE_GENAI_SYSTEM_NAME;
});
var GOOGLE_GENAI_INTEGRATION_NAME = 'Google_GenAI';
// https://ai.google.dev/api/rest/v1/models/generateContent
// https://ai.google.dev/api/rest/v1/chats/sendMessage
// https://googleapis.github.io/js-genai/release_docs/classes/models.Models.html#generatecontentstream
// https://googleapis.github.io/js-genai/release_docs/classes/chats.Chat.html#sendmessagestream
var GOOGLE_GENAI_INSTRUMENTED_METHODS = [
    'models.generateContent',
    'models.generateContentStream',
    'chats.create',
    'sendMessage',
    'sendMessageStream'
];
// Constants for internal use
var GOOGLE_GENAI_SYSTEM_NAME = 'google_genai';
var CHATS_CREATE_METHOD = 'chats.create';
var CHAT_PATH = 'chat';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"0RhUf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "instrumentStream", function() {
    return instrumentStream;
});
var _asyncIterator = require("@swc/helpers/_/_async_iterator");
var _awaitAsyncGenerator = require("@swc/helpers/_/_await_async_generator");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _wrapAsyncGenerator = require("@swc/helpers/_/_wrap_async_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _exportsJs = require("../../exports.js");
var _spanstatusJs = require("../spanstatus.js");
var _genAiAttributesJs = require("../ai/gen-ai-attributes.js");
/**
 * State object used to accumulate information from a stream of Google GenAI events.
 */ /**
 * Checks if a response chunk contains an error
 * @param chunk - The response chunk to check
 * @param span - The span to update if error is found
 * @returns Whether an error occurred
 */ function isErrorChunk(chunk, span) {
    var feedback = chunk === null || chunk === void 0 ? void 0 : chunk.promptFeedback;
    if (feedback === null || feedback === void 0 ? void 0 : feedback.blockReason) {
        var _feedback_blockReasonMessage;
        var message = (_feedback_blockReasonMessage = feedback.blockReasonMessage) !== null && _feedback_blockReasonMessage !== void 0 ? _feedback_blockReasonMessage : feedback.blockReason;
        span.setStatus({
            code: (0, _spanstatusJs.SPAN_STATUS_ERROR),
            message: "Content blocked: ".concat(message)
        });
        (0, _exportsJs.captureException)("Content blocked: ".concat(message), {
            mechanism: {
                handled: false,
                type: 'auto.ai.google_genai'
            }
        });
        return true;
    }
    return false;
}
/**
 * Processes response metadata from a chunk
 * @param chunk - The response chunk to process
 * @param state - The state of the streaming process
 */ function handleResponseMetadata(chunk, state) {
    if (typeof chunk.responseId === 'string') state.responseId = chunk.responseId;
    if (typeof chunk.modelVersion === 'string') state.responseModel = chunk.modelVersion;
    var usage = chunk.usageMetadata;
    if (usage) {
        if (typeof usage.promptTokenCount === 'number') state.promptTokens = usage.promptTokenCount;
        if (typeof usage.candidatesTokenCount === 'number') state.completionTokens = usage.candidatesTokenCount;
        if (typeof usage.totalTokenCount === 'number') state.totalTokens = usage.totalTokenCount;
    }
}
/**
 * Processes candidate content from a response chunk
 * @param chunk - The response chunk to process
 * @param state - The state of the streaming process
 * @param recordOutputs - Whether to record outputs
 */ function handleCandidateContent(chunk, state, recordOutputs) {
    var _state_toolCalls;
    if (Array.isArray(chunk.functionCalls)) (_state_toolCalls = state.toolCalls).push.apply(_state_toolCalls, (0, _toConsumableArray._)(chunk.functionCalls));
    var _chunk_candidates;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = ((_chunk_candidates = chunk.candidates) !== null && _chunk_candidates !== void 0 ? _chunk_candidates : [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var candidate = _step.value;
            var _candidate_content;
            if ((candidate === null || candidate === void 0 ? void 0 : candidate.finishReason) && !state.finishReasons.includes(candidate.finishReason)) state.finishReasons.push(candidate.finishReason);
            var _candidate_content_parts;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = ((_candidate_content_parts = candidate === null || candidate === void 0 ? void 0 : (_candidate_content = candidate.content) === null || _candidate_content === void 0 ? void 0 : _candidate_content.parts) !== null && _candidate_content_parts !== void 0 ? _candidate_content_parts : [])[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var part = _step1.value;
                    if (recordOutputs && part.text) state.responseTexts.push(part.text);
                    if (part.functionCall) state.toolCalls.push({
                        type: 'function',
                        id: part.functionCall.id,
                        name: part.functionCall.name,
                        arguments: part.functionCall.args
                    });
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
/**
 * Processes a single chunk from the Google GenAI stream
 * @param chunk - The chunk to process
 * @param state - The state of the streaming process
 * @param recordOutputs - Whether to record outputs
 * @param span - The span to update
 */ function processChunk(chunk, state, recordOutputs, span) {
    if (!chunk || isErrorChunk(chunk, span)) return;
    handleResponseMetadata(chunk, state);
    handleCandidateContent(chunk, state, recordOutputs);
}
/**
 * Instruments an async iterable stream of Google GenAI response chunks, updates the span with
 * streaming attributes and (optionally) the aggregated output text, and yields
 * each chunk from the input stream unchanged.
 */ function instrumentStream(stream, span, recordOutputs) {
    return (0, _wrapAsyncGenerator._)(function() {
        var state, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, attrs;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    state = {
                        responseTexts: [],
                        finishReasons: [],
                        toolCalls: []
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        ,
                        15,
                        16
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        8,
                        9,
                        14
                    ]);
                    _iterator = (0, _asyncIterator._)(stream);
                    _state.label = 3;
                case 3:
                    return [
                        4,
                        (0, _awaitAsyncGenerator._)(_iterator.next())
                    ];
                case 4:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        7
                    ];
                    _value = _step.value;
                    chunk = _value;
                    processChunk(chunk, state, recordOutputs, span);
                    return [
                        4,
                        chunk
                    ];
                case 5:
                    _state.sent();
                    _state.label = 6;
                case 6:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        3
                    ];
                case 7:
                    return [
                        3,
                        14
                    ];
                case 8:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        14
                    ];
                case 9:
                    _state.trys.push([
                        9,
                        ,
                        12,
                        13
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                        3,
                        11
                    ];
                    return [
                        4,
                        (0, _awaitAsyncGenerator._)(_iterator.return())
                    ];
                case 10:
                    _state.sent();
                    _state.label = 11;
                case 11:
                    return [
                        3,
                        13
                    ];
                case 12:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 13:
                    return [
                        7
                    ];
                case 14:
                    return [
                        3,
                        16
                    ];
                case 15:
                    attrs = (0, _defineProperty._)({}, (0, _genAiAttributesJs.GEN_AI_RESPONSE_STREAMING_ATTRIBUTE), true);
                    if (state.responseId) attrs[0, _genAiAttributesJs.GEN_AI_RESPONSE_ID_ATTRIBUTE] = state.responseId;
                    if (state.responseModel) attrs[0, _genAiAttributesJs.GEN_AI_RESPONSE_MODEL_ATTRIBUTE] = state.responseModel;
                    if (state.promptTokens !== undefined) attrs[0, _genAiAttributesJs.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = state.promptTokens;
                    if (state.completionTokens !== undefined) attrs[0, _genAiAttributesJs.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] = state.completionTokens;
                    if (state.totalTokens !== undefined) attrs[0, _genAiAttributesJs.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = state.totalTokens;
                    if (state.finishReasons.length) attrs[0, _genAiAttributesJs.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE] = JSON.stringify(state.finishReasons);
                    if (recordOutputs && state.responseTexts.length) attrs[0, _genAiAttributesJs.GEN_AI_RESPONSE_TEXT_ATTRIBUTE] = state.responseTexts.join('');
                    if (recordOutputs && state.toolCalls.length) attrs[0, _genAiAttributesJs.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE] = JSON.stringify(state.toolCalls);
                    span.setAttributes(attrs);
                    span.end();
                    return [
                        7
                    ];
                case 16:
                    return [
                        2
                    ];
            }
        });
    })();
}

},{"@swc/helpers/_/_async_iterator":"6B313","@swc/helpers/_/_await_async_generator":"ZoK6H","@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_to_consumable_array":"1eSZf","@swc/helpers/_/_wrap_async_generator":"l6OQn","@swc/helpers/_/_ts_generator":"78Tqx","../../exports.js":"1Xqap","../spanstatus.js":"WiYVV","../ai/gen-ai-attributes.js":"faK6k","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hXBDv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isStreamingMethod", function() {
    return isStreamingMethod;
});
parcelHelpers.export(exports, "shouldInstrument", function() {
    return shouldInstrument;
});
var _constantsJs = require("./constants.js");
/**
 * Check if a method path should be instrumented
 */ function shouldInstrument(methodPath) {
    // Check for exact matches first (like 'models.generateContent')
    if ((0, _constantsJs.GOOGLE_GENAI_INSTRUMENTED_METHODS).includes(methodPath)) return true;
    // Check for method name matches (like 'sendMessage' from chat instances)
    var methodName = methodPath.split('.').pop();
    return (0, _constantsJs.GOOGLE_GENAI_INSTRUMENTED_METHODS).includes(methodName);
}
/**
 * Check if a method is a streaming method
 */ function isStreamingMethod(methodPath) {
    return methodPath.includes('Stream') || methodPath.endsWith('generateContentStream') || methodPath.endsWith('sendMessageStream');
}

},{"./constants.js":"82pKK","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bIGl1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createLangChainCallbackHandler", function() {
    return createLangChainCallbackHandler;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _exportsJs = require("../../exports.js");
var _semanticAttributesJs = require("../../semanticAttributes.js");
var _spanstatusJs = require("../spanstatus.js");
var _traceJs = require("../trace.js");
var _genAiAttributesJs = require("../ai/gen-ai-attributes.js");
var _constantsJs = require("./constants.js");
var _utilsJs = require("./utils.js");
/**
 * Creates a Sentry callback handler for LangChain
 * Returns a plain object that LangChain will call via duck-typing
 *
 * This is a stateful handler that tracks spans across multiple LangChain executions.
 */ function createLangChainCallbackHandler() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _options_recordInputs;
    var recordInputs = (_options_recordInputs = options.recordInputs) !== null && _options_recordInputs !== void 0 ? _options_recordInputs : false;
    var _options_recordOutputs;
    var recordOutputs = (_options_recordOutputs = options.recordOutputs) !== null && _options_recordOutputs !== void 0 ? _options_recordOutputs : false;
    // Internal state - single instance tracks all spans
    var spanMap = new Map();
    /**
   * Exit a span and clean up
   */ var exitSpan = function(runId) {
        var span = spanMap.get(runId);
        if (span === null || span === void 0 ? void 0 : span.isRecording()) {
            span.end();
            spanMap.delete(runId);
        }
    };
    /**
   * Handler for LLM Start
   * This handler will be called by LangChain's callback handler when an LLM event is detected.
   */ var handler = {
        // Required LangChain BaseCallbackHandler properties
        lc_serializable: false,
        lc_namespace: [
            'langchain_core',
            'callbacks',
            'sentry'
        ],
        lc_secrets: undefined,
        lc_attributes: undefined,
        lc_aliases: undefined,
        lc_serializable_keys: undefined,
        lc_id: [
            'langchain_core',
            'callbacks',
            'sentry'
        ],
        lc_kwargs: {},
        name: 'SentryCallbackHandler',
        // BaseCallbackHandlerInput boolean flags
        ignoreLLM: false,
        ignoreChain: false,
        ignoreAgent: false,
        ignoreRetriever: false,
        ignoreCustomEvent: false,
        raiseError: false,
        awaitHandlers: true,
        handleLLMStart: function handleLLMStart(llm, prompts, runId, _parentRunId, _extraParams, tags, metadata, _runName) {
            var invocationParams = (0, _utilsJs.getInvocationParams)(tags);
            var attributes = (0, _utilsJs.extractLLMRequestAttributes)(llm, prompts, recordInputs, invocationParams, metadata);
            var modelName = attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_MODEL_ATTRIBUTE];
            var operationName = attributes[0, _genAiAttributesJs.GEN_AI_OPERATION_NAME_ATTRIBUTE];
            (0, _traceJs.startSpanManual)({
                name: "".concat(operationName, " ").concat(modelName),
                op: 'gen_ai.pipeline',
                attributes: (0, _objectSpreadProps._)((0, _objectSpread._)({}, attributes), (0, _defineProperty._)({}, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP), 'gen_ai.pipeline'))
            }, function(span) {
                spanMap.set(runId, span);
                return span;
            });
        },
        // Chat Model Start Handler
        handleChatModelStart: function handleChatModelStart(llm, messages, runId, _parentRunId, _extraParams, tags, metadata, _runName) {
            var invocationParams = (0, _utilsJs.getInvocationParams)(tags);
            var attributes = (0, _utilsJs.extractChatModelRequestAttributes)(llm, messages, recordInputs, invocationParams, metadata);
            var modelName = attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_MODEL_ATTRIBUTE];
            var operationName = attributes[0, _genAiAttributesJs.GEN_AI_OPERATION_NAME_ATTRIBUTE];
            (0, _traceJs.startSpanManual)({
                name: "".concat(operationName, " ").concat(modelName),
                op: 'gen_ai.chat',
                attributes: (0, _objectSpreadProps._)((0, _objectSpread._)({}, attributes), (0, _defineProperty._)({}, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP), 'gen_ai.chat'))
            }, function(span) {
                spanMap.set(runId, span);
                return span;
            });
        },
        // LLM End Handler - note: handleLLMEnd with capital LLM (used by both LLMs and chat models!)
        handleLLMEnd: function handleLLMEnd(output, runId, _parentRunId, _tags, _extraParams) {
            var span = spanMap.get(runId);
            if (span === null || span === void 0 ? void 0 : span.isRecording()) {
                var attributes = (0, _utilsJs.extractLlmResponseAttributes)(output, recordOutputs);
                if (attributes) span.setAttributes(attributes);
                exitSpan(runId);
            }
        },
        // LLM Error Handler - note: handleLLMError with capital LLM
        handleLLMError: function handleLLMError(error, runId) {
            var span = spanMap.get(runId);
            if (span === null || span === void 0 ? void 0 : span.isRecording()) {
                span.setStatus({
                    code: (0, _spanstatusJs.SPAN_STATUS_ERROR),
                    message: 'llm_error'
                });
                exitSpan(runId);
            }
            (0, _exportsJs.captureException)(error, {
                mechanism: {
                    handled: false,
                    type: "".concat((0, _constantsJs.LANGCHAIN_ORIGIN), ".llm_error_handler")
                }
            });
        },
        // Chain Start Handler
        handleChainStart: function handleChainStart(chain, inputs, runId, _parentRunId) {
            var chainName = chain.name || 'unknown_chain';
            var _obj;
            var attributes = (_obj = {}, (0, _defineProperty._)(_obj, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), 'auto.ai.langchain'), (0, _defineProperty._)(_obj, 'langchain.chain.name', chainName), _obj);
            // Add inputs if recordInputs is enabled
            if (recordInputs) attributes['langchain.chain.inputs'] = JSON.stringify(inputs);
            (0, _traceJs.startSpanManual)({
                name: "chain ".concat(chainName),
                op: 'gen_ai.invoke_agent',
                attributes: (0, _objectSpreadProps._)((0, _objectSpread._)({}, attributes), (0, _defineProperty._)({}, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP), 'gen_ai.invoke_agent'))
            }, function(span) {
                spanMap.set(runId, span);
                return span;
            });
        },
        // Chain End Handler
        handleChainEnd: function handleChainEnd(outputs, runId) {
            var span = spanMap.get(runId);
            if (span === null || span === void 0 ? void 0 : span.isRecording()) {
                // Add outputs if recordOutputs is enabled
                if (recordOutputs) span.setAttributes({
                    'langchain.chain.outputs': JSON.stringify(outputs)
                });
                exitSpan(runId);
            }
        },
        // Chain Error Handler
        handleChainError: function handleChainError(error, runId) {
            var span = spanMap.get(runId);
            if (span === null || span === void 0 ? void 0 : span.isRecording()) {
                span.setStatus({
                    code: (0, _spanstatusJs.SPAN_STATUS_ERROR),
                    message: 'chain_error'
                });
                exitSpan(runId);
            }
            (0, _exportsJs.captureException)(error, {
                mechanism: {
                    handled: false,
                    type: "".concat((0, _constantsJs.LANGCHAIN_ORIGIN), ".chain_error_handler")
                }
            });
        },
        // Tool Start Handler
        handleToolStart: function handleToolStart(tool, input, runId, _parentRunId) {
            var toolName = tool.name || 'unknown_tool';
            var _obj;
            var attributes = (_obj = {}, (0, _defineProperty._)(_obj, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), (0, _constantsJs.LANGCHAIN_ORIGIN)), (0, _defineProperty._)(_obj, 'gen_ai.tool.name', toolName), _obj);
            // Add input if recordInputs is enabled
            if (recordInputs) attributes['gen_ai.tool.input'] = input;
            (0, _traceJs.startSpanManual)({
                name: "execute_tool ".concat(toolName),
                op: 'gen_ai.execute_tool',
                attributes: (0, _objectSpreadProps._)((0, _objectSpread._)({}, attributes), (0, _defineProperty._)({}, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP), 'gen_ai.execute_tool'))
            }, function(span) {
                spanMap.set(runId, span);
                return span;
            });
        },
        // Tool End Handler
        handleToolEnd: function handleToolEnd(output, runId) {
            var span = spanMap.get(runId);
            if (span === null || span === void 0 ? void 0 : span.isRecording()) {
                // Add output if recordOutputs is enabled
                if (recordOutputs) span.setAttributes({
                    'gen_ai.tool.output': JSON.stringify(output)
                });
                exitSpan(runId);
            }
        },
        // Tool Error Handler
        handleToolError: function handleToolError(error, runId) {
            var span = spanMap.get(runId);
            if (span === null || span === void 0 ? void 0 : span.isRecording()) {
                span.setStatus({
                    code: (0, _spanstatusJs.SPAN_STATUS_ERROR),
                    message: 'tool_error'
                });
                exitSpan(runId);
            }
            (0, _exportsJs.captureException)(error, {
                mechanism: {
                    handled: false,
                    type: "".concat((0, _constantsJs.LANGCHAIN_ORIGIN), ".tool_error_handler")
                }
            });
        },
        // LangChain BaseCallbackHandler required methods
        copy: function copy() {
            return handler;
        },
        toJSON: function toJSON() {
            return {
                lc: 1,
                type: 'not_implemented',
                id: handler.lc_id
            };
        },
        toJSONNotImplemented: function toJSONNotImplemented() {
            return {
                lc: 1,
                type: 'not_implemented',
                id: handler.lc_id
            };
        }
    };
    return handler;
}

},{"@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","../../exports.js":"1Xqap","../../semanticAttributes.js":"7WRPE","../spanstatus.js":"WiYVV","../trace.js":"eu0PU","../ai/gen-ai-attributes.js":"faK6k","./constants.js":"ccscT","./utils.js":"6eF0L","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ccscT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LANGCHAIN_INTEGRATION_NAME", function() {
    return LANGCHAIN_INTEGRATION_NAME;
});
parcelHelpers.export(exports, "LANGCHAIN_ORIGIN", function() {
    return LANGCHAIN_ORIGIN;
});
parcelHelpers.export(exports, "ROLE_MAP", function() {
    return ROLE_MAP;
});
var LANGCHAIN_INTEGRATION_NAME = 'LangChain';
var LANGCHAIN_ORIGIN = 'auto.ai.langchain';
var ROLE_MAP = {
    human: 'user',
    ai: 'assistant',
    assistant: 'assistant',
    system: 'system',
    function: 'function',
    tool: 'tool'
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6eF0L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extractChatModelRequestAttributes", function() {
    return extractChatModelRequestAttributes;
});
parcelHelpers.export(exports, "extractLLMRequestAttributes", function() {
    return extractLLMRequestAttributes;
});
parcelHelpers.export(exports, "extractLlmResponseAttributes", function() {
    return extractLlmResponseAttributes;
});
parcelHelpers.export(exports, "getInvocationParams", function() {
    return getInvocationParams;
});
parcelHelpers.export(exports, "normalizeLangChainMessages", function() {
    return normalizeLangChainMessages;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _semanticAttributesJs = require("../../semanticAttributes.js");
var _genAiAttributesJs = require("../ai/gen-ai-attributes.js");
var _messageTruncationJs = require("../ai/messageTruncation.js");
var _constantsJs = require("./constants.js");
/**
 * Assigns an attribute only when the value is neither `undefined` nor `null`.
 *
 * We keep this tiny helper because call sites are repetitive and easy to miswrite.
 * It also preserves falsy-but-valid values like `0` and `""`.
 */ var setIfDefined = function(target, key, value) {
    if (value != null) target[key] = value;
};
/**
 * Like `setIfDefined`, but converts the value with `Number()` and skips only when the
 * result is `NaN`. This ensures numeric 0 makes it through (unlike truthy checks).
 */ var setNumberIfDefined = function(target, key, value) {
    var n = Number(value);
    if (!Number.isNaN(n)) target[key] = n;
};
/**
 * Converts a value to a string. Avoids double-quoted JSON strings where a plain
 * string is desired, but still handles objects/arrays safely.
 */ function asString(v) {
    if (typeof v === 'string') return v;
    try {
        return JSON.stringify(v);
    } catch (e) {
        return String(v);
    }
}
/**
 * Normalizes a single role token to our canonical set.
 *
 * @param role Incoming role value (free-form, any casing)
 * @returns Canonical role: 'user' | 'assistant' | 'system' | 'function' | 'tool' | <passthrough>
 */ function normalizeMessageRole(role) {
    var normalized = role.toLowerCase();
    var _ROLE_MAP_normalized;
    return (_ROLE_MAP_normalized = (0, _constantsJs.ROLE_MAP)[normalized]) !== null && _ROLE_MAP_normalized !== void 0 ? _ROLE_MAP_normalized : normalized;
}
/**
 * Infers a role from a LangChain message constructor name.
 *
 * Checks for substrings like "System", "Human", "AI", etc.
 */ function normalizeRoleNameFromCtor(name) {
    if (name.includes('System')) return 'system';
    if (name.includes('Human')) return 'user';
    if (name.includes('AI') || name.includes('Assistant')) return 'assistant';
    if (name.includes('Function')) return 'function';
    if (name.includes('Tool')) return 'tool';
    return 'user';
}
/**
 * Returns invocation params from a LangChain `tags` object.
 *
 * LangChain often passes runtime parameters (model, temperature, etc.) via the
 * `tags.invocation_params` bag. If `tags` is an array (LangChain sometimes uses
 * string tags), we return `undefined`.
 *
 * @param tags LangChain tags (string[] or record)
 * @returns The `invocation_params` object, if present
 */ function getInvocationParams(tags) {
    if (!tags || Array.isArray(tags)) return undefined;
    return tags.invocation_params;
}
/**
 * Normalizes a heterogeneous set of LangChain messages to `{ role, content }`.
 *
 * Why so many branches? LangChain messages can arrive in several shapes:
 *  - Message classes with `_getType()` (most reliable)
 *  - Classes with meaningful constructor names (e.g. `SystemMessage`)
 *  - Plain objects with `type`, or `{ role, content }`
 *  - Serialized format with `{ lc: 1, id: [...], kwargs: { content } }`
 * We preserve the prioritization to minimize behavioral drift.
 *
 * @param messages Mixed LangChain messages
 * @returns Array of normalized `{ role, content }`
 */ function normalizeLangChainMessages(messages) {
    return messages.map(function(message) {
        var _message_constructor;
        // 1) Prefer _getType() when present
        var maybeGetType = message._getType;
        if (typeof maybeGetType === 'function') {
            var messageType = maybeGetType.call(message);
            return {
                role: normalizeMessageRole(messageType),
                content: asString(message.content)
            };
        }
        // 2) Then try constructor name (SystemMessage / HumanMessage / ...)
        var ctor = (_message_constructor = message.constructor) === null || _message_constructor === void 0 ? void 0 : _message_constructor.name;
        if (ctor) return {
            role: normalizeMessageRole(normalizeRoleNameFromCtor(ctor)),
            content: asString(message.content)
        };
        // 3) Then objects with `type`
        if (message.type) {
            var role = String(message.type).toLowerCase();
            return {
                role: normalizeMessageRole(role),
                content: asString(message.content)
            };
        }
        // 4) Then objects with `{ role, content }`
        if (message.role) return {
            role: normalizeMessageRole(String(message.role)),
            content: asString(message.content)
        };
        // 5) Serialized LangChain format (lc: 1)
        if (message.lc === 1 && message.kwargs) {
            var _message_kwargs;
            var id = message.id;
            var messageType1 = Array.isArray(id) && id.length > 0 ? id[id.length - 1] : '';
            var role1 = typeof messageType1 === 'string' ? normalizeRoleNameFromCtor(messageType1) : 'user';
            return {
                role: normalizeMessageRole(role1),
                content: asString((_message_kwargs = message.kwargs) === null || _message_kwargs === void 0 ? void 0 : _message_kwargs.content)
            };
        }
        // 6) Fallback: treat as user text
        return {
            role: 'user',
            content: asString(message.content)
        };
    });
}
/**
 * Extracts request attributes common to both LLM and ChatModel invocations.
 *
 * Source precedence:
 * 1) `invocationParams` (highest)
 * 2) `langSmithMetadata`
 *
 * Numeric values are set even when 0 (e.g. `temperature: 0`), but skipped if `NaN`.
 */ function extractCommonRequestAttributes(serialized, invocationParams, langSmithMetadata) {
    var attrs = {};
    // Get kwargs if available (from constructor type)
    var kwargs = 'kwargs' in serialized ? serialized.kwargs : undefined;
    var _invocationParams_temperature, _ref;
    var temperature = (_ref = (_invocationParams_temperature = invocationParams === null || invocationParams === void 0 ? void 0 : invocationParams.temperature) !== null && _invocationParams_temperature !== void 0 ? _invocationParams_temperature : langSmithMetadata === null || langSmithMetadata === void 0 ? void 0 : langSmithMetadata.ls_temperature) !== null && _ref !== void 0 ? _ref : kwargs === null || kwargs === void 0 ? void 0 : kwargs.temperature;
    setNumberIfDefined(attrs, (0, _genAiAttributesJs.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE), temperature);
    var _invocationParams_max_tokens, _ref1;
    var maxTokens = (_ref1 = (_invocationParams_max_tokens = invocationParams === null || invocationParams === void 0 ? void 0 : invocationParams.max_tokens) !== null && _invocationParams_max_tokens !== void 0 ? _invocationParams_max_tokens : langSmithMetadata === null || langSmithMetadata === void 0 ? void 0 : langSmithMetadata.ls_max_tokens) !== null && _ref1 !== void 0 ? _ref1 : kwargs === null || kwargs === void 0 ? void 0 : kwargs.max_tokens;
    setNumberIfDefined(attrs, (0, _genAiAttributesJs.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE), maxTokens);
    var _invocationParams_top_p;
    var topP = (_invocationParams_top_p = invocationParams === null || invocationParams === void 0 ? void 0 : invocationParams.top_p) !== null && _invocationParams_top_p !== void 0 ? _invocationParams_top_p : kwargs === null || kwargs === void 0 ? void 0 : kwargs.top_p;
    setNumberIfDefined(attrs, (0, _genAiAttributesJs.GEN_AI_REQUEST_TOP_P_ATTRIBUTE), topP);
    var frequencyPenalty = invocationParams === null || invocationParams === void 0 ? void 0 : invocationParams.frequency_penalty;
    setNumberIfDefined(attrs, (0, _genAiAttributesJs.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE), frequencyPenalty);
    var presencePenalty = invocationParams === null || invocationParams === void 0 ? void 0 : invocationParams.presence_penalty;
    setNumberIfDefined(attrs, (0, _genAiAttributesJs.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE), presencePenalty);
    // LangChain uses `stream`. We only set the attribute if the key actually exists
    // (some callbacks report `false` even on streamed requests, this stems from LangChain's callback handler).
    if (invocationParams && 'stream' in invocationParams) setIfDefined(attrs, (0, _genAiAttributesJs.GEN_AI_REQUEST_STREAM_ATTRIBUTE), Boolean(invocationParams.stream));
    return attrs;
}
/**
 * Small helper to assemble boilerplate attributes shared by both request extractors.
 */ function baseRequestAttributes(system, modelName, operation, serialized, invocationParams, langSmithMetadata) {
    var _obj;
    return (0, _objectSpread._)((_obj = {}, (0, _defineProperty._)(_obj, (0, _genAiAttributesJs.GEN_AI_SYSTEM_ATTRIBUTE), asString(system !== null && system !== void 0 ? system : 'langchain')), (0, _defineProperty._)(_obj, (0, _genAiAttributesJs.GEN_AI_OPERATION_NAME_ATTRIBUTE), operation), (0, _defineProperty._)(_obj, (0, _genAiAttributesJs.GEN_AI_REQUEST_MODEL_ATTRIBUTE), asString(modelName)), (0, _defineProperty._)(_obj, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), (0, _constantsJs.LANGCHAIN_ORIGIN)), _obj), extractCommonRequestAttributes(serialized, invocationParams, langSmithMetadata));
}
/**
 * Extracts attributes for plain LLM invocations (string prompts).
 *
 * - Operation is tagged as `pipeline` to distinguish from chat-style invocations.
 * - When `recordInputs` is true, string prompts are wrapped into `{role:"user"}`
 *   messages to align with the chat schema used elsewhere.
 */ function extractLLMRequestAttributes(llm, prompts, recordInputs, invocationParams, langSmithMetadata) {
    var system = langSmithMetadata === null || langSmithMetadata === void 0 ? void 0 : langSmithMetadata.ls_provider;
    var _invocationParams_model, _ref;
    var modelName = (_ref = (_invocationParams_model = invocationParams === null || invocationParams === void 0 ? void 0 : invocationParams.model) !== null && _invocationParams_model !== void 0 ? _invocationParams_model : langSmithMetadata === null || langSmithMetadata === void 0 ? void 0 : langSmithMetadata.ls_model_name) !== null && _ref !== void 0 ? _ref : 'unknown';
    var attrs = baseRequestAttributes(system, modelName, 'pipeline', llm, invocationParams, langSmithMetadata);
    if (recordInputs && Array.isArray(prompts) && prompts.length > 0) {
        var messages = prompts.map(function(p) {
            return {
                role: 'user',
                content: p
            };
        });
        setIfDefined(attrs, (0, _genAiAttributesJs.GEN_AI_REQUEST_MESSAGES_ATTRIBUTE), asString(messages));
    }
    return attrs;
}
/**
 * Extracts attributes for ChatModel invocations (array-of-arrays of messages).
 *
 * - Operation is tagged as `chat`.
 * - We flatten LangChain's `LangChainMessage[][]` and normalize shapes into a
 *   consistent `{ role, content }` array when `recordInputs` is true.
 * - Provider system value falls back to `serialized.id?.[2]`.
 */ function extractChatModelRequestAttributes(llm, langChainMessages, recordInputs, invocationParams, langSmithMetadata) {
    var _llm_id;
    var _langSmithMetadata_ls_provider;
    var system = (_langSmithMetadata_ls_provider = langSmithMetadata === null || langSmithMetadata === void 0 ? void 0 : langSmithMetadata.ls_provider) !== null && _langSmithMetadata_ls_provider !== void 0 ? _langSmithMetadata_ls_provider : (_llm_id = llm.id) === null || _llm_id === void 0 ? void 0 : _llm_id[2];
    var _invocationParams_model, _ref;
    var modelName = (_ref = (_invocationParams_model = invocationParams === null || invocationParams === void 0 ? void 0 : invocationParams.model) !== null && _invocationParams_model !== void 0 ? _invocationParams_model : langSmithMetadata === null || langSmithMetadata === void 0 ? void 0 : langSmithMetadata.ls_model_name) !== null && _ref !== void 0 ? _ref : 'unknown';
    var attrs = baseRequestAttributes(system, modelName, 'chat', llm, invocationParams, langSmithMetadata);
    if (recordInputs && Array.isArray(langChainMessages) && langChainMessages.length > 0) {
        var normalized = normalizeLangChainMessages(langChainMessages.flat());
        var truncated = (0, _messageTruncationJs.truncateGenAiMessages)(normalized);
        setIfDefined(attrs, (0, _genAiAttributesJs.GEN_AI_REQUEST_MESSAGES_ATTRIBUTE), asString(truncated));
    }
    return attrs;
}
/**
 * Scans generations for Anthropic-style `tool_use` items and records them.
 *
 * LangChain represents some provider messages (e.g., Anthropic) with a `message.content`
 * array that may include objects `{ type: 'tool_use', ... }`. We collect and attach
 * them as a JSON array on `gen_ai.response.tool_calls` for downstream consumers.
 */ function addToolCallsAttributes(generations, attrs) {
    var toolCalls = [];
    var flatGenerations = generations.flat();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = flatGenerations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var gen = _step.value;
            var _gen_message;
            var content = (_gen_message = gen.message) === null || _gen_message === void 0 ? void 0 : _gen_message.content;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            if (Array.isArray(content)) try {
                for(var _iterator1 = content[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var item = _step1.value;
                    var t = item;
                    if (t.type === 'tool_use') toolCalls.push(t);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (toolCalls.length > 0) setIfDefined(attrs, (0, _genAiAttributesJs.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE), asString(toolCalls));
}
/**
 * Adds token usage attributes, supporting both OpenAI (`tokenUsage`) and Anthropic (`usage`) formats.
 * - Preserve zero values (0 tokens) by avoiding truthy checks.
 * - Compute a total for Anthropic when not explicitly provided.
 * - Include cache token metrics when present.
 */ function addTokenUsageAttributes(llmOutput, attrs) {
    if (!llmOutput) return;
    var tokenUsage = llmOutput.tokenUsage;
    var anthropicUsage = llmOutput.usage;
    if (tokenUsage) {
        setNumberIfDefined(attrs, (0, _genAiAttributesJs.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE), tokenUsage.promptTokens);
        setNumberIfDefined(attrs, (0, _genAiAttributesJs.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE), tokenUsage.completionTokens);
        setNumberIfDefined(attrs, (0, _genAiAttributesJs.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE), tokenUsage.totalTokens);
    } else if (anthropicUsage) {
        setNumberIfDefined(attrs, (0, _genAiAttributesJs.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE), anthropicUsage.input_tokens);
        setNumberIfDefined(attrs, (0, _genAiAttributesJs.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE), anthropicUsage.output_tokens);
        // Compute total when not provided by the provider.
        var input = Number(anthropicUsage.input_tokens);
        var output = Number(anthropicUsage.output_tokens);
        var total = (Number.isNaN(input) ? 0 : input) + (Number.isNaN(output) ? 0 : output);
        if (total > 0) setNumberIfDefined(attrs, (0, _genAiAttributesJs.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE), total);
        // Extra Anthropic cache metrics (present only when caching is enabled)
        if (anthropicUsage.cache_creation_input_tokens !== undefined) setNumberIfDefined(attrs, (0, _genAiAttributesJs.GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_ATTRIBUTE), anthropicUsage.cache_creation_input_tokens);
        if (anthropicUsage.cache_read_input_tokens !== undefined) setNumberIfDefined(attrs, (0, _genAiAttributesJs.GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_ATTRIBUTE), anthropicUsage.cache_read_input_tokens);
    }
}
/**
 * Extracts response-related attributes based on a `LangChainLLMResult`.
 *
 * - Records finish reasons when present on generations (e.g., OpenAI)
 * - When `recordOutputs` is true, captures textual response content and any
 *   tool calls.
 * - Also propagates model name (`model_name` or `model`), response `id`, and
 *   `stop_reason` (for providers that use it).
 */ function extractLlmResponseAttributes(llmResult, recordOutputs) {
    if (!llmResult) return;
    var attrs = {};
    if (Array.isArray(llmResult.generations)) {
        var finishReasons = llmResult.generations.flat().map(function(g) {
            var _g_generation_info;
            return (_g_generation_info = g.generation_info) === null || _g_generation_info === void 0 ? void 0 : _g_generation_info.finish_reason;
        }).filter(function(r) {
            return typeof r === 'string';
        });
        if (finishReasons.length > 0) setIfDefined(attrs, (0, _genAiAttributesJs.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE), asString(finishReasons));
        // Tool calls metadata (names, IDs) are not PII, so capture them regardless of recordOutputs
        addToolCallsAttributes(llmResult.generations, attrs);
        if (recordOutputs) {
            var texts = llmResult.generations.flat().map(function(gen) {
                var _gen_message;
                var _gen_text;
                return (_gen_text = gen.text) !== null && _gen_text !== void 0 ? _gen_text : (_gen_message = gen.message) === null || _gen_message === void 0 ? void 0 : _gen_message.content;
            }).filter(function(t) {
                return typeof t === 'string';
            });
            if (texts.length > 0) setIfDefined(attrs, (0, _genAiAttributesJs.GEN_AI_RESPONSE_TEXT_ATTRIBUTE), asString(texts));
        }
    }
    addTokenUsageAttributes(llmResult.llmOutput, attrs);
    var llmOutput = llmResult.llmOutput;
    var _llmOutput_model_name;
    // Provider model identifier: `model_name` (OpenAI-style) or `model` (others)
    var modelName = (_llmOutput_model_name = llmOutput === null || llmOutput === void 0 ? void 0 : llmOutput.model_name) !== null && _llmOutput_model_name !== void 0 ? _llmOutput_model_name : llmOutput === null || llmOutput === void 0 ? void 0 : llmOutput.model;
    if (modelName) setIfDefined(attrs, (0, _genAiAttributesJs.GEN_AI_RESPONSE_MODEL_ATTRIBUTE), modelName);
    if (llmOutput === null || llmOutput === void 0 ? void 0 : llmOutput.id) setIfDefined(attrs, (0, _genAiAttributesJs.GEN_AI_RESPONSE_ID_ATTRIBUTE), llmOutput.id);
    if (llmOutput === null || llmOutput === void 0 ? void 0 : llmOutput.stop_reason) setIfDefined(attrs, (0, _genAiAttributesJs.GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE), asString(llmOutput.stop_reason));
    return attrs;
}

},{"@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_object_spread":"9gdrV","../../semanticAttributes.js":"7WRPE","../ai/gen-ai-attributes.js":"faK6k","../ai/messageTruncation.js":"4zJE9","./constants.js":"ccscT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2zQDc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "instrumentLangGraph", function() {
    return instrumentLangGraph;
});
parcelHelpers.export(exports, "instrumentStateGraphCompile", function() {
    return instrumentStateGraphCompile;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _exportsJs = require("../../exports.js");
var _semanticAttributesJs = require("../../semanticAttributes.js");
var _spanstatusJs = require("../spanstatus.js");
var _traceJs = require("../trace.js");
var _genAiAttributesJs = require("../ai/gen-ai-attributes.js");
var _messageTruncationJs = require("../ai/messageTruncation.js");
var _utilsJs = require("../langchain/utils.js");
var _constantsJs = require("./constants.js");
var _utilsJs1 = require("./utils.js");
/**
 * Instruments StateGraph's compile method to create spans for agent creation and invocation
 *
 * Wraps the compile() method to:
 * - Create a `gen_ai.create_agent` span when compile() is called
 * - Automatically wrap the invoke() method on the returned compiled graph with a `gen_ai.invoke_agent` span
 *
 */ function instrumentStateGraphCompile(originalCompile, options) {
    return new Proxy(originalCompile, {
        apply: function apply(target, thisArg, args) {
            var _obj;
            return (0, _traceJs.startSpan)({
                op: 'gen_ai.create_agent',
                name: 'create_agent',
                attributes: (_obj = {}, (0, _defineProperty._)(_obj, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), (0, _constantsJs.LANGGRAPH_ORIGIN)), (0, _defineProperty._)(_obj, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP), 'gen_ai.create_agent'), (0, _defineProperty._)(_obj, (0, _genAiAttributesJs.GEN_AI_OPERATION_NAME_ATTRIBUTE), 'create_agent'), _obj)
            }, function(span) {
                try {
                    var compiledGraph = Reflect.apply(target, thisArg, args);
                    var compileOptions = args.length > 0 ? args[0] : {};
                    // Extract graph name
                    if ((compileOptions === null || compileOptions === void 0 ? void 0 : compileOptions.name) && typeof compileOptions.name === 'string') {
                        span.setAttribute((0, _genAiAttributesJs.GEN_AI_AGENT_NAME_ATTRIBUTE), compileOptions.name);
                        span.updateName("create_agent ".concat(compileOptions.name));
                    }
                    // Instrument agent invoke method on the compiled graph
                    var originalInvoke = compiledGraph.invoke;
                    if (originalInvoke && typeof originalInvoke === 'function') compiledGraph.invoke = instrumentCompiledGraphInvoke(originalInvoke.bind(compiledGraph), compiledGraph, compileOptions, options);
                    return compiledGraph;
                } catch (error) {
                    span.setStatus({
                        code: (0, _spanstatusJs.SPAN_STATUS_ERROR),
                        message: 'internal_error'
                    });
                    (0, _exportsJs.captureException)(error, {
                        mechanism: {
                            handled: false,
                            type: 'auto.ai.langgraph.error'
                        }
                    });
                    throw error;
                }
            });
        }
    });
}
/**
 * Instruments CompiledGraph's invoke method to create spans for agent invocation
 *
 * Creates a `gen_ai.invoke_agent` span when invoke() is called
 */ function instrumentCompiledGraphInvoke(originalInvoke, graphInstance, compileOptions, options) {
    return new Proxy(originalInvoke, {
        apply: function apply(target, thisArg, args) {
            var _obj;
            return (0, _traceJs.startSpan)({
                op: 'gen_ai.invoke_agent',
                name: 'invoke_agent',
                attributes: (_obj = {}, (0, _defineProperty._)(_obj, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), (0, _constantsJs.LANGGRAPH_ORIGIN)), (0, _defineProperty._)(_obj, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP), (0, _genAiAttributesJs.GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE)), (0, _defineProperty._)(_obj, (0, _genAiAttributesJs.GEN_AI_OPERATION_NAME_ATTRIBUTE), 'invoke_agent'), _obj)
            }, function(span) {
                return (0, _asyncToGenerator._)(function() {
                    var graphName, tools, recordInputs, recordOutputs, _args__messages, inputMessages, normalizedMessages, truncatedMessages, result, error;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                graphName = compileOptions === null || compileOptions === void 0 ? void 0 : compileOptions.name;
                                if (graphName && typeof graphName === 'string') {
                                    span.setAttribute((0, _genAiAttributesJs.GEN_AI_PIPELINE_NAME_ATTRIBUTE), graphName);
                                    span.setAttribute((0, _genAiAttributesJs.GEN_AI_AGENT_NAME_ATTRIBUTE), graphName);
                                    span.updateName("invoke_agent ".concat(graphName));
                                }
                                // Extract available tools from the graph instance
                                tools = (0, _utilsJs1.extractToolsFromCompiledGraph)(graphInstance);
                                if (tools) span.setAttribute((0, _genAiAttributesJs.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE), JSON.stringify(tools));
                                // Parse input messages
                                recordInputs = options.recordInputs;
                                recordOutputs = options.recordOutputs;
                                inputMessages = args.length > 0 ? (_args__messages = args[0].messages) !== null && _args__messages !== void 0 ? _args__messages : [] : [];
                                if (inputMessages && recordInputs) {
                                    normalizedMessages = (0, _utilsJs.normalizeLangChainMessages)(inputMessages);
                                    truncatedMessages = (0, _messageTruncationJs.truncateGenAiMessages)(normalizedMessages);
                                    span.setAttribute((0, _genAiAttributesJs.GEN_AI_REQUEST_MESSAGES_ATTRIBUTE), JSON.stringify(truncatedMessages));
                                }
                                return [
                                    4,
                                    Reflect.apply(target, thisArg, args)
                                ];
                            case 1:
                                result = _state.sent();
                                // Set response attributes
                                if (recordOutputs) (0, _utilsJs1.setResponseAttributes)(span, inputMessages !== null && inputMessages !== void 0 ? inputMessages : null, result);
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                span.setStatus({
                                    code: (0, _spanstatusJs.SPAN_STATUS_ERROR),
                                    message: 'internal_error'
                                });
                                (0, _exportsJs.captureException)(error, {
                                    mechanism: {
                                        handled: false,
                                        type: 'auto.ai.langgraph.error'
                                    }
                                });
                                throw error;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            });
        }
    });
}
/**
 * Directly instruments a StateGraph instance to add tracing spans
 *
 * This function can be used to manually instrument LangGraph StateGraph instances
 * in environments where automatic instrumentation is not available or desired.
 *
 * @param stateGraph - The StateGraph instance to instrument
 * @param options - Optional configuration for recording inputs/outputs
 *
 * @example
 * ```typescript
 * import { instrumentLangGraph } from '@sentry/cloudflare';
 * import { StateGraph } from '@langchain/langgraph';
 *
 * const graph = new StateGraph(MessagesAnnotation)
 *   .addNode('agent', mockLlm)
 *   .addEdge(START, 'agent')
 *   .addEdge('agent', END);
 *
 * instrumentLangGraph(graph, { recordInputs: true, recordOutputs: true });
 * const compiled = graph.compile({ name: 'my_agent' });
 * ```
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function instrumentLangGraph(stateGraph, options) {
    var _options = options || {};
    stateGraph.compile = instrumentStateGraphCompile(stateGraph.compile.bind(stateGraph), _options);
    return stateGraph;
}

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_ts_generator":"78Tqx","../../exports.js":"1Xqap","../../semanticAttributes.js":"7WRPE","../spanstatus.js":"WiYVV","../trace.js":"eu0PU","../ai/gen-ai-attributes.js":"faK6k","../ai/messageTruncation.js":"4zJE9","../langchain/utils.js":"6eF0L","./constants.js":"h6j6H","./utils.js":"iL3ow","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"h6j6H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LANGGRAPH_INTEGRATION_NAME", function() {
    return LANGGRAPH_INTEGRATION_NAME;
});
parcelHelpers.export(exports, "LANGGRAPH_ORIGIN", function() {
    return LANGGRAPH_ORIGIN;
});
var LANGGRAPH_INTEGRATION_NAME = 'LangGraph';
var LANGGRAPH_ORIGIN = 'auto.ai.langgraph';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iL3ow":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extractModelMetadata", function() {
    return extractModelMetadata;
});
parcelHelpers.export(exports, "extractTokenUsageFromMessage", function() {
    return extractTokenUsageFromMessage;
});
parcelHelpers.export(exports, "extractToolCalls", function() {
    return extractToolCalls;
});
parcelHelpers.export(exports, "extractToolsFromCompiledGraph", function() {
    return extractToolsFromCompiledGraph;
});
parcelHelpers.export(exports, "setResponseAttributes", function() {
    return setResponseAttributes;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var _genAiAttributesJs = require("../ai/gen-ai-attributes.js");
var _utilsJs = require("../langchain/utils.js");
/**
 * Extract tool calls from messages
 */ function extractToolCalls(messages) {
    if (!messages || messages.length === 0) return null;
    var toolCalls = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = messages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var message = _step.value;
            if (message && (typeof message === "undefined" ? "undefined" : (0, _typeOf._)(message)) === 'object') {
                var _toolCalls;
                var msgToolCalls = message.tool_calls;
                if (msgToolCalls && Array.isArray(msgToolCalls)) (_toolCalls = toolCalls).push.apply(_toolCalls, (0, _toConsumableArray._)(msgToolCalls));
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return toolCalls.length > 0 ? toolCalls : null;
}
/**
 * Extract token usage from a message's usage_metadata or response_metadata
 * Returns token counts without setting span attributes
 */ function extractTokenUsageFromMessage(message) {
    var msg = message;
    var inputTokens = 0;
    var outputTokens = 0;
    var totalTokens = 0;
    // Extract from usage_metadata (newer format)
    if (msg.usage_metadata && (0, _typeOf._)(msg.usage_metadata) === 'object') {
        var usage = msg.usage_metadata;
        if (typeof usage.input_tokens === 'number') inputTokens = usage.input_tokens;
        if (typeof usage.output_tokens === 'number') outputTokens = usage.output_tokens;
        if (typeof usage.total_tokens === 'number') totalTokens = usage.total_tokens;
        return {
            inputTokens: inputTokens,
            outputTokens: outputTokens,
            totalTokens: totalTokens
        };
    }
    // Fallback: Extract from response_metadata.tokenUsage
    if (msg.response_metadata && (0, _typeOf._)(msg.response_metadata) === 'object') {
        var metadata = msg.response_metadata;
        if (metadata.tokenUsage && (0, _typeOf._)(metadata.tokenUsage) === 'object') {
            var tokenUsage = metadata.tokenUsage;
            if (typeof tokenUsage.promptTokens === 'number') inputTokens = tokenUsage.promptTokens;
            if (typeof tokenUsage.completionTokens === 'number') outputTokens = tokenUsage.completionTokens;
            if (typeof tokenUsage.totalTokens === 'number') totalTokens = tokenUsage.totalTokens;
        }
    }
    return {
        inputTokens: inputTokens,
        outputTokens: outputTokens,
        totalTokens: totalTokens
    };
}
/**
 * Extract model and finish reason from a message's response_metadata
 */ function extractModelMetadata(span, message) {
    var msg = message;
    if (msg.response_metadata && (0, _typeOf._)(msg.response_metadata) === 'object') {
        var metadata = msg.response_metadata;
        if (metadata.model_name && typeof metadata.model_name === 'string') span.setAttribute((0, _genAiAttributesJs.GEN_AI_RESPONSE_MODEL_ATTRIBUTE), metadata.model_name);
        if (metadata.finish_reason && typeof metadata.finish_reason === 'string') span.setAttribute((0, _genAiAttributesJs.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE), [
            metadata.finish_reason
        ]);
    }
}
/**
 * Extract tools from compiled graph structure
 *
 * Tools are stored in: compiledGraph.builder.nodes.tools.runnable.tools
 */ function extractToolsFromCompiledGraph(compiledGraph) {
    var _compiledGraph_builder_nodes_tools_runnable, _compiledGraph_builder_nodes_tools, _compiledGraph_builder_nodes, _compiledGraph_builder, _compiledGraph_builder_nodes_tools_runnable1, _compiledGraph_builder_nodes_tools1, _compiledGraph_builder_nodes1, _compiledGraph_builder1;
    if (!((_compiledGraph_builder = compiledGraph.builder) === null || _compiledGraph_builder === void 0 ? void 0 : (_compiledGraph_builder_nodes = _compiledGraph_builder.nodes) === null || _compiledGraph_builder_nodes === void 0 ? void 0 : (_compiledGraph_builder_nodes_tools = _compiledGraph_builder_nodes.tools) === null || _compiledGraph_builder_nodes_tools === void 0 ? void 0 : (_compiledGraph_builder_nodes_tools_runnable = _compiledGraph_builder_nodes_tools.runnable) === null || _compiledGraph_builder_nodes_tools_runnable === void 0 ? void 0 : _compiledGraph_builder_nodes_tools_runnable.tools)) return null;
    var tools = (_compiledGraph_builder1 = compiledGraph.builder) === null || _compiledGraph_builder1 === void 0 ? void 0 : (_compiledGraph_builder_nodes1 = _compiledGraph_builder1.nodes) === null || _compiledGraph_builder_nodes1 === void 0 ? void 0 : (_compiledGraph_builder_nodes_tools1 = _compiledGraph_builder_nodes1.tools) === null || _compiledGraph_builder_nodes_tools1 === void 0 ? void 0 : (_compiledGraph_builder_nodes_tools_runnable1 = _compiledGraph_builder_nodes_tools1.runnable) === null || _compiledGraph_builder_nodes_tools_runnable1 === void 0 ? void 0 : _compiledGraph_builder_nodes_tools_runnable1.tools;
    if (!tools || !Array.isArray(tools) || tools.length === 0) return null;
    // Extract name, description, and schema from each tool's lc_kwargs
    return tools.map(function(tool) {
        var _tool_lc_kwargs, _tool_lc_kwargs1, _tool_lc_kwargs2;
        return {
            name: (_tool_lc_kwargs = tool.lc_kwargs) === null || _tool_lc_kwargs === void 0 ? void 0 : _tool_lc_kwargs.name,
            description: (_tool_lc_kwargs1 = tool.lc_kwargs) === null || _tool_lc_kwargs1 === void 0 ? void 0 : _tool_lc_kwargs1.description,
            schema: (_tool_lc_kwargs2 = tool.lc_kwargs) === null || _tool_lc_kwargs2 === void 0 ? void 0 : _tool_lc_kwargs2.schema
        };
    });
}
/**
 * Set response attributes on the span
 */ function setResponseAttributes(span, inputMessages, result) {
    // Extract messages from result
    var resultObj = result;
    var outputMessages = resultObj === null || resultObj === void 0 ? void 0 : resultObj.messages;
    if (!outputMessages || !Array.isArray(outputMessages)) return;
    var _inputMessages_length;
    // Get new messages (delta between input and output)
    var inputCount = (_inputMessages_length = inputMessages === null || inputMessages === void 0 ? void 0 : inputMessages.length) !== null && _inputMessages_length !== void 0 ? _inputMessages_length : 0;
    var newMessages = outputMessages.length > inputCount ? outputMessages.slice(inputCount) : [];
    if (newMessages.length === 0) return;
    // Extract and set tool calls from new messages BEFORE normalization
    // (normalization strips tool_calls, so we need to extract them first)
    var toolCalls = extractToolCalls(newMessages);
    if (toolCalls) span.setAttribute((0, _genAiAttributesJs.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE), JSON.stringify(toolCalls));
    // Normalize the new messages
    var normalizedNewMessages = (0, _utilsJs.normalizeLangChainMessages)(newMessages);
    span.setAttribute((0, _genAiAttributesJs.GEN_AI_RESPONSE_TEXT_ATTRIBUTE), JSON.stringify(normalizedNewMessages));
    // Accumulate token usage across all messages
    var totalInputTokens = 0;
    var totalOutputTokens = 0;
    var totalTokens = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // Extract metadata from messages
        for(var _iterator = newMessages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var message = _step.value;
            // Accumulate token usage
            var tokens = extractTokenUsageFromMessage(message);
            totalInputTokens += tokens.inputTokens;
            totalOutputTokens += tokens.outputTokens;
            totalTokens += tokens.totalTokens;
            // Extract model metadata (last message's metadata wins for model/finish_reason)
            extractModelMetadata(span, message);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Set accumulated token usage on span
    if (totalInputTokens > 0) span.setAttribute((0, _genAiAttributesJs.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE), totalInputTokens);
    if (totalOutputTokens > 0) span.setAttribute((0, _genAiAttributesJs.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE), totalOutputTokens);
    if (totalTokens > 0) span.setAttribute((0, _genAiAttributesJs.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE), totalTokens);
}

},{"@swc/helpers/_/_to_consumable_array":"1eSZf","@swc/helpers/_/_type_of":"iFJdx","../ai/gen-ai-attributes.js":"faK6k","../langchain/utils.js":"6eF0L","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kjugJ":[function(require,module,exports,__globalThis) {
/**
 * Determine a breadcrumb's log level (only `warning` or `error`) based on an HTTP status code.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getBreadcrumbLogLevelFromHttpStatusCode", function() {
    return getBreadcrumbLogLevelFromHttpStatusCode;
});
function getBreadcrumbLogLevelFromHttpStatusCode(statusCode) {
    // NOTE: undefined defaults to 'info' in Sentry
    if (statusCode === undefined) return undefined;
    else if (statusCode >= 400 && statusCode < 500) return 'warning';
    else if (statusCode >= 500) return 'error';
    else return undefined;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7rXdg":[function(require,module,exports,__globalThis) {
/**
 * An error emitted by Sentry SDKs and related utilities.
 * @deprecated This class is no longer used and will be removed in a future version. Use `Error` instead.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SentryError", function() {
    return SentryError;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _inherits = require("@swc/helpers/_/_inherits");
var _wrapNativeSuper = require("@swc/helpers/_/_wrap_native_super");
var SentryError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, _inherits._)(SentryError, Error1);
    function SentryError(message) {
        var logLevel = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'warn';
        (0, _classCallCheck._)(this, SentryError);
        var _this;
        _this = (0, _callSuper._)(this, SentryError, [
            message
        ]);
        _this.message = message;
        _this.logLevel = logLevel;
        return _this;
    }
    return SentryError;
}((0, _wrapNativeSuper._)(Error));

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_inherits":"2sfqW","@swc/helpers/_/_wrap_native_super":"d0Iin","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7S2h2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addFetchEndInstrumentationHandler", function() {
    return addFetchEndInstrumentationHandler;
});
parcelHelpers.export(exports, "addFetchInstrumentationHandler", function() {
    return addFetchInstrumentationHandler;
});
parcelHelpers.export(exports, "parseFetchArgs", function() {
    return parseFetchArgs;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _isJs = require("../utils/is.js");
var _objectJs = require("../utils/object.js");
var _supportsJs = require("../utils/supports.js");
var _timeJs = require("../utils/time.js");
var _worldwideJs = require("../utils/worldwide.js");
var _handlersJs = require("./handlers.js");
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function addFetchInstrumentationHandler(handler, skipNativeFetchCheck) {
    var type = 'fetch';
    (0, _handlersJs.addHandler)(type, handler);
    (0, _handlersJs.maybeInstrument)(type, function() {
        return instrumentFetch(undefined, skipNativeFetchCheck);
    });
}
/**
 * Add an instrumentation handler for long-lived fetch requests, like consuming server-sent events (SSE) via fetch.
 * The handler will resolve the request body and emit the actual `endTimestamp`, so that the
 * span can be updated accordingly.
 *
 * Only used internally
 * @hidden
 */ function addFetchEndInstrumentationHandler(handler) {
    var type = 'fetch-body-resolved';
    (0, _handlersJs.addHandler)(type, handler);
    (0, _handlersJs.maybeInstrument)(type, function() {
        return instrumentFetch(streamHandler);
    });
}
function instrumentFetch(onFetchResolved) {
    var skipNativeFetchCheck = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (skipNativeFetchCheck && !(0, _supportsJs.supportsNativeFetch)()) return;
    (0, _objectJs.fill)((0, _worldwideJs.GLOBAL_OBJ), 'fetch', function(originalFetch) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            // We capture the error right here and not in the Promise error callback because Safari (and probably other
            // browsers too) will wipe the stack trace up to this point, only leaving us with this file which is useless.
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your fetch call did not
            //       have a stack trace, so the SDK backfilled the stack trace so
            //       you can see which fetch call failed.
            var virtualError = new Error();
            var _parseFetchArgs = parseFetchArgs(args), method = _parseFetchArgs.method, url = _parseFetchArgs.url;
            var handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: (0, _timeJs.timestampInSeconds)() * 1000,
                // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError: virtualError,
                headers: getHeadersFromFetchArgs(args)
            };
            // if there is no callback, fetch is instrumented directly
            if (!onFetchResolved) (0, _handlersJs.triggerHandlers)('fetch', (0, _objectSpread._)({}, handlerData));
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, _worldwideJs.GLOBAL_OBJ), args).then(function(response) {
                return (0, _asyncToGenerator._)(function() {
                    return (0, _tsGenerator._)(this, function(_state) {
                        if (onFetchResolved) onFetchResolved(response);
                        else (0, _handlersJs.triggerHandlers)('fetch', (0, _objectSpreadProps._)((0, _objectSpread._)({}, handlerData), {
                            endTimestamp: (0, _timeJs.timestampInSeconds)() * 1000,
                            response: response
                        }));
                        return [
                            2,
                            response
                        ];
                    });
                })();
            }, function(error) {
                (0, _handlersJs.triggerHandlers)('fetch', (0, _objectSpreadProps._)((0, _objectSpread._)({}, handlerData), {
                    endTimestamp: (0, _timeJs.timestampInSeconds)() * 1000,
                    error: error
                }));
                if ((0, _isJs.isError)(error) && error.stack === undefined) {
                    // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                    //       it means the error, that was caused by your fetch call did not
                    //       have a stack trace, so the SDK backfilled the stack trace so
                    //       you can see which fetch call failed.
                    error.stack = virtualError.stack;
                    (0, _objectJs.addNonEnumerableProperty)(error, 'framesToPop', 1);
                }
                // We enhance the not-so-helpful "Failed to fetch" error messages with the host
                // Possible messages we handle here:
                // * "Failed to fetch" (chromium)
                // * "Load failed" (webkit)
                // * "NetworkError when attempting to fetch resource." (firefox)
                if ((0, _instanceof._)(error, TypeError) && (error.message === 'Failed to fetch' || error.message === 'Load failed' || error.message === 'NetworkError when attempting to fetch resource.')) try {
                    var url = new URL(handlerData.fetchData.url);
                    error.message = "".concat(error.message, " (").concat(url.host, ")");
                } catch (e) {
                // ignore it if errors happen here
                }
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
function resolveResponse(res, onFinishedResolving) {
    return (0, _asyncToGenerator._)(function() {
        var body, responseReader, maxFetchDurationTimeout, readingActive, chunkTimeout, done, e;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(res === null || res === void 0 ? void 0 : res.body)) return [
                        3,
                        8
                    ];
                    body = res.body;
                    responseReader = body.getReader();
                    // Define a maximum duration after which we just cancel
                    maxFetchDurationTimeout = setTimeout(function() {
                        body.cancel().then(null, function() {
                        // noop
                        });
                    }, 90000);
                    readingActive = true;
                    _state.label = 1;
                case 1:
                    if (!readingActive) return [
                        3,
                        7
                    ];
                    chunkTimeout = void 0;
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        5,
                        6
                    ]);
                    // abort reading if read op takes more than 5s
                    chunkTimeout = setTimeout(function() {
                        body.cancel().then(null, function() {
                        // noop on error
                        });
                    }, 5000);
                    return [
                        4,
                        responseReader.read()
                    ];
                case 3:
                    done = _state.sent().done;
                    clearTimeout(chunkTimeout);
                    if (done) {
                        onFinishedResolving();
                        readingActive = false;
                    }
                    return [
                        3,
                        6
                    ];
                case 4:
                    e = _state.sent();
                    readingActive = false;
                    return [
                        3,
                        6
                    ];
                case 5:
                    clearTimeout(chunkTimeout);
                    return [
                        7
                    ];
                case 6:
                    return [
                        3,
                        1
                    ];
                case 7:
                    clearTimeout(maxFetchDurationTimeout);
                    responseReader.releaseLock();
                    body.cancel().then(null, function() {
                    // noop on error
                    });
                    _state.label = 8;
                case 8:
                    return [
                        2
                    ];
            }
        });
    })();
}
function streamHandler(response) {
    // clone response for awaiting stream
    var clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch (e) {
        return;
    }
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    resolveResponse(clonedResponseForResolving, function() {
        (0, _handlersJs.triggerHandlers)('fetch-body-resolved', {
            endTimestamp: (0, _timeJs.timestampInSeconds)() * 1000,
            response: response
        });
    });
}
function hasProp(obj, prop) {
    return !!obj && (typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj)) === 'object' && !!obj[prop];
}
function getUrlFromResource(resource) {
    if (typeof resource === 'string') return resource;
    if (!resource) return '';
    if (hasProp(resource, 'url')) return resource.url;
    if (resource.toString) return resource.toString();
    return '';
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function parseFetchArgs(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: 'GET',
        url: ''
    };
    if (fetchArgs.length === 2) {
        var _fetchArgs = (0, _slicedToArray._)(fetchArgs, 2), url = _fetchArgs[0], options = _fetchArgs[1];
        return {
            url: getUrlFromResource(url),
            method: hasProp(options, 'method') ? String(options.method).toUpperCase() : 'GET'
        };
    }
    var arg = fetchArgs[0];
    return {
        url: getUrlFromResource(arg),
        method: hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET'
    };
}
function getHeadersFromFetchArgs(fetchArgs) {
    var _fetchArgs = (0, _slicedToArray._)(fetchArgs, 2), requestArgument = _fetchArgs[0], optionsArgument = _fetchArgs[1];
    try {
        if ((typeof optionsArgument === "undefined" ? "undefined" : (0, _typeOf._)(optionsArgument)) === 'object' && optionsArgument !== null && 'headers' in optionsArgument && optionsArgument.headers) return new Headers(optionsArgument.headers);
        if ((0, _isJs.isRequest)(requestArgument)) return new Headers(requestArgument.headers);
    } catch (e) {
    // noop
    }
    return;
}

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_type_of":"iFJdx","@swc/helpers/_/_ts_generator":"78Tqx","../utils/is.js":"kSqSf","../utils/object.js":"9SKe9","../utils/supports.js":"63xuU","../utils/time.js":"i4V6H","../utils/worldwide.js":"3qnNR","./handlers.js":"imb6z","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"63xuU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNativeFunction", function() {
    return isNativeFunction;
});
parcelHelpers.export(exports, "supportsDOMError", function() {
    return supportsDOMError;
});
parcelHelpers.export(exports, "supportsDOMException", function() {
    return supportsDOMException;
});
parcelHelpers.export(exports, "supportsErrorEvent", function() {
    return supportsErrorEvent;
});
parcelHelpers.export(exports, "supportsFetch", function() {
    return supportsFetch;
});
parcelHelpers.export(exports, "supportsHistory", function() {
    return supportsHistory;
});
parcelHelpers.export(exports, "supportsNativeFetch", function() {
    return supportsNativeFetch;
});
parcelHelpers.export(exports, "supportsReferrerPolicy", function() {
    return supportsReferrerPolicy;
});
parcelHelpers.export(exports, "supportsReportingObserver", function() {
    return supportsReportingObserver;
});
var _debugBuildJs = require("../debug-build.js");
var _debugLoggerJs = require("./debug-logger.js");
var _worldwideJs = require("./worldwide.js");
var WINDOW = (0, _worldwideJs.GLOBAL_OBJ);
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function supportsErrorEvent() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function supportsDOMError() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function supportsDOMException() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function supportsHistory() {
    return 'history' in WINDOW && !!WINDOW.history;
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 * @deprecated This is no longer used and will be removed in a future major version.
 */ var supportsFetch = _isFetchSupported;
function _isFetchSupported() {
    if (!('fetch' in WINDOW)) return false;
    try {
        new Headers();
        // Deno requires a valid URL so '' cannot be used as an argument
        new Request('data:,');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNative checks if the given function is a native implementation
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function isNativeFunction(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function supportsNativeFetch() {
    if (typeof EdgeRuntime === 'string') return true;
    if (!_isFetchSupported()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if (isNativeFunction(WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    var result = false;
    var doc = WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        var _sandbox_contentWindow;
        var sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if ((_sandbox_contentWindow = sandbox.contentWindow) === null || _sandbox_contentWindow === void 0 ? void 0 : _sandbox_contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = isNativeFunction(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function supportsReportingObserver() {
    return 'ReportingObserver' in WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 * @deprecated This is no longer used and will be removed in a future major version.
 */ function supportsReferrerPolicy() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!_isFetchSupported()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}

},{"../debug-build.js":"ejIQP","./debug-logger.js":"3X9Vf","./worldwide.js":"3qnNR","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cknCE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isBrowser", function() {
    return isBrowser;
});
var _nodeJs = require("./node.js");
var _worldwideJs = require("./worldwide.js");
/**
 * Returns true if we are in the browser.
 */ function isBrowser() {
    // eslint-disable-next-line no-restricted-globals
    return typeof window !== 'undefined' && (!(0, _nodeJs.isNodeEnv)() || isElectronNodeRenderer());
}
// Electron renderers with nodeIntegration enabled are detected as Node.js so we specifically test for them
function isElectronNodeRenderer() {
    var process = (0, _worldwideJs.GLOBAL_OBJ).process;
    return (process === null || process === void 0 ? void 0 : process.type) === 'renderer';
}

},{"./node.js":"bvQbS","./worldwide.js":"3qnNR","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bvQbS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNodeEnv", function() {
    return isNodeEnv;
});
parcelHelpers.export(exports, "loadModule", function() {
    return loadModule;
});
var _envJs = require("./env.js");
var process = require("574201cb9668b8e7");
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the `debug` singleton, or b) put your function elsewhere.
 */ /**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, _envJs.isBrowserBundle)() && Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]';
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @param existingModule module to use for requiring
 * @returns possibly required module
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function loadModule(moduleName) {
    var existingModule = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : module;
    var mod;
    try {
        mod = dynamicRequire(existingModule, moduleName);
    } catch (e) {
    // no-empty
    }
    if (!mod) try {
        var cwd = dynamicRequire(existingModule, 'process').cwd;
        mod = dynamicRequire(existingModule, "".concat(cwd(), "/node_modules/").concat(moduleName));
    } catch (e) {
    // no-empty
    }
    return mod;
}

},{"574201cb9668b8e7":"gNLf3","./env.js":"3gTEJ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3gTEJ":[function(require,module,exports,__globalThis) {
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `debug` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSDKSource", function() {
    return getSDKSource;
});
parcelHelpers.export(exports, "isBrowserBundle", function() {
    return isBrowserBundle;
});
function isBrowserBundle() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function getSDKSource() {
    // This comment is used to identify this line in the CDN bundle build step and replace this with "return 'cdn';"
    /* __SENTRY_SDK_SOURCE__ */ return 'npm';
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6TQa7":[function(require,module,exports,__globalThis) {
/**
 * Replaces constructor functions in module exports, handling read-only properties,
 * and both default and named exports by wrapping them with the constructor.
 *
 * @param exports The module exports object to modify
 * @param exportName The name of the export to replace (e.g., 'GoogleGenAI', 'Anthropic', 'OpenAI')
 * @param wrappedConstructor The wrapped constructor function to replace the original with
 * @returns void
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "replaceExports", function() {
    return replaceExports;
});
function replaceExports(exports, exportName, wrappedConstructor) {
    var original = exports[exportName];
    if (typeof original !== 'function') return;
    // Replace the named export - handle read-only properties
    try {
        exports[exportName] = wrappedConstructor;
    } catch (error) {
        // If direct assignment fails, override the property descriptor
        Object.defineProperty(exports, exportName, {
            value: wrappedConstructor,
            writable: true,
            configurable: true,
            enumerable: true
        });
    }
    // Replace the default export if it points to the original constructor
    if (exports.default === original) try {
        exports.default = wrappedConstructor;
    } catch (error) {
        Object.defineProperty(exports, 'default', {
            value: wrappedConstructor,
            writable: true,
            configurable: true,
            enumerable: true
        });
    }
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hs5Jm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "filenameIsInApp", function() {
    return filenameIsInApp;
});
parcelHelpers.export(exports, "node", function() {
    return node;
});
parcelHelpers.export(exports, "nodeStackLineParser", function() {
    return nodeStackLineParser;
});
var _stacktraceJs = require("./stacktrace.js");
/**
 * Does this filename look like it's part of the app code?
 */ function filenameIsInApp(filename) {
    var isNative = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var isInternal = isNative || filename && // It's not internal if it's an absolute linux path
    !filename.startsWith('/') && // It's not internal if it's an absolute windows path
    !filename.match(/^[A-Z]:/) && // It's not internal if the path is starting with a dot
    !filename.startsWith('.') && // It's not internal if the frame has a protocol. In node, this is usually the case if the file got pre-processed with a bundler like webpack
    !filename.match(/^[a-zA-Z]([a-zA-Z0-9.\-+])*:\/\//); // Schema from: https://stackoverflow.com/a/3641782
    // in_app is all that's not an internal Node function or a module within node_modules
    // note that isNative appears to return true even for node core libraries
    // see https://github.com/getsentry/raven-node/issues/176
    return !isInternal && filename !== undefined && !filename.includes('node_modules/');
}
/** Node Stack line parser */ function node(getModule) {
    var FILENAME_MATCH = /^\s*[-]{4,}$/;
    var FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    var DATA_URI_MATCH = /at (?:async )?(.+?) \(data:(.*?),/;
    // eslint-disable-next-line complexity
    return function(line) {
        var dataUriMatch = line.match(DATA_URI_MATCH);
        if (dataUriMatch) return {
            filename: "<data:".concat(dataUriMatch[2], ">"),
            function: dataUriMatch[1]
        };
        var lineMatch = line.match(FULL_MATCH);
        if (lineMatch) {
            var _lineMatch_;
            var object;
            var method;
            var functionName;
            var typeName;
            var methodName;
            if (lineMatch[1]) {
                functionName = lineMatch[1];
                var methodStart = functionName.lastIndexOf('.');
                if (functionName[methodStart - 1] === '.') methodStart--;
                if (methodStart > 0) {
                    object = functionName.slice(0, methodStart);
                    method = functionName.slice(methodStart + 1);
                    var objectEnd = object.indexOf('.Module');
                    if (objectEnd > 0) {
                        functionName = functionName.slice(objectEnd + 1);
                        object = object.slice(0, objectEnd);
                    }
                }
                typeName = undefined;
            }
            if (method) {
                typeName = object;
                methodName = method;
            }
            if (method === '<anonymous>') {
                methodName = undefined;
                functionName = undefined;
            }
            if (functionName === undefined) {
                methodName = methodName || (0, _stacktraceJs.UNKNOWN_FUNCTION);
                functionName = typeName ? "".concat(typeName, ".").concat(methodName) : methodName;
            }
            var filename = ((_lineMatch_ = lineMatch[2]) === null || _lineMatch_ === void 0 ? void 0 : _lineMatch_.startsWith('file://')) ? lineMatch[2].slice(7) : lineMatch[2];
            var isNative = lineMatch[5] === 'native';
            // If it's a Windows path, trim the leading slash so that `/C:/foo` becomes `C:/foo`
            if (filename === null || filename === void 0 ? void 0 : filename.match(/\/[A-Z]:/)) filename = filename.slice(1);
            if (!filename && lineMatch[5] && !isNative) filename = lineMatch[5];
            return {
                filename: filename ? decodeURI(filename) : undefined,
                module: getModule ? getModule(filename) : undefined,
                function: functionName,
                lineno: _parseIntOrUndefined(lineMatch[3]),
                colno: _parseIntOrUndefined(lineMatch[4]),
                in_app: filenameIsInApp(filename || '', isNative)
            };
        }
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        return undefined;
    };
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/core so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function nodeStackLineParser(getModule) {
    return [
        90,
        node(getModule)
    ];
}
function _parseIntOrUndefined(input) {
    return parseInt(input || '', 10) || undefined;
}

},{"./stacktrace.js":"5srWn","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eErp3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "callFrameToStackFrame", function() {
    return callFrameToStackFrame;
});
parcelHelpers.export(exports, "watchdogTimer", function() {
    return watchdogTimer;
});
var _nodeStackTraceJs = require("./node-stack-trace.js");
var _stacktraceJs = require("./stacktrace.js");
/**
 * A node.js watchdog timer
 * @param pollInterval The interval that we expect to get polled at
 * @param anrThreshold The threshold for when we consider ANR
 * @param callback The callback to call for ANR
 * @returns An object with `poll` and `enabled` functions {@link WatchdogReturn}
 */ function watchdogTimer(createTimer, pollInterval, anrThreshold, callback) {
    var timer = createTimer();
    var triggered = false;
    var enabled = true;
    setInterval(function() {
        var diffMs = timer.getTimeMs();
        if (triggered === false && diffMs > pollInterval + anrThreshold) {
            triggered = true;
            if (enabled) callback();
        }
        if (diffMs < pollInterval + anrThreshold) triggered = false;
    }, 20);
    return {
        poll: function() {
            timer.reset();
        },
        enabled: function(state) {
            enabled = state;
        }
    };
}
// types copied from inspector.d.ts
/**
 * Converts Debugger.CallFrame to Sentry StackFrame
 */ function callFrameToStackFrame(frame, url, getModuleFromFilename) {
    var filename = url ? url.replace(/^file:\/\//, '') : undefined;
    // CallFrame row/col are 0 based, whereas StackFrame are 1 based
    var colno = frame.location.columnNumber ? frame.location.columnNumber + 1 : undefined;
    var lineno = frame.location.lineNumber ? frame.location.lineNumber + 1 : undefined;
    return {
        filename: filename,
        module: getModuleFromFilename(filename),
        function: frame.functionName || (0, _stacktraceJs.UNKNOWN_FUNCTION),
        colno: colno,
        lineno: lineno,
        in_app: filename ? (0, _nodeStackTraceJs.filenameIsInApp)(filename) : undefined
    };
}

},{"./node-stack-trace.js":"hs5Jm","./stacktrace.js":"5srWn","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ad42A":[function(require,module,exports,__globalThis) {
/** A simple Least Recently Used map */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LRUMap", function() {
    return LRUMap;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var LRUMap = /*#__PURE__*/ function() {
    "use strict";
    function LRUMap(_maxSize) {
        (0, _classCallCheck._)(this, LRUMap);
        this._maxSize = _maxSize;
        this._cache = new Map();
    }
    (0, _createClass._)(LRUMap, [
        {
            key: "size",
            get: /** Get the current size of the cache */ function get() {
                return this._cache.size;
            }
        },
        {
            /** Get an entry or undefined if it was not in the cache. Re-inserts to update the recently used order */ key: "get",
            value: function get(key) {
                var value = this._cache.get(key);
                if (value === undefined) return undefined;
                // Remove and re-insert to update the order
                this._cache.delete(key);
                this._cache.set(key, value);
                return value;
            }
        },
        {
            /** Insert an entry and evict an older entry if we've reached maxSize */ key: "set",
            value: function set(key, value) {
                if (this._cache.size >= this._maxSize) {
                    // keys() returns an iterator in insertion order so keys().next() gives us the oldest key
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    var nextKey = this._cache.keys().next().value;
                    this._cache.delete(nextKey);
                }
                this._cache.set(key, value);
            }
        },
        {
            /** Remove an entry and return the entry if it was in the cache */ key: "remove",
            value: function remove(key) {
                var value = this._cache.get(key);
                if (value) this._cache.delete(key);
                return value;
            }
        },
        {
            /** Clear all entries */ key: "clear",
            value: function clear() {
                this._cache.clear();
            }
        },
        {
            /** Get all the keys */ key: "keys",
            value: function keys() {
                return Array.from(this._cache.keys());
            }
        },
        {
            /** Get all the values */ key: "values",
            value: function values() {
                var values = [];
                this._cache.forEach(function(value) {
                    return values.push(value);
                });
                return values;
            }
        }
    ]);
    return LRUMap;
}();

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2ra8i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "vercelWaitUntil", function() {
    return vercelWaitUntil;
});
var _worldwideJs = require("./worldwide.js");
/**
 * Function that delays closing of a Vercel lambda until the provided promise is resolved.
 *
 * Vendored from https://www.npmjs.com/package/@vercel/functions
 */ function vercelWaitUntil(task) {
    var _vercelRequestContextGlobal_get;
    var vercelRequestContextGlobal = // @ts-expect-error This is not typed
    (0, _worldwideJs.GLOBAL_OBJ)[Symbol.for('@vercel/request-context')];
    var ctx = vercelRequestContextGlobal === null || vercelRequestContextGlobal === void 0 ? void 0 : (_vercelRequestContextGlobal_get = vercelRequestContextGlobal.get) === null || _vercelRequestContextGlobal_get === void 0 ? void 0 : _vercelRequestContextGlobal_get.call(vercelRequestContextGlobal);
    if (ctx === null || ctx === void 0 ? void 0 : ctx.waitUntil) ctx.waitUntil(task);
}

},{"./worldwide.js":"3qnNR","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"h8O8y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "flushIfServerless", function() {
    return flushIfServerless;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _exportsJs = require("../exports.js");
var _debugLoggerJs = require("./debug-logger.js");
var _vercelWaitUntilJs = require("./vercelWaitUntil.js");
var _worldwideJs = require("./worldwide.js");
var process = require("ce32d217476efd4");
function flushWithTimeout(timeout) {
    return (0, _asyncToGenerator._)(function() {
        var e;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    (0, _debugLoggerJs.debug).log('Flushing events...');
                    return [
                        4,
                        (0, _exportsJs.flush)(timeout)
                    ];
                case 1:
                    _state.sent();
                    (0, _debugLoggerJs.debug).log('Done flushing events');
                    return [
                        3,
                        3
                    ];
                case 2:
                    e = _state.sent();
                    (0, _debugLoggerJs.debug).log('Error while flushing events:\n', e);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
}
/**
 *  Flushes the event queue with a timeout in serverless environments to ensure that events are sent to Sentry before the
 *  serverless function execution ends.
 *
 * The function is async, but in environments that support a `waitUntil` mechanism, it will run synchronously.
 *
 * This function is aware of the following serverless platforms:
 * - Cloudflare: If a Cloudflare context is provided, it will use `ctx.waitUntil()` to flush events (keeps the `this` context of `ctx`).
 *               If a `cloudflareWaitUntil` function is provided, it will use that to flush events (looses the `this` context of `ctx`).
 * - Vercel: It detects the Vercel environment and uses Vercel's `waitUntil` function.
 * - Other Serverless (AWS Lambda, Google Cloud, etc.): It detects the environment via environment variables
 *   and uses a regular `await flush()`.
 *
 *  @internal This function is supposed for internal Sentry SDK usage only.
 *  @hidden
 */ function flushIfServerless() {
    return (0, _asyncToGenerator._)(function() {
        var params, _params_cloudflareCtx, _params_timeout, timeout, isServerless;
        var _arguments = arguments;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                    _params_timeout = params.timeout, timeout = _params_timeout === void 0 ? 2000 : _params_timeout;
                    if ('cloudflareWaitUntil' in params && typeof (params === null || params === void 0 ? void 0 : params.cloudflareWaitUntil) === 'function') {
                        params.cloudflareWaitUntil(flushWithTimeout(timeout));
                        return [
                            2
                        ];
                    }
                    if ('cloudflareCtx' in params && typeof ((_params_cloudflareCtx = params.cloudflareCtx) === null || _params_cloudflareCtx === void 0 ? void 0 : _params_cloudflareCtx.waitUntil) === 'function') {
                        params.cloudflareCtx.waitUntil(flushWithTimeout(timeout));
                        return [
                            2
                        ];
                    }
                    // @ts-expect-error This is not typed
                    if ((0, _worldwideJs.GLOBAL_OBJ)[Symbol.for('@vercel/request-context')]) {
                        // Vercel has a waitUntil equivalent that works without execution context
                        (0, _vercelWaitUntilJs.vercelWaitUntil)(flushWithTimeout(timeout));
                        return [
                            2
                        ];
                    }
                    if (typeof process === 'undefined') return [
                        2
                    ];
                    isServerless = false;
                    if (!isServerless) return [
                        3,
                        2
                    ];
                    // Use regular flush for environments without a generic waitUntil mechanism
                    return [
                        4,
                        flushWithTimeout(timeout)
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_ts_generator":"78Tqx","ce32d217476efd4":"gNLf3","../exports.js":"1Xqap","./debug-logger.js":"3X9Vf","./vercelWaitUntil.js":"2ra8i","./worldwide.js":"3qnNR","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"e5qMa":[function(require,module,exports,__globalThis) {
// Based on https://github.com/sindresorhus/escape-string-regexp but with modifications to:
//   a) reduce the size by skipping the runtime type - checking
//   b) ensure it gets down - compiled for old versions of Node(the published package only supports Node 14+).
//
// MIT License
//
// Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (https://sindresorhus.com)
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated
// documentation files(the "Software"), to deal in the Software without restriction, including without limitation
// the rights to use, copy, modify, merge, publish, distribute, sublicense, and / or sell copies of the Software, and
// to permit persons to whom the Software is furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all copies or substantial portions of
// the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO
// THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
// TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
// IN THE SOFTWARE.
/**
 * Given a string, escape characters which have meaning in the regex grammar, such that the result is safe to feed to
 * `new RegExp()`.
 *
 * @param regexString The string to escape
 * @returns An version of the string with all special regex characters escaped
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "escapeStringForRegex", function() {
    return escapeStringForRegex;
});
function escapeStringForRegex(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"Y9Rnv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lazyLoadIntegration", function() {
    return lazyLoadIntegration;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _core = require("@sentry/core");
var _helpersJs = require("../helpers.js");
// This is a map of integration function method to bundle file name.
var LazyLoadableIntegrations = {
    replayIntegration: 'replay',
    replayCanvasIntegration: 'replay-canvas',
    feedbackIntegration: 'feedback',
    feedbackModalIntegration: 'feedback-modal',
    feedbackScreenshotIntegration: 'feedback-screenshot',
    captureConsoleIntegration: 'captureconsole',
    contextLinesIntegration: 'contextlines',
    linkedErrorsIntegration: 'linkederrors',
    dedupeIntegration: 'dedupe',
    extraErrorDataIntegration: 'extraerrordata',
    graphqlClientIntegration: 'graphqlclient',
    httpClientIntegration: 'httpclient',
    reportingObserverIntegration: 'reportingobserver',
    rewriteFramesIntegration: 'rewriteframes',
    browserProfilingIntegration: 'browserprofiling',
    moduleMetadataIntegration: 'modulemetadata',
    instrumentAnthropicAiClient: 'instrumentanthropicaiclient',
    instrumentOpenAiClient: 'instrumentopenaiclient',
    instrumentGoogleGenAIClient: 'instrumentgooglegenaiclient'
};
var WindowWithMaybeIntegration = (0, _helpersJs.WINDOW);
/**
 * Lazy load an integration from the CDN.
 * Rejects if the integration cannot be loaded.
 */ function lazyLoadIntegration(name, scriptNonce) {
    return (0, _asyncToGenerator._)(function() {
        var bundle, sentryOnWindow, existing, url, script, waitForLoad, currentScript, parent, e, integrationFn;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    bundle = LazyLoadableIntegrations[name];
                    // `window.Sentry` is only set when using a CDN bundle, but this method can also be used via the NPM package
                    sentryOnWindow = WindowWithMaybeIntegration.Sentry = WindowWithMaybeIntegration.Sentry || {};
                    if (!bundle) throw new Error("Cannot lazy load integration: ".concat(name));
                    // Bail if the integration already exists
                    existing = sentryOnWindow[name];
                    // The `feedbackIntegration` is loaded by default in the CDN bundles,
                    // so we need to differentiate between the real integration and the shim.
                    // if only the shim exists, we still want to lazy load the real integration.
                    if (typeof existing === 'function' && !('_isShim' in existing)) return [
                        2,
                        existing
                    ];
                    url = getScriptURL(bundle);
                    script = (0, _helpersJs.WINDOW).document.createElement('script');
                    script.src = url;
                    script.crossOrigin = 'anonymous';
                    script.referrerPolicy = 'strict-origin';
                    if (scriptNonce) script.setAttribute('nonce', scriptNonce);
                    waitForLoad = new Promise(function(resolve, reject) {
                        script.addEventListener('load', function() {
                            return resolve();
                        });
                        script.addEventListener('error', reject);
                    });
                    currentScript = (0, _helpersJs.WINDOW).document.currentScript;
                    parent = (0, _helpersJs.WINDOW).document.body || (0, _helpersJs.WINDOW).document.head || (currentScript === null || currentScript === void 0 ? void 0 : currentScript.parentElement);
                    if (parent) parent.appendChild(script);
                    else throw new Error("Could not find parent element to insert lazy-loaded ".concat(name, " script"));
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        waitForLoad
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    throw new Error("Error when loading integration: ".concat(name));
                case 4:
                    integrationFn = sentryOnWindow[name];
                    if (typeof integrationFn !== 'function') throw new Error("Could not load integration: ".concat(name));
                    return [
                        2,
                        integrationFn
                    ];
            }
        });
    })();
}
function getScriptURL(bundle) {
    var _client_getOptions;
    var client = (0, _core.getClient)();
    var baseURL = (client === null || client === void 0 ? void 0 : (_client_getOptions = client.getOptions()) === null || _client_getOptions === void 0 ? void 0 : _client_getOptions.cdnBaseUrl) || 'https://browser.sentry-cdn.com';
    return new URL("/".concat((0, _core.SDK_VERSION), "/").concat(bundle, ".min.js"), baseURL).toString();
}

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_ts_generator":"78Tqx","@sentry/core":"lqtxA","../helpers.js":"45G1f","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"45G1f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WINDOW", function() {
    return WINDOW;
});
parcelHelpers.export(exports, "getHttpRequestData", function() {
    return getHttpRequestData;
});
parcelHelpers.export(exports, "ignoreNextOnError", function() {
    return ignoreNextOnError;
});
parcelHelpers.export(exports, "shouldIgnoreOnError", function() {
    return shouldIgnoreOnError;
});
parcelHelpers.export(exports, "wrap", function() {
    return wrap;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@sentry/core");
var WINDOW = (0, _core.GLOBAL_OBJ);
var ignoreOnError = 0;
/**
 * @hidden
 */ function shouldIgnoreOnError() {
    return ignoreOnError > 0;
}
/**
 * @hidden
 */ function ignoreNextOnError() {
    // onerror should trigger before setTimeout
    ignoreOnError++;
    setTimeout(function() {
        ignoreOnError--;
    });
}
// eslint-disable-next-line @typescript-eslint/ban-types
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function wrap(fn) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    function isFunction(fn) {
        return typeof fn === 'function';
    }
    if (!isFunction(fn)) return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        var wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === 'function') return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, _core.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    // Wrap the function itself
    // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    var sentryWrapped = function sentryWrapped() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        try {
            // Also wrap arguments that are themselves functions
            var wrappedArguments = args.map(function(arg) {
                return wrap(arg, options);
            });
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            ignoreNextOnError();
            (0, _core.withScope)(function(scope) {
                scope.addEventProcessor(function(event) {
                    if (options.mechanism) {
                        (0, _core.addExceptionTypeValue)(event, undefined, undefined);
                        (0, _core.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = (0, _objectSpreadProps._)((0, _objectSpread._)({}, event.extra), {
                        arguments: args
                    });
                    return event;
                });
                // no need to add a mechanism here, we already add it via an event processor above
                (0, _core.captureException)(ex);
            });
            throw ex;
        }
    };
    // Wrap the wrapped function in a proxy, to ensure any other properties of the original function remain available
    try {
        for(var property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (e) {
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    }
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, _core.markFunctionWrapped)(sentryWrapped, fn);
    (0, _core.addNonEnumerableProperty)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get: function get() {
                return fn.name;
            }
        });
    } catch (e) {
    // This may throw if e.g. the descriptor does not exist, or a browser does not allow redefining `name`.
    // to save some bytes we simply try-catch this
    }
    return sentryWrapped;
}
/**
 * Get HTTP request data from the current page.
 */ function getHttpRequestData() {
    // grab as much info as exists and add it to the event
    var url = (0, _core.getLocationHref)();
    var referrer = (WINDOW.document || {}).referrer;
    var userAgent = (WINDOW.navigator || {}).userAgent;
    var headers = (0, _objectSpread._)({}, referrer && {
        Referer: referrer
    }, userAgent && {
        'User-Agent': userAgent
    });
    var request = {
        url: url,
        headers: headers
    };
    return request;
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@sentry/core":"lqtxA","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"78329":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "feedbackSyncIntegration", function() {
    return feedbackSyncIntegration;
});
var _feedback = require("@sentry-internal/feedback");
/** Add a widget to capture user feedback to your application. */ var feedbackSyncIntegration = (0, _feedback.buildFeedbackIntegration)({
    getModalIntegration: function() {
        return 0, _feedback.feedbackModalIntegration;
    },
    getScreenshotIntegration: function() {
        return 0, _feedback.feedbackScreenshotIntegration;
    }
});

},{"@sentry-internal/feedback":"inibQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"k9FBA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BrowserClient", function() {
    return BrowserClient;
});
parcelHelpers.export(exports, "applyDefaultOptions", function() {
    return applyDefaultOptions;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _get = require("@swc/helpers/_/_get");
var _getPrototypeOf = require("@swc/helpers/_/_get_prototype_of");
var _inherits = require("@swc/helpers/_/_inherits");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _core = require("@sentry/core");
var _eventbuilderJs = require("./eventbuilder.js");
var _helpersJs = require("./helpers.js");
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ var BrowserClient = /*#__PURE__*/ function(Client) {
    "use strict";
    (0, _inherits._)(BrowserClient, Client);
    function BrowserClient(options) {
        (0, _classCallCheck._)(this, BrowserClient);
        var _this;
        var _opts__metadata;
        var opts = applyDefaultOptions(options);
        var sdkSource = (0, _helpersJs.WINDOW).SENTRY_SDK_SOURCE || (0, _core.getSDKSource)();
        (0, _core.applySdkMetadata)(opts, 'browser', [
            'browser'
        ], sdkSource);
        // Only allow IP inferral by Relay if sendDefaultPii is true
        if ((_opts__metadata = opts._metadata) === null || _opts__metadata === void 0 ? void 0 : _opts__metadata.sdk) opts._metadata.sdk.settings = (0, _objectSpread._)({
            infer_ip: opts.sendDefaultPii ? 'auto' : 'never'
        }, opts._metadata.sdk.settings);
        _this = (0, _callSuper._)(this, BrowserClient, [
            opts
        ]);
        var _this__options = _this._options, sendDefaultPii = _this__options.sendDefaultPii, sendClientReports = _this__options.sendClientReports, enableLogs = _this__options.enableLogs, _experiments = _this__options._experiments, enableMetricsOption = _this__options.enableMetrics;
        var _ref;
        // todo(v11): Remove the experimental flag
        // eslint-disable-next-line deprecation/deprecation
        var enableMetrics = (_ref = enableMetricsOption !== null && enableMetricsOption !== void 0 ? enableMetricsOption : _experiments === null || _experiments === void 0 ? void 0 : _experiments.enableMetrics) !== null && _ref !== void 0 ? _ref : true;
        // Flush logs and metrics when page becomes hidden (e.g., tab switch, navigation)
        // todo(v11): Remove the experimental flag
        if ((0, _helpersJs.WINDOW).document && (sendClientReports || enableLogs || enableMetrics)) (0, _helpersJs.WINDOW).document.addEventListener('visibilitychange', function() {
            if ((0, _helpersJs.WINDOW).document.visibilityState === 'hidden') {
                if (sendClientReports) _this._flushOutcomes();
                if (enableLogs) (0, _core._INTERNAL_flushLogsBuffer)(_this);
                if (enableMetrics) (0, _core._INTERNAL_flushMetricsBuffer)(_this);
            }
        });
        if (sendDefaultPii) _this.on('beforeSendSession', (0, _core.addAutoIpAddressToSession));
        return _this;
    }
    (0, _createClass._)(BrowserClient, [
        {
            /**
   * @inheritDoc
   */ key: "eventFromException",
            value: function eventFromException(exception, hint) {
                return (0, _eventbuilderJs.eventFromException)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "eventFromMessage",
            value: function eventFromMessage(message) {
                var level = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'info', hint = arguments.length > 2 ? arguments[2] : void 0;
                return (0, _eventbuilderJs.eventFromMessage)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "_prepareEvent",
            value: function _prepareEvent(event, hint, currentScope, isolationScope) {
                event.platform = event.platform || 'javascript';
                return (0, _get._)((0, _getPrototypeOf._)(BrowserClient.prototype), "_prepareEvent", this).call(this, event, hint, currentScope, isolationScope);
            }
        }
    ]);
    return BrowserClient;
}((0, _core.Client));
/** Exported only for tests. */ function applyDefaultOptions(optionsArg) {
    var _WINDOW_SENTRY_RELEASE;
    return (0, _objectSpread._)({
        release: typeof __SENTRY_RELEASE__ === 'string' // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
         ? __SENTRY_RELEASE__ : (_WINDOW_SENTRY_RELEASE = (0, _helpersJs.WINDOW).SENTRY_RELEASE) === null || _WINDOW_SENTRY_RELEASE === void 0 ? void 0 : _WINDOW_SENTRY_RELEASE.id,
        sendClientReports: true,
        // We default this to true, as it is the safer scenario
        parentSpanIsAlwaysRootSpan: true
    }, optionsArg);
}

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_get":"38TLD","@swc/helpers/_/_get_prototype_of":"5txK6","@swc/helpers/_/_inherits":"2sfqW","@swc/helpers/_/_object_spread":"9gdrV","@sentry/core":"lqtxA","./eventbuilder.js":"gS96Q","./helpers.js":"45G1f","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gS96Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "eventFromException", function() {
    return eventFromException;
});
parcelHelpers.export(exports, "eventFromMessage", function() {
    return eventFromMessage;
});
parcelHelpers.export(exports, "eventFromUnknownInput", function() {
    return eventFromUnknownInput;
});
parcelHelpers.export(exports, "exceptionFromError", function() {
    return exceptionFromError;
});
parcelHelpers.export(exports, "extractMessage", function() {
    return extractMessage;
});
parcelHelpers.export(exports, "extractType", function() {
    return extractType;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@sentry/core");
/**
 * This function creates an exception from a JavaScript Error
 */ function exceptionFromError(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    var frames = parseStackFrames(stackParser, ex);
    var exception = {
        type: extractType(ex),
        value: extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
function eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    var client = (0, _core.getClient)();
    var normalizeDepth = client === null || client === void 0 ? void 0 : client.getOptions().normalizeDepth;
    // If we can, we extract an exception from the object properties
    var errorFromProp = getErrorPropertyFromObject(exception);
    var extra = {
        __serialized__: (0, _core.normalizeToSize)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                exceptionFromError(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    var event = {
        exception: {
            values: [
                {
                    type: (0, _core.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        var frames = parseStackFrames(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                exceptionFromError(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function parseStackFrames(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    var stacktrace = ex.stacktrace || ex.stack || '';
    var skipLines = getSkipFirstStackStringLines(ex);
    var framesToPop = getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
var reactMinifiedRegexp = /Minified React error #\d+;/i;
/**
 * Certain known React errors contain links that would be falsely
 * parsed as frames. This function check for these errors and
 * returns number of the stack string lines to skip.
 */ function getSkipFirstStackStringLines(ex) {
    if (ex && reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
/**
 * If error has `framesToPop` property, it means that the
 * creator tells us the first x frames will be useless
 * and should be discarded. Typically error from wrapper function
 * which don't point to the actual location in the developer's code.
 *
 * Example: https://github.com/zertosh/invariant/blob/master/invariant.js#L46
 */ function getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === 'number') return ex.framesToPop;
    return 0;
}
// https://developer.mozilla.org/en-US/docs/WebAssembly/JavaScript_interface/Exception
// @ts-expect-error - WebAssembly.Exception is a valid class
function isWebAssemblyException(exception) {
    // Check for support
    // @ts-expect-error - WebAssembly.Exception is a valid class
    if (typeof WebAssembly !== 'undefined' && typeof WebAssembly.Exception !== 'undefined') // @ts-expect-error - WebAssembly.Exception is a valid class
    return (0, _instanceof._)(exception, WebAssembly.Exception);
    else return false;
}
/**
 * Extracts from errors what we use as the exception `type` in error events.
 *
 * Usually, this is the `name` property on Error objects but WASM errors need to be treated differently.
 */ function extractType(ex) {
    var name = ex === null || ex === void 0 ? void 0 : ex.name;
    // The name for WebAssembly.Exception Errors needs to be extracted differently.
    // Context: https://github.com/getsentry/sentry-javascript/issues/13787
    if (!name && isWebAssemblyException(ex)) {
        // Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        var hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
        return hasTypeInMessage ? ex.message[0] : 'WebAssembly.Exception';
    }
    return name;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function extractMessage(ex) {
    var message = ex === null || ex === void 0 ? void 0 : ex.message;
    if (isWebAssemblyException(ex)) {
        // For Node 18, Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        if (Array.isArray(ex.message) && ex.message.length == 2) return ex.message[1];
        return 'wasm exception';
    }
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function eventFromException(stackParser, exception, hint, attachStacktrace) {
    var syntheticException = (hint === null || hint === void 0 ? void 0 : hint.syntheticException) || undefined;
    var event = eventFromUnknownInput(stackParser, exception, syntheticException, attachStacktrace);
    (0, _core.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = 'error';
    if (hint === null || hint === void 0 ? void 0 : hint.event_id) event.event_id = hint.event_id;
    return (0, _core.resolvedSyncPromise)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function eventFromMessage(stackParser, message) {
    var level = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'info', hint = arguments.length > 3 ? arguments[3] : void 0, attachStacktrace = arguments.length > 4 ? arguments[4] : void 0;
    var syntheticException = (hint === null || hint === void 0 ? void 0 : hint.syntheticException) || undefined;
    var event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint === null || hint === void 0 ? void 0 : hint.event_id) event.event_id = hint.event_id;
    return (0, _core.resolvedSyncPromise)(event);
}
/**
 * @hidden
 */ function eventFromUnknownInput(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    var event;
    if ((0, _core.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        var errorEvent = exception;
        return eventFromError(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, _core.isDOMError)(exception) || (0, _core.isDOMException)(exception)) {
        var domException = exception;
        if ('stack' in exception) event = eventFromError(stackParser, exception);
        else {
            var name = domException.name || ((0, _core.isDOMError)(domException) ? 'DOMError' : 'DOMException');
            var message = domException.message ? "".concat(name, ": ").concat(domException.message) : name;
            event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, _core.addExceptionTypeValue)(event, message);
        }
        if ('code' in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = (0, _objectSpreadProps._)((0, _objectSpread._)({}, event.tags), {
            'DOMException.code': "".concat(domException.code)
        });
        return event;
    }
    if ((0, _core.isError)(exception)) // we have a real Error object, do nothing
    return eventFromError(stackParser, exception);
    if ((0, _core.isPlainObject)(exception) || (0, _core.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        var objectException = exception;
        event = eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, _core.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, _core.addExceptionTypeValue)(event, "".concat(exception), undefined);
    (0, _core.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
function eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    var event = {};
    if (attachStacktrace && syntheticException) {
        var frames = parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
        (0, _core.addExceptionMechanism)(event, {
            synthetic: true
        });
    }
    if ((0, _core.isParameterizedString)(message)) {
        var __sentry_template_string__ = message.__sentry_template_string__, __sentry_template_values__ = message.__sentry_template_values__;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function getNonErrorObjectExceptionValue(exception, param) {
    var isUnhandledRejection = param.isUnhandledRejection;
    var keys = (0, _core.extractExceptionKeysForMessage)(exception);
    var captureType = isUnhandledRejection ? 'promise rejection' : 'exception';
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, _core.isErrorEvent)(exception)) return "Event `ErrorEvent` captured as ".concat(captureType, " with message `").concat(exception.message, "`");
    if ((0, _core.isEvent)(exception)) {
        var className = getObjectClassName(exception);
        return "Event `".concat(className, "` (type=").concat(exception.type, ") captured as ").concat(captureType);
    }
    return "Object captured as ".concat(captureType, " with keys: ").concat(keys);
}
function getObjectClassName(obj) {
    try {
        var prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}
/** If a plain object has a property that is an `Error`, return this error. */ function getErrorPropertyFromObject(obj) {
    for(var prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        var value = obj[prop];
        if ((0, _instanceof._)(value, Error)) return value;
    }
    return undefined;
}

},{"@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@sentry/core":"lqtxA","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6NfhH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeFetchTransport", function() {
    return makeFetchTransport;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _core = require("@sentry/core");
var _browserUtils = require("@sentry-internal/browser-utils");
var DEFAULT_BROWSER_TRANSPORT_BUFFER_SIZE = 40;
/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function makeFetchTransport(options) {
    var nativeFetch = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, _browserUtils.getNativeImplementation)('fetch');
    var pendingBodySize = 0;
    var pendingCount = 0;
    function makeRequest(request) {
        return (0, _asyncToGenerator._)(function() {
            var requestSize, requestOptions, response, e;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        requestSize = request.body.length;
                        pendingBodySize += requestSize;
                        pendingCount++;
                        requestOptions = (0, _objectSpread._)({
                            body: request.body,
                            method: 'POST',
                            referrerPolicy: 'strict-origin',
                            headers: options.headers,
                            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
                            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
                            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
                            // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
                            // Gotchas:
                            // - `keepalive` isn't supported by Firefox
                            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
                            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
                            //   We will therefore only activate the flag when we're below that limit.
                            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
                            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
                            keepalive: pendingBodySize <= 60000 && pendingCount < 15
                        }, options.fetchOptions);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            nativeFetch(options.url, requestOptions)
                        ];
                    case 2:
                        response = _state.sent();
                        return [
                            2,
                            {
                                statusCode: response.status,
                                headers: {
                                    'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                                    'retry-after': response.headers.get('Retry-After')
                                }
                            }
                        ];
                    case 3:
                        e = _state.sent();
                        (0, _browserUtils.clearCachedImplementation)('fetch');
                        throw e;
                    case 4:
                        pendingBodySize -= requestSize;
                        pendingCount--;
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    return (0, _core.createTransport)(options, makeRequest, (0, _core.makePromiseBuffer)(options.bufferSize || DEFAULT_BROWSER_TRANSPORT_BUFFER_SIZE));
}

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_ts_generator":"78Tqx","@sentry/core":"lqtxA","@sentry-internal/browser-utils":"hXSTf","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hXSTf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addClsInstrumentationHandler", function() {
    return 0, _instrumentJs.addClsInstrumentationHandler;
});
parcelHelpers.export(exports, "addInpInstrumentationHandler", function() {
    return 0, _instrumentJs.addInpInstrumentationHandler;
});
parcelHelpers.export(exports, "addLcpInstrumentationHandler", function() {
    return 0, _instrumentJs.addLcpInstrumentationHandler;
});
parcelHelpers.export(exports, "addPerformanceInstrumentationHandler", function() {
    return 0, _instrumentJs.addPerformanceInstrumentationHandler;
});
parcelHelpers.export(exports, "addTtfbInstrumentationHandler", function() {
    return 0, _instrumentJs.addTtfbInstrumentationHandler;
});
parcelHelpers.export(exports, "addPerformanceEntries", function() {
    return 0, _browserMetricsJs.addPerformanceEntries;
});
parcelHelpers.export(exports, "startTrackingInteractions", function() {
    return 0, _browserMetricsJs.startTrackingInteractions;
});
parcelHelpers.export(exports, "startTrackingLongAnimationFrames", function() {
    return 0, _browserMetricsJs.startTrackingLongAnimationFrames;
});
parcelHelpers.export(exports, "startTrackingLongTasks", function() {
    return 0, _browserMetricsJs.startTrackingLongTasks;
});
parcelHelpers.export(exports, "startTrackingWebVitals", function() {
    return 0, _browserMetricsJs.startTrackingWebVitals;
});
parcelHelpers.export(exports, "startTrackingElementTiming", function() {
    return 0, _elementTimingJs.startTrackingElementTiming;
});
parcelHelpers.export(exports, "extractNetworkProtocol", function() {
    return 0, _utilsJs.extractNetworkProtocol;
});
parcelHelpers.export(exports, "addClickKeypressInstrumentationHandler", function() {
    return 0, _domJs.addClickKeypressInstrumentationHandler;
});
parcelHelpers.export(exports, "addHistoryInstrumentationHandler", function() {
    return 0, _historyJs.addHistoryInstrumentationHandler;
});
parcelHelpers.export(exports, "clearCachedImplementation", function() {
    return 0, _getNativeImplementationJs.clearCachedImplementation;
});
parcelHelpers.export(exports, "fetch", function() {
    return 0, _getNativeImplementationJs.fetch;
});
parcelHelpers.export(exports, "getNativeImplementation", function() {
    return 0, _getNativeImplementationJs.getNativeImplementation;
});
parcelHelpers.export(exports, "setTimeout", function() {
    return 0, _getNativeImplementationJs.setTimeout;
});
parcelHelpers.export(exports, "SENTRY_XHR_DATA_KEY", function() {
    return 0, _xhrJs.SENTRY_XHR_DATA_KEY;
});
parcelHelpers.export(exports, "addXhrInstrumentationHandler", function() {
    return 0, _xhrJs.addXhrInstrumentationHandler;
});
parcelHelpers.export(exports, "getBodyString", function() {
    return 0, _networkUtilsJs.getBodyString;
});
parcelHelpers.export(exports, "getFetchRequestArgBody", function() {
    return 0, _networkUtilsJs.getFetchRequestArgBody;
});
parcelHelpers.export(exports, "parseXhrResponseHeaders", function() {
    return 0, _networkUtilsJs.parseXhrResponseHeaders;
});
parcelHelpers.export(exports, "serializeFormData", function() {
    return 0, _networkUtilsJs.serializeFormData;
});
parcelHelpers.export(exports, "resourceTimingToSpanAttributes", function() {
    return 0, _resourceTimingJs.resourceTimingToSpanAttributes;
});
parcelHelpers.export(exports, "registerInpInteractionListener", function() {
    return 0, _inpJs.registerInpInteractionListener;
});
parcelHelpers.export(exports, "startTrackingINP", function() {
    return 0, _inpJs.startTrackingINP;
});
var _instrumentJs = require("./metrics/instrument.js");
var _browserMetricsJs = require("./metrics/browserMetrics.js");
var _elementTimingJs = require("./metrics/elementTiming.js");
var _utilsJs = require("./metrics/utils.js");
var _domJs = require("./instrument/dom.js");
var _historyJs = require("./instrument/history.js");
var _getNativeImplementationJs = require("./getNativeImplementation.js");
var _xhrJs = require("./instrument/xhr.js");
var _networkUtilsJs = require("./networkUtils.js");
var _resourceTimingJs = require("./metrics/resourceTiming.js");
var _inpJs = require("./metrics/inp.js");

},{"./metrics/instrument.js":"5FnSf","./metrics/browserMetrics.js":"esMPd","./metrics/elementTiming.js":"ds3S5","./metrics/utils.js":"5IDN9","./instrument/dom.js":"8Gply","./instrument/history.js":"fEFCc","./getNativeImplementation.js":"8WTkI","./instrument/xhr.js":"3x1ca","./networkUtils.js":"700nK","./metrics/resourceTiming.js":"5xNEV","./metrics/inp.js":"6KXEx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5FnSf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addClsInstrumentationHandler", function() {
    return addClsInstrumentationHandler;
});
parcelHelpers.export(exports, "addInpInstrumentationHandler", function() {
    return addInpInstrumentationHandler;
});
parcelHelpers.export(exports, "addLcpInstrumentationHandler", function() {
    return addLcpInstrumentationHandler;
});
parcelHelpers.export(exports, "addPerformanceInstrumentationHandler", function() {
    return addPerformanceInstrumentationHandler;
});
parcelHelpers.export(exports, "addTtfbInstrumentationHandler", function() {
    return addTtfbInstrumentationHandler;
});
parcelHelpers.export(exports, "isPerformanceEventTiming", function() {
    return isPerformanceEventTiming;
});
var _core = require("@sentry/core");
var _debugBuildJs = require("../debug-build.js");
var _getCLSJs = require("./web-vitals/getCLS.js");
var _getINPJs = require("./web-vitals/getINP.js");
var _getLCPJs = require("./web-vitals/getLCP.js");
var _observeJs = require("./web-vitals/lib/observe.js");
var _onTTFBJs = require("./web-vitals/onTTFB.js");
var handlers = {};
var instrumented = {};
var _previousCls;
var _previousLcp;
var _previousTtfb;
var _previousInp;
/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for CLS when the cleanup callback is called.
 * This will lead to the CLS being finalized and frozen.
 */ function addClsInstrumentationHandler(callback) {
    var stopOnCallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return addMetricObserver('cls', callback, instrumentCls, _previousCls, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for LCP when the cleanup callback is called.
 * This will lead to the LCP being finalized and frozen.
 */ function addLcpInstrumentationHandler(callback) {
    var stopOnCallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return addMetricObserver('lcp', callback, instrumentLcp, _previousLcp, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a TTFD metric is available.
 */ function addTtfbInstrumentationHandler(callback) {
    return addMetricObserver('ttfb', callback, instrumentTtfb, _previousTtfb);
}
/**
 * Add a callback that will be triggered when a INP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function addInpInstrumentationHandler(callback) {
    return addMetricObserver('inp', callback, instrumentInp, _previousInp);
}
/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function addPerformanceInstrumentationHandler(type, callback) {
    addHandler(type, callback);
    if (!instrumented[type]) {
        instrumentPerformanceObserver(type);
        instrumented[type] = true;
    }
    return getCleanupCallback(type, callback);
}
/** Trigger all handlers of a given type. */ function triggerHandlers(type, data) {
    var typeHandlers = handlers[type];
    if (!(typeHandlers === null || typeHandlers === void 0 ? void 0 : typeHandlers.length)) return;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = typeHandlers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var handler = _step.value;
            try {
                handler(data);
            } catch (e) {
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).error("Error while triggering instrumentation handler.\nType: ".concat(type, "\nName: ").concat((0, _core.getFunctionName)(handler), "\nError:"), e);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function instrumentCls() {
    return (0, _getCLSJs.onCLS)(function(metric) {
        triggerHandlers('cls', {
            metric: metric
        });
        _previousCls = metric;
    }, // We want the callback to be called whenever the CLS value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function instrumentLcp() {
    return (0, _getLCPJs.onLCP)(function(metric) {
        triggerHandlers('lcp', {
            metric: metric
        });
        _previousLcp = metric;
    }, // We want the callback to be called whenever the LCP value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function instrumentTtfb() {
    return (0, _onTTFBJs.onTTFB)(function(metric) {
        triggerHandlers('ttfb', {
            metric: metric
        });
        _previousTtfb = metric;
    });
}
function instrumentInp() {
    return (0, _getINPJs.onINP)(function(metric) {
        triggerHandlers('inp', {
            metric: metric
        });
        _previousInp = metric;
    });
}
function addMetricObserver(type, callback, instrumentFn, previousValue) {
    var stopOnCallback = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    addHandler(type, callback);
    var stopListening;
    if (!instrumented[type]) {
        stopListening = instrumentFn();
        instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return getCleanupCallback(type, callback, stopOnCallback ? stopListening : undefined);
}
function instrumentPerformanceObserver(type) {
    var options = {};
    // Special per-type options we want to use
    if (type === 'event') options.durationThreshold = 0;
    (0, _observeJs.observe)(type, function(entries) {
        triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function addHandler(type, handler) {
    handlers[type] = handlers[type] || [];
    handlers[type].push(handler);
}
// Get a callback which can be called to remove the instrumentation handler
function getCleanupCallback(type, callback, stopListening) {
    return function() {
        if (stopListening) stopListening();
        var typeHandlers = handlers[type];
        if (!typeHandlers) return;
        var index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}
/**
 * Check if a PerformanceEntry is a PerformanceEventTiming by checking for the `duration` property.
 */ function isPerformanceEventTiming(entry) {
    return 'duration' in entry;
}

},{"@sentry/core":"7plmH","../debug-build.js":"jrbj2","./web-vitals/getCLS.js":"cls7N","./web-vitals/getINP.js":"308V2","./web-vitals/getLCP.js":"94v74","./web-vitals/lib/observe.js":"2fG7S","./web-vitals/onTTFB.js":"bVY0k","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7plmH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "registerSpanErrorInstrumentation", function() {
    return 0, _errorsJs.registerSpanErrorInstrumentation;
});
parcelHelpers.export(exports, "getCapturedScopesOnSpan", function() {
    return 0, _utilsJs.getCapturedScopesOnSpan;
});
parcelHelpers.export(exports, "setCapturedScopesOnSpan", function() {
    return 0, _utilsJs.setCapturedScopesOnSpan;
});
parcelHelpers.export(exports, "TRACING_DEFAULTS", function() {
    return 0, _idleSpanJs.TRACING_DEFAULTS;
});
parcelHelpers.export(exports, "startIdleSpan", function() {
    return 0, _idleSpanJs.startIdleSpan;
});
parcelHelpers.export(exports, "SentrySpan", function() {
    return 0, _sentrySpanJs.SentrySpan;
});
parcelHelpers.export(exports, "SentryNonRecordingSpan", function() {
    return 0, _sentryNonRecordingSpanJs.SentryNonRecordingSpan;
});
parcelHelpers.export(exports, "SPAN_STATUS_ERROR", function() {
    return 0, _spanstatusJs.SPAN_STATUS_ERROR;
});
parcelHelpers.export(exports, "SPAN_STATUS_OK", function() {
    return 0, _spanstatusJs.SPAN_STATUS_OK;
});
parcelHelpers.export(exports, "SPAN_STATUS_UNSET", function() {
    return 0, _spanstatusJs.SPAN_STATUS_UNSET;
});
parcelHelpers.export(exports, "getSpanStatusFromHttpCode", function() {
    return 0, _spanstatusJs.getSpanStatusFromHttpCode;
});
parcelHelpers.export(exports, "setHttpStatus", function() {
    return 0, _spanstatusJs.setHttpStatus;
});
parcelHelpers.export(exports, "continueTrace", function() {
    return 0, _traceJs.continueTrace;
});
parcelHelpers.export(exports, "startInactiveSpan", function() {
    return 0, _traceJs.startInactiveSpan;
});
parcelHelpers.export(exports, "startNewTrace", function() {
    return 0, _traceJs.startNewTrace;
});
parcelHelpers.export(exports, "startSpan", function() {
    return 0, _traceJs.startSpan;
});
parcelHelpers.export(exports, "startSpanManual", function() {
    return 0, _traceJs.startSpanManual;
});
parcelHelpers.export(exports, "suppressTracing", function() {
    return 0, _traceJs.suppressTracing;
});
parcelHelpers.export(exports, "withActiveSpan", function() {
    return 0, _traceJs.withActiveSpan;
});
parcelHelpers.export(exports, "getDynamicSamplingContextFromClient", function() {
    return 0, _dynamicSamplingContextJs.getDynamicSamplingContextFromClient;
});
parcelHelpers.export(exports, "getDynamicSamplingContextFromScope", function() {
    return 0, _dynamicSamplingContextJs.getDynamicSamplingContextFromScope;
});
parcelHelpers.export(exports, "getDynamicSamplingContextFromSpan", function() {
    return 0, _dynamicSamplingContextJs.getDynamicSamplingContextFromSpan;
});
parcelHelpers.export(exports, "spanToBaggageHeader", function() {
    return 0, _dynamicSamplingContextJs.spanToBaggageHeader;
});
parcelHelpers.export(exports, "setMeasurement", function() {
    return 0, _measurementJs.setMeasurement;
});
parcelHelpers.export(exports, "timedEventsToMeasurements", function() {
    return 0, _measurementJs.timedEventsToMeasurements;
});
parcelHelpers.export(exports, "sampleSpan", function() {
    return 0, _samplingJs.sampleSpan;
});
parcelHelpers.export(exports, "logSpanEnd", function() {
    return 0, _logSpansJs.logSpanEnd;
});
parcelHelpers.export(exports, "logSpanStart", function() {
    return 0, _logSpansJs.logSpanStart;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_CACHE_HIT", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_CACHE_HIT;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_CACHE_KEY", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_CACHE_KEY;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_PROFILE_ID", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_PROFILE_ID;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_OP", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_URL_FULL", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_URL_FULL;
});
parcelHelpers.export(exports, "SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE", function() {
    return 0, _semanticAttributesJs.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE;
});
parcelHelpers.export(exports, "createEventEnvelope", function() {
    return 0, _envelopeJs.createEventEnvelope;
});
parcelHelpers.export(exports, "createSessionEnvelope", function() {
    return 0, _envelopeJs.createSessionEnvelope;
});
parcelHelpers.export(exports, "createSpanEnvelope", function() {
    return 0, _envelopeJs.createSpanEnvelope;
});
parcelHelpers.export(exports, "addEventProcessor", function() {
    return 0, _exportsJs.addEventProcessor;
});
parcelHelpers.export(exports, "captureCheckIn", function() {
    return 0, _exportsJs.captureCheckIn;
});
parcelHelpers.export(exports, "captureEvent", function() {
    return 0, _exportsJs.captureEvent;
});
parcelHelpers.export(exports, "captureException", function() {
    return 0, _exportsJs.captureException;
});
parcelHelpers.export(exports, "captureMessage", function() {
    return 0, _exportsJs.captureMessage;
});
parcelHelpers.export(exports, "captureSession", function() {
    return 0, _exportsJs.captureSession;
});
parcelHelpers.export(exports, "close", function() {
    return 0, _exportsJs.close;
});
parcelHelpers.export(exports, "endSession", function() {
    return 0, _exportsJs.endSession;
});
parcelHelpers.export(exports, "flush", function() {
    return 0, _exportsJs.flush;
});
parcelHelpers.export(exports, "isEnabled", function() {
    return 0, _exportsJs.isEnabled;
});
parcelHelpers.export(exports, "isInitialized", function() {
    return 0, _exportsJs.isInitialized;
});
parcelHelpers.export(exports, "lastEventId", function() {
    return 0, _exportsJs.lastEventId;
});
parcelHelpers.export(exports, "setContext", function() {
    return 0, _exportsJs.setContext;
});
parcelHelpers.export(exports, "setExtra", function() {
    return 0, _exportsJs.setExtra;
});
parcelHelpers.export(exports, "setExtras", function() {
    return 0, _exportsJs.setExtras;
});
parcelHelpers.export(exports, "setTag", function() {
    return 0, _exportsJs.setTag;
});
parcelHelpers.export(exports, "setTags", function() {
    return 0, _exportsJs.setTags;
});
parcelHelpers.export(exports, "setUser", function() {
    return 0, _exportsJs.setUser;
});
parcelHelpers.export(exports, "startSession", function() {
    return 0, _exportsJs.startSession;
});
parcelHelpers.export(exports, "withMonitor", function() {
    return 0, _exportsJs.withMonitor;
});
parcelHelpers.export(exports, "getClient", function() {
    return 0, _currentScopesJs.getClient;
});
parcelHelpers.export(exports, "getCurrentScope", function() {
    return 0, _currentScopesJs.getCurrentScope;
});
parcelHelpers.export(exports, "getGlobalScope", function() {
    return 0, _currentScopesJs.getGlobalScope;
});
parcelHelpers.export(exports, "getIsolationScope", function() {
    return 0, _currentScopesJs.getIsolationScope;
});
parcelHelpers.export(exports, "getTraceContextFromScope", function() {
    return 0, _currentScopesJs.getTraceContextFromScope;
});
parcelHelpers.export(exports, "withIsolationScope", function() {
    return 0, _currentScopesJs.withIsolationScope;
});
parcelHelpers.export(exports, "withScope", function() {
    return 0, _currentScopesJs.withScope;
});
parcelHelpers.export(exports, "getDefaultCurrentScope", function() {
    return 0, _defaultScopesJs.getDefaultCurrentScope;
});
parcelHelpers.export(exports, "getDefaultIsolationScope", function() {
    return 0, _defaultScopesJs.getDefaultIsolationScope;
});
parcelHelpers.export(exports, "setAsyncContextStrategy", function() {
    return 0, _indexJs.setAsyncContextStrategy;
});
parcelHelpers.export(exports, "getGlobalSingleton", function() {
    return 0, _carrierJs.getGlobalSingleton;
});
parcelHelpers.export(exports, "getMainCarrier", function() {
    return 0, _carrierJs.getMainCarrier;
});
parcelHelpers.export(exports, "closeSession", function() {
    return 0, _sessionJs.closeSession;
});
parcelHelpers.export(exports, "makeSession", function() {
    return 0, _sessionJs.makeSession;
});
parcelHelpers.export(exports, "updateSession", function() {
    return 0, _sessionJs.updateSession;
});
parcelHelpers.export(exports, "Scope", function() {
    return 0, _scopeJs.Scope;
});
parcelHelpers.export(exports, "notifyEventProcessors", function() {
    return 0, _eventProcessorsJs.notifyEventProcessors;
});
parcelHelpers.export(exports, "getEnvelopeEndpointWithUrlEncodedAuth", function() {
    return 0, _apiJs.getEnvelopeEndpointWithUrlEncodedAuth;
});
parcelHelpers.export(exports, "getReportDialogEndpoint", function() {
    return 0, _apiJs.getReportDialogEndpoint;
});
parcelHelpers.export(exports, "Client", function() {
    return 0, _clientJs.Client;
});
parcelHelpers.export(exports, "ServerRuntimeClient", function() {
    return 0, _serverRuntimeClientJs.ServerRuntimeClient;
});
parcelHelpers.export(exports, "initAndBind", function() {
    return 0, _sdkJs.initAndBind;
});
parcelHelpers.export(exports, "setCurrentClient", function() {
    return 0, _sdkJs.setCurrentClient;
});
parcelHelpers.export(exports, "createTransport", function() {
    return 0, _baseJs.createTransport;
});
parcelHelpers.export(exports, "makeOfflineTransport", function() {
    return 0, _offlineJs.makeOfflineTransport;
});
parcelHelpers.export(exports, "makeMultiplexedTransport", function() {
    return 0, _multiplexedJs.makeMultiplexedTransport;
});
parcelHelpers.export(exports, "addIntegration", function() {
    return 0, _integrationJs.addIntegration;
});
parcelHelpers.export(exports, "defineIntegration", function() {
    return 0, _integrationJs.defineIntegration;
});
parcelHelpers.export(exports, "getIntegrationsToSetup", function() {
    return 0, _integrationJs.getIntegrationsToSetup;
});
parcelHelpers.export(exports, "installedIntegrations", function() {
    return 0, _integrationJs.installedIntegrations;
});
parcelHelpers.export(exports, "_INTERNAL_clearAiProviderSkips", function() {
    return 0, _providerSkipJs._INTERNAL_clearAiProviderSkips;
});
parcelHelpers.export(exports, "_INTERNAL_shouldSkipAiProviderWrapping", function() {
    return 0, _providerSkipJs._INTERNAL_shouldSkipAiProviderWrapping;
});
parcelHelpers.export(exports, "_INTERNAL_skipAiProviderWrapping", function() {
    return 0, _providerSkipJs._INTERNAL_skipAiProviderWrapping;
});
parcelHelpers.export(exports, "applyScopeDataToEvent", function() {
    return 0, _applyScopeDataToEventJs.applyScopeDataToEvent;
});
parcelHelpers.export(exports, "mergeScopeData", function() {
    return 0, _applyScopeDataToEventJs.mergeScopeData;
});
parcelHelpers.export(exports, "prepareEvent", function() {
    return 0, _prepareEventJs.prepareEvent;
});
parcelHelpers.export(exports, "createCheckInEnvelope", function() {
    return 0, _checkinJs.createCheckInEnvelope;
});
parcelHelpers.export(exports, "hasSpansEnabled", function() {
    return 0, _hasSpansEnabledJs.hasSpansEnabled;
});
parcelHelpers.export(exports, "isSentryRequestUrl", function() {
    return 0, _isSentryRequestUrlJs.isSentryRequestUrl;
});
parcelHelpers.export(exports, "handleCallbackErrors", function() {
    return 0, _handleCallbackErrorsJs.handleCallbackErrors;
});
parcelHelpers.export(exports, "fmt", function() {
    return 0, _parameterizeJs.fmt;
});
parcelHelpers.export(exports, "parameterize", function() {
    return 0, _parameterizeJs.parameterize;
});
parcelHelpers.export(exports, "addAutoIpAddressToSession", function() {
    return 0, _ipAddressJs.addAutoIpAddressToSession;
});
parcelHelpers.export(exports, "addAutoIpAddressToUser", function() {
    return 0, _ipAddressJs.addAutoIpAddressToUser;
});
parcelHelpers.export(exports, "addChildSpanToSpan", function() {
    return 0, _spanUtilsJs.addChildSpanToSpan;
});
parcelHelpers.export(exports, "convertSpanLinksForEnvelope", function() {
    return 0, _spanUtilsJs.convertSpanLinksForEnvelope;
});
parcelHelpers.export(exports, "getActiveSpan", function() {
    return 0, _spanUtilsJs.getActiveSpan;
});
parcelHelpers.export(exports, "getRootSpan", function() {
    return 0, _spanUtilsJs.getRootSpan;
});
parcelHelpers.export(exports, "getSpanDescendants", function() {
    return 0, _spanUtilsJs.getSpanDescendants;
});
parcelHelpers.export(exports, "getStatusMessage", function() {
    return 0, _spanUtilsJs.getStatusMessage;
});
parcelHelpers.export(exports, "spanIsSampled", function() {
    return 0, _spanUtilsJs.spanIsSampled;
});
parcelHelpers.export(exports, "spanTimeInputToSeconds", function() {
    return 0, _spanUtilsJs.spanTimeInputToSeconds;
});
parcelHelpers.export(exports, "spanToJSON", function() {
    return 0, _spanUtilsJs.spanToJSON;
});
parcelHelpers.export(exports, "spanToTraceContext", function() {
    return 0, _spanUtilsJs.spanToTraceContext;
});
parcelHelpers.export(exports, "spanToTraceHeader", function() {
    return 0, _spanUtilsJs.spanToTraceHeader;
});
parcelHelpers.export(exports, "updateSpanName", function() {
    return 0, _spanUtilsJs.updateSpanName;
});
parcelHelpers.export(exports, "_INTERNAL_setSpanForScope", function() {
    return 0, _spanOnScopeJs._setSpanForScope;
});
parcelHelpers.export(exports, "parseSampleRate", function() {
    return 0, _parseSampleRateJs.parseSampleRate;
});
parcelHelpers.export(exports, "applySdkMetadata", function() {
    return 0, _sdkMetadataJs.applySdkMetadata;
});
parcelHelpers.export(exports, "getTraceData", function() {
    return 0, _traceDataJs.getTraceData;
});
parcelHelpers.export(exports, "getTraceMetaTags", function() {
    return 0, _metaJs.getTraceMetaTags;
});
parcelHelpers.export(exports, "debounce", function() {
    return 0, _debounceJs.debounce;
});
parcelHelpers.export(exports, "extractQueryParamsFromUrl", function() {
    return 0, _requestJs.extractQueryParamsFromUrl;
});
parcelHelpers.export(exports, "headersToDict", function() {
    return 0, _requestJs.headersToDict;
});
parcelHelpers.export(exports, "httpHeadersToSpanAttributes", function() {
    return 0, _requestJs.httpHeadersToSpanAttributes;
});
parcelHelpers.export(exports, "httpRequestToRequestData", function() {
    return 0, _requestJs.httpRequestToRequestData;
});
parcelHelpers.export(exports, "winterCGHeadersToDict", function() {
    return 0, _requestJs.winterCGHeadersToDict;
});
parcelHelpers.export(exports, "winterCGRequestToRequestData", function() {
    return 0, _requestJs.winterCGRequestToRequestData;
});
parcelHelpers.export(exports, "DEFAULT_ENVIRONMENT", function() {
    return 0, _constantsJs.DEFAULT_ENVIRONMENT;
});
parcelHelpers.export(exports, "addBreadcrumb", function() {
    return 0, _breadcrumbsJs.addBreadcrumb;
});
parcelHelpers.export(exports, "functionToStringIntegration", function() {
    return 0, _functiontostringJs.functionToStringIntegration;
});
parcelHelpers.export(exports, "eventFiltersIntegration", function() {
    return 0, _eventFiltersJs.eventFiltersIntegration;
});
parcelHelpers.export(exports, "inboundFiltersIntegration", function() {
    return 0, _eventFiltersJs.inboundFiltersIntegration;
});
parcelHelpers.export(exports, "linkedErrorsIntegration", function() {
    return 0, _linkederrorsJs.linkedErrorsIntegration;
});
parcelHelpers.export(exports, "moduleMetadataIntegration", function() {
    return 0, _moduleMetadataJs.moduleMetadataIntegration;
});
parcelHelpers.export(exports, "requestDataIntegration", function() {
    return 0, _requestdataJs.requestDataIntegration;
});
parcelHelpers.export(exports, "captureConsoleIntegration", function() {
    return 0, _captureconsoleJs.captureConsoleIntegration;
});
parcelHelpers.export(exports, "dedupeIntegration", function() {
    return 0, _dedupeJs.dedupeIntegration;
});
parcelHelpers.export(exports, "extraErrorDataIntegration", function() {
    return 0, _extraerrordataJs.extraErrorDataIntegration;
});
parcelHelpers.export(exports, "rewriteFramesIntegration", function() {
    return 0, _rewriteframesJs.rewriteFramesIntegration;
});
parcelHelpers.export(exports, "instrumentSupabaseClient", function() {
    return 0, _supabaseJs.instrumentSupabaseClient;
});
parcelHelpers.export(exports, "supabaseIntegration", function() {
    return 0, _supabaseJs.supabaseIntegration;
});
parcelHelpers.export(exports, "zodErrorsIntegration", function() {
    return 0, _zoderrorsJs.zodErrorsIntegration;
});
parcelHelpers.export(exports, "thirdPartyErrorFilterIntegration", function() {
    return 0, _thirdPartyErrorsFilterJs.thirdPartyErrorFilterIntegration;
});
parcelHelpers.export(exports, "consoleIntegration", function() {
    return 0, _consoleJs.consoleIntegration;
});
parcelHelpers.export(exports, "featureFlagsIntegration", function() {
    return 0, _featureFlagsIntegrationJs.featureFlagsIntegration;
});
parcelHelpers.export(exports, "growthbookIntegration", function() {
    return 0, _growthbookJs.growthbookIntegration;
});
parcelHelpers.export(exports, "profiler", function() {
    return 0, _profilingJs.profiler;
});
parcelHelpers.export(exports, "instrumentFetchRequest", function() {
    return 0, _fetchJs.instrumentFetchRequest;
});
parcelHelpers.export(exports, "trpcMiddleware", function() {
    return 0, _trpcJs.trpcMiddleware;
});
parcelHelpers.export(exports, "wrapMcpServerWithSentry", function() {
    return 0, _indexJs1.wrapMcpServerWithSentry;
});
parcelHelpers.export(exports, "captureFeedback", function() {
    return 0, _feedbackJs.captureFeedback;
});
parcelHelpers.export(exports, "_INTERNAL_captureLog", function() {
    return 0, _internalJs._INTERNAL_captureLog;
});
parcelHelpers.export(exports, "_INTERNAL_captureSerializedLog", function() {
    return 0, _internalJs._INTERNAL_captureSerializedLog;
});
parcelHelpers.export(exports, "_INTERNAL_flushLogsBuffer", function() {
    return 0, _internalJs._INTERNAL_flushLogsBuffer;
});
parcelHelpers.export(exports, "consoleLoggingIntegration", function() {
    return 0, _consoleIntegrationJs.consoleLoggingIntegration;
});
parcelHelpers.export(exports, "_INTERNAL_captureMetric", function() {
    return 0, _internalJs1._INTERNAL_captureMetric;
});
parcelHelpers.export(exports, "_INTERNAL_captureSerializedMetric", function() {
    return 0, _internalJs1._INTERNAL_captureSerializedMetric;
});
parcelHelpers.export(exports, "_INTERNAL_flushMetricsBuffer", function() {
    return 0, _internalJs1._INTERNAL_flushMetricsBuffer;
});
parcelHelpers.export(exports, "createConsolaReporter", function() {
    return 0, _consolaJs.createConsolaReporter;
});
parcelHelpers.export(exports, "addVercelAiProcessors", function() {
    return 0, _indexJs2.addVercelAiProcessors;
});
parcelHelpers.export(exports, "_INTERNAL_cleanupToolCallSpan", function() {
    return 0, _utilsJs1._INTERNAL_cleanupToolCallSpan;
});
parcelHelpers.export(exports, "_INTERNAL_getSpanForToolCallId", function() {
    return 0, _utilsJs1._INTERNAL_getSpanForToolCallId;
});
parcelHelpers.export(exports, "instrumentOpenAiClient", function() {
    return 0, _indexJs3.instrumentOpenAiClient;
});
parcelHelpers.export(exports, "OPENAI_INTEGRATION_NAME", function() {
    return 0, _constantsJs1.OPENAI_INTEGRATION_NAME;
});
parcelHelpers.export(exports, "instrumentAnthropicAiClient", function() {
    return 0, _indexJs4.instrumentAnthropicAiClient;
});
parcelHelpers.export(exports, "ANTHROPIC_AI_INTEGRATION_NAME", function() {
    return 0, _constantsJs2.ANTHROPIC_AI_INTEGRATION_NAME;
});
parcelHelpers.export(exports, "instrumentGoogleGenAIClient", function() {
    return 0, _indexJs5.instrumentGoogleGenAIClient;
});
parcelHelpers.export(exports, "GOOGLE_GENAI_INTEGRATION_NAME", function() {
    return 0, _constantsJs3.GOOGLE_GENAI_INTEGRATION_NAME;
});
parcelHelpers.export(exports, "createLangChainCallbackHandler", function() {
    return 0, _indexJs6.createLangChainCallbackHandler;
});
parcelHelpers.export(exports, "LANGCHAIN_INTEGRATION_NAME", function() {
    return 0, _constantsJs4.LANGCHAIN_INTEGRATION_NAME;
});
parcelHelpers.export(exports, "instrumentLangGraph", function() {
    return 0, _indexJs7.instrumentLangGraph;
});
parcelHelpers.export(exports, "instrumentStateGraphCompile", function() {
    return 0, _indexJs7.instrumentStateGraphCompile;
});
parcelHelpers.export(exports, "LANGGRAPH_INTEGRATION_NAME", function() {
    return 0, _constantsJs5.LANGGRAPH_INTEGRATION_NAME;
});
parcelHelpers.export(exports, "_INTERNAL_FLAG_BUFFER_SIZE", function() {
    return 0, _featureFlagsJs._INTERNAL_FLAG_BUFFER_SIZE;
});
parcelHelpers.export(exports, "_INTERNAL_MAX_FLAGS_PER_SPAN", function() {
    return 0, _featureFlagsJs._INTERNAL_MAX_FLAGS_PER_SPAN;
});
parcelHelpers.export(exports, "_INTERNAL_addFeatureFlagToActiveSpan", function() {
    return 0, _featureFlagsJs._INTERNAL_addFeatureFlagToActiveSpan;
});
parcelHelpers.export(exports, "_INTERNAL_copyFlagsFromScopeToEvent", function() {
    return 0, _featureFlagsJs._INTERNAL_copyFlagsFromScopeToEvent;
});
parcelHelpers.export(exports, "_INTERNAL_insertFlagToScope", function() {
    return 0, _featureFlagsJs._INTERNAL_insertFlagToScope;
});
parcelHelpers.export(exports, "applyAggregateErrorsToEvent", function() {
    return 0, _aggregateErrorsJs.applyAggregateErrorsToEvent;
});
parcelHelpers.export(exports, "getBreadcrumbLogLevelFromHttpStatusCode", function() {
    return 0, _breadcrumbLogLevelJs.getBreadcrumbLogLevelFromHttpStatusCode;
});
parcelHelpers.export(exports, "getComponentName", function() {
    return 0, _browserJs.getComponentName;
});
parcelHelpers.export(exports, "getLocationHref", function() {
    return 0, _browserJs.getLocationHref;
});
parcelHelpers.export(exports, "htmlTreeAsString", function() {
    return 0, _browserJs.htmlTreeAsString;
});
parcelHelpers.export(exports, "dsnFromString", function() {
    return 0, _dsnJs.dsnFromString;
});
parcelHelpers.export(exports, "dsnToString", function() {
    return 0, _dsnJs.dsnToString;
});
parcelHelpers.export(exports, "makeDsn", function() {
    return 0, _dsnJs.makeDsn;
});
parcelHelpers.export(exports, "SentryError", function() {
    return 0, _errorJs.SentryError;
});
parcelHelpers.export(exports, "GLOBAL_OBJ", function() {
    return 0, _worldwideJs.GLOBAL_OBJ;
});
parcelHelpers.export(exports, "addConsoleInstrumentationHandler", function() {
    return 0, _consoleJs1.addConsoleInstrumentationHandler;
});
parcelHelpers.export(exports, "addFetchEndInstrumentationHandler", function() {
    return 0, _fetchJs1.addFetchEndInstrumentationHandler;
});
parcelHelpers.export(exports, "addFetchInstrumentationHandler", function() {
    return 0, _fetchJs1.addFetchInstrumentationHandler;
});
parcelHelpers.export(exports, "addGlobalErrorInstrumentationHandler", function() {
    return 0, _globalErrorJs.addGlobalErrorInstrumentationHandler;
});
parcelHelpers.export(exports, "addGlobalUnhandledRejectionInstrumentationHandler", function() {
    return 0, _globalUnhandledRejectionJs.addGlobalUnhandledRejectionInstrumentationHandler;
});
parcelHelpers.export(exports, "addHandler", function() {
    return 0, _handlersJs.addHandler;
});
parcelHelpers.export(exports, "maybeInstrument", function() {
    return 0, _handlersJs.maybeInstrument;
});
parcelHelpers.export(exports, "resetInstrumentationHandlers", function() {
    return 0, _handlersJs.resetInstrumentationHandlers;
});
parcelHelpers.export(exports, "triggerHandlers", function() {
    return 0, _handlersJs.triggerHandlers;
});
parcelHelpers.export(exports, "isDOMError", function() {
    return 0, _isJs.isDOMError;
});
parcelHelpers.export(exports, "isDOMException", function() {
    return 0, _isJs.isDOMException;
});
parcelHelpers.export(exports, "isElement", function() {
    return 0, _isJs.isElement;
});
parcelHelpers.export(exports, "isError", function() {
    return 0, _isJs.isError;
});
parcelHelpers.export(exports, "isErrorEvent", function() {
    return 0, _isJs.isErrorEvent;
});
parcelHelpers.export(exports, "isEvent", function() {
    return 0, _isJs.isEvent;
});
parcelHelpers.export(exports, "isInstanceOf", function() {
    return 0, _isJs.isInstanceOf;
});
parcelHelpers.export(exports, "isParameterizedString", function() {
    return 0, _isJs.isParameterizedString;
});
parcelHelpers.export(exports, "isPlainObject", function() {
    return 0, _isJs.isPlainObject;
});
parcelHelpers.export(exports, "isPrimitive", function() {
    return 0, _isJs.isPrimitive;
});
parcelHelpers.export(exports, "isRegExp", function() {
    return 0, _isJs.isRegExp;
});
parcelHelpers.export(exports, "isString", function() {
    return 0, _isJs.isString;
});
parcelHelpers.export(exports, "isSyntheticEvent", function() {
    return 0, _isJs.isSyntheticEvent;
});
parcelHelpers.export(exports, "isThenable", function() {
    return 0, _isJs.isThenable;
});
parcelHelpers.export(exports, "isVueViewModel", function() {
    return 0, _isJs.isVueViewModel;
});
parcelHelpers.export(exports, "isBrowser", function() {
    return 0, _isBrowserJs.isBrowser;
});
parcelHelpers.export(exports, "CONSOLE_LEVELS", function() {
    return 0, _debugLoggerJs.CONSOLE_LEVELS;
});
parcelHelpers.export(exports, "consoleSandbox", function() {
    return 0, _debugLoggerJs.consoleSandbox;
});
parcelHelpers.export(exports, "debug", function() {
    return 0, _debugLoggerJs.debug;
});
parcelHelpers.export(exports, "originalConsoleMethods", function() {
    return 0, _debugLoggerJs.originalConsoleMethods;
});
parcelHelpers.export(exports, "addContextToFrame", function() {
    return 0, _miscJs.addContextToFrame;
});
parcelHelpers.export(exports, "addExceptionMechanism", function() {
    return 0, _miscJs.addExceptionMechanism;
});
parcelHelpers.export(exports, "addExceptionTypeValue", function() {
    return 0, _miscJs.addExceptionTypeValue;
});
parcelHelpers.export(exports, "checkOrSetAlreadyCaught", function() {
    return 0, _miscJs.checkOrSetAlreadyCaught;
});
parcelHelpers.export(exports, "getEventDescription", function() {
    return 0, _miscJs.getEventDescription;
});
parcelHelpers.export(exports, "parseSemver", function() {
    return 0, _miscJs.parseSemver;
});
parcelHelpers.export(exports, "uuid4", function() {
    return 0, _miscJs.uuid4;
});
parcelHelpers.export(exports, "isNodeEnv", function() {
    return 0, _nodeJs.isNodeEnv;
});
parcelHelpers.export(exports, "loadModule", function() {
    return 0, _nodeJs.loadModule;
});
parcelHelpers.export(exports, "normalize", function() {
    return 0, _normalizeJs.normalize;
});
parcelHelpers.export(exports, "normalizeToSize", function() {
    return 0, _normalizeJs.normalizeToSize;
});
parcelHelpers.export(exports, "normalizeUrlToBase", function() {
    return 0, _normalizeJs.normalizeUrlToBase;
});
parcelHelpers.export(exports, "addNonEnumerableProperty", function() {
    return 0, _objectJs.addNonEnumerableProperty;
});
parcelHelpers.export(exports, "convertToPlainObject", function() {
    return 0, _objectJs.convertToPlainObject;
});
parcelHelpers.export(exports, "dropUndefinedKeys", function() {
    return 0, _objectJs.dropUndefinedKeys;
});
parcelHelpers.export(exports, "extractExceptionKeysForMessage", function() {
    return 0, _objectJs.extractExceptionKeysForMessage;
});
parcelHelpers.export(exports, "fill", function() {
    return 0, _objectJs.fill;
});
parcelHelpers.export(exports, "getOriginalFunction", function() {
    return 0, _objectJs.getOriginalFunction;
});
parcelHelpers.export(exports, "markFunctionWrapped", function() {
    return 0, _objectJs.markFunctionWrapped;
});
parcelHelpers.export(exports, "objectify", function() {
    return 0, _objectJs.objectify;
});
parcelHelpers.export(exports, "basename", function() {
    return 0, _pathJs.basename;
});
parcelHelpers.export(exports, "dirname", function() {
    return 0, _pathJs.dirname;
});
parcelHelpers.export(exports, "isAbsolute", function() {
    return 0, _pathJs.isAbsolute;
});
parcelHelpers.export(exports, "join", function() {
    return 0, _pathJs.join;
});
parcelHelpers.export(exports, "normalizePath", function() {
    return 0, _pathJs.normalizePath;
});
parcelHelpers.export(exports, "relative", function() {
    return 0, _pathJs.relative;
});
parcelHelpers.export(exports, "resolve", function() {
    return 0, _pathJs.resolve;
});
parcelHelpers.export(exports, "SENTRY_BUFFER_FULL_ERROR", function() {
    return 0, _promisebufferJs.SENTRY_BUFFER_FULL_ERROR;
});
parcelHelpers.export(exports, "makePromiseBuffer", function() {
    return 0, _promisebufferJs.makePromiseBuffer;
});
parcelHelpers.export(exports, "severityLevelFromString", function() {
    return 0, _severityJs.severityLevelFromString;
});
parcelHelpers.export(exports, "replaceExports", function() {
    return 0, _exportsJs1.replaceExports;
});
parcelHelpers.export(exports, "UNKNOWN_FUNCTION", function() {
    return 0, _stacktraceJs.UNKNOWN_FUNCTION;
});
parcelHelpers.export(exports, "createStackParser", function() {
    return 0, _stacktraceJs.createStackParser;
});
parcelHelpers.export(exports, "getFramesFromEvent", function() {
    return 0, _stacktraceJs.getFramesFromEvent;
});
parcelHelpers.export(exports, "getFunctionName", function() {
    return 0, _stacktraceJs.getFunctionName;
});
parcelHelpers.export(exports, "stackParserFromStackParserOptions", function() {
    return 0, _stacktraceJs.stackParserFromStackParserOptions;
});
parcelHelpers.export(exports, "stripSentryFramesAndReverse", function() {
    return 0, _stacktraceJs.stripSentryFramesAndReverse;
});
parcelHelpers.export(exports, "filenameIsInApp", function() {
    return 0, _nodeStackTraceJs.filenameIsInApp;
});
parcelHelpers.export(exports, "node", function() {
    return 0, _nodeStackTraceJs.node;
});
parcelHelpers.export(exports, "nodeStackLineParser", function() {
    return 0, _nodeStackTraceJs.nodeStackLineParser;
});
parcelHelpers.export(exports, "isMatchingPattern", function() {
    return 0, _stringJs.isMatchingPattern;
});
parcelHelpers.export(exports, "safeJoin", function() {
    return 0, _stringJs.safeJoin;
});
parcelHelpers.export(exports, "snipLine", function() {
    return 0, _stringJs.snipLine;
});
parcelHelpers.export(exports, "stringMatchesSomePattern", function() {
    return 0, _stringJs.stringMatchesSomePattern;
});
parcelHelpers.export(exports, "truncate", function() {
    return 0, _stringJs.truncate;
});
parcelHelpers.export(exports, "isNativeFunction", function() {
    return 0, _supportsJs.isNativeFunction;
});
parcelHelpers.export(exports, "supportsDOMError", function() {
    return 0, _supportsJs.supportsDOMError;
});
parcelHelpers.export(exports, "supportsDOMException", function() {
    return 0, _supportsJs.supportsDOMException;
});
parcelHelpers.export(exports, "supportsErrorEvent", function() {
    return 0, _supportsJs.supportsErrorEvent;
});
parcelHelpers.export(exports, "supportsFetch", function() {
    return 0, _supportsJs.supportsFetch;
});
parcelHelpers.export(exports, "supportsHistory", function() {
    return 0, _supportsJs.supportsHistory;
});
parcelHelpers.export(exports, "supportsNativeFetch", function() {
    return 0, _supportsJs.supportsNativeFetch;
});
parcelHelpers.export(exports, "supportsReferrerPolicy", function() {
    return 0, _supportsJs.supportsReferrerPolicy;
});
parcelHelpers.export(exports, "supportsReportingObserver", function() {
    return 0, _supportsJs.supportsReportingObserver;
});
parcelHelpers.export(exports, "SyncPromise", function() {
    return 0, _syncpromiseJs.SyncPromise;
});
parcelHelpers.export(exports, "rejectedSyncPromise", function() {
    return 0, _syncpromiseJs.rejectedSyncPromise;
});
parcelHelpers.export(exports, "resolvedSyncPromise", function() {
    return 0, _syncpromiseJs.resolvedSyncPromise;
});
parcelHelpers.export(exports, "browserPerformanceTimeOrigin", function() {
    return 0, _timeJs.browserPerformanceTimeOrigin;
});
parcelHelpers.export(exports, "dateTimestampInSeconds", function() {
    return 0, _timeJs.dateTimestampInSeconds;
});
parcelHelpers.export(exports, "timestampInSeconds", function() {
    return 0, _timeJs.timestampInSeconds;
});
parcelHelpers.export(exports, "TRACEPARENT_REGEXP", function() {
    return 0, _tracingJs.TRACEPARENT_REGEXP;
});
parcelHelpers.export(exports, "extractTraceparentData", function() {
    return 0, _tracingJs.extractTraceparentData;
});
parcelHelpers.export(exports, "generateSentryTraceHeader", function() {
    return 0, _tracingJs.generateSentryTraceHeader;
});
parcelHelpers.export(exports, "propagationContextFromHeaders", function() {
    return 0, _tracingJs.propagationContextFromHeaders;
});
parcelHelpers.export(exports, "shouldContinueTrace", function() {
    return 0, _tracingJs.shouldContinueTrace;
});
parcelHelpers.export(exports, "getSDKSource", function() {
    return 0, _envJs.getSDKSource;
});
parcelHelpers.export(exports, "isBrowserBundle", function() {
    return 0, _envJs.isBrowserBundle;
});
parcelHelpers.export(exports, "addItemToEnvelope", function() {
    return 0, _envelopeJs1.addItemToEnvelope;
});
parcelHelpers.export(exports, "createAttachmentEnvelopeItem", function() {
    return 0, _envelopeJs1.createAttachmentEnvelopeItem;
});
parcelHelpers.export(exports, "createEnvelope", function() {
    return 0, _envelopeJs1.createEnvelope;
});
parcelHelpers.export(exports, "createEventEnvelopeHeaders", function() {
    return 0, _envelopeJs1.createEventEnvelopeHeaders;
});
parcelHelpers.export(exports, "createSpanEnvelopeItem", function() {
    return 0, _envelopeJs1.createSpanEnvelopeItem;
});
parcelHelpers.export(exports, "envelopeContainsItemType", function() {
    return 0, _envelopeJs1.envelopeContainsItemType;
});
parcelHelpers.export(exports, "envelopeItemTypeToDataCategory", function() {
    return 0, _envelopeJs1.envelopeItemTypeToDataCategory;
});
parcelHelpers.export(exports, "forEachEnvelopeItem", function() {
    return 0, _envelopeJs1.forEachEnvelopeItem;
});
parcelHelpers.export(exports, "getSdkMetadataForEnvelopeHeader", function() {
    return 0, _envelopeJs1.getSdkMetadataForEnvelopeHeader;
});
parcelHelpers.export(exports, "parseEnvelope", function() {
    return 0, _envelopeJs1.parseEnvelope;
});
parcelHelpers.export(exports, "serializeEnvelope", function() {
    return 0, _envelopeJs1.serializeEnvelope;
});
parcelHelpers.export(exports, "createClientReportEnvelope", function() {
    return 0, _clientreportJs.createClientReportEnvelope;
});
parcelHelpers.export(exports, "DEFAULT_RETRY_AFTER", function() {
    return 0, _ratelimitJs.DEFAULT_RETRY_AFTER;
});
parcelHelpers.export(exports, "disabledUntil", function() {
    return 0, _ratelimitJs.disabledUntil;
});
parcelHelpers.export(exports, "isRateLimited", function() {
    return 0, _ratelimitJs.isRateLimited;
});
parcelHelpers.export(exports, "parseRetryAfterHeader", function() {
    return 0, _ratelimitJs.parseRetryAfterHeader;
});
parcelHelpers.export(exports, "updateRateLimits", function() {
    return 0, _ratelimitJs.updateRateLimits;
});
parcelHelpers.export(exports, "MAX_BAGGAGE_STRING_LENGTH", function() {
    return 0, _baggageJs.MAX_BAGGAGE_STRING_LENGTH;
});
parcelHelpers.export(exports, "SENTRY_BAGGAGE_KEY_PREFIX", function() {
    return 0, _baggageJs.SENTRY_BAGGAGE_KEY_PREFIX;
});
parcelHelpers.export(exports, "SENTRY_BAGGAGE_KEY_PREFIX_REGEX", function() {
    return 0, _baggageJs.SENTRY_BAGGAGE_KEY_PREFIX_REGEX;
});
parcelHelpers.export(exports, "baggageHeaderToDynamicSamplingContext", function() {
    return 0, _baggageJs.baggageHeaderToDynamicSamplingContext;
});
parcelHelpers.export(exports, "dynamicSamplingContextToSentryBaggageHeader", function() {
    return 0, _baggageJs.dynamicSamplingContextToSentryBaggageHeader;
});
parcelHelpers.export(exports, "objectToBaggageHeader", function() {
    return 0, _baggageJs.objectToBaggageHeader;
});
parcelHelpers.export(exports, "parseBaggageHeader", function() {
    return 0, _baggageJs.parseBaggageHeader;
});
parcelHelpers.export(exports, "getHttpSpanDetailsFromUrlObject", function() {
    return 0, _urlJs.getHttpSpanDetailsFromUrlObject;
});
parcelHelpers.export(exports, "getSanitizedUrlString", function() {
    return 0, _urlJs.getSanitizedUrlString;
});
parcelHelpers.export(exports, "getSanitizedUrlStringFromUrlObject", function() {
    return 0, _urlJs.getSanitizedUrlStringFromUrlObject;
});
parcelHelpers.export(exports, "isURLObjectRelative", function() {
    return 0, _urlJs.isURLObjectRelative;
});
parcelHelpers.export(exports, "parseStringToURLObject", function() {
    return 0, _urlJs.parseStringToURLObject;
});
parcelHelpers.export(exports, "parseUrl", function() {
    return 0, _urlJs.parseUrl;
});
parcelHelpers.export(exports, "stripUrlQueryAndFragment", function() {
    return 0, _urlJs.stripUrlQueryAndFragment;
});
parcelHelpers.export(exports, "eventFromMessage", function() {
    return 0, _eventbuilderJs.eventFromMessage;
});
parcelHelpers.export(exports, "eventFromUnknownInput", function() {
    return 0, _eventbuilderJs.eventFromUnknownInput;
});
parcelHelpers.export(exports, "exceptionFromError", function() {
    return 0, _eventbuilderJs.exceptionFromError;
});
parcelHelpers.export(exports, "parseStackFrames", function() {
    return 0, _eventbuilderJs.parseStackFrames;
});
parcelHelpers.export(exports, "callFrameToStackFrame", function() {
    return 0, _anrJs.callFrameToStackFrame;
});
parcelHelpers.export(exports, "watchdogTimer", function() {
    return 0, _anrJs.watchdogTimer;
});
parcelHelpers.export(exports, "LRUMap", function() {
    return 0, _lruJs.LRUMap;
});
parcelHelpers.export(exports, "generateSpanId", function() {
    return 0, _propagationContextJs.generateSpanId;
});
parcelHelpers.export(exports, "generateTraceId", function() {
    return 0, _propagationContextJs.generateTraceId;
});
parcelHelpers.export(exports, "vercelWaitUntil", function() {
    return 0, _vercelWaitUntilJs.vercelWaitUntil;
});
parcelHelpers.export(exports, "flushIfServerless", function() {
    return 0, _flushIfServerlessJs.flushIfServerless;
});
parcelHelpers.export(exports, "SDK_VERSION", function() {
    return 0, _versionJs.SDK_VERSION;
});
parcelHelpers.export(exports, "getDebugImagesForResources", function() {
    return 0, _debugIdsJs.getDebugImagesForResources;
});
parcelHelpers.export(exports, "getFilenameToDebugIdMap", function() {
    return 0, _debugIdsJs.getFilenameToDebugIdMap;
});
parcelHelpers.export(exports, "escapeStringForRegex", function() {
    return 0, _escapeStringForRegexJs.escapeStringForRegex;
});
parcelHelpers.export(exports, "logger", function() {
    return _publicApiJs;
});
parcelHelpers.export(exports, "metrics", function() {
    return _publicApiJs1;
});
var _errorsJs = require("./tracing/errors.js");
var _utilsJs = require("./tracing/utils.js");
var _idleSpanJs = require("./tracing/idleSpan.js");
var _sentrySpanJs = require("./tracing/sentrySpan.js");
var _sentryNonRecordingSpanJs = require("./tracing/sentryNonRecordingSpan.js");
var _spanstatusJs = require("./tracing/spanstatus.js");
var _traceJs = require("./tracing/trace.js");
var _dynamicSamplingContextJs = require("./tracing/dynamicSamplingContext.js");
var _measurementJs = require("./tracing/measurement.js");
var _samplingJs = require("./tracing/sampling.js");
var _logSpansJs = require("./tracing/logSpans.js");
var _semanticAttributesJs = require("./semanticAttributes.js");
var _envelopeJs = require("./envelope.js");
var _exportsJs = require("./exports.js");
var _currentScopesJs = require("./currentScopes.js");
var _defaultScopesJs = require("./defaultScopes.js");
var _indexJs = require("./asyncContext/index.js");
var _carrierJs = require("./carrier.js");
var _sessionJs = require("./session.js");
var _scopeJs = require("./scope.js");
var _eventProcessorsJs = require("./eventProcessors.js");
var _apiJs = require("./api.js");
var _clientJs = require("./client.js");
var _serverRuntimeClientJs = require("./server-runtime-client.js");
var _sdkJs = require("./sdk.js");
var _baseJs = require("./transports/base.js");
var _offlineJs = require("./transports/offline.js");
var _multiplexedJs = require("./transports/multiplexed.js");
var _integrationJs = require("./integration.js");
var _providerSkipJs = require("./utils/ai/providerSkip.js");
var _applyScopeDataToEventJs = require("./utils/applyScopeDataToEvent.js");
var _prepareEventJs = require("./utils/prepareEvent.js");
var _checkinJs = require("./checkin.js");
var _hasSpansEnabledJs = require("./utils/hasSpansEnabled.js");
var _isSentryRequestUrlJs = require("./utils/isSentryRequestUrl.js");
var _handleCallbackErrorsJs = require("./utils/handleCallbackErrors.js");
var _parameterizeJs = require("./utils/parameterize.js");
var _ipAddressJs = require("./utils/ipAddress.js");
var _spanUtilsJs = require("./utils/spanUtils.js");
var _spanOnScopeJs = require("./utils/spanOnScope.js");
var _parseSampleRateJs = require("./utils/parseSampleRate.js");
var _sdkMetadataJs = require("./utils/sdkMetadata.js");
var _traceDataJs = require("./utils/traceData.js");
var _metaJs = require("./utils/meta.js");
var _debounceJs = require("./utils/debounce.js");
var _requestJs = require("./utils/request.js");
var _constantsJs = require("./constants.js");
var _breadcrumbsJs = require("./breadcrumbs.js");
var _functiontostringJs = require("./integrations/functiontostring.js");
var _eventFiltersJs = require("./integrations/eventFilters.js");
var _linkederrorsJs = require("./integrations/linkederrors.js");
var _moduleMetadataJs = require("./integrations/moduleMetadata.js");
var _requestdataJs = require("./integrations/requestdata.js");
var _captureconsoleJs = require("./integrations/captureconsole.js");
var _dedupeJs = require("./integrations/dedupe.js");
var _extraerrordataJs = require("./integrations/extraerrordata.js");
var _rewriteframesJs = require("./integrations/rewriteframes.js");
var _supabaseJs = require("./integrations/supabase.js");
var _zoderrorsJs = require("./integrations/zoderrors.js");
var _thirdPartyErrorsFilterJs = require("./integrations/third-party-errors-filter.js");
var _consoleJs = require("./integrations/console.js");
var _featureFlagsIntegrationJs = require("./integrations/featureFlags/featureFlagsIntegration.js");
var _growthbookJs = require("./integrations/featureFlags/growthbook.js");
var _profilingJs = require("./profiling.js");
var _fetchJs = require("./fetch.js");
var _trpcJs = require("./trpc.js");
var _indexJs1 = require("./integrations/mcp-server/index.js");
var _feedbackJs = require("./feedback.js");
var _internalJs = require("./logs/internal.js");
var _publicApiJs = require("./logs/public-api.js");
var _consoleIntegrationJs = require("./logs/console-integration.js");
var _internalJs1 = require("./metrics/internal.js");
var _publicApiJs1 = require("./metrics/public-api.js");
var _consolaJs = require("./integrations/consola.js");
var _indexJs2 = require("./tracing/vercel-ai/index.js");
var _utilsJs1 = require("./tracing/vercel-ai/utils.js");
var _indexJs3 = require("./tracing/openai/index.js");
var _constantsJs1 = require("./tracing/openai/constants.js");
var _indexJs4 = require("./tracing/anthropic-ai/index.js");
var _constantsJs2 = require("./tracing/anthropic-ai/constants.js");
var _indexJs5 = require("./tracing/google-genai/index.js");
var _constantsJs3 = require("./tracing/google-genai/constants.js");
var _indexJs6 = require("./tracing/langchain/index.js");
var _constantsJs4 = require("./tracing/langchain/constants.js");
var _indexJs7 = require("./tracing/langgraph/index.js");
var _constantsJs5 = require("./tracing/langgraph/constants.js");
var _featureFlagsJs = require("./utils/featureFlags.js");
var _aggregateErrorsJs = require("./utils/aggregate-errors.js");
var _breadcrumbLogLevelJs = require("./utils/breadcrumb-log-level.js");
var _browserJs = require("./utils/browser.js");
var _dsnJs = require("./utils/dsn.js");
var _errorJs = require("./utils/error.js");
var _worldwideJs = require("./utils/worldwide.js");
var _consoleJs1 = require("./instrument/console.js");
var _fetchJs1 = require("./instrument/fetch.js");
var _globalErrorJs = require("./instrument/globalError.js");
var _globalUnhandledRejectionJs = require("./instrument/globalUnhandledRejection.js");
var _handlersJs = require("./instrument/handlers.js");
var _isJs = require("./utils/is.js");
var _isBrowserJs = require("./utils/isBrowser.js");
var _debugLoggerJs = require("./utils/debug-logger.js");
var _miscJs = require("./utils/misc.js");
var _nodeJs = require("./utils/node.js");
var _normalizeJs = require("./utils/normalize.js");
var _objectJs = require("./utils/object.js");
var _pathJs = require("./utils/path.js");
var _promisebufferJs = require("./utils/promisebuffer.js");
var _severityJs = require("./utils/severity.js");
var _exportsJs1 = require("./utils/exports.js");
var _stacktraceJs = require("./utils/stacktrace.js");
var _nodeStackTraceJs = require("./utils/node-stack-trace.js");
var _stringJs = require("./utils/string.js");
var _supportsJs = require("./utils/supports.js");
var _syncpromiseJs = require("./utils/syncpromise.js");
var _timeJs = require("./utils/time.js");
var _tracingJs = require("./utils/tracing.js");
var _envJs = require("./utils/env.js");
var _envelopeJs1 = require("./utils/envelope.js");
var _clientreportJs = require("./utils/clientreport.js");
var _ratelimitJs = require("./utils/ratelimit.js");
var _baggageJs = require("./utils/baggage.js");
var _urlJs = require("./utils/url.js");
var _eventbuilderJs = require("./utils/eventbuilder.js");
var _anrJs = require("./utils/anr.js");
var _lruJs = require("./utils/lru.js");
var _propagationContextJs = require("./utils/propagationContext.js");
var _vercelWaitUntilJs = require("./utils/vercelWaitUntil.js");
var _flushIfServerlessJs = require("./utils/flushIfServerless.js");
var _versionJs = require("./utils/version.js");
var _debugIdsJs = require("./utils/debug-ids.js");
var _escapeStringForRegexJs = require("./vendor/escapeStringForRegex.js");

},{"./tracing/errors.js":false,"./tracing/utils.js":false,"./tracing/idleSpan.js":false,"./tracing/sentrySpan.js":false,"./tracing/sentryNonRecordingSpan.js":false,"./tracing/spanstatus.js":false,"./tracing/trace.js":"6PWst","./tracing/dynamicSamplingContext.js":false,"./tracing/measurement.js":"2qTtZ","./tracing/sampling.js":false,"./tracing/logSpans.js":false,"./semanticAttributes.js":"1gZBD","./envelope.js":false,"./exports.js":false,"./currentScopes.js":"gz9fq","./defaultScopes.js":false,"./asyncContext/index.js":false,"./carrier.js":false,"./session.js":false,"./scope.js":false,"./eventProcessors.js":false,"./api.js":false,"./client.js":false,"./server-runtime-client.js":false,"./sdk.js":false,"./transports/base.js":false,"./transports/offline.js":false,"./transports/multiplexed.js":false,"./integration.js":false,"./utils/ai/providerSkip.js":false,"./utils/applyScopeDataToEvent.js":false,"./utils/prepareEvent.js":false,"./checkin.js":false,"./utils/hasSpansEnabled.js":false,"./utils/isSentryRequestUrl.js":false,"./utils/handleCallbackErrors.js":false,"./utils/parameterize.js":false,"./utils/ipAddress.js":false,"./utils/spanUtils.js":"3nJab","./utils/spanOnScope.js":false,"./utils/parseSampleRate.js":false,"./utils/sdkMetadata.js":false,"./utils/traceData.js":false,"./utils/meta.js":false,"./utils/debounce.js":false,"./utils/request.js":false,"./constants.js":false,"./breadcrumbs.js":false,"./integrations/functiontostring.js":false,"./integrations/eventFilters.js":false,"./integrations/linkederrors.js":false,"./integrations/moduleMetadata.js":false,"./integrations/requestdata.js":false,"./integrations/captureconsole.js":false,"./integrations/dedupe.js":false,"./integrations/extraerrordata.js":false,"./integrations/rewriteframes.js":false,"./integrations/supabase.js":false,"./integrations/zoderrors.js":false,"./integrations/third-party-errors-filter.js":false,"./integrations/console.js":false,"./integrations/featureFlags/featureFlagsIntegration.js":false,"./integrations/featureFlags/growthbook.js":false,"./profiling.js":false,"./fetch.js":false,"./trpc.js":false,"./integrations/mcp-server/index.js":false,"./feedback.js":false,"./logs/internal.js":false,"./logs/public-api.js":false,"./logs/console-integration.js":false,"./metrics/internal.js":false,"./metrics/public-api.js":false,"./integrations/consola.js":false,"./tracing/vercel-ai/index.js":false,"./tracing/vercel-ai/utils.js":false,"./tracing/openai/index.js":false,"./tracing/openai/constants.js":false,"./tracing/anthropic-ai/index.js":false,"./tracing/anthropic-ai/constants.js":false,"./tracing/google-genai/index.js":false,"./tracing/google-genai/constants.js":false,"./tracing/langchain/index.js":false,"./tracing/langchain/constants.js":false,"./tracing/langgraph/index.js":false,"./tracing/langgraph/constants.js":false,"./utils/featureFlags.js":false,"./utils/aggregate-errors.js":false,"./utils/breadcrumb-log-level.js":false,"./utils/browser.js":"cGGZ4","./utils/dsn.js":false,"./utils/error.js":false,"./utils/worldwide.js":"ez2k9","./instrument/console.js":false,"./instrument/fetch.js":false,"./instrument/globalError.js":false,"./instrument/globalUnhandledRejection.js":false,"./instrument/handlers.js":"gWN7s","./utils/is.js":"7d2pF","./utils/isBrowser.js":"9KH0H","./utils/debug-logger.js":"8ZbA0","./utils/misc.js":"6l5Su","./utils/node.js":false,"./utils/normalize.js":false,"./utils/object.js":"eRvge","./utils/path.js":false,"./utils/promisebuffer.js":false,"./utils/severity.js":false,"./utils/exports.js":false,"./utils/stacktrace.js":"fLSqJ","./utils/node-stack-trace.js":false,"./utils/string.js":"jmPmL","./utils/supports.js":"92ooK","./utils/syncpromise.js":false,"./utils/time.js":"dtWIl","./utils/tracing.js":false,"./utils/env.js":false,"./utils/envelope.js":false,"./utils/clientreport.js":false,"./utils/ratelimit.js":false,"./utils/baggage.js":false,"./utils/url.js":"9VVsK","./utils/eventbuilder.js":false,"./utils/anr.js":false,"./utils/lru.js":false,"./utils/propagationContext.js":false,"./utils/vercelWaitUntil.js":false,"./utils/flushIfServerless.js":false,"./utils/version.js":false,"./utils/debug-ids.js":false,"./vendor/escapeStringForRegex.js":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5qiWB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCapturedScopesOnSpan", function() {
    return getCapturedScopesOnSpan;
});
parcelHelpers.export(exports, "setCapturedScopesOnSpan", function() {
    return setCapturedScopesOnSpan;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _objectJs = require("../utils/object.js");
var _worldwideJs = require("../utils/worldwide.js");
var SCOPE_ON_START_SPAN_FIELD = '_sentryScope';
var ISOLATION_SCOPE_ON_START_SPAN_FIELD = '_sentryIsolationScope';
/** Wrap a scope with a WeakRef if available, falling back to a direct scope. */ function wrapScopeWithWeakRef(scope) {
    try {
        // @ts-expect-error - WeakRef is not available in all environments
        var WeakRefClass = (0, _worldwideJs.GLOBAL_OBJ).WeakRef;
        if (typeof WeakRefClass === 'function') return new WeakRefClass(scope);
    } catch (e) {
    // WeakRef not available or failed to create
    // We'll fall back to a direct scope
    }
    return scope;
}
/** Try to unwrap a scope from a potential WeakRef wrapper. */ function unwrapScopeFromWeakRef(scopeRef) {
    if (!scopeRef) return undefined;
    if ((typeof scopeRef === "undefined" ? "undefined" : (0, _typeOf._)(scopeRef)) === 'object' && 'deref' in scopeRef && typeof scopeRef.deref === 'function') try {
        return scopeRef.deref();
    } catch (e) {
        return undefined;
    }
    // Fallback to a direct scope
    return scopeRef;
}
/** Store the scope & isolation scope for a span, which can the be used when it is finished. */ function setCapturedScopesOnSpan(span, scope, isolationScope) {
    if (span) {
        (0, _objectJs.addNonEnumerableProperty)(span, ISOLATION_SCOPE_ON_START_SPAN_FIELD, wrapScopeWithWeakRef(isolationScope));
        // We don't wrap the scope with a WeakRef here because webkit aggressively garbage collects
        // and scopes are not held in memory for long periods of time.
        (0, _objectJs.addNonEnumerableProperty)(span, SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 * If WeakRef was used and scopes have been garbage collected, returns undefined for those scopes.
 */ function getCapturedScopesOnSpan(span) {
    var spanWithScopes = span;
    return {
        scope: spanWithScopes[SCOPE_ON_START_SPAN_FIELD],
        isolationScope: unwrapScopeFromWeakRef(spanWithScopes[ISOLATION_SCOPE_ON_START_SPAN_FIELD])
    };
}

},{"@swc/helpers/_/_type_of":"iFJdx","../utils/object.js":"eRvge","../utils/worldwide.js":"ez2k9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eRvge":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addNonEnumerableProperty", function() {
    return addNonEnumerableProperty;
});
parcelHelpers.export(exports, "convertToPlainObject", function() {
    return convertToPlainObject;
});
parcelHelpers.export(exports, "dropUndefinedKeys", function() {
    return dropUndefinedKeys;
});
parcelHelpers.export(exports, "extractExceptionKeysForMessage", function() {
    return extractExceptionKeysForMessage;
});
parcelHelpers.export(exports, "fill", function() {
    return fill;
});
parcelHelpers.export(exports, "getOriginalFunction", function() {
    return getOriginalFunction;
});
parcelHelpers.export(exports, "markFunctionWrapped", function() {
    return markFunctionWrapped;
});
parcelHelpers.export(exports, "objectify", function() {
    return objectify;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _typeOf = require("@swc/helpers/_/_type_of");
var _debugBuildJs = require("../debug-build.js");
var _browserJs = require("./browser.js");
var _debugLoggerJs = require("./debug-logger.js");
var _isJs = require("./is.js");
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Replace a method in an object with a wrapped version of itself.
 *
 * If the method on the passed object is not a function, the wrapper will not be applied.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function fill(source, name, replacementFactory) {
    if (!(name in source)) return;
    // explicitly casting to unknown because we don't know the type of the method initially at all
    var original = source[name];
    if (typeof original !== 'function') return;
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') markFunctionWrapped(wrapped, original);
    try {
        source[name] = wrapped;
    } catch (e) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log('Failed to replace method "'.concat(name, '" in object'), source);
    }
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function addNonEnumerableProperty(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (e) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log('Failed to add non-enumerable property "'.concat(name, '" to object'), obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function markFunctionWrapped(wrapped, original) {
    try {
        var proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        addNonEnumerableProperty(wrapped, '__sentry_original__', original);
    } catch (e) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function getOriginalFunction(func) {
    return func.__sentry_original__;
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argument itself, when value is neither an Event nor
 *  an Error.
 */ function convertToPlainObject(value) {
    if ((0, _isJs.isError)(value)) return (0, _objectSpread._)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, getOwnProperties(value));
    else if ((0, _isJs.isEvent)(value)) {
        var newObj = (0, _objectSpread._)({
            type: value.type,
            target: serializeEventTarget(value.target),
            currentTarget: serializeEventTarget(value.currentTarget)
        }, getOwnProperties(value));
        if (typeof CustomEvent !== 'undefined' && (0, _isJs.isInstanceOf)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function serializeEventTarget(target) {
    try {
        return (0, _isJs.isElement)(target) ? (0, _browserJs.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (e) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function getOwnProperties(obj) {
    if ((typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj)) === 'object' && obj !== null) {
        var extractedProps = {};
        for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function extractExceptionKeysForMessage(exception) {
    var keys = Object.keys(convertToPlainObject(exception));
    keys.sort();
    return !keys[0] ? '[object has no keys]' : keys.join(', ');
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 *
 * @deprecated This function is no longer used by the SDK and will be removed in a future major version.
 */ function dropUndefinedKeys(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    var memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return _dropUndefinedKeys(inputValue, memoizationMap);
}
function _dropUndefinedKeys(inputValue, memoizationMap) {
    // Early return for primitive values
    if (inputValue === null || (typeof inputValue === "undefined" ? "undefined" : (0, _typeOf._)(inputValue)) !== 'object') return inputValue;
    // Check memo map first for all object types
    var memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) return memoVal;
    // handle arrays
    if (Array.isArray(inputValue)) {
        var returnValue = [];
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach(function(value) {
            returnValue.push(_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if (isPojo(inputValue)) {
        var returnValue1 = {};
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue1);
        var keys = Object.keys(inputValue);
        keys.forEach(function(key) {
            var val = inputValue[key];
            if (val !== undefined) returnValue1[key] = _dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue1;
    }
    // For other object types, return as is
    return inputValue;
}
function isPojo(input) {
    // Plain objects have Object as constructor or no constructor
    var constructor = input.constructor;
    return constructor === Object || constructor === undefined;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function objectify(wat) {
    var objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == undefined:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case (typeof wat === "undefined" ? "undefined" : (0, _typeOf._)(wat)) === 'symbol' || (typeof wat === "undefined" ? "undefined" : (0, _typeOf._)(wat)) === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, _isJs.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_type_of":"iFJdx","../debug-build.js":"ltjQB","./browser.js":"cGGZ4","./debug-logger.js":"8ZbA0","./is.js":"7d2pF","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ltjQB":[function(require,module,exports,__globalThis) {
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEBUG_BUILD", function() {
    return DEBUG_BUILD;
});
var DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cGGZ4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getComponentName", function() {
    return getComponentName;
});
parcelHelpers.export(exports, "getLocationHref", function() {
    return getLocationHref;
});
parcelHelpers.export(exports, "htmlTreeAsString", function() {
    return htmlTreeAsString;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
var _isJs = require("./is.js");
var _worldwideJs = require("./worldwide.js");
var WINDOW = (0, _worldwideJs.GLOBAL_OBJ);
var DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function htmlTreeAsString(elem) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!elem) return '<unknown>';
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr;
        var keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        var maxStringLength = !Array.isArray(options) && options.maxStringLength || DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = _htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (e) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function _htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    if (!(elem === null || elem === void 0 ? void 0 : elem.tagName)) return '';
    // @ts-expect-error WINDOW has HTMLElement
    if (WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if ((0, _instanceof._)(elem, HTMLElement) && elem.dataset) {
            if (elem.dataset['sentryComponent']) return elem.dataset['sentryComponent'];
            if (elem.dataset['sentryElement']) return elem.dataset['sentryElement'];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = (keyAttrs === null || keyAttrs === void 0 ? void 0 : keyAttrs.length) ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs === null || keyAttrPairs === void 0 ? void 0 : keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push("[".concat(keyAttrPair[0], '="').concat(keyAttrPair[1], '"]'));
    });
    else {
        if (elem.id) out.push("#".concat(elem.id));
        var className = elem.className;
        if (className && (0, _isJs.isString)(className)) {
            var classes = className.split(/\s+/);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = classes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var c = _step.value;
                    out.push(".".concat(c));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }
    var allowedAttrs = [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ];
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = allowedAttrs[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var k = _step1.value;
            var attr = elem.getAttribute(k);
            if (attr) out.push("[".concat(k, '="').concat(attr, '"]'));
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function getLocationHref() {
    try {
        return WINDOW.document.location.href;
    } catch (e) {
        return '';
    }
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precedence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function getComponentName(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!WINDOW.HTMLElement) return null;
    var currentElem = elem;
    var MAX_TRAVERSE_HEIGHT = 5;
    for(var i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if ((0, _instanceof._)(currentElem, HTMLElement)) {
            if (currentElem.dataset['sentryComponent']) return currentElem.dataset['sentryComponent'];
            if (currentElem.dataset['sentryElement']) return currentElem.dataset['sentryElement'];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}

},{"@swc/helpers/_/_instanceof":"h9UKc","./is.js":"7d2pF","./worldwide.js":"ez2k9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7d2pF":[function(require,module,exports,__globalThis) {
// eslint-disable-next-line @typescript-eslint/unbound-method
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isDOMError", function() {
    return isDOMError;
});
parcelHelpers.export(exports, "isDOMException", function() {
    return isDOMException;
});
parcelHelpers.export(exports, "isElement", function() {
    return isElement;
});
parcelHelpers.export(exports, "isError", function() {
    return isError;
});
parcelHelpers.export(exports, "isErrorEvent", function() {
    return isErrorEvent;
});
parcelHelpers.export(exports, "isEvent", function() {
    return isEvent;
});
parcelHelpers.export(exports, "isInstanceOf", function() {
    return isInstanceOf;
});
parcelHelpers.export(exports, "isParameterizedString", function() {
    return isParameterizedString;
});
parcelHelpers.export(exports, "isPlainObject", function() {
    return isPlainObject;
});
parcelHelpers.export(exports, "isPrimitive", function() {
    return isPrimitive;
});
parcelHelpers.export(exports, "isRegExp", function() {
    return isRegExp;
});
parcelHelpers.export(exports, "isRequest", function() {
    return isRequest;
});
parcelHelpers.export(exports, "isString", function() {
    return isString;
});
parcelHelpers.export(exports, "isSyntheticEvent", function() {
    return isSyntheticEvent;
});
parcelHelpers.export(exports, "isThenable", function() {
    return isThenable;
});
parcelHelpers.export(exports, "isVueViewModel", function() {
    return isVueViewModel;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
var _typeOf = require("@swc/helpers/_/_type_of");
var objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isError(wat) {
    switch(objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
        case '[object WebAssembly.Exception]':
            return true;
        default:
            return isInstanceOf(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function isBuiltin(wat, className) {
    return objectToString.call(wat) === "[object ".concat(className, "]");
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isErrorEvent(wat) {
    return isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isDOMError(wat) {
    return isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isDOMException(wat) {
    return isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isString(wat) {
    return isBuiltin(wat, 'String');
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isParameterizedString(wat) {
    return (typeof wat === "undefined" ? "undefined" : (0, _typeOf._)(wat)) === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isPrimitive(wat) {
    return wat === null || isParameterizedString(wat) || (typeof wat === "undefined" ? "undefined" : (0, _typeOf._)(wat)) !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isPlainObject(wat) {
    return isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isEvent(wat) {
    return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isElement(wat) {
    return typeof Element !== 'undefined' && isInstanceOf(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isRegExp(wat) {
    return isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function isThenable(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean((wat === null || wat === void 0 ? void 0 : wat.then) && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isSyntheticEvent(wat) {
    return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function isInstanceOf(wat, base) {
    try {
        return (0, _instanceof._)(wat, base);
    } catch (e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel or a VNode.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isVueViewModel(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    // We also need to check for __v_isVNode because Vue 3 component render instances have an internal __v_isVNode property.
    return !!((typeof wat === "undefined" ? "undefined" : (0, _typeOf._)(wat)) === 'object' && wat !== null && (wat.__isVue || wat._isVue || wat.__v_isVNode));
}
/**
 * Checks whether the given parameter is a Standard Web API Request instance.
 *
 * Returns false if Request is not available in the current runtime.
 */ function isRequest(request) {
    return typeof Request !== 'undefined' && isInstanceOf(request, Request);
}

},{"@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_type_of":"iFJdx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ez2k9":[function(require,module,exports,__globalThis) {
/** Internal global with common properties and Sentry extensions  */ /** Get's the global object for the current JavaScript runtime */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GLOBAL_OBJ", function() {
    return GLOBAL_OBJ;
});
var GLOBAL_OBJ = globalThis;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8ZbA0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CONSOLE_LEVELS", function() {
    return CONSOLE_LEVELS;
});
parcelHelpers.export(exports, "consoleSandbox", function() {
    return consoleSandbox;
});
parcelHelpers.export(exports, "debug", function() {
    return debug;
});
parcelHelpers.export(exports, "originalConsoleMethods", function() {
    return originalConsoleMethods;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _carrierJs = require("../carrier.js");
var _debugBuildJs = require("../debug-build.js");
var _worldwideJs = require("./worldwide.js");
var CONSOLE_LEVELS = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/** Prefix for logging strings */ var PREFIX = 'Sentry Logger ';
/** This may be mutated by the console instrumentation. */ var originalConsoleMethods = {};
/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function consoleSandbox(callback) {
    if (!('console' in (0, _worldwideJs.GLOBAL_OBJ))) return callback();
    var console = (0, _worldwideJs.GLOBAL_OBJ).console;
    var wrappedFuncs = {};
    var wrappedLevels = Object.keys(originalConsoleMethods);
    // Restore all wrapped console methods
    wrappedLevels.forEach(function(level) {
        var originalConsoleMethod = originalConsoleMethods[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach(function(level) {
            console[level] = wrappedFuncs[level];
        });
    }
}
function enable() {
    _getLoggerSettings().enabled = true;
}
function disable() {
    _getLoggerSettings().enabled = false;
}
function isEnabled() {
    return _getLoggerSettings().enabled;
}
function log() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    _maybeLog.apply(void 0, [
        'log'
    ].concat((0, _toConsumableArray._)(args)));
}
function warn() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    _maybeLog.apply(void 0, [
        'warn'
    ].concat((0, _toConsumableArray._)(args)));
}
function error() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    _maybeLog.apply(void 0, [
        'error'
    ].concat((0, _toConsumableArray._)(args)));
}
function _maybeLog(level) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    if (!(0, _debugBuildJs.DEBUG_BUILD)) return;
    if (isEnabled()) consoleSandbox(function() {
        var _GLOBAL_OBJ_console;
        (_GLOBAL_OBJ_console = (0, _worldwideJs.GLOBAL_OBJ).console)[level].apply(_GLOBAL_OBJ_console, [
            "".concat(PREFIX, "[").concat(level, "]:")
        ].concat((0, _toConsumableArray._)(args)));
    });
}
function _getLoggerSettings() {
    if (!(0, _debugBuildJs.DEBUG_BUILD)) return {
        enabled: false
    };
    return (0, _carrierJs.getGlobalSingleton)('loggerSettings', function() {
        return {
            enabled: false
        };
    });
}
/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 */ var debug = {
    /** Enable logging. */ enable: enable,
    /** Disable logging. */ disable: disable,
    /** Check if logging is enabled. */ isEnabled: isEnabled,
    /** Log a message. */ log: log,
    /** Log a warning. */ warn: warn,
    /** Log an error. */ error: error
};

},{"@swc/helpers/_/_to_consumable_array":"1eSZf","../carrier.js":"eMQiO","../debug-build.js":"ltjQB","./worldwide.js":"ez2k9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eMQiO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getGlobalSingleton", function() {
    return getGlobalSingleton;
});
parcelHelpers.export(exports, "getMainCarrier", function() {
    return getMainCarrier;
});
parcelHelpers.export(exports, "getSentryCarrier", function() {
    return getSentryCarrier;
});
var _versionJs = require("./utils/version.js");
var _worldwideJs = require("./utils/worldwide.js");
/**
 * An object that contains globally accessible properties and maintains a scope stack.
 * @hidden
 */ /**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function getMainCarrier() {
    // This ensures a Sentry carrier exists
    getSentryCarrier((0, _worldwideJs.GLOBAL_OBJ));
    return 0, _worldwideJs.GLOBAL_OBJ;
}
/** Will either get the existing sentry carrier, or create a new one. */ function getSentryCarrier(carrier) {
    var __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    // For now: First SDK that sets the .version property wins
    __SENTRY__.version = __SENTRY__.version || (0, _versionJs.SDK_VERSION);
    // Intentionally populating and returning the version of "this" SDK instance
    // rather than what's set in .version so that "this" SDK always gets its carrier
    return __SENTRY__[0, _versionJs.SDK_VERSION] = __SENTRY__[0, _versionJs.SDK_VERSION] || {};
}
/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function getGlobalSingleton(name, creator) {
    var obj = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, _worldwideJs.GLOBAL_OBJ);
    var __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    var carrier = __SENTRY__[0, _versionJs.SDK_VERSION] = __SENTRY__[0, _versionJs.SDK_VERSION] || {};
    // Note: We do not want to set `carrier.version` here, as this may be called before any `init` is called, e.g. for the default scopes
    return carrier[name] || (carrier[name] = creator());
}

},{"./utils/version.js":"dBVBN","./utils/worldwide.js":"ez2k9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dBVBN":[function(require,module,exports,__globalThis) {
// This is a magic string replaced by rollup
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SDK_VERSION", function() {
    return SDK_VERSION;
});
var SDK_VERSION = "10.27.0";

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9WhTS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SentrySpan", function() {
    return SentrySpan;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _currentScopesJs = require("../currentScopes.js");
var _debugBuildJs = require("../debug-build.js");
var _envelopeJs = require("../envelope.js");
var _semanticAttributesJs = require("../semanticAttributes.js");
var _debugLoggerJs = require("../utils/debug-logger.js");
var _propagationContextJs = require("../utils/propagationContext.js");
var _spanUtilsJs = require("../utils/spanUtils.js");
var _timeJs = require("../utils/time.js");
var _dynamicSamplingContextJs = require("./dynamicSamplingContext.js");
var _logSpansJs = require("./logSpans.js");
var _measurementJs = require("./measurement.js");
var _utilsJs = require("./utils.js");
var MAX_SPAN_COUNT = 1000;
/**
 * Span contains all data about a span
 */ var SentrySpan = /*#__PURE__*/ function() {
    "use strict";
    function SentrySpan() {
        var spanContext = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, _classCallCheck._)(this, SentrySpan);
        this._traceId = spanContext.traceId || (0, _propagationContextJs.generateTraceId)();
        this._spanId = spanContext.spanId || (0, _propagationContextJs.generateSpanId)();
        this._startTime = spanContext.startTimestamp || (0, _timeJs.timestampInSeconds)();
        this._links = spanContext.links;
        this._attributes = {};
        var _obj;
        this.setAttributes((0, _objectSpread._)((_obj = {}, (0, _defineProperty._)(_obj, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), 'manual'), (0, _defineProperty._)(_obj, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP), spanContext.op), _obj), spanContext.attributes));
        this._name = spanContext.name;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ('sampled' in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        this._events = [];
        this._isStandaloneSpan = spanContext.isStandalone;
        // If the span is already ended, ensure we finalize the span immediately
        if (this._endTime) this._onSpanEnded();
    }
    (0, _createClass._)(SentrySpan, [
        {
            /** @inheritDoc */ key: "addLink",
            value: function addLink(link) {
                if (this._links) this._links.push(link);
                else this._links = [
                    link
                ];
                return this;
            }
        },
        {
            /** @inheritDoc */ key: "addLinks",
            value: function addLinks(links) {
                var _this__links;
                if (this._links) (_this__links = this._links).push.apply(_this__links, (0, _toConsumableArray._)(links));
                else this._links = links;
                return this;
            }
        },
        {
            /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ key: "recordException",
            value: function recordException(_exception, _time) {
            // noop
            }
        },
        {
            /** @inheritdoc */ key: "spanContext",
            value: function spanContext() {
                var _this = this, spanId = _this._spanId, traceId = _this._traceId, sampled = _this._sampled;
                return {
                    spanId: spanId,
                    traceId: traceId,
                    traceFlags: sampled ? (0, _spanUtilsJs.TRACE_FLAG_SAMPLED) : (0, _spanUtilsJs.TRACE_FLAG_NONE)
                };
            }
        },
        {
            /** @inheritdoc */ key: "setAttribute",
            value: function setAttribute(key, value) {
                if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                delete this._attributes[key];
                else this._attributes[key] = value;
                return this;
            }
        },
        {
            /** @inheritdoc */ key: "setAttributes",
            value: function setAttributes(attributes) {
                var _this = this;
                Object.keys(attributes).forEach(function(key) {
                    return _this.setAttribute(key, attributes[key]);
                });
                return this;
            }
        },
        {
            /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */ key: "updateStartTime",
            value: function updateStartTime(timeInput) {
                this._startTime = (0, _spanUtilsJs.spanTimeInputToSeconds)(timeInput);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setStatus",
            value: function setStatus(value) {
                this._status = value;
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "updateName",
            value: function updateName(name) {
                this._name = name;
                this.setAttribute((0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), 'custom');
                return this;
            }
        },
        {
            /** @inheritdoc */ key: "end",
            value: function end(endTimestamp) {
                // If already ended, skip
                if (this._endTime) return;
                this._endTime = (0, _spanUtilsJs.spanTimeInputToSeconds)(endTimestamp);
                (0, _logSpansJs.logSpanEnd)(this);
                this._onSpanEnded();
            }
        },
        {
            /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ key: "getSpanJSON",
            value: function getSpanJSON() {
                return {
                    data: this._attributes,
                    description: this._name,
                    op: this._attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP],
                    parent_span_id: this._parentSpanId,
                    span_id: this._spanId,
                    start_timestamp: this._startTime,
                    status: (0, _spanUtilsJs.getStatusMessage)(this._status),
                    timestamp: this._endTime,
                    trace_id: this._traceId,
                    origin: this._attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
                    profile_id: this._attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_PROFILE_ID],
                    exclusive_time: this._attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
                    measurements: (0, _measurementJs.timedEventsToMeasurements)(this._events),
                    is_segment: this._isStandaloneSpan && (0, _spanUtilsJs.getRootSpan)(this) === this || undefined,
                    segment_id: this._isStandaloneSpan ? (0, _spanUtilsJs.getRootSpan)(this).spanContext().spanId : undefined,
                    links: (0, _spanUtilsJs.convertSpanLinksForEnvelope)(this._links)
                };
            }
        },
        {
            /** @inheritdoc */ key: "isRecording",
            value: function isRecording() {
                return !this._endTime && !!this._sampled;
            }
        },
        {
            /**
   * @inheritdoc
   */ key: "addEvent",
            value: function addEvent(name, attributesOrStartTime, startTime) {
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log('[Tracing] Adding an event to span:', name);
                var time = isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || (0, _timeJs.timestampInSeconds)();
                var attributes = isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
                var event = {
                    name: name,
                    time: (0, _spanUtilsJs.spanTimeInputToSeconds)(time),
                    attributes: attributes
                };
                this._events.push(event);
                return this;
            }
        },
        {
            /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */ key: "isStandaloneSpan",
            value: function isStandaloneSpan() {
                return !!this._isStandaloneSpan;
            }
        },
        {
            /** Emit `spanEnd` when the span is ended. */ key: "_onSpanEnded",
            value: function _onSpanEnded() {
                var client = (0, _currentScopesJs.getClient)();
                if (client) client.emit('spanEnd', this);
                // A segment span is basically the root span of a local span tree.
                // So for now, this is either what we previously refer to as the root span,
                // or a standalone span.
                var isSegmentSpan = this._isStandaloneSpan || this === (0, _spanUtilsJs.getRootSpan)(this);
                if (!isSegmentSpan) return;
                // if this is a standalone span, we send it immediately
                if (this._isStandaloneSpan) {
                    if (this._sampled) sendSpanEnvelope((0, _envelopeJs.createSpanEnvelope)([
                        this
                    ], client));
                    else {
                        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log('[Tracing] Discarding standalone span because its trace was not chosen to be sampled.');
                        if (client) client.recordDroppedEvent('sample_rate', 'span');
                    }
                    return;
                }
                var transactionEvent = this._convertSpanToTransaction();
                if (transactionEvent) {
                    var scope = (0, _utilsJs.getCapturedScopesOnSpan)(this).scope || (0, _currentScopesJs.getCurrentScope)();
                    scope.captureEvent(transactionEvent);
                }
            }
        },
        {
            /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ key: "_convertSpanToTransaction",
            value: function _convertSpanToTransaction() {
                var _this = this;
                var _capturedSpanScope_getScopeData_sdkProcessingMetadata;
                // We can only convert finished spans
                if (!isFullFinishedSpan((0, _spanUtilsJs.spanToJSON)(this))) return undefined;
                if (!this._name) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
                    this._name = '<unlabeled transaction>';
                }
                var _getCapturedScopesOnSpan = (0, _utilsJs.getCapturedScopesOnSpan)(this), capturedSpanScope = _getCapturedScopesOnSpan.scope, capturedSpanIsolationScope = _getCapturedScopesOnSpan.isolationScope;
                var normalizedRequest = capturedSpanScope === null || capturedSpanScope === void 0 ? void 0 : (_capturedSpanScope_getScopeData_sdkProcessingMetadata = capturedSpanScope.getScopeData().sdkProcessingMetadata) === null || _capturedSpanScope_getScopeData_sdkProcessingMetadata === void 0 ? void 0 : _capturedSpanScope_getScopeData_sdkProcessingMetadata.normalizedRequest;
                if (this._sampled !== true) return undefined;
                // The transaction span itself as well as any potential standalone spans should be filtered out
                var finishedSpans = (0, _spanUtilsJs.getSpanDescendants)(this).filter(function(span) {
                    return span !== _this && !isStandaloneSpan(span);
                });
                var spans = finishedSpans.map(function(span) {
                    return (0, _spanUtilsJs.spanToJSON)(span);
                }).filter(isFullFinishedSpan);
                var source = this._attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
                // remove internal root span attributes we don't need to send.
                /* eslint-disable @typescript-eslint/no-dynamic-delete */ delete this._attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
                spans.forEach(function(span) {
                    delete span.data[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
                });
                // eslint-enabled-next-line @typescript-eslint/no-dynamic-delete
                var transaction = (0, _objectSpread._)({
                    contexts: {
                        trace: (0, _spanUtilsJs.spanToTransactionTraceContext)(this)
                    },
                    spans: // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
                    // we do not use spans anymore after this point
                    spans.length > MAX_SPAN_COUNT ? spans.sort(function(a, b) {
                        return a.start_timestamp - b.start_timestamp;
                    }).slice(0, MAX_SPAN_COUNT) : spans,
                    start_timestamp: this._startTime,
                    timestamp: this._endTime,
                    transaction: this._name,
                    type: 'transaction',
                    sdkProcessingMetadata: {
                        capturedSpanScope: capturedSpanScope,
                        capturedSpanIsolationScope: capturedSpanIsolationScope,
                        dynamicSamplingContext: (0, _dynamicSamplingContextJs.getDynamicSamplingContextFromSpan)(this)
                    },
                    request: normalizedRequest
                }, source && {
                    transaction_info: {
                        source: source
                    }
                });
                var measurements = (0, _measurementJs.timedEventsToMeasurements)(this._events);
                var hasMeasurements = measurements && Object.keys(measurements).length;
                if (hasMeasurements) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log('[Measurements] Adding measurements to transaction event', JSON.stringify(measurements, undefined, 2));
                    transaction.measurements = measurements;
                }
                return transaction;
            }
        }
    ]);
    return SentrySpan;
}();
function isSpanTimeInput(value) {
    return value && typeof value === 'number' || (0, _instanceof._)(value, Date) || Array.isArray(value);
}
// We want to filter out any incomplete SpanJSON objects
function isFullFinishedSpan(input) {
    return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}
/** `SentrySpan`s can be sent as a standalone span rather than belonging to a transaction */ function isStandaloneSpan(span) {
    return (0, _instanceof._)(span, SentrySpan) && span.isStandaloneSpan();
}
/**
 * Sends a `SpanEnvelope`.
 *
 * Note: If the envelope's spans are dropped, e.g. via `beforeSendSpan`,
 * the envelope will not be sent either.
 */ function sendSpanEnvelope(envelope) {
    var client = (0, _currentScopesJs.getClient)();
    if (!client) return;
    var spanItems = envelope[1];
    if (!spanItems || spanItems.length === 0) {
        client.recordDroppedEvent('before_send', 'span');
        return;
    }
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_to_consumable_array":"1eSZf","../currentScopes.js":"gz9fq","../debug-build.js":"ltjQB","../envelope.js":"8wudz","../semanticAttributes.js":"1gZBD","../utils/debug-logger.js":"8ZbA0","../utils/propagationContext.js":"96jC2","../utils/spanUtils.js":"3nJab","../utils/time.js":"dtWIl","./dynamicSamplingContext.js":"iV5HZ","./logSpans.js":"93nlh","./measurement.js":"2qTtZ","./utils.js":"5qiWB","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gz9fq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getClient", function() {
    return getClient;
});
parcelHelpers.export(exports, "getCurrentScope", function() {
    return getCurrentScope;
});
parcelHelpers.export(exports, "getGlobalScope", function() {
    return getGlobalScope;
});
parcelHelpers.export(exports, "getIsolationScope", function() {
    return getIsolationScope;
});
parcelHelpers.export(exports, "getTraceContextFromScope", function() {
    return getTraceContextFromScope;
});
parcelHelpers.export(exports, "withIsolationScope", function() {
    return withIsolationScope;
});
parcelHelpers.export(exports, "withScope", function() {
    return withScope;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _indexJs = require("./asyncContext/index.js");
var _carrierJs = require("./carrier.js");
var _scopeJs = require("./scope.js");
var _propagationContextJs = require("./utils/propagationContext.js");
/**
 * Get the currently active scope.
 */ function getCurrentScope() {
    var carrier = (0, _carrierJs.getMainCarrier)();
    var acs = (0, _indexJs.getAsyncContextStrategy)(carrier);
    return acs.getCurrentScope();
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current execution context.
 */ function getIsolationScope() {
    var carrier = (0, _carrierJs.getMainCarrier)();
    var acs = (0, _indexJs.getAsyncContextStrategy)(carrier);
    return acs.getIsolationScope();
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function getGlobalScope() {
    return (0, _carrierJs.getGlobalSingleton)('globalScope', function() {
        return new (0, _scopeJs.Scope)();
    });
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function withScope() {
    for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++){
        rest[_key] = arguments[_key];
    }
    var carrier = (0, _carrierJs.getMainCarrier)();
    var acs = (0, _indexJs.getAsyncContextStrategy)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        var _rest = (0, _slicedToArray._)(rest, 2), scope = _rest[0], callback = _rest[1];
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 */ /**
 * Either creates a new active isolation scope, or sets the given isolation scope as active scope in the given callback.
 */ function withIsolationScope() {
    for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++){
        rest[_key] = arguments[_key];
    }
    var carrier = (0, _carrierJs.getMainCarrier)();
    var acs = (0, _indexJs.getAsyncContextStrategy)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        var _rest = (0, _slicedToArray._)(rest, 2), isolationScope = _rest[0], callback = _rest[1];
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
/**
 * Get the currently active client.
 */ function getClient() {
    return getCurrentScope().getClient();
}
/**
 * Get a trace context for the given scope.
 */ function getTraceContextFromScope(scope) {
    var propagationContext = scope.getPropagationContext();
    var traceId = propagationContext.traceId, parentSpanId = propagationContext.parentSpanId, propagationSpanId = propagationContext.propagationSpanId;
    var traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || (0, _propagationContextJs.generateSpanId)()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","./asyncContext/index.js":"5J8tn","./carrier.js":"eMQiO","./scope.js":"gfY4l","./utils/propagationContext.js":"96jC2","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5J8tn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAsyncContextStrategy", function() {
    return getAsyncContextStrategy;
});
parcelHelpers.export(exports, "setAsyncContextStrategy", function() {
    return setAsyncContextStrategy;
});
var _carrierJs = require("../carrier.js");
var _stackStrategyJs = require("./stackStrategy.js");
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function setAsyncContextStrategy(strategy) {
    // Get main carrier (global for every environment)
    var registry = (0, _carrierJs.getMainCarrier)();
    var sentry = (0, _carrierJs.getSentryCarrier)(registry);
    sentry.acs = strategy;
}
/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */ function getAsyncContextStrategy(carrier) {
    var sentry = (0, _carrierJs.getSentryCarrier)(carrier);
    if (sentry.acs) return sentry.acs;
    // Otherwise, use the default one (stack)
    return (0, _stackStrategyJs.getStackAsyncContextStrategy)();
}

},{"../carrier.js":"eMQiO","./stackStrategy.js":"25Nuu","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"25Nuu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsyncContextStack", function() {
    return AsyncContextStack;
});
parcelHelpers.export(exports, "getStackAsyncContextStrategy", function() {
    return getStackAsyncContextStrategy;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defaultScopesJs = require("../defaultScopes.js");
var _scopeJs = require("../scope.js");
var _isJs = require("../utils/is.js");
var _carrierJs = require("../carrier.js");
/**
 * This is an object that holds a stack of scopes.
 */ var AsyncContextStack = /*#__PURE__*/ function() {
    "use strict";
    function AsyncContextStack(scope, isolationScope) {
        (0, _classCallCheck._)(this, AsyncContextStack);
        var assignedScope;
        if (!scope) assignedScope = new (0, _scopeJs.Scope)();
        else assignedScope = scope;
        var assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, _scopeJs.Scope)();
        else assignedIsolationScope = isolationScope;
        // scope stack for domains or the process
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    (0, _createClass._)(AsyncContextStack, [
        {
            /**
   * Fork a scope for the stack.
   */ key: "withScope",
            value: function withScope(callback) {
                var _this = this;
                var scope = this._pushScope();
                var maybePromiseResult;
                try {
                    maybePromiseResult = callback(scope);
                } catch (e) {
                    this._popScope();
                    throw e;
                }
                if ((0, _isJs.isThenable)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
                return maybePromiseResult.then(function(res) {
                    _this._popScope();
                    return res;
                }, function(e) {
                    _this._popScope();
                    throw e;
                });
                this._popScope();
                return maybePromiseResult;
            }
        },
        {
            /**
   * Get the client of the stack.
   */ key: "getClient",
            value: function getClient() {
                return this.getStackTop().client;
            }
        },
        {
            /**
   * Returns the scope of the top stack.
   */ key: "getScope",
            value: function getScope() {
                return this.getStackTop().scope;
            }
        },
        {
            /**
   * Get the isolation scope for the stack.
   */ key: "getIsolationScope",
            value: function getIsolationScope() {
                return this._isolationScope;
            }
        },
        {
            /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ key: "getStackTop",
            value: function getStackTop() {
                return this._stack[this._stack.length - 1];
            }
        },
        {
            /**
   * Push a scope to the stack.
   */ key: "_pushScope",
            value: function _pushScope() {
                // We want to clone the content of prev scope
                var scope = this.getScope().clone();
                this._stack.push({
                    client: this.getClient(),
                    scope: scope
                });
                return scope;
            }
        },
        {
            /**
   * Pop a scope from the stack.
   */ key: "_popScope",
            value: function _popScope() {
                if (this._stack.length <= 1) return false;
                return !!this._stack.pop();
            }
        }
    ]);
    return AsyncContextStack;
}();
/**
 * Get the global async context stack.
 * This will be removed during the v8 cycle and is only here to make migration easier.
 */ function getAsyncContextStack() {
    var registry = (0, _carrierJs.getMainCarrier)();
    var sentry = (0, _carrierJs.getSentryCarrier)(registry);
    return sentry.stack = sentry.stack || new AsyncContextStack((0, _defaultScopesJs.getDefaultCurrentScope)(), (0, _defaultScopesJs.getDefaultIsolationScope)());
}
function withScope(callback) {
    return getAsyncContextStack().withScope(callback);
}
function withSetScope(scope, callback) {
    var stack = getAsyncContextStack();
    return stack.withScope(function() {
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function withIsolationScope(callback) {
    return getAsyncContextStack().withScope(function() {
        return callback(getAsyncContextStack().getIsolationScope());
    });
}
/**
 * Get the stack-based async context strategy.
 */ function getStackAsyncContextStrategy() {
    return {
        withIsolationScope: withIsolationScope,
        withScope: withScope,
        withSetScope: withSetScope,
        withSetIsolationScope: function(_isolationScope, callback) {
            return withIsolationScope(callback);
        },
        getCurrentScope: function() {
            return getAsyncContextStack().getScope();
        },
        getIsolationScope: function() {
            return getAsyncContextStack().getIsolationScope();
        }
    };
}

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","../defaultScopes.js":"ex8Qy","../scope.js":"gfY4l","../utils/is.js":"7d2pF","../carrier.js":"eMQiO","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ex8Qy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaultCurrentScope", function() {
    return getDefaultCurrentScope;
});
parcelHelpers.export(exports, "getDefaultIsolationScope", function() {
    return getDefaultIsolationScope;
});
var _carrierJs = require("./carrier.js");
var _scopeJs = require("./scope.js");
/** Get the default current scope. */ function getDefaultCurrentScope() {
    return (0, _carrierJs.getGlobalSingleton)('defaultCurrentScope', function() {
        return new (0, _scopeJs.Scope)();
    });
}
/** Get the default isolation scope. */ function getDefaultIsolationScope() {
    return (0, _carrierJs.getGlobalSingleton)('defaultIsolationScope', function() {
        return new (0, _scopeJs.Scope)();
    });
}

},{"./carrier.js":"eMQiO","./scope.js":"gfY4l","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gfY4l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Scope", function() {
    return Scope;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _debugBuildJs = require("./debug-build.js");
var _sessionJs = require("./session.js");
var _debugLoggerJs = require("./utils/debug-logger.js");
var _isJs = require("./utils/is.js");
var _mergeJs = require("./utils/merge.js");
var _miscJs = require("./utils/misc.js");
var _propagationContextJs = require("./utils/propagationContext.js");
var _spanOnScopeJs = require("./utils/spanOnScope.js");
var _stringJs = require("./utils/string.js");
var _timeJs = require("./utils/time.js");
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ var DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * A context to be used for capturing an event.
 * This can either be a Scope, or a partial ScopeContext,
 * or a callback that receives the current scope and returns a new scope to use.
 */ /**
 * Holds additional event information.
 */ var Scope = /*#__PURE__*/ function() {
    "use strict";
    function Scope() {
        (0, _classCallCheck._)(this, Scope);
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: (0, _propagationContextJs.generateTraceId)(),
            sampleRand: Math.random()
        };
    }
    (0, _createClass._)(Scope, [
        {
            /**
   * Clone all data from this scope into a new scope.
   */ key: "clone",
            value: function clone() {
                var newScope = new Scope();
                newScope._breadcrumbs = (0, _toConsumableArray._)(this._breadcrumbs);
                newScope._tags = (0, _objectSpread._)({}, this._tags);
                newScope._attributes = (0, _objectSpread._)({}, this._attributes);
                newScope._extra = (0, _objectSpread._)({}, this._extra);
                newScope._contexts = (0, _objectSpread._)({}, this._contexts);
                if (this._contexts.flags) // We need to copy the `values` array so insertions on a cloned scope
                // won't affect the original array.
                newScope._contexts.flags = {
                    values: (0, _toConsumableArray._)(this._contexts.flags.values)
                };
                newScope._user = this._user;
                newScope._level = this._level;
                newScope._session = this._session;
                newScope._transactionName = this._transactionName;
                newScope._fingerprint = this._fingerprint;
                newScope._eventProcessors = (0, _toConsumableArray._)(this._eventProcessors);
                newScope._attachments = (0, _toConsumableArray._)(this._attachments);
                newScope._sdkProcessingMetadata = (0, _objectSpread._)({}, this._sdkProcessingMetadata);
                newScope._propagationContext = (0, _objectSpread._)({}, this._propagationContext);
                newScope._client = this._client;
                newScope._lastEventId = this._lastEventId;
                (0, _spanOnScopeJs._setSpanForScope)(newScope, (0, _spanOnScopeJs._getSpanForScope)(this));
                return newScope;
            }
        },
        {
            /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ key: "setClient",
            value: function setClient(client) {
                this._client = client;
            }
        },
        {
            /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ key: "setLastEventId",
            value: function setLastEventId(lastEventId) {
                this._lastEventId = lastEventId;
            }
        },
        {
            /**
   * Get the client assigned to this scope.
   */ key: "getClient",
            value: function getClient() {
                return this._client;
            }
        },
        {
            /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ key: "lastEventId",
            value: function lastEventId() {
                return this._lastEventId;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "addScopeListener",
            value: function addScopeListener(callback) {
                this._scopeListeners.push(callback);
            }
        },
        {
            /**
   * Add an event processor that will be called before an event is sent.
   */ key: "addEventProcessor",
            value: function addEventProcessor(callback) {
                this._eventProcessors.push(callback);
                return this;
            }
        },
        {
            /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ key: "setUser",
            value: function setUser(user) {
                // If null is passed we want to unset everything, but still define keys,
                // so that later down in the pipeline any existing values are cleared.
                this._user = user || {
                    email: undefined,
                    id: undefined,
                    ip_address: undefined,
                    username: undefined
                };
                if (this._session) (0, _sessionJs.updateSession)(this._session, {
                    user: user
                });
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Get the user from this scope.
   */ key: "getUser",
            value: function getUser() {
                return this._user;
            }
        },
        {
            /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ key: "setTags",
            value: function setTags(tags) {
                this._tags = (0, _objectSpread._)({}, this._tags, tags);
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Set a single tag that will be sent as tags data with the event.
   */ key: "setTag",
            value: function setTag(key, value) {
                return this.setTags((0, _defineProperty._)({}, key, value));
            }
        },
        {
            /**
   * Sets attributes onto the scope.
   *
   * TODO:
   * Currently, these attributes are not applied to any telemetry data but they will be in the future.
   *
   * @param newAttributes - The attributes to set on the scope. You can either pass in key-value pairs, or
   * an object with a `value` and an optional `unit` (if applicable to your attribute).
   *
   * @example
   * ```typescript
   * scope.setAttributes({
   *   is_admin: true,
   *   payment_selection: 'credit_card',
   *   clicked_products: [130, 554, 292],
   *   render_duration: { value: 'render_duration', unit: 'ms' },
   * });
   * ```
   */ key: "setAttributes",
            value: function setAttributes(newAttributes) {
                this._attributes = (0, _objectSpread._)({}, this._attributes, newAttributes);
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Sets an attribute onto the scope.
   *
   * TODO:
   * Currently, these attributes are not applied to any telemetry data but they will be in the future.
   *
   * @param key - The attribute key.
   * @param value - the attribute value. You can either pass in a raw value, or an attribute
   * object with a `value` and an optional `unit` (if applicable to your attribute).
   *
   * @example
   * ```typescript
   * scope.setAttribute('is_admin', true);
   * scope.setAttribute('clicked_products', [130, 554, 292]);
   * scope.setAttribute('render_duration', { value: 'render_duration', unit: 'ms' });
   * ```
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
            key: "setAttribute",
            value: function setAttribute(key, value) {
                return this.setAttributes((0, _defineProperty._)({}, key, value));
            }
        },
        {
            /**
   * Removes the attribute with the given key from the scope.
   *
   * @param key - The attribute key.
   *
   * @example
   * ```typescript
   * scope.removeAttribute('is_admin');
   * ```
   */ key: "removeAttribute",
            value: function removeAttribute(key) {
                if (key in this._attributes) {
                    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                    delete this._attributes[key];
                    this._notifyScopeListeners();
                }
                return this;
            }
        },
        {
            /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ key: "setExtras",
            value: function setExtras(extras) {
                this._extra = (0, _objectSpread._)({}, this._extra, extras);
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ key: "setExtra",
            value: function setExtra(key, extra) {
                this._extra = (0, _objectSpreadProps._)((0, _objectSpread._)({}, this._extra), (0, _defineProperty._)({}, key, extra));
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ key: "setFingerprint",
            value: function setFingerprint(fingerprint) {
                this._fingerprint = fingerprint;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Sets the level on the scope for future events.
   */ key: "setLevel",
            value: function setLevel(level) {
                this._level = level;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ key: "setTransactionName",
            value: function setTransactionName(name) {
                this._transactionName = name;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ key: "setContext",
            value: function setContext(key, context) {
                if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                delete this._contexts[key];
                else this._contexts[key] = context;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Set the session for the scope.
   */ key: "setSession",
            value: function setSession(session) {
                if (!session) delete this._session;
                else this._session = session;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Get the session from the scope.
   */ key: "getSession",
            value: function getSession() {
                return this._session;
            }
        },
        {
            /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ key: "update",
            value: function update(captureContext) {
                if (!captureContext) return this;
                var scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;
                var scopeInstance = (0, _instanceof._)(scopeToMerge, Scope) ? scopeToMerge.getScopeData() : (0, _isJs.isPlainObject)(scopeToMerge) ? captureContext : undefined;
                var _ref = scopeInstance || {}, tags = _ref.tags, attributes = _ref.attributes, extra = _ref.extra, user = _ref.user, contexts = _ref.contexts, level = _ref.level, _ref_fingerprint = _ref.fingerprint, fingerprint = _ref_fingerprint === void 0 ? [] : _ref_fingerprint, propagationContext = _ref.propagationContext;
                this._tags = (0, _objectSpread._)({}, this._tags, tags);
                this._attributes = (0, _objectSpread._)({}, this._attributes, attributes);
                this._extra = (0, _objectSpread._)({}, this._extra, extra);
                this._contexts = (0, _objectSpread._)({}, this._contexts, contexts);
                if (user && Object.keys(user).length) this._user = user;
                if (level) this._level = level;
                if (fingerprint.length) this._fingerprint = fingerprint;
                if (propagationContext) this._propagationContext = propagationContext;
                return this;
            }
        },
        {
            /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */ key: "clear",
            value: function clear() {
                // client is not cleared here on purpose!
                this._breadcrumbs = [];
                this._tags = {};
                this._attributes = {};
                this._extra = {};
                this._user = {};
                this._contexts = {};
                this._level = undefined;
                this._transactionName = undefined;
                this._fingerprint = undefined;
                this._session = undefined;
                (0, _spanOnScopeJs._setSpanForScope)(this, undefined);
                this._attachments = [];
                this.setPropagationContext({
                    traceId: (0, _propagationContextJs.generateTraceId)(),
                    sampleRand: Math.random()
                });
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ key: "addBreadcrumb",
            value: function addBreadcrumb(breadcrumb, maxBreadcrumbs) {
                var maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : DEFAULT_MAX_BREADCRUMBS;
                // No data has been changed, so don't notify scope listeners
                if (maxCrumbs <= 0) return this;
                var mergedBreadcrumb = (0, _objectSpreadProps._)((0, _objectSpread._)({
                    timestamp: (0, _timeJs.dateTimestampInSeconds)()
                }, breadcrumb), {
                    // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
                    message: breadcrumb.message ? (0, _stringJs.truncate)(breadcrumb.message, 2048) : breadcrumb.message
                });
                this._breadcrumbs.push(mergedBreadcrumb);
                if (this._breadcrumbs.length > maxCrumbs) {
                    var _this__client;
                    this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
                    (_this__client = this._client) === null || _this__client === void 0 ? void 0 : _this__client.recordDroppedEvent('buffer_overflow', 'log_item');
                }
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Get the last breadcrumb of the scope.
   */ key: "getLastBreadcrumb",
            value: function getLastBreadcrumb() {
                return this._breadcrumbs[this._breadcrumbs.length - 1];
            }
        },
        {
            /**
   * Clear all breadcrumbs from the scope.
   */ key: "clearBreadcrumbs",
            value: function clearBreadcrumbs() {
                this._breadcrumbs = [];
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Add an attachment to the scope.
   */ key: "addAttachment",
            value: function addAttachment(attachment) {
                this._attachments.push(attachment);
                return this;
            }
        },
        {
            /**
   * Clear all attachments from the scope.
   */ key: "clearAttachments",
            value: function clearAttachments() {
                this._attachments = [];
                return this;
            }
        },
        {
            /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ key: "getScopeData",
            value: function getScopeData() {
                return {
                    breadcrumbs: this._breadcrumbs,
                    attachments: this._attachments,
                    contexts: this._contexts,
                    tags: this._tags,
                    attributes: this._attributes,
                    extra: this._extra,
                    user: this._user,
                    level: this._level,
                    fingerprint: this._fingerprint || [],
                    eventProcessors: this._eventProcessors,
                    propagationContext: this._propagationContext,
                    sdkProcessingMetadata: this._sdkProcessingMetadata,
                    transactionName: this._transactionName,
                    span: (0, _spanOnScopeJs._getSpanForScope)(this)
                };
            }
        },
        {
            /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ key: "setSDKProcessingMetadata",
            value: function setSDKProcessingMetadata(newData) {
                this._sdkProcessingMetadata = (0, _mergeJs.merge)(this._sdkProcessingMetadata, newData, 2);
                return this;
            }
        },
        {
            /**
   * Add propagation context to the scope, used for distributed tracing
   */ key: "setPropagationContext",
            value: function setPropagationContext(context) {
                this._propagationContext = context;
                return this;
            }
        },
        {
            /**
   * Get propagation context from the scope, used for distributed tracing
   */ key: "getPropagationContext",
            value: function getPropagationContext() {
                return this._propagationContext;
            }
        },
        {
            /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ key: "captureException",
            value: function captureException(exception, hint) {
                var eventId = (hint === null || hint === void 0 ? void 0 : hint.event_id) || (0, _miscJs.uuid4)();
                if (!this._client) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn('No client configured on scope - will not capture exception!');
                    return eventId;
                }
                var syntheticException = new Error('Sentry syntheticException');
                this._client.captureException(exception, (0, _objectSpreadProps._)((0, _objectSpread._)({
                    originalException: exception,
                    syntheticException: syntheticException
                }, hint), {
                    event_id: eventId
                }), this);
                return eventId;
            }
        },
        {
            /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ key: "captureMessage",
            value: function captureMessage(message, level, hint) {
                var eventId = (hint === null || hint === void 0 ? void 0 : hint.event_id) || (0, _miscJs.uuid4)();
                if (!this._client) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn('No client configured on scope - will not capture message!');
                    return eventId;
                }
                var _hint_syntheticException;
                var syntheticException = (_hint_syntheticException = hint === null || hint === void 0 ? void 0 : hint.syntheticException) !== null && _hint_syntheticException !== void 0 ? _hint_syntheticException : new Error(message);
                this._client.captureMessage(message, level, (0, _objectSpreadProps._)((0, _objectSpread._)({
                    originalException: message,
                    syntheticException: syntheticException
                }, hint), {
                    event_id: eventId
                }), this);
                return eventId;
            }
        },
        {
            /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ key: "captureEvent",
            value: function captureEvent(event, hint) {
                var eventId = (hint === null || hint === void 0 ? void 0 : hint.event_id) || (0, _miscJs.uuid4)();
                if (!this._client) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn('No client configured on scope - will not capture event!');
                    return eventId;
                }
                this._client.captureEvent(event, (0, _objectSpreadProps._)((0, _objectSpread._)({}, hint), {
                    event_id: eventId
                }), this);
                return eventId;
            }
        },
        {
            /**
   * This will be called on every set call.
   */ key: "_notifyScopeListeners",
            value: function _notifyScopeListeners() {
                var _this = this;
                // We need this check for this._notifyingListeners to be able to work on scope during updates
                // If this check is not here we'll produce endless recursion when something is done with the scope
                // during the callback.
                if (!this._notifyingListeners) {
                    this._notifyingListeners = true;
                    this._scopeListeners.forEach(function(callback) {
                        callback(_this);
                    });
                    this._notifyingListeners = false;
                }
            }
        }
    ]);
    return Scope;
}();

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_to_consumable_array":"1eSZf","./debug-build.js":"ltjQB","./session.js":"30PQL","./utils/debug-logger.js":"8ZbA0","./utils/is.js":"7d2pF","./utils/merge.js":"1w6IX","./utils/misc.js":"6l5Su","./utils/propagationContext.js":"96jC2","./utils/spanOnScope.js":"NI6uV","./utils/string.js":"jmPmL","./utils/time.js":"dtWIl","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"30PQL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "closeSession", function() {
    return closeSession;
});
parcelHelpers.export(exports, "makeSession", function() {
    return makeSession;
});
parcelHelpers.export(exports, "updateSession", function() {
    return updateSession;
});
var _miscJs = require("./utils/misc.js");
var _timeJs = require("./utils/time.js");
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function makeSession(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    var startingTime = (0, _timeJs.timestampInSeconds)();
    var session = {
        sid: (0, _miscJs.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: function() {
            return sessionToJSON(session);
        }
    };
    if (context) updateSession(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see Client.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function updateSession(session) {
    var context = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, _timeJs.timestampInSeconds)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, _miscJs.uuid4)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = "".concat(context.did);
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        var duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function closeSession(session, status) {
    var context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    updateSession(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function sessionToJSON(session) {
    return {
        sid: "".concat(session.sid),
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? "".concat(session.did) : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}

},{"./utils/misc.js":"6l5Su","./utils/time.js":"dtWIl","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6l5Su":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addContextToFrame", function() {
    return addContextToFrame;
});
parcelHelpers.export(exports, "addExceptionMechanism", function() {
    return addExceptionMechanism;
});
parcelHelpers.export(exports, "addExceptionTypeValue", function() {
    return addExceptionTypeValue;
});
parcelHelpers.export(exports, "checkOrSetAlreadyCaught", function() {
    return checkOrSetAlreadyCaught;
});
parcelHelpers.export(exports, "getEventDescription", function() {
    return getEventDescription;
});
parcelHelpers.export(exports, "parseSemver", function() {
    return parseSemver;
});
parcelHelpers.export(exports, "uuid4", function() {
    return uuid4;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectJs = require("./object.js");
var _stringJs = require("./string.js");
var _worldwideJs = require("./worldwide.js");
function getCrypto() {
    var gbl = (0, _worldwideJs.GLOBAL_OBJ);
    return gbl.crypto || gbl.msCrypto;
}
var emptyUuid;
function getRandomByte() {
    return Math.random() * 16;
}
/**
 * UUID4 generator
 * @param crypto Object that provides the crypto API.
 * @returns string Generated UUID4.
 */ function uuid4() {
    var crypto = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getCrypto();
    try {
        if (crypto === null || crypto === void 0 ? void 0 : crypto.randomUUID) return crypto.randomUUID().replace(/-/g, '');
    } catch (e) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    if (!emptyUuid) // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    emptyUuid = "10000000100040008000100000000000";
    return emptyUuid.replace(/[018]/g, function(c) {
        return(// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
    });
}
function getFirstException(event) {
    var _event_exception_values, _event_exception;
    return (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values[0];
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function getEventDescription(event) {
    var message = event.message, eventId = event.event_id;
    if (message) return message;
    var firstException = getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return "".concat(firstException.type, ": ").concat(firstException.value);
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function addExceptionTypeValue(event, value, type) {
    var exception = event.exception = event.exception || {};
    var values = exception.values = exception.values || [];
    var firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function addExceptionMechanism(event, newMechanism) {
    var firstException = getFirstException(event);
    if (!firstException) return;
    var defaultMechanism = {
        type: 'generic',
        handled: true
    };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = (0, _objectSpread._)({}, defaultMechanism, currentMechanism, newMechanism);
    if (newMechanism && 'data' in newMechanism) {
        var mergedData = (0, _objectSpread._)({}, currentMechanism === null || currentMechanism === void 0 ? void 0 : currentMechanism.data, newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ function _parseInt(input) {
    return parseInt(input || '', 10);
}
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function parseSemver(input) {
    var match = input.match(SEMVER_REGEXP) || [];
    var major = _parseInt(match[1]);
    var minor = _parseInt(match[2]);
    var patch = _parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function addContextToFrame(lines, frame) {
    var linesOfContext = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 5;
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map(function(line) {
        return (0, _stringJs.snipLine)(line, 0);
    });
    // We guard here to ensure this is not larger than the existing number of lines
    var lineIndex = Math.min(maxLines - 1, sourceLine);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    frame.context_line = (0, _stringJs.snipLine)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map(function(line) {
        return (0, _stringJs.snipLine)(line, 0);
    });
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function checkOrSetAlreadyCaught(exception) {
    if (isAlreadyCaptured(exception)) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, _objectJs.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (e) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
function isAlreadyCaptured(exception) {
    try {
        return exception.__sentry_captured__;
    } catch (e) {} // eslint-disable-line no-empty
}

},{"@swc/helpers/_/_object_spread":"9gdrV","./object.js":"eRvge","./string.js":"jmPmL","./worldwide.js":"ez2k9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jmPmL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isMatchingPattern", function() {
    return isMatchingPattern;
});
parcelHelpers.export(exports, "safeJoin", function() {
    return safeJoin;
});
parcelHelpers.export(exports, "snipLine", function() {
    return snipLine;
});
parcelHelpers.export(exports, "stringMatchesSomePattern", function() {
    return stringMatchesSomePattern;
});
parcelHelpers.export(exports, "truncate", function() {
    return truncate;
});
var _isJs = require("./is.js");
var _stacktraceJs = require("./stacktrace.js");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function truncate(str) {
    var max = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : "".concat(str.slice(0, max), "...");
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function snipLine(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} ".concat(newLine);
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ function safeJoin(input, delimiter) {
    if (!Array.isArray(input)) return '';
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, _isJs.isVueViewModel)(value)) output.push((0, _stacktraceJs.getVueInternalName)(value));
            else output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function isMatchingPattern(value, pattern) {
    var requireExactStringMatch = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (!(0, _isJs.isString)(value)) return false;
    if ((0, _isJs.isRegExp)(pattern)) return pattern.test(value);
    if ((0, _isJs.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function stringMatchesSomePattern(testString) {
    var patterns = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], requireExactStringMatch = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return patterns.some(function(pattern) {
        return isMatchingPattern(testString, pattern, requireExactStringMatch);
    });
}

},{"./is.js":"7d2pF","./stacktrace.js":"fLSqJ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fLSqJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UNKNOWN_FUNCTION", function() {
    return UNKNOWN_FUNCTION;
});
parcelHelpers.export(exports, "createStackParser", function() {
    return createStackParser;
});
parcelHelpers.export(exports, "getFramesFromEvent", function() {
    return getFramesFromEvent;
});
parcelHelpers.export(exports, "getFunctionName", function() {
    return getFunctionName;
});
parcelHelpers.export(exports, "getVueInternalName", function() {
    return getVueInternalName;
});
parcelHelpers.export(exports, "stackParserFromStackParserOptions", function() {
    return stackParserFromStackParserOptions;
});
parcelHelpers.export(exports, "stripSentryFramesAndReverse", function() {
    return stripSentryFramesAndReverse;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var STACKTRACE_FRAME_LIMIT = 50;
var UNKNOWN_FUNCTION = '?';
// Used to sanitize webpack (error: *) wrapped stack errors
var WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
var STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function createStackParser() {
    for(var _len = arguments.length, parsers = new Array(_len), _key = 0; _key < _len; _key++){
        parsers[_key] = arguments[_key];
    }
    var sortedParsers = parsers.sort(function(a, b) {
        return a[0] - b[0];
    }).map(function(p) {
        return p[1];
    });
    return function(stack) {
        var skipFirstLines = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, framesToPop = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
        var frames = [];
        var lines = stack.split('\n');
        for(var i = skipFirstLines; i < lines.length; i++){
            var line = lines[i];
            // Truncate lines over 1kb because many of the regular expressions use
            // backtracking which results in run time that increases exponentially
            // with input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) line = line.slice(0, 1024);
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            var cleanedLine = WEBPACK_ERROR_REGEXP.test(line) ? line.replace(WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = sortedParsers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var parser = _step.value;
                    var frame = parser(cleanedLine);
                    if (frame) {
                        frames.push(frame);
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            if (frames.length >= STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return stripSentryFramesAndReverse(frames.slice(framesToPop));
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function stackParserFromStackParserOptions(stackParser) {
    if (Array.isArray(stackParser)) return createStackParser.apply(void 0, (0, _toConsumableArray._)(stackParser));
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function stripSentryFramesAndReverse(stack) {
    if (!stack.length) return [];
    var localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(getLastStackFrame(localStack).function || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (STRIP_FRAME_REGEXP.test(getLastStackFrame(localStack).function || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the scope itself, making it:
        //
        //   Sentry.captureException()
        //   scope.captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if (STRIP_FRAME_REGEXP.test(getLastStackFrame(localStack).function || '')) localStack.pop();
    }
    return localStack.slice(0, STACKTRACE_FRAME_LIMIT).map(function(frame) {
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, frame), {
            filename: frame.filename || getLastStackFrame(localStack).filename,
            function: frame.function || UNKNOWN_FUNCTION
        });
    });
}
function getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
var defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function getFunctionName(fn) {
    try {
        if (!fn || typeof fn !== 'function') return defaultFunctionName;
        return fn.name || defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return defaultFunctionName;
    }
}
/**
 * Get's stack frames from an event without needing to check for undefined properties.
 */ function getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) {
        var frames = [];
        try {
            // @ts-expect-error Object could be undefined
            exception.values.forEach(function(value) {
                var // @ts-expect-error Value could be undefined
                _frames;
                // @ts-expect-error Value could be undefined
                if (value.stacktrace.frames) (_frames = frames).push.apply(_frames, (0, _toConsumableArray._)(value.stacktrace.frames));
            });
            return frames;
        } catch (e) {
            return undefined;
        }
    }
    return undefined;
}
/**
 * Get the internal name of an internal Vue value, to represent it in a stacktrace.
 *
 * @param value The value to get the internal name of.
 */ function getVueInternalName(value) {
    // Check if it's a VNode (has __v_isVNode) or a component instance (has _isVue/__isVue)
    var isVNode = '__v_isVNode' in value && value.__v_isVNode;
    return isVNode ? '[VueVNode]' : '[VueViewModel]';
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_to_consumable_array":"1eSZf","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dtWIl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "browserPerformanceTimeOrigin", function() {
    return browserPerformanceTimeOrigin;
});
parcelHelpers.export(exports, "dateTimestampInSeconds", function() {
    return dateTimestampInSeconds;
});
parcelHelpers.export(exports, "timestampInSeconds", function() {
    return timestampInSeconds;
});
var _worldwideJs = require("./worldwide.js");
var ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */ function dateTimestampInSeconds() {
    return Date.now() / ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function createUnixTimestampInSecondsFunc() {
    var performance = (0, _worldwideJs.GLOBAL_OBJ).performance;
    // Some browser and environments don't have a performance or timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    if (!(performance === null || performance === void 0 ? void 0 : performance.now) || !performance.timeOrigin) return dateTimestampInSeconds;
    var timeOrigin = performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return function() {
        return (timeOrigin + performance.now()) / ONE_SECOND_IN_MS;
    };
}
var _cachedTimestampInSeconds;
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ function timestampInSeconds() {
    // We store this in a closure so that we don't have to create a new function every time this is called.
    var func = _cachedTimestampInSeconds !== null && _cachedTimestampInSeconds !== void 0 ? _cachedTimestampInSeconds : _cachedTimestampInSeconds = createUnixTimestampInSecondsFunc();
    return func();
}
/**
 * Cached result of getBrowserTimeOrigin.
 */ var cachedTimeOrigin;
/**
 * Gets the time origin and the mode used to determine it.
 */ function getBrowserTimeOrigin() {
    var _performance_timing;
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0, _worldwideJs.GLOBAL_OBJ).performance;
    if (!(performance === null || performance === void 0 ? void 0 : performance.now)) return [
        undefined,
        'none'
    ];
    var threshold = 3600000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = (_performance_timing = performance.timing) === null || _performance_timing === void 0 ? void 0 : _performance_timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) return [
            performance.timeOrigin,
            'timeOrigin'
        ];
        else return [
            navigationStart,
            'navigationStart'
        ];
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    return [
        dateNow,
        'dateNow'
    ];
}
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ function browserPerformanceTimeOrigin() {
    if (!cachedTimeOrigin) cachedTimeOrigin = getBrowserTimeOrigin();
    return cachedTimeOrigin[0];
}

},{"./worldwide.js":"ez2k9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1w6IX":[function(require,module,exports,__globalThis) {
/**
 * Shallow merge two objects.
 * Does not mutate the passed in objects.
 * Undefined/empty values in the merge object will overwrite existing values.
 *
 * By default, this merges 2 levels deep.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "merge", function() {
    return merge;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _typeOf = require("@swc/helpers/_/_type_of");
function merge(initialObj, mergeObj) {
    var levels = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 2;
    // If the merge value is not an object, or we have no merge levels left,
    // we just set the value to the merge value
    if (!mergeObj || (typeof mergeObj === "undefined" ? "undefined" : (0, _typeOf._)(mergeObj)) !== 'object' || levels <= 0) return mergeObj;
    // If the merge object is an empty object, and the initial object is not undefined, we return the initial object
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    // Clone object
    var output = (0, _objectSpread._)({}, initialObj);
    // Merge values into output, resursively
    for(var key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = merge(output[key], mergeObj[key], levels - 1);
    return output;
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_type_of":"iFJdx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"96jC2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateSpanId", function() {
    return generateSpanId;
});
parcelHelpers.export(exports, "generateTraceId", function() {
    return generateTraceId;
});
var _miscJs = require("./misc.js");
/**
 * Generate a random, valid trace ID.
 */ function generateTraceId() {
    return (0, _miscJs.uuid4)();
}
/**
 * Generate a random, valid span ID.
 */ function generateSpanId() {
    return (0, _miscJs.uuid4)().substring(16);
}

},{"./misc.js":"6l5Su","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"NI6uV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_getSpanForScope", function() {
    return _getSpanForScope;
});
parcelHelpers.export(exports, "_setSpanForScope", function() {
    return _setSpanForScope;
});
var _objectJs = require("./object.js");
var SCOPE_SPAN_FIELD = '_sentrySpan';
/**
 * Set the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function _setSpanForScope(scope, span) {
    if (span) (0, _objectJs.addNonEnumerableProperty)(scope, SCOPE_SPAN_FIELD, span);
    else // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete scope[SCOPE_SPAN_FIELD];
}
/**
 * Get the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function _getSpanForScope(scope) {
    return scope[SCOPE_SPAN_FIELD];
}

},{"./object.js":"eRvge","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8wudz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_enhanceEventWithSdkInfo", function() {
    return _enhanceEventWithSdkInfo;
});
parcelHelpers.export(exports, "createEventEnvelope", function() {
    return createEventEnvelope;
});
parcelHelpers.export(exports, "createSessionEnvelope", function() {
    return createSessionEnvelope;
});
parcelHelpers.export(exports, "createSpanEnvelope", function() {
    return createSpanEnvelope;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _dynamicSamplingContextJs = require("./tracing/dynamicSamplingContext.js");
var _dsnJs = require("./utils/dsn.js");
var _envelopeJs = require("./utils/envelope.js");
var _shouldIgnoreSpanJs = require("./utils/should-ignore-span.js");
var _spanUtilsJs = require("./utils/spanUtils.js");
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 *
 * @internal, exported only for testing
 **/ function _enhanceEventWithSdkInfo(event, newSdkInfo) {
    var _event_sdk, _event_sdk1, _event_sdk2, _event_sdk3;
    if (!newSdkInfo) return event;
    var eventSdkInfo = event.sdk || {};
    event.sdk = (0, _objectSpreadProps._)((0, _objectSpread._)({}, eventSdkInfo), {
        name: eventSdkInfo.name || newSdkInfo.name,
        version: eventSdkInfo.version || newSdkInfo.version,
        integrations: (0, _toConsumableArray._)(((_event_sdk = event.sdk) === null || _event_sdk === void 0 ? void 0 : _event_sdk.integrations) || []).concat((0, _toConsumableArray._)(newSdkInfo.integrations || [])),
        packages: (0, _toConsumableArray._)(((_event_sdk1 = event.sdk) === null || _event_sdk1 === void 0 ? void 0 : _event_sdk1.packages) || []).concat((0, _toConsumableArray._)(newSdkInfo.packages || [])),
        settings: ((_event_sdk2 = event.sdk) === null || _event_sdk2 === void 0 ? void 0 : _event_sdk2.settings) || newSdkInfo.settings ? (0, _objectSpread._)({}, (_event_sdk3 = event.sdk) === null || _event_sdk3 === void 0 ? void 0 : _event_sdk3.settings, newSdkInfo.settings) : undefined
    });
    return event;
}
/** Creates an envelope from a Session */ function createSessionEnvelope(session, dsn, metadata, tunnel) {
    var sdkInfo = (0, _envelopeJs.getSdkMetadataForEnvelopeHeader)(metadata);
    var envelopeHeaders = (0, _objectSpread._)({
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }, !!tunnel && dsn && {
        dsn: (0, _dsnJs.dsnToString)(dsn)
    });
    var envelopeItem = 'aggregates' in session ? [
        {
            type: 'sessions'
        },
        session
    ] : [
        {
            type: 'session'
        },
        session.toJSON()
    ];
    return (0, _envelopeJs.createEnvelope)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function createEventEnvelope(event, dsn, metadata, tunnel) {
    var sdkInfo = (0, _envelopeJs.getSdkMetadataForEnvelopeHeader)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjust a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ var eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';
    _enhanceEventWithSdkInfo(event, metadata === null || metadata === void 0 ? void 0 : metadata.sdk);
    var envelopeHeaders = (0, _envelopeJs.createEventEnvelopeHeaders)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    var eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, _envelopeJs.createEnvelope)(envelopeHeaders, [
        eventItem
    ]);
}
/**
 * Create envelope from Span item.
 *
 * Takes an optional client and runs spans through `beforeSendSpan` if available.
 */ function createSpanEnvelope(spans, client) {
    function dscHasRequiredProps(dsc) {
        return !!dsc.trace_id && !!dsc.public_key;
    }
    // For the moment we'll obtain the DSC from the first span in the array
    // This might need to be changed if we permit sending multiple spans from
    // different segments in one envelope
    var dsc = (0, _dynamicSamplingContextJs.getDynamicSamplingContextFromSpan)(spans[0]);
    var dsn = client === null || client === void 0 ? void 0 : client.getDsn();
    var tunnel = client === null || client === void 0 ? void 0 : client.getOptions().tunnel;
    var headers = (0, _objectSpread._)({
        sent_at: new Date().toISOString()
    }, dscHasRequiredProps(dsc) && {
        trace: dsc
    }, !!tunnel && dsn && {
        dsn: (0, _dsnJs.dsnToString)(dsn)
    });
    var _ref = (client === null || client === void 0 ? void 0 : client.getOptions()) || {}, beforeSendSpan = _ref.beforeSendSpan, ignoreSpans = _ref.ignoreSpans;
    var filteredSpans = (ignoreSpans === null || ignoreSpans === void 0 ? void 0 : ignoreSpans.length) ? spans.filter(function(span) {
        return !(0, _shouldIgnoreSpanJs.shouldIgnoreSpan)((0, _spanUtilsJs.spanToJSON)(span), ignoreSpans);
    }) : spans;
    var droppedSpans = spans.length - filteredSpans.length;
    if (droppedSpans) client === null || client === void 0 ? void 0 : client.recordDroppedEvent('before_send', 'span', droppedSpans);
    var convertToSpanJSON = beforeSendSpan ? function(span) {
        var spanJson = (0, _spanUtilsJs.spanToJSON)(span);
        var processedSpan = beforeSendSpan(spanJson);
        if (!processedSpan) {
            (0, _spanUtilsJs.showSpanDropWarning)();
            return spanJson;
        }
        return processedSpan;
    } : (0, _spanUtilsJs.spanToJSON);
    var items = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = filteredSpans[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var span = _step.value;
            var spanJson = convertToSpanJSON(span);
            if (spanJson) items.push((0, _envelopeJs.createSpanEnvelopeItem)(spanJson));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return (0, _envelopeJs.createEnvelope)(headers, items);
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_to_consumable_array":"1eSZf","./tracing/dynamicSamplingContext.js":"iV5HZ","./utils/dsn.js":"cQ6Rk","./utils/envelope.js":"9HGrJ","./utils/should-ignore-span.js":"cLjrq","./utils/spanUtils.js":"3nJab","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iV5HZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "freezeDscOnSpan", function() {
    return freezeDscOnSpan;
});
parcelHelpers.export(exports, "getDynamicSamplingContextFromClient", function() {
    return getDynamicSamplingContextFromClient;
});
parcelHelpers.export(exports, "getDynamicSamplingContextFromScope", function() {
    return getDynamicSamplingContextFromScope;
});
parcelHelpers.export(exports, "getDynamicSamplingContextFromSpan", function() {
    return getDynamicSamplingContextFromSpan;
});
parcelHelpers.export(exports, "spanToBaggageHeader", function() {
    return spanToBaggageHeader;
});
var _constantsJs = require("../constants.js");
var _currentScopesJs = require("../currentScopes.js");
var _semanticAttributesJs = require("../semanticAttributes.js");
var _baggageJs = require("../utils/baggage.js");
var _dsnJs = require("../utils/dsn.js");
var _hasSpansEnabledJs = require("../utils/hasSpansEnabled.js");
var _objectJs = require("../utils/object.js");
var _spanUtilsJs = require("../utils/spanUtils.js");
var _utilsJs = require("./utils.js");
/**
 * If you change this value, also update the terser plugin config to
 * avoid minification of the object property!
 */ var FROZEN_DSC_FIELD = '_frozenDsc';
/**
 * Freeze the given DSC on the given span.
 */ function freezeDscOnSpan(span, dsc) {
    var spanWithMaybeDsc = span;
    (0, _objectJs.addNonEnumerableProperty)(spanWithMaybeDsc, FROZEN_DSC_FIELD, dsc);
}
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function getDynamicSamplingContextFromClient(trace_id, client) {
    var options = client.getOptions();
    var _ref = client.getDsn() || {}, public_key = _ref.publicKey;
    // Instead of conditionally adding non-undefined values, we add them and then remove them if needed
    // otherwise, the order of baggage entries changes, which "breaks" a bunch of tests etc.
    var dsc = {
        environment: options.environment || (0, _constantsJs.DEFAULT_ENVIRONMENT),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id,
        org_id: (0, _dsnJs.extractOrgIdFromClient)(client)
    };
    client.emit('createDsc', dsc);
    return dsc;
}
/**
 * Get the dynamic sampling context for the currently active scopes.
 */ function getDynamicSamplingContextFromScope(client, scope) {
    var propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || getDynamicSamplingContextFromClient(propagationContext.traceId, client);
}
/**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function getDynamicSamplingContextFromSpan(span) {
    var client = (0, _currentScopesJs.getClient)();
    if (!client) return {};
    var rootSpan = (0, _spanUtilsJs.getRootSpan)(span);
    var rootSpanJson = (0, _spanUtilsJs.spanToJSON)(rootSpan);
    var rootSpanAttributes = rootSpanJson.data;
    var traceState = rootSpan.spanContext().traceState;
    var _traceState_get, _ref;
    // The span sample rate that was locally applied to the root span should also always be applied to the DSC, even if the DSC is frozen.
    // This is so that the downstream traces/services can use parentSampleRate in their `tracesSampler` to make consistent sampling decisions across the entire trace.
    var rootSpanSampleRate = (_ref = (_traceState_get = traceState === null || traceState === void 0 ? void 0 : traceState.get('sentry.sample_rate')) !== null && _traceState_get !== void 0 ? _traceState_get : rootSpanAttributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE]) !== null && _ref !== void 0 ? _ref : rootSpanAttributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE];
    function applyLocalSampleRateToDsc(dsc) {
        if (typeof rootSpanSampleRate === 'number' || typeof rootSpanSampleRate === 'string') dsc.sample_rate = "".concat(rootSpanSampleRate);
        return dsc;
    }
    // For core implementation, we freeze the DSC onto the span as a non-enumerable property
    var frozenDsc = rootSpan[FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    // For OpenTelemetry, we freeze the DSC on the trace state
    var traceStateDsc = traceState === null || traceState === void 0 ? void 0 : traceState.get('sentry.dsc');
    // If the span has a DSC, we want it to take precedence
    var dscOnTraceState = traceStateDsc && (0, _baggageJs.baggageHeaderToDynamicSamplingContext)(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    // Else, we generate it from the span
    var dsc = getDynamicSamplingContextFromClient(span.spanContext().traceId, client);
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    var source = rootSpanAttributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // after JSON conversion, txn.name becomes jsonSpan.description
    var name = rootSpanJson.description;
    if (source !== 'url' && name) dsc.transaction = name;
    // How can we even land here with hasSpansEnabled() returning false?
    // Otel creates a Non-recording span in Tracing Without Performance mode when handling incoming requests
    // So we end up with an active span that is not sampled (neither positively nor negatively)
    if ((0, _hasSpansEnabledJs.hasSpansEnabled)()) {
        var // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        _getCapturedScopesOnSpan_scope;
        dsc.sampled = String((0, _spanUtilsJs.spanIsSampled)(rootSpan));
        var // In OTEL we store the sample rand on the trace state because we cannot access scopes for NonRecordingSpans
        // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        _traceState_get1;
        dsc.sample_rand = (_traceState_get1 = traceState === null || traceState === void 0 ? void 0 : traceState.get('sentry.sample_rand')) !== null && _traceState_get1 !== void 0 ? _traceState_get1 : (_getCapturedScopesOnSpan_scope = (0, _utilsJs.getCapturedScopesOnSpan)(rootSpan).scope) === null || _getCapturedScopesOnSpan_scope === void 0 ? void 0 : _getCapturedScopesOnSpan_scope.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit('createDsc', dsc, rootSpan);
    return dsc;
}
/**
 * Convert a Span to a baggage header.
 */ function spanToBaggageHeader(span) {
    var dsc = getDynamicSamplingContextFromSpan(span);
    return (0, _baggageJs.dynamicSamplingContextToSentryBaggageHeader)(dsc);
}

},{"../constants.js":"7SCBJ","../currentScopes.js":"gz9fq","../semanticAttributes.js":"1gZBD","../utils/baggage.js":"1l8af","../utils/dsn.js":"cQ6Rk","../utils/hasSpansEnabled.js":"6JXLr","../utils/object.js":"eRvge","../utils/spanUtils.js":"3nJab","./utils.js":"5qiWB","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7SCBJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_ENVIRONMENT", function() {
    return DEFAULT_ENVIRONMENT;
});
var DEFAULT_ENVIRONMENT = 'production';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1gZBD":[function(require,module,exports,__globalThis) {
/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_CACHE_HIT", function() {
    return SEMANTIC_ATTRIBUTE_CACHE_HIT;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE", function() {
    return SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_CACHE_KEY", function() {
    return SEMANTIC_ATTRIBUTE_CACHE_KEY;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME", function() {
    return SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD", function() {
    return SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_PROFILE_ID", function() {
    return SEMANTIC_ATTRIBUTE_PROFILE_ID;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME", function() {
    return SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON", function() {
    return SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT", function() {
    return SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE", function() {
    return SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_OP", function() {
    return SEMANTIC_ATTRIBUTE_SENTRY_OP;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN", function() {
    return SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE", function() {
    return SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE", function() {
    return SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE", function() {
    return SEMANTIC_ATTRIBUTE_SENTRY_SOURCE;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_URL_FULL", function() {
    return SEMANTIC_ATTRIBUTE_URL_FULL;
});
parcelHelpers.export(exports, "SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE", function() {
    return SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE;
});
var SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = 'sentry.source';
/**
 * Attributes that holds the sample rate that was locally applied to a span.
 * If this attribute is not defined, it means that the span inherited a sampling decision.
 *
 * NOTE: Is only defined on root spans.
 */ var SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = 'sentry.sample_rate';
/**
 * Attribute holding the sample rate of the previous trace.
 * This is used to sample consistently across subsequent traces in the browser SDK.
 *
 * Note: Only defined on root spans, if opted into consistent sampling
 */ var SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE = 'sentry.previous_trace_sample_rate';
/**
 * Use this attribute to represent the operation of a span.
 */ var SEMANTIC_ATTRIBUTE_SENTRY_OP = 'sentry.op';
/**
 * Use this attribute to represent the origin of a span.
 */ var SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = 'sentry.origin';
/** The reason why an idle span finished. */ var SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON = 'sentry.idle_span_finish_reason';
/** The unit of a measurement, which may be stored as a TimedEvent. */ var SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT = 'sentry.measurement_unit';
/** The value of a measurement, which may be stored as a TimedEvent. */ var SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE = 'sentry.measurement_value';
/**
 * A custom span name set by users guaranteed to be taken over any automatically
 * inferred name. This attribute is removed before the span is sent.
 *
 * @internal only meant for internal SDK usage
 * @hidden
 */ var SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME = 'sentry.custom_span_name';
/**
 * The id of the profile that this span occurred in.
 */ var SEMANTIC_ATTRIBUTE_PROFILE_ID = 'sentry.profile_id';
var SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME = 'sentry.exclusive_time';
var SEMANTIC_ATTRIBUTE_CACHE_HIT = 'cache.hit';
var SEMANTIC_ATTRIBUTE_CACHE_KEY = 'cache.key';
var SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE = 'cache.item_size';
/** TODO: Remove these once we update to latest semantic conventions */ var SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD = 'http.request.method';
var SEMANTIC_ATTRIBUTE_URL_FULL = 'url.full';
/**
 * A span link attribute to mark the link as a special span link.
 *
 * Known values:
 * - `previous_trace`: The span links to the frontend root span of the previous trace.
 * - `next_trace`: The span links to the frontend root span of the next trace. (Not set by the SDK)
 *
 * Other values may be set as appropriate.
 * @see https://develop.sentry.dev/sdk/telemetry/traces/span-links/#link-types
 */ var SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE = 'sentry.link.type';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1l8af":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MAX_BAGGAGE_STRING_LENGTH", function() {
    return MAX_BAGGAGE_STRING_LENGTH;
});
parcelHelpers.export(exports, "SENTRY_BAGGAGE_KEY_PREFIX", function() {
    return SENTRY_BAGGAGE_KEY_PREFIX;
});
parcelHelpers.export(exports, "SENTRY_BAGGAGE_KEY_PREFIX_REGEX", function() {
    return SENTRY_BAGGAGE_KEY_PREFIX_REGEX;
});
parcelHelpers.export(exports, "baggageHeaderToDynamicSamplingContext", function() {
    return baggageHeaderToDynamicSamplingContext;
});
parcelHelpers.export(exports, "dynamicSamplingContextToSentryBaggageHeader", function() {
    return dynamicSamplingContextToSentryBaggageHeader;
});
parcelHelpers.export(exports, "objectToBaggageHeader", function() {
    return objectToBaggageHeader;
});
parcelHelpers.export(exports, "parseBaggageHeader", function() {
    return parseBaggageHeader;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _debugBuildJs = require("../debug-build.js");
var _debugLoggerJs = require("./debug-logger.js");
var _isJs = require("./is.js");
var SENTRY_BAGGAGE_KEY_PREFIX = 'sentry-';
var SENTRY_BAGGAGE_KEY_PREFIX_REGEX = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ var MAX_BAGGAGE_STRING_LENGTH = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function baggageHeaderToDynamicSamplingContext(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    var baggageObject = parseBaggageHeader(baggageHeader);
    if (!baggageObject) return undefined;
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    var dynamicSamplingContext = Object.entries(baggageObject).reduce(function(acc, param) {
        var _param = (0, _slicedToArray._)(param, 2), key = _param[0], value = _param[1];
        if (key.match(SENTRY_BAGGAGE_KEY_PREFIX_REGEX)) {
            var nonPrefixedKey = key.slice(SENTRY_BAGGAGE_KEY_PREFIX.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function dynamicSamplingContextToSentryBaggageHeader(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    var sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce(function(acc, param) {
        var _param = (0, _slicedToArray._)(param, 2), dscKey = _param[0], dscValue = _param[1];
        if (dscValue) acc["".concat(SENTRY_BAGGAGE_KEY_PREFIX).concat(dscKey)] = dscValue;
        return acc;
    }, {});
    return objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Take a baggage header and parse it into an object.
 */ function parseBaggageHeader(baggageHeader) {
    if (!baggageHeader || !(0, _isJs.isString)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    return baggageHeader.reduce(function(acc, curr) {
        var currBaggageObject = baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(function(param) {
            var _param = (0, _slicedToArray._)(param, 2), key = _param[0], value = _param[1];
            acc[key] = value;
        });
        return acc;
    }, {});
    return baggageHeaderToObject(baggageHeader);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map(function(baggageEntry) {
        var eqIdx = baggageEntry.indexOf('=');
        if (eqIdx === -1) // Likely an invalid entry
        return [];
        var key = baggageEntry.slice(0, eqIdx);
        var value = baggageEntry.slice(eqIdx + 1);
        return [
            key,
            value
        ].map(function(keyOrValue) {
            try {
                return decodeURIComponent(keyOrValue.trim());
            } catch (e) {
                // We ignore errors here, e.g. if the value cannot be URL decoded.
                // This will then be skipped in the next step
                return;
            }
        });
    }).reduce(function(acc, param) {
        var _param = (0, _slicedToArray._)(param, 2), key = _param[0], value = _param[1];
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce(function(baggageHeader, param, currentIndex) {
        var _param = (0, _slicedToArray._)(param, 2), objectKey = _param[0], objectValue = _param[1];
        var baggageEntry = "".concat(encodeURIComponent(objectKey), "=").concat(encodeURIComponent(objectValue));
        var newBaggageHeader = currentIndex === 0 ? baggageEntry : "".concat(baggageHeader, ",").concat(baggageEntry);
        if (newBaggageHeader.length > MAX_BAGGAGE_STRING_LENGTH) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn("Not adding key: ".concat(objectKey, " with val: ").concat(objectValue, " to baggage header due to exceeding baggage size limits."));
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","../debug-build.js":"ltjQB","./debug-logger.js":"8ZbA0","./is.js":"7d2pF","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cQ6Rk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dsnFromString", function() {
    return dsnFromString;
});
parcelHelpers.export(exports, "dsnToString", function() {
    return dsnToString;
});
parcelHelpers.export(exports, "extractOrgIdFromClient", function() {
    return extractOrgIdFromClient;
});
parcelHelpers.export(exports, "extractOrgIdFromDsnHost", function() {
    return extractOrgIdFromDsnHost;
});
parcelHelpers.export(exports, "makeDsn", function() {
    return makeDsn;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _debugBuildJs = require("../debug-build.js");
var _debugLoggerJs = require("./debug-logger.js");
/** Regular expression used to extract org ID from a DSN host. */ var ORG_ID_REGEX = /^o(\d+)\./;
/** Regular expression used to parse a Dsn. */ var DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function dsnToString(dsn) {
    var withPassword = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var host = dsn.host, path = dsn.path, pass = dsn.pass, port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol, publicKey = dsn.publicKey;
    return "".concat(protocol, "://").concat(publicKey).concat(withPassword && pass ? ":".concat(pass) : '') + "@".concat(host).concat(port ? ":".concat(port) : '', "/").concat(path ? "".concat(path, "/") : path).concat(projectId);
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function dsnFromString(str) {
    var match = DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, _debugLoggerJs.consoleSandbox)(function() {
            // eslint-disable-next-line no-console
            console.error("Invalid Sentry Dsn: ".concat(str));
        });
        return undefined;
    }
    var _match_slice = (0, _slicedToArray._)(match.slice(1), 6), protocol = _match_slice[0], publicKey = _match_slice[1], tmp = _match_slice[2], pass = tmp === void 0 ? '' : tmp, tmp1 = _match_slice[3], host = tmp1 === void 0 ? '' : tmp1, tmp2 = _match_slice[4], port = tmp2 === void 0 ? '' : tmp2, tmp3 = _match_slice[5], lastPath = tmp3 === void 0 ? '' : tmp3;
    var path = '';
    var projectId = lastPath;
    var split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        var projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function validateDsn(dsn) {
    if (!(0, _debugBuildJs.DEBUG_BUILD)) return true;
    var port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol;
    var requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    var hasMissingRequiredComponent = requiredComponents.find(function(component) {
        if (!dsn[component]) {
            (0, _debugLoggerJs.debug).error("Invalid Sentry Dsn: ".concat(component, " missing"));
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, _debugLoggerJs.debug).error("Invalid Sentry Dsn: Invalid projectId ".concat(projectId));
        return false;
    }
    if (!isValidProtocol(protocol)) {
        (0, _debugLoggerJs.debug).error("Invalid Sentry Dsn: Invalid protocol ".concat(protocol));
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, _debugLoggerJs.debug).error("Invalid Sentry Dsn: Invalid port ".concat(port));
        return false;
    }
    return true;
}
/**
 * Extract the org ID from a DSN host.
 *
 * @param host The host from a DSN
 * @returns The org ID if found, undefined otherwise
 */ function extractOrgIdFromDsnHost(host) {
    var match = host.match(ORG_ID_REGEX);
    return match === null || match === void 0 ? void 0 : match[1];
}
/**
 *  Returns the organization ID of the client.
 *
 *  The organization ID is extracted from the DSN. If the client options include a `orgId`, this will always take precedence.
 */ function extractOrgIdFromClient(client) {
    var options = client.getOptions();
    var host = (client.getDsn() || {}).host;
    var org_id;
    if (options.orgId) org_id = String(options.orgId);
    else if (host) org_id = extractOrgIdFromDsnHost(host);
    return org_id;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function makeDsn(from) {
    var components = typeof from === 'string' ? dsnFromString(from) : dsnFromComponents(from);
    if (!components || !validateDsn(components)) return undefined;
    return components;
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","../debug-build.js":"ltjQB","./debug-logger.js":"8ZbA0","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6JXLr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasSpansEnabled", function() {
    return hasSpansEnabled;
});
var _currentScopesJs = require("../currentScopes.js");
// Treeshakable guard to remove all code related to tracing
/**
 * Determines if span recording is currently enabled.
 *
 * Spans are recorded when at least one of `tracesSampleRate` and `tracesSampler`
 * is defined in the SDK config. This function does not make any assumption about
 * sampling decisions, it only checks if the SDK is configured to record spans.
 *
 * Important: This function only determines if span recording is enabled. Trace
 * continuation and propagation is separately controlled and not covered by this function.
 * If this function returns `false`, traces can still be propagated (which is what
 * we refer to by "Tracing without Performance")
 * @see https://develop.sentry.dev/sdk/telemetry/traces/tracing-without-performance/
 *
 * @param maybeOptions An SDK options object to be passed to this function.
 * If this option is not provided, the function will use the current client's options.
 */ function hasSpansEnabled(maybeOptions) {
    var _getClient;
    if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) return false;
    var options = maybeOptions || ((_getClient = (0, _currentScopesJs.getClient)()) === null || _getClient === void 0 ? void 0 : _getClient.getOptions());
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}

},{"../currentScopes.js":"gz9fq","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3nJab":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TRACE_FLAG_NONE", function() {
    return TRACE_FLAG_NONE;
});
parcelHelpers.export(exports, "TRACE_FLAG_SAMPLED", function() {
    return TRACE_FLAG_SAMPLED;
});
parcelHelpers.export(exports, "addChildSpanToSpan", function() {
    return addChildSpanToSpan;
});
parcelHelpers.export(exports, "convertSpanLinksForEnvelope", function() {
    return convertSpanLinksForEnvelope;
});
parcelHelpers.export(exports, "getActiveSpan", function() {
    return getActiveSpan;
});
parcelHelpers.export(exports, "getRootSpan", function() {
    return getRootSpan;
});
parcelHelpers.export(exports, "getSpanDescendants", function() {
    return getSpanDescendants;
});
parcelHelpers.export(exports, "getStatusMessage", function() {
    return getStatusMessage;
});
parcelHelpers.export(exports, "removeChildSpanFromSpan", function() {
    return removeChildSpanFromSpan;
});
parcelHelpers.export(exports, "showSpanDropWarning", function() {
    return showSpanDropWarning;
});
parcelHelpers.export(exports, "spanIsSampled", function() {
    return spanIsSampled;
});
parcelHelpers.export(exports, "spanTimeInputToSeconds", function() {
    return spanTimeInputToSeconds;
});
parcelHelpers.export(exports, "spanToJSON", function() {
    return spanToJSON;
});
parcelHelpers.export(exports, "spanToTraceContext", function() {
    return spanToTraceContext;
});
parcelHelpers.export(exports, "spanToTraceHeader", function() {
    return spanToTraceHeader;
});
parcelHelpers.export(exports, "spanToTraceparentHeader", function() {
    return spanToTraceparentHeader;
});
parcelHelpers.export(exports, "spanToTransactionTraceContext", function() {
    return spanToTransactionTraceContext;
});
parcelHelpers.export(exports, "updateSpanName", function() {
    return updateSpanName;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _indexJs = require("../asyncContext/index.js");
var _carrierJs = require("../carrier.js");
var _currentScopesJs = require("../currentScopes.js");
var _semanticAttributesJs = require("../semanticAttributes.js");
var _spanstatusJs = require("../tracing/spanstatus.js");
var _utilsJs = require("../tracing/utils.js");
var _objectJs = require("./object.js");
var _propagationContextJs = require("./propagationContext.js");
var _timeJs = require("./time.js");
var _tracingJs = require("./tracing.js");
var _debugLoggerJs = require("./debug-logger.js");
var _spanOnScopeJs = require("./spanOnScope.js");
// These are aligned with OpenTelemetry trace flags
var TRACE_FLAG_NONE = 0x0;
var TRACE_FLAG_SAMPLED = 0x1;
var hasShownSpanDropWarning = false;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 * By default, this will only include trace_id, span_id & parent_span_id.
 * If `includeAllData` is true, it will also include data, op, status & origin.
 */ function spanToTransactionTraceContext(span) {
    var _span_spanContext = span.spanContext(), span_id = _span_spanContext.spanId, trace_id = _span_spanContext.traceId;
    var _spanToJSON = spanToJSON(span), data = _spanToJSON.data, op = _spanToJSON.op, parent_span_id = _spanToJSON.parent_span_id, status = _spanToJSON.status, origin = _spanToJSON.origin, links = _spanToJSON.links;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in a non-transaction event.
 */ function spanToTraceContext(span) {
    var _span_spanContext = span.spanContext(), spanId = _span_spanContext.spanId, trace_id = _span_spanContext.traceId, isRemote = _span_spanContext.isRemote;
    // If the span is remote, we use a random/virtual span as span_id to the trace context,
    // and the remote span as parent_span_id
    var parent_span_id = isRemote ? spanId : spanToJSON(span).parent_span_id;
    var scope = (0, _utilsJs.getCapturedScopesOnSpan)(span).scope;
    var span_id = isRemote ? (scope === null || scope === void 0 ? void 0 : scope.getPropagationContext().propagationSpanId) || (0, _propagationContextJs.generateSpanId)() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
/**
 * Convert a Span to a Sentry trace header.
 */ function spanToTraceHeader(span) {
    var _span_spanContext = span.spanContext(), traceId = _span_spanContext.traceId, spanId = _span_spanContext.spanId;
    var sampled = spanIsSampled(span);
    return (0, _tracingJs.generateSentryTraceHeader)(traceId, spanId, sampled);
}
/**
 * Convert a Span to a W3C traceparent header.
 */ function spanToTraceparentHeader(span) {
    var _span_spanContext = span.spanContext(), traceId = _span_spanContext.traceId, spanId = _span_spanContext.spanId;
    var sampled = spanIsSampled(span);
    return (0, _tracingJs.generateTraceparentHeader)(traceId, spanId, sampled);
}
/**
 *  Converts the span links array to a flattened version to be sent within an envelope.
 *
 *  If the links array is empty, it returns `undefined` so the empty value can be dropped before it's sent.
 */ function convertSpanLinksForEnvelope(links) {
    if (links && links.length > 0) return links.map(function(_param) {
        var _param_context = _param.context, spanId = _param_context.spanId, traceId = _param_context.traceId, traceFlags = _param_context.traceFlags, attributes = _param.attributes, restContext = (0, _objectWithoutProperties._)(_param.context, [
            "spanId",
            "traceId",
            "traceFlags"
        ]);
        return (0, _objectSpread._)({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === TRACE_FLAG_SAMPLED,
            attributes: attributes
        }, restContext);
    });
    else return undefined;
}
/**
 * Convert a span time input into a timestamp in seconds.
 */ function spanTimeInputToSeconds(input) {
    if (typeof input === 'number') return ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if ((0, _instanceof._)(input, Date)) return ensureTimestampInSeconds(input.getTime());
    return (0, _timeJs.timestampInSeconds)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function ensureTimestampInSeconds(timestamp) {
    var isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 */ // Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
// This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
// And `spanToJSON` needs the Span class from `span.ts` to check here.
function spanToJSON(span) {
    if (spanIsSentrySpan(span)) return span.getSpanJSON();
    var _span_spanContext = span.spanContext(), span_id = _span_spanContext.spanId, trace_id = _span_spanContext.traceId;
    // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
    if (spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        var _span_parentSpanContext;
        var attributes = span.attributes, startTime = span.startTime, name = span.name, endTime = span.endTime, status = span.status, links = span.links;
        // In preparation for the next major of OpenTelemetry, we want to support
        // looking up the parent span id according to the new API
        // In OTel v1, the parent span id is accessed as `parentSpanId`
        // In OTel v2, the parent span id is accessed as `spanId` on the `parentSpanContext`
        var parentSpanId = 'parentSpanId' in span ? span.parentSpanId : 'parentSpanContext' in span ? (_span_parentSpanContext = span.parentSpanContext) === null || _span_parentSpanContext === void 0 ? void 0 : _span_parentSpanContext.spanId : undefined;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: parentSpanId,
            start_timestamp: spanTimeInputToSeconds(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: spanTimeInputToSeconds(endTime) || undefined,
            status: getStatusMessage(status),
            op: attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            origin: attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            links: convertSpanLinksForEnvelope(links)
        };
    }
    // Finally, at least we have `spanContext()`....
    // This should not actually happen in reality, but we need to handle it for type safety.
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
function spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    var castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
/** Exported only for tests. */ /**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === 'function';
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function spanIsSampled(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    var traceFlags = span.spanContext().traceFlags;
    return traceFlags === TRACE_FLAG_SAMPLED;
}
/** Get the status message to use for a JSON representation of a span. */ function getStatusMessage(status) {
    if (!status || status.code === (0, _spanstatusJs.SPAN_STATUS_UNSET)) return undefined;
    if (status.code === (0, _spanstatusJs.SPAN_STATUS_OK)) return 'ok';
    return status.message || 'internal_error';
}
var CHILD_SPANS_FIELD = '_sentryChildSpans';
var ROOT_SPAN_FIELD = '_sentryRootSpan';
/**
 * Adds an opaque child span reference to a span.
 */ function addChildSpanToSpan(span, childSpan) {
    // We store the root span reference on the child span
    // We need this for `getRootSpan()` to work
    var rootSpan = span[ROOT_SPAN_FIELD] || span;
    (0, _objectJs.addNonEnumerableProperty)(childSpan, ROOT_SPAN_FIELD, rootSpan);
    // We store a list of child spans on the parent span
    // We need this for `getSpanDescendants()` to work
    if (span[CHILD_SPANS_FIELD]) span[CHILD_SPANS_FIELD].add(childSpan);
    else (0, _objectJs.addNonEnumerableProperty)(span, CHILD_SPANS_FIELD, new Set([
        childSpan
    ]));
}
/** This is only used internally by Idle Spans. */ function removeChildSpanFromSpan(span, childSpan) {
    if (span[CHILD_SPANS_FIELD]) span[CHILD_SPANS_FIELD].delete(childSpan);
}
/**
 * Returns an array of the given span and all of its descendants.
 */ function getSpanDescendants(span) {
    var resultSet = new Set();
    function addSpanChildren(span) {
        // This exit condition is required to not infinitely loop in case of a circular dependency.
        if (resultSet.has(span)) return;
        else if (spanIsSampled(span)) {
            resultSet.add(span);
            var childSpans = span[CHILD_SPANS_FIELD] ? Array.from(span[CHILD_SPANS_FIELD]) : [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = childSpans[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var childSpan = _step.value;
                    addSpanChildren(childSpan);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
/**
 * Returns the root span of a given span.
 */ function getRootSpan(span) {
    return span[ROOT_SPAN_FIELD] || span;
}
/**
 * Returns the currently active span.
 */ function getActiveSpan() {
    var carrier = (0, _carrierJs.getMainCarrier)();
    var acs = (0, _indexJs.getAsyncContextStrategy)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, _spanOnScopeJs._getSpanForScope)((0, _currentScopesJs.getCurrentScope)());
}
/**
 * Logs a warning once if `beforeSendSpan` is used to drop spans.
 */ function showSpanDropWarning() {
    if (!hasShownSpanDropWarning) {
        (0, _debugLoggerJs.consoleSandbox)(function() {
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly or use `ignoreSpans`.');
        });
        hasShownSpanDropWarning = true;
    }
}
/**
 * Updates the name of the given span and ensures that the span name is not
 * overwritten by the Sentry SDK.
 *
 * Use this function instead of `span.updateName()` if you want to make sure that
 * your name is kept. For some spans, for example root `http.server` spans the
 * Sentry SDK would otherwise overwrite the span name with a high-quality name
 * it infers when the span ends.
 *
 * Use this function in server code or when your span is started on the server
 * and on the client (browser). If you only update a span name on the client,
 * you can also use `span.updateName()` the SDK does not overwrite the name.
 *
 * @param span - The span to update the name of.
 * @param name - The name to set on the span.
 */ function updateSpanName(span, name) {
    span.updateName(name);
    var _obj;
    span.setAttributes((_obj = {}, (0, _defineProperty._)(_obj, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), 'custom'), (0, _defineProperty._)(_obj, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME), name), _obj));
}

},{"@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_without_properties":"6HqIM","../asyncContext/index.js":"5J8tn","../carrier.js":"eMQiO","../currentScopes.js":"gz9fq","../semanticAttributes.js":"1gZBD","../tracing/spanstatus.js":"9Rb4c","../tracing/utils.js":"5qiWB","./object.js":"eRvge","./propagationContext.js":"96jC2","./time.js":"dtWIl","./tracing.js":"e0DzU","./debug-logger.js":"8ZbA0","./spanOnScope.js":"NI6uV","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9Rb4c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SPAN_STATUS_ERROR", function() {
    return SPAN_STATUS_ERROR;
});
parcelHelpers.export(exports, "SPAN_STATUS_OK", function() {
    return SPAN_STATUS_OK;
});
parcelHelpers.export(exports, "SPAN_STATUS_UNSET", function() {
    return SPAN_STATUS_UNSET;
});
parcelHelpers.export(exports, "getSpanStatusFromHttpCode", function() {
    return getSpanStatusFromHttpCode;
});
parcelHelpers.export(exports, "setHttpStatus", function() {
    return setHttpStatus;
});
var SPAN_STATUS_UNSET = 0;
var SPAN_STATUS_OK = 1;
var SPAN_STATUS_ERROR = 2;
/**
 * Converts a HTTP status code into a sentry status with a message.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or internal_error.
 */ // https://develop.sentry.dev/sdk/event-payloads/span/
function getSpanStatusFromHttpCode(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: SPAN_STATUS_OK
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: SPAN_STATUS_ERROR,
                message: 'unauthenticated'
            };
        case 403:
            return {
                code: SPAN_STATUS_ERROR,
                message: 'permission_denied'
            };
        case 404:
            return {
                code: SPAN_STATUS_ERROR,
                message: 'not_found'
            };
        case 409:
            return {
                code: SPAN_STATUS_ERROR,
                message: 'already_exists'
            };
        case 413:
            return {
                code: SPAN_STATUS_ERROR,
                message: 'failed_precondition'
            };
        case 429:
            return {
                code: SPAN_STATUS_ERROR,
                message: 'resource_exhausted'
            };
        case 499:
            return {
                code: SPAN_STATUS_ERROR,
                message: 'cancelled'
            };
        default:
            return {
                code: SPAN_STATUS_ERROR,
                message: 'invalid_argument'
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: SPAN_STATUS_ERROR,
                message: 'unimplemented'
            };
        case 503:
            return {
                code: SPAN_STATUS_ERROR,
                message: 'unavailable'
            };
        case 504:
            return {
                code: SPAN_STATUS_ERROR,
                message: 'deadline_exceeded'
            };
        default:
            return {
                code: SPAN_STATUS_ERROR,
                message: 'internal_error'
            };
    }
    return {
        code: SPAN_STATUS_ERROR,
        message: 'internal_error'
    };
}
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function setHttpStatus(span, httpStatus) {
    span.setAttribute('http.response.status_code', httpStatus);
    var spanStatus = getSpanStatusFromHttpCode(httpStatus);
    if (spanStatus.message !== 'unknown_error') span.setStatus(spanStatus);
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"e0DzU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TRACEPARENT_REGEXP", function() {
    return TRACEPARENT_REGEXP;
});
parcelHelpers.export(exports, "extractTraceparentData", function() {
    return extractTraceparentData;
});
parcelHelpers.export(exports, "generateSentryTraceHeader", function() {
    return generateSentryTraceHeader;
});
parcelHelpers.export(exports, "generateTraceparentHeader", function() {
    return generateTraceparentHeader;
});
parcelHelpers.export(exports, "propagationContextFromHeaders", function() {
    return propagationContextFromHeaders;
});
parcelHelpers.export(exports, "shouldContinueTrace", function() {
    return shouldContinueTrace;
});
var _debugLoggerJs = require("./debug-logger.js");
var _baggageJs = require("./baggage.js");
var _dsnJs = require("./dsn.js");
var _parseSampleRateJs = require("./parseSampleRate.js");
var _propagationContextJs = require("./propagationContext.js");
// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
var TRACEPARENT_REGEXP = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * This is terrible naming but the function has nothing to do with the W3C traceparent header.
 * It can only parse the `sentry-trace` header and extract the "trace parent" data.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function extractTraceparentData(traceparent) {
    if (!traceparent) return undefined;
    var matches = traceparent.match(TRACEPARENT_REGEXP);
    if (!matches) return undefined;
    var parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create a propagation context from incoming headers or
 * creates a minimal new one if the headers are undefined.
 */ function propagationContextFromHeaders(sentryTrace, baggage) {
    var traceparentData = extractTraceparentData(sentryTrace);
    var dynamicSamplingContext = (0, _baggageJs.baggageHeaderToDynamicSamplingContext)(baggage);
    if (!(traceparentData === null || traceparentData === void 0 ? void 0 : traceparentData.traceId)) return {
        traceId: (0, _propagationContextJs.generateTraceId)(),
        sampleRand: Math.random()
    };
    var sampleRand = getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    // The sample_rand on the DSC needs to be generated based on traceparent + baggage.
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    var traceId = traceparentData.traceId, parentSpanId = traceparentData.parentSpanId, parentSampled = traceparentData.parentSampled;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: sampleRand
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function generateSentryTraceHeader() {
    var traceId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, _propagationContextJs.generateTraceId)(), spanId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, _propagationContextJs.generateSpanId)(), sampled = arguments.length > 2 ? arguments[2] : void 0;
    var sampledString = '';
    if (sampled !== undefined) sampledString = sampled ? '-1' : '-0';
    return "".concat(traceId, "-").concat(spanId).concat(sampledString);
}
/**
 * Creates a W3C traceparent header from the given trace and span ids.
 */ function generateTraceparentHeader() {
    var traceId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, _propagationContextJs.generateTraceId)(), spanId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, _propagationContextJs.generateSpanId)(), sampled = arguments.length > 2 ? arguments[2] : void 0;
    return "00-".concat(traceId, "-").concat(spanId, "-").concat(sampled ? '01' : '00');
}
/**
 * Given any combination of an incoming trace, generate a sample rand based on its defined semantics.
 *
 * Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
 */ function getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    // When there is an incoming sample rand use it.
    var parsedSampleRand = (0, _parseSampleRateJs.parseSampleRate)(dsc === null || dsc === void 0 ? void 0 : dsc.sample_rand);
    if (parsedSampleRand !== undefined) return parsedSampleRand;
    // Otherwise, if there is an incoming sampling decision + sample rate, generate a sample rand that would lead to the same sampling decision.
    var parsedSampleRate = (0, _parseSampleRateJs.parseSampleRate)(dsc === null || dsc === void 0 ? void 0 : dsc.sample_rate);
    if (parsedSampleRate && (traceparentData === null || traceparentData === void 0 ? void 0 : traceparentData.parentSampled) !== undefined) return traceparentData.parentSampled ? Math.random() * parsedSampleRate : parsedSampleRate + Math.random() * (1 - parsedSampleRate);
    else // If nothing applies, return a random sample rand.
    return Math.random();
}
/**
 * Determines whether a new trace should be continued based on the provided baggage org ID and the client's `strictTraceContinuation` option.
 * If the trace should not be continued, a new trace will be started.
 *
 * The result is dependent on the `strictTraceContinuation` option in the client.
 * See https://develop.sentry.dev/sdk/telemetry/traces/#stricttracecontinuation
 */ function shouldContinueTrace(client, baggageOrgId) {
    var clientOrgId = (0, _dsnJs.extractOrgIdFromClient)(client);
    // Case: baggage orgID and Client orgID don't match - always start new trace
    if (baggageOrgId && clientOrgId && baggageOrgId !== clientOrgId) {
        (0, _debugLoggerJs.debug).log("Won't continue trace because org IDs don't match (incoming baggage: ".concat(baggageOrgId, ", SDK options: ").concat(clientOrgId, ")"));
        return false;
    }
    var strictTraceContinuation = client.getOptions().strictTraceContinuation || false; // default for `strictTraceContinuation` is `false`
    if (strictTraceContinuation) // With strict continuation enabled, don't continue trace if:
    // - Baggage has orgID, but Client doesn't have one
    // - Client has orgID, but baggage doesn't have one
    {
        if (baggageOrgId && !clientOrgId || !baggageOrgId && clientOrgId) {
            (0, _debugLoggerJs.debug).log("Starting a new trace because strict trace continuation is enabled but one org ID is missing (incoming baggage: ".concat(baggageOrgId, ", Sentry client: ").concat(clientOrgId, ")"));
            return false;
        }
    }
    return true;
}

},{"./debug-logger.js":"8ZbA0","./baggage.js":"1l8af","./dsn.js":"cQ6Rk","./parseSampleRate.js":"1Xa4Z","./propagationContext.js":"96jC2","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1Xa4Z":[function(require,module,exports,__globalThis) {
/**
 * Parse a sample rate from a given value.
 * This will either return a boolean or number sample rate, if the sample rate is valid (between 0 and 1).
 * If a string is passed, we try to convert it to a number.
 *
 * Any invalid sample rate will return `undefined`.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseSampleRate", function() {
    return parseSampleRate;
});
function parseSampleRate(sampleRate) {
    if (typeof sampleRate === 'boolean') return Number(sampleRate);
    var rate = typeof sampleRate === 'string' ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== 'number' || isNaN(rate) || rate < 0 || rate > 1) return undefined;
    return rate;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9HGrJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addItemToEnvelope", function() {
    return addItemToEnvelope;
});
parcelHelpers.export(exports, "createAttachmentEnvelopeItem", function() {
    return createAttachmentEnvelopeItem;
});
parcelHelpers.export(exports, "createEnvelope", function() {
    return createEnvelope;
});
parcelHelpers.export(exports, "createEventEnvelopeHeaders", function() {
    return createEventEnvelopeHeaders;
});
parcelHelpers.export(exports, "createSpanEnvelopeItem", function() {
    return createSpanEnvelopeItem;
});
parcelHelpers.export(exports, "envelopeContainsItemType", function() {
    return envelopeContainsItemType;
});
parcelHelpers.export(exports, "envelopeItemTypeToDataCategory", function() {
    return envelopeItemTypeToDataCategory;
});
parcelHelpers.export(exports, "forEachEnvelopeItem", function() {
    return forEachEnvelopeItem;
});
parcelHelpers.export(exports, "getSdkMetadataForEnvelopeHeader", function() {
    return getSdkMetadataForEnvelopeHeader;
});
parcelHelpers.export(exports, "parseEnvelope", function() {
    return parseEnvelope;
});
parcelHelpers.export(exports, "serializeEnvelope", function() {
    return serializeEnvelope;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _carrierJs = require("../carrier.js");
var _dsnJs = require("./dsn.js");
var _normalizeJs = require("./normalize.js");
var _worldwideJs = require("./worldwide.js");
/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function createEnvelope(headers) {
    var items = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function addItemToEnvelope(envelope, newItem) {
    var _envelope = (0, _slicedToArray._)(envelope, 2), headers = _envelope[0], items = _envelope[1];
    return [
        headers,
        (0, _toConsumableArray._)(items).concat([
            newItem
        ])
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function forEachEnvelopeItem(envelope, callback) {
    var envelopeItems = envelope[1];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = envelopeItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var envelopeItem = _step.value;
            var envelopeItemType = envelopeItem[0].type;
            var result = callback(envelopeItem, envelopeItemType);
            if (result) return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function envelopeContainsItemType(envelope, types) {
    return forEachEnvelopeItem(envelope, function(_, type) {
        return types.includes(type);
    });
}
/**
 * Encode a string to UTF8 array.
 */ function encodeUTF8(input) {
    var carrier = (0, _carrierJs.getSentryCarrier)((0, _worldwideJs.GLOBAL_OBJ));
    return carrier.encodePolyfill ? carrier.encodePolyfill(input) : new TextEncoder().encode(input);
}
/**
 * Decode a UTF8 array to string.
 */ function decodeUTF8(input) {
    var carrier = (0, _carrierJs.getSentryCarrier)((0, _worldwideJs.GLOBAL_OBJ));
    return carrier.decodePolyfill ? carrier.decodePolyfill(input) : new TextDecoder().decode(input);
}
/**
 * Serializes an envelope.
 */ function serializeEnvelope(envelope) {
    var _envelope = (0, _slicedToArray._)(envelope, 2), envHeaders = _envelope[0], items = _envelope[1];
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    var parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === 'string') parts = typeof next === 'string' ? parts + next : [
            encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === 'string' ? encodeUTF8(next) : next);
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            var _item = (0, _slicedToArray._)(item, 2), itemHeaders = _item[0], payload = _item[1];
            append("\n".concat(JSON.stringify(itemHeaders), "\n"));
            if (typeof payload === 'string' || (0, _instanceof._)(payload, Uint8Array)) append(payload);
            else {
                var stringifiedPayload = void 0;
                try {
                    stringifiedPayload = JSON.stringify(payload);
                } catch (e) {
                    // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.stringify()` still
                    // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                    // performance impact but in this case a performance hit is better than throwing.
                    stringifiedPayload = JSON.stringify((0, _normalizeJs.normalize)(payload));
                }
                append(stringifiedPayload);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return typeof parts === 'string' ? parts : concatBuffers(parts);
}
function concatBuffers(buffers) {
    var totalLength = buffers.reduce(function(acc, buf) {
        return acc + buf.length;
    }, 0);
    var merged = new Uint8Array(totalLength);
    var offset = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = buffers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var buffer = _step.value;
            merged.set(buffer, offset);
            offset += buffer.length;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return merged;
}
/**
 * Parses an envelope
 */ function parseEnvelope(env) {
    var buffer = typeof env === 'string' ? encodeUTF8(env) : env;
    function readBinary(length) {
        var bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        var i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse(decodeUTF8(readBinary(i)));
    }
    var envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var items = [];
    while(buffer.length){
        var itemHeader = readJson();
        var binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates envelope item for a single span
 */ function createSpanEnvelopeItem(spanJson) {
    var spanHeaders = {
        type: 'span'
    };
    return [
        spanHeaders,
        spanJson
    ];
}
/**
 * Creates attachment envelope items
 */ function createAttachmentEnvelopeItem(attachment) {
    var buffer = typeof attachment.data === 'string' ? encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: 'attachment',
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
var ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: 'session',
    sessions: 'session',
    attachment: 'attachment',
    transaction: 'transaction',
    event: 'error',
    client_report: 'internal',
    user_report: 'default',
    profile: 'profile',
    profile_chunk: 'profile',
    replay_event: 'replay',
    replay_recording: 'replay',
    check_in: 'monitor',
    feedback: 'feedback',
    span: 'span',
    raw_security: 'security',
    log: 'log_item',
    metric: 'metric',
    trace_metric: 'metric'
};
/**
 * Maps the type of an envelope item to a data category.
 */ function envelopeItemTypeToDataCategory(type) {
    return ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function getSdkMetadataForEnvelopeHeader(metadataOrEvent) {
    if (!(metadataOrEvent === null || metadataOrEvent === void 0 ? void 0 : metadataOrEvent.sdk)) return;
    var _metadataOrEvent_sdk = metadataOrEvent.sdk, name = _metadataOrEvent_sdk.name, version = _metadataOrEvent_sdk.version;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn) {
    var _event_sdkProcessingMetadata;
    var dynamicSamplingContext = (_event_sdkProcessingMetadata = event.sdkProcessingMetadata) === null || _event_sdkProcessingMetadata === void 0 ? void 0 : _event_sdkProcessingMetadata.dynamicSamplingContext;
    return (0, _objectSpread._)({
        event_id: event.event_id,
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }, !!tunnel && dsn && {
        dsn: (0, _dsnJs.dsnToString)(dsn)
    }, dynamicSamplingContext && {
        trace: dynamicSamplingContext
    });
}

},{"@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_to_consumable_array":"1eSZf","../carrier.js":"eMQiO","./dsn.js":"cQ6Rk","./normalize.js":"lCs0t","./worldwide.js":"ez2k9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lCs0t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "normalize", function() {
    return normalize;
});
parcelHelpers.export(exports, "normalizeToSize", function() {
    return normalizeToSize;
});
parcelHelpers.export(exports, "normalizeUrlToBase", function() {
    return normalizeUrlToBase;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var _isJs = require("./is.js");
var _objectJs = require("./object.js");
var _stacktraceJs = require("./stacktrace.js");
var global = arguments[3];
/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normalized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function normalize(input) {
    var depth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100, maxProperties = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Infinity;
    try {
        // since we're at the outermost level, we don't provide a key
        return visit('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: "**non-serializable** (".concat(err, ")")
        };
    }
}
/** JSDoc */ function normalizeToSize(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object) {
    var // Default Node.js REPL depth
    depth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
    maxSize = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 102400;
    var normalized = normalize(object, depth);
    if (jsonSize(normalized) > maxSize) return normalizeToSize(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function visit(key, value) {
    var depth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Infinity, maxProperties = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Infinity, memo = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : memoBuilder();
    var _memo = (0, _slicedToArray._)(memo, 2), memoize = _memo[0], unmemoize = _memo[1];
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        'boolean',
        'string'
    ].includes(typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) || typeof value === 'number' && Number.isFinite(value)) return value;
    var stringified = stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value['__sentry_skip_normalization__']) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    var remainingDepth = typeof value['__sentry_override_normalization_depth__'] === 'number' ? value['__sentry_override_normalization_depth__'] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    var valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        var jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return visit('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (e) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    var normalized = Array.isArray(value) ? [] : {};
    var numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    var visitable = (0, _objectJs.convertToPlainObject)(value);
    for(var visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        var visitValue = visitable[visitKey];
        normalized[visitKey] = visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && (typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof global !== 'undefined' && value === global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        if ((0, _isJs.isVueViewModel)(value)) return (0, _stacktraceJs.getVueInternalName)(value);
        // React's SyntheticEvent thingy
        if ((0, _isJs.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && !Number.isFinite(value)) return "[".concat(value, "]");
        if (typeof value === 'function') return "[Function: ".concat((0, _stacktraceJs.getFunctionName)(value), "]");
        if ((typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) === 'symbol') return "[".concat(String(value), "]");
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if ((typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) === 'bigint') return "[BigInt: ".concat(String(value), "]");
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        var objName = getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return "[HTMLElement: ".concat(objName, "]");
        return "[object ".concat(objName, "]");
    } catch (err) {
        return "**non-serializable** (".concat(err, ")");
    }
}
/* eslint-enable complexity */ function getConstructorName(value) {
    var prototype = Object.getPrototypeOf(value);
    return (prototype === null || prototype === void 0 ? void 0 : prototype.constructor) ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function jsonSize(value) {
    return utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function normalizeUrlToBase(url, basePath) {
    var escapedBase = basePath// Backslash to forward
    .replace(/\\/g, '/')// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    var newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (e) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, '/').replace(/webpack:\/?/g, '') // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp("(file://)?/*".concat(escapedBase, "/*"), 'ig'), 'app:///');
}
/**
 * Helper to decycle json objects
 */ function memoBuilder() {
    var inner = new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_type_of":"iFJdx","./is.js":"7d2pF","./object.js":"eRvge","./stacktrace.js":"fLSqJ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cLjrq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reparentChildSpans", function() {
    return reparentChildSpans;
});
parcelHelpers.export(exports, "shouldIgnoreSpan", function() {
    return shouldIgnoreSpan;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
var _debugBuildJs = require("../debug-build.js");
var _debugLoggerJs = require("./debug-logger.js");
var _stringJs = require("./string.js");
function logIgnoredSpan(droppedSpan) {
    (0, _debugLoggerJs.debug).log("Ignoring span ".concat(droppedSpan.op, " - ").concat(droppedSpan.description, " because it matches `ignoreSpans`."));
}
/**
 * Check if a span should be ignored based on the ignoreSpans configuration.
 */ function shouldIgnoreSpan(span, ignoreSpans) {
    if (!(ignoreSpans === null || ignoreSpans === void 0 ? void 0 : ignoreSpans.length) || !span.description) return false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = ignoreSpans[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var pattern = _step.value;
            if (isStringOrRegExp(pattern)) {
                if ((0, _stringJs.isMatchingPattern)(span.description, pattern)) {
                    (0, _debugBuildJs.DEBUG_BUILD) && logIgnoredSpan(span);
                    return true;
                }
                continue;
            }
            if (!pattern.name && !pattern.op) continue;
            var nameMatches = pattern.name ? (0, _stringJs.isMatchingPattern)(span.description, pattern.name) : true;
            var opMatches = pattern.op ? span.op && (0, _stringJs.isMatchingPattern)(span.op, pattern.op) : true;
            // This check here is only correct because we can guarantee that we ran `isMatchingPattern`
            // for at least one of `nameMatches` and `opMatches`. So in contrary to how this looks,
            // not both op and name actually have to match. This is the most efficient way to check
            // for all combinations of name and op patterns.
            if (nameMatches && opMatches) {
                (0, _debugBuildJs.DEBUG_BUILD) && logIgnoredSpan(span);
                return true;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
/**
 * Takes a list of spans, and a span that was dropped, and re-parents the child spans of the dropped span to the parent of the dropped span, if possible.
 * This mutates the spans array in place!
 */ function reparentChildSpans(spans, dropSpan) {
    var droppedSpanParentId = dropSpan.parent_span_id;
    var droppedSpanId = dropSpan.span_id;
    // This should generally not happen, as we do not apply this on root spans
    // but to be safe, we just bail in this case
    if (!droppedSpanParentId) return;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = spans[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var span = _step.value;
            if (span.parent_span_id === droppedSpanId) span.parent_span_id = droppedSpanParentId;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function isStringOrRegExp(value) {
    return typeof value === 'string' || (0, _instanceof._)(value, RegExp);
}

},{"@swc/helpers/_/_instanceof":"h9UKc","../debug-build.js":"ltjQB","./debug-logger.js":"8ZbA0","./string.js":"jmPmL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"93nlh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "logSpanEnd", function() {
    return logSpanEnd;
});
parcelHelpers.export(exports, "logSpanStart", function() {
    return logSpanStart;
});
var _debugBuildJs = require("../debug-build.js");
var _debugLoggerJs = require("../utils/debug-logger.js");
var _spanUtilsJs = require("../utils/spanUtils.js");
/**
 * Print a log message for a started span.
 */ function logSpanStart(span) {
    if (!(0, _debugBuildJs.DEBUG_BUILD)) return;
    var _spanToJSON = (0, _spanUtilsJs.spanToJSON)(span), _spanToJSON_description = _spanToJSON.description, description = _spanToJSON_description === void 0 ? '< unknown name >' : _spanToJSON_description, _spanToJSON_op = _spanToJSON.op, op = _spanToJSON_op === void 0 ? '< unknown op >' : _spanToJSON_op, parentSpanId = _spanToJSON.parent_span_id;
    var spanId = span.spanContext().spanId;
    var sampled = (0, _spanUtilsJs.spanIsSampled)(span);
    var rootSpan = (0, _spanUtilsJs.getRootSpan)(span);
    var isRootSpan = rootSpan === span;
    var header = "[Tracing] Starting ".concat(sampled ? 'sampled' : 'unsampled', " ").concat(isRootSpan ? 'root ' : '', "span");
    var infoParts = [
        "op: ".concat(op),
        "name: ".concat(description),
        "ID: ".concat(spanId)
    ];
    if (parentSpanId) infoParts.push("parent ID: ".concat(parentSpanId));
    if (!isRootSpan) {
        var _spanToJSON1 = (0, _spanUtilsJs.spanToJSON)(rootSpan), op1 = _spanToJSON1.op, description1 = _spanToJSON1.description;
        infoParts.push("root ID: ".concat(rootSpan.spanContext().spanId));
        if (op1) infoParts.push("root op: ".concat(op1));
        if (description1) infoParts.push("root description: ".concat(description1));
    }
    (0, _debugLoggerJs.debug).log("".concat(header, "\n  ").concat(infoParts.join('\n  ')));
}
/**
 * Print a log message for an ended span.
 */ function logSpanEnd(span) {
    if (!(0, _debugBuildJs.DEBUG_BUILD)) return;
    var _spanToJSON = (0, _spanUtilsJs.spanToJSON)(span), _spanToJSON_description = _spanToJSON.description, description = _spanToJSON_description === void 0 ? '< unknown name >' : _spanToJSON_description, _spanToJSON_op = _spanToJSON.op, op = _spanToJSON_op === void 0 ? '< unknown op >' : _spanToJSON_op;
    var spanId = span.spanContext().spanId;
    var rootSpan = (0, _spanUtilsJs.getRootSpan)(span);
    var isRootSpan = rootSpan === span;
    var msg = '[Tracing] Finishing "'.concat(op, '" ').concat(isRootSpan ? 'root ' : '', 'span "').concat(description, '" with ID ').concat(spanId);
    (0, _debugLoggerJs.debug).log(msg);
}

},{"../debug-build.js":"ltjQB","../utils/debug-logger.js":"8ZbA0","../utils/spanUtils.js":"3nJab","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2qTtZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setMeasurement", function() {
    return setMeasurement;
});
parcelHelpers.export(exports, "timedEventsToMeasurements", function() {
    return timedEventsToMeasurements;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _debugBuildJs = require("../debug-build.js");
var _semanticAttributesJs = require("../semanticAttributes.js");
var _debugLoggerJs = require("../utils/debug-logger.js");
var _spanUtilsJs = require("../utils/spanUtils.js");
/**
 * Adds a measurement to the active transaction on the current global scope. You can optionally pass in a different span
 * as the 4th parameter.
 */ function setMeasurement(name, value, unit) {
    var activeSpan = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : (0, _spanUtilsJs.getActiveSpan)();
    var rootSpan = activeSpan && (0, _spanUtilsJs.getRootSpan)(activeSpan);
    if (rootSpan) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log("[Measurement] Setting measurement on root span: ".concat(name, " = ").concat(value, " ").concat(unit));
        var _obj;
        rootSpan.addEvent(name, (_obj = {}, (0, _defineProperty._)(_obj, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE), value), (0, _defineProperty._)(_obj, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT), unit), _obj));
    }
}
/**
 * Convert timed events to measurements.
 */ function timedEventsToMeasurements(events) {
    if (!events || events.length === 0) return undefined;
    var measurements = {};
    events.forEach(function(event) {
        var attributes = event.attributes || {};
        var unit = attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT];
        var value = attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE];
        if (typeof unit === 'string' && typeof value === 'number') measurements[event.name] = {
            value: value,
            unit: unit
        };
    });
    return measurements;
}

},{"@swc/helpers/_/_define_property":"e80IS","../debug-build.js":"ltjQB","../semanticAttributes.js":"1gZBD","../utils/debug-logger.js":"8ZbA0","../utils/spanUtils.js":"3nJab","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9RE4W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SentryNonRecordingSpan", function() {
    return SentryNonRecordingSpan;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _propagationContextJs = require("../utils/propagationContext.js");
var _spanUtilsJs = require("../utils/spanUtils.js");
/**
 * A Sentry Span that is non-recording, meaning it will not be sent to Sentry.
 */ var SentryNonRecordingSpan = /*#__PURE__*/ function() {
    "use strict";
    function SentryNonRecordingSpan() {
        var spanContext = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, _classCallCheck._)(this, SentryNonRecordingSpan);
        this._traceId = spanContext.traceId || (0, _propagationContextJs.generateTraceId)();
        this._spanId = spanContext.spanId || (0, _propagationContextJs.generateSpanId)();
    }
    (0, _createClass._)(SentryNonRecordingSpan, [
        {
            /** @inheritdoc */ key: "spanContext",
            value: function spanContext() {
                return {
                    spanId: this._spanId,
                    traceId: this._traceId,
                    traceFlags: (0, _spanUtilsJs.TRACE_FLAG_NONE)
                };
            }
        },
        {
            /** @inheritdoc */ key: "end",
            value: function end(_timestamp) {}
        },
        {
            /** @inheritdoc */ key: "setAttribute",
            value: function setAttribute(_key, _value) {
                return this;
            }
        },
        {
            /** @inheritdoc */ key: "setAttributes",
            value: function setAttributes(_values) {
                return this;
            }
        },
        {
            /** @inheritdoc */ key: "setStatus",
            value: function setStatus(_status) {
                return this;
            }
        },
        {
            /** @inheritdoc */ key: "updateName",
            value: function updateName(_name) {
                return this;
            }
        },
        {
            /** @inheritdoc */ key: "isRecording",
            value: function isRecording() {
                return false;
            }
        },
        {
            /** @inheritdoc */ key: "addEvent",
            value: function addEvent(_name, _attributesOrStartTime, _startTime) {
                return this;
            }
        },
        {
            /** @inheritDoc */ key: "addLink",
            value: function addLink(_link) {
                return this;
            }
        },
        {
            /** @inheritDoc */ key: "addLinks",
            value: function addLinks(_links) {
                return this;
            }
        },
        {
            /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ key: "recordException",
            value: function recordException(_exception, _time) {
            // noop
            }
        }
    ]);
    return SentryNonRecordingSpan;
}();

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","../utils/propagationContext.js":"96jC2","../utils/spanUtils.js":"3nJab","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6PWst":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "continueTrace", function() {
    return continueTrace;
});
parcelHelpers.export(exports, "startInactiveSpan", function() {
    return startInactiveSpan;
});
parcelHelpers.export(exports, "startNewTrace", function() {
    return startNewTrace;
});
parcelHelpers.export(exports, "startSpan", function() {
    return startSpan;
});
parcelHelpers.export(exports, "startSpanManual", function() {
    return startSpanManual;
});
parcelHelpers.export(exports, "suppressTracing", function() {
    return suppressTracing;
});
parcelHelpers.export(exports, "withActiveSpan", function() {
    return withActiveSpan;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _indexJs = require("../asyncContext/index.js");
var _carrierJs = require("../carrier.js");
var _currentScopesJs = require("../currentScopes.js");
var _debugBuildJs = require("../debug-build.js");
var _semanticAttributesJs = require("../semanticAttributes.js");
var _baggageJs = require("../utils/baggage.js");
var _debugLoggerJs = require("../utils/debug-logger.js");
var _handleCallbackErrorsJs = require("../utils/handleCallbackErrors.js");
var _hasSpansEnabledJs = require("../utils/hasSpansEnabled.js");
var _parseSampleRateJs = require("../utils/parseSampleRate.js");
var _propagationContextJs = require("../utils/propagationContext.js");
var _spanOnScopeJs = require("../utils/spanOnScope.js");
var _spanUtilsJs = require("../utils/spanUtils.js");
var _tracingJs = require("../utils/tracing.js");
var _dynamicSamplingContextJs = require("./dynamicSamplingContext.js");
var _logSpansJs = require("./logSpans.js");
var _samplingJs = require("./sampling.js");
var _sentryNonRecordingSpanJs = require("./sentryNonRecordingSpan.js");
var _sentrySpanJs = require("./sentrySpan.js");
var _spanstatusJs = require("./spanstatus.js");
var _utilsJs = require("./utils.js");
/* eslint-disable max-lines */ var SUPPRESS_TRACING_KEY = '__SENTRY_SUPPRESS_TRACING__';
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function startSpan(options, callback) {
    var acs = getAcs();
    if (acs.startSpan) return acs.startSpan(options, callback);
    var spanArguments = parseSentrySpanArguments(options);
    var forceTransaction = options.forceTransaction, customParentSpan = options.parentSpan, customScope = options.scope;
    // We still need to fork a potentially passed scope, as we set the active span on it
    // and we need to ensure that it is cleaned up properly once the span ends.
    var customForkedScope = customScope === null || customScope === void 0 ? void 0 : customScope.clone();
    return (0, _currentScopesJs.withScope)(customForkedScope, function() {
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        var wrapper = getActiveSpanWrapper(customParentSpan);
        return wrapper(function() {
            var scope = (0, _currentScopesJs.getCurrentScope)();
            var parentSpan = getParentSpan(scope, customParentSpan);
            var shouldSkipSpan = options.onlyIfParent && !parentSpan;
            var activeSpan = shouldSkipSpan ? new (0, _sentryNonRecordingSpanJs.SentryNonRecordingSpan)() : createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            (0, _spanOnScopeJs._setSpanForScope)(scope, activeSpan);
            return (0, _handleCallbackErrorsJs.handleCallbackErrors)(function() {
                return callback(activeSpan);
            }, function() {
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                var status = (0, _spanUtilsJs.spanToJSON)(activeSpan).status;
                if (activeSpan.isRecording() && (!status || status === 'ok')) activeSpan.setStatus({
                    code: (0, _spanstatusJs.SPAN_STATUS_ERROR),
                    message: 'internal_error'
                });
            }, function() {
                activeSpan.end();
            });
        });
    });
}
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. Use `span.end()` to end the span.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function startSpanManual(options, callback) {
    var acs = getAcs();
    if (acs.startSpanManual) return acs.startSpanManual(options, callback);
    var spanArguments = parseSentrySpanArguments(options);
    var forceTransaction = options.forceTransaction, customParentSpan = options.parentSpan, customScope = options.scope;
    var customForkedScope = customScope === null || customScope === void 0 ? void 0 : customScope.clone();
    return (0, _currentScopesJs.withScope)(customForkedScope, function() {
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        var wrapper = getActiveSpanWrapper(customParentSpan);
        return wrapper(function() {
            var scope = (0, _currentScopesJs.getCurrentScope)();
            var parentSpan = getParentSpan(scope, customParentSpan);
            var shouldSkipSpan = options.onlyIfParent && !parentSpan;
            var activeSpan = shouldSkipSpan ? new (0, _sentryNonRecordingSpanJs.SentryNonRecordingSpan)() : createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            (0, _spanOnScopeJs._setSpanForScope)(scope, activeSpan);
            return (0, _handleCallbackErrorsJs.handleCallbackErrors)(// We pass the `finish` function to the callback, so the user can finish the span manually
            // this is mainly here for historic purposes because previously, we instructed users to call
            // `finish` instead of `span.end()` to also clean up the scope. Nowadays, calling `span.end()`
            // or `finish` has the same effect and we simply leave it here to avoid breaking user code.
            function() {
                return callback(activeSpan, function() {
                    return activeSpan.end();
                });
            }, function() {
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                var status = (0, _spanUtilsJs.spanToJSON)(activeSpan).status;
                if (activeSpan.isRecording() && (!status || status === 'ok')) activeSpan.setStatus({
                    code: (0, _spanstatusJs.SPAN_STATUS_ERROR),
                    message: 'internal_error'
                });
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getActiveSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * This function will always return a span,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function startInactiveSpan(options) {
    var acs = getAcs();
    if (acs.startInactiveSpan) return acs.startInactiveSpan(options);
    var spanArguments = parseSentrySpanArguments(options);
    var forceTransaction = options.forceTransaction, customParentSpan = options.parentSpan;
    // If `options.scope` is defined, we use this as as a wrapper,
    // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
    var wrapper = options.scope ? function(callback) {
        return (0, _currentScopesJs.withScope)(options.scope, callback);
    } : customParentSpan !== undefined ? function(callback) {
        return withActiveSpan(customParentSpan, callback);
    } : function(callback) {
        return callback();
    };
    return wrapper(function() {
        var scope = (0, _currentScopesJs.getCurrentScope)();
        var parentSpan = getParentSpan(scope, customParentSpan);
        var shouldSkipSpan = options.onlyIfParent && !parentSpan;
        if (shouldSkipSpan) return new (0, _sentryNonRecordingSpanJs.SentryNonRecordingSpan)();
        return createChildOrRootSpan({
            parentSpan: parentSpan,
            spanArguments: spanArguments,
            forceTransaction: forceTransaction,
            scope: scope
        });
    });
}
/**
 * Continue a trace from `sentry-trace` and `baggage` values.
 * These values can be obtained from incoming request headers, or in the browser from `<meta name="sentry-trace">`
 * and `<meta name="baggage">` HTML tags.
 *
 * Spans started with `startSpan`, `startSpanManual` and `startInactiveSpan`, within the callback will automatically
 * be attached to the incoming trace.
 */ var continueTrace = function(options, callback) {
    var carrier = (0, _carrierJs.getMainCarrier)();
    var acs = (0, _indexJs.getAsyncContextStrategy)(carrier);
    if (acs.continueTrace) return acs.continueTrace(options, callback);
    var sentryTrace = options.sentryTrace, baggage = options.baggage;
    var client = (0, _currentScopesJs.getClient)();
    var incomingDsc = (0, _baggageJs.baggageHeaderToDynamicSamplingContext)(baggage);
    if (client && !(0, _tracingJs.shouldContinueTrace)(client, incomingDsc === null || incomingDsc === void 0 ? void 0 : incomingDsc.org_id)) return startNewTrace(callback);
    return (0, _currentScopesJs.withScope)(function(scope) {
        var propagationContext = (0, _tracingJs.propagationContextFromHeaders)(sentryTrace, baggage);
        scope.setPropagationContext(propagationContext);
        return callback();
    });
};
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback. Can be
 * passed `null` to start an entirely new span tree.
 *
 * @param span Spans started in the context of the provided callback will be children of this span. If `null` is passed,
 * spans started within the callback will not be attached to a parent span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function withActiveSpan(span, callback) {
    var acs = getAcs();
    if (acs.withActiveSpan) return acs.withActiveSpan(span, callback);
    return (0, _currentScopesJs.withScope)(function(scope) {
        (0, _spanOnScopeJs._setSpanForScope)(scope, span || undefined);
        return callback(scope);
    });
}
/** Suppress tracing in the given callback, ensuring no spans are generated inside of it. */ function suppressTracing(callback) {
    var acs = getAcs();
    if (acs.suppressTracing) return acs.suppressTracing(callback);
    return (0, _currentScopesJs.withScope)(function(scope) {
        // Note: We do not wait for the callback to finish before we reset the metadata
        // the reason for this is that otherwise, in the browser this can lead to very weird behavior
        // as there is only a single top scope, if the callback takes longer to finish,
        // other, unrelated spans may also be suppressed, which we do not want
        // so instead, we only suppress tracing synchronoysly in the browser
        scope.setSDKProcessingMetadata((0, _defineProperty._)({}, SUPPRESS_TRACING_KEY, true));
        var res = callback();
        scope.setSDKProcessingMetadata((0, _defineProperty._)({}, SUPPRESS_TRACING_KEY, undefined));
        return res;
    });
}
/**
 * Starts a new trace for the duration of the provided callback. Spans started within the
 * callback will be part of the new trace instead of a potentially previously started trace.
 *
 * Important: Only use this function if you want to override the default trace lifetime and
 * propagation mechanism of the SDK for the duration and scope of the provided callback.
 * The newly created trace will also be the root of a new distributed trace, for example if
 * you make http requests within the callback.
 * This function might be useful if the operation you want to instrument should not be part
 * of a potentially ongoing trace.
 *
 * Default behavior:
 * - Server-side: A new trace is started for each incoming request.
 * - Browser: A new trace is started for each page our route. Navigating to a new route
 *            or page will automatically create a new trace.
 */ function startNewTrace(callback) {
    return (0, _currentScopesJs.withScope)(function(scope) {
        scope.setPropagationContext({
            traceId: (0, _propagationContextJs.generateTraceId)(),
            sampleRand: Math.random()
        });
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log("Starting a new trace with id ".concat(scope.getPropagationContext().traceId));
        return withActiveSpan(null, callback);
    });
}
function createChildOrRootSpan(param) {
    var parentSpan = param.parentSpan, spanArguments = param.spanArguments, forceTransaction = param.forceTransaction, scope = param.scope;
    if (!(0, _hasSpansEnabledJs.hasSpansEnabled)()) {
        var span = new (0, _sentryNonRecordingSpanJs.SentryNonRecordingSpan)();
        // If this is a root span, we ensure to freeze a DSC
        // So we can have at least partial data here
        if (forceTransaction || !parentSpan) {
            var dsc = (0, _objectSpread._)({
                sampled: 'false',
                sample_rate: '0',
                transaction: spanArguments.name
            }, (0, _dynamicSamplingContextJs.getDynamicSamplingContextFromSpan)(span));
            (0, _dynamicSamplingContextJs.freezeDscOnSpan)(span, dsc);
        }
        return span;
    }
    var isolationScope = (0, _currentScopesJs.getIsolationScope)();
    var span1;
    if (parentSpan && !forceTransaction) {
        span1 = _startChildSpan(parentSpan, scope, spanArguments);
        (0, _spanUtilsJs.addChildSpanToSpan)(parentSpan, span1);
    } else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        var dsc1 = (0, _dynamicSamplingContextJs.getDynamicSamplingContextFromSpan)(parentSpan);
        var _parentSpan_spanContext = parentSpan.spanContext(), traceId = _parentSpan_spanContext.traceId, parentSpanId = _parentSpan_spanContext.spanId;
        var parentSampled = (0, _spanUtilsJs.spanIsSampled)(parentSpan);
        span1 = _startRootSpan((0, _objectSpread._)({
            traceId: traceId,
            parentSpanId: parentSpanId
        }, spanArguments), scope, parentSampled);
        (0, _dynamicSamplingContextJs.freezeDscOnSpan)(span1, dsc1);
    } else {
        var _$_object_spread = (0, _objectSpread._)({}, isolationScope.getPropagationContext(), scope.getPropagationContext()), traceId1 = _$_object_spread.traceId, dsc2 = _$_object_spread.dsc, parentSpanId1 = _$_object_spread.parentSpanId, parentSampled1 = _$_object_spread.sampled;
        span1 = _startRootSpan((0, _objectSpread._)({
            traceId: traceId1,
            parentSpanId: parentSpanId1
        }, spanArguments), scope, parentSampled1);
        if (dsc2) (0, _dynamicSamplingContextJs.freezeDscOnSpan)(span1, dsc2);
    }
    (0, _logSpansJs.logSpanStart)(span1);
    (0, _utilsJs.setCapturedScopesOnSpan)(span1, scope, isolationScope);
    return span1;
}
/**
 * This converts StartSpanOptions to SentrySpanArguments.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 */ function parseSentrySpanArguments(options) {
    var exp = options.experimental || {};
    var initialCtx = (0, _objectSpread._)({
        isStandalone: exp.standalone
    }, options);
    if (options.startTime) {
        var ctx = (0, _objectSpread._)({}, initialCtx);
        ctx.startTimestamp = (0, _spanUtilsJs.spanTimeInputToSeconds)(options.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return initialCtx;
}
function getAcs() {
    var carrier = (0, _carrierJs.getMainCarrier)();
    return (0, _indexJs.getAsyncContextStrategy)(carrier);
}
function _startRootSpan(spanArguments, scope, parentSampled) {
    var _currentPropagationContext_dsc;
    var client = (0, _currentScopesJs.getClient)();
    var options = (client === null || client === void 0 ? void 0 : client.getOptions()) || {};
    var _spanArguments_name = spanArguments.name, name = _spanArguments_name === void 0 ? '' : _spanArguments_name;
    var mutableSpanSamplingData = {
        spanAttributes: (0, _objectSpread._)({}, spanArguments.attributes),
        spanName: name,
        parentSampled: parentSampled
    };
    // we don't care about the decision for the moment; this is just a placeholder
    client === null || client === void 0 ? void 0 : client.emit('beforeSampling', mutableSpanSamplingData, {
        decision: false
    });
    var _mutableSpanSamplingData_parentSampled;
    // If hook consumers override the parentSampled flag, we will use that value instead of the actual one
    var finalParentSampled = (_mutableSpanSamplingData_parentSampled = mutableSpanSamplingData.parentSampled) !== null && _mutableSpanSamplingData_parentSampled !== void 0 ? _mutableSpanSamplingData_parentSampled : parentSampled;
    var finalAttributes = mutableSpanSamplingData.spanAttributes;
    var currentPropagationContext = scope.getPropagationContext();
    var _ref = (0, _slicedToArray._)(scope.getScopeData().sdkProcessingMetadata[SUPPRESS_TRACING_KEY] ? [
        false
    ] : (0, _samplingJs.sampleSpan)(options, {
        name: name,
        parentSampled: finalParentSampled,
        attributes: finalAttributes,
        parentSampleRate: (0, _parseSampleRateJs.parseSampleRate)((_currentPropagationContext_dsc = currentPropagationContext.dsc) === null || _currentPropagationContext_dsc === void 0 ? void 0 : _currentPropagationContext_dsc.sample_rate)
    }, currentPropagationContext.sampleRand), 3), sampled = _ref[0], sampleRate = _ref[1], localSampleRateWasApplied = _ref[2];
    var _obj;
    var rootSpan = new (0, _sentrySpanJs.SentrySpan)((0, _objectSpreadProps._)((0, _objectSpread._)({}, spanArguments), {
        attributes: (0, _objectSpread._)((_obj = {}, (0, _defineProperty._)(_obj, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), 'custom'), (0, _defineProperty._)(_obj, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), sampleRate !== undefined && localSampleRateWasApplied ? sampleRate : undefined), _obj), finalAttributes),
        sampled: sampled
    }));
    if (!sampled && client) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log('[Tracing] Discarding root span because its trace was not chosen to be sampled.');
        client.recordDroppedEvent('sample_rate', 'transaction');
    }
    if (client) client.emit('spanStart', rootSpan);
    return rootSpan;
}
/**
 * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
 * This inherits the sampling decision from the parent span.
 */ function _startChildSpan(parentSpan, scope, spanArguments) {
    var _parentSpan_spanContext = parentSpan.spanContext(), spanId = _parentSpan_spanContext.spanId, traceId = _parentSpan_spanContext.traceId;
    var sampled = scope.getScopeData().sdkProcessingMetadata[SUPPRESS_TRACING_KEY] ? false : (0, _spanUtilsJs.spanIsSampled)(parentSpan);
    var childSpan = sampled ? new (0, _sentrySpanJs.SentrySpan)((0, _objectSpreadProps._)((0, _objectSpread._)({}, spanArguments), {
        parentSpanId: spanId,
        traceId: traceId,
        sampled: sampled
    })) : new (0, _sentryNonRecordingSpanJs.SentryNonRecordingSpan)({
        traceId: traceId
    });
    (0, _spanUtilsJs.addChildSpanToSpan)(parentSpan, childSpan);
    var client = (0, _currentScopesJs.getClient)();
    if (client) {
        client.emit('spanStart', childSpan);
        // If it has an endTimestamp, it's already ended
        if (spanArguments.endTimestamp) client.emit('spanEnd', childSpan);
    }
    return childSpan;
}
function getParentSpan(scope, customParentSpan) {
    // always use the passed in span directly
    if (customParentSpan) return customParentSpan;
    // This is different from `undefined` as it means the user explicitly wants no parent span
    if (customParentSpan === null) return undefined;
    var span = (0, _spanOnScopeJs._getSpanForScope)(scope);
    if (!span) return undefined;
    var client = (0, _currentScopesJs.getClient)();
    var options = client ? client.getOptions() : {};
    if (options.parentSpanIsAlwaysRootSpan) return (0, _spanUtilsJs.getRootSpan)(span);
    return span;
}
function getActiveSpanWrapper(parentSpan) {
    return parentSpan !== undefined ? function(callback) {
        return withActiveSpan(parentSpan, callback);
    } : function(callback) {
        return callback();
    };
}

},{"@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_sliced_to_array":"8PtL6","../asyncContext/index.js":"5J8tn","../carrier.js":"eMQiO","../currentScopes.js":"gz9fq","../debug-build.js":"ltjQB","../semanticAttributes.js":"1gZBD","../utils/baggage.js":"1l8af","../utils/debug-logger.js":"8ZbA0","../utils/handleCallbackErrors.js":"l034C","../utils/hasSpansEnabled.js":"6JXLr","../utils/parseSampleRate.js":"1Xa4Z","../utils/propagationContext.js":"96jC2","../utils/spanOnScope.js":"NI6uV","../utils/spanUtils.js":"3nJab","../utils/tracing.js":"e0DzU","./dynamicSamplingContext.js":"iV5HZ","./logSpans.js":"93nlh","./sampling.js":"4pqtV","./sentryNonRecordingSpan.js":"9RE4W","./sentrySpan.js":"9WhTS","./spanstatus.js":"9Rb4c","./utils.js":"5qiWB","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"l034C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "handleCallbackErrors", function() {
    return handleCallbackErrors;
});
var _isJs = require("./is.js");
/* eslint-disable */ // Vendor "Awaited" in to be TS 3.8 compatible
/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function handleCallbackErrors(fn, onError) {
    var onFinally = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function() {}, onSuccess = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : function() {};
    var maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally, onSuccess);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */ function maybeHandlePromiseRejection(value, onError, onFinally, onSuccess) {
    if ((0, _isJs.isThenable)(value)) // @ts-expect-error - the isThenable check returns the "wrong" type here
    return value.then(function(res) {
        onFinally();
        onSuccess(res);
        return res;
    }, function(e) {
        onError(e);
        onFinally();
        throw e;
    });
    onFinally();
    onSuccess(value);
    return value;
}

},{"./is.js":"7d2pF","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4pqtV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sampleSpan", function() {
    return sampleSpan;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _typeOf = require("@swc/helpers/_/_type_of");
var _debugBuildJs = require("../debug-build.js");
var _debugLoggerJs = require("../utils/debug-logger.js");
var _hasSpansEnabledJs = require("../utils/hasSpansEnabled.js");
var _parseSampleRateJs = require("../utils/parseSampleRate.js");
/**
 * Makes a sampling decision for the given options.
 *
 * Called every time a root span is created. Only root spans which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 */ function sampleSpan(options, samplingContext, sampleRand) {
    // nothing to do if span recording is not enabled
    if (!(0, _hasSpansEnabledJs.hasSpansEnabled)(options)) return [
        false
    ];
    var localSampleRateWasApplied = undefined;
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` were defined, so one of these should
    // work; prefer the hook if so
    var sampleRate;
    if (typeof options.tracesSampler === 'function') {
        sampleRate = options.tracesSampler((0, _objectSpreadProps._)((0, _objectSpread._)({}, samplingContext), {
            inheritOrSampleWith: function(fallbackSampleRate) {
                // If we have an incoming parent sample rate, we'll just use that one.
                // The sampling decision will be inherited because of the sample_rand that was generated when the trace reached the incoming boundaries of the SDK.
                if (typeof samplingContext.parentSampleRate === 'number') return samplingContext.parentSampleRate;
                // Fallback if parent sample rate is not on the incoming trace (e.g. if there is no baggage)
                // This is to provide backwards compatibility if there are incoming traces from older SDKs that don't send a parent sample rate or a sample rand. In these cases we just want to force either a sampling decision on the downstream traces via the sample rate.
                if (typeof samplingContext.parentSampled === 'boolean') return Number(samplingContext.parentSampled);
                return fallbackSampleRate;
            }
        }));
        localSampleRateWasApplied = true;
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== 'undefined') {
        sampleRate = options.tracesSampleRate;
        localSampleRateWasApplied = true;
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get.
    // (The only valid values are booleans or numbers between 0 and 1.)
    var parsedSampleRate = (0, _parseSampleRateJs.parseSampleRate)(sampleRate);
    if (parsedSampleRate === undefined) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn("[Tracing] Discarding root span because of invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ".concat(JSON.stringify(sampleRate), " of type ").concat(JSON.stringify(typeof sampleRate === "undefined" ? "undefined" : (0, _typeOf._)(sampleRate)), "."));
        return [
            false
        ];
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!parsedSampleRate) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log("[Tracing] Discarding transaction because ".concat(typeof options.tracesSampler === 'function' ? 'tracesSampler returned 0 or false' : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'));
        return [
            false,
            parsedSampleRate,
            localSampleRateWasApplied
        ];
    }
    // We always compare the sample rand for the current execution context against the chosen sample rate.
    // Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
    var shouldSample = sampleRand < parsedSampleRate;
    // if we're not going to keep it, we're done
    if (!shouldSample) (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log("[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ".concat(Number(sampleRate), ")"));
    return [
        shouldSample,
        parsedSampleRate,
        localSampleRateWasApplied
    ];
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_type_of":"iFJdx","../debug-build.js":"ltjQB","../utils/debug-logger.js":"8ZbA0","../utils/hasSpansEnabled.js":"6JXLr","../utils/parseSampleRate.js":"1Xa4Z","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gWN7s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addHandler", function() {
    return addHandler;
});
parcelHelpers.export(exports, "maybeInstrument", function() {
    return maybeInstrument;
});
parcelHelpers.export(exports, "resetInstrumentationHandlers", function() {
    return resetInstrumentationHandlers;
});
parcelHelpers.export(exports, "triggerHandlers", function() {
    return triggerHandlers;
});
var _debugBuildJs = require("../debug-build.js");
var _debugLoggerJs = require("../utils/debug-logger.js");
var _stacktraceJs = require("../utils/stacktrace.js");
// We keep the handlers globally
var handlers = {};
var instrumented = {};
/** Add a handler function. */ function addHandler(type, handler) {
    handlers[type] = handlers[type] || [];
    handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function resetInstrumentationHandlers() {
    Object.keys(handlers).forEach(function(key) {
        handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function maybeInstrument(type, instrumentFn) {
    if (!instrumented[type]) {
        instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).error("Error while instrumenting ".concat(type), e);
        }
    }
}
/** Trigger handlers for a given instrumentation type. */ function triggerHandlers(type, data) {
    var typeHandlers = type && handlers[type];
    if (!typeHandlers) return;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = typeHandlers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var handler = _step.value;
            try {
                handler(data);
            } catch (e) {
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).error("Error while triggering instrumentation handler.\nType: ".concat(type, "\nName: ").concat((0, _stacktraceJs.getFunctionName)(handler), "\nError:"), e);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}

},{"../debug-build.js":"ltjQB","../utils/debug-logger.js":"8ZbA0","../utils/stacktrace.js":"fLSqJ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9KH0H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isBrowser", function() {
    return isBrowser;
});
var _nodeJs = require("./node.js");
var _worldwideJs = require("./worldwide.js");
/**
 * Returns true if we are in the browser.
 */ function isBrowser() {
    // eslint-disable-next-line no-restricted-globals
    return typeof window !== 'undefined' && (!(0, _nodeJs.isNodeEnv)() || isElectronNodeRenderer());
}
// Electron renderers with nodeIntegration enabled are detected as Node.js so we specifically test for them
function isElectronNodeRenderer() {
    var process = (0, _worldwideJs.GLOBAL_OBJ).process;
    return (process === null || process === void 0 ? void 0 : process.type) === 'renderer';
}

},{"./node.js":"dgYTV","./worldwide.js":"ez2k9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dgYTV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNodeEnv", function() {
    return isNodeEnv;
});
parcelHelpers.export(exports, "loadModule", function() {
    return loadModule;
});
var _envJs = require("./env.js");
var process = require("f229b9c1f102a22e");
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the `debug` singleton, or b) put your function elsewhere.
 */ /**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, _envJs.isBrowserBundle)() && Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]';
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @param existingModule module to use for requiring
 * @returns possibly required module
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function loadModule(moduleName) {
    var existingModule = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : module;
    var mod;
    try {
        mod = dynamicRequire(existingModule, moduleName);
    } catch (e) {
    // no-empty
    }
    if (!mod) try {
        var cwd = dynamicRequire(existingModule, 'process').cwd;
        mod = dynamicRequire(existingModule, "".concat(cwd(), "/node_modules/").concat(moduleName));
    } catch (e) {
    // no-empty
    }
    return mod;
}

},{"f229b9c1f102a22e":"gNLf3","./env.js":"9DQLm","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9DQLm":[function(require,module,exports,__globalThis) {
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `debug` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSDKSource", function() {
    return getSDKSource;
});
parcelHelpers.export(exports, "isBrowserBundle", function() {
    return isBrowserBundle;
});
function isBrowserBundle() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function getSDKSource() {
    // This comment is used to identify this line in the CDN bundle build step and replace this with "return 'cdn';"
    /* __SENTRY_SDK_SOURCE__ */ return 'npm';
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"92ooK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNativeFunction", function() {
    return isNativeFunction;
});
parcelHelpers.export(exports, "supportsDOMError", function() {
    return supportsDOMError;
});
parcelHelpers.export(exports, "supportsDOMException", function() {
    return supportsDOMException;
});
parcelHelpers.export(exports, "supportsErrorEvent", function() {
    return supportsErrorEvent;
});
parcelHelpers.export(exports, "supportsFetch", function() {
    return supportsFetch;
});
parcelHelpers.export(exports, "supportsHistory", function() {
    return supportsHistory;
});
parcelHelpers.export(exports, "supportsNativeFetch", function() {
    return supportsNativeFetch;
});
parcelHelpers.export(exports, "supportsReferrerPolicy", function() {
    return supportsReferrerPolicy;
});
parcelHelpers.export(exports, "supportsReportingObserver", function() {
    return supportsReportingObserver;
});
var _debugBuildJs = require("../debug-build.js");
var _debugLoggerJs = require("./debug-logger.js");
var _worldwideJs = require("./worldwide.js");
var WINDOW = (0, _worldwideJs.GLOBAL_OBJ);
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function supportsErrorEvent() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function supportsDOMError() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function supportsDOMException() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function supportsHistory() {
    return 'history' in WINDOW && !!WINDOW.history;
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 * @deprecated This is no longer used and will be removed in a future major version.
 */ var supportsFetch = _isFetchSupported;
function _isFetchSupported() {
    if (!('fetch' in WINDOW)) return false;
    try {
        new Headers();
        // Deno requires a valid URL so '' cannot be used as an argument
        new Request('data:,');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNative checks if the given function is a native implementation
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function isNativeFunction(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function supportsNativeFetch() {
    if (typeof EdgeRuntime === 'string') return true;
    if (!_isFetchSupported()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if (isNativeFunction(WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    var result = false;
    var doc = WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        var _sandbox_contentWindow;
        var sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if ((_sandbox_contentWindow = sandbox.contentWindow) === null || _sandbox_contentWindow === void 0 ? void 0 : _sandbox_contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = isNativeFunction(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function supportsReportingObserver() {
    return 'ReportingObserver' in WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 * @deprecated This is no longer used and will be removed in a future major version.
 */ function supportsReferrerPolicy() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!_isFetchSupported()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}

},{"../debug-build.js":"ltjQB","./debug-logger.js":"8ZbA0","./worldwide.js":"ez2k9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9VVsK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getHttpSpanDetailsFromUrlObject", function() {
    return getHttpSpanDetailsFromUrlObject;
});
parcelHelpers.export(exports, "getSanitizedUrlString", function() {
    return getSanitizedUrlString;
});
parcelHelpers.export(exports, "getSanitizedUrlStringFromUrlObject", function() {
    return getSanitizedUrlStringFromUrlObject;
});
parcelHelpers.export(exports, "isURLObjectRelative", function() {
    return isURLObjectRelative;
});
parcelHelpers.export(exports, "parseStringToURLObject", function() {
    return parseStringToURLObject;
});
parcelHelpers.export(exports, "parseUrl", function() {
    return parseUrl;
});
parcelHelpers.export(exports, "stripUrlQueryAndFragment", function() {
    return stripUrlQueryAndFragment;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _semanticAttributesJs = require("../semanticAttributes.js");
// Curious about `thismessage:/`? See: https://www.rfc-editor.org/rfc/rfc2557.html
//  > When the methods above do not yield an absolute URI, a base URL
//  > of "thismessage:/" MUST be employed. This base URL has been
//  > defined for the sole purpose of resolving relative references
//  > within a multipart/related structure when no other base URI is
//  > specified.
//
// We need to provide a base URL to `parseStringToURLObject` because the fetch API gives us a
// relative URL sometimes.
//
// This is the only case where we need to provide a base URL to `parseStringToURLObject`
// because the relative URL is not valid on its own.
var DEFAULT_BASE_URL = 'thismessage:/';
/**
 * Checks if the URL object is relative
 *
 * @param url - The URL object to check
 * @returns True if the URL object is relative, false otherwise
 */ function isURLObjectRelative(url) {
    return 'isRelative' in url;
}
/**
 * Parses string to a URL object
 *
 * @param url - The URL to parse
 * @returns The parsed URL object or undefined if the URL is invalid
 */ function parseStringToURLObject(url, urlBase) {
    var isRelative = url.indexOf('://') <= 0 && url.indexOf('//') !== 0;
    var base = urlBase !== null && urlBase !== void 0 ? urlBase : isRelative ? DEFAULT_BASE_URL : undefined;
    try {
        // Use `canParse` to short-circuit the URL constructor if it's not a valid URL
        // This is faster than trying to construct the URL and catching the error
        // Node 20+, Chrome 120+, Firefox 115+, Safari 17+
        if ('canParse' in URL && !URL.canParse(url, base)) return undefined;
        var fullUrlObject = new URL(url, base);
        if (isRelative) // Because we used a fake base URL, we need to return a relative URL object.
        // We cannot return anything about the origin, host, etc. because it will refer to the fake base URL.
        return {
            isRelative: isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch (e) {
    // empty body
    }
    return undefined;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function getSanitizedUrlStringFromUrlObject(url) {
    if (isURLObjectRelative(url)) return url.pathname;
    var newUrl = new URL(url);
    newUrl.search = '';
    newUrl.hash = '';
    if ([
        '80',
        '443'
    ].includes(newUrl.port)) newUrl.port = '';
    if (newUrl.password) newUrl.password = '%filtered%';
    if (newUrl.username) newUrl.username = '%filtered%';
    return newUrl.toString();
}
function getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName) {
    var _request_method;
    var _request_method_toUpperCase;
    var method = (_request_method_toUpperCase = request === null || request === void 0 ? void 0 : (_request_method = request.method) === null || _request_method === void 0 ? void 0 : _request_method.toUpperCase()) !== null && _request_method_toUpperCase !== void 0 ? _request_method_toUpperCase : 'GET';
    var route = routeName ? routeName : urlObject ? kind === 'client' ? getSanitizedUrlStringFromUrlObject(urlObject) : urlObject.pathname : '/';
    return "".concat(method, " ").concat(route);
}
/**
 * Takes a parsed URL object and returns a set of attributes for the span
 * that represents the HTTP request for that url. This is used for both server
 * and client http spans.
 *
 * Follows https://opentelemetry.io/docs/specs/semconv/http/.
 *
 * @param urlObject - see {@link parseStringToURLObject}
 * @param kind - The type of HTTP operation (server or client)
 * @param spanOrigin - The origin of the span
 * @param request - The request object, see {@link PartialRequest}
 * @param routeName - The name of the route, must be low cardinality
 * @returns The span name and attributes for the HTTP operation
 */ function getHttpSpanDetailsFromUrlObject(urlObject, kind, spanOrigin, request, routeName) {
    var _obj;
    var attributes = (_obj = {}, (0, _defineProperty._)(_obj, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), spanOrigin), (0, _defineProperty._)(_obj, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), 'url'), _obj);
    if (routeName) {
        // This is based on https://opentelemetry.io/docs/specs/semconv/http/http-spans/#name
        attributes[kind === 'server' ? 'http.route' : 'url.template'] = routeName;
        attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = 'route';
    }
    if (request === null || request === void 0 ? void 0 : request.method) attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD] = request.method.toUpperCase();
    if (urlObject) {
        if (urlObject.search) attributes['url.query'] = urlObject.search;
        if (urlObject.hash) attributes['url.fragment'] = urlObject.hash;
        if (urlObject.pathname) {
            attributes['url.path'] = urlObject.pathname;
            if (urlObject.pathname === '/') attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = 'route';
        }
        if (!isURLObjectRelative(urlObject)) {
            attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_URL_FULL] = urlObject.href;
            if (urlObject.port) attributes['url.port'] = urlObject.port;
            if (urlObject.protocol) attributes['url.scheme'] = urlObject.protocol;
            if (urlObject.hostname) attributes[kind === 'server' ? 'server.address' : 'url.domain'] = urlObject.hostname;
        }
    }
    return [
        getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName),
        attributes
    ];
}
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function parseUrl(url) {
    if (!url) return {};
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function stripUrlQueryAndFragment(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function getSanitizedUrlString(url) {
    var protocol = url.protocol, host = url.host, path = url.path;
    var filteredHost = (host === null || host === void 0 ? void 0 : host.replace(/^.*@/, '[filtered]:[filtered]@')// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, '').replace(/(:443)$/, '')) || '';
    return "".concat(protocol ? "".concat(protocol, "://") : '').concat(filteredHost).concat(path);
}

},{"@swc/helpers/_/_define_property":"e80IS","../semanticAttributes.js":"1gZBD","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jrbj2":[function(require,module,exports,__globalThis) {
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEBUG_BUILD", function() {
    return DEBUG_BUILD;
});
var DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cls7N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CLSThresholds", function() {
    return CLSThresholds;
});
parcelHelpers.export(exports, "onCLS", function() {
    return onCLS;
});
var _typesJs = require("../../types.js");
var _bindReporterJs = require("./lib/bindReporter.js");
var _getVisibilityWatcherJs = require("./lib/getVisibilityWatcher.js");
var _initMetricJs = require("./lib/initMetric.js");
var _initUniqueJs = require("./lib/initUnique.js");
var _layoutShiftManagerJs = require("./lib/LayoutShiftManager.js");
var _observeJs = require("./lib/observe.js");
var _runOnceJs = require("./lib/runOnce.js");
var _onFCPJs = require("./onFCP.js");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for CLS. See https://web.dev/articles/cls#what_is_a_good_cls_score */ var CLSThresholds = [
    0.1,
    0.25
];
/**
 * Calculates the [CLS](https://web.dev/articles/cls) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/articles/cls#layout_shift_score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ var onCLS = function(onReport) {
    var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    // Start monitoring FCP so we can only report CLS if FCP is also reported.
    // Note: this is done to match the current behavior of CrUX.
    (0, _onFCPJs.onFCP)((0, _runOnceJs.runOnce)(function() {
        var metric = (0, _initMetricJs.initMetric)('CLS', 0);
        var report;
        var visibilityWatcher = (0, _getVisibilityWatcherJs.getVisibilityWatcher)();
        var layoutShiftManager = (0, _initUniqueJs.initUnique)(opts, (0, _layoutShiftManagerJs.LayoutShiftManager));
        var handleEntries = function(entries) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var entry = _step.value;
                    layoutShiftManager._processEntry(entry);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            // If the current session value is larger than the current CLS value,
            // update CLS and the entries contributing to it.
            if (layoutShiftManager._sessionValue > metric.value) {
                metric.value = layoutShiftManager._sessionValue;
                metric.entries = layoutShiftManager._sessionEntries;
                report();
            }
        };
        var po = (0, _observeJs.observe)('layout-shift', handleEntries);
        if (po) {
            var // Queue a task to report (if nothing else triggers a report first).
            // This allows CLS to be reported as soon as FCP fires when
            // `reportAllChanges` is true.
            _WINDOW_setTimeout;
            report = (0, _bindReporterJs.bindReporter)(onReport, metric, CLSThresholds, opts.reportAllChanges);
            visibilityWatcher.onHidden(function() {
                handleEntries(po.takeRecords());
                report(true);
            });
            (0, _typesJs.WINDOW) === null || (0, _typesJs.WINDOW) === void 0 ? void 0 : (_WINDOW_setTimeout = (0, _typesJs.WINDOW).setTimeout) === null || _WINDOW_setTimeout === void 0 ? void 0 : _WINDOW_setTimeout.call((0, _typesJs.WINDOW), report);
        }
    }));
};

},{"../../types.js":"5Nyr0","./lib/bindReporter.js":"cfUa8","./lib/getVisibilityWatcher.js":"gYvqN","./lib/initMetric.js":"cDVyd","./lib/initUnique.js":"hKyb6","./lib/LayoutShiftManager.js":"9qbds","./lib/observe.js":"2fG7S","./lib/runOnce.js":"nt2Zw","./onFCP.js":"5vO1m","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5Nyr0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WINDOW", function() {
    return WINDOW;
});
var _core = require("@sentry/core");
var WINDOW = (0, _core.GLOBAL_OBJ);

},{"@sentry/core":"7plmH","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cfUa8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bindReporter", function() {
    return bindReporter;
});
var getRating = function(value, thresholds) {
    if (value > thresholds[1]) return 'poor';
    if (value > thresholds[0]) return 'needs-improvement';
    return 'good';
};
var bindReporter = function(callback, metric, thresholds, reportAllChanges) {
    var prevValue;
    var delta;
    return function(forceReport) {
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue !== null && prevValue !== void 0 ? prevValue : 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    metric.rating = getRating(metric.value, thresholds);
                    callback(metric);
                }
            }
        }
    };
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gYvqN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getVisibilityWatcher", function() {
    return getVisibilityWatcher;
});
var _typesJs = require("../../../types.js");
var _getActivationStartJs = require("./getActivationStart.js");
var _globalListenersJs = require("./globalListeners.js");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var firstHiddenTime = -1;
var onHiddenFunctions = new Set();
var initHiddenTime = function() {
    var _WINDOW_document, _WINDOW_document1;
    // If the document is hidden when this code runs, assume it was always
    // hidden and the page was loaded in the background, with the one exception
    // that visibility state is always 'hidden' during prerendering, so we have
    // to ignore that case until prerendering finishes (see: `prerenderingchange`
    // event logic below).
    return ((_WINDOW_document = (0, _typesJs.WINDOW).document) === null || _WINDOW_document === void 0 ? void 0 : _WINDOW_document.visibilityState) === 'hidden' && !((_WINDOW_document1 = (0, _typesJs.WINDOW).document) === null || _WINDOW_document1 === void 0 ? void 0 : _WINDOW_document1.prerendering) ? 0 : Infinity;
};
var onVisibilityUpdate = function(event) {
    // Handle changes to hidden state
    if (isPageHidden(event) && firstHiddenTime > -1) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        // Sentry-specific change: Also call onHidden callbacks for pagehide events
        // to support older browsers (Safari <14.4) that don't properly fire visibilitychange
        if (event.type === 'visibilitychange' || event.type === 'pagehide') try {
            for(var _iterator = onHiddenFunctions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var onHiddenFunction = _step.value;
                onHiddenFunction();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        // If the document is 'hidden' and no previous hidden timestamp has been
        // set (so is infinity), update it based on the current event data.
        if (!isFinite(firstHiddenTime)) {
            // If the event is a 'visibilitychange' event, it means the page was
            // visible prior to this change, so the event timestamp is the first
            // hidden time.
            // However, if the event is not a 'visibilitychange' event, then it must
            // be a 'prerenderingchange' or 'pagehide' event, and the fact that the document is
            // still 'hidden' from the above check means the tab was activated
            // in a background state and so has always been hidden.
            firstHiddenTime = event.type === 'visibilitychange' ? event.timeStamp : 0;
            // We no longer need the `prerenderingchange` event listener now we've
            // set an initial init time so remove that
            // (we'll keep the visibilitychange and pagehide ones for onHiddenFunction above)
            (0, _globalListenersJs.removePageListener)('prerenderingchange', onVisibilityUpdate, true);
        }
    }
};
var getVisibilityWatcher = function() {
    if ((0, _typesJs.WINDOW).document && firstHiddenTime < 0) {
        var _globalThis_performance_getEntriesByType_filter_;
        // Check if we have a previous hidden `visibility-state` performance entry.
        var activationStart = (0, _getActivationStartJs.getActivationStart)();
        var firstVisibilityStateHiddenTime = !(0, _typesJs.WINDOW).document.prerendering ? (_globalThis_performance_getEntriesByType_filter_ = globalThis.performance.getEntriesByType('visibility-state').filter(function(e) {
            return e.name === 'hidden' && e.startTime > activationStart;
        })[0]) === null || _globalThis_performance_getEntriesByType_filter_ === void 0 ? void 0 : _globalThis_performance_getEntriesByType_filter_.startTime : undefined;
        // Prefer that, but if it's not available and the document is hidden when
        // this code runs, assume it was hidden since navigation start. This isn't
        // a perfect heuristic, but it's the best we can do until the
        // `visibility-state` performance entry becomes available in all browsers.
        firstHiddenTime = firstVisibilityStateHiddenTime !== null && firstVisibilityStateHiddenTime !== void 0 ? firstVisibilityStateHiddenTime : initHiddenTime();
        // Listen for visibility changes so we can handle things like bfcache
        // restores and/or prerender without having to examine individual
        // timestamps in detail and also for onHidden function calls.
        (0, _globalListenersJs.addPageListener)('visibilitychange', onVisibilityUpdate, true);
        // Sentry-specific change: Some browsers have buggy implementations of visibilitychange,
        // so we use pagehide in addition, just to be safe. This is also required for older
        // Safari versions (<14.4) that we still support.
        (0, _globalListenersJs.addPageListener)('pagehide', onVisibilityUpdate, true);
        // IMPORTANT: when a page is prerendering, its `visibilityState` is
        // 'hidden', so in order to account for cases where this module checks for
        // visibility during prerendering, an additional check after prerendering
        // completes is also required.
        (0, _globalListenersJs.addPageListener)('prerenderingchange', onVisibilityUpdate, true);
    }
    return {
        get firstHiddenTime () {
            return firstHiddenTime;
        },
        onHidden: function onHidden(cb) {
            onHiddenFunctions.add(cb);
        }
    };
};
/**
 * Check if the page is hidden, uses the `pagehide` event for older browsers support that we used to have in `onHidden` function.
 * Some browsers we still support (Safari <14.4) don't fully support `visibilitychange`
 * or have known bugs w.r.t the `visibilitychange` event.
 * // TODO (v11): If we decide to drop support for Safari 14.4, we can use the logic from web-vitals 4.2.4
 */ function isPageHidden(event) {
    var _WINDOW_document;
    return event.type === 'pagehide' || ((_WINDOW_document = (0, _typesJs.WINDOW).document) === null || _WINDOW_document === void 0 ? void 0 : _WINDOW_document.visibilityState) === 'hidden';
}

},{"../../../types.js":"5Nyr0","./getActivationStart.js":"awFZB","./globalListeners.js":"cYQny","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"awFZB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getActivationStart", function() {
    return getActivationStart;
});
var _getNavigationEntryJs = require("./getNavigationEntry.js");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var getActivationStart = function() {
    var navEntry = (0, _getNavigationEntryJs.getNavigationEntry)();
    var _navEntry_activationStart;
    return (_navEntry_activationStart = navEntry === null || navEntry === void 0 ? void 0 : navEntry.activationStart) !== null && _navEntry_activationStart !== void 0 ? _navEntry_activationStart : 0;
};

},{"./getNavigationEntry.js":"i6iTI","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"i6iTI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getNavigationEntry", function() {
    return getNavigationEntry;
});
var _typesJs = require("../../../types.js");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // sentry-specific change:
// add optional param to not check for responseStart (see comment below)
var getNavigationEntry = function() {
    var checkResponseStart = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    var _WINDOW_performance_getEntriesByType, _WINDOW_performance;
    var navigationEntry = (_WINDOW_performance = (0, _typesJs.WINDOW).performance) === null || _WINDOW_performance === void 0 ? void 0 : (_WINDOW_performance_getEntriesByType = _WINDOW_performance.getEntriesByType) === null || _WINDOW_performance_getEntriesByType === void 0 ? void 0 : _WINDOW_performance_getEntriesByType.call(_WINDOW_performance, 'navigation')[0];
    // Check to ensure the `responseStart` property is present and valid.
    // In some cases a zero value is reported by the browser (for
    // privacy/security reasons), and in other cases (bugs) the value is
    // negative or is larger than the current page time. Ignore these cases:
    // - https://github.com/GoogleChrome/web-vitals/issues/137
    // - https://github.com/GoogleChrome/web-vitals/issues/162
    // - https://github.com/GoogleChrome/web-vitals/issues/275
    if (// sentry-specific change:
    // We don't want to check for responseStart for our own use of `getNavigationEntry`
    !checkResponseStart || navigationEntry && navigationEntry.responseStart > 0 && navigationEntry.responseStart < performance.now()) return navigationEntry;
};

},{"../../../types.js":"5Nyr0","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cYQny":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addPageListener", function() {
    return addPageListener;
});
parcelHelpers.export(exports, "removePageListener", function() {
    return removePageListener;
});
var _typesJs = require("../../../types.js");
/**
 * web-vitals 5.1.0 switched listeners to be added on the window rather than the document.
 * Instead of having to check for window/document every time we add a listener, we can use this function.
 */ function addPageListener(type, listener, options) {
    if ((0, _typesJs.WINDOW).document) (0, _typesJs.WINDOW).addEventListener(type, listener, options);
}
/**
 * web-vitals 5.1.0 switched listeners to be removed from the window rather than the document.
 * Instead of having to check for window/document every time we remove a listener, we can use this function.
 */ function removePageListener(type, listener, options) {
    if ((0, _typesJs.WINDOW).document) (0, _typesJs.WINDOW).removeEventListener(type, listener, options);
}

},{"../../../types.js":"5Nyr0","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cDVyd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initMetric", function() {
    return initMetric;
});
var _typesJs = require("../../../types.js");
var _generateUniqueIDJs = require("./generateUniqueID.js");
var _getActivationStartJs = require("./getActivationStart.js");
var _getNavigationEntryJs = require("./getNavigationEntry.js");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var initMetric = function(name) {
    var value = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1;
    var navEntry = (0, _getNavigationEntryJs.getNavigationEntry)();
    var navigationType = 'navigate';
    if (navEntry) {
        var _WINDOW_document, _WINDOW_document1;
        if (((_WINDOW_document = (0, _typesJs.WINDOW).document) === null || _WINDOW_document === void 0 ? void 0 : _WINDOW_document.prerendering) || (0, _getActivationStartJs.getActivationStart)() > 0) navigationType = 'prerender';
        else if ((_WINDOW_document1 = (0, _typesJs.WINDOW).document) === null || _WINDOW_document1 === void 0 ? void 0 : _WINDOW_document1.wasDiscarded) navigationType = 'restore';
        else if (navEntry.type) navigationType = navEntry.type.replace(/_/g, '-');
    }
    // Use `entries` type specific for the metric.
    var entries = [];
    return {
        name: name,
        value: value,
        rating: 'good',
        delta: 0,
        entries: entries,
        id: (0, _generateUniqueIDJs.generateUniqueID)(),
        navigationType: navigationType
    };
};

},{"../../../types.js":"5Nyr0","./generateUniqueID.js":"ec4P2","./getActivationStart.js":"awFZB","./getNavigationEntry.js":"i6iTI","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ec4P2":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateUniqueID", function() {
    return generateUniqueID;
});
var generateUniqueID = function() {
    return "v5-".concat(Date.now(), "-").concat(Math.floor(Math.random() * (9e12 - 1)) + 1e12);
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hKyb6":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initUnique", function() {
    return initUnique;
});
var instanceMap = new WeakMap();
/**
 * A function that accepts and identity object and a class object and returns
 * either a new instance of that class or an existing instance, if the
 * identity object was previously used.
 */ function initUnique(identityObj, ClassObj) {
    if (!instanceMap.get(identityObj)) instanceMap.set(identityObj, new ClassObj());
    return instanceMap.get(identityObj);
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9qbds":[function(require,module,exports,__globalThis) {
/* eslint-disable jsdoc/require-jsdoc */ /*
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LayoutShiftManager", function() {
    return LayoutShiftManager;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var LayoutShiftManager = /*#__PURE__*/ function() {
    "use strict";
    function LayoutShiftManager() {
        (0, _classCallCheck._)(this, LayoutShiftManager);
        LayoutShiftManager.prototype.__init.call(this);
        LayoutShiftManager.prototype.__init2.call(this);
    }
    (0, _createClass._)(LayoutShiftManager, [
        {
            // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
            // eslint-disable-next-line @sentry-internal/sdk/no-class-field-initializers, @typescript-eslint/explicit-member-accessibility
            key: "__init",
            value: function __init() {
                this._sessionValue = 0;
            }
        },
        {
            // eslint-disable-next-line @sentry-internal/sdk/no-class-field-initializers, @typescript-eslint/explicit-member-accessibility
            key: "__init2",
            value: function __init2() {
                this._sessionEntries = [];
            }
        },
        {
            // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
            key: "_processEntry",
            value: function _processEntry(entry) {
                var _this__onAfterProcessingUnexpectedShift, _this;
                // Only count layout shifts without recent user input.
                if (entry.hadRecentInput) return;
                var firstSessionEntry = this._sessionEntries[0];
                // This previously used `this._sessionEntries.at(-1)` but that is ES2022. We support ES2021 and earlier.
                var lastSessionEntry = this._sessionEntries[this._sessionEntries.length - 1];
                // If the entry occurred less than 1 second after the previous entry
                // and less than 5 seconds after the first entry in the session,
                // include the entry in the current session. Otherwise, start a new
                // session.
                if (this._sessionValue && firstSessionEntry && lastSessionEntry && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                    this._sessionValue += entry.value;
                    this._sessionEntries.push(entry);
                } else {
                    this._sessionValue = entry.value;
                    this._sessionEntries = [
                        entry
                    ];
                }
                (_this__onAfterProcessingUnexpectedShift = (_this = this)._onAfterProcessingUnexpectedShift) === null || _this__onAfterProcessingUnexpectedShift === void 0 ? void 0 : _this__onAfterProcessingUnexpectedShift.call(_this, entry);
            }
        }
    ]);
    return LayoutShiftManager;
}();

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2fG7S":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "observe", function() {
    return observe;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var observe = function(type, callback) {
    var opts = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            var po = new PerformanceObserver(function(list) {
                // Delay by a microtask to workaround a bug in Safari where the
                // callback is invoked immediately, rather than in a separate task.
                // See: https://github.com/GoogleChrome/web-vitals/issues/277
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                Promise.resolve().then(function() {
                    callback(list.getEntries());
                });
            });
            po.observe((0, _objectSpread._)({
                type: type,
                buffered: true
            }, opts));
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"nt2Zw":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "runOnce", function() {
    return runOnce;
});
var runOnce = function(cb) {
    var called = false;
    return function() {
        if (!called) {
            cb();
            called = true;
        }
    };
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5vO1m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FCPThresholds", function() {
    return FCPThresholds;
});
parcelHelpers.export(exports, "onFCP", function() {
    return onFCP;
});
var _bindReporterJs = require("./lib/bindReporter.js");
var _getActivationStartJs = require("./lib/getActivationStart.js");
var _getVisibilityWatcherJs = require("./lib/getVisibilityWatcher.js");
var _initMetricJs = require("./lib/initMetric.js");
var _observeJs = require("./lib/observe.js");
var _whenActivatedJs = require("./lib/whenActivated.js");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for FCP. See https://web.dev/articles/fcp#what_is_a_good_fcp_score */ var FCPThresholds = [
    1800,
    3000
];
/**
 * Calculates the [FCP](https://web.dev/articles/fcp) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `paint` performance entry used to determine the value. The reported
 * value is a `DOMHighResTimeStamp`.
 */ var onFCP = function(onReport) {
    var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    (0, _whenActivatedJs.whenActivated)(function() {
        var visibilityWatcher = (0, _getVisibilityWatcherJs.getVisibilityWatcher)();
        var metric = (0, _initMetricJs.initMetric)('FCP');
        var report;
        var handleEntries = function(entries) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var entry = _step.value;
                    if (entry.name === 'first-contentful-paint') {
                        po.disconnect();
                        // Only report if the page wasn't hidden prior to the first paint.
                        if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                            // The activationStart reference is used because FCP should be
                            // relative to page activation rather than navigation start if the
                            // page was prerendered. But in cases where `activationStart` occurs
                            // after the FCP, this time should be clamped at 0.
                            metric.value = Math.max(entry.startTime - (0, _getActivationStartJs.getActivationStart)(), 0);
                            metric.entries.push(entry);
                            report(true);
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        };
        var po = (0, _observeJs.observe)('paint', handleEntries);
        if (po) report = (0, _bindReporterJs.bindReporter)(onReport, metric, FCPThresholds, opts.reportAllChanges);
    });
};

},{"./lib/bindReporter.js":"cfUa8","./lib/getActivationStart.js":"awFZB","./lib/getVisibilityWatcher.js":"gYvqN","./lib/initMetric.js":"cDVyd","./lib/observe.js":"2fG7S","./lib/whenActivated.js":"jVSXe","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jVSXe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "whenActivated", function() {
    return whenActivated;
});
var _typesJs = require("../../../types.js");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var whenActivated = function(callback) {
    var _WINDOW_document;
    if ((_WINDOW_document = (0, _typesJs.WINDOW).document) === null || _WINDOW_document === void 0 ? void 0 : _WINDOW_document.prerendering) addEventListener('prerenderingchange', function() {
        return callback();
    }, true);
    else callback();
};

},{"../../../types.js":"5Nyr0","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"308V2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "INPThresholds", function() {
    return INPThresholds;
});
parcelHelpers.export(exports, "onINP", function() {
    return onINP;
});
var _bindReporterJs = require("./lib/bindReporter.js");
var _getVisibilityWatcherJs = require("./lib/getVisibilityWatcher.js");
var _initMetricJs = require("./lib/initMetric.js");
var _initUniqueJs = require("./lib/initUnique.js");
var _interactionManagerJs = require("./lib/InteractionManager.js");
var _observeJs = require("./lib/observe.js");
var _interactionCountPolyfillJs = require("./lib/polyfills/interactionCountPolyfill.js");
var _whenActivatedJs = require("./lib/whenActivated.js");
var _whenIdleOrHiddenJs = require("./lib/whenIdleOrHidden.js");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for INP. See https://web.dev/articles/inp#what_is_a_good_inp_score */ var INPThresholds = [
    200,
    500
];
// The default `durationThreshold` used across this library for observing
// `event` entries via PerformanceObserver.
var DEFAULT_DURATION_THRESHOLD = 40;
/**
 * Calculates the [INP](https://web.dev/articles/inp) value for the current
 * page and calls the `callback` function once the value is ready, along with
 * the `event` performance entries reported for that interaction. The reported
 * value is a `DOMHighResTimeStamp`.
 *
 * A custom `durationThreshold` configuration option can optionally be passed
 * to control what `event-timing` entries are considered for INP reporting. The
 * default threshold is `40`, which means INP scores of less than 40 will not
 * be reported. To avoid reporting no interactions in these cases, the library
 * will fall back to the input delay of the first interaction. Note that this
 * will not affect your 75th percentile INP value unless that value is also
 * less than 40 (well below the recommended
 * [good](https://web.dev/articles/inp#what_is_a_good_inp_score) threshold).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** INP should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ var onINP = function(onReport) {
    var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    // Return if the browser doesn't support all APIs needed to measure INP.
    if (!(globalThis.PerformanceEventTiming && 'interactionId' in PerformanceEventTiming.prototype)) return;
    var visibilityWatcher = (0, _getVisibilityWatcherJs.getVisibilityWatcher)();
    (0, _whenActivatedJs.whenActivated)(function() {
        // TODO(philipwalton): remove once the polyfill is no longer needed.
        (0, _interactionCountPolyfillJs.initInteractionCountPolyfill)();
        var metric = (0, _initMetricJs.initMetric)('INP');
        // eslint-disable-next-line prefer-const
        var report;
        var interactionManager = (0, _initUniqueJs.initUnique)(opts, (0, _interactionManagerJs.InteractionManager));
        var handleEntries = function(entries) {
            // Queue the `handleEntries()` callback in the next idle task.
            // This is needed to increase the chances that all event entries that
            // occurred between the user interaction and the next paint
            // have been dispatched. Note: there is currently an experiment
            // running in Chrome (EventTimingKeypressAndCompositionInteractionId)
            // 123+ that if rolled out fully may make this no longer necessary.
            (0, _whenIdleOrHiddenJs.whenIdleOrHidden)(function() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var entry = _step.value;
                        interactionManager._processEntry(entry);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var inp = interactionManager._estimateP98LongestInteraction();
                if (inp && inp._latency !== metric.value) {
                    metric.value = inp._latency;
                    metric.entries = inp.entries;
                    report();
                }
            });
        };
        var _opts_durationThreshold;
        var po = (0, _observeJs.observe)('event', handleEntries, {
            // Event Timing entries have their durations rounded to the nearest 8ms,
            // so a duration of 40ms would be any event that spans 2.5 or more frames
            // at 60Hz. This threshold is chosen to strike a balance between usefulness
            // and performance. Running this callback for any interaction that spans
            // just one or two frames is likely not worth the insight that could be
            // gained.
            durationThreshold: (_opts_durationThreshold = opts.durationThreshold) !== null && _opts_durationThreshold !== void 0 ? _opts_durationThreshold : DEFAULT_DURATION_THRESHOLD
        });
        report = (0, _bindReporterJs.bindReporter)(onReport, metric, INPThresholds, opts.reportAllChanges);
        if (po) {
            // Also observe entries of type `first-input`. This is useful in cases
            // where the first interaction is less than the `durationThreshold`.
            po.observe({
                type: 'first-input',
                buffered: true
            });
            visibilityWatcher.onHidden(function() {
                handleEntries(po.takeRecords());
                report(true);
            });
        }
    });
};

},{"./lib/bindReporter.js":"cfUa8","./lib/getVisibilityWatcher.js":"gYvqN","./lib/initMetric.js":"cDVyd","./lib/initUnique.js":"hKyb6","./lib/InteractionManager.js":"8Beiy","./lib/observe.js":"2fG7S","./lib/polyfills/interactionCountPolyfill.js":"9AWlh","./lib/whenActivated.js":"jVSXe","./lib/whenIdleOrHidden.js":"jOKBW","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8Beiy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InteractionManager", function() {
    return InteractionManager;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _interactionCountPolyfillJs = require("./polyfills/interactionCountPolyfill.js");
/*
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // To prevent unnecessary memory usage on pages with lots of interactions,
// store at most 10 of the longest interactions to consider as INP candidates.
var MAX_INTERACTIONS_TO_CONSIDER = 10;
// Used to store the interaction count after a bfcache restore, since p98
// interaction latencies should only consider the current navigation.
var prevInteractionCount = 0;
/**
 * Returns the interaction count since the last bfcache restore (or for the
 * full page lifecycle if there were no bfcache restores).
 */ var getInteractionCountForNavigation = function() {
    return (0, _interactionCountPolyfillJs.getInteractionCount)() - prevInteractionCount;
};
/**
 *
 */ var InteractionManager = /*#__PURE__*/ function() {
    "use strict";
    function InteractionManager() {
        (0, _classCallCheck._)(this, InteractionManager);
        InteractionManager.prototype.__init.call(this);
        InteractionManager.prototype.__init2.call(this);
    }
    (0, _createClass._)(InteractionManager, [
        {
            /**
   * A list of longest interactions on the page (by latency) sorted so the
   * longest one is first. The list is at most MAX_INTERACTIONS_TO_CONSIDER
   * long.
   */ // eslint-disable-next-line @sentry-internal/sdk/no-class-field-initializers, @typescript-eslint/explicit-member-accessibility
            key: "__init",
            value: function __init() {
                this._longestInteractionList = [];
            }
        },
        {
            /**
   * A mapping of longest interactions by their interaction ID.
   * This is used for faster lookup.
   */ // eslint-disable-next-line @sentry-internal/sdk/no-class-field-initializers, @typescript-eslint/explicit-member-accessibility
            key: "__init2",
            value: function __init2() {
                this._longestInteractionMap = new Map();
            }
        },
        {
            // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
            // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
            // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility, jsdoc/require-jsdoc
            key: "_resetInteractions",
            value: function _resetInteractions() {
                prevInteractionCount = (0, _interactionCountPolyfillJs.getInteractionCount)();
                this._longestInteractionList.length = 0;
                this._longestInteractionMap.clear();
            }
        },
        {
            /**
   * Returns the estimated p98 longest interaction based on the stored
   * interaction candidates and the interaction count for the current page.
   */ // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
            key: "_estimateP98LongestInteraction",
            value: function _estimateP98LongestInteraction() {
                var candidateInteractionIndex = Math.min(this._longestInteractionList.length - 1, Math.floor(getInteractionCountForNavigation() / 50));
                return this._longestInteractionList[candidateInteractionIndex];
            }
        },
        {
            /**
   * Takes a performance entry and adds it to the list of worst interactions
   * if its duration is long enough to make it among the worst. If the
   * entry is part of an existing interaction, it is merged and the latency
   * and entries list is updated as needed.
   */ // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
            key: "_processEntry",
            value: function _processEntry(entry) {
                var _this__onBeforeProcessingEntry, _this;
                (_this__onBeforeProcessingEntry = (_this = this)._onBeforeProcessingEntry) === null || _this__onBeforeProcessingEntry === void 0 ? void 0 : _this__onBeforeProcessingEntry.call(_this, entry);
                // Skip further processing for entries that cannot be INP candidates.
                if (!(entry.interactionId || entry.entryType === 'first-input')) return;
                // The least-long of the 10 longest interactions.
                var minLongestInteraction = this._longestInteractionList.at(-1);
                var interaction = this._longestInteractionMap.get(entry.interactionId);
                // Only process the entry if it's possibly one of the ten longest,
                // or if it's part of an existing interaction.
                if (interaction || this._longestInteractionList.length < MAX_INTERACTIONS_TO_CONSIDER || // If the above conditions are false, `minLongestInteraction` will be set.
                entry.duration > minLongestInteraction._latency) {
                    var // Call any post-processing on the interaction
                    _this__onAfterProcessingINPCandidate, _this1;
                    // If the interaction already exists, update it. Otherwise create one.
                    if (interaction) {
                        // If the new entry has a longer duration, replace the old entries,
                        // otherwise add to the array.
                        if (entry.duration > interaction._latency) {
                            interaction.entries = [
                                entry
                            ];
                            interaction._latency = entry.duration;
                        } else if (entry.duration === interaction._latency && entry.startTime === interaction.entries[0].startTime) interaction.entries.push(entry);
                    } else {
                        interaction = {
                            id: entry.interactionId,
                            entries: [
                                entry
                            ],
                            _latency: entry.duration
                        };
                        this._longestInteractionMap.set(interaction.id, interaction);
                        this._longestInteractionList.push(interaction);
                    }
                    // Sort the entries by latency (descending) and keep only the top ten.
                    this._longestInteractionList.sort(function(a, b) {
                        return b._latency - a._latency;
                    });
                    if (this._longestInteractionList.length > MAX_INTERACTIONS_TO_CONSIDER) {
                        var removedInteractions = this._longestInteractionList.splice(MAX_INTERACTIONS_TO_CONSIDER);
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = removedInteractions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var interaction1 = _step.value;
                                this._longestInteractionMap.delete(interaction1.id);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                    (_this__onAfterProcessingINPCandidate = (_this1 = this)._onAfterProcessingINPCandidate) === null || _this__onAfterProcessingINPCandidate === void 0 ? void 0 : _this__onAfterProcessingINPCandidate.call(_this1, interaction);
                }
            }
        }
    ]);
    return InteractionManager;
}();

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","./polyfills/interactionCountPolyfill.js":"9AWlh","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9AWlh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getInteractionCount", function() {
    return getInteractionCount;
});
parcelHelpers.export(exports, "initInteractionCountPolyfill", function() {
    return initInteractionCountPolyfill;
});
var _observeJs = require("../observe.js");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var interactionCountEstimate = 0;
var minKnownInteractionId = Infinity;
var maxKnownInteractionId = 0;
var updateEstimate = function(entries) {
    entries.forEach(function(e) {
        if (e.interactionId) {
            minKnownInteractionId = Math.min(minKnownInteractionId, e.interactionId);
            maxKnownInteractionId = Math.max(maxKnownInteractionId, e.interactionId);
            interactionCountEstimate = maxKnownInteractionId ? (maxKnownInteractionId - minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
var po;
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */ var getInteractionCount = function() {
    return po ? interactionCountEstimate : performance.interactionCount || 0;
};
/**
 * Feature detects native support or initializes the polyfill if needed.
 */ var initInteractionCountPolyfill = function() {
    if ('interactionCount' in performance || po) return;
    po = (0, _observeJs.observe)('event', updateEstimate, {
        type: 'event',
        buffered: true,
        durationThreshold: 0
    });
};

},{"../observe.js":"2fG7S","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jOKBW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "whenIdleOrHidden", function() {
    return whenIdleOrHidden;
});
var _typesJs = require("../../../types.js");
var _globalListenersJs = require("./globalListeners.js");
var _onHiddenJs = require("./onHidden.js");
var _runOnceJs = require("./runOnce.js");
/*
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Runs the passed callback during the next idle period, or immediately
 * if the browser's visibility state is (or becomes) hidden.
 */ var whenIdleOrHidden = function(cb) {
    var _WINDOW_document;
    var rIC = (0, _typesJs.WINDOW).requestIdleCallback || (0, _typesJs.WINDOW).setTimeout;
    // If the document is hidden, run the callback immediately, otherwise
    // race an idle callback with the next `visibilitychange` event.
    if (((_WINDOW_document = (0, _typesJs.WINDOW).document) === null || _WINDOW_document === void 0 ? void 0 : _WINDOW_document.visibilityState) === 'hidden') cb();
    else {
        // eslint-disable-next-line no-param-reassign
        cb = (0, _runOnceJs.runOnce)(cb);
        (0, _globalListenersJs.addPageListener)('visibilitychange', cb, {
            once: true,
            capture: true
        });
        rIC(function() {
            cb();
            // Remove the above event listener since no longer required.
            // See: https://github.com/GoogleChrome/web-vitals/issues/622
            (0, _globalListenersJs.removePageListener)('visibilitychange', cb, {
                capture: true
            });
        });
        // sentry: we use onHidden instead of directly listening to visibilitychange
        // because some browsers we still support (Safari <14.4) don't fully support
        // `visibilitychange` or have known bugs w.r.t the `visibilitychange` event.
        (0, _onHiddenJs.onHidden)(cb);
    }
};

},{"../../../types.js":"5Nyr0","./globalListeners.js":"cYQny","./onHidden.js":"geYnH","./runOnce.js":"nt2Zw","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"geYnH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "onHidden", function() {
    return onHidden;
});
var _typesJs = require("../../../types.js");
var _globalListenersJs = require("./globalListeners.js");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Sentry-specific change:
// This function's logic was NOT updated to web-vitals 4.2.4 or 5.x but we continue
// to use the web-vitals 3.5.2 versiondue to us having stricter browser support.
// PR with context that made the changes: https://github.com/GoogleChrome/web-vitals/pull/442/files#r1530492402
// The PR removed listening to the `pagehide` event, in favour of only listening to `visibilitychange` event.
// This is "more correct" but some browsers we still support (Safari <14.4) don't fully support `visibilitychange`
// or have known bugs w.r.t the `visibilitychange` event.
// TODO (v11): If we decide to drop support for Safari 14.4, we can use the logic from web-vitals 4.2.4
// In this case, we also need to update the integration tests that currently trigger the `pagehide` event to
// simulate the page being hidden.
var onHidden = function(cb) {
    var onHiddenOrPageHide = function(event) {
        var _WINDOW_document;
        if (event.type === 'pagehide' || ((_WINDOW_document = (0, _typesJs.WINDOW).document) === null || _WINDOW_document === void 0 ? void 0 : _WINDOW_document.visibilityState) === 'hidden') cb(event);
    };
    (0, _globalListenersJs.addPageListener)('visibilitychange', onHiddenOrPageHide, true);
    // Some browsers have buggy implementations of visibilitychange,
    // so we use pagehide in addition, just to be safe.
    (0, _globalListenersJs.addPageListener)('pagehide', onHiddenOrPageHide, true);
};

},{"../../../types.js":"5Nyr0","./globalListeners.js":"cYQny","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"94v74":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LCPThresholds", function() {
    return LCPThresholds;
});
parcelHelpers.export(exports, "onLCP", function() {
    return onLCP;
});
var _bindReporterJs = require("./lib/bindReporter.js");
var _getActivationStartJs = require("./lib/getActivationStart.js");
var _getVisibilityWatcherJs = require("./lib/getVisibilityWatcher.js");
var _globalListenersJs = require("./lib/globalListeners.js");
var _initMetricJs = require("./lib/initMetric.js");
var _initUniqueJs = require("./lib/initUnique.js");
var _lcpentryManagerJs = require("./lib/LCPEntryManager.js");
var _observeJs = require("./lib/observe.js");
var _runOnceJs = require("./lib/runOnce.js");
var _whenActivatedJs = require("./lib/whenActivated.js");
var _whenIdleOrHiddenJs = require("./lib/whenIdleOrHidden.js");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for LCP. See https://web.dev/articles/lcp#what_is_a_good_lcp_score */ var LCPThresholds = [
    2500,
    4000
];
/**
 * Calculates the [LCP](https://web.dev/articles/lcp) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called any time a new `largest-contentful-paint`
 * performance entry is dispatched, or once the final value of the metric has
 * been determined.
 */ var onLCP = function(onReport) {
    var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    (0, _whenActivatedJs.whenActivated)(function() {
        var visibilityWatcher = (0, _getVisibilityWatcherJs.getVisibilityWatcher)();
        var metric = (0, _initMetricJs.initMetric)('LCP');
        var report;
        var lcpEntryManager = (0, _initUniqueJs.initUnique)(opts, (0, _lcpentryManagerJs.LCPEntryManager));
        var handleEntries = function(entries) {
            // If reportAllChanges is set then call this function for each entry,
            // otherwise only consider the last one.
            if (!opts.reportAllChanges) // eslint-disable-next-line no-param-reassign
            entries = entries.slice(-1);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var entry = _step.value;
                    lcpEntryManager._processEntry(entry);
                    // Only report if the page wasn't hidden prior to LCP.
                    if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                        // The startTime attribute returns the value of the renderTime if it is
                        // not 0, and the value of the loadTime otherwise. The activationStart
                        // reference is used because LCP should be relative to page activation
                        // rather than navigation start if the page was prerendered. But in cases
                        // where `activationStart` occurs after the LCP, this time should be
                        // clamped at 0.
                        metric.value = Math.max(entry.startTime - (0, _getActivationStartJs.getActivationStart)(), 0);
                        metric.entries = [
                            entry
                        ];
                        report();
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        };
        var po = (0, _observeJs.observe)('largest-contentful-paint', handleEntries);
        if (po) {
            report = (0, _bindReporterJs.bindReporter)(onReport, metric, LCPThresholds, opts.reportAllChanges);
            // Ensure this logic only runs once, since it can be triggered from
            // any of three different event listeners below.
            var stopListening = (0, _runOnceJs.runOnce)(function() {
                handleEntries(po.takeRecords());
                po.disconnect();
                report(true);
            });
            // Need a separate wrapper to ensure the `runOnce` function above is
            // common for all three functions
            var stopListeningWrapper = function(event) {
                if (event.isTrusted) {
                    // Wrap the listener in an idle callback so it's run in a separate
                    // task to reduce potential INP impact.
                    // https://github.com/GoogleChrome/web-vitals/issues/383
                    (0, _whenIdleOrHiddenJs.whenIdleOrHidden)(stopListening);
                    (0, _globalListenersJs.removePageListener)(event.type, stopListeningWrapper, {
                        capture: true
                    });
                }
            };
            // Stop listening after input or visibilitychange.
            // Note: while scrolling is an input that stops LCP observation, it's
            // unreliable since it can be programmatically generated.
            // See: https://github.com/GoogleChrome/web-vitals/issues/75
            for(var _i = 0, _iter = [
                'keydown',
                'click',
                'visibilitychange'
            ]; _i < _iter.length; _i++){
                var type = _iter[_i];
                (0, _globalListenersJs.addPageListener)(type, stopListeningWrapper, {
                    capture: true
                });
            }
        }
    });
};

},{"./lib/bindReporter.js":"cfUa8","./lib/getActivationStart.js":"awFZB","./lib/getVisibilityWatcher.js":"gYvqN","./lib/globalListeners.js":"cYQny","./lib/initMetric.js":"cDVyd","./lib/initUnique.js":"hKyb6","./lib/LCPEntryManager.js":"djD2M","./lib/observe.js":"2fG7S","./lib/runOnce.js":"nt2Zw","./lib/whenActivated.js":"jVSXe","./lib/whenIdleOrHidden.js":"jOKBW","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"djD2M":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // eslint-disable-next-line jsdoc/require-jsdoc
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LCPEntryManager", function() {
    return LCPEntryManager;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var LCPEntryManager = /*#__PURE__*/ function() {
    "use strict";
    function LCPEntryManager() {
        (0, _classCallCheck._)(this, LCPEntryManager);
    }
    (0, _createClass._)(LCPEntryManager, [
        {
            // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
            // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility, jsdoc/require-jsdoc
            key: "_processEntry",
            value: function _processEntry(entry) {
                var _this__onBeforeProcessingEntry, _this;
                (_this__onBeforeProcessingEntry = (_this = this)._onBeforeProcessingEntry) === null || _this__onBeforeProcessingEntry === void 0 ? void 0 : _this__onBeforeProcessingEntry.call(_this, entry);
            }
        }
    ]);
    return LCPEntryManager;
}();

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bVY0k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TTFBThresholds", function() {
    return TTFBThresholds;
});
parcelHelpers.export(exports, "onTTFB", function() {
    return onTTFB;
});
var _typesJs = require("../../types.js");
var _bindReporterJs = require("./lib/bindReporter.js");
var _getActivationStartJs = require("./lib/getActivationStart.js");
var _getNavigationEntryJs = require("./lib/getNavigationEntry.js");
var _initMetricJs = require("./lib/initMetric.js");
var _whenActivatedJs = require("./lib/whenActivated.js");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for TTFB. See https://web.dev/articles/ttfb#what_is_a_good_ttfb_score */ var TTFBThresholds = [
    800,
    1800
];
/**
 * Runs in the next task after the page is done loading and/or prerendering.
 * @param callback
 */ var whenReady = function(callback) {
    var _WINDOW_document, _WINDOW_document1;
    if ((_WINDOW_document = (0, _typesJs.WINDOW).document) === null || _WINDOW_document === void 0 ? void 0 : _WINDOW_document.prerendering) (0, _whenActivatedJs.whenActivated)(function() {
        return whenReady(callback);
    });
    else if (((_WINDOW_document1 = (0, _typesJs.WINDOW).document) === null || _WINDOW_document1 === void 0 ? void 0 : _WINDOW_document1.readyState) !== 'complete') addEventListener('load', function() {
        return whenReady(callback);
    }, true);
    else // Queue a task so the callback runs after `loadEventEnd`.
    setTimeout(callback);
};
/**
 * Calculates the [TTFB](https://web.dev/articles/ttfb) value for the
 * current page and calls the `callback` function once the page has loaded,
 * along with the relevant `navigation` performance entry used to determine the
 * value. The reported value is a `DOMHighResTimeStamp`.
 *
 * Note, this function waits until after the page is loaded to call `callback`
 * in order to ensure all properties of the `navigation` entry are populated.
 * This is useful if you want to report on other metrics exposed by the
 * [Navigation Timing API](https://w3c.github.io/navigation-timing/). For
 * example, the TTFB metric starts from the page's [time
 * origin](https://www.w3.org/TR/hr-time-2/#sec-time-origin), which means it
 * includes time spent on DNS lookup, connection negotiation, network latency,
 * and server processing time.
 */ var onTTFB = function(onReport) {
    var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var metric = (0, _initMetricJs.initMetric)('TTFB');
    var report = (0, _bindReporterJs.bindReporter)(onReport, metric, TTFBThresholds, opts.reportAllChanges);
    whenReady(function() {
        var navigationEntry = (0, _getNavigationEntryJs.getNavigationEntry)();
        if (navigationEntry) {
            // The activationStart reference is used because TTFB should be
            // relative to page activation rather than navigation start if the
            // page was prerendered. But in cases where `activationStart` occurs
            // after the first byte is received, this time should be clamped at 0.
            metric.value = Math.max(navigationEntry.responseStart - (0, _getActivationStartJs.getActivationStart)(), 0);
            metric.entries = [
                navigationEntry
            ];
            report(true);
        }
    });
};

},{"../../types.js":"5Nyr0","./lib/bindReporter.js":"cfUa8","./lib/getActivationStart.js":"awFZB","./lib/getNavigationEntry.js":"i6iTI","./lib/initMetric.js":"cDVyd","./lib/whenActivated.js":"jVSXe","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"esMPd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_addMeasureSpans", function() {
    return _addMeasureSpans;
});
parcelHelpers.export(exports, "_addNavigationSpans", function() {
    return _addNavigationSpans;
});
parcelHelpers.export(exports, "_addResourceSpans", function() {
    return _addResourceSpans;
});
parcelHelpers.export(exports, "_setResourceRequestAttributes", function() {
    return _setResourceRequestAttributes;
});
parcelHelpers.export(exports, "addPerformanceEntries", function() {
    return addPerformanceEntries;
});
parcelHelpers.export(exports, "startTrackingInteractions", function() {
    return startTrackingInteractions;
});
parcelHelpers.export(exports, "startTrackingLongAnimationFrames", function() {
    return startTrackingLongAnimationFrames;
});
parcelHelpers.export(exports, "startTrackingLongTasks", function() {
    return startTrackingLongTasks;
});
parcelHelpers.export(exports, "startTrackingWebVitals", function() {
    return startTrackingWebVitals;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var _core = require("@sentry/core");
var _typesJs = require("../types.js");
var _clsJs = require("./cls.js");
var _instrumentJs = require("./instrument.js");
var _lcpJs = require("./lcp.js");
var _resourceTimingJs = require("./resourceTiming.js");
var _utilsJs = require("./utils.js");
var _getActivationStartJs = require("./web-vitals/lib/getActivationStart.js");
var _getNavigationEntryJs = require("./web-vitals/lib/getNavigationEntry.js");
var _getVisibilityWatcherJs = require("./web-vitals/lib/getVisibilityWatcher.js");
var MAX_INT_AS_BYTES = 2147483647;
var _performanceCursor = 0;
var _measurements = {};
var _lcpEntry;
var _clsEntry;
/**
 * Start tracking web vitals.
 * The callback returned by this function can be used to stop tracking & ensure all measurements are final & captured.
 *
 * @returns A function that forces web vitals collection
 */ function startTrackingWebVitals(param) {
    var recordClsStandaloneSpans = param.recordClsStandaloneSpans, recordLcpStandaloneSpans = param.recordLcpStandaloneSpans, client = param.client;
    var performance = (0, _utilsJs.getBrowserPerformanceAPI)();
    if (performance && (0, _core.browserPerformanceTimeOrigin)()) {
        // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
        if (performance.mark) (0, _typesJs.WINDOW).performance.mark('sentry-tracing-init');
        var lcpCleanupCallback = recordLcpStandaloneSpans ? (0, _lcpJs.trackLcpAsStandaloneSpan)(client) : _trackLCP();
        var ttfbCleanupCallback = _trackTtfb();
        var clsCleanupCallback = recordClsStandaloneSpans ? (0, _clsJs.trackClsAsStandaloneSpan)(client) : _trackCLS();
        return function() {
            lcpCleanupCallback === null || lcpCleanupCallback === void 0 ? void 0 : lcpCleanupCallback();
            ttfbCleanupCallback();
            clsCleanupCallback === null || clsCleanupCallback === void 0 ? void 0 : clsCleanupCallback();
        };
    }
    return function() {
        return undefined;
    };
}
/**
 * Start tracking long tasks.
 */ function startTrackingLongTasks() {
    (0, _instrumentJs.addPerformanceInstrumentationHandler)('longtask', function(param) {
        var entries = param.entries;
        var parent = (0, _core.getActiveSpan)();
        if (!parent) return;
        var _spanToJSON = (0, _core.spanToJSON)(parent), parentOp = _spanToJSON.op, parentStartTimestamp = _spanToJSON.start_timestamp;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entry = _step.value;
                var startTime = (0, _utilsJs.msToSec)((0, _core.browserPerformanceTimeOrigin)() + entry.startTime);
                var duration = (0, _utilsJs.msToSec)(entry.duration);
                if (parentOp === 'navigation' && parentStartTimestamp && startTime < parentStartTimestamp) continue;
                (0, _utilsJs.startAndEndSpan)(parent, startTime, startTime + duration, {
                    name: 'Main UI thread blocked',
                    op: 'ui.long-task',
                    attributes: (0, _defineProperty._)({}, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), 'auto.ui.browser.metrics')
                });
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
}
/**
 * Start tracking long animation frames.
 */ function startTrackingLongAnimationFrames() {
    // NOTE: the current web-vitals version (3.5.2) does not support long-animation-frame, so
    // we directly observe `long-animation-frame` events instead of through the web-vitals
    // `observe` helper function.
    var observer = new PerformanceObserver(function(list) {
        var parent = (0, _core.getActiveSpan)();
        if (!parent) return;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = list.getEntries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entry = _step.value;
                if (!entry.scripts[0]) continue;
                var startTime = (0, _utilsJs.msToSec)((0, _core.browserPerformanceTimeOrigin)() + entry.startTime);
                var _spanToJSON = (0, _core.spanToJSON)(parent), parentStartTimestamp = _spanToJSON.start_timestamp, parentOp = _spanToJSON.op;
                if (parentOp === 'navigation' && parentStartTimestamp && startTime < parentStartTimestamp) continue;
                var duration = (0, _utilsJs.msToSec)(entry.duration);
                var attributes = (0, _defineProperty._)({}, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), 'auto.ui.browser.metrics');
                var initialScript = entry.scripts[0];
                var invoker = initialScript.invoker, invokerType = initialScript.invokerType, sourceURL = initialScript.sourceURL, sourceFunctionName = initialScript.sourceFunctionName, sourceCharPosition = initialScript.sourceCharPosition;
                attributes['browser.script.invoker'] = invoker;
                attributes['browser.script.invoker_type'] = invokerType;
                if (sourceURL) attributes['code.filepath'] = sourceURL;
                if (sourceFunctionName) attributes['code.function'] = sourceFunctionName;
                if (sourceCharPosition !== -1) attributes['browser.script.source_char_position'] = sourceCharPosition;
                (0, _utilsJs.startAndEndSpan)(parent, startTime, startTime + duration, {
                    name: 'Main UI thread blocked',
                    op: 'ui.long-animation-frame',
                    attributes: attributes
                });
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    observer.observe({
        type: 'long-animation-frame',
        buffered: true
    });
}
/**
 * Start tracking interaction events.
 */ function startTrackingInteractions() {
    (0, _instrumentJs.addPerformanceInstrumentationHandler)('event', function(param) {
        var entries = param.entries;
        var parent = (0, _core.getActiveSpan)();
        if (!parent) return;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entry = _step.value;
                if (entry.name === 'click') {
                    var startTime = (0, _utilsJs.msToSec)((0, _core.browserPerformanceTimeOrigin)() + entry.startTime);
                    var duration = (0, _utilsJs.msToSec)(entry.duration);
                    var spanOptions = {
                        name: (0, _core.htmlTreeAsString)(entry.target),
                        op: "ui.interaction.".concat(entry.name),
                        startTime: startTime,
                        attributes: (0, _defineProperty._)({}, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), 'auto.ui.browser.metrics')
                    };
                    var componentName = (0, _core.getComponentName)(entry.target);
                    if (componentName) spanOptions.attributes['ui.component_name'] = componentName;
                    (0, _utilsJs.startAndEndSpan)(parent, startTime, startTime + duration, spanOptions);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
}
/**
 * Starts tracking the Cumulative Layout Shift on the current page and collects the value and last entry
 * to the `_measurements` object which ultimately is applied to the pageload span's measurements.
 */ function _trackCLS() {
    return (0, _instrumentJs.addClsInstrumentationHandler)(function(param) {
        var metric = param.metric;
        var entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        _measurements['cls'] = {
            value: metric.value,
            unit: ''
        };
        _clsEntry = entry;
    }, true);
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function _trackLCP() {
    return (0, _instrumentJs.addLcpInstrumentationHandler)(function(param) {
        var metric = param.metric;
        var entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        _measurements['lcp'] = {
            value: metric.value,
            unit: 'millisecond'
        };
        _lcpEntry = entry;
    }, true);
}
function _trackTtfb() {
    return (0, _instrumentJs.addTtfbInstrumentationHandler)(function(param) {
        var metric = param.metric;
        var entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        _measurements['ttfb'] = {
            value: metric.value,
            unit: 'millisecond'
        };
    });
}
/** Add performance related spans to a transaction */ function addPerformanceEntries(span, options) {
    var performance = (0, _utilsJs.getBrowserPerformanceAPI)();
    var origin = (0, _core.browserPerformanceTimeOrigin)();
    if (!(performance === null || performance === void 0 ? void 0 : performance.getEntries) || !origin) // Gatekeeper if performance API not available
    return;
    var timeOrigin = (0, _utilsJs.msToSec)(origin);
    var performanceEntries = performance.getEntries();
    var _spanToJSON = (0, _core.spanToJSON)(span), op = _spanToJSON.op, transactionStartTime = _spanToJSON.start_timestamp;
    performanceEntries.slice(_performanceCursor).forEach(function(entry) {
        var startTime = (0, _utilsJs.msToSec)(entry.startTime);
        var duration = (0, _utilsJs.msToSec)(// Inexplicably, Chrome sometimes emits a negative duration. We need to work around this.
        // There is a SO post attempting to explain this, but it leaves one with open questions: https://stackoverflow.com/questions/23191918/peformance-getentries-and-negative-duration-display
        // The way we clamp the value is probably not accurate, since we have observed this happen for things that may take a while to load, like for example the replay worker.
        // TODO: Investigate why this happens and how to properly mitigate. For now, this is a workaround to prevent transactions being dropped due to negative duration spans.
        Math.max(0, entry.duration));
        if (op === 'navigation' && transactionStartTime && timeOrigin + startTime < transactionStartTime) return;
        switch(entry.entryType){
            case 'navigation':
                _addNavigationSpans(span, entry, timeOrigin);
                break;
            case 'mark':
            case 'paint':
            case 'measure':
                {
                    _addMeasureSpans(span, entry, startTime, duration, timeOrigin, options.ignorePerformanceApiSpans);
                    // capture web vitals
                    var firstHidden = (0, _getVisibilityWatcherJs.getVisibilityWatcher)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    var shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === 'first-paint' && shouldRecord) _measurements['fp'] = {
                        value: entry.startTime,
                        unit: 'millisecond'
                    };
                    if (entry.name === 'first-contentful-paint' && shouldRecord) _measurements['fcp'] = {
                        value: entry.startTime,
                        unit: 'millisecond'
                    };
                    break;
                }
            case 'resource':
                _addResourceSpans(span, entry, entry.name, startTime, duration, timeOrigin, options.ignoreResourceSpans);
                break;
        }
    });
    _performanceCursor = Math.max(performanceEntries.length - 1, 0);
    _trackNavigator(span);
    // Measurements are only available for pageload transactions
    if (op === 'pageload') {
        _addTtfbRequestTimeToMeasurements(_measurements);
        // If CLS standalone spans are enabled, don't record CLS as a measurement
        if (!options.recordClsOnPageloadSpan) delete _measurements.cls;
        // If LCP standalone spans are enabled, don't record LCP as a measurement
        if (!options.recordLcpOnPageloadSpan) delete _measurements.lcp;
        Object.entries(_measurements).forEach(function(param) {
            var _param = (0, _slicedToArray._)(param, 2), measurementName = _param[0], measurement = _param[1];
            (0, _core.setMeasurement)(measurementName, measurement.value, measurement.unit);
        });
        // Set timeOrigin which denotes the timestamp which to base the LCP/FCP/FP/TTFB measurements on
        span.setAttribute('performance.timeOrigin', timeOrigin);
        // In prerendering scenarios, where a page might be prefetched and pre-rendered before the user clicks the link,
        // the navigation starts earlier than when the user clicks it. Web Vitals should always be based on the
        // user-perceived time, so they are not reported from the actual start of the navigation, but rather from the
        // time where the user actively started the navigation, for example by clicking a link.
        // This is user action is called "activation" and the time between navigation and activation is stored in
        // the `activationStart` attribute of the "navigation" PerformanceEntry.
        span.setAttribute('performance.activationStart', (0, _getActivationStartJs.getActivationStart)());
        _setWebVitalAttributes(span, options);
    }
    _lcpEntry = undefined;
    _clsEntry = undefined;
    _measurements = {};
}
/**
 * React 19.2+ creates performance.measure entries for component renders.
 * We can identify them by the `detail.devtools.track` property being set to 'Components ⚛'.
 * see: https://react.dev/reference/dev-tools/react-performance-tracks
 * see: https://github.com/facebook/react/blob/06fcc8f380c6a905c7bc18d94453f623cf8cbc81/packages/react-reconciler/src/ReactFiberPerformanceTrack.js#L454-L473
 */ function isReact19MeasureEntry(entry) {
    if ((entry === null || entry === void 0 ? void 0 : entry.entryType) !== 'measure') return;
    try {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return entry.detail.devtools.track === "Components \u269B";
    } catch (e) {
        return;
    }
}
/**
 * Create measure related spans.
 * Exported only for tests.
 */ function _addMeasureSpans(span, entry, startTime, duration, timeOrigin, ignorePerformanceApiSpans) {
    if (isReact19MeasureEntry(entry)) return;
    if ([
        'mark',
        'measure'
    ].includes(entry.entryType) && (0, _core.stringMatchesSomePattern)(entry.name, ignorePerformanceApiSpans)) return;
    var navEntry = (0, _getNavigationEntryJs.getNavigationEntry)(false);
    var requestTime = (0, _utilsJs.msToSec)(navEntry ? navEntry.requestStart : 0);
    // Because performance.measure accepts arbitrary timestamps it can produce
    // spans that happen before the browser even makes a request for the page.
    //
    // An example of this is the automatically generated Next.js-before-hydration
    // spans created by the Next.js framework.
    //
    // To prevent this we will pin the start timestamp to the request start time
    // This does make duration inaccurate, so if this does happen, we will add
    // an attribute to the span
    var measureStartTimestamp = timeOrigin + Math.max(startTime, requestTime);
    var startTimeStamp = timeOrigin + startTime;
    var measureEndTimestamp = startTimeStamp + duration;
    var attributes = (0, _defineProperty._)({}, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), 'auto.resource.browser.metrics');
    if (measureStartTimestamp !== startTimeStamp) {
        attributes['sentry.browser.measure_happened_before_request'] = true;
        attributes['sentry.browser.measure_start_time'] = measureStartTimestamp;
    }
    _addDetailToSpanAttributes(attributes, entry);
    // Measurements from third parties can be off, which would create invalid spans, dropping transactions in the process.
    if (measureStartTimestamp <= measureEndTimestamp) (0, _utilsJs.startAndEndSpan)(span, measureStartTimestamp, measureEndTimestamp, {
        name: entry.name,
        op: entry.entryType,
        attributes: attributes
    });
}
function _addDetailToSpanAttributes(attributes, performanceMeasure) {
    try {
        // Accessing detail might throw in some browsers (e.g., Firefox) due to security restrictions
        var detail = performanceMeasure.detail;
        if (!detail) return;
        // Process detail based on its type
        if ((typeof detail === "undefined" ? "undefined" : (0, _typeOf._)(detail)) === 'object') {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                // Handle object details
                for(var _iterator = Object.entries(detail)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, _slicedToArray._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                    if (value && (0, _core.isPrimitive)(value)) attributes["sentry.browser.measure.detail.".concat(key)] = value;
                    else if (value !== undefined) try {
                        // This is user defined so we can't guarantee it's serializable
                        attributes["sentry.browser.measure.detail.".concat(key)] = JSON.stringify(value);
                    } catch (e) {
                    // Skip values that can't be stringified
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return;
        }
        if ((0, _core.isPrimitive)(detail)) {
            // Handle primitive details
            attributes['sentry.browser.measure.detail'] = detail;
            return;
        }
        try {
            attributes['sentry.browser.measure.detail'] = JSON.stringify(detail);
        } catch (e) {
        // Skip if stringification fails
        }
    } catch (e) {
    // Silently ignore any errors when accessing detail
    // This handles the Firefox "Permission denied to access object" error
    }
}
/**
 * Instrument navigation entries
 * exported only for tests
 */ function _addNavigationSpans(span, entry, timeOrigin) {
    [
        'unloadEvent',
        'redirect',
        'domContentLoadedEvent',
        'loadEvent',
        'connect'
    ].forEach(function(event) {
        _addPerformanceNavigationTiming(span, entry, event, timeOrigin);
    });
    _addPerformanceNavigationTiming(span, entry, 'secureConnection', timeOrigin, 'TLS/SSL');
    _addPerformanceNavigationTiming(span, entry, 'fetch', timeOrigin, 'cache');
    _addPerformanceNavigationTiming(span, entry, 'domainLookup', timeOrigin, 'DNS');
    _addRequest(span, entry, timeOrigin);
}
/** Create performance navigation related spans */ function _addPerformanceNavigationTiming(span, entry, event, timeOrigin) {
    var name = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : event;
    var eventEnd = _getEndPropertyNameForNavigationTiming(event);
    var end = entry[eventEnd];
    var start = entry["".concat(event, "Start")];
    if (!start || !end) return;
    (0, _utilsJs.startAndEndSpan)(span, timeOrigin + (0, _utilsJs.msToSec)(start), timeOrigin + (0, _utilsJs.msToSec)(end), {
        op: "browser.".concat(name),
        name: entry.name,
        attributes: (0, _objectSpread._)((0, _defineProperty._)({}, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), 'auto.ui.browser.metrics'), event === 'redirect' && entry.redirectCount != null ? {
            'http.redirect_count': entry.redirectCount
        } : {})
    });
}
function _getEndPropertyNameForNavigationTiming(event) {
    if (event === 'secureConnection') return 'connectEnd';
    if (event === 'fetch') return 'domainLookupStart';
    return "".concat(event, "End");
}
/** Create request and response related spans */ function _addRequest(span, entry, timeOrigin) {
    var requestStartTimestamp = timeOrigin + (0, _utilsJs.msToSec)(entry.requestStart);
    var responseEndTimestamp = timeOrigin + (0, _utilsJs.msToSec)(entry.responseEnd);
    var responseStartTimestamp = timeOrigin + (0, _utilsJs.msToSec)(entry.responseStart);
    if (entry.responseEnd) {
        // It is possible that we are collecting these metrics when the page hasn't finished loading yet, for example when the HTML slowly streams in.
        // In this case, ie. when the document request hasn't finished yet, `entry.responseEnd` will be 0.
        // In order not to produce faulty spans, where the end timestamp is before the start timestamp, we will only collect
        // these spans when the responseEnd value is available. The backend (Relay) would drop the entire span if it contained faulty spans.
        (0, _utilsJs.startAndEndSpan)(span, requestStartTimestamp, responseEndTimestamp, {
            op: 'browser.request',
            name: entry.name,
            attributes: (0, _defineProperty._)({}, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), 'auto.ui.browser.metrics')
        });
        (0, _utilsJs.startAndEndSpan)(span, responseStartTimestamp, responseEndTimestamp, {
            op: 'browser.response',
            name: entry.name,
            attributes: (0, _defineProperty._)({}, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), 'auto.ui.browser.metrics')
        });
    }
}
/**
 * Create resource-related spans.
 * Exported only for tests.
 */ function _addResourceSpans(span, entry, resourceUrl, startTime, duration, timeOrigin, ignoredResourceSpanOps) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') return;
    var op = entry.initiatorType ? "resource.".concat(entry.initiatorType) : 'resource.other';
    if (ignoredResourceSpanOps === null || ignoredResourceSpanOps === void 0 ? void 0 : ignoredResourceSpanOps.includes(op)) return;
    var attributes = (0, _defineProperty._)({}, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), 'auto.resource.browser.metrics');
    var parsedUrl = (0, _core.parseUrl)(resourceUrl);
    if (parsedUrl.protocol) attributes['url.scheme'] = parsedUrl.protocol.split(':').pop(); // the protocol returned by parseUrl includes a :, but OTEL spec does not, so we remove it.
    if (parsedUrl.host) attributes['server.address'] = parsedUrl.host;
    attributes['url.same_origin'] = resourceUrl.includes((0, _typesJs.WINDOW).location.origin);
    _setResourceRequestAttributes(entry, attributes, [
        // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/responseStatus
        [
            'responseStatus',
            'http.response.status_code'
        ],
        [
            'transferSize',
            'http.response_transfer_size'
        ],
        [
            'encodedBodySize',
            'http.response_content_length'
        ],
        [
            'decodedBodySize',
            'http.decoded_response_content_length'
        ],
        // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/renderBlockingStatus
        [
            'renderBlockingStatus',
            'resource.render_blocking_status'
        ],
        // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/deliveryType
        [
            'deliveryType',
            'http.response_delivery_type'
        ]
    ]);
    var attributesWithResourceTiming = (0, _objectSpread._)({}, attributes, (0, _resourceTimingJs.resourceTimingToSpanAttributes)(entry));
    var startTimestamp = timeOrigin + startTime;
    var endTimestamp = startTimestamp + duration;
    (0, _utilsJs.startAndEndSpan)(span, startTimestamp, endTimestamp, {
        name: resourceUrl.replace((0, _typesJs.WINDOW).location.origin, ''),
        op: op,
        attributes: attributesWithResourceTiming
    });
}
/**
 * Capture the information of the user agent.
 */ function _trackNavigator(span) {
    var navigator = (0, _typesJs.WINDOW).navigator;
    if (!navigator) return;
    // track network connectivity
    var connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) span.setAttribute('effectiveConnectionType', connection.effectiveType);
        if (connection.type) span.setAttribute('connectionType', connection.type);
        if ((0, _utilsJs.isMeasurementValue)(connection.rtt)) _measurements['connection.rtt'] = {
            value: connection.rtt,
            unit: 'millisecond'
        };
    }
    if ((0, _utilsJs.isMeasurementValue)(navigator.deviceMemory)) span.setAttribute('deviceMemory', "".concat(navigator.deviceMemory, " GB"));
    if ((0, _utilsJs.isMeasurementValue)(navigator.hardwareConcurrency)) span.setAttribute('hardwareConcurrency', String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to span to allow debugging */ function _setWebVitalAttributes(span, options) {
    // Only add LCP attributes if LCP is being recorded on the pageload span
    if (_lcpEntry && options.recordLcpOnPageloadSpan) {
        // Capture Properties of the LCP element that contributes to the LCP.
        if (_lcpEntry.element) span.setAttribute('lcp.element', (0, _core.htmlTreeAsString)(_lcpEntry.element));
        if (_lcpEntry.id) span.setAttribute('lcp.id', _lcpEntry.id);
        if (_lcpEntry.url) // Trim URL to the first 200 characters.
        span.setAttribute('lcp.url', _lcpEntry.url.trim().slice(0, 200));
        if (_lcpEntry.loadTime != null) // loadTime is the time of LCP that's related to receiving the LCP element response..
        span.setAttribute('lcp.loadTime', _lcpEntry.loadTime);
        if (_lcpEntry.renderTime != null) // renderTime is loadTime + rendering time
        // it's 0 if the LCP element is loaded from a 3rd party origin that doesn't send the
        // `Timing-Allow-Origin` header.
        span.setAttribute('lcp.renderTime', _lcpEntry.renderTime);
        span.setAttribute('lcp.size', _lcpEntry.size);
    }
    // Only add CLS attributes if CLS is being recorded on the pageload span
    if ((_clsEntry === null || _clsEntry === void 0 ? void 0 : _clsEntry.sources) && options.recordClsOnPageloadSpan) _clsEntry.sources.forEach(function(source, index) {
        return span.setAttribute("cls.source.".concat(index + 1), (0, _core.htmlTreeAsString)(source.node));
    });
}
/**
 * Use this to set any attributes we can take directly form the PerformanceResourceTiming entry.
 *
 * This is just a mapping function for entry->attribute to keep bundle-size minimal.
 * Experimental properties are also accepted (see {@link ExperimentalResourceTimingProperty}).
 * Assumes that all entry properties might be undefined for browser-specific differences.
 * Only accepts string and number values for now and also sets 0-values.
 */ function _setResourceRequestAttributes(entry, attributes, properties) {
    properties.forEach(function(param) {
        var _param = (0, _slicedToArray._)(param, 2), entryKey = _param[0], attributeKey = _param[1];
        var entryVal = entry[entryKey];
        if (entryVal != null && (typeof entryVal === 'number' && entryVal < MAX_INT_AS_BYTES || typeof entryVal === 'string')) attributes[attributeKey] = entryVal;
    });
}
/**
 * Add ttfb request time information to measurements.
 *
 * ttfb information is added via vendored web vitals library.
 */ function _addTtfbRequestTimeToMeasurements(_measurements) {
    var navEntry = (0, _getNavigationEntryJs.getNavigationEntry)(false);
    if (!navEntry) return;
    var responseStart = navEntry.responseStart, requestStart = navEntry.requestStart;
    if (requestStart <= responseStart) _measurements['ttfb.requestTime'] = {
        value: responseStart - requestStart,
        unit: 'millisecond'
    };
}

},{"@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_type_of":"iFJdx","@sentry/core":"7plmH","../types.js":"5Nyr0","./cls.js":"7VM5E","./instrument.js":"5FnSf","./lcp.js":"2YAGL","./resourceTiming.js":"5xNEV","./utils.js":"5IDN9","./web-vitals/lib/getActivationStart.js":"awFZB","./web-vitals/lib/getNavigationEntry.js":"i6iTI","./web-vitals/lib/getVisibilityWatcher.js":"gYvqN","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7VM5E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_sendStandaloneClsSpan", function() {
    return _sendStandaloneClsSpan;
});
parcelHelpers.export(exports, "trackClsAsStandaloneSpan", function() {
    return trackClsAsStandaloneSpan;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _core = require("@sentry/core");
var _debugBuildJs = require("../debug-build.js");
var _instrumentJs = require("./instrument.js");
var _utilsJs = require("./utils.js");
/**
 * Starts tracking the Cumulative Layout Shift on the current page and collects the value once
 *
 * - the page visibility is hidden
 * - a navigation span is started (to stop CLS measurement for SPA soft navigations)
 *
 * Once either of these events triggers, the CLS value is sent as a standalone span and we stop
 * measuring CLS.
 */ function trackClsAsStandaloneSpan(client) {
    var standaloneCLsValue = 0;
    var standaloneClsEntry;
    if (!(0, _utilsJs.supportsWebVital)('layout-shift')) return;
    var cleanupClsHandler = (0, _instrumentJs.addClsInstrumentationHandler)(function(param) {
        var metric = param.metric;
        var entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        standaloneCLsValue = metric.value;
        standaloneClsEntry = entry;
    }, true);
    (0, _utilsJs.listenForWebVitalReportEvents)(client, function(reportEvent, pageloadSpanId) {
        _sendStandaloneClsSpan(standaloneCLsValue, standaloneClsEntry, pageloadSpanId, reportEvent);
        cleanupClsHandler();
    });
}
/**
 * Exported only for testing!
 */ function _sendStandaloneClsSpan(clsValue, entry, pageloadSpanId, reportEvent) {
    var _entry_sources_;
    (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).log("Sending CLS span (".concat(clsValue, ")"));
    var startTime = entry ? (0, _utilsJs.msToSec)(((0, _core.browserPerformanceTimeOrigin)() || 0) + entry.startTime) : (0, _core.timestampInSeconds)();
    var routeName = (0, _core.getCurrentScope)().getScopeData().transactionName;
    var name = entry ? (0, _core.htmlTreeAsString)((_entry_sources_ = entry.sources[0]) === null || _entry_sources_ === void 0 ? void 0 : _entry_sources_.node) : 'Layout shift';
    var _obj;
    var attributes = (_obj = {}, (0, _defineProperty._)(_obj, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), 'auto.http.browser.cls'), (0, _defineProperty._)(_obj, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_OP), 'ui.webvital.cls'), (0, _defineProperty._)(_obj, (0, _core.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME), 0), // attach the pageload span id to the CLS span so that we can link them in the UI
    (0, _defineProperty._)(_obj, 'sentry.pageload.span_id', pageloadSpanId), // describes what triggered the web vital to be reported
    (0, _defineProperty._)(_obj, 'sentry.report_event', reportEvent), _obj);
    // Add CLS sources as span attributes to help with debugging layout shifts
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift/sources
    if (entry === null || entry === void 0 ? void 0 : entry.sources) entry.sources.forEach(function(source, index) {
        attributes["cls.source.".concat(index + 1)] = (0, _core.htmlTreeAsString)(source.node);
    });
    var span = (0, _utilsJs.startStandaloneWebVitalSpan)({
        name: name,
        transaction: routeName,
        attributes: attributes,
        startTime: startTime
    });
    if (span) {
        var _obj1;
        span.addEvent('cls', (_obj1 = {}, (0, _defineProperty._)(_obj1, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT), ''), (0, _defineProperty._)(_obj1, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE), clsValue), _obj1));
        // LayoutShift performance entries always have a duration of 0, so we don't need to add `entry.duration` here
        // see: https://developer.mozilla.org/en-US/docs/Web/API/PerformanceEntry/duration
        span.end(startTime);
    }
}

},{"@swc/helpers/_/_define_property":"e80IS","@sentry/core":"7plmH","../debug-build.js":"jrbj2","./instrument.js":"5FnSf","./utils.js":"5IDN9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5IDN9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extractNetworkProtocol", function() {
    return extractNetworkProtocol;
});
parcelHelpers.export(exports, "getBrowserPerformanceAPI", function() {
    return getBrowserPerformanceAPI;
});
parcelHelpers.export(exports, "isMeasurementValue", function() {
    return isMeasurementValue;
});
parcelHelpers.export(exports, "listenForWebVitalReportEvents", function() {
    return listenForWebVitalReportEvents;
});
parcelHelpers.export(exports, "msToSec", function() {
    return msToSec;
});
parcelHelpers.export(exports, "startAndEndSpan", function() {
    return startAndEndSpan;
});
parcelHelpers.export(exports, "startStandaloneWebVitalSpan", function() {
    return startStandaloneWebVitalSpan;
});
parcelHelpers.export(exports, "supportsWebVital", function() {
    return supportsWebVital;
});
var _extends = require("@swc/helpers/_/_extends");
var _objectDestructuringEmpty = require("@swc/helpers/_/_object_destructuring_empty");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _core = require("@sentry/core");
var _typesJs = require("../types.js");
var _onHiddenJs = require("./web-vitals/lib/onHidden.js");
/**
 * Checks if a given value is a valid measurement value.
 */ function isMeasurementValue(value) {
    return typeof value === 'number' && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 */ function startAndEndSpan(parentSpan, startTimeInSeconds, endTime, _param) {
    var ctx = (0, _extends._)({}, (0, _objectDestructuringEmpty._)(_param));
    var parentStartTime = (0, _core.spanToJSON)(parentSpan).start_timestamp;
    if (parentStartTime && parentStartTime > startTimeInSeconds) // We can only do this for SentrySpans...
    {
        if (typeof parentSpan.updateStartTime === 'function') parentSpan.updateStartTime(startTimeInSeconds);
    }
    // The return value only exists for tests
    return (0, _core.withActiveSpan)(parentSpan, function() {
        var span = (0, _core.startInactiveSpan)((0, _objectSpread._)({
            startTime: startTimeInSeconds
        }, ctx));
        if (span) span.end(endTime);
        return span;
    });
}
/**
 * Starts an inactive, standalone span used to send web vital values to Sentry.
 * DO NOT use this for arbitrary spans, as these spans require special handling
 * during ingestion to extract metrics.
 *
 * This function adds a bunch of attributes and data to the span that's shared
 * by all web vital standalone spans. However, you need to take care of adding
 * the actual web vital value as an event to the span. Also, you need to assign
 * a transaction name and some other values that are specific to the web vital.
 *
 * Ultimately, you also need to take care of ending the span to send it off.
 *
 * @param options
 *
 * @returns an inactive, standalone and NOT YET ended span
 */ function startStandaloneWebVitalSpan(options) {
    var _WINDOW_navigator;
    var client = (0, _core.getClient)();
    if (!client) return;
    var name = options.name, transaction = options.transaction, passedAttributes = options.attributes, startTime = options.startTime;
    var _client_getOptions = client.getOptions(), release = _client_getOptions.release, environment = _client_getOptions.environment, sendDefaultPii = _client_getOptions.sendDefaultPii;
    // We need to get the replay, user, and activeTransaction from the current scope
    // so that we can associate replay id, profile id, and a user display to the span
    var replay = client.getIntegrationByName('Replay');
    var replayId = replay === null || replay === void 0 ? void 0 : replay.getReplayId();
    var scope = (0, _core.getCurrentScope)();
    var user = scope.getUser();
    var userDisplay = user !== undefined ? user.email || user.id || user.ip_address : undefined;
    var profileId;
    try {
        // @ts-expect-error skip optional chaining to save bundle size with try catch
        profileId = scope.getScopeData().contexts.profile.profile_id;
    } catch (e) {
    // do nothing
    }
    var attributes = (0, _objectSpread._)({
        release: release,
        environment: environment,
        user: userDisplay || undefined,
        profile_id: profileId || undefined,
        replay_id: replayId || undefined,
        transaction: transaction,
        // Web vital score calculation relies on the user agent to account for different
        // browsers setting different thresholds for what is considered a good/meh/bad value.
        // For example: Chrome vs. Chrome Mobile
        'user_agent.original': (_WINDOW_navigator = (0, _typesJs.WINDOW).navigator) === null || _WINDOW_navigator === void 0 ? void 0 : _WINDOW_navigator.userAgent,
        // This tells Sentry to infer the IP address from the request
        'client.address': sendDefaultPii ? '{{auto}}' : undefined
    }, passedAttributes);
    return (0, _core.startInactiveSpan)({
        name: name,
        attributes: attributes,
        startTime: startTime,
        experimental: {
            standalone: true
        }
    });
}
/** Get the browser performance API. */ function getBrowserPerformanceAPI() {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    return (0, _typesJs.WINDOW).addEventListener && (0, _typesJs.WINDOW).performance;
}
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function msToSec(time) {
    return time / 1000;
}
/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */ function extractNetworkProtocol(nextHopProtocol) {
    var name = 'unknown';
    var version = 'unknown';
    var _name = '';
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = nextHopProtocol[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var char = _step.value;
            // http/1.1 etc.
            if (char === '/') {
                var ref;
                ref = (0, _slicedToArray._)(nextHopProtocol.split('/'), 2), name = ref[0], version = ref[1], ref;
                break;
            }
            // h2, h3 etc.
            if (!isNaN(Number(char))) {
                name = _name === 'h' ? 'http' : _name;
                version = nextHopProtocol.split(_name)[1];
                break;
            }
            _name += char;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (_name === nextHopProtocol) // webrtc, ftp, etc.
    name = _name;
    return {
        name: name,
        version: version
    };
}
/**
 * Generic support check for web vitals
 */ function supportsWebVital(entryType) {
    try {
        return PerformanceObserver.supportedEntryTypes.includes(entryType);
    } catch (e) {
        return false;
    }
}
/**
 * Listens for events on which we want to collect a previously accumulated web vital value.
 * Currently, this includes:
 *
 * - pagehide (i.e. user minimizes browser window, hides tab, etc)
 * - soft navigation (we only care about the vital of the initially loaded route)
 *
 * As a "side-effect", this function will also collect the span id of the pageload span.
 *
 * @param collectorCallback the callback to be called when the first of these events is triggered. Parameters:
 * - event: the event that triggered the reporting of the web vital value.
 * - pageloadSpanId: the span id of the pageload span. This is used to link the web vital span to the pageload span.
 */ function listenForWebVitalReportEvents(client, collectorCallback) {
    var pageloadSpanId;
    var collected = false;
    function _runCollectorCallbackOnce(event) {
        if (!collected && pageloadSpanId) collectorCallback(event, pageloadSpanId);
        collected = true;
    }
    (0, _onHiddenJs.onHidden)(function() {
        _runCollectorCallbackOnce('pagehide');
    });
    var unsubscribeStartNavigation = client.on('beforeStartNavigationSpan', function(_, options) {
        // we only want to collect LCP if we actually navigate. Redirects should be ignored.
        if (!(options === null || options === void 0 ? void 0 : options.isRedirect)) {
            _runCollectorCallbackOnce('navigation');
            unsubscribeStartNavigation();
            unsubscribeAfterStartPageLoadSpan();
        }
    });
    var unsubscribeAfterStartPageLoadSpan = client.on('afterStartPageLoadSpan', function(span) {
        pageloadSpanId = span.spanContext().spanId;
        unsubscribeAfterStartPageLoadSpan();
    });
}

},{"@swc/helpers/_/_extends":"bXNuS","@swc/helpers/_/_object_destructuring_empty":"18aa3","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_sliced_to_array":"8PtL6","@sentry/core":"7plmH","../types.js":"5Nyr0","./web-vitals/lib/onHidden.js":"geYnH","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bXNuS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _extends;
});
function _extends() {
    _extends = Object.assign || function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"18aa3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _object_destructuring_empty;
});
function _object_destructuring_empty(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2YAGL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_sendStandaloneLcpSpan", function() {
    return _sendStandaloneLcpSpan;
});
parcelHelpers.export(exports, "trackLcpAsStandaloneSpan", function() {
    return trackLcpAsStandaloneSpan;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _core = require("@sentry/core");
var _debugBuildJs = require("../debug-build.js");
var _instrumentJs = require("./instrument.js");
var _utilsJs = require("./utils.js");
/**
 * Starts tracking the Largest Contentful Paint on the current page and collects the value once
 *
 * - the page visibility is hidden
 * - a navigation span is started (to stop LCP measurement for SPA soft navigations)
 *
 * Once either of these events triggers, the LCP value is sent as a standalone span and we stop
 * measuring LCP for subsequent routes.
 */ function trackLcpAsStandaloneSpan(client) {
    var standaloneLcpValue = 0;
    var standaloneLcpEntry;
    if (!(0, _utilsJs.supportsWebVital)('largest-contentful-paint')) return;
    var cleanupLcpHandler = (0, _instrumentJs.addLcpInstrumentationHandler)(function(param) {
        var metric = param.metric;
        var entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        standaloneLcpValue = metric.value;
        standaloneLcpEntry = entry;
    }, true);
    (0, _utilsJs.listenForWebVitalReportEvents)(client, function(reportEvent, pageloadSpanId) {
        _sendStandaloneLcpSpan(standaloneLcpValue, standaloneLcpEntry, pageloadSpanId, reportEvent);
        cleanupLcpHandler();
    });
}
/**
 * Exported only for testing!
 */ function _sendStandaloneLcpSpan(lcpValue, entry, pageloadSpanId, reportEvent) {
    (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).log("Sending LCP span (".concat(lcpValue, ")"));
    var startTime = (0, _utilsJs.msToSec)(((0, _core.browserPerformanceTimeOrigin)() || 0) + ((entry === null || entry === void 0 ? void 0 : entry.startTime) || 0));
    var routeName = (0, _core.getCurrentScope)().getScopeData().transactionName;
    var name = entry ? (0, _core.htmlTreeAsString)(entry.element) : 'Largest contentful paint';
    var _obj;
    var attributes = (_obj = {}, (0, _defineProperty._)(_obj, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), 'auto.http.browser.lcp'), (0, _defineProperty._)(_obj, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_OP), 'ui.webvital.lcp'), (0, _defineProperty._)(_obj, (0, _core.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME), 0), // attach the pageload span id to the LCP span so that we can link them in the UI
    (0, _defineProperty._)(_obj, 'sentry.pageload.span_id', pageloadSpanId), // describes what triggered the web vital to be reported
    (0, _defineProperty._)(_obj, 'sentry.report_event', reportEvent), _obj);
    if (entry) {
        entry.element && (attributes['lcp.element'] = (0, _core.htmlTreeAsString)(entry.element));
        entry.id && (attributes['lcp.id'] = entry.id);
        entry.url && (attributes['lcp.url'] = entry.url);
        // loadTime is the time of LCP that's related to receiving the LCP element response..
        entry.loadTime != null && (attributes['lcp.loadTime'] = entry.loadTime);
        // renderTime is loadTime + rendering time
        // it's 0 if the LCP element is loaded from a 3rd party origin that doesn't send the
        // `Timing-Allow-Origin` header.
        entry.renderTime != null && (attributes['lcp.renderTime'] = entry.renderTime);
        entry.size != null && (attributes['lcp.size'] = entry.size);
    }
    var span = (0, _utilsJs.startStandaloneWebVitalSpan)({
        name: name,
        transaction: routeName,
        attributes: attributes,
        startTime: startTime
    });
    if (span) {
        var _obj1;
        span.addEvent('lcp', (_obj1 = {}, (0, _defineProperty._)(_obj1, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT), 'millisecond'), (0, _defineProperty._)(_obj1, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE), lcpValue), _obj1));
        // LCP is a point-in-time metric, so we end the span immediately
        span.end(startTime);
    }
}

},{"@swc/helpers/_/_define_property":"e80IS","@sentry/core":"7plmH","../debug-build.js":"jrbj2","./instrument.js":"5FnSf","./utils.js":"5IDN9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5xNEV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resourceTimingToSpanAttributes", function() {
    return resourceTimingToSpanAttributes;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _core = require("@sentry/core");
var _utilsJs = require("./utils.js");
function getAbsoluteTime(time) {
    // falsy values should be preserved so that we can later on drop undefined values and
    // preserve 0 vals for cross-origin resources without proper `Timing-Allow-Origin` header.
    return time ? (((0, _core.browserPerformanceTimeOrigin)() || performance.timeOrigin) + time) / 1000 : time;
}
/**
 * Converts a PerformanceResourceTiming entry to span data for the resource span. Most importantly,
 * it converts the timing values from timestamps relative to the `performance.timeOrigin` to absolute timestamps
 * in seconds.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming#timestamps
 *
 * @param resourceTiming
 * @returns An array where the first element is the attribute name and the second element is the attribute value.
 */ function resourceTimingToSpanAttributes(resourceTiming) {
    var _getBrowserPerformanceAPI;
    var timingSpanData = {};
    // Checking for only `undefined` and `null` is intentional because it's
    // valid for `nextHopProtocol` to be an empty string.
    if (resourceTiming.nextHopProtocol != undefined) {
        var _extractNetworkProtocol = (0, _utilsJs.extractNetworkProtocol)(resourceTiming.nextHopProtocol), name = _extractNetworkProtocol.name, version = _extractNetworkProtocol.version;
        timingSpanData['network.protocol.version'] = version;
        timingSpanData['network.protocol.name'] = name;
    }
    if (!((0, _core.browserPerformanceTimeOrigin)() || ((_getBrowserPerformanceAPI = (0, _utilsJs.getBrowserPerformanceAPI)()) === null || _getBrowserPerformanceAPI === void 0 ? void 0 : _getBrowserPerformanceAPI.timeOrigin))) return timingSpanData;
    return dropUndefinedKeysFromObject((0, _objectSpreadProps._)((0, _objectSpread._)({}, timingSpanData), {
        'http.request.redirect_start': getAbsoluteTime(resourceTiming.redirectStart),
        'http.request.redirect_end': getAbsoluteTime(resourceTiming.redirectEnd),
        'http.request.worker_start': getAbsoluteTime(resourceTiming.workerStart),
        'http.request.fetch_start': getAbsoluteTime(resourceTiming.fetchStart),
        'http.request.domain_lookup_start': getAbsoluteTime(resourceTiming.domainLookupStart),
        'http.request.domain_lookup_end': getAbsoluteTime(resourceTiming.domainLookupEnd),
        'http.request.connect_start': getAbsoluteTime(resourceTiming.connectStart),
        'http.request.secure_connection_start': getAbsoluteTime(resourceTiming.secureConnectionStart),
        'http.request.connection_end': getAbsoluteTime(resourceTiming.connectEnd),
        'http.request.request_start': getAbsoluteTime(resourceTiming.requestStart),
        'http.request.response_start': getAbsoluteTime(resourceTiming.responseStart),
        'http.request.response_end': getAbsoluteTime(resourceTiming.responseEnd),
        // For TTFB we actually want the relative time from timeOrigin to responseStart
        // This way, TTFB always measures the "first page load" experience.
        // see: https://web.dev/articles/ttfb#measure-resource-requests
        'http.request.time_to_first_byte': resourceTiming.responseStart != null ? resourceTiming.responseStart / 1000 : undefined
    }));
}
/**
 * Remove properties with `undefined` as value from an object.
 * In contrast to `dropUndefinedKeys` in core this funciton only works on first-level
 * key-value objects and does not recursively go into object properties or arrays.
 */ function dropUndefinedKeysFromObject(attrs) {
    return Object.fromEntries(Object.entries(attrs).filter(function(param) {
        var _param = (0, _slicedToArray._)(param, 2), value = _param[1];
        return value != null;
    }));
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_sliced_to_array":"8PtL6","@sentry/core":"7plmH","./utils.js":"5IDN9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ds3S5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_onElementTiming", function() {
    return _onElementTiming;
});
parcelHelpers.export(exports, "startTrackingElementTiming", function() {
    return startTrackingElementTiming;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _core = require("@sentry/core");
var _instrumentJs = require("./instrument.js");
var _utilsJs = require("./utils.js");
// ElementTiming interface based on the W3C spec
/**
 * Start tracking ElementTiming performance entries.
 */ function startTrackingElementTiming() {
    var performance = (0, _utilsJs.getBrowserPerformanceAPI)();
    if (performance && (0, _core.browserPerformanceTimeOrigin)()) return (0, _instrumentJs.addPerformanceInstrumentationHandler)('element', _onElementTiming);
    return function() {
        return undefined;
    };
}
/**
 * exported only for testing
 */ var _onElementTiming = function(param) {
    var entries = param.entries;
    var activeSpan = (0, _core.getActiveSpan)();
    var rootSpan = activeSpan ? (0, _core.getRootSpan)(activeSpan) : undefined;
    var transactionName = rootSpan ? (0, _core.spanToJSON)(rootSpan).description : (0, _core.getCurrentScope)().getScopeData().transactionName;
    entries.forEach(function(entry) {
        var _elementEntry_element_tagName, _elementEntry_element;
        var elementEntry = entry;
        // Skip entries without identifier (elementtiming attribute)
        if (!elementEntry.identifier) return;
        // `name` contains the type of the element paint. Can be `'image-paint'` or `'text-paint'`.
        // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceElementTiming#instance_properties
        var paintType = elementEntry.name;
        var renderTime = elementEntry.renderTime;
        var loadTime = elementEntry.loadTime;
        // starting the span at:
        // - `loadTime` if available (should be available for all "image-paint" entries, 0 otherwise)
        // - `renderTime` if available (available for all entries, except 3rd party images, but these should be covered by `loadTime`, 0 otherwise)
        // - `timestampInSeconds()` as a safeguard
        // see https://developer.mozilla.org/en-US/docs/Web/API/PerformanceElementTiming/renderTime#cross-origin_image_render_time
        var _ref = (0, _slicedToArray._)(loadTime ? [
            (0, _utilsJs.msToSec)(loadTime),
            'load-time'
        ] : renderTime ? [
            (0, _utilsJs.msToSec)(renderTime),
            'render-time'
        ] : [
            (0, _core.timestampInSeconds)(),
            'entry-emission'
        ], 2), spanStartTime = _ref[0], spanStartTimeSource = _ref[1];
        var duration = paintType === 'image-paint' ? // and `renderTime`. `loadTime` is the time when the image finished loading and `renderTime` is the
        // time when the image finished rendering.
        (0, _utilsJs.msToSec)(Math.max(0, (renderTime !== null && renderTime !== void 0 ? renderTime : 0) - (loadTime !== null && loadTime !== void 0 ? loadTime : 0))) : 0;
        var _obj;
        var attributes = (_obj = {}, (0, _defineProperty._)(_obj, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), 'auto.ui.browser.elementtiming'), (0, _defineProperty._)(_obj, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_OP), 'ui.elementtiming'), // name must be user-entered, so we can assume low cardinality
        (0, _defineProperty._)(_obj, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), 'component'), // recording the source of the span start time, as it varies depending on available data
        (0, _defineProperty._)(_obj, 'sentry.span_start_time_source', spanStartTimeSource), (0, _defineProperty._)(_obj, 'sentry.transaction_name', transactionName), (0, _defineProperty._)(_obj, 'element.id', elementEntry.id), (0, _defineProperty._)(_obj, 'element.type', ((_elementEntry_element = elementEntry.element) === null || _elementEntry_element === void 0 ? void 0 : (_elementEntry_element_tagName = _elementEntry_element.tagName) === null || _elementEntry_element_tagName === void 0 ? void 0 : _elementEntry_element_tagName.toLowerCase()) || 'unknown'), (0, _defineProperty._)(_obj, 'element.size', elementEntry.naturalWidth && elementEntry.naturalHeight ? "".concat(elementEntry.naturalWidth, "x").concat(elementEntry.naturalHeight) : undefined), (0, _defineProperty._)(_obj, 'element.render_time', renderTime), (0, _defineProperty._)(_obj, 'element.load_time', loadTime), // `url` is `0`(number) for text paints (hence we fall back to undefined)
        (0, _defineProperty._)(_obj, 'element.url', elementEntry.url || undefined), (0, _defineProperty._)(_obj, 'element.identifier', elementEntry.identifier), (0, _defineProperty._)(_obj, 'element.paint_type', paintType), _obj);
        (0, _core.startSpan)({
            name: "element[".concat(elementEntry.identifier, "]"),
            attributes: attributes,
            startTime: spanStartTime,
            onlyIfParent: true
        }, function(span) {
            span.end(spanStartTime + duration);
        });
    });
};

},{"@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_sliced_to_array":"8PtL6","@sentry/core":"7plmH","./instrument.js":"5FnSf","./utils.js":"5IDN9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8Gply":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addClickKeypressInstrumentationHandler", function() {
    return addClickKeypressInstrumentationHandler;
});
parcelHelpers.export(exports, "instrumentDOM", function() {
    return instrumentDOM;
});
var _core = require("@sentry/core");
var _typesJs = require("../types.js");
var DEBOUNCE_DURATION = 1000;
var debounceTimerID;
var lastCapturedEventType;
var lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function addClickKeypressInstrumentationHandler(handler) {
    var type = 'dom';
    (0, _core.addHandler)(type, handler);
    (0, _core.maybeInstrument)(type, instrumentDOM);
}
/** Exported for tests only. */ function instrumentDOM() {
    if (!(0, _typesJs.WINDOW).document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    var triggerDOMHandler = (0, _core.triggerHandlers).bind(null, 'dom');
    var globalDOMEventHandler = makeDOMEventHandler(triggerDOMHandler, true);
    (0, _typesJs.WINDOW).document.addEventListener('click', globalDOMEventHandler, false);
    (0, _typesJs.WINDOW).document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach(function(target) {
        var _globalObject_target, _proto_hasOwnProperty;
        var globalObject = (0, _typesJs.WINDOW);
        var proto = (_globalObject_target = globalObject[target]) === null || _globalObject_target === void 0 ? void 0 : _globalObject_target.prototype;
        // eslint-disable-next-line no-prototype-builtins
        if (!(proto === null || proto === void 0 ? void 0 : (_proto_hasOwnProperty = proto.hasOwnProperty) === null || _proto_hasOwnProperty === void 0 ? void 0 : _proto_hasOwnProperty.call(proto, 'addEventListener'))) return;
        (0, _core.fill)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    var handlers = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {};
                    var handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        var handler = makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, _core.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    var handlers = this.__sentry_instrumentation_handlers__ || {};
                    var handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete this.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== 'keypress') return false;
    if (!(target === null || target === void 0 ? void 0 : target.tagName)) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function makeDOMEventHandler(handler) {
    var globalListener = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return function(event) {
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event['_sentryCaptured']) return;
        var target = getEventTarget(event);
        // We always want to skip _some_ events.
        if (shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, _core.addNonEnumerableProperty)(event, '_sentryCaptured', true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, _core.addNonEnumerableProperty)(target, '_sentryId', (0, _core.uuid4)());
        var name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!isSimilarToLastCapturedEvent(event)) {
            var handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            lastCapturedEventType = event.type;
            lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout(debounceTimerID);
        debounceTimerID = (0, _typesJs.WINDOW).setTimeout(function() {
            lastCapturedEventTargetId = undefined;
            lastCapturedEventType = undefined;
        }, DEBOUNCE_DURATION);
    };
}
function getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}

},{"@sentry/core":"7plmH","../types.js":"5Nyr0","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fEFCc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addHistoryInstrumentationHandler", function() {
    return addHistoryInstrumentationHandler;
});
parcelHelpers.export(exports, "instrumentHistory", function() {
    return instrumentHistory;
});
var _core = require("@sentry/core");
var _typesJs = require("../types.js");
var lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function addHistoryInstrumentationHandler(handler) {
    var type = 'history';
    (0, _core.addHandler)(type, handler);
    (0, _core.maybeInstrument)(type, instrumentHistory);
}
/**
 * Exported just for testing
 */ function instrumentHistory() {
    // The `popstate` event may also be triggered on `pushState`, but it may not always reliably be emitted by the browser
    // Which is why we also monkey-patch methods below, in addition to this
    (0, _typesJs.WINDOW).addEventListener('popstate', function() {
        var to = (0, _typesJs.WINDOW).location.href;
        // keep track of the current URL state, as we always receive only the updated state
        var from = lastHref;
        lastHref = to;
        if (from === to) return;
        var handlerData = {
            from: from,
            to: to
        };
        (0, _core.triggerHandlers)('history', handlerData);
    });
    // Just guard against this not being available, in weird environments
    if (!(0, _core.supportsHistory)()) return;
    function historyReplacementFunction(originalHistoryFunction) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var url = args.length > 2 ? args[2] : undefined;
            if (url) {
                var from = lastHref;
                // Ensure the URL is absolute
                // this can be either a path, then it is relative to the current origin
                // or a full URL of the current origin - other origins are not allowed
                // See: https://developer.mozilla.org/en-US/docs/Web/API/History/pushState#url
                // coerce to string (this is what pushState does)
                var to = getAbsoluteUrl(String(url));
                // keep track of the current URL state, as we always receive only the updated state
                lastHref = to;
                if (from === to) return originalHistoryFunction.apply(this, args);
                var handlerData = {
                    from: from,
                    to: to
                };
                (0, _core.triggerHandlers)('history', handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, _core.fill)((0, _typesJs.WINDOW).history, 'pushState', historyReplacementFunction);
    (0, _core.fill)((0, _typesJs.WINDOW).history, 'replaceState', historyReplacementFunction);
}
function getAbsoluteUrl(urlOrPath) {
    try {
        var url = new URL(urlOrPath, (0, _typesJs.WINDOW).location.origin);
        return url.toString();
    } catch (e) {
        // fallback, just do nothing
        return urlOrPath;
    }
}

},{"@sentry/core":"7plmH","../types.js":"5Nyr0","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8WTkI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clearCachedImplementation", function() {
    return clearCachedImplementation;
});
parcelHelpers.export(exports, "fetch", function() {
    return fetch;
});
parcelHelpers.export(exports, "getNativeImplementation", function() {
    return getNativeImplementation;
});
parcelHelpers.export(exports, "setTimeout", function() {
    return setTimeout;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _core = require("@sentry/core");
var _debugBuildJs = require("./debug-build.js");
var _typesJs = require("./types.js");
/**
 * We generally want to use window.fetch / window.setTimeout.
 * However, in some cases this may be wrapped (e.g. by Zone.js for Angular),
 * so we try to get an unpatched version of this from a sandboxed iframe.
 */ var cachedImplementations = {};
/**
 * Get the native implementation of a browser function.
 *
 * This can be used to ensure we get an unwrapped version of a function, in cases where a wrapped function can lead to problems.
 *
 * The following methods can be retrieved:
 * - `setTimeout`: This can be wrapped by e.g. Angular, causing change detection to be triggered.
 * - `fetch`: This can be wrapped by e.g. ad-blockers, causing an infinite loop when a request is blocked.
 */ function getNativeImplementation(name) {
    var cached = cachedImplementations[name];
    if (cached) return cached;
    var impl = (0, _typesJs.WINDOW)[name];
    // Fast path to avoid DOM I/O
    if ((0, _core.isNativeFunction)(impl)) return cachedImplementations[name] = impl.bind((0, _typesJs.WINDOW));
    var document = (0, _typesJs.WINDOW).document;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        var sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        var contentWindow = sandbox.contentWindow;
        if (contentWindow === null || contentWindow === void 0 ? void 0 : contentWindow[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        // Could not create sandbox iframe, just use window.xxx
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).warn("Could not create sandbox iframe for ".concat(name, " check, bailing to window.").concat(name, ": "), e);
    }
    // Sanity check: This _should_ not happen, but if it does, we just skip caching...
    // This can happen e.g. in tests where fetch may not be available in the env, or similar.
    if (!impl) return impl;
    return cachedImplementations[name] = impl.bind((0, _typesJs.WINDOW));
}
/** Clear a cached implementation. */ function clearCachedImplementation(name) {
    cachedImplementations[name] = undefined;
}
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function fetch() {
    for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++){
        rest[_key] = arguments[_key];
    }
    return getNativeImplementation('fetch').apply(this, (0, _toConsumableArray._)(rest));
}
/**
 * Get an unwrapped `setTimeout` method.
 * This ensures that even if e.g. Angular wraps `setTimeout`, we get the native implementation,
 * avoiding triggering change detection.
 */ function setTimeout() {
    for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++){
        rest[_key] = arguments[_key];
    }
    return getNativeImplementation('setTimeout').apply(this, (0, _toConsumableArray._)(rest));
}

},{"@swc/helpers/_/_to_consumable_array":"1eSZf","@sentry/core":"7plmH","./debug-build.js":"jrbj2","./types.js":"5Nyr0","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3x1ca":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SENTRY_XHR_DATA_KEY", function() {
    return SENTRY_XHR_DATA_KEY;
});
parcelHelpers.export(exports, "addXhrInstrumentationHandler", function() {
    return addXhrInstrumentationHandler;
});
parcelHelpers.export(exports, "instrumentXHR", function() {
    return instrumentXHR;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _core = require("@sentry/core");
var _typesJs = require("../types.js");
var SENTRY_XHR_DATA_KEY = '__sentry_xhr_v3__';
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function addXhrInstrumentationHandler(handler) {
    var type = 'xhr';
    (0, _core.addHandler)(type, handler);
    (0, _core.maybeInstrument)(type, instrumentXHR);
}
/** Exported only for tests. */ function instrumentXHR() {
    if (!(0, _typesJs.WINDOW).XMLHttpRequest) return;
    var xhrproto = XMLHttpRequest.prototype;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.open = new Proxy(xhrproto.open, {
        apply: function apply(originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your XHR call did not
            //       have a stack trace. If you are using HttpClient integration,
            //       this is the expected behavior, as we are using this virtual error to capture
            //       the location of your XHR call, and group your HttpClient events accordingly.
            var virtualError = new Error();
            var startTimestamp = (0, _core.timestampInSeconds)() * 1000;
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            var method = (0, _core.isString)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : undefined;
            var url = parseXhrUrlArg(xhrOpenArgArray[1]);
            if (!method || !url) return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
            xhrOpenThisArg[SENTRY_XHR_DATA_KEY] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === 'POST' && url.match(/sentry_key/)) xhrOpenThisArg.__sentry_own_request__ = true;
            var onreadystatechangeHandler = function() {
                // For whatever reason, this is not the same instance here as from the outer method
                var xhrInfo = xhrOpenThisArg[SENTRY_XHR_DATA_KEY];
                if (!xhrInfo) return;
                if (xhrOpenThisArg.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhrOpenThisArg.status;
                    } catch (e) {
                    /* do nothing */ }
                    var handlerData = {
                        endTimestamp: (0, _core.timestampInSeconds)() * 1000,
                        startTimestamp: startTimestamp,
                        xhr: xhrOpenThisArg,
                        virtualError: virtualError
                    };
                    (0, _core.triggerHandlers)('xhr', handlerData);
                }
            };
            if ('onreadystatechange' in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === 'function') xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
                apply: function apply(originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
                    onreadystatechangeHandler();
                    return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
                }
            });
            else xhrOpenThisArg.addEventListener('readystatechange', onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
                apply: function apply(originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
                    var _setRequestHeaderArgArray = (0, _slicedToArray._)(setRequestHeaderArgArray, 2), header = _setRequestHeaderArgArray[0], value = _setRequestHeaderArgArray[1];
                    var xhrInfo = setRequestHeaderThisArg[SENTRY_XHR_DATA_KEY];
                    if (xhrInfo && (0, _core.isString)(header) && (0, _core.isString)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
                }
            });
            return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
        }
    });
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.send = new Proxy(xhrproto.send, {
        apply: function apply(originalSend, sendThisArg, sendArgArray) {
            var sentryXhrData = sendThisArg[SENTRY_XHR_DATA_KEY];
            if (!sentryXhrData) return originalSend.apply(sendThisArg, sendArgArray);
            if (sendArgArray[0] !== undefined) sentryXhrData.body = sendArgArray[0];
            var handlerData = {
                startTimestamp: (0, _core.timestampInSeconds)() * 1000,
                xhr: sendThisArg
            };
            (0, _core.triggerHandlers)('xhr', handlerData);
            return originalSend.apply(sendThisArg, sendArgArray);
        }
    });
}
/**
 * Parses the URL argument of a XHR method to a string.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/open#url
 * url: A string or any other object with a stringifier — including a URL object — that provides the URL of the resource to send the request to.
 *
 * @param url - The URL argument of an XHR method
 * @returns The parsed URL string or undefined if the URL is invalid
 */ function parseXhrUrlArg(url) {
    if ((0, _core.isString)(url)) return url;
    try {
        // If the passed in argument is not a string, it should have a `toString` method as a stringifier.
        // If that fails, we just return undefined (like in IE11 where URL is not available)
        return url.toString();
    } catch (e) {} // eslint-disable-line no-empty
    return undefined;
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","@sentry/core":"7plmH","../types.js":"5Nyr0","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"700nK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getBodyString", function() {
    return getBodyString;
});
parcelHelpers.export(exports, "getFetchRequestArgBody", function() {
    return getFetchRequestArgBody;
});
parcelHelpers.export(exports, "parseXhrResponseHeaders", function() {
    return parseXhrResponseHeaders;
});
parcelHelpers.export(exports, "serializeFormData", function() {
    return serializeFormData;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var _core = require("@sentry/core");
var _debugBuildJs = require("./debug-build.js");
/**
 * Serializes FormData.
 *
 * This is a bit simplified, but gives us a decent estimate.
 * This converts e.g. { name: 'Anne Smith', age: 13 } to 'name=Anne+Smith&age=13'.
 *
 */ function serializeFormData(formData) {
    // @ts-expect-error passing FormData to URLSearchParams actually works
    return new URLSearchParams(formData).toString();
}
/** Get the string representation of a body. */ function getBodyString(body) {
    var _debug = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, _core.debug);
    try {
        if (typeof body === 'string') return [
            body
        ];
        if ((0, _instanceof._)(body, URLSearchParams)) return [
            body.toString()
        ];
        if ((0, _instanceof._)(body, FormData)) return [
            serializeFormData(body)
        ];
        if (!body) return [
            undefined
        ];
    } catch (error) {
        (0, _debugBuildJs.DEBUG_BUILD) && _debug.error(error, 'Failed to serialize body', body);
        return [
            undefined,
            'BODY_PARSE_ERROR'
        ];
    }
    (0, _debugBuildJs.DEBUG_BUILD) && _debug.log('Skipping network body because of body type', body);
    return [
        undefined,
        'UNPARSEABLE_BODY_TYPE'
    ];
}
/**
 * Parses the fetch arguments to extract the request payload.
 *
 * We only support getting the body from the fetch options.
 */ function getFetchRequestArgBody() {
    var fetchArgs = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    if (fetchArgs.length !== 2 || (0, _typeOf._)(fetchArgs[1]) !== 'object') return undefined;
    return fetchArgs[1].body;
}
/**
 * Parses XMLHttpRequest response headers into a Record.
 * Extracted from replay internals to be reusable.
 */ function parseXhrResponseHeaders(xhr) {
    var headers;
    try {
        headers = xhr.getAllResponseHeaders();
    } catch (error) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).error(error, 'Failed to get xhr response headers', xhr);
        return {};
    }
    if (!headers) return {};
    return headers.split('\r\n').reduce(function(acc, line) {
        var _line_split = (0, _slicedToArray._)(line.split(': '), 2), key = _line_split[0], value = _line_split[1];
        if (value) acc[key.toLowerCase()] = value;
        return acc;
    }, {});
}

},{"@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_type_of":"iFJdx","@sentry/core":"7plmH","./debug-build.js":"jrbj2","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6KXEx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_onInp", function() {
    return _onInp;
});
parcelHelpers.export(exports, "_trackINP", function() {
    return _trackINP;
});
parcelHelpers.export(exports, "registerInpInteractionListener", function() {
    return registerInpInteractionListener;
});
parcelHelpers.export(exports, "startTrackingINP", function() {
    return startTrackingINP;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _core = require("@sentry/core");
var _typesJs = require("../types.js");
var _instrumentJs = require("./instrument.js");
var _utilsJs = require("./utils.js");
var LAST_INTERACTIONS = [];
var INTERACTIONS_SPAN_MAP = new Map();
// Map to store element names by timestamp, since we get the DOM event before the PerformanceObserver entry
var ELEMENT_NAME_TIMESTAMP_MAP = new Map();
/**
 * 60 seconds is the maximum for a plausible INP value
 * (source: Me)
 */ var MAX_PLAUSIBLE_INP_DURATION = 60;
/**
 * Start tracking INP webvital events.
 */ function startTrackingINP() {
    var performance = (0, _utilsJs.getBrowserPerformanceAPI)();
    if (performance && (0, _core.browserPerformanceTimeOrigin)()) {
        var inpCallback = _trackINP();
        return function() {
            inpCallback();
        };
    }
    return function() {
        return undefined;
    };
}
var INP_ENTRY_MAP = {
    click: 'click',
    pointerdown: 'click',
    pointerup: 'click',
    mousedown: 'click',
    mouseup: 'click',
    touchstart: 'click',
    touchend: 'click',
    mouseover: 'hover',
    mouseout: 'hover',
    mouseenter: 'hover',
    mouseleave: 'hover',
    pointerover: 'hover',
    pointerout: 'hover',
    pointerenter: 'hover',
    pointerleave: 'hover',
    dragstart: 'drag',
    dragend: 'drag',
    drag: 'drag',
    dragenter: 'drag',
    dragleave: 'drag',
    dragover: 'drag',
    drop: 'drag',
    keydown: 'press',
    keyup: 'press',
    keypress: 'press',
    input: 'press'
};
/** Starts tracking the Interaction to Next Paint on the current page. #
 * exported only for testing
 */ function _trackINP() {
    return (0, _instrumentJs.addInpInstrumentationHandler)(_onInp);
}
/**
 * exported only for testing
 */ var _onInp = function(param) {
    var metric = param.metric;
    if (metric.value == undefined) return;
    var duration = (0, _utilsJs.msToSec)(metric.value);
    // We received occasional reports of hour-long INP values.
    // Therefore, we add a sanity check to avoid creating spans for
    // unrealistically long INP durations.
    if (duration > MAX_PLAUSIBLE_INP_DURATION) return;
    var entry = metric.entries.find(function(entry) {
        return entry.duration === metric.value && INP_ENTRY_MAP[entry.name];
    });
    if (!entry) return;
    var interactionId = entry.interactionId;
    var interactionType = INP_ENTRY_MAP[entry.name];
    /** Build the INP span, create an envelope from the span, and then send the envelope */ var startTime = (0, _utilsJs.msToSec)((0, _core.browserPerformanceTimeOrigin)() + entry.startTime);
    var activeSpan = (0, _core.getActiveSpan)();
    var rootSpan = activeSpan ? (0, _core.getRootSpan)(activeSpan) : undefined;
    // We first try to lookup the interaction context from our INTERACTIONS_SPAN_MAP,
    // where we cache the route and element name per interactionId
    var cachedInteractionContext = interactionId != null ? INTERACTIONS_SPAN_MAP.get(interactionId) : undefined;
    var spanToUse = (cachedInteractionContext === null || cachedInteractionContext === void 0 ? void 0 : cachedInteractionContext.span) || rootSpan;
    // Else, we try to use the active span.
    // Finally, we fall back to look at the transactionName on the scope
    var routeName = spanToUse ? (0, _core.spanToJSON)(spanToUse).description : (0, _core.getCurrentScope)().getScopeData().transactionName;
    var name = (cachedInteractionContext === null || cachedInteractionContext === void 0 ? void 0 : cachedInteractionContext.elementName) || (0, _core.htmlTreeAsString)(entry.target);
    var _obj;
    var attributes = (_obj = {}, (0, _defineProperty._)(_obj, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), 'auto.http.browser.inp'), (0, _defineProperty._)(_obj, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_OP), "ui.interaction.".concat(interactionType)), (0, _defineProperty._)(_obj, (0, _core.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME), entry.duration), _obj);
    var span = (0, _utilsJs.startStandaloneWebVitalSpan)({
        name: name,
        transaction: routeName,
        attributes: attributes,
        startTime: startTime
    });
    if (span) {
        var _obj1;
        span.addEvent('inp', (_obj1 = {}, (0, _defineProperty._)(_obj1, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT), 'millisecond'), (0, _defineProperty._)(_obj1, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE), metric.value), _obj1));
        span.end(startTime + duration);
    }
};
/**
 * Register a listener to cache route information for INP interactions.
 */ function registerInpInteractionListener() {
    // Listen for all interaction events that could contribute to INP
    var interactionEvents = Object.keys(INP_ENTRY_MAP);
    if ((0, _core.isBrowser)()) interactionEvents.forEach(function(eventType) {
        (0, _typesJs.WINDOW).addEventListener(eventType, captureElementFromEvent, {
            capture: true,
            passive: true
        });
    });
    /**
   * Captures the element name from a DOM event and stores it in the ELEMENT_NAME_TIMESTAMP_MAP.
   */ function captureElementFromEvent(event) {
        var target = event.target;
        if (!target) return;
        var elementName = (0, _core.htmlTreeAsString)(target);
        var timestamp = Math.round(event.timeStamp);
        // Store the element name by timestamp so we can match it with the PerformanceEntry
        ELEMENT_NAME_TIMESTAMP_MAP.set(timestamp, elementName);
        // Clean up old
        if (ELEMENT_NAME_TIMESTAMP_MAP.size > 50) {
            var firstKey = ELEMENT_NAME_TIMESTAMP_MAP.keys().next().value;
            if (firstKey !== undefined) ELEMENT_NAME_TIMESTAMP_MAP.delete(firstKey);
        }
    }
    /**
   * Tries to get the element name from the timestamp map.
   */ function resolveElementNameFromEntry(entry) {
        var timestamp = Math.round(entry.startTime);
        var elementName = ELEMENT_NAME_TIMESTAMP_MAP.get(timestamp);
        // try nearby timestamps (±5ms)
        if (!elementName) for(var offset = -5; offset <= 5; offset++){
            var nearbyName = ELEMENT_NAME_TIMESTAMP_MAP.get(timestamp + offset);
            if (nearbyName) {
                elementName = nearbyName;
                break;
            }
        }
        return elementName || '<unknown>';
    }
    var handleEntries = function(param) {
        var entries = param.entries;
        var activeSpan = (0, _core.getActiveSpan)();
        var activeRootSpan = activeSpan && (0, _core.getRootSpan)(activeSpan);
        entries.forEach(function(entry) {
            if (!(0, _instrumentJs.isPerformanceEventTiming)(entry)) return;
            var interactionId = entry.interactionId;
            if (interactionId == null) return;
            // If the interaction was already recorded before, nothing more to do
            if (INTERACTIONS_SPAN_MAP.has(interactionId)) return;
            var elementName = entry.target ? (0, _core.htmlTreeAsString)(entry.target) : resolveElementNameFromEntry(entry);
            // We keep max. 10 interactions in the list, then remove the oldest one & clean up
            if (LAST_INTERACTIONS.length > 10) {
                var last = LAST_INTERACTIONS.shift();
                INTERACTIONS_SPAN_MAP.delete(last);
            }
            // We add the interaction to the list of recorded interactions
            // and store both the span and element name for this interaction
            LAST_INTERACTIONS.push(interactionId);
            INTERACTIONS_SPAN_MAP.set(interactionId, {
                span: activeRootSpan,
                elementName: elementName
            });
        });
    };
    (0, _instrumentJs.addPerformanceInstrumentationHandler)('event', handleEntries);
    (0, _instrumentJs.addPerformanceInstrumentationHandler)('first-input', handleEntries);
}

},{"@swc/helpers/_/_define_property":"e80IS","@sentry/core":"7plmH","../types.js":"5Nyr0","./instrument.js":"5FnSf","./utils.js":"5IDN9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8qS5R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "uiProfiler", function() {
    return uiProfiler;
});
var _core = require("@sentry/core");
var _debugBuildJs = require("../debug-build.js");
/**
 * Starts the Sentry UI profiler.
 * This mode is exclusive with the transaction profiler and will only work if the profilesSampleRate is set to a falsy value.
 * In UI profiling mode, the profiler will keep reporting profile chunks to Sentry until it is stopped, which allows for continuous profiling of the application.
 */ function startProfiler() {
    var client = (0, _core.getClient)();
    if (!client) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).warn('No Sentry client available, profiling is not started');
        return;
    }
    var integration = client.getIntegrationByName('BrowserProfiling');
    if (!integration) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).warn('BrowserProfiling integration is not available');
        return;
    }
    client.emit('startUIProfiler');
}
/**
 * Stops the Sentry UI profiler.
 * Calls to stop will stop the profiler and flush the currently collected profile data to Sentry.
 */ function stopProfiler() {
    var client = (0, _core.getClient)();
    if (!client) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).warn('No Sentry client available, profiling is not started');
        return;
    }
    var integration = client.getIntegrationByName('BrowserProfiling');
    if (!integration) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).warn('ProfilingIntegration is not available');
        return;
    }
    client.emit('stopUIProfiler');
}
/**
 * Profiler namespace for controlling the JS profiler in 'manual' mode.
 *
 * Requires the `browserProfilingIntegration` from the `@sentry/browser` package.
 */ var uiProfiler = {
    startProfiler: startProfiler,
    stopProfiler: stopProfiler
};

},{"@sentry/core":"lqtxA","../debug-build.js":"55n2m","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"55n2m":[function(require,module,exports,__globalThis) {
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEBUG_BUILD", function() {
    return DEBUG_BUILD;
});
var DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"82YO9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "chromeStackLineParser", function() {
    return chromeStackLineParser;
});
parcelHelpers.export(exports, "defaultStackLineParsers", function() {
    return defaultStackLineParsers;
});
parcelHelpers.export(exports, "defaultStackParser", function() {
    return defaultStackParser;
});
parcelHelpers.export(exports, "geckoStackLineParser", function() {
    return geckoStackLineParser;
});
parcelHelpers.export(exports, "opera10StackLineParser", function() {
    return opera10StackLineParser;
});
parcelHelpers.export(exports, "opera11StackLineParser", function() {
    return opera11StackLineParser;
});
parcelHelpers.export(exports, "winjsStackLineParser", function() {
    return winjsStackLineParser;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _core = require("@sentry/core");
var OPERA10_PRIORITY = 10;
var OPERA11_PRIORITY = 20;
var CHROME_PRIORITY = 30;
var WINJS_PRIORITY = 40;
var GECKO_PRIORITY = 50;
function createFrame(filename, func, lineno, colno) {
    var frame = {
        filename: filename,
        function: func === '<anonymous>' ? (0, _core.UNKNOWN_FUNCTION) : func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// This regex matches frames that have no function name (ie. are at the top level of a module).
// For example "at http://localhost:5000//script.js:1:126"
// Frames _with_ function names usually look as follows: "at commitLayoutEffects (react-dom.development.js:23426:1)"
var chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
// This regex matches all the frames that have a function name.
var chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
var chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// Matches stack frames with data URIs instead of filename so we can still get the function name
// Example: "at dynamicFn (data:application/javascript,export function dynamicFn() {..."
var chromeDataUriRegex = /at (.+?) ?\(data:(.+?),/;
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
var chromeStackParserFn = function(line) {
    var dataUriMatch = line.match(chromeDataUriRegex);
    if (dataUriMatch) return {
        filename: "<data:".concat(dataUriMatch[2], ">"),
        function: dataUriMatch[1]
    };
    // If the stack line has no function name, we need to parse it differently
    var noFnParts = chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        var _noFnParts = (0, _slicedToArray._)(noFnParts, 4), filename = _noFnParts[1], _$line = _noFnParts[2], col = _noFnParts[3];
        return createFrame(filename, (0, _core.UNKNOWN_FUNCTION), +_$line, +col);
    }
    var parts = chromeRegex.exec(line);
    if (parts) {
        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            var subMatch = chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        var _extractSafariExtensionDetails = (0, _slicedToArray._)(extractSafariExtensionDetails(parts[1] || (0, _core.UNKNOWN_FUNCTION), parts[2]), 2), func = _extractSafariExtensionDetails[0], filename1 = _extractSafariExtensionDetails[1];
        return createFrame(filename1, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
var chromeStackLineParser = [
    CHROME_PRIORITY,
    chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
var geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
var gecko = function(line) {
    var parts = geckoREgex.exec(line);
    if (parts) {
        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            var subMatch = geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        var filename = parts[3];
        var func = parts[1] || (0, _core.UNKNOWN_FUNCTION);
        var ref;
        ref = (0, _slicedToArray._)(extractSafariExtensionDetails(func, filename), 2), func = ref[0], filename = ref[1], ref;
        return createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
var geckoStackLineParser = [
    GECKO_PRIORITY,
    gecko
];
var winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
var winjs = function(line) {
    var parts = winjsRegex.exec(line);
    return parts ? createFrame(parts[2], parts[1] || (0, _core.UNKNOWN_FUNCTION), +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
var winjsStackLineParser = [
    WINJS_PRIORITY,
    winjs
];
var opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
var opera10 = function(line) {
    var parts = opera10Regex.exec(line);
    return parts ? createFrame(parts[2], parts[3] || (0, _core.UNKNOWN_FUNCTION), +parts[1]) : undefined;
};
var opera10StackLineParser = [
    OPERA10_PRIORITY,
    opera10
];
var opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
var opera11 = function(line) {
    var parts = opera11Regex.exec(line);
    return parts ? createFrame(parts[5], parts[3] || parts[4] || (0, _core.UNKNOWN_FUNCTION), +parts[1], +parts[2]) : undefined;
};
var opera11StackLineParser = [
    OPERA11_PRIORITY,
    opera11
];
var defaultStackLineParsers = [
    chromeStackLineParser,
    geckoStackLineParser
];
var defaultStackParser = (0, _core.createStackParser).apply(void 0, (0, _toConsumableArray._)(defaultStackLineParsers));
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ var extractSafariExtensionDetails = function(func, filename) {
    var isSafariExtension = func.indexOf('safari-extension') !== -1;
    var isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : (0, _core.UNKNOWN_FUNCTION),
        isSafariExtension ? "safari-extension:".concat(filename) : "safari-web-extension:".concat(filename)
    ] : [
        func,
        filename
    ];
};

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_to_consumable_array":"1eSZf","@sentry/core":"lqtxA","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7O5e0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createUserFeedbackEnvelope", function() {
    return createUserFeedbackEnvelope;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _core = require("@sentry/core");
/**
 * Creates an envelope from a user feedback.
 */ function createUserFeedbackEnvelope(feedback, param) {
    var metadata = param.metadata, tunnel = param.tunnel, dsn = param.dsn;
    var headers = (0, _objectSpread._)({
        event_id: feedback.event_id,
        sent_at: new Date().toISOString()
    }, (metadata === null || metadata === void 0 ? void 0 : metadata.sdk) && {
        sdk: {
            name: metadata.sdk.name,
            version: metadata.sdk.version
        }
    }, !!tunnel && !!dsn && {
        dsn: (0, _core.dsnToString)(dsn)
    });
    var item = createUserFeedbackEnvelopeItem(feedback);
    return (0, _core.createEnvelope)(headers, [
        item
    ]);
}
function createUserFeedbackEnvelopeItem(feedback) {
    var feedbackHeaders = {
        type: 'user_report'
    };
    return [
        feedbackHeaders,
        feedback
    ];
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@sentry/core":"lqtxA","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8Y6ls":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "forceLoad", function() {
    return forceLoad;
});
parcelHelpers.export(exports, "getDefaultIntegrations", function() {
    return getDefaultIntegrations;
});
parcelHelpers.export(exports, "init", function() {
    return init;
});
parcelHelpers.export(exports, "onLoad", function() {
    return onLoad;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@sentry/core");
var _clientJs = require("./client.js");
var _breadcrumbsJs = require("./integrations/breadcrumbs.js");
var _browserapierrorsJs = require("./integrations/browserapierrors.js");
var _browsersessionJs = require("./integrations/browsersession.js");
var _globalhandlersJs = require("./integrations/globalhandlers.js");
var _httpcontextJs = require("./integrations/httpcontext.js");
var _linkederrorsJs = require("./integrations/linkederrors.js");
var _spotlightJs = require("./integrations/spotlight.js");
var _stackParsersJs = require("./stack-parsers.js");
var _fetchJs = require("./transports/fetch.js");
var _detectBrowserExtensionJs = require("./utils/detectBrowserExtension.js");
/** Get the default integrations for the browser SDK. */ function getDefaultIntegrations(_options) {
    /**
   * Note: Please make sure this stays in sync with Angular SDK, which re-exports
   * `getDefaultIntegrations` but with an adjusted set of integrations.
   */ return [
        // TODO(v11): Replace with `eventFiltersIntegration` once we remove the deprecated `inboundFiltersIntegration`
        // eslint-disable-next-line deprecation/deprecation
        (0, _core.inboundFiltersIntegration)(),
        (0, _core.functionToStringIntegration)(),
        (0, _browserapierrorsJs.browserApiErrorsIntegration)(),
        (0, _breadcrumbsJs.breadcrumbsIntegration)(),
        (0, _globalhandlersJs.globalHandlersIntegration)(),
        (0, _linkederrorsJs.linkedErrorsIntegration)(),
        (0, _core.dedupeIntegration)(),
        (0, _httpcontextJs.httpContextIntegration)(),
        (0, _browsersessionJs.browserSessionIntegration)()
    ];
}
/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function init() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var shouldDisableBecauseIsBrowserExtenstion = !options.skipBrowserExtensionCheck && (0, _detectBrowserExtensionJs.checkAndWarnIfIsEmbeddedBrowserExtension)();
    var defaultIntegrations = options.defaultIntegrations == null ? getDefaultIntegrations() : options.defaultIntegrations;
    var clientOptions = (0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
        enabled: shouldDisableBecauseIsBrowserExtenstion ? false : options.enabled,
        stackParser: (0, _core.stackParserFromStackParserOptions)(options.stackParser || (0, _stackParsersJs.defaultStackParser)),
        integrations: (0, _core.getIntegrationsToSetup)({
            integrations: options.integrations,
            defaultIntegrations: defaultIntegrations
        }),
        transport: options.transport || (0, _fetchJs.makeFetchTransport)
    });
    return (0, _core.initAndBind)((0, _clientJs.BrowserClient), clientOptions);
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function forceLoad() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function onLoad(callback) {
    callback();
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@sentry/core":"lqtxA","./client.js":"k9FBA","./integrations/breadcrumbs.js":"dGpRx","./integrations/browserapierrors.js":"hsRAR","./integrations/browsersession.js":"80LXs","./integrations/globalhandlers.js":"1Jyt8","./integrations/httpcontext.js":"kBg3j","./integrations/linkederrors.js":"1L5lO","./integrations/spotlight.js":"eCM3r","./stack-parsers.js":"82YO9","./transports/fetch.js":"6NfhH","./utils/detectBrowserExtension.js":"gCD0q","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dGpRx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "breadcrumbsIntegration", function() {
    return breadcrumbsIntegration;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _typeOf = require("@swc/helpers/_/_type_of");
var _core = require("@sentry/core");
var _browserUtils = require("@sentry-internal/browser-utils");
var _debugBuildJs = require("../debug-build.js");
var _helpersJs = require("../helpers.js");
/** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ var MAX_ALLOWED_STRING_LENGTH = 1024;
var INTEGRATION_NAME = 'Breadcrumbs';
var _breadcrumbsIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _options = (0, _objectSpread._)({
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true
    }, options);
    return {
        name: INTEGRATION_NAME,
        setup: function setup(client) {
            // TODO(v11): Remove this functionality and use `consoleIntegration` from @sentry/core instead.
            if (_options.console) (0, _core.addConsoleInstrumentationHandler)(_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, _browserUtils.addClickKeypressInstrumentationHandler)(_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, _browserUtils.addXhrInstrumentationHandler)(_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, _core.addFetchInstrumentationHandler)(_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, _browserUtils.addHistoryInstrumentationHandler)(_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on('beforeSendEvent', _getSentryBreadcrumbHandler(client));
        }
    };
};
var breadcrumbsIntegration = (0, _core.defineIntegration)(_breadcrumbsIntegration);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function _getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, _core.getClient)() !== client) return;
        (0, _core.addBreadcrumb)({
            category: "sentry.".concat(event.type === 'transaction' ? 'transaction' : 'event'),
            event_id: event.event_id,
            level: event.level,
            message: (0, _core.getEventDescription)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creates a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function _getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, _core.getClient)() !== client) return;
        var target;
        var componentName;
        var keyAttrs = (typeof dom === "undefined" ? "undefined" : (0, _typeOf._)(dom)) === 'object' ? dom.serializeAttribute : undefined;
        var maxStringLength = (typeof dom === "undefined" ? "undefined" : (0, _typeOf._)(dom)) === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > MAX_ALLOWED_STRING_LENGTH) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).warn("`dom.maxStringLength` cannot exceed ".concat(MAX_ALLOWED_STRING_LENGTH, ", but a value of ").concat(maxStringLength, " was configured. Sentry will use ").concat(MAX_ALLOWED_STRING_LENGTH, " instead."));
            maxStringLength = MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            var event = handlerData.event;
            var element = _isEvent(event) ? event.target : event;
            target = (0, _core.htmlTreeAsString)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, _core.getComponentName)(element);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        var breadcrumb = {
            category: "ui.".concat(handlerData.name),
            message: target
        };
        if (componentName) breadcrumb.data = {
            'ui.component_name': componentName
        };
        (0, _core.addBreadcrumb)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function _getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, _core.getClient)() !== client) return;
        var breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console'
            },
            level: (0, _core.severityLevelFromString)(handlerData.level),
            message: (0, _core.safeJoin)(handlerData.args, ' ')
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = "Assertion failed: ".concat((0, _core.safeJoin)(handlerData.args.slice(1), ' ') || 'console.assert');
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, _core.addBreadcrumb)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function _getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, _core.getClient)() !== client) return;
        var startTimestamp = handlerData.startTimestamp, endTimestamp = handlerData.endTimestamp;
        var sentryXhrData = handlerData.xhr[0, _browserUtils.SENTRY_XHR_DATA_KEY];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        var method = sentryXhrData.method, url = sentryXhrData.url, status_code = sentryXhrData.status_code, body = sentryXhrData.body;
        var data = {
            method: method,
            url: url,
            status_code: status_code
        };
        var hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        var breadcrumb = {
            category: 'xhr',
            data: data,
            type: 'http',
            level: (0, _core.getBreadcrumbLogLevelFromHttpStatusCode)(status_code)
        };
        client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
        (0, _core.addBreadcrumb)(breadcrumb, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function _getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, _core.getClient)() !== client) return;
        var startTimestamp = handlerData.startTimestamp, endTimestamp = handlerData.endTimestamp;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        handlerData.fetchData.method, handlerData.fetchData.url;
        if (handlerData.error) {
            var data = handlerData.fetchData;
            var hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            var breadcrumb = {
                category: 'fetch',
                data: data,
                level: 'error',
                type: 'http'
            };
            client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
            (0, _core.addBreadcrumb)(breadcrumb, hint);
        } else {
            var response = handlerData.response;
            var data1 = (0, _objectSpreadProps._)((0, _objectSpread._)({}, handlerData.fetchData), {
                status_code: response === null || response === void 0 ? void 0 : response.status
            });
            handlerData.fetchData.request_body_size;
            handlerData.fetchData.response_body_size;
            response === null || response === void 0 ? void 0 : response.status;
            var hint1 = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            var breadcrumb1 = {
                category: 'fetch',
                data: data1,
                type: 'http',
                level: (0, _core.getBreadcrumbLogLevelFromHttpStatusCode)(data1.status_code)
            };
            client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb1, hint1);
            (0, _core.addBreadcrumb)(breadcrumb1, hint1);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function _getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, _core.getClient)() !== client) return;
        var from = handlerData.from;
        var to = handlerData.to;
        var parsedLoc = (0, _core.parseUrl)((0, _helpersJs.WINDOW).location.href);
        var parsedFrom = from ? (0, _core.parseUrl)(from) : undefined;
        var parsedTo = (0, _core.parseUrl)(to);
        // Initial pushState doesn't provide `from` information
        if (!(parsedFrom === null || parsedFrom === void 0 ? void 0 : parsedFrom.path)) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, _core.addBreadcrumb)({
            category: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    };
}
function _isEvent(event) {
    return !!event && !!event.target;
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_type_of":"iFJdx","@sentry/core":"lqtxA","@sentry-internal/browser-utils":"hXSTf","../debug-build.js":"55n2m","../helpers.js":"45G1f","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hsRAR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "browserApiErrorsIntegration", function() {
    return browserApiErrorsIntegration;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _typeOf = require("@swc/helpers/_/_type_of");
var _core = require("@sentry/core");
var _helpersJs = require("../helpers.js");
var DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'BroadcastChannel',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'SharedWorker',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
var INTEGRATION_NAME = 'BrowserApiErrors';
var _browserApiErrorsIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _options = (0, _objectSpread._)({
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        unregisterOriginalCallbacks: false
    }, options);
    return {
        name: INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce: function setupOnce() {
            if (_options.setTimeout) (0, _core.fill)((0, _helpersJs.WINDOW), 'setTimeout', _wrapTimeFunction);
            if (_options.setInterval) (0, _core.fill)((0, _helpersJs.WINDOW), 'setInterval', _wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, _core.fill)((0, _helpersJs.WINDOW), 'requestAnimationFrame', _wrapRAF);
            if (_options.XMLHttpRequest && 'XMLHttpRequest' in (0, _helpersJs.WINDOW)) (0, _core.fill)(XMLHttpRequest.prototype, 'send', _wrapXHR);
            var eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                var eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : DEFAULT_EVENT_TARGET;
                eventTarget.forEach(function(target) {
                    return _wrapEventTarget(target, _options);
                });
            }
        }
    };
};
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 */ var browserApiErrorsIntegration = (0, _core.defineIntegration)(_browserApiErrorsIntegration);
function _wrapTimeFunction(original) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var originalCallback = args[0];
        args[0] = (0, _helpersJs.wrap)(originalCallback, {
            mechanism: {
                handled: false,
                type: "auto.browser.browserapierrors.".concat((0, _core.getFunctionName)(original))
            }
        });
        return original.apply(this, args);
    };
}
function _wrapRAF(original) {
    return function(callback) {
        return original.apply(this, [
            (0, _helpersJs.wrap)(callback, {
                mechanism: {
                    data: {
                        handler: (0, _core.getFunctionName)(original)
                    },
                    handled: false,
                    type: 'auto.browser.browserapierrors.requestAnimationFrame'
                }
            })
        ]);
    };
}
function _wrapXHR(originalSend) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var xhr = this;
        var xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach(function(prop) {
            if (prop in xhr && typeof xhr[prop] === 'function') (0, _core.fill)(xhr, prop, function(original) {
                var wrapOptions = {
                    mechanism: {
                        data: {
                            handler: (0, _core.getFunctionName)(original)
                        },
                        handled: false,
                        type: "auto.browser.browserapierrors.xhr.".concat(prop)
                    }
                };
                // If Instrument integration has been called before BrowserApiErrors, get the name of original function
                var originalFunction = (0, _core.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, _core.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, _helpersJs.wrap)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function _wrapEventTarget(target, integrationOptions) {
    var _globalObject_target, _proto_hasOwnProperty;
    var globalObject = (0, _helpersJs.WINDOW);
    var proto = (_globalObject_target = globalObject[target]) === null || _globalObject_target === void 0 ? void 0 : _globalObject_target.prototype;
    // eslint-disable-next-line no-prototype-builtins
    if (!(proto === null || proto === void 0 ? void 0 : (_proto_hasOwnProperty = proto.hasOwnProperty) === null || _proto_hasOwnProperty === void 0 ? void 0 : _proto_hasOwnProperty.call(proto, 'addEventListener'))) return;
    (0, _core.fill)(proto, 'addEventListener', function(original) {
        return function(eventName, fn, options) {
            try {
                if (isEventListenerObject(fn)) // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, _helpersJs.wrap)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            handler: (0, _core.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'auto.browser.browserapierrors.handleEvent'
                    }
                });
            } catch (e) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            if (integrationOptions.unregisterOriginalCallbacks) unregisterOriginalCallback(this, eventName, fn);
            return original.apply(this, [
                eventName,
                (0, _helpersJs.wrap)(fn, {
                    mechanism: {
                        data: {
                            handler: (0, _core.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'auto.browser.browserapierrors.addEventListener'
                    }
                }),
                options
            ]);
        };
    });
    (0, _core.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            /**
       * There are 2 possible scenarios here:
       *
       * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
       * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
       * as a pass-through, and call original `removeEventListener` with it.
       *
       * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
       * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
       * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
       * in order for us to make a distinction between wrapped/non-wrapped functions possible.
       * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
       *
       * When someone adds a handler prior to initialization, and then do it again, but after,
       * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
       * to get rid of the initial handler and it'd stick there forever.
       */ try {
                var originalEventHandler = fn.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, fn, options);
        };
    });
}
function isEventListenerObject(obj) {
    return typeof obj.handleEvent === 'function';
}
function unregisterOriginalCallback(target, eventName, fn) {
    if (target && (typeof target === "undefined" ? "undefined" : (0, _typeOf._)(target)) === 'object' && 'removeEventListener' in target && typeof target.removeEventListener === 'function') target.removeEventListener(eventName, fn);
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_type_of":"iFJdx","@sentry/core":"lqtxA","../helpers.js":"45G1f","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"80LXs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "browserSessionIntegration", function() {
    return browserSessionIntegration;
});
var _core = require("@sentry/core");
var _browserUtils = require("@sentry-internal/browser-utils");
var _debugBuildJs = require("../debug-build.js");
var _helpersJs = require("../helpers.js");
/**
 * When added, automatically creates sessions which allow you to track adoption and crashes (crash free rate) in your Releases in Sentry.
 * More information: https://docs.sentry.io/product/releases/health/
 *
 * Note: In order for session tracking to work, you need to set up Releases: https://docs.sentry.io/product/releases/
 */ var browserSessionIntegration = (0, _core.defineIntegration)(function() {
    return {
        name: 'BrowserSession',
        setupOnce: function setupOnce() {
            if (typeof (0, _helpersJs.WINDOW).document === 'undefined') {
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).warn('Using the `browserSessionIntegration` in non-browser environments is not supported.');
                return;
            }
            // The session duration for browser sessions does not track a meaningful
            // concept that can be used as a metric.
            // Automatically captured sessions are akin to page views, and thus we
            // discard their duration.
            (0, _core.startSession)({
                ignoreDuration: true
            });
            (0, _core.captureSession)();
            // We want to create a session for every navigation as well
            (0, _browserUtils.addHistoryInstrumentationHandler)(function(param) {
                var from = param.from, to = param.to;
                // Don't create an additional session for the initial route or if the location did not change
                if (from !== undefined && from !== to) {
                    (0, _core.startSession)({
                        ignoreDuration: true
                    });
                    (0, _core.captureSession)();
                }
            });
        }
    };
});

},{"@sentry/core":"lqtxA","@sentry-internal/browser-utils":"hXSTf","../debug-build.js":"55n2m","../helpers.js":"45G1f","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1Jyt8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_eventFromRejectionWithPrimitive", function() {
    return _eventFromRejectionWithPrimitive;
});
parcelHelpers.export(exports, "_getUnhandledRejectionError", function() {
    return _getUnhandledRejectionError;
});
parcelHelpers.export(exports, "globalHandlersIntegration", function() {
    return globalHandlersIntegration;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _core = require("@sentry/core");
var _debugBuildJs = require("../debug-build.js");
var _eventbuilderJs = require("../eventbuilder.js");
var _helpersJs = require("../helpers.js");
var INTEGRATION_NAME = 'GlobalHandlers';
var _globalHandlersIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _options = (0, _objectSpread._)({
        onerror: true,
        onunhandledrejection: true
    }, options);
    return {
        name: INTEGRATION_NAME,
        setupOnce: function setupOnce() {
            Error.stackTraceLimit = 50;
        },
        setup: function setup(client) {
            if (_options.onerror) {
                _installGlobalOnErrorHandler(client);
                globalHandlerLog('onerror');
            }
            if (_options.onunhandledrejection) {
                _installGlobalOnUnhandledRejectionHandler(client);
                globalHandlerLog('onunhandledrejection');
            }
        }
    };
};
var globalHandlersIntegration = (0, _core.defineIntegration)(_globalHandlersIntegration);
function _installGlobalOnErrorHandler(client) {
    (0, _core.addGlobalErrorInstrumentationHandler)(function(data) {
        var _getOptions = getOptions(), stackParser = _getOptions.stackParser, attachStacktrace = _getOptions.attachStacktrace;
        if ((0, _core.getClient)() !== client || (0, _helpersJs.shouldIgnoreOnError)()) return;
        var msg = data.msg, url = data.url, line = data.line, column = data.column, error = data.error;
        var event = _enhanceEventWithInitialFrame((0, _eventbuilderJs.eventFromUnknownInput)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = 'error';
        (0, _core.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'auto.browser.global_handlers.onerror'
            }
        });
    });
}
function _installGlobalOnUnhandledRejectionHandler(client) {
    (0, _core.addGlobalUnhandledRejectionInstrumentationHandler)(function(e) {
        var _getOptions = getOptions(), stackParser = _getOptions.stackParser, attachStacktrace = _getOptions.attachStacktrace;
        if ((0, _core.getClient)() !== client || (0, _helpersJs.shouldIgnoreOnError)()) return;
        var error = _getUnhandledRejectionError(e);
        var event = (0, _core.isPrimitive)(error) ? _eventFromRejectionWithPrimitive(error) : (0, _eventbuilderJs.eventFromUnknownInput)(stackParser, error, undefined, attachStacktrace, true);
        event.level = 'error';
        (0, _core.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'auto.browser.global_handlers.onunhandledrejection'
            }
        });
    });
}
/**
 *
 */ function _getUnhandledRejectionError(error) {
    if ((0, _core.isPrimitive)(error)) return error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in error) return error.reason;
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        if ('detail' in error && 'reason' in error.detail) return error.detail.reason;
    } catch (e) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function _eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: "Non-Error promise rejection captured with value: ".concat(String(reason))
                }
            ]
        }
    };
}
function _enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    var e = event.exception = event.exception || {};
    // event.exception.values
    var ev = e.values = e.values || [];
    // event.exception.values[0]
    var ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    var ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    var ev0sf = ev0s.frames = ev0s.frames || [];
    var colno = column;
    var lineno = line;
    var _getFilenameFromUrl;
    var filename = (_getFilenameFromUrl = getFilenameFromUrl(url)) !== null && _getFilenameFromUrl !== void 0 ? _getFilenameFromUrl : (0, _core.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: (0, _core.UNKNOWN_FUNCTION),
        in_app: true,
        lineno: lineno
    });
    return event;
}
function globalHandlerLog(type) {
    (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).log("Global Handler attached: ".concat(type));
}
function getOptions() {
    var client = (0, _core.getClient)();
    var options = (client === null || client === void 0 ? void 0 : client.getOptions()) || {
        stackParser: function() {
            return [];
        },
        attachStacktrace: false
    };
    return options;
}
function getFilenameFromUrl(url) {
    if (!(0, _core.isString)(url) || url.length === 0) return undefined;
    // stack frame urls can be data urls, for example when initializing a Worker with a base64 encoded script
    // in this case we just show the data prefix and mime type to avoid too long raw data urls
    if (url.startsWith('data:')) {
        var match = url.match(/^data:([^;]+)/);
        var mimeType = match ? match[1] : 'text/javascript';
        var isBase64 = url.includes('base64,');
        return "<data:".concat(mimeType).concat(isBase64 ? ',base64' : '', ">");
    }
    return url; // it's fine to not truncate it as it's not put in a regex (https://codeql.github.com/codeql-query-help/javascript/js-polynomial-redos)
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@sentry/core":"lqtxA","../debug-build.js":"55n2m","../eventbuilder.js":"gS96Q","../helpers.js":"45G1f","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kBg3j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "httpContextIntegration", function() {
    return httpContextIntegration;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@sentry/core");
var _helpersJs = require("../helpers.js");
/**
 * Collects information about HTTP request headers and
 * attaches them to the event.
 */ var httpContextIntegration = (0, _core.defineIntegration)(function() {
    return {
        name: 'HttpContext',
        preprocessEvent: function preprocessEvent(event) {
            var _event_request;
            // if none of the information we want exists, don't bother
            if (!(0, _helpersJs.WINDOW).navigator && !(0, _helpersJs.WINDOW).location && !(0, _helpersJs.WINDOW).document) return;
            var reqData = (0, _helpersJs.getHttpRequestData)();
            var headers = (0, _objectSpread._)({}, reqData.headers, (_event_request = event.request) === null || _event_request === void 0 ? void 0 : _event_request.headers);
            event.request = (0, _objectSpreadProps._)((0, _objectSpread._)({}, reqData, event.request), {
                headers: headers
            });
        }
    };
});

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@sentry/core":"lqtxA","../helpers.js":"45G1f","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1L5lO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "linkedErrorsIntegration", function() {
    return linkedErrorsIntegration;
});
var _core = require("@sentry/core");
var _eventbuilderJs = require("../eventbuilder.js");
var DEFAULT_KEY = 'cause';
var DEFAULT_LIMIT = 5;
var INTEGRATION_NAME = 'LinkedErrors';
var _linkedErrorsIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var limit = options.limit || DEFAULT_LIMIT;
    var key = options.key || DEFAULT_KEY;
    return {
        name: INTEGRATION_NAME,
        preprocessEvent: function preprocessEvent(event, hint, client) {
            var options = client.getOptions();
            (0, _core.applyAggregateErrorsToEvent)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, _eventbuilderJs.exceptionFromError), options.stackParser, key, limit, event, hint);
        }
    };
};
/**
 * Aggregrate linked errors in an event.
 */ var linkedErrorsIntegration = (0, _core.defineIntegration)(_linkedErrorsIntegration);

},{"@sentry/core":"lqtxA","../eventbuilder.js":"gS96Q","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eCM3r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "INTEGRATION_NAME", function() {
    return INTEGRATION_NAME;
});
parcelHelpers.export(exports, "isSpotlightInteraction", function() {
    return isSpotlightInteraction;
});
parcelHelpers.export(exports, "spotlightBrowserIntegration", function() {
    return spotlightBrowserIntegration;
});
var _core = require("@sentry/core");
var _browserUtils = require("@sentry-internal/browser-utils");
var _debugBuildJs = require("../debug-build.js");
var INTEGRATION_NAME = 'SpotlightBrowser';
var _spotlightIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var sidecarUrl = options.sidecarUrl || 'http://localhost:8969/stream';
    return {
        name: INTEGRATION_NAME,
        setup: function() {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).log('Using Sidecar URL', sidecarUrl);
        },
        // We don't want to send interaction transactions/root spans created from
        // clicks within Spotlight to Sentry. Neither do we want them to be sent to
        // spotlight.
        processEvent: function(event) {
            return isSpotlightInteraction(event) ? null : event;
        },
        afterAllSetup: function(client) {
            setupSidecarForwarding(client, sidecarUrl);
        }
    };
};
function setupSidecarForwarding(client, sidecarUrl) {
    var makeFetch = (0, _browserUtils.getNativeImplementation)('fetch');
    var failCount = 0;
    client.on('beforeEnvelope', function(envelope) {
        if (failCount > 3) {
            (0, _core.debug).warn('[Spotlight] Disabled Sentry -> Spotlight integration due to too many failed requests:', failCount);
            return;
        }
        makeFetch(sidecarUrl, {
            method: 'POST',
            body: (0, _core.serializeEnvelope)(envelope),
            headers: {
                'Content-Type': 'application/x-sentry-envelope'
            },
            mode: 'cors'
        }).then(function(res) {
            if (res.status >= 200 && res.status < 400) // Reset failed requests counter on success
            failCount = 0;
        }, function(err) {
            failCount++;
            (0, _core.debug).error("Sentry SDK can't connect to Sidecar is it running? See: https://spotlightjs.com/sidecar/npx/", err);
        });
    });
}
/**
 * Use this integration to send errors and transactions to Spotlight.
 *
 * Learn more about spotlight at https://spotlightjs.com
 */ var spotlightBrowserIntegration = (0, _core.defineIntegration)(_spotlightIntegration);
/**
 * Flags if the event is a transaction created from an interaction with the spotlight UI.
 */ function isSpotlightInteraction(event) {
    var _event_contexts;
    return Boolean(event.type === 'transaction' && event.spans && ((_event_contexts = event.contexts) === null || _event_contexts === void 0 ? void 0 : _event_contexts.trace) && event.contexts.trace.op === 'ui.action.click' && event.spans.some(function(param) {
        var description = param.description;
        return description === null || description === void 0 ? void 0 : description.includes('#sentry-spotlight');
    }));
}

},{"@sentry/core":"lqtxA","@sentry-internal/browser-utils":"hXSTf","../debug-build.js":"55n2m","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gCD0q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "checkAndWarnIfIsEmbeddedBrowserExtension", function() {
    return checkAndWarnIfIsEmbeddedBrowserExtension;
});
var _core = require("@sentry/core");
var _debugBuildJs = require("../debug-build.js");
var _helpersJs = require("../helpers.js");
/**
 * Returns true if the SDK is running in an embedded browser extension.
 * Stand-alone browser extensions (which do not share the same data as the main browser page) are fine.
 */ function checkAndWarnIfIsEmbeddedBrowserExtension() {
    if (_isEmbeddedBrowserExtension()) {
        if (0, _debugBuildJs.DEBUG_BUILD) (0, _core.consoleSandbox)(function() {
            // eslint-disable-next-line no-console
            console.error('[Sentry] You cannot use Sentry.init() in a browser extension, see: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/');
        });
        return true;
    }
    return false;
}
function _isEmbeddedBrowserExtension() {
    var _extensionObject_runtime;
    if (typeof (0, _helpersJs.WINDOW).window === 'undefined') // No need to show the error if we're not in a browser window environment (e.g. service workers)
    return false;
    var _window = (0, _helpersJs.WINDOW);
    // Running the SDK in NW.js, which appears like a browser extension but isn't, is also fine
    // see: https://github.com/getsentry/sentry-javascript/issues/12668
    if (_window.nw) return false;
    var extensionObject = _window['chrome'] || _window['browser'];
    if (!(extensionObject === null || extensionObject === void 0 ? void 0 : (_extensionObject_runtime = extensionObject.runtime) === null || _extensionObject_runtime === void 0 ? void 0 : _extensionObject_runtime.id)) return false;
    var href = (0, _core.getLocationHref)();
    var extensionProtocols = [
        'chrome-extension',
        'moz-extension',
        'ms-browser-extension',
        'safari-web-extension'
    ];
    // Running the SDK in a dedicated extension page and calling Sentry.init is fine; no risk of data leakage
    var isDedicatedExtensionPage = (0, _helpersJs.WINDOW) === (0, _helpersJs.WINDOW).top && extensionProtocols.some(function(protocol) {
        return href.startsWith("".concat(protocol, "://"));
    });
    return !isDedicatedExtensionPage;
}

},{"@sentry/core":"lqtxA","../debug-build.js":"55n2m","../helpers.js":"45G1f","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1iWb1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "showReportDialog", function() {
    return showReportDialog;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@sentry/core");
var _debugBuildJs = require("./debug-build.js");
var _helpersJs = require("./helpers.js");
/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the current scope.
 */ function showReportDialog() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var optionalDocument = (0, _helpersJs.WINDOW).document;
    var injectionPoint = (optionalDocument === null || optionalDocument === void 0 ? void 0 : optionalDocument.head) || (optionalDocument === null || optionalDocument === void 0 ? void 0 : optionalDocument.body);
    // doesn't work without a document (React Native)
    if (!injectionPoint) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).error('[showReportDialog] Global document not defined');
        return;
    }
    var scope = (0, _core.getCurrentScope)();
    var client = (0, _core.getClient)();
    var dsn = client === null || client === void 0 ? void 0 : client.getDsn();
    if (!dsn) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).error('[showReportDialog] DSN not configured');
        return;
    }
    var mergedOptions = (0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
        user: (0, _objectSpread._)({}, scope.getUser(), options.user),
        eventId: options.eventId || (0, _core.lastEventId)()
    });
    var script = (0, _helpersJs.WINDOW).document.createElement('script');
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = (0, _core.getReportDialogEndpoint)(dsn, mergedOptions);
    var onLoad = mergedOptions.onLoad, onClose = mergedOptions.onClose;
    if (onLoad) script.onload = onLoad;
    if (onClose) {
        var reportDialogClosedMessageHandler = function(event) {
            if (event.data === '__sentry_reportdialog_closed__') try {
                onClose();
            } finally{
                (0, _helpersJs.WINDOW).removeEventListener('message', reportDialogClosedMessageHandler);
            }
        };
        (0, _helpersJs.WINDOW).addEventListener('message', reportDialogClosedMessageHandler);
    }
    injectionPoint.appendChild(script);
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@sentry/core":"lqtxA","./debug-build.js":"55n2m","./helpers.js":"45G1f","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lITBT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reportingObserverIntegration", function() {
    return reportingObserverIntegration;
});
var _core = require("@sentry/core");
var WINDOW = (0, _core.GLOBAL_OBJ);
var INTEGRATION_NAME = 'ReportingObserver';
var SETUP_CLIENTS = new WeakMap();
var _reportingObserverIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var types = options.types || [
        'crash',
        'deprecation',
        'intervention'
    ];
    /** Handler for the reporting observer. */ function handler(reports) {
        if (!SETUP_CLIENTS.has((0, _core.getClient)())) return;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var report = _step.value;
                (0, _core.withScope)(function(scope) {
                    scope.setExtra('url', report.url);
                    var label = "ReportingObserver [".concat(report.type, "]");
                    var details = 'No details available';
                    if (report.body) {
                        // Object.keys doesn't work on ReportBody, as all properties are inherited
                        var plainBody = {};
                        // eslint-disable-next-line guard-for-in
                        for(var prop in report.body)plainBody[prop] = report.body[prop];
                        scope.setExtra('body', plainBody);
                        if (report.type === 'crash') {
                            var body = report.body;
                            // A fancy way to create a message out of crashId OR reason OR both OR fallback
                            details = [
                                body.crashId || '',
                                body.reason || ''
                            ].join(' ').trim() || details;
                        } else {
                            var body1 = report.body;
                            details = body1.message || details;
                        }
                    }
                    (0, _core.captureMessage)("".concat(label, ": ").concat(details));
                });
            };
            for(var _iterator = reports[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return {
        name: INTEGRATION_NAME,
        setupOnce: function setupOnce() {
            if (!(0, _core.supportsReportingObserver)()) return;
            var observer = new WINDOW.ReportingObserver(handler, {
                buffered: true,
                types: types
            });
            observer.observe();
        },
        setup: function setup(client) {
            SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Reporting API integration - https://w3c.github.io/reporting/
 */ var reportingObserverIntegration = (0, _core.defineIntegration)(_reportingObserverIntegration);

},{"@sentry/core":"lqtxA","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iYWTa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "httpClientIntegration", function() {
    return httpClientIntegration;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _core = require("@sentry/core");
var _browserUtils = require("@sentry-internal/browser-utils");
var _debugBuildJs = require("../debug-build.js");
var INTEGRATION_NAME = 'HttpClient';
var _httpClientIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _options = (0, _objectSpread._)({
        failedRequestStatusCodes: [
            [
                500,
                599
            ]
        ],
        failedRequestTargets: [
            /.*/
        ]
    }, options);
    return {
        name: INTEGRATION_NAME,
        setup: function setup(client) {
            _wrapFetch(client, _options);
            _wrapXHR(client, _options);
        }
    };
};
/**
 * Create events for failed client side HTTP requests.
 */ var httpClientIntegration = (0, _core.defineIntegration)(_httpClientIntegration);
/**
 * Interceptor function for fetch requests
 *
 * @param requestInfo The Fetch API request info
 * @param response The Fetch API response
 * @param requestInit The request init object
 */ function _fetchResponseHandler(options, requestInfo, response, requestInit, error) {
    if (_shouldCaptureResponse(options, response.status, response.url)) {
        var request = _getRequest(requestInfo, requestInit);
        var requestHeaders, responseHeaders, requestCookies, responseCookies;
        if (_shouldSendDefaultPii()) {
            var ref;
            ref = (0, _slicedToArray._)(_parseCookieHeaders('Cookie', request), 2), requestHeaders = ref[0], requestCookies = ref[1], ref;
            var ref1;
            ref1 = (0, _slicedToArray._)(_parseCookieHeaders('Set-Cookie', response), 2), responseHeaders = ref1[0], responseCookies = ref1[1], ref1;
        }
        var event = _createEvent({
            url: request.url,
            method: request.method,
            status: response.status,
            requestHeaders: requestHeaders,
            responseHeaders: responseHeaders,
            requestCookies: requestCookies,
            responseCookies: responseCookies,
            error: error,
            type: 'fetch'
        });
        (0, _core.captureEvent)(event);
    }
}
function _parseCookieHeaders(cookieHeader, obj) {
    var headers = _extractFetchHeaders(obj.headers);
    var cookies;
    try {
        var cookieString = headers[cookieHeader] || headers[cookieHeader.toLowerCase()] || undefined;
        if (cookieString) cookies = _parseCookieString(cookieString);
    } catch (e) {
    // ignore it if parsing fails
    }
    return [
        headers,
        cookies
    ];
}
/**
 * Interceptor function for XHR requests
 *
 * @param xhr The XHR request
 * @param method The HTTP method
 * @param headers The HTTP headers
 */ function _xhrResponseHandler(options, xhr, method, headers, error) {
    if (_shouldCaptureResponse(options, xhr.status, xhr.responseURL)) {
        var requestHeaders, responseCookies, responseHeaders;
        if (_shouldSendDefaultPii()) {
            try {
                var cookieString = xhr.getResponseHeader('Set-Cookie') || xhr.getResponseHeader('set-cookie') || undefined;
                if (cookieString) responseCookies = _parseCookieString(cookieString);
            } catch (e) {
            // ignore it if parsing fails
            }
            try {
                responseHeaders = _getXHRResponseHeaders(xhr);
            } catch (e) {
            // ignore it if parsing fails
            }
            requestHeaders = headers;
        }
        var event = _createEvent({
            url: xhr.responseURL,
            method: method,
            status: xhr.status,
            requestHeaders: requestHeaders,
            // Can't access request cookies from XHR
            responseHeaders: responseHeaders,
            responseCookies: responseCookies,
            error: error,
            type: 'xhr'
        });
        (0, _core.captureEvent)(event);
    }
}
/**
 * Extracts response size from `Content-Length` header when possible
 *
 * @param headers
 * @returns The response size in bytes or undefined
 */ function _getResponseSizeFromHeaders(headers) {
    if (headers) {
        var contentLength = headers['Content-Length'] || headers['content-length'];
        if (contentLength) return parseInt(contentLength, 10);
    }
    return undefined;
}
/**
 * Creates an object containing cookies from the given cookie string
 *
 * @param cookieString The cookie string to parse
 * @returns The parsed cookies
 */ function _parseCookieString(cookieString) {
    return cookieString.split('; ').reduce(function(acc, cookie) {
        var _cookie_split = (0, _slicedToArray._)(cookie.split('='), 2), key = _cookie_split[0], value = _cookie_split[1];
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Extracts the headers as an object from the given Fetch API request or response object
 *
 * @param headers The headers to extract
 * @returns The extracted headers as an object
 */ function _extractFetchHeaders(headers) {
    var result = {};
    headers.forEach(function(value, key) {
        result[key] = value;
    });
    return result;
}
/**
 * Extracts the response headers as an object from the given XHR object
 *
 * @param xhr The XHR object to extract the response headers from
 * @returns The response headers as an object
 */ function _getXHRResponseHeaders(xhr) {
    var headers = xhr.getAllResponseHeaders();
    if (!headers) return {};
    return headers.split('\r\n').reduce(function(acc, line) {
        var _line_split = (0, _slicedToArray._)(line.split(': '), 2), key = _line_split[0], value = _line_split[1];
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Checks if the given target url is in the given list of targets
 *
 * @param target The target url to check
 * @returns true if the target url is in the given list of targets, false otherwise
 */ function _isInGivenRequestTargets(failedRequestTargets, target) {
    return failedRequestTargets.some(function(givenRequestTarget) {
        if (typeof givenRequestTarget === 'string') return target.includes(givenRequestTarget);
        return givenRequestTarget.test(target);
    });
}
/**
 * Checks if the given status code is in the given range
 *
 * @param status The status code to check
 * @returns true if the status code is in the given range, false otherwise
 */ function _isInGivenStatusRanges(failedRequestStatusCodes, status) {
    return failedRequestStatusCodes.some(function(range) {
        if (typeof range === 'number') return range === status;
        return status >= range[0] && status <= range[1];
    });
}
/**
 * Wraps `fetch` function to capture request and response data
 */ function _wrapFetch(client, options) {
    if (!(0, _core.supportsNativeFetch)()) return;
    (0, _core.addFetchInstrumentationHandler)(function(handlerData) {
        if ((0, _core.getClient)() !== client) return;
        var response = handlerData.response, args = handlerData.args, error = handlerData.error, virtualError = handlerData.virtualError;
        var _args = (0, _slicedToArray._)(args, 2), requestInfo = _args[0], requestInit = _args[1];
        if (!response) return;
        _fetchResponseHandler(options, requestInfo, response, requestInit, error || virtualError);
    }, false);
}
/**
 * Wraps XMLHttpRequest to capture request and response data
 */ function _wrapXHR(client, options) {
    if (!('XMLHttpRequest' in (0, _core.GLOBAL_OBJ))) return;
    (0, _browserUtils.addXhrInstrumentationHandler)(function(handlerData) {
        if ((0, _core.getClient)() !== client) return;
        var error = handlerData.error, virtualError = handlerData.virtualError;
        var xhr = handlerData.xhr;
        var sentryXhrData = xhr[0, _browserUtils.SENTRY_XHR_DATA_KEY];
        if (!sentryXhrData) return;
        var method = sentryXhrData.method, headers = sentryXhrData.request_headers;
        try {
            _xhrResponseHandler(options, xhr, method, headers, error || virtualError);
        } catch (e) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).warn('Error while extracting response event form XHR response', e);
        }
    });
}
/**
 * Checks whether to capture given response as an event
 *
 * @param status response status code
 * @param url response url
 */ function _shouldCaptureResponse(options, status, url) {
    return _isInGivenStatusRanges(options.failedRequestStatusCodes, status) && _isInGivenRequestTargets(options.failedRequestTargets, url) && !(0, _core.isSentryRequestUrl)(url, (0, _core.getClient)());
}
/**
 * Creates a synthetic Sentry event from given response data
 *
 * @param data response data
 * @returns event
 */ function _createEvent(data) {
    var client = (0, _core.getClient)();
    var virtualStackTrace = client && data.error && (0, _instanceof._)(data.error, Error) ? data.error.stack : undefined;
    // Remove the first frame from the stack as it's the HttpClient call
    var stack = virtualStackTrace && client ? client.getOptions().stackParser(virtualStackTrace, 0, 1) : undefined;
    var message = "HTTP Client Error with status code: ".concat(data.status);
    var event = {
        message: message,
        exception: {
            values: [
                {
                    type: 'Error',
                    value: message,
                    stacktrace: stack ? {
                        frames: stack
                    } : undefined
                }
            ]
        },
        request: {
            url: data.url,
            method: data.method,
            headers: data.requestHeaders,
            cookies: data.requestCookies
        },
        contexts: {
            response: {
                status_code: data.status,
                headers: data.responseHeaders,
                cookies: data.responseCookies,
                body_size: _getResponseSizeFromHeaders(data.responseHeaders)
            }
        }
    };
    (0, _core.addExceptionMechanism)(event, {
        type: "auto.http.client.".concat(data.type),
        handled: false
    });
    return event;
}
function _getRequest(requestInfo, requestInit) {
    if (!requestInit && (0, _instanceof._)(requestInfo, Request)) return requestInfo;
    // If both are set, we try to construct a new Request with the given arguments
    // However, if e.g. the original request has a `body`, this will throw an error because it was already accessed
    // In this case, as a fallback, we just use the original request - using both is rather an edge case
    if ((0, _instanceof._)(requestInfo, Request) && requestInfo.bodyUsed) return requestInfo;
    return new Request(requestInfo, requestInit);
}
function _shouldSendDefaultPii() {
    var client = (0, _core.getClient)();
    return client ? Boolean(client.getOptions().sendDefaultPii) : false;
}

},{"@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_sliced_to_array":"8PtL6","@sentry/core":"lqtxA","@sentry-internal/browser-utils":"hXSTf","../debug-build.js":"55n2m","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aTnWH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applySourceContextToFrame", function() {
    return applySourceContextToFrame;
});
parcelHelpers.export(exports, "contextLinesIntegration", function() {
    return contextLinesIntegration;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _core = require("@sentry/core");
var WINDOW = (0, _core.GLOBAL_OBJ);
var DEFAULT_LINES_OF_CONTEXT = 7;
var INTEGRATION_NAME = 'ContextLines';
var _contextLinesIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var contextLines = options.frameContextLines != null ? options.frameContextLines : DEFAULT_LINES_OF_CONTEXT;
    return {
        name: INTEGRATION_NAME,
        processEvent: function processEvent(event) {
            return addSourceContext(event, contextLines);
        }
    };
};
/**
 * Collects source context lines around the lines of stackframes pointing to JS embedded in
 * the current page's HTML.
 *
 * This integration DOES NOT work for stack frames pointing to JS files that are loaded by the browser.
 * For frames pointing to files, context lines are added during ingestion and symbolication
 * by attempting to download the JS files to the Sentry backend.
 *
 * Use this integration if you have inline JS code in HTML pages that can't be accessed
 * by our backend (e.g. due to a login-protected page).
 */ var contextLinesIntegration = (0, _core.defineIntegration)(_contextLinesIntegration);
/**
 * Processes an event and adds context lines.
 */ function addSourceContext(event, contextLines) {
    var _event_exception;
    var doc = WINDOW.document;
    var htmlFilename = WINDOW.location && (0, _core.stripUrlQueryAndFragment)(WINDOW.location.href);
    if (!doc || !htmlFilename) return event;
    var exceptions = (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : _event_exception.values;
    if (!(exceptions === null || exceptions === void 0 ? void 0 : exceptions.length)) return event;
    var html = doc.documentElement.innerHTML;
    if (!html) return event;
    var htmlLines = [
        '<!DOCTYPE html>',
        '<html>'
    ].concat((0, _toConsumableArray._)(html.split('\n')), [
        '</html>'
    ]);
    exceptions.forEach(function(exception) {
        var stacktrace = exception.stacktrace;
        if (stacktrace === null || stacktrace === void 0 ? void 0 : stacktrace.frames) stacktrace.frames = stacktrace.frames.map(function(frame) {
            return applySourceContextToFrame(frame, htmlLines, htmlFilename, contextLines);
        });
    });
    return event;
}
/**
 * Only exported for testing
 */ function applySourceContextToFrame(frame, htmlLines, htmlFilename, linesOfContext) {
    if (frame.filename !== htmlFilename || !frame.lineno || !htmlLines.length) return frame;
    (0, _core.addContextToFrame)(htmlLines, frame, linesOfContext);
    return frame;
}

},{"@swc/helpers/_/_to_consumable_array":"1eSZf","@sentry/core":"lqtxA","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3DhuF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getGraphQLRequestPayload", function() {
    return getGraphQLRequestPayload;
});
parcelHelpers.export(exports, "getRequestPayloadXhrOrFetch", function() {
    return getRequestPayloadXhrOrFetch;
});
parcelHelpers.export(exports, "graphqlClientIntegration", function() {
    return graphqlClientIntegration;
});
parcelHelpers.export(exports, "parseGraphQLQuery", function() {
    return parseGraphQLQuery;
});
var _core = require("@sentry/core");
var _browserUtils = require("@sentry-internal/browser-utils");
var INTEGRATION_NAME = 'GraphQLClient';
var _graphqlClientIntegration = function(options) {
    return {
        name: INTEGRATION_NAME,
        setup: function setup(client) {
            _updateSpanWithGraphQLData(client, options);
            _updateBreadcrumbWithGraphQLData(client, options);
        }
    };
};
function _updateSpanWithGraphQLData(client, options) {
    client.on('beforeOutgoingRequestSpan', function(span, hint) {
        var spanJSON = (0, _core.spanToJSON)(span);
        var spanAttributes = spanJSON.data || {};
        var spanOp = spanAttributes[0, _core.SEMANTIC_ATTRIBUTE_SENTRY_OP];
        var isHttpClientSpan = spanOp === 'http.client';
        if (!isHttpClientSpan) return;
        var httpUrl = spanAttributes[0, _core.SEMANTIC_ATTRIBUTE_URL_FULL] || spanAttributes['http.url'];
        var httpMethod = spanAttributes[0, _core.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD] || spanAttributes['http.method'];
        if (!(0, _core.isString)(httpUrl) || !(0, _core.isString)(httpMethod)) return;
        var endpoints = options.endpoints;
        var isTracedGraphqlEndpoint = (0, _core.stringMatchesSomePattern)(httpUrl, endpoints);
        var payload = getRequestPayloadXhrOrFetch(hint);
        if (isTracedGraphqlEndpoint && payload) {
            var graphqlBody = getGraphQLRequestPayload(payload);
            if (graphqlBody) {
                var operationInfo = _getGraphQLOperation(graphqlBody);
                span.updateName("".concat(httpMethod, " ").concat(httpUrl, " (").concat(operationInfo, ")"));
                span.setAttribute('graphql.document', payload);
            }
        }
    });
}
function _updateBreadcrumbWithGraphQLData(client, options) {
    client.on('beforeOutgoingRequestBreadcrumb', function(breadcrumb, handlerData) {
        var category = breadcrumb.category, type = breadcrumb.type, data = breadcrumb.data;
        var isFetch = category === 'fetch';
        var isXhr = category === 'xhr';
        var isHttpBreadcrumb = type === 'http';
        if (isHttpBreadcrumb && (isFetch || isXhr)) {
            var httpUrl = data === null || data === void 0 ? void 0 : data.url;
            var endpoints = options.endpoints;
            var isTracedGraphqlEndpoint = (0, _core.stringMatchesSomePattern)(httpUrl, endpoints);
            var payload = getRequestPayloadXhrOrFetch(handlerData);
            if (isTracedGraphqlEndpoint && data && payload) {
                var graphqlBody = getGraphQLRequestPayload(payload);
                if (!data.graphql && graphqlBody) {
                    var operationInfo = _getGraphQLOperation(graphqlBody);
                    data['graphql.document'] = graphqlBody.query;
                    data['graphql.operation'] = operationInfo;
                }
            }
        }
    });
}
/**
 * @param requestBody - GraphQL request
 * @returns A formatted version of the request: 'TYPE NAME' or 'TYPE'
 */ function _getGraphQLOperation(requestBody) {
    var graphqlQuery = requestBody.query, graphqlOperationName = requestBody.operationName;
    var _parseGraphQLQuery = parseGraphQLQuery(graphqlQuery), _parseGraphQLQuery_operationName = _parseGraphQLQuery.operationName, operationName = _parseGraphQLQuery_operationName === void 0 ? graphqlOperationName : _parseGraphQLQuery_operationName, operationType = _parseGraphQLQuery.operationType;
    var operationInfo = operationName ? "".concat(operationType, " ").concat(operationName) : "".concat(operationType);
    return operationInfo;
}
/**
 * Get the request body/payload based on the shape of the hint.
 *
 * Exported for tests only.
 */ function getRequestPayloadXhrOrFetch(hint) {
    var isXhr = 'xhr' in hint;
    var body;
    if (isXhr) {
        var sentryXhrData = hint.xhr[0, _browserUtils.SENTRY_XHR_DATA_KEY];
        body = sentryXhrData && (0, _browserUtils.getBodyString)(sentryXhrData.body)[0];
    } else {
        var sentryFetchData = (0, _browserUtils.getFetchRequestArgBody)(hint.input);
        body = (0, _browserUtils.getBodyString)(sentryFetchData)[0];
    }
    return body;
}
/**
 * Extract the name and type of the operation from the GraphQL query.
 *
 * Exported for tests only.
 */ function parseGraphQLQuery(query) {
    var namedQueryRe = /^(?:\s*)(query|mutation|subscription)(?:\s*)(\w+)(?:\s*)[{(]/;
    var unnamedQueryRe = /^(?:\s*)(query|mutation|subscription)(?:\s*)[{(]/;
    var namedMatch = query.match(namedQueryRe);
    if (namedMatch) return {
        operationType: namedMatch[1],
        operationName: namedMatch[2]
    };
    var unnamedMatch = query.match(unnamedQueryRe);
    if (unnamedMatch) return {
        operationType: unnamedMatch[1],
        operationName: undefined
    };
    return {
        operationType: undefined,
        operationName: undefined
    };
}
/**
 * Extract the payload of a request if it's GraphQL.
 * Exported for tests only.
 * @param payload - A valid JSON string
 * @returns A POJO or undefined
 */ function getGraphQLRequestPayload(payload) {
    var graphqlBody = undefined;
    try {
        var requestBody = JSON.parse(payload);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        var isGraphQLRequest = !!requestBody['query'];
        if (isGraphQLRequest) graphqlBody = requestBody;
    } finally{
        // Fallback to undefined if payload is an invalid JSON (SyntaxError)
        /* eslint-disable no-unsafe-finally */ return graphqlBody;
    }
}
/**
 * This integration ensures that GraphQL requests made in the browser
 * have their GraphQL-specific data captured and attached to spans and breadcrumbs.
 */ var graphqlClientIntegration = (0, _core.defineIntegration)(_graphqlClientIntegration);

},{"@sentry/core":"lqtxA","@sentry-internal/browser-utils":"hXSTf","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eIDrB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getReplay", function() {
    return getReplay;
});
parcelHelpers.export(exports, "replayIntegration", function() {
    return replayIntegration;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var _wrapNativeSuper = require("@swc/helpers/_/_wrap_native_super");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _core = require("@sentry/core");
var _browserUtils = require("@sentry-internal/browser-utils");
// exporting a separate copy of `WINDOW` rather than exporting the one from `@sentry/browser`
// prevents the browser package from being bundled in the CDN bundle, and avoids a
// circular dependency between the browser and replay packages should `@sentry/browser` import
// from `@sentry/replay` in the future
var WINDOW = (0, _core.GLOBAL_OBJ);
var REPLAY_SESSION_KEY = 'sentryReplaySession';
var REPLAY_EVENT_NAME = 'replay_event';
var UNABLE_TO_SEND_REPLAY = 'Unable to send Replay';
// The idle limit for a session after which recording is paused.
var SESSION_IDLE_PAUSE_DURATION = 300000; // 5 minutes in ms
// The idle limit for a session after which the session expires.
var SESSION_IDLE_EXPIRE_DURATION = 900000; // 15 minutes in ms
/** Default flush delays */ var DEFAULT_FLUSH_MIN_DELAY = 5000;
// XXX: Temp fix for our debounce logic where `maxWait` would never occur if it
// was the same as `wait`
var DEFAULT_FLUSH_MAX_DELAY = 5500;
/* How long to wait for error checkouts */ var BUFFER_CHECKOUT_TIME = 60000;
var RETRY_BASE_INTERVAL = 5000;
var RETRY_MAX_COUNT = 3;
/* The max (uncompressed) size in bytes of a network body. Any body larger than this will be truncated. */ var NETWORK_BODY_MAX_SIZE = 150000;
/* The max size of a single console arg that is captured. Any arg larger than this will be truncated. */ var CONSOLE_ARG_MAX_SIZE = 5000;
/* Min. time to wait before we consider something a slow click. */ var SLOW_CLICK_THRESHOLD = 3000;
/* For scroll actions after a click, we only look for a very short time period to detect programmatic scrolling. */ var SLOW_CLICK_SCROLL_TIMEOUT = 300;
/** When encountering a total segment size exceeding this size, stop the replay (as we cannot properly ingest it). */ var REPLAY_MAX_EVENT_BUFFER_SIZE = 20000000; // ~20MB
/** Replays must be min. 5s long before we send them. */ var MIN_REPLAY_DURATION = 4999;
/*
The max. allowed value that the minReplayDuration can be set to.
This needs to be below 60s, so we don't unintentionally drop buffered replays that are longer than 60s.
*/ var MIN_REPLAY_DURATION_LIMIT = 50000;
/** The max. length of a replay. */ var MAX_REPLAY_DURATION = 3600000; // 60 minutes in ms;
var __defProp$1 = Object.defineProperty;
var __defNormalProp$1 = function(obj, key, value) {
    return key in obj ? __defProp$1(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var __publicField$1 = function(obj, key, value) {
    return __defNormalProp$1(obj, (typeof key === "undefined" ? "undefined" : (0, _typeOf._)(key)) !== "symbol" ? key + "" : key, value);
};
var NodeType$2 = /* @__PURE__ */ function(NodeType2) {
    NodeType2[NodeType2["Document"] = 0] = "Document";
    NodeType2[NodeType2["DocumentType"] = 1] = "DocumentType";
    NodeType2[NodeType2["Element"] = 2] = "Element";
    NodeType2[NodeType2["Text"] = 3] = "Text";
    NodeType2[NodeType2["CDATA"] = 4] = "CDATA";
    NodeType2[NodeType2["Comment"] = 5] = "Comment";
    return NodeType2;
}(NodeType$2 || {});
function isElement$1(n2) {
    return n2.nodeType === n2.ELEMENT_NODE;
}
function isShadowRoot(n2) {
    var host = n2 === null || n2 === void 0 ? void 0 : n2.host;
    return Boolean((host === null || host === void 0 ? void 0 : host.shadowRoot) === n2);
}
function isNativeShadowDom(shadowRoot) {
    return Object.prototype.toString.call(shadowRoot) === "[object ShadowRoot]";
}
function fixBrowserCompatibilityIssuesInCSS(cssText) {
    if (cssText.includes(" background-clip: text;") && !cssText.includes(" -webkit-background-clip: text;")) cssText = cssText.replace(/\sbackground-clip:\s*text;/g, " -webkit-background-clip: text; background-clip: text;");
    return cssText;
}
function escapeImportStatement(rule) {
    var cssText = rule.cssText;
    if (cssText.split('"').length < 3) return cssText;
    var statement = [
        "@import",
        "url(".concat(JSON.stringify(rule.href), ")")
    ];
    if (rule.layerName === "") statement.push("layer");
    else if (rule.layerName) statement.push("layer(".concat(rule.layerName, ")"));
    if (rule.supportsText) statement.push("supports(".concat(rule.supportsText, ")"));
    if (rule.media.length) statement.push(rule.media.mediaText);
    return statement.join(" ") + ";";
}
function stringifyStylesheet(s2) {
    try {
        var rules2 = s2.rules || s2.cssRules;
        return rules2 ? fixBrowserCompatibilityIssuesInCSS(Array.from(rules2, stringifyRule).join("")) : null;
    } catch (error) {
        return null;
    }
}
function fixAllCssProperty(rule) {
    var styles = "";
    for(var i2 = 0; i2 < rule.style.length; i2++){
        var styleDeclaration = rule.style;
        var attribute = styleDeclaration[i2];
        var isImportant = styleDeclaration.getPropertyPriority(attribute);
        styles += "".concat(attribute, ":").concat(styleDeclaration.getPropertyValue(attribute)).concat(isImportant ? " !important" : "", ";");
    }
    return "".concat(rule.selectorText, " { ").concat(styles, " }");
}
function stringifyRule(rule) {
    var importStringified;
    if (isCSSImportRule(rule)) try {
        importStringified = // we can access the imported stylesheet rules directly
        stringifyStylesheet(rule.styleSheet) || // work around browser issues with the raw string `@import url(...)` statement
        escapeImportStatement(rule);
    } catch (error) {}
    else if (isCSSStyleRule(rule)) {
        var cssText = rule.cssText;
        var needsSafariColonFix = rule.selectorText.includes(":");
        var needsAllFix = typeof rule.style["all"] === "string" && rule.style["all"];
        if (needsAllFix) cssText = fixAllCssProperty(rule);
        if (needsSafariColonFix) cssText = fixSafariColons(cssText);
        if (needsSafariColonFix || needsAllFix) return cssText;
    }
    return importStringified || rule.cssText;
}
function fixSafariColons(cssStringified) {
    var regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
    return cssStringified.replace(regex, "$1\\$2");
}
function isCSSImportRule(rule) {
    return "styleSheet" in rule;
}
function isCSSStyleRule(rule) {
    return "selectorText" in rule;
}
var Mirror = /*#__PURE__*/ function() {
    "use strict";
    function Mirror() {
        (0, _classCallCheck._)(this, Mirror);
        __publicField$1(this, "idNodeMap", /* @__PURE__ */ new Map());
        __publicField$1(this, "nodeMetaMap", /* @__PURE__ */ new WeakMap());
    }
    (0, _createClass._)(Mirror, [
        {
            key: "getId",
            value: function getId(n2) {
                var _this_getMeta;
                if (!n2) return -1;
                var id = (_this_getMeta = this.getMeta(n2)) === null || _this_getMeta === void 0 ? void 0 : _this_getMeta.id;
                return id !== null && id !== void 0 ? id : -1;
            }
        },
        {
            key: "getNode",
            value: function getNode(id) {
                return this.idNodeMap.get(id) || null;
            }
        },
        {
            key: "getIds",
            value: function getIds() {
                return Array.from(this.idNodeMap.keys());
            }
        },
        {
            key: "getMeta",
            value: function getMeta(n2) {
                return this.nodeMetaMap.get(n2) || null;
            }
        },
        {
            // removes the node from idNodeMap
            // doesn't remove the node from nodeMetaMap
            key: "removeNodeFromMap",
            value: function removeNodeFromMap(n2) {
                var _this = this;
                var id = this.getId(n2);
                this.idNodeMap.delete(id);
                if (n2.childNodes) n2.childNodes.forEach(function(childNode) {
                    return _this.removeNodeFromMap(childNode);
                });
            }
        },
        {
            key: "has",
            value: function has(id) {
                return this.idNodeMap.has(id);
            }
        },
        {
            key: "hasNode",
            value: function hasNode(node) {
                return this.nodeMetaMap.has(node);
            }
        },
        {
            key: "add",
            value: function add(n2, meta) {
                var id = meta.id;
                this.idNodeMap.set(id, n2);
                this.nodeMetaMap.set(n2, meta);
            }
        },
        {
            key: "replace",
            value: function replace(id, n2) {
                var oldNode = this.getNode(id);
                if (oldNode) {
                    var meta = this.nodeMetaMap.get(oldNode);
                    if (meta) this.nodeMetaMap.set(n2, meta);
                }
                this.idNodeMap.set(id, n2);
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.idNodeMap = /* @__PURE__ */ new Map();
                this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
            }
        }
    ]);
    return Mirror;
}();
function createMirror$2() {
    return new Mirror();
}
function shouldMaskInput(param) {
    var maskInputOptions = param.maskInputOptions, tagName = param.tagName, type = param.type;
    if (tagName === "OPTION") tagName = "SELECT";
    return Boolean(maskInputOptions[tagName.toLowerCase()] || type && maskInputOptions[type] || type === "password" || // Default to "text" option for inputs without a "type" attribute defined
    tagName === "INPUT" && !type && maskInputOptions["text"]);
}
function maskInputValue(param) {
    var isMasked = param.isMasked, element = param.element, value = param.value, maskInputFn = param.maskInputFn;
    var text = value || "";
    if (!isMasked) return text;
    if (maskInputFn) text = maskInputFn(text, element);
    return "*".repeat(text.length);
}
function toLowerCase(str) {
    return str.toLowerCase();
}
function toUpperCase(str) {
    return str.toUpperCase();
}
var ORIGINAL_ATTRIBUTE_NAME = "__rrweb_original__";
function is2DCanvasBlank(canvas) {
    var ctx = canvas.getContext("2d");
    if (!ctx) return true;
    var chunkSize = 50;
    for(var x = 0; x < canvas.width; x += chunkSize)for(var y = 0; y < canvas.height; y += chunkSize){
        var getImageData = ctx.getImageData;
        var originalGetImageData = ORIGINAL_ATTRIBUTE_NAME in getImageData ? getImageData[ORIGINAL_ATTRIBUTE_NAME] : getImageData;
        var pixelBuffer = new Uint32Array(// eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
        originalGetImageData.call(ctx, x, y, Math.min(chunkSize, canvas.width - x), Math.min(chunkSize, canvas.height - y)).data.buffer);
        if (pixelBuffer.some(function(pixel) {
            return pixel !== 0;
        })) return false;
    }
    return true;
}
function getInputType(element) {
    var type = element.type;
    return element.hasAttribute("data-rr-is-password") ? "password" : type ? // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
    toLowerCase(type) : null;
}
function getInputValue(el, tagName, type) {
    if (tagName === "INPUT" && (type === "radio" || type === "checkbox")) return el.getAttribute("value") || "";
    return el.value;
}
function extractFileExtension(path, baseURL) {
    var url;
    try {
        url = new URL(path, baseURL !== null && baseURL !== void 0 ? baseURL : window.location.href);
    } catch (err) {
        return null;
    }
    var regex = /\.([0-9a-z]+)(?:$)/i;
    var match = url.pathname.match(regex);
    var _match_;
    return (_match_ = match === null || match === void 0 ? void 0 : match[1]) !== null && _match_ !== void 0 ? _match_ : null;
}
var cachedImplementations$1 = {};
function getImplementation$1(name) {
    var cached = cachedImplementations$1[name];
    if (cached) return cached;
    var document2 = window.document;
    var impl = window[name];
    if (document2 && typeof document2.createElement === "function") try {
        var sandbox = document2.createElement("iframe");
        sandbox.hidden = true;
        document2.head.appendChild(sandbox);
        var contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document2.head.removeChild(sandbox);
    } catch (e2) {}
    return cachedImplementations$1[name] = impl.bind(window);
}
function setTimeout$2() {
    for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++){
        rest[_key] = arguments[_key];
    }
    return getImplementation$1("setTimeout").apply(this, (0, _toConsumableArray._)(rest));
}
function clearTimeout$1() {
    for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++){
        rest[_key] = arguments[_key];
    }
    return getImplementation$1("clearTimeout").apply(this, (0, _toConsumableArray._)(rest));
}
function getIframeContentDocument(iframe) {
    try {
        return iframe.contentDocument;
    } catch (e2) {}
}
var _id = 1;
var tagNameRegex = new RegExp("[^a-z0-9-_:]");
var IGNORED_NODE = -2;
function genId() {
    return _id++;
}
function getValidTagName$1(element) {
    if ((0, _instanceof._)(element, HTMLFormElement)) return "form";
    var processedTagName = toLowerCase(element.tagName);
    if (tagNameRegex.test(processedTagName)) return "div";
    return processedTagName;
}
function extractOrigin(url) {
    var origin = "";
    if (url.indexOf("//") > -1) origin = url.split("/").slice(0, 3).join("/");
    else origin = url.split("/")[0];
    origin = origin.split("?")[0];
    return origin;
}
var canvasService;
var canvasCtx;
var URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
var URL_PROTOCOL_MATCH = /^(?:[a-z+]+:)?\/\//i;
var URL_WWW_MATCH = /^www\..*/i;
var DATA_URI = /^(data:)([^,]*),(.*)/i;
function filterCSSPropertiesFromInlineStyle(cssText, ignoredProperties) {
    if (!cssText || ignoredProperties.size === 0) return cssText;
    try {
        var properties = cssText.split(";");
        var filteredProperties = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = properties[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var property = _step.value;
                property = property.trim();
                if (!property) continue;
                var colonIndex = property.indexOf(":");
                if (colonIndex === -1) {
                    filteredProperties.push(property);
                    continue;
                }
                var propertyName = property.slice(0, colonIndex).trim();
                if (!ignoredProperties.has(propertyName)) filteredProperties.push(property);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return filteredProperties.join("; ") + (filteredProperties.length > 0 && cssText.endsWith(";") ? ";" : "");
    } catch (error) {
        console.warn("Error filtering CSS properties:", error);
        return cssText;
    }
}
function absoluteToStylesheet(cssText, href) {
    return (cssText || "").replace(URL_IN_CSS_REF, function(origin, quote1, path1, quote2, path2, path3) {
        var filePath = path1 || path2 || path3;
        var maybeQuote = quote1 || quote2 || "";
        if (!filePath) return origin;
        if (URL_PROTOCOL_MATCH.test(filePath) || URL_WWW_MATCH.test(filePath)) return "url(".concat(maybeQuote).concat(filePath).concat(maybeQuote, ")");
        if (DATA_URI.test(filePath)) return "url(".concat(maybeQuote).concat(filePath).concat(maybeQuote, ")");
        if (filePath[0] === "/") return "url(".concat(maybeQuote).concat(extractOrigin(href) + filePath).concat(maybeQuote, ")");
        var stack = href.split("/");
        var parts = filePath.split("/");
        stack.pop();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = parts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var part = _step.value;
                if (part === ".") continue;
                else if (part === "..") stack.pop();
                else stack.push(part);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return "url(".concat(maybeQuote).concat(stack.join("/")).concat(maybeQuote, ")");
    });
}
var SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
var SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function getAbsoluteSrcsetString(doc, attributeValue) {
    if (attributeValue.trim() === "") return attributeValue;
    var pos = 0;
    function collectCharacters(regEx) {
        var chars2;
        var match = regEx.exec(attributeValue.substring(pos));
        if (match) {
            chars2 = match[0];
            pos += chars2.length;
            return chars2;
        }
        return "";
    }
    var output = [];
    while(true){
        collectCharacters(SRCSET_COMMAS_OR_SPACES);
        if (pos >= attributeValue.length) break;
        var url = collectCharacters(SRCSET_NOT_SPACES);
        if (url.slice(-1) === ",") {
            url = absoluteToDoc(doc, url.substring(0, url.length - 1));
            output.push(url);
        } else {
            var descriptorsStr = "";
            url = absoluteToDoc(doc, url);
            var inParens = false;
            while(true){
                var c2 = attributeValue.charAt(pos);
                if (c2 === "") {
                    output.push((url + descriptorsStr).trim());
                    break;
                } else if (!inParens) {
                    if (c2 === ",") {
                        pos += 1;
                        output.push((url + descriptorsStr).trim());
                        break;
                    } else if (c2 === "(") inParens = true;
                } else if (c2 === ")") inParens = false;
                descriptorsStr += c2;
                pos += 1;
            }
        }
    }
    return output.join(", ");
}
var cachedDocument = /* @__PURE__ */ new WeakMap();
function absoluteToDoc(doc, attributeValue) {
    if (!attributeValue || attributeValue.trim() === "") return attributeValue;
    return getHref(doc, attributeValue);
}
function isSVGElement(el) {
    return Boolean(el.tagName === "svg" || el.ownerSVGElement);
}
function getHref(doc, customHref) {
    var a2 = cachedDocument.get(doc);
    if (!a2) {
        a2 = doc.createElement("a");
        cachedDocument.set(doc, a2);
    }
    if (!customHref) customHref = "";
    else if (customHref.startsWith("blob:") || customHref.startsWith("data:")) return customHref;
    a2.setAttribute("href", customHref);
    return a2.href;
}
function transformAttribute(doc, tagName, name, value, element, maskAttributeFn, ignoreCSSAttributes) {
    if (!value) return value;
    if (name === "src" || name === "href" && !(tagName === "use" && value[0] === "#")) return absoluteToDoc(doc, value);
    else if (name === "xlink:href" && value[0] !== "#") return absoluteToDoc(doc, value);
    else if (name === "background" && (tagName === "table" || tagName === "td" || tagName === "th")) return absoluteToDoc(doc, value);
    else if (name === "srcset") return getAbsoluteSrcsetString(doc, value);
    else if (name === "style") {
        var processedStyle = absoluteToStylesheet(value, getHref(doc));
        if (ignoreCSSAttributes && ignoreCSSAttributes.size > 0) processedStyle = filterCSSPropertiesFromInlineStyle(processedStyle, ignoreCSSAttributes);
        return processedStyle;
    } else if (tagName === "object" && name === "data") return absoluteToDoc(doc, value);
    if (typeof maskAttributeFn === "function") return maskAttributeFn(name, value, element);
    return value;
}
function ignoreAttribute(tagName, name, _value) {
    return (tagName === "video" || tagName === "audio") && name === "autoplay";
}
function _isBlockedElement(element, blockClass, blockSelector, unblockSelector) {
    try {
        if (unblockSelector && element.matches(unblockSelector)) return false;
        if (typeof blockClass === "string") {
            if (element.classList.contains(blockClass)) return true;
        } else for(var eIndex = element.classList.length; eIndex--;){
            var className = element.classList[eIndex];
            if (blockClass.test(className)) return true;
        }
        if (blockSelector) return element.matches(blockSelector);
    } catch (e2) {}
    return false;
}
function elementClassMatchesRegex(el, regex) {
    for(var eIndex = el.classList.length; eIndex--;){
        var className = el.classList[eIndex];
        if (regex.test(className)) return true;
    }
    return false;
}
function distanceToMatch(node, matchPredicate) {
    var limit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Infinity, distance = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    if (!node) return -1;
    if (node.nodeType !== node.ELEMENT_NODE) return -1;
    if (distance > limit) return -1;
    if (matchPredicate(node)) return distance;
    return distanceToMatch(node.parentNode, matchPredicate, limit, distance + 1);
}
function createMatchPredicate(className, selector) {
    return function(node) {
        var el = node;
        if (el === null) return false;
        try {
            if (className) {
                if (typeof className === "string") {
                    if (el.matches(".".concat(className))) return true;
                } else if (elementClassMatchesRegex(el, className)) return true;
            }
            if (selector && el.matches(selector)) return true;
            return false;
        } catch (e) {
            return false;
        }
    };
}
function needMaskingText(node, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText) {
    try {
        var el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
        if (el === null) return false;
        if (el.tagName === "INPUT") {
            var autocomplete = el.getAttribute("autocomplete");
            var disallowedAutocompleteValues = [
                "current-password",
                "new-password",
                "cc-number",
                "cc-exp",
                "cc-exp-month",
                "cc-exp-year",
                "cc-csc"
            ];
            if (disallowedAutocompleteValues.includes(autocomplete)) return true;
        }
        var maskDistance = -1;
        var unmaskDistance = -1;
        if (maskAllText) {
            unmaskDistance = distanceToMatch(el, createMatchPredicate(unmaskTextClass, unmaskTextSelector));
            if (unmaskDistance < 0) return true;
            maskDistance = distanceToMatch(el, createMatchPredicate(maskTextClass, maskTextSelector), unmaskDistance >= 0 ? unmaskDistance : Infinity);
        } else {
            maskDistance = distanceToMatch(el, createMatchPredicate(maskTextClass, maskTextSelector));
            if (maskDistance < 0) return false;
            unmaskDistance = distanceToMatch(el, createMatchPredicate(unmaskTextClass, unmaskTextSelector), maskDistance >= 0 ? maskDistance : Infinity);
        }
        return maskDistance >= 0 ? unmaskDistance >= 0 ? maskDistance <= unmaskDistance : true : unmaskDistance >= 0 ? false : !!maskAllText;
    } catch (e2) {}
    return !!maskAllText;
}
function onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
    var win = iframeEl.contentWindow;
    if (!win) return;
    var fired = false;
    var readyState;
    try {
        readyState = win.document.readyState;
    } catch (error) {
        return;
    }
    if (readyState !== "complete") {
        var timer = setTimeout$2(function() {
            if (!fired) {
                listener();
                fired = true;
            }
        }, iframeLoadTimeout);
        iframeEl.addEventListener("load", function() {
            clearTimeout$1(timer);
            fired = true;
            listener();
        });
        return;
    }
    var blankUrl = "about:blank";
    if (win.location.href !== blankUrl || iframeEl.src === blankUrl || iframeEl.src === "") {
        setTimeout$2(listener, 0);
        return iframeEl.addEventListener("load", listener);
    }
    iframeEl.addEventListener("load", listener);
}
function onceStylesheetLoaded(link, listener, styleSheetLoadTimeout) {
    var fired = false;
    var styleSheetLoaded;
    try {
        styleSheetLoaded = link.sheet;
    } catch (error) {
        return;
    }
    if (styleSheetLoaded) return;
    var timer = setTimeout$2(function() {
        if (!fired) {
            listener();
            fired = true;
        }
    }, styleSheetLoadTimeout);
    link.addEventListener("load", function() {
        clearTimeout$1(timer);
        fired = true;
        listener();
    });
}
function serializeNode(n2, options) {
    var doc = options.doc, mirror2 = options.mirror, blockClass = options.blockClass, blockSelector = options.blockSelector, unblockSelector = options.unblockSelector, maskAllText = options.maskAllText, maskAttributeFn = options.maskAttributeFn, maskTextClass = options.maskTextClass, unmaskTextClass = options.unmaskTextClass, maskTextSelector = options.maskTextSelector, unmaskTextSelector = options.unmaskTextSelector, inlineStylesheet = options.inlineStylesheet, _options_maskInputOptions = options.maskInputOptions, maskInputOptions = _options_maskInputOptions === void 0 ? {} : _options_maskInputOptions, maskTextFn = options.maskTextFn, maskInputFn = options.maskInputFn, _options_dataURLOptions = options.dataURLOptions, dataURLOptions = _options_dataURLOptions === void 0 ? {} : _options_dataURLOptions, inlineImages = options.inlineImages, recordCanvas = options.recordCanvas, keepIframeSrcFn = options.keepIframeSrcFn, _options_newlyAddedElement = options.newlyAddedElement, newlyAddedElement = _options_newlyAddedElement === void 0 ? false : _options_newlyAddedElement, ignoreCSSAttributes = options.ignoreCSSAttributes;
    var rootId = getRootId(doc, mirror2);
    switch(n2.nodeType){
        case n2.DOCUMENT_NODE:
            if (n2.compatMode !== "CSS1Compat") return {
                type: NodeType$2.Document,
                childNodes: [],
                compatMode: n2.compatMode
            };
            else return {
                type: NodeType$2.Document,
                childNodes: []
            };
        case n2.DOCUMENT_TYPE_NODE:
            return {
                type: NodeType$2.DocumentType,
                name: n2.name,
                publicId: n2.publicId,
                systemId: n2.systemId,
                rootId: rootId
            };
        case n2.ELEMENT_NODE:
            return serializeElementNode(n2, {
                doc: doc,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                inlineStylesheet: inlineStylesheet,
                maskAttributeFn: maskAttributeFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                keepIframeSrcFn: keepIframeSrcFn,
                newlyAddedElement: newlyAddedElement,
                rootId: rootId,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                ignoreCSSAttributes: ignoreCSSAttributes
            });
        case n2.TEXT_NODE:
            return serializeTextNode(n2, {
                doc: doc,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskTextFn: maskTextFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                rootId: rootId
            });
        case n2.CDATA_SECTION_NODE:
            return {
                type: NodeType$2.CDATA,
                textContent: "",
                rootId: rootId
            };
        case n2.COMMENT_NODE:
            return {
                type: NodeType$2.Comment,
                textContent: n2.textContent || "",
                rootId: rootId
            };
        default:
            return false;
    }
}
function getRootId(doc, mirror2) {
    if (!mirror2.hasNode(doc)) return void 0;
    var docId = mirror2.getId(doc);
    return docId === 1 ? void 0 : docId;
}
function serializeTextNode(n2, options) {
    var maskAllText = options.maskAllText, maskTextClass = options.maskTextClass, unmaskTextClass = options.unmaskTextClass, maskTextSelector = options.maskTextSelector, unmaskTextSelector = options.unmaskTextSelector, maskTextFn = options.maskTextFn, maskInputOptions = options.maskInputOptions, maskInputFn = options.maskInputFn, rootId = options.rootId;
    var parentTagName = n2.parentNode && n2.parentNode.tagName;
    var textContent = n2.textContent;
    var isStyle = parentTagName === "STYLE" ? true : void 0;
    var isScript = parentTagName === "SCRIPT" ? true : void 0;
    var isTextarea = parentTagName === "TEXTAREA" ? true : void 0;
    if (isStyle && textContent) {
        try {
            var _n2_parentNode_sheet;
            if (n2.nextSibling || n2.previousSibling) ;
            else if ((_n2_parentNode_sheet = n2.parentNode.sheet) === null || _n2_parentNode_sheet === void 0 ? void 0 : _n2_parentNode_sheet.cssRules) textContent = stringifyStylesheet(n2.parentNode.sheet);
        } catch (err) {
            console.warn("Cannot get CSS styles from text's parentNode. Error: ".concat(err), n2);
        }
        textContent = absoluteToStylesheet(textContent, getHref(options.doc));
    }
    if (isScript) textContent = "SCRIPT_PLACEHOLDER";
    var forceMask = needMaskingText(n2, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText);
    if (!isStyle && !isScript && !isTextarea && textContent && forceMask) textContent = maskTextFn ? maskTextFn(textContent, n2.parentElement) : textContent.replace(/[\S]/g, "*");
    if (isTextarea && textContent && (maskInputOptions.textarea || forceMask)) textContent = maskInputFn ? maskInputFn(textContent, n2.parentNode) : textContent.replace(/[\S]/g, "*");
    if (parentTagName === "OPTION" && textContent) {
        var isInputMasked = shouldMaskInput({
            type: null,
            tagName: parentTagName,
            maskInputOptions: maskInputOptions
        });
        textContent = maskInputValue({
            isMasked: needMaskingText(n2, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked),
            element: n2,
            value: textContent,
            maskInputFn: maskInputFn
        });
    }
    return {
        type: NodeType$2.Text,
        textContent: textContent || "",
        isStyle: isStyle,
        rootId: rootId
    };
}
function serializeElementNode(n2, options) {
    var doc = options.doc, blockClass = options.blockClass, blockSelector = options.blockSelector, unblockSelector = options.unblockSelector, inlineStylesheet = options.inlineStylesheet, _options_maskInputOptions = options.maskInputOptions, maskInputOptions = _options_maskInputOptions === void 0 ? {} : _options_maskInputOptions, maskAttributeFn = options.maskAttributeFn, maskInputFn = options.maskInputFn, _options_dataURLOptions = options.dataURLOptions, dataURLOptions = _options_dataURLOptions === void 0 ? {} : _options_dataURLOptions, inlineImages = options.inlineImages, recordCanvas = options.recordCanvas, keepIframeSrcFn = options.keepIframeSrcFn, _options_newlyAddedElement = options.newlyAddedElement, newlyAddedElement = _options_newlyAddedElement === void 0 ? false : _options_newlyAddedElement, rootId = options.rootId, maskTextClass = options.maskTextClass, unmaskTextClass = options.unmaskTextClass, maskTextSelector = options.maskTextSelector, unmaskTextSelector = options.unmaskTextSelector, ignoreCSSAttributes = options.ignoreCSSAttributes;
    var needBlock = _isBlockedElement(n2, blockClass, blockSelector, unblockSelector);
    var tagName = getValidTagName$1(n2);
    var attributes2 = {};
    var len = n2.attributes.length;
    for(var i2 = 0; i2 < len; i2++){
        var attr = n2.attributes[i2];
        if (attr.name && !ignoreAttribute(tagName, attr.name, attr.value)) attributes2[attr.name] = transformAttribute(doc, tagName, toLowerCase(attr.name), attr.value, n2, maskAttributeFn, ignoreCSSAttributes);
    }
    if (tagName === "link" && inlineStylesheet) {
        var stylesheet = Array.from(doc.styleSheets).find(function(s2) {
            return s2.href === n2.href;
        });
        var cssText = null;
        if (stylesheet) cssText = stringifyStylesheet(stylesheet);
        if (cssText) {
            attributes2.rel = null;
            attributes2.href = null;
            attributes2.crossorigin = null;
            attributes2._cssText = absoluteToStylesheet(cssText, stylesheet.href);
        }
    }
    if (tagName === "style" && n2.sheet && // TODO: Currently we only try to get dynamic stylesheet when it is an empty style element
    !(n2.innerText || n2.textContent || "").trim().length) {
        var cssText1 = stringifyStylesheet(n2.sheet);
        if (cssText1) attributes2._cssText = absoluteToStylesheet(cssText1, getHref(doc));
    }
    if (tagName === "input" || tagName === "textarea" || tagName === "select" || tagName === "option") {
        var el = n2;
        var type = getInputType(el);
        var value = getInputValue(el, toUpperCase(tagName), type);
        var checked = el.checked;
        if (type !== "submit" && type !== "button" && value) {
            var forceMask = needMaskingText(el, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, shouldMaskInput({
                type: type,
                tagName: toUpperCase(tagName),
                maskInputOptions: maskInputOptions
            }));
            attributes2.value = maskInputValue({
                isMasked: forceMask,
                element: el,
                value: value,
                maskInputFn: maskInputFn
            });
        }
        if (checked) attributes2.checked = checked;
    }
    if (tagName === "option") {
        if (n2.selected && !maskInputOptions["select"]) attributes2.selected = true;
        else delete attributes2.selected;
    }
    if (tagName === "canvas" && recordCanvas) {
        if (n2.__context === "2d") {
            if (!is2DCanvasBlank(n2)) attributes2.rr_dataURL = n2.toDataURL(dataURLOptions.type, dataURLOptions.quality);
        } else if (!("__context" in n2)) {
            var canvasDataURL = n2.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            var blankCanvas = doc.createElement("canvas");
            blankCanvas.width = n2.width;
            blankCanvas.height = n2.height;
            var blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            if (canvasDataURL !== blankCanvasDataURL) attributes2.rr_dataURL = canvasDataURL;
        }
    }
    if (tagName === "img" && inlineImages) {
        if (!canvasService) {
            canvasService = doc.createElement("canvas");
            canvasCtx = canvasService.getContext("2d");
        }
        var image = n2;
        var imageSrc = image.currentSrc || image.getAttribute("src") || "<unknown-src>";
        var priorCrossOrigin = image.crossOrigin;
        var recordInlineImage = function() {
            image.removeEventListener("load", recordInlineImage);
            try {
                canvasService.width = image.naturalWidth;
                canvasService.height = image.naturalHeight;
                canvasCtx.drawImage(image, 0, 0);
                attributes2.rr_dataURL = canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            } catch (err) {
                if (image.crossOrigin !== "anonymous") {
                    image.crossOrigin = "anonymous";
                    if (image.complete && image.naturalWidth !== 0) recordInlineImage();
                    else image.addEventListener("load", recordInlineImage);
                    return;
                } else console.warn("Cannot inline img src=".concat(imageSrc, "! Error: ").concat(err));
            }
            if (image.crossOrigin === "anonymous") priorCrossOrigin ? attributes2.crossOrigin = priorCrossOrigin : image.removeAttribute("crossorigin");
        };
        if (image.complete && image.naturalWidth !== 0) recordInlineImage();
        else image.addEventListener("load", recordInlineImage);
    }
    if (tagName === "audio" || tagName === "video") {
        attributes2.rr_mediaState = n2.paused ? "paused" : "played";
        attributes2.rr_mediaCurrentTime = n2.currentTime;
    }
    if (!newlyAddedElement) {
        if (n2.scrollLeft) attributes2.rr_scrollLeft = n2.scrollLeft;
        if (n2.scrollTop) attributes2.rr_scrollTop = n2.scrollTop;
    }
    if (needBlock) {
        var _n2_getBoundingClientRect = n2.getBoundingClientRect(), width = _n2_getBoundingClientRect.width, height = _n2_getBoundingClientRect.height;
        attributes2 = {
            class: attributes2.class,
            rr_width: "".concat(width, "px"),
            rr_height: "".concat(height, "px")
        };
    }
    if (tagName === "iframe" && !keepIframeSrcFn(attributes2.src)) {
        if (!needBlock && !getIframeContentDocument(n2)) attributes2.rr_src = attributes2.src;
        delete attributes2.src;
    }
    var isCustomElement;
    try {
        if (customElements.get(tagName)) isCustomElement = true;
    } catch (e2) {}
    return {
        type: NodeType$2.Element,
        tagName: tagName,
        attributes: attributes2,
        childNodes: [],
        isSVG: isSVGElement(n2) || void 0,
        needBlock: needBlock,
        rootId: rootId,
        isCustom: isCustomElement
    };
}
function lowerIfExists(maybeAttr) {
    if (maybeAttr === void 0 || maybeAttr === null) return "";
    else return maybeAttr.toLowerCase();
}
function slimDOMExcluded(sn, slimDOMOptions) {
    if (slimDOMOptions.comment && sn.type === NodeType$2.Comment) return true;
    else if (sn.type === NodeType$2.Element) {
        if (slimDOMOptions.script && // script tag
        (sn.tagName === "script" || // (module)preload link
        sn.tagName === "link" && (sn.attributes.rel === "preload" || sn.attributes.rel === "modulepreload") || // prefetch link
        sn.tagName === "link" && sn.attributes.rel === "prefetch" && typeof sn.attributes.href === "string" && extractFileExtension(sn.attributes.href) === "js")) return true;
        else if (slimDOMOptions.headFavicon && (sn.tagName === "link" && sn.attributes.rel === "shortcut icon" || sn.tagName === "meta" && (lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) || lowerIfExists(sn.attributes.name) === "application-name" || lowerIfExists(sn.attributes.rel) === "icon" || lowerIfExists(sn.attributes.rel) === "apple-touch-icon" || lowerIfExists(sn.attributes.rel) === "shortcut icon"))) return true;
        else if (sn.tagName === "meta") {
            if (slimDOMOptions.headMetaDescKeywords && lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) return true;
            else if (slimDOMOptions.headMetaSocial && (lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) || // og = opengraph (facebook)
            lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) || lowerIfExists(sn.attributes.name) === "pinterest")) return true;
            else if (slimDOMOptions.headMetaRobots && (lowerIfExists(sn.attributes.name) === "robots" || lowerIfExists(sn.attributes.name) === "googlebot" || lowerIfExists(sn.attributes.name) === "bingbot")) return true;
            else if (slimDOMOptions.headMetaHttpEquiv && sn.attributes["http-equiv"] !== void 0) return true;
            else if (slimDOMOptions.headMetaAuthorship && (lowerIfExists(sn.attributes.name) === "author" || lowerIfExists(sn.attributes.name) === "generator" || lowerIfExists(sn.attributes.name) === "framework" || lowerIfExists(sn.attributes.name) === "publisher" || lowerIfExists(sn.attributes.name) === "progid" || lowerIfExists(sn.attributes.property).match(/^article:/) || lowerIfExists(sn.attributes.property).match(/^product:/))) return true;
            else if (slimDOMOptions.headMetaVerification && (lowerIfExists(sn.attributes.name) === "google-site-verification" || lowerIfExists(sn.attributes.name) === "yandex-verification" || lowerIfExists(sn.attributes.name) === "csrf-token" || lowerIfExists(sn.attributes.name) === "p:domain_verify" || lowerIfExists(sn.attributes.name) === "verify-v1" || lowerIfExists(sn.attributes.name) === "verification" || lowerIfExists(sn.attributes.name) === "shopify-checkout-api-token")) return true;
        }
    }
    return false;
}
function serializeNodeWithId(n2, options) {
    var doc = options.doc, mirror2 = options.mirror, blockClass = options.blockClass, blockSelector = options.blockSelector, unblockSelector = options.unblockSelector, maskAllText = options.maskAllText, maskTextClass = options.maskTextClass, unmaskTextClass = options.unmaskTextClass, maskTextSelector = options.maskTextSelector, unmaskTextSelector = options.unmaskTextSelector, _options_skipChild = options.skipChild, skipChild = _options_skipChild === void 0 ? false : _options_skipChild, _options_inlineStylesheet = options.inlineStylesheet, inlineStylesheet = _options_inlineStylesheet === void 0 ? true : _options_inlineStylesheet, _options_maskInputOptions = options.maskInputOptions, maskInputOptions = _options_maskInputOptions === void 0 ? {} : _options_maskInputOptions, maskAttributeFn = options.maskAttributeFn, maskTextFn = options.maskTextFn, maskInputFn = options.maskInputFn, slimDOMOptions = options.slimDOMOptions, _options_dataURLOptions = options.dataURLOptions, dataURLOptions = _options_dataURLOptions === void 0 ? {} : _options_dataURLOptions, _options_inlineImages = options.inlineImages, inlineImages = _options_inlineImages === void 0 ? false : _options_inlineImages, _options_recordCanvas = options.recordCanvas, recordCanvas = _options_recordCanvas === void 0 ? false : _options_recordCanvas, onSerialize = options.onSerialize, onIframeLoad = options.onIframeLoad, _options_iframeLoadTimeout = options.iframeLoadTimeout, iframeLoadTimeout = _options_iframeLoadTimeout === void 0 ? 5e3 : _options_iframeLoadTimeout, onBlockedImageLoad = options.onBlockedImageLoad, onStylesheetLoad = options.onStylesheetLoad, _options_stylesheetLoadTimeout = options.stylesheetLoadTimeout, stylesheetLoadTimeout = _options_stylesheetLoadTimeout === void 0 ? 5e3 : _options_stylesheetLoadTimeout, _options_keepIframeSrcFn = options.keepIframeSrcFn, keepIframeSrcFn = _options_keepIframeSrcFn === void 0 ? function() {
        return false;
    } : _options_keepIframeSrcFn, _options_newlyAddedElement = options.newlyAddedElement, newlyAddedElement = _options_newlyAddedElement === void 0 ? false : _options_newlyAddedElement, ignoreCSSAttributes = options.ignoreCSSAttributes;
    var _options_preserveWhiteSpace = options.preserveWhiteSpace, preserveWhiteSpace = _options_preserveWhiteSpace === void 0 ? true : _options_preserveWhiteSpace;
    var _serializedNode = serializeNode(n2, {
        doc: doc,
        mirror: mirror2,
        blockClass: blockClass,
        blockSelector: blockSelector,
        maskAllText: maskAllText,
        unblockSelector: unblockSelector,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: newlyAddedElement,
        ignoreCSSAttributes: ignoreCSSAttributes
    });
    if (!_serializedNode) {
        console.warn(n2, "not serialized");
        return null;
    }
    var id;
    if (mirror2.hasNode(n2)) id = mirror2.getId(n2);
    else if (slimDOMExcluded(_serializedNode, slimDOMOptions) || !preserveWhiteSpace && _serializedNode.type === NodeType$2.Text && !_serializedNode.isStyle && !_serializedNode.textContent.replace(/^\s+|\s+$/gm, "").length) id = IGNORED_NODE;
    else id = genId();
    var serializedNode2 = Object.assign(_serializedNode, {
        id: id
    });
    mirror2.add(n2, serializedNode2);
    if (id === IGNORED_NODE) return null;
    if (onSerialize) onSerialize(n2);
    var recordChild = !skipChild;
    if (serializedNode2.type === NodeType$2.Element) {
        recordChild = recordChild && !serializedNode2.needBlock;
        var shadowRoot = n2.shadowRoot;
        if (shadowRoot && isNativeShadowDom(shadowRoot)) serializedNode2.isShadowHost = true;
    }
    if ((serializedNode2.type === NodeType$2.Document || serializedNode2.type === NodeType$2.Element) && recordChild) {
        if (slimDOMOptions.headWhitespace && serializedNode2.type === NodeType$2.Element && serializedNode2.tagName === "head") preserveWhiteSpace = false;
        var bypassOptions = {
            doc: doc,
            mirror: mirror2,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskAllText: maskAllText,
            unblockSelector: unblockSelector,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            skipChild: skipChild,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOMOptions: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            inlineImages: inlineImages,
            recordCanvas: recordCanvas,
            preserveWhiteSpace: preserveWhiteSpace,
            onSerialize: onSerialize,
            onIframeLoad: onIframeLoad,
            iframeLoadTimeout: iframeLoadTimeout,
            onBlockedImageLoad: onBlockedImageLoad,
            onStylesheetLoad: onStylesheetLoad,
            stylesheetLoadTimeout: stylesheetLoadTimeout,
            keepIframeSrcFn: keepIframeSrcFn,
            ignoreCSSAttributes: ignoreCSSAttributes
        };
        var childNodes = n2.childNodes ? Array.from(n2.childNodes) : [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = childNodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var childN = _step.value;
                var serializedChildNode = serializeNodeWithId(childN, bypassOptions);
                if (serializedChildNode) serializedNode2.childNodes.push(serializedChildNode);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        if (isElement$1(n2) && n2.shadowRoot) try {
            for(var _iterator1 = Array.from(n2.shadowRoot.childNodes)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var childN1 = _step1.value;
                var serializedChildNode1 = serializeNodeWithId(childN1, bypassOptions);
                if (serializedChildNode1) {
                    isNativeShadowDom(n2.shadowRoot) && (serializedChildNode1.isShadow = true);
                    serializedNode2.childNodes.push(serializedChildNode1);
                }
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    if (n2.parentNode && isShadowRoot(n2.parentNode) && isNativeShadowDom(n2.parentNode)) serializedNode2.isShadow = true;
    if (serializedNode2.type === NodeType$2.Element && serializedNode2.tagName === "iframe" && !serializedNode2.needBlock) onceIframeLoaded(n2, function() {
        var iframeDoc = getIframeContentDocument(n2);
        if (iframeDoc && onIframeLoad) {
            var serializedIframeNode = serializeNodeWithId(iframeDoc, {
                doc: iframeDoc,
                mirror: mirror2,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn,
                ignoreCSSAttributes: ignoreCSSAttributes
            });
            if (serializedIframeNode) onIframeLoad(n2, serializedIframeNode);
        }
    }, iframeLoadTimeout);
    if (serializedNode2.type === NodeType$2.Element && serializedNode2.tagName === "img" && !n2.complete && serializedNode2.needBlock) {
        var image = n2;
        var updateImageDimensions = function() {
            if (image.isConnected && !image.complete && onBlockedImageLoad) try {
                var rect = image.getBoundingClientRect();
                if (rect.width > 0 && rect.height > 0) onBlockedImageLoad(image, serializedNode2, rect);
            } catch (error) {}
            image.removeEventListener("load", updateImageDimensions);
        };
        if (image.isConnected) image.addEventListener("load", updateImageDimensions);
    }
    if (serializedNode2.type === NodeType$2.Element && serializedNode2.tagName === "link" && typeof serializedNode2.attributes.rel === "string" && (serializedNode2.attributes.rel === "stylesheet" || serializedNode2.attributes.rel === "preload" && typeof serializedNode2.attributes.href === "string" && extractFileExtension(serializedNode2.attributes.href) === "css")) onceStylesheetLoaded(n2, function() {
        if (onStylesheetLoad) {
            var serializedLinkNode = serializeNodeWithId(n2, {
                doc: doc,
                mirror: mirror2,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn,
                ignoreCSSAttributes: ignoreCSSAttributes
            });
            if (serializedLinkNode) onStylesheetLoad(n2, serializedLinkNode);
        }
    }, stylesheetLoadTimeout);
    if (serializedNode2.type === NodeType$2.Element) delete serializedNode2.needBlock;
    return serializedNode2;
}
function snapshot(n2, options) {
    var _ref = options || {}, tmp = _ref.mirror, mirror2 = tmp === void 0 ? new Mirror() : tmp, _ref_blockClass = _ref.blockClass, blockClass = _ref_blockClass === void 0 ? "rr-block" : _ref_blockClass, _ref_blockSelector = _ref.blockSelector, blockSelector = _ref_blockSelector === void 0 ? null : _ref_blockSelector, _ref_unblockSelector = _ref.unblockSelector, unblockSelector = _ref_unblockSelector === void 0 ? null : _ref_unblockSelector, _ref_maskAllText = _ref.maskAllText, maskAllText = _ref_maskAllText === void 0 ? false : _ref_maskAllText, _ref_maskTextClass = _ref.maskTextClass, maskTextClass = _ref_maskTextClass === void 0 ? "rr-mask" : _ref_maskTextClass, _ref_unmaskTextClass = _ref.unmaskTextClass, unmaskTextClass = _ref_unmaskTextClass === void 0 ? null : _ref_unmaskTextClass, _ref_maskTextSelector = _ref.maskTextSelector, maskTextSelector = _ref_maskTextSelector === void 0 ? null : _ref_maskTextSelector, _ref_unmaskTextSelector = _ref.unmaskTextSelector, unmaskTextSelector = _ref_unmaskTextSelector === void 0 ? null : _ref_unmaskTextSelector, _ref_inlineStylesheet = _ref.inlineStylesheet, inlineStylesheet = _ref_inlineStylesheet === void 0 ? true : _ref_inlineStylesheet, _ref_inlineImages = _ref.inlineImages, inlineImages = _ref_inlineImages === void 0 ? false : _ref_inlineImages, _ref_recordCanvas = _ref.recordCanvas, recordCanvas = _ref_recordCanvas === void 0 ? false : _ref_recordCanvas, _ref_maskAllInputs = _ref.maskAllInputs, maskAllInputs = _ref_maskAllInputs === void 0 ? false : _ref_maskAllInputs, maskAttributeFn = _ref.maskAttributeFn, maskTextFn = _ref.maskTextFn, maskInputFn = _ref.maskInputFn, _ref_slimDOM = _ref.slimDOM, slimDOM = _ref_slimDOM === void 0 ? false : _ref_slimDOM, dataURLOptions = _ref.dataURLOptions, preserveWhiteSpace = _ref.preserveWhiteSpace, onSerialize = _ref.onSerialize, onIframeLoad = _ref.onIframeLoad, iframeLoadTimeout = _ref.iframeLoadTimeout, onBlockedImageLoad = _ref.onBlockedImageLoad, onStylesheetLoad = _ref.onStylesheetLoad, stylesheetLoadTimeout = _ref.stylesheetLoadTimeout, _ref_keepIframeSrcFn = _ref.keepIframeSrcFn, keepIframeSrcFn = _ref_keepIframeSrcFn === void 0 ? function() {
        return false;
    } : _ref_keepIframeSrcFn, _ref_ignoreCSSAttributes = _ref.ignoreCSSAttributes, ignoreCSSAttributes = _ref_ignoreCSSAttributes === void 0 ? /* @__PURE__ */ new Set([]) : _ref_ignoreCSSAttributes;
    var maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true
    } : maskAllInputs === false ? {} : maskAllInputs;
    var slimDOMOptions = slimDOM === true || slimDOM === "all" ? // if true: set of sensible options that should not throw away any information
    {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaDescKeywords: slimDOM === "all",
        // destructive
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaAuthorship: true,
        headMetaVerification: true
    } : slimDOM === false ? {} : slimDOM;
    return serializeNodeWithId(n2, {
        doc: n2,
        mirror: mirror2,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maskAllText: maskAllText,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        skipChild: false,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        slimDOMOptions: slimDOMOptions,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        preserveWhiteSpace: preserveWhiteSpace,
        onSerialize: onSerialize,
        onIframeLoad: onIframeLoad,
        iframeLoadTimeout: iframeLoadTimeout,
        onBlockedImageLoad: onBlockedImageLoad,
        onStylesheetLoad: onStylesheetLoad,
        stylesheetLoadTimeout: stylesheetLoadTimeout,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: false,
        ignoreCSSAttributes: ignoreCSSAttributes
    });
}
function on(type, fn) {
    var target = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : document;
    var options = {
        capture: true,
        passive: true
    };
    target.addEventListener(type, fn, options);
    return function() {
        return target.removeEventListener(type, fn, options);
    };
}
var DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
var _mirror = {
    map: {},
    getId: function getId() {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode: function getNode() {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap: function removeNodeFromMap() {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has: function has() {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset: function reset() {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== "undefined" && window.Proxy && window.Reflect) _mirror = new Proxy(_mirror, {
    get: function get(target, prop, receiver) {
        if (prop === "map") console.error(DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function throttle$1(func, wait) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var timeout = null;
    var previous = 0;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var now = Date.now();
        if (!previous && options.leading === false) previous = now;
        var remaining = wait - (now - previous);
        var context = this;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout$2(timeout);
                timeout = null;
            }
            previous = now;
            func.apply(context, args);
        } else if (!timeout && options.trailing !== false) timeout = setTimeout$1(function() {
            previous = options.leading === false ? 0 : Date.now();
            timeout = null;
            func.apply(context, args);
        }, remaining);
    };
}
function hookSetter(target, key, d, isRevoked) {
    var win = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : window;
    var original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set: function set(value) {
            var _this = this;
            setTimeout$1(function() {
                d.set.call(_this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return function() {
        return hookSetter(target, key, original || {}, true);
    };
}
function patch(source, name, replacement) {
    try {
        if (!(name in source)) return function() {};
        var original = source[name];
        var wrapped = replacement(original);
        if (typeof wrapped === "function") {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return function() {
            source[name] = original;
        };
    } catch (e) {
        return function() {};
    }
}
var nowTimestamp = Date.now;
if (!/* @__PURE__ */ /[1-9][0-9]{12}/.test(Date.now().toString())) nowTimestamp = function() {
    return /* @__PURE__ */ new Date().getTime();
};
function getWindowScroll(win) {
    var _doc_body_parentElement, _doc_body, _doc_body1, _doc_body_parentElement1, _doc_body2, _doc_body3;
    var doc = win.document;
    return {
        left: doc.scrollingElement ? doc.scrollingElement.scrollLeft : win.pageXOffset !== void 0 ? win.pageXOffset : (doc === null || doc === void 0 ? void 0 : doc.documentElement.scrollLeft) || (doc === null || doc === void 0 ? void 0 : (_doc_body = doc.body) === null || _doc_body === void 0 ? void 0 : (_doc_body_parentElement = _doc_body.parentElement) === null || _doc_body_parentElement === void 0 ? void 0 : _doc_body_parentElement.scrollLeft) || (doc === null || doc === void 0 ? void 0 : (_doc_body1 = doc.body) === null || _doc_body1 === void 0 ? void 0 : _doc_body1.scrollLeft) || 0,
        top: doc.scrollingElement ? doc.scrollingElement.scrollTop : win.pageYOffset !== void 0 ? win.pageYOffset : (doc === null || doc === void 0 ? void 0 : doc.documentElement.scrollTop) || (doc === null || doc === void 0 ? void 0 : (_doc_body2 = doc.body) === null || _doc_body2 === void 0 ? void 0 : (_doc_body_parentElement1 = _doc_body2.parentElement) === null || _doc_body_parentElement1 === void 0 ? void 0 : _doc_body_parentElement1.scrollTop) || (doc === null || doc === void 0 ? void 0 : (_doc_body3 = doc.body) === null || _doc_body3 === void 0 ? void 0 : _doc_body3.scrollTop) || 0
    };
}
function getWindowHeight() {
    return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function getWindowWidth() {
    return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function closestElementOfNode$1(node) {
    if (!node) return null;
    try {
        var el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
        return el;
    } catch (error) {
        return null;
    }
}
function isBlocked(node, blockClass, blockSelector, unblockSelector, checkAncestors) {
    if (!node) return false;
    var el = closestElementOfNode$1(node);
    if (!el) return false;
    var blockedPredicate = createMatchPredicate(blockClass, blockSelector);
    if (!checkAncestors) {
        var isUnblocked = unblockSelector && el.matches(unblockSelector);
        return blockedPredicate(el) && !isUnblocked;
    }
    var blockDistance = distanceToMatch(el, blockedPredicate);
    var unblockDistance = -1;
    if (blockDistance < 0) return false;
    if (unblockSelector) unblockDistance = distanceToMatch(el, createMatchPredicate(null, unblockSelector));
    if (blockDistance > -1 && unblockDistance < 0) return true;
    return blockDistance < unblockDistance;
}
function isSerialized(n2, mirror2) {
    return mirror2.getId(n2) !== -1;
}
function isIgnored(n2, mirror2) {
    return mirror2.getId(n2) === IGNORED_NODE;
}
function isAncestorRemoved(target, mirror2) {
    if (isShadowRoot(target)) return false;
    var id = mirror2.getId(target);
    if (!mirror2.has(id)) return true;
    if (target.parentNode && target.parentNode.nodeType === target.DOCUMENT_NODE) return false;
    if (!target.parentNode) return true;
    return isAncestorRemoved(target.parentNode, mirror2);
}
function legacy_isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function polyfill$1() {
    var win = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window;
    var _this = this;
    if ("NodeList" in win && !win.NodeList.prototype.forEach) win.NodeList.prototype.forEach = Array.prototype.forEach;
    if ("DOMTokenList" in win && !win.DOMTokenList.prototype.forEach) win.DOMTokenList.prototype.forEach = Array.prototype.forEach;
    if (!Node.prototype.contains) Node.prototype.contains = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var node = args[0];
        if (!(0 in args)) throw new TypeError("1 argument is required");
        do {
            if (_this === node) return true;
        }while (node = node && node.parentNode);
        return false;
    };
}
function isSerializedIframe(n2, mirror2) {
    return Boolean(n2.nodeName === "IFRAME" && mirror2.getMeta(n2));
}
function isSerializedStylesheet(n2, mirror2) {
    return Boolean(n2.nodeName === "LINK" && n2.nodeType === n2.ELEMENT_NODE && n2.getAttribute && n2.getAttribute("rel") === "stylesheet" && mirror2.getMeta(n2));
}
function hasShadowRoot(n2) {
    return Boolean(n2 === null || n2 === void 0 ? void 0 : n2.shadowRoot);
}
var StyleSheetMirror = /*#__PURE__*/ function() {
    "use strict";
    function StyleSheetMirror() {
        (0, _classCallCheck._)(this, StyleSheetMirror);
        this.id = 1;
        this.styleIDMap = /* @__PURE__ */ new WeakMap();
        this.idStyleMap = /* @__PURE__ */ new Map();
    }
    (0, _createClass._)(StyleSheetMirror, [
        {
            key: "getId",
            value: function getId(stylesheet) {
                var _this_styleIDMap_get;
                return (_this_styleIDMap_get = this.styleIDMap.get(stylesheet)) !== null && _this_styleIDMap_get !== void 0 ? _this_styleIDMap_get : -1;
            }
        },
        {
            key: "has",
            value: function has(stylesheet) {
                return this.styleIDMap.has(stylesheet);
            }
        },
        {
            /**
   * @returns If the stylesheet is in the mirror, returns the id of the stylesheet. If not, return the new assigned id.
   */ key: "add",
            value: function add(stylesheet, id) {
                if (this.has(stylesheet)) return this.getId(stylesheet);
                var newId;
                if (id === void 0) newId = this.id++;
                else newId = id;
                this.styleIDMap.set(stylesheet, newId);
                this.idStyleMap.set(newId, stylesheet);
                return newId;
            }
        },
        {
            key: "getStyle",
            value: function getStyle(id) {
                return this.idStyleMap.get(id) || null;
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.styleIDMap = /* @__PURE__ */ new WeakMap();
                this.idStyleMap = /* @__PURE__ */ new Map();
                this.id = 1;
            }
        },
        {
            key: "generateId",
            value: function generateId() {
                return this.id++;
            }
        }
    ]);
    return StyleSheetMirror;
}();
function getShadowHost(n2) {
    var _n2_getRootNode, _n2_getRootNode1;
    var shadowHost = null;
    if (((_n2_getRootNode1 = n2.getRootNode) === null || _n2_getRootNode1 === void 0 ? void 0 : (_n2_getRootNode = _n2_getRootNode1.call(n2)) === null || _n2_getRootNode === void 0 ? void 0 : _n2_getRootNode.nodeType) === Node.DOCUMENT_FRAGMENT_NODE && n2.getRootNode().host) shadowHost = n2.getRootNode().host;
    return shadowHost;
}
function getRootShadowHost(n2) {
    var rootShadowHost = n2;
    var shadowHost;
    while(shadowHost = getShadowHost(rootShadowHost))rootShadowHost = shadowHost;
    return rootShadowHost;
}
function shadowHostInDom(n2) {
    var doc = n2.ownerDocument;
    if (!doc) return false;
    var shadowHost = getRootShadowHost(n2);
    return doc.contains(shadowHost);
}
function inDom(n2) {
    var doc = n2.ownerDocument;
    if (!doc) return false;
    return doc.contains(n2) || shadowHostInDom(n2);
}
var cachedImplementations = {};
function getImplementation(name) {
    var cached = cachedImplementations[name];
    if (cached) return cached;
    var document2 = window.document;
    var impl = window[name];
    if (document2 && typeof document2.createElement === "function") try {
        var sandbox = document2.createElement("iframe");
        sandbox.hidden = true;
        document2.head.appendChild(sandbox);
        var contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document2.head.removeChild(sandbox);
    } catch (e2) {}
    return cachedImplementations[name] = impl.bind(window);
}
function onRequestAnimationFrame() {
    for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++){
        rest[_key] = arguments[_key];
    }
    return getImplementation("requestAnimationFrame").apply(this, (0, _toConsumableArray._)(rest));
}
function setTimeout$1() {
    for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++){
        rest[_key] = arguments[_key];
    }
    return getImplementation("setTimeout").apply(this, (0, _toConsumableArray._)(rest));
}
function clearTimeout$2() {
    for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++){
        rest[_key] = arguments[_key];
    }
    return getImplementation("clearTimeout").apply(this, (0, _toConsumableArray._)(rest));
}
var EventType = /* @__PURE__ */ function(EventType2) {
    EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
    EventType2[EventType2["Load"] = 1] = "Load";
    EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
    EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    EventType2[EventType2["Meta"] = 4] = "Meta";
    EventType2[EventType2["Custom"] = 5] = "Custom";
    EventType2[EventType2["Plugin"] = 6] = "Plugin";
    return EventType2;
}(EventType || {});
var IncrementalSource = /* @__PURE__ */ function(IncrementalSource2) {
    IncrementalSource2[IncrementalSource2["Mutation"] = 0] = "Mutation";
    IncrementalSource2[IncrementalSource2["MouseMove"] = 1] = "MouseMove";
    IncrementalSource2[IncrementalSource2["MouseInteraction"] = 2] = "MouseInteraction";
    IncrementalSource2[IncrementalSource2["Scroll"] = 3] = "Scroll";
    IncrementalSource2[IncrementalSource2["ViewportResize"] = 4] = "ViewportResize";
    IncrementalSource2[IncrementalSource2["Input"] = 5] = "Input";
    IncrementalSource2[IncrementalSource2["TouchMove"] = 6] = "TouchMove";
    IncrementalSource2[IncrementalSource2["MediaInteraction"] = 7] = "MediaInteraction";
    IncrementalSource2[IncrementalSource2["StyleSheetRule"] = 8] = "StyleSheetRule";
    IncrementalSource2[IncrementalSource2["CanvasMutation"] = 9] = "CanvasMutation";
    IncrementalSource2[IncrementalSource2["Font"] = 10] = "Font";
    IncrementalSource2[IncrementalSource2["Log"] = 11] = "Log";
    IncrementalSource2[IncrementalSource2["Drag"] = 12] = "Drag";
    IncrementalSource2[IncrementalSource2["StyleDeclaration"] = 13] = "StyleDeclaration";
    IncrementalSource2[IncrementalSource2["Selection"] = 14] = "Selection";
    IncrementalSource2[IncrementalSource2["AdoptedStyleSheet"] = 15] = "AdoptedStyleSheet";
    IncrementalSource2[IncrementalSource2["CustomElement"] = 16] = "CustomElement";
    return IncrementalSource2;
}(IncrementalSource || {});
var MouseInteractions = /* @__PURE__ */ function(MouseInteractions2) {
    MouseInteractions2[MouseInteractions2["MouseUp"] = 0] = "MouseUp";
    MouseInteractions2[MouseInteractions2["MouseDown"] = 1] = "MouseDown";
    MouseInteractions2[MouseInteractions2["Click"] = 2] = "Click";
    MouseInteractions2[MouseInteractions2["ContextMenu"] = 3] = "ContextMenu";
    MouseInteractions2[MouseInteractions2["DblClick"] = 4] = "DblClick";
    MouseInteractions2[MouseInteractions2["Focus"] = 5] = "Focus";
    MouseInteractions2[MouseInteractions2["Blur"] = 6] = "Blur";
    MouseInteractions2[MouseInteractions2["TouchStart"] = 7] = "TouchStart";
    MouseInteractions2[MouseInteractions2["TouchMove_Departed"] = 8] = "TouchMove_Departed";
    MouseInteractions2[MouseInteractions2["TouchEnd"] = 9] = "TouchEnd";
    MouseInteractions2[MouseInteractions2["TouchCancel"] = 10] = "TouchCancel";
    return MouseInteractions2;
}(MouseInteractions || {});
var PointerTypes = /* @__PURE__ */ function(PointerTypes2) {
    PointerTypes2[PointerTypes2["Mouse"] = 0] = "Mouse";
    PointerTypes2[PointerTypes2["Pen"] = 1] = "Pen";
    PointerTypes2[PointerTypes2["Touch"] = 2] = "Touch";
    return PointerTypes2;
}(PointerTypes || {});
var MediaInteractions = /* @__PURE__ */ function(MediaInteractions2) {
    MediaInteractions2[MediaInteractions2["Play"] = 0] = "Play";
    MediaInteractions2[MediaInteractions2["Pause"] = 1] = "Pause";
    MediaInteractions2[MediaInteractions2["Seeked"] = 2] = "Seeked";
    MediaInteractions2[MediaInteractions2["VolumeChange"] = 3] = "VolumeChange";
    MediaInteractions2[MediaInteractions2["RateChange"] = 4] = "RateChange";
    return MediaInteractions2;
}(MediaInteractions || {});
function getIFrameContentDocument(iframe) {
    try {
        return iframe.contentDocument;
    } catch (e2) {}
}
function getIFrameContentWindow(iframe) {
    try {
        return iframe.contentWindow;
    } catch (e2) {}
}
function isNodeInLinkedList(n2) {
    return "__ln" in n2;
}
var DoubleLinkedList = /*#__PURE__*/ function() {
    "use strict";
    function DoubleLinkedList() {
        (0, _classCallCheck._)(this, DoubleLinkedList);
        this.length = 0;
        this.head = null;
        this.tail = null;
    }
    (0, _createClass._)(DoubleLinkedList, [
        {
            key: "get",
            value: function get(position) {
                if (position >= this.length) throw new Error("Position outside of list range");
                var current = this.head;
                for(var index = 0; index < position; index++)current = (current === null || current === void 0 ? void 0 : current.next) || null;
                return current;
            }
        },
        {
            key: "addNode",
            value: function addNode(n2) {
                var node = {
                    value: n2,
                    previous: null,
                    next: null
                };
                n2.__ln = node;
                if (n2.previousSibling && isNodeInLinkedList(n2.previousSibling)) {
                    var current = n2.previousSibling.__ln.next;
                    node.next = current;
                    node.previous = n2.previousSibling.__ln;
                    n2.previousSibling.__ln.next = node;
                    if (current) current.previous = node;
                } else if (n2.nextSibling && isNodeInLinkedList(n2.nextSibling) && n2.nextSibling.__ln.previous) {
                    var current1 = n2.nextSibling.__ln.previous;
                    node.previous = current1;
                    node.next = n2.nextSibling.__ln;
                    n2.nextSibling.__ln.previous = node;
                    if (current1) current1.next = node;
                } else {
                    if (this.head) this.head.previous = node;
                    node.next = this.head;
                    this.head = node;
                }
                if (node.next === null) this.tail = node;
                this.length++;
            }
        },
        {
            key: "removeNode",
            value: function removeNode(n2) {
                var current = n2.__ln;
                if (!this.head) return;
                if (!current.previous) {
                    this.head = current.next;
                    if (this.head) this.head.previous = null;
                    else this.tail = null;
                } else {
                    current.previous.next = current.next;
                    if (current.next) current.next.previous = current.previous;
                    else this.tail = current.previous;
                }
                if (n2.__ln) delete n2.__ln;
                this.length--;
            }
        }
    ]);
    return DoubleLinkedList;
}();
var moveKey = function(id, parentId) {
    return "".concat(id, "@").concat(parentId);
};
var MutationBuffer = /*#__PURE__*/ function() {
    "use strict";
    function MutationBuffer() {
        var _this = this;
        (0, _classCallCheck._)(this, MutationBuffer);
        this.frozen = false;
        this.locked = false;
        this.texts = [];
        this.attributes = [];
        this.attributeMap = /* @__PURE__ */ new WeakMap();
        this.removes = [];
        this.mapRemoves = [];
        this.movedMap = {};
        this.addedSet = /* @__PURE__ */ new Set();
        this.movedSet = /* @__PURE__ */ new Set();
        this.droppedSet = /* @__PURE__ */ new Set();
        this.processMutations = function(mutations) {
            mutations.forEach(_this.processMutation);
            _this.emit();
        };
        this.emit = function() {
            if (_this.frozen || _this.locked) return;
            var adds = [];
            var addedIds = /* @__PURE__ */ new Set();
            var addList = new DoubleLinkedList();
            var getNextId = function(n2) {
                var ns = n2;
                var nextId = IGNORED_NODE;
                while(nextId === IGNORED_NODE){
                    ns = ns && ns.nextSibling;
                    nextId = ns && _this.mirror.getId(ns);
                }
                return nextId;
            };
            var pushAdd = function(n2) {
                if (!n2.parentNode || !inDom(n2)) return;
                var parentId = isShadowRoot(n2.parentNode) ? _this.mirror.getId(getShadowHost(n2)) : _this.mirror.getId(n2.parentNode);
                var nextId = getNextId(n2);
                if (parentId === -1 || nextId === -1) return addList.addNode(n2);
                var sn = serializeNodeWithId(n2, {
                    doc: _this.doc,
                    mirror: _this.mirror,
                    blockClass: _this.blockClass,
                    blockSelector: _this.blockSelector,
                    maskAllText: _this.maskAllText,
                    unblockSelector: _this.unblockSelector,
                    maskTextClass: _this.maskTextClass,
                    unmaskTextClass: _this.unmaskTextClass,
                    maskTextSelector: _this.maskTextSelector,
                    unmaskTextSelector: _this.unmaskTextSelector,
                    skipChild: true,
                    newlyAddedElement: true,
                    inlineStylesheet: _this.inlineStylesheet,
                    maskInputOptions: _this.maskInputOptions,
                    maskAttributeFn: _this.maskAttributeFn,
                    maskTextFn: _this.maskTextFn,
                    maskInputFn: _this.maskInputFn,
                    slimDOMOptions: _this.slimDOMOptions,
                    dataURLOptions: _this.dataURLOptions,
                    recordCanvas: _this.recordCanvas,
                    inlineImages: _this.inlineImages,
                    onSerialize: function(currentN) {
                        if (isSerializedIframe(currentN, _this.mirror) && !isBlocked(currentN, _this.blockClass, _this.blockSelector, _this.unblockSelector, false)) _this.iframeManager.addIframe(currentN);
                        if (isSerializedStylesheet(currentN, _this.mirror)) _this.stylesheetManager.trackLinkElement(currentN);
                        if (hasShadowRoot(n2)) _this.shadowDomManager.addShadowRoot(n2.shadowRoot, _this.doc);
                    },
                    onIframeLoad: function(iframe, childSn) {
                        if (isBlocked(iframe, _this.blockClass, _this.blockSelector, _this.unblockSelector, false)) return;
                        _this.iframeManager.attachIframe(iframe, childSn);
                        if (iframe.contentWindow) _this.canvasManager.addWindow(iframe.contentWindow);
                        _this.shadowDomManager.observeAttachShadow(iframe);
                    },
                    onStylesheetLoad: function(link, childSn) {
                        _this.stylesheetManager.attachLinkElement(link, childSn);
                    },
                    onBlockedImageLoad: function(_imageEl, serializedNode, param) {
                        var width = param.width, height = param.height;
                        _this.mutationCb({
                            adds: [],
                            removes: [],
                            texts: [],
                            attributes: [
                                {
                                    id: serializedNode.id,
                                    attributes: {
                                        style: {
                                            width: "".concat(width, "px"),
                                            height: "".concat(height, "px")
                                        }
                                    }
                                }
                            ]
                        });
                    },
                    ignoreCSSAttributes: _this.ignoreCSSAttributes
                });
                if (sn) {
                    adds.push({
                        parentId: parentId,
                        nextId: nextId,
                        node: sn
                    });
                    addedIds.add(sn.id);
                }
            };
            while(_this.mapRemoves.length)_this.mirror.removeNodeFromMap(_this.mapRemoves.shift());
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = _this.movedSet[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var n2 = _step.value;
                    if (isParentRemoved(_this.removes, n2, _this.mirror) && !_this.movedSet.has(n2.parentNode)) continue;
                    pushAdd(n2);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = _this.addedSet[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var n21 = _step1.value;
                    if (!isAncestorInSet(_this.droppedSet, n21) && !isParentRemoved(_this.removes, n21, _this.mirror)) pushAdd(n21);
                    else if (isAncestorInSet(_this.movedSet, n21)) pushAdd(n21);
                    else _this.droppedSet.add(n21);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            var candidate = null;
            while(addList.length){
                var node = null;
                if (candidate) {
                    var parentId = _this.mirror.getId(candidate.value.parentNode);
                    var nextId = getNextId(candidate.value);
                    if (parentId !== -1 && nextId !== -1) node = candidate;
                }
                if (!node) {
                    var tailNode = addList.tail;
                    while(tailNode){
                        var _node = tailNode;
                        tailNode = tailNode.previous;
                        if (_node) {
                            var parentId1 = _this.mirror.getId(_node.value.parentNode);
                            var nextId1 = getNextId(_node.value);
                            if (nextId1 === -1) continue;
                            else if (parentId1 !== -1) {
                                node = _node;
                                break;
                            } else {
                                var unhandledNode = _node.value;
                                if (unhandledNode.parentNode && unhandledNode.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                                    var shadowHost = unhandledNode.parentNode.host;
                                    var parentId2 = _this.mirror.getId(shadowHost);
                                    if (parentId2 !== -1) {
                                        node = _node;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
                if (!node) {
                    while(addList.head)addList.removeNode(addList.head.value);
                    break;
                }
                candidate = node.previous;
                addList.removeNode(node.value);
                pushAdd(node.value);
            }
            var payload = {
                texts: _this.texts.map(function(text) {
                    return {
                        id: _this.mirror.getId(text.node),
                        value: text.value
                    };
                }).filter(function(text) {
                    return !addedIds.has(text.id);
                }).filter(function(text) {
                    return _this.mirror.has(text.id);
                }),
                attributes: _this.attributes.map(function(attribute) {
                    var attributes = attribute.attributes;
                    if (typeof attributes.style === "string") {
                        var diffAsStr = JSON.stringify(attribute.styleDiff);
                        var unchangedAsStr = JSON.stringify(attribute._unchangedStyles);
                        if (diffAsStr.length < attributes.style.length) {
                            if ((diffAsStr + unchangedAsStr).split("var(").length === attributes.style.split("var(").length) attributes.style = attribute.styleDiff;
                        }
                    }
                    return {
                        id: _this.mirror.getId(attribute.node),
                        attributes: attributes
                    };
                }).filter(function(attribute) {
                    return !addedIds.has(attribute.id);
                }).filter(function(attribute) {
                    return _this.mirror.has(attribute.id);
                }),
                removes: _this.removes,
                adds: adds
            };
            if (!payload.texts.length && !payload.attributes.length && !payload.removes.length && !payload.adds.length) return;
            _this.texts = [];
            _this.attributes = [];
            _this.attributeMap = /* @__PURE__ */ new WeakMap();
            _this.removes = [];
            _this.addedSet = /* @__PURE__ */ new Set();
            _this.movedSet = /* @__PURE__ */ new Set();
            _this.droppedSet = /* @__PURE__ */ new Set();
            _this.movedMap = {};
            _this.mutationCb(payload);
        };
        this.processMutation = function(m) {
            if (isIgnored(m.target, _this.mirror)) return;
            switch(m.type){
                case "characterData":
                    {
                        var value = m.target.textContent;
                        if (!isBlocked(m.target, _this.blockClass, _this.blockSelector, _this.unblockSelector, false) && value !== m.oldValue) _this.texts.push({
                            value: needMaskingText(m.target, _this.maskTextClass, _this.maskTextSelector, _this.unmaskTextClass, _this.unmaskTextSelector, _this.maskAllText) && value ? _this.maskTextFn ? _this.maskTextFn(value, closestElementOfNode$1(m.target)) : value.replace(/[\S]/g, "*") : value,
                            node: m.target
                        });
                        break;
                    }
                case "attributes":
                    {
                        var target = m.target;
                        var attributeName = m.attributeName;
                        var value1 = m.target.getAttribute(attributeName);
                        if (attributeName === "value") {
                            var type = getInputType(target);
                            var tagName = target.tagName;
                            value1 = getInputValue(target, tagName, type);
                            var isInputMasked = shouldMaskInput({
                                maskInputOptions: _this.maskInputOptions,
                                tagName: tagName,
                                type: type
                            });
                            var forceMask = needMaskingText(m.target, _this.maskTextClass, _this.maskTextSelector, _this.unmaskTextClass, _this.unmaskTextSelector, isInputMasked);
                            value1 = maskInputValue({
                                isMasked: forceMask,
                                element: target,
                                value: value1,
                                maskInputFn: _this.maskInputFn
                            });
                        }
                        if (isBlocked(m.target, _this.blockClass, _this.blockSelector, _this.unblockSelector, false) || value1 === m.oldValue) return;
                        var item = _this.attributeMap.get(m.target);
                        if (target.tagName === "IFRAME" && attributeName === "src" && !_this.keepIframeSrcFn(value1)) {
                            var iframeDoc = getIFrameContentDocument(target);
                            if (!iframeDoc) attributeName = "rr_src";
                            else return;
                        }
                        if (!item) {
                            item = {
                                node: m.target,
                                attributes: {},
                                styleDiff: {},
                                _unchangedStyles: {}
                            };
                            _this.attributes.push(item);
                            _this.attributeMap.set(m.target, item);
                        }
                        if (attributeName === "type" && target.tagName === "INPUT" && (m.oldValue || "").toLowerCase() === "password") target.setAttribute("data-rr-is-password", "true");
                        if (!ignoreAttribute(target.tagName, attributeName)) {
                            item.attributes[attributeName] = transformAttribute(_this.doc, toLowerCase(target.tagName), toLowerCase(attributeName), value1, target, _this.maskAttributeFn);
                            if (attributeName === "style") {
                                if (!_this.unattachedDoc) try {
                                    _this.unattachedDoc = document.implementation.createHTMLDocument();
                                } catch (e2) {
                                    _this.unattachedDoc = _this.doc;
                                }
                                var old = _this.unattachedDoc.createElement("span");
                                if (m.oldValue) old.setAttribute("style", m.oldValue);
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = Array.from(target.style)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var pname = _step.value;
                                        var newValue = target.style.getPropertyValue(pname);
                                        var newPriority = target.style.getPropertyPriority(pname);
                                        if (newValue !== old.style.getPropertyValue(pname) || newPriority !== old.style.getPropertyPriority(pname)) {
                                            if (newPriority === "") item.styleDiff[pname] = newValue;
                                            else item.styleDiff[pname] = [
                                                newValue,
                                                newPriority
                                            ];
                                        } else item._unchangedStyles[pname] = [
                                            newValue,
                                            newPriority
                                        ];
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                try {
                                    for(var _iterator1 = Array.from(old.style)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                        var pname1 = _step1.value;
                                        if (target.style.getPropertyValue(pname1) === "") item.styleDiff[pname1] = false;
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                            _iterator1.return();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                            }
                        }
                        break;
                    }
                case "childList":
                    if (isBlocked(m.target, _this.blockClass, _this.blockSelector, _this.unblockSelector, true)) return;
                    m.addedNodes.forEach(function(n2) {
                        return _this.genAdds(n2, m.target);
                    });
                    m.removedNodes.forEach(function(n2) {
                        var nodeId = _this.mirror.getId(n2);
                        var parentId = isShadowRoot(m.target) ? _this.mirror.getId(m.target.host) : _this.mirror.getId(m.target);
                        if (isBlocked(m.target, _this.blockClass, _this.blockSelector, _this.unblockSelector, false) || isIgnored(n2, _this.mirror) || !isSerialized(n2, _this.mirror)) return;
                        if (_this.addedSet.has(n2)) {
                            deepDelete(_this.addedSet, n2);
                            _this.droppedSet.add(n2);
                        } else if (_this.addedSet.has(m.target) && nodeId === -1) ;
                        else if (isAncestorRemoved(m.target, _this.mirror)) ;
                        else if (_this.movedSet.has(n2) && _this.movedMap[moveKey(nodeId, parentId)]) deepDelete(_this.movedSet, n2);
                        else _this.removes.push({
                            parentId: parentId,
                            id: nodeId,
                            isShadow: isShadowRoot(m.target) && isNativeShadowDom(m.target) ? true : void 0
                        });
                        _this.mapRemoves.push(n2);
                    });
                    break;
            }
        };
        this.genAdds = function(n2, target) {
            if (_this.processedNodeManager.inOtherBuffer(n2, _this)) return;
            if (_this.addedSet.has(n2) || _this.movedSet.has(n2)) return;
            if (_this.mirror.hasNode(n2)) {
                if (isIgnored(n2, _this.mirror)) return;
                _this.movedSet.add(n2);
                var targetId = null;
                if (target && _this.mirror.hasNode(target)) targetId = _this.mirror.getId(target);
                if (targetId && targetId !== -1) _this.movedMap[moveKey(_this.mirror.getId(n2), targetId)] = true;
            } else {
                _this.addedSet.add(n2);
                _this.droppedSet.delete(n2);
            }
            if (!isBlocked(n2, _this.blockClass, _this.blockSelector, _this.unblockSelector, false)) {
                if (n2.childNodes) n2.childNodes.forEach(function(childN) {
                    return _this.genAdds(childN);
                });
                if (hasShadowRoot(n2)) n2.shadowRoot.childNodes.forEach(function(childN) {
                    _this.processedNodeManager.add(childN, _this);
                    _this.genAdds(childN, n2);
                });
            }
        };
    }
    (0, _createClass._)(MutationBuffer, [
        {
            key: "init",
            value: function init(options) {
                var _this = this;
                [
                    "mutationCb",
                    "blockClass",
                    "blockSelector",
                    "unblockSelector",
                    "maskAllText",
                    "maskTextClass",
                    "unmaskTextClass",
                    "maskTextSelector",
                    "unmaskTextSelector",
                    "inlineStylesheet",
                    "maskInputOptions",
                    "maskAttributeFn",
                    "maskTextFn",
                    "maskInputFn",
                    "keepIframeSrcFn",
                    "recordCanvas",
                    "inlineImages",
                    "slimDOMOptions",
                    "dataURLOptions",
                    "doc",
                    "mirror",
                    "iframeManager",
                    "stylesheetManager",
                    "shadowDomManager",
                    "canvasManager",
                    "processedNodeManager",
                    "ignoreCSSAttributes"
                ].forEach(function(key) {
                    _this[key] = options[key];
                });
            }
        },
        {
            key: "freeze",
            value: function freeze() {
                this.frozen = true;
                this.canvasManager.freeze();
            }
        },
        {
            key: "unfreeze",
            value: function unfreeze() {
                this.frozen = false;
                this.canvasManager.unfreeze();
                this.emit();
            }
        },
        {
            key: "isFrozen",
            value: function isFrozen() {
                return this.frozen;
            }
        },
        {
            key: "lock",
            value: function lock() {
                this.locked = true;
                this.canvasManager.lock();
            }
        },
        {
            key: "unlock",
            value: function unlock() {
                this.locked = false;
                this.canvasManager.unlock();
                this.emit();
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.shadowDomManager.reset();
                this.canvasManager.reset();
            }
        }
    ]);
    return MutationBuffer;
}();
function deepDelete(addsSet, n2) {
    var _n2_childNodes;
    addsSet.delete(n2);
    (_n2_childNodes = n2.childNodes) === null || _n2_childNodes === void 0 ? void 0 : _n2_childNodes.forEach(function(childN) {
        return deepDelete(addsSet, childN);
    });
}
function isParentRemoved(removes, n2, mirror2) {
    if (removes.length === 0) return false;
    return _isParentRemoved(removes, n2, mirror2);
}
function _isParentRemoved(removes, n2, mirror2) {
    var _loop = function() {
        var parentId = mirror2.getId(node);
        if (removes.some(function(r2) {
            return r2.id === parentId;
        })) return {
            v: true
        };
        node = node.parentNode;
    };
    var node = n2.parentNode;
    while(node){
        var _ret = _loop();
        if ((0, _typeOf._)(_ret) === "object") return _ret.v;
    }
    return false;
}
function isAncestorInSet(set, n2) {
    if (set.size === 0) return false;
    return _isAncestorInSet(set, n2);
}
function _isAncestorInSet(set, n2) {
    var parentNode = n2.parentNode;
    if (!parentNode) return false;
    if (set.has(parentNode)) return true;
    return _isAncestorInSet(set, parentNode);
}
var errorHandler;
function registerErrorHandler(handler) {
    errorHandler = handler;
}
function unregisterErrorHandler() {
    errorHandler = void 0;
}
var callbackWrapper = function(cb) {
    if (!errorHandler) return cb;
    var rrwebWrapped = function() {
        for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++){
            rest[_key] = arguments[_key];
        }
        try {
            return cb.apply(void 0, (0, _toConsumableArray._)(rest));
        } catch (error) {
            if (errorHandler && errorHandler(error) === true) return function() {};
            throw error;
        }
    };
    return rrwebWrapped;
};
var mutationBuffers = [];
function getEventTarget(event) {
    try {
        if ("composedPath" in event) {
            var path = event.composedPath();
            if (path.length) return path[0];
        } else if ("path" in event && event.path.length) return event.path[0];
    } catch (e) {}
    return event && event.target;
}
function initMutationObserver(options, rootEl) {
    var _window_Zone___symbol__, _window_Zone, _window;
    var mutationBuffer = new MutationBuffer();
    mutationBuffers.push(mutationBuffer);
    mutationBuffer.init(options);
    var mutationObserverCtor = window.MutationObserver || /**
  * Some websites may disable MutationObserver by removing it from the window object.
  * If someone is using rrweb to build a browser extention or things like it, they
  * could not change the website's code but can have an opportunity to inject some
  * code before the website executing its JS logic.
  * Then they can do this to store the native MutationObserver:
  * window.__rrMutationObserver = MutationObserver
  */ window.__rrMutationObserver;
    var angularZoneSymbol = (_window = window) === null || _window === void 0 ? void 0 : (_window_Zone = _window.Zone) === null || _window_Zone === void 0 ? void 0 : (_window_Zone___symbol__ = _window_Zone.__symbol__) === null || _window_Zone___symbol__ === void 0 ? void 0 : _window_Zone___symbol__.call(_window_Zone, "MutationObserver");
    if (angularZoneSymbol && window[angularZoneSymbol]) mutationObserverCtor = window[angularZoneSymbol];
    var observer = new mutationObserverCtor(callbackWrapper(function(mutations) {
        if (options.onMutation && options.onMutation(mutations) === false) return;
        mutationBuffer.processMutations.bind(mutationBuffer)(mutations);
    }));
    observer.observe(rootEl, {
        attributes: true,
        attributeOldValue: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true
    });
    return observer;
}
function initMoveObserver(param) {
    var mousemoveCb = param.mousemoveCb, sampling = param.sampling, doc = param.doc, mirror2 = param.mirror;
    if (sampling.mousemove === false) return function() {};
    var threshold = typeof sampling.mousemove === "number" ? sampling.mousemove : 50;
    var callbackThreshold = typeof sampling.mousemoveCallback === "number" ? sampling.mousemoveCallback : 500;
    var positions = [];
    var timeBaseline;
    var wrappedCb = throttle$1(callbackWrapper(function(source) {
        var totalOffset = Date.now() - timeBaseline;
        mousemoveCb(positions.map(function(p) {
            p.timeOffset -= totalOffset;
            return p;
        }), source);
        positions = [];
        timeBaseline = null;
    }), callbackThreshold);
    var updatePosition = callbackWrapper(throttle$1(callbackWrapper(function(evt) {
        var target = getEventTarget(evt);
        var _ref = legacy_isTouchEvent(evt) ? evt.changedTouches[0] : evt, clientX = _ref.clientX, clientY = _ref.clientY;
        if (!timeBaseline) timeBaseline = nowTimestamp();
        positions.push({
            x: clientX,
            y: clientY,
            id: mirror2.getId(target),
            timeOffset: nowTimestamp() - timeBaseline
        });
        wrappedCb(typeof DragEvent !== "undefined" && (0, _instanceof._)(evt, DragEvent) ? IncrementalSource.Drag : (0, _instanceof._)(evt, MouseEvent) ? IncrementalSource.MouseMove : IncrementalSource.TouchMove);
    }), threshold, {
        trailing: false
    }));
    var handlers = [
        on("mousemove", updatePosition, doc),
        on("touchmove", updatePosition, doc),
        on("drag", updatePosition, doc)
    ];
    return callbackWrapper(function() {
        handlers.forEach(function(h) {
            return h();
        });
    });
}
function initMouseInteractionObserver(param) {
    var mouseInteractionCb = param.mouseInteractionCb, doc = param.doc, mirror2 = param.mirror, blockClass = param.blockClass, blockSelector = param.blockSelector, unblockSelector = param.unblockSelector, sampling = param.sampling;
    if (sampling.mouseInteraction === false) return function() {};
    var disableMap = sampling.mouseInteraction === true || sampling.mouseInteraction === void 0 ? {} : sampling.mouseInteraction;
    var handlers = [];
    var currentPointerType = null;
    var getHandler = function(eventKey) {
        return function(event) {
            var target = getEventTarget(event);
            if (isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            var pointerType = null;
            var thisEventKey = eventKey;
            if ("pointerType" in event) {
                switch(event.pointerType){
                    case "mouse":
                        pointerType = PointerTypes.Mouse;
                        break;
                    case "touch":
                        pointerType = PointerTypes.Touch;
                        break;
                    case "pen":
                        pointerType = PointerTypes.Pen;
                        break;
                }
                if (pointerType === PointerTypes.Touch) {
                    if (MouseInteractions[eventKey] === MouseInteractions.MouseDown) thisEventKey = "TouchStart";
                    else if (MouseInteractions[eventKey] === MouseInteractions.MouseUp) thisEventKey = "TouchEnd";
                } else PointerTypes.Pen;
            } else if (legacy_isTouchEvent(event)) pointerType = PointerTypes.Touch;
            if (pointerType !== null) {
                currentPointerType = pointerType;
                if (thisEventKey.startsWith("Touch") && pointerType === PointerTypes.Touch || thisEventKey.startsWith("Mouse") && pointerType === PointerTypes.Mouse) pointerType = null;
            } else if (MouseInteractions[eventKey] === MouseInteractions.Click) {
                pointerType = currentPointerType;
                currentPointerType = null;
            }
            var e2 = legacy_isTouchEvent(event) ? event.changedTouches[0] : event;
            if (!e2) return;
            var id = mirror2.getId(target);
            var clientX = e2.clientX, clientY = e2.clientY;
            callbackWrapper(mouseInteractionCb)((0, _objectSpread._)({
                type: MouseInteractions[thisEventKey],
                id: id,
                x: clientX,
                y: clientY
            }, pointerType !== null && {
                pointerType: pointerType
            }));
        };
    };
    Object.keys(MouseInteractions).filter(function(key) {
        return Number.isNaN(Number(key)) && !key.endsWith("_Departed") && disableMap[key] !== false;
    }).forEach(function(eventKey) {
        var eventName = toLowerCase(eventKey);
        var handler = getHandler(eventKey);
        if (window.PointerEvent) switch(MouseInteractions[eventKey]){
            case MouseInteractions.MouseDown:
            case MouseInteractions.MouseUp:
                eventName = eventName.replace("mouse", "pointer");
                break;
            case MouseInteractions.TouchStart:
            case MouseInteractions.TouchEnd:
                return;
        }
        handlers.push(on(eventName, handler, doc));
    });
    return callbackWrapper(function() {
        handlers.forEach(function(h) {
            return h();
        });
    });
}
function initScrollObserver(param) {
    var scrollCb = param.scrollCb, doc = param.doc, mirror2 = param.mirror, blockClass = param.blockClass, blockSelector = param.blockSelector, unblockSelector = param.unblockSelector, sampling = param.sampling;
    var updatePosition = callbackWrapper(throttle$1(callbackWrapper(function(evt) {
        var target = getEventTarget(evt);
        if (!target || isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        var id = mirror2.getId(target);
        if (target === doc && doc.defaultView) {
            var scrollLeftTop = getWindowScroll(doc.defaultView);
            scrollCb({
                id: id,
                x: scrollLeftTop.left,
                y: scrollLeftTop.top
            });
        } else scrollCb({
            id: id,
            x: target.scrollLeft,
            y: target.scrollTop
        });
    }), sampling.scroll || 100));
    return on("scroll", updatePosition, doc);
}
function initViewportResizeObserver(param, param1) {
    var viewportResizeCb = param.viewportResizeCb, win = param1.win;
    var lastH = -1;
    var lastW = -1;
    var updateDimension = callbackWrapper(throttle$1(callbackWrapper(function() {
        var height = getWindowHeight();
        var width = getWindowWidth();
        if (lastH !== height || lastW !== width) {
            viewportResizeCb({
                width: Number(width),
                height: Number(height)
            });
            lastH = height;
            lastW = width;
        }
    }), 200));
    return on("resize", updateDimension, win);
}
var INPUT_TAGS = [
    "INPUT",
    "TEXTAREA",
    "SELECT"
];
var lastInputValueMap = /* @__PURE__ */ new WeakMap();
function initInputObserver(param) {
    var inputCb = param.inputCb, doc = param.doc, mirror2 = param.mirror, blockClass = param.blockClass, blockSelector = param.blockSelector, unblockSelector = param.unblockSelector, ignoreClass = param.ignoreClass, ignoreSelector = param.ignoreSelector, maskInputOptions = param.maskInputOptions, maskInputFn = param.maskInputFn, sampling = param.sampling, userTriggeredOnInput = param.userTriggeredOnInput, maskTextClass = param.maskTextClass, unmaskTextClass = param.unmaskTextClass, maskTextSelector = param.maskTextSelector, unmaskTextSelector = param.unmaskTextSelector;
    var _handlers;
    function eventHandler(event) {
        var target = getEventTarget(event);
        var userTriggered = event.isTrusted;
        var tagName = target && toUpperCase(target.tagName);
        if (tagName === "OPTION") target = target.parentElement;
        if (!target || !tagName || INPUT_TAGS.indexOf(tagName) < 0 || isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        var el = target;
        if (el.classList.contains(ignoreClass) || ignoreSelector && el.matches(ignoreSelector)) return;
        var type = getInputType(target);
        var text = getInputValue(el, tagName, type);
        var isChecked = false;
        var isInputMasked = shouldMaskInput({
            maskInputOptions: maskInputOptions,
            tagName: tagName,
            type: type
        });
        var forceMask = needMaskingText(target, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked);
        if (type === "radio" || type === "checkbox") isChecked = target.checked;
        text = maskInputValue({
            isMasked: forceMask,
            element: target,
            value: text,
            maskInputFn: maskInputFn
        });
        cbWithDedup(target, userTriggeredOnInput ? {
            text: text,
            isChecked: isChecked,
            userTriggered: userTriggered
        } : {
            text: text,
            isChecked: isChecked
        });
        var name = target.name;
        if (type === "radio" && name && isChecked) doc.querySelectorAll('input[type="radio"][name="'.concat(name, '"]')).forEach(function(el2) {
            if (el2 !== target) {
                var text2 = maskInputValue({
                    // share mask behavior of `target`
                    isMasked: forceMask,
                    element: el2,
                    value: getInputValue(el2, tagName, type),
                    maskInputFn: maskInputFn
                });
                cbWithDedup(el2, userTriggeredOnInput ? {
                    text: text2,
                    isChecked: !isChecked,
                    userTriggered: false
                } : {
                    text: text2,
                    isChecked: !isChecked
                });
            }
        });
    }
    function cbWithDedup(target, v2) {
        var lastInputValue = lastInputValueMap.get(target);
        if (!lastInputValue || lastInputValue.text !== v2.text || lastInputValue.isChecked !== v2.isChecked) {
            lastInputValueMap.set(target, v2);
            var id = mirror2.getId(target);
            callbackWrapper(inputCb)((0, _objectSpreadProps._)((0, _objectSpread._)({}, v2), {
                id: id
            }));
        }
    }
    var events = sampling.input === "last" ? [
        "change"
    ] : [
        "input",
        "change"
    ];
    var handlers = events.map(function(eventName) {
        return on(eventName, callbackWrapper(eventHandler), doc);
    });
    var currentWindow = doc.defaultView;
    if (!currentWindow) return function() {
        handlers.forEach(function(h) {
            return h();
        });
    };
    var propertyDescriptor = currentWindow.Object.getOwnPropertyDescriptor(currentWindow.HTMLInputElement.prototype, "value");
    var hookProperties = [
        [
            currentWindow.HTMLInputElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLInputElement.prototype,
            "checked"
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLTextAreaElement.prototype,
            "value"
        ],
        // Some UI library use selectedIndex to set select value
        [
            currentWindow.HTMLSelectElement.prototype,
            "selectedIndex"
        ],
        [
            currentWindow.HTMLOptionElement.prototype,
            "selected"
        ]
    ];
    if (propertyDescriptor && propertyDescriptor.set) (_handlers = handlers).push.apply(_handlers, (0, _toConsumableArray._)(hookProperties.map(function(p) {
        return hookSetter(p[0], p[1], {
            set: function set() {
                callbackWrapper(eventHandler)({
                    target: this,
                    isTrusted: false
                });
            }
        }, false, currentWindow);
    })));
    return callbackWrapper(function() {
        handlers.forEach(function(h) {
            return h();
        });
    });
}
function getNestedCSSRulePositions(rule) {
    var positions = [];
    function recurse(childRule, pos) {
        if (hasNestedCSSRule("CSSGroupingRule") && (0, _instanceof._)(childRule.parentRule, CSSGroupingRule) || hasNestedCSSRule("CSSMediaRule") && (0, _instanceof._)(childRule.parentRule, CSSMediaRule) || hasNestedCSSRule("CSSSupportsRule") && (0, _instanceof._)(childRule.parentRule, CSSSupportsRule) || hasNestedCSSRule("CSSConditionRule") && (0, _instanceof._)(childRule.parentRule, CSSConditionRule)) {
            var rules2 = Array.from(childRule.parentRule.cssRules);
            var index = rules2.indexOf(childRule);
            pos.unshift(index);
        } else if (childRule.parentStyleSheet) {
            var rules21 = Array.from(childRule.parentStyleSheet.cssRules);
            var index1 = rules21.indexOf(childRule);
            pos.unshift(index1);
        }
        return pos;
    }
    return recurse(rule, positions);
}
function getIdAndStyleId(sheet, mirror2, styleMirror) {
    var id, styleId;
    if (!sheet) return {};
    if (sheet.ownerNode) id = mirror2.getId(sheet.ownerNode);
    else styleId = styleMirror.getId(sheet);
    return {
        styleId: styleId,
        id: id
    };
}
function initStyleSheetObserver(param, param1) {
    var styleSheetRuleCb = param.styleSheetRuleCb, mirror2 = param.mirror, stylesheetManager = param.stylesheetManager, win = param1.win;
    if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) return function() {};
    var insertRule = win.CSSStyleSheet.prototype.insertRule;
    win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
        apply: callbackWrapper(function(target, thisArg, argumentsList) {
            var _argumentsList = (0, _slicedToArray._)(argumentsList, 2), rule = _argumentsList[0], index = _argumentsList[1];
            var _getIdAndStyleId = getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                adds: [
                    {
                        rule: rule,
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    var deleteRule = win.CSSStyleSheet.prototype.deleteRule;
    win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
        apply: callbackWrapper(function(target, thisArg, argumentsList) {
            var _argumentsList = (0, _slicedToArray._)(argumentsList, 1), index = _argumentsList[0];
            var _getIdAndStyleId = getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                removes: [
                    {
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    var replace;
    if (win.CSSStyleSheet.prototype.replace) {
        replace = win.CSSStyleSheet.prototype.replace;
        win.CSSStyleSheet.prototype.replace = new Proxy(replace, {
            apply: callbackWrapper(function(target, thisArg, argumentsList) {
                var _argumentsList = (0, _slicedToArray._)(argumentsList, 1), text = _argumentsList[0];
                var _getIdAndStyleId = getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replace: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    var replaceSync;
    if (win.CSSStyleSheet.prototype.replaceSync) {
        replaceSync = win.CSSStyleSheet.prototype.replaceSync;
        win.CSSStyleSheet.prototype.replaceSync = new Proxy(replaceSync, {
            apply: callbackWrapper(function(target, thisArg, argumentsList) {
                var _argumentsList = (0, _slicedToArray._)(argumentsList, 1), text = _argumentsList[0];
                var _getIdAndStyleId = getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replaceSync: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    var supportedNestedCSSRuleTypes = {};
    if (canMonkeyPatchNestedCSSRule("CSSGroupingRule")) supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
    else {
        if (canMonkeyPatchNestedCSSRule("CSSMediaRule")) supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
        if (canMonkeyPatchNestedCSSRule("CSSConditionRule")) supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
        if (canMonkeyPatchNestedCSSRule("CSSSupportsRule")) supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
    }
    var unmodifiedFunctions = {};
    Object.entries(supportedNestedCSSRuleTypes).forEach(function(param) {
        var _param = (0, _slicedToArray._)(param, 2), typeKey = _param[0], type = _param[1];
        unmodifiedFunctions[typeKey] = {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            insertRule: type.prototype.insertRule,
            // eslint-disable-next-line @typescript-eslint/unbound-method
            deleteRule: type.prototype.deleteRule
        };
        type.prototype.insertRule = new Proxy(unmodifiedFunctions[typeKey].insertRule, {
            apply: callbackWrapper(function(target, thisArg, argumentsList) {
                var _argumentsList = (0, _slicedToArray._)(argumentsList, 2), rule = _argumentsList[0], index = _argumentsList[1];
                var _getIdAndStyleId = getIdAndStyleId(thisArg.parentStyleSheet, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    adds: [
                        {
                            rule: rule,
                            index: (0, _toConsumableArray._)(getNestedCSSRulePositions(thisArg)).concat([
                                index || 0
                            ])
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
        type.prototype.deleteRule = new Proxy(unmodifiedFunctions[typeKey].deleteRule, {
            apply: callbackWrapper(function(target, thisArg, argumentsList) {
                var _argumentsList = (0, _slicedToArray._)(argumentsList, 1), index = _argumentsList[0];
                var _getIdAndStyleId = getIdAndStyleId(thisArg.parentStyleSheet, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    removes: [
                        {
                            index: (0, _toConsumableArray._)(getNestedCSSRulePositions(thisArg)).concat([
                                index
                            ])
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    });
    return callbackWrapper(function() {
        win.CSSStyleSheet.prototype.insertRule = insertRule;
        win.CSSStyleSheet.prototype.deleteRule = deleteRule;
        replace && (win.CSSStyleSheet.prototype.replace = replace);
        replaceSync && (win.CSSStyleSheet.prototype.replaceSync = replaceSync);
        Object.entries(supportedNestedCSSRuleTypes).forEach(function(param) {
            var _param = (0, _slicedToArray._)(param, 2), typeKey = _param[0], type = _param[1];
            type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
            type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
        });
    });
}
function initAdoptedStyleSheetObserver(param, host) {
    var mirror2 = param.mirror, stylesheetManager = param.stylesheetManager;
    var _host_defaultView, _host_ownerDocument_defaultView, _host_ownerDocument;
    var hostId = null;
    if (host.nodeName === "#document") hostId = mirror2.getId(host);
    else hostId = mirror2.getId(host.host);
    var patchTarget = host.nodeName === "#document" ? (_host_defaultView = host.defaultView) === null || _host_defaultView === void 0 ? void 0 : _host_defaultView.Document : (_host_ownerDocument = host.ownerDocument) === null || _host_ownerDocument === void 0 ? void 0 : (_host_ownerDocument_defaultView = _host_ownerDocument.defaultView) === null || _host_ownerDocument_defaultView === void 0 ? void 0 : _host_ownerDocument_defaultView.ShadowRoot;
    var originalPropertyDescriptor = (patchTarget === null || patchTarget === void 0 ? void 0 : patchTarget.prototype) ? Object.getOwnPropertyDescriptor(patchTarget === null || patchTarget === void 0 ? void 0 : patchTarget.prototype, "adoptedStyleSheets") : void 0;
    if (hostId === null || hostId === -1 || !patchTarget || !originalPropertyDescriptor) return function() {};
    Object.defineProperty(host, "adoptedStyleSheets", {
        configurable: originalPropertyDescriptor.configurable,
        enumerable: originalPropertyDescriptor.enumerable,
        get: function get() {
            var _originalPropertyDescriptor_get;
            return (_originalPropertyDescriptor_get = originalPropertyDescriptor.get) === null || _originalPropertyDescriptor_get === void 0 ? void 0 : _originalPropertyDescriptor_get.call(this);
        },
        set: function set(sheets) {
            var _originalPropertyDescriptor_set;
            var result = (_originalPropertyDescriptor_set = originalPropertyDescriptor.set) === null || _originalPropertyDescriptor_set === void 0 ? void 0 : _originalPropertyDescriptor_set.call(this, sheets);
            if (hostId !== null && hostId !== -1) try {
                stylesheetManager.adoptStyleSheets(sheets, hostId);
            } catch (e2) {}
            return result;
        }
    });
    return callbackWrapper(function() {
        Object.defineProperty(host, "adoptedStyleSheets", {
            configurable: originalPropertyDescriptor.configurable,
            enumerable: originalPropertyDescriptor.enumerable,
            // eslint-disable-next-line @typescript-eslint/unbound-method
            get: originalPropertyDescriptor.get,
            // eslint-disable-next-line @typescript-eslint/unbound-method
            set: originalPropertyDescriptor.set
        });
    });
}
function initStyleDeclarationObserver(param, param1) {
    var styleDeclarationCb = param.styleDeclarationCb, mirror2 = param.mirror, ignoreCSSAttributes = param.ignoreCSSAttributes, stylesheetManager = param.stylesheetManager, win = param1.win;
    var setProperty = win.CSSStyleDeclaration.prototype.setProperty;
    win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
        apply: callbackWrapper(function(target, thisArg, argumentsList) {
            var _thisArg_parentRule;
            var _argumentsList = (0, _slicedToArray._)(argumentsList, 3), property = _argumentsList[0], value = _argumentsList[1], priority = _argumentsList[2];
            if (ignoreCSSAttributes.has(property)) return setProperty.apply(thisArg, [
                property,
                value,
                priority
            ]);
            var _getIdAndStyleId = getIdAndStyleId((_thisArg_parentRule = thisArg.parentRule) === null || _thisArg_parentRule === void 0 ? void 0 : _thisArg_parentRule.parentStyleSheet, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                set: {
                    property: property,
                    value: value,
                    priority: priority
                },
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                index: getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    var removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
        apply: callbackWrapper(function(target, thisArg, argumentsList) {
            var _thisArg_parentRule;
            var _argumentsList = (0, _slicedToArray._)(argumentsList, 1), property = _argumentsList[0];
            if (ignoreCSSAttributes.has(property)) return removeProperty.apply(thisArg, [
                property
            ]);
            var _getIdAndStyleId = getIdAndStyleId((_thisArg_parentRule = thisArg.parentRule) === null || _thisArg_parentRule === void 0 ? void 0 : _thisArg_parentRule.parentStyleSheet, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                remove: {
                    property: property
                },
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                index: getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    return callbackWrapper(function() {
        win.CSSStyleDeclaration.prototype.setProperty = setProperty;
        win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
    });
}
function initMediaInteractionObserver(param) {
    var mediaInteractionCb = param.mediaInteractionCb, blockClass = param.blockClass, blockSelector = param.blockSelector, unblockSelector = param.unblockSelector, mirror2 = param.mirror, sampling = param.sampling, doc = param.doc;
    var handler = callbackWrapper(function(type) {
        return throttle$1(callbackWrapper(function(event) {
            var target = getEventTarget(event);
            if (!target || isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            var currentTime = target.currentTime, volume = target.volume, muted = target.muted, playbackRate = target.playbackRate;
            mediaInteractionCb({
                type: type,
                id: mirror2.getId(target),
                currentTime: currentTime,
                volume: volume,
                muted: muted,
                playbackRate: playbackRate
            });
        }), sampling.media || 500);
    });
    var handlers = [
        on("play", handler(MediaInteractions.Play), doc),
        on("pause", handler(MediaInteractions.Pause), doc),
        on("seeked", handler(MediaInteractions.Seeked), doc),
        on("volumechange", handler(MediaInteractions.VolumeChange), doc),
        on("ratechange", handler(MediaInteractions.RateChange), doc)
    ];
    return callbackWrapper(function() {
        handlers.forEach(function(h) {
            return h();
        });
    });
}
function initFontObserver(param) {
    var fontCb = param.fontCb, doc = param.doc;
    var win = doc.defaultView;
    if (!win) return function() {};
    var handlers = [];
    var fontMap = /* @__PURE__ */ new WeakMap();
    var originalFontFace = win.FontFace;
    win.FontFace = function FontFace2(family, source, descriptors) {
        var fontFace = new originalFontFace(family, source, descriptors);
        fontMap.set(fontFace, {
            family: family,
            buffer: typeof source !== "string",
            descriptors: descriptors,
            fontSource: typeof source === "string" ? source : JSON.stringify(Array.from(new Uint8Array(source)))
        });
        return fontFace;
    };
    var restoreHandler = patch(doc.fonts, "add", function(original) {
        return function(fontFace) {
            setTimeout$1(callbackWrapper(function() {
                var p = fontMap.get(fontFace);
                if (p) {
                    fontCb(p);
                    fontMap.delete(fontFace);
                }
            }), 0);
            return original.apply(this, [
                fontFace
            ]);
        };
    });
    handlers.push(function() {
        win.FontFace = originalFontFace;
    });
    handlers.push(restoreHandler);
    return callbackWrapper(function() {
        handlers.forEach(function(h) {
            return h();
        });
    });
}
function initSelectionObserver(param) {
    var doc = param.doc, mirror2 = param.mirror, blockClass = param.blockClass, blockSelector = param.blockSelector, unblockSelector = param.unblockSelector, selectionCb = param.selectionCb;
    var collapsed = true;
    var updateSelection = callbackWrapper(function() {
        var selection = doc.getSelection();
        if (!selection || collapsed && (selection === null || selection === void 0 ? void 0 : selection.isCollapsed)) return;
        collapsed = selection.isCollapsed || false;
        var ranges = [];
        var count = selection.rangeCount || 0;
        for(var i2 = 0; i2 < count; i2++){
            var range = selection.getRangeAt(i2);
            var startContainer = range.startContainer, startOffset = range.startOffset, endContainer = range.endContainer, endOffset = range.endOffset;
            var blocked = isBlocked(startContainer, blockClass, blockSelector, unblockSelector, true) || isBlocked(endContainer, blockClass, blockSelector, unblockSelector, true);
            if (blocked) continue;
            ranges.push({
                start: mirror2.getId(startContainer),
                startOffset: startOffset,
                end: mirror2.getId(endContainer),
                endOffset: endOffset
            });
        }
        selectionCb({
            ranges: ranges
        });
    });
    updateSelection();
    return on("selectionchange", updateSelection);
}
function initCustomElementObserver(param) {
    var doc = param.doc, customElementCb = param.customElementCb;
    var win = doc.defaultView;
    if (!win || !win.customElements) return function() {};
    var restoreHandler = patch(win.customElements, "define", function(original) {
        return function(name, constructor, options) {
            try {
                customElementCb({
                    define: {
                        name: name
                    }
                });
            } catch (e2) {}
            return original.apply(this, [
                name,
                constructor,
                options
            ]);
        };
    });
    return restoreHandler;
}
function initObservers(o2) {
    var _hooks = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var currentWindow = o2.doc.defaultView;
    if (!currentWindow) return function() {};
    var mutationObserver;
    if (o2.recordDOM) mutationObserver = initMutationObserver(o2, o2.doc);
    var mousemoveHandler = initMoveObserver(o2);
    var mouseInteractionHandler = initMouseInteractionObserver(o2);
    var scrollHandler = initScrollObserver(o2);
    var viewportResizeHandler = initViewportResizeObserver(o2, {
        win: currentWindow
    });
    var inputHandler = initInputObserver(o2);
    var mediaInteractionHandler = initMediaInteractionObserver(o2);
    var styleSheetObserver = function() {};
    var adoptedStyleSheetObserver = function() {};
    var styleDeclarationObserver = function() {};
    var fontObserver = function() {};
    if (o2.recordDOM) {
        styleSheetObserver = initStyleSheetObserver(o2, {
            win: currentWindow
        });
        adoptedStyleSheetObserver = initAdoptedStyleSheetObserver(o2, o2.doc);
        styleDeclarationObserver = initStyleDeclarationObserver(o2, {
            win: currentWindow
        });
        if (o2.collectFonts) fontObserver = initFontObserver(o2);
    }
    var selectionObserver = initSelectionObserver(o2);
    var customElementObserver = initCustomElementObserver(o2);
    var pluginHandlers = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = o2.plugins[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var plugin = _step.value;
            pluginHandlers.push(plugin.observer(plugin.callback, currentWindow, plugin.options));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return callbackWrapper(function() {
        mutationBuffers.forEach(function(b) {
            return b.reset();
        });
        mutationObserver === null || mutationObserver === void 0 ? void 0 : mutationObserver.disconnect();
        mousemoveHandler();
        mouseInteractionHandler();
        scrollHandler();
        viewportResizeHandler();
        inputHandler();
        mediaInteractionHandler();
        styleSheetObserver();
        adoptedStyleSheetObserver();
        styleDeclarationObserver();
        fontObserver();
        selectionObserver();
        customElementObserver();
        pluginHandlers.forEach(function(h) {
            return h();
        });
    });
}
function hasNestedCSSRule(prop) {
    return typeof window[prop] !== "undefined";
}
function canMonkeyPatchNestedCSSRule(prop) {
    return Boolean(typeof window[prop] !== "undefined" && // Note: Generally, this check _shouldn't_ be necessary
    // However, in some scenarios (e.g. jsdom) this can sometimes fail, so we check for it here
    window[prop].prototype && "insertRule" in window[prop].prototype && "deleteRule" in window[prop].prototype);
}
var CrossOriginIframeMirror = /*#__PURE__*/ function() {
    "use strict";
    function CrossOriginIframeMirror(generateIdFn) {
        (0, _classCallCheck._)(this, CrossOriginIframeMirror);
        this.generateIdFn = generateIdFn;
        this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap();
        this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
    }
    (0, _createClass._)(CrossOriginIframeMirror, [
        {
            key: "getId",
            value: function getId(iframe, remoteId, idToRemoteMap, remoteToIdMap) {
                var idToRemoteIdMap = idToRemoteMap || this.getIdToRemoteIdMap(iframe);
                var remoteIdToIdMap = remoteToIdMap || this.getRemoteIdToIdMap(iframe);
                var id = idToRemoteIdMap.get(remoteId);
                if (!id) {
                    id = this.generateIdFn();
                    idToRemoteIdMap.set(remoteId, id);
                    remoteIdToIdMap.set(id, remoteId);
                }
                return id;
            }
        },
        {
            key: "getIds",
            value: function getIds(iframe, remoteId) {
                var _this = this;
                var idToRemoteIdMap = this.getIdToRemoteIdMap(iframe);
                var remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
                return remoteId.map(function(id) {
                    return _this.getId(iframe, id, idToRemoteIdMap, remoteIdToIdMap);
                });
            }
        },
        {
            key: "getRemoteId",
            value: function getRemoteId(iframe, id, map) {
                var remoteIdToIdMap = map || this.getRemoteIdToIdMap(iframe);
                if (typeof id !== "number") return id;
                var remoteId = remoteIdToIdMap.get(id);
                if (!remoteId) return -1;
                return remoteId;
            }
        },
        {
            key: "getRemoteIds",
            value: function getRemoteIds(iframe, ids) {
                var _this = this;
                var remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
                return ids.map(function(id) {
                    return _this.getRemoteId(iframe, id, remoteIdToIdMap);
                });
            }
        },
        {
            key: "reset",
            value: function reset(iframe) {
                if (!iframe) {
                    this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap();
                    this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
                    return;
                }
                this.iframeIdToRemoteIdMap.delete(iframe);
                this.iframeRemoteIdToIdMap.delete(iframe);
            }
        },
        {
            key: "getIdToRemoteIdMap",
            value: function getIdToRemoteIdMap(iframe) {
                var idToRemoteIdMap = this.iframeIdToRemoteIdMap.get(iframe);
                if (!idToRemoteIdMap) {
                    idToRemoteIdMap = /* @__PURE__ */ new Map();
                    this.iframeIdToRemoteIdMap.set(iframe, idToRemoteIdMap);
                }
                return idToRemoteIdMap;
            }
        },
        {
            key: "getRemoteIdToIdMap",
            value: function getRemoteIdToIdMap(iframe) {
                var remoteIdToIdMap = this.iframeRemoteIdToIdMap.get(iframe);
                if (!remoteIdToIdMap) {
                    remoteIdToIdMap = /* @__PURE__ */ new Map();
                    this.iframeRemoteIdToIdMap.set(iframe, remoteIdToIdMap);
                }
                return remoteIdToIdMap;
            }
        }
    ]);
    return CrossOriginIframeMirror;
}();
var IframeManagerNoop = /*#__PURE__*/ function() {
    "use strict";
    function IframeManagerNoop() {
        (0, _classCallCheck._)(this, IframeManagerNoop);
        this.crossOriginIframeMirror = new CrossOriginIframeMirror(genId);
        this.crossOriginIframeRootIdMap = /* @__PURE__ */ new WeakMap();
    }
    (0, _createClass._)(IframeManagerNoop, [
        {
            key: "addIframe",
            value: function addIframe() {}
        },
        {
            key: "addLoadListener",
            value: function addLoadListener() {}
        },
        {
            key: "attachIframe",
            value: function attachIframe() {}
        }
    ]);
    return IframeManagerNoop;
}();
var IframeManager = /*#__PURE__*/ function() {
    "use strict";
    function IframeManager(options) {
        (0, _classCallCheck._)(this, IframeManager);
        this.iframes = /* @__PURE__ */ new WeakMap();
        this.crossOriginIframeMap = /* @__PURE__ */ new WeakMap();
        this.crossOriginIframeMirror = new CrossOriginIframeMirror(genId);
        this.crossOriginIframeRootIdMap = /* @__PURE__ */ new WeakMap();
        this.mutationCb = options.mutationCb;
        this.wrappedEmit = options.wrappedEmit;
        this.stylesheetManager = options.stylesheetManager;
        this.recordCrossOriginIframes = options.recordCrossOriginIframes;
        this.crossOriginIframeStyleMirror = new CrossOriginIframeMirror(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror));
        this.mirror = options.mirror;
        if (this.recordCrossOriginIframes) window.addEventListener("message", this.handleMessage.bind(this));
    }
    (0, _createClass._)(IframeManager, [
        {
            key: "addIframe",
            value: function addIframe(iframeEl) {
                this.iframes.set(iframeEl, true);
                if (iframeEl.contentWindow) this.crossOriginIframeMap.set(iframeEl.contentWindow, iframeEl);
            }
        },
        {
            key: "addLoadListener",
            value: function addLoadListener(cb) {
                this.loadListener = cb;
            }
        },
        {
            key: "attachIframe",
            value: function attachIframe(iframeEl, childSn) {
                var _iframeEl_contentWindow, _this_loadListener, _this;
                this.mutationCb({
                    adds: [
                        {
                            parentId: this.mirror.getId(iframeEl),
                            nextId: null,
                            node: childSn
                        }
                    ],
                    removes: [],
                    texts: [],
                    attributes: [],
                    isAttachIframe: true
                });
                if (this.recordCrossOriginIframes) (_iframeEl_contentWindow = iframeEl.contentWindow) === null || _iframeEl_contentWindow === void 0 ? void 0 : _iframeEl_contentWindow.addEventListener("message", this.handleMessage.bind(this));
                (_this_loadListener = (_this = this).loadListener) === null || _this_loadListener === void 0 ? void 0 : _this_loadListener.call(_this, iframeEl);
                var iframeDoc = getIFrameContentDocument(iframeEl);
                if (iframeDoc && iframeDoc.adoptedStyleSheets && iframeDoc.adoptedStyleSheets.length > 0) this.stylesheetManager.adoptStyleSheets(iframeDoc.adoptedStyleSheets, this.mirror.getId(iframeDoc));
            }
        },
        {
            key: "handleMessage",
            value: function handleMessage(message) {
                var crossOriginMessageEvent = message;
                if (crossOriginMessageEvent.data.type !== "rrweb" || // To filter out the rrweb messages which are forwarded by some sites.
                crossOriginMessageEvent.origin !== crossOriginMessageEvent.data.origin) return;
                var iframeSourceWindow = message.source;
                if (!iframeSourceWindow) return;
                var iframeEl = this.crossOriginIframeMap.get(message.source);
                if (!iframeEl) return;
                var transformedEvent = this.transformCrossOriginEvent(iframeEl, crossOriginMessageEvent.data.event);
                if (transformedEvent) this.wrappedEmit(transformedEvent, crossOriginMessageEvent.data.isCheckout);
            }
        },
        {
            key: "transformCrossOriginEvent",
            value: function transformCrossOriginEvent(iframeEl, e2) {
                var _this = this;
                switch(e2.type){
                    case EventType.FullSnapshot:
                        {
                            this.crossOriginIframeMirror.reset(iframeEl);
                            this.crossOriginIframeStyleMirror.reset(iframeEl);
                            this.replaceIdOnNode(e2.data.node, iframeEl);
                            var rootId = e2.data.node.id;
                            this.crossOriginIframeRootIdMap.set(iframeEl, rootId);
                            this.patchRootIdOnNode(e2.data.node, rootId);
                            return {
                                timestamp: e2.timestamp,
                                type: EventType.IncrementalSnapshot,
                                data: {
                                    source: IncrementalSource.Mutation,
                                    adds: [
                                        {
                                            parentId: this.mirror.getId(iframeEl),
                                            nextId: null,
                                            node: e2.data.node
                                        }
                                    ],
                                    removes: [],
                                    texts: [],
                                    attributes: [],
                                    isAttachIframe: true
                                }
                            };
                        }
                    case EventType.Meta:
                    case EventType.Load:
                    case EventType.DomContentLoaded:
                        return false;
                    case EventType.Plugin:
                        return e2;
                    case EventType.Custom:
                        this.replaceIds(e2.data.payload, iframeEl, [
                            "id",
                            "parentId",
                            "previousId",
                            "nextId"
                        ]);
                        return e2;
                    case EventType.IncrementalSnapshot:
                        switch(e2.data.source){
                            case IncrementalSource.Mutation:
                                e2.data.adds.forEach(function(n2) {
                                    _this.replaceIds(n2, iframeEl, [
                                        "parentId",
                                        "nextId",
                                        "previousId"
                                    ]);
                                    _this.replaceIdOnNode(n2.node, iframeEl);
                                    var rootId = _this.crossOriginIframeRootIdMap.get(iframeEl);
                                    rootId && _this.patchRootIdOnNode(n2.node, rootId);
                                });
                                e2.data.removes.forEach(function(n2) {
                                    _this.replaceIds(n2, iframeEl, [
                                        "parentId",
                                        "id"
                                    ]);
                                });
                                e2.data.attributes.forEach(function(n2) {
                                    _this.replaceIds(n2, iframeEl, [
                                        "id"
                                    ]);
                                });
                                e2.data.texts.forEach(function(n2) {
                                    _this.replaceIds(n2, iframeEl, [
                                        "id"
                                    ]);
                                });
                                return e2;
                            case IncrementalSource.Drag:
                            case IncrementalSource.TouchMove:
                            case IncrementalSource.MouseMove:
                                e2.data.positions.forEach(function(p) {
                                    _this.replaceIds(p, iframeEl, [
                                        "id"
                                    ]);
                                });
                                return e2;
                            case IncrementalSource.ViewportResize:
                                return false;
                            case IncrementalSource.MediaInteraction:
                            case IncrementalSource.MouseInteraction:
                            case IncrementalSource.Scroll:
                            case IncrementalSource.CanvasMutation:
                            case IncrementalSource.Input:
                                this.replaceIds(e2.data, iframeEl, [
                                    "id"
                                ]);
                                return e2;
                            case IncrementalSource.StyleSheetRule:
                            case IncrementalSource.StyleDeclaration:
                                this.replaceIds(e2.data, iframeEl, [
                                    "id"
                                ]);
                                this.replaceStyleIds(e2.data, iframeEl, [
                                    "styleId"
                                ]);
                                return e2;
                            case IncrementalSource.Font:
                                return e2;
                            case IncrementalSource.Selection:
                                e2.data.ranges.forEach(function(range) {
                                    _this.replaceIds(range, iframeEl, [
                                        "start",
                                        "end"
                                    ]);
                                });
                                return e2;
                            case IncrementalSource.AdoptedStyleSheet:
                                var _e2_data_styles;
                                this.replaceIds(e2.data, iframeEl, [
                                    "id"
                                ]);
                                this.replaceStyleIds(e2.data, iframeEl, [
                                    "styleIds"
                                ]);
                                (_e2_data_styles = e2.data.styles) === null || _e2_data_styles === void 0 ? void 0 : _e2_data_styles.forEach(function(style) {
                                    _this.replaceStyleIds(style, iframeEl, [
                                        "styleId"
                                    ]);
                                });
                                return e2;
                        }
                }
                return false;
            }
        },
        {
            key: "replace",
            value: function replace(iframeMirror, obj, iframeEl, keys) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        if (!Array.isArray(obj[key]) && typeof obj[key] !== "number") continue;
                        if (Array.isArray(obj[key])) obj[key] = iframeMirror.getIds(iframeEl, obj[key]);
                        else obj[key] = iframeMirror.getId(iframeEl, obj[key]);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return obj;
            }
        },
        {
            key: "replaceIds",
            value: function replaceIds(obj, iframeEl, keys) {
                return this.replace(this.crossOriginIframeMirror, obj, iframeEl, keys);
            }
        },
        {
            key: "replaceStyleIds",
            value: function replaceStyleIds(obj, iframeEl, keys) {
                return this.replace(this.crossOriginIframeStyleMirror, obj, iframeEl, keys);
            }
        },
        {
            key: "replaceIdOnNode",
            value: function replaceIdOnNode(node, iframeEl) {
                var _this = this;
                this.replaceIds(node, iframeEl, [
                    "id",
                    "rootId"
                ]);
                if ("childNodes" in node) node.childNodes.forEach(function(child) {
                    _this.replaceIdOnNode(child, iframeEl);
                });
            }
        },
        {
            key: "patchRootIdOnNode",
            value: function patchRootIdOnNode(node, rootId) {
                var _this = this;
                if (node.type !== NodeType$2.Document && !node.rootId) node.rootId = rootId;
                if ("childNodes" in node) node.childNodes.forEach(function(child) {
                    _this.patchRootIdOnNode(child, rootId);
                });
            }
        }
    ]);
    return IframeManager;
}();
var ShadowDomManagerNoop = /*#__PURE__*/ function() {
    "use strict";
    function ShadowDomManagerNoop() {
        (0, _classCallCheck._)(this, ShadowDomManagerNoop);
    }
    (0, _createClass._)(ShadowDomManagerNoop, [
        {
            key: "init",
            value: function init() {}
        },
        {
            key: "addShadowRoot",
            value: function addShadowRoot() {}
        },
        {
            key: "observeAttachShadow",
            value: function observeAttachShadow() {}
        },
        {
            key: "reset",
            value: function reset() {}
        }
    ]);
    return ShadowDomManagerNoop;
}();
var ShadowDomManager = /*#__PURE__*/ function() {
    "use strict";
    function ShadowDomManager(options) {
        (0, _classCallCheck._)(this, ShadowDomManager);
        this.shadowDoms = /* @__PURE__ */ new WeakSet();
        this.restoreHandlers = [];
        this.mutationCb = options.mutationCb;
        this.scrollCb = options.scrollCb;
        this.bypassOptions = options.bypassOptions;
        this.mirror = options.mirror;
        this.init();
    }
    (0, _createClass._)(ShadowDomManager, [
        {
            key: "init",
            value: function init() {
                this.reset();
                this.patchAttachShadow(Element, document);
            }
        },
        {
            key: "addShadowRoot",
            value: function addShadowRoot(shadowRoot, doc) {
                var _this = this;
                if (!isNativeShadowDom(shadowRoot)) return;
                if (this.shadowDoms.has(shadowRoot)) return;
                this.shadowDoms.add(shadowRoot);
                this.bypassOptions.canvasManager.addShadowRoot(shadowRoot);
                var observer = initMutationObserver((0, _objectSpreadProps._)((0, _objectSpread._)({}, this.bypassOptions), {
                    doc: doc,
                    mutationCb: this.mutationCb,
                    mirror: this.mirror,
                    shadowDomManager: this
                }), shadowRoot);
                this.restoreHandlers.push(function() {
                    return observer.disconnect();
                });
                this.restoreHandlers.push(initScrollObserver((0, _objectSpreadProps._)((0, _objectSpread._)({}, this.bypassOptions), {
                    scrollCb: this.scrollCb,
                    // https://gist.github.com/praveenpuglia/0832da687ed5a5d7a0907046c9ef1813
                    // scroll is not allowed to pass the boundary, so we need to listen the shadow document
                    doc: shadowRoot,
                    mirror: this.mirror
                })));
                setTimeout$1(function() {
                    if (shadowRoot.adoptedStyleSheets && shadowRoot.adoptedStyleSheets.length > 0) _this.bypassOptions.stylesheetManager.adoptStyleSheets(shadowRoot.adoptedStyleSheets, _this.mirror.getId(shadowRoot.host));
                    _this.restoreHandlers.push(initAdoptedStyleSheetObserver({
                        mirror: _this.mirror,
                        stylesheetManager: _this.bypassOptions.stylesheetManager
                    }, shadowRoot));
                }, 0);
            }
        },
        {
            /**
   * Monkey patch 'attachShadow' of an IFrameElement to observe newly added shadow doms.
   */ key: "observeAttachShadow",
            value: function observeAttachShadow(iframeElement) {
                var iframeDoc = getIFrameContentDocument(iframeElement);
                var iframeWindow = getIFrameContentWindow(iframeElement);
                if (!iframeDoc || !iframeWindow) return;
                this.patchAttachShadow(iframeWindow.Element, iframeDoc);
            }
        },
        {
            /**
   * Patch 'attachShadow' to observe newly added shadow doms.
   */ key: "patchAttachShadow",
            value: function patchAttachShadow(element, doc) {
                var manager = this;
                this.restoreHandlers.push(patch(element.prototype, "attachShadow", function(original) {
                    return function(option) {
                        var shadowRoot = original.call(this, option);
                        if (this.shadowRoot && inDom(this)) manager.addShadowRoot(this.shadowRoot, doc);
                        return shadowRoot;
                    };
                }));
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.restoreHandlers.forEach(function(handler) {
                    try {
                        handler();
                    } catch (e2) {}
                });
                this.restoreHandlers = [];
                this.shadowDoms = /* @__PURE__ */ new WeakSet();
                this.bypassOptions.canvasManager.resetShadowRoots();
            }
        }
    ]);
    return ShadowDomManager;
}();
var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for(var i$1 = 0; i$1 < chars.length; i$1++)lookup[chars.charCodeAt(i$1)] = i$1;
var CanvasManagerNoop = /*#__PURE__*/ function() {
    "use strict";
    function CanvasManagerNoop() {
        (0, _classCallCheck._)(this, CanvasManagerNoop);
    }
    (0, _createClass._)(CanvasManagerNoop, [
        {
            key: "reset",
            value: function reset() {}
        },
        {
            key: "freeze",
            value: function freeze() {}
        },
        {
            key: "unfreeze",
            value: function unfreeze() {}
        },
        {
            key: "lock",
            value: function lock() {}
        },
        {
            key: "unlock",
            value: function unlock() {}
        },
        {
            key: "snapshot",
            value: function snapshot() {}
        },
        {
            key: "addWindow",
            value: function addWindow() {}
        },
        {
            key: "addShadowRoot",
            value: function addShadowRoot() {}
        },
        {
            key: "resetShadowRoots",
            value: function resetShadowRoots() {}
        }
    ]);
    return CanvasManagerNoop;
}();
var StylesheetManager = /*#__PURE__*/ function() {
    "use strict";
    function StylesheetManager(options) {
        (0, _classCallCheck._)(this, StylesheetManager);
        this.trackedLinkElements = /* @__PURE__ */ new WeakSet();
        this.styleMirror = new StyleSheetMirror();
        this.mutationCb = options.mutationCb;
        this.adoptedStyleSheetCb = options.adoptedStyleSheetCb;
    }
    (0, _createClass._)(StylesheetManager, [
        {
            key: "attachLinkElement",
            value: function attachLinkElement(linkEl, childSn) {
                if ("_cssText" in childSn.attributes) this.mutationCb({
                    adds: [],
                    removes: [],
                    texts: [],
                    attributes: [
                        {
                            id: childSn.id,
                            attributes: childSn.attributes
                        }
                    ]
                });
                this.trackLinkElement(linkEl);
            }
        },
        {
            key: "trackLinkElement",
            value: function trackLinkElement(linkEl) {
                if (this.trackedLinkElements.has(linkEl)) return;
                this.trackedLinkElements.add(linkEl);
                this.trackStylesheetInLinkElement(linkEl);
            }
        },
        {
            key: "adoptStyleSheets",
            value: function adoptStyleSheets(sheets, hostId) {
                if (sheets.length === 0) return;
                var adoptedStyleSheetData = {
                    id: hostId,
                    styleIds: []
                };
                var styles = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = sheets[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var sheet = _step.value;
                        var styleId = void 0;
                        if (!this.styleMirror.has(sheet)) {
                            styleId = this.styleMirror.add(sheet);
                            styles.push({
                                styleId: styleId,
                                rules: Array.from(sheet.rules || CSSRule, function(r2, index) {
                                    return {
                                        rule: stringifyRule(r2),
                                        index: index
                                    };
                                })
                            });
                        } else styleId = this.styleMirror.getId(sheet);
                        adoptedStyleSheetData.styleIds.push(styleId);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (styles.length > 0) adoptedStyleSheetData.styles = styles;
                this.adoptedStyleSheetCb(adoptedStyleSheetData);
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.styleMirror.reset();
                this.trackedLinkElements = /* @__PURE__ */ new WeakSet();
            }
        },
        {
            // TODO: take snapshot on stylesheet reload by applying event listener
            key: "trackStylesheetInLinkElement",
            value: function trackStylesheetInLinkElement(_linkEl) {}
        }
    ]);
    return StylesheetManager;
}();
var ProcessedNodeManager = /*#__PURE__*/ function() {
    "use strict";
    function ProcessedNodeManager() {
        (0, _classCallCheck._)(this, ProcessedNodeManager);
        this.nodeMap = /* @__PURE__ */ new WeakMap();
        this.active = false;
    }
    (0, _createClass._)(ProcessedNodeManager, [
        {
            key: "inOtherBuffer",
            value: function inOtherBuffer(node, thisBuffer) {
                var buffers = this.nodeMap.get(node);
                return buffers && Array.from(buffers).some(function(buffer) {
                    return buffer !== thisBuffer;
                });
            }
        },
        {
            key: "add",
            value: function add(node, buffer) {
                var _this = this;
                if (!this.active) {
                    this.active = true;
                    onRequestAnimationFrame(function() {
                        _this.nodeMap = /* @__PURE__ */ new WeakMap();
                        _this.active = false;
                    });
                }
                this.nodeMap.set(node, (this.nodeMap.get(node) || /* @__PURE__ */ new Set()).add(buffer));
            }
        },
        {
            key: "destroy",
            value: function destroy() {}
        }
    ]);
    return ProcessedNodeManager;
}();
var wrappedEmit;
var _takeFullSnapshot;
try {
    if (Array.from([
        1
    ], function(x) {
        return x * 2;
    })[0] !== 2) {
        var _cleanFrame_contentWindow;
        var cleanFrame = document.createElement("iframe");
        document.body.appendChild(cleanFrame);
        Array.from = ((_cleanFrame_contentWindow = cleanFrame.contentWindow) === null || _cleanFrame_contentWindow === void 0 ? void 0 : _cleanFrame_contentWindow.Array.from) || Array.from;
        document.body.removeChild(cleanFrame);
    }
} catch (err) {
    console.debug("Unable to override Array.from", err);
}
var mirror = createMirror$2();
function record() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var emit = options.emit, checkoutEveryNms = options.checkoutEveryNms, checkoutEveryNth = options.checkoutEveryNth, _options_blockClass = options.blockClass, blockClass = _options_blockClass === void 0 ? "rr-block" : _options_blockClass, _options_blockSelector = options.blockSelector, blockSelector = _options_blockSelector === void 0 ? null : _options_blockSelector, _options_unblockSelector = options.unblockSelector, unblockSelector = _options_unblockSelector === void 0 ? null : _options_unblockSelector, _options_ignoreClass = options.ignoreClass, ignoreClass = _options_ignoreClass === void 0 ? "rr-ignore" : _options_ignoreClass, _options_ignoreSelector = options.ignoreSelector, ignoreSelector = _options_ignoreSelector === void 0 ? null : _options_ignoreSelector, _options_maskAllText = options.maskAllText, maskAllText = _options_maskAllText === void 0 ? false : _options_maskAllText, _options_maskTextClass = options.maskTextClass, maskTextClass = _options_maskTextClass === void 0 ? "rr-mask" : _options_maskTextClass, _options_unmaskTextClass = options.unmaskTextClass, unmaskTextClass = _options_unmaskTextClass === void 0 ? null : _options_unmaskTextClass, _options_maskTextSelector = options.maskTextSelector, maskTextSelector = _options_maskTextSelector === void 0 ? null : _options_maskTextSelector, _options_unmaskTextSelector = options.unmaskTextSelector, unmaskTextSelector = _options_unmaskTextSelector === void 0 ? null : _options_unmaskTextSelector, _options_inlineStylesheet = options.inlineStylesheet, inlineStylesheet = _options_inlineStylesheet === void 0 ? true : _options_inlineStylesheet, maskAllInputs = options.maskAllInputs, _maskInputOptions = options.maskInputOptions, _slimDOMOptions = options.slimDOMOptions, maskAttributeFn = options.maskAttributeFn, maskInputFn = options.maskInputFn, maskTextFn = options.maskTextFn, _options_maxCanvasSize = options.maxCanvasSize, maxCanvasSize = _options_maxCanvasSize === void 0 ? null : _options_maxCanvasSize, packFn = options.packFn, _options_sampling = options.sampling, sampling = _options_sampling === void 0 ? {} : _options_sampling, _options_dataURLOptions = options.dataURLOptions, dataURLOptions = _options_dataURLOptions === void 0 ? {} : _options_dataURLOptions, mousemoveWait = options.mousemoveWait, _options_recordDOM = options.recordDOM, recordDOM = _options_recordDOM === void 0 ? true : _options_recordDOM, _options_recordCanvas = options.recordCanvas, recordCanvas = _options_recordCanvas === void 0 ? false : _options_recordCanvas, _options_recordCrossOriginIframes = options.recordCrossOriginIframes, recordCrossOriginIframes = _options_recordCrossOriginIframes === void 0 ? false : _options_recordCrossOriginIframes, _options_recordAfter = options.recordAfter, recordAfter = _options_recordAfter === void 0 ? options.recordAfter === "DOMContentLoaded" ? options.recordAfter : "load" : _options_recordAfter, _options_userTriggeredOnInput = options.userTriggeredOnInput, userTriggeredOnInput = _options_userTriggeredOnInput === void 0 ? false : _options_userTriggeredOnInput, _options_collectFonts = options.collectFonts, collectFonts = _options_collectFonts === void 0 ? false : _options_collectFonts, _options_inlineImages = options.inlineImages, inlineImages = _options_inlineImages === void 0 ? false : _options_inlineImages, plugins = options.plugins, _options_keepIframeSrcFn = options.keepIframeSrcFn, keepIframeSrcFn = _options_keepIframeSrcFn === void 0 ? function() {
        return false;
    } : _options_keepIframeSrcFn, _options_ignoreCSSAttributes = options.ignoreCSSAttributes, ignoreCSSAttributes = _options_ignoreCSSAttributes === void 0 ? /* @__PURE__ */ new Set([]) : _options_ignoreCSSAttributes, errorHandler2 = options.errorHandler, onMutation = options.onMutation, getCanvasManager = options.getCanvasManager;
    registerErrorHandler(errorHandler2);
    var inEmittingFrame = recordCrossOriginIframes ? window.parent === window : true;
    var passEmitsToParent = false;
    if (!inEmittingFrame) try {
        if (window.parent.document) passEmitsToParent = false;
    } catch (e2) {
        passEmitsToParent = true;
    }
    if (inEmittingFrame && !emit) throw new Error("emit function is required");
    if (!inEmittingFrame && !passEmitsToParent) return function() {};
    if (mousemoveWait !== void 0 && sampling.mousemove === void 0) sampling.mousemove = mousemoveWait;
    mirror.reset();
    var maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        radio: true,
        checkbox: true
    } : _maskInputOptions !== void 0 ? _maskInputOptions : {};
    var slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaVerification: true,
        // the following are off for slimDOMOptions === true,
        // as they destroy some (hidden) info:
        headMetaAuthorship: _slimDOMOptions === "all",
        headMetaDescKeywords: _slimDOMOptions === "all"
    } : _slimDOMOptions ? _slimDOMOptions : {};
    polyfill$1();
    var lastFullSnapshotEvent;
    var incrementalSnapshotCount = 0;
    var eventProcessor = function(e2) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = (plugins || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var plugin = _step.value;
                if (plugin.eventProcessor) e2 = plugin.eventProcessor(e2);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (packFn && // Disable packing events which will be emitted to parent frames.
        !passEmitsToParent) e2 = packFn(e2);
        return e2;
    };
    wrappedEmit = function(r2, isCheckout) {
        var _mutationBuffers_;
        var e2 = r2;
        e2.timestamp = nowTimestamp();
        if (((_mutationBuffers_ = mutationBuffers[0]) === null || _mutationBuffers_ === void 0 ? void 0 : _mutationBuffers_.isFrozen()) && e2.type !== EventType.FullSnapshot && !(e2.type === EventType.IncrementalSnapshot && e2.data.source === IncrementalSource.Mutation)) mutationBuffers.forEach(function(buf) {
            return buf.unfreeze();
        });
        if (inEmittingFrame) emit === null || emit === void 0 ? void 0 : emit(eventProcessor(e2), isCheckout);
        else if (passEmitsToParent) {
            var message = {
                type: "rrweb",
                event: eventProcessor(e2),
                origin: window.location.origin,
                isCheckout: isCheckout
            };
            window.parent.postMessage(message, "*");
        }
        if (e2.type === EventType.FullSnapshot) {
            lastFullSnapshotEvent = e2;
            incrementalSnapshotCount = 0;
        } else if (e2.type === EventType.IncrementalSnapshot) {
            if (e2.data.source === IncrementalSource.Mutation && e2.data.isAttachIframe) return;
            incrementalSnapshotCount++;
            var exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
            var exceedTime = checkoutEveryNms && lastFullSnapshotEvent && e2.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
            if (exceedCount || exceedTime) takeFullSnapshot2(true);
        }
    };
    var wrappedMutationEmit = function(m) {
        wrappedEmit({
            type: EventType.IncrementalSnapshot,
            data: (0, _objectSpread._)({
                source: IncrementalSource.Mutation
            }, m)
        });
    };
    var wrappedScrollEmit = function(p) {
        return wrappedEmit({
            type: EventType.IncrementalSnapshot,
            data: (0, _objectSpread._)({
                source: IncrementalSource.Scroll
            }, p)
        });
    };
    var wrappedCanvasMutationEmit = function(p) {
        return wrappedEmit({
            type: EventType.IncrementalSnapshot,
            data: (0, _objectSpread._)({
                source: IncrementalSource.CanvasMutation
            }, p)
        });
    };
    var wrappedAdoptedStyleSheetEmit = function(a2) {
        return wrappedEmit({
            type: EventType.IncrementalSnapshot,
            data: (0, _objectSpread._)({
                source: IncrementalSource.AdoptedStyleSheet
            }, a2)
        });
    };
    var stylesheetManager = new StylesheetManager({
        mutationCb: wrappedMutationEmit,
        adoptedStyleSheetCb: wrappedAdoptedStyleSheetEmit
    });
    var iframeManager = typeof __RRWEB_EXCLUDE_IFRAME__ === "boolean" && __RRWEB_EXCLUDE_IFRAME__ ? new IframeManagerNoop() : new IframeManager({
        mirror: mirror,
        mutationCb: wrappedMutationEmit,
        stylesheetManager: stylesheetManager,
        recordCrossOriginIframes: recordCrossOriginIframes,
        wrappedEmit: wrappedEmit
    });
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = (plugins || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var plugin = _step.value;
            if (plugin.getMirror) plugin.getMirror({
                nodeMirror: mirror,
                crossOriginIframeMirror: iframeManager.crossOriginIframeMirror,
                crossOriginIframeStyleMirror: iframeManager.crossOriginIframeStyleMirror
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var processedNodeManager = new ProcessedNodeManager();
    var canvasManager = _getCanvasManager(getCanvasManager, {
        mirror: mirror,
        win: window,
        mutationCb: function(p) {
            return wrappedEmit({
                type: EventType.IncrementalSnapshot,
                data: (0, _objectSpread._)({
                    source: IncrementalSource.CanvasMutation
                }, p)
            });
        },
        recordCanvas: recordCanvas,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maxCanvasSize: maxCanvasSize,
        sampling: sampling["canvas"],
        dataURLOptions: dataURLOptions,
        errorHandler: errorHandler2
    });
    var shadowDomManager = typeof __RRWEB_EXCLUDE_SHADOW_DOM__ === "boolean" && __RRWEB_EXCLUDE_SHADOW_DOM__ ? new ShadowDomManagerNoop() : new ShadowDomManager({
        mutationCb: wrappedMutationEmit,
        scrollCb: wrappedScrollEmit,
        bypassOptions: {
            onMutation: onMutation,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            dataURLOptions: dataURLOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            sampling: sampling,
            slimDOMOptions: slimDOMOptions,
            iframeManager: iframeManager,
            stylesheetManager: stylesheetManager,
            canvasManager: canvasManager,
            keepIframeSrcFn: keepIframeSrcFn,
            processedNodeManager: processedNodeManager,
            ignoreCSSAttributes: ignoreCSSAttributes
        },
        mirror: mirror
    });
    var takeFullSnapshot2 = function() {
        var isCheckout = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        if (!recordDOM) return;
        wrappedEmit({
            type: EventType.Meta,
            data: {
                href: window.location.href,
                width: getWindowWidth(),
                height: getWindowHeight()
            }
        }, isCheckout);
        stylesheetManager.reset();
        shadowDomManager.init();
        mutationBuffers.forEach(function(buf) {
            return buf.lock();
        });
        var node = snapshot(document, {
            mirror: mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskAllInputs: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskInputFn: maskInputFn,
            maskTextFn: maskTextFn,
            slimDOM: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            onSerialize: function(n2) {
                if (isSerializedIframe(n2, mirror)) iframeManager.addIframe(n2);
                if (isSerializedStylesheet(n2, mirror)) stylesheetManager.trackLinkElement(n2);
                if (hasShadowRoot(n2)) shadowDomManager.addShadowRoot(n2.shadowRoot, document);
            },
            onIframeLoad: function(iframe, childSn) {
                iframeManager.attachIframe(iframe, childSn);
                if (iframe.contentWindow) canvasManager.addWindow(iframe.contentWindow);
                shadowDomManager.observeAttachShadow(iframe);
            },
            onStylesheetLoad: function(linkEl, childSn) {
                stylesheetManager.attachLinkElement(linkEl, childSn);
            },
            onBlockedImageLoad: function(_imageEl, serializedNode, param) {
                var width = param.width, height = param.height;
                wrappedMutationEmit({
                    adds: [],
                    removes: [],
                    texts: [],
                    attributes: [
                        {
                            id: serializedNode.id,
                            attributes: {
                                style: {
                                    width: "".concat(width, "px"),
                                    height: "".concat(height, "px")
                                }
                            }
                        }
                    ]
                });
            },
            keepIframeSrcFn: keepIframeSrcFn,
            ignoreCSSAttributes: ignoreCSSAttributes
        });
        if (!node) return console.warn("Failed to snapshot the document");
        wrappedEmit({
            type: EventType.FullSnapshot,
            data: {
                node: node,
                initialOffset: getWindowScroll(window)
            }
        });
        mutationBuffers.forEach(function(buf) {
            return buf.unlock();
        });
        if (document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0) stylesheetManager.adoptStyleSheets(document.adoptedStyleSheets, mirror.getId(document));
    };
    _takeFullSnapshot = takeFullSnapshot2;
    try {
        var handlers = [];
        var observe = function(doc) {
            var _plugins_filter;
            return callbackWrapper(initObservers)({
                onMutation: onMutation,
                mutationCb: wrappedMutationEmit,
                mousemoveCb: function(positions, source) {
                    return wrappedEmit({
                        type: EventType.IncrementalSnapshot,
                        data: {
                            source: source,
                            positions: positions
                        }
                    });
                },
                mouseInteractionCb: function(d) {
                    return wrappedEmit({
                        type: EventType.IncrementalSnapshot,
                        data: (0, _objectSpread._)({
                            source: IncrementalSource.MouseInteraction
                        }, d)
                    });
                },
                scrollCb: wrappedScrollEmit,
                viewportResizeCb: function(d) {
                    return wrappedEmit({
                        type: EventType.IncrementalSnapshot,
                        data: (0, _objectSpread._)({
                            source: IncrementalSource.ViewportResize
                        }, d)
                    });
                },
                inputCb: function(v2) {
                    return wrappedEmit({
                        type: EventType.IncrementalSnapshot,
                        data: (0, _objectSpread._)({
                            source: IncrementalSource.Input
                        }, v2)
                    });
                },
                mediaInteractionCb: function(p) {
                    return wrappedEmit({
                        type: EventType.IncrementalSnapshot,
                        data: (0, _objectSpread._)({
                            source: IncrementalSource.MediaInteraction
                        }, p)
                    });
                },
                styleSheetRuleCb: function(r2) {
                    return wrappedEmit({
                        type: EventType.IncrementalSnapshot,
                        data: (0, _objectSpread._)({
                            source: IncrementalSource.StyleSheetRule
                        }, r2)
                    });
                },
                styleDeclarationCb: function(r2) {
                    return wrappedEmit({
                        type: EventType.IncrementalSnapshot,
                        data: (0, _objectSpread._)({
                            source: IncrementalSource.StyleDeclaration
                        }, r2)
                    });
                },
                canvasMutationCb: wrappedCanvasMutationEmit,
                fontCb: function(p) {
                    return wrappedEmit({
                        type: EventType.IncrementalSnapshot,
                        data: (0, _objectSpread._)({
                            source: IncrementalSource.Font
                        }, p)
                    });
                },
                selectionCb: function(p) {
                    wrappedEmit({
                        type: EventType.IncrementalSnapshot,
                        data: (0, _objectSpread._)({
                            source: IncrementalSource.Selection
                        }, p)
                    });
                },
                customElementCb: function(c2) {
                    wrappedEmit({
                        type: EventType.IncrementalSnapshot,
                        data: (0, _objectSpread._)({
                            source: IncrementalSource.CustomElement
                        }, c2)
                    });
                },
                blockClass: blockClass,
                ignoreClass: ignoreClass,
                ignoreSelector: ignoreSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskInputOptions: maskInputOptions,
                inlineStylesheet: inlineStylesheet,
                sampling: sampling,
                recordDOM: recordDOM,
                recordCanvas: recordCanvas,
                inlineImages: inlineImages,
                userTriggeredOnInput: userTriggeredOnInput,
                collectFonts: collectFonts,
                doc: doc,
                maskAttributeFn: maskAttributeFn,
                maskInputFn: maskInputFn,
                maskTextFn: maskTextFn,
                keepIframeSrcFn: keepIframeSrcFn,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                mirror: mirror,
                iframeManager: iframeManager,
                stylesheetManager: stylesheetManager,
                shadowDomManager: shadowDomManager,
                processedNodeManager: processedNodeManager,
                canvasManager: canvasManager,
                ignoreCSSAttributes: ignoreCSSAttributes,
                plugins: (plugins === null || plugins === void 0 ? void 0 : (_plugins_filter = plugins.filter(function(p) {
                    return p.observer;
                })) === null || _plugins_filter === void 0 ? void 0 : _plugins_filter.map(function(p) {
                    return {
                        observer: p.observer,
                        options: p.options,
                        callback: function(payload) {
                            return wrappedEmit({
                                type: EventType.Plugin,
                                data: {
                                    plugin: p.name,
                                    payload: payload
                                }
                            });
                        }
                    };
                })) || []
            }, {});
        };
        iframeManager.addLoadListener(function(iframeEl) {
            try {
                handlers.push(observe(iframeEl.contentDocument));
            } catch (error) {
                console.warn(error);
            }
        });
        var init = function() {
            takeFullSnapshot2();
            handlers.push(observe(document));
        };
        if (document.readyState === "interactive" || document.readyState === "complete") init();
        else {
            handlers.push(on("DOMContentLoaded", function() {
                wrappedEmit({
                    type: EventType.DomContentLoaded,
                    data: {}
                });
                if (recordAfter === "DOMContentLoaded") init();
            }));
            handlers.push(on("load", function() {
                wrappedEmit({
                    type: EventType.Load,
                    data: {}
                });
                if (recordAfter === "load") init();
            }, window));
        }
        return function() {
            handlers.forEach(function(h) {
                return h();
            });
            processedNodeManager.destroy();
            _takeFullSnapshot = void 0;
            unregisterErrorHandler();
        };
    } catch (error) {
        console.warn(error);
    }
}
function takeFullSnapshot(isCheckout) {
    if (!_takeFullSnapshot) throw new Error("please take full snapshot after start recording");
    _takeFullSnapshot(isCheckout);
}
record.mirror = mirror;
record.takeFullSnapshot = takeFullSnapshot;
function _getCanvasManager(getCanvasManagerFn, options) {
    try {
        return getCanvasManagerFn ? getCanvasManagerFn(options) : new CanvasManagerNoop();
    } catch (e) {
        console.warn("Unable to initialize CanvasManager");
        return new CanvasManagerNoop();
    }
}
var n;
!function(t2) {
    t2[t2.NotStarted = 0] = "NotStarted", t2[t2.Running = 1] = "Running", t2[t2.Stopped = 2] = "Stopped";
}(n || (n = {}));
var ReplayEventTypeIncrementalSnapshot = 3;
var ReplayEventTypeCustom = 5;
/**
 * Converts a timestamp to ms, if it was in s, or keeps it as ms.
 */ function timestampToMs(timestamp) {
    var isMs = timestamp > 9999999999;
    return isMs ? timestamp : timestamp * 1000;
}
/**
 * Converts a timestamp to s, if it was in ms, or keeps it as s.
 */ function timestampToS(timestamp) {
    var isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Add a breadcrumb event to replay.
 */ function addBreadcrumbEvent(replay, breadcrumb) {
    if (breadcrumb.category === 'sentry.transaction') return;
    if ([
        'ui.click',
        'ui.input'
    ].includes(breadcrumb.category)) replay.triggerUserActivity();
    else replay.checkAndHandleExpiredSession();
    replay.addUpdate(function() {
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.throttledAddEvent({
            type: EventType.Custom,
            // TODO: We were converting from ms to seconds for breadcrumbs, spans,
            // but maybe we should just keep them as milliseconds
            timestamp: (breadcrumb.timestamp || 0) * 1000,
            data: {
                tag: 'breadcrumb',
                // normalize to max. 10 depth and 1_000 properties per object
                payload: (0, _core.normalize)(breadcrumb, 10, 1000)
            }
        });
        // Do not flush after console log messages
        return breadcrumb.category === 'console';
    });
}
var INTERACTIVE_SELECTOR = 'button,a';
/** Get the closest interactive parent element, or else return the given element. */ function getClosestInteractive(element) {
    var closestInteractive = element.closest(INTERACTIVE_SELECTOR);
    return closestInteractive || element;
}
/**
 * For clicks, we check if the target is inside of a button or link
 * If so, we use this as the target instead
 * This is useful because if you click on the image in <button><img></button>,
 * The target will be the image, not the button, which we don't want here
 */ function getClickTargetNode(event) {
    var target = getTargetNode(event);
    if (!target || !(0, _instanceof._)(target, Element)) return target;
    return getClosestInteractive(target);
}
/** Get the event target node. */ function getTargetNode(event) {
    if (isEventWithTarget(event)) return event.target;
    return event;
}
function isEventWithTarget(event) {
    return (typeof event === "undefined" ? "undefined" : (0, _typeOf._)(event)) === 'object' && !!event && 'target' in event;
}
var handlers;
/**
 * Register a handler to be called when `window.open()` is called.
 * Returns a cleanup function.
 */ function onWindowOpen(cb) {
    // Ensure to only register this once
    if (!handlers) {
        handlers = [];
        monkeyPatchWindowOpen();
    }
    handlers.push(cb);
    return function() {
        var pos = handlers ? handlers.indexOf(cb) : -1;
        if (pos > -1) handlers.splice(pos, 1);
    };
}
function monkeyPatchWindowOpen() {
    (0, _core.fill)(WINDOW, 'open', function(originalWindowOpen) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (handlers) try {
                handlers.forEach(function(handler) {
                    return handler();
                });
            } catch (e) {
            // ignore errors in here
            }
            return originalWindowOpen.apply(WINDOW, args);
        };
    });
}
/** Any IncrementalSource for rrweb that we interpret as a kind of mutation. */ var IncrementalMutationSources = new Set([
    IncrementalSource.Mutation,
    IncrementalSource.StyleSheetRule,
    IncrementalSource.StyleDeclaration,
    IncrementalSource.AdoptedStyleSheet,
    IncrementalSource.CanvasMutation,
    IncrementalSource.Selection,
    IncrementalSource.MediaInteraction
]);
/** Handle a click. */ function handleClick(clickDetector, clickBreadcrumb, node) {
    clickDetector.handleClick(clickBreadcrumb, node);
}
/** A click detector class that can be used to detect slow or rage clicks on elements. */ var ClickDetector = /*#__PURE__*/ function() {
    "use strict";
    function ClickDetector(replay, slowClickConfig) {
        var // Just for easier testing
        _addBreadcrumbEvent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : addBreadcrumbEvent;
        (0, _classCallCheck._)(this, ClickDetector);
        this._lastMutation = 0;
        this._lastScroll = 0;
        this._clicks = [];
        // We want everything in s, but options are in ms
        this._timeout = slowClickConfig.timeout / 1000;
        this._threshold = slowClickConfig.threshold / 1000;
        this._scrollTimeout = slowClickConfig.scrollTimeout / 1000;
        this._replay = replay;
        this._ignoreSelector = slowClickConfig.ignoreSelector;
        this._addBreadcrumbEvent = _addBreadcrumbEvent;
    }
    (0, _createClass._)(ClickDetector, [
        {
            /** Register click detection handlers on mutation or scroll. */ key: "addListeners",
            value: function addListeners() {
                var _this = this;
                var cleanupWindowOpen = onWindowOpen(function() {
                    // Treat window.open as mutation
                    _this._lastMutation = nowInSeconds();
                });
                this._teardown = function() {
                    cleanupWindowOpen();
                    _this._clicks = [];
                    _this._lastMutation = 0;
                    _this._lastScroll = 0;
                };
            }
        },
        {
            /** Clean up listeners. */ key: "removeListeners",
            value: function removeListeners() {
                if (this._teardown) this._teardown();
                if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
            }
        },
        {
            /** @inheritDoc */ key: "handleClick",
            value: function handleClick(breadcrumb, node) {
                if (ignoreElement(node, this._ignoreSelector) || !isClickBreadcrumb(breadcrumb)) return;
                var newClick = {
                    timestamp: timestampToS(breadcrumb.timestamp),
                    clickBreadcrumb: breadcrumb,
                    // Set this to 0 so we know it originates from the click breadcrumb
                    clickCount: 0,
                    node: node
                };
                // If there was a click in the last 1s on the same element, ignore it - only keep a single reference per second
                if (this._clicks.some(function(click) {
                    return click.node === newClick.node && Math.abs(click.timestamp - newClick.timestamp) < 1;
                })) return;
                this._clicks.push(newClick);
                // If this is the first new click, set a timeout to check for multi clicks
                if (this._clicks.length === 1) this._scheduleCheckClicks();
            }
        },
        {
            /** @inheritDoc */ key: "registerMutation",
            value: function registerMutation() {
                var timestamp = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Date.now();
                this._lastMutation = timestampToS(timestamp);
            }
        },
        {
            /** @inheritDoc */ key: "registerScroll",
            value: function registerScroll() {
                var timestamp = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Date.now();
                this._lastScroll = timestampToS(timestamp);
            }
        },
        {
            /** @inheritDoc */ key: "registerClick",
            value: function registerClick(element) {
                var node = getClosestInteractive(element);
                this._handleMultiClick(node);
            }
        },
        {
            /** Count multiple clicks on elements. */ key: "_handleMultiClick",
            value: function _handleMultiClick(node) {
                this._getClicks(node).forEach(function(click) {
                    click.clickCount++;
                });
            }
        },
        {
            /** Get all pending clicks for a given node. */ key: "_getClicks",
            value: function _getClicks(node) {
                return this._clicks.filter(function(click) {
                    return click.node === node;
                });
            }
        },
        {
            /** Check the clicks that happened. */ key: "_checkClicks",
            value: function _checkClicks() {
                var _this = this;
                var timedOutClicks = [];
                var now = nowInSeconds();
                this._clicks.forEach(function(click) {
                    if (!click.mutationAfter && _this._lastMutation) click.mutationAfter = click.timestamp <= _this._lastMutation ? _this._lastMutation - click.timestamp : undefined;
                    if (!click.scrollAfter && _this._lastScroll) click.scrollAfter = click.timestamp <= _this._lastScroll ? _this._lastScroll - click.timestamp : undefined;
                    // All of these are in seconds!
                    if (click.timestamp + _this._timeout <= now) timedOutClicks.push(click);
                });
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // Remove "old" clicks
                    for(var _iterator = timedOutClicks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var click = _step.value;
                        var pos = this._clicks.indexOf(click);
                        if (pos > -1) {
                            this._generateBreadcrumbs(click);
                            this._clicks.splice(pos, 1);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                // Trigger new check, unless no clicks left
                if (this._clicks.length) this._scheduleCheckClicks();
            }
        },
        {
            /** Generate matching breadcrumb(s) for the click. */ key: "_generateBreadcrumbs",
            value: function _generateBreadcrumbs(click) {
                var replay = this._replay;
                var hadScroll = click.scrollAfter && click.scrollAfter <= this._scrollTimeout;
                var hadMutation = click.mutationAfter && click.mutationAfter <= this._threshold;
                var isSlowClick = !hadScroll && !hadMutation;
                var clickCount = click.clickCount, clickBreadcrumb = click.clickBreadcrumb;
                // Slow click
                if (isSlowClick) {
                    // If `mutationAfter` is set, it means a mutation happened after the threshold, but before the timeout
                    // If not, it means we just timed out without scroll & mutation
                    var timeAfterClickMs = Math.min(click.mutationAfter || this._timeout, this._timeout) * 1000;
                    var endReason = timeAfterClickMs < this._timeout * 1000 ? 'mutation' : 'timeout';
                    var breadcrumb = {
                        type: 'default',
                        message: clickBreadcrumb.message,
                        timestamp: clickBreadcrumb.timestamp,
                        category: 'ui.slowClickDetected',
                        data: (0, _objectSpreadProps._)((0, _objectSpread._)({}, clickBreadcrumb.data), {
                            url: WINDOW.location.href,
                            route: replay.getCurrentRoute(),
                            timeAfterClickMs: timeAfterClickMs,
                            endReason: endReason,
                            // If clickCount === 0, it means multiClick was not correctly captured here
                            // - we still want to send 1 in this case
                            clickCount: clickCount || 1
                        })
                    };
                    this._addBreadcrumbEvent(replay, breadcrumb);
                    return;
                }
                // Multi click
                if (clickCount > 1) {
                    var breadcrumb1 = {
                        type: 'default',
                        message: clickBreadcrumb.message,
                        timestamp: clickBreadcrumb.timestamp,
                        category: 'ui.multiClick',
                        data: (0, _objectSpreadProps._)((0, _objectSpread._)({}, clickBreadcrumb.data), {
                            url: WINDOW.location.href,
                            route: replay.getCurrentRoute(),
                            clickCount: clickCount,
                            metric: true
                        })
                    };
                    this._addBreadcrumbEvent(replay, breadcrumb1);
                }
            }
        },
        {
            /** Schedule to check current clicks. */ key: "_scheduleCheckClicks",
            value: function _scheduleCheckClicks() {
                var _this = this;
                if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
                this._checkClickTimeout = (0, _browserUtils.setTimeout)(function() {
                    return _this._checkClicks();
                }, 1000);
            }
        }
    ]);
    return ClickDetector;
}();
var SLOW_CLICK_TAGS = [
    'A',
    'BUTTON',
    'INPUT'
];
/** exported for tests only */ function ignoreElement(node, ignoreSelector) {
    if (!SLOW_CLICK_TAGS.includes(node.tagName)) return true;
    // If <input> tag, we only want to consider input[type='submit'] & input[type='button']
    if (node.tagName === 'INPUT' && ![
        'submit',
        'button'
    ].includes(node.getAttribute('type') || '')) return true;
    // If <a> tag, detect special variants that may not lead to an action
    // If target !== _self, we may open the link somewhere else, which would lead to no action
    // Also, when downloading a file, we may not leave the page, but still not trigger an action
    if (node.tagName === 'A' && (node.hasAttribute('download') || node.hasAttribute('target') && node.getAttribute('target') !== '_self')) return true;
    if (ignoreSelector && node.matches(ignoreSelector)) return true;
    return false;
}
function isClickBreadcrumb(breadcrumb) {
    return !!(breadcrumb.data && typeof breadcrumb.data.nodeId === 'number' && breadcrumb.timestamp);
}
// This is good enough for us, and is easier to test/mock than `timestampInSeconds`
function nowInSeconds() {
    return Date.now() / 1000;
}
/** Update the click detector based on a recording event of rrweb. */ function updateClickDetectorForRecordingEvent(clickDetector, event) {
    try {
        // note: We only consider incremental snapshots here
        // This means that any full snapshot is ignored for mutation detection - the reason is that we simply cannot know if a mutation happened here.
        // E.g. think that we are buffering, an error happens and we take a full snapshot because we switched to session mode -
        // in this scenario, we would not know if a dead click happened because of the error, which is a key dead click scenario.
        // Instead, by ignoring full snapshots, we have the risk that we generate a false positive
        // (if a mutation _did_ happen but was "swallowed" by the full snapshot)
        // But this should be more unlikely as we'd generally capture the incremental snapshot right away
        if (!isIncrementalEvent(event)) return;
        var source = event.data.source;
        if (IncrementalMutationSources.has(source)) clickDetector.registerMutation(event.timestamp);
        if (source === IncrementalSource.Scroll) clickDetector.registerScroll(event.timestamp);
        if (isIncrementalMouseInteraction(event)) {
            var _event_data = event.data, type = _event_data.type, id = _event_data.id;
            var node = record.mirror.getNode(id);
            if ((0, _instanceof._)(node, HTMLElement) && type === MouseInteractions.Click) clickDetector.registerClick(node);
        }
    } catch (e) {
    // ignore errors here, e.g. if accessing something that does not exist
    }
}
function isIncrementalEvent(event) {
    return event.type === ReplayEventTypeIncrementalSnapshot;
}
function isIncrementalMouseInteraction(event) {
    return event.data.source === IncrementalSource.MouseInteraction;
}
/**
 * Create a breadcrumb for a replay.
 */ function createBreadcrumb(breadcrumb) {
    return (0, _objectSpread._)({
        timestamp: Date.now() / 1000,
        type: 'default'
    }, breadcrumb);
}
var NodeType = /* @__PURE__ */ function(NodeType2) {
    NodeType2[NodeType2["Document"] = 0] = "Document";
    NodeType2[NodeType2["DocumentType"] = 1] = "DocumentType";
    NodeType2[NodeType2["Element"] = 2] = "Element";
    NodeType2[NodeType2["Text"] = 3] = "Text";
    NodeType2[NodeType2["CDATA"] = 4] = "CDATA";
    NodeType2[NodeType2["Comment"] = 5] = "Comment";
    return NodeType2;
}(NodeType || {});
// Note that these are the serialized attributes and not attributes directly on
// the DOM Node. Attributes we are interested in:
var ATTRIBUTES_TO_RECORD = new Set([
    'id',
    'class',
    'aria-label',
    'role',
    'name',
    'alt',
    'title',
    'data-test-id',
    'data-testid',
    'disabled',
    'aria-disabled',
    'data-sentry-component'
]);
/**
 * Inclusion list of attributes that we want to record from the DOM element
 */ function getAttributesToRecord(attributes) {
    var obj = {};
    if (!attributes['data-sentry-component'] && attributes['data-sentry-element']) attributes['data-sentry-component'] = attributes['data-sentry-element'];
    for(var key in attributes)if (ATTRIBUTES_TO_RECORD.has(key)) {
        var normalizedKey = key;
        if (key === 'data-testid' || key === 'data-test-id') normalizedKey = 'testId';
        obj[normalizedKey] = attributes[key];
    }
    return obj;
}
var handleDomListener = function(replay) {
    return function(handlerData) {
        if (!replay.isEnabled()) return;
        var result = handleDom(handlerData);
        if (!result) return;
        var isClick = handlerData.name === 'click';
        var event = isClick ? handlerData.event : undefined;
        // Ignore clicks if ctrl/alt/meta/shift keys are held down as they alter behavior of clicks (e.g. open in new tab)
        if (isClick && replay.clickDetector && (event === null || event === void 0 ? void 0 : event.target) && !event.altKey && !event.metaKey && !event.ctrlKey && !event.shiftKey) handleClick(replay.clickDetector, result, getClickTargetNode(handlerData.event));
        addBreadcrumbEvent(replay, result);
    };
};
/** Get the base DOM breadcrumb. */ function getBaseDomBreadcrumb(target, message) {
    var nodeId = record.mirror.getId(target);
    var node = nodeId && record.mirror.getNode(nodeId);
    var meta = node && record.mirror.getMeta(node);
    var element = meta && isElement(meta) ? meta : null;
    return {
        message: message,
        data: element ? {
            nodeId: nodeId,
            node: {
                id: nodeId,
                tagName: element.tagName,
                textContent: Array.from(element.childNodes).map(function(node) {
                    return node.type === NodeType.Text && node.textContent;
                }).filter(Boolean) // filter out empty values
                .map(function(text) {
                    return text.trim();
                }).join(''),
                attributes: getAttributesToRecord(element.attributes)
            }
        } : {}
    };
}
/**
 * An event handler to react to DOM events.
 * Exported for tests.
 */ function handleDom(handlerData) {
    var _getDomTarget = getDomTarget(handlerData), target = _getDomTarget.target, message = _getDomTarget.message;
    return createBreadcrumb((0, _objectSpread._)({
        category: "ui.".concat(handlerData.name)
    }, getBaseDomBreadcrumb(target, message)));
}
function getDomTarget(handlerData) {
    var isClick = handlerData.name === 'click';
    var message;
    var target = null;
    // Accessing event.target can throw (see getsentry/raven-js#838, #768)
    try {
        target = isClick ? getClickTargetNode(handlerData.event) : getTargetNode(handlerData.event);
        message = (0, _core.htmlTreeAsString)(target, {
            maxStringLength: 200
        }) || '<unknown>';
    } catch (e) {
        message = '<unknown>';
    }
    return {
        target: target,
        message: message
    };
}
function isElement(node) {
    return node.type === NodeType.Element;
}
/** Handle keyboard events & create breadcrumbs. */ function handleKeyboardEvent(replay, event) {
    if (!replay.isEnabled()) return;
    // Update user activity, but do not restart recording as it can create
    // noisy/low-value replays (e.g. user comes back from idle, hits alt-tab, new
    // session with a single "keydown" breadcrumb is created)
    replay.updateUserActivity();
    var breadcrumb = getKeyboardBreadcrumb(event);
    if (!breadcrumb) return;
    addBreadcrumbEvent(replay, breadcrumb);
}
/** exported only for tests */ function getKeyboardBreadcrumb(event) {
    var metaKey = event.metaKey, shiftKey = event.shiftKey, ctrlKey = event.ctrlKey, altKey = event.altKey, key = event.key, target = event.target;
    // never capture for input fields
    if (!target || isInputElement(target) || !key) return null;
    // Note: We do not consider shift here, as that means "uppercase"
    var hasModifierKey = metaKey || ctrlKey || altKey;
    var isCharacterKey = key.length === 1; // other keys like Escape, Tab, etc have a longer length
    // Do not capture breadcrumb if only a word key is pressed
    // This could leak e.g. user input
    if (!hasModifierKey && isCharacterKey) return null;
    var message = (0, _core.htmlTreeAsString)(target, {
        maxStringLength: 200
    }) || '<unknown>';
    var baseBreadcrumb = getBaseDomBreadcrumb(target, message);
    return createBreadcrumb({
        category: 'ui.keyDown',
        message: message,
        data: (0, _objectSpreadProps._)((0, _objectSpread._)({}, baseBreadcrumb.data), {
            metaKey: metaKey,
            shiftKey: shiftKey,
            ctrlKey: ctrlKey,
            altKey: altKey,
            key: key
        })
    });
}
function isInputElement(target) {
    return target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable;
}
// Map entryType -> function to normalize data for event
var ENTRY_TYPES = {
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    resource: createResourceEntry,
    paint: createPaintEntry,
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    navigation: createNavigationEntry
};
/**
 * Handler creater for web vitals
 */ function webVitalHandler(getter, replay) {
    return function(param) {
        var metric = param.metric;
        return void replay.replayPerformanceEntries.push(getter(metric));
    };
}
/**
 * Create replay performance entries from the browser performance entries.
 */ function createPerformanceEntries(entries) {
    return entries.map(createPerformanceEntry).filter(Boolean);
}
function createPerformanceEntry(entry) {
    var entryType = ENTRY_TYPES[entry.entryType];
    if (!entryType) return null;
    return entryType(entry);
}
function getAbsoluteTime(time) {
    // browserPerformanceTimeOrigin can be undefined if `performance` or
    // `performance.now` doesn't exist, but this is already checked by this integration
    return (((0, _core.browserPerformanceTimeOrigin)() || WINDOW.performance.timeOrigin) + time) / 1000;
}
function createPaintEntry(entry) {
    var duration = entry.duration, entryType = entry.entryType, name = entry.name, startTime = entry.startTime;
    var start = getAbsoluteTime(startTime);
    return {
        type: entryType,
        name: name,
        start: start,
        end: start + duration,
        data: undefined
    };
}
function createNavigationEntry(entry) {
    var entryType = entry.entryType, name = entry.name, decodedBodySize = entry.decodedBodySize, duration = entry.duration, domComplete = entry.domComplete, encodedBodySize = entry.encodedBodySize, domContentLoadedEventStart = entry.domContentLoadedEventStart, domContentLoadedEventEnd = entry.domContentLoadedEventEnd, domInteractive = entry.domInteractive, loadEventStart = entry.loadEventStart, loadEventEnd = entry.loadEventEnd, redirectCount = entry.redirectCount, startTime = entry.startTime, transferSize = entry.transferSize, type = entry.type;
    // Ignore entries with no duration, they do not seem to be useful and cause dupes
    if (duration === 0) return null;
    return {
        type: "".concat(entryType, ".").concat(type),
        start: getAbsoluteTime(startTime),
        end: getAbsoluteTime(domComplete),
        name: name,
        data: {
            size: transferSize,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize,
            duration: duration,
            domInteractive: domInteractive,
            domContentLoadedEventStart: domContentLoadedEventStart,
            domContentLoadedEventEnd: domContentLoadedEventEnd,
            loadEventStart: loadEventStart,
            loadEventEnd: loadEventEnd,
            domComplete: domComplete,
            redirectCount: redirectCount
        }
    };
}
function createResourceEntry(entry) {
    var entryType = entry.entryType, initiatorType = entry.initiatorType, name = entry.name, responseEnd = entry.responseEnd, startTime = entry.startTime, decodedBodySize = entry.decodedBodySize, encodedBodySize = entry.encodedBodySize, responseStatus = entry.responseStatus, transferSize = entry.transferSize;
    // Core SDK handles these
    if ([
        'fetch',
        'xmlhttprequest'
    ].includes(initiatorType)) return null;
    return {
        type: "".concat(entryType, ".").concat(initiatorType),
        start: getAbsoluteTime(startTime),
        end: getAbsoluteTime(responseEnd),
        name: name,
        data: {
            size: transferSize,
            statusCode: responseStatus,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize
        }
    };
}
/**
 * Add a LCP event to the replay based on a LCP metric.
 */ function getLargestContentfulPaint(metric) {
    var lastEntry = metric.entries[metric.entries.length - 1];
    var node = (lastEntry === null || lastEntry === void 0 ? void 0 : lastEntry.element) ? [
        lastEntry.element
    ] : undefined;
    return getWebVital(metric, 'largest-contentful-paint', node);
}
function isLayoutShift(entry) {
    return entry.sources !== undefined;
}
/**
 * Add a CLS event to the replay based on a CLS metric.
 */ function getCumulativeLayoutShift(metric) {
    var layoutShifts = [];
    var nodes = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = metric.entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var entry = _step.value;
            if (isLayoutShift(entry)) {
                var nodeIds = [];
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = entry.sources[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var source = _step1.value;
                        if (source.node) {
                            nodes.push(source.node);
                            var nodeId = record.mirror.getId(source.node);
                            if (nodeId) nodeIds.push(nodeId);
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                layoutShifts.push({
                    value: entry.value,
                    nodeIds: nodeIds.length ? nodeIds : undefined
                });
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return getWebVital(metric, 'cumulative-layout-shift', nodes, layoutShifts);
}
/**
 * Add an INP event to the replay based on an INP metric.
 */ function getInteractionToNextPaint(metric) {
    var lastEntry = metric.entries[metric.entries.length - 1];
    var node = (lastEntry === null || lastEntry === void 0 ? void 0 : lastEntry.target) ? [
        lastEntry.target
    ] : undefined;
    return getWebVital(metric, 'interaction-to-next-paint', node);
}
/**
 * Add an web vital event to the replay based on the web vital metric.
 */ function getWebVital(metric, name, nodes, attributions) {
    var value = metric.value;
    var rating = metric.rating;
    var end = getAbsoluteTime(value);
    return {
        type: 'web-vital',
        name: name,
        start: end,
        end: end,
        data: {
            value: value,
            size: value,
            rating: rating,
            nodeIds: nodes ? nodes.map(function(node) {
                return record.mirror.getId(node);
            }) : undefined,
            attributions: attributions
        }
    };
}
/**
 * Sets up a PerformanceObserver to listen to all performance entry types.
 * Returns a callback to stop observing.
 */ function setupPerformanceObserver(replay) {
    function addPerformanceEntry(entry) {
        // It is possible for entries to come up multiple times
        if (!replay.performanceEntries.includes(entry)) replay.performanceEntries.push(entry);
    }
    function onEntries(param) {
        var entries = param.entries;
        entries.forEach(addPerformanceEntry);
    }
    var clearCallbacks = [];
    [
        'navigation',
        'paint',
        'resource'
    ].forEach(function(type) {
        clearCallbacks.push((0, _browserUtils.addPerformanceInstrumentationHandler)(type, onEntries));
    });
    clearCallbacks.push((0, _browserUtils.addLcpInstrumentationHandler)(webVitalHandler(getLargestContentfulPaint, replay)), (0, _browserUtils.addClsInstrumentationHandler)(webVitalHandler(getCumulativeLayoutShift, replay)), (0, _browserUtils.addInpInstrumentationHandler)(webVitalHandler(getInteractionToNextPaint, replay)));
    // A callback to cleanup all handlers
    return function() {
        clearCallbacks.forEach(function(clearCallback) {
            return clearCallback();
        });
    };
}
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ var DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;
var r = 'var t=Uint8Array,n=Uint16Array,r=Int32Array,e=new t([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0]),i=new t([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0]),s=new t([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),a=function(t,e){for(var i=new n(31),s=0;s<31;++s)i[s]=e+=1<<t[s-1];var a=new r(i[30]);for(s=1;s<30;++s)for(var o=i[s];o<i[s+1];++o)a[o]=o-i[s]<<5|s;return{b:i,r:a}},o=a(e,2),h=o.b,f=o.r;h[28]=258,f[258]=28;for(var l=a(i,0).r,u=new n(32768),c=0;c<32768;++c){var v=(43690&c)>>1|(21845&c)<<1;v=(61680&(v=(52428&v)>>2|(13107&v)<<2))>>4|(3855&v)<<4,u[c]=((65280&v)>>8|(255&v)<<8)>>1}var d=function(t,r,e){for(var i=t.length,s=0,a=new n(r);s<i;++s)t[s]&&++a[t[s]-1];var o,h=new n(r);for(s=1;s<r;++s)h[s]=h[s-1]+a[s-1]<<1;if(e){o=new n(1<<r);var f=15-r;for(s=0;s<i;++s)if(t[s])for(var l=s<<4|t[s],c=r-t[s],v=h[t[s]-1]++<<c,d=v|(1<<c)-1;v<=d;++v)o[u[v]>>f]=l}else for(o=new n(i),s=0;s<i;++s)t[s]&&(o[s]=u[h[t[s]-1]++]>>15-t[s]);return o},p=new t(288);for(c=0;c<144;++c)p[c]=8;for(c=144;c<256;++c)p[c]=9;for(c=256;c<280;++c)p[c]=7;for(c=280;c<288;++c)p[c]=8;var g=new t(32);for(c=0;c<32;++c)g[c]=5;var w=d(p,9,0),y=d(g,5,0),m=function(t){return(t+7)/8|0},b=function(n,r,e){return(null==e||e>n.length)&&(e=n.length),new t(n.subarray(r,e))},M=["unexpected EOF","invalid block type","invalid length/literal","invalid distance","stream finished","no stream handler",,"no callback","invalid UTF-8 data","extra field too long","date not in range 1980-2099","filename too long","stream finishing","invalid zip data"],E=function(t,n,r){var e=new Error(n||M[t]);if(e.code=t,Error.captureStackTrace&&Error.captureStackTrace(e,E),!r)throw e;return e},z=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8},_=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8,t[e+2]|=r>>16},x=function(r,e){for(var i=[],s=0;s<r.length;++s)r[s]&&i.push({s:s,f:r[s]});var a=i.length,o=i.slice();if(!a)return{t:F,l:0};if(1==a){var h=new t(i[0].s+1);return h[i[0].s]=1,{t:h,l:1}}i.sort(function(t,n){return t.f-n.f}),i.push({s:-1,f:25001});var f=i[0],l=i[1],u=0,c=1,v=2;for(i[0]={s:-1,f:f.f+l.f,l:f,r:l};c!=a-1;)f=i[i[u].f<i[v].f?u++:v++],l=i[u!=c&&i[u].f<i[v].f?u++:v++],i[c++]={s:-1,f:f.f+l.f,l:f,r:l};var d=o[0].s;for(s=1;s<a;++s)o[s].s>d&&(d=o[s].s);var p=new n(d+1),g=A(i[c-1],p,0);if(g>e){s=0;var w=0,y=g-e,m=1<<y;for(o.sort(function(t,n){return p[n.s]-p[t.s]||t.f-n.f});s<a;++s){var b=o[s].s;if(!(p[b]>e))break;w+=m-(1<<g-p[b]),p[b]=e}for(w>>=y;w>0;){var M=o[s].s;p[M]<e?w-=1<<e-p[M]++-1:++s}for(;s>=0&&w;--s){var E=o[s].s;p[E]==e&&(--p[E],++w)}g=e}return{t:new t(p),l:g}},A=function(t,n,r){return-1==t.s?Math.max(A(t.l,n,r+1),A(t.r,n,r+1)):n[t.s]=r},D=function(t){for(var r=t.length;r&&!t[--r];);for(var e=new n(++r),i=0,s=t[0],a=1,o=function(t){e[i++]=t},h=1;h<=r;++h)if(t[h]==s&&h!=r)++a;else{if(!s&&a>2){for(;a>138;a-=138)o(32754);a>2&&(o(a>10?a-11<<5|28690:a-3<<5|12305),a=0)}else if(a>3){for(o(s),--a;a>6;a-=6)o(8304);a>2&&(o(a-3<<5|8208),a=0)}for(;a--;)o(s);a=1,s=t[h]}return{c:e.subarray(0,i),n:r}},T=function(t,n){for(var r=0,e=0;e<n.length;++e)r+=t[e]*n[e];return r},k=function(t,n,r){var e=r.length,i=m(n+2);t[i]=255&e,t[i+1]=e>>8,t[i+2]=255^t[i],t[i+3]=255^t[i+1];for(var s=0;s<e;++s)t[i+s+4]=r[s];return 8*(i+4+e)},U=function(t,r,a,o,h,f,l,u,c,v,m){z(r,m++,a),++h[256];for(var b=x(h,15),M=b.t,E=b.l,A=x(f,15),U=A.t,C=A.l,F=D(M),I=F.c,S=F.n,L=D(U),O=L.c,j=L.n,q=new n(19),B=0;B<I.length;++B)++q[31&I[B]];for(B=0;B<O.length;++B)++q[31&O[B]];for(var G=x(q,7),H=G.t,J=G.l,K=19;K>4&&!H[s[K-1]];--K);var N,P,Q,R,V=v+5<<3,W=T(h,p)+T(f,g)+l,X=T(h,M)+T(f,U)+l+14+3*K+T(q,H)+2*q[16]+3*q[17]+7*q[18];if(c>=0&&V<=W&&V<=X)return k(r,m,t.subarray(c,c+v));if(z(r,m,1+(X<W)),m+=2,X<W){N=d(M,E,0),P=M,Q=d(U,C,0),R=U;var Y=d(H,J,0);z(r,m,S-257),z(r,m+5,j-1),z(r,m+10,K-4),m+=14;for(B=0;B<K;++B)z(r,m+3*B,H[s[B]]);m+=3*K;for(var Z=[I,O],$=0;$<2;++$){var tt=Z[$];for(B=0;B<tt.length;++B){var nt=31&tt[B];z(r,m,Y[nt]),m+=H[nt],nt>15&&(z(r,m,tt[B]>>5&127),m+=tt[B]>>12)}}}else N=w,P=p,Q=y,R=g;for(B=0;B<u;++B){var rt=o[B];if(rt>255){_(r,m,N[(nt=rt>>18&31)+257]),m+=P[nt+257],nt>7&&(z(r,m,rt>>23&31),m+=e[nt]);var et=31&rt;_(r,m,Q[et]),m+=R[et],et>3&&(_(r,m,rt>>5&8191),m+=i[et])}else _(r,m,N[rt]),m+=P[rt]}return _(r,m,N[256]),m+P[256]},C=new r([65540,131080,131088,131104,262176,1048704,1048832,2114560,2117632]),F=new t(0),I=function(){for(var t=new Int32Array(256),n=0;n<256;++n){for(var r=n,e=9;--e;)r=(1&r&&-306674912)^r>>>1;t[n]=r}return t}(),S=function(){var t=1,n=0;return{p:function(r){for(var e=t,i=n,s=0|r.length,a=0;a!=s;){for(var o=Math.min(a+2655,s);a<o;++a)i+=e+=r[a];e=(65535&e)+15*(e>>16),i=(65535&i)+15*(i>>16)}t=e,n=i},d:function(){return(255&(t%=65521))<<24|(65280&t)<<8|(255&(n%=65521))<<8|n>>8}}},L=function(s,a,o,h,u){if(!u&&(u={l:1},a.dictionary)){var c=a.dictionary.subarray(-32768),v=new t(c.length+s.length);v.set(c),v.set(s,c.length),s=v,u.w=c.length}return function(s,a,o,h,u,c){var v=c.z||s.length,d=new t(h+v+5*(1+Math.ceil(v/7e3))+u),p=d.subarray(h,d.length-u),g=c.l,w=7&(c.r||0);if(a){w&&(p[0]=c.r>>3);for(var y=C[a-1],M=y>>13,E=8191&y,z=(1<<o)-1,_=c.p||new n(32768),x=c.h||new n(z+1),A=Math.ceil(o/3),D=2*A,T=function(t){return(s[t]^s[t+1]<<A^s[t+2]<<D)&z},F=new r(25e3),I=new n(288),S=new n(32),L=0,O=0,j=c.i||0,q=0,B=c.w||0,G=0;j+2<v;++j){var H=T(j),J=32767&j,K=x[H];if(_[J]=K,x[H]=J,B<=j){var N=v-j;if((L>7e3||q>24576)&&(N>423||!g)){w=U(s,p,0,F,I,S,O,q,G,j-G,w),q=L=O=0,G=j;for(var P=0;P<286;++P)I[P]=0;for(P=0;P<30;++P)S[P]=0}var Q=2,R=0,V=E,W=J-K&32767;if(N>2&&H==T(j-W))for(var X=Math.min(M,N)-1,Y=Math.min(32767,j),Z=Math.min(258,N);W<=Y&&--V&&J!=K;){if(s[j+Q]==s[j+Q-W]){for(var $=0;$<Z&&s[j+$]==s[j+$-W];++$);if($>Q){if(Q=$,R=W,$>X)break;var tt=Math.min(W,$-2),nt=0;for(P=0;P<tt;++P){var rt=j-W+P&32767,et=rt-_[rt]&32767;et>nt&&(nt=et,K=rt)}}}W+=(J=K)-(K=_[J])&32767}if(R){F[q++]=268435456|f[Q]<<18|l[R];var it=31&f[Q],st=31&l[R];O+=e[it]+i[st],++I[257+it],++S[st],B=j+Q,++L}else F[q++]=s[j],++I[s[j]]}}for(j=Math.max(j,B);j<v;++j)F[q++]=s[j],++I[s[j]];w=U(s,p,g,F,I,S,O,q,G,j-G,w),g||(c.r=7&w|p[w/8|0]<<3,w-=7,c.h=x,c.p=_,c.i=j,c.w=B)}else{for(j=c.w||0;j<v+g;j+=65535){var at=j+65535;at>=v&&(p[w/8|0]=g,at=v),w=k(p,w+1,s.subarray(j,at))}c.i=v}return b(d,0,h+m(w)+u)}(s,null==a.level?6:a.level,null==a.mem?u.l?Math.ceil(1.5*Math.max(8,Math.min(13,Math.log(s.length)))):20:12+a.mem,o,h,u)},O=function(t,n,r){for(;r;++n)t[n]=r,r>>>=8},j=function(){function n(n,r){if("function"==typeof n&&(r=n,n={}),this.ondata=r,this.o=n||{},this.s={l:0,i:32768,w:32768,z:32768},this.b=new t(98304),this.o.dictionary){var e=this.o.dictionary.subarray(-32768);this.b.set(e,32768-e.length),this.s.i=32768-e.length}}return n.prototype.p=function(t,n){this.ondata(L(t,this.o,0,0,this.s),n)},n.prototype.push=function(n,r){this.ondata||E(5),this.s.l&&E(4);var e=n.length+this.s.z;if(e>this.b.length){if(e>2*this.b.length-32768){var i=new t(-32768&e);i.set(this.b.subarray(0,this.s.z)),this.b=i}var s=this.b.length-this.s.z;this.b.set(n.subarray(0,s),this.s.z),this.s.z=this.b.length,this.p(this.b,!1),this.b.set(this.b.subarray(-32768)),this.b.set(n.subarray(s),32768),this.s.z=n.length-s+32768,this.s.i=32766,this.s.w=32768}else this.b.set(n,this.s.z),this.s.z+=n.length;this.s.l=1&r,(this.s.z>this.s.w+8191||r)&&(this.p(this.b,r||!1),this.s.w=this.s.i,this.s.i-=2)},n.prototype.flush=function(){this.ondata||E(5),this.s.l&&E(4),this.p(this.b,!1),this.s.w=this.s.i,this.s.i-=2},n}();function q(t,n){n||(n={});var r=function(){var t=-1;return{p:function(n){for(var r=t,e=0;e<n.length;++e)r=I[255&r^n[e]]^r>>>8;t=r},d:function(){return~t}}}(),e=t.length;r.p(t);var i,s=L(t,n,10+((i=n).filename?i.filename.length+1:0),8),a=s.length;return function(t,n){var r=n.filename;if(t[0]=31,t[1]=139,t[2]=8,t[8]=n.level<2?4:9==n.level?2:0,t[9]=3,0!=n.mtime&&O(t,4,Math.floor(new Date(n.mtime||Date.now())/1e3)),r){t[3]=8;for(var e=0;e<=r.length;++e)t[e+10]=r.charCodeAt(e)}}(s,n),O(s,a-8,r.d()),O(s,a-4,e),s}var B=function(){function t(t,n){this.c=S(),this.v=1,j.call(this,t,n)}return t.prototype.push=function(t,n){this.c.p(t),j.prototype.push.call(this,t,n)},t.prototype.p=function(t,n){var r=L(t,this.o,this.v&&(this.o.dictionary?6:2),n&&4,this.s);this.v&&(function(t,n){var r=n.level,e=0==r?0:r<6?1:9==r?3:2;if(t[0]=120,t[1]=e<<6|(n.dictionary&&32),t[1]|=31-(t[0]<<8|t[1])%31,n.dictionary){var i=S();i.p(n.dictionary),O(t,2,i.d())}}(r,this.o),this.v=0),n&&O(r,r.length-4,this.c.d()),this.ondata(r,n)},t.prototype.flush=function(){j.prototype.flush.call(this)},t}(),G="undefined"!=typeof TextEncoder&&new TextEncoder,H="undefined"!=typeof TextDecoder&&new TextDecoder;try{H.decode(F,{stream:!0})}catch(t){}var J=function(){function t(t){this.ondata=t}return t.prototype.push=function(t,n){this.ondata||E(5),this.d&&E(4),this.ondata(K(t),this.d=n||!1)},t}();function K(n,r){if(G)return G.encode(n);for(var e=n.length,i=new t(n.length+(n.length>>1)),s=0,a=function(t){i[s++]=t},o=0;o<e;++o){if(s+5>i.length){var h=new t(s+8+(e-o<<1));h.set(i),i=h}var f=n.charCodeAt(o);f<128||r?a(f):f<2048?(a(192|f>>6),a(128|63&f)):f>55295&&f<57344?(a(240|(f=65536+(1047552&f)|1023&n.charCodeAt(++o))>>18),a(128|f>>12&63),a(128|f>>6&63),a(128|63&f)):(a(224|f>>12),a(128|f>>6&63),a(128|63&f))}return b(i,0,s)}const N=new class{constructor(){this._init()}clear(){this._init()}addEvent(t){if(!t)throw new Error("Adding invalid event");const n=this._hasEvents?",":"";this.stream.push(n+t),this._hasEvents=!0}finish(){this.stream.push("]",!0);const t=function(t){let n=0;for(const r of t)n+=r.length;const r=new Uint8Array(n);for(let n=0,e=0,i=t.length;n<i;n++){const i=t[n];r.set(i,e),e+=i.length}return r}(this._deflatedData);return this._init(),t}_init(){this._hasEvents=!1,this._deflatedData=[],this.deflate=new B,this.deflate.ondata=(t,n)=>{this._deflatedData.push(t)},this.stream=new J((t,n)=>{this.deflate.push(t,n)}),this.stream.push("[")}},P={clear:()=>{N.clear()},addEvent:t=>N.addEvent(t),finish:()=>N.finish(),compress:t=>function(t){return q(K(t))}(t)};addEventListener("message",function(t){const n=t.data.method,r=t.data.id,e=t.data.arg;if(n in P&&"function"==typeof P[n])try{const t=P[n](e);postMessage({id:r,method:n,success:!0,response:t})}catch(t){postMessage({id:r,method:n,success:!1,response:t.message}),console.error(t)}}),postMessage({id:void 0,method:"init",success:!0,response:void 0});';
function e() {
    var e = new Blob([
        r
    ]);
    return URL.createObjectURL(e);
}
var CONSOLE_LEVELS = [
    'log',
    'warn',
    'error'
];
var PREFIX = '[Replay] ';
function _addBreadcrumb(message) {
    var level = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'info';
    (0, _core.addBreadcrumb)({
        category: 'console',
        data: {
            logger: 'replay'
        },
        level: level,
        message: "".concat(PREFIX).concat(message)
    }, {
        level: level
    });
}
function makeReplayDebugLogger() {
    var _capture = false;
    var _trace = false;
    var _debug = {
        exception: function() {
            return undefined;
        },
        infoTick: function() {
            return undefined;
        },
        setConfig: function(opts) {
            _capture = !!opts.captureExceptions;
            _trace = !!opts.traceInternals;
        }
    };
    if (DEBUG_BUILD) {
        CONSOLE_LEVELS.forEach(function(name) {
            _debug[name] = function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _debug$1;
                (_debug$1 = (0, _core.debug))[name].apply(_debug$1, [
                    PREFIX
                ].concat((0, _toConsumableArray._)(args)));
                if (_trace) _addBreadcrumb(args.join(''), (0, _core.severityLevelFromString)(name));
            };
        });
        _debug.exception = function(error) {
            for(var _len = arguments.length, message = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                message[_key - 1] = arguments[_key];
            }
            var _debug1;
            if (message.length && _debug.error) (_debug1 = _debug).error.apply(_debug1, (0, _toConsumableArray._)(message));
            (0, _core.debug).error(PREFIX, error);
            if (_capture) (0, _core.captureException)(error, {
                mechanism: {
                    handled: true,
                    type: 'auto.function.replay.debug'
                }
            });
            else if (_trace) // No need for a breadcrumb if `_capture` is enabled since it should be
            // captured as an exception
            _addBreadcrumb(error, 'error');
        };
        _debug.infoTick = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _debug$1;
            (_debug$1 = (0, _core.debug)).log.apply(_debug$1, [
                PREFIX
            ].concat((0, _toConsumableArray._)(args)));
            if (_trace) // Wait a tick here to avoid race conditions for some initial logs
            // which may be added before replay is initialized
            setTimeout(function() {
                return _addBreadcrumb(args[0]);
            }, 0);
        };
    } else CONSOLE_LEVELS.forEach(function(name) {
        _debug[name] = function() {
            return undefined;
        };
    });
    return _debug;
}
var debug = makeReplayDebugLogger();
/** This error indicates that the event buffer size exceeded the limit.. */ var EventBufferSizeExceededError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, _inherits._)(EventBufferSizeExceededError, Error1);
    function EventBufferSizeExceededError() {
        (0, _classCallCheck._)(this, EventBufferSizeExceededError);
        return (0, _callSuper._)(this, EventBufferSizeExceededError, [
            "Event buffer exceeded maximum size of ".concat(REPLAY_MAX_EVENT_BUFFER_SIZE, ".")
        ]);
    }
    return EventBufferSizeExceededError;
}((0, _wrapNativeSuper._)(Error));
/**
 * A basic event buffer that does not do any compression.
 * Used as fallback if the compression worker cannot be loaded or is disabled.
 */ var EventBufferArray = /*#__PURE__*/ function() {
    "use strict";
    function EventBufferArray() {
        (0, _classCallCheck._)(this, EventBufferArray);
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
        this.waitForCheckout = false;
    }
    (0, _createClass._)(EventBufferArray, [
        {
            key: "hasEvents",
            get: /** @inheritdoc */ function get() {
                return this.events.length > 0;
            }
        },
        {
            key: "type",
            get: /** @inheritdoc */ function get() {
                return 'sync';
            }
        },
        {
            /** @inheritdoc */ key: "destroy",
            value: function destroy() {
                this.events = [];
            }
        },
        {
            key: "addEvent",
            value: /** @inheritdoc */ function addEvent(event) {
                return (0, _asyncToGenerator._)(function() {
                    var eventSize;
                    return (0, _tsGenerator._)(this, function(_state) {
                        eventSize = JSON.stringify(event).length;
                        this._totalSize += eventSize;
                        if (this._totalSize > REPLAY_MAX_EVENT_BUFFER_SIZE) throw new EventBufferSizeExceededError();
                        this.events.push(event);
                        return [
                            2
                        ];
                    });
                }).call(this);
            }
        },
        {
            /** @inheritdoc */ key: "finish",
            value: function finish() {
                var _this = this;
                return new Promise(function(resolve) {
                    // Make a copy of the events array reference and immediately clear the
                    // events member so that we do not lose new events while uploading
                    // attachment.
                    var eventsRet = _this.events;
                    _this.clear();
                    resolve(JSON.stringify(eventsRet));
                });
            }
        },
        {
            /** @inheritdoc */ key: "clear",
            value: function clear() {
                this.events = [];
                this._totalSize = 0;
                this.hasCheckout = false;
            }
        },
        {
            /** @inheritdoc */ key: "getEarliestTimestamp",
            value: function getEarliestTimestamp() {
                var timestamp = this.events.map(function(event) {
                    return event.timestamp;
                }).sort()[0];
                if (!timestamp) return null;
                return timestampToMs(timestamp);
            }
        }
    ]);
    return EventBufferArray;
}();
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ var WorkerHandler = /*#__PURE__*/ function() {
    "use strict";
    function WorkerHandler(worker) {
        (0, _classCallCheck._)(this, WorkerHandler);
        this._worker = worker;
        this._id = 0;
    }
    (0, _createClass._)(WorkerHandler, [
        {
            /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occurred.
   */ key: "ensureReady",
            value: function ensureReady() {
                var _this = this;
                // Ensure we only check once
                if (this._ensureReadyPromise) return this._ensureReadyPromise;
                this._ensureReadyPromise = new Promise(function(resolve, reject) {
                    _this._worker.addEventListener('message', function(param) {
                        var data = param.data;
                        if (data.success) resolve();
                        else reject();
                    }, {
                        once: true
                    });
                    _this._worker.addEventListener('error', function(error) {
                        reject(error);
                    }, {
                        once: true
                    });
                });
                return this._ensureReadyPromise;
            }
        },
        {
            /**
   * Destroy the worker.
   */ key: "destroy",
            value: function destroy() {
                DEBUG_BUILD && debug.log('Destroying compression worker');
                this._worker.terminate();
            }
        },
        {
            /**
   * Post message to worker and wait for response before resolving promise.
   */ key: "postMessage",
            value: function postMessage(method, arg) {
                var _this = this;
                var id = this._getAndIncrementId();
                return new Promise(function(resolve, reject) {
                    var listener = function(param) {
                        var data = param.data;
                        var response = data;
                        if (response.method !== method) return;
                        // There can be multiple listeners for a single method, the id ensures
                        // that the response matches the caller.
                        if (response.id !== id) return;
                        // At this point, we'll always want to remove listener regardless of result status
                        _this._worker.removeEventListener('message', listener);
                        if (!response.success) {
                            // TODO: Do some error handling, not sure what
                            DEBUG_BUILD && debug.error('Error in compression worker: ', response.response);
                            reject(new Error('Error in compression worker'));
                            return;
                        }
                        resolve(response.response);
                    };
                    // Note: we can't use `once` option because it's possible it needs to
                    // listen to multiple messages
                    _this._worker.addEventListener('message', listener);
                    _this._worker.postMessage({
                        id: id,
                        method: method,
                        arg: arg
                    });
                });
            }
        },
        {
            /** Get the current ID and increment it for the next call. */ key: "_getAndIncrementId",
            value: function _getAndIncrementId() {
                return this._id++;
            }
        }
    ]);
    return WorkerHandler;
}();
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ var EventBufferCompressionWorker = /*#__PURE__*/ function() {
    "use strict";
    function EventBufferCompressionWorker(worker) {
        (0, _classCallCheck._)(this, EventBufferCompressionWorker);
        this._worker = new WorkerHandler(worker);
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
        this.waitForCheckout = false;
    }
    (0, _createClass._)(EventBufferCompressionWorker, [
        {
            key: "hasEvents",
            get: /** @inheritdoc */ function get() {
                return !!this._earliestTimestamp;
            }
        },
        {
            key: "type",
            get: /** @inheritdoc */ function get() {
                return 'worker';
            }
        },
        {
            /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occurred.
   */ key: "ensureReady",
            value: function ensureReady() {
                return this._worker.ensureReady();
            }
        },
        {
            /**
   * Destroy the event buffer.
   */ key: "destroy",
            value: function destroy() {
                this._worker.destroy();
            }
        },
        {
            /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully received and processed by worker.
   */ key: "addEvent",
            value: function addEvent(event) {
                var timestamp = timestampToMs(event.timestamp);
                if (!this._earliestTimestamp || timestamp < this._earliestTimestamp) this._earliestTimestamp = timestamp;
                var data = JSON.stringify(event);
                this._totalSize += data.length;
                if (this._totalSize > REPLAY_MAX_EVENT_BUFFER_SIZE) return Promise.reject(new EventBufferSizeExceededError());
                return this._sendEventToWorker(data);
            }
        },
        {
            /**
   * Finish the event buffer and return the compressed data.
   */ key: "finish",
            value: function finish() {
                return this._finishRequest();
            }
        },
        {
            /** @inheritdoc */ key: "clear",
            value: function clear() {
                this._earliestTimestamp = null;
                this._totalSize = 0;
                this.hasCheckout = false;
                // We do not wait on this, as we assume the order of messages is consistent for the worker
                this._worker.postMessage('clear').then(null, function(e) {
                    DEBUG_BUILD && debug.exception(e, 'Sending "clear" message to worker failed', e);
                });
            }
        },
        {
            /** @inheritdoc */ key: "getEarliestTimestamp",
            value: function getEarliestTimestamp() {
                return this._earliestTimestamp;
            }
        },
        {
            /**
   * Send the event to the worker.
   */ key: "_sendEventToWorker",
            value: function _sendEventToWorker(data) {
                return this._worker.postMessage('addEvent', data);
            }
        },
        {
            key: "_finishRequest",
            value: /**
   * Finish the request and return the compressed data from the worker.
   */ function _finishRequest() {
                return (0, _asyncToGenerator._)(function() {
                    var response;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this._worker.postMessage('finish')
                                ];
                            case 1:
                                response = _state.sent();
                                this._earliestTimestamp = null;
                                this._totalSize = 0;
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return EventBufferCompressionWorker;
}();
/**
 * This proxy will try to use the compression worker, and fall back to use the simple buffer if an error occurs there.
 * This can happen e.g. if the worker cannot be loaded.
 * Exported only for testing.
 */ var EventBufferProxy = /*#__PURE__*/ function() {
    "use strict";
    function EventBufferProxy(worker) {
        (0, _classCallCheck._)(this, EventBufferProxy);
        this._fallback = new EventBufferArray();
        this._compression = new EventBufferCompressionWorker(worker);
        this._used = this._fallback;
        this._ensureWorkerIsLoadedPromise = this._ensureWorkerIsLoaded();
    }
    (0, _createClass._)(EventBufferProxy, [
        {
            key: "waitForCheckout",
            get: /** @inheritdoc */ function get() {
                return this._used.waitForCheckout;
            },
            set: /** @inheritdoc */ // eslint-disable-next-line @typescript-eslint/adjacent-overload-signatures
            function set(value) {
                this._used.waitForCheckout = value;
            }
        },
        {
            key: "type",
            get: /** @inheritdoc */ function get() {
                return this._used.type;
            }
        },
        {
            key: "hasEvents",
            get: /** @inheritDoc */ function get() {
                return this._used.hasEvents;
            }
        },
        {
            key: "hasCheckout",
            get: /** @inheritdoc */ function get() {
                return this._used.hasCheckout;
            },
            set: /** @inheritdoc */ function set(value) {
                this._used.hasCheckout = value;
            }
        },
        {
            /** @inheritDoc */ key: "destroy",
            value: function destroy() {
                this._fallback.destroy();
                this._compression.destroy();
            }
        },
        {
            /** @inheritdoc */ key: "clear",
            value: function clear() {
                return this._used.clear();
            }
        },
        {
            /** @inheritdoc */ key: "getEarliestTimestamp",
            value: function getEarliestTimestamp() {
                return this._used.getEarliestTimestamp();
            }
        },
        {
            /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully added.
   */ key: "addEvent",
            value: function addEvent(event) {
                return this._used.addEvent(event);
            }
        },
        {
            key: "finish",
            value: /** @inheritDoc */ function finish() {
                return (0, _asyncToGenerator._)(function() {
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Ensure the worker is loaded, so the sent event is compressed
                                return [
                                    4,
                                    this.ensureWorkerIsLoaded()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    this._used.finish()
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /** Ensure the worker has loaded. */ key: "ensureWorkerIsLoaded",
            value: function ensureWorkerIsLoaded() {
                return this._ensureWorkerIsLoadedPromise;
            }
        },
        {
            key: "_ensureWorkerIsLoaded",
            value: /** Actually check if the worker has been loaded. */ function _ensureWorkerIsLoaded() {
                return (0, _asyncToGenerator._)(function() {
                    var error;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    this._compression.ensureReady()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                error = _state.sent();
                                // If the worker fails to load, we fall back to the simple buffer.
                                // Nothing more to do from our side here
                                DEBUG_BUILD && debug.exception(error, 'Failed to load the compression worker, falling back to simple buffer');
                                return [
                                    2
                                ];
                            case 3:
                                // Now we need to switch over the array buffer to the compression worker
                                return [
                                    4,
                                    this._switchToCompressionWorker()
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "_switchToCompressionWorker",
            value: /** Switch the used buffer to the compression worker. */ function _switchToCompressionWorker() {
                return (0, _asyncToGenerator._)(function() {
                    var _this__fallback, events, hasCheckout, waitForCheckout, addEventPromises, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, event, error;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this__fallback = this._fallback, events = _this__fallback.events, hasCheckout = _this__fallback.hasCheckout, waitForCheckout = _this__fallback.waitForCheckout;
                                addEventPromises = [];
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(_iterator = events[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        event = _step.value;
                                        addEventPromises.push(this._compression.addEvent(event));
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                this._compression.hasCheckout = hasCheckout;
                                this._compression.waitForCheckout = waitForCheckout;
                                // We switch over to the new buffer immediately - any further events will be added
                                // after the previously buffered ones
                                this._used = this._compression;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    Promise.all(addEventPromises)
                                ];
                            case 2:
                                _state.sent();
                                // Can now clear fallback buffer as it's no longer necessary
                                this._fallback.clear();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                error = _state.sent();
                                DEBUG_BUILD && debug.exception(error, 'Failed to add events when switching buffers.');
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return EventBufferProxy;
}();
/**
 * Create an event buffer for replays.
 */ function createEventBuffer(param) {
    var useCompression = param.useCompression, customWorkerUrl = param.workerUrl;
    if (useCompression && // eslint-disable-next-line no-restricted-globals
    window.Worker) {
        var worker = _loadWorker(customWorkerUrl);
        if (worker) return worker;
    }
    DEBUG_BUILD && debug.log('Using simple buffer');
    return new EventBufferArray();
}
function _loadWorker(customWorkerUrl) {
    try {
        var workerUrl = customWorkerUrl || _getWorkerUrl();
        if (!workerUrl) return;
        DEBUG_BUILD && debug.log("Using compression worker".concat(customWorkerUrl ? " from ".concat(customWorkerUrl) : ''));
        var worker = new Worker(workerUrl);
        return new EventBufferProxy(worker);
    } catch (error) {
        DEBUG_BUILD && debug.exception(error, 'Failed to create compression worker');
    // Fall back to use simple event buffer array
    }
}
function _getWorkerUrl() {
    if (typeof __SENTRY_EXCLUDE_REPLAY_WORKER__ === 'undefined' || !__SENTRY_EXCLUDE_REPLAY_WORKER__) return e();
    return '';
}
/** If sessionStorage is available. */ function hasSessionStorage() {
    try {
        // This can throw, e.g. when being accessed in a sandboxed iframe
        return 'sessionStorage' in WINDOW && !!WINDOW.sessionStorage;
    } catch (e) {
        return false;
    }
}
/**
 * Removes the session from Session Storage and unsets session in replay instance
 */ function clearSession(replay) {
    deleteSession();
    replay.session = undefined;
}
/**
 * Deletes a session from storage
 */ function deleteSession() {
    if (!hasSessionStorage()) return;
    try {
        WINDOW.sessionStorage.removeItem(REPLAY_SESSION_KEY);
    } catch (e) {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Given a sample rate, returns true if replay should be sampled.
 *
 * 1.0 = 100% sampling
 * 0.0 = 0% sampling
 */ function isSampled(sampleRate) {
    if (sampleRate === undefined) return false;
    // Math.random() returns a number in range of 0 to 1 (inclusive of 0, but not 1)
    return Math.random() < sampleRate;
}
/**
 * Save a session to session storage.
 */ function saveSession(session) {
    if (!hasSessionStorage()) return;
    try {
        WINDOW.sessionStorage.setItem(REPLAY_SESSION_KEY, JSON.stringify(session));
    } catch (e) {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Get a session with defaults & applied sampling.
 */ function makeSession(session) {
    var now = Date.now();
    var id = session.id || (0, _core.uuid4)();
    // Note that this means we cannot set a started/lastActivity of `0`, but this should not be relevant outside of tests.
    var started = session.started || now;
    var lastActivity = session.lastActivity || now;
    var segmentId = session.segmentId || 0;
    var sampled = session.sampled;
    var previousSessionId = session.previousSessionId;
    var dirty = session.dirty || false;
    return {
        id: id,
        started: started,
        lastActivity: lastActivity,
        segmentId: segmentId,
        sampled: sampled,
        previousSessionId: previousSessionId,
        dirty: dirty
    };
}
/**
 * Get the sampled status for a session based on sample rates & current sampled status.
 */ function getSessionSampleType(sessionSampleRate, allowBuffering) {
    return isSampled(sessionSampleRate) ? 'session' : allowBuffering ? 'buffer' : false;
}
/**
 * Create a new session, which in its current implementation is a Sentry event
 * that all replays will be saved to as attachments. Currently, we only expect
 * one of these Sentry events per "replay session".
 */ function createSession(param) {
    var sessionSampleRate = param.sessionSampleRate, allowBuffering = param.allowBuffering, _param_stickySession = param.stickySession, stickySession = _param_stickySession === void 0 ? false : _param_stickySession, previousSessionId = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).previousSessionId;
    var sampled = getSessionSampleType(sessionSampleRate, allowBuffering);
    var session = makeSession({
        sampled: sampled,
        previousSessionId: previousSessionId
    });
    if (stickySession) saveSession(session);
    return session;
}
/**
 * Fetches a session from storage
 */ function fetchSession() {
    if (!hasSessionStorage()) return null;
    try {
        // This can throw if cookies are disabled
        var sessionStringFromStorage = WINDOW.sessionStorage.getItem(REPLAY_SESSION_KEY);
        if (!sessionStringFromStorage) return null;
        var sessionObj = JSON.parse(sessionStringFromStorage);
        DEBUG_BUILD && debug.infoTick('Loading existing session');
        return makeSession(sessionObj);
    } catch (e) {
        return null;
    }
}
/**
 * Given an initial timestamp and an expiry duration, checks to see if current
 * time should be considered as expired.
 */ function isExpired(initialTime, expiry) {
    var targetTime = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : +new Date();
    // Always expired if < 0
    if (initialTime === null || expiry === undefined || expiry < 0) return true;
    // Never expires if == 0
    if (expiry === 0) return false;
    return initialTime + expiry <= targetTime;
}
/**
 * Checks to see if session is expired
 */ function isSessionExpired(session, param) {
    var maxReplayDuration = param.maxReplayDuration, sessionIdleExpire = param.sessionIdleExpire, _param_targetTime = param.targetTime, targetTime = _param_targetTime === void 0 ? Date.now() : _param_targetTime;
    return(// First, check that maximum session length has not been exceeded
    isExpired(session.started, maxReplayDuration, targetTime) || // check that the idle timeout has not been exceeded (i.e. user has
    // performed an action within the last `sessionIdleExpire` ms)
    isExpired(session.lastActivity, sessionIdleExpire, targetTime));
}
/** If the session should be refreshed or not. */ function shouldRefreshSession(session, param) {
    var sessionIdleExpire = param.sessionIdleExpire, maxReplayDuration = param.maxReplayDuration;
    // If not expired, all good, just keep the session
    if (!isSessionExpired(session, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return false;
    // If we are buffering & haven't ever flushed yet, always continue
    if (session.sampled === 'buffer' && session.segmentId === 0) return false;
    return true;
}
/**
 * Get or create a session, when initializing the replay.
 * Returns a session that may be unsampled.
 */ function loadOrCreateSession(param, sessionOptions) {
    var sessionIdleExpire = param.sessionIdleExpire, maxReplayDuration = param.maxReplayDuration, previousSessionId = param.previousSessionId;
    var existingSession = sessionOptions.stickySession && fetchSession();
    // No session exists yet, just create a new one
    if (!existingSession) {
        DEBUG_BUILD && debug.infoTick('Creating new session');
        return createSession(sessionOptions, {
            previousSessionId: previousSessionId
        });
    }
    if (!shouldRefreshSession(existingSession, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return existingSession;
    DEBUG_BUILD && debug.infoTick('Session in sessionStorage is expired, creating new one...');
    return createSession(sessionOptions, {
        previousSessionId: existingSession.id
    });
}
function isCustomEvent(event) {
    return event.type === EventType.Custom;
}
/**
 * Add an event to the event buffer.
 * In contrast to `addEvent`, this does not return a promise & does not wait for the adding of the event to succeed/fail.
 * Instead this returns `true` if we tried to add the event, else false.
 * It returns `false` e.g. if we are paused, disabled, or out of the max replay duration.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ function addEventSync(replay, event, isCheckout) {
    if (!shouldAddEvent(replay, event)) return false;
    // This should never reject
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    _addEvent(replay, event, isCheckout);
    return true;
}
/**
 * Add an event to the event buffer.
 * Resolves to `null` if no event was added, else to `void`.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ function addEvent(replay, event, isCheckout) {
    if (!shouldAddEvent(replay, event)) return Promise.resolve(null);
    return _addEvent(replay, event, isCheckout);
}
function _addEvent(replay, event, isCheckout) {
    return (0, _asyncToGenerator._)(function() {
        var eventBuffer, isBufferMode, replayOptions, eventAfterPossibleCallback, error, isExceeded, reason, client, dropReason;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    eventBuffer = replay.eventBuffer;
                    if (!eventBuffer || eventBuffer.waitForCheckout && !isCheckout) return [
                        2,
                        null
                    ];
                    isBufferMode = replay.recordingMode === 'buffer';
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        5
                    ]);
                    if (isCheckout && isBufferMode) eventBuffer.clear();
                    if (isCheckout) {
                        eventBuffer.hasCheckout = true;
                        eventBuffer.waitForCheckout = false;
                    }
                    replayOptions = replay.getOptions();
                    eventAfterPossibleCallback = maybeApplyCallback(event, replayOptions.beforeAddRecordingEvent);
                    if (!eventAfterPossibleCallback) return [
                        2
                    ];
                    return [
                        4,
                        eventBuffer.addEvent(eventAfterPossibleCallback)
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    error = _state.sent();
                    isExceeded = error && (0, _instanceof._)(error, EventBufferSizeExceededError);
                    reason = isExceeded ? 'addEventSizeExceeded' : 'addEvent';
                    client = (0, _core.getClient)();
                    if (client) {
                        // We are limited in the drop reasons:
                        // https://github.com/getsentry/snuba/blob/6c73be60716c2fb1c30ca627883207887c733cbd/rust_snuba/src/processors/outcomes.rs#L39
                        dropReason = isExceeded ? 'buffer_overflow' : 'internal_sdk_error';
                        client.recordDroppedEvent(dropReason, 'replay');
                    }
                    if (isExceeded && isBufferMode) {
                        // Clear buffer and wait for next checkout
                        eventBuffer.clear();
                        eventBuffer.waitForCheckout = true;
                        return [
                            2,
                            null
                        ];
                    }
                    replay.handleException(error);
                    return [
                        4,
                        replay.stop({
                            reason: reason
                        })
                    ];
                case 4:
                    _state.sent();
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    })();
}
/** Exported only for tests. */ function shouldAddEvent(replay, event) {
    if (!replay.eventBuffer || replay.isPaused() || !replay.isEnabled()) return false;
    var timestampInMs = timestampToMs(event.timestamp);
    // Throw out events that happen more than 5 minutes ago. This can happen if
    // page has been left open and idle for a long period of time and user
    // comes back to trigger a new session. The performance entries rely on
    // `performance.timeOrigin`, which is when the page first opened.
    if (timestampInMs + replay.timeouts.sessionIdlePause < Date.now()) return false;
    // Throw out events that are +60min from the initial timestamp
    if (timestampInMs > replay.getContext().initialTimestamp + replay.getOptions().maxReplayDuration) {
        DEBUG_BUILD && debug.infoTick("Skipping event with timestamp ".concat(timestampInMs, " because it is after maxReplayDuration"));
        return false;
    }
    return true;
}
function maybeApplyCallback(event, callback) {
    try {
        if (typeof callback === 'function' && isCustomEvent(event)) return callback(event);
    } catch (error) {
        DEBUG_BUILD && debug.exception(error, 'An error occurred in the `beforeAddRecordingEvent` callback, skipping the event...');
        return null;
    }
    return event;
}
/** If the event is an error event */ function isErrorEvent(event) {
    return !event.type;
}
/** If the event is a transaction event */ function isTransactionEvent(event) {
    return event.type === 'transaction';
}
/** If the event is an replay event */ function isReplayEvent(event) {
    return event.type === 'replay_event';
}
/** If the event is a feedback event */ function isFeedbackEvent(event) {
    return event.type === 'feedback';
}
/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */ function handleAfterSendEvent(replay) {
    return function(event, sendResponse) {
        if (!replay.isEnabled() || !isErrorEvent(event) && !isTransactionEvent(event)) return;
        var statusCode = sendResponse.statusCode;
        // We only want to do stuff on successful error sending, otherwise you get error replays without errors attached
        // We skip if we encountered an non-OK status code
        if (!statusCode || statusCode < 200 || statusCode >= 300) return;
        if (isTransactionEvent(event)) {
            handleTransactionEvent(replay, event);
            return;
        }
        handleErrorEvent(replay, event);
    };
}
function handleTransactionEvent(replay, event) {
    var _event_contexts_trace, _event_contexts;
    var replayContext = replay.getContext();
    // Collect traceIds in _context regardless of `recordingMode`
    // In error mode, _context gets cleared on every checkout
    // We limit to max. 100 transactions linked
    if (((_event_contexts = event.contexts) === null || _event_contexts === void 0 ? void 0 : (_event_contexts_trace = _event_contexts.trace) === null || _event_contexts_trace === void 0 ? void 0 : _event_contexts_trace.trace_id) && replayContext.traceIds.size < 100) replayContext.traceIds.add(event.contexts.trace.trace_id);
}
function handleErrorEvent(replay, event) {
    var replayContext = replay.getContext();
    // Add error to list of errorIds of replay. This is ok to do even if not
    // sampled because context will get reset at next checkout.
    // XXX: There is also a race condition where it's possible to capture an
    // error to Sentry before Replay SDK has loaded, but response returns after
    // it was loaded, and this gets called.
    // We limit to max. 100 errors linked
    if (event.event_id && replayContext.errorIds.size < 100) replayContext.errorIds.add(event.event_id);
    // If error event is tagged with replay id it means it was sampled (when in buffer mode)
    // Need to be very careful that this does not cause an infinite loop
    if (replay.recordingMode !== 'buffer' || !event.tags || !event.tags.replayId) return;
    var beforeErrorSampling = replay.getOptions().beforeErrorSampling;
    if (typeof beforeErrorSampling === 'function' && !beforeErrorSampling(event)) return;
    (0, _browserUtils.setTimeout)(function() {
        return (0, _asyncToGenerator._)(function() {
            var err;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        // Capture current event buffer as new replay
                        return [
                            4,
                            replay.sendBufferedReplayOrFlush()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        err = _state.sent();
                        replay.handleException(err);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    });
}
/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */ function handleBeforeSendEvent(replay) {
    return function(event) {
        if (!replay.isEnabled() || !isErrorEvent(event)) return;
        handleHydrationError(replay, event);
    };
}
function handleHydrationError(replay, event) {
    var _event_exception_values_, _event_exception_values, _event_exception;
    var exceptionValue = (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : (_event_exception_values_ = _event_exception_values[0]) === null || _event_exception_values_ === void 0 ? void 0 : _event_exception_values_.value;
    if (typeof exceptionValue !== 'string') return;
    if (// Only matches errors in production builds of react-dom
    // Example https://reactjs.org/docs/error-decoder.html?invariant=423
    // With newer React versions, the messages changed to a different website https://react.dev/errors/418
    exceptionValue.match(/(reactjs\.org\/docs\/error-decoder\.html\?invariant=|react\.dev\/errors\/)(418|419|422|423|425)/) || // Development builds of react-dom
    // Error 1: Hydration failed because the initial UI does not match what was rendered on the server.
    // Error 2: Text content does not match server-rendered HTML. Warning: Text content did not match.
    exceptionValue.match(/(does not match server-rendered HTML|Hydration failed because)/i)) {
        var breadcrumb = createBreadcrumb({
            category: 'replay.hydrate-error',
            data: {
                url: (0, _core.getLocationHref)()
            }
        });
        addBreadcrumbEvent(replay, breadcrumb);
    }
}
/**
 * Handle breadcrumbs that Sentry captures, and make sure to capture relevant breadcrumbs to Replay as well.
 */ function handleBreadcrumbs(replay) {
    var client = (0, _core.getClient)();
    if (!client) return;
    client.on('beforeAddBreadcrumb', function(breadcrumb) {
        return beforeAddBreadcrumb(replay, breadcrumb);
    });
}
function beforeAddBreadcrumb(replay, breadcrumb) {
    if (!replay.isEnabled() || !isBreadcrumbWithCategory(breadcrumb)) return;
    var result = normalizeBreadcrumb(breadcrumb);
    if (result) addBreadcrumbEvent(replay, result);
}
/** Exported only for tests. */ function normalizeBreadcrumb(breadcrumb) {
    if (!isBreadcrumbWithCategory(breadcrumb) || [
        // fetch & xhr are handled separately,in handleNetworkBreadcrumbs
        'fetch',
        'xhr',
        // These two are breadcrumbs for emitted sentry events, we don't care about them
        'sentry.event',
        'sentry.transaction'
    ].includes(breadcrumb.category) || // We capture UI breadcrumbs separately
    breadcrumb.category.startsWith('ui.')) return null;
    if (breadcrumb.category === 'console') return normalizeConsoleBreadcrumb(breadcrumb);
    return createBreadcrumb(breadcrumb);
}
/** exported for tests only */ function normalizeConsoleBreadcrumb(breadcrumb) {
    var _breadcrumb_data;
    var args = (_breadcrumb_data = breadcrumb.data) === null || _breadcrumb_data === void 0 ? void 0 : _breadcrumb_data.arguments;
    if (!Array.isArray(args) || args.length === 0) return createBreadcrumb(breadcrumb);
    var isTruncated = false;
    // Avoid giant args captures
    var normalizedArgs = args.map(function(arg) {
        if (!arg) return arg;
        if (typeof arg === 'string') {
            if (arg.length > CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                return "".concat(arg.slice(0, CONSOLE_ARG_MAX_SIZE), "\u2026");
            }
            return arg;
        }
        if ((typeof arg === "undefined" ? "undefined" : (0, _typeOf._)(arg)) === 'object') try {
            var normalizedArg = (0, _core.normalize)(arg, 7);
            var stringified = JSON.stringify(normalizedArg);
            if (stringified.length > CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                // We use the pretty printed JSON string here as a base
                return "".concat(JSON.stringify(normalizedArg, null, 2).slice(0, CONSOLE_ARG_MAX_SIZE), "\u2026");
            }
            return normalizedArg;
        } catch (e) {
        // fall back to default
        }
        return arg;
    });
    return createBreadcrumb((0, _objectSpreadProps._)((0, _objectSpread._)({}, breadcrumb), {
        data: (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, breadcrumb.data), {
            arguments: normalizedArgs
        }), isTruncated ? {
            _meta: {
                warnings: [
                    'CONSOLE_ARG_TRUNCATED'
                ]
            }
        } : {})
    }));
}
function isBreadcrumbWithCategory(breadcrumb) {
    return !!breadcrumb.category;
}
/**
 * Returns true if we think the given event is an error originating inside of rrweb.
 */ function isRrwebError(event, hint) {
    var _event_exception_values, _event_exception, _hint_originalException;
    if (event.type || !((_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values.length)) return false;
    // @ts-expect-error this may be set by rrweb when it finds errors
    if ((_hint_originalException = hint.originalException) === null || _hint_originalException === void 0 ? void 0 : _hint_originalException.__rrweb__) return true;
    return false;
}
/**
 * Reset the `replay_id` field on the DSC.
 */ function resetReplayIdOnDynamicSamplingContext() {
    // Reset DSC on the current scope, if there is one
    var dsc = (0, _core.getCurrentScope)().getPropagationContext().dsc;
    if (dsc) delete dsc.replay_id;
    // Clear it from frozen DSC on the active span
    var activeSpan = (0, _core.getActiveSpan)();
    if (activeSpan) {
        var dsc1 = (0, _core.getDynamicSamplingContextFromSpan)(activeSpan);
        delete dsc1.replay_id;
    }
}
/**
 * Add a feedback breadcrumb event to replay.
 */ function addFeedbackBreadcrumb(replay, event) {
    replay.triggerUserActivity();
    replay.addUpdate(function() {
        if (!event.timestamp) // Ignore events that don't have timestamps (this shouldn't happen, more of a typing issue)
        // Return true here so that we don't flush
        return true;
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.throttledAddEvent({
            type: EventType.Custom,
            timestamp: event.timestamp * 1000,
            data: {
                tag: 'breadcrumb',
                payload: {
                    timestamp: event.timestamp,
                    type: 'default',
                    category: 'sentry.feedback',
                    data: {
                        feedbackId: event.event_id
                    }
                }
            }
        });
        return false;
    });
}
/**
 * Determine if event should be sampled (only applies in buffer mode).
 * When an event is captured by `handleGlobalEvent`, when in buffer mode
 * we determine if we want to sample the error or not.
 */ function shouldSampleForBufferEvent(replay, event) {
    if (replay.recordingMode !== 'buffer') return false;
    // ignore this error because otherwise we could loop indefinitely with
    // trying to capture replay and failing
    if (event.message === UNABLE_TO_SEND_REPLAY) return false;
    // Require the event to be an error event & to have an exception
    if (!event.exception || event.type) return false;
    return isSampled(replay.getOptions().errorSampleRate);
}
/**
 * Returns a listener to be added to `addEventProcessor(listener)`.
 */ function handleGlobalEventListener(replay) {
    return Object.assign(function(event, hint) {
        var _replay_session;
        // Do nothing if replay has been disabled or paused
        if (!replay.isEnabled() || replay.isPaused()) return event;
        if (isReplayEvent(event)) {
            // Replays have separate set of breadcrumbs, do not include breadcrumbs
            // from core SDK
            delete event.breadcrumbs;
            return event;
        }
        // We only want to handle errors, transactions, and feedbacks, nothing else
        if (!isErrorEvent(event) && !isTransactionEvent(event) && !isFeedbackEvent(event)) return event;
        // Ensure we do not add replay_id if the session is expired
        var isSessionActive = replay.checkAndHandleExpiredSession();
        if (!isSessionActive) {
            // prevent exceeding replay durations by removing the expired replayId from the DSC
            resetReplayIdOnDynamicSamplingContext();
            return event;
        }
        if (isFeedbackEvent(event)) {
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            replay.flush();
            event.contexts.feedback.replay_id = replay.getSessionId();
            // Add a replay breadcrumb for this piece of feedback
            addFeedbackBreadcrumb(replay, event);
            return event;
        }
        // Unless `captureExceptions` is enabled, we want to ignore errors coming from rrweb
        // As there can be a bunch of stuff going wrong in internals there, that we don't want to bubble up to users
        if (isRrwebError(event, hint) && !replay.getOptions()._experiments.captureExceptions) {
            DEBUG_BUILD && debug.log('Ignoring error from rrweb internals', event);
            return null;
        }
        // When in buffer mode, we decide to sample here.
        // Later, in `handleAfterSendEvent`, if the replayId is set, we know that we sampled
        // And convert the buffer session to a full session
        var isErrorEventSampled = shouldSampleForBufferEvent(replay, event);
        // Tag errors if it has been sampled in buffer mode, or if it is session mode
        // Only tag transactions if in session mode
        var shouldTagReplayId = isErrorEventSampled || replay.recordingMode === 'session';
        if (shouldTagReplayId) event.tags = (0, _objectSpreadProps._)((0, _objectSpread._)({}, event.tags), {
            replayId: replay.getSessionId()
        });
        // If we sampled this error in buffer mode, immediately mark the session as "sampled"
        // by changing the sampled state from 'buffer' to 'session'. Otherwise, if the application is interrupte
        // before `afterSendEvent` occurs, then the session would remain as "buffer" but we have an error event
        // that is tagged with a replay id. This could end up creating replays w/ excessive durations because
        // of the linked error.
        if (isErrorEventSampled && replay.recordingMode === 'buffer' && ((_replay_session = replay.session) === null || _replay_session === void 0 ? void 0 : _replay_session.sampled) === 'buffer') {
            var session = replay.session;
            session.dirty = true;
            // Save the session if sticky sessions are enabled to persist the state change
            if (replay.getOptions().stickySession) saveSession(session);
        }
        return event;
    }, {
        id: 'Replay'
    });
}
/**
 * Create a "span" for each performance entry.
 */ function createPerformanceSpans(replay, entries) {
    return entries.map(function(param) {
        var type = param.type, start = param.start, end = param.end, name = param.name, data = param.data;
        var response = replay.throttledAddEvent({
            type: EventType.Custom,
            timestamp: start,
            data: {
                tag: 'performanceSpan',
                payload: {
                    op: type,
                    description: name,
                    startTimestamp: start,
                    endTimestamp: end,
                    data: data
                }
            }
        });
        // If response is a string, it means its either THROTTLED or SKIPPED
        return typeof response === 'string' ? Promise.resolve(null) : response;
    });
}
function handleHistory(handlerData) {
    var from = handlerData.from, to = handlerData.to;
    var now = Date.now() / 1000;
    return {
        type: 'navigation.push',
        start: now,
        end: now,
        name: to,
        data: {
            previous: from
        }
    };
}
/**
 * Returns a listener to be added to `addHistoryInstrumentationHandler(listener)`.
 */ function handleHistorySpanListener(replay) {
    return function(handlerData) {
        if (!replay.isEnabled()) return;
        var result = handleHistory(handlerData);
        if (result === null) return;
        // Need to collect visited URLs
        replay.getContext().urls.push(result.name);
        replay.triggerUserActivity();
        replay.addUpdate(function() {
            createPerformanceSpans(replay, [
                result
            ]);
            // Returning false to flush
            return false;
        });
    };
}
/**
 * Check whether a given request URL should be filtered out. This is so we
 * don't log Sentry ingest requests.
 */ function shouldFilterRequest(replay, url) {
    // If we enabled the `traceInternals` experiment, we want to trace everything
    if (DEBUG_BUILD && replay.getOptions()._experiments.traceInternals) return false;
    return (0, _core.isSentryRequestUrl)(url, (0, _core.getClient)());
}
/** Add a performance entry breadcrumb */ function addNetworkBreadcrumb(replay, result) {
    if (!replay.isEnabled()) return;
    if (result === null) return;
    if (shouldFilterRequest(replay, result.name)) return;
    replay.addUpdate(function() {
        createPerformanceSpans(replay, [
            result
        ]);
        // Returning true will cause `addUpdate` to not flush
        // We do not want network requests to cause a flush. This will prevent
        // recurring/polling requests from keeping the replay session alive.
        return true;
    });
}
/** Get the size of a body. */ function getBodySize(body) {
    if (!body) return undefined;
    var textEncoder = new TextEncoder();
    try {
        if (typeof body === 'string') return textEncoder.encode(body).length;
        if ((0, _instanceof._)(body, URLSearchParams)) return textEncoder.encode(body.toString()).length;
        if ((0, _instanceof._)(body, FormData)) {
            var formDataStr = (0, _browserUtils.serializeFormData)(body);
            return textEncoder.encode(formDataStr).length;
        }
        if ((0, _instanceof._)(body, Blob)) return body.size;
        if ((0, _instanceof._)(body, ArrayBuffer)) return body.byteLength;
    // Currently unhandled types: ArrayBufferView, ReadableStream
    } catch (e) {
    // just return undefined
    }
    return undefined;
}
/** Convert a Content-Length header to number/undefined.  */ function parseContentLengthHeader(header) {
    if (!header) return undefined;
    var size = parseInt(header, 10);
    return isNaN(size) ? undefined : size;
}
/** Merge a warning into an existing network request/response. */ function mergeWarning(info, warning) {
    if (!info) return {
        headers: {},
        size: undefined,
        _meta: {
            warnings: [
                warning
            ]
        }
    };
    var newMeta = (0, _objectSpread._)({}, info._meta);
    var existingWarnings = newMeta.warnings || [];
    newMeta.warnings = (0, _toConsumableArray._)(existingWarnings).concat([
        warning
    ]);
    info._meta = newMeta;
    return info;
}
/** Convert ReplayNetworkRequestData to a PerformanceEntry. */ function makeNetworkReplayBreadcrumb(type, data) {
    if (!data) return null;
    var startTimestamp = data.startTimestamp, endTimestamp = data.endTimestamp, url = data.url, method = data.method, statusCode = data.statusCode, request = data.request, response = data.response;
    var result = {
        type: type,
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        name: url,
        data: {
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        }
    };
    return result;
}
/** Build the request or response part of a replay network breadcrumb that was skipped. */ function buildSkippedNetworkRequestOrResponse(bodySize) {
    return {
        headers: {},
        size: bodySize,
        _meta: {
            warnings: [
                'URL_SKIPPED'
            ]
        }
    };
}
/** Build the request or response part of a replay network breadcrumb. */ function buildNetworkRequestOrResponse(headers, bodySize, body) {
    if (!bodySize && Object.keys(headers).length === 0) return undefined;
    if (!bodySize) return {
        headers: headers
    };
    if (!body) return {
        headers: headers,
        size: bodySize
    };
    var info = {
        headers: headers,
        size: bodySize
    };
    var _normalizeNetworkBody = normalizeNetworkBody(body), normalizedBody = _normalizeNetworkBody.body, warnings = _normalizeNetworkBody.warnings;
    info.body = normalizedBody;
    if (warnings === null || warnings === void 0 ? void 0 : warnings.length) info._meta = {
        warnings: warnings
    };
    return info;
}
/** Filter a set of headers */ function getAllowedHeaders(headers, allowedHeaders) {
    return Object.entries(headers).reduce(function(filteredHeaders, param) {
        var _param = (0, _slicedToArray._)(param, 2), key = _param[0], value = _param[1];
        var normalizedKey = key.toLowerCase();
        // Avoid putting empty strings into the headers
        if (allowedHeaders.includes(normalizedKey) && headers[key]) filteredHeaders[normalizedKey] = value;
        return filteredHeaders;
    }, {});
}
function normalizeNetworkBody(body) {
    if (!body || typeof body !== 'string') return {
        body: body
    };
    var exceedsSizeLimit = body.length > NETWORK_BODY_MAX_SIZE;
    var isProbablyJson = _strIsProbablyJson(body);
    if (exceedsSizeLimit) {
        var truncatedBody = body.slice(0, NETWORK_BODY_MAX_SIZE);
        if (isProbablyJson) return {
            body: truncatedBody,
            warnings: [
                'MAYBE_JSON_TRUNCATED'
            ]
        };
        return {
            body: "".concat(truncatedBody, "\u2026"),
            warnings: [
                'TEXT_TRUNCATED'
            ]
        };
    }
    if (isProbablyJson) try {
        var jsonBody = JSON.parse(body);
        return {
            body: jsonBody
        };
    } catch (e) {
    // fall back to just send the body as string
    }
    return {
        body: body
    };
}
function _strIsProbablyJson(str) {
    var first = str[0];
    var last = str[str.length - 1];
    // Simple check: If this does not start & end with {} or [], it's not JSON
    return first === '[' && last === ']' || first === '{' && last === '}';
}
/** Match an URL against a list of strings/Regex. */ function urlMatches(url, urls) {
    var fullUrl = getFullUrl(url);
    return (0, _core.stringMatchesSomePattern)(fullUrl, urls);
}
/** exported for tests */ function getFullUrl(url) {
    var baseURI = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : WINDOW.document.baseURI;
    // Short circuit for common cases:
    if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith(WINDOW.location.origin)) return url;
    var fixedUrl = new URL(url, baseURI);
    // If these do not match, we are not dealing with a relative URL, so just return it
    if (fixedUrl.origin !== new URL(baseURI).origin) return url;
    var fullUrl = fixedUrl.href;
    // Remove trailing slashes, if they don't match the original URL
    if (!url.endsWith('/') && fullUrl.endsWith('/')) return fullUrl.slice(0, -1);
    return fullUrl;
}
/**
 * Capture a fetch breadcrumb to a replay.
 * This adds additional data (where appropriate).
 */ function captureFetchBreadcrumbToReplay(breadcrumb, hint, options) {
    return (0, _asyncToGenerator._)(function() {
        var data, result, error;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        _prepareFetchData(breadcrumb, hint, options)
                    ];
                case 1:
                    data = _state.sent();
                    // Create a replay performance entry from this breadcrumb
                    result = makeNetworkReplayBreadcrumb('resource.fetch', data);
                    addNetworkBreadcrumb(options.replay, result);
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    DEBUG_BUILD && debug.exception(error, 'Failed to capture fetch breadcrumb');
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function enrichFetchBreadcrumb(breadcrumb, hint) {
    var input = hint.input, response = hint.response;
    var body = input ? (0, _browserUtils.getFetchRequestArgBody)(input) : undefined;
    var reqSize = getBodySize(body);
    var resSize = response ? parseContentLengthHeader(response.headers.get('content-length')) : undefined;
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
function _prepareFetchData(breadcrumb, hint, options) {
    return (0, _asyncToGenerator._)(function() {
        var now, _hint_startTimestamp, startTimestamp, _hint_endTimestamp, endTimestamp, _breadcrumb_data, url, method, tmp, statusCode, requestBodySize, responseBodySize, captureDetails, request, response;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    now = Date.now();
                    _hint_startTimestamp = hint.startTimestamp, startTimestamp = _hint_startTimestamp === void 0 ? now : _hint_startTimestamp, _hint_endTimestamp = hint.endTimestamp, endTimestamp = _hint_endTimestamp === void 0 ? now : _hint_endTimestamp;
                    _breadcrumb_data = breadcrumb.data, url = _breadcrumb_data.url, method = _breadcrumb_data.method, tmp = _breadcrumb_data.status_code, statusCode = tmp === void 0 ? 0 : tmp, requestBodySize = _breadcrumb_data.request_body_size, responseBodySize = _breadcrumb_data.response_body_size;
                    captureDetails = urlMatches(url, options.networkDetailAllowUrls) && !urlMatches(url, options.networkDetailDenyUrls);
                    request = captureDetails ? _getRequestInfo(options, hint.input, requestBodySize) : buildSkippedNetworkRequestOrResponse(requestBodySize);
                    return [
                        4,
                        _getResponseInfo(captureDetails, options, hint.response, responseBodySize)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        {
                            startTimestamp: startTimestamp,
                            endTimestamp: endTimestamp,
                            url: url,
                            method: method,
                            statusCode: statusCode,
                            request: request,
                            response: response
                        }
                    ];
            }
        });
    })();
}
function _getRequestInfo(param, input, requestBodySize) {
    var networkCaptureBodies = param.networkCaptureBodies, networkRequestHeaders = param.networkRequestHeaders;
    var headers = input ? getRequestHeaders(input, networkRequestHeaders) : {};
    if (!networkCaptureBodies) return buildNetworkRequestOrResponse(headers, requestBodySize, undefined);
    // We only want to transmit string or string-like bodies
    var requestBody = (0, _browserUtils.getFetchRequestArgBody)(input);
    var _getBodyString = (0, _slicedToArray._)((0, _browserUtils.getBodyString)(requestBody, debug), 2), bodyStr = _getBodyString[0], warning = _getBodyString[1];
    var data = buildNetworkRequestOrResponse(headers, requestBodySize, bodyStr);
    if (warning) return mergeWarning(data, warning);
    return data;
}
/** Exported only for tests. */ function _getResponseInfo(_0, _1, _2, _3) {
    return (0, _asyncToGenerator._)(function(captureDetails, param, response, responseBodySize) {
        var networkCaptureBodies, networkResponseHeaders, headers, _ref, bodyText, warning, result;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    networkCaptureBodies = param.networkCaptureBodies, networkResponseHeaders = param.networkResponseHeaders;
                    if (!captureDetails && responseBodySize !== undefined) return [
                        2,
                        buildSkippedNetworkRequestOrResponse(responseBodySize)
                    ];
                    headers = response ? getAllHeaders(response.headers, networkResponseHeaders) : {};
                    if (!response || !networkCaptureBodies && responseBodySize !== undefined) return [
                        2,
                        buildNetworkRequestOrResponse(headers, responseBodySize, undefined)
                    ];
                    return [
                        4,
                        _parseFetchResponseBody(response)
                    ];
                case 1:
                    _ref = (0, _slicedToArray._).apply(void 0, [
                        _state.sent(),
                        2
                    ]), bodyText = _ref[0], warning = _ref[1];
                    result = getResponseData(bodyText, {
                        networkCaptureBodies: networkCaptureBodies,
                        responseBodySize: responseBodySize,
                        captureDetails: captureDetails,
                        headers: headers
                    });
                    if (warning) return [
                        2,
                        mergeWarning(result, warning)
                    ];
                    return [
                        2,
                        result
                    ];
            }
        });
    }).apply(this, arguments);
}
function getResponseData(bodyText, param) {
    var networkCaptureBodies = param.networkCaptureBodies, responseBodySize = param.responseBodySize, captureDetails = param.captureDetails, headers = param.headers;
    try {
        var size = (bodyText === null || bodyText === void 0 ? void 0 : bodyText.length) && responseBodySize === undefined ? getBodySize(bodyText) : responseBodySize;
        if (!captureDetails) return buildSkippedNetworkRequestOrResponse(size);
        if (networkCaptureBodies) return buildNetworkRequestOrResponse(headers, size, bodyText);
        return buildNetworkRequestOrResponse(headers, size, undefined);
    } catch (error) {
        DEBUG_BUILD && debug.exception(error, 'Failed to serialize response body');
        // fallback
        return buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    }
}
function _parseFetchResponseBody(response) {
    return (0, _asyncToGenerator._)(function() {
        var res, text, error;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    res = _tryCloneResponse(response);
                    if (!res) return [
                        2,
                        [
                            undefined,
                            'BODY_PARSE_ERROR'
                        ]
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        _tryGetResponseText(res)
                    ];
                case 2:
                    text = _state.sent();
                    return [
                        2,
                        [
                            text
                        ]
                    ];
                case 3:
                    error = _state.sent();
                    if ((0, _instanceof._)(error, Error) && error.message.indexOf('Timeout') > -1) {
                        DEBUG_BUILD && debug.warn('Parsing text body from response timed out');
                        return [
                            2,
                            [
                                undefined,
                                'BODY_PARSE_TIMEOUT'
                            ]
                        ];
                    }
                    DEBUG_BUILD && debug.exception(error, 'Failed to get text body from response');
                    return [
                        2,
                        [
                            undefined,
                            'BODY_PARSE_ERROR'
                        ]
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    })();
}
function getAllHeaders(headers, allowedHeaders) {
    var allHeaders = {};
    allowedHeaders.forEach(function(header) {
        if (headers.get(header)) allHeaders[header] = headers.get(header);
    });
    return allHeaders;
}
function getRequestHeaders(fetchArgs, allowedHeaders) {
    if (fetchArgs.length === 1 && typeof fetchArgs[0] !== 'string') return getHeadersFromOptions(fetchArgs[0], allowedHeaders);
    if (fetchArgs.length === 2) return getHeadersFromOptions(fetchArgs[1], allowedHeaders);
    return {};
}
function getHeadersFromOptions(input, allowedHeaders) {
    if (!input) return {};
    var headers = input.headers;
    if (!headers) return {};
    if ((0, _instanceof._)(headers, Headers)) return getAllHeaders(headers, allowedHeaders);
    // We do not support this, as it is not really documented (anymore?)
    if (Array.isArray(headers)) return {};
    return getAllowedHeaders(headers, allowedHeaders);
}
function _tryCloneResponse(response) {
    try {
        // We have to clone this, as the body can only be read once
        return response.clone();
    } catch (error) {
        // this can throw if the response was already consumed before
        DEBUG_BUILD && debug.exception(error, 'Failed to clone response body');
    }
}
/**
 * Get the response body of a fetch request, or timeout after 500ms.
 * Fetch can return a streaming body, that may not resolve (or not for a long time).
 * If that happens, we rather abort after a short time than keep waiting for this.
 */ function _tryGetResponseText(response) {
    return new Promise(function(resolve, reject) {
        var timeout = (0, _browserUtils.setTimeout)(function() {
            return reject(new Error('Timeout while trying to read response body'));
        }, 500);
        _getResponseText(response).then(function(txt) {
            return resolve(txt);
        }, function(reason) {
            return reject(reason);
        }).finally(function() {
            return clearTimeout(timeout);
        });
    });
}
function _getResponseText(response) {
    return (0, _asyncToGenerator._)(function() {
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        response.text()
                    ];
                case 1:
                    // Force this to be a promise, just to be safe
                    // eslint-disable-next-line no-return-await
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    })();
}
/**
 * Capture an XHR breadcrumb to a replay.
 * This adds additional data (where appropriate).
 */ function captureXhrBreadcrumbToReplay(breadcrumb, hint, options) {
    return (0, _asyncToGenerator._)(function() {
        var data, result;
        return (0, _tsGenerator._)(this, function(_state) {
            try {
                data = _prepareXhrData(breadcrumb, hint, options);
                // Create a replay performance entry from this breadcrumb
                result = makeNetworkReplayBreadcrumb('resource.xhr', data);
                addNetworkBreadcrumb(options.replay, result);
            } catch (error) {
                DEBUG_BUILD && debug.exception(error, 'Failed to capture xhr breadcrumb');
            }
            return [
                2
            ];
        });
    })();
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function enrichXhrBreadcrumb(breadcrumb, hint) {
    var xhr = hint.xhr, input = hint.input;
    if (!xhr) return;
    var reqSize = getBodySize(input);
    var resSize = xhr.getResponseHeader('content-length') ? parseContentLengthHeader(xhr.getResponseHeader('content-length')) : _getBodySize(xhr.response, xhr.responseType);
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
function _prepareXhrData(breadcrumb, hint, options) {
    var now = Date.now();
    var _hint_startTimestamp = hint.startTimestamp, startTimestamp = _hint_startTimestamp === void 0 ? now : _hint_startTimestamp, _hint_endTimestamp = hint.endTimestamp, endTimestamp = _hint_endTimestamp === void 0 ? now : _hint_endTimestamp, input = hint.input, xhr = hint.xhr;
    var _breadcrumb_data = breadcrumb.data, url = _breadcrumb_data.url, method = _breadcrumb_data.method, tmp = _breadcrumb_data.status_code, statusCode = tmp === void 0 ? 0 : tmp, requestBodySize = _breadcrumb_data.request_body_size, responseBodySize = _breadcrumb_data.response_body_size;
    if (!url) return null;
    if (!xhr || !urlMatches(url, options.networkDetailAllowUrls) || urlMatches(url, options.networkDetailDenyUrls)) {
        var request = buildSkippedNetworkRequestOrResponse(requestBodySize);
        var response = buildSkippedNetworkRequestOrResponse(responseBodySize);
        return {
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp,
            url: url,
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        };
    }
    // ---- This additional network data below is only captured for URLs defined in `networkDetailAllowUrls` ----
    var xhrInfo = xhr[0, _browserUtils.SENTRY_XHR_DATA_KEY];
    var networkRequestHeaders = xhrInfo ? getAllowedHeaders(xhrInfo.request_headers, options.networkRequestHeaders) : {};
    var networkResponseHeaders = getAllowedHeaders((0, _browserUtils.parseXhrResponseHeaders)(xhr), options.networkResponseHeaders);
    var _ref = (0, _slicedToArray._)(options.networkCaptureBodies ? (0, _browserUtils.getBodyString)(input, debug) : [
        undefined
    ], 2), requestBody = _ref[0], requestWarning = _ref[1];
    var _ref1 = (0, _slicedToArray._)(options.networkCaptureBodies ? _getXhrResponseBody(xhr) : [
        undefined
    ], 2), responseBody = _ref1[0], responseWarning = _ref1[1];
    var request1 = buildNetworkRequestOrResponse(networkRequestHeaders, requestBodySize, requestBody);
    var response1 = buildNetworkRequestOrResponse(networkResponseHeaders, responseBodySize, responseBody);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: requestWarning ? mergeWarning(request1, requestWarning) : request1,
        response: responseWarning ? mergeWarning(response1, responseWarning) : response1
    };
}
function _getXhrResponseBody(xhr) {
    var _debug;
    // We collect errors that happen, but only log them if we can't get any response body
    var errors = [];
    try {
        return [
            xhr.responseText
        ];
    } catch (e) {
        errors.push(e);
    }
    // Try to manually parse the response body, if responseText fails
    try {
        return _parseXhrResponse(xhr.response, xhr.responseType);
    } catch (e) {
        errors.push(e);
    }
    DEBUG_BUILD && (_debug = debug).warn.apply(_debug, [
        'Failed to get xhr response body'
    ].concat((0, _toConsumableArray._)(errors)));
    return [
        undefined
    ];
}
/**
 * Get the string representation of the XHR response.
 * Based on MDN, these are the possible types of the response:
 * string
 * ArrayBuffer
 * Blob
 * Document
 * POJO
 *
 * Exported only for tests.
 */ function _parseXhrResponse(body, responseType) {
    try {
        if (typeof body === 'string') return [
            body
        ];
        if ((0, _instanceof._)(body, Document)) return [
            body.body.outerHTML
        ];
        if (responseType === 'json' && body && (typeof body === "undefined" ? "undefined" : (0, _typeOf._)(body)) === 'object') return [
            JSON.stringify(body)
        ];
        if (!body) return [
            undefined
        ];
    } catch (error) {
        DEBUG_BUILD && debug.exception(error, 'Failed to serialize body', body);
        return [
            undefined,
            'BODY_PARSE_ERROR'
        ];
    }
    DEBUG_BUILD && debug.log('Skipping network body because of body type', body);
    return [
        undefined,
        'UNPARSEABLE_BODY_TYPE'
    ];
}
function _getBodySize(body, responseType) {
    try {
        var bodyStr = responseType === 'json' && body && (typeof body === "undefined" ? "undefined" : (0, _typeOf._)(body)) === 'object' ? JSON.stringify(body) : body;
        return getBodySize(bodyStr);
    } catch (e) {
        return undefined;
    }
}
/**
 * This method does two things:
 * - It enriches the regular XHR/fetch breadcrumbs with request/response size data
 * - It captures the XHR/fetch breadcrumbs to the replay
 *   (enriching it with further data that is _not_ added to the regular breadcrumbs)
 */ function handleNetworkBreadcrumbs(replay) {
    var client = (0, _core.getClient)();
    try {
        var _replay_getOptions = replay.getOptions(), networkDetailAllowUrls = _replay_getOptions.networkDetailAllowUrls, networkDetailDenyUrls = _replay_getOptions.networkDetailDenyUrls, networkCaptureBodies = _replay_getOptions.networkCaptureBodies, networkRequestHeaders = _replay_getOptions.networkRequestHeaders, networkResponseHeaders = _replay_getOptions.networkResponseHeaders;
        var options = {
            replay: replay,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: networkRequestHeaders,
            networkResponseHeaders: networkResponseHeaders
        };
        if (client) client.on('beforeAddBreadcrumb', function(breadcrumb, hint) {
            return beforeAddNetworkBreadcrumb(options, breadcrumb, hint);
        });
    } catch (e) {
    // Do nothing
    }
}
/** just exported for tests */ function beforeAddNetworkBreadcrumb(options, breadcrumb, hint) {
    if (!breadcrumb.data) return;
    try {
        if (_isXhrBreadcrumb(breadcrumb) && _isXhrHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            enrichXhrBreadcrumb(breadcrumb, hint);
            // This call should not reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            captureXhrBreadcrumbToReplay(breadcrumb, hint, options);
        }
        if (_isFetchBreadcrumb(breadcrumb) && _isFetchHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            enrichFetchBreadcrumb(breadcrumb, hint);
            // This call should not reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            captureFetchBreadcrumbToReplay(breadcrumb, hint, options);
        }
    } catch (e) {
        DEBUG_BUILD && debug.exception(e, 'Error when enriching network breadcrumb');
    }
}
function _isXhrBreadcrumb(breadcrumb) {
    return breadcrumb.category === 'xhr';
}
function _isFetchBreadcrumb(breadcrumb) {
    return breadcrumb.category === 'fetch';
}
function _isXhrHint(hint) {
    return hint === null || hint === void 0 ? void 0 : hint.xhr;
}
function _isFetchHint(hint) {
    return hint === null || hint === void 0 ? void 0 : hint.response;
}
/**
 * Add global listeners that cannot be removed.
 */ function addGlobalListeners(replay) {
    // Listeners from core SDK //
    var client = (0, _core.getClient)();
    (0, _browserUtils.addClickKeypressInstrumentationHandler)(handleDomListener(replay));
    (0, _browserUtils.addHistoryInstrumentationHandler)(handleHistorySpanListener(replay));
    handleBreadcrumbs(replay);
    handleNetworkBreadcrumbs(replay);
    // Tag all (non replay) events that get sent to Sentry with the current
    // replay ID so that we can reference them later in the UI
    var eventProcessor = handleGlobalEventListener(replay);
    (0, _core.addEventProcessor)(eventProcessor);
    // If a custom client has no hooks yet, we continue to use the "old" implementation
    if (client) {
        client.on('beforeSendEvent', handleBeforeSendEvent(replay));
        client.on('afterSendEvent', handleAfterSendEvent(replay));
        client.on('createDsc', function(dsc) {
            var replayId = replay.getSessionId();
            // We do not want to set the DSC when in buffer mode, as that means the replay has not been sent (yet)
            if (replayId && replay.isEnabled() && replay.recordingMode === 'session') {
                // Ensure to check that the session is still active - it could have expired in the meanwhile
                var isSessionActive = replay.checkAndHandleExpiredSession();
                if (isSessionActive) dsc.replay_id = replayId;
            }
        });
        client.on('spanStart', function(span) {
            replay.lastActiveSpan = span;
        });
        // We may be missing the initial spanStart due to timing issues,
        // so we capture it on finish again.
        client.on('spanEnd', function(span) {
            replay.lastActiveSpan = span;
        });
        // We want to attach the replay id to the feedback event
        client.on('beforeSendFeedback', function(feedbackEvent, options) {
            return (0, _asyncToGenerator._)(function() {
                var _feedbackEvent_contexts, replayId;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            replayId = replay.getSessionId();
                            if (!((options === null || options === void 0 ? void 0 : options.includeReplay) && replay.isEnabled() && replayId && ((_feedbackEvent_contexts = feedbackEvent.contexts) === null || _feedbackEvent_contexts === void 0 ? void 0 : _feedbackEvent_contexts.feedback))) return [
                                3,
                                3
                            ];
                            if (!(feedbackEvent.contexts.feedback.source === 'api')) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                replay.sendBufferedReplayOrFlush()
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            feedbackEvent.contexts.feedback.replay_id = replayId;
                            _state.label = 3;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            })();
        });
        client.on('openFeedbackWidget', function() {
            return (0, _asyncToGenerator._)(function() {
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                replay.sendBufferedReplayOrFlush()
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            })();
        });
    }
}
/**
 * Create a "span" for the total amount of memory being used by JS objects
 * (including v8 internal objects).
 */ function addMemoryEntry(replay) {
    return (0, _asyncToGenerator._)(function() {
        return (0, _tsGenerator._)(this, function(_state) {
            // window.performance.memory is a non-standard API and doesn't work on all browsers, so we try-catch this
            try {
                return [
                    2,
                    Promise.all(createPerformanceSpans(replay, [
                        // @ts-expect-error memory doesn't exist on type Performance as the API is non-standard (we check that it exists above)
                        createMemoryEntry(WINDOW.performance.memory)
                    ]))
                ];
            } catch (e) {
                // Do nothing
                return [
                    2,
                    []
                ];
            }
            return [
                2
            ];
        });
    })();
}
function createMemoryEntry(memoryEntry) {
    var jsHeapSizeLimit = memoryEntry.jsHeapSizeLimit, totalJSHeapSize = memoryEntry.totalJSHeapSize, usedJSHeapSize = memoryEntry.usedJSHeapSize;
    // we don't want to use `getAbsoluteTime` because it adds the event time to the
    // time origin, so we get the current timestamp instead
    var time = Date.now() / 1000;
    return {
        type: 'memory',
        name: 'memory',
        start: time,
        end: time,
        data: {
            memory: {
                jsHeapSizeLimit: jsHeapSizeLimit,
                totalJSHeapSize: totalJSHeapSize,
                usedJSHeapSize: usedJSHeapSize
            }
        }
    };
}
/**
 * Heavily simplified debounce function based on lodash.debounce.
 *
 * This function takes a callback function (@param fun) and delays its invocation
 * by @param wait milliseconds. Optionally, a maxWait can be specified in @param options,
 * which ensures that the callback is invoked at least once after the specified max. wait time.
 *
 * @param func the function whose invocation is to be debounced
 * @param wait the minimum time until the function is invoked after it was called once
 * @param options the options object, which can contain the `maxWait` property
 *
 * @returns the debounced version of the function, which needs to be called at least once to start the
 *          debouncing process. Subsequent calls will reset the debouncing timer and, in case @paramfunc
 *          was already invoked in the meantime, return @param func's return value.
 *          The debounced function has two additional properties:
 *          - `flush`: Invokes the debounced function immediately and returns its return value
 *          - `cancel`: Cancels the debouncing process and resets the debouncing timer
 */ function debounce(func, wait, options) {
    return (0, _core.debounce)(func, wait, (0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
        // @ts-expect-error - Not quite sure why these types do not match, but this is fine
        setTimeoutImpl: (0, _browserUtils.setTimeout)
    }));
}
var NAVIGATOR = (0, _core.GLOBAL_OBJ).navigator;
/**
 *  Disable sampling mousemove events on iOS browsers as this can cause blocking the main thread
 *  https://github.com/getsentry/sentry-javascript/issues/14534
 */ function getRecordingSamplingOptions() {
    var _NAVIGATOR_userAgent, _NAVIGATOR_userAgent1;
    if (/iPhone|iPad|iPod/i.test((_NAVIGATOR_userAgent = NAVIGATOR === null || NAVIGATOR === void 0 ? void 0 : NAVIGATOR.userAgent) !== null && _NAVIGATOR_userAgent !== void 0 ? _NAVIGATOR_userAgent : '') || /Macintosh/i.test((_NAVIGATOR_userAgent1 = NAVIGATOR === null || NAVIGATOR === void 0 ? void 0 : NAVIGATOR.userAgent) !== null && _NAVIGATOR_userAgent1 !== void 0 ? _NAVIGATOR_userAgent1 : '') && (NAVIGATOR === null || NAVIGATOR === void 0 ? void 0 : NAVIGATOR.maxTouchPoints) && (NAVIGATOR === null || NAVIGATOR === void 0 ? void 0 : NAVIGATOR.maxTouchPoints) > 1) return {
        sampling: {
            mousemove: false
        }
    };
    return {};
}
/**
 * Handler for recording events.
 *
 * Adds to event buffer, and has varying flushing behaviors if the event was a checkout.
 */ function getHandleRecordingEmit(replay) {
    var hadFirstEvent = false;
    return function(event, _isCheckout) {
        // If this is false, it means session is expired, create and a new session and wait for checkout
        if (!replay.checkAndHandleExpiredSession()) {
            DEBUG_BUILD && debug.warn('Received replay event after session expired.');
            return;
        }
        // `_isCheckout` is only set when the checkout is due to `checkoutEveryNms`
        // We also want to treat the first event as a checkout, so we handle this specifically here
        var isCheckout = _isCheckout || !hadFirstEvent;
        hadFirstEvent = true;
        if (replay.clickDetector) updateClickDetectorForRecordingEvent(replay.clickDetector, event);
        // The handler returns `true` if we do not want to trigger debounced flush, `false` if we want to debounce flush.
        replay.addUpdate(function() {
            // The session is always started immediately on pageload/init, but for
            // error-only replays, it should reflect the most recent checkout
            // when an error occurs. Clear any state that happens before this current
            // checkout. This needs to happen before `addEvent()` which updates state
            // dependent on this reset.
            if (replay.recordingMode === 'buffer' && isCheckout) replay.setInitialState();
            // If the event is not added (e.g. due to being paused, disabled, or out of the max replay duration),
            // Skip all further steps
            if (!addEventSync(replay, event, isCheckout)) // Return true to skip scheduling a debounced flush
            return true;
            // Different behavior for full snapshots (type=2), ignore other event types
            // See https://github.com/rrweb-io/rrweb/blob/d8f9290ca496712aa1e7d472549480c4e7876594/packages/rrweb/src/types.ts#L16
            if (!isCheckout) return false;
            var session = replay.session;
            // Additionally, create a meta event that will capture certain SDK settings.
            // In order to handle buffer mode, this needs to either be done when we
            // receive checkout events or at flush time. We have an experimental mode
            // to perform multiple checkouts a session (the idea is to improve
            // seeking during playback), so also only include if segmentId is 0
            // (handled in `addSettingsEvent`).
            //
            // `isCheckout` is always true, but want to be explicit that it should
            // only be added for checkouts
            addSettingsEvent(replay, isCheckout);
            // When in buffer mode, make sure we adjust the session started date to the current earliest event of the buffer
            // this should usually be the timestamp of the checkout event, but to be safe...
            if (replay.recordingMode === 'buffer' && session && replay.eventBuffer && !session.dirty) {
                var earliestEvent = replay.eventBuffer.getEarliestTimestamp();
                if (earliestEvent) {
                    DEBUG_BUILD && debug.log("Updating session start time to earliest event in buffer to ".concat(new Date(earliestEvent)));
                    session.started = earliestEvent;
                    if (replay.getOptions().stickySession) saveSession(session);
                }
            }
            // If there is a previousSessionId after a full snapshot occurs, then
            // the replay session was started due to session expiration. The new session
            // is started before triggering a new checkout and contains the id
            // of the previous session. Do not immediately flush in this case
            // to avoid capturing only the checkout and instead the replay will
            // be captured if they perform any follow-up actions.
            if (session === null || session === void 0 ? void 0 : session.previousSessionId) return true;
            if (replay.recordingMode === 'session') // If the full snapshot is due to an initial load, we will not have
            // a previous session ID. In this case, we want to buffer events
            // for a set amount of time before flushing. This can help avoid
            // capturing replays of users that immediately close the window.
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            replay.flush();
            return true;
        });
    };
}
/**
 * Exported for tests
 */ function createOptionsEvent(replay) {
    var options = replay.getOptions();
    return {
        type: EventType.Custom,
        timestamp: Date.now(),
        data: {
            tag: 'options',
            payload: {
                shouldRecordCanvas: replay.isRecordingCanvas(),
                sessionSampleRate: options.sessionSampleRate,
                errorSampleRate: options.errorSampleRate,
                useCompressionOption: options.useCompression,
                blockAllMedia: options.blockAllMedia,
                maskAllText: options.maskAllText,
                maskAllInputs: options.maskAllInputs,
                useCompression: replay.eventBuffer ? replay.eventBuffer.type === 'worker' : false,
                networkDetailHasUrls: options.networkDetailAllowUrls.length > 0,
                networkCaptureBodies: options.networkCaptureBodies,
                networkRequestHasHeaders: options.networkRequestHeaders.length > 0,
                networkResponseHasHeaders: options.networkResponseHeaders.length > 0
            }
        }
    };
}
/**
 * Add a "meta" event that contains a simplified view on current configuration
 * options. This should only be included on the first segment of a recording.
 */ function addSettingsEvent(replay, isCheckout) {
    // Only need to add this event when sending the first segment
    if (!isCheckout || !replay.session || replay.session.segmentId !== 0) return;
    addEventSync(replay, createOptionsEvent(replay), false);
}
/**
 * Vendored in from @sentry-internal/rrweb.
 *
 * This is a copy of the function from rrweb, it is not nicely exported there.
 */ function closestElementOfNode(node) {
    if (!node) return null;
    // Catch access to node properties to avoid Firefox "permission denied" errors
    try {
        var el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
        return el;
    } catch (e) {
        return null;
    }
}
/**
 * Create a replay envelope ready to be sent.
 * This includes both the replay event, as well as the recording data.
 */ function createReplayEnvelope(replayEvent, recordingData, dsn, tunnel) {
    return (0, _core.createEnvelope)((0, _core.createEventEnvelopeHeaders)(replayEvent, (0, _core.getSdkMetadataForEnvelopeHeader)(replayEvent), tunnel, dsn), [
        [
            {
                type: 'replay_event'
            },
            replayEvent
        ],
        [
            {
                type: 'replay_recording',
                // If string then we need to encode to UTF8, otherwise will have
                // wrong size. TextEncoder has similar browser support to
                // MutationObserver, although it does not accept IE11.
                length: typeof recordingData === 'string' ? new TextEncoder().encode(recordingData).length : recordingData.length
            },
            recordingData
        ]
    ]);
}
/**
 * Prepare the recording data ready to be sent.
 */ function prepareRecordingData(param) {
    var recordingData = param.recordingData, headers = param.headers;
    var payloadWithSequence;
    // XXX: newline is needed to separate sequence id from events
    var replayHeaders = "".concat(JSON.stringify(headers), "\n");
    if (typeof recordingData === 'string') payloadWithSequence = "".concat(replayHeaders).concat(recordingData);
    else {
        var enc = new TextEncoder();
        // XXX: newline is needed to separate sequence id from events
        var sequence = enc.encode(replayHeaders);
        // Merge the two Uint8Arrays
        payloadWithSequence = new Uint8Array(sequence.length + recordingData.length);
        payloadWithSequence.set(sequence);
        payloadWithSequence.set(recordingData, sequence.length);
    }
    return payloadWithSequence;
}
/**
 * Prepare a replay event & enrich it with the SDK metadata.
 */ function prepareReplayEvent(_0) {
    return (0, _asyncToGenerator._)(function(param) {
        var client, scope, event_id, event, integrations, eventHint, preparedEvent, metadata, _ref, name, version, settings;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    client = param.client, scope = param.scope, event_id = param.replayId, event = param.event;
                    integrations = (0, _typeOf._)(client['_integrations']) === 'object' && client['_integrations'] !== null && !Array.isArray(client['_integrations']) ? Object.keys(client['_integrations']) : undefined;
                    eventHint = {
                        event_id: event_id,
                        integrations: integrations
                    };
                    client.emit('preprocessEvent', event, eventHint);
                    return [
                        4,
                        (0, _core.prepareEvent)(client.getOptions(), event, eventHint, scope, client, (0, _core.getIsolationScope)())
                    ];
                case 1:
                    preparedEvent = _state.sent();
                    // If e.g. a global event processor returned null
                    if (!preparedEvent) return [
                        2,
                        null
                    ];
                    client.emit('postprocessEvent', preparedEvent, eventHint);
                    // This normally happens in browser client "_prepareEvent"
                    // but since we do not use this private method from the client, but rather the plain import
                    // we need to do this manually.
                    preparedEvent.platform = preparedEvent.platform || 'javascript';
                    // extract the SDK name because `client._prepareEvent` doesn't add it to the event
                    metadata = client.getSdkMetadata();
                    _ref = (metadata === null || metadata === void 0 ? void 0 : metadata.sdk) || {}, name = _ref.name, version = _ref.version, settings = _ref.settings;
                    preparedEvent.sdk = (0, _objectSpreadProps._)((0, _objectSpread._)({}, preparedEvent.sdk), {
                        name: name || 'sentry.javascript.unknown',
                        version: version || '0.0.0',
                        settings: settings
                    });
                    return [
                        2,
                        preparedEvent
                    ];
            }
        });
    }).apply(this, arguments);
}
/**
 * Send replay attachment using `fetch()`
 */ function sendReplayRequest(_0) {
    return (0, _asyncToGenerator._)(function(param) {
        var recordingData, replayId, segment_id, eventContext, timestamp, session, preparedRecordingData, urls, errorIds, traceIds, initialTimestamp, client, scope, transport, dsn, baseEvent, replayEvent, envelope, response, err, error, rateLimits;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    recordingData = param.recordingData, replayId = param.replayId, segment_id = param.segmentId, eventContext = param.eventContext, timestamp = param.timestamp, session = param.session;
                    preparedRecordingData = prepareRecordingData({
                        recordingData: recordingData,
                        headers: {
                            segment_id: segment_id
                        }
                    });
                    urls = eventContext.urls, errorIds = eventContext.errorIds, traceIds = eventContext.traceIds, initialTimestamp = eventContext.initialTimestamp;
                    client = (0, _core.getClient)();
                    scope = (0, _core.getCurrentScope)();
                    transport = client === null || client === void 0 ? void 0 : client.getTransport();
                    dsn = client === null || client === void 0 ? void 0 : client.getDsn();
                    if (!client || !transport || !dsn || !session.sampled) return [
                        2,
                        Promise.resolve({})
                    ];
                    baseEvent = {
                        type: REPLAY_EVENT_NAME,
                        replay_start_timestamp: initialTimestamp / 1000,
                        timestamp: timestamp / 1000,
                        error_ids: errorIds,
                        trace_ids: traceIds,
                        urls: urls,
                        replay_id: replayId,
                        segment_id: segment_id,
                        replay_type: session.sampled
                    };
                    return [
                        4,
                        prepareReplayEvent({
                            scope: scope,
                            client: client,
                            replayId: replayId,
                            event: baseEvent
                        })
                    ];
                case 1:
                    replayEvent = _state.sent();
                    if (!replayEvent) {
                        // Taken from baseclient's `_processEvent` method, where this is handled for errors/transactions
                        client.recordDroppedEvent('event_processor', 'replay');
                        DEBUG_BUILD && debug.log('An event processor returned `null`, will not send event.');
                        return [
                            2,
                            Promise.resolve({})
                        ];
                    }
                    /*
  For reference, the fully built event looks something like this:
  {
      "type": "replay_event",
      "timestamp": 1670837008.634,
      "error_ids": [
          "errorId"
      ],
      "trace_ids": [
          "traceId"
      ],
      "urls": [
          "https://example.com"
      ],
      "replay_id": "eventId",
      "segment_id": 3,
      "replay_type": "error",
      "platform": "javascript",
      "event_id": "eventId",
      "environment": "production",
      "sdk": {
          "integrations": [
              "BrowserTracing",
              "Replay"
          ],
          "name": "sentry.javascript.browser",
          "version": "7.25.0"
      },
      "sdkProcessingMetadata": {},
      "contexts": {
      },
  }
  */ // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
                    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
                    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
                    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
                    delete replayEvent.sdkProcessingMetadata;
                    envelope = createReplayEnvelope(replayEvent, preparedRecordingData, dsn, client.getOptions().tunnel);
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        transport.send(envelope)
                    ];
                case 3:
                    response = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 4:
                    err = _state.sent();
                    error = new Error(UNABLE_TO_SEND_REPLAY);
                    try {
                        // In case browsers don't allow this property to be writable
                        // @ts-expect-error This needs lib es2022 and newer
                        error.cause = err;
                    } catch (e) {
                    // nothing to do
                    }
                    throw error;
                case 5:
                    // If the status code is invalid, we want to immediately stop & not retry
                    if (typeof response.statusCode === 'number' && (response.statusCode < 200 || response.statusCode >= 300)) throw new TransportStatusCodeError(response.statusCode);
                    rateLimits = (0, _core.updateRateLimits)({}, response);
                    if ((0, _core.isRateLimited)(rateLimits, 'replay')) throw new RateLimitError(rateLimits);
                    return [
                        2,
                        response
                    ];
            }
        });
    }).apply(this, arguments);
}
/**
 * This error indicates that the transport returned an invalid status code.
 */ var TransportStatusCodeError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, _inherits._)(TransportStatusCodeError, Error1);
    function TransportStatusCodeError(statusCode) {
        (0, _classCallCheck._)(this, TransportStatusCodeError);
        return (0, _callSuper._)(this, TransportStatusCodeError, [
            "Transport returned status code ".concat(statusCode)
        ]);
    }
    return TransportStatusCodeError;
}((0, _wrapNativeSuper._)(Error));
/**
 * This error indicates that we hit a rate limit API error.
 */ var RateLimitError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, _inherits._)(RateLimitError, Error1);
    function RateLimitError(rateLimits) {
        (0, _classCallCheck._)(this, RateLimitError);
        var _this;
        _this = (0, _callSuper._)(this, RateLimitError, [
            'Rate limit hit'
        ]);
        _this.rateLimits = rateLimits;
        return _this;
    }
    return RateLimitError;
}((0, _wrapNativeSuper._)(Error));
/**
 * Finalize and send the current replay event to Sentry
 */ function sendReplay(_0) {
    return (0, _asyncToGenerator._)(function(replayData) {
        var retryConfig, recordingData, onError, err, error;
        var _arguments = arguments;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    retryConfig = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {
                        count: 0,
                        interval: RETRY_BASE_INTERVAL
                    };
                    recordingData = replayData.recordingData, onError = replayData.onError;
                    // short circuit if there's no events to upload (this shouldn't happen as _runFlush makes this check)
                    if (!recordingData.length) return [
                        2
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        sendReplayRequest(replayData)
                    ];
                case 2:
                    _state.sent();
                    return [
                        2,
                        true
                    ];
                case 3:
                    err = _state.sent();
                    if ((0, _instanceof._)(err, TransportStatusCodeError) || (0, _instanceof._)(err, RateLimitError)) throw err;
                    // Capture error for every failed replay
                    (0, _core.setContext)('Replays', {
                        _retryCount: retryConfig.count
                    });
                    if (onError) onError(err);
                    // If an error happened here, it's likely that uploading the attachment
                    // failed, we'll can retry with the same events payload
                    if (retryConfig.count >= RETRY_MAX_COUNT) {
                        error = new Error("".concat(UNABLE_TO_SEND_REPLAY, " - max retries exceeded"));
                        try {
                            // In case browsers don't allow this property to be writable
                            // @ts-expect-error This needs lib es2022 and newer
                            error.cause = err;
                        } catch (e) {
                        // nothing to do
                        }
                        throw error;
                    }
                    // will retry in intervals of 5, 10, 30
                    retryConfig.interval *= ++retryConfig.count;
                    return [
                        2,
                        new Promise(function(resolve, reject) {
                            (0, _browserUtils.setTimeout)(function() {
                                return (0, _asyncToGenerator._)(function() {
                                    var err;
                                    return (0, _tsGenerator._)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                _state.trys.push([
                                                    0,
                                                    2,
                                                    ,
                                                    3
                                                ]);
                                                return [
                                                    4,
                                                    sendReplay(replayData, retryConfig)
                                                ];
                                            case 1:
                                                _state.sent();
                                                resolve(true);
                                                return [
                                                    3,
                                                    3
                                                ];
                                            case 2:
                                                err = _state.sent();
                                                reject(err);
                                                return [
                                                    3,
                                                    3
                                                ];
                                            case 3:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                })();
                            }, retryConfig.interval);
                        })
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
var THROTTLED = '__THROTTLED';
var SKIPPED = '__SKIPPED';
/**
 * Create a throttled function off a given function.
 * When calling the throttled function, it will call the original function only
 * if it hasn't been called more than `maxCount` times in the last `durationSeconds`.
 *
 * Returns `THROTTLED` if throttled for the first time, after that `SKIPPED`,
 * or else the return value of the original function.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function throttle(fn, maxCount, durationSeconds) {
    var counter = new Map();
    var _cleanup = function(now) {
        var threshold = now - durationSeconds;
        counter.forEach(function(_value, key) {
            if (key < threshold) counter.delete(key);
        });
    };
    var _getTotalCount = function() {
        return (0, _toConsumableArray._)(counter.values()).reduce(function(a, b) {
            return a + b;
        }, 0);
    };
    var isThrottled = false;
    return function() {
        for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++){
            rest[_key] = arguments[_key];
        }
        // Date in second-precision, which we use as basis for the throttling
        var now = Math.floor(Date.now() / 1000);
        // First, make sure to delete any old entries
        _cleanup(now);
        // If already over limit, do nothing
        if (_getTotalCount() >= maxCount) {
            var wasThrottled = isThrottled;
            isThrottled = true;
            return wasThrottled ? SKIPPED : THROTTLED;
        }
        isThrottled = false;
        var count = counter.get(now) || 0;
        counter.set(now, count + 1);
        return fn.apply(void 0, (0, _toConsumableArray._)(rest));
    };
}
/**
 * The main replay container class, which holds all the state and methods for recording and sending replays.
 */ var ReplayContainer = /*#__PURE__*/ function() {
    "use strict";
    function ReplayContainer(param) {
        var _this = this;
        var options = param.options, recordingOptions = param.recordingOptions;
        (0, _classCallCheck._)(this, ReplayContainer);
        this.eventBuffer = null;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        this.recordingMode = 'session';
        this.timeouts = {
            sessionIdlePause: SESSION_IDLE_PAUSE_DURATION,
            sessionIdleExpire: SESSION_IDLE_EXPIRE_DURATION
        };
        this._lastActivity = Date.now();
        this._isEnabled = false;
        this._isPaused = false;
        this._requiresManualStart = false;
        this._hasInitializedCoreListeners = false;
        this._context = {
            errorIds: new Set(),
            traceIds: new Set(),
            urls: [],
            initialTimestamp: Date.now(),
            initialUrl: ''
        };
        this._recordingOptions = recordingOptions;
        this._options = options;
        this._debouncedFlush = debounce(function() {
            return _this._flush();
        }, this._options.flushMinDelay, {
            maxWait: this._options.flushMaxDelay
        });
        this._throttledAddEvent = throttle(function(event, isCheckout) {
            return addEvent(_this, event, isCheckout);
        }, // Max 300 events...
        300, // ... per 5s
        5);
        var _this_getOptions = this.getOptions(), slowClickTimeout = _this_getOptions.slowClickTimeout, slowClickIgnoreSelectors = _this_getOptions.slowClickIgnoreSelectors;
        var slowClickConfig = slowClickTimeout ? {
            threshold: Math.min(SLOW_CLICK_THRESHOLD, slowClickTimeout),
            timeout: slowClickTimeout,
            scrollTimeout: SLOW_CLICK_SCROLL_TIMEOUT,
            ignoreSelector: slowClickIgnoreSelectors ? slowClickIgnoreSelectors.join(',') : ''
        } : undefined;
        if (slowClickConfig) this.clickDetector = new ClickDetector(this, slowClickConfig);
        // Configure replay debug logger w/ experimental options
        if (DEBUG_BUILD) {
            var experiments = options._experiments;
            debug.setConfig({
                captureExceptions: !!experiments.captureExceptions,
                traceInternals: !!experiments.traceInternals
            });
        }
        // We set these handler properties as class properties, to make binding/unbinding them easier
        this._handleVisibilityChange = function() {
            if (WINDOW.document.visibilityState === 'visible') _this._doChangeToForegroundTasks();
            else _this._doChangeToBackgroundTasks();
        };
        /**
     * Handle when page is blurred
     */ this._handleWindowBlur = function() {
            var breadcrumb = createBreadcrumb({
                category: 'ui.blur'
            });
            // Do not count blur as a user action -- it's part of the process of them
            // leaving the page
            _this._doChangeToBackgroundTasks(breadcrumb);
        };
        this._handleWindowFocus = function() {
            var breadcrumb = createBreadcrumb({
                category: 'ui.focus'
            });
            // Do not count focus as a user action -- instead wait until they focus and
            // interactive with page
            _this._doChangeToForegroundTasks(breadcrumb);
        };
        /** Ensure page remains active when a key is pressed. */ this._handleKeyboardEvent = function(event) {
            handleKeyboardEvent(_this, event);
        };
    }
    (0, _createClass._)(ReplayContainer, [
        {
            /** Get the event context. */ key: "getContext",
            value: function getContext() {
                return this._context;
            }
        },
        {
            /** If recording is currently enabled. */ key: "isEnabled",
            value: function isEnabled() {
                return this._isEnabled;
            }
        },
        {
            /** If recording is currently paused. */ key: "isPaused",
            value: function isPaused() {
                return this._isPaused;
            }
        },
        {
            /**
   * Determine if canvas recording is enabled
   */ key: "isRecordingCanvas",
            value: function isRecordingCanvas() {
                return Boolean(this._canvas);
            }
        },
        {
            /** Get the replay integration options. */ key: "getOptions",
            value: function getOptions() {
                return this._options;
            }
        },
        {
            /** A wrapper to conditionally capture exceptions. */ key: "handleException",
            value: function handleException(error) {
                DEBUG_BUILD && debug.exception(error);
                if (this._options.onError) this._options.onError(error);
            }
        },
        {
            /**
   * Initializes the plugin based on sampling configuration. Should not be
   * called outside of constructor.
   */ key: "initializeSampling",
            value: function initializeSampling(previousSessionId) {
                var _this__options = this._options, errorSampleRate = _this__options.errorSampleRate, sessionSampleRate = _this__options.sessionSampleRate;
                // If neither sample rate is > 0, then do nothing - user will need to call one of
                // `start()` or `startBuffering` themselves.
                var requiresManualStart = errorSampleRate <= 0 && sessionSampleRate <= 0;
                this._requiresManualStart = requiresManualStart;
                if (requiresManualStart) return;
                // Otherwise if there is _any_ sample rate set, try to load an existing
                // session, or create a new one.
                this._initializeSessionForSampling(previousSessionId);
                if (!this.session) {
                    // This should not happen, something wrong has occurred
                    DEBUG_BUILD && debug.exception(new Error('Unable to initialize and create session'));
                    return;
                }
                if (this.session.sampled === false) // This should only occur if `errorSampleRate` is 0 and was unsampled for
                // session-based replay. In this case there is nothing to do.
                return;
                // If segmentId > 0, it means we've previously already captured this session
                // In this case, we still want to continue in `session` recording mode
                this.recordingMode = this.session.sampled === 'buffer' && this.session.segmentId === 0 ? 'buffer' : 'session';
                DEBUG_BUILD && debug.infoTick("Starting replay in ".concat(this.recordingMode, " mode"));
                this._initializeRecording();
            }
        },
        {
            /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will log a message if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * _performanceObserver, Recording, Sentry SDK, etc)
   */ key: "start",
            value: function start() {
                if (this._isEnabled && this.recordingMode === 'session') {
                    DEBUG_BUILD && debug.log('Recording is already in progress');
                    return;
                }
                if (this._isEnabled && this.recordingMode === 'buffer') {
                    DEBUG_BUILD && debug.log('Buffering is in progress, call `flush()` to save the replay');
                    return;
                }
                DEBUG_BUILD && debug.infoTick('Starting replay in session mode');
                // Required as user activity is initially set in
                // constructor, so if `start()` is called after
                // session idle expiration, a replay will not be
                // created due to an idle timeout.
                this._updateUserActivity();
                var session = loadOrCreateSession({
                    maxReplayDuration: this._options.maxReplayDuration,
                    sessionIdleExpire: this.timeouts.sessionIdleExpire
                }, {
                    stickySession: this._options.stickySession,
                    // This is intentional: create a new session-based replay when calling `start()`
                    sessionSampleRate: 1,
                    allowBuffering: false
                });
                this.session = session;
                this.recordingMode = 'session';
                this._initializeRecording();
            }
        },
        {
            /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, an error occurs.
   */ key: "startBuffering",
            value: function startBuffering() {
                if (this._isEnabled) {
                    DEBUG_BUILD && debug.log('Buffering is in progress, call `flush()` to save the replay');
                    return;
                }
                DEBUG_BUILD && debug.infoTick('Starting replay in buffer mode');
                var session = loadOrCreateSession({
                    sessionIdleExpire: this.timeouts.sessionIdleExpire,
                    maxReplayDuration: this._options.maxReplayDuration
                }, {
                    stickySession: this._options.stickySession,
                    sessionSampleRate: 0,
                    allowBuffering: true
                });
                this.session = session;
                this.recordingMode = 'buffer';
                this._initializeRecording();
            }
        },
        {
            /**
   * Start recording.
   *
   * Note that this will cause a new DOM checkout
   */ key: "startRecording",
            value: function startRecording() {
                try {
                    var canvasOptions = this._canvas;
                    this._stopRecording = record((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, this._recordingOptions, this.recordingMode === 'buffer' ? {
                        checkoutEveryNms: BUFFER_CHECKOUT_TIME
                    } : // This is to improve playback seeking as there could potentially be
                    // less mutations to process in the worse cases.
                    //
                    // checkout by "N" events is probably ideal, but means we have less
                    // control about the number of checkouts we make (which generally
                    // increases replay size)
                    this._options._experiments.continuousCheckout && {
                        // Minimum checkout time is 6 minutes
                        checkoutEveryNms: Math.max(360000, this._options._experiments.continuousCheckout)
                    }), {
                        emit: getHandleRecordingEmit(this)
                    }), getRecordingSamplingOptions()), {
                        onMutation: this._onMutationHandler.bind(this)
                    }), canvasOptions ? {
                        recordCanvas: canvasOptions.recordCanvas,
                        getCanvasManager: canvasOptions.getCanvasManager,
                        sampling: canvasOptions.sampling,
                        dataURLOptions: canvasOptions.dataURLOptions
                    } : {}));
                } catch (err) {
                    this.handleException(err);
                }
            }
        },
        {
            /**
   * Stops the recording, if it was running.
   *
   * Returns true if it was previously stopped, or is now stopped,
   * otherwise false.
   */ key: "stopRecording",
            value: function stopRecording() {
                try {
                    if (this._stopRecording) {
                        this._stopRecording();
                        this._stopRecording = undefined;
                    }
                    return true;
                } catch (err) {
                    this.handleException(err);
                    return false;
                }
            }
        },
        {
            key: "stop",
            value: /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ function stop() {
                return (0, _asyncToGenerator._)(function() {
                    var _ref, _ref_forceFlush, forceFlush, reason, // After flush, destroy event buffer
                    _this_eventBuffer, err;
                    var _arguments = arguments;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _ref = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, _ref_forceFlush = _ref.forceFlush, forceFlush = _ref_forceFlush === void 0 ? false : _ref_forceFlush, reason = _ref.reason;
                                if (!this._isEnabled) return [
                                    2
                                ];
                                // We can't move `_isEnabled` after awaiting a flush, otherwise we can
                                // enter into an infinite loop when `stop()` is called while flushing.
                                this._isEnabled = false;
                                // Make sure to reset `recordingMode` to `buffer` to avoid any additional
                                // breadcrumbs to trigger a flush (e.g. in `addUpdate()`)
                                this.recordingMode = 'buffer';
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    4,
                                    ,
                                    5
                                ]);
                                DEBUG_BUILD && debug.log("Stopping Replay".concat(reason ? " triggered by ".concat(reason) : ''));
                                resetReplayIdOnDynamicSamplingContext();
                                this._removeListeners();
                                this.stopRecording();
                                this._debouncedFlush.cancel();
                                if (!forceFlush) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    this._flush({
                                        force: true
                                    })
                                ];
                            case 2:
                                _state.sent();
                                _state.label = 3;
                            case 3:
                                (_this_eventBuffer = this.eventBuffer) === null || _this_eventBuffer === void 0 ? void 0 : _this_eventBuffer.destroy();
                                this.eventBuffer = null;
                                // Clear session from session storage, note this means if a new session
                                // is started after, it will not have `previousSessionId`
                                clearSession(this);
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                err = _state.sent();
                                this.handleException(err);
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        },
        {
            /**
   * Pause some replay functionality. See comments for `_isPaused`.
   * This differs from stop as this only stops DOM recording, it is
   * not as thorough of a shutdown as `stop()`.
   */ key: "pause",
            value: function pause() {
                if (this._isPaused) return;
                this._isPaused = true;
                this.stopRecording();
                DEBUG_BUILD && debug.log('Pausing replay');
            }
        },
        {
            /**
   * Resumes recording, see notes for `pause().
   *
   * Note that calling `startRecording()` here will cause a
   * new DOM checkout.`
   */ key: "resume",
            value: function resume() {
                if (!this._isPaused || !this._checkSession()) return;
                this._isPaused = false;
                this.startRecording();
                DEBUG_BUILD && debug.log('Resuming replay');
            }
        },
        {
            key: "sendBufferedReplayOrFlush",
            value: /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ function sendBufferedReplayOrFlush() {
                return (0, _asyncToGenerator._)(function() {
                    var _ref, _ref_continueRecording, continueRecording, activityTime, hasStoppedRecording;
                    var _arguments = arguments;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _ref = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, _ref_continueRecording = _ref.continueRecording, continueRecording = _ref_continueRecording === void 0 ? true : _ref_continueRecording;
                                if (this.recordingMode === 'session') return [
                                    2,
                                    this.flushImmediate()
                                ];
                                activityTime = Date.now();
                                DEBUG_BUILD && debug.log('Converting buffer to session');
                                // Allow flush to complete before resuming as a session recording, otherwise
                                // the checkout from `startRecording` may be included in the payload.
                                // Prefer to keep the error replay as a separate (and smaller) segment
                                // than the session replay.
                                return [
                                    4,
                                    this.flushImmediate()
                                ];
                            case 1:
                                _state.sent();
                                hasStoppedRecording = this.stopRecording();
                                if (!continueRecording || !hasStoppedRecording) return [
                                    2
                                ];
                                // To avoid race conditions where this is called multiple times, we check here again that we are still buffering
                                if (this.recordingMode === 'session') return [
                                    2
                                ];
                                // Re-start recording in session-mode
                                this.recordingMode = 'session';
                                // Once this session ends, we do not want to refresh it
                                if (this.session) {
                                    this.session.dirty = false;
                                    this._updateUserActivity(activityTime);
                                    this._updateSessionActivity(activityTime);
                                    this._maybeSaveSession();
                                }
                                this.startRecording();
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        },
        {
            /**
   * We want to batch uploads of replay events. Save events only if
   * `<flushMinDelay>` milliseconds have elapsed since the last event
   * *OR* if `<flushMaxDelay>` milliseconds have elapsed.
   *
   * Accepts a callback to perform side-effects and returns true to stop batch
   * processing and hand back control to caller.
   */ key: "addUpdate",
            value: function addUpdate(cb) {
                // We need to always run `cb` (e.g. in the case of `this.recordingMode == 'buffer'`)
                var cbResult = cb();
                // If this option is turned on then we will only want to call `flush`
                // explicitly
                if (this.recordingMode === 'buffer' || !this._isEnabled) return;
                // If callback is true, we do not want to continue with flushing -- the
                // caller will need to handle it.
                if (cbResult === true) return;
                // addUpdate is called quite frequently - use _debouncedFlush so that it
                // respects the flush delays and does not flush immediately
                this._debouncedFlush();
            }
        },
        {
            /**
   * Updates the user activity timestamp and resumes recording. This should be
   * called in an event handler for a user action that we consider as the user
   * being "active" (e.g. a mouse click).
   */ key: "triggerUserActivity",
            value: function triggerUserActivity() {
                this._updateUserActivity();
                // This case means that recording was once stopped due to inactivity.
                // Ensure that recording is resumed.
                if (!this._stopRecording) {
                    // Create a new session, otherwise when the user action is flushed, it
                    // will get rejected due to an expired session.
                    if (!this._checkSession()) return;
                    // Note: This will cause a new DOM checkout
                    this.resume();
                    return;
                }
                // Otherwise... recording was never suspended, continue as normalish
                this.checkAndHandleExpiredSession();
                this._updateSessionActivity();
            }
        },
        {
            /**
   * Updates the user activity timestamp *without* resuming
   * recording. Some user events (e.g. keydown) can be create
   * low-value replays that only contain the keypress as a
   * breadcrumb. Instead this would require other events to
   * create a new replay after a session has expired.
   */ key: "updateUserActivity",
            value: function updateUserActivity() {
                this._updateUserActivity();
                this._updateSessionActivity();
            }
        },
        {
            /**
   * Only flush if `this.recordingMode === 'session'`
   */ key: "conditionalFlush",
            value: function conditionalFlush() {
                if (this.recordingMode === 'buffer') return Promise.resolve();
                return this.flushImmediate();
            }
        },
        {
            /**
   * Flush using debounce flush
   */ key: "flush",
            value: function flush() {
                return this._debouncedFlush();
            }
        },
        {
            /**
   * Always flush via `_debouncedFlush` so that we do not have flushes triggered
   * from calling both `flush` and `_debouncedFlush`. Otherwise, there could be
   * cases of multiple flushes happening closely together.
   */ key: "flushImmediate",
            value: function flushImmediate() {
                this._debouncedFlush();
                // `.flush` is provided by the debounced function, analogously to lodash.debounce
                return this._debouncedFlush.flush();
            }
        },
        {
            /**
   * Cancels queued up flushes.
   */ key: "cancelFlush",
            value: function cancelFlush() {
                this._debouncedFlush.cancel();
            }
        },
        {
            /** Get the current session (=replay) ID
   *
   * @param onlyIfSampled - If true, will only return the session ID if the session is sampled.
   */ key: "getSessionId",
            value: function getSessionId(onlyIfSampled) {
                var _this_session, _this_session1;
                if (onlyIfSampled && ((_this_session = this.session) === null || _this_session === void 0 ? void 0 : _this_session.sampled) === false) return undefined;
                return (_this_session1 = this.session) === null || _this_session1 === void 0 ? void 0 : _this_session1.id;
            }
        },
        {
            /**
   * Checks if recording should be stopped due to user inactivity. Otherwise
   * check if session is expired and create a new session if so. Triggers a new
   * full snapshot on new session.
   *
   * Returns true if session is not expired, false otherwise.
   * @hidden
   */ key: "checkAndHandleExpiredSession",
            value: function checkAndHandleExpiredSession() {
                // Prevent starting a new session if the last user activity is older than
                // SESSION_IDLE_PAUSE_DURATION. Otherwise non-user activity can trigger a new
                // session+recording. This creates noisy replays that do not have much
                // content in them.
                if (this._lastActivity && isExpired(this._lastActivity, this.timeouts.sessionIdlePause) && this.session && this.session.sampled === 'session') {
                    // Pause recording only for session-based replays. Otherwise, resuming
                    // will create a new replay and will conflict with users who only choose
                    // to record error-based replays only. (e.g. the resumed replay will not
                    // contain a reference to an error)
                    this.pause();
                    return;
                }
                // --- There is recent user activity --- //
                // This will create a new session if expired, based on expiry length
                if (!this._checkSession()) // Check session handles the refreshing itself
                return false;
                return true;
            }
        },
        {
            /**
   * Capture some initial state that can change throughout the lifespan of the
   * replay. This is required because otherwise they would be captured at the
   * first flush.
   */ key: "setInitialState",
            value: function setInitialState() {
                var urlPath = "".concat(WINDOW.location.pathname).concat(WINDOW.location.hash).concat(WINDOW.location.search);
                var url = "".concat(WINDOW.location.origin).concat(urlPath);
                this.performanceEntries = [];
                this.replayPerformanceEntries = [];
                // Reset _context as well
                this._clearContext();
                this._context.initialUrl = url;
                this._context.initialTimestamp = Date.now();
                this._context.urls.push(url);
            }
        },
        {
            /**
   * Add a breadcrumb event, that may be throttled.
   * If it was throttled, we add a custom breadcrumb to indicate that.
   */ key: "throttledAddEvent",
            value: function throttledAddEvent(event, isCheckout) {
                var _this = this;
                var res = this._throttledAddEvent(event, isCheckout);
                // If this is THROTTLED, it means we have throttled the event for the first time
                // In this case, we want to add a breadcrumb indicating that something was skipped
                if (res === THROTTLED) {
                    var breadcrumb = createBreadcrumb({
                        category: 'replay.throttled'
                    });
                    this.addUpdate(function() {
                        // Return `false` if the event _was_ added, as that means we schedule a flush
                        return !addEventSync(_this, {
                            type: ReplayEventTypeCustom,
                            timestamp: breadcrumb.timestamp || 0,
                            data: {
                                tag: 'breadcrumb',
                                payload: breadcrumb,
                                metric: true
                            }
                        });
                    });
                }
                return res;
            }
        },
        {
            /**
   * This will get the parametrized route name of the current page.
   * This is only available if performance is enabled, and if an instrumented router is used.
   */ key: "getCurrentRoute",
            value: function getCurrentRoute() {
                var lastActiveSpan = this.lastActiveSpan || (0, _core.getActiveSpan)();
                var lastRootSpan = lastActiveSpan && (0, _core.getRootSpan)(lastActiveSpan);
                var attributes = lastRootSpan && (0, _core.spanToJSON)(lastRootSpan).data || {};
                var source = attributes[0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
                if (!lastRootSpan || !source || ![
                    'route',
                    'custom'
                ].includes(source)) return undefined;
                return (0, _core.spanToJSON)(lastRootSpan).description;
            }
        },
        {
            /**
   * Initialize and start all listeners to varying events (DOM,
   * Performance Observer, Recording, Sentry SDK, etc)
   */ key: "_initializeRecording",
            value: function _initializeRecording() {
                this.setInitialState();
                // this method is generally called on page load or manually - in both cases
                // we should treat it as an activity
                this._updateSessionActivity();
                this.eventBuffer = createEventBuffer({
                    useCompression: this._options.useCompression,
                    workerUrl: this._options.workerUrl
                });
                this._removeListeners();
                this._addListeners();
                // Need to set as enabled before we start recording, as `record()` can trigger a flush with a new checkout
                this._isEnabled = true;
                this._isPaused = false;
                this.startRecording();
            }
        },
        {
            /**
   * Loads (or refreshes) the current session.
   */ key: "_initializeSessionForSampling",
            value: function _initializeSessionForSampling(previousSessionId) {
                // Whenever there is _any_ error sample rate, we always allow buffering
                // Because we decide on sampling when an error occurs, we need to buffer at all times if sampling for errors
                var allowBuffering = this._options.errorSampleRate > 0;
                var session = loadOrCreateSession({
                    sessionIdleExpire: this.timeouts.sessionIdleExpire,
                    maxReplayDuration: this._options.maxReplayDuration,
                    previousSessionId: previousSessionId
                }, {
                    stickySession: this._options.stickySession,
                    sessionSampleRate: this._options.sessionSampleRate,
                    allowBuffering: allowBuffering
                });
                this.session = session;
            }
        },
        {
            /**
   * Checks and potentially refreshes the current session.
   * Returns false if session is not recorded.
   */ key: "_checkSession",
            value: function _checkSession() {
                // If there is no session yet, we do not want to refresh anything
                // This should generally not happen, but to be safe....
                if (!this.session) return false;
                var currentSession = this.session;
                if (shouldRefreshSession(currentSession, {
                    sessionIdleExpire: this.timeouts.sessionIdleExpire,
                    maxReplayDuration: this._options.maxReplayDuration
                })) {
                    // This should never reject
                    // eslint-disable-next-line @typescript-eslint/no-floating-promises
                    this._refreshSession(currentSession);
                    return false;
                }
                return true;
            }
        },
        {
            key: "_refreshSession",
            value: /**
   * Refresh a session with a new one.
   * This stops the current session (without forcing a flush, as that would never work since we are expired),
   * and then does a new sampling based on the refreshed session.
   */ function _refreshSession(session) {
                return (0, _asyncToGenerator._)(function() {
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!this._isEnabled) return [
                                    2
                                ];
                                return [
                                    4,
                                    this.stop({
                                        reason: 'refresh session'
                                    })
                                ];
                            case 1:
                                _state.sent();
                                this.initializeSampling(session.id);
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
   * Adds listeners to record events for the replay
   */ key: "_addListeners",
            value: function _addListeners() {
                try {
                    WINDOW.document.addEventListener('visibilitychange', this._handleVisibilityChange);
                    WINDOW.addEventListener('blur', this._handleWindowBlur);
                    WINDOW.addEventListener('focus', this._handleWindowFocus);
                    WINDOW.addEventListener('keydown', this._handleKeyboardEvent);
                    if (this.clickDetector) this.clickDetector.addListeners();
                    // There is no way to remove these listeners, so ensure they are only added once
                    if (!this._hasInitializedCoreListeners) {
                        addGlobalListeners(this);
                        this._hasInitializedCoreListeners = true;
                    }
                } catch (err) {
                    this.handleException(err);
                }
                this._performanceCleanupCallback = setupPerformanceObserver(this);
            }
        },
        {
            /**
   * Cleans up listeners that were created in `_addListeners`
   */ key: "_removeListeners",
            value: function _removeListeners() {
                try {
                    WINDOW.document.removeEventListener('visibilitychange', this._handleVisibilityChange);
                    WINDOW.removeEventListener('blur', this._handleWindowBlur);
                    WINDOW.removeEventListener('focus', this._handleWindowFocus);
                    WINDOW.removeEventListener('keydown', this._handleKeyboardEvent);
                    if (this.clickDetector) this.clickDetector.removeListeners();
                    if (this._performanceCleanupCallback) this._performanceCleanupCallback();
                } catch (err) {
                    this.handleException(err);
                }
            }
        },
        {
            /**
   * Tasks to run when we consider a page to be hidden (via blurring and/or visibility)
   */ key: "_doChangeToBackgroundTasks",
            value: function _doChangeToBackgroundTasks(breadcrumb) {
                if (!this.session) return;
                var expired = isSessionExpired(this.session, {
                    maxReplayDuration: this._options.maxReplayDuration,
                    sessionIdleExpire: this.timeouts.sessionIdleExpire
                });
                if (expired) return;
                if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
                // Send replay when the page/tab becomes hidden. There is no reason to send
                // replay if it becomes visible, since no actions we care about were done
                // while it was hidden
                // This should never reject
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.conditionalFlush();
            }
        },
        {
            /**
   * Tasks to run when we consider a page to be visible (via focus and/or visibility)
   */ key: "_doChangeToForegroundTasks",
            value: function _doChangeToForegroundTasks(breadcrumb) {
                if (!this.session) return;
                var isSessionActive = this.checkAndHandleExpiredSession();
                if (!isSessionActive) {
                    // If the user has come back to the page within SESSION_IDLE_PAUSE_DURATION
                    // ms, we will re-use the existing session, otherwise create a new
                    // session
                    DEBUG_BUILD && debug.log('Document has become active, but session has expired');
                    return;
                }
                if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
            }
        },
        {
            /**
   * Update user activity (across session lifespans)
   */ key: "_updateUserActivity",
            value: function _updateUserActivity() {
                var _lastActivity = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Date.now();
                this._lastActivity = _lastActivity;
            }
        },
        {
            /**
   * Updates the session's last activity timestamp
   */ key: "_updateSessionActivity",
            value: function _updateSessionActivity() {
                var _lastActivity = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Date.now();
                if (this.session) {
                    this.session.lastActivity = _lastActivity;
                    this._maybeSaveSession();
                }
            }
        },
        {
            /**
   * Helper to create (and buffer) a replay breadcrumb from a core SDK breadcrumb
   */ key: "_createCustomBreadcrumb",
            value: function _createCustomBreadcrumb(breadcrumb) {
                var _this = this;
                this.addUpdate(function() {
                    // This should never reject
                    // eslint-disable-next-line @typescript-eslint/no-floating-promises
                    _this.throttledAddEvent({
                        type: EventType.Custom,
                        timestamp: breadcrumb.timestamp || 0,
                        data: {
                            tag: 'breadcrumb',
                            payload: breadcrumb
                        }
                    });
                });
            }
        },
        {
            /**
   * Observed performance events are added to `this.performanceEntries`. These
   * are included in the replay event before it is finished and sent to Sentry.
   */ key: "_addPerformanceEntries",
            value: function _addPerformanceEntries() {
                var performanceEntries = createPerformanceEntries(this.performanceEntries).concat(this.replayPerformanceEntries);
                this.performanceEntries = [];
                this.replayPerformanceEntries = [];
                // If we are manually starting, we want to ensure we only include performance entries
                // that are after the initial timestamp
                // The reason for this is that we may have performance entries from the page load, but may decide to start
                // the replay later on, in which case we do not want to include these entries.
                // without this, manually started replays can have events long before the actual replay recording starts,
                // which messes with the timeline etc.
                if (this._requiresManualStart) {
                    var initialTimestampInSeconds = this._context.initialTimestamp / 1000;
                    performanceEntries = performanceEntries.filter(function(entry) {
                        return entry.start >= initialTimestampInSeconds;
                    });
                }
                return Promise.all(createPerformanceSpans(this, performanceEntries));
            }
        },
        {
            /**
   * Clear _context
   */ key: "_clearContext",
            value: function _clearContext() {
                // XXX: `initialTimestamp` and `initialUrl` do not get cleared
                this._context.errorIds.clear();
                this._context.traceIds.clear();
                this._context.urls = [];
            }
        },
        {
            /** Update the initial timestamp based on the buffer content. */ key: "_updateInitialTimestampFromEventBuffer",
            value: function _updateInitialTimestampFromEventBuffer() {
                var _this = this, session = _this.session, eventBuffer = _this.eventBuffer;
                // If replay was started manually (=no sample rate was given),
                // We do not want to back-port the initial timestamp
                if (!session || !eventBuffer || this._requiresManualStart) return;
                // we only ever update this on the initial segment
                if (session.segmentId) return;
                var earliestEvent = eventBuffer.getEarliestTimestamp();
                if (earliestEvent && earliestEvent < this._context.initialTimestamp) this._context.initialTimestamp = earliestEvent;
            }
        },
        {
            /**
   * Return and clear _context
   */ key: "_popEventContext",
            value: function _popEventContext() {
                var _context = {
                    initialTimestamp: this._context.initialTimestamp,
                    initialUrl: this._context.initialUrl,
                    errorIds: Array.from(this._context.errorIds),
                    traceIds: Array.from(this._context.traceIds),
                    urls: this._context.urls
                };
                this._clearContext();
                return _context;
            }
        },
        {
            key: "_runFlush",
            value: /**
   * Flushes replay event buffer to Sentry.
   *
   * Performance events are only added right before flushing - this is
   * due to the buffered performance observer events.
   *
   * Should never be called directly, only by `flush`
   */ function _runFlush() {
                return (0, _asyncToGenerator._)(function() {
                    var _this, _this_eventBuffer, replayId, timestamp, eventContext, segmentId, recordingData, err, client, dropReason;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                replayId = this.getSessionId();
                                if (!this.session || !this.eventBuffer || !replayId) {
                                    DEBUG_BUILD && debug.error('No session or eventBuffer found to flush.');
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    this._addPerformanceEntries()
                                ];
                            case 1:
                                _state.sent();
                                // Check eventBuffer again, as it could have been stopped in the meanwhile
                                if (!((_this_eventBuffer = this.eventBuffer) === null || _this_eventBuffer === void 0 ? void 0 : _this_eventBuffer.hasEvents)) return [
                                    2
                                ];
                                // Only attach memory event if eventBuffer is not empty
                                return [
                                    4,
                                    addMemoryEntry(this)
                                ];
                            case 2:
                                _state.sent();
                                // Check eventBuffer again, as it could have been stopped in the meanwhile
                                if (!this.eventBuffer) return [
                                    2
                                ];
                                // if this changed in the meanwhile, e.g. because the session was refreshed or similar, we abort here
                                if (replayId !== this.getSessionId()) return [
                                    2
                                ];
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    6,
                                    ,
                                    7
                                ]);
                                // This uses the data from the eventBuffer, so we need to call this before `finish()
                                this._updateInitialTimestampFromEventBuffer();
                                timestamp = Date.now();
                                // Check total duration again, to avoid sending outdated stuff
                                // We leave 30s wiggle room to accommodate late flushing etc.
                                // This _could_ happen when the browser is suspended during flushing, in which case we just want to stop
                                if (timestamp - this._context.initialTimestamp > this._options.maxReplayDuration + 30000) throw new Error('Session is too long, not sending replay');
                                eventContext = this._popEventContext();
                                // Always increment segmentId regardless of outcome of sending replay
                                segmentId = this.session.segmentId++;
                                this._maybeSaveSession();
                                return [
                                    4,
                                    this.eventBuffer.finish()
                                ];
                            case 4:
                                recordingData = _state.sent();
                                return [
                                    4,
                                    sendReplay({
                                        replayId: replayId,
                                        recordingData: recordingData,
                                        segmentId: segmentId,
                                        eventContext: eventContext,
                                        session: this.session,
                                        timestamp: timestamp,
                                        onError: function(err) {
                                            return _this.handleException(err);
                                        }
                                    })
                                ];
                            case 5:
                                _state.sent();
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                err = _state.sent();
                                this.handleException(err);
                                // This means we retried 3 times and all of them failed,
                                // or we ran into a problem we don't want to retry, like rate limiting.
                                // In this case, we want to completely stop the replay - otherwise, we may get inconsistent segments
                                // This should never reject
                                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                                this.stop({
                                    reason: 'sendReplay'
                                });
                                client = (0, _core.getClient)();
                                if (client) {
                                    dropReason = (0, _instanceof._)(err, RateLimitError) ? 'ratelimit_backoff' : 'send_error';
                                    client.recordDroppedEvent(dropReason, 'replay');
                                }
                                return [
                                    3,
                                    7
                                ];
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "_flush",
            value: /**
   * Flush recording data to Sentry. Creates a lock so that only a single flush
   * can be active at a time. Do not call this directly.
   */ function _flush() {
                return (0, _asyncToGenerator._)(function() {
                    var _ref, _ref_force, force, start, now, duration, tooShort, tooLong, eventBuffer, _flushInProgress, err;
                    var _arguments = arguments;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _ref = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, _ref_force = _ref.force, force = _ref_force === void 0 ? false : _ref_force;
                                if (!this._isEnabled && !force) // This can happen if e.g. the replay was stopped because of exceeding the retry limit
                                return [
                                    2
                                ];
                                if (!this.checkAndHandleExpiredSession()) {
                                    DEBUG_BUILD && debug.error('Attempting to finish replay event after session expired.');
                                    return [
                                        2
                                    ];
                                }
                                if (!this.session) // should never happen, as we would have bailed out before
                                return [
                                    2
                                ];
                                start = this.session.started;
                                now = Date.now();
                                duration = now - start;
                                // A flush is about to happen, cancel any queued flushes
                                this._debouncedFlush.cancel();
                                // If session is too short, or too long (allow some wiggle room over maxReplayDuration), do not send it
                                // This _should_ not happen, but it may happen if flush is triggered due to a page activity change or similar
                                tooShort = duration < this._options.minReplayDuration;
                                tooLong = duration > this._options.maxReplayDuration + 5000;
                                if (tooShort || tooLong) {
                                    DEBUG_BUILD && debug.log("Session duration (".concat(Math.floor(duration / 1000), "s) is too ").concat(tooShort ? 'short' : 'long', ", not sending replay."));
                                    if (tooShort) this._debouncedFlush();
                                    return [
                                        2
                                    ];
                                }
                                eventBuffer = this.eventBuffer;
                                if (eventBuffer && this.session.segmentId === 0 && !eventBuffer.hasCheckout) DEBUG_BUILD && debug.log('Flushing initial segment without checkout.');
                                _flushInProgress = !!this._flushLock;
                                // this._flushLock acts as a lock so that future calls to `_flush()` will
                                // be blocked until current flush is finished (i.e. this promise resolves)
                                if (!this._flushLock) this._flushLock = this._runFlush();
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    4,
                                    5
                                ]);
                                return [
                                    4,
                                    this._flushLock
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 3:
                                err = _state.sent();
                                this.handleException(err);
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                this._flushLock = undefined;
                                if (_flushInProgress) // Wait for previous flush to finish, then call the debounced
                                // `_flush()`. It's possible there are other flush requests queued and
                                // waiting for it to resolve. We want to reduce all outstanding
                                // requests (as well as any new flush requests that occur within a
                                // second of the locked flush completing) into a single flush.
                                this._debouncedFlush();
                                return [
                                    7
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        },
        {
            /** Save the session, if it is sticky */ key: "_maybeSaveSession",
            value: function _maybeSaveSession() {
                if (this.session && this._options.stickySession) saveSession(this.session);
            }
        },
        {
            /** Handler for rrweb.record.onMutation */ key: "_onMutationHandler",
            value: function _onMutationHandler(mutations) {
                var ignoreMutations = this._options._experiments.ignoreMutations;
                if (ignoreMutations === null || ignoreMutations === void 0 ? void 0 : ignoreMutations.length) {
                    if (mutations.some(function(mutation) {
                        var el = closestElementOfNode(mutation.target);
                        var selector = ignoreMutations.join(',');
                        return el === null || el === void 0 ? void 0 : el.matches(selector);
                    })) return false;
                }
                var count = mutations.length;
                var mutationLimit = this._options.mutationLimit;
                var mutationBreadcrumbLimit = this._options.mutationBreadcrumbLimit;
                var overMutationLimit = mutationLimit && count > mutationLimit;
                // Create a breadcrumb if a lot of mutations happen at the same time
                // We can show this in the UI as an information with potential performance improvements
                if (count > mutationBreadcrumbLimit || overMutationLimit) {
                    var breadcrumb = createBreadcrumb({
                        category: 'replay.mutations',
                        data: {
                            count: count,
                            limit: overMutationLimit
                        }
                    });
                    this._createCustomBreadcrumb(breadcrumb);
                }
                // Stop replay if over the mutation limit
                if (overMutationLimit) {
                    // This should never reject
                    // eslint-disable-next-line @typescript-eslint/no-floating-promises
                    this.stop({
                        reason: 'mutationLimit',
                        forceFlush: this.recordingMode === 'session'
                    });
                    return false;
                }
                // `true` means we use the regular mutation handling by rrweb
                return true;
            }
        }
    ]);
    return ReplayContainer;
}();
function getOption(selectors, defaultSelectors) {
    return (0, _toConsumableArray._)(selectors).concat(// sentry defaults
    (0, _toConsumableArray._)(defaultSelectors)).join(',');
}
/**
 * Returns privacy related configuration for use in rrweb
 */ function getPrivacyOptions(param) {
    var mask = param.mask, unmask = param.unmask, block = param.block, unblock = param.unblock, ignore = param.ignore;
    var defaultBlockedElements = [
        'base',
        'iframe[srcdoc]:not([src])'
    ];
    var maskSelector = getOption(mask, [
        '.sentry-mask',
        '[data-sentry-mask]'
    ]);
    var unmaskSelector = getOption(unmask, []);
    var options = {
        // We are making the decision to make text and input selectors the same
        maskTextSelector: maskSelector,
        unmaskTextSelector: unmaskSelector,
        blockSelector: getOption(block, [
            '.sentry-block',
            '[data-sentry-block]'
        ].concat((0, _toConsumableArray._)(defaultBlockedElements))),
        unblockSelector: getOption(unblock, []),
        ignoreSelector: getOption(ignore, [
            '.sentry-ignore',
            '[data-sentry-ignore]',
            'input[type="file"]'
        ])
    };
    return options;
}
/**
 * Masks an attribute if necessary, otherwise return attribute value as-is.
 */ function maskAttribute(param) {
    var el = param.el, key = param.key, maskAttributes = param.maskAttributes, maskAllText = param.maskAllText, privacyOptions = param.privacyOptions, value = param.value;
    // We only mask attributes if `maskAllText` is true
    if (!maskAllText) return value;
    // unmaskTextSelector takes precedence
    if (privacyOptions.unmaskTextSelector && el.matches(privacyOptions.unmaskTextSelector)) return value;
    if (maskAttributes.includes(key) || // Need to mask `value` attribute for `<input>` if it's a button-like
    // type
    key === 'value' && el.tagName === 'INPUT' && [
        'submit',
        'button'
    ].includes(el.getAttribute('type') || '')) return value.replace(/[\S]/g, '*');
    return value;
}
var MEDIA_SELECTORS = 'img,image,svg,video,object,picture,embed,map,audio,link[rel="icon"],link[rel="apple-touch-icon"]';
var DEFAULT_NETWORK_HEADERS = [
    'content-length',
    'content-type',
    'accept'
];
var _initialized = false;
/**
 * Sentry integration for [Session Replay](https://sentry.io/for/session-replay/).
 *
 * See the [Replay documentation](https://docs.sentry.io/platforms/javascript/guides/session-replay/) for more information.
 *
 * @example
 *
 * ```
 * Sentry.init({
 *   dsn: '__DSN__',
 *   integrations: [Sentry.replayIntegration()],
 * });
 * ```
 */ var replayIntegration = function(options) {
    return new Replay(options);
};
/**
 * Replay integration
 */ var Replay = /*#__PURE__*/ function() {
    "use strict";
    function Replay() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_flushMinDelay = _ref.flushMinDelay, flushMinDelay = _ref_flushMinDelay === void 0 ? DEFAULT_FLUSH_MIN_DELAY : _ref_flushMinDelay, _ref_flushMaxDelay = _ref.flushMaxDelay, flushMaxDelay = _ref_flushMaxDelay === void 0 ? DEFAULT_FLUSH_MAX_DELAY : _ref_flushMaxDelay, _ref_minReplayDuration = _ref.minReplayDuration, minReplayDuration = _ref_minReplayDuration === void 0 ? MIN_REPLAY_DURATION : _ref_minReplayDuration, _ref_maxReplayDuration = _ref.maxReplayDuration, maxReplayDuration = _ref_maxReplayDuration === void 0 ? MAX_REPLAY_DURATION : _ref_maxReplayDuration, _ref_stickySession = _ref.stickySession, stickySession = _ref_stickySession === void 0 ? true : _ref_stickySession, _ref_useCompression = _ref.useCompression, useCompression = _ref_useCompression === void 0 ? true : _ref_useCompression, workerUrl = _ref.workerUrl, _ref__experiments = _ref._experiments, _experiments = _ref__experiments === void 0 ? {} : _ref__experiments, _ref_maskAllText = _ref.maskAllText, maskAllText = _ref_maskAllText === void 0 ? true : _ref_maskAllText, _ref_maskAllInputs = _ref.maskAllInputs, maskAllInputs = _ref_maskAllInputs === void 0 ? true : _ref_maskAllInputs, _ref_blockAllMedia = _ref.blockAllMedia, blockAllMedia = _ref_blockAllMedia === void 0 ? true : _ref_blockAllMedia, _ref_mutationBreadcrumbLimit = _ref.mutationBreadcrumbLimit, mutationBreadcrumbLimit = _ref_mutationBreadcrumbLimit === void 0 ? 750 : _ref_mutationBreadcrumbLimit, _ref_mutationLimit = _ref.mutationLimit, mutationLimit = _ref_mutationLimit === void 0 ? 10000 : _ref_mutationLimit, _ref_slowClickTimeout = _ref.slowClickTimeout, slowClickTimeout = _ref_slowClickTimeout === void 0 ? 7000 : _ref_slowClickTimeout, _ref_slowClickIgnoreSelectors = _ref.slowClickIgnoreSelectors, slowClickIgnoreSelectors = _ref_slowClickIgnoreSelectors === void 0 ? [] : _ref_slowClickIgnoreSelectors, _ref_networkDetailAllowUrls = _ref.networkDetailAllowUrls, networkDetailAllowUrls = _ref_networkDetailAllowUrls === void 0 ? [] : _ref_networkDetailAllowUrls, _ref_networkDetailDenyUrls = _ref.networkDetailDenyUrls, networkDetailDenyUrls = _ref_networkDetailDenyUrls === void 0 ? [] : _ref_networkDetailDenyUrls, _ref_networkCaptureBodies = _ref.networkCaptureBodies, networkCaptureBodies = _ref_networkCaptureBodies === void 0 ? true : _ref_networkCaptureBodies, _ref_networkRequestHeaders = _ref.networkRequestHeaders, networkRequestHeaders = _ref_networkRequestHeaders === void 0 ? [] : _ref_networkRequestHeaders, _ref_networkResponseHeaders = _ref.networkResponseHeaders, networkResponseHeaders = _ref_networkResponseHeaders === void 0 ? [] : _ref_networkResponseHeaders, _ref_mask = _ref.mask, mask = _ref_mask === void 0 ? [] : _ref_mask, _ref_maskAttributes = _ref.maskAttributes, maskAttributes = _ref_maskAttributes === void 0 ? [
            'title',
            'placeholder',
            'aria-label'
        ] : _ref_maskAttributes, _ref_unmask = _ref.unmask, unmask = _ref_unmask === void 0 ? [] : _ref_unmask, _ref_block = _ref.block, block = _ref_block === void 0 ? [] : _ref_block, _ref_unblock = _ref.unblock, unblock = _ref_unblock === void 0 ? [] : _ref_unblock, _ref_ignore = _ref.ignore, ignore = _ref_ignore === void 0 ? [] : _ref_ignore, maskFn = _ref.maskFn, beforeAddRecordingEvent = _ref.beforeAddRecordingEvent, beforeErrorSampling = _ref.beforeErrorSampling, onError = _ref.onError;
        (0, _classCallCheck._)(this, Replay);
        this.name = 'Replay';
        var privacyOptions = getPrivacyOptions({
            mask: mask,
            unmask: unmask,
            block: block,
            unblock: unblock,
            ignore: ignore
        });
        this._recordingOptions = (0, _objectSpreadProps._)((0, _objectSpread._)({
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            maskInputOptions: {
                password: true
            },
            maskTextFn: maskFn,
            maskInputFn: maskFn,
            maskAttributeFn: function(key, value, el) {
                return maskAttribute({
                    maskAttributes: maskAttributes,
                    maskAllText: maskAllText,
                    privacyOptions: privacyOptions,
                    key: key,
                    value: value,
                    el: el
                });
            }
        }, privacyOptions), {
            // Our defaults
            slimDOMOptions: 'all',
            inlineStylesheet: true,
            // Disable inline images as it will increase segment/replay size
            inlineImages: false,
            // collect fonts, but be aware that `sentry.io` needs to be an allowed
            // origin for playback
            collectFonts: true,
            errorHandler: function(err) {
                try {
                    err.__rrweb__ = true;
                } catch (e) {
                // ignore errors here
                // this can happen if the error is frozen or does not allow mutation for other reasons
                }
            },
            // experimental support for recording iframes from different origins
            recordCrossOriginIframes: Boolean(_experiments.recordCrossOriginIframes)
        });
        this._initialOptions = {
            flushMinDelay: flushMinDelay,
            flushMaxDelay: flushMaxDelay,
            minReplayDuration: Math.min(minReplayDuration, MIN_REPLAY_DURATION_LIMIT),
            maxReplayDuration: Math.min(maxReplayDuration, MAX_REPLAY_DURATION),
            stickySession: stickySession,
            useCompression: useCompression,
            workerUrl: workerUrl,
            blockAllMedia: blockAllMedia,
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            mutationBreadcrumbLimit: mutationBreadcrumbLimit,
            mutationLimit: mutationLimit,
            slowClickTimeout: slowClickTimeout,
            slowClickIgnoreSelectors: slowClickIgnoreSelectors,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: _getMergedNetworkHeaders(networkRequestHeaders),
            networkResponseHeaders: _getMergedNetworkHeaders(networkResponseHeaders),
            beforeAddRecordingEvent: beforeAddRecordingEvent,
            beforeErrorSampling: beforeErrorSampling,
            onError: onError,
            _experiments: _experiments
        };
        if (this._initialOptions.blockAllMedia) {
            // `blockAllMedia` is a more user friendly option to configure blocking
            // embedded media elements
            this._recordingOptions.blockSelector = !this._recordingOptions.blockSelector ? MEDIA_SELECTORS : "".concat(this._recordingOptions.blockSelector, ",").concat(MEDIA_SELECTORS);
            this._recordingOptions.ignoreCSSAttributes = new Set([
                'background-image'
            ]);
        }
        if (this._isInitialized && (0, _core.isBrowser)()) throw new Error('Multiple Sentry Session Replay instances are not supported');
        this._isInitialized = true;
    }
    (0, _createClass._)(Replay, [
        {
            key: "_isInitialized",
            get: /** If replay has already been initialized */ function get() {
                return _initialized;
            },
            set: /** Update _isInitialized */ function set(value) {
                _initialized = value;
            }
        },
        {
            /**
   * Setup and initialize replay container
   */ key: "afterAllSetup",
            value: function afterAllSetup(client) {
                if (!(0, _core.isBrowser)() || this._replay) return;
                this._setup(client);
                this._initialize(client);
            }
        },
        {
            /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will log a message if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * PerformanceObserver, Recording, Sentry SDK, etc)
   */ key: "start",
            value: function start() {
                if (!this._replay) return;
                this._replay.start();
            }
        },
        {
            /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, until an error occurs.
   */ key: "startBuffering",
            value: function startBuffering() {
                if (!this._replay) return;
                this._replay.startBuffering();
            }
        },
        {
            /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ key: "stop",
            value: function stop() {
                if (!this._replay) return Promise.resolve();
                return this._replay.stop({
                    forceFlush: this._replay.recordingMode === 'session'
                });
            }
        },
        {
            /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * If replay is not enabled, a new session replay is started.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ key: "flush",
            value: function flush(options) {
                if (!this._replay) return Promise.resolve();
                // assuming a session should be recorded in this case
                if (!this._replay.isEnabled()) {
                    this._replay.start();
                    return Promise.resolve();
                }
                return this._replay.sendBufferedReplayOrFlush(options);
            }
        },
        {
            /**
   * Get the current session ID.
   *
   * @param onlyIfSampled - If true, will only return the session ID if the session is sampled.
   *
   */ key: "getReplayId",
            value: function getReplayId(onlyIfSampled) {
                var _this__replay;
                if (!((_this__replay = this._replay) === null || _this__replay === void 0 ? void 0 : _this__replay.isEnabled())) return;
                return this._replay.getSessionId(onlyIfSampled);
            }
        },
        {
            /**
   * Get the current recording mode. This can be either `session` or `buffer`.
   *
   * `session`: Recording the whole session, sending it continuously
   * `buffer`: Always keeping the last 60s of recording, requires:
   *   - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *   - or calling `flush()` to send the replay
   */ key: "getRecordingMode",
            value: function getRecordingMode() {
                var _this__replay;
                if (!((_this__replay = this._replay) === null || _this__replay === void 0 ? void 0 : _this__replay.isEnabled())) return;
                return this._replay.recordingMode;
            }
        },
        {
            /**
   * Initializes replay.
   */ key: "_initialize",
            value: function _initialize(client) {
                if (!this._replay) return;
                this._maybeLoadFromReplayCanvasIntegration(client);
                this._replay.initializeSampling();
            }
        },
        {
            /** Setup the integration. */ key: "_setup",
            value: function _setup(client) {
                // Client is not available in constructor, so we need to wait until setupOnce
                var finalOptions = loadReplayOptionsFromClient(this._initialOptions, client);
                this._replay = new ReplayContainer({
                    options: finalOptions,
                    recordingOptions: this._recordingOptions
                });
            }
        },
        {
            /** Get canvas options from ReplayCanvas integration, if it is also added. */ key: "_maybeLoadFromReplayCanvasIntegration",
            value: function _maybeLoadFromReplayCanvasIntegration(client) {
                // To save bundle size, we skip checking for stuff here
                // and instead just try-catch everything - as generally this should all be defined
                /* eslint-disable @typescript-eslint/no-non-null-assertion */ try {
                    var canvasIntegration = client.getIntegrationByName('ReplayCanvas');
                    if (!canvasIntegration) return;
                    this._replay['_canvas'] = canvasIntegration.getOptions();
                } catch (e) {
                // ignore errors here
                }
            /* eslint-enable @typescript-eslint/no-non-null-assertion */ }
        }
    ]);
    return Replay;
}();
/** Parse Replay-related options from SDK options */ function loadReplayOptionsFromClient(initialOptions, client) {
    var opt = client.getOptions();
    var finalOptions = (0, _objectSpread._)({
        sessionSampleRate: 0,
        errorSampleRate: 0
    }, initialOptions);
    var replaysSessionSampleRate = (0, _core.parseSampleRate)(opt.replaysSessionSampleRate);
    var replaysOnErrorSampleRate = (0, _core.parseSampleRate)(opt.replaysOnErrorSampleRate);
    if (replaysSessionSampleRate == null && replaysOnErrorSampleRate == null) (0, _core.consoleSandbox)(function() {
        // eslint-disable-next-line no-console
        console.warn('Replay is disabled because neither `replaysSessionSampleRate` nor `replaysOnErrorSampleRate` are set.');
    });
    if (replaysSessionSampleRate != null) finalOptions.sessionSampleRate = replaysSessionSampleRate;
    if (replaysOnErrorSampleRate != null) finalOptions.errorSampleRate = replaysOnErrorSampleRate;
    return finalOptions;
}
function _getMergedNetworkHeaders(headers) {
    return (0, _toConsumableArray._)(DEFAULT_NETWORK_HEADERS).concat((0, _toConsumableArray._)(headers.map(function(header) {
        return header.toLowerCase();
    })));
}
/**
 * This is a small utility to get a type-safe instance of the Replay integration.
 */ function getReplay() {
    var client = (0, _core.getClient)();
    return client === null || client === void 0 ? void 0 : client.getIntegrationByName('Replay');
}

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_inherits":"2sfqW","@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_to_consumable_array":"1eSZf","@swc/helpers/_/_type_of":"iFJdx","@swc/helpers/_/_wrap_native_super":"d0Iin","@swc/helpers/_/_ts_generator":"78Tqx","@sentry/core":"8UqT3","@sentry-internal/browser-utils":"hXSTf","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8UqT3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "registerSpanErrorInstrumentation", function() {
    return 0, _errorsJs.registerSpanErrorInstrumentation;
});
parcelHelpers.export(exports, "getCapturedScopesOnSpan", function() {
    return 0, _utilsJs.getCapturedScopesOnSpan;
});
parcelHelpers.export(exports, "setCapturedScopesOnSpan", function() {
    return 0, _utilsJs.setCapturedScopesOnSpan;
});
parcelHelpers.export(exports, "TRACING_DEFAULTS", function() {
    return 0, _idleSpanJs.TRACING_DEFAULTS;
});
parcelHelpers.export(exports, "startIdleSpan", function() {
    return 0, _idleSpanJs.startIdleSpan;
});
parcelHelpers.export(exports, "SentrySpan", function() {
    return 0, _sentrySpanJs.SentrySpan;
});
parcelHelpers.export(exports, "SentryNonRecordingSpan", function() {
    return 0, _sentryNonRecordingSpanJs.SentryNonRecordingSpan;
});
parcelHelpers.export(exports, "SPAN_STATUS_ERROR", function() {
    return 0, _spanstatusJs.SPAN_STATUS_ERROR;
});
parcelHelpers.export(exports, "SPAN_STATUS_OK", function() {
    return 0, _spanstatusJs.SPAN_STATUS_OK;
});
parcelHelpers.export(exports, "SPAN_STATUS_UNSET", function() {
    return 0, _spanstatusJs.SPAN_STATUS_UNSET;
});
parcelHelpers.export(exports, "getSpanStatusFromHttpCode", function() {
    return 0, _spanstatusJs.getSpanStatusFromHttpCode;
});
parcelHelpers.export(exports, "setHttpStatus", function() {
    return 0, _spanstatusJs.setHttpStatus;
});
parcelHelpers.export(exports, "continueTrace", function() {
    return 0, _traceJs.continueTrace;
});
parcelHelpers.export(exports, "startInactiveSpan", function() {
    return 0, _traceJs.startInactiveSpan;
});
parcelHelpers.export(exports, "startNewTrace", function() {
    return 0, _traceJs.startNewTrace;
});
parcelHelpers.export(exports, "startSpan", function() {
    return 0, _traceJs.startSpan;
});
parcelHelpers.export(exports, "startSpanManual", function() {
    return 0, _traceJs.startSpanManual;
});
parcelHelpers.export(exports, "suppressTracing", function() {
    return 0, _traceJs.suppressTracing;
});
parcelHelpers.export(exports, "withActiveSpan", function() {
    return 0, _traceJs.withActiveSpan;
});
parcelHelpers.export(exports, "getDynamicSamplingContextFromClient", function() {
    return 0, _dynamicSamplingContextJs.getDynamicSamplingContextFromClient;
});
parcelHelpers.export(exports, "getDynamicSamplingContextFromScope", function() {
    return 0, _dynamicSamplingContextJs.getDynamicSamplingContextFromScope;
});
parcelHelpers.export(exports, "getDynamicSamplingContextFromSpan", function() {
    return 0, _dynamicSamplingContextJs.getDynamicSamplingContextFromSpan;
});
parcelHelpers.export(exports, "spanToBaggageHeader", function() {
    return 0, _dynamicSamplingContextJs.spanToBaggageHeader;
});
parcelHelpers.export(exports, "setMeasurement", function() {
    return 0, _measurementJs.setMeasurement;
});
parcelHelpers.export(exports, "timedEventsToMeasurements", function() {
    return 0, _measurementJs.timedEventsToMeasurements;
});
parcelHelpers.export(exports, "sampleSpan", function() {
    return 0, _samplingJs.sampleSpan;
});
parcelHelpers.export(exports, "logSpanEnd", function() {
    return 0, _logSpansJs.logSpanEnd;
});
parcelHelpers.export(exports, "logSpanStart", function() {
    return 0, _logSpansJs.logSpanStart;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_CACHE_HIT", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_CACHE_HIT;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_CACHE_KEY", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_CACHE_KEY;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_PROFILE_ID", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_PROFILE_ID;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_OP", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_URL_FULL", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_URL_FULL;
});
parcelHelpers.export(exports, "SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE", function() {
    return 0, _semanticAttributesJs.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE;
});
parcelHelpers.export(exports, "createEventEnvelope", function() {
    return 0, _envelopeJs.createEventEnvelope;
});
parcelHelpers.export(exports, "createSessionEnvelope", function() {
    return 0, _envelopeJs.createSessionEnvelope;
});
parcelHelpers.export(exports, "createSpanEnvelope", function() {
    return 0, _envelopeJs.createSpanEnvelope;
});
parcelHelpers.export(exports, "addEventProcessor", function() {
    return 0, _exportsJs.addEventProcessor;
});
parcelHelpers.export(exports, "captureCheckIn", function() {
    return 0, _exportsJs.captureCheckIn;
});
parcelHelpers.export(exports, "captureEvent", function() {
    return 0, _exportsJs.captureEvent;
});
parcelHelpers.export(exports, "captureException", function() {
    return 0, _exportsJs.captureException;
});
parcelHelpers.export(exports, "captureMessage", function() {
    return 0, _exportsJs.captureMessage;
});
parcelHelpers.export(exports, "captureSession", function() {
    return 0, _exportsJs.captureSession;
});
parcelHelpers.export(exports, "close", function() {
    return 0, _exportsJs.close;
});
parcelHelpers.export(exports, "endSession", function() {
    return 0, _exportsJs.endSession;
});
parcelHelpers.export(exports, "flush", function() {
    return 0, _exportsJs.flush;
});
parcelHelpers.export(exports, "isEnabled", function() {
    return 0, _exportsJs.isEnabled;
});
parcelHelpers.export(exports, "isInitialized", function() {
    return 0, _exportsJs.isInitialized;
});
parcelHelpers.export(exports, "lastEventId", function() {
    return 0, _exportsJs.lastEventId;
});
parcelHelpers.export(exports, "setContext", function() {
    return 0, _exportsJs.setContext;
});
parcelHelpers.export(exports, "setExtra", function() {
    return 0, _exportsJs.setExtra;
});
parcelHelpers.export(exports, "setExtras", function() {
    return 0, _exportsJs.setExtras;
});
parcelHelpers.export(exports, "setTag", function() {
    return 0, _exportsJs.setTag;
});
parcelHelpers.export(exports, "setTags", function() {
    return 0, _exportsJs.setTags;
});
parcelHelpers.export(exports, "setUser", function() {
    return 0, _exportsJs.setUser;
});
parcelHelpers.export(exports, "startSession", function() {
    return 0, _exportsJs.startSession;
});
parcelHelpers.export(exports, "withMonitor", function() {
    return 0, _exportsJs.withMonitor;
});
parcelHelpers.export(exports, "getClient", function() {
    return 0, _currentScopesJs.getClient;
});
parcelHelpers.export(exports, "getCurrentScope", function() {
    return 0, _currentScopesJs.getCurrentScope;
});
parcelHelpers.export(exports, "getGlobalScope", function() {
    return 0, _currentScopesJs.getGlobalScope;
});
parcelHelpers.export(exports, "getIsolationScope", function() {
    return 0, _currentScopesJs.getIsolationScope;
});
parcelHelpers.export(exports, "getTraceContextFromScope", function() {
    return 0, _currentScopesJs.getTraceContextFromScope;
});
parcelHelpers.export(exports, "withIsolationScope", function() {
    return 0, _currentScopesJs.withIsolationScope;
});
parcelHelpers.export(exports, "withScope", function() {
    return 0, _currentScopesJs.withScope;
});
parcelHelpers.export(exports, "getDefaultCurrentScope", function() {
    return 0, _defaultScopesJs.getDefaultCurrentScope;
});
parcelHelpers.export(exports, "getDefaultIsolationScope", function() {
    return 0, _defaultScopesJs.getDefaultIsolationScope;
});
parcelHelpers.export(exports, "setAsyncContextStrategy", function() {
    return 0, _indexJs.setAsyncContextStrategy;
});
parcelHelpers.export(exports, "getGlobalSingleton", function() {
    return 0, _carrierJs.getGlobalSingleton;
});
parcelHelpers.export(exports, "getMainCarrier", function() {
    return 0, _carrierJs.getMainCarrier;
});
parcelHelpers.export(exports, "closeSession", function() {
    return 0, _sessionJs.closeSession;
});
parcelHelpers.export(exports, "makeSession", function() {
    return 0, _sessionJs.makeSession;
});
parcelHelpers.export(exports, "updateSession", function() {
    return 0, _sessionJs.updateSession;
});
parcelHelpers.export(exports, "Scope", function() {
    return 0, _scopeJs.Scope;
});
parcelHelpers.export(exports, "notifyEventProcessors", function() {
    return 0, _eventProcessorsJs.notifyEventProcessors;
});
parcelHelpers.export(exports, "getEnvelopeEndpointWithUrlEncodedAuth", function() {
    return 0, _apiJs.getEnvelopeEndpointWithUrlEncodedAuth;
});
parcelHelpers.export(exports, "getReportDialogEndpoint", function() {
    return 0, _apiJs.getReportDialogEndpoint;
});
parcelHelpers.export(exports, "Client", function() {
    return 0, _clientJs.Client;
});
parcelHelpers.export(exports, "ServerRuntimeClient", function() {
    return 0, _serverRuntimeClientJs.ServerRuntimeClient;
});
parcelHelpers.export(exports, "initAndBind", function() {
    return 0, _sdkJs.initAndBind;
});
parcelHelpers.export(exports, "setCurrentClient", function() {
    return 0, _sdkJs.setCurrentClient;
});
parcelHelpers.export(exports, "createTransport", function() {
    return 0, _baseJs.createTransport;
});
parcelHelpers.export(exports, "makeOfflineTransport", function() {
    return 0, _offlineJs.makeOfflineTransport;
});
parcelHelpers.export(exports, "makeMultiplexedTransport", function() {
    return 0, _multiplexedJs.makeMultiplexedTransport;
});
parcelHelpers.export(exports, "addIntegration", function() {
    return 0, _integrationJs.addIntegration;
});
parcelHelpers.export(exports, "defineIntegration", function() {
    return 0, _integrationJs.defineIntegration;
});
parcelHelpers.export(exports, "getIntegrationsToSetup", function() {
    return 0, _integrationJs.getIntegrationsToSetup;
});
parcelHelpers.export(exports, "installedIntegrations", function() {
    return 0, _integrationJs.installedIntegrations;
});
parcelHelpers.export(exports, "_INTERNAL_clearAiProviderSkips", function() {
    return 0, _providerSkipJs._INTERNAL_clearAiProviderSkips;
});
parcelHelpers.export(exports, "_INTERNAL_shouldSkipAiProviderWrapping", function() {
    return 0, _providerSkipJs._INTERNAL_shouldSkipAiProviderWrapping;
});
parcelHelpers.export(exports, "_INTERNAL_skipAiProviderWrapping", function() {
    return 0, _providerSkipJs._INTERNAL_skipAiProviderWrapping;
});
parcelHelpers.export(exports, "applyScopeDataToEvent", function() {
    return 0, _applyScopeDataToEventJs.applyScopeDataToEvent;
});
parcelHelpers.export(exports, "mergeScopeData", function() {
    return 0, _applyScopeDataToEventJs.mergeScopeData;
});
parcelHelpers.export(exports, "prepareEvent", function() {
    return 0, _prepareEventJs.prepareEvent;
});
parcelHelpers.export(exports, "createCheckInEnvelope", function() {
    return 0, _checkinJs.createCheckInEnvelope;
});
parcelHelpers.export(exports, "hasSpansEnabled", function() {
    return 0, _hasSpansEnabledJs.hasSpansEnabled;
});
parcelHelpers.export(exports, "isSentryRequestUrl", function() {
    return 0, _isSentryRequestUrlJs.isSentryRequestUrl;
});
parcelHelpers.export(exports, "handleCallbackErrors", function() {
    return 0, _handleCallbackErrorsJs.handleCallbackErrors;
});
parcelHelpers.export(exports, "fmt", function() {
    return 0, _parameterizeJs.fmt;
});
parcelHelpers.export(exports, "parameterize", function() {
    return 0, _parameterizeJs.parameterize;
});
parcelHelpers.export(exports, "addAutoIpAddressToSession", function() {
    return 0, _ipAddressJs.addAutoIpAddressToSession;
});
parcelHelpers.export(exports, "addAutoIpAddressToUser", function() {
    return 0, _ipAddressJs.addAutoIpAddressToUser;
});
parcelHelpers.export(exports, "addChildSpanToSpan", function() {
    return 0, _spanUtilsJs.addChildSpanToSpan;
});
parcelHelpers.export(exports, "convertSpanLinksForEnvelope", function() {
    return 0, _spanUtilsJs.convertSpanLinksForEnvelope;
});
parcelHelpers.export(exports, "getActiveSpan", function() {
    return 0, _spanUtilsJs.getActiveSpan;
});
parcelHelpers.export(exports, "getRootSpan", function() {
    return 0, _spanUtilsJs.getRootSpan;
});
parcelHelpers.export(exports, "getSpanDescendants", function() {
    return 0, _spanUtilsJs.getSpanDescendants;
});
parcelHelpers.export(exports, "getStatusMessage", function() {
    return 0, _spanUtilsJs.getStatusMessage;
});
parcelHelpers.export(exports, "spanIsSampled", function() {
    return 0, _spanUtilsJs.spanIsSampled;
});
parcelHelpers.export(exports, "spanTimeInputToSeconds", function() {
    return 0, _spanUtilsJs.spanTimeInputToSeconds;
});
parcelHelpers.export(exports, "spanToJSON", function() {
    return 0, _spanUtilsJs.spanToJSON;
});
parcelHelpers.export(exports, "spanToTraceContext", function() {
    return 0, _spanUtilsJs.spanToTraceContext;
});
parcelHelpers.export(exports, "spanToTraceHeader", function() {
    return 0, _spanUtilsJs.spanToTraceHeader;
});
parcelHelpers.export(exports, "updateSpanName", function() {
    return 0, _spanUtilsJs.updateSpanName;
});
parcelHelpers.export(exports, "_INTERNAL_setSpanForScope", function() {
    return 0, _spanOnScopeJs._setSpanForScope;
});
parcelHelpers.export(exports, "parseSampleRate", function() {
    return 0, _parseSampleRateJs.parseSampleRate;
});
parcelHelpers.export(exports, "applySdkMetadata", function() {
    return 0, _sdkMetadataJs.applySdkMetadata;
});
parcelHelpers.export(exports, "getTraceData", function() {
    return 0, _traceDataJs.getTraceData;
});
parcelHelpers.export(exports, "getTraceMetaTags", function() {
    return 0, _metaJs.getTraceMetaTags;
});
parcelHelpers.export(exports, "debounce", function() {
    return 0, _debounceJs.debounce;
});
parcelHelpers.export(exports, "extractQueryParamsFromUrl", function() {
    return 0, _requestJs.extractQueryParamsFromUrl;
});
parcelHelpers.export(exports, "headersToDict", function() {
    return 0, _requestJs.headersToDict;
});
parcelHelpers.export(exports, "httpHeadersToSpanAttributes", function() {
    return 0, _requestJs.httpHeadersToSpanAttributes;
});
parcelHelpers.export(exports, "httpRequestToRequestData", function() {
    return 0, _requestJs.httpRequestToRequestData;
});
parcelHelpers.export(exports, "winterCGHeadersToDict", function() {
    return 0, _requestJs.winterCGHeadersToDict;
});
parcelHelpers.export(exports, "winterCGRequestToRequestData", function() {
    return 0, _requestJs.winterCGRequestToRequestData;
});
parcelHelpers.export(exports, "DEFAULT_ENVIRONMENT", function() {
    return 0, _constantsJs.DEFAULT_ENVIRONMENT;
});
parcelHelpers.export(exports, "addBreadcrumb", function() {
    return 0, _breadcrumbsJs.addBreadcrumb;
});
parcelHelpers.export(exports, "functionToStringIntegration", function() {
    return 0, _functiontostringJs.functionToStringIntegration;
});
parcelHelpers.export(exports, "eventFiltersIntegration", function() {
    return 0, _eventFiltersJs.eventFiltersIntegration;
});
parcelHelpers.export(exports, "inboundFiltersIntegration", function() {
    return 0, _eventFiltersJs.inboundFiltersIntegration;
});
parcelHelpers.export(exports, "linkedErrorsIntegration", function() {
    return 0, _linkederrorsJs.linkedErrorsIntegration;
});
parcelHelpers.export(exports, "moduleMetadataIntegration", function() {
    return 0, _moduleMetadataJs.moduleMetadataIntegration;
});
parcelHelpers.export(exports, "requestDataIntegration", function() {
    return 0, _requestdataJs.requestDataIntegration;
});
parcelHelpers.export(exports, "captureConsoleIntegration", function() {
    return 0, _captureconsoleJs.captureConsoleIntegration;
});
parcelHelpers.export(exports, "dedupeIntegration", function() {
    return 0, _dedupeJs.dedupeIntegration;
});
parcelHelpers.export(exports, "extraErrorDataIntegration", function() {
    return 0, _extraerrordataJs.extraErrorDataIntegration;
});
parcelHelpers.export(exports, "rewriteFramesIntegration", function() {
    return 0, _rewriteframesJs.rewriteFramesIntegration;
});
parcelHelpers.export(exports, "instrumentSupabaseClient", function() {
    return 0, _supabaseJs.instrumentSupabaseClient;
});
parcelHelpers.export(exports, "supabaseIntegration", function() {
    return 0, _supabaseJs.supabaseIntegration;
});
parcelHelpers.export(exports, "zodErrorsIntegration", function() {
    return 0, _zoderrorsJs.zodErrorsIntegration;
});
parcelHelpers.export(exports, "thirdPartyErrorFilterIntegration", function() {
    return 0, _thirdPartyErrorsFilterJs.thirdPartyErrorFilterIntegration;
});
parcelHelpers.export(exports, "consoleIntegration", function() {
    return 0, _consoleJs.consoleIntegration;
});
parcelHelpers.export(exports, "featureFlagsIntegration", function() {
    return 0, _featureFlagsIntegrationJs.featureFlagsIntegration;
});
parcelHelpers.export(exports, "growthbookIntegration", function() {
    return 0, _growthbookJs.growthbookIntegration;
});
parcelHelpers.export(exports, "profiler", function() {
    return 0, _profilingJs.profiler;
});
parcelHelpers.export(exports, "instrumentFetchRequest", function() {
    return 0, _fetchJs.instrumentFetchRequest;
});
parcelHelpers.export(exports, "trpcMiddleware", function() {
    return 0, _trpcJs.trpcMiddleware;
});
parcelHelpers.export(exports, "wrapMcpServerWithSentry", function() {
    return 0, _indexJs1.wrapMcpServerWithSentry;
});
parcelHelpers.export(exports, "captureFeedback", function() {
    return 0, _feedbackJs.captureFeedback;
});
parcelHelpers.export(exports, "_INTERNAL_captureLog", function() {
    return 0, _internalJs._INTERNAL_captureLog;
});
parcelHelpers.export(exports, "_INTERNAL_captureSerializedLog", function() {
    return 0, _internalJs._INTERNAL_captureSerializedLog;
});
parcelHelpers.export(exports, "_INTERNAL_flushLogsBuffer", function() {
    return 0, _internalJs._INTERNAL_flushLogsBuffer;
});
parcelHelpers.export(exports, "consoleLoggingIntegration", function() {
    return 0, _consoleIntegrationJs.consoleLoggingIntegration;
});
parcelHelpers.export(exports, "_INTERNAL_captureMetric", function() {
    return 0, _internalJs1._INTERNAL_captureMetric;
});
parcelHelpers.export(exports, "_INTERNAL_captureSerializedMetric", function() {
    return 0, _internalJs1._INTERNAL_captureSerializedMetric;
});
parcelHelpers.export(exports, "_INTERNAL_flushMetricsBuffer", function() {
    return 0, _internalJs1._INTERNAL_flushMetricsBuffer;
});
parcelHelpers.export(exports, "createConsolaReporter", function() {
    return 0, _consolaJs.createConsolaReporter;
});
parcelHelpers.export(exports, "addVercelAiProcessors", function() {
    return 0, _indexJs2.addVercelAiProcessors;
});
parcelHelpers.export(exports, "_INTERNAL_cleanupToolCallSpan", function() {
    return 0, _utilsJs1._INTERNAL_cleanupToolCallSpan;
});
parcelHelpers.export(exports, "_INTERNAL_getSpanForToolCallId", function() {
    return 0, _utilsJs1._INTERNAL_getSpanForToolCallId;
});
parcelHelpers.export(exports, "instrumentOpenAiClient", function() {
    return 0, _indexJs3.instrumentOpenAiClient;
});
parcelHelpers.export(exports, "OPENAI_INTEGRATION_NAME", function() {
    return 0, _constantsJs1.OPENAI_INTEGRATION_NAME;
});
parcelHelpers.export(exports, "instrumentAnthropicAiClient", function() {
    return 0, _indexJs4.instrumentAnthropicAiClient;
});
parcelHelpers.export(exports, "ANTHROPIC_AI_INTEGRATION_NAME", function() {
    return 0, _constantsJs2.ANTHROPIC_AI_INTEGRATION_NAME;
});
parcelHelpers.export(exports, "instrumentGoogleGenAIClient", function() {
    return 0, _indexJs5.instrumentGoogleGenAIClient;
});
parcelHelpers.export(exports, "GOOGLE_GENAI_INTEGRATION_NAME", function() {
    return 0, _constantsJs3.GOOGLE_GENAI_INTEGRATION_NAME;
});
parcelHelpers.export(exports, "createLangChainCallbackHandler", function() {
    return 0, _indexJs6.createLangChainCallbackHandler;
});
parcelHelpers.export(exports, "LANGCHAIN_INTEGRATION_NAME", function() {
    return 0, _constantsJs4.LANGCHAIN_INTEGRATION_NAME;
});
parcelHelpers.export(exports, "instrumentLangGraph", function() {
    return 0, _indexJs7.instrumentLangGraph;
});
parcelHelpers.export(exports, "instrumentStateGraphCompile", function() {
    return 0, _indexJs7.instrumentStateGraphCompile;
});
parcelHelpers.export(exports, "LANGGRAPH_INTEGRATION_NAME", function() {
    return 0, _constantsJs5.LANGGRAPH_INTEGRATION_NAME;
});
parcelHelpers.export(exports, "_INTERNAL_FLAG_BUFFER_SIZE", function() {
    return 0, _featureFlagsJs._INTERNAL_FLAG_BUFFER_SIZE;
});
parcelHelpers.export(exports, "_INTERNAL_MAX_FLAGS_PER_SPAN", function() {
    return 0, _featureFlagsJs._INTERNAL_MAX_FLAGS_PER_SPAN;
});
parcelHelpers.export(exports, "_INTERNAL_addFeatureFlagToActiveSpan", function() {
    return 0, _featureFlagsJs._INTERNAL_addFeatureFlagToActiveSpan;
});
parcelHelpers.export(exports, "_INTERNAL_copyFlagsFromScopeToEvent", function() {
    return 0, _featureFlagsJs._INTERNAL_copyFlagsFromScopeToEvent;
});
parcelHelpers.export(exports, "_INTERNAL_insertFlagToScope", function() {
    return 0, _featureFlagsJs._INTERNAL_insertFlagToScope;
});
parcelHelpers.export(exports, "applyAggregateErrorsToEvent", function() {
    return 0, _aggregateErrorsJs.applyAggregateErrorsToEvent;
});
parcelHelpers.export(exports, "getBreadcrumbLogLevelFromHttpStatusCode", function() {
    return 0, _breadcrumbLogLevelJs.getBreadcrumbLogLevelFromHttpStatusCode;
});
parcelHelpers.export(exports, "getComponentName", function() {
    return 0, _browserJs.getComponentName;
});
parcelHelpers.export(exports, "getLocationHref", function() {
    return 0, _browserJs.getLocationHref;
});
parcelHelpers.export(exports, "htmlTreeAsString", function() {
    return 0, _browserJs.htmlTreeAsString;
});
parcelHelpers.export(exports, "dsnFromString", function() {
    return 0, _dsnJs.dsnFromString;
});
parcelHelpers.export(exports, "dsnToString", function() {
    return 0, _dsnJs.dsnToString;
});
parcelHelpers.export(exports, "makeDsn", function() {
    return 0, _dsnJs.makeDsn;
});
parcelHelpers.export(exports, "SentryError", function() {
    return 0, _errorJs.SentryError;
});
parcelHelpers.export(exports, "GLOBAL_OBJ", function() {
    return 0, _worldwideJs.GLOBAL_OBJ;
});
parcelHelpers.export(exports, "addConsoleInstrumentationHandler", function() {
    return 0, _consoleJs1.addConsoleInstrumentationHandler;
});
parcelHelpers.export(exports, "addFetchEndInstrumentationHandler", function() {
    return 0, _fetchJs1.addFetchEndInstrumentationHandler;
});
parcelHelpers.export(exports, "addFetchInstrumentationHandler", function() {
    return 0, _fetchJs1.addFetchInstrumentationHandler;
});
parcelHelpers.export(exports, "addGlobalErrorInstrumentationHandler", function() {
    return 0, _globalErrorJs.addGlobalErrorInstrumentationHandler;
});
parcelHelpers.export(exports, "addGlobalUnhandledRejectionInstrumentationHandler", function() {
    return 0, _globalUnhandledRejectionJs.addGlobalUnhandledRejectionInstrumentationHandler;
});
parcelHelpers.export(exports, "addHandler", function() {
    return 0, _handlersJs.addHandler;
});
parcelHelpers.export(exports, "maybeInstrument", function() {
    return 0, _handlersJs.maybeInstrument;
});
parcelHelpers.export(exports, "resetInstrumentationHandlers", function() {
    return 0, _handlersJs.resetInstrumentationHandlers;
});
parcelHelpers.export(exports, "triggerHandlers", function() {
    return 0, _handlersJs.triggerHandlers;
});
parcelHelpers.export(exports, "isDOMError", function() {
    return 0, _isJs.isDOMError;
});
parcelHelpers.export(exports, "isDOMException", function() {
    return 0, _isJs.isDOMException;
});
parcelHelpers.export(exports, "isElement", function() {
    return 0, _isJs.isElement;
});
parcelHelpers.export(exports, "isError", function() {
    return 0, _isJs.isError;
});
parcelHelpers.export(exports, "isErrorEvent", function() {
    return 0, _isJs.isErrorEvent;
});
parcelHelpers.export(exports, "isEvent", function() {
    return 0, _isJs.isEvent;
});
parcelHelpers.export(exports, "isInstanceOf", function() {
    return 0, _isJs.isInstanceOf;
});
parcelHelpers.export(exports, "isParameterizedString", function() {
    return 0, _isJs.isParameterizedString;
});
parcelHelpers.export(exports, "isPlainObject", function() {
    return 0, _isJs.isPlainObject;
});
parcelHelpers.export(exports, "isPrimitive", function() {
    return 0, _isJs.isPrimitive;
});
parcelHelpers.export(exports, "isRegExp", function() {
    return 0, _isJs.isRegExp;
});
parcelHelpers.export(exports, "isString", function() {
    return 0, _isJs.isString;
});
parcelHelpers.export(exports, "isSyntheticEvent", function() {
    return 0, _isJs.isSyntheticEvent;
});
parcelHelpers.export(exports, "isThenable", function() {
    return 0, _isJs.isThenable;
});
parcelHelpers.export(exports, "isVueViewModel", function() {
    return 0, _isJs.isVueViewModel;
});
parcelHelpers.export(exports, "isBrowser", function() {
    return 0, _isBrowserJs.isBrowser;
});
parcelHelpers.export(exports, "CONSOLE_LEVELS", function() {
    return 0, _debugLoggerJs.CONSOLE_LEVELS;
});
parcelHelpers.export(exports, "consoleSandbox", function() {
    return 0, _debugLoggerJs.consoleSandbox;
});
parcelHelpers.export(exports, "debug", function() {
    return 0, _debugLoggerJs.debug;
});
parcelHelpers.export(exports, "originalConsoleMethods", function() {
    return 0, _debugLoggerJs.originalConsoleMethods;
});
parcelHelpers.export(exports, "addContextToFrame", function() {
    return 0, _miscJs.addContextToFrame;
});
parcelHelpers.export(exports, "addExceptionMechanism", function() {
    return 0, _miscJs.addExceptionMechanism;
});
parcelHelpers.export(exports, "addExceptionTypeValue", function() {
    return 0, _miscJs.addExceptionTypeValue;
});
parcelHelpers.export(exports, "checkOrSetAlreadyCaught", function() {
    return 0, _miscJs.checkOrSetAlreadyCaught;
});
parcelHelpers.export(exports, "getEventDescription", function() {
    return 0, _miscJs.getEventDescription;
});
parcelHelpers.export(exports, "parseSemver", function() {
    return 0, _miscJs.parseSemver;
});
parcelHelpers.export(exports, "uuid4", function() {
    return 0, _miscJs.uuid4;
});
parcelHelpers.export(exports, "isNodeEnv", function() {
    return 0, _nodeJs.isNodeEnv;
});
parcelHelpers.export(exports, "loadModule", function() {
    return 0, _nodeJs.loadModule;
});
parcelHelpers.export(exports, "normalize", function() {
    return 0, _normalizeJs.normalize;
});
parcelHelpers.export(exports, "normalizeToSize", function() {
    return 0, _normalizeJs.normalizeToSize;
});
parcelHelpers.export(exports, "normalizeUrlToBase", function() {
    return 0, _normalizeJs.normalizeUrlToBase;
});
parcelHelpers.export(exports, "addNonEnumerableProperty", function() {
    return 0, _objectJs.addNonEnumerableProperty;
});
parcelHelpers.export(exports, "convertToPlainObject", function() {
    return 0, _objectJs.convertToPlainObject;
});
parcelHelpers.export(exports, "dropUndefinedKeys", function() {
    return 0, _objectJs.dropUndefinedKeys;
});
parcelHelpers.export(exports, "extractExceptionKeysForMessage", function() {
    return 0, _objectJs.extractExceptionKeysForMessage;
});
parcelHelpers.export(exports, "fill", function() {
    return 0, _objectJs.fill;
});
parcelHelpers.export(exports, "getOriginalFunction", function() {
    return 0, _objectJs.getOriginalFunction;
});
parcelHelpers.export(exports, "markFunctionWrapped", function() {
    return 0, _objectJs.markFunctionWrapped;
});
parcelHelpers.export(exports, "objectify", function() {
    return 0, _objectJs.objectify;
});
parcelHelpers.export(exports, "basename", function() {
    return 0, _pathJs.basename;
});
parcelHelpers.export(exports, "dirname", function() {
    return 0, _pathJs.dirname;
});
parcelHelpers.export(exports, "isAbsolute", function() {
    return 0, _pathJs.isAbsolute;
});
parcelHelpers.export(exports, "join", function() {
    return 0, _pathJs.join;
});
parcelHelpers.export(exports, "normalizePath", function() {
    return 0, _pathJs.normalizePath;
});
parcelHelpers.export(exports, "relative", function() {
    return 0, _pathJs.relative;
});
parcelHelpers.export(exports, "resolve", function() {
    return 0, _pathJs.resolve;
});
parcelHelpers.export(exports, "SENTRY_BUFFER_FULL_ERROR", function() {
    return 0, _promisebufferJs.SENTRY_BUFFER_FULL_ERROR;
});
parcelHelpers.export(exports, "makePromiseBuffer", function() {
    return 0, _promisebufferJs.makePromiseBuffer;
});
parcelHelpers.export(exports, "severityLevelFromString", function() {
    return 0, _severityJs.severityLevelFromString;
});
parcelHelpers.export(exports, "replaceExports", function() {
    return 0, _exportsJs1.replaceExports;
});
parcelHelpers.export(exports, "UNKNOWN_FUNCTION", function() {
    return 0, _stacktraceJs.UNKNOWN_FUNCTION;
});
parcelHelpers.export(exports, "createStackParser", function() {
    return 0, _stacktraceJs.createStackParser;
});
parcelHelpers.export(exports, "getFramesFromEvent", function() {
    return 0, _stacktraceJs.getFramesFromEvent;
});
parcelHelpers.export(exports, "getFunctionName", function() {
    return 0, _stacktraceJs.getFunctionName;
});
parcelHelpers.export(exports, "stackParserFromStackParserOptions", function() {
    return 0, _stacktraceJs.stackParserFromStackParserOptions;
});
parcelHelpers.export(exports, "stripSentryFramesAndReverse", function() {
    return 0, _stacktraceJs.stripSentryFramesAndReverse;
});
parcelHelpers.export(exports, "filenameIsInApp", function() {
    return 0, _nodeStackTraceJs.filenameIsInApp;
});
parcelHelpers.export(exports, "node", function() {
    return 0, _nodeStackTraceJs.node;
});
parcelHelpers.export(exports, "nodeStackLineParser", function() {
    return 0, _nodeStackTraceJs.nodeStackLineParser;
});
parcelHelpers.export(exports, "isMatchingPattern", function() {
    return 0, _stringJs.isMatchingPattern;
});
parcelHelpers.export(exports, "safeJoin", function() {
    return 0, _stringJs.safeJoin;
});
parcelHelpers.export(exports, "snipLine", function() {
    return 0, _stringJs.snipLine;
});
parcelHelpers.export(exports, "stringMatchesSomePattern", function() {
    return 0, _stringJs.stringMatchesSomePattern;
});
parcelHelpers.export(exports, "truncate", function() {
    return 0, _stringJs.truncate;
});
parcelHelpers.export(exports, "isNativeFunction", function() {
    return 0, _supportsJs.isNativeFunction;
});
parcelHelpers.export(exports, "supportsDOMError", function() {
    return 0, _supportsJs.supportsDOMError;
});
parcelHelpers.export(exports, "supportsDOMException", function() {
    return 0, _supportsJs.supportsDOMException;
});
parcelHelpers.export(exports, "supportsErrorEvent", function() {
    return 0, _supportsJs.supportsErrorEvent;
});
parcelHelpers.export(exports, "supportsFetch", function() {
    return 0, _supportsJs.supportsFetch;
});
parcelHelpers.export(exports, "supportsHistory", function() {
    return 0, _supportsJs.supportsHistory;
});
parcelHelpers.export(exports, "supportsNativeFetch", function() {
    return 0, _supportsJs.supportsNativeFetch;
});
parcelHelpers.export(exports, "supportsReferrerPolicy", function() {
    return 0, _supportsJs.supportsReferrerPolicy;
});
parcelHelpers.export(exports, "supportsReportingObserver", function() {
    return 0, _supportsJs.supportsReportingObserver;
});
parcelHelpers.export(exports, "SyncPromise", function() {
    return 0, _syncpromiseJs.SyncPromise;
});
parcelHelpers.export(exports, "rejectedSyncPromise", function() {
    return 0, _syncpromiseJs.rejectedSyncPromise;
});
parcelHelpers.export(exports, "resolvedSyncPromise", function() {
    return 0, _syncpromiseJs.resolvedSyncPromise;
});
parcelHelpers.export(exports, "browserPerformanceTimeOrigin", function() {
    return 0, _timeJs.browserPerformanceTimeOrigin;
});
parcelHelpers.export(exports, "dateTimestampInSeconds", function() {
    return 0, _timeJs.dateTimestampInSeconds;
});
parcelHelpers.export(exports, "timestampInSeconds", function() {
    return 0, _timeJs.timestampInSeconds;
});
parcelHelpers.export(exports, "TRACEPARENT_REGEXP", function() {
    return 0, _tracingJs.TRACEPARENT_REGEXP;
});
parcelHelpers.export(exports, "extractTraceparentData", function() {
    return 0, _tracingJs.extractTraceparentData;
});
parcelHelpers.export(exports, "generateSentryTraceHeader", function() {
    return 0, _tracingJs.generateSentryTraceHeader;
});
parcelHelpers.export(exports, "propagationContextFromHeaders", function() {
    return 0, _tracingJs.propagationContextFromHeaders;
});
parcelHelpers.export(exports, "shouldContinueTrace", function() {
    return 0, _tracingJs.shouldContinueTrace;
});
parcelHelpers.export(exports, "getSDKSource", function() {
    return 0, _envJs.getSDKSource;
});
parcelHelpers.export(exports, "isBrowserBundle", function() {
    return 0, _envJs.isBrowserBundle;
});
parcelHelpers.export(exports, "addItemToEnvelope", function() {
    return 0, _envelopeJs1.addItemToEnvelope;
});
parcelHelpers.export(exports, "createAttachmentEnvelopeItem", function() {
    return 0, _envelopeJs1.createAttachmentEnvelopeItem;
});
parcelHelpers.export(exports, "createEnvelope", function() {
    return 0, _envelopeJs1.createEnvelope;
});
parcelHelpers.export(exports, "createEventEnvelopeHeaders", function() {
    return 0, _envelopeJs1.createEventEnvelopeHeaders;
});
parcelHelpers.export(exports, "createSpanEnvelopeItem", function() {
    return 0, _envelopeJs1.createSpanEnvelopeItem;
});
parcelHelpers.export(exports, "envelopeContainsItemType", function() {
    return 0, _envelopeJs1.envelopeContainsItemType;
});
parcelHelpers.export(exports, "envelopeItemTypeToDataCategory", function() {
    return 0, _envelopeJs1.envelopeItemTypeToDataCategory;
});
parcelHelpers.export(exports, "forEachEnvelopeItem", function() {
    return 0, _envelopeJs1.forEachEnvelopeItem;
});
parcelHelpers.export(exports, "getSdkMetadataForEnvelopeHeader", function() {
    return 0, _envelopeJs1.getSdkMetadataForEnvelopeHeader;
});
parcelHelpers.export(exports, "parseEnvelope", function() {
    return 0, _envelopeJs1.parseEnvelope;
});
parcelHelpers.export(exports, "serializeEnvelope", function() {
    return 0, _envelopeJs1.serializeEnvelope;
});
parcelHelpers.export(exports, "createClientReportEnvelope", function() {
    return 0, _clientreportJs.createClientReportEnvelope;
});
parcelHelpers.export(exports, "DEFAULT_RETRY_AFTER", function() {
    return 0, _ratelimitJs.DEFAULT_RETRY_AFTER;
});
parcelHelpers.export(exports, "disabledUntil", function() {
    return 0, _ratelimitJs.disabledUntil;
});
parcelHelpers.export(exports, "isRateLimited", function() {
    return 0, _ratelimitJs.isRateLimited;
});
parcelHelpers.export(exports, "parseRetryAfterHeader", function() {
    return 0, _ratelimitJs.parseRetryAfterHeader;
});
parcelHelpers.export(exports, "updateRateLimits", function() {
    return 0, _ratelimitJs.updateRateLimits;
});
parcelHelpers.export(exports, "MAX_BAGGAGE_STRING_LENGTH", function() {
    return 0, _baggageJs.MAX_BAGGAGE_STRING_LENGTH;
});
parcelHelpers.export(exports, "SENTRY_BAGGAGE_KEY_PREFIX", function() {
    return 0, _baggageJs.SENTRY_BAGGAGE_KEY_PREFIX;
});
parcelHelpers.export(exports, "SENTRY_BAGGAGE_KEY_PREFIX_REGEX", function() {
    return 0, _baggageJs.SENTRY_BAGGAGE_KEY_PREFIX_REGEX;
});
parcelHelpers.export(exports, "baggageHeaderToDynamicSamplingContext", function() {
    return 0, _baggageJs.baggageHeaderToDynamicSamplingContext;
});
parcelHelpers.export(exports, "dynamicSamplingContextToSentryBaggageHeader", function() {
    return 0, _baggageJs.dynamicSamplingContextToSentryBaggageHeader;
});
parcelHelpers.export(exports, "objectToBaggageHeader", function() {
    return 0, _baggageJs.objectToBaggageHeader;
});
parcelHelpers.export(exports, "parseBaggageHeader", function() {
    return 0, _baggageJs.parseBaggageHeader;
});
parcelHelpers.export(exports, "getHttpSpanDetailsFromUrlObject", function() {
    return 0, _urlJs.getHttpSpanDetailsFromUrlObject;
});
parcelHelpers.export(exports, "getSanitizedUrlString", function() {
    return 0, _urlJs.getSanitizedUrlString;
});
parcelHelpers.export(exports, "getSanitizedUrlStringFromUrlObject", function() {
    return 0, _urlJs.getSanitizedUrlStringFromUrlObject;
});
parcelHelpers.export(exports, "isURLObjectRelative", function() {
    return 0, _urlJs.isURLObjectRelative;
});
parcelHelpers.export(exports, "parseStringToURLObject", function() {
    return 0, _urlJs.parseStringToURLObject;
});
parcelHelpers.export(exports, "parseUrl", function() {
    return 0, _urlJs.parseUrl;
});
parcelHelpers.export(exports, "stripUrlQueryAndFragment", function() {
    return 0, _urlJs.stripUrlQueryAndFragment;
});
parcelHelpers.export(exports, "eventFromMessage", function() {
    return 0, _eventbuilderJs.eventFromMessage;
});
parcelHelpers.export(exports, "eventFromUnknownInput", function() {
    return 0, _eventbuilderJs.eventFromUnknownInput;
});
parcelHelpers.export(exports, "exceptionFromError", function() {
    return 0, _eventbuilderJs.exceptionFromError;
});
parcelHelpers.export(exports, "parseStackFrames", function() {
    return 0, _eventbuilderJs.parseStackFrames;
});
parcelHelpers.export(exports, "callFrameToStackFrame", function() {
    return 0, _anrJs.callFrameToStackFrame;
});
parcelHelpers.export(exports, "watchdogTimer", function() {
    return 0, _anrJs.watchdogTimer;
});
parcelHelpers.export(exports, "LRUMap", function() {
    return 0, _lruJs.LRUMap;
});
parcelHelpers.export(exports, "generateSpanId", function() {
    return 0, _propagationContextJs.generateSpanId;
});
parcelHelpers.export(exports, "generateTraceId", function() {
    return 0, _propagationContextJs.generateTraceId;
});
parcelHelpers.export(exports, "vercelWaitUntil", function() {
    return 0, _vercelWaitUntilJs.vercelWaitUntil;
});
parcelHelpers.export(exports, "flushIfServerless", function() {
    return 0, _flushIfServerlessJs.flushIfServerless;
});
parcelHelpers.export(exports, "SDK_VERSION", function() {
    return 0, _versionJs.SDK_VERSION;
});
parcelHelpers.export(exports, "getDebugImagesForResources", function() {
    return 0, _debugIdsJs.getDebugImagesForResources;
});
parcelHelpers.export(exports, "getFilenameToDebugIdMap", function() {
    return 0, _debugIdsJs.getFilenameToDebugIdMap;
});
parcelHelpers.export(exports, "escapeStringForRegex", function() {
    return 0, _escapeStringForRegexJs.escapeStringForRegex;
});
parcelHelpers.export(exports, "logger", function() {
    return _publicApiJs;
});
parcelHelpers.export(exports, "metrics", function() {
    return _publicApiJs1;
});
var _errorsJs = require("./tracing/errors.js");
var _utilsJs = require("./tracing/utils.js");
var _idleSpanJs = require("./tracing/idleSpan.js");
var _sentrySpanJs = require("./tracing/sentrySpan.js");
var _sentryNonRecordingSpanJs = require("./tracing/sentryNonRecordingSpan.js");
var _spanstatusJs = require("./tracing/spanstatus.js");
var _traceJs = require("./tracing/trace.js");
var _dynamicSamplingContextJs = require("./tracing/dynamicSamplingContext.js");
var _measurementJs = require("./tracing/measurement.js");
var _samplingJs = require("./tracing/sampling.js");
var _logSpansJs = require("./tracing/logSpans.js");
var _semanticAttributesJs = require("./semanticAttributes.js");
var _envelopeJs = require("./envelope.js");
var _exportsJs = require("./exports.js");
var _currentScopesJs = require("./currentScopes.js");
var _defaultScopesJs = require("./defaultScopes.js");
var _indexJs = require("./asyncContext/index.js");
var _carrierJs = require("./carrier.js");
var _sessionJs = require("./session.js");
var _scopeJs = require("./scope.js");
var _eventProcessorsJs = require("./eventProcessors.js");
var _apiJs = require("./api.js");
var _clientJs = require("./client.js");
var _serverRuntimeClientJs = require("./server-runtime-client.js");
var _sdkJs = require("./sdk.js");
var _baseJs = require("./transports/base.js");
var _offlineJs = require("./transports/offline.js");
var _multiplexedJs = require("./transports/multiplexed.js");
var _integrationJs = require("./integration.js");
var _providerSkipJs = require("./utils/ai/providerSkip.js");
var _applyScopeDataToEventJs = require("./utils/applyScopeDataToEvent.js");
var _prepareEventJs = require("./utils/prepareEvent.js");
var _checkinJs = require("./checkin.js");
var _hasSpansEnabledJs = require("./utils/hasSpansEnabled.js");
var _isSentryRequestUrlJs = require("./utils/isSentryRequestUrl.js");
var _handleCallbackErrorsJs = require("./utils/handleCallbackErrors.js");
var _parameterizeJs = require("./utils/parameterize.js");
var _ipAddressJs = require("./utils/ipAddress.js");
var _spanUtilsJs = require("./utils/spanUtils.js");
var _spanOnScopeJs = require("./utils/spanOnScope.js");
var _parseSampleRateJs = require("./utils/parseSampleRate.js");
var _sdkMetadataJs = require("./utils/sdkMetadata.js");
var _traceDataJs = require("./utils/traceData.js");
var _metaJs = require("./utils/meta.js");
var _debounceJs = require("./utils/debounce.js");
var _requestJs = require("./utils/request.js");
var _constantsJs = require("./constants.js");
var _breadcrumbsJs = require("./breadcrumbs.js");
var _functiontostringJs = require("./integrations/functiontostring.js");
var _eventFiltersJs = require("./integrations/eventFilters.js");
var _linkederrorsJs = require("./integrations/linkederrors.js");
var _moduleMetadataJs = require("./integrations/moduleMetadata.js");
var _requestdataJs = require("./integrations/requestdata.js");
var _captureconsoleJs = require("./integrations/captureconsole.js");
var _dedupeJs = require("./integrations/dedupe.js");
var _extraerrordataJs = require("./integrations/extraerrordata.js");
var _rewriteframesJs = require("./integrations/rewriteframes.js");
var _supabaseJs = require("./integrations/supabase.js");
var _zoderrorsJs = require("./integrations/zoderrors.js");
var _thirdPartyErrorsFilterJs = require("./integrations/third-party-errors-filter.js");
var _consoleJs = require("./integrations/console.js");
var _featureFlagsIntegrationJs = require("./integrations/featureFlags/featureFlagsIntegration.js");
var _growthbookJs = require("./integrations/featureFlags/growthbook.js");
var _profilingJs = require("./profiling.js");
var _fetchJs = require("./fetch.js");
var _trpcJs = require("./trpc.js");
var _indexJs1 = require("./integrations/mcp-server/index.js");
var _feedbackJs = require("./feedback.js");
var _internalJs = require("./logs/internal.js");
var _publicApiJs = require("./logs/public-api.js");
var _consoleIntegrationJs = require("./logs/console-integration.js");
var _internalJs1 = require("./metrics/internal.js");
var _publicApiJs1 = require("./metrics/public-api.js");
var _consolaJs = require("./integrations/consola.js");
var _indexJs2 = require("./tracing/vercel-ai/index.js");
var _utilsJs1 = require("./tracing/vercel-ai/utils.js");
var _indexJs3 = require("./tracing/openai/index.js");
var _constantsJs1 = require("./tracing/openai/constants.js");
var _indexJs4 = require("./tracing/anthropic-ai/index.js");
var _constantsJs2 = require("./tracing/anthropic-ai/constants.js");
var _indexJs5 = require("./tracing/google-genai/index.js");
var _constantsJs3 = require("./tracing/google-genai/constants.js");
var _indexJs6 = require("./tracing/langchain/index.js");
var _constantsJs4 = require("./tracing/langchain/constants.js");
var _indexJs7 = require("./tracing/langgraph/index.js");
var _constantsJs5 = require("./tracing/langgraph/constants.js");
var _featureFlagsJs = require("./utils/featureFlags.js");
var _aggregateErrorsJs = require("./utils/aggregate-errors.js");
var _breadcrumbLogLevelJs = require("./utils/breadcrumb-log-level.js");
var _browserJs = require("./utils/browser.js");
var _dsnJs = require("./utils/dsn.js");
var _errorJs = require("./utils/error.js");
var _worldwideJs = require("./utils/worldwide.js");
var _consoleJs1 = require("./instrument/console.js");
var _fetchJs1 = require("./instrument/fetch.js");
var _globalErrorJs = require("./instrument/globalError.js");
var _globalUnhandledRejectionJs = require("./instrument/globalUnhandledRejection.js");
var _handlersJs = require("./instrument/handlers.js");
var _isJs = require("./utils/is.js");
var _isBrowserJs = require("./utils/isBrowser.js");
var _debugLoggerJs = require("./utils/debug-logger.js");
var _miscJs = require("./utils/misc.js");
var _nodeJs = require("./utils/node.js");
var _normalizeJs = require("./utils/normalize.js");
var _objectJs = require("./utils/object.js");
var _pathJs = require("./utils/path.js");
var _promisebufferJs = require("./utils/promisebuffer.js");
var _severityJs = require("./utils/severity.js");
var _exportsJs1 = require("./utils/exports.js");
var _stacktraceJs = require("./utils/stacktrace.js");
var _nodeStackTraceJs = require("./utils/node-stack-trace.js");
var _stringJs = require("./utils/string.js");
var _supportsJs = require("./utils/supports.js");
var _syncpromiseJs = require("./utils/syncpromise.js");
var _timeJs = require("./utils/time.js");
var _tracingJs = require("./utils/tracing.js");
var _envJs = require("./utils/env.js");
var _envelopeJs1 = require("./utils/envelope.js");
var _clientreportJs = require("./utils/clientreport.js");
var _ratelimitJs = require("./utils/ratelimit.js");
var _baggageJs = require("./utils/baggage.js");
var _urlJs = require("./utils/url.js");
var _eventbuilderJs = require("./utils/eventbuilder.js");
var _anrJs = require("./utils/anr.js");
var _lruJs = require("./utils/lru.js");
var _propagationContextJs = require("./utils/propagationContext.js");
var _vercelWaitUntilJs = require("./utils/vercelWaitUntil.js");
var _flushIfServerlessJs = require("./utils/flushIfServerless.js");
var _versionJs = require("./utils/version.js");
var _debugIdsJs = require("./utils/debug-ids.js");
var _escapeStringForRegexJs = require("./vendor/escapeStringForRegex.js");

},{"./tracing/errors.js":false,"./tracing/utils.js":false,"./tracing/idleSpan.js":false,"./tracing/sentrySpan.js":false,"./tracing/sentryNonRecordingSpan.js":false,"./tracing/spanstatus.js":false,"./tracing/trace.js":false,"./tracing/dynamicSamplingContext.js":"3oEzR","./tracing/measurement.js":false,"./tracing/sampling.js":false,"./tracing/logSpans.js":false,"./semanticAttributes.js":false,"./envelope.js":false,"./exports.js":"ggsl8","./currentScopes.js":"3SsyM","./defaultScopes.js":false,"./asyncContext/index.js":false,"./carrier.js":false,"./session.js":false,"./scope.js":false,"./eventProcessors.js":false,"./api.js":false,"./client.js":false,"./server-runtime-client.js":false,"./sdk.js":false,"./transports/base.js":false,"./transports/offline.js":false,"./transports/multiplexed.js":false,"./integration.js":false,"./utils/ai/providerSkip.js":false,"./utils/applyScopeDataToEvent.js":false,"./utils/prepareEvent.js":"gw3Kv","./checkin.js":false,"./utils/hasSpansEnabled.js":false,"./utils/isSentryRequestUrl.js":"tQSqJ","./utils/handleCallbackErrors.js":false,"./utils/parameterize.js":false,"./utils/ipAddress.js":false,"./utils/spanUtils.js":"3Vkzh","./utils/spanOnScope.js":false,"./utils/parseSampleRate.js":"gTH0Z","./utils/sdkMetadata.js":false,"./utils/traceData.js":false,"./utils/meta.js":false,"./utils/debounce.js":"bU7tT","./utils/request.js":false,"./constants.js":false,"./breadcrumbs.js":"fJCGb","./integrations/functiontostring.js":false,"./integrations/eventFilters.js":false,"./integrations/linkederrors.js":false,"./integrations/moduleMetadata.js":false,"./integrations/requestdata.js":false,"./integrations/captureconsole.js":false,"./integrations/dedupe.js":false,"./integrations/extraerrordata.js":false,"./integrations/rewriteframes.js":false,"./integrations/supabase.js":false,"./integrations/zoderrors.js":false,"./integrations/third-party-errors-filter.js":false,"./integrations/console.js":false,"./integrations/featureFlags/featureFlagsIntegration.js":false,"./integrations/featureFlags/growthbook.js":false,"./profiling.js":false,"./fetch.js":false,"./trpc.js":false,"./integrations/mcp-server/index.js":false,"./feedback.js":false,"./logs/internal.js":false,"./logs/public-api.js":false,"./logs/console-integration.js":false,"./metrics/internal.js":false,"./metrics/public-api.js":false,"./integrations/consola.js":false,"./tracing/vercel-ai/index.js":false,"./tracing/vercel-ai/utils.js":false,"./tracing/openai/index.js":false,"./tracing/openai/constants.js":false,"./tracing/anthropic-ai/index.js":false,"./tracing/anthropic-ai/constants.js":false,"./tracing/google-genai/index.js":false,"./tracing/google-genai/constants.js":false,"./tracing/langchain/index.js":false,"./tracing/langchain/constants.js":false,"./tracing/langgraph/index.js":false,"./tracing/langgraph/constants.js":false,"./utils/featureFlags.js":false,"./utils/aggregate-errors.js":false,"./utils/breadcrumb-log-level.js":false,"./utils/browser.js":"kuwFX","./utils/dsn.js":false,"./utils/error.js":false,"./utils/worldwide.js":"05aQd","./instrument/console.js":false,"./instrument/fetch.js":false,"./instrument/globalError.js":false,"./instrument/globalUnhandledRejection.js":false,"./instrument/handlers.js":false,"./utils/is.js":false,"./utils/isBrowser.js":"3n3zH","./utils/debug-logger.js":"7EizD","./utils/misc.js":"363eC","./utils/node.js":false,"./utils/normalize.js":"8EOdt","./utils/object.js":"fwaBi","./utils/path.js":false,"./utils/promisebuffer.js":false,"./utils/severity.js":"6RYho","./utils/exports.js":false,"./utils/stacktrace.js":false,"./utils/node-stack-trace.js":false,"./utils/string.js":"c9ata","./utils/supports.js":false,"./utils/syncpromise.js":false,"./utils/time.js":"eCVqZ","./utils/tracing.js":false,"./utils/env.js":false,"./utils/envelope.js":"9Uq9n","./utils/clientreport.js":false,"./utils/ratelimit.js":"iYQ03","./utils/baggage.js":false,"./utils/url.js":false,"./utils/eventbuilder.js":false,"./utils/anr.js":false,"./utils/lru.js":false,"./utils/propagationContext.js":false,"./utils/vercelWaitUntil.js":false,"./utils/flushIfServerless.js":false,"./utils/version.js":false,"./utils/debug-ids.js":false,"./vendor/escapeStringForRegex.js":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"l773i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCapturedScopesOnSpan", function() {
    return getCapturedScopesOnSpan;
});
parcelHelpers.export(exports, "setCapturedScopesOnSpan", function() {
    return setCapturedScopesOnSpan;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _objectJs = require("../utils/object.js");
var _worldwideJs = require("../utils/worldwide.js");
var SCOPE_ON_START_SPAN_FIELD = '_sentryScope';
var ISOLATION_SCOPE_ON_START_SPAN_FIELD = '_sentryIsolationScope';
/** Wrap a scope with a WeakRef if available, falling back to a direct scope. */ function wrapScopeWithWeakRef(scope) {
    try {
        // @ts-expect-error - WeakRef is not available in all environments
        var WeakRefClass = (0, _worldwideJs.GLOBAL_OBJ).WeakRef;
        if (typeof WeakRefClass === 'function') return new WeakRefClass(scope);
    } catch (e) {
    // WeakRef not available or failed to create
    // We'll fall back to a direct scope
    }
    return scope;
}
/** Try to unwrap a scope from a potential WeakRef wrapper. */ function unwrapScopeFromWeakRef(scopeRef) {
    if (!scopeRef) return undefined;
    if ((typeof scopeRef === "undefined" ? "undefined" : (0, _typeOf._)(scopeRef)) === 'object' && 'deref' in scopeRef && typeof scopeRef.deref === 'function') try {
        return scopeRef.deref();
    } catch (e) {
        return undefined;
    }
    // Fallback to a direct scope
    return scopeRef;
}
/** Store the scope & isolation scope for a span, which can the be used when it is finished. */ function setCapturedScopesOnSpan(span, scope, isolationScope) {
    if (span) {
        (0, _objectJs.addNonEnumerableProperty)(span, ISOLATION_SCOPE_ON_START_SPAN_FIELD, wrapScopeWithWeakRef(isolationScope));
        // We don't wrap the scope with a WeakRef here because webkit aggressively garbage collects
        // and scopes are not held in memory for long periods of time.
        (0, _objectJs.addNonEnumerableProperty)(span, SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 * If WeakRef was used and scopes have been garbage collected, returns undefined for those scopes.
 */ function getCapturedScopesOnSpan(span) {
    var spanWithScopes = span;
    return {
        scope: spanWithScopes[SCOPE_ON_START_SPAN_FIELD],
        isolationScope: unwrapScopeFromWeakRef(spanWithScopes[ISOLATION_SCOPE_ON_START_SPAN_FIELD])
    };
}

},{"@swc/helpers/_/_type_of":"iFJdx","../utils/object.js":"fwaBi","../utils/worldwide.js":"05aQd","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fwaBi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addNonEnumerableProperty", function() {
    return addNonEnumerableProperty;
});
parcelHelpers.export(exports, "convertToPlainObject", function() {
    return convertToPlainObject;
});
parcelHelpers.export(exports, "dropUndefinedKeys", function() {
    return dropUndefinedKeys;
});
parcelHelpers.export(exports, "extractExceptionKeysForMessage", function() {
    return extractExceptionKeysForMessage;
});
parcelHelpers.export(exports, "fill", function() {
    return fill;
});
parcelHelpers.export(exports, "getOriginalFunction", function() {
    return getOriginalFunction;
});
parcelHelpers.export(exports, "markFunctionWrapped", function() {
    return markFunctionWrapped;
});
parcelHelpers.export(exports, "objectify", function() {
    return objectify;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _typeOf = require("@swc/helpers/_/_type_of");
var _debugBuildJs = require("../debug-build.js");
var _browserJs = require("./browser.js");
var _debugLoggerJs = require("./debug-logger.js");
var _isJs = require("./is.js");
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Replace a method in an object with a wrapped version of itself.
 *
 * If the method on the passed object is not a function, the wrapper will not be applied.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function fill(source, name, replacementFactory) {
    if (!(name in source)) return;
    // explicitly casting to unknown because we don't know the type of the method initially at all
    var original = source[name];
    if (typeof original !== 'function') return;
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') markFunctionWrapped(wrapped, original);
    try {
        source[name] = wrapped;
    } catch (e) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log('Failed to replace method "'.concat(name, '" in object'), source);
    }
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function addNonEnumerableProperty(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (e) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log('Failed to add non-enumerable property "'.concat(name, '" to object'), obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function markFunctionWrapped(wrapped, original) {
    try {
        var proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        addNonEnumerableProperty(wrapped, '__sentry_original__', original);
    } catch (e) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function getOriginalFunction(func) {
    return func.__sentry_original__;
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argument itself, when value is neither an Event nor
 *  an Error.
 */ function convertToPlainObject(value) {
    if ((0, _isJs.isError)(value)) return (0, _objectSpread._)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, getOwnProperties(value));
    else if ((0, _isJs.isEvent)(value)) {
        var newObj = (0, _objectSpread._)({
            type: value.type,
            target: serializeEventTarget(value.target),
            currentTarget: serializeEventTarget(value.currentTarget)
        }, getOwnProperties(value));
        if (typeof CustomEvent !== 'undefined' && (0, _isJs.isInstanceOf)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function serializeEventTarget(target) {
    try {
        return (0, _isJs.isElement)(target) ? (0, _browserJs.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (e) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function getOwnProperties(obj) {
    if ((typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj)) === 'object' && obj !== null) {
        var extractedProps = {};
        for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function extractExceptionKeysForMessage(exception) {
    var keys = Object.keys(convertToPlainObject(exception));
    keys.sort();
    return !keys[0] ? '[object has no keys]' : keys.join(', ');
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 *
 * @deprecated This function is no longer used by the SDK and will be removed in a future major version.
 */ function dropUndefinedKeys(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    var memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return _dropUndefinedKeys(inputValue, memoizationMap);
}
function _dropUndefinedKeys(inputValue, memoizationMap) {
    // Early return for primitive values
    if (inputValue === null || (typeof inputValue === "undefined" ? "undefined" : (0, _typeOf._)(inputValue)) !== 'object') return inputValue;
    // Check memo map first for all object types
    var memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) return memoVal;
    // handle arrays
    if (Array.isArray(inputValue)) {
        var returnValue = [];
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach(function(value) {
            returnValue.push(_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if (isPojo(inputValue)) {
        var returnValue1 = {};
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue1);
        var keys = Object.keys(inputValue);
        keys.forEach(function(key) {
            var val = inputValue[key];
            if (val !== undefined) returnValue1[key] = _dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue1;
    }
    // For other object types, return as is
    return inputValue;
}
function isPojo(input) {
    // Plain objects have Object as constructor or no constructor
    var constructor = input.constructor;
    return constructor === Object || constructor === undefined;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function objectify(wat) {
    var objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == undefined:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case (typeof wat === "undefined" ? "undefined" : (0, _typeOf._)(wat)) === 'symbol' || (typeof wat === "undefined" ? "undefined" : (0, _typeOf._)(wat)) === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, _isJs.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_type_of":"iFJdx","../debug-build.js":"2P3sP","./browser.js":"kuwFX","./debug-logger.js":"7EizD","./is.js":"aNXcg","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2P3sP":[function(require,module,exports,__globalThis) {
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEBUG_BUILD", function() {
    return DEBUG_BUILD;
});
var DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kuwFX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getComponentName", function() {
    return getComponentName;
});
parcelHelpers.export(exports, "getLocationHref", function() {
    return getLocationHref;
});
parcelHelpers.export(exports, "htmlTreeAsString", function() {
    return htmlTreeAsString;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
var _isJs = require("./is.js");
var _worldwideJs = require("./worldwide.js");
var WINDOW = (0, _worldwideJs.GLOBAL_OBJ);
var DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function htmlTreeAsString(elem) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!elem) return '<unknown>';
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr;
        var keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        var maxStringLength = !Array.isArray(options) && options.maxStringLength || DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = _htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (e) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function _htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    if (!(elem === null || elem === void 0 ? void 0 : elem.tagName)) return '';
    // @ts-expect-error WINDOW has HTMLElement
    if (WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if ((0, _instanceof._)(elem, HTMLElement) && elem.dataset) {
            if (elem.dataset['sentryComponent']) return elem.dataset['sentryComponent'];
            if (elem.dataset['sentryElement']) return elem.dataset['sentryElement'];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = (keyAttrs === null || keyAttrs === void 0 ? void 0 : keyAttrs.length) ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs === null || keyAttrPairs === void 0 ? void 0 : keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push("[".concat(keyAttrPair[0], '="').concat(keyAttrPair[1], '"]'));
    });
    else {
        if (elem.id) out.push("#".concat(elem.id));
        var className = elem.className;
        if (className && (0, _isJs.isString)(className)) {
            var classes = className.split(/\s+/);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = classes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var c = _step.value;
                    out.push(".".concat(c));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }
    var allowedAttrs = [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ];
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = allowedAttrs[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var k = _step1.value;
            var attr = elem.getAttribute(k);
            if (attr) out.push("[".concat(k, '="').concat(attr, '"]'));
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function getLocationHref() {
    try {
        return WINDOW.document.location.href;
    } catch (e) {
        return '';
    }
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precedence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function getComponentName(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!WINDOW.HTMLElement) return null;
    var currentElem = elem;
    var MAX_TRAVERSE_HEIGHT = 5;
    for(var i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if ((0, _instanceof._)(currentElem, HTMLElement)) {
            if (currentElem.dataset['sentryComponent']) return currentElem.dataset['sentryComponent'];
            if (currentElem.dataset['sentryElement']) return currentElem.dataset['sentryElement'];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}

},{"@swc/helpers/_/_instanceof":"h9UKc","./is.js":"aNXcg","./worldwide.js":"05aQd","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aNXcg":[function(require,module,exports,__globalThis) {
// eslint-disable-next-line @typescript-eslint/unbound-method
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isDOMError", function() {
    return isDOMError;
});
parcelHelpers.export(exports, "isDOMException", function() {
    return isDOMException;
});
parcelHelpers.export(exports, "isElement", function() {
    return isElement;
});
parcelHelpers.export(exports, "isError", function() {
    return isError;
});
parcelHelpers.export(exports, "isErrorEvent", function() {
    return isErrorEvent;
});
parcelHelpers.export(exports, "isEvent", function() {
    return isEvent;
});
parcelHelpers.export(exports, "isInstanceOf", function() {
    return isInstanceOf;
});
parcelHelpers.export(exports, "isParameterizedString", function() {
    return isParameterizedString;
});
parcelHelpers.export(exports, "isPlainObject", function() {
    return isPlainObject;
});
parcelHelpers.export(exports, "isPrimitive", function() {
    return isPrimitive;
});
parcelHelpers.export(exports, "isRegExp", function() {
    return isRegExp;
});
parcelHelpers.export(exports, "isRequest", function() {
    return isRequest;
});
parcelHelpers.export(exports, "isString", function() {
    return isString;
});
parcelHelpers.export(exports, "isSyntheticEvent", function() {
    return isSyntheticEvent;
});
parcelHelpers.export(exports, "isThenable", function() {
    return isThenable;
});
parcelHelpers.export(exports, "isVueViewModel", function() {
    return isVueViewModel;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
var _typeOf = require("@swc/helpers/_/_type_of");
var objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isError(wat) {
    switch(objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
        case '[object WebAssembly.Exception]':
            return true;
        default:
            return isInstanceOf(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function isBuiltin(wat, className) {
    return objectToString.call(wat) === "[object ".concat(className, "]");
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isErrorEvent(wat) {
    return isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isDOMError(wat) {
    return isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isDOMException(wat) {
    return isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isString(wat) {
    return isBuiltin(wat, 'String');
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isParameterizedString(wat) {
    return (typeof wat === "undefined" ? "undefined" : (0, _typeOf._)(wat)) === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isPrimitive(wat) {
    return wat === null || isParameterizedString(wat) || (typeof wat === "undefined" ? "undefined" : (0, _typeOf._)(wat)) !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isPlainObject(wat) {
    return isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isEvent(wat) {
    return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isElement(wat) {
    return typeof Element !== 'undefined' && isInstanceOf(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isRegExp(wat) {
    return isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function isThenable(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean((wat === null || wat === void 0 ? void 0 : wat.then) && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isSyntheticEvent(wat) {
    return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function isInstanceOf(wat, base) {
    try {
        return (0, _instanceof._)(wat, base);
    } catch (e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel or a VNode.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isVueViewModel(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    // We also need to check for __v_isVNode because Vue 3 component render instances have an internal __v_isVNode property.
    return !!((typeof wat === "undefined" ? "undefined" : (0, _typeOf._)(wat)) === 'object' && wat !== null && (wat.__isVue || wat._isVue || wat.__v_isVNode));
}
/**
 * Checks whether the given parameter is a Standard Web API Request instance.
 *
 * Returns false if Request is not available in the current runtime.
 */ function isRequest(request) {
    return typeof Request !== 'undefined' && isInstanceOf(request, Request);
}

},{"@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_type_of":"iFJdx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"05aQd":[function(require,module,exports,__globalThis) {
/** Internal global with common properties and Sentry extensions  */ /** Get's the global object for the current JavaScript runtime */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GLOBAL_OBJ", function() {
    return GLOBAL_OBJ;
});
var GLOBAL_OBJ = globalThis;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7EizD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CONSOLE_LEVELS", function() {
    return CONSOLE_LEVELS;
});
parcelHelpers.export(exports, "consoleSandbox", function() {
    return consoleSandbox;
});
parcelHelpers.export(exports, "debug", function() {
    return debug;
});
parcelHelpers.export(exports, "originalConsoleMethods", function() {
    return originalConsoleMethods;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _carrierJs = require("../carrier.js");
var _debugBuildJs = require("../debug-build.js");
var _worldwideJs = require("./worldwide.js");
var CONSOLE_LEVELS = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/** Prefix for logging strings */ var PREFIX = 'Sentry Logger ';
/** This may be mutated by the console instrumentation. */ var originalConsoleMethods = {};
/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function consoleSandbox(callback) {
    if (!('console' in (0, _worldwideJs.GLOBAL_OBJ))) return callback();
    var console = (0, _worldwideJs.GLOBAL_OBJ).console;
    var wrappedFuncs = {};
    var wrappedLevels = Object.keys(originalConsoleMethods);
    // Restore all wrapped console methods
    wrappedLevels.forEach(function(level) {
        var originalConsoleMethod = originalConsoleMethods[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach(function(level) {
            console[level] = wrappedFuncs[level];
        });
    }
}
function enable() {
    _getLoggerSettings().enabled = true;
}
function disable() {
    _getLoggerSettings().enabled = false;
}
function isEnabled() {
    return _getLoggerSettings().enabled;
}
function log() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    _maybeLog.apply(void 0, [
        'log'
    ].concat((0, _toConsumableArray._)(args)));
}
function warn() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    _maybeLog.apply(void 0, [
        'warn'
    ].concat((0, _toConsumableArray._)(args)));
}
function error() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    _maybeLog.apply(void 0, [
        'error'
    ].concat((0, _toConsumableArray._)(args)));
}
function _maybeLog(level) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    if (!(0, _debugBuildJs.DEBUG_BUILD)) return;
    if (isEnabled()) consoleSandbox(function() {
        var _GLOBAL_OBJ_console;
        (_GLOBAL_OBJ_console = (0, _worldwideJs.GLOBAL_OBJ).console)[level].apply(_GLOBAL_OBJ_console, [
            "".concat(PREFIX, "[").concat(level, "]:")
        ].concat((0, _toConsumableArray._)(args)));
    });
}
function _getLoggerSettings() {
    if (!(0, _debugBuildJs.DEBUG_BUILD)) return {
        enabled: false
    };
    return (0, _carrierJs.getGlobalSingleton)('loggerSettings', function() {
        return {
            enabled: false
        };
    });
}
/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 */ var debug = {
    /** Enable logging. */ enable: enable,
    /** Disable logging. */ disable: disable,
    /** Check if logging is enabled. */ isEnabled: isEnabled,
    /** Log a message. */ log: log,
    /** Log a warning. */ warn: warn,
    /** Log an error. */ error: error
};

},{"@swc/helpers/_/_to_consumable_array":"1eSZf","../carrier.js":"4tZQo","../debug-build.js":"2P3sP","./worldwide.js":"05aQd","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4tZQo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getGlobalSingleton", function() {
    return getGlobalSingleton;
});
parcelHelpers.export(exports, "getMainCarrier", function() {
    return getMainCarrier;
});
parcelHelpers.export(exports, "getSentryCarrier", function() {
    return getSentryCarrier;
});
var _versionJs = require("./utils/version.js");
var _worldwideJs = require("./utils/worldwide.js");
/**
 * An object that contains globally accessible properties and maintains a scope stack.
 * @hidden
 */ /**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function getMainCarrier() {
    // This ensures a Sentry carrier exists
    getSentryCarrier((0, _worldwideJs.GLOBAL_OBJ));
    return 0, _worldwideJs.GLOBAL_OBJ;
}
/** Will either get the existing sentry carrier, or create a new one. */ function getSentryCarrier(carrier) {
    var __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    // For now: First SDK that sets the .version property wins
    __SENTRY__.version = __SENTRY__.version || (0, _versionJs.SDK_VERSION);
    // Intentionally populating and returning the version of "this" SDK instance
    // rather than what's set in .version so that "this" SDK always gets its carrier
    return __SENTRY__[0, _versionJs.SDK_VERSION] = __SENTRY__[0, _versionJs.SDK_VERSION] || {};
}
/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function getGlobalSingleton(name, creator) {
    var obj = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, _worldwideJs.GLOBAL_OBJ);
    var __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    var carrier = __SENTRY__[0, _versionJs.SDK_VERSION] = __SENTRY__[0, _versionJs.SDK_VERSION] || {};
    // Note: We do not want to set `carrier.version` here, as this may be called before any `init` is called, e.g. for the default scopes
    return carrier[name] || (carrier[name] = creator());
}

},{"./utils/version.js":"b2Aag","./utils/worldwide.js":"05aQd","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"b2Aag":[function(require,module,exports,__globalThis) {
// This is a magic string replaced by rollup
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SDK_VERSION", function() {
    return SDK_VERSION;
});
var SDK_VERSION = "10.27.0";

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9BW0F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SPAN_STATUS_ERROR", function() {
    return SPAN_STATUS_ERROR;
});
parcelHelpers.export(exports, "SPAN_STATUS_OK", function() {
    return SPAN_STATUS_OK;
});
parcelHelpers.export(exports, "SPAN_STATUS_UNSET", function() {
    return SPAN_STATUS_UNSET;
});
parcelHelpers.export(exports, "getSpanStatusFromHttpCode", function() {
    return getSpanStatusFromHttpCode;
});
parcelHelpers.export(exports, "setHttpStatus", function() {
    return setHttpStatus;
});
var SPAN_STATUS_UNSET = 0;
var SPAN_STATUS_OK = 1;
var SPAN_STATUS_ERROR = 2;
/**
 * Converts a HTTP status code into a sentry status with a message.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or internal_error.
 */ // https://develop.sentry.dev/sdk/event-payloads/span/
function getSpanStatusFromHttpCode(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: SPAN_STATUS_OK
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: SPAN_STATUS_ERROR,
                message: 'unauthenticated'
            };
        case 403:
            return {
                code: SPAN_STATUS_ERROR,
                message: 'permission_denied'
            };
        case 404:
            return {
                code: SPAN_STATUS_ERROR,
                message: 'not_found'
            };
        case 409:
            return {
                code: SPAN_STATUS_ERROR,
                message: 'already_exists'
            };
        case 413:
            return {
                code: SPAN_STATUS_ERROR,
                message: 'failed_precondition'
            };
        case 429:
            return {
                code: SPAN_STATUS_ERROR,
                message: 'resource_exhausted'
            };
        case 499:
            return {
                code: SPAN_STATUS_ERROR,
                message: 'cancelled'
            };
        default:
            return {
                code: SPAN_STATUS_ERROR,
                message: 'invalid_argument'
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: SPAN_STATUS_ERROR,
                message: 'unimplemented'
            };
        case 503:
            return {
                code: SPAN_STATUS_ERROR,
                message: 'unavailable'
            };
        case 504:
            return {
                code: SPAN_STATUS_ERROR,
                message: 'deadline_exceeded'
            };
        default:
            return {
                code: SPAN_STATUS_ERROR,
                message: 'internal_error'
            };
    }
    return {
        code: SPAN_STATUS_ERROR,
        message: 'internal_error'
    };
}
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function setHttpStatus(span, httpStatus) {
    span.setAttribute('http.response.status_code', httpStatus);
    var spanStatus = getSpanStatusFromHttpCode(httpStatus);
    if (spanStatus.message !== 'unknown_error') span.setStatus(spanStatus);
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3oEzR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "freezeDscOnSpan", function() {
    return freezeDscOnSpan;
});
parcelHelpers.export(exports, "getDynamicSamplingContextFromClient", function() {
    return getDynamicSamplingContextFromClient;
});
parcelHelpers.export(exports, "getDynamicSamplingContextFromScope", function() {
    return getDynamicSamplingContextFromScope;
});
parcelHelpers.export(exports, "getDynamicSamplingContextFromSpan", function() {
    return getDynamicSamplingContextFromSpan;
});
parcelHelpers.export(exports, "spanToBaggageHeader", function() {
    return spanToBaggageHeader;
});
var _constantsJs = require("../constants.js");
var _currentScopesJs = require("../currentScopes.js");
var _semanticAttributesJs = require("../semanticAttributes.js");
var _baggageJs = require("../utils/baggage.js");
var _dsnJs = require("../utils/dsn.js");
var _hasSpansEnabledJs = require("../utils/hasSpansEnabled.js");
var _objectJs = require("../utils/object.js");
var _spanUtilsJs = require("../utils/spanUtils.js");
var _utilsJs = require("./utils.js");
/**
 * If you change this value, also update the terser plugin config to
 * avoid minification of the object property!
 */ var FROZEN_DSC_FIELD = '_frozenDsc';
/**
 * Freeze the given DSC on the given span.
 */ function freezeDscOnSpan(span, dsc) {
    var spanWithMaybeDsc = span;
    (0, _objectJs.addNonEnumerableProperty)(spanWithMaybeDsc, FROZEN_DSC_FIELD, dsc);
}
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function getDynamicSamplingContextFromClient(trace_id, client) {
    var options = client.getOptions();
    var _ref = client.getDsn() || {}, public_key = _ref.publicKey;
    // Instead of conditionally adding non-undefined values, we add them and then remove them if needed
    // otherwise, the order of baggage entries changes, which "breaks" a bunch of tests etc.
    var dsc = {
        environment: options.environment || (0, _constantsJs.DEFAULT_ENVIRONMENT),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id,
        org_id: (0, _dsnJs.extractOrgIdFromClient)(client)
    };
    client.emit('createDsc', dsc);
    return dsc;
}
/**
 * Get the dynamic sampling context for the currently active scopes.
 */ function getDynamicSamplingContextFromScope(client, scope) {
    var propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || getDynamicSamplingContextFromClient(propagationContext.traceId, client);
}
/**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function getDynamicSamplingContextFromSpan(span) {
    var client = (0, _currentScopesJs.getClient)();
    if (!client) return {};
    var rootSpan = (0, _spanUtilsJs.getRootSpan)(span);
    var rootSpanJson = (0, _spanUtilsJs.spanToJSON)(rootSpan);
    var rootSpanAttributes = rootSpanJson.data;
    var traceState = rootSpan.spanContext().traceState;
    var _traceState_get, _ref;
    // The span sample rate that was locally applied to the root span should also always be applied to the DSC, even if the DSC is frozen.
    // This is so that the downstream traces/services can use parentSampleRate in their `tracesSampler` to make consistent sampling decisions across the entire trace.
    var rootSpanSampleRate = (_ref = (_traceState_get = traceState === null || traceState === void 0 ? void 0 : traceState.get('sentry.sample_rate')) !== null && _traceState_get !== void 0 ? _traceState_get : rootSpanAttributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE]) !== null && _ref !== void 0 ? _ref : rootSpanAttributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE];
    function applyLocalSampleRateToDsc(dsc) {
        if (typeof rootSpanSampleRate === 'number' || typeof rootSpanSampleRate === 'string') dsc.sample_rate = "".concat(rootSpanSampleRate);
        return dsc;
    }
    // For core implementation, we freeze the DSC onto the span as a non-enumerable property
    var frozenDsc = rootSpan[FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    // For OpenTelemetry, we freeze the DSC on the trace state
    var traceStateDsc = traceState === null || traceState === void 0 ? void 0 : traceState.get('sentry.dsc');
    // If the span has a DSC, we want it to take precedence
    var dscOnTraceState = traceStateDsc && (0, _baggageJs.baggageHeaderToDynamicSamplingContext)(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    // Else, we generate it from the span
    var dsc = getDynamicSamplingContextFromClient(span.spanContext().traceId, client);
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    var source = rootSpanAttributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // after JSON conversion, txn.name becomes jsonSpan.description
    var name = rootSpanJson.description;
    if (source !== 'url' && name) dsc.transaction = name;
    // How can we even land here with hasSpansEnabled() returning false?
    // Otel creates a Non-recording span in Tracing Without Performance mode when handling incoming requests
    // So we end up with an active span that is not sampled (neither positively nor negatively)
    if ((0, _hasSpansEnabledJs.hasSpansEnabled)()) {
        var // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        _getCapturedScopesOnSpan_scope;
        dsc.sampled = String((0, _spanUtilsJs.spanIsSampled)(rootSpan));
        var // In OTEL we store the sample rand on the trace state because we cannot access scopes for NonRecordingSpans
        // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        _traceState_get1;
        dsc.sample_rand = (_traceState_get1 = traceState === null || traceState === void 0 ? void 0 : traceState.get('sentry.sample_rand')) !== null && _traceState_get1 !== void 0 ? _traceState_get1 : (_getCapturedScopesOnSpan_scope = (0, _utilsJs.getCapturedScopesOnSpan)(rootSpan).scope) === null || _getCapturedScopesOnSpan_scope === void 0 ? void 0 : _getCapturedScopesOnSpan_scope.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit('createDsc', dsc, rootSpan);
    return dsc;
}
/**
 * Convert a Span to a baggage header.
 */ function spanToBaggageHeader(span) {
    var dsc = getDynamicSamplingContextFromSpan(span);
    return (0, _baggageJs.dynamicSamplingContextToSentryBaggageHeader)(dsc);
}

},{"../constants.js":"lcYWR","../currentScopes.js":"3SsyM","../semanticAttributes.js":"fd43L","../utils/baggage.js":"aQ02G","../utils/dsn.js":"92vls","../utils/hasSpansEnabled.js":"2jW7Y","../utils/object.js":"fwaBi","../utils/spanUtils.js":"3Vkzh","./utils.js":"l773i","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lcYWR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_ENVIRONMENT", function() {
    return DEFAULT_ENVIRONMENT;
});
var DEFAULT_ENVIRONMENT = 'production';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3SsyM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getClient", function() {
    return getClient;
});
parcelHelpers.export(exports, "getCurrentScope", function() {
    return getCurrentScope;
});
parcelHelpers.export(exports, "getGlobalScope", function() {
    return getGlobalScope;
});
parcelHelpers.export(exports, "getIsolationScope", function() {
    return getIsolationScope;
});
parcelHelpers.export(exports, "getTraceContextFromScope", function() {
    return getTraceContextFromScope;
});
parcelHelpers.export(exports, "withIsolationScope", function() {
    return withIsolationScope;
});
parcelHelpers.export(exports, "withScope", function() {
    return withScope;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _indexJs = require("./asyncContext/index.js");
var _carrierJs = require("./carrier.js");
var _scopeJs = require("./scope.js");
var _propagationContextJs = require("./utils/propagationContext.js");
/**
 * Get the currently active scope.
 */ function getCurrentScope() {
    var carrier = (0, _carrierJs.getMainCarrier)();
    var acs = (0, _indexJs.getAsyncContextStrategy)(carrier);
    return acs.getCurrentScope();
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current execution context.
 */ function getIsolationScope() {
    var carrier = (0, _carrierJs.getMainCarrier)();
    var acs = (0, _indexJs.getAsyncContextStrategy)(carrier);
    return acs.getIsolationScope();
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function getGlobalScope() {
    return (0, _carrierJs.getGlobalSingleton)('globalScope', function() {
        return new (0, _scopeJs.Scope)();
    });
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function withScope() {
    for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++){
        rest[_key] = arguments[_key];
    }
    var carrier = (0, _carrierJs.getMainCarrier)();
    var acs = (0, _indexJs.getAsyncContextStrategy)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        var _rest = (0, _slicedToArray._)(rest, 2), scope = _rest[0], callback = _rest[1];
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 */ /**
 * Either creates a new active isolation scope, or sets the given isolation scope as active scope in the given callback.
 */ function withIsolationScope() {
    for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++){
        rest[_key] = arguments[_key];
    }
    var carrier = (0, _carrierJs.getMainCarrier)();
    var acs = (0, _indexJs.getAsyncContextStrategy)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        var _rest = (0, _slicedToArray._)(rest, 2), isolationScope = _rest[0], callback = _rest[1];
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
/**
 * Get the currently active client.
 */ function getClient() {
    return getCurrentScope().getClient();
}
/**
 * Get a trace context for the given scope.
 */ function getTraceContextFromScope(scope) {
    var propagationContext = scope.getPropagationContext();
    var traceId = propagationContext.traceId, parentSpanId = propagationContext.parentSpanId, propagationSpanId = propagationContext.propagationSpanId;
    var traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || (0, _propagationContextJs.generateSpanId)()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","./asyncContext/index.js":"eMMN1","./carrier.js":"4tZQo","./scope.js":"5hY8y","./utils/propagationContext.js":"kk1Ei","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eMMN1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAsyncContextStrategy", function() {
    return getAsyncContextStrategy;
});
parcelHelpers.export(exports, "setAsyncContextStrategy", function() {
    return setAsyncContextStrategy;
});
var _carrierJs = require("../carrier.js");
var _stackStrategyJs = require("./stackStrategy.js");
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function setAsyncContextStrategy(strategy) {
    // Get main carrier (global for every environment)
    var registry = (0, _carrierJs.getMainCarrier)();
    var sentry = (0, _carrierJs.getSentryCarrier)(registry);
    sentry.acs = strategy;
}
/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */ function getAsyncContextStrategy(carrier) {
    var sentry = (0, _carrierJs.getSentryCarrier)(carrier);
    if (sentry.acs) return sentry.acs;
    // Otherwise, use the default one (stack)
    return (0, _stackStrategyJs.getStackAsyncContextStrategy)();
}

},{"../carrier.js":"4tZQo","./stackStrategy.js":"aRB19","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aRB19":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsyncContextStack", function() {
    return AsyncContextStack;
});
parcelHelpers.export(exports, "getStackAsyncContextStrategy", function() {
    return getStackAsyncContextStrategy;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defaultScopesJs = require("../defaultScopes.js");
var _scopeJs = require("../scope.js");
var _isJs = require("../utils/is.js");
var _carrierJs = require("../carrier.js");
/**
 * This is an object that holds a stack of scopes.
 */ var AsyncContextStack = /*#__PURE__*/ function() {
    "use strict";
    function AsyncContextStack(scope, isolationScope) {
        (0, _classCallCheck._)(this, AsyncContextStack);
        var assignedScope;
        if (!scope) assignedScope = new (0, _scopeJs.Scope)();
        else assignedScope = scope;
        var assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, _scopeJs.Scope)();
        else assignedIsolationScope = isolationScope;
        // scope stack for domains or the process
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    (0, _createClass._)(AsyncContextStack, [
        {
            /**
   * Fork a scope for the stack.
   */ key: "withScope",
            value: function withScope(callback) {
                var _this = this;
                var scope = this._pushScope();
                var maybePromiseResult;
                try {
                    maybePromiseResult = callback(scope);
                } catch (e) {
                    this._popScope();
                    throw e;
                }
                if ((0, _isJs.isThenable)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
                return maybePromiseResult.then(function(res) {
                    _this._popScope();
                    return res;
                }, function(e) {
                    _this._popScope();
                    throw e;
                });
                this._popScope();
                return maybePromiseResult;
            }
        },
        {
            /**
   * Get the client of the stack.
   */ key: "getClient",
            value: function getClient() {
                return this.getStackTop().client;
            }
        },
        {
            /**
   * Returns the scope of the top stack.
   */ key: "getScope",
            value: function getScope() {
                return this.getStackTop().scope;
            }
        },
        {
            /**
   * Get the isolation scope for the stack.
   */ key: "getIsolationScope",
            value: function getIsolationScope() {
                return this._isolationScope;
            }
        },
        {
            /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ key: "getStackTop",
            value: function getStackTop() {
                return this._stack[this._stack.length - 1];
            }
        },
        {
            /**
   * Push a scope to the stack.
   */ key: "_pushScope",
            value: function _pushScope() {
                // We want to clone the content of prev scope
                var scope = this.getScope().clone();
                this._stack.push({
                    client: this.getClient(),
                    scope: scope
                });
                return scope;
            }
        },
        {
            /**
   * Pop a scope from the stack.
   */ key: "_popScope",
            value: function _popScope() {
                if (this._stack.length <= 1) return false;
                return !!this._stack.pop();
            }
        }
    ]);
    return AsyncContextStack;
}();
/**
 * Get the global async context stack.
 * This will be removed during the v8 cycle and is only here to make migration easier.
 */ function getAsyncContextStack() {
    var registry = (0, _carrierJs.getMainCarrier)();
    var sentry = (0, _carrierJs.getSentryCarrier)(registry);
    return sentry.stack = sentry.stack || new AsyncContextStack((0, _defaultScopesJs.getDefaultCurrentScope)(), (0, _defaultScopesJs.getDefaultIsolationScope)());
}
function withScope(callback) {
    return getAsyncContextStack().withScope(callback);
}
function withSetScope(scope, callback) {
    var stack = getAsyncContextStack();
    return stack.withScope(function() {
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function withIsolationScope(callback) {
    return getAsyncContextStack().withScope(function() {
        return callback(getAsyncContextStack().getIsolationScope());
    });
}
/**
 * Get the stack-based async context strategy.
 */ function getStackAsyncContextStrategy() {
    return {
        withIsolationScope: withIsolationScope,
        withScope: withScope,
        withSetScope: withSetScope,
        withSetIsolationScope: function(_isolationScope, callback) {
            return withIsolationScope(callback);
        },
        getCurrentScope: function() {
            return getAsyncContextStack().getScope();
        },
        getIsolationScope: function() {
            return getAsyncContextStack().getIsolationScope();
        }
    };
}

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","../defaultScopes.js":"fZgiF","../scope.js":"5hY8y","../utils/is.js":"aNXcg","../carrier.js":"4tZQo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fZgiF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaultCurrentScope", function() {
    return getDefaultCurrentScope;
});
parcelHelpers.export(exports, "getDefaultIsolationScope", function() {
    return getDefaultIsolationScope;
});
var _carrierJs = require("./carrier.js");
var _scopeJs = require("./scope.js");
/** Get the default current scope. */ function getDefaultCurrentScope() {
    return (0, _carrierJs.getGlobalSingleton)('defaultCurrentScope', function() {
        return new (0, _scopeJs.Scope)();
    });
}
/** Get the default isolation scope. */ function getDefaultIsolationScope() {
    return (0, _carrierJs.getGlobalSingleton)('defaultIsolationScope', function() {
        return new (0, _scopeJs.Scope)();
    });
}

},{"./carrier.js":"4tZQo","./scope.js":"5hY8y","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5hY8y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Scope", function() {
    return Scope;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _debugBuildJs = require("./debug-build.js");
var _sessionJs = require("./session.js");
var _debugLoggerJs = require("./utils/debug-logger.js");
var _isJs = require("./utils/is.js");
var _mergeJs = require("./utils/merge.js");
var _miscJs = require("./utils/misc.js");
var _propagationContextJs = require("./utils/propagationContext.js");
var _spanOnScopeJs = require("./utils/spanOnScope.js");
var _stringJs = require("./utils/string.js");
var _timeJs = require("./utils/time.js");
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ var DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * A context to be used for capturing an event.
 * This can either be a Scope, or a partial ScopeContext,
 * or a callback that receives the current scope and returns a new scope to use.
 */ /**
 * Holds additional event information.
 */ var Scope = /*#__PURE__*/ function() {
    "use strict";
    function Scope() {
        (0, _classCallCheck._)(this, Scope);
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: (0, _propagationContextJs.generateTraceId)(),
            sampleRand: Math.random()
        };
    }
    (0, _createClass._)(Scope, [
        {
            /**
   * Clone all data from this scope into a new scope.
   */ key: "clone",
            value: function clone() {
                var newScope = new Scope();
                newScope._breadcrumbs = (0, _toConsumableArray._)(this._breadcrumbs);
                newScope._tags = (0, _objectSpread._)({}, this._tags);
                newScope._attributes = (0, _objectSpread._)({}, this._attributes);
                newScope._extra = (0, _objectSpread._)({}, this._extra);
                newScope._contexts = (0, _objectSpread._)({}, this._contexts);
                if (this._contexts.flags) // We need to copy the `values` array so insertions on a cloned scope
                // won't affect the original array.
                newScope._contexts.flags = {
                    values: (0, _toConsumableArray._)(this._contexts.flags.values)
                };
                newScope._user = this._user;
                newScope._level = this._level;
                newScope._session = this._session;
                newScope._transactionName = this._transactionName;
                newScope._fingerprint = this._fingerprint;
                newScope._eventProcessors = (0, _toConsumableArray._)(this._eventProcessors);
                newScope._attachments = (0, _toConsumableArray._)(this._attachments);
                newScope._sdkProcessingMetadata = (0, _objectSpread._)({}, this._sdkProcessingMetadata);
                newScope._propagationContext = (0, _objectSpread._)({}, this._propagationContext);
                newScope._client = this._client;
                newScope._lastEventId = this._lastEventId;
                (0, _spanOnScopeJs._setSpanForScope)(newScope, (0, _spanOnScopeJs._getSpanForScope)(this));
                return newScope;
            }
        },
        {
            /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ key: "setClient",
            value: function setClient(client) {
                this._client = client;
            }
        },
        {
            /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ key: "setLastEventId",
            value: function setLastEventId(lastEventId) {
                this._lastEventId = lastEventId;
            }
        },
        {
            /**
   * Get the client assigned to this scope.
   */ key: "getClient",
            value: function getClient() {
                return this._client;
            }
        },
        {
            /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ key: "lastEventId",
            value: function lastEventId() {
                return this._lastEventId;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "addScopeListener",
            value: function addScopeListener(callback) {
                this._scopeListeners.push(callback);
            }
        },
        {
            /**
   * Add an event processor that will be called before an event is sent.
   */ key: "addEventProcessor",
            value: function addEventProcessor(callback) {
                this._eventProcessors.push(callback);
                return this;
            }
        },
        {
            /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ key: "setUser",
            value: function setUser(user) {
                // If null is passed we want to unset everything, but still define keys,
                // so that later down in the pipeline any existing values are cleared.
                this._user = user || {
                    email: undefined,
                    id: undefined,
                    ip_address: undefined,
                    username: undefined
                };
                if (this._session) (0, _sessionJs.updateSession)(this._session, {
                    user: user
                });
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Get the user from this scope.
   */ key: "getUser",
            value: function getUser() {
                return this._user;
            }
        },
        {
            /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ key: "setTags",
            value: function setTags(tags) {
                this._tags = (0, _objectSpread._)({}, this._tags, tags);
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Set a single tag that will be sent as tags data with the event.
   */ key: "setTag",
            value: function setTag(key, value) {
                return this.setTags((0, _defineProperty._)({}, key, value));
            }
        },
        {
            /**
   * Sets attributes onto the scope.
   *
   * TODO:
   * Currently, these attributes are not applied to any telemetry data but they will be in the future.
   *
   * @param newAttributes - The attributes to set on the scope. You can either pass in key-value pairs, or
   * an object with a `value` and an optional `unit` (if applicable to your attribute).
   *
   * @example
   * ```typescript
   * scope.setAttributes({
   *   is_admin: true,
   *   payment_selection: 'credit_card',
   *   clicked_products: [130, 554, 292],
   *   render_duration: { value: 'render_duration', unit: 'ms' },
   * });
   * ```
   */ key: "setAttributes",
            value: function setAttributes(newAttributes) {
                this._attributes = (0, _objectSpread._)({}, this._attributes, newAttributes);
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Sets an attribute onto the scope.
   *
   * TODO:
   * Currently, these attributes are not applied to any telemetry data but they will be in the future.
   *
   * @param key - The attribute key.
   * @param value - the attribute value. You can either pass in a raw value, or an attribute
   * object with a `value` and an optional `unit` (if applicable to your attribute).
   *
   * @example
   * ```typescript
   * scope.setAttribute('is_admin', true);
   * scope.setAttribute('clicked_products', [130, 554, 292]);
   * scope.setAttribute('render_duration', { value: 'render_duration', unit: 'ms' });
   * ```
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
            key: "setAttribute",
            value: function setAttribute(key, value) {
                return this.setAttributes((0, _defineProperty._)({}, key, value));
            }
        },
        {
            /**
   * Removes the attribute with the given key from the scope.
   *
   * @param key - The attribute key.
   *
   * @example
   * ```typescript
   * scope.removeAttribute('is_admin');
   * ```
   */ key: "removeAttribute",
            value: function removeAttribute(key) {
                if (key in this._attributes) {
                    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                    delete this._attributes[key];
                    this._notifyScopeListeners();
                }
                return this;
            }
        },
        {
            /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ key: "setExtras",
            value: function setExtras(extras) {
                this._extra = (0, _objectSpread._)({}, this._extra, extras);
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ key: "setExtra",
            value: function setExtra(key, extra) {
                this._extra = (0, _objectSpreadProps._)((0, _objectSpread._)({}, this._extra), (0, _defineProperty._)({}, key, extra));
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ key: "setFingerprint",
            value: function setFingerprint(fingerprint) {
                this._fingerprint = fingerprint;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Sets the level on the scope for future events.
   */ key: "setLevel",
            value: function setLevel(level) {
                this._level = level;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ key: "setTransactionName",
            value: function setTransactionName(name) {
                this._transactionName = name;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ key: "setContext",
            value: function setContext(key, context) {
                if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                delete this._contexts[key];
                else this._contexts[key] = context;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Set the session for the scope.
   */ key: "setSession",
            value: function setSession(session) {
                if (!session) delete this._session;
                else this._session = session;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Get the session from the scope.
   */ key: "getSession",
            value: function getSession() {
                return this._session;
            }
        },
        {
            /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ key: "update",
            value: function update(captureContext) {
                if (!captureContext) return this;
                var scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;
                var scopeInstance = (0, _instanceof._)(scopeToMerge, Scope) ? scopeToMerge.getScopeData() : (0, _isJs.isPlainObject)(scopeToMerge) ? captureContext : undefined;
                var _ref = scopeInstance || {}, tags = _ref.tags, attributes = _ref.attributes, extra = _ref.extra, user = _ref.user, contexts = _ref.contexts, level = _ref.level, _ref_fingerprint = _ref.fingerprint, fingerprint = _ref_fingerprint === void 0 ? [] : _ref_fingerprint, propagationContext = _ref.propagationContext;
                this._tags = (0, _objectSpread._)({}, this._tags, tags);
                this._attributes = (0, _objectSpread._)({}, this._attributes, attributes);
                this._extra = (0, _objectSpread._)({}, this._extra, extra);
                this._contexts = (0, _objectSpread._)({}, this._contexts, contexts);
                if (user && Object.keys(user).length) this._user = user;
                if (level) this._level = level;
                if (fingerprint.length) this._fingerprint = fingerprint;
                if (propagationContext) this._propagationContext = propagationContext;
                return this;
            }
        },
        {
            /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */ key: "clear",
            value: function clear() {
                // client is not cleared here on purpose!
                this._breadcrumbs = [];
                this._tags = {};
                this._attributes = {};
                this._extra = {};
                this._user = {};
                this._contexts = {};
                this._level = undefined;
                this._transactionName = undefined;
                this._fingerprint = undefined;
                this._session = undefined;
                (0, _spanOnScopeJs._setSpanForScope)(this, undefined);
                this._attachments = [];
                this.setPropagationContext({
                    traceId: (0, _propagationContextJs.generateTraceId)(),
                    sampleRand: Math.random()
                });
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ key: "addBreadcrumb",
            value: function addBreadcrumb(breadcrumb, maxBreadcrumbs) {
                var maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : DEFAULT_MAX_BREADCRUMBS;
                // No data has been changed, so don't notify scope listeners
                if (maxCrumbs <= 0) return this;
                var mergedBreadcrumb = (0, _objectSpreadProps._)((0, _objectSpread._)({
                    timestamp: (0, _timeJs.dateTimestampInSeconds)()
                }, breadcrumb), {
                    // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
                    message: breadcrumb.message ? (0, _stringJs.truncate)(breadcrumb.message, 2048) : breadcrumb.message
                });
                this._breadcrumbs.push(mergedBreadcrumb);
                if (this._breadcrumbs.length > maxCrumbs) {
                    var _this__client;
                    this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
                    (_this__client = this._client) === null || _this__client === void 0 ? void 0 : _this__client.recordDroppedEvent('buffer_overflow', 'log_item');
                }
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Get the last breadcrumb of the scope.
   */ key: "getLastBreadcrumb",
            value: function getLastBreadcrumb() {
                return this._breadcrumbs[this._breadcrumbs.length - 1];
            }
        },
        {
            /**
   * Clear all breadcrumbs from the scope.
   */ key: "clearBreadcrumbs",
            value: function clearBreadcrumbs() {
                this._breadcrumbs = [];
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Add an attachment to the scope.
   */ key: "addAttachment",
            value: function addAttachment(attachment) {
                this._attachments.push(attachment);
                return this;
            }
        },
        {
            /**
   * Clear all attachments from the scope.
   */ key: "clearAttachments",
            value: function clearAttachments() {
                this._attachments = [];
                return this;
            }
        },
        {
            /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ key: "getScopeData",
            value: function getScopeData() {
                return {
                    breadcrumbs: this._breadcrumbs,
                    attachments: this._attachments,
                    contexts: this._contexts,
                    tags: this._tags,
                    attributes: this._attributes,
                    extra: this._extra,
                    user: this._user,
                    level: this._level,
                    fingerprint: this._fingerprint || [],
                    eventProcessors: this._eventProcessors,
                    propagationContext: this._propagationContext,
                    sdkProcessingMetadata: this._sdkProcessingMetadata,
                    transactionName: this._transactionName,
                    span: (0, _spanOnScopeJs._getSpanForScope)(this)
                };
            }
        },
        {
            /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ key: "setSDKProcessingMetadata",
            value: function setSDKProcessingMetadata(newData) {
                this._sdkProcessingMetadata = (0, _mergeJs.merge)(this._sdkProcessingMetadata, newData, 2);
                return this;
            }
        },
        {
            /**
   * Add propagation context to the scope, used for distributed tracing
   */ key: "setPropagationContext",
            value: function setPropagationContext(context) {
                this._propagationContext = context;
                return this;
            }
        },
        {
            /**
   * Get propagation context from the scope, used for distributed tracing
   */ key: "getPropagationContext",
            value: function getPropagationContext() {
                return this._propagationContext;
            }
        },
        {
            /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ key: "captureException",
            value: function captureException(exception, hint) {
                var eventId = (hint === null || hint === void 0 ? void 0 : hint.event_id) || (0, _miscJs.uuid4)();
                if (!this._client) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn('No client configured on scope - will not capture exception!');
                    return eventId;
                }
                var syntheticException = new Error('Sentry syntheticException');
                this._client.captureException(exception, (0, _objectSpreadProps._)((0, _objectSpread._)({
                    originalException: exception,
                    syntheticException: syntheticException
                }, hint), {
                    event_id: eventId
                }), this);
                return eventId;
            }
        },
        {
            /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ key: "captureMessage",
            value: function captureMessage(message, level, hint) {
                var eventId = (hint === null || hint === void 0 ? void 0 : hint.event_id) || (0, _miscJs.uuid4)();
                if (!this._client) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn('No client configured on scope - will not capture message!');
                    return eventId;
                }
                var _hint_syntheticException;
                var syntheticException = (_hint_syntheticException = hint === null || hint === void 0 ? void 0 : hint.syntheticException) !== null && _hint_syntheticException !== void 0 ? _hint_syntheticException : new Error(message);
                this._client.captureMessage(message, level, (0, _objectSpreadProps._)((0, _objectSpread._)({
                    originalException: message,
                    syntheticException: syntheticException
                }, hint), {
                    event_id: eventId
                }), this);
                return eventId;
            }
        },
        {
            /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ key: "captureEvent",
            value: function captureEvent(event, hint) {
                var eventId = (hint === null || hint === void 0 ? void 0 : hint.event_id) || (0, _miscJs.uuid4)();
                if (!this._client) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn('No client configured on scope - will not capture event!');
                    return eventId;
                }
                this._client.captureEvent(event, (0, _objectSpreadProps._)((0, _objectSpread._)({}, hint), {
                    event_id: eventId
                }), this);
                return eventId;
            }
        },
        {
            /**
   * This will be called on every set call.
   */ key: "_notifyScopeListeners",
            value: function _notifyScopeListeners() {
                var _this = this;
                // We need this check for this._notifyingListeners to be able to work on scope during updates
                // If this check is not here we'll produce endless recursion when something is done with the scope
                // during the callback.
                if (!this._notifyingListeners) {
                    this._notifyingListeners = true;
                    this._scopeListeners.forEach(function(callback) {
                        callback(_this);
                    });
                    this._notifyingListeners = false;
                }
            }
        }
    ]);
    return Scope;
}();

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_to_consumable_array":"1eSZf","./debug-build.js":"2P3sP","./session.js":"9gr1J","./utils/debug-logger.js":"7EizD","./utils/is.js":"aNXcg","./utils/merge.js":"5ricq","./utils/misc.js":"363eC","./utils/propagationContext.js":"kk1Ei","./utils/spanOnScope.js":"hO3xG","./utils/string.js":"c9ata","./utils/time.js":"eCVqZ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9gr1J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "closeSession", function() {
    return closeSession;
});
parcelHelpers.export(exports, "makeSession", function() {
    return makeSession;
});
parcelHelpers.export(exports, "updateSession", function() {
    return updateSession;
});
var _miscJs = require("./utils/misc.js");
var _timeJs = require("./utils/time.js");
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function makeSession(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    var startingTime = (0, _timeJs.timestampInSeconds)();
    var session = {
        sid: (0, _miscJs.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: function() {
            return sessionToJSON(session);
        }
    };
    if (context) updateSession(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see Client.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function updateSession(session) {
    var context = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, _timeJs.timestampInSeconds)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, _miscJs.uuid4)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = "".concat(context.did);
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        var duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function closeSession(session, status) {
    var context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    updateSession(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function sessionToJSON(session) {
    return {
        sid: "".concat(session.sid),
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? "".concat(session.did) : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}

},{"./utils/misc.js":"363eC","./utils/time.js":"eCVqZ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"363eC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addContextToFrame", function() {
    return addContextToFrame;
});
parcelHelpers.export(exports, "addExceptionMechanism", function() {
    return addExceptionMechanism;
});
parcelHelpers.export(exports, "addExceptionTypeValue", function() {
    return addExceptionTypeValue;
});
parcelHelpers.export(exports, "checkOrSetAlreadyCaught", function() {
    return checkOrSetAlreadyCaught;
});
parcelHelpers.export(exports, "getEventDescription", function() {
    return getEventDescription;
});
parcelHelpers.export(exports, "parseSemver", function() {
    return parseSemver;
});
parcelHelpers.export(exports, "uuid4", function() {
    return uuid4;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectJs = require("./object.js");
var _stringJs = require("./string.js");
var _worldwideJs = require("./worldwide.js");
function getCrypto() {
    var gbl = (0, _worldwideJs.GLOBAL_OBJ);
    return gbl.crypto || gbl.msCrypto;
}
var emptyUuid;
function getRandomByte() {
    return Math.random() * 16;
}
/**
 * UUID4 generator
 * @param crypto Object that provides the crypto API.
 * @returns string Generated UUID4.
 */ function uuid4() {
    var crypto = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getCrypto();
    try {
        if (crypto === null || crypto === void 0 ? void 0 : crypto.randomUUID) return crypto.randomUUID().replace(/-/g, '');
    } catch (e) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    if (!emptyUuid) // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    emptyUuid = "10000000100040008000100000000000";
    return emptyUuid.replace(/[018]/g, function(c) {
        return(// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
    });
}
function getFirstException(event) {
    var _event_exception_values, _event_exception;
    return (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values[0];
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function getEventDescription(event) {
    var message = event.message, eventId = event.event_id;
    if (message) return message;
    var firstException = getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return "".concat(firstException.type, ": ").concat(firstException.value);
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function addExceptionTypeValue(event, value, type) {
    var exception = event.exception = event.exception || {};
    var values = exception.values = exception.values || [];
    var firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function addExceptionMechanism(event, newMechanism) {
    var firstException = getFirstException(event);
    if (!firstException) return;
    var defaultMechanism = {
        type: 'generic',
        handled: true
    };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = (0, _objectSpread._)({}, defaultMechanism, currentMechanism, newMechanism);
    if (newMechanism && 'data' in newMechanism) {
        var mergedData = (0, _objectSpread._)({}, currentMechanism === null || currentMechanism === void 0 ? void 0 : currentMechanism.data, newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ function _parseInt(input) {
    return parseInt(input || '', 10);
}
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function parseSemver(input) {
    var match = input.match(SEMVER_REGEXP) || [];
    var major = _parseInt(match[1]);
    var minor = _parseInt(match[2]);
    var patch = _parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function addContextToFrame(lines, frame) {
    var linesOfContext = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 5;
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map(function(line) {
        return (0, _stringJs.snipLine)(line, 0);
    });
    // We guard here to ensure this is not larger than the existing number of lines
    var lineIndex = Math.min(maxLines - 1, sourceLine);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    frame.context_line = (0, _stringJs.snipLine)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map(function(line) {
        return (0, _stringJs.snipLine)(line, 0);
    });
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function checkOrSetAlreadyCaught(exception) {
    if (isAlreadyCaptured(exception)) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, _objectJs.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (e) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
function isAlreadyCaptured(exception) {
    try {
        return exception.__sentry_captured__;
    } catch (e) {} // eslint-disable-line no-empty
}

},{"@swc/helpers/_/_object_spread":"9gdrV","./object.js":"fwaBi","./string.js":"c9ata","./worldwide.js":"05aQd","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"c9ata":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isMatchingPattern", function() {
    return isMatchingPattern;
});
parcelHelpers.export(exports, "safeJoin", function() {
    return safeJoin;
});
parcelHelpers.export(exports, "snipLine", function() {
    return snipLine;
});
parcelHelpers.export(exports, "stringMatchesSomePattern", function() {
    return stringMatchesSomePattern;
});
parcelHelpers.export(exports, "truncate", function() {
    return truncate;
});
var _isJs = require("./is.js");
var _stacktraceJs = require("./stacktrace.js");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function truncate(str) {
    var max = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : "".concat(str.slice(0, max), "...");
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function snipLine(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} ".concat(newLine);
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ function safeJoin(input, delimiter) {
    if (!Array.isArray(input)) return '';
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, _isJs.isVueViewModel)(value)) output.push((0, _stacktraceJs.getVueInternalName)(value));
            else output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function isMatchingPattern(value, pattern) {
    var requireExactStringMatch = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (!(0, _isJs.isString)(value)) return false;
    if ((0, _isJs.isRegExp)(pattern)) return pattern.test(value);
    if ((0, _isJs.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function stringMatchesSomePattern(testString) {
    var patterns = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], requireExactStringMatch = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return patterns.some(function(pattern) {
        return isMatchingPattern(testString, pattern, requireExactStringMatch);
    });
}

},{"./is.js":"aNXcg","./stacktrace.js":"13BlR","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"13BlR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UNKNOWN_FUNCTION", function() {
    return UNKNOWN_FUNCTION;
});
parcelHelpers.export(exports, "createStackParser", function() {
    return createStackParser;
});
parcelHelpers.export(exports, "getFramesFromEvent", function() {
    return getFramesFromEvent;
});
parcelHelpers.export(exports, "getFunctionName", function() {
    return getFunctionName;
});
parcelHelpers.export(exports, "getVueInternalName", function() {
    return getVueInternalName;
});
parcelHelpers.export(exports, "stackParserFromStackParserOptions", function() {
    return stackParserFromStackParserOptions;
});
parcelHelpers.export(exports, "stripSentryFramesAndReverse", function() {
    return stripSentryFramesAndReverse;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var STACKTRACE_FRAME_LIMIT = 50;
var UNKNOWN_FUNCTION = '?';
// Used to sanitize webpack (error: *) wrapped stack errors
var WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
var STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function createStackParser() {
    for(var _len = arguments.length, parsers = new Array(_len), _key = 0; _key < _len; _key++){
        parsers[_key] = arguments[_key];
    }
    var sortedParsers = parsers.sort(function(a, b) {
        return a[0] - b[0];
    }).map(function(p) {
        return p[1];
    });
    return function(stack) {
        var skipFirstLines = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, framesToPop = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
        var frames = [];
        var lines = stack.split('\n');
        for(var i = skipFirstLines; i < lines.length; i++){
            var line = lines[i];
            // Truncate lines over 1kb because many of the regular expressions use
            // backtracking which results in run time that increases exponentially
            // with input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) line = line.slice(0, 1024);
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            var cleanedLine = WEBPACK_ERROR_REGEXP.test(line) ? line.replace(WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = sortedParsers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var parser = _step.value;
                    var frame = parser(cleanedLine);
                    if (frame) {
                        frames.push(frame);
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            if (frames.length >= STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return stripSentryFramesAndReverse(frames.slice(framesToPop));
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function stackParserFromStackParserOptions(stackParser) {
    if (Array.isArray(stackParser)) return createStackParser.apply(void 0, (0, _toConsumableArray._)(stackParser));
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function stripSentryFramesAndReverse(stack) {
    if (!stack.length) return [];
    var localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(getLastStackFrame(localStack).function || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (STRIP_FRAME_REGEXP.test(getLastStackFrame(localStack).function || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the scope itself, making it:
        //
        //   Sentry.captureException()
        //   scope.captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if (STRIP_FRAME_REGEXP.test(getLastStackFrame(localStack).function || '')) localStack.pop();
    }
    return localStack.slice(0, STACKTRACE_FRAME_LIMIT).map(function(frame) {
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, frame), {
            filename: frame.filename || getLastStackFrame(localStack).filename,
            function: frame.function || UNKNOWN_FUNCTION
        });
    });
}
function getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
var defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function getFunctionName(fn) {
    try {
        if (!fn || typeof fn !== 'function') return defaultFunctionName;
        return fn.name || defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return defaultFunctionName;
    }
}
/**
 * Get's stack frames from an event without needing to check for undefined properties.
 */ function getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) {
        var frames = [];
        try {
            // @ts-expect-error Object could be undefined
            exception.values.forEach(function(value) {
                var // @ts-expect-error Value could be undefined
                _frames;
                // @ts-expect-error Value could be undefined
                if (value.stacktrace.frames) (_frames = frames).push.apply(_frames, (0, _toConsumableArray._)(value.stacktrace.frames));
            });
            return frames;
        } catch (e) {
            return undefined;
        }
    }
    return undefined;
}
/**
 * Get the internal name of an internal Vue value, to represent it in a stacktrace.
 *
 * @param value The value to get the internal name of.
 */ function getVueInternalName(value) {
    // Check if it's a VNode (has __v_isVNode) or a component instance (has _isVue/__isVue)
    var isVNode = '__v_isVNode' in value && value.__v_isVNode;
    return isVNode ? '[VueVNode]' : '[VueViewModel]';
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_to_consumable_array":"1eSZf","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eCVqZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "browserPerformanceTimeOrigin", function() {
    return browserPerformanceTimeOrigin;
});
parcelHelpers.export(exports, "dateTimestampInSeconds", function() {
    return dateTimestampInSeconds;
});
parcelHelpers.export(exports, "timestampInSeconds", function() {
    return timestampInSeconds;
});
var _worldwideJs = require("./worldwide.js");
var ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */ function dateTimestampInSeconds() {
    return Date.now() / ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function createUnixTimestampInSecondsFunc() {
    var performance = (0, _worldwideJs.GLOBAL_OBJ).performance;
    // Some browser and environments don't have a performance or timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    if (!(performance === null || performance === void 0 ? void 0 : performance.now) || !performance.timeOrigin) return dateTimestampInSeconds;
    var timeOrigin = performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return function() {
        return (timeOrigin + performance.now()) / ONE_SECOND_IN_MS;
    };
}
var _cachedTimestampInSeconds;
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ function timestampInSeconds() {
    // We store this in a closure so that we don't have to create a new function every time this is called.
    var func = _cachedTimestampInSeconds !== null && _cachedTimestampInSeconds !== void 0 ? _cachedTimestampInSeconds : _cachedTimestampInSeconds = createUnixTimestampInSecondsFunc();
    return func();
}
/**
 * Cached result of getBrowserTimeOrigin.
 */ var cachedTimeOrigin;
/**
 * Gets the time origin and the mode used to determine it.
 */ function getBrowserTimeOrigin() {
    var _performance_timing;
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0, _worldwideJs.GLOBAL_OBJ).performance;
    if (!(performance === null || performance === void 0 ? void 0 : performance.now)) return [
        undefined,
        'none'
    ];
    var threshold = 3600000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = (_performance_timing = performance.timing) === null || _performance_timing === void 0 ? void 0 : _performance_timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) return [
            performance.timeOrigin,
            'timeOrigin'
        ];
        else return [
            navigationStart,
            'navigationStart'
        ];
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    return [
        dateNow,
        'dateNow'
    ];
}
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ function browserPerformanceTimeOrigin() {
    if (!cachedTimeOrigin) cachedTimeOrigin = getBrowserTimeOrigin();
    return cachedTimeOrigin[0];
}

},{"./worldwide.js":"05aQd","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5ricq":[function(require,module,exports,__globalThis) {
/**
 * Shallow merge two objects.
 * Does not mutate the passed in objects.
 * Undefined/empty values in the merge object will overwrite existing values.
 *
 * By default, this merges 2 levels deep.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "merge", function() {
    return merge;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _typeOf = require("@swc/helpers/_/_type_of");
function merge(initialObj, mergeObj) {
    var levels = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 2;
    // If the merge value is not an object, or we have no merge levels left,
    // we just set the value to the merge value
    if (!mergeObj || (typeof mergeObj === "undefined" ? "undefined" : (0, _typeOf._)(mergeObj)) !== 'object' || levels <= 0) return mergeObj;
    // If the merge object is an empty object, and the initial object is not undefined, we return the initial object
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    // Clone object
    var output = (0, _objectSpread._)({}, initialObj);
    // Merge values into output, resursively
    for(var key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = merge(output[key], mergeObj[key], levels - 1);
    return output;
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_type_of":"iFJdx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kk1Ei":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateSpanId", function() {
    return generateSpanId;
});
parcelHelpers.export(exports, "generateTraceId", function() {
    return generateTraceId;
});
var _miscJs = require("./misc.js");
/**
 * Generate a random, valid trace ID.
 */ function generateTraceId() {
    return (0, _miscJs.uuid4)();
}
/**
 * Generate a random, valid span ID.
 */ function generateSpanId() {
    return (0, _miscJs.uuid4)().substring(16);
}

},{"./misc.js":"363eC","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hO3xG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_getSpanForScope", function() {
    return _getSpanForScope;
});
parcelHelpers.export(exports, "_setSpanForScope", function() {
    return _setSpanForScope;
});
var _objectJs = require("./object.js");
var SCOPE_SPAN_FIELD = '_sentrySpan';
/**
 * Set the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function _setSpanForScope(scope, span) {
    if (span) (0, _objectJs.addNonEnumerableProperty)(scope, SCOPE_SPAN_FIELD, span);
    else // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete scope[SCOPE_SPAN_FIELD];
}
/**
 * Get the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function _getSpanForScope(scope) {
    return scope[SCOPE_SPAN_FIELD];
}

},{"./object.js":"fwaBi","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fd43L":[function(require,module,exports,__globalThis) {
/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_CACHE_HIT", function() {
    return SEMANTIC_ATTRIBUTE_CACHE_HIT;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE", function() {
    return SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_CACHE_KEY", function() {
    return SEMANTIC_ATTRIBUTE_CACHE_KEY;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME", function() {
    return SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD", function() {
    return SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_PROFILE_ID", function() {
    return SEMANTIC_ATTRIBUTE_PROFILE_ID;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME", function() {
    return SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON", function() {
    return SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT", function() {
    return SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE", function() {
    return SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_OP", function() {
    return SEMANTIC_ATTRIBUTE_SENTRY_OP;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN", function() {
    return SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE", function() {
    return SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE", function() {
    return SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE", function() {
    return SEMANTIC_ATTRIBUTE_SENTRY_SOURCE;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_URL_FULL", function() {
    return SEMANTIC_ATTRIBUTE_URL_FULL;
});
parcelHelpers.export(exports, "SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE", function() {
    return SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE;
});
var SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = 'sentry.source';
/**
 * Attributes that holds the sample rate that was locally applied to a span.
 * If this attribute is not defined, it means that the span inherited a sampling decision.
 *
 * NOTE: Is only defined on root spans.
 */ var SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = 'sentry.sample_rate';
/**
 * Attribute holding the sample rate of the previous trace.
 * This is used to sample consistently across subsequent traces in the browser SDK.
 *
 * Note: Only defined on root spans, if opted into consistent sampling
 */ var SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE = 'sentry.previous_trace_sample_rate';
/**
 * Use this attribute to represent the operation of a span.
 */ var SEMANTIC_ATTRIBUTE_SENTRY_OP = 'sentry.op';
/**
 * Use this attribute to represent the origin of a span.
 */ var SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = 'sentry.origin';
/** The reason why an idle span finished. */ var SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON = 'sentry.idle_span_finish_reason';
/** The unit of a measurement, which may be stored as a TimedEvent. */ var SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT = 'sentry.measurement_unit';
/** The value of a measurement, which may be stored as a TimedEvent. */ var SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE = 'sentry.measurement_value';
/**
 * A custom span name set by users guaranteed to be taken over any automatically
 * inferred name. This attribute is removed before the span is sent.
 *
 * @internal only meant for internal SDK usage
 * @hidden
 */ var SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME = 'sentry.custom_span_name';
/**
 * The id of the profile that this span occurred in.
 */ var SEMANTIC_ATTRIBUTE_PROFILE_ID = 'sentry.profile_id';
var SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME = 'sentry.exclusive_time';
var SEMANTIC_ATTRIBUTE_CACHE_HIT = 'cache.hit';
var SEMANTIC_ATTRIBUTE_CACHE_KEY = 'cache.key';
var SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE = 'cache.item_size';
/** TODO: Remove these once we update to latest semantic conventions */ var SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD = 'http.request.method';
var SEMANTIC_ATTRIBUTE_URL_FULL = 'url.full';
/**
 * A span link attribute to mark the link as a special span link.
 *
 * Known values:
 * - `previous_trace`: The span links to the frontend root span of the previous trace.
 * - `next_trace`: The span links to the frontend root span of the next trace. (Not set by the SDK)
 *
 * Other values may be set as appropriate.
 * @see https://develop.sentry.dev/sdk/telemetry/traces/span-links/#link-types
 */ var SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE = 'sentry.link.type';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aQ02G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MAX_BAGGAGE_STRING_LENGTH", function() {
    return MAX_BAGGAGE_STRING_LENGTH;
});
parcelHelpers.export(exports, "SENTRY_BAGGAGE_KEY_PREFIX", function() {
    return SENTRY_BAGGAGE_KEY_PREFIX;
});
parcelHelpers.export(exports, "SENTRY_BAGGAGE_KEY_PREFIX_REGEX", function() {
    return SENTRY_BAGGAGE_KEY_PREFIX_REGEX;
});
parcelHelpers.export(exports, "baggageHeaderToDynamicSamplingContext", function() {
    return baggageHeaderToDynamicSamplingContext;
});
parcelHelpers.export(exports, "dynamicSamplingContextToSentryBaggageHeader", function() {
    return dynamicSamplingContextToSentryBaggageHeader;
});
parcelHelpers.export(exports, "objectToBaggageHeader", function() {
    return objectToBaggageHeader;
});
parcelHelpers.export(exports, "parseBaggageHeader", function() {
    return parseBaggageHeader;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _debugBuildJs = require("../debug-build.js");
var _debugLoggerJs = require("./debug-logger.js");
var _isJs = require("./is.js");
var SENTRY_BAGGAGE_KEY_PREFIX = 'sentry-';
var SENTRY_BAGGAGE_KEY_PREFIX_REGEX = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ var MAX_BAGGAGE_STRING_LENGTH = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function baggageHeaderToDynamicSamplingContext(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    var baggageObject = parseBaggageHeader(baggageHeader);
    if (!baggageObject) return undefined;
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    var dynamicSamplingContext = Object.entries(baggageObject).reduce(function(acc, param) {
        var _param = (0, _slicedToArray._)(param, 2), key = _param[0], value = _param[1];
        if (key.match(SENTRY_BAGGAGE_KEY_PREFIX_REGEX)) {
            var nonPrefixedKey = key.slice(SENTRY_BAGGAGE_KEY_PREFIX.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function dynamicSamplingContextToSentryBaggageHeader(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    var sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce(function(acc, param) {
        var _param = (0, _slicedToArray._)(param, 2), dscKey = _param[0], dscValue = _param[1];
        if (dscValue) acc["".concat(SENTRY_BAGGAGE_KEY_PREFIX).concat(dscKey)] = dscValue;
        return acc;
    }, {});
    return objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Take a baggage header and parse it into an object.
 */ function parseBaggageHeader(baggageHeader) {
    if (!baggageHeader || !(0, _isJs.isString)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    return baggageHeader.reduce(function(acc, curr) {
        var currBaggageObject = baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(function(param) {
            var _param = (0, _slicedToArray._)(param, 2), key = _param[0], value = _param[1];
            acc[key] = value;
        });
        return acc;
    }, {});
    return baggageHeaderToObject(baggageHeader);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map(function(baggageEntry) {
        var eqIdx = baggageEntry.indexOf('=');
        if (eqIdx === -1) // Likely an invalid entry
        return [];
        var key = baggageEntry.slice(0, eqIdx);
        var value = baggageEntry.slice(eqIdx + 1);
        return [
            key,
            value
        ].map(function(keyOrValue) {
            try {
                return decodeURIComponent(keyOrValue.trim());
            } catch (e) {
                // We ignore errors here, e.g. if the value cannot be URL decoded.
                // This will then be skipped in the next step
                return;
            }
        });
    }).reduce(function(acc, param) {
        var _param = (0, _slicedToArray._)(param, 2), key = _param[0], value = _param[1];
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce(function(baggageHeader, param, currentIndex) {
        var _param = (0, _slicedToArray._)(param, 2), objectKey = _param[0], objectValue = _param[1];
        var baggageEntry = "".concat(encodeURIComponent(objectKey), "=").concat(encodeURIComponent(objectValue));
        var newBaggageHeader = currentIndex === 0 ? baggageEntry : "".concat(baggageHeader, ",").concat(baggageEntry);
        if (newBaggageHeader.length > MAX_BAGGAGE_STRING_LENGTH) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn("Not adding key: ".concat(objectKey, " with val: ").concat(objectValue, " to baggage header due to exceeding baggage size limits."));
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","../debug-build.js":"2P3sP","./debug-logger.js":"7EizD","./is.js":"aNXcg","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"92vls":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dsnFromString", function() {
    return dsnFromString;
});
parcelHelpers.export(exports, "dsnToString", function() {
    return dsnToString;
});
parcelHelpers.export(exports, "extractOrgIdFromClient", function() {
    return extractOrgIdFromClient;
});
parcelHelpers.export(exports, "extractOrgIdFromDsnHost", function() {
    return extractOrgIdFromDsnHost;
});
parcelHelpers.export(exports, "makeDsn", function() {
    return makeDsn;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _debugBuildJs = require("../debug-build.js");
var _debugLoggerJs = require("./debug-logger.js");
/** Regular expression used to extract org ID from a DSN host. */ var ORG_ID_REGEX = /^o(\d+)\./;
/** Regular expression used to parse a Dsn. */ var DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function dsnToString(dsn) {
    var withPassword = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var host = dsn.host, path = dsn.path, pass = dsn.pass, port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol, publicKey = dsn.publicKey;
    return "".concat(protocol, "://").concat(publicKey).concat(withPassword && pass ? ":".concat(pass) : '') + "@".concat(host).concat(port ? ":".concat(port) : '', "/").concat(path ? "".concat(path, "/") : path).concat(projectId);
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function dsnFromString(str) {
    var match = DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, _debugLoggerJs.consoleSandbox)(function() {
            // eslint-disable-next-line no-console
            console.error("Invalid Sentry Dsn: ".concat(str));
        });
        return undefined;
    }
    var _match_slice = (0, _slicedToArray._)(match.slice(1), 6), protocol = _match_slice[0], publicKey = _match_slice[1], tmp = _match_slice[2], pass = tmp === void 0 ? '' : tmp, tmp1 = _match_slice[3], host = tmp1 === void 0 ? '' : tmp1, tmp2 = _match_slice[4], port = tmp2 === void 0 ? '' : tmp2, tmp3 = _match_slice[5], lastPath = tmp3 === void 0 ? '' : tmp3;
    var path = '';
    var projectId = lastPath;
    var split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        var projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function validateDsn(dsn) {
    if (!(0, _debugBuildJs.DEBUG_BUILD)) return true;
    var port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol;
    var requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    var hasMissingRequiredComponent = requiredComponents.find(function(component) {
        if (!dsn[component]) {
            (0, _debugLoggerJs.debug).error("Invalid Sentry Dsn: ".concat(component, " missing"));
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, _debugLoggerJs.debug).error("Invalid Sentry Dsn: Invalid projectId ".concat(projectId));
        return false;
    }
    if (!isValidProtocol(protocol)) {
        (0, _debugLoggerJs.debug).error("Invalid Sentry Dsn: Invalid protocol ".concat(protocol));
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, _debugLoggerJs.debug).error("Invalid Sentry Dsn: Invalid port ".concat(port));
        return false;
    }
    return true;
}
/**
 * Extract the org ID from a DSN host.
 *
 * @param host The host from a DSN
 * @returns The org ID if found, undefined otherwise
 */ function extractOrgIdFromDsnHost(host) {
    var match = host.match(ORG_ID_REGEX);
    return match === null || match === void 0 ? void 0 : match[1];
}
/**
 *  Returns the organization ID of the client.
 *
 *  The organization ID is extracted from the DSN. If the client options include a `orgId`, this will always take precedence.
 */ function extractOrgIdFromClient(client) {
    var options = client.getOptions();
    var host = (client.getDsn() || {}).host;
    var org_id;
    if (options.orgId) org_id = String(options.orgId);
    else if (host) org_id = extractOrgIdFromDsnHost(host);
    return org_id;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function makeDsn(from) {
    var components = typeof from === 'string' ? dsnFromString(from) : dsnFromComponents(from);
    if (!components || !validateDsn(components)) return undefined;
    return components;
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","../debug-build.js":"2P3sP","./debug-logger.js":"7EizD","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2jW7Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasSpansEnabled", function() {
    return hasSpansEnabled;
});
var _currentScopesJs = require("../currentScopes.js");
// Treeshakable guard to remove all code related to tracing
/**
 * Determines if span recording is currently enabled.
 *
 * Spans are recorded when at least one of `tracesSampleRate` and `tracesSampler`
 * is defined in the SDK config. This function does not make any assumption about
 * sampling decisions, it only checks if the SDK is configured to record spans.
 *
 * Important: This function only determines if span recording is enabled. Trace
 * continuation and propagation is separately controlled and not covered by this function.
 * If this function returns `false`, traces can still be propagated (which is what
 * we refer to by "Tracing without Performance")
 * @see https://develop.sentry.dev/sdk/telemetry/traces/tracing-without-performance/
 *
 * @param maybeOptions An SDK options object to be passed to this function.
 * If this option is not provided, the function will use the current client's options.
 */ function hasSpansEnabled(maybeOptions) {
    var _getClient;
    if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) return false;
    var options = maybeOptions || ((_getClient = (0, _currentScopesJs.getClient)()) === null || _getClient === void 0 ? void 0 : _getClient.getOptions());
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}

},{"../currentScopes.js":"3SsyM","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3Vkzh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TRACE_FLAG_NONE", function() {
    return TRACE_FLAG_NONE;
});
parcelHelpers.export(exports, "TRACE_FLAG_SAMPLED", function() {
    return TRACE_FLAG_SAMPLED;
});
parcelHelpers.export(exports, "addChildSpanToSpan", function() {
    return addChildSpanToSpan;
});
parcelHelpers.export(exports, "convertSpanLinksForEnvelope", function() {
    return convertSpanLinksForEnvelope;
});
parcelHelpers.export(exports, "getActiveSpan", function() {
    return getActiveSpan;
});
parcelHelpers.export(exports, "getRootSpan", function() {
    return getRootSpan;
});
parcelHelpers.export(exports, "getSpanDescendants", function() {
    return getSpanDescendants;
});
parcelHelpers.export(exports, "getStatusMessage", function() {
    return getStatusMessage;
});
parcelHelpers.export(exports, "removeChildSpanFromSpan", function() {
    return removeChildSpanFromSpan;
});
parcelHelpers.export(exports, "showSpanDropWarning", function() {
    return showSpanDropWarning;
});
parcelHelpers.export(exports, "spanIsSampled", function() {
    return spanIsSampled;
});
parcelHelpers.export(exports, "spanTimeInputToSeconds", function() {
    return spanTimeInputToSeconds;
});
parcelHelpers.export(exports, "spanToJSON", function() {
    return spanToJSON;
});
parcelHelpers.export(exports, "spanToTraceContext", function() {
    return spanToTraceContext;
});
parcelHelpers.export(exports, "spanToTraceHeader", function() {
    return spanToTraceHeader;
});
parcelHelpers.export(exports, "spanToTraceparentHeader", function() {
    return spanToTraceparentHeader;
});
parcelHelpers.export(exports, "spanToTransactionTraceContext", function() {
    return spanToTransactionTraceContext;
});
parcelHelpers.export(exports, "updateSpanName", function() {
    return updateSpanName;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _indexJs = require("../asyncContext/index.js");
var _carrierJs = require("../carrier.js");
var _currentScopesJs = require("../currentScopes.js");
var _semanticAttributesJs = require("../semanticAttributes.js");
var _spanstatusJs = require("../tracing/spanstatus.js");
var _utilsJs = require("../tracing/utils.js");
var _objectJs = require("./object.js");
var _propagationContextJs = require("./propagationContext.js");
var _timeJs = require("./time.js");
var _tracingJs = require("./tracing.js");
var _debugLoggerJs = require("./debug-logger.js");
var _spanOnScopeJs = require("./spanOnScope.js");
// These are aligned with OpenTelemetry trace flags
var TRACE_FLAG_NONE = 0x0;
var TRACE_FLAG_SAMPLED = 0x1;
var hasShownSpanDropWarning = false;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 * By default, this will only include trace_id, span_id & parent_span_id.
 * If `includeAllData` is true, it will also include data, op, status & origin.
 */ function spanToTransactionTraceContext(span) {
    var _span_spanContext = span.spanContext(), span_id = _span_spanContext.spanId, trace_id = _span_spanContext.traceId;
    var _spanToJSON = spanToJSON(span), data = _spanToJSON.data, op = _spanToJSON.op, parent_span_id = _spanToJSON.parent_span_id, status = _spanToJSON.status, origin = _spanToJSON.origin, links = _spanToJSON.links;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in a non-transaction event.
 */ function spanToTraceContext(span) {
    var _span_spanContext = span.spanContext(), spanId = _span_spanContext.spanId, trace_id = _span_spanContext.traceId, isRemote = _span_spanContext.isRemote;
    // If the span is remote, we use a random/virtual span as span_id to the trace context,
    // and the remote span as parent_span_id
    var parent_span_id = isRemote ? spanId : spanToJSON(span).parent_span_id;
    var scope = (0, _utilsJs.getCapturedScopesOnSpan)(span).scope;
    var span_id = isRemote ? (scope === null || scope === void 0 ? void 0 : scope.getPropagationContext().propagationSpanId) || (0, _propagationContextJs.generateSpanId)() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
/**
 * Convert a Span to a Sentry trace header.
 */ function spanToTraceHeader(span) {
    var _span_spanContext = span.spanContext(), traceId = _span_spanContext.traceId, spanId = _span_spanContext.spanId;
    var sampled = spanIsSampled(span);
    return (0, _tracingJs.generateSentryTraceHeader)(traceId, spanId, sampled);
}
/**
 * Convert a Span to a W3C traceparent header.
 */ function spanToTraceparentHeader(span) {
    var _span_spanContext = span.spanContext(), traceId = _span_spanContext.traceId, spanId = _span_spanContext.spanId;
    var sampled = spanIsSampled(span);
    return (0, _tracingJs.generateTraceparentHeader)(traceId, spanId, sampled);
}
/**
 *  Converts the span links array to a flattened version to be sent within an envelope.
 *
 *  If the links array is empty, it returns `undefined` so the empty value can be dropped before it's sent.
 */ function convertSpanLinksForEnvelope(links) {
    if (links && links.length > 0) return links.map(function(_param) {
        var _param_context = _param.context, spanId = _param_context.spanId, traceId = _param_context.traceId, traceFlags = _param_context.traceFlags, attributes = _param.attributes, restContext = (0, _objectWithoutProperties._)(_param.context, [
            "spanId",
            "traceId",
            "traceFlags"
        ]);
        return (0, _objectSpread._)({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === TRACE_FLAG_SAMPLED,
            attributes: attributes
        }, restContext);
    });
    else return undefined;
}
/**
 * Convert a span time input into a timestamp in seconds.
 */ function spanTimeInputToSeconds(input) {
    if (typeof input === 'number') return ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if ((0, _instanceof._)(input, Date)) return ensureTimestampInSeconds(input.getTime());
    return (0, _timeJs.timestampInSeconds)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function ensureTimestampInSeconds(timestamp) {
    var isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 */ // Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
// This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
// And `spanToJSON` needs the Span class from `span.ts` to check here.
function spanToJSON(span) {
    if (spanIsSentrySpan(span)) return span.getSpanJSON();
    var _span_spanContext = span.spanContext(), span_id = _span_spanContext.spanId, trace_id = _span_spanContext.traceId;
    // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
    if (spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        var _span_parentSpanContext;
        var attributes = span.attributes, startTime = span.startTime, name = span.name, endTime = span.endTime, status = span.status, links = span.links;
        // In preparation for the next major of OpenTelemetry, we want to support
        // looking up the parent span id according to the new API
        // In OTel v1, the parent span id is accessed as `parentSpanId`
        // In OTel v2, the parent span id is accessed as `spanId` on the `parentSpanContext`
        var parentSpanId = 'parentSpanId' in span ? span.parentSpanId : 'parentSpanContext' in span ? (_span_parentSpanContext = span.parentSpanContext) === null || _span_parentSpanContext === void 0 ? void 0 : _span_parentSpanContext.spanId : undefined;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: parentSpanId,
            start_timestamp: spanTimeInputToSeconds(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: spanTimeInputToSeconds(endTime) || undefined,
            status: getStatusMessage(status),
            op: attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            origin: attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            links: convertSpanLinksForEnvelope(links)
        };
    }
    // Finally, at least we have `spanContext()`....
    // This should not actually happen in reality, but we need to handle it for type safety.
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
function spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    var castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
/** Exported only for tests. */ /**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === 'function';
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function spanIsSampled(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    var traceFlags = span.spanContext().traceFlags;
    return traceFlags === TRACE_FLAG_SAMPLED;
}
/** Get the status message to use for a JSON representation of a span. */ function getStatusMessage(status) {
    if (!status || status.code === (0, _spanstatusJs.SPAN_STATUS_UNSET)) return undefined;
    if (status.code === (0, _spanstatusJs.SPAN_STATUS_OK)) return 'ok';
    return status.message || 'internal_error';
}
var CHILD_SPANS_FIELD = '_sentryChildSpans';
var ROOT_SPAN_FIELD = '_sentryRootSpan';
/**
 * Adds an opaque child span reference to a span.
 */ function addChildSpanToSpan(span, childSpan) {
    // We store the root span reference on the child span
    // We need this for `getRootSpan()` to work
    var rootSpan = span[ROOT_SPAN_FIELD] || span;
    (0, _objectJs.addNonEnumerableProperty)(childSpan, ROOT_SPAN_FIELD, rootSpan);
    // We store a list of child spans on the parent span
    // We need this for `getSpanDescendants()` to work
    if (span[CHILD_SPANS_FIELD]) span[CHILD_SPANS_FIELD].add(childSpan);
    else (0, _objectJs.addNonEnumerableProperty)(span, CHILD_SPANS_FIELD, new Set([
        childSpan
    ]));
}
/** This is only used internally by Idle Spans. */ function removeChildSpanFromSpan(span, childSpan) {
    if (span[CHILD_SPANS_FIELD]) span[CHILD_SPANS_FIELD].delete(childSpan);
}
/**
 * Returns an array of the given span and all of its descendants.
 */ function getSpanDescendants(span) {
    var resultSet = new Set();
    function addSpanChildren(span) {
        // This exit condition is required to not infinitely loop in case of a circular dependency.
        if (resultSet.has(span)) return;
        else if (spanIsSampled(span)) {
            resultSet.add(span);
            var childSpans = span[CHILD_SPANS_FIELD] ? Array.from(span[CHILD_SPANS_FIELD]) : [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = childSpans[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var childSpan = _step.value;
                    addSpanChildren(childSpan);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
/**
 * Returns the root span of a given span.
 */ function getRootSpan(span) {
    return span[ROOT_SPAN_FIELD] || span;
}
/**
 * Returns the currently active span.
 */ function getActiveSpan() {
    var carrier = (0, _carrierJs.getMainCarrier)();
    var acs = (0, _indexJs.getAsyncContextStrategy)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, _spanOnScopeJs._getSpanForScope)((0, _currentScopesJs.getCurrentScope)());
}
/**
 * Logs a warning once if `beforeSendSpan` is used to drop spans.
 */ function showSpanDropWarning() {
    if (!hasShownSpanDropWarning) {
        (0, _debugLoggerJs.consoleSandbox)(function() {
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly or use `ignoreSpans`.');
        });
        hasShownSpanDropWarning = true;
    }
}
/**
 * Updates the name of the given span and ensures that the span name is not
 * overwritten by the Sentry SDK.
 *
 * Use this function instead of `span.updateName()` if you want to make sure that
 * your name is kept. For some spans, for example root `http.server` spans the
 * Sentry SDK would otherwise overwrite the span name with a high-quality name
 * it infers when the span ends.
 *
 * Use this function in server code or when your span is started on the server
 * and on the client (browser). If you only update a span name on the client,
 * you can also use `span.updateName()` the SDK does not overwrite the name.
 *
 * @param span - The span to update the name of.
 * @param name - The name to set on the span.
 */ function updateSpanName(span, name) {
    span.updateName(name);
    var _obj;
    span.setAttributes((_obj = {}, (0, _defineProperty._)(_obj, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), 'custom'), (0, _defineProperty._)(_obj, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME), name), _obj));
}

},{"@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_without_properties":"6HqIM","../asyncContext/index.js":"eMMN1","../carrier.js":"4tZQo","../currentScopes.js":"3SsyM","../semanticAttributes.js":"fd43L","../tracing/spanstatus.js":"9BW0F","../tracing/utils.js":"l773i","./object.js":"fwaBi","./propagationContext.js":"kk1Ei","./time.js":"eCVqZ","./tracing.js":"1Pcfo","./debug-logger.js":"7EizD","./spanOnScope.js":"hO3xG","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1Pcfo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TRACEPARENT_REGEXP", function() {
    return TRACEPARENT_REGEXP;
});
parcelHelpers.export(exports, "extractTraceparentData", function() {
    return extractTraceparentData;
});
parcelHelpers.export(exports, "generateSentryTraceHeader", function() {
    return generateSentryTraceHeader;
});
parcelHelpers.export(exports, "generateTraceparentHeader", function() {
    return generateTraceparentHeader;
});
parcelHelpers.export(exports, "propagationContextFromHeaders", function() {
    return propagationContextFromHeaders;
});
parcelHelpers.export(exports, "shouldContinueTrace", function() {
    return shouldContinueTrace;
});
var _debugLoggerJs = require("./debug-logger.js");
var _baggageJs = require("./baggage.js");
var _dsnJs = require("./dsn.js");
var _parseSampleRateJs = require("./parseSampleRate.js");
var _propagationContextJs = require("./propagationContext.js");
// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
var TRACEPARENT_REGEXP = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * This is terrible naming but the function has nothing to do with the W3C traceparent header.
 * It can only parse the `sentry-trace` header and extract the "trace parent" data.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function extractTraceparentData(traceparent) {
    if (!traceparent) return undefined;
    var matches = traceparent.match(TRACEPARENT_REGEXP);
    if (!matches) return undefined;
    var parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create a propagation context from incoming headers or
 * creates a minimal new one if the headers are undefined.
 */ function propagationContextFromHeaders(sentryTrace, baggage) {
    var traceparentData = extractTraceparentData(sentryTrace);
    var dynamicSamplingContext = (0, _baggageJs.baggageHeaderToDynamicSamplingContext)(baggage);
    if (!(traceparentData === null || traceparentData === void 0 ? void 0 : traceparentData.traceId)) return {
        traceId: (0, _propagationContextJs.generateTraceId)(),
        sampleRand: Math.random()
    };
    var sampleRand = getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    // The sample_rand on the DSC needs to be generated based on traceparent + baggage.
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    var traceId = traceparentData.traceId, parentSpanId = traceparentData.parentSpanId, parentSampled = traceparentData.parentSampled;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: sampleRand
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function generateSentryTraceHeader() {
    var traceId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, _propagationContextJs.generateTraceId)(), spanId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, _propagationContextJs.generateSpanId)(), sampled = arguments.length > 2 ? arguments[2] : void 0;
    var sampledString = '';
    if (sampled !== undefined) sampledString = sampled ? '-1' : '-0';
    return "".concat(traceId, "-").concat(spanId).concat(sampledString);
}
/**
 * Creates a W3C traceparent header from the given trace and span ids.
 */ function generateTraceparentHeader() {
    var traceId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, _propagationContextJs.generateTraceId)(), spanId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, _propagationContextJs.generateSpanId)(), sampled = arguments.length > 2 ? arguments[2] : void 0;
    return "00-".concat(traceId, "-").concat(spanId, "-").concat(sampled ? '01' : '00');
}
/**
 * Given any combination of an incoming trace, generate a sample rand based on its defined semantics.
 *
 * Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
 */ function getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    // When there is an incoming sample rand use it.
    var parsedSampleRand = (0, _parseSampleRateJs.parseSampleRate)(dsc === null || dsc === void 0 ? void 0 : dsc.sample_rand);
    if (parsedSampleRand !== undefined) return parsedSampleRand;
    // Otherwise, if there is an incoming sampling decision + sample rate, generate a sample rand that would lead to the same sampling decision.
    var parsedSampleRate = (0, _parseSampleRateJs.parseSampleRate)(dsc === null || dsc === void 0 ? void 0 : dsc.sample_rate);
    if (parsedSampleRate && (traceparentData === null || traceparentData === void 0 ? void 0 : traceparentData.parentSampled) !== undefined) return traceparentData.parentSampled ? Math.random() * parsedSampleRate : parsedSampleRate + Math.random() * (1 - parsedSampleRate);
    else // If nothing applies, return a random sample rand.
    return Math.random();
}
/**
 * Determines whether a new trace should be continued based on the provided baggage org ID and the client's `strictTraceContinuation` option.
 * If the trace should not be continued, a new trace will be started.
 *
 * The result is dependent on the `strictTraceContinuation` option in the client.
 * See https://develop.sentry.dev/sdk/telemetry/traces/#stricttracecontinuation
 */ function shouldContinueTrace(client, baggageOrgId) {
    var clientOrgId = (0, _dsnJs.extractOrgIdFromClient)(client);
    // Case: baggage orgID and Client orgID don't match - always start new trace
    if (baggageOrgId && clientOrgId && baggageOrgId !== clientOrgId) {
        (0, _debugLoggerJs.debug).log("Won't continue trace because org IDs don't match (incoming baggage: ".concat(baggageOrgId, ", SDK options: ").concat(clientOrgId, ")"));
        return false;
    }
    var strictTraceContinuation = client.getOptions().strictTraceContinuation || false; // default for `strictTraceContinuation` is `false`
    if (strictTraceContinuation) // With strict continuation enabled, don't continue trace if:
    // - Baggage has orgID, but Client doesn't have one
    // - Client has orgID, but baggage doesn't have one
    {
        if (baggageOrgId && !clientOrgId || !baggageOrgId && clientOrgId) {
            (0, _debugLoggerJs.debug).log("Starting a new trace because strict trace continuation is enabled but one org ID is missing (incoming baggage: ".concat(baggageOrgId, ", Sentry client: ").concat(clientOrgId, ")"));
            return false;
        }
    }
    return true;
}

},{"./debug-logger.js":"7EizD","./baggage.js":"aQ02G","./dsn.js":"92vls","./parseSampleRate.js":"gTH0Z","./propagationContext.js":"kk1Ei","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gTH0Z":[function(require,module,exports,__globalThis) {
/**
 * Parse a sample rate from a given value.
 * This will either return a boolean or number sample rate, if the sample rate is valid (between 0 and 1).
 * If a string is passed, we try to convert it to a number.
 *
 * Any invalid sample rate will return `undefined`.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseSampleRate", function() {
    return parseSampleRate;
});
function parseSampleRate(sampleRate) {
    if (typeof sampleRate === 'boolean') return Number(sampleRate);
    var rate = typeof sampleRate === 'string' ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== 'number' || isNaN(rate) || rate < 0 || rate > 1) return undefined;
    return rate;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ggsl8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addEventProcessor", function() {
    return addEventProcessor;
});
parcelHelpers.export(exports, "captureCheckIn", function() {
    return captureCheckIn;
});
parcelHelpers.export(exports, "captureEvent", function() {
    return captureEvent;
});
parcelHelpers.export(exports, "captureException", function() {
    return captureException;
});
parcelHelpers.export(exports, "captureMessage", function() {
    return captureMessage;
});
parcelHelpers.export(exports, "captureSession", function() {
    return captureSession;
});
parcelHelpers.export(exports, "close", function() {
    return close;
});
parcelHelpers.export(exports, "endSession", function() {
    return endSession;
});
parcelHelpers.export(exports, "flush", function() {
    return flush;
});
parcelHelpers.export(exports, "isEnabled", function() {
    return isEnabled;
});
parcelHelpers.export(exports, "isInitialized", function() {
    return isInitialized;
});
parcelHelpers.export(exports, "lastEventId", function() {
    return lastEventId;
});
parcelHelpers.export(exports, "setContext", function() {
    return setContext;
});
parcelHelpers.export(exports, "setExtra", function() {
    return setExtra;
});
parcelHelpers.export(exports, "setExtras", function() {
    return setExtras;
});
parcelHelpers.export(exports, "setTag", function() {
    return setTag;
});
parcelHelpers.export(exports, "setTags", function() {
    return setTags;
});
parcelHelpers.export(exports, "setUser", function() {
    return setUser;
});
parcelHelpers.export(exports, "startSession", function() {
    return startSession;
});
parcelHelpers.export(exports, "withMonitor", function() {
    return withMonitor;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _currentScopesJs = require("./currentScopes.js");
var _debugBuildJs = require("./debug-build.js");
var _sessionJs = require("./session.js");
var _debugLoggerJs = require("./utils/debug-logger.js");
var _isJs = require("./utils/is.js");
var _miscJs = require("./utils/misc.js");
var _prepareEventJs = require("./utils/prepareEvent.js");
var _timeJs = require("./utils/time.js");
var _worldwideJs = require("./utils/worldwide.js");
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function captureException(exception, hint) {
    return (0, _currentScopesJs.getCurrentScope)().captureException(exception, (0, _prepareEventJs.parseEventHintOrCaptureContext)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function captureMessage(message, captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    var level = typeof captureContext === 'string' ? captureContext : undefined;
    var hint = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    return (0, _currentScopesJs.getCurrentScope)().captureMessage(message, level, hint);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function captureEvent(event, hint) {
    return (0, _currentScopesJs.getCurrentScope)().captureEvent(event, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ function setContext(name, context) {
    (0, _currentScopesJs.getIsolationScope)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function setExtras(extras) {
    (0, _currentScopesJs.getIsolationScope)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function setExtra(key, extra) {
    (0, _currentScopesJs.getIsolationScope)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function setTags(tags) {
    (0, _currentScopesJs.getIsolationScope)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function setTag(key, value) {
    (0, _currentScopesJs.getIsolationScope)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function setUser(user) {
    (0, _currentScopesJs.getIsolationScope)().setUser(user);
}
/**
 * The last error event id of the isolation scope.
 *
 * Warning: This function really returns the last recorded error event id on the current
 * isolation scope. If you call this function after handling a certain error and another error
 * is captured in between, the last one is returned instead of the one you might expect.
 * Also, ids of events that were never sent to Sentry (for example because
 * they were dropped in `beforeSend`) could be returned.
 *
 * @returns The last event id of the isolation scope.
 */ function lastEventId() {
    return (0, _currentScopesJs.getIsolationScope)().lastEventId();
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function captureCheckIn(checkIn, upsertMonitorConfig) {
    var scope = (0, _currentScopesJs.getCurrentScope)();
    var client = (0, _currentScopesJs.getClient)();
    if (!client) (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn('Cannot capture check-in. No client defined.');
    else if (!client.captureCheckIn) (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn('Cannot capture check-in. Client does not support sending check-ins.');
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, _miscJs.uuid4)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param callback Callback to be monitored
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function withMonitor(monitorSlug, callback, upsertMonitorConfig) {
    var checkInId = captureCheckIn({
        monitorSlug: monitorSlug,
        status: 'in_progress'
    }, upsertMonitorConfig);
    var now = (0, _timeJs.timestampInSeconds)();
    function finishCheckIn(status) {
        captureCheckIn({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, _timeJs.timestampInSeconds)() - now
        });
    }
    return (0, _currentScopesJs.withIsolationScope)(function() {
        var maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn('error');
            throw e;
        }
        if ((0, _isJs.isThenable)(maybePromiseResult)) return maybePromiseResult.then(function(r) {
            finishCheckIn('ok');
            return r;
        }, function(e) {
            finishCheckIn('error');
            throw e;
        });
        finishCheckIn('ok');
        return maybePromiseResult;
    });
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ function flush(timeout) {
    return (0, _asyncToGenerator._)(function() {
        var client;
        return (0, _tsGenerator._)(this, function(_state) {
            client = (0, _currentScopesJs.getClient)();
            if (client) return [
                2,
                client.flush(timeout)
            ];
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn('Cannot flush events. No client defined.');
            return [
                2,
                Promise.resolve(false)
            ];
        });
    })();
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ function close(timeout) {
    return (0, _asyncToGenerator._)(function() {
        var client;
        return (0, _tsGenerator._)(this, function(_state) {
            client = (0, _currentScopesJs.getClient)();
            if (client) return [
                2,
                client.close(timeout)
            ];
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn('Cannot flush events and disable SDK. No client defined.');
            return [
                2,
                Promise.resolve(false)
            ];
        });
    })();
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function isInitialized() {
    return !!(0, _currentScopesJs.getClient)();
}
/** If the SDK is initialized & enabled. */ function isEnabled() {
    var client = (0, _currentScopesJs.getClient)();
    return (client === null || client === void 0 ? void 0 : client.getOptions().enabled) !== false && !!(client === null || client === void 0 ? void 0 : client.getTransport());
}
/**
 * Add an event processor.
 * This will be added to the current isolation scope, ensuring any event that is processed in the current execution
 * context will have the processor applied.
 */ function addEventProcessor(callback) {
    (0, _currentScopesJs.getIsolationScope)().addEventProcessor(callback);
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function startSession(context) {
    var isolationScope = (0, _currentScopesJs.getIsolationScope)();
    var currentScope = (0, _currentScopesJs.getCurrentScope)();
    // Will fetch userAgent if called from browser sdk
    var userAgent = ((0, _worldwideJs.GLOBAL_OBJ).navigator || {}).userAgent;
    var session = (0, _sessionJs.makeSession)((0, _objectSpread._)({
        user: currentScope.getUser() || isolationScope.getUser()
    }, userAgent && {
        userAgent: userAgent
    }, context));
    // End existing session if there's one
    var currentSession = isolationScope.getSession();
    if ((currentSession === null || currentSession === void 0 ? void 0 : currentSession.status) === 'ok') (0, _sessionJs.updateSession)(currentSession, {
        status: 'exited'
    });
    endSession();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function endSession() {
    var isolationScope = (0, _currentScopesJs.getIsolationScope)();
    var currentScope = (0, _currentScopesJs.getCurrentScope)();
    var session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, _sessionJs.closeSession)(session);
    _sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function _sendSessionUpdate() {
    var isolationScope = (0, _currentScopesJs.getIsolationScope)();
    var client = (0, _currentScopesJs.getClient)();
    var session = isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function captureSession() {
    var end = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    // both send the update and pull the session from the scope
    if (end) {
        endSession();
        return;
    }
    // only send the update
    _sendSessionUpdate();
}

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_ts_generator":"78Tqx","./currentScopes.js":"3SsyM","./debug-build.js":"2P3sP","./session.js":"9gr1J","./utils/debug-logger.js":"7EizD","./utils/is.js":"aNXcg","./utils/misc.js":"363eC","./utils/prepareEvent.js":"gw3Kv","./utils/time.js":"eCVqZ","./utils/worldwide.js":"05aQd","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gw3Kv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applyClientOptions", function() {
    return applyClientOptions;
});
parcelHelpers.export(exports, "applyDebugIds", function() {
    return applyDebugIds;
});
parcelHelpers.export(exports, "applyDebugMeta", function() {
    return applyDebugMeta;
});
parcelHelpers.export(exports, "parseEventHintOrCaptureContext", function() {
    return parseEventHintOrCaptureContext;
});
parcelHelpers.export(exports, "prepareEvent", function() {
    return prepareEvent;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _constantsJs = require("../constants.js");
var _currentScopesJs = require("../currentScopes.js");
var _eventProcessorsJs = require("../eventProcessors.js");
var _scopeJs = require("../scope.js");
var _applyScopeDataToEventJs = require("./applyScopeDataToEvent.js");
var _debugIdsJs = require("./debug-ids.js");
var _miscJs = require("./misc.js");
var _normalizeJs = require("./normalize.js");
var _stringJs = require("./string.js");
var _timeJs = require("./time.js");
/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function prepareEvent(options, event, hint, scope, client, isolationScope) {
    var _options_normalizeDepth = options.normalizeDepth, normalizeDepth = _options_normalizeDepth === void 0 ? 3 : _options_normalizeDepth, _options_normalizeMaxBreadth = options.normalizeMaxBreadth, normalizeMaxBreadth = _options_normalizeMaxBreadth === void 0 ? 1000 : _options_normalizeMaxBreadth;
    var prepared = (0, _objectSpreadProps._)((0, _objectSpread._)({}, event), {
        event_id: event.event_id || hint.event_id || (0, _miscJs.uuid4)(),
        timestamp: event.timestamp || (0, _timeJs.dateTimestampInSeconds)()
    });
    var integrations = hint.integrations || options.integrations.map(function(i) {
        return i.name;
    });
    applyClientOptions(prepared, options);
    applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit('applyFrameMetadata', event);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) applyDebugIds(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    var finalScope = getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, _miscJs.addExceptionMechanism)(prepared, hint.mechanism);
    var clientEventProcessors = client ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Scope.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    var data = (0, _currentScopesJs.getGlobalScope)().getScopeData();
    if (isolationScope) {
        var isolationData = isolationScope.getScopeData();
        (0, _applyScopeDataToEventJs.mergeScopeData)(data, isolationData);
    }
    if (finalScope) {
        var finalScopeData = finalScope.getScopeData();
        (0, _applyScopeDataToEventJs.mergeScopeData)(data, finalScopeData);
    }
    var attachments = (0, _toConsumableArray._)(hint.attachments || []).concat((0, _toConsumableArray._)(data.attachments));
    if (attachments.length) hint.attachments = attachments;
    (0, _applyScopeDataToEventJs.applyScopeDataToEvent)(prepared, data);
    var eventProcessors = (0, _toConsumableArray._)(clientEventProcessors).concat(// Run scope event processors _after_ all other processors
    (0, _toConsumableArray._)(data.eventProcessors));
    var result = (0, _eventProcessorsJs.notifyEventProcessors)(eventProcessors, prepared, hint);
    return result.then(function(evt) {
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        applyDebugMeta(evt);
        if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 * Enhances event using the client configuration.
 * It takes care of all "static" values like environment, release and `dist`,
 * as well as truncating overly long values.
 *
 * Only exported for tests.
 *
 * @param event event instance to be enhanced
 */ function applyClientOptions(event, options) {
    var _event_exception_values, _event_exception;
    var environment = options.environment, release = options.release, dist = options.dist, maxValueLength = options.maxValueLength;
    // empty strings do not make sense for environment, release, and dist
    // so we handle them the same as if they were not provided
    event.environment = event.environment || environment || (0, _constantsJs.DEFAULT_ENVIRONMENT);
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    var request = event.request;
    if ((request === null || request === void 0 ? void 0 : request.url) && maxValueLength) request.url = (0, _stringJs.truncate)(request.url, maxValueLength);
    if (maxValueLength) (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values.forEach(function(exception) {
        if (exception.value) // Truncates error messages
        exception.value = (0, _stringJs.truncate)(exception.value, maxValueLength);
    });
}
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function applyDebugIds(event, stackParser) {
    var _event_exception_values, _event_exception;
    // Build a map of filename -> debug_id
    var filenameDebugIdMap = (0, _debugIdsJs.getFilenameToDebugIdMap)(stackParser);
    (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values.forEach(function(exception) {
        var _exception_stacktrace_frames, _exception_stacktrace;
        (_exception_stacktrace = exception.stacktrace) === null || _exception_stacktrace === void 0 ? void 0 : (_exception_stacktrace_frames = _exception_stacktrace.frames) === null || _exception_stacktrace_frames === void 0 ? void 0 : _exception_stacktrace_frames.forEach(function(frame) {
            if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
        });
    });
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function applyDebugMeta(event) {
    var _event_exception_values, _event_exception;
    // Extract debug IDs and filenames from the stack frames on the event.
    var filenameDebugIdMap = {};
    (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values.forEach(function(exception) {
        var _exception_stacktrace_frames, _exception_stacktrace;
        (_exception_stacktrace = exception.stacktrace) === null || _exception_stacktrace === void 0 ? void 0 : (_exception_stacktrace_frames = _exception_stacktrace.frames) === null || _exception_stacktrace_frames === void 0 ? void 0 : _exception_stacktrace_frames.forEach(function(frame) {
            if (frame.debug_id) {
                if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                delete frame.debug_id;
            }
        });
    });
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    var images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(function(param) {
        var _param = (0, _slicedToArray._)(param, 2), filename = _param[0], debug_id = _param[1];
        images.push({
            type: 'sourcemap',
            code_file: filename,
            debug_id: debug_id
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = (0, _toConsumableArray._)(event.sdk.integrations || []).concat((0, _toConsumableArray._)(integrationNames));
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function normalizeEvent(event, depth, maxBreadth) {
    var _event_contexts, _event_contexts1;
    if (!event) return null;
    var normalized = (0, _objectSpread._)({}, event, event.breadcrumbs && {
        breadcrumbs: event.breadcrumbs.map(function(b) {
            return (0, _objectSpread._)({}, b, b.data && {
                data: (0, _normalizeJs.normalize)(b.data, depth, maxBreadth)
            });
        })
    }, event.user && {
        user: (0, _normalizeJs.normalize)(event.user, depth, maxBreadth)
    }, event.contexts && {
        contexts: (0, _normalizeJs.normalize)(event.contexts, depth, maxBreadth)
    }, event.extra && {
        extra: (0, _normalizeJs.normalize)(event.extra, depth, maxBreadth)
    });
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (((_event_contexts = event.contexts) === null || _event_contexts === void 0 ? void 0 : _event_contexts.trace) && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, _normalizeJs.normalize)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map(function(span) {
        return (0, _objectSpread._)({}, span, span.data && {
            data: (0, _normalizeJs.normalize)(span.data, depth, maxBreadth)
        });
    });
    // event.contexts.flags (FeatureFlagContext) stores context for our feature
    // flag integrations. It has a greater nesting depth than our other typed
    // Contexts, so we re-normalize with a fixed depth of 3 here. We do not want
    // to skip this in case of conflicting, user-provided context.
    if (((_event_contexts1 = event.contexts) === null || _event_contexts1 === void 0 ? void 0 : _event_contexts1.flags) && normalized.contexts) normalized.contexts.flags = (0, _normalizeJs.normalize)(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    var finalScope = scope ? scope.clone() : new (0, _scopeJs.Scope)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function parseEventHintOrCaptureContext(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if (hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if (hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function hintIsScopeOrFunction(hint) {
    return (0, _instanceof._)(hint, (0, _scopeJs.Scope)) || typeof hint === 'function';
}
var captureContextKeys = [
    'user',
    'level',
    'extra',
    'contexts',
    'tags',
    'fingerprint',
    'propagationContext'
];
function hintIsScopeContext(hint) {
    return Object.keys(hint).some(function(key) {
        return captureContextKeys.includes(key);
    });
}

},{"@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_to_consumable_array":"1eSZf","../constants.js":"lcYWR","../currentScopes.js":"3SsyM","../eventProcessors.js":"g4i05","../scope.js":"5hY8y","./applyScopeDataToEvent.js":"aiR5G","./debug-ids.js":"94VUD","./misc.js":"363eC","./normalize.js":"8EOdt","./string.js":"c9ata","./time.js":"eCVqZ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"g4i05":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "notifyEventProcessors", function() {
    return notifyEventProcessors;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _debugBuildJs = require("./debug-build.js");
var _debugLoggerJs = require("./utils/debug-logger.js");
var _isJs = require("./utils/is.js");
var _syncpromiseJs = require("./utils/syncpromise.js");
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function notifyEventProcessors(processors, event, hint) {
    var index = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    try {
        var result = _notifyEventProcessors(event, hint, processors, index);
        return (0, _isJs.isThenable)(result) ? result : (0, _syncpromiseJs.resolvedSyncPromise)(result);
    } catch (error) {
        return (0, _syncpromiseJs.rejectedSyncPromise)(error);
    }
}
function _notifyEventProcessors(event, hint, processors, index) {
    var processor = processors[index];
    if (!event || !processor) return event;
    var result = processor((0, _objectSpread._)({}, event), hint);
    (0, _debugBuildJs.DEBUG_BUILD) && result === null && (0, _debugLoggerJs.debug).log('Event processor "'.concat(processor.id || '?', '" dropped event'));
    if ((0, _isJs.isThenable)(result)) return result.then(function(final) {
        return _notifyEventProcessors(final, hint, processors, index + 1);
    });
    return _notifyEventProcessors(result, hint, processors, index + 1);
}

},{"@swc/helpers/_/_object_spread":"9gdrV","./debug-build.js":"2P3sP","./utils/debug-logger.js":"7EizD","./utils/is.js":"aNXcg","./utils/syncpromise.js":"jZ98m","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jZ98m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SyncPromise", function() {
    return SyncPromise;
});
parcelHelpers.export(exports, "rejectedSyncPromise", function() {
    return rejectedSyncPromise;
});
parcelHelpers.export(exports, "resolvedSyncPromise", function() {
    return resolvedSyncPromise;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _isJs = require("./is.js");
/* eslint-disable @typescript-eslint/no-explicit-any */ /** SyncPromise internal states */ var STATE_PENDING = 0;
var STATE_RESOLVED = 1;
var STATE_REJECTED = 2;
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function resolvedSyncPromise(value) {
    return new SyncPromise(function(resolve) {
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function rejectedSyncPromise(reason) {
    return new SyncPromise(function(_, reject) {
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ var SyncPromise = /*#__PURE__*/ function() {
    "use strict";
    function SyncPromise(executor) {
        (0, _classCallCheck._)(this, SyncPromise);
        this._state = STATE_PENDING;
        this._handlers = [];
        this._runExecutor(executor);
    }
    (0, _createClass._)(SyncPromise, [
        {
            /** @inheritdoc */ key: "then",
            value: function then(onfulfilled, onrejected) {
                var _this = this;
                return new SyncPromise(function(resolve, reject) {
                    _this._handlers.push([
                        false,
                        function(result) {
                            if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                            // TODO: FIXME
                            resolve(result);
                            else try {
                                resolve(onfulfilled(result));
                            } catch (e) {
                                reject(e);
                            }
                        },
                        function(reason) {
                            if (!onrejected) reject(reason);
                            else try {
                                resolve(onrejected(reason));
                            } catch (e) {
                                reject(e);
                            }
                        }
                    ]);
                    _this._executeHandlers();
                });
            }
        },
        {
            /** @inheritdoc */ key: "catch",
            value: function _catch(onrejected) {
                return this.then(function(val) {
                    return val;
                }, onrejected);
            }
        },
        {
            /** @inheritdoc */ key: "finally",
            value: function _finally(onfinally) {
                var _this = this;
                return new SyncPromise(function(resolve, reject) {
                    var val;
                    var isRejected;
                    return _this.then(function(value) {
                        isRejected = false;
                        val = value;
                        if (onfinally) onfinally();
                    }, function(reason) {
                        isRejected = true;
                        val = reason;
                        if (onfinally) onfinally();
                    }).then(function() {
                        if (isRejected) {
                            reject(val);
                            return;
                        }
                        resolve(val);
                    });
                });
            }
        },
        {
            /** Excute the resolve/reject handlers. */ key: "_executeHandlers",
            value: function _executeHandlers() {
                var _this = this;
                if (this._state === STATE_PENDING) return;
                var cachedHandlers = this._handlers.slice();
                this._handlers = [];
                cachedHandlers.forEach(function(handler) {
                    if (handler[0]) return;
                    if (_this._state === STATE_RESOLVED) handler[1](_this._value);
                    if (_this._state === STATE_REJECTED) handler[2](_this._value);
                    handler[0] = true;
                });
            }
        },
        {
            /** Run the executor for the SyncPromise. */ key: "_runExecutor",
            value: function _runExecutor(executor) {
                var _this = this;
                var setResult = function(state, value) {
                    if (_this._state !== STATE_PENDING) return;
                    if ((0, _isJs.isThenable)(value)) {
                        value.then(resolve, reject);
                        return;
                    }
                    _this._state = state;
                    _this._value = value;
                    _this._executeHandlers();
                };
                var resolve = function(value) {
                    setResult(STATE_RESOLVED, value);
                };
                var reject = function(reason) {
                    setResult(STATE_REJECTED, reason);
                };
                try {
                    executor(resolve, reject);
                } catch (e) {
                    reject(e);
                }
            }
        }
    ]);
    return SyncPromise;
}();

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","./is.js":"aNXcg","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aiR5G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applyScopeDataToEvent", function() {
    return applyScopeDataToEvent;
});
parcelHelpers.export(exports, "mergeAndOverwriteScopeData", function() {
    return mergeAndOverwriteScopeData;
});
parcelHelpers.export(exports, "mergeScopeData", function() {
    return mergeScopeData;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _dynamicSamplingContextJs = require("../tracing/dynamicSamplingContext.js");
var _mergeJs = require("./merge.js");
var _spanUtilsJs = require("./spanUtils.js");
/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function applyScopeDataToEvent(event, data) {
    var fingerprint = data.fingerprint, span = data.span, breadcrumbs = data.breadcrumbs, sdkProcessingMetadata = data.sdkProcessingMetadata;
    // Apply general data
    applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) applySpanToEvent(event, span);
    applyFingerprintToEvent(event, fingerprint);
    applyBreadcrumbsToEvent(event, breadcrumbs);
    applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function mergeScopeData(data, mergeData) {
    var extra = mergeData.extra, tags = mergeData.tags, user = mergeData.user, contexts = mergeData.contexts, level = mergeData.level, sdkProcessingMetadata = mergeData.sdkProcessingMetadata, breadcrumbs = mergeData.breadcrumbs, fingerprint = mergeData.fingerprint, eventProcessors = mergeData.eventProcessors, attachments = mergeData.attachments, propagationContext = mergeData.propagationContext, transactionName = mergeData.transactionName, span = mergeData.span;
    mergeAndOverwriteScopeData(data, 'extra', extra);
    mergeAndOverwriteScopeData(data, 'tags', tags);
    mergeAndOverwriteScopeData(data, 'user', user);
    mergeAndOverwriteScopeData(data, 'contexts', contexts);
    data.sdkProcessingMetadata = (0, _mergeJs.merge)(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = (0, _toConsumableArray._)(data.breadcrumbs).concat((0, _toConsumableArray._)(breadcrumbs));
    if (fingerprint.length) data.fingerprint = (0, _toConsumableArray._)(data.fingerprint).concat((0, _toConsumableArray._)(fingerprint));
    if (eventProcessors.length) data.eventProcessors = (0, _toConsumableArray._)(data.eventProcessors).concat((0, _toConsumableArray._)(eventProcessors));
    if (attachments.length) data.attachments = (0, _toConsumableArray._)(data.attachments).concat((0, _toConsumableArray._)(attachments));
    data.propagationContext = (0, _objectSpread._)({}, data.propagationContext, propagationContext);
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function mergeAndOverwriteScopeData(data, prop, mergeVal) {
    data[prop] = (0, _mergeJs.merge)(data[prop], mergeVal, 1);
}
function applyDataToEvent(event, data) {
    var extra = data.extra, tags = data.tags, user = data.user, contexts = data.contexts, level = data.level, transactionName = data.transactionName;
    if (Object.keys(extra).length) event.extra = (0, _objectSpread._)({}, extra, event.extra);
    if (Object.keys(tags).length) event.tags = (0, _objectSpread._)({}, tags, event.tags);
    if (Object.keys(user).length) event.user = (0, _objectSpread._)({}, user, event.user);
    if (Object.keys(contexts).length) event.contexts = (0, _objectSpread._)({}, contexts, event.contexts);
    if (level) event.level = level;
    // transaction events get their `transaction` from the root span name
    if (transactionName && event.type !== 'transaction') event.transaction = transactionName;
}
function applyBreadcrumbsToEvent(event, breadcrumbs) {
    var mergedBreadcrumbs = (0, _toConsumableArray._)(event.breadcrumbs || []).concat((0, _toConsumableArray._)(breadcrumbs));
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = (0, _objectSpread._)({}, event.sdkProcessingMetadata, sdkProcessingMetadata);
}
function applySpanToEvent(event, span) {
    event.contexts = (0, _objectSpread._)({
        trace: (0, _spanUtilsJs.spanToTraceContext)(span)
    }, event.contexts);
    event.sdkProcessingMetadata = (0, _objectSpread._)({
        dynamicSamplingContext: (0, _dynamicSamplingContextJs.getDynamicSamplingContextFromSpan)(span)
    }, event.sdkProcessingMetadata);
    var rootSpan = (0, _spanUtilsJs.getRootSpan)(span);
    var transactionName = (0, _spanUtilsJs.spanToJSON)(rootSpan).description;
    if (transactionName && !event.transaction && event.type === 'transaction') event.transaction = transactionName;
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (!event.fingerprint.length) delete event.fingerprint;
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_to_consumable_array":"1eSZf","../tracing/dynamicSamplingContext.js":"3oEzR","./merge.js":"5ricq","./spanUtils.js":"3Vkzh","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"94VUD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDebugImagesForResources", function() {
    return getDebugImagesForResources;
});
parcelHelpers.export(exports, "getFilenameToDebugIdMap", function() {
    return getFilenameToDebugIdMap;
});
var _worldwideJs = require("./worldwide.js");
var parsedStackResults;
var lastSentryKeysCount;
var lastNativeKeysCount;
var cachedFilenameDebugIds;
/**
 * Returns a map of filenames to debug identifiers.
 * Supports both proprietary _sentryDebugIds and native _debugIds (e.g., from Vercel) formats.
 */ function getFilenameToDebugIdMap(stackParser) {
    var sentryDebugIdMap = (0, _worldwideJs.GLOBAL_OBJ)._sentryDebugIds;
    var nativeDebugIdMap = (0, _worldwideJs.GLOBAL_OBJ)._debugIds;
    if (!sentryDebugIdMap && !nativeDebugIdMap) return {};
    var sentryDebugIdKeys = sentryDebugIdMap ? Object.keys(sentryDebugIdMap) : [];
    var nativeDebugIdKeys = nativeDebugIdMap ? Object.keys(nativeDebugIdMap) : [];
    // If the count of registered globals hasn't changed since the last call, we
    // can just return the cached result.
    if (cachedFilenameDebugIds && sentryDebugIdKeys.length === lastSentryKeysCount && nativeDebugIdKeys.length === lastNativeKeysCount) return cachedFilenameDebugIds;
    lastSentryKeysCount = sentryDebugIdKeys.length;
    lastNativeKeysCount = nativeDebugIdKeys.length;
    // Build a map of filename -> debug_id from both sources
    cachedFilenameDebugIds = {};
    if (!parsedStackResults) parsedStackResults = {};
    var processDebugIds = function(debugIdKeys, debugIdMap) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = debugIdKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var debugId = debugIdMap[key];
                var result = parsedStackResults === null || parsedStackResults === void 0 ? void 0 : parsedStackResults[key];
                if (result && cachedFilenameDebugIds && debugId) {
                    // Use cached filename but update with current debug ID
                    cachedFilenameDebugIds[result[0]] = debugId;
                    // Update cached result with new debug ID
                    if (parsedStackResults) parsedStackResults[key] = [
                        result[0],
                        debugId
                    ];
                } else if (debugId) {
                    var parsedStack = stackParser(key);
                    for(var i = parsedStack.length - 1; i >= 0; i--){
                        var stackFrame = parsedStack[i];
                        var filename = stackFrame === null || stackFrame === void 0 ? void 0 : stackFrame.filename;
                        if (filename && cachedFilenameDebugIds && parsedStackResults) {
                            cachedFilenameDebugIds[filename] = debugId;
                            parsedStackResults[key] = [
                                filename,
                                debugId
                            ];
                            break;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
    if (sentryDebugIdMap) processDebugIds(sentryDebugIdKeys, sentryDebugIdMap);
    // Native _debugIds will override _sentryDebugIds if same file
    if (nativeDebugIdMap) processDebugIds(nativeDebugIdKeys, nativeDebugIdMap);
    return cachedFilenameDebugIds;
}
/**
 * Returns a list of debug images for the given resources.
 */ function getDebugImagesForResources(stackParser, resource_paths) {
    var filenameDebugIdMap = getFilenameToDebugIdMap(stackParser);
    if (!filenameDebugIdMap) return [];
    var images = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = resource_paths[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var path = _step.value;
            if (path && filenameDebugIdMap[path]) images.push({
                type: 'sourcemap',
                code_file: path,
                debug_id: filenameDebugIdMap[path]
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return images;
}

},{"./worldwide.js":"05aQd","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8EOdt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "normalize", function() {
    return normalize;
});
parcelHelpers.export(exports, "normalizeToSize", function() {
    return normalizeToSize;
});
parcelHelpers.export(exports, "normalizeUrlToBase", function() {
    return normalizeUrlToBase;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var _isJs = require("./is.js");
var _objectJs = require("./object.js");
var _stacktraceJs = require("./stacktrace.js");
var global = arguments[3];
/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normalized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function normalize(input) {
    var depth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100, maxProperties = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Infinity;
    try {
        // since we're at the outermost level, we don't provide a key
        return visit('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: "**non-serializable** (".concat(err, ")")
        };
    }
}
/** JSDoc */ function normalizeToSize(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object) {
    var // Default Node.js REPL depth
    depth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
    maxSize = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 102400;
    var normalized = normalize(object, depth);
    if (jsonSize(normalized) > maxSize) return normalizeToSize(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function visit(key, value) {
    var depth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Infinity, maxProperties = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Infinity, memo = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : memoBuilder();
    var _memo = (0, _slicedToArray._)(memo, 2), memoize = _memo[0], unmemoize = _memo[1];
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        'boolean',
        'string'
    ].includes(typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) || typeof value === 'number' && Number.isFinite(value)) return value;
    var stringified = stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value['__sentry_skip_normalization__']) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    var remainingDepth = typeof value['__sentry_override_normalization_depth__'] === 'number' ? value['__sentry_override_normalization_depth__'] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    var valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        var jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return visit('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (e) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    var normalized = Array.isArray(value) ? [] : {};
    var numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    var visitable = (0, _objectJs.convertToPlainObject)(value);
    for(var visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        var visitValue = visitable[visitKey];
        normalized[visitKey] = visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && (typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof global !== 'undefined' && value === global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        if ((0, _isJs.isVueViewModel)(value)) return (0, _stacktraceJs.getVueInternalName)(value);
        // React's SyntheticEvent thingy
        if ((0, _isJs.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && !Number.isFinite(value)) return "[".concat(value, "]");
        if (typeof value === 'function') return "[Function: ".concat((0, _stacktraceJs.getFunctionName)(value), "]");
        if ((typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) === 'symbol') return "[".concat(String(value), "]");
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if ((typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) === 'bigint') return "[BigInt: ".concat(String(value), "]");
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        var objName = getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return "[HTMLElement: ".concat(objName, "]");
        return "[object ".concat(objName, "]");
    } catch (err) {
        return "**non-serializable** (".concat(err, ")");
    }
}
/* eslint-enable complexity */ function getConstructorName(value) {
    var prototype = Object.getPrototypeOf(value);
    return (prototype === null || prototype === void 0 ? void 0 : prototype.constructor) ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function jsonSize(value) {
    return utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function normalizeUrlToBase(url, basePath) {
    var escapedBase = basePath// Backslash to forward
    .replace(/\\/g, '/')// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    var newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (e) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, '/').replace(/webpack:\/?/g, '') // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp("(file://)?/*".concat(escapedBase, "/*"), 'ig'), 'app:///');
}
/**
 * Helper to decycle json objects
 */ function memoBuilder() {
    var inner = new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_type_of":"iFJdx","./is.js":"aNXcg","./object.js":"fwaBi","./stacktrace.js":"13BlR","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"tQSqJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isSentryRequestUrl", function() {
    return isSentryRequestUrl;
});
var _urlJs = require("./url.js");
/**
 * Checks whether given url points to Sentry server
 *
 * @param url url to verify
 */ function isSentryRequestUrl(url, client) {
    var dsn = client === null || client === void 0 ? void 0 : client.getDsn();
    var tunnel = client === null || client === void 0 ? void 0 : client.getOptions().tunnel;
    return checkDsn(url, dsn) || checkTunnel(url, tunnel);
}
function checkTunnel(url, tunnel) {
    if (!tunnel) return false;
    return removeTrailingSlash(url) === removeTrailingSlash(tunnel);
}
function checkDsn(url, dsn) {
    // Requests to Sentry's ingest endpoint must have a `sentry_key` in the query string
    // This is equivalent to the public_key which is required in the DSN
    // see https://develop.sentry.dev/sdk/overview/#parsing-the-dsn
    // Therefore, a request to the same host and with a `sentry_key` in the query string
    // can be considered a request to the ingest endpoint.
    var urlParts = (0, _urlJs.parseStringToURLObject)(url);
    if (!urlParts || (0, _urlJs.isURLObjectRelative)(urlParts)) return false;
    return dsn ? urlParts.host.includes(dsn.host) && /(^|&|\?)sentry_key=/.test(urlParts.search) : false;
}
function removeTrailingSlash(str) {
    return str[str.length - 1] === '/' ? str.slice(0, -1) : str;
}

},{"./url.js":"5ZpHJ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5ZpHJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getHttpSpanDetailsFromUrlObject", function() {
    return getHttpSpanDetailsFromUrlObject;
});
parcelHelpers.export(exports, "getSanitizedUrlString", function() {
    return getSanitizedUrlString;
});
parcelHelpers.export(exports, "getSanitizedUrlStringFromUrlObject", function() {
    return getSanitizedUrlStringFromUrlObject;
});
parcelHelpers.export(exports, "isURLObjectRelative", function() {
    return isURLObjectRelative;
});
parcelHelpers.export(exports, "parseStringToURLObject", function() {
    return parseStringToURLObject;
});
parcelHelpers.export(exports, "parseUrl", function() {
    return parseUrl;
});
parcelHelpers.export(exports, "stripUrlQueryAndFragment", function() {
    return stripUrlQueryAndFragment;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _semanticAttributesJs = require("../semanticAttributes.js");
// Curious about `thismessage:/`? See: https://www.rfc-editor.org/rfc/rfc2557.html
//  > When the methods above do not yield an absolute URI, a base URL
//  > of "thismessage:/" MUST be employed. This base URL has been
//  > defined for the sole purpose of resolving relative references
//  > within a multipart/related structure when no other base URI is
//  > specified.
//
// We need to provide a base URL to `parseStringToURLObject` because the fetch API gives us a
// relative URL sometimes.
//
// This is the only case where we need to provide a base URL to `parseStringToURLObject`
// because the relative URL is not valid on its own.
var DEFAULT_BASE_URL = 'thismessage:/';
/**
 * Checks if the URL object is relative
 *
 * @param url - The URL object to check
 * @returns True if the URL object is relative, false otherwise
 */ function isURLObjectRelative(url) {
    return 'isRelative' in url;
}
/**
 * Parses string to a URL object
 *
 * @param url - The URL to parse
 * @returns The parsed URL object or undefined if the URL is invalid
 */ function parseStringToURLObject(url, urlBase) {
    var isRelative = url.indexOf('://') <= 0 && url.indexOf('//') !== 0;
    var base = urlBase !== null && urlBase !== void 0 ? urlBase : isRelative ? DEFAULT_BASE_URL : undefined;
    try {
        // Use `canParse` to short-circuit the URL constructor if it's not a valid URL
        // This is faster than trying to construct the URL and catching the error
        // Node 20+, Chrome 120+, Firefox 115+, Safari 17+
        if ('canParse' in URL && !URL.canParse(url, base)) return undefined;
        var fullUrlObject = new URL(url, base);
        if (isRelative) // Because we used a fake base URL, we need to return a relative URL object.
        // We cannot return anything about the origin, host, etc. because it will refer to the fake base URL.
        return {
            isRelative: isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch (e) {
    // empty body
    }
    return undefined;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function getSanitizedUrlStringFromUrlObject(url) {
    if (isURLObjectRelative(url)) return url.pathname;
    var newUrl = new URL(url);
    newUrl.search = '';
    newUrl.hash = '';
    if ([
        '80',
        '443'
    ].includes(newUrl.port)) newUrl.port = '';
    if (newUrl.password) newUrl.password = '%filtered%';
    if (newUrl.username) newUrl.username = '%filtered%';
    return newUrl.toString();
}
function getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName) {
    var _request_method;
    var _request_method_toUpperCase;
    var method = (_request_method_toUpperCase = request === null || request === void 0 ? void 0 : (_request_method = request.method) === null || _request_method === void 0 ? void 0 : _request_method.toUpperCase()) !== null && _request_method_toUpperCase !== void 0 ? _request_method_toUpperCase : 'GET';
    var route = routeName ? routeName : urlObject ? kind === 'client' ? getSanitizedUrlStringFromUrlObject(urlObject) : urlObject.pathname : '/';
    return "".concat(method, " ").concat(route);
}
/**
 * Takes a parsed URL object and returns a set of attributes for the span
 * that represents the HTTP request for that url. This is used for both server
 * and client http spans.
 *
 * Follows https://opentelemetry.io/docs/specs/semconv/http/.
 *
 * @param urlObject - see {@link parseStringToURLObject}
 * @param kind - The type of HTTP operation (server or client)
 * @param spanOrigin - The origin of the span
 * @param request - The request object, see {@link PartialRequest}
 * @param routeName - The name of the route, must be low cardinality
 * @returns The span name and attributes for the HTTP operation
 */ function getHttpSpanDetailsFromUrlObject(urlObject, kind, spanOrigin, request, routeName) {
    var _obj;
    var attributes = (_obj = {}, (0, _defineProperty._)(_obj, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), spanOrigin), (0, _defineProperty._)(_obj, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), 'url'), _obj);
    if (routeName) {
        // This is based on https://opentelemetry.io/docs/specs/semconv/http/http-spans/#name
        attributes[kind === 'server' ? 'http.route' : 'url.template'] = routeName;
        attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = 'route';
    }
    if (request === null || request === void 0 ? void 0 : request.method) attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD] = request.method.toUpperCase();
    if (urlObject) {
        if (urlObject.search) attributes['url.query'] = urlObject.search;
        if (urlObject.hash) attributes['url.fragment'] = urlObject.hash;
        if (urlObject.pathname) {
            attributes['url.path'] = urlObject.pathname;
            if (urlObject.pathname === '/') attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = 'route';
        }
        if (!isURLObjectRelative(urlObject)) {
            attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_URL_FULL] = urlObject.href;
            if (urlObject.port) attributes['url.port'] = urlObject.port;
            if (urlObject.protocol) attributes['url.scheme'] = urlObject.protocol;
            if (urlObject.hostname) attributes[kind === 'server' ? 'server.address' : 'url.domain'] = urlObject.hostname;
        }
    }
    return [
        getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName),
        attributes
    ];
}
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function parseUrl(url) {
    if (!url) return {};
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function stripUrlQueryAndFragment(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function getSanitizedUrlString(url) {
    var protocol = url.protocol, host = url.host, path = url.path;
    var filteredHost = (host === null || host === void 0 ? void 0 : host.replace(/^.*@/, '[filtered]:[filtered]@')// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, '').replace(/(:443)$/, '')) || '';
    return "".concat(protocol ? "".concat(protocol, "://") : '').concat(filteredHost).concat(path);
}

},{"@swc/helpers/_/_define_property":"e80IS","../semanticAttributes.js":"fd43L","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bU7tT":[function(require,module,exports,__globalThis) {
/**
 * Heavily simplified debounce function based on lodash.debounce.
 *
 * This function takes a callback function (@param fun) and delays its invocation
 * by @param wait milliseconds. Optionally, a maxWait can be specified in @param options,
 * which ensures that the callback is invoked at least once after the specified max. wait time.
 *
 * @param func the function whose invocation is to be debounced
 * @param wait the minimum time until the function is invoked after it was called once
 * @param options the options object, which can contain the `maxWait` property
 *
 * @returns the debounced version of the function, which needs to be called at least once to start the
 *          debouncing process. Subsequent calls will reset the debouncing timer and, in case @paramfunc
 *          was already invoked in the meantime, return @param func's return value.
 *          The debounced function has two additional properties:
 *          - `flush`: Invokes the debounced function immediately and returns its return value
 *          - `cancel`: Cancels the debouncing process and resets the debouncing timer
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "debounce", function() {
    return debounce;
});
function debounce(func, wait, options) {
    var callbackReturnValue;
    var timerId;
    var maxTimerId;
    var maxWait = (options === null || options === void 0 ? void 0 : options.maxWait) ? Math.max(options.maxWait, wait) : 0;
    var setTimeoutImpl = (options === null || options === void 0 ? void 0 : options.setTimeoutImpl) || setTimeout;
    function invokeFunc() {
        cancelTimers();
        callbackReturnValue = func();
        return callbackReturnValue;
    }
    function cancelTimers() {
        timerId !== undefined && clearTimeout(timerId);
        maxTimerId !== undefined && clearTimeout(maxTimerId);
        timerId = maxTimerId = undefined;
    }
    function flush() {
        if (timerId !== undefined || maxTimerId !== undefined) return invokeFunc();
        return callbackReturnValue;
    }
    function debounced() {
        if (timerId) clearTimeout(timerId);
        timerId = setTimeoutImpl(invokeFunc, wait);
        if (maxWait && maxTimerId === undefined) maxTimerId = setTimeoutImpl(invokeFunc, maxWait);
        return callbackReturnValue;
    }
    debounced.cancel = cancelTimers;
    debounced.flush = flush;
    return debounced;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fJCGb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addBreadcrumb", function() {
    return addBreadcrumb;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _currentScopesJs = require("./currentScopes.js");
var _debugLoggerJs = require("./utils/debug-logger.js");
var _timeJs = require("./utils/time.js");
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ var DEFAULT_BREADCRUMBS = 100;
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 */ function addBreadcrumb(breadcrumb, hint) {
    var client = (0, _currentScopesJs.getClient)();
    var isolationScope = (0, _currentScopesJs.getIsolationScope)();
    if (!client) return;
    var _client_getOptions = client.getOptions(), _client_getOptions_beforeBreadcrumb = _client_getOptions.beforeBreadcrumb, beforeBreadcrumb = _client_getOptions_beforeBreadcrumb === void 0 ? null : _client_getOptions_beforeBreadcrumb, _client_getOptions_maxBreadcrumbs = _client_getOptions.maxBreadcrumbs, maxBreadcrumbs = _client_getOptions_maxBreadcrumbs === void 0 ? DEFAULT_BREADCRUMBS : _client_getOptions_maxBreadcrumbs;
    if (maxBreadcrumbs <= 0) return;
    var timestamp = (0, _timeJs.dateTimestampInSeconds)();
    var mergedBreadcrumb = (0, _objectSpread._)({
        timestamp: timestamp
    }, breadcrumb);
    var finalBreadcrumb = beforeBreadcrumb ? (0, _debugLoggerJs.consoleSandbox)(function() {
        return beforeBreadcrumb(mergedBreadcrumb, hint);
    }) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}

},{"@swc/helpers/_/_object_spread":"9gdrV","./currentScopes.js":"3SsyM","./utils/debug-logger.js":"7EizD","./utils/time.js":"eCVqZ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3n3zH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isBrowser", function() {
    return isBrowser;
});
var _nodeJs = require("./node.js");
var _worldwideJs = require("./worldwide.js");
/**
 * Returns true if we are in the browser.
 */ function isBrowser() {
    // eslint-disable-next-line no-restricted-globals
    return typeof window !== 'undefined' && (!(0, _nodeJs.isNodeEnv)() || isElectronNodeRenderer());
}
// Electron renderers with nodeIntegration enabled are detected as Node.js so we specifically test for them
function isElectronNodeRenderer() {
    var process = (0, _worldwideJs.GLOBAL_OBJ).process;
    return (process === null || process === void 0 ? void 0 : process.type) === 'renderer';
}

},{"./node.js":"bkTQL","./worldwide.js":"05aQd","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bkTQL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNodeEnv", function() {
    return isNodeEnv;
});
parcelHelpers.export(exports, "loadModule", function() {
    return loadModule;
});
var _envJs = require("./env.js");
var process = require("e3053d459575465a");
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the `debug` singleton, or b) put your function elsewhere.
 */ /**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, _envJs.isBrowserBundle)() && Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]';
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @param existingModule module to use for requiring
 * @returns possibly required module
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function loadModule(moduleName) {
    var existingModule = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : module;
    var mod;
    try {
        mod = dynamicRequire(existingModule, moduleName);
    } catch (e) {
    // no-empty
    }
    if (!mod) try {
        var cwd = dynamicRequire(existingModule, 'process').cwd;
        mod = dynamicRequire(existingModule, "".concat(cwd(), "/node_modules/").concat(moduleName));
    } catch (e) {
    // no-empty
    }
    return mod;
}

},{"e3053d459575465a":"gNLf3","./env.js":"6nlvg","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6nlvg":[function(require,module,exports,__globalThis) {
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `debug` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSDKSource", function() {
    return getSDKSource;
});
parcelHelpers.export(exports, "isBrowserBundle", function() {
    return isBrowserBundle;
});
function isBrowserBundle() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function getSDKSource() {
    // This comment is used to identify this line in the CDN bundle build step and replace this with "return 'cdn';"
    /* __SENTRY_SDK_SOURCE__ */ return 'npm';
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6RYho":[function(require,module,exports,__globalThis) {
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "severityLevelFromString", function() {
    return severityLevelFromString;
});
function severityLevelFromString(level) {
    return level === 'warn' ? 'warning' : [
        'fatal',
        'error',
        'warning',
        'log',
        'info',
        'debug'
    ].includes(level) ? level : 'log';
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9Uq9n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addItemToEnvelope", function() {
    return addItemToEnvelope;
});
parcelHelpers.export(exports, "createAttachmentEnvelopeItem", function() {
    return createAttachmentEnvelopeItem;
});
parcelHelpers.export(exports, "createEnvelope", function() {
    return createEnvelope;
});
parcelHelpers.export(exports, "createEventEnvelopeHeaders", function() {
    return createEventEnvelopeHeaders;
});
parcelHelpers.export(exports, "createSpanEnvelopeItem", function() {
    return createSpanEnvelopeItem;
});
parcelHelpers.export(exports, "envelopeContainsItemType", function() {
    return envelopeContainsItemType;
});
parcelHelpers.export(exports, "envelopeItemTypeToDataCategory", function() {
    return envelopeItemTypeToDataCategory;
});
parcelHelpers.export(exports, "forEachEnvelopeItem", function() {
    return forEachEnvelopeItem;
});
parcelHelpers.export(exports, "getSdkMetadataForEnvelopeHeader", function() {
    return getSdkMetadataForEnvelopeHeader;
});
parcelHelpers.export(exports, "parseEnvelope", function() {
    return parseEnvelope;
});
parcelHelpers.export(exports, "serializeEnvelope", function() {
    return serializeEnvelope;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _carrierJs = require("../carrier.js");
var _dsnJs = require("./dsn.js");
var _normalizeJs = require("./normalize.js");
var _worldwideJs = require("./worldwide.js");
/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function createEnvelope(headers) {
    var items = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function addItemToEnvelope(envelope, newItem) {
    var _envelope = (0, _slicedToArray._)(envelope, 2), headers = _envelope[0], items = _envelope[1];
    return [
        headers,
        (0, _toConsumableArray._)(items).concat([
            newItem
        ])
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function forEachEnvelopeItem(envelope, callback) {
    var envelopeItems = envelope[1];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = envelopeItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var envelopeItem = _step.value;
            var envelopeItemType = envelopeItem[0].type;
            var result = callback(envelopeItem, envelopeItemType);
            if (result) return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function envelopeContainsItemType(envelope, types) {
    return forEachEnvelopeItem(envelope, function(_, type) {
        return types.includes(type);
    });
}
/**
 * Encode a string to UTF8 array.
 */ function encodeUTF8(input) {
    var carrier = (0, _carrierJs.getSentryCarrier)((0, _worldwideJs.GLOBAL_OBJ));
    return carrier.encodePolyfill ? carrier.encodePolyfill(input) : new TextEncoder().encode(input);
}
/**
 * Decode a UTF8 array to string.
 */ function decodeUTF8(input) {
    var carrier = (0, _carrierJs.getSentryCarrier)((0, _worldwideJs.GLOBAL_OBJ));
    return carrier.decodePolyfill ? carrier.decodePolyfill(input) : new TextDecoder().decode(input);
}
/**
 * Serializes an envelope.
 */ function serializeEnvelope(envelope) {
    var _envelope = (0, _slicedToArray._)(envelope, 2), envHeaders = _envelope[0], items = _envelope[1];
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    var parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === 'string') parts = typeof next === 'string' ? parts + next : [
            encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === 'string' ? encodeUTF8(next) : next);
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            var _item = (0, _slicedToArray._)(item, 2), itemHeaders = _item[0], payload = _item[1];
            append("\n".concat(JSON.stringify(itemHeaders), "\n"));
            if (typeof payload === 'string' || (0, _instanceof._)(payload, Uint8Array)) append(payload);
            else {
                var stringifiedPayload = void 0;
                try {
                    stringifiedPayload = JSON.stringify(payload);
                } catch (e) {
                    // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.stringify()` still
                    // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                    // performance impact but in this case a performance hit is better than throwing.
                    stringifiedPayload = JSON.stringify((0, _normalizeJs.normalize)(payload));
                }
                append(stringifiedPayload);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return typeof parts === 'string' ? parts : concatBuffers(parts);
}
function concatBuffers(buffers) {
    var totalLength = buffers.reduce(function(acc, buf) {
        return acc + buf.length;
    }, 0);
    var merged = new Uint8Array(totalLength);
    var offset = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = buffers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var buffer = _step.value;
            merged.set(buffer, offset);
            offset += buffer.length;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return merged;
}
/**
 * Parses an envelope
 */ function parseEnvelope(env) {
    var buffer = typeof env === 'string' ? encodeUTF8(env) : env;
    function readBinary(length) {
        var bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        var i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse(decodeUTF8(readBinary(i)));
    }
    var envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var items = [];
    while(buffer.length){
        var itemHeader = readJson();
        var binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates envelope item for a single span
 */ function createSpanEnvelopeItem(spanJson) {
    var spanHeaders = {
        type: 'span'
    };
    return [
        spanHeaders,
        spanJson
    ];
}
/**
 * Creates attachment envelope items
 */ function createAttachmentEnvelopeItem(attachment) {
    var buffer = typeof attachment.data === 'string' ? encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: 'attachment',
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
var ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: 'session',
    sessions: 'session',
    attachment: 'attachment',
    transaction: 'transaction',
    event: 'error',
    client_report: 'internal',
    user_report: 'default',
    profile: 'profile',
    profile_chunk: 'profile',
    replay_event: 'replay',
    replay_recording: 'replay',
    check_in: 'monitor',
    feedback: 'feedback',
    span: 'span',
    raw_security: 'security',
    log: 'log_item',
    metric: 'metric',
    trace_metric: 'metric'
};
/**
 * Maps the type of an envelope item to a data category.
 */ function envelopeItemTypeToDataCategory(type) {
    return ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function getSdkMetadataForEnvelopeHeader(metadataOrEvent) {
    if (!(metadataOrEvent === null || metadataOrEvent === void 0 ? void 0 : metadataOrEvent.sdk)) return;
    var _metadataOrEvent_sdk = metadataOrEvent.sdk, name = _metadataOrEvent_sdk.name, version = _metadataOrEvent_sdk.version;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn) {
    var _event_sdkProcessingMetadata;
    var dynamicSamplingContext = (_event_sdkProcessingMetadata = event.sdkProcessingMetadata) === null || _event_sdkProcessingMetadata === void 0 ? void 0 : _event_sdkProcessingMetadata.dynamicSamplingContext;
    return (0, _objectSpread._)({
        event_id: event.event_id,
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }, !!tunnel && dsn && {
        dsn: (0, _dsnJs.dsnToString)(dsn)
    }, dynamicSamplingContext && {
        trace: dynamicSamplingContext
    });
}

},{"@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_to_consumable_array":"1eSZf","../carrier.js":"4tZQo","./dsn.js":"92vls","./normalize.js":"8EOdt","./worldwide.js":"05aQd","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iYQ03":[function(require,module,exports,__globalThis) {
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_RETRY_AFTER", function() {
    return DEFAULT_RETRY_AFTER;
});
parcelHelpers.export(exports, "disabledUntil", function() {
    return disabledUntil;
});
parcelHelpers.export(exports, "isRateLimited", function() {
    return isRateLimited;
});
parcelHelpers.export(exports, "parseRetryAfterHeader", function() {
    return parseRetryAfterHeader;
});
parcelHelpers.export(exports, "updateRateLimits", function() {
    return updateRateLimits;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var DEFAULT_RETRY_AFTER = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function parseRetryAfterHeader(header) {
    var now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
    var headerDelay = parseInt("".concat(header), 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    var headerDate = Date.parse("".concat(header));
    if (!isNaN(headerDate)) return headerDate - now;
    return DEFAULT_RETRY_AFTER;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function disabledUntil(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function isRateLimited(limits, dataCategory) {
    var now = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Date.now();
    return disabledUntil(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function updateRateLimits(limits, param) {
    var statusCode = param.statusCode, headers = param.headers, now = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Date.now();
    var updatedRateLimits = (0, _objectSpread._)({}, limits);
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    var rateLimitHeader = headers === null || headers === void 0 ? void 0 : headers['x-sentry-rate-limits'];
    var retryAfterHeader = headers === null || headers === void 0 ? void 0 : headers['retry-after'];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (rateLimitHeader) try {
        /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for(var _iterator = rateLimitHeader.trim().split(',')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var limit = _step.value;
            var _limit_split = (0, _slicedToArray._)(limit.split(':', 5), 5), retryAfter = _limit_split[0], categories = _limit_split[1], namespaces = _limit_split[4];
            var headerDelay = parseInt(retryAfter, 10);
            var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            if (!categories) updatedRateLimits.all = now + delay;
            else try {
                for(var _iterator1 = categories.split(';')[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var category = _step1.value;
                    if (category === 'metric_bucket') // namespaces will be present when category === 'metric_bucket'
                    {
                        if (!namespaces || namespaces.split(';').includes('custom')) updatedRateLimits[category] = now + delay;
                    } else updatedRateLimits[category] = now + delay;
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + parseRetryAfterHeader(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_sliced_to_array":"8PtL6","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aasNs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "replayCanvasIntegration", function() {
    return replayCanvasIntegration;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _core = require("@sentry/core");
var __defProp$1 = Object.defineProperty;
var __defNormalProp$1 = function(obj, key, value) {
    return key in obj ? __defProp$1(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var __publicField$1 = function(obj, key, value) {
    return __defNormalProp$1(obj, (typeof key === "undefined" ? "undefined" : (0, _typeOf._)(key)) !== "symbol" ? key + "" : key, value);
};
var Mirror = /*#__PURE__*/ function() {
    "use strict";
    function Mirror() {
        (0, _classCallCheck._)(this, Mirror);
        __publicField$1(this, "idNodeMap", /* @__PURE__ */ new Map());
        __publicField$1(this, "nodeMetaMap", /* @__PURE__ */ new WeakMap());
    }
    (0, _createClass._)(Mirror, [
        {
            key: "getId",
            value: function getId(n2) {
                var _this_getMeta;
                if (!n2) return -1;
                var id = (_this_getMeta = this.getMeta(n2)) === null || _this_getMeta === void 0 ? void 0 : _this_getMeta.id;
                return id !== null && id !== void 0 ? id : -1;
            }
        },
        {
            key: "getNode",
            value: function getNode(id) {
                return this.idNodeMap.get(id) || null;
            }
        },
        {
            key: "getIds",
            value: function getIds() {
                return Array.from(this.idNodeMap.keys());
            }
        },
        {
            key: "getMeta",
            value: function getMeta(n2) {
                return this.nodeMetaMap.get(n2) || null;
            }
        },
        {
            // removes the node from idNodeMap
            // doesn't remove the node from nodeMetaMap
            key: "removeNodeFromMap",
            value: function removeNodeFromMap(n2) {
                var _this = this;
                var id = this.getId(n2);
                this.idNodeMap.delete(id);
                if (n2.childNodes) n2.childNodes.forEach(function(childNode) {
                    return _this.removeNodeFromMap(childNode);
                });
            }
        },
        {
            key: "has",
            value: function has(id) {
                return this.idNodeMap.has(id);
            }
        },
        {
            key: "hasNode",
            value: function hasNode(node) {
                return this.nodeMetaMap.has(node);
            }
        },
        {
            key: "add",
            value: function add(n2, meta) {
                var id = meta.id;
                this.idNodeMap.set(id, n2);
                this.nodeMetaMap.set(n2, meta);
            }
        },
        {
            key: "replace",
            value: function replace(id, n2) {
                var oldNode = this.getNode(id);
                if (oldNode) {
                    var meta = this.nodeMetaMap.get(oldNode);
                    if (meta) this.nodeMetaMap.set(n2, meta);
                }
                this.idNodeMap.set(id, n2);
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.idNodeMap = /* @__PURE__ */ new Map();
                this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
            }
        }
    ]);
    return Mirror;
}();
function createMirror$2() {
    return new Mirror();
}
function elementClassMatchesRegex(el, regex) {
    for(var eIndex = el.classList.length; eIndex--;){
        var className = el.classList[eIndex];
        if (regex.test(className)) return true;
    }
    return false;
}
function distanceToMatch(node, matchPredicate) {
    var limit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Infinity, distance = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    if (!node) return -1;
    if (node.nodeType !== node.ELEMENT_NODE) return -1;
    if (distance > limit) return -1;
    if (matchPredicate(node)) return distance;
    return distanceToMatch(node.parentNode, matchPredicate, limit, distance + 1);
}
function createMatchPredicate(className, selector) {
    return function(node) {
        var el = node;
        if (el === null) return false;
        try {
            if (className) {
                if (typeof className === "string") {
                    if (el.matches(".".concat(className))) return true;
                } else if (elementClassMatchesRegex(el, className)) return true;
            }
            if (selector && el.matches(selector)) return true;
            return false;
        } catch (e) {
            return false;
        }
    };
}
var DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
var _mirror = {
    map: {},
    getId: function getId() {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode: function getNode() {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap: function removeNodeFromMap() {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has: function has() {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset: function reset() {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== "undefined" && window.Proxy && window.Reflect) _mirror = new Proxy(_mirror, {
    get: function get(target, prop, receiver) {
        if (prop === "map") console.error(DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function hookSetter(target, key, d, isRevoked) {
    var win = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : window;
    var original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set: function set(value) {
            var _this = this;
            setTimeout$1(function() {
                d.set.call(_this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return function() {
        return hookSetter(target, key, original || {}, true);
    };
}
function patch(source, name, replacement) {
    try {
        if (!(name in source)) return function() {};
        var original = source[name];
        var wrapped = replacement(original);
        if (typeof wrapped === "function") {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return function() {
            source[name] = original;
        };
    } catch (e) {
        return function() {};
    }
}
/* @__PURE__ */ /[1-9][0-9]{12}/.test(Date.now().toString());
function closestElementOfNode(node) {
    if (!node) return null;
    try {
        var el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
        return el;
    } catch (error) {
        return null;
    }
}
function isBlocked(node, blockClass, blockSelector, unblockSelector, checkAncestors) {
    if (!node) return false;
    var el = closestElementOfNode(node);
    if (!el) return false;
    var blockedPredicate = createMatchPredicate(blockClass, blockSelector);
    if (!checkAncestors) {
        var isUnblocked = unblockSelector && el.matches(unblockSelector);
        return blockedPredicate(el) && !isUnblocked;
    }
    var blockDistance = distanceToMatch(el, blockedPredicate);
    var unblockDistance = -1;
    if (blockDistance < 0) return false;
    if (unblockSelector) unblockDistance = distanceToMatch(el, createMatchPredicate(null, unblockSelector));
    if (blockDistance > -1 && unblockDistance < 0) return true;
    return blockDistance < unblockDistance;
}
var cachedImplementations = {};
function getImplementation(name) {
    var cached = cachedImplementations[name];
    if (cached) return cached;
    var document2 = window.document;
    var impl = window[name];
    if (document2 && typeof document2.createElement === "function") try {
        var sandbox = document2.createElement("iframe");
        sandbox.hidden = true;
        document2.head.appendChild(sandbox);
        var contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document2.head.removeChild(sandbox);
    } catch (e2) {}
    return cachedImplementations[name] = impl.bind(window);
}
function onRequestAnimationFrame() {
    for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++){
        rest[_key] = arguments[_key];
    }
    return getImplementation("requestAnimationFrame").apply(this, (0, _toConsumableArray._)(rest));
}
function setTimeout$1() {
    for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++){
        rest[_key] = arguments[_key];
    }
    return getImplementation("setTimeout").apply(this, (0, _toConsumableArray._)(rest));
}
var CanvasContext = /* @__PURE__ */ function(CanvasContext2) {
    CanvasContext2[CanvasContext2["2D"] = 0] = "2D";
    CanvasContext2[CanvasContext2["WebGL"] = 1] = "WebGL";
    CanvasContext2[CanvasContext2["WebGL2"] = 2] = "WebGL2";
    return CanvasContext2;
}(CanvasContext || {});
var errorHandler;
function registerErrorHandler(handler) {
    errorHandler = handler;
}
var callbackWrapper = function(cb) {
    if (!errorHandler) return cb;
    var rrwebWrapped = function() {
        for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++){
            rest[_key] = arguments[_key];
        }
        try {
            return cb.apply(void 0, (0, _toConsumableArray._)(rest));
        } catch (error) {
            if (errorHandler && errorHandler(error) === true) return function() {};
            throw error;
        }
    };
    return rrwebWrapped;
};
var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for(var i$1 = 0; i$1 < chars.length; i$1++)lookup[chars.charCodeAt(i$1)] = i$1;
var encode = function encode(arraybuffer) {
    var bytes = new Uint8Array(arraybuffer), i2, len = bytes.length, base64 = "";
    for(i2 = 0; i2 < len; i2 += 3){
        base64 += chars[bytes[i2] >> 2];
        base64 += chars[(bytes[i2] & 3) << 4 | bytes[i2 + 1] >> 4];
        base64 += chars[(bytes[i2 + 1] & 15) << 2 | bytes[i2 + 2] >> 6];
        base64 += chars[bytes[i2 + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + "=";
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + "==";
    return base64;
};
var canvasVarMap = /* @__PURE__ */ new Map();
function variableListFor$1(ctx, ctor) {
    var contextMap = canvasVarMap.get(ctx);
    if (!contextMap) {
        contextMap = /* @__PURE__ */ new Map();
        canvasVarMap.set(ctx, contextMap);
    }
    if (!contextMap.has(ctor)) contextMap.set(ctor, []);
    return contextMap.get(ctor);
}
var saveWebGLVar = function(value, win, ctx) {
    if (!value || !(isInstanceOfWebGLObject(value, win) || (typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) === "object")) return;
    var name = value.constructor.name;
    var list = variableListFor$1(ctx, name);
    var index = list.indexOf(value);
    if (index === -1) {
        index = list.length;
        list.push(value);
    }
    return index;
};
function serializeArg(value, win, ctx) {
    if ((0, _instanceof._)(value, Array)) return value.map(function(arg) {
        return serializeArg(arg, win, ctx);
    });
    else if (value === null) return value;
    else if ((0, _instanceof._)(value, Float32Array) || (0, _instanceof._)(value, Float64Array) || (0, _instanceof._)(value, Int32Array) || (0, _instanceof._)(value, Uint32Array) || (0, _instanceof._)(value, Uint8Array) || (0, _instanceof._)(value, Uint16Array) || (0, _instanceof._)(value, Int16Array) || (0, _instanceof._)(value, Int8Array) || (0, _instanceof._)(value, Uint8ClampedArray)) {
        var name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                Object.values(value)
            ]
        };
    } else if (// SharedArrayBuffer disabled on most browsers due to spectre.
    // More info: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/SharedArrayBuffer/SharedArrayBuffer
    // value instanceof SharedArrayBuffer ||
    (0, _instanceof._)(value, ArrayBuffer)) {
        var name1 = value.constructor.name;
        var base64 = encode(value);
        return {
            rr_type: name1,
            base64: base64
        };
    } else if ((0, _instanceof._)(value, DataView)) {
        var name2 = value.constructor.name;
        return {
            rr_type: name2,
            args: [
                serializeArg(value.buffer, win, ctx),
                value.byteOffset,
                value.byteLength
            ]
        };
    } else if ((0, _instanceof._)(value, HTMLImageElement)) {
        var name3 = value.constructor.name;
        var src = value.src;
        return {
            rr_type: name3,
            src: src
        };
    } else if ((0, _instanceof._)(value, HTMLCanvasElement)) {
        var name4 = "HTMLImageElement";
        var src1 = value.toDataURL();
        return {
            rr_type: name4,
            src: src1
        };
    } else if ((0, _instanceof._)(value, ImageData)) {
        var name5 = value.constructor.name;
        return {
            rr_type: name5,
            args: [
                serializeArg(value.data, win, ctx),
                value.width,
                value.height
            ]
        };
    } else if (isInstanceOfWebGLObject(value, win) || (typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) === "object") {
        var name6 = value.constructor.name;
        var index = saveWebGLVar(value, win, ctx);
        return {
            rr_type: name6,
            index: index
        };
    }
    return value;
}
var serializeArgs = function(args, win, ctx) {
    return args.map(function(arg) {
        return serializeArg(arg, win, ctx);
    });
};
var isInstanceOfWebGLObject = function(value, win) {
    var webGLConstructorNames = [
        "WebGLActiveInfo",
        "WebGLBuffer",
        "WebGLFramebuffer",
        "WebGLProgram",
        "WebGLRenderbuffer",
        "WebGLShader",
        "WebGLShaderPrecisionFormat",
        "WebGLTexture",
        "WebGLUniformLocation",
        "WebGLVertexArrayObject",
        // In old Chrome versions, value won't be an instanceof WebGLVertexArrayObject.
        "WebGLVertexArrayObjectOES"
    ];
    var supportedWebGLConstructorNames = webGLConstructorNames.filter(function(name) {
        return typeof win[name] === "function";
    });
    return Boolean(supportedWebGLConstructorNames.find(function(name) {
        return (0, _instanceof._)(value, win[name]);
    }));
};
function initCanvas2DMutationObserver(cb, win, blockClass2, blockSelector, unblockSelector) {
    var handlers = [];
    var props2D = Object.getOwnPropertyNames(win.CanvasRenderingContext2D.prototype);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var prop = _step.value;
            try {
                if (typeof win.CanvasRenderingContext2D.prototype[prop] !== "function") return "continue";
                var restoreHandler = patch(win.CanvasRenderingContext2D.prototype, prop, function(original) {
                    return function() {
                        var _this = this;
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                            args[_key] = arguments[_key];
                        }
                        if (!isBlocked(this.canvas, blockClass2, blockSelector, unblockSelector, true)) setTimeout$1(function() {
                            var recordArgs = serializeArgs(args, win, _this);
                            cb(_this.canvas, {
                                type: CanvasContext["2D"],
                                property: prop,
                                args: recordArgs
                            });
                        }, 0);
                        return original.apply(this, args);
                    };
                });
                handlers.push(restoreHandler);
            } catch (e) {
                var hookHandler = hookSetter(win.CanvasRenderingContext2D.prototype, prop, {
                    set: function set(v2) {
                        cb(this.canvas, {
                            type: CanvasContext["2D"],
                            property: prop,
                            args: [
                                v2
                            ],
                            setter: true
                        });
                    }
                });
                handlers.push(hookHandler);
            }
        };
        for(var _iterator = props2D[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return function() {
        handlers.forEach(function(h) {
            return h();
        });
    };
}
function getNormalizedContextName(contextType) {
    return contextType === "experimental-webgl" ? "webgl" : contextType;
}
function initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector, setPreserveDrawingBufferToTrue) {
    var handlers = [];
    try {
        var restoreHandler = patch(win.HTMLCanvasElement.prototype, "getContext", function(original) {
            return function(contextType) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                if (!isBlocked(this, blockClass, blockSelector, unblockSelector, true)) {
                    var ctxName = getNormalizedContextName(contextType);
                    if (!("__context" in this)) this.__context = ctxName;
                    if (setPreserveDrawingBufferToTrue && [
                        "webgl",
                        "webgl2"
                    ].includes(ctxName)) {
                        if (args[0] && (0, _typeOf._)(args[0]) === "object") {
                            var contextAttributes = args[0];
                            if (!contextAttributes.preserveDrawingBuffer) contextAttributes.preserveDrawingBuffer = true;
                        } else args.splice(0, 1, {
                            preserveDrawingBuffer: true
                        });
                    }
                }
                return original.apply(this, [
                    contextType
                ].concat((0, _toConsumableArray._)(args)));
            };
        });
        handlers.push(restoreHandler);
    } catch (e) {
        console.error("failed to patch HTMLCanvasElement.prototype.getContext");
    }
    return function() {
        handlers.forEach(function(h) {
            return h();
        });
    };
}
function patchGLPrototype(prototype, type, cb, blockClass2, blockSelector, unblockSelector, _mirror2, win) {
    var handlers = [];
    var props = Object.getOwnPropertyNames(prototype);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var prop = _step.value;
            if (//prop.startsWith('get') ||  // e.g. getProgramParameter, but too risky
            [
                "isContextLost",
                "canvas",
                "drawingBufferWidth",
                "drawingBufferHeight"
            ].includes(prop)) return "continue";
            try {
                if (typeof prototype[prop] !== "function") return "continue";
                var restoreHandler = patch(prototype, prop, function(original) {
                    return function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                            args[_key] = arguments[_key];
                        }
                        var result = original.apply(this, args);
                        saveWebGLVar(result, win, this);
                        if ("tagName" in this.canvas && !isBlocked(this.canvas, blockClass2, blockSelector, unblockSelector, true)) {
                            var recordArgs = serializeArgs(args, win, this);
                            var mutation = {
                                type: type,
                                property: prop,
                                args: recordArgs
                            };
                            cb(this.canvas, mutation);
                        }
                        return result;
                    };
                });
                handlers.push(restoreHandler);
            } catch (e) {
                var hookHandler = hookSetter(prototype, prop, {
                    set: function set(v2) {
                        cb(this.canvas, {
                            type: type,
                            property: prop,
                            args: [
                                v2
                            ],
                            setter: true
                        });
                    }
                });
                handlers.push(hookHandler);
            }
        };
        for(var _iterator = props[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return handlers;
}
function initCanvasWebGLMutationObserver(cb, win, blockClass2, blockSelector, unblockSelector, mirror2) {
    var _handlers, _handlers1;
    var handlers = [];
    (_handlers = handlers).push.apply(_handlers, (0, _toConsumableArray._)(patchGLPrototype(win.WebGLRenderingContext.prototype, CanvasContext.WebGL, cb, blockClass2, blockSelector, unblockSelector, mirror2, win)));
    if (typeof win.WebGL2RenderingContext !== "undefined") (_handlers1 = handlers).push.apply(_handlers1, (0, _toConsumableArray._)(patchGLPrototype(win.WebGL2RenderingContext.prototype, CanvasContext.WebGL2, cb, blockClass2, blockSelector, unblockSelector, mirror2, win)));
    return function() {
        handlers.forEach(function(h) {
            return h();
        });
    };
}
var r$1 = 'for(var e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",t="undefined"==typeof Uint8Array?[]:new Uint8Array(256),a=0;a<64;a++)t[e.charCodeAt(a)]=a;var n=function(t){var a,n=new Uint8Array(t),r=n.length,s="";for(a=0;a<r;a+=3)s+=e[n[a]>>2],s+=e[(3&n[a])<<4|n[a+1]>>4],s+=e[(15&n[a+1])<<2|n[a+2]>>6],s+=e[63&n[a+2]];return r%3==2?s=s.substring(0,s.length-1)+"=":r%3==1&&(s=s.substring(0,s.length-2)+"=="),s};const r=new Map,s=new Map;const i=self;i.onmessage=async function(e){if(!("OffscreenCanvas"in globalThis))return i.postMessage({id:e.data.id});{const{id:t,bitmap:a,width:o,height:f,maxCanvasSize:c,dataURLOptions:g}=e.data,u=async function(e,t,a){const r=e+"-"+t;if("OffscreenCanvas"in globalThis){if(s.has(r))return s.get(r);const i=new OffscreenCanvas(e,t);i.getContext("2d");const o=await i.convertToBlob(a),f=await o.arrayBuffer(),c=n(f);return s.set(r,c),c}return""}(o,f,g),[h,d]=function(e,t,a){if(!a)return[e,t];const[n,r]=a;if(e<=n&&t<=r)return[e,t];let s=e,i=t;return s>n&&(i=Math.floor(n*t/e),s=n),i>r&&(s=Math.floor(r*e/t),i=r),[s,i]}(o,f,c),l=new OffscreenCanvas(h,d),w=l.getContext("bitmaprenderer"),p=h===o&&d===f?a:await createImageBitmap(a,{resizeWidth:h,resizeHeight:d,resizeQuality:"low"});w?.transferFromImageBitmap(p),a.close();const y=await l.convertToBlob(g),v=y.type,b=await y.arrayBuffer(),m=n(b);if(p.close(),!r.has(t)&&await u===m)return r.set(t,m),i.postMessage({id:t});if(r.get(t)===m)return i.postMessage({id:t});i.postMessage({id:t,type:v,base64:m,width:o,height:f}),r.set(t,m)}};';
function t$1() {
    var t2 = new Blob([
        r$1
    ]);
    return URL.createObjectURL(t2);
}
var CanvasManager = /*#__PURE__*/ function() {
    "use strict";
    function CanvasManager(options) {
        var _this = this;
        (0, _classCallCheck._)(this, CanvasManager);
        this.pendingCanvasMutations = /* @__PURE__ */ new Map();
        this.rafStamps = {
            latestId: 0,
            invokeId: null
        };
        this.shadowDoms = /* @__PURE__ */ new Set();
        this.windowsSet = /* @__PURE__ */ new WeakSet();
        this.windows = [];
        this.restoreHandlers = [];
        this.frozen = false;
        this.locked = false;
        this.snapshotInProgressMap = /* @__PURE__ */ new Map();
        this.worker = null;
        this.lastSnapshotTime = 0;
        this.processMutation = function(target, mutation) {
            var newFrame = _this.rafStamps.invokeId && _this.rafStamps.latestId !== _this.rafStamps.invokeId;
            if (newFrame || !_this.rafStamps.invokeId) _this.rafStamps.invokeId = _this.rafStamps.latestId;
            if (!_this.pendingCanvasMutations.has(target)) _this.pendingCanvasMutations.set(target, []);
            _this.pendingCanvasMutations.get(target).push(mutation);
        };
        var enableManualSnapshot = options.enableManualSnapshot, _options_sampling = options.sampling, sampling = _options_sampling === void 0 ? "all" : _options_sampling, win = options.win, recordCanvas = options.recordCanvas, errorHandler2 = options.errorHandler;
        options.sampling = sampling;
        this.mutationCb = options.mutationCb;
        this.mirror = options.mirror;
        this.options = options;
        if (errorHandler2) registerErrorHandler(errorHandler2);
        if (recordCanvas && typeof sampling === "number" || enableManualSnapshot) this.worker = this.initFPSWorker();
        this.addWindow(win);
        if (enableManualSnapshot) return;
        callbackWrapper(function() {
            if (recordCanvas && sampling === "all") {
                _this.startRAFTimestamping();
                _this.startPendingCanvasMutationFlusher();
            }
            if (recordCanvas && typeof sampling === "number") _this.initCanvasFPSObserver();
        })();
    }
    (0, _createClass._)(CanvasManager, [
        {
            key: "reset",
            value: function reset() {
                var _this_worker;
                this.pendingCanvasMutations.clear();
                this.restoreHandlers.forEach(function(handler) {
                    try {
                        handler();
                    } catch (e2) {}
                });
                this.restoreHandlers = [];
                this.windowsSet = /* @__PURE__ */ new WeakSet();
                this.windows = [];
                this.shadowDoms = /* @__PURE__ */ new Set();
                (_this_worker = this.worker) === null || _this_worker === void 0 ? void 0 : _this_worker.terminate();
                this.worker = null;
                this.snapshotInProgressMap = /* @__PURE__ */ new Map();
            }
        },
        {
            key: "freeze",
            value: function freeze() {
                this.frozen = true;
            }
        },
        {
            key: "unfreeze",
            value: function unfreeze() {
                this.frozen = false;
            }
        },
        {
            key: "lock",
            value: function lock() {
                this.locked = true;
            }
        },
        {
            key: "unlock",
            value: function unlock() {
                this.locked = false;
            }
        },
        {
            key: "addWindow",
            value: function addWindow(win) {
                var _this = this;
                var _this_options = this.options, _this_options_sampling = _this_options.sampling, sampling = _this_options_sampling === void 0 ? "all" : _this_options_sampling, blockClass = _this_options.blockClass, blockSelector = _this_options.blockSelector, unblockSelector = _this_options.unblockSelector, recordCanvas = _this_options.recordCanvas, enableManualSnapshot = _this_options.enableManualSnapshot;
                if (this.windowsSet.has(win)) return;
                if (enableManualSnapshot) {
                    this.windowsSet.add(win);
                    this.windows.push(new WeakRef(win));
                    return;
                }
                callbackWrapper(function() {
                    if (recordCanvas && sampling === "all") _this.initCanvasMutationObserver(win, blockClass, blockSelector, unblockSelector);
                    if (recordCanvas && typeof sampling === "number") {
                        var canvasContextReset = initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector, true);
                        _this.restoreHandlers.push(function() {
                            canvasContextReset();
                        });
                    }
                })();
                this.windowsSet.add(win);
                this.windows.push(new WeakRef(win));
            }
        },
        {
            key: "addShadowRoot",
            value: function addShadowRoot(shadowRoot) {
                this.shadowDoms.add(new WeakRef(shadowRoot));
            }
        },
        {
            key: "resetShadowRoots",
            value: function resetShadowRoots() {
                this.shadowDoms = /* @__PURE__ */ new Set();
            }
        },
        {
            key: "snapshot",
            value: function snapshot(canvasElement, options) {
                var _this = this;
                if (options === null || options === void 0 ? void 0 : options.skipRequestAnimationFrame) {
                    this.takeSnapshot(performance.now(), true, canvasElement);
                    return;
                }
                onRequestAnimationFrame(function(timestamp) {
                    return _this.takeSnapshot(timestamp, true, canvasElement);
                });
            }
        },
        {
            key: "initFPSWorker",
            value: function initFPSWorker() {
                var _this = this;
                var worker = new Worker(t$1());
                worker.onmessage = function(e2) {
                    var data = e2.data;
                    var id = data.id;
                    _this.snapshotInProgressMap.set(id, false);
                    if (!("base64" in data)) return;
                    var base64 = data.base64, type = data.type, width = data.width, height = data.height;
                    _this.mutationCb({
                        id: id,
                        type: CanvasContext["2D"],
                        commands: [
                            {
                                property: "clearRect",
                                // wipe canvas
                                args: [
                                    0,
                                    0,
                                    width,
                                    height
                                ]
                            },
                            {
                                property: "drawImage",
                                // draws (semi-transparent) image
                                args: [
                                    {
                                        rr_type: "ImageBitmap",
                                        args: [
                                            {
                                                rr_type: "Blob",
                                                data: [
                                                    {
                                                        rr_type: "ArrayBuffer",
                                                        base64: base64
                                                    }
                                                ],
                                                type: type
                                            }
                                        ]
                                    },
                                    0,
                                    0,
                                    // The below args are needed if we enforce a max size, we want to
                                    // retain the original size when drawing the image (which should be smaller)
                                    width,
                                    height
                                ]
                            }
                        ]
                    });
                };
                return worker;
            }
        },
        {
            key: "initCanvasFPSObserver",
            value: function initCanvasFPSObserver() {
                var _this = this;
                var rafId;
                if (!this.windows.length && !this.shadowDoms.size) return;
                var rafCallback = function(timestamp) {
                    _this.takeSnapshot(timestamp, false);
                    rafId = onRequestAnimationFrame(rafCallback);
                };
                rafId = onRequestAnimationFrame(rafCallback);
                this.restoreHandlers.push(function() {
                    if (rafId) cancelAnimationFrame(rafId);
                });
            }
        },
        {
            key: "initCanvasMutationObserver",
            value: function initCanvasMutationObserver(win, blockClass, blockSelector, unblockSelector) {
                var canvasContextReset = initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector, false);
                var canvas2DReset = initCanvas2DMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector, unblockSelector);
                var canvasWebGL1and2Reset = initCanvasWebGLMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector, unblockSelector, this.mirror);
                this.restoreHandlers.push(function() {
                    canvasContextReset();
                    canvas2DReset();
                    canvasWebGL1and2Reset();
                });
            }
        },
        {
            /**
   * Returns all `canvas` elements that are not blocked by the given selectors. Searches all windows and shadow roots.
   */ key: "getCanvasElements",
            value: function getCanvasElements(blockClass, blockSelector, unblockSelector) {
                var matchedCanvas = [];
                var searchCanvas = function(root) {
                    root.querySelectorAll("canvas").forEach(function(canvas) {
                        if (!isBlocked(canvas, blockClass, blockSelector, unblockSelector, true)) matchedCanvas.push(canvas);
                    });
                };
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.windows[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var item = _step.value;
                        var window2 = item.deref();
                        var _document = void 0;
                        try {
                            _document = window2 && window2.document;
                        } catch (e) {}
                        if (_document) searchCanvas(_document);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = this.shadowDoms[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var item1 = _step1.value;
                        var shadowRoot = item1.deref();
                        if (shadowRoot) searchCanvas(shadowRoot);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                return matchedCanvas;
            }
        },
        {
            /**
   * Takes a snapshot of the provided canvas element, or will search all windows/shadow roots for canvases. Will self-throttle based on `options.sampling`.
   *
   * @returns `true` if the snapshot was taken, `false` if it was throttled.
   */ key: "takeSnapshot",
            value: function takeSnapshot(timestamp, isManualSnapshot, canvasElement) {
                var _this = this;
                var _this_options = this.options, sampling = _this_options.sampling, blockClass = _this_options.blockClass, blockSelector = _this_options.blockSelector, unblockSelector = _this_options.unblockSelector, dataURLOptions = _this_options.dataURLOptions, maxCanvasSize = _this_options.maxCanvasSize;
                var fps = sampling === "all" ? 2 : sampling || 2;
                var timeBetweenSnapshots = 1e3 / fps;
                var shouldThrottle = this.lastSnapshotTime && timestamp - this.lastSnapshotTime < timeBetweenSnapshots;
                if (shouldThrottle) return false;
                this.lastSnapshotTime = timestamp;
                var canvases = canvasElement ? [
                    canvasElement
                ] : this.getCanvasElements(blockClass, blockSelector, unblockSelector);
                canvases.forEach(function(canvas) {
                    var id = _this.mirror.getId(canvas);
                    if (!_this.mirror.hasNode(canvas) || !canvas.width || !canvas.height || _this.snapshotInProgressMap.get(id)) return;
                    _this.snapshotInProgressMap.set(id, true);
                    if (!isManualSnapshot && [
                        "webgl",
                        "webgl2"
                    ].includes(canvas.__context)) {
                        var _context_getContextAttributes;
                        var context = canvas.getContext(canvas.__context);
                        if ((context === null || context === void 0 ? void 0 : (_context_getContextAttributes = context.getContextAttributes()) === null || _context_getContextAttributes === void 0 ? void 0 : _context_getContextAttributes.preserveDrawingBuffer) === false) context.clear(context.COLOR_BUFFER_BIT);
                    }
                    createImageBitmap(canvas).then(function(bitmap) {
                        var _this_worker;
                        (_this_worker = _this.worker) === null || _this_worker === void 0 ? void 0 : _this_worker.postMessage({
                            id: id,
                            bitmap: bitmap,
                            width: canvas.width,
                            height: canvas.height,
                            dataURLOptions: dataURLOptions,
                            maxCanvasSize: maxCanvasSize
                        }, [
                            bitmap
                        ]);
                    }).catch(function(error) {
                        callbackWrapper(function() {
                            _this.snapshotInProgressMap.delete(id);
                            throw error;
                        })();
                    });
                });
                return true;
            }
        },
        {
            key: "startPendingCanvasMutationFlusher",
            value: function startPendingCanvasMutationFlusher() {
                var _this = this;
                onRequestAnimationFrame(function() {
                    return _this.flushPendingCanvasMutations();
                });
            }
        },
        {
            key: "startRAFTimestamping",
            value: function startRAFTimestamping() {
                var _this = this;
                var setLatestRAFTimestamp = function(timestamp) {
                    _this.rafStamps.latestId = timestamp;
                    onRequestAnimationFrame(setLatestRAFTimestamp);
                };
                onRequestAnimationFrame(setLatestRAFTimestamp);
            }
        },
        {
            key: "flushPendingCanvasMutations",
            value: function flushPendingCanvasMutations() {
                var _this = this;
                this.pendingCanvasMutations.forEach(function(_values, canvas) {
                    var id = _this.mirror.getId(canvas);
                    _this.flushPendingCanvasMutationFor(canvas, id);
                });
                onRequestAnimationFrame(function() {
                    return _this.flushPendingCanvasMutations();
                });
            }
        },
        {
            key: "flushPendingCanvasMutationFor",
            value: function flushPendingCanvasMutationFor(canvas, id) {
                if (this.frozen || this.locked) return;
                var valuesWithType = this.pendingCanvasMutations.get(canvas);
                if (!valuesWithType || id === -1) return;
                var values = valuesWithType.map(function(value) {
                    var type2 = value.type, rest = (0, _objectWithoutProperties._)(value, [
                        "type"
                    ]);
                    return rest;
                });
                var type = valuesWithType[0].type;
                this.mutationCb({
                    id: id,
                    type: type,
                    commands: values
                });
                this.pendingCanvasMutations.delete(canvas);
            }
        }
    ]);
    return CanvasManager;
}();
try {
    if (Array.from([
        1
    ], function(x) {
        return x * 2;
    })[0] !== 2) {
        var _cleanFrame_contentWindow;
        var cleanFrame = document.createElement("iframe");
        document.body.appendChild(cleanFrame);
        Array.from = ((_cleanFrame_contentWindow = cleanFrame.contentWindow) === null || _cleanFrame_contentWindow === void 0 ? void 0 : _cleanFrame_contentWindow.Array.from) || Array.from;
        document.body.removeChild(cleanFrame);
    }
} catch (err) {
    console.debug("Unable to override Array.from", err);
}
createMirror$2();
var n;
!function(t2) {
    t2[t2.NotStarted = 0] = "NotStarted", t2[t2.Running = 1] = "Running", t2[t2.Stopped = 2] = "Stopped";
}(n || (n = {}));
var CANVAS_QUALITY = {
    low: {
        sampling: {
            canvas: 1
        },
        dataURLOptions: {
            type: 'image/webp',
            quality: 0.25
        }
    },
    medium: {
        sampling: {
            canvas: 2
        },
        dataURLOptions: {
            type: 'image/webp',
            quality: 0.4
        }
    },
    high: {
        sampling: {
            canvas: 4
        },
        dataURLOptions: {
            type: 'image/webp',
            quality: 0.5
        }
    }
};
var INTEGRATION_NAME = 'ReplayCanvas';
var DEFAULT_MAX_CANVAS_SIZE = 1280;
/** Exported only for type safe tests. */ var _replayCanvasIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _ref = (0, _slicedToArray._)(options.maxCanvasSize || [], 2), maxCanvasWidth = _ref[0], maxCanvasHeight = _ref[1];
    var _canvasOptions = {
        quality: options.quality || 'medium',
        enableManualSnapshot: options.enableManualSnapshot,
        maxCanvasSize: [
            maxCanvasWidth ? Math.min(maxCanvasWidth, DEFAULT_MAX_CANVAS_SIZE) : DEFAULT_MAX_CANVAS_SIZE,
            maxCanvasHeight ? Math.min(maxCanvasHeight, DEFAULT_MAX_CANVAS_SIZE) : DEFAULT_MAX_CANVAS_SIZE
        ]
    };
    var canvasManagerResolve;
    var _canvasManager = new Promise(function(resolve) {
        return canvasManagerResolve = resolve;
    });
    return {
        name: INTEGRATION_NAME,
        getOptions: function getOptions() {
            var quality = _canvasOptions.quality, enableManualSnapshot = _canvasOptions.enableManualSnapshot, maxCanvasSize = _canvasOptions.maxCanvasSize;
            return (0, _objectSpread._)({
                enableManualSnapshot: enableManualSnapshot,
                recordCanvas: true,
                getCanvasManager: function(getCanvasManagerOptions) {
                    var manager = new CanvasManager((0, _objectSpreadProps._)((0, _objectSpread._)({}, getCanvasManagerOptions), {
                        enableManualSnapshot: enableManualSnapshot,
                        maxCanvasSize: maxCanvasSize,
                        errorHandler: function(err) {
                            try {
                                if ((typeof err === "undefined" ? "undefined" : (0, _typeOf._)(err)) === 'object') err.__rrweb__ = true;
                            } catch (e) {
                            // ignore errors here
                            // this can happen if the error is frozen or does not allow mutation for other reasons
                            }
                        }
                    }));
                    canvasManagerResolve(manager);
                    return manager;
                }
            }, CANVAS_QUALITY[quality] || CANVAS_QUALITY.medium);
        },
        snapshot: function snapshot(canvasElement, options) {
            return (0, _asyncToGenerator._)(function() {
                var canvasManager;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _canvasManager
                            ];
                        case 1:
                            canvasManager = _state.sent();
                            canvasManager.snapshot(canvasElement, options);
                            return [
                                2
                            ];
                    }
                });
            })();
        }
    };
};
/**
 * Add this in addition to `replayIntegration()` to enable canvas recording.
 */ var replayCanvasIntegration = (0, _core.defineIntegration)(_replayCanvasIntegration);

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_to_consumable_array":"1eSZf","@swc/helpers/_/_type_of":"iFJdx","@swc/helpers/_/_ts_generator":"78Tqx","@sentry/core":"lqtxA","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iYAFH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultRequestInstrumentationOptions", function() {
    return defaultRequestInstrumentationOptions;
});
parcelHelpers.export(exports, "instrumentOutgoingRequests", function() {
    return instrumentOutgoingRequests;
});
parcelHelpers.export(exports, "shouldAttachHeaders", function() {
    return shouldAttachHeaders;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _core = require("@sentry/core");
var _browserUtils = require("@sentry-internal/browser-utils");
var _utilsJs = require("./utils.js");
/** Options for Request Instrumentation */ var responseToSpanId = new WeakMap();
var spanIdToEndTimestamp = new Map();
var defaultRequestInstrumentationOptions = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    trackFetchStreamPerformance: false
};
/** Registers span creators for xhr and fetch requests  */ function instrumentOutgoingRequests(client, _options) {
    var _$_object_spread = (0, _objectSpread._)({}, defaultRequestInstrumentationOptions, _options), traceFetch = _$_object_spread.traceFetch, traceXHR = _$_object_spread.traceXHR, trackFetchStreamPerformance = _$_object_spread.trackFetchStreamPerformance, shouldCreateSpanForRequest = _$_object_spread.shouldCreateSpanForRequest, enableHTTPTimings = _$_object_spread.enableHTTPTimings, tracePropagationTargets = _$_object_spread.tracePropagationTargets, onRequestSpanStart = _$_object_spread.onRequestSpanStart, onRequestSpanEnd = _$_object_spread.onRequestSpanEnd;
    var shouldCreateSpan = typeof shouldCreateSpanForRequest === 'function' ? shouldCreateSpanForRequest : function(_) {
        return true;
    };
    var shouldAttachHeadersWithTargets = function(url) {
        return shouldAttachHeaders(url, tracePropagationTargets);
    };
    var spans = {};
    var propagateTraceparent = client.getOptions().propagateTraceparent;
    if (traceFetch) {
        // Keeping track of http requests, whose body payloads resolved later than the initial resolved request
        // e.g. streaming using server sent events (SSE)
        client.addEventProcessor(function(event) {
            if (event.type === 'transaction' && event.spans) event.spans.forEach(function(span) {
                if (span.op === 'http.client') {
                    var updatedTimestamp = spanIdToEndTimestamp.get(span.span_id);
                    if (updatedTimestamp) {
                        span.timestamp = updatedTimestamp / 1000;
                        spanIdToEndTimestamp.delete(span.span_id);
                    }
                }
            });
            return event;
        });
        if (trackFetchStreamPerformance) (0, _core.addFetchEndInstrumentationHandler)(function(handlerData) {
            if (handlerData.response) {
                var span = responseToSpanId.get(handlerData.response);
                if (span && handlerData.endTimestamp) spanIdToEndTimestamp.set(span, handlerData.endTimestamp);
            }
        });
        (0, _core.addFetchInstrumentationHandler)(function(handlerData) {
            var createdSpan = (0, _core.instrumentFetchRequest)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans, {
                propagateTraceparent: propagateTraceparent,
                onRequestSpanEnd: onRequestSpanEnd
            });
            if (handlerData.response && handlerData.fetchData.__span) responseToSpanId.set(handlerData.response, handlerData.fetchData.__span);
            // We cannot use `window.location` in the generic fetch instrumentation,
            // but we need it for reliable `server.address` attribute.
            // so we extend this in here
            if (createdSpan) {
                var fullUrl = (0, _utilsJs.getFullURL)(handlerData.fetchData.url);
                var host = fullUrl ? (0, _core.parseUrl)(fullUrl).host : undefined;
                createdSpan.setAttributes({
                    'http.url': fullUrl,
                    'server.address': host
                });
                if (enableHTTPTimings) addHTTPTimings(createdSpan);
                onRequestSpanStart === null || onRequestSpanStart === void 0 ? void 0 : onRequestSpanStart(createdSpan, {
                    headers: handlerData.headers
                });
            }
        });
    }
    if (traceXHR) (0, _browserUtils.addXhrInstrumentationHandler)(function(handlerData) {
        var createdSpan = xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans, propagateTraceparent, onRequestSpanEnd);
        if (createdSpan) {
            var _handlerData_xhr___sentry_xhr_v3__;
            if (enableHTTPTimings) addHTTPTimings(createdSpan);
            onRequestSpanStart === null || onRequestSpanStart === void 0 ? void 0 : onRequestSpanStart(createdSpan, {
                headers: (0, _utilsJs.createHeadersSafely)((_handlerData_xhr___sentry_xhr_v3__ = handlerData.xhr.__sentry_xhr_v3__) === null || _handlerData_xhr___sentry_xhr_v3__ === void 0 ? void 0 : _handlerData_xhr___sentry_xhr_v3__.request_headers)
            });
        }
    });
}
/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */ function addHTTPTimings(span) {
    var url = (0, _core.spanToJSON)(span).data.url;
    if (!url || typeof url !== 'string') return;
    var cleanup = (0, _browserUtils.addPerformanceInstrumentationHandler)('resource', function(param) {
        var entries = param.entries;
        entries.forEach(function(entry) {
            if ((0, _utilsJs.isPerformanceResourceTiming)(entry) && entry.name.endsWith(url)) {
                span.setAttributes((0, _browserUtils.resourceTimingToSpanAttributes)(entry));
                // In the next tick, clean this handler up
                // We have to wait here because otherwise this cleans itself up before it is fully done
                setTimeout(cleanup);
            }
        });
    });
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * We only export this function for testing purposes.
 */ function shouldAttachHeaders(targetUrl, tracePropagationTargets) {
    // window.location.href not being defined is an edge case in the browser but we need to handle it.
    // Potentially dangerous situations where it may not be defined: Browser Extensions, Web Workers, patching of the location obj
    var href = (0, _core.getLocationHref)();
    if (!href) {
        // If there is no window.location.origin, we default to only attaching tracing headers to relative requests, i.e. ones that start with `/`
        // BIG DISCLAIMER: Users can call URLs with a double slash (fetch("//example.com/api")), this is a shorthand for "send to the same protocol",
        // so we need a to exclude those requests, because they might be cross origin.
        var isRelativeSameOriginRequest = !!targetUrl.match(/^\/(?!\/)/);
        if (!tracePropagationTargets) return isRelativeSameOriginRequest;
        else return (0, _core.stringMatchesSomePattern)(targetUrl, tracePropagationTargets);
    } else {
        var resolvedUrl;
        var currentOrigin;
        // URL parsing may fail, we default to not attaching trace headers in that case.
        try {
            resolvedUrl = new URL(targetUrl, href);
            currentOrigin = new URL(href).origin;
        } catch (e) {
            return false;
        }
        var isSameOriginRequest = resolvedUrl.origin === currentOrigin;
        if (!tracePropagationTargets) return isSameOriginRequest;
        else return (0, _core.stringMatchesSomePattern)(resolvedUrl.toString(), tracePropagationTargets) || isSameOriginRequest && (0, _core.stringMatchesSomePattern)(resolvedUrl.pathname, tracePropagationTargets);
    }
}
/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ function xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, propagateTraceparent, onRequestSpanEnd) {
    var xhr = handlerData.xhr;
    var sentryXhrData = xhr === null || xhr === void 0 ? void 0 : xhr[0, _browserUtils.SENTRY_XHR_DATA_KEY];
    if (!xhr || xhr.__sentry_own_request__ || !sentryXhrData) return undefined;
    var url = sentryXhrData.url, method = sentryXhrData.method;
    var shouldCreateSpanResult = (0, _core.hasSpansEnabled)() && shouldCreateSpan(url);
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        var spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        var span = spans[spanId];
        if (span && sentryXhrData.status_code !== undefined) {
            (0, _core.setHttpStatus)(span, sentryXhrData.status_code);
            span.end();
            onRequestSpanEnd === null || onRequestSpanEnd === void 0 ? void 0 : onRequestSpanEnd(span, {
                headers: (0, _utilsJs.createHeadersSafely)((0, _browserUtils.parseXhrResponseHeaders)(xhr)),
                error: handlerData.error
            });
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    var fullUrl = (0, _utilsJs.getFullURL)(url);
    var parsedUrl = fullUrl ? (0, _core.parseUrl)(fullUrl) : (0, _core.parseUrl)(url);
    var urlForSpanName = (0, _core.stripUrlQueryAndFragment)(url);
    var hasParent = !!(0, _core.getActiveSpan)();
    var _obj;
    var span1 = shouldCreateSpanResult && hasParent ? (0, _core.startInactiveSpan)({
        name: "".concat(method, " ").concat(urlForSpanName),
        attributes: (0, _objectSpread._)((_obj = {
            url: url,
            type: 'xhr',
            'http.method': method,
            'http.url': fullUrl,
            'server.address': parsedUrl === null || parsedUrl === void 0 ? void 0 : parsedUrl.host
        }, (0, _defineProperty._)(_obj, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), 'auto.http.browser'), (0, _defineProperty._)(_obj, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_OP), 'http.client'), _obj), (parsedUrl === null || parsedUrl === void 0 ? void 0 : parsedUrl.search) && {
            'http.query': parsedUrl === null || parsedUrl === void 0 ? void 0 : parsedUrl.search
        }, (parsedUrl === null || parsedUrl === void 0 ? void 0 : parsedUrl.hash) && {
            'http.fragment': parsedUrl === null || parsedUrl === void 0 ? void 0 : parsedUrl.hash
        })
    }) : new (0, _core.SentryNonRecordingSpan)();
    xhr.__sentry_xhr_span_id__ = span1.spanContext().spanId;
    spans[xhr.__sentry_xhr_span_id__] = span1;
    if (shouldAttachHeaders(url)) addTracingHeadersToXhrRequest(xhr, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
    // we do not want to use the span as base for the trace headers,
    // which means that the headers will be generated from the scope and the sampling decision is deferred
    (0, _core.hasSpansEnabled)() && hasParent ? span1 : undefined, propagateTraceparent);
    var client = (0, _core.getClient)();
    if (client) client.emit('beforeOutgoingRequestSpan', span1, handlerData);
    return span1;
}
function addTracingHeadersToXhrRequest(xhr, span, propagateTraceparent) {
    var _getTraceData = (0, _core.getTraceData)({
        span: span,
        propagateTraceparent: propagateTraceparent
    }), sentryTrace = _getTraceData['sentry-trace'], baggage = _getTraceData.baggage, traceparent = _getTraceData.traceparent;
    if (sentryTrace) setHeaderOnXhr(xhr, sentryTrace, baggage, traceparent);
}
function setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader, traceparentHeader) {
    var _xhr___sentry_xhr_v3__;
    var originalHeaders = (_xhr___sentry_xhr_v3__ = xhr.__sentry_xhr_v3__) === null || _xhr___sentry_xhr_v3__ === void 0 ? void 0 : _xhr___sentry_xhr_v3__.request_headers;
    if ((originalHeaders === null || originalHeaders === void 0 ? void 0 : originalHeaders['sentry-trace']) || !xhr.setRequestHeader) // bail if a sentry-trace header is already set
    return;
    try {
        xhr.setRequestHeader('sentry-trace', sentryTraceHeader);
        if (traceparentHeader && !(originalHeaders === null || originalHeaders === void 0 ? void 0 : originalHeaders['traceparent'])) xhr.setRequestHeader('traceparent', traceparentHeader);
        if (sentryBaggageHeader) {
            // only add our headers if
            // - no pre-existing baggage header exists
            // - or it is set and doesn't yet contain sentry values
            var originalBaggageHeader = originalHeaders === null || originalHeaders === void 0 ? void 0 : originalHeaders['baggage'];
            if (!originalBaggageHeader || !(0, _utilsJs.baggageHeaderHasSentryValues)(originalBaggageHeader)) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
            // We can therefore simply set a baggage header without checking what was there before
            // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
            xhr.setRequestHeader('baggage', sentryBaggageHeader);
        }
    } catch (e) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
    }
}

},{"@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_object_spread":"9gdrV","@sentry/core":"lqtxA","@sentry-internal/browser-utils":"hXSTf","./utils.js":"8GMCM","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8GMCM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "baggageHeaderHasSentryValues", function() {
    return baggageHeaderHasSentryValues;
});
parcelHelpers.export(exports, "createHeadersSafely", function() {
    return createHeadersSafely;
});
parcelHelpers.export(exports, "getFullURL", function() {
    return getFullURL;
});
parcelHelpers.export(exports, "isPerformanceResourceTiming", function() {
    return isPerformanceResourceTiming;
});
var _helpersJs = require("../helpers.js");
/**
 * Checks if the baggage header has Sentry values.
 */ function baggageHeaderHasSentryValues(baggageHeader) {
    return baggageHeader.split(',').some(function(value) {
        return value.trim().startsWith('sentry-');
    });
}
/**
 * Gets the full URL from a given URL string.
 */ function getFullURL(url) {
    try {
        // By adding a base URL to new URL(), this will also work for relative urls
        // If `url` is a full URL, the base URL is ignored anyhow
        var parsed = new URL(url, (0, _helpersJs.WINDOW).location.origin);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}
/**
 * Checks if the entry is a PerformanceResourceTiming.
 */ function isPerformanceResourceTiming(entry) {
    return entry.entryType === 'resource' && 'initiatorType' in entry && typeof entry.nextHopProtocol === 'string' && (entry.initiatorType === 'fetch' || entry.initiatorType === 'xmlhttprequest');
}
/**
 * Creates a Headers object from a record of string key-value pairs, and returns undefined if it fails.
 */ function createHeadersSafely(headers) {
    try {
        return new Headers(headers);
    } catch (e) {
        // noop
        return undefined;
    }
}

},{"../helpers.js":"45G1f","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hs3de":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BROWSER_TRACING_INTEGRATION_ID", function() {
    return BROWSER_TRACING_INTEGRATION_ID;
});
parcelHelpers.export(exports, "browserTracingIntegration", function() {
    return browserTracingIntegration;
});
parcelHelpers.export(exports, "getMetaContent", function() {
    return getMetaContent;
});
parcelHelpers.export(exports, "startBrowserTracingNavigationSpan", function() {
    return startBrowserTracingNavigationSpan;
});
parcelHelpers.export(exports, "startBrowserTracingPageLoadSpan", function() {
    return startBrowserTracingPageLoadSpan;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@sentry/core");
var _browserUtils = require("@sentry-internal/browser-utils");
var _debugBuildJs = require("../debug-build.js");
var _helpersJs = require("../helpers.js");
var _backgroundtabJs = require("./backgroundtab.js");
var _linkedTracesJs = require("./linkedTraces.js");
var _requestJs = require("./request.js");
var BROWSER_TRACING_INTEGRATION_ID = 'BrowserTracing';
var DEFAULT_BROWSER_TRACING_OPTIONS = (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _core.TRACING_DEFAULTS)), {
    instrumentNavigation: true,
    instrumentPageLoad: true,
    markBackgroundSpan: true,
    enableLongTask: true,
    enableLongAnimationFrame: true,
    enableInp: true,
    enableElementTiming: true,
    ignoreResourceSpans: [],
    ignorePerformanceApiSpans: [],
    detectRedirects: true,
    linkPreviousTrace: 'in-memory',
    consistentTraceSampling: false,
    enableReportPageLoaded: false,
    _experiments: {}
}), (0, _requestJs.defaultRequestInstrumentationOptions));
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library.
 *
 * We explicitly export the proper type here, as this has to be extended in some cases.
 */ var browserTracingIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var latestRoute = {
        name: undefined,
        source: undefined
    };
    /**
   * This is just a small wrapper that makes `document` optional.
   * We want to be extra-safe and always check that this exists, to ensure weird environments do not blow up.
   */ var optionalWindowDocument = (0, _helpersJs.WINDOW).document;
    var _$_object_spread = (0, _objectSpread._)({}, DEFAULT_BROWSER_TRACING_OPTIONS, options), enableInp = _$_object_spread.enableInp, enableElementTiming = _$_object_spread.enableElementTiming, enableLongTask = _$_object_spread.enableLongTask, enableLongAnimationFrame = _$_object_spread.enableLongAnimationFrame, _object_spread__experiments = _$_object_spread._experiments, enableInteractions = _object_spread__experiments.enableInteractions, enableStandaloneClsSpans = _object_spread__experiments.enableStandaloneClsSpans, enableStandaloneLcpSpans = _object_spread__experiments.enableStandaloneLcpSpans, beforeStartSpan = _$_object_spread.beforeStartSpan, idleTimeout = _$_object_spread.idleTimeout, finalTimeout = _$_object_spread.finalTimeout, childSpanTimeout = _$_object_spread.childSpanTimeout, markBackgroundSpan = _$_object_spread.markBackgroundSpan, traceFetch = _$_object_spread.traceFetch, traceXHR = _$_object_spread.traceXHR, trackFetchStreamPerformance = _$_object_spread.trackFetchStreamPerformance, shouldCreateSpanForRequest = _$_object_spread.shouldCreateSpanForRequest, enableHTTPTimings = _$_object_spread.enableHTTPTimings, ignoreResourceSpans = _$_object_spread.ignoreResourceSpans, ignorePerformanceApiSpans = _$_object_spread.ignorePerformanceApiSpans, instrumentPageLoad = _$_object_spread.instrumentPageLoad, instrumentNavigation = _$_object_spread.instrumentNavigation, detectRedirects = _$_object_spread.detectRedirects, linkPreviousTrace = _$_object_spread.linkPreviousTrace, consistentTraceSampling = _$_object_spread.consistentTraceSampling, enableReportPageLoaded = _$_object_spread.enableReportPageLoaded, onRequestSpanStart = _$_object_spread.onRequestSpanStart, onRequestSpanEnd = _$_object_spread.onRequestSpanEnd;
    var _collectWebVitals;
    var lastInteractionTimestamp;
    var _pageloadSpan;
    /** Create routing idle transaction. */ function _createRouteSpan(client, startSpanOptions) {
        var makeActive = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
        var isPageloadSpan = startSpanOptions.op === 'pageload';
        var initialSpanName = startSpanOptions.name;
        var finalStartSpanOptions = beforeStartSpan ? beforeStartSpan(startSpanOptions) : startSpanOptions;
        var attributes = finalStartSpanOptions.attributes || {};
        // If `finalStartSpanOptions.name` is different than `startSpanOptions.name`
        // it is because `beforeStartSpan` set a custom name. Therefore we set the source to 'custom'.
        if (initialSpanName !== finalStartSpanOptions.name) {
            attributes[0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = 'custom';
            finalStartSpanOptions.attributes = attributes;
        }
        if (!makeActive) {
            // We want to ensure this has 0s duration
            var now = (0, _core.dateTimestampInSeconds)();
            (0, _core.startInactiveSpan)((0, _objectSpreadProps._)((0, _objectSpread._)({}, finalStartSpanOptions), {
                startTime: now
            })).end(now);
            return;
        }
        latestRoute.name = finalStartSpanOptions.name;
        latestRoute.source = attributes[0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
        var idleSpan = (0, _core.startIdleSpan)(finalStartSpanOptions, {
            idleTimeout: idleTimeout,
            finalTimeout: finalTimeout,
            childSpanTimeout: childSpanTimeout,
            // should wait for finish signal if it's a pageload transaction
            disableAutoFinish: isPageloadSpan,
            beforeSpanEnd: function(span) {
                // This will generally always be defined here, because it is set in `setup()` of the integration
                // but technically, it is optional, so we guard here to be extra safe
                _collectWebVitals === null || _collectWebVitals === void 0 ? void 0 : _collectWebVitals();
                (0, _browserUtils.addPerformanceEntries)(span, {
                    recordClsOnPageloadSpan: !enableStandaloneClsSpans,
                    recordLcpOnPageloadSpan: !enableStandaloneLcpSpans,
                    ignoreResourceSpans: ignoreResourceSpans,
                    ignorePerformanceApiSpans: ignorePerformanceApiSpans
                });
                setActiveIdleSpan(client, undefined);
                // A trace should stay consistent over the entire timespan of one route - even after the pageload/navigation ended.
                // Only when another navigation happens, we want to create a new trace.
                // This way, e.g. errors that occur after the pageload span ended are still associated to the pageload trace.
                var scope = (0, _core.getCurrentScope)();
                var oldPropagationContext = scope.getPropagationContext();
                scope.setPropagationContext((0, _objectSpreadProps._)((0, _objectSpread._)({}, oldPropagationContext), {
                    traceId: idleSpan.spanContext().traceId,
                    sampled: (0, _core.spanIsSampled)(idleSpan),
                    dsc: (0, _core.getDynamicSamplingContextFromSpan)(span)
                }));
                if (isPageloadSpan) // clean up the stored pageload span on the intergration.
                _pageloadSpan = undefined;
            },
            trimIdleSpanEndTimestamp: !enableReportPageLoaded
        });
        if (isPageloadSpan && enableReportPageLoaded) _pageloadSpan = idleSpan;
        setActiveIdleSpan(client, idleSpan);
        function emitFinish() {
            if (optionalWindowDocument && [
                'interactive',
                'complete'
            ].includes(optionalWindowDocument.readyState)) client.emit('idleSpanEnableAutoFinish', idleSpan);
        }
        // Enable auto finish of the pageload span if users are not explicitly ending it
        if (isPageloadSpan && !enableReportPageLoaded && optionalWindowDocument) {
            optionalWindowDocument.addEventListener('readystatechange', function() {
                emitFinish();
            });
            emitFinish();
        }
    }
    return {
        name: BROWSER_TRACING_INTEGRATION_ID,
        setup: function setup(client) {
            (0, _core.registerSpanErrorInstrumentation)();
            _collectWebVitals = (0, _browserUtils.startTrackingWebVitals)({
                recordClsStandaloneSpans: enableStandaloneClsSpans || false,
                recordLcpStandaloneSpans: enableStandaloneLcpSpans || false,
                client: client
            });
            if (enableInp) (0, _browserUtils.startTrackingINP)();
            if (enableElementTiming) (0, _browserUtils.startTrackingElementTiming)();
            if (enableLongAnimationFrame && (0, _core.GLOBAL_OBJ).PerformanceObserver && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.includes('long-animation-frame')) (0, _browserUtils.startTrackingLongAnimationFrames)();
            else if (enableLongTask) (0, _browserUtils.startTrackingLongTasks)();
            if (enableInteractions) (0, _browserUtils.startTrackingInteractions)();
            if (detectRedirects && optionalWindowDocument) {
                var interactionHandler = function() {
                    lastInteractionTimestamp = (0, _core.timestampInSeconds)();
                };
                addEventListener('click', interactionHandler, {
                    capture: true
                });
                addEventListener('keydown', interactionHandler, {
                    capture: true,
                    passive: true
                });
            }
            function maybeEndActiveSpan() {
                var activeSpan = getActiveIdleSpan(client);
                if (activeSpan && !(0, _core.spanToJSON)(activeSpan).timestamp) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).log("[Tracing] Finishing current active span with op: ".concat((0, _core.spanToJSON)(activeSpan).op));
                    // If there's an open active span, we need to finish it before creating an new one.
                    activeSpan.setAttribute((0, _core.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON), 'cancelled');
                    activeSpan.end();
                }
            }
            client.on('startNavigationSpan', function(startSpanOptions, navigationOptions) {
                if ((0, _core.getClient)() !== client) return;
                if (navigationOptions === null || navigationOptions === void 0 ? void 0 : navigationOptions.isRedirect) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).warn('[Tracing] Detected redirect, navigation span will not be the root span, but a child span.');
                    _createRouteSpan(client, (0, _objectSpread._)({
                        op: 'navigation.redirect'
                    }, startSpanOptions), false);
                    return;
                }
                // Reset the last interaction timestamp since we now start a new navigation.
                // Any subsequent navigation span starts could again be a redirect, so we
                // should reset our heuristic detectors.
                lastInteractionTimestamp = undefined;
                maybeEndActiveSpan();
                (0, _core.getIsolationScope)().setPropagationContext({
                    traceId: (0, _core.generateTraceId)(),
                    sampleRand: Math.random(),
                    propagationSpanId: (0, _core.hasSpansEnabled)() ? undefined : (0, _core.generateSpanId)()
                });
                var scope = (0, _core.getCurrentScope)();
                scope.setPropagationContext({
                    traceId: (0, _core.generateTraceId)(),
                    sampleRand: Math.random(),
                    propagationSpanId: (0, _core.hasSpansEnabled)() ? undefined : (0, _core.generateSpanId)()
                });
                // We reset this to ensure we do not have lingering incorrect data here
                // places that call this hook may set this where appropriate - else, the URL at span sending time is used
                scope.setSDKProcessingMetadata({
                    normalizedRequest: undefined
                });
                _createRouteSpan(client, (0, _objectSpreadProps._)((0, _objectSpread._)({
                    op: 'navigation'
                }, startSpanOptions), {
                    // Navigation starts a new trace and is NOT parented under any active interaction (e.g. ui.action.click)
                    parentSpan: null,
                    forceTransaction: true
                }));
            });
            client.on('startPageLoadSpan', function(startSpanOptions) {
                var traceOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                if ((0, _core.getClient)() !== client) return;
                maybeEndActiveSpan();
                var sentryTrace = traceOptions.sentryTrace || getMetaContent('sentry-trace');
                var baggage = traceOptions.baggage || getMetaContent('baggage');
                var propagationContext = (0, _core.propagationContextFromHeaders)(sentryTrace, baggage);
                var scope = (0, _core.getCurrentScope)();
                scope.setPropagationContext(propagationContext);
                if (!(0, _core.hasSpansEnabled)()) // for browser, we wanna keep the spanIds consistent during the entire lifetime of the trace
                // this works by setting the propagationSpanId to a random spanId so that we have a consistent
                // span id to propagate in TwP mode (!hasSpansEnabled())
                scope.getPropagationContext().propagationSpanId = (0, _core.generateSpanId)();
                // We store the normalized request data on the scope, so we get the request data at time of span creation
                // otherwise, the URL etc. may already be of the following navigation, and we'd report the wrong URL
                scope.setSDKProcessingMetadata({
                    normalizedRequest: (0, _helpersJs.getHttpRequestData)()
                });
                _createRouteSpan(client, (0, _objectSpread._)({
                    op: 'pageload'
                }, startSpanOptions));
            });
            client.on('endPageloadSpan', function() {
                if (enableReportPageLoaded && _pageloadSpan) {
                    _pageloadSpan.setAttribute((0, _core.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON), 'reportPageLoaded');
                    _pageloadSpan.end();
                }
            });
        },
        afterAllSetup: function afterAllSetup(client) {
            var startingUrl = (0, _core.getLocationHref)();
            if (linkPreviousTrace !== 'off') (0, _linkedTracesJs.linkTraces)(client, {
                linkPreviousTrace: linkPreviousTrace,
                consistentTraceSampling: consistentTraceSampling
            });
            if ((0, _helpersJs.WINDOW).location) {
                if (instrumentPageLoad) {
                    var origin = (0, _core.browserPerformanceTimeOrigin)();
                    var _obj;
                    startBrowserTracingPageLoadSpan(client, {
                        name: (0, _helpersJs.WINDOW).location.pathname,
                        // pageload should always start at timeOrigin (and needs to be in s, not ms)
                        startTime: origin ? origin / 1000 : undefined,
                        attributes: (_obj = {}, (0, _defineProperty._)(_obj, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), 'url'), (0, _defineProperty._)(_obj, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), 'auto.pageload.browser'), _obj)
                    });
                }
                if (instrumentNavigation) (0, _browserUtils.addHistoryInstrumentationHandler)(function(param) {
                    var to = param.to, from = param.from;
                    /**
             * This early return is there to account for some cases where a navigation transaction starts right after
             * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
             * create an uneccessary navigation transaction.
             *
             * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
             * only be caused in certain development environments where the usage of a hot module reloader is causing
             * errors.
             */ if (from === undefined && (startingUrl === null || startingUrl === void 0 ? void 0 : startingUrl.indexOf(to)) !== -1) {
                        startingUrl = undefined;
                        return;
                    }
                    startingUrl = undefined;
                    var parsed = (0, _core.parseStringToURLObject)(to);
                    var activeSpan = getActiveIdleSpan(client);
                    var navigationIsRedirect = activeSpan && detectRedirects && isRedirect(activeSpan, lastInteractionTimestamp);
                    var _obj;
                    startBrowserTracingNavigationSpan(client, {
                        name: (parsed === null || parsed === void 0 ? void 0 : parsed.pathname) || (0, _helpersJs.WINDOW).location.pathname,
                        attributes: (_obj = {}, (0, _defineProperty._)(_obj, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), 'url'), (0, _defineProperty._)(_obj, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), 'auto.navigation.browser'), _obj)
                    }, {
                        url: to,
                        isRedirect: navigationIsRedirect
                    });
                });
            }
            if (markBackgroundSpan) (0, _backgroundtabJs.registerBackgroundTabDetection)();
            if (enableInteractions) registerInteractionListener(client, idleTimeout, finalTimeout, childSpanTimeout, latestRoute);
            if (enableInp) (0, _browserUtils.registerInpInteractionListener)();
            (0, _requestJs.instrumentOutgoingRequests)(client, {
                traceFetch: traceFetch,
                traceXHR: traceXHR,
                trackFetchStreamPerformance: trackFetchStreamPerformance,
                tracePropagationTargets: client.getOptions().tracePropagationTargets,
                shouldCreateSpanForRequest: shouldCreateSpanForRequest,
                enableHTTPTimings: enableHTTPTimings,
                onRequestSpanStart: onRequestSpanStart,
                onRequestSpanEnd: onRequestSpanEnd
            });
        }
    };
};
/**
 * Manually start a page load span.
 * This will only do something if a browser tracing integration integration has been setup.
 *
 * If you provide a custom `traceOptions` object, it will be used to continue the trace
 * instead of the default behavior, which is to look it up on the <meta> tags.
 */ function startBrowserTracingPageLoadSpan(client, spanOptions, traceOptions) {
    client.emit('startPageLoadSpan', spanOptions, traceOptions);
    (0, _core.getCurrentScope)().setTransactionName(spanOptions.name);
    var pageloadSpan = getActiveIdleSpan(client);
    if (pageloadSpan) client.emit('afterStartPageLoadSpan', pageloadSpan);
    return pageloadSpan;
}
/**
 * Manually start a navigation span.
 * This will only do something if a browser tracing integration has been setup.
 */ function startBrowserTracingNavigationSpan(client, spanOptions, options) {
    var _ref = options || {}, url = _ref.url, isRedirect = _ref.isRedirect;
    client.emit('beforeStartNavigationSpan', spanOptions, {
        isRedirect: isRedirect
    });
    client.emit('startNavigationSpan', spanOptions, {
        isRedirect: isRedirect
    });
    var scope = (0, _core.getCurrentScope)();
    scope.setTransactionName(spanOptions.name);
    // We store the normalized request data on the scope, so we get the request data at time of span creation
    // otherwise, the URL etc. may already be of the following navigation, and we'd report the wrong URL
    if (url && !isRedirect) scope.setSDKProcessingMetadata({
        normalizedRequest: (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _helpersJs.getHttpRequestData)()), {
            url: url
        })
    });
    return getActiveIdleSpan(client);
}
/** Returns the value of a meta tag */ function getMetaContent(metaName) {
    /**
   * This is just a small wrapper that makes `document` optional.
   * We want to be extra-safe and always check that this exists, to ensure weird environments do not blow up.
   */ var optionalWindowDocument = (0, _helpersJs.WINDOW).document;
    var metaTag = optionalWindowDocument === null || optionalWindowDocument === void 0 ? void 0 : optionalWindowDocument.querySelector("meta[name=".concat(metaName, "]"));
    return (metaTag === null || metaTag === void 0 ? void 0 : metaTag.getAttribute('content')) || undefined;
}
/** Start listener for interaction transactions */ function registerInteractionListener(client, idleTimeout, finalTimeout, childSpanTimeout, latestRoute) {
    /**
   * This is just a small wrapper that makes `document` optional.
   * We want to be extra-safe and always check that this exists, to ensure weird environments do not blow up.
   */ var optionalWindowDocument = (0, _helpersJs.WINDOW).document;
    var inflightInteractionSpan;
    var registerInteractionTransaction = function() {
        var op = 'ui.action.click';
        var activeIdleSpan = getActiveIdleSpan(client);
        if (activeIdleSpan) {
            var currentRootSpanOp = (0, _core.spanToJSON)(activeIdleSpan).op;
            if ([
                'navigation',
                'pageload'
            ].includes(currentRootSpanOp)) {
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).warn("[Tracing] Did not create ".concat(op, " span because a pageload or navigation span is in progress."));
                return undefined;
            }
        }
        if (inflightInteractionSpan) {
            inflightInteractionSpan.setAttribute((0, _core.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON), 'interactionInterrupted');
            inflightInteractionSpan.end();
            inflightInteractionSpan = undefined;
        }
        if (!latestRoute.name) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).warn("[Tracing] Did not create ".concat(op, " transaction because _latestRouteName is missing."));
            return undefined;
        }
        inflightInteractionSpan = (0, _core.startIdleSpan)({
            name: latestRoute.name,
            op: op,
            attributes: (0, _defineProperty._)({}, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), latestRoute.source || 'url')
        }, {
            idleTimeout: idleTimeout,
            finalTimeout: finalTimeout,
            childSpanTimeout: childSpanTimeout
        });
    };
    if (optionalWindowDocument) addEventListener('click', registerInteractionTransaction, {
        capture: true
    });
}
// We store the active idle span on the client object, so we can access it from exported functions
var ACTIVE_IDLE_SPAN_PROPERTY = '_sentry_idleSpan';
function getActiveIdleSpan(client) {
    return client[ACTIVE_IDLE_SPAN_PROPERTY];
}
function setActiveIdleSpan(client, span) {
    (0, _core.addNonEnumerableProperty)(client, ACTIVE_IDLE_SPAN_PROPERTY, span);
}
// The max. time in seconds between two pageload/navigation spans that makes us consider the second one a redirect
var REDIRECT_THRESHOLD = 1.5;
function isRedirect(activeSpan, lastInteractionTimestamp) {
    var spanData = (0, _core.spanToJSON)(activeSpan);
    var now = (0, _core.dateTimestampInSeconds)();
    // More than REDIRECT_THRESHOLD seconds since last navigation/pageload span?
    // --> never consider this a redirect
    var startTimestamp = spanData.start_timestamp;
    if (now - startTimestamp > REDIRECT_THRESHOLD) return false;
    // A click happened in the last REDIRECT_THRESHOLD seconds?
    // --> never consider this a redirect
    if (lastInteractionTimestamp && now - lastInteractionTimestamp <= REDIRECT_THRESHOLD) return false;
    return true;
}

},{"@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@sentry/core":"lqtxA","@sentry-internal/browser-utils":"hXSTf","../debug-build.js":"55n2m","../helpers.js":"45G1f","./backgroundtab.js":"6Pvkd","./linkedTraces.js":"aRe5h","./request.js":"iYAFH","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6Pvkd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "registerBackgroundTabDetection", function() {
    return registerBackgroundTabDetection;
});
var _core = require("@sentry/core");
var _debugBuildJs = require("../debug-build.js");
var _helpersJs = require("../helpers.js");
/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function registerBackgroundTabDetection() {
    if ((0, _helpersJs.WINDOW).document) (0, _helpersJs.WINDOW).document.addEventListener('visibilitychange', function() {
        var activeSpan = (0, _core.getActiveSpan)();
        if (!activeSpan) return;
        var rootSpan = (0, _core.getRootSpan)(activeSpan);
        if ((0, _helpersJs.WINDOW).document.hidden && rootSpan) {
            var cancelledStatus = 'cancelled';
            var _spanToJSON = (0, _core.spanToJSON)(rootSpan), op = _spanToJSON.op, status = _spanToJSON.status;
            if (0, _debugBuildJs.DEBUG_BUILD) (0, _core.debug).log("[Tracing] Transaction: ".concat(cancelledStatus, " -> since tab moved to the background, op: ").concat(op));
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!status) rootSpan.setStatus({
                code: (0, _core.SPAN_STATUS_ERROR),
                message: cancelledStatus
            });
            rootSpan.setAttribute('sentry.cancellation_reason', 'document.hidden');
            rootSpan.end();
        }
    });
    else (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).warn('[Tracing] Could not set up background tab detection due to lack of global document');
}

},{"@sentry/core":"lqtxA","../debug-build.js":"55n2m","../helpers.js":"45G1f","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aRe5h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PREVIOUS_TRACE_KEY", function() {
    return PREVIOUS_TRACE_KEY;
});
parcelHelpers.export(exports, "PREVIOUS_TRACE_MAX_DURATION", function() {
    return PREVIOUS_TRACE_MAX_DURATION;
});
parcelHelpers.export(exports, "PREVIOUS_TRACE_TMP_SPAN_ATTRIBUTE", function() {
    return PREVIOUS_TRACE_TMP_SPAN_ATTRIBUTE;
});
parcelHelpers.export(exports, "addPreviousTraceSpanLink", function() {
    return addPreviousTraceSpanLink;
});
parcelHelpers.export(exports, "getPreviousTraceFromSessionStorage", function() {
    return getPreviousTraceFromSessionStorage;
});
parcelHelpers.export(exports, "linkTraces", function() {
    return linkTraces;
});
parcelHelpers.export(exports, "spanContextSampled", function() {
    return spanContextSampled;
});
parcelHelpers.export(exports, "storePreviousTraceInSessionStorage", function() {
    return storePreviousTraceInSessionStorage;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@sentry/core");
var _debugBuildJs = require("../debug-build.js");
var _helpersJs = require("../helpers.js");
var _browserUtils = require("@sentry-internal/browser-utils");
var _stackParsersJs = require("../stack-parsers.js");
var _breadcrumbsJs = require("../integrations/breadcrumbs.js");
var _browserapierrorsJs = require("../integrations/browserapierrors.js");
var _browsersessionJs = require("../integrations/browsersession.js");
var _globalhandlersJs = require("../integrations/globalhandlers.js");
var _httpcontextJs = require("../integrations/httpcontext.js");
var _linkederrorsJs = require("../integrations/linkederrors.js");
var _spotlightJs = require("../integrations/spotlight.js");
// 1h in seconds
var PREVIOUS_TRACE_MAX_DURATION = 3600;
// session storage key
var PREVIOUS_TRACE_KEY = 'sentry_previous_trace';
var PREVIOUS_TRACE_TMP_SPAN_ATTRIBUTE = 'sentry.previous_trace';
/**
 * Takes care of linking traces and applying the (consistent) sampling behavoiour based on the passed options
 * @param options - options for linking traces and consistent trace sampling (@see BrowserTracingOptions)
 * @param client - Sentry client
 */ function linkTraces(client, param) {
    var linkPreviousTrace = param.linkPreviousTrace, consistentTraceSampling = param.consistentTraceSampling;
    var useSessionStorage = linkPreviousTrace === 'session-storage';
    var inMemoryPreviousTraceInfo = useSessionStorage ? getPreviousTraceFromSessionStorage() : undefined;
    client.on('spanStart', function(span) {
        if ((0, _core.getRootSpan)(span) !== span) return;
        var oldPropagationContext = (0, _core.getCurrentScope)().getPropagationContext();
        inMemoryPreviousTraceInfo = addPreviousTraceSpanLink(inMemoryPreviousTraceInfo, span, oldPropagationContext);
        if (useSessionStorage) storePreviousTraceInSessionStorage(inMemoryPreviousTraceInfo);
    });
    var isFirstTraceOnPageload = true;
    if (consistentTraceSampling) /*
    When users opt into `consistentTraceSampling`, we need to ensure that we propagate
    the previous trace's sample rate and rand to the current trace. This is necessary because otherwise, span
    metric extrapolation is inaccurate, as we'd propagate too high of a sample rate for the subsequent traces.

    So therefore, we pretend that the previous trace was the parent trace of the newly started trace. To do that,
    we mutate the propagation context of the current trace and set the sample rate and sample rand of the previous trace.
    Timing-wise, it is fine because it happens before we even sample the root span.

    @see https://github.com/getsentry/sentry-javascript/issues/15754
    */ client.on('beforeSampling', function(mutableSamplingContextData) {
        if (!inMemoryPreviousTraceInfo) return;
        var scope = (0, _core.getCurrentScope)();
        var currentPropagationContext = scope.getPropagationContext();
        // We do not want to force-continue the sampling decision if we continue a trace
        // that was started on the backend. Most prominently, this will happen in MPAs where
        // users hard-navigate between pages. In this case, the sampling decision of a potentially
        // started trace on the server takes precedence.
        // Why? We want to prioritize inter-trace consistency over intra-trace consistency.
        if (isFirstTraceOnPageload && currentPropagationContext.parentSpanId) {
            isFirstTraceOnPageload = false;
            return;
        }
        scope.setPropagationContext((0, _objectSpreadProps._)((0, _objectSpread._)({}, currentPropagationContext), {
            dsc: (0, _objectSpreadProps._)((0, _objectSpread._)({}, currentPropagationContext.dsc), {
                sample_rate: String(inMemoryPreviousTraceInfo.sampleRate),
                sampled: String(spanContextSampled(inMemoryPreviousTraceInfo.spanContext))
            }),
            sampleRand: inMemoryPreviousTraceInfo.sampleRand
        }));
        mutableSamplingContextData.parentSampled = spanContextSampled(inMemoryPreviousTraceInfo.spanContext);
        mutableSamplingContextData.parentSampleRate = inMemoryPreviousTraceInfo.sampleRate;
        mutableSamplingContextData.spanAttributes = (0, _objectSpreadProps._)((0, _objectSpread._)({}, mutableSamplingContextData.spanAttributes), (0, _defineProperty._)({}, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE), inMemoryPreviousTraceInfo.sampleRate));
    });
}
/**
 * Adds a previous_trace span link to the passed span if the passed
 * previousTraceInfo is still valid.
 *
 * @returns the updated previous trace info (based on the current span/trace) to
 * be used on the next call
 */ function addPreviousTraceSpanLink(previousTraceInfo, span, oldPropagationContext) {
    var spanJson = (0, _core.spanToJSON)(span);
    function getSampleRate() {
        try {
            var _oldPropagationContext_dsc, _spanJson_data;
            var _Number;
            return (_Number = Number((_oldPropagationContext_dsc = oldPropagationContext.dsc) === null || _oldPropagationContext_dsc === void 0 ? void 0 : _oldPropagationContext_dsc.sample_rate)) !== null && _Number !== void 0 ? _Number : Number((_spanJson_data = spanJson.data) === null || _spanJson_data === void 0 ? void 0 : _spanJson_data[0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE]);
        } catch (e) {
            return 0;
        }
    }
    var updatedPreviousTraceInfo = {
        spanContext: span.spanContext(),
        startTimestamp: spanJson.start_timestamp,
        sampleRate: getSampleRate(),
        sampleRand: oldPropagationContext.sampleRand
    };
    if (!previousTraceInfo) return updatedPreviousTraceInfo;
    var previousTraceSpanCtx = previousTraceInfo.spanContext;
    if (previousTraceSpanCtx.traceId === spanJson.trace_id) // This means, we're still in the same trace so let's not update the previous trace info
    // or add a link to the current span.
    // Once we move away from the long-lived, route-based trace model, we can remove this cases
    return previousTraceInfo;
    // Only add the link if the startTimeStamp of the previous trace's root span is within
    // PREVIOUS_TRACE_MAX_DURATION (1h) of the current root span's startTimestamp
    // This is done to
    // - avoid adding links to "stale" traces
    // - enable more efficient querying for previous/next traces in Sentry
    if (Date.now() / 1000 - previousTraceInfo.startTimestamp <= PREVIOUS_TRACE_MAX_DURATION) {
        if (0, _debugBuildJs.DEBUG_BUILD) (0, _core.debug).log("Adding previous_trace ".concat(previousTraceSpanCtx, " link to span ").concat((0, _objectSpread._)({
            op: spanJson.op
        }, span.spanContext())));
        span.addLink({
            context: previousTraceSpanCtx,
            attributes: (0, _defineProperty._)({}, (0, _core.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE), 'previous_trace')
        });
        // TODO: Remove this once EAP can store span links. We currently only set this attribute so that we
        // can obtain the previous trace information from the EAP store. Long-term, EAP will handle
        // span links and then we should remove this again. Also throwing in a TODO(v11), to remind us
        // to check this at v11 time :)
        span.setAttribute(PREVIOUS_TRACE_TMP_SPAN_ATTRIBUTE, "".concat(previousTraceSpanCtx.traceId, "-").concat(previousTraceSpanCtx.spanId, "-").concat(spanContextSampled(previousTraceSpanCtx) ? 1 : 0));
    }
    return updatedPreviousTraceInfo;
}
/**
 * Stores @param previousTraceInfo in sessionStorage.
 */ function storePreviousTraceInSessionStorage(previousTraceInfo) {
    try {
        (0, _helpersJs.WINDOW).sessionStorage.setItem(PREVIOUS_TRACE_KEY, JSON.stringify(previousTraceInfo));
    } catch (e) {
        // Ignore potential errors (e.g. if sessionStorage is not available)
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).warn('Could not store previous trace in sessionStorage', e);
    }
}
/**
 * Retrieves the previous trace from sessionStorage if available.
 */ function getPreviousTraceFromSessionStorage() {
    try {
        var _WINDOW_sessionStorage;
        var previousTraceInfo = (_WINDOW_sessionStorage = (0, _helpersJs.WINDOW).sessionStorage) === null || _WINDOW_sessionStorage === void 0 ? void 0 : _WINDOW_sessionStorage.getItem(PREVIOUS_TRACE_KEY);
        // @ts-expect-error - intentionally risking JSON.parse throwing when previousTraceInfo is null to save bundle size
        return JSON.parse(previousTraceInfo);
    } catch (e) {
        return undefined;
    }
}
/**
 * see {@link import('@sentry/core').spanIsSampled}
 */ function spanContextSampled(ctx) {
    return ctx.traceFlags === 0x1;
}

},{"@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@sentry/core":"lqtxA","../debug-build.js":"55n2m","../helpers.js":"45G1f","@sentry-internal/browser-utils":"hXSTf","../stack-parsers.js":"82YO9","../integrations/breadcrumbs.js":"dGpRx","../integrations/browserapierrors.js":"hsRAR","../integrations/browsersession.js":"80LXs","../integrations/globalhandlers.js":"1Jyt8","../integrations/httpcontext.js":"kBg3j","../integrations/linkederrors.js":"1L5lO","../integrations/spotlight.js":"eCM3r","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4gdAj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reportPageLoaded", function() {
    return reportPageLoaded;
});
var _core = require("@sentry/core");
/**
 * Manually report the end of the page load, resulting in the SDK ending the pageload span.
 * This only works if {@link BrowserTracingOptions.enableReportPageLoaded} is set to `true`.
 * Otherwise, the pageload span will end itself based on the {@link BrowserTracingOptions.finalTimeout},
 * {@link BrowserTracingOptions.idleTimeout} and {@link BrowserTracingOptions.childSpanTimeout}.
 *
 * @param client - The client to use. If not provided, the global client will be used.
 */ function reportPageLoaded() {
    var client = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, _core.getClient)();
    client === null || client === void 0 ? void 0 : client.emit('endPageloadSpan');
}

},{"@sentry/core":"lqtxA","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5QjiO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setActiveSpanInBrowser", function() {
    return setActiveSpanInBrowser;
});
var _core = require("@sentry/core");
/**
 * Sets an inactive span active on the current scope.
 *
 * This is useful in browser applications, if you want to create a span that cannot be finished
 * within its callback. Any spans started while the given span is active, will be children of the span.
 *
 * If there already was an active span on the scope prior to calling this function, it is replaced
 * with the given span and restored after the span ended. Otherwise, the span will simply be
 * removed, resulting in no active span on the scope.
 *
 * IMPORTANT: This function can ONLY be used in the browser! Calling this function in a server
 * environment (for example in a server-side rendered component) will result in undefined behaviour
 * and is not supported.
 * You MUST call `span.end()` manually, otherwise the span will never be finished.
 *
 * @example
 * ```js
 * let checkoutSpan;
 *
 * on('checkoutStarted', () => {
 *  checkoutSpan = Sentry.startInactiveSpan({ name: 'checkout-flow' });
 *  Sentry.setActiveSpanInBrowser(checkoutSpan);
 * })
 *
 * // during this time, any spans started will be children of `checkoutSpan`:
 * Sentry.startSpan({ name: 'checkout-step-1' }, () => {
 *  // ... `
 * })
 *
 * on('checkoutCompleted', () => {
 *  checkoutSpan?.end();
 * })
 * ```
 *
 * @param span - the span to set active
 */ function setActiveSpanInBrowser(span) {
    var maybePreviousActiveSpan = (0, _core.getActiveSpan)();
    // If the span is already active, there's no need to double-patch or set it again.
    // This also guards against users (for whatever reason) calling setActiveSpanInBrowser on SDK-started
    // idle spans like pageload or navigation spans. These will already be handled correctly by the SDK.
    // For nested situations, we have to double-patch to ensure we restore the correct previous span (see tests)
    if (maybePreviousActiveSpan === span) return;
    var scope = (0, _core.getCurrentScope)();
    // Putting a small patch onto the span.end method to ensure we
    // remove the span from the scope when it ends.
    // eslint-disable-next-line @typescript-eslint/unbound-method
    span.end = new Proxy(span.end, {
        apply: function apply(target, thisArg, args) {
            (0, _core._INTERNAL_setSpanForScope)(scope, maybePreviousActiveSpan);
            return Reflect.apply(target, thisArg, args);
        }
    });
    (0, _core._INTERNAL_setSpanForScope)(scope, span);
}

},{"@sentry/core":"lqtxA","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"k5FyM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createStore", function() {
    return createStore;
});
parcelHelpers.export(exports, "makeBrowserOfflineTransport", function() {
    return makeBrowserOfflineTransport;
});
parcelHelpers.export(exports, "push", function() {
    return push;
});
parcelHelpers.export(exports, "shift", function() {
    return shift;
});
parcelHelpers.export(exports, "unshift", function() {
    return unshift;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _core = require("@sentry/core");
var _helpersJs = require("../helpers.js");
var _fetchJs = require("./fetch.js");
// 'Store', 'promisifyRequest' and 'createStore' were originally copied from the 'idb-keyval' package before being
// modified and simplified: https://github.com/jakearchibald/idb-keyval
//
// At commit: 0420a704fd6cbb4225429c536b1f61112d012fca
// Original license:
// Copyright 2016, Jake Archibald
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
function promisifyRequest(request) {
    return new Promise(function(resolve, reject) {
        // @ts-expect-error - file size hacks
        request.oncomplete = request.onsuccess = function() {
            return resolve(request.result);
        };
        // @ts-expect-error - file size hacks
        request.onabort = request.onerror = function() {
            return reject(request.error);
        };
    });
}
/** Create or open an IndexedDb store */ function createStore(dbName, storeName) {
    var request = indexedDB.open(dbName);
    request.onupgradeneeded = function() {
        return request.result.createObjectStore(storeName);
    };
    var dbp = promisifyRequest(request);
    return function(callback) {
        return dbp.then(function(db) {
            return callback(db.transaction(storeName, 'readwrite').objectStore(storeName));
        });
    };
}
function keys(store) {
    return promisifyRequest(store.getAllKeys());
}
/** Insert into the end of the store */ function push(store, value, maxQueueSize) {
    return store(function(store) {
        return keys(store).then(function(keys) {
            var _Math;
            if (keys.length >= maxQueueSize) return;
            // We insert with an incremented key so that the entries are popped in order
            store.put(value, (_Math = Math).max.apply(_Math, (0, _toConsumableArray._)(keys).concat([
                0
            ])) + 1);
            return promisifyRequest(store.transaction);
        });
    });
}
/** Insert into the front of the store */ function unshift(store, value, maxQueueSize) {
    return store(function(store) {
        return keys(store).then(function(keys) {
            var _Math;
            if (keys.length >= maxQueueSize) return;
            // We insert with an decremented key so that the entries are popped in order
            store.put(value, (_Math = Math).min.apply(_Math, (0, _toConsumableArray._)(keys).concat([
                0
            ])) - 1);
            return promisifyRequest(store.transaction);
        });
    });
}
/** Pop the oldest value from the store */ function shift(store) {
    return store(function(store) {
        return keys(store).then(function(keys) {
            var firstKey = keys[0];
            if (firstKey == null) return undefined;
            return promisifyRequest(store.get(firstKey)).then(function(value) {
                store.delete(firstKey);
                return promisifyRequest(store.transaction).then(function() {
                    return value;
                });
            });
        });
    });
}
function createIndexedDbStore(options) {
    var store;
    // Lazily create the store only when it's needed
    function getStore() {
        if (store == undefined) store = createStore(options.dbName || 'sentry-offline', options.storeName || 'queue');
        return store;
    }
    return {
        push: function(env) {
            return (0, _asyncToGenerator._)(function() {
                var serialized, e;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                (0, _core.serializeEnvelope)(env)
                            ];
                        case 1:
                            serialized = _state.sent();
                            return [
                                4,
                                push(getStore(), serialized, options.maxQueueSize || 30)
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        unshift: function(env) {
            return (0, _asyncToGenerator._)(function() {
                var serialized, e;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                (0, _core.serializeEnvelope)(env)
                            ];
                        case 1:
                            serialized = _state.sent();
                            return [
                                4,
                                unshift(getStore(), serialized, options.maxQueueSize || 30)
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        shift: function() {
            return (0, _asyncToGenerator._)(function() {
                var deserialized, e;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                shift(getStore())
                            ];
                        case 1:
                            deserialized = _state.sent();
                            if (deserialized) return [
                                2,
                                (0, _core.parseEnvelope)(deserialized)
                            ];
                            return [
                                3,
                                3
                            ];
                        case 2:
                            e = _state.sent();
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2,
                                undefined
                            ];
                    }
                });
            })();
        }
    };
}
function makeIndexedDbOfflineTransport(createTransport) {
    return function(options) {
        var transport = createTransport((0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
            createStore: createIndexedDbStore
        }));
        (0, _helpersJs.WINDOW).addEventListener('online', function(_) {
            return (0, _asyncToGenerator._)(function() {
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                transport.flush()
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            })();
        });
        return transport;
    };
}
/**
 * Creates a transport that uses IndexedDb to store events when offline.
 */ function makeBrowserOfflineTransport() {
    var createTransport = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, _fetchJs.makeFetchTransport);
    return makeIndexedDbOfflineTransport((0, _core.makeOfflineTransport)(createTransport));
}

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_to_consumable_array":"1eSZf","@swc/helpers/_/_ts_generator":"78Tqx","@sentry/core":"lqtxA","../helpers.js":"45G1f","./fetch.js":"6NfhH","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jt2uL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "browserProfilingIntegration", function() {
    return browserProfilingIntegration;
});
var _core = require("@sentry/core");
var _debugBuildJs = require("../debug-build.js");
var _helpersJs = require("../helpers.js");
var _startProfileForSpanJs = require("./startProfileForSpan.js");
var _uiprofilerJs = require("./UIProfiler.js");
var _utilsJs = require("./utils.js");
var INTEGRATION_NAME = 'BrowserProfiling';
var _browserProfilingIntegration = function() {
    return {
        name: INTEGRATION_NAME,
        setup: function setup(client) {
            var options = client.getOptions();
            var profiler = new (0, _uiprofilerJs.UIProfiler)();
            if (!(0, _utilsJs.hasLegacyProfiling)(options) && !options.profileLifecycle) // Set default lifecycle mode
            options.profileLifecycle = 'manual';
            // eslint-disable-next-line deprecation/deprecation
            if ((0, _utilsJs.hasLegacyProfiling)(options) && !options.profilesSampleRate) {
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).log('[Profiling] Profiling disabled, no profiling options found.');
                return;
            }
            var activeSpan = (0, _core.getActiveSpan)();
            var rootSpan = activeSpan && (0, _core.getRootSpan)(activeSpan);
            if ((0, _utilsJs.hasLegacyProfiling)(options) && options.profileSessionSampleRate !== undefined) (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).warn('[Profiling] Both legacy profiling (`profilesSampleRate`) and UI profiling settings are defined. `profileSessionSampleRate` has no effect when legacy profiling is enabled.');
            // UI PROFILING (Profiling V2)
            if (!(0, _utilsJs.hasLegacyProfiling)(options)) {
                var lifecycleMode = options.profileLifecycle;
                // Registering hooks in all lifecycle modes to be able to notify users in case they want to start/stop the profiler manually in `trace` mode
                client.on('startUIProfiler', function() {
                    return profiler.start();
                });
                client.on('stopUIProfiler', function() {
                    return profiler.stop();
                });
                if (lifecycleMode === 'manual') profiler.initialize(client);
                else if (lifecycleMode === 'trace') {
                    if (!(0, _core.hasSpansEnabled)(options)) {
                        (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).warn("[Profiling] `profileLifecycle` is 'trace' but tracing is disabled. Set a `tracesSampleRate` or `tracesSampler` to enable span tracing.");
                        return;
                    }
                    profiler.initialize(client);
                    // If there is an active, sampled root span already, notify the profiler
                    if (rootSpan) profiler.notifyRootSpanActive(rootSpan);
                    // In case rootSpan is created slightly after setup -> schedule microtask to re-check and notify.
                    (0, _helpersJs.WINDOW).setTimeout(function() {
                        var laterActiveSpan = (0, _core.getActiveSpan)();
                        var laterRootSpan = laterActiveSpan && (0, _core.getRootSpan)(laterActiveSpan);
                        if (laterRootSpan) profiler.notifyRootSpanActive(laterRootSpan);
                    }, 0);
                }
            } else {
                // LEGACY PROFILING (v1)
                if (rootSpan && (0, _utilsJs.isAutomatedPageLoadSpan)(rootSpan)) {
                    if ((0, _utilsJs.shouldProfileSpanLegacy)(rootSpan)) (0, _startProfileForSpanJs.startProfileForSpan)(rootSpan);
                }
                client.on('spanStart', function(span) {
                    if (span === (0, _core.getRootSpan)(span) && (0, _utilsJs.shouldProfileSpanLegacy)(span)) (0, _startProfileForSpanJs.startProfileForSpan)(span);
                });
                client.on('beforeEnvelope', function(envelope) {
                    // if not profiles are in queue, there is nothing to add to the envelope.
                    if (!(0, _utilsJs.getActiveProfilesCount)()) return;
                    var profiledTransactionEvents = (0, _utilsJs.findProfiledTransactionsFromEnvelope)(envelope);
                    if (!profiledTransactionEvents.length) return;
                    var profilesToAddToEnvelope = [];
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = profiledTransactionEvents[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var profiledTransaction = _step.value;
                            var _context_profile, _context_profile1;
                            var context = profiledTransaction === null || profiledTransaction === void 0 ? void 0 : profiledTransaction.contexts;
                            var profile_id = context === null || context === void 0 ? void 0 : (_context_profile = context.profile) === null || _context_profile === void 0 ? void 0 : _context_profile['profile_id'];
                            var start_timestamp = context === null || context === void 0 ? void 0 : (_context_profile1 = context.profile) === null || _context_profile1 === void 0 ? void 0 : _context_profile1['start_timestamp'];
                            if (typeof profile_id !== 'string') {
                                (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).log('[Profiling] cannot find profile for a span without a profile context');
                                continue;
                            }
                            if (!profile_id) {
                                (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).log('[Profiling] cannot find profile for a span without a profile context');
                                continue;
                            }
                            // Remove the profile from the span context before sending, relay will take care of the rest.
                            if (context === null || context === void 0 ? void 0 : context.profile) delete context.profile;
                            var profile = (0, _utilsJs.takeProfileFromGlobalCache)(profile_id);
                            if (!profile) {
                                (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).log("[Profiling] Could not retrieve profile for span: ".concat(profile_id));
                                continue;
                            }
                            var profileEvent = (0, _utilsJs.createProfilingEvent)(profile_id, start_timestamp, profile, profiledTransaction);
                            if (profileEvent) profilesToAddToEnvelope.push(profileEvent);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    (0, _utilsJs.addProfilesToEnvelope)(envelope, profilesToAddToEnvelope);
                });
            }
        },
        processEvent: function processEvent(event) {
            return (0, _utilsJs.attachProfiledThreadToEvent)(event);
        }
    };
};
var browserProfilingIntegration = (0, _core.defineIntegration)(_browserProfilingIntegration);

},{"@sentry/core":"lqtxA","../debug-build.js":"55n2m","../helpers.js":"45G1f","./startProfileForSpan.js":"9ghPJ","./UIProfiler.js":"7yDKK","./utils.js":"j05hz","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9ghPJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "startProfileForSpan", function() {
    return startProfileForSpan;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _core = require("@sentry/core");
var _debugBuildJs = require("../debug-build.js");
var _helpersJs = require("../helpers.js");
var _utilsJs = require("./utils.js");
/**
 * Wraps startTransaction and stopTransaction with profiling related logic.
 * startProfileForTransaction is called after the call to startTransaction in order to avoid our own code from
 * being profiled. Because of that same reason, stopProfiling is called before the call to stopTransaction.
 */ function startProfileForSpan(span) {
    // Start the profiler and get the profiler instance.
    var startTimestamp;
    if ((0, _utilsJs.isAutomatedPageLoadSpan)(span)) startTimestamp = (0, _core.timestampInSeconds)() * 1000;
    var profiler = (0, _utilsJs.startJSSelfProfile)();
    // We failed to construct the profiler, so we skip.
    // No need to log anything as this has already been logged in startProfile.
    if (!profiler) return;
    if (0, _debugBuildJs.DEBUG_BUILD) (0, _core.debug).log("[Profiling] started profiling span: ".concat((0, _core.spanToJSON)(span).description));
    // We create "unique" span names to avoid concurrent spans with same names
    // from being ignored by the profiler. From here on, only this span name should be used when
    // calling the profiler methods. Note: we log the original name to the user to avoid confusion.
    var profileId = (0, _core.uuid4)();
    // A couple of important things to note here:
    // `CpuProfilerBindings.stopProfiling` will be scheduled to run in 30seconds in order to exceed max profile duration.
    // Whichever of the two (span.finish/timeout) is first to run, the profiling will be stopped and the gathered profile
    // will be processed when the original span is finished. Since onProfileHandler can be invoked multiple times in the
    // event of an error or user mistake (calling span.finish multiple times), it is important that the behavior of onProfileHandler
    // is idempotent as we do not want any timings or profiles to be overridden by the last call to onProfileHandler.
    // After the original finish method is called, the event will be reported through the integration and delegated to transport.
    var processedProfile = null;
    (0, _core.getCurrentScope)().setContext('profile', {
        profile_id: profileId,
        start_timestamp: startTimestamp
    });
    /**
   * Idempotent handler for profile stop
   */ function onProfileHandler() {
        return (0, _asyncToGenerator._)(function() {
            return (0, _tsGenerator._)(this, function(_state) {
                // Check if the profile exists and return it the behavior has to be idempotent as users may call span.finish multiple times.
                if (!span) return [
                    2
                ];
                // Satisfy the type checker, but profiler will always be defined here.
                if (!profiler) return [
                    2
                ];
                if (processedProfile) {
                    if (0, _debugBuildJs.DEBUG_BUILD) (0, _core.debug).log('[Profiling] profile for:', (0, _core.spanToJSON)(span).description, 'already exists, returning early');
                    return [
                        2
                    ];
                }
                return [
                    2,
                    profiler.stop().then(function(profile) {
                        if (maxDurationTimeoutID) {
                            (0, _helpersJs.WINDOW).clearTimeout(maxDurationTimeoutID);
                            maxDurationTimeoutID = undefined;
                        }
                        if (0, _debugBuildJs.DEBUG_BUILD) (0, _core.debug).log("[Profiling] stopped profiling of span: ".concat((0, _core.spanToJSON)(span).description));
                        // In case of an overlapping span, stopProfiling may return null and silently ignore the overlapping profile.
                        if (!profile) {
                            if (0, _debugBuildJs.DEBUG_BUILD) (0, _core.debug).log("[Profiling] profiler returned null profile for: ".concat((0, _core.spanToJSON)(span).description), 'this may indicate an overlapping span or a call to stopProfiling with a profile title that was never started');
                            return;
                        }
                        processedProfile = profile;
                        (0, _utilsJs.addProfileToGlobalCache)(profileId, profile);
                    }).catch(function(error) {
                        if (0, _debugBuildJs.DEBUG_BUILD) (0, _core.debug).log('[Profiling] error while stopping profiler:', error);
                    })
                ];
            });
        })();
    }
    // Enqueue a timeout to prevent profiles from running over max duration.
    var maxDurationTimeoutID = (0, _helpersJs.WINDOW).setTimeout(function() {
        if (0, _debugBuildJs.DEBUG_BUILD) (0, _core.debug).log('[Profiling] max profile duration elapsed, stopping profiling for:', (0, _core.spanToJSON)(span).description);
        // If the timeout exceeds, we want to stop profiling, but not finish the span
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        onProfileHandler();
    }, (0, _utilsJs.MAX_PROFILE_DURATION_MS));
    // We need to reference the original end call to avoid creating an infinite loop
    var originalEnd = span.end.bind(span);
    /**
   * Wraps span `end()` with profiling related logic.
   * startProfiling is called after the call to spanStart in order to avoid our own code from
   * being profiled. Because of that same reason, stopProfiling is called before the call to spanEnd.
   */ function profilingWrappedSpanEnd() {
        if (!span) return originalEnd();
        // onProfileHandler should always return the same profile even if this is called multiple times.
        // Always call onProfileHandler to ensure stopProfiling is called and the timeout is cleared.
        onProfileHandler().then(function() {
            originalEnd();
        }, function() {
            // If onProfileHandler fails, we still want to call the original finish method.
            originalEnd();
        });
        return span;
    }
    span.end = profilingWrappedSpanEnd;
}

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_ts_generator":"78Tqx","@sentry/core":"lqtxA","../debug-build.js":"55n2m","../helpers.js":"45G1f","./utils.js":"j05hz","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"j05hz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MAX_PROFILE_DURATION_MS", function() {
    return MAX_PROFILE_DURATION_MS;
});
parcelHelpers.export(exports, "PROFILER_THREAD_ID_STRING", function() {
    return PROFILER_THREAD_ID_STRING;
});
parcelHelpers.export(exports, "PROFILER_THREAD_NAME", function() {
    return PROFILER_THREAD_NAME;
});
parcelHelpers.export(exports, "addProfileToGlobalCache", function() {
    return addProfileToGlobalCache;
});
parcelHelpers.export(exports, "addProfilesToEnvelope", function() {
    return addProfilesToEnvelope;
});
parcelHelpers.export(exports, "applyDebugMetadata", function() {
    return applyDebugMetadata;
});
parcelHelpers.export(exports, "attachProfiledThreadToEvent", function() {
    return attachProfiledThreadToEvent;
});
parcelHelpers.export(exports, "convertJSSelfProfileToSampledFormat", function() {
    return convertJSSelfProfileToSampledFormat;
});
parcelHelpers.export(exports, "createProfileChunkPayload", function() {
    return createProfileChunkPayload;
});
parcelHelpers.export(exports, "createProfilePayload", function() {
    return createProfilePayload;
});
parcelHelpers.export(exports, "createProfilingEvent", function() {
    return createProfilingEvent;
});
parcelHelpers.export(exports, "enrichWithThreadInformation", function() {
    return enrichWithThreadInformation;
});
parcelHelpers.export(exports, "findProfiledTransactionsFromEnvelope", function() {
    return findProfiledTransactionsFromEnvelope;
});
parcelHelpers.export(exports, "getActiveProfilesCount", function() {
    return getActiveProfilesCount;
});
parcelHelpers.export(exports, "hasLegacyProfiling", function() {
    return hasLegacyProfiling;
});
parcelHelpers.export(exports, "isAutomatedPageLoadSpan", function() {
    return isAutomatedPageLoadSpan;
});
parcelHelpers.export(exports, "isValidSampleRate", function() {
    return isValidSampleRate;
});
parcelHelpers.export(exports, "shouldProfileSession", function() {
    return shouldProfileSession;
});
parcelHelpers.export(exports, "shouldProfileSpanLegacy", function() {
    return shouldProfileSpanLegacy;
});
parcelHelpers.export(exports, "startJSSelfProfile", function() {
    return startJSSelfProfile;
});
parcelHelpers.export(exports, "takeProfileFromGlobalCache", function() {
    return takeProfileFromGlobalCache;
});
parcelHelpers.export(exports, "validateProfileChunk", function() {
    return validateProfileChunk;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _typeOf = require("@swc/helpers/_/_type_of");
var _core = require("@sentry/core");
var _debugBuildJs = require("../debug-build.js");
var _helpersJs = require("../helpers.js");
var _navigator_languages;
var MS_TO_NS = 1e6;
// Checking if we are in Main or Worker thread: `self` (not `window`) is the `globalThis` in Web Workers and `importScripts` are only available in Web Workers
var isMainThread = 'window' in (0, _core.GLOBAL_OBJ) && (0, _core.GLOBAL_OBJ).window === (0, _core.GLOBAL_OBJ) && typeof importScripts === 'undefined';
// Setting ID to 0 as we cannot get an ID from Web Workers
var PROFILER_THREAD_ID_STRING = String(0);
var PROFILER_THREAD_NAME = isMainThread ? 'main' : 'worker';
// We force make this optional to be on the safe side...
var navigator = (0, _helpersJs.WINDOW).navigator;
// Machine properties (eval only once)
var OS_PLATFORM = '';
var OS_PLATFORM_VERSION = '';
var OS_ARCH = '';
var OS_BROWSER = (navigator === null || navigator === void 0 ? void 0 : navigator.userAgent) || '';
var OS_MODEL = '';
var OS_LOCALE = (navigator === null || navigator === void 0 ? void 0 : navigator.language) || (navigator === null || navigator === void 0 ? void 0 : (_navigator_languages = navigator.languages) === null || _navigator_languages === void 0 ? void 0 : _navigator_languages[0]) || '';
function isUserAgentData(data) {
    return (typeof data === "undefined" ? "undefined" : (0, _typeOf._)(data)) === 'object' && data !== null && 'getHighEntropyValues' in data;
}
// @ts-expect-error userAgentData is not part of the navigator interface yet
var userAgentData = navigator === null || navigator === void 0 ? void 0 : navigator.userAgentData;
if (isUserAgentData(userAgentData)) userAgentData.getHighEntropyValues([
    'architecture',
    'model',
    'platform',
    'platformVersion',
    'fullVersionList'
]).then(function(ua) {
    var _ua_fullVersionList;
    OS_PLATFORM = ua.platform || '';
    OS_ARCH = ua.architecture || '';
    OS_MODEL = ua.model || '';
    OS_PLATFORM_VERSION = ua.platformVersion || '';
    if ((_ua_fullVersionList = ua.fullVersionList) === null || _ua_fullVersionList === void 0 ? void 0 : _ua_fullVersionList.length) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        var firstUa = ua.fullVersionList[ua.fullVersionList.length - 1];
        OS_BROWSER = "".concat(firstUa.brand, " ").concat(firstUa.version);
    }
}).catch(function(e) {
    return void 0;
});
function isProcessedJSSelfProfile(profile) {
    return !('thread_metadata' in profile);
}
// Enriches the profile with threadId of the current thread.
// This is done in node as we seem to not be able to get the info from C native code.
/**
 *
 */ function enrichWithThreadInformation(profile) {
    if (!isProcessedJSSelfProfile(profile)) return profile;
    return convertJSSelfProfileToSampledFormat(profile);
}
// Profile is marked as optional because it is deleted from the metadata
// by the integration before the event is processed by other integrations.
function getTraceId(event) {
    var _event_contexts_trace, _event_contexts;
    var traceId = (_event_contexts = event.contexts) === null || _event_contexts === void 0 ? void 0 : (_event_contexts_trace = _event_contexts.trace) === null || _event_contexts_trace === void 0 ? void 0 : _event_contexts_trace.trace_id;
    // Log a warning if the profile has an invalid traceId (should be uuidv4).
    // All profiles and transactions are rejected if this is the case and we want to
    // warn users that this is happening if they enable debug flag
    if (typeof traceId === 'string' && traceId.length !== 32) {
        if (0, _debugBuildJs.DEBUG_BUILD) (0, _core.debug).log("[Profiling] Invalid traceId: ".concat(traceId, " on profiled event"));
    }
    if (typeof traceId !== 'string') return '';
    return traceId;
}
/**
 * Creates a profiling event envelope from a Sentry event. If profile does not pass
 * validation, returns null.
 * @param event
 * @param dsn
 * @param metadata
 * @param tunnel
 * @returns {EventEnvelope | null}
 */ /**
 * Creates a profiling event envelope from a Sentry event.
 */ function createProfilePayload(profile_id, start_timestamp, processed_profile, event) {
    if (event.type !== 'transaction') // createProfilingEventEnvelope should only be called for transactions,
    // we type guard this behavior with isProfiledTransactionEvent.
    throw new TypeError('Profiling events may only be attached to transactions, this should never occur.');
    if (processed_profile === undefined || processed_profile === null) throw new TypeError("Cannot construct profiling event envelope without a valid profile. Got ".concat(processed_profile, " instead."));
    var traceId = getTraceId(event);
    var enrichedThreadProfile = enrichWithThreadInformation(processed_profile);
    var transactionStartMs = start_timestamp ? start_timestamp : typeof event.start_timestamp === 'number' ? event.start_timestamp * 1000 : (0, _core.timestampInSeconds)() * 1000;
    var transactionEndMs = typeof event.timestamp === 'number' ? event.timestamp * 1000 : (0, _core.timestampInSeconds)() * 1000;
    var profile = {
        event_id: profile_id,
        timestamp: new Date(transactionStartMs).toISOString(),
        platform: 'javascript',
        version: '1',
        release: event.release || '',
        environment: event.environment || (0, _core.DEFAULT_ENVIRONMENT),
        runtime: {
            name: 'javascript',
            version: (0, _helpersJs.WINDOW).navigator.userAgent
        },
        os: {
            name: OS_PLATFORM,
            version: OS_PLATFORM_VERSION,
            build_number: OS_BROWSER
        },
        device: {
            locale: OS_LOCALE,
            model: OS_MODEL,
            manufacturer: OS_BROWSER,
            architecture: OS_ARCH,
            is_emulator: false
        },
        debug_meta: {
            images: applyDebugMetadata(processed_profile.resources)
        },
        profile: enrichedThreadProfile,
        transactions: [
            {
                name: event.transaction || '',
                id: event.event_id || (0, _core.uuid4)(),
                trace_id: traceId,
                active_thread_id: PROFILER_THREAD_ID_STRING,
                relative_start_ns: '0',
                relative_end_ns: ((transactionEndMs - transactionStartMs) * 1e6).toFixed(0)
            }
        ]
    };
    return profile;
}
/**
 * Create a profile chunk envelope item
 */ function createProfileChunkPayload(jsSelfProfile, client, profilerId) {
    var _client_getSdkMetadata, _client_getSdkMetadata1;
    // only == to catch null and undefined
    if (jsSelfProfile == null) throw new TypeError("Cannot construct profiling event envelope without a valid profile. Got ".concat(jsSelfProfile, " instead."));
    var continuousProfile = convertToContinuousProfile(jsSelfProfile);
    var options = client.getOptions();
    var sdk = (_client_getSdkMetadata1 = client.getSdkMetadata) === null || _client_getSdkMetadata1 === void 0 ? void 0 : (_client_getSdkMetadata = _client_getSdkMetadata1.call(client)) === null || _client_getSdkMetadata === void 0 ? void 0 : _client_getSdkMetadata.sdk;
    var _sdk_name, _sdk_version, _options_release, _options_environment;
    return {
        chunk_id: (0, _core.uuid4)(),
        client_sdk: {
            name: (_sdk_name = sdk === null || sdk === void 0 ? void 0 : sdk.name) !== null && _sdk_name !== void 0 ? _sdk_name : 'sentry.javascript.browser',
            version: (_sdk_version = sdk === null || sdk === void 0 ? void 0 : sdk.version) !== null && _sdk_version !== void 0 ? _sdk_version : '0.0.0'
        },
        profiler_id: profilerId || (0, _core.uuid4)(),
        platform: 'javascript',
        version: '2',
        release: (_options_release = options.release) !== null && _options_release !== void 0 ? _options_release : '',
        environment: (_options_environment = options.environment) !== null && _options_environment !== void 0 ? _options_environment : 'production',
        debug_meta: {
            // function name obfuscation
            images: applyDebugMetadata(jsSelfProfile.resources)
        },
        profile: continuousProfile
    };
}
/**
 * Validate a profile chunk against the Sample Format V2 requirements.
 * https://develop.sentry.dev/sdk/telemetry/profiles/sample-format-v2/
 * - Presence of samples, stacks, frames
 * - Required metadata fields
 */ function validateProfileChunk(chunk) {
    try {
        // Required metadata
        if (!chunk || (typeof chunk === "undefined" ? "undefined" : (0, _typeOf._)(chunk)) !== 'object') return {
            reason: 'chunk is not an object'
        };
        // profiler_id and chunk_id must be 32 lowercase hex chars
        var isHex32 = function(val) {
            return typeof val === 'string' && /^[a-f0-9]{32}$/.test(val);
        };
        if (!isHex32(chunk.profiler_id)) return {
            reason: 'missing or invalid profiler_id'
        };
        if (!isHex32(chunk.chunk_id)) return {
            reason: 'missing or invalid chunk_id'
        };
        if (!chunk.client_sdk) return {
            reason: 'missing client_sdk metadata'
        };
        // Profile data must have frames, stacks, samples
        var profile = chunk.profile;
        if (!profile) return {
            reason: 'missing profile data'
        };
        if (!Array.isArray(profile.frames) || !profile.frames.length) return {
            reason: 'profile has no frames'
        };
        if (!Array.isArray(profile.stacks) || !profile.stacks.length) return {
            reason: 'profile has no stacks'
        };
        if (!Array.isArray(profile.samples) || !profile.samples.length) return {
            reason: 'profile has no samples'
        };
        return {
            valid: true
        };
    } catch (e) {
        return {
            reason: "unknown validation error: ".concat(e)
        };
    }
}
/**
 * Convert from JSSelfProfile format to ContinuousThreadCpuProfile format.
 */ function convertToContinuousProfile(input) {
    // Frames map 1:1 by index; fill only when present to avoid sparse writes
    var frames = [];
    for(var i = 0; i < input.frames.length; i++){
        var frame = input.frames[i];
        if (!frame) continue;
        frames[i] = {
            function: frame.name,
            abs_path: typeof frame.resourceId === 'number' ? input.resources[frame.resourceId] : undefined,
            lineno: frame.line,
            colno: frame.column
        };
    }
    // Build stacks by following parent links, top->down order (root last)
    var stacks = [];
    for(var i1 = 0; i1 < input.stacks.length; i1++){
        var stackHead = input.stacks[i1];
        if (!stackHead) continue;
        var list = [];
        var current = stackHead;
        while(current){
            list.push(current.frameId);
            current = current.parentId === undefined ? undefined : input.stacks[current.parentId];
        }
        stacks[i1] = list;
    }
    // Align timestamps to SDK time origin to match span/event timelines
    var perfOrigin = (0, _core.browserPerformanceTimeOrigin)();
    var origin = typeof performance.timeOrigin === 'number' ? performance.timeOrigin : perfOrigin || 0;
    var adjustForOriginChange = origin - (perfOrigin || origin);
    var samples = [];
    for(var i2 = 0; i2 < input.samples.length; i2++){
        var sample = input.samples[i2];
        if (!sample) continue;
        // Convert ms to seconds epoch-based timestamp
        var timestampSeconds = (origin + (sample.timestamp - adjustForOriginChange)) / 1000;
        var _sample_stackId;
        samples[i2] = {
            stack_id: (_sample_stackId = sample.stackId) !== null && _sample_stackId !== void 0 ? _sample_stackId : 0,
            thread_id: PROFILER_THREAD_ID_STRING,
            timestamp: timestampSeconds
        };
    }
    return {
        frames: frames,
        stacks: stacks,
        samples: samples,
        thread_metadata: (0, _defineProperty._)({}, PROFILER_THREAD_ID_STRING, {
            name: PROFILER_THREAD_NAME
        })
    };
}
/*
  See packages/browser-utils/src/browser/router.ts
*/ /**
 *
 */ function isAutomatedPageLoadSpan(span) {
    return (0, _core.spanToJSON)(span).op === 'pageload';
}
/**
 * Converts a JSSelfProfile to a our sampled format.
 * Does not currently perform stack indexing.
 */ function convertJSSelfProfileToSampledFormat(input) {
    var EMPTY_STACK_ID = undefined;
    var STACK_ID = 0;
    // Initialize the profile that we will fill with data
    var profile = {
        samples: [],
        stacks: [],
        frames: [],
        thread_metadata: (0, _defineProperty._)({}, PROFILER_THREAD_ID_STRING, {
            name: PROFILER_THREAD_NAME
        })
    };
    var firstSample = input.samples[0];
    if (!firstSample) return profile;
    // We assert samples.length > 0 above and timestamp should always be present
    var start = firstSample.timestamp;
    // The JS SDK might change it's time origin based on some heuristic (see See packages/utils/src/time.ts)
    // when that happens, we need to ensure we are correcting the profile timings so the two timelines stay in sync.
    // Since JS self profiling time origin is always initialized to performance.timeOrigin, we need to adjust for
    // the drift between the SDK selected value and our profile time origin.
    var perfOrigin = (0, _core.browserPerformanceTimeOrigin)();
    var origin = typeof performance.timeOrigin === 'number' ? performance.timeOrigin : perfOrigin || 0;
    var adjustForOriginChange = origin - (perfOrigin || origin);
    input.samples.forEach(function(jsSample, i) {
        // If sample has no stack, add an empty sample
        if (jsSample.stackId === undefined) {
            if (EMPTY_STACK_ID === undefined) {
                EMPTY_STACK_ID = STACK_ID;
                profile.stacks[EMPTY_STACK_ID] = [];
                STACK_ID++;
            }
            profile['samples'][i] = {
                // convert ms timestamp to ns
                elapsed_since_start_ns: ((jsSample.timestamp + adjustForOriginChange - start) * MS_TO_NS).toFixed(0),
                stack_id: EMPTY_STACK_ID,
                thread_id: PROFILER_THREAD_ID_STRING
            };
            return;
        }
        var stackTop = input.stacks[jsSample.stackId];
        // Functions in top->down order (root is last)
        // We follow the stackTop.parentId trail and collect each visited frameId
        var stack = [];
        while(stackTop){
            stack.push(stackTop.frameId);
            var frame = input.frames[stackTop.frameId];
            // If our frame has not been indexed yet, index it
            if (frame && profile.frames[stackTop.frameId] === undefined) profile.frames[stackTop.frameId] = {
                function: frame.name,
                abs_path: typeof frame.resourceId === 'number' ? input.resources[frame.resourceId] : undefined,
                lineno: frame.line,
                colno: frame.column
            };
            stackTop = stackTop.parentId === undefined ? undefined : input.stacks[stackTop.parentId];
        }
        var sample = {
            // convert ms timestamp to ns
            elapsed_since_start_ns: ((jsSample.timestamp + adjustForOriginChange - start) * MS_TO_NS).toFixed(0),
            stack_id: STACK_ID,
            thread_id: PROFILER_THREAD_ID_STRING
        };
        profile['stacks'][STACK_ID] = stack;
        profile['samples'][i] = sample;
        STACK_ID++;
    });
    return profile;
}
/**
 * Adds items to envelope if they are not already present - mutates the envelope.
 * @param envelope
 */ function addProfilesToEnvelope(envelope, profiles) {
    if (!profiles.length) return envelope;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = profiles[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var profile = _step.value;
            envelope[1].push([
                {
                    type: 'profile'
                },
                profile
            ]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return envelope;
}
/**
 * Finds transactions with profile_id context in the envelope
 * @param envelope
 * @returns
 */ function findProfiledTransactionsFromEnvelope(envelope) {
    var events = [];
    (0, _core.forEachEnvelopeItem)(envelope, function(item, type) {
        if (type !== 'transaction') return;
        for(var j = 1; j < item.length; j++){
            var _event_contexts_profile, _event_contexts;
            var event = item[j];
            if (event === null || event === void 0 ? void 0 : (_event_contexts = event.contexts) === null || _event_contexts === void 0 ? void 0 : (_event_contexts_profile = _event_contexts.profile) === null || _event_contexts_profile === void 0 ? void 0 : _event_contexts_profile.profile_id) events.push(item[j]);
        }
    });
    return events;
}
/**
 * Applies debug meta data to an event from a list of paths to resources (sourcemaps)
 */ function applyDebugMetadata(resource_paths) {
    var client = (0, _core.getClient)();
    var options = client === null || client === void 0 ? void 0 : client.getOptions();
    var stackParser = options === null || options === void 0 ? void 0 : options.stackParser;
    if (!stackParser) return [];
    return (0, _core.getDebugImagesForResources)(stackParser, resource_paths);
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function isValidSampleRate(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    if (typeof rate !== 'number' && typeof rate !== 'boolean' || typeof rate === 'number' && isNaN(rate)) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).warn("[Profiling] Invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ".concat(JSON.stringify(rate), " of type ").concat(JSON.stringify(typeof rate === "undefined" ? "undefined" : (0, _typeOf._)(rate)), "."));
        return false;
    }
    // Boolean sample rates are always valid
    if (rate === true || rate === false) return true;
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).warn("[Profiling] Invalid sample rate. Sample rate must be between 0 and 1. Got ".concat(rate, "."));
        return false;
    }
    return true;
}
function isValidProfile(profile) {
    if (profile.samples.length < 2) {
        if (0, _debugBuildJs.DEBUG_BUILD) // Log a warning if the profile has less than 2 samples so users can know why
        // they are not seeing any profiling data and we cant avoid the back and forth
        // of asking them to provide us with a dump of the profile data.
        (0, _core.debug).log('[Profiling] Discarding profile because it contains less than 2 samples');
        return false;
    }
    if (!profile.frames.length) {
        if (0, _debugBuildJs.DEBUG_BUILD) (0, _core.debug).log('[Profiling] Discarding profile because it contains no frames');
        return false;
    }
    return true;
}
// Keep a flag value to avoid re-initializing the profiler constructor. If it fails
// once, it will always fail and this allows us to early return.
var PROFILING_CONSTRUCTOR_FAILED = false;
var MAX_PROFILE_DURATION_MS = 30000;
/**
 * Check if profiler constructor is available.
 * @param maybeProfiler
 */ function isJSProfilerSupported(maybeProfiler) {
    return typeof maybeProfiler === 'function';
}
/**
 * Starts the profiler and returns the profiler instance.
 */ function startJSSelfProfile() {
    // Feature support check first
    var JSProfilerConstructor = (0, _helpersJs.WINDOW).Profiler;
    if (!isJSProfilerSupported(JSProfilerConstructor)) {
        if (0, _debugBuildJs.DEBUG_BUILD) (0, _core.debug).log('[Profiling] Profiling is not supported by this browser, Profiler interface missing on window object.');
        return;
    }
    // From initial testing, it seems that the minimum value for sampleInterval is 10ms.
    var samplingIntervalMS = 10;
    // Start the profiler
    var maxSamples = Math.floor(MAX_PROFILE_DURATION_MS / samplingIntervalMS);
    // Attempt to initialize the profiler constructor, if it fails, we disable profiling for the current user session.
    // This is likely due to a missing 'Document-Policy': 'js-profiling' header. We do not want to throw an error if this happens
    // as we risk breaking the user's application, so just disable profiling and log an error.
    try {
        return new JSProfilerConstructor({
            sampleInterval: samplingIntervalMS,
            maxBufferSize: maxSamples
        });
    } catch (e) {
        if (0, _debugBuildJs.DEBUG_BUILD) {
            (0, _core.debug).log("[Profiling] Failed to initialize the Profiling constructor, this is likely due to a missing 'Document-Policy': 'js-profiling' header.");
            (0, _core.debug).log('[Profiling] Disabling profiling for current user session.');
        }
        PROFILING_CONSTRUCTOR_FAILED = true;
    }
    return;
}
/**
 * Determine if a profile should be profiled.
 */ function shouldProfileSpanLegacy(span) {
    // If constructor failed once, it will always fail, so we can early return.
    if (PROFILING_CONSTRUCTOR_FAILED) {
        if (0, _debugBuildJs.DEBUG_BUILD) (0, _core.debug).log('[Profiling] Profiling has been disabled for the duration of the current user session.');
        return false;
    }
    if (!span.isRecording()) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).log('[Profiling] Discarding profile because root span was not sampled.');
        return false;
    }
    var client = (0, _core.getClient)();
    var options = client === null || client === void 0 ? void 0 : client.getOptions();
    if (!options) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).log('[Profiling] Profiling disabled, no options found.');
        return false;
    }
    // eslint-disable-next-line deprecation/deprecation
    var profilesSampleRate = options.profilesSampleRate;
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!isValidSampleRate(profilesSampleRate)) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).warn('[Profiling] Discarding profile because of invalid sample rate.');
        return false;
    }
    // if the function returned 0 (or false), or if `profileSampleRate` is 0, it's a sign the profile should be dropped
    if (!profilesSampleRate) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).log('[Profiling] Discarding profile because a negative sampling decision was inherited or profileSampleRate is set to 0');
        return false;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    var sampled = profilesSampleRate === true ? true : Math.random() < profilesSampleRate;
    // Check if we should sample this profile
    if (!sampled) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).log("[Profiling] Discarding profile because it's not included in the random sample (sampling rate = ".concat(Number(profilesSampleRate), ")"));
        return false;
    }
    return true;
}
/**
 * Determine if a profile should be created for the current session.
 */ function shouldProfileSession(options) {
    // If constructor failed once, it will always fail, so we can early return.
    if (PROFILING_CONSTRUCTOR_FAILED) {
        if (0, _debugBuildJs.DEBUG_BUILD) (0, _core.debug).log('[Profiling] Profiling has been disabled for the duration of the current user session as the JS Profiler could not be started.');
        return false;
    }
    if (options.profileLifecycle !== 'trace' && options.profileLifecycle !== 'manual') {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).warn('[Profiling] Session not sampled. Invalid `profileLifecycle` option.');
        return false;
    }
    //  Session sampling: profileSessionSampleRate gates whether profiling is enabled for this session
    var profileSessionSampleRate = options.profileSessionSampleRate;
    if (!isValidSampleRate(profileSessionSampleRate)) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).warn('[Profiling] Discarding profile because of invalid profileSessionSampleRate.');
        return false;
    }
    if (!profileSessionSampleRate) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).log('[Profiling] Discarding profile because profileSessionSampleRate is not defined or set to 0');
        return false;
    }
    return Math.random() <= profileSessionSampleRate;
}
/**
 * Checks if legacy profiling is configured.
 */ function hasLegacyProfiling(options) {
    // eslint-disable-next-line deprecation/deprecation
    return typeof options.profilesSampleRate !== 'undefined';
}
/**
 * Creates a profiling envelope item, if the profile does not pass validation, returns null.
 * @param event
 * @returns {Profile | null}
 */ function createProfilingEvent(profile_id, start_timestamp, profile, event) {
    if (!isValidProfile(profile)) return null;
    return createProfilePayload(profile_id, start_timestamp, profile, event);
}
// TODO (v8): We need to obtain profile ids in @sentry-internal/tracing,
// but we don't have access to this map because importing this map would
// cause a circular dependency. We need to resolve this in v8.
var PROFILE_MAP = new Map();
/**
 *
 */ function getActiveProfilesCount() {
    return PROFILE_MAP.size;
}
/**
 * Retrieves profile from global cache and removes it.
 */ function takeProfileFromGlobalCache(profile_id) {
    var profile = PROFILE_MAP.get(profile_id);
    if (profile) PROFILE_MAP.delete(profile_id);
    return profile;
}
/**
 * Adds profile to global cache and evicts the oldest profile if the cache is full.
 */ function addProfileToGlobalCache(profile_id, profile) {
    PROFILE_MAP.set(profile_id, profile);
    if (PROFILE_MAP.size > 30) {
        var last = PROFILE_MAP.keys().next().value;
        if (last !== undefined) PROFILE_MAP.delete(last);
    }
}
/**
 * Attaches the profiled thread information to the event's trace context.
 */ function attachProfiledThreadToEvent(event) {
    var _event_contexts, _event_contexts1, _event_contexts_trace, _event_contexts2, // Attach thread info to individual spans so that spans can be associated with the profiled thread on the UI even if contexts are missing.
    _event_spans;
    if (!(event === null || event === void 0 ? void 0 : (_event_contexts = event.contexts) === null || _event_contexts === void 0 ? void 0 : _event_contexts.profile)) return event;
    if (!event.contexts) return event;
    var _event_contexts_trace1, _event_contexts_trace_data;
    var _obj;
    // @ts-expect-error the trace fallback value is wrong, though it should never happen
    // and in case it does, we dont want to override whatever was passed initially.
    event.contexts.trace = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (_event_contexts_trace1 = (_event_contexts1 = event.contexts) === null || _event_contexts1 === void 0 ? void 0 : _event_contexts1.trace) !== null && _event_contexts_trace1 !== void 0 ? _event_contexts_trace1 : {}), {
        data: (0, _objectSpreadProps._)((0, _objectSpread._)({}, (_event_contexts_trace_data = (_event_contexts2 = event.contexts) === null || _event_contexts2 === void 0 ? void 0 : (_event_contexts_trace = _event_contexts2.trace) === null || _event_contexts_trace === void 0 ? void 0 : _event_contexts_trace.data) !== null && _event_contexts_trace_data !== void 0 ? _event_contexts_trace_data : {}), (_obj = {}, (0, _defineProperty._)(_obj, 'thread.id', PROFILER_THREAD_ID_STRING), (0, _defineProperty._)(_obj, 'thread.name', PROFILER_THREAD_NAME), _obj))
    });
    (_event_spans = event.spans) === null || _event_spans === void 0 ? void 0 : _event_spans.forEach(function(span) {
        var _obj;
        span.data = (0, _objectSpreadProps._)((0, _objectSpread._)({}, span.data || {}), (_obj = {}, (0, _defineProperty._)(_obj, 'thread.id', PROFILER_THREAD_ID_STRING), (0, _defineProperty._)(_obj, 'thread.name', PROFILER_THREAD_NAME), _obj));
    });
    return event;
}

},{"@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_type_of":"iFJdx","@sentry/core":"lqtxA","../debug-build.js":"55n2m","../helpers.js":"45G1f","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7yDKK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UIProfiler", function() {
    return UIProfiler;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _core = require("@sentry/core");
var _debugBuildJs = require("../debug-build.js");
var _utilsJs = require("./utils.js");
var CHUNK_INTERVAL_MS = 60000; // 1 minute
// Maximum length for trace lifecycle profiling per root span (e.g. if spanEnd never fires)
var MAX_ROOT_SPAN_PROFILE_MS = 300000; // 5 minutes max per root span in trace mode
/**
 * UIProfiler (Profiling V2):
 * Supports two lifecycle modes:
 *  - 'manual': controlled explicitly via start()/stop()
 *  - 'trace': automatically runs while there are active sampled root spans
 *
 * Profiles are emitted as standalone `profile_chunk` envelopes either when:
 * - there are no more sampled root spans, or
 * - the 60s chunk timer elapses while profiling is running.
 */ var UIProfiler = /*#__PURE__*/ function() {
    "use strict";
    function UIProfiler() {
        (0, _classCallCheck._)(this, UIProfiler);
        this._client = undefined;
        this._profiler = undefined;
        this._chunkTimer = undefined;
        this._profilerId = undefined;
        this._isRunning = false;
        this._sessionSampled = false;
        this._lifecycleMode = undefined;
        this._activeRootSpanIds = new Set();
        this._rootSpanTimeouts = new Map();
    }
    (0, _createClass._)(UIProfiler, [
        {
            /**
   * Initialize the profiler with client, session sampling and lifecycle mode.
   */ key: "initialize",
            value: function initialize(client) {
                var lifecycleMode = client.getOptions().profileLifecycle;
                var sessionSampled = (0, _utilsJs.shouldProfileSession)(client.getOptions());
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).log("[Profiling] Initializing profiler (lifecycle='".concat(lifecycleMode, "')."));
                if (!sessionSampled) (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).log('[Profiling] Session not sampled. Skipping lifecycle profiler initialization.');
                // One Profiler ID per profiling session (user session)
                this._profilerId = (0, _core.uuid4)();
                this._client = client;
                this._sessionSampled = sessionSampled;
                this._lifecycleMode = lifecycleMode;
                if (lifecycleMode === 'trace') this._setupTraceLifecycleListeners(client);
            }
        },
        {
            /** Starts UI profiling (only effective in 'manual' mode and when sampled). */ key: "start",
            value: function start() {
                if (this._lifecycleMode === 'trace') {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).warn('[Profiling] `profileLifecycle` is set to "trace". Calls to `uiProfiler.start()` are ignored in trace mode.');
                    return;
                }
                if (this._isRunning) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).warn('[Profiling] Profile session is already running, `uiProfiler.start()` is a no-op.');
                    return;
                }
                if (!this._sessionSampled) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).warn('[Profiling] Session is not sampled, `uiProfiler.start()` is a no-op.');
                    return;
                }
                this._beginProfiling();
            }
        },
        {
            /** Stops UI profiling (only effective in 'manual' mode). */ key: "stop",
            value: function stop() {
                if (this._lifecycleMode === 'trace') {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).warn('[Profiling] `profileLifecycle` is set to "trace". Calls to `uiProfiler.stop()` are ignored in trace mode.');
                    return;
                }
                if (!this._isRunning) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).warn('[Profiling] Profiler is not running, `uiProfiler.stop()` is a no-op.');
                    return;
                }
                this._endProfiling();
            }
        },
        {
            /** Handle an already-active root span at integration setup time (used only in trace mode). */ key: "notifyRootSpanActive",
            value: function notifyRootSpanActive(rootSpan) {
                if (this._lifecycleMode !== 'trace' || !this._sessionSampled) return;
                var spanId = rootSpan.spanContext().spanId;
                if (!spanId || this._activeRootSpanIds.has(spanId)) return;
                this._registerTraceRootSpan(spanId);
                var rootSpanCount = this._activeRootSpanIds.size;
                if (rootSpanCount === 1) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).log('[Profiling] Detected already active root span during setup. Active root spans now:', rootSpanCount);
                    this._beginProfiling();
                }
            }
        },
        {
            /**
   * Begin profiling if not already running.
   */ key: "_beginProfiling",
            value: function _beginProfiling() {
                if (this._isRunning) return;
                this._isRunning = true;
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).log('[Profiling] Started profiling with profiler ID:', this._profilerId);
                // Expose profiler_id to match root spans with profiles
                (0, _core.getGlobalScope)().setContext('profile', {
                    profiler_id: this._profilerId
                });
                this._startProfilerInstance();
                if (!this._profiler) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).log('[Profiling] Failed to start JS Profiler; stopping.');
                    this._resetProfilerInfo();
                    return;
                }
                this._startPeriodicChunking();
            }
        },
        {
            /** End profiling session; final chunk will be collected and sent. */ key: "_endProfiling",
            value: function _endProfiling() {
                if (!this._isRunning) return;
                this._isRunning = false;
                if (this._chunkTimer) {
                    clearTimeout(this._chunkTimer);
                    this._chunkTimer = undefined;
                }
                this._clearAllRootSpanTimeouts();
                // Collect whatever was currently recording
                this._collectCurrentChunk().catch(function(e) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).error('[Profiling] Failed to collect current profile chunk on `stop()`:', e);
                });
                // Manual: Clear profiling context so spans outside start()/stop() aren't marked as profiled
                // Trace: Profile context is kept for the whole session duration
                if (this._lifecycleMode === 'manual') (0, _core.getGlobalScope)().setContext('profile', {});
            }
        },
        {
            /** Trace-mode: attach spanStart/spanEnd listeners. */ key: "_setupTraceLifecycleListeners",
            value: function _setupTraceLifecycleListeners(client) {
                var _this = this;
                client.on('spanStart', function(span) {
                    if (!_this._sessionSampled) {
                        (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).log('[Profiling] Session not sampled because of negative sampling decision.');
                        return;
                    }
                    if (span !== (0, _core.getRootSpan)(span)) return; // only care about root spans
                    // Only count sampled root spans
                    if (!span.isRecording()) {
                        (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).log('[Profiling] Discarding profile because root span was not sampled.');
                        return;
                    }
                    var spanId = span.spanContext().spanId;
                    if (!spanId || _this._activeRootSpanIds.has(spanId)) return;
                    _this._registerTraceRootSpan(spanId);
                    var rootSpanCount = _this._activeRootSpanIds.size;
                    if (rootSpanCount === 1) {
                        (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).log("[Profiling] Root span ".concat(spanId, " started. Profiling active while there are active root spans (count=").concat(rootSpanCount, ")."));
                        _this._beginProfiling();
                    }
                });
                client.on('spanEnd', function(span) {
                    if (!_this._sessionSampled) return;
                    var spanId = span.spanContext().spanId;
                    if (!spanId || !_this._activeRootSpanIds.has(spanId)) return;
                    _this._activeRootSpanIds.delete(spanId);
                    var rootSpanCount = _this._activeRootSpanIds.size;
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).log("[Profiling] Root span with ID ".concat(spanId, " ended. Will continue profiling for as long as there are active root spans (currently: ").concat(rootSpanCount, ")."));
                    if (rootSpanCount === 0) {
                        _this._collectCurrentChunk().catch(function(e) {
                            (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).error('[Profiling] Failed to collect current profile chunk on last `spanEnd`:', e);
                        });
                        _this._endProfiling();
                    }
                });
            }
        },
        {
            /**
   * Resets profiling information from scope and resets running state (used on failure)
   */ key: "_resetProfilerInfo",
            value: function _resetProfilerInfo() {
                this._isRunning = false;
                (0, _core.getGlobalScope)().setContext('profile', {});
            }
        },
        {
            /**
   * Clear and reset all per-root-span timeouts.
   */ key: "_clearAllRootSpanTimeouts",
            value: function _clearAllRootSpanTimeouts() {
                this._rootSpanTimeouts.forEach(function(timeout) {
                    return clearTimeout(timeout);
                });
                this._rootSpanTimeouts.clear();
            }
        },
        {
            /** Keep track of root spans and schedule safeguard timeout (trace mode). */ key: "_registerTraceRootSpan",
            value: function _registerTraceRootSpan(spanId) {
                var _this = this;
                this._activeRootSpanIds.add(spanId);
                var timeout = setTimeout(function() {
                    return _this._onRootSpanTimeout(spanId);
                }, MAX_ROOT_SPAN_PROFILE_MS);
                this._rootSpanTimeouts.set(spanId, timeout);
            }
        },
        {
            /**
   * Start a profiler instance if needed.
   */ key: "_startProfilerInstance",
            value: function _startProfilerInstance() {
                var _this__profiler;
                if (((_this__profiler = this._profiler) === null || _this__profiler === void 0 ? void 0 : _this__profiler.stopped) === false) return; // already running
                var profiler = (0, _utilsJs.startJSSelfProfile)();
                if (!profiler) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).log('[Profiling] Failed to start JS Profiler.');
                    return;
                }
                this._profiler = profiler;
            }
        },
        {
            /**
   * Schedule the next 60s chunk while running.
   * Each tick collects a chunk and restarts the profiler.
   * A chunk should be closed when there are no active root spans anymore OR when the maximum chunk interval is reached.
   */ key: "_startPeriodicChunking",
            value: function _startPeriodicChunking() {
                var _this = this;
                if (!this._isRunning) return;
                this._chunkTimer = setTimeout(function() {
                    _this._collectCurrentChunk().catch(function(e) {
                        (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).error('[Profiling] Failed to collect current profile chunk during periodic chunking:', e);
                    });
                    if (_this._isRunning) {
                        _this._startProfilerInstance();
                        if (!_this._profiler) {
                            // If restart failed, stop scheduling further chunks and reset context.
                            _this._resetProfilerInfo();
                            return;
                        }
                        _this._startPeriodicChunking();
                    }
                }, CHUNK_INTERVAL_MS);
            }
        },
        {
            /**
   * Handle timeout for a specific root span ID to avoid indefinitely running profiler if `spanEnd` never fires.
   * If this was the last active root span, collect the current chunk and stop profiling.
   */ key: "_onRootSpanTimeout",
            value: function _onRootSpanTimeout(rootSpanId) {
                // If span already ended, ignore
                if (!this._rootSpanTimeouts.has(rootSpanId)) return;
                this._rootSpanTimeouts.delete(rootSpanId);
                if (!this._activeRootSpanIds.has(rootSpanId)) return;
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).log("[Profiling] Reached 5-minute timeout for root span ".concat(rootSpanId, ". You likely started a manual root span that never called `.end()`."));
                this._activeRootSpanIds.delete(rootSpanId);
                if (this._activeRootSpanIds.size === 0) this._endProfiling();
            }
        },
        {
            key: "_collectCurrentChunk",
            value: /**
   * Stop current profiler instance, convert profile to chunk & send.
   */ function _collectCurrentChunk() {
                return (0, _asyncToGenerator._)(function() {
                    var prevProfiler, profile, chunk, validationReturn, e;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                prevProfiler = this._profiler;
                                this._profiler = undefined;
                                if (!prevProfiler) return [
                                    2
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    prevProfiler.stop()
                                ];
                            case 2:
                                profile = _state.sent();
                                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                chunk = (0, _utilsJs.createProfileChunkPayload)(profile, this._client, this._profilerId);
                                // Validate chunk before sending
                                validationReturn = (0, _utilsJs.validateProfileChunk)(chunk);
                                if ('reason' in validationReturn) {
                                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).log('[Profiling] Discarding invalid profile chunk (this is probably a bug in the SDK):', validationReturn.reason);
                                    return [
                                        2
                                    ];
                                }
                                this._sendProfileChunk(chunk);
                                (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).log('[Profiling] Collected browser profile chunk.');
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).log('[Profiling] Error while stopping JS Profiler for chunk:', e);
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
   * Send a profile chunk as a standalone envelope.
   */ key: "_sendProfileChunk",
            value: function _sendProfileChunk(chunk) {
                var _client_getSdkMetadata;
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                var client = this._client;
                var sdkInfo = (0, _core.getSdkMetadataForEnvelopeHeader)((_client_getSdkMetadata = client.getSdkMetadata) === null || _client_getSdkMetadata === void 0 ? void 0 : _client_getSdkMetadata.call(client));
                var dsn = client.getDsn();
                var tunnel = client.getOptions().tunnel;
                var envelope = (0, _core.createEnvelope)((0, _objectSpread._)({
                    event_id: (0, _core.uuid4)(),
                    sent_at: new Date().toISOString()
                }, sdkInfo && {
                    sdk: sdkInfo
                }, !!tunnel && dsn && {
                    dsn: (0, _core.dsnToString)(dsn)
                }), [
                    [
                        {
                            type: 'profile_chunk'
                        },
                        chunk
                    ]
                ]);
                client.sendEnvelope(envelope).then(null, function(reason) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).error('Error while sending profile chunk envelope:', reason);
                });
            }
        }
    ]);
    return UIProfiler;
}();

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_ts_generator":"78Tqx","@sentry/core":"lqtxA","../debug-build.js":"55n2m","./utils.js":"j05hz","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hCiRd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildLaunchDarklyFlagUsedHandler", function() {
    return buildLaunchDarklyFlagUsedHandler;
});
parcelHelpers.export(exports, "launchDarklyIntegration", function() {
    return launchDarklyIntegration;
});
var _core = require("@sentry/core");
/**
 * Sentry integration for capturing feature flag evaluations from LaunchDarkly.
 *
 * See the [feature flag documentation](https://develop.sentry.dev/sdk/expected-features/#feature-flags) for more information.
 *
 * @example
 * ```
 * import * as Sentry from '@sentry/browser';
 * import {launchDarklyIntegration, buildLaunchDarklyFlagUsedInspector} from '@sentry/browser';
 * import * as LaunchDarkly from 'launchdarkly-js-client-sdk';
 *
 * Sentry.init(..., integrations: [launchDarklyIntegration()])
 * const ldClient = LaunchDarkly.initialize(..., {inspectors: [buildLaunchDarklyFlagUsedHandler()]});
 * ```
 */ var launchDarklyIntegration = (0, _core.defineIntegration)(function() {
    return {
        name: 'LaunchDarkly',
        processEvent: function processEvent(event, _hint, _client) {
            return (0, _core._INTERNAL_copyFlagsFromScopeToEvent)(event);
        }
    };
});
/**
 * LaunchDarkly hook to listen for and buffer flag evaluations. This needs to
 * be registered as an 'inspector' in LaunchDarkly initialize() options,
 * separately from `launchDarklyIntegration`. Both the hook and the integration
 * are needed to capture LaunchDarkly flags.
 */ function buildLaunchDarklyFlagUsedHandler() {
    return {
        name: 'sentry-flag-auditor',
        type: 'flag-used',
        synchronous: true,
        /**
     * Handle a flag evaluation by storing its name and value on the current scope.
     */ method: function(flagKey, flagDetail, _context) {
            (0, _core._INTERNAL_insertFlagToScope)(flagKey, flagDetail.value);
            (0, _core._INTERNAL_addFeatureFlagToActiveSpan)(flagKey, flagDetail.value);
        }
    };
}

},{"@sentry/core":"lqtxA","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"asldQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OpenFeatureIntegrationHook", function() {
    return OpenFeatureIntegrationHook;
});
parcelHelpers.export(exports, "openFeatureIntegration", function() {
    return openFeatureIntegration;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _core = require("@sentry/core");
var openFeatureIntegration = (0, _core.defineIntegration)(function() {
    return {
        name: 'OpenFeature',
        processEvent: function processEvent(event, _hint, _client) {
            return (0, _core._INTERNAL_copyFlagsFromScopeToEvent)(event);
        }
    };
});
/**
 * OpenFeature Hook class implementation.
 */ var OpenFeatureIntegrationHook = /*#__PURE__*/ function() {
    "use strict";
    function OpenFeatureIntegrationHook() {
        (0, _classCallCheck._)(this, OpenFeatureIntegrationHook);
    }
    (0, _createClass._)(OpenFeatureIntegrationHook, [
        {
            /**
   * Successful evaluation result.
   */ key: "after",
            value: function after(_hookContext, evaluationDetails) {
                (0, _core._INTERNAL_insertFlagToScope)(evaluationDetails.flagKey, evaluationDetails.value);
                (0, _core._INTERNAL_addFeatureFlagToActiveSpan)(evaluationDetails.flagKey, evaluationDetails.value);
            }
        },
        {
            /**
   * On error evaluation result.
   */ key: "error",
            value: function error(hookContext, _error, _hookHints) {
                (0, _core._INTERNAL_insertFlagToScope)(hookContext.flagKey, hookContext.defaultValue);
                (0, _core._INTERNAL_addFeatureFlagToActiveSpan)(hookContext.flagKey, hookContext.defaultValue);
            }
        }
    ]);
    return OpenFeatureIntegrationHook;
}();

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@sentry/core":"lqtxA","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cqtF8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unleashIntegration", function() {
    return unleashIntegration;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _core = require("@sentry/core");
var _debugBuildJs = require("../../../debug-build.js");
/**
 * Sentry integration for capturing feature flag evaluations from the Unleash SDK.
 *
 * See the [feature flag documentation](https://develop.sentry.dev/sdk/expected-features/#feature-flags) for more information.
 *
 * @example
 * ```
 * import { UnleashClient } from 'unleash-proxy-client';
 * import * as Sentry from '@sentry/browser';
 *
 * Sentry.init({
 *   dsn: '___PUBLIC_DSN___',
 *   integrations: [Sentry.unleashIntegration({featureFlagClientClass: UnleashClient})],
 * });
 *
 * const unleash = new UnleashClient(...);
 * unleash.start();
 *
 * unleash.isEnabled('my-feature');
 * Sentry.captureException(new Error('something went wrong'));
 * ```
 */ var unleashIntegration = (0, _core.defineIntegration)(function(param) {
    var unleashClientClass = param.featureFlagClientClass;
    return {
        name: 'Unleash',
        setupOnce: function setupOnce() {
            var unleashClientPrototype = unleashClientClass.prototype;
            (0, _core.fill)(unleashClientPrototype, 'isEnabled', _wrappedIsEnabled);
        },
        processEvent: function processEvent(event, _hint, _client) {
            return (0, _core._INTERNAL_copyFlagsFromScopeToEvent)(event);
        }
    };
});
/**
 * Wraps the UnleashClient.isEnabled method to capture feature flag evaluations. Its only side effect is writing to Sentry scope.
 *
 * This wrapper is safe for all isEnabled signatures. If the signature does not match (this: UnleashClient, toggleName: string, ...args: unknown[]) => boolean,
 * we log an error and return the original result.
 *
 * @param original - The original method.
 * @returns Wrapped method. Results should match the original.
 */ function _wrappedIsEnabled(original) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var toggleName = args[0];
        var result = original.apply(this, args);
        if (typeof toggleName === 'string' && typeof result === 'boolean') {
            (0, _core._INTERNAL_insertFlagToScope)(toggleName, result);
            (0, _core._INTERNAL_addFeatureFlagToActiveSpan)(toggleName, result);
        } else if (0, _debugBuildJs.DEBUG_BUILD) (0, _core.debug).error("[Feature Flags] UnleashClient.isEnabled does not match expected signature. arg0: ".concat(toggleName, " (").concat(typeof toggleName === "undefined" ? "undefined" : (0, _typeOf._)(toggleName), "), result: ").concat(result, " (").concat(typeof result === "undefined" ? "undefined" : (0, _typeOf._)(result), ")"));
        return result;
    };
}

},{"@swc/helpers/_/_type_of":"iFJdx","@sentry/core":"lqtxA","../../../debug-build.js":"55n2m","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7OGqW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "growthbookIntegration", function() {
    return growthbookIntegration;
});
var _core = require("@sentry/core");
/**
 * Sentry integration for capturing feature flag evaluations from GrowthBook.
 *
 * See the feature flag documentation: https://develop.sentry.dev/sdk/expected-features/#feature-flags
 *
 * @example
 * ```
 * import { GrowthBook } from '@growthbook/growthbook';
 * import * as Sentry from '@sentry/browser';
 *
 * Sentry.init({
 *   dsn: '___PUBLIC_DSN___',
 *   integrations: [Sentry.growthbookIntegration({ growthbookClass: GrowthBook })],
 * });
 *
 * const gb = new GrowthBook();
 * gb.isOn('my-feature');
 * Sentry.captureException(new Error('something went wrong'));
 * ```
 */ var growthbookIntegration = function(param) {
    var growthbookClass = param.growthbookClass;
    return (0, _core.growthbookIntegration)({
        growthbookClass: growthbookClass
    });
};

},{"@sentry/core":"lqtxA","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bxBEx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "statsigIntegration", function() {
    return statsigIntegration;
});
var _core = require("@sentry/core");
/**
 * Sentry integration for capturing feature flag evaluations from the Statsig js-client SDK.
 *
 * See the [feature flag documentation](https://develop.sentry.dev/sdk/expected-features/#feature-flags) for more information.
 *
 * @example
 * ```
 * import { StatsigClient } from '@statsig/js-client';
 * import * as Sentry from '@sentry/browser';
 *
 * const statsigClient = new StatsigClient();
 *
 * Sentry.init({
 *   dsn: '___PUBLIC_DSN___',
 *   integrations: [Sentry.statsigIntegration({featureFlagClient: statsigClient})],
 * });
 *
 * await statsigClient.initializeAsync();  // or statsigClient.initializeSync();
 *
 * const result = statsigClient.checkGate('my-feature-gate');
 * Sentry.captureException(new Error('something went wrong'));
 * ```
 */ var statsigIntegration = (0, _core.defineIntegration)(function(param) {
    var statsigClient = param.featureFlagClient;
    return {
        name: 'Statsig',
        setup: function setup(_client) {
            statsigClient.on('gate_evaluation', function(event) {
                (0, _core._INTERNAL_insertFlagToScope)(event.gate.name, event.gate.value);
                (0, _core._INTERNAL_addFeatureFlagToActiveSpan)(event.gate.name, event.gate.value);
            });
        },
        processEvent: function processEvent(event, _hint, _client) {
            return (0, _core._INTERNAL_copyFlagsFromScopeToEvent)(event);
        }
    };
});

},{"@sentry/core":"lqtxA","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1E4Re":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "diagnoseSdkConnectivity", function() {
    return diagnoseSdkConnectivity;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _core = require("@sentry/core");
/**
 * A function to diagnose why the SDK might not be successfully sending data.
 *
 * Possible return values wrapped in a Promise:
 * - `"no-client-active"` - There was no active client when the function was called. This possibly means that the SDK was not initialized yet.
 * - `"sentry-unreachable"` - The Sentry SaaS servers were not reachable. This likely means that there is an ad blocker active on the page or that there are other connection issues.
 *
 * If the function doesn't detect an issue it resolves to `undefined`.
 */ function diagnoseSdkConnectivity() {
    return (0, _asyncToGenerator._)(function() {
        var client, e;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    client = (0, _core.getClient)();
                    if (!client) return [
                        2,
                        'no-client-active'
                    ];
                    if (!client.getDsn()) return [
                        2,
                        'no-dsn-configured'
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0, _core.suppressTracing)(function() {
                            return(// If fetch throws, there is likely an ad blocker active or there are other connective issues.
                            fetch(// We are using the
                            // - "sentry-sdks" org with id 447951 not to pollute any actual organizations.
                            // - "diagnose-sdk-connectivity" project with id 4509632503087104
                            // - the public key of said org/project, which is disabled in the project settings
                            // => this DSN: https://c1dfb07d783ad5325c245c1fd3725390@o447951.ingest.us.sentry.io/4509632503087104 (i.e. disabled)
                            'https://o447951.ingest.sentry.io/api/4509632503087104/envelope/?sentry_version=7&sentry_key=c1dfb07d783ad5325c245c1fd3725390&sentry_client=sentry.javascript.browser%2F1.33.7', {
                                body: '{}',
                                method: 'POST',
                                mode: 'cors',
                                credentials: 'omit'
                            }));
                        })
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    return [
                        2,
                        'sentry-unreachable'
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    })();
}

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_ts_generator":"78Tqx","@sentry/core":"lqtxA","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aDjEx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "INTEGRATION_NAME", function() {
    return INTEGRATION_NAME;
});
parcelHelpers.export(exports, "registerWebWorker", function() {
    return registerWebWorker;
});
parcelHelpers.export(exports, "webWorkerIntegration", function() {
    return webWorkerIntegration;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@sentry/core");
var _debugBuildJs = require("../debug-build.js");
var _eventbuilderJs = require("../eventbuilder.js");
var _helpersJs = require("../helpers.js");
var _globalhandlersJs = require("./globalhandlers.js");
var INTEGRATION_NAME = 'WebWorker';
/**
 * Use this integration to set up Sentry with web workers.
 *
 * IMPORTANT: This integration must be added **before** you start listening to
 * any messages from the worker. Otherwise, your message handlers will receive
 * messages from the Sentry SDK which you need to ignore.
 *
 * This integration only has an effect, if you call `Sentry.registerWebWorker(self)`
 * from within the worker(s) you're adding to the integration.
 *
 * Given that you want to initialize the SDK as early as possible, you most likely
 * want to add this integration **after** initializing the SDK:
 *
 * @example:
 * ```ts filename={main.js}
 * import * as Sentry from '@sentry/<your-sdk>';
 *
 * // some time earlier:
 * Sentry.init(...)
 *
 * // 1. Initialize the worker
 * const worker = new Worker(new URL('./worker.ts', import.meta.url));
 *
 * // 2. Add the integration
 * const webWorkerIntegration = Sentry.webWorkerIntegration({ worker });
 * Sentry.addIntegration(webWorkerIntegration);
 *
 * // 3. Register message listeners on the worker
 * worker.addEventListener('message', event => {
 *  // ...
 * });
 * ```
 *
 * If you initialize multiple workers at the same time, you can also pass an array of workers
 * to the integration:
 *
 * ```ts filename={main.js}
 * const webWorkerIntegration = Sentry.webWorkerIntegration({ worker: [worker1, worker2] });
 * Sentry.addIntegration(webWorkerIntegration);
 * ```
 *
 * If you have any additional workers that you initialize at a later point,
 * you can add them to the integration as follows:
 *
 * ```ts filename={main.js}
 * const webWorkerIntegration = Sentry.webWorkerIntegration({ worker: worker1 });
 * Sentry.addIntegration(webWorkerIntegration);
 *
 * // sometime later:
 * webWorkerIntegration.addWorker(worker2);
 * ```
 *
 * Of course, you can also directly add the integration in Sentry.init:
 * ```ts filename={main.js}
 * import * as Sentry from '@sentry/<your-sdk>';
 *
 * // 1. Initialize the worker
 * const worker = new Worker(new URL('./worker.ts', import.meta.url));
 *
 * // 2. Initialize the SDK
 * Sentry.init({
 *  integrations: [Sentry.webWorkerIntegration({ worker })]
 * });
 *
 * // 3. Register message listeners on the worker
 * worker.addEventListener('message', event => {
 *  // ...
 * });
 * ```
 *
 * @param options {WebWorkerIntegrationOptions} Integration options:
 *   - `worker`: The worker instance.
 */ var webWorkerIntegration = (0, _core.defineIntegration)(function(param) {
    var worker = param.worker;
    return {
        name: INTEGRATION_NAME,
        setupOnce: function() {
            (Array.isArray(worker) ? worker : [
                worker
            ]).forEach(function(w) {
                return listenForSentryMessages(w);
            });
        },
        addWorker: function(worker) {
            return listenForSentryMessages(worker);
        }
    };
});
function listenForSentryMessages(worker) {
    worker.addEventListener('message', function(event) {
        if (isSentryMessage(event.data)) {
            event.stopImmediatePropagation(); // other listeners should not receive this message
            // Handle debug IDs
            if (event.data._sentryDebugIds) {
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).log('Sentry debugId web worker message received', event.data);
                (0, _helpersJs.WINDOW)._sentryDebugIds = (0, _objectSpread._)({}, event.data._sentryDebugIds, (0, _helpersJs.WINDOW)._sentryDebugIds);
            }
            // Handle unhandled rejections forwarded from worker
            if (event.data._sentryWorkerError) {
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).log('Sentry worker rejection message received', event.data._sentryWorkerError);
                handleForwardedWorkerRejection(event.data._sentryWorkerError);
            }
        }
    });
}
function handleForwardedWorkerRejection(workerError) {
    var client = (0, _core.getClient)();
    if (!client) return;
    var stackParser = client.getOptions().stackParser;
    var attachStacktrace = client.getOptions().attachStacktrace;
    var error = workerError.reason;
    // Follow same pattern as globalHandlers for unhandledrejection
    // Handle both primitives and errors the same way
    var event = (0, _core.isPrimitive)(error) ? (0, _globalhandlersJs._eventFromRejectionWithPrimitive)(error) : (0, _eventbuilderJs.eventFromUnknownInput)(stackParser, error, undefined, attachStacktrace, true);
    event.level = 'error';
    // Add worker-specific context
    if (workerError.filename) event.contexts = (0, _objectSpreadProps._)((0, _objectSpread._)({}, event.contexts), {
        worker: {
            filename: workerError.filename
        }
    });
    (0, _core.captureEvent)(event, {
        originalException: error,
        mechanism: {
            handled: false,
            type: 'auto.browser.web_worker.onunhandledrejection'
        }
    });
    (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).log('Captured worker unhandled rejection', error);
}
/**
 * Minimal interface for DedicatedWorkerGlobalScope, only requiring the postMessage method.
 * (which is the only thing we need from the worker's global object)
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/DedicatedWorkerGlobalScope
 *
 * We can't use the actual type because it breaks everyone who doesn't have {"lib": ["WebWorker"]}
 * but uses {"skipLibCheck": true} in their tsconfig.json.
 */ /**
 * Use this function to register the worker with the Sentry SDK.
 *
 * This function will:
 * - Send debug IDs to the parent thread
 * - Set up a handler for unhandled rejections in the worker
 * - Forward unhandled rejections to the parent thread for capture
 *
 * Note: Synchronous errors in workers are already captured by globalHandlers.
 * This only handles unhandled promise rejections which don't bubble to the parent.
 *
 * @example
 * ```ts filename={worker.js}
 * import * as Sentry from '@sentry/<your-sdk>';
 *
 * // Do this as early as possible in your worker.
 * Sentry.registerWebWorker({ self });
 *
 * // continue setting up your worker
 * self.postMessage(...)
 * ```
 * @param options {RegisterWebWorkerOptions} Integration options:
 *   - `self`: The worker instance you're calling this function from (self).
 */ function registerWebWorker(param) {
    var self = param.self;
    var _self__sentryDebugIds;
    // Send debug IDs to parent thread
    self.postMessage({
        _sentryMessage: true,
        _sentryDebugIds: (_self__sentryDebugIds = self._sentryDebugIds) !== null && _self__sentryDebugIds !== void 0 ? _self__sentryDebugIds : undefined
    });
    // Set up unhandledrejection handler inside the worker
    // Following the same pattern as globalHandlers
    // unhandled rejections don't bubble to the parent thread, so we need to handle them here
    self.addEventListener('unhandledrejection', function(event) {
        var _self_location;
        var reason = (0, _globalhandlersJs._getUnhandledRejectionError)(event);
        // Forward the raw reason to parent thread
        // The parent will handle primitives vs errors the same way globalHandlers does
        var serializedError = {
            reason: reason,
            filename: (_self_location = self.location) === null || _self_location === void 0 ? void 0 : _self_location.href
        };
        // Forward to parent thread
        self.postMessage({
            _sentryMessage: true,
            _sentryWorkerError: serializedError
        });
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).log('[Sentry Worker] Forwarding unhandled rejection to parent', serializedError);
    });
    (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).log('[Sentry Worker] Registered worker with unhandled rejection handling');
}
function isSentryMessage(eventData) {
    if (!(0, _core.isPlainObject)(eventData) || eventData._sentryMessage !== true) return false;
    // Must have at least one of: debug IDs or worker error
    var hasDebugIds = '_sentryDebugIds' in eventData;
    var hasWorkerError = '_sentryWorkerError' in eventData;
    if (!hasDebugIds && !hasWorkerError) return false;
    // Validate debug IDs if present
    if (hasDebugIds && !((0, _core.isPlainObject)(eventData._sentryDebugIds) || eventData._sentryDebugIds === undefined)) return false;
    // Validate worker error if present
    if (hasWorkerError && !(0, _core.isPlainObject)(eventData._sentryWorkerError)) return false;
    return true;
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@sentry/core":"lqtxA","../debug-build.js":"55n2m","../eventbuilder.js":"gS96Q","../helpers.js":"45G1f","./globalhandlers.js":"1Jyt8","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"klgia":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "init", function() {
    return init;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _browser = require("@sentry/browser");
var _core = require("@sentry/core");
var _react = require("react");
/**
 * Inits the React SDK
 */ function init(options) {
    var opts = (0, _objectSpread._)({}, options);
    (0, _core.applySdkMetadata)(opts, 'react');
    (0, _browser.setContext)('react', {
        version: (0, _react.version)
    });
    return (0, _browser.init)(opts);
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@sentry/browser":"fdZ8u","@sentry/core":"lqtxA","react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gF5NP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "captureReactException", function() {
    return captureReactException;
});
parcelHelpers.export(exports, "isAtLeastReact17", function() {
    return isAtLeastReact17;
});
parcelHelpers.export(exports, "reactErrorHandler", function() {
    return reactErrorHandler;
});
parcelHelpers.export(exports, "setCause", function() {
    return setCause;
});
var _browser = require("@sentry/browser");
var _core = require("@sentry/core");
var _react = require("react");
/**
 * See if React major version is 17+ by parsing version string.
 */ function isAtLeastReact17(reactVersion) {
    var reactMajor = reactVersion.match(/^([^.]+)/);
    return reactMajor !== null && parseInt(reactMajor[0]) >= 17;
}
/**
 * Recurse through `error.cause` chain to set cause on an error.
 */ function setCause(error, cause) {
    var seenErrors = new WeakSet();
    function recurse(error, cause) {
        // If we've already seen the error, there is a recursive loop somewhere in the error's
        // cause chain. Let's just bail out then to prevent a stack overflow.
        if (seenErrors.has(error)) return;
        if (error.cause) {
            seenErrors.add(error);
            return recurse(error.cause, cause);
        }
        error.cause = cause;
    }
    recurse(error, cause);
}
/**
 * Captures an error that was thrown by a React ErrorBoundary or React root.
 *
 * @param error The error to capture.
 * @param errorInfo The errorInfo provided by React.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function captureReactException(// eslint-disable-next-line @typescript-eslint/no-explicit-any
error, param, hint) {
    var componentStack = param.componentStack;
    // If on React version >= 17, create stack trace from componentStack param and links
    // to to the original error using `error.cause` otherwise relies on error param for stacktrace.
    // Linking errors requires the `LinkedErrors` integration be enabled.
    // See: https://reactjs.org/blog/2020/08/10/react-v17-rc.html#native-component-stacks
    //
    // Although `componentDidCatch` is typed to accept an `Error` object, it can also be invoked
    // with non-error objects. This is why we need to check if the error is an error-like object.
    // See: https://github.com/getsentry/sentry-javascript/issues/6167
    if (isAtLeastReact17((0, _react.version)) && (0, _core.isError)(error) && componentStack) {
        var errorBoundaryError = new Error(error.message);
        errorBoundaryError.name = "React ErrorBoundary ".concat(error.name);
        errorBoundaryError.stack = componentStack;
        // Using the `LinkedErrors` integration to link the errors together.
        setCause(error, errorBoundaryError);
    }
    return (0, _browser.withScope)(function(scope) {
        scope.setContext('react', {
            componentStack: componentStack
        });
        return (0, _browser.captureException)(error, hint);
    });
}
/**
 * Creates an error handler that can be used with the `onCaughtError`, `onUncaughtError`,
 * and `onRecoverableError` options in `createRoot` and `hydrateRoot` React DOM methods.
 *
 * @param callback An optional callback that will be called after the error is captured.
 * Use this to add custom handling for errors.
 *
 * @example
 *
 * ```JavaScript
 * const root = createRoot(container, {
 *  onCaughtError: Sentry.reactErrorHandler(),
 *  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
 *    console.warn('Caught error', error, errorInfo.componentStack);
 *  });
 * });
 * ```
 */ function reactErrorHandler(// eslint-disable-next-line @typescript-eslint/no-explicit-any
callback) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(error, errorInfo) {
        var hasCallback = !!callback;
        var eventId = captureReactException(error, errorInfo, {
            mechanism: {
                handled: hasCallback,
                type: 'auto.function.react.error_handler'
            }
        });
        if (hasCallback) callback(error, errorInfo, eventId);
    };
}

},{"@sentry/browser":"fdZ8u","@sentry/core":"lqtxA","react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9iBn8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Profiler", function() {
    return Profiler;
});
parcelHelpers.export(exports, "UNKNOWN_COMPONENT", function() {
    return UNKNOWN_COMPONENT;
});
parcelHelpers.export(exports, "useProfiler", function() {
    return useProfiler;
});
parcelHelpers.export(exports, "withProfiler", function() {
    return withProfiler;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _possibleConstructorReturn = require("@swc/helpers/_/_possible_constructor_return");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _browser = require("@sentry/browser");
var _core = require("@sentry/core");
var _react = require("react");
var _constantsJs = require("./constants.js");
var _hoistNonReactStaticsJs = require("./hoist-non-react-statics.js");
var UNKNOWN_COMPONENT = 'unknown';
/**
 * The Profiler component leverages Sentry's Tracing integration to generate
 * spans based on component lifecycles.
 */ var Profiler = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, _inherits._)(Profiler, _React_Component);
    function Profiler(props) {
        (0, _classCallCheck._)(this, Profiler);
        var _this;
        _this = (0, _callSuper._)(this, Profiler, [
            props
        ]);
        var _this_props = _this.props, name = _this_props.name, _this_props_disabled = _this_props.disabled, disabled = _this_props_disabled === void 0 ? false : _this_props_disabled;
        if (disabled) return (0, _possibleConstructorReturn._)(_this);
        var _obj;
        _this._mountSpan = (0, _browser.startInactiveSpan)({
            name: "<".concat(name, ">"),
            onlyIfParent: true,
            op: (0, _constantsJs.REACT_MOUNT_OP),
            attributes: (_obj = {}, (0, _defineProperty._)(_obj, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), 'auto.ui.react.profiler'), (0, _defineProperty._)(_obj, 'ui.component_name', name), _obj)
        });
        return _this;
    }
    (0, _createClass._)(Profiler, [
        {
            // If a component mounted, we can finish the mount activity.
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this._mountSpan) this._mountSpan.end();
            }
        },
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(param) {
                var _this = this;
                var updateProps = param.updateProps, _param_includeUpdates = param.includeUpdates, includeUpdates = _param_includeUpdates === void 0 ? true : _param_includeUpdates;
                // Only generate an update span if includeUpdates is true, if there is a valid mountSpan,
                // and if the updateProps have changed. It is ok to not do a deep equality check here as it is expensive.
                // We are just trying to give baseline clues for further investigation.
                if (includeUpdates && this._mountSpan && updateProps !== this.props.updateProps) {
                    // See what props have changed between the previous props, and the current props. This is
                    // set as data on the span. We just store the prop keys as the values could be potentially very large.
                    var changedProps = Object.keys(updateProps).filter(function(k) {
                        return updateProps[k] !== _this.props.updateProps[k];
                    });
                    if (changedProps.length > 0) {
                        var now = (0, _core.timestampInSeconds)();
                        this._updateSpan = (0, _core.withActiveSpan)(this._mountSpan, function() {
                            var _obj;
                            return (0, _browser.startInactiveSpan)({
                                name: "<".concat(_this.props.name, ">"),
                                onlyIfParent: true,
                                op: (0, _constantsJs.REACT_UPDATE_OP),
                                startTime: now,
                                attributes: (_obj = {}, (0, _defineProperty._)(_obj, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), 'auto.ui.react.profiler'), (0, _defineProperty._)(_obj, 'ui.component_name', _this.props.name), (0, _defineProperty._)(_obj, 'ui.react.changed_props', changedProps), _obj)
                            });
                        });
                    }
                }
                return true;
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                if (this._updateSpan) {
                    this._updateSpan.end();
                    this._updateSpan = undefined;
                }
            }
        },
        {
            // If a component is unmounted, we can say it is no longer on the screen.
            // This means we can finish the span representing the component render.
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                var endTimestamp = (0, _core.timestampInSeconds)();
                var _this_props = this.props, name = _this_props.name, _this_props_includeRender = _this_props.includeRender, includeRender = _this_props_includeRender === void 0 ? true : _this_props_includeRender;
                if (this._mountSpan && includeRender) {
                    var startTime = (0, _core.spanToJSON)(this._mountSpan).timestamp;
                    (0, _core.withActiveSpan)(this._mountSpan, function() {
                        var _obj;
                        var renderSpan = (0, _browser.startInactiveSpan)({
                            onlyIfParent: true,
                            name: "<".concat(name, ">"),
                            op: (0, _constantsJs.REACT_RENDER_OP),
                            startTime: startTime,
                            attributes: (_obj = {}, (0, _defineProperty._)(_obj, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), 'auto.ui.react.profiler'), (0, _defineProperty._)(_obj, 'ui.component_name', name), _obj)
                        });
                        if (renderSpan) // Have to cast to Span because the type of _mountSpan is Span | undefined
                        // and not getting narrowed properly
                        renderSpan.end(endTimestamp);
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return Profiler;
}(_react.Component);
// React.Component default props are defined as static property on the class
Object.assign(Profiler, {
    defaultProps: {
        disabled: false,
        includeRender: true,
        includeUpdates: true
    }
});
/**
 * withProfiler is a higher order component that wraps a
 * component in a {@link Profiler} component. It is recommended that
 * the higher order component be used over the regular {@link Profiler} component.
 *
 * @param WrappedComponent component that is wrapped by Profiler
 * @param options the {@link ProfilerProps} you can pass into the Profiler
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function withProfiler(WrappedComponent, // We do not want to have `updateProps` given in options, it is instead filled through the HOC.
options) {
    var componentDisplayName = (options === null || options === void 0 ? void 0 : options.name) || WrappedComponent.displayName || WrappedComponent.name || UNKNOWN_COMPONENT;
    var Wrapped = function(props) {
        return _react.createElement(Profiler, (0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
            name: componentDisplayName,
            updateProps: props
        }), _react.createElement(WrappedComponent, (0, _objectSpread._)({}, props)));
    };
    Wrapped.displayName = "profiler(".concat(componentDisplayName, ")");
    // Copy over static methods from Wrapped component to Profiler HOC
    // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
    (0, _hoistNonReactStaticsJs.hoistNonReactStatics)(Wrapped, WrappedComponent);
    return Wrapped;
}
/**
 *
 * `useProfiler` is a React hook that profiles a React component.
 *
 * Requires React 16.8 or above.
 * @param name displayName of component being profiled
 */ function useProfiler(name) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        disabled: false,
        hasRenderSpan: true
    };
    var _React_useState = (0, _slicedToArray._)(_react.useState(function() {
        if (options === null || options === void 0 ? void 0 : options.disabled) return undefined;
        var _obj;
        return (0, _browser.startInactiveSpan)({
            name: "<".concat(name, ">"),
            onlyIfParent: true,
            op: (0, _constantsJs.REACT_MOUNT_OP),
            attributes: (_obj = {}, (0, _defineProperty._)(_obj, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), 'auto.ui.react.profiler'), (0, _defineProperty._)(_obj, 'ui.component_name', name), _obj)
        });
    }), 1), mountSpan = _React_useState[0];
    _react.useEffect(function() {
        if (mountSpan) mountSpan.end();
        return function() {
            if (mountSpan && options.hasRenderSpan) {
                var startTime = (0, _core.spanToJSON)(mountSpan).timestamp;
                var endTimestamp = (0, _core.timestampInSeconds)();
                var _obj;
                var renderSpan = (0, _browser.startInactiveSpan)({
                    name: "<".concat(name, ">"),
                    onlyIfParent: true,
                    op: (0, _constantsJs.REACT_RENDER_OP),
                    startTime: startTime,
                    attributes: (_obj = {}, (0, _defineProperty._)(_obj, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), 'auto.ui.react.profiler'), (0, _defineProperty._)(_obj, 'ui.component_name', name), _obj)
                });
                if (renderSpan) // Have to cast to Span because the type of _mountSpan is Span | undefined
                // and not getting narrowed properly
                renderSpan.end(endTimestamp);
            }
        };
    // We only want this to run once.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_inherits":"2sfqW","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_possible_constructor_return":"fMpPb","@swc/helpers/_/_sliced_to_array":"8PtL6","@sentry/browser":"fdZ8u","@sentry/core":"lqtxA","react":"ltHCL","./constants.js":"7915W","./hoist-non-react-statics.js":"2S4dg","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7915W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "REACT_MOUNT_OP", function() {
    return REACT_MOUNT_OP;
});
parcelHelpers.export(exports, "REACT_RENDER_OP", function() {
    return REACT_RENDER_OP;
});
parcelHelpers.export(exports, "REACT_UPDATE_OP", function() {
    return REACT_UPDATE_OP;
});
var REACT_RENDER_OP = 'ui.react.render';
var REACT_UPDATE_OP = 'ui.react.update';
var REACT_MOUNT_OP = 'ui.react.mount';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2S4dg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hoistNonReactStatics", function() {
    return hoistNonReactStatics;
});
var _hoistNonReactStatics = require("hoist-non-react-statics");
// Ensure we use the default export from hoist-non-react-statics if available,
// falling back to the module itself. This handles both ESM and CJS usage.
var hoistNonReactStatics = _hoistNonReactStatics.default || _hoistNonReactStatics;

},{"hoist-non-react-statics":"nZLnq","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aacW2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ErrorBoundary", function() {
    return ErrorBoundary;
});
parcelHelpers.export(exports, "UNKNOWN_COMPONENT", function() {
    return UNKNOWN_COMPONENT;
});
parcelHelpers.export(exports, "withErrorBoundary", function() {
    return withErrorBoundary;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _browser = require("@sentry/browser");
var _core = require("@sentry/core");
var _react = require("react");
var _debugBuildJs = require("./debug-build.js");
var _errorJs = require("./error.js");
var _hoistNonReactStaticsJs = require("./hoist-non-react-statics.js");
var UNKNOWN_COMPONENT = 'unknown';
var INITIAL_STATE = {
    componentStack: null,
    error: null,
    eventId: null
};
/**
 * A ErrorBoundary component that logs errors to Sentry.
 * NOTE: If you are a Sentry user, and you are seeing this stack frame, it means the
 * Sentry React SDK ErrorBoundary caught an error invoking your application code. This
 * is expected behavior and NOT indicative of a bug with the Sentry React SDK.
 */ var ErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, _inherits._)(ErrorBoundary, _React_Component);
    function ErrorBoundary(props) {
        (0, _classCallCheck._)(this, ErrorBoundary);
        var _this;
        _this = (0, _callSuper._)(this, ErrorBoundary, [
            props
        ]);
        _this.state = INITIAL_STATE;
        _this._openFallbackReportDialog = true;
        var client = (0, _browser.getClient)();
        if (client && props.showDialog) {
            _this._openFallbackReportDialog = false;
            _this._cleanupHook = client.on('afterSendEvent', function(event) {
                if (!event.type && _this._lastEventId && event.event_id === _this._lastEventId) (0, _browser.showReportDialog)((0, _objectSpreadProps._)((0, _objectSpread._)({}, props.dialogOptions), {
                    eventId: _this._lastEventId
                }));
            });
        }
        return _this;
    }
    (0, _createClass._)(ErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                var _this = this;
                var componentStack = errorInfo.componentStack;
                var _this_props = this.props, beforeCapture = _this_props.beforeCapture, onError = _this_props.onError, showDialog = _this_props.showDialog, dialogOptions = _this_props.dialogOptions;
                (0, _browser.withScope)(function(scope) {
                    if (beforeCapture) beforeCapture(scope, error, componentStack);
                    var handled = _this.props.handled != null ? _this.props.handled : !!_this.props.fallback;
                    var eventId = (0, _errorJs.captureReactException)(error, errorInfo, {
                        mechanism: {
                            handled: handled,
                            type: 'auto.function.react.error_boundary'
                        }
                    });
                    if (onError) onError(error, componentStack, eventId);
                    if (showDialog) {
                        _this._lastEventId = eventId;
                        if (_this._openFallbackReportDialog) (0, _browser.showReportDialog)((0, _objectSpreadProps._)((0, _objectSpread._)({}, dialogOptions), {
                            eventId: eventId
                        }));
                    }
                    // componentDidCatch is used over getDerivedStateFromError
                    // so that componentStack is accessible through state.
                    _this.setState({
                        error: error,
                        componentStack: componentStack,
                        eventId: eventId
                    });
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var onMount = this.props.onMount;
                if (onMount) onMount();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                var _this_state = this.state, error = _this_state.error, componentStack = _this_state.componentStack, eventId = _this_state.eventId;
                var onUnmount = this.props.onUnmount;
                if (onUnmount) {
                    if (this.state === INITIAL_STATE) // If the error boundary never encountered an error, call onUnmount with null values
                    onUnmount(null, null, null);
                    else // `componentStack` and `eventId` are guaranteed to be non-null here because `onUnmount` is only called
                    // when the error boundary has already encountered an error.
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    onUnmount(error, componentStack, eventId);
                }
                if (this._cleanupHook) {
                    this._cleanupHook();
                    this._cleanupHook = undefined;
                }
            }
        },
        {
            key: "resetErrorBoundary",
            value: function resetErrorBoundary() {
                var onReset = this.props.onReset;
                var _this_state = this.state, error = _this_state.error, componentStack = _this_state.componentStack, eventId = _this_state.eventId;
                if (onReset) // `componentStack` and `eventId` are guaranteed to be non-null here because `onReset` is only called
                // when the error boundary has already encountered an error.
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                onReset(error, componentStack, eventId);
                this.setState(INITIAL_STATE);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this_props = this.props, fallback = _this_props.fallback, children = _this_props.children;
                var state = this.state;
                // `componentStack` is only null in the initial state, when no error has been captured.
                // If an error has been captured, `componentStack` will be a string.
                // We cannot check `state.error` because null can be thrown as an error.
                if (state.componentStack === null) return typeof children === 'function' ? children() : children;
                var element = typeof fallback === 'function' ? _react.createElement(fallback, {
                    error: state.error,
                    componentStack: state.componentStack,
                    resetError: function() {
                        return _this.resetErrorBoundary();
                    },
                    eventId: state.eventId
                }) : fallback;
                if (_react.isValidElement(element)) return element;
                if (fallback) (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).warn('fallback did not produce a valid ReactElement');
                // Fail gracefully if no fallback provided or is not valid
                return null;
            }
        }
    ]);
    return ErrorBoundary;
}(_react.Component);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function withErrorBoundary(WrappedComponent, errorBoundaryOptions) {
    var componentDisplayName = WrappedComponent.displayName || WrappedComponent.name || UNKNOWN_COMPONENT;
    var Wrapped = _react.memo(function(props) {
        return _react.createElement(ErrorBoundary, (0, _objectSpread._)({}, errorBoundaryOptions), _react.createElement(WrappedComponent, (0, _objectSpread._)({}, props)));
    });
    Wrapped.displayName = "errorBoundary(".concat(componentDisplayName, ")");
    // Copy over static methods from Wrapped component to Profiler HOC
    // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
    (0, _hoistNonReactStaticsJs.hoistNonReactStatics)(Wrapped, WrappedComponent);
    return Wrapped;
}

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_inherits":"2sfqW","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@sentry/browser":"fdZ8u","@sentry/core":"lqtxA","react":"ltHCL","./debug-build.js":"3E3ob","./error.js":"gF5NP","./hoist-non-react-statics.js":"2S4dg","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3E3ob":[function(require,module,exports,__globalThis) {
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEBUG_BUILD", function() {
    return DEBUG_BUILD;
});
var DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eJSs2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createReduxEnhancer", function() {
    return createReduxEnhancer;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _core = require("@sentry/core");
var ACTION_BREADCRUMB_CATEGORY = 'redux.action';
var ACTION_BREADCRUMB_TYPE = 'info';
var defaultOptions = {
    attachReduxState: true,
    actionTransformer: function(action) {
        return action;
    },
    stateTransformer: function(state) {
        return state || null;
    }
};
/**
 * Creates an enhancer that would be passed to Redux's createStore to log actions and the latest state to Sentry.
 *
 * @param enhancerOptions Options to pass to the enhancer
 */ function createReduxEnhancer(enhancerOptions) {
    // Note: We return an any type as to not have type conflicts.
    var options = (0, _objectSpread._)({}, defaultOptions, enhancerOptions);
    return function(next) {
        return function(reducer, initialState) {
            options.attachReduxState && (0, _core.getGlobalScope)().addEventProcessor(function(event, hint) {
                try {
                    // @ts-expect-error try catch to reduce bundle size
                    if (event.type === undefined && event.contexts.state.state.type === 'redux') hint.attachments = (0, _toConsumableArray._)(hint.attachments || []).concat([
                        // @ts-expect-error try catch to reduce bundle size
                        {
                            filename: 'redux_state.json',
                            data: JSON.stringify(event.contexts.state.state.value)
                        }
                    ]);
                } catch (e) {
                // empty
                }
                return event;
            });
            function sentryWrapReducer(reducer) {
                return function(state, action) {
                    var newState = reducer(state, action);
                    var scope = (0, _core.getCurrentScope)();
                    /* Action breadcrumbs */ var transformedAction = options.actionTransformer(action);
                    if (typeof transformedAction !== 'undefined' && transformedAction !== null) (0, _core.addBreadcrumb)({
                        category: ACTION_BREADCRUMB_CATEGORY,
                        data: transformedAction,
                        type: ACTION_BREADCRUMB_TYPE
                    });
                    /* Set latest state to scope */ var transformedState = options.stateTransformer(newState);
                    if (typeof transformedState !== 'undefined' && transformedState !== null) {
                        var client = (0, _core.getClient)();
                        var options1 = client === null || client === void 0 ? void 0 : client.getOptions();
                        var normalizationDepth = (options1 === null || options1 === void 0 ? void 0 : options1.normalizeDepth) || 3; // default state normalization depth to 3
                        // Set the normalization depth of the redux state to the configured `normalizeDepth` option or a sane number as a fallback
                        var newStateContext = {
                            state: {
                                type: 'redux',
                                value: transformedState
                            }
                        };
                        (0, _core.addNonEnumerableProperty)(newStateContext, '__sentry_override_normalization_depth__', 3 + // 3 layers for `state.value.transformedState`
                        normalizationDepth);
                        scope.setContext('state', newStateContext);
                    } else scope.setContext('state', null);
                    /* Allow user to configure scope with latest state */ var configureScopeWithState = options.configureScopeWithState;
                    if (typeof configureScopeWithState === 'function') configureScopeWithState(scope, newState);
                    return newState;
                };
            }
            var store = next(sentryWrapReducer(reducer), initialState);
            // eslint-disable-next-line @typescript-eslint/unbound-method
            store.replaceReducer = new Proxy(store.replaceReducer, {
                apply: function apply(target, thisArg, args) {
                    target.apply(thisArg, [
                        sentryWrapReducer(args[0])
                    ]);
                }
            });
            return store;
        };
    };
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_to_consumable_array":"1eSZf","@sentry/core":"lqtxA","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"f44ZV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reactRouterV3BrowserTracingIntegration", function() {
    return reactRouterV3BrowserTracingIntegration;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _browser = require("@sentry/browser");
var _core = require("@sentry/core");
// Many of the types below had to be mocked out to prevent typescript issues
// these types are required for correct functionality.
/**
 * A browser tracing integration that uses React Router v3 to instrument navigations.
 * Expects `history` (and optionally `routes` and `matchPath`) to be passed as options.
 */ function reactRouterV3BrowserTracingIntegration(options) {
    var integration = (0, _browser.browserTracingIntegration)((0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
        instrumentPageLoad: false,
        instrumentNavigation: false
    }));
    var history = options.history, routes = options.routes, match = options.match, _options_instrumentPageLoad = options.instrumentPageLoad, instrumentPageLoad = _options_instrumentPageLoad === void 0 ? true : _options_instrumentPageLoad, _options_instrumentNavigation = options.instrumentNavigation, instrumentNavigation = _options_instrumentNavigation === void 0 ? true : _options_instrumentNavigation;
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, integration), {
        afterAllSetup: function afterAllSetup(client) {
            integration.afterAllSetup(client);
            if (instrumentPageLoad && (0, _browser.WINDOW).location) normalizeTransactionName(routes, (0, _browser.WINDOW).location, match, function(localName) {
                var source = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'url';
                var _obj;
                (0, _browser.startBrowserTracingPageLoadSpan)(client, {
                    name: localName,
                    attributes: (_obj = {}, (0, _defineProperty._)(_obj, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_OP), 'pageload'), (0, _defineProperty._)(_obj, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), 'auto.pageload.react.reactrouter_v3'), (0, _defineProperty._)(_obj, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), source), _obj)
                });
            });
            if (instrumentNavigation && history.listen) history.listen(function(location) {
                if (location.action === 'PUSH' || location.action === 'POP') normalizeTransactionName(routes, location, match, function(localName) {
                    var source = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'url';
                    var _obj;
                    (0, _browser.startBrowserTracingNavigationSpan)(client, {
                        name: localName,
                        attributes: (_obj = {}, (0, _defineProperty._)(_obj, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_OP), 'navigation'), (0, _defineProperty._)(_obj, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), 'auto.navigation.react.reactrouter_v3'), (0, _defineProperty._)(_obj, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), source), _obj)
                    });
                });
            });
        }
    });
}
/**
 * Normalize transaction names using `Router.match`
 */ function normalizeTransactionName(appRoutes, location, match, callback) {
    var name = location.pathname;
    match({
        location: location,
        routes: appRoutes
    }, function(error, _redirectLocation, renderProps) {
        if (error || !renderProps) return callback(name);
        var routePath = getRouteStringFromRoutes(renderProps.routes || []);
        if (routePath.length === 0 || routePath === '/*') return callback(name);
        name = routePath;
        return callback(name, 'route');
    });
}
/**
 * Generate route name from array of routes
 */ function getRouteStringFromRoutes(routes) {
    if (!Array.isArray(routes) || routes.length === 0) return '';
    var routesWithPaths = routes.filter(function(route) {
        return !!route.path;
    });
    var index = -1;
    for(var x = routesWithPaths.length - 1; x >= 0; x--){
        var _route_path;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        var route = routesWithPaths[x];
        if ((_route_path = route.path) === null || _route_path === void 0 ? void 0 : _route_path.startsWith('/')) {
            index = x;
            break;
        }
    }
    return routesWithPaths.slice(index).reduce(function(acc, param) {
        var path = param.path;
        var pathSegment = acc === '/' || acc === '' ? path : "/".concat(path);
        return "".concat(acc).concat(pathSegment);
    }, '');
}

},{"@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@sentry/browser":"fdZ8u","@sentry/core":"lqtxA","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"d9MzP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "tanstackRouterBrowserTracingIntegration", function() {
    return tanstackRouterBrowserTracingIntegration;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _browser = require("@sentry/browser");
var _core = require("@sentry/core");
/**
 * A custom browser tracing integration for TanStack Router.
 *
 * The minimum compatible version of `@tanstack/react-router` is `1.64.0`.
 *
 * @param router A TanStack Router `Router` instance that should be used for routing instrumentation.
 * @param options Sentry browser tracing configuration.
 */ function tanstackRouterBrowserTracingIntegration(// eslint-disable-next-line @typescript-eslint/no-explicit-any
router) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var castRouterInstance = router;
    var browserTracingIntegrationInstance = (0, _browser.browserTracingIntegration)((0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
        instrumentNavigation: false,
        instrumentPageLoad: false
    }));
    var _options_instrumentPageLoad = options.instrumentPageLoad, instrumentPageLoad = _options_instrumentPageLoad === void 0 ? true : _options_instrumentPageLoad, _options_instrumentNavigation = options.instrumentNavigation, instrumentNavigation = _options_instrumentNavigation === void 0 ? true : _options_instrumentNavigation;
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, browserTracingIntegrationInstance), {
        afterAllSetup: function afterAllSetup(client) {
            browserTracingIntegrationInstance.afterAllSetup(client);
            var initialWindowLocation = (0, _browser.WINDOW).location;
            if (instrumentPageLoad && initialWindowLocation) {
                var matchedRoutes = castRouterInstance.matchRoutes(initialWindowLocation.pathname, castRouterInstance.options.parseSearch(initialWindowLocation.search), {
                    preload: false,
                    throwOnError: false
                });
                var lastMatch = matchedRoutes[matchedRoutes.length - 1];
                var _obj;
                (0, _browser.startBrowserTracingPageLoadSpan)(client, {
                    name: lastMatch ? lastMatch.routeId : initialWindowLocation.pathname,
                    attributes: (0, _objectSpread._)((_obj = {}, (0, _defineProperty._)(_obj, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_OP), 'pageload'), (0, _defineProperty._)(_obj, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), 'auto.pageload.react.tanstack_router'), (0, _defineProperty._)(_obj, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), lastMatch ? 'route' : 'url'), _obj), routeMatchToParamSpanAttributes(lastMatch))
                });
            }
            if (instrumentNavigation) // The onBeforeNavigate hook is called at the very beginning of a navigation and is only called once per navigation, even when the user is redirected
            castRouterInstance.subscribe('onBeforeNavigate', function(onBeforeNavigateArgs) {
                var _onBeforeNavigateArgs_fromLocation;
                // onBeforeNavigate is called during pageloads. We can avoid creating navigation spans by comparing the states of the to and from arguments.
                if (onBeforeNavigateArgs.toLocation.state === ((_onBeforeNavigateArgs_fromLocation = onBeforeNavigateArgs.fromLocation) === null || _onBeforeNavigateArgs_fromLocation === void 0 ? void 0 : _onBeforeNavigateArgs_fromLocation.state)) return;
                var onResolvedMatchedRoutes = castRouterInstance.matchRoutes(onBeforeNavigateArgs.toLocation.pathname, onBeforeNavigateArgs.toLocation.search, {
                    preload: false,
                    throwOnError: false
                });
                var onBeforeNavigateLastMatch = onResolvedMatchedRoutes[onResolvedMatchedRoutes.length - 1];
                var navigationLocation = (0, _browser.WINDOW).location;
                var _obj;
                var navigationSpan = (0, _browser.startBrowserTracingNavigationSpan)(client, {
                    name: onBeforeNavigateLastMatch ? onBeforeNavigateLastMatch.routeId : navigationLocation.pathname,
                    attributes: (_obj = {}, (0, _defineProperty._)(_obj, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_OP), 'navigation'), (0, _defineProperty._)(_obj, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), 'auto.navigation.react.tanstack_router'), (0, _defineProperty._)(_obj, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), onBeforeNavigateLastMatch ? 'route' : 'url'), _obj)
                });
                // In case the user is redirected during navigation we want to update the span with the right value.
                var unsubscribeOnResolved = castRouterInstance.subscribe('onResolved', function(onResolvedArgs) {
                    unsubscribeOnResolved();
                    if (navigationSpan) {
                        var onResolvedMatchedRoutes = castRouterInstance.matchRoutes(onResolvedArgs.toLocation.pathname, onResolvedArgs.toLocation.search, {
                            preload: false,
                            throwOnError: false
                        });
                        var onResolvedLastMatch = onResolvedMatchedRoutes[onResolvedMatchedRoutes.length - 1];
                        if (onResolvedLastMatch) {
                            navigationSpan.updateName(onResolvedLastMatch.routeId);
                            navigationSpan.setAttribute((0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), 'route');
                            navigationSpan.setAttributes(routeMatchToParamSpanAttributes(onResolvedLastMatch));
                        }
                    }
                });
            });
        }
    });
}
function routeMatchToParamSpanAttributes(match) {
    if (!match) return {};
    var paramAttributes = {};
    Object.entries(match.params).forEach(function(param) {
        var _param = (0, _slicedToArray._)(param, 2), key = _param[0], value = _param[1];
        paramAttributes["url.path.params.".concat(key)] = value; // TODO(v11): remove attribute which does not adhere to Sentry's semantic convention
        paramAttributes["url.path.parameter.".concat(key)] = value;
        paramAttributes["params.".concat(key)] = value; // params.[key] is an alias
    });
    return paramAttributes;
}

},{"@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_sliced_to_array":"8PtL6","@sentry/browser":"fdZ8u","@sentry/core":"lqtxA","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9H8A3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reactRouterV4BrowserTracingIntegration", function() {
    return reactRouterV4BrowserTracingIntegration;
});
parcelHelpers.export(exports, "reactRouterV5BrowserTracingIntegration", function() {
    return reactRouterV5BrowserTracingIntegration;
});
parcelHelpers.export(exports, "withSentryRouting", function() {
    return withSentryRouting;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _browser = require("@sentry/browser");
var _core = require("@sentry/core");
var _react = require("react");
var _hoistNonReactStaticsJs = require("./hoist-non-react-statics.js");
// We need to disable eslint no-explicit-any because any is required for the
// react-router typings.
/**
 * A browser tracing integration that uses React Router v4 to instrument navigations.
 * Expects `history` (and optionally `routes` and `matchPath`) to be passed as options.
 */ function reactRouterV4BrowserTracingIntegration(options) {
    var integration = (0, _browser.browserTracingIntegration)((0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
        instrumentPageLoad: false,
        instrumentNavigation: false
    }));
    var history = options.history, routes = options.routes, matchPath = options.matchPath, _options_instrumentPageLoad = options.instrumentPageLoad, instrumentPageLoad = _options_instrumentPageLoad === void 0 ? true : _options_instrumentPageLoad, _options_instrumentNavigation = options.instrumentNavigation, instrumentNavigation = _options_instrumentNavigation === void 0 ? true : _options_instrumentNavigation;
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, integration), {
        afterAllSetup: function afterAllSetup(client) {
            integration.afterAllSetup(client);
            instrumentReactRouter(client, instrumentPageLoad, instrumentNavigation, history, 'reactrouter_v4', routes, matchPath);
        }
    });
}
/**
 * A browser tracing integration that uses React Router v5 to instrument navigations.
 * Expects `history` (and optionally `routes` and `matchPath`) to be passed as options.
 */ function reactRouterV5BrowserTracingIntegration(options) {
    var integration = (0, _browser.browserTracingIntegration)((0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
        instrumentPageLoad: false,
        instrumentNavigation: false
    }));
    var history = options.history, routes = options.routes, matchPath = options.matchPath, _options_instrumentPageLoad = options.instrumentPageLoad, instrumentPageLoad = _options_instrumentPageLoad === void 0 ? true : _options_instrumentPageLoad, _options_instrumentNavigation = options.instrumentNavigation, instrumentNavigation = _options_instrumentNavigation === void 0 ? true : _options_instrumentNavigation;
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, integration), {
        afterAllSetup: function afterAllSetup(client) {
            integration.afterAllSetup(client);
            instrumentReactRouter(client, instrumentPageLoad, instrumentNavigation, history, 'reactrouter_v5', routes, matchPath);
        }
    });
}
function instrumentReactRouter(client, instrumentPageLoad, instrumentNavigation, history, instrumentationName) {
    var allRoutes = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : [], matchPath = arguments.length > 6 ? arguments[6] : void 0;
    function getInitPathName() {
        if (history.location) return history.location.pathname;
        if ((0, _browser.WINDOW).location) return (0, _browser.WINDOW).location.pathname;
        return undefined;
    }
    /**
   * Normalizes a transaction name. Returns the new name as well as the
   * source of the transaction.
   *
   * @param pathname The initial pathname we normalize
   */ function normalizeTransactionName(pathname) {
        if (allRoutes.length === 0 || !matchPath) return [
            pathname,
            'url'
        ];
        var branches = matchRoutes(allRoutes, pathname, matchPath);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = branches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var branch = _step.value;
                if (branch.match.isExact) return [
                    branch.match.path,
                    'route'
                ];
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return [
            pathname,
            'url'
        ];
    }
    if (instrumentPageLoad) {
        var initPathName = getInitPathName();
        if (initPathName) {
            var _normalizeTransactionName = (0, _slicedToArray._)(normalizeTransactionName(initPathName), 2), name = _normalizeTransactionName[0], source = _normalizeTransactionName[1];
            var _obj;
            (0, _browser.startBrowserTracingPageLoadSpan)(client, {
                name: name,
                attributes: (_obj = {}, (0, _defineProperty._)(_obj, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_OP), 'pageload'), (0, _defineProperty._)(_obj, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), "auto.pageload.react.".concat(instrumentationName)), (0, _defineProperty._)(_obj, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), source), _obj)
            });
        }
    }
    if (instrumentNavigation && history.listen) history.listen(function(location, action) {
        if (action && (action === 'PUSH' || action === 'POP')) {
            var _normalizeTransactionName = (0, _slicedToArray._)(normalizeTransactionName(location.pathname), 2), name = _normalizeTransactionName[0], source = _normalizeTransactionName[1];
            var _obj;
            (0, _browser.startBrowserTracingNavigationSpan)(client, {
                name: name,
                attributes: (_obj = {}, (0, _defineProperty._)(_obj, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_OP), 'navigation'), (0, _defineProperty._)(_obj, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), "auto.navigation.react.".concat(instrumentationName)), (0, _defineProperty._)(_obj, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), source), _obj)
            });
        }
    });
}
/**
 * Matches a set of routes to a pathname
 * Based on implementation from
 */ function matchRoutes(routes, pathname, matchPath) {
    var branch = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [];
    routes.some(function(route) {
        var match = route.path ? matchPath(pathname, route) : branch.length ? branch[branch.length - 1].match // use parent match
         : computeRootMatch(pathname); // use default "root" match
        if (match) {
            branch.push({
                route: route,
                match: match
            });
            if (route.routes) matchRoutes(route.routes, pathname, matchPath, branch);
        }
        return !!match;
    });
    return branch;
}
function computeRootMatch(pathname) {
    return {
        path: '/',
        url: '/',
        params: {},
        isExact: pathname === '/'
    };
}
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */ function withSentryRouting(Route) {
    var componentDisplayName = Route.displayName || Route.name;
    var WrappedRoute = function(props) {
        var _props_computedMatch;
        if (props === null || props === void 0 ? void 0 : (_props_computedMatch = props.computedMatch) === null || _props_computedMatch === void 0 ? void 0 : _props_computedMatch.isExact) {
            var route = props.computedMatch.path;
            var activeRootSpan = getActiveRootSpan();
            (0, _core.getCurrentScope)().setTransactionName(route);
            if (activeRootSpan) {
                activeRootSpan.updateName(route);
                activeRootSpan.setAttribute((0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), 'route');
            }
        }
        // @ts-expect-error Setting more specific React Component typing for `R` generic above
        // will break advanced type inference done by react router params:
        // https://github.com/DefinitelyTyped/DefinitelyTyped/blob/13dc4235c069e25fe7ee16e11f529d909f9f3ff8/types/react-router/index.d.ts#L154-L164
        return _react.createElement(Route, (0, _objectSpread._)({}, props));
    };
    WrappedRoute.displayName = "sentryRoute(".concat(componentDisplayName, ")");
    (0, _hoistNonReactStaticsJs.hoistNonReactStatics)(WrappedRoute, Route);
    // @ts-expect-error Setting more specific React Component typing for `R` generic above
    // will break advanced type inference done by react router params:
    // https://github.com/DefinitelyTyped/DefinitelyTyped/blob/13dc4235c069e25fe7ee16e11f529d909f9f3ff8/types/react-router/index.d.ts#L154-L164
    return WrappedRoute;
}
/* eslint-enable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */ function getActiveRootSpan() {
    var span = (0, _core.getActiveSpan)();
    var rootSpan = span && (0, _core.getRootSpan)(span);
    if (!rootSpan) return undefined;
    var op = (0, _core.spanToJSON)(rootSpan).op;
    // Only use this root span if it is a pageload or navigation span
    return op === 'navigation' || op === 'pageload' ? rootSpan : undefined;
}

},{"@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_sliced_to_array":"8PtL6","@sentry/browser":"fdZ8u","@sentry/core":"lqtxA","react":"ltHCL","./hoist-non-react-statics.js":"2S4dg","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lIgVp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reactRouterV6BrowserTracingIntegration", function() {
    return reactRouterV6BrowserTracingIntegration;
});
parcelHelpers.export(exports, "withSentryReactRouterV6Routing", function() {
    return withSentryReactRouterV6Routing;
});
parcelHelpers.export(exports, "wrapCreateBrowserRouterV6", function() {
    return wrapCreateBrowserRouterV6;
});
parcelHelpers.export(exports, "wrapCreateMemoryRouterV6", function() {
    return wrapCreateMemoryRouterV6;
});
parcelHelpers.export(exports, "wrapUseRoutesV6", function() {
    return wrapUseRoutesV6;
});
var _instrumentationJs = require("./reactrouter-compat-utils/instrumentation.js");
var _core = require("@sentry/core");
/**
 * A browser tracing integration that uses React Router v6 to instrument navigations.
 * Expects `useEffect`, `useLocation`, `useNavigationType`, `createRoutesFromChildren` and `matchRoutes` to be passed as options.
 */ function reactRouterV6BrowserTracingIntegration(options) {
    return (0, _instrumentationJs.createReactRouterV6CompatibleTracingIntegration)(options, '6');
}
/**
 * A wrapper function that adds Sentry routing instrumentation to a React Router v6 useRoutes hook.
 * This is used to automatically capture route changes as transactions when using the useRoutes hook.
 */ function wrapUseRoutesV6(origUseRoutes) {
    return (0, _instrumentationJs.createV6CompatibleWrapUseRoutes)(origUseRoutes, '6');
}
/**
 * A wrapper function that adds Sentry routing instrumentation to a React Router v6 createBrowserRouter function.
 * This is used to automatically capture route changes as transactions when using the createBrowserRouter API.
 */ function wrapCreateBrowserRouterV6(createRouterFunction) {
    return (0, _instrumentationJs.createV6CompatibleWrapCreateBrowserRouter)(createRouterFunction, '6');
}
/**
 * A wrapper function that adds Sentry routing instrumentation to a React Router v6 createMemoryRouter function.
 * This is used to automatically capture route changes as transactions when using the createMemoryRouter API.
 * The difference between createBrowserRouter and createMemoryRouter is that with createMemoryRouter,
 * optional `initialEntries` are also taken into account.
 */ function wrapCreateMemoryRouterV6(createMemoryRouterFunction) {
    return (0, _instrumentationJs.createV6CompatibleWrapCreateMemoryRouter)(createMemoryRouterFunction, '6');
}
/**
 * A higher-order component that adds Sentry routing instrumentation to a React Router v6 Route component.
 * This is used to automatically capture route changes as transactions.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function withSentryReactRouterV6Routing(routes) {
    return (0, _instrumentationJs.createV6CompatibleWithSentryReactRouterRouting)(routes, '6');
}

},{"./reactrouter-compat-utils/instrumentation.js":"g30h5","@sentry/core":"lqtxA","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"g30h5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addResolvedRoutesToParent", function() {
    return addResolvedRoutesToParent;
});
parcelHelpers.export(exports, "addRoutesToAllRoutes", function() {
    return addRoutesToAllRoutes;
});
parcelHelpers.export(exports, "allRoutes", function() {
    return allRoutes;
});
parcelHelpers.export(exports, "computeLocationKey", function() {
    return computeLocationKey;
});
parcelHelpers.export(exports, "createReactRouterV6CompatibleTracingIntegration", function() {
    return createReactRouterV6CompatibleTracingIntegration;
});
parcelHelpers.export(exports, "createV6CompatibleWithSentryReactRouterRouting", function() {
    return createV6CompatibleWithSentryReactRouterRouting;
});
parcelHelpers.export(exports, "createV6CompatibleWrapCreateBrowserRouter", function() {
    return createV6CompatibleWrapCreateBrowserRouter;
});
parcelHelpers.export(exports, "createV6CompatibleWrapCreateMemoryRouter", function() {
    return createV6CompatibleWrapCreateMemoryRouter;
});
parcelHelpers.export(exports, "createV6CompatibleWrapUseRoutes", function() {
    return createV6CompatibleWrapUseRoutes;
});
parcelHelpers.export(exports, "handleNavigation", function() {
    return handleNavigation;
});
parcelHelpers.export(exports, "processResolvedRoutes", function() {
    return processResolvedRoutes;
});
parcelHelpers.export(exports, "shouldSkipNavigation", function() {
    return shouldSkipNavigation;
});
parcelHelpers.export(exports, "updateNavigationSpan", function() {
    return updateNavigationSpan;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _browser = require("@sentry/browser");
var _core = require("@sentry/core");
var _react = require("react");
var _debugBuildJs = require("../debug-build.js");
var _hoistNonReactStaticsJs = require("../hoist-non-react-statics.js");
var _lazyRoutesJs = require("./lazy-routes.js");
var _utilsJs = require("./utils.js");
/* eslint-disable max-lines */ // Inspired from Donnie McNeal's solution:
// https://gist.github.com/wontondon/e8c4bdf2888875e4c755712e99279536
var _useEffect;
var _useLocation;
var _useNavigationType;
var _createRoutesFromChildren;
var _matchRoutes;
var _enableAsyncRouteHandlers = false;
var _lazyRouteTimeout = 3000;
var CLIENTS_WITH_INSTRUMENT_NAVIGATION = new WeakSet();
// Prevents duplicate spans when router.subscribe fires multiple times
var activeNavigationSpans = new WeakMap();
// Exported for testing only
var allRoutes = new Set();
// Tracks lazy route loads to wait before finalizing span names
var pendingLazyRouteLoads = new WeakMap();
/**
 * Schedules a callback using requestAnimationFrame when available (browser),
 * or falls back to setTimeout for SSR environments (Node.js, createMemoryRouter tests).
 */ function scheduleCallback(callback) {
    if ((0, _browser.WINDOW) === null || (0, _browser.WINDOW) === void 0 ? void 0 : (0, _browser.WINDOW).requestAnimationFrame) return (0, _browser.WINDOW).requestAnimationFrame(callback);
    return setTimeout(callback, 0);
}
/**
 * Cancels a scheduled callback, handling both RAF (browser) and timeout (SSR) IDs.
 */ function cancelScheduledCallback(id) {
    if ((0, _browser.WINDOW) === null || (0, _browser.WINDOW) === void 0 ? void 0 : (0, _browser.WINDOW).cancelAnimationFrame) (0, _browser.WINDOW).cancelAnimationFrame(id);
    else clearTimeout(id);
}
/**
 * Computes location key for duplicate detection. Normalizes undefined/null to empty strings.
 * Exported for testing.
 */ function computeLocationKey(location) {
    return "".concat(location.pathname).concat(location.search || '').concat(location.hash || '');
}
/**
 * Checks if a route name is parameterized (contains route parameters like :id or wildcards like *)
 * vs a raw URL path.
 */ function isParameterizedRoute(routeName) {
    return routeName.includes(':') || routeName.includes('*');
}
/**
 * Determines if a navigation should be skipped as a duplicate, and if an existing span should be updated.
 * Exported for testing.
 *
 * @returns An object with:
 *   - skip: boolean - Whether to skip creating a new span
 *   - shouldUpdate: boolean - Whether to update the existing span name (wildcard upgrade)
 */ function shouldSkipNavigation(trackedNav, locationKey, proposedName, spanHasEnded) {
    if (!trackedNav) return {
        skip: false,
        shouldUpdate: false
    };
    // Check if this is a duplicate navigation (same location)
    // 1. If it's a placeholder, it's always a duplicate (we're waiting for the real one)
    // 2. If it's a real span, it's a duplicate only if it hasn't ended yet
    var isDuplicate = trackedNav.locationKey === locationKey && (trackedNav.isPlaceholder || !spanHasEnded);
    if (isDuplicate) {
        var _trackedNav_routeName;
        // Check if we should update the span name with a better route
        // Allow updates if:
        // 1. Current has wildcard and new doesn't (wildcard → parameterized upgrade)
        // 2. Current is raw path and new is parameterized (raw → parameterized upgrade)
        // 3. New name is different and more specific (longer, indicating nested routes resolved)
        var currentHasWildcard = !!trackedNav.routeName && (0, _utilsJs.transactionNameHasWildcard)(trackedNav.routeName);
        var proposedHasWildcard = (0, _utilsJs.transactionNameHasWildcard)(proposedName);
        var currentIsParameterized = !!trackedNav.routeName && isParameterizedRoute(trackedNav.routeName);
        var proposedIsParameterized = isParameterizedRoute(proposedName);
        var isWildcardUpgrade = currentHasWildcard && !proposedHasWildcard;
        var isRawToParameterized = !currentIsParameterized && proposedIsParameterized;
        var isMoreSpecific = proposedName !== trackedNav.routeName && proposedName.length > (((_trackedNav_routeName = trackedNav.routeName) === null || _trackedNav_routeName === void 0 ? void 0 : _trackedNav_routeName.length) || 0) && !proposedHasWildcard;
        var shouldUpdate = !!(trackedNav.routeName && (isWildcardUpgrade || isRawToParameterized || isMoreSpecific));
        return {
            skip: true,
            shouldUpdate: shouldUpdate
        };
    }
    return {
        skip: false,
        shouldUpdate: false
    };
}
function addResolvedRoutesToParent(resolvedRoutes, parentRoute) {
    var existingChildren = parentRoute.children || [];
    var newRoutes = resolvedRoutes.filter(function(newRoute) {
        return !existingChildren.some(function(existing) {
            return existing === newRoute || newRoute.path && existing.path === newRoute.path || newRoute.id && existing.id === newRoute.id;
        });
    });
    if (newRoutes.length > 0) parentRoute.children = (0, _toConsumableArray._)(existingChildren).concat((0, _toConsumableArray._)(newRoutes));
}
/** Registers a pending lazy route load promise for a span. */ function trackLazyRouteLoad(span, promise) {
    var promises = pendingLazyRouteLoads.get(span);
    if (!promises) {
        promises = new Set();
        pendingLazyRouteLoads.set(span, promises);
    }
    promises.add(promise);
    // Clean up when promise resolves/rejects
    promise.finally(function() {
        var currentPromises = pendingLazyRouteLoads.get(span);
        if (currentPromises) currentPromises.delete(promise);
    });
}
/**
 * Processes resolved routes by adding them to allRoutes and checking for nested async handlers.
 */ function processResolvedRoutes(resolvedRoutes, parentRoute) {
    var currentLocation = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    resolvedRoutes.forEach(function(child) {
        allRoutes.add(child);
        // Only check for async handlers if the feature is enabled
        if (_enableAsyncRouteHandlers) (0, _lazyRoutesJs.checkRouteForAsyncHandler)(child, processResolvedRoutes);
    });
    if (parentRoute) // If a parent route is provided, add the resolved routes as children to the parent route
    addResolvedRoutesToParent(resolvedRoutes, parentRoute);
    // After processing lazy routes, check if we need to update an active transaction
    var activeRootSpan = getActiveRootSpan();
    if (activeRootSpan) {
        var spanOp = (0, _core.spanToJSON)(activeRootSpan).op;
        // Try to use the provided location first, then fall back to global window location if needed
        var location = currentLocation;
        if (!location) {
            if (typeof (0, _browser.WINDOW) !== 'undefined') {
                var globalLocation = (0, _browser.WINDOW).location;
                if (globalLocation) location = {
                    pathname: globalLocation.pathname
                };
            }
        }
        if (location) {
            if (spanOp === 'pageload') // Re-run the pageload transaction update with the newly loaded routes
            updatePageloadTransaction({
                activeRootSpan: activeRootSpan,
                location: {
                    pathname: location.pathname
                },
                routes: Array.from(allRoutes),
                allRoutes: Array.from(allRoutes)
            });
            else if (spanOp === 'navigation') // For navigation spans, update the name with the newly loaded routes
            updateNavigationSpan(activeRootSpan, location, Array.from(allRoutes), false, _matchRoutes);
        }
    }
}
/**
 * Updates a navigation span with the correct route name after lazy routes have been loaded.
 */ function updateNavigationSpan(activeRootSpan, location, allRoutes) {
    var forceUpdate = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, matchRoutes = arguments.length > 4 ? arguments[4] : void 0;
    var spanJson = (0, _core.spanToJSON)(activeRootSpan);
    var currentName = spanJson.description;
    var hasBeenNamed = activeRootSpan === null || activeRootSpan === void 0 ? void 0 : activeRootSpan.__sentry_navigation_name_set__;
    var currentNameHasWildcard = currentName && (0, _utilsJs.transactionNameHasWildcard)(currentName);
    var shouldUpdate = !hasBeenNamed || forceUpdate || currentNameHasWildcard;
    if (shouldUpdate && !spanJson.timestamp) {
        var _spanJson_data;
        var currentBranches = matchRoutes(allRoutes, location);
        var _resolveRouteNameAndSource = (0, _slicedToArray._)((0, _utilsJs.resolveRouteNameAndSource)(location, allRoutes, allRoutes, currentBranches || [], ''), 2), name = _resolveRouteNameAndSource[0], source = _resolveRouteNameAndSource[1];
        var currentSource = (_spanJson_data = spanJson.data) === null || _spanJson_data === void 0 ? void 0 : _spanJson_data[0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
        var isImprovement = name && (!currentName || // No current name - always set
        !hasBeenNamed && (currentSource !== 'route' || source === 'route') || // Not finalized - allow unless downgrading route→url
        currentSource !== 'route' && source === 'route' || // URL → route upgrade
        currentSource === 'route' && source === 'route' && currentNameHasWildcard); // Route → better route (only if current has wildcard)
        if (isImprovement) {
            activeRootSpan.updateName(name);
            activeRootSpan.setAttribute((0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), source);
            // Only mark as finalized for non-wildcard route names (allows URL→route upgrades).
            if (!(0, _utilsJs.transactionNameHasWildcard)(name) && source === 'route') (0, _core.addNonEnumerableProperty)(activeRootSpan, '__sentry_navigation_name_set__', true);
        }
    }
}
function setupRouterSubscription(router, routes, version, basename, activeRootSpan) {
    var isInitialPageloadComplete = false;
    var hasSeenPageloadSpan = !!activeRootSpan && (0, _core.spanToJSON)(activeRootSpan).op === 'pageload';
    var hasSeenPopAfterPageload = false;
    var scheduledNavigationHandler = null;
    var lastHandledPathname = null;
    router.subscribe(function(state) {
        if (!isInitialPageloadComplete) {
            var currentRootSpan = getActiveRootSpan();
            var isCurrentlyInPageload = currentRootSpan && (0, _core.spanToJSON)(currentRootSpan).op === 'pageload';
            if (isCurrentlyInPageload) hasSeenPageloadSpan = true;
            else if (hasSeenPageloadSpan) {
                if (state.historyAction === 'POP' && !hasSeenPopAfterPageload) hasSeenPopAfterPageload = true;
                else isInitialPageloadComplete = true;
            }
        }
        var shouldHandleNavigation = state.historyAction === 'PUSH' || state.historyAction === 'POP' && isInitialPageloadComplete;
        if (shouldHandleNavigation) {
            // Include search and hash to allow query/hash-only navigations
            // Use computeLocationKey() to ensure undefined/null values are normalized to empty strings
            var currentLocationKey = computeLocationKey(state.location);
            var navigationHandler = function() {
                // Prevent multiple calls for the same location within the same navigation cycle
                if (lastHandledPathname === currentLocationKey) return;
                lastHandledPathname = currentLocationKey;
                scheduledNavigationHandler = null;
                handleNavigation({
                    location: state.location,
                    routes: routes,
                    navigationType: state.historyAction,
                    version: version,
                    basename: basename,
                    allRoutes: Array.from(allRoutes)
                });
            };
            if (state.navigation.state !== 'idle') {
                // Navigation in progress - reset if location changed
                if (lastHandledPathname !== currentLocationKey) lastHandledPathname = null;
                // Cancel any previously scheduled handler to avoid duplicates
                if (scheduledNavigationHandler !== null) cancelScheduledCallback(scheduledNavigationHandler);
                scheduledNavigationHandler = scheduleCallback(navigationHandler);
            } else {
                // Navigation completed - cancel scheduled handler if any, then call immediately
                if (scheduledNavigationHandler !== null) {
                    cancelScheduledCallback(scheduledNavigationHandler);
                    scheduledNavigationHandler = null;
                }
                navigationHandler();
            // Don't reset - next navigation cycle resets to prevent duplicates within same cycle.
            }
        }
    });
}
/**
 * Creates a wrapCreateBrowserRouter function that can be used with all React Router v6 compatible versions.
 */ function createV6CompatibleWrapCreateBrowserRouter(createRouterFunction, version) {
    if (!_useEffect || !_useLocation || !_useNavigationType || !_matchRoutes) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).warn("reactRouterV".concat(version, "Instrumentation was unable to wrap the `createRouter` function because of one or more missing parameters."));
        return createRouterFunction;
    }
    return function(routes, opts) {
        addRoutesToAllRoutes(routes);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (_enableAsyncRouteHandlers) try {
            for(var _iterator = routes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var route = _step.value;
                (0, _lazyRoutesJs.checkRouteForAsyncHandler)(route, processResolvedRoutes);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var wrappedOpts = wrapPatchRoutesOnNavigation(opts);
        var router = createRouterFunction(routes, wrappedOpts);
        var basename = opts === null || opts === void 0 ? void 0 : opts.basename;
        var activeRootSpan = getActiveRootSpan();
        if (router.state.historyAction === 'POP' && activeRootSpan) updatePageloadTransaction({
            activeRootSpan: activeRootSpan,
            location: router.state.location,
            routes: routes,
            basename: basename,
            allRoutes: Array.from(allRoutes)
        });
        setupRouterSubscription(router, routes, version, basename, activeRootSpan);
        return router;
    };
}
/**
 * Creates a wrapCreateMemoryRouter function that can be used with all React Router v6 compatible versions.
 */ function createV6CompatibleWrapCreateMemoryRouter(createRouterFunction, version) {
    if (!_useEffect || !_useLocation || !_useNavigationType || !_matchRoutes) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).warn("reactRouterV".concat(version, "Instrumentation was unable to wrap the `createMemoryRouter` function because of one or more missing parameters."));
        return createRouterFunction;
    }
    return function(routes, opts) {
        addRoutesToAllRoutes(routes);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (_enableAsyncRouteHandlers) try {
            for(var _iterator = routes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var route = _step.value;
                (0, _lazyRoutesJs.checkRouteForAsyncHandler)(route, processResolvedRoutes);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var wrappedOpts = wrapPatchRoutesOnNavigation(opts, true);
        var router = createRouterFunction(routes, wrappedOpts);
        var basename = opts === null || opts === void 0 ? void 0 : opts.basename;
        var initialEntry = undefined;
        var initialEntries = opts === null || opts === void 0 ? void 0 : opts.initialEntries;
        var initialIndex = opts === null || opts === void 0 ? void 0 : opts.initialIndex;
        var hasOnlyOneInitialEntry = initialEntries && initialEntries.length === 1;
        var hasIndexedEntry = initialIndex !== undefined && initialEntries && initialEntries[initialIndex];
        initialEntry = hasOnlyOneInitialEntry ? initialEntries[0] : hasIndexedEntry ? initialEntries[initialIndex] : undefined;
        var location = initialEntry ? typeof initialEntry === 'string' ? {
            pathname: initialEntry
        } : initialEntry : router.state.location;
        var memoryActiveRootSpan = getActiveRootSpan();
        if (router.state.historyAction === 'POP' && memoryActiveRootSpan) updatePageloadTransaction({
            activeRootSpan: memoryActiveRootSpan,
            location: location,
            routes: routes,
            basename: basename,
            allRoutes: Array.from(allRoutes)
        });
        setupRouterSubscription(router, routes, version, basename, memoryActiveRootSpan);
        return router;
    };
}
/**
 * Creates a browser tracing integration that can be used with all React Router v6 compatible versions.
 */ function createReactRouterV6CompatibleTracingIntegration(options, version) {
    var integration = (0, _browser.browserTracingIntegration)((0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
        instrumentPageLoad: false,
        instrumentNavigation: false
    }));
    var useEffect = options.useEffect, useLocation = options.useLocation, useNavigationType = options.useNavigationType, createRoutesFromChildren = options.createRoutesFromChildren, matchRoutes = options.matchRoutes, stripBasename = options.stripBasename, _options_enableAsyncRouteHandlers = options.enableAsyncRouteHandlers, enableAsyncRouteHandlers = _options_enableAsyncRouteHandlers === void 0 ? false : _options_enableAsyncRouteHandlers, _options_instrumentPageLoad = options.instrumentPageLoad, instrumentPageLoad = _options_instrumentPageLoad === void 0 ? true : _options_instrumentPageLoad, _options_instrumentNavigation = options.instrumentNavigation, instrumentNavigation = _options_instrumentNavigation === void 0 ? true : _options_instrumentNavigation, lazyRouteTimeout = options.lazyRouteTimeout;
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, integration), {
        setup: function setup(client) {
            integration.setup(client);
            var _options_finalTimeout;
            var finalTimeout = (_options_finalTimeout = options.finalTimeout) !== null && _options_finalTimeout !== void 0 ? _options_finalTimeout : 30000;
            var _options_idleTimeout;
            var defaultMaxWait = ((_options_idleTimeout = options.idleTimeout) !== null && _options_idleTimeout !== void 0 ? _options_idleTimeout : 1000) * 3;
            var configuredMaxWait = lazyRouteTimeout !== null && lazyRouteTimeout !== void 0 ? lazyRouteTimeout : defaultMaxWait;
            // Cap Infinity at finalTimeout to prevent indefinite hangs
            if (configuredMaxWait === Infinity) {
                _lazyRouteTimeout = finalTimeout;
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).log('[React Router] lazyRouteTimeout set to Infinity, capping at finalTimeout:', finalTimeout, 'ms to prevent indefinite hangs');
            } else if (Number.isNaN(configuredMaxWait)) {
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).warn('[React Router] lazyRouteTimeout must be a number, falling back to default:', defaultMaxWait);
                _lazyRouteTimeout = defaultMaxWait;
            } else if (configuredMaxWait < 0) {
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).warn('[React Router] lazyRouteTimeout must be non-negative or Infinity, got:', configuredMaxWait, 'falling back to:', defaultMaxWait);
                _lazyRouteTimeout = defaultMaxWait;
            } else _lazyRouteTimeout = configuredMaxWait;
            _useEffect = useEffect;
            _useLocation = useLocation;
            _useNavigationType = useNavigationType;
            _matchRoutes = matchRoutes;
            _createRoutesFromChildren = createRoutesFromChildren;
            _enableAsyncRouteHandlers = enableAsyncRouteHandlers;
            // Initialize the router utils with the required dependencies
            (0, _utilsJs.initializeRouterUtils)(matchRoutes, stripBasename || false);
        },
        afterAllSetup: function afterAllSetup(client) {
            var _WINDOW_location;
            integration.afterAllSetup(client);
            var initPathName = (_WINDOW_location = (0, _browser.WINDOW).location) === null || _WINDOW_location === void 0 ? void 0 : _WINDOW_location.pathname;
            var _obj;
            if (instrumentPageLoad && initPathName) (0, _browser.startBrowserTracingPageLoadSpan)(client, {
                name: initPathName,
                attributes: (_obj = {}, (0, _defineProperty._)(_obj, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), 'url'), (0, _defineProperty._)(_obj, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_OP), 'pageload'), (0, _defineProperty._)(_obj, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), "auto.pageload.react.reactrouter_v".concat(version)), _obj)
            });
            if (instrumentNavigation) CLIENTS_WITH_INSTRUMENT_NAVIGATION.add(client);
        }
    });
}
function createV6CompatibleWrapUseRoutes(origUseRoutes, version) {
    if (!_useEffect || !_useLocation || !_useNavigationType || !_matchRoutes) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).warn('reactRouterV6Instrumentation was unable to wrap `useRoutes` because of one or more missing parameters.');
        return origUseRoutes;
    }
    var SentryRoutes = function(props) {
        var isMountRenderPass = _react.useRef(true);
        var routes = props.routes, locationArg = props.locationArg;
        var Routes = origUseRoutes(routes, locationArg);
        var location = _useLocation();
        var navigationType = _useNavigationType();
        // A value with stable identity to either pick `locationArg` if available or `location` if not
        var stableLocationParam = typeof locationArg === 'string' || (locationArg === null || locationArg === void 0 ? void 0 : locationArg.pathname) ? locationArg : location;
        _useEffect(function() {
            var normalizedLocation = typeof stableLocationParam === 'string' ? {
                pathname: stableLocationParam
            } : stableLocationParam;
            if (isMountRenderPass.current) {
                addRoutesToAllRoutes(routes);
                updatePageloadTransaction({
                    activeRootSpan: getActiveRootSpan(),
                    location: normalizedLocation,
                    routes: routes,
                    allRoutes: Array.from(allRoutes)
                });
                isMountRenderPass.current = false;
            } else // Note: Component-based routes don't support lazy route tracking via lazyRouteTimeout
            // because React.lazy() loads happen at the component level, not the router level.
            // Use createBrowserRouter with patchRoutesOnNavigation for lazy route tracking.
            handleNavigation({
                location: normalizedLocation,
                routes: routes,
                navigationType: navigationType,
                version: version,
                allRoutes: Array.from(allRoutes)
            });
        }, [
            navigationType,
            stableLocationParam
        ]);
        return Routes;
    };
    // eslint-disable-next-line react/display-name
    return function(routes, locationArg) {
        return _react.createElement(SentryRoutes, {
            routes: routes,
            locationArg: locationArg
        });
    };
}
function wrapPatchRoutesOnNavigation(opts) {
    var isMemoryRouter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (!opts || !('patchRoutesOnNavigation' in opts) || typeof opts.patchRoutesOnNavigation !== 'function') return opts || {};
    var originalPatchRoutes = opts.patchRoutesOnNavigation;
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, opts), {
        patchRoutesOnNavigation: function(args) {
            return (0, _asyncToGenerator._)(function() {
                var targetPath, activeRootSpan, originalPatch, lazyLoadPromise;
                return (0, _tsGenerator._)(this, function(_state) {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
                    targetPath = args === null || args === void 0 ? void 0 : args.path;
                    activeRootSpan = getActiveRootSpan();
                    if (!isMemoryRouter) {
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
                        originalPatch = args === null || args === void 0 ? void 0 : args.patch;
                        if (originalPatch) // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
                        args.patch = function(routeId, children) {
                            addRoutesToAllRoutes(children);
                            var currentActiveRootSpan = getActiveRootSpan();
                            if (currentActiveRootSpan && (0, _core.spanToJSON)(currentActiveRootSpan).op === 'navigation') updateNavigationSpan(currentActiveRootSpan, {
                                pathname: targetPath,
                                search: '',
                                hash: '',
                                state: null,
                                key: 'default'
                            }, Array.from(allRoutes), true, _matchRoutes);
                            return originalPatch(routeId, children);
                        };
                    }
                    lazyLoadPromise = function() {
                        return (0, _asyncToGenerator._)(function() {
                            var result, currentActiveRootSpan, _WINDOW_location, pathname;
                            return (0, _tsGenerator._)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            originalPatchRoutes(args)
                                        ];
                                    case 1:
                                        result = _state.sent();
                                        currentActiveRootSpan = getActiveRootSpan();
                                        if (currentActiveRootSpan && (0, _core.spanToJSON)(currentActiveRootSpan).op === 'navigation') {
                                            ;
                                            pathname = isMemoryRouter ? targetPath : targetPath || ((_WINDOW_location = (0, _browser.WINDOW).location) === null || _WINDOW_location === void 0 ? void 0 : _WINDOW_location.pathname);
                                            if (pathname) updateNavigationSpan(currentActiveRootSpan, {
                                                pathname: pathname,
                                                search: '',
                                                hash: '',
                                                state: null,
                                                key: 'default'
                                            }, Array.from(allRoutes), false, _matchRoutes);
                                        }
                                        return [
                                            2,
                                            result
                                        ];
                                }
                            });
                        })();
                    }();
                    if (activeRootSpan) trackLazyRouteLoad(activeRootSpan, lazyLoadPromise);
                    return [
                        2,
                        lazyLoadPromise
                    ];
                });
            })();
        }
    });
}
// eslint-disable-next-line complexity
function handleNavigation(opts) {
    var location = opts.location, routes = opts.routes, navigationType = opts.navigationType, version = opts.version, matches = opts.matches, basename = opts.basename, allRoutes = opts.allRoutes;
    var branches = Array.isArray(matches) ? matches : _matchRoutes(allRoutes || routes, location, basename);
    var client = (0, _core.getClient)();
    if (!client || !CLIENTS_WITH_INSTRUMENT_NAVIGATION.has(client)) return;
    var activeRootSpan = getActiveRootSpan();
    if (activeRootSpan && (0, _core.spanToJSON)(activeRootSpan).op === 'pageload' && navigationType === 'POP') return;
    if ((navigationType === 'PUSH' || navigationType === 'POP') && branches) {
        var _resolveRouteNameAndSource = (0, _slicedToArray._)((0, _utilsJs.resolveRouteNameAndSource)(location, allRoutes || routes, allRoutes || routes, branches, basename), 2), name = _resolveRouteNameAndSource[0], source = _resolveRouteNameAndSource[1];
        var locationKey = computeLocationKey(location);
        var trackedNav = activeNavigationSpans.get(client);
        // Determine if this navigation should be skipped as a duplicate
        var trackedSpanHasEnded = trackedNav && !trackedNav.isPlaceholder ? !!(0, _core.spanToJSON)(trackedNav.span).timestamp : false;
        var _shouldSkipNavigation = shouldSkipNavigation(trackedNav, locationKey, name, trackedSpanHasEnded), skip = _shouldSkipNavigation.skip, shouldUpdate = _shouldSkipNavigation.shouldUpdate;
        if (skip) {
            if (shouldUpdate && trackedNav) {
                var oldName = trackedNav.routeName;
                if (trackedNav.isPlaceholder) {
                    // Update placeholder's route name - the real span will be created with this name
                    trackedNav.routeName = name;
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).log('[Tracing] Updated placeholder navigation name from "'.concat(oldName, '" to "').concat(name, '" (will apply to real span)'));
                } else {
                    // Update existing real span from wildcard to parameterized route name
                    trackedNav.span.updateName(name);
                    trackedNav.span.setAttribute((0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), source);
                    (0, _core.addNonEnumerableProperty)(trackedNav.span, '__sentry_navigation_name_set__', true);
                    trackedNav.routeName = name;
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).log('[Tracing] Updated navigation span name from "'.concat(oldName, '" to "').concat(name, '"'));
                }
            } else (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).log("[Tracing] Skipping duplicate navigation for location: ".concat(locationKey));
            return;
        }
        // Create new navigation span (first navigation or legitimate new navigation)
        // Reserve the spot in the map first to prevent race conditions
        // Mark as placeholder to prevent concurrent handleNavigation calls from creating duplicates
        var placeholderSpan = {
            end: function() {}
        };
        var placeholderEntry = {
            span: placeholderSpan,
            routeName: name,
            pathname: location.pathname,
            locationKey: locationKey,
            isPlaceholder: true
        };
        activeNavigationSpans.set(client, placeholderEntry);
        var navigationSpan;
        try {
            var _obj;
            navigationSpan = (0, _browser.startBrowserTracingNavigationSpan)(client, {
                name: placeholderEntry.routeName,
                attributes: (_obj = {}, (0, _defineProperty._)(_obj, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), source), (0, _defineProperty._)(_obj, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_OP), 'navigation'), (0, _defineProperty._)(_obj, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), "auto.navigation.react.reactrouter_v".concat(version)), _obj)
            });
        } catch (e) {
            // If span creation fails, remove the placeholder so we don't block future navigations
            activeNavigationSpans.delete(client);
            throw e;
        }
        if (navigationSpan) {
            // Update the map with the real span (isPlaceholder omitted, defaults to false)
            activeNavigationSpans.set(client, {
                span: navigationSpan,
                routeName: placeholderEntry.routeName,
                pathname: location.pathname,
                locationKey: locationKey
            });
            patchSpanEnd(navigationSpan, location, routes, basename, allRoutes, 'navigation');
        } else // If no span was created, remove the placeholder
        activeNavigationSpans.delete(client);
    }
}
/* Only exported for testing purposes */ function addRoutesToAllRoutes(routes) {
    routes.forEach(function(route) {
        var extractedChildRoutes = getChildRoutesRecursively(route);
        extractedChildRoutes.forEach(function(r) {
            allRoutes.add(r);
        });
    });
}
function getChildRoutesRecursively(route) {
    var allRoutes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new Set();
    if (!allRoutes.has(route)) {
        allRoutes.add(route);
        if (route.children && !route.index) route.children.forEach(function(child) {
            var childRoutes = getChildRoutesRecursively(child, allRoutes);
            childRoutes.forEach(function(r) {
                allRoutes.add(r);
            });
        });
    }
    return allRoutes;
}
function updatePageloadTransaction(param) {
    var activeRootSpan = param.activeRootSpan, location = param.location, routes = param.routes, matches = param.matches, basename = param.basename, allRoutes = param.allRoutes;
    var branches = Array.isArray(matches) ? matches : _matchRoutes(allRoutes || routes, location, basename);
    if (branches) {
        var _resolveRouteNameAndSource = (0, _slicedToArray._)((0, _utilsJs.resolveRouteNameAndSource)(location, allRoutes || routes, allRoutes || routes, branches, basename), 2), name = _resolveRouteNameAndSource[0], source = _resolveRouteNameAndSource[1];
        (0, _core.getCurrentScope)().setTransactionName(name || '/');
        if (activeRootSpan) {
            activeRootSpan.updateName(name);
            activeRootSpan.setAttribute((0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), source);
            // Patch span.end() to ensure we update the name one last time before the span is sent
            patchSpanEnd(activeRootSpan, location, routes, basename, allRoutes, 'pageload');
        }
    }
}
/**
 * Determines if a span name should be updated during wildcard route resolution.
 *
 * Update conditions (in priority order):
 * 1. No current name + allowNoCurrentName: true → always update (pageload spans)
 * 2. Current name has wildcard + new is route without wildcard → upgrade (e.g., "/users/*" → "/users/:id")
 * 3. Current source is not 'route' + new source is 'route' → upgrade (e.g., URL → parameterized route)
 *
 * @param currentName - The current span name (may be undefined)
 * @param currentSource - The current span source ('route', 'url', or undefined)
 * @param newName - The proposed new span name
 * @param newSource - The proposed new span source
 * @param allowNoCurrentName - If true, allow updates when there's no current name (for pageload spans)
 * @returns true if the span name should be updated
 */ function shouldUpdateWildcardSpanName(currentName, currentSource, newName, newSource) {
    var allowNoCurrentName = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    if (!newName) return false;
    if (!currentName && allowNoCurrentName) return true;
    var hasWildcard = currentName && (0, _utilsJs.transactionNameHasWildcard)(currentName);
    if (hasWildcard && newSource === 'route' && !(0, _utilsJs.transactionNameHasWildcard)(newName)) return true;
    if (currentSource !== 'route' && newSource === 'route') return true;
    return false;
}
function tryUpdateSpanNameBeforeEnd(span, spanJson, currentName, location, routes, basename, spanType, allRoutes) {
    try {
        var _spanJson_data;
        var currentSource = (_spanJson_data = spanJson.data) === null || _spanJson_data === void 0 ? void 0 : _spanJson_data[0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
        if (currentSource === 'route' && currentName && !(0, _utilsJs.transactionNameHasWildcard)(currentName)) return;
        var currentAllRoutes = Array.from(allRoutes);
        var routesToUse = currentAllRoutes.length > 0 ? currentAllRoutes : routes;
        var branches = _matchRoutes(routesToUse, location, basename);
        if (!branches) return;
        var _resolveRouteNameAndSource = (0, _slicedToArray._)((0, _utilsJs.resolveRouteNameAndSource)(location, routesToUse, routesToUse, branches, basename), 2), name = _resolveRouteNameAndSource[0], source = _resolveRouteNameAndSource[1];
        var isImprovement = shouldUpdateWildcardSpanName(currentName, currentSource, name, source, true);
        var spanNotEnded = spanType === 'pageload' || !spanJson.timestamp;
        if (isImprovement && spanNotEnded) {
            span.updateName(name);
            span.setAttribute((0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), source);
        }
    } catch (error) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).warn("Error updating span details before ending: ".concat(error));
    }
}
/**
 * Patches the span.end() method to update the transaction name one last time before the span is sent.
 * This handles cases where the span is cancelled early (e.g., document.hidden) before lazy routes have finished loading.
 */ function patchSpanEnd(span, location, routes, basename, _allRoutes, spanType) {
    var patchedPropertyName = "__sentry_".concat(spanType, "_end_patched__");
    var hasEndBeenPatched = span === null || span === void 0 ? void 0 : span[patchedPropertyName];
    if (hasEndBeenPatched || !span.end) return;
    // Use the passed route context, or fall back to global Set
    var allRoutesSet = _allRoutes ? new Set(_allRoutes) : allRoutes;
    var originalEnd = span.end.bind(span);
    var endCalled = false;
    span.end = function patchedEnd() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _spanJson_data;
        if (endCalled) return;
        endCalled = true;
        // Capture timestamp immediately to avoid delay from async operations
        // If no timestamp was provided, capture the current time now
        var endTimestamp = args.length > 0 ? args[0] : Date.now() / 1000;
        var spanJson = (0, _core.spanToJSON)(span);
        var currentName = spanJson.description;
        var currentSource = (_spanJson_data = spanJson.data) === null || _spanJson_data === void 0 ? void 0 : _spanJson_data[0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
        // Helper to clean up activeNavigationSpans after span ends
        var cleanupNavigationSpan = function() {
            var client = (0, _core.getClient)();
            if (client && spanType === 'navigation') {
                var trackedNav = activeNavigationSpans.get(client);
                if (trackedNav && trackedNav.span === span) activeNavigationSpans.delete(client);
            }
        };
        var pendingPromises = pendingLazyRouteLoads.get(span);
        // Wait for lazy routes if:
        // 1. There are pending promises AND
        // 2. Current name exists AND
        // 3. Either the name has a wildcard OR the source is not 'route' (URL-based names)
        var shouldWaitForLazyRoutes = pendingPromises && pendingPromises.size > 0 && currentName && ((0, _utilsJs.transactionNameHasWildcard)(currentName) || currentSource !== 'route');
        if (shouldWaitForLazyRoutes) {
            if (_lazyRouteTimeout === 0) {
                tryUpdateSpanNameBeforeEnd(span, spanJson, currentName, location, routes, basename, spanType, allRoutesSet);
                cleanupNavigationSpan();
                originalEnd(endTimestamp);
                return;
            }
            var allSettled = Promise.allSettled(pendingPromises).then(function() {});
            var waitPromise = _lazyRouteTimeout === Infinity ? allSettled : Promise.race([
                allSettled,
                new Promise(function(r) {
                    return setTimeout(r, _lazyRouteTimeout);
                })
            ]);
            waitPromise.then(function() {
                var updatedSpanJson = (0, _core.spanToJSON)(span);
                tryUpdateSpanNameBeforeEnd(span, updatedSpanJson, updatedSpanJson.description, location, routes, basename, spanType, allRoutesSet);
                cleanupNavigationSpan();
                originalEnd(endTimestamp);
            }).catch(function() {
                cleanupNavigationSpan();
                originalEnd(endTimestamp);
            });
            return;
        }
        tryUpdateSpanNameBeforeEnd(span, spanJson, currentName, location, routes, basename, spanType, allRoutesSet);
        cleanupNavigationSpan();
        originalEnd(endTimestamp);
    };
    (0, _core.addNonEnumerableProperty)(span, patchedPropertyName, true);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function createV6CompatibleWithSentryReactRouterRouting(Routes, version) {
    if (!_useEffect || !_useLocation || !_useNavigationType || !_createRoutesFromChildren || !_matchRoutes) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).warn("reactRouterV6Instrumentation was unable to wrap Routes because of one or more missing parameters.\n      useEffect: ".concat(_useEffect, ". useLocation: ").concat(_useLocation, ". useNavigationType: ").concat(_useNavigationType, ".\n      createRoutesFromChildren: ").concat(_createRoutesFromChildren, ". matchRoutes: ").concat(_matchRoutes, "."));
        return Routes;
    }
    var SentryRoutes = function(props) {
        var isMountRenderPass = _react.useRef(true);
        var location = _useLocation();
        var navigationType = _useNavigationType();
        _useEffect(function() {
            var routes = _createRoutesFromChildren(props.children);
            if (isMountRenderPass.current) {
                addRoutesToAllRoutes(routes);
                updatePageloadTransaction({
                    activeRootSpan: getActiveRootSpan(),
                    location: location,
                    routes: routes,
                    allRoutes: Array.from(allRoutes)
                });
                isMountRenderPass.current = false;
            } else // Note: Component-based routes don't support lazy route tracking via lazyRouteTimeout
            // because React.lazy() loads happen at the component level, not the router level.
            // Use createBrowserRouter with patchRoutesOnNavigation for lazy route tracking.
            handleNavigation({
                location: location,
                routes: routes,
                navigationType: navigationType,
                version: version,
                allRoutes: Array.from(allRoutes)
            });
        }, // Re-run only on location/navigation changes, not children changes
        [
            location,
            navigationType
        ]);
        // @ts-expect-error Setting more specific React Component typing for `R` generic above
        // will break advanced type inference done by react router params
        return _react.createElement(Routes, (0, _objectSpread._)({}, props));
    };
    (0, _hoistNonReactStaticsJs.hoistNonReactStatics)(SentryRoutes, Routes);
    // @ts-expect-error Setting more specific React Component typing for `R` generic above
    // will break advanced type inference done by react router params
    return SentryRoutes;
}
function getActiveRootSpan() {
    var span = (0, _core.getActiveSpan)();
    var rootSpan = span ? (0, _core.getRootSpan)(span) : undefined;
    if (!rootSpan) return undefined;
    var op = (0, _core.spanToJSON)(rootSpan).op;
    // Only use this root span if it is a pageload or navigation span
    return op === 'navigation' || op === 'pageload' ? rootSpan : undefined;
}

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_to_consumable_array":"1eSZf","@swc/helpers/_/_ts_generator":"78Tqx","@sentry/browser":"fdZ8u","@sentry/core":"lqtxA","react":"ltHCL","../debug-build.js":"3E3ob","../hoist-non-react-statics.js":"2S4dg","./lazy-routes.js":"gZyyN","./utils.js":"lgebU","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gZyyN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "checkRouteForAsyncHandler", function() {
    return checkRouteForAsyncHandler;
});
parcelHelpers.export(exports, "createAsyncHandlerProxy", function() {
    return createAsyncHandlerProxy;
});
parcelHelpers.export(exports, "handleAsyncHandlerResult", function() {
    return handleAsyncHandlerResult;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _core = require("@sentry/core");
var _debugBuildJs = require("../debug-build.js");
/**
 * Creates a proxy wrapper for an async handler function.
 */ function createAsyncHandlerProxy(originalFunction, route, handlerKey, processResolvedRoutes) {
    var proxy = new Proxy(originalFunction, {
        apply: function apply(target, thisArg, argArray) {
            var result = target.apply(thisArg, argArray);
            handleAsyncHandlerResult(result, route, handlerKey, processResolvedRoutes);
            return result;
        }
    });
    (0, _core.addNonEnumerableProperty)(proxy, '__sentry_proxied__', true);
    return proxy;
}
/**
 * Handles the result of an async handler function call.
 */ function handleAsyncHandlerResult(result, route, handlerKey, processResolvedRoutes) {
    if ((0, _core.isThenable)(result)) result.then(function(resolvedRoutes) {
        if (Array.isArray(resolvedRoutes)) processResolvedRoutes(resolvedRoutes, route);
    }).catch(function(e) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _core.debug).warn("Error resolving async handler '".concat(handlerKey, "' for route"), route, e);
    });
    else if (Array.isArray(result)) processResolvedRoutes(result, route);
}
/**
 * Recursively checks a route for async handlers and sets up Proxies to add discovered child routes to allRoutes when called.
 */ function checkRouteForAsyncHandler(route, processResolvedRoutes) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    // Set up proxies for any functions in the route's handle
    if (route.handle && (0, _typeOf._)(route.handle) === 'object') try {
        for(var _iterator = Object.keys(route.handle)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            var maybeFn = route.handle[key];
            if (typeof maybeFn === 'function' && !maybeFn.__sentry_proxied__) route.handle[key] = createAsyncHandlerProxy(maybeFn, route, key, processResolvedRoutes);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    // Recursively check child routes
    if (Array.isArray(route.children)) try {
        for(var _iterator1 = route.children[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var child = _step1.value;
            checkRouteForAsyncHandler(child, processResolvedRoutes);
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
}

},{"@swc/helpers/_/_type_of":"iFJdx","@sentry/core":"lqtxA","../debug-build.js":"3E3ob","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lgebU":[function(require,module,exports,__globalThis) {
// Global variables that these utilities depend on
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getNormalizedName", function() {
    return getNormalizedName;
});
parcelHelpers.export(exports, "getNumberOfUrlSegments", function() {
    return getNumberOfUrlSegments;
});
parcelHelpers.export(exports, "initializeRouterUtils", function() {
    return initializeRouterUtils;
});
parcelHelpers.export(exports, "locationIsInsideDescendantRoute", function() {
    return locationIsInsideDescendantRoute;
});
parcelHelpers.export(exports, "pathEndsWithWildcard", function() {
    return pathEndsWithWildcard;
});
parcelHelpers.export(exports, "pathIsWildcardAndHasChildren", function() {
    return pathIsWildcardAndHasChildren;
});
parcelHelpers.export(exports, "prefixWithSlash", function() {
    return prefixWithSlash;
});
parcelHelpers.export(exports, "rebuildRoutePathFromAllRoutes", function() {
    return rebuildRoutePathFromAllRoutes;
});
parcelHelpers.export(exports, "resolveRouteNameAndSource", function() {
    return resolveRouteNameAndSource;
});
parcelHelpers.export(exports, "routeIsDescendant", function() {
    return routeIsDescendant;
});
parcelHelpers.export(exports, "transactionNameHasWildcard", function() {
    return transactionNameHasWildcard;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var _matchRoutes;
var _stripBasename = false;
/**
 * Initialize function to set dependencies that the router utilities need.
 * Must be called before using any of the exported utility functions.
 */ function initializeRouterUtils(matchRoutes) {
    var stripBasename = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    _matchRoutes = matchRoutes;
    _stripBasename = stripBasename;
}
// Helper functions
function pickPath(match) {
    return trimWildcard(match.route.path || '');
}
function pickSplat(match) {
    return match.params['*'] || '';
}
function trimWildcard(path) {
    return path[path.length - 1] === '*' ? path.slice(0, -1) : path;
}
function trimSlash(path) {
    return path[path.length - 1] === '/' ? path.slice(0, -1) : path;
}
/**
 * Checks if a path ends with a wildcard character (*).
 */ function pathEndsWithWildcard(path) {
    return path.endsWith('*');
}
/** Checks if transaction name has wildcard (/* or ends with *). */ function transactionNameHasWildcard(name) {
    return name.includes('/*') || name.endsWith('*');
}
/**
 * Checks if a path is a wildcard and has child routes.
 */ function pathIsWildcardAndHasChildren(path, branch) {
    var _branch_route_children;
    return pathEndsWithWildcard(path) && !!((_branch_route_children = branch.route.children) === null || _branch_route_children === void 0 ? void 0 : _branch_route_children.length) || false;
}
/** Check if route is in descendant route (<Routes> within <Routes>) */ function routeIsDescendant(route) {
    var _route_path;
    return !!(!route.children && route.element && ((_route_path = route.path) === null || _route_path === void 0 ? void 0 : _route_path.endsWith('/*')));
}
function sendIndexPath(pathBuilder, pathname, basename) {
    var reconstructedPath = pathBuilder && pathBuilder.length > 0 ? pathBuilder : _stripBasename ? stripBasenameFromPathname(pathname, basename) : pathname;
    var formattedPath = // If the path ends with a wildcard suffix, remove both the slash and the asterisk
    reconstructedPath.slice(-2) === '/*' ? reconstructedPath.slice(0, -2) : reconstructedPath;
    // If the path ends with a slash, remove it (but keep single '/')
    if (formattedPath.length > 1 && formattedPath[formattedPath.length - 1] === '/') formattedPath = formattedPath.slice(0, -1);
    return [
        formattedPath,
        'route'
    ];
}
/**
 * Returns the number of URL segments in the given URL string.
 * Splits at '/' or '\/' to handle regex URLs correctly.
 *
 * @param url - The URL string to segment.
 * @returns The number of segments in the URL.
 */ function getNumberOfUrlSegments(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter(function(s) {
        return s.length > 0 && s !== ',';
    }).length;
}
/**
 * Strip the basename from a pathname if exists.
 *
 * Vendored and modified from `react-router`
 * https://github.com/remix-run/react-router/blob/462bb712156a3f739d6139a0f14810b76b002df6/packages/router/utils.ts#L1038
 */ function stripBasenameFromPathname(pathname, basename) {
    if (!basename || basename === '/') return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return pathname;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    var startIndex = basename.endsWith('/') ? basename.length - 1 : basename.length;
    var nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== '/') // pathname does not start with basename/
    return pathname;
    return pathname.slice(startIndex) || '/';
}
// Exported utility functions
/**
 * Ensures a path string starts with a forward slash.
 */ function prefixWithSlash(path) {
    return path[0] === '/' ? path : "/".concat(path);
}
/**
 * Rebuilds the route path from all available routes by matching against the current location.
 */ function rebuildRoutePathFromAllRoutes(allRoutes, location) {
    var matchedRoutes = _matchRoutes(allRoutes, location);
    if (!matchedRoutes || matchedRoutes.length === 0) return '';
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var match = _step.value;
            if (match.route.path && match.route.path !== '*') {
                var path = pickPath(match);
                var strippedPath = stripBasenameFromPathname(location.pathname, prefixWithSlash(match.pathnameBase));
                if (location.pathname === strippedPath) return {
                    v: trimSlash(strippedPath)
                };
                return {
                    v: trimSlash(trimSlash(path || '') + prefixWithSlash(rebuildRoutePathFromAllRoutes(allRoutes.filter(function(route) {
                        return route !== match.route;
                    }), {
                        pathname: strippedPath
                    })))
                };
            }
        };
        for(var _iterator = matchedRoutes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _ret = _loop();
            if ((0, _typeOf._)(_ret) === "object") return _ret.v;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return '';
}
/**
 * Checks if the current location is inside a descendant route (route with splat parameter).
 */ function locationIsInsideDescendantRoute(location, routes) {
    var matchedRoutes = _matchRoutes(routes, location);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (matchedRoutes) try {
        for(var _iterator = matchedRoutes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var match = _step.value;
            if (routeIsDescendant(match.route) && pickSplat(match)) return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
/**
 * Returns a fallback transaction name from location pathname.
 */ function getFallbackTransactionName(location, basename) {
    return _stripBasename ? stripBasenameFromPathname(location.pathname, basename) : location.pathname || '';
}
/**
 * Gets a normalized route name and transaction source from the current routes and location.
 */ function getNormalizedName(routes, location, branches) {
    var basename = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : '';
    if (!routes || routes.length === 0) return [
        _stripBasename ? stripBasenameFromPathname(location.pathname, basename) : location.pathname,
        'url'
    ];
    if (!branches) return [
        getFallbackTransactionName(location, basename),
        'url'
    ];
    var pathBuilder = '';
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = branches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var branch = _step.value;
            var route = branch.route;
            if (!route) continue;
            // Early return for index routes
            if (route.index) return sendIndexPath(pathBuilder, branch.pathname, basename);
            var path = route.path;
            if (!path || pathIsWildcardAndHasChildren(path, branch)) continue;
            // Build the route path
            var newPath = path[0] === '/' || pathBuilder[pathBuilder.length - 1] === '/' ? path : "/".concat(path);
            pathBuilder = trimSlash(pathBuilder) + prefixWithSlash(newPath);
            // Check if this path matches the current location
            if (trimSlash(location.pathname) !== trimSlash(basename + branch.pathname)) continue;
            // Check if this is a parameterized route like /stores/:storeId/products/:productId
            if (getNumberOfUrlSegments(pathBuilder) !== getNumberOfUrlSegments(branch.pathname) && !pathEndsWithWildcard(pathBuilder)) return [
                (_stripBasename ? '' : basename) + newPath,
                'route'
            ];
            // Handle wildcard routes with children - strip trailing wildcard
            if (pathIsWildcardAndHasChildren(pathBuilder, branch)) pathBuilder = pathBuilder.slice(0, -1);
            return [
                (_stripBasename ? '' : basename) + pathBuilder,
                'route'
            ];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Fallback when no matching route found
    return [
        getFallbackTransactionName(location, basename),
        'url'
    ];
}
/**
 * Shared helper function to resolve route name and source
 */ function resolveRouteNameAndSource(location, routes, allRoutes, branches) {
    var basename = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : '';
    var name;
    var source = 'url';
    var isInDescendantRoute = locationIsInsideDescendantRoute(location, allRoutes);
    if (isInDescendantRoute) {
        name = prefixWithSlash(rebuildRoutePathFromAllRoutes(allRoutes, location));
        source = 'route';
    }
    var ref;
    if (!isInDescendantRoute || !name) ref = (0, _slicedToArray._)(getNormalizedName(routes, location, branches, basename), 2), name = ref[0], source = ref[1], ref;
    return [
        name || location.pathname,
        source
    ];
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_type_of":"iFJdx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"i9jdX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reactRouterV7BrowserTracingIntegration", function() {
    return reactRouterV7BrowserTracingIntegration;
});
parcelHelpers.export(exports, "withSentryReactRouterV7Routing", function() {
    return withSentryReactRouterV7Routing;
});
parcelHelpers.export(exports, "wrapCreateBrowserRouterV7", function() {
    return wrapCreateBrowserRouterV7;
});
parcelHelpers.export(exports, "wrapCreateMemoryRouterV7", function() {
    return wrapCreateMemoryRouterV7;
});
parcelHelpers.export(exports, "wrapUseRoutesV7", function() {
    return wrapUseRoutesV7;
});
var _instrumentationJs = require("./reactrouter-compat-utils/instrumentation.js");
var _core = require("@sentry/core");
/**
 * A browser tracing integration that uses React Router v7 to instrument navigations.
 * Expects `useEffect`, `useLocation`, `useNavigationType`, `createRoutesFromChildren` and `matchRoutes` to be passed as options.
 */ function reactRouterV7BrowserTracingIntegration(options) {
    return (0, _instrumentationJs.createReactRouterV6CompatibleTracingIntegration)(options, '7');
}
/**
 * A higher-order component that adds Sentry routing instrumentation to a React Router v7 Route component.
 * This is used to automatically capture route changes as transactions.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function withSentryReactRouterV7Routing(routes) {
    return (0, _instrumentationJs.createV6CompatibleWithSentryReactRouterRouting)(routes, '7');
}
/**
 * A wrapper function that adds Sentry routing instrumentation to a React Router v7 createBrowserRouter function.
 * This is used to automatically capture route changes as transactions when using the createBrowserRouter API.
 */ function wrapCreateBrowserRouterV7(createRouterFunction) {
    return (0, _instrumentationJs.createV6CompatibleWrapCreateBrowserRouter)(createRouterFunction, '7');
}
/**
 * A wrapper function that adds Sentry routing instrumentation to a React Router v7 createMemoryRouter function.
 * This is used to automatically capture route changes as transactions when using the createMemoryRouter API.
 * The difference between createBrowserRouter and createMemoryRouter is that with createMemoryRouter,
 * optional `initialEntries` are also taken into account.
 */ function wrapCreateMemoryRouterV7(createMemoryRouterFunction) {
    return (0, _instrumentationJs.createV6CompatibleWrapCreateMemoryRouter)(createMemoryRouterFunction, '7');
}
/**
 * A wrapper function that adds Sentry routing instrumentation to a React Router v7 useRoutes hook.
 * This is used to automatically capture route changes as transactions when using the useRoutes hook.
 */ function wrapUseRoutesV7(origUseRoutes) {
    return (0, _instrumentationJs.createV6CompatibleWrapUseRoutes)(origUseRoutes, '7');
}

},{"./reactrouter-compat-utils/instrumentation.js":"g30h5","@sentry/core":"lqtxA","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eB5lC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SentryErrorBoundary", function() {
    return SentryErrorBoundary;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _twgCommon = require("@atlassian/twg-common");
var _utils = require("./utils");
var SentryErrorBoundary = function(param) {
    var children = param.children, fallback = param.fallback, loggerName = param.loggerName, accountId = param.accountId, onError = param.onError, teamName = param.teamName, touchpointId = param.touchpointId;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _twgCommon.ErrorBoundary), {
        fallback: fallback,
        onError: function(error, errorInfo) {
            var extras = {
                loggerName: loggerName,
                accountId: accountId,
                teamName: teamName,
                touchpointId: touchpointId
            };
            (0, _utils.logException)(error, extras);
            onError === null || onError === void 0 ? void 0 : onError(error, errorInfo);
        }
    }, children);
};

},{"react":"ltHCL","@atlassian/twg-common":"7BO56","./utils":"dKdnr","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7BO56":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ErrorBoundary", function() {
    return 0, _errorBoundary.ErrorBoundary;
});
parcelHelpers.export(exports, "ExampleContainer", function() {
    return 0, _exampleContainer.ExampleContainer;
});
parcelHelpers.export(exports, "Switcher", function() {
    return 0, _switcher.Switcher;
});
parcelHelpers.export(exports, "VRTestWrapper", function() {
    return 0, _vrtestWrapper.VRTestWrapper;
});
parcelHelpers.export(exports, "request", function() {
    return 0, _request.request;
});
parcelHelpers.export(exports, "NetworkError", function() {
    return 0, _request.NetworkError;
});
parcelHelpers.export(exports, "requestWithAbort", function() {
    return 0, _request.requestWithAbort;
});
var _errorBoundary = require("./ErrorBoundary");
var _exampleContainer = require("./ExampleContainer");
var _switcher = require("./Switcher");
var _vrtestWrapper = require("./VRTestWrapper");
var _request = require("./utils/request");

},{"./ErrorBoundary":"8Ht2S","./ExampleContainer":false,"./Switcher":"bvSwF","./VRTestWrapper":false,"./utils/request":"b3kmP","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8Ht2S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ErrorBoundary", function() {
    return ErrorBoundary;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var ErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, _inherits._)(ErrorBoundary, _React_Component);
    function ErrorBoundary(props) {
        (0, _classCallCheck._)(this, ErrorBoundary);
        var _this;
        _this = (0, _callSuper._)(this, ErrorBoundary, [
            props
        ]);
        _this.state = {
            hasError: false
        };
        return _this;
    }
    (0, _createClass._)(ErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                var _this_props_onError, _this_props;
                (_this_props = this.props) === null || _this_props === void 0 ? void 0 : (_this_props_onError = _this_props.onError) === null || _this_props_onError === void 0 ? void 0 : _this_props_onError.call(_this_props, error, errorInfo);
                // eslint-disable-next-line no-console
                console.error('TWG Common ErrorBoundary', error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                if (this.state.hasError) return this.props.fallback;
                return this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    hasError: true,
                    error: error
                };
            }
        }
    ]);
    return ErrorBoundary;
}((0, _reactDefault.default).Component);

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_inherits":"2sfqW","react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bvSwF":[function(require,module,exports,__globalThis) {
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Switcher", function() {
    return Switcher;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _new = require("@atlaskit/button/new");
var _newDefault = parcelHelpers.interopDefault(_new);
var _compiled = require("@atlaskit/primitives/compiled");
var styles = {
    switcherOptionsContainer: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _2rko12b0 _19itia51 _18zr1b66 _bfhkhp5a _4t3izwfg",
    switcherOption: "_16jlkb7n"
};
var tabButtonProps = {
    appearance: 'subtle',
    spacing: 'compact',
    shouldFitContainer: true
};
var Switcher = function(param) {
    var selectedTab = param.selectedTab, tabs = param.tabs, setTab = param.setTab, testId = param.testId;
    var switchToTab = function(event, tabKey) {
        event.preventDefault();
        setTab(tabKey);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _compiled.Inline), {
        alignBlock: "center",
        xcss: styles.switcherOptionsContainer,
        testId: testId,
        children: tabs.map(function(tab, index) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _compiled.Box), {
                xcss: styles.switcherOption,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _newDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, tabButtonProps), {
                    iconBefore: tab.icon,
                    isSelected: selectedTab === tab.key,
                    onClick: function(e) {
                        return switchToTab(e, tab.key);
                    },
                    testId: "".concat(testId, "-").concat(index, "-button"),
                    children: tab.label
                }))
            }, tab.key);
        })
    });
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","@atlaskit/button/new":"2LnSZ","@atlaskit/primitives/compiled":"jhQE8","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"b3kmP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NetworkError", function() {
    return NetworkError;
});
parcelHelpers.export(exports, "request", function() {
    return request;
});
parcelHelpers.export(exports, "requestWithAbort", function() {
    return requestWithAbort;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _wrapNativeSuper = require("@swc/helpers/_/_wrap_native_super");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var ALLOWED_RESPONSE_STATUS_CODES = [
    200
];
var NetworkError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, _inherits._)(NetworkError, Error1);
    function NetworkError(statusCode, error) {
        (0, _classCallCheck._)(this, NetworkError);
        var _this;
        _this = (0, _callSuper._)(this, NetworkError, [
            error
        ]);
        _this.statusCode = statusCode;
        return _this;
    }
    (0, _createClass._)(NetworkError, [
        {
            key: "getStatusCode",
            value: function getStatusCode() {
                return this.statusCode;
            }
        }
    ]);
    return NetworkError;
}((0, _wrapNativeSuper._)(Error));
function request(_0, _1, _2, _3, _4) {
    return (0, _asyncToGenerator._)(function(method, url, data, headers) {
        var statuses, controller, noCredentials, requestConfig, response, _tmp, _tmp1, error, _controller_signal_reason;
        var _arguments = arguments;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    statuses = _arguments.length > 4 && _arguments[4] !== void 0 ? _arguments[4] : ALLOWED_RESPONSE_STATUS_CODES, controller = _arguments.length > 5 ? _arguments[5] : void 0, noCredentials = _arguments.length > 6 && _arguments[6] !== void 0 ? _arguments[6] : false;
                    requestConfig = (0, _objectSpread._)({
                        method: method,
                        credentials: noCredentials ? 'omit' : 'include',
                        headers: (0, _objectSpread._)({
                            Accept: 'application/json',
                            'Cache-Control': 'no-cache',
                            'Content-Type': 'application/json'
                        }, headers)
                    }, data ? {
                        body: JSON.stringify(data)
                    } : undefined, controller ? {
                        signal: controller.signal
                    } : undefined);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        ,
                        7
                    ]);
                    return [
                        4,
                        fetch(url, requestConfig)
                    ];
                case 2:
                    response = _state.sent();
                    if (!(response.ok || (statuses === null || statuses === void 0 ? void 0 : statuses.includes(response.status)))) return [
                        3,
                        4
                    ];
                    _tmp = {
                        statusCode: response.status,
                        success: true
                    };
                    return [
                        4,
                        response.json()
                    ];
                case 3:
                    return [
                        2,
                        (_tmp.data = _state.sent(), _tmp.traceId = getTraceId(response), _tmp)
                    ];
                case 4:
                    _tmp1 = {
                        statusCode: response.status,
                        success: false
                    };
                    return [
                        4,
                        response.json()
                    ];
                case 5:
                    return [
                        2,
                        (_tmp1.error = _state.sent(), _tmp1.traceId = getTraceId(response), _tmp1)
                    ];
                case 6:
                    error = _state.sent();
                    if (controller === null || controller === void 0 ? void 0 : controller.signal.aborted) return [
                        2,
                        {
                            statusCode: null,
                            success: false,
                            error: (_controller_signal_reason = controller === null || controller === void 0 ? void 0 : controller.signal.reason) !== null && _controller_signal_reason !== void 0 ? _controller_signal_reason : 'Request aborted',
                            traceId: null
                        }
                    ];
                    if ((0, _instanceof._)(error, NetworkError)) return [
                        2,
                        {
                            statusCode: error.getStatusCode(),
                            success: false,
                            error: error.message,
                            traceId: null
                        }
                    ];
                    return [
                        2,
                        {
                            statusCode: 500,
                            success: false,
                            error: (0, _instanceof._)(error, Error) ? error.message : JSON.stringify(error),
                            traceId: null
                        }
                    ];
                case 7:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
var requestWithAbort = function(method, url, data, headers) {
    var statuses = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : ALLOWED_RESPONSE_STATUS_CODES, noCredentials = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
    var controller = new AbortController();
    var response = request(method, url, data, headers, statuses, controller, noCredentials);
    return {
        controller: controller,
        execute: response
    };
};
var getTraceId = function(response) {
    return response.headers.get('atl-traceid') || response.headers.get('X-Trace-Id') || response.headers.get('atl-request-id') || null;
};

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_inherits":"2sfqW","@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_wrap_native_super":"d0Iin","@swc/helpers/_/_ts_generator":"78Tqx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"b9HLV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasAutomaticAuthFailed", function() {
    return hasAutomaticAuthFailed;
});
parcelHelpers.export(exports, "attemptClientLogin", function() {
    return attemptClientLogin;
});
/**
 * Returns `true` exactly once, the first time it is called after the
 * sentinel was set by {@link attemptClientLogin}. Subsequent calls (and
 * page loads where no login was initiated) return `false`. Safe in SSR /
 * non-browser contexts (returns `false` if `sessionStorage` is unavailable).
 */ parcelHelpers.export(exports, "consumeLoginPendingMarker", function() {
    return consumeLoginPendingMarker;
});
parcelHelpers.export(exports, "cleanupClientAuthFlow", function() {
    return cleanupClientAuthFlow;
});
var _env = require("@atlassian/pillar/runtime/env");
var CLIENT_AUTH_REDIRECT_COUNT_STORAGE_KEY = 'twg-microsite.auth.redirect-count';
/**
 * Sentinel set immediately before redirecting the user to the identity
 * provider in {@link attemptClientLogin}. Survives the same-tab redirect
 * via sessionStorage and is consumed by {@link consumeLoginPendingMarker}
 * the first time `fetchUserProfile` resolves successfully after the
 * redirect, so we can distinguish a real login from a session resume
 * (e.g. a page reload with a still-valid auth cookie).
 */ var LOGIN_PENDING_STORAGE_KEY = 'twg-microsite.auth.login-pending';
/**
 * Maximum number of times the user will be redirected to the auth page before instead
 * showing a login failed error.
 */ var MAX_REDIRECT_COUNT = 1;
function getRedirectCount() {
    var count = globalThis.window.sessionStorage.getItem(CLIENT_AUTH_REDIRECT_COUNT_STORAGE_KEY);
    return count ? parseInt(count, 10) : 0;
}
function hasAutomaticAuthFailed() {
    return getRedirectCount() > MAX_REDIRECT_COUNT;
}
function attemptClientLogin() {
    var newRedirectCount = getRedirectCount() + 1;
    globalThis.window.sessionStorage.setItem(CLIENT_AUTH_REDIRECT_COUNT_STORAGE_KEY, newRedirectCount.toString());
    // Mark that we have just initiated a login redirect. The success path
    // of `fetchUserProfile` reads + removes this to fire `track.user.loggedIn`
    // at most once per actual login (not on every reload with a valid
    // session cookie).
    globalThis.window.sessionStorage.setItem(LOGIN_PENDING_STORAGE_KEY, '1');
    globalThis.window.location.replace((0, _env.getIdentityLoginUrl)());
}
function consumeLoginPendingMarker() {
    try {
        var pending = globalThis.window.sessionStorage.getItem(LOGIN_PENDING_STORAGE_KEY) === '1';
        if (pending) globalThis.window.sessionStorage.removeItem(LOGIN_PENDING_STORAGE_KEY);
        return pending;
    } catch (e) {
        return false;
    }
}
function cleanupClientAuthFlow() {
    globalThis.window.sessionStorage.removeItem(CLIENT_AUTH_REDIRECT_COUNT_STORAGE_KEY);
    globalThis.window.sessionStorage.removeItem(LOGIN_PENDING_STORAGE_KEY);
}

},{"@atlassian/pillar/runtime/env":"aTPIA","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"04ND0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "queryUserProfile", function() {
    return queryUserProfile;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _utilsTwgMicrositeCurrentUserQueryGraphql = require("./__generated__/utils_twg_microsite_CurrentUser_Query.graphql");
var _utilsTwgMicrositeCurrentUserQueryGraphqlDefault = parcelHelpers.interopDefault(_utilsTwgMicrositeCurrentUserQueryGraphql);
var _reactRelay = require("react-relay");
function queryUserProfile(environment) {
    return (0, _asyncToGenerator._)(function() {
        var _data_me_user, _data_me, _data_me_user1, _data_me1, _data_me_user2, _data_me2, _data_me_user3, _data_me3, _data_me_user4, _data_me4, _data_me_user5, _data_me5, _data_me_user6, _data_me6, _data_me_user7, _data_me7, _data_me_user8, _data_me8, data, _data_me_user_id, id, _data_me_user_accountId, accountId, _data_me_user_email, email, _data_me_user_name, name, _data_me_user_nickname, nickname, _data_me_user_picture, picture, _data_me_user_orgId, orgId, _data_me_user_createdAt, createdAt, normalizedEmail, isAtlassianEmployee, extendedProfile, _extendedProfile_organization, _extendedProfile_jobTitle, e;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0, _reactRelay.fetchQuery)(environment, (0, _utilsTwgMicrositeCurrentUserQueryGraphqlDefault.default), {}).toPromise()
                    ];
                case 1:
                    data = _state.sent();
                    id = (_data_me_user_id = data === null || data === void 0 ? void 0 : (_data_me = data.me) === null || _data_me === void 0 ? void 0 : (_data_me_user = _data_me.user) === null || _data_me_user === void 0 ? void 0 : _data_me_user.id) !== null && _data_me_user_id !== void 0 ? _data_me_user_id : '';
                    accountId = (_data_me_user_accountId = data === null || data === void 0 ? void 0 : (_data_me1 = data.me) === null || _data_me1 === void 0 ? void 0 : (_data_me_user1 = _data_me1.user) === null || _data_me_user1 === void 0 ? void 0 : _data_me_user1.accountId) !== null && _data_me_user_accountId !== void 0 ? _data_me_user_accountId : '';
                    email = (_data_me_user_email = data === null || data === void 0 ? void 0 : (_data_me2 = data.me) === null || _data_me2 === void 0 ? void 0 : (_data_me_user2 = _data_me2.user) === null || _data_me_user2 === void 0 ? void 0 : _data_me_user2.email) !== null && _data_me_user_email !== void 0 ? _data_me_user_email : '';
                    name = (_data_me_user_name = data === null || data === void 0 ? void 0 : (_data_me3 = data.me) === null || _data_me3 === void 0 ? void 0 : (_data_me_user3 = _data_me3.user) === null || _data_me_user3 === void 0 ? void 0 : _data_me_user3.name) !== null && _data_me_user_name !== void 0 ? _data_me_user_name : '';
                    nickname = (_data_me_user_nickname = data === null || data === void 0 ? void 0 : (_data_me4 = data.me) === null || _data_me4 === void 0 ? void 0 : (_data_me_user4 = _data_me4.user) === null || _data_me_user4 === void 0 ? void 0 : _data_me_user4.nickname) !== null && _data_me_user_nickname !== void 0 ? _data_me_user_nickname : '';
                    picture = (_data_me_user_picture = data === null || data === void 0 ? void 0 : (_data_me5 = data.me) === null || _data_me5 === void 0 ? void 0 : (_data_me_user5 = _data_me5.user) === null || _data_me_user5 === void 0 ? void 0 : _data_me_user5.picture) !== null && _data_me_user_picture !== void 0 ? _data_me_user_picture : '';
                    orgId = (_data_me_user_orgId = data === null || data === void 0 ? void 0 : (_data_me6 = data.me) === null || _data_me6 === void 0 ? void 0 : (_data_me_user6 = _data_me6.user) === null || _data_me_user6 === void 0 ? void 0 : _data_me_user6.orgId) !== null && _data_me_user_orgId !== void 0 ? _data_me_user_orgId : '';
                    createdAt = (_data_me_user_createdAt = data === null || data === void 0 ? void 0 : (_data_me7 = data.me) === null || _data_me7 === void 0 ? void 0 : (_data_me_user7 = _data_me7.user) === null || _data_me_user7 === void 0 ? void 0 : _data_me_user7.createdAt) !== null && _data_me_user_createdAt !== void 0 ? _data_me_user_createdAt : '';
                    if ([
                        id,
                        accountId
                    ].some(function(x) {
                        return x.length === 0;
                    })) return [
                        2,
                        {
                            success: false,
                            error: 'id or accountId is missing'
                        }
                    ];
                    normalizedEmail = email.toLowerCase();
                    isAtlassianEmployee = normalizedEmail.endsWith(ATLASSIAN_EMAIL_DOMAIN);
                    extendedProfile = data === null || data === void 0 ? void 0 : (_data_me8 = data.me) === null || _data_me8 === void 0 ? void 0 : (_data_me_user8 = _data_me8.user) === null || _data_me_user8 === void 0 ? void 0 : _data_me_user8.extendedProfile;
                    return [
                        2,
                        {
                            success: true,
                            identity: {
                                id: id,
                                accountId: accountId,
                                email: email,
                                name: name,
                                nickname: nickname,
                                picture: picture,
                                staffId: getStaffIdFromEmail(email),
                                isAtlassianEmployee: isAtlassianEmployee,
                                organisation: (_extendedProfile_organization = extendedProfile === null || extendedProfile === void 0 ? void 0 : extendedProfile.organization) !== null && _extendedProfile_organization !== void 0 ? _extendedProfile_organization : '',
                                jobTitle: (_extendedProfile_jobTitle = extendedProfile === null || extendedProfile === void 0 ? void 0 : extendedProfile.jobTitle) !== null && _extendedProfile_jobTitle !== void 0 ? _extendedProfile_jobTitle : '',
                                orgId: orgId,
                                createdAt: createdAt
                            }
                        }
                    ];
                case 2:
                    e = _state.sent();
                    return [
                        2,
                        {
                            success: false,
                            error: e
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
}
var ATLASSIAN_EMAIL_DOMAIN = '@atlassian.com';
var getStaffIdFromEmail = function(email) {
    var _email_split_at;
    return (_email_split_at = email.split('@').at(0)) !== null && _email_split_at !== void 0 ? _email_split_at : '';
};

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_ts_generator":"78Tqx","./__generated__/utils_twg_microsite_CurrentUser_Query.graphql":"hlHHZ","react-relay":"9HAyN","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hlHHZ":[function(require,module,exports,__globalThis) {
/**
 * @generated SignedSource<<e190d24f87eeb7a82e0fba3e16ce0ce9>>
 * @relayHash 5396db60d6140da4f42dcdadd893b844
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 67429d396a5d8a6ce0a5818b06123898ed719a41842dbdc6e11d4582876eda3a
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "nickname"
    }, v4 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v5 = {
        "kind": "ScalarField",
        "name": "email"
    }, v6 = {
        "kind": "ScalarField",
        "name": "orgId"
    }, v7 = {
        "kind": "ScalarField",
        "name": "createdAt"
    }, v8 = {
        "concreteType": "AtlassianAccountUserExtendedProfile",
        "kind": "LinkedField",
        "name": "extendedProfile",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "jobTitle"
            },
            {
                "kind": "ScalarField",
                "name": "organization"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "utils_twg_microsite_CurrentUser_Query",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v0 /*: any*/ ,
                                        v1 /*: any*/ ,
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ],
                                    "type": "AtlassianAccountUser"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "utils_twg_microsite_CurrentUser_Query",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                v0 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v1 /*: any*/ ,
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ],
                                    "type": "AtlassianAccountUser"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "67429d396a5d8a6ce0a5818b06123898ed719a41842dbdc6e11d4582876eda3a",
            "metadata": {},
            "name": "utils_twg_microsite_CurrentUser_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
node.hash = "0ccaaff8433b011ee0e24fbed3a153e4";
exports.default = node;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dTmHb":[function(require,module,exports,__globalThis) {
/**
 * Acquisition attribution for the TWG microsite — captures where a visitor
 * came from and the anonymous identifier needed to track conversion
 * (visit → CTA click → login) in GASv3 marketing dashboards.
 *
 * Modelled on WAC's `analytics/atl-analytics/helpers.ts` (`getAndSetUtms`)
 * so the same browser produces the same `anonId` and the same UTM bag
 * regardless of which Atlassian property captured them first. We keep
 * cross-property identity stitching by:
 *
 *  - Reading (never minting) the existing Segment-style `ajs_anonymous_id`
 *    cookie. WAC, the Analytics Wrapper, and `@atlassiansox/analytics-web-client`
 *    all converge on this cookie name. If it's missing we return `null` and
 *    let the GASv3 client mint one when it sends its first event.
 *  - Persisting the captured UTM bag to `localStorage["marketingContext"]`
 *    using the same JSON envelope WAC writes: `{ domain, utm: { source,
 *    medium, campaign, content, sfdcCampaignId } }`. Cross-property
 *    backfill (`teamworkgraph.com` ← `atlassian.com`) will eventually
 *    happen via GUPS once the Analytics Wrapper is adopted; until then
 *    each property persists locally only.
 *
 * Replacement semantics (same as WAC, NOT first-touch):
 *  - URL has UTMs → overwrite localStorage with the URL UTMs.
 *  - URL has no UTMs → return whatever is in localStorage.
 *  - Neither → return null UTMs.
 *
 * The "where did the user come from" question is answered by combining
 * three things on every event:
 *  1. UTM bag (highest fidelity — direct marketing attribution).
 *  2. Paid-ad click IDs (`gclid`, `fbclid`, `msclkid`, `li_fat_id`) when
 *     UTMs are missing.
 *  3. `referrerHost` (lowest fidelity, often blank for native apps —
 *     Discord, Slack, iOS — but useful for organic search and inbound
 *     blog/news links).
 *
 * Everything is best-effort; storage failures (Brave / Safari ITP /
 * private mode) collapse to in-memory only and never throw.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "readAnonId", function() {
    return readAnonId;
});
parcelHelpers.export(exports, "resolveAttribution", function() {
    return resolveAttribution;
});
parcelHelpers.export(exports, "getAttribution", function() {
    return getAttribution;
});
parcelHelpers.export(exports, "__resetAttributionForTests", function() {
    return __resetAttributionForTests;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var STORAGE_KEY_MARKETING_CONTEXT = 'marketingContext';
var COOKIE_NAME_ANON_ID = 'ajs_anonymous_id';
var SEARCH_ENGINE_HOSTS = [
    {
        match: 'google.',
        family: 'google'
    },
    {
        match: 'bing.com',
        family: 'bing'
    },
    {
        match: 'duckduckgo.com',
        family: 'duckduckgo'
    },
    {
        match: 'search.yahoo.',
        family: 'yahoo'
    },
    {
        match: 'baidu.com',
        family: 'baidu'
    },
    {
        match: 'yandex.',
        family: 'yandex'
    },
    {
        match: 'ecosia.org',
        family: 'ecosia'
    },
    {
        match: 'search.brave.com',
        family: 'brave'
    }
];
var INTERNAL_HOST_SUFFIXES = [
    'atlassian.com',
    'atlassian.net',
    'jira.com',
    'confluence.com',
    'loom.com',
    'bitbucket.org',
    'trello.com',
    'statuspage.io'
];
var detailFromClickId = function(gclid, fbclid, msclkid, liFatId) {
    if (gclid) return 'google-ads';
    if (fbclid) return 'meta-ads';
    if (msclkid) return 'bing-ads';
    if (liFatId) return 'linkedin-ads';
    return null;
};
var safeHostname = function(rawUrl) {
    if (!rawUrl) return null;
    try {
        return new URL(rawUrl).hostname.toLowerCase();
    } catch (e) {
        return null;
    }
};
var matchesSearchEngine = function(host) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = SEARCH_ENGINE_HOSTS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var engine = _step.value;
            if (host.includes(engine.match)) return engine.family;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
};
var matchesInternalHost = function(host) {
    return INTERNAL_HOST_SUFFIXES.some(function(suffix) {
        return host === suffix || host.endsWith(".".concat(suffix));
    });
};
var safeReadLocalStorage = function(key) {
    try {
        return window.localStorage.getItem(key);
    } catch (e) {
        return null;
    }
};
var safeWriteLocalStorage = function(key, value) {
    try {
        window.localStorage.setItem(key, value);
    } catch (e) {
    // Blocked storage APIs (Brave / Safari ITP / private mode) must
    // not crash the page. We silently fall back to in-memory only —
    // the event still fires, just without persisted UTMs across
    // SPA navigations.
    }
};
var readAnonId = function() {
    if (typeof document === 'undefined') return null;
    try {
        var all = document.cookie ? document.cookie.split('; ') : [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = all[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entry = _step.value;
                var eqIdx = entry.indexOf('=');
                if (eqIdx === -1) continue;
                if (entry.slice(0, eqIdx) === COOKIE_NAME_ANON_ID) {
                    var raw = entry.slice(eqIdx + 1);
                    return decodeURIComponent(raw).replace(/['"]+/g, '') || null;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } catch (e) {
    // fall through
    }
    return null;
};
var readStoredContext = function() {
    var raw = safeReadLocalStorage(STORAGE_KEY_MARKETING_CONTEXT);
    if (!raw) return null;
    try {
        var parsed = JSON.parse(raw);
        if (!parsed || !parsed.utm) return null;
        return parsed;
    } catch (e) {
        return null;
    }
};
var writeStoredContext = function(context) {
    safeWriteLocalStorage(STORAGE_KEY_MARKETING_CONTEXT, JSON.stringify(context));
};
var resolveAttribution = function(search, referrer, pathname, anonId) {
    var params = new URLSearchParams(search);
    var utmSource = params.get('utm_source');
    var utmMedium = params.get('utm_medium');
    var utmCampaign = params.get('utm_campaign');
    var utmContent = params.get('utm_content');
    var utmTerm = params.get('utm_term');
    var utmSfdcCampaignId = params.get('utm_sfdc-campaign_id');
    var gclid = params.get('gclid');
    var fbclid = params.get('fbclid');
    var msclkid = params.get('msclkid');
    var liFatId = params.get('li_fat_id');
    var referrerHost = safeHostname(referrer);
    var trafficSource = 'direct';
    var trafficSourceDetail = null;
    if (utmSource) {
        trafficSource = utmMedium === 'cpc' ? 'paid' : 'referral';
        trafficSourceDetail = utmSource;
    } else if (gclid || fbclid || msclkid || liFatId) {
        trafficSource = 'paid';
        trafficSourceDetail = detailFromClickId(gclid, fbclid, msclkid, liFatId);
    } else if (referrerHost) {
        var engine = matchesSearchEngine(referrerHost);
        if (engine) {
            trafficSource = 'organic';
            trafficSourceDetail = engine;
        } else if (matchesInternalHost(referrerHost)) {
            trafficSource = 'internal';
            trafficSourceDetail = referrerHost;
        } else {
            trafficSource = 'referral';
            trafficSourceDetail = referrerHost;
        }
    }
    return {
        anonId: anonId,
        trafficSource: trafficSource,
        trafficSourceDetail: trafficSourceDetail,
        utmSource: utmSource,
        utmMedium: utmMedium,
        utmCampaign: utmCampaign,
        utmContent: utmContent,
        utmTerm: utmTerm,
        utmSfdcCampaignId: utmSfdcCampaignId,
        gclid: gclid,
        fbclid: fbclid,
        msclkid: msclkid,
        liFatId: liFatId,
        referrerHost: referrerHost,
        landingPath: pathname
    };
};
var getAttribution = function() {
    if (typeof window === 'undefined') return resolveAttribution('', '', '/', null);
    var anonId = readAnonId();
    var search = window.location.search;
    var pathname = window.location.pathname;
    var referrer = typeof document !== 'undefined' ? document.referrer : '';
    var live = resolveAttribution(search, referrer, pathname, anonId);
    if (live.utmSource || live.utmMedium || live.utmCampaign || live.utmContent || live.utmTerm) {
        var _live_utmSource, _live_utmMedium, _live_utmCampaign, _live_utmContent, _live_utmSfdcCampaignId;
        // URL has UTMs — overwrite stored context (replacement semantics).
        writeStoredContext({
            domain: window.location.hostname,
            utm: {
                source: (_live_utmSource = live.utmSource) !== null && _live_utmSource !== void 0 ? _live_utmSource : '',
                medium: (_live_utmMedium = live.utmMedium) !== null && _live_utmMedium !== void 0 ? _live_utmMedium : '',
                campaign: (_live_utmCampaign = live.utmCampaign) !== null && _live_utmCampaign !== void 0 ? _live_utmCampaign : '',
                content: (_live_utmContent = live.utmContent) !== null && _live_utmContent !== void 0 ? _live_utmContent : '',
                sfdcCampaignId: (_live_utmSfdcCampaignId = live.utmSfdcCampaignId) !== null && _live_utmSfdcCampaignId !== void 0 ? _live_utmSfdcCampaignId : ''
            }
        });
        return live;
    }
    // No UTMs in URL — fall back to persisted UTMs (if any) and re-derive
    // trafficSource using the persisted UTMs + live referrer.
    var stored = readStoredContext();
    if (!stored) return live;
    var restoredUtmSource = stored.utm.source || null;
    var restoredUtmMedium = stored.utm.medium || null;
    var trafficSource = live.trafficSource;
    var trafficSourceDetail = live.trafficSourceDetail;
    if (restoredUtmSource) {
        trafficSource = restoredUtmMedium === 'cpc' ? 'paid' : 'referral';
        trafficSourceDetail = restoredUtmSource;
    }
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, live), {
        trafficSource: trafficSource,
        trafficSourceDetail: trafficSourceDetail,
        utmSource: restoredUtmSource,
        utmMedium: restoredUtmMedium,
        utmCampaign: stored.utm.campaign || null,
        utmContent: stored.utm.content || null,
        utmTerm: live.utmTerm,
        utmSfdcCampaignId: stored.utm.sfdcCampaignId || null
    });
};
var __resetAttributionForTests = function() {
    try {
        window.localStorage.removeItem(STORAGE_KEY_MARKETING_CONTEXT);
    } catch (e) {
    // noop
    }
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9GPzn":[function(require,module,exports,__globalThis) {
/**
 * Closed-set type definitions used across the microsite analytics
 * surface. Co-locating them in one file keeps the analytics package
 * directory listing tight and makes "what string-literal attributes
 * does this package emit?" answerable in a single read.
 *
 * Each enum mirrors the corresponding `enum:` list in
 * `analytics.spec.yaml` — keep the two in sync when editing either.
 */ // ---------------------------------------------------------------------------
// Sections (used by `ui.section.revealed.twgMicrositeSection`,
// `ui.section.clicked.twgMicrositeSection`, and
// `ui.section.dwelled.twgMicrositeSection`).
// ---------------------------------------------------------------------------
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SectionName", function() {
    return SectionName;
});
parcelHelpers.export(exports, "MicrositeTier", function() {
    return MicrositeTier;
});
parcelHelpers.export(exports, "TierResolution", function() {
    return TierResolution;
});
parcelHelpers.export(exports, "GraphInteractionType", function() {
    return GraphInteractionType;
});
parcelHelpers.export(exports, "GraphAbandonReason", function() {
    return GraphAbandonReason;
});
parcelHelpers.export(exports, "ZoomDirection", function() {
    return ZoomDirection;
});
parcelHelpers.export(exports, "UndoSource", function() {
    return UndoSource;
});
parcelHelpers.export(exports, "NodeDwellTrigger", function() {
    return NodeDwellTrigger;
});
parcelHelpers.export(exports, "ScrollDepthBucket", function() {
    return ScrollDepthBucket;
});
parcelHelpers.export(exports, "SCROLL_DEPTH_BUCKETS_IN_ORDER", function() {
    return SCROLL_DEPTH_BUCKETS_IN_ORDER;
});
var SectionName = /*#__PURE__*/ function(SectionName) {
    // Logged-out hero section.
    SectionName["Hero"] = "hero";
    // Logged-out overview section.
    SectionName["Overview"] = "overview";
    // Logged-out 3-panel scroll carousel rendered inside the overview section.
    SectionName["OverviewCarousel"] = "overviewCarousel";
    // Logged-out graph preview panel rendered inside the overview section.
    SectionName["GraphPreviewPanel"] = "graphPreviewPanel";
    // Logged-out "Results that speak for themselves" supplemental section.
    SectionName["Results"] = "results";
    // Logged-out "See your Teamwork Graph in action" supplemental section.
    SectionName["GraphInAction"] = "graphInAction";
    // Shared between logged-out and logged-in experiences.
    SectionName["ConnectorShowcase"] = "connectorShowcase";
    SectionName["GettingStarted"] = "gettingStarted";
    SectionName["Footer"] = "footer";
    // Logged-in sections.
    SectionName["Introduction"] = "introduction";
    SectionName["GraphPreview"] = "graphPreview";
    SectionName["ConnectedApps"] = "connectedApps";
    SectionName["Collaborators"] = "collaborators";
    SectionName["UserGraph"] = "userGraph";
    return SectionName;
}({});
var MicrositeTier = /*#__PURE__*/ function(MicrositeTier) {
    MicrositeTier["LoggedOut"] = "loggedOut";
    MicrositeTier["UserGraph"] = "userGraph";
    MicrositeTier["OrgGraph"] = "orgGraph";
    MicrositeTier["GettingStarted"] = "gettingStarted";
    return MicrositeTier;
}({});
var TierResolution = /*#__PURE__*/ function(TierResolution) {
    TierResolution["Organic"] = "organic";
    TierResolution["DebugOverride"] = "debugOverride";
    return TierResolution;
}({});
var GraphInteractionType = /*#__PURE__*/ function(GraphInteractionType) {
    GraphInteractionType["NodeClick"] = "nodeClick";
    GraphInteractionType["NodeKeyboardSelect"] = "nodeKeyboardSelect";
    GraphInteractionType["CanvasPan"] = "canvasPan";
    GraphInteractionType["CanvasZoom"] = "canvasZoom";
    GraphInteractionType["EdgeClick"] = "edgeClick";
    GraphInteractionType["BackgroundClick"] = "backgroundClick";
    return GraphInteractionType;
}({});
var GraphAbandonReason = /*#__PURE__*/ function(GraphAbandonReason) {
    /** `document.visibilityState` flipped to `'hidden'`. */ GraphAbandonReason["PageHidden"] = "pageHidden";
    /** Browser tab switched but window remained focused (best-effort). */ GraphAbandonReason["TabSwitched"] = "tabSwitched";
    /** The explorer wrapper unmounted before any interaction. */ GraphAbandonReason["Unmounted"] = "unmounted";
    return GraphAbandonReason;
}({});
var ZoomDirection = /*#__PURE__*/ function(ZoomDirection) {
    ZoomDirection["In"] = "in";
    ZoomDirection["Out"] = "out";
    ZoomDirection["FitView"] = "fitView";
    return ZoomDirection;
}({});
var UndoSource = /*#__PURE__*/ function(UndoSource) {
    UndoSource["ClearAllExpanded"] = "clearAllExpanded";
    UndoSource["NoResultsHeader"] = "noResultsHeader";
    return UndoSource;
}({});
var NodeDwellTrigger = /*#__PURE__*/ function(NodeDwellTrigger) {
    NodeDwellTrigger["Hover"] = "hover";
    return NodeDwellTrigger;
}({});
var ScrollDepthBucket = /*#__PURE__*/ function(ScrollDepthBucket) {
    ScrollDepthBucket["Quarter"] = "25";
    ScrollDepthBucket["Half"] = "50";
    ScrollDepthBucket["ThreeQuarters"] = "75";
    ScrollDepthBucket["Full"] = "100";
    return ScrollDepthBucket;
}({});
var SCROLL_DEPTH_BUCKETS_IN_ORDER = [
    "25",
    "50",
    "75",
    "100"
];

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4SS5v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useTierShownEvent", function() {
    return useTierShownEvent;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _react = require("react");
var _attribution = require("../attribution");
var _useAnalyticsEvents = require("../generated/use-analytics-events");
var useTierShownEvent = function(param) {
    var tier = param.tier, resolution = param.resolution, hasUserMetrics = param.hasUserMetrics, hasOrgMetrics = param.hasOrgMetrics, metricCount = param.metricCount;
    var fireEvent = (0, _useAnalyticsEvents.useAnalyticsEvents)().fireEvent;
    var seenTuplesRef = (0, _react.useRef)(new Set());
    (0, _react.useEffect)(function() {
        if (tier === undefined) return;
        var key = "".concat(tier, ":").concat(resolution);
        if (seenTuplesRef.current.has(key)) return;
        seenTuplesRef.current.add(key);
        fireEvent('track.twgMicrositeTier.shown', (0, _objectSpread._)({
            tier: tier,
            resolution: resolution,
            hasUserMetrics: hasUserMetrics,
            hasOrgMetrics: hasOrgMetrics,
            metricCount: metricCount
        }, (0, _attribution.getAttribution)()));
    // `fireEvent` is stable per-mount (returned by `useAnalyticsEvents`)
    // and `getAttribution` reads from a module-level const, so neither
    // needs to be in the deps array. Including them would not change
    // behaviour but would clutter the lint surface.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        tier,
        resolution,
        hasUserMetrics,
        hasOrgMetrics,
        metricCount
    ]);
};

},{"@swc/helpers/_/_object_spread":"9gdrV","react":"ltHCL","../attribution":"dTmHb","../generated/use-analytics-events":"hpATH","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fWBfP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SessionTracker", function() {
    return SessionTracker;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _react = require("react");
var _bindEventListener = require("bind-event-listener");
var _browserApis = require("@atlaskit/browser-apis");
var _attribution = require("../attribution");
var _useAnalyticsEvents = require("../generated/use-analytics-events");
/**
 * Lifecycle-only component (renders nothing). Mounted by the home page in
 * each auth-state branch so it remounts on auth-state flips.
 *
 * Fires:
 *  - `screen.twgMicrositeHome.viewed` once on mount.
 *  - track.session.ended.twgMicrositeHome` exactly once per page-load
 *    on the first hidden signal (visibilitychange to 'hidden' OR pagehide),
 *    carrying durationMs since mount.
 */ /**
 * Returns a monotonic clock reading in milliseconds. Falls back to
 * `Date.now()` in environments where `performance.now()` is unavailable
 * (e.g. some SSR shims). `performance.now()` is preferred because it is
 * not affected by wall-clock skew (NTP corrections, manual clock changes)
 * and therefore cannot produce negative `durationMs` values that would
 * pollute the Time-on-Page / Avg Session Duration dashboards.
 */ var now = function() {
    return typeof performance !== 'undefined' && typeof performance.now === 'function' ? performance.now() : Date.now();
};
var SessionTracker = function(param) {
    var authState = param.authState, tier = param.tier;
    var fireEvent = (0, _useAnalyticsEvents.useAnalyticsEvents)().fireEvent;
    var mountTime = (0, _react.useRef)(now());
    var sessionEndedFired = (0, _react.useRef)(false);
    // Guards against StrictMode's intentional double-invocation of effects
    // in development (mount → cleanup → re-mount), which would otherwise
    // produce two `screen.twgMicrositeHome.viewed` events per real mount.
    var screenViewedFired = (0, _react.useRef)(false);
    var authStateRef = (0, _react.useRef)(authState);
    var tierRef = (0, _react.useRef)(tier);
    (0, _react.useEffect)(function() {
        if (screenViewedFired.current) return;
        screenViewedFired.current = true;
        fireEvent('screen.twgMicrositeHome.viewed', (0, _objectSpread._)({
            authState: authStateRef.current
        }, tierRef.current !== undefined ? {
            tier: tierRef.current
        } : {}, (0, _attribution.getAttribution)()));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Bind visibility/pagehide listeners exactly once per mount. Same
    // reasoning as above — empty deps avoid re-binding on prop changes
    // while still firing the correct `authState` (read via the ref).
    (0, _react.useEffect)(function() {
        var fire = function() {
            if (sessionEndedFired.current) return;
            sessionEndedFired.current = true;
            fireEvent('track.session.ended.twgMicrositeHome', {
                durationMs: now() - mountTime.current,
                authState: authStateRef.current
            });
        };
        var doc = (0, _browserApis.getDocument)();
        if (!doc) return undefined;
        var onVisibility = function() {
            if (doc.visibilityState === 'hidden') fire();
        };
        // BFCache restore: when the user navigates away with `pagehide`
        // and later returns via the browser's back/forward cache, the JS
        // context is reused — including our `sessionEndedFired` flag and
        // the original `mountTime`. Without resetting, the next visit
        // would never emit `session.ended` (and `durationMs` would be
        // inflated by the time spent in BFCache). `pageshow` with
        // `event.persisted === true` signals a BFCache restore, so we
        // reset the per-session state to start a fresh session.
        var onPageShow = function(event) {
            if (event.persisted) {
                sessionEndedFired.current = false;
                mountTime.current = now();
            }
        };
        var cleanups = [
            (0, _bindEventListener.bind)(doc, {
                type: 'visibilitychange',
                listener: onVisibility
            }),
            (0, _bindEventListener.bind)(window, {
                type: 'pagehide',
                listener: fire
            }),
            (0, _bindEventListener.bind)(window, {
                type: 'pageshow',
                listener: onPageShow
            })
        ];
        return function() {
            return cleanups.forEach(function(c) {
                return c();
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};

},{"@swc/helpers/_/_object_spread":"9gdrV","react":"ltHCL","bind-event-listener":"bjeUU","@atlaskit/browser-apis":"2dayt","../attribution":"dTmHb","../generated/use-analytics-events":"hpATH","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bVqUv":[function(require,module,exports,__globalThis) {
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CollectFeedback", function() {
    return CollectFeedback;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _new = require("@atlaskit/button/new");
var _feedbackCollector = require("@atlaskit/feedback-collector");
var _feedbackCollectorDefault = parcelHelpers.interopDefault(_feedbackCollector);
var _flag = require("@atlaskit/flag");
var _megaphone = require("@atlaskit/icon/core/megaphone");
var _megaphoneDefault = parcelHelpers.interopDefault(_megaphone);
var _compiled = require("@atlaskit/primitives/compiled");
var _attribution = require("../../../common/analytics/attribution");
var _useAnalyticsEvents = require("../../../common/analytics/generated/use-analytics-events");
var _sentry = require("../../../common/sentry");
var styles = {
    floatingButton: "_kqsw1n9t _94n5pxbi _1ltvpxbi _1pbyb4wl"
};
var CollectFeedback = function(param) {
    var atlassianAccountId = param.atlassianAccountId, entrypointId = param.entrypointId, name = param.name, _param_locale = param.locale, locale = _param_locale === void 0 ? 'en' : _param_locale;
    var _React_useState = (0, _slicedToArray._)((0, _reactDefault.default).useState(false), 2), isOpen = _React_useState[0], setIsOpen = _React_useState[1];
    var _React_useState1 = (0, _slicedToArray._)((0, _reactDefault.default).useState(false), 2), displayFlag = _React_useState1[0], setDisplayFlag = _React_useState1[1];
    var fireEvent = (0, _useAnalyticsEvents.useAnalyticsEvents)().fireEvent;
    var handleOpen = (0, _reactDefault.default).useCallback(function() {
        fireEvent('ui.feedbackButton.clicked.twgMicrositeHome', (0, _objectSpread._)({}, (0, _attribution.getAttribution)()));
        setIsOpen(true);
    }, [
        fireEvent
    ]);
    var handleClose = (0, _reactDefault.default).useCallback(function() {
        return setIsOpen(false);
    }, []);
    var handleSubmit = (0, _reactDefault.default).useCallback(function() {
        return setDisplayFlag(true);
    }, []);
    var hideFlag = (0, _reactDefault.default).useCallback(function() {
        return setDisplayFlag(false);
    }, []);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _sentry.SentryErrorBoundary), {
        fallback: null,
        touchpointId: "collect-feedback"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Box), {
        xcss: styles.floatingButton
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _new.IconButton), {
        icon: (0, _megaphoneDefault.default),
        label: "Give feedback",
        shape: "circle",
        onClick: handleOpen,
        appearance: "discovery"
    })), isOpen && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _feedbackCollectorDefault.default), {
        locale: locale,
        onClose: handleClose,
        onSubmit: handleSubmit,
        atlassianAccountId: atlassianAccountId,
        name: name,
        entrypointId: entrypointId
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _flag.FlagGroup), {
        onDismissed: hideFlag
    }, displayFlag && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _feedbackCollector.FeedbackFlag), null)));
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_sliced_to_array":"8PtL6","react":"ltHCL","@atlaskit/button/new":"2LnSZ","@atlaskit/feedback-collector":"4ORLm","@atlaskit/flag":"blMWC","@atlaskit/icon/core/megaphone":"aGGNS","@atlaskit/primitives/compiled":"jhQE8","../../../common/analytics/attribution":"dTmHb","../../../common/analytics/generated/use-analytics-events":"hpATH","../../../common/sentry":"lc1oo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4ORLm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FeedbackFlag", function() {
    return 0, _feedbackFlagDefault.default;
});
parcelHelpers.export(exports, "FeedbackForm", function() {
    return 0, _feedbackFormDefault.default;
});
parcelHelpers.export(exports, "FeedbackButton", function() {
    return 0, _feedbackButtonDefault.default;
});
var _feedbackButton = require("./components/FeedbackButton");
var _feedbackButtonDefault = parcelHelpers.interopDefault(_feedbackButton);
var _feedbackCollector = require("./components/FeedbackCollector");
var _feedbackCollectorDefault = parcelHelpers.interopDefault(_feedbackCollector);
var _feedbackFlag = require("./components/FeedbackFlag");
var _feedbackFlagDefault = parcelHelpers.interopDefault(_feedbackFlag);
var _feedbackForm = require("./components/FeedbackForm");
var _feedbackFormDefault = parcelHelpers.interopDefault(_feedbackForm);
exports.default = (0, _feedbackCollectorDefault.default);

},{"./components/FeedbackButton":false,"./components/FeedbackCollector":"h07CF","./components/FeedbackFlag":"3Mstt","./components/FeedbackForm":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"h07CF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return FeedbackCollector;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _jsxRuntime = require("react/jsx-runtime");
var _buffer = require("buffer");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _isApiGatewayUrl = require("../utils/is-api-gateway-url");
var _truncate = require("../utils/Truncate");
var _truncateDefault = parcelHelpers.interopDefault(_truncate);
var _feedbackForm = require("./FeedbackForm");
var _feedbackFormDefault = parcelHelpers.interopDefault(_feedbackForm);
var MAX_SUMMARY_LENGTH_CHARS = 100;
var singleLineTruncatedText = function(text) {
    var length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : MAX_SUMMARY_LENGTH_CHARS;
    var singleLineText = text.replace(/\n/g, ' ');
    return (0, _truncateDefault.default)(singleLineText, length);
};
var FeedbackCollector = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, _inherits._)(FeedbackCollector, Component);
    function FeedbackCollector() {
        (0, _classCallCheck._)(this, FeedbackCollector);
        var _this;
        var _this1;
        _this = (0, _callSuper._)(this, FeedbackCollector, arguments), _this1 = _this, _this1.state = {
            anonymousFeedback: true
        }, _this1.postFeedback = function(formValues) {
            return (0, _asyncToGenerator._)(function() {
                var entrypointId, fetchUrl, formData, body, postData;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            entrypointId = _this1.props.entrypointId;
                            fetchUrl = _this1.getFeedbackUrl();
                            if (!entrypointId) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                _this1.mapFormToJSD(formValues)
                            ];
                        case 1:
                            formData = _state.sent();
                            body = {
                                feedback: (0, _objectSpread._)({
                                    entrypointId: _this1.props.entrypointId,
                                    entrypointUiVersion: _this1.getPackageVersion()
                                }, formData)
                            };
                            if ((0, _isApiGatewayUrl.isApiGatewayUrl)(fetchUrl)) fetchUrl += '/feedback-collector-api';
                            else if (!_this1.props.customFeedbackUrl) fetchUrl = 'https://feedback-collector-api.services.atlassian.com';
                            postData = (0, _buffer.Buffer).from(JSON.stringify(body)).toString('base64');
                            fetch("".concat(fetchUrl, "/v2/feedback"), {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify({
                                    data: postData
                                }),
                                credentials: 'include'
                            });
                            _state.label = 2;
                        case 2:
                            _this1.props.onClose();
                            // slightly delay confirming submit since we don't wait for the REST call to succeed
                            //
                            // Because `onClose` is invoked prior to this timeout triggering, the `componentWillUnmount`
                            // may occur before the `onSubmit` is called. To prevent prematurely cancelling the
                            // network request, we deliberately don't clear this timeout inside `componentWillUnmount`.
                            //
                            setTimeout(function() {
                                return _this1.props.onSubmit(formValues);
                            }, _this1.props.timeoutOnSubmit);
                            return [
                                2
                            ];
                    }
                });
            })();
        };
        return _this;
    }
    (0, _createClass._)(FeedbackCollector, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                return (0, _asyncToGenerator._)(function() {
                    var anonymousFeedback;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.shouldShowOptInCheckboxesNew()
                                ];
                            case 1:
                                anonymousFeedback = !_state.sent();
                                this.setState({
                                    anonymousFeedback: anonymousFeedback
                                });
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getGatewayUrl",
            value: function getGatewayUrl() {
                var _this_props = this.props, customGatewayUrl = _this_props.customGatewayUrl, url = _this_props.url;
                if (customGatewayUrl) return customGatewayUrl;
                if (url) return url;
                return FeedbackCollector.defaultProps.url;
            }
        },
        {
            key: "getFeedbackUrl",
            value: function getFeedbackUrl() {
                var _this_props = this.props, customFeedbackUrl = _this_props.customFeedbackUrl, url = _this_props.url;
                if (customFeedbackUrl) return customFeedbackUrl;
                if (url) return url;
                return FeedbackCollector.defaultProps.url;
            }
        },
        {
            key: "getPackageVersion",
            value: function getPackageVersion() {
                return 'Unknown, at least 11.0.0';
            }
        },
        {
            key: "getEntitlementInformation",
            value: function getEntitlementInformation() {
                return (0, _asyncToGenerator._)(function() {
                    var url, productName, productEntitlement, entitlementDetails, productKey, _document_querySelector, hasPremium, e, entitlement, entitlementInformation, cloudSiteId;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = this.getGatewayUrl();
                                if (!window.location.host.includes('bitbucket.org')) return [
                                    3,
                                    1
                                ];
                                productName = 'Bitbucket';
                                productKey = 'bitbucket';
                                entitlementDetails = JSON.parse(JSON.stringify((_document_querySelector = document.querySelector('meta[id="bb-bootstrap"]')) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.getAttribute('data-current-user')));
                                hasPremium = entitlementDetails['hasPremium'];
                                productEntitlement = hasPremium ? 'PREMIUM' : 'STANDARD';
                                return [
                                    3,
                                    6
                                ];
                            case 1:
                                if (![
                                    'trellis.coffee',
                                    'trello.com'
                                ].includes(window.location.host)) return [
                                    3,
                                    2
                                ];
                                productName = 'Trello';
                                productKey = 'trello';
                                return [
                                    3,
                                    6
                                ];
                            case 2:
                                if (document.querySelector('meta[id="confluence-context-path"]')) {
                                    productName = 'Confluence';
                                    productKey = 'pricingplan.confluence.ondemand';
                                } else {
                                    productName = 'Jira';
                                    productKey = 'jira-software.ondemand';
                                }
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    5,
                                    ,
                                    6
                                ]);
                                return [
                                    4,
                                    fetch("".concat(url, "/customer-context/entitlements/").concat(window.location.host), (0, _objectSpread._)({
                                        method: 'GET',
                                        headers: {
                                            'Content-Type': 'application/json'
                                        }
                                    }, (0, _isApiGatewayUrl.isApiGatewayUrl)(url) ? {
                                        credentials: 'include'
                                    } : {}))
                                ];
                            case 4:
                                entitlementDetails = _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                e = _state.sent();
                                entitlementDetails = undefined;
                                return [
                                    3,
                                    6
                                ];
                            case 6:
                                entitlementInformation = [];
                                cloudSiteId = (entitlementDetails === null || entitlementDetails === void 0 ? void 0 : entitlementDetails.cloudSiteId) || '';
                                if (entitlementDetails === null || entitlementDetails === void 0 ? void 0 : entitlementDetails.children) entitlement = entitlementDetails === null || entitlementDetails === void 0 ? void 0 : entitlementDetails.children.find(function(entitlement) {
                                    return entitlement.key === productKey;
                                });
                                entitlementInformation.push({
                                    id: 'product',
                                    value: productName ? productName === null || productName === void 0 ? void 0 : productName.toLowerCase() : ''
                                }, {
                                    id: 'hostingType',
                                    value: (entitlement === null || entitlement === void 0 ? void 0 : entitlement.product) ? entitlement.product.hostingType : 'CLOUD'
                                }, {
                                    id: 'entitlementEdition',
                                    value: productEntitlement !== null && productEntitlement !== void 0 ? productEntitlement : ''
                                }, {
                                    id: 'cloudId',
                                    value: cloudSiteId
                                });
                                return [
                                    2,
                                    entitlementInformation
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getTypeFieldValue",
            value: function getTypeFieldValue(dtype) {
                switch(dtype){
                    case 'bug':
                        return this.props.typeBugDefaultValue;
                    case 'comment':
                        return this.props.typeCommentDefaultValue;
                    case 'suggestion':
                        return this.props.typeSuggestionDefaultValue;
                    case 'question':
                        return this.props.typeQuestionDefaultValue;
                    case 'empty':
                    default:
                        return this.props.typeEmptyDefaultValue;
                }
            }
        },
        {
            key: "getAtlassianID",
            value: function getAtlassianID() {
                return (0, _asyncToGenerator._)(function() {
                    var _this_props, atlassianAccountId, shouldGetEntitlementDetails, url, result, json, e;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this_props = this.props, atlassianAccountId = _this_props.atlassianAccountId, shouldGetEntitlementDetails = _this_props.shouldGetEntitlementDetails;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    4,
                                    ,
                                    5
                                ]);
                                if (atlassianAccountId || !shouldGetEntitlementDetails) return [
                                    2,
                                    atlassianAccountId
                                ];
                                url = this.getGatewayUrl();
                                return [
                                    4,
                                    fetch("".concat(url, "/me"), (0, _objectSpread._)({
                                        method: 'GET',
                                        headers: {
                                            'Content-Type': 'application/json'
                                        }
                                    }, (0, _isApiGatewayUrl.isApiGatewayUrl)(url) ? {
                                        credentials: 'include'
                                    } : {}))
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    4,
                                    result.json()
                                ];
                            case 3:
                                json = _state.sent();
                                return [
                                    2,
                                    json.account_id
                                ];
                            case 4:
                                e = _state.sent();
                                return [
                                    2,
                                    undefined
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "shouldShowOptInCheckboxes",
            value: function shouldShowOptInCheckboxes() {
                if (this.props.anonymousFeedback) return !this.props.anonymousFeedback;
                if (this.props.atlassianAccountId) return true;
                var response;
                this.getAtlassianID().then(function(result) {
                    response = result !== undefined;
                }).catch(function() {
                    response = false;
                });
                // @ts-ignore
                return response;
            }
        },
        {
            key: "shouldShowOptInCheckboxesNew",
            value: function shouldShowOptInCheckboxesNew() {
                var _this = this;
                return new Promise(function(resolve) {
                    if (_this.props.anonymousFeedback) resolve(!_this.props.anonymousFeedback);
                    if (_this.props.atlassianAccountId) resolve(true);
                    _this.getAtlassianID().then(function(result) {
                        resolve(result !== undefined);
                    }).catch(function() {
                        resolve(false);
                    });
                });
            }
        },
        {
            key: "getDescription",
            value: function getDescription(formValues) {
                return formValues.description || this.props.descriptionDefaultValue;
            }
        },
        {
            key: "getSummary",
            value: function getSummary(formValues) {
                return singleLineTruncatedText(formValues.description, this.props.summaryTruncateLength) || this.props.summaryDefaultValue;
            }
        },
        {
            key: "getCustomerName",
            value: function getCustomerName() {
                var _this_props_name;
                return (_this_props_name = this.props.name) !== null && _this_props_name !== void 0 ? _this_props_name : this.props.customerNameDefaultValue;
            }
        },
        {
            key: "addEmailToContext",
            value: function addEmailToContext() {
                var contextField = this.props.additionalFields.find(function(field) {
                    return field.id === 'customfield_10047';
                });
                if (contextField) contextField.value = "".concat(contextField.value, "\n        email: ").concat(this.props.email);
                else this.props.additionalFields.push({
                    id: 'customfield_10047',
                    value: "email: ".concat(this.props.email)
                });
            }
        },
        {
            key: "addAccountIdToContext",
            value: function addAccountIdToContext(atlassianID) {
                if (atlassianID) {
                    var contextField = this.props.additionalFields.find(function(field) {
                        return field.id === 'customfield_10047';
                    });
                    if (contextField) contextField.value = "".concat(contextField.value, "\n			atlassian-account-id: ").concat(atlassianID);
                }
            }
        },
        {
            key: "mapFormToJSD",
            value: function mapFormToJSD(formValues) {
                return (0, _asyncToGenerator._)(function() {
                    var _this_props, _this_props1, entitlementInformation, atlassianID;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                entitlementInformation = null;
                                if (!((_this_props = this.props) === null || _this_props === void 0 ? void 0 : _this_props.shouldGetEntitlementDetails)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    this.getEntitlementInformation()
                                ];
                            case 1:
                                entitlementInformation = _state.sent();
                                _state.label = 2;
                            case 2:
                                if ((_this_props1 = this.props) === null || _this_props1 === void 0 ? void 0 : _this_props1.email) this.addEmailToContext();
                                return [
                                    4,
                                    this.getAtlassianID()
                                ];
                            case 3:
                                atlassianID = _state.sent();
                                this.addAccountIdToContext(atlassianID);
                                return [
                                    2,
                                    {
                                        fields: (0, _toConsumableArray._)(entitlementInformation !== null && entitlementInformation || []).concat([
                                            this.props.showTypeField ? {
                                                id: this.props.typeFieldId,
                                                value: this.getTypeFieldValue(formValues.type)
                                            } : undefined,
                                            {
                                                id: this.props.summaryFieldId,
                                                value: this.getSummary(formValues)
                                            },
                                            {
                                                id: this.props.descriptionFieldId,
                                                value: this.getDescription(formValues)
                                            },
                                            {
                                                id: 'aaidOrHash',
                                                value: formValues.canBeContacted ? atlassianID : undefined
                                            },
                                            {
                                                id: this.props.customerNameFieldId,
                                                value: this.getCustomerName()
                                            },
                                            formValues.canBeContacted ? {
                                                id: this.props.canBeContactedFieldId,
                                                value: this.props.canBeContactedAgreeValue
                                            } : {
                                                id: this.props.canBeContactedFieldId,
                                                value: this.props.canBeContactedDeclineValue
                                            },
                                            formValues.enrollInResearchGroup ? {
                                                id: this.props.enrollInResearchFieldId,
                                                value: this.props.enrollInResearchAgreeValue
                                            } : {
                                                id: this.props.enrollInResearchFieldId,
                                                value: this.props.enrollInResearchDeclineValue
                                            }
                                        ], (0, _toConsumableArray._)(this.props.additionalFields)).filter(Boolean)
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "render",
            value: function render() {
                var anonymousFeedback = !this.shouldShowOptInCheckboxes();
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _feedbackFormDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({
                    customContent: this.props.customContent,
                    feedbackTitle: this.props.feedbackTitle,
                    feedbackTitleDetails: this.props.feedbackTitleDetails,
                    showTypeField: this.props.showTypeField,
                    showDefaultTextFields: this.props.showDefaultTextFields,
                    hasDescriptionDefaultValue: !!this.props.descriptionDefaultValue,
                    canBeContactedLabel: this.props.canBeContactedLabel,
                    enrolInResearchLabel: this.props.enrolInResearchLabel,
                    summaryPlaceholder: this.props.summaryPlaceholder,
                    submitButtonLabel: this.props.submitButtonLabel,
                    cancelButtonLabel: this.props.cancelButtonLabel,
                    feedbackGroupLabels: this.props.feedbackGroupLabels,
                    onSubmit: this.postFeedback,
                    onClose: this.props.onClose,
                    locale: this.props.locale,
                    anonymousFeedback: (0, _platformFeatureFlags.fg)('platform.proforma-form-builder-feedback_hupaz') ? this.state.anonymousFeedback : anonymousFeedback,
                    selectLabel: this.props.selectLabel,
                    customTextAreaLabel: this.props.customTextAreaLabel,
                    customFeedbackOptions: this.props.customFeedbackOptions,
                    shouldReturnFocusRef: this.props.shouldReturnFocusRef,
                    disableSubmitButton: this.props.disableSubmitButton
                }, (0, _platformFeatureFlags.fg)('jfp_a11y_team_feedback_collector_nested_elements') && {
                    enrolInResearchLink: this.props.enrolInResearchLink,
                    canBeContactedLink: this.props.canBeContactedLink
                }), {
                    showRequiredFieldsSummary: this.props.showRequiredFieldsSummary
                }));
            }
        }
    ]);
    return FeedbackCollector;
}((0, _react.Component));
FeedbackCollector.defaultProps = {
    locale: 'en',
    url: '/gateway/api',
    shouldGetEntitlementDetails: true,
    canBeContactedFieldId: 'customfield_10043',
    canBeContactedAgreeValue: [
        {
            id: '10109'
        }
    ],
    canBeContactedDeclineValue: [
        {
            id: '10111'
        }
    ],
    additionalFields: [],
    customerNameFieldId: 'customfield_10045',
    customerNameDefaultValue: 'unknown',
    descriptionFieldId: 'description',
    descriptionDefaultValue: '',
    enrollInResearchFieldId: 'customfield_10044',
    enrollInResearchAgreeValue: [
        {
            id: '10110'
        }
    ],
    enrollInResearchDeclineValue: [
        {
            id: '10112'
        }
    ],
    summaryFieldId: 'summary',
    summaryDefaultValue: '',
    summaryTruncateLength: 100,
    timeoutOnSubmit: 700,
    typeFieldId: 'customfield_10042',
    typeBugDefaultValue: {
        id: '10105'
    },
    typeCommentDefaultValue: {
        id: '10106'
    },
    typeSuggestionDefaultValue: {
        id: '10107'
    },
    typeQuestionDefaultValue: {
        id: '10108'
    },
    typeEmptyDefaultValue: {
        id: 'empty'
    },
    showTypeField: true,
    showDefaultTextFields: true,
    anonymousFeedback: false,
    onClose: function() {},
    onSubmit: function() {}
};

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_inherits":"2sfqW","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_to_consumable_array":"1eSZf","@swc/helpers/_/_ts_generator":"78Tqx","react/jsx-runtime":"bGvcw","buffer":"xxtHx","react":"ltHCL","@atlaskit/platform-feature-flags":"kO5t9","../utils/is-api-gateway-url":"1Dsnx","../utils/Truncate":"huopn","./FeedbackForm":"8sA6v","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"xxtHx":[function(require,module,exports,__globalThis) {
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var base64 = require("936d7d40ee51556e");
var ieee754 = require("a9454e8447bbf491");
var customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
var K_MAX_LENGTH = 0x7fffffff;
exports.kMaxLength = K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty(Buffer.prototype, 'parent', {
    enumerable: true,
    get: function get() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty(Buffer.prototype, 'offset', {
    enumerable: true,
    get: function get() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function createBuffer(length) {
    if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return allocUnsafe(arg);
    }
    return from(arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192; // not used by this implementation
function from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)));
    if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
    var b = fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
    return from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf(Buffer, Uint8Array);
function assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function alloc(size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
    return createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
    return alloc(size, fill, encoding);
};
function allocUnsafe(size) {
    assertSize(size);
    return createBuffer(size < 0 ? 0 : checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
    return allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
    return allocUnsafe(size);
};
function fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = byteLength(string, encoding) | 0;
    var buf = createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function fromArrayLike(array) {
    var length = array.length < 0 ? 0 : checked(array.length) | 0;
    var buf = createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function fromArrayView(arrayView) {
    if (isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return fromArrayLike(arrayView);
}
function fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
function fromObject(obj) {
    if (Buffer.isBuffer(obj)) {
        var len = checked(obj.length) | 0;
        var buf = createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) return createBuffer(0);
        return fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return fromArrayLike(obj.data);
}
function checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function SlowBuffer(length) {
    if (+length != length) length = 0;
    return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
Buffer.compare = function compare(a, b) {
    if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
    if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, _typeOf._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return utf8Slice(this, start, end);
        case 'ascii':
            return asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return latin1Slice(this, start, end);
        case 'base64':
            return base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.toLocaleString = Buffer.prototype.toString;
Buffer.prototype.equals = function equals(b) {
    if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = exports.INSPECT_MAX_BYTES;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
    if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, _typeOf._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset; // Coerce to Number.
    if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF; // Search for a byte value [0-255]
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    var i;
    for(i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
    else return base64.fromByteArray(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
    return out;
}
function utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    var lo = first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
    var hi = this[++offset] + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
Buffer.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    var val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * Math.pow(2, 16) + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
});
Buffer.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    var val = (first << 24) + // Overflow
    this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last);
});
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function wrtBigUInt64LE(buf, value, offset, min, max) {
    checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function wrtBigUInt64BE(buf, value, offset, min, max) {
    checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
Buffer.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
Buffer.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
Buffer.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38);
    ieee754.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157e+308);
    ieee754.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
var errors = {};
function E(sym, getMessage, Base) {
    errors[sym] = /*#__PURE__*/ function(Base) {
        (0, _inherits._)(NodeError, Base);
        function NodeError() {
            (0, _classCallCheck._)(this, NodeError);
            var _this;
            _this = (0, _callSuper._)(this, NodeError);
            Object.defineProperty(_this, 'message', {
                value: getMessage.apply(_this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            _this.name = "".concat(_this.name, " [").concat(sym, "]");
            // Access the stack to generate the error message including the error code
            // from the name.
            _this.stack; // eslint-disable-line no-unused-expressions
            // Reset the name to the actual name.
            delete _this.name;
            return _this;
        }
        (0, _createClass._)(NodeError, [
            {
                key: "code",
                get: function get() {
                    return sym;
                },
                set: function set(value) {
                    Object.defineProperty(this, 'code', {
                        configurable: true,
                        enumerable: true,
                        value: value,
                        writable: true
                    });
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
}
E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return "".concat(name, " is outside of buffer bounds");
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return 'The "'.concat(name, '" argument must be of type number. Received type ').concat(typeof actual === "undefined" ? "undefined" : (0, _typeOf._)(actual));
}, TypeError);
E('ERR_OUT_OF_RANGE', function(str, range, input) {
    var msg = 'The value of "'.concat(str, '" is out of range.');
    var received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, _typeOf._)(input)) === 'bigint') {
        received = String(input);
        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = addNumericalSeparator(received);
        received += 'n';
    }
    msg += " It must be ".concat(range, ". Received ").concat(received);
    return msg;
}, RangeError);
function addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
// CHECK FUNCTIONS
// ===============
function checkBounds(buf, offset, byteLength) {
    validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) boundsError(offset, buf.length - (byteLength + 1));
}
function checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        var n = (typeof min === "undefined" ? "undefined" : (0, _typeOf._)(min)) === 'bigint' ? 'n' : '';
        var range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
            else range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength + 1) * 8 - 1).concat(n);
        } else range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
        throw new errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    checkBounds(buf, offset, byteLength);
}
function validateNumber(value, name) {
    if (typeof value !== 'number') throw new errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        validateNumber(value, type);
        throw new errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new errors.ERR_OUT_OF_RANGE(type || 'offset', ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
}
// HELPER FUNCTIONS
// ================
var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace(INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    var i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance(obj, type) {
    return (0, _instanceof._)(obj, type) || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? BufferBigIntNotDefined : fn;
}
function BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_inherits":"2sfqW","@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_type_of":"iFJdx","936d7d40ee51556e":"3s4Of","a9454e8447bbf491":"7UiJ8"}],"3s4Of":[function(require,module,exports,__globalThis) {
'use strict';
exports.byteLength = byteLength;
exports.toByteArray = toByteArray;
exports.fromByteArray = fromByteArray;
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var i = 0, len = code.length; i < len; ++i){
    lookup[i] = code[i];
    revLookup[code.charCodeAt(i)] = i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62;
revLookup['_'.charCodeAt(0)] = 63;
function getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function byteLength(b64) {
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function _byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function toByteArray(b64) {
    var tmp;
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function tripletToBase64(num) {
    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}
function encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push(tripletToBase64(tmp));
    }
    return output.join('');
}
function fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

},{}],"7UiJ8":[function(require,module,exports,__globalThis) {
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ exports.read = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
exports.write = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

},{}],"1Dsnx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isApiGatewayUrl", function() {
    return isApiGatewayUrl;
});
var isApiGatewayUrl = function(url) {
    return [
        '/gateway/api'
    ].includes(url);
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"huopn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return truncate;
});
function truncate(text, maxLength) {
    if (!text || !maxLength) return text;
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8sA6v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactIntl = require("react-intl");
var _standardButton = require("@atlaskit/button/standard-button");
var _standardButtonDefault = parcelHelpers.interopDefault(_standardButton);
var _checkbox = require("@atlaskit/checkbox");
var _form = require("@atlaskit/form");
var _formDefault = parcelHelpers.interopDefault(_form);
var _link = require("@atlaskit/link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _modalDialog = require("@atlaskit/modal-dialog");
var _modalDialogDefault = parcelHelpers.interopDefault(_modalDialog);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _sectionMessage = require("@atlaskit/section-message");
var _sectionMessageDefault = parcelHelpers.interopDefault(_sectionMessage);
var _select = require("@atlaskit/select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _textarea = require("@atlaskit/textarea");
var _textareaDefault = parcelHelpers.interopDefault(_textarea);
var _messages = require("../messages");
var _intlProviderWithResolvedMessages = require("./IntlProviderWithResolvedMessages");
var LinkWrapper = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            paddingInlineStart: "var(--ds-space-300, 24px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginInlineStart: "var(--ds-space-050, 4px)"
        },
        children: children
    });
};
var FeedbackForm = function(param) {
    var _param_showTypeField = param.showTypeField, showTypeField = _param_showTypeField === void 0 ? true : _param_showTypeField, _param_showDefaultTextFields = param.showDefaultTextFields, showDefaultTextFields = _param_showDefaultTextFields === void 0 ? true : _param_showDefaultTextFields, customContent = param.customContent, onClose = param.onClose, onSubmit = param.onSubmit, feedbackTitle = param.feedbackTitle, feedbackTitleDetails = param.feedbackTitleDetails, feedbackGroupLabels = param.feedbackGroupLabels, summaryPlaceholder = param.summaryPlaceholder, canBeContactedLabel = param.canBeContactedLabel, canBeContactedLink = param.canBeContactedLink, enrolInResearchLabel = param.enrolInResearchLabel, enrolInResearchLink = param.enrolInResearchLink, submitButtonLabel = param.submitButtonLabel, cancelButtonLabel = param.cancelButtonLabel, anonymousFeedback = param.anonymousFeedback, hasDescriptionDefaultValue = param.hasDescriptionDefaultValue, selectLabel = param.selectLabel, customTextAreaLabel = param.customTextAreaLabel, _param_customFeedbackOptions = param.customFeedbackOptions, customFeedbackOptions = _param_customFeedbackOptions === void 0 ? [] : _param_customFeedbackOptions, shouldReturnFocusRef = param.shouldReturnFocusRef, disableSubmitButton = param.disableSubmitButton, _param_showRequiredFieldsSummary = param.showRequiredFieldsSummary, showRequiredFieldsSummary = _param_showRequiredFieldsSummary === void 0 ? true : _param_showRequiredFieldsSummary;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), canBeContacted = _useState[0], setCanBeContacted = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(''), 2), description = _useState1[0], setDescription = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(false), 2), enrollInResearchGroup = _useState2[0], setEnrollInResearchGroup = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)('empty'), 2), type = _useState3[0], setType = _useState3[1];
    var _useState4 = (0, _slicedToArray._)((0, _react.useState)(false), 2), isSubmitting = _useState4[0], setIsSubmitting = _useState4[1];
    var _useState5 = (0, _slicedToArray._)((0, _react.useState)({}), 2), validationErrors = _useState5[0], setValidationErrors = _useState5[1];
    var formatMessage = (0, _reactIntl.useIntl)().formatMessage;
    var isTypeSelected = function() {
        return type !== 'empty';
    };
    var canShowTextField = isTypeSelected() || !showTypeField;
    var hasDescription = description || hasDescriptionDefaultValue;
    var isDisabled = isSubmitting || disableSubmitButton;
    var getValidationErrors = function() {
        var errors = {};
        // Validate type selection if showTypeField is true
        if (showTypeField && !isTypeSelected()) errors.type = formatMessage((0, _messages.messages).validationErrorTypeRequired);
        // Validate description if showDefaultTextFields is true
        if (showDefaultTextFields && !hasDescription) errors.description = formatMessage((0, _messages.messages).validationErrorDescriptionRequired);
        return errors;
    };
    var getFieldLabels = function(record) {
        var _record_bug, _record_comment, _record_suggestion, _record_question, _record_empty, _record_not_relevant, _record_not_accurate, _record_too_slow, _record_unhelpful_links, _record_other;
        return {
            bug: (record === null || record === void 0 ? void 0 : (_record_bug = record.bug) === null || _record_bug === void 0 ? void 0 : _record_bug.fieldLabel) || formatMessage((0, _messages.messages).formBugLabel),
            comment: (record === null || record === void 0 ? void 0 : (_record_comment = record.comment) === null || _record_comment === void 0 ? void 0 : _record_comment.fieldLabel) || formatMessage((0, _messages.messages).formCommentLabel),
            suggestion: (record === null || record === void 0 ? void 0 : (_record_suggestion = record.suggestion) === null || _record_suggestion === void 0 ? void 0 : _record_suggestion.fieldLabel) || formatMessage((0, _messages.messages).formSuggestionLabel),
            question: (record === null || record === void 0 ? void 0 : (_record_question = record.question) === null || _record_question === void 0 ? void 0 : _record_question.fieldLabel) || formatMessage((0, _messages.messages).formQuestionLabel),
            empty: (record === null || record === void 0 ? void 0 : (_record_empty = record.empty) === null || _record_empty === void 0 ? void 0 : _record_empty.fieldLabel) || formatMessage((0, _messages.messages).formEmptyLabel),
            not_relevant: (record === null || record === void 0 ? void 0 : (_record_not_relevant = record.not_relevant) === null || _record_not_relevant === void 0 ? void 0 : _record_not_relevant.fieldLabel) || formatMessage((0, _messages.messages).formNotRelevantLabel),
            not_accurate: (record === null || record === void 0 ? void 0 : (_record_not_accurate = record.not_accurate) === null || _record_not_accurate === void 0 ? void 0 : _record_not_accurate.fieldLabel) || formatMessage((0, _messages.messages).formNotAccurateLabel),
            too_slow: (record === null || record === void 0 ? void 0 : (_record_too_slow = record.too_slow) === null || _record_too_slow === void 0 ? void 0 : _record_too_slow.fieldLabel) || formatMessage((0, _messages.messages).formTooSlowLabel),
            unhelpful_links: (record === null || record === void 0 ? void 0 : (_record_unhelpful_links = record.unhelpful_links) === null || _record_unhelpful_links === void 0 ? void 0 : _record_unhelpful_links.fieldLabel) || formatMessage((0, _messages.messages).formUnhelpfulLinksLabel),
            other: (record === null || record === void 0 ? void 0 : (_record_other = record.other) === null || _record_other === void 0 ? void 0 : _record_other.fieldLabel) || formatMessage((0, _messages.messages).formOtherLabel)
        };
    };
    var getSelectOptions = function(record) {
        var _record_question, _record_comment, _record_bug, _record_suggestion;
        return [
            {
                label: (record === null || record === void 0 ? void 0 : (_record_question = record.question) === null || _record_question === void 0 ? void 0 : _record_question.selectOptionLabel) || formatMessage((0, _messages.messages).selectionOptionQuestionLabel),
                value: 'question'
            },
            {
                label: (record === null || record === void 0 ? void 0 : (_record_comment = record.comment) === null || _record_comment === void 0 ? void 0 : _record_comment.selectOptionLabel) || formatMessage((0, _messages.messages).selectionOptionCommentLabel),
                value: 'comment'
            },
            {
                label: (record === null || record === void 0 ? void 0 : (_record_bug = record.bug) === null || _record_bug === void 0 ? void 0 : _record_bug.selectOptionLabel) || formatMessage((0, _messages.messages).selectionOptionBugLabel),
                value: 'bug'
            },
            {
                label: (record === null || record === void 0 ? void 0 : (_record_suggestion = record.suggestion) === null || _record_suggestion === void 0 ? void 0 : _record_suggestion.selectOptionLabel) || formatMessage((0, _messages.messages).selectionOptionSuggestionLabel),
                value: 'suggestion'
            }
        ];
    };
    var getDefaultPlaceholder = function(record) {
        var _record_empty;
        return (record === null || record === void 0 ? void 0 : (_record_empty = record.empty) === null || _record_empty === void 0 ? void 0 : _record_empty.selectOptionLabel) || formatMessage((0, _messages.messages).selectionOptionDefaultPlaceholder);
    };
    var focusRef = (0, _react.useRef)();
    var selectOptions = customFeedbackOptions.length > 0 ? customFeedbackOptions : getSelectOptions(feedbackGroupLabels);
    var renderContactLabelAppify = function() {
        if ((0, _platformFeatureFlags.fg)('jfp_a11y_team_feedback_collector_nested_elements')) return (0, _messages.messages).canBeContactedLabelAppifyWithoutLink;
        return (0, _messages.messages).canBeContactedLabelAppify;
    };
    var renderContactLabel = function() {
        if ((0, _platformFeatureFlags.fg)('jfp_a11y_team_feedback_collector_nested_elements')) return (0, _messages.messages).canBeContactedLabelWithoutLink;
        return (0, _messages.messages).canBeContactedLabel;
    };
    var requiredFieldsSummary = // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            color: "var(--ds-text-subtle, #505258)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginBottom: "var(--ds-space-300, 24px)"
        },
        children: [
            formatMessage((0, _messages.messages).requiredFieldsSummary),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.RequiredAsterisk), {})
        ]
    });
    var feedbackIsAnonymous = // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
        children: formatMessage((0, _messages.messages).feedbackIsAnonymous)
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalDialogDefault.default), {
        shouldCloseOnOverlayClick: false,
        onClose: onClose,
        testId: "feedbackCollectorModalDialog",
        shouldReturnFocus: shouldReturnFocusRef,
        shouldScrollInViewport: true,
        children: (0, _platformFeatureFlags.fg)('platform-design_system_team-form_conversion') ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _formDefault.default), {
            onSubmit: function() {
                return (0, _asyncToGenerator._)(function() {
                    var errors;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                errors = getValidationErrors();
                                if (Object.keys(errors).length > 0) {
                                    setValidationErrors(errors);
                                    return [
                                        2
                                    ];
                                }
                                setIsSubmitting(true);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    ,
                                    3,
                                    4
                                ]);
                                return [
                                    4,
                                    onSubmit({
                                        canBeContacted: canBeContacted,
                                        description: description,
                                        enrollInResearchGroup: enrollInResearchGroup,
                                        type: type
                                    })
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                setIsSubmitting(false);
                                return [
                                    7
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalDialog.ModalHeader), {
                    hasCloseButton: true,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalDialog.ModalTitle), {
                        children: feedbackTitle || /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactIntl.FormattedMessage), (0, _objectSpread._)({}, (0, _messages.messages).feedbackTitle))
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _modalDialog.ModalBody), {
                    children: [
                        (0, _platformFeatureFlags.fg)('ak_feedback_collector_hide_required_summary') ? showRequiredFieldsSummary && requiredFieldsSummary : requiredFieldsSummary,
                        feedbackTitleDetails,
                        customContent,
                        showTypeField ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Field), {
                            name: "topic",
                            label: selectLabel || formatMessage((0, _messages.messages).selectionOptionDefaultLabel),
                            isRequired: true,
                            children: function(_param) {
                                var id = _param.fieldProps.id, restProps = (0, _objectWithoutProperties._)(_param.fieldProps, [
                                    "id"
                                ]);
                                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, restProps), {
                                            onChange: function(option) {
                                                if (!option || (0, _instanceof._)(option, Array)) return;
                                                setType(option.value);
                                                if (validationErrors.type) setValidationErrors(function(prev) {
                                                    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, prev), {
                                                        type: undefined
                                                    });
                                                });
                                            },
                                            menuPortalTarget: document.body,
                                            styles: {
                                                menuPortal: function(base) {
                                                    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, base), {
                                                        zIndex: 9999
                                                    });
                                                }
                                            },
                                            options: selectOptions,
                                            // @ts-ignore
                                            ref: focusRef,
                                            placeholder: getDefaultPlaceholder(feedbackGroupLabels),
                                            inputId: id
                                        })),
                                        validationErrors.type && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.ErrorMessage), {
                                            children: validationErrors.type
                                        })
                                    ]
                                });
                            }
                        }) : null,
                        showDefaultTextFields && canShowTextField && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Field), {
                                    label: showTypeField ? getFieldLabels(feedbackGroupLabels)[type] : customTextAreaLabel || formatMessage((0, _messages.messages).defaultCustomTextAreaLabel),
                                    isRequired: true,
                                    name: "description",
                                    children: function(param) {
                                        var fieldProps = param.fieldProps;
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textareaDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, fieldProps), {
                                                    name: "foo",
                                                    minimumRows: 6,
                                                    placeholder: summaryPlaceholder || undefined,
                                                    onChange: function(e) {
                                                        setDescription(e.target.value);
                                                        if (validationErrors.description) setValidationErrors(function(prev) {
                                                            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, prev), {
                                                                description: undefined
                                                            });
                                                        });
                                                    },
                                                    value: description
                                                })),
                                                validationErrors.description && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.ErrorMessage), {
                                                    children: validationErrors.description
                                                })
                                            ]
                                        });
                                    }
                                }),
                                !anonymousFeedback && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Fieldset), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                                            "aria-hidden": false,
                                            hidden: true,
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactIntl.FormattedMessage), (0, _objectSpread._)({}, (0, _messages.messages).optInOptionsLegend))
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Field), {
                                            name: "can-be-contacted",
                                            children: function(param) {
                                                var fieldProps = param.fieldProps;
                                                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkbox.Checkbox), (0, _objectSpreadProps._)((0, _objectSpread._)({}, fieldProps), {
                                                            "aria-describedby": undefined,
                                                            label: canBeContactedLabel || /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactIntl.FormattedMessage), (0, _objectSpread._)({}, (0, _platformFeatureFlags.fg)('product-terminology-refresh') ? renderContactLabelAppify() : renderContactLabel(), !(0, _platformFeatureFlags.fg)('jfp_a11y_team_feedback_collector_nested_elements') && {
                                                                values: {
                                                                    a: function(chunks) {
                                                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
                                                                            href: "https://www.atlassian.com/legal/privacy-policy",
                                                                            target: "_blank",
                                                                            children: chunks
                                                                        });
                                                                    }
                                                                }
                                                            })),
                                                            onChange: function(event) {
                                                                return setCanBeContacted(event.target.checked);
                                                            }
                                                        })),
                                                        canBeContactedLabel && canBeContactedLink && (0, _platformFeatureFlags.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, _jsxRuntime.jsx)(LinkWrapper, {
                                                            children: canBeContactedLink
                                                        }),
                                                        !canBeContactedLabel && (0, _platformFeatureFlags.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, _jsxRuntime.jsx)(LinkWrapper, {
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
                                                                href: "https://www.atlassian.com/legal/privacy-policy",
                                                                target: "_blank",
                                                                children: formatMessage((0, _messages.messages).privacyPolicy)
                                                            })
                                                        })
                                                    ]
                                                });
                                            }
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Field), {
                                            name: "enroll-in-research-group",
                                            children: function(param) {
                                                var fieldProps = param.fieldProps;
                                                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkbox.Checkbox), (0, _objectSpreadProps._)((0, _objectSpread._)({}, fieldProps), {
                                                            "aria-describedby": undefined,
                                                            label: enrolInResearchLabel || formatMessage((0, _messages.messages).enrolInResearchLabel),
                                                            onChange: function(event) {
                                                                return setEnrollInResearchGroup(event.target.checked);
                                                            }
                                                        })),
                                                        enrolInResearchLabel && enrolInResearchLink && (0, _platformFeatureFlags.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, _jsxRuntime.jsx)(LinkWrapper, {
                                                            children: enrolInResearchLink
                                                        })
                                                    ]
                                                });
                                            }
                                        })
                                    ]
                                }) || /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Field), {
                                        name: 'anonymousFeedback',
                                        children: function() {
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sectionMessageDefault.default), {
                                                title: formatMessage((0, _messages.messages).feedbackIsAnonymousTitle),
                                                appearance: 'information',
                                                children: feedbackIsAnonymous
                                            });
                                        }
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _modalDialog.ModalFooter), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _standardButtonDefault.default), {
                            appearance: "subtle",
                            onClick: onClose,
                            children: cancelButtonLabel || /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactIntl.FormattedMessage), (0, _objectSpread._)({}, (0, _messages.messages).cancelButtonLabel))
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _standardButtonDefault.default), {
                            appearance: "primary",
                            type: "submit",
                            isDisabled: isSubmitting || isDisabled,
                            testId: "feedbackCollectorSubmitBtn",
                            children: submitButtonLabel || /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactIntl.FormattedMessage), (0, _objectSpread._)({}, (0, _messages.messages).submitButtonLabel))
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formDefault.default), {
            onSubmit: function() {
                return (0, _asyncToGenerator._)(function() {
                    var errors;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                errors = getValidationErrors();
                                if (Object.keys(errors).length > 0) {
                                    setValidationErrors(errors);
                                    return [
                                        2
                                    ];
                                }
                                setIsSubmitting(true);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    ,
                                    3,
                                    4
                                ]);
                                return [
                                    4,
                                    onSubmit({
                                        canBeContacted: canBeContacted,
                                        description: description,
                                        enrollInResearchGroup: enrollInResearchGroup,
                                        type: type
                                    })
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                setIsSubmitting(false);
                                return [
                                    7
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            children: function(param) {
                var formProps = param.formProps;
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", (0, _objectSpreadProps._)((0, _objectSpread._)({}, formProps), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalDialog.ModalHeader), {
                            hasCloseButton: true,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalDialog.ModalTitle), {
                                children: feedbackTitle || /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactIntl.FormattedMessage), (0, _objectSpread._)({}, (0, _messages.messages).feedbackTitle))
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _modalDialog.ModalBody), {
                            children: [
                                (0, _platformFeatureFlags.fg)('ak_feedback_collector_hide_required_summary') ? showRequiredFieldsSummary && requiredFieldsSummary : requiredFieldsSummary,
                                feedbackTitleDetails,
                                customContent,
                                showTypeField ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Field), {
                                    name: "topic",
                                    label: selectLabel || formatMessage((0, _messages.messages).selectionOptionDefaultLabel),
                                    isRequired: true,
                                    children: function(_param) {
                                        var id = _param.fieldProps.id, restProps = (0, _objectWithoutProperties._)(_param.fieldProps, [
                                            "id"
                                        ]);
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, restProps), {
                                                    onChange: function(option) {
                                                        if (!option || (0, _instanceof._)(option, Array)) return;
                                                        setType(option.value);
                                                        if (validationErrors.type) setValidationErrors(function(prev) {
                                                            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, prev), {
                                                                type: undefined
                                                            });
                                                        });
                                                    },
                                                    menuPortalTarget: document.body,
                                                    styles: {
                                                        menuPortal: function(base) {
                                                            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, base), {
                                                                zIndex: 9999
                                                            });
                                                        }
                                                    },
                                                    options: selectOptions,
                                                    // @ts-ignore
                                                    ref: focusRef,
                                                    placeholder: getDefaultPlaceholder(feedbackGroupLabels),
                                                    inputId: id
                                                })),
                                                validationErrors.type && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.ErrorMessage), {
                                                    children: validationErrors.type
                                                })
                                            ]
                                        });
                                    }
                                }) : null,
                                showDefaultTextFields && canShowTextField && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Field), {
                                            label: showTypeField ? getFieldLabels(feedbackGroupLabels)[type] : customTextAreaLabel || formatMessage((0, _messages.messages).defaultCustomTextAreaLabel),
                                            isRequired: true,
                                            name: "description",
                                            children: function(param) {
                                                var fieldProps = param.fieldProps;
                                                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textareaDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, fieldProps), {
                                                            name: "foo",
                                                            minimumRows: 6,
                                                            placeholder: summaryPlaceholder || undefined,
                                                            onChange: function(e) {
                                                                setDescription(e.target.value);
                                                                if (validationErrors.description) setValidationErrors(function(prev) {
                                                                    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, prev), {
                                                                        description: undefined
                                                                    });
                                                                });
                                                            },
                                                            value: description
                                                        })),
                                                        validationErrors.description && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.ErrorMessage), {
                                                            children: validationErrors.description
                                                        })
                                                    ]
                                                });
                                            }
                                        }),
                                        !anonymousFeedback && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Fieldset), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                                                    "aria-hidden": false,
                                                    hidden: true,
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactIntl.FormattedMessage), (0, _objectSpread._)({}, (0, _messages.messages).optInOptionsLegend))
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Field), {
                                                    name: "can-be-contacted",
                                                    children: function(param) {
                                                        var fieldProps = param.fieldProps;
                                                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkbox.Checkbox), (0, _objectSpreadProps._)((0, _objectSpread._)({}, fieldProps), {
                                                                    "aria-describedby": undefined,
                                                                    label: canBeContactedLabel || /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactIntl.FormattedMessage), (0, _objectSpread._)({}, (0, _platformFeatureFlags.fg)('product-terminology-refresh') ? renderContactLabelAppify() : renderContactLabel(), !(0, _platformFeatureFlags.fg)('jfp_a11y_team_feedback_collector_nested_elements') && {
                                                                        values: {
                                                                            a: function(chunks) {
                                                                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
                                                                                    href: "https://www.atlassian.com/legal/privacy-policy",
                                                                                    target: "_blank",
                                                                                    children: chunks
                                                                                });
                                                                            }
                                                                        }
                                                                    })),
                                                                    onChange: function(event) {
                                                                        return setCanBeContacted(event.target.checked);
                                                                    }
                                                                })),
                                                                canBeContactedLabel && canBeContactedLink && (0, _platformFeatureFlags.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, _jsxRuntime.jsx)(LinkWrapper, {
                                                                    children: canBeContactedLink
                                                                }),
                                                                !canBeContactedLabel && (0, _platformFeatureFlags.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, _jsxRuntime.jsx)(LinkWrapper, {
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
                                                                        href: "https://www.atlassian.com/legal/privacy-policy",
                                                                        target: "_blank",
                                                                        children: formatMessage((0, _messages.messages).privacyPolicy)
                                                                    })
                                                                })
                                                            ]
                                                        });
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Field), {
                                                    name: "enroll-in-research-group",
                                                    children: function(param) {
                                                        var fieldProps = param.fieldProps;
                                                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkbox.Checkbox), (0, _objectSpreadProps._)((0, _objectSpread._)({}, fieldProps), {
                                                                    "aria-describedby": undefined,
                                                                    label: enrolInResearchLabel || formatMessage((0, _messages.messages).enrolInResearchLabel),
                                                                    onChange: function(event) {
                                                                        return setEnrollInResearchGroup(event.target.checked);
                                                                    }
                                                                })),
                                                                enrolInResearchLabel && enrolInResearchLink && (0, _platformFeatureFlags.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, _jsxRuntime.jsx)(LinkWrapper, {
                                                                    children: enrolInResearchLink
                                                                })
                                                            ]
                                                        });
                                                    }
                                                })
                                            ]
                                        }) || /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Field), {
                                                name: 'anonymousFeedback',
                                                children: function() {
                                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sectionMessageDefault.default), {
                                                        title: formatMessage((0, _messages.messages).feedbackIsAnonymousTitle),
                                                        appearance: 'information',
                                                        children: feedbackIsAnonymous
                                                    });
                                                }
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _modalDialog.ModalFooter), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _standardButtonDefault.default), {
                                    appearance: "subtle",
                                    onClick: onClose,
                                    children: cancelButtonLabel || /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactIntl.FormattedMessage), (0, _objectSpread._)({}, (0, _messages.messages).cancelButtonLabel))
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _standardButtonDefault.default), {
                                    appearance: "primary",
                                    type: "submit",
                                    isDisabled: isSubmitting || isDisabled,
                                    testId: "feedbackCollectorSubmitBtn",
                                    children: submitButtonLabel || /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactIntl.FormattedMessage), (0, _objectSpread._)({}, (0, _messages.messages).submitButtonLabel))
                                })
                            ]
                        })
                    ]
                }));
            }
        })
    });
};
var FeedbackFormWithIntl = function(_param) {
    var locale = _param.locale, props = (0, _objectWithoutProperties._)(_param, [
        "locale"
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _intlProviderWithResolvedMessages.IntlProviderWithResolvedMessages), {
        locale: locale,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(FeedbackForm, (0, _objectSpread._)({}, props))
    });
};
exports.default = FeedbackFormWithIntl;

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_ts_generator":"78Tqx","react/jsx-runtime":"bGvcw","react":"ltHCL","react-intl":"f41fF","@atlaskit/button/standard-button":"jfzMr","@atlaskit/checkbox":"6T4j0","@atlaskit/form":"1ZYq3","@atlaskit/link":"1WBY4","@atlaskit/modal-dialog":"6s9iq","@atlaskit/platform-feature-flags":"kO5t9","@atlaskit/section-message":"66JzH","@atlaskit/select":"7RKck","@atlaskit/textarea":"jkntP","../messages":"1UW1R","./IntlProviderWithResolvedMessages":"lbRXm","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"f41fF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createIntlCache", function() {
    return 0, _intl.createIntlCache;
});
parcelHelpers.export(exports, "UnsupportedFormatterError", function() {
    return 0, _intl.UnsupportedFormatterError;
});
parcelHelpers.export(exports, "InvalidConfigError", function() {
    return 0, _intl.InvalidConfigError;
});
parcelHelpers.export(exports, "MissingDataError", function() {
    return 0, _intl.MissingDataError;
});
parcelHelpers.export(exports, "MessageFormatError", function() {
    return 0, _intl.MessageFormatError;
});
parcelHelpers.export(exports, "MissingTranslationError", function() {
    return 0, _intl.MissingTranslationError;
});
parcelHelpers.export(exports, "ReactIntlErrorCode", function() {
    return 0, _intl.IntlErrorCode;
});
parcelHelpers.export(exports, "ReactIntlError", function() {
    return 0, _intl.IntlError;
});
parcelHelpers.export(exports, "FormattedNumberParts", function() {
    return 0, _createFormattedComponent.FormattedNumberParts;
});
parcelHelpers.export(exports, "FormattedListParts", function() {
    return 0, _createFormattedComponent.FormattedListParts;
});
parcelHelpers.export(exports, "FormattedDateTimeRange", function() {
    return 0, _dateTimeRangeDefault.default;
});
parcelHelpers.export(exports, "FormattedMessage", function() {
    return 0, _messageDefault.default;
});
parcelHelpers.export(exports, "FormattedPlural", function() {
    return 0, _pluralDefault.default;
});
parcelHelpers.export(exports, "FormattedRelativeTime", function() {
    return 0, _relativeDefault.default;
});
parcelHelpers.export(exports, "IntlContext", function() {
    return 0, _injectIntl.Context;
});
parcelHelpers.export(exports, "IntlProvider", function() {
    return 0, _providerDefault.default;
});
parcelHelpers.export(exports, "RawIntlProvider", function() {
    return 0, _injectIntl.Provider;
});
parcelHelpers.export(exports, "createIntl", function() {
    return 0, _createIntl.createIntl;
});
parcelHelpers.export(exports, "injectIntl", function() {
    return 0, _injectIntlDefault.default;
});
parcelHelpers.export(exports, "useIntl", function() {
    return 0, _useIntlDefault.default;
});
parcelHelpers.export(exports, "defineMessages", function() {
    return defineMessages;
});
parcelHelpers.export(exports, "defineMessage", function() {
    return defineMessage;
});
parcelHelpers.export(exports, "FormattedDate", function() {
    return FormattedDate;
});
parcelHelpers.export(exports, "FormattedTime", function() {
    return FormattedTime;
});
parcelHelpers.export(exports, "FormattedNumber", function() {
    return FormattedNumber;
});
parcelHelpers.export(exports, "FormattedList", function() {
    return FormattedList;
});
parcelHelpers.export(exports, "FormattedDisplayName", function() {
    return FormattedDisplayName;
});
parcelHelpers.export(exports, "FormattedDateParts", function() {
    return FormattedDateParts;
});
parcelHelpers.export(exports, "FormattedTimeParts", function() {
    return FormattedTimeParts;
});
var _createFormattedComponent = require("./src/components/createFormattedComponent");
var _injectIntl = require("./src/components/injectIntl");
var _injectIntlDefault = parcelHelpers.interopDefault(_injectIntl);
var _useIntl = require("./src/components/useIntl");
var _useIntlDefault = parcelHelpers.interopDefault(_useIntl);
var _provider = require("./src/components/provider");
var _providerDefault = parcelHelpers.interopDefault(_provider);
var _createIntl = require("./src/components/createIntl");
var _relative = require("./src/components/relative");
var _relativeDefault = parcelHelpers.interopDefault(_relative);
var _plural = require("./src/components/plural");
var _pluralDefault = parcelHelpers.interopDefault(_plural);
var _message = require("./src/components/message");
var _messageDefault = parcelHelpers.interopDefault(_message);
var _dateTimeRange = require("./src/components/dateTimeRange");
var _dateTimeRangeDefault = parcelHelpers.interopDefault(_dateTimeRange);
var _intl = require("@formatjs/intl");
function defineMessages(msgs) {
    return msgs;
}
function defineMessage(msg) {
    return msg;
}
var FormattedDate = (0, _createFormattedComponent.createFormattedComponent)('formatDate');
var FormattedTime = (0, _createFormattedComponent.createFormattedComponent)('formatTime');
var FormattedNumber = (0, _createFormattedComponent.createFormattedComponent)('formatNumber');
var FormattedList = (0, _createFormattedComponent.createFormattedComponent)('formatList');
var FormattedDisplayName = (0, _createFormattedComponent.createFormattedComponent)('formatDisplayName');
var FormattedDateParts = (0, _createFormattedComponent.createFormattedDateTimePartsComponent)('formatDate');
var FormattedTimeParts = (0, _createFormattedComponent.createFormattedDateTimePartsComponent)('formatTime');

},{"./src/components/createFormattedComponent":"bS5Zp","./src/components/injectIntl":false,"./src/components/useIntl":"jQUM3","./src/components/provider":"b7DFj","./src/components/createIntl":false,"./src/components/relative":false,"./src/components/plural":false,"./src/components/message":"gfNgD","./src/components/dateTimeRange":false,"@formatjs/intl":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bS5Zp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormattedNumberParts", function() {
    return FormattedNumberParts;
});
parcelHelpers.export(exports, "FormattedListParts", function() {
    return FormattedListParts;
});
parcelHelpers.export(exports, "createFormattedDateTimePartsComponent", function() {
    return createFormattedDateTimePartsComponent;
});
parcelHelpers.export(exports, "createFormattedComponent", function() {
    return createFormattedComponent;
});
var _tslib = require("tslib");
var _react = require("react");
var _useIntl = require("./useIntl");
var _useIntlDefault = parcelHelpers.interopDefault(_useIntl);
var DisplayName;
(function(DisplayName) {
    DisplayName["formatDate"] = "FormattedDate";
    DisplayName["formatTime"] = "FormattedTime";
    DisplayName["formatNumber"] = "FormattedNumber";
    DisplayName["formatList"] = "FormattedList";
    // Note that this DisplayName is the locale display name, not to be confused with
    // the name of the enum, which is for React component display name in dev tools.
    DisplayName["formatDisplayName"] = "FormattedDisplayName";
})(DisplayName || (DisplayName = {}));
var DisplayNameParts;
(function(DisplayNameParts) {
    DisplayNameParts["formatDate"] = "FormattedDateParts";
    DisplayNameParts["formatTime"] = "FormattedTimeParts";
    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
    DisplayNameParts["formatList"] = "FormattedListParts";
})(DisplayNameParts || (DisplayNameParts = {}));
var FormattedNumberParts = function FormattedNumberParts(props) {
    var intl = (0, _useIntlDefault.default)();
    var value = props.value, children = props.children, formatProps = (0, _tslib.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatNumberToParts(value, formatProps));
};
FormattedNumberParts.displayName = 'FormattedNumberParts';
var FormattedListParts = function FormattedListParts(props) {
    var intl = (0, _useIntlDefault.default)();
    var value = props.value, children = props.children, formatProps = (0, _tslib.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatListToParts(value, formatProps));
};
FormattedNumberParts.displayName = 'FormattedNumberParts';
function createFormattedDateTimePartsComponent(name) {
    var ComponentParts = function ComponentParts(props) {
        var intl = (0, _useIntlDefault.default)();
        var value = props.value, children = props.children, formatProps = (0, _tslib.__rest)(props, [
            "value",
            "children"
        ]);
        var date = typeof value === 'string' ? new Date(value || 0) : value;
        var formattedParts = name === 'formatDate' ? intl.formatDateToParts(date, formatProps) : intl.formatTimeToParts(date, formatProps);
        return children(formattedParts);
    };
    ComponentParts.displayName = DisplayNameParts[name];
    return ComponentParts;
}
function createFormattedComponent(name) {
    var Component = function Component(props) {
        var intl = (0, _useIntlDefault.default)();
        var value = props.value, children = props.children, formatProps = (0, _tslib.__rest)(props, [
            "value",
            "children"
        ]);
        // TODO: fix TS type definition for localeMatcher upstream
        var formattedValue = intl[name](value, formatProps);
        if (typeof children === 'function') return children(formattedValue);
        var Text = intl.textComponent || _react.Fragment;
        return _react.createElement(Text, null, formattedValue);
    };
    Component.displayName = DisplayName[name];
    return Component;
}

},{"tslib":"6MhhU","react":"ltHCL","./useIntl":"jQUM3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jQUM3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return useIntl;
});
var _react = require("react");
var _utils = require("../utils");
var _injectIntl = require("./injectIntl");
function useIntl() {
    var intl = _react.useContext((0, _injectIntl.Context));
    (0, _utils.invariantIntlContext)(intl);
    return intl;
}

},{"react":"ltHCL","../utils":"88Xfc","./injectIntl":"jwY9c","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"88Xfc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "invariantIntlContext", function() {
    return invariantIntlContext;
});
parcelHelpers.export(exports, "DEFAULT_INTL_CONFIG", function() {
    return DEFAULT_INTL_CONFIG;
});
/**
 * Takes a `formatXMLElementFn`, and composes it in function, which passes
 * argument `parts` through, assigning unique key to each part, to prevent
 * "Each child in a list should have a unique "key"" React error.
 * @param formatXMLElementFn
 */ parcelHelpers.export(exports, "assignUniqueKeysToParts", function() {
    return assignUniqueKeysToParts;
});
parcelHelpers.export(exports, "shallowEqual", function() {
    return shallowEqual;
});
var _tslib = require("tslib");
var _react = require("react");
var _ecma402Abstract = require("@formatjs/ecma402-abstract");
var _intl = require("@formatjs/intl");
function invariantIntlContext(intl) {
    (0, _ecma402Abstract.invariant)(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var DEFAULT_INTL_CONFIG = (0, _tslib.__assign)((0, _tslib.__assign)({}, (0, _intl.DEFAULT_INTL_CONFIG)), {
    textComponent: _react.Fragment
});
function assignUniqueKeysToParts(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn(_react.Children.toArray(parts));
    };
}
function shallowEqual(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}

},{"tslib":"6MhhU","react":"ltHCL","@formatjs/ecma402-abstract":"kC5cd","@formatjs/intl":"4jZTM","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kC5cd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_formatToParts", function() {
    return 0, _formatToPartsDefault.default;
});
parcelHelpers.export(exports, "createDataProperty", function() {
    return 0, _utils.createDataProperty;
});
parcelHelpers.export(exports, "defineProperty", function() {
    return 0, _utils.defineProperty;
});
parcelHelpers.export(exports, "getInternalSlot", function() {
    return 0, _utils.getInternalSlot;
});
parcelHelpers.export(exports, "getMagnitude", function() {
    return 0, _utils.getMagnitude;
});
parcelHelpers.export(exports, "getMultiInternalSlots", function() {
    return 0, _utils.getMultiInternalSlots;
});
parcelHelpers.export(exports, "isLiteralPart", function() {
    return 0, _utils.isLiteralPart;
});
parcelHelpers.export(exports, "setInternalSlot", function() {
    return 0, _utils.setInternalSlot;
});
parcelHelpers.export(exports, "setMultiInternalSlots", function() {
    return 0, _utils.setMultiInternalSlots;
});
parcelHelpers.export(exports, "isMissingLocaleDataError", function() {
    return 0, _data.isMissingLocaleDataError;
});
parcelHelpers.export(exports, "createMemoizedDateTimeFormat", function() {
    return 0, _utils.createMemoizedDateTimeFormat;
});
parcelHelpers.export(exports, "createMemoizedListFormat", function() {
    return 0, _utils.createMemoizedListFormat;
});
parcelHelpers.export(exports, "createMemoizedLocale", function() {
    return 0, _utils.createMemoizedLocale;
});
parcelHelpers.export(exports, "createMemoizedNumberFormat", function() {
    return 0, _utils.createMemoizedNumberFormat;
});
parcelHelpers.export(exports, "createMemoizedPluralRules", function() {
    return 0, _utils.createMemoizedPluralRules;
});
parcelHelpers.export(exports, "invariant", function() {
    return 0, _utils.invariant;
});
var _canonicalizeLocaleList = require("./CanonicalizeLocaleList");
parcelHelpers.exportAll(_canonicalizeLocaleList, exports);
var _canonicalizeTimeZoneName = require("./CanonicalizeTimeZoneName");
parcelHelpers.exportAll(_canonicalizeTimeZoneName, exports);
var _coerceOptionsToObject = require("./CoerceOptionsToObject");
parcelHelpers.exportAll(_coerceOptionsToObject, exports);
var _getNumberOption = require("./GetNumberOption");
parcelHelpers.exportAll(_getNumberOption, exports);
var _getOption = require("./GetOption");
parcelHelpers.exportAll(_getOption, exports);
var _getOptionsObject = require("./GetOptionsObject");
parcelHelpers.exportAll(_getOptionsObject, exports);
var _getStringOrBooleanOption = require("./GetStringOrBooleanOption");
parcelHelpers.exportAll(_getStringOrBooleanOption, exports);
var _isSanctionedSimpleUnitIdentifier = require("./IsSanctionedSimpleUnitIdentifier");
parcelHelpers.exportAll(_isSanctionedSimpleUnitIdentifier, exports);
var _isValidTimeZoneName = require("./IsValidTimeZoneName");
parcelHelpers.exportAll(_isValidTimeZoneName, exports);
var _isWellFormedCurrencyCode = require("./IsWellFormedCurrencyCode");
parcelHelpers.exportAll(_isWellFormedCurrencyCode, exports);
var _isWellFormedUnitIdentifier = require("./IsWellFormedUnitIdentifier");
parcelHelpers.exportAll(_isWellFormedUnitIdentifier, exports);
var _applyUnsignedRoundingMode = require("./NumberFormat/ApplyUnsignedRoundingMode");
parcelHelpers.exportAll(_applyUnsignedRoundingMode, exports);
var _collapseNumberRange = require("./NumberFormat/CollapseNumberRange");
parcelHelpers.exportAll(_collapseNumberRange, exports);
var _computeExponent = require("./NumberFormat/ComputeExponent");
parcelHelpers.exportAll(_computeExponent, exports);
var _computeExponentForMagnitude = require("./NumberFormat/ComputeExponentForMagnitude");
parcelHelpers.exportAll(_computeExponentForMagnitude, exports);
var _currencyDigits = require("./NumberFormat/CurrencyDigits");
parcelHelpers.exportAll(_currencyDigits, exports);
var _formatToParts = require("./NumberFormat/format_to_parts");
var _formatToPartsDefault = parcelHelpers.interopDefault(_formatToParts);
var _formatApproximately = require("./NumberFormat/FormatApproximately");
parcelHelpers.exportAll(_formatApproximately, exports);
var _formatNumericRange = require("./NumberFormat/FormatNumericRange");
parcelHelpers.exportAll(_formatNumericRange, exports);
var _formatNumericRangeToParts = require("./NumberFormat/FormatNumericRangeToParts");
parcelHelpers.exportAll(_formatNumericRangeToParts, exports);
var _formatNumericToParts = require("./NumberFormat/FormatNumericToParts");
parcelHelpers.exportAll(_formatNumericToParts, exports);
var _formatNumericToString = require("./NumberFormat/FormatNumericToString");
parcelHelpers.exportAll(_formatNumericToString, exports);
var _getUnsignedRoundingMode = require("./NumberFormat/GetUnsignedRoundingMode");
parcelHelpers.exportAll(_getUnsignedRoundingMode, exports);
var _initializeNumberFormat = require("./NumberFormat/InitializeNumberFormat");
parcelHelpers.exportAll(_initializeNumberFormat, exports);
var _partitionNumberPattern = require("./NumberFormat/PartitionNumberPattern");
parcelHelpers.exportAll(_partitionNumberPattern, exports);
var _partitionNumberRangePattern = require("./NumberFormat/PartitionNumberRangePattern");
parcelHelpers.exportAll(_partitionNumberRangePattern, exports);
var _setNumberFormatDigitOptions = require("./NumberFormat/SetNumberFormatDigitOptions");
parcelHelpers.exportAll(_setNumberFormatDigitOptions, exports);
var _setNumberFormatUnitOptions = require("./NumberFormat/SetNumberFormatUnitOptions");
parcelHelpers.exportAll(_setNumberFormatUnitOptions, exports);
var _toRawFixed = require("./NumberFormat/ToRawFixed");
parcelHelpers.exportAll(_toRawFixed, exports);
var _toRawPrecision = require("./NumberFormat/ToRawPrecision");
parcelHelpers.exportAll(_toRawPrecision, exports);
var _partitionPattern = require("./PartitionPattern");
parcelHelpers.exportAll(_partitionPattern, exports);
var _supportedLocales = require("./SupportedLocales");
parcelHelpers.exportAll(_supportedLocales, exports);
var _utils = require("./utils");
var _262 = require("./262");
parcelHelpers.exportAll(_262, exports);
var _data = require("./data");
var _dateTime = require("./types/date-time");
parcelHelpers.exportAll(_dateTime, exports);
var _displaynames = require("./types/displaynames");
parcelHelpers.exportAll(_displaynames, exports);
var _list = require("./types/list");
parcelHelpers.exportAll(_list, exports);
var _number = require("./types/number");
parcelHelpers.exportAll(_number, exports);
var _pluralRules = require("./types/plural-rules");
parcelHelpers.exportAll(_pluralRules, exports);
var _relativeTime = require("./types/relative-time");
parcelHelpers.exportAll(_relativeTime, exports);

},{"./CanonicalizeLocaleList":false,"./CanonicalizeTimeZoneName":false,"./CoerceOptionsToObject":false,"./GetNumberOption":false,"./GetOption":false,"./GetOptionsObject":false,"./GetStringOrBooleanOption":false,"./IsSanctionedSimpleUnitIdentifier":false,"./IsValidTimeZoneName":false,"./IsWellFormedCurrencyCode":false,"./IsWellFormedUnitIdentifier":false,"./NumberFormat/ApplyUnsignedRoundingMode":false,"./NumberFormat/CollapseNumberRange":false,"./NumberFormat/ComputeExponent":false,"./NumberFormat/ComputeExponentForMagnitude":false,"./NumberFormat/CurrencyDigits":false,"./NumberFormat/format_to_parts":false,"./NumberFormat/FormatApproximately":false,"./NumberFormat/FormatNumericRange":false,"./NumberFormat/FormatNumericRangeToParts":false,"./NumberFormat/FormatNumericToParts":false,"./NumberFormat/FormatNumericToString":false,"./NumberFormat/GetUnsignedRoundingMode":false,"./NumberFormat/InitializeNumberFormat":false,"./NumberFormat/PartitionNumberPattern":false,"./NumberFormat/PartitionNumberRangePattern":false,"./NumberFormat/SetNumberFormatDigitOptions":false,"./NumberFormat/SetNumberFormatUnitOptions":false,"./NumberFormat/ToRawFixed":false,"./NumberFormat/ToRawPrecision":false,"./PartitionPattern":false,"./SupportedLocales":false,"./utils":"98X6H","./262":false,"./data":false,"./types/date-time":false,"./types/displaynames":false,"./types/list":false,"./types/number":false,"./types/plural-rules":false,"./types/relative-time":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"98X6H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Cannot do Math.log(x) / Math.log(10) bc if IEEE floating point issue
 * @param x number
 */ parcelHelpers.export(exports, "getMagnitude", function() {
    return getMagnitude;
});
parcelHelpers.export(exports, "repeat", function() {
    return repeat;
});
parcelHelpers.export(exports, "setInternalSlot", function() {
    return setInternalSlot;
});
parcelHelpers.export(exports, "setMultiInternalSlots", function() {
    return setMultiInternalSlots;
});
parcelHelpers.export(exports, "getInternalSlot", function() {
    return getInternalSlot;
});
parcelHelpers.export(exports, "getMultiInternalSlots", function() {
    return getMultiInternalSlots;
});
parcelHelpers.export(exports, "isLiteralPart", function() {
    return isLiteralPart;
});
/*
  17 ECMAScript Standard Built-in Objects:
    Every built-in Function object, including constructors, that is not
    identified as an anonymous function has a name property whose value
    is a String.

    Unless otherwise specified, the name property of a built-in Function
    object, if it exists, has the attributes { [[Writable]]: false,
    [[Enumerable]]: false, [[Configurable]]: true }.
*/ parcelHelpers.export(exports, "defineProperty", function() {
    return defineProperty;
});
/**
 * 7.3.5 CreateDataProperty
 * @param target
 * @param name
 * @param value
 */ parcelHelpers.export(exports, "createDataProperty", function() {
    return createDataProperty;
});
parcelHelpers.export(exports, "UNICODE_EXTENSION_SEQUENCE_REGEX", function() {
    return UNICODE_EXTENSION_SEQUENCE_REGEX;
});
parcelHelpers.export(exports, "invariant", function() {
    return invariant;
});
parcelHelpers.export(exports, "createMemoizedNumberFormat", function() {
    return createMemoizedNumberFormat;
});
parcelHelpers.export(exports, "createMemoizedDateTimeFormat", function() {
    return createMemoizedDateTimeFormat;
});
parcelHelpers.export(exports, "createMemoizedPluralRules", function() {
    return createMemoizedPluralRules;
});
parcelHelpers.export(exports, "createMemoizedLocale", function() {
    return createMemoizedLocale;
});
parcelHelpers.export(exports, "createMemoizedListFormat", function() {
    return createMemoizedListFormat;
});
var _tslib = require("tslib");
var _fastMemoize = require("@formatjs/fast-memoize");
function getMagnitude(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
function repeat(s, times) {
    if (typeof s.repeat === 'function') return s.repeat(times);
    var arr = new Array(times);
    for(var i = 0; i < arr.length; i++)arr[i] = s;
    return arr.join('');
}
function setInternalSlot(map, pl, field, value) {
    if (!map.get(pl)) map.set(pl, Object.create(null));
    var slots = map.get(pl);
    slots[field] = value;
}
function setMultiInternalSlots(map, pl, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var k = _a[_i];
        setInternalSlot(map, pl, k, props[k]);
    }
}
function getInternalSlot(map, pl, field) {
    return getMultiInternalSlots(map, pl, field)[field];
}
function getMultiInternalSlots(map, pl) {
    var fields = [];
    for(var _i = 2; _i < arguments.length; _i++)fields[_i - 2] = arguments[_i];
    var slots = map.get(pl);
    if (!slots) throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    return fields.reduce(function(all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
function isLiteralPart(patternPart) {
    return patternPart.type === 'literal';
}
function defineProperty(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value
    });
}
function createDataProperty(target, name, value) {
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: true,
        writable: true,
        value: value
    });
}
var UNICODE_EXTENSION_SEQUENCE_REGEX = /-u(?:-[0-9a-z]{2,8})+/gi;
function invariant(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}
var createMemoizedNumberFormat = (0, _fastMemoize.memoize)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, _tslib.__spreadArray)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, _fastMemoize.strategies).variadic
});
var createMemoizedDateTimeFormat = (0, _fastMemoize.memoize)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, _tslib.__spreadArray)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, _fastMemoize.strategies).variadic
});
var createMemoizedPluralRules = (0, _fastMemoize.memoize)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.PluralRules).bind.apply(_a, (0, _tslib.__spreadArray)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, _fastMemoize.strategies).variadic
});
var createMemoizedLocale = (0, _fastMemoize.memoize)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.Locale).bind.apply(_a, (0, _tslib.__spreadArray)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, _fastMemoize.strategies).variadic
});
var createMemoizedListFormat = (0, _fastMemoize.memoize)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.ListFormat).bind.apply(_a, (0, _tslib.__spreadArray)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, _fastMemoize.strategies).variadic
});

},{"tslib":"6MhhU","@formatjs/fast-memoize":"iucPL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iucPL":[function(require,module,exports,__globalThis) {
//
// Main
//
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "memoize", function() {
    return memoize;
});
parcelHelpers.export(exports, "strategies", function() {
    return strategies;
});
function memoize(fn, options) {
    var cache = options && options.cache ? options.cache : cacheDefault;
    var serializer = options && options.serializer ? options.serializer : serializerDefault;
    var strategy = options && options.strategy ? options.strategy : strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function monadic(fn, cache, serializer, arg) {
    var cacheKey = isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? monadic : variadic;
    return assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function strategyVariadic(fn, options) {
    return assemble(fn, this, variadic, options.cache.create(), options.serializer);
}
function strategyMonadic(fn, options) {
    return assemble(fn, this, monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var serializerDefault = function serializerDefault() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new ObjectWithoutPrototypeCache();
    }
};
var strategies = {
    variadic: strategyVariadic,
    monadic: strategyMonadic
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4jZTM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createIntlCache", function() {
    return 0, _utils.createIntlCache;
});
parcelHelpers.export(exports, "filterProps", function() {
    return 0, _utils.filterProps;
});
parcelHelpers.export(exports, "DEFAULT_INTL_CONFIG", function() {
    return 0, _utils.DEFAULT_INTL_CONFIG;
});
parcelHelpers.export(exports, "createFormatters", function() {
    return 0, _utils.createFormatters;
});
parcelHelpers.export(exports, "getNamedFormat", function() {
    return 0, _utils.getNamedFormat;
});
parcelHelpers.export(exports, "formatMessage", function() {
    return 0, _message.formatMessage;
});
parcelHelpers.export(exports, "formatDate", function() {
    return 0, _dateTime.formatDate;
});
parcelHelpers.export(exports, "formatDateToParts", function() {
    return 0, _dateTime.formatDateToParts;
});
parcelHelpers.export(exports, "formatTime", function() {
    return 0, _dateTime.formatTime;
});
parcelHelpers.export(exports, "formatTimeToParts", function() {
    return 0, _dateTime.formatTimeToParts;
});
parcelHelpers.export(exports, "formatDisplayName", function() {
    return 0, _displayName.formatDisplayName;
});
parcelHelpers.export(exports, "formatList", function() {
    return 0, _list.formatList;
});
parcelHelpers.export(exports, "formatPlural", function() {
    return 0, _plural.formatPlural;
});
parcelHelpers.export(exports, "formatRelativeTime", function() {
    return 0, _relativeTime.formatRelativeTime;
});
parcelHelpers.export(exports, "formatNumber", function() {
    return 0, _number.formatNumber;
});
parcelHelpers.export(exports, "formatNumberToParts", function() {
    return 0, _number.formatNumberToParts;
});
parcelHelpers.export(exports, "createIntl", function() {
    return 0, _createIntl.createIntl;
});
parcelHelpers.export(exports, "defineMessages", function() {
    return defineMessages;
});
parcelHelpers.export(exports, "defineMessage", function() {
    return defineMessage;
});
var _types = require("./src/types");
parcelHelpers.exportAll(_types, exports);
var _utils = require("./src/utils");
var _error = require("./src/error");
parcelHelpers.exportAll(_error, exports);
var _message = require("./src/message");
var _dateTime = require("./src/dateTime");
var _displayName = require("./src/displayName");
var _list = require("./src/list");
var _plural = require("./src/plural");
var _relativeTime = require("./src/relativeTime");
var _number = require("./src/number");
var _createIntl = require("./src/create-intl");
function defineMessages(msgs) {
    return msgs;
}
function defineMessage(msg) {
    return msg;
}

},{"./src/types":false,"./src/utils":"iIYJ2","./src/error":false,"./src/message":"dhjzu","./src/dateTime":false,"./src/displayName":false,"./src/list":false,"./src/plural":false,"./src/relativeTime":false,"./src/number":false,"./src/create-intl":"hBk8u","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iIYJ2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "filterProps", function() {
    return filterProps;
});
parcelHelpers.export(exports, "DEFAULT_INTL_CONFIG", function() {
    return DEFAULT_INTL_CONFIG;
});
parcelHelpers.export(exports, "createIntlCache", function() {
    return createIntlCache;
});
/**
 * Create intl formatters and populate cache
 * @param cache explicit cache to prevent leaking memory
 */ parcelHelpers.export(exports, "createFormatters", function() {
    return createFormatters;
});
parcelHelpers.export(exports, "getNamedFormat", function() {
    return getNamedFormat;
});
var _tslib = require("tslib");
var _intlMessageformat = require("intl-messageformat");
var _fastMemoize = require("@formatjs/fast-memoize");
var _error = require("./error");
function filterProps(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var defaultErrorHandler = function defaultErrorHandler(error) {};
var defaultWarnHandler = function defaultWarnHandler(warning) {};
var DEFAULT_INTL_CONFIG = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: 'en',
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: defaultErrorHandler,
    onWarn: defaultWarnHandler
};
function createIntlCache() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function createFastMemoizeCache(store) {
    return {
        create: function create() {
            return {
                get: function get(key) {
                    return store[key];
                },
                set: function set(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function createFormatters(cache) {
    if (cache === void 0) cache = createIntlCache();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, _fastMemoize.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, _tslib.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: createFastMemoizeCache(cache.dateTime),
        strategy: (0, _fastMemoize.strategies).variadic
    });
    var getNumberFormat = (0, _fastMemoize.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, _tslib.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: createFastMemoizeCache(cache.number),
        strategy: (0, _fastMemoize.strategies).variadic
    });
    var getPluralRules = (0, _fastMemoize.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, _tslib.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: createFastMemoizeCache(cache.pluralRules),
        strategy: (0, _fastMemoize.strategies).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, _fastMemoize.memoize)(function(message, locales, overrideFormats, opts) {
            return new (0, _intlMessageformat.IntlMessageFormat)(message, locales, overrideFormats, (0, _tslib.__assign)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: createFastMemoizeCache(cache.message),
            strategy: (0, _fastMemoize.strategies).variadic
        }),
        getRelativeTimeFormat: (0, _fastMemoize.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, _tslib.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.relativeTime),
            strategy: (0, _fastMemoize.strategies).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, _fastMemoize.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, _tslib.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.list),
            strategy: (0, _fastMemoize.strategies).variadic
        }),
        getDisplayNames: (0, _fastMemoize.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, _tslib.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.displayNames),
            strategy: (0, _fastMemoize.strategies).variadic
        })
    };
}
function getNamedFormat(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, _error.UnsupportedFormatterError)("No ".concat(type, " format named: ").concat(name)));
}

},{"tslib":"6MhhU","intl-messageformat":"jTIQv","@formatjs/fast-memoize":"iucPL","./error":"28lQw","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jTIQv":[function(require,module,exports,__globalThis) {
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IntlMessageFormat", function() {
    return 0, _core.IntlMessageFormat;
});
var _core = require("./src/core");
parcelHelpers.exportAll(_core, exports);
var _error = require("./src/error");
parcelHelpers.exportAll(_error, exports);
var _formatters = require("./src/formatters");
parcelHelpers.exportAll(_formatters, exports);
exports.default = (0, _core.IntlMessageFormat);

},{"./src/core":"hPjgt","./src/error":"lCMXu","./src/formatters":"fCNNO","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hPjgt":[function(require,module,exports,__globalThis) {
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IntlMessageFormat", function() {
    return IntlMessageFormat;
});
var _tslib = require("tslib");
var _fastMemoize = require("@formatjs/fast-memoize");
var _icuMessageformatParser = require("@formatjs/icu-messageformat-parser");
var _formatters = require("./formatters");
// -- MessageFormat --------------------------------------------------------
function mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, _tslib.__assign)((0, _tslib.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, _tslib.__assign)({}, defaultConfig));
}
function createFastMemoizeCache(store) {
    return {
        create: function create() {
            return {
                get: function get(key) {
                    return store[key];
                },
                set: function set(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, _fastMemoize.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, _tslib.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.number),
            strategy: (0, _fastMemoize.strategies).variadic
        }),
        getDateTimeFormat: (0, _fastMemoize.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, _tslib.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.dateTime),
            strategy: (0, _fastMemoize.strategies).variadic
        }),
        getPluralRules: (0, _fastMemoize.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, _tslib.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.pluralRules),
            strategy: (0, _fastMemoize.strategies).variadic
        })
    };
}
var IntlMessageFormat = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        var _this = this;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, _formatters.PART_TYPE).literal || typeof all[all.length - 1] !== 'string') all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || '';
            return result;
        };
        this.formatToParts = function(values) {
            return (0, _formatters.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            var _a;
            return {
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) || Intl.NumberFormat.supportedLocalesOf(_this.locales)[0]
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            var _a = opts || {}, formatters = _a.formatters, parseOpts = (0, _tslib.__rest)(_a, [
                "formatters"
            ]);
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, (0, _tslib.__assign)((0, _tslib.__assign)({}, parseOpts), {
                locale: this.resolvedLocale
            }));
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError('A message must be provided as a String or AST.');
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function get() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        if (typeof Intl.Locale === 'undefined') return;
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, _icuMessageformatParser.parse);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: 'currency'
            },
            percent: {
                style: 'percent'
            }
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit'
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            }
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric'
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            }
        }
    };
    return IntlMessageFormat;
}();

},{"tslib":"6MhhU","@formatjs/fast-memoize":"iucPL","@formatjs/icu-messageformat-parser":"8z7gL","./formatters":"fCNNO","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8z7gL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parse", function() {
    return parse;
});
parcelHelpers.export(exports, "_Parser", function() {
    return _Parser;
});
var _tslib = require("tslib");
var _error = require("./error");
var _parser = require("./parser");
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);
function pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, _types.isSelectElement)(el) || (0, _types.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            pruneLocation(el.options[k].value);
        }
        else if ((0, _types.isNumberElement)(el) && (0, _types.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, _types.isDateElement)(el) || (0, _types.isTimeElement)(el)) && (0, _types.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, _types.isTagElement)(el)) pruneLocation(el.children);
    });
}
function parse(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, _tslib.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, _parser.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, _error.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) pruneLocation(result.val);
    return result.val;
}
var _Parser = (0, _parser.Parser);

},{"tslib":"6MhhU","./error":"6RY4R","./parser":"cNmeS","./types":"eAl7a","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6RY4R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ErrorKind", function() {
    return ErrorKind;
});
var ErrorKind;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})(ErrorKind || (ErrorKind = {}));

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cNmeS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Parser", function() {
    return Parser;
});
var _tslib = require("tslib");
var _error = require("./error");
var _types = require("./types");
var _regexGenerated = require("./regex.generated");
var _icuSkeletonParser = require("@formatjs/icu-skeleton-parser");
var _dateTimePatternGenerator = require("./date-time-pattern-generator");
var _a;
var SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, _regexGenerated.SPACE_SEPARATOR_REGEX).source, "*"));
var SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, _regexGenerated.SPACE_SEPARATOR_REGEX).source, "*$"));
function createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var hasNativeStartsWith = !!String.prototype.startsWith && '_a'.startsWith('a', 1);
var hasNativeFromCodePoint = !!String.fromCodePoint;
var hasNativeFromEntries = !!Object.fromEntries;
var hasNativeCodePointAt = !!String.prototype.codePointAt;
var hasTrimStart = !!String.prototype.trimStart;
var hasTrimEnd = !!String.prototype.trimEnd;
var hasNativeIsSafeInteger = !!Number.isSafeInteger;
var isSafeInteger = hasNativeIsSafeInteger ? Number.isSafeInteger : function isSafeInteger(n) {
    return typeof n === 'number' && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var REGEX_SUPPORTS_U_AND_Y = true;
try {
    var re = RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ REGEX_SUPPORTS_U_AND_Y = ((_a = re.exec('a')) === null || _a === void 0 ? void 0 : _a[0]) === 'a';
} catch (_) {
    REGEX_SUPPORTS_U_AND_Y = false;
}
var startsWith = hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var fromCodePoint = hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = '';
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + ' is not a valid code point');
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var fromEntries = // native
hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var codePointAt = hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var trimStart = hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace(SPACE_SEPARATOR_START_REGEX, '');
};
var trimEnd = hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace(SPACE_SEPARATOR_END_REGEX, '');
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var matchIdentifierAtIndex;
if (REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var IDENTIFIER_PREFIX_RE_1 = RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
} else // IE11
matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = codePointAt(s, index);
        if (c === undefined || _isWhiteSpace(c) || _isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return fromCodePoint.apply(void 0, match);
};
var Parser = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error('parser can only be used once');
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, _types.TYPE).pound,
                    location: createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, _error.ErrorKind).UNMATCHED_CLOSING_TAG, createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && _isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) // Self closing tag
        return {
            val: {
                type: (0, _types.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !_isAlpha(this.char())) return this.error((0, _error.ErrorKind).INVALID_TAG, createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, _error.ErrorKind).UNMATCHED_CLOSING_TAG, createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf('>')) return this.error((0, _error.ErrorKind).INVALID_TAG, createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, _types.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, _error.ErrorKind).UNCLOSED_TAG, createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, _error.ErrorKind).INVALID_TAG, createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && _isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, _types.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal') || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, _error.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, _error.ErrorKind).EMPTY_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, _error.ErrorKind).MALFORMED_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, _error.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, _types.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, _error.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, _error.ErrorKind).MALFORMED_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, _error.ErrorKind).EXPECT_ARGUMENT_TYPE, createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time':
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = trimEnd(result.val);
                    if (style.length === 0) return this.error((0, _error.ErrorKind).EXPECT_ARGUMENT_STYLE, createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, _types.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, _error.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, _dateTimePatternGenerator.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: (0, _types.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, _icuSkeletonParser.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === 'date' ? (0, _types.TYPE).date : (0, _types.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number' ? (0, _types.TYPE).number : argType === 'date' ? (0, _types.TYPE).date : (0, _types.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case 'plural':
            case 'selectordinal':
            case 'select':
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) return this.error((0, _error.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, createLocation(typeEndPosition_1, (0, _tslib.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) return this.error((0, _error.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, _error.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, _error.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') return {
                    val: {
                        type: (0, _types.TYPE).select,
                        value: value,
                        options: fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, _types.TYPE).plural,
                        value: value,
                        options: fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, _error.ErrorKind).INVALID_ARGUMENT_TYPE, createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, _error.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, _error.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, _icuSkeletonParser.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, _error.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, _types.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, _icuSkeletonParser.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, _error.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, _error.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === 'select' ? (0, _error.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, _error.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === 'other') hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) return this.error(parentArgType === 'select' ? (0, _error.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, _error.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === 'select' ? (0, _error.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, _error.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, _error.ErrorKind).MISSING_OTHER_CLAUSE, createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) ;
        else if (this.bumpIf('-')) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error('out of bound');
        var code = codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if (startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && _isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function _isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function _isAlphaOrSlash(codepoint) {
    return _isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function _isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function _isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function _isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

},{"tslib":"6MhhU","./error":"6RY4R","./types":"eAl7a","./regex.generated":"dq6pt","@formatjs/icu-skeleton-parser":"6oKdS","./date-time-pattern-generator":"7uLrt","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eAl7a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TYPE", function() {
    return TYPE;
});
parcelHelpers.export(exports, "SKELETON_TYPE", function() {
    return SKELETON_TYPE;
});
/**
 * Type Guards
 */ parcelHelpers.export(exports, "isLiteralElement", function() {
    return isLiteralElement;
});
parcelHelpers.export(exports, "isArgumentElement", function() {
    return isArgumentElement;
});
parcelHelpers.export(exports, "isNumberElement", function() {
    return isNumberElement;
});
parcelHelpers.export(exports, "isDateElement", function() {
    return isDateElement;
});
parcelHelpers.export(exports, "isTimeElement", function() {
    return isTimeElement;
});
parcelHelpers.export(exports, "isSelectElement", function() {
    return isSelectElement;
});
parcelHelpers.export(exports, "isPluralElement", function() {
    return isPluralElement;
});
parcelHelpers.export(exports, "isPoundElement", function() {
    return isPoundElement;
});
parcelHelpers.export(exports, "isTagElement", function() {
    return isTagElement;
});
parcelHelpers.export(exports, "isNumberSkeleton", function() {
    return isNumberSkeleton;
});
parcelHelpers.export(exports, "isDateTimeSkeleton", function() {
    return isDateTimeSkeleton;
});
parcelHelpers.export(exports, "createLiteralElement", function() {
    return createLiteralElement;
});
parcelHelpers.export(exports, "createNumberElement", function() {
    return createNumberElement;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var TYPE;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})(TYPE || (TYPE = {}));
var SKELETON_TYPE;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})(SKELETON_TYPE || (SKELETON_TYPE = {}));
function isLiteralElement(el) {
    return el.type === TYPE.literal;
}
function isArgumentElement(el) {
    return el.type === TYPE.argument;
}
function isNumberElement(el) {
    return el.type === TYPE.number;
}
function isDateElement(el) {
    return el.type === TYPE.date;
}
function isTimeElement(el) {
    return el.type === TYPE.time;
}
function isSelectElement(el) {
    return el.type === TYPE.select;
}
function isPluralElement(el) {
    return el.type === TYPE.plural;
}
function isPoundElement(el) {
    return el.type === TYPE.pound;
}
function isTagElement(el) {
    return el.type === TYPE.tag;
}
function isNumberSkeleton(el) {
    return !!(el && (typeof el === "undefined" ? "undefined" : (0, _typeOf._)(el)) === 'object' && el.type === SKELETON_TYPE.number);
}
function isDateTimeSkeleton(el) {
    return !!(el && (typeof el === "undefined" ? "undefined" : (0, _typeOf._)(el)) === 'object' && el.type === SKELETON_TYPE.dateTime);
}
function createLiteralElement(value) {
    return {
        type: TYPE.literal,
        value: value
    };
}
function createNumberElement(value, style) {
    return {
        type: TYPE.number,
        value: value,
        style: style
    };
}

},{"@swc/helpers/_/_type_of":"iFJdx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dq6pt":[function(require,module,exports,__globalThis) {
// @generated from regex-gen.ts
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SPACE_SEPARATOR_REGEX", function() {
    return SPACE_SEPARATOR_REGEX;
});
parcelHelpers.export(exports, "WHITE_SPACE_REGEX", function() {
    return WHITE_SPACE_REGEX;
});
var SPACE_SEPARATOR_REGEX = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6oKdS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _dateTime = require("./date-time");
parcelHelpers.exportAll(_dateTime, exports);
var _number = require("./number");
parcelHelpers.exportAll(_number, exports);

},{"./date-time":"hgtou","./number":"aQrHd","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hgtou":[function(require,module,exports,__globalThis) {
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Parse Date time skeleton into Intl.DateTimeFormatOptions
 * Ref: https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * @public
 * @param skeleton skeleton string
 */ parcelHelpers.export(exports, "parseDateTimeSkeleton", function() {
    return parseDateTimeSkeleton;
});
var DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function parseDateTimeSkeleton(skeleton) {
    var result = {};
    skeleton.replace(DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = [
                    'numeric',
                    '2-digit',
                    'short',
                    'long',
                    'narrow'
                ][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) throw new RangeError('`e..eee` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            case 'c':
                if (len < 4) throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            // Period
            case 'a':
                result.hour12 = true;
                break;
            case 'b':
            case 'B':
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            // Second
            case 's':
                result.second = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z':
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z':
            case 'O':
            case 'v':
            case 'V':
            case 'X':
            case 'x':
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aQrHd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseNumberSkeletonFromString", function() {
    return parseNumberSkeletonFromString;
});
/**
 * https://github.com/unicode-org/icu/blob/master/docs/userguide/format_parse/numbers/skeletons.md#skeleton-stems-and-options
 */ parcelHelpers.export(exports, "parseNumberSkeleton", function() {
    return parseNumberSkeleton;
});
var _tslib = require("tslib");
var _regexGenerated = require("./regex.generated");
function parseNumberSkeletonFromString(skeleton) {
    if (skeleton.length === 0) throw new Error('Number skeleton cannot be empty');
    // Parse the skeleton
    var stringTokens = skeleton.split((0, _regexGenerated.WHITE_SPACE_REGEX)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) throw new Error('Invalid number skeleton');
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error('Invalid number skeleton');
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') result.roundingPriority = 'morePrecision';
    else if (str[str.length - 1] === 's') result.roundingPriority = 'lessPrecision';
    str.replace(SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === '+') result.minimumSignificantDigits = g1.length;
        else if (g1[0] === '#') result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function parseSign(str) {
    switch(str){
        case 'sign-auto':
            return {
                signDisplay: 'auto'
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting'
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always'
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting'
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero'
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting'
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never'
            };
    }
}
function parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering'
        };
        stem = stem.slice(2);
    } else if (stem[0] === 'E') {
        result = {
            notation: 'scientific'
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        } else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error('Malformed concise eng/scientific notation');
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function parseNotationOptions(opt) {
    var result = {};
    var signOpts = parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function parseNumberSkeleton(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, result), {
                    notation: 'scientific'
                }), token.options.reduce(function(all, opt) {
                    return (0, _tslib.__assign)((0, _tslib.__assign)({}, all), parseNotationOptions(opt));
                }, {}));
                continue;
            case 'engineering':
                result = (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, result), {
                    notation: 'engineering'
                }), token.options.reduce(function(all, opt) {
                    return (0, _tslib.__assign)((0, _tslib.__assign)({}, all), parseNotationOptions(opt));
                }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            case 'rounding-mode-floor':
                result.roundingMode = 'floor';
                continue;
            case 'rounding-mode-ceiling':
                result.roundingMode = 'ceil';
                continue;
            case 'rounding-mode-down':
                result.roundingMode = 'trunc';
                continue;
            case 'rounding-mode-up':
                result.roundingMode = 'expand';
                continue;
            case 'rounding-mode-half-even':
                result.roundingMode = 'halfEven';
                continue;
            case 'rounding-mode-half-down':
                result.roundingMode = 'halfTrunc';
                continue;
            case 'rounding-mode-half-up':
                result.roundingMode = 'halfExpand';
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) throw new RangeError('integer-width stems only accept a single optional option');
                token.options[0].replace(INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error('We currently do not support maximum integer digits');
                    else if (g5) throw new Error('We currently do not support exact integer digits');
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if (CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if (FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError('Fraction-precision stems only accept a single optional option');
            token.stem.replace(FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === '#') result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') result = (0, _tslib.__assign)((0, _tslib.__assign)({}, result), {
                trailingZeroDisplay: 'stripIfInteger'
            });
            else if (opt) result = (0, _tslib.__assign)((0, _tslib.__assign)({}, result), parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if (SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, _tslib.__assign)((0, _tslib.__assign)({}, result), parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = parseSign(token.stem);
        if (signOpts) result = (0, _tslib.__assign)((0, _tslib.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, _tslib.__assign)((0, _tslib.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}

},{"tslib":"6MhhU","./regex.generated":"2FEEu","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2FEEu":[function(require,module,exports,__globalThis) {
// @generated from regex-gen.ts
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WHITE_SPACE_REGEX", function() {
    return WHITE_SPACE_REGEX;
});
var WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7uLrt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns the best matching date time pattern if a date time skeleton
 * pattern is provided with a locale. Follows the Unicode specification:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#table-mapping-requested-time-skeletons-to-patterns
 * @param skeleton date time skeleton pattern that possibly includes j, J or C
 * @param locale
 */ parcelHelpers.export(exports, "getBestPattern", function() {
    return getBestPattern;
});
var _timeDataGenerated = require("./time-data.generated");
function getBestPattern(skeleton, locale) {
    var skeletonCopy = '';
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === 'J') skeletonCopy += 'H';
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case 'h24':
            return 'k';
        case 'h23':
            return 'H';
        case 'h12':
            return 'h';
        case 'h11':
            return 'K';
        default:
            throw new Error('Invalid hourCycle');
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') regionTag = locale.maximize().region;
    var hourCycles = (0, _timeDataGenerated.timeData)[regionTag || ''] || (0, _timeDataGenerated.timeData)[languageTag || ''] || (0, _timeDataGenerated.timeData)["".concat(languageTag, "-001")] || (0, _timeDataGenerated.timeData)['001'];
    return hourCycles[0];
}

},{"./time-data.generated":"1OrjE","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1OrjE":[function(require,module,exports,__globalThis) {
// @generated from time-data-gen.ts
// prettier-ignore  
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeData", function() {
    return timeData;
});
var timeData = {
    "001": [
        "H",
        "h"
    ],
    "419": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CU": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-HK": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-IL": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "en-MY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fCNNO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PART_TYPE", function() {
    return PART_TYPE;
});
parcelHelpers.export(exports, "isFormatXMLElementFn", function() {
    return isFormatXMLElementFn;
});
// TODO(skeleton): add skeleton support
parcelHelpers.export(exports, "formatToParts", function() {
    return formatToParts;
});
var _icuMessageformatParser = require("@formatjs/icu-messageformat-parser");
var _error = require("./error");
var PART_TYPE;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})(PART_TYPE || (PART_TYPE = {}));
function mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== PART_TYPE.literal || part.type !== PART_TYPE.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function isFormatXMLElementFn(el) {
    return typeof el === 'function';
}
function formatToParts(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, _icuMessageformatParser.isLiteralElement)(els[0])) return [
        {
            type: PART_TYPE.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, _icuMessageformatParser.isLiteralElement)(el)) {
            result.push({
                type: PART_TYPE.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, _icuMessageformatParser.isPoundElement)(el)) {
            if (typeof currentPluralValue === 'number') result.push({
                type: PART_TYPE.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, _error.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, _icuMessageformatParser.isArgumentElement)(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') value = typeof value === 'string' || typeof value === 'number' ? String(value) : '';
            result.push({
                type: typeof value === 'string' ? PART_TYPE.literal : PART_TYPE.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, _icuMessageformatParser.isDateElement)(el)) {
            var style = typeof el.style === 'string' ? formats.date[el.style] : (0, _icuMessageformatParser.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: PART_TYPE.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, _icuMessageformatParser.isTimeElement)(el)) {
            var style = typeof el.style === 'string' ? formats.time[el.style] : (0, _icuMessageformatParser.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: PART_TYPE.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, _icuMessageformatParser.isNumberElement)(el)) {
            var style = typeof el.style === 'string' ? formats.number[el.style] : (0, _icuMessageformatParser.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: PART_TYPE.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, _icuMessageformatParser.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!isFormatXMLElementFn(formatFn)) throw new (0, _error.InvalidValueTypeError)(value_1, 'function', originalMessage);
            var parts = formatToParts(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === 'string' ? PART_TYPE.literal : PART_TYPE.object,
                    value: c
                };
            }));
        }
        if ((0, _icuMessageformatParser.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, _error.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, _icuMessageformatParser.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, _error.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, _error.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, _error.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return mergeLiteral(result);
}

},{"@formatjs/icu-messageformat-parser":"8z7gL","./error":"lCMXu","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lCMXu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ErrorCode", function() {
    return ErrorCode;
});
parcelHelpers.export(exports, "FormatError", function() {
    return FormatError;
});
parcelHelpers.export(exports, "InvalidValueError", function() {
    return InvalidValueError;
});
parcelHelpers.export(exports, "InvalidValueTypeError", function() {
    return InvalidValueTypeError;
});
parcelHelpers.export(exports, "MissingValueError", function() {
    return MissingValueError;
});
var _tslib = require("tslib");
var ErrorCode;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})(ErrorCode || (ErrorCode = {}));
var FormatError = /** @class */ function(_super) {
    (0, _tslib.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var InvalidValueError = /** @class */ function(_super) {
    (0, _tslib.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), ErrorCode.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}(FormatError);
var InvalidValueTypeError = /** @class */ function(_super) {
    (0, _tslib.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), ErrorCode.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}(FormatError);
var MissingValueError = /** @class */ function(_super) {
    (0, _tslib.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), ErrorCode.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}(FormatError);

},{"tslib":"6MhhU","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"28lQw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IntlErrorCode", function() {
    return IntlErrorCode;
});
parcelHelpers.export(exports, "IntlError", function() {
    return IntlError;
});
parcelHelpers.export(exports, "UnsupportedFormatterError", function() {
    return UnsupportedFormatterError;
});
parcelHelpers.export(exports, "InvalidConfigError", function() {
    return InvalidConfigError;
});
parcelHelpers.export(exports, "MissingDataError", function() {
    return MissingDataError;
});
parcelHelpers.export(exports, "IntlFormatError", function() {
    return IntlFormatError;
});
parcelHelpers.export(exports, "MessageFormatError", function() {
    return MessageFormatError;
});
parcelHelpers.export(exports, "MissingTranslationError", function() {
    return MissingTranslationError;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
var _tslib = require("tslib");
var IntlErrorCode;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})(IntlErrorCode || (IntlErrorCode = {}));
var IntlError = /** @class */ function(_super) {
    (0, _tslib.__extends)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? (0, _instanceof._)(exception, Error) ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, "\n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : '')) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === 'function') // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var UnsupportedFormatterError = /** @class */ function(_super) {
    (0, _tslib.__extends)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, IntlErrorCode.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}(IntlError);
var InvalidConfigError = /** @class */ function(_super) {
    (0, _tslib.__extends)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, IntlErrorCode.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}(IntlError);
var MissingDataError = /** @class */ function(_super) {
    (0, _tslib.__extends)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, IntlErrorCode.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}(IntlError);
var IntlFormatError = /** @class */ function(_super) {
    (0, _tslib.__extends)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        var _this = _super.call(this, IntlErrorCode.FORMAT_ERROR, "".concat(message, "\nLocale: ").concat(locale, "\n"), exception) || this;
        _this.locale = locale;
        return _this;
    }
    return IntlFormatError;
}(IntlError);
var MessageFormatError = /** @class */ function(_super) {
    (0, _tslib.__extends)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, "\nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, "\n"), locale, exception) || this;
        _this.descriptor = descriptor;
        _this.locale = locale;
        return _this;
    }
    return MessageFormatError;
}(IntlFormatError);
var MissingTranslationError = /** @class */ function(_super) {
    (0, _tslib.__extends)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, IntlErrorCode.MISSING_TRANSLATION, "Missing message: \"".concat(descriptor.id, "\" for locale \"").concat(locale, "\", using ").concat(descriptor.defaultMessage ? "default message (".concat(typeof descriptor.defaultMessage === 'string' ? descriptor.defaultMessage : descriptor.defaultMessage.map(function(e) {
            var _a;
            return (_a = e.value) !== null && _a !== void 0 ? _a : JSON.stringify(e);
        }).join(), ")") : 'id', " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}(IntlError);

},{"@swc/helpers/_/_instanceof":"h9UKc","tslib":"6MhhU","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dhjzu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatMessage", function() {
    return formatMessage;
});
var _tslib = require("tslib");
var _ecma402Abstract = require("@formatjs/ecma402-abstract");
var _intlMessageformat = require("intl-messageformat");
var _error = require("./error");
var _icuMessageformatParser = require("@formatjs/icu-messageformat-parser");
function setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, _tslib.__assign)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, _tslib.__assign)((0, _tslib.__assign)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, _tslib.__assign)((0, _tslib.__assign)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, _intlMessageformat.IntlMessageFormat).formats;
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, mfFormats), f1), {
        date: deepMergeOptions(setTimeZoneInOptions(mfFormats.date, timeZone), setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: deepMergeOptions(setTimeZoneInOptions(mfFormats.time, timeZone), setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
var formatMessage = function formatMessage(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ''
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, _ecma402Abstract.invariant)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, _icuMessageformatParser.TYPE).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === 'string' && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, _tslib.__assign)((0, _tslib.__assign)({}, defaultRichTextElements), values || {});
    formats = deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === '') return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, _error.MissingTranslationError)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, _error.MessageFormatError)("Error formatting default message for: \"".concat(id, "\", rendering default message verbatim"), locale, messageDescriptor, e));
            return typeof defaultMessage === 'string' ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, _tslib.__assign)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, _error.MessageFormatError)("Error formatting message: \"".concat(id, "\", using ").concat(defaultMessage ? 'default message' : 'id', " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, _error.MessageFormatError)("Error formatting the default message for: \"".concat(id, "\", rendering message verbatim"), locale, messageDescriptor, e));
    }
    if (typeof message === 'string') return message;
    if (typeof defaultMessage === 'string') return defaultMessage;
    return id;
};

},{"tslib":"6MhhU","@formatjs/ecma402-abstract":"kC5cd","intl-messageformat":"jTIQv","./error":"28lQw","@formatjs/icu-messageformat-parser":"8z7gL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bLcVY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFormatter", function() {
    return getFormatter;
});
parcelHelpers.export(exports, "formatDate", function() {
    return formatDate;
});
parcelHelpers.export(exports, "formatTime", function() {
    return formatTime;
});
parcelHelpers.export(exports, "formatDateTimeRange", function() {
    return formatDateTimeRange;
});
parcelHelpers.export(exports, "formatDateToParts", function() {
    return formatDateToParts;
});
parcelHelpers.export(exports, "formatTimeToParts", function() {
    return formatTimeToParts;
});
var _tslib = require("tslib");
var _utils = require("./utils");
var _error = require("./error");
var DATE_TIME_FORMAT_OPTIONS = [
    'formatMatcher',
    'timeZone',
    'hour12',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'hourCycle',
    'dateStyle',
    'timeStyle',
    'calendar',
    // 'dayPeriod',
    'numberingSystem',
    'fractionalSecondDigits'
];
function getFormatter(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, _tslib.__assign)((0, _tslib.__assign)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, _utils.getNamedFormat)(formats, type, format, onError));
    var filteredOptions = (0, _utils.filterProps)(options, DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === 'time' && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, _tslib.__assign)((0, _tslib.__assign)({}, filteredOptions), {
        hour: 'numeric',
        minute: 'numeric'
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function formatDate(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return getFormatter(config, 'date', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, _error.IntlFormatError)('Error formatting date.', config.locale, e));
    }
    return String(date);
}
function formatTime(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return getFormatter(config, 'time', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, _error.IntlFormatError)('Error formatting time.', config.locale, e));
    }
    return String(date);
}
function formatDateTimeRange(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
    var filteredOptions = (0, _utils.filterProps)(options, DATE_TIME_FORMAT_OPTIONS, timeZone ? {
        timeZone: timeZone
    } : {});
    try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
    } catch (e) {
        onError(new (0, _error.IntlFormatError)('Error formatting date time range.', config.locale, e));
    }
    return String(from);
}
function formatDateToParts(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return getFormatter(config, 'date', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, _error.IntlFormatError)('Error formatting date.', config.locale, e));
    }
    return [];
}
function formatTimeToParts(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return getFormatter(config, 'time', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, _error.IntlFormatError)('Error formatting time.', config.locale, e));
    }
    return [];
}

},{"tslib":"6MhhU","./utils":"iIYJ2","./error":"28lQw","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6CmBI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatDisplayName", function() {
    return formatDisplayName;
});
var _utils = require("./utils");
var _intlMessageformat = require("intl-messageformat");
var _error = require("./error");
var DISPLAY_NAMES_OPTONS = [
    'style',
    'type',
    'fallback',
    'languageDisplay'
];
function formatDisplayName(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, _intlMessageformat.FormatError)("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", (0, _intlMessageformat.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, _utils.filterProps)(options, DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, _error.IntlFormatError)('Error formatting display name.', locale, e));
    }
}

},{"./utils":"iIYJ2","intl-messageformat":"jTIQv","./error":"28lQw","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"g9xTd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatList", function() {
    return formatList;
});
parcelHelpers.export(exports, "formatListToParts", function() {
    return formatListToParts;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _tslib = require("tslib");
var _utils = require("./utils");
var _intlMessageformat = require("intl-messageformat");
var _error = require("./error");
var LIST_FORMAT_OPTIONS = [
    'type',
    'style'
];
var now = Date.now();
function generateToken(i) {
    return "".concat(now, "_").concat(i, "_").concat(now);
}
function formatList(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = formatListToParts(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== 'string') all.push(val);
        else if (typeof all[all.length - 1] === 'string') all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results.length === 0 ? '' : results;
}
function formatListToParts(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, _intlMessageformat.FormatError)("Intl.ListFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-listformat\"\n", (0, _intlMessageformat.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, _utils.filterProps)(options, LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function(v, i) {
            if ((typeof v === "undefined" ? "undefined" : (0, _typeOf._)(v)) === 'object') {
                var id = generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === 'literal' ? part : (0, _tslib.__assign)((0, _tslib.__assign)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, _error.IntlFormatError)('Error formatting list.', locale, e));
    }
    // @ts-ignore
    return values;
}

},{"@swc/helpers/_/_type_of":"iFJdx","tslib":"6MhhU","./utils":"iIYJ2","intl-messageformat":"jTIQv","./error":"28lQw","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4moaM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatPlural", function() {
    return formatPlural;
});
var _utils = require("./utils");
var _error = require("./error");
var _intlMessageformat = require("intl-messageformat");
var PLURAL_FORMAT_OPTIONS = [
    'type'
];
function formatPlural(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, _intlMessageformat.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, _intlMessageformat.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, _utils.filterProps)(options, PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, _error.IntlFormatError)('Error formatting plural.', locale, e));
    }
    return 'other';
}

},{"./utils":"iIYJ2","./error":"28lQw","intl-messageformat":"jTIQv","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bU2nJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatRelativeTime", function() {
    return formatRelativeTime;
});
var _utils = require("./utils");
var _intlMessageformat = require("intl-messageformat");
var _error = require("./error");
var RELATIVE_TIME_FORMAT_OPTIONS = [
    'numeric',
    'style'
];
function getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, _utils.getNamedFormat)(formats, 'relative', format, onError) || {};
    var filteredOptions = (0, _utils.filterProps)(options, RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function formatRelativeTime(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = 'second';
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, _intlMessageformat.FormatError)("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n", (0, _intlMessageformat.ErrorCode).MISSING_INTL_API));
    try {
        return getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, _error.IntlFormatError)('Error formatting relative time.', config.locale, e));
    }
    return String(value);
}

},{"./utils":"iIYJ2","intl-messageformat":"jTIQv","./error":"28lQw","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4TVpB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFormatter", function() {
    return getFormatter;
});
parcelHelpers.export(exports, "formatNumber", function() {
    return formatNumber;
});
parcelHelpers.export(exports, "formatNumberToParts", function() {
    return formatNumberToParts;
});
var _error = require("./error");
var _utils = require("./utils");
var NUMBER_FORMAT_OPTIONS = [
    'style',
    'currency',
    'unit',
    'unitDisplay',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    // ES2020 NumberFormat
    'compactDisplay',
    'currencyDisplay',
    'currencySign',
    'notation',
    'signDisplay',
    'unit',
    'unitDisplay',
    'numberingSystem',
    // ES2023 NumberFormat
    'trailingZeroDisplay',
    'roundingPriority',
    'roundingIncrement',
    'roundingMode'
];
function getFormatter(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, _utils.getNamedFormat)(formats, 'number', format, onError) || {};
    var filteredOptions = (0, _utils.filterProps)(options, NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function formatNumber(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return getFormatter(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, _error.IntlFormatError)('Error formatting number.', config.locale, e));
    }
    return String(value);
}
function formatNumberToParts(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return getFormatter(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, _error.IntlFormatError)('Error formatting number.', config.locale, e));
    }
    return [];
}

},{"./error":"28lQw","./utils":"iIYJ2","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hBk8u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Create intl object
 * @param config intl config
 * @param cache cache for formatter instances to prevent memory leak
 */ parcelHelpers.export(exports, "createIntl", function() {
    return createIntl;
});
var _tslib = require("tslib");
var _utils = require("./utils");
var _error = require("./error");
var _number = require("./number");
var _relativeTime = require("./relativeTime");
var _dateTime = require("./dateTime");
var _plural = require("./plural");
var _message = require("./message");
var _list = require("./list");
var _displayName = require("./displayName");
function messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === 'string';
}
function verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && messagesContainString(config.messages || {})) config.onWarn("[@formatjs/intl] \"defaultRichTextElements\" was specified but \"message\" was not pre-compiled. \nPlease consider using \"@formatjs/cli\" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution");
}
function createIntl(config, cache) {
    var formatters = (0, _utils.createFormatters)(cache);
    var resolvedConfig = (0, _tslib.__assign)((0, _tslib.__assign)({}, (0, _utils.DEFAULT_INTL_CONFIG)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, _error.InvalidConfigError)("\"locale\" was not configured, using \"".concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details")));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || 'en';
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, _error.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.NumberFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, _error.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.DateTimeFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    verifyConfigMessages(resolvedConfig);
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, _number.formatNumber).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, _number.formatNumberToParts).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, _relativeTime.formatRelativeTime).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, _dateTime.formatDate).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, _dateTime.formatDateToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, _dateTime.formatTime).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, _dateTime.formatDateTimeRange).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, _dateTime.formatTimeToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, _plural.formatPlural).bind(null, resolvedConfig, formatters.getPluralRules),
        // @ts-expect-error TODO: will get to this later
        formatMessage: (0, _message.formatMessage).bind(null, resolvedConfig, formatters),
        // @ts-expect-error TODO: will get to this later
        $t: (0, _message.formatMessage).bind(null, resolvedConfig, formatters),
        formatList: (0, _list.formatList).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, _list.formatListToParts).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, _displayName.formatDisplayName).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}

},{"tslib":"6MhhU","./utils":"iIYJ2","./error":"28lQw","./number":"4TVpB","./relativeTime":"bU2nJ","./dateTime":"bLcVY","./plural":"4moaM","./message":"dhjzu","./list":"g9xTd","./displayName":"6CmBI","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jwY9c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Provider", function() {
    return Provider;
});
parcelHelpers.export(exports, "Context", function() {
    return Context;
});
parcelHelpers.export(exports, "default", function() {
    return injectIntl;
});
var _tslib = require("tslib");
var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
var _react = require("react");
var _utils = require("../utils");
function getDisplayName(Component) {
    return Component.displayName || Component.name || 'Component';
}
// This is primarily dealing with packaging systems where multiple copies of react-intl
// might exist
var IntlContext = typeof window !== 'undefined' && !window.__REACT_INTL_BYPASS_GLOBAL_CONTEXT__ ? window.__REACT_INTL_CONTEXT__ || (window.__REACT_INTL_CONTEXT__ = _react.createContext(null)) : _react.createContext(null);
var IntlConsumer = IntlContext.Consumer, IntlProvider = IntlContext.Provider;
var Provider = IntlProvider;
var Context = IntlContext;
function injectIntl(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? 'intl' : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function WithIntl(props) {
        return _react.createElement(IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, _utils.invariantIntlContext)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return _react.createElement(WrappedComponent, (0, _tslib.__assign)({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat(getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, _hoistNonReactStaticsDefault.default)(// @ts-expect-error
    _react.forwardRef(function(props, ref) {
        return _react.createElement(WithIntl, (0, _tslib.__assign)({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, _hoistNonReactStaticsDefault.default)(WithIntl, WrappedComponent);
}

},{"tslib":"6MhhU","hoist-non-react-statics":"nZLnq","react":"ltHCL","../utils":"88Xfc","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"b7DFj":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
var _intl = require("@formatjs/intl");
var _react = require("react");
var _utils = require("../utils");
var _injectIntl = require("./injectIntl");
var _createIntl = require("./createIntl");
function processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
var IntlProvider = /** @class */ function(_super) {
    (0, _tslib.__extends)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, _intl.createIntlCache)();
        _this.state = {
            cache: _this.cache,
            intl: (0, _createIntl.createIntl)(processIntlConfig(_this.props), _this.cache),
            prevConfig: processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = processIntlConfig(props);
        if (!(0, _utils.shallowEqual)(prevConfig, config)) return {
            intl: (0, _createIntl.createIntl)(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, _utils.invariantIntlContext)(this.state.intl);
        return _react.createElement((0, _injectIntl.Provider), {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = 'IntlProvider';
    IntlProvider.defaultProps = (0, _utils.DEFAULT_INTL_CONFIG);
    return IntlProvider;
}(_react.PureComponent);
exports.default = IntlProvider;

},{"tslib":"6MhhU","@formatjs/intl":"4jZTM","react":"ltHCL","../utils":"88Xfc","./injectIntl":"jwY9c","./createIntl":"4Xxzz","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4Xxzz":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createIntl", function() {
    return createIntl;
});
var _tslib = require("tslib");
var _intl = require("@formatjs/intl");
var _react = require("react");
var _utils = require("../utils");
var _intlMessageformat = require("intl-messageformat");
function assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, _intlMessageformat.isFormatXMLElementFn)(v) ? (0, _utils.assignUniqueKeysToParts)(v) : v;
        return acc;
    }, {});
}
var formatMessage = function formatMessage(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, _intl.formatMessage).apply(void 0, (0, _tslib.__spreadArray)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return _react.Children.toArray(chunks);
    return chunks;
};
var createIntl = function createIntl(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, _tslib.__rest)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, _intl.createIntl)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, (0, _utils.DEFAULT_INTL_CONFIG)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    var resolvedConfig = {
        locale: coreIntl.locale,
        timeZone: coreIntl.timeZone,
        fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
        formats: coreIntl.formats,
        defaultLocale: coreIntl.defaultLocale,
        defaultFormats: coreIntl.defaultFormats,
        messages: coreIntl.messages,
        onError: coreIntl.onError,
        defaultRichTextElements: defaultRichTextElements
    };
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, coreIntl), {
        formatMessage: formatMessage.bind(null, resolvedConfig, // @ts-expect-error fix this
        coreIntl.formatters),
        // @ts-expect-error fix this
        $t: formatMessage.bind(null, resolvedConfig, coreIntl.formatters)
    });
};

},{"tslib":"6MhhU","@formatjs/intl":"4jZTM","react":"ltHCL","../utils":"88Xfc","intl-messageformat":"jTIQv","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gfNgD":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
var _react = require("react");
var _utils = require("../utils");
var _useIntl = require("./useIntl");
var _useIntlDefault = parcelHelpers.interopDefault(_useIntl);
function areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0, _tslib.__rest)(prevProps, [
        "values"
    ]);
    var nextValues = nextProps.values, nextOtherProps = (0, _tslib.__rest)(nextProps, [
        "values"
    ]);
    return (0, _utils.shallowEqual)(nextValues, values) && (0, _utils.shallowEqual)(otherProps, nextOtherProps);
}
function FormattedMessage(props) {
    var intl = (0, _useIntlDefault.default)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? _react.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
    };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag
    });
    if (typeof children === 'function') return children(Array.isArray(nodes) ? nodes : [
        nodes
    ]);
    if (Component) return _react.createElement(Component, null, _react.Children.toArray(nodes));
    return _react.createElement(_react.Fragment, null, nodes);
}
FormattedMessage.displayName = 'FormattedMessage';
var MemoizedFormattedMessage = _react.memo(FormattedMessage, areEqual);
MemoizedFormattedMessage.displayName = 'MemoizedFormattedMessage';
exports.default = MemoizedFormattedMessage;

},{"tslib":"6MhhU","react":"ltHCL","../utils":"88Xfc","./useIntl":"jQUM3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jfzMr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return 0, _buttonDefault.default;
});
var _button = require("../old-button/button");
var _buttonDefault = parcelHelpers.interopDefault(_button);

},{"../old-button/button":"LfdZg","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"LfdZg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var _buttonBase = require("./shared/button-base");
var _buttonBaseDefault = parcelHelpers.interopDefault(_buttonBase);
var _getCss = require("./shared/get-css");
var _getIsOnlySingleIcon = require("./shared/get-is-only-single-icon");
var _getIsOnlySingleIconDefault = parcelHelpers.interopDefault(_getIsOnlySingleIcon);
var isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
/**
 * __Button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/button-legacy/examples)
 * - [Code](https://atlassian.design/components/button/button-legacy/code)
 * - [Usage](https://atlassian.design/components/button/button-legacy/usage)
 */ var Button = /*#__PURE__*/ (0, _reactDefault.default).memo(/*#__PURE__*/ (0, _reactDefault.default).forwardRef(function Button(_param, ref) {
    var _param_appearance = _param.appearance, appearance = _param_appearance === void 0 ? 'default' : _param_appearance, children = _param.children, iconBefore = _param.iconBefore, iconAfter = _param.iconAfter, _param_isSelected = _param.isSelected, isSelected = _param_isSelected === void 0 ? false : _param_isSelected, tmp = _param.onMouseDown, providedOnMouseDown = tmp === void 0 ? (0, _noopDefault.default) : tmp, tmp1 = _param.onMouseUp, providedOnMouseUp = tmp1 === void 0 ? (0, _noopDefault.default) : tmp1, _param_shouldFitContainer = _param.shouldFitContainer, shouldFitContainer = _param_shouldFitContainer === void 0 ? false : _param_shouldFitContainer, _param_spacing = _param.spacing, spacing = _param_spacing === void 0 ? 'default' : _param_spacing, rest = (0, _objectWithoutProperties._)(_param, [
        "appearance",
        "children",
        "iconBefore",
        "iconAfter",
        "isSelected",
        "onMouseDown",
        "onMouseUp",
        "shouldFitContainer",
        "spacing"
    ]);
    var isOnlySingleIcon = (0, _getIsOnlySingleIconDefault.default)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), isActive = _useState[0], setIsActive = _useState[1];
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    // in Firefox
    var onMouseDown = (0, _react.useCallback)(function(event) {
        providedOnMouseDown(event);
        if (isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    var onMouseUp = (0, _react.useCallback)(function(event) {
        providedOnMouseUp(event);
        if (isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    var buttonCss = (0, _react.useMemo)(function() {
        return (0, _getCss.getCss)({
            appearance: appearance,
            spacing: spacing,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        });
    }, [
        appearance,
        spacing,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonBaseDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, rest), {
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        // Due to how click events are set, we need to set active styles
        // manually in Firefox and wrap onMouseDown/onMouseUp
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    }));
}));
// Tools including enzyme rely on components having a display name
Button.displayName = 'Button';
exports.default = Button;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","@swc/helpers/_/_sliced_to_array":"8PtL6","react/jsx-runtime":"bGvcw","react":"ltHCL","@atlaskit/ds-lib/noop":"2f3bg","./shared/button-base":"7LoHE","./shared/get-css":"34ado","./shared/get-is-only-single-icon":"icn9U","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6T4j0":[function(require,module,exports,__globalThis) {
// This allows you to import Checkbox as a default or named export
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return 0, _checkboxDefault.default;
});
parcelHelpers.export(exports, "Checkbox", function() {
    return 0, _checkboxDefault.default;
});
var _checkbox = require("./checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);

},{"./checkbox":"iPMxO","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iPMxO":[function(require,module,exports,__globalThis) {
/* checkbox.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _usePlatformLeafEventHandler = require("@atlaskit/analytics-next/usePlatformLeafEventHandler");
var _mergeRefs = require("@atlaskit/ds-lib/merge-refs");
var _mergeRefsDefault = parcelHelpers.interopDefault(_mergeRefs);
var _checkboxIcon = require("./internal/checkbox-icon");
var _checkboxIconDefault = parcelHelpers.interopDefault(_checkboxIcon);
var _label = require("./internal/label");
var _labelDefault = parcelHelpers.interopDefault(_label);
var _labelText = require("./internal/label-text");
var _labelTextDefault = parcelHelpers.interopDefault(_labelText);
var _requiredIndicator = require("./internal/required-indicator");
var _requiredIndicatorDefault = parcelHelpers.interopDefault(_requiredIndicator);
/**
 * The input is visually hidden but remains in the DOM for accessibility.
 * State-based styling is handled by the Label component using CSS custom properties
 * that cascade to the CheckboxIcon, avoiding nested sibling selectors.
 */ var checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf"
};
/**
 * __Checkbox__
 *
 * A checkbox an input control that allows a user to select one or more options from a number of choices.
 *
 * - [Examples](https://atlassian.design/components/checkbox/examples)
 * - [Code](https://atlassian.design/components/checkbox/code)
 * - [Usage](https://atlassian.design/components/checkbox/usage)
 */ var Checkbox = /*#__PURE__*/ (0, _react.memo)(/*#__PURE__*/ (0, _react.forwardRef)(function Checkbox(_param, ref) {
    var isCheckedProp = _param.isChecked, _param_isDisabled = _param.isDisabled, isDisabled = _param_isDisabled === void 0 ? false : _param_isDisabled, _param_isInvalid = _param.isInvalid, isInvalid = _param_isInvalid === void 0 ? false : _param_isInvalid, _param_defaultChecked = _param.defaultChecked, defaultChecked = _param_defaultChecked === void 0 ? false : _param_defaultChecked, _param_isIndeterminate = _param.isIndeterminate, isIndeterminate = _param_isIndeterminate === void 0 ? false : _param_isIndeterminate, onChangeProps = _param.onChange, analyticsContext = _param.analyticsContext, label = _param.label, name = _param.name, value = _param.value, isRequired = _param.isRequired, testId = _param.testId, xcss = _param.xcss, className = _param.className, rest = (0, _objectWithoutProperties._)(_param, [
        "isChecked",
        "isDisabled",
        "isInvalid",
        "defaultChecked",
        "isIndeterminate",
        "onChange",
        "analyticsContext",
        "label",
        "name",
        "value",
        "isRequired",
        "testId",
        "xcss",
        "className"
    ]);
    var _useState = (0, _slicedToArray._)((0, _react.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked), 2), isCheckedState = _useState[0], setIsCheckedState = _useState[1];
    var onChange = (0, _react.useCallback)(function(e, analyticsEvent) {
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    var onChangeAnalytics = (0, _usePlatformLeafEventHandler.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: undefined,
        packageVersion: undefined
    });
    var internalRef = (0, _react.useRef)(null);
    var mergedRefs = (0, _mergeRefsDefault.default)([
        internalRef,
        ref
    ]);
    // Use isChecked from the state if it is controlled
    var isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, _react.useEffect)(function() {
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _labelDefault.default), {
        isDisabled: isDisabled,
        isChecked: isChecked,
        isIndeterminate: isIndeterminate,
        isInvalid: isInvalid,
        label: label,
        id: rest.id ? "".concat(rest.id, "-label") : undefined,
        testId: testId && "".concat(testId, "--checkbox-label"),
        // Currently the rule hasn't been updated to enable "allowed" dynamic pass-throughs.
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", (0, _objectSpreadProps._)((0, _objectSpread._)({
                // It is necessary only for Safari. It allows to render focus styles.
                tabIndex: 0
            }, rest), {
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: (0, _runtime.ax)([
                    checkboxStyles.root,
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && "".concat(testId, "--hidden-checkbox"),
                "data-invalid": isInvalid ? 'true' : undefined
            })),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxIconDefault.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _labelTextDefault.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requiredIndicatorDefault.default), {})
                ]
            })
        ]
    });
}));
Checkbox.displayName = 'Checkbox';
exports.default = Checkbox;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","@swc/helpers/_/_sliced_to_array":"8PtL6","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/analytics-next/usePlatformLeafEventHandler":"8d2dv","@atlaskit/ds-lib/merge-refs":"bhv2L","./internal/checkbox-icon":"8nx6p","./internal/label":"htMtE","./internal/label-text":"7hL22","./internal/required-indicator":"e9ITv","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8nx6p":[function(require,module,exports,__globalThis) {
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
/**
 * Styles for the checkbox icon.
 * CSS custom properties for colors are set by the parent Label element
 * and consumed directly in these styles.
 */ var svgStyles = {
    root: "_nd5lfibj _1reo15vq _18m915vq _v5641mn3 _2rko12b0 _1a3742bt _lcxvglyw _syazmov0 _lswu1kgh _1cwg1i6y",
    rect: "_v56411so _1snbe4h9 _1s17hteq"
};
function getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
        fill: "inherit"
    });
    if (isChecked) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit"
    });
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ var CheckboxIcon = /*#__PURE__*/ (0, _react.memo)(function(param) {
    var isIndeterminate = param.isIndeterminate, isChecked = param.isChecked;
    var icon = (0, _react.useMemo)(function() {
        return getIcon(isIndeterminate, isChecked);
    }, [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        role: "presentation",
        className: (0, _runtime.ax)([
            svgStyles.root
        ]),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5",
                    className: (0, _runtime.ax)([
                        svgStyles.rect
                    ])
                }),
                icon
            ]
        })
    });
});
exports.default = CheckboxIcon;

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"htMtE":[function(require,module,exports,__globalThis) {
/* label.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return Label;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
/**
 * Base state styles with CSS custom properties.
 * Pseudo-selectors (:hover, :focus-within, :active) on the label element
 * update CSS variables that cascade to the CheckboxIcon.
 * This avoids nested sibling selectors.
 *
 * Uses `css` over `cssMap` to work around a bug in Compiled types when
 * using CSS variables in pseudo-selectors.
 */ var baseStyles = null;
var textLabelLayoutStyles = null;
// Checked/Indeterminate state
var checkedStyles = null;
// Invalid state - must override hover/active to maintain red border
var invalidStyles = null;
// Disabled state - must override hover/active to maintain disabled appearance
var disabledStyles = null;
// Disabled + Checked/Indeterminate
var disabledCheckedStyles = null;
function Label(param) {
    var children = param.children, isDisabled = param.isDisabled, isChecked = param.isChecked, isIndeterminate = param.isIndeterminate, isInvalid = param.isInvalid, testId = param.testId, label = param.label, id = param.id, xcss = param.xcss;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
        className: (0, _runtime.ax)([
            "_11c8fhey _1e0c11p5 _1ejihkll _umai184x _1qwn1j9a _f0grrsbi _1c53glyw _1e9d1j28 _syazi7uo _80om73ad _ljcgdfik _1vj5l4ek _dh4gr01l _cz1u1l7x _jom5wc43 _1s071onz _106f1onz",
            label && "_zulp1nu5 _yv0ey09t",
            (isChecked || isIndeterminate) && "_1qwnjmqp _f0grjmqp _1e9d5w2r _1vj51q28 _q29q1q28 _dh4gr01l _cz1u1l7x _zoo95w2r _jom5wc43 _1s071onz _106f1onz",
            isInvalid && "_f0gr1bqt _q29q1bqt _cz1u1bqt _1s07gir2",
            isDisabled && "_1qwnby5v _f0grby5v _syaz1gmx _80om13gf _1vj5by5v _q29qby5v _dh4gby5v _cz1uby5v _jom5wc43 _1s0718qt _106f18qt",
            isDisabled && (isChecked || isIndeterminate) && "_1e9d2sac _9js12sac _zoo92sac",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
}

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7hL22":[function(require,module,exports,__globalThis) {
/* label-text.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return LabelText;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var labelTextStyles = null;
function LabelText(param) {
    var children = param.children;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: (0, _runtime.ax)([
            "_nd5l11ig _1wpz1h6o"
        ]),
        children: children
    });
}

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"e9ITv":[function(require,module,exports,__globalThis) {
/* required-indicator.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return RequiredIndicator;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var requiredIndicatorStyles = null;
function RequiredIndicator() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        "aria-hidden": true,
        className: (0, _runtime.ax)([
            "_syaz1tmw _bozgv77o"
        ]),
        children: "*"
    });
}

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1ZYq3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return 0, _formDefault.default;
});
parcelHelpers.export(exports, "FormHeader", function() {
    return 0, _formHeaderDefault.default;
});
parcelHelpers.export(exports, "FormFooter", function() {
    return 0, _formFooterDefault.default;
});
parcelHelpers.export(exports, "FormSection", function() {
    return 0, _formSectionDefault.default;
});
parcelHelpers.export(exports, "Field", function() {
    return 0, _fieldDefault.default;
});
parcelHelpers.export(exports, "CheckboxField", function() {
    return 0, _checkboxFieldDefault.default;
});
parcelHelpers.export(exports, "RangeField", function() {
    return 0, _rangeFieldDefault.default;
});
parcelHelpers.export(exports, "Label", function() {
    return 0, _label.Label;
});
parcelHelpers.export(exports, "Legend", function() {
    return 0, _label.Legend;
});
parcelHelpers.export(exports, "HelperMessage", function() {
    return 0, _messages.HelperMessage;
});
parcelHelpers.export(exports, "ErrorMessage", function() {
    return 0, _messages.ErrorMessage;
});
parcelHelpers.export(exports, "MessageWrapper", function() {
    return 0, _messages.MessageWrapper;
});
parcelHelpers.export(exports, "ValidMessage", function() {
    return 0, _messages.ValidMessage;
});
parcelHelpers.export(exports, "Fieldset", function() {
    return 0, _fieldsetDefault.default;
});
parcelHelpers.export(exports, "RequiredAsterisk", function() {
    return 0, _requiredAsteriskDefault.default;
});
parcelHelpers.export(exports, "useFormState", function() {
    return 0, _useFormState.useFormState;
});
parcelHelpers.export(exports, "CharacterCounterField", function() {
    return 0, _characterCounterFieldDefault.default;
});
parcelHelpers.export(exports, "CharacterCounter", function() {
    return 0, _characterCounterDefault.default;
});
var _form = require("./form");
var _formDefault = parcelHelpers.interopDefault(_form);
var _formHeader = require("./form-header");
var _formHeaderDefault = parcelHelpers.interopDefault(_formHeader);
var _formFooter = require("./form-footer");
var _formFooterDefault = parcelHelpers.interopDefault(_formFooter);
var _formSection = require("./form-section");
var _formSectionDefault = parcelHelpers.interopDefault(_formSection);
var _field = require("./field");
var _fieldDefault = parcelHelpers.interopDefault(_field);
var _checkboxField = require("./checkbox-field");
var _checkboxFieldDefault = parcelHelpers.interopDefault(_checkboxField);
var _rangeField = require("./range-field");
var _rangeFieldDefault = parcelHelpers.interopDefault(_rangeField);
var _label = require("./label");
var _messages = require("./messages");
var _fieldset = require("./fieldset");
var _fieldsetDefault = parcelHelpers.interopDefault(_fieldset);
var _requiredAsterisk = require("./required-asterisk");
var _requiredAsteriskDefault = parcelHelpers.interopDefault(_requiredAsterisk);
var _useFormState = require("./use-form-state");
var _characterCounterField = require("./character-counter-field");
var _characterCounterFieldDefault = parcelHelpers.interopDefault(_characterCounterField);
var _characterCounter = require("./character-counter");
var _characterCounterDefault = parcelHelpers.interopDefault(_characterCounter);

},{"./form":"iUKvx","./form-header":false,"./form-footer":false,"./form-section":false,"./field":"bowko","./checkbox-field":false,"./range-field":false,"./label":false,"./messages":"bruyW","./fieldset":"boYwl","./required-asterisk":"giFGQ","./use-form-state":false,"./character-counter-field":false,"./character-counter":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iUKvx":[function(require,module,exports,__globalThis) {
/* form.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormContext", function() {
    return FormContext;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _finalForm = require("final-form");
var _finalFormFocus = require("final-form-focus");
var _finalFormFocusDefault = parcelHelpers.interopDefault(_finalFormFocus);
var _set = require("lodash/set");
var _setDefault = parcelHelpers.interopDefault(_set);
var _forwardRefWithGeneric = require("@atlaskit/ds-lib/forward-ref-with-generic");
var _forwardRefWithGenericDefault = parcelHelpers.interopDefault(_forwardRefWithGeneric);
var _mergeRefs = require("@atlaskit/ds-lib/merge-refs");
var _mergeRefsDefault = parcelHelpers.interopDefault(_mergeRefs);
var _isDisabledContext = require("./is-disabled-context");
var _utils = require("./utils");
var FormContext = /*#__PURE__*/ (0, _react.createContext)({
    registerField: function registerField() {
        return function() {};
    },
    getCurrentValue: function() {
        return undefined;
    },
    subscribe: function subscribe() {
        return function() {};
    }
});
var FormBase = function(props, ref) {
    var autocomplete = props.autocomplete, userProvidedFormProps = props.formProps, id = props.id, label = props.label, labelId = props.labelId, name = props.name, noValidate = props.noValidate, onSubmit = props.onSubmit, testId = props.testId, xcss = props.xcss;
    var formRef = (0, _react.useRef)(null);
    var onSubmitRef = (0, _react.useRef)(onSubmit);
    onSubmitRef.current = onSubmit;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(function() {
        var _onSubmitRef;
        // Types here would break the existing API
        var finalForm = (0, _finalForm.createForm)({
            onSubmit: function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return (_onSubmitRef = onSubmitRef).current.apply(_onSubmitRef, (0, _toConsumableArray._)(args));
            },
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: function(param, state) {
                    var _param = (0, _slicedToArray._)(param, 2), name = _param[0], defaultValue = _param[1];
                    if (state.formState.initialValues) {
                        var initialValues = state.formState.initialValues;
                        var values = state.formState.values;
                        var value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        (0, _setDefault.default)(initialValues, name, value);
                        (0, _setDefault.default)(values, name, value);
                    }
                }
            }
        });
        (0, _finalFormFocusDefault.default)(function() {
            return formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [];
        }, (0, _utils.getFirstErrorField))(finalForm);
        return finalForm;
    }), 1), form = _useState[0];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)({
        dirty: false,
        submitting: false
    }), 2), state = _useState1[0], setState = _useState1[1];
    (0, _react.useEffect)(function() {
        var unsubscribe = form.subscribe(function(param) {
            var dirty = param.dirty, submitting = param.submitting;
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    var registerField = (0, _react.useCallback)(function(name, defaultValue, subscriber, subscription, config) {
        form.pauseValidation();
        var unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    var handleSubmit = function(e) {
        if (e) e.preventDefault();
        form.submit();
    };
    var handleReset = function(initialValues) {
        form.reset(initialValues);
    };
    var handleKeyDown = function(e) {
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            var submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    var _props_isDisabled = props.isDisabled, isDisabled = _props_isDisabled === void 0 ? false : _props_isDisabled, children = props.children;
    var dirty = state.dirty, submitting = state.submitting;
    /**
   * This method is needed in FormContext to use it on the field level
   * to check the current value of the field in case of the component re-mounting.
   */ var getCurrentValue = (0, _react.useCallback)(function(name) {
        var formState = form.getState();
        return (formState === null || formState === void 0 ? void 0 : formState.values[name]) || undefined;
    }, [
        form
    ]);
    var FormContextValue = (0, _react.useMemo)(function() {
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    var conditionalFormProps = {
        autocomplete: autocomplete,
        className: xcss,
        id: id,
        'aria-label': label,
        'aria-labelledby': labelId,
        name: name,
        noValidate: noValidate,
        'data-testid': testId
    };
    // Abstracting so we can use the same for both rendering patterns
    var formProps = {
        onKeyDown: handleKeyDown,
        onSubmit: handleSubmit,
        ref: ref ? (0, _mergeRefsDefault.default)([
            ref,
            formRef
        ]) : formRef
    };
    // We don't want to add undefined values to the component
    Object.keys(conditionalFormProps).forEach(function(attr) {
        if (conditionalFormProps[attr] !== undefined) formProps[attr] = conditionalFormProps[attr];
    });
    var childrenContent = function() {
        if (typeof children === 'function') {
            var result = children.length > 0 ? children({
                formProps: formProps,
                dirty: dirty,
                reset: handleReset,
                submitting: submitting,
                disabled: isDisabled,
                getState: function() {
                    return form.getState();
                },
                getValues: function() {
                    return form.getState().values;
                },
                setFieldValue: form.change,
                resetFieldState: form.resetFieldState
            }) : children();
            return result === undefined ? null : result;
        } else return /*#__PURE__*/ (0, _jsxRuntime.jsx)("form", (0, _objectSpreadProps._)((0, _objectSpread._)({}, formProps, userProvidedFormProps), {
            children: children
        }));
    }();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(FormContext.Provider, {
        value: FormContextValue,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _isDisabledContext.IsDisabledContext).Provider, {
            value: isDisabled,
            children: childrenContent
        })
    });
};
/**
 * __Form__
 *
 * A form allows users to input information.
 *
 * - [Examples](https://atlassian.design/components/form/examples)
 * - [Code](https://atlassian.design/components/form/code)
 * - [Usage](https://atlassian.design/components/form/usage)
 */ var Form = (0, _forwardRefWithGenericDefault.default)(FormBase);
exports.default = Form;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_to_consumable_array":"1eSZf","react/jsx-runtime":"bGvcw","react":"ltHCL","final-form":"gSo5N","final-form-focus":"jAbkv","lodash/set":"lT2WR","@atlaskit/ds-lib/forward-ref-with-generic":"lGsVr","@atlaskit/ds-lib/merge-refs":"bhv2L","./is-disabled-context":"8vGSQ","./utils":"8sPZa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gSo5N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ARRAY_ERROR", function() {
    return ARRAY_ERROR;
});
parcelHelpers.export(exports, "FORM_ERROR", function() {
    return FORM_ERROR;
});
parcelHelpers.export(exports, "configOptions", function() {
    return configOptions;
});
parcelHelpers.export(exports, "createForm", function() {
    return createForm;
});
parcelHelpers.export(exports, "fieldSubscriptionItems", function() {
    return fieldSubscriptionItems;
});
parcelHelpers.export(exports, "formSubscriptionItems", function() {
    return formSubscriptionItems;
});
parcelHelpers.export(exports, "getIn", function() {
    return getIn;
});
parcelHelpers.export(exports, "setIn", function() {
    return setIn;
});
parcelHelpers.export(exports, "version", function() {
    return version;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
var _typeOf = require("@swc/helpers/_/_type_of");
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
//      
var charCodeOfDot = ".".charCodeAt(0);
var reEscapeChar = /\\(\\)?/g;
var rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === charCodeOfDot) result.push("");
    string.replace(rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace(reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var keysCache = {};
var keysRegex = /[.[\]]+/;
var toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if (keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        keysCache[key] = key.split(keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        keysCache[key] = stringToPath(key);
    }
    return keysCache[key];
};
//      
var getIn = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || (typeof current === "undefined" ? "undefined" : (0, _typeOf._)(current)) !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : (0, _typeOf._)(key)) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if ((typeof input === "undefined" ? "undefined" : (0, _typeOf._)(input)) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((typeof res === "undefined" ? "undefined" : (0, _typeOf._)(res)) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, _objectWithoutPropertiesLooseDefault.default)(current, [
                key
            ].map(_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, _extendsDefault.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var setIn = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return setInRecursor(state, 0, toPath(key), value1, destroyArrays);
};
var FORM_ERROR = "FINAL_FORM/form-error";
var ARRAY_ERROR = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = getIn(values, name);
    var error = getIn(errors, name);
    if (error && error[ARRAY_ERROR]) error = error[ARRAY_ERROR];
    var submitError = submitErrors && getIn(submitErrors, name);
    var initial = initialValues && getIn(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual(getIn(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var fieldSubscriptionItems = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if ((typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)) !== "object" || !a || (typeof b === "undefined" ? "undefined" : (0, _typeOf._)(b)) !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = subscriptionFilter(result, state, previousState, subscription, fieldSubscriptionItems, shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var formSubscriptionItems = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = subscriptionFilter(result, state, previousState, subscription, formSubscriptionItems, shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var isPromise = function isPromise(obj) {
    return !!obj && ((typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj)) === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var version = "4.20.10";
var configOptions = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && (typeof value1 === "undefined" ? "undefined" : (0, _typeOf._)(value1)) === "object" && !(0, _instanceof._)(value1, Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if (notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function createForm(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, _extendsDefault.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, _extendsDefault.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = getIn(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = setIn(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, _extendsDefault.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, _extendsDefault.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, _extendsDefault.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var _$value = getIn(state.formState.values, from);
            state.formState.values = setIn(state.formState.values, from, undefined) || {};
            state.formState.values = setIn(state.formState.values, to, _$value);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: getIn,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: setIn,
                    shallowEqual: shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, _extendsDefault.default)({}, state.formState.values)); // clone to avoid writing
            if (isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator(getIn(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, _extendsDefault.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, _extendsDefault.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = getIn(recordLevelErrors, name);
                        var errorFromParent = getIn(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = setIn(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[ARRAY_ERROR]) {
                    var existing = getIn(merged, name);
                    var copy = [].concat(existing);
                    copy[ARRAY_ERROR] = error[ARRAY_ERROR];
                    merged = setIn(merged, name, copy);
                }
            });
            if (!shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[FORM_ERROR];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, _extendsDefault.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) notify(fieldSubscriber, fieldState, lastFieldState, filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, _extendsDefault.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual(getIn(formState.values, key), getIn(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual(getIn(formState.values, key), getIn(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !hasAnyError(formState.errors) && !(formState.submitErrors && hasAnyError(formState.submitErrors));
        var nextFormState = convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    notify(state.subscribers, nextFormState, lastFormState, filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, _extendsDefault.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if (getIn(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, _extendsDefault.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, _extendsDefault.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual(getIn(formState.values, key), getIn(formState.initialValues || {}, key));
                if (!pristine) result[key] = getIn(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = setIn(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = getIn(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || getIn(state.formState.values, name) === getIn(state.formState.initialValues, name))) {
                    state.formState.initialValues = setIn(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = setIn(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && getIn(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = setIn(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = setIn(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = setIn(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, _extendsDefault.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, _extendsDefault.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, _extendsDefault.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[FORM_ERROR];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, _extendsDefault.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            notifySubscriber(memoized, subscription, nextFormState, nextFormState, filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

},{"@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_type_of":"iFJdx","@babel/runtime/helpers/esm/extends":"3LZYG","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"5JG3D","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jAbkv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFormInputs", function() {
    return getFormInputs;
});
var _finalForm = require("final-form");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter(isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, _finalForm.getIn)(errors, input.name);
    });
};
//      
var noop = function noop() {};
var createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = getAllInputs;
            if (!findInput$$1) findInput$$1 = findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var getFormInputs = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter(isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
//
exports.default = createDecorator;

},{"final-form":"gSo5N","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lT2WR":[function(require,module,exports,__globalThis) {
var baseSet = require("a28205848a34d70");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function set(object, path, value) {
    return object == null ? object : baseSet(object, path, value);
}
module.exports = set;

},{"a28205848a34d70":"117LL"}],"117LL":[function(require,module,exports,__globalThis) {
var assignValue = require("4b8a459255843724"), castPath = require("f34439c003d1a858"), isIndex = require("50cf4a15cc8c9371"), isObject = require("df62e2a3f5ec7efa"), toKey = require("72c6823d333373c7");
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function baseSet(object, path, value, customizer) {
    if (!isObject(object)) return object;
    path = castPath(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = toKey(path[index]), newValue = value;
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
module.exports = baseSet;

},{"4b8a459255843724":"gVboZ","f34439c003d1a858":"dcAtc","50cf4a15cc8c9371":"7YwKX","df62e2a3f5ec7efa":"cGl8g","72c6823d333373c7":"20tbd"}],"dcAtc":[function(require,module,exports,__globalThis) {
var isArray = require("8eba1034040ab83f"), isKey = require("b36b94566ba2ae39"), stringToPath = require("6ab0a7b5e77b3289"), toString = require("9b301dc4cabf70f1");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value, object) {
    if (isArray(value)) return value;
    return isKey(value, object) ? [
        value
    ] : stringToPath(toString(value));
}
module.exports = castPath;

},{"8eba1034040ab83f":"7eHCl","b36b94566ba2ae39":"8lMJI","6ab0a7b5e77b3289":"lTmin","9b301dc4cabf70f1":"hWGy5"}],"8lMJI":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
var isArray = require("cc1412d0e3a3674e"), isSymbol = require("f321ffcbb81c5993");
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    if (isArray(value)) return false;
    var type = typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value);
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = isKey;

},{"@swc/helpers/_/_type_of":"iFJdx","cc1412d0e3a3674e":"7eHCl","f321ffcbb81c5993":"iaMVe"}],"iaMVe":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
var baseGetTag = require("e344678315216c84"), isObjectLike = require("9171f30f91feab88");
/** `Object#toString` result references. */ var symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return (typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
}
module.exports = isSymbol;

},{"@swc/helpers/_/_type_of":"iFJdx","e344678315216c84":"5NOi0","9171f30f91feab88":"eoT9f"}],"lTmin":[function(require,module,exports,__globalThis) {
var memoizeCapped = require("811272dee770c1ca");
/** Used to match property names within property paths. */ var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = memoizeCapped(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
    });
    return result;
});
module.exports = stringToPath;

},{"811272dee770c1ca":"dp4mp"}],"dp4mp":[function(require,module,exports,__globalThis) {
var memoize = require("90070e2f8c45f70");
/** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function memoizeCapped(func) {
    var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = memoizeCapped;

},{"90070e2f8c45f70":"d0eCX"}],"d0eCX":[function(require,module,exports,__globalThis) {
var MapCache = require("9af14f8ae5b88293");
/** Error message constants. */ var FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function memoized1() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
}
// Expose `MapCache`.
memoize.Cache = MapCache;
module.exports = memoize;

},{"9af14f8ae5b88293":"bRb09"}],"hWGy5":[function(require,module,exports,__globalThis) {
var baseToString = require("8fd4ff256ab5ec10");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? '' : baseToString(value);
}
module.exports = toString;

},{"8fd4ff256ab5ec10":"cOyPZ"}],"cOyPZ":[function(require,module,exports,__globalThis) {
var Symbol = require("217861e8d34c6bfb"), arrayMap = require("165706c062fe5448"), isArray = require("5d192271a2353a2c"), isSymbol = require("b19f55f4c66ebc6a");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
    if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
module.exports = baseToString;

},{"217861e8d34c6bfb":"c4qDk","165706c062fe5448":"aQnwt","5d192271a2353a2c":"7eHCl","b19f55f4c66ebc6a":"iaMVe"}],"aQnwt":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = arrayMap;

},{}],"20tbd":[function(require,module,exports,__globalThis) {
var isSymbol = require("9df83a5f9c1faf53");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == 'string' || isSymbol(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
module.exports = toKey;

},{"9df83a5f9c1faf53":"iaMVe"}],"lGsVr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
/**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ exports.default = (0, _react.forwardRef);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8vGSQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IsDisabledContext", function() {
    return IsDisabledContext;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var IsDisabledContext = /*#__PURE__*/ (0, _react.createContext)(false);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8sPZa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFirstErrorField", function() {
    return getFirstErrorField;
});
var _finalForm = require("final-form");
var getFirstErrorField = function(inputs, errors) {
    // Guaranteed to be of type HTMLInputElement[] due to getInputs function overrided in createDecorator
    var htmlInputs = inputs;
    return htmlInputs.find(function(input) {
        // If input is hidden, do not focus
        if (input.type === 'hidden') return false;
        // If input ID matches the error, focus
        if (input.id && (0, _finalForm.getIn)(errors, input.id)) return true;
        // Default to base behavior
        return input.name && (0, _finalForm.getIn)(errors, input.name);
    });
};

},{"final-form":"gSo5N","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bowko":[function(require,module,exports,__globalThis) {
/* field.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return Field;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var _jsxRuntime = require("react/jsx-runtime");
var _runtime = require("@compiled/react/runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useId = require("@atlaskit/ds-lib/use-id");
var _fieldIdContext = require("./field-id-context");
var _form = require("./form");
var _isDisabledContext = require("./is-disabled-context");
var _label = require("./label");
var _messages = require("./messages");
var _requiredAsterisk = require("./required-asterisk");
var _requiredAsteriskDefault = parcelHelpers.interopDefault(_requiredAsterisk);
var fieldWrapperStyles = null;
function isEvent(event) {
    return Boolean(event && event.target);
}
function isFunction(x) {
    return typeof x === 'function';
}
function usePreviousRef(current) {
    var ref = (0, _react.useRef)(current);
    // will be updated on the next render
    (0, _react.useEffect)(function() {
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if ((typeof previousValue === "undefined" ? "undefined" : (0, _typeOf._)(previousValue)) === 'object' && (typeof currentValue === "undefined" ? "undefined" : (0, _typeOf._)(currentValue)) === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function Field(props) {
    var _props_children = props.children, children = _props_children === void 0 ? function() {
        return null;
    } : _props_children, component = props.component;
    var _useContext = (0, _react.useContext)((0, _form.FormContext)), registerField = _useContext.registerField, getCurrentValue = _useContext.getCurrentValue;
    var isDisabled = (0, _react.useContext)((0, _isDisabledContext.IsDisabledContext)) || props.isDisabled || false;
    var defaultValue = isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    var latestPropsRef = usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ var isDefaultValueChanged = !isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    var _getCurrentValue;
    var _useState = (0, _slicedToArray._)((0, _react.useState)({
        fieldProps: {
            onChange: function() {},
            onBlur: function() {},
            onFocus: function() {},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
       * effectively made it an optional prop to external consumers of Field. However the
       * prop types defined defaultValue as required, so inside the component it was not
       * valid for defaultValue to be undefined. We need to suppress the error
       * after changing defaultValue to explicitly be an optional prop.
       * If default value has changed we are using new default value.
       * Otherwise we need to check if we already have value for this field
       * (because we are using changing key prop to re-run field level validation, and that
       * cause the component re-mounting) to not override the actual value with the default value.
       */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : (_getCurrentValue = getCurrentValue(props.name)) !== null && _getCurrentValue !== void 0 ? _getCurrentValue : defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    }), 2), state = _useState[0], setState = _useState[1];
    var latestStateRef = usePreviousRef(state);
    (0, _react.useEffect)(function() {
        function fieldStateToMeta() {
            var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        var unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, function(fieldState) {
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ var modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ var modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ var modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            var modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ var modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if (isEvent(eventOrValue)) {
                    var currentTarget = eventOrValue.currentTarget;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                    return;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: function(e) {
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: function() {
                return function validate(value, formState, fieldState) {
                    var supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                };
            }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        props.isRequired,
        isDefaultValueChanged
    ]);
    var uid = (0, _useId.useId)();
    var fieldId = (0, _react.useMemo)(function() {
        return props.id ? props.id : "".concat(props.name, "-").concat(uid);
    }, [
        props.id,
        props.name,
        uid
    ]);
    var getDescribedBy = function() {
        var value = '';
        if (state.error) value += "".concat(fieldId, "-error ");
        if (state.valid) value += "".concat(fieldId, "-valid ");
        return "".concat(value).concat(fieldId, "-helper");
    };
    var extendedFieldProps = (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.fieldProps), {
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-required': String(Boolean(props.isRequired)),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': "".concat(fieldId, "-label"),
        id: fieldId
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        "data-testid": props.testId,
        className: (0, _runtime.ax)([
            "_1pfhu2gc"
        ]),
        children: [
            props.label && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _label.Label), {
                htmlFor: fieldId,
                id: "".concat(fieldId, "-label"),
                testId: props.testId && "".concat(props.testId, "--label"),
                children: [
                    props.label,
                    props.isRequired && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requiredAsteriskDefault.default), {}),
                    props.elementAfterLabel
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fieldIdContext.FieldId).Provider, {
                value: fieldId,
                children: component ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                    children: [
                        component({
                            fieldProps: extendedFieldProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _messages.MessageWrapper), {
                            children: [
                                props.helperMessage && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _messages.HelperMessage), {
                                    children: props.helperMessage
                                }),
                                state.error && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _messages.ErrorMessage), {
                                    children: props.errorMessage || state.error
                                }),
                                state.meta.touched && state.valid && props.validMessage && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _messages.ValidMessage), {
                                    children: props.validMessage
                                })
                            ]
                        })
                    ]
                }) : children({
                    fieldProps: extendedFieldProps,
                    error: state.error,
                    valid: state.valid,
                    meta: state.meta
                })
            })
        ]
    });
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_type_of":"iFJdx","react/jsx-runtime":"bGvcw","@compiled/react/runtime":"d27Vo","react":"ltHCL","@atlaskit/ds-lib/use-id":"axFod","./field-id-context":"gOp9v","./form":"iUKvx","./is-disabled-context":"8vGSQ","./label":"6iMOq","./messages":"bruyW","./required-asterisk":"giFGQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gOp9v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FieldId", function() {
    return FieldId;
});
var _react = require("react");
var FieldId = /*#__PURE__*/ (0, _react.createContext)(undefined);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6iMOq":[function(require,module,exports,__globalThis) {
/* label.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Label", function() {
    return Label;
});
parcelHelpers.export(exports, "Legend", function() {
    return Legend;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var fieldsetLabelStyles = null;
var Label = function(param) {
    var children = param.children, htmlFor = param.htmlFor, id = param.id, testId = param.testId;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId,
        className: (0, _runtime.ax)([
            "_11c8wadc _1e0c1o8l _syazazsu _k48pwu06 _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });
};
var Legend = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
        className: (0, _runtime.ax)([
            "_11c8wadc _1e0c1o8l _syazazsu _k48pwu06 _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });
};

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bruyW":[function(require,module,exports,__globalThis) {
/* messages.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HelperMessage", function() {
    return HelperMessage;
});
parcelHelpers.export(exports, "ErrorMessage", function() {
    return ErrorMessage;
});
parcelHelpers.export(exports, "ValidMessage", function() {
    return ValidMessage;
});
parcelHelpers.export(exports, "MessageWrapper", function() {
    return MessageWrapper;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _statusError = require("@atlaskit/icon/core/status-error");
var _statusErrorDefault = parcelHelpers.interopDefault(_statusError);
var _statusSuccess = require("@atlaskit/icon/core/status-success");
var _statusSuccessDefault = parcelHelpers.interopDefault(_statusSuccess);
var _fieldIdContext = require("./field-id-context");
var messageStyles = null;
var messageAppearanceStyles = {
    default: "_syaz1rpy",
    error: "_syaz1tmw",
    valid: "_syazgsak"
};
var iconWrapperStyles = {
    root: "_1e0c1txw _4t3i7vkz _4cvr1h6o"
};
var IconWrapper = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: (0, _runtime.ax)([
            iconWrapperStyles.root
        ]),
        children: children
    });
};
var messageIcons = {
    error: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusErrorDefault.default), {
        color: "currentColor",
        label: "error",
        size: "small"
    }),
    valid: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusSuccessDefault.default), {
        color: "currentColor",
        label: "success",
        size: "small"
    })
};
var Message = function(param) {
    var children = param.children, _param_appearance = param.appearance, appearance = _param_appearance === void 0 ? 'default' : _param_appearance, fieldId = param.fieldId, testId = param.testId;
    var icon = messageIcons[appearance];
    var messageRef = (0, _react.useRef)(null);
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), hasMessageWrapper = _useState[0], setHasMessageWrapper = _useState[1];
    var isWrapper = (0, _react.useContext)(MessageWrapperContext).isWrapper;
    (0, _react.useEffect)(function() {
        if (messageRef.current) setHasMessageWrapper(isWrapper);
    }, [
        isWrapper
    ]);
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ var content = typeof children === 'string' ? children : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        children: children
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        "data-testid": testId,
        id: fieldId,
        ref: messageRef,
        // For backwards compatability, if there is a wrapper, aria-live is not needed
        "aria-live": !hasMessageWrapper ? 'polite' : undefined,
        className: (0, _runtime.ax)([
            "_zulp12x7 _11c8wadc _1e0c1txw _1bah1q9y _1pfh1b66",
            messageAppearanceStyles[appearance]
        ]),
        children: [
            icon && /*#__PURE__*/ (0, _jsxRuntime.jsx)(IconWrapper, {
                children: icon
            }),
            content
        ]
    });
};
var HelperMessage = function(param) {
    var children = param.children, testId = param.testId;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fieldIdContext.FieldId).Consumer, {
        children: function(fieldId) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Message, {
                fieldId: fieldId ? "".concat(fieldId, "-helper") : undefined,
                testId: testId,
                children: children
            });
        }
    });
};
var ErrorMessage = function(param) {
    var children = param.children, testId = param.testId;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fieldIdContext.FieldId).Consumer, {
        children: function(fieldId) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Message, {
                appearance: "error",
                fieldId: fieldId ? "".concat(fieldId, "-error") : undefined,
                testId: testId,
                children: children
            });
        }
    });
};
var ValidMessage = function(param) {
    var children = param.children, testId = param.testId;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fieldIdContext.FieldId).Consumer, {
        children: function(fieldId) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Message, {
                appearance: "valid",
                fieldId: fieldId ? "".concat(fieldId, "-valid") : undefined,
                testId: testId,
                children: children
            });
        }
    });
};
/**
 * __Message wrapper context__
 *
 * A message wrapper context allows the children to check
 * if it is contained within the MessageWrapper.
 */ var MessageWrapperContext = /*#__PURE__*/ (0, _react.createContext)({
    isWrapper: false
});
var MessageWrapper = function(param) {
    var children = param.children;
    var contextValue = {
        isWrapper: true
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(MessageWrapperContext.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            "aria-live": "polite",
            "data-testid": "message-wrapper",
            children: children
        })
    });
};

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/icon/core/status-error":"gJMKC","@atlaskit/icon/core/status-success":"4HNQp","./field-id-context":"gOp9v","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"giFGQ":[function(require,module,exports,__globalThis) {
/* required-asterisk.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return RequiredAsterisk;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var requiredIndicatorStyles = null;
function RequiredAsterisk() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        "aria-hidden": "true",
        title: "required",
        className: (0, _runtime.ax)([
            "_syaz1tmw _ect4ttxp _bozgv77o"
        ]),
        children: "*"
    });
}

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"boYwl":[function(require,module,exports,__globalThis) {
/* fieldset.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _label = require("./label");
var fieldSetStyles = null;
/**
 * __Fieldset__
 *
 * A fieldset groups a number of fields together. For example, when multiple CheckboxFields share the same name,
 * a fieldset can be used to group them together. This makes the form more accessible.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields)
 */ var Fieldset = function(param) {
    var children = param.children, legend = param.legend;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
        className: (0, _runtime.ax)([
            "_1pfhu2gc"
        ]),
        children: [
            legend && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _label.Legend), {
                children: legend
            }),
            children
        ]
    });
};
exports.default = Fieldset;

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","./label":"6iMOq","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1WBY4":[function(require,module,exports,__globalThis) {
// Ideally this file is not used directly. But rather, you go through the entry points
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return 0, _linkDefault.default;
});
var _link = require("./components/link");
var _linkDefault = parcelHelpers.interopDefault(_link);

},{"./components/link":"3EfCS","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3EfCS":[function(require,module,exports,__globalThis) {
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _css = require("@atlaskit/css");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _compiled = require("@atlaskit/primitives/compiled");
var styles = {
    base: "_ect4ttxp",
    baseT26Shape: "_2rkolb4i",
    visitedLink: "_10531ra0 _1ien1ra0 _n0fx1ra0 _1vhv17z1",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz13af _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1r31 _1bnxglyw _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazazsu _1a3b1r31 _4fprglyw _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
var iconStyles = null;
var LinkWithoutRef = function(_param, ref) {
    var children = _param.children, testId = _param.testId, _param_appearance = _param.appearance, appearance = _param_appearance === void 0 ? 'default' : _param_appearance, newWindowLabel = _param.newWindowLabel, target = _param.target, // @ts-expect-error
    _preventedClassName = _param.className, // @ts-expect-error
    _preventedStyle = _param.style, htmlAttributes = (0, _objectWithoutProperties._)(_param, [
        "children",
        "testId",
        "appearance",
        "newWindowLabel",
        "target",
        "className",
        "style"
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _compiled.Anchor), (0, _objectSpreadProps._)((0, _objectSpread._)({}, htmlAttributes), {
        target: target,
        ref: ref,
        xcss: (0, _css.cx)(styles.base, (0, _platformFeatureFlags.fg)('platform-dst-shape-theme-default') && styles.baseT26Shape, appearance === 'default' && styles.defaultAppearance, appearance === 'subtle' && styles.subtleAppearance, appearance === 'inverse' && styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel,
        children: [
            children,
            target === '_blank' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _compiled.Box), {
                as: "span",
                xcss: styles.iconWrapper,
                testId: testId && "".concat(testId, "__icon"),
                children: [
                    "\uFEFF",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        className: (0, _runtime.ax)([
                            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
                        ]),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                            fill: "currentColor"
                        })
                    })
                ]
            })
        ]
    }));
};
// Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ var Link = /*#__PURE__*/ (0, _react.forwardRef)(LinkWithoutRef);
exports.default = Link;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/css":"fiaHp","@atlaskit/platform-feature-flags":"kO5t9","@atlaskit/primitives/compiled":"jhQE8","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6s9iq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return 0, _modalDialogDefault.default;
});
parcelHelpers.export(exports, "ModalTransition", function() {
    return 0, _modalTransitionDefault.default;
});
parcelHelpers.export(exports, "ModalHeader", function() {
    return 0, _modalHeaderDefault.default;
});
parcelHelpers.export(exports, "ModalTitle", function() {
    return 0, _modalTitleDefault.default;
});
parcelHelpers.export(exports, "ModalBody", function() {
    return 0, _modalBodyDefault.default;
});
parcelHelpers.export(exports, "ModalFooter", function() {
    return 0, _modalFooterDefault.default;
});
parcelHelpers.export(exports, "CloseButton", function() {
    return 0, _closeButton.CloseButton;
});
parcelHelpers.export(exports, "useModal", function() {
    return 0, _hooks.useModal;
});
var _modalDialog = require("./modal-dialog");
var _modalDialogDefault = parcelHelpers.interopDefault(_modalDialog);
var _modalTransition = require("./modal-transition");
var _modalTransitionDefault = parcelHelpers.interopDefault(_modalTransition);
var _modalHeader = require("./modal-header");
var _modalHeaderDefault = parcelHelpers.interopDefault(_modalHeader);
var _modalTitle = require("./modal-title");
var _modalTitleDefault = parcelHelpers.interopDefault(_modalTitle);
var _modalBody = require("./modal-body");
var _modalBodyDefault = parcelHelpers.interopDefault(_modalBody);
var _modalFooter = require("./modal-footer");
var _modalFooterDefault = parcelHelpers.interopDefault(_modalFooter);
var _closeButton = require("./close-button");
var _hooks = require("./hooks");

},{"./modal-dialog":"3Nz6G","./modal-transition":false,"./modal-header":"7jAuN","./modal-title":"hGuwm","./modal-body":"ccsmv","./modal-footer":"ap3Lr","./close-button":false,"./hooks":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3Nz6G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return ModalWrapper;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _modalWrapper = require("./internal/components/modal-wrapper");
var _modalWrapperDefault = parcelHelpers.interopDefault(_modalWrapper);
function ModalWrapper(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalWrapperDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        isFullScreen: false
    }));
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","./internal/components/modal-wrapper":"5U5jB","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5U5jB":[function(require,module,exports,__globalThis) {
/* modal-wrapper.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _reactFocusLock = require("react-focus-lock");
var _reactFocusLockDefault = parcelHelpers.interopDefault(_reactFocusLock);
var _reactScrolllock = require("react-scrolllock");
var _reactScrolllockDefault = parcelHelpers.interopDefault(_reactScrolllock);
var _analyticsNext = require("@atlaskit/analytics-next");
var _blanket = require("@atlaskit/blanket");
var _blanketDefault = parcelHelpers.interopDefault(_blanket);
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var _layering = require("@atlaskit/layering");
var _openLayerObserver = require("@atlaskit/layering/experimental/open-layer-observer");
var _motion = require("@atlaskit/motion");
var _fadeIn = require("@atlaskit/motion/fade-in");
var _fadeInDefault = parcelHelpers.interopDefault(_fadeIn);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _portal = require("@atlaskit/portal");
var _portalDefault = parcelHelpers.interopDefault(_portal);
var _constants = require("@atlaskit/theme/constants");
var _useModalStack = require("../hooks/use-modal-stack");
var _useModalStackDefault = parcelHelpers.interopDefault(_useModalStack);
var _usePreventProgrammaticScroll = require("../hooks/use-prevent-programmatic-scroll");
var _usePreventProgrammaticScrollDefault = parcelHelpers.interopDefault(_usePreventProgrammaticScroll);
var _modalDialog = require("./modal-dialog");
var _modalDialogDefault = parcelHelpers.interopDefault(_modalDialog);
var fillScreenStyles = null;
var allowlistElements = function(element, callback) {
    // Allow focus to reach elements outside the modal:
    // if AUI dialog is allowListed and visible
    if (document.querySelector('.aui-blanket:not([hidden])')) return false;
    // allows to pass a callback function to allow elements be ignored by focus lock
    if (typeof callback === 'function') return callback(element);
    return true;
};
/**
 * __Modal wrapper__
 *
 * A modal wrapper displays content that requires user interaction, in a layer above the page.
 * This component is primary container for other modal components.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var InternalModalWrapper = function(props) {
    var _props_autoFocus = props.autoFocus, autoFocus = _props_autoFocus === void 0 ? true : _props_autoFocus, focusLockAllowlist = props.focusLockAllowlist, _props_shouldCloseOnEscapePress = props.shouldCloseOnEscapePress, shouldCloseOnEscapePress = _props_shouldCloseOnEscapePress === void 0 ? true : _props_shouldCloseOnEscapePress, _props_shouldCloseOnOverlayClick = props.shouldCloseOnOverlayClick, shouldCloseOnOverlayClick = _props_shouldCloseOnOverlayClick === void 0 ? true : _props_shouldCloseOnOverlayClick, _props_shouldScrollInViewport = props.shouldScrollInViewport, shouldScrollInViewport = _props_shouldScrollInViewport === void 0 ? false : _props_shouldScrollInViewport, _props_shouldReturnFocus = props.shouldReturnFocus, shouldReturnFocus = _props_shouldReturnFocus === void 0 ? true : _props_shouldReturnFocus, stackIndexOverride = props.stackIndex, providedOnClose = props.onClose, _props_onStackChange = props.onStackChange, onStackChange = _props_onStackChange === void 0 ? (0, _noopDefault.default) : _props_onStackChange, isBlanketHidden = props.isBlanketHidden, children = props.children, height = props.height, width = props.width, onCloseComplete = props.onCloseComplete, onOpenComplete = props.onOpenComplete, label = props.label, testId = props.testId, isFullScreen = props.isFullScreen, _props_UNSAFE_shouldDisableMotionUplift = props.UNSAFE_shouldDisableMotionUplift, UNSAFE_shouldDisableMotionUplift = _props_UNSAFE_shouldDisableMotionUplift === void 0 ? false : _props_UNSAFE_shouldDisableMotionUplift;
    var calculatedStackIndex = (0, _useModalStackDefault.default)({
        onStackChange: onStackChange
    });
    var stackIndex = stackIndexOverride || calculatedStackIndex;
    var isForeground = stackIndex === 0;
    // When a user supplies a ref to focus we skip auto focus via react-focus-lock
    // When flag is true and a ref is not supplied, autofocus is true. See https://product-fabric.atlassian.net/browse/DSP-24307
    // When we remove boolean `autoFocus`, we won't have to worry about this
    var autoFocusLock = typeof autoFocus === 'boolean';
    var onCloseHandler = (0, _analyticsNext.usePlatformLeafEventHandler)({
        fn: providedOnClose || (0, _noopDefault.default),
        action: 'closed',
        componentName: 'modalDialog',
        packageName: undefined,
        packageVersion: undefined
    });
    var onBlanketClicked = (0, _react.useCallback)(function(e) {
        if (shouldCloseOnOverlayClick) onCloseHandler(e);
    }, [
        shouldCloseOnOverlayClick,
        onCloseHandler
    ]);
    // This ensures to prevent additional re-renders while nothing is passed to focusLockAllowlist explicitly.
    var allowListCallback = (0, _react.useCallback)(function(element) {
        return allowlistElements(element, focusLockAllowlist);
    }, [
        focusLockAllowlist
    ]);
    (0, _usePreventProgrammaticScrollDefault.default)();
    (0, _openLayerObserver.useNotifyOpenLayerObserver)({
        type: 'modal',
        // Modal dialog is conditionally rendered when visible, so when this runs it is always open.
        isOpen: true,
        // Passing a no-op for now, as there isn't a real use case for closing the modal dialog programmatically
        // by the OpenLayerObserver. The only current use case is closing layers when resizing the nav layout,
        // which cannot happen while a modal dialog is open.
        onClose: (0, _noopDefault.default)
    });
    var modalDialogWithBlanket = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _blanketDefault.default), {
        isTinted: !isBlanketHidden,
        onBlanketClicked: onBlanketClicked,
        testId: testId && "".concat(testId, "--blanket"),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalDialogDefault.default), {
            testId: testId,
            label: label,
            autoFocus: autoFocus,
            stackIndex: stackIndex,
            onClose: onCloseHandler,
            shouldCloseOnEscapePress: shouldCloseOnEscapePress && isForeground,
            shouldScrollInViewport: shouldScrollInViewport,
            height: height,
            width: width,
            onCloseComplete: onCloseComplete,
            onOpenComplete: onOpenComplete,
            hasProvidedOnClose: Boolean(providedOnClose),
            isFullScreen: isFullScreen,
            UNSAFE_shouldDisableMotionUplift: UNSAFE_shouldDisableMotionUplift,
            children: children
        })
    });
    var returnFocus = true;
    var onDeactivation = (0, _noopDefault.default);
    if ('boolean' === typeof shouldReturnFocus) returnFocus = shouldReturnFocus;
    else onDeactivation = function() {
        window.setTimeout(function() {
            var _shouldReturnFocus_current;
            (_shouldReturnFocus_current = shouldReturnFocus.current) === null || _shouldReturnFocus_current === void 0 ? void 0 : _shouldReturnFocus_current.focus();
        }, 0);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layering.Layering), {
        isDisabled: false,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _portalDefault.default), {
            zIndex: (0, _constants.layers).modal(),
            children: !UNSAFE_shouldDisableMotionUplift && (0, _platformFeatureFlags.fg)('platform-dst-motion-uplift-modal') ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _motion.Motion), {
                enteringAnimation: "var(--ds-blanket-enter, 250ms cubic-bezier(0.4, 0, 0, 1) FadeIn0to100)",
                exitingAnimation: "var(--ds-blanket-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    "aria-hidden": !isForeground,
                    className: (0, _runtime.ax)([
                        "_1bsbauwl _4t3i1kxc _kqsw1n9t _152tze3t _1e02ze3t _18m91wug _8am5i4x0"
                    ]),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactFocusLockDefault.default), {
                        autoFocus: autoFocusLock,
                        returnFocus: returnFocus,
                        onDeactivation: onDeactivation,
                        whiteList: allowListCallback,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactScrolllockDefault.default), {}),
                            shouldScrollInViewport ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactScrolllock.TouchScrollable), {
                                children: modalDialogWithBlanket
                            }) : modalDialogWithBlanket
                        ]
                    })
                })
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fadeInDefault.default), {
                children: function(fadeInProps) {
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, fadeInProps), {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                        className: (0, _runtime.ax)([
                            "_1bsbauwl _4t3i1kxc _kqsw1n9t _152tze3t _1e02ze3t _18m91wug _8am5i4x0",
                            fadeInProps.className
                        ]),
                        "aria-hidden": !isForeground,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactFocusLockDefault.default), {
                            autoFocus: autoFocusLock,
                            returnFocus: returnFocus,
                            onDeactivation: onDeactivation,
                            whiteList: allowListCallback,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactScrolllockDefault.default), {}),
                                shouldScrollInViewport ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactScrolllock.TouchScrollable), {
                                    children: modalDialogWithBlanket
                                }) : modalDialogWithBlanket
                            ]
                        })
                    }));
                }
            })
        })
    });
};
exports.default = InternalModalWrapper;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","react-focus-lock":"1FqTV","react-scrolllock":"iBy4G","@atlaskit/analytics-next":"auH4u","@atlaskit/blanket":"9QvIs","@atlaskit/ds-lib/noop":"2f3bg","@atlaskit/layering":"laO1Y","@atlaskit/layering/experimental/open-layer-observer":"iPCuE","@atlaskit/motion":"gQd69","@atlaskit/motion/fade-in":"3d5W2","@atlaskit/platform-feature-flags":"kO5t9","@atlaskit/portal":"kqyHU","@atlaskit/theme/constants":"3DRjL","../hooks/use-modal-stack":"chD7x","../hooks/use-prevent-programmatic-scroll":"8gSof","./modal-dialog":"7mQoU","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1FqTV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _combination = require("./Combination");
var _combinationDefault = parcelHelpers.interopDefault(_combination);
var _ui = require("./UI");
parcelHelpers.exportAll(_ui, exports);
exports.default = (0, _combinationDefault.default);

},{"./Combination":"8PJJO","./UI":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8PJJO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _lock = require("./Lock");
var _lockDefault = parcelHelpers.interopDefault(_lock);
var _trap = require("./Trap");
var _trapDefault = parcelHelpers.interopDefault(_trap);
var FocusLockCombination = /*#__PURE__*/ _react.forwardRef(function FocusLockUICombination(props, ref) {
    return /*#__PURE__*/ _react.createElement((0, _lockDefault.default), (0, _extendsDefault.default)({
        sideCar: (0, _trapDefault.default),
        ref: ref
    }, props));
});
var _ref = (0, _lockDefault.default).propTypes || {}, sideCar = _ref.sideCar, propTypes = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, [
    "sideCar"
]);
FocusLockCombination.propTypes = {};
exports.default = FocusLockCombination;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"5JG3D","@babel/runtime/helpers/esm/extends":"3LZYG","react":"ltHCL","./Lock":"crgQn","./Trap":"gpfpv","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"crgQn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _typeOf = require("@swc/helpers/_/_type_of");
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _constants = require("focus-lock/constants");
var _useCallbackRef = require("use-callback-ref");
var _focusGuard = require("./FocusGuard");
var _medium = require("./medium");
var _scope = require("./scope");
var emptyArray = [];
var FocusLock = /*#__PURE__*/ _react.forwardRef(function FocusLockUI(props, parentRef) {
    var _extends2;
    var _React$useState = _react.useState(), realObserved = _React$useState[0], setObserved = _React$useState[1];
    var observed = _react.useRef();
    var isActive = _react.useRef(false);
    var originalFocusedElement = _react.useRef(null);
    var _React$useState2 = _react.useState({}), update = _React$useState2[1];
    var children = props.children, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$noFocusGuards = props.noFocusGuards, noFocusGuards = _props$noFocusGuards === void 0 ? false : _props$noFocusGuards, _props$persistentFocu = props.persistentFocus, persistentFocus = _props$persistentFocu === void 0 ? false : _props$persistentFocu, _props$crossFrame = props.crossFrame, crossFrame = _props$crossFrame === void 0 ? true : _props$crossFrame, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, hasPositiveIndices = props.hasPositiveIndices, _props$shards = props.shards, shards = _props$shards === void 0 ? emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? 'div' : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props.sideCar, _props$returnFocus = props.returnFocus, shouldReturnFocus = _props$returnFocus === void 0 ? false : _props$returnFocus, focusOptions = props.focusOptions, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
    var _React$useState3 = _react.useState({}), id = _React$useState3[0];
    var onActivation = _react.useCallback(function(_ref) {
        var captureFocusRestore = _ref.captureFocusRestore;
        if (!originalFocusedElement.current) {
            var _document;
            var activeElement = (_document = document) == null ? void 0 : _document.activeElement;
            originalFocusedElement.current = activeElement;
            if (activeElement !== document.body) originalFocusedElement.current = captureFocusRestore(activeElement);
        }
        if (observed.current && onActivationCallback) onActivationCallback(observed.current);
        isActive.current = true;
        update();
    }, [
        onActivationCallback
    ]);
    var onDeactivation = _react.useCallback(function() {
        isActive.current = false;
        if (onDeactivationCallback) onDeactivationCallback(observed.current);
        update();
    }, [
        onDeactivationCallback
    ]);
    var returnFocus = _react.useCallback(function(allowDefer) {
        var focusRestore = originalFocusedElement.current;
        if (focusRestore) {
            var returnFocusTo = (typeof focusRestore === 'function' ? focusRestore() : focusRestore) || document.body;
            var howToReturnFocus = typeof shouldReturnFocus === 'function' ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
            if (howToReturnFocus) {
                var returnFocusOptions = (typeof howToReturnFocus === "undefined" ? "undefined" : (0, _typeOf._)(howToReturnFocus)) === 'object' ? howToReturnFocus : undefined;
                originalFocusedElement.current = null;
                if (allowDefer) Promise.resolve().then(function() {
                    return returnFocusTo.focus(returnFocusOptions);
                });
                else returnFocusTo.focus(returnFocusOptions);
            }
        }
    }, [
        shouldReturnFocus
    ]);
    var onFocus = _react.useCallback(function(event) {
        if (isActive.current) (0, _medium.mediumFocus).useMedium(event);
    }, []);
    var onBlur = (0, _medium.mediumBlur).useMedium;
    var setObserveNode = _react.useCallback(function(newObserved) {
        if (observed.current !== newObserved) {
            observed.current = newObserved;
            setObserved(newObserved);
        }
    }, []);
    var lockProps = (0, _extendsDefault.default)((_extends2 = {}, _extends2[_constants.FOCUS_DISABLED] = disabled && 'disabled', _extends2[_constants.FOCUS_GROUP] = group, _extends2), containerProps);
    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
    var mergedRef = (0, _useCallbackRef.useMergeRefs)([
        parentRef,
        setObserveNode
    ]);
    var focusScopeValue = _react.useMemo(function() {
        return {
            observed: observed,
            shards: shards,
            enabled: !disabled,
            active: isActive.current
        };
    }, [
        disabled,
        isActive.current,
        shards,
        realObserved
    ]);
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, hasLeadingGuards && [
        /*#__PURE__*/ _react.createElement("div", {
            key: "guard-first",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 0,
            style: (0, _focusGuard.hiddenGuard)
        }),
        hasPositiveIndices ? /*#__PURE__*/ _react.createElement("div", {
            key: "guard-nearest",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 1,
            style: (0, _focusGuard.hiddenGuard)
        }) : null
    ], !disabled && /*#__PURE__*/ _react.createElement(SideCar, {
        id: id,
        sideCar: (0, _medium.mediumSidecar),
        observed: realObserved,
        disabled: disabled,
        persistentFocus: persistentFocus,
        crossFrame: crossFrame,
        autoFocus: autoFocus,
        whiteList: whiteList,
        shards: shards,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus,
        focusOptions: focusOptions
    }), /*#__PURE__*/ _react.createElement(Container, (0, _extendsDefault.default)({
        ref: mergedRef
    }, lockProps, {
        className: className,
        onBlur: onBlur,
        onFocus: onFocus
    }), /*#__PURE__*/ _react.createElement((0, _scope.focusScope).Provider, {
        value: focusScopeValue
    }, children)), hasTailingGuards && /*#__PURE__*/ _react.createElement("div", {
        "data-focus-guard": true,
        tabIndex: disabled ? -1 : 0,
        style: (0, _focusGuard.hiddenGuard)
    }));
});
FocusLock.propTypes = {};
exports.default = FocusLock;

},{"@swc/helpers/_/_type_of":"iFJdx","@babel/runtime/helpers/esm/extends":"3LZYG","react":"ltHCL","prop-types":"3k3Jl","focus-lock/constants":"drTLK","use-callback-ref":"eIq7b","./FocusGuard":"1QfV3","./medium":"275di","./scope":"28GTX","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"drTLK":[function(require,module,exports,__globalThis) {
/**
 * defines a focus group
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FOCUS_GROUP", function() {
    return FOCUS_GROUP;
});
parcelHelpers.export(exports, "FOCUS_DISABLED", function() {
    return FOCUS_DISABLED;
});
parcelHelpers.export(exports, "FOCUS_ALLOW", function() {
    return FOCUS_ALLOW;
});
parcelHelpers.export(exports, "FOCUS_AUTO", function() {
    return FOCUS_AUTO;
});
parcelHelpers.export(exports, "FOCUS_NO_AUTOFOCUS", function() {
    return FOCUS_NO_AUTOFOCUS;
});
var FOCUS_GROUP = 'data-focus-lock';
var FOCUS_DISABLED = 'data-focus-lock-disabled';
var FOCUS_ALLOW = 'data-no-focus-lock';
var FOCUS_AUTO = 'data-autofocus-inside';
var FOCUS_NO_AUTOFOCUS = 'data-no-autofocus';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eIq7b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "assignRef", function() {
    return 0, _assignRef.assignRef;
});
// callback ref
parcelHelpers.export(exports, "useCallbackRef", function() {
    return 0, _useRef.useCallbackRef;
});
parcelHelpers.export(exports, "createCallbackRef", function() {
    return 0, _createRef.createCallbackRef;
});
// merge ref
parcelHelpers.export(exports, "mergeRefs", function() {
    return 0, _mergeRef.mergeRefs;
});
parcelHelpers.export(exports, "useMergeRefs", function() {
    return 0, _useMergeRef.useMergeRefs;
});
// transform ref
parcelHelpers.export(exports, "useTransformRef", function() {
    return 0, _useTransformRef.useTransformRef;
});
parcelHelpers.export(exports, "transformRef", function() {
    return 0, _transformRef.transformRef;
});
// refToCallback
parcelHelpers.export(exports, "refToCallback", function() {
    return 0, _refToCallback.refToCallback;
});
parcelHelpers.export(exports, "useRefToCallback", function() {
    return 0, _refToCallback.useRefToCallback;
});
var _assignRef = require("./assignRef");
var _useRef = require("./useRef");
var _createRef = require("./createRef");
var _mergeRef = require("./mergeRef");
var _useMergeRef = require("./useMergeRef");
var _useTransformRef = require("./useTransformRef");
var _transformRef = require("./transformRef");
var _refToCallback = require("./refToCallback");

},{"./assignRef":false,"./useRef":false,"./createRef":false,"./mergeRef":false,"./useMergeRef":"edamM","./useTransformRef":false,"./transformRef":false,"./refToCallback":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8V88a":[function(require,module,exports,__globalThis) {
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "assignRef", function() {
    return assignRef;
});
function assignRef(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
    return ref;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lVyKe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * creates a MutableRef with ref change callback
 * @param initialValue - initial ref value
 * @param {Function} callback - a callback to run when value changes
 *
 * @example
 * const ref = useCallbackRef(0, (newValue, oldValue) => console.log(oldValue, '->', newValue);
 * ref.current = 1;
 * // prints 0 -> 1
 *
 * @see https://reactjs.org/docs/hooks-reference.html#useref
 * @see https://github.com/theKashey/use-callback-ref#usecallbackref---to-replace-reactuseref
 * @returns {MutableRefObject}
 */ parcelHelpers.export(exports, "useCallbackRef", function() {
    return useCallbackRef;
});
var _react = require("react");
function useCallbackRef(initialValue, callback) {
    var ref = (0, _react.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"edamM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Merges two or more refs together providing a single interface to set their value
 * @param {RefObject|Ref} refs
 * @returns {MutableRefObject} - a new ref, which translates all changes to {refs}
 *
 * @see {@link mergeRefs} a version without buit-in memoization
 * @see https://github.com/theKashey/use-callback-ref#usemergerefs
 * @example
 * const Component = React.forwardRef((props, ref) => {
 *   const ownRef = useRef();
 *   const domRef = useMergeRefs([ref, ownRef]); // 👈 merge together
 *   return <div ref={domRef}>...</div>
 * }
 */ parcelHelpers.export(exports, "useMergeRefs", function() {
    return useMergeRefs;
});
var _react = require("react");
var _assignRef = require("./assignRef");
var _useRef = require("./useRef");
var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? _react.useLayoutEffect : _react.useEffect;
var currentValues = new WeakMap();
function useMergeRefs(refs, defaultValue) {
    var callbackRef = (0, _useRef.useCallbackRef)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, _assignRef.assignRef)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    useIsomorphicLayoutEffect(function() {
        var oldValue = currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, _assignRef.assignRef)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, _assignRef.assignRef)(ref, current_1);
            });
        }
        currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}

},{"react":"ltHCL","./assignRef":"8V88a","./useRef":"lVyKe","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1QfV3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hiddenGuard", function() {
    return hiddenGuard;
});
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var hiddenGuard = {
    width: '1px',
    height: '0px',
    padding: 0,
    overflow: 'hidden',
    position: 'fixed',
    top: '1px',
    left: '1px'
};
var InFocusGuard = function InFocusGuard(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement("div", {
        key: "guard-first",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: hiddenGuard
    }), children, children && /*#__PURE__*/ _react.createElement("div", {
        key: "guard-last",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: hiddenGuard
    }));
};
InFocusGuard.propTypes = {};
exports.default = InFocusGuard;

},{"react":"ltHCL","prop-types":"3k3Jl","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"275di":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mediumFocus", function() {
    return mediumFocus;
});
parcelHelpers.export(exports, "mediumBlur", function() {
    return mediumBlur;
});
parcelHelpers.export(exports, "mediumEffect", function() {
    return mediumEffect;
});
parcelHelpers.export(exports, "mediumSidecar", function() {
    return mediumSidecar;
});
var _useSidecar = require("use-sidecar");
var mediumFocus = (0, _useSidecar.createMedium)({}, function(_ref) {
    var target = _ref.target, currentTarget = _ref.currentTarget;
    return {
        target: target,
        currentTarget: currentTarget
    };
});
var mediumBlur = (0, _useSidecar.createMedium)();
var mediumEffect = (0, _useSidecar.createMedium)();
var mediumSidecar = (0, _useSidecar.createSidecarMedium)({
    async: true,
    ssr: typeof document !== 'undefined'
});

},{"use-sidecar":"1J8Yv","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1J8Yv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sidecar", function() {
    return 0, _hoc.sidecar;
});
parcelHelpers.export(exports, "useSidecar", function() {
    return 0, _hook.useSidecar;
});
parcelHelpers.export(exports, "setConfig", function() {
    return 0, _config.setConfig;
});
parcelHelpers.export(exports, "createMedium", function() {
    return 0, _medium.createMedium;
});
parcelHelpers.export(exports, "createSidecarMedium", function() {
    return 0, _medium.createSidecarMedium;
});
parcelHelpers.export(exports, "renderCar", function() {
    return 0, _renderProp.renderCar;
});
parcelHelpers.export(exports, "exportSidecar", function() {
    return 0, _exports.exportSidecar;
});
var _hoc = require("./hoc");
var _hook = require("./hook");
var _config = require("./config");
var _medium = require("./medium");
var _renderProp = require("./renderProp");
var _exports = require("./exports");

},{"./hoc":false,"./hook":false,"./config":false,"./medium":"gOuaJ","./renderProp":false,"./exports":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gOuaJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createMedium", function() {
    return createMedium;
});
// eslint-disable-next-line @typescript-eslint/ban-types
parcelHelpers.export(exports, "createSidecarMedium", function() {
    return createSidecarMedium;
});
var _tslib = require("tslib");
function ItoI(a) {
    return a;
}
function innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function read() {
            if (assigned) throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function useMedium(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function assignSyncMedium(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function push(x) {
                    return cb(x);
                },
                filter: function filter() {
                    return buffer;
                }
            };
        },
        assignMedium: function assignMedium(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function executeQueue() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function cycle() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function push(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function filter(_filter) {
                    pendingQueue = pendingQueue.filter(_filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function createMedium(defaults, middleware) {
    if (middleware === void 0) middleware = ItoI;
    return innerCreateMedium(defaults, middleware);
}
function createSidecarMedium(options) {
    if (options === void 0) options = {};
    var medium = innerCreateMedium(null);
    medium.options = (0, _tslib.__assign)({
        async: true,
        ssr: false
    }, options);
    return medium;
}

},{"tslib":"6MhhU","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"28GTX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "focusScope", function() {
    return focusScope;
});
var _react = require("react");
var focusScope = /*#__PURE__*/ (0, _react.createContext)(undefined);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gpfpv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactClientsideEffect = require("react-clientside-effect");
var _reactClientsideEffectDefault = parcelHelpers.interopDefault(_reactClientsideEffect);
var _focusLock = require("focus-lock");
var _util = require("./util");
var _medium = require("./medium");
var focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
};
var isFreeFocus = function isFreeFocus() {
    return focusOnBody() || (0, _focusLock.focusIsHidden)();
};
var lastActiveTrap = null;
var lastActiveFocus = null;
var lastPortaledElement = null;
var focusWasOutsideWindow = false;
var defaultWhitelist = function defaultWhitelist() {
    return true;
};
var focusWhitelisted = function focusWhitelisted(activeElement) {
    return (lastActiveTrap.whiteList || defaultWhitelist)(activeElement);
};
var recordPortal = function recordPortal(observerNode, portaledElement) {
    lastPortaledElement = {
        observerNode: observerNode,
        portaledElement: portaledElement
    };
};
var focusIsPortaledPair = function focusIsPortaledPair(element) {
    return lastPortaledElement && lastPortaledElement.portaledElement === element;
};
function autoGuard(startIndex, end, step, allNodes) {
    var lastGuard = null;
    var i = startIndex;
    do {
        var item = allNodes[i];
        if (item.guard) {
            if (item.node.dataset.focusAutoGuard) lastGuard = item;
        } else if (item.lockItem) {
            if (i !== startIndex) return;
            lastGuard = null;
        } else break;
    }while ((i += step) !== end);
    if (lastGuard) lastGuard.node.tabIndex = 0;
}
var focusWasOutside = function focusWasOutside(crossFrameOption) {
    if (crossFrameOption) return Boolean(focusWasOutsideWindow);
    return focusWasOutsideWindow === 'meanwhile';
};
var checkInHost = function checkInHost(check, el, boundary) {
    return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) || el.parentNode && checkInHost(check, el.parentNode, boundary));
};
var withinHost = function withinHost(activeElement, workingArea) {
    return workingArea.some(function(area) {
        return checkInHost(activeElement, area, area);
    });
};
var activateTrap = function activateTrap() {
    var result = false;
    if (lastActiveTrap) {
        var _lastActiveTrap = lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame, focusOptions = _lastActiveTrap.focusOptions;
        var workingNode = observed || lastPortaledElement && lastPortaledElement.portaledElement;
        var activeElement = document && document.activeElement;
        if (workingNode) {
            var workingArea = [
                workingNode
            ].concat(shards.map((0, _util.extractRef)).filter(Boolean));
            if (!activeElement || focusWhitelisted(activeElement)) {
                if (persistentFocus || focusWasOutside(crossFrame) || !isFreeFocus() || !lastActiveFocus && autoFocus) {
                    if (workingNode && !((0, _focusLock.focusInside)(workingArea) || activeElement && withinHost(activeElement, workingArea) || focusIsPortaledPair(activeElement, workingNode))) {
                        if (document && !lastActiveFocus && activeElement && !autoFocus) {
                            if (activeElement.blur) activeElement.blur();
                            document.body.focus();
                        } else {
                            result = (0, _focusLock.moveFocusInside)(workingArea, lastActiveFocus, {
                                focusOptions: focusOptions
                            });
                            lastPortaledElement = {};
                        }
                    }
                    focusWasOutsideWindow = false;
                    lastActiveFocus = document && document.activeElement;
                }
            }
            if (document && activeElement !== document.activeElement && document.querySelector('[data-focus-auto-guard]')) {
                var newActiveElement = document && document.activeElement;
                var allNodes = (0, _focusLock.expandFocusableNodes)(workingArea);
                var focusedIndex = allNodes.map(function(_ref) {
                    var node = _ref.node;
                    return node;
                }).indexOf(newActiveElement);
                if (focusedIndex > -1) {
                    allNodes.filter(function(_ref2) {
                        var guard = _ref2.guard, node = _ref2.node;
                        return guard && node.dataset.focusAutoGuard;
                    }).forEach(function(_ref3) {
                        var node = _ref3.node;
                        return node.removeAttribute('tabIndex');
                    });
                    autoGuard(focusedIndex, allNodes.length, 1, allNodes);
                    autoGuard(focusedIndex, -1, -1, allNodes);
                }
            }
        }
    }
    return result;
};
var onTrap = function onTrap(event) {
    if (activateTrap() && event) {
        event.stopPropagation();
        event.preventDefault();
    }
};
var onBlur = function onBlur() {
    return (0, _util.deferAction)(activateTrap);
};
var onFocus = function onFocus(event) {
    var source = event.target;
    var currentNode = event.currentTarget;
    if (!currentNode.contains(source)) recordPortal(currentNode, source);
};
var FocusWatcher = function FocusWatcher() {
    return null;
};
var FocusTrap = function FocusTrap(_ref4) {
    var children = _ref4.children;
    return /*#__PURE__*/ _react.createElement("div", {
        onBlur: onBlur,
        onFocus: onFocus
    }, children);
};
FocusTrap.propTypes = {};
var onWindowBlur = function onWindowBlur() {
    focusWasOutsideWindow = 'just';
    (0, _util.deferAction)(function() {
        focusWasOutsideWindow = 'meanwhile';
    });
};
var attachHandler = function attachHandler() {
    document.addEventListener('focusin', onTrap);
    document.addEventListener('focusout', onBlur);
    window.addEventListener('blur', onWindowBlur);
};
var detachHandler = function detachHandler() {
    document.removeEventListener('focusin', onTrap);
    document.removeEventListener('focusout', onBlur);
    window.removeEventListener('blur', onWindowBlur);
};
function reducePropsToState(propsList) {
    return propsList.filter(function(_ref5) {
        var disabled = _ref5.disabled;
        return !disabled;
    });
}
var focusLockAPI = {
    moveFocusInside: (0, _focusLock.moveFocusInside),
    focusInside: (0, _focusLock.focusInside),
    focusNextElement: (0, _focusLock.focusNextElement),
    focusPrevElement: (0, _focusLock.focusPrevElement),
    focusFirstElement: (0, _focusLock.focusFirstElement),
    focusLastElement: (0, _focusLock.focusLastElement),
    captureFocusRestore: (0, _focusLock.captureFocusRestore)
};
function handleStateChangeOnClient(traps) {
    var trap = traps.slice(-1)[0];
    if (trap && !lastActiveTrap) attachHandler();
    var lastTrap = lastActiveTrap;
    var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
    lastActiveTrap = trap;
    if (lastTrap && !sameTrap) {
        lastTrap.onDeactivation();
        if (!traps.filter(function(_ref6) {
            var id = _ref6.id;
            return id === lastTrap.id;
        }).length) lastTrap.returnFocus(!trap);
    }
    if (trap) {
        lastActiveFocus = null;
        if (!sameTrap || lastTrap.observed !== trap.observed) trap.onActivation(focusLockAPI);
        activateTrap(true);
        (0, _util.deferAction)(activateTrap);
    } else {
        detachHandler();
        lastActiveFocus = null;
    }
}
(0, _medium.mediumFocus).assignSyncMedium(onFocus);
(0, _medium.mediumBlur).assignMedium(onBlur);
(0, _medium.mediumEffect).assignMedium(function(cb) {
    return cb(focusLockAPI);
});
exports.default = (0, _reactClientsideEffectDefault.default)(reducePropsToState, handleStateChangeOnClient)(FocusWatcher);

},{"react":"ltHCL","prop-types":"3k3Jl","react-clientside-effect":"2mo7T","focus-lock":"aqy59","./util":"2gE4f","./medium":"275di","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2mo7T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function withSideEffect(reducePropsToState, handleStateChangeOnClient) {
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            handleStateChangeOnClient(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            (0, _inheritsLooseDefault.default)(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            SideEffect.peek = function peek() {
                return state;
            };
            var _proto = SideEffect.prototype;
            _proto.componentDidMount = function componentDidMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return /*#__PURE__*/ (0, _reactDefault.default).createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }((0, _react.PureComponent));
        (0, _definePropertyDefault.default)(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        return SideEffect;
    };
}
exports.default = withSideEffect;

},{"@babel/runtime/helpers/esm/inheritsLoose":"7Jcdm","@babel/runtime/helpers/esm/defineProperty":"8oXwS","react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7Jcdm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _inheritsLoose;
});
var _setPrototypeOfJs = require("./setPrototypeOf.js");
var _setPrototypeOfJsDefault = parcelHelpers.interopDefault(_setPrototypeOfJs);
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, _setPrototypeOfJsDefault.default)(t, o);
}

},{"./setPrototypeOf.js":"9pigx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9pigx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _setPrototypeOf;
});
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aqy59":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "constants", function() {
    return constants;
});
parcelHelpers.export(exports, "focusInside", function() {
    return(//
    0, _focusInside.focusInside);
});
parcelHelpers.export(exports, "focusIsHidden", function() {
    return 0, _focusIsHidden.focusIsHidden;
});
parcelHelpers.export(exports, "moveFocusInside", function() {
    return(//
    0, _moveFocusInside.moveFocusInside);
});
parcelHelpers.export(exports, "focusSolver", function() {
    return 0, _focusSolver.focusSolver;
});
parcelHelpers.export(exports, "expandFocusableNodes", function() {
    return(//
    0, _focusables.expandFocusableNodes);
});
parcelHelpers.export(exports, "getFocusableNodes", function() {
    return 0, _domutils.getFocusableNodes;
});
parcelHelpers.export(exports, "getTabbableNodes", function() {
    return 0, _domutils.getTabbableNodes;
});
parcelHelpers.export(exports, "focusNextElement", function() {
    return(//
    0, _sibling.focusNextElement);
});
parcelHelpers.export(exports, "focusPrevElement", function() {
    return 0, _sibling.focusPrevElement;
});
parcelHelpers.export(exports, "focusFirstElement", function() {
    return 0, _sibling.focusFirstElement;
});
parcelHelpers.export(exports, "focusLastElement", function() {
    return 0, _sibling.focusLastElement;
});
parcelHelpers.export(exports, "getRelativeFocusable", function() {
    return 0, _sibling.getRelativeFocusable;
});
parcelHelpers.export(exports, "captureFocusRestore", function() {
    return(//
    0, _returnFocus.captureFocusRestore);
});
var _constants = require("./constants");
var _focusInside = require("./focusInside");
var _focusIsHidden = require("./focusIsHidden");
var _focusSolver = require("./focusSolver");
var _focusables = require("./focusables");
var _moveFocusInside = require("./moveFocusInside");
var _returnFocus = require("./return-focus");
var _sibling = require("./sibling");
var _domutils = require("./utils/DOMutils");
/**
 * magic symbols to control focus behavior from DOM
 * see description of every particular one
 */ var constants = _constants;
/**
 * @deprecated - please use {@link moveFocusInside} named export
 */ var deprecated_default_moveFocusInside = (0, _moveFocusInside.moveFocusInside);
exports.default = deprecated_default_moveFocusInside; //

},{"./constants":"drTLK","./focusInside":"2DpxM","./focusIsHidden":"4xWun","./focusSolver":false,"./focusables":"dMfjS","./moveFocusInside":"baHNh","./return-focus":"d1oFU","./sibling":"h7jzm","./utils/DOMutils":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2DpxM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "focusInside", function() {
    return focusInside;
});
var _domutils = require("./utils/DOMutils");
var _allAffected = require("./utils/all-affected");
var _array = require("./utils/array");
var _getActiveElement = require("./utils/getActiveElement");
var focusInFrame = function focusInFrame(frame, activeElement) {
    return frame === activeElement;
};
var focusInsideIframe = function focusInsideIframe(topNode, activeElement) {
    return Boolean((0, _array.toArray)(topNode.querySelectorAll('iframe')).some(function(node) {
        return focusInFrame(node, activeElement);
    }));
};
var focusInside = function focusInside(topNode, activeElement) {
    // const activeElement = document && getActiveElement();
    if (activeElement === void 0) activeElement = (0, _getActiveElement.getActiveElement)((0, _array.getFirst)(topNode).ownerDocument);
    if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) return false;
    return (0, _allAffected.getAllAffectedNodes)(topNode).some(function(node) {
        return (0, _domutils.contains)(node, activeElement) || focusInsideIframe(node, activeElement);
    });
};

},{"./utils/DOMutils":"5u5g3","./utils/all-affected":"9H4z3","./utils/array":"elZm4","./utils/getActiveElement":"3wPqm","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5u5g3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "filterFocusable", function() {
    return filterFocusable;
});
parcelHelpers.export(exports, "filterAutoFocusable", function() {
    return filterAutoFocusable;
});
parcelHelpers.export(exports, "getTabbableNodes", function() {
    return getTabbableNodes;
});
parcelHelpers.export(exports, "getFocusableNodes", function() {
    return getFocusableNodes;
});
parcelHelpers.export(exports, "parentAutofocusables", function() {
    return parentAutofocusables;
});
parcelHelpers.export(exports, "contains", function() {
    return contains;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
var _array = require("./array");
var _is = require("./is");
var _tabOrder = require("./tabOrder");
var _tabUtils = require("./tabUtils");
var filterFocusable = function filterFocusable(nodes, visibilityCache) {
    return (0, _array.toArray)(nodes).filter(function(node) {
        return (0, _is.isVisibleCached)(visibilityCache, node);
    }).filter(function(node) {
        return (0, _is.notHiddenInput)(node);
    });
};
var filterAutoFocusable = function filterAutoFocusable(nodes, cache) {
    if (cache === void 0) cache = new Map();
    return (0, _array.toArray)(nodes).filter(function(node) {
        return (0, _is.isAutoFocusAllowedCached)(cache, node);
    });
};
var getTabbableNodes = function getTabbableNodes(topNodes, visibilityCache, withGuards) {
    return (0, _tabOrder.orderByTabIndex)(filterFocusable((0, _tabUtils.getFocusables)(topNodes, withGuards), visibilityCache), true, withGuards);
};
var getFocusableNodes = function getFocusableNodes(topNodes, visibilityCache) {
    return (0, _tabOrder.orderByTabIndex)(filterFocusable((0, _tabUtils.getFocusables)(topNodes), visibilityCache), false);
};
var parentAutofocusables = function parentAutofocusables(topNode, visibilityCache) {
    return filterFocusable((0, _tabUtils.getParentAutofocusables)(topNode), visibilityCache);
};
var contains = function contains1(scope, element) {
    if (scope.shadowRoot) return contains(scope.shadowRoot, element);
    else {
        if (Object.getPrototypeOf(scope).contains !== undefined && Object.getPrototypeOf(scope).contains.call(scope, element)) return true;
        return (0, _array.toArray)(scope.children).some(function(child) {
            var _a;
            if ((0, _instanceof._)(child, HTMLIFrameElement)) {
                var iframeBody = (_a = child.contentDocument) === null || _a === void 0 ? void 0 : _a.body;
                if (iframeBody) return contains(iframeBody, element);
                return false;
            }
            return contains(child, element);
        });
    }
};

},{"@swc/helpers/_/_instanceof":"h9UKc","./array":"elZm4","./is":"a0hgY","./tabOrder":"gPAjj","./tabUtils":"5pdZb","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"elZm4":[function(require,module,exports,__globalThis) {
/*
IE11 support
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toArray", function() {
    return toArray;
});
parcelHelpers.export(exports, "asArray", function() {
    return asArray;
});
parcelHelpers.export(exports, "getFirst", function() {
    return getFirst;
});
var toArray = function toArray(a) {
    var ret = Array(a.length);
    for(var i = 0; i < a.length; ++i)ret[i] = a[i];
    return ret;
};
var asArray = function asArray(a) {
    return Array.isArray(a) ? a : [
        a
    ];
};
var getFirst = function getFirst(a) {
    return Array.isArray(a) ? a[0] : a;
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"a0hgY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isVisibleCached", function() {
    return isVisibleCached;
});
parcelHelpers.export(exports, "isAutoFocusAllowedCached", function() {
    return isAutoFocusAllowedCached;
});
parcelHelpers.export(exports, "getDataset", function() {
    return getDataset;
});
parcelHelpers.export(exports, "isHTMLButtonElement", function() {
    return isHTMLButtonElement;
});
parcelHelpers.export(exports, "isHTMLInputElement", function() {
    return isHTMLInputElement;
});
parcelHelpers.export(exports, "isRadioElement", function() {
    return isRadioElement;
});
parcelHelpers.export(exports, "notHiddenInput", function() {
    return notHiddenInput;
});
parcelHelpers.export(exports, "isAutoFocusAllowed", function() {
    return isAutoFocusAllowed;
});
parcelHelpers.export(exports, "isGuard", function() {
    return isGuard;
});
parcelHelpers.export(exports, "isNotAGuard", function() {
    return isNotAGuard;
});
parcelHelpers.export(exports, "isDefined", function() {
    return isDefined;
});
var _constants = require("../constants");
var isElementHidden = function isElementHidden(node) {
    // we can measure only "elements"
    // consider others as "visible"
    if (node.nodeType !== Node.ELEMENT_NODE) return false;
    var computedStyle = window.getComputedStyle(node, null);
    if (!computedStyle || !computedStyle.getPropertyValue) return false;
    return computedStyle.getPropertyValue('display') === 'none' || computedStyle.getPropertyValue('visibility') === 'hidden';
};
var getParentNode = function getParentNode(node) {
    // DOCUMENT_FRAGMENT_NODE can also point on ShadowRoot. In this case .host will point on the next node
    return node.parentNode && node.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? node.parentNode.host : node.parentNode;
};
var isTopNode = function isTopNode(node) {
    // @ts-ignore
    return node === document || node && node.nodeType === Node.DOCUMENT_NODE;
};
var isInert = function isInert(node) {
    return node.hasAttribute('inert');
};
/**
 * @see https://github.com/testing-library/jest-dom/blob/main/src/to-be-visible.js
 */ var isVisibleUncached = function isVisibleUncached(node, checkParent) {
    return !node || isTopNode(node) || !isElementHidden(node) && !isInert(node) && checkParent(getParentNode(node));
};
var isVisibleCached = function isVisibleCached1(visibilityCache, node) {
    var cached = visibilityCache.get(node);
    if (cached !== undefined) return cached;
    var result = isVisibleUncached(node, isVisibleCached.bind(undefined, visibilityCache));
    visibilityCache.set(node, result);
    return result;
};
var isAutoFocusAllowedUncached = function isAutoFocusAllowedUncached(node, checkParent) {
    return node && !isTopNode(node) ? isAutoFocusAllowed(node) ? checkParent(getParentNode(node)) : false : true;
};
var isAutoFocusAllowedCached = function isAutoFocusAllowedCached1(cache, node) {
    var cached = cache.get(node);
    if (cached !== undefined) return cached;
    var result = isAutoFocusAllowedUncached(node, isAutoFocusAllowedCached.bind(undefined, cache));
    cache.set(node, result);
    return result;
};
var getDataset = function getDataset(node) {
    // @ts-ignore
    return node.dataset;
};
var isHTMLButtonElement = function isHTMLButtonElement(node) {
    return node.tagName === 'BUTTON';
};
var isHTMLInputElement = function isHTMLInputElement(node) {
    return node.tagName === 'INPUT';
};
var isRadioElement = function isRadioElement(node) {
    return isHTMLInputElement(node) && node.type === 'radio';
};
var notHiddenInput = function notHiddenInput(node) {
    return !((isHTMLInputElement(node) || isHTMLButtonElement(node)) && (node.type === 'hidden' || node.disabled));
};
var isAutoFocusAllowed = function isAutoFocusAllowed(node) {
    var attribute = node.getAttribute((0, _constants.FOCUS_NO_AUTOFOCUS));
    return ![
        true,
        'true',
        ''
    ].includes(attribute);
};
var isGuard = function isGuard(node) {
    var _a;
    return Boolean(node && ((_a = getDataset(node)) === null || _a === void 0 ? void 0 : _a.focusGuard));
};
var isNotAGuard = function isNotAGuard(node) {
    return !isGuard(node);
};
var isDefined = function isDefined(x) {
    return Boolean(x);
};

},{"../constants":"drTLK","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gPAjj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "tabSort", function() {
    return tabSort;
});
parcelHelpers.export(exports, "orderByTabIndex", function() {
    return orderByTabIndex;
});
var _array = require("./array");
var tabSort = function tabSort(a, b) {
    var aTab = Math.max(0, a.tabIndex);
    var bTab = Math.max(0, b.tabIndex);
    var tabDiff = aTab - bTab;
    var indexDiff = a.index - b.index;
    if (tabDiff) {
        if (!aTab) return 1;
        if (!bTab) return -1;
    }
    return tabDiff || indexDiff;
};
var getTabIndex = function getTabIndex(node) {
    if (node.tabIndex < 0) {
        // all "focusable" elements are already preselected
        // but some might have implicit negative tabIndex
        // return 0 for <audio without tabIndex attribute - it is "tabbable"
        if (!node.hasAttribute('tabindex')) return 0;
    }
    return node.tabIndex;
};
var orderByTabIndex = function orderByTabIndex(nodes, filterNegative, keepGuards) {
    return (0, _array.toArray)(nodes).map(function(node, index) {
        var tabIndex = getTabIndex(node);
        return {
            node: node,
            index: index,
            tabIndex: keepGuards && tabIndex === -1 ? (node.dataset || {}).focusGuard ? 0 : -1 : tabIndex
        };
    }).filter(function(data) {
        return !filterNegative || data.tabIndex >= 0;
    }).sort(tabSort);
};

},{"./array":"elZm4","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5pdZb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFocusables", function() {
    return getFocusables;
});
parcelHelpers.export(exports, "getParentAutofocusables", function() {
    return getParentAutofocusables;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
var _constants = require("../constants");
var _array = require("./array");
var _tabbables = require("./tabbables");
var queryTabbables = (0, _tabbables.tabbables).join(',');
var queryGuardTabbables = "".concat(queryTabbables, ", [data-focus-guard]");
var getFocusablesWithShadowDom = function getFocusablesWithShadowDom1(parent, withGuards) {
    return (0, _array.toArray)((parent.shadowRoot || parent).children).reduce(function(acc, child) {
        return acc.concat(child.matches(withGuards ? queryGuardTabbables : queryTabbables) ? [
            child
        ] : [], getFocusablesWithShadowDom(child));
    }, []);
};
var getFocusablesWithIFrame = function getFocusablesWithIFrame(parent, withGuards) {
    var _a;
    // contentDocument of iframe will be null if current origin cannot access it
    if ((0, _instanceof._)(parent, HTMLIFrameElement) && ((_a = parent.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) return getFocusables([
        parent.contentDocument.body
    ], withGuards);
    return [
        parent
    ];
};
var getFocusables = function getFocusables(parents, withGuards) {
    return parents.reduce(function(acc, parent) {
        var _a;
        var focusableWithShadowDom = getFocusablesWithShadowDom(parent, withGuards);
        var focusableWithIframes = (_a = []).concat.apply(_a, focusableWithShadowDom.map(function(node) {
            return getFocusablesWithIFrame(node, withGuards);
        }));
        return acc.concat(// add all tabbables inside and within shadow DOMs in DOM order
        focusableWithIframes, // add if node is tabbable itself
        parent.parentNode ? (0, _array.toArray)(parent.parentNode.querySelectorAll(queryTabbables)).filter(function(node) {
            return node === parent;
        }) : []);
    }, []);
};
var getParentAutofocusables = function getParentAutofocusables(parent) {
    var parentFocus = parent.querySelectorAll("[".concat((0, _constants.FOCUS_AUTO), "]"));
    return (0, _array.toArray)(parentFocus).map(function(node) {
        return getFocusables([
            node
        ]);
    }).reduce(function(acc, nodes) {
        return acc.concat(nodes);
    }, []);
};

},{"@swc/helpers/_/_instanceof":"h9UKc","../constants":"drTLK","./array":"elZm4","./tabbables":"4QTKk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4QTKk":[function(require,module,exports,__globalThis) {
/**
 * list of the object to be considered as focusable
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "tabbables", function() {
    return tabbables;
});
var tabbables = [
    'button:enabled',
    'select:enabled',
    'textarea:enabled',
    'input:enabled',
    // elements with explicit roles will also use explicit tabindex
    // '[role="button"]',
    'a[href]',
    'area[href]',
    'summary',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[tabindex]',
    '[contenteditable]',
    '[autofocus]'
];

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9H4z3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAllAffectedNodes", function() {
    return getAllAffectedNodes;
});
var _constants = require("../constants");
var _array = require("./array");
/**
 * in case of multiple nodes nested inside each other
 * keeps only top ones
 * this is O(nlogn)
 * @param nodes
 * @returns {*}
 */ var filterNested = function filterNested(nodes) {
    var contained = new Set();
    var l = nodes.length;
    for(var i = 0; i < l; i += 1)for(var j = i + 1; j < l; j += 1){
        var position = nodes[i].compareDocumentPosition(nodes[j]);
        /* eslint-disable no-bitwise */ if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) contained.add(j);
        if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) contained.add(i);
    /* eslint-enable */ }
    return nodes.filter(function(_, index) {
        return !contained.has(index);
    });
};
/**
 * finds top most parent for a node
 * @param node
 * @returns {*}
 */ var getTopParent = function getTopParent1(node) {
    return node.parentNode ? getTopParent(node.parentNode) : node;
};
var getAllAffectedNodes = function getAllAffectedNodes(node) {
    var nodes = (0, _array.asArray)(node);
    return nodes.filter(Boolean).reduce(function(acc, currentNode) {
        var group = currentNode.getAttribute((0, _constants.FOCUS_GROUP));
        acc.push.apply(acc, group ? filterNested((0, _array.toArray)(getTopParent(currentNode).querySelectorAll("[".concat((0, _constants.FOCUS_GROUP), "=\"").concat(group, "\"]:not([").concat((0, _constants.FOCUS_DISABLED), "=\"disabled\"])")))) : [
            currentNode
        ]);
        return acc;
    }, []);
};

},{"../constants":"drTLK","./array":"elZm4","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3wPqm":[function(require,module,exports,__globalThis) {
/**
 * returns active element from document or from nested shadowdoms
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getActiveElement", function() {
    return getActiveElement;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
var _safe = require("./safe");
var getActiveElement = function getActiveElement1(inDocument) {
    if (inDocument === void 0) inDocument = document;
    if (!inDocument || !inDocument.activeElement) return undefined;
    var activeElement = inDocument.activeElement;
    return activeElement.shadowRoot ? getActiveElement(activeElement.shadowRoot) : (0, _instanceof._)(activeElement, HTMLIFrameElement) && (0, _safe.safeProbe)(function() {
        return activeElement.contentWindow.document;
    }) ? getActiveElement(activeElement.contentWindow.document) : activeElement;
};

},{"@swc/helpers/_/_instanceof":"h9UKc","./safe":"bhrkR","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bhrkR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "safeProbe", function() {
    return safeProbe;
});
var safeProbe = function safeProbe(cb) {
    try {
        return cb();
    } catch (e) {
        return undefined;
    }
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4xWun":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "focusIsHidden", function() {
    return focusIsHidden;
});
var _constants = require("./constants");
var _domutils = require("./utils/DOMutils");
var _array = require("./utils/array");
var _getActiveElement = require("./utils/getActiveElement");
var focusIsHidden = function focusIsHidden(inDocument) {
    if (inDocument === void 0) inDocument = document;
    var activeElement = (0, _getActiveElement.getActiveElement)(inDocument);
    if (!activeElement) return false;
    // this does not support setting FOCUS_ALLOW within shadow dom
    return (0, _array.toArray)(inDocument.querySelectorAll("[".concat((0, _constants.FOCUS_ALLOW), "]"))).some(function(node) {
        return (0, _domutils.contains)(node, activeElement);
    });
};

},{"./constants":"drTLK","./utils/DOMutils":"5u5g3","./utils/array":"elZm4","./utils/getActiveElement":"3wPqm","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"pKq9x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "focusSolver", function() {
    return focusSolver;
});
var _solver = require("./solver");
var _domutils = require("./utils/DOMutils");
var _allAffected = require("./utils/all-affected");
var _array = require("./utils/array");
var _autoFocus = require("./utils/auto-focus");
var _getActiveElement = require("./utils/getActiveElement");
var _is = require("./utils/is");
var _parenting = require("./utils/parenting");
var reorderNodes = function reorderNodes(srcNodes, dstNodes) {
    var remap = new Map();
    // no Set(dstNodes) for IE11 :(
    dstNodes.forEach(function(entity) {
        return remap.set(entity.node, entity);
    });
    // remap to dstNodes
    return srcNodes.map(function(node) {
        return remap.get(node);
    }).filter((0, _is.isDefined));
};
var focusSolver = function focusSolver(topNode, lastNode) {
    var activeElement = (0, _getActiveElement.getActiveElement)((0, _array.asArray)(topNode).length > 0 ? document : (0, _array.getFirst)(topNode).ownerDocument);
    var entries = (0, _allAffected.getAllAffectedNodes)(topNode).filter((0, _is.isNotAGuard));
    var commonParent = (0, _parenting.getTopCommonParent)(activeElement || topNode, topNode, entries);
    var visibilityCache = new Map();
    var anyFocusable = (0, _domutils.getFocusableNodes)(entries, visibilityCache);
    var innerElements = anyFocusable.filter(function(_a) {
        var node = _a.node;
        return (0, _is.isNotAGuard)(node);
    });
    if (!innerElements[0]) return undefined;
    var outerNodes = (0, _domutils.getFocusableNodes)([
        commonParent
    ], visibilityCache).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var orderedInnerElements = reorderNodes(outerNodes, innerElements);
    // collect inner focusable and separately tabbables
    var innerFocusables = orderedInnerElements.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var innerTabbable = orderedInnerElements.filter(function(_a) {
        var tabIndex = _a.tabIndex;
        return tabIndex >= 0;
    }).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var newId = (0, _solver.newFocus)(innerFocusables, innerTabbable, outerNodes, activeElement, lastNode);
    if (newId === (0, _solver.NEW_FOCUS)) {
        var focusNode = // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
        (0, _autoFocus.pickAutofocus)(anyFocusable, innerTabbable, (0, _parenting.allParentAutofocusables)(entries, visibilityCache)) || (0, _autoFocus.pickAutofocus)(anyFocusable, innerFocusables, (0, _parenting.allParentAutofocusables)(entries, visibilityCache));
        if (focusNode) return {
            node: focusNode
        };
        else {
            console.warn('focus-lock: cannot find any node to move focus into');
            return undefined;
        }
    }
    if (newId === undefined) return newId;
    return orderedInnerElements[newId];
};

},{"./solver":"5MnbY","./utils/DOMutils":"5u5g3","./utils/all-affected":"9H4z3","./utils/array":"elZm4","./utils/auto-focus":"b8B7Q","./utils/getActiveElement":"3wPqm","./utils/is":"a0hgY","./utils/parenting":"aRl9T","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5MnbY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NEW_FOCUS", function() {
    return NEW_FOCUS;
});
parcelHelpers.export(exports, "newFocus", function() {
    return newFocus;
});
var _correctFocus = require("./utils/correctFocus");
var _firstFocus = require("./utils/firstFocus");
var _is = require("./utils/is");
var NEW_FOCUS = 'NEW_FOCUS';
var newFocus = function newFocus(innerNodes, innerTabbables, outerNodes, activeElement, lastNode) {
    var cnt = innerNodes.length;
    var firstFocus = innerNodes[0];
    var lastFocus = innerNodes[cnt - 1];
    var isOnGuard = (0, _is.isGuard)(activeElement);
    // focus is inside
    if (activeElement && innerNodes.indexOf(activeElement) >= 0) return undefined;
    var activeIndex = activeElement !== undefined ? outerNodes.indexOf(activeElement) : -1;
    var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
    var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
    // no active focus (or focus is on the body)
    if (activeIndex === -1) {
        // known fallback
        if (lastNodeInside !== -1) return lastNodeInside;
        return NEW_FOCUS;
    }
    // new focus, nothing to calculate
    if (lastNodeInside === -1) return NEW_FOCUS;
    var indexDiff = activeIndex - lastIndex;
    var firstNodeIndex = outerNodes.indexOf(firstFocus);
    var lastNodeIndex = outerNodes.indexOf(lastFocus);
    var correctedNodes = (0, _correctFocus.correctNodes)(outerNodes);
    var currentFocusableIndex = activeElement !== undefined ? correctedNodes.indexOf(activeElement) : -1;
    var previousFocusableIndex = lastNode ? correctedNodes.indexOf(lastNode) : currentFocusableIndex;
    var tabbableNodes = correctedNodes.filter(function(node) {
        return node.tabIndex >= 0;
    });
    var currentTabbableIndex = activeElement !== undefined ? tabbableNodes.indexOf(activeElement) : -1;
    var previousTabbableIndex = lastNode ? tabbableNodes.indexOf(lastNode) : currentTabbableIndex;
    var focusIndexDiff = currentTabbableIndex >= 0 && previousTabbableIndex >= 0 ? previousTabbableIndex - currentTabbableIndex : previousFocusableIndex - currentFocusableIndex;
    // old focus
    if (!indexDiff && lastNodeInside >= 0) return lastNodeInside;
    // no tabbable elements, autofocus is not possible
    if (innerTabbables.length === 0) // an edge case with no tabbable elements
    // return the last focusable one
    // with some probability this will prevent focus from cycling across the lock, but there is no tabbale elements to cycle to
    return lastNodeInside;
    var returnFirstNode = (0, _firstFocus.pickFocusable)(innerNodes, innerTabbables[0]);
    var returnLastNode = (0, _firstFocus.pickFocusable)(innerNodes, innerTabbables[innerTabbables.length - 1]);
    // first element
    if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnLastNode;
    // last element
    if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnFirstNode;
    // jump out, but not on the guard
    if (indexDiff && Math.abs(focusIndexDiff) > 1) return lastNodeInside;
    // focus above lock
    if (activeIndex <= firstNodeIndex) return returnLastNode;
    // focus below lock
    if (activeIndex > lastNodeIndex) return returnFirstNode;
    // index is inside tab order, but outside Lock
    if (indexDiff) {
        if (Math.abs(indexDiff) > 1) return lastNodeInside;
        return (cnt + lastNodeInside + indexDiff) % cnt;
    }
    // do nothing
    return undefined;
};

},{"./utils/correctFocus":"aX9cy","./utils/firstFocus":"hjJVM","./utils/is":"a0hgY","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aX9cy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "correctNode", function() {
    return correctNode;
});
parcelHelpers.export(exports, "correctNodes", function() {
    return correctNodes;
});
var _is = require("./is");
var findSelectedRadio = function findSelectedRadio(node, nodes) {
    return nodes.filter((0, _is.isRadioElement)).filter(function(el) {
        return el.name === node.name;
    }).filter(function(el) {
        return el.checked;
    })[0] || node;
};
var correctNode = function correctNode(node, nodes) {
    if ((0, _is.isRadioElement)(node) && node.name) return findSelectedRadio(node, nodes);
    return node;
};
var correctNodes = function correctNodes(nodes) {
    // IE11 has no Set(array) constructor
    var resultSet = new Set();
    nodes.forEach(function(node) {
        return resultSet.add(correctNode(node, nodes));
    });
    // using filter to support IE11
    return nodes.filter(function(node) {
        return resultSet.has(node);
    });
};

},{"./is":"a0hgY","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hjJVM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pickFirstFocus", function() {
    return pickFirstFocus;
});
parcelHelpers.export(exports, "pickFocusable", function() {
    return pickFocusable;
});
var _correctFocus = require("./correctFocus");
var pickFirstFocus = function pickFirstFocus(nodes) {
    if (nodes[0] && nodes.length > 1) return (0, _correctFocus.correctNode)(nodes[0], nodes);
    return nodes[0];
};
var pickFocusable = function pickFocusable(nodes, node) {
    return nodes.indexOf((0, _correctFocus.correctNode)(node, nodes));
};

},{"./correctFocus":"aX9cy","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"b8B7Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pickAutofocus", function() {
    return pickAutofocus;
});
var _domutils = require("./DOMutils");
var _firstFocus = require("./firstFocus");
var _is = require("./is");
var findAutoFocused = function findAutoFocused(autoFocusables) {
    return function(node) {
        var _a;
        var autofocus = (_a = (0, _is.getDataset)(node)) === null || _a === void 0 ? void 0 : _a.autofocus;
        return(// @ts-expect-error
        node.autofocus || //
        autofocus !== undefined && autofocus !== 'false' || //
        autoFocusables.indexOf(node) >= 0);
    };
};
var pickAutofocus = function pickAutofocus(nodesIndexes, orderedNodes, groups) {
    var nodes = nodesIndexes.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var autoFocusable = (0, _domutils.filterAutoFocusable)(nodes.filter(findAutoFocused(groups)));
    if (autoFocusable && autoFocusable.length) return (0, _firstFocus.pickFirstFocus)(autoFocusable);
    return (0, _firstFocus.pickFirstFocus)((0, _domutils.filterAutoFocusable)(orderedNodes));
};

},{"./DOMutils":"5u5g3","./firstFocus":"hjJVM","./is":"a0hgY","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aRl9T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCommonParent", function() {
    return getCommonParent;
});
parcelHelpers.export(exports, "getTopCommonParent", function() {
    return getTopCommonParent;
});
parcelHelpers.export(exports, "allParentAutofocusables", function() {
    return allParentAutofocusables;
});
var _domutils = require("./DOMutils");
var _array = require("./array");
var getParents = function getParents1(node, parents) {
    if (parents === void 0) parents = [];
    parents.push(node);
    if (node.parentNode) getParents(node.parentNode.host || node.parentNode, parents);
    return parents;
};
var getCommonParent = function getCommonParent(nodeA, nodeB) {
    var parentsA = getParents(nodeA);
    var parentsB = getParents(nodeB);
    // tslint:disable-next-line:prefer-for-of
    for(var i = 0; i < parentsA.length; i += 1){
        var currentParent = parentsA[i];
        if (parentsB.indexOf(currentParent) >= 0) return currentParent;
    }
    return false;
};
var getTopCommonParent = function getTopCommonParent(baseActiveElement, leftEntry, rightEntries) {
    var activeElements = (0, _array.asArray)(baseActiveElement);
    var leftEntries = (0, _array.asArray)(leftEntry);
    var activeElement = activeElements[0];
    var topCommon = false;
    leftEntries.filter(Boolean).forEach(function(entry) {
        topCommon = getCommonParent(topCommon || entry, entry) || topCommon;
        rightEntries.filter(Boolean).forEach(function(subEntry) {
            var common = getCommonParent(activeElement, subEntry);
            if (common) {
                if (!topCommon || (0, _domutils.contains)(common, topCommon)) topCommon = common;
                else topCommon = getCommonParent(common, topCommon);
            }
        });
    });
    // TODO: add assert here?
    return topCommon;
};
var allParentAutofocusables = function allParentAutofocusables(entries, visibilityCache) {
    return entries.reduce(function(acc, node) {
        return acc.concat((0, _domutils.parentAutofocusables)(node, visibilityCache));
    }, []);
};

},{"./DOMutils":"5u5g3","./array":"elZm4","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dMfjS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "expandFocusableNodes", function() {
    return expandFocusableNodes;
});
var _allAffected = require("./utils/all-affected");
var _is = require("./utils/is");
var _parenting = require("./utils/parenting");
var _tabOrder = require("./utils/tabOrder");
var _tabUtils = require("./utils/tabUtils");
var expandFocusableNodes = function expandFocusableNodes(topNode) {
    var entries = (0, _allAffected.getAllAffectedNodes)(topNode).filter((0, _is.isNotAGuard));
    var commonParent = (0, _parenting.getTopCommonParent)(topNode, topNode, entries);
    var outerNodes = (0, _tabOrder.orderByTabIndex)((0, _tabUtils.getFocusables)([
        commonParent
    ], true), true, true);
    var innerElements = (0, _tabUtils.getFocusables)(entries, false);
    return outerNodes.map(function(_a) {
        var node = _a.node, index = _a.index;
        return {
            node: node,
            index: index,
            lockItem: innerElements.indexOf(node) >= 0,
            guard: (0, _is.isGuard)(node)
        };
    });
};

},{"./utils/all-affected":"9H4z3","./utils/is":"a0hgY","./utils/parenting":"aRl9T","./utils/tabOrder":"gPAjj","./utils/tabUtils":"5pdZb","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"baHNh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "moveFocusInside", function() {
    return moveFocusInside;
});
var _commands = require("./commands");
var _focusSolver = require("./focusSolver");
var guardCount = 0;
var lockDisabled = false;
var moveFocusInside = function moveFocusInside(topNode, lastNode, options) {
    if (options === void 0) options = {};
    var focusable = (0, _focusSolver.focusSolver)(topNode, lastNode);
    // global local side effect to countain recursive lock activation and resolve focus-fighting
    if (lockDisabled) return;
    if (focusable) {
        /** +FOCUS-FIGHTING prevention **/ if (guardCount > 2) {
            // we have recursive entered back the lock activation
            console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting");
            lockDisabled = true;
            setTimeout(function() {
                lockDisabled = false;
            }, 1);
            return;
        }
        guardCount++;
        (0, _commands.focusOn)(focusable.node, options.focusOptions);
        guardCount--;
    }
};

},{"./commands":"X1CaT","./focusSolver":"pKq9x","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"X1CaT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "focusOn", function() {
    return focusOn;
});
var focusOn = function focusOn(target, focusOptions) {
    if (!target) // not clear how, but is possible https://github.com/theKashey/focus-lock/issues/53
    return;
    if ('focus' in target) target.focus(focusOptions);
    if ('contentWindow' in target && target.contentWindow) target.contentWindow.focus();
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"d1oFU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "recordElementLocation", function() {
    return recordElementLocation;
});
parcelHelpers.export(exports, "captureFocusRestore", function() {
    return captureFocusRestore;
});
var _domutils = require("./utils/DOMutils");
function weakRef(value) {
    if (!value) return null;
    // #68 Safari 14.1 dont have it yet
    // FIXME: remove in 2025
    if (typeof WeakRef === 'undefined') return function() {
        return value || null;
    };
    var w = value ? new WeakRef(value) : null;
    return function() {
        return (w === null || w === void 0 ? void 0 : w.deref()) || null;
    };
}
var recordElementLocation = function recordElementLocation(element) {
    if (!element) return null;
    var stack = [];
    var currentElement = element;
    while(currentElement && currentElement !== document.body){
        stack.push({
            current: weakRef(currentElement),
            parent: weakRef(currentElement.parentElement),
            left: weakRef(currentElement.previousElementSibling),
            right: weakRef(currentElement.nextElementSibling)
        });
        currentElement = currentElement.parentElement;
    }
    return {
        element: weakRef(element),
        stack: stack,
        ownerDocument: element.ownerDocument
    };
};
var restoreFocusTo = function restoreFocusTo(location) {
    var _a, _b, _c, _d, _e;
    if (!location) return undefined;
    var stack = location.stack, ownerDocument = location.ownerDocument;
    var visibilityCache = new Map();
    for(var _i = 0, stack_1 = stack; _i < stack_1.length; _i++){
        var line = stack_1[_i];
        var parent_1 = (_a = line.parent) === null || _a === void 0 ? void 0 : _a.call(line);
        // is it still here?
        if (parent_1 && ownerDocument.contains(parent_1)) {
            var left = (_b = line.left) === null || _b === void 0 ? void 0 : _b.call(line);
            var savedCurrent = line.current();
            var current = parent_1.contains(savedCurrent) ? savedCurrent : undefined;
            var right = (_c = line.right) === null || _c === void 0 ? void 0 : _c.call(line);
            var focusables = (0, _domutils.getTabbableNodes)([
                parent_1
            ], visibilityCache);
            var aim = // that is element itself
            (_e = (_d = current !== null && current !== void 0 ? current : // or something in it's place
            left === null || left === void 0 ? void 0 : left.nextElementSibling) !== null && _d !== void 0 ? _d : // or somebody to the right, still close enough
            right) !== null && _e !== void 0 ? _e : // or somebody to the left, something?
            left;
            while(aim){
                for(var _f = 0, focusables_1 = focusables; _f < focusables_1.length; _f++){
                    var focusable = focusables_1[_f];
                    if (aim === null || aim === void 0 ? void 0 : aim.contains(focusable.node)) return focusable.node;
                }
                aim = aim.nextElementSibling;
            }
            if (focusables.length) // if parent contains a focusable - move there
            return focusables[0].node;
        }
    }
    // nothing matched
    return undefined;
};
var captureFocusRestore = function captureFocusRestore(targetElement) {
    var location = recordElementLocation(targetElement);
    return function() {
        return restoreFocusTo(location);
    };
};

},{"./utils/DOMutils":"5u5g3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"h7jzm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRelativeFocusable", function() {
    return getRelativeFocusable;
});
parcelHelpers.export(exports, "focusNextElement", function() {
    return focusNextElement;
});
parcelHelpers.export(exports, "focusPrevElement", function() {
    return focusPrevElement;
});
parcelHelpers.export(exports, "focusFirstElement", function() {
    return focusFirstElement;
});
parcelHelpers.export(exports, "focusLastElement", function() {
    return focusLastElement;
});
var _commands = require("./commands");
var _domutils = require("./utils/DOMutils");
var _array = require("./utils/array");
var getRelativeFocusable = function getRelativeFocusable(element, scope, useTabbables) {
    if (!element || !scope) {
        console.error('no element or scope given');
        return {};
    }
    var shards = (0, _array.asArray)(scope);
    if (shards.every(function(shard) {
        return !(0, _domutils.contains)(shard, element);
    })) {
        console.error('Active element is not contained in the scope');
        return {};
    }
    var focusables = useTabbables ? (0, _domutils.getTabbableNodes)(shards, new Map()) : (0, _domutils.getFocusableNodes)(shards, new Map());
    var current = focusables.findIndex(function(_a) {
        var node = _a.node;
        return node === element;
    });
    if (current === -1) // an edge case, when anchor element is not found
    return undefined;
    return {
        prev: focusables[current - 1],
        next: focusables[current + 1],
        first: focusables[0],
        last: focusables[focusables.length - 1]
    };
};
var getBoundary = function getBoundary(shards, useTabbables) {
    var set = useTabbables ? (0, _domutils.getTabbableNodes)((0, _array.asArray)(shards), new Map()) : (0, _domutils.getFocusableNodes)((0, _array.asArray)(shards), new Map());
    return {
        first: set[0],
        last: set[set.length - 1]
    };
};
var defaultOptions = function defaultOptions(options) {
    return Object.assign({
        scope: document.body,
        cycle: true,
        onlyTabbable: true
    }, options);
};
var moveFocus = function moveFocus(fromElement, options, cb) {
    if (options === void 0) options = {};
    var newOptions = defaultOptions(options);
    var solution = getRelativeFocusable(fromElement, newOptions.scope, newOptions.onlyTabbable);
    if (!solution) return;
    var target = cb(solution, newOptions.cycle);
    if (target) (0, _commands.focusOn)(target.node, newOptions.focusOptions);
};
var focusNextElement = function focusNextElement(fromElement, options) {
    if (options === void 0) options = {};
    moveFocus(fromElement, options, function(_a, cycle) {
        var next = _a.next, first = _a.first;
        return next || cycle && first;
    });
};
var focusPrevElement = function focusPrevElement(fromElement, options) {
    if (options === void 0) options = {};
    moveFocus(fromElement, options, function(_a, cycle) {
        var prev = _a.prev, last = _a.last;
        return prev || cycle && last;
    });
};
var pickBoundary = function pickBoundary(scope, options, what) {
    var _a;
    var boundary = getBoundary(scope, (_a = options.onlyTabbable) !== null && _a !== void 0 ? _a : true);
    var node = boundary[what];
    if (node) (0, _commands.focusOn)(node.node, options.focusOptions);
};
var focusFirstElement = function focusFirstElement(scope, options) {
    if (options === void 0) options = {};
    pickBoundary(scope, options, 'first');
};
var focusLastElement = function focusLastElement(scope, options) {
    if (options === void 0) options = {};
    pickBoundary(scope, options, 'last');
};

},{"./commands":"X1CaT","./utils/DOMutils":"5u5g3","./utils/array":"elZm4","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2gE4f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deferAction", function() {
    return deferAction;
});
parcelHelpers.export(exports, "inlineProp", function() {
    return inlineProp;
});
parcelHelpers.export(exports, "extractRef", function() {
    return extractRef;
});
function deferAction(action) {
    setTimeout(action, 1);
}
var inlineProp = function inlineProp(name, value) {
    var obj = {};
    obj[name] = value;
    return obj;
};
var extractRef = function extractRef(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iBy4G":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _ScrollLock = require("c9d108485449cab6");
Object.defineProperty(exports, 'default', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_ScrollLock).default;
    }
});
var _TouchScrollable = require("4f073b15a78b9f38");
Object.defineProperty(exports, 'TouchScrollable', {
    enumerable: true,
    get: function get() {
        return _TouchScrollable.TouchScrollable;
    }
});
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

},{"c9d108485449cab6":"2m9Mf","4f073b15a78b9f38":"fBrOL"}],"2m9Mf":[function(require,module,exports,__globalThis) {
var _instanceof = require("@swc/helpers/_/_instanceof");
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _react = require("4212636c361ae747");
var _react2 = _interopRequireDefault(_react);
var _exenv = require("25c719b7c60d2573");
var _TouchScrollable = require("d70815e65c0f0aed");
var _withLockSheet = require("d885418bbbe2e405");
var _withLockSheet2 = _interopRequireDefault(_withLockSheet);
var _withTouchListeners = require("7047119e6b70f1f2");
var _withTouchListeners2 = _interopRequireDefault(_withTouchListeners);
var _utils = require("bbe7fdfd1f1d5fac");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(0, _instanceof._)(instance, Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && ((typeof call === "undefined" ? "undefined" : (0, _typeOf._)(call)) === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeOf._)(superClass)));
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var ScrollLock = function(_PureComponent) {
    _inherits(ScrollLock, _PureComponent);
    function ScrollLock() {
        _classCallCheck(this, ScrollLock);
        return _possibleConstructorReturn(this, (ScrollLock.__proto__ || Object.getPrototypeOf(ScrollLock)).apply(this, arguments));
    }
    _createClass(ScrollLock, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!_exenv.canUseDOM) return;
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                var offset = window.innerHeight - this.initialHeight;
                // adjust scroll if the window has been resized since the lock was engaged
                // e.g. mobile safari dynamic chrome heights
                if (offset) window.scrollTo(0, window.pageYOffset + offset);
                // reset the initial height in case this scroll lock is used again
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: 'render',
            value: function render() {
                var children = this.props.children;
                return children ? _react2.default.createElement(_TouchScrollable.TouchScrollable, null, children) : null;
            }
        }
    ]);
    return ScrollLock;
}(_react.PureComponent);
// attach the stylesheet and inject styles on [un]mount
var compose = (0, _utils.pipe)(_withTouchListeners2.default, _withLockSheet2.default);
var SheetLock = compose(ScrollLock);
// toggle the lock based on `isActive` prop
var LockToggle = function LockToggle(props) {
    return props.isActive ? _react2.default.createElement(SheetLock, props) : props.children;
};
LockToggle.defaultProps = {
    accountForScrollbars: true,
    children: null,
    isActive: true
};
exports.default = LockToggle;

},{"@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_type_of":"iFJdx","4212636c361ae747":"ltHCL","25c719b7c60d2573":"9G3Tv","d70815e65c0f0aed":"fBrOL","d885418bbbe2e405":"lf7Dn","7047119e6b70f1f2":"fLXG7","bbe7fdfd1f1d5fac":"2dFFR"}],"9G3Tv":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/ /* global define */ (function() {
    'use strict';
    var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    var ExecutionEnvironment = {
        canUseDOM: canUseDOM,
        canUseWorkers: typeof Worker !== 'undefined',
        canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
        canUseViewport: canUseDOM && !!window.screen
    };
    if (typeof define === 'function' && (0, _typeOf._)(define.amd) === 'object' && define.amd) define(function() {
        return ExecutionEnvironment;
    });
    else if (module.exports) module.exports = ExecutionEnvironment;
    else window.ExecutionEnvironment = ExecutionEnvironment;
})();

},{"@swc/helpers/_/_type_of":"iFJdx"}],"fBrOL":[function(require,module,exports,__globalThis) {
var _instanceof = require("@swc/helpers/_/_instanceof");
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TouchScrollable = undefined;
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _react = require("755e63adcd77fb16");
var _exenv = require("9846e6385a7469a3");
var _utils = require("6445da016a994d4d");
function _objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function _classCallCheck(instance, Constructor) {
    if (!(0, _instanceof._)(instance, Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && ((typeof call === "undefined" ? "undefined" : (0, _typeOf._)(call)) === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeOf._)(superClass)));
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var TouchScrollable = exports.TouchScrollable = function(_PureComponent) {
    _inherits(TouchScrollable, _PureComponent);
    function TouchScrollable() {
        var _ref;
        var _temp, _this, _ret;
        _classCallCheck(this, TouchScrollable);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TouchScrollable.__proto__ || Object.getPrototypeOf(TouchScrollable)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.getScrollableArea = function _ret(ref) {
            _this.scrollableArea = ref;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }
    _createClass(TouchScrollable, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!_exenv.canUseEventListeners) return;
                this.scrollableArea.addEventListener('touchstart', _utils.preventInertiaScroll, _utils.listenerOptions);
                this.scrollableArea.addEventListener('touchmove', _utils.allowTouchMove, _utils.listenerOptions);
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (!_exenv.canUseEventListeners) return;
                this.scrollableArea.removeEventListener('touchstart', _utils.preventInertiaScroll, _utils.listenerOptions);
                this.scrollableArea.removeEventListener('touchmove', _utils.allowTouchMove, _utils.listenerOptions);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, children = _props.children, rest = _objectWithoutProperties(_props, [
                    'children'
                ]);
                return typeof children === 'function' ? children(this.getScrollableArea) : (0, _react.cloneElement)(children, _extends({
                    ref: this.getScrollableArea
                }, rest));
            }
        }
    ]);
    return TouchScrollable;
}(_react.PureComponent);

},{"@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_type_of":"iFJdx","755e63adcd77fb16":"ltHCL","9846e6385a7469a3":"9G3Tv","6445da016a994d4d":"2dFFR"}],"2dFFR":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.pipe = exports.listenerOptions = undefined;
exports.preventTouchMove = preventTouchMove;
exports.allowTouchMove = allowTouchMove;
exports.preventInertiaScroll = preventInertiaScroll;
exports.isTouchDevice = isTouchDevice;
exports.camelToKebab = camelToKebab;
exports.parse = parse;
exports.getPadding = getPadding;
exports.getWindowHeight = getWindowHeight;
exports.getDocumentHeight = getDocumentHeight;
exports.makeStyleTag = makeStyleTag;
exports.injectStyles = injectStyles;
exports.insertStyleTag = insertStyleTag;
var _exenv = require("b4cb8ee42bf2dcad");
var listenerOptions = exports.listenerOptions = {
    capture: false,
    passive: false
};
// ==============================
// Touch Helpers
// ==============================
function preventTouchMove(e) {
    e.preventDefault();
    return false;
}
function allowTouchMove(e) {
    var target = e.currentTarget;
    if (target.scrollHeight > target.clientHeight) {
        e.stopPropagation();
        return true;
    }
    e.preventDefault();
    return false;
}
function preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function isTouchDevice() {
    if (!_exenv.canUseDOM) return false;
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
// ==============================
// Misc.
// ==============================
function camelToKebab(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}
function parse(val) {
    return isNaN(val) ? val : val + 'px';
}
// Take a list of functions and return a function that applies the list of
// functions from left to right
var pipeFns = function pipeFns(a, b) {
    return function() {
        return b(a.apply(undefined, arguments));
    };
};
var pipe = exports.pipe = function pipe() {
    for(var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return fns.reduce(pipeFns);
};
// ==============================
// Document Helpers
// ==============================
function getPadding() {
    if (!_exenv.canUseDOM) return 0;
    var paddingRight = parseInt(window.getComputedStyle(document.body).paddingRight, 10);
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    return paddingRight + scrollbarWidth;
}
function getWindowHeight() {
    var multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    if (_exenv.canUseDOM) return window.innerHeight * multiplier;
}
function getDocumentHeight() {
    if (_exenv.canUseDOM) return document.body.clientHeight;
}
// ==============================
// Style Sheets
// ==============================
function makeStyleTag() {
    if (!_exenv.canUseDOM) return;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    tag.setAttribute('data-react-scrolllock', '');
    return tag;
}
function injectStyles(tag, css) {
    if (!_exenv.canUseDOM) return;
    if (tag.styleSheet) tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function insertStyleTag(tag) {
    if (!_exenv.canUseDOM) return;
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}

},{"b4cb8ee42bf2dcad":"9G3Tv"}],"lf7Dn":[function(require,module,exports,__globalThis) {
var _instanceof = require("@swc/helpers/_/_instanceof");
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
exports.default = withLockSheet;
var _react = require("737cf936330fc708");
var _react2 = _interopRequireDefault(_react);
var _utils = require("acba1fa2f92d654f");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(0, _instanceof._)(instance, Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && ((typeof call === "undefined" ? "undefined" : (0, _typeOf._)(call)) === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeOf._)(superClass)));
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function withLockSheet(WrappedComponent) {
    return function(_PureComponent) {
        _inherits(SheetProvider, _PureComponent);
        function SheetProvider() {
            var _ref;
            var _temp, _this, _ret;
            _classCallCheck(this, SheetProvider);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SheetProvider.__proto__ || Object.getPrototypeOf(SheetProvider)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.addSheet = function _ret() {
                var styles = _this.getStyles();
                var sheet = (0, _utils.makeStyleTag)();
                if (!sheet) return;
                (0, _utils.injectStyles)(sheet, styles);
                (0, _utils.insertStyleTag)(sheet);
                _this.sheet = sheet;
            }, _this.getStyles = function() {
                var accountForScrollbars = _this.props.accountForScrollbars;
                var height = (0, _utils.getDocumentHeight)();
                var paddingRight = accountForScrollbars ? (0, _utils.getPadding)() : null;
                var styles = 'body {\n        box-sizing: border-box !important;\n        overflow: hidden !important;\n        position: relative !important;\n        ' + (height ? 'height: ' + height + 'px !important;' : '') + '\n        ' + (paddingRight ? 'padding-right: ' + paddingRight + 'px !important;' : '') + '\n      }';
                return styles;
            }, _temp), _possibleConstructorReturn(_this, _ret);
        }
        _createClass(SheetProvider, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    this.addSheet();
                }
            },
            {
                key: 'removeSheet',
                value: function removeSheet() {
                    if (!this.sheet || !this.sheet.parentNode || typeof this.sheet.parentNode.removeChild !== 'function') return;
                    // $FlowFixMe
                    this.sheet.parentNode.removeChild(this.sheet);
                    this.sheet = null;
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    this.removeSheet();
                }
            },
            {
                key: 'render',
                value: function render() {
                    return _react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return SheetProvider;
    }(_react.PureComponent);
}

},{"@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_type_of":"iFJdx","737cf936330fc708":"ltHCL","acba1fa2f92d654f":"2dFFR"}],"fLXG7":[function(require,module,exports,__globalThis) {
var _instanceof = require("@swc/helpers/_/_instanceof");
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
exports.default = withTouchListeners;
var _react = require("aa6594585f6f1c7");
var _react2 = _interopRequireDefault(_react);
var _exenv = require("ea84623b51c95046");
var _utils = require("5a42eda247af6766");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(0, _instanceof._)(instance, Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && ((typeof call === "undefined" ? "undefined" : (0, _typeOf._)(call)) === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeOf._)(superClass)));
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// Mobile Safari ignores { overflow: hidden } declaration on the body,
// so we have to prevent touchmove events via JS
function withTouchListeners(WrappedComponent) {
    return function(_PureComponent) {
        _inherits(TouchProvider, _PureComponent);
        function TouchProvider() {
            _classCallCheck(this, TouchProvider);
            return _possibleConstructorReturn(this, (TouchProvider.__proto__ || Object.getPrototypeOf(TouchProvider)).apply(this, arguments));
        }
        _createClass(TouchProvider, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    if (!_exenv.canUseDOM || !(0, _utils.isTouchDevice)()) return;
                    document.addEventListener('touchmove', _utils.preventTouchMove, _utils.listenerOptions);
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    if (!_exenv.canUseDOM || !(0, _utils.isTouchDevice)()) return;
                    document.removeEventListener('touchmove', _utils.preventTouchMove, _utils.listenerOptions);
                }
            },
            {
                key: 'render',
                value: function render() {
                    return _react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return TouchProvider;
    }(_react.PureComponent);
}

},{"@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_type_of":"iFJdx","aa6594585f6f1c7":"ltHCL","ea84623b51c95046":"9G3Tv","5a42eda247af6766":"2dFFR"}],"9QvIs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return 0, _blanketDefault.default;
});
var _blanket = require("./blanket");
var _blanketDefault = parcelHelpers.interopDefault(_blanket);

},{"./blanket":"ad2Eo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ad2Eo":[function(require,module,exports,__globalThis) {
/* blanket.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _usePlatformLeafEventHandler = require("@atlaskit/analytics-next/usePlatformLeafEventHandler");
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var packageName = undefined;
var packageVersion = undefined;
var analyticsAttributes = {
    componentName: 'blanket',
    packageName: packageName,
    packageVersion: packageVersion
};
var baseStyles = null;
var shouldAllowClickThroughStyles = null;
var invisibleStyles = null;
/**
 * __Blanket__
 *
 * A Blanket provides the overlay layer for components such as a modal dialog or a tooltip
 *
 * - [Examples](https://atlaskit.atlassian.com/examples/design-system/blanket/basic-usage)
 */ var Blanket = /*#__PURE__*/ (0, _react.memo)(/*#__PURE__*/ (0, _react.forwardRef)(function Blanket(param, ref) {
    var _param_shouldAllowClickThrough = param.shouldAllowClickThrough, shouldAllowClickThrough = _param_shouldAllowClickThrough === void 0 ? false : _param_shouldAllowClickThrough, _param_isTinted = param.isTinted, isTinted = _param_isTinted === void 0 ? false : _param_isTinted, _param_onBlanketClicked = param.onBlanketClicked, onBlanketClicked = _param_onBlanketClicked === void 0 ? (0, _noopDefault.default) : _param_onBlanketClicked, testId = param.testId, children = param.children, analyticsContext = param.analyticsContext;
    var mouseDownTarget = (0, _react.useRef)(null);
    var onBlanketClickedWithAnalytics = (0, _usePlatformLeafEventHandler.usePlatformLeafEventHandler)((0, _objectSpread._)({
        fn: onBlanketClicked,
        action: 'clicked',
        analyticsData: analyticsContext
    }, analyticsAttributes));
    var blanketClickOutsideChildren = (0, _react.useCallback)(function(e) {
        return e.currentTarget === e.target && mouseDownTarget.current === e.target ? onBlanketClickedWithAnalytics(e) : undefined;
    }, [
        onBlanketClickedWithAnalytics
    ]);
    var onClick = shouldAllowClickThrough ? undefined : blanketClickOutsideChildren;
    var onMouseDown = (0, _react.useCallback)(function(e) {
        mouseDownTarget.current = e.target;
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        role: "presentation",
        onClick: onClick,
        onMouseDown: onMouseDown,
        "data-testid": testId,
        ref: ref,
        className: (0, _runtime.ax)([
            "_1r04idpf _kqsw1n9t _1pbybfng _bfhk1i5c _18m91wug _lcxv1wug",
            shouldAllowClickThrough && "_lcxvglyw",
            !isTinted && "_bfhk1j28"
        ]),
        children: children
    });
}));
Blanket.displayName = 'Blanket';
exports.default = Blanket;

},{"@swc/helpers/_/_object_spread":"9gdrV","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/analytics-next/usePlatformLeafEventHandler":"8d2dv","@atlaskit/ds-lib/noop":"2f3bg","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3d5W2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return 0, _fadeInDefault.default;
});
var _fadeIn = require("../entering/fade-in");
var _fadeInDefault = parcelHelpers.interopDefault(_fadeIn);

},{"../entering/fade-in":"iIUo1","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"chD7x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return useModalStack;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _useLazyCallback = require("@atlaskit/ds-lib/use-lazy-callback");
var _useLazyCallbackDefault = parcelHelpers.interopDefault(_useLazyCallback);
var _usePreviousValue = require("@atlaskit/ds-lib/use-previous-value");
var _usePreviousValueDefault = parcelHelpers.interopDefault(_usePreviousValue);
var _useStateRef = require("@atlaskit/ds-lib/use-state-ref");
var _useStateRefDefault = parcelHelpers.interopDefault(_useStateRef);
var _exitingPersistence = require("@atlaskit/motion/exiting-persistence");
/**
 *  ________________________________________________
 * | MAJOR VERSIONS WILL NOT KNOW ABOUT EACH OTHER! |
 *  ------------------------------------------------
 *
 * An array which holds references to all currently open modal dialogs.
 * This will only work for modal dialogs of the same major version,
 * as the reference will be different between them.
 *
 * E.g. V11 won't know about any from V12.
 */ var modalStackRegister = [];
function useModalStack(param) {
    var onStackChange = param.onStackChange;
    var isExiting = (0, _exitingPersistence.useExitingPersistence)().isExiting;
    var _useStateRef = (0, _slicedToArray._)((0, _useStateRefDefault.default)(0), 2), stackIndexRef = _useStateRef[0], setStackIndex = _useStateRef[1];
    var currentStackIndex = stackIndexRef.current;
    var previousStackIndex = (0, _usePreviousValueDefault.default)(stackIndexRef.current);
    // We want to ensure this function **never changes** during the lifecycle of this component.
    // This is why it's assigned to a ref and not in a useMemo/useCallback.
    var updateStack = (0, _useLazyCallbackDefault.default)(function() {
        var newStackIndex = modalStackRegister.indexOf(updateStack);
        // We access the stack index ref instead of state because this closure will always only
        // have the initial state and not any of the later values.
        if (stackIndexRef.current !== newStackIndex) {
            setStackIndex(newStackIndex);
            stackIndexRef.current = newStackIndex;
        }
    });
    (0, _react.useEffect)(function() {
        var currentStackIndex = modalStackRegister.indexOf(updateStack);
        if (!isExiting && currentStackIndex === -1) // We are opening the modal dialog.
        // Add ourselves to the modal stack register!
        modalStackRegister.unshift(updateStack);
        if (isExiting && currentStackIndex !== -1) // We are closing the modal dialog using a wrapping modal transition component.
        // Remove ourselves from the modal stack register!
        // NOTE: Modal dialogs that don't have a wrapping modal transition component won't flow through here!
        // For that scenario we cleanup when the component unmounts.
        modalStackRegister.splice(currentStackIndex, 1);
        // Fire all registered modal dialogs to update their position in the stack.
        modalStackRegister.forEach(function(cb) {
            return cb();
        });
    }, [
        updateStack,
        isExiting
    ]);
    (0, _react.useEffect)(function() {
        return function() {
            // Final cleanup just in case this modal dialog did not have a wrapping modal transition.
            var currentStackIndex = modalStackRegister.indexOf(updateStack);
            if (currentStackIndex !== -1) {
                modalStackRegister.splice(currentStackIndex, 1);
                modalStackRegister.forEach(function(cb) {
                    return cb();
                });
            }
        };
    }, [
        updateStack
    ]);
    (0, _react.useEffect)(function() {
        if (previousStackIndex === undefined) // Initial case that we don't need to notify about.
        return;
        if (previousStackIndex !== currentStackIndex) onStackChange(currentStackIndex);
    }, [
        onStackChange,
        previousStackIndex,
        currentStackIndex
    ]);
    return currentStackIndex;
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","react":"ltHCL","@atlaskit/ds-lib/use-lazy-callback":"lB6Xv","@atlaskit/ds-lib/use-previous-value":"6f014","@atlaskit/ds-lib/use-state-ref":"aOY5i","@atlaskit/motion/exiting-persistence":"kQCSw","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lB6Xv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return useLazyCallback;
});
var _useLazyRef = require("./use-lazy-ref");
var _useLazyRefDefault = parcelHelpers.interopDefault(_useLazyRef);
function useLazyCallback(callback) {
    var ref = (0, _useLazyRefDefault.default)(function() {
        return callback;
    });
    return ref.current;
}

},{"./use-lazy-ref":"ifddZ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ifddZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return useLazyRef;
});
var _react = require("react");
var uniqueReferencedValue = {};
function useLazyRef(initializer) {
    var ref = (0, _react.useRef)(uniqueReferencedValue);
    if (ref.current === uniqueReferencedValue) ref.current = initializer();
    return ref;
}

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6f014":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return usePreviousValue;
});
var _react = require("react");
function usePreviousValue(value) {
    var ref = (0, _react.useRef)();
    (0, _react.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aOY5i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return useStateRef;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
function useStateRef(initialState) {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(initialState), 2), value = _useState[0], setValue = _useState[1];
    var valueRef = (0, _react.useRef)(value);
    valueRef.current = value;
    return [
        valueRef,
        setValue
    ];
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8gSof":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return usePreventProgrammaticScroll;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _bindEventListener = require("bind-event-listener");
/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function getScrollDistance() {
    var _document_documentElement, _document_body;
    return window.pageYOffset || ((_document_documentElement = document.documentElement) === null || _document_documentElement === void 0 ? void 0 : _document_documentElement.scrollTop) || ((_document_body = document.body) === null || _document_body === void 0 ? void 0 : _document_body.scrollTop) || 0;
}
function usePreventProgrammaticScroll() {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(0), 2), scrollTopOffset = _useState[0], setScrollTopOffset = _useState[1];
    (0, _react.useLayoutEffect)(function() {
        setScrollTopOffset(getScrollDistance());
    }, []);
    var onWindowScroll = (0, _react.useCallback)(function() {
        if (getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, _react.useEffect)(function() {
        return (0, _bindEventListener.bind)(window, {
            type: 'scroll',
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","react":"ltHCL","bind-event-listener":"bjeUU","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7mQoU":[function(require,module,exports,__globalThis) {
/* modal-dialog.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _css = require("@atlaskit/css");
var _mergeRefs = require("@atlaskit/ds-lib/merge-refs");
var _mergeRefsDefault = parcelHelpers.interopDefault(_mergeRefs);
var _useAutoFocus = require("@atlaskit/ds-lib/use-auto-focus");
var _useAutoFocusDefault = parcelHelpers.interopDefault(_useAutoFocus);
var _useId = require("@atlaskit/ds-lib/use-id");
var _layering = require("@atlaskit/layering");
var _motion = require("@atlaskit/motion");
var _fadeIn = require("@atlaskit/motion/fade-in");
var _fadeInDefault = parcelHelpers.interopDefault(_fadeIn);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _combine = require("@atlaskit/pragmatic-drag-and-drop/combine");
var _context = require("../context");
var _useOnMotionFinish = require("../hooks/use-on-motion-finish");
var _useOnMotionFinishDefault = parcelHelpers.interopDefault(_useOnMotionFinish);
var _element = require("../pragmatic-drag-and-drop/disable-dragging-to-cross-origin-iframes/element");
var _external = require("../pragmatic-drag-and-drop/disable-dragging-to-cross-origin-iframes/external");
var _textSelection = require("../pragmatic-drag-and-drop/disable-dragging-to-cross-origin-iframes/text-selection");
var _scrollContext = require("../scroll-context");
var _width = require("../width");
var _positioner = require("./positioner");
var _positionerDefault = parcelHelpers.interopDefault(_positioner);
var dialogWidth = function(input) {
    if (!input) return 'auto';
    var isWidthName = (0, _width.width).values.indexOf(input.toString()) !== -1;
    var widthName = isWidthName && input;
    if (widthName) return "".concat((0, _width.width).widths[widthName], "px");
    return typeof input === 'number' ? "".concat(input, "px") : input;
};
var dialogHeight = function(input) {
    if (!input) return 'auto';
    return typeof input === 'number' ? "".concat(input, "px") : input;
};
var LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
var dialogStyles = {
    root: "_16jlidpf _1o9zkb7n _i0dl1wug _1e0c1txw _1bsb1osq _p12fauwl _4t3i1osq _1tkeidpf _c71l1kxc _2lx21bp4 _bfhk1bhr _syazi7uo _1q1l1bhr _lcxv1wug _1mq81kw7 _m01u1kw7 _1dg11kw7 _mizu1v1w _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y _we1i1kw7 _zg7p130s _yakv1kw7 _4lht1kw7 _1xlt6m9r",
    borderRadius: "_epkxfajl",
    borderRadiusT26Shape: "_epkxpb1k",
    motion: "_4t3i1osq _c71l1kw7 _p12f1kw7 _1jyk1wug _yakv1kw7 _4lht1kw7",
    fullscreen: "_1jyk1osq"
};
var viewportScrollStyles = null;
var bodyScrollStyles = null;
var ModalDialog = function(props) {
    var _props_width = props.width, width = _props_width === void 0 ? 'medium' : _props_width, _props_shouldScrollInViewport = props.shouldScrollInViewport, shouldScrollInViewport = _props_shouldScrollInViewport === void 0 ? false : _props_shouldScrollInViewport, shouldCloseOnEscapePress = props.shouldCloseOnEscapePress, providedAutoFocus = props.autoFocus, stackIndex = props.stackIndex, onClose = props.onClose, onCloseComplete = props.onCloseComplete, onOpenComplete = props.onOpenComplete, height = props.height, hasProvidedOnClose = props.hasProvidedOnClose, children = props.children, label = props.label, testId = props.testId, _props_isFullScreen = props.isFullScreen, isFullScreen = _props_isFullScreen === void 0 ? false : _props_isFullScreen, _props_UNSAFE_shouldDisableMotionUplift = props.UNSAFE_shouldDisableMotionUplift, UNSAFE_shouldDisableMotionUplift = _props_UNSAFE_shouldDisableMotionUplift === void 0 ? false : _props_UNSAFE_shouldDisableMotionUplift;
    var id = (0, _useId.useId)();
    var titleId = "modal-dialog-title-".concat(id);
    var defaultTestId = testId || 'modal-dialog'; // https://product-fabric.atlassian.net/browse/DSP-24307
    // If flag and falsy, use true instead.
    // When we remove boolean `autoFocus`, we won't have to worry about this
    var autoFocus = !providedAutoFocus ? true : providedAutoFocus;
    (0, _react.useEffect)(function() {
        // Modal dialogs can appear on top of iframe elements that are on another domain.
        // There is a Chrome bug where drag and drop in an element on top of a cross domain
        // iframe is not working. We are applying the workaround for this bug in modal so
        // that consumers of our modal don't have to worry about this bug and are free to
        // create whatever drag and drop experience they like inside a modal
        //
        // Chrome bug: https://issues.chromium.org/issues/362301053
        return (0, _combine.combine)((0, _element.disableDraggingToCrossOriginIFramesForElement)(), (0, _textSelection.disableDraggingToCrossOriginIFramesForTextSelection)(), (0, _external.disableDraggingToCrossOriginIFramesForExternal)());
    }, []);
    (0, _useAutoFocusDefault.default)((typeof autoFocus === "undefined" ? "undefined" : (0, _typeOf._)(autoFocus)) === 'object' ? autoFocus : undefined, // When a user supplies  a ref to focus we enable this hook
    (typeof autoFocus === "undefined" ? "undefined" : (0, _typeOf._)(autoFocus)) === 'object');
    var _useOnMotionFinish = (0, _slicedToArray._)((0, _useOnMotionFinishDefault.default)({
        onOpenComplete: onOpenComplete,
        onCloseComplete: onCloseComplete
    }), 2), motionRef = _useOnMotionFinish[0], onMotionFinish = _useOnMotionFinish[1];
    var modalDialogContext = (0, _react.useMemo)(function() {
        return {
            testId: defaultTestId,
            titleId: titleId,
            onClose: onClose,
            hasProvidedOnClose: hasProvidedOnClose,
            isFullScreen: isFullScreen
        };
    }, [
        defaultTestId,
        titleId,
        onClose,
        hasProvidedOnClose,
        isFullScreen
    ]);
    (0, _layering.useCloseOnEscapePress)({
        onClose: onClose,
        isDisabled: !shouldCloseOnEscapePress
    });
    var currentLevel = (0, _layering.useLayering)().currentLevel;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _positionerDefault.default), {
        stackIndex: stackIndex,
        shouldScrollInViewport: shouldScrollInViewport,
        testId: defaultTestId,
        isFullScreen: isFullScreen,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.ModalContext).Provider, {
            value: modalDialogContext,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _scrollContext.ScrollContext).Provider, {
                value: shouldScrollInViewport,
                children: !UNSAFE_shouldDisableMotionUplift && (0, _platformFeatureFlags.fg)('platform-dst-motion-uplift-modal') ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _motion.Motion), {
                    enteringAnimation: "var(--ds-modal-enter, 250ms cubic-bezier(0.4, 0, 0, 1) ScaleIn95to100)",
                    exitingAnimation: "var(--ds-modal-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to95)",
                    onFinish: onMotionFinish,
                    xcss: (0, _css.cx)(dialogStyles.motion, isFullScreen && dialogStyles.fullscreen),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("section", {
                        "aria-label": label,
                        ref: motionRef,
                        style: {
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                            '--modal-dialog-width': dialogWidth(width),
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                            '--modal-dialog-height': dialogHeight(height)
                        },
                        role: "dialog",
                        "aria-labelledby": label ? undefined : titleId,
                        "data-testid": defaultTestId,
                        "data-modal-stack": stackIndex,
                        tabIndex: -1,
                        "aria-modal": true,
                        "data-ds--level": currentLevel,
                        className: (0, _runtime.ax)([
                            dialogStyles.root,
                            !isFullScreen && dialogStyles.borderRadius,
                            !isFullScreen && (0, _platformFeatureFlags.fg)('platform-dst-shape-theme-default') && dialogStyles.borderRadiusT26Shape,
                            shouldScrollInViewport ? "_1tke1kxc _c71lglyw _8kn617ks" : "_cbiz17ks _bolh1kw7"
                        ]),
                        children: children
                    })
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fadeInDefault.default /**
                           * We don't want a 'slide in' for the full screen modals.
                           */ ), {
                    entranceDirection: isFullScreen ? undefined : 'bottom',
                    onFinish: onMotionFinish,
                    children: function(bottomFadeInProps) {
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("section", (0, _objectSpreadProps._)((0, _objectSpread._)({}, bottomFadeInProps), {
                            "aria-label": label,
                            ref: (0, _mergeRefsDefault.default)([
                                bottomFadeInProps.ref,
                                motionRef
                            ]),
                            style: {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                '--modal-dialog-width': dialogWidth(width),
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                '--modal-dialog-height': dialogHeight(height)
                            },
                            className: (0, _runtime.ax)([
                                dialogStyles.root,
                                !isFullScreen && dialogStyles.borderRadius,
                                !isFullScreen && (0, _platformFeatureFlags.fg)('platform-dst-shape-theme-default') && dialogStyles.borderRadiusT26Shape,
                                shouldScrollInViewport ? "_1tke1kxc _c71lglyw _8kn617ks" : "_cbiz17ks _bolh1kw7",
                                bottomFadeInProps.className
                            ]),
                            role: "dialog",
                            "aria-labelledby": label ? undefined : titleId,
                            "data-testid": defaultTestId,
                            "data-modal-stack": stackIndex,
                            tabIndex: -1,
                            "aria-modal": true,
                            "data-ds--level": currentLevel,
                            children: children
                        }));
                    }
                })
            })
        })
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = ModalDialog;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_type_of":"iFJdx","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/css":"fiaHp","@atlaskit/ds-lib/merge-refs":"bhv2L","@atlaskit/ds-lib/use-auto-focus":"2jsXQ","@atlaskit/ds-lib/use-id":"axFod","@atlaskit/layering":"laO1Y","@atlaskit/motion":"gQd69","@atlaskit/motion/fade-in":"3d5W2","@atlaskit/platform-feature-flags":"kO5t9","@atlaskit/pragmatic-drag-and-drop/combine":"ajFdY","../context":"hnWJj","../hooks/use-on-motion-finish":"6k7PV","../pragmatic-drag-and-drop/disable-dragging-to-cross-origin-iframes/element":"bQHJw","../pragmatic-drag-and-drop/disable-dragging-to-cross-origin-iframes/external":"b22jl","../pragmatic-drag-and-drop/disable-dragging-to-cross-origin-iframes/text-selection":"8Hakd","../scroll-context":"g0pv7","../width":"c0zul","./positioner":"9MxCN","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hnWJj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScrollContext", function() {
    return 0, _scrollContext.ScrollContext;
});
parcelHelpers.export(exports, "ModalContext", function() {
    return ModalContext;
});
var _react = require("react");
var _scrollContext = require("./scroll-context");
var ModalContext = /*#__PURE__*/ (0, _react.createContext)(null);

},{"react":"ltHCL","./scroll-context":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"g0pv7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScrollContext", function() {
    return ScrollContext;
});
var _react = require("react");
var ScrollContext = /*#__PURE__*/ (0, _react.createContext)(null);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6k7PV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return useOnMotionFinish;
});
var _react = require("react");
function useOnMotionFinish(param) {
    var onOpenComplete = param.onOpenComplete, onCloseComplete = param.onCloseComplete;
    var motionRef = (0, _react.useRef)(null);
    var onMotionFinish = (0, _react.useCallback)(function(state) {
        if (state === 'entering' && onOpenComplete) onOpenComplete(motionRef.current, true);
        if (state === 'exiting' && onCloseComplete) onCloseComplete(motionRef.current);
    }, [
        onOpenComplete,
        onCloseComplete
    ]);
    return [
        motionRef,
        onMotionFinish
    ];
}

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bQHJw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "disableDraggingToCrossOriginIFramesForElement", function() {
    return disableDraggingToCrossOriginIFramesForElement;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
var _bindEventListener = require("bind-event-listener");
var _combine = require("@atlaskit/pragmatic-drag-and-drop/combine");
var _adapter = require("@atlaskit/pragmatic-drag-and-drop/element/adapter");
var _makeFixForAdapter = require("./make-fix-for-adapter");
function watchForInteractionEnd(param) {
    var stop = param.stop;
    var isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    var unbindEvents = (0, _bindEventListener.bindAll)(window, [
        {
            // Another interaction is starting, this fix should be removed.
            type: 'pointerdown',
            listener: stop
        },
        {
            // The user did not start a drag
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            // if a "dragstart" occurs and the flag is not set,
            // then a drag has not started.
            // Note: could not use "pointercancel" as it is not
            // published in Safari
            // → https://bugs.webkit.org/show_bug.cgi?id=222632
            type: 'dragstart',
            listener: stopIfNotDragging,
            // Need to come after the element adapter
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // Being super clear these should only run once
        once: true
    });
    var unbindMonitor = (0, _adapter.monitorForElements)({
        onGenerateDragPreview: function onGenerateDragPreview() {
            isDragging = true;
        },
        onDrop: function onDrop() {
            isDragging = false;
            stop();
        }
    });
    return (0, _combine.combine)(unbindEvents, unbindMonitor);
}
function watchForInteractionStart(param) {
    var start = param.start;
    return (0, _bindEventListener.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener: function listener(event) {
            // Only starting if pressing down inside a draggable element
            // At this point, we are not sure which if:
            // 1. a text selection drag is starting
            // 2. a draggable managed by pdnd is going to be dragged
            // 3. a draggable not managed by pdnd is going to be dragged
            // 4. The user will be dragging anything at all (might be doing a click)
            if ((0, _instanceof._)(event.target, HTMLElement) && event.target.closest('[draggable="true"]')) start();
        }
    });
}
var api = (0, _makeFixForAdapter.makeFixForAdapter)({
    watchForInteractionStart: watchForInteractionStart,
    watchForInteractionEnd: watchForInteractionEnd
});
function disableDraggingToCrossOriginIFramesForElement() {
    return api.registerUsage();
}

},{"@swc/helpers/_/_instanceof":"h9UKc","bind-event-listener":"bjeUU","@atlaskit/pragmatic-drag-and-drop/combine":"ajFdY","@atlaskit/pragmatic-drag-and-drop/element/adapter":"9mWL4","./make-fix-for-adapter":"iIXf2","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iIXf2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeFixForAdapter", function() {
    return makeFixForAdapter;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _combine = require("@atlaskit/pragmatic-drag-and-drop/combine");
/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function setStyle(el, param) {
    var property = param.property, rule = param.rule, _param_priority = param.priority, priority = _param_priority === void 0 ? '' : _param_priority;
    var originalValue = el.style.getPropertyValue(property);
    var originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
function hasSameOrigin(href1, href2) {
    var url1;
    var url2;
    try {
        url1 = new URL(href1);
        url2 = new URL(href2);
    } catch (e) {
        // failed to parse a href
        return false;
    }
    // https://developer.mozilla.org/en-US/docs/Web/Security/Same-origin_policy
    return url1.protocol === url2.protocol && url1.host === url2.host && url1.port === url2.port;
}
function isIframeOnAnotherDomain(iframe) {
    /**
	 * iframe with contents defined inline. Runs on the current origin.
	 * `<iframe srcdoc="<!doctype html><body>Hello</body>" />`
	 */ if (iframe.srcdoc) return false;
    /**
	 * iframe with contents defined inline. Runs on the current origin.
	 * `<iframe src={`data:text/html;charset=utf-8,${encodeURI('<!doctype html><body>Hello</body>')}`} />`
	 */ if (iframe.src.startsWith('data:')) return false;
    return !hasSameOrigin(window.location.href, iframe.src);
}
var registry = new Map();
function applyFix(watchForEndOfInteraction) {
    var iframes = Array.from(document.querySelectorAll('iframe')).filter(isIframeOnAnotherDomain);
    var cleanups = iframes.map(function(iframe) {
        var entry = registry.get(iframe);
        if (!entry) {
            entry = {
                reset: setStyle(iframe, {
                    property: 'pointer-events',
                    rule: 'none',
                    priority: 'important'
                }),
                count: 1
            };
            registry.set(iframe, entry);
        } else // pointer-events:none already applied to the iframe
        // increment how many things requested the fix
        entry.count++;
        return function cleanup() {
            entry.count--;
            if (entry.count < 1) {
                entry.reset();
                registry.delete(iframe);
            }
        };
    });
    function stop() {
        cleanupWatcher();
        (0, _combine.combine).apply(void 0, (0, _toConsumableArray._)(cleanups))();
    }
    var cleanupWatcher = watchForEndOfInteraction({
        stop: stop
    });
}
function makeFixForAdapter(param) {
    var watchForInteractionStart = param.watchForInteractionStart, watchForInteractionEnd = param.watchForInteractionEnd;
    var registrationCount = 0;
    var stopWatchingInteractionStart = null;
    function start() {
        applyFix(watchForInteractionEnd);
    }
    function registerUsage() {
        if (registrationCount === 0) stopWatchingInteractionStart = watchForInteractionStart({
            start: start
        });
        registrationCount++;
        return function unregisterUsage() {
            registrationCount--;
            if (registrationCount !== 0) return;
            stopWatchingInteractionStart === null || stopWatchingInteractionStart === void 0 ? void 0 : stopWatchingInteractionStart();
            stopWatchingInteractionStart = null;
        };
    }
    return {
        registerUsage: registerUsage
    };
}

},{"@swc/helpers/_/_to_consumable_array":"1eSZf","@atlaskit/pragmatic-drag-and-drop/combine":"ajFdY","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"b22jl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "disableDraggingToCrossOriginIFramesForExternal", function() {
    return disableDraggingToCrossOriginIFramesForExternal;
});
var _adapter = require("@atlaskit/pragmatic-drag-and-drop/external/adapter");
var _makeFixForAdapter = require("./make-fix-for-adapter");
function watchForInteractionStart(param) {
    var start = param.start;
    return (0, _adapter.monitorForExternal)({
        onDragStart: function onDragStart() {
            start();
        }
    });
}
function watchForInteractionEnd(param) {
    var stop = param.stop;
    return (0, _adapter.monitorForExternal)({
        onDrop: function onDrop() {
            stop();
        }
    });
}
var api = (0, _makeFixForAdapter.makeFixForAdapter)({
    watchForInteractionStart: watchForInteractionStart,
    watchForInteractionEnd: watchForInteractionEnd
});
function disableDraggingToCrossOriginIFramesForExternal() {
    return api.registerUsage();
}

},{"@atlaskit/pragmatic-drag-and-drop/external/adapter":"fdJzN","./make-fix-for-adapter":"iIXf2","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fdJzN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "monitorForExternal", function() {
    return 0, _externalAdapter.monitorForExternal;
});
parcelHelpers.export(exports, "dropTargetForExternal", function() {
    return 0, _externalAdapter.dropTargetForExternal;
});
var _externalAdapter = require("../../adapter/external-adapter");

},{"../../adapter/external-adapter":"7sTXo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7sTXo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isAnAvailableType", function() {
    return isAnAvailableType;
});
parcelHelpers.export(exports, "getAvailableTypes", function() {
    return getAvailableTypes;
});
parcelHelpers.export(exports, "getAvailableItems", function() {
    return getAvailableItems;
});
parcelHelpers.export(exports, "dropTargetForExternal", function() {
    return dropTargetForExternal;
});
parcelHelpers.export(exports, "monitorForExternal", function() {
    return monitorForExternal;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _bindEventListener = require("bind-event-listener");
var _makeAdapter = require("../make-adapter/make-adapter");
var _android = require("../util/android");
var _isEnteringWindow = require("../util/changing-window/is-entering-window");
var _detectBrokenDrag = require("../util/detect-broken-drag");
var _textMediaType = require("../util/media-types/text-media-type");
var _elementAdapterNativeDataKey = require("./element-adapter-native-data-key");
function isAnAvailableType(param) {
    var type = param.type, value = param.value;
    // We don't want to expose our private elementAdapter key / value
    if (type === (0, _elementAdapterNativeDataKey.elementAdapterNativeDataKey)) return false;
    // Not exposing "text/plain" if it contains the android fallback text
    // We _could_ add an `isAndroid()` check, but it's probably safest
    // to trim this data out, regardless of what OS we see it on.
    if (type === (0, _textMediaType.textMediaType) && value === (0, _android.androidFallbackText)) return false;
    return true;
}
function getAvailableTypes(transfer) {
    return Array.from(transfer.types).filter(function(type) {
        return isAnAvailableType({
            type: type,
            value: transfer.getData(type)
        });
    });
}
function getAvailableItems(dataTransfer) {
    // item.kind is 'string' | 'file'
    // For 'string' item.type is the mimeType (eg 'text/plain')
    // For 'file' item.type is the file type (eg 'image/jpg')
    return Array.from(dataTransfer.items).filter(function(item) {
        return item.kind === 'file' || isAnAvailableType({
            type: item.type,
            value: dataTransfer.getData(item.type)
        });
    });
}
var didDragStartLocally = false;
var adapter = (0, _makeAdapter.makeAdapter)({
    typeKey: 'external',
    // for external drags, we are generally making a copy of something that is being dragged
    defaultDropEffect: 'copy',
    mount: function mount(api) {
        // Binding to the `window` so that the element adapter
        // has a chance to get in first on the`document`.
        // We are giving preference to the element adapter.
        return (0, _bindEventListener.bind)(window, {
            type: 'dragenter',
            listener: function listener(event) {
                // drag operation was started within the document, it won't be an "external" drag
                if (didDragStartLocally) return;
                // Note: not checking if event was cancelled (`event.defaultPrevented`) as
                // cancelling a "dragenter" accepts the drag operation (not prevent it)
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                if (!api.canStart(event)) return;
                if (!(0, _isEnteringWindow.isEnteringWindow)({
                    dragEnter: event
                })) return;
                // Note: not checking types for `elementAdapterNativeDataKey` as we expect to see that
                // key when pdnd started the drag in another document
                var types = getAvailableTypes(event.dataTransfer);
                if (!types.length) return;
                var locked = {
                    types: types,
                    items: [],
                    getStringData: function() {
                        return null;
                    }
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'external',
                        startedFrom: 'external',
                        payload: locked,
                        getDropPayload: function getDropPayload(event) {
                            // this would be a platform error
                            // trying to handle it gracefully rather than throwing (for now)
                            if (!event.dataTransfer) return locked;
                            var items = getAvailableItems(event.dataTransfer);
                            // need to use `.bind` as `getData` is required
                            // to be run with `event.dataTransfer` as the "this" context
                            var nativeGetData = event.dataTransfer.getData.bind(event.dataTransfer);
                            return {
                                types: types,
                                items: items,
                                // return `null` if there is no result, otherwise string
                                getStringData: function getStringData(mediaType) {
                                    // not dragging the requested type
                                    // return `null` (no result)
                                    if (!types.includes(mediaType)) return null;
                                    // nativeGetData will return `""` when there is no value,
                                    // but at this point we know we will only get explicitly set
                                    // values back as we have checked the `types`.
                                    // `""` can be an explicitly set value.
                                    var value = nativeGetData(mediaType);
                                    // not exposing data for unavailable types
                                    if (!isAnAvailableType({
                                        type: mediaType,
                                        value: value
                                    })) return null;
                                    return value;
                                }
                            };
                        }
                    }
                });
            }
        });
    }
});
function dropTargetForExternal(args) {
    // not removing unused events, just leaning on the type system
    return adapter.dropTarget(args);
}
function monitorForExternal(args) {
    // not removing unused events, just leaning on the type system
    return adapter.monitor(args);
}
(function startup() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    // A shared single usage registration as we want to capture
    // all external drag operations, even if there are no drop targets
    // on the page yet
    adapter.registerUsage();
    // independent of pdnd, we need to keep track of
    // all drag operations so that we can know if a drag operation
    // has started locally
    var idle = {
        type: 'idle'
    };
    var state = idle;
    function clear() {
        if (state.type !== 'dragging') return;
        didDragStartLocally = false;
        state.cleanup();
        state = idle;
    }
    function bindEndEvents() {
        return (0, _bindEventListener.bindAll)(window, [
            {
                type: 'dragend',
                listener: clear
            }
        ].concat((0, _toConsumableArray._)((0, _detectBrokenDrag.getBindingsForBrokenDrags)({
            onDragEnd: clear
        }))), // we want to make sure we get all the events,
        // and this helps avoid not seeing events when folks stop
        // them later on the event path
        {
            capture: true
        });
    }
    // we always keep this event listener active
    (0, _bindEventListener.bind)(window, {
        type: 'dragstart',
        listener: function listener() {
            // something bad has happened if this is true!
            if (state.type !== 'idle') return;
            // set our global flag
            didDragStartLocally = true;
            state = {
                type: 'dragging',
                cleanup: bindEndEvents()
            };
        },
        // binding in the capture phase so these listeners are called
        // before our listeners in the adapters `mount` function
        options: {
            capture: true
        }
    });
})();

},{"@swc/helpers/_/_to_consumable_array":"1eSZf","bind-event-listener":"bjeUU","../make-adapter/make-adapter":"ibq8J","../util/android":"dls44","../util/changing-window/is-entering-window":"4X4TU","../util/detect-broken-drag":"bwqjB","../util/media-types/text-media-type":"7cAH9","./element-adapter-native-data-key":"dJH0T","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4X4TU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isEnteringWindow", function() {
    return isEnteringWindow;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
var _isFirefox = require("../is-firefox");
var _isSafari = require("../is-safari");
var _countEventsForSafari = require("./count-events-for-safari");
var _isFromAnotherWindow = require("./is-from-another-window");
function isEnteringWindow(param) {
    var dragEnter = param.dragEnter;
    var type = dragEnter.type, relatedTarget = dragEnter.relatedTarget;
    if (type !== 'dragenter') return false;
    if ((0, _isSafari.isSafari)()) return (0, _countEventsForSafari.isEnteringWindowInSafari)({
        dragEnter: dragEnter
    });
    // standard check
    if (relatedTarget == null) return true;
    /**
	 * 🦊 Exception: `iframe` in Firefox (`125.0`)
	 *
	 * Case 1: parent `window` → child `iframe`
	 * `relatedTarget` is the `iframe` element in the parent `window`
	 * (foreign element)
	 *
	 * Case 2: child `iframe` → parent `window`
	 * `relatedTarget` is an element inside the child `iframe`
	 * (foreign element)
	 */ if ((0, _isFirefox.isFirefox)()) return (0, _isFromAnotherWindow.isFromAnotherWindow)(relatedTarget);
    /**
	 * 🌏 Exception: `iframe` in Chrome (`124.0`)
	 *
	 * Case 1: parent `window` → child `iframe`
	 * `relatedTarget` is `null` *(standard check)*
	 *
	 * Case 2: child `iframe` → parent `window`
	 * `relatedTarget` is the `iframe` element in the parent `window`
	 */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return (0, _instanceof._)(relatedTarget, HTMLIFrameElement);
}

},{"@swc/helpers/_/_instanceof":"h9UKc","../is-firefox":"e1jES","../is-safari":"dBlxP","./count-events-for-safari":"l6xRq","./is-from-another-window":"7KjZz","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8Hakd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "disableDraggingToCrossOriginIFramesForTextSelection", function() {
    return disableDraggingToCrossOriginIFramesForTextSelection;
});
var _bindEventListener = require("bind-event-listener");
var _combine = require("@atlaskit/pragmatic-drag-and-drop/combine");
var _adapter = require("@atlaskit/pragmatic-drag-and-drop/text-selection/adapter");
var _makeFixForAdapter = require("./make-fix-for-adapter");
function watchForInteractionEnd(param) {
    var stop = param.stop;
    var isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    var frameId = null;
    var unbindEvents = (0, _bindEventListener.bindAll)(window, [
        {
            // User is starting another interaction
            type: 'pointerdown',
            listener: stop
        },
        {
            // User did not start a drag.
            // "pointerdown" won't be fired if a drag started
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            type: 'dragstart',
            listener: function listener() {
                /**
					 * The pdnd `onDragStart()` fires in the frame after "dragstart"
					 * So we are delaying our isDragging check to give a chance
					 * for `onDragStart()` to set the value correctly.
					 *
					 * Note: could not use "pointercancel" as it is not
					 * published in Safari → https://bugs.webkit.org/show_bug.cgi?id=222632
					 */ frameId = requestAnimationFrame(function() {
                    frameId = null;
                    stopIfNotDragging();
                });
            },
            // need to schedule our frame after the text-selection
            // adapter queues it's `onDragStart` frame.
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // being super clear these should only run once
        once: true
    });
    var unbindMonitor = (0, _adapter.monitorForTextSelection)({
        onDragStart: function onDragStart() {
            isDragging = true;
        },
        onDrop: function onDrop() {
            isDragging = false;
            stop();
        }
    });
    return (0, _combine.combine)(unbindEvents, unbindMonitor, function abortFrame() {
        if (frameId != null) cancelAnimationFrame(frameId);
    });
}
function watchForInteractionStart(param) {
    var start = param.start;
    return (0, _bindEventListener.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener: function listener() {
            // A text selection drag will only start when there is
            // an active text selection.
            var selection = window.getSelection();
            // No selection object found
            if (!selection) return;
            // `isCollapsed` is "true" if there is currently no selected text
            if (selection.isCollapsed) return;
            start();
        }
    });
}
var api = (0, _makeFixForAdapter.makeFixForAdapter)({
    watchForInteractionStart: watchForInteractionStart,
    watchForInteractionEnd: watchForInteractionEnd
});
function disableDraggingToCrossOriginIFramesForTextSelection() {
    return api.registerUsage();
}

},{"bind-event-listener":"bjeUU","@atlaskit/pragmatic-drag-and-drop/combine":"ajFdY","@atlaskit/pragmatic-drag-and-drop/text-selection/adapter":"hdslE","./make-fix-for-adapter":"iIXf2","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hdslE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "monitorForTextSelection", function() {
    return 0, _textSelectionAdapter.monitorForTextSelection;
});
parcelHelpers.export(exports, "dropTargetForTextSelection", function() {
    return 0, _textSelectionAdapter.dropTargetForTextSelection;
});
var _textSelectionAdapter = require("../../adapter/text-selection-adapter");

},{"../../adapter/text-selection-adapter":"2JWbW","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2JWbW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dropTargetForTextSelection", function() {
    return dropTargetForTextSelection;
});
parcelHelpers.export(exports, "monitorForTextSelection", function() {
    return monitorForTextSelection;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
var _bindEventListener = require("bind-event-listener");
var _makeHoneyPotFix = require("../honey-pot-fix/make-honey-pot-fix");
var _makeAdapter = require("../make-adapter/make-adapter");
var _combine = require("../public-utils/combine");
var _isSafari = require("../util/is-safari");
var _htmlMediaType = require("../util/media-types/html-media-type");
var _textMediaType = require("../util/media-types/text-media-type");
var _elementAdapterNativeDataKey = require("./element-adapter-native-data-key");
function findTextNode(event) {
    var _event_dataTransfer;
    // Standard: the `event.target` should be the closest `Text` node.
    if ((0, _instanceof._)(event.target, Text)) return event.target;
    // Structuring things this way so that if Safari fixes their bug
    // then the standard check will start working
    if (!(0, _isSafari.isSafari)()) return null;
    /**
	 * According to the spec, `event.target` should be the `Text` node that
	 * the drag started from when dragging a text selection.
	 *
	 * → https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
	 *
	 * However, in Safari the closest `HTMLElement` is returned.
	 * So we need to figure out if text is dragging ourselves.
	 *
	 * → https://bugs.webkit.org/show_bug.cgi?id=268959
	 */ if (!(0, _instanceof._)(event.target, HTMLElement)) return null;
    // Unlikely that this particular drag is a text selection drag
    if (event.target.draggable) return null;
    // if the drag contains no text data, then not dragging selected text
    // return `null` if there is no dataTransfer, or if `getData()` returns ""
    if (!((_event_dataTransfer = event.dataTransfer) === null || _event_dataTransfer === void 0 ? void 0 : _event_dataTransfer.getData((0, _textMediaType.textMediaType)))) return null;
    /**
	 * Grab the first Text node and use that.
	 * Only doing a single level search as that is all we need for this bug.
	 */ var text = Array.from(event.target.childNodes).find(function(node) {
        return node.nodeType === Node.TEXT_NODE;
    });
    return text !== null && text !== void 0 ? text : null;
}
var honeyPotFix = (0, _makeHoneyPotFix.makeHoneyPotFix)();
var adapter = (0, _makeAdapter.makeAdapter)({
    typeKey: 'text-selection',
    // for text selection, we will usually be making a copy of the text
    defaultDropEffect: 'copy',
    mount: function mount(api) {
        // Binding to the `window` so that the element adapter has a
        // chance to get in first on the `document`.
        // We are giving preference to the element adapter.
        return (0, _combine.combine)(honeyPotFix.bindEvents(), (0, _bindEventListener.bind)(window, {
            type: 'dragstart',
            listener: function listener(event) {
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                // Drag is being handled by the element adapter
                if (event.dataTransfer.types.includes((0, _elementAdapterNativeDataKey.elementAdapterNativeDataKey))) return;
                // Something else is handling this drag
                if (!api.canStart(event)) return;
                // no text being dragged
                if (!event.dataTransfer.types.includes((0, _textMediaType.textMediaType))) return;
                var target = findTextNode(event);
                // could not find `Text` node that is being dragged from
                if (!target) return;
                var payload = {
                    // The `Text` node that is the `target` is the `Text` node
                    // that the user started the drag from.
                    // The full text being dragged can be looked up from the `dataTransfer`.
                    target: target,
                    plain: event.dataTransfer.getData((0, _textMediaType.textMediaType)),
                    HTML: event.dataTransfer.getData((0, _htmlMediaType.HTMLMediaType))
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'text-selection',
                        startedFrom: 'internal',
                        payload: payload
                    }
                });
            }
        }));
    },
    onPostDispatch: honeyPotFix.getOnPostDispatch()
});
function dropTargetForTextSelection(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return adapter.dropTarget(args);
}
// A shared single usage registration as any text can be dragged at any time
(function register() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    adapter.registerUsage();
})();
function monitorForTextSelection(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return adapter.monitor(args);
}

},{"@swc/helpers/_/_instanceof":"h9UKc","bind-event-listener":"bjeUU","../honey-pot-fix/make-honey-pot-fix":"cMBuo","../make-adapter/make-adapter":"ibq8J","../public-utils/combine":"hR4cH","../util/is-safari":"dBlxP","../util/media-types/html-media-type":"65z2b","../util/media-types/text-media-type":"7cAH9","./element-adapter-native-data-key":"dJH0T","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"65z2b":[function(require,module,exports,__globalThis) {
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HTMLMediaType", function() {
    return HTMLMediaType;
});
var HTMLMediaType = 'text/html';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"c0zul":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "width", function() {
    return width;
});
var width = {
    values: [
        'small',
        'medium',
        'large',
        'x-large'
    ],
    widths: {
        small: 400,
        medium: 600,
        large: 800,
        'x-large': 968
    },
    defaultValue: 'medium'
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9MxCN":[function(require,module,exports,__globalThis) {
/* positioner.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _curves = require("@atlaskit/motion/curves");
var _durations = require("@atlaskit/motion/durations");
// Flex and min-content are set to constrain the height of the body and support multi-column scrolling experiences
var positionerStyles = null;
var stackStyles = {
    stackTransition: "_k8m01e03 _1bumglyw _sedtglyw",
    stackTransform: "_t9ec1b95",
    stackIdle: "_t9ecglyw"
};
// Hardcoded pixels are based off a 60px base gutter
var scrollStyles = {
    viewport: "_4t3i1wug _kqswh2mm _1f6n1wqb _1eot1wug _eoawglyw",
    body: "_we1i18uh _e8uozwhf _y1k5stnw _5ee41nf8 _1urridpf _1juqidpf _yakv1wug _4lht1wug _eoawglyw",
    fullScreen: ""
};
function getScrollBehavior(param) {
    var isFullScreen = param.isFullScreen, shouldScrollInViewport = param.shouldScrollInViewport;
    if (isFullScreen) return 'fullScreen';
    if (shouldScrollInViewport) return 'viewport';
    return 'body';
}
var Positioner = function(props) {
    var children = props.children, stackIndex = props.stackIndex, shouldScrollInViewport = props.shouldScrollInViewport, testId = props.testId, isFullScreen = props.isFullScreen;
    var scrollBehavior = getScrollBehavior({
        isFullScreen: isFullScreen,
        shouldScrollInViewport: shouldScrollInViewport
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        style: {
            '--modal-dialog-translate-y': "calc(".concat(stackIndex, "px * ", "var(--ds-space-100, 8px)", ")"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            transitionDuration: "".concat((0, _durations.durations).medium, "ms"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            transitionTimingFunction: (0, _curves.easeInOut)
        },
        "data-testid": testId && "".concat(testId, "--positioner"),
        className: (0, _runtime.ax)([
            "_1e0c1txw _1bsb1osq _p12f1osq _4t3i1osq _kqsw1n9t _1pby16oo _2lx21bp4 _152tidpf _1e02idpf",
            stackStyles.stackTransition,
            stackIndex > 0 ? stackStyles.stackTransform : stackStyles.stackIdle,
            scrollStyles[scrollBehavior]
        ]),
        children: children
    });
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = Positioner;

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/motion/curves":"3NhfX","@atlaskit/motion/durations":"fobmK","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3NhfX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "easeIn", function() {
    return 0, _curves.easeIn;
});
parcelHelpers.export(exports, "easeIn40Out", function() {
    return 0, _curves.easeIn40Out;
});
parcelHelpers.export(exports, "easeIn60Out", function() {
    return 0, _curves.easeIn60Out;
});
parcelHelpers.export(exports, "easeIn80Out", function() {
    return 0, _curves.easeIn80Out;
});
parcelHelpers.export(exports, "easeInOut", function() {
    return 0, _curves.easeInOut;
});
parcelHelpers.export(exports, "easeOut", function() {
    return 0, _curves.easeOut;
});
parcelHelpers.export(exports, "linear", function() {
    return 0, _curves.linear;
});
var _curves = require("../utils/curves");

},{"../utils/curves":"1YfC6","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fobmK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "durationStep", function() {
    return 0, _durations.durationStep;
});
parcelHelpers.export(exports, "durations", function() {
    return 0, _durations.durations;
});
parcelHelpers.export(exports, "exitingDurations", function() {
    return 0, _durations.exitingDurations;
});
var _durations = require("../utils/durations");

},{"../utils/durations":"1dp5g","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7jAuN":[function(require,module,exports,__globalThis) {
/* modal-header.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _runtime = require("@compiled/react/runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _compiled = require("@atlaskit/primitives/compiled");
var _closeButton = require("./close-button");
var _hooks = require("./hooks");
var styles = {
    header: "_18zr1ejb _1e0c1txw _kqswh2mm _4cvr1h6o _1bah1yb4 _6rth1i6y _85i5pxbi _1q511ejb",
    flex: "_2lx21sbv _1bsb1osq",
    titleContainer: "_1ul9idpf"
};
/**
 * __Modal header__
 *
 * A modal header contains the title of the modal and can contain other React elements such as a close button.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-header)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-header-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var ModalHeader = function(props) {
    var children = props.children, userDefinedTestId = props.testId, _props_hasCloseButton = props.hasCloseButton, hasCloseButton = _props_hasCloseButton === void 0 ? false : _props_hasCloseButton;
    var _useModal = (0, _hooks.useModal)(), hasProvidedOnClose = _useModal.hasProvidedOnClose, onClose = _useModal.onClose, modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--header");
    // Only show if an onClose was provided for the modal dialog
    var shouldShowCloseButton = hasCloseButton && hasProvidedOnClose && onClose;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        "data-testid": testId,
        className: (0, _runtime.ax)([
            styles.header
        ]),
        children: shouldShowCloseButton ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _compiled.Flex), {
            gap: "space.200",
            justifyContent: "space-between",
            xcss: styles.flex,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _compiled.Flex), {
                    justifyContent: "end",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeButton.CloseButton), {
                        onClick: onClose,
                        testId: modalTestId
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _compiled.Flex), {
                    justifyContent: "start",
                    alignItems: "center",
                    xcss: styles.titleContainer,
                    children: children
                })
            ]
        }) : children
    });
};
exports.default = ModalHeader;

},{"react/jsx-runtime":"bGvcw","@compiled/react/runtime":"d27Vo","react":"ltHCL","@atlaskit/primitives/compiled":"jhQE8","./close-button":"4g408","./hooks":"gBvjp","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4g408":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CloseButton", function() {
    return CloseButton;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _new = require("@atlaskit/button/new");
var _cross = require("@atlaskit/icon/core/cross");
var _crossDefault = parcelHelpers.interopDefault(_cross);
var CloseButton = function(param) {
    var label = param.label, onBlur = param.onBlur, onClick = param.onClick, testId = param.testId;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _new.IconButton), {
        testId: testId && "".concat(testId, "--close-button"),
        appearance: "subtle",
        icon: (0, _crossDefault.default),
        label: label || 'Close Modal',
        onBlur: onBlur,
        onClick: onClick
    });
};

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","@atlaskit/button/new":"2LnSZ","@atlaskit/icon/core/cross":"cnbEZ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gBvjp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useModal", function() {
    return useModal;
});
var _react = require("react");
var _context = require("./internal/context");
var useModal = function() {
    var modalContext = (0, _react.useContext)((0, _context.ModalContext));
    if (modalContext == null) throw Error("@atlaskit/modal-dialog: Modal context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return modalContext;
};

},{"react":"ltHCL","./internal/context":"hnWJj","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hGuwm":[function(require,module,exports,__globalThis) {
/* modal-title.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _statusError = require("@atlaskit/icon/core/status-error");
var _statusErrorDefault = parcelHelpers.interopDefault(_statusError);
var _statusWarning = require("@atlaskit/icon/core/status-warning");
var _statusWarningDefault = parcelHelpers.interopDefault(_statusWarning);
var _hooks = require("./hooks");
var iconColor = {
    danger: "var(--ds-icon-danger, #C9372C)",
    warning: "var(--ds-icon-warning, #E06C00)"
};
var iconStyles = null;
var titleStyles = null;
var textStyles = null;
var truncatedTextStyles = null;
var TitleIcon = function(param) {
    var appearance = param.appearance;
    var Icon = appearance === 'danger' ? (0, _statusErrorDefault.default) : (0, _statusWarningDefault.default);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: (0, _runtime.ax)([
            "_16jlidpf _1o9zidpf _i0dl1wug _syaz1kw7 _1wyb1kw7 _zg8l1kw7 _k48p1kw7 _1dyz1kw7 _vwz41kw7"
        ]),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Icon, {
            label: appearance,
            color: iconColor[appearance],
            spacing: "spacious"
        })
    });
};
/**
 * __Modal title__
 *
 * A modal title is used to display a title within a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var ModalTitle = function(props) {
    var appearance = props.appearance, children = props.children, _props_isMultiline = props.isMultiline, isMultiline = _props_isMultiline === void 0 ? true : _props_isMultiline, userDefinedTestId = props.testId;
    var _useModal = (0, _hooks.useModal)(), titleId = _useModal.titleId, modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--title");
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h1", {
        "data-testid": testId,
        className: (0, _runtime.ax)([
            "_zulpu2gc _11c81af2 _1e0c1txw _1ul9idpf _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t"
        ]),
        children: [
            appearance && /*#__PURE__*/ (0, _jsxRuntime.jsx)(TitleIcon, {
                appearance: appearance
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                id: titleId,
                "data-testid": testId && "".concat(testId, "-text"),
                className: (0, _runtime.ax)([
                    "_16jlkb7n _1o9zkb7n _i0dl1wug _11c81af2 _1ul9idpf _slp31hna",
                    !isMultiline && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
                ]),
                children: children
            })
        ]
    });
};
exports.default = ModalTitle;

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/icon/core/status-error":"gJMKC","@atlaskit/icon/core/status-warning":"h2k3M","./hooks":"gBvjp","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ccsmv":[function(require,module,exports,__globalThis) {
/* modal-body.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _runtime = require("@compiled/react/runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactScrolllock = require("react-scrolllock");
var _hooks = require("./hooks");
var _scrollContainer = require("./internal/components/scroll-container");
var _scrollContainerDefault = parcelHelpers.interopDefault(_scrollContainer);
var _useScroll = require("./internal/hooks/use-scroll");
var _useScrollDefault = parcelHelpers.interopDefault(_useScroll);
var styles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _11c8fhey",
    paddingBlock: "_1rjcv77o",
    paddingInline: "_18zr1ejb"
};
/**
 * __Modal body__
 *
 * A modal body is used to display the main content of a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-body-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var ModalBody = function(props) {
    var children = props.children, userDefinedTestId = props.testId, _props_hasInlinePadding = props.hasInlinePadding, hasInlinePadding = _props_hasInlinePadding === void 0 ? true : _props_hasInlinePadding;
    var _useModal = (0, _hooks.useModal)(), modalTestId = _useModal.testId;
    var shouldScrollInViewport = (0, _useScrollDefault.default)();
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--body");
    return shouldScrollInViewport ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        "data-testid": testId,
        className: (0, _runtime.ax)([
            styles.root,
            hasInlinePadding && styles.paddingInline
        ]),
        children: children
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactScrolllock.TouchScrollable), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _scrollContainerDefault.default), {
            testId: userDefinedTestId || modalTestId,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                "data-testid": testId,
                className: (0, _runtime.ax)([
                    styles.root,
                    /**
       * Adding block padding for scroll keylines, which are only shown when the scrolling
       * is on the container.
       */ styles.paddingBlock,
                    hasInlinePadding && styles.paddingInline
                ]),
                children: children
            })
        })
    });
};
exports.default = ModalBody;

},{"react/jsx-runtime":"bGvcw","@compiled/react/runtime":"d27Vo","react":"ltHCL","react-scrolllock":"iBy4G","./hooks":"gBvjp","./internal/components/scroll-container":"eurX1","./internal/hooks/use-scroll":"iyMSd","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eurX1":[function(require,module,exports,__globalThis) {
/* scroll-container.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _bindEventListener = require("bind-event-listener");
var _rafSchd = require("raf-schd");
var _rafSchdDefault = parcelHelpers.interopDefault(_rafSchd);
var _css = require("@atlaskit/css");
var _mergeRefs = require("@atlaskit/ds-lib/merge-refs");
var _mergeRefsDefault = parcelHelpers.interopDefault(_mergeRefs);
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var _useLazyCallback = require("@atlaskit/ds-lib/use-lazy-callback");
var _useLazyCallbackDefault = parcelHelpers.interopDefault(_useLazyCallback);
var _compiled = require("@atlaskit/primitives/compiled");
var keylineColor = "var(--ds-border, #0B120E24)";
var styles = {
    base: "_kkes1kw7 _1e0c1kw7 _2lx21kw7 _16jlkb7n _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _1reo15vq _18m91wug _1jykn7od _wzg61wug",
    topKeyline: "_mqm21uh4",
    bottomKeyline: "_179r1uh4"
};
var keylineHeight = 2;
/**
 * A container that shows top and bottom keylines when the
 * content overflows into the scrollable element.
 */ var ScrollContainer = /*#__PURE__*/ (0, _react.forwardRef)(function(param, ref) {
    var testId = param.testId, children = param.children;
    var scrollableRef = (0, _react.useRef)(null);
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), showTopKeyline = _useState[0], setTopKeyline = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(false), 2), showBottomKeyline = _useState1[0], setBottomKeyline = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(false), 2), showContentFocus = _useState2[0], setContentFocus = _useState2[1];
    // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, _react.useEffect)(function() {
        var schedule = (0, _rafSchdDefault.default)(function() {
            var target = scrollableRef.current;
            target && setContentFocus(target.scrollHeight > target.clientHeight);
        });
        schedule();
    }, [
        scrollableRef
    ]);
    var setLazyKeylines = (0, _useLazyCallbackDefault.default)((0, _rafSchdDefault.default)(function() {
        var target = scrollableRef.current;
        if (target) {
            var scrollableDistance = target.scrollHeight - target.clientHeight;
            if (target.previousElementSibling) setTopKeyline(target.scrollTop > keylineHeight);
            if (target.nextElementSibling) setBottomKeyline(target.scrollTop <= scrollableDistance - keylineHeight);
        }
    }));
    // On load (and scroll/resize events), we set "keylines"
    // these border the content to indicate scrollability when content underflows the header or footer
    (0, _react.useEffect)(function() {
        var target = scrollableRef.current;
        setLazyKeylines();
        var unbindWindowEvent = (0, _bindEventListener.bind)(window, {
            type: 'resize',
            listener: setLazyKeylines
        });
        var unbindTargetEvent = target ? (0, _bindEventListener.bind)(target, {
            type: 'scroll',
            listener: setLazyKeylines
        }) : (0, _noopDefault.default);
        return function() {
            unbindWindowEvent();
            unbindTargetEvent();
        };
    }, [
        setLazyKeylines
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _compiled.Focusable), {
        as: "div",
        isInset: true,
        // tabindex is allowed here so that keyboard users can scroll content
        tabIndex: showContentFocus ? 0 : undefined,
        role: showContentFocus ? 'region' : undefined,
        "aria-label": showContentFocus ? 'Scrollable content' : undefined,
        testId: testId && "".concat(testId, "--scrollable"),
        ref: (0, _mergeRefsDefault.default)([
            ref,
            scrollableRef
        ]),
        xcss: (0, _css.cx)(styles.base, showTopKeyline && styles.topKeyline, showBottomKeyline && styles.bottomKeyline),
        children: children
    });
});
ScrollContainer.displayName = 'ScrollContainer';
exports.default = ScrollContainer;

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","react/jsx-runtime":"bGvcw","react":"ltHCL","bind-event-listener":"bjeUU","raf-schd":"oiTmD","@atlaskit/css":"fiaHp","@atlaskit/ds-lib/merge-refs":"bhv2L","@atlaskit/ds-lib/noop":"2f3bg","@atlaskit/ds-lib/use-lazy-callback":"lB6Xv","@atlaskit/primitives/compiled":"jhQE8","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iyMSd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return useScroll;
});
var _react = require("react");
var _scrollContext = require("../scroll-context");
function useScroll() {
    var shouldScrollInViewport = (0, _react.useContext)((0, _scrollContext.ScrollContext));
    if (shouldScrollInViewport == null) throw Error("@atlaskit/modal-dialog: Scroll context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return shouldScrollInViewport;
}

},{"react":"ltHCL","../scroll-context":"g0pv7","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ap3Lr":[function(require,module,exports,__globalThis) {
/* modal-footer.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _hooks = require("./hooks");
var footerStyles = null;
/**
 * __Modal footer__
 *
 * A modal footer often contains a primary action and the ability to cancel and close the dialog, though can contain any React element.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-footer)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-footer-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var ModalFooter = function(props) {
    var children = props.children, userDefinedTestId = props.testId;
    var _useModal = (0, _hooks.useModal)(), modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--footer");
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        "data-testid": testId,
        className: (0, _runtime.ax)([
            "_zulpu2gc _18zr1ejb _1e0c1txw _kqswh2mm _4cvr1h6o _1bahesu3 _1pfh1i6y _85i51ejb _1q51pxbi"
        ]),
        children: children
    });
};
exports.default = ModalFooter;

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","./hooks":"gBvjp","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"66JzH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return 0, _sectionMessageDefault.default;
});
parcelHelpers.export(exports, "SectionMessageAction", function() {
    return 0, _sectionMessageActionDefault.default;
});
var _sectionMessage = require("./section-message");
var _sectionMessageDefault = parcelHelpers.interopDefault(_sectionMessage);
var _sectionMessageAction = require("./section-message-action");
var _sectionMessageActionDefault = parcelHelpers.interopDefault(_sectionMessageAction);

},{"./section-message":"cSy4z","./section-message-action":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cSy4z":[function(require,module,exports,__globalThis) {
/* section-message.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _new = require("@atlaskit/button/new");
var _heading = require("@atlaskit/heading");
var _headingDefault = parcelHelpers.interopDefault(_heading);
var _cross = require("@atlaskit/icon/core/cross");
var _crossDefault = parcelHelpers.interopDefault(_cross);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _compiled = require("@atlaskit/primitives/compiled");
var _appearanceIcon = require("./internal/appearance-icon");
var sectionMessageStyles = {
    container: "_2rko12b0 _1rjcpxbi _18zrpxbi _1nmz1hna",
    containerT26Shape: "_2rko1mok",
    iconContainer: "_1mou1i6y _1e0c1txw",
    contentContainer: "_16jlkb7n",
    content: "_11c8fhey _syazi7uo",
    actionsContainer: "_11c8fhey",
    dismissButtonContainer: "_1pfh1i6y"
};
var appearanceStyles = {
    information: "_bfhk19ip",
    warning: "_bfhk1917",
    error: "_bfhk1gly",
    success: "_bfhk1y9u",
    discovery: "_bfhk6vm6"
};
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ var SectionMessage = /*#__PURE__*/ (0, _react.forwardRef)(function SectionMessage(param, ref) {
    var children = param.children, _param_appearance = param.appearance, appearance = _param_appearance === void 0 ? 'information' : _param_appearance, actions = param.actions, title = param.title, icon = param.icon, isDismissible = param.isDismissible, onDismiss = param.onDismiss, testId = param.testId;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), dismissed = _useState[0], setDismissed = _useState[1];
    var handleDismiss = (0, _react.useCallback)(function() {
        onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
        setDismissed(true);
    }, [
        onDismiss
    ]);
    var _getAppearanceIconStyles = (0, _appearanceIcon.getAppearanceIconStyles)(appearance, icon), primaryColor = _getAppearanceIconStyles.primaryIconColor, secondaryColor = _getAppearanceIconStyles.backgroundColor, Icon = _getAppearanceIconStyles.Icon;
    var actionElements = actions && actions.type === (0, _react.Fragment) ? actions.props.children : actions;
    var actionsArray = (0, _react.Children).toArray(actionElements);
    return isDismissible && dismissed ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("section", {
        "data-testid": testId,
        ref: ref,
        className: (0, _runtime.ax)([
            sectionMessageStyles.container,
            (0, _platformFeatureFlags.fg)('platform-dst-shape-theme-default') && sectionMessageStyles.containerT26Shape,
            appearanceStyles[appearance]
        ]),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _compiled.Inline), {
            space: "space.200",
            alignBlock: "stretch",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: (0, _runtime.ax)([
                        sectionMessageStyles.iconContainer
                    ]),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Icon, {
                        size: "medium",
                        primaryColor: primaryColor,
                        secondaryColor: secondaryColor,
                        // props for new icon
                        color: primaryColor,
                        spacing: "spacious"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _compiled.Stack), {
                    space: "space.100",
                    testId: testId && "".concat(testId, "--content"),
                    xcss: sectionMessageStyles.contentContainer,
                    children: [
                        !!title && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headingDefault.default), {
                            as: "h2",
                            size: "small",
                            children: title
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: (0, _runtime.ax)([
                                sectionMessageStyles.content
                            ]),
                            children: children
                        }),
                        actionsArray.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _compiled.Inline), {
                            shouldWrap: true,
                            testId: testId && "".concat(testId, "--actions"),
                            separator: "\xb7",
                            space: "space.100",
                            rowSpace: "space.0",
                            // Only use a list role if more than one action is present
                            role: actionsArray.length > 1 ? 'list' : undefined,
                            xcss: sectionMessageStyles.actionsContainer,
                            children: actionsArray.map(function(action, id) {
                                return(// Only use a listitem role if more than one action is present
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _compiled.Inline), {
                                    role: actionsArray.length > 1 ? 'listitem' : undefined,
                                    children: action
                                }, id));
                            })
                        })
                    ]
                }),
                isDismissible && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: (0, _runtime.ax)([
                        sectionMessageStyles.dismissButtonContainer
                    ]),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _new.IconButton), {
                        testId: testId && "".concat(testId, "--dismiss-button"),
                        label: "Dismiss",
                        icon: (0, _crossDefault.default),
                        appearance: "subtle",
                        onClick: handleDismiss,
                        spacing: "compact"
                    })
                })
            ]
        })
    });
});
SectionMessage.displayName = 'SectionMessage';
exports.default = SectionMessage;

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/button/new":"2LnSZ","@atlaskit/heading":"dsM8C","@atlaskit/icon/core/cross":"cnbEZ","@atlaskit/platform-feature-flags":"kO5t9","@atlaskit/primitives/compiled":"jhQE8","./internal/appearance-icon":"gYHI2","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gYHI2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAppearanceIconStyles", function() {
    return getAppearanceIconStyles;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _statusDiscovery = require("@atlaskit/icon/core/status-discovery");
var _statusDiscoveryDefault = parcelHelpers.interopDefault(_statusDiscovery);
var _statusError = require("@atlaskit/icon/core/status-error");
var _statusErrorDefault = parcelHelpers.interopDefault(_statusError);
var _statusInformation = require("@atlaskit/icon/core/status-information");
var _statusInformationDefault = parcelHelpers.interopDefault(_statusInformation);
var _statusSuccess = require("@atlaskit/icon/core/status-success");
var _statusSuccessDefault = parcelHelpers.interopDefault(_statusSuccess);
var _statusWarning = require("@atlaskit/icon/core/status-warning");
var _statusWarningDefault = parcelHelpers.interopDefault(_statusWarning);
var appearanceIconSchema = {
    information: {
        backgroundColor: "var(--ds-background-information, #E9F2FE)",
        Icon: (0, _statusInformationDefault.default),
        primaryIconColor: "var(--ds-icon-information, #357DE8)"
    },
    warning: {
        backgroundColor: "var(--ds-background-warning, #FFF5DB)",
        Icon: (0, _statusWarningDefault.default),
        primaryIconColor: "var(--ds-icon-warning, #E06C00)"
    },
    error: {
        backgroundColor: "var(--ds-background-danger, #FFECEB)",
        Icon: (0, _statusErrorDefault.default),
        primaryIconColor: "var(--ds-icon-danger, #C9372C)"
    },
    success: {
        backgroundColor: "var(--ds-background-success, #EFFFD6)",
        Icon: (0, _statusSuccessDefault.default),
        primaryIconColor: "var(--ds-icon-success, #6A9A23)"
    },
    discovery: {
        backgroundColor: "var(--ds-background-discovery, #F8EEFE)",
        Icon: (0, _statusDiscoveryDefault.default),
        primaryIconColor: "var(--ds-icon-discovery, #AF59E1)"
    }
};
function getAppearanceIconStyles(appearance, icon) {
    var appearanceIconStyles = appearanceIconSchema[appearance] || appearanceIconSchema.information;
    var AppearanceIcon = function(param) {
        var primaryColor = param.primaryColor;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(appearanceIconStyles.Icon, {
            color: primaryColor,
            spacing: "spacious",
            label: appearance
        });
    };
    var Icon = icon || AppearanceIcon;
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, appearanceIconStyles), {
        Icon: Icon
    });
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","@atlaskit/icon/core/status-discovery":"QsGAw","@atlaskit/icon/core/status-error":"gJMKC","@atlaskit/icon/core/status-information":"631pM","@atlaskit/icon/core/status-success":"4HNQp","@atlaskit/icon/core/status-warning":"h2k3M","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"QsGAw":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4b3613c7e18556761a1c0b5ad2c9a88f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("4ddc5dcc3fcce5b9"));
var _baseNew = _interopRequireDefault(require("56ed8fdba9b427d"));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusDiscovery".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for discovery statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ var StatusDiscoveryIcon = function(props) {
    return /*#__PURE__*/ _react.default.createElement(_baseNew.default, Object.assign({
        name: "StatusDiscoveryIcon",
        dangerouslySetGlyph: '<path fill="currentcolor" d="M10.5 15.06v-3.81a.75.75 0 0 1 .75-.75h3.81z"/><path fill="currentcolor" fill-rule="evenodd" d="M13 1a2 2 0 0 1 2 2v6h-4.75C9.56 9 9 9.56 9 10.25V15H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zM4 9h3V7.5H4zm0-5v1.5h7V4z" clip-rule="evenodd"/>'
    }, props));
};
StatusDiscoveryIcon.displayName = 'StatusDiscoveryIcon';
var _default = exports.default = StatusDiscoveryIcon;

},{"4ddc5dcc3fcce5b9":"ltHCL","56ed8fdba9b427d":"kuGeY"}],"7RKck":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "components", function() {
    return 0, _reactSelect.components;
});
parcelHelpers.export(exports, "createFilter", function() {
    return 0, _reactSelect.createFilter;
});
parcelHelpers.export(exports, "mergeStyles", function() {
    return 0, _reactSelect.mergeStyles;
});
parcelHelpers.export(exports, "useAsync", function() {
    return 0, _useAsync.useAsync;
});
parcelHelpers.export(exports, "useCreatable", function() {
    return 0, _useCreatable.useCreatable;
});
parcelHelpers.export(exports, "CheckboxOption", function() {
    return 0, _inputOptions.CheckboxOption;
});
parcelHelpers.export(exports, "RadioOption", function() {
    return 0, _inputOptions.RadioOption;
});
parcelHelpers.export(exports, "default", function() {
    return 0, _selectDefault.default;
});
parcelHelpers.export(exports, "SelectWithoutAnalytics", function() {
    return 0, _select.SelectWithoutAnalytics;
});
parcelHelpers.export(exports, "AsyncSelect", function() {
    return 0, _asyncSelectDefault.default;
});
parcelHelpers.export(exports, "CreatableSelect", function() {
    return 0, _creatableSelectDefault.default;
});
parcelHelpers.export(exports, "AsyncCreatableSelect", function() {
    return 0, _asyncCreatableSelectDefault.default;
});
parcelHelpers.export(exports, "isOptionsGrouped", function() {
    return 0, _groupedOptionsAnnouncement.isOptionsGrouped;
});
parcelHelpers.export(exports, "CheckboxSelect", function() {
    return 0, _checkboxSelectDefault.default;
});
parcelHelpers.export(exports, "CountrySelect", function() {
    return 0, _countrySelectDefault.default;
});
parcelHelpers.export(exports, "RadioSelect", function() {
    return 0, _radioSelectDefault.default;
});
parcelHelpers.export(exports, "PopupSelect", function() {
    return 0, _popupSelectDefault.default;
});
var _reactSelect = require("./entry-points/react-select");
var _useAsync = require("./entry-points/use-async");
var _useCreatable = require("./entry-points/use-creatable");
var _inputOptions = require("./components/input-options");
var _select = require("./entry-points/select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _asyncSelect = require("./entry-points/async-select");
var _asyncSelectDefault = parcelHelpers.interopDefault(_asyncSelect);
var _creatableSelect = require("./entry-points/creatable-select");
var _creatableSelectDefault = parcelHelpers.interopDefault(_creatableSelect);
var _asyncCreatableSelect = require("./entry-points/async-creatable-select");
var _asyncCreatableSelectDefault = parcelHelpers.interopDefault(_asyncCreatableSelect);
var _groupedOptionsAnnouncement = require("./utils/grouped-options-announcement");
var _checkboxSelect = require("./checkbox-select");
var _checkboxSelectDefault = parcelHelpers.interopDefault(_checkboxSelect);
var _countrySelect = require("./country-select");
var _countrySelectDefault = parcelHelpers.interopDefault(_countrySelect);
var _radioSelect = require("./radio-select");
var _radioSelectDefault = parcelHelpers.interopDefault(_radioSelect);
var _popupSelect = require("./popup-select");
var _popupSelectDefault = parcelHelpers.interopDefault(_popupSelect);
 /**
 * Types not exported on the public API, didn't find usages in sourcegraph
 *
 * CreatableSelectProps,
 */ 
},{"./entry-points/react-select":false,"./entry-points/use-async":false,"./entry-points/use-creatable":false,"./components/input-options":false,"./entry-points/select":"2NwGU","./entry-points/async-select":false,"./entry-points/creatable-select":false,"./entry-points/async-creatable-select":false,"./utils/grouped-options-announcement":false,"./checkbox-select":false,"./country-select":false,"./radio-select":false,"./popup-select":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2NwGU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return 0, _selectDefault.default;
});
parcelHelpers.export(exports, "SelectWithoutAnalytics", function() {
    return 0, _select.SelectWithoutAnalytics;
});
var _select = require("../select");
var _selectDefault = parcelHelpers.interopDefault(_select);

},{"../select":"gjnUm","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gjnUm":[function(require,module,exports,__globalThis) {
/* eslint-disable @repo/internal/react/require-jsdoc */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SelectWithoutAnalytics", function() {
    return SelectWithoutAnalytics;
});
var _analyticsNext = require("@atlaskit/analytics-next");
var _async = require("@atlaskit/react-select/async");
var _asyncDefault = parcelHelpers.interopDefault(_async);
var _createSelect = require("./create-select");
var _createSelectDefault = parcelHelpers.interopDefault(_createSelect);
var packageName = undefined;
var packageVersion = undefined;
var SelectWithoutAnalytics = (0, _createSelectDefault.default)((0, _asyncDefault.default));
var createAndFireEventOnAtlaskit = (0, _analyticsNext.createAndFireEvent)('atlaskit');
var Select = (0, _analyticsNext.withAnalyticsContext)({
    componentName: 'select',
    packageName: packageName,
    packageVersion: packageVersion
})((0, _analyticsNext.withAnalyticsEvents)({
    onChange: createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: packageName,
            packageVersion: packageVersion
        }
    })
})(SelectWithoutAnalytics));
exports.default = Select;

},{"@atlaskit/analytics-next":"auH4u","@atlaskit/react-select/async":"3pR3O","./create-select":"5nVqX","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3pR3O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAsync", function() {
    return 0, _async.useAsync;
});
parcelHelpers.export(exports, "default", function() {
    return 0, _asyncDefault.default;
});
var _async = require("../async");
var _asyncDefault = parcelHelpers.interopDefault(_async);

},{"../async":"jpKJK","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jpKJK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAsync", function() {
    return 0, _useAsyncDefault.default;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _select = require("./select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _useAsync = require("./use-async");
var _useAsyncDefault = parcelHelpers.interopDefault(_useAsync);
var _useStateManager = require("./use-state-manager");
var _useStateManagerDefault = parcelHelpers.interopDefault(_useStateManager);
var AsyncSelect = /*#__PURE__*/ (0, _react.forwardRef)(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
function(props, ref) {
    // when isAsync is true, options are not provided and async props are used, we will enable async
    var isAsyncEnabledInBaseSelect = props.isAsync && !props.options && (!!props.loadOptions || !!props.defaultOptions);
    var stateManagedProps = (0, _useAsyncDefault.default)(props);
    // when isAsync is falsy or isAsyncEnabledInBaseSelect is true, we use async props, otherwise we use base props
    var selectAsyncProps = !props.isAsync || isAsyncEnabledInBaseSelect ? stateManagedProps : props;
    var selectProps = (0, _useStateManagerDefault.default)(selectAsyncProps);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default), (0, _objectSpread._)({
        ref: ref
    }, selectProps));
});
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = AsyncSelect;

},{"@swc/helpers/_/_object_spread":"9gdrV","react/jsx-runtime":"bGvcw","react":"ltHCL","./select":"jLnLx","./use-async":"d4snc","./use-state-manager":"kQWD7","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jLnLx":[function(require,module,exports,__globalThis) {
/* select.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultProps", function() {
    return defaultProps;
});
// eslint-disable-next-line @repo/internal/react/no-class-components
parcelHelpers.export(exports, "default", function() {
    return Select;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _deviceCheck = require("@atlaskit/ds-lib/device-check");
var _isSafari = require("@atlaskit/ds-lib/is-safari");
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _builtins = require("./builtins");
var _components = require("./components");
var _dummyInput = require("./components/dummy-input");
var _dummyInputDefault = parcelHelpers.interopDefault(_dummyInput);
var _liveRegion = require("./components/live-region");
var _liveRegionDefault = parcelHelpers.interopDefault(_liveRegion);
var _menuPlacer = require("./components/menu-placer");
var _menuPlacerDefault = parcelHelpers.interopDefault(_menuPlacer);
var _filters = require("./filters");
var _classnames = require("./internal/classnames");
var _cleanValue = require("./internal/clean-value");
var _isDocumentEl = require("./internal/is-document-el");
var _multiValueAsValue = require("./internal/multi-value-as-value");
var _notifyOpenLayerObserver = require("./internal/notify-open-layer-observer");
var _requiredInput = require("./internal/required-input");
var _requiredInputDefault = parcelHelpers.interopDefault(_requiredInput);
var _scrollManager = require("./internal/scroll-manager");
var _scrollManagerDefault = parcelHelpers.interopDefault(_scrollManager);
var _scrollTo = require("./internal/scroll-to");
var _singleValueAsValue = require("./internal/single-value-as-value");
var _valueTernary = require("./internal/value-ternary");
var noop = (0, _noopDefault.default);
function notNullish(item) {
    return item != null;
}
function scrollIntoView(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) (0, _scrollTo.scrollTo)(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) (0, _scrollTo.scrollTo)(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
function isMobileDevice() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
function isTouchCapable() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Filters out unsupported selectors (e.g., pseudo-classes, complex selectors) from a styles object.
 * @param styles - The styles object to filter.
 * @returns A new object containing only supported styles.
 */ var filterUnsupportedSelectors = function(styles) {
    var unsupportedSelectors = [
        ':',
        // pseudo-classes/elements
        '[',
        // attribute selectors
        '>',
        // child combinator
        '+',
        // adjacent sibling combinator
        '~',
        // general sibling combinator
        ' ',
        // descendant combinator
        '*',
        // universal selector
        '#',
        // ID selector
        '.',
        // class selector
        '@',
        // at-rules
        '&',
        // parent selector
        '|',
        // namespace separator
        '^',
        // starts with
        '$',
        // ends with
        '=' // equals
    ];
    return Object.keys(styles).reduce(function(filteredStyles, key) {
        if (!unsupportedSelectors.some(function(selector) {
            return key.includes(selector);
        })) filteredStyles[key] = styles[key];
        return filteredStyles;
    }, {});
};
var elemBeforeCSS = null;
var defaultProps = {
    backspaceRemovesValue: true,
    blurInputOnSelect: isTouchCapable(),
    captureMenuScroll: !isTouchCapable(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: (0, _filters.createFilter)(),
    formatGroupLabel: (0, _builtins.formatGroupLabel),
    getOptionLabel: (0, _builtins.getOptionLabel),
    getOptionValue: (0, _builtins.getOptionValue),
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: (0, _builtins.isOptionDisabled),
    loadingMessage: function() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !isMobileDevice(),
    noOptionsMessage: function() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    shouldPreventEscapePropagation: false,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function(param) {
        var count = param.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    UNSAFE_is_experimental_generic: false
};
function toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = isOptionDisabled(props, option, selectValue);
    var isSelected = isOptionSelected(props, option, selectValue);
    var label = getOptionLabel(props, option);
    var value = getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        //@ts-ignore
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter(notNullish);
}
function buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        var _optionsAccumulator;
        if (categorizedOption.type === 'group') (_optionsAccumulator = optionsAccumulator).push.apply(_optionsAccumulator, (0, _toConsumableArray._)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        var _optionsAccumulator;
        if (categorizedOption.type === 'group') (_optionsAccumulator = optionsAccumulator).push.apply(_optionsAccumulator, (0, _toConsumableArray._)(categorizedOption.options.map(function(option) {
            return {
                data: option.data,
                id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
            };
        })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: "".concat(optionId, "-").concat(categorizedOption.index)
        });
        return optionsAccumulator;
    }, []);
}
function buildFocusableOptions(props, selectValue) {
    return buildFocusableOptionsFromCategorizedOptions(buildCategorizedOptions(props, selectValue));
}
function isFocusable(props, categorizedOption) {
    var _props_inputValue = props.inputValue, inputValue = _props_inputValue === void 0 ? '' : _props_inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!shouldHideSelectedOptions(props) || !isSelected) && filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var getFocusedOptionId = function(focusableOptionsWithIds, focusedOption) {
    var _focusableOptionsWithIds_find;
    var focusedOptionId = (_focusableOptionsWithIds_find = focusableOptionsWithIds.find(function(option) {
        return option.data === focusedOption;
    })) === null || _focusableOptionsWithIds_find === void 0 ? void 0 : _focusableOptionsWithIds_find.id;
    return focusedOptionId || null;
};
var getOptionLabel = function(props, data) {
    return props.getOptionLabel(data);
};
var getOptionValue = function(props, data) {
    return props.getOptionValue(data);
};
function isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = getOptionValue(props, option);
    return selectValue.some(function(i) {
        return getOptionValue(props, i) === candidate;
    });
}
function filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var shouldHideSelectedOptions = function(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var instanceId = 1;
var Select = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, _inherits._)(Select, Component);
    function Select(props) {
        (0, _classCallCheck._)(this, Select);
        var _this;
        _this = (0, _callSuper._)(this, Select, [
            props
        ]), _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            focusedValueId: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ''
        }, // Misc. Instance Properties
        // ------------------------------
        _this.blockOptionHover = false, _this.isComposing = false, _this.initialTouchX = 0, _this.initialTouchY = 0, _this.openAfterFocus = false, _this.scrollToFocusedOptionOnUpdate = false, // Refs
        // ------------------------------
        _this.controlRef = null, _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        }, _this.focusedOptionRef = null, _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        }, _this.menuListRef = null, _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        }, _this.inputRef = null, _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        }, // aliased for consumers
        _this.focus = _this.focusInput, _this.blur = _this.blurInput, _this.onChange = function(newValue, actionMeta) {
            var _this_props = _this.props, onChange = _this_props.onChange, name = _this_props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        }, _this.setValue = function(newValue, action, option) {
            var _this_props = _this.props, closeMenuOnSelect = _this_props.closeMenuOnSelect, isMulti = _this_props.isMulti, inputValue = _this_props.inputValue;
            _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        }, _this.selectOption = function(newValue) {
            var _this_props = _this.props, blurInputOnSelect = _this_props.blurInputOnSelect, isMulti = _this_props.isMulti, name = _this_props.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, _multiValueAsValue.multiValueAsValue)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, _multiValueAsValue.multiValueAsValue)((0, _toConsumableArray._)(selectValue).concat([
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, _singleValueAsValue.singleValueAsValue)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, _singleValueAsValue.singleValueAsValue)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        }, _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, _valueTernary.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        }, _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, _valueTernary.valueTernary)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        }, _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, _valueTernary.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        }, // ==============================
        // Getters
        // ==============================
        _this.getFocusedOptionId = function(focusedOption) {
            return getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
        }, _this.getFocusableOptionsWithIds = function() {
            return buildFocusableOptionsWithIds(buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId('option'));
        }, _this.getValue = function() {
            return _this.state.selectValue;
        }, _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return (0, _classnames.classNames).apply(void 0, [
                _this.props.classNamePrefix
            ].concat((0, _toConsumableArray._)(args)));
        }, _this.getOptionLabel = function(data) {
            return getOptionLabel(_this.props, data);
        }, _this.getOptionValue = function(data) {
            return getOptionValue(_this.props, data);
        }, _this.getStyles = function(key, props) {
            var base = {
                boxSizing: 'border-box'
            };
            var custom = _this.props.styles[key];
            if (custom) return filterUnsupportedSelectors(custom(base, props));
            return base;
        }, _this.getClassNames = function(key, props) {
            var _this_props_classNames_key, _this_props_classNames;
            return (_this_props_classNames_key = (_this_props_classNames = _this.props.classNames)[key]) === null || _this_props_classNames_key === void 0 ? void 0 : _this_props_classNames_key.call(_this_props_classNames, props);
        }, _this.getElementId = function(element) {
            return "".concat(_this.state.instancePrefix, "-").concat(element);
        }, _this.getComponents = function() {
            return (0, _components.defaultComponents)(_this.props);
        }, _this.buildCategorizedOptions = function() {
            return buildCategorizedOptions(_this.props, _this.state.selectValue);
        }, _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        }, _this.buildFocusableOptions = function() {
            return buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        }, _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        }, // ==============================
        // Helpers
        // ==============================
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, _objectSpread._)({
                    value: value
                }, actionMeta)
            });
        }, // ==============================
        // Mouse Handlers
        // ==============================
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        }, _this.onMenuMouseMove = function(_) {
            _this.blockOptionHover = false;
        }, _this.onControlMouseDown = function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) {
                var _this_controlRef;
                // react-dnd will fire preventDefault in mouseDown, which make select is not clickable.
                // temp workaround to check if select is within dnd, we don't do the early return.
                if (!((_this_controlRef = _this.controlRef) === null || _this_controlRef === void 0 ? void 0 : _this_controlRef.closest('[data-rbd-draggable-context-id]'))) return;
            }
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        }, _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this_props = _this.props, isMulti = _this_props.isMulti, menuIsOpen = _this_props.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
        }, _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        }, _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if ((0, _instanceof._)(event.target, HTMLElement) && (0, _isDocumentEl.isDocumentElement)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        }, _this.onCompositionStart = function() {
            _this.isComposing = true;
        }, _this.onCompositionEnd = function() {
            _this.isComposing = false;
        }, _this.onTouchStart = function(param) {
            var touches = param.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        }, _this.onTouchMove = function(param) {
            var touches = param.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        }, _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        }, _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        }, _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        }, _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        }, // ==============================
        // Focus Handlers
        // ==============================
        _this.handleInputChange = function(event) {
            var _this_props = _this.props, prevInputValue = _this_props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        }, _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        }, _this.onInputBlur = function(event) {
            var _this_props = _this.props, prevInputValue = _this_props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            if ((0, _platformFeatureFlags.fg)('platform_dst_select_menu_close_on_blur')) // when fg is enabled, we only call onMenuClose when this.props.menuIsOpen is true.
            _this.props.menuIsOpen && _this.onMenuClose();
            else _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        }, _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            var options = _this.getFocusableOptions();
            var focusedOptionIndex = options.indexOf(focusedOption);
            _this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
            });
        }, _this.shouldHideSelectedOptions = function() {
            return shouldHideSelectedOptions(_this.props);
        }, // If the hidden input gets focus through form submit,
        // redirect focus to focusable input.
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        }, // ==============================
        // Keyboard Handlers
        // ==============================
        _this.onKeyDown = function(event) {
            var _this_props = _this.props, isMulti = _this_props.isMulti, backspaceRemovesValue = _this_props.backspaceRemovesValue, escapeClearsValue = _this_props.escapeClearsValue, inputValue = _this_props.inputValue, isClearable = _this_props.isClearable, isDisabled = _this_props.isDisabled, menuIsOpen = _this_props.menuIsOpen, onKeyDown = _this_props.onKeyDown, tabSelectsValue = _this_props.tabSelectsValue, openMenuOnFocus = _this_props.openMenuOnFocus, shouldPreventEscapePropagation = _this_props.shouldPreventEscapePropagation;
            var _this_state = _this.state, focusedOption = _this_state.focusedOption, focusedValue = _this_state.focusedValue, selectValue = _this_state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (focusedValue) _this.removeValue(focusedValue);
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                        if (shouldPreventEscapePropagation && (0, _instanceof._)(event.target, HTMLElement)) event.stopPropagation();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        }, _this.handleOpenLayerObserverCloseSignal = function() {
            _this.onMenuClose();
        };
        _this.state.instancePrefix = 'react-select-' + (_this.props.instanceId || ++instanceId);
        _this.state.selectValue = (0, _cleanValue.cleanValue)(props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (props.menuIsOpen) {
            var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            _this.state.focusedOption = focusableOptions[optionIndex];
            _this.state.focusedOptionId = getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
        return _this;
    }
    (0, _createClass._)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) scrollIntoView(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this_props = this.props, isDisabled = _this_props.isDisabled, menuIsOpen = _this_props.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    scrollIntoView(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            // ==============================
            // Consumer Handlers
            // ==============================
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            // ==============================
            // Methods
            // ==============================
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this = this;
                var _this_state = this.state, selectValue = _this_state.selectValue, isFocused = _this_state.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                var focusedOption = focusableOptions[openAtIndex];
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusedOption,
                    focusedOptionId: this.getFocusedOptionId(focusedOption)
                }, function() {
                    return _this.onMenuOpen();
                });
                (0, _isSafari.isSafari)() && focusedOption && this.updateInputLabel(this.calculateInputLabel(focusedOption, openAtIndex));
            }
        },
        {
            key: "updateInputLabel",
            value: function updateInputLabel(inputLabel) {
                var _this = this;
                if (inputLabel) {
                    var _this_inputRef;
                    (_this_inputRef = this.inputRef) === null || _this_inputRef === void 0 ? void 0 : _this_inputRef.setAttribute('aria-label', inputLabel);
                    setTimeout(function() {
                        var _this_inputRef, _this_inputRef1;
                        var normalizedLabel = _this.props['aria-label'] || _this.props.label;
                        if (normalizedLabel) (_this_inputRef = _this.inputRef) === null || _this_inputRef === void 0 ? void 0 : _this_inputRef.setAttribute('aria-label', normalizedLabel);
                        else (_this_inputRef1 = _this.inputRef) === null || _this_inputRef1 === void 0 ? void 0 : _this_inputRef1.removeAttribute('aria-label');
                    }, 500);
                }
            }
        },
        {
            key: "calculateInputLabel",
            value: function calculateInputLabel(focusedOption, optionIndex) {
                var _this = this;
                var options = this.props.options;
                var isOptionsGrouped = options === null || options === void 0 ? void 0 : options.every(function(obj) {
                    return (typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj)) === 'object' && obj !== null && 'options' in obj;
                });
                var inputLabel = this.getOptionLabel(focusedOption);
                var isOptionFocused = function(option) {
                    return _this.getOptionLabel(option) === inputLabel;
                };
                var groupData = options === null || options === void 0 ? void 0 : options.find(function(option) {
                    var _groupCandidate_options;
                    var groupCandidate = option;
                    var _groupCandidate_options_some;
                    return (_groupCandidate_options_some = (_groupCandidate_options = groupCandidate.options) === null || _groupCandidate_options === void 0 ? void 0 : _groupCandidate_options.some(isOptionFocused)) !== null && _groupCandidate_options_some !== void 0 ? _groupCandidate_options_some : false;
                });
                if (isOptionsGrouped) {
                    var _groupData_options_findIndex;
                    var groupOptionIndex = (_groupData_options_findIndex = groupData === null || groupData === void 0 ? void 0 : groupData.options.findIndex(isOptionFocused)) !== null && _groupData_options_findIndex !== void 0 ? _groupData_options_findIndex : 0;
                    var totalLength = options === null || options === void 0 ? void 0 : options.reduce(function(acc, currentGroup) {
                        var _group_options;
                        var group = currentGroup;
                        acc += group === null || group === void 0 ? void 0 : (_group_options = group.options) === null || _group_options === void 0 ? void 0 : _group_options.length;
                        return acc;
                    }, 0);
                    inputLabel = "".concat(inputLabel, ", ").concat(groupData === null || groupData === void 0 ? void 0 : groupData.label, " (").concat(groupOptionIndex + 1, " of ").concat(totalLength, ")");
                } else inputLabel = "".concat(inputLabel, " (").concat(optionIndex + 1, " of ").concat(options === null || options === void 0 ? void 0 : options.length, ")");
                return inputLabel;
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this_state = this.state, selectValue = _this_state.selectValue, focusedValue = _this_state.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus],
                    focusedValueId: "".concat(this.getElementId('selected-value'), "-").concat(nextFocus, "-remove"),
                    focusedOption: null,
                    focusedOptionId: null
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null,
                    focusedValueId: null,
                    focusedOptionId: this.getFocusedOptionId(options[nextFocus])
                });
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var _this = this, clearValue = _this.clearValue, cx = _this.cx, getStyles = _this.getStyles, getClassNames = _this.getClassNames, getValue = _this.getValue, selectOption = _this.selectOption, setValue = _this.setValue, props = _this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this_props = this.props, isClearable = _this_props.isClearable, isMulti = _this_props.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled1(option, selectValue) {
                return isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected1(option, selectValue) {
                return isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption1(option, inputValue) {
                return filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                var _this_props_components;
                if (typeof this.props.formatOptionLabel === 'function') {
                    var inputValue = this.props.inputValue;
                    var selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: inputValue,
                        selectValue: selectValue
                    });
                }
                // Auto-render elemBefore in dropdown menu only if formatOptionLabel is not provided
                // and no custom Option component is provided (custom Option components may already
                // render elemBefore themselves, causing it to appear twice)
                if (context === 'menu' && !this.props.formatOptionLabel && !((_this_props_components = this.props.components) === null || _this_props_components === void 0 ? void 0 : _this_props_components.Option) && (0, _platformFeatureFlags.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
                    var elemBefore = data.elemBefore;
                    if (elemBefore) {
                        var label = this.getOptionLabel(data);
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: (0, _runtime.ax)([
                                "_zulpu2gc _1e0c1txw _4cvr1h6o"
                            ]),
                            children: [
                                elemBefore,
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: label
                                })
                            ]
                        });
                    }
                }
                return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "calculateDescription",
            value: function calculateDescription() {
                var descriptionProp = this.props['aria-describedby'] || this.props.descriptionId;
                var isMulti = this.props.isMulti;
                var hasValue = this.state.selectValue.length > 0;
                // Determine base description based on selection state
                var baseDescriptionId = hasValue ? isMulti ? '' : this.getElementId('single-value') : this.getElementId('placeholder');
                // Fast path for single select with no description prop
                if (!isMulti && !descriptionProp) return {
                    'aria-describedby': baseDescriptionId
                };
                // Build the describedby string efficiently
                var describedBy = baseDescriptionId;
                // Add description prop if it exists
                if (descriptionProp) describedBy = describedBy ? "".concat(descriptionProp, " ").concat(describedBy) : descriptionProp;
                // For multi-select, always add multi-message ID
                if (isMulti) {
                    var multiMessage = this.getElementId('multi-message');
                    describedBy = describedBy ? "".concat(describedBy, " ").concat(multiMessage) : multiMessage;
                }
                return {
                    'aria-describedby': describedBy
                };
            }
        },
        {
            // ==============================
            // Composition Handlers
            // ==============================
            key: "startListeningComposition",
            value: function startListeningComposition() {
                if (document && document.addEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            // ==============================
            // Touch Handlers
            // ==============================
            key: "startListeningToTouch",
            value: function startListeningToTouch() {
                if (document && document.addEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('touchstart', this.onTouchStart);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('touchmove', this.onTouchMove);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            // ==============================
            // Renderers
            // ==============================
            key: "renderInput",
            value: function renderInput() {
                var _this_props = this.props, form = _this_props.form, inputId = _this_props.inputId, inputValue = _this_props.inputValue, isDisabled = _this_props.isDisabled, isInvalid = _this_props.isInvalid, isRequired = _this_props.isRequired, isSearchable = _this_props.isSearchable, label = _this_props.label, labelId = _this_props.labelId, menuIsOpen = _this_props.menuIsOpen, required = _this_props.required, _this_props_tabIndex = _this_props.tabIndex, tabIndex = _this_props_tabIndex === void 0 ? 0 : _this_props_tabIndex, testId = _this_props.testId;
                var Input = this.getComponents().Input;
                var inputIsHidden = this.state.inputIsHidden;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, !this.props.isSearchable && (0, _platformFeatureFlags.fg)('platform_fix_autocomplete_aria_for_select') ? {} : {
                    'aria-autocomplete': 'both'
                }), {
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-expanded': menuIsOpen,
                    // TODO: aria-haspopup is implied as listbox with role="combobox" and was deprecated for aria 1.2, we still might need to keep it for back compat
                    'aria-haspopup': this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox',
                    'aria-invalid': this.props['aria-invalid'] || isInvalid,
                    'aria-label': this.props['aria-label'] || label,
                    'aria-labelledby': this.props['aria-labelledby'] || labelId,
                    'aria-required': required || isRequired,
                    role: 'combobox',
                    'aria-activedescendant': this.props['UNSAFE_is_experimental_generic'] ? undefined : this.state.focusedOptionId || this.state.focusedValueId || undefined
                }), menuIsOpen && {
                    'aria-controls': this.getElementId('listbox')
                }, !isSearchable && !(0, _platformFeatureFlags.fg)('select_issearchable_aria-readonly_fix') && {
                    'aria-readonly': true
                }, this.calculateDescription());
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dummyInputDefault.default), (0, _objectSpread._)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: noop,
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: "",
                    "data-testid": testId && "".concat(testId, "-select--input")
                }, ariaAttributes));
                // NOTE: Don't add the `name` prop to this Input, `name` is already a prop on the hidden input element that has the value of the select.
                // Adding `name` to this Input will cause unexpected behavior.
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Input, (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, commonProps), {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    testId: testId,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }), ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this = this;
                var _this_getComponents = this.getComponents(), MultiValue = _this_getComponents.MultiValue, MultiValueContainer = _this_getComponents.MultiValueContainer, MultiValueLabel = _this_getComponents.MultiValueLabel, MultiValueRemove = _this_getComponents.MultiValueRemove, SingleValue = _this_getComponents.SingleValue, Placeholder = _this_getComponents.Placeholder;
                var commonProps = this.commonProps;
                var _this_props = this.props, controlShouldRenderValue = _this_props.controlShouldRenderValue, isDisabled = _this_props.isDisabled, isMulti = _this_props.isMulti, inputValue = _this_props.inputValue, placeholder = _this_props.placeholder, testId = _this_props.testId;
                var _this_state = this.state, selectValue = _this_state.selectValue, focusedValue = _this_state.focusedValue, isFocused = _this_state.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ (0, _react.createElement)(Placeholder, (0, _objectSpreadProps._)((0, _objectSpread._)({}, commonProps), {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: (0, _objectSpread._)({
                        id: this.getElementId('placeholder')
                    }, testId && {
                        'data-testid': "".concat(testId, "-select--placeholder")
                    })
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this.getOptionLabel(opt), "-").concat(_this.getOptionValue(opt));
                    return /*#__PURE__*/ (0, _react.createElement)(MultiValue, (0, _objectSpreadProps._)((0, _objectSpread._)({}, commonProps), {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: (0, _objectSpreadProps._)((0, _objectSpread._)({
                            onClick: function() {
                                return _this.removeValue(opt);
                            },
                            onTouchEnd: function() {
                                return _this.removeValue(opt);
                            },
                            onMouseDown: function(e) {
                                e.preventDefault();
                            }
                        }, testId && {
                            'data-testid': "".concat(testId, "-select--multivalue-").concat(index, "-remove")
                        }), {
                            id: "".concat(_this.getElementId('selected-value'), "-").concat(index, "-remove")
                        }),
                        data: opt,
                        innerProps: (0, _objectSpreadProps._)((0, _objectSpread._)({}, testId && {
                            'data-testid': "".concat(testId, "-select--multivalue-").concat(index)
                        }), {
                            id: "".concat(_this.getElementId('selected-value'), "-").concat(index)
                        })
                    }), _this.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SingleValue, (0, _objectSpreadProps._)((0, _objectSpread._)({}, commonProps), {
                    data: singleValue,
                    isDisabled: isDisabled,
                    innerProps: {
                        id: this.getElementId('single-value')
                    },
                    children: this.formatOptionLabel(singleValue, 'value')
                }));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var ClearIndicator = this.getComponents().ClearIndicator;
                var commonProps = this.commonProps;
                var _this_props = this.props, clearControlLabel = _this_props.clearControlLabel, isDisabled = _this_props.isDisabled, isLoading = _this_props.isLoading, spacing = _this_props.spacing, testId = _this_props.testId;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = (0, _objectSpread._)({
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd
                }, testId && {
                    'data-testid': "".concat(testId, "-select--clear-indicator")
                });
                var isCompact = spacing === 'compact';
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClearIndicator, (0, _objectSpreadProps._)((0, _objectSpread._)({
                    clearControlLabel: clearControlLabel
                }, commonProps), {
                    innerProps: innerProps,
                    isFocused: isFocused,
                    isCompact: isCompact
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var LoadingIndicator = this.getComponents().LoadingIndicator;
                var commonProps = this.commonProps;
                var _this_props = this.props, isDisabled = _this_props.isDisabled, isLoading = _this_props.isLoading, spacing = _this_props.spacing, testId = _this_props.testId;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var isCompact = spacing === 'compact';
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(LoadingIndicator, (0, _objectSpreadProps._)((0, _objectSpread._)({
                    "data-testid": testId && "".concat(testId, "-select--loading-indicator")
                }, commonProps), {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    isCompact: isCompact
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var DropdownIndicator = this.getComponents().DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var _this_props = this.props, isDisabled = _this_props.isDisabled, spacing = _this_props.spacing, testId = _this_props.testId;
                var isFocused = this.state.isFocused;
                var isCompact = spacing === 'compact';
                var innerProps = (0, _objectSpread._)({
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                }, testId && {
                    'data-testid': "".concat(testId, "-select--dropdown-indicator")
                });
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DropdownIndicator, (0, _objectSpreadProps._)((0, _objectSpread._)({}, commonProps), {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    isCompact: isCompact
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this = this;
                var _this_getComponents = this.getComponents(), Group = _this_getComponents.Group, GroupHeading = _this_getComponents.GroupHeading, Menu = _this_getComponents.Menu, MenuList = _this_getComponents.MenuList, MenuPortal = _this_getComponents.MenuPortal, LoadingMessage = _this_getComponents.LoadingMessage, NoOptionsMessage = _this_getComponents.NoOptionsMessage, Option = _this_getComponents.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this_props = this.props, captureMenuScroll = _this_props.captureMenuScroll, inputValue = _this_props.inputValue, isLoading = _this_props.isLoading, loadingMessage = _this_props.loadingMessage, minMenuHeight = _this_props.minMenuHeight, maxMenuHeight = _this_props.maxMenuHeight, menuIsOpen = _this_props.menuIsOpen, menuPlacement = _this_props.menuPlacement, menuPosition = _this_props.menuPosition, menuPortalTarget = _this_props.menuPortalTarget, menuShouldBlockScroll = _this_props.menuShouldBlockScroll, menuShouldScrollIntoView = _this_props.menuShouldScrollIntoView, noOptionsMessage = _this_props.noOptionsMessage, onMenuScrollToTop = _this_props.onMenuScrollToTop, onMenuScrollToBottom = _this_props.onMenuScrollToBottom, testId = _this_props.testId;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function(props, id, headingId) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this.selectOption(data);
                    };
                    var optionId = "".concat(_this.getElementId('option'), "-").concat(id);
                    var innerProps = (0, _objectSpread._)({
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        role: _this.props['UNSAFE_is_experimental_generic'] ? 'listitem' : 'option',
                        'aria-selected': _this.props['UNSAFE_is_experimental_generic'] ? undefined : isSelected,
                        // We don't want aria-disabled if it's false. It's just noisy.
                        'aria-disabled': !isDisabled ? undefined : isDisabled,
                        'aria-describedby': headingId
                    }, testId && {
                        'data-testid': "".concat(testId, "-select--option-").concat(id)
                    });
                    return /*#__PURE__*/ (0, _react.createElement)(Option, (0, _objectSpreadProps._)((0, _objectSpread._)({}, commonProps), {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this.getFocusedOptionRef : undefined
                    }), _this.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) {
                    var items = this.getCategorizedOptions();
                    menuUI = items.map(function(item) {
                        if (item.type === 'group') {
                            var data = item.data, options = item.options, groupIndex = item.index;
                            var groupId = "".concat(_this.getElementId('group'), "-").concat(groupIndex);
                            var headingId = "".concat(groupId, "-heading");
                            return /*#__PURE__*/ (0, _react.createElement)(Group, (0, _objectSpreadProps._)((0, _objectSpread._)({}, commonProps), {
                                key: groupId,
                                data: data,
                                options: options,
                                Heading: GroupHeading,
                                headingProps: (0, _objectSpread._)({
                                    id: headingId,
                                    data: item.data
                                }, testId && {
                                    'data-testid': "".concat(testId, "-select--group-").concat(groupIndex, "-heading")
                                }),
                                label: _this.formatGroupLabel(item.data)
                            }), item.options.map(function(option) {
                                return render(option, "".concat(groupIndex, "-").concat(option.index), headingId);
                            }));
                        } else if (item.type === 'option') return render(item, "".concat(item.index));
                        return undefined;
                    });
                } else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ (0, _jsxRuntime.jsx)(LoadingMessage, (0, _objectSpreadProps._)((0, _objectSpread._)({}, commonProps), {
                        children: message
                    }));
                } else {
                    var message1 = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (message1 === null) return null;
                    menuUI = /*#__PURE__*/ (0, _jsxRuntime.jsx)(NoOptionsMessage, (0, _objectSpreadProps._)((0, _objectSpread._)({}, commonProps), {
                        innerProps: (0, _objectSpread._)({}, this.props['UNSAFE_is_experimental_generic'] && {
                            role: 'listitem'
                        }, testId && {
                            'data-testid': "".concat(testId, "-select--no-options")
                        }),
                        children: message1
                    }));
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuPlacerDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, commonProps, menuPlacementProps), {
                    children: function(param) {
                        var ref = param.ref, _param_placerProps = param.placerProps, placement = _param_placerProps.placement, maxHeight = _param_placerProps.maxHeight;
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Menu, (0, _objectSpreadProps._)((0, _objectSpread._)({}, commonProps, menuPlacementProps), {
                            innerRef: ref,
                            innerProps: (0, _objectSpread._)({
                                onMouseDown: _this.onMenuMouseDown,
                                onMouseMove: _this.onMenuMouseMove,
                                id: _this.props.components.Menu ? _this.getElementId('listbox') : undefined
                            }, testId && {
                                'data-testid': "".concat(testId, "-select--listbox-container")
                            }),
                            isLoading: isLoading,
                            placement: placement,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _scrollManagerDefault.default), {
                                captureEnabled: captureMenuScroll,
                                onTopArrive: onMenuScrollToTop,
                                onBottomArrive: onMenuScrollToBottom,
                                lockEnabled: menuShouldBlockScroll,
                                children: function(scrollTargetRef) {
                                    var _this_inputRef, _this_inputRef1;
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(MenuList, (0, _objectSpreadProps._)((0, _objectSpread._)({}, commonProps), {
                                        innerRef: function(instance) {
                                            _this.getMenuListRef(instance);
                                            scrollTargetRef(instance);
                                        },
                                        innerProps: (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({
                                            role: _this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox'
                                        }, _this.props['UNSAFE_is_experimental_generic'] && {
                                            'aria-labelledby': ((_this_inputRef = _this.inputRef) === null || _this_inputRef === void 0 ? void 0 : _this_inputRef.id) || _this.getElementId('input')
                                        }), {
                                            'aria-multiselectable': !commonProps.isMulti || _this.props['UNSAFE_is_experimental_generic'] ? undefined : commonProps.isMulti,
                                            id: _this.getElementId('listbox')
                                        }), testId && {
                                            'data-testid': "".concat(testId, "-select--listbox")
                                        }, (0, _isSafari.isSafari)() && !_this.props['UNSAFE_is_experimental_generic'] && {
                                            'aria-describedby': ((_this_inputRef1 = _this.inputRef) === null || _this_inputRef1 === void 0 ? void 0 : _this_inputRef1.id) || _this.getElementId('input')
                                        }),
                                        isLoading: isLoading,
                                        maxHeight: maxHeight,
                                        focusedOption: focusedOption,
                                        children: _this.props['UNSAFE_is_experimental_generic'] ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            role: "list",
                                            children: menuUI
                                        }) : menuUI
                                    }));
                                }
                            })
                        }));
                    }
                }));
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(MenuPortal, (0, _objectSpreadProps._)((0, _objectSpread._)({}, commonProps), {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    children: menuElement
                })) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this = this;
                var _this_props = this.props, delimiter = _this_props.delimiter, isDisabled = _this_props.isDisabled, isMulti = _this_props.isMulti, required = _this_props.required, name = _this_props.name;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requiredInputDefault.default), {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                name: name,
                                type: "hidden",
                                value: _this.getOptionValue(opt)
                            }, "i-".concat(i));
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            children: input
                        });
                    }
                } else {
                    var value1 = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        name: name,
                        type: "hidden",
                        value: value1
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this_state = this.state, ariaSelection = _this_state.ariaSelection, isFocused = _this_state.isFocused, selectValue = _this_state.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _liveRegionDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, commonProps), {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions
                }));
            }
        },
        {
            key: "renderMultiselectMessage",
            value: function renderMultiselectMessage() {
                // In the future, when we actually support touch devices, we'll need to update this to not be keyboard specific.
                // Also, since this is rendered onscreen, it should be transtlated automatically.
                var msg = ", multiple selections available, ".concat(this.state.selectValue.length ? 'Use left or right arrow keys to navigate selected items' : '');
                return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    id: this.getElementId('multi-message'),
                    hidden: true,
                    children: msg
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_getComponents = this.getComponents(), Control = _this_getComponents.Control, IndicatorsContainer = _this_getComponents.IndicatorsContainer, SelectContainer = _this_getComponents.SelectContainer, ValueContainer = _this_getComponents.ValueContainer;
                var _this_props = this.props, className = _this_props.className, id = _this_props.id, isDisabled = _this_props.isDisabled, menuIsOpen = _this_props.menuIsOpen, isInvalid = _this_props.isInvalid, testId = _this_props.testId, _this_props_appearance = _this_props.appearance, appearance = _this_props_appearance === void 0 ? 'default' : _this_props_appearance, _this_props_spacing = _this_props.spacing, spacing = _this_props_spacing === void 0 ? 'default' : _this_props_spacing;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                var isCompact = spacing === 'compact';
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(SelectContainer, (0, _objectSpreadProps._)((0, _objectSpread._)({}, commonProps), {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                    className: className,
                    innerProps: (0, _objectSpread._)({
                        id: id,
                        onKeyDown: this.onKeyDown
                    }, testId && {
                        'data-testid': testId && "".concat(testId, "-select--container")
                    }),
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    children: [
                        this.renderLiveRegion(),
                        commonProps.isMulti && this.renderMultiselectMessage(),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Control, (0, _objectSpreadProps._)((0, _objectSpread._)({}, commonProps), {
                            innerRef: this.getControlRef,
                            innerProps: (0, _objectSpread._)({
                                onMouseDown: this.onControlMouseDown,
                                onTouchEnd: this.onControlTouchEnd
                            }, testId && {
                                'data-testid': "".concat(testId, "-select--control")
                            }),
                            appearance: appearance,
                            isInvalid: isInvalid,
                            isDisabled: isDisabled,
                            isFocused: isFocused,
                            menuIsOpen: menuIsOpen,
                            isCompact: isCompact,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ValueContainer, (0, _objectSpreadProps._)((0, _objectSpread._)({}, commonProps), {
                                    isDisabled: isDisabled,
                                    isCompact: isCompact,
                                    innerProps: (0, _objectSpread._)({}, testId && {
                                        'data-testid': "".concat(testId, "-select--value-container")
                                    }, commonProps.isMulti && commonProps.hasValue && !(0, _deviceCheck.isAppleDevice)() && {
                                        // Required to keep JAWS from popping out of forms mode when using LEFT/RIGHT arrow keys.
                                        // This is Jedi Master level ARIA and not taken lightly. Do not modify without consulting
                                        // DST Accessibility.
                                        role: 'application'
                                    }),
                                    children: [
                                        this.renderPlaceholderOrValue(),
                                        this.renderInput()
                                    ]
                                })),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)(IndicatorsContainer, (0, _objectSpreadProps._)((0, _objectSpread._)({}, commonProps), {
                                    isDisabled: isDisabled,
                                    innerProps: (0, _objectSpread._)({}, testId && {
                                        'data-testid': "".concat(testId, "-select--indicators-container")
                                    }),
                                    children: [
                                        this.renderClearIndicator(),
                                        this.renderLoadingIndicator(),
                                        this.renderDropdownIndicator()
                                    ]
                                }))
                            ]
                        })),
                        this.renderMenu(),
                        this.renderFormField(),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notifyOpenLayerObserver.NotifyOpenLayerObserver), {
                            isOpen: this.props.menuIsOpen,
                            onClose: this.handleOpenLayerObserverCloseSignal
                        })
                    ]
                }));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, _cleanValue.cleanValue)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? buildFocusableOptions(props, selectValue) : [];
                    var focusableOptionsWithIds = menuIsOpen ? buildFocusableOptionsWithIds(buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
                    var focusedValue = clearFocusValueOnUpdate ? getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = getNextFocusedOption(state, focusableOptions);
                    var focusedOptionId = getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedOptionId: focusedOptionId,
                        focusableOptionsWithIds: focusableOptionsWithIds,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, _valueTernary.valueTernary)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, newMenuOptionsState, newInputIsHiddenState), {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, _react.Component));
Select.defaultProps = defaultProps;

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_inherits":"2sfqW","@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_to_consumable_array":"1eSZf","@swc/helpers/_/_type_of":"iFJdx","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/ds-lib/device-check":"7THvh","@atlaskit/ds-lib/is-safari":"1P4BQ","@atlaskit/ds-lib/noop":"2f3bg","@atlaskit/platform-feature-flags":"kO5t9","./builtins":"481cR","./components":"lMqb7","./components/dummy-input":"jbpEk","./components/live-region":"cv5eA","./components/menu-placer":"5rakI","./filters":"4FBJr","./internal/classnames":"7aOk0","./internal/clean-value":"klSP6","./internal/is-document-el":"iK3PO","./internal/multi-value-as-value":"3u4nt","./internal/notify-open-layer-observer":"iceUp","./internal/required-input":"7S3pc","./internal/scroll-manager":"2KVrx","./internal/scroll-to":"cuUZ3","./internal/single-value-as-value":"VIAuO","./internal/value-ternary":"2ztHW","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7THvh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isAppleDevice", function() {
    return isAppleDevice;
});
function testPlatform(re) {
    var _window_navigator_userAgentData;
    return typeof window !== 'undefined' && window.navigator != null ? re.test(((_window_navigator_userAgentData = window.navigator['userAgentData']) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.platform) || window.navigator.platform) : false;
}
function isIPhone() {
    return testPlatform(/^iPhone/i);
}
function isIPad() {
    return testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    isMac() && navigator.maxTouchPoints > 1;
}
function isMac() {
    return testPlatform(/^Mac/i);
}
function isIOS() {
    return isIPhone() || isIPad();
}
function isAppleDevice() {
    return isMac() || isIOS();
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"481cR":[function(require,module,exports,__globalThis) {
/* eslint-disable @repo/internal/fs/filename-pattern-match */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatGroupLabel", function() {
    return 0, _formatGroupLabel.formatGroupLabel;
});
parcelHelpers.export(exports, "getOptionLabel", function() {
    return 0, _getOptionLabel.getOptionLabel;
});
parcelHelpers.export(exports, "getOptionValue", function() {
    return 0, _getOptionValue.getOptionValue;
});
parcelHelpers.export(exports, "isOptionDisabled", function() {
    return 0, _isOptionDisabled.isOptionDisabled;
});
var _formatGroupLabel = require("./format-group-label");
var _getOptionLabel = require("./get-option-label");
var _getOptionValue = require("./get-option-value");
var _isOptionDisabled = require("./is-option-disabled");

},{"./format-group-label":"bGDZh","./get-option-label":"4K9LS","./get-option-value":"bZnS7","./is-option-disabled":"jqxrL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bGDZh":[function(require,module,exports,__globalThis) {
/* eslint-disable @repo/internal/fs/filename-pattern-match */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatGroupLabel", function() {
    return formatGroupLabel;
});
var formatGroupLabel = function(group) {
    return group.label;
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4K9LS":[function(require,module,exports,__globalThis) {
/* eslint-disable @repo/internal/fs/filename-pattern-match */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOptionLabel", function() {
    return getOptionLabel;
});
var getOptionLabel = function(option) {
    return option.label;
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bZnS7":[function(require,module,exports,__globalThis) {
/* eslint-disable @repo/internal/fs/filename-pattern-match */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOptionValue", function() {
    return getOptionValue;
});
var getOptionValue = function(option) {
    return option.value;
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jqxrL":[function(require,module,exports,__globalThis) {
/* eslint-disable @repo/internal/fs/filename-pattern-match */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isOptionDisabled", function() {
    return isOptionDisabled;
});
var isOptionDisabled = function(option) {
    return !!option.isDisabled;
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lMqb7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "components", function() {
    return components;
});
parcelHelpers.export(exports, "defaultComponents", function() {
    return defaultComponents;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _indicatorsContainer = require("./containers/indicators-container");
var _multiValueContainer = require("./containers/multi-value-container");
var _selectContainer = require("./containers/select-container");
var _valueContainer = require("./containers/value-container");
var _control = require("./control");
var _controlDefault = parcelHelpers.interopDefault(_control);
var _group = require("./group");
var _groupDefault = parcelHelpers.interopDefault(_group);
var _groupHeading = require("./group-heading");
var _clearIndicator = require("./indicators/clear-indicator");
var _dropdownIndicator = require("./indicators/dropdown-indicator");
var _loadingIndicator = require("./indicators/loading-indicator");
var _input = require("./input");
var _inputDefault = parcelHelpers.interopDefault(_input);
var _menu = require("./menu");
var _menuDefault = parcelHelpers.interopDefault(_menu);
var _menuList = require("./menu-list");
var _menuLoadingMessage = require("./menu-loading-message");
var _menuNoOptionsMessage = require("./menu-no-options-message");
var _menuPortal = require("./menu-portal");
var _multiValue = require("./multi-value");
var _multiValueDefault = parcelHelpers.interopDefault(_multiValue);
var _multiValueLabel = require("./multi-value-label");
var _multiValueRemove = require("./multi-value-remove");
var _option = require("./option");
var _optionDefault = parcelHelpers.interopDefault(_option);
var _placeholder = require("./placeholder");
var _placeholderDefault = parcelHelpers.interopDefault(_placeholder);
var _singleValue = require("./single-value");
var _singleValueDefault = parcelHelpers.interopDefault(_singleValue);
var components = {
    ClearIndicator: (0, _clearIndicator.ClearIndicator),
    Control: (0, _controlDefault.default),
    DropdownIndicator: (0, _dropdownIndicator.DropdownIndicator),
    Group: (0, _groupDefault.default),
    GroupHeading: (0, _groupHeading.GroupHeading),
    IndicatorsContainer: (0, _indicatorsContainer.IndicatorsContainer),
    Input: (0, _inputDefault.default),
    LoadingIndicator: (0, _loadingIndicator.LoadingIndicator),
    Menu: (0, _menuDefault.default),
    MenuList: (0, _menuList.MenuList),
    MenuPortal: (0, _menuPortal.MenuPortal),
    LoadingMessage: (0, _menuLoadingMessage.LoadingMessage),
    NoOptionsMessage: (0, _menuNoOptionsMessage.NoOptionsMessage),
    MultiValue: (0, _multiValueDefault.default),
    MultiValueContainer: (0, _multiValueContainer.MultiValueContainer),
    MultiValueLabel: (0, _multiValueLabel.MultiValueLabel),
    MultiValueRemove: (0, _multiValueRemove.MultiValueRemove),
    Option: (0, _optionDefault.default),
    Placeholder: (0, _placeholderDefault.default),
    SelectContainer: (0, _selectContainer.SelectContainer),
    SingleValue: (0, _singleValueDefault.default),
    ValueContainer: (0, _valueContainer.ValueContainer)
};
var defaultComponents = function(props) {
    return (0, _objectSpread._)({}, components, props.components);
};

},{"@swc/helpers/_/_object_spread":"9gdrV","./containers/indicators-container":"gMRac","./containers/multi-value-container":"h73TH","./containers/select-container":"jCvlw","./containers/value-container":"aK5lK","./control":"kC006","./group":"4SCh0","./group-heading":"2lJZI","./indicators/clear-indicator":"k59Wa","./indicators/dropdown-indicator":"9GmVF","./indicators/loading-indicator":"kM50n","./input":"4bU89","./menu":"23EbI","./menu-list":"bIoeb","./menu-loading-message":"90g1m","./menu-no-options-message":"4LLin","./menu-portal":"fY1Xy","./multi-value":"luFyw","./multi-value-label":"7EdfH","./multi-value-remove":"jaa70","./option":"bYPP3","./placeholder":"kdNMr","./single-value":"TnCuu","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gMRac":[function(require,module,exports,__globalThis) {
/* indicators-container.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IndicatorsContainer", function() {
    return IndicatorsContainer;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _react1 = require("@compiled/react");
var _getStyleProps = require("../../get-style-props");
var indicatorContainerStyles = null;
var IndicatorsContainer = function(props) {
    var children = props.children, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps1 = (0, _getStyleProps.getStyleProps)(props, 'indicatorsContainer', {
        indicators: true
    }), css = _getStyleProps1.css, className = _getStyleProps1.className;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, _runtime.ax)([
            "_1e0c1txw _4cvr1h6o _1o9zidpf _1wpz1fhb _y4ti1b66",
            (0, _react1.cx)(className, xcss, '-IndicatorsContainer')
        ])
    }, innerProps), {
        children: children
    }));
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@compiled/react":"MfI9Z","../../get-style-props":"aedDQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aedDQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getStyleProps", function() {
    return getStyleProps;
});
var getStyleProps = function(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"h73TH":[function(require,module,exports,__globalThis) {
/* multi-value-container.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MultiValueContainer", function() {
    return MultiValueContainer;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _react1 = require("@compiled/react");
var multiValueStyles = {
    root: "_2rko12b0 _1h6d14je _1dqonqa1 _189ee4h9 _1e0c1txw _1ul9ze3t _1pfhv77o _12l2v77o _6rthv77o _ahbqv77o _bfhk1j9a _p12f1osq _syazi7uo _3yq3glyw",
    disabled: "_syaz1gmx _bfhki8nm",
    focused: "_syaz6x5g _bfhk15s3 _16qs1xv8 _1aewe4h9 _6up51j28 _1xdnnqa1"
};
var MultiValueContainer = function(param) {
    var children = param.children, innerProps = param.innerProps, isFocused = param.isFocused, isDisabled = param.isDisabled, className = param.className, xcss = param.xcss;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, innerProps), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, _runtime.ax)([
            multiValueStyles.root,
            isDisabled && multiValueStyles.disabled,
            isFocused && multiValueStyles.focused,
            (0, _react1.cx)(className, xcss, '-multiValue')
        ]),
        children: children
    }));
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@compiled/react":"MfI9Z","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jCvlw":[function(require,module,exports,__globalThis) {
/* select-container.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SelectContainer", function() {
    return SelectContainer;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _react1 = require("@compiled/react");
var _getStyleProps = require("../../get-style-props");
var containerStyles = {
    default: "_11c81d4k _kqswh2mm _lcxv1rj4 _1tn2fhey",
    rtl: "_1eim1xrj",
    disabled: "_80om13gf"
};
var SelectContainer = function(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl, xcss = props.xcss;
    var _getStyleProps1 = (0, _getStyleProps.getStyleProps)(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), className = _getStyleProps1.className, css = _getStyleProps1.css;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, _runtime.ax)([
            containerStyles.default,
            isRtl && containerStyles.rtl,
            isDisabled && containerStyles.disabled,
            (0, _react1.cx)(className, xcss, '-container')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css
    }, innerProps), {
        children: children
    }));
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@compiled/react":"MfI9Z","../../get-style-props":"aedDQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aK5lK":[function(require,module,exports,__globalThis) {
/* value-container.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ValueContainer", function() {
    return ValueContainer;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _react1 = require("@compiled/react");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _getStyleProps = require("../../get-style-props");
var valueContainerStyles = {
    default: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _4cvr1h6o _1e0c11p5 _1n261g80 _8am5i4x0 _kqswh2mm _y4ti12x7 _bozg12x7",
    verticalPaddingStandard: "_1q51v77o _85i5v77o",
    verticalPaddingTagUpliftMulti: "_1q511b66 _85i51b66",
    verticalPaddingTagUpliftCompactMulti: "_1q51v77o _85i5v77o",
    verticalPaddingCompactNonUplift: "_1q51ze3t _85i5ze3t",
    flex: "_1e0c1txw",
    flexWithGap: "_zulp1b66 _1e0c1txw _1n261g80"
};
var ValueContainer = function(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue, isCompact = props.isCompact, xcss = props.xcss, controlShouldRenderValue = props.selectProps.controlShouldRenderValue;
    var _getStyleProps1 = (0, _getStyleProps.getStyleProps)(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), css = _getStyleProps1.css, className = _getStyleProps1.className;
    var ffTagUplifts = (0, _platformFeatureFlags.fg)('platform-dst-lozenge-tag-badge-visual-uplifts');
    var tagUpliftMultiVertical = ffTagUplifts && isMulti;
    var tagUpliftChipRow = ffTagUplifts && isMulti && hasValue && controlShouldRenderValue;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, _runtime.ax)([
            valueContainerStyles.default,
            tagUpliftMultiVertical && isCompact && valueContainerStyles.verticalPaddingTagUpliftCompactMulti,
            tagUpliftMultiVertical && !isCompact && valueContainerStyles.verticalPaddingTagUpliftMulti,
            !tagUpliftMultiVertical && !isCompact && valueContainerStyles.verticalPaddingStandard,
            !tagUpliftMultiVertical && isCompact && valueContainerStyles.verticalPaddingCompactNonUplift,
            isMulti && hasValue && controlShouldRenderValue && valueContainerStyles.flex,
            tagUpliftChipRow && valueContainerStyles.flexWithGap,
            (0, _react1.cx)(className, xcss, '-ValueContainer')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css
    }, innerProps), {
        children: children
    }));
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@compiled/react":"MfI9Z","@atlaskit/platform-feature-flags":"kO5t9","../../get-style-props":"aedDQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kC006":[function(require,module,exports,__globalThis) {
/* control.tsx generated by @compiled/babel-plugin v0.39.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _react1 = require("@compiled/react");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _getStyleProps = require("../get-style-props");
var styles = {
    default: "_12ji1r31 _1qu2glyw _12y3idpf _2rkofajl _v564r5cv _1h6drsbi _1dqonqa1 _189ee4h9 _4cvr1h6o _80om73ad _1e0c1txw _1n261g80 _1bah1yb4 _kqswh2mm _bfhk1j9a _1tke1ylp _1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _15peftgi _1ke8ftgi _jaboglyw _1u6luvb6 _4cvxrsbi _123byq51 _d0altlke _irr3l4ek _1ogl1caj",
    defaultT26Shape: "_2rko1qi0",
    compact: "_1tkezwfg",
    invalid: "_1h6d1bqt _16qsizbr _1u6lizbr _4cvx1bqt",
    focusedInvalid: "_16qsvyy1",
    disabled: "_1h6dby5v _lcxvglyw _bfhkby5v _1u6l1s3b",
    focused: "_1h6d1v1w _bfhkr01l _16qsvyy1 _1u6lvyy1 _4cvx1v1w _irr3r01l",
    subtle: "_1h6d1j28 _bfhk1j28 _1u6l3sij",
    subtleFocused: "_bfhkvuon",
    none: "_1h6d1j28 _bfhk1j28 _1u6l3sij _4cvx1j28 _irr31j28"
};
var Control = function(props) {
    var children = props.children, appearance = props.appearance, isCompact = props.isCompact, isDisabled = props.isDisabled, isFocused = props.isFocused, isInvalid = props.isInvalid, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen, xcss = props.xcss;
    var _getStyleProps1 = (0, _getStyleProps.getStyleProps)(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), css = _getStyleProps1.css, className = _getStyleProps1.className;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, _runtime.ax)([
            styles.default,
            (0, _platformFeatureFlags.fg)('platform-dst-shape-theme-default') && styles.defaultT26Shape,
            isDisabled && styles.disabled,
            isInvalid && styles.invalid,
            isCompact && styles.compact,
            appearance === 'subtle' && styles.subtle,
            appearance === 'subtle' && isFocused && styles.subtleFocused,
            isFocused && styles.focused,
            appearance === 'none' && styles.none,
            (0, _react1.cx)(className, xcss, '-control')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css
    }, innerProps), {
        "aria-disabled": isDisabled || undefined,
        children: children
    }));
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = Control;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@compiled/react":"MfI9Z","@atlaskit/platform-feature-flags":"kO5t9","../get-style-props":"aedDQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4SCh0":[function(require,module,exports,__globalThis) {
/* group.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _react1 = require("@compiled/react");
var _getStyleProps = require("../get-style-props");
var styles = {
    root: "_85i5u2gc _1q51u2gc"
};
var Group = function(props) {
    var children = props.children, builtinCX = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, selectProps = props.selectProps, xcss = props.xcss;
    var _getStyleProps1 = (0, _getStyleProps.getStyleProps)(props, 'group', {
        group: true
    }), css = _getStyleProps1.css, className = _getStyleProps1.className;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css
    }, innerProps), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, _runtime.ax)([
            styles.root,
            (0, _react1.cx)(className, xcss, innerProps === null || innerProps === void 0 ? void 0 : innerProps.className, '-Group')
        ]),
        children: [
            label && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Heading, (0, _objectSpreadProps._)((0, _objectSpread._)({}, headingProps), {
                selectProps: selectProps,
                getStyles: getStyles,
                getClassNames: getClassNames,
                cx: builtinCX,
                children: label
            })),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: children
            })
        ]
    }));
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = Group;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@compiled/react":"MfI9Z","../get-style-props":"aedDQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2lJZI":[function(require,module,exports,__globalThis) {
/* group-heading.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GroupHeading", function() {
    return GroupHeading;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _react1 = require("@compiled/react");
var _getStyleProps = require("../get-style-props");
var _cleanCommonProps = require("../internal/clean-common-props");
var headingStyles = null;
var GroupHeading = function(props) {
    var xcss = props.xcss;
    var _cleanCommonProps1 = (0, _cleanCommonProps.cleanCommonProps)(props), data = _cleanCommonProps1.data, innerProps = (0, _objectWithoutProperties._)(_cleanCommonProps1, [
        "data"
    ]);
    var _getStyleProps1 = (0, _getStyleProps.getStyleProps)(props, 'groupHeading', {
        'group-heading': true
    }), css = _getStyleProps1.css, className = _getStyleProps1.className;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpread._)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, _runtime.ax)([
            "_11c8wadc _1e0c1ule _syazazsu _80om73ad _k48pwu06 _6rthpd1z _y4tiutpp _bozgutpp _1p1dglyw",
            (0, _react1.cx)(className, xcss, '-group')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css
    }, innerProps));
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_without_properties":"6HqIM","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@compiled/react":"MfI9Z","../get-style-props":"aedDQ","../internal/clean-common-props":"dz9UW","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dz9UW":[function(require,module,exports,__globalThis) {
// Clean Common Props
// ==============================
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cleanCommonProps", function() {
    return cleanCommonProps;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var cleanCommonProps = function(props) {
    //className
    var className = props.className, clearValue = props.clearValue, cx = props.cx, xcss = props.xcss, getStyles = props.getStyles, getClassNames = props.getClassNames, getValue = props.getValue, hasValue = props.hasValue, isMulti = props.isMulti, isRtl = props.isRtl, options = props.options, selectOption = props.selectOption, selectProps = props.selectProps, setValue = props.setValue, innerProps = (0, _objectWithoutProperties._)(props, [
        "className",
        "clearValue",
        "cx",
        "xcss",
        "getStyles",
        "getClassNames",
        "getValue",
        "hasValue",
        "isMulti",
        "isRtl",
        "options",
        "selectOption",
        "selectProps",
        "setValue"
    ]);
    return (0, _objectSpread._)({}, innerProps);
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_without_properties":"6HqIM","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"k59Wa":[function(require,module,exports,__globalThis) {
/* clear-indicator.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClearIndicator", function() {
    return ClearIndicator;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _react1 = require("@compiled/react");
var _crossCircle = require("@atlaskit/icon/core/cross-circle");
var _crossCircleDefault = parcelHelpers.interopDefault(_crossCircle);
var _compiled = require("@atlaskit/primitives/compiled");
var _getStyleProps = require("../../get-style-props");
var iconContainerStyles = {
    root: "_kkk2n7od _12ji1r31 _1qu219ly _12y31o36 _1e0c1txw _4cvr1h6o _1bah1h6o _1q51v77o _y4tiv77o _85i5v77o _bozgv77o"
};
var clearIndicatorStyles = {
    default: "_v564vrg3 _1e0c1txw _syaz1rpy _1q5112x7 _y4tiv77o _85i512x7 _bozgv77o _30l3azsu",
    compact: "_1q51idpf _85i5idpf"
};
var ClearIndicator = function(props) {
    var innerProps = props.innerProps, _props_clearControlLabel = props.clearControlLabel, clearControlLabel = _props_clearControlLabel === void 0 ? 'clear' : _props_clearControlLabel, isCompact = props.isCompact, xcss = props.xcss;
    var _getStyleProps1 = (0, _getStyleProps.getStyleProps)(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), css = _getStyleProps1.css, className = _getStyleProps1.className;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, _runtime.ax)([
            clearIndicatorStyles.default,
            isCompact && clearIndicatorStyles.compact,
            (0, _react1.cx)(className, xcss, '-indicatorContainer')
        ])
    }, innerProps), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _compiled.Pressable), {
            xcss: iconContainerStyles.root,
            tabIndex: -1,
            "aria-label": clearControlLabel,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _crossCircleDefault.default), {
                label: "",
                color: "currentColor",
                size: "small"
            })
        })
    }));
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@compiled/react":"MfI9Z","@atlaskit/icon/core/cross-circle":"aVVhf","@atlaskit/primitives/compiled":"jhQE8","../../get-style-props":"aedDQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aVVhf":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3eb90e0e095210547df6d71f04e27a56>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("da3e9f8af489410f"));
var _baseNew = _interopRequireDefault(require("2e034aa4497e852e"));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ var CrossCircleIcon = function(props) {
    return /*#__PURE__*/ _react.default.createElement(_baseNew.default, Object.assign({
        name: "CrossCircleIcon",
        dangerouslySetGlyph: '<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>'
    }, props));
};
CrossCircleIcon.displayName = 'CrossCircleIcon';
var _default = exports.default = CrossCircleIcon;

},{"da3e9f8af489410f":"ltHCL","2e034aa4497e852e":"kuGeY"}],"9GmVF":[function(require,module,exports,__globalThis) {
/* dropdown-indicator.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DropdownIndicator", function() {
    return DropdownIndicator;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _react1 = require("@compiled/react");
var _chevronDown = require("@atlaskit/icon/core/chevron-down");
var _chevronDownDefault = parcelHelpers.interopDefault(_chevronDown);
var _compiled = require("@atlaskit/primitives/compiled");
var _getStyleProps = require("../../get-style-props");
var dropdownWrapperStyles = {
    root: "_1q5112x7 _y4ti12x7 _85i512x7 _bozg12x7"
};
var dropdownStyles = {
    default: "_v564vrg3 _1e0c1txw _syazazsu _1q5112x7 _y4tiv77o _85i512x7 _bozgv77o _30l3azsu",
    compact: "_1q51idpf _85i5idpf",
    disabled: "_syaz1gmx"
};
var DropdownIndicator = function(props) {
    var innerProps = props.innerProps, children = props.children, isDisabled = props.isDisabled, isCompact = props.isCompact, xcss = props.xcss;
    var _getStyleProps1 = (0, _getStyleProps.getStyleProps)(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), css = _getStyleProps1.css, className = _getStyleProps1.className;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, _runtime.ax)([
            dropdownStyles.default,
            isDisabled && dropdownStyles.disabled,
            isCompact && dropdownStyles.compact,
            (0, _react1.cx)(className, xcss, '-indicatorContainer')
        ])
    }, innerProps), {
        children: children ? children : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _compiled.Inline), {
            as: "span",
            xcss: dropdownWrapperStyles.root,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chevronDownDefault.default), {
                color: "currentColor",
                label: "open",
                size: "small"
            })
        })
    }));
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@compiled/react":"MfI9Z","@atlaskit/icon/core/chevron-down":"6b1ia","@atlaskit/primitives/compiled":"jhQE8","../../get-style-props":"aedDQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kM50n":[function(require,module,exports,__globalThis) {
/* loading-indicator.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LoadingIndicator", function() {
    return LoadingIndicator;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _react1 = require("@compiled/react");
var _spinner = require("@atlaskit/spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _getStyleProps = require("../../get-style-props");
var loadingIndicatorStyles = {
    default: "_1q5112x7 _y4tiu2gc _85i512x7 _bozgu2gc",
    compact: "_1q51idpf _85i5idpf"
};
var LoadingIndicator = function(_param) {
    var innerProps = _param.innerProps, isRtl = _param.isRtl, _param_size = _param.size, size = _param_size === void 0 ? 4 : _param_size, isCompact = _param.isCompact, xcss = _param.xcss, restProps = (0, _objectWithoutProperties._)(_param, [
        "innerProps",
        "isRtl",
        "size",
        "isCompact",
        "xcss"
    ]);
    var _getStyleProps1 = (0, _getStyleProps.getStyleProps)((0, _objectSpreadProps._)((0, _objectSpread._)({}, restProps), {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), css = _getStyleProps1.css, className = _getStyleProps1.className;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, _runtime.ax)([
            loadingIndicatorStyles.default,
            isCompact && loadingIndicatorStyles.compact,
            (0, _react1.cx)(className, xcss, '-loadingIndicator')
        ])
    }, innerProps), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {
            size: "small"
        })
    }));
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@compiled/react":"MfI9Z","@atlaskit/spinner":"04ZYE","../../get-style-props":"aedDQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4bU89":[function(require,module,exports,__globalThis) {
/* input.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _react1 = require("@compiled/react");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _getStyleProps = require("../get-style-props");
var _cleanCommonProps = require("../internal/clean-common-props");
var inputStylesOld = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _1e0c1n7u _yv0e12qd _syazi7uo _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq",
    labellingFFStyles: "_11c8wadc _1mouze3t _195gze3t _1rjcze3t"
};
var inputStyles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _kqswh2mm _1e0c1txw _yv0e12qd _syazi7uo _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq",
    labellingFFStyles: "_11c8wadc _1mouze3t _195gze3t _1rjcze3t"
};
var nativeInputStylesOld = null;
var nativeInputStyles = null;
var hidden = null;
var Input = function(props) {
    var builtinCX = props.cx, value = props.value, xcss = props.xcss, isMulti = props.isMulti;
    var _cleanCommonProps1 = (0, _cleanCommonProps.cleanCommonProps)(props), innerRef = _cleanCommonProps1.innerRef, isDisabled = _cleanCommonProps1.isDisabled, isHidden = _cleanCommonProps1.isHidden, inputClassName = _cleanCommonProps1.inputClassName, testId = _cleanCommonProps1.testId, innerProps = (0, _objectWithoutProperties._)(_cleanCommonProps1, [
        "innerRef",
        "isDisabled",
        "isHidden",
        "inputClassName",
        "testId"
    ]);
    var dataId = testId ? "".concat(testId, "-select--input") : null;
    var _getStyleProps1 = (0, _getStyleProps.getStyleProps)(props, 'input', {
        'input-container': true
    }), css = _getStyleProps1.css, className = _getStyleProps1.className;
    var ffTagUplifts = (0, _platformFeatureFlags.fg)('platform-dst-lozenge-tag-badge-visual-uplifts');
    if ((0, _platformFeatureFlags.fg)('platform_fix_input_component_styling')) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, _runtime.ax)([
            inputStyles.root,
            isMulti && ffTagUplifts && inputStyles.labellingFFStyles,
            isDisabled && inputStyles.disabled,
            (0, _react1.cx)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && "".concat(dataId, "-container"),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", (0, _objectSpread._)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, _runtime.ax)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1r04idpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _kqswstnw _syaz1kw7 _tzy4kb7n",
                isHidden && "_tzy4idpf",
                builtinCX({
                    input: true
                }, inputClassName, '-input')
            ]),
            ref: innerRef,
            disabled: isDisabled,
            "data-testid": dataId
        }, innerProps))
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, _runtime.ax)([
            inputStylesOld.root,
            isMulti && ffTagUplifts && inputStylesOld.labellingFFStyles,
            isDisabled && inputStylesOld.disabled,
            (0, _react1.cx)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && "".concat(dataId, "-container"),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", (0, _objectSpread._)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, _runtime.ax)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _syaz1kw7 _tzy4kb7n",
                isHidden && "_tzy4idpf",
                builtinCX({
                    input: true
                }, inputClassName, '-input')
            ]),
            ref: innerRef,
            disabled: isDisabled,
            "data-testid": dataId
        }, innerProps))
    });
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = Input;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_without_properties":"6HqIM","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@compiled/react":"MfI9Z","@atlaskit/platform-feature-flags":"kO5t9","../get-style-props":"aedDQ","../internal/clean-common-props":"dz9UW","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"23EbI":[function(require,module,exports,__globalThis) {
/* menu.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _react1 = require("@compiled/react");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _getStyleProps = require("../get-style-props");
var menuStyles = {
    root: "_2rko12b0 _kqswstnw _1bsb1osq _1pbykb7n _6rthu2gc _1pfhu2gc _bfhk1bhr _16qs130s",
    rootT26Shape: "_2rko1mok",
    bottom: "_152t1osq",
    top: "_u7co1osq"
};
var Menu = function(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps, _props_placement = props.placement, placement = _props_placement === void 0 ? 'bottom' : _props_placement, xcss = props.xcss;
    var _getStyleProps1 = (0, _getStyleProps.getStyleProps)(props, 'menu', {
        menu: true
    }), css = _getStyleProps1.css, className = _getStyleProps1.className;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, _runtime.ax)([
            menuStyles.root,
            menuStyles[placement],
            (0, _platformFeatureFlags.fg)('platform-dst-shape-theme-default') && menuStyles.rootT26Shape,
            (0, _react1.cx)(xcss, className, '-menu')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ref: innerRef
    }, innerProps), {
        children: children
    }));
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = Menu;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@compiled/react":"MfI9Z","@atlaskit/platform-feature-flags":"kO5t9","../get-style-props":"aedDQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bIoeb":[function(require,module,exports,__globalThis) {
/* menu-list.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MenuList", function() {
    return MenuList;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _react1 = require("@compiled/react");
var _getStyleProps = require("../get-style-props");
var menuListStyles = null;
var MenuList = function(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti, maxHeight = props.maxHeight, xcss = props.xcss;
    var _getStyleProps1 = (0, _getStyleProps.getStyleProps)(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), css = _getStyleProps1.css, className = _getStyleProps1.className;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, _runtime.ax)([
            "_kqswh2mm _18m91wug _85i5u2gc _1q51u2gc _8am5i4x0",
            (0, _react1.cx)(className, xcss, '-MenuList')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: (0, _objectSpreadProps._)((0, _objectSpread._)({}, css), {
            maxHeight: maxHeight
        }),
        ref: innerRef
    }, innerProps), {
        tabIndex: -1,
        children: children
    }));
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@compiled/react":"MfI9Z","../get-style-props":"aedDQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"90g1m":[function(require,module,exports,__globalThis) {
/* menu-loading-message.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LoadingMessage", function() {
    return LoadingMessage;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _react1 = require("@compiled/react");
var _compiled = require("@atlaskit/primitives/compiled");
var _getStyleProps = require("../get-style-props");
var noticeStyles = null;
var LoadingMessage = function(_param) {
    var _param_children = _param.children, children = _param_children === void 0 ? 'Loading...' : _param_children, innerProps = _param.innerProps, xcss = _param.xcss, restProps = (0, _objectWithoutProperties._)(_param, [
        "children",
        "innerProps",
        "xcss"
    ]);
    var _getStyleProps1 = (0, _getStyleProps.getStyleProps)((0, _objectSpreadProps._)((0, _objectSpread._)({}, restProps), {
        children: children,
        innerProps: innerProps
    }), 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), css = _getStyleProps1.css, className = _getStyleProps1.className;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, _runtime.ax)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, _react1.cx)(className, xcss, '-LoadingMessage')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css
    }, innerProps), {
        // eslint-disable-next-line @atlassian/a11y/role-has-required-aria-props
        role: "option",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _compiled.Text), {
            color: "color.text.subtle",
            children: children
        })
    }));
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@compiled/react":"MfI9Z","@atlaskit/primitives/compiled":"jhQE8","../get-style-props":"aedDQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4LLin":[function(require,module,exports,__globalThis) {
/* menu-no-options-message.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NoOptionsMessage", function() {
    return NoOptionsMessage;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _react1 = require("@compiled/react");
var _compiled = require("@atlaskit/primitives/compiled");
var _getStyleProps = require("../get-style-props");
var noticeStyles = null;
var NoOptionsMessage = function(_param) {
    var _param_children = _param.children, children = _param_children === void 0 ? 'No options' : _param_children, innerProps = _param.innerProps, xcss = _param.xcss, restProps = (0, _objectWithoutProperties._)(_param, [
        "children",
        "innerProps",
        "xcss"
    ]);
    var _getStyleProps1 = (0, _getStyleProps.getStyleProps)((0, _objectSpreadProps._)((0, _objectSpread._)({}, restProps), {
        children: children,
        innerProps: innerProps
    }), 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), css = _getStyleProps1.css, className = _getStyleProps1.className;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, _runtime.ax)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, _react1.cx)(className, xcss, '-NoOptionsMessage')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlassian/a11y/role-has-required-aria-props
        role: "option"
    }, innerProps), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _compiled.Text), {
            color: "color.text.subtle",
            children: children
        })
    }));
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@compiled/react":"MfI9Z","@atlaskit/primitives/compiled":"jhQE8","../get-style-props":"aedDQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fY1Xy":[function(require,module,exports,__globalThis) {
/* menu-portal.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MenuPortal", function() {
    return MenuPortal;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _react1 = require("@compiled/react");
var _dom = require("@floating-ui/dom");
var _reactDom = require("react-dom");
var _getStyleProps = require("../get-style-props");
var _portalPlacementContext = require("../internal/portal-placement-context");
function getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
var coercePlacement = function(p) {
    return p === 'auto' ? 'bottom' : p;
};
var menuPortalStyles = {
    root: "_1pbykb7n _1e02a1vk _kqswcp1v _152t1nmo _1bsb1qxj"
};
var MenuPortal = function(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, xcss = props.xcss;
    var menuPortalRef = (0, _react.useRef)(null);
    var cleanupRef = (0, _react.useRef)(null);
    var _useState = (0, _slicedToArray._)((0, _react.useState)(coercePlacement(menuPlacement)), 2), placement = _useState[0], setPortalPlacement = _useState[1];
    var portalPlacementContext = (0, _react.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(null), 2), computedPosition = _useState1[0], setComputedPosition = _useState1[1];
    var updateComputedPosition = (0, _react.useCallback)(function() {
        if (!controlElement) return;
        var rect = getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, _react.useLayoutEffect)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, _react.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, _dom.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, _react.useLayoutEffect)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, _react.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    var _getStyleProps1 = (0, _getStyleProps.getStyleProps)((0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), css = _getStyleProps1.css, className = _getStyleProps1.className;
    // same wrapper element whether fixed or portalled
    var menuWrapper = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, _runtime.ax)([
            menuPortalStyles.root,
            (0, _react1.cx)(className, xcss, '-MenuPortal')
        ]),
        ref: setMenuPortalElement,
        style: (0, _objectSpread._)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            '--menu-left': "".concat(computedPosition.rect.left, "px"),
            '--menu-position': menuPosition,
            '--menu-top': "".concat(computedPosition.offset, "px"),
            '--menu-width': "".concat(computedPosition.rect.width, "px")
        }, css)
    }, innerProps), {
        children: children
    }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _portalPlacementContext.PortalPlacementContext).Provider, {
        value: portalPlacementContext,
        children: appendTo ? /*#__PURE__*/ (0, _reactDom.createPortal)(menuWrapper, appendTo) : menuWrapper
    });
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_sliced_to_array":"8PtL6","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@compiled/react":"MfI9Z","@floating-ui/dom":"3zrVe","react-dom":"bvX0P","../get-style-props":"aedDQ","../internal/portal-placement-context":"cDq7E","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3zrVe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOverflowAncestors", function() {
    return 0, _dom.getOverflowAncestors;
});
parcelHelpers.export(exports, "arrow", function() {
    return arrow;
});
parcelHelpers.export(exports, "autoPlacement", function() {
    return autoPlacement;
});
parcelHelpers.export(exports, "autoUpdate", function() {
    return autoUpdate;
});
parcelHelpers.export(exports, "computePosition", function() {
    return computePosition;
});
parcelHelpers.export(exports, "detectOverflow", function() {
    return detectOverflow;
});
parcelHelpers.export(exports, "flip", function() {
    return flip;
});
parcelHelpers.export(exports, "hide", function() {
    return hide;
});
parcelHelpers.export(exports, "inline", function() {
    return inline;
});
parcelHelpers.export(exports, "limitShift", function() {
    return limitShift;
});
parcelHelpers.export(exports, "offset", function() {
    return offset;
});
parcelHelpers.export(exports, "platform", function() {
    return platform;
});
parcelHelpers.export(exports, "shift", function() {
    return shift;
});
parcelHelpers.export(exports, "size", function() {
    return size;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _core = require("@floating-ui/core");
var _utils = require("@floating-ui/utils");
var _dom = require("@floating-ui/utils/dom");
function getCssDimensions(element) {
    var css = (0, _dom.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    var width = parseFloat(css.width) || 0;
    var height = parseFloat(css.height) || 0;
    var hasOffset = (0, _dom.isHTMLElement)(element);
    var offsetWidth = hasOffset ? element.offsetWidth : width;
    var offsetHeight = hasOffset ? element.offsetHeight : height;
    var shouldFallback = (0, _utils.round)(width) !== offsetWidth || (0, _utils.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function unwrapElement(element) {
    return !(0, _dom.isElement)(element) ? element.contextElement : element;
}
function getScale(element) {
    var domElement = unwrapElement(element);
    if (!(0, _dom.isHTMLElement)(domElement)) return (0, _utils.createCoords)(1);
    var rect = domElement.getBoundingClientRect();
    var _getCssDimensions = getCssDimensions(domElement), width = _getCssDimensions.width, height = _getCssDimensions.height, $ = _getCssDimensions.$;
    var x = ($ ? (0, _utils.round)(rect.width) : rect.width) / width;
    var y = ($ ? (0, _utils.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
var noOffsets = /*#__PURE__*/ (0, _utils.createCoords)(0);
function getVisualOffsets(element) {
    var win = (0, _dom.getWindow)(element);
    if (!(0, _dom.isWebKit)() || !win.visualViewport) return noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, _dom.getWindow)(element)) return false;
    return isFixed;
}
function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var domElement = unwrapElement(element);
    var scale = (0, _utils.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, _dom.isElement)(offsetParent)) scale = getScale(offsetParent);
        } else scale = getScale(element);
    }
    var visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : (0, _utils.createCoords)(0);
    var x = (clientRect.left + visualOffsets.x) / scale.x;
    var y = (clientRect.top + visualOffsets.y) / scale.y;
    var width = clientRect.width / scale.x;
    var height = clientRect.height / scale.y;
    if (domElement) {
        var win = (0, _dom.getWindow)(domElement);
        var offsetWin = offsetParent && (0, _dom.isElement)(offsetParent) ? (0, _dom.getWindow)(offsetParent) : offsetParent;
        var currentWin = win;
        var currentIFrame = (0, _dom.getFrameElement)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            var iframeScale = getScale(currentIFrame);
            var iframeRect = currentIFrame.getBoundingClientRect();
            var css = (0, _dom.getComputedStyle)(currentIFrame);
            var left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            var top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, _dom.getWindow)(currentIFrame);
            currentIFrame = (0, _dom.getFrameElement)(currentWin);
        }
    }
    return (0, _core.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function getWindowScrollBarX(element, rect) {
    var leftScroll = (0, _dom.getNodeScroll)(element).scrollLeft;
    if (!rect) return getBoundingClientRect((0, _dom.getDocumentElement)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function getHTMLOffset(documentElement, scroll) {
    var htmlRect = documentElement.getBoundingClientRect();
    var x = htmlRect.left + scroll.scrollLeft - getWindowScrollBarX(documentElement, htmlRect);
    var y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    var elements = _ref.elements, rect = _ref.rect, offsetParent = _ref.offsetParent, strategy = _ref.strategy;
    var isFixed = strategy === 'fixed';
    var documentElement = (0, _dom.getDocumentElement)(offsetParent);
    var topLayer = elements ? (0, _dom.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var scale = (0, _utils.createCoords)(1);
    var offsets = (0, _utils.createCoords)(0);
    var isOffsetParentAnElement = (0, _dom.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, _dom.getNodeName)(offsetParent) !== 'body' || (0, _dom.isOverflowElement)(documentElement)) scroll = (0, _dom.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            var offsetRect = getBoundingClientRect(offsetParent);
            scale = getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    var htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : (0, _utils.createCoords)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function getDocumentRect(element) {
    var html = (0, _dom.getDocumentElement)(element);
    var scroll = (0, _dom.getNodeScroll)(element);
    var body = element.ownerDocument.body;
    var width = (0, _utils.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    var height = (0, _utils.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    var x = -scroll.scrollLeft + getWindowScrollBarX(element);
    var y = -scroll.scrollTop;
    if ((0, _dom.getComputedStyle)(body).direction === 'rtl') x += (0, _utils.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Safety check: ensure the scrollbar space is reasonable in case this
// calculation is affected by unusual styles.
// Most scrollbars leave 15-18px of space.
var SCROLLBAR_MAX = 25;
function getViewportRect(element, strategy) {
    var win = (0, _dom.getWindow)(element);
    var html = (0, _dom.getDocumentElement)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var visualViewportBased = (0, _dom.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    var windowScrollbarX = getWindowScrollBarX(html);
    // <html> `overflow: hidden` + `scrollbar-gutter: stable` reduces the
    // visual width of the <html> but this is not considered in the size
    // of `html.clientWidth`.
    if (windowScrollbarX <= 0) {
        var doc = html.ownerDocument;
        var body = doc.body;
        var bodyStyles = getComputedStyle(body);
        var bodyMarginInline = doc.compatMode === 'CSS1Compat' ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
        var clippingStableScrollbarWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
        if (clippingStableScrollbarWidth <= SCROLLBAR_MAX) width -= clippingStableScrollbarWidth;
    } else if (windowScrollbarX <= SCROLLBAR_MAX) // If the <body> scrollbar is on the left, the width needs to be extended
    // by the scrollbar amount so there isn't extra space on the right.
    width += windowScrollbarX;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function getInnerBoundingClientRect(element, strategy) {
    var clientRect = getBoundingClientRect(element, true, strategy === 'fixed');
    var top = clientRect.top + element.clientTop;
    var left = clientRect.left + element.clientLeft;
    var scale = (0, _dom.isHTMLElement)(element) ? getScale(element) : (0, _utils.createCoords)(1);
    var width = element.clientWidth * scale.x;
    var height = element.clientHeight * scale.y;
    var x = left * scale.x;
    var y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    var rect;
    if (clippingAncestor === 'viewport') rect = getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = getDocumentRect((0, _dom.getDocumentElement)(element));
    else if ((0, _dom.isElement)(clippingAncestor)) rect = getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        var visualOffsets = getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, _core.rectToClientRect)(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
    var parentNode = (0, _dom.getParentNode)(element);
    if (parentNode === stopNode || !(0, _dom.isElement)(parentNode) || (0, _dom.isLastTraversableNode)(parentNode)) return false;
    return (0, _dom.getComputedStyle)(parentNode).position === 'fixed' || hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function getClippingElementAncestors(element, cache) {
    var cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    var result = (0, _dom.getOverflowAncestors)(element, [], false).filter(function(el) {
        return (0, _dom.isElement)(el) && (0, _dom.getNodeName)(el) !== 'body';
    });
    var currentContainingBlockComputedStyle = null;
    var elementIsFixed = (0, _dom.getComputedStyle)(element).position === 'fixed';
    var currentNode = elementIsFixed ? (0, _dom.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, _dom.isElement)(currentNode) && !(0, _dom.isLastTraversableNode)(currentNode)){
        var computedStyle = (0, _dom.getComputedStyle)(currentNode);
        var currentNodeIsContaining = (0, _dom.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        var shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && (currentContainingBlockComputedStyle.position === 'absolute' || currentContainingBlockComputedStyle.position === 'fixed') || (0, _dom.isOverflowElement)(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter(function(ancestor) {
            return ancestor !== currentNode;
        });
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, _dom.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function getClippingRect(_ref) {
    var element = _ref.element, boundary = _ref.boundary, rootBoundary = _ref.rootBoundary, strategy = _ref.strategy;
    var elementClippingAncestors = boundary === 'clippingAncestors' ? (0, _dom.isTopLayer)(element) ? [] : getClippingElementAncestors(element, this._c) : [].concat(boundary);
    var clippingAncestors = (0, _toConsumableArray._)(elementClippingAncestors).concat([
        rootBoundary
    ]);
    var firstRect = getClientRectFromClippingAncestor(element, clippingAncestors[0], strategy);
    var top = firstRect.top;
    var right = firstRect.right;
    var bottom = firstRect.bottom;
    var left = firstRect.left;
    for(var i = 1; i < clippingAncestors.length; i++){
        var rect = getClientRectFromClippingAncestor(element, clippingAncestors[i], strategy);
        top = (0, _utils.max)(rect.top, top);
        right = (0, _utils.min)(rect.right, right);
        bottom = (0, _utils.min)(rect.bottom, bottom);
        left = (0, _utils.max)(rect.left, left);
    }
    return {
        width: right - left,
        height: bottom - top,
        x: left,
        y: top
    };
}
function getDimensions(element) {
    var _getCssDimensions = getCssDimensions(element), width = _getCssDimensions.width, height = _getCssDimensions.height;
    return {
        width: width,
        height: height
    };
}
function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    var isOffsetParentAnElement = (0, _dom.isHTMLElement)(offsetParent);
    var documentElement = (0, _dom.getDocumentElement)(offsetParent);
    var isFixed = strategy === 'fixed';
    var rect = getBoundingClientRect(element, true, isFixed, offsetParent);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = (0, _utils.createCoords)(0);
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    function setLeftRTLScrollbarOffset() {
        offsets.x = getWindowScrollBarX(documentElement);
    }
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, _dom.getNodeName)(offsetParent) !== 'body' || (0, _dom.isOverflowElement)(documentElement)) scroll = (0, _dom.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            var offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) setLeftRTLScrollbarOffset();
    }
    if (isFixed && !isOffsetParentAnElement && documentElement) setLeftRTLScrollbarOffset();
    var htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : (0, _utils.createCoords)(0);
    var x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    var y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function isStaticPositioned(element) {
    return (0, _dom.getComputedStyle)(element).position === 'static';
}
function getTrueOffsetParent(element, polyfill) {
    if (!(0, _dom.isHTMLElement)(element) || (0, _dom.getComputedStyle)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    var rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, _dom.getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function getOffsetParent(element, polyfill) {
    var win = (0, _dom.getWindow)(element);
    if ((0, _dom.isTopLayer)(element)) return win;
    if (!(0, _dom.isHTMLElement)(element)) {
        var svgOffsetParent = (0, _dom.getParentNode)(element);
        while(svgOffsetParent && !(0, _dom.isLastTraversableNode)(svgOffsetParent)){
            if ((0, _dom.isElement)(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, _dom.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    var offsetParent = getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, _dom.isTableElement)(offsetParent) && isStaticPositioned(offsetParent))offsetParent = getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, _dom.isLastTraversableNode)(offsetParent) && isStaticPositioned(offsetParent) && !(0, _dom.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, _dom.getContainingBlock)(element) || win;
}
var getElementRects = function getElementRects(data) {
    return (0, _asyncToGenerator._)(function() {
        var getOffsetParentFn, getDimensionsFn, floatingDimensions, _tmp, _tmp1;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    getOffsetParentFn = this.getOffsetParent || getOffsetParent;
                    getDimensionsFn = this.getDimensions;
                    return [
                        4,
                        getDimensionsFn(data.floating)
                    ];
                case 1:
                    floatingDimensions = _state.sent();
                    _tmp = {};
                    _tmp1 = [
                        data.reference
                    ];
                    return [
                        4,
                        getOffsetParentFn(data.floating)
                    ];
                case 2:
                    return [
                        2,
                        (_tmp.reference = getRectRelativeToOffsetParent.apply(void 0, _tmp1.concat([
                            _state.sent(),
                            data.strategy
                        ])), _tmp.floating = {
                            x: 0,
                            y: 0,
                            width: floatingDimensions.width,
                            height: floatingDimensions.height
                        }, _tmp)
                    ];
            }
        });
    }).call(this);
};
function isRTL(element) {
    return (0, _dom.getComputedStyle)(element).direction === 'rtl';
}
var platform = {
    convertOffsetParentRelativeRectToViewportRelativeRect: convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: (0, _dom.getDocumentElement),
    getClippingRect: getClippingRect,
    getOffsetParent: getOffsetParent,
    getElementRects: getElementRects,
    getClientRects: getClientRects,
    getDimensions: getDimensions,
    getScale: getScale,
    isElement: (0, _dom.isElement),
    isRTL: isRTL
};
function rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function observeMove(element, onMove) {
    var io = null;
    var timeoutId;
    var root = (0, _dom.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        var elementRectForRootMargin = element.getBoundingClientRect();
        var left = elementRectForRootMargin.left, top = elementRectForRootMargin.top, width = elementRectForRootMargin.width, height = elementRectForRootMargin.height;
        if (!skip) onMove();
        if (!width || !height) return;
        var insetTop = (0, _utils.floor)(top);
        var insetRight = (0, _utils.floor)(root.clientWidth - (left + width));
        var insetBottom = (0, _utils.floor)(root.clientHeight - (top + height));
        var insetLeft = (0, _utils.floor)(left);
        var rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        var options = {
            rootMargin: rootMargin,
            threshold: (0, _utils.max)(0, (0, _utils.min)(1, threshold)) || 1
        };
        var isFirstUpdate = true;
        function handleObserve(entries) {
            var ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(function() {
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, (0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
                // Handle <iframe>s
                root: root.ownerDocument
            }));
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function autoUpdate(reference, floating, update, options) {
    if (options === void 0) options = {};
    var _options_ancestorScroll = options.ancestorScroll, ancestorScroll = _options_ancestorScroll === void 0 ? true : _options_ancestorScroll, _options_ancestorResize = options.ancestorResize, ancestorResize = _options_ancestorResize === void 0 ? true : _options_ancestorResize, _options_elementResize = options.elementResize, elementResize = _options_elementResize === void 0 ? typeof ResizeObserver === 'function' : _options_elementResize, _options_layoutShift = options.layoutShift, layoutShift = _options_layoutShift === void 0 ? typeof IntersectionObserver === 'function' : _options_layoutShift, _options_animationFrame = options.animationFrame, animationFrame = _options_animationFrame === void 0 ? false : _options_animationFrame;
    var referenceEl = unwrapElement(reference);
    var ancestors = ancestorScroll || ancestorResize ? (0, _toConsumableArray._)(referenceEl ? (0, _dom.getOverflowAncestors)(referenceEl) : []).concat((0, _toConsumableArray._)(floating ? (0, _dom.getOverflowAncestors)(floating) : [])) : [];
    ancestors.forEach(function(ancestor) {
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    var cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
    var reobserveFrame = -1;
    var resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver(function(_ref) {
            var _$_ref = (0, _slicedToArray._)(_ref, 1), firstEntry = _$_ref[0];
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver && floating) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(function() {
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        if (floating) resizeObserver.observe(floating);
    }
    var frameId;
    var prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        var nextRefRect = getBoundingClientRect(reference);
        if (prevRefRect && !rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return function() {
        var _resizeObserver2;
        ancestors.forEach(function(ancestor) {
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ var detectOverflow = (0, _core.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ var offset = (0, _core.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ var autoPlacement = (0, _core.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ var shift = (0, _core.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ var flip = (0, _core.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ var size = (0, _core.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ var hide = (0, _core.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ var arrow = (0, _core.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ var inline = (0, _core.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ var limitShift = (0, _core.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ var computePosition = function(reference, floating, options) {
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    var cache = new Map();
    var mergedOptions = (0, _objectSpread._)({
        platform: platform
    }, options);
    var platformWithCache = (0, _objectSpreadProps._)((0, _objectSpread._)({}, mergedOptions.platform), {
        _c: cache
    });
    return (0, _core.computePosition)(reference, floating, (0, _objectSpreadProps._)((0, _objectSpread._)({}, mergedOptions), {
        platform: platformWithCache
    }));
};

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_to_consumable_array":"1eSZf","@swc/helpers/_/_ts_generator":"78Tqx","@floating-ui/core":"7rH2T","@floating-ui/utils":"gVBaK","@floating-ui/utils/dom":"cDpKU","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7rH2T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rectToClientRect", function() {
    return 0, _utils.rectToClientRect;
});
parcelHelpers.export(exports, "arrow", function() {
    return arrow;
});
parcelHelpers.export(exports, "autoPlacement", function() {
    return autoPlacement;
});
parcelHelpers.export(exports, "computePosition", function() {
    return computePosition;
});
parcelHelpers.export(exports, "detectOverflow", function() {
    return detectOverflow;
});
parcelHelpers.export(exports, "flip", function() {
    return flip;
});
parcelHelpers.export(exports, "hide", function() {
    return hide;
});
parcelHelpers.export(exports, "inline", function() {
    return inline;
});
parcelHelpers.export(exports, "limitShift", function() {
    return limitShift;
});
parcelHelpers.export(exports, "offset", function() {
    return offset;
});
parcelHelpers.export(exports, "shift", function() {
    return shift;
});
parcelHelpers.export(exports, "size", function() {
    return size;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _utils = require("@floating-ui/utils");
function computeCoordsFromPlacement(_ref, placement, rtl) {
    var reference = _ref.reference, floating = _ref.floating;
    var sideAxis = (0, _utils.getSideAxis)(placement);
    var alignmentAxis = (0, _utils.getAlignmentAxis)(placement);
    var alignLength = (0, _utils.getAxisLength)(alignmentAxis);
    var side = (0, _utils.getSide)(placement);
    var isVertical = sideAxis === 'y';
    var commonX = reference.x + reference.width / 2 - floating.width / 2;
    var commonY = reference.y + reference.height / 2 - floating.height / 2;
    var commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    var coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, _utils.getAlignment)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ function detectOverflow(state, options) {
    return (0, _asyncToGenerator._)(function() {
        var _await$platform$isEle, x, y, platform, rects, elements, strategy, _evaluate, _evaluate_boundary, boundary, _evaluate_rootBoundary, rootBoundary, _evaluate_elementContext, elementContext, _evaluate_altBoundary, altBoundary, _evaluate_padding, padding, paddingObject, altContext, element, clippingClientRect, _, _tmp, _tmp1, _tmp2, rect, offsetParent, offsetScale, _tmp3, elementClientRect, _tmp4;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (options === void 0) options = {};
                    x = state.x, y = state.y, platform = state.platform, rects = state.rects, elements = state.elements, strategy = state.strategy;
                    _evaluate = (0, _utils.evaluate)(options, state), _evaluate_boundary = _evaluate.boundary, boundary = _evaluate_boundary === void 0 ? 'clippingAncestors' : _evaluate_boundary, _evaluate_rootBoundary = _evaluate.rootBoundary, rootBoundary = _evaluate_rootBoundary === void 0 ? 'viewport' : _evaluate_rootBoundary, _evaluate_elementContext = _evaluate.elementContext, elementContext = _evaluate_elementContext === void 0 ? 'floating' : _evaluate_elementContext, _evaluate_altBoundary = _evaluate.altBoundary, altBoundary = _evaluate_altBoundary === void 0 ? false : _evaluate_altBoundary, _evaluate_padding = _evaluate.padding, padding = _evaluate_padding === void 0 ? 0 : _evaluate_padding;
                    paddingObject = (0, _utils.getPaddingObject)(padding);
                    altContext = elementContext === 'floating' ? 'reference' : 'floating';
                    element = elements[altBoundary ? altContext : elementContext];
                    _ = platform.getClippingRect;
                    _tmp = {};
                    return [
                        4,
                        platform.isElement == null ? void 0 : platform.isElement(element)
                    ];
                case 1:
                    if (!((_await$platform$isEle = _state.sent()) != null ? _await$platform$isEle : true)) return [
                        3,
                        2
                    ];
                    _tmp1 = element;
                    return [
                        3,
                        5
                    ];
                case 2:
                    _tmp2 = element.contextElement;
                    if (_tmp2) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)
                    ];
                case 3:
                    _tmp2 = _state.sent();
                    _state.label = 4;
                case 4:
                    _tmp1 = _tmp2;
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _.apply(platform, [
                            (_tmp.element = _tmp1, _tmp.boundary = boundary, _tmp.rootBoundary = rootBoundary, _tmp.strategy = strategy, _tmp)
                        ])
                    ];
                case 6:
                    clippingClientRect = (0, _utils.rectToClientRect).apply(void 0, [
                        _state.sent()
                    ]);
                    rect = elementContext === 'floating' ? {
                        x: x,
                        y: y,
                        width: rects.floating.width,
                        height: rects.floating.height
                    } : rects.reference;
                    return [
                        4,
                        platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating)
                    ];
                case 7:
                    offsetParent = _state.sent();
                    return [
                        4,
                        platform.isElement == null ? void 0 : platform.isElement(offsetParent)
                    ];
                case 8:
                    if (!_state.sent()) return [
                        3,
                        10
                    ];
                    return [
                        4,
                        platform.getScale == null ? void 0 : platform.getScale(offsetParent)
                    ];
                case 9:
                    _tmp3 = _state.sent() || {
                        x: 1,
                        y: 1
                    };
                    return [
                        3,
                        11
                    ];
                case 10:
                    _tmp3 = {
                        x: 1,
                        y: 1
                    };
                    _state.label = 11;
                case 11:
                    offsetScale = _tmp3;
                    if (!platform.convertOffsetParentRelativeRectToViewportRelativeRect) return [
                        3,
                        13
                    ];
                    return [
                        4,
                        platform.convertOffsetParentRelativeRectToViewportRelativeRect({
                            elements: elements,
                            rect: rect,
                            offsetParent: offsetParent,
                            strategy: strategy
                        })
                    ];
                case 12:
                    _tmp4 = _state.sent();
                    return [
                        3,
                        14
                    ];
                case 13:
                    _tmp4 = rect;
                    _state.label = 14;
                case 14:
                    elementClientRect = (0, _utils.rectToClientRect).apply(void 0, [
                        _tmp4
                    ]);
                    return [
                        2,
                        {
                            top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
                            bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
                            left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
                            right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
                        }
                    ];
            }
        });
    })();
}
// Maximum number of resets that can occur before bailing to avoid infinite reset loops.
var MAX_RESET_COUNT = 50;
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ var computePosition = function(reference, floating, config) {
    return (0, _asyncToGenerator._)(function() {
        var _config_placement, placement, _config_strategy, strategy, _config_middleware, middleware, platform, platformWithDetectOverflow, rtl, rects, _computeCoordsFromPlacement, x, y, statefulPlacement, resetCount, middlewareData, i, currentMiddleware, name, fn, _ref, nextX, nextY, data, reset, _tmp, ref;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _config_placement = config.placement, placement = _config_placement === void 0 ? 'bottom' : _config_placement, _config_strategy = config.strategy, strategy = _config_strategy === void 0 ? 'absolute' : _config_strategy, _config_middleware = config.middleware, middleware = _config_middleware === void 0 ? [] : _config_middleware, platform = config.platform;
                    platformWithDetectOverflow = platform.detectOverflow ? platform : (0, _objectSpreadProps._)((0, _objectSpread._)({}, platform), {
                        detectOverflow: detectOverflow
                    });
                    return [
                        4,
                        platform.isRTL == null ? void 0 : platform.isRTL(floating)
                    ];
                case 1:
                    rtl = _state.sent();
                    return [
                        4,
                        platform.getElementRects({
                            reference: reference,
                            floating: floating,
                            strategy: strategy
                        })
                    ];
                case 2:
                    rects = _state.sent();
                    _computeCoordsFromPlacement = computeCoordsFromPlacement(rects, placement, rtl), x = _computeCoordsFromPlacement.x, y = _computeCoordsFromPlacement.y;
                    statefulPlacement = placement;
                    resetCount = 0;
                    middlewareData = {};
                    i = 0;
                    _state.label = 3;
                case 3:
                    if (!(i < middleware.length)) return [
                        3,
                        11
                    ];
                    currentMiddleware = middleware[i];
                    if (!currentMiddleware) return [
                        3,
                        10
                    ];
                    name = currentMiddleware.name, fn = currentMiddleware.fn;
                    return [
                        4,
                        fn({
                            x: x,
                            y: y,
                            initialPlacement: placement,
                            placement: statefulPlacement,
                            strategy: strategy,
                            middlewareData: middlewareData,
                            rects: rects,
                            platform: platformWithDetectOverflow,
                            elements: {
                                reference: reference,
                                floating: floating
                            }
                        })
                    ];
                case 4:
                    _ref = _state.sent(), nextX = _ref.x, nextY = _ref.y, data = _ref.data, reset = _ref.reset;
                    x = nextX != null ? nextX : x;
                    y = nextY != null ? nextY : y;
                    middlewareData[name] = (0, _objectSpread._)({}, middlewareData[name], data);
                    if (!(reset && resetCount < MAX_RESET_COUNT)) return [
                        3,
                        10
                    ];
                    resetCount++;
                    if (!((typeof reset === "undefined" ? "undefined" : (0, _typeOf._)(reset)) === 'object')) return [
                        3,
                        9
                    ];
                    if (reset.placement) statefulPlacement = reset.placement;
                    if (!reset.rects) return [
                        3,
                        8
                    ];
                    if (!(reset.rects === true)) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        platform.getElementRects({
                            reference: reference,
                            floating: floating,
                            strategy: strategy
                        })
                    ];
                case 5:
                    _tmp = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 6:
                    _tmp = reset.rects;
                    _state.label = 7;
                case 7:
                    rects = _tmp;
                    _state.label = 8;
                case 8:
                    ref = computeCoordsFromPlacement(rects, statefulPlacement, rtl), x = ref.x, y = ref.y, ref;
                    _state.label = 9;
                case 9:
                    i = -1;
                    _state.label = 10;
                case 10:
                    i++;
                    return [
                        3,
                        3
                    ];
                case 11:
                    return [
                        2,
                        {
                            x: x,
                            y: y,
                            placement: statefulPlacement,
                            strategy: strategy,
                            middlewareData: middlewareData
                        }
                    ];
            }
        });
    })();
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ var arrow = function(options) {
    return {
        name: 'arrow',
        options: options,
        fn: function fn(state) {
            return (0, _asyncToGenerator._)(function() {
                var x, y, placement, rects, platform, elements, middlewareData, _ref, element, _ref_padding, padding, paddingObject, coords, axis, length, arrowDimensions, isYAxis, minProp, maxProp, clientProp, endDiff, startDiff, arrowOffsetParent, clientSize, _tmp, centerToReference, largestPossiblePadding, minPadding, maxPadding, min$1, max, center, offset, shouldAddOffset, alignmentOffset, _obj, _obj1;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            x = state.x, y = state.y, placement = state.placement, rects = state.rects, platform = state.platform, elements = state.elements, middlewareData = state.middlewareData;
                            // Since `element` is required, we don't Partial<> the type.
                            _ref = (0, _utils.evaluate)(options, state) || {}, element = _ref.element, _ref_padding = _ref.padding, padding = _ref_padding === void 0 ? 0 : _ref_padding;
                            if (element == null) return [
                                2,
                                {}
                            ];
                            paddingObject = (0, _utils.getPaddingObject)(padding);
                            coords = {
                                x: x,
                                y: y
                            };
                            axis = (0, _utils.getAlignmentAxis)(placement);
                            length = (0, _utils.getAxisLength)(axis);
                            return [
                                4,
                                platform.getDimensions(element)
                            ];
                        case 1:
                            arrowDimensions = _state.sent();
                            isYAxis = axis === 'y';
                            minProp = isYAxis ? 'top' : 'left';
                            maxProp = isYAxis ? 'bottom' : 'right';
                            clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
                            endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
                            startDiff = coords[axis] - rects.reference[axis];
                            return [
                                4,
                                platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element)
                            ];
                        case 2:
                            arrowOffsetParent = _state.sent();
                            clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
                            _tmp = !clientSize;
                            if (_tmp) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent)
                            ];
                        case 3:
                            _tmp = !_state.sent();
                            _state.label = 4;
                        case 4:
                            // DOM platform can return `window` as the `offsetParent`.
                            if (_tmp) clientSize = elements.floating[clientProp] || rects.floating[length];
                            centerToReference = endDiff / 2 - startDiff / 2;
                            // If the padding is large enough that it causes the arrow to no longer be
                            // centered, modify the padding so that it is centered.
                            largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
                            minPadding = (0, _utils.min)(paddingObject[minProp], largestPossiblePadding);
                            maxPadding = (0, _utils.min)(paddingObject[maxProp], largestPossiblePadding);
                            // Make sure the arrow doesn't overflow the floating element if the center
                            // point is outside the floating element's bounds.
                            min$1 = minPadding;
                            max = clientSize - arrowDimensions[length] - maxPadding;
                            center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
                            offset = (0, _utils.clamp)(min$1, center, max);
                            // If the reference is small enough that the arrow's padding causes it to
                            // to point to nothing for an aligned placement, adjust the offset of the
                            // floating element itself. To ensure `shift()` continues to take action,
                            // a single reset is performed when this is true.
                            shouldAddOffset = !middlewareData.arrow && (0, _utils.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
                            alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
                            return [
                                2,
                                (_obj1 = {}, (0, _defineProperty._)(_obj1, axis, coords[axis] + alignmentOffset), (0, _defineProperty._)(_obj1, "data", (0, _objectSpread._)((_obj = {}, (0, _defineProperty._)(_obj, axis, offset), (0, _defineProperty._)(_obj, "centerOffset", center - offset - alignmentOffset), _obj), shouldAddOffset && {
                                    alignmentOffset: alignmentOffset
                                })), (0, _defineProperty._)(_obj1, "reset", shouldAddOffset), _obj1)
                            ];
                    }
                });
            })();
        }
    };
};
function getPlacementList(alignment, autoAlignment, allowedPlacements) {
    var allowedPlacementsSortedByAlignment = alignment ? (0, _toConsumableArray._)(allowedPlacements.filter(function(placement) {
        return (0, _utils.getAlignment)(placement) === alignment;
    })).concat((0, _toConsumableArray._)(allowedPlacements.filter(function(placement) {
        return (0, _utils.getAlignment)(placement) !== alignment;
    }))) : allowedPlacements.filter(function(placement) {
        return (0, _utils.getSide)(placement) === placement;
    });
    return allowedPlacementsSortedByAlignment.filter(function(placement) {
        if (alignment) return (0, _utils.getAlignment)(placement) === alignment || (autoAlignment ? (0, _utils.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ var autoPlacement = function autoPlacement(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        fn: function fn(state) {
            return (0, _asyncToGenerator._)(function() {
                var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE, rects, middlewareData, placement, platform, elements, _evaluate, _evaluate_crossAxis, crossAxis, alignment, _evaluate_allowedPlacements, allowedPlacements, _evaluate_autoAlignment, autoAlignment, detectOverflowOptions, placements$1, overflow, currentIndex, currentPlacement, alignmentSides, _tmp, currentOverflows, allOverflows, nextPlacement, placementsSortedByMostSpace, placementsThatFitOnEachSide, resetPlacement;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            rects = state.rects, middlewareData = state.middlewareData, placement = state.placement, platform = state.platform, elements = state.elements;
                            _evaluate = (0, _utils.evaluate)(options, state), _evaluate_crossAxis = _evaluate.crossAxis, crossAxis = _evaluate_crossAxis === void 0 ? false : _evaluate_crossAxis, alignment = _evaluate.alignment, _evaluate_allowedPlacements = _evaluate.allowedPlacements, allowedPlacements = _evaluate_allowedPlacements === void 0 ? (0, _utils.placements) : _evaluate_allowedPlacements, _evaluate_autoAlignment = _evaluate.autoAlignment, autoAlignment = _evaluate_autoAlignment === void 0 ? true : _evaluate_autoAlignment, detectOverflowOptions = (0, _objectWithoutProperties._)(_evaluate, [
                                "crossAxis",
                                "alignment",
                                "allowedPlacements",
                                "autoAlignment"
                            ]);
                            placements$1 = alignment !== undefined || allowedPlacements === (0, _utils.placements) ? getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
                            return [
                                4,
                                platform.detectOverflow(state, detectOverflowOptions)
                            ];
                        case 1:
                            overflow = _state.sent();
                            currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
                            currentPlacement = placements$1[currentIndex];
                            if (currentPlacement == null) return [
                                2,
                                {}
                            ];
                            _tmp = [
                                currentPlacement,
                                rects
                            ];
                            return [
                                4,
                                platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)
                            ];
                        case 2:
                            alignmentSides = (0, _utils.getAlignmentSides).apply(void 0, _tmp.concat([
                                _state.sent()
                            ]));
                            // Make `computeCoords` start from the right place.
                            if (placement !== currentPlacement) return [
                                2,
                                {
                                    reset: {
                                        placement: placements$1[0]
                                    }
                                }
                            ];
                            currentOverflows = [
                                overflow[(0, _utils.getSide)(currentPlacement)],
                                overflow[alignmentSides[0]],
                                overflow[alignmentSides[1]]
                            ];
                            allOverflows = (0, _toConsumableArray._)(((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || []).concat([
                                {
                                    placement: currentPlacement,
                                    overflows: currentOverflows
                                }
                            ]);
                            nextPlacement = placements$1[currentIndex + 1];
                            // There are more placements to check.
                            if (nextPlacement) return [
                                2,
                                {
                                    data: {
                                        index: currentIndex + 1,
                                        overflows: allOverflows
                                    },
                                    reset: {
                                        placement: nextPlacement
                                    }
                                }
                            ];
                            placementsSortedByMostSpace = allOverflows.map(function(d) {
                                var alignment = (0, _utils.getAlignment)(d.placement);
                                return [
                                    d.placement,
                                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                                    d.overflows.slice(0, 2).reduce(function(acc, v) {
                                        return acc + v;
                                    }, 0) : // Check only the mainAxis.
                                    d.overflows[0],
                                    d.overflows
                                ];
                            }).sort(function(a, b) {
                                return a[1] - b[1];
                            });
                            placementsThatFitOnEachSide = placementsSortedByMostSpace.filter(function(d) {
                                return d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                                // side.
                                (0, _utils.getAlignment)(d[0]) ? 2 : 3).every(function(v) {
                                    return v <= 0;
                                });
                            });
                            resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
                            if (resetPlacement !== placement) return [
                                2,
                                {
                                    data: {
                                        index: currentIndex + 1,
                                        overflows: allOverflows
                                    },
                                    reset: {
                                        placement: resetPlacement
                                    }
                                }
                            ];
                            return [
                                2,
                                {}
                            ];
                    }
                });
            })();
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ var flip = function flip(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        fn: function fn(state) {
            return (0, _asyncToGenerator._)(function() {
                var _fallbackPlacements, _middlewareData$arrow, _middlewareData$flip, placement, middlewareData, rects, initialPlacement, platform, elements, _evaluate, tmp, checkMainAxis, tmp1, checkCrossAxis, specifiedFallbackPlacements, _evaluate_fallbackStrategy, fallbackStrategy, _evaluate_fallbackAxisSideDirection, fallbackAxisSideDirection, _evaluate_flipAlignment, flipAlignment, detectOverflowOptions, side, initialSideAxis, isBasePlacement, rtl, fallbackPlacements, hasFallbackAxisSideDirection, placements, overflow, overflows, overflowsData, sides, _middlewareData$flip2, _overflowsData$filter, nextIndex, nextPlacement, ignoreCrossAxisOverflow, resetPlacement, _overflowsData$filter2, placement1;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            placement = state.placement, middlewareData = state.middlewareData, rects = state.rects, initialPlacement = state.initialPlacement, platform = state.platform, elements = state.elements;
                            _evaluate = (0, _utils.evaluate)(options, state), tmp = _evaluate.mainAxis, checkMainAxis = tmp === void 0 ? true : tmp, tmp1 = _evaluate.crossAxis, checkCrossAxis = tmp1 === void 0 ? true : tmp1, specifiedFallbackPlacements = _evaluate.fallbackPlacements, _evaluate_fallbackStrategy = _evaluate.fallbackStrategy, fallbackStrategy = _evaluate_fallbackStrategy === void 0 ? 'bestFit' : _evaluate_fallbackStrategy, _evaluate_fallbackAxisSideDirection = _evaluate.fallbackAxisSideDirection, fallbackAxisSideDirection = _evaluate_fallbackAxisSideDirection === void 0 ? 'none' : _evaluate_fallbackAxisSideDirection, _evaluate_flipAlignment = _evaluate.flipAlignment, flipAlignment = _evaluate_flipAlignment === void 0 ? true : _evaluate_flipAlignment, detectOverflowOptions = (0, _objectWithoutProperties._)(_evaluate, [
                                "mainAxis",
                                "crossAxis",
                                "fallbackPlacements",
                                "fallbackStrategy",
                                "fallbackAxisSideDirection",
                                "flipAlignment"
                            ]);
                            // If a reset by the arrow was caused due to an alignment offset being
                            // added, we should skip any logic now since `flip()` has already done its
                            // work.
                            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
                            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return [
                                2,
                                {}
                            ];
                            side = (0, _utils.getSide)(placement);
                            initialSideAxis = (0, _utils.getSideAxis)(initialPlacement);
                            isBasePlacement = (0, _utils.getSide)(initialPlacement) === initialPlacement;
                            return [
                                4,
                                platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)
                            ];
                        case 1:
                            rtl = _state.sent();
                            fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                                (0, _utils.getOppositePlacement)(initialPlacement)
                            ] : (0, _utils.getExpandedPlacements)(initialPlacement));
                            hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
                            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) (_fallbackPlacements = fallbackPlacements).push.apply(_fallbackPlacements, (0, _toConsumableArray._)((0, _utils.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl)));
                            placements = [
                                initialPlacement
                            ].concat((0, _toConsumableArray._)(fallbackPlacements));
                            return [
                                4,
                                platform.detectOverflow(state, detectOverflowOptions)
                            ];
                        case 2:
                            overflow = _state.sent();
                            overflows = [];
                            overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
                            if (checkMainAxis) overflows.push(overflow[side]);
                            if (checkCrossAxis) {
                                sides = (0, _utils.getAlignmentSides)(placement, rects, rtl);
                                overflows.push(overflow[sides[0]], overflow[sides[1]]);
                            }
                            overflowsData = (0, _toConsumableArray._)(overflowsData).concat([
                                {
                                    placement: placement,
                                    overflows: overflows
                                }
                            ]);
                            // One or more sides is overflowing.
                            if (!overflows.every(function(side) {
                                return side <= 0;
                            })) {
                                ;
                                nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                                nextPlacement = placements[nextIndex];
                                if (nextPlacement) {
                                    ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== (0, _utils.getSideAxis)(nextPlacement) : false;
                                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                                    // overflows the main axis.
                                    overflowsData.every(function(d) {
                                        return (0, _utils.getSideAxis)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true;
                                    })) // Try next placement and re-run the lifecycle.
                                    return [
                                        2,
                                        {
                                            data: {
                                                index: nextIndex,
                                                overflows: overflowsData
                                            },
                                            reset: {
                                                placement: nextPlacement
                                            }
                                        }
                                    ];
                                }
                                // First, find the candidates that fit on the mainAxis side of overflow,
                                // then find the placement that fits the best on the main crossAxis side.
                                resetPlacement = (_overflowsData$filter = overflowsData.filter(function(d) {
                                    return d.overflows[0] <= 0;
                                }).sort(function(a, b) {
                                    return a.overflows[1] - b.overflows[1];
                                })[0]) == null ? void 0 : _overflowsData$filter.placement;
                                // Otherwise fallback.
                                if (!resetPlacement) switch(fallbackStrategy){
                                    case 'bestFit':
                                        {
                                            ;
                                            placement1 = (_overflowsData$filter2 = overflowsData.filter(function(d) {
                                                if (hasFallbackAxisSideDirection) {
                                                    var currentSideAxis = (0, _utils.getSideAxis)(d.placement);
                                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                                    // reading directions favoring greater width.
                                                    currentSideAxis === 'y';
                                                }
                                                return true;
                                            }).map(function(d) {
                                                return [
                                                    d.placement,
                                                    d.overflows.filter(function(overflow) {
                                                        return overflow > 0;
                                                    }).reduce(function(acc, overflow) {
                                                        return acc + overflow;
                                                    }, 0)
                                                ];
                                            }).sort(function(a, b) {
                                                return a[1] - b[1];
                                            })[0]) == null ? void 0 : _overflowsData$filter2[0];
                                            if (placement1) resetPlacement = placement1;
                                            break;
                                        }
                                    case 'initialPlacement':
                                        resetPlacement = initialPlacement;
                                        break;
                                }
                                if (placement !== resetPlacement) return [
                                    2,
                                    {
                                        reset: {
                                            placement: resetPlacement
                                        }
                                    }
                                ];
                            }
                            return [
                                2,
                                {}
                            ];
                    }
                });
            })();
        }
    };
};
function getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function isAnySideFullyClipped(overflow) {
    return (0, _utils.sides).some(function(side) {
        return overflow[side] >= 0;
    });
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ var hide = function hide(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        fn: function fn(state) {
            return (0, _asyncToGenerator._)(function() {
                var rects, platform, _evaluate, _evaluate_strategy, strategy, detectOverflowOptions, overflow, offsets, overflow1, offsets1;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            rects = state.rects, platform = state.platform;
                            _evaluate = (0, _utils.evaluate)(options, state), _evaluate_strategy = _evaluate.strategy, strategy = _evaluate_strategy === void 0 ? 'referenceHidden' : _evaluate_strategy, detectOverflowOptions = (0, _objectWithoutProperties._)(_evaluate, [
                                "strategy"
                            ]);
                            switch(strategy){
                                case 'referenceHidden':
                                    return [
                                        3,
                                        1
                                    ];
                                case 'escaped':
                                    return [
                                        3,
                                        3
                                    ];
                            }
                            return [
                                3,
                                5
                            ];
                        case 1:
                            return [
                                4,
                                platform.detectOverflow(state, (0, _objectSpreadProps._)((0, _objectSpread._)({}, detectOverflowOptions), {
                                    elementContext: 'reference'
                                }))
                            ];
                        case 2:
                            overflow = _state.sent();
                            offsets = getSideOffsets(overflow, rects.reference);
                            return [
                                2,
                                {
                                    data: {
                                        referenceHiddenOffsets: offsets,
                                        referenceHidden: isAnySideFullyClipped(offsets)
                                    }
                                }
                            ];
                        case 3:
                            return [
                                4,
                                platform.detectOverflow(state, (0, _objectSpreadProps._)((0, _objectSpread._)({}, detectOverflowOptions), {
                                    altBoundary: true
                                }))
                            ];
                        case 4:
                            overflow1 = _state.sent();
                            offsets1 = getSideOffsets(overflow1, rects.floating);
                            return [
                                2,
                                {
                                    data: {
                                        escapedOffsets: offsets1,
                                        escaped: isAnySideFullyClipped(offsets1)
                                    }
                                }
                            ];
                        case 5:
                            return [
                                2,
                                {}
                            ];
                        case 6:
                            return [
                                2
                            ];
                    }
                });
            })();
        }
    };
};
function getBoundingRect(rects) {
    var minX = (0, _utils.min).apply(void 0, (0, _toConsumableArray._)(rects.map(function(rect) {
        return rect.left;
    })));
    var minY = (0, _utils.min).apply(void 0, (0, _toConsumableArray._)(rects.map(function(rect) {
        return rect.top;
    })));
    var maxX = (0, _utils.max).apply(void 0, (0, _toConsumableArray._)(rects.map(function(rect) {
        return rect.right;
    })));
    var maxY = (0, _utils.max).apply(void 0, (0, _toConsumableArray._)(rects.map(function(rect) {
        return rect.bottom;
    })));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function getRectsByLine(rects) {
    var sortedRects = rects.slice().sort(function(a, b) {
        return a.y - b.y;
    });
    var groups = [];
    var prevRect = null;
    for(var i = 0; i < sortedRects.length; i++){
        var rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map(function(rect) {
        return (0, _utils.rectToClientRect)(getBoundingRect(rect));
    });
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ var inline = function inline(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        fn: function fn(state) {
            return (0, _asyncToGenerator._)(function() {
                var placement, elements, rects, platform, strategy, _evaluate, _evaluate_padding, padding, x, y, nativeClientRects, _, clientRects, fallback, paddingObject, resetRects;
                function getBoundingClientRect() {
                    // There are two rects and they are disjoined.
                    if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                    return clientRects.find(function(rect) {
                        return x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom;
                    }) || fallback;
                    // There are 2 or more connected rects.
                    if (clientRects.length >= 2) {
                        if ((0, _utils.getSideAxis)(placement) === 'y') {
                            var firstRect = clientRects[0];
                            var lastRect = clientRects[clientRects.length - 1];
                            var isTop = (0, _utils.getSide)(placement) === 'top';
                            var top = firstRect.top;
                            var bottom = lastRect.bottom;
                            var left = isTop ? firstRect.left : lastRect.left;
                            var right = isTop ? firstRect.right : lastRect.right;
                            var width = right - left;
                            var height = bottom - top;
                            return {
                                top: top,
                                bottom: bottom,
                                left: left,
                                right: right,
                                width: width,
                                height: height,
                                x: left,
                                y: top
                            };
                        }
                        var isLeftSide = (0, _utils.getSide)(placement) === 'left';
                        var maxRight = (0, _utils.max).apply(void 0, (0, _toConsumableArray._)(clientRects.map(function(rect) {
                            return rect.right;
                        })));
                        var minLeft = (0, _utils.min).apply(void 0, (0, _toConsumableArray._)(clientRects.map(function(rect) {
                            return rect.left;
                        })));
                        var measureRects = clientRects.filter(function(rect) {
                            return isLeftSide ? rect.left === minLeft : rect.right === maxRight;
                        });
                        var top1 = measureRects[0].top;
                        var bottom1 = measureRects[measureRects.length - 1].bottom;
                        var left1 = minLeft;
                        var right1 = maxRight;
                        var width1 = right1 - left1;
                        var height1 = bottom1 - top1;
                        return {
                            top: top1,
                            bottom: bottom1,
                            left: left1,
                            right: right1,
                            width: width1,
                            height: height1,
                            x: left1,
                            y: top1
                        };
                    }
                    return fallback;
                }
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            placement = state.placement, elements = state.elements, rects = state.rects, platform = state.platform, strategy = state.strategy;
                            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
                            // ClientRect's bounds, despite the event listener being triggered. A
                            // padding of 2 seems to handle this issue.
                            _evaluate = (0, _utils.evaluate)(options, state), _evaluate_padding = _evaluate.padding, padding = _evaluate_padding === void 0 ? 2 : _evaluate_padding, x = _evaluate.x, y = _evaluate.y;
                            _ = Array.from;
                            return [
                                4,
                                platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)
                            ];
                        case 1:
                            nativeClientRects = _.apply(Array, [
                                _state.sent() || []
                            ]);
                            clientRects = getRectsByLine(nativeClientRects);
                            fallback = (0, _utils.rectToClientRect)(getBoundingRect(nativeClientRects));
                            paddingObject = (0, _utils.getPaddingObject)(padding);
                            return [
                                4,
                                platform.getElementRects({
                                    reference: {
                                        getBoundingClientRect: getBoundingClientRect
                                    },
                                    floating: elements.floating,
                                    strategy: strategy
                                })
                            ];
                        case 2:
                            resetRects = _state.sent();
                            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return [
                                2,
                                {
                                    reset: {
                                        rects: resetRects
                                    }
                                }
                            ];
                            return [
                                2,
                                {}
                            ];
                    }
                });
            })();
        }
    };
};
var originSides = /*#__PURE__*/ new Set([
    'left',
    'top'
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
function convertValueToCoords(state, options) {
    return (0, _asyncToGenerator._)(function() {
        var placement, platform, elements, rtl, side, alignment, isVertical, mainAxisMulti, crossAxisMulti, rawValue, _ref, mainAxis, crossAxis, alignmentAxis;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    placement = state.placement, platform = state.platform, elements = state.elements;
                    return [
                        4,
                        platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)
                    ];
                case 1:
                    rtl = _state.sent();
                    side = (0, _utils.getSide)(placement);
                    alignment = (0, _utils.getAlignment)(placement);
                    isVertical = (0, _utils.getSideAxis)(placement) === 'y';
                    mainAxisMulti = originSides.has(side) ? -1 : 1;
                    crossAxisMulti = rtl && isVertical ? -1 : 1;
                    rawValue = (0, _utils.evaluate)(options, state);
                    // eslint-disable-next-line prefer-const
                    _ref = typeof rawValue === 'number' ? {
                        mainAxis: rawValue,
                        crossAxis: 0,
                        alignmentAxis: null
                    } : {
                        mainAxis: rawValue.mainAxis || 0,
                        crossAxis: rawValue.crossAxis || 0,
                        alignmentAxis: rawValue.alignmentAxis
                    }, mainAxis = _ref.mainAxis, crossAxis = _ref.crossAxis, alignmentAxis = _ref.alignmentAxis;
                    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
                    return [
                        2,
                        isVertical ? {
                            x: crossAxis * crossAxisMulti,
                            y: mainAxis * mainAxisMulti
                        } : {
                            x: mainAxis * mainAxisMulti,
                            y: crossAxis * crossAxisMulti
                        }
                    ];
            }
        });
    })();
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ var offset = function offset(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        fn: function fn(state) {
            return (0, _asyncToGenerator._)(function() {
                var _middlewareData$offse, _middlewareData$arrow, x, y, placement, middlewareData, diffCoords;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            x = state.x, y = state.y, placement = state.placement, middlewareData = state.middlewareData;
                            return [
                                4,
                                convertValueToCoords(state, options)
                            ];
                        case 1:
                            diffCoords = _state.sent();
                            // If the placement is the same and the arrow caused an alignment offset
                            // then we don't need to change the positioning coordinates.
                            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return [
                                2,
                                {}
                            ];
                            return [
                                2,
                                {
                                    x: x + diffCoords.x,
                                    y: y + diffCoords.y,
                                    data: (0, _objectSpreadProps._)((0, _objectSpread._)({}, diffCoords), {
                                        placement: placement
                                    })
                                }
                            ];
                    }
                });
            })();
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ var shift = function shift(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        fn: function fn(state) {
            return (0, _asyncToGenerator._)(function() {
                var x, y, placement, platform, _evaluate, tmp, checkMainAxis, tmp1, checkCrossAxis, _evaluate_limiter, limiter, detectOverflowOptions, coords, overflow, crossAxis, mainAxis, mainAxisCoord, crossAxisCoord, minSide, maxSide, min, max, minSide1, maxSide1, min1, max1, _obj, limitedCoords, _obj1;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            x = state.x, y = state.y, placement = state.placement, platform = state.platform;
                            _evaluate = (0, _utils.evaluate)(options, state), tmp = _evaluate.mainAxis, checkMainAxis = tmp === void 0 ? true : tmp, tmp1 = _evaluate.crossAxis, checkCrossAxis = tmp1 === void 0 ? false : tmp1, _evaluate_limiter = _evaluate.limiter, limiter = _evaluate_limiter === void 0 ? {
                                fn: function(_ref) {
                                    var x = _ref.x, y = _ref.y;
                                    return {
                                        x: x,
                                        y: y
                                    };
                                }
                            } : _evaluate_limiter, detectOverflowOptions = (0, _objectWithoutProperties._)(_evaluate, [
                                "mainAxis",
                                "crossAxis",
                                "limiter"
                            ]);
                            coords = {
                                x: x,
                                y: y
                            };
                            return [
                                4,
                                platform.detectOverflow(state, detectOverflowOptions)
                            ];
                        case 1:
                            overflow = _state.sent();
                            crossAxis = (0, _utils.getSideAxis)((0, _utils.getSide)(placement));
                            mainAxis = (0, _utils.getOppositeAxis)(crossAxis);
                            mainAxisCoord = coords[mainAxis];
                            crossAxisCoord = coords[crossAxis];
                            if (checkMainAxis) {
                                minSide = mainAxis === 'y' ? 'top' : 'left';
                                maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                                min = mainAxisCoord + overflow[minSide];
                                max = mainAxisCoord - overflow[maxSide];
                                mainAxisCoord = (0, _utils.clamp)(min, mainAxisCoord, max);
                            }
                            if (checkCrossAxis) {
                                minSide1 = crossAxis === 'y' ? 'top' : 'left';
                                maxSide1 = crossAxis === 'y' ? 'bottom' : 'right';
                                min1 = crossAxisCoord + overflow[minSide1];
                                max1 = crossAxisCoord - overflow[maxSide1];
                                crossAxisCoord = (0, _utils.clamp)(min1, crossAxisCoord, max1);
                            }
                            limitedCoords = limiter.fn((0, _objectSpreadProps._)((0, _objectSpread._)({}, state), (_obj = {}, (0, _defineProperty._)(_obj, mainAxis, mainAxisCoord), (0, _defineProperty._)(_obj, crossAxis, crossAxisCoord), _obj)));
                            return [
                                2,
                                (0, _objectSpreadProps._)((0, _objectSpread._)({}, limitedCoords), {
                                    data: {
                                        x: limitedCoords.x - x,
                                        y: limitedCoords.y - y,
                                        enabled: (_obj1 = {}, (0, _defineProperty._)(_obj1, mainAxis, checkMainAxis), (0, _defineProperty._)(_obj1, crossAxis, checkCrossAxis), _obj1)
                                    }
                                })
                            ];
                    }
                });
            })();
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ var limitShift = function limitShift(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn: function fn(state) {
            var x = state.x, y = state.y, placement = state.placement, rects = state.rects, middlewareData = state.middlewareData;
            var _evaluate = (0, _utils.evaluate)(options, state), _evaluate_offset = _evaluate.offset, offset = _evaluate_offset === void 0 ? 0 : _evaluate_offset, tmp = _evaluate.mainAxis, checkMainAxis = tmp === void 0 ? true : tmp, tmp1 = _evaluate.crossAxis, checkCrossAxis = tmp1 === void 0 ? true : tmp1;
            var coords = {
                x: x,
                y: y
            };
            var crossAxis = (0, _utils.getSideAxis)(placement);
            var mainAxis = (0, _utils.getOppositeAxis)(crossAxis);
            var mainAxisCoord = coords[mainAxis];
            var crossAxisCoord = coords[crossAxis];
            var rawOffset = (0, _utils.evaluate)(offset, state);
            var computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : (0, _objectSpread._)({
                mainAxis: 0,
                crossAxis: 0
            }, rawOffset);
            if (checkMainAxis) {
                var len = mainAxis === 'y' ? 'height' : 'width';
                var limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                var limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                var len1 = mainAxis === 'y' ? 'width' : 'height';
                var isOriginSide = originSides.has((0, _utils.getSide)(placement));
                var limitMin1 = rects.reference[crossAxis] - rects.floating[len1] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                var limitMax1 = rects.reference[crossAxis] + rects.reference[len1] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin1) crossAxisCoord = limitMin1;
                else if (crossAxisCoord > limitMax1) crossAxisCoord = limitMax1;
            }
            var _obj;
            return _obj = {}, (0, _defineProperty._)(_obj, mainAxis, mainAxisCoord), (0, _defineProperty._)(_obj, crossAxis, crossAxisCoord), _obj;
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ var size = function size(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        fn: function fn(state) {
            return (0, _asyncToGenerator._)(function() {
                var _state$middlewareData, _state$middlewareData2, placement, rects, platform, elements, _evaluate, _evaluate_apply, apply, detectOverflowOptions, overflow, side, alignment, isYAxis, _rects_floating, width, height, heightSide, widthSide, maximumClippingHeight, maximumClippingWidth, overflowAvailableHeight, overflowAvailableWidth, noShift, availableHeight, availableWidth, xMin, xMax, yMin, yMax, nextDimensions;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            placement = state.placement, rects = state.rects, platform = state.platform, elements = state.elements;
                            _evaluate = (0, _utils.evaluate)(options, state), _evaluate_apply = _evaluate.apply, apply = _evaluate_apply === void 0 ? function() {} : _evaluate_apply, detectOverflowOptions = (0, _objectWithoutProperties._)(_evaluate, [
                                "apply"
                            ]);
                            return [
                                4,
                                platform.detectOverflow(state, detectOverflowOptions)
                            ];
                        case 1:
                            overflow = _state.sent();
                            side = (0, _utils.getSide)(placement);
                            alignment = (0, _utils.getAlignment)(placement);
                            isYAxis = (0, _utils.getSideAxis)(placement) === 'y';
                            _rects_floating = rects.floating, width = _rects_floating.width, height = _rects_floating.height;
                            if (!(side === 'top' || side === 'bottom')) return [
                                3,
                                3
                            ];
                            heightSide = side;
                            return [
                                4,
                                platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)
                            ];
                        case 2:
                            widthSide = alignment === (_state.sent() ? 'start' : 'end') ? 'left' : 'right';
                            return [
                                3,
                                4
                            ];
                        case 3:
                            widthSide = side;
                            heightSide = alignment === 'end' ? 'top' : 'bottom';
                            _state.label = 4;
                        case 4:
                            maximumClippingHeight = height - overflow.top - overflow.bottom;
                            maximumClippingWidth = width - overflow.left - overflow.right;
                            overflowAvailableHeight = (0, _utils.min)(height - overflow[heightSide], maximumClippingHeight);
                            overflowAvailableWidth = (0, _utils.min)(width - overflow[widthSide], maximumClippingWidth);
                            noShift = !state.middlewareData.shift;
                            availableHeight = overflowAvailableHeight;
                            availableWidth = overflowAvailableWidth;
                            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
                            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
                            if (noShift && !alignment) {
                                xMin = (0, _utils.max)(overflow.left, 0);
                                xMax = (0, _utils.max)(overflow.right, 0);
                                yMin = (0, _utils.max)(overflow.top, 0);
                                yMax = (0, _utils.max)(overflow.bottom, 0);
                                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, _utils.max)(overflow.left, overflow.right));
                                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, _utils.max)(overflow.top, overflow.bottom));
                            }
                            return [
                                4,
                                apply((0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                                    availableWidth: availableWidth,
                                    availableHeight: availableHeight
                                }))
                            ];
                        case 5:
                            _state.sent();
                            return [
                                4,
                                platform.getDimensions(elements.floating)
                            ];
                        case 6:
                            nextDimensions = _state.sent();
                            if (width !== nextDimensions.width || height !== nextDimensions.height) return [
                                2,
                                {
                                    reset: {
                                        rects: true
                                    }
                                }
                            ];
                            return [
                                2,
                                {}
                            ];
                    }
                });
            })();
        }
    };
};

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","@swc/helpers/_/_to_consumable_array":"1eSZf","@swc/helpers/_/_type_of":"iFJdx","@swc/helpers/_/_ts_generator":"78Tqx","@floating-ui/utils":"gVBaK","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gVBaK":[function(require,module,exports,__globalThis) {
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "alignments", function() {
    return alignments;
});
parcelHelpers.export(exports, "clamp", function() {
    return clamp;
});
parcelHelpers.export(exports, "createCoords", function() {
    return createCoords;
});
parcelHelpers.export(exports, "evaluate", function() {
    return evaluate;
});
parcelHelpers.export(exports, "expandPaddingObject", function() {
    return expandPaddingObject;
});
parcelHelpers.export(exports, "floor", function() {
    return floor;
});
parcelHelpers.export(exports, "getAlignment", function() {
    return getAlignment;
});
parcelHelpers.export(exports, "getAlignmentAxis", function() {
    return getAlignmentAxis;
});
parcelHelpers.export(exports, "getAlignmentSides", function() {
    return getAlignmentSides;
});
parcelHelpers.export(exports, "getAxisLength", function() {
    return getAxisLength;
});
parcelHelpers.export(exports, "getExpandedPlacements", function() {
    return getExpandedPlacements;
});
parcelHelpers.export(exports, "getOppositeAlignmentPlacement", function() {
    return getOppositeAlignmentPlacement;
});
parcelHelpers.export(exports, "getOppositeAxis", function() {
    return getOppositeAxis;
});
parcelHelpers.export(exports, "getOppositeAxisPlacements", function() {
    return getOppositeAxisPlacements;
});
parcelHelpers.export(exports, "getOppositePlacement", function() {
    return getOppositePlacement;
});
parcelHelpers.export(exports, "getPaddingObject", function() {
    return getPaddingObject;
});
parcelHelpers.export(exports, "getSide", function() {
    return getSide;
});
parcelHelpers.export(exports, "getSideAxis", function() {
    return getSideAxis;
});
parcelHelpers.export(exports, "max", function() {
    return max;
});
parcelHelpers.export(exports, "min", function() {
    return min;
});
parcelHelpers.export(exports, "placements", function() {
    return placements;
});
parcelHelpers.export(exports, "rectToClientRect", function() {
    return rectToClientRect;
});
parcelHelpers.export(exports, "round", function() {
    return round;
});
parcelHelpers.export(exports, "sides", function() {
    return sides;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var sides = [
    'top',
    'right',
    'bottom',
    'left'
];
var alignments = [
    'start',
    'end'
];
var placements = /*#__PURE__*/ sides.reduce(function(acc, side) {
    return acc.concat(side, side + "-" + alignments[0], side + "-" + alignments[1]);
}, []);
var min = Math.min;
var max = Math.max;
var round = Math.round;
var floor = Math.floor;
var createCoords = function(v) {
    return {
        x: v,
        y: v
    };
};
var oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function clamp(start, value, end) {
    return max(start, min(value, end));
}
function evaluate(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function getSide(placement) {
    return placement.split('-')[0];
}
function getAlignment(placement) {
    return placement.split('-')[1];
}
function getOppositeAxis(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function getAxisLength(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function getSideAxis(placement) {
    var firstChar = placement[0];
    return firstChar === 't' || firstChar === 'b' ? 'y' : 'x';
}
function getAlignmentAxis(placement) {
    return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    var alignment = getAlignment(placement);
    var alignmentAxis = getAlignmentAxis(placement);
    var length = getAxisLength(alignmentAxis);
    var mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
    return [
        mainAlignmentSide,
        getOppositePlacement(mainAlignmentSide)
    ];
}
function getExpandedPlacements(placement) {
    var oppositePlacement = getOppositePlacement(placement);
    return [
        getOppositeAlignmentPlacement(placement),
        oppositePlacement,
        getOppositeAlignmentPlacement(oppositePlacement)
    ];
}
function getOppositeAlignmentPlacement(placement) {
    return placement.includes('start') ? placement.replace('start', 'end') : placement.replace('end', 'start');
}
var lrPlacement = [
    'left',
    'right'
];
var rlPlacement = [
    'right',
    'left'
];
var tbPlacement = [
    'top',
    'bottom'
];
var btPlacement = [
    'bottom',
    'top'
];
function getSideList(side, isStart, rtl) {
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? rlPlacement : lrPlacement;
            return isStart ? lrPlacement : rlPlacement;
        case 'left':
        case 'right':
            return isStart ? tbPlacement : btPlacement;
        default:
            return [];
    }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
    var alignment = getAlignment(placement);
    var list = getSideList(getSide(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map(function(side) {
            return side + "-" + alignment;
        });
        if (flipAlignment) list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
    return list;
}
function getOppositePlacement(placement) {
    var side = getSide(placement);
    return oppositeSideMap[side] + placement.slice(side.length);
}
function expandPaddingObject(padding) {
    return (0, _objectSpread._)({
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }, padding);
}
function getPaddingObject(padding) {
    return typeof padding !== 'number' ? expandPaddingObject(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function rectToClientRect(rect) {
    var x = rect.x, y = rect.y, width = rect.width, height = rect.height;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cDpKU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getComputedStyle", function() {
    return getComputedStyle;
});
parcelHelpers.export(exports, "getContainingBlock", function() {
    return getContainingBlock;
});
parcelHelpers.export(exports, "getDocumentElement", function() {
    return getDocumentElement;
});
parcelHelpers.export(exports, "getFrameElement", function() {
    return getFrameElement;
});
parcelHelpers.export(exports, "getNearestOverflowAncestor", function() {
    return getNearestOverflowAncestor;
});
parcelHelpers.export(exports, "getNodeName", function() {
    return getNodeName;
});
parcelHelpers.export(exports, "getNodeScroll", function() {
    return getNodeScroll;
});
parcelHelpers.export(exports, "getOverflowAncestors", function() {
    return getOverflowAncestors;
});
parcelHelpers.export(exports, "getParentNode", function() {
    return getParentNode;
});
parcelHelpers.export(exports, "getWindow", function() {
    return getWindow;
});
parcelHelpers.export(exports, "isContainingBlock", function() {
    return isContainingBlock;
});
parcelHelpers.export(exports, "isElement", function() {
    return isElement;
});
parcelHelpers.export(exports, "isHTMLElement", function() {
    return isHTMLElement;
});
parcelHelpers.export(exports, "isLastTraversableNode", function() {
    return isLastTraversableNode;
});
parcelHelpers.export(exports, "isNode", function() {
    return isNode;
});
parcelHelpers.export(exports, "isOverflowElement", function() {
    return isOverflowElement;
});
parcelHelpers.export(exports, "isShadowRoot", function() {
    return isShadowRoot;
});
parcelHelpers.export(exports, "isTableElement", function() {
    return isTableElement;
});
parcelHelpers.export(exports, "isTopLayer", function() {
    return isTopLayer;
});
parcelHelpers.export(exports, "isWebKit", function() {
    return isWebKit;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
function hasWindow() {
    return typeof window !== 'undefined';
}
function getNodeName(node) {
    if (isNode(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function getWindow(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
    var _ref;
    return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
    if (!hasWindow()) return false;
    return (0, _instanceof._)(value, Node) || (0, _instanceof._)(value, getWindow(value).Node);
}
function isElement(value) {
    if (!hasWindow()) return false;
    return (0, _instanceof._)(value, Element) || (0, _instanceof._)(value, getWindow(value).Element);
}
function isHTMLElement(value) {
    if (!hasWindow()) return false;
    return (0, _instanceof._)(value, HTMLElement) || (0, _instanceof._)(value, getWindow(value).HTMLElement);
}
function isShadowRoot(value) {
    if (!hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return (0, _instanceof._)(value, ShadowRoot) || (0, _instanceof._)(value, getWindow(value).ShadowRoot);
}
function isOverflowElement(element) {
    var _getComputedStyle = getComputedStyle(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY, display = _getComputedStyle.display;
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && display !== 'inline' && display !== 'contents';
}
function isTableElement(element) {
    return /^(table|td|th)$/.test(getNodeName(element));
}
function isTopLayer(element) {
    try {
        if (element.matches(':popover-open')) return true;
    } catch (_e) {
    // no-op
    }
    try {
        return element.matches(':modal');
    } catch (_e) {
        return false;
    }
}
var willChangeRe = /transform|translate|scale|rotate|perspective|filter/;
var containRe = /paint|layout|strict|content/;
var isNotNone = function(value) {
    return !!value && value !== 'none';
};
var isWebKitValue;
function isContainingBlock(elementOrCss) {
    var css = isElement(elementOrCss) ? getComputedStyle(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return isNotNone(css.transform) || isNotNone(css.translate) || isNotNone(css.scale) || isNotNone(css.rotate) || isNotNone(css.perspective) || !isWebKit() && (isNotNone(css.backdropFilter) || isNotNone(css.filter)) || willChangeRe.test(css.willChange || '') || containRe.test(css.contain || '');
}
function getContainingBlock(element) {
    var currentNode = getParentNode(element);
    while(isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)){
        if (isContainingBlock(currentNode)) return currentNode;
        else if (isTopLayer(currentNode)) return null;
        currentNode = getParentNode(currentNode);
    }
    return null;
}
function isWebKit() {
    if (isWebKitValue == null) isWebKitValue = typeof CSS !== 'undefined' && CSS.supports && CSS.supports('-webkit-backdrop-filter', 'none');
    return isWebKitValue;
}
function isLastTraversableNode(node) {
    return /^(html|body|#document)$/.test(getNodeName(node));
}
function getComputedStyle(element) {
    return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
    if (isElement(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function getParentNode(node) {
    if (getNodeName(node) === 'html') return node;
    var result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    isShadowRoot(node) && node.host || // Fallback.
    getDocumentElement(node);
    return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
    var parentNode = getParentNode(node);
    if (isLastTraversableNode(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) return parentNode;
    return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    var scrollableAncestor = getNearestOverflowAncestor(node);
    var isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    var win = getWindow(scrollableAncestor);
    if (isBody) {
        var frameElement = getFrameElement(win);
        return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? getOverflowAncestors(frameElement) : []);
    } else return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
function getFrameElement(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

},{"@swc/helpers/_/_instanceof":"h9UKc","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cDq7E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PortalPlacementContext", function() {
    return PortalPlacementContext;
});
var _react = require("react");
var PortalPlacementContext = /*#__PURE__*/ (0, _react.createContext)(null);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"luFyw":[function(require,module,exports,__globalThis) {
/* multi-value.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _react1 = require("@compiled/react");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _tag = require("@atlaskit/tag");
var _tagDefault = parcelHelpers.interopDefault(_tag);
var _getStyleProps = require("../get-style-props");
var _multiValueLabel = require("./multi-value-label");
var multiValueTagWrapperStyles = {
    root: "_16jlidpf _1o9zkb7n _i0dl1wug _1mouze3t _195gze3t _4cvr1h6o _1e0c1txw _1ul9ze3t _zdxokb7n _v5ynkb7n _13lsf1ug _3pxh1h6o _d0dz1txw _1ouwze3t"
};
// Tag-like color styles
var tagLikeColorStyles = {
    gray: "_119b8yml",
    blue: "_119b1w55",
    green: "_119b1crs",
    red: "_119b16y8",
    yellow: "_119bfeiv",
    purple: "_119b1hqq",
    lime: "_119bnf89",
    magenta: "_119buwd0",
    orange: "_119b1b2s",
    teal: "_119b1h3o"
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-unsafe-values -- match TagNew border color logic
var tagLikeBorderFilterStyles = null;
// Tag-like styles for custom content values (not plain text) when FF is on.
// Mirrors the TagNew component's visual appearance (padding, margins, sizing, colors).
// The container uses tag-like styling while Label/Remove sub-components are preserved
// so custom overrides (e.g. custom aria-labels, rendering objects as data) continue to work.
var multiValueTagLikeStyles = {
    root: "_1reo15vq _18m915vq _2rko12b0 _11c8wadc _1dqonqa1 _189ee4h9 _1mouze3t _195gze3t _1e0c116y _vchhusvi _kqswh2mm _4cvr1h6o _1wpz1h6o _1ul9ze3t _1o9zkb7n _p12ff6dh _4t3i1k92 _bfhksm61 _syazi7uo _80om73ad _3yq3glyw",
    labelWrapper: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _11c8wadc _1e0c1txw _4cvr1h6o _1ul9ze3t _1tkeidpf _2a9v1kw7",
    disabled: "_syaz1gmx _bfhki8nm",
    focused: "_syaz6x5g _bfhk1dpa _16qs1xv8 _1aewe4h9 _6up51j28 _1xdnnqa1"
};
var getMultiValueLabelText = function(children, data) {
    if (typeof children === 'string') return children;
    var label = data === null || data === void 0 ? void 0 : data.label;
    return typeof label === 'string' ? label : '';
};
var MultiValue = function(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, isFocused = props.isFocused, removeProps = props.removeProps, selectProps = props.selectProps, cropWithEllipsis = props.cropWithEllipsis;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    var labelText = getMultiValueLabelText(children, data);
    var isPlainLabel = typeof children === 'string';
    var ffTagUplifts = (0, _platformFeatureFlags.fg)('platform-dst-lozenge-tag-badge-visual-uplifts');
    var _getStyleProps1 = (0, _getStyleProps.getStyleProps)(props, 'multiValue', {
        'multi-value': true,
        'multi-value--is-disabled': isDisabled
    }), containerCss = _getStyleProps1.css, containerClassName = _getStyleProps1.className;
    var _getStyleProps2 = (0, _getStyleProps.getStyleProps)(props, 'multiValueLabel', {
        'multi-value__label': true
    }), labelCss = _getStyleProps2.css, labelClassName = _getStyleProps2.className;
    var _getStyleProps3 = (0, _getStyleProps.getStyleProps)(props, 'multiValueRemove', {
        'multi-value__remove': true
    }), removeCss = _getStyleProps3.css, removeClassName = _getStyleProps3.className;
    var hasCustomLabel = Label !== (0, _multiValueLabel.MultiValueLabel);
    // Plain labels: use Tag with fillContainer so it truncates like tag-like structure.
    if (ffTagUplifts && isPlainLabel && !hasCustomLabel) {
        var _ref = data !== null && data !== void 0 ? data : {}, elemBefore = _ref.elemBefore, tagColor = _ref.color;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, innerProps), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
            className: (0, _runtime.ax)([
                multiValueTagWrapperStyles.root,
                (0, _react1.cx)(props.className, containerClassName, props.xcss, '-multiValue')
            ]),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagDefault.default), {
                text: labelText,
                isRemovable: !isDisabled,
                removeButtonLabel: "".concat(labelText, ", remove"),
                onBeforeRemoveAction: function() {
                    var _removeProps_onClick;
                    (_removeProps_onClick = removeProps.onClick) === null || _removeProps_onClick === void 0 ? void 0 : _removeProps_onClick.call(removeProps, {});
                    return false;
                },
                color: tagColor !== null && tagColor !== void 0 ? tagColor : 'gray',
                elemBefore: elemBefore,
                hasMargin: false
            })
        }));
    }
    // FF on + custom content → tag-like path
    if (ffTagUplifts) {
        var colorKey = data === null || data === void 0 ? void 0 : data.color;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({
            "data-multi-value-tag-like": "true"
        }, innerProps), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- custom styles.multiValue overrides (e.g. colored borders) must be preserved
            style: containerCss,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
            className: (0, _runtime.ax)([
                multiValueTagLikeStyles.root,
                tagLikeColorStyles.gray,
                colorKey === 'blue' && tagLikeColorStyles.blue,
                colorKey === 'green' && tagLikeColorStyles.green,
                colorKey === 'red' && tagLikeColorStyles.red,
                colorKey === 'yellow' && tagLikeColorStyles.yellow,
                colorKey === 'purple' && tagLikeColorStyles.purple,
                colorKey === 'lime' && tagLikeColorStyles.lime,
                colorKey === 'magenta' && tagLikeColorStyles.magenta,
                colorKey === 'orange' && tagLikeColorStyles.orange,
                colorKey === 'teal' && tagLikeColorStyles.teal,
                "_1h6dpryq _1k671038 _13muu67f _oe6mmko7 _u8p61h4e _hg5mr3uz _1easrqqc",
                isDisabled && multiValueTagLikeStyles.disabled,
                isFocused && multiValueTagLikeStyles.focused,
                (0, _react1.cx)(props.className, containerClassName, props.xcss, '-multiValue')
            ]),
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: (0, _runtime.ax)([
                        multiValueTagLikeStyles.labelWrapper
                    ]),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Label, {
                        data: data,
                        innerProps: {
                            style: labelCss,
                            className: labelClassName
                        },
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                        className: labelClassName,
                        hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
                        selectProps: selectProps,
                        children: children
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(Remove, {
                    data: data,
                    innerProps: (0, _objectSpread._)({
                        style: removeCss,
                        className: removeClassName,
                        role: 'button',
                        tabIndex: -1,
                        'aria-label': "".concat(labelText || 'option', ", remove")
                    }, removeProps),
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                    className: removeClassName,
                    isDisabled: isDisabled,
                    selectProps: selectProps
                })
            ]
        }));
    }
    // FF off → default styles
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Container, {
        data: data,
        innerProps: (0, _objectSpread._)({
            style: containerCss,
            className: containerClassName
        }, innerProps),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: containerClassName,
        isFocused: isFocused,
        isDisabled: isDisabled,
        selectProps: selectProps,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Label, {
                data: data,
                innerProps: {
                    style: labelCss,
                    className: labelClassName
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: labelClassName,
                hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
                selectProps: selectProps,
                children: children
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Remove, {
                data: data,
                innerProps: (0, _objectSpread._)({
                    style: removeCss,
                    className: removeClassName,
                    role: 'button',
                    tabIndex: -1,
                    'aria-label': "".concat(labelText || 'option', ", remove")
                }, removeProps),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: removeClassName,
                isDisabled: isDisabled,
                selectProps: selectProps
            })
        ]
    });
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = MultiValue;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@compiled/react":"MfI9Z","@atlaskit/platform-feature-flags":"kO5t9","@atlaskit/tag":"8kGTk","../get-style-props":"aedDQ","./multi-value-label":"7EdfH","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8kGTk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return 0, _tagDefault.default;
});
parcelHelpers.export(exports, "RemovableTag", function() {
    return 0, _tagDefault.default;
});
parcelHelpers.export(exports, "SimpleTag", function() {
    return 0, _tag.SimpleTag;
});
// Export new visual refresh components
parcelHelpers.export(exports, "AvatarTag", function() {
    return 0, _tagNew.AvatarTag;
});
parcelHelpers.export(exports, "TagDropdownTrigger", function() {
    return 0, _tagNew.TagDropdownTrigger;
});
var _tag = require("./tag");
var _tagDefault = parcelHelpers.interopDefault(_tag);
var _tagNew = require("./tag-new");

},{"./tag":"e2YkD","./tag-new":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"e2YkD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SimpleTag", function() {
    return 0, _simpleTagDefault.default;
});
parcelHelpers.export(exports, "default", function() {
    return 0, _removableTagDefault.default;
});
parcelHelpers.export(exports, "RemovableTag", function() {
    return 0, _removableTagDefault.default;
});
parcelHelpers.export(exports, "AvatarTag", function() {
    return 0, _avatarTagDefault.default;
});
var _simpleTag = require("./simple-tag");
var _simpleTagDefault = parcelHelpers.interopDefault(_simpleTag);
var _removableTag = require("./removable-tag");
var _removableTagDefault = parcelHelpers.interopDefault(_removableTag);
var _avatarTag = require("../tag-new/avatar-tag");
var _avatarTagDefault = parcelHelpers.interopDefault(_avatarTag);

},{"./simple-tag":false,"./removable-tag":"l9BBl","../tag-new/avatar-tag":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"l9BBl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return 0, _removableDefault.default;
});
var _removable = require("./internal/removable");
var _removableDefault = parcelHelpers.interopDefault(_removable);

},{"./internal/removable":"is1Ms","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"is1Ms":[function(require,module,exports,__globalThis) {
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _analyticsNext = require("@atlaskit/analytics-next");
var _mergeRefs = require("@atlaskit/ds-lib/merge-refs");
var _mergeRefsDefault = parcelHelpers.interopDefault(_mergeRefs);
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var _lozenge = require("@atlaskit/lozenge");
var _lozengeDefault = parcelHelpers.interopDefault(_lozenge);
var _motion = require("@atlaskit/motion");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _tagNew = require("../../../tag-new");
var _tagNewDefault = parcelHelpers.interopDefault(_tagNew);
var _base = require("../shared/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _before = require("../shared/before");
var _beforeDefault = parcelHelpers.interopDefault(_before);
var _colorToLozengeAppearance = require("../shared/color-to-lozenge-appearance");
var _content = require("../shared/content");
var _contentDefault = parcelHelpers.interopDefault(_content);
var _removeButton = require("./remove-button");
var _removeButtonDefault = parcelHelpers.interopDefault(_removeButton);
var textLinkCssVar = '--ds-ctl';
var textDefaultCssVar = '--ds-ct';
var textActiveCssVar = '--ds-ctp';
var backgroundHoverCssVar = '--ds-cbh';
var backgroundActiveCssVar = '--ds-cba';
var TagStatus = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}(TagStatus || {});
var packageName = undefined;
var packageVersion = undefined;
var defaultBeforeRemoveAction = function() {
    return true;
};
/**
 * These hide the focus ring for the tag when its remove button is focused,
 * preventing a double focus ring.
 */ var removingStyles = null;
var RemovableTagComponent = /*#__PURE__*/ (0, _react.forwardRef)(function(_param, ref) {
    var appearance = _param.appearance, _param_elemBefore = _param.elemBefore, elemBefore = _param_elemBefore === void 0 ? null : _param_elemBefore, _param_isRemovable = _param.isRemovable, isRemovable = _param_isRemovable === void 0 ? true : _param_isRemovable, _param_text = _param.text, text = _param_text === void 0 ? '' : _param_text, _param_color = _param.color, color = _param_color === void 0 ? 'standard' : _param_color, href = _param.href, removeButtonLabel = _param.removeButtonLabel, testId = _param.testId, _param_onBeforeRemoveAction = _param.onBeforeRemoveAction, onBeforeRemoveAction = _param_onBeforeRemoveAction === void 0 ? defaultBeforeRemoveAction : _param_onBeforeRemoveAction, _param_onAfterRemoveAction = _param.onAfterRemoveAction, onAfterRemoveAction = _param_onAfterRemoveAction === void 0 ? (0, _noopDefault.default) : _param_onAfterRemoveAction, linkComponent = _param.linkComponent, migration_fallback = _param.migration_fallback, maxWidth = _param.maxWidth, _param_hasMargin = _param.hasMargin, hasMargin = _param_hasMargin === void 0 ? true : _param_hasMargin, swatchBefore = _param.swatchBefore, rest = (0, _objectWithoutProperties._)(_param, [
        "appearance",
        "elemBefore",
        "isRemovable",
        "text",
        "color",
        "href",
        "removeButtonLabel",
        "testId",
        "onBeforeRemoveAction",
        "onAfterRemoveAction",
        "linkComponent",
        "migration_fallback",
        "maxWidth",
        "hasMargin",
        "swatchBefore"
    ]);
    var _useState = (0, _slicedToArray._)((0, _react.useState)("showing"), 2), status = _useState[0], setStatus = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(false), 2), isHoverCloseButton = _useState1[0], setIsHoverCloseButton = _useState1[1];
    var onAfterRemoveActionWithAnalytics = (0, _analyticsNext.useCallbackWithAnalytics)(onAfterRemoveAction, {
        action: 'removed',
        actionSubject: 'tag',
        attributes: {
            componentName: 'tag',
            packageName: packageName,
            packageVersion: packageVersion
        }
    }, 'atlaskit');
    var handleRemoveComplete = (0, _react.useCallback)(function() {
        setStatus("removed");
    }, []);
    var handleRemoveRequest = (0, _react.useCallback)(function() {
        if (onBeforeRemoveAction && onBeforeRemoveAction()) {
            onAfterRemoveActionWithAnalytics(text);
            handleRemoveComplete();
        }
    }, [
        handleRemoveComplete,
        onBeforeRemoveAction,
        onAfterRemoveActionWithAnalytics,
        text
    ]);
    var onKeyPress = (0, _react.useCallback)(function(e) {
        var spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    var removingTag = (0, _react.useCallback)(function() {
        return setStatus("removing");
    }, []);
    var showingTag = (0, _react.useCallback)(function() {
        return setStatus("showing");
    }, []);
    var handleMouseOver = (0, _react.useCallback)(function() {
        return setIsHoverCloseButton(true);
    }, []);
    var handleMouseOut = (0, _react.useCallback)(function() {
        return setIsHoverCloseButton(false);
    }, []);
    var removeButton = isRemovable ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _removeButtonDefault.default), {
        "aria-label": "".concat(removeButtonLabel || 'Remove', " ").concat(text),
        onClick: handleRemoveRequest,
        onFocus: removingTag,
        onBlur: showingTag,
        onKeyPress: onKeyPress,
        onMouseOver: handleMouseOver,
        onMouseOut: handleMouseOut,
        testId: "close-button-".concat(testId)
    }) : undefined;
    // Handle migration_fallback: render Lozenge when flag is off and migration_fallback is 'lozenge'
    if (migration_fallback === 'lozenge' && !(0, _platformFeatureFlags.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        var lozengeAppearance = (0, _colorToLozengeAppearance.getLozengeAppearance)(color);
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lozengeDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({
            appearance: lozengeAppearance,
            isBold: false,
            testId: testId
        }, rest), {
            children: text
        }));
    }
    // Use new TagNew component behind feature flag
    // TagNew handles its own animation internally via RemovableWrapper
    if ((0, _platformFeatureFlags.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        var newColor = (0, _tagNew.colorMapping)[color || 'standard'];
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagNewDefault.default), {
            ref: ref,
            color: newColor,
            text: text,
            elemBefore: elemBefore,
            href: href,
            testId: testId,
            isRemovable: isRemovable,
            removeButtonLabel: removeButtonLabel,
            onBeforeRemoveAction: onBeforeRemoveAction,
            onAfterRemoveAction: onAfterRemoveActionWithAnalytics,
            maxWidth: maxWidth,
            hasMargin: hasMargin,
            swatchBefore: swatchBefore
        });
    }
    // Original implementation
    var content = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _contentDefault.default), {
        elemBefore: elemBefore,
        isRemovable: isRemovable,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent
    });
    var _obj;
    var hoverCloseButtonColors = (_obj = {
        backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
    }, // Tag background color on hover
    (0, _defineProperty._)(_obj, backgroundHoverCssVar, undefined), // Tag background color on press
    (0, _defineProperty._)(_obj, backgroundActiveCssVar, undefined), // The tag text on hover of remove button
    (0, _defineProperty._)(_obj, textDefaultCssVar, undefined), // 'elemBefore' text on press of remove button
    (0, _defineProperty._)(_obj, textActiveCssVar, undefined), // The tag link text on hover of remove button
    (0, _defineProperty._)(_obj, textLinkCssVar, undefined), _obj);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _motion.ExitingPersistence), {
        children: !(status === "removed") && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _motion.ShrinkOut), {
            onFinish: handleRemoveComplete,
            children: function(motion) {
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _baseDefault.default), {
                    ref: (0, _mergeRefsDefault.default)([
                        motion.ref,
                        ref
                    ]),
                    appearance: appearance,
                    color: color,
                    testId: testId,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    style: isHoverCloseButton ? hoverCloseButtonColors : undefined,
                    "data-removable": true,
                    "data-removing": status === "removing",
                    "data-ishoverclosebutton": isHoverCloseButton,
                    href: href,
                    before: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _beforeDefault.default), {
                        elemBefore: elemBefore
                    }),
                    contentElement: content,
                    after: removeButton,
                    className: (0, _runtime.ax)([
                        status === "removing" && "_z30c1r31 _twwiglyw _1pka1o36 _bqhtfiwo"
                    ])
                });
            }
        }, "atlaskit-removable-tag-legacy-shrink-out")
    });
});
/**
 * __Removable tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * Once a tag has been removed, it cannot be re-rendered. Removable tags are visible in "edit" mode or in multi-select controls.
 *
 */ var RemovableTag = /*#__PURE__*/ (0, _react.memo)(RemovableTagComponent);
exports.default = RemovableTag;

},{"@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","@swc/helpers/_/_sliced_to_array":"8PtL6","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/analytics-next":"auH4u","@atlaskit/ds-lib/merge-refs":"bhv2L","@atlaskit/ds-lib/noop":"2f3bg","@atlaskit/lozenge":"7FeBU","@atlaskit/motion":"gQd69","@atlaskit/platform-feature-flags":"kO5t9","../../../tag-new":"ixD9N","../shared/base":"lDHvo","../shared/before":"cI34r","../shared/color-to-lozenge-appearance":"ishBc","../shared/content":"6F0d0","./remove-button":"k6j75","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7FeBU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return 0, _lozengeDefault.default;
});
parcelHelpers.export(exports, "LozengeDropdownTrigger", function() {
    return 0, _lozengeDropdownTriggerDefault.default;
});
var _lozenge = require("./lozenge");
var _lozengeDefault = parcelHelpers.interopDefault(_lozenge);
var _lozengeDropdownTrigger = require("./new/lozenge-dropdown-trigger");
var _lozengeDropdownTriggerDefault = parcelHelpers.interopDefault(_lozengeDropdownTrigger);

},{"./lozenge":"kjxW8","./new/lozenge-dropdown-trigger":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kjxW8":[function(require,module,exports,__globalThis) {
/* lozenge.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _lozenge = require("./new/lozenge");
var _lozengeDefault = parcelHelpers.interopDefault(_lozenge);
/**
 * TODO: We should be using our bounded `cssMap` here, but most of
 * these styles from the visual refresh are not in the Design System.
 */ var styles = {
    container: "_2rkofajl _1reo15vq _18m915vq _1e0c116y _vchhusvi _kqswpfqs _1kz6184x _bozg1b66 _y4ti1b66",
    containerSubtle: "_1cwg1n1a",
    text: "_1reo15vq _18m915vq _ect4ttxp _1wyb1skh _zg8l4jg8 _k48pwu06 _vwz47vkz _1bto1l2s _1p1dangw _o5721q9c",
    customLetterspacing: "_1dyz9vsi",
    'bg.bold.default': "_bfhk1fkg",
    'bg.bold.inprogress': "_bfhk1ymo",
    'bg.bold.moved': "_bfhkxmjf",
    'bg.bold.new': "_bfhkshej",
    'bg.bold.removed': "_bfhk1366",
    'bg.bold.success': "_bfhk3uhp",
    'bg.subtle.default': "_bfhksm61",
    'bg.subtle.inprogress': "_bfhksm61",
    'bg.subtle.moved': "_bfhksm61",
    'bg.subtle.new': "_bfhksm61",
    'bg.subtle.removed': "_bfhksm61",
    'bg.subtle.success': "_bfhksm61",
    'outline.subtle.default': "_12ji14je _1qu2nqa1 _12y3t94y",
    'outline.subtle.inprogress': "_12jiuisw _1qu2nqa1 _12y3t94y",
    'outline.subtle.moved': "_12jih727 _1qu2nqa1 _12y3t94y",
    'outline.subtle.new': "_12ji157s _1qu2nqa1 _12y3t94y",
    'outline.subtle.removed': "_12jia2c0 _1qu2nqa1 _12y3t94y",
    'outline.subtle.success': "_12jin0nx _1qu2nqa1 _12y3t94y",
    'text.subtle': "_syazi7uo",
    'text.bold': "_syazwwip"
};
var appearanceTypes = [
    'default',
    'inprogress',
    'moved',
    'new',
    'removed'
];
var newSemanticColors = [
    'success',
    'discovery',
    'warning',
    'danger',
    'information',
    'neutral'
];
var appearanceMapping = {
    neutral: 'default',
    default: 'default',
    information: 'inprogress',
    inprogress: 'inprogress',
    warning: 'moved',
    moved: 'moved',
    removed: 'removed',
    danger: 'removed',
    success: 'success',
    discovery: 'new',
    new: 'new'
};
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ var LegacyLozenge = /*#__PURE__*/ (0, _react.memo)(function(param) {
    var children = param.children, testId = param.testId, _param_isBold = param.isBold, isBold = _param_isBold === void 0 ? false : _param_isBold, _param_appearance = param.appearance, appearance = _param_appearance === void 0 ? 'default' : _param_appearance, _param_maxWidth = param.maxWidth, maxWidth = _param_maxWidth === void 0 ? 200 : _param_maxWidth, style = param.style;
    var appearanceStyle = isBold ? 'bold' : 'subtle';
    var appearanceType = (0, _react.useMemo)(function() {
        return appearanceTypes.includes(appearance) || newSemanticColors.includes(appearance) ? appearanceMapping[appearance] : 'default';
    }, [
        appearance
    ]);
    var maxWidthValue = typeof maxWidth === 'string' ? maxWidth : "".concat(maxWidth, "px");
    var maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        style: {
            backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        "data-testid": testId,
        className: (0, _runtime.ax)([
            styles.container,
            styles["bg.".concat(appearanceStyle, ".").concat(appearanceType)],
            appearanceStyle === 'subtle' && styles["outline.subtle.".concat(appearanceType)],
            appearanceStyle === 'subtle' && styles.containerSubtle
        ]),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            style: {
                color: style === null || style === void 0 ? void 0 : style.color,
                // to negate paddingInline specified on Box above
                maxWidth: maxWidthIsPc ? '100%' : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")")
            },
            "data-testid": testId && "".concat(testId, "--text"),
            className: (0, _runtime.ax)([
                styles.text,
                (0, _platformFeatureFlags.fg)('platform-lozenge-custom-letterspacing') && styles.customLetterspacing,
                styles["text.".concat(appearanceStyle)]
            ]),
            children: children
        })
    });
});
LegacyLozenge.displayName = 'Lozenge';
/**
 * Wrapper component that switches between old and new Lozenge based on feature flag
 */ var LozengeWrapper = /*#__PURE__*/ (0, _react.memo)(function(props) {
    if ((0, _platformFeatureFlags.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lozengeDefault.default), (0, _objectSpread._)({}, props));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(LegacyLozenge, (0, _objectSpread._)({}, props));
});
LozengeWrapper.displayName = 'Lozenge';
exports.default = LozengeWrapper;

},{"@swc/helpers/_/_object_spread":"9gdrV","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/platform-feature-flags":"kO5t9","./new/lozenge":"3TPb8","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3TPb8":[function(require,module,exports,__globalThis) {
/* lozenge.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _lozengeBase = require("./lozenge-base");
var _lozengeBaseDefault = parcelHelpers.interopDefault(_lozengeBase);
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ var Lozenge = function(param) {
    var _param_appearance = param.appearance, appearance = _param_appearance === void 0 ? 'neutral' : _param_appearance, _param_spacing = param.spacing, spacing = _param_spacing === void 0 ? 'default' : _param_spacing, _param_maxWidth = param.maxWidth, maxWidth = _param_maxWidth === void 0 ? 200 : _param_maxWidth, style = param.style, testId = param.testId, children = param.children, iconBefore = param.iconBefore, trailingMetric = param.trailingMetric, trailingMetricAppearance = param.trailingMetricAppearance;
    var baseProps = {
        appearance: appearance,
        spacing: spacing,
        iconBefore: iconBefore,
        trailingMetric: trailingMetric,
        trailingMetricAppearance: trailingMetricAppearance,
        maxWidth: maxWidth,
        style: style,
        testId: testId,
        children: children
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lozengeBaseDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, baseProps), {
        children: children
    }));
};
Lozenge.displayName = 'Lozenge';
exports.default = Lozenge;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","./lozenge-base":"6KfoV","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6KfoV":[function(require,module,exports,__globalThis) {
/* lozenge-base.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _badge = require("@atlaskit/badge");
var _badgeDefault = parcelHelpers.interopDefault(_badge);
var _css = require("@atlaskit/css");
var _chevronDown = require("@atlaskit/icon/core/chevron-down");
var _chevronDownDefault = parcelHelpers.interopDefault(_chevronDown);
var _resizing = require("@atlaskit/motion/resizing");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _pressable = require("@atlaskit/primitives/pressable");
var _pressableDefault = parcelHelpers.interopDefault(_pressable);
var _spinner = require("@atlaskit/spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _getThemeStyles = require("./get-theme-styles");
var _iconRenderer = require("./icon-renderer");
var _iconRendererDefault = parcelHelpers.interopDefault(_iconRenderer);
var _utils = require("./utils");
// Get the pressed background color for the selected lozenge dropdown trigger
var pressedBackgroundMapping = {
    success: "var(--ds-background-success-subtler-pressed, #B3DF72)",
    warning: "var(--ds-background-warning-subtler-pressed, #FBC828)",
    danger: "var(--ds-background-danger-subtler-pressed, #FD9891)",
    information: "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    neutral: "var(--ds-background-neutral-pressed, #080F214A)",
    discovery: "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'accent-red': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'accent-orange': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'accent-yellow': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'accent-lime': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'accent-green': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'accent-teal': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'accent-blue': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'accent-purple': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'accent-magenta': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'accent-gray': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
};
var styles = {
    container: "_2rko12b0 _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6d1j28 _kqswh2mm _1e0c116y _4cvr1h6o _vchhusvi _4t3i1k92 _1q51v77o _85i5v77o _bozg1b66 _y4ti1b66",
    motionContainer: "_k8m01rje _1oeci9qs _6fl41d08",
    containerSpacious: "_2rko1qi0 _1tkeviql _1q511b66 _85i51b66 _bozgutpp _y4tiutpp",
    containerBadgePadding: "_y4ti303w",
    text: "_11c8wadc _1reo15vq _18m915vq _o5721q9c",
    textEllipsis: "_1bto1l2s",
    textClip: "_1btozryt",
    textSpacious: "_11c8fhey _k48p1wq8",
    textSelected: "_syaz6x5g",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t _lcxvglyw",
    metricBadgeWrapper: "_1e0c1txw",
    'metric.semantic.success': "_1bn8d6jc _4ayg1wl5",
    'metric.semantic.warning': "_1bn8bkku _4aygzr32",
    'metric.semantic.danger': "_1bn8jkmi _4ayg1r4b",
    'metric.semantic.information': "_1bn8ar1y _4ayg1c1j",
    'metric.semantic.neutral': "_1bn814je _4ayg1fkg _iymy8hz0 _16burnys",
    'metric.semantic.discovery': "_1bn85usi _4ayg18vq",
    'metric.inverse': "_1bn8vuon _4aygvuon",
    'semantic.success': "_1b3i4pcx _3wu01mps _bfhk14j0 _syaz1p1e",
    'semantic.warning': "_1b3iervl _3wu01xiv _bfhk10f4 _syazmgs1",
    'semantic.danger': "_1b3is4qr _3wu01bqt _bfhk18wg _syaz1blx",
    'semantic.information': "_1b3iyhbg _3wu0vbh5 _bfhk8lbg _syaz1qd9",
    'semantic.neutral': "_1b3i1cv2 _3wu01ihb _bfhki8nm _syazi7uo",
    'semantic.discovery': "_1b3iqm1h _3wu0v30g _bfhke670 _syaz1g72",
    'accent.red': "_1b3inbxb _3wu016y8 _bfhk1rtt _syazhwvp",
    'accent.orange': "_1b3i1j6y _3wu01b2s _bfhk165s _syaz7i1p",
    'accent.yellow': "_1b3i1oqg _3wu0feiv _bfhk1773 _syazekll",
    'accent.lime': "_1b3i8645 _3wu0nf89 _bfhkz2ec _syaz1ik3",
    'accent.green': "_1b3i17hp _3wu01crs _bfhk1wnw _syaz1y78",
    'accent.teal': "_1b3i8uof _3wu01h3o _bfhk1a17 _syaz12v7",
    'accent.blue': "_1b3i6txe _3wu01w55 _bfhk1dy8 _syaz1kyx",
    'accent.purple': "_1b3iuq3u _3wu01hqq _bfhk1nm4 _syaz1mn1",
    'accent.magenta': "_1b3iv8hk _3wu0uwd0 _bfhkv9ra _syaz1qur",
    'accent.gray': "_1b3i1diz _3wu08yml _bfhkysee _syaz1tmo",
    'interactive.semantic.success': "_irr31r82 _1di6d6jc",
    'interactive.semantic.warning': "_irr31yx4 _1di6bkku",
    'interactive.semantic.danger': "_irr370oi _1di6jkmi",
    'interactive.semantic.information': "_irr315aw _1di6ar1y",
    'interactive.semantic.neutral': "_irr3plhp _1di61gdz",
    'interactive.semantic.discovery': "_irr3rumk _1di65usi",
    'interactive.accent.red': "_irr3affd _1di61j5a",
    'interactive.accent.orange': "_irr31ei0 _1di6dpo3",
    'interactive.accent.yellow': "_irr31uw7 _1di61r9w",
    'interactive.accent.lime': "_irr31gf0 _1di62kxc",
    'interactive.accent.green': "_irr31e2h _1di6ybhx",
    'interactive.accent.teal': "_irr3kwwr _1di61jb0",
    'interactive.accent.blue': "_irr3815t _1di6rwxf",
    'interactive.accent.purple': "_irr3attl _1di63nfk",
    'interactive.accent.magenta': "_irr31axx _1di642ri",
    'interactive.accent.gray': "_irr3wejn _1di618ut",
    iconBorderFilter: "_1h6dzs9d _4uq11yqs _1k671038 _m71tr3uz _13muu67f _168qx19p _oe6mmko7 _189qkb7n _u8p61h4e _1t75u67f _hg5mr3uz _1f28f1ug _1xe213rw _1easxmrh _1r9r1ss3",
    iconBorderInteractiveFilter: "_1iel6xdd _111i1h4e _18dicjiy _hyog26zw _fdt01r5k _46v5hwvj _ylgq1r5k _bg3q9by0 _196p1btq _18mn783i _l0666xdd _pclnn8xv _ockq1r5k _aewt1n8h _4cvx7ddx _1cp21w66 _q4zt1csi _1gqs1mvc _75gv2l9f _1lh71sfd _ui3h1ct7 _11o31cha",
    containerSelected: "_1xe213kw",
    content: "_zulp1b66 _1e0c116y _4cvr1h6o",
    contentSpacious: "_zulp12x7",
    loadingContent: "_tzy4idpf",
    containerBadge: "_1ftrbpke",
    containerBadgeInteractive: "_1axm1bqy"
};
/**
 * __New Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 * This is the updated version with the new North Star visual language.
 */ var LozengeBase = /*#__PURE__*/ (0, _react.memo)(/*#__PURE__*/ (0, _react.forwardRef)(function(param, ref) {
    var children = param.children, testId = param.testId, appearance = param.appearance, iconBefore = param.iconBefore, trailingMetric = param.trailingMetric, trailingMetricAppearance = param.trailingMetricAppearance, _param_maxWidth = param.maxWidth, maxWidth = _param_maxWidth === void 0 ? 200 : _param_maxWidth, _param_spacing = param.spacing, spacing = _param_spacing === void 0 ? 'default' : _param_spacing, isSelected = param.isSelected, _param_isLoading = param.// for dropdown trigger
    isLoading, isLoading = _param_isLoading === void 0 ? false : _param_isLoading, // for dropdown trigger
    onClick = param.onClick, // for dropdown trigger
    style = param.style, analyticsContext = param.analyticsContext, interactionName = param.interactionName, ariaControls = param['aria-controls'], ariaExpanded = param['aria-expanded'], ariaHaspopup = param['aria-haspopup'], ariaLabel = param['aria-label'];
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), resizing = _useState[0], setResizing = _useState[1];
    var onFinishMotion = function() {
        return setResizing(false);
    };
    var resizingWidth = (0, _resizing.useResizing)({
        dimension: 'width',
        duration: "var(--ds-duration-medium, 200ms)",
        easing: "var(--ds-easing-inout-bold, cubic-bezier(0.4, 0, 0, 1))",
        onFinishMotion: onFinishMotion
    });
    var isInitialRender = (0, _react.useRef)(true);
    var isInteractive = typeof onClick === 'function';
    // Determine the effective color, with fallback logic for legacy appearances
    var resolvedColor = (0, _utils.resolveLozengeColor)(appearance) || 'neutral';
    var _getThemeStyles1 = (0, _getThemeStyles.getThemeStyles)(resolvedColor), category = _getThemeStyles1.category, key = _getThemeStyles1.key;
    var colorStyleKey = "".concat(category, ".").concat(key);
    var interactiveStyleKey = "interactive.".concat(category, ".").concat(key);
    var maxWidthValue = typeof maxWidth === 'string' ? maxWidth : "".concat(maxWidth, "px");
    var maxWidthIsPc = typeof maxWidth === 'string' && maxWidth.endsWith('%');
    var resolvedTrailingMetricAppearance = trailingMetricAppearance ? trailingMetricAppearance === 'inverse' ? 'inverse' : (0, _utils.resolveLozengeColor)(trailingMetricAppearance) : resolvedColor;
    var metricBadgeAppearance = resolvedTrailingMetricAppearance === 'inverse' ? 'inverse' : resolvedTrailingMetricAppearance != null && resolvedTrailingMetricAppearance.startsWith('accent-') ? 'neutral' : resolvedTrailingMetricAppearance !== null && resolvedTrailingMetricAppearance !== void 0 ? resolvedTrailingMetricAppearance : 'neutral';
    var metricStyleKey = resolvedTrailingMetricAppearance === 'inverse' ? 'metric.inverse' : resolvedTrailingMetricAppearance != null && !resolvedTrailingMetricAppearance.startsWith('accent-') ? "metric.semantic.".concat((0, _getThemeStyles.getThemeStyles)(resolvedTrailingMetricAppearance).key) : 'metric.semantic.neutral';
    var commonStyleOverrides = {
        backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
        maxWidth: maxWidthIsPc ? maxWidth : '100%'
    };
    var hasTrailingMetric = trailingMetric != null && trailingMetric !== '';
    var childrenKey = typeof children === 'string' ? children : undefined;
    (0, _react.useLayoutEffect)(function() {
        // Ignore initial render
        if (isInitialRender.current) {
            isInitialRender.current = false;
            return;
        }
        setResizing(true);
    }, [
        childrenKey
    ]);
    var enableMotionFG = (0, _platformFeatureFlags.fg)('platform-dst-motion-uplift');
    var innerContent = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", (0, _objectSpreadProps._)((0, _objectSpread._)({
        style: {
            // When maxWidth is a percentage, constrain the content wrapper
            // so text truncation works correctly within the flex layout
            maxWidth: maxWidthIsPc ? '100%' : undefined
        }
    }, enableMotionFG ? resizingWidth : undefined), {
        className: (0, _runtime.ax)([
            styles.content,
            spacing === 'spacious' && styles.contentSpacious,
            isLoading && styles.loadingContent
        ]),
        children: [
            iconBefore && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconRendererDefault.default), {
                size: spacing === 'spacious' ? 'medium' : 'small',
                icon: iconBefore,
                color: resolvedColor,
                testId: testId && "".concat(testId, "--icon")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                style: {
                    maxWidth: maxWidthIsPc ? undefined : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")"),
                    color: style === null || style === void 0 ? void 0 : style.color
                },
                "data-testid": testId && "".concat(testId, "--text"),
                className: (0, _runtime.ax)([
                    styles.text,
                    enableMotionFG && resizing ? styles.textClip : styles.textEllipsis,
                    spacing === 'spacious' && styles.textSpacious
                ]),
                children: children
            }),
            hasTrailingMetric && !resolvedColor.startsWith('accent-') && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                "data-lozenge-metric-wrapper": true,
                "data-testid": testId && "".concat(testId, "--metric"),
                className: (0, _runtime.ax)([
                    styles.metricBadgeWrapper
                ]),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badgeDefault.default), {
                    appearance: metricBadgeAppearance,
                    children: trailingMetric
                })
            }),
            isInteractive && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chevronDownDefault.default), {
                label: "",
                size: "small",
                color: 'currentColor',
                testId: testId && "".concat(testId, "--chevron")
            })
        ]
    }));
    if (isInteractive) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pressableDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({
        ref: ref,
        xcss: (0, _css.cx)(styles.container, (0, _platformFeatureFlags.fg)('platform-dst-motion-uplift') && styles.motionContainer, spacing === 'spacious' && styles.containerSpacious, !isSelected && styles.iconBorderFilter, !isLoading && styles.iconBorderInteractiveFilter, styles[colorStyleKey], !isLoading && styles[interactiveStyleKey], isSelected && styles.containerSelected, hasTrailingMetric && styles.containerBadge, hasTrailingMetric && styles.containerBadgeInteractive, hasTrailingMetric && styles[metricStyleKey])
    }, isLoading && {
        'aria-busy': true,
        'aria-disabled': true,
        isDisabled: true
    }), {
        "aria-label": isLoading ? 'Loading' : ariaLabel,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHaspopup,
        onClick: isLoading ? undefined : onClick,
        style: (0, _objectSpreadProps._)((0, _objectSpread._)({}, commonStyleOverrides), {
            // Specified because Pressable has a default border:none which overrides the border specified on the container
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            border: "solid var(--ds-border-width, 1px) ".concat(isSelected ? 'oklch(from var(--border-color) calc(l * var(--border-pressed-l-factor)) c h) !important' : 'transparent'),
            backgroundColor: isSelected ? pressedBackgroundMapping[resolvedColor] : undefined,
            cursor: isLoading ? 'progress' : 'pointer'
        }),
        testId: testId,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "LozengeDropdownTrigger",
        children: [
            innerContent,
            isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: (0, _runtime.ax)([
                    styles.loadingOverlay
                ]),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {
                    size: spacing === 'spacious' ? 'small' : 'xsmall',
                    label: ", Loading",
                    testId: testId ? "".concat(testId, "--loading-spinner") : undefined
                })
            })
        ]
    }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        ref: ref,
        style: commonStyleOverrides,
        "data-testid": testId,
        className: (0, _runtime.ax)([
            styles.container,
            spacing === 'spacious' && styles.containerSpacious,
            spacing !== 'spacious' && hasTrailingMetric && styles.containerBadgePadding,
            styles[colorStyleKey],
            hasTrailingMetric && styles[metricStyleKey],
            styles.iconBorderFilter,
            styles.containerBadge
        ]),
        children: innerContent
    });
}));
exports.default = LozengeBase;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_sliced_to_array":"8PtL6","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/badge":"7LdYV","@atlaskit/css":"fiaHp","@atlaskit/icon/core/chevron-down":"6b1ia","@atlaskit/motion/resizing":"6QUIe","@atlaskit/platform-feature-flags":"kO5t9","@atlaskit/primitives/pressable":"hoAxU","@atlaskit/spinner":"04ZYE","./get-theme-styles":"3iB86","./icon-renderer":"lnB1E","./utils":"gvJRu","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7LdYV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return 0, _badgeDefault.default;
});
var _badge = require("./badge");
var _badgeDefault = parcelHelpers.interopDefault(_badge);

},{"./badge":"i6GM8","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"i6GM8":[function(require,module,exports,__globalThis) {
/* badge.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _compiled = require("@atlaskit/primitives/compiled");
var _appearanceMapping = require("./appearance-mapping");
var _appearanceMappingToOld = require("./appearance-mapping-to-old");
var _badgeNew = require("./badge-new");
var _badgeNewDefault = parcelHelpers.interopDefault(_badgeNew);
var _formatValueWithNegativeSupport = require("./internal/format-value-with-negative-support");
/**
 * Visual refresh colors.
 * Hardcoded hex colors are used as the they will be updated in the labelling system work and we want to avoid frequent UI changes.\
 *
 * Using separate variables as opposed to an object, to comply with UI styling standard
 * https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-unsafe-values/usage#object-access
 */ var neutral300 = '#DDDEE1';
var red300 = '#FD9891';
var blue300 = '#8FB8F6';
var neutral1000 = '#292A2E';
var styles = {
    root: "_2rkolb4i _18zr1b66 _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _1o9zidpf _1kz6184x",
    added: "_bfhk1y9u _syazi7uo",
    default: "_bfhk1fkg _syazwwip",
    important: "_bfhk1366 _syazwwip",
    primary: "_bfhk1ymo _syazwwip",
    primaryInverted: "_bfhkvuon _syaz1oa5",
    removed: "_bfhk1gly _syazi7uo"
};
var badgeValueWithNegativeNumberSupported = function(children, max) {
    return typeof children === 'number' && typeof max === 'number' ? (0, _formatValueWithNegativeSupport.formatValueWithNegativeSupport)(children, max) : children;
};
/**
 * __Badge__
 *
 * This component gives you the full badge functionality and automatically formats the number you provide in \`children\`.
 *
 * - [Examples](https://atlassian.design/components/badge/examples)
 * - [Code](https://atlassian.design/components/badge/code)
 * - [Usage](https://atlassian.design/components/badge/usage)
 */ var Badge = /*#__PURE__*/ (0, _react.memo)(function Badge(param) {
    var _param_appearance = param.appearance, appearance = _param_appearance === void 0 ? 'default' : _param_appearance, _param_children = param.children, children = _param_children === void 0 ? 0 : _param_children, _param_max = param.max, max = _param_max === void 0 ? 99 : _param_max, style = param.style, testId = param.testId;
    if ((0, _platformFeatureFlags.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        // Map old appearance names to new ones
        var newAppearance = (0, _appearanceMapping.appearanceMapping)[appearance];
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badgeNewDefault.default), {
            appearance: newAppearance,
            max: max,
            style: style,
            testId: testId,
            children: children
        });
    }
    var oldAppearance = (0, _appearanceMappingToOld.appearanceMappingToOld)[appearance];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        "data-testid": testId,
        style: {
            background: style === null || style === void 0 ? void 0 : style.backgroundColor,
            color: style === null || style === void 0 ? void 0 : style.color
        },
        className: (0, _runtime.ax)([
            styles.root,
            styles[oldAppearance]
        ]),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _compiled.Text), {
            size: "small",
            align: "center",
            color: "inherit",
            children: badgeValueWithNegativeNumberSupported(children, max)
        })
    });
});
exports.default = Badge;

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/platform-feature-flags":"kO5t9","@atlaskit/primitives/compiled":"jhQE8","./appearance-mapping":"3MKRu","./appearance-mapping-to-old":"ft8u2","./badge-new":"ede97","./internal/format-value-with-negative-support":"aFQqp","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3MKRu":[function(require,module,exports,__globalThis) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "appearanceMapping", function() {
    return appearanceMapping;
});
var appearanceMapping = {
    added: 'success',
    removed: 'danger',
    default: 'neutral',
    primary: 'information',
    primaryInverted: 'inverse',
    important: 'danger',
    warning: 'warning',
    discovery: 'discovery',
    danger: 'danger',
    success: 'success',
    information: 'information',
    inverse: 'inverse',
    neutral: 'neutral'
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ft8u2":[function(require,module,exports,__globalThis) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "appearanceMappingToOld", function() {
    return appearanceMappingToOld;
});
var appearanceMappingToOld = {
    added: 'added',
    removed: 'removed',
    default: 'default',
    primary: 'primary',
    primaryInverted: 'primaryInverted',
    important: 'important',
    danger: 'removed',
    success: 'added',
    information: 'primary',
    inverse: 'primaryInverted',
    neutral: 'default',
    warning: 'default',
    discovery: 'default'
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ede97":[function(require,module,exports,__globalThis) {
/* badge-new.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _compiled = require("@atlaskit/primitives/compiled");
var _formatValue = require("./internal/format-value");
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ // Nested selectors with data attributes are required for theme switching
var stylesNew = {
    root: "_2rkolb4i _18zr1b66 _1rjcidpf _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _1o9zidpf _1kz6184x",
    success: "_syaz1p1e _bfhk14j0",
    danger: "_syaz1blx _bfhk18wg",
    warning: "_syazmgs1 _bfhk10f4",
    information: "_syaz1qd9 _bfhk8lbg",
    discovery: "_syaz1g72 _bfhke670",
    neutral: "_syazi7uo _bfhk7qp0",
    inverse: "_bfhkvuon _syazi7uo"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ var badgeValueWithNegativeNumberSupported = function(children, max) {
    return typeof children === 'number' && max ? (0, _formatValue.formatValue)(children, max) : children;
};
/**
 * __BadgeNew__
 *
 * New visual refresh implementation of Badge component for the labelling system.
 * This component is used when the 'platform-dst-lozenge-tag-badge-visual-uplifts' feature flag is enabled.
 *
 * Uses new appearance naming convention:
 * - success (green)
 * - danger (red)
 * - neutral (gray)
 * - information (blue)
 * - inverse (inverted colors)
 * - warning (orange/yellow)
 * - discovery (purple)
 */ var BadgeNew = /*#__PURE__*/ (0, _react.memo)(function BadgeNew(param) {
    var _param_appearance = param.appearance, appearance = _param_appearance === void 0 ? 'neutral' : _param_appearance, _param_children = param.children, children = _param_children === void 0 ? 0 : _param_children, _param_max = param.max, max = _param_max === void 0 ? 99 : _param_max, style = param.style, testId = param.testId;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        "data-testid": testId,
        style: {
            background: style === null || style === void 0 ? void 0 : style.backgroundColor,
            color: style === null || style === void 0 ? void 0 : style.color
        },
        className: (0, _runtime.ax)([
            stylesNew.root,
            stylesNew[appearance]
        ]),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _compiled.Text), {
            size: "small",
            align: "center",
            color: "inherit",
            children: badgeValueWithNegativeNumberSupported(children, max)
        })
    });
});
exports.default = BadgeNew;

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/primitives/compiled":"jhQE8","./internal/format-value":"fj3Me","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fj3Me":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatValue", function() {
    return formatValue;
});
function getSafeValue() {
    var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    var numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function formatValue(value, max) {
    var safeValue = getSafeValue(value);
    var safeMax = getSafeValue(max);
    if (safeMax && safeMax < safeValue) return "".concat(safeMax, "+");
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aFQqp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatValueWithNegativeSupport", function() {
    return formatValueWithNegativeSupport;
});
function getSafeValueWithNegativeSupport() {
    var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    var numericValue = +value;
    // NOTE: Changing below code as this causes custom fields -ve number to show up as zero in activity timeline.
    // This will ensure it renders correctly if it is a number otherwise renders 0
    // If the value is NaN, return it as is (assuming it's a non-numeric string)
    if (isNaN(numericValue)) return value;
    // Return the numeric value, allowing negative numbers
    return numericValue;
}
function formatValueWithNegativeSupport(value, max) {
    var safeValue = getSafeValueWithNegativeSupport(value);
    var safeMax = getSafeValueWithNegativeSupport(max);
    var hasSafeMaxValue = false;
    if (max !== undefined) hasSafeMaxValue = true;
    if (safeMax === Infinity && safeValue === Infinity) return "\u221E";
    if (hasSafeMaxValue && safeMax < safeValue) return "".concat(safeMax, "+");
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6QUIe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useResizing", function() {
    return 0, _resizing.useResizing;
});
parcelHelpers.export(exports, "Resizing", function() {
    return 0, _resizing.Resizing;
});
var _resizing = require("../resizing/resizing");

},{"../resizing/resizing":"bIdeR","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bIdeR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useResizing", function() {
    return useResizing;
});
parcelHelpers.export(exports, "Resizing", function() {
    return Resizing;
});
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _accessibility = require("../utils/accessibility");
var _timerHooks = require("../utils/timer-hooks");
var _useElementRef = require("../utils/use-element-ref");
var _useLayoutEffect = require("../utils/use-layout-effect");
var _useSnapshotBeforeUpdate = require("../utils/use-snapshot-before-update");
/**
 * Parses a CSS time value (e.g. `"0.2s"` or `"200ms"`) and returns milliseconds.
 * Falls back to 0 if the value cannot be parsed.
 */ function parseCSSTimeToMs(value) {
    var parsed = parseFloat(value);
    if (Number.isNaN(parsed)) return 0;
    if (value.endsWith('ms')) return parsed;
    return parsed * 1000;
}
/**
 * Returns `true` if any of the dimension(s) being animated have changed
 * between the previous and next measurements.
 */ function hasDimensionChanged(dimension, prev, next) {
    if (dimension === 'width') return prev.width !== next.width;
    if (dimension === 'height') return prev.height !== next.height;
    return prev.width !== next.width || prev.height !== next.height;
}
/**
 * Returns the CSS `transition-property` / `will-change` value for the
 * given dimension(s).
 */ function getDimensionPropertyList(dimension) {
    if (dimension === 'both') return 'width, height';
    return dimension;
}
var useResizing = function(param) {
    var dimension = param.dimension, duration = param.duration, easing = param.easing, onFinishMotion = param.onFinishMotion;
    var prevDimensions = (0, _react.useRef)();
    var _useElementRef1 = (0, _slicedToArray._)((0, _useElementRef.useElementRef)(), 2), element = _useElementRef1[0], setElementRef = _useElementRef1[1];
    var setTimeout = (0, _timerHooks.useSetTimeout)({
        cleanup: 'next-effect'
    });
    var requestAnimationFrame = (0, _timerHooks.useRequestAnimationFrame)();
    (0, _useSnapshotBeforeUpdate.useSnapshotBeforeUpdate)(function() {
        if ((0, _accessibility.isReducedMotion)() || !element) return;
        var rect = element.getBoundingClientRect();
        prevDimensions.current = {
            width: rect.width,
            height: rect.height
        };
    });
    (0, _useLayoutEffect.useLayoutEffect)(function() {
        if ((0, _accessibility.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination dimensions first.
        element.setAttribute('style', '');
        var rect = element.getBoundingClientRect();
        var nextDimensions = {
            width: rect.width,
            height: rect.height
        };
        if (!hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
            onFinishMotion === null || onFinishMotion === void 0 ? void 0 : onFinishMotion();
            return;
        }
        var propertyList = getDimensionPropertyList(dimension);
        var newStyles = {
            willChange: propertyList,
            transitionProperty: propertyList,
            transitionDuration: duration,
            boxSizing: 'border-box',
            transitionTimingFunction: easing
        };
        if (dimension === 'width' || dimension === 'both') newStyles.width = "".concat(prevDimensions.current.width, "px");
        if (dimension === 'height' || dimension === 'both') newStyles.height = "".concat(prevDimensions.current.height, "px");
        Object.assign(element.style, newStyles);
        var resolvedDuration = parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(function() {
            requestAnimationFrame(function() {
                if (!element) return;
                if (dimension === 'width' || dimension === 'both') element.style.width = "".concat(nextDimensions.width, "px");
                if (dimension === 'height' || dimension === 'both') element.style.height = "".concat(nextDimensions.height, "px");
                setTimeout(function() {
                    if (!element) return;
                    element.setAttribute('style', '');
                    onFinishMotion === null || onFinishMotion === void 0 ? void 0 : onFinishMotion();
                }, resolvedDuration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
var Resizing = function(_param) {
    var children = _param.children, props = (0, _objectWithoutProperties._)(_param, [
        "children"
    ]);
    var resizing = useResizing(props);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: children(resizing)
    });
};

},{"@swc/helpers/_/_object_without_properties":"6HqIM","@swc/helpers/_/_sliced_to_array":"8PtL6","react/jsx-runtime":"bGvcw","react":"ltHCL","../utils/accessibility":"ek4Xd","../utils/timer-hooks":"NzLQz","../utils/use-element-ref":"fVKiA","../utils/use-layout-effect":"1IyB9","../utils/use-snapshot-before-update":"h1B8O","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"h1B8O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSnapshotBeforeUpdate", function() {
    return useSnapshotBeforeUpdate;
});
var _react = require("react");
var _useLayoutEffect = require("../utils/use-layout-effect");
var useSnapshotBeforeUpdate = function(cb) {
    var isFirstRender = (0, _react.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, _useLayoutEffect.useLayoutEffect)(function() {
        isFirstRender.current = false;
    }, []);
};

},{"react":"ltHCL","../utils/use-layout-effect":"1IyB9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hoAxU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return 0, _pressableDefault.default;
});
var _pressable = require("../components/pressable");
var _pressableDefault = parcelHelpers.interopDefault(_pressable);

},{"../components/pressable":"508Dd","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3iB86":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getThemeStyles", function() {
    return getThemeStyles;
});
var getThemeStyles = function(resolvedColor) {
    var isAccent = resolvedColor.startsWith('accent-');
    var category = isAccent ? 'accent' : 'semantic';
    var key = isAccent ? resolvedColor.replace('accent-', '') : resolvedColor;
    return {
        category: category,
        key: key
    };
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lnB1E":[function(require,module,exports,__globalThis) {
/* icon-renderer.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconRenderer", function() {
    return IconRenderer;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _compiled = require("@atlaskit/primitives/compiled");
// Map lozenge colors to appropriate icon colors
var getIconColor = function(color) {
    // For semantic colors, use corresponding semantic icon colors
    switch(color){
        case 'success':
            return "var(--ds-icon-success, #6A9A23)";
        case 'warning':
            return "var(--ds-icon-warning, #E06C00)";
        case 'danger':
            return "var(--ds-icon-danger, #C9372C)";
        case 'information':
            return "var(--ds-icon-information, #357DE8)";
        case 'neutral':
            return "var(--ds-icon-subtlest, #6B6E76)";
        case 'discovery':
            return "var(--ds-icon-discovery, #AF59E1)";
        // For accent colors, use corresponding accent icon colors
        case 'accent-red':
            return "var(--ds-icon-accent-red, #C9372C)";
        case 'accent-orange':
            return "var(--ds-icon-accent-orange, #E06C00)";
        case 'accent-yellow':
            return "var(--ds-icon-accent-yellow, #B38600)";
        case 'accent-lime':
            return "var(--ds-icon-accent-lime, #6A9A23)";
        case 'accent-green':
            return "var(--ds-icon-accent-green, #22A06B)";
        case 'accent-teal':
            return "var(--ds-icon-accent-teal, #2898BD)";
        case 'accent-blue':
            return "var(--ds-icon-accent-blue, #357DE8)";
        case 'accent-purple':
            return "var(--ds-icon-accent-purple, #AF59E1)";
        case 'accent-magenta':
            return "var(--ds-icon-accent-magenta, #CD519D)";
        case 'accent-gray':
            return "var(--ds-icon-accent-gray, #7D818A)";
        default:
            return "var(--ds-icon-subtlest, #6B6E76)";
    }
};
var styles = {
    motion: "_k8m01ylx _1oeci9qs _6fl41d08"
}; /**
    * Icon renderer for lozenge components
    * Handles proper sizing and color theming for icons
    */ 
var IconRenderer = function(param) {
    var Icon = param.icon, color = param.color, testId = param.testId, size = param.size;
    var iconColor = getIconColor(color);
    return (0, _platformFeatureFlags.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _compiled.Box), {
        xcss: styles.motion,
        style: {
            color: iconColor
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Icon, {
            label: "",
            size: size,
            testId: testId
        })
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(Icon, {
        color: iconColor,
        label: "",
        size: size,
        testId: testId
    });
};
exports.default = IconRenderer;

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","@atlaskit/platform-feature-flags":"kO5t9","@atlaskit/primitives/compiled":"jhQE8","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gvJRu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getThemeStyles", function() {
    return 0, _getThemeStyles.getThemeStyles;
});
parcelHelpers.export(exports, "resolveLozengeColor", function() {
    return resolveLozengeColor;
});
var _getThemeStyles = require("./get-theme-styles");
// Map legacy appearance to new color values
var legacyAppearanceMap = {
    default: 'neutral',
    removed: 'danger',
    inprogress: 'information',
    new: 'discovery',
    moved: 'warning'
};
var resolveLozengeColor = function() {
    var appearance = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'neutral';
    if (appearance.startsWith('accent-')) return appearance;
    var _legacyAppearanceMap_appearance;
    return (_legacyAppearanceMap_appearance = legacyAppearanceMap[appearance]) !== null && _legacyAppearanceMap_appearance !== void 0 ? _legacyAppearanceMap_appearance : appearance;
};

},{"./get-theme-styles":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ixD9N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return 0, _tagNewDefault.default;
});
parcelHelpers.export(exports, "TagNew", function() {
    return 0, _tagNewDefault.default;
});
parcelHelpers.export(exports, "colorMapping", function() {
    return 0, _tagNew.colorMapping;
});
parcelHelpers.export(exports, "AvatarTag", function() {
    return 0, _avatarTagDefault.default;
});
parcelHelpers.export(exports, "TagDropdownTrigger", function() {
    return 0, _tagDropdownTriggerDefault.default;
});
var _tagNew = require("./tag-new");
var _tagNewDefault = parcelHelpers.interopDefault(_tagNew);
var _avatarTag = require("./avatar-tag");
var _avatarTagDefault = parcelHelpers.interopDefault(_avatarTag);
var _tagDropdownTrigger = require("./tag-dropdown-trigger");
var _tagDropdownTriggerDefault = parcelHelpers.interopDefault(_tagDropdownTrigger);

},{"./tag-new":"a2MGa","./avatar-tag":false,"./tag-dropdown-trigger":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"a2MGa":[function(require,module,exports,__globalThis) {
/* tag-new.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "colorMapping", function() {
    return 0, _colorMapping.colorMapping;
});
parcelHelpers.export(exports, "TagDropdownTriggerComponent", function() {
    return TagDropdownTriggerComponent;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _react1 = require("@compiled/react");
var _chevronDown = require("@atlaskit/icon/core/chevron-down");
var _chevronDownDefault = parcelHelpers.interopDefault(_chevronDown);
var _compiled = require("@atlaskit/primitives/compiled");
var _spinner = require("@atlaskit/spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _colorMapping = require("./color-mapping");
var _shared = require("./shared");
var _swatchBefore = require("./swatch-before");
var _swatchBeforeDefault = parcelHelpers.interopDefault(_swatchBefore);
var _useButtonInteraction = require("./use-button-interaction");
var _useLink = require("./use-link");
var _useTagRemoval = require("./use-tag-removal");
// CSS variable name for icon color - must be used as literal string in cssMap due to Compiled CSS static analysis
var iconColorVar = '--ds-tag-icon';
var styles = {
    baseStyles: "_zulp1b66 _2rko12b0 _11c8wadc _1dqonqa1 _189ee4h9 _1rjcv77o _18zr1mie _1mou1b66 _195g1b66 _1e0c116y _vchhusvi _1ul9idpf _p12ff6dh _4t3i1k92 _kqswh2mm _4cvr1h6o _80om73ad _bfhksm61",
    noMarginStyles: "_1mouze3t _195gze3t",
    removableStyles: "_zulp1b66",
    beforeStyles: "_4bfu1snc _1hmsagmp _ajmmvv82 _1e0c116y _4cvr1h6o _1o9zidpf _syaz125o",
    beforeStylesSelected: "_syazxl6c",
    textStyles: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _16jlkb7n _1ul9idpf _syazi7uo",
    textStylesSelected: "_syaz6x5g",
    afterStyles: "_1e0c1txw _4cvr1h6o _1o9zidpf _lcxv1wug _kqswh2mm",
    focusRingStyles: "_1ygbdfik _1ah3v77o",
    childFocusRingStyles: "_1a37dfik _1cwgv77o",
    interactiveBaseStyles: "_80omtlke _1all1b66 _qsdj1r31 _17ncglyw _15hpnqa1 _1rg815vq _1yoo15vq _j8j91snc _1afaagmp _gdbt10yn _h5vp116y _1qxz1h6o _8zx0idpf _1km4jdj5 _wc1fagmp _9408jdj5 _usew1snc _ebtnagmp _uvk910yn _10nj1r31 _1xq0glyw _18x1nqa1 _2mpsagmp",
    interactiveHoverStyles: "_17501r31 _qrsc8stv _1wodnqa1 _irr31dpa _rlyhjdj5 _1di6fcek"
};
// Border and icon color styles - each color sets CSS variables for its token values
var colorStyles = {
    gray: "_119b8yml _1ib21diz",
    blue: "_119b1w55 _1ib26txe",
    green: "_119b1crs _1ib217hp",
    red: "_119b16y8 _1ib2nbxb",
    yellow: "_119bfeiv _1ib21oqg",
    purple: "_119b1hqq _1ib2uq3u",
    lime: "_119bnf89 _1ib28645",
    magenta: "_119buwd0 _1ib2v8hk",
    orange: "_119b1b2s _1ib21j6y",
    teal: "_119b1h3o _1ib28uof"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-unsafe-values */ // Border + icon filter styles - base state
var borderIconFilterStyles = {
    root: "_1h6dpryq _1k671038 _13muu67f _oe6mmko7 _m71tr3uz _168qx19p _wi6h1o1e _4uq11yqs _u8p61h4e _hg5mr3uz _1t75u67f _1f28f1ug _189qkb7n _1easrqqc _1knhjbtf"
};
// Border + icon filter styles - interactive states (hover/pressed)
var borderIconInteractiveFilterStyles = {
    root: "_18dicjiy _hyog26zw _ylgq1r5k _bg3q9by0 _fdt01r5k _46v5hwvj _1iel6xdd _111i1h4e _l0666xdd _pclnn8xv _ockq1r5k _aewt1n8h _196p1btq _18mn783i _4cvxpc7y _zqoikzix _q4zt1ij0 _ba351r2o _75gvn2k3 _kgu3swso _ui3h1vs5 _1r84p7hp"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-unsafe-values */ var dropdownStyles = {
    interactive: "_irr31dpa _1di6fcek",
    selected: "_1h6dq98m _syaz6x5g _bfhk15s3 _irr3ufnl _1di6nozp",
    content: "_zulp1b66 _1reo15vq _18m915vq _1e0c116y _4cvr1h6o _16jlkb7n _1o9zkb7n _1ul9idpf",
    loadingContent: "_tzy4idpf",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t _lcxvglyw"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-unsafe-values */ /**
 * __TagNew__
 *
 * TagNew is the visual uplift implementation of Tag
 */ var TagNewComponent = /*#__PURE__*/ (0, _react.forwardRef)(function TagNew(_param, ref) {
    var _param_color = _param.color, color = _param_color === void 0 ? 'gray' : _param_color, text = _param.text, elemBefore = _param.elemBefore, href = _param.href, linkComponent = _param.linkComponent, _param_isRemovable = _param.isRemovable, isRemovable = _param_isRemovable === void 0 ? true : _param_isRemovable, removeButtonLabel = _param.removeButtonLabel, onBeforeRemoveAction = _param.onBeforeRemoveAction, onAfterRemoveAction = _param.onAfterRemoveAction, testId = _param.testId, maxWidth = _param.maxWidth, _param_hasMargin = _param.hasMargin, hasMargin = _param_hasMargin === void 0 ? true : _param_hasMargin, onClick = _param.onClick, swatchBefore = _param.swatchBefore, other = (0, _objectWithoutProperties._)(_param, [
        "color",
        "text",
        "elemBefore",
        "href",
        "linkComponent",
        "isRemovable",
        "removeButtonLabel",
        "onBeforeRemoveAction",
        "onAfterRemoveAction",
        "testId",
        "maxWidth",
        "hasMargin",
        "onClick",
        "swatchBefore"
    ]);
    var _useTagRemoval1 = (0, _useTagRemoval.useTagRemoval)(onBeforeRemoveAction), status = _useTagRemoval1.status, handleRemoveRequest = _useTagRemoval1.handleRemoveRequest, onKeyPress = _useTagRemoval1.onKeyPress, removingTag = _useTagRemoval1.removingTag, showingTag = _useTagRemoval1.showingTag;
    var onShrinkOutExitComplete = (0, _react.useCallback)(function() {
        onAfterRemoveAction === null || onAfterRemoveAction === void 0 ? void 0 : onAfterRemoveAction(text);
    }, [
        onAfterRemoveAction,
        text
    ]);
    var _useLink1 = (0, _useLink.useLink)(href, linkComponent), isLink = _useLink1.isLink, LinkComponent = _useLink1.LinkComponent;
    var _useButtonInteraction1 = (0, _useButtonInteraction.useButtonInteraction)(), isLinkHovered = _useButtonInteraction1.isLinkHovered, isOverButton = _useButtonInteraction1.isOverButton, isButtonFocused = _useButtonInteraction1.isButtonFocused, isLinkFocused = _useButtonInteraction1.isLinkFocused, buttonHandlers = _useButtonInteraction1.buttonHandlers, linkHandlers = _useButtonInteraction1.linkHandlers;
    var removeButton = (0, _shared.useRemoveButton)({
        isRemovable: isRemovable,
        tagText: text,
        removeButtonLabel: removeButtonLabel,
        testId: testId,
        handleRemoveRequest: handleRemoveRequest,
        removingTag: removingTag,
        showingTag: showingTag,
        onKeyPress: onKeyPress,
        buttonHandlers: buttonHandlers
    });
    var tagContent = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", (0, _objectSpreadProps._)((0, _objectSpread._)({}, other), {
        ref: ref,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: maxWidth !== undefined ? {
            maxWidth: maxWidth
        } : undefined,
        className: (0, _runtime.ax)([
            styles.baseStyles,
            !hasMargin && styles.noMarginStyles,
            colorStyles[color],
            borderIconFilterStyles.root,
            isLink && styles.interactiveBaseStyles,
            isLink && styles.focusRingStyles,
            isLink && isLinkHovered && !isOverButton && borderIconInteractiveFilterStyles.root,
            isLink && isLinkHovered && !isOverButton && styles.interactiveHoverStyles,
            isRemovable && styles.removableStyles,
            isLinkFocused && !isButtonFocused && styles.childFocusRingStyles
        ]),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _shared.LinkWrapper), {
                isLink: isLink,
                href: href,
                LinkComponent: LinkComponent,
                testId: testId,
                linkHandlers: linkHandlers,
                onClick: onClick,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _swatchBeforeDefault.default), {
                        colorKey: color,
                        swatchBefore: swatchBefore
                    }),
                    elemBefore && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: (0, _runtime.ax)([
                            styles.beforeStyles
                        ]),
                        children: elemBefore
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        "data-tag-text": true,
                        className: (0, _runtime.ax)([
                            styles.textStyles
                        ]),
                        children: text
                    })
                ]
            }),
            removeButton && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: (0, _runtime.ax)([
                    styles.afterStyles
                ]),
                children: removeButton
            })
        ]
    }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _shared.RemovableWrapper), {
        isRemovable: isRemovable,
        status: status,
        onShrinkOutExitComplete: isRemovable ? onShrinkOutExitComplete : undefined,
        children: tagContent
    });
});
var TagDropdownTriggerComponent = /*#__PURE__*/ (0, _react.forwardRef)(function TagDropdownTrigger(_param, ref) {
    var _param_color = _param.color, color = _param_color === void 0 ? 'gray' : _param_color, text = _param.text, elemBefore = _param.elemBefore, testId = _param.testId, maxWidth = _param.maxWidth, _param_hasMargin = _param.hasMargin, hasMargin = _param_hasMargin === void 0 ? true : _param_hasMargin, onClick = _param.onClick, _param_isSelected = _param.isSelected, isSelected = _param_isSelected === void 0 ? false : _param_isSelected, _param_isLoading = _param.isLoading, isLoading = _param_isLoading === void 0 ? false : _param_isLoading, _analyticsContext = _param.analyticsContext, _param_hasChevron = _param.hasChevron, hasChevron = _param_hasChevron === void 0 ? true : _param_hasChevron, swatchBefore = _param.swatchBefore, other = (0, _objectWithoutProperties._)(_param, [
        "color",
        "text",
        "elemBefore",
        "testId",
        "maxWidth",
        "hasMargin",
        "onClick",
        "isSelected",
        "isLoading",
        "analyticsContext",
        "hasChevron",
        "swatchBefore"
    ]);
    var resolvedColor = (0, _colorMapping.colorMapping)[color] || 'gray';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _compiled.Pressable), (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({
        ref: ref,
        // @ts-expect-error paddingInline is 0.1875rem
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, _react1.cx)(styles.baseStyles, !hasMargin && styles.noMarginStyles, colorStyles[resolvedColor], borderIconFilterStyles.root, borderIconInteractiveFilterStyles.root, isSelected && dropdownStyles.selected),
        onClick: isLoading ? undefined : onClick,
        style: {
            borderColor: isSelected ? "var(--ds-border-selected, #1868DB)" : undefined,
            cursor: isLoading ? 'progress' : 'pointer',
            maxWidth: maxWidth !== undefined ? maxWidth : undefined
        }
    }, isLoading && {
        'aria-busy': true,
        'aria-disabled': true,
        isDisabled: true
    }), {
        testId: testId
    }), other), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                className: (0, _runtime.ax)([
                    dropdownStyles.content,
                    isLoading && dropdownStyles.loadingContent
                ]),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _swatchBeforeDefault.default), {
                        colorKey: resolvedColor,
                        swatchBefore: swatchBefore
                    }),
                    elemBefore && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: (0, _runtime.ax)([
                            styles.beforeStyles,
                            isSelected && styles.beforeStylesSelected
                        ]),
                        children: elemBefore
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        "data-tag-text": true,
                        className: (0, _runtime.ax)([
                            styles.textStyles,
                            isSelected && styles.textStylesSelected
                        ]),
                        children: text
                    }),
                    hasChevron && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chevronDownDefault.default), {
                        label: "",
                        size: "small",
                        color: 'currentColor',
                        testId: testId && "".concat(testId, "--chevron")
                    })
                ]
            }),
            isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: (0, _runtime.ax)([
                    dropdownStyles.loadingOverlay
                ]),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {
                    size: 'xsmall',
                    label: ", Loading",
                    testId: testId ? "".concat(testId, "--loading-spinner") : undefined
                })
            })
        ]
    }));
});
/**
 * __Tag new__
 */ var TagNew = /*#__PURE__*/ (0, _react.memo)(TagNewComponent);
exports.default = TagNew;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@compiled/react":"MfI9Z","@atlaskit/icon/core/chevron-down":"6b1ia","@atlaskit/primitives/compiled":"jhQE8","@atlaskit/spinner":"04ZYE","./color-mapping":"5WV1u","./shared":"hJf5t","./swatch-before":"g2IuF","./use-button-interaction":"ehauP","./use-link":"6KJ32","./use-tag-removal":"jK6Ej","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5WV1u":[function(require,module,exports,__globalThis) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "colorMapping", function() {
    return colorMapping;
});
var colorMapping = {
    standard: 'gray',
    grey: 'gray',
    blue: 'blue',
    green: 'green',
    red: 'red',
    yellow: 'yellow',
    purple: 'purple',
    lime: 'lime',
    magenta: 'magenta',
    orange: 'orange',
    teal: 'teal',
    // Light variants map to same as their non-light counterparts
    greyLight: 'gray',
    blueLight: 'blue',
    greenLight: 'green',
    redLight: 'red',
    yellowLight: 'yellow',
    purpleLight: 'purple',
    limeLight: 'lime',
    magentaLight: 'magenta',
    orangeLight: 'orange',
    tealLight: 'teal'
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hJf5t":[function(require,module,exports,__globalThis) {
/* shared.tsx generated by @compiled/babel-plugin v0.39.1 */ /**
 * Shared utilities for TagNew and AvatarTag components.
 * Note: CSS styles cannot be shared due to Compiled CSS static analysis requirements.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TagStatus", function() {
    return 0, _tagStatus.TagStatus;
});
parcelHelpers.export(exports, "defaultBeforeRemoveAction", function() {
    return 0, _defaultBeforeRemoveAction.defaultBeforeRemoveAction;
});
parcelHelpers.export(exports, "noop", function() {
    return 0, _noop.noop;
});
parcelHelpers.export(exports, "useLink", function() {
    return 0, _useLink.useLink;
});
parcelHelpers.export(exports, "useButtonInteraction", function() {
    return 0, _useButtonInteraction.useButtonInteraction;
});
parcelHelpers.export(exports, "useTagRemoval", function() {
    return 0, _useTagRemoval.useTagRemoval;
});
parcelHelpers.export(exports, "iconColorVar", function() {
    return iconColorVar;
});
parcelHelpers.export(exports, "borderTokenVar", function() {
    return borderTokenVar;
});
parcelHelpers.export(exports, "iconTokenVar", function() {
    return iconTokenVar;
});
// Shared hook for remove button creation
// TODO: Fill in the hook {description}.
/**
 * {description}.
 */ parcelHelpers.export(exports, "useRemoveButton", function() {
    return useRemoveButton;
});
// Shared component for motion wrapper
parcelHelpers.export(exports, "RemovableWrapper", function() {
    return RemovableWrapper;
});
// Shared component for conditional link wrapping
parcelHelpers.export(exports, "LinkWrapper", function() {
    return LinkWrapper;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _motion = require("@atlaskit/motion");
var _removeButton = require("../tag/internal/removable/remove-button");
var _removeButtonDefault = parcelHelpers.interopDefault(_removeButton);
var _tagStatus = require("./tag-status");
var _defaultBeforeRemoveAction = require("./default-before-remove-action");
var _noop = require("./noop");
var _useLink = require("./use-link");
var _useButtonInteraction = require("./use-button-interaction");
var _useTagRemoval = require("./use-tag-removal");
var iconColorVar = '--ds-tag-icon';
var borderTokenVar = '--tag-border-token';
var iconTokenVar = '--tag-icon-token';
/**
 * Stable key so ExitingPersistence can match this child across the remove transition
 * (see ShrinkOut + ExitingPersistence docs in @atlaskit/motion).
 */ var removableShrinkOutChildKey = 'atlaskit-tag-removable-shrink-out';
var motionWrapperStyles = null;
function useRemoveButton(param) {
    var isRemovable = param.isRemovable, tagText = param.tagText, removeButtonLabel = param.removeButtonLabel, testId = param.testId, handleRemoveRequest = param.handleRemoveRequest, removingTag = param.removingTag, showingTag = param.showingTag, onKeyPress = param.onKeyPress, _param_shape = param.shape, shape = _param_shape === void 0 ? 'default' : _param_shape, buttonHandlers = param.buttonHandlers;
    var handleFocus = (0, _react.useCallback)(function() {
        removingTag();
        buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onFocus();
    }, [
        removingTag,
        buttonHandlers
    ]);
    var handleBlur = (0, _react.useCallback)(function() {
        showingTag();
        buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onBlur();
    }, [
        showingTag,
        buttonHandlers
    ]);
    return (0, _react.useMemo)(function() {
        if (!isRemovable) return undefined;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _removeButtonDefault.default), {
            "aria-label": "".concat(removeButtonLabel || 'Remove', " ").concat(tagText),
            onClick: handleRemoveRequest,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onKeyPress: onKeyPress,
            onMouseEnter: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseEnter,
            onMouseLeave: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseLeave,
            onMouseDown: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseDown,
            testId: testId ? "close-button-".concat(testId) : undefined,
            shape: shape
        });
    }, [
        isRemovable,
        removeButtonLabel,
        tagText,
        handleRemoveRequest,
        handleFocus,
        handleBlur,
        onKeyPress,
        buttonHandlers,
        testId,
        shape
    ]);
}
function RemovableWrapper(param) {
    var isRemovable = param.isRemovable, status = param.status, onShrinkOutExitComplete = param.onShrinkOutExitComplete, children = param.children;
    if (isRemovable) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _motion.ExitingPersistence), {
        children: !(status === (0, _tagStatus.TagStatus).Removed) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _motion.ShrinkOut), {
            onFinish: onShrinkOutExitComplete ? function(phase) {
                if (phase === 'exiting') onShrinkOutExitComplete();
            } : undefined,
            children: function(motion) {
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    ref: motion.ref,
                    className: (0, _runtime.ax)([
                        "_1e0c116y"
                    ]),
                    children: children
                });
            }
        }, removableShrinkOutChildKey)
    });
    return children;
}
function LinkWrapper(param) {
    var isLink = param.isLink, href = param.href, LinkComponent = param.LinkComponent, testId = param.testId, children = param.children, onClick = param.onClick, linkHandlers = param.linkHandlers;
    if (isLink && href) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(LinkComponent, {
        href: href,
        testId: testId ? "".concat(testId, "--link") : undefined,
        onClick: onClick,
        onMouseEnter: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseEnter,
        onMouseLeave: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseLeave,
        onMouseDown: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseDown,
        onFocus: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onFocus,
        onBlur: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onBlur,
        children: children
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Fragment), {
        children: children
    });
}

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/motion":"gQd69","../tag/internal/removable/remove-button":"k6j75","./tag-status":"5x75Z","./default-before-remove-action":false,"./noop":false,"./use-link":false,"./use-button-interaction":false,"./use-tag-removal":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"k6j75":[function(require,module,exports,__globalThis) {
/* remove-button.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _css = require("@atlaskit/css");
var _cross = require("@atlaskit/icon/core/cross");
var _crossDefault = parcelHelpers.interopDefault(_cross);
var _compiled = require("@atlaskit/primitives/compiled");
var removeButtonStyles = {
    root: "_19itglyw _2rkolb4i _195gze3t _1mouze3t _18zrze3t _1rjcze3t _1e0c1txw _4t3i1j6v _1bsb1j6v _rjxpze3t _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhksm61 _syazi7uo _80omtlke _lcxv1wug _ahbq1i6y _12l21i6y _1ah3idpf _irr31dpa _1di6fcek",
    circle: "_2rko1rr0 _1ah3idpf"
};
var removeButtonStylesNewIcon = {
    root: "_rjxpv77o"
};
var RemoveButton = function(param) {
    var ariaLabel = param['aria-label'], onClick = param.onClick, onFocus = param.onFocus, onBlur = param.onBlur, onKeyPress = param.onKeyPress, onMouseOver = param.onMouseOver, onMouseOut = param.onMouseOut, onMouseDown = param.onMouseDown, onMouseUp = param.onMouseUp, onMouseEnter = param.onMouseEnter, onMouseLeave = param.onMouseLeave, testId = param.testId, _param_shape = param.shape, shape = _param_shape === void 0 ? 'default' : _param_shape;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _compiled.Pressable), {
        xcss: (0, _css.cx)(removeButtonStyles.root, shape === 'circle' && removeButtonStyles.circle, removeButtonStylesNewIcon.root),
        "aria-label": ariaLabel,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyPress: onKeyPress,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        testId: testId,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _crossDefault.default), {
            color: "currentColor",
            label: "",
            size: "small"
        })
    });
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = RemoveButton;

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","@atlaskit/css":"fiaHp","@atlaskit/icon/core/cross":"cnbEZ","@atlaskit/primitives/compiled":"jhQE8","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5x75Z":[function(require,module,exports,__globalThis) {
// Tag status enum
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TagStatus", function() {
    return TagStatus;
});
var TagStatus = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}({});

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7Rtj6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultBeforeRemoveAction", function() {
    return defaultBeforeRemoveAction;
});
var defaultBeforeRemoveAction = function() {
    return true;
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6KJ32":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Shared hook for link handling
 */ parcelHelpers.export(exports, "useLink", function() {
    return useLink;
});
var _link = require("@atlaskit/link");
var _linkDefault = parcelHelpers.interopDefault(_link);
function useLink(href, linkComponent) {
    var isLink = Boolean(href);
    var LinkComponent = linkComponent !== null && linkComponent !== void 0 ? linkComponent : (0, _linkDefault.default);
    return {
        isLink: isLink,
        LinkComponent: LinkComponent
    };
}

},{"@atlaskit/link":"1WBY4","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ehauP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Hook for tracking link/button hover/focus state (replaces CSS :has() selectors in this component)
 */ parcelHelpers.export(exports, "useButtonInteraction", function() {
    return useButtonInteraction;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
function useButtonInteraction() {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), isLinkHovered = _useState[0], setIsLinkHovered = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(false), 2), isOverButton = _useState1[0], setIsOverButton = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(false), 2), isButtonFocused = _useState2[0], setIsButtonFocused = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)(false), 2), isLinkFocused = _useState3[0], setIsLinkFocused = _useState3[1];
    // Track if last interaction was via mouse (to determine keyboard vs mouse focus)
    var hadMouseDownRef = (0, _react.useRef)(false);
    // Button handlers
    var buttonHandlers = (0, _react.useMemo)(function() {
        return {
            onMouseEnter: function() {
                return setIsOverButton(true);
            },
            onMouseLeave: function() {
                return setIsOverButton(false);
            },
            onMouseDown: function(e) {
                // Prevent the browser from moving focus to the remove button on mousedown.
                // Without this, parent composite widgets (e.g. Select) lose input focus when
                // the user clicks remove, triggering unwanted blur side-effects.
                e === null || e === void 0 ? void 0 : e.preventDefault();
                hadMouseDownRef.current = true;
            },
            onFocus: function() {
                // Only track keyboard focus for focus ring styles
                // If mousedown happened just before focus, it's mouse focus (not keyboard)
                if (!hadMouseDownRef.current) setIsButtonFocused(true);
                hadMouseDownRef.current = false;
            },
            onBlur: function() {
                return setIsButtonFocused(false);
            }
        };
    }, []);
    // Link handlers - includes hover tracking
    var linkHandlers = (0, _react.useMemo)(function() {
        return {
            onMouseEnter: function() {
                return setIsLinkHovered(true);
            },
            onMouseLeave: function() {
                return setIsLinkHovered(false);
            },
            onMouseDown: function() {
                hadMouseDownRef.current = true;
            },
            onFocus: function() {
                // Only track keyboard focus for focus ring styles
                // If mousedown happened just before focus, it's mouse focus (not keyboard)
                if (!hadMouseDownRef.current) setIsLinkFocused(true);
                hadMouseDownRef.current = false;
            },
            onBlur: function() {
                return setIsLinkFocused(false);
            }
        };
    }, []);
    return {
        isLinkHovered: isLinkHovered,
        isOverButton: isOverButton,
        isButtonFocused: isButtonFocused,
        isLinkFocused: isLinkFocused,
        buttonHandlers: buttonHandlers,
        linkHandlers: linkHandlers
    };
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jK6Ej":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * {description}.
 */ parcelHelpers.export(exports, "useTagRemoval", function() {
    return useTagRemoval;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _defaultBeforeRemoveAction = require("./default-before-remove-action");
var _tagStatus = require("./tag-status");
function useTagRemoval(onBeforeRemoveAction) {
    var _useState = (0, _slicedToArray._)((0, _react.useState)((0, _tagStatus.TagStatus).Showing), 2), status = _useState[0], setStatus = _useState[1];
    var handleRemoveRequest = (0, _react.useCallback)(function() {
        var beforeAction = onBeforeRemoveAction !== null && onBeforeRemoveAction !== void 0 ? onBeforeRemoveAction : (0, _defaultBeforeRemoveAction.defaultBeforeRemoveAction);
        if (beforeAction()) // Defer onAfterRemoveAction until ShrinkOut's onFinish so ExitingPersistence can run
        // the exit animation (e.g. in multi-select and user pickers).
        setStatus((0, _tagStatus.TagStatus).Removed);
    }, [
        onBeforeRemoveAction
    ]);
    var onKeyPress = (0, _react.useCallback)(function(e) {
        var spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    var removingTag = (0, _react.useCallback)(function() {
        return setStatus((0, _tagStatus.TagStatus).Removing);
    }, []);
    var showingTag = (0, _react.useCallback)(function() {
        return setStatus((0, _tagStatus.TagStatus).Showing);
    }, []);
    return {
        status: status,
        handleRemoveRequest: handleRemoveRequest,
        onKeyPress: onKeyPress,
        removingTag: removingTag,
        showingTag: showingTag
    };
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","react":"ltHCL","./default-before-remove-action":"7Rtj6","./tag-status":"5x75Z","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"g2IuF":[function(require,module,exports,__globalThis) {
/* swatch-before.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return SwatchBefore;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var tagSwatchBeforeStyles = {
    swatch: "_2rkolb4i _1bsboqnp _4t3ioqnp _1o9zidpf"
};
var tagSwatchBeforeColorStyles = {
    gray: "_bfhk18j9",
    blue: "_bfhk115i",
    green: "_bfhk1rsu",
    red: "_bfhkkrt9",
    yellow: "_bfhk8y3s",
    purple: "_bfhk18ah",
    lime: "_bfhkbq5w",
    magenta: "_bfhk1mi6",
    orange: "_bfhk1kkj",
    teal: "_bfhktdv8"
};
function SwatchBefore(param) {
    var colorKey = param.colorKey, swatchBefore = param.swatchBefore;
    if (swatchBefore === undefined || swatchBefore === false) return null;
    if (swatchBefore === true) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: (0, _runtime.ax)([
            tagSwatchBeforeStyles.swatch,
            tagSwatchBeforeColorStyles[colorKey]
        ])
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            backgroundColor: swatchBefore
        },
        className: (0, _runtime.ax)([
            tagSwatchBeforeStyles.swatch
        ])
    });
}

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lDHvo":[function(require,module,exports,__globalThis) {
/* base.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _runtime = require("@compiled/react/runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
// Border colors - Hardcoded for Visual Refresh - to be removed with labelling system work
var borderColors = {
    standard: "_1h6d14je",
    blue: "_1h6duisw",
    red: "_1h6da2c0",
    yellow: "_1h6deh2r",
    green: "_1h6d18uw",
    teal: "_1h6d1ug6",
    purple: "_1h6d157s",
    lime: "_1h6dn0nx",
    magenta: "_1h6d1lf6",
    orange: "_1h6dh727",
    grey: "_1h6d14je",
    standardLink: "_1h6d14je",
    blueLight: "_1h6duisw",
    redLight: "_1h6da2c0",
    yellowLight: "_1h6deh2r",
    greenLight: "_1h6d18uw",
    tealLight: "_1h6d1ug6",
    purpleLight: "_1h6d157s",
    limeLight: "_1h6dn0nx",
    magentaLight: "_1h6d1lf6",
    orangeLight: "_1h6dh727",
    greyLight: "_1h6d14je"
};
var baseStyles = null;
var interactiveStyles = null;
var focusRingStyles = null;
var BaseTag = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(function BaseTag(_param, ref) {
    var before = _param.before, contentElement = _param.contentElement, after = _param.after, testId = _param.testId, style = _param.style, _param_color = _param.color, color = _param_color === void 0 ? 'standard' : _param_color, href = _param.href, className = _param.className, other = (0, _objectWithoutProperties._)(_param, [
        "before",
        "contentElement",
        "after",
        "testId",
        "style",
        "color",
        "href",
        "className"
    ]);
    var isLink = Boolean(href);
    var isRemovable = Boolean(after);
    var isInteractive = isLink || isRemovable;
    if (color === 'gray') // internally we use 'grey' for gray color so that we can make migration easier behind the ff (gray will work with and without ff now)
    color = 'grey';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", (0, _objectSpreadProps._)((0, _objectSpread._)({}, other), {
        ref: ref,
        style: (0, _objectSpread._)({}, style),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, _runtime.ax)([
            "_zulp1b66 _2rko12b0 _1dqonqa1 _189ee4h9 _1mou1b66 _195g1b66 _18zr1b66 _1e0c116y _vchhusvi _1ul9idpf _4t3i1k92 _kqswh2mm _4cvr1h6o _bfhksm61 _syazi7uo _80om73ad",
            isInteractive && "_1e38dfik _7glxv77o",
            isLink && "_irr31dpa _1di6fcek",
            borderColors[color],
            className
        ]),
        "data-testid": testId,
        children: [
            before,
            contentElement,
            after
        ]
    }));
});
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = BaseTag;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react/jsx-runtime":"bGvcw","@compiled/react/runtime":"d27Vo","react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cI34r":[function(require,module,exports,__globalThis) {
/* before.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var beforeElementStyles = null;
var Before = function(param) {
    var elemBefore = param.elemBefore;
    return elemBefore ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: (0, _runtime.ax)([
            "_1e0c1txw _4t3i1j6v _4cvr1h6o _1bah1h6o _152tze3t"
        ]),
        children: elemBefore
    }) : null;
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = Before;

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ishBc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Gets the Lozenge appearance for a given Tag color.
 */ parcelHelpers.export(exports, "getLozengeAppearance", function() {
    return getLozengeAppearance;
});
/**
 * Maps Tag color values to Lozenge appearance values.
 * Used for migration_fallback rendering when feature flag is off.
 */ var colorToLozengeAppearanceMap = {
    gray: 'default',
    grey: 'default',
    lime: 'success',
    green: 'success',
    blue: 'inprogress',
    red: 'removed',
    purple: 'new',
    yellow: 'moved',
    orange: 'moved',
    magenta: 'new',
    teal: 'inprogress',
    grayLight: 'default',
    greyLight: 'default',
    limeLight: 'success',
    greenLight: 'success',
    blueLight: 'inprogress',
    redLight: 'removed',
    purpleLight: 'new',
    yellowLight: 'moved',
    orangeLight: 'moved',
    magentaLight: 'new',
    tealLight: 'inprogress'
};
function getLozengeAppearance(color) {
    return colorToLozengeAppearanceMap[color || 'gray'] || 'default';
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6F0d0":[function(require,module,exports,__globalThis) {
/* content.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var baseStyles = null;
var linkStyles = null;
var hasAfterStyles = null;
var Content = function(param) {
    var _param_isRemovable = param.isRemovable, isRemovable = _param_isRemovable === void 0 ? true : _param_isRemovable, _param_text = param.text, text = _param_text === void 0 ? '' : _param_text, _param_color = param.color, color = _param_color === void 0 ? 'standard' : _param_color, href = param.href, linkComponent = param.linkComponent, testId = param.testId;
    var Link = linkComponent !== null && linkComponent !== void 0 ? linkComponent : 'a';
    if (href) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Link, {
        href: href,
        "data-color": color,
        "data-testid": testId ? "".concat(testId, "--link") : undefined,
        className: (0, _runtime.ax)([
            "_11c8fhey _1reo15vq _18m915vq _p12ff6dh _1bto1l2s _o5721q9c",
            "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazi7uo _lcxv1wug _nt751r31 _49pcglyw _1hvw1o36 _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3i7uo _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
            isRemovable && "_p12f1lit"
        ]),
        children: text
    });
    else return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: (0, _runtime.ax)([
            "_11c8fhey _1reo15vq _18m915vq _p12ff6dh _1bto1l2s _o5721q9c",
            isRemovable && "_p12f1lit"
        ]),
        children: text
    });
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = Content;

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7EdfH":[function(require,module,exports,__globalThis) {
/* multi-value-label.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MultiValueLabel", function() {
    return MultiValueLabel;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _react1 = require("@compiled/react");
var multiValueLabelStyles = {
    root: "_1reo15vq _18m915vq _2rkolb4i _11c8fhey _o5721q9c _y4tiv77o _bozg1b66 _syaz1kw7",
    disabled: "_syaz1gmx",
    ellipsis: "_1bto1l2s"
};
var MultiValueLabel = function(param) {
    var children = param.children, innerProps = param.innerProps, isDisabled = param.isDisabled, hasEllipsis = param.hasEllipsis, className = param.className, xcss = param.xcss;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, innerProps), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, _runtime.ax)([
            multiValueLabelStyles.root,
            isDisabled && multiValueLabelStyles.disabled,
            hasEllipsis && multiValueLabelStyles.ellipsis,
            (0, _react1.cx)(className, xcss, '-MultiValueLabel')
        ]),
        children: children
    }));
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@compiled/react":"MfI9Z","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jaa70":[function(require,module,exports,__globalThis) {
/* multi-value-remove.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MultiValueRemove", function() {
    return MultiValueRemove;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _react1 = require("@compiled/react");
var _cross = require("@atlaskit/icon/core/cross");
var _crossDefault = parcelHelpers.interopDefault(_cross);
var disabledStyles = null;
var enabledStyles = null;
var multiValueRemoveStyles = {
    focused: "_bfhkb1q9 _lswu6x5g",
    root: "_19itglyw _2rko12b0 _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhksm61 _syazi7uo _1e0c1txw _lswui7uo _1q51v77o _y4tiv77o _85i5v77o _bozgv77o _12l2v77o _1ah312gs _irr31dpa _13br1tmw _1di6fcek _i5f81tmw"
};
function MultiValueRemove(param) {
    var isDisabled = param.isDisabled, isFocused = param.isFocused, innerProps = param.innerProps, className = param.className, xcss = param.xcss;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, innerProps), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, _runtime.ax)([
            multiValueRemoveStyles.root,
            isFocused && multiValueRemoveStyles.focused,
            (0, _react1.cx)(className, xcss, '-MultiValueRemove')
        ]),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon',
            className: (0, _runtime.ax)([
                isDisabled && "_1e0cglyw",
                !isDisabled && "_1e0c1kw7"
            ]),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _crossDefault.default), {
                label: "",
                color: "currentColor",
                size: "small"
            })
        })
    }));
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@compiled/react":"MfI9Z","@atlaskit/icon/core/cross":"cnbEZ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bYPP3":[function(require,module,exports,__globalThis) {
/* option.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _react1 = require("@compiled/react");
var _getStyleProps = require("../get-style-props");
var optionStyles = {
    root: "_1rjc12x7 _18zrutpp _syazi7uo _80om73ad _1e0c1ule _1wyb1kw7 _1bsb1osq _uiztglyw _18ql1j7p _1di6fcek",
    disabled: "_syaz1gmx _80om13gf _bfhk1j28 _16qsglyw _1di61j28 _112eglyw",
    focused: "_bfhk1dpa _16qs1x9r _112e5u6v",
    selected: "_syaz6x5g _bfhk15s3 _16qs1x9r _1di6nozp _112e5u6v",
    focusedSelected: "_bfhkufnl"
};
var Option = function(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps1 = (0, _getStyleProps.getStyleProps)(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), css = _getStyleProps1.css, className = _getStyleProps1.className;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, _runtime.ax)([
            optionStyles.root,
            isFocused && optionStyles.focused,
            isSelected && optionStyles.selected,
            isFocused && isSelected && optionStyles.focusedSelected,
            isDisabled && optionStyles.disabled,
            (0, _react1.cx)(className, xcss, '-option')
        ]),
        ref: innerRef
    }, innerProps), {
        tabIndex: -1,
        children: children
    }));
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = Option;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@compiled/react":"MfI9Z","../get-style-props":"aedDQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kdNMr":[function(require,module,exports,__globalThis) {
/* placeholder.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _react1 = require("@compiled/react");
var _getStyleProps = require("../get-style-props");
var placeholderStyles = {
    root: "_nd5l1sux _1pfhidpf _12l2v77o _6rthidpf _ahbqv77o _syaz1rpy",
    disabled: "_syaz1gmx"
};
var Placeholder = function(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, xcss = props.xcss;
    var _getStyleProps1 = (0, _getStyleProps.getStyleProps)(props, 'placeholder', {
        placeholder: true
    }), css = _getStyleProps1.css, className = _getStyleProps1.className;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, _runtime.ax)([
            placeholderStyles.root,
            isDisabled && placeholderStyles.disabled,
            (0, _react1.cx)(className, xcss, '-placeholder')
        ])
    }, innerProps), {
        children: children
    }));
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = Placeholder;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@compiled/react":"MfI9Z","../get-style-props":"aedDQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"TnCuu":[function(require,module,exports,__globalThis) {
/* single-value.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _react1 = require("@compiled/react");
var _getStyleProps = require("../get-style-props");
var styles = {
    root: "_nd5l1sux _1reo15vq _18m915vq _p12f1osq _1bto1l2s _o5721q9c _1pfhidpf _12l2v77o _6rthidpf _ahbqv77o _syazi7uo",
    disalbed: "_syaz1gmx"
};
var SingleValue = function(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps1 = (0, _getStyleProps.getStyleProps)(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), css = _getStyleProps1.css, className = _getStyleProps1.className;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, _runtime.ax)([
            styles.root,
            isDisabled && styles.disalbed,
            (0, _react1.cx)(className, xcss, '-singleValue')
        ])
    }, innerProps), {
        children: children
    }));
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = SingleValue;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@compiled/react":"MfI9Z","../get-style-props":"aedDQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jbpEk":[function(require,module,exports,__globalThis) {
/* dummy-input.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return DummyInput;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var removeProps = function(propsObj) {
    for(var _len = arguments.length, properties = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        properties[_key - 1] = arguments[_key];
    }
    var propsMap = Object.entries(propsObj).filter(function(param) {
        var _param = (0, _slicedToArray._)(param, 1), key = _param[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, param) {
        var _param = (0, _slicedToArray._)(param, 2), key = _param[0], val = _param[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var dummyInputStyles = null;
function DummyInput(_param) {
    var innerRef = _param.innerRef, props = (0, _objectWithoutProperties._)(_param, [
        "innerRef"
    ]);
    // Remove animation props not meant for HTML elements
    var filteredProps = removeProps(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", (0, _objectSpread._)({
        ref: innerRef,
        className: (0, _runtime.ax)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _nd5l1sux _12ji1r31 _1qu2glyw _12y3idpf _1bsbt94y _kqswh2mm _1n5d1j28 _syaz1j28 _1e02p1rm _tzy4idpf _t9ec1kuz",
            "-dummyInput"
        ])
    }, filteredProps));
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_without_properties":"6HqIM","@swc/helpers/_/_sliced_to_array":"8PtL6","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cv5eA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _accessibility = require("../accessibility");
var _a11YText = require("../internal/a11y-text");
var _a11YTextDefault = parcelHelpers.interopDefault(_a11YText);
var LiveRegion = function(props) {
    var ariaSelection = props.ariaSelection, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isOptionDisabled = selectProps.isOptionDisabled, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, isLoading = selectProps.isLoading;
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, _react.useMemo)(function() {
        return (0, _objectSpread._)({}, (0, _accessibility.defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, _react.useMemo)(function() {
        var message = '';
        if (menuIsOpen) // we don't need to have selected message when the menu is open
        return '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            if (!label && !labels.length) // return empty string if no labels provided
            return '';
            var onChangeProps = (0, _objectSpread._)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel,
        menuIsOpen
    ]);
    var ariaResults = (0, _react.useMemo)(function() {
        var resultsMsg = '';
        if (isLoading) resultsMsg = 'Loading. ';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        if (options && options.length === 0) resultsMsg = 'No options. ';
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    var ScreenReaderText = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                id: "aria-selection",
                children: ariaSelected
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                id: "aria-results",
                children: ariaResults
            })
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _a11YTextDefault.default), {
                id: id,
                children: isInitialFocus && ScreenReaderText
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _a11YTextDefault.default), {
                "aria-live": ariaLive,
                role: "status",
                children: isFocused && !isInitialFocus && ScreenReaderText
            })
        ]
    });
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = LiveRegion;

},{"@swc/helpers/_/_object_spread":"9gdrV","react/jsx-runtime":"bGvcw","react":"ltHCL","../accessibility":"84ByT","../internal/a11y-text":"02wcf","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"84ByT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultAriaLiveMessages", function() {
    return defaultAriaLiveMessages;
});
var defaultAriaLiveMessages = {
    onChange: function(props) {
        var action = props.action, _props_label = props.label, label = _props_label === void 0 ? '' : _props_label, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return label.length ? "option ".concat(label, ", deselected") : '';
            case 'clear':
                return 'All selected options have been cleared.';
            case 'select-option':
                return label.length && !isDisabled ? "option ".concat(label, ", selected.") : '';
            default:
                return '';
        }
    },
    onFilter: function(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return inputValue ? "".concat(resultsMessage, " for search term ").concat(inputValue, ".") : '';
    }
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"02wcf":[function(require,module,exports,__globalThis) {
/* a11y-text.tsx generated by @compiled/babel-plugin v0.39.1 */ // Assistive text to describe visual elements. Hidden for sighted users.
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var styles = null;
var A11yText = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", (0, _objectSpread._)({
        // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, _runtime.ax)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _1pbydx66 _ogto7mnp _uiztglyw _o5721q9c",
            "-a11yText"
        ])
    }, props));
};
exports.default = A11yText;

},{"@swc/helpers/_/_object_spread":"9gdrV","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5rakI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var _portalPlacementContext = require("../internal/portal-placement-context");
var noop = (0, _noopDefault.default);
function getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
function isDocumentElement(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
function normalizedHeight(el) {
    if (isDocumentElement(el)) return window.innerHeight;
    return el.clientHeight;
}
function scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if (isDocumentElement(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
function easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function getScrollTop(el) {
    if (isDocumentElement(el)) return window.pageYOffset;
    return el.scrollTop;
}
function animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 200, callback = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : noop;
    var start = getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = easeOutCubic(currentTime, start, change, duration);
        scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
function getMenuPlacement(param) {
    var preferredMaxHeight = param.maxHeight, menuEl = param.menuEl, minHeight = param.minHeight, preferredPlacement = param.placement, shouldScroll = param.shouldScroll, isFixedPosition = param.isFixedPosition, controlHeight = param.controlHeight;
    var scrollParent = getScrollParent(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent_getBoundingClientRect = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent_getBoundingClientRect.height;
    var _menuEl_getBoundingClientRect = menuEl.getBoundingClientRect(), menuBottom = _menuEl_getBoundingClientRect.bottom, menuHeight = _menuEl_getBoundingClientRect.height, menuTop = _menuEl_getBoundingClientRect.top;
    var _menuEl_offsetParent_getBoundingClientRect = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl_offsetParent_getBoundingClientRect.top;
    var viewHeight = isFixedPosition ? window.innerHeight : normalizedHeight(scrollParent);
    var scrollTop = getScrollTop(scrollParent);
    var menuTopFromParent = menuTop;
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTopFromParent;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTopFromParent;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var constrainedHeight1 = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) constrainedHeight1 = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight1
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error('Invalid placement provided "'.concat(preferredPlacement, '".'));
    }
    return defaultState;
}
var coercePlacement = function(p) {
    return p === 'auto' ? 'bottom' : p;
};
// NOTE: internal only
// eslint-disable-next-line @repo/internal/react/require-jsdoc
// TODO: Fill in the component {description} and ensure links point to the correct {packageName} location.
// Remove links that the component does not have (such as usage). If there are no links remove them all.
/**
 * __Menu placer__
 *
 * A menu placer {description}.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */ var MenuPlacer = function(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView;
    var setPortalPlacement = ((0, _react.useContext)((0, _portalPlacementContext.PortalPlacementContext)) || {}).setPortalPlacement;
    var ref = (0, _react.useRef)(null);
    var _useState = (0, _slicedToArray._)((0, _react.useState)(maxMenuHeight), 2), maxHeight = _useState[0], setMaxHeight = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(null), 2), placement = _useState1[0], setPlacement = _useState1[1];
    // The minimum height of the control
    var controlHeight = 38;
    (0, _react.useLayoutEffect)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 ? void 0 : setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
            placement: placement || coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
exports.default = MenuPlacer;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_sliced_to_array":"8PtL6","react":"ltHCL","@atlaskit/ds-lib/noop":"2f3bg","../internal/portal-placement-context":"cDq7E","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4FBJr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createFilter", function() {
    return createFilter;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _memoizeOne = require("memoize-one");
var _memoizeOneDefault = parcelHelpers.interopDefault(_memoizeOne);
var _diacritics = require("./diacritics");
var memoizedStripDiacriticsForInput = (0, _memoizeOneDefault.default)((0, _diacritics.stripDiacritics));
var trimString = function(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var defaultStringify = function(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var createFilter = function(config) {
    return function(option, rawInput) {
        if (option.data.__isNew__) return true;
        var _$_object_spread = (0, _objectSpread._)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _$_object_spread.ignoreCase, ignoreAccents = _$_object_spread.ignoreAccents, stringify = _$_object_spread.stringify, trim = _$_object_spread.trim, matchFrom = _$_object_spread.matchFrom;
        var input = trim ? trimString(rawInput) : rawInput;
        var candidate = trim ? trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = memoizedStripDiacriticsForInput(input);
            candidate = (0, _diacritics.stripDiacritics)(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};

},{"@swc/helpers/_/_object_spread":"9gdrV","memoize-one":"5rJro","./diacritics":"h9jZt","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"h9jZt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "stripDiacritics", function() {
    return stripDiacritics;
});
var diacritics = [
    {
        base: 'A',
        letters: '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'
    },
    {
        base: 'AA',
        letters: '\uA732'
    },
    {
        base: 'AE',
        letters: '\u00C6\u01FC\u01E2'
    },
    {
        base: 'AO',
        letters: '\uA734'
    },
    {
        base: 'AU',
        letters: '\uA736'
    },
    {
        base: 'AV',
        letters: '\uA738\uA73A'
    },
    {
        base: 'AY',
        letters: '\uA73C'
    },
    {
        base: 'B',
        letters: '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'
    },
    {
        base: 'C',
        letters: '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'
    },
    {
        base: 'D',
        letters: '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'
    },
    {
        base: 'DZ',
        letters: '\u01F1\u01C4'
    },
    {
        base: 'Dz',
        letters: '\u01F2\u01C5'
    },
    {
        base: 'E',
        letters: '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'
    },
    {
        base: 'F',
        letters: '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'
    },
    {
        base: 'G',
        letters: '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'
    },
    {
        base: 'H',
        letters: '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'
    },
    {
        base: 'I',
        letters: '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'
    },
    {
        base: 'J',
        letters: '\u004A\u24BF\uFF2A\u0134\u0248'
    },
    {
        base: 'K',
        letters: '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'
    },
    {
        base: 'L',
        letters: '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'
    },
    {
        base: 'LJ',
        letters: '\u01C7'
    },
    {
        base: 'Lj',
        letters: '\u01C8'
    },
    {
        base: 'M',
        letters: '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'
    },
    {
        base: 'N',
        letters: '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'
    },
    {
        base: 'NJ',
        letters: '\u01CA'
    },
    {
        base: 'Nj',
        letters: '\u01CB'
    },
    {
        base: 'O',
        letters: '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'
    },
    {
        base: 'OI',
        letters: '\u01A2'
    },
    {
        base: 'OO',
        letters: '\uA74E'
    },
    {
        base: 'OU',
        letters: '\u0222'
    },
    {
        base: 'P',
        letters: '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'
    },
    {
        base: 'Q',
        letters: '\u0051\u24C6\uFF31\uA756\uA758\u024A'
    },
    {
        base: 'R',
        letters: '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'
    },
    {
        base: 'S',
        letters: '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'
    },
    {
        base: 'T',
        letters: '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'
    },
    {
        base: 'TZ',
        letters: '\uA728'
    },
    {
        base: 'U',
        letters: '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'
    },
    {
        base: 'V',
        letters: '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'
    },
    {
        base: 'VY',
        letters: '\uA760'
    },
    {
        base: 'W',
        letters: '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'
    },
    {
        base: 'X',
        letters: '\u0058\u24CD\uFF38\u1E8A\u1E8C'
    },
    {
        base: 'Y',
        letters: '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'
    },
    {
        base: 'Z',
        letters: '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'
    },
    {
        base: 'a',
        letters: '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'
    },
    {
        base: 'aa',
        letters: '\uA733'
    },
    {
        base: 'ae',
        letters: '\u00E6\u01FD\u01E3'
    },
    {
        base: 'ao',
        letters: '\uA735'
    },
    {
        base: 'au',
        letters: '\uA737'
    },
    {
        base: 'av',
        letters: '\uA739\uA73B'
    },
    {
        base: 'ay',
        letters: '\uA73D'
    },
    {
        base: 'b',
        letters: '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'
    },
    {
        base: 'c',
        letters: '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'
    },
    {
        base: 'd',
        letters: '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'
    },
    {
        base: 'dz',
        letters: '\u01F3\u01C6'
    },
    {
        base: 'e',
        letters: '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'
    },
    {
        base: 'f',
        letters: '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'
    },
    {
        base: 'g',
        letters: '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'
    },
    {
        base: 'h',
        letters: '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'
    },
    {
        base: 'hv',
        letters: '\u0195'
    },
    {
        base: 'i',
        letters: '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'
    },
    {
        base: 'j',
        letters: '\u006A\u24D9\uFF4A\u0135\u01F0\u0249'
    },
    {
        base: 'k',
        letters: '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'
    },
    {
        base: 'l',
        letters: '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'
    },
    {
        base: 'lj',
        letters: '\u01C9'
    },
    {
        base: 'm',
        letters: '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'
    },
    {
        base: 'n',
        letters: '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'
    },
    {
        base: 'nj',
        letters: '\u01CC'
    },
    {
        base: 'o',
        letters: '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'
    },
    {
        base: 'oi',
        letters: '\u01A3'
    },
    {
        base: 'ou',
        letters: '\u0223'
    },
    {
        base: 'oo',
        letters: '\uA74F'
    },
    {
        base: 'p',
        letters: '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'
    },
    {
        base: 'q',
        letters: '\u0071\u24E0\uFF51\u024B\uA757\uA759'
    },
    {
        base: 'r',
        letters: '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'
    },
    {
        base: 's',
        letters: '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'
    },
    {
        base: 't',
        letters: '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'
    },
    {
        base: 'tz',
        letters: '\uA729'
    },
    {
        base: 'u',
        letters: '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'
    },
    {
        base: 'v',
        letters: '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'
    },
    {
        base: 'vy',
        letters: '\uA761'
    },
    {
        base: 'w',
        letters: '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'
    },
    {
        base: 'x',
        letters: '\u0078\u24E7\uFF58\u1E8B\u1E8D'
    },
    {
        base: 'y',
        letters: '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'
    },
    {
        base: 'z',
        letters: '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'
    }
];
var anyDiacritic = new RegExp('[' + diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var diacriticToBase = {};
for(var i = 0; i < diacritics.length; i++){
    var diacritic = diacritics[i];
    for(var j = 0; j < diacritic.letters.length; j++)diacriticToBase[diacritic.letters[j]] = diacritic.base;
}
var stripDiacritics = function(str) {
    return str.replace(anyDiacritic, function(match) {
        return diacriticToBase[match];
    });
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7aOk0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "classNames", function() {
    return classNames;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
/**
 * String representation of component state for styling with class names.
 *
 * Expects an array of strings OR a string/object pair:
 * - className(['comp', 'comp-arg', 'comp-arg-2'])
 * @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 * - className('comp', { some: true, state: false })
 * @returns 'react-select__comp react-select__comp--some'
 */ function applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function classNames(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        classNameList[_key - 2] = arguments[_key];
    }
    var arr = (0, _toConsumableArray._)(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat(applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}

},{"@swc/helpers/_/_to_consumable_array":"1eSZf","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"klSP6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cleanValue", function() {
    return cleanValue;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var cleanValue = function(value) {
    if (Array.isArray(value)) return value.filter(Boolean);
    if ((typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) === 'object' && value !== null) return [
        value
    ];
    return [];
};

},{"@swc/helpers/_/_type_of":"iFJdx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iK3PO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isDocumentElement", function() {
    return isDocumentElement;
});
function isDocumentElement(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3u4nt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "multiValueAsValue", function() {
    return multiValueAsValue;
});
function multiValueAsValue(multiValue) {
    return multiValue;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iceUp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Functional component wrapper around `useNotifyOpenLayerObserver`.
 *
 * This is needed as Select is a class component, which cannot use hooks directly.
 */ parcelHelpers.export(exports, "NotifyOpenLayerObserver", function() {
    return NotifyOpenLayerObserver;
});
var _openLayerObserver = require("@atlaskit/layering/experimental/open-layer-observer");
function NotifyOpenLayerObserver(param) {
    var isOpen = param.isOpen, onClose = param.onClose;
    // @ts-ignore - hot-116676
    (0, _openLayerObserver.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: onClose
    });
    return null;
}

},{"@atlaskit/layering/experimental/open-layer-observer":"iPCuE","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7S3pc":[function(require,module,exports,__globalThis) {
/* required-input.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var styles = null;
var RequiredInput = function(param) {
    var name = param.name, onFocus = param.onFocus;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, _runtime.ax)([
            "_1bsb1osq _kqswstnw _u7coidpf _rjxpidpf _1e02idpf _tzy4idpf _lcxvglyw",
            "-requiredInput"
        ]),
        onFocus: onFocus,
        // Prevent `Switching from uncontrolled to controlled` error
        value: "",
        onChange: (0, _noopDefault.default)
    });
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = RequiredInput;

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/ds-lib/noop":"2f3bg","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2KVrx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return ScrollManager;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useScrollCapture = require("./use-scroll-capture");
var _useScrollCaptureDefault = parcelHelpers.interopDefault(_useScrollCapture);
var _useScrollLock = require("./use-scroll-lock");
var _useScrollLockDefault = parcelHelpers.interopDefault(_useScrollLock);
var blurSelectInput = function(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
function ScrollManager(param) {
    var children = param.children, lockEnabled = param.lockEnabled, _param_captureEnabled = param.captureEnabled, captureEnabled = _param_captureEnabled === void 0 ? true : _param_captureEnabled, onBottomArrive = param.onBottomArrive, onBottomLeave = param.onBottomLeave, onTopArrive = param.onTopArrive, onTopLeave = param.onTopLeave;
    var setScrollCaptureTarget = (0, _useScrollCaptureDefault.default)({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = (0, _useScrollLockDefault.default)({
        isEnabled: lockEnabled
    });
    var targetRef = function(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
        children: [
            lockEnabled && // eslint-disable-next-line @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlassian/a11y/no-static-element-interactions
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                onClick: blurSelectInput,
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    position: 'fixed',
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetBlockEnd: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetBlockStart: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetInlineEnd: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetInlineStart: 0
                }
            }),
            children(targetRef)
        ]
    });
}

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","./use-scroll-capture":"cZ6OJ","./use-scroll-lock":"42y3T","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cZ6OJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return useScrollCapture;
});
var _react = require("react");
var _passiveEventDetector = require("./passive-event-detector");
var cancelScroll = function(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function useScrollCapture(param) {
    var isEnabled = param.isEnabled, onBottomArrive = param.onBottomArrive, onBottomLeave = param.onBottomLeave, onTopArrive = param.onTopArrive, onTopLeave = param.onTopLeave;
    var isBottom = (0, _react.useRef)(false);
    var isTop = (0, _react.useRef)(false);
    var touchStart = (0, _react.useRef)(0);
    var scrollTarget = (0, _react.useRef)(null);
    var handleEventDelta = (0, _react.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget_current = scrollTarget.current, scrollTop = _scrollTarget_current.scrollTop, scrollHeight = _scrollTarget_current.scrollHeight, clientHeight = _scrollTarget_current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, _react.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, _react.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, _react.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, _react.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, _passiveEventDetector.supportsPassiveEvents) ? {
            passive: false
        } : false;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('wheel', onWheel, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchstart', onTouchStart, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, _react.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('wheel', onWheel, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchstart', onTouchStart, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, _react.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}

},{"react":"ltHCL","./passive-event-detector":"9rkrs","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9rkrs":[function(require,module,exports,__globalThis) {
// ==============================
// Passive Event Detector
// ==============================
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "supportsPassiveEvents", function() {
    return supportsPassiveEvents;
});
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var noop = (0, _noopDefault.default);
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var passiveOptionAccessed = false;
var options = {
    get passive () {
        return passiveOptionAccessed = true;
    }
};
// check for SSR
var w = typeof window !== 'undefined' ? window : {};
if (w.addEventListener && w.removeEventListener) {
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    w.addEventListener('p', noop, options);
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    w.removeEventListener('p', noop, false);
}
var supportsPassiveEvents = passiveOptionAccessed;

},{"@atlaskit/ds-lib/noop":"2f3bg","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"42y3T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return useScrollLock;
});
var _react = require("react");
var STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var LOCK_STYLES = {
    boxSizing: 'border-box',
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function preventTouchMove(e) {
    e.preventDefault();
}
function allowTouchMove(e) {
    e.stopPropagation();
}
function preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var activeScrollLocks = 0;
var listenerOptions = {
    capture: false,
    passive: false
};
function useScrollLock(param) {
    var isEnabled = param.isEnabled, _param_accountForScrollbars = param.accountForScrollbars, accountForScrollbars = _param_accountForScrollbars === void 0 ? true : _param_accountForScrollbars;
    var originalStyles = (0, _react.useRef)({});
    var scrollTarget = (0, _react.useRef)(null);
    var addScrollLock = (0, _react.useCallback)(function(touchScrollTarget) {
        if (!canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys(LOCK_STYLES).forEach(function(key) {
                var val = LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.addEventListener('touchmove', preventTouchMove, listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchstart', preventInertiaScroll, listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchmove', allowTouchMove, listenerOptions);
            }
        }
        // increment active scroll locks
        activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, _react.useCallback)(function(touchScrollTarget) {
        if (!canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        activeScrollLocks = Math.max(activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && activeScrollLocks < 1) STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && isTouchDevice()) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.removeEventListener('touchmove', preventTouchMove, listenerOptions);
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchstart', preventInertiaScroll, listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchmove', allowTouchMove, listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, _react.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cuUZ3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scrollTo", function() {
    return scrollTo;
});
var _isDocumentEl = require("./is-document-el");
function scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ((0, _isDocumentEl.isDocumentElement)(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}

},{"./is-document-el":"iK3PO","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"VIAuO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "singleValueAsValue", function() {
    return singleValueAsValue;
});
function singleValueAsValue(singleValue) {
    return singleValue;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2ztHW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "valueTernary", function() {
    return valueTernary;
});
function valueTernary(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"d4snc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return useAsync;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
function handleInputChange(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var newValue = onInputChange(inputValue, actionMeta);
        if (typeof newValue === 'string') return newValue;
    }
    return inputValue;
}
function useAsync(_param) {
    var tmp = _param.defaultOptions, propsDefaultOptions = tmp === void 0 ? false : tmp, _param_cacheOptions = _param.cacheOptions, cacheOptions = _param_cacheOptions === void 0 ? false : _param_cacheOptions, propsLoadOptions = _param.loadOptions, propsOptions = _param.options, tmp1 = _param.isLoading, propsIsLoading = tmp1 === void 0 ? false : tmp1, propsOnInputChange = _param.onInputChange, _param_filterOption = _param.filterOption, filterOption = _param_filterOption === void 0 ? null : _param_filterOption, restSelectProps = (0, _objectWithoutProperties._)(_param, [
        "defaultOptions",
        "cacheOptions",
        "loadOptions",
        "options",
        "isLoading",
        "onInputChange",
        "filterOption"
    ]);
    var propsInputValue = restSelectProps.inputValue;
    var lastRequest = (0, _react.useRef)(undefined);
    var mounted = (0, _react.useRef)(false);
    var _useState = (0, _slicedToArray._)((0, _react.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined), 2), defaultOptions = _useState[0], setDefaultOptions = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : ''), 2), stateInputValue = _useState1[0], setStateInputValue = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(propsDefaultOptions === true), 2), isLoading = _useState2[0], setIsLoading = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)(undefined), 2), loadedInputValue = _useState3[0], setLoadedInputValue = _useState3[1];
    var _useState4 = (0, _slicedToArray._)((0, _react.useState)([]), 2), loadedOptions = _useState4[0], setLoadedOptions = _useState4[1];
    var _useState5 = (0, _slicedToArray._)((0, _react.useState)(false), 2), passEmptyOptions = _useState5[0], setPassEmptyOptions = _useState5[1];
    var _useState6 = (0, _slicedToArray._)((0, _react.useState)({}), 2), optionsCache = _useState6[0], setOptionsCache = _useState6[1];
    var _useState7 = (0, _slicedToArray._)((0, _react.useState)(undefined), 2), prevDefaultOptions = _useState7[0], setPrevDefaultOptions = _useState7[1];
    var _useState8 = (0, _slicedToArray._)((0, _react.useState)(undefined), 2), prevCacheOptions = _useState8[0], setPrevCacheOptions = _useState8[1];
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, _react.useEffect)(function() {
        mounted.current = true;
        return function() {
            mounted.current = false;
        };
    }, []);
    var loadOptions = (0, _react.useCallback)(function(inputValue, callback) {
        if (!propsLoadOptions) return callback();
        var loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === 'function') loader.then(callback, function() {
            return callback();
        });
    }, [
        propsLoadOptions
    ]);
    (0, _react.useEffect)(function() {
        if (propsDefaultOptions === true) loadOptions(stateInputValue, function(options) {
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var onInputChange = (0, _react.useCallback)(function(newValue, actionMeta) {
        var inputValue = handleInputChange(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue('');
            setLoadedInputValue('');
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            var request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, function(options) {
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? (0, _objectSpreadProps._)((0, _objectSpread._)({}, optionsCache), (0, _defineProperty._)({}, inputValue, options)) : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    var options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, restSelectProps), {
        options: options,
        isLoading: isLoading || propsIsLoading,
        onInputChange: onInputChange,
        filterOption: filterOption
    });
}

},{"@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","@swc/helpers/_/_sliced_to_array":"8PtL6","react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kQWD7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return useStateManager;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
function useStateManager(_param) {
    var _param_defaultInputValue = _param.defaultInputValue, defaultInputValue = _param_defaultInputValue === void 0 ? '' : _param_defaultInputValue, _param_defaultMenuIsOpen = _param.defaultMenuIsOpen, defaultMenuIsOpen = _param_defaultMenuIsOpen === void 0 ? false : _param_defaultMenuIsOpen, _param_defaultValue = _param.defaultValue, defaultValue = _param_defaultValue === void 0 ? null : _param_defaultValue, propsInputValue = _param.inputValue, propsMenuIsOpen = _param.menuIsOpen, propsOnChange = _param.onChange, propsOnInputChange = _param.onInputChange, propsOnMenuClose = _param.onMenuClose, propsOnMenuOpen = _param.onMenuOpen, propsValue = _param.value, restSelectProps = (0, _objectWithoutProperties._)(_param, [
        "defaultInputValue",
        "defaultMenuIsOpen",
        "defaultValue",
        "inputValue",
        "menuIsOpen",
        "onChange",
        "onInputChange",
        "onMenuClose",
        "onMenuOpen",
        "value"
    ]);
    var _useState = (0, _slicedToArray._)((0, _react.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), 2), stateInputValue = _useState[0], setStateInputValue = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), 2), stateMenuIsOpen = _useState1[0], setStateMenuIsOpen = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(propsValue !== undefined ? propsValue : defaultValue), 2), stateValue = _useState2[0], setStateValue = _useState2[1];
    var onChange = (0, _react.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, _react.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, _react.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, _react.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    //@ts-ignore react-select unsupported props
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, restSelectProps), {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","@swc/helpers/_/_sliced_to_array":"8PtL6","react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5nVqX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return createSelect;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function createSelect(WrappedComponent) {
    var AtlaskitSelect = /*#__PURE__*/ (0, _react.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        var ariaLiveMessages = props.ariaLiveMessages, isInvalid = props.isInvalid, _props_onClickPreventDefault = props.onClickPreventDefault, onClickPreventDefault = _props_onClickPreventDefault === void 0 ? true : _props_onClickPreventDefault, _props_tabSelectsValue = props.tabSelectsValue, tabSelectsValue = _props_tabSelectsValue === void 0 ? false : _props_tabSelectsValue, _props_validationState = props.validationState, validationState = _props_validationState === void 0 ? 'default' : _props_validationState, restProps = (0, _objectWithoutProperties._)(props, [
            "ariaLiveMessages",
            "isInvalid",
            "onClickPreventDefault",
            "tabSelectsValue",
            "validationState"
        ]);
        var internalSelectRef = (0, _react.useRef)(null);
        /**
		 * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
		 * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
		 * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
		 * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
		 * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
		 */ (0, _react.useImperativeHandle)(forwardedRef, function() {
            return {
                select: internalSelectRef.current,
                focus: function() {
                    var _internalSelectRef_current;
                    return (_internalSelectRef_current = internalSelectRef.current) === null || _internalSelectRef_current === void 0 ? void 0 : _internalSelectRef_current.focus();
                },
                blur: function() {
                    var _internalSelectRef_current;
                    return (_internalSelectRef_current = internalSelectRef.current) === null || _internalSelectRef_current === void 0 ? void 0 : _internalSelectRef_current.blur();
                }
            };
        }, []);
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(WrappedComponent, (0, _objectSpreadProps._)((0, _objectSpread._)({
            ref: internalSelectRef,
            ariaLiveMessages: ariaLiveMessages,
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            isInvalid: isInvalid || validationState === 'error'
        }, restProps), {
            // indicates react-select to be async by default using the base Select component
            // so that makers can pass all async props on the base select to async load options.
            isAsync: true
        }));
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react/jsx-runtime":"bGvcw","react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jkntP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return 0, _textAreaDefault.default;
});
var _textArea = require("./text-area");
var _textAreaDefault = parcelHelpers.interopDefault(_textArea);

},{"./text-area":"dm2IA","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dm2IA":[function(require,module,exports,__globalThis) {
/* text-area.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _typeOf = require("@swc/helpers/_/_type_of");
var _jsxRuntime = require("react/jsx-runtime");
var _runtime = require("@compiled/react/runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _analyticsNext = require("@atlaskit/analytics-next");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var packageName = undefined;
var packageVersion = undefined;
var analyticsParams = {
    componentName: 'textArea',
    packageName: packageName,
    packageVersion: packageVersion
};
var lineHeightBase = 20;
var lineHeightCompact = 16;
var compactVerticalPadding = 2;
var verticalPadding = 6;
var transitionDuration = '0.2s';
var borderWidth = 2;
var baseStyles = null;
var baseStylesT26Shape = null;
var appearanceStyles = {
    standard: "_1dqonqa1 _kp82rsbi _1ltx1j9a _1bqsbk0g _z1pvby5v _19wtrsbi _12yml4ek _1l02v77o _11zpv77o _141f1v6z _daj71v6z _olc612x7 _14ji12x7 _7ba01v6z _1kod1v6z _858u1v1w _jomrr01l _7ehivyy1 _186j1v1w _qu18by5v",
    subtle: "_1dqonqa1 _kp821j28 _1ltx1j28 _19wtrsbi _12yml4ek _1l02v77o _11zpv77o _141f1v6z _daj71v6z _olc612x7 _14ji12x7 _1kod1v6z _7ba01v6z _858u1v1w _jomrr01l _7ehivyy1",
    none: "_1dqoglyw _kp821j28 _1ltx1j28 _19wt1j28 _12ym1j28 _1l02v77o _daj712x7 _11zpv77o _141f12x7 _olc612x7 _1kod12x7 _14ji12x7 _7ba012x7 _858u1j28 _jomr1j28 _7ehi3sij"
};
// iOS Safari automatically zooms into form inputs on focus when the font size is less than 16px.
// To prevent this zoom behaviour on mobile devices, the textarea uses font.body.large (16px) by default,
// then switches to the smaller font.body on screens wider than 30rem (desktop).
// @see: https://medium.com/@rares.popescu/2-ways-to-avoid-the-automatic-zoom-in-on-input-fields-8a71479e542e
var fontStyles = {
    default: "_11c81d4k _1tn2fhey",
    monospace: "_11c81d4k _ect4zzfg _1tn2fhey _14md1vhz"
};
var resizeStyles = {
    horizontal: "_14zg1e08",
    vertical: "_14zg1e54",
    auto: "_14zg1hrf",
    smart: "_14zgglyw",
    none: "_14zgglyw"
};
var setSmartHeight = function(el) {
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    var borderHeight = borderWidth;
    var paddingBoxHeight = el.scrollHeight;
    var borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = "".concat(borderBoxHeight, "px");
};
var InnerTextArea = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    var ourRef = (0, _react.useRef)(null);
    var _props_resize = props.resize, resize = _props_resize === void 0 ? 'smart' : _props_resize, _props_appearance = props.appearance, appearance = _props_appearance === void 0 ? 'standard' : _props_appearance, _props_isCompact = props.isCompact, isCompact = _props_isCompact === void 0 ? false : _props_isCompact, _props_isRequired = props.isRequired, isRequired = _props_isRequired === void 0 ? false : _props_isRequired, _props_isReadOnly = props.isReadOnly, isReadOnly = _props_isReadOnly === void 0 ? false : _props_isReadOnly, _props_isDisabled = props.isDisabled, isDisabled = _props_isDisabled === void 0 ? false : _props_isDisabled, _props_isInvalid = props.isInvalid, isInvalid = _props_isInvalid === void 0 ? false : _props_isInvalid, _props_isMonospaced = props.isMonospaced, isMonospaced = _props_isMonospaced === void 0 ? false : _props_isMonospaced, _props_minimumRows = props.minimumRows, minimumRows = _props_minimumRows === void 0 ? 2 : _props_minimumRows, testId = props.testId, _props_maxHeight = props.maxHeight, maxHeight = _props_maxHeight === void 0 ? '50vh' : _props_maxHeight, onBlur = props.onBlur, onFocus = props.onFocus, onChange = props.onChange, value = props.value, style = props.style, rest = (0, _objectWithoutProperties._)(props, [
        "resize",
        "appearance",
        "isCompact",
        "isRequired",
        "isReadOnly",
        "isDisabled",
        "isInvalid",
        "isMonospaced",
        "minimumRows",
        "testId",
        "maxHeight",
        "onBlur",
        "onFocus",
        "onChange",
        "value",
        "style"
    ]);
    var borderHeight = (0, _react.useMemo)(function() {
        return appearance === 'none' ? 2 : 1;
    }, [
        appearance
    ]);
    (0, _react.useEffect)(function() {
        var el = ourRef.current;
        if (resize === 'smart' && el) setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    var onBlurWithAnalytics = (0, _analyticsNext.usePlatformLeafEventHandler)((0, _objectSpread._)({
        fn: function(event) {
            onBlur && onBlur(event);
        },
        action: 'blurred'
    }, analyticsParams));
    var onFocusWithAnalytics = (0, _analyticsNext.usePlatformLeafEventHandler)((0, _objectSpread._)({
        fn: function(event) {
            onFocus && onFocus(event);
        },
        action: 'focused'
    }, analyticsParams));
    var getTextAreaRef = function(elementRef) {
        ourRef.current = elementRef;
        if (ref && (typeof ref === "undefined" ? "undefined" : (0, _typeOf._)(ref)) === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    var handleOnChange = (0, _react.useCallback)(function(e) {
        var el = ourRef.current;
        if (resize === 'smart' && el) setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    var controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    var compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, controlProps), {
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows
    }), rest), {
        className: (0, _runtime.ax)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1osq _2rkofajl _11c8fhey _12ji1r31 _1qu2glyw _12y31o36 _1reo1wug _18m91wug _v564r5cv _189ee4h9 _1e0c1ule _vchhusvi _1bsb1osq _1ul9idpf _p12f1osq _kqswh2mm _syazi7uo _slp31hna _153g1bqt _usy41j9a _1a2sizbr _vbqb1gmx _j5dh13gf _cfjqkb7n _k3o7n7od _1goxglyw _13xeglyw _1fra1bqt _ibjdl4ek _6zpvizbr _19k0by5v _1idr1rpy _1lep1gmx _nmhq1fiz _1n388sxn _1luh1v1w _ndzbr01l _1vj0vyy1",
            (0, _platformFeatureFlags.fg)('platform-dst-shape-theme-default') && "_2rko1qi0",
            appearanceStyles[appearance],
            fontStyles[isMonospaced ? 'monospace' : 'default'],
            resizeStyles[resize],
            "_uzq71i7i _16lwuel1"
        ]),
        style: (0, _objectSpreadProps._)((0, _objectSpread._)({}, style), {
            maxHeight: maxHeight,
            "--_6ny3x7": (0, _runtime.ix)(lineHeightCompact * minimumRows + compactVerticalPadding * 2 + borderHeight * 2, "px"),
            "--_eorxnz": (0, _runtime.ix)(lineHeightBase * minimumRows + verticalPadding * 2 + borderHeight * 2, "px")
        })
    }));
});
/**
 * __Text area__
 *
 * A text area lets users enter long form text which spans over multiple lines.
 *
 * - [Examples](https://atlassian.design/components/textarea/examples)
 * - [Code](https://atlassian.design/components/textarea/code)
 * - [Usage](https://atlassian.design/components/textarea/usage)
 */ var TextArea = /*#__PURE__*/ (0, _react.memo)(/*#__PURE__*/ (0, _react.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(InnerTextArea, (0, _objectSpread._)({
        ref: ref
    }, props));
}));
TextArea.displayName = 'TextArea';
exports.default = TextArea;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","@swc/helpers/_/_type_of":"iFJdx","react/jsx-runtime":"bGvcw","@compiled/react/runtime":"d27Vo","react":"ltHCL","@atlaskit/analytics-next":"auH4u","@atlaskit/platform-feature-flags":"kO5t9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1UW1R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "messages", function() {
    return messages;
});
var _reactIntl = require("react-intl");
var messages = (0, _reactIntl.defineMessages)({
    feedbackTitle: {
        id: 'feedback-collector.feedback-title',
        defaultMessage: 'Share your thoughts',
        description: 'The title shown at the top of the feedback form encouraging users to leave feedback'
    },
    enrolInResearchLabel: {
        id: 'feedback-collector.enrol-in-research.label',
        defaultMessage: "I'd like to participate in product research",
        description: 'The checkbox label letting users enrol themselves in future product research interviews'
    },
    canBeContactedLabel: {
        id: 'feedback-collector.can-be-contacted.label',
        defaultMessage: 'Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian products and services. I acknowledge the <a>Atlassian Privacy Policy</a>.',
        description: 'The checkbox label to give consent to be contacted about their feedback'
    },
    canBeContactedLabelWithoutLink: {
        id: 'feedback-collector.can-be-contacted.label-without-link',
        defaultMessage: 'Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian products and services. I acknowledge the Atlassian Privacy Policy.',
        description: 'The checkbox label to give consent to be contacted about their feedback'
    },
    privacyPolicy: {
        id: 'feedback-collector.privacy-policy',
        defaultMessage: 'Atlassian Privacy Policy',
        description: 'The text content for the Privacy Policy link'
    },
    summaryPlaceholder: {
        id: 'feedback-collector.summary-placeholder',
        defaultMessage: "Let us know what's on your mind",
        description: 'The textarea label listing feedback categories (bug, suggestions, questions, comments)'
    },
    formCommentLabel: {
        id: 'feedback-collector.form.comment.label',
        defaultMessage: "Let us know what's on your mind",
        description: 'The textarea label where users can write their comment'
    },
    submitButtonLabel: {
        id: 'feedback-collector.submit-button.label',
        defaultMessage: 'Send feedback',
        description: "The text is shown on a primary submit button at the bottom of the feedback collector form. When clicked, it submits the user's feedback to Atlassian."
    },
    cancelButtonLabel: {
        id: 'feedback-collector.cancel-button.label',
        defaultMessage: 'Cancel',
        description: 'The button to cancel feedback submission'
    },
    giveFeedback: {
        id: 'proforma-form-builder.give-feedback',
        defaultMessage: 'Give feedback',
        description: 'The button that allows users to give feedback'
    },
    formBugLabel: {
        id: 'feedback-collector.form.bug.label',
        defaultMessage: 'Describe the bug or issue',
        description: 'The textarea label where users can describe the bug or issue they have'
    },
    formSuggestionLabel: {
        id: 'feedback-collector.form.suggestion.label',
        defaultMessage: "Let us know what you'd like to improve",
        description: 'The textarea label where users can write their suggestion'
    },
    formQuestionLabel: {
        id: 'feedback-collector.form.question.label',
        defaultMessage: 'What would you like to know?',
        description: 'The textarea label where users can write their question'
    },
    formEmptyLabel: {
        id: 'feedback-collector.form.empty.label',
        defaultMessage: 'Select an option',
        description: 'The text is shown as the default empty/placeholder option in the feedback type drop-down list when no option has been selected yet.'
    },
    formNotRelevantLabel: {
        id: 'feedback-collector.form.not-relevant.label',
        defaultMessage: "Wasn't relevant",
        description: 'The textarea label where users can write their not relevant feedback'
    },
    formNotAccurateLabel: {
        id: 'feedback-collector.form.not-accurate.label',
        defaultMessage: "Wasn't accurate",
        description: 'The textarea label where users can write their not accurate feedback'
    },
    formTooSlowLabel: {
        id: 'feedback-collector.form.too-slow.label',
        defaultMessage: 'Too slow',
        description: 'The textarea label where users can write their too slow feedback'
    },
    formUnhelpfulLinksLabel: {
        id: 'feedback-collector.form.unhelpful-links.label',
        defaultMessage: 'Unhelpful links',
        description: 'The textarea label where users can write their unhelpful links feedback'
    },
    formOtherLabel: {
        id: 'feedback-collector.form.other.label',
        defaultMessage: 'Other',
        description: 'The textarea label where users can write their other feedback'
    },
    selectionOptionQuestionLabel: {
        id: 'feedback-collector.option.question.label',
        defaultMessage: 'Ask a question',
        description: 'The feedback dropdown list option to ask a question'
    },
    selectionOptionCommentLabel: {
        id: 'feedback-collector.option.comment.label',
        defaultMessage: 'Leave a comment',
        description: 'The feedback dropdown list option to leave a comment'
    },
    selectionOptionBugLabel: {
        id: 'feedback-collector.option.bug.label',
        defaultMessage: 'Report a bug',
        description: 'The feedback dropdown list option to report a bug'
    },
    selectionOptionSuggestionLabel: {
        id: 'feedback-collector.option.suggestion.label',
        defaultMessage: 'Suggest an improvement',
        description: 'The feedback dropdown list option to suggest an improvement'
    },
    selectionOptionDefaultLabel: {
        id: 'feedback-collector.option.default.label',
        defaultMessage: 'Select feedback',
        description: 'The text is shown as the visible label of the feedback type drop-down selector in the feedback collector form, prompting the user to choose a feedback category.'
    },
    selectionOptionDefaultPlaceholder: {
        id: 'feedback-collector.option.default.placeholder',
        defaultMessage: 'Choose one',
        description: 'The text is shown as the placeholder inside the feedback type drop-down selector before the user makes a selection, prompting them to pick one of the available feedback categories.'
    },
    feedbackIconLabel: {
        id: 'proforma-form-builder.feedback-icon-label',
        defaultMessage: 'Feedback',
        description: 'Accessibility text used for the feedback icon'
    },
    feedbackSuccessFlagDescription: {
        id: 'feedback-collector.success-flag.description',
        defaultMessage: 'Your valuable feedback helps us continually improve our products.',
        description: 'Description shown when feedback is successfully submitted'
    },
    feedbackSuccessFlagTitle: {
        id: 'feedback-collector.success-flag.title',
        defaultMessage: 'Thanks!',
        description: 'Button to dismiss successflag flag after submitting feedback'
    },
    feedbackIsAnonymousTitle: {
        id: 'feedback-collector.anonymous.title',
        defaultMessage: 'Anonymous feedback',
        description: 'Section message title for anonymous feedback'
    },
    feedbackIsAnonymous: {
        id: 'feedback-collector.anonymous',
        defaultMessage: 'This feedback is being submitted anonymously. Atlassian will not be able to contact you directly regarding this feedback',
        description: 'The text is shown as an informational notice in the feedback collector form when the user is submitting feedback anonymously, informing them that Atlassian will not be able to follow up with them directly.'
    },
    requiredFieldsSummary: {
        id: 'feedback-collector.required.fields.summary',
        defaultMessage: 'Required fields are marked with an asterisk',
        description: 'Summary info of required fields asterisk.'
    },
    defaultCustomTextAreaLabel: {
        id: 'feedback-collector.default.custom.textarea.label',
        defaultMessage: "What's on your mind?",
        description: 'The textarea label where users can write their suggestion for custom feedback collector'
    },
    canBeContactedLabelAppify: {
        id: 'feedback-collector.can-be-contacted.label-appify',
        defaultMessage: 'Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian apps and services. I acknowledge the <a>Atlassian Privacy Policy</a>.',
        description: 'The checkbox label to give consent to be contacted about their feedback'
    },
    canBeContactedLabelAppifyWithoutLink: {
        id: 'feedback-collector.can-be-contacted.label-appify-without-link',
        defaultMessage: 'Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian apps and services. I acknowledge the Atlassian Privacy Policy.',
        description: 'The checkbox label to give consent to be contacted about their feedback'
    },
    feedbackSuccessFlagDescriptionAppify: {
        id: 'feedback-collector.success-flag.description-appify',
        defaultMessage: 'Your valuable feedback helps us continually improve our apps.',
        description: 'Description shown when feedback is successfully submitted'
    },
    validationErrorTypeRequired: {
        id: 'feedback-collector.validation.type.required',
        defaultMessage: 'Please select a feedback type',
        description: 'Error message when feedback type is not selected'
    },
    validationErrorDescriptionRequired: {
        id: 'feedback-collector.validation.description.required',
        defaultMessage: 'Please provide a description',
        description: 'Error message when description is not provided'
    },
    optInOptionsLegend: {
        id: 'feedback-collector.opt-in.options.legend',
        defaultMessage: 'Atlassian opt-in options',
        description: 'Legend for the opt-in options on the feedback form'
    }
});

},{"react-intl":"f41fF","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lbRXm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IntlProviderWithResolvedMessages", function() {
    return IntlProviderWithResolvedMessages;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactIntl = require("react-intl");
var _i18NGetMessagesForLocale = require("../utils/i18n-get-messages-for-locale");
var IntlProviderWithResolvedMessages = function(param) {
    var children = param.children, locale = param.locale;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(), 2), resolvedMessagesForLocale = _useState[0], setResolvedMessagesForLocale = _useState[1];
    (0, _react.useEffect)(function() {
        var fetchMessageLocale = function() {
            return (0, _asyncToGenerator._)(function() {
                var messages;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!locale) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                (0, _i18NGetMessagesForLocale.getMessagesForLocale)(locale)
                            ];
                        case 1:
                            messages = _state.sent();
                            setResolvedMessagesForLocale(messages);
                            _state.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            })();
        };
        fetchMessageLocale();
    }, [
        locale
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactIntl.IntlProvider), {
        locale: locale || 'en',
        defaultLocale: "en",
        messages: resolvedMessagesForLocale,
        children: children
    });
};

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_ts_generator":"78Tqx","react/jsx-runtime":"bGvcw","react":"ltHCL","react-intl":"f41fF","../utils/i18n-get-messages-for-locale":"3Wi9m","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3Wi9m":[function(require,module,exports,__globalThis) {
/**
 * Tries to get the most specific messages bundle for a given locale.
 *
 * Strategy:
 * 1. Try to find messages with the exact string (i.e. 'fr_FR')
 * 2. If that doesn't work, try to find messages for the country locale (i.e. 'fr')
 * 3. If that doesn't work, return english messages as a fallback.
 *
 * @param locale string specifying the locale like 'en_GB', or 'fr'.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getMessagesForLocale", function() {
    return getMessagesForLocale;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var getMessagesForLocale = function(locale) {
    return (0, _asyncToGenerator._)(function() {
        var messages, e, parentLocale, messages1, e1;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    locale = locale.replace('-', '_');
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        require(/* webpackChunkName: "@atlaskit-internal_feedback-collector/i18n-tranlations" */ "../i18n/".concat(locale))
                    ];
                case 2:
                    messages = _state.sent();
                    return [
                        2,
                        messages.default
                    ];
                case 3:
                    e = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 4:
                    _state.trys.push([
                        4,
                        6,
                        ,
                        7
                    ]);
                    parentLocale = locale.split(/[-_]/)[0];
                    return [
                        4,
                        require(/* webpackChunkName: "@atlaskit-internal_feedback-collector/i18n-tranlations" */ "../i18n/".concat(parentLocale))
                    ];
                case 5:
                    messages1 = _state.sent();
                    return [
                        2,
                        messages1.default
                    ];
                case 6:
                    e1 = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 7:
                    return [
                        2
                    ];
            }
        });
    })();
};

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_ts_generator":"78Tqx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3Mstt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactIntl = require("react-intl");
var _flag = require("@atlaskit/flag");
var _statusSuccess = require("@atlaskit/icon/core/status-success");
var _statusSuccessDefault = parcelHelpers.interopDefault(_statusSuccess);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _messages = require("../messages");
var _intlProviderWithResolvedMessages = require("./IntlProviderWithResolvedMessages");
var FeedbackFlag = function(param) {
    var description = param.description, title = param.title;
    var formatMessage = (0, _reactIntl.useIntl)().formatMessage;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _flag.AutoDismissFlag), {
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusSuccessDefault.default), {
            spacing: "spacious",
            color: "var(--ds-icon-success, #6A9A23)",
            label: "Success"
        }),
        id: "feedbackSent",
        description: description || formatMessage((0, _platformFeatureFlags.fg)('product-terminology-refresh') ? (0, _messages.messages).feedbackSuccessFlagDescriptionAppify : (0, _messages.messages).feedbackSuccessFlagDescription),
        title: title || formatMessage((0, _messages.messages).feedbackSuccessFlagTitle)
    });
};
var FeedbackFlagWithIntl = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _intlProviderWithResolvedMessages.IntlProviderWithResolvedMessages), {
        locale: props.locale,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(FeedbackFlag, (0, _objectSpread._)({}, props))
    });
};
exports.default = FeedbackFlagWithIntl;

},{"@swc/helpers/_/_object_spread":"9gdrV","react/jsx-runtime":"bGvcw","react":"ltHCL","react-intl":"f41fF","@atlaskit/flag":"blMWC","@atlaskit/icon/core/status-success":"4HNQp","@atlaskit/platform-feature-flags":"kO5t9","../messages":"1UW1R","./IntlProviderWithResolvedMessages":"lbRXm","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aGGNS":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0a07179b7f5702563b15bc18315c2436>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("6f62f17e558c5798"));
var _baseNew = _interopRequireDefault(require("86cb048768db4507"));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Megaphone".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: feedback in apps.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ var MegaphoneIcon = function(props) {
    return /*#__PURE__*/ _react.default.createElement(_baseNew.default, Object.assign({
        name: "MegaphoneIcon",
        dangerouslySetGlyph: '<path fill="currentcolor" d="M13.5 3.096a.5.5 0 0 0-.685-.465L7.5 4.756v4.736l5.315 2.126a.5.5 0 0 0 .685-.465zM5 13a.5.5 0 0 0 .5.5H6v-2.75H5zM2.5 8.75a.5.5 0 0 0 .5.5h3V5H3a.5.5 0 0 0-.5.5zM15 11.152a2 2 0 0 1-2.743 1.857L7.5 11.107v3.143a.75.75 0 0 1-.75.75H5.5a2 2 0 0 1-2-2v-2.25H3a2 2 0 0 1-2-2V5.5a2 2 0 0 1 2-2h3.605l5.652-2.261A2 2 0 0 1 15 3.096z"/>'
    }, props));
};
MegaphoneIcon.displayName = 'MegaphoneIcon';
var _default = exports.default = MegaphoneIcon;

},{"6f62f17e558c5798":"ltHCL","86cb048768db4507":"kuGeY"}],"fyYwD":[function(require,module,exports,__globalThis) {
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable @atlaskit/design-system/use-primitives-text */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ErrorView", function() {
    return ErrorView;
});
var _runtime = require("@compiled/react/runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactIntl = require("react-intl");
var _interactiveHeroIcons = require("../InteractiveHeroIcons");
var _useMediaQuery = require("../InteractiveHeroIcons/use-media-query");
var _whoopsPng = require("./assets/whoops.png");
var _whoopsPngDefault = parcelHelpers.interopDefault(_whoopsPng);
var _messages = require("./messages");
// `whoops.png` is exported at @2x density (intrinsic 1316x311). The 1x display
// size is therefore 658x155.5, which we use as the upper bound so the image
// never renders larger than its native resolution.
var WHOOPS_INTRINSIC_DISPLAY_WIDTH_PX = 658;
// Mirror the fluid sizing strategy used by the signed-out hero typography in
// `ContentStack.tsx` (`WORDMARK_MAX_WIDTH`/`WORDMARK_WIDE_VIEWPORT_QUERY`):
// gutter the image away from the viewport edges, switching to a wider gutter
// past the same breakpoint, so it scales smoothly with the viewport while
// still being capped at its native 1x size.
var WHOOPS_WIDE_VIEWPORT_QUERY = '(min-width: 769px)';
var WHOOPS_MAX_WIDTH = {
    base: "min(".concat(WHOOPS_INTRINSIC_DISPLAY_WIDTH_PX, "px, calc(100vw - 96px))"),
    wide: "min(".concat(WHOOPS_INTRINSIC_DISPLAY_WIDTH_PX, "px, calc(100vw - 256px))")
};
var WHOOPS_DESCRIPTION_MAX_WIDTH = {
    base: 'min(84vw, 390px)',
    wide: 'min(612px, calc(100vw - 256px))'
};
var styles = {
    placeholder: "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1osq _4t3i1osq",
    stack: "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bsb1osq",
    image: "_1e0c1ule _1bsb1osq _4t3i1wug",
    description: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o _k48p1nn1 _1dyz1m6u _syaz14je _ect41t23 _1wyb19j1 _vwz4bs82 _o5726vc6"
};
/**
 * Centered "Whoops" graphic shown while the error UI is being designed.
 * Renders the @2x PNG asset at a fluid size that mirrors the marketing
 * wordmark in the signed-out hero (`ContentStack`), capped at its 1x size.
 */ function WhoopsPlaceholder() {
    var isWideViewport = (0, _useMediaQuery.useMediaQuery)(WHOOPS_WIDE_VIEWPORT_QUERY);
    var imageMaxWidth = isWideViewport ? WHOOPS_MAX_WIDTH.wide : WHOOPS_MAX_WIDTH.base;
    var descriptionMaxWidth = isWideViewport ? WHOOPS_DESCRIPTION_MAX_WIDTH.wide : WHOOPS_DESCRIPTION_MAX_WIDTH.base;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _runtime.ax)([
            styles.placeholder
        ])
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            gap: 'clamp(24px, 4vh, 48px)'
        },
        className: (0, _runtime.ax)([
            styles.stack
        ])
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("img", {
        src: (0, _whoopsPngDefault.default),
        alt: "",
        style: {
            maxWidth: imageMaxWidth
        },
        className: (0, _runtime.ax)([
            styles.image
        ])
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("p", {
        style: {
            maxWidth: descriptionMaxWidth
        },
        className: (0, _runtime.ax)([
            styles.description
        ])
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), (0, _messages.messages).description))));
}
var ErrorView = function() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _interactiveHeroIcons.HeroIcons), {
        centerContent: /*#__PURE__*/ (0, _reactDefault.default).createElement(WhoopsPlaceholder, null)
    });
};

},{"@compiled/react/runtime":"d27Vo","react":"ltHCL","react-intl":"f41fF","../InteractiveHeroIcons":"hVNOg","../InteractiveHeroIcons/use-media-query":"1jDzn","./assets/whoops.png":"kazTe","./messages":"ci7ka","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hVNOg":[function(require,module,exports,__globalThis) {
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HeroIcons", function() {
    return HeroIcons;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _runtime = require("@compiled/react/runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _react1 = require("motion/react");
var _browserApis = require("@atlaskit/browser-apis");
var _useSectionReveal = require("../../../common/analytics/hooks/useSectionReveal");
var _types = require("../../../common/analytics/types");
var _scrollContainer = require("../../utils/scroll-container");
var _backgroundIcons = require("./BackgroundIcons");
var _contentStack = require("./ContentStack");
var _layout = require("./layout");
var _usePointerInteractivity = require("./use-pointer-interactivity");
var _usePrefersReducedMotion = require("./use-prefers-reduced-motion");
var _useViewportTier = require("./use-viewport-tier");
var EDGE_CONFIG = {
    density: 3,
    radius: 600,
    opacity: 0.25
};
var LAYOUT_CONFIG = {
    ovalSize: 0.82,
    ovalAspectRatio: 1.19,
    mobileOvalSize: 1.16,
    mobileOvalAspectRatio: 0.85
};
var AMBIENT_CONFIG = {
    ambientAmp: 2.5
};
var PHYSICS_CONFIG = {
    kSelf: 80,
    kEdge: 20,
    damping: 8,
    flick: 0.5
};
var INTRO_CONFIG = {
    avatarStaggerMs: 60,
    edgeGrowMs: 800,
    iconAppearMs: 300,
    iconAppearOvershoot: 1.8
};
var SHIMMER_CONFIG = {
    enabled: true,
    startOffsetMs: -2000,
    avgIntervalMs: 120,
    maxConcurrent: 10,
    durationMs: 1420,
    pulseLen: 0.37,
    brightness: 0.5,
    strokeWidth: 1.5,
    glow: 0.3
};
var HERO_MOTION_FREEZE_SCROLL_PROGRESS = 0.04;
var HERO_MOTION_UNFREEZE_SCROLL_PROGRESS = 0.025;
var TYPOGRAPHY_HERO_CONFIG = {
    scale: 1
};
var TYPOGRAPHY_LETTER_A_CONFIG = {
    lineWidth: 3,
    durationMs: 800,
    startTimeMs: -1970,
    nodePhaseStart: 0.1,
    nodePhaseEnd: 1,
    shuffleNodes: false,
    shuffleSeed: 300
};
var TYPOGRAPHY_SCRIBBLE_CONFIG = {
    durationMs: 1000,
    startTimeMs: 700,
    ease: 'ease-out',
    lineWidth: 10.5,
    blurPx: 0.5
};
var TYPOGRAPHY_LETTER_INTRO_CONFIG = {
    style: 'fade-in',
    fadeDurationMs: 400,
    blurStartPx: 8,
    totalDurationMs: 450,
    startDelayMs: 480,
    shuffleSeed: 532
};
var CTA_TIMING_CONFIG = {
    subtitleStartMs: 1000,
    subtitleFadeMs: 400,
    ctaStartMs: 1150,
    ctaFadeMs: 500
};
var TYPOGRAPHY_MOUNT_KEY = 'twg-hero-defaults';
var HERO_ASSET_READY_TIMEOUT_MS = 1600;
function initialIntroDone() {
    var doc = (0, _browserApis.getDocument)();
    if (!doc) return false;
    return doc.visibilityState !== 'visible';
}
function waitForHeroImageDecode(src) {
    return new Promise(function(resolve) {
        if (typeof Image === 'undefined') {
            resolve();
            return;
        }
        var image = new Image();
        var settled = false;
        var finish = function() {
            if (settled) return;
            settled = true;
            resolve();
        };
        image.onload = function() {
            var _image_decode;
            var decode = (_image_decode = image.decode) === null || _image_decode === void 0 ? void 0 : _image_decode.call(image);
            if (decode) {
                decode.then(finish, finish);
                return;
            }
            finish();
        };
        image.onerror = finish;
        image.src = src;
        if (image.complete) {
            var _image_decode;
            var decode = (_image_decode = image.decode) === null || _image_decode === void 0 ? void 0 : _image_decode.call(image);
            if (decode) {
                decode.then(finish, finish);
                return;
            }
            finish();
        }
    });
}
// Some production runtimes do not implement Promise.allSettled, which caused
// HeroIcons to crash during image preload (https://atlassian-2y.sentry.io/issues/7464332880/?query=is:unresolved%20issue.category:%5Berror,outage%5D)
// Keep this helper so hero asset readiness waits for all promises without requiring allSettled.
function waitForAllPromisesToSettle(promises) {
    if (typeof Promise.allSettled === 'function') return Promise.allSettled(promises).then(function() {
        return undefined;
    });
    return Promise.all(promises.map(function(promise) {
        return promise.then(function() {
            return undefined;
        }, function() {
            return undefined;
        });
    })).then(function() {
        return undefined;
    });
}
var styles = {
    stageWrapper: "_kqswh2mm _1bsb1osq _4t3i3v0s _bfhk1hlk",
    stageSticky: "_1reo15vq _18m915vq _kqsw1if8 _154iidpf _1bsb1osq _4t3i8stt _bfhk1hlk",
    artboard: "_kqswstnw _154i1ssb _1ltv1ssb _1bsb1ypn _4t3i1fra _t9ec1ooe",
    heroIconLayer: "_1r04idpf _kqswstnw _m6k416lu",
    heroContentLayer: "_1r04idpf _kqswstnw _1pbycs5v _m6k41rjc",
    mobileStageWrapper: "_4t3itm62",
    mobileStageSticky: "_4t3ieki3",
    mobileArtboard: "_1bsbstmo _4t3ieki3"
};
function HeroIcons() {
    var centerContent = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).centerContent;
    var stageRef = (0, _react.useRef)(null);
    var scrollSceneRef = (0, _react.useRef)(null);
    var scrollContainerRef = (0, _react.useRef)(null);
    var sectionRef = (0, _useSectionReveal.useSectionReveal)((0, _types.SectionName).Hero);
    var viewportTier = (0, _useViewportTier.useViewportTier)();
    var iconsInteractive = (0, _usePointerInteractivity.usePointerInteractivity)();
    var reducedMotion = (0, _usePrefersReducedMotion.usePrefersReducedMotion)();
    var _useState = (0, _slicedToArray._)((0, _react.useState)(initialIntroDone), 2), introDone = _useState[0], setIntroDone = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(initialIntroDone), 2), heroAssetsReady = _useState1[0], setHeroAssetsReady = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(false), 2), motionFrozen = _useState2[0], setMotionFrozen = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)(null), 2), scrollContainer = _useState3[0], setScrollContainer = _useState3[1];
    var motionFrozenRef = (0, _react.useRef)(false);
    var replayHandleRef = (0, _react.useRef)(null);
    var isMobileLayout = viewportTier === 'mobile';
    var heroAssetSources = (0, _react.useMemo)(function() {
        return Array.from(new Set((0, _layout.getHeroLayout)((0, _objectSpread._)({
            viewportTier: viewportTier
        }, LAYOUT_CONFIG)).assets.map(function(asset) {
            return asset.src;
        }).filter(function(src) {
            return Boolean(src);
        })));
    }, [
        viewportTier
    ]);
    var scrollYProgress = (0, _react1.useScroll)((0, _objectSpread._)({
        target: scrollSceneRef,
        offset: [
            'start start',
            'end start'
        ]
    }, scrollContainer ? {
        container: scrollContainerRef
    } : {})).scrollYProgress;
    var smoothScrollProgress = (0, _react1.useSpring)(scrollYProgress, {
        stiffness: 120,
        damping: 32,
        mass: 0.2
    });
    var iconScale = (0, _react1.useTransform)(smoothScrollProgress, [
        0,
        1
    ], [
        1,
        1.08
    ]);
    var iconOpacity = (0, _react1.useTransform)(smoothScrollProgress, [
        0,
        0.18,
        0.82
    ], [
        1,
        0.8,
        0.52
    ]);
    var iconBlur = (0, _react1.useTransform)(smoothScrollProgress, [
        0,
        0.08,
        0.55
    ], [
        'blur(0px)',
        'blur(3px)',
        'blur(8px)'
    ]);
    var contentY = (0, _react1.useTransform)(smoothScrollProgress, [
        0,
        0.9
    ], [
        '0%',
        '-14%'
    ]);
    var contentScale = (0, _react1.useTransform)(smoothScrollProgress, [
        0,
        1
    ], [
        1,
        1.04
    ]);
    var contentOpacity = (0, _react1.useTransform)(smoothScrollProgress, [
        0,
        0.82,
        1
    ], [
        1,
        1,
        0
    ]);
    (0, _react1.useMotionValueEvent)(scrollYProgress, 'change', function(latest) {
        if (reducedMotion) return;
        var nextMotionFrozen = motionFrozenRef.current ? latest >= HERO_MOTION_UNFREEZE_SCROLL_PROGRESS : latest >= HERO_MOTION_FREEZE_SCROLL_PROGRESS;
        if (nextMotionFrozen === motionFrozenRef.current) return;
        motionFrozenRef.current = nextMotionFrozen;
        setMotionFrozen(nextMotionFrozen);
    });
    (0, _react.useEffect)(function() {
        var doc = (0, _browserApis.getDocument)();
        var win = doc === null || doc === void 0 ? void 0 : doc.defaultView;
        if (!win || heroAssetSources.length === 0) {
            setHeroAssetsReady(true);
            return;
        }
        var cancelled = false;
        setHeroAssetsReady(false);
        var timeoutId = win.setTimeout(function() {
            if (!cancelled) setHeroAssetsReady(true);
        }, HERO_ASSET_READY_TIMEOUT_MS);
        waitForAllPromisesToSettle(heroAssetSources.map(function(src) {
            return waitForHeroImageDecode(src);
        })).then(function() {
            if (cancelled) return;
            win.clearTimeout(timeoutId);
            setHeroAssetsReady(true);
        });
        return function() {
            cancelled = true;
            win.clearTimeout(timeoutId);
        };
    }, [
        heroAssetSources
    ]);
    var onIntroComplete = (0, _react.useCallback)(function() {
        setIntroDone(true);
    }, []);
    // Hold the latest `sectionRef` in a ref so the merged ref callback below
    // can keep a stable identity for the lifetime of the component. Without
    // this, any change in `sectionRef`'s identity (e.g. from an upstream
    // analytics context re-render that recreates `fireEvent` →
    // `useSectionReveal`'s callback) would cause React to run the
    // detach-with-null + attach-with-node cycle on every render. Each cycle
    // calls `setScrollContainer` with alternating values, which trips React's
    // "Maximum update depth exceeded" guard during commit (TWG-MICROSITE-1N).
    var sectionRefLatest = (0, _react.useRef)(sectionRef);
    sectionRefLatest.current = sectionRef;
    var setScrollSceneNode = (0, _react.useCallback)(function(node) {
        scrollSceneRef.current = node;
        var nextScrollContainer = (0, _scrollContainer.getNearestScrollContainer)(node);
        scrollContainerRef.current = nextScrollContainer;
        setScrollContainer(function(currentScrollContainer) {
            return currentScrollContainer === nextScrollContainer ? currentScrollContainer : nextScrollContainer;
        });
        sectionRefLatest.current(node);
    }, []);
    var effectiveAmbient = reducedMotion ? (0, _objectSpreadProps._)((0, _objectSpread._)({}, AMBIENT_CONFIG), {
        ambientAmp: 0
    }) : AMBIENT_CONFIG;
    var effectiveIntro = reducedMotion ? (0, _objectSpreadProps._)((0, _objectSpread._)({}, INTRO_CONFIG), {
        avatarStaggerMs: 0,
        edgeGrowMs: 0,
        iconAppearMs: 0,
        iconAppearOvershoot: 1
    }) : INTRO_CONFIG;
    var effectiveShimmer = reducedMotion ? (0, _objectSpreadProps._)((0, _objectSpread._)({}, SHIMMER_CONFIG), {
        enabled: false,
        maxConcurrent: 1,
        glow: 0
    }) : SHIMMER_CONFIG;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: setScrollSceneNode,
        className: (0, _runtime.ax)([
            styles.stageWrapper,
            isMobileLayout && styles.mobileStageWrapper
        ])
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _runtime.ax)([
            styles.stageSticky,
            isMobileLayout && styles.mobileStageSticky
        ])
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: stageRef,
        className: (0, _runtime.ax)([
            styles.artboard,
            isMobileLayout && styles.mobileArtboard
        ])
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react1.motion).div, {
        style: reducedMotion ? undefined : {
            scale: iconScale,
            opacity: iconOpacity,
            filter: iconBlur
        },
        className: (0, _runtime.ax)([
            styles.heroIconLayer
        ])
    }, heroAssetsReady && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _backgroundIcons.BackgroundIcons), {
        stageRef: stageRef,
        introDone: introDone,
        onIntroComplete: onIntroComplete,
        replayHandleRef: replayHandleRef,
        edges: EDGE_CONFIG,
        layout: LAYOUT_CONFIG,
        ambient: effectiveAmbient,
        physics: PHYSICS_CONFIG,
        intro: effectiveIntro,
        shimmer: effectiveShimmer,
        viewportTier: viewportTier,
        interactive: iconsInteractive,
        motionFrozen: motionFrozen
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react1.motion).div, {
        style: reducedMotion ? undefined : {
            y: contentY,
            scale: contentScale,
            opacity: contentOpacity
        },
        className: (0, _runtime.ax)([
            styles.heroContentLayer
        ])
    }, centerContent !== null && centerContent !== void 0 ? centerContent : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contentStack.ContentStack), {
        mountKey: TYPOGRAPHY_MOUNT_KEY,
        viewportTier: viewportTier,
        reducedMotion: reducedMotion,
        hero: TYPOGRAPHY_HERO_CONFIG,
        letterA: TYPOGRAPHY_LETTER_A_CONFIG,
        scribble: TYPOGRAPHY_SCRIBBLE_CONFIG,
        letterIntro: TYPOGRAPHY_LETTER_INTRO_CONFIG,
        cta: CTA_TIMING_CONFIG
    })))));
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_sliced_to_array":"8PtL6","@compiled/react/runtime":"d27Vo","react":"ltHCL","motion/react":"4SMiv","@atlaskit/browser-apis":"2dayt","../../../common/analytics/hooks/useSectionReveal":"eteNK","../../../common/analytics/types":"9GPzn","../../utils/scroll-container":"gGuWC","./BackgroundIcons":"hT62j","./ContentStack":"dJjMS","./layout":"aOTT1","./use-pointer-interactivity":"9x0nm","./use-prefers-reduced-motion":"dhHjN","./use-viewport-tier":"5p3Rq","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4SMiv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "m", function() {
    return 0, _framerMotion.m;
});
parcelHelpers.export(exports, "motion", function() {
    return 0, _framerMotion.motion;
});
var _framerMotion = require("framer-motion");
parcelHelpers.exportAll(_framerMotion, exports);

},{"framer-motion":"hdbTm","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hdbTm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AnimatePresence", function() {
    return 0, _indexMjs.AnimatePresence;
});
parcelHelpers.export(exports, "PopChild", function() {
    return 0, _popChildMjs.PopChild;
});
parcelHelpers.export(exports, "PresenceChild", function() {
    return 0, _presenceChildMjs.PresenceChild;
});
parcelHelpers.export(exports, "LayoutGroup", function() {
    return 0, _indexMjs1.LayoutGroup;
});
parcelHelpers.export(exports, "LazyMotion", function() {
    return 0, _indexMjs2.LazyMotion;
});
parcelHelpers.export(exports, "MotionConfig", function() {
    return 0, _indexMjs3.MotionConfig;
});
parcelHelpers.export(exports, "m", function() {
    return 0, _proxyMjs.m;
});
parcelHelpers.export(exports, "motion", function() {
    return 0, _proxyMjs1.motion;
});
parcelHelpers.export(exports, "addPointerEvent", function() {
    return 0, _addPointerEventMjs.addPointerEvent;
});
parcelHelpers.export(exports, "addPointerInfo", function() {
    return 0, _eventInfoMjs.addPointerInfo;
});
parcelHelpers.export(exports, "animations", function() {
    return 0, _animationsMjs.animations;
});
parcelHelpers.export(exports, "makeUseVisualState", function() {
    return 0, _useVisualStateMjs.makeUseVisualState;
});
parcelHelpers.export(exports, "VisualElement", function() {
    return 0, _motionDom.VisualElement;
});
parcelHelpers.export(exports, "addScaleCorrector", function() {
    return 0, _motionDom.addScaleCorrector;
});
parcelHelpers.export(exports, "animateVisualElement", function() {
    return 0, _motionDom.animateVisualElement;
});
parcelHelpers.export(exports, "buildTransform", function() {
    return 0, _motionDom.buildTransform;
});
parcelHelpers.export(exports, "calcLength", function() {
    return 0, _motionDom.calcLength;
});
parcelHelpers.export(exports, "createBox", function() {
    return 0, _motionDom.createBox;
});
parcelHelpers.export(exports, "delay", function() {
    return 0, _motionDom.delay;
});
parcelHelpers.export(exports, "optimizedAppearDataAttribute", function() {
    return 0, _motionDom.optimizedAppearDataAttribute;
});
parcelHelpers.export(exports, "resolveMotionValue", function() {
    return 0, _motionDom.resolveMotionValue;
});
parcelHelpers.export(exports, "visualElementStore", function() {
    return 0, _motionDom.visualElementStore;
});
parcelHelpers.export(exports, "filterProps", function() {
    return 0, _filterPropsMjs.filterProps;
});
parcelHelpers.export(exports, "isBrowser", function() {
    return 0, _isBrowserMjs.isBrowser;
});
parcelHelpers.export(exports, "useComposedRefs", function() {
    return 0, _useComposedRefMjs.useComposedRefs;
});
parcelHelpers.export(exports, "useForceUpdate", function() {
    return 0, _useForceUpdateMjs.useForceUpdate;
});
parcelHelpers.export(exports, "useIsomorphicLayoutEffect", function() {
    return 0, _useIsomorphicEffectMjs.useIsomorphicLayoutEffect;
});
parcelHelpers.export(exports, "useUnmountEffect", function() {
    return 0, _useUnmountEffectMjs.useUnmountEffect;
});
parcelHelpers.export(exports, "domAnimation", function() {
    return 0, _featuresAnimationMjs.domAnimation;
});
parcelHelpers.export(exports, "domMax", function() {
    return 0, _featuresMaxMjs.domMax;
});
parcelHelpers.export(exports, "domMin", function() {
    return 0, _featuresMinMjs.domMin;
});
parcelHelpers.export(exports, "useMotionValueEvent", function() {
    return 0, _useMotionValueEventMjs.useMotionValueEvent;
});
parcelHelpers.export(exports, "useElementScroll", function() {
    return 0, _useElementScrollMjs.useElementScroll;
});
parcelHelpers.export(exports, "useViewportScroll", function() {
    return 0, _useViewportScrollMjs.useViewportScroll;
});
parcelHelpers.export(exports, "useMotionTemplate", function() {
    return 0, _useMotionTemplateMjs.useMotionTemplate;
});
parcelHelpers.export(exports, "useMotionValue", function() {
    return 0, _useMotionValueMjs.useMotionValue;
});
parcelHelpers.export(exports, "useScroll", function() {
    return 0, _useScrollMjs.useScroll;
});
parcelHelpers.export(exports, "useFollowValue", function() {
    return 0, _useFollowValueMjs.useFollowValue;
});
parcelHelpers.export(exports, "useSpring", function() {
    return 0, _useSpringMjs.useSpring;
});
parcelHelpers.export(exports, "useTime", function() {
    return 0, _useTimeMjs.useTime;
});
parcelHelpers.export(exports, "useTransform", function() {
    return 0, _useTransformMjs.useTransform;
});
parcelHelpers.export(exports, "useVelocity", function() {
    return 0, _useVelocityMjs.useVelocity;
});
parcelHelpers.export(exports, "useWillChange", function() {
    return 0, _indexMjs4.useWillChange;
});
parcelHelpers.export(exports, "WillChangeMotionValue", function() {
    return 0, _willChangeMotionValueMjs.WillChangeMotionValue;
});
parcelHelpers.export(exports, "useReducedMotion", function() {
    return 0, _useReducedMotionMjs.useReducedMotion;
});
parcelHelpers.export(exports, "useReducedMotionConfig", function() {
    return 0, _useReducedMotionConfigMjs.useReducedMotionConfig;
});
parcelHelpers.export(exports, "MotionGlobalConfig", function() {
    return 0, _motionUtils.MotionGlobalConfig;
});
parcelHelpers.export(exports, "animationControls", function() {
    return 0, _animationControlsMjs.animationControls;
});
parcelHelpers.export(exports, "useAnimate", function() {
    return 0, _useAnimateMjs.useAnimate;
});
parcelHelpers.export(exports, "useAnimateMini", function() {
    return 0, _useAnimateStyleMjs.useAnimateMini;
});
parcelHelpers.export(exports, "useAnimation", function() {
    return 0, _useAnimationMjs.useAnimation;
});
parcelHelpers.export(exports, "useAnimationControls", function() {
    return 0, _useAnimationMjs.useAnimationControls;
});
parcelHelpers.export(exports, "useIsPresent", function() {
    return 0, _usePresenceMjs.useIsPresent;
});
parcelHelpers.export(exports, "usePresence", function() {
    return 0, _usePresenceMjs.usePresence;
});
parcelHelpers.export(exports, "usePresenceData", function() {
    return 0, _usePresenceDataMjs.usePresenceData;
});
parcelHelpers.export(exports, "useDomEvent", function() {
    return 0, _useDomEventMjs.useDomEvent;
});
parcelHelpers.export(exports, "DragControls", function() {
    return 0, _useDragControlsMjs.DragControls;
});
parcelHelpers.export(exports, "useDragControls", function() {
    return 0, _useDragControlsMjs.useDragControls;
});
parcelHelpers.export(exports, "isMotionComponent", function() {
    return 0, _isMotionComponentMjs.isMotionComponent;
});
parcelHelpers.export(exports, "unwrapMotionComponent", function() {
    return 0, _unwrapMotionComponentMjs.unwrapMotionComponent;
});
parcelHelpers.export(exports, "isValidMotionProp", function() {
    return 0, _validPropMjs.isValidMotionProp;
});
parcelHelpers.export(exports, "useInstantLayoutTransition", function() {
    return 0, _useInstantLayoutTransitionMjs.useInstantLayoutTransition;
});
parcelHelpers.export(exports, "useResetProjection", function() {
    return 0, _useResetProjectionMjs.useResetProjection;
});
parcelHelpers.export(exports, "useAnimationFrame", function() {
    return 0, _useAnimationFrameMjs.useAnimationFrame;
});
parcelHelpers.export(exports, "useCycle", function() {
    return 0, _useCycleMjs.useCycle;
});
parcelHelpers.export(exports, "useInView", function() {
    return 0, _useInViewMjs.useInView;
});
parcelHelpers.export(exports, "disableInstantTransitions", function() {
    return 0, _useInstantTransitionMjs.disableInstantTransitions;
});
parcelHelpers.export(exports, "useInstantTransition", function() {
    return 0, _useInstantTransitionMjs.useInstantTransition;
});
parcelHelpers.export(exports, "usePageInView", function() {
    return 0, _usePageInViewMjs.usePageInView;
});
parcelHelpers.export(exports, "transformViewBoxPoint", function() {
    return 0, _transformViewboxPointMjs.transformViewBoxPoint;
});
parcelHelpers.export(exports, "correctParentTransform", function() {
    return 0, _transformRotatedParentMjs.correctParentTransform;
});
parcelHelpers.export(exports, "startOptimizedAppearAnimation", function() {
    return 0, _startMjs.startOptimizedAppearAnimation;
});
parcelHelpers.export(exports, "LayoutGroupContext", function() {
    return 0, _layoutGroupContextMjs.LayoutGroupContext;
});
parcelHelpers.export(exports, "MotionConfigContext", function() {
    return 0, _motionConfigContextMjs.MotionConfigContext;
});
parcelHelpers.export(exports, "MotionContext", function() {
    return 0, _indexMjs5.MotionContext;
});
parcelHelpers.export(exports, "PresenceContext", function() {
    return 0, _presenceContextMjs.PresenceContext;
});
parcelHelpers.export(exports, "SwitchLayoutGroupContext", function() {
    return 0, _switchLayoutGroupContextMjs.SwitchLayoutGroupContext;
});
parcelHelpers.export(exports, "useDeprecatedAnimatedState", function() {
    return 0, _useAnimatedStateMjs.useAnimatedState;
});
parcelHelpers.export(exports, "AnimateSharedLayout", function() {
    return 0, _animateSharedLayoutMjs.AnimateSharedLayout;
});
parcelHelpers.export(exports, "DeprecatedLayoutGroupContext", function() {
    return 0, _deprecatedLayoutGroupContextMjs.DeprecatedLayoutGroupContext;
});
parcelHelpers.export(exports, "useDeprecatedInvertedScale", function() {
    return 0, _useInvertedScaleMjs.useInvertedScale;
});
parcelHelpers.export(exports, "animate", function() {
    return 0, _indexMjs6.animate;
});
parcelHelpers.export(exports, "createScopedAnimate", function() {
    return 0, _indexMjs6.createScopedAnimate;
});
parcelHelpers.export(exports, "animateMini", function() {
    return 0, _animateStyleMjs.animateMini;
});
parcelHelpers.export(exports, "distance", function() {
    return 0, _distanceMjs.distance;
});
parcelHelpers.export(exports, "distance2D", function() {
    return 0, _distanceMjs.distance2D;
});
parcelHelpers.export(exports, "inView", function() {
    return 0, _indexMjs7.inView;
});
parcelHelpers.export(exports, "scroll", function() {
    return 0, _indexMjs8.scroll;
});
parcelHelpers.export(exports, "scrollInfo", function() {
    return 0, _trackMjs.scrollInfo;
});
parcelHelpers.export(exports, "Reorder", function() {
    return _namespaceMjs;
});
var _indexMjs = require("./components/AnimatePresence/index.mjs");
var _popChildMjs = require("./components/AnimatePresence/PopChild.mjs");
var _presenceChildMjs = require("./components/AnimatePresence/PresenceChild.mjs");
var _indexMjs1 = require("./components/LayoutGroup/index.mjs");
var _indexMjs2 = require("./components/LazyMotion/index.mjs");
var _indexMjs3 = require("./components/MotionConfig/index.mjs");
var _proxyMjs = require("./render/components/m/proxy.mjs");
var _proxyMjs1 = require("./render/components/motion/proxy.mjs");
var _addPointerEventMjs = require("./events/add-pointer-event.mjs");
var _eventInfoMjs = require("./events/event-info.mjs");
var _animationsMjs = require("./motion/features/animations.mjs");
var _useVisualStateMjs = require("./motion/utils/use-visual-state.mjs");
var _motionDom = require("motion-dom");
parcelHelpers.exportAll(_motionDom, exports);
var _filterPropsMjs = require("./render/dom/utils/filter-props.mjs");
var _isBrowserMjs = require("./utils/is-browser.mjs");
var _useComposedRefMjs = require("./utils/use-composed-ref.mjs");
var _useForceUpdateMjs = require("./utils/use-force-update.mjs");
var _useIsomorphicEffectMjs = require("./utils/use-isomorphic-effect.mjs");
var _useUnmountEffectMjs = require("./utils/use-unmount-effect.mjs");
var _featuresAnimationMjs = require("./render/dom/features-animation.mjs");
var _featuresMaxMjs = require("./render/dom/features-max.mjs");
var _featuresMinMjs = require("./render/dom/features-min.mjs");
var _useMotionValueEventMjs = require("./utils/use-motion-value-event.mjs");
var _useElementScrollMjs = require("./value/scroll/use-element-scroll.mjs");
var _useViewportScrollMjs = require("./value/scroll/use-viewport-scroll.mjs");
var _useMotionTemplateMjs = require("./value/use-motion-template.mjs");
var _useMotionValueMjs = require("./value/use-motion-value.mjs");
var _useScrollMjs = require("./value/use-scroll.mjs");
var _useFollowValueMjs = require("./value/use-follow-value.mjs");
var _useSpringMjs = require("./value/use-spring.mjs");
var _useTimeMjs = require("./value/use-time.mjs");
var _useTransformMjs = require("./value/use-transform.mjs");
var _useVelocityMjs = require("./value/use-velocity.mjs");
var _indexMjs4 = require("./value/use-will-change/index.mjs");
var _willChangeMotionValueMjs = require("./value/use-will-change/WillChangeMotionValue.mjs");
var _useReducedMotionMjs = require("./utils/reduced-motion/use-reduced-motion.mjs");
var _useReducedMotionConfigMjs = require("./utils/reduced-motion/use-reduced-motion-config.mjs");
var _motionUtils = require("motion-utils");
parcelHelpers.exportAll(_motionUtils, exports);
var _animationControlsMjs = require("./animation/hooks/animation-controls.mjs");
var _useAnimateMjs = require("./animation/hooks/use-animate.mjs");
var _useAnimateStyleMjs = require("./animation/hooks/use-animate-style.mjs");
var _useAnimationMjs = require("./animation/hooks/use-animation.mjs");
var _usePresenceMjs = require("./components/AnimatePresence/use-presence.mjs");
var _usePresenceDataMjs = require("./components/AnimatePresence/use-presence-data.mjs");
var _useDomEventMjs = require("./events/use-dom-event.mjs");
var _useDragControlsMjs = require("./gestures/drag/use-drag-controls.mjs");
var _isMotionComponentMjs = require("./motion/utils/is-motion-component.mjs");
var _unwrapMotionComponentMjs = require("./motion/utils/unwrap-motion-component.mjs");
var _validPropMjs = require("./motion/utils/valid-prop.mjs");
var _useInstantLayoutTransitionMjs = require("./projection/use-instant-layout-transition.mjs");
var _useResetProjectionMjs = require("./projection/use-reset-projection.mjs");
var _useAnimationFrameMjs = require("./utils/use-animation-frame.mjs");
var _useCycleMjs = require("./utils/use-cycle.mjs");
var _useInViewMjs = require("./utils/use-in-view.mjs");
var _useInstantTransitionMjs = require("./utils/use-instant-transition.mjs");
var _usePageInViewMjs = require("./utils/use-page-in-view.mjs");
var _transformViewboxPointMjs = require("./utils/transform-viewbox-point.mjs");
var _transformRotatedParentMjs = require("./utils/transform-rotated-parent.mjs");
var _startMjs = require("./animation/optimized-appear/start.mjs");
var _layoutGroupContextMjs = require("./context/LayoutGroupContext.mjs");
var _motionConfigContextMjs = require("./context/MotionConfigContext.mjs");
var _indexMjs5 = require("./context/MotionContext/index.mjs");
var _presenceContextMjs = require("./context/PresenceContext.mjs");
var _switchLayoutGroupContextMjs = require("./context/SwitchLayoutGroupContext.mjs");
var _useAnimatedStateMjs = require("./animation/hooks/use-animated-state.mjs");
var _animateSharedLayoutMjs = require("./components/AnimateSharedLayout.mjs");
var _deprecatedLayoutGroupContextMjs = require("./context/DeprecatedLayoutGroupContext.mjs");
var _useInvertedScaleMjs = require("./value/use-inverted-scale.mjs");
var _namespaceMjs = require("./components/Reorder/namespace.mjs");
var _indexMjs6 = require("./animation/animate/index.mjs");
var _animateStyleMjs = require("./animation/animators/waapi/animate-style.mjs");
var _distanceMjs = require("./utils/distance.mjs");
var _indexMjs7 = require("./render/dom/viewport/index.mjs");
var _indexMjs8 = require("./render/dom/scroll/index.mjs");
var _trackMjs = require("./render/dom/scroll/track.mjs");

},{"./components/AnimatePresence/index.mjs":"i4Qtr","./components/AnimatePresence/PopChild.mjs":false,"./components/AnimatePresence/PresenceChild.mjs":false,"./components/LayoutGroup/index.mjs":false,"./components/LazyMotion/index.mjs":false,"./components/MotionConfig/index.mjs":false,"./render/components/m/proxy.mjs":false,"./render/components/motion/proxy.mjs":"lRaFo","./events/add-pointer-event.mjs":false,"./events/event-info.mjs":false,"./motion/features/animations.mjs":false,"./motion/utils/use-visual-state.mjs":false,"motion-dom":"kgVDX","./render/dom/utils/filter-props.mjs":false,"./utils/is-browser.mjs":false,"./utils/use-composed-ref.mjs":false,"./utils/use-force-update.mjs":false,"./utils/use-isomorphic-effect.mjs":false,"./utils/use-unmount-effect.mjs":false,"./render/dom/features-animation.mjs":false,"./render/dom/features-max.mjs":false,"./render/dom/features-min.mjs":false,"./utils/use-motion-value-event.mjs":"idybG","./value/scroll/use-element-scroll.mjs":false,"./value/scroll/use-viewport-scroll.mjs":false,"./value/use-motion-template.mjs":"4m3vJ","./value/use-motion-value.mjs":"30uxP","./value/use-scroll.mjs":"aM8BP","./value/use-follow-value.mjs":false,"./value/use-spring.mjs":"4Ncs3","./value/use-time.mjs":false,"./value/use-transform.mjs":"kJjDj","./value/use-velocity.mjs":false,"./value/use-will-change/index.mjs":false,"./value/use-will-change/WillChangeMotionValue.mjs":false,"./utils/reduced-motion/use-reduced-motion.mjs":"eyBfJ","./utils/reduced-motion/use-reduced-motion-config.mjs":false,"motion-utils":false,"./animation/hooks/animation-controls.mjs":false,"./animation/hooks/use-animate.mjs":false,"./animation/hooks/use-animate-style.mjs":false,"./animation/hooks/use-animation.mjs":false,"./components/AnimatePresence/use-presence.mjs":false,"./components/AnimatePresence/use-presence-data.mjs":false,"./events/use-dom-event.mjs":false,"./gestures/drag/use-drag-controls.mjs":false,"./motion/utils/is-motion-component.mjs":false,"./motion/utils/unwrap-motion-component.mjs":false,"./motion/utils/valid-prop.mjs":false,"./projection/use-instant-layout-transition.mjs":false,"./projection/use-reset-projection.mjs":false,"./utils/use-animation-frame.mjs":false,"./utils/use-cycle.mjs":false,"./utils/use-in-view.mjs":"c2aMv","./utils/use-instant-transition.mjs":false,"./utils/use-page-in-view.mjs":false,"./utils/transform-viewbox-point.mjs":false,"./utils/transform-rotated-parent.mjs":false,"./animation/optimized-appear/start.mjs":false,"./context/LayoutGroupContext.mjs":false,"./context/MotionConfigContext.mjs":false,"./context/MotionContext/index.mjs":false,"./context/PresenceContext.mjs":false,"./context/SwitchLayoutGroupContext.mjs":false,"./animation/hooks/use-animated-state.mjs":false,"./components/AnimateSharedLayout.mjs":false,"./context/DeprecatedLayoutGroupContext.mjs":false,"./value/use-inverted-scale.mjs":false,"./components/Reorder/namespace.mjs":false,"./animation/animate/index.mjs":"fIMTL","./animation/animators/waapi/animate-style.mjs":false,"./utils/distance.mjs":false,"./render/dom/viewport/index.mjs":false,"./render/dom/scroll/index.mjs":false,"./render/dom/scroll/track.mjs":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"i4Qtr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AnimatePresence", function() {
    return AnimatePresence;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _layoutGroupContextMjs = require("../../context/LayoutGroupContext.mjs");
var _useConstantMjs = require("../../utils/use-constant.mjs");
var _useIsomorphicEffectMjs = require("../../utils/use-isomorphic-effect.mjs");
var _presenceChildMjs = require("./PresenceChild.mjs");
var _usePresenceMjs = require("./use-presence.mjs");
var _utilsMjs = require("./utils.mjs");
"use client";
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */ var AnimatePresence = function(param) {
    var children = param.children, custom = param.custom, _param_initial = param.initial, initial = _param_initial === void 0 ? true : _param_initial, onExitComplete = param.onExitComplete, _param_presenceAffectsLayout = param.presenceAffectsLayout, presenceAffectsLayout = _param_presenceAffectsLayout === void 0 ? true : _param_presenceAffectsLayout, _param_mode = param.mode, mode = _param_mode === void 0 ? "sync" : _param_mode, _param_propagate = param.propagate, propagate = _param_propagate === void 0 ? false : _param_propagate, _param_anchorX = param.anchorX, anchorX = _param_anchorX === void 0 ? "left" : _param_anchorX, _param_anchorY = param.anchorY, anchorY = _param_anchorY === void 0 ? "top" : _param_anchorY, root = param.root;
    var _usePresence = (0, _slicedToArray._)((0, _usePresenceMjs.usePresence)(propagate), 2), isParentPresent = _usePresence[0], safeToRemove = _usePresence[1];
    /**
     * Filter any children that aren't ReactElements. We can only track components
     * between renders with a props.key.
     */ var presentChildren = (0, _react.useMemo)(function() {
        return (0, _utilsMjs.onlyElements)(children);
    }, [
        children
    ]);
    /**
     * Track the keys of the currently rendered children. This is used to
     * determine which children are exiting.
     */ var presentKeys = propagate && !isParentPresent ? [] : presentChildren.map((0, _utilsMjs.getChildKey));
    /**
     * If `initial={false}` we only want to pass this to components in the first render.
     */ var isInitialRender = (0, _react.useRef)(true);
    /**
     * A ref containing the currently present children. When all exit animations
     * are complete, we use this to re-render the component with the latest children
     * *committed* rather than the latest children *rendered*.
     */ var pendingPresentChildren = (0, _react.useRef)(presentChildren);
    /**
     * Track which exiting children have finished animating out.
     */ var exitComplete = (0, _useConstantMjs.useConstant)(function() {
        return new Map();
    });
    /**
     * Track which components are currently processing exit to prevent duplicate processing.
     */ var exitingComponents = (0, _react.useRef)(new Set());
    /**
     * Save children to render as React state. To ensure this component is concurrent-safe,
     * we check for exiting children via an effect.
     */ var _useState = (0, _slicedToArray._)((0, _react.useState)(presentChildren), 2), diffedChildren = _useState[0], setDiffedChildren = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(presentChildren), 2), renderedChildren = _useState1[0], setRenderedChildren = _useState1[1];
    (0, _useIsomorphicEffectMjs.useIsomorphicLayoutEffect)(function() {
        isInitialRender.current = false;
        pendingPresentChildren.current = presentChildren;
        /**
         * Update complete status of exiting children.
         */ for(var i = 0; i < renderedChildren.length; i++){
            var key = (0, _utilsMjs.getChildKey)(renderedChildren[i]);
            if (!presentKeys.includes(key)) {
                if (exitComplete.get(key) !== true) exitComplete.set(key, false);
            } else {
                exitComplete.delete(key);
                exitingComponents.current.delete(key);
            }
        }
    }, [
        renderedChildren,
        presentKeys.length,
        presentKeys.join("-")
    ]);
    var exitingChildren = [];
    if (presentChildren !== diffedChildren) {
        var nextChildren = (0, _toConsumableArray._)(presentChildren);
        /**
         * Loop through all the currently rendered components and decide which
         * are exiting.
         */ for(var i = 0; i < renderedChildren.length; i++){
            var child = renderedChildren[i];
            var key = (0, _utilsMjs.getChildKey)(child);
            if (!presentKeys.includes(key)) {
                nextChildren.splice(i, 0, child);
                exitingChildren.push(child);
            }
        }
        /**
         * If we're in "wait" mode, and we have exiting children, we want to
         * only render these until they've all exited.
         */ if (mode === "wait" && exitingChildren.length) nextChildren = exitingChildren;
        setRenderedChildren((0, _utilsMjs.onlyElements)(nextChildren));
        setDiffedChildren(presentChildren);
        /**
         * Early return to ensure once we've set state with the latest diffed
         * children, we can immediately re-render.
         */ return null;
    }
    /**
     * If we've been provided a forceRender function by the LayoutGroupContext,
     * we can use it to force a re-render amongst all surrounding components once
     * all components have finished animating out.
     */ var forceRender = (0, _react.useContext)((0, _layoutGroupContextMjs.LayoutGroupContext)).forceRender;
    return (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: renderedChildren.map(function(child) {
            var key = (0, _utilsMjs.getChildKey)(child);
            var isPresent = propagate && !isParentPresent ? false : presentChildren === renderedChildren || presentKeys.includes(key);
            var onExit = function() {
                if (exitingComponents.current.has(key)) return;
                if (exitComplete.has(key)) {
                    exitingComponents.current.add(key);
                    exitComplete.set(key, true);
                } else return;
                var isEveryExitComplete = true;
                exitComplete.forEach(function(isExitComplete) {
                    if (!isExitComplete) isEveryExitComplete = false;
                });
                if (isEveryExitComplete) {
                    forceRender === null || forceRender === void 0 ? void 0 : forceRender();
                    setRenderedChildren(pendingPresentChildren.current);
                    propagate && (safeToRemove === null || safeToRemove === void 0 ? void 0 : safeToRemove());
                    onExitComplete && onExitComplete();
                }
            };
            return (0, _jsxRuntime.jsx)((0, _presenceChildMjs.PresenceChild), {
                isPresent: isPresent,
                initial: !isInitialRender.current || initial ? undefined : false,
                custom: custom,
                presenceAffectsLayout: presenceAffectsLayout,
                mode: mode,
                root: root,
                onExitComplete: isPresent ? undefined : onExit,
                anchorX: anchorX,
                anchorY: anchorY,
                children: child
            }, key);
        })
    });
};

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_to_consumable_array":"1eSZf","react/jsx-runtime":"bGvcw","react":"ltHCL","../../context/LayoutGroupContext.mjs":"9RQFv","../../utils/use-constant.mjs":"bhMxB","../../utils/use-isomorphic-effect.mjs":"lN2vQ","./PresenceChild.mjs":"efTJN","./use-presence.mjs":"39VSv","./utils.mjs":"2KCYN","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9RQFv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LayoutGroupContext", function() {
    return LayoutGroupContext;
});
var _react = require("react");
"use client";
var LayoutGroupContext = (0, _react.createContext)({});

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bhMxB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useConstant", function() {
    return useConstant;
});
var _react = require("react");
"use client";
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function useConstant(init) {
    var ref = (0, _react.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lN2vQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIsomorphicLayoutEffect", function() {
    return useIsomorphicLayoutEffect;
});
var _react = require("react");
var _isBrowserMjs = require("./is-browser.mjs");
"use client";
var useIsomorphicLayoutEffect = (0, _isBrowserMjs.isBrowser) ? (0, _react.useLayoutEffect) : (0, _react.useEffect);

},{"react":"ltHCL","./is-browser.mjs":"bwJp9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bwJp9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isBrowser", function() {
    return isBrowser;
});
var isBrowser = typeof window !== "undefined";

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"efTJN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PresenceChild", function() {
    return PresenceChild;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _presenceContextMjs = require("../../context/PresenceContext.mjs");
var _useConstantMjs = require("../../utils/use-constant.mjs");
var _popChildMjs = require("./PopChild.mjs");
"use client";
var PresenceChild = function(param) {
    var children = param.children, initial = param.initial, isPresent = param.isPresent, onExitComplete = param.onExitComplete, custom = param.custom, presenceAffectsLayout = param.presenceAffectsLayout, mode = param.mode, anchorX = param.anchorX, anchorY = param.anchorY, root = param.root;
    var presenceChildren = (0, _useConstantMjs.useConstant)(newChildrenMap);
    var id = (0, _react.useId)();
    var isReusedContext = true;
    var context = (0, _react.useMemo)(function() {
        isReusedContext = false;
        return {
            id: id,
            initial: initial,
            isPresent: isPresent,
            custom: custom,
            onExitComplete: function(childId) {
                presenceChildren.set(childId, true);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = presenceChildren.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var isComplete = _step.value;
                        if (!isComplete) return; // can stop searching when any is incomplete
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                onExitComplete && onExitComplete();
            },
            register: function(childId) {
                presenceChildren.set(childId, false);
                return function() {
                    return presenceChildren.delete(childId);
                };
            }
        };
    }, [
        isPresent,
        presenceChildren,
        onExitComplete
    ]);
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */ if (presenceAffectsLayout && isReusedContext) context = (0, _objectSpread._)({}, context);
    (0, _react.useMemo)(function() {
        presenceChildren.forEach(function(_, key) {
            return presenceChildren.set(key, false);
        });
    }, [
        isPresent
    ]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */ _react.useEffect(function() {
        !isPresent && !presenceChildren.size && onExitComplete && onExitComplete();
    }, [
        isPresent
    ]);
    children = (0, _jsxRuntime.jsx)((0, _popChildMjs.PopChild), {
        pop: mode === "popLayout",
        isPresent: isPresent,
        anchorX: anchorX,
        anchorY: anchorY,
        root: root,
        children: children
    });
    return (0, _jsxRuntime.jsx)((0, _presenceContextMjs.PresenceContext).Provider, {
        value: context,
        children: children
    });
};
function newChildrenMap() {
    return new Map();
}

},{"@swc/helpers/_/_object_spread":"9gdrV","react/jsx-runtime":"bGvcw","react":"ltHCL","../../context/PresenceContext.mjs":"7pkrx","../../utils/use-constant.mjs":"bhMxB","./PopChild.mjs":"3mlCz","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7pkrx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PresenceContext", function() {
    return PresenceContext;
});
var _react = require("react");
"use client";
/**
 * @public
 */ var PresenceContext = /* @__PURE__ */ (0, _react.createContext)(null);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3mlCz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PopChild", function() {
    return PopChild;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _jsxRuntime = require("react/jsx-runtime");
var _motionDom = require("motion-dom");
var _react = require("react");
var _motionConfigContextMjs = require("../../context/MotionConfigContext.mjs");
var _useComposedRefMjs = require("../../utils/use-composed-ref.mjs");
"use client";
/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */ var PopChildMeasure = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, _inherits._)(PopChildMeasure, _React_Component);
    function PopChildMeasure() {
        (0, _classCallCheck._)(this, PopChildMeasure);
        return (0, _callSuper._)(this, PopChildMeasure, arguments);
    }
    (0, _createClass._)(PopChildMeasure, [
        {
            key: "getSnapshotBeforeUpdate",
            value: function getSnapshotBeforeUpdate(prevProps) {
                var element = this.props.childRef.current;
                if ((0, _motionDom.isHTMLElement)(element) && prevProps.isPresent && !this.props.isPresent && this.props.pop !== false) {
                    var parent = element.offsetParent;
                    var parentWidth = (0, _motionDom.isHTMLElement)(parent) ? parent.offsetWidth || 0 : 0;
                    var parentHeight = (0, _motionDom.isHTMLElement)(parent) ? parent.offsetHeight || 0 : 0;
                    var computedStyle = getComputedStyle(element);
                    var size = this.props.sizeRef.current;
                    size.height = parseFloat(computedStyle.height);
                    size.width = parseFloat(computedStyle.width);
                    size.top = element.offsetTop;
                    size.left = element.offsetLeft;
                    size.right = parentWidth - size.width - size.left;
                    size.bottom = parentHeight - size.height - size.top;
                }
                return null;
            }
        },
        {
            /**
     * Required with getSnapshotBeforeUpdate to stop React complaining.
     */ key: "componentDidUpdate",
            value: function componentDidUpdate() {}
        },
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return PopChildMeasure;
}(_react.Component);
function PopChild(param) {
    var children = param.children, isPresent = param.isPresent, anchorX = param.anchorX, anchorY = param.anchorY, root = param.root, pop = param.pop;
    var _children_props;
    var id = (0, _react.useId)();
    var ref = (0, _react.useRef)(null);
    var size = (0, _react.useRef)({
        width: 0,
        height: 0,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
    });
    var nonce = (0, _react.useContext)((0, _motionConfigContextMjs.MotionConfigContext)).nonce;
    var _children_props_ref;
    /**
     * In React 19, refs are passed via props.ref instead of element.ref.
     * We check props.ref first (React 19) and fall back to element.ref (React 18).
     */ var childRef = (_children_props_ref = (_children_props = children.props) === null || _children_props === void 0 ? void 0 : _children_props.ref) !== null && _children_props_ref !== void 0 ? _children_props_ref : children === null || children === void 0 ? void 0 : children.ref;
    var composedRef = (0, _useComposedRefMjs.useComposedRefs)(ref, childRef);
    /**
     * We create and inject a style block so we can apply this explicit
     * sizing in a non-destructive manner by just deleting the style block.
     *
     * We can't apply size via render as the measurement happens
     * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
     * styles directly on the DOM node, we might be overwriting
     * styles set via the style prop.
     */ (0, _react.useInsertionEffect)(function() {
        var _size_current = size.current, width = _size_current.width, height = _size_current.height, top = _size_current.top, left = _size_current.left, right = _size_current.right, bottom = _size_current.bottom;
        if (isPresent || pop === false || !ref.current || !width || !height) return;
        var x = anchorX === "left" ? "left: ".concat(left) : "right: ".concat(right);
        var y = anchorY === "bottom" ? "bottom: ".concat(bottom) : "top: ".concat(top);
        ref.current.dataset.motionPopId = id;
        var style = document.createElement("style");
        if (nonce) style.nonce = nonce;
        var parent = root !== null && root !== void 0 ? root : document.head;
        parent.appendChild(style);
        if (style.sheet) style.sheet.insertRule('\n          [data-motion-pop-id="'.concat(id, '"] {\n            position: absolute !important;\n            width: ').concat(width, "px !important;\n            height: ").concat(height, "px !important;\n            ").concat(x, "px !important;\n            ").concat(y, "px !important;\n          }\n        "));
        return function() {
            var _ref_current;
            (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.removeAttribute("data-motion-pop-id");
            if (parent.contains(style)) parent.removeChild(style);
        };
    }, [
        isPresent
    ]);
    return (0, _jsxRuntime.jsx)(PopChildMeasure, {
        isPresent: isPresent,
        childRef: ref,
        sizeRef: size,
        pop: pop,
        children: pop === false ? children : _react.cloneElement(children, {
            ref: composedRef
        })
    });
}

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_inherits":"2sfqW","react/jsx-runtime":"bGvcw","motion-dom":"kgVDX","react":"ltHCL","../../context/MotionConfigContext.mjs":"aBfeG","../../utils/use-composed-ref.mjs":"1lcvv","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kgVDX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsyncMotionValueAnimation", function() {
    return 0, _asyncMotionValueAnimationMjs.AsyncMotionValueAnimation;
});
parcelHelpers.export(exports, "GroupAnimation", function() {
    return 0, _groupAnimationMjs.GroupAnimation;
});
parcelHelpers.export(exports, "GroupAnimationWithThen", function() {
    return 0, _groupAnimationWithThenMjs.GroupAnimationWithThen;
});
parcelHelpers.export(exports, "JSAnimation", function() {
    return 0, _jsanimationMjs.JSAnimation;
});
parcelHelpers.export(exports, "animateValue", function() {
    return 0, _jsanimationMjs.animateValue;
});
parcelHelpers.export(exports, "NativeAnimation", function() {
    return 0, _nativeAnimationMjs.NativeAnimation;
});
parcelHelpers.export(exports, "NativeAnimationExtended", function() {
    return 0, _nativeAnimationExtendedMjs.NativeAnimationExtended;
});
parcelHelpers.export(exports, "NativeAnimationWrapper", function() {
    return 0, _nativeAnimationWrapperMjs.NativeAnimationWrapper;
});
parcelHelpers.export(exports, "animationMapKey", function() {
    return 0, _activeAnimationsMjs.animationMapKey;
});
parcelHelpers.export(exports, "getAnimationMap", function() {
    return 0, _activeAnimationsMjs.getAnimationMap;
});
parcelHelpers.export(exports, "calcChildStagger", function() {
    return 0, _calcChildStaggerMjs.calcChildStagger;
});
parcelHelpers.export(exports, "getVariableValue", function() {
    return 0, _cssVariablesConversionMjs.getVariableValue;
});
parcelHelpers.export(exports, "parseCSSVariable", function() {
    return 0, _cssVariablesConversionMjs.parseCSSVariable;
});
parcelHelpers.export(exports, "getDefaultTransition", function() {
    return 0, _defaultTransitionsMjs.getDefaultTransition;
});
parcelHelpers.export(exports, "getFinalKeyframe", function() {
    return 0, _getFinalMjs.getFinalKeyframe;
});
parcelHelpers.export(exports, "getValueTransition", function() {
    return 0, _getValueTransitionMjs.getValueTransition;
});
parcelHelpers.export(exports, "resolveTransition", function() {
    return 0, _resolveTransitionMjs.resolveTransition;
});
parcelHelpers.export(exports, "containsCSSVariable", function() {
    return 0, _isCssVariableMjs.containsCSSVariable;
});
parcelHelpers.export(exports, "isCSSVariableName", function() {
    return 0, _isCssVariableMjs.isCSSVariableName;
});
parcelHelpers.export(exports, "isCSSVariableToken", function() {
    return 0, _isCssVariableMjs.isCSSVariableToken;
});
parcelHelpers.export(exports, "isTransitionDefined", function() {
    return 0, _isTransitionDefinedMjs.isTransitionDefined;
});
parcelHelpers.export(exports, "makeAnimationInstant", function() {
    return 0, _makeAnimationInstantMjs.makeAnimationInstant;
});
parcelHelpers.export(exports, "animateMotionValue", function() {
    return 0, _motionValueMjs.animateMotionValue;
});
parcelHelpers.export(exports, "animateVisualElement", function() {
    return 0, _visualElementMjs.animateVisualElement;
});
parcelHelpers.export(exports, "animateTarget", function() {
    return 0, _visualElementTargetMjs.animateTarget;
});
parcelHelpers.export(exports, "animateVariant", function() {
    return 0, _visualElementVariantMjs.animateVariant;
});
parcelHelpers.export(exports, "optimizedAppearDataAttribute", function() {
    return 0, _dataIdMjs.optimizedAppearDataAttribute;
});
parcelHelpers.export(exports, "optimizedAppearDataId", function() {
    return 0, _dataIdMjs.optimizedAppearDataId;
});
parcelHelpers.export(exports, "getOptimisedAppearId", function() {
    return 0, _getAppearIdMjs.getOptimisedAppearId;
});
parcelHelpers.export(exports, "inertia", function() {
    return 0, _inertiaMjs.inertia;
});
parcelHelpers.export(exports, "defaultEasing", function() {
    return 0, _keyframesMjs.defaultEasing;
});
parcelHelpers.export(exports, "keyframes", function() {
    return 0, _keyframesMjs.keyframes;
});
parcelHelpers.export(exports, "spring", function() {
    return 0, _springMjs.spring;
});
parcelHelpers.export(exports, "calcGeneratorDuration", function() {
    return 0, _calcDurationMjs.calcGeneratorDuration;
});
parcelHelpers.export(exports, "maxGeneratorDuration", function() {
    return 0, _calcDurationMjs.maxGeneratorDuration;
});
parcelHelpers.export(exports, "createGeneratorEasing", function() {
    return 0, _createGeneratorEasingMjs.createGeneratorEasing;
});
parcelHelpers.export(exports, "isGenerator", function() {
    return 0, _isGeneratorMjs.isGenerator;
});
parcelHelpers.export(exports, "DOMKeyframesResolver", function() {
    return 0, _domkeyframesResolverMjs.DOMKeyframesResolver;
});
parcelHelpers.export(exports, "KeyframeResolver", function() {
    return 0, _keyframesResolverMjs.KeyframeResolver;
});
parcelHelpers.export(exports, "flushKeyframeResolvers", function() {
    return 0, _keyframesResolverMjs.flushKeyframeResolvers;
});
parcelHelpers.export(exports, "defaultOffset", function() {
    return 0, _defaultMjs.defaultOffset;
});
parcelHelpers.export(exports, "fillOffset", function() {
    return 0, _fillMjs.fillOffset;
});
parcelHelpers.export(exports, "convertOffsetToTimes", function() {
    return 0, _timeMjs.convertOffsetToTimes;
});
parcelHelpers.export(exports, "applyPxDefaults", function() {
    return 0, _applyPxDefaultsMjs.applyPxDefaults;
});
parcelHelpers.export(exports, "fillWildcards", function() {
    return 0, _fillWildcardsMjs.fillWildcards;
});
parcelHelpers.export(exports, "cubicBezierAsString", function() {
    return 0, _cubicBezierMjs.cubicBezierAsString;
});
parcelHelpers.export(exports, "isWaapiSupportedEasing", function() {
    return 0, _isSupportedMjs.isWaapiSupportedEasing;
});
parcelHelpers.export(exports, "mapEasingToNativeEasing", function() {
    return 0, _mapEasingMjs.mapEasingToNativeEasing;
});
parcelHelpers.export(exports, "supportedWaapiEasing", function() {
    return 0, _supportedMjs.supportedWaapiEasing;
});
parcelHelpers.export(exports, "startWaapiAnimation", function() {
    return 0, _startWaapiAnimationMjs.startWaapiAnimation;
});
parcelHelpers.export(exports, "supportsPartialKeyframes", function() {
    return 0, _partialKeyframesMjs.supportsPartialKeyframes;
});
parcelHelpers.export(exports, "supportsBrowserAnimation", function() {
    return 0, _waapiMjs.supportsBrowserAnimation;
});
parcelHelpers.export(exports, "acceleratedValues", function() {
    return 0, _acceleratedValuesMjs.acceleratedValues;
});
parcelHelpers.export(exports, "applyGeneratorOptions", function() {
    return 0, _applyGeneratorMjs.applyGeneratorOptions;
});
parcelHelpers.export(exports, "generateLinearEasing", function() {
    return 0, _linearMjs.generateLinearEasing;
});
parcelHelpers.export(exports, "addAttrValue", function() {
    return 0, _indexMjs.addAttrValue;
});
parcelHelpers.export(exports, "attrEffect", function() {
    return 0, _indexMjs.attrEffect;
});
parcelHelpers.export(exports, "propEffect", function() {
    return 0, _indexMjs1.propEffect;
});
parcelHelpers.export(exports, "addStyleValue", function() {
    return 0, _indexMjs2.addStyleValue;
});
parcelHelpers.export(exports, "styleEffect", function() {
    return 0, _indexMjs2.styleEffect;
});
parcelHelpers.export(exports, "svgEffect", function() {
    return 0, _indexMjs3.svgEffect;
});
parcelHelpers.export(exports, "createRenderBatcher", function() {
    return 0, _batcherMjs.createRenderBatcher;
});
parcelHelpers.export(exports, "cancelMicrotask", function() {
    return 0, _microtaskMjs.cancelMicrotask;
});
parcelHelpers.export(exports, "microtask", function() {
    return 0, _microtaskMjs.microtask;
});
parcelHelpers.export(exports, "time", function() {
    return 0, _syncTimeMjs.time;
});
parcelHelpers.export(exports, "isDragActive", function() {
    return 0, _isActiveMjs.isDragActive;
});
parcelHelpers.export(exports, "isDragging", function() {
    return 0, _isActiveMjs.isDragging;
});
parcelHelpers.export(exports, "setDragLock", function() {
    return 0, _setActiveMjs.setDragLock;
});
parcelHelpers.export(exports, "hover", function() {
    return 0, _hoverMjs.hover;
});
parcelHelpers.export(exports, "press", function() {
    return 0, _indexMjs4.press;
});
parcelHelpers.export(exports, "isElementKeyboardAccessible", function() {
    return 0, _isKeyboardAccessibleMjs.isElementKeyboardAccessible;
});
parcelHelpers.export(exports, "isElementTextInput", function() {
    return 0, _isKeyboardAccessibleMjs.isElementTextInput;
});
parcelHelpers.export(exports, "isNodeOrChild", function() {
    return 0, _isNodeOrChildMjs.isNodeOrChild;
});
parcelHelpers.export(exports, "isPrimaryPointer", function() {
    return 0, _isPrimaryPointerMjs.isPrimaryPointer;
});
parcelHelpers.export(exports, "defaultTransformValue", function() {
    return 0, _parseTransformMjs.defaultTransformValue;
});
parcelHelpers.export(exports, "parseValueFromTransform", function() {
    return 0, _parseTransformMjs.parseValueFromTransform;
});
parcelHelpers.export(exports, "readTransformValue", function() {
    return 0, _parseTransformMjs.readTransformValue;
});
parcelHelpers.export(exports, "getComputedStyle", function() {
    return 0, _styleComputedMjs.getComputedStyle;
});
parcelHelpers.export(exports, "setStyle", function() {
    return 0, _styleSetMjs.setStyle;
});
parcelHelpers.export(exports, "isKeyframesTarget", function() {
    return 0, _isKeyframesTargetMjs.isKeyframesTarget;
});
parcelHelpers.export(exports, "positionalKeys", function() {
    return 0, _keysPositionMjs.positionalKeys;
});
parcelHelpers.export(exports, "transformPropOrder", function() {
    return 0, _keysTransformMjs.transformPropOrder;
});
parcelHelpers.export(exports, "transformProps", function() {
    return 0, _keysTransformMjs.transformProps;
});
parcelHelpers.export(exports, "resize", function() {
    return 0, _indexMjs5.resize;
});
parcelHelpers.export(exports, "observeTimeline", function() {
    return 0, _observeMjs.observeTimeline;
});
parcelHelpers.export(exports, "recordStats", function() {
    return 0, _indexMjs6.recordStats;
});
parcelHelpers.export(exports, "activeAnimations", function() {
    return 0, _animationCountMjs.activeAnimations;
});
parcelHelpers.export(exports, "statsBuffer", function() {
    return 0, _bufferMjs.statsBuffer;
});
parcelHelpers.export(exports, "interpolate", function() {
    return 0, _interpolateMjs.interpolate;
});
parcelHelpers.export(exports, "isHTMLElement", function() {
    return 0, _isHtmlElementMjs.isHTMLElement;
});
parcelHelpers.export(exports, "isSVGElement", function() {
    return 0, _isSvgElementMjs.isSVGElement;
});
parcelHelpers.export(exports, "isSVGSVGElement", function() {
    return 0, _isSvgSvgElementMjs.isSVGSVGElement;
});
parcelHelpers.export(exports, "mix", function() {
    return 0, _indexMjs7.mix;
});
parcelHelpers.export(exports, "mixColor", function() {
    return 0, _colorMjs.mixColor;
});
parcelHelpers.export(exports, "mixLinearColor", function() {
    return 0, _colorMjs.mixLinearColor;
});
parcelHelpers.export(exports, "getMixer", function() {
    return 0, _complexMjs.getMixer;
});
parcelHelpers.export(exports, "mixArray", function() {
    return 0, _complexMjs.mixArray;
});
parcelHelpers.export(exports, "mixComplex", function() {
    return 0, _complexMjs.mixComplex;
});
parcelHelpers.export(exports, "mixObject", function() {
    return 0, _complexMjs.mixObject;
});
parcelHelpers.export(exports, "mixImmediate", function() {
    return 0, _immediateMjs.mixImmediate;
});
parcelHelpers.export(exports, "mixNumber", function() {
    return 0, _numberMjs.mixNumber;
});
parcelHelpers.export(exports, "invisibleValues", function() {
    return 0, _visibilityMjs.invisibleValues;
});
parcelHelpers.export(exports, "mixVisibility", function() {
    return 0, _visibilityMjs.mixVisibility;
});
parcelHelpers.export(exports, "resolveElements", function() {
    return 0, _resolveElementsMjs.resolveElements;
});
parcelHelpers.export(exports, "getOriginIndex", function() {
    return 0, _staggerMjs.getOriginIndex;
});
parcelHelpers.export(exports, "stagger", function() {
    return 0, _staggerMjs.stagger;
});
parcelHelpers.export(exports, "supportsFlags", function() {
    return 0, _flagsMjs.supportsFlags;
});
parcelHelpers.export(exports, "supportsLinearEasing", function() {
    return 0, _linearEasingMjs.supportsLinearEasing;
});
parcelHelpers.export(exports, "supportsScrollTimeline", function() {
    return 0, _scrollTimelineMjs.supportsScrollTimeline;
});
parcelHelpers.export(exports, "supportsViewTimeline", function() {
    return 0, _scrollTimelineMjs.supportsViewTimeline;
});
parcelHelpers.export(exports, "transform", function() {
    return 0, _transformMjs.transform;
});
parcelHelpers.export(exports, "MotionValue", function() {
    return 0, _indexMjs8.MotionValue;
});
parcelHelpers.export(exports, "collectMotionValues", function() {
    return 0, _indexMjs8.collectMotionValues;
});
parcelHelpers.export(exports, "motionValue", function() {
    return 0, _indexMjs8.motionValue;
});
parcelHelpers.export(exports, "attachFollow", function() {
    return 0, _followValueMjs.attachFollow;
});
parcelHelpers.export(exports, "followValue", function() {
    return 0, _followValueMjs.followValue;
});
parcelHelpers.export(exports, "mapValue", function() {
    return 0, _mapValueMjs.mapValue;
});
parcelHelpers.export(exports, "attachSpring", function() {
    return 0, _springValueMjs.attachSpring;
});
parcelHelpers.export(exports, "springValue", function() {
    return 0, _springValueMjs.springValue;
});
parcelHelpers.export(exports, "transformValue", function() {
    return 0, _transformValueMjs.transformValue;
});
parcelHelpers.export(exports, "color", function() {
    return 0, _indexMjs9.color;
});
parcelHelpers.export(exports, "hex", function() {
    return 0, _hexMjs.hex;
});
parcelHelpers.export(exports, "hsla", function() {
    return 0, _hslaMjs.hsla;
});
parcelHelpers.export(exports, "hslaToRgba", function() {
    return 0, _hslaToRgbaMjs.hslaToRgba;
});
parcelHelpers.export(exports, "rgbUnit", function() {
    return 0, _rgbaMjs.rgbUnit;
});
parcelHelpers.export(exports, "rgba", function() {
    return 0, _rgbaMjs.rgba;
});
parcelHelpers.export(exports, "analyseComplexValue", function() {
    return 0, _indexMjs10.analyseComplexValue;
});
parcelHelpers.export(exports, "complex", function() {
    return 0, _indexMjs10.complex;
});
parcelHelpers.export(exports, "dimensionValueTypes", function() {
    return 0, _dimensionsMjs.dimensionValueTypes;
});
parcelHelpers.export(exports, "findDimensionValueType", function() {
    return 0, _dimensionsMjs.findDimensionValueType;
});
parcelHelpers.export(exports, "defaultValueTypes", function() {
    return 0, _defaultsMjs.defaultValueTypes;
});
parcelHelpers.export(exports, "getDefaultValueType", function() {
    return 0, _defaultsMjs.getDefaultValueType;
});
parcelHelpers.export(exports, "numberValueTypes", function() {
    return 0, _numberMjs1.numberValueTypes;
});
parcelHelpers.export(exports, "transformValueTypes", function() {
    return 0, _transformMjs1.transformValueTypes;
});
parcelHelpers.export(exports, "alpha", function() {
    return 0, _indexMjs11.alpha;
});
parcelHelpers.export(exports, "number", function() {
    return 0, _indexMjs11.number;
});
parcelHelpers.export(exports, "scale", function() {
    return 0, _indexMjs11.scale;
});
parcelHelpers.export(exports, "degrees", function() {
    return 0, _unitsMjs.degrees;
});
parcelHelpers.export(exports, "percent", function() {
    return 0, _unitsMjs.percent;
});
parcelHelpers.export(exports, "progressPercentage", function() {
    return 0, _unitsMjs.progressPercentage;
});
parcelHelpers.export(exports, "px", function() {
    return 0, _unitsMjs.px;
});
parcelHelpers.export(exports, "vh", function() {
    return 0, _unitsMjs.vh;
});
parcelHelpers.export(exports, "vw", function() {
    return 0, _unitsMjs.vw;
});
parcelHelpers.export(exports, "testValueType", function() {
    return 0, _testMjs.testValueType;
});
parcelHelpers.export(exports, "getAnimatableNone", function() {
    return 0, _animatableNoneMjs.getAnimatableNone;
});
parcelHelpers.export(exports, "findValueType", function() {
    return 0, _findMjs.findValueType;
});
parcelHelpers.export(exports, "getValueAsType", function() {
    return 0, _getAsTypeMjs.getValueAsType;
});
parcelHelpers.export(exports, "isMotionValue", function() {
    return 0, _isMotionValueMjs.isMotionValue;
});
parcelHelpers.export(exports, "addValueToWillChange", function() {
    return 0, _addWillChangeMjs.addValueToWillChange;
});
parcelHelpers.export(exports, "isWillChangeMotionValue", function() {
    return 0, _isMjs.isWillChangeMotionValue;
});
parcelHelpers.export(exports, "ViewTransitionBuilder", function() {
    return 0, _indexMjs12.ViewTransitionBuilder;
});
parcelHelpers.export(exports, "animateView", function() {
    return 0, _indexMjs12.animateView;
});
parcelHelpers.export(exports, "getViewAnimationLayerInfo", function() {
    return 0, _getLayerInfoMjs.getViewAnimationLayerInfo;
});
parcelHelpers.export(exports, "getViewAnimations", function() {
    return 0, _getViewAnimationsMjs.getViewAnimations;
});
parcelHelpers.export(exports, "DOMVisualElement", function() {
    return 0, _domvisualElementMjs.DOMVisualElement;
});
parcelHelpers.export(exports, "Feature", function() {
    return 0, _featureMjs.Feature;
});
parcelHelpers.export(exports, "HTMLVisualElement", function() {
    return 0, _htmlvisualElementMjs.HTMLVisualElement;
});
parcelHelpers.export(exports, "ObjectVisualElement", function() {
    return 0, _objectVisualElementMjs.ObjectVisualElement;
});
parcelHelpers.export(exports, "visualElementStore", function() {
    return 0, _storeMjs.visualElementStore;
});
parcelHelpers.export(exports, "SVGVisualElement", function() {
    return 0, _svgvisualElementMjs.SVGVisualElement;
});
parcelHelpers.export(exports, "VisualElement", function() {
    return 0, _visualElementMjs1.VisualElement;
});
parcelHelpers.export(exports, "getFeatureDefinitions", function() {
    return 0, _visualElementMjs1.getFeatureDefinitions;
});
parcelHelpers.export(exports, "setFeatureDefinitions", function() {
    return 0, _visualElementMjs1.setFeatureDefinitions;
});
parcelHelpers.export(exports, "checkVariantsDidChange", function() {
    return 0, _animationStateMjs.checkVariantsDidChange;
});
parcelHelpers.export(exports, "createAnimationState", function() {
    return 0, _animationStateMjs.createAnimationState;
});
parcelHelpers.export(exports, "getVariantContext", function() {
    return 0, _getVariantContextMjs.getVariantContext;
});
parcelHelpers.export(exports, "isAnimationControls", function() {
    return 0, _isAnimationControlsMjs.isAnimationControls;
});
parcelHelpers.export(exports, "isControllingVariants", function() {
    return 0, _isControllingVariantsMjs.isControllingVariants;
});
parcelHelpers.export(exports, "isVariantNode", function() {
    return 0, _isControllingVariantsMjs.isVariantNode;
});
parcelHelpers.export(exports, "isForcedMotionValue", function() {
    return 0, _isForcedMotionValueMjs.isForcedMotionValue;
});
parcelHelpers.export(exports, "isVariantLabel", function() {
    return 0, _isVariantLabelMjs.isVariantLabel;
});
parcelHelpers.export(exports, "updateMotionValuesFromProps", function() {
    return 0, _motionValuesMjs.updateMotionValuesFromProps;
});
parcelHelpers.export(exports, "resolveVariant", function() {
    return 0, _resolveDynamicVariantsMjs.resolveVariant;
});
parcelHelpers.export(exports, "resolveVariantFromProps", function() {
    return 0, _resolveVariantsMjs.resolveVariantFromProps;
});
parcelHelpers.export(exports, "setTarget", function() {
    return 0, _settersMjs.setTarget;
});
parcelHelpers.export(exports, "variantPriorityOrder", function() {
    return 0, _variantPropsMjs.variantPriorityOrder;
});
parcelHelpers.export(exports, "variantProps", function() {
    return 0, _variantPropsMjs.variantProps;
});
parcelHelpers.export(exports, "initPrefersReducedMotion", function() {
    return 0, _indexMjs13.initPrefersReducedMotion;
});
parcelHelpers.export(exports, "convertBoundingBoxToBox", function() {
    return 0, _conversionMjs.convertBoundingBoxToBox;
});
parcelHelpers.export(exports, "convertBoxToBoundingBox", function() {
    return 0, _conversionMjs.convertBoxToBoundingBox;
});
parcelHelpers.export(exports, "transformBoxPoints", function() {
    return 0, _conversionMjs.transformBoxPoints;
});
parcelHelpers.export(exports, "copyAxisDeltaInto", function() {
    return 0, _copyMjs.copyAxisDeltaInto;
});
parcelHelpers.export(exports, "copyAxisInto", function() {
    return 0, _copyMjs.copyAxisInto;
});
parcelHelpers.export(exports, "copyBoxInto", function() {
    return 0, _copyMjs.copyBoxInto;
});
parcelHelpers.export(exports, "applyAxisDelta", function() {
    return 0, _deltaApplyMjs.applyAxisDelta;
});
parcelHelpers.export(exports, "applyBoxDelta", function() {
    return 0, _deltaApplyMjs.applyBoxDelta;
});
parcelHelpers.export(exports, "applyPointDelta", function() {
    return 0, _deltaApplyMjs.applyPointDelta;
});
parcelHelpers.export(exports, "applyTreeDeltas", function() {
    return 0, _deltaApplyMjs.applyTreeDeltas;
});
parcelHelpers.export(exports, "scalePoint", function() {
    return 0, _deltaApplyMjs.scalePoint;
});
parcelHelpers.export(exports, "transformAxis", function() {
    return 0, _deltaApplyMjs.transformAxis;
});
parcelHelpers.export(exports, "transformBox", function() {
    return 0, _deltaApplyMjs.transformBox;
});
parcelHelpers.export(exports, "translateAxis", function() {
    return 0, _deltaApplyMjs.translateAxis;
});
parcelHelpers.export(exports, "calcAxisDelta", function() {
    return 0, _deltaCalcMjs.calcAxisDelta;
});
parcelHelpers.export(exports, "calcBoxDelta", function() {
    return 0, _deltaCalcMjs.calcBoxDelta;
});
parcelHelpers.export(exports, "calcLength", function() {
    return 0, _deltaCalcMjs.calcLength;
});
parcelHelpers.export(exports, "calcRelativeAxis", function() {
    return 0, _deltaCalcMjs.calcRelativeAxis;
});
parcelHelpers.export(exports, "calcRelativeAxisPosition", function() {
    return 0, _deltaCalcMjs.calcRelativeAxisPosition;
});
parcelHelpers.export(exports, "calcRelativeBox", function() {
    return 0, _deltaCalcMjs.calcRelativeBox;
});
parcelHelpers.export(exports, "calcRelativePosition", function() {
    return 0, _deltaCalcMjs.calcRelativePosition;
});
parcelHelpers.export(exports, "isNear", function() {
    return 0, _deltaCalcMjs.isNear;
});
parcelHelpers.export(exports, "removeAxisDelta", function() {
    return 0, _deltaRemoveMjs.removeAxisDelta;
});
parcelHelpers.export(exports, "removeAxisTransforms", function() {
    return 0, _deltaRemoveMjs.removeAxisTransforms;
});
parcelHelpers.export(exports, "removeBoxTransforms", function() {
    return 0, _deltaRemoveMjs.removeBoxTransforms;
});
parcelHelpers.export(exports, "removePointDelta", function() {
    return 0, _deltaRemoveMjs.removePointDelta;
});
parcelHelpers.export(exports, "createAxis", function() {
    return 0, _modelsMjs.createAxis;
});
parcelHelpers.export(exports, "createAxisDelta", function() {
    return 0, _modelsMjs.createAxisDelta;
});
parcelHelpers.export(exports, "createBox", function() {
    return 0, _modelsMjs.createBox;
});
parcelHelpers.export(exports, "createDelta", function() {
    return 0, _modelsMjs.createDelta;
});
parcelHelpers.export(exports, "aspectRatio", function() {
    return 0, _utilsMjs.aspectRatio;
});
parcelHelpers.export(exports, "axisDeltaEquals", function() {
    return 0, _utilsMjs.axisDeltaEquals;
});
parcelHelpers.export(exports, "axisEquals", function() {
    return 0, _utilsMjs.axisEquals;
});
parcelHelpers.export(exports, "axisEqualsRounded", function() {
    return 0, _utilsMjs.axisEqualsRounded;
});
parcelHelpers.export(exports, "boxEquals", function() {
    return 0, _utilsMjs.boxEquals;
});
parcelHelpers.export(exports, "boxEqualsRounded", function() {
    return 0, _utilsMjs.boxEqualsRounded;
});
parcelHelpers.export(exports, "isDeltaZero", function() {
    return 0, _utilsMjs.isDeltaZero;
});
parcelHelpers.export(exports, "eachAxis", function() {
    return 0, _eachAxisMjs.eachAxis;
});
parcelHelpers.export(exports, "has2DTranslate", function() {
    return 0, _hasTransformMjs.has2DTranslate;
});
parcelHelpers.export(exports, "hasScale", function() {
    return 0, _hasTransformMjs.hasScale;
});
parcelHelpers.export(exports, "hasTransform", function() {
    return 0, _hasTransformMjs.hasTransform;
});
parcelHelpers.export(exports, "measurePageBox", function() {
    return 0, _measureMjs.measurePageBox;
});
parcelHelpers.export(exports, "measureViewportBox", function() {
    return 0, _measureMjs.measureViewportBox;
});
parcelHelpers.export(exports, "correctBorderRadius", function() {
    return 0, _scaleBorderRadiusMjs.correctBorderRadius;
});
parcelHelpers.export(exports, "pixelsToPercent", function() {
    return 0, _scaleBorderRadiusMjs.pixelsToPercent;
});
parcelHelpers.export(exports, "correctBoxShadow", function() {
    return 0, _scaleBoxShadowMjs.correctBoxShadow;
});
parcelHelpers.export(exports, "buildProjectionTransform", function() {
    return 0, _transformMjs2.buildProjectionTransform;
});
parcelHelpers.export(exports, "mixValues", function() {
    return 0, _mixValuesMjs.mixValues;
});
parcelHelpers.export(exports, "animateSingleValue", function() {
    return 0, _singleValueMjs.animateSingleValue;
});
parcelHelpers.export(exports, "addDomEvent", function() {
    return 0, _addDomEventMjs.addDomEvent;
});
parcelHelpers.export(exports, "compareByDepth", function() {
    return 0, _compareByDepthMjs.compareByDepth;
});
parcelHelpers.export(exports, "FlatTree", function() {
    return 0, _flatTreeMjs.FlatTree;
});
parcelHelpers.export(exports, "delay", function() {
    return 0, _delayMjs.delay;
});
parcelHelpers.export(exports, "delayInSeconds", function() {
    return 0, _delayMjs.delayInSeconds;
});
parcelHelpers.export(exports, "resolveMotionValue", function() {
    return 0, _resolveMotionValueMjs.resolveMotionValue;
});
parcelHelpers.export(exports, "cleanDirtyNodes", function() {
    return 0, _createProjectionNodeMjs.cleanDirtyNodes;
});
parcelHelpers.export(exports, "createProjectionNode", function() {
    return 0, _createProjectionNodeMjs.createProjectionNode;
});
parcelHelpers.export(exports, "propagateDirtyNodes", function() {
    return 0, _createProjectionNodeMjs.propagateDirtyNodes;
});
parcelHelpers.export(exports, "DocumentProjectionNode", function() {
    return 0, _documentProjectionNodeMjs.DocumentProjectionNode;
});
parcelHelpers.export(exports, "nodeGroup", function() {
    return 0, _groupMjs.nodeGroup;
});
parcelHelpers.export(exports, "HTMLProjectionNode", function() {
    return 0, _htmlprojectionNodeMjs.HTMLProjectionNode;
});
parcelHelpers.export(exports, "rootProjectionNode", function() {
    return 0, _htmlprojectionNodeMjs.rootProjectionNode;
});
parcelHelpers.export(exports, "globalProjectionState", function() {
    return 0, _stateMjs.globalProjectionState;
});
parcelHelpers.export(exports, "NodeStack", function() {
    return 0, _stackMjs.NodeStack;
});
parcelHelpers.export(exports, "camelToDash", function() {
    return 0, _camelToDashMjs.camelToDash;
});
parcelHelpers.export(exports, "buildHTMLStyles", function() {
    return 0, _buildStylesMjs.buildHTMLStyles;
});
parcelHelpers.export(exports, "buildTransform", function() {
    return 0, _buildTransformMjs.buildTransform;
});
parcelHelpers.export(exports, "renderHTML", function() {
    return 0, _renderMjs.renderHTML;
});
parcelHelpers.export(exports, "scrapeHTMLMotionValuesFromProps", function() {
    return 0, _scrapeMotionValuesMjs.scrapeMotionValuesFromProps;
});
parcelHelpers.export(exports, "buildSVGAttrs", function() {
    return 0, _buildAttrsMjs.buildSVGAttrs;
});
parcelHelpers.export(exports, "camelCaseAttributes", function() {
    return 0, _camelCaseAttrsMjs.camelCaseAttributes;
});
parcelHelpers.export(exports, "isSVGTag", function() {
    return 0, _isSvgTagMjs.isSVGTag;
});
parcelHelpers.export(exports, "buildSVGPath", function() {
    return 0, _pathMjs.buildSVGPath;
});
parcelHelpers.export(exports, "renderSVG", function() {
    return 0, _renderMjs1.renderSVG;
});
parcelHelpers.export(exports, "scrapeSVGMotionValuesFromProps", function() {
    return 0, _scrapeMotionValuesMjs1.scrapeMotionValuesFromProps;
});
parcelHelpers.export(exports, "LayoutAnimationBuilder", function() {
    return 0, _layoutAnimationBuilderMjs.LayoutAnimationBuilder;
});
parcelHelpers.export(exports, "parseAnimateLayoutArgs", function() {
    return 0, _layoutAnimationBuilderMjs.parseAnimateLayoutArgs;
});
parcelHelpers.export(exports, "cancelSync", function() {
    return 0, _indexLegacyMjs.cancelSync;
});
parcelHelpers.export(exports, "sync", function() {
    return 0, _indexLegacyMjs.sync;
});
parcelHelpers.export(exports, "addScaleCorrector", function() {
    return 0, _scaleCorrectionMjs.addScaleCorrector;
});
parcelHelpers.export(exports, "scaleCorrectors", function() {
    return 0, _scaleCorrectionMjs.scaleCorrectors;
});
parcelHelpers.export(exports, "cancelFrame", function() {
    return 0, _frameMjs.cancelFrame;
});
parcelHelpers.export(exports, "frame", function() {
    return 0, _frameMjs.frame;
});
parcelHelpers.export(exports, "frameData", function() {
    return 0, _frameMjs.frameData;
});
parcelHelpers.export(exports, "frameSteps", function() {
    return 0, _frameMjs.frameSteps;
});
parcelHelpers.export(exports, "hasReducedMotionListener", function() {
    return 0, _stateMjs1.hasReducedMotionListener;
});
parcelHelpers.export(exports, "prefersReducedMotion", function() {
    return 0, _stateMjs1.prefersReducedMotion;
});
var _asyncMotionValueAnimationMjs = require("./animation/AsyncMotionValueAnimation.mjs");
var _groupAnimationMjs = require("./animation/GroupAnimation.mjs");
var _groupAnimationWithThenMjs = require("./animation/GroupAnimationWithThen.mjs");
var _jsanimationMjs = require("./animation/JSAnimation.mjs");
var _nativeAnimationMjs = require("./animation/NativeAnimation.mjs");
var _nativeAnimationExtendedMjs = require("./animation/NativeAnimationExtended.mjs");
var _nativeAnimationWrapperMjs = require("./animation/NativeAnimationWrapper.mjs");
var _activeAnimationsMjs = require("./animation/utils/active-animations.mjs");
var _calcChildStaggerMjs = require("./animation/utils/calc-child-stagger.mjs");
var _cssVariablesConversionMjs = require("./animation/utils/css-variables-conversion.mjs");
var _defaultTransitionsMjs = require("./animation/utils/default-transitions.mjs");
var _getFinalMjs = require("./animation/keyframes/get-final.mjs");
var _getValueTransitionMjs = require("./animation/utils/get-value-transition.mjs");
var _resolveTransitionMjs = require("./animation/utils/resolve-transition.mjs");
var _isCssVariableMjs = require("./animation/utils/is-css-variable.mjs");
var _isTransitionDefinedMjs = require("./animation/utils/is-transition-defined.mjs");
var _makeAnimationInstantMjs = require("./animation/utils/make-animation-instant.mjs");
var _motionValueMjs = require("./animation/interfaces/motion-value.mjs");
var _visualElementMjs = require("./animation/interfaces/visual-element.mjs");
var _visualElementTargetMjs = require("./animation/interfaces/visual-element-target.mjs");
var _visualElementVariantMjs = require("./animation/interfaces/visual-element-variant.mjs");
var _dataIdMjs = require("./animation/optimized-appear/data-id.mjs");
var _getAppearIdMjs = require("./animation/optimized-appear/get-appear-id.mjs");
var _inertiaMjs = require("./animation/generators/inertia.mjs");
var _keyframesMjs = require("./animation/generators/keyframes.mjs");
var _springMjs = require("./animation/generators/spring.mjs");
var _calcDurationMjs = require("./animation/generators/utils/calc-duration.mjs");
var _createGeneratorEasingMjs = require("./animation/generators/utils/create-generator-easing.mjs");
var _isGeneratorMjs = require("./animation/generators/utils/is-generator.mjs");
var _domkeyframesResolverMjs = require("./animation/keyframes/DOMKeyframesResolver.mjs");
var _keyframesResolverMjs = require("./animation/keyframes/KeyframesResolver.mjs");
var _defaultMjs = require("./animation/keyframes/offsets/default.mjs");
var _fillMjs = require("./animation/keyframes/offsets/fill.mjs");
var _timeMjs = require("./animation/keyframes/offsets/time.mjs");
var _applyPxDefaultsMjs = require("./animation/keyframes/utils/apply-px-defaults.mjs");
var _fillWildcardsMjs = require("./animation/keyframes/utils/fill-wildcards.mjs");
var _cubicBezierMjs = require("./animation/waapi/easing/cubic-bezier.mjs");
var _isSupportedMjs = require("./animation/waapi/easing/is-supported.mjs");
var _mapEasingMjs = require("./animation/waapi/easing/map-easing.mjs");
var _supportedMjs = require("./animation/waapi/easing/supported.mjs");
var _startWaapiAnimationMjs = require("./animation/waapi/start-waapi-animation.mjs");
var _partialKeyframesMjs = require("./animation/waapi/supports/partial-keyframes.mjs");
var _waapiMjs = require("./animation/waapi/supports/waapi.mjs");
var _acceleratedValuesMjs = require("./animation/waapi/utils/accelerated-values.mjs");
var _applyGeneratorMjs = require("./animation/waapi/utils/apply-generator.mjs");
var _linearMjs = require("./animation/waapi/utils/linear.mjs");
var _indexMjs = require("./effects/attr/index.mjs");
var _indexMjs1 = require("./effects/prop/index.mjs");
var _indexMjs2 = require("./effects/style/index.mjs");
var _indexMjs3 = require("./effects/svg/index.mjs");
var _batcherMjs = require("./frameloop/batcher.mjs");
var _microtaskMjs = require("./frameloop/microtask.mjs");
var _syncTimeMjs = require("./frameloop/sync-time.mjs");
var _isActiveMjs = require("./gestures/drag/state/is-active.mjs");
var _setActiveMjs = require("./gestures/drag/state/set-active.mjs");
var _hoverMjs = require("./gestures/hover.mjs");
var _indexMjs4 = require("./gestures/press/index.mjs");
var _isKeyboardAccessibleMjs = require("./gestures/press/utils/is-keyboard-accessible.mjs");
var _isNodeOrChildMjs = require("./gestures/utils/is-node-or-child.mjs");
var _isPrimaryPointerMjs = require("./gestures/utils/is-primary-pointer.mjs");
var _parseTransformMjs = require("./render/dom/parse-transform.mjs");
var _styleComputedMjs = require("./render/dom/style-computed.mjs");
var _styleSetMjs = require("./render/dom/style-set.mjs");
var _isKeyframesTargetMjs = require("./render/utils/is-keyframes-target.mjs");
var _keysPositionMjs = require("./render/utils/keys-position.mjs");
var _keysTransformMjs = require("./render/utils/keys-transform.mjs");
var _indexMjs5 = require("./resize/index.mjs");
var _observeMjs = require("./scroll/observe.mjs");
var _indexMjs6 = require("./stats/index.mjs");
var _animationCountMjs = require("./stats/animation-count.mjs");
var _bufferMjs = require("./stats/buffer.mjs");
var _interpolateMjs = require("./utils/interpolate.mjs");
var _isHtmlElementMjs = require("./utils/is-html-element.mjs");
var _isSvgElementMjs = require("./utils/is-svg-element.mjs");
var _isSvgSvgElementMjs = require("./utils/is-svg-svg-element.mjs");
var _indexMjs7 = require("./utils/mix/index.mjs");
var _colorMjs = require("./utils/mix/color.mjs");
var _complexMjs = require("./utils/mix/complex.mjs");
var _immediateMjs = require("./utils/mix/immediate.mjs");
var _numberMjs = require("./utils/mix/number.mjs");
var _visibilityMjs = require("./utils/mix/visibility.mjs");
var _resolveElementsMjs = require("./utils/resolve-elements.mjs");
var _staggerMjs = require("./utils/stagger.mjs");
var _flagsMjs = require("./utils/supports/flags.mjs");
var _linearEasingMjs = require("./utils/supports/linear-easing.mjs");
var _scrollTimelineMjs = require("./utils/supports/scroll-timeline.mjs");
var _transformMjs = require("./utils/transform.mjs");
var _indexMjs8 = require("./value/index.mjs");
var _followValueMjs = require("./value/follow-value.mjs");
var _mapValueMjs = require("./value/map-value.mjs");
var _springValueMjs = require("./value/spring-value.mjs");
var _transformValueMjs = require("./value/transform-value.mjs");
var _indexMjs9 = require("./value/types/color/index.mjs");
var _hexMjs = require("./value/types/color/hex.mjs");
var _hslaMjs = require("./value/types/color/hsla.mjs");
var _hslaToRgbaMjs = require("./value/types/color/hsla-to-rgba.mjs");
var _rgbaMjs = require("./value/types/color/rgba.mjs");
var _indexMjs10 = require("./value/types/complex/index.mjs");
var _dimensionsMjs = require("./value/types/dimensions.mjs");
var _defaultsMjs = require("./value/types/maps/defaults.mjs");
var _numberMjs1 = require("./value/types/maps/number.mjs");
var _transformMjs1 = require("./value/types/maps/transform.mjs");
var _indexMjs11 = require("./value/types/numbers/index.mjs");
var _unitsMjs = require("./value/types/numbers/units.mjs");
var _testMjs = require("./value/types/test.mjs");
var _animatableNoneMjs = require("./value/types/utils/animatable-none.mjs");
var _findMjs = require("./value/types/utils/find.mjs");
var _getAsTypeMjs = require("./value/types/utils/get-as-type.mjs");
var _isMotionValueMjs = require("./value/utils/is-motion-value.mjs");
var _addWillChangeMjs = require("./value/will-change/add-will-change.mjs");
var _isMjs = require("./value/will-change/is.mjs");
var _indexMjs12 = require("./view/index.mjs");
var _getLayerInfoMjs = require("./view/utils/get-layer-info.mjs");
var _getViewAnimationsMjs = require("./view/utils/get-view-animations.mjs");
var _domvisualElementMjs = require("./render/dom/DOMVisualElement.mjs");
var _featureMjs = require("./render/Feature.mjs");
var _htmlvisualElementMjs = require("./render/html/HTMLVisualElement.mjs");
var _objectVisualElementMjs = require("./render/object/ObjectVisualElement.mjs");
var _storeMjs = require("./render/store.mjs");
var _svgvisualElementMjs = require("./render/svg/SVGVisualElement.mjs");
var _visualElementMjs1 = require("./render/VisualElement.mjs");
var _animationStateMjs = require("./render/utils/animation-state.mjs");
var _getVariantContextMjs = require("./render/utils/get-variant-context.mjs");
var _isAnimationControlsMjs = require("./render/utils/is-animation-controls.mjs");
var _isControllingVariantsMjs = require("./render/utils/is-controlling-variants.mjs");
var _isForcedMotionValueMjs = require("./render/utils/is-forced-motion-value.mjs");
var _isVariantLabelMjs = require("./render/utils/is-variant-label.mjs");
var _motionValuesMjs = require("./render/utils/motion-values.mjs");
var _resolveDynamicVariantsMjs = require("./render/utils/resolve-dynamic-variants.mjs");
var _resolveVariantsMjs = require("./render/utils/resolve-variants.mjs");
var _settersMjs = require("./render/utils/setters.mjs");
var _variantPropsMjs = require("./render/utils/variant-props.mjs");
var _indexMjs13 = require("./render/utils/reduced-motion/index.mjs");
var _conversionMjs = require("./projection/geometry/conversion.mjs");
var _copyMjs = require("./projection/geometry/copy.mjs");
var _deltaApplyMjs = require("./projection/geometry/delta-apply.mjs");
var _deltaCalcMjs = require("./projection/geometry/delta-calc.mjs");
var _deltaRemoveMjs = require("./projection/geometry/delta-remove.mjs");
var _modelsMjs = require("./projection/geometry/models.mjs");
var _utilsMjs = require("./projection/geometry/utils.mjs");
var _eachAxisMjs = require("./projection/utils/each-axis.mjs");
var _hasTransformMjs = require("./projection/utils/has-transform.mjs");
var _measureMjs = require("./projection/utils/measure.mjs");
var _scaleBorderRadiusMjs = require("./projection/styles/scale-border-radius.mjs");
var _scaleBoxShadowMjs = require("./projection/styles/scale-box-shadow.mjs");
var _transformMjs2 = require("./projection/styles/transform.mjs");
var _mixValuesMjs = require("./projection/animation/mix-values.mjs");
var _singleValueMjs = require("./animation/animate/single-value.mjs");
var _addDomEventMjs = require("./events/add-dom-event.mjs");
var _compareByDepthMjs = require("./projection/utils/compare-by-depth.mjs");
var _flatTreeMjs = require("./projection/utils/flat-tree.mjs");
var _delayMjs = require("./utils/delay.mjs");
var _resolveMotionValueMjs = require("./value/utils/resolve-motion-value.mjs");
var _createProjectionNodeMjs = require("./projection/node/create-projection-node.mjs");
var _documentProjectionNodeMjs = require("./projection/node/DocumentProjectionNode.mjs");
var _groupMjs = require("./projection/node/group.mjs");
var _htmlprojectionNodeMjs = require("./projection/node/HTMLProjectionNode.mjs");
var _stateMjs = require("./projection/node/state.mjs");
var _stackMjs = require("./projection/shared/stack.mjs");
var _camelToDashMjs = require("./render/dom/utils/camel-to-dash.mjs");
var _buildStylesMjs = require("./render/html/utils/build-styles.mjs");
var _buildTransformMjs = require("./render/html/utils/build-transform.mjs");
var _renderMjs = require("./render/html/utils/render.mjs");
var _scrapeMotionValuesMjs = require("./render/html/utils/scrape-motion-values.mjs");
var _buildAttrsMjs = require("./render/svg/utils/build-attrs.mjs");
var _camelCaseAttrsMjs = require("./render/svg/utils/camel-case-attrs.mjs");
var _isSvgTagMjs = require("./render/svg/utils/is-svg-tag.mjs");
var _pathMjs = require("./render/svg/utils/path.mjs");
var _renderMjs1 = require("./render/svg/utils/render.mjs");
var _scrapeMotionValuesMjs1 = require("./render/svg/utils/scrape-motion-values.mjs");
var _layoutAnimationBuilderMjs = require("./layout/LayoutAnimationBuilder.mjs");
var _indexLegacyMjs = require("./frameloop/index-legacy.mjs");
var _scaleCorrectionMjs = require("./projection/styles/scale-correction.mjs");
var _frameMjs = require("./frameloop/frame.mjs");
var _stateMjs1 = require("./render/utils/reduced-motion/state.mjs");

},{"./animation/AsyncMotionValueAnimation.mjs":"k2WgK","./animation/GroupAnimation.mjs":"cpgZo","./animation/GroupAnimationWithThen.mjs":"69Lba","./animation/JSAnimation.mjs":"9nspW","./animation/NativeAnimation.mjs":"30yuo","./animation/NativeAnimationExtended.mjs":"bgeoN","./animation/NativeAnimationWrapper.mjs":"ambch","./animation/utils/active-animations.mjs":"g8sFG","./animation/utils/calc-child-stagger.mjs":"h5ciR","./animation/utils/css-variables-conversion.mjs":"9gQEb","./animation/utils/default-transitions.mjs":"gYLkc","./animation/keyframes/get-final.mjs":"hAUAJ","./animation/utils/get-value-transition.mjs":"dkYvz","./animation/utils/resolve-transition.mjs":"ndZ8f","./animation/utils/is-css-variable.mjs":"5nV2N","./animation/utils/is-transition-defined.mjs":"2LEKK","./animation/utils/make-animation-instant.mjs":"7YJWD","./animation/interfaces/motion-value.mjs":"dwpM4","./animation/interfaces/visual-element.mjs":"dkWvU","./animation/interfaces/visual-element-target.mjs":"40l2J","./animation/interfaces/visual-element-variant.mjs":"9Xbau","./animation/optimized-appear/data-id.mjs":"kv3NC","./animation/optimized-appear/get-appear-id.mjs":"1uuWd","./animation/generators/inertia.mjs":"fSjpI","./animation/generators/keyframes.mjs":"heVZz","./animation/generators/spring.mjs":"dB8Sj","./animation/generators/utils/calc-duration.mjs":"hyydG","./animation/generators/utils/create-generator-easing.mjs":"g9gdi","./animation/generators/utils/is-generator.mjs":"i5tAy","./animation/keyframes/DOMKeyframesResolver.mjs":"blRNU","./animation/keyframes/KeyframesResolver.mjs":"aeJtq","./animation/keyframes/offsets/default.mjs":"aLlnz","./animation/keyframes/offsets/fill.mjs":"7PYPn","./animation/keyframes/offsets/time.mjs":"j3GiE","./animation/keyframes/utils/apply-px-defaults.mjs":"6UTXu","./animation/keyframes/utils/fill-wildcards.mjs":"9HhRp","./animation/waapi/easing/cubic-bezier.mjs":"6QXfh","./animation/waapi/easing/is-supported.mjs":"dW3WR","./animation/waapi/easing/map-easing.mjs":"gPAe1","./animation/waapi/easing/supported.mjs":"biXOG","./animation/waapi/start-waapi-animation.mjs":"2IlJu","./animation/waapi/supports/partial-keyframes.mjs":"SUwK3","./animation/waapi/supports/waapi.mjs":"98x8M","./animation/waapi/utils/accelerated-values.mjs":"kN2wj","./animation/waapi/utils/apply-generator.mjs":"k35Bi","./animation/waapi/utils/linear.mjs":"6RXsU","./effects/attr/index.mjs":"l5RVE","./effects/prop/index.mjs":"koyRe","./effects/style/index.mjs":"3eqaP","./effects/svg/index.mjs":"4zw5D","./frameloop/batcher.mjs":"dVA5A","./frameloop/microtask.mjs":"icPpP","./frameloop/sync-time.mjs":"aPTZo","./gestures/drag/state/is-active.mjs":"eNLFf","./gestures/drag/state/set-active.mjs":"gVAtS","./gestures/hover.mjs":"6nSd0","./gestures/press/index.mjs":"eMPTL","./gestures/press/utils/is-keyboard-accessible.mjs":"8b5no","./gestures/utils/is-node-or-child.mjs":"5ZdeE","./gestures/utils/is-primary-pointer.mjs":"CTZIR","./render/dom/parse-transform.mjs":"4ieLZ","./render/dom/style-computed.mjs":"gDOz3","./render/dom/style-set.mjs":"6z2KW","./render/utils/is-keyframes-target.mjs":"lh5lz","./render/utils/keys-position.mjs":"7MP49","./render/utils/keys-transform.mjs":"91lmj","./resize/index.mjs":"dLN7G","./scroll/observe.mjs":"ejcM8","./stats/index.mjs":"9elgm","./stats/animation-count.mjs":"gY9Wc","./stats/buffer.mjs":"bcR1L","./utils/interpolate.mjs":"c1Uzm","./utils/is-html-element.mjs":"1mjTC","./utils/is-svg-element.mjs":"3tMgU","./utils/is-svg-svg-element.mjs":"o8RpJ","./utils/mix/index.mjs":"gnOe8","./utils/mix/color.mjs":"9UUUz","./utils/mix/complex.mjs":"gqozO","./utils/mix/immediate.mjs":"3HHoi","./utils/mix/number.mjs":"j0eyN","./utils/mix/visibility.mjs":"kGlHI","./utils/resolve-elements.mjs":"4pe2G","./utils/stagger.mjs":"bnye7","./utils/supports/flags.mjs":"esOs5","./utils/supports/linear-easing.mjs":"ewVKW","./utils/supports/scroll-timeline.mjs":"66T4L","./utils/transform.mjs":"2QzHU","./value/index.mjs":"lOANY","./value/follow-value.mjs":"h0xh3","./value/map-value.mjs":"exG8F","./value/spring-value.mjs":"6sD7C","./value/transform-value.mjs":"5PKnG","./value/types/color/index.mjs":"gbu7c","./value/types/color/hex.mjs":"fmT9b","./value/types/color/hsla.mjs":"8tWc0","./value/types/color/hsla-to-rgba.mjs":"8H6LK","./value/types/color/rgba.mjs":"5eamO","./value/types/complex/index.mjs":"6JMtB","./value/types/dimensions.mjs":"lgLwV","./value/types/maps/defaults.mjs":"1QOLD","./value/types/maps/number.mjs":"fcZR9","./value/types/maps/transform.mjs":"fZEWC","./value/types/numbers/index.mjs":"l5BDX","./value/types/numbers/units.mjs":"iC5kO","./value/types/test.mjs":"33ooj","./value/types/utils/animatable-none.mjs":"2aLeu","./value/types/utils/find.mjs":"hvs3x","./value/types/utils/get-as-type.mjs":"cE0Ua","./value/utils/is-motion-value.mjs":"cYNey","./value/will-change/add-will-change.mjs":"kDErF","./value/will-change/is.mjs":"23kcl","./view/index.mjs":"9MsoD","./view/utils/get-layer-info.mjs":"hSSN2","./view/utils/get-view-animations.mjs":"5hmln","./render/dom/DOMVisualElement.mjs":"isUIr","./render/Feature.mjs":"V3nrd","./render/html/HTMLVisualElement.mjs":"g5ilZ","./render/object/ObjectVisualElement.mjs":"e9ZBr","./render/store.mjs":"aYOSW","./render/svg/SVGVisualElement.mjs":"gDoaF","./render/VisualElement.mjs":"1ZK29","./render/utils/animation-state.mjs":"9qv2D","./render/utils/get-variant-context.mjs":"hahtH","./render/utils/is-animation-controls.mjs":"4N6Mr","./render/utils/is-controlling-variants.mjs":"qsgzo","./render/utils/is-forced-motion-value.mjs":"6zPnO","./render/utils/is-variant-label.mjs":"aChc4","./render/utils/motion-values.mjs":"350Yl","./render/utils/resolve-dynamic-variants.mjs":"5FiD7","./render/utils/resolve-variants.mjs":"gzt8h","./render/utils/setters.mjs":"lAlTD","./render/utils/variant-props.mjs":"2ZATM","./render/utils/reduced-motion/index.mjs":"hu0S7","./projection/geometry/conversion.mjs":"4hVaF","./projection/geometry/copy.mjs":"c2JNt","./projection/geometry/delta-apply.mjs":"ltFfy","./projection/geometry/delta-calc.mjs":"gXjVB","./projection/geometry/delta-remove.mjs":"j7Gx5","./projection/geometry/models.mjs":"i3okE","./projection/geometry/utils.mjs":"aQEwH","./projection/utils/each-axis.mjs":"lkSyh","./projection/utils/has-transform.mjs":"bAGvf","./projection/utils/measure.mjs":"c1XTz","./projection/styles/scale-border-radius.mjs":"7pIVE","./projection/styles/scale-box-shadow.mjs":"fJ1qX","./projection/styles/transform.mjs":"4GQSO","./projection/animation/mix-values.mjs":"jHs2u","./animation/animate/single-value.mjs":"cbr0l","./events/add-dom-event.mjs":"iFSgF","./projection/utils/compare-by-depth.mjs":"lThrv","./projection/utils/flat-tree.mjs":"isDUr","./utils/delay.mjs":"5W0bS","./value/utils/resolve-motion-value.mjs":"bDNc5","./projection/node/create-projection-node.mjs":"6Rhzb","./projection/node/DocumentProjectionNode.mjs":"7sk16","./projection/node/group.mjs":"3KEqV","./projection/node/HTMLProjectionNode.mjs":"6kyDQ","./projection/node/state.mjs":"2xFYt","./projection/shared/stack.mjs":"ioujo","./render/dom/utils/camel-to-dash.mjs":"2DA9K","./render/html/utils/build-styles.mjs":"gch0a","./render/html/utils/build-transform.mjs":"hcEfp","./render/html/utils/render.mjs":"cSqL4","./render/html/utils/scrape-motion-values.mjs":"7lZGa","./render/svg/utils/build-attrs.mjs":"jDjzT","./render/svg/utils/camel-case-attrs.mjs":"dOfIy","./render/svg/utils/is-svg-tag.mjs":"5H8Ff","./render/svg/utils/path.mjs":"43lki","./render/svg/utils/render.mjs":"7t54Q","./render/svg/utils/scrape-motion-values.mjs":"58bJ3","./layout/LayoutAnimationBuilder.mjs":"eSDFV","./frameloop/index-legacy.mjs":"1Nnob","./projection/styles/scale-correction.mjs":"cExFS","./frameloop/frame.mjs":"lxQZr","./render/utils/reduced-motion/state.mjs":"7Tal4","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"k2WgK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsyncMotionValueAnimation", function() {
    return AsyncMotionValueAnimation;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _motionUtils = require("motion-utils");
var _syncTimeMjs = require("../frameloop/sync-time.mjs");
var _jsanimationMjs = require("./JSAnimation.mjs");
var _getFinalMjs = require("./keyframes/get-final.mjs");
var _keyframesResolverMjs = require("./keyframes/KeyframesResolver.mjs");
var _nativeAnimationExtendedMjs = require("./NativeAnimationExtended.mjs");
var _canAnimateMjs = require("./utils/can-animate.mjs");
var _makeAnimationInstantMjs = require("./utils/make-animation-instant.mjs");
var _withPromiseMjs = require("./utils/WithPromise.mjs");
var _waapiMjs = require("./waapi/supports/waapi.mjs");
/**
 * Maximum time allowed between an animation being created and it being
 * resolved for us to use the latter as the start time.
 *
 * This is to ensure that while we prefer to "start" an animation as soon
 * as it's triggered, we also want to avoid a visual jump if there's a big delay
 * between these two moments.
 */ var MAX_RESOLVE_DELAY = 40;
var AsyncMotionValueAnimation = /*#__PURE__*/ function(WithPromise) {
    "use strict";
    (0, _inherits._)(AsyncMotionValueAnimation, WithPromise);
    function AsyncMotionValueAnimation(_param) {
        (0, _classCallCheck._)(this, AsyncMotionValueAnimation);
        var _this;
        var _param_autoplay = _param.autoplay, autoplay = _param_autoplay === void 0 ? true : _param_autoplay, _param_delay = _param.delay, delay = _param_delay === void 0 ? 0 : _param_delay, _param_type = _param.type, type = _param_type === void 0 ? "keyframes" : _param_type, _param_repeat = _param.repeat, repeat = _param_repeat === void 0 ? 0 : _param_repeat, _param_repeatDelay = _param.repeatDelay, repeatDelay = _param_repeatDelay === void 0 ? 0 : _param_repeatDelay, _param_repeatType = _param.repeatType, repeatType = _param_repeatType === void 0 ? "loop" : _param_repeatType, keyframes = _param.keyframes, name = _param.name, motionValue = _param.motionValue, element = _param.element, options = (0, _objectWithoutProperties._)(_param, [
            "autoplay",
            "delay",
            "type",
            "repeat",
            "repeatDelay",
            "repeatType",
            "keyframes",
            "name",
            "motionValue",
            "element"
        ]);
        var _this_keyframeResolver;
        _this = (0, _callSuper._)(this, AsyncMotionValueAnimation);
        /**
         * Bound to support return animation.stop pattern
         */ _this.stop = function() {
            var _this_keyframeResolver;
            if (_this._animation) {
                var _this_stopTimeline, _this1;
                _this._animation.stop();
                (_this_stopTimeline = (_this1 = _this).stopTimeline) === null || _this_stopTimeline === void 0 ? void 0 : _this_stopTimeline.call(_this1);
            }
            (_this_keyframeResolver = _this.keyframeResolver) === null || _this_keyframeResolver === void 0 ? void 0 : _this_keyframeResolver.cancel();
        };
        _this.createdAt = (0, _syncTimeMjs.time).now();
        var optionsWithDefaults = (0, _objectSpread._)({
            autoplay: autoplay,
            delay: delay,
            type: type,
            repeat: repeat,
            repeatDelay: repeatDelay,
            repeatType: repeatType,
            name: name,
            motionValue: motionValue,
            element: element
        }, options);
        var KeyframeResolver$1 = (element === null || element === void 0 ? void 0 : element.KeyframeResolver) || (0, _keyframesResolverMjs.KeyframeResolver);
        _this.keyframeResolver = new KeyframeResolver$1(keyframes, function(resolvedKeyframes, finalKeyframe, forced) {
            return _this.onKeyframesResolved(resolvedKeyframes, finalKeyframe, optionsWithDefaults, !forced);
        }, name, motionValue, element);
        (_this_keyframeResolver = _this.keyframeResolver) === null || _this_keyframeResolver === void 0 ? void 0 : _this_keyframeResolver.scheduleResolve();
        return _this;
    }
    (0, _createClass._)(AsyncMotionValueAnimation, [
        {
            key: "onKeyframesResolved",
            value: function onKeyframesResolved(keyframes, finalKeyframe, options, sync) {
                var _this = this;
                var _resolvedOptions_motionValue_owner, _resolvedOptions_motionValue;
                this.keyframeResolver = undefined;
                var name = options.name, type = options.type, velocity = options.velocity, delay = options.delay, isHandoff = options.isHandoff, onUpdate = options.onUpdate;
                this.resolvedAt = (0, _syncTimeMjs.time).now();
                /**
         * If we can't animate this value with the resolved keyframes
         * then we should complete it immediately.
         */ var canAnimateValue = true;
                if (!(0, _canAnimateMjs.canAnimate)(keyframes, name, type, velocity)) {
                    canAnimateValue = false;
                    if ((0, _motionUtils.MotionGlobalConfig).instantAnimations || !delay) onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate((0, _getFinalMjs.getFinalKeyframe)(keyframes, options, finalKeyframe));
                    keyframes[0] = keyframes[keyframes.length - 1];
                    (0, _makeAnimationInstantMjs.makeAnimationInstant)(options);
                    options.repeat = 0;
                }
                /**
         * Resolve startTime for the animation.
         *
         * This method uses the createdAt and resolvedAt to calculate the
         * animation startTime. *Ideally*, we would use the createdAt time as t=0
         * as the following frame would then be the first frame of the animation in
         * progress, which would feel snappier.
         *
         * However, if there's a delay (main thread work) between the creation of
         * the animation and the first committed frame, we prefer to use resolvedAt
         * to avoid a sudden jump into the animation.
         */ var startTime = sync ? !this.resolvedAt ? this.createdAt : this.resolvedAt - this.createdAt > MAX_RESOLVE_DELAY ? this.resolvedAt : this.createdAt : undefined;
                var resolvedOptions = (0, _objectSpreadProps._)((0, _objectSpread._)({
                    startTime: startTime,
                    finalKeyframe: finalKeyframe
                }, options), {
                    keyframes: keyframes
                });
                /**
         * Animate via WAAPI if possible. If this is a handoff animation, the optimised animation will be running via
         * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
         * optimised animation.
         *
         * Also skip WAAPI when keyframes aren't animatable, as the resolved
         * values may not be valid CSS and would trigger browser warnings.
         */ var useWaapi = canAnimateValue && !isHandoff && (0, _waapiMjs.supportsBrowserAnimation)(resolvedOptions);
                var element = (_resolvedOptions_motionValue = resolvedOptions.motionValue) === null || _resolvedOptions_motionValue === void 0 ? void 0 : (_resolvedOptions_motionValue_owner = _resolvedOptions_motionValue.owner) === null || _resolvedOptions_motionValue_owner === void 0 ? void 0 : _resolvedOptions_motionValue_owner.current;
                var animation;
                if (useWaapi) try {
                    animation = new (0, _nativeAnimationExtendedMjs.NativeAnimationExtended)((0, _objectSpreadProps._)((0, _objectSpread._)({}, resolvedOptions), {
                        element: element
                    }));
                } catch (e) {
                    animation = new (0, _jsanimationMjs.JSAnimation)(resolvedOptions);
                }
                else animation = new (0, _jsanimationMjs.JSAnimation)(resolvedOptions);
                animation.finished.then(function() {
                    _this.notifyFinished();
                }).catch((0, _motionUtils.noop));
                if (this.pendingTimeline) {
                    this.stopTimeline = animation.attachTimeline(this.pendingTimeline);
                    this.pendingTimeline = undefined;
                }
                this._animation = animation;
            }
        },
        {
            key: "finished",
            get: function get() {
                if (!this._animation) return this._finished;
                else return this.animation.finished;
            }
        },
        {
            key: "then",
            value: function then(onResolve, _onReject) {
                return this.finished.finally(onResolve).then(function() {});
            }
        },
        {
            key: "animation",
            get: function get() {
                if (!this._animation) {
                    var _this_keyframeResolver;
                    (_this_keyframeResolver = this.keyframeResolver) === null || _this_keyframeResolver === void 0 ? void 0 : _this_keyframeResolver.resume();
                    (0, _keyframesResolverMjs.flushKeyframeResolvers)();
                }
                return this._animation;
            }
        },
        {
            key: "duration",
            get: function get() {
                return this.animation.duration;
            }
        },
        {
            key: "iterationDuration",
            get: function get() {
                return this.animation.iterationDuration;
            }
        },
        {
            key: "time",
            get: function get() {
                return this.animation.time;
            },
            set: function set(newTime) {
                this.animation.time = newTime;
            }
        },
        {
            key: "speed",
            get: function get() {
                return this.animation.speed;
            },
            set: function set(newSpeed) {
                this.animation.speed = newSpeed;
            }
        },
        {
            key: "state",
            get: function get() {
                return this.animation.state;
            }
        },
        {
            key: "startTime",
            get: function get() {
                return this.animation.startTime;
            }
        },
        {
            key: "attachTimeline",
            value: function attachTimeline(timeline) {
                var _this = this;
                if (this._animation) this.stopTimeline = this.animation.attachTimeline(timeline);
                else this.pendingTimeline = timeline;
                return function() {
                    return _this.stop();
                };
            }
        },
        {
            key: "play",
            value: function play() {
                this.animation.play();
            }
        },
        {
            key: "pause",
            value: function pause() {
                this.animation.pause();
            }
        },
        {
            key: "complete",
            value: function complete() {
                this.animation.complete();
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                var _this_keyframeResolver;
                if (this._animation) this.animation.cancel();
                (_this_keyframeResolver = this.keyframeResolver) === null || _this_keyframeResolver === void 0 ? void 0 : _this_keyframeResolver.cancel();
            }
        }
    ]);
    return AsyncMotionValueAnimation;
}((0, _withPromiseMjs.WithPromise));

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_inherits":"2sfqW","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","motion-utils":"9Q5qC","../frameloop/sync-time.mjs":"aPTZo","./JSAnimation.mjs":"9nspW","./keyframes/get-final.mjs":"hAUAJ","./keyframes/KeyframesResolver.mjs":"aeJtq","./NativeAnimationExtended.mjs":"bgeoN","./utils/can-animate.mjs":"klLI8","./utils/make-animation-instant.mjs":"7YJWD","./utils/WithPromise.mjs":"jEvnC","./waapi/supports/waapi.mjs":"98x8M","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9Q5qC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addUniqueItem", function() {
    return 0, _arrayMjs.addUniqueItem;
});
parcelHelpers.export(exports, "moveItem", function() {
    return 0, _arrayMjs.moveItem;
});
parcelHelpers.export(exports, "removeItem", function() {
    return 0, _arrayMjs.removeItem;
});
parcelHelpers.export(exports, "clamp", function() {
    return 0, _clampMjs.clamp;
});
parcelHelpers.export(exports, "invariant", function() {
    return 0, _errorsMjs.invariant;
});
parcelHelpers.export(exports, "warning", function() {
    return 0, _errorsMjs.warning;
});
parcelHelpers.export(exports, "MotionGlobalConfig", function() {
    return 0, _globalConfigMjs.MotionGlobalConfig;
});
parcelHelpers.export(exports, "isNumericalString", function() {
    return 0, _isNumericalStringMjs.isNumericalString;
});
parcelHelpers.export(exports, "isObject", function() {
    return 0, _isObjectMjs.isObject;
});
parcelHelpers.export(exports, "isZeroValueString", function() {
    return 0, _isZeroValueStringMjs.isZeroValueString;
});
parcelHelpers.export(exports, "memo", function() {
    return 0, _memoMjs.memo;
});
parcelHelpers.export(exports, "noop", function() {
    return 0, _noopMjs.noop;
});
parcelHelpers.export(exports, "pipe", function() {
    return 0, _pipeMjs.pipe;
});
parcelHelpers.export(exports, "progress", function() {
    return 0, _progressMjs.progress;
});
parcelHelpers.export(exports, "SubscriptionManager", function() {
    return 0, _subscriptionManagerMjs.SubscriptionManager;
});
parcelHelpers.export(exports, "millisecondsToSeconds", function() {
    return 0, _timeConversionMjs.millisecondsToSeconds;
});
parcelHelpers.export(exports, "secondsToMilliseconds", function() {
    return 0, _timeConversionMjs.secondsToMilliseconds;
});
parcelHelpers.export(exports, "velocityPerSecond", function() {
    return 0, _velocityPerSecondMjs.velocityPerSecond;
});
parcelHelpers.export(exports, "hasWarned", function() {
    return 0, _warnOnceMjs.hasWarned;
});
parcelHelpers.export(exports, "warnOnce", function() {
    return 0, _warnOnceMjs.warnOnce;
});
parcelHelpers.export(exports, "wrap", function() {
    return 0, _wrapMjs.wrap;
});
parcelHelpers.export(exports, "anticipate", function() {
    return 0, _anticipateMjs.anticipate;
});
parcelHelpers.export(exports, "backIn", function() {
    return 0, _backMjs.backIn;
});
parcelHelpers.export(exports, "backInOut", function() {
    return 0, _backMjs.backInOut;
});
parcelHelpers.export(exports, "backOut", function() {
    return 0, _backMjs.backOut;
});
parcelHelpers.export(exports, "circIn", function() {
    return 0, _circMjs.circIn;
});
parcelHelpers.export(exports, "circInOut", function() {
    return 0, _circMjs.circInOut;
});
parcelHelpers.export(exports, "circOut", function() {
    return 0, _circMjs.circOut;
});
parcelHelpers.export(exports, "cubicBezier", function() {
    return 0, _cubicBezierMjs.cubicBezier;
});
parcelHelpers.export(exports, "easeIn", function() {
    return 0, _easeMjs.easeIn;
});
parcelHelpers.export(exports, "easeInOut", function() {
    return 0, _easeMjs.easeInOut;
});
parcelHelpers.export(exports, "easeOut", function() {
    return 0, _easeMjs.easeOut;
});
parcelHelpers.export(exports, "mirrorEasing", function() {
    return 0, _mirrorMjs.mirrorEasing;
});
parcelHelpers.export(exports, "reverseEasing", function() {
    return 0, _reverseMjs.reverseEasing;
});
parcelHelpers.export(exports, "steps", function() {
    return 0, _stepsMjs.steps;
});
parcelHelpers.export(exports, "getEasingForSegment", function() {
    return 0, _getEasingForSegmentMjs.getEasingForSegment;
});
parcelHelpers.export(exports, "isBezierDefinition", function() {
    return 0, _isBezierDefinitionMjs.isBezierDefinition;
});
parcelHelpers.export(exports, "isEasingArray", function() {
    return 0, _isEasingArrayMjs.isEasingArray;
});
parcelHelpers.export(exports, "easingDefinitionToFunction", function() {
    return 0, _mapMjs.easingDefinitionToFunction;
});
var _arrayMjs = require("./array.mjs");
var _clampMjs = require("./clamp.mjs");
var _errorsMjs = require("./errors.mjs");
var _globalConfigMjs = require("./global-config.mjs");
var _isNumericalStringMjs = require("./is-numerical-string.mjs");
var _isObjectMjs = require("./is-object.mjs");
var _isZeroValueStringMjs = require("./is-zero-value-string.mjs");
var _memoMjs = require("./memo.mjs");
var _noopMjs = require("./noop.mjs");
var _pipeMjs = require("./pipe.mjs");
var _progressMjs = require("./progress.mjs");
var _subscriptionManagerMjs = require("./subscription-manager.mjs");
var _timeConversionMjs = require("./time-conversion.mjs");
var _velocityPerSecondMjs = require("./velocity-per-second.mjs");
var _warnOnceMjs = require("./warn-once.mjs");
var _wrapMjs = require("./wrap.mjs");
var _anticipateMjs = require("./easing/anticipate.mjs");
var _backMjs = require("./easing/back.mjs");
var _circMjs = require("./easing/circ.mjs");
var _cubicBezierMjs = require("./easing/cubic-bezier.mjs");
var _easeMjs = require("./easing/ease.mjs");
var _mirrorMjs = require("./easing/modifiers/mirror.mjs");
var _reverseMjs = require("./easing/modifiers/reverse.mjs");
var _stepsMjs = require("./easing/steps.mjs");
var _getEasingForSegmentMjs = require("./easing/utils/get-easing-for-segment.mjs");
var _isBezierDefinitionMjs = require("./easing/utils/is-bezier-definition.mjs");
var _isEasingArrayMjs = require("./easing/utils/is-easing-array.mjs");
var _mapMjs = require("./easing/utils/map.mjs");

},{"./array.mjs":"84oPU","./clamp.mjs":"6TWGX","./errors.mjs":"21oze","./global-config.mjs":"1RfIV","./is-numerical-string.mjs":"is0gb","./is-object.mjs":"f3dvR","./is-zero-value-string.mjs":"lNkpK","./memo.mjs":"gGGxT","./noop.mjs":"aaZcO","./pipe.mjs":"gf258","./progress.mjs":"1uYtD","./subscription-manager.mjs":"cCQLu","./time-conversion.mjs":"aAR1z","./velocity-per-second.mjs":"a19z0","./warn-once.mjs":"aVwph","./wrap.mjs":"9d2V3","./easing/anticipate.mjs":"dfedV","./easing/back.mjs":"glWJa","./easing/circ.mjs":"gml7W","./easing/cubic-bezier.mjs":"1Lser","./easing/ease.mjs":"3cp3O","./easing/modifiers/mirror.mjs":"ayy6m","./easing/modifiers/reverse.mjs":"eV3Kl","./easing/steps.mjs":"bbiyi","./easing/utils/get-easing-for-segment.mjs":"1LxjU","./easing/utils/is-bezier-definition.mjs":"uL8rq","./easing/utils/is-easing-array.mjs":"bFNsx","./easing/utils/map.mjs":"6tdf2","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"84oPU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addUniqueItem", function() {
    return addUniqueItem;
});
parcelHelpers.export(exports, "moveItem", function() {
    return moveItem;
});
parcelHelpers.export(exports, "removeItem", function() {
    return removeItem;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toArray = require("@swc/helpers/_/_to_array");
function addUniqueItem(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function removeItem(arr, item) {
    var index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function moveItem(param, fromIndex, toIndex) {
    var _param = (0, _toArray._)(param), arr = _param.slice(0);
    var startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        var endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        var _arr_splice = (0, _slicedToArray._)(arr.splice(fromIndex, 1), 1), item = _arr_splice[0];
        arr.splice(endIndex, 0, item);
    }
    return arr;
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_to_array":"auK39","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6TWGX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clamp", function() {
    return clamp;
});
var clamp = function(min, max, v) {
    if (v > max) return max;
    if (v < min) return min;
    return v;
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"21oze":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "invariant", function() {
    return invariant;
});
parcelHelpers.export(exports, "warning", function() {
    return warning;
});
var _formatErrorMessageMjs = require("./format-error-message.mjs");
var _process_env;
var process = require("556ed69a6b8c72b");
var warning = function() {};
var invariant = function() {};
if (typeof process !== "undefined" && ((_process_env = process.env) === null || _process_env === void 0 ? void 0 : _process_env.NODE_ENV) !== "production") {
    warning = function(check, message, errorCode) {
        if (!check && typeof console !== "undefined") console.warn((0, _formatErrorMessageMjs.formatErrorMessage)(message, errorCode));
    };
    invariant = function(check, message, errorCode) {
        if (!check) throw new Error((0, _formatErrorMessageMjs.formatErrorMessage)(message, errorCode));
    };
}

},{"556ed69a6b8c72b":"gNLf3","./format-error-message.mjs":"aT5rt","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aT5rt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatErrorMessage", function() {
    return formatErrorMessage;
});
function formatErrorMessage(message, errorCode) {
    return errorCode ? "".concat(message, ". For more information and steps for solving, visit https://motion.dev/troubleshooting/").concat(errorCode) : message;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1RfIV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MotionGlobalConfig", function() {
    return MotionGlobalConfig;
});
var MotionGlobalConfig = {};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"is0gb":[function(require,module,exports,__globalThis) {
/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNumericalString", function() {
    return isNumericalString;
});
var isNumericalString = function(v) {
    return RegExp("^-?(?:\\d+(?:\\.\\d+)?|\\.\\d+)$", "u").test(v);
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"f3dvR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isObject", function() {
    return isObject;
});
var _typeOf = require("@swc/helpers/_/_type_of");
function isObject(value) {
    return (typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) === "object" && value !== null;
}

},{"@swc/helpers/_/_type_of":"iFJdx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lNkpK":[function(require,module,exports,__globalThis) {
/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isZeroValueString", function() {
    return isZeroValueString;
});
var isZeroValueString = function(v) {
    return RegExp("^0[^.\\s]+$", "u").test(v);
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gGGxT":[function(require,module,exports,__globalThis) {
/*#__NO_SIDE_EFFECTS__*/ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "memo", function() {
    return memo;
});
function memo(callback) {
    var result;
    return function() {
        if (result === undefined) result = callback();
        return result;
    };
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aaZcO":[function(require,module,exports,__globalThis) {
/*#__NO_SIDE_EFFECTS__*/ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "noop", function() {
    return noop;
});
var noop = function(any) {
    return any;
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gf258":[function(require,module,exports,__globalThis) {
/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pipe", function() {
    return pipe;
});
var combineFunctions = function(a, b) {
    return function(v) {
        return b(a(v));
    };
};
var pipe = function() {
    for(var _len = arguments.length, transformers = new Array(_len), _key = 0; _key < _len; _key++){
        transformers[_key] = arguments[_key];
    }
    return transformers.reduce(combineFunctions);
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1uYtD":[function(require,module,exports,__globalThis) {
/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ /*#__NO_SIDE_EFFECTS__*/ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "progress", function() {
    return progress;
});
var progress = function(from, to, value) {
    var toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cCQLu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SubscriptionManager", function() {
    return SubscriptionManager;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _arrayMjs = require("./array.mjs");
var SubscriptionManager = /*#__PURE__*/ function() {
    "use strict";
    function SubscriptionManager() {
        (0, _classCallCheck._)(this, SubscriptionManager);
        this.subscriptions = [];
    }
    (0, _createClass._)(SubscriptionManager, [
        {
            key: "add",
            value: function add(handler) {
                var _this = this;
                (0, _arrayMjs.addUniqueItem)(this.subscriptions, handler);
                return function() {
                    return (0, _arrayMjs.removeItem)(_this.subscriptions, handler);
                };
            }
        },
        {
            key: "notify",
            value: function notify(a, b, c) {
                var numSubscriptions = this.subscriptions.length;
                if (!numSubscriptions) return;
                if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
                else for(var i = 0; i < numSubscriptions; i++){
                    /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ var handler = this.subscriptions[i];
                    handler && handler(a, b, c);
                }
            }
        },
        {
            key: "getSize",
            value: function getSize() {
                return this.subscriptions.length;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.subscriptions.length = 0;
            }
        }
    ]);
    return SubscriptionManager;
}();

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","./array.mjs":"84oPU","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aAR1z":[function(require,module,exports,__globalThis) {
/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ /*#__NO_SIDE_EFFECTS__*/ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "millisecondsToSeconds", function() {
    return millisecondsToSeconds;
});
parcelHelpers.export(exports, "secondsToMilliseconds", function() {
    return secondsToMilliseconds;
});
var secondsToMilliseconds = function(seconds) {
    return seconds * 1000;
};
/*#__NO_SIDE_EFFECTS__*/ var millisecondsToSeconds = function(milliseconds) {
    return milliseconds / 1000;
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"a19z0":[function(require,module,exports,__globalThis) {
/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "velocityPerSecond", function() {
    return velocityPerSecond;
});
function velocityPerSecond(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aVwph":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasWarned", function() {
    return hasWarned;
});
parcelHelpers.export(exports, "warnOnce", function() {
    return warnOnce;
});
var _formatErrorMessageMjs = require("./format-error-message.mjs");
var warned = new Set();
function hasWarned(message) {
    return warned.has(message);
}
function warnOnce(condition, message, errorCode) {
    if (condition || warned.has(message)) return;
    console.warn((0, _formatErrorMessageMjs.formatErrorMessage)(message, errorCode));
    warned.add(message);
}

},{"./format-error-message.mjs":"aT5rt","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9d2V3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "wrap", function() {
    return wrap;
});
var wrap = function(min, max, v) {
    var rangeSize = max - min;
    return ((v - min) % rangeSize + rangeSize) % rangeSize + min;
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dfedV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "anticipate", function() {
    return anticipate;
});
var _backMjs = require("./back.mjs");
var anticipate = function(p) {
    return p >= 1 ? 1 : (p *= 2) < 1 ? 0.5 * (0, _backMjs.backIn)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));
};

},{"./back.mjs":"glWJa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"glWJa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "backIn", function() {
    return backIn;
});
parcelHelpers.export(exports, "backInOut", function() {
    return backInOut;
});
parcelHelpers.export(exports, "backOut", function() {
    return backOut;
});
var _cubicBezierMjs = require("./cubic-bezier.mjs");
var _mirrorMjs = require("./modifiers/mirror.mjs");
var _reverseMjs = require("./modifiers/reverse.mjs");
var backOut = /*@__PURE__*/ (0, _cubicBezierMjs.cubicBezier)(0.33, 1.53, 0.69, 0.99);
var backIn = /*@__PURE__*/ (0, _reverseMjs.reverseEasing)(backOut);
var backInOut = /*@__PURE__*/ (0, _mirrorMjs.mirrorEasing)(backIn);

},{"./cubic-bezier.mjs":"1Lser","./modifiers/mirror.mjs":"ayy6m","./modifiers/reverse.mjs":"eV3Kl","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1Lser":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cubicBezier", function() {
    return cubicBezier;
});
var _noopMjs = require("../noop.mjs");
/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticeably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
var calcBezier = function(t, a1, a2) {
    return (((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
};
var subdivisionPrecision = 0.0000001;
var subdivisionMaxIterations = 12;
function binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    var currentX;
    var currentT;
    var i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > subdivisionPrecision && ++i < subdivisionMaxIterations);
    return currentT;
}
function cubicBezier(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, _noopMjs.noop;
    var getTForX = function(aX) {
        return binarySubdivide(aX, 0, 1, mX1, mX2);
    };
    // If animation is at start/end, return t without easing
    return function(t) {
        return t === 0 || t === 1 ? t : calcBezier(getTForX(t), mY1, mY2);
    };
}

},{"../noop.mjs":"aaZcO","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ayy6m":[function(require,module,exports,__globalThis) {
// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mirrorEasing", function() {
    return mirrorEasing;
});
var mirrorEasing = function(easing) {
    return function(p) {
        return p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;
    };
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eV3Kl":[function(require,module,exports,__globalThis) {
// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reverseEasing", function() {
    return reverseEasing;
});
var reverseEasing = function(easing) {
    return function(p) {
        return 1 - easing(1 - p);
    };
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gml7W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "circIn", function() {
    return circIn;
});
parcelHelpers.export(exports, "circInOut", function() {
    return circInOut;
});
parcelHelpers.export(exports, "circOut", function() {
    return circOut;
});
var _mirrorMjs = require("./modifiers/mirror.mjs");
var _reverseMjs = require("./modifiers/reverse.mjs");
var circIn = function(p) {
    return 1 - Math.sin(Math.acos(p));
};
var circOut = (0, _reverseMjs.reverseEasing)(circIn);
var circInOut = (0, _mirrorMjs.mirrorEasing)(circIn);

},{"./modifiers/mirror.mjs":"ayy6m","./modifiers/reverse.mjs":"eV3Kl","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3cp3O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "easeIn", function() {
    return easeIn;
});
parcelHelpers.export(exports, "easeInOut", function() {
    return easeInOut;
});
parcelHelpers.export(exports, "easeOut", function() {
    return easeOut;
});
var _cubicBezierMjs = require("./cubic-bezier.mjs");
var easeIn = /*@__PURE__*/ (0, _cubicBezierMjs.cubicBezier)(0.42, 0, 1, 1);
var easeOut = /*@__PURE__*/ (0, _cubicBezierMjs.cubicBezier)(0, 0, 0.58, 1);
var easeInOut = /*@__PURE__*/ (0, _cubicBezierMjs.cubicBezier)(0.42, 0, 0.58, 1);

},{"./cubic-bezier.mjs":"1Lser","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bbiyi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "steps", function() {
    return steps;
});
var _clampMjs = require("../clamp.mjs");
function steps(numSteps) {
    var direction = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "end";
    return function(progress) {
        progress = direction === "end" ? Math.min(progress, 0.999) : Math.max(progress, 0.001);
        var expanded = progress * numSteps;
        var rounded = direction === "end" ? Math.floor(expanded) : Math.ceil(expanded);
        return (0, _clampMjs.clamp)(0, 1, rounded / numSteps);
    };
}

},{"../clamp.mjs":"6TWGX","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1LxjU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getEasingForSegment", function() {
    return getEasingForSegment;
});
var _wrapMjs = require("../../wrap.mjs");
var _isEasingArrayMjs = require("./is-easing-array.mjs");
function getEasingForSegment(easing, i) {
    return (0, _isEasingArrayMjs.isEasingArray)(easing) ? easing[(0, _wrapMjs.wrap)(0, easing.length, i)] : easing;
}

},{"../../wrap.mjs":"9d2V3","./is-easing-array.mjs":"bFNsx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bFNsx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isEasingArray", function() {
    return isEasingArray;
});
var isEasingArray = function(ease) {
    return Array.isArray(ease) && typeof ease[0] !== "number";
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"uL8rq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isBezierDefinition", function() {
    return isBezierDefinition;
});
var isBezierDefinition = function(easing) {
    return Array.isArray(easing) && typeof easing[0] === "number";
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6tdf2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "easingDefinitionToFunction", function() {
    return easingDefinitionToFunction;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _errorsMjs = require("../../errors.mjs");
var _noopMjs = require("../../noop.mjs");
var _anticipateMjs = require("../anticipate.mjs");
var _backMjs = require("../back.mjs");
var _circMjs = require("../circ.mjs");
var _cubicBezierMjs = require("../cubic-bezier.mjs");
var _easeMjs = require("../ease.mjs");
var _isBezierDefinitionMjs = require("./is-bezier-definition.mjs");
var easingLookup = {
    linear: (0, _noopMjs.noop),
    easeIn: (0, _easeMjs.easeIn),
    easeInOut: (0, _easeMjs.easeInOut),
    easeOut: (0, _easeMjs.easeOut),
    circIn: (0, _circMjs.circIn),
    circInOut: (0, _circMjs.circInOut),
    circOut: (0, _circMjs.circOut),
    backIn: (0, _backMjs.backIn),
    backInOut: (0, _backMjs.backInOut),
    backOut: (0, _backMjs.backOut),
    anticipate: (0, _anticipateMjs.anticipate)
};
var isValidEasing = function(easing) {
    return typeof easing === "string";
};
var easingDefinitionToFunction = function(definition) {
    if ((0, _isBezierDefinitionMjs.isBezierDefinition)(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, _errorsMjs.invariant)(definition.length === 4, "Cubic bezier arrays must contain four numerical values.", "cubic-bezier-length");
        var _definition = (0, _slicedToArray._)(definition, 4), x1 = _definition[0], y1 = _definition[1], x2 = _definition[2], y2 = _definition[3];
        return (0, _cubicBezierMjs.cubicBezier)(x1, y1, x2, y2);
    } else if (isValidEasing(definition)) {
        // Else lookup from table
        (0, _errorsMjs.invariant)(easingLookup[definition] !== undefined, "Invalid easing type '".concat(definition, "'"), "invalid-easing-type");
        return easingLookup[definition];
    }
    return definition;
};

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","../../errors.mjs":"21oze","../../noop.mjs":"aaZcO","../anticipate.mjs":"dfedV","../back.mjs":"glWJa","../circ.mjs":"gml7W","../cubic-bezier.mjs":"1Lser","../ease.mjs":"3cp3O","./is-bezier-definition.mjs":"uL8rq","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aPTZo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "time", function() {
    return time;
});
var _motionUtils = require("motion-utils");
var _frameMjs = require("./frame.mjs");
var now;
function clearTime() {
    now = undefined;
}
/**
 * An eventloop-synchronous alternative to performance.now().
 *
 * Ensures that time measurements remain consistent within a synchronous context.
 * Usually calling performance.now() twice within the same synchronous context
 * will return different values which isn't useful for animations when we're usually
 * trying to sync animations to the same frame.
 */ var time = {
    now: function() {
        if (now === undefined) time.set((0, _frameMjs.frameData).isProcessing || (0, _motionUtils.MotionGlobalConfig).useManualTiming ? (0, _frameMjs.frameData).timestamp : performance.now());
        return now;
    },
    set: function(newTime) {
        now = newTime;
        queueMicrotask(clearTime);
    }
};

},{"motion-utils":"9Q5qC","./frame.mjs":"lxQZr","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lxQZr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cancelFrame", function() {
    return cancelFrame;
});
parcelHelpers.export(exports, "frame", function() {
    return frame;
});
parcelHelpers.export(exports, "frameData", function() {
    return frameData;
});
parcelHelpers.export(exports, "frameSteps", function() {
    return frameSteps;
});
var _motionUtils = require("motion-utils");
var _batcherMjs = require("./batcher.mjs");
var /* @__PURE__ */ _createRenderBatcher = (0, _batcherMjs.createRenderBatcher)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, _motionUtils.noop), true), frame = _createRenderBatcher.schedule, cancelFrame = _createRenderBatcher.cancel, frameData = _createRenderBatcher.state, frameSteps = _createRenderBatcher.steps;

},{"motion-utils":"9Q5qC","./batcher.mjs":"dVA5A","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dVA5A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createRenderBatcher", function() {
    return createRenderBatcher;
});
var _motionUtils = require("motion-utils");
var _orderMjs = require("./order.mjs");
var _renderStepMjs = require("./render-step.mjs");
var maxElapsed = 40;
function createRenderBatcher(scheduleNextBatch, allowKeepAlive) {
    var runNextFrame = false;
    var useDefaultElapsed = true;
    var state = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    var flagRunNextFrame = function() {
        return runNextFrame = true;
    };
    var steps = (0, _orderMjs.stepsOrder).reduce(function(acc, key) {
        acc[key] = (0, _renderStepMjs.createRenderStep)(flagRunNextFrame, allowKeepAlive ? key : undefined);
        return acc;
    }, {});
    var setup = steps.setup, read = steps.read, resolveKeyframes = steps.resolveKeyframes, preUpdate = steps.preUpdate, update = steps.update, preRender = steps.preRender, render = steps.render, postRender = steps.postRender;
    var processBatch = function() {
        var useManualTiming = (0, _motionUtils.MotionGlobalConfig).useManualTiming;
        var timestamp = useManualTiming ? state.timestamp : performance.now();
        runNextFrame = false;
        if (!useManualTiming) state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        // Unrolled render loop for better per-frame performance
        setup.process(state);
        read.process(state);
        resolveKeyframes.process(state);
        preUpdate.process(state);
        update.process(state);
        preRender.process(state);
        render.process(state);
        postRender.process(state);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    var wake = function() {
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    var schedule = (0, _orderMjs.stepsOrder).reduce(function(acc, key) {
        var step = steps[key];
        acc[key] = function(process) {
            var keepAlive = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, immediate = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    var cancel = function(process) {
        for(var i = 0; i < (0, _orderMjs.stepsOrder).length; i++)steps[(0, _orderMjs.stepsOrder)[i]].cancel(process);
    };
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}

},{"motion-utils":"9Q5qC","./order.mjs":"1wFti","./render-step.mjs":"eiIUJ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1wFti":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "stepsOrder", function() {
    return stepsOrder;
});
var stepsOrder = [
    "setup",
    "read",
    "resolveKeyframes",
    "preUpdate",
    "update",
    "preRender",
    "render",
    "postRender"
];

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eiIUJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createRenderStep", function() {
    return createRenderStep;
});
var _bufferMjs = require("../stats/buffer.mjs");
function createRenderStep(runNextFrame, stepName) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ var thisFrame = new Set();
    var nextFrame = new Set();
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ var isProcessing = false;
    var flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ var toKeepAlive = new WeakSet();
    var latestFrameData = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    var numCalls = 0;
    function triggerCallback(callback) {
        if (toKeepAlive.has(callback)) {
            step.schedule(callback);
            runNextFrame();
        }
        numCalls++;
        callback(latestFrameData);
    }
    var step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: function(callback) {
            var keepAlive = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, immediate = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
            var addToCurrentFrame = immediate && isProcessing;
            var queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            queue.add(callback);
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: function(callback) {
            nextFrame.delete(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: function(frameData) {
            latestFrameData = frameData;
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            // Swap this frame and the next to avoid GC
            var prevFrame = thisFrame;
            thisFrame = nextFrame;
            nextFrame = prevFrame;
            // Execute this frame
            thisFrame.forEach(triggerCallback);
            /**
             * If we're recording stats then
             */ if (stepName && (0, _bufferMjs.statsBuffer).value) (0, _bufferMjs.statsBuffer).value.frameloop[stepName].push(numCalls);
            numCalls = 0;
            // Clear the frame so no callbacks remain. This is to avoid
            // memory leaks should this render step not run for a while.
            thisFrame.clear();
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}

},{"../stats/buffer.mjs":"bcR1L","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bcR1L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "statsBuffer", function() {
    return statsBuffer;
});
var statsBuffer = {
    value: null,
    addProjectionMetrics: null
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9nspW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JSAnimation", function() {
    return JSAnimation;
});
parcelHelpers.export(exports, "animateValue", function() {
    return animateValue;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _motionUtils = require("motion-utils");
var _syncTimeMjs = require("../frameloop/sync-time.mjs");
var _animationCountMjs = require("../stats/animation-count.mjs");
var _indexMjs = require("../utils/mix/index.mjs");
var _frameMjs = require("./drivers/frame.mjs");
var _inertiaMjs = require("./generators/inertia.mjs");
var _keyframesMjs = require("./generators/keyframes.mjs");
var _calcDurationMjs = require("./generators/utils/calc-duration.mjs");
var _velocityMjs = require("./generators/utils/velocity.mjs");
var _getFinalMjs = require("./keyframes/get-final.mjs");
var _replaceTransitionTypeMjs = require("./utils/replace-transition-type.mjs");
var _withPromiseMjs = require("./utils/WithPromise.mjs");
var percentToProgress = function(percent) {
    return percent / 100;
};
var JSAnimation = /*#__PURE__*/ function(WithPromise) {
    "use strict";
    (0, _inherits._)(JSAnimation, WithPromise);
    function JSAnimation(options) {
        (0, _classCallCheck._)(this, JSAnimation);
        var _this;
        _this = (0, _callSuper._)(this, JSAnimation);
        _this.state = "idle";
        _this.startTime = null;
        _this.isStopped = false;
        /**
         * The current time of the animation.
         */ _this.currentTime = 0;
        /**
         * The time at which the animation was paused.
         */ _this.holdTime = null;
        /**
         * Playback speed as a factor. 0 would be stopped, -1 reverse and 2 double speed.
         */ _this.playbackSpeed = 1;
        /**
         * Reusable state object for the delay phase to avoid
         * allocating a new object every frame.
         */ _this.delayState = {
            done: false,
            value: undefined
        };
        /**
         * This method is bound to the instance to fix a pattern where
         * animation.stop is returned as a reference from a useEffect.
         */ _this.stop = function() {
            var _this_options_onStop, _this_options;
            var motionValue = _this.options.motionValue;
            if (motionValue && motionValue.updatedAt !== (0, _syncTimeMjs.time).now()) _this.tick((0, _syncTimeMjs.time).now());
            _this.isStopped = true;
            if (_this.state === "idle") return;
            _this.teardown();
            (_this_options_onStop = (_this_options = _this.options).onStop) === null || _this_options_onStop === void 0 ? void 0 : _this_options_onStop.call(_this_options);
        };
        (0, _animationCountMjs.activeAnimations).mainThread++;
        _this.options = options;
        _this.initAnimation();
        _this.play();
        if (options.autoplay === false) _this.pause();
        return _this;
    }
    (0, _createClass._)(JSAnimation, [
        {
            key: "initAnimation",
            value: function initAnimation() {
                var options = this.options;
                (0, _replaceTransitionTypeMjs.replaceTransitionType)(options);
                var _options_type = options.type, type = _options_type === void 0 ? (0, _keyframesMjs.keyframes) : _options_type, _options_repeat = options.repeat, repeat = _options_repeat === void 0 ? 0 : _options_repeat, _options_repeatDelay = options.repeatDelay, repeatDelay = _options_repeatDelay === void 0 ? 0 : _options_repeatDelay, repeatType = options.repeatType, _options_velocity = options.velocity, velocity = _options_velocity === void 0 ? 0 : _options_velocity;
                var keyframes$1 = options.keyframes;
                var generatorFactory = type || (0, _keyframesMjs.keyframes);
                if (generatorFactory !== (0, _keyframesMjs.keyframes) && typeof keyframes$1[0] !== "number") {
                    this.mixKeyframes = (0, _motionUtils.pipe)(percentToProgress, (0, _indexMjs.mix)(keyframes$1[0], keyframes$1[1]));
                    keyframes$1 = [
                        0,
                        100
                    ];
                }
                var generator = generatorFactory((0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
                    keyframes: keyframes$1
                }));
                /**
         * If we have a mirror repeat type we need to create a second generator that outputs the
         * mirrored (not reversed) animation and later ping pong between the two generators.
         */ if (repeatType === "mirror") this.mirroredGenerator = generatorFactory((0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
                    keyframes: (0, _toConsumableArray._)(keyframes$1).reverse(),
                    velocity: -velocity
                }));
                /**
         * If duration is undefined and we have repeat options,
         * we need to calculate a duration from the generator.
         *
         * We set it to the generator itself to cache the duration.
         * Any timeline resolver will need to have already precalculated
         * the duration by this step.
         */ if (generator.calculatedDuration === null) generator.calculatedDuration = (0, _calcDurationMjs.calcGeneratorDuration)(generator);
                var calculatedDuration = generator.calculatedDuration;
                this.calculatedDuration = calculatedDuration;
                this.resolvedDuration = calculatedDuration + repeatDelay;
                this.totalDuration = this.resolvedDuration * (repeat + 1) - repeatDelay;
                this.generator = generator;
            }
        },
        {
            key: "updateTime",
            value: function updateTime(timestamp) {
                var animationTime = Math.round(timestamp - this.startTime) * this.playbackSpeed;
                // Update currentTime
                if (this.holdTime !== null) this.currentTime = this.holdTime;
                else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
                // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
                // example.
                this.currentTime = animationTime;
            }
        },
        {
            key: "tick",
            value: function tick(timestamp) {
                var sample = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this, generator = _this.generator, totalDuration = _this.totalDuration, mixKeyframes = _this.mixKeyframes, mirroredGenerator = _this.mirroredGenerator, resolvedDuration = _this.resolvedDuration, calculatedDuration = _this.calculatedDuration;
                if (this.startTime === null) return generator.next(0);
                var _this_options = this.options, _this_options_delay = _this_options.delay, delay = _this_options_delay === void 0 ? 0 : _this_options_delay, keyframes = _this_options.keyframes, repeat = _this_options.repeat, repeatType = _this_options.repeatType, repeatDelay = _this_options.repeatDelay, type = _this_options.type, onUpdate = _this_options.onUpdate, finalKeyframe = _this_options.finalKeyframe;
                /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (this.speed > 0) this.startTime = Math.min(this.startTime, timestamp);
                else if (this.speed < 0) this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
                if (sample) this.currentTime = timestamp;
                else this.updateTime(timestamp);
                // Rebase on delay
                var timeWithoutDelay = this.currentTime - delay * (this.playbackSpeed >= 0 ? 1 : -1);
                var isInDelayPhase = this.playbackSpeed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
                this.currentTime = Math.max(timeWithoutDelay, 0);
                // If this animation has finished, set the current time  to the total duration.
                if (this.state === "finished" && this.holdTime === null) this.currentTime = totalDuration;
                var elapsed = this.currentTime;
                var frameGenerator = generator;
                if (repeat) {
                    /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ var progress = Math.min(this.currentTime, totalDuration) / resolvedDuration;
                    /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ var currentIteration = Math.floor(progress);
                    /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ var iterationProgress = progress % 1.0;
                    /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
                    iterationProgress === 1 && currentIteration--;
                    currentIteration = Math.min(currentIteration, repeat + 1);
                    /**
             * Reverse progress if we're not running in "normal" direction
             */ var isOddIteration = Boolean(currentIteration % 2);
                    if (isOddIteration) {
                        if (repeatType === "reverse") {
                            iterationProgress = 1 - iterationProgress;
                            if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                        } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
                    }
                    elapsed = (0, _motionUtils.clamp)(0, 1, iterationProgress) * resolvedDuration;
                }
                /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ var state;
                if (isInDelayPhase) {
                    this.delayState.value = keyframes[0];
                    state = this.delayState;
                } else state = frameGenerator.next(elapsed);
                if (mixKeyframes && !isInDelayPhase) state.value = mixKeyframes(state.value);
                var done = state.done;
                if (!isInDelayPhase && calculatedDuration !== null) done = this.playbackSpeed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
                var isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done);
                // TODO: The exception for inertia could be cleaner here
                if (isAnimationFinished && type !== (0, _inertiaMjs.inertia)) state.value = (0, _getFinalMjs.getFinalKeyframe)(keyframes, this.options, finalKeyframe, this.speed);
                if (onUpdate) onUpdate(state.value);
                if (isAnimationFinished) this.finish();
                return state;
            }
        },
        {
            /**
     * Allows the returned animation to be awaited or promise-chained. Currently
     * resolves when the animation finishes at all but in a future update could/should
     * reject if its cancels.
     */ key: "then",
            value: function then(resolve, reject) {
                return this.finished.then(resolve, reject);
            }
        },
        {
            key: "duration",
            get: function get() {
                return (0, _motionUtils.millisecondsToSeconds)(this.calculatedDuration);
            }
        },
        {
            key: "iterationDuration",
            get: function get() {
                var _ref = this.options || {}, _ref_delay = _ref.delay, delay = _ref_delay === void 0 ? 0 : _ref_delay;
                return this.duration + (0, _motionUtils.millisecondsToSeconds)(delay);
            }
        },
        {
            key: "time",
            get: function get() {
                return (0, _motionUtils.millisecondsToSeconds)(this.currentTime);
            },
            set: function set(newTime) {
                newTime = (0, _motionUtils.secondsToMilliseconds)(newTime);
                this.currentTime = newTime;
                if (this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0) this.holdTime = newTime;
                else if (this.driver) this.startTime = this.driver.now() - newTime / this.playbackSpeed;
                if (this.driver) this.driver.start(false);
                else {
                    this.startTime = 0;
                    this.state = "paused";
                    this.holdTime = newTime;
                    this.tick(newTime);
                }
            }
        },
        {
            /**
     * Returns the generator's velocity at the current time in units/second.
     * Uses the analytical derivative when available (springs), avoiding
     * the MotionValue's frame-dependent velocity estimation.
     */ key: "getGeneratorVelocity",
            value: function getGeneratorVelocity() {
                var _this = this;
                var t = this.currentTime;
                if (t <= 0) return this.options.velocity || 0;
                if (this.generator.velocity) return this.generator.velocity(t);
                // Fallback: finite difference
                var current = this.generator.next(t).value;
                return (0, _velocityMjs.getGeneratorVelocity)(function(s) {
                    return _this.generator.next(s).value;
                }, t, current);
            }
        },
        {
            key: "speed",
            get: function get() {
                return this.playbackSpeed;
            },
            set: function set(newSpeed) {
                var hasChanged = this.playbackSpeed !== newSpeed;
                if (hasChanged && this.driver) this.updateTime((0, _syncTimeMjs.time).now());
                this.playbackSpeed = newSpeed;
                if (hasChanged && this.driver) this.time = (0, _motionUtils.millisecondsToSeconds)(this.currentTime);
            }
        },
        {
            key: "play",
            value: function play() {
                var _this = this;
                var _this_options_onPlay, _this_options;
                if (this.isStopped) return;
                var _this_options1 = this.options, _this_options_driver = _this_options1.driver, driver = _this_options_driver === void 0 ? (0, _frameMjs.frameloopDriver) : _this_options_driver, startTime = _this_options1.startTime;
                if (!this.driver) this.driver = driver(function(timestamp) {
                    return _this.tick(timestamp);
                });
                (_this_options_onPlay = (_this_options = this.options).onPlay) === null || _this_options_onPlay === void 0 ? void 0 : _this_options_onPlay.call(_this_options);
                var now = this.driver.now();
                if (this.state === "finished") {
                    this.updateFinished();
                    this.startTime = now;
                } else if (this.holdTime !== null) this.startTime = now - this.holdTime;
                else if (!this.startTime) this.startTime = startTime !== null && startTime !== void 0 ? startTime : now;
                if (this.state === "finished" && this.speed < 0) this.startTime += this.calculatedDuration;
                this.holdTime = null;
                /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ this.state = "running";
                this.driver.start();
            }
        },
        {
            key: "pause",
            value: function pause() {
                this.state = "paused";
                this.updateTime((0, _syncTimeMjs.time).now());
                this.holdTime = this.currentTime;
            }
        },
        {
            key: "complete",
            value: function complete() {
                if (this.state !== "running") this.play();
                this.state = "finished";
                this.holdTime = null;
            }
        },
        {
            key: "finish",
            value: function finish() {
                var _this_options_onComplete, _this_options;
                this.notifyFinished();
                this.teardown();
                this.state = "finished";
                (_this_options_onComplete = (_this_options = this.options).onComplete) === null || _this_options_onComplete === void 0 ? void 0 : _this_options_onComplete.call(_this_options);
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                var _this_options_onCancel, _this_options;
                this.holdTime = null;
                this.startTime = 0;
                this.tick(0);
                this.teardown();
                (_this_options_onCancel = (_this_options = this.options).onCancel) === null || _this_options_onCancel === void 0 ? void 0 : _this_options_onCancel.call(_this_options);
            }
        },
        {
            key: "teardown",
            value: function teardown() {
                this.state = "idle";
                this.stopDriver();
                this.startTime = this.holdTime = null;
                (0, _animationCountMjs.activeAnimations).mainThread--;
            }
        },
        {
            key: "stopDriver",
            value: function stopDriver() {
                if (!this.driver) return;
                this.driver.stop();
                this.driver = undefined;
            }
        },
        {
            key: "sample",
            value: function sample(sampleTime) {
                this.startTime = 0;
                return this.tick(sampleTime, true);
            }
        },
        {
            key: "attachTimeline",
            value: function attachTimeline(timeline) {
                var _this_driver;
                if (this.options.allowFlatten) {
                    this.options.type = "keyframes";
                    this.options.ease = "linear";
                    this.initAnimation();
                }
                (_this_driver = this.driver) === null || _this_driver === void 0 ? void 0 : _this_driver.stop();
                return timeline.observe(this);
            }
        }
    ]);
    return JSAnimation;
}((0, _withPromiseMjs.WithPromise));
// Legacy function support
function animateValue(options) {
    return new JSAnimation(options);
}

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_inherits":"2sfqW","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_to_consumable_array":"1eSZf","motion-utils":"9Q5qC","../frameloop/sync-time.mjs":"aPTZo","../stats/animation-count.mjs":"gY9Wc","../utils/mix/index.mjs":"gnOe8","./drivers/frame.mjs":"d5msi","./generators/inertia.mjs":"fSjpI","./generators/keyframes.mjs":"heVZz","./generators/utils/calc-duration.mjs":"hyydG","./generators/utils/velocity.mjs":"i231k","./keyframes/get-final.mjs":"hAUAJ","./utils/replace-transition-type.mjs":"1PTe1","./utils/WithPromise.mjs":"jEvnC","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gY9Wc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "activeAnimations", function() {
    return activeAnimations;
});
var activeAnimations = {
    layout: 0,
    mainThread: 0,
    waapi: 0
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gnOe8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mix", function() {
    return mix;
});
var _complexMjs = require("./complex.mjs");
var _numberMjs = require("./number.mjs");
function mix(from, to, p) {
    if (typeof from === "number" && typeof to === "number" && typeof p === "number") return (0, _numberMjs.mixNumber)(from, to, p);
    var mixer = (0, _complexMjs.getMixer)(from);
    return mixer(from, to);
}

},{"./complex.mjs":"gqozO","./number.mjs":"j0eyN","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gqozO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getMixer", function() {
    return getMixer;
});
parcelHelpers.export(exports, "mixArray", function() {
    return mixArray;
});
parcelHelpers.export(exports, "mixComplex", function() {
    return mixComplex;
});
parcelHelpers.export(exports, "mixObject", function() {
    return mixObject;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var _motionUtils = require("motion-utils");
var _isCssVariableMjs = require("../../animation/utils/is-css-variable.mjs");
var _indexMjs = require("../../value/types/color/index.mjs");
var _indexMjs1 = require("../../value/types/complex/index.mjs");
var _colorMjs = require("./color.mjs");
var _immediateMjs = require("./immediate.mjs");
var _numberMjs = require("./number.mjs");
var _visibilityMjs = require("./visibility.mjs");
function mixNumber(a, b) {
    return function(p) {
        return (0, _numberMjs.mixNumber)(a, b, p);
    };
}
function getMixer(a) {
    if (typeof a === "number") return mixNumber;
    else if (typeof a === "string") return (0, _isCssVariableMjs.isCSSVariableToken)(a) ? (0, _immediateMjs.mixImmediate) : (0, _indexMjs.color).test(a) ? (0, _colorMjs.mixColor) : mixComplex;
    else if (Array.isArray(a)) return mixArray;
    else if ((typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)) === "object") return (0, _indexMjs.color).test(a) ? (0, _colorMjs.mixColor) : mixObject;
    return 0, _immediateMjs.mixImmediate;
}
function mixArray(a, b) {
    var output = (0, _toConsumableArray._)(a);
    var numValues = output.length;
    var blendValue = a.map(function(v, i) {
        return getMixer(v)(v, b[i]);
    });
    return function(p) {
        for(var i = 0; i < numValues; i++)output[i] = blendValue[i](p);
        return output;
    };
}
function mixObject(a, b) {
    var output = (0, _objectSpread._)({}, a, b);
    var blendValue = {};
    for(var key in output)if (a[key] !== undefined && b[key] !== undefined) blendValue[key] = getMixer(a[key])(a[key], b[key]);
    return function(v) {
        for(var key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
}
function matchOrder(origin, target) {
    var orderedOrigin = [];
    var pointers = {
        color: 0,
        var: 0,
        number: 0
    };
    for(var i = 0; i < target.values.length; i++){
        var type = target.types[i];
        var originIndex = origin.indexes[type][pointers[type]];
        var _origin_values_originIndex;
        var originValue = (_origin_values_originIndex = origin.values[originIndex]) !== null && _origin_values_originIndex !== void 0 ? _origin_values_originIndex : 0;
        orderedOrigin[i] = originValue;
        pointers[type]++;
    }
    return orderedOrigin;
}
var mixComplex = function(origin, target) {
    var template = (0, _indexMjs1.complex).createTransformer(target);
    var originStats = (0, _indexMjs1.analyseComplexValue)(origin);
    var targetStats = (0, _indexMjs1.analyseComplexValue)(target);
    var canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length && originStats.indexes.color.length === targetStats.indexes.color.length && originStats.indexes.number.length >= targetStats.indexes.number.length;
    if (canInterpolate) {
        if ((0, _visibilityMjs.invisibleValues).has(origin) && !targetStats.values.length || (0, _visibilityMjs.invisibleValues).has(target) && !originStats.values.length) return (0, _visibilityMjs.mixVisibility)(origin, target);
        return (0, _motionUtils.pipe)(mixArray(matchOrder(originStats, targetStats), targetStats.values), template);
    } else {
        (0, _motionUtils.warning)(true, "Complex values '".concat(origin, "' and '").concat(target, "' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition."), "complex-values-different");
        return (0, _immediateMjs.mixImmediate)(origin, target);
    }
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_to_consumable_array":"1eSZf","@swc/helpers/_/_type_of":"iFJdx","motion-utils":"9Q5qC","../../animation/utils/is-css-variable.mjs":"5nV2N","../../value/types/color/index.mjs":"gbu7c","../../value/types/complex/index.mjs":"6JMtB","./color.mjs":"9UUUz","./immediate.mjs":"3HHoi","./number.mjs":"j0eyN","./visibility.mjs":"kGlHI","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5nV2N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "containsCSSVariable", function() {
    return containsCSSVariable;
});
parcelHelpers.export(exports, "isCSSVariableName", function() {
    return isCSSVariableName;
});
parcelHelpers.export(exports, "isCSSVariableToken", function() {
    return isCSSVariableToken;
});
var checkStringStartsWith = function(token) {
    return function(key) {
        return typeof key === "string" && key.startsWith(token);
    };
};
var isCSSVariableName = /*@__PURE__*/ checkStringStartsWith("--");
var startsAsVariableToken = /*@__PURE__*/ checkStringStartsWith("var(--");
var isCSSVariableToken = function(value) {
    var startsWithToken = startsAsVariableToken(value);
    if (!startsWithToken) return false;
    // Ensure any comments are stripped from the value as this can harm performance of the regex.
    return singleCssVariableRegex.test(value.split("/*")[0].trim());
};
var singleCssVariableRegex = RegExp("var\\(--(?:[\\w-]+\\s*|[\\w-]+\\s*,(?:\\s*[^)(\\s]|\\s*\\((?:[^)(]|\\([^)(]*\\))*\\))+\\s*)\\)$", "iu");
/**
 * Check if a value contains a CSS variable anywhere (e.g. inside calc()).
 * Unlike isCSSVariableToken which checks if the value IS a var() token,
 * this checks if the value CONTAINS var() somewhere in the string.
 */ function containsCSSVariable(value) {
    if (typeof value !== "string") return false;
    // Strip comments to avoid false positives
    return value.split("/*")[0].includes("var(--");
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gbu7c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "color", function() {
    return color;
});
var _hexMjs = require("./hex.mjs");
var _hslaMjs = require("./hsla.mjs");
var _rgbaMjs = require("./rgba.mjs");
var color = {
    test: function(v) {
        return (0, _rgbaMjs.rgba).test(v) || (0, _hexMjs.hex).test(v) || (0, _hslaMjs.hsla).test(v);
    },
    parse: function(v) {
        if ((0, _rgbaMjs.rgba).test(v)) return (0, _rgbaMjs.rgba).parse(v);
        else if ((0, _hslaMjs.hsla).test(v)) return (0, _hslaMjs.hsla).parse(v);
        else return (0, _hexMjs.hex).parse(v);
    },
    transform: function(v) {
        return typeof v === "string" ? v : v.hasOwnProperty("red") ? (0, _rgbaMjs.rgba).transform(v) : (0, _hslaMjs.hsla).transform(v);
    },
    getAnimatableNone: function(v) {
        var parsed = color.parse(v);
        parsed.alpha = 0;
        return color.transform(parsed);
    }
};

},{"./hex.mjs":"fmT9b","./hsla.mjs":"8tWc0","./rgba.mjs":"5eamO","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fmT9b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hex", function() {
    return hex;
});
var _rgbaMjs = require("./rgba.mjs");
var _utilsMjs = require("./utils.mjs");
function parseHex(v) {
    var r = "";
    var g = "";
    var b = "";
    var a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
var hex = {
    test: /*@__PURE__*/ (0, _utilsMjs.isColorString)("#"),
    parse: parseHex,
    transform: (0, _rgbaMjs.rgba).transform
};

},{"./rgba.mjs":"5eamO","./utils.mjs":"cnWxC","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5eamO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rgbUnit", function() {
    return rgbUnit;
});
parcelHelpers.export(exports, "rgba", function() {
    return rgba;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _motionUtils = require("motion-utils");
var _indexMjs = require("../numbers/index.mjs");
var _sanitizeMjs = require("../utils/sanitize.mjs");
var _utilsMjs = require("./utils.mjs");
var clampRgbUnit = function(v) {
    return (0, _motionUtils.clamp)(0, 255, v);
};
var rgbUnit = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _indexMjs.number)), {
    transform: function(v) {
        return Math.round(clampRgbUnit(v));
    }
});
var rgba = {
    test: /*@__PURE__*/ (0, _utilsMjs.isColorString)("rgb", "red"),
    parse: /*@__PURE__*/ (0, _utilsMjs.splitColor)("red", "green", "blue"),
    transform: function(param) {
        var red = param.red, green = param.green, blue = param.blue, tmp = param.alpha, alpha$1 = tmp === void 0 ? 1 : tmp;
        return "rgba(" + rgbUnit.transform(red) + ", " + rgbUnit.transform(green) + ", " + rgbUnit.transform(blue) + ", " + (0, _sanitizeMjs.sanitize)((0, _indexMjs.alpha).transform(alpha$1)) + ")";
    }
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","motion-utils":"9Q5qC","../numbers/index.mjs":"l5BDX","../utils/sanitize.mjs":"cYIBx","./utils.mjs":"cnWxC","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"l5BDX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "alpha", function() {
    return alpha;
});
parcelHelpers.export(exports, "number", function() {
    return number;
});
parcelHelpers.export(exports, "scale", function() {
    return scale;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _motionUtils = require("motion-utils");
var number = {
    test: function(v) {
        return typeof v === "number";
    },
    parse: parseFloat,
    transform: function(v) {
        return v;
    }
};
var alpha = (0, _objectSpreadProps._)((0, _objectSpread._)({}, number), {
    transform: function(v) {
        return (0, _motionUtils.clamp)(0, 1, v);
    }
});
var scale = (0, _objectSpreadProps._)((0, _objectSpread._)({}, number), {
    default: 1
});

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","motion-utils":"9Q5qC","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cYIBx":[function(require,module,exports,__globalThis) {
// If this number is a decimal, make it just five decimal places
// to avoid exponents
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sanitize", function() {
    return sanitize;
});
var sanitize = function(v) {
    return Math.round(v * 100000) / 100000;
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cnWxC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isColorString", function() {
    return isColorString;
});
parcelHelpers.export(exports, "splitColor", function() {
    return splitColor;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _floatRegexMjs = require("../utils/float-regex.mjs");
var _isNullishMjs = require("../utils/is-nullish.mjs");
var _singleColorRegexMjs = require("../utils/single-color-regex.mjs");
/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ var isColorString = function(type, testProp) {
    return function(v) {
        return Boolean(typeof v === "string" && (0, _singleColorRegexMjs.singleColorRegex).test(v) && v.startsWith(type) || testProp && !(0, _isNullishMjs.isNullish)(v) && Object.prototype.hasOwnProperty.call(v, testProp));
    };
};
var splitColor = function(aName, bName, cName) {
    return function(v) {
        if (typeof v !== "string") return v;
        var _v_match = (0, _slicedToArray._)(v.match((0, _floatRegexMjs.floatRegex)), 4), a = _v_match[0], b = _v_match[1], c = _v_match[2], alpha = _v_match[3];
        var _obj;
        return _obj = {}, (0, _defineProperty._)(_obj, aName, parseFloat(a)), (0, _defineProperty._)(_obj, bName, parseFloat(b)), (0, _defineProperty._)(_obj, cName, parseFloat(c)), (0, _defineProperty._)(_obj, "alpha", alpha !== undefined ? parseFloat(alpha) : 1), _obj;
    };
};

},{"@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_sliced_to_array":"8PtL6","../utils/float-regex.mjs":"1DShP","../utils/is-nullish.mjs":"66SIu","../utils/single-color-regex.mjs":"fwWv1","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1DShP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "floatRegex", function() {
    return floatRegex;
});
var floatRegex = RegExp("-?(?:\\d+(?:\\.\\d+)?|\\.\\d+)", "gu");

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"66SIu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNullish", function() {
    return isNullish;
});
function isNullish(v) {
    return v == null;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fwWv1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "singleColorRegex", function() {
    return singleColorRegex;
});
var singleColorRegex = RegExp("^(?:#[\\da-f]{3,8}|(?:rgb|hsl)a?\\((?:-?[\\d.]+%?[,\\s]+){2}-?[\\d.]+%?\\s*(?:[,/]\\s*)?(?:\\b\\d+(?:\\.\\d+)?|\\.\\d+)?%?\\))$", "iu");

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8tWc0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hsla", function() {
    return hsla;
});
var _indexMjs = require("../numbers/index.mjs");
var _unitsMjs = require("../numbers/units.mjs");
var _sanitizeMjs = require("../utils/sanitize.mjs");
var _utilsMjs = require("./utils.mjs");
var hsla = {
    test: /*@__PURE__*/ (0, _utilsMjs.isColorString)("hsl", "hue"),
    parse: /*@__PURE__*/ (0, _utilsMjs.splitColor)("hue", "saturation", "lightness"),
    transform: function(param) {
        var hue = param.hue, saturation = param.saturation, lightness = param.lightness, tmp = param.alpha, alpha$1 = tmp === void 0 ? 1 : tmp;
        return "hsla(" + Math.round(hue) + ", " + (0, _unitsMjs.percent).transform((0, _sanitizeMjs.sanitize)(saturation)) + ", " + (0, _unitsMjs.percent).transform((0, _sanitizeMjs.sanitize)(lightness)) + ", " + (0, _sanitizeMjs.sanitize)((0, _indexMjs.alpha).transform(alpha$1)) + ")";
    }
};

},{"../numbers/index.mjs":"l5BDX","../numbers/units.mjs":"iC5kO","../utils/sanitize.mjs":"cYIBx","./utils.mjs":"cnWxC","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iC5kO":[function(require,module,exports,__globalThis) {
/*#__NO_SIDE_EFFECTS__*/ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "degrees", function() {
    return degrees;
});
parcelHelpers.export(exports, "percent", function() {
    return percent;
});
parcelHelpers.export(exports, "progressPercentage", function() {
    return progressPercentage;
});
parcelHelpers.export(exports, "px", function() {
    return px;
});
parcelHelpers.export(exports, "vh", function() {
    return vh;
});
parcelHelpers.export(exports, "vw", function() {
    return vw;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var createUnitType = function(unit) {
    return {
        test: function(v) {
            return typeof v === "string" && v.endsWith(unit) && v.split(" ").length === 1;
        },
        parse: parseFloat,
        transform: function(v) {
            return "".concat(v).concat(unit);
        }
    };
};
var degrees = /*@__PURE__*/ createUnitType("deg");
var percent = /*@__PURE__*/ createUnitType("%");
var px = /*@__PURE__*/ createUnitType("px");
var vh = /*@__PURE__*/ createUnitType("vh");
var vw = /*@__PURE__*/ createUnitType("vw");
var progressPercentage = /*@__PURE__*/ function() {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, percent), {
        parse: function(v) {
            return percent.parse(v) / 100;
        },
        transform: function(v) {
            return percent.transform(v * 100);
        }
    });
}();

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6JMtB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "analyseComplexValue", function() {
    return analyseComplexValue;
});
parcelHelpers.export(exports, "complex", function() {
    return complex;
});
var _indexMjs = require("../color/index.mjs");
var _colorRegexMjs = require("../utils/color-regex.mjs");
var _floatRegexMjs = require("../utils/float-regex.mjs");
var _sanitizeMjs = require("../utils/sanitize.mjs");
function test(v) {
    var _v_match, _v_match1;
    return isNaN(v) && typeof v === "string" && (((_v_match = v.match((0, _floatRegexMjs.floatRegex))) === null || _v_match === void 0 ? void 0 : _v_match.length) || 0) + (((_v_match1 = v.match((0, _colorRegexMjs.colorRegex))) === null || _v_match1 === void 0 ? void 0 : _v_match1.length) || 0) > 0;
}
var NUMBER_TOKEN = "number";
var COLOR_TOKEN = "color";
var VAR_TOKEN = "var";
var VAR_FUNCTION_TOKEN = "var(";
var SPLIT_TOKEN = "${}";
// this regex consists of the `singleCssVariableRegex|rgbHSLValueRegex|digitRegex`
var complexRegex = RegExp("var\\s*\\(\\s*--(?:[\\w-]+\\s*|[\\w-]+\\s*,(?:\\s*[^)(\\s]|\\s*\\((?:[^)(]|\\([^)(]*\\))*\\))+\\s*)\\)|#[\\da-f]{3,8}|(?:rgb|hsl)a?\\((?:-?[\\d.]+%?[,\\s]+){2}-?[\\d.]+%?\\s*(?:[,/]\\s*)?(?:\\b\\d+(?:\\.\\d+)?|\\.\\d+)?%?\\)|-?(?:\\d+(?:\\.\\d+)?|\\.\\d+)", "giu");
function analyseComplexValue(value) {
    var originalValue = value.toString();
    var values = [];
    var indexes = {
        color: [],
        number: [],
        var: []
    };
    var types = [];
    var i = 0;
    var tokenised = originalValue.replace(complexRegex, function(parsedValue) {
        if ((0, _indexMjs.color).test(parsedValue)) {
            indexes.color.push(i);
            types.push(COLOR_TOKEN);
            values.push((0, _indexMjs.color).parse(parsedValue));
        } else if (parsedValue.startsWith(VAR_FUNCTION_TOKEN)) {
            indexes.var.push(i);
            types.push(VAR_TOKEN);
            values.push(parsedValue);
        } else {
            indexes.number.push(i);
            types.push(NUMBER_TOKEN);
            values.push(parseFloat(parsedValue));
        }
        ++i;
        return SPLIT_TOKEN;
    });
    var split = tokenised.split(SPLIT_TOKEN);
    return {
        values: values,
        split: split,
        indexes: indexes,
        types: types
    };
}
function parseComplexValue(v) {
    return analyseComplexValue(v).values;
}
function buildTransformer(param) {
    var split = param.split, types = param.types;
    var numSections = split.length;
    return function(v) {
        var output = "";
        for(var i = 0; i < numSections; i++){
            output += split[i];
            if (v[i] !== undefined) {
                var type = types[i];
                if (type === NUMBER_TOKEN) output += (0, _sanitizeMjs.sanitize)(v[i]);
                else if (type === COLOR_TOKEN) output += (0, _indexMjs.color).transform(v[i]);
                else output += v[i];
            }
        }
        return output;
    };
}
function createTransformer(source) {
    return buildTransformer(analyseComplexValue(source));
}
var convertNumbersToZero = function(v) {
    return typeof v === "number" ? 0 : (0, _indexMjs.color).test(v) ? (0, _indexMjs.color).getAnimatableNone(v) : v;
};
/**
 * Convert a parsed value to its zero equivalent, but preserve numbers
 * that act as divisors in CSS calc() expressions.
 *
 * analyseComplexValue extracts numbers from CSS strings and puts the
 * surrounding text into a `split` template array. For example:
 *   "calc(var(--gap) / 5)"  →  values: [var(--gap), 5]
 *                               split:  ["calc(", " / ", ")"]
 *
 * When building a zero-equivalent for animation, naively zeroing all
 * numbers turns the divisor into 0 → "calc(var(--gap) / 0)" → NaN.
 * We detect this by checking whether the text preceding a number
 * (split[i]) ends with "/" — the CSS calc division operator.
 */ var convertToZero = function(value, splitBefore) {
    if (typeof value === "number") return (splitBefore === null || splitBefore === void 0 ? void 0 : splitBefore.trim().endsWith("/")) ? value : 0;
    return convertNumbersToZero(value);
};
function getAnimatableNone(v) {
    var info = analyseComplexValue(v);
    var transformer = buildTransformer(info);
    return transformer(info.values.map(function(value, i) {
        return convertToZero(value, info.split[i]);
    }));
}
var complex = {
    test: test,
    parse: parseComplexValue,
    createTransformer: createTransformer,
    getAnimatableNone: getAnimatableNone
};

},{"../color/index.mjs":"gbu7c","../utils/color-regex.mjs":"5mA6n","../utils/float-regex.mjs":"1DShP","../utils/sanitize.mjs":"cYIBx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5mA6n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "colorRegex", function() {
    return colorRegex;
});
var colorRegex = RegExp("(?:#[\\da-f]{3,8}|(?:rgb|hsl)a?\\((?:-?[\\d.]+%?[,\\s]+){2}-?[\\d.]+%?\\s*(?:[,/]\\s*)?(?:\\b\\d+(?:\\.\\d+)?|\\.\\d+)?%?\\))", "giu");

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9UUUz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mixColor", function() {
    return mixColor;
});
parcelHelpers.export(exports, "mixLinearColor", function() {
    return mixLinearColor;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _motionUtils = require("motion-utils");
var _hexMjs = require("../../value/types/color/hex.mjs");
var _hslaMjs = require("../../value/types/color/hsla.mjs");
var _hslaToRgbaMjs = require("../../value/types/color/hsla-to-rgba.mjs");
var _rgbaMjs = require("../../value/types/color/rgba.mjs");
var _immediateMjs = require("./immediate.mjs");
var _numberMjs = require("./number.mjs");
// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
var mixLinearColor = function(from, to, v) {
    var fromExpo = from * from;
    var expo = v * (to * to - fromExpo) + fromExpo;
    return expo < 0 ? 0 : Math.sqrt(expo);
};
var colorTypes = [
    (0, _hexMjs.hex),
    (0, _rgbaMjs.rgba),
    (0, _hslaMjs.hsla)
];
var getColorType = function(v) {
    return colorTypes.find(function(type) {
        return type.test(v);
    });
};
function asRGBA(color) {
    var type = getColorType(color);
    (0, _motionUtils.warning)(Boolean(type), "'".concat(color, "' is not an animatable color. Use the equivalent color code instead."), "color-not-animatable");
    if (!Boolean(type)) return false;
    var model = type.parse(color);
    if (type === (0, _hslaMjs.hsla)) // TODO Remove this cast - needed since Motion's stricter typing
    model = (0, _hslaToRgbaMjs.hslaToRgba)(model);
    return model;
}
var mixColor = function(from, to) {
    var fromRGBA = asRGBA(from);
    var toRGBA = asRGBA(to);
    if (!fromRGBA || !toRGBA) return (0, _immediateMjs.mixImmediate)(from, to);
    var blended = (0, _objectSpread._)({}, fromRGBA);
    return function(v) {
        blended.red = mixLinearColor(fromRGBA.red, toRGBA.red, v);
        blended.green = mixLinearColor(fromRGBA.green, toRGBA.green, v);
        blended.blue = mixLinearColor(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, _numberMjs.mixNumber)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, _rgbaMjs.rgba).transform(blended);
    };
};

},{"@swc/helpers/_/_object_spread":"9gdrV","motion-utils":"9Q5qC","../../value/types/color/hex.mjs":"fmT9b","../../value/types/color/hsla.mjs":"8tWc0","../../value/types/color/hsla-to-rgba.mjs":"8H6LK","../../value/types/color/rgba.mjs":"5eamO","./immediate.mjs":"3HHoi","./number.mjs":"j0eyN","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8H6LK":[function(require,module,exports,__globalThis) {
// Adapted from https://gist.github.com/mjackson/5311256
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hslaToRgba", function() {
    return hslaToRgba;
});
function hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function hslaToRgba(param) {
    var hue = param.hue, saturation = param.saturation, lightness = param.lightness, alpha = param.alpha;
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    var red = 0;
    var green = 0;
    var blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        var q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        var p = 2 * lightness - q;
        red = hueToRgb(p, q, hue + 1 / 3);
        green = hueToRgb(p, q, hue);
        blue = hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3HHoi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mixImmediate", function() {
    return mixImmediate;
});
function mixImmediate(a, b) {
    return function(p) {
        return p > 0 ? b : a;
    };
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"j0eyN":[function(require,module,exports,__globalThis) {
/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mixNumber", function() {
    return mixNumber;
});
var mixNumber = function(from, to, progress) {
    return from + (to - from) * progress;
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kGlHI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "invisibleValues", function() {
    return invisibleValues;
});
parcelHelpers.export(exports, "mixVisibility", function() {
    return mixVisibility;
});
var invisibleValues = new Set([
    "none",
    "hidden"
]);
/**
 * Returns a function that, when provided a progress value between 0 and 1,
 * will return the "none" or "hidden" string only when the progress is that of
 * the origin or target.
 */ function mixVisibility(origin, target) {
    if (invisibleValues.has(origin)) return function(p) {
        return p <= 0 ? origin : target;
    };
    else return function(p) {
        return p >= 1 ? target : origin;
    };
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"d5msi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "frameloopDriver", function() {
    return frameloopDriver;
});
var _syncTimeMjs = require("../../frameloop/sync-time.mjs");
var _frameMjs = require("../../frameloop/frame.mjs");
var frameloopDriver = function(update) {
    var passTimestamp = function(param) {
        var timestamp = param.timestamp;
        return update(timestamp);
    };
    return {
        start: function() {
            var keepAlive = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
            return (0, _frameMjs.frame).update(passTimestamp, keepAlive);
        },
        stop: function() {
            return (0, _frameMjs.cancelFrame)(passTimestamp);
        },
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: function() {
            return (0, _frameMjs.frameData).isProcessing ? (0, _frameMjs.frameData).timestamp : (0, _syncTimeMjs.time).now();
        }
    };
};

},{"../../frameloop/sync-time.mjs":"aPTZo","../../frameloop/frame.mjs":"lxQZr","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fSjpI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "inertia", function() {
    return inertia;
});
var _springMjs = require("./spring.mjs");
var _velocityMjs = require("./utils/velocity.mjs");
function inertia(param) {
    var keyframes = param.keyframes, _param_velocity = param.velocity, velocity = _param_velocity === void 0 ? 0.0 : _param_velocity, _param_power = param.power, power = _param_power === void 0 ? 0.8 : _param_power, _param_timeConstant = param.timeConstant, timeConstant = _param_timeConstant === void 0 ? 325 : _param_timeConstant, _param_bounceDamping = param.bounceDamping, bounceDamping = _param_bounceDamping === void 0 ? 10 : _param_bounceDamping, _param_bounceStiffness = param.bounceStiffness, bounceStiffness = _param_bounceStiffness === void 0 ? 500 : _param_bounceStiffness, modifyTarget = param.modifyTarget, min = param.min, max = param.max, _param_restDelta = param.restDelta, restDelta = _param_restDelta === void 0 ? 0.5 : _param_restDelta, restSpeed = param.restSpeed;
    var origin = keyframes[0];
    var state = {
        done: false,
        value: origin
    };
    var isOutOfBounds = function(v) {
        return min !== undefined && v < min || max !== undefined && v > max;
    };
    var nearestBoundary = function(v) {
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    var amplitude = power * velocity;
    var ideal = origin + amplitude;
    var target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    var calcDelta = function(t) {
        return -amplitude * Math.exp(-t / timeConstant);
    };
    var calcLatest = function(t) {
        return target + calcDelta(t);
    };
    var applyFriction = function(t) {
        var delta = calcDelta(t);
        var latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ var timeReachedBoundary;
    var spring$1;
    var checkCatchBoundary = function(t) {
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, _springMjs.spring)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, _velocityMjs.getGeneratorVelocity)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: function(t) {
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ var hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t >= timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}

},{"./spring.mjs":"dB8Sj","./utils/velocity.mjs":"i231k","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dB8Sj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "spring", function() {
    return spring;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _typeOf = require("@swc/helpers/_/_type_of");
var _motionUtils = require("motion-utils");
var _linearMjs = require("../waapi/utils/linear.mjs");
var _calcDurationMjs = require("./utils/calc-duration.mjs");
var _createGeneratorEasingMjs = require("./utils/create-generator-easing.mjs");
var springDefaults = {
    // Default spring physics
    stiffness: 100,
    damping: 10,
    mass: 1.0,
    velocity: 0.0,
    // Default duration/bounce-based options
    duration: 800,
    bounce: 0.3,
    visualDuration: 0.3,
    // Rest thresholds
    restSpeed: {
        granular: 0.01,
        default: 2
    },
    restDelta: {
        granular: 0.005,
        default: 0.5
    },
    // Limits
    minDuration: 0.01,
    maxDuration: 10.0,
    minDamping: 0.05,
    maxDamping: 1
};
function calcAngularFreq(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}
var rootIterations = 12;
function approximateRoot(envelope, derivative, initialGuess) {
    var result = initialGuess;
    for(var i = 1; i < rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
/**
 * This is ported from the Framer implementation of duration-based spring resolution.
 */ var safeMin = 0.001;
function findSpring(param) {
    var _param_duration = param.duration, duration = _param_duration === void 0 ? springDefaults.duration : _param_duration, _param_bounce = param.bounce, bounce = _param_bounce === void 0 ? springDefaults.bounce : _param_bounce, _param_velocity = param.velocity, velocity = _param_velocity === void 0 ? springDefaults.velocity : _param_velocity, _param_mass = param.mass, mass = _param_mass === void 0 ? springDefaults.mass : _param_mass;
    var envelope;
    var derivative;
    (0, _motionUtils.warning)(duration <= (0, _motionUtils.secondsToMilliseconds)(springDefaults.maxDuration), "Spring duration must be 10 seconds or less", "spring-duration-limit");
    var dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, _motionUtils.clamp)(springDefaults.minDamping, springDefaults.maxDamping, dampingRatio);
    duration = (0, _motionUtils.clamp)(springDefaults.minDuration, springDefaults.maxDuration, (0, _motionUtils.millisecondsToSeconds)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = function(undampedFreq) {
            var exponentialDecay = undampedFreq * dampingRatio;
            var delta = exponentialDecay * duration;
            var a = exponentialDecay - velocity;
            var b = calcAngularFreq(undampedFreq, dampingRatio);
            var c = Math.exp(-delta);
            return safeMin - a / b * c;
        };
        derivative = function(undampedFreq) {
            var exponentialDecay = undampedFreq * dampingRatio;
            var delta = exponentialDecay * duration;
            var d = delta * velocity + velocity;
            var e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            var f = Math.exp(-delta);
            var g = calcAngularFreq(Math.pow(undampedFreq, 2), dampingRatio);
            var factor = -envelope(undampedFreq) + safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = function(undampedFreq) {
            var a = Math.exp(-undampedFreq * duration);
            var b = (undampedFreq - velocity) * duration + 1;
            return -safeMin + a * b;
        };
        derivative = function(undampedFreq) {
            var a = Math.exp(-undampedFreq * duration);
            var b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    var initialGuess = 5 / duration;
    var undampedFreq = approximateRoot(envelope, derivative, initialGuess);
    duration = (0, _motionUtils.secondsToMilliseconds)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: springDefaults.stiffness,
        damping: springDefaults.damping,
        duration: duration
    };
    else {
        var stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
var durationKeys = [
    "duration",
    "bounce"
];
var physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function isSpringType(options, keys) {
    return keys.some(function(key) {
        return options[key] !== undefined;
    });
}
function getSpringOptions(options) {
    var springOptions = (0, _objectSpread._)({
        velocity: springDefaults.velocity,
        stiffness: springDefaults.stiffness,
        damping: springDefaults.damping,
        mass: springDefaults.mass,
        isResolvedFromDuration: false
    }, options);
    // stiffness/damping/mass overrides duration/bounce
    if (!isSpringType(options, physicsKeys) && isSpringType(options, durationKeys)) {
        // Time-defined springs should ignore inherited velocity.
        // Velocity from interrupted animations can cause findSpring()
        // to compute wildly different spring parameters, leading to
        // massive oscillation on small-range animations.
        springOptions.velocity = 0;
        if (options.visualDuration) {
            var visualDuration = options.visualDuration;
            var root = 2 * Math.PI / (visualDuration * 1.2);
            var stiffness = root * root;
            var damping = 2 * (0, _motionUtils.clamp)(0.05, 1, 1 - (options.bounce || 0)) * Math.sqrt(stiffness);
            springOptions = (0, _objectSpreadProps._)((0, _objectSpread._)({}, springOptions), {
                mass: springDefaults.mass,
                stiffness: stiffness,
                damping: damping
            });
        } else {
            var derived = findSpring((0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
                velocity: 0
            }));
            springOptions = (0, _objectSpreadProps._)((0, _objectSpread._)({}, springOptions, derived), {
                mass: springDefaults.mass
            });
            springOptions.isResolvedFromDuration = true;
        }
    }
    return springOptions;
}
function spring() {
    var optionsOrVisualDuration = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : springDefaults.visualDuration, bounce = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : springDefaults.bounce;
    var options = (typeof optionsOrVisualDuration === "undefined" ? "undefined" : (0, _typeOf._)(optionsOrVisualDuration)) !== "object" ? {
        visualDuration: optionsOrVisualDuration,
        keyframes: [
            0,
            1
        ],
        bounce: bounce
    } : optionsOrVisualDuration;
    var restSpeed = options.restSpeed, restDelta = options.restDelta;
    var origin = options.keyframes[0];
    var target = options.keyframes[options.keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ var state = {
        done: false,
        value: origin
    };
    var _getSpringOptions = getSpringOptions((0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
        velocity: -(0, _motionUtils.millisecondsToSeconds)(options.velocity || 0)
    })), stiffness = _getSpringOptions.stiffness, damping = _getSpringOptions.damping, mass = _getSpringOptions.mass, duration = _getSpringOptions.duration, velocity = _getSpringOptions.velocity, isResolvedFromDuration = _getSpringOptions.isResolvedFromDuration;
    var initialVelocity = velocity || 0.0;
    var dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    var initialDelta = target - origin;
    var undampedAngularFreq = (0, _motionUtils.millisecondsToSeconds)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ var isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? springDefaults.restSpeed.granular : springDefaults.restSpeed.default);
    restDelta || (restDelta = isGranularScale ? springDefaults.restDelta.granular : springDefaults.restDelta.default);
    var resolveSpring;
    var resolveVelocity;
    // Underdamped coefficients, hoisted for use in the inlined next() hot path
    var angularFreq;
    var A;
    var sinCoeff;
    var cosCoeff;
    if (dampingRatio < 1) {
        angularFreq = calcAngularFreq(undampedAngularFreq, dampingRatio);
        A = (initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq;
        // Underdamped spring
        resolveSpring = function(t) {
            var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * (A * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
        // Analytical derivative of underdamped spring (px/ms)
        sinCoeff = dampingRatio * undampedAngularFreq * A + initialDelta * angularFreq;
        cosCoeff = dampingRatio * undampedAngularFreq * initialDelta - A * angularFreq;
        resolveVelocity = function(t) {
            var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return envelope * (sinCoeff * Math.sin(angularFreq * t) + cosCoeff * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) {
        // Critically damped spring
        resolveSpring = function(t) {
            return target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
        };
        // Analytical derivative of critically damped spring (px/ms)
        var C = initialVelocity + undampedAngularFreq * initialDelta;
        resolveVelocity = function(t) {
            return Math.exp(-undampedAngularFreq * t) * (undampedAngularFreq * C * t - initialVelocity);
        };
    } else {
        // Overdamped spring
        var dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = function(t) {
            var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            var freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
        // Analytical derivative of overdamped spring (px/ms)
        var P = (initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / dampedAngularFreq;
        var sinhCoeff = dampingRatio * undampedAngularFreq * P - initialDelta * dampedAngularFreq;
        var coshCoeff = dampingRatio * undampedAngularFreq * initialDelta - P * dampedAngularFreq;
        resolveVelocity = function(t) {
            var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            var freqForT = Math.min(dampedAngularFreq * t, 300);
            return envelope * (sinhCoeff * Math.sinh(freqForT) + coshCoeff * Math.cosh(freqForT));
        };
    }
    var generator = {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        velocity: function(t) {
            return (0, _motionUtils.secondsToMilliseconds)(resolveVelocity(t));
        },
        next: function(t) {
            /**
             * For underdamped physics springs we need both position and
             * velocity each tick. Compute shared trig values once to avoid
             * duplicate Math.exp/sin/cos calls on the hot path.
             */ if (!isResolvedFromDuration && dampingRatio < 1) {
                var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                var sin = Math.sin(angularFreq * t);
                var cos = Math.cos(angularFreq * t);
                var current = target - envelope * (A * sin + initialDelta * cos);
                var currentVelocity = (0, _motionUtils.secondsToMilliseconds)(envelope * (sinCoeff * sin + cosCoeff * cos));
                state.done = Math.abs(currentVelocity) <= restSpeed && Math.abs(target - current) <= restDelta;
                state.value = state.done ? target : current;
                return state;
            }
            var current1 = resolveSpring(t);
            if (!isResolvedFromDuration) {
                var currentVelocity1 = (0, _motionUtils.secondsToMilliseconds)(resolveVelocity(t));
                state.done = Math.abs(currentVelocity1) <= restSpeed && Math.abs(target - current1) <= restDelta;
            } else state.done = t >= duration;
            state.value = state.done ? target : current1;
            return state;
        },
        toString: function() {
            var calculatedDuration = Math.min((0, _calcDurationMjs.calcGeneratorDuration)(generator), (0, _calcDurationMjs.maxGeneratorDuration));
            var easing = (0, _linearMjs.generateLinearEasing)(function(progress) {
                return generator.next(calculatedDuration * progress).value;
            }, calculatedDuration, 30);
            return calculatedDuration + "ms " + easing;
        },
        toTransition: function() {}
    };
    return generator;
}
spring.applyToOptions = function(options) {
    var generatorOptions = (0, _createGeneratorEasingMjs.createGeneratorEasing)(options, 100, spring);
    options.ease = generatorOptions.ease;
    options.duration = (0, _motionUtils.secondsToMilliseconds)(generatorOptions.duration);
    options.type = "keyframes";
    return options;
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_type_of":"iFJdx","motion-utils":"9Q5qC","../waapi/utils/linear.mjs":"6RXsU","./utils/calc-duration.mjs":"hyydG","./utils/create-generator-easing.mjs":"g9gdi","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6RXsU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateLinearEasing", function() {
    return generateLinearEasing;
});
var generateLinearEasing = function(easing, duration) {
    var resolution = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 10 // as milliseconds
    ;
    var points = "";
    var numPoints = Math.max(Math.round(duration / resolution), 2);
    for(var i = 0; i < numPoints; i++)points += Math.round(easing(i / (numPoints - 1)) * 10000) / 10000 + ", ";
    return "linear(".concat(points.substring(0, points.length - 2), ")");
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hyydG":[function(require,module,exports,__globalThis) {
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calcGeneratorDuration", function() {
    return calcGeneratorDuration;
});
parcelHelpers.export(exports, "maxGeneratorDuration", function() {
    return maxGeneratorDuration;
});
var maxGeneratorDuration = 20000;
function calcGeneratorDuration(generator) {
    var duration = 0;
    var timeStep = 50;
    var state = generator.next(duration);
    while(!state.done && duration < maxGeneratorDuration){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= maxGeneratorDuration ? Infinity : duration;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"g9gdi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createGeneratorEasing", function() {
    return createGeneratorEasing;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _motionUtils = require("motion-utils");
var _calcDurationMjs = require("./calc-duration.mjs");
/**
 * Create a progress => progress easing function from a generator.
 */ function createGeneratorEasing(options) {
    var scale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100, createGenerator = arguments.length > 2 ? arguments[2] : void 0;
    var generator = createGenerator((0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
        keyframes: [
            0,
            scale
        ]
    }));
    var duration = Math.min((0, _calcDurationMjs.calcGeneratorDuration)(generator), (0, _calcDurationMjs.maxGeneratorDuration));
    return {
        type: "keyframes",
        ease: function(progress) {
            return generator.next(duration * progress).value / scale;
        },
        duration: (0, _motionUtils.millisecondsToSeconds)(duration)
    };
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","motion-utils":"9Q5qC","./calc-duration.mjs":"hyydG","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"i231k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getGeneratorVelocity", function() {
    return getGeneratorVelocity;
});
var _motionUtils = require("motion-utils");
var velocitySampleDuration = 5; // ms
function getGeneratorVelocity(resolveValue, t, current) {
    var prevT = Math.max(t - velocitySampleDuration, 0);
    return (0, _motionUtils.velocityPerSecond)(current - resolveValue(prevT), t - prevT);
}

},{"motion-utils":"9Q5qC","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"heVZz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultEasing", function() {
    return defaultEasing;
});
parcelHelpers.export(exports, "keyframes", function() {
    return keyframes;
});
var _motionUtils = require("motion-utils");
var _interpolateMjs = require("../../utils/interpolate.mjs");
var _defaultMjs = require("../keyframes/offsets/default.mjs");
var _timeMjs = require("../keyframes/offsets/time.mjs");
function defaultEasing(values, easing) {
    return values.map(function() {
        return easing || (0, _motionUtils.easeInOut);
    }).splice(0, values.length - 1);
}
function keyframes(param) {
    var _param_duration = param.duration, duration = _param_duration === void 0 ? 300 : _param_duration, keyframeValues = param.keyframes, times = param.times, _param_ease = param.ease, ease = _param_ease === void 0 ? "easeInOut" : _param_ease;
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ var easingFunctions = (0, _motionUtils.isEasingArray)(ease) ? ease.map((0, _motionUtils.easingDefinitionToFunction)) : (0, _motionUtils.easingDefinitionToFunction)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ var state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ var absoluteTimes = (0, _timeMjs.convertOffsetToTimes)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, _defaultMjs.defaultOffset)(keyframeValues), duration);
    var mapTimeToKeyframe = (0, _interpolateMjs.interpolate)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : defaultEasing(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: function(t) {
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}

},{"motion-utils":"9Q5qC","../../utils/interpolate.mjs":"c1Uzm","../keyframes/offsets/default.mjs":"aLlnz","../keyframes/offsets/time.mjs":"j3GiE","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"c1Uzm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "interpolate", function() {
    return interpolate;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _motionUtils = require("motion-utils");
var _indexMjs = require("./mix/index.mjs");
function createMixers(output, ease, customMixer) {
    var mixers = [];
    var mixerFactory = customMixer || (0, _motionUtils.MotionGlobalConfig).mix || (0, _indexMjs.mix);
    var numMixers = output.length - 1;
    for(var i = 0; i < numMixers; i++){
        var mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            var easingFunction = Array.isArray(ease) ? ease[i] || (0, _motionUtils.noop) : ease;
            mixer = (0, _motionUtils.pipe)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revisit this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function interpolate(input, output) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, tmp = _ref.clamp, isClamp = tmp === void 0 ? true : tmp, ease = _ref.ease, mixer = _ref.mixer;
    var inputLength = input.length;
    (0, _motionUtils.invariant)(inputLength === output.length, "Both input and output ranges must be the same length", "range-length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return function() {
        return output[0];
    };
    if (inputLength === 2 && output[0] === output[1]) return function() {
        return output[1];
    };
    var isZeroDeltaRange = input[0] === input[1];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = (0, _toConsumableArray._)(input).reverse();
        output = (0, _toConsumableArray._)(output).reverse();
    }
    var mixers = createMixers(output, ease, mixer);
    var numMixers = mixers.length;
    var interpolator = function(v) {
        if (isZeroDeltaRange && v < input[0]) return output[0];
        var i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        var progressInRange = (0, _motionUtils.progress)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? function(v) {
        return interpolator((0, _motionUtils.clamp)(input[0], input[inputLength - 1], v));
    } : interpolator;
}

},{"@swc/helpers/_/_to_consumable_array":"1eSZf","motion-utils":"9Q5qC","./mix/index.mjs":"gnOe8","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aLlnz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultOffset", function() {
    return defaultOffset;
});
var _fillMjs = require("./fill.mjs");
function defaultOffset(arr) {
    var offset = [
        0
    ];
    (0, _fillMjs.fillOffset)(offset, arr.length - 1);
    return offset;
}

},{"./fill.mjs":"7PYPn","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7PYPn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fillOffset", function() {
    return fillOffset;
});
var _motionUtils = require("motion-utils");
var _numberMjs = require("../../../utils/mix/number.mjs");
function fillOffset(offset, remaining) {
    var min = offset[offset.length - 1];
    for(var i = 1; i <= remaining; i++){
        var offsetProgress = (0, _motionUtils.progress)(0, remaining, i);
        offset.push((0, _numberMjs.mixNumber)(min, 1, offsetProgress));
    }
}

},{"motion-utils":"9Q5qC","../../../utils/mix/number.mjs":"j0eyN","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"j3GiE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "convertOffsetToTimes", function() {
    return convertOffsetToTimes;
});
function convertOffsetToTimes(offset, duration) {
    return offset.map(function(o) {
        return o * duration;
    });
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hAUAJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFinalKeyframe", function() {
    return getFinalKeyframe;
});
var isNotNull = function(value) {
    return value !== null;
};
function getFinalKeyframe(keyframes, param, finalKeyframe) {
    var repeat = param.repeat, _param_repeatType = param.repeatType, repeatType = _param_repeatType === void 0 ? "loop" : _param_repeatType, speed = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
    var resolvedKeyframes = keyframes.filter(isNotNull);
    var useFirstKeyframe = speed < 0 || repeat && repeatType !== "loop" && repeat % 2 === 1;
    var index = useFirstKeyframe ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1PTe1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "replaceTransitionType", function() {
    return replaceTransitionType;
});
var _inertiaMjs = require("../generators/inertia.mjs");
var _keyframesMjs = require("../generators/keyframes.mjs");
var _springMjs = require("../generators/spring.mjs");
var transitionTypeMap = {
    decay: (0, _inertiaMjs.inertia),
    inertia: (0, _inertiaMjs.inertia),
    tween: (0, _keyframesMjs.keyframes),
    keyframes: (0, _keyframesMjs.keyframes),
    spring: (0, _springMjs.spring)
};
function replaceTransitionType(transition) {
    if (typeof transition.type === "string") transition.type = transitionTypeMap[transition.type];
}

},{"../generators/inertia.mjs":"fSjpI","../generators/keyframes.mjs":"heVZz","../generators/spring.mjs":"dB8Sj","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jEvnC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WithPromise", function() {
    return WithPromise;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var WithPromise = /*#__PURE__*/ function() {
    "use strict";
    function WithPromise() {
        (0, _classCallCheck._)(this, WithPromise);
        this.updateFinished();
    }
    (0, _createClass._)(WithPromise, [
        {
            key: "finished",
            get: function get() {
                return this._finished;
            }
        },
        {
            key: "updateFinished",
            value: function updateFinished() {
                var _this = this;
                this._finished = new Promise(function(resolve) {
                    _this.resolve = resolve;
                });
            }
        },
        {
            key: "notifyFinished",
            value: function notifyFinished() {
                this.resolve();
            }
        },
        {
            /**
     * Allows the animation to be awaited.
     *
     * @deprecated Use `finished` instead.
     */ key: "then",
            value: function then(onResolve, onReject) {
                return this.finished.then(onResolve, onReject);
            }
        }
    ]);
    return WithPromise;
}();

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aeJtq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "KeyframeResolver", function() {
    return KeyframeResolver;
});
parcelHelpers.export(exports, "flushKeyframeResolvers", function() {
    return flushKeyframeResolvers;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _fillWildcardsMjs = require("./utils/fill-wildcards.mjs");
var _unitConversionMjs = require("./utils/unit-conversion.mjs");
var _frameMjs = require("../../frameloop/frame.mjs");
var toResolve = new Set();
var isScheduled = false;
var anyNeedsMeasurement = false;
var isForced = false;
function measureAllKeyframes() {
    if (anyNeedsMeasurement) {
        var resolversToMeasure = Array.from(toResolve).filter(function(resolver) {
            return resolver.needsMeasurement;
        });
        var elementsToMeasure = new Set(resolversToMeasure.map(function(resolver) {
            return resolver.element;
        }));
        var transformsToRestore = new Map();
        /**
         * Write pass
         * If we're measuring elements we want to remove bounding box-changing transforms.
         */ elementsToMeasure.forEach(function(element) {
            var removedTransforms = (0, _unitConversionMjs.removeNonTranslationalTransform)(element);
            if (!removedTransforms.length) return;
            transformsToRestore.set(element, removedTransforms);
            element.render();
        });
        // Read
        resolversToMeasure.forEach(function(resolver) {
            return resolver.measureInitialState();
        });
        // Write
        elementsToMeasure.forEach(function(element) {
            element.render();
            var restore = transformsToRestore.get(element);
            if (restore) restore.forEach(function(param) {
                var _param = (0, _slicedToArray._)(param, 2), key = _param[0], value = _param[1];
                var _element_getValue;
                (_element_getValue = element.getValue(key)) === null || _element_getValue === void 0 ? void 0 : _element_getValue.set(value);
            });
        });
        // Read
        resolversToMeasure.forEach(function(resolver) {
            return resolver.measureEndState();
        });
        // Write
        resolversToMeasure.forEach(function(resolver) {
            if (resolver.suspendedScrollY !== undefined) window.scrollTo(0, resolver.suspendedScrollY);
        });
    }
    anyNeedsMeasurement = false;
    isScheduled = false;
    toResolve.forEach(function(resolver) {
        return resolver.complete(isForced);
    });
    toResolve.clear();
}
function readAllKeyframes() {
    toResolve.forEach(function(resolver) {
        resolver.readKeyframes();
        if (resolver.needsMeasurement) anyNeedsMeasurement = true;
    });
}
function flushKeyframeResolvers() {
    isForced = true;
    readAllKeyframes();
    measureAllKeyframes();
    isForced = false;
}
var KeyframeResolver = /*#__PURE__*/ function() {
    "use strict";
    function KeyframeResolver(unresolvedKeyframes, onComplete, name, motionValue, element) {
        var isAsync = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
        (0, _classCallCheck._)(this, KeyframeResolver);
        this.state = "pending";
        /**
         * Track whether this resolver is async. If it is, it'll be added to the
         * resolver queue and flushed in the next frame. Resolvers that aren't going
         * to trigger read/write thrashing don't need to be async.
         */ this.isAsync = false;
        /**
         * Track whether this resolver needs to perform a measurement
         * to resolve its keyframes.
         */ this.needsMeasurement = false;
        this.unresolvedKeyframes = (0, _toConsumableArray._)(unresolvedKeyframes);
        this.onComplete = onComplete;
        this.name = name;
        this.motionValue = motionValue;
        this.element = element;
        this.isAsync = isAsync;
    }
    (0, _createClass._)(KeyframeResolver, [
        {
            key: "scheduleResolve",
            value: function scheduleResolve() {
                this.state = "scheduled";
                if (this.isAsync) {
                    toResolve.add(this);
                    if (!isScheduled) {
                        isScheduled = true;
                        (0, _frameMjs.frame).read(readAllKeyframes);
                        (0, _frameMjs.frame).resolveKeyframes(measureAllKeyframes);
                    }
                } else {
                    this.readKeyframes();
                    this.complete();
                }
            }
        },
        {
            key: "readKeyframes",
            value: function readKeyframes() {
                var _this = this, unresolvedKeyframes = _this.unresolvedKeyframes, name = _this.name, element = _this.element, motionValue = _this.motionValue;
                // If initial keyframe is null we need to read it from the DOM
                if (unresolvedKeyframes[0] === null) {
                    var currentValue = motionValue === null || motionValue === void 0 ? void 0 : motionValue.get();
                    // TODO: This doesn't work if the final keyframe is a wildcard
                    var finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
                    if (currentValue !== undefined) unresolvedKeyframes[0] = currentValue;
                    else if (element && name) {
                        var valueAsRead = element.readValue(name, finalKeyframe);
                        if (valueAsRead !== undefined && valueAsRead !== null) unresolvedKeyframes[0] = valueAsRead;
                    }
                    if (unresolvedKeyframes[0] === undefined) unresolvedKeyframes[0] = finalKeyframe;
                    if (motionValue && currentValue === undefined) motionValue.set(unresolvedKeyframes[0]);
                }
                (0, _fillWildcardsMjs.fillWildcards)(unresolvedKeyframes);
            }
        },
        {
            key: "setFinalKeyframe",
            value: function setFinalKeyframe() {}
        },
        {
            key: "measureInitialState",
            value: function measureInitialState() {}
        },
        {
            key: "renderEndStyles",
            value: function renderEndStyles() {}
        },
        {
            key: "measureEndState",
            value: function measureEndState() {}
        },
        {
            key: "complete",
            value: function complete() {
                var isForcedComplete = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                this.state = "complete";
                this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, isForcedComplete);
                toResolve.delete(this);
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                if (this.state === "scheduled") {
                    toResolve.delete(this);
                    this.state = "pending";
                }
            }
        },
        {
            key: "resume",
            value: function resume() {
                if (this.state === "pending") this.scheduleResolve();
            }
        }
    ]);
    return KeyframeResolver;
}();

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_to_consumable_array":"1eSZf","./utils/fill-wildcards.mjs":"9HhRp","./utils/unit-conversion.mjs":"bpxYX","../../frameloop/frame.mjs":"lxQZr","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9HhRp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fillWildcards", function() {
    return fillWildcards;
});
function fillWildcards(keyframes) {
    var _keyframes_i;
    for(var i = 1; i < keyframes.length; i++)(_keyframes_i = keyframes[i]) !== null && _keyframes_i !== void 0 ? _keyframes_i : keyframes[i] = keyframes[i - 1];
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bpxYX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNumOrPxType", function() {
    return isNumOrPxType;
});
parcelHelpers.export(exports, "positionalValues", function() {
    return positionalValues;
});
parcelHelpers.export(exports, "removeNonTranslationalTransform", function() {
    return removeNonTranslationalTransform;
});
var _parseTransformMjs = require("../../../render/dom/parse-transform.mjs");
var _keysTransformMjs = require("../../../render/utils/keys-transform.mjs");
var _indexMjs = require("../../../value/types/numbers/index.mjs");
var _unitsMjs = require("../../../value/types/numbers/units.mjs");
var isNumOrPxType = function(v) {
    return v === (0, _indexMjs.number) || v === (0, _unitsMjs.px);
};
var transformKeys = new Set([
    "x",
    "y",
    "z"
]);
var nonTranslationalTransformKeys = (0, _keysTransformMjs.transformPropOrder).filter(function(key) {
    return !transformKeys.has(key);
});
function removeNonTranslationalTransform(visualElement) {
    var removedTransforms = [];
    nonTranslationalTransformKeys.forEach(function(key) {
        var value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    return removedTransforms;
}
var positionalValues = {
    // Dimensions
    width: function(param, param1) {
        var x = param.x, _param_paddingLeft = param1.paddingLeft, paddingLeft = _param_paddingLeft === void 0 ? "0" : _param_paddingLeft, _param_paddingRight = param1.paddingRight, paddingRight = _param_paddingRight === void 0 ? "0" : _param_paddingRight, boxSizing = param1.boxSizing;
        var width = x.max - x.min;
        return boxSizing === "border-box" ? width : width - parseFloat(paddingLeft) - parseFloat(paddingRight);
    },
    height: function(param, param1) {
        var y = param.y, _param_paddingTop = param1.paddingTop, paddingTop = _param_paddingTop === void 0 ? "0" : _param_paddingTop, _param_paddingBottom = param1.paddingBottom, paddingBottom = _param_paddingBottom === void 0 ? "0" : _param_paddingBottom, boxSizing = param1.boxSizing;
        var height = y.max - y.min;
        return boxSizing === "border-box" ? height : height - parseFloat(paddingTop) - parseFloat(paddingBottom);
    },
    top: function(_bbox, param) {
        var top = param.top;
        return parseFloat(top);
    },
    left: function(_bbox, param) {
        var left = param.left;
        return parseFloat(left);
    },
    bottom: function(param, param1) {
        var y = param.y, top = param1.top;
        return parseFloat(top) + (y.max - y.min);
    },
    right: function(param, param1) {
        var x = param.x, left = param1.left;
        return parseFloat(left) + (x.max - x.min);
    },
    // Transform
    x: function(_bbox, param) {
        var transform = param.transform;
        return (0, _parseTransformMjs.parseValueFromTransform)(transform, "x");
    },
    y: function(_bbox, param) {
        var transform = param.transform;
        return (0, _parseTransformMjs.parseValueFromTransform)(transform, "y");
    }
};
// Alias translate longform names
positionalValues.translateX = positionalValues.x;
positionalValues.translateY = positionalValues.y;

},{"../../../render/dom/parse-transform.mjs":"4ieLZ","../../../render/utils/keys-transform.mjs":"91lmj","../../../value/types/numbers/index.mjs":"l5BDX","../../../value/types/numbers/units.mjs":"iC5kO","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4ieLZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultTransformValue", function() {
    return defaultTransformValue;
});
parcelHelpers.export(exports, "parseValueFromTransform", function() {
    return parseValueFromTransform;
});
parcelHelpers.export(exports, "readTransformValue", function() {
    return readTransformValue;
});
var radToDeg = function(rad) {
    return rad * 180 / Math.PI;
};
var rotate = function(v) {
    var angle = radToDeg(Math.atan2(v[1], v[0]));
    return rebaseAngle(angle);
};
var matrix2dParsers = {
    x: 4,
    y: 5,
    translateX: 4,
    translateY: 5,
    scaleX: 0,
    scaleY: 3,
    scale: function(v) {
        return (Math.abs(v[0]) + Math.abs(v[3])) / 2;
    },
    rotate: rotate,
    rotateZ: rotate,
    skewX: function(v) {
        return radToDeg(Math.atan(v[1]));
    },
    skewY: function(v) {
        return radToDeg(Math.atan(v[2]));
    },
    skew: function(v) {
        return (Math.abs(v[1]) + Math.abs(v[2])) / 2;
    }
};
var rebaseAngle = function(angle) {
    angle = angle % 360;
    if (angle < 0) angle += 360;
    return angle;
};
var rotateZ = rotate;
var scaleX = function(v) {
    return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
};
var scaleY = function(v) {
    return Math.sqrt(v[4] * v[4] + v[5] * v[5]);
};
var matrix3dParsers = {
    x: 12,
    y: 13,
    z: 14,
    translateX: 12,
    translateY: 13,
    translateZ: 14,
    scaleX: scaleX,
    scaleY: scaleY,
    scale: function(v) {
        return (scaleX(v) + scaleY(v)) / 2;
    },
    rotateX: function(v) {
        return rebaseAngle(radToDeg(Math.atan2(v[6], v[5])));
    },
    rotateY: function(v) {
        return rebaseAngle(radToDeg(Math.atan2(-v[2], v[0])));
    },
    rotateZ: rotateZ,
    rotate: rotateZ,
    skewX: function(v) {
        return radToDeg(Math.atan(v[4]));
    },
    skewY: function(v) {
        return radToDeg(Math.atan(v[1]));
    },
    skew: function(v) {
        return (Math.abs(v[1]) + Math.abs(v[4])) / 2;
    }
};
function defaultTransformValue(name) {
    return name.includes("scale") ? 1 : 0;
}
function parseValueFromTransform(transform, name) {
    if (!transform || transform === "none") return defaultTransformValue(name);
    var matrix3dMatch = transform.match(RegExp("^matrix3d\\(([-\\d.e\\s,]+)\\)$", "u"));
    var parsers;
    var match;
    if (matrix3dMatch) {
        parsers = matrix3dParsers;
        match = matrix3dMatch;
    } else {
        var matrix2dMatch = transform.match(RegExp("^matrix\\(([-\\d.e\\s,]+)\\)$", "u"));
        parsers = matrix2dParsers;
        match = matrix2dMatch;
    }
    if (!match) return defaultTransformValue(name);
    var valueParser = parsers[name];
    var values = match[1].split(",").map(convertTransformToNumber);
    return typeof valueParser === "function" ? valueParser(values) : values[valueParser];
}
var readTransformValue = function(instance, name) {
    var _getComputedStyle = getComputedStyle(instance), _getComputedStyle_transform = _getComputedStyle.transform, transform = _getComputedStyle_transform === void 0 ? "none" : _getComputedStyle_transform;
    return parseValueFromTransform(transform, name);
};
function convertTransformToNumber(value) {
    return parseFloat(value.trim());
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"91lmj":[function(require,module,exports,__globalThis) {
/**
 * Generate a list of every possible transform key.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "transformPropOrder", function() {
    return transformPropOrder;
});
parcelHelpers.export(exports, "transformProps", function() {
    return transformProps;
});
var transformPropOrder = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ var transformProps = /*@__PURE__*/ function() {
    return new Set(transformPropOrder);
}();

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bgeoN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NativeAnimationExtended", function() {
    return NativeAnimationExtended;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _motionUtils = require("motion-utils");
var _syncTimeMjs = require("../frameloop/sync-time.mjs");
var _styleSetMjs = require("../render/dom/style-set.mjs");
var _jsanimationMjs = require("./JSAnimation.mjs");
var _nativeAnimationMjs = require("./NativeAnimation.mjs");
var _replaceTransitionTypeMjs = require("./utils/replace-transition-type.mjs");
var _unsupportedEasingMjs = require("./waapi/utils/unsupported-easing.mjs");
/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ var sampleDelta = 10; //ms
var NativeAnimationExtended = /*#__PURE__*/ function(NativeAnimation) {
    "use strict";
    (0, _inherits._)(NativeAnimationExtended, NativeAnimation);
    function NativeAnimationExtended(options) {
        (0, _classCallCheck._)(this, NativeAnimationExtended);
        var _this;
        /**
         * The base NativeAnimation function only supports a subset
         * of Motion easings, and WAAPI also only supports some
         * easing functions via string/cubic-bezier definitions.
         *
         * This function replaces those unsupported easing functions
         * with a JS easing function. This will later get compiled
         * to a linear() easing function.
         */ (0, _unsupportedEasingMjs.replaceStringEasing)(options);
        /**
         * Ensure we replace the transition type with a generator function
         * before passing to WAAPI.
         *
         * TODO: Does this have a better home? It could be shared with
         * JSAnimation.
         */ (0, _replaceTransitionTypeMjs.replaceTransitionType)(options);
        _this = (0, _callSuper._)(this, NativeAnimationExtended, [
            options
        ]);
        /**
         * Only set startTime when the animation should autoplay.
         * Setting startTime on a paused WAAPI animation unpauses it
         * (per the WAAPI spec), which breaks autoplay: false.
         */ if (options.startTime !== undefined && options.autoplay !== false) _this.startTime = options.startTime;
        _this.options = options;
        return _this;
    }
    (0, _createClass._)(NativeAnimationExtended, [
        {
            /**
     * WAAPI doesn't natively have any interruption capabilities.
     *
     * Rather than read committed styles back out of the DOM, we can
     * create a renderless JS animation and sample it twice to calculate
     * its current value, "previous" value, and therefore allow
     * Motion to calculate velocity for any subsequent animation.
     */ key: "updateMotionValue",
            value: function updateMotionValue(value) {
                var _this_options = this.options, motionValue = _this_options.motionValue, onUpdate = _this_options.onUpdate, onComplete = _this_options.onComplete, element = _this_options.element, options = (0, _objectWithoutProperties._)(_this_options, [
                    "motionValue",
                    "onUpdate",
                    "onComplete",
                    "element"
                ]);
                if (!motionValue) return;
                if (value !== undefined) {
                    motionValue.set(value);
                    return;
                }
                var sampleAnimation = new (0, _jsanimationMjs.JSAnimation)((0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
                    autoplay: false
                }));
                /**
         * Use wall-clock elapsed time for sampling.
         * Under CPU load, WAAPI's currentTime may not reflect actual
         * elapsed time, causing incorrect sampling and visual jumps.
         */ var sampleTime = Math.max(sampleDelta, (0, _syncTimeMjs.time).now() - this.startTime);
                var delta = (0, _motionUtils.clamp)(0, sampleDelta, sampleTime - sampleDelta);
                var current = sampleAnimation.sample(sampleTime).value;
                /**
         * Write the estimated value to inline style so it persists
         * after cancel(), covering the async gap before the next
         * animation starts.
         */ var name = this.options.name;
                if (element && name) (0, _styleSetMjs.setStyle)(element, name, current);
                motionValue.setWithVelocity(sampleAnimation.sample(Math.max(0, sampleTime - delta)).value, current, delta);
                sampleAnimation.stop();
            }
        }
    ]);
    return NativeAnimationExtended;
}((0, _nativeAnimationMjs.NativeAnimation));

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_inherits":"2sfqW","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","motion-utils":"9Q5qC","../frameloop/sync-time.mjs":"aPTZo","../render/dom/style-set.mjs":"6z2KW","./JSAnimation.mjs":"9nspW","./NativeAnimation.mjs":"30yuo","./utils/replace-transition-type.mjs":"1PTe1","./waapi/utils/unsupported-easing.mjs":"a7b3w","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6z2KW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setStyle", function() {
    return setStyle;
});
var _isCssVarMjs = require("./is-css-var.mjs");
function setStyle(element, name, value) {
    (0, _isCssVarMjs.isCSSVar)(name) ? element.style.setProperty(name, value) : element.style[name] = value;
}

},{"./is-css-var.mjs":"5Ukzo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5Ukzo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isCSSVar", function() {
    return isCSSVar;
});
var isCSSVar = function(name) {
    return name.startsWith("--");
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"30yuo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NativeAnimation", function() {
    return NativeAnimation;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _possibleConstructorReturn = require("@swc/helpers/_/_possible_constructor_return");
var _motionUtils = require("motion-utils");
var _styleSetMjs = require("../render/dom/style-set.mjs");
var _scrollTimelineMjs = require("../utils/supports/scroll-timeline.mjs");
var _getFinalMjs = require("./keyframes/get-final.mjs");
var _withPromiseMjs = require("./utils/WithPromise.mjs");
var _startWaapiAnimationMjs = require("./waapi/start-waapi-animation.mjs");
var _applyGeneratorMjs = require("./waapi/utils/apply-generator.mjs");
/**
 * NativeAnimation implements AnimationPlaybackControls for the browser's Web Animations API.
 */ var NativeAnimation = /*#__PURE__*/ function(WithPromise) {
    "use strict";
    (0, _inherits._)(NativeAnimation, WithPromise);
    function NativeAnimation(options) {
        (0, _classCallCheck._)(this, NativeAnimation);
        var _this;
        _this = (0, _callSuper._)(this, NativeAnimation);
        _this.finishedTime = null;
        _this.isStopped = false;
        /**
         * Tracks a manually-set start time that takes precedence over WAAPI's
         * dynamic startTime. This is cleared when play() or time setter is called,
         * allowing WAAPI to take over timing.
         */ _this.manualStartTime = null;
        if (!options) return (0, _possibleConstructorReturn._)(_this);
        var element = options.element, name = options.name, keyframes = options.keyframes, pseudoElement = options.pseudoElement, _options_allowFlatten = options.allowFlatten, allowFlatten = _options_allowFlatten === void 0 ? false : _options_allowFlatten, finalKeyframe = options.finalKeyframe, onComplete = options.onComplete;
        _this.isPseudoElement = Boolean(pseudoElement);
        _this.allowFlatten = allowFlatten;
        _this.options = options;
        (0, _motionUtils.invariant)(typeof options.type !== "string", 'Mini animate() doesn\'t support "type" as a string.', "mini-spring");
        var transition = (0, _applyGeneratorMjs.applyGeneratorOptions)(options);
        _this.animation = (0, _startWaapiAnimationMjs.startWaapiAnimation)(element, name, keyframes, transition, pseudoElement);
        if (transition.autoplay === false) _this.animation.pause();
        _this.animation.onfinish = function() {
            _this.finishedTime = _this.time;
            if (!pseudoElement) {
                var keyframe = (0, _getFinalMjs.getFinalKeyframe)(keyframes, _this.options, finalKeyframe, _this.speed);
                if (_this.updateMotionValue) _this.updateMotionValue(keyframe);
                /**
                 * If we can, we want to commit the final style as set by the user,
                 * rather than the computed keyframe value supplied by the animation.
                 * We always do this, even when a motion value is present, to prevent
                 * a visual flash in Firefox where the WAAPI animation's fill is removed
                 * during cancel() before the scheduled render can apply the correct value.
                 */ (0, _styleSetMjs.setStyle)(element, name, keyframe);
                _this.animation.cancel();
            }
            onComplete === null || onComplete === void 0 ? void 0 : onComplete();
            _this.notifyFinished();
        };
        return _this;
    }
    (0, _createClass._)(NativeAnimation, [
        {
            key: "play",
            value: function play() {
                if (this.isStopped) return;
                this.manualStartTime = null;
                this.animation.play();
                if (this.state === "finished") this.updateFinished();
            }
        },
        {
            key: "pause",
            value: function pause() {
                this.animation.pause();
            }
        },
        {
            key: "complete",
            value: function complete() {
                var _this_animation_finish, _this_animation;
                (_this_animation_finish = (_this_animation = this.animation).finish) === null || _this_animation_finish === void 0 ? void 0 : _this_animation_finish.call(_this_animation);
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                try {
                    this.animation.cancel();
                } catch (e) {}
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (this.isStopped) return;
                this.isStopped = true;
                var state = this.state;
                if (state === "idle" || state === "finished") return;
                if (this.updateMotionValue) this.updateMotionValue();
                else this.commitStyles();
                if (!this.isPseudoElement) this.cancel();
            }
        },
        {
            /**
     * WAAPI doesn't natively have any interruption capabilities.
     *
     * In this method, we commit styles back to the DOM before cancelling
     * the animation.
     *
     * This is designed to be overridden by NativeAnimationExtended, which
     * will create a renderless JS animation and sample it twice to calculate
     * its current value, "previous" value, and therefore allow
     * Motion to also correctly calculate velocity for any subsequent animation
     * while deferring the commit until the next animation frame.
     */ key: "commitStyles",
            value: function commitStyles() {
                var _this_options, _this_animation_commitStyles, _this_animation;
                var element = (_this_options = this.options) === null || _this_options === void 0 ? void 0 : _this_options.element;
                if (!this.isPseudoElement && (element === null || element === void 0 ? void 0 : element.isConnected)) (_this_animation_commitStyles = (_this_animation = this.animation).commitStyles) === null || _this_animation_commitStyles === void 0 ? void 0 : _this_animation_commitStyles.call(_this_animation);
            }
        },
        {
            key: "duration",
            get: function get() {
                var _this_animation_effect_getComputedTiming, _this_animation_effect;
                var duration = ((_this_animation_effect = this.animation.effect) === null || _this_animation_effect === void 0 ? void 0 : (_this_animation_effect_getComputedTiming = _this_animation_effect.getComputedTiming) === null || _this_animation_effect_getComputedTiming === void 0 ? void 0 : _this_animation_effect_getComputedTiming.call(_this_animation_effect).duration) || 0;
                return (0, _motionUtils.millisecondsToSeconds)(Number(duration));
            }
        },
        {
            key: "iterationDuration",
            get: function get() {
                var _ref = this.options || {}, _ref_delay = _ref.delay, delay = _ref_delay === void 0 ? 0 : _ref_delay;
                return this.duration + (0, _motionUtils.millisecondsToSeconds)(delay);
            }
        },
        {
            key: "time",
            get: function get() {
                return (0, _motionUtils.millisecondsToSeconds)(Number(this.animation.currentTime) || 0);
            },
            set: function set(newTime) {
                var wasFinished = this.finishedTime !== null;
                this.manualStartTime = null;
                this.finishedTime = null;
                this.animation.currentTime = (0, _motionUtils.secondsToMilliseconds)(newTime);
                if (wasFinished) this.animation.pause();
            }
        },
        {
            key: "speed",
            get: /**
     * The playback speed of the animation.
     * 1 = normal speed, 2 = double speed, 0.5 = half speed.
     */ function get() {
                return this.animation.playbackRate;
            },
            set: function set(newSpeed) {
                // Allow backwards playback after finishing
                if (newSpeed < 0) this.finishedTime = null;
                this.animation.playbackRate = newSpeed;
            }
        },
        {
            key: "state",
            get: function get() {
                return this.finishedTime !== null ? "finished" : this.animation.playState;
            }
        },
        {
            key: "startTime",
            get: function get() {
                var _this_manualStartTime;
                return (_this_manualStartTime = this.manualStartTime) !== null && _this_manualStartTime !== void 0 ? _this_manualStartTime : Number(this.animation.startTime);
            },
            set: function set(newStartTime) {
                this.manualStartTime = this.animation.startTime = newStartTime;
            }
        },
        {
            /**
     * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
     */ key: "attachTimeline",
            value: function attachTimeline(param) {
                var timeline = param.timeline, rangeStart = param.rangeStart, rangeEnd = param.rangeEnd, observe = param.observe;
                var _this_animation_effect;
                if (this.allowFlatten) (_this_animation_effect = this.animation.effect) === null || _this_animation_effect === void 0 ? void 0 : _this_animation_effect.updateTiming({
                    easing: "linear"
                });
                this.animation.onfinish = null;
                if (timeline && (0, _scrollTimelineMjs.supportsScrollTimeline)()) {
                    this.animation.timeline = timeline;
                    if (rangeStart) this.animation.rangeStart = rangeStart;
                    if (rangeEnd) this.animation.rangeEnd = rangeEnd;
                    return 0, _motionUtils.noop;
                } else return observe(this);
            }
        }
    ]);
    return NativeAnimation;
}((0, _withPromiseMjs.WithPromise));

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_inherits":"2sfqW","@swc/helpers/_/_possible_constructor_return":"fMpPb","motion-utils":"9Q5qC","../render/dom/style-set.mjs":"6z2KW","../utils/supports/scroll-timeline.mjs":"66T4L","./keyframes/get-final.mjs":"hAUAJ","./utils/WithPromise.mjs":"jEvnC","./waapi/start-waapi-animation.mjs":"2IlJu","./waapi/utils/apply-generator.mjs":"k35Bi","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"66T4L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "supportsScrollTimeline", function() {
    return supportsScrollTimeline;
});
parcelHelpers.export(exports, "supportsViewTimeline", function() {
    return supportsViewTimeline;
});
var _memoMjs = require("./memo.mjs");
var supportsScrollTimeline = /* @__PURE__ */ (0, _memoMjs.memoSupports)(function() {
    return window.ScrollTimeline !== undefined;
}, "scrollTimeline");
var supportsViewTimeline = /* @__PURE__ */ (0, _memoMjs.memoSupports)(function() {
    return window.ViewTimeline !== undefined;
}, "viewTimeline");

},{"./memo.mjs":"iljb7","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iljb7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "memoSupports", function() {
    return memoSupports;
});
var _motionUtils = require("motion-utils");
var _flagsMjs = require("./flags.mjs");
function memoSupports(callback, supportsFlag) {
    var memoized = (0, _motionUtils.memo)(callback);
    return function() {
        var _supportsFlags_supportsFlag;
        return (_supportsFlags_supportsFlag = (0, _flagsMjs.supportsFlags)[supportsFlag]) !== null && _supportsFlags_supportsFlag !== void 0 ? _supportsFlags_supportsFlag : memoized();
    };
}

},{"motion-utils":"9Q5qC","./flags.mjs":"esOs5","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"esOs5":[function(require,module,exports,__globalThis) {
/**
 * Add the ability for test suites to manually set support flags
 * to better test more environments.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "supportsFlags", function() {
    return supportsFlags;
});
var supportsFlags = {};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2IlJu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "startWaapiAnimation", function() {
    return startWaapiAnimation;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _animationCountMjs = require("../../stats/animation-count.mjs");
var _bufferMjs = require("../../stats/buffer.mjs");
var _mapEasingMjs = require("./easing/map-easing.mjs");
function startWaapiAnimation(element, valueName, keyframes) {
    var _ref = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, _ref_delay = _ref.delay, delay = _ref_delay === void 0 ? 0 : _ref_delay, _ref_duration = _ref.duration, duration = _ref_duration === void 0 ? 300 : _ref_duration, _ref_repeat = _ref.repeat, repeat = _ref_repeat === void 0 ? 0 : _ref_repeat, _ref_repeatType = _ref.repeatType, repeatType = _ref_repeatType === void 0 ? "loop" : _ref_repeatType, _ref_ease = _ref.ease, ease = _ref_ease === void 0 ? "easeOut" : _ref_ease, times = _ref.times, pseudoElement = arguments.length > 4 ? arguments[4] : void 0;
    var keyframeOptions = (0, _defineProperty._)({}, valueName, keyframes);
    if (times) keyframeOptions.offset = times;
    var easing = (0, _mapEasingMjs.mapEasingToNativeEasing)(ease, duration);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    if ((0, _bufferMjs.statsBuffer).value) (0, _animationCountMjs.activeAnimations).waapi++;
    var options = {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    };
    if (pseudoElement) options.pseudoElement = pseudoElement;
    var animation = element.animate(keyframeOptions, options);
    if ((0, _bufferMjs.statsBuffer).value) animation.finished.finally(function() {
        (0, _animationCountMjs.activeAnimations).waapi--;
    });
    return animation;
}

},{"@swc/helpers/_/_define_property":"e80IS","../../stats/animation-count.mjs":"gY9Wc","../../stats/buffer.mjs":"bcR1L","./easing/map-easing.mjs":"gPAe1","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gPAe1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapEasingToNativeEasing", function() {
    return mapEasingToNativeEasing;
});
var _motionUtils = require("motion-utils");
var _linearEasingMjs = require("../../../utils/supports/linear-easing.mjs");
var _linearMjs = require("../utils/linear.mjs");
var _cubicBezierMjs = require("./cubic-bezier.mjs");
var _supportedMjs = require("./supported.mjs");
function mapEasingToNativeEasing(easing, duration) {
    if (!easing) return undefined;
    else if (typeof easing === "function") return (0, _linearEasingMjs.supportsLinearEasing)() ? (0, _linearMjs.generateLinearEasing)(easing, duration) : "ease-out";
    else if ((0, _motionUtils.isBezierDefinition)(easing)) return (0, _cubicBezierMjs.cubicBezierAsString)(easing);
    else if (Array.isArray(easing)) return easing.map(function(segmentEasing) {
        return mapEasingToNativeEasing(segmentEasing, duration) || (0, _supportedMjs.supportedWaapiEasing).easeOut;
    });
    else return (0, _supportedMjs.supportedWaapiEasing)[easing];
}

},{"motion-utils":"9Q5qC","../../../utils/supports/linear-easing.mjs":"ewVKW","../utils/linear.mjs":"6RXsU","./cubic-bezier.mjs":"6QXfh","./supported.mjs":"biXOG","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ewVKW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "supportsLinearEasing", function() {
    return supportsLinearEasing;
});
var _memoMjs = require("./memo.mjs");
var supportsLinearEasing = /*@__PURE__*/ (0, _memoMjs.memoSupports)(function() {
    try {
        document.createElement("div").animate({
            opacity: 0
        }, {
            easing: "linear(0, 1)"
        });
    } catch (e) {
        return false;
    }
    return true;
}, "linearEasing");

},{"./memo.mjs":"iljb7","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6QXfh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cubicBezierAsString", function() {
    return cubicBezierAsString;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var cubicBezierAsString = function(param) {
    var _param = (0, _slicedToArray._)(param, 4), a = _param[0], b = _param[1], c = _param[2], d = _param[3];
    return "cubic-bezier(".concat(a, ", ").concat(b, ", ").concat(c, ", ").concat(d, ")");
};

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"biXOG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "supportedWaapiEasing", function() {
    return supportedWaapiEasing;
});
var _cubicBezierMjs = require("./cubic-bezier.mjs");
var supportedWaapiEasing = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: /*@__PURE__*/ (0, _cubicBezierMjs.cubicBezierAsString)([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: /*@__PURE__*/ (0, _cubicBezierMjs.cubicBezierAsString)([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: /*@__PURE__*/ (0, _cubicBezierMjs.cubicBezierAsString)([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: /*@__PURE__*/ (0, _cubicBezierMjs.cubicBezierAsString)([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};

},{"./cubic-bezier.mjs":"6QXfh","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"k35Bi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applyGeneratorOptions", function() {
    return applyGeneratorOptions;
});
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _linearEasingMjs = require("../../../utils/supports/linear-easing.mjs");
var _isGeneratorMjs = require("../../generators/utils/is-generator.mjs");
function applyGeneratorOptions(_param) {
    var type = _param.type, options = (0, _objectWithoutProperties._)(_param, [
        "type"
    ]);
    if ((0, _isGeneratorMjs.isGenerator)(type) && (0, _linearEasingMjs.supportsLinearEasing)()) return type.applyToOptions(options);
    else {
        var _options_duration;
        (_options_duration = options.duration) !== null && _options_duration !== void 0 ? _options_duration : options.duration = 300;
        var _options_ease;
        (_options_ease = options.ease) !== null && _options_ease !== void 0 ? _options_ease : options.ease = "easeOut";
    }
    return options;
}

},{"@swc/helpers/_/_object_without_properties":"6HqIM","../../../utils/supports/linear-easing.mjs":"ewVKW","../../generators/utils/is-generator.mjs":"i5tAy","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"i5tAy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isGenerator", function() {
    return isGenerator;
});
function isGenerator(type) {
    return typeof type === "function" && "applyToOptions" in type;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"a7b3w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "replaceStringEasing", function() {
    return replaceStringEasing;
});
var _motionUtils = require("motion-utils");
var unsupportedEasingFunctions = {
    anticipate: (0, _motionUtils.anticipate),
    backInOut: (0, _motionUtils.backInOut),
    circInOut: (0, _motionUtils.circInOut)
};
function isUnsupportedEase(key) {
    return key in unsupportedEasingFunctions;
}
function replaceStringEasing(transition) {
    if (typeof transition.ease === "string" && isUnsupportedEase(transition.ease)) transition.ease = unsupportedEasingFunctions[transition.ease];
}

},{"motion-utils":"9Q5qC","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"klLI8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "canAnimate", function() {
    return canAnimate;
});
var _motionUtils = require("motion-utils");
var _isGeneratorMjs = require("../generators/utils/is-generator.mjs");
var _isAnimatableMjs = require("./is-animatable.mjs");
function hasKeyframesChanged(keyframes) {
    var current = keyframes[0];
    if (keyframes.length === 1) return true;
    for(var i = 0; i < keyframes.length; i++){
        if (keyframes[i] !== current) return true;
    }
}
function canAnimate(keyframes, name, type, velocity) {
    /**
     * Check if we're able to animate between the start and end keyframes,
     * and throw a warning if we're attempting to animate between one that's
     * animatable and another that isn't.
     */ var originKeyframe = keyframes[0];
    if (originKeyframe === null) return false;
    /**
     * These aren't traditionally animatable but we do support them.
     * In future we could look into making this more generic or replacing
     * this function with mix() === mixImmediate
     */ if (name === "display" || name === "visibility") return true;
    var targetKeyframe = keyframes[keyframes.length - 1];
    var isOriginAnimatable = (0, _isAnimatableMjs.isAnimatable)(originKeyframe, name);
    var isTargetAnimatable = (0, _isAnimatableMjs.isAnimatable)(targetKeyframe, name);
    (0, _motionUtils.warning)(isOriginAnimatable === isTargetAnimatable, "You are trying to animate ".concat(name, ' from "').concat(originKeyframe, '" to "').concat(targetKeyframe, '". "').concat(isOriginAnimatable ? targetKeyframe : originKeyframe, '" is not an animatable value.'), "value-not-animatable");
    // Always skip if any of these are true
    if (!isOriginAnimatable || !isTargetAnimatable) return false;
    return hasKeyframesChanged(keyframes) || (type === "spring" || (0, _isGeneratorMjs.isGenerator)(type)) && velocity;
}

},{"motion-utils":"9Q5qC","../generators/utils/is-generator.mjs":"i5tAy","./is-animatable.mjs":"kei3x","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kei3x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isAnimatable", function() {
    return isAnimatable;
});
var _indexMjs = require("../../value/types/complex/index.mjs");
/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ var isAnimatable = function(value, name) {
    // If the list of keys that might be non-animatable grows, replace with Set
    if (name === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, _indexMjs.complex).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};

},{"../../value/types/complex/index.mjs":"6JMtB","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7YJWD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeAnimationInstant", function() {
    return makeAnimationInstant;
});
function makeAnimationInstant(options) {
    options.duration = 0;
    options.type = "keyframes";
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"98x8M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "supportsBrowserAnimation", function() {
    return supportsBrowserAnimation;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
var _motionUtils = require("motion-utils");
var _acceleratedValuesMjs = require("../utils/accelerated-values.mjs");
var _isBrowserColorMjs = require("../utils/is-browser-color.mjs");
var colorProperties = new Set([
    "color",
    "backgroundColor",
    "outlineColor",
    "fill",
    "stroke",
    "borderColor",
    "borderTopColor",
    "borderRightColor",
    "borderBottomColor",
    "borderLeftColor"
]);
var supportsWaapi = /*@__PURE__*/ (0, _motionUtils.memo)(function() {
    return Object.hasOwnProperty.call(Element.prototype, "animate");
});
function supportsBrowserAnimation(options) {
    var _motionValue_owner;
    var motionValue = options.motionValue, name = options.name, repeatDelay = options.repeatDelay, repeatType = options.repeatType, damping = options.damping, type = options.type, keyframes = options.keyframes;
    var subject = motionValue === null || motionValue === void 0 ? void 0 : (_motionValue_owner = motionValue.owner) === null || _motionValue_owner === void 0 ? void 0 : _motionValue_owner.current;
    /**
     * We use this check instead of isHTMLElement() because we explicitly
     * **don't** want elements in different timing contexts (i.e. popups)
     * to be accelerated, as it's not possible to sync these animations
     * properly with those driven from the main window frameloop.
     */ if (!(0, _instanceof._)(subject, HTMLElement)) return false;
    var _motionValue_owner_getProps = motionValue.owner.getProps(), onUpdate = _motionValue_owner_getProps.onUpdate, transformTemplate = _motionValue_owner_getProps.transformTemplate;
    return supportsWaapi() && name && /**
         * Force WAAPI for color properties with browser-only color formats
         * (oklch, oklab, lab, lch, etc.) that the JS animation path can't parse.
         */ ((0, _acceleratedValuesMjs.acceleratedValues).has(name) || colorProperties.has(name) && (0, _isBrowserColorMjs.hasBrowserOnlyColors)(keyframes)) && (name !== "transform" || !transformTemplate) && /**
         * If we're outputting values to onUpdate then we can't use WAAPI as there's
         * no way to read the value from WAAPI every frame.
         */ !onUpdate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
}

},{"@swc/helpers/_/_instanceof":"h9UKc","motion-utils":"9Q5qC","../utils/accelerated-values.mjs":"kN2wj","../utils/is-browser-color.mjs":"68FGf","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kN2wj":[function(require,module,exports,__globalThis) {
/**
 * A list of values that can be hardware-accelerated.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "acceleratedValues", function() {
    return acceleratedValues;
});
var acceleratedValues = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform"
]);

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"68FGf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasBrowserOnlyColors", function() {
    return hasBrowserOnlyColors;
});
var browserColorFunctions = /^(?:oklch|oklab|lab|lch|color|color-mix|light-dark)\(/;
function hasBrowserOnlyColors(keyframes) {
    for(var i = 0; i < keyframes.length; i++){
        if (typeof keyframes[i] === "string" && browserColorFunctions.test(keyframes[i])) return true;
    }
    return false;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cpgZo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GroupAnimation", function() {
    return GroupAnimation;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var GroupAnimation = /*#__PURE__*/ function() {
    "use strict";
    function GroupAnimation(animations) {
        var _this = this;
        (0, _classCallCheck._)(this, GroupAnimation);
        // Bound to accomadate common `return animation.stop` pattern
        this.stop = function() {
            return _this.runAll("stop");
        };
        this.animations = animations.filter(Boolean);
    }
    (0, _createClass._)(GroupAnimation, [
        {
            key: "finished",
            get: function get() {
                return Promise.all(this.animations.map(function(animation) {
                    return animation.finished;
                }));
            }
        },
        {
            /**
     * TODO: Filter out cancelled or stopped animations before returning
     */ key: "getAll",
            value: function getAll(propName) {
                return this.animations[0][propName];
            }
        },
        {
            key: "setAll",
            value: function setAll(propName, newValue) {
                for(var i = 0; i < this.animations.length; i++)this.animations[i][propName] = newValue;
            }
        },
        {
            key: "attachTimeline",
            value: function attachTimeline(timeline) {
                var _this = this;
                var subscriptions = this.animations.map(function(animation) {
                    return animation.attachTimeline(timeline);
                });
                return function() {
                    subscriptions.forEach(function(cancel, i) {
                        cancel && cancel();
                        _this.animations[i].stop();
                    });
                };
            }
        },
        {
            key: "time",
            get: function get() {
                return this.getAll("time");
            },
            set: function set(time) {
                this.setAll("time", time);
            }
        },
        {
            key: "speed",
            get: function get() {
                return this.getAll("speed");
            },
            set: function set(speed) {
                this.setAll("speed", speed);
            }
        },
        {
            key: "state",
            get: function get() {
                return this.getAll("state");
            }
        },
        {
            key: "startTime",
            get: function get() {
                return this.getAll("startTime");
            }
        },
        {
            key: "duration",
            get: function get() {
                return getMax(this.animations, "duration");
            }
        },
        {
            key: "iterationDuration",
            get: function get() {
                return getMax(this.animations, "iterationDuration");
            }
        },
        {
            key: "runAll",
            value: function runAll(methodName) {
                this.animations.forEach(function(controls) {
                    return controls[methodName]();
                });
            }
        },
        {
            key: "play",
            value: function play() {
                this.runAll("play");
            }
        },
        {
            key: "pause",
            value: function pause() {
                this.runAll("pause");
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                this.runAll("cancel");
            }
        },
        {
            key: "complete",
            value: function complete() {
                this.runAll("complete");
            }
        }
    ]);
    return GroupAnimation;
}();
function getMax(animations, propName) {
    var max = 0;
    for(var i = 0; i < animations.length; i++){
        var value = animations[i][propName];
        if (value !== null && value > max) max = value;
    }
    return max;
}

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"69Lba":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GroupAnimationWithThen", function() {
    return GroupAnimationWithThen;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _groupAnimationMjs = require("./GroupAnimation.mjs");
var GroupAnimationWithThen = /*#__PURE__*/ function(GroupAnimation) {
    "use strict";
    (0, _inherits._)(GroupAnimationWithThen, GroupAnimation);
    function GroupAnimationWithThen() {
        (0, _classCallCheck._)(this, GroupAnimationWithThen);
        return (0, _callSuper._)(this, GroupAnimationWithThen, arguments);
    }
    (0, _createClass._)(GroupAnimationWithThen, [
        {
            key: "then",
            value: function then(onResolve, _onReject) {
                return this.finished.finally(onResolve).then(function() {});
            }
        }
    ]);
    return GroupAnimationWithThen;
}((0, _groupAnimationMjs.GroupAnimation));

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_inherits":"2sfqW","./GroupAnimation.mjs":"cpgZo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ambch":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NativeAnimationWrapper", function() {
    return NativeAnimationWrapper;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _inherits = require("@swc/helpers/_/_inherits");
var _nativeAnimationMjs = require("./NativeAnimation.mjs");
var NativeAnimationWrapper = /*#__PURE__*/ function(NativeAnimation) {
    "use strict";
    (0, _inherits._)(NativeAnimationWrapper, NativeAnimation);
    function NativeAnimationWrapper(animation) {
        (0, _classCallCheck._)(this, NativeAnimationWrapper);
        var _this;
        _this = (0, _callSuper._)(this, NativeAnimationWrapper);
        _this.animation = animation;
        animation.onfinish = function() {
            _this.finishedTime = _this.time;
            _this.notifyFinished();
        };
        return _this;
    }
    return NativeAnimationWrapper;
}((0, _nativeAnimationMjs.NativeAnimation));

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_inherits":"2sfqW","./NativeAnimation.mjs":"30yuo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"g8sFG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animationMapKey", function() {
    return animationMapKey;
});
parcelHelpers.export(exports, "getAnimationMap", function() {
    return getAnimationMap;
});
var animationMaps = new WeakMap();
var animationMapKey = function(name) {
    var pseudoElement = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return "".concat(name, ":").concat(pseudoElement);
};
function getAnimationMap(element) {
    var map = animationMaps.get(element);
    if (!map) {
        map = new Map();
        animationMaps.set(element, map);
    }
    return map;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"h5ciR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calcChildStagger", function() {
    return calcChildStagger;
});
function calcChildStagger(children, child, delayChildren) {
    var staggerChildren = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, staggerDirection = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 1;
    var index = Array.from(children).sort(function(a, b) {
        return a.sortNodePosition(b);
    }).indexOf(child);
    var numChildren = children.size;
    var maxStaggerDuration = (numChildren - 1) * staggerChildren;
    var delayIsFunction = typeof delayChildren === "function";
    return delayIsFunction ? delayChildren(index, numChildren) : staggerDirection === 1 ? index * staggerChildren : maxStaggerDuration - index * staggerChildren;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9gQEb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getVariableValue", function() {
    return getVariableValue;
});
parcelHelpers.export(exports, "parseCSSVariable", function() {
    return parseCSSVariable;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _motionUtils = require("motion-utils");
var _isCssVariableMjs = require("./is-css-variable.mjs");
/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ var splitCSSVariableRegex = // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
RegExp("^var\\(--(?:([\\w-]+)|([\\w-]+), ?([a-zA-Z\\d ()%#.,-]+))\\)", "u");
function parseCSSVariable(current) {
    var match = splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    var _match = (0, _slicedToArray._)(match, 4), token1 = _match[1], token2 = _match[2], fallback = _match[3];
    return [
        "--".concat(token1 !== null && token1 !== void 0 ? token1 : token2),
        fallback
    ];
}
var maxDepth = 4;
function getVariableValue(current, element) {
    var depth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
    (0, _motionUtils.invariant)(depth <= maxDepth, 'Max CSS variable fallback depth detected in property "'.concat(current, '". This may indicate a circular fallback dependency.'), "max-css-var-depth");
    var _parseCSSVariable = (0, _slicedToArray._)(parseCSSVariable(current), 2), token = _parseCSSVariable[0], fallback = _parseCSSVariable[1];
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    var resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        var trimmed = resolved.trim();
        return (0, _motionUtils.isNumericalString)(trimmed) ? parseFloat(trimmed) : trimmed;
    }
    return (0, _isCssVariableMjs.isCSSVariableToken)(fallback) ? getVariableValue(fallback, element, depth + 1) : fallback;
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","motion-utils":"9Q5qC","./is-css-variable.mjs":"5nV2N","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gYLkc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaultTransition", function() {
    return getDefaultTransition;
});
var _keysTransformMjs = require("../../render/utils/keys-transform.mjs");
var underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
var criticallyDampedSpring = function(target) {
    return {
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    };
};
var keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ var ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
var getDefaultTransition = function(valueKey, param) {
    var keyframes = param.keyframes;
    if (keyframes.length > 2) return keyframesTransition;
    else if ((0, _keysTransformMjs.transformProps).has(valueKey)) return valueKey.startsWith("scale") ? criticallyDampedSpring(keyframes[1]) : underDampedSpring;
    return ease;
};

},{"../../render/utils/keys-transform.mjs":"91lmj","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dkYvz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getValueTransition", function() {
    return getValueTransition;
});
var _resolveTransitionMjs = require("./resolve-transition.mjs");
function getValueTransition(transition, key) {
    var _transition_key, _ref;
    var valueTransition = (_ref = (_transition_key = transition === null || transition === void 0 ? void 0 : transition[key]) !== null && _transition_key !== void 0 ? _transition_key : transition === null || transition === void 0 ? void 0 : transition["default"]) !== null && _ref !== void 0 ? _ref : transition;
    if (valueTransition !== transition) return (0, _resolveTransitionMjs.resolveTransition)(valueTransition, transition);
    return valueTransition;
}

},{"./resolve-transition.mjs":"ndZ8f","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ndZ8f":[function(require,module,exports,__globalThis) {
/**
 * If `transition` has `inherit: true`, shallow-merge it with
 * `parentTransition` (child keys win) and strip the `inherit` key.
 * Otherwise return `transition` unchanged.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveTransition", function() {
    return resolveTransition;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
function resolveTransition(transition, parentTransition) {
    if ((transition === null || transition === void 0 ? void 0 : transition.inherit) && parentTransition) {
        var _ = transition.inherit, rest = (0, _objectWithoutProperties._)(transition, [
            "inherit"
        ]);
        return (0, _objectSpread._)({}, parentTransition, rest);
    }
    return transition;
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_without_properties":"6HqIM","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2LEKK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isTransitionDefined", function() {
    return isTransitionDefined;
});
var orchestrationKeys = new Set([
    "when",
    "delay",
    "delayChildren",
    "staggerChildren",
    "staggerDirection",
    "repeat",
    "repeatType",
    "repeatDelay",
    "from",
    "elapsed"
]);
/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function isTransitionDefined(transition) {
    for(var key in transition){
        if (!orchestrationKeys.has(key)) return true;
    }
    return false;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dwpM4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animateMotionValue", function() {
    return animateMotionValue;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _motionUtils = require("motion-utils");
var _asyncMotionValueAnimationMjs = require("../AsyncMotionValueAnimation.mjs");
var _jsanimationMjs = require("../JSAnimation.mjs");
var _getValueTransitionMjs = require("../utils/get-value-transition.mjs");
var _makeAnimationInstantMjs = require("../utils/make-animation-instant.mjs");
var _defaultTransitionsMjs = require("../utils/default-transitions.mjs");
var _getFinalMjs = require("../keyframes/get-final.mjs");
var _isTransitionDefinedMjs = require("../utils/is-transition-defined.mjs");
var _frameMjs = require("../../frameloop/frame.mjs");
var animateMotionValue = function(name, value, target) {
    var transition = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, element = arguments.length > 4 ? arguments[4] : void 0, isHandoff = arguments.length > 5 ? arguments[5] : void 0;
    return function(onComplete) {
        var valueTransition = (0, _getValueTransitionMjs.getValueTransition)(transition, name) || {};
        /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */ var delay = valueTransition.delay || transition.delay || 0;
        /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */ var _transition_elapsed = transition.elapsed, elapsed = _transition_elapsed === void 0 ? 0 : _transition_elapsed;
        elapsed = elapsed - (0, _motionUtils.secondsToMilliseconds)(delay);
        var options = (0, _objectSpreadProps._)((0, _objectSpread._)({
            keyframes: Array.isArray(target) ? target : [
                null,
                target
            ],
            ease: "easeOut",
            velocity: value.getVelocity()
        }, valueTransition), {
            delay: -elapsed,
            onUpdate: function(v) {
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: function() {
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            },
            name: name,
            motionValue: value,
            element: isHandoff ? undefined : element
        });
        /**
     * If there's no transition defined for this value, we can generate
     * unique transition settings for this value.
     */ if (!(0, _isTransitionDefinedMjs.isTransitionDefined)(valueTransition)) Object.assign(options, (0, _defaultTransitionsMjs.getDefaultTransition)(name, options));
        /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */ options.duration && (options.duration = (0, _motionUtils.secondsToMilliseconds)(options.duration));
        options.repeatDelay && (options.repeatDelay = (0, _motionUtils.secondsToMilliseconds)(options.repeatDelay));
        /**
     * Support deprecated way to set initial value. Prefer keyframe syntax.
     */ if (options.from !== undefined) options.keyframes[0] = options.from;
        var shouldSkip = false;
        if (options.type === false || options.duration === 0 && !options.repeatDelay) {
            (0, _makeAnimationInstantMjs.makeAnimationInstant)(options);
            if (options.delay === 0) shouldSkip = true;
        }
        if ((0, _motionUtils.MotionGlobalConfig).instantAnimations || (0, _motionUtils.MotionGlobalConfig).skipAnimations || (element === null || element === void 0 ? void 0 : element.shouldSkipAnimations)) {
            shouldSkip = true;
            (0, _makeAnimationInstantMjs.makeAnimationInstant)(options);
            options.delay = 0;
        }
        /**
     * If the transition type or easing has been explicitly set by the user
     * then we don't want to allow flattening the animation.
     */ options.allowFlatten = !valueTransition.type && !valueTransition.ease;
        /**
     * If we can or must skip creating the animation, and apply only
     * the final keyframe, do so. We also check once keyframes are resolved but
     * this early check prevents the need to create an animation at all.
     */ if (shouldSkip && !isHandoff && value.get() !== undefined) {
            var finalKeyframe = (0, _getFinalMjs.getFinalKeyframe)(options.keyframes, valueTransition);
            if (finalKeyframe !== undefined) {
                (0, _frameMjs.frame).update(function() {
                    options.onUpdate(finalKeyframe);
                    options.onComplete();
                });
                return;
            }
        }
        return valueTransition.isSync ? new (0, _jsanimationMjs.JSAnimation)(options) : new (0, _asyncMotionValueAnimationMjs.AsyncMotionValueAnimation)(options);
    };
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","motion-utils":"9Q5qC","../AsyncMotionValueAnimation.mjs":"k2WgK","../JSAnimation.mjs":"9nspW","../utils/get-value-transition.mjs":"dkYvz","../utils/make-animation-instant.mjs":"7YJWD","../utils/default-transitions.mjs":"gYLkc","../keyframes/get-final.mjs":"hAUAJ","../utils/is-transition-defined.mjs":"2LEKK","../../frameloop/frame.mjs":"lxQZr","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dkWvU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animateVisualElement", function() {
    return animateVisualElement;
});
var _resolveDynamicVariantsMjs = require("../../render/utils/resolve-dynamic-variants.mjs");
var _visualElementTargetMjs = require("./visual-element-target.mjs");
var _visualElementVariantMjs = require("./visual-element-variant.mjs");
function animateVisualElement(visualElement, definition) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    visualElement.notify("AnimationStart", definition);
    var animation;
    if (Array.isArray(definition)) {
        var animations = definition.map(function(variant) {
            return (0, _visualElementVariantMjs.animateVariant)(visualElement, variant, options);
        });
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, _visualElementVariantMjs.animateVariant)(visualElement, definition, options);
    else {
        var resolvedDefinition = typeof definition === "function" ? (0, _resolveDynamicVariantsMjs.resolveVariant)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, _visualElementTargetMjs.animateTarget)(visualElement, resolvedDefinition, options));
    }
    return animation.then(function() {
        visualElement.notify("AnimationComplete", definition);
    });
}

},{"../../render/utils/resolve-dynamic-variants.mjs":"5FiD7","./visual-element-target.mjs":"40l2J","./visual-element-variant.mjs":"9Xbau","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5FiD7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveVariant", function() {
    return resolveVariant;
});
var _resolveVariantsMjs = require("./resolve-variants.mjs");
function resolveVariant(visualElement, definition, custom) {
    var props = visualElement.getProps();
    return (0, _resolveVariantsMjs.resolveVariantFromProps)(props, definition, custom !== undefined ? custom : props.custom, visualElement);
}

},{"./resolve-variants.mjs":"gzt8h","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gzt8h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveVariantFromProps", function() {
    return resolveVariantFromProps;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
function getValueState(visualElement) {
    var state = [
        {},
        {}
    ];
    visualElement === null || visualElement === void 0 ? void 0 : visualElement.values.forEach(function(value, key) {
        state[0][key] = value.get();
        state[1][key] = value.getVelocity();
    });
    return state;
}
function resolveVariantFromProps(props, definition, custom, visualElement) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") {
        var _getValueState = (0, _slicedToArray._)(getValueState(visualElement), 2), current = _getValueState[0], velocity = _getValueState[1];
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") {
        var _getValueState1 = (0, _slicedToArray._)(getValueState(visualElement), 2), current1 = _getValueState1[0], velocity1 = _getValueState1[1];
        definition = definition(custom !== undefined ? custom : props.custom, current1, velocity1);
    }
    return definition;
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"40l2J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animateTarget", function() {
    return animateTarget;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _getValueTransitionMjs = require("../utils/get-value-transition.mjs");
var _resolveTransitionMjs = require("../utils/resolve-transition.mjs");
var _keysPositionMjs = require("../../render/utils/keys-position.mjs");
var _settersMjs = require("../../render/utils/setters.mjs");
var _addWillChangeMjs = require("../../value/will-change/add-will-change.mjs");
var _getAppearIdMjs = require("../optimized-appear/get-appear-id.mjs");
var _motionValueMjs = require("./motion-value.mjs");
var _frameMjs = require("../../frameloop/frame.mjs");
/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function shouldBlockAnimation(param, key) {
    var protectedKeys = param.protectedKeys, needsAnimating = param.needsAnimating;
    var shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function animateTarget(visualElement, targetAndTransition) {
    var _loop = function(key) {
        var _visualElement_latestValues_key;
        var value = visualElement.getValue(key, (_visualElement_latestValues_key = visualElement.latestValues[key]) !== null && _visualElement_latestValues_key !== void 0 ? _visualElement_latestValues_key : null);
        var valueTarget = target[key];
        if (valueTarget === undefined || animationTypeState && shouldBlockAnimation(animationTypeState, key)) return "continue";
        var valueTransition = (0, _objectSpread._)({
            delay: delay
        }, (0, _getValueTransitionMjs.getValueTransition)(transition || {}, key));
        /**
         * If the value is already at the defined target, skip the animation.
         * We still re-assert the value via frame.update to take precedence
         * over any stale transitionEnd callbacks from previous animations.
         */ var currentValue = value.get();
        if (currentValue !== undefined && !value.isAnimating() && !Array.isArray(valueTarget) && valueTarget === currentValue && !valueTransition.velocity) {
            (0, _frameMjs.frame).update(function() {
                return value.set(valueTarget);
            });
            return "continue";
        }
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ var isHandoff = false;
        if (window.MotionHandoffAnimation) {
            var appearId = (0, _getAppearIdMjs.getOptimisedAppearId)(visualElement);
            if (appearId) {
                var startTime = window.MotionHandoffAnimation(appearId, key, (0, _frameMjs.frame));
                if (startTime !== null) {
                    valueTransition.startTime = startTime;
                    isHandoff = true;
                }
            }
        }
        (0, _addWillChangeMjs.addValueToWillChange)(visualElement, key);
        var shouldReduceMotion = reduceMotion !== null && reduceMotion !== void 0 ? reduceMotion : visualElement.shouldReduceMotion;
        value.start((0, _motionValueMjs.animateMotionValue)(key, value, valueTarget, shouldReduceMotion && (0, _keysPositionMjs.positionalKeys).has(key) ? {
            type: false
        } : valueTransition, visualElement, isHandoff));
        var animation = value.animation;
        if (animation) animations.push(animation);
    };
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref_delay = _ref.delay, delay = _ref_delay === void 0 ? 0 : _ref_delay, transitionOverride = _ref.transitionOverride, type = _ref.type;
    var transition = targetAndTransition.transition, transitionEnd = targetAndTransition.transitionEnd, target = (0, _objectWithoutProperties._)(targetAndTransition, [
        "transition",
        "transitionEnd"
    ]);
    var defaultTransition = visualElement.getDefaultTransition();
    transition = transition ? (0, _resolveTransitionMjs.resolveTransition)(transition, defaultTransition) : defaultTransition;
    var reduceMotion = transition === null || transition === void 0 ? void 0 : transition.reduceMotion;
    if (transitionOverride) transition = transitionOverride;
    var animations = [];
    var animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(var key in target)_loop(key);
    if (transitionEnd) {
        var applyTransitionEnd = function() {
            return (0, _frameMjs.frame).update(function() {
                transitionEnd && (0, _settersMjs.setTarget)(visualElement, transitionEnd);
            });
        };
        if (animations.length) Promise.all(animations).then(applyTransitionEnd);
        else applyTransitionEnd();
    }
    return animations;
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_without_properties":"6HqIM","../utils/get-value-transition.mjs":"dkYvz","../utils/resolve-transition.mjs":"ndZ8f","../../render/utils/keys-position.mjs":"7MP49","../../render/utils/setters.mjs":"lAlTD","../../value/will-change/add-will-change.mjs":"kDErF","../optimized-appear/get-appear-id.mjs":"1uuWd","./motion-value.mjs":"dwpM4","../../frameloop/frame.mjs":"lxQZr","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7MP49":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "positionalKeys", function() {
    return positionalKeys;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _keysTransformMjs = require("./keys-transform.mjs");
var positionalKeys = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom"
].concat((0, _toConsumableArray._)((0, _keysTransformMjs.transformPropOrder))));

},{"@swc/helpers/_/_to_consumable_array":"1eSZf","./keys-transform.mjs":"91lmj","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lAlTD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setTarget", function() {
    return setTarget;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _indexMjs = require("../../value/index.mjs");
var _resolveDynamicVariantsMjs = require("./resolve-dynamic-variants.mjs");
var _isKeyframesTargetMjs = require("./is-keyframes-target.mjs");
/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, _indexMjs.motionValue)(value));
}
function resolveFinalValueInKeyframes(v) {
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, _isKeyframesTargetMjs.isKeyframesTarget)(v) ? v[v.length - 1] || 0 : v;
}
function setTarget(visualElement, definition) {
    var resolved = (0, _resolveDynamicVariantsMjs.resolveVariant)(visualElement, definition);
    var _ref = resolved || {}, _ref_transitionEnd = _ref.transitionEnd, transitionEnd = _ref_transitionEnd === void 0 ? {} : _ref_transitionEnd, _ref_transition = _ref.transition, transition = _ref_transition === void 0 ? {} : _ref_transition, target = (0, _objectWithoutProperties._)(_ref, [
        "transitionEnd",
        "transition"
    ]);
    target = (0, _objectSpread._)({}, target, transitionEnd);
    for(var key in target){
        var value = resolveFinalValueInKeyframes(target[key]);
        setMotionValue(visualElement, key, value);
    }
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_without_properties":"6HqIM","../../value/index.mjs":"lOANY","./resolve-dynamic-variants.mjs":"5FiD7","./is-keyframes-target.mjs":"lh5lz","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lOANY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MotionValue", function() {
    return MotionValue;
});
parcelHelpers.export(exports, "collectMotionValues", function() {
    return collectMotionValues;
});
parcelHelpers.export(exports, "motionValue", function() {
    return motionValue;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _motionUtils = require("motion-utils");
var _syncTimeMjs = require("../frameloop/sync-time.mjs");
var _frameMjs = require("../frameloop/frame.mjs");
/**
 * Maximum time between the value of two frames, beyond which we
 * assume the velocity has since been 0.
 */ var MAX_VELOCITY_DELTA = 30;
var isFloat = function(value) {
    return !isNaN(parseFloat(value));
};
var collectMotionValues = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ var MotionValue = /*#__PURE__*/ function() {
    "use strict";
    function MotionValue(init) {
        var _this = this;
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, _classCallCheck._)(this, MotionValue);
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = null;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = function(v) {
            var currentTime = (0, _syncTimeMjs.time).now();
            /**
             * If we're updating the value during another frame or eventloop
             * than the previous frame, then the we set the previous frame value
             * to current.
             */ if (_this.updatedAt !== currentTime) _this.setPrevFrameValue();
            _this.prev = _this.current;
            _this.setCurrent(v);
            // Update update subscribers
            if (_this.current !== _this.prev) {
                var _this_events_change;
                (_this_events_change = _this.events.change) === null || _this_events_change === void 0 ? void 0 : _this_events_change.notify(_this.current);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (_this.dependents) try {
                    for(var _iterator = _this.dependents[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var dependent = _step.value;
                        dependent.dirty();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        };
        this.hasAnimated = false;
        this.setCurrent(init);
        this.owner = options.owner;
    }
    (0, _createClass._)(MotionValue, [
        {
            key: "setCurrent",
            value: function setCurrent(current) {
                this.current = current;
                this.updatedAt = (0, _syncTimeMjs.time).now();
                if (this.canTrackVelocity === null && current !== undefined) this.canTrackVelocity = isFloat(this.current);
            }
        },
        {
            key: "setPrevFrameValue",
            value: function setPrevFrameValue() {
                var prevFrameValue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.current;
                this.prevFrameValue = prevFrameValue;
                this.prevUpdatedAt = this.updatedAt;
            }
        },
        {
            /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ key: "onChange",
            value: function onChange(subscription) {
                return this.on("change", subscription);
            }
        },
        {
            key: "on",
            value: function on(eventName, callback) {
                var _this = this;
                if (!this.events[eventName]) this.events[eventName] = new (0, _motionUtils.SubscriptionManager)();
                var unsubscribe = this.events[eventName].add(callback);
                if (eventName === "change") return function() {
                    unsubscribe();
                    /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, _frameMjs.frame).read(function() {
                        if (!_this.events.change.getSize()) _this.stop();
                    });
                };
                return unsubscribe;
            }
        },
        {
            key: "clearListeners",
            value: function clearListeners() {
                for(var eventManagers in this.events)this.events[eventManagers].clear();
            }
        },
        {
            /**
     * Attaches a passive effect to the `MotionValue`.
     */ key: "attach",
            value: function attach(passiveEffect, stopPassiveEffect) {
                this.passiveEffect = passiveEffect;
                this.stopPassiveEffect = stopPassiveEffect;
            }
        },
        {
            /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ key: "set",
            value: function set(v) {
                if (!this.passiveEffect) this.updateAndNotify(v);
                else this.passiveEffect(v, this.updateAndNotify);
            }
        },
        {
            key: "setWithVelocity",
            value: function setWithVelocity(prev, current, delta) {
                this.set(current);
                this.prev = undefined;
                this.prevFrameValue = prev;
                this.prevUpdatedAt = this.updatedAt - delta;
            }
        },
        {
            /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ key: "jump",
            value: function jump(v) {
                var endAnimation = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                this.updateAndNotify(v);
                this.prev = v;
                this.prevUpdatedAt = this.prevFrameValue = undefined;
                endAnimation && this.stop();
                if (this.stopPassiveEffect) this.stopPassiveEffect();
            }
        },
        {
            key: "dirty",
            value: function dirty() {
                var _this_events_change;
                (_this_events_change = this.events.change) === null || _this_events_change === void 0 ? void 0 : _this_events_change.notify(this.current);
            }
        },
        {
            key: "addDependent",
            value: function addDependent(dependent) {
                if (!this.dependents) this.dependents = new Set();
                this.dependents.add(dependent);
            }
        },
        {
            key: "removeDependent",
            value: function removeDependent(dependent) {
                if (this.dependents) this.dependents.delete(dependent);
            }
        },
        {
            /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ key: "get",
            value: function get() {
                if (collectMotionValues.current) collectMotionValues.current.push(this);
                return this.current;
            }
        },
        {
            /**
     * @public
     */ key: "getPrevious",
            value: function getPrevious() {
                return this.prev;
            }
        },
        {
            /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ key: "getVelocity",
            value: function getVelocity() {
                var currentTime = (0, _syncTimeMjs.time).now();
                if (!this.canTrackVelocity || this.prevFrameValue === undefined || currentTime - this.updatedAt > MAX_VELOCITY_DELTA) return 0;
                var delta = Math.min(this.updatedAt - this.prevUpdatedAt, MAX_VELOCITY_DELTA);
                // Casts because of parseFloat's poor typing
                return (0, _motionUtils.velocityPerSecond)(parseFloat(this.current) - parseFloat(this.prevFrameValue), delta);
            }
        },
        {
            /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     */ key: "start",
            value: function start(startAnimation) {
                var _this = this;
                this.stop();
                return new Promise(function(resolve) {
                    _this.hasAnimated = true;
                    _this.animation = startAnimation(resolve);
                    if (_this.events.animationStart) _this.events.animationStart.notify();
                }).then(function() {
                    if (_this.events.animationComplete) _this.events.animationComplete.notify();
                    _this.clearAnimation();
                });
            }
        },
        {
            /**
     * Stop the currently active animation.
     *
     * @public
     */ key: "stop",
            value: function stop() {
                if (this.animation) {
                    this.animation.stop();
                    if (this.events.animationCancel) this.events.animationCancel.notify();
                }
                this.clearAnimation();
            }
        },
        {
            /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ key: "isAnimating",
            value: function isAnimating() {
                return !!this.animation;
            }
        },
        {
            key: "clearAnimation",
            value: function clearAnimation() {
                delete this.animation;
            }
        },
        {
            /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ key: "destroy",
            value: function destroy() {
                var _this_dependents, _this_events_destroy;
                (_this_dependents = this.dependents) === null || _this_dependents === void 0 ? void 0 : _this_dependents.clear();
                (_this_events_destroy = this.events.destroy) === null || _this_events_destroy === void 0 ? void 0 : _this_events_destroy.notify();
                this.clearListeners();
                this.stop();
                if (this.stopPassiveEffect) this.stopPassiveEffect();
            }
        }
    ]);
    return MotionValue;
}();
function motionValue(init, options) {
    return new MotionValue(init, options);
}

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","motion-utils":"9Q5qC","../frameloop/sync-time.mjs":"aPTZo","../frameloop/frame.mjs":"lxQZr","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lh5lz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isKeyframesTarget", function() {
    return isKeyframesTarget;
});
var isKeyframesTarget = function(v) {
    return Array.isArray(v);
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kDErF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addValueToWillChange", function() {
    return addValueToWillChange;
});
var _motionUtils = require("motion-utils");
var _isMjs = require("./is.mjs");
function addValueToWillChange(visualElement, key) {
    var willChange = visualElement.getValue("willChange");
    /**
     * It could be that a user has set willChange to a regular MotionValue,
     * in which case we can't add the value to it.
     */ if ((0, _isMjs.isWillChangeMotionValue)(willChange)) return willChange.add(key);
    else if (!willChange && (0, _motionUtils.MotionGlobalConfig).WillChange) {
        var newWillChange = new (0, _motionUtils.MotionGlobalConfig).WillChange("auto");
        visualElement.addValue("willChange", newWillChange);
        newWillChange.add(key);
    }
}

},{"motion-utils":"9Q5qC","./is.mjs":"23kcl","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"23kcl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isWillChangeMotionValue", function() {
    return isWillChangeMotionValue;
});
var _isMotionValueMjs = require("../utils/is-motion-value.mjs");
function isWillChangeMotionValue(value) {
    return Boolean((0, _isMotionValueMjs.isMotionValue)(value) && value.add);
}

},{"../utils/is-motion-value.mjs":"cYNey","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cYNey":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isMotionValue", function() {
    return isMotionValue;
});
var isMotionValue = function(value) {
    return Boolean(value && value.getVelocity);
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1uuWd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOptimisedAppearId", function() {
    return getOptimisedAppearId;
});
var _dataIdMjs = require("./data-id.mjs");
function getOptimisedAppearId(visualElement) {
    return visualElement.props[0, _dataIdMjs.optimizedAppearDataAttribute];
}

},{"./data-id.mjs":"kv3NC","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kv3NC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "optimizedAppearDataAttribute", function() {
    return optimizedAppearDataAttribute;
});
parcelHelpers.export(exports, "optimizedAppearDataId", function() {
    return optimizedAppearDataId;
});
var _camelToDashMjs = require("../../render/dom/utils/camel-to-dash.mjs");
var optimizedAppearDataId = "framerAppearId";
var optimizedAppearDataAttribute = "data-" + (0, _camelToDashMjs.camelToDash)(optimizedAppearDataId);

},{"../../render/dom/utils/camel-to-dash.mjs":"2DA9K","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2DA9K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "camelToDash", function() {
    return camelToDash;
});
function camelToDash(str) {
    return str.replace(/([A-Z])/g, function(match) {
        return "-".concat(match.toLowerCase());
    });
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9Xbau":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animateVariant", function() {
    return animateVariant;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _resolveDynamicVariantsMjs = require("../../render/utils/resolve-dynamic-variants.mjs");
var _calcChildStaggerMjs = require("../utils/calc-child-stagger.mjs");
var _visualElementTargetMjs = require("./visual-element-target.mjs");
function animateVariant(visualElement, variant) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var _visualElement_presenceContext;
    var resolved = (0, _resolveDynamicVariantsMjs.resolveVariant)(visualElement, variant, options.type === "exit" ? (_visualElement_presenceContext = visualElement.presenceContext) === null || _visualElement_presenceContext === void 0 ? void 0 : _visualElement_presenceContext.custom : undefined);
    var _ref = resolved || {}, _ref_transition = _ref.transition, transition = _ref_transition === void 0 ? visualElement.getDefaultTransition() || {} : _ref_transition;
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ var getAnimation = resolved ? function() {
        return Promise.all((0, _visualElementTargetMjs.animateTarget)(visualElement, resolved, options));
    } : function() {
        return Promise.resolve();
    };
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ var getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? function() {
        var forwardDelay = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
        var _transition_delayChildren = transition.delayChildren, delayChildren = _transition_delayChildren === void 0 ? 0 : _transition_delayChildren, staggerChildren = transition.staggerChildren, staggerDirection = transition.staggerDirection;
        return animateChildren(visualElement, variant, forwardDelay, delayChildren, staggerChildren, staggerDirection, options);
    } : function() {
        return Promise.resolve();
    };
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ var when = transition.when;
    if (when) {
        var _ref1 = (0, _slicedToArray._)(when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ], 2), first = _ref1[0], last = _ref1[1];
        return first().then(function() {
            return last();
        });
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function animateChildren(visualElement, variant) {
    var delay = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, delayChildren = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, staggerChildren = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0, staggerDirection = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 1, options = arguments.length > 6 ? arguments[6] : void 0;
    var animations = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var child = _step.value;
            child.notify("AnimationStart", variant);
            animations.push(animateVariant(child, variant, (0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
                delay: delay + (typeof delayChildren === "function" ? 0 : delayChildren) + (0, _calcChildStaggerMjs.calcChildStagger)(visualElement.variantChildren, child, delayChildren, staggerChildren, staggerDirection)
            })).then(function() {
                return child.notify("AnimationComplete", variant);
            }));
        };
        for(var _iterator = visualElement.variantChildren[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return Promise.all(animations);
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_sliced_to_array":"8PtL6","../../render/utils/resolve-dynamic-variants.mjs":"5FiD7","../utils/calc-child-stagger.mjs":"h5ciR","./visual-element-target.mjs":"40l2J","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"blRNU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DOMKeyframesResolver", function() {
    return DOMKeyframesResolver;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _get = require("@swc/helpers/_/_get");
var _getPrototypeOf = require("@swc/helpers/_/_get_prototype_of");
var _inherits = require("@swc/helpers/_/_inherits");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _keysPositionMjs = require("../../render/utils/keys-position.mjs");
var _dimensionsMjs = require("../../value/types/dimensions.mjs");
var _cssVariablesConversionMjs = require("../utils/css-variables-conversion.mjs");
var _isCssVariableMjs = require("../utils/is-css-variable.mjs");
var _keyframesResolverMjs = require("./KeyframesResolver.mjs");
var _isNoneMjs = require("./utils/is-none.mjs");
var _makeNoneAnimatableMjs = require("./utils/make-none-animatable.mjs");
var _unitConversionMjs = require("./utils/unit-conversion.mjs");
var DOMKeyframesResolver = /*#__PURE__*/ function(KeyframeResolver) {
    "use strict";
    (0, _inherits._)(DOMKeyframesResolver, KeyframeResolver);
    function DOMKeyframesResolver(unresolvedKeyframes, onComplete, name, motionValue, element) {
        (0, _classCallCheck._)(this, DOMKeyframesResolver);
        return (0, _callSuper._)(this, DOMKeyframesResolver, [
            unresolvedKeyframes,
            onComplete,
            name,
            motionValue,
            element,
            true
        ]);
    }
    (0, _createClass._)(DOMKeyframesResolver, [
        {
            key: "readKeyframes",
            value: function readKeyframes() {
                var _this = this, unresolvedKeyframes = _this.unresolvedKeyframes, element = _this.element, name = _this.name;
                if (!element || !element.current) return;
                (0, _get._)((0, _getPrototypeOf._)(DOMKeyframesResolver.prototype), "readKeyframes", this).call(this);
                /**
         * If any keyframe is a CSS variable, we need to find its value by sampling the element
         */ for(var i = 0; i < unresolvedKeyframes.length; i++){
                    var keyframe = unresolvedKeyframes[i];
                    if (typeof keyframe === "string") {
                        keyframe = keyframe.trim();
                        if ((0, _isCssVariableMjs.isCSSVariableToken)(keyframe)) {
                            var resolved = (0, _cssVariablesConversionMjs.getVariableValue)(keyframe, element.current);
                            if (resolved !== undefined) unresolvedKeyframes[i] = resolved;
                            if (i === unresolvedKeyframes.length - 1) this.finalKeyframe = keyframe;
                        }
                    }
                }
                /**
         * Resolve "none" values. We do this potentially twice - once before and once after measuring keyframes.
         * This could be seen as inefficient but it's a trade-off to avoid measurements in more situations, which
         * have a far bigger performance impact.
         */ this.resolveNoneKeyframes();
                /**
         * Check to see if unit type has changed. If so schedule jobs that will
         * temporarily set styles to the destination keyframes.
         * Skip if we have more than two keyframes or this isn't a positional value.
         * TODO: We can throw if there are multiple keyframes and the value type changes.
         */ if (!(0, _keysPositionMjs.positionalKeys).has(name) || unresolvedKeyframes.length !== 2) return;
                var _unresolvedKeyframes = (0, _slicedToArray._)(unresolvedKeyframes, 2), origin = _unresolvedKeyframes[0], target = _unresolvedKeyframes[1];
                var originType = (0, _dimensionsMjs.findDimensionValueType)(origin);
                var targetType = (0, _dimensionsMjs.findDimensionValueType)(target);
                /**
         * If one keyframe contains embedded CSS variables (e.g. in calc()) and the other
         * doesn't, we need to measure to convert to pixels. This handles GitHub issue #3410.
         */ var originHasVar = (0, _isCssVariableMjs.containsCSSVariable)(origin);
                var targetHasVar = (0, _isCssVariableMjs.containsCSSVariable)(target);
                if (originHasVar !== targetHasVar && (0, _unitConversionMjs.positionalValues)[name]) {
                    this.needsMeasurement = true;
                    return;
                }
                /**
         * Either we don't recognise these value types or we can animate between them.
         */ if (originType === targetType) return;
                /**
         * If both values are numbers or pixels, we can animate between them by
         * converting them to numbers.
         */ if ((0, _unitConversionMjs.isNumOrPxType)(originType) && (0, _unitConversionMjs.isNumOrPxType)(targetType)) for(var i1 = 0; i1 < unresolvedKeyframes.length; i1++){
                    var value = unresolvedKeyframes[i1];
                    if (typeof value === "string") unresolvedKeyframes[i1] = parseFloat(value);
                }
                else if ((0, _unitConversionMjs.positionalValues)[name]) /**
             * Else, the only way to resolve this is by measuring the element.
             */ this.needsMeasurement = true;
            }
        },
        {
            key: "resolveNoneKeyframes",
            value: function resolveNoneKeyframes() {
                var _this = this, unresolvedKeyframes = _this.unresolvedKeyframes, name = _this.name;
                var noneKeyframeIndexes = [];
                for(var i = 0; i < unresolvedKeyframes.length; i++)if (unresolvedKeyframes[i] === null || (0, _isNoneMjs.isNone)(unresolvedKeyframes[i])) noneKeyframeIndexes.push(i);
                if (noneKeyframeIndexes.length) (0, _makeNoneAnimatableMjs.makeNoneKeyframesAnimatable)(unresolvedKeyframes, noneKeyframeIndexes, name);
            }
        },
        {
            key: "measureInitialState",
            value: function measureInitialState() {
                var _this = this, element = _this.element, unresolvedKeyframes = _this.unresolvedKeyframes, name = _this.name;
                if (!element || !element.current) return;
                if (name === "height") this.suspendedScrollY = window.pageYOffset;
                this.measuredOrigin = (0, _unitConversionMjs.positionalValues)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
                unresolvedKeyframes[0] = this.measuredOrigin;
                // Set final key frame to measure after next render
                var measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
                if (measureKeyframe !== undefined) element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
            }
        },
        {
            key: "measureEndState",
            value: function measureEndState() {
                var _this_removedTransforms;
                var _this = this, element = _this.element, name = _this.name, unresolvedKeyframes = _this.unresolvedKeyframes;
                if (!element || !element.current) return;
                var value = element.getValue(name);
                value && value.jump(this.measuredOrigin, false);
                var finalKeyframeIndex = unresolvedKeyframes.length - 1;
                var finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
                unresolvedKeyframes[finalKeyframeIndex] = (0, _unitConversionMjs.positionalValues)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
                if (finalKeyframe !== null && this.finalKeyframe === undefined) this.finalKeyframe = finalKeyframe;
                // If we removed transform values, reapply them before the next render
                if ((_this_removedTransforms = this.removedTransforms) === null || _this_removedTransforms === void 0 ? void 0 : _this_removedTransforms.length) this.removedTransforms.forEach(function(param) {
                    var _param = (0, _slicedToArray._)(param, 2), unsetTransformName = _param[0], unsetTransformValue = _param[1];
                    element.getValue(unsetTransformName).set(unsetTransformValue);
                });
                this.resolveNoneKeyframes();
            }
        }
    ]);
    return DOMKeyframesResolver;
}((0, _keyframesResolverMjs.KeyframeResolver));

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_get":"38TLD","@swc/helpers/_/_get_prototype_of":"5txK6","@swc/helpers/_/_inherits":"2sfqW","@swc/helpers/_/_sliced_to_array":"8PtL6","../../render/utils/keys-position.mjs":"7MP49","../../value/types/dimensions.mjs":"lgLwV","../utils/css-variables-conversion.mjs":"9gQEb","../utils/is-css-variable.mjs":"5nV2N","./KeyframesResolver.mjs":"aeJtq","./utils/is-none.mjs":"9al84","./utils/make-none-animatable.mjs":"4zEqR","./utils/unit-conversion.mjs":"bpxYX","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lgLwV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dimensionValueTypes", function() {
    return dimensionValueTypes;
});
parcelHelpers.export(exports, "findDimensionValueType", function() {
    return findDimensionValueType;
});
var _autoMjs = require("./auto.mjs");
var _indexMjs = require("./numbers/index.mjs");
var _unitsMjs = require("./numbers/units.mjs");
var _testMjs = require("./test.mjs");
/**
 * A list of value types commonly used for dimensions
 */ var dimensionValueTypes = [
    (0, _indexMjs.number),
    (0, _unitsMjs.px),
    (0, _unitsMjs.percent),
    (0, _unitsMjs.degrees),
    (0, _unitsMjs.vw),
    (0, _unitsMjs.vh),
    (0, _autoMjs.auto)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ var findDimensionValueType = function(v) {
    return dimensionValueTypes.find((0, _testMjs.testValueType)(v));
};

},{"./auto.mjs":"dAZQf","./numbers/index.mjs":"l5BDX","./numbers/units.mjs":"iC5kO","./test.mjs":"33ooj","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dAZQf":[function(require,module,exports,__globalThis) {
/**
 * ValueType for "auto"
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "auto", function() {
    return auto;
});
var auto = {
    test: function(v) {
        return v === "auto";
    },
    parse: function(v) {
        return v;
    }
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"33ooj":[function(require,module,exports,__globalThis) {
/**
 * Tests a provided value against a ValueType
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "testValueType", function() {
    return testValueType;
});
var testValueType = function(v) {
    return function(type) {
        return type.test(v);
    };
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9al84":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNone", function() {
    return isNone;
});
var _motionUtils = require("motion-utils");
function isNone(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, _motionUtils.isZeroValueString)(value);
    else return true;
}

},{"motion-utils":"9Q5qC","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4zEqR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeNoneKeyframesAnimatable", function() {
    return makeNoneKeyframesAnimatable;
});
var _indexMjs = require("../../../value/types/complex/index.mjs");
var _animatableNoneMjs = require("../../../value/types/utils/animatable-none.mjs");
/**
 * If we encounter keyframes like "none" or "0" and we also have keyframes like
 * "#fff" or "200px 200px" we want to find a keyframe to serve as a template for
 * the "none" keyframes. In this case "#fff" or "200px 200px" - then these get turned into
 * zero equivalents, i.e. "#fff0" or "0px 0px".
 */ var invalidTemplates = new Set([
    "auto",
    "none",
    "0"
]);
function makeNoneKeyframesAnimatable(unresolvedKeyframes, noneKeyframeIndexes, name) {
    var i = 0;
    var animatableTemplate = undefined;
    while(i < unresolvedKeyframes.length && !animatableTemplate){
        var keyframe = unresolvedKeyframes[i];
        if (typeof keyframe === "string" && !invalidTemplates.has(keyframe) && (0, _indexMjs.analyseComplexValue)(keyframe).values.length) animatableTemplate = unresolvedKeyframes[i];
        i++;
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (animatableTemplate && name) try {
        for(var _iterator = noneKeyframeIndexes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var noneIndex = _step.value;
            unresolvedKeyframes[noneIndex] = (0, _animatableNoneMjs.getAnimatableNone)(name, animatableTemplate);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}

},{"../../../value/types/complex/index.mjs":"6JMtB","../../../value/types/utils/animatable-none.mjs":"2aLeu","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2aLeu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAnimatableNone", function() {
    return getAnimatableNone;
});
var _indexMjs = require("../complex/index.mjs");
var _filterMjs = require("../complex/filter.mjs");
var _maskMjs = require("../complex/mask.mjs");
var _defaultsMjs = require("../maps/defaults.mjs");
var customTypes = /*@__PURE__*/ new Set([
    (0, _filterMjs.filter),
    (0, _maskMjs.mask)
]);
function getAnimatableNone(key, value) {
    var defaultValueType = (0, _defaultsMjs.getDefaultValueType)(key);
    if (!customTypes.has(defaultValueType)) defaultValueType = (0, _indexMjs.complex);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}

},{"../complex/index.mjs":"6JMtB","../complex/filter.mjs":"eH2uQ","../complex/mask.mjs":"8iJLP","../maps/defaults.mjs":"1QOLD","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eH2uQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "filter", function() {
    return filter;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _indexMjs = require("./index.mjs");
var _floatRegexMjs = require("../utils/float-regex.mjs");
/**
 * Properties that should default to 1 or 100%
 */ var maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function applyDefaultFilter(v) {
    var _v_slice_split = (0, _slicedToArray._)(v.slice(0, -1).split("("), 2), name = _v_slice_split[0], value = _v_slice_split[1];
    if (name === "drop-shadow") return v;
    var _ref = (0, _slicedToArray._)(value.match((0, _floatRegexMjs.floatRegex)) || [], 1), number = _ref[0];
    if (!number) return v;
    var unit = value.replace(number, "");
    var defaultValue = maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
var functionRegex = RegExp("\\b([a-z-]*)\\(.*?\\)", "gu");
var filter = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _indexMjs.complex)), {
    getAnimatableNone: function(v) {
        var functions = v.match(functionRegex);
        return functions ? functions.map(applyDefaultFilter).join(" ") : v;
    }
});

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_sliced_to_array":"8PtL6","./index.mjs":"6JMtB","../utils/float-regex.mjs":"1DShP","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8iJLP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mask", function() {
    return mask;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _typeOf = require("@swc/helpers/_/_type_of");
var _indexMjs = require("./index.mjs");
var mask = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _indexMjs.complex)), {
    getAnimatableNone: function(v) {
        var parsed = (0, _indexMjs.complex).parse(v);
        var transformer = (0, _indexMjs.complex).createTransformer(v);
        return transformer(parsed.map(function(v) {
            return typeof v === "number" ? 0 : (typeof v === "undefined" ? "undefined" : (0, _typeOf._)(v)) === "object" ? (0, _objectSpreadProps._)((0, _objectSpread._)({}, v), {
                alpha: 1
            }) : v;
        }));
    }
});

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_type_of":"iFJdx","./index.mjs":"6JMtB","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1QOLD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultValueTypes", function() {
    return defaultValueTypes;
});
parcelHelpers.export(exports, "getDefaultValueType", function() {
    return getDefaultValueType;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _indexMjs = require("../color/index.mjs");
var _filterMjs = require("../complex/filter.mjs");
var _maskMjs = require("../complex/mask.mjs");
var _numberMjs = require("./number.mjs");
/**
 * A map of default value types for common values
 */ var defaultValueTypes = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _numberMjs.numberValueTypes)), {
    // Color props
    color: (0, _indexMjs.color),
    backgroundColor: (0, _indexMjs.color),
    outlineColor: (0, _indexMjs.color),
    fill: (0, _indexMjs.color),
    stroke: (0, _indexMjs.color),
    // Border props
    borderColor: (0, _indexMjs.color),
    borderTopColor: (0, _indexMjs.color),
    borderRightColor: (0, _indexMjs.color),
    borderBottomColor: (0, _indexMjs.color),
    borderLeftColor: (0, _indexMjs.color),
    filter: (0, _filterMjs.filter),
    WebkitFilter: (0, _filterMjs.filter),
    mask: (0, _maskMjs.mask),
    WebkitMask: (0, _maskMjs.mask)
});
/**
 * Gets the default ValueType for the provided value key
 */ var getDefaultValueType = function(key) {
    return defaultValueTypes[key];
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","../color/index.mjs":"gbu7c","../complex/filter.mjs":"eH2uQ","../complex/mask.mjs":"8iJLP","./number.mjs":"fcZR9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fcZR9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "numberValueTypes", function() {
    return numberValueTypes;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _intMjs = require("../int.mjs");
var _indexMjs = require("../numbers/index.mjs");
var _unitsMjs = require("../numbers/units.mjs");
var _transformMjs = require("./transform.mjs");
var numberValueTypes = (0, _objectSpreadProps._)((0, _objectSpread._)({
    // Border props
    borderWidth: (0, _unitsMjs.px),
    borderTopWidth: (0, _unitsMjs.px),
    borderRightWidth: (0, _unitsMjs.px),
    borderBottomWidth: (0, _unitsMjs.px),
    borderLeftWidth: (0, _unitsMjs.px),
    borderRadius: (0, _unitsMjs.px),
    borderTopLeftRadius: (0, _unitsMjs.px),
    borderTopRightRadius: (0, _unitsMjs.px),
    borderBottomRightRadius: (0, _unitsMjs.px),
    borderBottomLeftRadius: (0, _unitsMjs.px),
    // Positioning props
    width: (0, _unitsMjs.px),
    maxWidth: (0, _unitsMjs.px),
    height: (0, _unitsMjs.px),
    maxHeight: (0, _unitsMjs.px),
    top: (0, _unitsMjs.px),
    right: (0, _unitsMjs.px),
    bottom: (0, _unitsMjs.px),
    left: (0, _unitsMjs.px),
    inset: (0, _unitsMjs.px),
    insetBlock: (0, _unitsMjs.px),
    insetBlockStart: (0, _unitsMjs.px),
    insetBlockEnd: (0, _unitsMjs.px),
    insetInline: (0, _unitsMjs.px),
    insetInlineStart: (0, _unitsMjs.px),
    insetInlineEnd: (0, _unitsMjs.px),
    // Spacing props
    padding: (0, _unitsMjs.px),
    paddingTop: (0, _unitsMjs.px),
    paddingRight: (0, _unitsMjs.px),
    paddingBottom: (0, _unitsMjs.px),
    paddingLeft: (0, _unitsMjs.px),
    paddingBlock: (0, _unitsMjs.px),
    paddingBlockStart: (0, _unitsMjs.px),
    paddingBlockEnd: (0, _unitsMjs.px),
    paddingInline: (0, _unitsMjs.px),
    paddingInlineStart: (0, _unitsMjs.px),
    paddingInlineEnd: (0, _unitsMjs.px),
    margin: (0, _unitsMjs.px),
    marginTop: (0, _unitsMjs.px),
    marginRight: (0, _unitsMjs.px),
    marginBottom: (0, _unitsMjs.px),
    marginLeft: (0, _unitsMjs.px),
    marginBlock: (0, _unitsMjs.px),
    marginBlockStart: (0, _unitsMjs.px),
    marginBlockEnd: (0, _unitsMjs.px),
    marginInline: (0, _unitsMjs.px),
    marginInlineStart: (0, _unitsMjs.px),
    marginInlineEnd: (0, _unitsMjs.px),
    // Typography
    fontSize: (0, _unitsMjs.px),
    // Misc
    backgroundPositionX: (0, _unitsMjs.px),
    backgroundPositionY: (0, _unitsMjs.px)
}, (0, _transformMjs.transformValueTypes)), {
    zIndex: (0, _intMjs.int),
    // SVG
    fillOpacity: (0, _indexMjs.alpha),
    strokeOpacity: (0, _indexMjs.alpha),
    numOctaves: (0, _intMjs.int)
});

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","../int.mjs":"gBGB3","../numbers/index.mjs":"l5BDX","../numbers/units.mjs":"iC5kO","./transform.mjs":"fZEWC","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gBGB3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "int", function() {
    return int;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _indexMjs = require("./numbers/index.mjs");
var int = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _indexMjs.number)), {
    transform: Math.round
});

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","./numbers/index.mjs":"l5BDX","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fZEWC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "transformValueTypes", function() {
    return transformValueTypes;
});
var _indexMjs = require("../numbers/index.mjs");
var _unitsMjs = require("../numbers/units.mjs");
var transformValueTypes = {
    rotate: (0, _unitsMjs.degrees),
    rotateX: (0, _unitsMjs.degrees),
    rotateY: (0, _unitsMjs.degrees),
    rotateZ: (0, _unitsMjs.degrees),
    scale: (0, _indexMjs.scale),
    scaleX: (0, _indexMjs.scale),
    scaleY: (0, _indexMjs.scale),
    scaleZ: (0, _indexMjs.scale),
    skew: (0, _unitsMjs.degrees),
    skewX: (0, _unitsMjs.degrees),
    skewY: (0, _unitsMjs.degrees),
    distance: (0, _unitsMjs.px),
    translateX: (0, _unitsMjs.px),
    translateY: (0, _unitsMjs.px),
    translateZ: (0, _unitsMjs.px),
    x: (0, _unitsMjs.px),
    y: (0, _unitsMjs.px),
    z: (0, _unitsMjs.px),
    perspective: (0, _unitsMjs.px),
    transformPerspective: (0, _unitsMjs.px),
    opacity: (0, _indexMjs.alpha),
    originX: (0, _unitsMjs.progressPercentage),
    originY: (0, _unitsMjs.progressPercentage),
    originZ: (0, _unitsMjs.px)
};

},{"../numbers/index.mjs":"l5BDX","../numbers/units.mjs":"iC5kO","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6UTXu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applyPxDefaults", function() {
    return applyPxDefaults;
});
var _pxValuesMjs = require("../../waapi/utils/px-values.mjs");
function applyPxDefaults(keyframes, name) {
    for(var i = 0; i < keyframes.length; i++)if (typeof keyframes[i] === "number" && (0, _pxValuesMjs.pxValues).has(name)) keyframes[i] = keyframes[i] + "px";
}

},{"../../waapi/utils/px-values.mjs":"1lHAk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1lHAk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pxValues", function() {
    return pxValues;
});
var pxValues = new Set([
    // Border props
    "borderWidth",
    "borderTopWidth",
    "borderRightWidth",
    "borderBottomWidth",
    "borderLeftWidth",
    "borderRadius",
    "borderTopLeftRadius",
    "borderTopRightRadius",
    "borderBottomRightRadius",
    "borderBottomLeftRadius",
    // Positioning props
    "width",
    "maxWidth",
    "height",
    "maxHeight",
    "top",
    "right",
    "bottom",
    "left",
    "inset",
    "insetBlock",
    "insetBlockStart",
    "insetBlockEnd",
    "insetInline",
    "insetInlineStart",
    "insetInlineEnd",
    // Spacing props
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginBlock",
    "marginBlockStart",
    "marginBlockEnd",
    "marginInline",
    "marginInlineStart",
    "marginInlineEnd",
    // Typography
    "fontSize",
    // Misc
    "backgroundPositionX",
    "backgroundPositionY"
]);

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dW3WR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isWaapiSupportedEasing", function() {
    return isWaapiSupportedEasing;
});
var _motionUtils = require("motion-utils");
var _linearEasingMjs = require("../../../utils/supports/linear-easing.mjs");
var _supportedMjs = require("./supported.mjs");
function isWaapiSupportedEasing(easing) {
    return Boolean(typeof easing === "function" && (0, _linearEasingMjs.supportsLinearEasing)() || !easing || typeof easing === "string" && (easing in (0, _supportedMjs.supportedWaapiEasing) || (0, _linearEasingMjs.supportsLinearEasing)()) || (0, _motionUtils.isBezierDefinition)(easing) || Array.isArray(easing) && easing.every(isWaapiSupportedEasing));
}

},{"motion-utils":"9Q5qC","../../../utils/supports/linear-easing.mjs":"ewVKW","./supported.mjs":"biXOG","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"SUwK3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "supportsPartialKeyframes", function() {
    return supportsPartialKeyframes;
});
var _motionUtils = require("motion-utils");
var supportsPartialKeyframes = /*@__PURE__*/ (0, _motionUtils.memo)(function() {
    try {
        document.createElement("div").animate({
            opacity: [
                1
            ]
        });
    } catch (e) {
        return false;
    }
    return true;
});

},{"motion-utils":"9Q5qC","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"l5RVE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addAttrValue", function() {
    return addAttrValue;
});
parcelHelpers.export(exports, "attrEffect", function() {
    return attrEffect;
});
var _camelToDashMjs = require("../../render/dom/utils/camel-to-dash.mjs");
var _createDomEffectMjs = require("../utils/create-dom-effect.mjs");
var _createEffectMjs = require("../utils/create-effect.mjs");
function canSetAsProperty(element, name) {
    if (!(name in element)) return false;
    var descriptor = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(element), name) || Object.getOwnPropertyDescriptor(element, name);
    // Check if it has a setter
    return descriptor && typeof descriptor.set === "function";
}
var addAttrValue = function(element, state, key, value) {
    var isProp = canSetAsProperty(element, key);
    var name = isProp ? key : key.startsWith("data") || key.startsWith("aria") ? (0, _camelToDashMjs.camelToDash)(key) : key;
    /**
     * Set attribute directly via property if available
     */ var render = isProp ? function() {
        element[name] = state.latest[key];
    } : function() {
        var v = state.latest[key];
        if (v === null || v === undefined) element.removeAttribute(name);
        else element.setAttribute(name, String(v));
    };
    return state.set(key, value, render);
};
var attrEffect = /*@__PURE__*/ (0, _createDomEffectMjs.createSelectorEffect)(/*@__PURE__*/ (0, _createEffectMjs.createEffect)(addAttrValue));

},{"../../render/dom/utils/camel-to-dash.mjs":"2DA9K","../utils/create-dom-effect.mjs":"kv8Vx","../utils/create-effect.mjs":"dDguS","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kv8Vx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createSelectorEffect", function() {
    return createSelectorEffect;
});
var _resolveElementsMjs = require("../../utils/resolve-elements.mjs");
function createSelectorEffect(subjectEffect) {
    return function(subject, values) {
        var elements = (0, _resolveElementsMjs.resolveElements)(subject);
        var subscriptions = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var element = _step.value;
                var remove = subjectEffect(element, values);
                subscriptions.push(remove);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return function() {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = subscriptions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var remove = _step.value;
                    remove();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        };
    };
}

},{"../../utils/resolve-elements.mjs":"4pe2G","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4pe2G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveElements", function() {
    return resolveElements;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
function resolveElements(elementOrSelector, scope, selectorCache) {
    if (elementOrSelector == null) return [];
    if ((0, _instanceof._)(elementOrSelector, EventTarget)) return [
        elementOrSelector
    ];
    else if (typeof elementOrSelector === "string") {
        var root = document;
        if (scope) root = scope.current;
        var _selectorCache_elementOrSelector;
        var elements = (_selectorCache_elementOrSelector = selectorCache === null || selectorCache === void 0 ? void 0 : selectorCache[elementOrSelector]) !== null && _selectorCache_elementOrSelector !== void 0 ? _selectorCache_elementOrSelector : root.querySelectorAll(elementOrSelector);
        return elements ? Array.from(elements) : [];
    }
    return Array.from(elementOrSelector).filter(function(element) {
        return element != null;
    });
}

},{"@swc/helpers/_/_instanceof":"h9UKc","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dDguS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createEffect", function() {
    return createEffect;
});
var _motionValueStateMjs = require("../MotionValueState.mjs");
function createEffect(addValue) {
    var stateCache = new WeakMap();
    return function(subject, values) {
        var _stateCache_get;
        var state = (_stateCache_get = stateCache.get(subject)) !== null && _stateCache_get !== void 0 ? _stateCache_get : new (0, _motionValueStateMjs.MotionValueState)();
        stateCache.set(subject, state);
        var subscriptions = [];
        for(var key in values){
            var value = values[key];
            var remove = addValue(subject, state, key, value);
            subscriptions.push(remove);
        }
        return function() {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = subscriptions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var cancel = _step.value;
                    cancel();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        };
    };
}

},{"../MotionValueState.mjs":"eFgDQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eFgDQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MotionValueState", function() {
    return MotionValueState;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _frameMjs = require("../frameloop/frame.mjs");
var _numberMjs = require("../value/types/maps/number.mjs");
var _getAsTypeMjs = require("../value/types/utils/get-as-type.mjs");
var MotionValueState = /*#__PURE__*/ function() {
    "use strict";
    function MotionValueState() {
        (0, _classCallCheck._)(this, MotionValueState);
        this.latest = {};
        this.values = new Map();
    }
    (0, _createClass._)(MotionValueState, [
        {
            key: "set",
            value: function set(name, value, render, computed) {
                var _this = this;
                var useDefaultValueType = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : true;
                var existingValue = this.values.get(name);
                if (existingValue) existingValue.onRemove();
                var onChange = function() {
                    var v = value.get();
                    if (useDefaultValueType) _this.latest[name] = (0, _getAsTypeMjs.getValueAsType)(v, (0, _numberMjs.numberValueTypes)[name]);
                    else _this.latest[name] = v;
                    render && (0, _frameMjs.frame).render(render);
                };
                onChange();
                var cancelOnChange = value.on("change", onChange);
                computed && value.addDependent(computed);
                var remove = function() {
                    cancelOnChange();
                    render && (0, _frameMjs.cancelFrame)(render);
                    _this.values.delete(name);
                    computed && value.removeDependent(computed);
                };
                this.values.set(name, {
                    value: value,
                    onRemove: remove
                });
                return remove;
            }
        },
        {
            key: "get",
            value: function get(name) {
                var _this_values_get;
                return (_this_values_get = this.values.get(name)) === null || _this_values_get === void 0 ? void 0 : _this_values_get.value;
            }
        }
    ]);
    return MotionValueState;
}();

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","../frameloop/frame.mjs":"lxQZr","../value/types/maps/number.mjs":"fcZR9","../value/types/utils/get-as-type.mjs":"cE0Ua","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cE0Ua":[function(require,module,exports,__globalThis) {
/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getValueAsType", function() {
    return getValueAsType;
});
var getValueAsType = function(value, type) {
    return type && typeof value === "number" ? type.transform(value) : value;
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"koyRe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "propEffect", function() {
    return propEffect;
});
var _createEffectMjs = require("../utils/create-effect.mjs");
var propEffect = /*@__PURE__*/ (0, _createEffectMjs.createEffect)(function(subject, state, key, value) {
    return state.set(key, value, function() {
        subject[key] = state.latest[key];
    }, undefined, false);
});

},{"../utils/create-effect.mjs":"dDguS","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3eqaP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addStyleValue", function() {
    return addStyleValue;
});
parcelHelpers.export(exports, "styleEffect", function() {
    return styleEffect;
});
var _isCssVarMjs = require("../../render/dom/is-css-var.mjs");
var _keysTransformMjs = require("../../render/utils/keys-transform.mjs");
var _isHtmlElementMjs = require("../../utils/is-html-element.mjs");
var _indexMjs = require("../../value/index.mjs");
var _createDomEffectMjs = require("../utils/create-dom-effect.mjs");
var _createEffectMjs = require("../utils/create-effect.mjs");
var _transformMjs = require("./transform.mjs");
var originProps = new Set([
    "originX",
    "originY",
    "originZ"
]);
var addStyleValue = function(element, state, key, value) {
    var render = undefined;
    var computed = undefined;
    if ((0, _keysTransformMjs.transformProps).has(key)) {
        if (!state.get("transform")) {
            // If this is an HTML element, we need to set the transform-box to fill-box
            // to normalise the transform relative to the element's bounding box
            if (!(0, _isHtmlElementMjs.isHTMLElement)(element) && !state.get("transformBox")) addStyleValue(element, state, "transformBox", new (0, _indexMjs.MotionValue)("fill-box"));
            state.set("transform", new (0, _indexMjs.MotionValue)("none"), function() {
                element.style.transform = (0, _transformMjs.buildTransform)(state);
            });
        }
        computed = state.get("transform");
    } else if (originProps.has(key)) {
        if (!state.get("transformOrigin")) state.set("transformOrigin", new (0, _indexMjs.MotionValue)(""), function() {
            var _state_latest_originX;
            var originX = (_state_latest_originX = state.latest.originX) !== null && _state_latest_originX !== void 0 ? _state_latest_originX : "50%";
            var _state_latest_originY;
            var originY = (_state_latest_originY = state.latest.originY) !== null && _state_latest_originY !== void 0 ? _state_latest_originY : "50%";
            var _state_latest_originZ;
            var originZ = (_state_latest_originZ = state.latest.originZ) !== null && _state_latest_originZ !== void 0 ? _state_latest_originZ : 0;
            element.style.transformOrigin = "".concat(originX, " ").concat(originY, " ").concat(originZ);
        });
        computed = state.get("transformOrigin");
    } else if ((0, _isCssVarMjs.isCSSVar)(key)) render = function() {
        element.style.setProperty(key, state.latest[key]);
    };
    else render = function() {
        element.style[key] = state.latest[key];
    };
    return state.set(key, value, render, computed);
};
var styleEffect = /*@__PURE__*/ (0, _createDomEffectMjs.createSelectorEffect)(/*@__PURE__*/ (0, _createEffectMjs.createEffect)(addStyleValue));

},{"../../render/dom/is-css-var.mjs":"5Ukzo","../../render/utils/keys-transform.mjs":"91lmj","../../utils/is-html-element.mjs":"1mjTC","../../value/index.mjs":"lOANY","../utils/create-dom-effect.mjs":"kv8Vx","../utils/create-effect.mjs":"dDguS","./transform.mjs":"fbsUv","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1mjTC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isHTMLElement", function() {
    return isHTMLElement;
});
var _motionUtils = require("motion-utils");
/**
 * Checks if an element is an HTML element in a way
 * that works across iframes
 */ function isHTMLElement(element) {
    return (0, _motionUtils.isObject)(element) && "offsetHeight" in element && !("ownerSVGElement" in element);
}

},{"motion-utils":"9Q5qC","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fbsUv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildTransform", function() {
    return buildTransform;
});
var _keysTransformMjs = require("../../render/utils/keys-transform.mjs");
var translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
function buildTransform(state) {
    var transform = "";
    var transformIsDefault = true;
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(var i = 0; i < (0, _keysTransformMjs.transformPropOrder).length; i++){
        var key = (0, _keysTransformMjs.transformPropOrder)[i];
        var value = state.latest[key];
        if (value === undefined) continue;
        var valueIsDefault = true;
        if (typeof value === "number") valueIsDefault = value === (key.startsWith("scale") ? 1 : 0);
        else {
            var parsed = parseFloat(value);
            valueIsDefault = key.startsWith("scale") ? parsed === 1 : parsed === 0;
        }
        if (!valueIsDefault) {
            transformIsDefault = false;
            var transformName = translateAlias[key] || key;
            transform += "".concat(transformName, "(").concat(value, ") ");
        }
    }
    return transformIsDefault ? "none" : transform.trim();
}

},{"../../render/utils/keys-transform.mjs":"91lmj","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4zw5D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "svgEffect", function() {
    return svgEffect;
});
var _indexMjs = require("../../value/index.mjs");
var _indexMjs1 = require("../attr/index.mjs");
var _indexMjs2 = require("../style/index.mjs");
var _createDomEffectMjs = require("../utils/create-dom-effect.mjs");
var _createEffectMjs = require("../utils/create-effect.mjs");
var _frameMjs = require("../../frameloop/frame.mjs");
function addSVGPathValue(element, state, key, value) {
    (0, _frameMjs.frame).render(function() {
        return element.setAttribute("pathLength", "1");
    });
    if (key === "pathOffset") return state.set(key, value, function() {
        // Use unitless value to avoid Safari zoom bug
        var offset = state.latest[key];
        element.setAttribute("stroke-dashoffset", "".concat(-offset));
    });
    else {
        if (!state.get("stroke-dasharray")) state.set("stroke-dasharray", new (0, _indexMjs.MotionValue)("1 1"), function() {
            var _state_latest = state.latest, _state_latest_pathLength = _state_latest.pathLength, pathLength = _state_latest_pathLength === void 0 ? 1 : _state_latest_pathLength, pathSpacing = _state_latest.pathSpacing;
            // Use unitless values to avoid Safari zoom bug
            element.setAttribute("stroke-dasharray", "".concat(pathLength, " ").concat(pathSpacing !== null && pathSpacing !== void 0 ? pathSpacing : 1 - Number(pathLength)));
        });
        return state.set(key, value, undefined, state.get("stroke-dasharray"));
    }
}
var addSVGValue = function(element, state, key, value) {
    if (key.startsWith("path")) return addSVGPathValue(element, state, key, value);
    else if (key.startsWith("attr")) return (0, _indexMjs1.addAttrValue)(element, state, convertAttrKey(key), value);
    var handler = key in element.style ? (0, _indexMjs2.addStyleValue) : (0, _indexMjs1.addAttrValue);
    return handler(element, state, key, value);
};
var svgEffect = /*@__PURE__*/ (0, _createDomEffectMjs.createSelectorEffect)(/*@__PURE__*/ (0, _createEffectMjs.createEffect)(addSVGValue));
function convertAttrKey(key) {
    return key.replace(/^attr([A-Z])/, function(_, firstChar) {
        return firstChar.toLowerCase();
    });
}

},{"../../value/index.mjs":"lOANY","../attr/index.mjs":"l5RVE","../style/index.mjs":"3eqaP","../utils/create-dom-effect.mjs":"kv8Vx","../utils/create-effect.mjs":"dDguS","../../frameloop/frame.mjs":"lxQZr","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"icPpP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cancelMicrotask", function() {
    return cancelMicrotask;
});
parcelHelpers.export(exports, "microtask", function() {
    return microtask;
});
var _batcherMjs = require("./batcher.mjs");
var /* @__PURE__ */ _createRenderBatcher = (0, _batcherMjs.createRenderBatcher)(queueMicrotask, false), microtask = _createRenderBatcher.schedule, cancelMicrotask = _createRenderBatcher.cancel;

},{"./batcher.mjs":"dVA5A","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eNLFf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isDragActive", function() {
    return isDragActive;
});
parcelHelpers.export(exports, "isDragging", function() {
    return isDragging;
});
var isDragging = {
    x: false,
    y: false
};
function isDragActive() {
    return isDragging.x || isDragging.y;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gVAtS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setDragLock", function() {
    return setDragLock;
});
var _isActiveMjs = require("./is-active.mjs");
function setDragLock(axis) {
    if (axis === "x" || axis === "y") {
        if ((0, _isActiveMjs.isDragging)[axis]) return null;
        else {
            (0, _isActiveMjs.isDragging)[axis] = true;
            return function() {
                (0, _isActiveMjs.isDragging)[axis] = false;
            };
        }
    } else {
        if ((0, _isActiveMjs.isDragging).x || (0, _isActiveMjs.isDragging).y) return null;
        else {
            (0, _isActiveMjs.isDragging).x = (0, _isActiveMjs.isDragging).y = true;
            return function() {
                (0, _isActiveMjs.isDragging).x = (0, _isActiveMjs.isDragging).y = false;
            };
        }
    }
}

},{"./is-active.mjs":"eNLFf","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6nSd0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hover", function() {
    return hover;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _isActiveMjs = require("./drag/state/is-active.mjs");
var _setupMjs = require("./utils/setup.mjs");
function isValidHover(event) {
    return !(event.pointerType === "touch" || (0, _isActiveMjs.isDragActive)());
}
/**
 * Create a hover gesture. hover() is different to .addEventListener("pointerenter")
 * in that it has an easier syntax, filters out polyfilled touch events, interoperates
 * with drag gestures, and automatically removes the "pointerennd" event listener when the hover ends.
 *
 * @public
 */ function hover(elementOrSelector, onHoverStart) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var _setupGesture = (0, _slicedToArray._)((0, _setupMjs.setupGesture)(elementOrSelector, options), 3), elements = _setupGesture[0], eventOptions = _setupGesture[1], cancel = _setupGesture[2];
    elements.forEach(function(element) {
        var isPressed = false;
        var deferredHoverEnd = false;
        var hoverEndCallback;
        var removePointerLeave = function() {
            element.removeEventListener("pointerleave", onPointerLeave);
        };
        var endHover = function(event) {
            if (hoverEndCallback) {
                hoverEndCallback(event);
                hoverEndCallback = undefined;
            }
            removePointerLeave();
        };
        var onPointerUp = function(event) {
            isPressed = false;
            window.removeEventListener("pointerup", onPointerUp);
            window.removeEventListener("pointercancel", onPointerUp);
            if (deferredHoverEnd) {
                deferredHoverEnd = false;
                endHover(event);
            }
        };
        var onPointerDown = function() {
            isPressed = true;
            window.addEventListener("pointerup", onPointerUp, eventOptions);
            window.addEventListener("pointercancel", onPointerUp, eventOptions);
        };
        var onPointerLeave = function(leaveEvent) {
            if (leaveEvent.pointerType === "touch") return;
            if (isPressed) {
                deferredHoverEnd = true;
                return;
            }
            endHover(leaveEvent);
        };
        var onPointerEnter = function(enterEvent) {
            if (!isValidHover(enterEvent)) return;
            deferredHoverEnd = false;
            var onHoverEnd = onHoverStart(element, enterEvent);
            if (typeof onHoverEnd !== "function") return;
            hoverEndCallback = onHoverEnd;
            element.addEventListener("pointerleave", onPointerLeave, eventOptions);
        };
        element.addEventListener("pointerenter", onPointerEnter, eventOptions);
        element.addEventListener("pointerdown", onPointerDown, eventOptions);
    });
    return cancel;
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","./drag/state/is-active.mjs":"eNLFf","./utils/setup.mjs":"j4uUj","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"j4uUj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setupGesture", function() {
    return setupGesture;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _resolveElementsMjs = require("../../utils/resolve-elements.mjs");
function setupGesture(elementOrSelector, options) {
    var elements = (0, _resolveElementsMjs.resolveElements)(elementOrSelector);
    var gestureAbortController = new AbortController();
    var eventOptions = (0, _objectSpreadProps._)((0, _objectSpread._)({
        passive: true
    }, options), {
        signal: gestureAbortController.signal
    });
    var cancel = function() {
        return gestureAbortController.abort();
    };
    return [
        elements,
        eventOptions,
        cancel
    ];
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","../../utils/resolve-elements.mjs":"4pe2G","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eMPTL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "press", function() {
    return press;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _isHtmlElementMjs = require("../../utils/is-html-element.mjs");
var _isActiveMjs = require("../drag/state/is-active.mjs");
var _isNodeOrChildMjs = require("../utils/is-node-or-child.mjs");
var _isPrimaryPointerMjs = require("../utils/is-primary-pointer.mjs");
var _setupMjs = require("../utils/setup.mjs");
var _isKeyboardAccessibleMjs = require("./utils/is-keyboard-accessible.mjs");
var _keyboardMjs = require("./utils/keyboard.mjs");
var _stateMjs = require("./utils/state.mjs");
/**
 * Filter out events that are not primary pointer events, or are triggering
 * while a Motion gesture is active.
 */ function isValidPressEvent(event) {
    return (0, _isPrimaryPointerMjs.isPrimaryPointer)(event) && !(0, _isActiveMjs.isDragActive)();
}
var claimedPointerDownEvents = new WeakSet();
/**
 * Create a press gesture.
 *
 * Press is different to `"pointerdown"`, `"pointerup"` in that it
 * automatically filters out secondary pointer events like right
 * click and multitouch.
 *
 * It also adds accessibility support for keyboards, where
 * an element with a press gesture will receive focus and
 *  trigger on Enter `"keydown"` and `"keyup"` events.
 *
 * This is different to a browser's `"click"` event, which does
 * respond to keyboards but only for the `"click"` itself, rather
 * than the press start and end/cancel. The element also needs
 * to be focusable for this to work, whereas a press gesture will
 * make an element focusable by default.
 *
 * @public
 */ function press(targetOrSelector, onPressStart) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var _setupGesture = (0, _slicedToArray._)((0, _setupMjs.setupGesture)(targetOrSelector, options), 3), targets = _setupGesture[0], eventOptions = _setupGesture[1], cancelEvents = _setupGesture[2];
    var startPress = function(startEvent) {
        var target = startEvent.currentTarget;
        if (!isValidPressEvent(startEvent)) return;
        if (claimedPointerDownEvents.has(startEvent)) return;
        (0, _stateMjs.isPressing).add(target);
        if (options.stopPropagation) claimedPointerDownEvents.add(startEvent);
        var onPressEnd = onPressStart(target, startEvent);
        var onPointerEnd = function(endEvent, success) {
            window.removeEventListener("pointerup", onPointerUp);
            window.removeEventListener("pointercancel", onPointerCancel);
            if ((0, _stateMjs.isPressing).has(target)) (0, _stateMjs.isPressing).delete(target);
            if (!isValidPressEvent(endEvent)) return;
            if (typeof onPressEnd === "function") onPressEnd(endEvent, {
                success: success
            });
        };
        var onPointerUp = function(upEvent) {
            onPointerEnd(upEvent, target === window || target === document || options.useGlobalTarget || (0, _isNodeOrChildMjs.isNodeOrChild)(target, upEvent.target));
        };
        var onPointerCancel = function(cancelEvent) {
            onPointerEnd(cancelEvent, false);
        };
        window.addEventListener("pointerup", onPointerUp, eventOptions);
        window.addEventListener("pointercancel", onPointerCancel, eventOptions);
    };
    targets.forEach(function(target) {
        var pointerDownTarget = options.useGlobalTarget ? window : target;
        pointerDownTarget.addEventListener("pointerdown", startPress, eventOptions);
        if ((0, _isHtmlElementMjs.isHTMLElement)(target)) {
            target.addEventListener("focus", function(event) {
                return (0, _keyboardMjs.enableKeyboardPress)(event, eventOptions);
            });
            if (!(0, _isKeyboardAccessibleMjs.isElementKeyboardAccessible)(target) && !target.hasAttribute("tabindex")) target.tabIndex = 0;
        }
    });
    return cancelEvents;
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","../../utils/is-html-element.mjs":"1mjTC","../drag/state/is-active.mjs":"eNLFf","../utils/is-node-or-child.mjs":"5ZdeE","../utils/is-primary-pointer.mjs":"CTZIR","../utils/setup.mjs":"j4uUj","./utils/is-keyboard-accessible.mjs":"8b5no","./utils/keyboard.mjs":"lUaPc","./utils/state.mjs":"cjjmc","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5ZdeE":[function(require,module,exports,__globalThis) {
/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNodeOrChild", function() {
    return isNodeOrChild;
});
var isNodeOrChild = function(parent, child) {
    if (!child) return false;
    else if (parent === child) return true;
    else return isNodeOrChild(parent, child.parentElement);
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"CTZIR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isPrimaryPointer", function() {
    return isPrimaryPointer;
});
var isPrimaryPointer = function(event) {
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8b5no":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isElementKeyboardAccessible", function() {
    return isElementKeyboardAccessible;
});
parcelHelpers.export(exports, "isElementTextInput", function() {
    return isElementTextInput;
});
var keyboardAccessibleElements = new Set([
    "BUTTON",
    "INPUT",
    "SELECT",
    "TEXTAREA",
    "A"
]);
/**
 * Checks if an element is natively keyboard accessible (focusable).
 * Used by the press gesture to determine if we need to add tabIndex.
 */ function isElementKeyboardAccessible(element) {
    return keyboardAccessibleElements.has(element.tagName) || element.isContentEditable === true;
}
var textInputElements = new Set([
    "INPUT",
    "SELECT",
    "TEXTAREA"
]);
/**
 * Checks if an element has text selection or direct interaction behavior
 * that should block drag gestures from starting.
 *
 * This specifically targets form controls where the user might want to select
 * text or interact with the control (e.g., sliders, dropdowns).
 *
 * Buttons and links are NOT included because they don't have click-and-move
 * actions of their own - they only respond to click events, so dragging
 * should still work when initiated from these elements.
 */ function isElementTextInput(element) {
    return textInputElements.has(element.tagName) || element.isContentEditable === true;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lUaPc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "enableKeyboardPress", function() {
    return enableKeyboardPress;
});
var _stateMjs = require("./state.mjs");
/**
 * Filter out events that are not "Enter" keys.
 */ function filterEvents(callback) {
    return function(event) {
        if (event.key !== "Enter") return;
        callback(event);
    };
}
function firePointerEvent(target, type) {
    target.dispatchEvent(new PointerEvent("pointer" + type, {
        isPrimary: true,
        bubbles: true
    }));
}
var enableKeyboardPress = function(focusEvent, eventOptions) {
    var element = focusEvent.currentTarget;
    if (!element) return;
    var handleKeydown = filterEvents(function() {
        if ((0, _stateMjs.isPressing).has(element)) return;
        firePointerEvent(element, "down");
        var handleKeyup = filterEvents(function() {
            firePointerEvent(element, "up");
        });
        var handleBlur = function() {
            return firePointerEvent(element, "cancel");
        };
        element.addEventListener("keyup", handleKeyup, eventOptions);
        element.addEventListener("blur", handleBlur, eventOptions);
    });
    element.addEventListener("keydown", handleKeydown, eventOptions);
    /**
     * Add an event listener that fires on blur to remove the keydown events.
     */ element.addEventListener("blur", function() {
        return element.removeEventListener("keydown", handleKeydown);
    }, eventOptions);
};

},{"./state.mjs":"cjjmc","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cjjmc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isPressing", function() {
    return isPressing;
});
var isPressing = new WeakSet();

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gDOz3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getComputedStyle", function() {
    return getComputedStyle;
});
var _isCssVarMjs = require("./is-css-var.mjs");
function getComputedStyle(element, name) {
    var computedStyle = window.getComputedStyle(element);
    return (0, _isCssVarMjs.isCSSVar)(name) ? computedStyle.getPropertyValue(name) : computedStyle[name];
}

},{"./is-css-var.mjs":"5Ukzo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dLN7G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resize", function() {
    return resize;
});
var _handleElementMjs = require("./handle-element.mjs");
var _handleWindowMjs = require("./handle-window.mjs");
function resize(a, b) {
    return typeof a === "function" ? (0, _handleWindowMjs.resizeWindow)(a) : (0, _handleElementMjs.resizeElement)(a, b);
}

},{"./handle-element.mjs":"eUfco","./handle-window.mjs":"aOznh","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eUfco":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resizeElement", function() {
    return resizeElement;
});
var _isSvgElementMjs = require("../utils/is-svg-element.mjs");
var _resolveElementsMjs = require("../utils/resolve-elements.mjs");
var resizeHandlers = new WeakMap();
var observer;
var getSize = function(borderBoxAxis, svgAxis, htmlAxis) {
    return function(target, borderBoxSize) {
        if (borderBoxSize && borderBoxSize[0]) return borderBoxSize[0][borderBoxAxis + "Size"];
        else if ((0, _isSvgElementMjs.isSVGElement)(target) && "getBBox" in target) return target.getBBox()[svgAxis];
        else return target[htmlAxis];
    };
};
var getWidth = /*@__PURE__*/ getSize("inline", "width", "offsetWidth");
var getHeight = /*@__PURE__*/ getSize("block", "height", "offsetHeight");
function notifyTarget(param) {
    var target = param.target, borderBoxSize = param.borderBoxSize;
    var _resizeHandlers_get;
    (_resizeHandlers_get = resizeHandlers.get(target)) === null || _resizeHandlers_get === void 0 ? void 0 : _resizeHandlers_get.forEach(function(handler) {
        handler(target, {
            get width () {
                return getWidth(target, borderBoxSize);
            },
            get height () {
                return getHeight(target, borderBoxSize);
            }
        });
    });
}
function notifyAll(entries) {
    entries.forEach(notifyTarget);
}
function createResizeObserver() {
    if (typeof ResizeObserver === "undefined") return;
    observer = new ResizeObserver(notifyAll);
}
function resizeElement(target, handler) {
    if (!observer) createResizeObserver();
    var elements = (0, _resolveElementsMjs.resolveElements)(target);
    elements.forEach(function(element) {
        var elementHandlers = resizeHandlers.get(element);
        if (!elementHandlers) {
            elementHandlers = new Set();
            resizeHandlers.set(element, elementHandlers);
        }
        elementHandlers.add(handler);
        observer === null || observer === void 0 ? void 0 : observer.observe(element);
    });
    return function() {
        elements.forEach(function(element) {
            var elementHandlers = resizeHandlers.get(element);
            elementHandlers === null || elementHandlers === void 0 ? void 0 : elementHandlers.delete(handler);
            if (!(elementHandlers === null || elementHandlers === void 0 ? void 0 : elementHandlers.size)) observer === null || observer === void 0 ? void 0 : observer.unobserve(element);
        });
    };
}

},{"../utils/is-svg-element.mjs":"3tMgU","../utils/resolve-elements.mjs":"4pe2G","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3tMgU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isSVGElement", function() {
    return isSVGElement;
});
var _motionUtils = require("motion-utils");
/**
 * Checks if an element is an SVG element in a way
 * that works across iframes
 */ function isSVGElement(element) {
    return (0, _motionUtils.isObject)(element) && "ownerSVGElement" in element;
}

},{"motion-utils":"9Q5qC","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aOznh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resizeWindow", function() {
    return resizeWindow;
});
var windowCallbacks = new Set();
var windowResizeHandler;
function createWindowResizeHandler() {
    windowResizeHandler = function() {
        var info = {
            get width () {
                return window.innerWidth;
            },
            get height () {
                return window.innerHeight;
            }
        };
        windowCallbacks.forEach(function(callback) {
            return callback(info);
        });
    };
    window.addEventListener("resize", windowResizeHandler);
}
function resizeWindow(callback) {
    windowCallbacks.add(callback);
    if (!windowResizeHandler) createWindowResizeHandler();
    return function() {
        windowCallbacks.delete(callback);
        if (!windowCallbacks.size && typeof windowResizeHandler === "function") {
            window.removeEventListener("resize", windowResizeHandler);
            windowResizeHandler = undefined;
        }
    };
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ejcM8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "observeTimeline", function() {
    return observeTimeline;
});
var _frameMjs = require("../frameloop/frame.mjs");
function observeTimeline(update, timeline) {
    var prevProgress;
    var onFrame = function() {
        var currentTime = timeline.currentTime;
        var percentage = currentTime === null ? 0 : currentTime.value;
        var progress = percentage / 100;
        if (prevProgress !== progress) update(progress);
        prevProgress = progress;
    };
    (0, _frameMjs.frame).preUpdate(onFrame, true);
    return function() {
        return (0, _frameMjs.cancelFrame)(onFrame);
    };
}

},{"../frameloop/frame.mjs":"lxQZr","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9elgm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "recordStats", function() {
    return recordStats;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _animationCountMjs = require("./animation-count.mjs");
var _bufferMjs = require("./buffer.mjs");
var _frameMjs = require("../frameloop/frame.mjs");
function record() {
    var value = (0, _bufferMjs.statsBuffer).value;
    if (value === null) {
        (0, _frameMjs.cancelFrame)(record);
        return;
    }
    value.frameloop.rate.push((0, _frameMjs.frameData).delta);
    value.animations.mainThread.push((0, _animationCountMjs.activeAnimations).mainThread);
    value.animations.waapi.push((0, _animationCountMjs.activeAnimations).waapi);
    value.animations.layout.push((0, _animationCountMjs.activeAnimations).layout);
}
function mean(values) {
    return values.reduce(function(acc, value) {
        return acc + value;
    }, 0) / values.length;
}
function summarise(values) {
    var calcAverage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : mean;
    var _Math, _Math1;
    if (values.length === 0) return {
        min: 0,
        max: 0,
        avg: 0
    };
    return {
        min: (_Math = Math).min.apply(_Math, (0, _toConsumableArray._)(values)),
        max: (_Math1 = Math).max.apply(_Math1, (0, _toConsumableArray._)(values)),
        avg: calcAverage(values)
    };
}
var msToFps = function(ms) {
    return Math.round(1000 / ms);
};
function clearStatsBuffer() {
    (0, _bufferMjs.statsBuffer).value = null;
    (0, _bufferMjs.statsBuffer).addProjectionMetrics = null;
}
function reportStats() {
    var value = (0, _bufferMjs.statsBuffer).value;
    if (!value) throw new Error("Stats are not being measured");
    clearStatsBuffer();
    (0, _frameMjs.cancelFrame)(record);
    var summary = {
        frameloop: {
            setup: summarise(value.frameloop.setup),
            rate: summarise(value.frameloop.rate),
            read: summarise(value.frameloop.read),
            resolveKeyframes: summarise(value.frameloop.resolveKeyframes),
            preUpdate: summarise(value.frameloop.preUpdate),
            update: summarise(value.frameloop.update),
            preRender: summarise(value.frameloop.preRender),
            render: summarise(value.frameloop.render),
            postRender: summarise(value.frameloop.postRender)
        },
        animations: {
            mainThread: summarise(value.animations.mainThread),
            waapi: summarise(value.animations.waapi),
            layout: summarise(value.animations.layout)
        },
        layoutProjection: {
            nodes: summarise(value.layoutProjection.nodes),
            calculatedTargetDeltas: summarise(value.layoutProjection.calculatedTargetDeltas),
            calculatedProjections: summarise(value.layoutProjection.calculatedProjections)
        }
    };
    /**
     * Convert the rate to FPS
     */ var rate = summary.frameloop.rate;
    rate.min = msToFps(rate.min);
    rate.max = msToFps(rate.max);
    rate.avg = msToFps(rate.avg);
    var ref;
    ref = [
        rate.max,
        rate.min
    ], rate.min = ref[0], rate.max = ref[1], ref;
    return summary;
}
function recordStats() {
    if ((0, _bufferMjs.statsBuffer).value) {
        clearStatsBuffer();
        throw new Error("Stats are already being measured");
    }
    var newStatsBuffer = (0, _bufferMjs.statsBuffer);
    newStatsBuffer.value = {
        frameloop: {
            setup: [],
            rate: [],
            read: [],
            resolveKeyframes: [],
            preUpdate: [],
            update: [],
            preRender: [],
            render: [],
            postRender: []
        },
        animations: {
            mainThread: [],
            waapi: [],
            layout: []
        },
        layoutProjection: {
            nodes: [],
            calculatedTargetDeltas: [],
            calculatedProjections: []
        }
    };
    newStatsBuffer.addProjectionMetrics = function(metrics) {
        var layoutProjection = newStatsBuffer.value.layoutProjection;
        layoutProjection.nodes.push(metrics.nodes);
        layoutProjection.calculatedTargetDeltas.push(metrics.calculatedTargetDeltas);
        layoutProjection.calculatedProjections.push(metrics.calculatedProjections);
    };
    (0, _frameMjs.frame).postRender(record, true);
    return reportStats;
}

},{"@swc/helpers/_/_to_consumable_array":"1eSZf","./animation-count.mjs":"gY9Wc","./buffer.mjs":"bcR1L","../frameloop/frame.mjs":"lxQZr","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"o8RpJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isSVGSVGElement", function() {
    return isSVGSVGElement;
});
var _isSvgElementMjs = require("./is-svg-element.mjs");
/**
 * Checks if an element is specifically an SVGSVGElement (the root SVG element)
 * in a way that works across iframes
 */ function isSVGSVGElement(element) {
    return (0, _isSvgElementMjs.isSVGElement)(element) && element.tagName === "svg";
}

},{"./is-svg-element.mjs":"3tMgU","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bnye7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOriginIndex", function() {
    return getOriginIndex;
});
parcelHelpers.export(exports, "stagger", function() {
    return stagger;
});
var _motionUtils = require("motion-utils");
function getOriginIndex(from, total) {
    if (from === "first") return 0;
    else {
        var lastIndex = total - 1;
        return from === "last" ? lastIndex : lastIndex / 2;
    }
}
function stagger() {
    var duration = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0.1, _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_startDelay = _ref.startDelay, startDelay = _ref_startDelay === void 0 ? 0 : _ref_startDelay, _ref_from = _ref.from, from = _ref_from === void 0 ? 0 : _ref_from, ease = _ref.ease;
    return function(i, total) {
        var fromIndex = typeof from === "number" ? from : getOriginIndex(from, total);
        var distance = Math.abs(fromIndex - i);
        var delay = duration * distance;
        if (ease) {
            var maxDelay = total * duration;
            var easingFunction = (0, _motionUtils.easingDefinitionToFunction)(ease);
            delay = easingFunction(delay / maxDelay) * maxDelay;
        }
        return startDelay + delay;
    };
}

},{"motion-utils":"9Q5qC","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2QzHU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "transform", function() {
    return transform;
});
var _interpolateMjs = require("./interpolate.mjs");
function transform() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var useImmediate = !Array.isArray(args[0]);
    var argOffset = useImmediate ? 0 : -1;
    var inputValue = args[0 + argOffset];
    var inputRange = args[1 + argOffset];
    var outputRange = args[2 + argOffset];
    var options = args[3 + argOffset];
    var interpolator = (0, _interpolateMjs.interpolate)(inputRange, outputRange, options);
    return useImmediate ? interpolator(inputValue) : interpolator;
}

},{"./interpolate.mjs":"c1Uzm","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"h0xh3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "attachFollow", function() {
    return attachFollow;
});
parcelHelpers.export(exports, "followValue", function() {
    return followValue;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _indexMjs = require("./index.mjs");
var _jsanimationMjs = require("../animation/JSAnimation.mjs");
var _isMotionValueMjs = require("./utils/is-motion-value.mjs");
var _frameMjs = require("../frameloop/frame.mjs");
/**
 * Create a `MotionValue` that animates to its latest value using any transition type.
 * Can either be a value or track another `MotionValue`.
 *
 * ```jsx
 * const x = motionValue(0)
 * const y = followValue(x, { type: "spring", stiffness: 300 })
 * // or with tween
 * const z = followValue(x, { type: "tween", duration: 0.5, ease: "easeOut" })
 * ```
 *
 * @param source - Initial value or MotionValue to track
 * @param options - Animation transition options
 * @returns `MotionValue`
 *
 * @public
 */ function followValue(source, options) {
    var initialValue = (0, _isMotionValueMjs.isMotionValue)(source) ? source.get() : source;
    var value = (0, _indexMjs.motionValue)(initialValue);
    attachFollow(value, source, options);
    return value;
}
/**
 * Attach an animation to a MotionValue that will animate whenever the value changes.
 * Similar to attachSpring but supports any transition type (spring, tween, inertia, etc.)
 *
 * @param value - The MotionValue to animate
 * @param source - Initial value or MotionValue to track
 * @param options - Animation transition options
 * @returns Cleanup function
 *
 * @public
 */ function attachFollow(value, source) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var initialValue = value.get();
    var activeAnimation = null;
    var latestValue = initialValue;
    var latestSetter;
    var unit = typeof initialValue === "string" ? initialValue.replace(/[\d.-]/g, "") : undefined;
    var stopAnimation = function() {
        if (activeAnimation) {
            activeAnimation.stop();
            activeAnimation = null;
        }
        value.animation = undefined;
    };
    var startAnimation = function() {
        var currentValue = asNumber(value.get());
        var targetValue = asNumber(latestValue);
        // Don't animate if we're already at the target
        if (currentValue === targetValue) {
            stopAnimation();
            return;
        }
        // Use the running animation's analytical velocity for accuracy,
        // falling back to the MotionValue's velocity for the initial animation.
        // This prevents systematic velocity loss at high frame rates (240hz+).
        var velocity = activeAnimation ? activeAnimation.getGeneratorVelocity() : value.getVelocity();
        stopAnimation();
        activeAnimation = new (0, _jsanimationMjs.JSAnimation)((0, _objectSpreadProps._)((0, _objectSpread._)({
            keyframes: [
                currentValue,
                targetValue
            ],
            velocity: velocity,
            // Default to spring if no type specified (matches useSpring behavior)
            type: "spring",
            restDelta: 0.001,
            restSpeed: 0.01
        }, options), {
            onUpdate: latestSetter
        }));
    };
    // Use a stable function reference so the frame loop Set deduplicates
    // multiple calls within the same frame (e.g. rapid mouse events)
    var scheduleAnimation = function() {
        var _value_events_animationStart;
        startAnimation();
        value.animation = activeAnimation !== null && activeAnimation !== void 0 ? activeAnimation : undefined;
        (_value_events_animationStart = value["events"].animationStart) === null || _value_events_animationStart === void 0 ? void 0 : _value_events_animationStart.notify();
        activeAnimation === null || activeAnimation === void 0 ? void 0 : activeAnimation.then(function() {
            var _value_events_animationComplete;
            value.animation = undefined;
            (_value_events_animationComplete = value["events"].animationComplete) === null || _value_events_animationComplete === void 0 ? void 0 : _value_events_animationComplete.notify();
        });
    };
    value.attach(function(v, set) {
        latestValue = v;
        latestSetter = function(latest) {
            return set(parseValue(latest, unit));
        };
        (0, _frameMjs.frame).postRender(scheduleAnimation);
    }, stopAnimation);
    if ((0, _isMotionValueMjs.isMotionValue)(source)) {
        var skipNextAnimation = options.skipInitialAnimation === true;
        var removeSourceOnChange = source.on("change", function(v) {
            if (skipNextAnimation) {
                skipNextAnimation = false;
                value.jump(parseValue(v, unit), false);
            } else value.set(parseValue(v, unit));
        });
        var removeValueOnDestroy = value.on("destroy", removeSourceOnChange);
        return function() {
            removeSourceOnChange();
            removeValueOnDestroy();
        };
    }
    return stopAnimation;
}
function parseValue(v, unit) {
    return unit ? v + unit : v;
}
function asNumber(v) {
    return typeof v === "number" ? v : parseFloat(v);
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","./index.mjs":"lOANY","../animation/JSAnimation.mjs":"9nspW","./utils/is-motion-value.mjs":"cYNey","../frameloop/frame.mjs":"lxQZr","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"exG8F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapValue", function() {
    return mapValue;
});
var _transformMjs = require("../utils/transform.mjs");
var _transformValueMjs = require("./transform-value.mjs");
/**
 * Create a `MotionValue` that maps the output of another `MotionValue` by
 * mapping it from one range of values into another.
 *
 * @remarks
 *
 * Given an input range of `[-200, -100, 100, 200]` and an output range of
 * `[0, 1, 1, 0]`, the returned `MotionValue` will:
 *
 * - When provided a value between `-200` and `-100`, will return a value between `0` and  `1`.
 * - When provided a value between `-100` and `100`, will return `1`.
 * - When provided a value between `100` and `200`, will return a value between `1` and  `0`
 *
 * The input range must be a linear series of numbers. The output range
 * can be any value type supported by Motion: numbers, colors, shadows, etc.
 *
 * Every value in the output range must be of the same type and in the same format.
 *
 * ```jsx
 * const x = motionValue(0)
 * const xRange = [-200, -100, 100, 200]
 * const opacityRange = [0, 1, 1, 0]
 * const opacity = mapValue(x, xRange, opacityRange)
 * ```
 *
 * @param inputValue - `MotionValue`
 * @param inputRange - A linear series of numbers (either all increasing or decreasing)
 * @param outputRange - A series of numbers, colors or strings. Must be the same length as `inputRange`.
 * @param options -
 *
 *  - clamp: boolean. Clamp values to within the given range. Defaults to `true`
 *  - ease: EasingFunction[]. Easing functions to use on the interpolations between each value in the input and output ranges. If provided as an array, the array must be one item shorter than the input and output ranges, as the easings apply to the transition between each.
 *
 * @returns `MotionValue`
 *
 * @public
 */ function mapValue(inputValue, inputRange, outputRange, options) {
    var map = (0, _transformMjs.transform)(inputRange, outputRange, options);
    return (0, _transformValueMjs.transformValue)(function() {
        return map(inputValue.get());
    });
}

},{"../utils/transform.mjs":"2QzHU","./transform-value.mjs":"5PKnG","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5PKnG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "transformValue", function() {
    return transformValue;
});
var _indexMjs = require("./index.mjs");
var _subscribeValueMjs = require("./subscribe-value.mjs");
/**
 * Create a `MotionValue` that transforms the output of other `MotionValue`s by
 * passing their latest values through a transform function.
 *
 * Whenever a `MotionValue` referred to in the provided function is updated,
 * it will be re-evaluated.
 *
 * ```jsx
 * const x = motionValue(0)
 * const y = transformValue(() => x.get() * 2) // double x
 * ```
 *
 * @param transformer - A transform function. This function must be pure with no side-effects or conditional statements.
 * @returns `MotionValue`
 *
 * @public
 */ function transformValue(transform) {
    var collectedValues = [];
    /**
     * Open session of collectMotionValues. Any MotionValue that calls get()
     * inside transform will be saved into this array.
     */ (0, _indexMjs.collectMotionValues).current = collectedValues;
    var initialValue = transform();
    (0, _indexMjs.collectMotionValues).current = undefined;
    var value = (0, _indexMjs.motionValue)(initialValue);
    (0, _subscribeValueMjs.subscribeValue)(collectedValues, value, transform);
    return value;
}

},{"./index.mjs":"lOANY","./subscribe-value.mjs":"JkcOH","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"JkcOH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribeValue", function() {
    return subscribeValue;
});
var _frameMjs = require("../frameloop/frame.mjs");
function subscribeValue(inputValues, outputValue, getLatest) {
    var update = function() {
        return outputValue.set(getLatest());
    };
    var scheduleUpdate = function() {
        return (0, _frameMjs.frame).preRender(update, false, true);
    };
    var subscriptions = inputValues.map(function(v) {
        return v.on("change", scheduleUpdate);
    });
    outputValue.on("destroy", function() {
        subscriptions.forEach(function(unsubscribe) {
            return unsubscribe();
        });
        (0, _frameMjs.cancelFrame)(update);
    });
}

},{"../frameloop/frame.mjs":"lxQZr","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6sD7C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "attachSpring", function() {
    return attachSpring;
});
parcelHelpers.export(exports, "springValue", function() {
    return springValue;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _followValueMjs = require("./follow-value.mjs");
/**
 * Create a `MotionValue` that animates to its latest value using a spring.
 * Can either be a value or track another `MotionValue`.
 *
 * ```jsx
 * const x = motionValue(0)
 * const y = springValue(x, { stiffness: 300 })
 * ```
 *
 * @param source - Initial value or MotionValue to track
 * @param options - Spring configuration options
 * @returns `MotionValue`
 *
 * @public
 */ function springValue(source, options) {
    return (0, _followValueMjs.followValue)(source, (0, _objectSpread._)({
        type: "spring"
    }, options));
}
/**
 * Attach a spring animation to a MotionValue that will animate whenever the value changes.
 *
 * @param value - The MotionValue to animate
 * @param source - Initial value or MotionValue to track
 * @param options - Spring configuration options
 * @returns Cleanup function
 *
 * @public
 */ function attachSpring(value, source, options) {
    return (0, _followValueMjs.attachFollow)(value, source, (0, _objectSpread._)({
        type: "spring"
    }, options));
}

},{"@swc/helpers/_/_object_spread":"9gdrV","./follow-value.mjs":"h0xh3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hvs3x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "findValueType", function() {
    return findValueType;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _indexMjs = require("../color/index.mjs");
var _indexMjs1 = require("../complex/index.mjs");
var _dimensionsMjs = require("../dimensions.mjs");
var _testMjs = require("../test.mjs");
/**
 * A list of all ValueTypes
 */ var valueTypes = (0, _toConsumableArray._)((0, _dimensionsMjs.dimensionValueTypes)).concat([
    (0, _indexMjs.color),
    (0, _indexMjs1.complex)
]);
/**
 * Tests a value against the list of ValueTypes
 */ var findValueType = function(v) {
    return valueTypes.find((0, _testMjs.testValueType)(v));
};

},{"@swc/helpers/_/_to_consumable_array":"1eSZf","../color/index.mjs":"gbu7c","../complex/index.mjs":"6JMtB","../dimensions.mjs":"lgLwV","../test.mjs":"33ooj","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9MsoD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ViewTransitionBuilder", function() {
    return ViewTransitionBuilder;
});
parcelHelpers.export(exports, "animateView", function() {
    return animateView;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _motionUtils = require("motion-utils");
var _queueMjs = require("./queue.mjs");
var ViewTransitionBuilder = /*#__PURE__*/ function() {
    "use strict";
    function ViewTransitionBuilder(update) {
        var _this = this;
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, _classCallCheck._)(this, ViewTransitionBuilder);
        this.currentSubject = "root";
        this.targets = new Map();
        this.notifyReady = (0, _motionUtils.noop);
        this.readyPromise = new Promise(function(resolve) {
            _this.notifyReady = resolve;
        });
        this.update = update;
        this.options = (0, _objectSpread._)({
            interrupt: "wait"
        }, options);
        (0, _queueMjs.addToQueue)(this);
    }
    (0, _createClass._)(ViewTransitionBuilder, [
        {
            key: "get",
            value: function get(subject) {
                this.currentSubject = subject;
                return this;
            }
        },
        {
            key: "layout",
            value: function layout(keyframes, options) {
                this.updateTarget("layout", keyframes, options);
                return this;
            }
        },
        {
            key: "new",
            value: function _new(keyframes, options) {
                this.updateTarget("new", keyframes, options);
                return this;
            }
        },
        {
            key: "old",
            value: function old(keyframes, options) {
                this.updateTarget("old", keyframes, options);
                return this;
            }
        },
        {
            key: "enter",
            value: function enter(keyframes, options) {
                this.updateTarget("enter", keyframes, options);
                return this;
            }
        },
        {
            key: "exit",
            value: function exit(keyframes, options) {
                this.updateTarget("exit", keyframes, options);
                return this;
            }
        },
        {
            key: "crossfade",
            value: function crossfade(options) {
                this.updateTarget("enter", {
                    opacity: 1
                }, options);
                this.updateTarget("exit", {
                    opacity: 0
                }, options);
                return this;
            }
        },
        {
            key: "updateTarget",
            value: function updateTarget(target, keyframes) {
                var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var _this = this, currentSubject = _this.currentSubject, targets = _this.targets;
                if (!targets.has(currentSubject)) targets.set(currentSubject, {});
                var targetData = targets.get(currentSubject);
                targetData[target] = {
                    keyframes: keyframes,
                    options: options
                };
            }
        },
        {
            key: "then",
            value: function then(resolve, reject) {
                return this.readyPromise.then(resolve, reject);
            }
        }
    ]);
    return ViewTransitionBuilder;
}();
function animateView(update) {
    var defaultOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return new ViewTransitionBuilder(update, defaultOptions);
}

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_object_spread":"9gdrV","motion-utils":"9Q5qC","./queue.mjs":"2TjUQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2TjUQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addToQueue", function() {
    return addToQueue;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _motionUtils = require("motion-utils");
var _microtaskMjs = require("../frameloop/microtask.mjs");
var _startMjs = require("./start.mjs");
var builders = [];
var current = null;
function next() {
    current = null;
    var _builders = (0, _slicedToArray._)(builders, 1), nextBuilder = _builders[0];
    if (nextBuilder) start(nextBuilder);
}
function start(builder) {
    (0, _motionUtils.removeItem)(builders, builder);
    current = builder;
    (0, _startMjs.startViewAnimation)(builder).then(function(animation) {
        builder.notifyReady(animation);
        animation.finished.finally(next);
    });
}
function processQueue() {
    var _loop = function(i) {
        var builder = builders[i];
        var interrupt = builder.options.interrupt;
        if (interrupt === "immediate") {
            var batchedUpdates = builders.slice(0, i + 1).map(function(b) {
                return b.update;
            });
            var remaining = builders.slice(i + 1);
            builder.update = function() {
                batchedUpdates.forEach(function(update) {
                    return update();
                });
            };
            // Put the current builder at the front, followed by any "wait" builders
            builders = [
                builder
            ].concat((0, _toConsumableArray._)(remaining));
            return "break";
        }
    };
    var _builders_;
    /**
     * Iterate backwards over the builders array. We can ignore the
     * "wait" animations. If we have an interrupting animation in the
     * queue then we need to batch all preceeding animations into it.
     * Currently this only batches the update functions but will also
     * need to batch the targets.
     */ for(var i = builders.length - 1; i >= 0; i--){
        var _ret = _loop(i);
        if (_ret === "break") break;
    }
    if (!current || ((_builders_ = builders[0]) === null || _builders_ === void 0 ? void 0 : _builders_.options.interrupt) === "immediate") next();
}
function addToQueue(builder) {
    builders.push(builder);
    (0, _microtaskMjs.microtask).render(processQueue);
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_to_consumable_array":"1eSZf","motion-utils":"9Q5qC","../frameloop/microtask.mjs":"icPpP","./start.mjs":"fjgTn","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fjgTn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "startViewAnimation", function() {
    return startViewAnimation;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _motionUtils = require("motion-utils");
var _groupAnimationMjs = require("../animation/GroupAnimation.mjs");
var _nativeAnimationMjs = require("../animation/NativeAnimation.mjs");
var _nativeAnimationWrapperMjs = require("../animation/NativeAnimationWrapper.mjs");
var _getValueTransitionMjs = require("../animation/utils/get-value-transition.mjs");
var _mapEasingMjs = require("../animation/waapi/easing/map-easing.mjs");
var _applyGeneratorMjs = require("../animation/waapi/utils/apply-generator.mjs");
var _chooseLayerTypeMjs = require("./utils/choose-layer-type.mjs");
var _cssMjs = require("./utils/css.mjs");
var _getLayerInfoMjs = require("./utils/get-layer-info.mjs");
var _getViewAnimationsMjs = require("./utils/get-view-animations.mjs");
var _hasTargetMjs = require("./utils/has-target.mjs");
var definitionNames = [
    "layout",
    "enter",
    "exit",
    "new",
    "old"
];
function startViewAnimation(builder) {
    var update = builder.update, targets = builder.targets, defaultOptions = builder.options;
    if (!document.startViewTransition) return new Promise(function(resolve) {
        return (0, _asyncToGenerator._)(function() {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            update()
                        ];
                    case 1:
                        _state.sent();
                        resolve(new (0, _groupAnimationMjs.GroupAnimation)([]));
                        return [
                            2
                        ];
                }
            });
        })();
    });
    // TODO: Go over existing targets and ensure they all have ids
    /**
     * If we don't have any animations defined for the root target,
     * remove it from being captured.
     */ if (!(0, _hasTargetMjs.hasTarget)("root", targets)) (0, _cssMjs.css).set(":root", {
        "view-transition-name": "none"
    });
    /**
     * Set the timing curve to linear for all view transition layers.
     * This gets baked into the keyframes, which can't be changed
     * without breaking the generated animation.
     *
     * This allows us to set easing via updateTiming - which can be changed.
     */ (0, _cssMjs.css).set("::view-transition-group(*), ::view-transition-old(*), ::view-transition-new(*)", {
        "animation-timing-function": "linear !important"
    });
    (0, _cssMjs.css).commit(); // Write
    var transition = document.startViewTransition(function() {
        return (0, _asyncToGenerator._)(function() {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            update()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        // TODO: Go over new targets and ensure they all have ids
        })();
    });
    transition.finished.finally(function() {
        (0, _cssMjs.css).remove(); // Write
    });
    return new Promise(function(resolve) {
        transition.ready.then(function() {
            var generatedViewAnimations = (0, _getViewAnimationsMjs.getViewAnimations)();
            var animations = [];
            /**
             * Create animations for each of our explicitly-defined subjects.
             */ targets.forEach(function(definition, target) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // TODO: If target is not "root", resolve elements
                    // and iterate over each
                    for(var _iterator = definitionNames[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        if (!definition[key]) continue;
                        var _definition_key = definition[key], keyframes = _definition_key.keyframes, options = _definition_key.options;
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = Object.entries(keyframes)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var _step_value = (0, _slicedToArray._)(_step1.value, 2), valueName = _step_value[0], valueKeyframes = _step_value[1];
                                if (!valueKeyframes) continue;
                                var valueOptions = (0, _objectSpread._)({}, (0, _getValueTransitionMjs.getValueTransition)(defaultOptions, valueName), (0, _getValueTransitionMjs.getValueTransition)(options, valueName));
                                var type = (0, _chooseLayerTypeMjs.chooseLayerType)(key);
                                /**
                         * If this is an opacity animation, and keyframes are not an array,
                         * we need to convert them into an array and set an initial value.
                         */ if (valueName === "opacity" && !Array.isArray(valueKeyframes)) {
                                    var initialValue = type === "new" ? 0 : 1;
                                    valueKeyframes = [
                                        initialValue,
                                        valueKeyframes
                                    ];
                                }
                                /**
                         * Resolve stagger function if provided.
                         */ if (typeof valueOptions.delay === "function") valueOptions.delay = valueOptions.delay(0, 1);
                                valueOptions.duration && (valueOptions.duration = (0, _motionUtils.secondsToMilliseconds)(valueOptions.duration));
                                valueOptions.delay && (valueOptions.delay = (0, _motionUtils.secondsToMilliseconds)(valueOptions.delay));
                                var animation = new (0, _nativeAnimationMjs.NativeAnimation)((0, _objectSpreadProps._)((0, _objectSpread._)({}, valueOptions), {
                                    element: document.documentElement,
                                    name: valueName,
                                    pseudoElement: "::view-transition-".concat(type, "(").concat(target, ")"),
                                    keyframes: valueKeyframes
                                }));
                                animations.push(animation);
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                /**
             * Handle browser generated animations
             */ for(var _iterator = generatedViewAnimations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var animation = _step.value;
                    if (animation.playState === "finished") continue;
                    var effect = animation.effect;
                    if (!effect || !(0, _instanceof._)(effect, KeyframeEffect)) continue;
                    var pseudoElement = effect.pseudoElement;
                    if (!pseudoElement) continue;
                    var name = (0, _getLayerInfoMjs.getViewAnimationLayerInfo)(pseudoElement);
                    if (!name) continue;
                    var targetDefinition = targets.get(name.layer);
                    if (!targetDefinition) {
                        /**
                     * If transition name is group then update the timing of the animation
                     * whereas if it's old or new then we could possibly replace it using
                     * the above method.
                     */ var transitionName = name.type === "group" ? "layout" : "";
                        var animationTransition = (0, _objectSpread._)({}, (0, _getValueTransitionMjs.getValueTransition)(defaultOptions, transitionName));
                        animationTransition.duration && (animationTransition.duration = (0, _motionUtils.secondsToMilliseconds)(animationTransition.duration));
                        animationTransition = (0, _applyGeneratorMjs.applyGeneratorOptions)(animationTransition);
                        var easing = (0, _mapEasingMjs.mapEasingToNativeEasing)(animationTransition.ease, animationTransition.duration);
                        var _animationTransition_delay;
                        effect.updateTiming({
                            delay: (0, _motionUtils.secondsToMilliseconds)((_animationTransition_delay = animationTransition.delay) !== null && _animationTransition_delay !== void 0 ? _animationTransition_delay : 0),
                            duration: animationTransition.duration,
                            easing: easing
                        });
                        animations.push(new (0, _nativeAnimationWrapperMjs.NativeAnimationWrapper)(animation));
                    } else if (hasOpacity(targetDefinition, "enter") && hasOpacity(targetDefinition, "exit") && effect.getKeyframes().some(function(keyframe) {
                        return keyframe.mixBlendMode;
                    })) animations.push(new (0, _nativeAnimationWrapperMjs.NativeAnimationWrapper)(animation));
                    else animation.cancel();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            resolve(new (0, _groupAnimationMjs.GroupAnimation)(animations));
        });
    });
}
function hasOpacity(target, key) {
    var _target_key;
    return target === null || target === void 0 ? void 0 : (_target_key = target[key]) === null || _target_key === void 0 ? void 0 : _target_key.keyframes.opacity;
}

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_ts_generator":"78Tqx","motion-utils":"9Q5qC","../animation/GroupAnimation.mjs":"cpgZo","../animation/NativeAnimation.mjs":"30yuo","../animation/NativeAnimationWrapper.mjs":"ambch","../animation/utils/get-value-transition.mjs":"dkYvz","../animation/waapi/easing/map-easing.mjs":"gPAe1","../animation/waapi/utils/apply-generator.mjs":"k35Bi","./utils/choose-layer-type.mjs":"glWyk","./utils/css.mjs":"8HA0I","./utils/get-layer-info.mjs":"hSSN2","./utils/get-view-animations.mjs":"5hmln","./utils/has-target.mjs":"jdrg5","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"glWyk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "chooseLayerType", function() {
    return chooseLayerType;
});
function chooseLayerType(valueName) {
    if (valueName === "layout") return "group";
    if (valueName === "enter" || valueName === "new") return "new";
    if (valueName === "exit" || valueName === "old") return "old";
    return "group";
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8HA0I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "css", function() {
    return css;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var pendingRules = {};
var style = null;
var css = {
    set: function(selector, values) {
        pendingRules[selector] = values;
    },
    commit: function() {
        if (!style) {
            style = document.createElement("style");
            style.id = "motion-view";
        }
        var cssText = "";
        for(var selector in pendingRules){
            var rule = pendingRules[selector];
            cssText += "".concat(selector, " {\n");
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(rule)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, _slicedToArray._)(_step.value, 2), property = _step_value[0], value = _step_value[1];
                    cssText += "  ".concat(property, ": ").concat(value, ";\n");
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            cssText += "}\n";
        }
        style.textContent = cssText;
        document.head.appendChild(style);
        pendingRules = {};
    },
    remove: function() {
        if (style && style.parentElement) style.parentElement.removeChild(style);
    }
};

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hSSN2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getViewAnimationLayerInfo", function() {
    return getViewAnimationLayerInfo;
});
function getViewAnimationLayerInfo(pseudoElement) {
    var match = pseudoElement.match(/::view-transition-(old|new|group|image-pair)\((.*?)\)/);
    if (!match) return null;
    return {
        layer: match[2],
        type: match[1]
    };
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5hmln":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getViewAnimations", function() {
    return getViewAnimations;
});
function filterViewAnimations(animation) {
    var _effect_pseudoElement;
    var effect = animation.effect;
    if (!effect) return false;
    return effect.target === document.documentElement && ((_effect_pseudoElement = effect.pseudoElement) === null || _effect_pseudoElement === void 0 ? void 0 : _effect_pseudoElement.startsWith("::view-transition"));
}
function getViewAnimations() {
    return document.getAnimations().filter(filterViewAnimations);
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jdrg5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasTarget", function() {
    return hasTarget;
});
function hasTarget(target, targets) {
    return targets.has(target) && Object.keys(targets.get(target)).length > 0;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"isUIr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DOMVisualElement", function() {
    return DOMVisualElement;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _isMotionValueMjs = require("../../value/utils/is-motion-value.mjs");
var _domkeyframesResolverMjs = require("../../animation/keyframes/DOMKeyframesResolver.mjs");
var _visualElementMjs = require("../VisualElement.mjs");
var DOMVisualElement = /*#__PURE__*/ function(VisualElement) {
    "use strict";
    (0, _inherits._)(DOMVisualElement, VisualElement);
    function DOMVisualElement() {
        (0, _classCallCheck._)(this, DOMVisualElement);
        var _this;
        _this = (0, _callSuper._)(this, DOMVisualElement, arguments);
        _this.KeyframeResolver = (0, _domkeyframesResolverMjs.DOMKeyframesResolver);
        return _this;
    }
    (0, _createClass._)(DOMVisualElement, [
        {
            key: "sortInstanceNodePosition",
            value: function sortInstanceNodePosition(a, b) {
                /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
            }
        },
        {
            key: "getBaseTargetFromProps",
            value: function getBaseTargetFromProps(props, key) {
                var style = props.style;
                return style ? style[key] : undefined;
            }
        },
        {
            key: "removeValueFromRenderState",
            value: function removeValueFromRenderState(key, param) {
                var vars = param.vars, style = param.style;
                delete vars[key];
                delete style[key];
            }
        },
        {
            key: "handleChildMotionValue",
            value: function handleChildMotionValue() {
                var _this = this;
                if (this.childSubscription) {
                    this.childSubscription();
                    delete this.childSubscription;
                }
                var children = this.props.children;
                if ((0, _isMotionValueMjs.isMotionValue)(children)) this.childSubscription = children.on("change", function(latest) {
                    if (_this.current) _this.current.textContent = "".concat(latest);
                });
            }
        }
    ]);
    return DOMVisualElement;
}((0, _visualElementMjs.VisualElement));

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_inherits":"2sfqW","../../value/utils/is-motion-value.mjs":"cYNey","../../animation/keyframes/DOMKeyframesResolver.mjs":"blRNU","../VisualElement.mjs":"1ZK29","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1ZK29":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VisualElement", function() {
    return VisualElement;
});
parcelHelpers.export(exports, "getFeatureDefinitions", function() {
    return getFeatureDefinitions;
});
parcelHelpers.export(exports, "setFeatureDefinitions", function() {
    return setFeatureDefinitions;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var _motionUtils = require("motion-utils");
var _keyframesResolverMjs = require("../animation/keyframes/KeyframesResolver.mjs");
var _nativeAnimationMjs = require("../animation/NativeAnimation.mjs");
var _acceleratedValuesMjs = require("../animation/waapi/utils/accelerated-values.mjs");
var _microtaskMjs = require("../frameloop/microtask.mjs");
var _syncTimeMjs = require("../frameloop/sync-time.mjs");
var _modelsMjs = require("../projection/geometry/models.mjs");
var _indexMjs = require("../value/index.mjs");
var _indexMjs1 = require("../value/types/complex/index.mjs");
var _animatableNoneMjs = require("../value/types/utils/animatable-none.mjs");
var _findMjs = require("../value/types/utils/find.mjs");
var _isMotionValueMjs = require("../value/utils/is-motion-value.mjs");
var _storeMjs = require("./store.mjs");
var _isControllingVariantsMjs = require("./utils/is-controlling-variants.mjs");
var _keysTransformMjs = require("./utils/keys-transform.mjs");
var _motionValuesMjs = require("./utils/motion-values.mjs");
var _indexMjs2 = require("./utils/reduced-motion/index.mjs");
var _resolveVariantsMjs = require("./utils/resolve-variants.mjs");
var _stateMjs = require("./utils/reduced-motion/state.mjs");
var _frameMjs = require("../frameloop/frame.mjs");
var propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
/**
 * Static feature definitions - can be injected by framework layer
 */ var featureDefinitions = {};
/**
 * Set feature definitions for all VisualElements.
 * This should be called by the framework layer (e.g., framer-motion) during initialization.
 */ function setFeatureDefinitions(definitions) {
    featureDefinitions = definitions;
}
/**
 * Get the current feature definitions
 */ function getFeatureDefinitions() {
    return featureDefinitions;
}
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ var VisualElement = /*#__PURE__*/ function() {
    "use strict";
    function VisualElement(param) {
        var _this = this;
        var parent = param.parent, props = param.props, presenceContext = param.presenceContext, reducedMotionConfig = param.reducedMotionConfig, skipAnimations = param.skipAnimations, blockInitialAnimation = param.blockInitialAnimation, visualState = param.visualState, options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, _classCallCheck._)(this, VisualElement);
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * Decides whether animations should be skipped for this VisualElement.
         * Useful for E2E tests and visual regression testing.
         */ this.shouldSkipAnimations = false;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        this.KeyframeResolver = (0, _keyframesResolverMjs.KeyframeResolver);
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * Track whether this element has been mounted before, to detect
         * remounts after Suspense unmount/remount cycles.
         */ this.hasBeenMounted = false;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = function() {
            return _this.notify("Update", _this.latestValues);
        };
        this.render = function() {
            if (!_this.current) return;
            _this.triggerBuild();
            _this.renderInstance(_this.current, _this.renderState, _this.props.style, _this.projection);
        };
        this.renderScheduledAt = 0.0;
        this.scheduleRender = function() {
            var now = (0, _syncTimeMjs.time).now();
            if (_this.renderScheduledAt < now) {
                _this.renderScheduledAt = now;
                (0, _frameMjs.frame).render(_this.render, false, true);
            }
        };
        var latestValues = visualState.latestValues, renderState = visualState.renderState;
        this.latestValues = latestValues;
        this.baseTarget = (0, _objectSpread._)({}, latestValues);
        this.initialValues = props.initial ? (0, _objectSpread._)({}, latestValues) : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.skipAnimationsConfig = skipAnimations;
        this.options = options;
        this.blockInitialAnimation = Boolean(blockInitialAnimation);
        this.isControllingVariants = (0, _isControllingVariantsMjs.isControllingVariants)(props);
        this.isVariantNode = (0, _isControllingVariantsMjs.isVariantNode)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't necessarily a breaking change,
         * more a reflection of the test.
         */ var _this_scrapeMotionValuesFromProps = this.scrapeMotionValuesFromProps(props, {}, this), willChange = _this_scrapeMotionValuesFromProps.willChange, initialMotionValues = (0, _objectWithoutProperties._)(_this_scrapeMotionValuesFromProps, [
            "willChange"
        ]);
        for(var key in initialMotionValues){
            var value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, _isMotionValueMjs.isMotionValue)(value)) value.set(latestValues[key]);
        }
    }
    (0, _createClass._)(VisualElement, [
        {
            /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ key: "scrapeMotionValuesFromProps",
            value: function scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
                return {};
            }
        },
        {
            key: "mount",
            value: function mount(instance) {
                var _this = this;
                var _this_parent;
                /**
         * If this element has been mounted before (e.g. after a Suspense
         * unmount/remount), reset motion values to their initial state
         * so animations replay correctly from initial → animate.
         */ if (this.hasBeenMounted) for(var key in this.initialValues){
                    var _this_values_get;
                    (_this_values_get = this.values.get(key)) === null || _this_values_get === void 0 ? void 0 : _this_values_get.jump(this.initialValues[key]);
                    this.latestValues[key] = this.initialValues[key];
                }
                this.current = instance;
                (0, _storeMjs.visualElementStore).set(instance, this);
                if (this.projection && !this.projection.instance) this.projection.mount(instance);
                if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
                this.values.forEach(function(value, key) {
                    return _this.bindToMotionValue(key, value);
                });
                /**
         * Determine reduced motion preference. Only initialize the matchMedia
         * listener if we actually need the dynamic value (i.e., when config
         * is neither "never" nor "always").
         */ if (this.reducedMotionConfig === "never") this.shouldReduceMotion = false;
                else if (this.reducedMotionConfig === "always") this.shouldReduceMotion = true;
                else {
                    if (!(0, _stateMjs.hasReducedMotionListener).current) (0, _indexMjs2.initPrefersReducedMotion)();
                    this.shouldReduceMotion = (0, _stateMjs.prefersReducedMotion).current;
                }
                var _this_skipAnimationsConfig;
                /**
         * Set whether animations should be skipped based on the config.
         */ this.shouldSkipAnimations = (_this_skipAnimationsConfig = this.skipAnimationsConfig) !== null && _this_skipAnimationsConfig !== void 0 ? _this_skipAnimationsConfig : false;
                (_this_parent = this.parent) === null || _this_parent === void 0 ? void 0 : _this_parent.addChild(this);
                this.update(this.props, this.presenceContext);
                this.hasBeenMounted = true;
            }
        },
        {
            key: "unmount",
            value: function unmount() {
                var _this_parent;
                this.projection && this.projection.unmount();
                (0, _frameMjs.cancelFrame)(this.notifyUpdate);
                (0, _frameMjs.cancelFrame)(this.render);
                this.valueSubscriptions.forEach(function(remove) {
                    return remove();
                });
                this.valueSubscriptions.clear();
                this.removeFromVariantTree && this.removeFromVariantTree();
                (_this_parent = this.parent) === null || _this_parent === void 0 ? void 0 : _this_parent.removeChild(this);
                for(var key in this.events)this.events[key].clear();
                for(var key1 in this.features){
                    var feature = this.features[key1];
                    if (feature) {
                        feature.unmount();
                        feature.isMounted = false;
                    }
                }
                this.current = null;
            }
        },
        {
            key: "addChild",
            value: function addChild(child) {
                this.children.add(child);
                var _this_enteringChildren;
                (_this_enteringChildren = this.enteringChildren) !== null && _this_enteringChildren !== void 0 ? _this_enteringChildren : this.enteringChildren = new Set();
                this.enteringChildren.add(child);
            }
        },
        {
            key: "removeChild",
            value: function removeChild(child) {
                this.children.delete(child);
                this.enteringChildren && this.enteringChildren.delete(child);
            }
        },
        {
            key: "bindToMotionValue",
            value: function bindToMotionValue(key, value) {
                var _this = this;
                if (this.valueSubscriptions.has(key)) this.valueSubscriptions.get(key)();
                if (value.accelerate && (0, _acceleratedValuesMjs.acceleratedValues).has(key) && (0, _instanceof._)(this.current, HTMLElement)) {
                    var _value_accelerate = value.accelerate, factory = _value_accelerate.factory, keyframes = _value_accelerate.keyframes, times = _value_accelerate.times, ease = _value_accelerate.ease, duration = _value_accelerate.duration;
                    var animation = new (0, _nativeAnimationMjs.NativeAnimation)({
                        element: this.current,
                        name: key,
                        keyframes: keyframes,
                        times: times,
                        ease: ease,
                        duration: (0, _motionUtils.secondsToMilliseconds)(duration)
                    });
                    var cleanup = factory(animation);
                    this.valueSubscriptions.set(key, function() {
                        cleanup();
                        animation.cancel();
                    });
                    return;
                }
                var valueIsTransform = (0, _keysTransformMjs.transformProps).has(key);
                if (valueIsTransform && this.onBindTransform) this.onBindTransform();
                var removeOnChange = value.on("change", function(latestValue) {
                    _this.latestValues[key] = latestValue;
                    _this.props.onUpdate && (0, _frameMjs.frame).preRender(_this.notifyUpdate);
                    if (valueIsTransform && _this.projection) _this.projection.isTransformDirty = true;
                    _this.scheduleRender();
                });
                var removeSyncCheck;
                if (typeof window !== "undefined" && window.MotionCheckAppearSync) removeSyncCheck = window.MotionCheckAppearSync(this, key, value);
                this.valueSubscriptions.set(key, function() {
                    removeOnChange();
                    if (removeSyncCheck) removeSyncCheck();
                    if (value.owner) value.stop();
                });
            }
        },
        {
            key: "sortNodePosition",
            value: function sortNodePosition(other) {
                /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
                return this.sortInstanceNodePosition(this.current, other.current);
            }
        },
        {
            key: "updateFeatures",
            value: function updateFeatures() {
                var key = "animation";
                for(key in featureDefinitions){
                    var featureDefinition = featureDefinitions[key];
                    if (!featureDefinition) continue;
                    var isEnabled = featureDefinition.isEnabled, FeatureConstructor = featureDefinition.Feature;
                    /**
             * If this feature is enabled but not active, make a new instance.
             */ if (!this.features[key] && FeatureConstructor && isEnabled(this.props)) this.features[key] = new FeatureConstructor(this);
                    /**
             * If we have a feature, mount or update it.
             */ if (this.features[key]) {
                        var feature = this.features[key];
                        if (feature.isMounted) feature.update();
                        else {
                            feature.mount();
                            feature.isMounted = true;
                        }
                    }
                }
            }
        },
        {
            key: "triggerBuild",
            value: function triggerBuild() {
                this.build(this.renderState, this.latestValues, this.props);
            }
        },
        {
            /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ key: "measureViewportBox",
            value: function measureViewportBox() {
                return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, _modelsMjs.createBox)();
            }
        },
        {
            key: "getStaticValue",
            value: function getStaticValue(key) {
                return this.latestValues[key];
            }
        },
        {
            key: "setStaticValue",
            value: function setStaticValue(key, value) {
                this.latestValues[key] = value;
            }
        },
        {
            /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ key: "update",
            value: function update(props, presenceContext) {
                if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
                this.prevProps = this.props;
                this.props = props;
                this.prevPresenceContext = this.presenceContext;
                this.presenceContext = presenceContext;
                /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(var i = 0; i < propEventHandlers.length; i++){
                    var key = propEventHandlers[i];
                    if (this.propEventSubscriptions[key]) {
                        this.propEventSubscriptions[key]();
                        delete this.propEventSubscriptions[key];
                    }
                    var listenerName = "on" + key;
                    var listener = props[listenerName];
                    if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
                }
                this.prevMotionValues = (0, _motionValuesMjs.updateMotionValuesFromProps)(this, this.scrapeMotionValuesFromProps(props, this.prevProps || {}, this), this.prevMotionValues);
                if (this.handleChildMotionValue) this.handleChildMotionValue();
            }
        },
        {
            key: "getProps",
            value: function getProps() {
                return this.props;
            }
        },
        {
            /**
     * Returns the variant definition with a given name.
     */ key: "getVariant",
            value: function getVariant(name) {
                return this.props.variants ? this.props.variants[name] : undefined;
            }
        },
        {
            /**
     * Returns the defined default transition on this component.
     */ key: "getDefaultTransition",
            value: function getDefaultTransition() {
                return this.props.transition;
            }
        },
        {
            key: "getTransformPagePoint",
            value: function getTransformPagePoint() {
                return this.props.transformPagePoint;
            }
        },
        {
            key: "getClosestVariantNode",
            value: function getClosestVariantNode() {
                return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
            }
        },
        {
            /**
     * Add a child visual element to our set of children.
     */ key: "addVariantChild",
            value: function addVariantChild(child) {
                var closestVariantNode = this.getClosestVariantNode();
                if (closestVariantNode) {
                    closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
                    return function() {
                        return closestVariantNode.variantChildren.delete(child);
                    };
                }
            }
        },
        {
            /**
     * Add a motion value and bind it to this visual element.
     */ key: "addValue",
            value: function addValue(key, value) {
                // Remove existing value if it exists
                var existingValue = this.values.get(key);
                if (value !== existingValue) {
                    if (existingValue) this.removeValue(key);
                    this.bindToMotionValue(key, value);
                    this.values.set(key, value);
                    this.latestValues[key] = value.get();
                }
            }
        },
        {
            /**
     * Remove a motion value and unbind any active subscriptions.
     */ key: "removeValue",
            value: function removeValue(key) {
                this.values.delete(key);
                var unsubscribe = this.valueSubscriptions.get(key);
                if (unsubscribe) {
                    unsubscribe();
                    this.valueSubscriptions.delete(key);
                }
                delete this.latestValues[key];
                this.removeValueFromRenderState(key, this.renderState);
            }
        },
        {
            /**
     * Check whether we have a motion value for this key
     */ key: "hasValue",
            value: function hasValue(key) {
                return this.values.has(key);
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (this.props.values && this.props.values[key]) return this.props.values[key];
                var value = this.values.get(key);
                if (value === undefined && defaultValue !== undefined) {
                    value = (0, _indexMjs.motionValue)(defaultValue === null ? undefined : defaultValue, {
                        owner: this
                    });
                    this.addValue(key, value);
                }
                return value;
            }
        },
        {
            /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ key: "readValue",
            value: function readValue(key, target) {
                var _this_getBaseTargetFromProps;
                var value = this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : (_this_getBaseTargetFromProps = this.getBaseTargetFromProps(this.props, key)) !== null && _this_getBaseTargetFromProps !== void 0 ? _this_getBaseTargetFromProps : this.readValueFromInstance(this.current, key, this.options);
                if (value !== undefined && value !== null) {
                    if (typeof value === "string" && ((0, _motionUtils.isNumericalString)(value) || (0, _motionUtils.isZeroValueString)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
                    value = parseFloat(value);
                    else if (!(0, _findMjs.findValueType)(value) && (0, _indexMjs1.complex).test(target)) value = (0, _animatableNoneMjs.getAnimatableNone)(key, target);
                    this.setBaseTarget(key, (0, _isMotionValueMjs.isMotionValue)(value) ? value.get() : value);
                }
                return (0, _isMotionValueMjs.isMotionValue)(value) ? value.get() : value;
            }
        },
        {
            /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ key: "setBaseTarget",
            value: function setBaseTarget(key, value) {
                this.baseTarget[key] = value;
            }
        },
        {
            /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ key: "getBaseTarget",
            value: function getBaseTarget(key) {
                var initial = this.props.initial;
                var valueFromInitial;
                if (typeof initial === "string" || (typeof initial === "undefined" ? "undefined" : (0, _typeOf._)(initial)) === "object") {
                    var _this_presenceContext;
                    var variant = (0, _resolveVariantsMjs.resolveVariantFromProps)(this.props, initial, (_this_presenceContext = this.presenceContext) === null || _this_presenceContext === void 0 ? void 0 : _this_presenceContext.custom);
                    if (variant) valueFromInitial = variant[key];
                }
                /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
                /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ var target = this.getBaseTargetFromProps(this.props, key);
                if (target !== undefined && !(0, _isMotionValueMjs.isMotionValue)(target)) return target;
                /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
            }
        },
        {
            key: "on",
            value: function on(eventName, callback) {
                if (!this.events[eventName]) this.events[eventName] = new (0, _motionUtils.SubscriptionManager)();
                return this.events[eventName].add(callback);
            }
        },
        {
            key: "notify",
            value: function notify(eventName) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                var _this_events_eventName;
                if (this.events[eventName]) (_this_events_eventName = this.events[eventName]).notify.apply(_this_events_eventName, (0, _toConsumableArray._)(args));
            }
        },
        {
            key: "scheduleRenderMicrotask",
            value: function scheduleRenderMicrotask() {
                (0, _microtaskMjs.microtask).render(this.render);
            }
        }
    ]);
    return VisualElement;
}();

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_without_properties":"6HqIM","@swc/helpers/_/_to_consumable_array":"1eSZf","@swc/helpers/_/_type_of":"iFJdx","motion-utils":"9Q5qC","../animation/keyframes/KeyframesResolver.mjs":"aeJtq","../animation/NativeAnimation.mjs":"30yuo","../animation/waapi/utils/accelerated-values.mjs":"kN2wj","../frameloop/microtask.mjs":"icPpP","../frameloop/sync-time.mjs":"aPTZo","../projection/geometry/models.mjs":"i3okE","../value/index.mjs":"lOANY","../value/types/complex/index.mjs":"6JMtB","../value/types/utils/animatable-none.mjs":"2aLeu","../value/types/utils/find.mjs":"hvs3x","../value/utils/is-motion-value.mjs":"cYNey","./store.mjs":"aYOSW","./utils/is-controlling-variants.mjs":"qsgzo","./utils/keys-transform.mjs":"91lmj","./utils/motion-values.mjs":"350Yl","./utils/reduced-motion/index.mjs":"hu0S7","./utils/resolve-variants.mjs":"gzt8h","./utils/reduced-motion/state.mjs":"7Tal4","../frameloop/frame.mjs":"lxQZr","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"i3okE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createAxis", function() {
    return createAxis;
});
parcelHelpers.export(exports, "createAxisDelta", function() {
    return createAxisDelta;
});
parcelHelpers.export(exports, "createBox", function() {
    return createBox;
});
parcelHelpers.export(exports, "createDelta", function() {
    return createDelta;
});
var createAxisDelta = function() {
    return {
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    };
};
var createDelta = function() {
    return {
        x: createAxisDelta(),
        y: createAxisDelta()
    };
};
var createAxis = function() {
    return {
        min: 0,
        max: 0
    };
};
var createBox = function() {
    return {
        x: createAxis(),
        y: createAxis()
    };
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aYOSW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "visualElementStore", function() {
    return visualElementStore;
});
var visualElementStore = new WeakMap();

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"qsgzo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isControllingVariants", function() {
    return isControllingVariants;
});
parcelHelpers.export(exports, "isVariantNode", function() {
    return isVariantNode;
});
var _isAnimationControlsMjs = require("./is-animation-controls.mjs");
var _isVariantLabelMjs = require("./is-variant-label.mjs");
var _variantPropsMjs = require("./variant-props.mjs");
function isControllingVariants(props) {
    return (0, _isAnimationControlsMjs.isAnimationControls)(props.animate) || (0, _variantPropsMjs.variantProps).some(function(name) {
        return (0, _isVariantLabelMjs.isVariantLabel)(props[name]);
    });
}
function isVariantNode(props) {
    return Boolean(isControllingVariants(props) || props.variants);
}

},{"./is-animation-controls.mjs":"4N6Mr","./is-variant-label.mjs":"aChc4","./variant-props.mjs":"2ZATM","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4N6Mr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isAnimationControls", function() {
    return isAnimationControls;
});
var _typeOf = require("@swc/helpers/_/_type_of");
function isAnimationControls(v) {
    return v !== null && (typeof v === "undefined" ? "undefined" : (0, _typeOf._)(v)) === "object" && typeof v.start === "function";
}

},{"@swc/helpers/_/_type_of":"iFJdx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aChc4":[function(require,module,exports,__globalThis) {
/**
 * Decides if the supplied variable is variant label
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isVariantLabel", function() {
    return isVariantLabel;
});
function isVariantLabel(v) {
    return typeof v === "string" || Array.isArray(v);
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2ZATM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "variantPriorityOrder", function() {
    return variantPriorityOrder;
});
parcelHelpers.export(exports, "variantProps", function() {
    return variantProps;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var variantPriorityOrder = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
var variantProps = [
    "initial"
].concat((0, _toConsumableArray._)(variantPriorityOrder));

},{"@swc/helpers/_/_to_consumable_array":"1eSZf","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"350Yl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "updateMotionValuesFromProps", function() {
    return updateMotionValuesFromProps;
});
var _indexMjs = require("../../value/index.mjs");
var _isMotionValueMjs = require("../../value/utils/is-motion-value.mjs");
/**
 * Updates motion values from props changes.
 * Uses `any` type for element to avoid circular dependencies with VisualElement.
 */ function updateMotionValuesFromProps(element, next, prev) {
    for(var key in next){
        var nextValue = next[key];
        var prevValue = prev[key];
        if ((0, _isMotionValueMjs.isMotionValue)(nextValue)) /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
        else if ((0, _isMotionValueMjs.isMotionValue)(prevValue)) /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, _indexMjs.motionValue)(nextValue, {
            owner: element
        }));
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                var existingValue = element.getValue(key);
                if (existingValue.liveStyle === true) existingValue.jump(nextValue);
                else if (!existingValue.hasAnimated) existingValue.set(nextValue);
            } else {
                var latestValue = element.getStaticValue(key);
                element.addValue(key, (0, _indexMjs.motionValue)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(var key1 in prev)if (next[key1] === undefined) element.removeValue(key1);
    return next;
}

},{"../../value/index.mjs":"lOANY","../../value/utils/is-motion-value.mjs":"cYNey","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hu0S7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasReducedMotionListener", function() {
    return 0, _stateMjs.hasReducedMotionListener;
});
parcelHelpers.export(exports, "initPrefersReducedMotion", function() {
    return initPrefersReducedMotion;
});
parcelHelpers.export(exports, "prefersReducedMotion", function() {
    return 0, _stateMjs.prefersReducedMotion;
});
var _stateMjs = require("./state.mjs");
var isBrowser = typeof window !== "undefined";
function initPrefersReducedMotion() {
    (0, _stateMjs.hasReducedMotionListener).current = true;
    if (!isBrowser) return;
    if (window.matchMedia) {
        var motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        var setReducedMotionPreferences = function() {
            return (0, _stateMjs.prefersReducedMotion).current = motionMediaQuery.matches;
        };
        motionMediaQuery.addEventListener("change", setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, _stateMjs.prefersReducedMotion).current = false;
}

},{"./state.mjs":"7Tal4","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7Tal4":[function(require,module,exports,__globalThis) {
// Does this device prefer reduced motion? Returns `null` server-side.
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasReducedMotionListener", function() {
    return hasReducedMotionListener;
});
parcelHelpers.export(exports, "prefersReducedMotion", function() {
    return prefersReducedMotion;
});
var prefersReducedMotion = {
    current: null
};
var hasReducedMotionListener = {
    current: false
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"V3nrd":[function(require,module,exports,__globalThis) {
/**
 * Feature base class for extending VisualElement functionality.
 * Features are plugins that can be mounted/unmounted to add behavior
 * like gestures, animations, or layout tracking.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Feature", function() {
    return Feature;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var Feature = /*#__PURE__*/ function() {
    "use strict";
    function Feature(node) {
        (0, _classCallCheck._)(this, Feature);
        this.isMounted = false;
        this.node = node;
    }
    (0, _createClass._)(Feature, [
        {
            key: "update",
            value: function update() {}
        }
    ]);
    return Feature;
}();

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"g5ilZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HTMLVisualElement", function() {
    return HTMLVisualElement;
});
parcelHelpers.export(exports, "getComputedStyle", function() {
    return getComputedStyle;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _isCssVariableMjs = require("../../animation/utils/is-css-variable.mjs");
var _keysTransformMjs = require("../utils/keys-transform.mjs");
var _parseTransformMjs = require("../dom/parse-transform.mjs");
var _measureMjs = require("../../projection/utils/measure.mjs");
var _domvisualElementMjs = require("../dom/DOMVisualElement.mjs");
var _buildStylesMjs = require("./utils/build-styles.mjs");
var _renderMjs = require("./utils/render.mjs");
var _scrapeMotionValuesMjs = require("./utils/scrape-motion-values.mjs");
function getComputedStyle(element) {
    return window.getComputedStyle(element);
}
var HTMLVisualElement = /*#__PURE__*/ function(DOMVisualElement) {
    "use strict";
    (0, _inherits._)(HTMLVisualElement, DOMVisualElement);
    function HTMLVisualElement() {
        (0, _classCallCheck._)(this, HTMLVisualElement);
        var _this;
        _this = (0, _callSuper._)(this, HTMLVisualElement, arguments);
        _this.type = "html";
        _this.renderInstance = (0, _renderMjs.renderHTML);
        return _this;
    }
    (0, _createClass._)(HTMLVisualElement, [
        {
            key: "readValueFromInstance",
            value: function readValueFromInstance(instance, key) {
                var _this_projection;
                if ((0, _keysTransformMjs.transformProps).has(key)) return ((_this_projection = this.projection) === null || _this_projection === void 0 ? void 0 : _this_projection.isProjecting) ? (0, _parseTransformMjs.defaultTransformValue)(key) : (0, _parseTransformMjs.readTransformValue)(instance, key);
                else {
                    var computedStyle = getComputedStyle(instance);
                    var value = ((0, _isCssVariableMjs.isCSSVariableName)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
                    return typeof value === "string" ? value.trim() : value;
                }
            }
        },
        {
            key: "measureInstanceViewportBox",
            value: function measureInstanceViewportBox(instance, param) {
                var transformPagePoint = param.transformPagePoint;
                return (0, _measureMjs.measureViewportBox)(instance, transformPagePoint);
            }
        },
        {
            key: "build",
            value: function build(renderState, latestValues, props) {
                (0, _buildStylesMjs.buildHTMLStyles)(renderState, latestValues, props.transformTemplate);
            }
        },
        {
            key: "scrapeMotionValuesFromProps",
            value: function scrapeMotionValuesFromProps(props, prevProps, visualElement) {
                return (0, _scrapeMotionValuesMjs.scrapeMotionValuesFromProps)(props, prevProps, visualElement);
            }
        }
    ]);
    return HTMLVisualElement;
}((0, _domvisualElementMjs.DOMVisualElement));

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_inherits":"2sfqW","../../animation/utils/is-css-variable.mjs":"5nV2N","../utils/keys-transform.mjs":"91lmj","../dom/parse-transform.mjs":"4ieLZ","../../projection/utils/measure.mjs":"c1XTz","../dom/DOMVisualElement.mjs":"isUIr","./utils/build-styles.mjs":"gch0a","./utils/render.mjs":"cSqL4","./utils/scrape-motion-values.mjs":"7lZGa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"c1XTz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "measurePageBox", function() {
    return measurePageBox;
});
parcelHelpers.export(exports, "measureViewportBox", function() {
    return measureViewportBox;
});
var _conversionMjs = require("../geometry/conversion.mjs");
var _deltaApplyMjs = require("../geometry/delta-apply.mjs");
function measureViewportBox(instance, transformPoint) {
    return (0, _conversionMjs.convertBoundingBoxToBox)((0, _conversionMjs.transformBoxPoints)(instance.getBoundingClientRect(), transformPoint));
}
function measurePageBox(element, rootProjectionNode, transformPagePoint) {
    var viewportBox = measureViewportBox(element, transformPagePoint);
    var scroll = rootProjectionNode.scroll;
    if (scroll) {
        (0, _deltaApplyMjs.translateAxis)(viewportBox.x, scroll.offset.x);
        (0, _deltaApplyMjs.translateAxis)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}

},{"../geometry/conversion.mjs":"4hVaF","../geometry/delta-apply.mjs":"ltFfy","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4hVaF":[function(require,module,exports,__globalThis) {
/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "convertBoundingBoxToBox", function() {
    return convertBoundingBoxToBox;
});
parcelHelpers.export(exports, "convertBoxToBoundingBox", function() {
    return convertBoxToBoundingBox;
});
parcelHelpers.export(exports, "transformBoxPoints", function() {
    return transformBoxPoints;
});
function convertBoundingBoxToBox(param) {
    var top = param.top, left = param.left, right = param.right, bottom = param.bottom;
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function convertBoxToBoundingBox(param) {
    var x = param.x, y = param.y;
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function transformBoxPoints(point, transformPoint) {
    if (!transformPoint) return point;
    var topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    var bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ltFfy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applyAxisDelta", function() {
    return applyAxisDelta;
});
parcelHelpers.export(exports, "applyBoxDelta", function() {
    return applyBoxDelta;
});
parcelHelpers.export(exports, "applyPointDelta", function() {
    return applyPointDelta;
});
parcelHelpers.export(exports, "applyTreeDeltas", function() {
    return applyTreeDeltas;
});
parcelHelpers.export(exports, "scalePoint", function() {
    return scalePoint;
});
parcelHelpers.export(exports, "transformAxis", function() {
    return transformAxis;
});
parcelHelpers.export(exports, "transformBox", function() {
    return transformBox;
});
parcelHelpers.export(exports, "translateAxis", function() {
    return translateAxis;
});
var _numberMjs = require("../../utils/mix/number.mjs");
var _hasTransformMjs = require("../utils/has-transform.mjs");
/**
 * Scales a point based on a factor and an originPoint
 */ function scalePoint(point, scale, originPoint) {
    var distanceFromOrigin = point - originPoint;
    var scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function applyPointDelta(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = scalePoint(point, boxScale, originPoint);
    return scalePoint(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function applyAxisDelta(axis) {
    var translate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, scale = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, originPoint = arguments.length > 3 ? arguments[3] : void 0, boxScale = arguments.length > 4 ? arguments[4] : void 0;
    axis.min = applyPointDelta(axis.min, translate, scale, originPoint, boxScale);
    axis.max = applyPointDelta(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function applyBoxDelta(box, param) {
    var x = param.x, y = param.y;
    applyAxisDelta(box.x, x.translate, x.scale, x.originPoint);
    applyAxisDelta(box.y, y.translate, y.scale, y.originPoint);
}
var TREE_SCALE_SNAP_MIN = 0.999999999999;
var TREE_SCALE_SNAP_MAX = 1.0000000000001;
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function applyTreeDeltas(box, treeScale, treePath) {
    var isSharedTransition = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    var node;
    var delta;
    for(var i = 0; i < treeLength; i++){
        var _node_layout;
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ var visualElement = node.options.visualElement;
        if (visualElement && visualElement.props.style && visualElement.props.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) {
            translateAxis(box.x, -node.scroll.offset.x);
            translateAxis(box.y, -node.scroll.offset.y);
        }
        if (delta) {
            // Incoporate each ancestor's scale into a cumulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            applyBoxDelta(box, delta);
        }
        if (isSharedTransition && (0, _hasTransformMjs.hasTransform)(node.latestValues)) transformBox(box, node.latestValues, (_node_layout = node.layout) === null || _node_layout === void 0 ? void 0 : _node_layout.layoutBox);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ if (treeScale.x < TREE_SCALE_SNAP_MAX && treeScale.x > TREE_SCALE_SNAP_MIN) treeScale.x = 1.0;
    if (treeScale.y < TREE_SCALE_SNAP_MAX && treeScale.y > TREE_SCALE_SNAP_MIN) treeScale.y = 1.0;
}
function translateAxis(axis, distance) {
    axis.min += distance;
    axis.max += distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function transformAxis(axis, axisTranslate, axisScale, boxScale) {
    var axisOrigin = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0.5;
    var originPoint = (0, _numberMjs.mixNumber)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    applyAxisDelta(axis, axisTranslate, axisScale, originPoint, boxScale);
}
function resolveAxisTranslate(value, axis) {
    if (typeof value === "string") return parseFloat(value) / 100 * (axis.max - axis.min);
    return value;
}
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function transformBox(box, transform, sourceBox) {
    var resolveBox = sourceBox !== null && sourceBox !== void 0 ? sourceBox : box;
    transformAxis(box.x, resolveAxisTranslate(transform.x, resolveBox.x), transform.scaleX, transform.scale, transform.originX);
    transformAxis(box.y, resolveAxisTranslate(transform.y, resolveBox.y), transform.scaleY, transform.scale, transform.originY);
}

},{"../../utils/mix/number.mjs":"j0eyN","../utils/has-transform.mjs":"bAGvf","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bAGvf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "has2DTranslate", function() {
    return has2DTranslate;
});
parcelHelpers.export(exports, "hasScale", function() {
    return hasScale;
});
parcelHelpers.export(exports, "hasTransform", function() {
    return hasTransform;
});
function isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function hasScale(param) {
    var scale = param.scale, scaleX = param.scaleX, scaleY = param.scaleY;
    return !isIdentityScale(scale) || !isIdentityScale(scaleX) || !isIdentityScale(scaleY);
}
function hasTransform(values) {
    return hasScale(values) || has2DTranslate(values) || values.z || values.rotate || values.rotateX || values.rotateY || values.skewX || values.skewY;
}
function has2DTranslate(values) {
    return is2DTranslate(values.x) || is2DTranslate(values.y);
}
function is2DTranslate(value) {
    return value && value !== "0%";
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gch0a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildHTMLStyles", function() {
    return buildHTMLStyles;
});
var _getAsTypeMjs = require("../../../value/types/utils/get-as-type.mjs");
var _numberMjs = require("../../../value/types/maps/number.mjs");
var _keysTransformMjs = require("../../utils/keys-transform.mjs");
var _isCssVariableMjs = require("../../../animation/utils/is-css-variable.mjs");
var _buildTransformMjs = require("./build-transform.mjs");
function buildHTMLStyles(state, latestValues, transformTemplate) {
    var style = state.style, vars = state.vars, transformOrigin = state.transformOrigin;
    // Track whether we encounter any transform or transformOrigin values.
    var hasTransform = false;
    var hasTransformOrigin = false;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept separately for further processing.
     */ for(var key in latestValues){
        var value = latestValues[key];
        if ((0, _keysTransformMjs.transformProps).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            continue;
        } else if ((0, _isCssVariableMjs.isCSSVariableName)(key)) {
            vars[key] = value;
            continue;
        } else {
            // Convert the value to its default value type, ie 0 -> "0px"
            var valueAsType = (0, _getAsTypeMjs.getValueAsType)(value, (0, _numberMjs.numberValueTypes)[key]);
            if (key.startsWith("origin")) {
                // If this is a transform origin, flag and enable further transform-origin processing
                hasTransformOrigin = true;
                transformOrigin[key] = valueAsType;
            } else style[key] = valueAsType;
        }
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, _buildTransformMjs.buildTransform)(latestValues, state.transform, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        var _transformOrigin_originX = transformOrigin.originX, originX = _transformOrigin_originX === void 0 ? "50%" : _transformOrigin_originX, _transformOrigin_originY = transformOrigin.originY, originY = _transformOrigin_originY === void 0 ? "50%" : _transformOrigin_originY, _transformOrigin_originZ = transformOrigin.originZ, originZ = _transformOrigin_originZ === void 0 ? 0 : _transformOrigin_originZ;
        style.transformOrigin = "".concat(originX, " ").concat(originY, " ").concat(originZ);
    }
}

},{"../../../value/types/utils/get-as-type.mjs":"cE0Ua","../../../value/types/maps/number.mjs":"fcZR9","../../utils/keys-transform.mjs":"91lmj","../../../animation/utils/is-css-variable.mjs":"5nV2N","./build-transform.mjs":"hcEfp","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hcEfp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildTransform", function() {
    return buildTransform;
});
var _getAsTypeMjs = require("../../../value/types/utils/get-as-type.mjs");
var _numberMjs = require("../../../value/types/maps/number.mjs");
var _keysTransformMjs = require("../../utils/keys-transform.mjs");
var translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
var numTransforms = (0, _keysTransformMjs.transformPropOrder).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function buildTransform(latestValues, transform, transformTemplate) {
    // The transform string we're going to build into.
    var transformString = "";
    var transformIsDefault = true;
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(var i = 0; i < numTransforms; i++){
        var key = (0, _keysTransformMjs.transformPropOrder)[i];
        var value = latestValues[key];
        if (value === undefined) continue;
        var valueIsDefault = true;
        if (typeof value === "number") valueIsDefault = value === (key.startsWith("scale") ? 1 : 0);
        else {
            var parsed = parseFloat(value);
            valueIsDefault = key.startsWith("scale") ? parsed === 1 : parsed === 0;
        }
        if (!valueIsDefault || transformTemplate) {
            var valueAsType = (0, _getAsTypeMjs.getValueAsType)(value, (0, _numberMjs.numberValueTypes)[key]);
            if (!valueIsDefault) {
                transformIsDefault = false;
                var transformName = translateAlias[key] || key;
                transformString += "".concat(transformName, "(").concat(valueAsType, ") ");
            }
            if (transformTemplate) transform[key] = valueAsType;
        }
    }
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (transformIsDefault) transformString = "none";
    return transformString;
}

},{"../../../value/types/utils/get-as-type.mjs":"cE0Ua","../../../value/types/maps/number.mjs":"fcZR9","../../utils/keys-transform.mjs":"91lmj","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cSqL4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "renderHTML", function() {
    return renderHTML;
});
function renderHTML(element, param, styleProp, projection) {
    var style = param.style, vars = param.vars;
    var elementStyle = element.style;
    var key;
    for(key in style)// CSSStyleDeclaration has [index: number]: string; in the types, so we use that as key type.
    elementStyle[key] = style[key];
    // Write projection styles directly to element style
    projection === null || projection === void 0 ? void 0 : projection.applyProjectionStyles(elementStyle, styleProp);
    for(key in vars)// Loop over any CSS variables and assign those.
    // They can only be assigned using `setProperty`.
    elementStyle.setProperty(key, vars[key]);
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7lZGa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scrapeMotionValuesFromProps", function() {
    return scrapeMotionValuesFromProps;
});
var _isMotionValueMjs = require("../../../value/utils/is-motion-value.mjs");
var _isForcedMotionValueMjs = require("../../utils/is-forced-motion-value.mjs");
function scrapeMotionValuesFromProps(props, prevProps, visualElement) {
    var _visualElement_getValue;
    var style = props.style;
    var prevStyle = prevProps === null || prevProps === void 0 ? void 0 : prevProps.style;
    var newValues = {};
    if (!style) return newValues;
    for(var key in style)if ((0, _isMotionValueMjs.isMotionValue)(style[key]) || prevStyle && (0, _isMotionValueMjs.isMotionValue)(prevStyle[key]) || (0, _isForcedMotionValueMjs.isForcedMotionValue)(key, props) || (visualElement === null || visualElement === void 0 ? void 0 : (_visualElement_getValue = visualElement.getValue(key)) === null || _visualElement_getValue === void 0 ? void 0 : _visualElement_getValue.liveStyle) !== undefined) newValues[key] = style[key];
    return newValues;
}

},{"../../../value/utils/is-motion-value.mjs":"cYNey","../../utils/is-forced-motion-value.mjs":"6zPnO","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6zPnO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addScaleCorrector", function() {
    return 0, _scaleCorrectionMjs.addScaleCorrector;
});
parcelHelpers.export(exports, "isForcedMotionValue", function() {
    return isForcedMotionValue;
});
parcelHelpers.export(exports, "scaleCorrectors", function() {
    return 0, _scaleCorrectionMjs.scaleCorrectors;
});
var _keysTransformMjs = require("./keys-transform.mjs");
var _scaleCorrectionMjs = require("../../projection/styles/scale-correction.mjs");
function isForcedMotionValue(key, param) {
    var layout = param.layout, layoutId = param.layoutId;
    return (0, _keysTransformMjs.transformProps).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, _scaleCorrectionMjs.scaleCorrectors)[key] || key === "opacity");
}

},{"./keys-transform.mjs":"91lmj","../../projection/styles/scale-correction.mjs":"cExFS","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cExFS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addScaleCorrector", function() {
    return addScaleCorrector;
});
parcelHelpers.export(exports, "scaleCorrectors", function() {
    return scaleCorrectors;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _isCssVariableMjs = require("../../animation/utils/is-css-variable.mjs");
var _scaleBorderRadiusMjs = require("./scale-border-radius.mjs");
var _scaleBoxShadowMjs = require("./scale-box-shadow.mjs");
var scaleCorrectors = {
    borderRadius: (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _scaleBorderRadiusMjs.correctBorderRadius)), {
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    }),
    borderTopLeftRadius: (0, _scaleBorderRadiusMjs.correctBorderRadius),
    borderTopRightRadius: (0, _scaleBorderRadiusMjs.correctBorderRadius),
    borderBottomLeftRadius: (0, _scaleBorderRadiusMjs.correctBorderRadius),
    borderBottomRightRadius: (0, _scaleBorderRadiusMjs.correctBorderRadius),
    boxShadow: (0, _scaleBoxShadowMjs.correctBoxShadow)
};
function addScaleCorrector(correctors) {
    for(var key in correctors){
        scaleCorrectors[key] = correctors[key];
        if ((0, _isCssVariableMjs.isCSSVariableName)(key)) scaleCorrectors[key].isCSSVariable = true;
    }
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","../../animation/utils/is-css-variable.mjs":"5nV2N","./scale-border-radius.mjs":"7pIVE","./scale-box-shadow.mjs":"fJ1qX","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7pIVE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "correctBorderRadius", function() {
    return correctBorderRadius;
});
parcelHelpers.export(exports, "pixelsToPercent", function() {
    return pixelsToPercent;
});
var _unitsMjs = require("../../value/types/numbers/units.mjs");
function pixelsToPercent(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ var correctBorderRadius = {
    correct: function(latest, node) {
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, _unitsMjs.px).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ var x = pixelsToPercent(latest, node.target.x);
        var y = pixelsToPercent(latest, node.target.y);
        return "".concat(x, "% ").concat(y, "%");
    }
};

},{"../../value/types/numbers/units.mjs":"iC5kO","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fJ1qX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "correctBoxShadow", function() {
    return correctBoxShadow;
});
var _indexMjs = require("../../value/types/complex/index.mjs");
var _numberMjs = require("../../utils/mix/number.mjs");
var correctBoxShadow = {
    correct: function(latest, param) {
        var treeScale = param.treeScale, projectionDelta = param.projectionDelta;
        var original = latest;
        var shadow = (0, _indexMjs.complex).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        var template = (0, _indexMjs.complex).createTransformer(latest);
        var offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        var xScale = projectionDelta.x.scale * treeScale.x;
        var yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ var averageScale = (0, _numberMjs.mixNumber)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};

},{"../../value/types/complex/index.mjs":"6JMtB","../../utils/mix/number.mjs":"j0eyN","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"e9ZBr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ObjectVisualElement", function() {
    return ObjectVisualElement;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _modelsMjs = require("../../projection/geometry/models.mjs");
var _visualElementMjs = require("../VisualElement.mjs");
function isObjectKey(key, object) {
    return key in object;
}
var ObjectVisualElement = /*#__PURE__*/ function(VisualElement) {
    "use strict";
    (0, _inherits._)(ObjectVisualElement, VisualElement);
    function ObjectVisualElement() {
        (0, _classCallCheck._)(this, ObjectVisualElement);
        var _this;
        _this = (0, _callSuper._)(this, ObjectVisualElement, arguments);
        _this.type = "object";
        return _this;
    }
    (0, _createClass._)(ObjectVisualElement, [
        {
            key: "readValueFromInstance",
            value: function readValueFromInstance(instance, key) {
                if (isObjectKey(key, instance)) {
                    var value = instance[key];
                    if (typeof value === "string" || typeof value === "number") return value;
                }
                return undefined;
            }
        },
        {
            key: "getBaseTargetFromProps",
            value: function getBaseTargetFromProps() {
                return undefined;
            }
        },
        {
            key: "removeValueFromRenderState",
            value: function removeValueFromRenderState(key, renderState) {
                delete renderState.output[key];
            }
        },
        {
            key: "measureInstanceViewportBox",
            value: function measureInstanceViewportBox() {
                return (0, _modelsMjs.createBox)();
            }
        },
        {
            key: "build",
            value: function build(renderState, latestValues) {
                Object.assign(renderState.output, latestValues);
            }
        },
        {
            key: "renderInstance",
            value: function renderInstance(instance, param) {
                var output = param.output;
                Object.assign(instance, output);
            }
        },
        {
            key: "sortInstanceNodePosition",
            value: function sortInstanceNodePosition() {
                return 0;
            }
        }
    ]);
    return ObjectVisualElement;
}((0, _visualElementMjs.VisualElement));

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_inherits":"2sfqW","../../projection/geometry/models.mjs":"i3okE","../VisualElement.mjs":"1ZK29","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gDoaF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SVGVisualElement", function() {
    return SVGVisualElement;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _get = require("@swc/helpers/_/_get");
var _getPrototypeOf = require("@swc/helpers/_/_get_prototype_of");
var _inherits = require("@swc/helpers/_/_inherits");
var _keysTransformMjs = require("../utils/keys-transform.mjs");
var _defaultsMjs = require("../../value/types/maps/defaults.mjs");
var _modelsMjs = require("../../projection/geometry/models.mjs");
var _domvisualElementMjs = require("../dom/DOMVisualElement.mjs");
var _camelToDashMjs = require("../dom/utils/camel-to-dash.mjs");
var _buildAttrsMjs = require("./utils/build-attrs.mjs");
var _camelCaseAttrsMjs = require("./utils/camel-case-attrs.mjs");
var _isSvgTagMjs = require("./utils/is-svg-tag.mjs");
var _renderMjs = require("./utils/render.mjs");
var _scrapeMotionValuesMjs = require("./utils/scrape-motion-values.mjs");
var SVGVisualElement = /*#__PURE__*/ function(DOMVisualElement) {
    "use strict";
    (0, _inherits._)(SVGVisualElement, DOMVisualElement);
    function SVGVisualElement() {
        (0, _classCallCheck._)(this, SVGVisualElement);
        var _this;
        _this = (0, _callSuper._)(this, SVGVisualElement, arguments);
        _this.type = "svg";
        _this.isSVGTag = false;
        _this.measureInstanceViewportBox = (0, _modelsMjs.createBox);
        return _this;
    }
    (0, _createClass._)(SVGVisualElement, [
        {
            key: "getBaseTargetFromProps",
            value: function getBaseTargetFromProps(props, key) {
                return props[key];
            }
        },
        {
            key: "readValueFromInstance",
            value: function readValueFromInstance(instance, key) {
                if ((0, _keysTransformMjs.transformProps).has(key)) {
                    var defaultType = (0, _defaultsMjs.getDefaultValueType)(key);
                    return defaultType ? defaultType.default || 0 : 0;
                }
                key = !(0, _camelCaseAttrsMjs.camelCaseAttributes).has(key) ? (0, _camelToDashMjs.camelToDash)(key) : key;
                return instance.getAttribute(key);
            }
        },
        {
            key: "scrapeMotionValuesFromProps",
            value: function scrapeMotionValuesFromProps(props, prevProps, visualElement) {
                return (0, _scrapeMotionValuesMjs.scrapeMotionValuesFromProps)(props, prevProps, visualElement);
            }
        },
        {
            key: "build",
            value: function build(renderState, latestValues, props) {
                (0, _buildAttrsMjs.buildSVGAttrs)(renderState, latestValues, this.isSVGTag, props.transformTemplate, props.style);
            }
        },
        {
            key: "renderInstance",
            value: function renderInstance(instance, renderState, styleProp, projection) {
                (0, _renderMjs.renderSVG)(instance, renderState, styleProp, projection);
            }
        },
        {
            key: "mount",
            value: function mount(instance) {
                this.isSVGTag = (0, _isSvgTagMjs.isSVGTag)(instance.tagName);
                (0, _get._)((0, _getPrototypeOf._)(SVGVisualElement.prototype), "mount", this).call(this, instance);
            }
        }
    ]);
    return SVGVisualElement;
}((0, _domvisualElementMjs.DOMVisualElement));

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_get":"38TLD","@swc/helpers/_/_get_prototype_of":"5txK6","@swc/helpers/_/_inherits":"2sfqW","../utils/keys-transform.mjs":"91lmj","../../value/types/maps/defaults.mjs":"1QOLD","../../projection/geometry/models.mjs":"i3okE","../dom/DOMVisualElement.mjs":"isUIr","../dom/utils/camel-to-dash.mjs":"2DA9K","./utils/build-attrs.mjs":"jDjzT","./utils/camel-case-attrs.mjs":"dOfIy","./utils/is-svg-tag.mjs":"5H8Ff","./utils/render.mjs":"7t54Q","./utils/scrape-motion-values.mjs":"58bJ3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jDjzT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildSVGAttrs", function() {
    return buildSVGAttrs;
});
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _buildStylesMjs = require("../../html/utils/build-styles.mjs");
var _pathMjs = require("./path.mjs");
/**
 * CSS Motion Path properties that should remain as CSS styles on SVG elements.
 */ var cssMotionPathProperties = [
    "offsetDistance",
    "offsetPath",
    "offsetRotate",
    "offsetAnchor"
];
/**
 * Build SVG visual attributes, like cx and style.transform
 */ function buildSVGAttrs(state, _param, isSVGTag, transformTemplate, styleProp) {
    var attrX = _param.attrX, attrY = _param.attrY, attrScale = _param.attrScale, pathLength = _param.pathLength, _param_pathSpacing = _param.pathSpacing, pathSpacing = _param_pathSpacing === void 0 ? 1 : _param_pathSpacing, _param_pathOffset = _param.pathOffset, pathOffset = _param_pathOffset === void 0 ? 0 : _param_pathOffset, latest = (0, _objectWithoutProperties._)(_param, [
        "attrX",
        "attrY",
        "attrScale",
        "pathLength",
        "pathSpacing",
        "pathOffset"
    ]);
    (0, _buildStylesMjs.buildHTMLStyles)(state, latest, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    var attrs = state.attrs, style = state.style;
    /**
     * However, we apply transforms as CSS transforms.
     * So if we detect a transform, transformOrigin we take it from attrs and copy it into style.
     */ if (attrs.transform) {
        style.transform = attrs.transform;
        delete attrs.transform;
    }
    if (style.transform || attrs.transformOrigin) {
        var _attrs_transformOrigin;
        style.transformOrigin = (_attrs_transformOrigin = attrs.transformOrigin) !== null && _attrs_transformOrigin !== void 0 ? _attrs_transformOrigin : "50% 50%";
        delete attrs.transformOrigin;
    }
    if (style.transform) {
        var _styleProp_transformBox;
        /**
         * SVG's element transform-origin uses its own median as a reference.
         * Therefore, transformBox becomes a fill-box
         */ style.transformBox = (_styleProp_transformBox = styleProp === null || styleProp === void 0 ? void 0 : styleProp.transformBox) !== null && _styleProp_transformBox !== void 0 ? _styleProp_transformBox : "fill-box";
        delete attrs.transformBox;
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = cssMotionPathProperties[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (attrs[key] !== undefined) {
                style[key] = attrs[key];
                delete attrs[key];
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, _pathMjs.buildSVGPath)(attrs, pathLength, pathSpacing, pathOffset, false);
}

},{"@swc/helpers/_/_object_without_properties":"6HqIM","../../html/utils/build-styles.mjs":"gch0a","./path.mjs":"43lki","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"43lki":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildSVGPath", function() {
    return buildSVGPath;
});
var dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
var camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 *
 * Note: We use unitless values for stroke-dasharray and stroke-dashoffset
 * because Safari incorrectly scales px values when the page is zoomed.
 */ function buildSVGPath(attrs, length) {
    var spacing = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, offset = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, useDashCase = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : true;
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    var keys = useDashCase ? dashKeys : camelKeys;
    // Build the dash offset (unitless to avoid Safari zoom bug)
    attrs[keys.offset] = "".concat(-offset);
    // Build the dash array (unitless to avoid Safari zoom bug)
    attrs[keys.array] = "".concat(length, " ").concat(spacing);
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dOfIy":[function(require,module,exports,__globalThis) {
/**
 * A set of attribute names that are always read/written as camel case.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "camelCaseAttributes", function() {
    return camelCaseAttributes;
});
var camelCaseAttributes = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5H8Ff":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isSVGTag", function() {
    return isSVGTag;
});
var isSVGTag = function(tag) {
    return typeof tag === "string" && tag.toLowerCase() === "svg";
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7t54Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "renderSVG", function() {
    return renderSVG;
});
var _camelToDashMjs = require("../../dom/utils/camel-to-dash.mjs");
var _renderMjs = require("../../html/utils/render.mjs");
var _camelCaseAttrsMjs = require("./camel-case-attrs.mjs");
function renderSVG(element, renderState, _styleProp, projection) {
    (0, _renderMjs.renderHTML)(element, renderState, undefined, projection);
    for(var key in renderState.attrs)element.setAttribute(!(0, _camelCaseAttrsMjs.camelCaseAttributes).has(key) ? (0, _camelToDashMjs.camelToDash)(key) : key, renderState.attrs[key]);
}

},{"../../dom/utils/camel-to-dash.mjs":"2DA9K","../../html/utils/render.mjs":"cSqL4","./camel-case-attrs.mjs":"dOfIy","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"58bJ3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scrapeMotionValuesFromProps", function() {
    return scrapeMotionValuesFromProps;
});
var _isMotionValueMjs = require("../../../value/utils/is-motion-value.mjs");
var _keysTransformMjs = require("../../utils/keys-transform.mjs");
var _scrapeMotionValuesMjs = require("../../html/utils/scrape-motion-values.mjs");
function scrapeMotionValuesFromProps(props, prevProps, visualElement) {
    var newValues = (0, _scrapeMotionValuesMjs.scrapeMotionValuesFromProps)(props, prevProps, visualElement);
    for(var key in props)if ((0, _isMotionValueMjs.isMotionValue)(props[key]) || (0, _isMotionValueMjs.isMotionValue)(prevProps[key])) {
        var targetKey = (0, _keysTransformMjs.transformPropOrder).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}

},{"../../../value/utils/is-motion-value.mjs":"cYNey","../../utils/keys-transform.mjs":"91lmj","../../html/utils/scrape-motion-values.mjs":"7lZGa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9qv2D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "checkVariantsDidChange", function() {
    return checkVariantsDidChange;
});
parcelHelpers.export(exports, "createAnimationState", function() {
    return createAnimationState;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _visualElementMjs = require("../../animation/interfaces/visual-element.mjs");
var _calcChildStaggerMjs = require("../../animation/utils/calc-child-stagger.mjs");
var _getVariantContextMjs = require("./get-variant-context.mjs");
var _isAnimationControlsMjs = require("./is-animation-controls.mjs");
var _isKeyframesTargetMjs = require("./is-keyframes-target.mjs");
var _isVariantLabelMjs = require("./is-variant-label.mjs");
var _resolveDynamicVariantsMjs = require("./resolve-dynamic-variants.mjs");
var _shallowCompareMjs = require("./shallow-compare.mjs");
var _variantPropsMjs = require("./variant-props.mjs");
var reversePriorityOrder = (0, _toConsumableArray._)((0, _variantPropsMjs.variantPriorityOrder)).reverse();
var numAnimationTypes = (0, _variantPropsMjs.variantPriorityOrder).length;
function createAnimateFunction(visualElement) {
    return function(animations) {
        return Promise.all(animations.map(function(param) {
            var animation = param.animation, options = param.options;
            return (0, _visualElementMjs.animateVisualElement)(visualElement, animation, options);
        }));
    };
}
function createAnimationState(visualElement) {
    var animate = createAnimateFunction(visualElement);
    var state = createState();
    var isInitialRender = true;
    /**
     * Track whether the animation state has been reset (e.g. via StrictMode
     * double-invocation or Suspense unmount/remount). On the first
     * animateChanges() call after a reset we need to behave like the initial
     * render for variant-inheritance checks, even though isInitialRender is
     * already false.
     */ var wasReset = false;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ var buildResolvedTypeValues = function(type) {
        return function(acc, definition) {
            var _visualElement_presenceContext;
            var resolved = (0, _resolveDynamicVariantsMjs.resolveVariant)(visualElement, definition, type === "exit" ? (_visualElement_presenceContext = visualElement.presenceContext) === null || _visualElement_presenceContext === void 0 ? void 0 : _visualElement_presenceContext.custom : undefined);
            if (resolved) {
                var transition = resolved.transition, transitionEnd = resolved.transitionEnd, target = (0, _objectWithoutProperties._)(resolved, [
                    "transition",
                    "transitionEnd"
                ]);
                acc = (0, _objectSpread._)({}, acc, target, transitionEnd);
            }
            return acc;
        };
    };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(changedActiveType) {
        var _loop = function(i) {
            var _animations;
            var type = reversePriorityOrder[i];
            var typeState = state[type];
            var prop = props[type] !== undefined ? props[type] : context[type];
            var propIsVariant = (0, _isVariantLabelMjs.isVariantLabel)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ var activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ var isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            if (isInherited && (isInitialRender || wasReset) && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = (0, _objectSpread._)({}, encounteredKeys);
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, _isAnimationControlsMjs.isAnimationControls)(prop) || typeof prop === "boolean") return "continue";
            /**
             * If exit is already active and wasn't just activated, skip
             * re-processing to prevent interrupting running exit animations.
             * Re-resolving exit with a changed custom value can start new
             * value animations that stop the originals, leaving the exit
             * animation promise unresolved and the component stuck in the DOM.
             */ if (type === "exit" && typeState.isActive && activeDelta !== true) {
                if (typeState.prevResolvedValues) encounteredKeys = (0, _objectSpread._)({}, encounteredKeys, typeState.prevResolvedValues);
                return "continue";
            }
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ var variantDidChange = checkVariantsDidChange(typeState.prevProp, prop);
            var shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            var handledRemovedValues = false;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ var definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ var resolvedValues = definitionList.reduce(buildResolvedTypeValues(type), {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ var _typeState_prevResolvedValues = typeState.prevResolvedValues, prevResolvedValues = _typeState_prevResolvedValues === void 0 ? {} : _typeState_prevResolvedValues;
            var allKeys = (0, _objectSpread._)({}, prevResolvedValues, resolvedValues);
            var markToAnimate = function(key) {
                shouldAnimateType = true;
                if (removedKeys.has(key)) {
                    handledRemovedValues = true;
                    removedKeys.delete(key);
                }
                typeState.needsAnimating[key] = true;
                var motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = false;
            };
            for(var key in allKeys){
                var next = resolvedValues[key];
                var prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ var valueHasChanged = false;
                if ((0, _isKeyframesTargetMjs.isKeyframesTarget)(next) && (0, _isKeyframesTargetMjs.isKeyframesTarget)(prev)) valueHasChanged = !(0, _shallowCompareMjs.shallowCompare)(next, prev);
                else valueHasChanged = next !== prev;
                if (valueHasChanged) {
                    if (next !== undefined && next !== null) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            if (typeState.isActive) encounteredKeys = (0, _objectSpread._)({}, encounteredKeys, resolvedValues);
            if ((isInitialRender || wasReset) && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to skip this animation
             * unless the inherited variants haven't changed on this render.
             */ var willAnimateViaParent = isInherited && variantDidChange;
            var needsAnimating = !willAnimateViaParent || handledRemovedValues;
            if (shouldAnimateType && needsAnimating) (_animations = animations).push.apply(_animations, (0, _toConsumableArray._)(definitionList.map(function(animation) {
                var options = {
                    type: type
                };
                /**
                     * If we're performing the initial animation, but we're not
                     * rendering at the same time as the variant-controlling parent,
                     * we want to use the parent's transition to calculate the stagger.
                     */ if (typeof animation === "string" && (isInitialRender || wasReset) && !willAnimateViaParent && visualElement.manuallyAnimateOnMount && visualElement.parent) {
                    var parent = visualElement.parent;
                    var parentVariant = (0, _resolveDynamicVariantsMjs.resolveVariant)(parent, animation);
                    if (parent.enteringChildren && parentVariant) {
                        var delayChildren = (parentVariant.transition || {}).delayChildren;
                        options.delay = (0, _calcChildStaggerMjs.calcChildStagger)(parent.enteringChildren, visualElement, delayChildren);
                    }
                }
                return {
                    animation: animation,
                    options: options
                };
            })));
        };
        var props = visualElement.props;
        var context = (0, _getVariantContextMjs.getVariantContext)(visualElement.parent) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ var animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ var removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ var encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ var removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(var i = 0; i < numAnimationTypes; i++)_loop(i);
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            var fallbackAnimation = {};
            /**
             * If the initial prop contains a transition we can use that, otherwise
             * allow the animation function to use the visual element's default.
             */ if (typeof props.initial !== "boolean") {
                var initialTransition = (0, _resolveDynamicVariantsMjs.resolveVariant)(visualElement, Array.isArray(props.initial) ? props.initial[0] : props.initial);
                if (initialTransition && initialTransition.transition) fallbackAnimation.transition = initialTransition.transition;
            }
            removedKeys.forEach(function(key) {
                var fallbackTarget = visualElement.getBaseTarget(key);
                var motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = true;
                // @ts-expect-error - @mattgperry to figure if we should do something here
                fallbackAnimation[key] = fallbackTarget !== null && fallbackTarget !== void 0 ? fallbackTarget : null;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        var shouldAnimate = Boolean(animations.length);
        if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        wasReset = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive) {
        var // Propagate active change to children
        _visualElement_variantChildren;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        (_visualElement_variantChildren = visualElement.variantChildren) === null || _visualElement_variantChildren === void 0 ? void 0 : _visualElement_variantChildren.forEach(function(child) {
            var _child_animationState;
            return (_child_animationState = child.animationState) === null || _child_animationState === void 0 ? void 0 : _child_animationState.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        var animations = animateChanges(type);
        for(var key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: function() {
            return state;
        },
        reset: function() {
            state = createState();
            wasReset = true;
        }
    };
}
function checkVariantsDidChange(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, _shallowCompareMjs.shallowCompare)(next, prev);
    return false;
}
function createTypeState() {
    var isActive = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function createState() {
    return {
        animate: createTypeState(true),
        whileInView: createTypeState(),
        whileHover: createTypeState(),
        whileTap: createTypeState(),
        whileDrag: createTypeState(),
        whileFocus: createTypeState(),
        exit: createTypeState()
    };
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_without_properties":"6HqIM","@swc/helpers/_/_to_consumable_array":"1eSZf","../../animation/interfaces/visual-element.mjs":"dkWvU","../../animation/utils/calc-child-stagger.mjs":"h5ciR","./get-variant-context.mjs":"hahtH","./is-animation-controls.mjs":"4N6Mr","./is-keyframes-target.mjs":"lh5lz","./is-variant-label.mjs":"aChc4","./resolve-dynamic-variants.mjs":"5FiD7","./shallow-compare.mjs":"3nct6","./variant-props.mjs":"2ZATM","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hahtH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getVariantContext", function() {
    return getVariantContext;
});
var _isVariantLabelMjs = require("./is-variant-label.mjs");
var _variantPropsMjs = require("./variant-props.mjs");
var numVariantProps = (0, _variantPropsMjs.variantProps).length;
/**
 * Get variant context from a visual element's parent chain.
 * Uses `any` type for visualElement to avoid circular dependencies.
 */ function getVariantContext(visualElement) {
    if (!visualElement) return undefined;
    if (!visualElement.isControllingVariants) {
        var context = visualElement.parent ? getVariantContext(visualElement.parent) || {} : {};
        if (visualElement.props.initial !== undefined) context.initial = visualElement.props.initial;
        return context;
    }
    var context1 = {};
    for(var i = 0; i < numVariantProps; i++){
        var name = (0, _variantPropsMjs.variantProps)[i];
        var prop = visualElement.props[name];
        if ((0, _isVariantLabelMjs.isVariantLabel)(prop) || prop === false) context1[name] = prop;
    }
    return context1;
}

},{"./is-variant-label.mjs":"aChc4","./variant-props.mjs":"2ZATM","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3nct6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shallowCompare", function() {
    return shallowCompare;
});
function shallowCompare(next, prev) {
    if (!Array.isArray(prev)) return false;
    var prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(var i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"c2JNt":[function(require,module,exports,__globalThis) {
/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "copyAxisDeltaInto", function() {
    return copyAxisDeltaInto;
});
parcelHelpers.export(exports, "copyAxisInto", function() {
    return copyAxisInto;
});
parcelHelpers.export(exports, "copyBoxInto", function() {
    return copyBoxInto;
});
function copyAxisInto(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function copyBoxInto(box, originBox) {
    copyAxisInto(box.x, originBox.x);
    copyAxisInto(box.y, originBox.y);
}
/**
 * Reset a delta to the provided origin box.
 *
 * This is a mutative operation.
 */ function copyAxisDeltaInto(delta, originDelta) {
    delta.translate = originDelta.translate;
    delta.scale = originDelta.scale;
    delta.originPoint = originDelta.originPoint;
    delta.origin = originDelta.origin;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gXjVB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calcAxisDelta", function() {
    return calcAxisDelta;
});
parcelHelpers.export(exports, "calcBoxDelta", function() {
    return calcBoxDelta;
});
parcelHelpers.export(exports, "calcLength", function() {
    return calcLength;
});
parcelHelpers.export(exports, "calcRelativeAxis", function() {
    return calcRelativeAxis;
});
parcelHelpers.export(exports, "calcRelativeAxisPosition", function() {
    return calcRelativeAxisPosition;
});
parcelHelpers.export(exports, "calcRelativeBox", function() {
    return calcRelativeBox;
});
parcelHelpers.export(exports, "calcRelativePosition", function() {
    return calcRelativePosition;
});
parcelHelpers.export(exports, "isNear", function() {
    return isNear;
});
var _numberMjs = require("../../utils/mix/number.mjs");
var SCALE_PRECISION = 0.0001;
var SCALE_MIN = 1 - SCALE_PRECISION;
var SCALE_MAX = 1 + SCALE_PRECISION;
var TRANSLATE_PRECISION = 0.01;
var TRANSLATE_MIN = 0 - TRANSLATE_PRECISION;
var TRANSLATE_MAX = 0 + TRANSLATE_PRECISION;
function calcLength(axis) {
    return axis.max - axis.min;
}
function isNear(value, target, maxDistance) {
    return Math.abs(value - target) <= maxDistance;
}
function calcAxisDelta(delta, source, target) {
    var origin = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0.5;
    delta.origin = origin;
    delta.originPoint = (0, _numberMjs.mixNumber)(source.min, source.max, delta.origin);
    delta.scale = calcLength(target) / calcLength(source);
    delta.translate = (0, _numberMjs.mixNumber)(target.min, target.max, delta.origin) - delta.originPoint;
    if (delta.scale >= SCALE_MIN && delta.scale <= SCALE_MAX || isNaN(delta.scale)) delta.scale = 1.0;
    if (delta.translate >= TRANSLATE_MIN && delta.translate <= TRANSLATE_MAX || isNaN(delta.translate)) delta.translate = 0.0;
}
function calcBoxDelta(delta, source, target, origin) {
    calcAxisDelta(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    calcAxisDelta(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function calcRelativeAxis(target, relative, parent) {
    var anchor = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    var anchorPoint = anchor ? (0, _numberMjs.mixNumber)(parent.min, parent.max, anchor) : parent.min;
    target.min = anchorPoint + relative.min;
    target.max = target.min + calcLength(relative);
}
function calcRelativeBox(target, relative, parent, anchor) {
    calcRelativeAxis(target.x, relative.x, parent.x, anchor === null || anchor === void 0 ? void 0 : anchor.x);
    calcRelativeAxis(target.y, relative.y, parent.y, anchor === null || anchor === void 0 ? void 0 : anchor.y);
}
function calcRelativeAxisPosition(target, layout, parent) {
    var anchor = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    var anchorPoint = anchor ? (0, _numberMjs.mixNumber)(parent.min, parent.max, anchor) : parent.min;
    target.min = layout.min - anchorPoint;
    target.max = target.min + calcLength(layout);
}
function calcRelativePosition(target, layout, parent, anchor) {
    calcRelativeAxisPosition(target.x, layout.x, parent.x, anchor === null || anchor === void 0 ? void 0 : anchor.x);
    calcRelativeAxisPosition(target.y, layout.y, parent.y, anchor === null || anchor === void 0 ? void 0 : anchor.y);
}

},{"../../utils/mix/number.mjs":"j0eyN","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"j7Gx5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "removeAxisDelta", function() {
    return removeAxisDelta;
});
parcelHelpers.export(exports, "removeAxisTransforms", function() {
    return removeAxisTransforms;
});
parcelHelpers.export(exports, "removeBoxTransforms", function() {
    return removeBoxTransforms;
});
parcelHelpers.export(exports, "removePointDelta", function() {
    return removePointDelta;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _numberMjs = require("../../utils/mix/number.mjs");
var _unitsMjs = require("../../value/types/numbers/units.mjs");
var _deltaApplyMjs = require("./delta-apply.mjs");
/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function removePointDelta(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, _deltaApplyMjs.scalePoint)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, _deltaApplyMjs.scalePoint)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function removeAxisDelta(axis) {
    var translate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, scale = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, origin = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0.5, boxScale = arguments.length > 4 ? arguments[4] : void 0, originAxis = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : axis, sourceAxis = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : axis;
    if ((0, _unitsMjs.percent).test(translate)) {
        translate = parseFloat(translate);
        var relativeProgress = (0, _numberMjs.mixNumber)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    var originPoint = (0, _numberMjs.mixNumber)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = removePointDelta(axis.min, translate, scale, originPoint, boxScale);
    axis.max = removePointDelta(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function removeAxisTransforms(axis, transforms, param, origin, sourceAxis) {
    var _param = (0, _slicedToArray._)(param, 3), key = _param[0], scaleKey = _param[1], originKey = _param[2];
    removeAxisDelta(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ var xKeys = [
    "x",
    "scaleX",
    "originX"
];
var yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function removeBoxTransforms(box, transforms, originBox, sourceBox) {
    removeAxisTransforms(box.x, transforms, xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    removeAxisTransforms(box.y, transforms, yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","../../utils/mix/number.mjs":"j0eyN","../../value/types/numbers/units.mjs":"iC5kO","./delta-apply.mjs":"ltFfy","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aQEwH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "aspectRatio", function() {
    return aspectRatio;
});
parcelHelpers.export(exports, "axisDeltaEquals", function() {
    return axisDeltaEquals;
});
parcelHelpers.export(exports, "axisEquals", function() {
    return axisEquals;
});
parcelHelpers.export(exports, "axisEqualsRounded", function() {
    return axisEqualsRounded;
});
parcelHelpers.export(exports, "boxEquals", function() {
    return boxEquals;
});
parcelHelpers.export(exports, "boxEqualsRounded", function() {
    return boxEqualsRounded;
});
parcelHelpers.export(exports, "isDeltaZero", function() {
    return isDeltaZero;
});
var _deltaCalcMjs = require("./delta-calc.mjs");
function isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function isDeltaZero(delta) {
    return isAxisDeltaZero(delta.x) && isAxisDeltaZero(delta.y);
}
function axisEquals(a, b) {
    return a.min === b.min && a.max === b.max;
}
function boxEquals(a, b) {
    return axisEquals(a.x, b.x) && axisEquals(a.y, b.y);
}
function axisEqualsRounded(a, b) {
    return Math.round(a.min) === Math.round(b.min) && Math.round(a.max) === Math.round(b.max);
}
function boxEqualsRounded(a, b) {
    return axisEqualsRounded(a.x, b.x) && axisEqualsRounded(a.y, b.y);
}
function aspectRatio(box) {
    return (0, _deltaCalcMjs.calcLength)(box.x) / (0, _deltaCalcMjs.calcLength)(box.y);
}
function axisDeltaEquals(a, b) {
    return a.translate === b.translate && a.scale === b.scale && a.originPoint === b.originPoint;
}

},{"./delta-calc.mjs":"gXjVB","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lkSyh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "eachAxis", function() {
    return eachAxis;
});
function eachAxis(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4GQSO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildProjectionTransform", function() {
    return buildProjectionTransform;
});
function buildProjectionTransform(delta, treeScale, latestTransform) {
    var transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ var xTranslate = delta.x.translate / treeScale.x;
    var yTranslate = delta.y.translate / treeScale.y;
    var zTranslate = (latestTransform === null || latestTransform === void 0 ? void 0 : latestTransform.z) || 0;
    if (xTranslate || yTranslate || zTranslate) transform = "translate3d(".concat(xTranslate, "px, ").concat(yTranslate, "px, ").concat(zTranslate, "px) ");
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += "scale(".concat(1 / treeScale.x, ", ").concat(1 / treeScale.y, ") ");
    if (latestTransform) {
        var transformPerspective = latestTransform.transformPerspective, rotate = latestTransform.rotate, rotateX = latestTransform.rotateX, rotateY = latestTransform.rotateY, skewX = latestTransform.skewX, skewY = latestTransform.skewY;
        if (transformPerspective) transform = "perspective(".concat(transformPerspective, "px) ").concat(transform);
        if (rotate) transform += "rotate(".concat(rotate, "deg) ");
        if (rotateX) transform += "rotateX(".concat(rotateX, "deg) ");
        if (rotateY) transform += "rotateY(".concat(rotateY, "deg) ");
        if (skewX) transform += "skewX(".concat(skewX, "deg) ");
        if (skewY) transform += "skewY(".concat(skewY, "deg) ");
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ var elementScaleX = delta.x.scale * treeScale.x;
    var elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += "scale(".concat(elementScaleX, ", ").concat(elementScaleY, ")");
    return transform || "none";
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jHs2u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mixValues", function() {
    return mixValues;
});
var _numberMjs = require("../../utils/mix/number.mjs");
var _unitsMjs = require("../../value/types/numbers/units.mjs");
var _motionUtils = require("motion-utils");
var borderLabels = [
    "borderTopLeftRadius",
    "borderTopRightRadius",
    "borderBottomLeftRadius",
    "borderBottomRightRadius"
];
var numBorders = borderLabels.length;
var asNumber = function(value) {
    return typeof value === "string" ? parseFloat(value) : value;
};
var isPx = function(value) {
    return typeof value === "number" || (0, _unitsMjs.px).test(value);
};
function mixValues(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    var _follow_opacity, _lead_opacity;
    if (shouldCrossfadeOpacity) {
        var _lead_opacity1;
        target.opacity = (0, _numberMjs.mixNumber)(0, (_lead_opacity1 = lead.opacity) !== null && _lead_opacity1 !== void 0 ? _lead_opacity1 : 1, easeCrossfadeIn(progress));
        var _follow_opacity1;
        target.opacityExit = (0, _numberMjs.mixNumber)((_follow_opacity1 = follow.opacity) !== null && _follow_opacity1 !== void 0 ? _follow_opacity1 : 1, 0, easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, _numberMjs.mixNumber)((_follow_opacity = follow.opacity) !== null && _follow_opacity !== void 0 ? _follow_opacity : 1, (_lead_opacity = lead.opacity) !== null && _lead_opacity !== void 0 ? _lead_opacity : 1, progress);
    /**
     * Mix border radius
     */ for(var i = 0; i < numBorders; i++){
        var borderLabel = borderLabels[i];
        var followRadius = getRadius(follow, borderLabel);
        var leadRadius = getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        var canMix = followRadius === 0 || leadRadius === 0 || isPx(followRadius) === isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, _numberMjs.mixNumber)(asNumber(followRadius), asNumber(leadRadius), progress), 0);
            if ((0, _unitsMjs.percent).test(leadRadius) || (0, _unitsMjs.percent).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, _numberMjs.mixNumber)(follow.rotate || 0, lead.rotate || 0, progress);
}
function getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
var easeCrossfadeIn = /*@__PURE__*/ compress(0, 0.5, (0, _motionUtils.circOut));
var easeCrossfadeOut = /*@__PURE__*/ compress(0.5, 0.95, (0, _motionUtils.noop));
function compress(min, max, easing) {
    return function(p) {
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, _motionUtils.progress)(min, max, p));
    };
}

},{"../../utils/mix/number.mjs":"j0eyN","../../value/types/numbers/units.mjs":"iC5kO","motion-utils":"9Q5qC","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cbr0l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animateSingleValue", function() {
    return animateSingleValue;
});
var _motionValueMjs = require("../interfaces/motion-value.mjs");
var _indexMjs = require("../../value/index.mjs");
var _isMotionValueMjs = require("../../value/utils/is-motion-value.mjs");
function animateSingleValue(value, keyframes, options) {
    var motionValue$1 = (0, _isMotionValueMjs.isMotionValue)(value) ? value : (0, _indexMjs.motionValue)(value);
    motionValue$1.start((0, _motionValueMjs.animateMotionValue)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}

},{"../interfaces/motion-value.mjs":"dwpM4","../../value/index.mjs":"lOANY","../../value/utils/is-motion-value.mjs":"cYNey","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iFSgF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addDomEvent", function() {
    return addDomEvent;
});
function addDomEvent(target, eventName, handler) {
    var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
        passive: true
    };
    target.addEventListener(eventName, handler, options);
    return function() {
        return target.removeEventListener(eventName, handler);
    };
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lThrv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "compareByDepth", function() {
    return compareByDepth;
});
var compareByDepth = function(a, b) {
    return a.depth - b.depth;
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"isDUr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FlatTree", function() {
    return FlatTree;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _motionUtils = require("motion-utils");
var _compareByDepthMjs = require("./compare-by-depth.mjs");
var FlatTree = /*#__PURE__*/ function() {
    "use strict";
    function FlatTree() {
        (0, _classCallCheck._)(this, FlatTree);
        this.children = [];
        this.isDirty = false;
    }
    (0, _createClass._)(FlatTree, [
        {
            key: "add",
            value: function add(child) {
                (0, _motionUtils.addUniqueItem)(this.children, child);
                this.isDirty = true;
            }
        },
        {
            key: "remove",
            value: function remove(child) {
                (0, _motionUtils.removeItem)(this.children, child);
                this.isDirty = true;
            }
        },
        {
            key: "forEach",
            value: function forEach(callback) {
                this.isDirty && this.children.sort((0, _compareByDepthMjs.compareByDepth));
                this.isDirty = false;
                this.children.forEach(callback);
            }
        }
    ]);
    return FlatTree;
}();

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","motion-utils":"9Q5qC","./compare-by-depth.mjs":"lThrv","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5W0bS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "delay", function() {
    return delay;
});
parcelHelpers.export(exports, "delayInSeconds", function() {
    return delayInSeconds;
});
var _syncTimeMjs = require("../frameloop/sync-time.mjs");
var _motionUtils = require("motion-utils");
var _frameMjs = require("../frameloop/frame.mjs");
/**
 * Timeout defined in ms
 */ function delay(callback, timeout) {
    var start = (0, _syncTimeMjs.time).now();
    var checkElapsed = function(param) {
        var timestamp = param.timestamp;
        var elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, _frameMjs.cancelFrame)(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, _frameMjs.frame).setup(checkElapsed, true);
    return function() {
        return (0, _frameMjs.cancelFrame)(checkElapsed);
    };
}
function delayInSeconds(callback, timeout) {
    return delay(callback, (0, _motionUtils.secondsToMilliseconds)(timeout));
}

},{"../frameloop/sync-time.mjs":"aPTZo","motion-utils":"9Q5qC","../frameloop/frame.mjs":"lxQZr","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bDNc5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveMotionValue", function() {
    return resolveMotionValue;
});
var _isMotionValueMjs = require("./is-motion-value.mjs");
/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 */ function resolveMotionValue(value) {
    return (0, _isMotionValueMjs.isMotionValue)(value) ? value.get() : value;
}

},{"./is-motion-value.mjs":"cYNey","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6Rhzb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cleanDirtyNodes", function() {
    return cleanDirtyNodes;
});
parcelHelpers.export(exports, "createProjectionNode", function() {
    return createProjectionNode;
});
parcelHelpers.export(exports, "mixAxis", function() {
    return mixAxis;
});
parcelHelpers.export(exports, "mixAxisDelta", function() {
    return mixAxisDelta;
});
parcelHelpers.export(exports, "mixBox", function() {
    return mixBox;
});
parcelHelpers.export(exports, "propagateDirtyNodes", function() {
    return propagateDirtyNodes;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _motionUtils = require("motion-utils");
var _singleValueMjs = require("../../animation/animate/single-value.mjs");
var _getAppearIdMjs = require("../../animation/optimized-appear/get-appear-id.mjs");
var _getValueTransitionMjs = require("../../animation/utils/get-value-transition.mjs");
var _microtaskMjs = require("../../frameloop/microtask.mjs");
var _syncTimeMjs = require("../../frameloop/sync-time.mjs");
var _scaleCorrectionMjs = require("../styles/scale-correction.mjs");
var _animationCountMjs = require("../../stats/animation-count.mjs");
var _bufferMjs = require("../../stats/buffer.mjs");
var _delayMjs = require("../../utils/delay.mjs");
var _isSvgElementMjs = require("../../utils/is-svg-element.mjs");
var _isSvgSvgElementMjs = require("../../utils/is-svg-svg-element.mjs");
var _numberMjs = require("../../utils/mix/number.mjs");
var _indexMjs = require("../../value/index.mjs");
var _resolveMotionValueMjs = require("../../value/utils/resolve-motion-value.mjs");
var _mixValuesMjs = require("../animation/mix-values.mjs");
var _copyMjs = require("../geometry/copy.mjs");
var _deltaApplyMjs = require("../geometry/delta-apply.mjs");
var _deltaCalcMjs = require("../geometry/delta-calc.mjs");
var _deltaRemoveMjs = require("../geometry/delta-remove.mjs");
var _modelsMjs = require("../geometry/models.mjs");
var _utilsMjs = require("../geometry/utils.mjs");
var _stackMjs = require("../shared/stack.mjs");
var _transformMjs = require("../styles/transform.mjs");
var _eachAxisMjs = require("../utils/each-axis.mjs");
var _flatTreeMjs = require("../utils/flat-tree.mjs");
var _hasTransformMjs = require("../utils/has-transform.mjs");
var _stateMjs = require("./state.mjs");
var _frameMjs = require("../../frameloop/frame.mjs");
var metrics = {
    nodes: 0,
    calculatedTargetDeltas: 0,
    calculatedProjections: 0
};
var transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ var animationTarget = 1000;
var id = 0;
function resetDistortingTransform(key, visualElement, values, sharedAnimationValues) {
    var latestValues = visualElement.latestValues;
    // Record the distorting transform and then temporarily set it to 0
    if (latestValues[key]) {
        values[key] = latestValues[key];
        visualElement.setStaticValue(key, 0);
        if (sharedAnimationValues) sharedAnimationValues[key] = 0;
    }
}
function cancelTreeOptimisedTransformAnimations(projectionNode) {
    projectionNode.hasCheckedOptimisedAppear = true;
    if (projectionNode.root === projectionNode) return;
    var visualElement = projectionNode.options.visualElement;
    if (!visualElement) return;
    var appearId = (0, _getAppearIdMjs.getOptimisedAppearId)(visualElement);
    if (window.MotionHasOptimisedAnimation(appearId, "transform")) {
        var _projectionNode_options = projectionNode.options, layout = _projectionNode_options.layout, layoutId = _projectionNode_options.layoutId;
        window.MotionCancelOptimisedAnimation(appearId, "transform", (0, _frameMjs.frame), !(layout || layoutId));
    }
    var parent = projectionNode.parent;
    if (parent && !parent.hasCheckedOptimisedAppear) cancelTreeOptimisedTransformAnimations(parent);
}
function createProjectionNode(param) {
    var attachResizeListener = param.attachResizeListener, defaultParent = param.defaultParent, measureScroll = param.measureScroll, checkIsScrollRoot = param.checkIsScrollRoot, resetTransform = param.resetTransform;
    return /*#__PURE__*/ function() {
        "use strict";
        function ProjectionNode() {
            var _this = this;
            var latestValues = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, parent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent();
            (0, _classCallCheck._)(this, ProjectionNode);
            /**
             * A unique ID generated for every projection node.
             */ this.id = id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            this.animationCommitId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * Store whether this node has been checked for optimised appear animations. As
             * effects fire bottom-up, and we want to look up the tree for appear animations,
             * this makes sure we only check each path once, stopping at nodes that
             * have already been checked.
             */ this.hasCheckedOptimisedAppear = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            this.layoutVersion = 0;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.scheduleUpdate = function() {
                return _this.update();
            };
            this.projectionUpdateScheduled = false;
            this.checkUpdateFailed = function() {
                if (_this.isUpdating) {
                    _this.isUpdating = false;
                    _this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = function() {
                _this.projectionUpdateScheduled = false;
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ if ((0, _bufferMjs.statsBuffer).value) metrics.nodes = metrics.calculatedTargetDeltas = metrics.calculatedProjections = 0;
                _this.nodes.forEach(propagateDirtyNodes);
                _this.nodes.forEach(resolveTargetDelta);
                _this.nodes.forEach(calcProjection);
                _this.nodes.forEach(cleanDirtyNodes);
                if ((0, _bufferMjs.statsBuffer).addProjectionMetrics) (0, _bufferMjs.statsBuffer).addProjectionMetrics(metrics);
            };
            /**
             * Frame calculations
             */ this.resolvedRelativeTargetAt = 0.0;
            this.linkedParentVersion = 0;
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? (0, _toConsumableArray._)(parent.path).concat([
                parent
            ]) : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for(var i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, _flatTreeMjs.FlatTree)();
        }
        (0, _createClass._)(ProjectionNode, [
            {
                key: "addEventListener",
                value: function addEventListener(name, handler) {
                    if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, _motionUtils.SubscriptionManager)());
                    return this.eventHandlers.get(name).add(handler);
                }
            },
            {
                key: "notifyListeners",
                value: function notifyListeners(name) {
                    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                        args[_key - 1] = arguments[_key];
                    }
                    var _subscriptionManager;
                    var subscriptionManager = this.eventHandlers.get(name);
                    subscriptionManager && (_subscriptionManager = subscriptionManager).notify.apply(_subscriptionManager, (0, _toConsumableArray._)(args));
                }
            },
            {
                key: "hasListeners",
                value: function hasListeners(name) {
                    return this.eventHandlers.has(name);
                }
            },
            {
                /**
         * Lifecycles
         */ key: "mount",
                value: function mount(instance) {
                    var _this = this;
                    if (this.instance) return;
                    this.isSVG = (0, _isSvgElementMjs.isSVGElement)(instance) && !(0, _isSvgSvgElementMjs.isSVGSVGElement)(instance);
                    this.instance = instance;
                    var _this_options = this.options, layoutId = _this_options.layoutId, layout = _this_options.layout, visualElement = _this_options.visualElement;
                    if (visualElement && !visualElement.current) visualElement.mount(instance);
                    this.root.nodes.add(this);
                    this.parent && this.parent.children.add(this);
                    if (this.root.hasTreeAnimated && (layout || layoutId)) this.isLayoutDirty = true;
                    if (attachResizeListener) {
                        var cancelDelay;
                        var innerWidth = 0;
                        var resizeUnblockUpdate = function() {
                            return _this.root.updateBlockedByResize = false;
                        };
                        // Set initial innerWidth in a frame.read callback to batch the read
                        (0, _frameMjs.frame).read(function() {
                            innerWidth = window.innerWidth;
                        });
                        attachResizeListener(instance, function() {
                            var newInnerWidth = window.innerWidth;
                            if (newInnerWidth === innerWidth) return;
                            innerWidth = newInnerWidth;
                            _this.root.updateBlockedByResize = true;
                            cancelDelay && cancelDelay();
                            cancelDelay = (0, _delayMjs.delay)(resizeUnblockUpdate, 250);
                            if ((0, _stateMjs.globalProjectionState).hasAnimatedSinceResize) {
                                (0, _stateMjs.globalProjectionState).hasAnimatedSinceResize = false;
                                _this.nodes.forEach(finishAnimation);
                            }
                        });
                    }
                    if (layoutId) this.root.registerSharedNode(layoutId, this);
                    // Only register the handler if it requires layout animation
                    if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", function(param) {
                        var delta = param.delta, hasLayoutChanged = param.hasLayoutChanged, hasRelativeLayoutChanged = param.hasRelativeLayoutChanged, newLayout = param.layout;
                        if (_this.isTreeAnimationBlocked()) {
                            _this.target = undefined;
                            _this.relativeTarget = undefined;
                            return;
                        }
                        // TODO: Check here if an animation exists
                        var layoutTransition = _this.options.transition || visualElement.getDefaultTransition() || defaultLayoutTransition;
                        var _visualElement_getProps = visualElement.getProps(), onLayoutAnimationStart = _visualElement_getProps.onLayoutAnimationStart, onLayoutAnimationComplete = _visualElement_getProps.onLayoutAnimationComplete;
                        /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ var hasTargetChanged = !_this.targetLayout || !(0, _utilsMjs.boxEqualsRounded)(_this.targetLayout, newLayout);
                        /*
                     * Note: Disabled to fix relative animations always triggering new
                     * layout animations. If this causes further issues, we can try
                     * a different approach to detecting relative target changes.
                     */ // || hasRelativeLayoutChanged
                        /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ var hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeLayoutChanged;
                        if (_this.options.layoutRoot || _this.resumeFrom || hasOnlyRelativeTargetChanged || hasLayoutChanged && (hasTargetChanged || !_this.currentAnimation)) {
                            if (_this.resumeFrom) {
                                _this.resumingFrom = _this.resumeFrom;
                                _this.resumingFrom.resumingFrom = undefined;
                            }
                            var animationOptions = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _getValueTransitionMjs.getValueTransition)(layoutTransition, "layout")), {
                                onPlay: onLayoutAnimationStart,
                                onComplete: onLayoutAnimationComplete
                            });
                            if (visualElement.shouldReduceMotion || _this.options.layoutRoot) {
                                animationOptions.delay = 0;
                                animationOptions.type = false;
                            }
                            _this.startAnimation(animationOptions);
                            /**
                         * Set animation origin after starting animation to avoid layout jump
                         * caused by stopping previous layout animation
                         */ _this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                        } else {
                            /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never committed to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged) finishAnimation(_this);
                            if (_this.isLead() && _this.options.onExitComplete) _this.options.onExitComplete();
                        }
                        _this.targetLayout = newLayout;
                    });
                }
            },
            {
                key: "unmount",
                value: function unmount() {
                    this.options.layoutId && this.willUpdate();
                    this.root.nodes.remove(this);
                    var stack = this.getStack();
                    stack && stack.remove(this);
                    this.parent && this.parent.children.delete(this);
                    this.instance = undefined;
                    this.eventHandlers.clear();
                    (0, _frameMjs.cancelFrame)(this.updateProjection);
                }
            },
            {
                // only on the root
                key: "blockUpdate",
                value: function blockUpdate() {
                    this.updateManuallyBlocked = true;
                }
            },
            {
                key: "unblockUpdate",
                value: function unblockUpdate() {
                    this.updateManuallyBlocked = false;
                }
            },
            {
                key: "isUpdateBlocked",
                value: function isUpdateBlocked() {
                    return this.updateManuallyBlocked || this.updateBlockedByResize;
                }
            },
            {
                key: "isTreeAnimationBlocked",
                value: function isTreeAnimationBlocked() {
                    return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
                }
            },
            {
                // Note: currently only running on root node
                key: "startUpdate",
                value: function startUpdate() {
                    if (this.isUpdateBlocked()) return;
                    this.isUpdating = true;
                    this.nodes && this.nodes.forEach(resetSkewAndRotation);
                    this.animationId++;
                }
            },
            {
                key: "getTransformTemplate",
                value: function getTransformTemplate() {
                    var visualElement = this.options.visualElement;
                    return visualElement && visualElement.getProps().transformTemplate;
                }
            },
            {
                key: "willUpdate",
                value: function willUpdate() {
                    var shouldNotifyListeners = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                    this.root.hasTreeAnimated = true;
                    if (this.root.isUpdateBlocked()) {
                        this.options.onExitComplete && this.options.onExitComplete();
                        return;
                    }
                    /**
             * If we're running optimised appear animations then these must be
             * cancelled before measuring the DOM. This is so we can measure
             * the true layout of the element rather than the WAAPI animation
             * which will be unaffected by the resetSkewAndRotate step.
             *
             * Note: This is a DOM write. Worst case scenario is this is sandwiched
             * between other snapshot reads which will cause unnecessary style recalculations.
             * This has to happen here though, as we don't yet know which nodes will need
             * snapshots in startUpdate(), but we only want to cancel optimised animations
             * if a layout animation measurement is actually going to be affected by them.
             */ if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear) cancelTreeOptimisedTransformAnimations(this);
                    !this.root.isUpdating && this.root.startUpdate();
                    if (this.isLayoutDirty) return;
                    this.isLayoutDirty = true;
                    for(var i = 0; i < this.path.length; i++){
                        var node = this.path[i];
                        node.shouldResetTransform = true;
                        /**
                 * Percentage translates resolve against layoutBox dimensions,
                 * so ancestors with them must be re-measured after transform reset.
                 */ if (typeof node.latestValues.x === "string" || typeof node.latestValues.y === "string") node.isLayoutDirty = true;
                        node.updateScroll("snapshot");
                        if (node.options.layoutRoot) node.willUpdate(false);
                    }
                    var _this_options = this.options, layoutId = _this_options.layoutId, layout = _this_options.layout;
                    if (layoutId === undefined && !layout) return;
                    var transformTemplate = this.getTransformTemplate();
                    this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
                    this.updateSnapshot();
                    shouldNotifyListeners && this.notifyListeners("willUpdate");
                }
            },
            {
                key: "update",
                value: function update() {
                    this.updateScheduled = false;
                    var updateWasBlocked = this.isUpdateBlocked();
                    // When doing an instant transition, we skip the layout update,
                    // but should still clean up the measurements so that the next
                    // snapshot could be taken correctly.
                    if (updateWasBlocked) {
                        var wasBlockedByResize = this.updateBlockedByResize;
                        this.unblockUpdate();
                        this.updateBlockedByResize = false;
                        this.clearAllSnapshots();
                        /**
                 * When blocked by resize, still measure layouts so
                 * callbacks like onLayoutMeasure fire (e.g. Reorder).
                 * Skip notifyLayoutUpdate to prevent animations.
                 */ if (wasBlockedByResize) this.nodes.forEach(forceLayoutMeasure);
                        this.nodes.forEach(clearMeasurements);
                        return;
                    }
                    /**
             * If this is a repeat of didUpdate then ignore the animation.
             */ if (this.animationId <= this.animationCommitId) {
                        this.nodes.forEach(clearIsLayoutDirty);
                        return;
                    }
                    this.animationCommitId = this.animationId;
                    if (!this.isUpdating) this.nodes.forEach(clearIsLayoutDirty);
                    else {
                        this.isUpdating = false;
                        /**
                 * Ensure animation-blocked nodes (e.g. during drag)
                 * get measured even when memoized (willUpdate skipped).
                 */ this.nodes.forEach(ensureDraggedNodesSnapshotted);
                        /**
                 * Write
                 */ this.nodes.forEach(resetTransformStyle);
                        /**
                 * Read ==================
                 */ // Update layout measurements of updated children
                        this.nodes.forEach(updateLayout);
                        /**
                 * Write
                 */ // Notify listeners that the layout is updated
                        this.nodes.forEach(notifyLayoutUpdate);
                    }
                    this.clearAllSnapshots();
                    /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */ var now = (0, _syncTimeMjs.time).now();
                    (0, _frameMjs.frameData).delta = (0, _motionUtils.clamp)(0, 1000 / 60, now - (0, _frameMjs.frameData).timestamp);
                    (0, _frameMjs.frameData).timestamp = now;
                    (0, _frameMjs.frameData).isProcessing = true;
                    (0, _frameMjs.frameSteps).update.process((0, _frameMjs.frameData));
                    (0, _frameMjs.frameSteps).preRender.process((0, _frameMjs.frameData));
                    (0, _frameMjs.frameSteps).render.process((0, _frameMjs.frameData));
                    (0, _frameMjs.frameData).isProcessing = false;
                }
            },
            {
                key: "didUpdate",
                value: function didUpdate() {
                    if (!this.updateScheduled) {
                        this.updateScheduled = true;
                        (0, _microtaskMjs.microtask).read(this.scheduleUpdate);
                    }
                }
            },
            {
                key: "clearAllSnapshots",
                value: function clearAllSnapshots() {
                    this.nodes.forEach(clearSnapshot);
                    this.sharedNodes.forEach(removeLeadSnapshots);
                }
            },
            {
                key: "scheduleUpdateProjection",
                value: function scheduleUpdateProjection() {
                    if (!this.projectionUpdateScheduled) {
                        this.projectionUpdateScheduled = true;
                        (0, _frameMjs.frame).preRender(this.updateProjection, false, true);
                    }
                }
            },
            {
                key: "scheduleCheckAfterUnmount",
                value: function scheduleCheckAfterUnmount() {
                    var _this = this;
                    /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, _frameMjs.frame).postRender(function() {
                        if (_this.isLayoutDirty) _this.root.didUpdate();
                        else _this.root.checkUpdateFailed();
                    });
                }
            },
            {
                /**
         * Update measurements
         */ key: "updateSnapshot",
                value: function updateSnapshot() {
                    if (this.snapshot || !this.instance) return;
                    this.snapshot = this.measure();
                    if (this.snapshot && !(0, _deltaCalcMjs.calcLength)(this.snapshot.measuredBox.x) && !(0, _deltaCalcMjs.calcLength)(this.snapshot.measuredBox.y)) this.snapshot = undefined;
                }
            },
            {
                key: "updateLayout",
                value: function updateLayout() {
                    if (!this.instance) return;
                    this.updateScroll();
                    if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
                    /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(var i = 0; i < this.path.length; i++){
                        var node = this.path[i];
                        node.updateScroll();
                    }
                    var prevLayout = this.layout;
                    this.layout = this.measure(false);
                    this.layoutVersion++;
                    if (!this.layoutCorrected) this.layoutCorrected = (0, _modelsMjs.createBox)();
                    this.isLayoutDirty = false;
                    this.projectionDelta = undefined;
                    this.notifyListeners("measure", this.layout.layoutBox);
                    var visualElement = this.options.visualElement;
                    visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
                }
            },
            {
                key: "updateScroll",
                value: function updateScroll() {
                    var phase = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "measure";
                    var needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
                    if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
                    if (needsMeasurement && this.instance) {
                        var isRoot = checkIsScrollRoot(this.instance);
                        this.scroll = {
                            animationId: this.root.animationId,
                            phase: phase,
                            isRoot: isRoot,
                            offset: measureScroll(this.instance),
                            wasRoot: this.scroll ? this.scroll.isRoot : isRoot
                        };
                    }
                }
            },
            {
                key: "resetTransform",
                value: function resetTransform1() {
                    if (!resetTransform) return;
                    var isResetRequested = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout;
                    var hasProjection = this.projectionDelta && !(0, _utilsMjs.isDeltaZero)(this.projectionDelta);
                    var transformTemplate = this.getTransformTemplate();
                    var transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
                    var transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
                    if (isResetRequested && this.instance && (hasProjection || (0, _hasTransformMjs.hasTransform)(this.latestValues) || transformTemplateHasChanged)) {
                        resetTransform(this.instance, transformTemplateValue);
                        this.shouldResetTransform = false;
                        this.scheduleRender();
                    }
                }
            },
            {
                key: "measure",
                value: function measure() {
                    var removeTransform = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                    var pageBox = this.measurePageBox();
                    var layoutBox = this.removeElementScroll(pageBox);
                    /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
                    roundBox(layoutBox);
                    return {
                        animationId: this.root.animationId,
                        measuredBox: pageBox,
                        layoutBox: layoutBox,
                        latestValues: {},
                        source: this.id
                    };
                }
            },
            {
                key: "measurePageBox",
                value: function measurePageBox() {
                    var _this_scroll;
                    var visualElement = this.options.visualElement;
                    if (!visualElement) return (0, _modelsMjs.createBox)();
                    var box = visualElement.measureViewportBox();
                    var wasInScrollRoot = ((_this_scroll = this.scroll) === null || _this_scroll === void 0 ? void 0 : _this_scroll.wasRoot) || this.path.some(checkNodeWasScrollRoot);
                    if (!wasInScrollRoot) {
                        // Remove viewport scroll to give page-relative coordinates
                        var scroll = this.root.scroll;
                        if (scroll) {
                            (0, _deltaApplyMjs.translateAxis)(box.x, scroll.offset.x);
                            (0, _deltaApplyMjs.translateAxis)(box.y, scroll.offset.y);
                        }
                    }
                    return box;
                }
            },
            {
                key: "removeElementScroll",
                value: function removeElementScroll(box) {
                    var _this_scroll;
                    var boxWithoutScroll = (0, _modelsMjs.createBox)();
                    (0, _copyMjs.copyBoxInto)(boxWithoutScroll, box);
                    if ((_this_scroll = this.scroll) === null || _this_scroll === void 0 ? void 0 : _this_scroll.wasRoot) return boxWithoutScroll;
                    /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(var i = 0; i < this.path.length; i++){
                        var node = this.path[i];
                        var scroll = node.scroll, options = node.options;
                        if (node !== this.root && scroll && options.layoutScroll) {
                            /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.wasRoot) (0, _copyMjs.copyBoxInto)(boxWithoutScroll, box);
                            (0, _deltaApplyMjs.translateAxis)(boxWithoutScroll.x, scroll.offset.x);
                            (0, _deltaApplyMjs.translateAxis)(boxWithoutScroll.y, scroll.offset.y);
                        }
                    }
                    return boxWithoutScroll;
                }
            },
            {
                key: "applyTransform",
                value: function applyTransform(box) {
                    var transformOnly = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, output = arguments.length > 2 ? arguments[2] : void 0;
                    var _this_layout;
                    var withTransforms = output || (0, _modelsMjs.createBox)();
                    (0, _copyMjs.copyBoxInto)(withTransforms, box);
                    for(var i = 0; i < this.path.length; i++){
                        var _node_layout;
                        var node = this.path[i];
                        if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) {
                            (0, _deltaApplyMjs.translateAxis)(withTransforms.x, -node.scroll.offset.x);
                            (0, _deltaApplyMjs.translateAxis)(withTransforms.y, -node.scroll.offset.y);
                        }
                        if (!(0, _hasTransformMjs.hasTransform)(node.latestValues)) continue;
                        (0, _deltaApplyMjs.transformBox)(withTransforms, node.latestValues, (_node_layout = node.layout) === null || _node_layout === void 0 ? void 0 : _node_layout.layoutBox);
                    }
                    if ((0, _hasTransformMjs.hasTransform)(this.latestValues)) (0, _deltaApplyMjs.transformBox)(withTransforms, this.latestValues, (_this_layout = this.layout) === null || _this_layout === void 0 ? void 0 : _this_layout.layoutBox);
                    return withTransforms;
                }
            },
            {
                key: "removeTransform",
                value: function removeTransform(box) {
                    var boxWithoutTransform = (0, _modelsMjs.createBox)();
                    (0, _copyMjs.copyBoxInto)(boxWithoutTransform, box);
                    for(var i = 0; i < this.path.length; i++){
                        var _node_snapshot;
                        var node = this.path[i];
                        if (!(0, _hasTransformMjs.hasTransform)(node.latestValues)) continue;
                        var sourceBox = void 0;
                        if (node.instance) {
                            (0, _hasTransformMjs.hasScale)(node.latestValues) && node.updateSnapshot();
                            sourceBox = (0, _modelsMjs.createBox)();
                            (0, _copyMjs.copyBoxInto)(sourceBox, node.measurePageBox());
                        }
                        (0, _deltaRemoveMjs.removeBoxTransforms)(boxWithoutTransform, node.latestValues, (_node_snapshot = node.snapshot) === null || _node_snapshot === void 0 ? void 0 : _node_snapshot.layoutBox, sourceBox);
                    }
                    if ((0, _hasTransformMjs.hasTransform)(this.latestValues)) (0, _deltaRemoveMjs.removeBoxTransforms)(boxWithoutTransform, this.latestValues);
                    return boxWithoutTransform;
                }
            },
            {
                key: "setTargetDelta",
                value: function setTargetDelta(delta) {
                    this.targetDelta = delta;
                    this.root.scheduleUpdateProjection();
                    this.isProjectionDirty = true;
                }
            },
            {
                key: "setOptions",
                value: function setOptions(options) {
                    this.options = (0, _objectSpreadProps._)((0, _objectSpread._)({}, this.options, options), {
                        crossfade: options.crossfade !== undefined ? options.crossfade : true
                    });
                }
            },
            {
                key: "clearMeasurements",
                value: function clearMeasurements() {
                    this.scroll = undefined;
                    this.layout = undefined;
                    this.snapshot = undefined;
                    this.prevTransformTemplateValue = undefined;
                    this.targetDelta = undefined;
                    this.target = undefined;
                    this.isLayoutDirty = false;
                }
            },
            {
                key: "forceRelativeParentToResolveTarget",
                value: function forceRelativeParentToResolveTarget() {
                    if (!this.relativeParent) return;
                    /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */ if (this.relativeParent.resolvedRelativeTargetAt !== (0, _frameMjs.frameData).timestamp) this.relativeParent.resolveTargetDelta(true);
                }
            },
            {
                key: "resolveTargetDelta",
                value: function resolveTargetDelta() {
                    var forceRecalculation = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                    var _this_parent;
                    /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ var lead = this.getLead();
                    this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
                    this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
                    this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
                    var isShared = Boolean(this.resumingFrom) || this !== lead;
                    /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ var canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || ((_this_parent = this.parent) === null || _this_parent === void 0 ? void 0 : _this_parent.isProjectionDirty) || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize);
                    if (canSkip) return;
                    var _this_options = this.options, layout = _this_options.layout, layoutId = _this_options.layoutId;
                    /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
                    this.resolvedRelativeTargetAt = (0, _frameMjs.frameData).timestamp;
                    var relativeParent = this.getClosestProjectingParent();
                    if (relativeParent && this.linkedParentVersion !== relativeParent.layoutVersion && !relativeParent.options.layoutRoot) this.removeRelativeTarget();
                    /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ if (!this.targetDelta && !this.relativeTarget) {
                        if (this.options.layoutAnchor !== false && relativeParent && relativeParent.layout) this.createRelativeTarget(relativeParent, this.layout.layoutBox, relativeParent.layout.layoutBox);
                        else this.removeRelativeTarget();
                    }
                    /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
                    /**
             * Lazy-init target data structure
             */ if (!this.target) {
                        this.target = (0, _modelsMjs.createBox)();
                        this.targetWithTransforms = (0, _modelsMjs.createBox)();
                    }
                    /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
                        this.forceRelativeParentToResolveTarget();
                        (0, _deltaCalcMjs.calcRelativeBox)(this.target, this.relativeTarget, this.relativeParent.target, this.options.layoutAnchor || undefined);
                    /**
                 * If we've only got a targetDelta, resolve it into a target
                 */ } else if (this.targetDelta) {
                        if (Boolean(this.resumingFrom)) this.applyTransform(this.layout.layoutBox, false, this.target);
                        else (0, _copyMjs.copyBoxInto)(this.target, this.layout.layoutBox);
                        (0, _deltaApplyMjs.applyBoxDelta)(this.target, this.targetDelta);
                    } else /**
                 * If no target, use own layout as target
                 */ (0, _copyMjs.copyBoxInto)(this.target, this.layout.layoutBox);
                    /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                        this.attemptToResolveRelativeTarget = false;
                        if (this.options.layoutAnchor !== false && relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) this.createRelativeTarget(relativeParent, this.target, relativeParent.target);
                        else this.relativeParent = this.relativeTarget = undefined;
                    }
                    /**
             * Increase debug counter for resolved target deltas
             */ if ((0, _bufferMjs.statsBuffer).value) metrics.calculatedTargetDeltas++;
                }
            },
            {
                key: "getClosestProjectingParent",
                value: function getClosestProjectingParent() {
                    if (!this.parent || (0, _hasTransformMjs.hasScale)(this.parent.latestValues) || (0, _hasTransformMjs.has2DTranslate)(this.parent.latestValues)) return undefined;
                    if (this.parent.isProjecting()) return this.parent;
                    else return this.parent.getClosestProjectingParent();
                }
            },
            {
                key: "isProjecting",
                value: function isProjecting() {
                    return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
                }
            },
            {
                key: "createRelativeTarget",
                value: function createRelativeTarget(relativeParent, layout, parentLayout) {
                    this.relativeParent = relativeParent;
                    this.linkedParentVersion = relativeParent.layoutVersion;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, _modelsMjs.createBox)();
                    this.relativeTargetOrigin = (0, _modelsMjs.createBox)();
                    (0, _deltaCalcMjs.calcRelativePosition)(this.relativeTargetOrigin, layout, parentLayout, this.options.layoutAnchor || undefined);
                    (0, _copyMjs.copyBoxInto)(this.relativeTarget, this.relativeTargetOrigin);
                }
            },
            {
                key: "removeRelativeTarget",
                value: function removeRelativeTarget() {
                    this.relativeParent = this.relativeTarget = undefined;
                }
            },
            {
                key: "calcProjection",
                value: function calcProjection() {
                    var _this_parent;
                    var lead = this.getLead();
                    var isShared = Boolean(this.resumingFrom) || this !== lead;
                    var canSkip = true;
                    /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || ((_this_parent = this.parent) === null || _this_parent === void 0 ? void 0 : _this_parent.isProjectionDirty)) canSkip = false;
                    /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
                    /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */ if (this.resolvedRelativeTargetAt === (0, _frameMjs.frameData).timestamp) canSkip = false;
                    if (canSkip) return;
                    var _this_options = this.options, layout = _this_options.layout, layoutId = _this_options.layoutId;
                    /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
                    if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
                    if (!this.layout || !(layout || layoutId)) return;
                    /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, _copyMjs.copyBoxInto)(this.layoutCorrected, this.layout.layoutBox);
                    /**
             * Record previous tree scales before updating.
             */ var prevTreeScaleX = this.treeScale.x;
                    var prevTreeScaleY = this.treeScale.y;
                    /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, _deltaApplyMjs.applyTreeDeltas)(this.layoutCorrected, this.treeScale, this.path, isShared);
                    /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */ if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) {
                        lead.target = lead.layout.layoutBox;
                        lead.targetWithTransforms = (0, _modelsMjs.createBox)();
                    }
                    var target = lead.target;
                    if (!target) {
                        /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */ if (this.prevProjectionDelta) {
                            this.createProjectionDeltas();
                            this.scheduleRender();
                        }
                        return;
                    }
                    if (!this.projectionDelta || !this.prevProjectionDelta) this.createProjectionDeltas();
                    else {
                        (0, _copyMjs.copyAxisDeltaInto)(this.prevProjectionDelta.x, this.projectionDelta.x);
                        (0, _copyMjs.copyAxisDeltaInto)(this.prevProjectionDelta.y, this.projectionDelta.y);
                    }
                    /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, _deltaCalcMjs.calcBoxDelta)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
                    if (this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY || !(0, _utilsMjs.axisDeltaEquals)(this.projectionDelta.x, this.prevProjectionDelta.x) || !(0, _utilsMjs.axisDeltaEquals)(this.projectionDelta.y, this.prevProjectionDelta.y)) {
                        this.hasProjected = true;
                        this.scheduleRender();
                        this.notifyListeners("projectionUpdate", target);
                    }
                    /**
             * Increase debug counter for recalculated projections
             */ if ((0, _bufferMjs.statsBuffer).value) metrics.calculatedProjections++;
                }
            },
            {
                key: "hide",
                value: function hide() {
                    this.isVisible = false;
                // TODO: Schedule render
                }
            },
            {
                key: "show",
                value: function show() {
                    this.isVisible = true;
                // TODO: Schedule render
                }
            },
            {
                key: "scheduleRender",
                value: function scheduleRender() {
                    var notifyAll = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                    var _this_options_visualElement;
                    (_this_options_visualElement = this.options.visualElement) === null || _this_options_visualElement === void 0 ? void 0 : _this_options_visualElement.scheduleRender();
                    if (notifyAll) {
                        var stack = this.getStack();
                        stack && stack.scheduleRender();
                    }
                    if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
                }
            },
            {
                key: "createProjectionDeltas",
                value: function createProjectionDeltas() {
                    this.prevProjectionDelta = (0, _modelsMjs.createDelta)();
                    this.projectionDelta = (0, _modelsMjs.createDelta)();
                    this.projectionDeltaWithTransform = (0, _modelsMjs.createDelta)();
                }
            },
            {
                key: "setAnimationOrigin",
                value: function setAnimationOrigin(delta) {
                    var _this = this;
                    var hasOnlyRelativeTargetChanged = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                    var snapshot = this.snapshot;
                    var snapshotLatestValues = snapshot ? snapshot.latestValues : {};
                    var mixedValues = (0, _objectSpread._)({}, this.latestValues);
                    var targetDelta = (0, _modelsMjs.createDelta)();
                    if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
                    this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
                    var relativeLayout = (0, _modelsMjs.createBox)();
                    var snapshotSource = snapshot ? snapshot.source : undefined;
                    var layoutSource = this.layout ? this.layout.source : undefined;
                    var isSharedLayoutAnimation = snapshotSource !== layoutSource;
                    var stack = this.getStack();
                    var isOnlyMember = !stack || stack.members.length <= 1;
                    var shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some(hasOpacityCrossfade));
                    this.animationProgress = 0;
                    var prevRelativeTarget;
                    this.mixTargetDelta = function(latest) {
                        var progress = latest / 1000;
                        mixAxisDelta(targetDelta.x, delta.x, progress);
                        mixAxisDelta(targetDelta.y, delta.y, progress);
                        _this.setTargetDelta(targetDelta);
                        if (_this.relativeTarget && _this.relativeTargetOrigin && _this.layout && _this.relativeParent && _this.relativeParent.layout) {
                            (0, _deltaCalcMjs.calcRelativePosition)(relativeLayout, _this.layout.layoutBox, _this.relativeParent.layout.layoutBox, _this.options.layoutAnchor || undefined);
                            mixBox(_this.relativeTarget, _this.relativeTargetOrigin, relativeLayout, progress);
                            /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, _utilsMjs.boxEquals)(_this.relativeTarget, prevRelativeTarget)) _this.isProjectionDirty = false;
                            if (!prevRelativeTarget) prevRelativeTarget = (0, _modelsMjs.createBox)();
                            (0, _copyMjs.copyBoxInto)(prevRelativeTarget, _this.relativeTarget);
                        }
                        if (isSharedLayoutAnimation) {
                            _this.animationValues = mixedValues;
                            (0, _mixValuesMjs.mixValues)(mixedValues, snapshotLatestValues, _this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                        }
                        _this.root.scheduleUpdateProjection();
                        _this.scheduleRender();
                        _this.animationProgress = progress;
                    };
                    this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
                }
            },
            {
                key: "startAnimation",
                value: function startAnimation(options) {
                    var _this = this;
                    var _this_currentAnimation, _this_resumingFrom_currentAnimation, _this_resumingFrom;
                    this.notifyListeners("animationStart");
                    (_this_currentAnimation = this.currentAnimation) === null || _this_currentAnimation === void 0 ? void 0 : _this_currentAnimation.stop();
                    (_this_resumingFrom = this.resumingFrom) === null || _this_resumingFrom === void 0 ? void 0 : (_this_resumingFrom_currentAnimation = _this_resumingFrom.currentAnimation) === null || _this_resumingFrom_currentAnimation === void 0 ? void 0 : _this_resumingFrom_currentAnimation.stop();
                    if (this.pendingAnimation) {
                        (0, _frameMjs.cancelFrame)(this.pendingAnimation);
                        this.pendingAnimation = undefined;
                    }
                    /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, _frameMjs.frame).update(function() {
                        (0, _stateMjs.globalProjectionState).hasAnimatedSinceResize = true;
                        (0, _animationCountMjs.activeAnimations).layout++;
                        _this.motionValue || (_this.motionValue = (0, _indexMjs.motionValue)(0));
                        _this.motionValue.jump(0, false);
                        _this.currentAnimation = (0, _singleValueMjs.animateSingleValue)(_this.motionValue, [
                            0,
                            1000
                        ], (0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
                            velocity: 0,
                            isSync: true,
                            onUpdate: function(latest) {
                                _this.mixTargetDelta(latest);
                                options.onUpdate && options.onUpdate(latest);
                            },
                            onStop: function() {
                                (0, _animationCountMjs.activeAnimations).layout--;
                            },
                            onComplete: function() {
                                (0, _animationCountMjs.activeAnimations).layout--;
                                options.onComplete && options.onComplete();
                                _this.completeAnimation();
                            }
                        }));
                        if (_this.resumingFrom) _this.resumingFrom.currentAnimation = _this.currentAnimation;
                        _this.pendingAnimation = undefined;
                    });
                }
            },
            {
                key: "completeAnimation",
                value: function completeAnimation() {
                    if (this.resumingFrom) {
                        this.resumingFrom.currentAnimation = undefined;
                        this.resumingFrom.preserveOpacity = undefined;
                    }
                    var stack = this.getStack();
                    stack && stack.exitAnimationComplete();
                    this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
                    this.notifyListeners("animationComplete");
                }
            },
            {
                key: "finishAnimation",
                value: function finishAnimation() {
                    if (this.currentAnimation) {
                        this.mixTargetDelta && this.mixTargetDelta(animationTarget);
                        this.currentAnimation.stop();
                    }
                    this.completeAnimation();
                }
            },
            {
                key: "applyTransformsToTarget",
                value: function applyTransformsToTarget() {
                    var lead = this.getLead();
                    var targetWithTransforms = lead.targetWithTransforms, target = lead.target, layout = lead.layout, latestValues = lead.latestValues;
                    if (!targetWithTransforms || !target || !layout) return;
                    /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                        target = this.target || (0, _modelsMjs.createBox)();
                        var xLength = (0, _deltaCalcMjs.calcLength)(this.layout.layoutBox.x);
                        target.x.min = lead.target.x.min;
                        target.x.max = target.x.min + xLength;
                        var yLength = (0, _deltaCalcMjs.calcLength)(this.layout.layoutBox.y);
                        target.y.min = lead.target.y.min;
                        target.y.max = target.y.min + yLength;
                    }
                    (0, _copyMjs.copyBoxInto)(targetWithTransforms, target);
                    /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, _deltaApplyMjs.transformBox)(targetWithTransforms, latestValues);
                    /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, _deltaCalcMjs.calcBoxDelta)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
                }
            },
            {
                key: "registerSharedNode",
                value: function registerSharedNode(layoutId, node) {
                    if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, _stackMjs.NodeStack)());
                    var stack = this.sharedNodes.get(layoutId);
                    stack.add(node);
                    var config = node.options.initialPromotionConfig;
                    node.promote({
                        transition: config ? config.transition : undefined,
                        preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
                    });
                }
            },
            {
                key: "isLead",
                value: function isLead() {
                    var stack = this.getStack();
                    return stack ? stack.lead === this : true;
                }
            },
            {
                key: "getLead",
                value: function getLead() {
                    var _this_getStack;
                    var layoutId = this.options.layoutId;
                    return layoutId ? ((_this_getStack = this.getStack()) === null || _this_getStack === void 0 ? void 0 : _this_getStack.lead) || this : this;
                }
            },
            {
                key: "getPrevLead",
                value: function getPrevLead() {
                    var _this_getStack;
                    var layoutId = this.options.layoutId;
                    return layoutId ? (_this_getStack = this.getStack()) === null || _this_getStack === void 0 ? void 0 : _this_getStack.prevLead : undefined;
                }
            },
            {
                key: "getStack",
                value: function getStack() {
                    var layoutId = this.options.layoutId;
                    if (layoutId) return this.root.sharedNodes.get(layoutId);
                }
            },
            {
                key: "promote",
                value: function promote() {
                    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, needsReset = _ref.needsReset, transition = _ref.transition, preserveFollowOpacity = _ref.preserveFollowOpacity;
                    var stack = this.getStack();
                    if (stack) stack.promote(this, preserveFollowOpacity);
                    if (needsReset) {
                        this.projectionDelta = undefined;
                        this.needsReset = true;
                    }
                    if (transition) this.setOptions({
                        transition: transition
                    });
                }
            },
            {
                key: "relegate",
                value: function relegate() {
                    var stack = this.getStack();
                    if (stack) return stack.relegate(this);
                    else return false;
                }
            },
            {
                key: "resetSkewAndRotation",
                value: function resetSkewAndRotation() {
                    var visualElement = this.options.visualElement;
                    if (!visualElement) return;
                    // If there's no detected skew or rotation values, we can early return without a forced render.
                    var hasDistortingTransform = false;
                    /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ var latestValues = visualElement.latestValues;
                    if (latestValues.z || latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ || latestValues.skewX || latestValues.skewY) hasDistortingTransform = true;
                    // If there's no distorting values, we don't need to do any more.
                    if (!hasDistortingTransform) return;
                    var resetValues = {};
                    if (latestValues.z) resetDistortingTransform("z", visualElement, resetValues, this.animationValues);
                    // Check the skew and rotate value of all axes and reset to 0
                    for(var i = 0; i < transformAxes.length; i++){
                        resetDistortingTransform("rotate".concat(transformAxes[i]), visualElement, resetValues, this.animationValues);
                        resetDistortingTransform("skew".concat(transformAxes[i]), visualElement, resetValues, this.animationValues);
                    }
                    // Force a render of this element to apply the transform with all skews and rotations
                    // set to 0.
                    visualElement.render();
                    // Put back all the values we reset
                    for(var key in resetValues){
                        visualElement.setStaticValue(key, resetValues[key]);
                        if (this.animationValues) this.animationValues[key] = resetValues[key];
                    }
                    // Schedule a render for the next frame. This ensures we won't visually
                    // see the element with the reset rotate value applied.
                    visualElement.scheduleRender();
                }
            },
            {
                key: "applyProjectionStyles",
                value: function applyProjectionStyles(targetStyle, styleProp) {
                    if (!this.instance || this.isSVG) return;
                    if (!this.isVisible) {
                        targetStyle.visibility = "hidden";
                        return;
                    }
                    var transformTemplate = this.getTransformTemplate();
                    if (this.needsReset) {
                        this.needsReset = false;
                        targetStyle.visibility = "";
                        targetStyle.opacity = "";
                        targetStyle.pointerEvents = (0, _resolveMotionValueMjs.resolveMotionValue)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                        targetStyle.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                        return;
                    }
                    var lead = this.getLead();
                    if (!this.projectionDelta || !this.layout || !lead.target) {
                        if (this.options.layoutId) {
                            targetStyle.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                            targetStyle.pointerEvents = (0, _resolveMotionValueMjs.resolveMotionValue)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                        }
                        if (this.hasProjected && !(0, _hasTransformMjs.hasTransform)(this.latestValues)) {
                            targetStyle.transform = transformTemplate ? transformTemplate({}, "") : "none";
                            this.hasProjected = false;
                        }
                        return;
                    }
                    targetStyle.visibility = "";
                    var valuesToRender = lead.animationValues || lead.latestValues;
                    this.applyTransformsToTarget();
                    var transform = (0, _transformMjs.buildProjectionTransform)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
                    if (transformTemplate) transform = transformTemplate(valuesToRender, transform);
                    targetStyle.transform = transform;
                    var _this_projectionDelta = this.projectionDelta, x = _this_projectionDelta.x, y = _this_projectionDelta.y;
                    targetStyle.transformOrigin = "".concat(x.origin * 100, "% ").concat(y.origin * 100, "% 0");
                    var _valuesToRender_opacity, _ref;
                    if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ targetStyle.opacity = lead === this ? (_ref = (_valuesToRender_opacity = valuesToRender.opacity) !== null && _valuesToRender_opacity !== void 0 ? _valuesToRender_opacity : this.latestValues.opacity) !== null && _ref !== void 0 ? _ref : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
                    else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ targetStyle.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
                    /**
             * Apply scale correction
             */ for(var key in 0, _scaleCorrectionMjs.scaleCorrectors){
                        if (valuesToRender[key] === undefined) continue;
                        var _scaleCorrectors_key = (0, _scaleCorrectionMjs.scaleCorrectors)[key], correct = _scaleCorrectors_key.correct, applyTo = _scaleCorrectors_key.applyTo, isCSSVariable = _scaleCorrectors_key.isCSSVariable;
                        /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ var corrected = transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                        if (applyTo) {
                            var num = applyTo.length;
                            for(var i = 0; i < num; i++)targetStyle[applyTo[i]] = corrected;
                        } else // If this is a CSS variable, set it directly on the instance.
                        // Replacing this function from creating styles to setting them
                        // would be a good place to remove per frame object creation
                        if (isCSSVariable) this.options.visualElement.renderState.vars[key] = corrected;
                        else targetStyle[key] = corrected;
                    }
                    /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) targetStyle.pointerEvents = lead === this ? (0, _resolveMotionValueMjs.resolveMotionValue)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "" : "none";
                }
            },
            {
                key: "clearSnapshot",
                value: function clearSnapshot() {
                    this.resumeFrom = this.snapshot = undefined;
                }
            },
            {
                // Only run on root
                key: "resetTree",
                value: function resetTree() {
                    this.root.nodes.forEach(function(node) {
                        var _node_currentAnimation;
                        return (_node_currentAnimation = node.currentAnimation) === null || _node_currentAnimation === void 0 ? void 0 : _node_currentAnimation.stop();
                    });
                    this.root.nodes.forEach(clearMeasurements);
                    this.root.sharedNodes.clear();
                }
            }
        ]);
        return ProjectionNode;
    }();
}
function updateLayout(node) {
    node.updateLayout();
}
function notifyLayoutUpdate(node) {
    var _node_resumeFrom;
    var snapshot = ((_node_resumeFrom = node.resumeFrom) === null || _node_resumeFrom === void 0 ? void 0 : _node_resumeFrom.snapshot) || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        var _node_layout = node.layout, layout = _node_layout.layoutBox, measuredLayout = _node_layout.measuredBox;
        var animationType = node.options.animationType;
        var isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, _eachAxisMjs.eachAxis)(function(axis) {
            var axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            var length = (0, _deltaCalcMjs.calcLength)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if (animationType === "x" || animationType === "y") {
            var snapAxis = animationType === "x" ? "y" : "x";
            (0, _copyMjs.copyAxisInto)(isShared ? snapshot.measuredBox[snapAxis] : snapshot.layoutBox[snapAxis], layout[snapAxis]);
        } else if (shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, _eachAxisMjs.eachAxis)(function(axis) {
            var axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            var length = (0, _deltaCalcMjs.calcLength)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
            /**
                 * Ensure relative target gets resized and rerendererd
                 */ if (node.relativeTarget && !node.currentAnimation) {
                node.isProjectionDirty = true;
                node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
            }
        });
        var layoutDelta = (0, _modelsMjs.createDelta)();
        (0, _deltaCalcMjs.calcBoxDelta)(layoutDelta, layout, snapshot.layoutBox);
        var visualDelta = (0, _modelsMjs.createDelta)();
        if (isShared) (0, _deltaCalcMjs.calcBoxDelta)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, _deltaCalcMjs.calcBoxDelta)(visualDelta, layout, snapshot.layoutBox);
        var hasLayoutChanged = !(0, _utilsMjs.isDeltaZero)(layoutDelta);
        var hasRelativeLayoutChanged = false;
        if (!node.resumeFrom) {
            var relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                var parentSnapshot = relativeParent.snapshot, parentLayout = relativeParent.layout;
                if (parentSnapshot && parentLayout) {
                    var anchor = node.options.layoutAnchor || undefined;
                    var relativeSnapshot = (0, _modelsMjs.createBox)();
                    (0, _deltaCalcMjs.calcRelativePosition)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox, anchor);
                    var relativeLayout = (0, _modelsMjs.createBox)();
                    (0, _deltaCalcMjs.calcRelativePosition)(relativeLayout, layout, parentLayout.layoutBox, anchor);
                    if (!(0, _utilsMjs.boxEqualsRounded)(relativeSnapshot, relativeLayout)) hasRelativeLayoutChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeLayoutChanged: hasRelativeLayoutChanged
        });
    } else if (node.isLead()) {
        var onExitComplete = node.options.onExitComplete;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function propagateDirtyNodes(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ if ((0, _bufferMjs.statsBuffer).value) metrics.nodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function cleanDirtyNodes(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function clearSnapshot(node) {
    node.clearSnapshot();
}
function clearMeasurements(node) {
    node.clearMeasurements();
}
function forceLayoutMeasure(node) {
    node.isLayoutDirty = true;
    node.updateLayout();
}
function clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
/**
 * When a node is animation-blocked (e.g. during drag) and its component
 * didn't re-render (memoized), willUpdate() is never called so there's
 * no snapshot. Use the previous layout as a snapshot and mark dirty so
 * resetTransform/updateLayout/notifyLayoutUpdate process it normally.
 */ function ensureDraggedNodesSnapshotted(node) {
    if (node.isAnimationBlocked && node.layout && !node.isLayoutDirty) {
        node.snapshot = node.layout;
        node.isLayoutDirty = true;
    }
}
function resetTransformStyle(node) {
    var visualElement = node.options.visualElement;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function calcProjection(node) {
    node.calcProjection();
}
function resetSkewAndRotation(node) {
    node.resetSkewAndRotation();
}
function removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function mixAxisDelta(output, delta, p) {
    output.translate = (0, _numberMjs.mixNumber)(delta.translate, 0, p);
    output.scale = (0, _numberMjs.mixNumber)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function mixAxis(output, from, to, p) {
    output.min = (0, _numberMjs.mixNumber)(from.min, to.min, p);
    output.max = (0, _numberMjs.mixNumber)(from.max, to.max, p);
}
function mixBox(output, from, to, p) {
    mixAxis(output.x, from.x, to.x, p);
    mixAxis(output.y, from.y, to.y, p);
}
function hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
var defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
var userAgentContains = function(string) {
    return typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(string);
};
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */ var roundPoint = userAgentContains("applewebkit/") && !userAgentContains("chrome/") ? Math.round : (0, _motionUtils.noop);
function roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = roundPoint(axis.min);
    axis.max = roundPoint(axis.max);
}
function roundBox(box) {
    roundAxis(box.x);
    roundAxis(box.y);
}
function shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, _deltaCalcMjs.isNear)((0, _utilsMjs.aspectRatio)(snapshot), (0, _utilsMjs.aspectRatio)(layout), 0.2);
}
function checkNodeWasScrollRoot(node) {
    var _node_scroll;
    return node !== node.root && ((_node_scroll = node.scroll) === null || _node_scroll === void 0 ? void 0 : _node_scroll.wasRoot);
}

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_to_consumable_array":"1eSZf","motion-utils":"9Q5qC","../../animation/animate/single-value.mjs":"cbr0l","../../animation/optimized-appear/get-appear-id.mjs":"1uuWd","../../animation/utils/get-value-transition.mjs":"dkYvz","../../frameloop/microtask.mjs":"icPpP","../../frameloop/sync-time.mjs":"aPTZo","../styles/scale-correction.mjs":"cExFS","../../stats/animation-count.mjs":"gY9Wc","../../stats/buffer.mjs":"bcR1L","../../utils/delay.mjs":"5W0bS","../../utils/is-svg-element.mjs":"3tMgU","../../utils/is-svg-svg-element.mjs":"o8RpJ","../../utils/mix/number.mjs":"j0eyN","../../value/index.mjs":"lOANY","../../value/utils/resolve-motion-value.mjs":"bDNc5","../animation/mix-values.mjs":"jHs2u","../geometry/copy.mjs":"c2JNt","../geometry/delta-apply.mjs":"ltFfy","../geometry/delta-calc.mjs":"gXjVB","../geometry/delta-remove.mjs":"j7Gx5","../geometry/models.mjs":"i3okE","../geometry/utils.mjs":"aQEwH","../shared/stack.mjs":"ioujo","../styles/transform.mjs":"4GQSO","../utils/each-axis.mjs":"lkSyh","../utils/flat-tree.mjs":"isDUr","../utils/has-transform.mjs":"bAGvf","./state.mjs":"2xFYt","../../frameloop/frame.mjs":"lxQZr","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ioujo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NodeStack", function() {
    return NodeStack;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _motionUtils = require("motion-utils");
var NodeStack = /*#__PURE__*/ function() {
    "use strict";
    function NodeStack() {
        (0, _classCallCheck._)(this, NodeStack);
        this.members = [];
    }
    (0, _createClass._)(NodeStack, [
        {
            key: "add",
            value: function add(node) {
                (0, _motionUtils.addUniqueItem)(this.members, node);
                for(var i = this.members.length - 1; i >= 0; i--){
                    var member = this.members[i];
                    if (member === node || member === this.lead || member === this.prevLead) continue;
                    var inst = member.instance;
                    if ((!inst || inst.isConnected === false) && !member.snapshot) {
                        (0, _motionUtils.removeItem)(this.members, member);
                        member.unmount();
                    }
                }
                node.scheduleRender();
            }
        },
        {
            key: "remove",
            value: function remove(node) {
                (0, _motionUtils.removeItem)(this.members, node);
                if (node === this.prevLead) this.prevLead = undefined;
                if (node === this.lead) {
                    var prevLead = this.members[this.members.length - 1];
                    if (prevLead) this.promote(prevLead);
                }
            }
        },
        {
            key: "relegate",
            value: function relegate(node) {
                for(var i = this.members.indexOf(node) - 1; i >= 0; i--){
                    var _member_instance;
                    var member = this.members[i];
                    if (member.isPresent !== false && ((_member_instance = member.instance) === null || _member_instance === void 0 ? void 0 : _member_instance.isConnected) !== false) {
                        this.promote(member);
                        return true;
                    }
                }
                return false;
            }
        },
        {
            key: "promote",
            value: function promote(node, preserveFollowOpacity) {
                var prevLead = this.lead;
                if (node === prevLead) return;
                this.prevLead = prevLead;
                this.lead = node;
                node.show();
                if (prevLead) {
                    prevLead.updateSnapshot();
                    node.scheduleRender();
                    var _prevLead_options = prevLead.options, prevDep = _prevLead_options.layoutDependency;
                    var _node_options = node.options, nextDep = _node_options.layoutDependency;
                    if (prevDep === undefined || prevDep !== nextDep) {
                        var _node_root;
                        node.resumeFrom = prevLead;
                        if (preserveFollowOpacity) prevLead.preserveOpacity = true;
                        if (prevLead.snapshot) {
                            node.snapshot = prevLead.snapshot;
                            node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
                        }
                        if ((_node_root = node.root) === null || _node_root === void 0 ? void 0 : _node_root.isUpdating) node.isLayoutDirty = true;
                    }
                    if (node.options.crossfade === false) prevLead.hide();
                }
            }
        },
        {
            key: "exitAnimationComplete",
            value: function exitAnimationComplete() {
                this.members.forEach(function(member) {
                    var _member_options_onExitComplete, _member_options, _member_resumingFrom_options_onExitComplete, _member_resumingFrom, _member_resumingFrom_options;
                    (_member_options_onExitComplete = (_member_options = member.options).onExitComplete) === null || _member_options_onExitComplete === void 0 ? void 0 : _member_options_onExitComplete.call(_member_options);
                    (_member_resumingFrom = member.resumingFrom) === null || _member_resumingFrom === void 0 ? void 0 : (_member_resumingFrom_options_onExitComplete = (_member_resumingFrom_options = _member_resumingFrom.options).onExitComplete) === null || _member_resumingFrom_options_onExitComplete === void 0 ? void 0 : _member_resumingFrom_options_onExitComplete.call(_member_resumingFrom_options);
                });
            }
        },
        {
            key: "scheduleRender",
            value: function scheduleRender() {
                this.members.forEach(function(member) {
                    return member.instance && member.scheduleRender(false);
                });
            }
        },
        {
            key: "removeLeadSnapshot",
            value: function removeLeadSnapshot() {
                var _this_lead;
                if ((_this_lead = this.lead) === null || _this_lead === void 0 ? void 0 : _this_lead.snapshot) this.lead.snapshot = undefined;
            }
        }
    ]);
    return NodeStack;
}();

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","motion-utils":"9Q5qC","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2xFYt":[function(require,module,exports,__globalThis) {
/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "globalProjectionState", function() {
    return globalProjectionState;
});
var globalProjectionState = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7sk16":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DocumentProjectionNode", function() {
    return DocumentProjectionNode;
});
var _addDomEventMjs = require("../../events/add-dom-event.mjs");
var _createProjectionNodeMjs = require("./create-projection-node.mjs");
var DocumentProjectionNode = (0, _createProjectionNodeMjs.createProjectionNode)({
    attachResizeListener: function(ref, notify) {
        return (0, _addDomEventMjs.addDomEvent)(ref, "resize", notify);
    },
    measureScroll: function() {
        var _document_body, _document_body1;
        return {
            x: document.documentElement.scrollLeft || ((_document_body = document.body) === null || _document_body === void 0 ? void 0 : _document_body.scrollLeft) || 0,
            y: document.documentElement.scrollTop || ((_document_body1 = document.body) === null || _document_body1 === void 0 ? void 0 : _document_body1.scrollTop) || 0
        };
    },
    checkIsScrollRoot: function() {
        return true;
    }
});

},{"../../events/add-dom-event.mjs":"iFSgF","./create-projection-node.mjs":"6Rhzb","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3KEqV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nodeGroup", function() {
    return nodeGroup;
});
var notify = function(node) {
    return !node.isLayoutDirty && node.willUpdate(false);
};
function nodeGroup() {
    var nodes = new Set();
    var subscriptions = new WeakMap();
    var dirtyAll = function() {
        return nodes.forEach(notify);
    };
    return {
        add: function(node) {
            nodes.add(node);
            subscriptions.set(node, node.addEventListener("willUpdate", dirtyAll));
        },
        remove: function(node) {
            nodes.delete(node);
            var unsubscribe = subscriptions.get(node);
            if (unsubscribe) {
                unsubscribe();
                subscriptions.delete(node);
            }
            dirtyAll();
        },
        dirty: dirtyAll
    };
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6kyDQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HTMLProjectionNode", function() {
    return HTMLProjectionNode;
});
parcelHelpers.export(exports, "rootProjectionNode", function() {
    return rootProjectionNode;
});
var _createProjectionNodeMjs = require("./create-projection-node.mjs");
var _documentProjectionNodeMjs = require("./DocumentProjectionNode.mjs");
var rootProjectionNode = {
    current: undefined
};
var HTMLProjectionNode = (0, _createProjectionNodeMjs.createProjectionNode)({
    measureScroll: function(instance) {
        return {
            x: instance.scrollLeft,
            y: instance.scrollTop
        };
    },
    defaultParent: function() {
        if (!rootProjectionNode.current) {
            var documentNode = new (0, _documentProjectionNodeMjs.DocumentProjectionNode)({});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            rootProjectionNode.current = documentNode;
        }
        return rootProjectionNode.current;
    },
    resetTransform: function(instance, value) {
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: function(instance) {
        return Boolean(window.getComputedStyle(instance).position === "fixed");
    }
});

},{"./create-projection-node.mjs":"6Rhzb","./DocumentProjectionNode.mjs":"7sk16","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eSDFV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LayoutAnimationBuilder", function() {
    return LayoutAnimationBuilder;
});
parcelHelpers.export(exports, "parseAnimateLayoutArgs", function() {
    return parseAnimateLayoutArgs;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _groupAnimationMjs = require("../animation/GroupAnimation.mjs");
var _copyMjs = require("../projection/geometry/copy.mjs");
var _modelsMjs = require("../projection/geometry/models.mjs");
var _htmlprojectionNodeMjs = require("../projection/node/HTMLProjectionNode.mjs");
var _htmlvisualElementMjs = require("../render/html/HTMLVisualElement.mjs");
var _storeMjs = require("../render/store.mjs");
var _resolveElementsMjs = require("../utils/resolve-elements.mjs");
var _frameMjs = require("../frameloop/frame.mjs");
var layoutSelector = "[data-layout], [data-layout-id]";
var noop = function() {};
function snapshotFromTarget(projection) {
    var _projection_root;
    var target = projection.targetWithTransforms || projection.target;
    if (!target) return undefined;
    var measuredBox = (0, _modelsMjs.createBox)();
    var layoutBox = (0, _modelsMjs.createBox)();
    (0, _copyMjs.copyBoxInto)(measuredBox, target);
    (0, _copyMjs.copyBoxInto)(layoutBox, target);
    var _projection_root_animationId;
    return {
        animationId: (_projection_root_animationId = (_projection_root = projection.root) === null || _projection_root === void 0 ? void 0 : _projection_root.animationId) !== null && _projection_root_animationId !== void 0 ? _projection_root_animationId : 0,
        measuredBox: measuredBox,
        layoutBox: layoutBox,
        latestValues: projection.animationValues || projection.latestValues || {},
        source: projection.id
    };
}
var LayoutAnimationBuilder = /*#__PURE__*/ function() {
    "use strict";
    function LayoutAnimationBuilder(scope, updateDom, defaultOptions) {
        var _this = this;
        (0, _classCallCheck._)(this, LayoutAnimationBuilder);
        this.sharedTransitions = new Map();
        this.notifyReady = noop;
        this.rejectReady = noop;
        this.scope = scope;
        this.updateDom = updateDom;
        this.defaultOptions = defaultOptions;
        this.readyPromise = new Promise(function(resolve, reject) {
            _this.notifyReady = resolve;
            _this.rejectReady = reject;
        });
        (0, _frameMjs.frame).postRender(function() {
            _this.start().then(_this.notifyReady).catch(_this.rejectReady);
        });
    }
    (0, _createClass._)(LayoutAnimationBuilder, [
        {
            key: "shared",
            value: function shared(id, transition) {
                this.sharedTransitions.set(id, transition);
                return this;
            }
        },
        {
            key: "then",
            value: function then(resolve, reject) {
                return this.readyPromise.then(resolve, reject);
            }
        },
        {
            key: "start",
            value: function start() {
                return (0, _asyncToGenerator._)(function() {
                    var beforeElements, beforeRecords, afterElements, afterRecords, root, animations, animation;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                beforeElements = collectLayoutElements(this.scope);
                                beforeRecords = this.buildRecords(beforeElements);
                                beforeRecords.forEach(function(param) {
                                    var projection = param.projection;
                                    var hasCurrentAnimation = Boolean(projection.currentAnimation);
                                    var isSharedLayout = Boolean(projection.options.layoutId);
                                    if (hasCurrentAnimation && isSharedLayout) {
                                        var snapshot = snapshotFromTarget(projection);
                                        if (snapshot) projection.snapshot = snapshot;
                                        else if (projection.snapshot) projection.snapshot = undefined;
                                    } else if (projection.snapshot && (projection.currentAnimation || projection.isProjecting())) projection.snapshot = undefined;
                                    projection.isPresent = true;
                                    projection.willUpdate();
                                });
                                return [
                                    4,
                                    this.updateDom()
                                ];
                            case 1:
                                _state.sent();
                                afterElements = collectLayoutElements(this.scope);
                                afterRecords = this.buildRecords(afterElements);
                                this.handleExitingElements(beforeRecords, afterRecords);
                                afterRecords.forEach(function(param) {
                                    var projection = param.projection;
                                    var _projection_resumeFrom;
                                    var instance = projection.instance;
                                    var resumeFromInstance = (_projection_resumeFrom = projection.resumeFrom) === null || _projection_resumeFrom === void 0 ? void 0 : _projection_resumeFrom.instance;
                                    if (!instance || !resumeFromInstance) return;
                                    if (!("style" in instance)) return;
                                    var currentTransform = instance.style.transform;
                                    var resumeFromTransform = resumeFromInstance.style.transform;
                                    if (currentTransform && resumeFromTransform && currentTransform === resumeFromTransform) {
                                        instance.style.transform = "";
                                        instance.style.transformOrigin = "";
                                    }
                                });
                                afterRecords.forEach(function(param) {
                                    var projection = param.projection;
                                    projection.isPresent = true;
                                });
                                root = getProjectionRoot(afterRecords, beforeRecords);
                                root === null || root === void 0 ? void 0 : root.didUpdate();
                                return [
                                    4,
                                    new Promise(function(resolve) {
                                        (0, _frameMjs.frame).postRender(function() {
                                            return resolve();
                                        });
                                    })
                                ];
                            case 2:
                                _state.sent();
                                animations = collectAnimations(afterRecords);
                                animation = new (0, _groupAnimationMjs.GroupAnimation)(animations);
                                return [
                                    2,
                                    animation
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "buildRecords",
            value: function buildRecords(elements) {
                var records = [];
                var recordMap = new Map();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        var parentRecord = findParentRecord(element, recordMap, this.scope);
                        var _readLayoutAttributes = readLayoutAttributes(element), layout = _readLayoutAttributes.layout, layoutId = _readLayoutAttributes.layoutId;
                        var override = layoutId ? this.sharedTransitions.get(layoutId) : undefined;
                        var transition = override || this.defaultOptions;
                        var record = getOrCreateRecord(element, parentRecord === null || parentRecord === void 0 ? void 0 : parentRecord.projection, {
                            layout: layout,
                            layoutId: layoutId,
                            animationType: typeof layout === "string" ? layout : "both",
                            transition: transition
                        });
                        recordMap.set(element, record);
                        records.push(record);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return records;
            }
        },
        {
            key: "handleExitingElements",
            value: function handleExitingElements(beforeRecords, afterRecords) {
                var afterElementsSet = new Set(afterRecords.map(function(record) {
                    return record.element;
                }));
                beforeRecords.forEach(function(record) {
                    if (afterElementsSet.has(record.element)) return;
                    // For shared layout elements, relegate to set up resumeFrom
                    // so the remaining element animates from this position
                    if (record.projection.options.layoutId) {
                        record.projection.isPresent = false;
                        record.projection.relegate();
                    }
                    record.visualElement.unmount();
                    (0, _storeMjs.visualElementStore).delete(record.element);
                });
                // Clear resumeFrom on EXISTING nodes that point to unmounted projections
                // This prevents crossfade animation when the source element was removed entirely
                // But preserve resumeFrom for NEW nodes so they can animate from the old position
                // Also preserve resumeFrom for lead nodes that were just promoted via relegate
                var beforeElementsSet = new Set(beforeRecords.map(function(record) {
                    return record.element;
                }));
                afterRecords.forEach(function(param) {
                    var element = param.element, projection = param.projection;
                    if (beforeElementsSet.has(element) && projection.resumeFrom && !projection.resumeFrom.instance && !projection.isLead()) {
                        projection.resumeFrom = undefined;
                        projection.snapshot = undefined;
                    }
                });
            }
        }
    ]);
    return LayoutAnimationBuilder;
}();
function parseAnimateLayoutArgs(scopeOrUpdateDom, updateDomOrOptions, options) {
    // animateLayout(updateDom)
    if (typeof scopeOrUpdateDom === "function") return {
        scope: document,
        updateDom: scopeOrUpdateDom,
        defaultOptions: updateDomOrOptions
    };
    // animateLayout(scope, updateDom, options?)
    var elements = (0, _resolveElementsMjs.resolveElements)(scopeOrUpdateDom);
    var scope = elements[0] || document;
    return {
        scope: scope,
        updateDom: updateDomOrOptions,
        defaultOptions: options
    };
}
function collectLayoutElements(scope) {
    var elements = Array.from(scope.querySelectorAll(layoutSelector));
    if ((0, _instanceof._)(scope, Element) && scope.matches(layoutSelector)) {
        if (!elements.includes(scope)) elements.unshift(scope);
    }
    return elements;
}
function readLayoutAttributes(element) {
    var layoutId = element.getAttribute("data-layout-id") || undefined;
    var rawLayout = element.getAttribute("data-layout");
    var layout;
    if (rawLayout === "" || rawLayout === "true") layout = true;
    else if (rawLayout) layout = rawLayout;
    return {
        layout: layout,
        layoutId: layoutId
    };
}
function createVisualState() {
    return {
        latestValues: {},
        renderState: {
            transform: {},
            transformOrigin: {},
            style: {},
            vars: {}
        }
    };
}
function getOrCreateRecord(element, parentProjection, projectionOptions) {
    var existing = (0, _storeMjs.visualElementStore).get(element);
    var visualElement = existing !== null && existing !== void 0 ? existing : new (0, _htmlvisualElementMjs.HTMLVisualElement)({
        props: {},
        presenceContext: null,
        visualState: createVisualState()
    }, {
        allowProjection: true
    });
    if (!existing || !visualElement.projection) visualElement.projection = new (0, _htmlprojectionNodeMjs.HTMLProjectionNode)(visualElement.latestValues, parentProjection);
    visualElement.projection.setOptions((0, _objectSpreadProps._)((0, _objectSpread._)({}, projectionOptions), {
        visualElement: visualElement
    }));
    if (!visualElement.current) visualElement.mount(element);
    else if (!visualElement.projection.instance) // Mount projection if VisualElement is already mounted but projection isn't
    // This happens when animate() was called before animateLayout()
    visualElement.projection.mount(element);
    if (!existing) (0, _storeMjs.visualElementStore).set(element, visualElement);
    return {
        element: element,
        visualElement: visualElement,
        projection: visualElement.projection
    };
}
function findParentRecord(element, recordMap, scope) {
    var parent = element.parentElement;
    while(parent){
        var record = recordMap.get(parent);
        if (record) return record;
        if (parent === scope) break;
        parent = parent.parentElement;
    }
    return undefined;
}
function getProjectionRoot(afterRecords, beforeRecords) {
    var record = afterRecords[0] || beforeRecords[0];
    return record === null || record === void 0 ? void 0 : record.projection.root;
}
function collectAnimations(afterRecords) {
    var animations = new Set();
    afterRecords.forEach(function(record) {
        var animation = record.projection.currentAnimation;
        if (animation) animations.add(animation);
    });
    return Array.from(animations);
}

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_ts_generator":"78Tqx","../animation/GroupAnimation.mjs":"cpgZo","../projection/geometry/copy.mjs":"c2JNt","../projection/geometry/models.mjs":"i3okE","../projection/node/HTMLProjectionNode.mjs":"6kyDQ","../render/html/HTMLVisualElement.mjs":"g5ilZ","../render/store.mjs":"aYOSW","../utils/resolve-elements.mjs":"4pe2G","../frameloop/frame.mjs":"lxQZr","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1Nnob":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cancelSync", function() {
    return cancelSync;
});
parcelHelpers.export(exports, "sync", function() {
    return sync;
});
var _orderMjs = require("./order.mjs");
var _frameMjs = require("./frame.mjs");
/**
 * @deprecated
 *
 * Import as `frame` instead.
 */ var sync = (0, _frameMjs.frame);
/**
 * @deprecated
 *
 * Use cancelFrame(callback) instead.
 */ var cancelSync = (0, _orderMjs.stepsOrder).reduce(function(acc, key) {
    acc[key] = function(process) {
        return (0, _frameMjs.cancelFrame)(process);
    };
    return acc;
}, {});

},{"./order.mjs":"1wFti","./frame.mjs":"lxQZr","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aBfeG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MotionConfigContext", function() {
    return MotionConfigContext;
});
var _react = require("react");
"use client";
/**
 * @public
 */ var MotionConfigContext = (0, _react.createContext)({
    transformPagePoint: function(p) {
        return p;
    },
    isStatic: false,
    reducedMotion: "never"
});

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1lcvv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useComposedRefs", function() {
    return useComposedRefs;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _react = require("react");
/**
 * Taken from https://github.com/radix-ui/primitives/blob/main/packages/react/compose-refs/src/compose-refs.tsx
 */ /**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function setRef(ref, value) {
    if (typeof ref === "function") return ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function composeRefs() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++){
        refs[_key] = arguments[_key];
    }
    return function(node) {
        var hasCleanup = false;
        var cleanups = refs.map(function(ref) {
            var cleanup = setRef(ref, node);
            if (!hasCleanup && typeof cleanup === "function") hasCleanup = true;
            return cleanup;
        });
        // React <19 will log an error to the console if a callback ref returns a
        // value. We don't use ref cleanups internally so this will only happen if a
        // user's ref callback returns a value, which we only expect if they are
        // using the cleanup functionality added in React 19.
        if (hasCleanup) return function() {
            for(var i = 0; i < cleanups.length; i++){
                var cleanup = cleanups[i];
                if (typeof cleanup === "function") cleanup();
                else setRef(refs[i], null);
            }
        };
    };
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function useComposedRefs() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++){
        refs[_key] = arguments[_key];
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return _react.useCallback(composeRefs.apply(void 0, (0, _toConsumableArray._)(refs)), refs);
}

},{"@swc/helpers/_/_to_consumable_array":"1eSZf","react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"39VSv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isPresent", function() {
    return isPresent;
});
parcelHelpers.export(exports, "useIsPresent", function() {
    return useIsPresent;
});
parcelHelpers.export(exports, "usePresence", function() {
    return usePresence;
});
var _react = require("react");
var _presenceContextMjs = require("../../context/PresenceContext.mjs");
"use client";
/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed from the tree,
 * but `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function usePresence() {
    var subscribe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    var context = (0, _react.useContext)((0, _presenceContextMjs.PresenceContext));
    if (context === null) return [
        true,
        null
    ];
    var isPresent = context.isPresent, onExitComplete = context.onExitComplete, register = context.register;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    var id = (0, _react.useId)();
    (0, _react.useEffect)(function() {
        if (subscribe) return register(id);
    }, [
        subscribe
    ]);
    var safeToRemove = (0, _react.useCallback)(function() {
        return subscribe && onExitComplete && onExitComplete(id);
    }, [
        id,
        onExitComplete,
        subscribe
    ]);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function useIsPresent() {
    return isPresent((0, _react.useContext)((0, _presenceContextMjs.PresenceContext)));
}
function isPresent(context) {
    return context === null ? true : context.isPresent;
}

},{"react":"ltHCL","../../context/PresenceContext.mjs":"7pkrx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2KCYN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getChildKey", function() {
    return getChildKey;
});
parcelHelpers.export(exports, "onlyElements", function() {
    return onlyElements;
});
var _react = require("react");
var getChildKey = function(child) {
    return child.key || "";
};
function onlyElements(children) {
    var filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    (0, _react.Children).forEach(children, function(child) {
        if ((0, _react.isValidElement)(child)) filtered.push(child);
    });
    return filtered;
}

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lRaFo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "motion", function() {
    return motion;
});
var _createVisualElementMjs = require("../../dom/create-visual-element.mjs");
var _createProxyMjs = require("../create-proxy.mjs");
var _featureBundleMjs = require("./feature-bundle.mjs");
var motion = /*@__PURE__*/ (0, _createProxyMjs.createMotionProxy)((0, _featureBundleMjs.featureBundle), (0, _createVisualElementMjs.createDomVisualElement));

},{"../../dom/create-visual-element.mjs":"6CCI4","../create-proxy.mjs":"grUGJ","./feature-bundle.mjs":"dayUO","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6CCI4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createDomVisualElement", function() {
    return createDomVisualElement;
});
var _motionDom = require("motion-dom");
var _react = require("react");
var _isSvgComponentMjs = require("./utils/is-svg-component.mjs");
var createDomVisualElement = function(Component, options) {
    var _options_isSVG;
    /**
     * Use explicit isSVG override if provided, otherwise auto-detect
     */ var isSVG = (_options_isSVG = options.isSVG) !== null && _options_isSVG !== void 0 ? _options_isSVG : (0, _isSvgComponentMjs.isSVGComponent)(Component);
    return isSVG ? new (0, _motionDom.SVGVisualElement)(options) : new (0, _motionDom.HTMLVisualElement)(options, {
        allowProjection: Component !== (0, _react.Fragment)
    });
};

},{"motion-dom":"kgVDX","react":"ltHCL","./utils/is-svg-component.mjs":"dtUAQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dtUAQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isSVGComponent", function() {
    return isSVGComponent;
});
var _lowercaseElementsMjs = require("../../svg/lowercase-elements.mjs");
function isSVGComponent(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, _lowercaseElementsMjs.lowercaseSVGElements).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ RegExp("[A-Z]", "u").test(Component)) return true;
    return false;
}

},{"../../svg/lowercase-elements.mjs":"kj4Ou","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kj4Ou":[function(require,module,exports,__globalThis) {
/**
 * We keep these listed separately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lowercaseSVGElements", function() {
    return lowercaseSVGElements;
});
var lowercaseSVGElements = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"grUGJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createMotionProxy", function() {
    return createMotionProxy;
});
var _motionUtils = require("motion-utils");
var _indexMjs = require("../../motion/index.mjs");
function createMotionProxy(preloadedFeatures, createVisualElement) {
    if (typeof Proxy === "undefined") return 0, _indexMjs.createMotionComponent;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ var componentCache = new Map();
    var factory = function(Component, options) {
        return (0, _indexMjs.createMotionComponent)(Component, options, preloadedFeatures, createVisualElement);
    };
    /**
     * Support for deprecated`motion(Component)` pattern
     */ var deprecatedFactoryFunction = function(Component, options) {
        return factory(Component, options);
    };
    return new Proxy(deprecatedFactoryFunction, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: function(_target, key) {
            if (key === "create") return factory;
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, (0, _indexMjs.createMotionComponent)(key, undefined, preloadedFeatures, createVisualElement));
            return componentCache.get(key);
        }
    });
}

},{"motion-utils":"9Q5qC","../../motion/index.mjs":"7CnzX","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7CnzX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createMotionComponent", function() {
    return createMotionComponent;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _motionUtils = require("motion-utils");
var _react = require("react");
var _layoutGroupContextMjs = require("../context/LayoutGroupContext.mjs");
var _lazyContextMjs = require("../context/LazyContext.mjs");
var _motionConfigContextMjs = require("../context/MotionConfigContext.mjs");
var _indexMjs = require("../context/MotionContext/index.mjs");
var _createMjs = require("../context/MotionContext/create.mjs");
var _useRenderMjs = require("../render/dom/use-render.mjs");
var _isSvgComponentMjs = require("../render/dom/utils/is-svg-component.mjs");
var _useHtmlVisualStateMjs = require("../render/html/use-html-visual-state.mjs");
var _useSvgVisualStateMjs = require("../render/svg/use-svg-visual-state.mjs");
var _definitionsMjs = require("./features/definitions.mjs");
var _loadFeaturesMjs = require("./features/load-features.mjs");
var _symbolMjs = require("./utils/symbol.mjs");
var _useMotionRefMjs = require("./utils/use-motion-ref.mjs");
var _useVisualElementMjs = require("./utils/use-visual-element.mjs");
"use client";
/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function createMotionComponent(Component) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_forwardMotionProps = _ref.forwardMotionProps, forwardMotionProps = _ref_forwardMotionProps === void 0 ? false : _ref_forwardMotionProps, type = _ref.type, preloadedFeatures = arguments.length > 2 ? arguments[2] : void 0, createVisualElement = arguments.length > 3 ? arguments[3] : void 0;
    preloadedFeatures && (0, _loadFeaturesMjs.loadFeatures)(preloadedFeatures);
    /**
     * Determine whether to use SVG or HTML rendering based on:
     * 1. Explicit `type` option (highest priority)
     * 2. Auto-detection via `isSVGComponent`
     */ var isSVG = type ? type === "svg" : (0, _isSvgComponentMjs.isSVGComponent)(Component);
    var useVisualState = isSVG ? (0, _useSvgVisualStateMjs.useSVGVisualState) : (0, _useHtmlVisualStateMjs.useHTMLVisualState);
    function MotionDOMComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ var MeasureLayout;
        var configAndProps = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _react.useContext)((0, _motionConfigContextMjs.MotionConfigContext)), props), {
            layoutId: useLayoutId(props)
        });
        var isStatic = configAndProps.isStatic;
        var context = (0, _createMjs.useCreateMotionContext)(props);
        var visualState = useVisualState(props, isStatic);
        if (!isStatic && typeof window !== "undefined") {
            useStrictMode(configAndProps, preloadedFeatures);
            var layoutProjection = getProjectionFunctionality(configAndProps);
            MeasureLayout = layoutProjection.MeasureLayout;
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, _useVisualElementMjs.useVisualElement)(Component, visualState, configAndProps, createVisualElement, layoutProjection.ProjectionNode, isSVG);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return (0, _jsxRuntime.jsxs)((0, _indexMjs.MotionContext).Provider, {
            value: context,
            children: [
                MeasureLayout && context.visualElement ? (0, _jsxRuntime.jsx)(MeasureLayout, (0, _objectSpread._)({
                    visualElement: context.visualElement
                }, configAndProps)) : null,
                (0, _useRenderMjs.useRender)(Component, props, (0, _useMotionRefMjs.useMotionRef)(visualState, context.visualElement, externalRef), visualState, isStatic, forwardMotionProps, isSVG)
            ]
        });
    }
    var _Component_displayName, _ref1;
    MotionDOMComponent.displayName = "motion.".concat(typeof Component === "string" ? Component : "create(".concat((_ref1 = (_Component_displayName = Component.displayName) !== null && _Component_displayName !== void 0 ? _Component_displayName : Component.name) !== null && _ref1 !== void 0 ? _ref1 : "", ")"));
    var ForwardRefMotionComponent = (0, _react.forwardRef)(MotionDOMComponent);
    ForwardRefMotionComponent[0, _symbolMjs.motionComponentSymbol] = Component;
    return ForwardRefMotionComponent;
}
function useLayoutId(param) {
    var layoutId = param.layoutId;
    var layoutGroupId = (0, _react.useContext)((0, _layoutGroupContextMjs.LayoutGroupContext)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}
function useStrictMode(configAndProps, preloadedFeatures) {
    var isStrict = (0, _react.useContext)((0, _lazyContextMjs.LazyContext)).strict;
}
function getProjectionFunctionality(props) {
    var featureDefinitions = (0, _definitionsMjs.getInitializedFeatureDefinitions)();
    var drag = featureDefinitions.drag, layout = featureDefinitions.layout;
    if (!drag && !layout) return {};
    var combined = (0, _objectSpread._)({}, drag, layout);
    return {
        MeasureLayout: (drag === null || drag === void 0 ? void 0 : drag.isEnabled(props)) || (layout === null || layout === void 0 ? void 0 : layout.isEnabled(props)) ? combined.MeasureLayout : undefined,
        ProjectionNode: combined.ProjectionNode
    };
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","motion-utils":"9Q5qC","react":"ltHCL","../context/LayoutGroupContext.mjs":"9RQFv","../context/LazyContext.mjs":"hpHRu","../context/MotionConfigContext.mjs":"aBfeG","../context/MotionContext/index.mjs":"c8hkL","../context/MotionContext/create.mjs":"fo4Xu","../render/dom/use-render.mjs":"bxp7A","../render/dom/utils/is-svg-component.mjs":"dtUAQ","../render/html/use-html-visual-state.mjs":"cscxu","../render/svg/use-svg-visual-state.mjs":"gqvE1","./features/definitions.mjs":"cRpX2","./features/load-features.mjs":"kRgKg","./utils/symbol.mjs":"87B8v","./utils/use-motion-ref.mjs":"f0AYW","./utils/use-visual-element.mjs":"17Mnf","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hpHRu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LazyContext", function() {
    return LazyContext;
});
var _react = require("react");
"use client";
var LazyContext = (0, _react.createContext)({
    strict: false
});

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"c8hkL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MotionContext", function() {
    return MotionContext;
});
var _react = require("react");
"use client";
var MotionContext = /* @__PURE__ */ (0, _react.createContext)({});

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fo4Xu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCreateMotionContext", function() {
    return useCreateMotionContext;
});
var _react = require("react");
var _indexMjs = require("./index.mjs");
var _utilsMjs = require("./utils.mjs");
"use client";
function useCreateMotionContext(props) {
    var _getCurrentTreeVariants = (0, _utilsMjs.getCurrentTreeVariants)(props, (0, _react.useContext)((0, _indexMjs.MotionContext))), initial = _getCurrentTreeVariants.initial, animate = _getCurrentTreeVariants.animate;
    return (0, _react.useMemo)(function() {
        return {
            initial: initial,
            animate: animate
        };
    }, [
        variantLabelsAsDependency(initial),
        variantLabelsAsDependency(animate)
    ]);
}
function variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}

},{"react":"ltHCL","./index.mjs":"c8hkL","./utils.mjs":"7ls0F","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7ls0F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCurrentTreeVariants", function() {
    return getCurrentTreeVariants;
});
var _motionDom = require("motion-dom");
function getCurrentTreeVariants(props, context) {
    if ((0, _motionDom.isControllingVariants)(props)) {
        var initial = props.initial, animate = props.animate;
        return {
            initial: initial === false || (0, _motionDom.isVariantLabel)(initial) ? initial : undefined,
            animate: (0, _motionDom.isVariantLabel)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}

},{"motion-dom":"kgVDX","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bxp7A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useRender", function() {
    return useRender;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _motionDom = require("motion-dom");
var _react = require("react");
var _usePropsMjs = require("../html/use-props.mjs");
var _usePropsMjs1 = require("../svg/use-props.mjs");
var _filterPropsMjs = require("./utils/filter-props.mjs");
var _isSvgComponentMjs = require("./utils/is-svg-component.mjs");
"use client";
function useRender(Component, props, ref, param, isStatic) {
    var latestValues = param.latestValues, forwardMotionProps = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false, isSVG = arguments.length > 6 ? arguments[6] : void 0;
    var useVisualProps = (isSVG !== null && isSVG !== void 0 ? isSVG : (0, _isSvgComponentMjs.isSVGComponent)(Component)) ? (0, _usePropsMjs1.useSVGProps) : (0, _usePropsMjs.useHTMLProps);
    var visualProps = useVisualProps(props, latestValues, isStatic, Component);
    var filteredProps = (0, _filterPropsMjs.filterProps)(props, typeof Component === "string", forwardMotionProps);
    var elementProps = Component !== (0, _react.Fragment) ? (0, _objectSpreadProps._)((0, _objectSpread._)({}, filteredProps, visualProps), {
        ref: ref
    }) : {};
    /**
     * If component has been handed a motion value as its child,
     * memoise its initial value and render that. Subsequent updates
     * will be handled by the onChange handler
     */ var children = props.children;
    var renderedChildren = (0, _react.useMemo)(function() {
        return (0, _motionDom.isMotionValue)(children) ? children.get() : children;
    }, [
        children
    ]);
    return (0, _react.createElement)(Component, (0, _objectSpreadProps._)((0, _objectSpread._)({}, elementProps), {
        children: renderedChildren
    }));
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","motion-dom":"kgVDX","react":"ltHCL","../html/use-props.mjs":"le3Hz","../svg/use-props.mjs":"bSria","./utils/filter-props.mjs":"iU3V5","./utils/is-svg-component.mjs":"dtUAQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"le3Hz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "copyRawValuesOnly", function() {
    return copyRawValuesOnly;
});
parcelHelpers.export(exports, "useHTMLProps", function() {
    return useHTMLProps;
});
var _motionDom = require("motion-dom");
var _react = require("react");
var _createRenderStateMjs = require("./utils/create-render-state.mjs");
"use client";
function copyRawValuesOnly(target, source, props) {
    for(var key in source)if (!(0, _motionDom.isMotionValue)(source[key]) && !(0, _motionDom.isForcedMotionValue)(key, props)) target[key] = source[key];
}
function useInitialMotionValues(param, visualState) {
    var transformTemplate = param.transformTemplate;
    return (0, _react.useMemo)(function() {
        var state = (0, _createRenderStateMjs.createHtmlRenderState)();
        (0, _motionDom.buildHTMLStyles)(state, visualState, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function useStyle(props, visualState) {
    var styleProp = props.style || {};
    var style = {};
    /**
     * Copy non-Motion Values straight into style
     */ copyRawValuesOnly(style, styleProp, props);
    Object.assign(style, useInitialMotionValues(props, visualState));
    return style;
}
function useHTMLProps(props, visualState) {
    // The `any` isn't ideal but it is the type of createElement props argument
    var htmlProps = {};
    var style = useStyle(props, visualState);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : "pan-".concat(props.drag === "x" ? "y" : "x");
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}

},{"motion-dom":"kgVDX","react":"ltHCL","./utils/create-render-state.mjs":"2dErj","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2dErj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createHtmlRenderState", function() {
    return createHtmlRenderState;
});
var createHtmlRenderState = function() {
    return {
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    };
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bSria":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSVGProps", function() {
    return useSVGProps;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _motionDom = require("motion-dom");
var _react = require("react");
var _usePropsMjs = require("../html/use-props.mjs");
var _createRenderStateMjs = require("./utils/create-render-state.mjs");
"use client";
function useSVGProps(props, visualState, _isStatic, Component) {
    var visualProps = (0, _react.useMemo)(function() {
        var state = (0, _createRenderStateMjs.createSvgRenderState)();
        (0, _motionDom.buildSVGAttrs)(state, visualState, (0, _motionDom.isSVGTag)(Component), props.transformTemplate, props.style);
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.attrs), {
            style: (0, _objectSpread._)({}, state.style)
        });
    }, [
        visualState
    ]);
    if (props.style) {
        var rawStyles = {};
        (0, _usePropsMjs.copyRawValuesOnly)(rawStyles, props.style, props);
        visualProps.style = (0, _objectSpread._)({}, rawStyles, visualProps.style);
    }
    return visualProps;
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","motion-dom":"kgVDX","react":"ltHCL","../html/use-props.mjs":"le3Hz","./utils/create-render-state.mjs":"e8Fs3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"e8Fs3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createSvgRenderState", function() {
    return createSvgRenderState;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _createRenderStateMjs = require("../../html/utils/create-render-state.mjs");
var createSvgRenderState = function() {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _createRenderStateMjs.createHtmlRenderState)()), {
        attrs: {}
    });
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","../../html/utils/create-render-state.mjs":"2dErj","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iU3V5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "filterProps", function() {
    return filterProps;
});
parcelHelpers.export(exports, "loadExternalIsValidProp", function() {
    return loadExternalIsValidProp;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _motionDom = require("motion-dom");
var _validPropMjs = require("../../../motion/utils/valid-prop.mjs");
var shouldForward = function(key) {
    return !(0, _validPropMjs.isValidMotionProp)(key);
};
function loadExternalIsValidProp(isValidProp) {
    if (typeof isValidProp !== "function") return;
    // Explicitly filter our events
    shouldForward = function(key) {
        return key.startsWith("on") ? !(0, _validPropMjs.isValidMotionProp)(key) : isValidProp(key);
    };
}
/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     *
     * String concatenation prevents bundlers like webpack (e.g. Storybook)
     * from statically resolving this optional dependency at build time.
     */ var emotionPkg = "@emotion/is-prop-valid";
    loadExternalIsValidProp(require(emotionPkg).default);
} catch (e) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function filterProps(props, isDom, forwardMotionProps) {
    var filteredProps = {};
    for(var key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && (0, _typeOf._)(props.values) === "object") continue;
        if ((0, _motionDom.isMotionValue)(props[key])) continue;
        if (shouldForward(key) || forwardMotionProps === true && (0, _validPropMjs.isValidMotionProp)(key) || !isDom && !(0, _validPropMjs.isValidMotionProp)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}

},{"@swc/helpers/_/_type_of":"iFJdx","motion-dom":"kgVDX","../../../motion/utils/valid-prop.mjs":"1LJNs","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1LJNs":[function(require,module,exports,__globalThis) {
/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isValidMotionProp", function() {
    return isValidMotionProp;
});
var validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "custom",
    "inherit",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "globalTapTarget",
    "propagate",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function isValidMotionProp(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || validMotionProps.has(key);
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cscxu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useHTMLVisualState", function() {
    return useHTMLVisualState;
});
var _motionDom = require("motion-dom");
var _useVisualStateMjs = require("../../motion/utils/use-visual-state.mjs");
var _createRenderStateMjs = require("./utils/create-render-state.mjs");
"use client";
var useHTMLVisualState = /*@__PURE__*/ (0, _useVisualStateMjs.makeUseVisualState)({
    scrapeMotionValuesFromProps: (0, _motionDom.scrapeHTMLMotionValuesFromProps),
    createRenderState: (0, _createRenderStateMjs.createHtmlRenderState)
});

},{"motion-dom":"kgVDX","../../motion/utils/use-visual-state.mjs":"vM7IL","./utils/create-render-state.mjs":"2dErj","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"vM7IL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeUseVisualState", function() {
    return makeUseVisualState;
});
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _motionDom = require("motion-dom");
var _react = require("react");
var _indexMjs = require("../../context/MotionContext/index.mjs");
var _presenceContextMjs = require("../../context/PresenceContext.mjs");
var _useConstantMjs = require("../../utils/use-constant.mjs");
"use client";
function makeState(param, props, context, presenceContext) {
    var scrapeMotionValuesFromProps = param.scrapeMotionValuesFromProps, createRenderState = param.createRenderState;
    var state = {
        latestValues: makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    return state;
}
function makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    var values = {};
    var motionValues = scrapeMotionValues(props, {});
    for(var key in motionValues)values[key] = (0, _motionDom.resolveMotionValue)(motionValues[key]);
    var initial = props.initial, animate = props.animate;
    var isControllingVariants$1 = (0, _motionDom.isControllingVariants)(props);
    var isVariantNode$1 = (0, _motionDom.isVariantNode)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    var isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    var variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, _motionDom.isAnimationControls)(variantToSet)) {
        var list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        for(var i = 0; i < list.length; i++){
            var resolved = (0, _motionDom.resolveVariantFromProps)(props, list[i]);
            if (resolved) {
                var transitionEnd = resolved.transitionEnd, transition = resolved.transition, target = (0, _objectWithoutProperties._)(resolved, [
                    "transitionEnd",
                    "transition"
                ]);
                for(var key1 in target){
                    var valueTarget = target[key1];
                    if (Array.isArray(valueTarget)) {
                        /**
                         * Take final keyframe if the initial animation is blocked because
                         * we want to initialise at the end of that blocked animation.
                         */ var index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                        valueTarget = valueTarget[index];
                    }
                    if (valueTarget !== null) values[key1] = valueTarget;
                }
                for(var key2 in transitionEnd)values[key2] = transitionEnd[key2];
            }
        }
    }
    return values;
}
var makeUseVisualState = function(config) {
    return function(props, isStatic) {
        var context = (0, _react.useContext)((0, _indexMjs.MotionContext));
        var presenceContext = (0, _react.useContext)((0, _presenceContextMjs.PresenceContext));
        var make = function() {
            return makeState(config, props, context, presenceContext);
        };
        return isStatic ? make() : (0, _useConstantMjs.useConstant)(make);
    };
};

},{"@swc/helpers/_/_object_without_properties":"6HqIM","motion-dom":"kgVDX","react":"ltHCL","../../context/MotionContext/index.mjs":"c8hkL","../../context/PresenceContext.mjs":"7pkrx","../../utils/use-constant.mjs":"bhMxB","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gqvE1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSVGVisualState", function() {
    return useSVGVisualState;
});
var _motionDom = require("motion-dom");
var _useVisualStateMjs = require("../../motion/utils/use-visual-state.mjs");
var _createRenderStateMjs = require("./utils/create-render-state.mjs");
"use client";
var useSVGVisualState = /*@__PURE__*/ (0, _useVisualStateMjs.makeUseVisualState)({
    scrapeMotionValuesFromProps: (0, _motionDom.scrapeSVGMotionValuesFromProps),
    createRenderState: (0, _createRenderStateMjs.createSvgRenderState)
});

},{"motion-dom":"kgVDX","../../motion/utils/use-visual-state.mjs":"vM7IL","./utils/create-render-state.mjs":"e8Fs3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cRpX2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getInitializedFeatureDefinitions", function() {
    return getInitializedFeatureDefinitions;
});
parcelHelpers.export(exports, "initFeatureDefinitions", function() {
    return initFeatureDefinitions;
});
var _motionDom = require("motion-dom");
var featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
var isInitialized = false;
/**
 * Initialize feature definitions with isEnabled checks.
 * This must be called before any motion components are rendered.
 */ function initFeatureDefinitions() {
    var _loop = function(key) {
        initialFeatureDefinitions[key] = {
            isEnabled: function(props) {
                return featureProps[key].some(function(name) {
                    return !!props[name];
                });
            }
        };
    };
    if (isInitialized) return;
    var initialFeatureDefinitions = {};
    for(var key in featureProps)_loop(key);
    (0, _motionDom.setFeatureDefinitions)(initialFeatureDefinitions);
    isInitialized = true;
}
/**
 * Get the current feature definitions, initializing if needed.
 */ function getInitializedFeatureDefinitions() {
    initFeatureDefinitions();
    return (0, _motionDom.getFeatureDefinitions)();
}

},{"motion-dom":"kgVDX","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kRgKg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loadFeatures", function() {
    return loadFeatures;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _motionDom = require("motion-dom");
var _definitionsMjs = require("./definitions.mjs");
function loadFeatures(features) {
    var featureDefinitions = (0, _definitionsMjs.getInitializedFeatureDefinitions)();
    for(var key in features)featureDefinitions[key] = (0, _objectSpread._)({}, featureDefinitions[key], features[key]);
    (0, _motionDom.setFeatureDefinitions)(featureDefinitions);
}

},{"@swc/helpers/_/_object_spread":"9gdrV","motion-dom":"kgVDX","./definitions.mjs":"cRpX2","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"87B8v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "motionComponentSymbol", function() {
    return motionComponentSymbol;
});
var motionComponentSymbol = Symbol.for("motionComponentSymbol");

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"f0AYW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useMotionRef", function() {
    return useMotionRef;
});
var _react = require("react");
"use client";
/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function useMotionRef(visualState, visualElement, externalRef) {
    /**
     * Store externalRef in a ref to avoid including it in the useCallback
     * dependency array. Including externalRef in dependencies causes issues
     * with libraries like Radix UI that create new callback refs on each render
     * when using asChild - this would cause the callback to be recreated,
     * triggering element remounts and breaking AnimatePresence exit animations.
     */ var externalRefContainer = (0, _react.useRef)(externalRef);
    (0, _react.useInsertionEffect)(function() {
        externalRefContainer.current = externalRef;
    });
    // Store cleanup function returned by callback refs (React 19 feature)
    var refCleanup = (0, _react.useRef)(null);
    return (0, _react.useCallback)(function(instance) {
        var _visualState_onMount;
        if (instance) (_visualState_onMount = visualState.onMount) === null || _visualState_onMount === void 0 ? void 0 : _visualState_onMount.call(visualState, instance);
        var ref = externalRefContainer.current;
        if (typeof ref === "function") {
            if (instance) {
                var cleanup = ref(instance);
                if (typeof cleanup === "function") refCleanup.current = cleanup;
            } else if (refCleanup.current) {
                refCleanup.current();
                refCleanup.current = null;
            } else ref(instance);
        } else if (ref) ref.current = instance;
        if (visualElement) instance ? visualElement.mount(instance) : visualElement.unmount();
    }, [
        visualElement
    ]);
}

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"17Mnf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useVisualElement", function() {
    return useVisualElement;
});
var _motionDom = require("motion-dom");
var _react = require("react");
var _lazyContextMjs = require("../../context/LazyContext.mjs");
var _motionConfigContextMjs = require("../../context/MotionConfigContext.mjs");
var _indexMjs = require("../../context/MotionContext/index.mjs");
var _presenceContextMjs = require("../../context/PresenceContext.mjs");
var _switchLayoutGroupContextMjs = require("../../context/SwitchLayoutGroupContext.mjs");
var _isRefObjectMjs = require("../../utils/is-ref-object.mjs");
var _useIsomorphicEffectMjs = require("../../utils/use-isomorphic-effect.mjs");
"use client";
function useVisualElement(Component, visualState, props, createVisualElement, ProjectionNodeConstructor, isSVG) {
    var _window_MotionHandoffIsComplete, _window, _window_MotionHasOptimisedAnimation, _window1;
    var _useContext = (0, _react.useContext)((0, _indexMjs.MotionContext)), parent = _useContext.visualElement;
    var lazyContext = (0, _react.useContext)((0, _lazyContextMjs.LazyContext));
    var presenceContext = (0, _react.useContext)((0, _presenceContextMjs.PresenceContext));
    var motionConfig = (0, _react.useContext)((0, _motionConfigContextMjs.MotionConfigContext));
    var reducedMotionConfig = motionConfig.reducedMotion;
    var skipAnimations = motionConfig.skipAnimations;
    var visualElementRef = (0, _react.useRef)(null);
    /**
     * Track whether the component has been through React's commit phase.
     * Used to detect when LazyMotion features load after the component has mounted.
     */ var hasMountedOnce = (0, _react.useRef)(false);
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) {
        visualElementRef.current = createVisualElement(Component, {
            visualState: visualState,
            parent: parent,
            props: props,
            presenceContext: presenceContext,
            blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
            reducedMotionConfig: reducedMotionConfig,
            skipAnimations: skipAnimations,
            isSVG: isSVG
        });
        /**
         * If the component has already mounted before features loaded (e.g. via
         * LazyMotion with async feature loading), we need to force the initial
         * animation to run. Otherwise state changes that occurred before features
         * loaded will be lost and the element will snap to its final state.
         */ if (hasMountedOnce.current && visualElementRef.current) visualElementRef.current.manuallyAnimateOnMount = true;
    }
    var visualElement = visualElementRef.current;
    /**
     * Load Motion gesture and animation features. These are rendered as renderless
     * components so each feature can optionally make use of React lifecycle methods.
     */ var initialLayoutGroupConfig = (0, _react.useContext)((0, _switchLayoutGroupContextMjs.SwitchLayoutGroupContext));
    if (visualElement && !visualElement.projection && ProjectionNodeConstructor && (visualElement.type === "html" || visualElement.type === "svg")) createProjectionNode(visualElementRef.current, props, ProjectionNodeConstructor, initialLayoutGroupConfig);
    var isMounted = (0, _react.useRef)(false);
    (0, _react.useInsertionEffect)(function() {
        /**
         * Check the component has already mounted before calling
         * `update` unnecessarily. This ensures we skip the initial update.
         */ if (visualElement && isMounted.current) visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */ var optimisedAppearId = props[0, _motionDom.optimizedAppearDataAttribute];
    var wantsHandoff = (0, _react.useRef)(Boolean(optimisedAppearId) && typeof window !== "undefined" && !((_window_MotionHandoffIsComplete = (_window = window).MotionHandoffIsComplete) === null || _window_MotionHandoffIsComplete === void 0 ? void 0 : _window_MotionHandoffIsComplete.call(_window, optimisedAppearId)) && ((_window_MotionHasOptimisedAnimation = (_window1 = window).MotionHasOptimisedAnimation) === null || _window_MotionHasOptimisedAnimation === void 0 ? void 0 : _window_MotionHasOptimisedAnimation.call(_window1, optimisedAppearId)));
    (0, _useIsomorphicEffectMjs.useIsomorphicLayoutEffect)(function() {
        /**
         * Track that this component has mounted. This is used to detect when
         * LazyMotion features load after the component has already committed.
         */ hasMountedOnce.current = true;
        if (!visualElement) return;
        isMounted.current = true;
        window.MotionIsMounted = true;
        visualElement.updateFeatures();
        visualElement.scheduleRenderMicrotask();
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */ if (wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, _react.useEffect)(function() {
        if (!visualElement) return;
        if (!wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
        if (wantsHandoff.current) {
            // This ensures all future calls to animateChanges() in this component will run in useEffect
            queueMicrotask(function() {
                var _window_MotionHandoffMarkAsComplete, _window;
                (_window_MotionHandoffMarkAsComplete = (_window = window).MotionHandoffMarkAsComplete) === null || _window_MotionHandoffMarkAsComplete === void 0 ? void 0 : _window_MotionHandoffMarkAsComplete.call(_window, optimisedAppearId);
            });
            wantsHandoff.current = false;
        }
        /**
         * Now we've finished triggering animations for this element we
         * can wipe the enteringChildren set for the next render.
         */ visualElement.enteringChildren = undefined;
    });
    return visualElement;
}
function createProjectionNode(visualElement, props, ProjectionNodeConstructor, initialPromotionConfig) {
    var layoutId = props.layoutId, layout = props.layout, drag = props.drag, dragConstraints = props.dragConstraints, layoutScroll = props.layoutScroll, layoutRoot = props.layoutRoot, layoutAnchor = props.layoutAnchor, layoutCrossfade = props.layoutCrossfade;
    visualElement.projection = new ProjectionNodeConstructor(visualElement.latestValues, props["data-framer-portal-id"] ? undefined : getClosestProjectingNode(visualElement.parent));
    visualElement.projection.setOptions({
        layoutId: layoutId,
        layout: layout,
        alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, _isRefObjectMjs.isRefObject)(dragConstraints),
        visualElement: visualElement,
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */ animationType: typeof layout === "string" ? layout : "both",
        initialPromotionConfig: initialPromotionConfig,
        crossfade: layoutCrossfade,
        layoutScroll: layoutScroll,
        layoutRoot: layoutRoot,
        layoutAnchor: layoutAnchor
    });
}
function getClosestProjectingNode(visualElement) {
    if (!visualElement) return undefined;
    return visualElement.options.allowProjection !== false ? visualElement.projection : getClosestProjectingNode(visualElement.parent);
}

},{"motion-dom":"kgVDX","react":"ltHCL","../../context/LazyContext.mjs":"hpHRu","../../context/MotionConfigContext.mjs":"aBfeG","../../context/MotionContext/index.mjs":"c8hkL","../../context/PresenceContext.mjs":"7pkrx","../../context/SwitchLayoutGroupContext.mjs":"3TpD7","../../utils/is-ref-object.mjs":"l0ycD","../../utils/use-isomorphic-effect.mjs":"lN2vQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3TpD7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SwitchLayoutGroupContext", function() {
    return SwitchLayoutGroupContext;
});
var _react = require("react");
"use client";
/**
 * Internal, exported only for usage in Framer
 */ var SwitchLayoutGroupContext = (0, _react.createContext)({});

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"l0ycD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isRefObject", function() {
    return isRefObject;
});
var _typeOf = require("@swc/helpers/_/_type_of");
function isRefObject(ref) {
    return ref && (typeof ref === "undefined" ? "undefined" : (0, _typeOf._)(ref)) === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}

},{"@swc/helpers/_/_type_of":"iFJdx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dayUO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "featureBundle", function() {
    return featureBundle;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _animationsMjs = require("../../../motion/features/animations.mjs");
var _dragMjs = require("../../../motion/features/drag.mjs");
var _gesturesMjs = require("../../../motion/features/gestures.mjs");
var _layoutMjs = require("../../../motion/features/layout.mjs");
var featureBundle = (0, _objectSpread._)({}, (0, _animationsMjs.animations), (0, _gesturesMjs.gestureAnimations), (0, _dragMjs.drag), (0, _layoutMjs.layout));

},{"@swc/helpers/_/_object_spread":"9gdrV","../../../motion/features/animations.mjs":"c0bVN","../../../motion/features/drag.mjs":"1q0tr","../../../motion/features/gestures.mjs":"49Ti9","../../../motion/features/layout.mjs":"f8IG9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"c0bVN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animations", function() {
    return animations;
});
var _indexMjs = require("./animation/index.mjs");
var _exitMjs = require("./animation/exit.mjs");
var animations = {
    animation: {
        Feature: (0, _indexMjs.AnimationFeature)
    },
    exit: {
        Feature: (0, _exitMjs.ExitAnimationFeature)
    }
};

},{"./animation/index.mjs":"iU0Iu","./animation/exit.mjs":"5zvz7","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iU0Iu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AnimationFeature", function() {
    return AnimationFeature;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _motionDom = require("motion-dom");
var AnimationFeature = /*#__PURE__*/ function(Feature) {
    "use strict";
    (0, _inherits._)(AnimationFeature, Feature);
    function AnimationFeature(node) {
        (0, _classCallCheck._)(this, AnimationFeature);
        var _this;
        _this = (0, _callSuper._)(this, AnimationFeature, [
            node
        ]);
        node.animationState || (node.animationState = (0, _motionDom.createAnimationState)(node));
        return _this;
    }
    (0, _createClass._)(AnimationFeature, [
        {
            key: "updateAnimationControlsSubscription",
            value: function updateAnimationControlsSubscription() {
                var animate = this.node.getProps().animate;
                if ((0, _motionDom.isAnimationControls)(animate)) this.unmountControls = animate.subscribe(this.node);
            }
        },
        {
            /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ key: "mount",
            value: function mount() {
                this.updateAnimationControlsSubscription();
            }
        },
        {
            key: "update",
            value: function update() {
                var animate = this.node.getProps().animate;
                var _ref = this.node.prevProps || {}, prevAnimate = _ref.animate;
                if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
            }
        },
        {
            key: "unmount",
            value: function unmount() {
                var _this_unmountControls, _this;
                this.node.animationState.reset();
                (_this_unmountControls = (_this = this).unmountControls) === null || _this_unmountControls === void 0 ? void 0 : _this_unmountControls.call(_this);
            }
        }
    ]);
    return AnimationFeature;
}((0, _motionDom.Feature));

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_inherits":"2sfqW","motion-dom":"kgVDX","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5zvz7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExitAnimationFeature", function() {
    return ExitAnimationFeature;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _motionDom = require("motion-dom");
var id = 0;
var ExitAnimationFeature = /*#__PURE__*/ function(Feature) {
    "use strict";
    (0, _inherits._)(ExitAnimationFeature, Feature);
    function ExitAnimationFeature() {
        (0, _classCallCheck._)(this, ExitAnimationFeature);
        var _this;
        _this = (0, _callSuper._)(this, ExitAnimationFeature, arguments);
        _this.id = id++;
        _this.isExitComplete = false;
        return _this;
    }
    (0, _createClass._)(ExitAnimationFeature, [
        {
            key: "update",
            value: function update() {
                var _this = this;
                if (!this.node.presenceContext) return;
                var _this_node_presenceContext = this.node.presenceContext, isPresent = _this_node_presenceContext.isPresent, onExitComplete = _this_node_presenceContext.onExitComplete;
                var _ref = this.node.prevPresenceContext || {}, prevIsPresent = _ref.isPresent;
                if (!this.node.animationState || isPresent === prevIsPresent) return;
                if (isPresent && prevIsPresent === false) {
                    /**
             * When re-entering, if the exit animation already completed
             * (element is at rest), reset to initial values so the enter
             * animation replays from the correct position.
             */ if (this.isExitComplete) {
                        var _this_node_getProps = this.node.getProps(), initial = _this_node_getProps.initial, custom = _this_node_getProps.custom;
                        if (typeof initial === "string") {
                            var resolved = (0, _motionDom.resolveVariant)(this.node, initial, custom);
                            if (resolved) {
                                var _this_node_getValue;
                                var transition = resolved.transition, transitionEnd = resolved.transitionEnd, target = (0, _objectWithoutProperties._)(resolved, [
                                    "transition",
                                    "transitionEnd"
                                ]);
                                for(var key in target)(_this_node_getValue = this.node.getValue(key)) === null || _this_node_getValue === void 0 ? void 0 : _this_node_getValue.jump(target[key]);
                            }
                        }
                        this.node.animationState.reset();
                        this.node.animationState.animateChanges();
                    } else this.node.animationState.setActive("exit", false);
                    this.isExitComplete = false;
                    return;
                }
                var exitAnimation = this.node.animationState.setActive("exit", !isPresent);
                if (onExitComplete && !isPresent) exitAnimation.then(function() {
                    _this.isExitComplete = true;
                    onExitComplete(_this.id);
                });
            }
        },
        {
            key: "mount",
            value: function mount() {
                var _ref = this.node.presenceContext || {}, register = _ref.register, onExitComplete = _ref.onExitComplete;
                if (onExitComplete) onExitComplete(this.id);
                if (register) this.unmount = register(this.id);
            }
        },
        {
            key: "unmount",
            value: function unmount() {}
        }
    ]);
    return ExitAnimationFeature;
}((0, _motionDom.Feature));

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_inherits":"2sfqW","@swc/helpers/_/_object_without_properties":"6HqIM","motion-dom":"kgVDX","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1q0tr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "drag", function() {
    return drag;
});
var _indexMjs = require("../../gestures/drag/index.mjs");
var _indexMjs1 = require("../../gestures/pan/index.mjs");
var _measureLayoutMjs = require("./layout/MeasureLayout.mjs");
var _motionDom = require("motion-dom");
var drag = {
    pan: {
        Feature: (0, _indexMjs1.PanGesture)
    },
    drag: {
        Feature: (0, _indexMjs.DragGesture),
        ProjectionNode: (0, _motionDom.HTMLProjectionNode),
        MeasureLayout: (0, _measureLayoutMjs.MeasureLayout)
    }
};

},{"../../gestures/drag/index.mjs":"Vcm3p","../../gestures/pan/index.mjs":"fTZJx","./layout/MeasureLayout.mjs":"jlzIs","motion-dom":"kgVDX","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"Vcm3p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DragGesture", function() {
    return DragGesture;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _motionDom = require("motion-dom");
var _motionUtils = require("motion-utils");
var _visualElementDragControlsMjs = require("./VisualElementDragControls.mjs");
var DragGesture = /*#__PURE__*/ function(Feature) {
    "use strict";
    (0, _inherits._)(DragGesture, Feature);
    function DragGesture(node) {
        (0, _classCallCheck._)(this, DragGesture);
        var _this;
        _this = (0, _callSuper._)(this, DragGesture, [
            node
        ]);
        _this.removeGroupControls = (0, _motionUtils.noop);
        _this.removeListeners = (0, _motionUtils.noop);
        _this.controls = new (0, _visualElementDragControlsMjs.VisualElementDragControls)(node);
        return _this;
    }
    (0, _createClass._)(DragGesture, [
        {
            key: "mount",
            value: function mount() {
                // If we've been provided a DragControls for manual control over the drag gesture,
                // subscribe this component to it on mount.
                var dragControls = this.node.getProps().dragControls;
                if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
                this.removeListeners = this.controls.addListeners() || (0, _motionUtils.noop);
            }
        },
        {
            key: "update",
            value: function update() {
                var dragControls = this.node.getProps().dragControls;
                var _ref = this.node.prevProps || {}, prevDragControls = _ref.dragControls;
                if (dragControls !== prevDragControls) {
                    this.removeGroupControls();
                    if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
                }
            }
        },
        {
            key: "unmount",
            value: function unmount() {
                this.removeGroupControls();
                this.removeListeners();
                /**
         * In React 19, during list reorder reconciliation, components may
         * briefly unmount and remount while the drag is still active. If we're
         * actively dragging, we should NOT end the pan session - it will
         * continue tracking pointer events via its window-level listeners.
         *
         * The pan session will be properly cleaned up when:
         * 1. The drag ends naturally (pointerup/pointercancel)
         * 2. The component is truly removed from the DOM
         */ if (!this.controls.isDragging) this.controls.endPanSession();
            }
        }
    ]);
    return DragGesture;
}((0, _motionDom.Feature));

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_inherits":"2sfqW","motion-dom":"kgVDX","motion-utils":"9Q5qC","./VisualElementDragControls.mjs":"jFwwl","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jFwwl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VisualElementDragControls", function() {
    return VisualElementDragControls;
});
parcelHelpers.export(exports, "elementDragControls", function() {
    return elementDragControls;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _motionDom = require("motion-dom");
var _motionUtils = require("motion-utils");
var _addPointerEventMjs = require("../../events/add-pointer-event.mjs");
var _eventInfoMjs = require("../../events/event-info.mjs");
var _getContextWindowMjs = require("../../utils/get-context-window.mjs");
var _isRefObjectMjs = require("../../utils/is-ref-object.mjs");
var _panSessionMjs = require("../pan/PanSession.mjs");
var _constraintsMjs = require("./utils/constraints.mjs");
var elementDragControls = new WeakMap();
var VisualElementDragControls = /*#__PURE__*/ function() {
    "use strict";
    function VisualElementDragControls(visualElement) {
        (0, _classCallCheck._)(this, VisualElementDragControls);
        this.openDragLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, _motionDom.createBox)();
        /**
         * The latest pointer event. Used as fallback when the `cancel` and `stop` functions are called without arguments.
         */ this.latestPointerEvent = null;
        /**
         * The latest pan info. Used as fallback when the `cancel` and `stop` functions are called without arguments.
         */ this.latestPanInfo = null;
        this.visualElement = visualElement;
    }
    (0, _createClass._)(VisualElementDragControls, [
        {
            key: "start",
            value: function start(originEvent) {
                var _this = this;
                var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_snapToCursor = _ref.snapToCursor, snapToCursor = _ref_snapToCursor === void 0 ? false : _ref_snapToCursor, distanceThreshold = _ref.distanceThreshold;
                /**
         * Don't start dragging if this component is exiting
         */ var presenceContext = this.visualElement.presenceContext;
                if (presenceContext && presenceContext.isPresent === false) return;
                var onSessionStart = function(event) {
                    if (snapToCursor) _this.snapToCursor((0, _eventInfoMjs.extractEventInfo)(event).point);
                    _this.stopAnimation();
                };
                var onStart = function(event, info) {
                    // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
                    var _this_getProps = _this.getProps(), drag = _this_getProps.drag, dragPropagation = _this_getProps.dragPropagation, onDragStart = _this_getProps.onDragStart;
                    if (drag && !dragPropagation) {
                        if (_this.openDragLock) _this.openDragLock();
                        _this.openDragLock = (0, _motionDom.setDragLock)(drag);
                        // If we don 't have the lock, don't start dragging
                        if (!_this.openDragLock) return;
                    }
                    _this.latestPointerEvent = event;
                    _this.latestPanInfo = info;
                    _this.isDragging = true;
                    _this.currentDirection = null;
                    _this.resolveConstraints();
                    if (_this.visualElement.projection) {
                        _this.visualElement.projection.isAnimationBlocked = true;
                        _this.visualElement.projection.target = undefined;
                    }
                    /**
             * Record gesture origin and pointer offset
             */ (0, _motionDom.eachAxis)(function(axis) {
                        var current = _this.getAxisMotionValue(axis).get() || 0;
                        /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, _motionDom.percent).test(current)) {
                            var projection = _this.visualElement.projection;
                            if (projection && projection.layout) {
                                var measuredAxis = projection.layout.layoutBox[axis];
                                if (measuredAxis) {
                                    var length = (0, _motionDom.calcLength)(measuredAxis);
                                    current = length * (parseFloat(current) / 100);
                                }
                            }
                        }
                        _this.originPoint[axis] = current;
                    });
                    // Fire onDragStart event
                    if (onDragStart) (0, _motionDom.frame).update(function() {
                        return onDragStart(event, info);
                    }, false, true);
                    (0, _motionDom.addValueToWillChange)(_this.visualElement, "transform");
                    var animationState = _this.visualElement.animationState;
                    animationState && animationState.setActive("whileDrag", true);
                };
                var onMove = function(event, info) {
                    _this.latestPointerEvent = event;
                    _this.latestPanInfo = info;
                    var _this_getProps = _this.getProps(), dragPropagation = _this_getProps.dragPropagation, dragDirectionLock = _this_getProps.dragDirectionLock, onDirectionLock = _this_getProps.onDirectionLock, onDrag = _this_getProps.onDrag;
                    // If we didn't successfully receive the gesture lock, early return.
                    if (!dragPropagation && !_this.openDragLock) return;
                    var offset = info.offset;
                    // Attempt to detect drag direction if directionLock is true
                    if (dragDirectionLock && _this.currentDirection === null) {
                        _this.currentDirection = getCurrentDirection(offset);
                        // If we've successfully set a direction, notify listener
                        if (_this.currentDirection !== null) onDirectionLock && onDirectionLock(_this.currentDirection);
                        return;
                    }
                    // Update each point with the latest position
                    _this.updateAxis("x", info.point, offset);
                    _this.updateAxis("y", info.point, offset);
                    /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ _this.visualElement.render();
                    /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ if (onDrag) (0, _motionDom.frame).update(function() {
                        return onDrag(event, info);
                    }, false, true);
                };
                var onSessionEnd = function(event, info) {
                    _this.latestPointerEvent = event;
                    _this.latestPanInfo = info;
                    _this.stop(event, info);
                    _this.latestPointerEvent = null;
                    _this.latestPanInfo = null;
                };
                var resumeAnimation = function() {
                    var _this_getProps = _this.getProps(), snap = _this_getProps.dragSnapToOrigin;
                    if (snap || _this.constraints) _this.startAnimation({
                        x: 0,
                        y: 0
                    });
                };
                var dragSnapToOrigin = this.getProps().dragSnapToOrigin;
                this.panSession = new (0, _panSessionMjs.PanSession)(originEvent, {
                    onSessionStart: onSessionStart,
                    onStart: onStart,
                    onMove: onMove,
                    onSessionEnd: onSessionEnd,
                    resumeAnimation: resumeAnimation
                }, {
                    transformPagePoint: this.visualElement.getTransformPagePoint(),
                    dragSnapToOrigin: dragSnapToOrigin,
                    distanceThreshold: distanceThreshold,
                    contextWindow: (0, _getContextWindowMjs.getContextWindow)(this.visualElement),
                    element: this.visualElement.current
                });
            }
        },
        {
            /**
     * @internal
     */ key: "stop",
            value: function stop(event, panInfo) {
                var finalEvent = event || this.latestPointerEvent;
                var finalPanInfo = panInfo || this.latestPanInfo;
                var isDragging = this.isDragging;
                this.cancel();
                if (!isDragging || !finalPanInfo || !finalEvent) return;
                var velocity = finalPanInfo.velocity;
                this.startAnimation(velocity);
                var onDragEnd = this.getProps().onDragEnd;
                if (onDragEnd) (0, _motionDom.frame).postRender(function() {
                    return onDragEnd(finalEvent, finalPanInfo);
                });
            }
        },
        {
            /**
     * @internal
     */ key: "cancel",
            value: function cancel() {
                this.isDragging = false;
                var _this_visualElement = this.visualElement, projection = _this_visualElement.projection, animationState = _this_visualElement.animationState;
                if (projection) projection.isAnimationBlocked = false;
                this.endPanSession();
                var dragPropagation = this.getProps().dragPropagation;
                if (!dragPropagation && this.openDragLock) {
                    this.openDragLock();
                    this.openDragLock = null;
                }
                animationState && animationState.setActive("whileDrag", false);
            }
        },
        {
            /**
     * Clean up the pan session without modifying other drag state.
     * This is used during unmount to ensure event listeners are removed
     * without affecting projection animations or drag locks.
     * @internal
     */ key: "endPanSession",
            value: function endPanSession() {
                this.panSession && this.panSession.end();
                this.panSession = undefined;
            }
        },
        {
            key: "updateAxis",
            value: function updateAxis(axis, _point, offset) {
                var drag = this.getProps().drag;
                // If we're not dragging this axis, do an early return.
                if (!offset || !shouldDrag(axis, drag, this.currentDirection)) return;
                var axisValue = this.getAxisMotionValue(axis);
                var next = this.originPoint[axis] + offset[axis];
                // Apply constraints
                if (this.constraints && this.constraints[axis]) next = (0, _constraintsMjs.applyConstraints)(next, this.constraints[axis], this.elastic[axis]);
                axisValue.set(next);
            }
        },
        {
            key: "resolveConstraints",
            value: function resolveConstraints() {
                var _this = this;
                var _this_visualElement_projection;
                var _this_getProps = this.getProps(), dragConstraints = _this_getProps.dragConstraints, dragElastic = _this_getProps.dragElastic;
                var layout = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : (_this_visualElement_projection = this.visualElement.projection) === null || _this_visualElement_projection === void 0 ? void 0 : _this_visualElement_projection.layout;
                var prevConstraints = this.constraints;
                if (dragConstraints && (0, _isRefObjectMjs.isRefObject)(dragConstraints)) {
                    if (!this.constraints) this.constraints = this.resolveRefConstraints();
                } else if (dragConstraints && layout) this.constraints = (0, _constraintsMjs.calcRelativeConstraints)(layout.layoutBox, dragConstraints);
                else this.constraints = false;
                this.elastic = (0, _constraintsMjs.resolveDragElastic)(dragElastic);
                /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative. This only applies to relative (non-ref)
         * constraints, as ref-based constraints from calcViewportConstraints are already in the
         * correct coordinate space for the motion value transform offset.
         */ if (prevConstraints !== this.constraints && !(0, _isRefObjectMjs.isRefObject)(dragConstraints) && layout && this.constraints && !this.hasMutatedConstraints) (0, _motionDom.eachAxis)(function(axis) {
                    if (_this.constraints !== false && _this.getAxisMotionValue(axis)) _this.constraints[axis] = (0, _constraintsMjs.rebaseAxisConstraints)(layout.layoutBox[axis], _this.constraints[axis]);
                });
            }
        },
        {
            key: "resolveRefConstraints",
            value: function resolveRefConstraints() {
                var _this_getProps = this.getProps(), constraints = _this_getProps.dragConstraints, onMeasureDragConstraints = _this_getProps.onMeasureDragConstraints;
                if (!constraints || !(0, _isRefObjectMjs.isRefObject)(constraints)) return false;
                var constraintsElement = constraints.current;
                (0, _motionUtils.invariant)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.", "drag-constraints-ref");
                var projection = this.visualElement.projection;
                // TODO
                if (!projection || !projection.layout) return false;
                var constraintsBox = (0, _motionDom.measurePageBox)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
                var measuredConstraints = (0, _constraintsMjs.calcViewportConstraints)(projection.layout.layoutBox, constraintsBox);
                /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
                    var userConstraints = onMeasureDragConstraints((0, _motionDom.convertBoxToBoundingBox)(measuredConstraints));
                    this.hasMutatedConstraints = !!userConstraints;
                    if (userConstraints) measuredConstraints = (0, _motionDom.convertBoundingBoxToBox)(userConstraints);
                }
                return measuredConstraints;
            }
        },
        {
            key: "startAnimation",
            value: function startAnimation(velocity) {
                var _this = this;
                var _this_getProps = this.getProps(), drag = _this_getProps.drag, dragMomentum = _this_getProps.dragMomentum, dragElastic = _this_getProps.dragElastic, dragTransition = _this_getProps.dragTransition, dragSnapToOrigin = _this_getProps.dragSnapToOrigin, onDragTransitionEnd = _this_getProps.onDragTransitionEnd;
                var constraints = this.constraints || {};
                var momentumAnimations = (0, _motionDom.eachAxis)(function(axis) {
                    if (!shouldDrag(axis, drag, _this.currentDirection)) return;
                    var transition = constraints && constraints[axis] || {};
                    if (dragSnapToOrigin === true || dragSnapToOrigin === axis) transition = {
                        min: 0,
                        max: 0
                    };
                    /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ var bounceStiffness = dragElastic ? 200 : 1000000;
                    var bounceDamping = dragElastic ? 40 : 10000000;
                    var inertia = (0, _objectSpread._)({
                        type: "inertia",
                        velocity: dragMomentum ? velocity[axis] : 0,
                        bounceStiffness: bounceStiffness,
                        bounceDamping: bounceDamping,
                        timeConstant: 750,
                        restDelta: 1,
                        restSpeed: 10
                    }, dragTransition, transition);
                    // If we're not animating on an externally-provided `MotionValue` we can use the
                    // component's animation controls which will handle interactions with whileHover (etc),
                    // otherwise we just have to animate the `MotionValue` itself.
                    return _this.startAxisValueAnimation(axis, inertia);
                });
                // Run all animations and then resolve the new drag constraints.
                return Promise.all(momentumAnimations).then(onDragTransitionEnd);
            }
        },
        {
            key: "startAxisValueAnimation",
            value: function startAxisValueAnimation(axis, transition) {
                var axisValue = this.getAxisMotionValue(axis);
                (0, _motionDom.addValueToWillChange)(this.visualElement, axis);
                return axisValue.start((0, _motionDom.animateMotionValue)(axis, axisValue, 0, transition, this.visualElement, false));
            }
        },
        {
            key: "stopAnimation",
            value: function stopAnimation() {
                var _this = this;
                (0, _motionDom.eachAxis)(function(axis) {
                    return _this.getAxisMotionValue(axis).stop();
                });
            }
        },
        {
            /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ key: "getAxisMotionValue",
            value: function getAxisMotionValue(axis) {
                var dragKey = "_drag".concat(axis.toUpperCase());
                var props = this.visualElement.getProps();
                var externalMotionValue = props[dragKey];
                return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
            }
        },
        {
            key: "snapToCursor",
            value: function snapToCursor(point) {
                var _this = this;
                (0, _motionDom.eachAxis)(function(axis) {
                    var drag = _this.getProps().drag;
                    // If we're not dragging this axis, do an early return.
                    if (!shouldDrag(axis, drag, _this.currentDirection)) return;
                    var projection = _this.visualElement.projection;
                    var axisValue = _this.getAxisMotionValue(axis);
                    if (projection && projection.layout) {
                        var _projection_layout_layoutBox_axis = projection.layout.layoutBox[axis], min = _projection_layout_layoutBox_axis.min, max = _projection_layout_layoutBox_axis.max;
                        /**
                 * The layout measurement includes the current transform value,
                 * so we need to add it back to get the correct snap position.
                 * This fixes an issue where elements with initial coordinates
                 * would snap to the wrong position on the first drag.
                 */ var current = axisValue.get() || 0;
                        axisValue.set(point[axis] - (0, _motionDom.mixNumber)(min, max, 0.5) + current);
                    }
                });
            }
        },
        {
            /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ key: "scalePositionWithinConstraints",
            value: function scalePositionWithinConstraints() {
                var _this = this;
                if (!this.visualElement.current) return;
                var _this_getProps = this.getProps(), drag = _this_getProps.drag, dragConstraints = _this_getProps.dragConstraints;
                var projection = this.visualElement.projection;
                if (!(0, _isRefObjectMjs.isRefObject)(dragConstraints) || !projection || !this.constraints) return;
                /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
                /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ var boxProgress = {
                    x: 0,
                    y: 0
                };
                (0, _motionDom.eachAxis)(function(axis) {
                    var axisValue = _this.getAxisMotionValue(axis);
                    if (axisValue && _this.constraints !== false) {
                        var latest = axisValue.get();
                        boxProgress[axis] = (0, _constraintsMjs.calcOrigin)({
                            min: latest,
                            max: latest
                        }, _this.constraints[axis]);
                    }
                });
                /**
         * Update the layout of this element and resolve the latest drag constraints
         */ var transformTemplate = this.visualElement.getProps().transformTemplate;
                this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
                projection.root && projection.root.updateScroll();
                projection.updateLayout();
                /**
         * Reset constraints so resolveConstraints() will recalculate them
         * with the freshly measured layout rather than returning the cached value.
         */ this.constraints = false;
                this.resolveConstraints();
                /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, _motionDom.eachAxis)(function(axis) {
                    if (!shouldDrag(axis, drag, null)) return;
                    /**
             * Calculate a new transform based on the previous box progress
             */ var axisValue = _this.getAxisMotionValue(axis);
                    var _this_constraints_axis = _this.constraints[axis], min = _this_constraints_axis.min, max = _this_constraints_axis.max;
                    axisValue.set((0, _motionDom.mixNumber)(min, max, boxProgress[axis]));
                });
                /**
         * Flush the updated transform to the DOM synchronously to prevent
         * a visual flash at the element's CSS layout position (0,0) when
         * the transform was stripped for measurement.
         */ this.visualElement.render();
            }
        },
        {
            key: "addListeners",
            value: function addListeners() {
                var _this = this;
                if (!this.visualElement.current) return;
                elementDragControls.set(this.visualElement, this);
                var element = this.visualElement.current;
                /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ var stopPointerListener = (0, _addPointerEventMjs.addPointerEvent)(element, "pointerdown", function(event) {
                    var _this_getProps = _this.getProps(), drag = _this_getProps.drag, _this_getProps_dragListener = _this_getProps.dragListener, dragListener = _this_getProps_dragListener === void 0 ? true : _this_getProps_dragListener;
                    var target = event.target;
                    /**
             * Only block drag if clicking on a text input child element
             * (input, textarea, select, contenteditable) where users might
             * want to select text or interact with the control.
             *
             * Buttons and links don't block drag since they don't have
             * click-and-move actions of their own.
             */ var isClickingTextInputChild = target !== element && (0, _motionDom.isElementTextInput)(target);
                    if (drag && dragListener && !isClickingTextInputChild) _this.start(event);
                });
                /**
         * If using ref-based constraints, observe both the draggable element
         * and the constraint container for size changes via ResizeObserver.
         * Setup is deferred because dragConstraints.current is null when
         * addListeners first runs (React hasn't committed the ref yet).
         */ var stopResizeObservers;
                var measureDragConstraints = function() {
                    var dragConstraints = _this.getProps().dragConstraints;
                    if ((0, _isRefObjectMjs.isRefObject)(dragConstraints) && dragConstraints.current) {
                        _this.constraints = _this.resolveRefConstraints();
                        if (!stopResizeObservers) stopResizeObservers = startResizeObservers(element, dragConstraints.current, function() {
                            return _this.scalePositionWithinConstraints();
                        });
                    }
                };
                var projection = this.visualElement.projection;
                var stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
                if (projection && !projection.layout) {
                    projection.root && projection.root.updateScroll();
                    projection.updateLayout();
                }
                (0, _motionDom.frame).read(measureDragConstraints);
                /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ var stopResizeListener = (0, _motionDom.addDomEvent)(window, "resize", function() {
                    return _this.scalePositionWithinConstraints();
                });
                /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ var stopLayoutUpdateListener = projection.addEventListener("didUpdate", function(param) {
                    var delta = param.delta, hasLayoutChanged = param.hasLayoutChanged;
                    if (_this.isDragging && hasLayoutChanged) {
                        (0, _motionDom.eachAxis)(function(axis) {
                            var motionValue = _this.getAxisMotionValue(axis);
                            if (!motionValue) return;
                            _this.originPoint[axis] += delta[axis].translate;
                            motionValue.set(motionValue.get() + delta[axis].translate);
                        });
                        _this.visualElement.render();
                    }
                });
                return function() {
                    stopResizeListener();
                    stopPointerListener();
                    stopMeasureLayoutListener();
                    stopLayoutUpdateListener && stopLayoutUpdateListener();
                    stopResizeObservers && stopResizeObservers();
                };
            }
        },
        {
            key: "getProps",
            value: function getProps() {
                var props = this.visualElement.getProps();
                var _props_drag = props.drag, drag = _props_drag === void 0 ? false : _props_drag, _props_dragDirectionLock = props.dragDirectionLock, dragDirectionLock = _props_dragDirectionLock === void 0 ? false : _props_dragDirectionLock, _props_dragPropagation = props.dragPropagation, dragPropagation = _props_dragPropagation === void 0 ? false : _props_dragPropagation, _props_dragConstraints = props.dragConstraints, dragConstraints = _props_dragConstraints === void 0 ? false : _props_dragConstraints, _props_dragElastic = props.dragElastic, dragElastic = _props_dragElastic === void 0 ? (0, _constraintsMjs.defaultElastic) : _props_dragElastic, _props_dragMomentum = props.dragMomentum, dragMomentum = _props_dragMomentum === void 0 ? true : _props_dragMomentum;
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
                    drag: drag,
                    dragDirectionLock: dragDirectionLock,
                    dragPropagation: dragPropagation,
                    dragConstraints: dragConstraints,
                    dragElastic: dragElastic,
                    dragMomentum: dragMomentum
                });
            }
        }
    ]);
    return VisualElementDragControls;
}();
function skipFirstCall(callback) {
    var isFirst = true;
    return function() {
        if (isFirst) {
            isFirst = false;
            return;
        }
        callback();
    };
}
function startResizeObservers(element, constraintsElement, onResize) {
    var stopElement = (0, _motionDom.resize)(element, skipFirstCall(onResize));
    var stopContainer = (0, _motionDom.resize)(constraintsElement, skipFirstCall(onResize));
    return function() {
        stopElement();
        stopContainer();
    };
}
function shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function getCurrentDirection(offset) {
    var lockThreshold = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 10;
    var direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","motion-dom":"kgVDX","motion-utils":"9Q5qC","../../events/add-pointer-event.mjs":"6LMsS","../../events/event-info.mjs":"gaWKL","../../utils/get-context-window.mjs":"1dTH8","../../utils/is-ref-object.mjs":"l0ycD","../pan/PanSession.mjs":"5NJn3","./utils/constraints.mjs":"ay5vj","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6LMsS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addPointerEvent", function() {
    return addPointerEvent;
});
var _motionDom = require("motion-dom");
var _eventInfoMjs = require("./event-info.mjs");
function addPointerEvent(target, eventName, handler, options) {
    return (0, _motionDom.addDomEvent)(target, eventName, (0, _eventInfoMjs.addPointerInfo)(handler), options);
}

},{"motion-dom":"kgVDX","./event-info.mjs":"gaWKL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gaWKL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addPointerInfo", function() {
    return addPointerInfo;
});
parcelHelpers.export(exports, "extractEventInfo", function() {
    return extractEventInfo;
});
var _motionDom = require("motion-dom");
function extractEventInfo(event) {
    return {
        point: {
            x: event.pageX,
            y: event.pageY
        }
    };
}
var addPointerInfo = function(handler) {
    return function(event) {
        return (0, _motionDom.isPrimaryPointer)(event) && handler(event, extractEventInfo(event));
    };
};

},{"motion-dom":"kgVDX","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1dTH8":[function(require,module,exports,__globalThis) {
// Fixes https://github.com/motiondivision/motion/issues/2270
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getContextWindow", function() {
    return getContextWindow;
});
var getContextWindow = function(param) {
    var current = param.current;
    return current ? current.ownerDocument.defaultView : null;
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5NJn3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PanSession", function() {
    return PanSession;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _motionDom = require("motion-dom");
var _motionUtils = require("motion-utils");
var _addPointerEventMjs = require("../../events/add-pointer-event.mjs");
var _eventInfoMjs = require("../../events/event-info.mjs");
var _distanceMjs = require("../../utils/distance.mjs");
var overflowStyles = /*#__PURE__*/ new Set([
    "auto",
    "scroll"
]);
/**
 * @internal
 */ var PanSession = /*#__PURE__*/ function() {
    "use strict";
    function PanSession(event, handlers) {
        var _this = this;
        var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, transformPagePoint = _ref.transformPagePoint, _ref_contextWindow = _ref.contextWindow, contextWindow = _ref_contextWindow === void 0 ? window : _ref_contextWindow, _ref_dragSnapToOrigin = _ref.dragSnapToOrigin, dragSnapToOrigin = _ref_dragSnapToOrigin === void 0 ? false : _ref_dragSnapToOrigin, _ref_distanceThreshold = _ref.distanceThreshold, distanceThreshold = _ref_distanceThreshold === void 0 ? 3 : _ref_distanceThreshold, element = _ref.element;
        (0, _classCallCheck._)(this, PanSession);
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * Raw (untransformed) event info, re-transformed each frame
         * so transformPagePoint sees the current parent matrix.
         * @internal
         */ this.lastRawMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        /**
         * @internal
         */ this.contextWindow = window;
        /**
         * Scroll positions of scrollable ancestors and window.
         * @internal
         */ this.scrollPositions = new Map();
        /**
         * Cleanup function for scroll listeners.
         * @internal
         */ this.removeScrollListeners = null;
        this.onElementScroll = function(event) {
            _this.handleScroll(event.target);
        };
        this.onWindowScroll = function() {
            _this.handleScroll(window);
        };
        this.updatePoint = function() {
            if (!(_this.lastMoveEvent && _this.lastMoveEventInfo)) return;
            // Re-transform raw point through current transformPagePoint so
            // animated parent transforms (e.g. rotation) are picked up each frame
            if (_this.lastRawMoveEventInfo) _this.lastMoveEventInfo = transformPoint(_this.lastRawMoveEventInfo, _this.transformPagePoint);
            var info = getPanInfo(_this.lastMoveEventInfo, _this.history);
            var isPanStarted = _this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursor.
            var isDistancePastThreshold = (0, _distanceMjs.distance2D)(info.offset, {
                x: 0,
                y: 0
            }) >= _this.distanceThreshold;
            if (!isPanStarted && !isDistancePastThreshold) return;
            var point = info.point;
            var timestamp = (0, _motionDom.frameData).timestamp;
            _this.history.push((0, _objectSpreadProps._)((0, _objectSpread._)({}, point), {
                timestamp: timestamp
            }));
            var _this_handlers = _this.handlers, onStart = _this_handlers.onStart, onMove = _this_handlers.onMove;
            if (!isPanStarted) {
                onStart && onStart(_this.lastMoveEvent, info);
                _this.startEvent = _this.lastMoveEvent;
            }
            onMove && onMove(_this.lastMoveEvent, info);
        };
        this.handlePointerMove = function(event, info) {
            _this.lastMoveEvent = event;
            _this.lastRawMoveEventInfo = info;
            _this.lastMoveEventInfo = transformPoint(info, _this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, _motionDom.frame).update(_this.updatePoint, true);
        };
        this.handlePointerUp = function(event, info) {
            _this.end();
            var _this_handlers = _this.handlers, onEnd = _this_handlers.onEnd, onSessionEnd = _this_handlers.onSessionEnd, resumeAnimation = _this_handlers.resumeAnimation;
            // Resume animation if dragSnapToOrigin is set OR if no drag started (user just clicked)
            // This ensures constraint animations continue when interrupted by a click
            if (_this.dragSnapToOrigin || !_this.startEvent) resumeAnimation && resumeAnimation();
            if (!(_this.lastMoveEvent && _this.lastMoveEventInfo)) return;
            var panInfo = getPanInfo(event.type === "pointercancel" ? _this.lastMoveEventInfo : transformPoint(info, _this.transformPagePoint), _this.history);
            if (_this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, _motionDom.isPrimaryPointer)(event)) return;
        this.dragSnapToOrigin = dragSnapToOrigin;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        this.distanceThreshold = distanceThreshold;
        this.contextWindow = contextWindow || window;
        var info = (0, _eventInfoMjs.extractEventInfo)(event);
        var initialInfo = transformPoint(info, this.transformPagePoint);
        var point = initialInfo.point;
        var timestamp = (0, _motionDom.frameData).timestamp;
        this.history = [
            (0, _objectSpreadProps._)((0, _objectSpread._)({}, point), {
                timestamp: timestamp
            })
        ];
        var onSessionStart = handlers.onSessionStart;
        onSessionStart && onSessionStart(event, getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, _motionUtils.pipe)((0, _addPointerEventMjs.addPointerEvent)(this.contextWindow, "pointermove", this.handlePointerMove), (0, _addPointerEventMjs.addPointerEvent)(this.contextWindow, "pointerup", this.handlePointerUp), (0, _addPointerEventMjs.addPointerEvent)(this.contextWindow, "pointercancel", this.handlePointerUp));
        // Start scroll tracking if element provided
        if (element) this.startScrollTracking(element);
    }
    (0, _createClass._)(PanSession, [
        {
            /**
     * Start tracking scroll on ancestors and window.
     */ key: "startScrollTracking",
            value: function startScrollTracking(element) {
                var _this = this;
                // Store initial scroll positions for scrollable ancestors
                var current = element.parentElement;
                while(current){
                    var style = getComputedStyle(current);
                    if (overflowStyles.has(style.overflowX) || overflowStyles.has(style.overflowY)) this.scrollPositions.set(current, {
                        x: current.scrollLeft,
                        y: current.scrollTop
                    });
                    current = current.parentElement;
                }
                // Track window scroll
                this.scrollPositions.set(window, {
                    x: window.scrollX,
                    y: window.scrollY
                });
                // Capture listener catches element scroll events as they bubble
                window.addEventListener("scroll", this.onElementScroll, {
                    capture: true
                });
                // Direct window scroll listener (window scroll doesn't bubble)
                window.addEventListener("scroll", this.onWindowScroll);
                this.removeScrollListeners = function() {
                    window.removeEventListener("scroll", _this.onElementScroll, {
                        capture: true
                    });
                    window.removeEventListener("scroll", _this.onWindowScroll);
                };
            }
        },
        {
            /**
     * Handle scroll compensation during drag.
     *
     * For element scroll: adjusts history origin since pageX/pageY doesn't change.
     * For window scroll: adjusts lastMoveEventInfo since pageX/pageY would change.
     */ key: "handleScroll",
            value: function handleScroll(target) {
                var initial = this.scrollPositions.get(target);
                if (!initial) return;
                var isWindow = target === window;
                var current = isWindow ? {
                    x: window.scrollX,
                    y: window.scrollY
                } : {
                    x: target.scrollLeft,
                    y: target.scrollTop
                };
                var delta = {
                    x: current.x - initial.x,
                    y: current.y - initial.y
                };
                if (delta.x === 0 && delta.y === 0) return;
                if (isWindow) // Window scroll: pageX/pageY changes, so update lastMoveEventInfo
                {
                    if (this.lastMoveEventInfo) {
                        this.lastMoveEventInfo.point.x += delta.x;
                        this.lastMoveEventInfo.point.y += delta.y;
                    }
                } else // Element scroll: pageX/pageY unchanged, so adjust history origin
                if (this.history.length > 0) {
                    this.history[0].x -= delta.x;
                    this.history[0].y -= delta.y;
                }
                this.scrollPositions.set(target, current);
                (0, _motionDom.frame).update(this.updatePoint, true);
            }
        },
        {
            key: "updateHandlers",
            value: function updateHandlers(handlers) {
                this.handlers = handlers;
            }
        },
        {
            key: "end",
            value: function end() {
                this.removeListeners && this.removeListeners();
                this.removeScrollListeners && this.removeScrollListeners();
                this.scrollPositions.clear();
                (0, _motionDom.cancelFrame)(this.updatePoint);
            }
        }
    ]);
    return PanSession;
}();
function transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function getPanInfo(param, history) {
    var point = param.point;
    return {
        point: point,
        delta: subtractPoint(point, lastDevicePoint(history)),
        offset: subtractPoint(point, startDevicePoint(history)),
        velocity: getVelocity(history, 0.1)
    };
}
function startDevicePoint(history) {
    return history[0];
}
function lastDevicePoint(history) {
    return history[history.length - 1];
}
function getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    var i = history.length - 1;
    var timestampedPoint = null;
    var lastPoint = lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, _motionUtils.secondsToMilliseconds)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    /**
     * If the selected point is the pointer-down origin (history[0]),
     * there are better movement points available, and the time gap
     * is suspiciously large (>2x timeDelta), use the next point instead.
     * This prevents stale pointer-down points from diluting velocity
     * in hold-then-flick gestures.
     */ if (timestampedPoint === history[0] && history.length > 2 && lastPoint.timestamp - timestampedPoint.timestamp > (0, _motionUtils.secondsToMilliseconds)(timeDelta) * 2) timestampedPoint = history[1];
    var time = (0, _motionUtils.millisecondsToSeconds)(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) return {
        x: 0,
        y: 0
    };
    var currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","motion-dom":"kgVDX","motion-utils":"9Q5qC","../../events/add-pointer-event.mjs":"6LMsS","../../events/event-info.mjs":"gaWKL","../../utils/distance.mjs":"aiDIF","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aiDIF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "distance", function() {
    return distance;
});
parcelHelpers.export(exports, "distance2D", function() {
    return distance2D;
});
var distance = function(a, b) {
    return Math.abs(a - b);
};
function distance2D(a, b) {
    // Multi-dimensional
    var xDelta = distance(a.x, b.x);
    var yDelta = distance(a.y, b.y);
    return Math.sqrt(Math.pow(xDelta, 2) + Math.pow(yDelta, 2));
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ay5vj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applyConstraints", function() {
    return applyConstraints;
});
parcelHelpers.export(exports, "calcOrigin", function() {
    return calcOrigin;
});
parcelHelpers.export(exports, "calcRelativeAxisConstraints", function() {
    return calcRelativeAxisConstraints;
});
parcelHelpers.export(exports, "calcRelativeConstraints", function() {
    return calcRelativeConstraints;
});
parcelHelpers.export(exports, "calcViewportAxisConstraints", function() {
    return calcViewportAxisConstraints;
});
parcelHelpers.export(exports, "calcViewportConstraints", function() {
    return calcViewportConstraints;
});
parcelHelpers.export(exports, "defaultElastic", function() {
    return defaultElastic;
});
parcelHelpers.export(exports, "rebaseAxisConstraints", function() {
    return rebaseAxisConstraints;
});
parcelHelpers.export(exports, "resolveAxisElastic", function() {
    return resolveAxisElastic;
});
parcelHelpers.export(exports, "resolveDragElastic", function() {
    return resolveDragElastic;
});
parcelHelpers.export(exports, "resolvePointElastic", function() {
    return resolvePointElastic;
});
var _motionDom = require("motion-dom");
var _motionUtils = require("motion-utils");
/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function applyConstraints(point, param, elastic) {
    var min = param.min, max = param.max;
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, _motionDom.mixNumber)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, _motionDom.mixNumber)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function calcRelativeAxisConstraints(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function calcRelativeConstraints(layoutBox, param) {
    var top = param.top, left = param.left, bottom = param.bottom, right = param.right;
    return {
        x: calcRelativeAxisConstraints(layoutBox.x, left, right),
        y: calcRelativeAxisConstraints(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function calcViewportAxisConstraints(layoutAxis, constraintsAxis) {
    var min = constraintsAxis.min - layoutAxis.min;
    var max = constraintsAxis.max - layoutAxis.max;
    var ref;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) ref = [
        max,
        min
    ], min = ref[0], max = ref[1], ref;
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function calcViewportConstraints(layoutBox, constraintsBox) {
    return {
        x: calcViewportAxisConstraints(layoutBox.x, constraintsBox.x),
        y: calcViewportAxisConstraints(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function calcOrigin(source, target) {
    var origin = 0.5;
    var sourceLength = (0, _motionDom.calcLength)(source);
    var targetLength = (0, _motionDom.calcLength)(target);
    if (targetLength > sourceLength) origin = (0, _motionUtils.progress)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, _motionUtils.progress)(source.min, source.max - targetLength, target.min);
    return (0, _motionUtils.clamp)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function rebaseAxisConstraints(layout, constraints) {
    var relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
var defaultElastic = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function resolveDragElastic() {
    var dragElastic = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultElastic;
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = defaultElastic;
    return {
        x: resolveAxisElastic(dragElastic, "left", "right"),
        y: resolveAxisElastic(dragElastic, "top", "bottom")
    };
}
function resolveAxisElastic(dragElastic, minLabel, maxLabel) {
    return {
        min: resolvePointElastic(dragElastic, minLabel),
        max: resolvePointElastic(dragElastic, maxLabel)
    };
}
function resolvePointElastic(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}

},{"motion-dom":"kgVDX","motion-utils":"9Q5qC","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fTZJx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PanGesture", function() {
    return PanGesture;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _motionDom = require("motion-dom");
var _motionUtils = require("motion-utils");
var _addPointerEventMjs = require("../../events/add-pointer-event.mjs");
var _getContextWindowMjs = require("../../utils/get-context-window.mjs");
var _panSessionMjs = require("./PanSession.mjs");
var asyncHandler = function(handler) {
    return function(event, info) {
        if (handler) (0, _motionDom.frame).update(function() {
            return handler(event, info);
        }, false, true);
    };
};
var PanGesture = /*#__PURE__*/ function(Feature) {
    "use strict";
    (0, _inherits._)(PanGesture, Feature);
    function PanGesture() {
        (0, _classCallCheck._)(this, PanGesture);
        var _this;
        _this = (0, _callSuper._)(this, PanGesture, arguments);
        _this.removePointerDownListener = (0, _motionUtils.noop);
        return _this;
    }
    (0, _createClass._)(PanGesture, [
        {
            key: "onPointerDown",
            value: function onPointerDown(pointerDownEvent) {
                this.session = new (0, _panSessionMjs.PanSession)(pointerDownEvent, this.createPanHandlers(), {
                    transformPagePoint: this.node.getTransformPagePoint(),
                    contextWindow: (0, _getContextWindowMjs.getContextWindow)(this.node)
                });
            }
        },
        {
            key: "createPanHandlers",
            value: function createPanHandlers() {
                var _this = this;
                var _this_node_getProps = this.node.getProps(), onPanSessionStart = _this_node_getProps.onPanSessionStart, onPanStart = _this_node_getProps.onPanStart, onPan = _this_node_getProps.onPan, onPanEnd = _this_node_getProps.onPanEnd;
                return {
                    onSessionStart: asyncHandler(onPanSessionStart),
                    onStart: asyncHandler(onPanStart),
                    onMove: asyncHandler(onPan),
                    onEnd: function(event, info) {
                        delete _this.session;
                        if (onPanEnd) (0, _motionDom.frame).postRender(function() {
                            return onPanEnd(event, info);
                        });
                    }
                };
            }
        },
        {
            key: "mount",
            value: function mount() {
                var _this = this;
                this.removePointerDownListener = (0, _addPointerEventMjs.addPointerEvent)(this.node.current, "pointerdown", function(event) {
                    return _this.onPointerDown(event);
                });
            }
        },
        {
            key: "update",
            value: function update() {
                this.session && this.session.updateHandlers(this.createPanHandlers());
            }
        },
        {
            key: "unmount",
            value: function unmount() {
                this.removePointerDownListener();
                this.session && this.session.end();
            }
        }
    ]);
    return PanGesture;
}((0, _motionDom.Feature));

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_inherits":"2sfqW","motion-dom":"kgVDX","motion-utils":"9Q5qC","../../events/add-pointer-event.mjs":"6LMsS","../../utils/get-context-window.mjs":"1dTH8","./PanSession.mjs":"5NJn3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jlzIs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MeasureLayout", function() {
    return MeasureLayout;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _motionDom = require("motion-dom");
var _react = require("react");
var _usePresenceMjs = require("../../../components/AnimatePresence/use-presence.mjs");
var _layoutGroupContextMjs = require("../../../context/LayoutGroupContext.mjs");
var _switchLayoutGroupContextMjs = require("../../../context/SwitchLayoutGroupContext.mjs");
"use client";
/**
 * Track whether we've taken any snapshots yet. If not,
 * we can safely skip notification of didUpdate.
 *
 * Difficult to capture in a test but to prevent flickering
 * we must set this to true either on update or unmount.
 * Running `next-env/layout-id` in Safari will show this behaviour if broken.
 */ var hasTakenAnySnapshot = false;
var MeasureLayoutWithContext = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, _inherits._)(MeasureLayoutWithContext, Component);
    function MeasureLayoutWithContext() {
        (0, _classCallCheck._)(this, MeasureLayoutWithContext);
        return (0, _callSuper._)(this, MeasureLayoutWithContext, arguments);
    }
    (0, _createClass._)(MeasureLayoutWithContext, [
        {
            /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                var _this_props = this.props, visualElement = _this_props.visualElement, layoutGroup = _this_props.layoutGroup, switchLayoutGroup = _this_props.switchLayoutGroup, layoutId = _this_props.layoutId;
                var projection = visualElement.projection;
                if (projection) {
                    if (layoutGroup.group) layoutGroup.group.add(projection);
                    if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
                    if (hasTakenAnySnapshot) projection.root.didUpdate();
                    projection.addEventListener("animationComplete", function() {
                        _this.safeToRemove();
                    });
                    projection.setOptions((0, _objectSpreadProps._)((0, _objectSpread._)({}, projection.options), {
                        layoutDependency: this.props.layoutDependency,
                        onExitComplete: function() {
                            return _this.safeToRemove();
                        }
                    }));
                }
                (0, _motionDom.globalProjectionState).hasEverUpdated = true;
            }
        },
        {
            key: "getSnapshotBeforeUpdate",
            value: function getSnapshotBeforeUpdate(prevProps) {
                var _this = this;
                var _this_props = this.props, layoutDependency = _this_props.layoutDependency, visualElement = _this_props.visualElement, drag = _this_props.drag, isPresent = _this_props.isPresent;
                var projection = visualElement.projection;
                if (!projection) return null;
                /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
                if (prevProps.layoutDependency !== layoutDependency) projection.setOptions((0, _objectSpreadProps._)((0, _objectSpread._)({}, projection.options), {
                    layoutDependency: layoutDependency
                }));
                hasTakenAnySnapshot = true;
                if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined || prevProps.isPresent !== isPresent) projection.willUpdate();
                else this.safeToRemove();
                if (prevProps.isPresent !== isPresent) {
                    if (isPresent) projection.promote();
                    else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, _motionDom.frame).postRender(function() {
                        var stack = projection.getStack();
                        if (!stack || !stack.members.length) _this.safeToRemove();
                    });
                }
                return null;
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                var _this = this;
                var _this_props = this.props, visualElement = _this_props.visualElement, layoutAnchor = _this_props.layoutAnchor;
                var projection = visualElement.projection;
                if (projection) {
                    projection.options.layoutAnchor = layoutAnchor;
                    projection.root.didUpdate();
                    (0, _motionDom.microtask).postRender(function() {
                        if (!projection.currentAnimation && projection.isLead()) _this.safeToRemove();
                    });
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                var _this_props = this.props, visualElement = _this_props.visualElement, layoutGroup = _this_props.layoutGroup, promoteContext = _this_props.switchLayoutGroup;
                var projection = visualElement.projection;
                hasTakenAnySnapshot = true;
                if (projection) {
                    projection.scheduleCheckAfterUnmount();
                    if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
                    if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
                }
            }
        },
        {
            key: "safeToRemove",
            value: function safeToRemove() {
                var safeToRemove = this.props.safeToRemove;
                safeToRemove && safeToRemove();
            }
        },
        {
            key: "render",
            value: function render() {
                return null;
            }
        }
    ]);
    return MeasureLayoutWithContext;
}((0, _react.Component));
function MeasureLayout(props) {
    var _usePresence = (0, _slicedToArray._)((0, _usePresenceMjs.usePresence)(), 2), isPresent = _usePresence[0], safeToRemove = _usePresence[1];
    var layoutGroup = (0, _react.useContext)((0, _layoutGroupContextMjs.LayoutGroupContext));
    return (0, _jsxRuntime.jsx)(MeasureLayoutWithContext, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, _react.useContext)((0, _switchLayoutGroupContextMjs.SwitchLayoutGroupContext)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    }));
}

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_inherits":"2sfqW","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_sliced_to_array":"8PtL6","react/jsx-runtime":"bGvcw","motion-dom":"kgVDX","react":"ltHCL","../../../components/AnimatePresence/use-presence.mjs":"39VSv","../../../context/LayoutGroupContext.mjs":"9RQFv","../../../context/SwitchLayoutGroupContext.mjs":"3TpD7","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"49Ti9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gestureAnimations", function() {
    return gestureAnimations;
});
var _hoverMjs = require("../../gestures/hover.mjs");
var _focusMjs = require("../../gestures/focus.mjs");
var _pressMjs = require("../../gestures/press.mjs");
var _indexMjs = require("./viewport/index.mjs");
var gestureAnimations = {
    inView: {
        Feature: (0, _indexMjs.InViewFeature)
    },
    tap: {
        Feature: (0, _pressMjs.PressGesture)
    },
    focus: {
        Feature: (0, _focusMjs.FocusGesture)
    },
    hover: {
        Feature: (0, _hoverMjs.HoverGesture)
    }
};

},{"../../gestures/hover.mjs":"fWE1G","../../gestures/focus.mjs":"axzln","../../gestures/press.mjs":"kC67a","./viewport/index.mjs":"4YKDS","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fWE1G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HoverGesture", function() {
    return HoverGesture;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _motionDom = require("motion-dom");
var _eventInfoMjs = require("../events/event-info.mjs");
function handleHoverEvent(node, event, lifecycle) {
    var props = node.props;
    if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", lifecycle === "Start");
    var eventName = "onHover" + lifecycle;
    var callback = props[eventName];
    if (callback) (0, _motionDom.frame).postRender(function() {
        return callback(event, (0, _eventInfoMjs.extractEventInfo)(event));
    });
}
var HoverGesture = /*#__PURE__*/ function(Feature) {
    "use strict";
    (0, _inherits._)(HoverGesture, Feature);
    function HoverGesture() {
        (0, _classCallCheck._)(this, HoverGesture);
        return (0, _callSuper._)(this, HoverGesture, arguments);
    }
    (0, _createClass._)(HoverGesture, [
        {
            key: "mount",
            value: function mount() {
                var _this = this;
                var current = this.node.current;
                if (!current) return;
                this.unmount = (0, _motionDom.hover)(current, function(_element, startEvent) {
                    handleHoverEvent(_this.node, startEvent, "Start");
                    return function(endEvent) {
                        return handleHoverEvent(_this.node, endEvent, "End");
                    };
                });
            }
        },
        {
            key: "unmount",
            value: function unmount() {}
        }
    ]);
    return HoverGesture;
}((0, _motionDom.Feature));

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_inherits":"2sfqW","motion-dom":"kgVDX","../events/event-info.mjs":"gaWKL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"axzln":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FocusGesture", function() {
    return FocusGesture;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _motionDom = require("motion-dom");
var _motionUtils = require("motion-utils");
var FocusGesture = /*#__PURE__*/ function(Feature) {
    "use strict";
    (0, _inherits._)(FocusGesture, Feature);
    function FocusGesture() {
        (0, _classCallCheck._)(this, FocusGesture);
        var _this;
        _this = (0, _callSuper._)(this, FocusGesture, arguments);
        _this.isActive = false;
        return _this;
    }
    (0, _createClass._)(FocusGesture, [
        {
            key: "onFocus",
            value: function onFocus() {
                var isFocusVisible = false;
                /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
                    isFocusVisible = this.node.current.matches(":focus-visible");
                } catch (e) {
                    isFocusVisible = true;
                }
                if (!isFocusVisible || !this.node.animationState) return;
                this.node.animationState.setActive("whileFocus", true);
                this.isActive = true;
            }
        },
        {
            key: "onBlur",
            value: function onBlur() {
                if (!this.isActive || !this.node.animationState) return;
                this.node.animationState.setActive("whileFocus", false);
                this.isActive = false;
            }
        },
        {
            key: "mount",
            value: function mount() {
                var _this = this;
                this.unmount = (0, _motionUtils.pipe)((0, _motionDom.addDomEvent)(this.node.current, "focus", function() {
                    return _this.onFocus();
                }), (0, _motionDom.addDomEvent)(this.node.current, "blur", function() {
                    return _this.onBlur();
                }));
            }
        },
        {
            key: "unmount",
            value: function unmount() {}
        }
    ]);
    return FocusGesture;
}((0, _motionDom.Feature));

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_inherits":"2sfqW","motion-dom":"kgVDX","motion-utils":"9Q5qC","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kC67a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PressGesture", function() {
    return PressGesture;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _motionDom = require("motion-dom");
var _eventInfoMjs = require("../events/event-info.mjs");
function handlePressEvent(node, event, lifecycle) {
    var props = node.props;
    if ((0, _instanceof._)(node.current, HTMLButtonElement) && node.current.disabled) return;
    if (node.animationState && props.whileTap) node.animationState.setActive("whileTap", lifecycle === "Start");
    var eventName = "onTap" + (lifecycle === "End" ? "" : lifecycle);
    var callback = props[eventName];
    if (callback) (0, _motionDom.frame).postRender(function() {
        return callback(event, (0, _eventInfoMjs.extractEventInfo)(event));
    });
}
var PressGesture = /*#__PURE__*/ function(Feature) {
    "use strict";
    (0, _inherits._)(PressGesture, Feature);
    function PressGesture() {
        (0, _classCallCheck._)(this, PressGesture);
        return (0, _callSuper._)(this, PressGesture, arguments);
    }
    (0, _createClass._)(PressGesture, [
        {
            key: "mount",
            value: function mount() {
                var _this = this;
                var current = this.node.current;
                if (!current) return;
                var _this_node_props = this.node.props, globalTapTarget = _this_node_props.globalTapTarget, propagate = _this_node_props.propagate;
                this.unmount = (0, _motionDom.press)(current, function(_element, startEvent) {
                    handlePressEvent(_this.node, startEvent, "Start");
                    return function(endEvent, param) {
                        var success = param.success;
                        return handlePressEvent(_this.node, endEvent, success ? "End" : "Cancel");
                    };
                }, {
                    useGlobalTarget: globalTapTarget,
                    stopPropagation: (propagate === null || propagate === void 0 ? void 0 : propagate.tap) === false
                });
            }
        },
        {
            key: "unmount",
            value: function unmount() {}
        }
    ]);
    return PressGesture;
}((0, _motionDom.Feature));

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_inherits":"2sfqW","@swc/helpers/_/_instanceof":"h9UKc","motion-dom":"kgVDX","../events/event-info.mjs":"gaWKL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4YKDS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InViewFeature", function() {
    return InViewFeature;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _motionDom = require("motion-dom");
var _observersMjs = require("./observers.mjs");
var thresholdNames = {
    some: 0,
    all: 1
};
var InViewFeature = /*#__PURE__*/ function(Feature) {
    "use strict";
    (0, _inherits._)(InViewFeature, Feature);
    function InViewFeature() {
        (0, _classCallCheck._)(this, InViewFeature);
        var _this;
        _this = (0, _callSuper._)(this, InViewFeature, arguments);
        _this.hasEnteredView = false;
        _this.isInView = false;
        return _this;
    }
    (0, _createClass._)(InViewFeature, [
        {
            key: "startObserver",
            value: function startObserver() {
                var _this = this;
                var _this_stopObserver, _this1;
                (_this_stopObserver = (_this1 = this).stopObserver) === null || _this_stopObserver === void 0 ? void 0 : _this_stopObserver.call(_this1);
                var _this_node_getProps = this.node.getProps(), _this_node_getProps_viewport = _this_node_getProps.viewport, viewport = _this_node_getProps_viewport === void 0 ? {} : _this_node_getProps_viewport;
                var root = viewport.root, rootMargin = viewport.margin, _viewport_amount = viewport.amount, amount = _viewport_amount === void 0 ? "some" : _viewport_amount, once = viewport.once;
                var options = {
                    root: root ? root.current : undefined,
                    rootMargin: rootMargin,
                    threshold: typeof amount === "number" ? amount : thresholdNames[amount]
                };
                var onIntersectionUpdate = function(entry) {
                    var isIntersecting = entry.isIntersecting;
                    /**
             * If there's been no change in the viewport state, early return.
             */ if (_this.isInView === isIntersecting) return;
                    _this.isInView = isIntersecting;
                    /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && _this.hasEnteredView) return;
                    else if (isIntersecting) _this.hasEnteredView = true;
                    if (_this.node.animationState) _this.node.animationState.setActive("whileInView", isIntersecting);
                    /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ var _this_node_getProps = _this.node.getProps(), onViewportEnter = _this_node_getProps.onViewportEnter, onViewportLeave = _this_node_getProps.onViewportLeave;
                    var callback = isIntersecting ? onViewportEnter : onViewportLeave;
                    callback && callback(entry);
                };
                this.stopObserver = (0, _observersMjs.observeIntersection)(this.node.current, options, onIntersectionUpdate);
            }
        },
        {
            key: "mount",
            value: function mount() {
                this.startObserver();
            }
        },
        {
            key: "update",
            value: function update() {
                if (typeof IntersectionObserver === "undefined") return;
                var _this_node = this.node, props = _this_node.props, prevProps = _this_node.prevProps;
                var hasOptionsChanged = [
                    "amount",
                    "margin",
                    "root"
                ].some(hasViewportOptionChanged(props, prevProps));
                if (hasOptionsChanged) this.startObserver();
            }
        },
        {
            key: "unmount",
            value: function unmount() {
                var _this_stopObserver, _this;
                (_this_stopObserver = (_this = this).stopObserver) === null || _this_stopObserver === void 0 ? void 0 : _this_stopObserver.call(_this);
                this.hasEnteredView = false;
                this.isInView = false;
            }
        }
    ]);
    return InViewFeature;
}((0, _motionDom.Feature));
function hasViewportOptionChanged(param) {
    var _param_viewport = param.viewport, viewport = _param_viewport === void 0 ? {} : _param_viewport, _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, tmp = _ref.viewport, prevViewport = tmp === void 0 ? {} : tmp;
    return function(name) {
        return viewport[name] !== prevViewport[name];
    };
}

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_inherits":"2sfqW","motion-dom":"kgVDX","./observers.mjs":"5muv4","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5muv4":[function(require,module,exports,__globalThis) {
/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "observeIntersection", function() {
    return observeIntersection;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ var observers = new WeakMap();
var fireObserverCallback = function(entry) {
    var callback = observerCallbacks.get(entry.target);
    callback && callback(entry);
};
var fireAllObserverCallbacks = function(entries) {
    entries.forEach(fireObserverCallback);
};
function initIntersectionObserver(_param) {
    var root = _param.root, options = (0, _objectWithoutProperties._)(_param, [
        "root"
    ]);
    var lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!observers.has(lookupRoot)) observers.set(lookupRoot, {});
    var rootObservers = observers.get(lookupRoot);
    var key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver(fireAllObserverCallbacks, (0, _objectSpread._)({
        root: root
    }, options));
    return rootObservers[key];
}
function observeIntersection(element, options, callback) {
    var rootInteresectionObserver = initIntersectionObserver(options);
    observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return function() {
        observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_without_properties":"6HqIM","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"f8IG9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "layout", function() {
    return layout;
});
var _motionDom = require("motion-dom");
var _measureLayoutMjs = require("./layout/MeasureLayout.mjs");
var layout = {
    layout: {
        ProjectionNode: (0, _motionDom.HTMLProjectionNode),
        MeasureLayout: (0, _measureLayoutMjs.MeasureLayout)
    }
};

},{"motion-dom":"kgVDX","./layout/MeasureLayout.mjs":"jlzIs","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"idybG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useMotionValueEvent", function() {
    return useMotionValueEvent;
});
var _react = require("react");
"use client";
function useMotionValueEvent(value, event, callback) {
    /**
     * useInsertionEffect will create subscriptions before any other
     * effects will run. Effects run upwards through the tree so it
     * can be that binding a useLayoutEffect higher up the tree can
     * miss changes from lower down the tree.
     */ (0, _react.useInsertionEffect)(function() {
        return value.on(event, callback);
    }, [
        value,
        event,
        callback
    ]);
}

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4m3vJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useMotionTemplate", function() {
    return useMotionTemplate;
});
var _motionDom = require("motion-dom");
var _useCombineValuesMjs = require("./use-combine-values.mjs");
"use client";
/**
 * Combine multiple motion values into a new one using a string template literal.
 *
 * ```jsx
 * import {
 *   motion,
 *   useSpring,
 *   useMotionValue,
 *   useMotionTemplate
 * } from "framer-motion"
 *
 * function Component() {
 *   const shadowX = useSpring(0)
 *   const shadowY = useMotionValue(0)
 *   const shadow = useMotionTemplate`drop-shadow(${shadowX}px ${shadowY}px 20px rgba(0,0,0,0.3))`
 *
 *   return <motion.div style={{ filter: shadow }} />
 * }
 * ```
 *
 * @public
 */ function useMotionTemplate(fragments) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        values[_key - 1] = arguments[_key];
    }
    /**
     * Create a function that will build a string from the latest motion values.
     */ var numFragments = fragments.length;
    function buildValue() {
        var output = "";
        for(var i = 0; i < numFragments; i++){
            output += fragments[i];
            var value = values[i];
            if (value) output += (0, _motionDom.isMotionValue)(value) ? value.get() : value;
        }
        return output;
    }
    return (0, _useCombineValuesMjs.useCombineMotionValues)(values.filter((0, _motionDom.isMotionValue)), buildValue);
}

},{"motion-dom":"kgVDX","./use-combine-values.mjs":"eGGVS","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eGGVS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCombineMotionValues", function() {
    return useCombineMotionValues;
});
var _motionDom = require("motion-dom");
var _useIsomorphicEffectMjs = require("../utils/use-isomorphic-effect.mjs");
var _useMotionValueMjs = require("./use-motion-value.mjs");
"use client";
function useCombineMotionValues(values, combineValues) {
    /**
     * Initialise the returned motion value. This remains the same between renders.
     */ var value = (0, _useMotionValueMjs.useMotionValue)(combineValues());
    /**
     * Create a function that will update the template motion value with the latest values.
     * This is pre-bound so whenever a motion value updates it can schedule its
     * execution in Framesync. If it's already been scheduled it won't be fired twice
     * in a single frame.
     */ var updateValue = function() {
        return value.set(combineValues());
    };
    /**
     * Synchronously update the motion value with the latest values during the render.
     * This ensures that within a React render, the styles applied to the DOM are up-to-date.
     */ updateValue();
    /**
     * Subscribe to all motion values found within the template. Whenever any of them change,
     * schedule an update.
     */ (0, _useIsomorphicEffectMjs.useIsomorphicLayoutEffect)(function() {
        var scheduleUpdate = function() {
            return (0, _motionDom.frame).preRender(updateValue, false, true);
        };
        var subscriptions = values.map(function(v) {
            return v.on("change", scheduleUpdate);
        });
        return function() {
            subscriptions.forEach(function(unsubscribe) {
                return unsubscribe();
            });
            (0, _motionDom.cancelFrame)(updateValue);
        };
    });
    return value;
}

},{"motion-dom":"kgVDX","../utils/use-isomorphic-effect.mjs":"lN2vQ","./use-motion-value.mjs":"30uxP","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"30uxP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useMotionValue", function() {
    return useMotionValue;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _motionDom = require("motion-dom");
var _react = require("react");
var _motionConfigContextMjs = require("../context/MotionConfigContext.mjs");
var _useConstantMjs = require("../utils/use-constant.mjs");
"use client";
/**
 * Creates a `MotionValue` to track the state and velocity of a value.
 *
 * Usually, these are created automatically. For advanced use-cases, like use with `useTransform`, you can create `MotionValue`s externally and pass them into the animated component via the `style` prop.
 *
 * ```jsx
 * export const MyComponent = () => {
 *   const scale = useMotionValue(1)
 *
 *   return <motion.div style={{ scale }} />
 * }
 * ```
 *
 * @param initial - The initial state.
 *
 * @public
 */ function useMotionValue(initial) {
    var value = (0, _useConstantMjs.useConstant)(function() {
        return (0, _motionDom.motionValue)(initial);
    });
    /**
     * If this motion value is being used in static mode, like on
     * the Framer canvas, force components to rerender when the motion
     * value is updated.
     */ var isStatic = (0, _react.useContext)((0, _motionConfigContextMjs.MotionConfigContext)).isStatic;
    if (isStatic) {
        var _useState = (0, _slicedToArray._)((0, _react.useState)(initial), 2), setLatest = _useState[1];
        (0, _react.useEffect)(function() {
            return value.on("change", setLatest);
        }, []);
    }
    return value;
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","motion-dom":"kgVDX","react":"ltHCL","../context/MotionConfigContext.mjs":"aBfeG","../utils/use-constant.mjs":"bhMxB","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aM8BP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useScroll", function() {
    return useScroll;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _motionDom = require("motion-dom");
var _motionUtils = require("motion-utils");
var _react = require("react");
var _indexMjs = require("../render/dom/scroll/index.mjs");
var _offsetToRangeMjs = require("../render/dom/scroll/utils/offset-to-range.mjs");
var _useConstantMjs = require("../utils/use-constant.mjs");
var _useIsomorphicEffectMjs = require("../utils/use-isomorphic-effect.mjs");
"use client";
var createScrollMotionValues = function() {
    return {
        scrollX: (0, _motionDom.motionValue)(0),
        scrollY: (0, _motionDom.motionValue)(0),
        scrollXProgress: (0, _motionDom.motionValue)(0),
        scrollYProgress: (0, _motionDom.motionValue)(0)
    };
};
var isRefPending = function(ref) {
    if (!ref) return false;
    return !ref.current;
};
function makeAccelerateConfig(axis, options, container, target) {
    return {
        factory: function(animation) {
            return (0, _indexMjs.scroll)(animation, (0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
                axis: axis,
                container: (container === null || container === void 0 ? void 0 : container.current) || undefined,
                target: (target === null || target === void 0 ? void 0 : target.current) || undefined
            }));
        },
        times: [
            0,
            1
        ],
        keyframes: [
            0,
            1
        ],
        ease: function(v) {
            return v;
        },
        duration: 1
    };
}
function canAccelerateScroll(target, offset) {
    if (typeof window === "undefined") return false;
    return target ? (0, _motionDom.supportsViewTimeline)() && !!(0, _offsetToRangeMjs.offsetToViewTimelineRange)(offset) : (0, _motionDom.supportsScrollTimeline)();
}
function useScroll() {
    var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var container = _param.container, target = _param.target, options = (0, _objectWithoutProperties._)(_param, [
        "container",
        "target"
    ]);
    var values = (0, _useConstantMjs.useConstant)(createScrollMotionValues);
    if (canAccelerateScroll(target, options.offset)) {
        values.scrollXProgress.accelerate = makeAccelerateConfig("x", options, container, target);
        values.scrollYProgress.accelerate = makeAccelerateConfig("y", options, container, target);
    }
    var scrollAnimation = (0, _react.useRef)(null);
    var needsStart = (0, _react.useRef)(false);
    var start = (0, _react.useCallback)(function() {
        scrollAnimation.current = (0, _indexMjs.scroll)(function(_progress, param) {
            var x = param.x, y = param.y;
            values.scrollX.set(x.current);
            values.scrollXProgress.set(x.progress);
            values.scrollY.set(y.current);
            values.scrollYProgress.set(y.progress);
        }, (0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
            container: (container === null || container === void 0 ? void 0 : container.current) || undefined,
            target: (target === null || target === void 0 ? void 0 : target.current) || undefined
        }));
        return function() {
            var _scrollAnimation_current;
            (_scrollAnimation_current = scrollAnimation.current) === null || _scrollAnimation_current === void 0 ? void 0 : _scrollAnimation_current.call(scrollAnimation);
        };
    }, [
        container,
        target,
        JSON.stringify(options.offset)
    ]);
    (0, _useIsomorphicEffectMjs.useIsomorphicLayoutEffect)(function() {
        needsStart.current = false;
        if (isRefPending(container) || isRefPending(target)) {
            needsStart.current = true;
            return;
        } else return start();
    }, [
        start
    ]);
    (0, _react.useEffect)(function() {
        if (needsStart.current) {
            (0, _motionUtils.invariant)(!isRefPending(container), "Container ref is defined but not hydrated", "use-scroll-ref");
            (0, _motionUtils.invariant)(!isRefPending(target), "Target ref is defined but not hydrated", "use-scroll-ref");
            return start();
        } else return;
    }, [
        start
    ]);
    return values;
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","motion-dom":"kgVDX","motion-utils":"9Q5qC","react":"ltHCL","../render/dom/scroll/index.mjs":"64PXe","../render/dom/scroll/utils/offset-to-range.mjs":"3qU9Z","../utils/use-constant.mjs":"bhMxB","../utils/use-isomorphic-effect.mjs":"lN2vQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"64PXe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scroll", function() {
    return scroll;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _motionUtils = require("motion-utils");
var _attachAnimationMjs = require("./attach-animation.mjs");
var _attachFunctionMjs = require("./attach-function.mjs");
function scroll(onScroll) {
    var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _param_axis = _param.axis, axis = _param_axis === void 0 ? "y" : _param_axis, _param_container = _param.container, container = _param_container === void 0 ? document.scrollingElement : _param_container, options = (0, _objectWithoutProperties._)(_param, [
        "axis",
        "container"
    ]);
    if (!container) return 0, _motionUtils.noop;
    var optionsWithDefaults = (0, _objectSpread._)({
        axis: axis,
        container: container
    }, options);
    return typeof onScroll === "function" ? (0, _attachFunctionMjs.attachToFunction)(onScroll, optionsWithDefaults) : (0, _attachAnimationMjs.attachToAnimation)(onScroll, optionsWithDefaults);
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_without_properties":"6HqIM","motion-utils":"9Q5qC","./attach-animation.mjs":"5ctf0","./attach-function.mjs":"35fyO","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5ctf0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "attachToAnimation", function() {
    return attachToAnimation;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _motionDom = require("motion-dom");
var _canUseNativeTimelineMjs = require("./utils/can-use-native-timeline.mjs");
var _getTimelineMjs = require("./utils/get-timeline.mjs");
var _offsetToRangeMjs = require("./utils/offset-to-range.mjs");
function attachToAnimation(animation, options) {
    var timeline = (0, _getTimelineMjs.getTimeline)(options);
    var range = options.target ? (0, _offsetToRangeMjs.offsetToViewTimelineRange)(options.offset) : undefined;
    /**
     * Use native timeline when:
     * - No target: ScrollTimeline (existing behaviour)
     * - Target with mappable offset: ViewTimeline with named range
     * - Target with unmappable offset: fall back to JS observe
     */ var useNative = options.target ? (0, _canUseNativeTimelineMjs.canUseNativeTimeline)(options.target) && !!range : (0, _canUseNativeTimelineMjs.canUseNativeTimeline)();
    return animation.attachTimeline((0, _objectSpreadProps._)((0, _objectSpread._)({
        timeline: useNative ? timeline : undefined
    }, range && useNative && {
        rangeStart: range.rangeStart,
        rangeEnd: range.rangeEnd
    }), {
        observe: function(valueAnimation) {
            valueAnimation.pause();
            return (0, _motionDom.observeTimeline)(function(progress) {
                valueAnimation.time = valueAnimation.iterationDuration * progress;
            }, timeline);
        }
    }));
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","motion-dom":"kgVDX","./utils/can-use-native-timeline.mjs":"3Pu4M","./utils/get-timeline.mjs":"joIuU","./utils/offset-to-range.mjs":"3qU9Z","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3Pu4M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "canUseNativeTimeline", function() {
    return canUseNativeTimeline;
});
var _motionDom = require("motion-dom");
function canUseNativeTimeline(target) {
    if (typeof window === "undefined") return false;
    return target ? (0, _motionDom.supportsViewTimeline)() : (0, _motionDom.supportsScrollTimeline)();
}

},{"motion-dom":"kgVDX","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"joIuU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTimeline", function() {
    return getTimeline;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _trackMjs = require("../track.mjs");
var _canUseNativeTimelineMjs = require("./can-use-native-timeline.mjs");
var _offsetToRangeMjs = require("./offset-to-range.mjs");
var timelineCache = new Map();
function scrollTimelineFallback(options) {
    var currentTime = {
        value: 0
    };
    var cancel = (0, _trackMjs.scrollInfo)(function(info) {
        currentTime.value = info[options.axis].progress * 100;
    }, options);
    return {
        currentTime: currentTime,
        cancel: cancel
    };
}
function getTimeline(_param) {
    var source = _param.source, container = _param.container, options = (0, _objectWithoutProperties._)(_param, [
        "source",
        "container"
    ]);
    var axis = options.axis;
    if (source) container = source;
    var containerCache = timelineCache.get(container);
    if (!containerCache) {
        containerCache = new Map();
        timelineCache.set(container, containerCache);
    }
    var _options_target;
    var targetKey = (_options_target = options.target) !== null && _options_target !== void 0 ? _options_target : "self";
    var targetCache = containerCache.get(targetKey);
    if (!targetCache) {
        targetCache = {};
        containerCache.set(targetKey, targetCache);
    }
    var _options_offset;
    var axisKey = axis + ((_options_offset = options.offset) !== null && _options_offset !== void 0 ? _options_offset : []).join(",");
    if (!targetCache[axisKey]) {
        if (options.target && (0, _canUseNativeTimelineMjs.canUseNativeTimeline)(options.target)) {
            var range = (0, _offsetToRangeMjs.offsetToViewTimelineRange)(options.offset);
            if (range) targetCache[axisKey] = new ViewTimeline({
                subject: options.target,
                axis: axis
            });
            else targetCache[axisKey] = scrollTimelineFallback((0, _objectSpread._)({
                container: container
            }, options));
        } else if ((0, _canUseNativeTimelineMjs.canUseNativeTimeline)()) targetCache[axisKey] = new ScrollTimeline({
            source: container,
            axis: axis
        });
        else targetCache[axisKey] = scrollTimelineFallback((0, _objectSpread._)({
            container: container
        }, options));
    }
    return targetCache[axisKey];
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_without_properties":"6HqIM","../track.mjs":"jC5VD","./can-use-native-timeline.mjs":"3Pu4M","./offset-to-range.mjs":"3qU9Z","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jC5VD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scrollInfo", function() {
    return scrollInfo;
});
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _motionDom = require("motion-dom");
var _motionUtils = require("motion-utils");
var _infoMjs = require("./info.mjs");
var _onScrollHandlerMjs = require("./on-scroll-handler.mjs");
var scrollListeners = new WeakMap();
var resizeListeners = new WeakMap();
var onScrollHandlers = new WeakMap();
var scrollSize = new WeakMap();
var dimensionCheckProcesses = new WeakMap();
var getEventTarget = function(element) {
    return element === document.scrollingElement ? window : element;
};
function scrollInfo(onScroll) {
    var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _param_container = _param.container, container = _param_container === void 0 ? document.scrollingElement : _param_container, _param_trackContentSize = _param.trackContentSize, trackContentSize = _param_trackContentSize === void 0 ? false : _param_trackContentSize, options = (0, _objectWithoutProperties._)(_param, [
        "container",
        "trackContentSize"
    ]);
    if (!container) return 0, _motionUtils.noop;
    var containerHandlers = onScrollHandlers.get(container);
    /**
     * Get the onScroll handlers for this container.
     * If one isn't found, create a new one.
     */ if (!containerHandlers) {
        containerHandlers = new Set();
        onScrollHandlers.set(container, containerHandlers);
    }
    /**
     * Create a new onScroll handler for the provided callback.
     */ var info = (0, _infoMjs.createScrollInfo)();
    var containerHandler = (0, _onScrollHandlerMjs.createOnScrollHandler)(container, onScroll, info, options);
    containerHandlers.add(containerHandler);
    /**
     * Check if there's a scroll event listener for this container.
     * If not, create one.
     */ if (!scrollListeners.has(container)) {
        var measureAll = function() {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = containerHandlers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var handler = _step.value;
                    handler.measure((0, _motionDom.frameData).timestamp);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            (0, _motionDom.frame).preUpdate(notifyAll);
        };
        var notifyAll = function() {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = containerHandlers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var handler = _step.value;
                    handler.notify();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        };
        var listener = function() {
            return (0, _motionDom.frame).read(measureAll);
        };
        scrollListeners.set(container, listener);
        var target = getEventTarget(container);
        window.addEventListener("resize", listener);
        if (container !== document.documentElement) resizeListeners.set(container, (0, _motionDom.resize)(container, listener));
        target.addEventListener("scroll", listener);
        listener();
    }
    /**
     * Enable content size tracking if requested and not already enabled.
     */ if (trackContentSize && !dimensionCheckProcesses.has(container)) {
        var listener1 = scrollListeners.get(container);
        // Store initial scroll dimensions (object is reused to avoid allocation)
        var size = {
            width: container.scrollWidth,
            height: container.scrollHeight
        };
        scrollSize.set(container, size);
        // Add frame-based scroll dimension checking to detect content changes
        var checkScrollDimensions = function() {
            var newWidth = container.scrollWidth;
            var newHeight = container.scrollHeight;
            if (size.width !== newWidth || size.height !== newHeight) {
                listener1();
                size.width = newWidth;
                size.height = newHeight;
            }
        };
        // Schedule with keepAlive=true to run every frame
        var dimensionCheckProcess = (0, _motionDom.frame).read(checkScrollDimensions, true);
        dimensionCheckProcesses.set(container, dimensionCheckProcess);
    }
    var listener2 = scrollListeners.get(container);
    (0, _motionDom.frame).read(listener2, false, true);
    return function() {
        (0, _motionDom.cancelFrame)(listener2);
        /**
         * Check if we even have any handlers for this container.
         */ var currentHandlers = onScrollHandlers.get(container);
        if (!currentHandlers) return;
        currentHandlers.delete(containerHandler);
        if (currentHandlers.size) return;
        /**
         * If no more handlers, remove the scroll listener too.
         */ var scrollListener = scrollListeners.get(container);
        scrollListeners.delete(container);
        if (scrollListener) {
            var _resizeListeners_get;
            getEventTarget(container).removeEventListener("scroll", scrollListener);
            (_resizeListeners_get = resizeListeners.get(container)) === null || _resizeListeners_get === void 0 ? void 0 : _resizeListeners_get();
            window.removeEventListener("resize", scrollListener);
        }
        // Clean up scroll dimension checking
        var dimensionCheckProcess = dimensionCheckProcesses.get(container);
        if (dimensionCheckProcess) {
            (0, _motionDom.cancelFrame)(dimensionCheckProcess);
            dimensionCheckProcesses.delete(container);
        }
        scrollSize.delete(container);
    };
}

},{"@swc/helpers/_/_object_without_properties":"6HqIM","motion-dom":"kgVDX","motion-utils":"9Q5qC","./info.mjs":"4LDpz","./on-scroll-handler.mjs":"hDe8m","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4LDpz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createScrollInfo", function() {
    return createScrollInfo;
});
parcelHelpers.export(exports, "updateScrollInfo", function() {
    return updateScrollInfo;
});
var _motionUtils = require("motion-utils");
/**
 * A time in milliseconds, beyond which we consider the scroll velocity to be 0.
 */ var maxElapsed = 50;
var createAxisInfo = function() {
    return {
        current: 0,
        offset: [],
        progress: 0,
        scrollLength: 0,
        targetOffset: 0,
        targetLength: 0,
        containerLength: 0,
        velocity: 0
    };
};
var createScrollInfo = function() {
    return {
        time: 0,
        x: createAxisInfo(),
        y: createAxisInfo()
    };
};
var keys = {
    x: {
        length: "Width",
        position: "Left"
    },
    y: {
        length: "Height",
        position: "Top"
    }
};
function updateAxisInfo(element, axisName, info, time) {
    var axis = info[axisName];
    var _keys_axisName = keys[axisName], length = _keys_axisName.length, position = _keys_axisName.position;
    var prev = axis.current;
    var prevTime = info.time;
    axis.current = Math.abs(element["scroll".concat(position)]);
    axis.scrollLength = element["scroll".concat(length)] - element["client".concat(length)];
    axis.offset.length = 0;
    axis.offset[0] = 0;
    axis.offset[1] = axis.scrollLength;
    axis.progress = (0, _motionUtils.progress)(0, axis.scrollLength, axis.current);
    var elapsed = time - prevTime;
    axis.velocity = elapsed > maxElapsed ? 0 : (0, _motionUtils.velocityPerSecond)(axis.current - prev, elapsed);
}
function updateScrollInfo(element, info, time) {
    updateAxisInfo(element, "x", info, time);
    updateAxisInfo(element, "y", info, time);
    info.time = time;
}

},{"motion-utils":"9Q5qC","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hDe8m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createOnScrollHandler", function() {
    return createOnScrollHandler;
});
var _motionUtils = require("motion-utils");
var _infoMjs = require("./info.mjs");
var _indexMjs = require("./offsets/index.mjs");
function measure(container) {
    var target = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : container, info = arguments.length > 2 ? arguments[2] : void 0;
    /**
     * Find inset of target within scrollable container
     */ info.x.targetOffset = 0;
    info.y.targetOffset = 0;
    if (target !== container) {
        var node = target;
        while(node && node !== container){
            info.x.targetOffset += node.offsetLeft;
            info.y.targetOffset += node.offsetTop;
            node = node.offsetParent;
        }
    }
    info.x.targetLength = target === container ? target.scrollWidth : target.clientWidth;
    info.y.targetLength = target === container ? target.scrollHeight : target.clientHeight;
    info.x.containerLength = container.clientWidth;
    info.y.containerLength = container.clientHeight;
}
function createOnScrollHandler(element, onScroll, info) {
    var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return {
        measure: function(time) {
            measure(element, options.target, info);
            (0, _infoMjs.updateScrollInfo)(element, info, time);
            if (options.offset || options.target) (0, _indexMjs.resolveOffsets)(element, info, options);
        },
        notify: function() {
            return onScroll(info);
        }
    };
}

},{"motion-utils":"9Q5qC","./info.mjs":"4LDpz","./offsets/index.mjs":"dkgZT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dkgZT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveOffsets", function() {
    return resolveOffsets;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _motionDom = require("motion-dom");
var _motionUtils = require("motion-utils");
var _insetMjs = require("./inset.mjs");
var _offsetMjs = require("./offset.mjs");
var _presetsMjs = require("./presets.mjs");
var point = {
    x: 0,
    y: 0
};
function getTargetSize(target) {
    return "getBBox" in target && target.tagName !== "svg" ? target.getBBox() : {
        width: target.clientWidth,
        height: target.clientHeight
    };
}
function resolveOffsets(container, info, options) {
    var tmp = options.offset, offsetDefinition = tmp === void 0 ? (0, _presetsMjs.ScrollOffset).All : tmp;
    var _options_target = options.target, target = _options_target === void 0 ? container : _options_target, _options_axis = options.axis, axis = _options_axis === void 0 ? "y" : _options_axis;
    var lengthLabel = axis === "y" ? "height" : "width";
    var inset = target !== container ? (0, _insetMjs.calcInset)(target, container) : point;
    /**
     * Measure the target and container. If they're the same thing then we
     * use the container's scrollWidth/Height as the target, from there
     * all other calculations can remain the same.
     */ var targetSize = target === container ? {
        width: container.scrollWidth,
        height: container.scrollHeight
    } : getTargetSize(target);
    var containerSize = {
        width: container.clientWidth,
        height: container.clientHeight
    };
    /**
     * Reset the length of the resolved offset array rather than creating a new one.
     * TODO: More reusable data structures for targetSize/containerSize would also be good.
     */ info[axis].offset.length = 0;
    /**
     * Populate the offset array by resolving the user's offset definition into
     * a list of pixel scroll offets.
     */ var hasChanged = !info[axis].interpolate;
    var numOffsets = offsetDefinition.length;
    for(var i = 0; i < numOffsets; i++){
        var offset = (0, _offsetMjs.resolveOffset)(offsetDefinition[i], containerSize[lengthLabel], targetSize[lengthLabel], inset[axis]);
        if (!hasChanged && offset !== info[axis].interpolatorOffsets[i]) hasChanged = true;
        info[axis].offset[i] = offset;
    }
    /**
     * If the pixel scroll offsets have changed, create a new interpolator function
     * to map scroll value into a progress.
     */ if (hasChanged) {
        info[axis].interpolate = (0, _motionDom.interpolate)(info[axis].offset, (0, _motionDom.defaultOffset)(offsetDefinition), {
            clamp: false
        });
        info[axis].interpolatorOffsets = (0, _toConsumableArray._)(info[axis].offset);
    }
    info[axis].progress = (0, _motionUtils.clamp)(0, 1, info[axis].interpolate(info[axis].current));
}

},{"@swc/helpers/_/_to_consumable_array":"1eSZf","motion-dom":"kgVDX","motion-utils":"9Q5qC","./inset.mjs":"kMDH0","./offset.mjs":"d5swY","./presets.mjs":"cABYK","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kMDH0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calcInset", function() {
    return calcInset;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
var _motionDom = require("motion-dom");
function calcInset(element, container) {
    var inset = {
        x: 0,
        y: 0
    };
    var current = element;
    while(current && current !== container){
        if ((0, _motionDom.isHTMLElement)(current)) {
            inset.x += current.offsetLeft;
            inset.y += current.offsetTop;
            current = current.offsetParent;
        } else if (current.tagName === "svg") {
            /**
             * This isn't an ideal approach to measuring the offset of <svg /> tags.
             * It would be preferable, given they behave like HTMLElements in most ways
             * to use offsetLeft/Top. But these don't exist on <svg />. Likewise we
             * can't use .getBBox() like most SVG elements as these provide the offset
             * relative to the SVG itself, which for <svg /> is usually 0x0.
             */ var svgBoundingBox = current.getBoundingClientRect();
            current = current.parentElement;
            var parentBoundingBox = current.getBoundingClientRect();
            inset.x += svgBoundingBox.left - parentBoundingBox.left;
            inset.y += svgBoundingBox.top - parentBoundingBox.top;
        } else if ((0, _instanceof._)(current, SVGGraphicsElement)) {
            var _current_getBBox = current.getBBox(), x = _current_getBBox.x, y = _current_getBBox.y;
            inset.x += x;
            inset.y += y;
            var svg = null;
            var parent = current.parentNode;
            while(!svg){
                if (parent.tagName === "svg") svg = parent;
                parent = current.parentNode;
            }
            current = svg;
        } else break;
    }
    return inset;
}

},{"@swc/helpers/_/_instanceof":"h9UKc","motion-dom":"kgVDX","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"d5swY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveOffset", function() {
    return resolveOffset;
});
var _edgeMjs = require("./edge.mjs");
var defaultOffset = [
    0,
    0
];
function resolveOffset(offset, containerLength, targetLength, targetInset) {
    var offsetDefinition = Array.isArray(offset) ? offset : defaultOffset;
    var targetPoint = 0;
    var containerPoint = 0;
    if (typeof offset === "number") /**
         * If we're provided offset: [0, 0.5, 1] then each number x should become
         * [x, x], so we default to the behaviour of mapping 0 => 0 of both target
         * and container etc.
         */ offsetDefinition = [
        offset,
        offset
    ];
    else if (typeof offset === "string") {
        offset = offset.trim();
        if (offset.includes(" ")) offsetDefinition = offset.split(" ");
        else /**
             * If we're provided a definition like "100px" then we want to apply
             * that only to the top of the target point, leaving the container at 0.
             * Whereas a named offset like "end" should be applied to both.
             */ offsetDefinition = [
            offset,
            (0, _edgeMjs.namedEdges)[offset] ? offset : "0"
        ];
    }
    targetPoint = (0, _edgeMjs.resolveEdge)(offsetDefinition[0], targetLength, targetInset);
    containerPoint = (0, _edgeMjs.resolveEdge)(offsetDefinition[1], containerLength);
    return targetPoint - containerPoint;
}

},{"./edge.mjs":"eCEqK","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eCEqK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "namedEdges", function() {
    return namedEdges;
});
parcelHelpers.export(exports, "resolveEdge", function() {
    return resolveEdge;
});
var namedEdges = {
    start: 0,
    center: 0.5,
    end: 1
};
function resolveEdge(edge, length) {
    var inset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    var delta = 0;
    /**
     * If we have this edge defined as a preset, replace the definition
     * with the numerical value.
     */ if (edge in namedEdges) edge = namedEdges[edge];
    /**
     * Handle unit values
     */ if (typeof edge === "string") {
        var asNumber = parseFloat(edge);
        if (edge.endsWith("px")) delta = asNumber;
        else if (edge.endsWith("%")) edge = asNumber / 100;
        else if (edge.endsWith("vw")) delta = asNumber / 100 * document.documentElement.clientWidth;
        else if (edge.endsWith("vh")) delta = asNumber / 100 * document.documentElement.clientHeight;
        else edge = asNumber;
    }
    /**
     * If the edge is defined as a number, handle as a progress value.
     */ if (typeof edge === "number") delta = length * edge;
    return inset + delta;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cABYK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScrollOffset", function() {
    return ScrollOffset;
});
var ScrollOffset = {
    Enter: [
        [
            0,
            1
        ],
        [
            1,
            1
        ]
    ],
    Exit: [
        [
            0,
            0
        ],
        [
            1,
            0
        ]
    ],
    Any: [
        [
            1,
            0
        ],
        [
            0,
            1
        ]
    ],
    All: [
        [
            0,
            0
        ],
        [
            1,
            1
        ]
    ]
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3qU9Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "offsetToViewTimelineRange", function() {
    return offsetToViewTimelineRange;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _presetsMjs = require("../offsets/presets.mjs");
/**
 * Maps from ProgressIntersection pairs used by Motion's preset offsets to
 * ViewTimeline named ranges. Returns undefined for unrecognised patterns,
 * which signals the caller to fall back to JS-based scroll tracking.
 */ var presets = [
    [
        (0, _presetsMjs.ScrollOffset).Enter,
        "entry"
    ],
    [
        (0, _presetsMjs.ScrollOffset).Exit,
        "exit"
    ],
    [
        (0, _presetsMjs.ScrollOffset).Any,
        "cover"
    ],
    [
        (0, _presetsMjs.ScrollOffset).All,
        "contain"
    ]
];
var stringToProgress = {
    start: 0,
    end: 1
};
function parseStringOffset(s) {
    var parts = s.trim().split(/\s+/);
    if (parts.length !== 2) return undefined;
    var a = stringToProgress[parts[0]];
    var b = stringToProgress[parts[1]];
    if (a === undefined || b === undefined) return undefined;
    return [
        a,
        b
    ];
}
function normaliseOffset(offset) {
    if (offset.length !== 2) return undefined;
    var result = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = offset[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            if (Array.isArray(item)) result.push(item);
            else if (typeof item === "string") {
                var parsed = parseStringOffset(item);
                if (!parsed) return undefined;
                result.push(parsed);
            } else return undefined;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return result;
}
function matchesPreset(offset, preset) {
    var normalised = normaliseOffset(offset);
    if (!normalised) return false;
    for(var i = 0; i < 2; i++){
        var o = normalised[i];
        var p = preset[i];
        if (o[0] !== p[0] || o[1] !== p[1]) return false;
    }
    return true;
}
function offsetToViewTimelineRange(offset) {
    if (!offset) return {
        rangeStart: "contain 0%",
        rangeEnd: "contain 100%"
    };
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = presets[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, _slicedToArray._)(_step.value, 2), preset = _step_value[0], name = _step_value[1];
            if (matchesPreset(offset, preset)) return {
                rangeStart: "".concat(name, " 0%"),
                rangeEnd: "".concat(name, " 100%")
            };
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return undefined;
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","../offsets/presets.mjs":"cABYK","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"35fyO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "attachToFunction", function() {
    return attachToFunction;
});
var _motionDom = require("motion-dom");
var _trackMjs = require("./track.mjs");
var _getTimelineMjs = require("./utils/get-timeline.mjs");
/**
 * If the onScroll function has two arguments, it's expecting
 * more specific information about the scroll from scrollInfo.
 */ function isOnScrollWithInfo(onScroll) {
    return onScroll.length === 2;
}
function attachToFunction(onScroll, options) {
    if (isOnScrollWithInfo(onScroll)) return (0, _trackMjs.scrollInfo)(function(info) {
        onScroll(info[options.axis].progress, info);
    }, options);
    else return (0, _motionDom.observeTimeline)(onScroll, (0, _getTimelineMjs.getTimeline)(options));
}

},{"motion-dom":"kgVDX","./track.mjs":"jC5VD","./utils/get-timeline.mjs":"joIuU","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5QElK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useFollowValue", function() {
    return useFollowValue;
});
var _motionDom = require("motion-dom");
var _react = require("react");
var _motionConfigContextMjs = require("../context/MotionConfigContext.mjs");
var _useMotionValueMjs = require("./use-motion-value.mjs");
var _useTransformMjs = require("./use-transform.mjs");
"use client";
function useFollowValue(source) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var isStatic = (0, _react.useContext)((0, _motionConfigContextMjs.MotionConfigContext)).isStatic;
    var getFromSource = function() {
        return (0, _motionDom.isMotionValue)(source) ? source.get() : source;
    };
    // isStatic will never change, allowing early hooks return
    if (isStatic) return (0, _useTransformMjs.useTransform)(getFromSource);
    var value = (0, _useMotionValueMjs.useMotionValue)(getFromSource());
    (0, _react.useInsertionEffect)(function() {
        return (0, _motionDom.attachFollow)(value, source, options);
    }, [
        value,
        JSON.stringify(options)
    ]);
    return value;
}

},{"motion-dom":"kgVDX","react":"ltHCL","../context/MotionConfigContext.mjs":"aBfeG","./use-motion-value.mjs":"30uxP","./use-transform.mjs":"kJjDj","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kJjDj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useTransform", function() {
    return useTransform;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _motionDom = require("motion-dom");
var _useConstantMjs = require("../utils/use-constant.mjs");
var _useCombineValuesMjs = require("./use-combine-values.mjs");
var _useComputedMjs = require("./use-computed.mjs");
"use client";
function useTransform(input, inputRangeOrTransformer, outputRangeOrMap, options) {
    if (typeof input === "function") return (0, _useComputedMjs.useComputed)(input);
    /**
     * Detect if outputRangeOrMap is an output map (object with keys)
     * rather than an output range (array).
     */ var isOutputMap = outputRangeOrMap !== undefined && !Array.isArray(outputRangeOrMap) && typeof inputRangeOrTransformer !== "function";
    if (isOutputMap) return useMapTransform(input, inputRangeOrTransformer, outputRangeOrMap, options);
    var outputRange = outputRangeOrMap;
    var transformer = typeof inputRangeOrTransformer === "function" ? inputRangeOrTransformer : (0, _motionDom.transform)(inputRangeOrTransformer, outputRange, options);
    var result = Array.isArray(input) ? useListTransform(input, transformer) : useListTransform([
        input
    ], function(param) {
        var _param = (0, _slicedToArray._)(param, 1), latest = _param[0];
        return transformer(latest);
    });
    var inputAccelerate = !Array.isArray(input) ? input.accelerate : undefined;
    if (inputAccelerate && !inputAccelerate.isTransformed && typeof inputRangeOrTransformer !== "function" && Array.isArray(outputRangeOrMap) && (options === null || options === void 0 ? void 0 : options.clamp) !== false) result.accelerate = (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, inputAccelerate), {
        times: inputRangeOrTransformer,
        keyframes: outputRangeOrMap,
        isTransformed: true
    }), (options === null || options === void 0 ? void 0 : options.ease) ? {
        ease: options.ease
    } : {});
    return result;
}
function useListTransform(values, transformer) {
    var latest = (0, _useConstantMjs.useConstant)(function() {
        return [];
    });
    return (0, _useCombineValuesMjs.useCombineMotionValues)(values, function() {
        latest.length = 0;
        var numValues = values.length;
        for(var i = 0; i < numValues; i++)latest[i] = values[i].get();
        return transformer(latest);
    });
}
function useMapTransform(inputValue, inputRange, outputMap, options) {
    /**
     * Capture keys once to ensure hooks are called in consistent order.
     */ var keys = (0, _useConstantMjs.useConstant)(function() {
        return Object.keys(outputMap);
    });
    var output = (0, _useConstantMjs.useConstant)(function() {
        return {};
    });
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            output[key] = useTransform(inputValue, inputRange, outputMap[key], options);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return output;
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_sliced_to_array":"8PtL6","motion-dom":"kgVDX","../utils/use-constant.mjs":"bhMxB","./use-combine-values.mjs":"eGGVS","./use-computed.mjs":"f95vc","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"f95vc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useComputed", function() {
    return useComputed;
});
var _motionDom = require("motion-dom");
var _useCombineValuesMjs = require("./use-combine-values.mjs");
"use client";
function useComputed(compute) {
    /**
     * Open session of collectMotionValues. Any MotionValue that calls get()
     * will be saved into this array.
     */ (0, _motionDom.collectMotionValues).current = [];
    compute();
    var value = (0, _useCombineValuesMjs.useCombineMotionValues)((0, _motionDom.collectMotionValues).current, compute);
    /**
     * Synchronously close session of collectMotionValues.
     */ (0, _motionDom.collectMotionValues).current = undefined;
    return value;
}

},{"motion-dom":"kgVDX","./use-combine-values.mjs":"eGGVS","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4Ncs3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSpring", function() {
    return useSpring;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _useFollowValueMjs = require("./use-follow-value.mjs");
"use client";
function useSpring(source) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return (0, _useFollowValueMjs.useFollowValue)(source, (0, _objectSpread._)({
        type: "spring"
    }, options));
}

},{"@swc/helpers/_/_object_spread":"9gdrV","./use-follow-value.mjs":"5QElK","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eyBfJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useReducedMotion", function() {
    return useReducedMotion;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _motionDom = require("motion-dom");
var _motionUtils = require("motion-utils");
var _react = require("react");
"use client";
/**
 * A hook that returns `true` if we should be using reduced motion based on the current device's Reduced Motion setting.
 *
 * This can be used to implement changes to your UI based on Reduced Motion. For instance, replacing motion-sickness inducing
 * `x`/`y` animations with `opacity`, disabling the autoplay of background videos, or turning off parallax motion.
 *
 * It will actively respond to changes and re-render your components with the latest setting.
 *
 * ```jsx
 * export function Sidebar({ isOpen }) {
 *   const shouldReduceMotion = useReducedMotion()
 *   const closedX = shouldReduceMotion ? 0 : "-100%"
 *
 *   return (
 *     <motion.div animate={{
 *       opacity: isOpen ? 1 : 0,
 *       x: isOpen ? 0 : closedX
 *     }} />
 *   )
 * }
 * ```
 *
 * @return boolean
 *
 * @public
 */ function useReducedMotion() {
    /**
     * Lazy initialisation of prefersReducedMotion
     */ !(0, _motionDom.hasReducedMotionListener).current && (0, _motionDom.initPrefersReducedMotion)();
    var _useState = (0, _slicedToArray._)((0, _react.useState)((0, _motionDom.prefersReducedMotion).current), 1), shouldReduceMotion = _useState[0];
    /**
     * TODO See if people miss automatically updating shouldReduceMotion setting
     */ return shouldReduceMotion;
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","motion-dom":"kgVDX","motion-utils":"9Q5qC","react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"c2aMv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useInView", function() {
    return useInView;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _indexMjs = require("../render/dom/viewport/index.mjs");
"use client";
function useInView(ref) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, root = _ref.root, margin = _ref.margin, amount = _ref.amount, _ref_once = _ref.once, once = _ref_once === void 0 ? false : _ref_once, _ref_initial = _ref.initial, initial = _ref_initial === void 0 ? false : _ref_initial;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(initial), 2), isInView = _useState[0], setInView = _useState[1];
    (0, _react.useEffect)(function() {
        if (!ref.current || once && isInView) return;
        var onEnter = function() {
            setInView(true);
            return once ? undefined : function() {
                return setInView(false);
            };
        };
        var options = {
            root: root && root.current || undefined,
            margin: margin,
            amount: amount
        };
        return (0, _indexMjs.inView)(ref.current, onEnter, options);
    }, [
        root,
        ref,
        margin,
        once,
        amount
    ]);
    return isInView;
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","react":"ltHCL","../render/dom/viewport/index.mjs":"2m2Rx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2m2Rx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "inView", function() {
    return inView;
});
var _motionDom = require("motion-dom");
var thresholds = {
    some: 0,
    all: 1
};
function inView(elementOrSelector, onStart) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, root = _ref.root, rootMargin = _ref.margin, _ref_amount = _ref.amount, amount = _ref_amount === void 0 ? "some" : _ref_amount;
    var elements = (0, _motionDom.resolveElements)(elementOrSelector);
    var activeIntersections = new WeakMap();
    var onIntersectionChange = function(entries) {
        entries.forEach(function(entry) {
            var onEnd = activeIntersections.get(entry.target);
            /**
             * If there's no change to the intersection, we don't need to
             * do anything here.
             */ if (entry.isIntersecting === Boolean(onEnd)) return;
            if (entry.isIntersecting) {
                var newOnEnd = onStart(entry.target, entry);
                if (typeof newOnEnd === "function") activeIntersections.set(entry.target, newOnEnd);
                else observer.unobserve(entry.target);
            } else if (typeof onEnd === "function") {
                onEnd(entry);
                activeIntersections.delete(entry.target);
            }
        });
    };
    var observer = new IntersectionObserver(onIntersectionChange, {
        root: root,
        rootMargin: rootMargin,
        threshold: typeof amount === "number" ? amount : thresholds[amount]
    });
    elements.forEach(function(element) {
        return observer.observe(element);
    });
    return function() {
        return observer.disconnect();
    };
}

},{"motion-dom":"kgVDX","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fIMTL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animate", function() {
    return animate;
});
parcelHelpers.export(exports, "createScopedAnimate", function() {
    return createScopedAnimate;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _motionDom = require("motion-dom");
var _motionUtils = require("motion-utils");
var _sequenceMjs = require("./sequence.mjs");
var _subjectMjs = require("./subject.mjs");
function isSequence(value) {
    return Array.isArray(value) && value.some(Array.isArray);
}
/**
 * Creates an animation function that is optionally scoped
 * to a specific element.
 */ function createScopedAnimate() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var scope = options.scope, reduceMotion = options.reduceMotion;
    /**
     * Implementation
     */ function scopedAnimate(subjectOrSequence, optionsOrKeyframes, options) {
        var animations = [];
        var animationOnComplete;
        if (isSequence(subjectOrSequence)) {
            var _ref = optionsOrKeyframes || {}, onComplete = _ref.onComplete, sequenceOptions = (0, _objectWithoutProperties._)(_ref, [
                "onComplete"
            ]);
            if (typeof onComplete === "function") animationOnComplete = onComplete;
            animations = (0, _sequenceMjs.animateSequence)(subjectOrSequence, reduceMotion !== undefined ? (0, _objectSpread._)({
                reduceMotion: reduceMotion
            }, sequenceOptions) : sequenceOptions, scope);
        } else {
            // Extract top-level onComplete so it doesn't get applied per-value
            var _ref1 = options || {}, onComplete1 = _ref1.onComplete, rest = (0, _objectWithoutProperties._)(_ref1, [
                "onComplete"
            ]);
            if (typeof onComplete1 === "function") animationOnComplete = onComplete1;
            animations = (0, _subjectMjs.animateSubject)(subjectOrSequence, optionsOrKeyframes, reduceMotion !== undefined ? (0, _objectSpread._)({
                reduceMotion: reduceMotion
            }, rest) : rest, scope);
        }
        var animation = new (0, _motionDom.GroupAnimationWithThen)(animations);
        if (animationOnComplete) animation.finished.then(animationOnComplete);
        if (scope) {
            scope.animations.push(animation);
            animation.finished.then(function() {
                (0, _motionUtils.removeItem)(scope.animations, animation);
            });
        }
        return animation;
    }
    return scopedAnimate;
}
var animate = createScopedAnimate();

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_without_properties":"6HqIM","motion-dom":"kgVDX","motion-utils":"9Q5qC","./sequence.mjs":"hgCN2","./subject.mjs":"hKitk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hgCN2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animateSequence", function() {
    return animateSequence;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _motionDom = require("motion-dom");
var _createMjs = require("../sequence/create.mjs");
var _subjectMjs = require("./subject.mjs");
function animateSequence(sequence, options, scope) {
    var animations = [];
    /**
     * Pre-process: replace function segments with MotionValue segments,
     * subscribe callbacks immediately
     */ var processedSequence = sequence.map(function(segment) {
        if (Array.isArray(segment) && typeof segment[0] === "function") {
            var callback = segment[0];
            var mv = (0, _motionDom.motionValue)(0);
            mv.on("change", callback);
            if (segment.length === 1) return [
                mv,
                [
                    0,
                    1
                ]
            ];
            else if (segment.length === 2) return [
                mv,
                [
                    0,
                    1
                ],
                segment[1]
            ];
            else return [
                mv,
                segment[1],
                segment[2]
            ];
        }
        return segment;
    });
    var animationDefinitions = (0, _createMjs.createAnimationsFromSequence)(processedSequence, options, scope, {
        spring: (0, _motionDom.spring)
    });
    animationDefinitions.forEach(function(param, subject) {
        var keyframes = param.keyframes, transition = param.transition;
        var _animations;
        (_animations = animations).push.apply(_animations, (0, _toConsumableArray._)((0, _subjectMjs.animateSubject)(subject, keyframes, transition)));
    });
    return animations;
}

},{"@swc/helpers/_/_to_consumable_array":"1eSZf","motion-dom":"kgVDX","../sequence/create.mjs":"hRTUg","./subject.mjs":"hKitk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hRTUg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createAnimationsFromSequence", function() {
    return createAnimationsFromSequence;
});
parcelHelpers.export(exports, "getValueTransition", function() {
    return getValueTransition;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _motionDom = require("motion-dom");
var _motionUtils = require("motion-utils");
var _resolveSubjectsMjs = require("../animate/resolve-subjects.mjs");
var _calcRepeatDurationMjs = require("./utils/calc-repeat-duration.mjs");
var _calcTimeMjs = require("./utils/calc-time.mjs");
var _editMjs = require("./utils/edit.mjs");
var _normalizeTimesMjs = require("./utils/normalize-times.mjs");
var _sortMjs = require("./utils/sort.mjs");
var defaultSegmentEasing = "easeInOut";
var MAX_REPEAT = 20;
function createAnimationsFromSequence(sequence) {
    var _loop = function(i) {
        var segment = sequence[i];
        /**
         * If this is a timeline label, mark it and skip the rest of this iteration.
         */ if (typeof segment === "string") {
            timeLabels.set(segment, currentTime);
            return "continue";
        } else if (!Array.isArray(segment)) {
            timeLabels.set(segment.name, (0, _calcTimeMjs.calcNextTime)(currentTime, segment.at, prevTime, timeLabels));
            return "continue";
        }
        var _segment = (0, _slicedToArray._)(segment, 3), subject = _segment[0], keyframes = _segment[1], tmp = _segment[2], transition = tmp === void 0 ? {} : tmp;
        /**
         * If a relative or absolute time value has been specified we need to resolve
         * it in relation to the currentTime.
         */ if (transition.at !== undefined) currentTime = (0, _calcTimeMjs.calcNextTime)(currentTime, transition.at, prevTime, timeLabels);
        /**
         * Keep track of the maximum duration in this definition. This will be
         * applied to currentTime once the definition has been parsed.
         */ var maxDuration = 0;
        var resolveValueSequence = function(valueKeyframes, valueTransition, valueSequence) {
            var elementIndex = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, numSubjects = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
            var valueKeyframesAsList = keyframesAsList(valueKeyframes);
            var _valueTransition_delay = valueTransition.delay, delay = _valueTransition_delay === void 0 ? 0 : _valueTransition_delay, _valueTransition_times = valueTransition.times, times = _valueTransition_times === void 0 ? (0, _motionDom.defaultOffset)(valueKeyframesAsList) : _valueTransition_times, _valueTransition_type = valueTransition.type, type = _valueTransition_type === void 0 ? defaultTransition.type || "keyframes" : _valueTransition_type, repeat = valueTransition.repeat, repeatType = valueTransition.repeatType, _valueTransition_repeatDelay = valueTransition.repeatDelay, repeatDelay = _valueTransition_repeatDelay === void 0 ? 0 : _valueTransition_repeatDelay, remainingTransition = (0, _objectWithoutProperties._)(valueTransition, [
                "delay",
                "times",
                "type",
                "repeat",
                "repeatType",
                "repeatDelay"
            ]);
            var _valueTransition_ease = valueTransition.ease, ease = _valueTransition_ease === void 0 ? defaultTransition.ease || "easeOut" : _valueTransition_ease, duration = valueTransition.duration;
            /**
             * Resolve stagger() if defined.
             */ var calculatedDelay = typeof delay === "function" ? delay(elementIndex, numSubjects) : delay;
            /**
             * If this animation should and can use a spring, generate a spring easing function.
             */ var numKeyframes = valueKeyframesAsList.length;
            var createGenerator = (0, _motionDom.isGenerator)(type) ? type : generators === null || generators === void 0 ? void 0 : generators[type || "keyframes"];
            if (numKeyframes <= 2 && createGenerator) {
                /**
                 * As we're creating an easing function from a spring,
                 * ideally we want to generate it using the real distance
                 * between the two keyframes. However this isn't always
                 * possible - in these situations we use 0-100.
                 */ var absoluteDelta = 100;
                if (numKeyframes === 2 && isNumberKeyframesArray(valueKeyframesAsList)) {
                    var delta = valueKeyframesAsList[1] - valueKeyframesAsList[0];
                    absoluteDelta = Math.abs(delta);
                }
                var springTransition = (0, _objectSpread._)({}, defaultTransition, remainingTransition);
                if (duration !== undefined) springTransition.duration = (0, _motionUtils.secondsToMilliseconds)(duration);
                var springEasing = (0, _motionDom.createGeneratorEasing)(springTransition, absoluteDelta, createGenerator);
                ease = springEasing.ease;
                duration = springEasing.duration;
            }
            duration !== null && duration !== void 0 ? duration : duration = defaultDuration;
            var startTime = currentTime + calculatedDelay;
            /**
             * If there's only one time offset of 0, fill in a second with length 1
             */ if (times.length === 1 && times[0] === 0) times[1] = 1;
            /**
             * Fill out if offset if fewer offsets than keyframes
             */ var remainder = times.length - valueKeyframesAsList.length;
            remainder > 0 && (0, _motionDom.fillOffset)(times, remainder);
            /**
             * If only one value has been set, ie [1], push a null to the start of
             * the keyframe array. This will let us mark a keyframe at this point
             * that will later be hydrated with the previous value.
             */ valueKeyframesAsList.length === 1 && valueKeyframesAsList.unshift(null);
            /**
             * Handle repeat options
             */ if (repeat) {
                (0, _motionUtils.invariant)(repeat < MAX_REPEAT, "Repeat count too high, must be less than 20", "repeat-count-high");
                duration = (0, _calcRepeatDurationMjs.calculateRepeatDuration)(duration, repeat);
                var originalKeyframes = (0, _toConsumableArray._)(valueKeyframesAsList);
                var originalTimes = (0, _toConsumableArray._)(times);
                ease = Array.isArray(ease) ? (0, _toConsumableArray._)(ease) : [
                    ease
                ];
                var originalEase = (0, _toConsumableArray._)(ease);
                for(var repeatIndex = 0; repeatIndex < repeat; repeatIndex++){
                    var _valueKeyframesAsList;
                    (_valueKeyframesAsList = valueKeyframesAsList).push.apply(_valueKeyframesAsList, (0, _toConsumableArray._)(originalKeyframes));
                    for(var keyframeIndex = 0; keyframeIndex < originalKeyframes.length; keyframeIndex++){
                        times.push(originalTimes[keyframeIndex] + (repeatIndex + 1));
                        ease.push(keyframeIndex === 0 ? "linear" : (0, _motionUtils.getEasingForSegment)(originalEase, keyframeIndex - 1));
                    }
                }
                (0, _normalizeTimesMjs.normalizeTimes)(times, repeat);
            }
            var targetTime = startTime + duration;
            /**
             * Add keyframes, mapping offsets to absolute time.
             */ (0, _editMjs.addKeyframes)(valueSequence, valueKeyframesAsList, ease, times, startTime, targetTime);
            maxDuration = Math.max(calculatedDelay + duration, maxDuration);
            totalDuration = Math.max(targetTime, totalDuration);
        };
        if ((0, _motionDom.isMotionValue)(subject)) {
            var subjectSequence = getSubjectSequence(subject, sequences);
            resolveValueSequence(keyframes, transition, getValueSequence("default", subjectSequence));
        } else {
            var subjects = (0, _resolveSubjectsMjs.resolveSubjects)(subject, keyframes, scope, elementCache);
            var numSubjects = subjects.length;
            /**
             * For every element in this segment, process the defined values.
             */ for(var subjectIndex = 0; subjectIndex < numSubjects; subjectIndex++){
                /**
                 * Cast necessary, but we know these are of this type
                 */ keyframes;
                transition;
                var thisSubject = subjects[subjectIndex];
                var subjectSequence1 = getSubjectSequence(thisSubject, sequences);
                for(var key in keyframes)resolveValueSequence(keyframes[key], getValueTransition(transition, key), getValueSequence(key, subjectSequence1), subjectIndex, numSubjects);
            }
        }
        prevTime = currentTime;
        currentTime += maxDuration;
    };
    var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, scope = arguments.length > 2 ? arguments[2] : void 0, generators = arguments.length > 3 ? arguments[3] : void 0;
    var _param_defaultTransition = _param.defaultTransition, defaultTransition = _param_defaultTransition === void 0 ? {} : _param_defaultTransition, sequenceTransition = (0, _objectWithoutProperties._)(_param, [
        "defaultTransition"
    ]);
    var defaultDuration = defaultTransition.duration || 0.3;
    var animationDefinitions = new Map();
    var sequences = new Map();
    var elementCache = {};
    var timeLabels = new Map();
    var prevTime = 0;
    var currentTime = 0;
    var totalDuration = 0;
    /**
     * Build the timeline by mapping over the sequence array and converting
     * the definitions into keyframes and offsets with absolute time values.
     * These will later get converted into relative offsets in a second pass.
     */ for(var i = 0; i < sequence.length; i++)_loop(i);
    /**
     * For every element and value combination create a new animation.
     */ sequences.forEach(function(valueSequences, element) {
        for(var _ref in valueSequences){
            var key = _ref;
            var valueSequence = valueSequences[key];
            /**
             * Arrange all the keyframes in ascending time order.
             */ valueSequence.sort((0, _sortMjs.compareByTime));
            var keyframes = [];
            var valueOffset = [];
            var valueEasing = [];
            /**
             * For each keyframe, translate absolute times into
             * relative offsets based on the total duration of the timeline.
             */ for(var i = 0; i < valueSequence.length; i++){
                var _valueSequence_i = valueSequence[i], at = _valueSequence_i.at, value = _valueSequence_i.value, easing = _valueSequence_i.easing;
                keyframes.push(value);
                valueOffset.push((0, _motionUtils.progress)(0, totalDuration, at));
                valueEasing.push(easing || "easeOut");
            }
            /**
             * If the first keyframe doesn't land on offset: 0
             * provide one by duplicating the initial keyframe. This ensures
             * it snaps to the first keyframe when the animation starts.
             */ if (valueOffset[0] !== 0) {
                valueOffset.unshift(0);
                keyframes.unshift(keyframes[0]);
                valueEasing.unshift(defaultSegmentEasing);
            }
            /**
             * If the last keyframe doesn't land on offset: 1
             * provide one with a null wildcard value. This will ensure it
             * stays static until the end of the animation.
             */ if (valueOffset[valueOffset.length - 1] !== 1) {
                valueOffset.push(1);
                keyframes.push(null);
            }
            if (!animationDefinitions.has(element)) animationDefinitions.set(element, {
                keyframes: {},
                transition: {}
            });
            var definition = animationDefinitions.get(element);
            definition.keyframes[key] = keyframes;
            /**
             * Exclude `type` from defaultTransition since springs have been
             * converted to duration-based easing functions in resolveValueSequence.
             * Including `type: "spring"` would cause JSAnimation to error when
             * the merged keyframes array has more than 2 keyframes.
             */ var _type = defaultTransition.type, remainingDefaultTransition = (0, _objectWithoutProperties._)(defaultTransition, [
                "type"
            ]);
            definition.transition[key] = (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, remainingDefaultTransition), {
                duration: totalDuration,
                ease: valueEasing,
                times: valueOffset
            }), sequenceTransition);
        }
    });
    return animationDefinitions;
}
function getSubjectSequence(subject, sequences) {
    !sequences.has(subject) && sequences.set(subject, {});
    return sequences.get(subject);
}
function getValueSequence(name, sequences) {
    if (!sequences[name]) sequences[name] = [];
    return sequences[name];
}
function keyframesAsList(keyframes) {
    return Array.isArray(keyframes) ? keyframes : [
        keyframes
    ];
}
function getValueTransition(transition, key) {
    return transition && transition[key] ? (0, _objectSpread._)({}, transition, transition[key]) : (0, _objectSpread._)({}, transition);
}
var isNumber = function(keyframe) {
    return typeof keyframe === "number";
};
var isNumberKeyframesArray = function(keyframes) {
    return keyframes.every(isNumber);
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_to_consumable_array":"1eSZf","motion-dom":"kgVDX","motion-utils":"9Q5qC","../animate/resolve-subjects.mjs":"22mWj","./utils/calc-repeat-duration.mjs":"eRXT0","./utils/calc-time.mjs":"jSyD6","./utils/edit.mjs":"5Vf5R","./utils/normalize-times.mjs":"4CFZt","./utils/sort.mjs":"a5waQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"22mWj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveSubjects", function() {
    return resolveSubjects;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
var _motionDom = require("motion-dom");
var _isDomKeyframesMjs = require("../utils/is-dom-keyframes.mjs");
function resolveSubjects(subject, keyframes, scope, selectorCache) {
    if (subject == null) return [];
    if (typeof subject === "string" && (0, _isDomKeyframesMjs.isDOMKeyframes)(keyframes)) return (0, _motionDom.resolveElements)(subject, scope, selectorCache);
    else if ((0, _instanceof._)(subject, NodeList)) return Array.from(subject);
    else if (Array.isArray(subject)) return subject.filter(function(s) {
        return s != null;
    });
    else return [
        subject
    ];
}

},{"@swc/helpers/_/_instanceof":"h9UKc","motion-dom":"kgVDX","../utils/is-dom-keyframes.mjs":"7G5I5","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7G5I5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isDOMKeyframes", function() {
    return isDOMKeyframes;
});
var _typeOf = require("@swc/helpers/_/_type_of");
function isDOMKeyframes(keyframes) {
    return (typeof keyframes === "undefined" ? "undefined" : (0, _typeOf._)(keyframes)) === "object" && !Array.isArray(keyframes);
}

},{"@swc/helpers/_/_type_of":"iFJdx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eRXT0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateRepeatDuration", function() {
    return calculateRepeatDuration;
});
function calculateRepeatDuration(duration, repeat, _repeatDelay) {
    return duration * (repeat + 1);
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jSyD6":[function(require,module,exports,__globalThis) {
/**
 * Given a absolute or relative time definition and current/prev time state of the sequence,
 * calculate an absolute time for the next keyframes.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calcNextTime", function() {
    return calcNextTime;
});
function calcNextTime(current, next, prev, labels) {
    var _labels_get;
    if (typeof next === "number") return next;
    else if (next.startsWith("-") || next.startsWith("+")) return Math.max(0, current + parseFloat(next));
    else if (next === "<") return prev;
    else if (next.startsWith("<")) return Math.max(0, prev + parseFloat(next.slice(1)));
    else return (_labels_get = labels.get(next)) !== null && _labels_get !== void 0 ? _labels_get : current;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5Vf5R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addKeyframes", function() {
    return addKeyframes;
});
parcelHelpers.export(exports, "eraseKeyframes", function() {
    return eraseKeyframes;
});
var _motionDom = require("motion-dom");
var _motionUtils = require("motion-utils");
function eraseKeyframes(sequence, startTime, endTime) {
    for(var i = 0; i < sequence.length; i++){
        var keyframe = sequence[i];
        if (keyframe.at > startTime && keyframe.at < endTime) {
            (0, _motionUtils.removeItem)(sequence, keyframe);
            // If we remove this item we have to push the pointer back one
            i--;
        }
    }
}
function addKeyframes(sequence, keyframes, easing, offset, startTime, endTime) {
    /**
     * Erase every existing value between currentTime and targetTime,
     * this will essentially splice this timeline into any currently
     * defined ones.
     */ eraseKeyframes(sequence, startTime, endTime);
    for(var i = 0; i < keyframes.length; i++)sequence.push({
        value: keyframes[i],
        at: (0, _motionDom.mixNumber)(startTime, endTime, offset[i]),
        easing: (0, _motionUtils.getEasingForSegment)(easing, i)
    });
}

},{"motion-dom":"kgVDX","motion-utils":"9Q5qC","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4CFZt":[function(require,module,exports,__globalThis) {
/**
 * Take an array of times that represent repeated keyframes. For instance
 * if we have original times of [0, 0.5, 1] then our repeated times will
 * be [0, 0.5, 1, 1, 1.5, 2]. Loop over the times and scale them back
 * down to a 0-1 scale.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "normalizeTimes", function() {
    return normalizeTimes;
});
function normalizeTimes(times, repeat) {
    for(var i = 0; i < times.length; i++)times[i] = times[i] / (repeat + 1);
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"a5waQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "compareByTime", function() {
    return compareByTime;
});
function compareByTime(a, b) {
    if (a.at === b.at) {
        if (a.value === null) return 1;
        if (b.value === null) return -1;
        return 0;
    } else return a.at - b.at;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hKitk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animateSubject", function() {
    return animateSubject;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _motionDom = require("motion-dom");
var _motionUtils = require("motion-utils");
var _createVisualElementMjs = require("../utils/create-visual-element.mjs");
var _isDomKeyframesMjs = require("../utils/is-dom-keyframes.mjs");
var _resolveSubjectsMjs = require("./resolve-subjects.mjs");
function isSingleValue(subject, keyframes) {
    return (0, _motionDom.isMotionValue)(subject) || typeof subject === "number" || typeof subject === "string" && !(0, _isDomKeyframesMjs.isDOMKeyframes)(keyframes);
}
/**
 * Implementation
 */ function animateSubject(subject, keyframes, options, scope) {
    var animations = [];
    if (isSingleValue(subject, keyframes)) animations.push((0, _motionDom.animateSingleValue)(subject, (0, _isDomKeyframesMjs.isDOMKeyframes)(keyframes) ? keyframes.default || keyframes : keyframes, options ? options.default || options : options));
    else {
        // Gracefully handle null/undefined subjects (e.g., from querySelector returning null)
        if (subject == null) return animations;
        var subjects = (0, _resolveSubjectsMjs.resolveSubjects)(subject, keyframes, scope);
        var numSubjects = subjects.length;
        (0, _motionUtils.invariant)(Boolean(numSubjects), "No valid elements provided.", "no-valid-elements");
        for(var i = 0; i < numSubjects; i++){
            var _animations;
            var thisSubject = subjects[i];
            var createVisualElement = (0, _instanceof._)(thisSubject, Element) ? (0, _createVisualElementMjs.createDOMVisualElement) : (0, _createVisualElementMjs.createObjectVisualElement);
            if (!(0, _motionDom.visualElementStore).has(thisSubject)) createVisualElement(thisSubject);
            var visualElement = (0, _motionDom.visualElementStore).get(thisSubject);
            var transition = (0, _objectSpread._)({}, options);
            /**
             * Resolve stagger function if provided.
             */ if ("delay" in transition && typeof transition.delay === "function") transition.delay = transition.delay(i, numSubjects);
            (_animations = animations).push.apply(_animations, (0, _toConsumableArray._)((0, _motionDom.animateTarget)(visualElement, (0, _objectSpreadProps._)((0, _objectSpread._)({}, keyframes), {
                transition: transition
            }), {})));
        }
    }
    return animations;
}

},{"@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_to_consumable_array":"1eSZf","motion-dom":"kgVDX","motion-utils":"9Q5qC","../utils/create-visual-element.mjs":"9iv4n","../utils/is-dom-keyframes.mjs":"7G5I5","./resolve-subjects.mjs":"22mWj","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9iv4n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createDOMVisualElement", function() {
    return createDOMVisualElement;
});
parcelHelpers.export(exports, "createObjectVisualElement", function() {
    return createObjectVisualElement;
});
var _motionDom = require("motion-dom");
function createDOMVisualElement(element) {
    var options = {
        presenceContext: null,
        props: {},
        visualState: {
            renderState: {
                transform: {},
                transformOrigin: {},
                style: {},
                vars: {},
                attrs: {}
            },
            latestValues: {}
        }
    };
    var node = (0, _motionDom.isSVGElement)(element) && !(0, _motionDom.isSVGSVGElement)(element) ? new (0, _motionDom.SVGVisualElement)(options) : new (0, _motionDom.HTMLVisualElement)(options);
    node.mount(element);
    (0, _motionDom.visualElementStore).set(element, node);
}
function createObjectVisualElement(subject) {
    var options = {
        presenceContext: null,
        props: {},
        visualState: {
            renderState: {
                output: {}
            },
            latestValues: {}
        }
    };
    var node = new (0, _motionDom.ObjectVisualElement)(options);
    node.mount(subject);
    (0, _motionDom.visualElementStore).set(subject, node);
}

},{"motion-dom":"kgVDX","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eteNK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSectionReveal", function() {
    return useSectionReveal;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _react = require("react");
var _bindEventListener = require("bind-event-listener");
var _browserApis = require("@atlaskit/browser-apis");
var _useUserContext = require("../../../hooks/use-user-context");
var _attribution = require("../attribution");
var _useAnalyticsEvents = require("../generated/use-analytics-events");
var DEFAULT_DWELL_THRESHOLD_MS = 1500;
var DEFAULT_INTERSECTION_THRESHOLD = 0.5;
var useSectionReveal = function(sectionName) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _options_threshold = options.threshold, threshold = _options_threshold === void 0 ? DEFAULT_INTERSECTION_THRESHOLD : _options_threshold, onReveal = options.onReveal, _options_dwellThresholdMs = options.dwellThresholdMs, dwellThresholdMs = _options_dwellThresholdMs === void 0 ? DEFAULT_DWELL_THRESHOLD_MS : _options_dwellThresholdMs;
    var isAuthed = (0, _useUserContext.useAtlassianUserContext)().isAuthed;
    var authState = isAuthed ? 'loggedIn' : 'loggedOut';
    var fireEvent = (0, _useAnalyticsEvents.useAnalyticsEvents)().fireEvent;
    var revealFiredRef = (0, _react.useRef)(false);
    var dwellFiredRef = (0, _react.useRef)(false);
    var visibleSinceMsRef = (0, _react.useRef)(null);
    var dwellTimerRef = (0, _react.useRef)(null);
    var observerRef = (0, _react.useRef)(null);
    // Hold the latest `onReveal` in a ref so swapping callbacks across
    // renders doesn't tear down + rebuild the IntersectionObserver.
    var onRevealRef = (0, _react.useRef)(onReveal);
    (0, _react.useEffect)(function() {
        onRevealRef.current = onReveal;
    }, [
        onReveal
    ]);
    // Hold the latest `authState` in a ref for the same reason.
    var authStateRef = (0, _react.useRef)(authState);
    (0, _react.useEffect)(function() {
        authStateRef.current = authState;
    }, [
        authState
    ]);
    // Cancel any in-flight dwell timer when the page is hidden so a
    // backgrounded tab doesn't accumulate spurious dwell.
    (0, _react.useEffect)(function() {
        if (dwellThresholdMs <= 0) return;
        var doc = (0, _browserApis.getDocument)();
        if (!doc) return;
        var onVisibilityChange = function() {
            if (doc.visibilityState === 'hidden' && dwellTimerRef.current !== null) {
                clearTimeout(dwellTimerRef.current);
                dwellTimerRef.current = null;
                visibleSinceMsRef.current = null;
            }
        };
        var unbind = (0, _bindEventListener.bind)(doc, {
            type: 'visibilitychange',
            listener: onVisibilityChange
        });
        return function() {
            unbind();
        };
    }, [
        dwellThresholdMs
    ]);
    return (0, _react.useCallback)(function(node) {
        // Detach + re-arm the previous observer when the host node
        // changes (or unmounts).
        if (observerRef.current) {
            observerRef.current.disconnect();
            observerRef.current = null;
        }
        if (dwellTimerRef.current !== null) {
            clearTimeout(dwellTimerRef.current);
            dwellTimerRef.current = null;
        }
        visibleSinceMsRef.current = null;
        // If both events have already fired, no need to re-observe.
        var dwellEnabled = dwellThresholdMs > 0;
        var allDone = revealFiredRef.current && (!dwellEnabled || dwellFiredRef.current);
        if (node === null || allDone) return;
        // IntersectionObserver may be missing in older test envs; bail out
        // silently rather than crashing the component.
        if (typeof IntersectionObserver === 'undefined') return;
        var fireDwell = function() {
            if (dwellFiredRef.current || visibleSinceMsRef.current === null) return;
            var dwellMs = Math.max(0, Date.now() - visibleSinceMsRef.current);
            dwellFiredRef.current = true;
            fireEvent('ui.section.dwelled.twgMicrositeSection', (0, _objectSpread._)({
                sectionName: sectionName,
                dwellMs: dwellMs,
                authState: authStateRef.current
            }, (0, _attribution.getAttribution)()));
            // If reveal also already fired, we're done — disconnect.
            if (revealFiredRef.current && observerRef.current) {
                observerRef.current.disconnect();
                observerRef.current = null;
            }
        };
        var io = new IntersectionObserver(function(entries) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var entry = _step.value;
                    if (entry.isIntersecting) {
                        // Reveal — fires on first intersection.
                        if (!revealFiredRef.current) {
                            var _onRevealRef_current;
                            revealFiredRef.current = true;
                            var currentAuthState = authStateRef.current;
                            fireEvent('ui.section.revealed.twgMicrositeSection', {
                                sectionName: sectionName,
                                authState: currentAuthState
                            });
                            (_onRevealRef_current = onRevealRef.current) === null || _onRevealRef_current === void 0 ? void 0 : _onRevealRef_current.call(onRevealRef, currentAuthState);
                            // If dwell is disabled and reveal just fired,
                            // we can disconnect immediately.
                            if (!dwellEnabled) {
                                io.disconnect();
                                observerRef.current = null;
                                return;
                            }
                        }
                        // Dwell — start the visibility timer.
                        if (dwellEnabled && !dwellFiredRef.current && visibleSinceMsRef.current === null) {
                            visibleSinceMsRef.current = Date.now();
                            dwellTimerRef.current = setTimeout(fireDwell, dwellThresholdMs);
                        }
                    } else {
                        // Cancel an in-flight dwell timer if the
                        // section drops back below threshold before
                        // the dwell event fires.
                        if (dwellTimerRef.current !== null) {
                            clearTimeout(dwellTimerRef.current);
                            dwellTimerRef.current = null;
                        }
                        visibleSinceMsRef.current = null;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }, {
            threshold: threshold
        });
        io.observe(node);
        observerRef.current = io;
    }, [
        fireEvent,
        sectionName,
        threshold,
        dwellThresholdMs
    ]);
};

},{"@swc/helpers/_/_object_spread":"9gdrV","react":"ltHCL","bind-event-listener":"bjeUU","@atlaskit/browser-apis":"2dayt","../../../hooks/use-user-context":"6Qevx","../attribution":"dTmHb","../generated/use-analytics-events":"hpATH","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gGuWC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getNearestScrollContainer", function() {
    return getNearestScrollContainer;
});
var _browserApis = require("@atlaskit/browser-apis");
var scrollableOverflowValues = new Set([
    'auto',
    'scroll',
    'overlay'
]);
var SCROLL_RANGE_EPSILON = 1;
function canScrollVertically(element) {
    return element.scrollHeight - element.clientHeight > SCROLL_RANGE_EPSILON;
}
function getNearestScrollContainer(node) {
    var doc = (0, _browserApis.getDocument)();
    var win = doc === null || doc === void 0 ? void 0 : doc.defaultView;
    if (!node || !doc || !win) return null;
    var parent = node.parentElement;
    while(parent && parent !== doc.body && parent !== doc.documentElement){
        var styles = win.getComputedStyle(parent);
        var hasScrollableOverflow = scrollableOverflowValues.has(styles.overflowY) || scrollableOverflowValues.has(styles.overflow);
        if (hasScrollableOverflow && canScrollVertically(parent)) return parent;
        parent = parent.parentElement;
    }
    return null;
}

},{"@atlaskit/browser-apis":"2dayt","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hT62j":[function(require,module,exports,__globalThis) {
/* BackgroundIcons.tsx generated by @compiled/babel-plugin v0.39.1 */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable @atlaskit/design-system/use-tokens-shape */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BackgroundIcons", function() {
    return BackgroundIcons;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _reactIntl = require("react-intl");
var _new = require("@atlaskit/lozenge/new");
var _newDefault = parcelHelpers.interopDefault(_new);
var _edges = require("./edges");
var _layout = require("./layout");
var _messages = require("./messages");
var _useHeroMotion = require("./use-hero-motion");
var EDGE_COLOR = '#FFFFFF';
var EDGE_DASH = '1 3';
var LABEL_LOZENGE_SPECS = {
    'status-done': {
        appearance: 'accent-green'
    },
    'status-on-track': {
        appearance: 'accent-blue'
    },
    'status-to-do': {
        appearance: 'accent-gray'
    },
    'status-at-risk': {
        appearance: 'accent-yellow'
    }
};
var styles = {
    root: "_uiztglyw",
    edgeSvg: "_1r04idpf _1reoewfl _18m9ewfl _kqswstnw _1bsb1osq _4t3i1osq _lcxvglyw",
    icon: "_kqswstnw _4t3i1wug _uiztglyw _m6k41rjc _t9ec1ooe",
    interactiveIcon: "_80om1qgj _1tktglyw _1qam5szm",
    passiveIcon: "_lcxvglyw",
    labelIcon: "_1e0c1txw _4cvr1h6o _1bah1h6o _o5721q9c",
    avatarIcon: "_2rko1ssb _1e0c1txw _4cvr1h6o _1bah1h6o _16qsioq4 _syazalr3 _ect41jf4 _k48pni7l _1wybdlk8",
    shimmerGroup: "_1o2w1lyw"
};
function BackgroundIcons(param) {
    var stageRef = param.stageRef, introDone = param.introDone, onIntroComplete = param.onIntroComplete, replayHandleRef = param.replayHandleRef, edgeParams = param.edges, layoutParams = param.layout, ambientParams = param.ambient, physicsParams = param.physics, introParams = param.intro, shimmerParams = param.shimmer, viewportTier = param.viewportTier, interactive = param.interactive, motionFrozen = param.motionFrozen;
    var formatMessage = (0, _reactIntl.useIntl)().formatMessage;
    var iconElsRef = (0, _react.useRef)(new Map());
    var edgeElsRef = (0, _react.useRef)(new Map());
    var shimmerSlotsRef = (0, _react.useRef)([]);
    var shimmerGradsRef = (0, _react.useRef)([]);
    var shimmerPoolSize = Math.max(1, Math.round(shimmerParams.maxConcurrent));
    var resolvedLayout = (0, _react.useMemo)(function() {
        return (0, _layout.getHeroLayout)((0, _objectSpread._)({
            viewportTier: viewportTier
        }, layoutParams));
    }, [
        layoutParams,
        viewportTier
    ]);
    var layoutAssets = resolvedLayout.assets;
    var referenceSize = (0, _react.useMemo)(function() {
        return {
            width: resolvedLayout.referenceWidth,
            height: resolvedLayout.referenceHeight
        };
    }, [
        resolvedLayout.referenceHeight,
        resolvedLayout.referenceWidth
    ]);
    var assetById = (0, _react.useMemo)(function() {
        return new Map(layoutAssets.map(function(asset) {
            return [
                asset.id,
                asset
            ];
        }));
    }, [
        layoutAssets
    ]);
    var edges = (0, _react.useMemo)(function() {
        return (0, _edges.buildEdgesForAssets)(layoutAssets, edgeParams.density, edgeParams.radius, resolvedLayout.textSafeArea, referenceSize);
    }, [
        edgeParams.density,
        edgeParams.radius,
        layoutAssets,
        referenceSize,
        resolvedLayout.textSafeArea
    ]);
    var handleIntroComplete = (0, _react.useCallback)(function() {
        return onIntroComplete();
    }, [
        onIntroComplete
    ]);
    var replayIntro = (0, _useHeroMotion.useHeroMotion)({
        ambientAmp: ambientParams.ambientAmp,
        dynamics: {
            kSelf: physicsParams.kSelf,
            kEdge: physicsParams.kEdge,
            damping: physicsParams.damping,
            maxDt: 1 / 30,
            substeps: 2
        },
        flick: physicsParams.flick,
        intro: introParams,
        edgeOpacity: edgeParams.opacity,
        shimmer: (0, _objectSpreadProps._)((0, _objectSpread._)({}, shimmerParams), {
            maxConcurrent: shimmerPoolSize
        }),
        interactive: interactive,
        motionFrozen: motionFrozen,
        onIntroComplete: handleIntroComplete
    }, {
        stage: stageRef,
        icons: iconElsRef,
        edges: edgeElsRef,
        shimmerSlots: shimmerSlotsRef,
        shimmerGrads: shimmerGradsRef
    }, edges, layoutAssets, resolvedLayout.motionOrigin, referenceSize).replayIntro;
    (0, _react.useEffect)(function() {
        replayHandleRef.current = replayIntro;
    }, [
        replayHandleRef,
        replayIntro
    ]);
    var labelMessages = {
        'status-done': formatMessage((0, _messages.messages).statusDone),
        'status-on-track': formatMessage((0, _messages.messages).statusOnTrack),
        'status-to-do': formatMessage((0, _messages.messages).statusToDo),
        'status-at-risk': formatMessage((0, _messages.messages).statusAtRisk)
    };
    return /*#__PURE__*/ _react.createElement("div", {
        "aria-hidden": "true",
        className: (0, _runtime.ax)([
            styles.root
        ])
    }, /*#__PURE__*/ _react.createElement("svg", {
        viewBox: "0 0 ".concat(resolvedLayout.referenceWidth, " ").concat(resolvedLayout.referenceHeight),
        preserveAspectRatio: "none",
        "aria-hidden": "true",
        className: (0, _runtime.ax)([
            styles.edgeSvg
        ])
    }, /*#__PURE__*/ _react.createElement("g", null, edges.map(function(edge, i) {
        var a = assetById.get(edge.from);
        var b = assetById.get(edge.to);
        if (!a || !b) return null;
        var x1 = a.x * resolvedLayout.referenceWidth;
        var y1 = a.y * resolvedLayout.referenceHeight;
        var x2 = b.x * resolvedLayout.referenceWidth;
        var y2 = b.y * resolvedLayout.referenceHeight;
        var edgeId = "".concat(edge.from, "__").concat(edge.to, "__").concat(i);
        var edgeRenderKey = [
            edgeId,
            x1.toFixed(2),
            y1.toFixed(2),
            x2.toFixed(2),
            y2.toFixed(2)
        ].join(':');
        return /*#__PURE__*/ _react.createElement("line", {
            key: edgeRenderKey,
            ref: function(el) {
                if (el) edgeElsRef.current.set(edgeId, {
                    el: el,
                    edgeId: edgeId,
                    from: edge.from,
                    to: edge.to,
                    baseX1: x1,
                    baseY1: y1,
                    baseX2: x2,
                    baseY2: y2,
                    liveX1: x1,
                    liveY1: y1,
                    liveX2: x2,
                    liveY2: y2
                });
                else edgeElsRef.current.delete(edgeId);
            },
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2,
            stroke: EDGE_COLOR,
            strokeOpacity: introDone ? edgeParams.opacity : 0,
            strokeWidth: 1,
            strokeDasharray: EDGE_DASH,
            vectorEffect: "non-scaling-stroke"
        });
    })), /*#__PURE__*/ _react.createElement("defs", null, Array.from({
        length: shimmerPoolSize
    }).map(function(_, i) {
        return /*#__PURE__*/ _react.createElement("linearGradient", {
            key: i,
            id: "hero-shimmer-".concat(i),
            ref: function(el) {
                shimmerGradsRef.current[i] = el;
            },
            gradientUnits: "userSpaceOnUse"
        }, /*#__PURE__*/ _react.createElement("stop", {
            offset: "0",
            stopColor: EDGE_COLOR,
            stopOpacity: "0"
        }), /*#__PURE__*/ _react.createElement("stop", {
            offset: "0.3",
            stopColor: EDGE_COLOR,
            stopOpacity: "1"
        }), /*#__PURE__*/ _react.createElement("stop", {
            offset: "0.7",
            stopColor: EDGE_COLOR,
            stopOpacity: "1"
        }), /*#__PURE__*/ _react.createElement("stop", {
            offset: "1",
            stopColor: EDGE_COLOR,
            stopOpacity: "0"
        }));
    })), /*#__PURE__*/ _react.createElement("g", {
        style: {
            filter: !motionFrozen && shimmerParams.glow > 0 ? "blur(".concat(shimmerParams.glow, "px)") : undefined
        },
        className: (0, _runtime.ax)([
            styles.shimmerGroup
        ])
    }, Array.from({
        length: shimmerPoolSize
    }).map(function(_, i) {
        return /*#__PURE__*/ _react.createElement("line", {
            key: i,
            ref: function(el) {
                shimmerSlotsRef.current[i] = el;
            },
            stroke: "url(#hero-shimmer-".concat(i, ")"),
            strokeWidth: shimmerParams.strokeWidth,
            strokeLinecap: "round",
            strokeOpacity: 0,
            strokeDasharray: EDGE_DASH,
            vectorEffect: "non-scaling-stroke"
        });
    }))), layoutAssets.map(function(asset) {
        var _labelMessages_asset_id, _ref;
        return /*#__PURE__*/ _react.createElement(HeroAssetNode, {
            key: asset.id,
            asset: asset,
            iconElsRef: iconElsRef,
            interactive: interactive,
            introDone: introDone,
            label: (_ref = (_labelMessages_asset_id = labelMessages[asset.id]) !== null && _labelMessages_asset_id !== void 0 ? _labelMessages_asset_id : asset.alt) !== null && _ref !== void 0 ? _ref : asset.id,
            referenceWidth: resolvedLayout.referenceWidth,
            viewportTier: viewportTier
        });
    }));
}
function HeroAssetNode(param) {
    var asset = param.asset, iconElsRef = param.iconElsRef, interactive = param.interactive, introDone = param.introDone, label = param.label, referenceWidth = param.referenceWidth, viewportTier = param.viewportTier;
    var commonStyle = {
        left: "".concat(asset.x * 100, "%"),
        top: "".concat(asset.y * 100, "%"),
        opacity: introDone ? 1 : 0
    };
    var setIconRef = function(el) {
        if (el) iconElsRef.current.set(asset.id, el);
        else iconElsRef.current.delete(asset.id);
    };
    if (asset.kind === 'label') {
        var _LABEL_LOZENGE_SPECS_asset_id;
        var spec = (_LABEL_LOZENGE_SPECS_asset_id = LABEL_LOZENGE_SPECS[asset.id]) !== null && _LABEL_LOZENGE_SPECS_asset_id !== void 0 ? _LABEL_LOZENGE_SPECS_asset_id : {
            appearance: 'accent-gray'
        };
        var lozengeScale = viewportTier === 'mobile' ? (0, _layout.MOBILE_ICON_SCALE) : 1;
        return /*#__PURE__*/ _react.createElement("span", {
            id: asset.id,
            ref: setIconRef,
            "data-asset-id": asset.id,
            "data-asset-kind": asset.kind,
            style: (0, _objectSpreadProps._)((0, _objectSpread._)({}, commonStyle), {
                minWidth: "".concat(asset.width * referenceWidth, "px")
            }),
            className: (0, _runtime.ax)([
                styles.icon,
                interactive ? styles.interactiveIcon : styles.passiveIcon,
                styles.labelIcon
            ])
        }, /*#__PURE__*/ _react.createElement("span", {
            style: {
                transform: lozengeScale === 1 ? undefined : "scale(".concat(lozengeScale, ")"),
                transformOrigin: 'center'
            }
        }, /*#__PURE__*/ _react.createElement((0, _newDefault.default), {
            appearance: spec.appearance,
            spacing: "spacious"
        }, label)));
    }
    if (asset.kind === 'avatar') {
        var avatarSize = asset.width * referenceWidth;
        if (asset.src) return /*#__PURE__*/ _react.createElement("img", {
            id: asset.id,
            ref: setIconRef,
            "data-asset-id": asset.id,
            "data-asset-kind": asset.kind,
            src: asset.src,
            alt: "",
            decoding: "async",
            draggable: false,
            loading: "eager",
            style: (0, _objectSpreadProps._)((0, _objectSpread._)({}, commonStyle), {
                width: "".concat(avatarSize, "px"),
                height: "".concat(avatarSize, "px"),
                objectFit: 'cover'
            }),
            className: (0, _runtime.ax)([
                styles.icon,
                interactive ? styles.interactiveIcon : styles.passiveIcon,
                styles.avatarIcon
            ])
        });
        return /*#__PURE__*/ _react.createElement("span", {
            id: asset.id,
            ref: setIconRef,
            "data-asset-id": asset.id,
            "data-asset-kind": asset.kind,
            style: (0, _objectSpreadProps._)((0, _objectSpread._)({}, commonStyle), {
                width: "".concat(avatarSize, "px"),
                height: "".concat(avatarSize, "px"),
                backgroundColor: getAvatarColor(asset.id)
            }),
            className: (0, _runtime.ax)([
                styles.icon,
                interactive ? styles.interactiveIcon : styles.passiveIcon,
                styles.avatarIcon
            ])
        }, getAvatarInitials(asset.id));
    }
    if (!asset.src) return null;
    return /*#__PURE__*/ _react.createElement("img", {
        id: asset.id,
        ref: setIconRef,
        "data-asset-id": asset.id,
        "data-asset-kind": asset.kind,
        src: asset.src,
        alt: "",
        decoding: "async",
        draggable: false,
        loading: "eager",
        style: (0, _objectSpreadProps._)((0, _objectSpread._)({}, commonStyle), {
            width: "".concat(asset.width * 100, "%")
        }),
        className: (0, _runtime.ax)([
            styles.icon,
            interactive ? styles.interactiveIcon : styles.passiveIcon
        ])
    });
}
var AVATAR_COLORS = [
    '#B3DF72',
    '#9F8FEF',
    '#7AB2FF',
    '#F5CD47',
    '#FFA364',
    '#6CC3E0'
];
function getAvatarColor(id) {
    var sum = 0;
    for(var i = 0; i < id.length; i++)sum += id.charCodeAt(i);
    return AVATAR_COLORS[sum % AVATAR_COLORS.length];
}
function getAvatarInitials(id) {
    var name = id.replace(/^avatar-/, '');
    return name.split('-').filter(Boolean).slice(0, 2).map(function(part) {
        var _part_;
        var _part__toUpperCase;
        return (_part__toUpperCase = (_part_ = part[0]) === null || _part_ === void 0 ? void 0 : _part_.toUpperCase()) !== null && _part__toUpperCase !== void 0 ? _part__toUpperCase : '';
    }).join('');
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","@compiled/react/runtime":"d27Vo","react-intl":"f41fF","@atlaskit/lozenge/new":"h9U8G","./edges":"3ySab","./layout":"aOTT1","./messages":"5rf9o","./use-hero-motion":"47Z1w","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"h9U8G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return 0, _lozengeDefault.default;
});
var _lozenge = require("./lozenge");
var _lozengeDefault = parcelHelpers.interopDefault(_lozenge);

},{"./lozenge":"3TPb8","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3ySab":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildEdgesForAssets", function() {
    return buildEdgesForAssets;
});
parcelHelpers.export(exports, "buildEdges", function() {
    return buildEdges;
});
var _layout = require("./layout");
/** Number of points sampled along a segment when checking rect intersection. */ var SEGMENT_SAMPLES = 16;
var toRefPoint = function(asset, referenceSize) {
    return {
        x: asset.x * referenceSize.width,
        y: asset.y * referenceSize.height
    };
};
var pointInRect = function(p, textSafeArea) {
    return p.x >= textSafeArea.x[0] && p.x <= textSafeArea.x[1] && p.y >= textSafeArea.y[0] && p.y <= textSafeArea.y[1];
};
/**
 * True if any point on the segment [a, b] lies inside TEXT_SAFE_AREA.
 * Sampling is sufficient at this scale (~50 nodes, rect with sides 300+px).
 */ var segmentCrossesTextArea = function(a, b, textSafeArea) {
    if (pointInRect(a, textSafeArea) || pointInRect(b, textSafeArea)) return true;
    for(var i = 1; i < SEGMENT_SAMPLES; i++){
        var t = i / SEGMENT_SAMPLES;
        var sample = {
            x: a.x + (b.x - a.x) * t,
            y: a.y + (b.y - a.y) * t
        };
        if (pointInRect(sample, textSafeArea)) return true;
    }
    return false;
};
var distance = function(a, b) {
    var dx = b.x - a.x;
    var dy = b.y - a.y;
    return Math.sqrt(dx * dx + dy * dy);
};
var densityToK = function(density) {
    if (density <= 1) return 2;
    if (density >= 3) return 4;
    return 3;
};
/** Scribbles are decorative — they should float free without any edges. */ var isConnectable = function(asset) {
    return asset.kind !== 'scribble';
};
var buildEdgesForAssets = function(assets, density, maxEdge, textSafeArea, referenceSize) {
    var k = densityToK(density);
    var points = assets.map(function(asset) {
        return toRefPoint(asset, referenceSize);
    });
    var seen = new Set();
    var edges = [];
    for(var i = 0; i < assets.length; i++){
        if (!isConnectable(assets[i])) continue;
        var candidates = [];
        for(var j = 0; j < assets.length; j++){
            if (i === j) continue;
            if (!isConnectable(assets[j])) continue;
            var dist = distance(points[i], points[j]);
            if (dist > maxEdge) continue;
            if (segmentCrossesTextArea(points[i], points[j], textSafeArea)) continue;
            candidates.push({
                index: j,
                dist: dist
            });
        }
        candidates.sort(function(a, b) {
            return a.dist - b.dist;
        });
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = candidates.slice(0, k)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = _step.value, j1 = _step_value.index;
                var a = assets[i].id;
                var b = assets[j1].id;
                var key = a < b ? "".concat(a, "__").concat(b) : "".concat(b, "__").concat(a);
                if (seen.has(key)) continue;
                seen.add(key);
                edges.push({
                    from: a,
                    to: b
                });
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return edges;
};
var buildEdges = function(density, maxEdge) {
    return buildEdgesForAssets((0, _layout.HERO_ASSETS), density, maxEdge, (0, _layout.TEXT_SAFE_AREA), {
        width: (0, _layout.REFERENCE_WIDTH),
        height: (0, _layout.REFERENCE_HEIGHT)
    });
};

},{"./layout":"aOTT1","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aOTT1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "REFERENCE_WIDTH", function() {
    return REFERENCE_WIDTH;
});
parcelHelpers.export(exports, "REFERENCE_HEIGHT", function() {
    return REFERENCE_HEIGHT;
});
parcelHelpers.export(exports, "MOBILE_REFERENCE_WIDTH", function() {
    return MOBILE_REFERENCE_WIDTH;
});
parcelHelpers.export(exports, "MOBILE_REFERENCE_HEIGHT", function() {
    return MOBILE_REFERENCE_HEIGHT;
});
parcelHelpers.export(exports, "MOBILE_ICON_SCALE", function() {
    return MOBILE_ICON_SCALE;
});
parcelHelpers.export(exports, "HERO_ASSETS", function() {
    return HERO_ASSETS;
});
parcelHelpers.export(exports, "TEXT_SAFE_AREA", function() {
    return TEXT_SAFE_AREA;
});
parcelHelpers.export(exports, "MOBILE_TEXT_SAFE_AREA", function() {
    return MOBILE_TEXT_SAFE_AREA;
});
parcelHelpers.export(exports, "findAsset", function() {
    return findAsset;
});
parcelHelpers.export(exports, "MOTION_ORIGIN", function() {
    return MOTION_ORIGIN;
});
parcelHelpers.export(exports, "MOBILE_MOTION_ORIGIN", function() {
    return MOBILE_MOTION_ORIGIN;
});
parcelHelpers.export(exports, "HERO_ASSETS_MOBILE", function() {
    return HERO_ASSETS_MOBILE;
});
parcelHelpers.export(exports, "getHeroLayout", function() {
    return getHeroLayout;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _agents01Svg = require // small blue (1:26243)
("../../../assets/hero-icons/agents/agents-01.svg");
var _agents01SvgDefault = parcelHelpers.interopDefault(_agents01Svg);
var _agents02Svg = require // small orange (1:26249)
("../../../assets/hero-icons/agents/agents-02.svg");
var _agents02SvgDefault = parcelHelpers.interopDefault(_agents02Svg);
var _agents03Svg = require // small purple (1:26261)
("../../../assets/hero-icons/agents/agents-03.svg");
var _agents03SvgDefault = parcelHelpers.interopDefault(_agents03Svg);
var _agents05Svg = require // small yellow (1:26255)
("../../../assets/hero-icons/agents/agents-05.svg");
var _agents05SvgDefault = parcelHelpers.interopDefault(_agents05Svg);
var _agents06Svg = require // large green (1:26267)
("../../../assets/hero-icons/agents/agents-06.svg");
var _agents06SvgDefault = parcelHelpers.interopDefault(_agents06Svg);
var _agents07Svg = require // large yellow (1:26255)
("../../../assets/hero-icons/agents/agents-07.svg");
var _agents07SvgDefault = parcelHelpers.interopDefault(_agents07Svg);
var _agents08Svg = require // large orange (1:26249)
("../../../assets/hero-icons/agents/agents-08.svg");
var _agents08SvgDefault = parcelHelpers.interopDefault(_agents08Svg);
var _agents10Svg = require // large purple (1:26261)
("../../../assets/hero-icons/agents/agents-10.svg");
var _agents10SvgDefault = parcelHelpers.interopDefault(_agents10Svg);
var _agentsSvg = require // small green (1:26267)
("../../../assets/hero-icons/agents/agents.svg");
var _agentsSvgDefault = parcelHelpers.interopDefault(_agentsSvg);
var _asanaSvg = require("../../../assets/hero-icons/apps/asana.svg");
var _asanaSvgDefault = parcelHelpers.interopDefault(_asanaSvg);
var _atlassianBitbucketSvg = require("../../../assets/hero-icons/apps/atlassian-bitbucket.svg");
var _atlassianBitbucketSvgDefault = parcelHelpers.interopDefault(_atlassianBitbucketSvg);
var _atlassianConfluenceSvg = require("../../../assets/hero-icons/apps/atlassian-confluence.svg");
var _atlassianConfluenceSvgDefault = parcelHelpers.interopDefault(_atlassianConfluenceSvg);
var _atlassianFocusSvg = require("../../../assets/hero-icons/apps/atlassian-focus.svg");
var _atlassianFocusSvgDefault = parcelHelpers.interopDefault(_atlassianFocusSvg);
var _atlassianGoalsSvg = require("../../../assets/hero-icons/apps/atlassian-goals.svg");
var _atlassianGoalsSvgDefault = parcelHelpers.interopDefault(_atlassianGoalsSvg);
var _atlassianJiraSvg = require("../../../assets/hero-icons/apps/atlassian-jira.svg");
var _atlassianJiraSvgDefault = parcelHelpers.interopDefault(_atlassianJiraSvg);
var _atlassianJpdSvg = require("../../../assets/hero-icons/apps/atlassian-jpd.svg");
var _atlassianJpdSvgDefault = parcelHelpers.interopDefault(_atlassianJpdSvg);
var _atlassianJsmSvg = require("../../../assets/hero-icons/apps/atlassian-jsm.svg");
var _atlassianJsmSvgDefault = parcelHelpers.interopDefault(_atlassianJsmSvg);
var _atlassianLoomSvg = require("../../../assets/hero-icons/apps/atlassian-loom.svg");
var _atlassianLoomSvgDefault = parcelHelpers.interopDefault(_atlassianLoomSvg);
var _atlassianProjectsSvg = require("../../../assets/hero-icons/apps/atlassian-projects.svg");
var _atlassianProjectsSvgDefault = parcelHelpers.interopDefault(_atlassianProjectsSvg);
var _dropboxSvg = require("../../../assets/hero-icons/apps/dropbox.svg");
var _dropboxSvgDefault = parcelHelpers.interopDefault(_dropboxSvg);
var _figmaSvg = require("../../../assets/hero-icons/apps/figma.svg");
var _figmaSvgDefault = parcelHelpers.interopDefault(_figmaSvg);
var _githubSvg = require("../../../assets/hero-icons/apps/github.svg");
var _githubSvgDefault = parcelHelpers.interopDefault(_githubSvg);
var _googleCalendarSvg = require("../../../assets/hero-icons/apps/google-calendar.svg");
var _googleCalendarSvgDefault = parcelHelpers.interopDefault(_googleCalendarSvg);
var _googleDocsSvg = require("../../../assets/hero-icons/apps/google-docs.svg");
var _googleDocsSvgDefault = parcelHelpers.interopDefault(_googleDocsSvg);
var _googleDriveSvg = require("../../../assets/hero-icons/apps/google-drive.svg");
var _googleDriveSvgDefault = parcelHelpers.interopDefault(_googleDriveSvg);
var _googleSheetsSvg = require("../../../assets/hero-icons/apps/google-sheets.svg");
var _googleSheetsSvgDefault = parcelHelpers.interopDefault(_googleSheetsSvg);
var _launchdarklySvg = require("../../../assets/hero-icons/apps/launchdarkly.svg");
var _launchdarklySvgDefault = parcelHelpers.interopDefault(_launchdarklySvg);
var _microsoftOutlookSvg = require("../../../assets/hero-icons/apps/microsoft-outlook.svg");
var _microsoftOutlookSvgDefault = parcelHelpers.interopDefault(_microsoftOutlookSvg);
var _microsoftSharepointSvg = require("../../../assets/hero-icons/apps/microsoft-sharepoint.svg");
var _microsoftSharepointSvgDefault = parcelHelpers.interopDefault(_microsoftSharepointSvg);
var _microsoftTeamsSvg = require("../../../assets/hero-icons/apps/microsoft-teams.svg");
var _microsoftTeamsSvgDefault = parcelHelpers.interopDefault(_microsoftTeamsSvg);
var _rovoSvg = require("../../../assets/hero-icons/apps/rovo.svg");
var _rovoSvgDefault = parcelHelpers.interopDefault(_rovoSvg);
var _avatar01Webp = require("../../../assets/hero-icons/avatars/avatar-01.webp");
var _avatar01WebpDefault = parcelHelpers.interopDefault(_avatar01Webp);
var _avatar02Webp = require("../../../assets/hero-icons/avatars/avatar-02.webp");
var _avatar02WebpDefault = parcelHelpers.interopDefault(_avatar02Webp);
var _avatar03Webp = require("../../../assets/hero-icons/avatars/avatar-03.webp");
var _avatar03WebpDefault = parcelHelpers.interopDefault(_avatar03Webp);
var _avatar04Webp = require("../../../assets/hero-icons/avatars/avatar-04.webp");
var _avatar04WebpDefault = parcelHelpers.interopDefault(_avatar04Webp);
var _avatar05Webp = require("../../../assets/hero-icons/avatars/avatar-05.webp");
var _avatar05WebpDefault = parcelHelpers.interopDefault(_avatar05Webp);
var _avatar06Webp = require("../../../assets/hero-icons/avatars/avatar-06.webp");
var _avatar06WebpDefault = parcelHelpers.interopDefault(_avatar06Webp);
var _avatar07Webp = require("../../../assets/hero-icons/avatars/avatar-07.webp");
var _avatar07WebpDefault = parcelHelpers.interopDefault(_avatar07Webp);
var _avatar08Webp = require("../../../assets/hero-icons/avatars/avatar-08.webp");
var _avatar08WebpDefault = parcelHelpers.interopDefault(_avatar08Webp);
var _avatar09Webp = require("../../../assets/hero-icons/avatars/avatar-09.webp");
var _avatar09WebpDefault = parcelHelpers.interopDefault(_avatar09Webp);
var _avatar10Webp = require("../../../assets/hero-icons/avatars/avatar-10.webp");
var _avatar10WebpDefault = parcelHelpers.interopDefault(_avatar10Webp);
var _avatar11Webp = require("../../../assets/hero-icons/avatars/avatar-11.webp");
var _avatar11WebpDefault = parcelHelpers.interopDefault(_avatar11Webp);
var _circleScribbleWebp = require("../../../assets/hero-icons/scribbles/circle-scribble.webp");
var _circleScribbleWebpDefault = parcelHelpers.interopDefault(_circleScribbleWebp);
var _loopSwooshWebp = require("../../../assets/hero-icons/scribbles/loop-swoosh.webp");
var _loopSwooshWebpDefault = parcelHelpers.interopDefault(_loopSwooshWebp);
var _plusWebp = require("../../../assets/hero-icons/scribbles/plus.webp");
var _plusWebpDefault = parcelHelpers.interopDefault(_plusWebp);
var _starburstWebp = require("../../../assets/hero-icons/scribbles/starburst.webp");
var _starburstWebpDefault = parcelHelpers.interopDefault(_starburstWebp);
var REFERENCE_WIDTH = 1680;
var REFERENCE_HEIGHT = 1200;
var MOBILE_REFERENCE_WIDTH = 650;
var MOBILE_REFERENCE_HEIGHT = 1200;
var MOBILE_ICON_SCALE = 0.65;
/**
 * Convert a Figma bounding box (top-left x, y plus width, height in the
 * 1680x1200 source frame) into the normalized center + width our renderer
 * expects.
 *
 *   - x, y → top-left of the box in Figma px
 *   - w, h → rendered size in Figma px (h is unused but kept for clarity)
 *
 * Returns `{ x, y, width }` ready to spread into a HeroAsset, where each
 * value is expressed as a 0..1 fraction of the reference frame
 * (REFERENCE_WIDTH × REFERENCE_HEIGHT). The icon layer pins those
 * dimensions in pixels at render time, so each asset ends up at exactly
 * its authored size and position regardless of viewport size.
 */ var place = function(x, y, w, h) {
    return {
        x: (x + w / 2) / REFERENCE_WIDTH,
        y: (y + h / 2) / REFERENCE_HEIGHT,
        width: w / REFERENCE_WIDTH
    };
};
var HERO_ASSETS = [
    (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: 'agent-green-large-top',
        src: (0, _agents06SvgDefault.default)
    }, place(391, 44, 52.5, 60)), {
        kind: 'agent'
    }),
    (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: 'avatar-ali',
        src: (0, _avatar01WebpDefault.default)
    }, place(1337, 998, 64, 64)), {
        kind: 'avatar'
    }),
    (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: 'google-drive',
        src: (0, _googleDriveSvgDefault.default)
    }, place(1181, 137, 60, 60)), {
        kind: 'app'
    }),
    (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: 'avatar-keanu-small',
        src: (0, _avatar02WebpDefault.default)
    }, place(367, 161, 40, 40)), {
        kind: 'avatar'
    }),
    (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: 'figma',
        src: (0, _figmaSvgDefault.default)
    }, place(528, 120, 48, 48)), {
        kind: 'app'
    }),
    (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: 'status-done'
    }, place(1161, 1037, 68, 32)), {
        kind: 'label',
        alt: 'Done'
    }),
    (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: 'avatar-avery',
        src: (0, _avatar03WebpDefault.default)
    }, place(657, 46, 64, 64)), {
        kind: 'avatar'
    }),
    (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: 'agent-blue-small-upper-right',
        src: (0, _agents01SvgDefault.default)
    }, place(1287, 212, 28, 32)), {
        kind: 'agent'
    }),
    (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: 'atlassian-loom',
        src: (0, _atlassianLoomSvgDefault.default)
    }, place(892, 31, 60, 60)), {
        kind: 'app'
    }),
    (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: 'scribble-starburst',
        src: (0, _starburstWebpDefault.default)
    }, place(230, 170, 36.313, 37.01)), {
        kind: 'scribble'
    }),
    (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: 'scribble-plus',
        src: (0, _plusWebpDefault.default)
    }, place(1078, 102, 22.973, 25)), {
        kind: 'scribble'
    }),
    (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: 'rovo',
        src: (0, _rovoSvgDefault.default)
    }, place(344, 995, 60, 60)), {
        kind: 'app',
        alt: 'Rovo'
    }),
    (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: 'atlassian-confluence',
        src: (0, _atlassianConfluenceSvgDefault.default)
    }, place(714, 146, 48, 48)), {
        kind: 'app'
    }),
    (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: 'agent-purple-large',
        src: (0, _agents10SvgDefault.default)
    }, place(678, 1061, 52.5, 60)), {
        kind: 'agent'
    }),
    (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: 'microsoft-teams',
        src: (0, _microsoftTeamsSvgDefault.default)
    }, place(527, 1108, 32, 32)), {
        kind: 'app'
    }),
    (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: 'agent-orange-small-upper-right',
        src: (0, _agents02SvgDefault.default)
    }, place(1212, 26, 28, 32)), {
        kind: 'agent'
    }),
    (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: 'status-on-track'
    }, place(1440, 113, 108, 32)), {
        kind: 'label',
        alt: 'On track'
    }),
    (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: 'avatar-ash',
        src: (0, _avatar04WebpDefault.default)
    }, place(1475, 267, 64, 64)), {
        kind: 'avatar'
    }),
    (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: 'atlassian-goals',
        src: (0, _atlassianGoalsSvgDefault.default)
    }, place(1015, 147, 40, 40)), {
        kind: 'app'
    }),
    (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: 'agent-blue-small-mid',
        src: (0, _agents01SvgDefault.default)
    }, place(370, 245, 28, 32)), {
        kind: 'agent'
    }),
    (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: 'avatar-aspen',
        src: (0, _avatar05WebpDefault.default)
    }, place(1362, 174, 64, 64)), {
        kind: 'avatar'
    }),
    (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: 'status-to-do'
    }, place(241, 256, 72, 32)), {
        kind: 'label',
        alt: 'To do'
    }),
    (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: 'agent-yellow-small-left',
        src: (0, _agents05SvgDefault.default)
    }, place(106, 217, 28, 32)), {
        kind: 'agent'
    }),
    (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: 'atlassian-projects',
        src: (0, _atlassianProjectsSvgDefault.default)
    }, place(141, 316, 48, 48)), {
        kind: 'app'
    }),
    (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: 'agent-green-small-right',
        src: (0, _agentsSvgDefault.default)
    }, place(1599, 263, 28, 32)), {
        kind: 'agent'
    }),
    (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: 'scribble-circle',
        src: (0, _circleScribbleWebpDefault.default)
    }, place(1453, 388, 41.169, 34.251)), {
        kind: 'scribble'
    }),
    (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: 'atlassian-focus',
        src: (0, _atlassianFocusSvgDefault.default)
    }, place(208, 529, 32, 32)), {
        kind: 'app'
    }),
    (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: 'asana',
        src: (0, _asanaSvgDefault.default)
    }, place(297, 449, 32, 32)), {
        kind: 'app'
    }),
    (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: 'google-calendar',
        src: (0, _googleCalendarSvgDefault.default)
    }, place(1369, 469, 48, 48)), {
        kind: 'app'
    }),
    (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: 'agent-yellow-large',
        src: (0, _agents07SvgDefault.default)
    }, place(1500, 500, 52.5, 60)), {
        kind: 'agent'
    }),
    (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: 'avatar-quinn',
        src: (0, _avatar06WebpDefault.default)
    }, place(287, 586, 64, 64)), {
        kind: 'avatar'
    }),
    (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: 'atlassian-jira',
        src: (0, _atlassianJiraSvgDefault.default)
    }, place(352, 721, 60, 60)), {
        kind: 'app'
    }),
    (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: 'agent-orange-large',
        src: (0, _agents08SvgDefault.default)
    }, place(1177, 892, 52.5, 60)), {
        kind: 'agent'
    }),
    (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: 'avatar-natalie-small',
        src: (0, _avatar07WebpDefault.default)
    }, place(1308, 75, 40, 40)), {
        kind: 'avatar'
    }),
    (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: 'scribble-loop-swoosh',
        src: (0, _loopSwooshWebpDefault.default)
    }, place(1342, 625, 79, 27)), {
        kind: 'scribble'
    }),
    (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: 'microsoft-sharepoint',
        src: (0, _microsoftSharepointSvgDefault.default)
    }, place(152, 656, 48, 48)), {
        kind: 'app'
    }),
    (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: 'google-sheets',
        src: (0, _googleSheetsSvgDefault.default)
    }, place(89, 450, 60, 60)), {
        kind: 'app'
    }),
    (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: 'agent-blue-small-mid-right',
        src: (0, _agents01SvgDefault.default)
    }, place(485, 944, 28, 32)), {
        kind: 'agent'
    }),
    (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: 'avatar-keanu',
        src: (0, _avatar08WebpDefault.default)
    }, place(998, 1041, 64, 64)), {
        kind: 'avatar'
    }),
    (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: 'status-at-risk'
    }, place(168, 785, 88, 32)), {
        kind: 'label',
        alt: 'At risk'
    }),
    (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: 'github',
        src: (0, _githubSvgDefault.default)
    }, place(1398, 854, 60, 60)), {
        kind: 'app'
    }),
    (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: 'atlassian-jpd',
        src: (0, _atlassianJpdSvgDefault.default)
    }, place(1514, 643, 60, 60)), {
        kind: 'app'
    }),
    (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: 'avatar-andrea-small',
        src: (0, _avatar09WebpDefault.default)
    }, place(841, 154, 40, 40)), {
        kind: 'avatar'
    }),
    (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: 'launchdarkly',
        src: (0, _launchdarklySvgDefault.default)
    }, place(108, 868, 60, 60)), {
        kind: 'app'
    }),
    (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: 'avatar-naz',
        src: (0, _avatar10WebpDefault.default)
    }, place(579, 957, 64, 64)), {
        kind: 'avatar'
    }),
    (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: 'agent-purple-small-bottom',
        src: (0, _agents03SvgDefault.default)
    }, place(248, 930, 28, 32)), {
        kind: 'agent'
    }),
    (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: 'atlassian-bitbucket',
        src: (0, _atlassianBitbucketSvgDefault.default)
    }, place(800, 970, 60, 60)), {
        kind: 'app'
    }),
    (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: 'microsoft-outlook',
        src: (0, _microsoftOutlookSvgDefault.default)
    }, place(1508, 921, 60, 60)), {
        kind: 'app'
    }),
    (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: 'avatar-imani',
        src: (0, _avatar11WebpDefault.default)
    }, place(315, 830, 64, 64)), {
        kind: 'avatar'
    }),
    (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: 'dropbox',
        src: (0, _dropboxSvgDefault.default)
    }, place(1444, 770, 48, 48)), {
        kind: 'app'
    }),
    (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: 'placeholder-gray-lower-middle',
        src: (0, _atlassianJsmSvgDefault.default)
    }, place(1029, 914, 40, 40)), {
        kind: 'app',
        alt: 'Jira Service Management'
    }),
    (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: 'placeholder-gray-right-middle',
        src: (0, _googleDocsSvgDefault.default)
    }, place(1316, 813, 40, 40)), {
        kind: 'app',
        alt: 'Google Docs'
    })
];
var TEXT_SAFE_AREA = {
    x: [
        560,
        1120
    ],
    y: [
        420,
        720
    ]
};
var MOBILE_TEXT_SAFE_AREA = {
    x: [
        125,
        525
    ],
    y: [
        390,
        800
    ]
};
var findAsset = function(id) {
    return HERO_ASSETS.find(function(a) {
        return a.id === id;
    });
};
var getMotionOrigin = function(textSafeArea, referenceWidth, referenceHeight) {
    return {
        x: (textSafeArea.x[0] + textSafeArea.x[1]) / 2 / referenceWidth,
        y: (textSafeArea.y[0] + textSafeArea.y[1]) / 2 / referenceHeight
    };
};
var MOTION_ORIGIN = getMotionOrigin(TEXT_SAFE_AREA, REFERENCE_WIDTH, REFERENCE_HEIGHT);
var MOBILE_MOTION_ORIGIN = getMotionOrigin(MOBILE_TEXT_SAFE_AREA, MOBILE_REFERENCE_WIDTH, MOBILE_REFERENCE_HEIGHT);
var scaleAssetsAroundOrigin = function(assets, xScale, yScale, origin) {
    if (xScale === 1 && yScale === 1) return (0, _toConsumableArray._)(assets);
    return assets.map(function(asset) {
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, asset), {
            x: origin.x + (asset.x - origin.x) * xScale,
            y: origin.y + (asset.y - origin.y) * yScale
        });
    });
};
var placeMobile = function(x, y, w, h) {
    return {
        x: (x + w / 2) / MOBILE_REFERENCE_WIDTH,
        y: (y + h / 2) / MOBILE_REFERENCE_HEIGHT,
        width: w * MOBILE_ICON_SCALE / MOBILE_REFERENCE_WIDTH
    };
};
var mobileAsset = function(id, x, y, w, h) {
    var asset = HERO_ASSETS.find(function(a) {
        return a.id === id;
    });
    if (!asset) throw new Error("Missing hero icon asset: ".concat(id));
    return (0, _objectSpread._)({}, asset, placeMobile(x, y, w, h));
};
var HERO_ASSETS_MOBILE = [
    mobileAsset('agent-green-large-top', 104, 174, 52.5, 60),
    mobileAsset('avatar-ali', 260, 148, 64, 64),
    mobileAsset('google-drive', 430, 196, 60, 60),
    mobileAsset('figma', 178, 254, 48, 48),
    mobileAsset('atlassian-loom', 330, 242, 60, 60),
    mobileAsset('microsoft-teams', 72, 296, 32, 32),
    mobileAsset('rovo', 508, 296, 60, 60),
    mobileAsset('scribble-plus', 288, 340, 23, 25),
    mobileAsset('status-to-do', 42, 370, 72, 32),
    mobileAsset('avatar-natalie-small', 434, 290, 40, 40),
    mobileAsset('agent-blue-small-upper-right', 562, 386, 28, 32),
    mobileAsset('agent-yellow-small-left', 80, 488, 28, 32),
    mobileAsset('placeholder-gray-right-middle', 560, 464, 40, 40),
    mobileAsset('atlassian-focus', 48, 594, 32, 32),
    mobileAsset('scribble-circle', 574, 560, 41, 34),
    mobileAsset('asana', 586, 640, 32, 32),
    mobileAsset('atlassian-projects', 74, 710, 48, 48),
    mobileAsset('google-calendar', 548, 704, 48, 48),
    mobileAsset('status-at-risk', -18, 782, 88, 32),
    mobileAsset('avatar-quinn', 70, 842, 64, 64),
    mobileAsset('atlassian-jira', 206, 850, 60, 60),
    mobileAsset('agent-orange-large', 424, 840, 52.5, 60),
    mobileAsset('github', 546, 862, 60, 60),
    mobileAsset('atlassian-bitbucket', 316, 928, 60, 60),
    mobileAsset('dropbox', 394, 958, 48, 48),
    mobileAsset('google-sheets', 92, 966, 60, 60),
    mobileAsset('scribble-loop-swoosh', 514, 976, 79, 27),
    mobileAsset('placeholder-gray-lower-middle', 184, 1030, 40, 40),
    mobileAsset('agent-purple-small-bottom', 284, 1054, 28, 32),
    mobileAsset('microsoft-outlook', 540, 1026, 60, 60),
    mobileAsset('avatar-naz', 452, 1060, 64, 64),
    mobileAsset('status-done', 374, 1086, 68, 32)
];
var TIER_OVAL_OVERRIDES = {
    desktop: {},
    compact: {
        ovalSize: 0.77,
        ovalAspectRatio: 0.96
    },
    mobile: {}
};
function getHeroLayout(param) {
    var viewportTier = param.viewportTier, ovalSize = param.ovalSize, ovalAspectRatio = param.ovalAspectRatio, mobileOvalSize = param.mobileOvalSize, mobileOvalAspectRatio = param.mobileOvalAspectRatio;
    if (viewportTier === 'mobile') return {
        assets: scaleAssetsAroundOrigin(HERO_ASSETS_MOBILE, mobileOvalSize * mobileOvalAspectRatio, mobileOvalSize, MOBILE_MOTION_ORIGIN),
        referenceWidth: MOBILE_REFERENCE_WIDTH,
        referenceHeight: MOBILE_REFERENCE_HEIGHT,
        textSafeArea: MOBILE_TEXT_SAFE_AREA,
        motionOrigin: MOBILE_MOTION_ORIGIN
    };
    var overrides = TIER_OVAL_OVERRIDES[viewportTier];
    var _overrides_ovalSize;
    var effectiveOvalSize = (_overrides_ovalSize = overrides.ovalSize) !== null && _overrides_ovalSize !== void 0 ? _overrides_ovalSize : ovalSize;
    var _overrides_ovalAspectRatio;
    var effectiveOvalAspectRatio = (_overrides_ovalAspectRatio = overrides.ovalAspectRatio) !== null && _overrides_ovalAspectRatio !== void 0 ? _overrides_ovalAspectRatio : ovalAspectRatio;
    return {
        assets: scaleAssetsAroundOrigin(HERO_ASSETS, effectiveOvalSize * effectiveOvalAspectRatio, effectiveOvalSize, MOTION_ORIGIN),
        referenceWidth: REFERENCE_WIDTH,
        referenceHeight: REFERENCE_HEIGHT,
        textSafeArea: TEXT_SAFE_AREA,
        motionOrigin: MOTION_ORIGIN
    };
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_to_consumable_array":"1eSZf","../../../assets/hero-icons/agents/agents-01.svg":"keUWL","../../../assets/hero-icons/agents/agents-02.svg":"fsG6B","../../../assets/hero-icons/agents/agents-03.svg":"etFjj","../../../assets/hero-icons/agents/agents-05.svg":"bmjLe","../../../assets/hero-icons/agents/agents-06.svg":"6oaOG","../../../assets/hero-icons/agents/agents-07.svg":"8NP0m","../../../assets/hero-icons/agents/agents-08.svg":"cSdUF","../../../assets/hero-icons/agents/agents-10.svg":"lC8xQ","../../../assets/hero-icons/agents/agents.svg":"iVgzC","../../../assets/hero-icons/apps/asana.svg":"jbFjY","../../../assets/hero-icons/apps/atlassian-bitbucket.svg":"l1JPI","../../../assets/hero-icons/apps/atlassian-confluence.svg":"jXwQ8","../../../assets/hero-icons/apps/atlassian-focus.svg":"kapw7","../../../assets/hero-icons/apps/atlassian-goals.svg":"bUZSX","../../../assets/hero-icons/apps/atlassian-jira.svg":"lu4M4","../../../assets/hero-icons/apps/atlassian-jpd.svg":"kjJbc","../../../assets/hero-icons/apps/atlassian-jsm.svg":"9IskX","../../../assets/hero-icons/apps/atlassian-loom.svg":"7VjVC","../../../assets/hero-icons/apps/atlassian-projects.svg":"6TuO3","../../../assets/hero-icons/apps/dropbox.svg":"9MEmQ","../../../assets/hero-icons/apps/figma.svg":"hMUJ1","../../../assets/hero-icons/apps/github.svg":"73pL2","../../../assets/hero-icons/apps/google-calendar.svg":"6ACbE","../../../assets/hero-icons/apps/google-docs.svg":"66wAV","../../../assets/hero-icons/apps/google-drive.svg":"bSUQY","../../../assets/hero-icons/apps/google-sheets.svg":"iblma","../../../assets/hero-icons/apps/launchdarkly.svg":"4dFWl","../../../assets/hero-icons/apps/microsoft-outlook.svg":"frfj0","../../../assets/hero-icons/apps/microsoft-sharepoint.svg":"1H1RK","../../../assets/hero-icons/apps/microsoft-teams.svg":"9qO17","../../../assets/hero-icons/apps/rovo.svg":"49CRE","../../../assets/hero-icons/avatars/avatar-01.webp":"jzTL0","../../../assets/hero-icons/avatars/avatar-02.webp":"i61HY","../../../assets/hero-icons/avatars/avatar-03.webp":"7C4aO","../../../assets/hero-icons/avatars/avatar-04.webp":"cTBuZ","../../../assets/hero-icons/avatars/avatar-05.webp":"7kBYz","../../../assets/hero-icons/avatars/avatar-06.webp":"hqWik","../../../assets/hero-icons/avatars/avatar-07.webp":"kw73c","../../../assets/hero-icons/avatars/avatar-08.webp":"ftdgU","../../../assets/hero-icons/avatars/avatar-09.webp":"b49K0","../../../assets/hero-icons/avatars/avatar-10.webp":"g4Fj5","../../../assets/hero-icons/avatars/avatar-11.webp":"2bTf8","../../../assets/hero-icons/scribbles/circle-scribble.webp":"7BHtq","../../../assets/hero-icons/scribbles/loop-swoosh.webp":"bV8aM","../../../assets/hero-icons/scribbles/plus.webp":"fft4F","../../../assets/hero-icons/scribbles/starburst.webp":"1SyuQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"keUWL":[function(require,module,exports,__globalThis) {
module.exports = require("b1ef3914843259c5").getBundleURL('a140o') + "agents-01.26138ceb.svg" + "?" + Date.now();

},{"b1ef3914843259c5":"cZKtR"}],"cZKtR":[function(require,module,exports,__globalThis) {
"use strict";
var stackTraceUrlRegexp = /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g;
var bundleURL = {};
/**
 * Retrieves the cached bundle URL for a given identifier.
 * If the URL is not cached, it computes and stores it in the cache.
 *
 * @param {string} id - The identifier for the bundle.
 * @param {Error?} inputError - An error object to extract the stack trace from
 * (for testing purposes).
 * @returns {string} The URL of the bundle, without file name.
 */ function getBundleURLCached(id, inputError) {
    var value = bundleURL[id];
    if (!value) {
        value = getBundleURL(inputError);
        bundleURL[id] = value;
    }
    return value;
}
/** Get the URL without the filename (last / segment)
 *
 * @param {string} url
 * @returns {string} The URL with the file name removed
 */ function getBaseURL(url) {
    return url.slice(0, url.lastIndexOf('/')) + '/';
}
function getBundleURL(inputError) {
    try {
        throw inputError !== null && inputError !== void 0 ? inputError : new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(stackTraceUrlRegexp);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return getBaseURL(matches[2]);
    }
    return '/';
}
/**
 * @param {string} url
 * @returns {string}
 */ function getOrigin(url) {
    return new URL(url).origin;
}
// TODO: convert this file to ESM once HMR issues are resolved
exports.getOrigin = getOrigin;
exports.getBundleURL = getBundleURLCached;
exports.getBaseURL = getBaseURL;

},{}],"fsG6B":[function(require,module,exports,__globalThis) {
module.exports = require("351af8bc03242114").getBundleURL('a140o') + "agents-02.b0615c80.svg" + "?" + Date.now();

},{"351af8bc03242114":"cZKtR"}],"etFjj":[function(require,module,exports,__globalThis) {
module.exports = require("33f54ad4c1873003").getBundleURL('a140o') + "agents-03.bff98701.svg" + "?" + Date.now();

},{"33f54ad4c1873003":"cZKtR"}],"bmjLe":[function(require,module,exports,__globalThis) {
module.exports = require("8bc31b62cf4bf1d").getBundleURL('a140o') + "agents-05.5c65fec0.svg" + "?" + Date.now();

},{"8bc31b62cf4bf1d":"cZKtR"}],"6oaOG":[function(require,module,exports,__globalThis) {
module.exports = require("78fecd261cbb1ca0").getBundleURL('a140o') + "agents-06.41f454e4.svg" + "?" + Date.now();

},{"78fecd261cbb1ca0":"cZKtR"}],"8NP0m":[function(require,module,exports,__globalThis) {
module.exports = require("e7398c9aeeeb88f2").getBundleURL('a140o') + "agents-07.73047889.svg" + "?" + Date.now();

},{"e7398c9aeeeb88f2":"cZKtR"}],"cSdUF":[function(require,module,exports,__globalThis) {
module.exports = require("44472092dd096371").getBundleURL('a140o') + "agents-08.85d30a48.svg" + "?" + Date.now();

},{"44472092dd096371":"cZKtR"}],"lC8xQ":[function(require,module,exports,__globalThis) {
module.exports = require("dc37527b259f6739").getBundleURL('a140o') + "agents-10.d80d3ea7.svg" + "?" + Date.now();

},{"dc37527b259f6739":"cZKtR"}],"iVgzC":[function(require,module,exports,__globalThis) {
module.exports = require("9f6c2a20609571f2").getBundleURL('a140o') + "agents.2634c1c8.svg" + "?" + Date.now();

},{"9f6c2a20609571f2":"cZKtR"}],"jbFjY":[function(require,module,exports,__globalThis) {
module.exports = require("1745cb3b2b649402").getBundleURL('a140o') + "asana.448d6d95.svg" + "?" + Date.now();

},{"1745cb3b2b649402":"cZKtR"}],"l1JPI":[function(require,module,exports,__globalThis) {
module.exports = require("c1dff3ba307a7574").getBundleURL('a140o') + "atlassian-bitbucket.728357c3.svg" + "?" + Date.now();

},{"c1dff3ba307a7574":"cZKtR"}],"jXwQ8":[function(require,module,exports,__globalThis) {
module.exports = require("41bfb5c775979b2c").getBundleURL('a140o') + "atlassian-confluence.e7fb6922.svg" + "?" + Date.now();

},{"41bfb5c775979b2c":"cZKtR"}],"kapw7":[function(require,module,exports,__globalThis) {
module.exports = require("d9c14beada7fe41").getBundleURL('a140o') + "atlassian-focus.b5cd7904.svg" + "?" + Date.now();

},{"d9c14beada7fe41":"cZKtR"}],"bUZSX":[function(require,module,exports,__globalThis) {
module.exports = require("f6f3bb76f5392f11").getBundleURL('a140o') + "atlassian-goals.ac34f057.svg" + "?" + Date.now();

},{"f6f3bb76f5392f11":"cZKtR"}],"lu4M4":[function(require,module,exports,__globalThis) {
module.exports = require("c5e734985bc7b5d2").getBundleURL('a140o') + "atlassian-jira.56f1f6f6.svg" + "?" + Date.now();

},{"c5e734985bc7b5d2":"cZKtR"}],"kjJbc":[function(require,module,exports,__globalThis) {
module.exports = require("3791b1ca48b00155").getBundleURL('a140o') + "atlassian-jpd.d5a2d819.svg" + "?" + Date.now();

},{"3791b1ca48b00155":"cZKtR"}],"9IskX":[function(require,module,exports,__globalThis) {
module.exports = require("466544aa88a986a2").getBundleURL('a140o') + "atlassian-jsm.0277427f.svg" + "?" + Date.now();

},{"466544aa88a986a2":"cZKtR"}],"7VjVC":[function(require,module,exports,__globalThis) {
module.exports = require("7fbcbf783e962821").getBundleURL('a140o') + "atlassian-loom.3e0348e1.svg" + "?" + Date.now();

},{"7fbcbf783e962821":"cZKtR"}],"6TuO3":[function(require,module,exports,__globalThis) {
module.exports = require("f8e4e4097660db90").getBundleURL('a140o') + "atlassian-projects.0ed0cb34.svg" + "?" + Date.now();

},{"f8e4e4097660db90":"cZKtR"}],"9MEmQ":[function(require,module,exports,__globalThis) {
module.exports = require("cec4f87ff2245fc1").getBundleURL('a140o') + "dropbox.c7c2fb10.svg" + "?" + Date.now();

},{"cec4f87ff2245fc1":"cZKtR"}],"hMUJ1":[function(require,module,exports,__globalThis) {
module.exports = require("12575ecaff7c9f42").getBundleURL('a140o') + "figma.f0667691.svg" + "?" + Date.now();

},{"12575ecaff7c9f42":"cZKtR"}],"73pL2":[function(require,module,exports,__globalThis) {
module.exports = require("ea348aa5fa4a715f").getBundleURL('a140o') + "github.d6efeb90.svg" + "?" + Date.now();

},{"ea348aa5fa4a715f":"cZKtR"}],"6ACbE":[function(require,module,exports,__globalThis) {
module.exports = require("e3a26c1469bc922a").getBundleURL('a140o') + "google-calendar.d39421c3.svg" + "?" + Date.now();

},{"e3a26c1469bc922a":"cZKtR"}],"66wAV":[function(require,module,exports,__globalThis) {
module.exports = require("f9d250d8e0effe0f").getBundleURL('a140o') + "google-docs.3809700a.svg" + "?" + Date.now();

},{"f9d250d8e0effe0f":"cZKtR"}],"bSUQY":[function(require,module,exports,__globalThis) {
module.exports = require("3ba6a971f212f7b0").getBundleURL('a140o') + "google-drive.8c6b7def.svg" + "?" + Date.now();

},{"3ba6a971f212f7b0":"cZKtR"}],"iblma":[function(require,module,exports,__globalThis) {
module.exports = require("e762bc4a46db1efc").getBundleURL('a140o') + "google-sheets.175e4ba2.svg" + "?" + Date.now();

},{"e762bc4a46db1efc":"cZKtR"}],"4dFWl":[function(require,module,exports,__globalThis) {
module.exports = require("17b1a71a56e56a5a").getBundleURL('a140o') + "launchdarkly.b971152d.svg" + "?" + Date.now();

},{"17b1a71a56e56a5a":"cZKtR"}],"frfj0":[function(require,module,exports,__globalThis) {
module.exports = require("f66b4939831e89a9").getBundleURL('a140o') + "microsoft-outlook.7cdb1e3c.svg" + "?" + Date.now();

},{"f66b4939831e89a9":"cZKtR"}],"1H1RK":[function(require,module,exports,__globalThis) {
module.exports = require("69c6fc4b19b1d141").getBundleURL('a140o') + "microsoft-sharepoint.5f0c2d9e.svg" + "?" + Date.now();

},{"69c6fc4b19b1d141":"cZKtR"}],"9qO17":[function(require,module,exports,__globalThis) {
module.exports = require("8244114a6d34acf5").getBundleURL('a140o') + "microsoft-teams.4c743783.svg" + "?" + Date.now();

},{"8244114a6d34acf5":"cZKtR"}],"49CRE":[function(require,module,exports,__globalThis) {
module.exports = require("110da89de1af5ea").getBundleURL('a140o') + "rovo.967b04bd.svg" + "?" + Date.now();

},{"110da89de1af5ea":"cZKtR"}],"jzTL0":[function(require,module,exports,__globalThis) {
module.exports = require("791f71177f9ab73").getBundleURL('a140o') + "avatar-01.80e1479e.webp" + "?" + Date.now();

},{"791f71177f9ab73":"cZKtR"}],"i61HY":[function(require,module,exports,__globalThis) {
module.exports = require("8adbbae1e36992c6").getBundleURL('a140o') + "avatar-02.ea95c9df.webp" + "?" + Date.now();

},{"8adbbae1e36992c6":"cZKtR"}],"7C4aO":[function(require,module,exports,__globalThis) {
module.exports = require("2e5a3c66d9c7bbef").getBundleURL('a140o') + "avatar-03.2baaebee.webp" + "?" + Date.now();

},{"2e5a3c66d9c7bbef":"cZKtR"}],"cTBuZ":[function(require,module,exports,__globalThis) {
module.exports = require("ff203685725d3ef4").getBundleURL('a140o') + "avatar-04.c891b09a.webp" + "?" + Date.now();

},{"ff203685725d3ef4":"cZKtR"}],"7kBYz":[function(require,module,exports,__globalThis) {
module.exports = require("e581649d11254848").getBundleURL('a140o') + "avatar-05.3e5ae59e.webp" + "?" + Date.now();

},{"e581649d11254848":"cZKtR"}],"hqWik":[function(require,module,exports,__globalThis) {
module.exports = require("25854026d4a75fb6").getBundleURL('a140o') + "avatar-06.94478d85.webp" + "?" + Date.now();

},{"25854026d4a75fb6":"cZKtR"}],"kw73c":[function(require,module,exports,__globalThis) {
module.exports = require("e4ef76689077ecc7").getBundleURL('a140o') + "avatar-07.27b28afa.webp" + "?" + Date.now();

},{"e4ef76689077ecc7":"cZKtR"}],"ftdgU":[function(require,module,exports,__globalThis) {
module.exports = require("a742856e6550d68d").getBundleURL('a140o') + "avatar-08.097e622f.webp" + "?" + Date.now();

},{"a742856e6550d68d":"cZKtR"}],"b49K0":[function(require,module,exports,__globalThis) {
module.exports = require("3c2bcba7a17f2ed8").getBundleURL('a140o') + "avatar-09.15007b53.webp" + "?" + Date.now();

},{"3c2bcba7a17f2ed8":"cZKtR"}],"g4Fj5":[function(require,module,exports,__globalThis) {
module.exports = require("860585eaf600cc28").getBundleURL('a140o') + "avatar-10.5fc24ec4.webp" + "?" + Date.now();

},{"860585eaf600cc28":"cZKtR"}],"2bTf8":[function(require,module,exports,__globalThis) {
module.exports = require("c70531ee2ae52cce").getBundleURL('a140o') + "avatar-11.c5c05510.webp" + "?" + Date.now();

},{"c70531ee2ae52cce":"cZKtR"}],"7BHtq":[function(require,module,exports,__globalThis) {
module.exports = require("69a22b67a307a9f6").getBundleURL('a140o') + "circle-scribble.bd6c56f1.webp" + "?" + Date.now();

},{"69a22b67a307a9f6":"cZKtR"}],"bV8aM":[function(require,module,exports,__globalThis) {
module.exports = require("9fcb6edcb607aa8e").getBundleURL('a140o') + "loop-swoosh.e78e2778.webp" + "?" + Date.now();

},{"9fcb6edcb607aa8e":"cZKtR"}],"fft4F":[function(require,module,exports,__globalThis) {
module.exports = require("38c4925b82e02d42").getBundleURL('a140o') + "plus.4c601115.webp" + "?" + Date.now();

},{"38c4925b82e02d42":"cZKtR"}],"1SyuQ":[function(require,module,exports,__globalThis) {
module.exports = require("a7873fed013c29c5").getBundleURL('a140o') + "starburst.2f677a86.webp" + "?" + Date.now();

},{"a7873fed013c29c5":"cZKtR"}],"5rf9o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "messages", function() {
    return messages;
});
var _reactIntl = require("react-intl");
var intlMessages = {
    heroName: {
        id: 'twg-microsite.heroIcons.heroName',
        defaultMessage: 'Teamwork Graph',
        description: 'Accessible heading text for the logged-out hero wordmark.'
    },
    subtitle: {
        id: 'twg-microsite.heroIcons.subtitle',
        defaultMessage: 'Meet the graph that automatically builds your teamwork context from everywhere you work',
        description: 'Hero supporting copy beneath the wordmark on the logged-out home page.'
    },
    previewCta: {
        id: 'twg-microsite.heroIcons.previewCta',
        defaultMessage: 'See your graph preview',
        description: 'Call-to-action label inviting the user to preview their teamwork graph.'
    },
    statusDone: {
        id: 'twg-microsite.heroIcons.statusDone',
        defaultMessage: 'Done',
        description: 'Decorative status lozenge label in the logged-out hero.'
    },
    statusOnTrack: {
        id: 'twg-microsite.heroIcons.statusOnTrack',
        defaultMessage: 'On track',
        description: 'Decorative status lozenge label in the logged-out hero.'
    },
    statusToDo: {
        id: 'twg-microsite.heroIcons.statusToDo',
        defaultMessage: 'To do',
        description: 'Decorative status lozenge label in the logged-out hero.'
    },
    statusAtRisk: {
        id: 'twg-microsite.heroIcons.statusAtRisk',
        defaultMessage: 'At risk',
        description: 'Decorative status lozenge label in the logged-out hero.'
    }
};
var messages = (0, _reactIntl.defineMessages)(intlMessages);

},{"react-intl":"f41fF","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"47Z1w":[function(require,module,exports,__globalThis) {
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useHeroMotion", function() {
    return useHeroMotion;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _react = require("react");
var _browserApis = require("@atlaskit/browser-apis");
var _dynamics = require("./dynamics");
var _intro = require("./intro");
var _layout = require("./layout");
var _motion = require("./motion");
var _shimmer = require("./shimmer");
/** Max number of pointer samples kept for flick-velocity estimation. */ var FLICK_SAMPLE_LIMIT = 6;
/** Window (ms) over which to compute release velocity. */ var FLICK_WINDOW_MS = 80;
/** Hard cap on flick velocity (px/s) so violent flicks don't shoot icons off-stage. */ var FLICK_MAX_SPEED = 4000;
function clearShimmerSlots(shimmerSlots, shimmerEls) {
    for(var i = 0; i < shimmerSlots.length; i++)if (shimmerSlots[i] !== null) {
        shimmerSlots[i] = null;
        var el = shimmerEls === null || shimmerEls === void 0 ? void 0 : shimmerEls[i];
        if (el) el.setAttribute('stroke-opacity', '0');
    }
}
/**
 * Convert a client-space pointer event to stage-relative pixels.
 */ function clientToStagePx(clientX, clientY, rect) {
    return {
        x: clientX - rect.left,
        y: clientY - rect.top
    };
}
var useHeroMotion = function(opts, refs, edges) {
    var assets = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : (0, _layout.HERO_ASSETS), motionOrigin = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : (0, _motion.DEFAULT_MOTION_ORIGIN), referenceSize = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
        width: (0, _layout.REFERENCE_WIDTH),
        height: (0, _layout.REFERENCE_HEIGHT)
    };
    var params = (0, _react.useMemo)(function() {
        return (0, _motion.computeAssetParams)(assets, motionOrigin);
    }, [
        assets,
        motionOrigin
    ]);
    var cfgRef = (0, _react.useRef)(opts);
    (0, _react.useEffect)(function() {
        cfgRef.current = opts;
    });
    var reducedMotionRef = (0, _react.useRef)(false);
    var prevNowRef = (0, _react.useRef)(0);
    var motionNowRef = (0, _react.useRef)(0);
    var _opts_intro = opts.intro, avatarStaggerMs = _opts_intro.avatarStaggerMs, edgeGrowMs = _opts_intro.edgeGrowMs, iconAppearMs = _opts_intro.iconAppearMs;
    var introSchedule = (0, _react.useMemo)(function() {
        return (0, _intro.computeIntroSchedule)(assets, edges, {
            avatarStaggerMs: avatarStaggerMs,
            edgeGrowMs: edgeGrowMs,
            iconAppearMs: iconAppearMs
        });
    }, [
        assets,
        edges,
        avatarStaggerMs,
        edgeGrowMs,
        iconAppearMs
    ]);
    var scheduleRef = (0, _react.useRef)(introSchedule);
    (0, _react.useEffect)(function() {
        scheduleRef.current = introSchedule;
    }, [
        introSchedule
    ]);
    var introStartRef = (0, _react.useRef)(0);
    var introCleanedUpRef = (0, _react.useRef)(false);
    var introCleanedUpAtRef = (0, _react.useRef)(0);
    var shimmerStateRef = (0, _react.useRef)([]);
    var nextShimmerSpawnAtRef = (0, _react.useRef)(0);
    var shimmerPoolSize = opts.shimmer.maxConcurrent;
    (0, _react.useEffect)(function() {
        var slots = shimmerStateRef.current;
        if (slots.length === shimmerPoolSize) return;
        if (slots.length < shimmerPoolSize) while(slots.length < shimmerPoolSize)slots.push(null);
        else slots.length = shimmerPoolSize;
    }, [
        shimmerPoolSize
    ]);
    var replayIntro = (0, _react.useCallback)(function() {
        var now = typeof performance !== 'undefined' ? performance.now() : 0;
        introStartRef.current = now;
        motionNowRef.current = now;
        introCleanedUpRef.current = false;
        introCleanedUpAtRef.current = 0;
        var slots = shimmerStateRef.current;
        for(var i = 0; i < slots.length; i++)slots[i] = null;
        var _refs_shimmerSlots_current;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = ((_refs_shimmerSlots_current = refs.shimmerSlots.current) !== null && _refs_shimmerSlots_current !== void 0 ? _refs_shimmerSlots_current : [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var el = _step.value;
                if (el) el.setAttribute('stroke-opacity', '0');
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        nextShimmerSpawnAtRef.current = 0;
    }, [
        refs.shimmerSlots
    ]);
    var dynStateRef = (0, _react.useRef)(new Map());
    var adjRef = (0, _react.useRef)({
        a: [],
        b: []
    });
    (0, _react.useEffect)(function() {
        var fresh = (0, _dynamics.createDynState)(assets);
        var current = dynStateRef.current;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fresh[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, _slicedToArray._)(_step.value, 2), id = _step_value[0], state = _step_value[1];
                if (!current.has(id)) current.set(id, state);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = current.keys()[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var id1 = _step1.value;
                if (!fresh.has(id1)) current.delete(id1);
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        adjRef.current = (0, _dynamics.buildAdjacency)(current, edges);
    }, [
        assets,
        edges
    ]);
    var dragsRef = (0, _react.useRef)(new Map());
    // `prefers-reduced-motion` — the rAF loop reads this each tick and skips
    // the intro / ambient drift when the user has opted in to reduced
    // motion, so the hero snaps to its resting state immediately.
    (0, _react.useEffect)(function() {
        var _getDocument;
        var win = (_getDocument = (0, _browserApis.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.defaultView;
        if (!(win === null || win === void 0 ? void 0 : win.matchMedia)) return;
        var mq = win.matchMedia('(prefers-reduced-motion: reduce)');
        var update = function() {
            reducedMotionRef.current = mq.matches;
        };
        update();
        mq.addEventListener('change', update);
        return function() {
            return mq.removeEventListener('change', update);
        };
    }, []);
    (0, _react.useEffect)(function() {
        var doc = (0, _browserApis.getDocument)();
        if (!doc) return;
        var hiddenAt = 0;
        var onVisibilityChange = function() {
            if (doc.hidden) hiddenAt = performance.now();
            else if (hiddenAt > 0) {
                prevNowRef.current = performance.now();
                hiddenAt = 0;
            }
        };
        doc.addEventListener('visibilitychange', onVisibilityChange);
        return function() {
            return doc.removeEventListener('visibilitychange', onVisibilityChange);
        };
    }, []);
    var _opts_interactive;
    var interactive = (_opts_interactive = opts.interactive) !== null && _opts_interactive !== void 0 ? _opts_interactive : true;
    (0, _react.useEffect)(function() {
        if (!interactive) return;
        var stage = refs.stage.current;
        if (!stage) return;
        // Snapshot the Map reference so the cleanup function uses the same
        // instance the listeners mutated (the ref itself never reassigns,
        // but eslint can't see that).
        var drags = dragsRef.current;
        var endDrag = function(pointerId) {
            var ctx = drags.get(pointerId);
            if (!ctx) return;
            var dyn = dynStateRef.current.get(ctx.id);
            if (dyn) {
                dyn.dragging = false;
                // Estimate flick velocity from the most recent samples within
                // FLICK_WINDOW_MS so a quick swipe carries momentum into the spring.
                var flick = cfgRef.current.flick;
                if (flick > 0 && ctx.samples.length >= 2) {
                    var last = ctx.samples[ctx.samples.length - 1];
                    // Find the oldest sample still inside the window.
                    var oldest = ctx.samples[0];
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = ctx.samples[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var s = _step.value;
                            if (last.t - s.t <= FLICK_WINDOW_MS) {
                                oldest = s;
                                break;
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    var dtMs = last.t - oldest.t;
                    if (dtMs > 0) {
                        var vx = (last.x - oldest.x) / dtMs * 1000 * flick;
                        var vy = (last.y - oldest.y) / dtMs * 1000 * flick;
                        var speed = Math.hypot(vx, vy);
                        var scale = speed > FLICK_MAX_SPEED ? FLICK_MAX_SPEED / speed : 1;
                        dyn.vx = vx * scale;
                        dyn.vy = vy * scale;
                    }
                }
            }
            try {
                ctx.el.releasePointerCapture(pointerId);
            } catch (e) {
            // Ignore — capture may already have been lost.
            }
            drags.delete(pointerId);
            if (drags.size === 0) stage.classList.remove('hero-icons-dragging');
        };
        var onPointerDown = function(e) {
            var _e_target;
            if (reducedMotionRef.current) return;
            if (e.pointerType !== 'mouse' || e.button !== 0) return;
            var target = (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.closest('[data-asset-id]');
            if (!target) return;
            var id = target.dataset.assetId;
            if (!id) return;
            var dyn = dynStateRef.current.get(id);
            if (!dyn) return;
            var rect = stage.getBoundingClientRect();
            var grab = clientToStagePx(e.clientX, e.clientY, rect);
            var ctx = {
                id: id,
                grabPx: grab,
                initialDisp: {
                    x: dyn.dispX,
                    y: dyn.dispY
                },
                samples: [
                    {
                        t: performance.now(),
                        x: grab.x,
                        y: grab.y
                    }
                ],
                el: target
            };
            drags.set(e.pointerId, ctx);
            dyn.dragging = true;
            dyn.vx = 0;
            dyn.vy = 0;
            try {
                target.setPointerCapture(e.pointerId);
            } catch (e) {
            // Some browsers reject capture in edge cases (e.g. detached node).
            }
            stage.classList.add('hero-icons-dragging');
            e.preventDefault();
        };
        var onPointerMove = function(e) {
            var ctx = drags.get(e.pointerId);
            if (!ctx) return;
            var dyn = dynStateRef.current.get(ctx.id);
            if (!dyn) return;
            var rect = stage.getBoundingClientRect();
            var p = clientToStagePx(e.clientX, e.clientY, rect);
            // Compose initial displacement so grabbing mid-flight is seamless.
            dyn.dispX = ctx.initialDisp.x + (p.x - ctx.grabPx.x);
            dyn.dispY = ctx.initialDisp.y + (p.y - ctx.grabPx.y);
            dyn.vx = 0;
            dyn.vy = 0;
            ctx.samples.push({
                t: performance.now(),
                x: p.x,
                y: p.y
            });
            if (ctx.samples.length > FLICK_SAMPLE_LIMIT) ctx.samples.shift();
        };
        var onPointerEnd = function(e) {
            endDrag(e.pointerId);
        };
        // Belt-and-braces: if the window loses focus (e.g. alt-tab during a
        // drag), end any in-flight drags so we don't leave nodes pinned.
        var onWindowBlur = function() {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = (0, _toConsumableArray._)(drags.keys())[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var id = _step.value;
                    endDrag(id);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        };
        stage.addEventListener('pointerdown', onPointerDown);
        stage.addEventListener('pointermove', onPointerMove);
        stage.addEventListener('pointerup', onPointerEnd);
        stage.addEventListener('pointercancel', onPointerEnd);
        window.addEventListener('blur', onWindowBlur);
        return function() {
            stage.removeEventListener('pointerdown', onPointerDown);
            stage.removeEventListener('pointermove', onPointerMove);
            stage.removeEventListener('pointerup', onPointerEnd);
            stage.removeEventListener('pointercancel', onPointerEnd);
            window.removeEventListener('blur', onWindowBlur);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = (0, _toConsumableArray._)(drags.keys())[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var id = _step.value;
                    endDrag(id);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        };
    }, [
        refs.stage,
        interactive
    ]);
    (0, _react.useEffect)(function() {
        var raf = 0;
        prevNowRef.current = performance.now();
        motionNowRef.current = prevNowRef.current;
        var offsets = new Map();
        var tick = function() {
            var _getDocument;
            raf = requestAnimationFrame(tick);
            if ((_getDocument = (0, _browserApis.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.hidden) return;
            var cfg = cfgRef.current;
            var reduced = reducedMotionRef.current;
            var now = performance.now();
            var dt = (now - prevNowRef.current) / 1000;
            prevNowRef.current = now;
            if (introStartRef.current === 0) introStartRef.current = now;
            var schedule = scheduleRef.current;
            var introElapsed = now - introStartRef.current;
            var introActive = !reduced && introElapsed < schedule.totalMs;
            var introNeedsCleanup = !introCleanedUpRef.current && !introActive;
            var introWriting = introActive || introNeedsCleanup;
            var hasActiveDrag = dragsRef.current.size > 0;
            var motionFrozen = Boolean(cfg.motionFrozen) && !introWriting && !hasActiveDrag;
            if (motionFrozen) {
                clearShimmerSlots(shimmerStateRef.current, refs.shimmerSlots.current);
                nextShimmerSpawnAtRef.current = 0;
                return;
            }
            var stage = refs.stage.current;
            if (!stage) return;
            var rect = stage.getBoundingClientRect();
            if (rect.width === 0 || rect.height === 0) return;
            var stageDims = {
                width: rect.width,
                height: rect.height
            };
            motionNowRef.current += dt * 1000;
            var motionNow = motionNowRef.current;
            var ambientAmp = reduced ? 0 : cfg.ambientAmp;
            if (!reduced) (0, _dynamics.integrate)(dynStateRef.current, adjRef.current, cfg.dynamics, dt);
            offsets.clear();
            var iconMap = refs.icons.current;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = params[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, _slicedToArray._)(_step.value, 2), id = _step_value[0], p = _step_value[1];
                    var am = (0, _motion.computeAmbient)(motionNow, p, ambientAmp);
                    var dyn = dynStateRef.current.get(id);
                    var dragDx = dyn ? dyn.dispX : 0;
                    var dragDy = dyn ? dyn.dispY : 0;
                    var dx = am.dx + dragDx;
                    var dy = am.dy + dragDy;
                    offsets.set(id, {
                        dx: dx,
                        dy: dy
                    });
                    var el = iconMap === null || iconMap === void 0 ? void 0 : iconMap.get(id);
                    if (el) {
                        var scale = 1;
                        if (introWriting) {
                            var opacity = 1;
                            if (introActive) {
                                var reveal = schedule.icons.get(id);
                                if (reveal) {
                                    var t = (0, _motion.clamp01)((introElapsed - reveal.startMs) / reveal.durationMs);
                                    opacity = (0, _motion.easeOutCubic)(t);
                                    scale = (0, _intro.easeOutBack)(t, cfg.intro.iconAppearOvershoot);
                                }
                            }
                            el.style.opacity = opacity.toFixed(3);
                        }
                        el.style.transform = scale === 1 ? "translate(-50%, -50%) translate(".concat(dx.toFixed(2), "px, ").concat(dy.toFixed(2), "px)") : "translate(-50%, -50%) translate(".concat(dx.toFixed(2), "px, ").concat(dy.toFixed(2), "px) scale(").concat(scale.toFixed(3), ")");
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            var _refs_edges_current;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = ((_refs_edges_current = refs.edges.current) !== null && _refs_edges_current !== void 0 ? _refs_edges_current : [])[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var _step_value1 = (0, _slicedToArray._)(_step1.value, 2), edgeId = _step_value1[0], ed = _step_value1[1];
                    if (!ed.el) continue;
                    var aPx = offsets.get(ed.from);
                    var bPx = offsets.get(ed.to);
                    var aVb = aPx ? (0, _motion.pxToViewBox)(aPx.dx, aPx.dy, stageDims, referenceSize) : {
                        dx: 0,
                        dy: 0
                    };
                    var bVb = bPx ? (0, _motion.pxToViewBox)(bPx.dx, bPx.dy, stageDims, referenceSize) : {
                        dx: 0,
                        dy: 0
                    };
                    var ax = ed.baseX1 + aVb.dx;
                    var ay = ed.baseY1 + aVb.dy;
                    var bx = ed.baseX2 + bVb.dx;
                    var by = ed.baseY2 + bVb.dy;
                    if (!introWriting) {
                        ed.el.setAttribute('x1', ax.toFixed(2));
                        ed.el.setAttribute('y1', ay.toFixed(2));
                        ed.el.setAttribute('x2', bx.toFixed(2));
                        ed.el.setAttribute('y2', by.toFixed(2));
                        ed.liveX1 = ax;
                        ed.liveY1 = ay;
                        ed.liveX2 = bx;
                        ed.liveY2 = by;
                        continue;
                    }
                    var reveal1 = introActive ? schedule.edges.get(edgeId) : undefined;
                    var eased = reveal1 ? (0, _motion.easeOutCubic)((0, _motion.clamp01)((introElapsed - reveal1.startMs) / reveal1.durationMs)) : 1;
                    var fromIsA = reveal1 ? reveal1.fromAssetId === ed.from : true;
                    var x1 = void 0;
                    var y1 = void 0;
                    var x2 = void 0;
                    var y2 = void 0;
                    if (fromIsA) {
                        x1 = ax;
                        y1 = ay;
                        x2 = ax + (bx - ax) * eased;
                        y2 = ay + (by - ay) * eased;
                    } else {
                        x1 = bx + (ax - bx) * eased;
                        y1 = by + (ay - by) * eased;
                        x2 = bx;
                        y2 = by;
                    }
                    ed.el.setAttribute('x1', x1.toFixed(2));
                    ed.el.setAttribute('y1', y1.toFixed(2));
                    ed.el.setAttribute('x2', x2.toFixed(2));
                    ed.el.setAttribute('y2', y2.toFixed(2));
                    ed.el.setAttribute('stroke-opacity', (eased * cfg.edgeOpacity).toFixed(3));
                    ed.liveX1 = x1;
                    ed.liveY1 = y1;
                    ed.liveX2 = x2;
                    ed.liveY2 = y2;
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            var shimmerCfg = cfg.shimmer;
            var shimmerEls = refs.shimmerSlots.current;
            var shimmerSlots = shimmerStateRef.current;
            var introCompleteAt = introCleanedUpRef.current ? introCleanedUpAtRef.current : introStartRef.current > 0 ? introStartRef.current + schedule.totalMs : Number.POSITIVE_INFINITY;
            var shimmerActive = now >= introCompleteAt + shimmerCfg.startOffsetMs && !reduced && shimmerCfg.enabled && shimmerCfg.brightness > 0 && shimmerEls !== null;
            if (shimmerActive && shimmerEls) {
                if (nextShimmerSpawnAtRef.current === 0) nextShimmerSpawnAtRef.current = now + (0, _shimmer.nextPoissonInterval)(shimmerCfg.avgIntervalMs, Math.random);
                if (now >= nextShimmerSpawnAtRef.current) {
                    var freeSlot = -1;
                    for(var i = 0; i < shimmerSlots.length; i++)if (shimmerSlots[i] === null && shimmerEls[i]) {
                        freeSlot = i;
                        break;
                    }
                    if (freeSlot !== -1 && refs.edges.current.size > 0) {
                        var edgeId1 = (0, _shimmer.pickRandomEdgeId)(Array.from(refs.edges.current.keys()), Math.random);
                        if (edgeId1 !== undefined) shimmerSlots[freeSlot] = {
                            edgeId: edgeId1,
                            startMs: now,
                            durationMs: shimmerCfg.durationMs,
                            pulseLen: shimmerCfg.pulseLen
                        };
                    }
                    nextShimmerSpawnAtRef.current = now + (0, _shimmer.nextPoissonInterval)(shimmerCfg.avgIntervalMs, Math.random);
                }
                var shimmerGrads = refs.shimmerGrads.current;
                for(var i1 = 0; i1 < shimmerSlots.length; i1++){
                    var slot = shimmerSlots[i1];
                    var el1 = shimmerEls[i1];
                    if (!el1 || !slot) continue;
                    var ed1 = refs.edges.current.get(slot.edgeId);
                    if (!ed1) {
                        shimmerSlots[i1] = null;
                        el1.setAttribute('stroke-opacity', '0');
                        continue;
                    }
                    var t1 = (now - slot.startMs) / slot.durationMs;
                    if (t1 >= 1) {
                        shimmerSlots[i1] = null;
                        el1.setAttribute('stroke-opacity', '0');
                        continue;
                    }
                    var eased1 = (0, _shimmer.easeInOutSine)(t1);
                    var lead = -slot.pulseLen + eased1 * (1 + 2 * slot.pulseLen);
                    var trail = lead - slot.pulseLen;
                    var dx1 = ed1.liveX2 - ed1.liveX1;
                    var dy1 = ed1.liveY2 - ed1.liveY1;
                    el1.setAttribute('x1', ed1.liveX1.toFixed(2));
                    el1.setAttribute('y1', ed1.liveY1.toFixed(2));
                    el1.setAttribute('x2', ed1.liveX2.toFixed(2));
                    el1.setAttribute('y2', ed1.liveY2.toFixed(2));
                    el1.setAttribute('stroke-opacity', shimmerCfg.brightness.toFixed(3));
                    var grad = shimmerGrads === null || shimmerGrads === void 0 ? void 0 : shimmerGrads[i1];
                    if (grad) {
                        grad.setAttribute('x1', (ed1.liveX1 + dx1 * trail).toFixed(2));
                        grad.setAttribute('y1', (ed1.liveY1 + dy1 * trail).toFixed(2));
                        grad.setAttribute('x2', (ed1.liveX1 + dx1 * lead).toFixed(2));
                        grad.setAttribute('y2', (ed1.liveY1 + dy1 * lead).toFixed(2));
                    }
                }
            } else {
                clearShimmerSlots(shimmerSlots, shimmerEls);
                nextShimmerSpawnAtRef.current = 0;
            }
            if (introNeedsCleanup) {
                var _cfg_onIntroComplete;
                introCleanedUpRef.current = true;
                introCleanedUpAtRef.current = now;
                (_cfg_onIntroComplete = cfg.onIntroComplete) === null || _cfg_onIntroComplete === void 0 ? void 0 : _cfg_onIntroComplete.call(cfg);
            }
        };
        raf = requestAnimationFrame(tick);
        return function() {
            return cancelAnimationFrame(raf);
        };
    }, [
        params,
        referenceSize,
        refs.stage,
        refs.icons,
        refs.edges,
        refs.shimmerSlots,
        refs.shimmerGrads
    ]);
    return {
        replayIntro: replayIntro
    };
};

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_to_consumable_array":"1eSZf","react":"ltHCL","@atlaskit/browser-apis":"2dayt","./dynamics":"8CuNP","./intro":"e6G9y","./layout":"aOTT1","./motion":"7XNpA","./shimmer":"8zvpg","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8CuNP":[function(require,module,exports,__globalThis) {
/**
 * Pure mass-spring dynamics for the hero-icons stage.
 *
 * A third additive layer on top of `bigBang` and `ambient` (see
 * `motion.ts`). The integrator is plain semi-implicit Euler with
 * exponential damping and a fixed substep count for stability when the
 * host's `dt` spikes (tab blur recovery, slow frames). All positions are
 * tracked as DISPLACEMENTS from the asset's resting position, in
 * container pixels — so summing into the existing offsets map in
 * `useHeroMotion` is a no-op composition.
 *
 * The hook in `use-hero-motion.ts` owns the loop and pointer events; this
 * module is a pure transformation of state with no React or DOM
 * dependencies.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_DYNAMICS_CFG", function() {
    return DEFAULT_DYNAMICS_CFG;
});
parcelHelpers.export(exports, "createDynState", function() {
    return createDynState;
});
parcelHelpers.export(exports, "resetDynState", function() {
    return resetDynState;
});
parcelHelpers.export(exports, "buildAdjacency", function() {
    return buildAdjacency;
});
parcelHelpers.export(exports, "integrate", function() {
    return integrate;
});
var DEFAULT_DYNAMICS_CFG = {
    kSelf: 80,
    kEdge: 20,
    damping: 8,
    maxDt: 1 / 30,
    substeps: 2
};
/** Threshold (px and px/s) below which we snap to rest to avoid jitter. */ var REST_EPSILON = 0.01;
var createDynState = function(assets) {
    var out = new Map();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = assets[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var a = _step.value;
            out.set(a.id, {
                dispX: 0,
                dispY: 0,
                vx: 0,
                vy: 0,
                dragging: false
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return out;
};
var resetDynState = function(state) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = state.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var s = _step.value;
            s.dispX = 0;
            s.dispY = 0;
            s.vx = 0;
            s.vy = 0;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
};
var buildAdjacency = function(state, edges) {
    var a = [];
    var b = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = edges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var e = _step.value;
            var sa = state.get(e.from);
            var sb = state.get(e.to);
            if (!sa || !sb) continue;
            a.push(sa);
            b.push(sb);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        a: a,
        b: b
    };
};
var integrate = function(state, adj, cfg, dt) {
    if (dt <= 0) return;
    var stepDt = Math.min(dt, cfg.maxDt) / Math.max(cfg.substeps, 1);
    var decay = Math.exp(-Math.max(cfg.damping, 0) * stepDt);
    var kSelfH = cfg.kSelf * stepDt;
    var kEdgeH = cfg.kEdge * stepDt;
    for(var step = 0; step < cfg.substeps; step++){
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (kSelfH > 0) try {
            for(var _iterator = state.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var s = _step.value;
                if (s.dragging) continue;
                s.vx -= kSelfH * s.dispX;
                s.vy -= kSelfH * s.dispY;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (kEdgeH > 0) {
            var a = adj.a, b = adj.b;
            for(var i = 0; i < a.length; i++){
                var sa = a[i];
                var sb = b[i];
                var fx = -kEdgeH * (sa.dispX - sb.dispX);
                var fy = -kEdgeH * (sa.dispY - sb.dispY);
                if (!sa.dragging) {
                    sa.vx += fx;
                    sa.vy += fy;
                }
                if (!sb.dragging) {
                    sb.vx -= fx;
                    sb.vy -= fy;
                }
            }
        }
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = state.values()[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var s1 = _step1.value;
                if (s1.dragging) continue;
                s1.vx *= decay;
                s1.vy *= decay;
                s1.dispX += s1.vx * stepDt;
                s1.dispY += s1.vy * stepDt;
                if (Math.abs(s1.dispX) < REST_EPSILON && Math.abs(s1.dispY) < REST_EPSILON && Math.abs(s1.vx) < REST_EPSILON && Math.abs(s1.vy) < REST_EPSILON) {
                    s1.dispX = 0;
                    s1.dispY = 0;
                    s1.vx = 0;
                    s1.vy = 0;
                }
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"e6G9y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "easeOutBack", function() {
    return easeOutBack;
});
parcelHelpers.export(exports, "computeIntroSchedule", function() {
    return computeIntroSchedule;
});
var _motion = require("./motion");
function easeOutBack(t) {
    var overshoot = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1.7;
    if (t <= 0) return 0;
    if (t >= 1) return 1;
    var c1 = overshoot;
    var c3 = c1 + 1;
    var x = t - 1;
    return 1 + c3 * x * x * x + c1 * x * x;
}
function makeEdgeId(edge, index) {
    return "".concat(edge.from, "__").concat(edge.to, "__").concat(index);
}
function dist2(ax, ay, bx, by) {
    var dx = ax - bx;
    var dy = ay - by;
    return dx * dx + dy * dy;
}
function computeIntroSchedule(assets, edges, cfg) {
    var icons = new Map();
    var edgeReveals = new Map();
    var avatars = assets.filter(function(asset) {
        return asset.kind === 'avatar';
    });
    avatars.sort(function(a, b) {
        var da = dist2(a.x, a.y, (0, _motion.DEFAULT_MOTION_ORIGIN).x, (0, _motion.DEFAULT_MOTION_ORIGIN).y);
        var db = dist2(b.x, b.y, (0, _motion.DEFAULT_MOTION_ORIGIN).x, (0, _motion.DEFAULT_MOTION_ORIGIN).y);
        return da - db;
    });
    var totalMs = 0;
    for(var i = 0; i < avatars.length; i++){
        var startMs = i * cfg.avatarStaggerMs;
        icons.set(avatars[i].id, {
            startMs: startMs,
            durationMs: cfg.iconAppearMs
        });
        totalMs = Math.max(totalMs, startMs + cfg.iconAppearMs);
    }
    var adjacency = new Map();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = assets[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var asset = _step.value;
            adjacency.set(asset.id, []);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    for(var i1 = 0; i1 < edges.length; i1++){
        var _adjacency_get, _adjacency_get1;
        var edge = edges[i1];
        var id = makeEdgeId(edge, i1);
        (_adjacency_get = adjacency.get(edge.from)) === null || _adjacency_get === void 0 ? void 0 : _adjacency_get.push({
            edgeId: id,
            otherId: edge.to
        });
        (_adjacency_get1 = adjacency.get(edge.to)) === null || _adjacency_get1 === void 0 ? void 0 : _adjacency_get1.push({
            edgeId: id,
            otherId: edge.from
        });
    }
    var queue = [];
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = avatars[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var avatar = _step1.value;
            var reveal = icons.get(avatar.id);
            if (reveal) queue.push({
                id: avatar.id,
                readyMs: reveal.startMs + reveal.durationMs
            });
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    var assetIndex = new Map();
    for(var i2 = 0; i2 < assets.length; i2++)assetIndex.set(assets[i2].id, i2);
    var jitterFor = function(id) {
        var _assetIndex_get;
        var idx = (_assetIndex_get = assetIndex.get(id)) !== null && _assetIndex_get !== void 0 ? _assetIndex_get : 0;
        return (idx * 2654435761 >>> 0) % 60;
    };
    var head = 0;
    while(head < queue.length){
        var _queue_ = queue[head++], parentId = _queue_.id, readyMs = _queue_.readyMs;
        var incidents = adjacency.get(parentId);
        if (!incidents) continue;
        var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
        try {
            for(var _iterator2 = incidents[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                var incident = _step2.value;
                if (edgeReveals.has(incident.edgeId)) continue;
                var edgeStart = readyMs + jitterFor(incident.edgeId);
                edgeReveals.set(incident.edgeId, {
                    startMs: edgeStart,
                    durationMs: cfg.edgeGrowMs,
                    fromAssetId: parentId
                });
                totalMs = Math.max(totalMs, edgeStart + cfg.edgeGrowMs);
                if (!icons.has(incident.otherId)) {
                    var iconStart = edgeStart + cfg.edgeGrowMs * 0.6;
                    icons.set(incident.otherId, {
                        startMs: iconStart,
                        durationMs: cfg.iconAppearMs
                    });
                    totalMs = Math.max(totalMs, iconStart + cfg.iconAppearMs);
                    queue.push({
                        id: incident.otherId,
                        readyMs: iconStart + cfg.iconAppearMs
                    });
                }
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                    _iterator2.return();
                }
            } finally{
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }
    }
    var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
    if (avatars.length > 0) try {
        for(var _iterator3 = assets[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
            var asset1 = _step3.value;
            if (icons.has(asset1.id)) continue;
            var bestAvatar = avatars[0];
            var bestDist = dist2(asset1.x, asset1.y, bestAvatar.x, bestAvatar.y);
            for(var i3 = 1; i3 < avatars.length; i3++){
                var distance = dist2(asset1.x, asset1.y, avatars[i3].x, avatars[i3].y);
                if (distance < bestDist) {
                    bestDist = distance;
                    bestAvatar = avatars[i3];
                }
            }
            var anchor = icons.get(bestAvatar.id);
            var delayMs = Math.sqrt(bestDist) * 600;
            var _anchor_startMs, _anchor_durationMs;
            var startMs1 = ((_anchor_startMs = anchor === null || anchor === void 0 ? void 0 : anchor.startMs) !== null && _anchor_startMs !== void 0 ? _anchor_startMs : 0) + ((_anchor_durationMs = anchor === null || anchor === void 0 ? void 0 : anchor.durationMs) !== null && _anchor_durationMs !== void 0 ? _anchor_durationMs : 0) + delayMs;
            icons.set(asset1.id, {
                startMs: startMs1,
                durationMs: cfg.iconAppearMs
            });
            totalMs = Math.max(totalMs, startMs1 + cfg.iconAppearMs);
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                _iterator3.return();
            }
        } finally{
            if (_didIteratorError3) {
                throw _iteratorError3;
            }
        }
    }
    else {
        var _iteratorNormalCompletion4 = true, _didIteratorError4 = false, _iteratorError4 = undefined;
        try {
            for(var _iterator4 = assets[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true){
                var asset2 = _step4.value;
                icons.set(asset2.id, {
                    startMs: 0,
                    durationMs: cfg.iconAppearMs
                });
            }
        } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                    _iterator4.return();
                }
            } finally{
                if (_didIteratorError4) {
                    throw _iteratorError4;
                }
            }
        }
        totalMs = Math.max(totalMs, cfg.iconAppearMs);
    }
    return {
        icons: icons,
        edges: edgeReveals,
        totalMs: totalMs
    };
}

},{"./motion":"7XNpA","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7XNpA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_MOTION_ORIGIN", function() {
    return DEFAULT_MOTION_ORIGIN;
});
parcelHelpers.export(exports, "easeOutCubic", function() {
    return easeOutCubic;
});
parcelHelpers.export(exports, "clamp01", function() {
    return clamp01;
});
parcelHelpers.export(exports, "mulberry32", function() {
    return mulberry32;
});
parcelHelpers.export(exports, "hashSeed", function() {
    return hashSeed;
});
parcelHelpers.export(exports, "computeAssetParams", function() {
    return computeAssetParams;
});
parcelHelpers.export(exports, "computeAmbient", function() {
    return computeAmbient;
});
parcelHelpers.export(exports, "pxToViewBox", function() {
    return pxToViewBox;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _layout = require("./layout");
var DEFAULT_MOTION_ORIGIN = (0, _layout.MOTION_ORIGIN);
var easeOutCubic = function(t) {
    if (t <= 0) return 0;
    if (t >= 1) return 1;
    return 1 - Math.pow(1 - t, 3);
};
var clamp01 = function(x) {
    return x < 0 ? 0 : x > 1 ? 1 : x;
};
var mulberry32 = function(seed) {
    var s = seed >>> 0;
    return function() {
        s = s + 0x6d2b79f5 >>> 0;
        var t = s;
        t = Math.imul(t ^ t >>> 15, t | 1);
        t ^= t + Math.imul(t ^ t >>> 7, t | 61);
        return ((t ^ t >>> 14) >>> 0) / 4294967296;
    };
};
var hashSeed = function(input) {
    var h = 0x811c9dc5;
    for(var i = 0; i < input.length; i++){
        h ^= input.charCodeAt(i);
        h = Math.imul(h, 0x01000193);
    }
    return h >>> 0;
};
var computeAssetParams = function(assets) {
    var motionOrigin = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : DEFAULT_MOTION_ORIGIN;
    var _Math, _Math1, _Math2;
    var widths = assets.map(function(a) {
        return a.width;
    });
    var minW = (_Math = Math).min.apply(_Math, (0, _toConsumableArray._)(widths));
    var maxW = (_Math1 = Math).max.apply(_Math1, (0, _toConsumableArray._)(widths));
    var widthRange = Math.max(maxW - minW, 1e-6);
    // Bigger icons read as closer (positive z), smaller as farther (negative z).
    var zOf = function(a) {
        return a.z !== undefined ? a.z : (a.width - minW) / widthRange * 2 - 1;
    };
    var dists = assets.map(function(a) {
        return Math.hypot(a.x - motionOrigin.x, a.y - motionOrigin.y);
    });
    var maxDist = (_Math2 = Math).max.apply(_Math2, (0, _toConsumableArray._)(dists).concat([
        1e-6
    ]));
    var out = new Map();
    for(var i = 0; i < assets.length; i++){
        var asset = assets[i];
        var rnd = mulberry32(hashSeed(asset.id));
        var z = zOf(asset);
        var normZ = (z + 1) / 2;
        // Closer items get larger ambient amplitude (sells depth without true 3D).
        var ampScale = 0.4 + 1.0 * normZ;
        out.set(asset.id, {
            id: asset.id,
            restX: asset.x,
            restY: asset.y,
            z: z,
            normZ: normZ,
            distFactor: dists[i] / maxDist,
            jitterFactor: rnd(),
            durationFactor: rnd(),
            ampX: (2 + rnd() * 4) * ampScale,
            ampY: (2 + rnd() * 4) * ampScale,
            freqX: 0.00035 + rnd() * 0.00025,
            freqY: 0.00035 + rnd() * 0.00025,
            phaseX: rnd() * Math.PI * 2,
            phaseY: rnd() * Math.PI * 2
        });
    }
    return out;
};
var computeAmbient = function(nowMs, params, ampMultiplier) {
    if (ampMultiplier <= 0) return {
        dx: 0,
        dy: 0
    };
    return {
        dx: Math.sin(nowMs * params.freqX + params.phaseX) * params.ampX * ampMultiplier,
        dy: Math.cos(nowMs * params.freqY + params.phaseY) * params.ampY * ampMultiplier
    };
};
var pxToViewBox = function(dxPx, dyPx, box) {
    var referenceSize = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
        width: (0, _layout.REFERENCE_WIDTH),
        height: (0, _layout.REFERENCE_HEIGHT)
    };
    return {
        dx: box.width > 0 ? dxPx / box.width * referenceSize.width : 0,
        dy: box.height > 0 ? dyPx / box.height * referenceSize.height : 0
    };
};

},{"@swc/helpers/_/_to_consumable_array":"1eSZf","./layout":"aOTT1","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8zvpg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nextPoissonInterval", function() {
    return nextPoissonInterval;
});
parcelHelpers.export(exports, "pickRandomEdgeId", function() {
    return pickRandomEdgeId;
});
parcelHelpers.export(exports, "easeInOutSine", function() {
    return easeInOutSine;
});
function nextPoissonInterval(avgMs, rand) {
    var mean = Math.max(1, avgMs);
    var u = Math.min(0.999999, Math.max(1e-9, rand()));
    return -Math.log(1 - u) * mean;
}
function pickRandomEdgeId(edgeIds, rand) {
    if (edgeIds.length === 0) return undefined;
    var i = Math.min(edgeIds.length - 1, Math.floor(rand() * edgeIds.length));
    return edgeIds[i];
}
function easeInOutSine(t) {
    if (t <= 0) return 0;
    if (t >= 1) return 1;
    return 0.5 - 0.5 * Math.cos(Math.PI * t);
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dJjMS":[function(require,module,exports,__globalThis) {
/* ContentStack.tsx generated by @compiled/babel-plugin v0.39.1 */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ /* eslint-disable @atlaskit/design-system/use-primitives-text */ /* eslint-disable @atlaskit/design-system/use-heading */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ContentStack", function() {
    return ContentStack;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _reactIntl = require("react-intl");
var _useAnalyticsEvents = require("../../../common/analytics/generated/use-analytics-events");
var _useUserContext = require("../../../hooks/use-user-context");
var _messages = require("./messages");
var _heroTypographyWordmarkConstants = require("./typography/hero-typography-wordmark-constants");
var _heroTypographyWordmark = require("./typography/HeroTypographyWordmark");
var _useMediaQuery = require("./use-media-query");
var WORDMARK_WIDE_VIEWPORT_QUERY = '(min-width: 769px)';
var WORDMARK_MAX_WIDTH = {
    base: 'min(800px, calc(100vw - 96px))',
    wide: 'min(800px, calc(100vw - 256px))'
};
var CONTENT_SPECS = {
    desktop: {
        wordmarkDescriptionGap: '40px',
        descriptionCtaGap: '40px',
        descriptionMaxWidth: '640px',
        descriptionFontSize: '32px',
        verticalOffset: '0px'
    },
    compact: {
        wordmarkDescriptionGap: '32px',
        descriptionCtaGap: '32px',
        descriptionMaxWidth: '600px',
        descriptionFontSize: '28px',
        verticalOffset: '0px'
    },
    mobile: {
        wordmarkDescriptionGap: 'clamp(18px, 3.5dvh, 24px)',
        descriptionCtaGap: 'clamp(20px, 4dvh, 28px)',
        descriptionMaxWidth: 'min(82vw, 390px)',
        descriptionFontSize: 'clamp(22px, 6vw, 26px)',
        verticalOffset: 'clamp(0px, 2dvh, 24px)'
    }
};
var styles = {
    overlay: "_1r04idpf _kqswstnw _1e0c1txw _4cvr1h6o _1bah1h6o _lcxvglyw _y3gn1h6o _1pbycs5v",
    stack: "_1e0c1txw _1bsb1osq _2lx21bp4 _4cvr1h6o _lcxvglyw",
    wordmarkFrame: "_1bsb1osq _lcxvglyw",
    lowerStack: "_1e0c1txw _1o9zidpf _2lx21bp4 _4cvr1h6o _1bahesu3 _lcxvglyw",
    subtitle: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _lcxv1wug _y3gn1h6o _k48p1nn1 _1dyz1h92 _syaz756n _ect41t23 _vwz4cjiy _m6k4brmi _t9ec1aqe",
    ctaWrapper: "_1e0c116y _lcxv1wug _m6k4brmi _t9ec1aqe",
    ctaButton: "_zulp12x7 _2rko1qi0 _11c8fhey _v5641ux5 _18zrsm30 _1rjccy7w _189e1lya _1dqonqa1 _1h6d1e01 _r06hglyw _wstuglyw _1e0c1txw _4cvr1h6o _bfhk1hlk _80omtlke _1pbykb7n _vwz4gktf _syaz14je _k48p1wq8 _irr31dpa"
};
function useDelayedReveal(delayMs, resetKey) {
    var initiallyVisible = delayMs <= 0;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(initiallyVisible), 2), visible = _useState[0], setVisible = _useState[1];
    (0, _react.useEffect)(function() {
        if (initiallyVisible) return;
        setVisible(false);
        var id = window.setTimeout(function() {
            return setVisible(true);
        }, delayMs);
        return function() {
            return window.clearTimeout(id);
        };
    }, [
        delayMs,
        initiallyVisible,
        resetKey
    ]);
    return visible;
}
function ContentStack(param) {
    var mountKey = param.mountKey, viewportTier = param.viewportTier, hero = param.hero, letterA = param.letterA, scribble = param.scribble, letterIntro = param.letterIntro, cta = param.cta, _param_reducedMotion = param.reducedMotion, reducedMotion = _param_reducedMotion === void 0 ? false : _param_reducedMotion;
    var formatMessage = (0, _reactIntl.useIntl)().formatMessage;
    var attemptUserLogin = (0, _useUserContext.useAtlassianUserContext)().attemptUserLogin;
    var fireEvent = (0, _useAnalyticsEvents.useAnalyticsEvents)().fireEvent;
    var handleCtaClick = (0, _react.useCallback)(function() {
        fireEvent('ui.button.clicked.twgMicrositeLogin', {
            location: 'heroPreviewCta'
        });
        attemptUserLogin();
    }, [
        fireEvent,
        attemptUserLogin
    ]);
    var effectiveSubtitleStart = reducedMotion ? 0 : cta.subtitleStartMs;
    var effectiveCtaStart = reducedMotion ? 0 : cta.ctaStartMs;
    var effectiveSubtitleFadeMs = reducedMotion ? 0 : cta.subtitleFadeMs;
    var effectiveCtaFadeMs = reducedMotion ? 0 : cta.ctaFadeMs;
    var subtitleVisible = useDelayedReveal(effectiveSubtitleStart, mountKey);
    var ctaVisible = useDelayedReveal(effectiveCtaStart, mountKey);
    var contentSpec = CONTENT_SPECS[viewportTier];
    var wordmarkMaxWidth = (0, _useMediaQuery.useMediaQuery)(WORDMARK_WIDE_VIEWPORT_QUERY) ? WORDMARK_MAX_WIDTH.wide : WORDMARK_MAX_WIDTH.base;
    return /*#__PURE__*/ _react.createElement("div", {
        key: mountKey,
        style: {
            transform: "translateY(".concat(contentSpec.verticalOffset, ")")
        },
        className: (0, _runtime.ax)([
            styles.overlay
        ])
    }, /*#__PURE__*/ _react.createElement("div", {
        style: {
            maxWidth: wordmarkMaxWidth,
            gap: contentSpec.wordmarkDescriptionGap
        },
        className: (0, _runtime.ax)([
            styles.stack
        ])
    }, /*#__PURE__*/ _react.createElement("div", {
        style: {
            aspectRatio: "".concat((0, _heroTypographyWordmarkConstants.HERO_TYPOGRAPHY_WORDMARK_VIEWBOX).width, " / ").concat((0, _heroTypographyWordmarkConstants.HERO_TYPOGRAPHY_WORDMARK_VIEWBOX).height)
        },
        className: (0, _runtime.ax)([
            styles.wordmarkFrame
        ])
    }, /*#__PURE__*/ _react.createElement((0, _heroTypographyWordmark.HeroTypographyWordmark), {
        accessibleName: formatMessage((0, _messages.messages).heroName),
        heroScale: hero.scale,
        letterALineWidth: letterA.lineWidth,
        letterADurationMs: letterA.durationMs,
        letterAStartTimeMs: letterA.startTimeMs,
        letterANodePhaseStart: letterA.nodePhaseStart,
        letterANodePhaseEnd: letterA.nodePhaseEnd,
        letterAShuffleNodes: letterA.shuffleNodes,
        letterAShuffleSeed: letterA.shuffleSeed,
        scribbleDurationMs: scribble.durationMs,
        scribbleStartTimeMs: scribble.startTimeMs,
        scribbleEase: scribble.ease,
        scribbleLineWidth: scribble.lineWidth,
        scribbleBlurPx: scribble.blurPx,
        letterIntroTotalDurationMs: letterIntro.totalDurationMs,
        letterIntroStartDelayMs: letterIntro.startDelayMs,
        letterIntroShuffleSeed: letterIntro.shuffleSeed,
        letterIntroStyle: letterIntro.style,
        letterIntroFadeDurationMs: letterIntro.fadeDurationMs,
        letterIntroBlurStartPx: letterIntro.blurStartPx,
        reducedMotion: reducedMotion
    })), /*#__PURE__*/ _react.createElement("div", {
        style: {
            gap: contentSpec.descriptionCtaGap
        },
        className: (0, _runtime.ax)([
            styles.lowerStack
        ])
    }, /*#__PURE__*/ _react.createElement("p", {
        style: {
            fontSize: contentSpec.descriptionFontSize,
            maxWidth: contentSpec.descriptionMaxWidth,
            opacity: subtitleVisible ? 1 : 0,
            visibility: subtitleVisible ? 'visible' : 'hidden',
            transition: "opacity ".concat(effectiveSubtitleFadeMs, "ms ease-out")
        },
        className: (0, _runtime.ax)([
            styles.subtitle
        ])
    }, /*#__PURE__*/ _react.createElement((0, _reactIntl.FormattedMessage), (0, _messages.messages).subtitle)), /*#__PURE__*/ _react.createElement("span", {
        style: {
            opacity: ctaVisible ? 1 : 0,
            visibility: ctaVisible ? 'visible' : 'hidden',
            transition: "opacity ".concat(effectiveCtaFadeMs, "ms ease-out")
        },
        className: (0, _runtime.ax)([
            styles.ctaWrapper
        ])
    }, /*#__PURE__*/ _react.createElement("button", {
        onClick: handleCtaClick,
        className: (0, _runtime.ax)([
            styles.ctaButton
        ])
    }, /*#__PURE__*/ _react.createElement((0, _reactIntl.FormattedMessage), (0, _messages.messages).previewCta))))));
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","react":"ltHCL","@compiled/react/runtime":"d27Vo","react-intl":"f41fF","../../../common/analytics/generated/use-analytics-events":"hpATH","../../../hooks/use-user-context":"6Qevx","./messages":"5rf9o","./typography/hero-typography-wordmark-constants":"4Os3L","./typography/HeroTypographyWordmark":"2bEBH","./use-media-query":"1jDzn","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4Os3L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HERO_TYPOGRAPHY_WORDMARK_VIEWBOX", function() {
    return HERO_TYPOGRAPHY_WORDMARK_VIEWBOX;
});
var HERO_TYPOGRAPHY_WORDMARK_VIEWBOX = {
    width: 904,
    height: 346
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2bEBH":[function(require,module,exports,__globalThis) {
/* HeroTypographyWordmark.tsx generated by @compiled/babel-plugin v0.39.1 */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable @atlaskit/design-system/use-heading */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HeroTypographyWordmark", function() {
    return HeroTypographyWordmark;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _runtime = require("@compiled/react/runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _heroTypographyWordmarkConstants = require("./hero-typography-wordmark-constants");
var _letterA = require("./LetterA");
var _scribble = require("./Scribble");
var HERO_VIEWBOX_WIDTH = (0, _heroTypographyWordmarkConstants.HERO_TYPOGRAPHY_WORDMARK_VIEWBOX).width;
var HERO_VIEWBOX_HEIGHT = (0, _heroTypographyWordmarkConstants.HERO_TYPOGRAPHY_WORDMARK_VIEWBOX).height;
var STATIC_LETTERS_PATH = [
    'M638.732 338.001v-146h24.999v58.6h39.198v-58.6h24.998v146h-24.998v-64.2h-39.198v64.2zM524.818 338.001v-146h48.598q14.598 0 25.398 5.6 11 5.6 16.999 15.8 6 10 6 23.6 0 13.4-6.2 23.6-6 10.2-16.799 15.8-10.8 5.6-25.398 5.6h-23.599v56zm24.999-78.6h23.599q10.398 0 16.599-6 6.399-6.2 6.399-16.4 0-10.4-6.399-16.4-6.201-6-16.599-6h-23.599zM224.003 160.001l36.798-146h32.198l36.998 146h-25.599l-7.999-35.4h-38.798l-8 35.4zm38.198-55.8h29.598l-8.8-39.2a982 982 0 0 1-3.799-17.6q-1.6-8-2.2-11.6-.6 3.6-2.2 11.6-1.4 7.8-3.8 17.4z',
    'M287.788 338.001v-146h46.197q14.6 0 25.199 5.4 10.799 5.4 16.799 15.2 6 9.6 6 22.8 0 14.4-7.4 25.4-7.2 11-19.599 15.6l28.998 61.6h-27.998l-25.398-58h-17.799v58zm24.999-80h21.198q10.6 0 16.599-5.8t6-16q0-10.4-6-16.2-5.999-6-16.599-6h-21.198zM223.47 340.001q-13.999 0-24.599-5.2-10.398-5.4-16.199-15-5.6-9.8-5.599-23v-63.6q0-13.4 5.599-23 5.8-9.6 16.199-14.8 10.6-5.4 24.599-5.4 14.199 0 24.399 5.4 10.399 5.2 16.199 14.8 5.799 9.6 5.799 23h-25.198q0-10.4-5.6-15.8-5.4-5.4-15.599-5.4t-15.799 5.4-5.6 15.6v63.8q0 10.2 5.6 15.8t15.799 5.6 15.599-5.6q5.6-5.6 5.6-15.8v-14.8H219.87v-21.6h49.997v36.4q0 13.2-5.799 23-5.8 9.6-16.199 15-10.2 5.2-24.399 5.2M805.406 160.001v-146h24.999v59h17.399l27.398-59h27.199l-32.599 70 34.198 76h-27.798l-28.798-64.2h-16.999v64.2zM693.49 160.001v-146h46.198q14.598 0 25.198 5.4 10.8 5.4 16.799 15.2 6 9.6 6 22.8 0 14.4-7.4 25.4-7.2 11-19.599 15.6l28.999 61.6h-27.999l-25.398-58h-17.799v58zm24.999-80h21.199q10.599 0 16.599-5.8 5.999-5.8 5.999-16 0-10.4-5.999-16.2-6-6-16.599-6h-21.199zM473.659 160.001l-14.999-146h21.599l8.799 94q.4 3.4.6 8.4.4 4.8.6 9.8.4 5 .4 8.8.4-3.8.8-8.8t.8-9.8q.6-5 1-8.4l11.999-94h20.999l11.2 94q.6 3.4.999 8.4.6 4.8 1.2 9.8t1 8.8q.2-3.8.4-8.8t.4-9.8q.4-5 .8-8.4l8.6-94h21.398l-15.799 146h-27.598l-10.799-94.4q-.4-3.8-1-8.8-.4-5.2-.8-10.2a421 421 0 0 1-.6-8.8q-.2 3.6-.8 8.8-.4 5-.8 10.2a358 358 0 0 1-.8 8.8l-11.799 94.4zM345.745 160.001v-146h29.598l14.2 46.4q2.2 7 3.599 12.8 1.401 5.8 1.8 8.4.4-2.6 1.8-8.4t3.4-12.8l13.599-46.4h29.598v146h-23.398v-45.4q0-10 .6-21.8t1.4-23.6a851 851 0 0 1 1.8-22.4c.799-7.067 1.466-9.267 1.999-14.6l-19.598 73h-22.799l-20.199-73c.667 5.067 1.333 7.067 2 14a736 736 0 0 1 1.8 22q1 11.6 1.6 23.6t.6 22.8v45.4zM121.315 160.001v-146h87.595v21.8h-62.997v38h55.997v21.6h-55.997v42.8h62.997v21.8zM38.198 160.001v-122.8H0v-23.2h101.594v23.2H63.396v122.8z'
].join(' ');
var LETTER_A_BOX = {
    x: 393.387,
    y: 184.501,
    width: 122,
    height: 161
};
var SCRIBBLE_BOX = {
    x: 525,
    y: 0,
    width: 195,
    height: 168
};
var SCRIBBLE_EASE_PRESETS = {
    linear: [
        0,
        0,
        1,
        1
    ],
    'ease-in': [
        0.55,
        0.055,
        0.675,
        0.19
    ],
    'ease-out': [
        0.215,
        0.61,
        0.355,
        1
    ],
    'ease-in-out': [
        0.645,
        0.045,
        0.355,
        1
    ],
    'back-out': [
        0.34,
        1.56,
        0.64,
        1
    ]
};
var styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11c81kw7 _kqswh2mm _1bsb1osq _4t3i1osq _k48p1kw7 _syaz1kw7",
    svgLayer: "_1r04idpf _kqswstnw _1bsb1osq _4t3i1osq _lswuglyw",
    decorativeLayer: "_1e0c1ule _1bsb1osq _4t3i1osq _uiztglyw",
    absolute: "_kqswstnw"
};
var VISUALLY_HIDDEN_STYLE = {
    position: 'absolute',
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    whiteSpace: 'nowrap',
    border: 0
};
function splitLetterSubpaths(combined) {
    var _combined_match;
    return (_combined_match = combined.match(/M[^M]*/g)) !== null && _combined_match !== void 0 ? _combined_match : [];
}
function mulberry32(seed) {
    var state = seed >>> 0 || 1;
    return function() {
        state = state + 0x6d2b79f5 >>> 0;
        var t = state;
        t = Math.imul(t ^ t >>> 15, t | 1);
        t ^= t + Math.imul(t ^ t >>> 7, t | 61);
        return ((t ^ t >>> 14) >>> 0) / 4294967296;
    };
}
function buildShuffledOrder(count, seed) {
    var order = Array.from({
        length: count
    }, function(_, i) {
        return i;
    });
    var rand = mulberry32(seed);
    for(var i = order.length - 1; i > 0; i--){
        var j = Math.floor(rand() * (i + 1));
        var ref;
        ref = [
            order[j],
            order[i]
        ], order[i] = ref[0], order[j] = ref[1], ref;
    }
    return order;
}
function pct(value, total) {
    return "".concat(value / total * 100, "%");
}
function IntroDelayAfterMount(param) {
    var delayMs = param.delayMs, children = param.children;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), mounted = _useState[0], setMounted = _useState[1];
    (0, _react.useEffect)(function() {
        var id = window.setTimeout(function() {
            return setMounted(true);
        }, delayMs);
        return function() {
            return window.clearTimeout(id);
        };
    }, [
        delayMs
    ]);
    return mounted ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, children) : null;
}
function IntroDelay(param) {
    var delayMs = param.delayMs, children = param.children;
    if (delayMs <= 0) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, children);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(IntroDelayAfterMount, {
        delayMs: delayMs
    }, children);
}
function useStaggeredVisibility(delaysMs) {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(function() {
        return delaysMs.map(function(delay) {
            return delay <= 0;
        });
    }), 2), visible = _useState[0], setVisible = _useState[1];
    (0, _react.useEffect)(function() {
        var initial = delaysMs.map(function(delay) {
            return delay <= 0;
        });
        if (initial.every(Boolean)) return;
        setVisible(initial);
        var timers = [];
        delaysMs.forEach(function(delay, i) {
            if (delay <= 0) return;
            var id = window.setTimeout(function() {
                setVisible(function(prev) {
                    if (prev[i]) return prev;
                    var next = prev.slice();
                    next[i] = true;
                    return next;
                });
            }, delay);
            timers.push(id);
        });
        return function() {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = timers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var id = _step.value;
                    window.clearTimeout(id);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        };
    }, [
        delaysMs
    ]);
    return visible;
}
function StaticLetters(param) {
    var paths = param.paths, delaysMs = param.delaysMs, fill = param.fill, style = param.style, fadeDurationMs = param.fadeDurationMs, blurStartPx = param.blurStartPx, reducedMotion = param.reducedMotion;
    var visible = useStaggeredVisibility(reducedMotion ? paths.map(function() {
        return 0;
    }) : delaysMs);
    var transition;
    if (style === 'fade-in') transition = "opacity ".concat(fadeDurationMs, "ms ease-out");
    else if (style === 'fade-in-blur') transition = "opacity ".concat(fadeDurationMs, "ms ease-out, filter ").concat(fadeDurationMs, "ms ease-out");
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 ".concat(HERO_VIEWBOX_WIDTH, " ").concat(HERO_VIEWBOX_HEIGHT),
        "aria-hidden": true,
        className: (0, _runtime.ax)([
            styles.svgLayer
        ])
    }, paths.map(function(d, i) {
        var isVisible = reducedMotion || visible[i];
        var filter = style === 'fade-in-blur' ? "blur(".concat(isVisible ? 0 : blurStartPx, "px)") : undefined;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
            key: d,
            fill: fill,
            d: d,
            style: {
                opacity: isVisible ? 1 : 0,
                transition: reducedMotion ? undefined : transition,
                filter: filter
            }
        });
    }));
}
function HeroTypographyWordmark(param) {
    var heroScale = param.heroScale, letterALineWidth = param.letterALineWidth, letterADurationMs = param.letterADurationMs, letterAStartTimeMs = param.letterAStartTimeMs, letterANodePhaseStart = param.letterANodePhaseStart, letterANodePhaseEnd = param.letterANodePhaseEnd, letterAShuffleNodes = param.letterAShuffleNodes, letterAShuffleSeed = param.letterAShuffleSeed, scribbleDurationMs = param.scribbleDurationMs, scribbleStartTimeMs = param.scribbleStartTimeMs, scribbleEase = param.scribbleEase, scribbleLineWidth = param.scribbleLineWidth, scribbleBlurPx = param.scribbleBlurPx, letterIntroTotalDurationMs = param.letterIntroTotalDurationMs, letterIntroStartDelayMs = param.letterIntroStartDelayMs, letterIntroShuffleSeed = param.letterIntroShuffleSeed, letterIntroStyle = param.letterIntroStyle, letterIntroFadeDurationMs = param.letterIntroFadeDurationMs, letterIntroBlurStartPx = param.letterIntroBlurStartPx, accessibleName = param.accessibleName, _param_reducedMotion = param.reducedMotion, reducedMotion = _param_reducedMotion === void 0 ? false : _param_reducedMotion;
    var _SCRIBBLE_EASE_PRESETS_scribbleEase;
    var ease = (_SCRIBBLE_EASE_PRESETS_scribbleEase = SCRIBBLE_EASE_PRESETS[scribbleEase]) !== null && _SCRIBBLE_EASE_PRESETS_scribbleEase !== void 0 ? _SCRIBBLE_EASE_PRESETS_scribbleEase : SCRIBBLE_EASE_PRESETS['ease-in'];
    var letterPaths = (0, _react.useMemo)(function() {
        return splitLetterSubpaths(STATIC_LETTERS_PATH);
    }, []);
    var letterDelaysMs = (0, _react.useMemo)(function() {
        var count = letterPaths.length;
        if (count === 0) return [];
        var order = buildShuffledOrder(count, letterIntroShuffleSeed);
        return order.map(function(slot) {
            var t = count <= 1 ? 0 : slot / (count - 1);
            return letterIntroStartDelayMs + t * letterIntroTotalDurationMs;
        });
    }, [
        letterPaths.length,
        letterIntroShuffleSeed,
        letterIntroTotalDurationMs,
        letterIntroStartDelayMs
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("h1", {
        style: {
            transform: "scale(".concat(heroScale, ")"),
            transformOrigin: 'center center'
        },
        className: (0, _runtime.ax)([
            styles.root
        ])
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        style: VISUALLY_HIDDEN_STYLE
    }, accessibleName), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        "aria-hidden": "true",
        className: (0, _runtime.ax)([
            styles.decorativeLayer
        ])
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(StaticLetters, {
        paths: letterPaths,
        delaysMs: letterDelaysMs,
        fill: "#f0f1f2",
        style: letterIntroStyle,
        fadeDurationMs: letterIntroFadeDurationMs,
        blurStartPx: letterIntroBlurStartPx,
        reducedMotion: reducedMotion
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            left: pct(LETTER_A_BOX.x, HERO_VIEWBOX_WIDTH),
            top: pct(LETTER_A_BOX.y, HERO_VIEWBOX_HEIGHT),
            width: pct(LETTER_A_BOX.width, HERO_VIEWBOX_WIDTH),
            height: pct(LETTER_A_BOX.height, HERO_VIEWBOX_HEIGHT)
        },
        className: (0, _runtime.ax)([
            styles.absolute
        ])
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(IntroDelay, {
        delayMs: reducedMotion ? 0 : letterAStartTimeMs
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _letterA.LetterA), {
        strokeColor: "#ffffff",
        strokeWidth: letterALineWidth,
        durationMs: letterADurationMs,
        nodePhaseStart: letterANodePhaseStart,
        nodePhaseEnd: letterANodePhaseEnd,
        shuffleNodes: letterAShuffleNodes,
        shuffleSeed: letterAShuffleSeed,
        reducedMotion: reducedMotion
    }))), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            left: pct(SCRIBBLE_BOX.x, HERO_VIEWBOX_WIDTH),
            top: pct(SCRIBBLE_BOX.y, HERO_VIEWBOX_HEIGHT),
            width: pct(SCRIBBLE_BOX.width, HERO_VIEWBOX_WIDTH),
            height: pct(SCRIBBLE_BOX.height, HERO_VIEWBOX_HEIGHT)
        },
        className: (0, _runtime.ax)([
            styles.absolute
        ])
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(IntroDelay, {
        delayMs: reducedMotion ? 0 : scribbleStartTimeMs
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _scribble.Scribble), {
        durationMs: scribbleDurationMs,
        ease: ease,
        color: "#FFC716",
        lineWidth: scribbleLineWidth,
        blurPx: scribbleBlurPx,
        reducedMotion: reducedMotion
    })))));
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","@compiled/react/runtime":"d27Vo","react":"ltHCL","./hero-typography-wordmark-constants":"4Os3L","./LetterA":"5FH2y","./Scribble":"cQ6bk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5FH2y":[function(require,module,exports,__globalThis) {
/* LetterA.tsx generated by @compiled/babel-plugin v0.39.1 */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ /* eslint-disable @atlaskit/ui-styling-standard/no-classname-prop */ /* eslint-disable @atlaskit/ui-styling-standard/no-global-styles */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LetterA", function() {
    return LetterA;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _letterAData = require("./letter-a-data");
var NODE_KEYFRAMES = 'twgHeroLetterANodeIn';
var EDGE_KEYFRAMES = 'twgHeroLetterAEdgeDraw';
var OUTLINE_KEYFRAMES = 'twgHeroLetterAOutlineDraw';
var NODE_CLASS = 'twg-hero-letter-a__node';
var EDGE_CLASS = 'twg-hero-letter-a__edge';
var OUTLINE_CLASS = 'twg-hero-letter-a__outline';
var NODE_REVEAL_MS = 220;
var EDGE_REVEAL_MS = 320;
var OUTLINE_PHASE_END = 0.7;
var EDGES_PHASE_START = 0.25;
var EDGES_PHASE_END = 0.85;
var DEFAULT_NODES_PHASE_START = 0.35;
var DEFAULT_NODES_PHASE_END = 1.0;
var DEFAULT_EASE = [
    0.34,
    1.56,
    0.64,
    1.0
];
function makeBezierEasing(param) {
    var _param = (0, _slicedToArray._)(param, 4), x1 = _param[0], y1 = _param[1], x2 = _param[2], y2 = _param[3];
    var bezX = function(t) {
        var u = 1 - t;
        return 3 * u * u * t * x1 + 3 * u * t * t * x2 + t * t * t;
    };
    var bezY = function(t) {
        var u = 1 - t;
        return 3 * u * u * t * y1 + 3 * u * t * t * y2 + t * t * t;
    };
    var bezDX = function(t) {
        var u = 1 - t;
        return 3 * u * u * x1 + 6 * u * t * (x2 - x1) + 3 * t * t * (1 - x2);
    };
    return function(x) {
        if (x <= 0) return 0;
        if (x >= 1) return 1;
        var t = x;
        for(var i = 0; i < 8; i++){
            var xt = bezX(t);
            var dx = bezDX(t);
            if (dx === 0) break;
            var dt = (xt - x) / dx;
            t -= dt;
            if (Math.abs(dt) < 1e-6) break;
        }
        return bezY(t);
    };
}
function edgeLength(a, b) {
    return Math.hypot(b.x - a.x, b.y - a.y);
}
function mulberry32(seed) {
    var state = (seed | 0) + 0x6d2b79f5;
    return function() {
        state = state + 0x6d2b79f5 | 0;
        var t = state;
        t = Math.imul(t ^ t >>> 15, t | 1);
        t ^= t + Math.imul(t ^ t >>> 7, t | 61);
        return ((t ^ t >>> 14) >>> 0) / 4294967296;
    };
}
function buildRevealOrder(count, shuffle, seed) {
    var order = Array.from({
        length: count
    }, function(_, i) {
        return i;
    });
    if (!shuffle || count < 2) return order;
    var rand = mulberry32(seed);
    for(var i = count - 1; i > 0; i--){
        var j = Math.floor(rand() * (i + 1));
        var ref;
        ref = [
            order[j],
            order[i]
        ], order[i] = ref[0], order[j] = ref[1], ref;
    }
    return order;
}
function LetterA(param) {
    var _param_durationMs = param.durationMs, durationMs = _param_durationMs === void 0 ? 1000 : _param_durationMs, _param_ease = param.ease, ease = _param_ease === void 0 ? DEFAULT_EASE : _param_ease, _param_strokeColor = param.strokeColor, strokeColor = _param_strokeColor === void 0 ? '#ffffff' : _param_strokeColor, _param_strokeWidth = param.strokeWidth, strokeWidth = _param_strokeWidth === void 0 ? 2 : _param_strokeWidth, _param_nodePhaseStart = param.nodePhaseStart, nodePhaseStart = _param_nodePhaseStart === void 0 ? DEFAULT_NODES_PHASE_START : _param_nodePhaseStart, _param_nodePhaseEnd = param.nodePhaseEnd, nodePhaseEnd = _param_nodePhaseEnd === void 0 ? DEFAULT_NODES_PHASE_END : _param_nodePhaseEnd, _param_shuffleNodes = param.shuffleNodes, shuffleNodes = _param_shuffleNodes === void 0 ? false : _param_shuffleNodes, _param_shuffleSeed = param.shuffleSeed, shuffleSeed = _param_shuffleSeed === void 0 ? 0 : _param_shuffleSeed, _param_reducedMotion = param.reducedMotion, reducedMotion = _param_reducedMotion === void 0 ? false : _param_reducedMotion;
    var easeFn = makeBezierEasing(ease);
    var outlineWindowMs = reducedMotion ? 0 : Math.max(0, durationMs * OUTLINE_PHASE_END);
    var edgeWindowStartMs = reducedMotion ? 0 : durationMs * EDGES_PHASE_START;
    var edgeWindowMs = reducedMotion ? 0 : Math.max(0, durationMs * (EDGES_PHASE_END - EDGES_PHASE_START) - EDGE_REVEAL_MS);
    var nodeStart = Math.max(0, Math.min(1, nodePhaseStart));
    var nodeEnd = Math.max(nodeStart, Math.min(1, nodePhaseEnd));
    var nodeWindowStartMs = reducedMotion ? 0 : durationMs * nodeStart;
    var nodeWindowMs = reducedMotion ? 0 : Math.max(0, durationMs * (nodeEnd - nodeStart) - NODE_REVEAL_MS);
    var nodeCount = (0, _letterAData.LETTER_A_NODES).length;
    var edgeCount = (0, _letterAData.LETTER_A_EDGES).length;
    var revealOrder = buildRevealOrder(nodeCount, shuffleNodes, shuffleSeed);
    var revealPosition = new Array(nodeCount);
    revealOrder.forEach(function(nodeIdx, position) {
        revealPosition[nodeIdx] = position;
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("style", null, "\n				@keyframes ".concat(NODE_KEYFRAMES, " {\n					from { opacity: 0; transform: scale(0.4); }\n					to { opacity: 1; transform: scale(1); }\n				}\n				@keyframes ").concat(EDGE_KEYFRAMES, " {\n					to { stroke-dashoffset: 0; }\n				}\n				@keyframes ").concat(OUTLINE_KEYFRAMES, " {\n					to { stroke-dashoffset: 0; }\n				}\n				.").concat(NODE_CLASS, " {\n					opacity: ").concat(reducedMotion ? '1' : '0', ";\n					transform-box: fill-box;\n					transform-origin: center;\n					animation: ").concat(NODE_KEYFRAMES, " ").concat(reducedMotion ? 0 : NODE_REVEAL_MS, "ms cubic-bezier(0.34, 1.56, 0.64, 1) forwards;\n				}\n				.").concat(EDGE_CLASS, " {\n					animation: ").concat(EDGE_KEYFRAMES, " ").concat(reducedMotion ? 0 : EDGE_REVEAL_MS, "ms ease-out forwards;\n				}\n				.").concat(OUTLINE_CLASS, " {\n					stroke-dasharray: 1;\n					stroke-dashoffset: ").concat(reducedMotion ? 0 : 1, ";\n					animation: ").concat(OUTLINE_KEYFRAMES, " ").concat(outlineWindowMs, "ms ease-in-out forwards;\n				}\n			")), /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "".concat((0, _letterAData.LETTER_A_VIEWBOX).x, " ").concat((0, _letterAData.LETTER_A_VIEWBOX).y, " ").concat((0, _letterAData.LETTER_A_VIEWBOX).width, " ").concat((0, _letterAData.LETTER_A_VIEWBOX).height),
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        "aria-hidden": true,
        style: {
            width: '100%',
            height: '100%'
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: (0, _letterAData.LETTER_A_OUTLINE_PATH),
        stroke: strokeColor,
        strokeWidth: strokeWidth,
        pathLength: 1,
        className: OUTLINE_CLASS
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", null, (0, _letterAData.LETTER_A_EDGES).map(function(param, idx) {
        var _param = (0, _slicedToArray._)(param, 2), i = _param[0], j = _param[1];
        var a = (0, _letterAData.LETTER_A_NODES)[i];
        var b = (0, _letterAData.LETTER_A_NODES)[j];
        var len = edgeLength(a, b);
        var t = edgeCount <= 1 ? 0 : idx / (edgeCount - 1);
        var delay = edgeWindowStartMs + easeFn(t) * edgeWindowMs;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("line", {
            key: "e-".concat(idx),
            x1: a.x,
            y1: a.y,
            x2: b.x,
            y2: b.y,
            stroke: strokeColor,
            strokeWidth: strokeWidth,
            strokeLinecap: "round",
            strokeLinejoin: "bevel",
            className: EDGE_CLASS,
            style: {
                strokeDasharray: len,
                strokeDashoffset: reducedMotion ? 0 : len,
                animationDelay: "".concat(delay, "ms")
            }
        });
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", null, (0, _letterAData.LETTER_A_NODES).map(function(node, idx) {
        var _revealPosition_idx;
        var position = (_revealPosition_idx = revealPosition[idx]) !== null && _revealPosition_idx !== void 0 ? _revealPosition_idx : idx;
        var t = nodeCount <= 1 ? 0 : position / (nodeCount - 1);
        var delay = nodeWindowStartMs + easeFn(t) * nodeWindowMs;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
            key: "n-".concat(idx),
            cx: node.x,
            cy: node.y,
            r: node.r,
            fill: node.color,
            className: NODE_CLASS,
            style: {
                animationDelay: "".concat(delay, "ms")
            }
        });
    }))));
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","react":"ltHCL","./letter-a-data":"irEc3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"irEc3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LETTER_A_VIEWBOX", function() {
    return LETTER_A_VIEWBOX;
});
parcelHelpers.export(exports, "LETTER_A_OUTLINE_PATH", function() {
    return LETTER_A_OUTLINE_PATH;
});
parcelHelpers.export(exports, "LETTER_A_NODES", function() {
    return LETTER_A_NODES;
});
parcelHelpers.export(exports, "LETTER_A_EDGES", function() {
    return LETTER_A_EDGES;
});
var PURPLE = '#bf63f3';
var BLUE = '#1868db';
var GREEN = '#82b536';
var ORANGE = '#fca700';
var LETTER_A_VIEWBOX = {
    x: -6,
    y: -6,
    width: 122,
    height: 161
};
var LETTER_A_OUTLINE_PATH = 'm1.925 147.5 36.798-146H70.92l36.998 146H82.32l-8-35.4H35.524l-8 35.4zm38.198-55.8H69.72l-8.8-39.2a983 983 0 0 1-3.8-17.6q-1.6-8-2.2-11.6-.6 3.6-2.2 11.6-1.399 7.8-3.799 17.4z';
var LETTER_A_NODES = [
    {
        x: 35.66,
        y: 111.5,
        r: 6,
        color: BLUE
    },
    {
        x: 40.11,
        y: 93.65,
        r: 6,
        color: ORANGE
    },
    {
        x: 39.12,
        y: 1.5,
        r: 6,
        color: PURPLE
    },
    {
        x: 55.11,
        y: 25.65,
        r: 6,
        color: BLUE
    },
    {
        x: 74.36,
        y: 112.25,
        r: 6,
        color: PURPLE
    },
    {
        x: 69.61,
        y: 92.65,
        r: 6,
        color: GREEN
    },
    {
        x: 20.12,
        y: 75.5,
        r: 6,
        color: BLUE
    },
    {
        x: 27.11,
        y: 148.64,
        r: 6,
        color: PURPLE
    },
    {
        x: 71.11,
        y: 2.15,
        r: 6,
        color: GREEN
    },
    {
        x: 81.61,
        y: 44.65,
        r: 6,
        color: PURPLE
    },
    {
        x: 106.61,
        y: 147.14,
        r: 6,
        color: ORANGE
    },
    {
        x: 1.12,
        y: 147.14,
        r: 6,
        color: GREEN
    }
];
var LETTER_A_EDGES = [
    [
        0,
        1
    ],
    [
        1,
        2
    ],
    [
        2,
        3
    ],
    [
        1,
        4
    ],
    [
        4,
        5
    ],
    [
        1,
        6
    ],
    [
        6,
        7
    ],
    [
        3,
        8
    ],
    [
        3,
        9
    ],
    [
        9,
        5
    ],
    [
        5,
        10
    ]
];

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cQ6bk":[function(require,module,exports,__globalThis) {
/* Scribble.tsx generated by @compiled/babel-plugin v0.39.1 */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ /* eslint-disable @atlaskit/ui-styling-standard/no-global-styles */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Scribble", function() {
    return Scribble;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var DRAW_KEYFRAMES_NAME = 'twgHeroTypographyScribbleDraw';
var SCRIBBLE = {
    width: 178,
    height: 165,
    pathD: 'M74.527 48.552C63.4 26.3-41.34 93.69 28.125 104.907c51.138 8.257 94.683-83.471 34.285-74.57-24.655 3.634-31.028 46.09-13.587 60.61 23.538 19.597 107.363.256 79.404-38.34-36.562-50.472-129.125 28.31-86.2 63.41 25.934 21.206 96.114-24.685 102.756-51.73 6.277-25.554-30.165-60.643-55.949-58.535-52.354 4.282-70.047 107.216-18.157 123.721 37.428 11.906 102.665-27.813 96.284-71.15C153.663-32 28.698 55.457 56.995 133.883c9.78 27.107 95.494-48.722 100.203-71.573C164.687 25.968 121.5-.802 89.128 5.395c-49.75 9.522-88.044 106.312-47.669 142.503 40.61 36.402 139.385-41.985 105.887-91.117-47.568-69.768-113.202 40.331-91.767 80.13 25.221 46.83 120.094 14.296 116.911-26.592',
    strokeWidth: 9,
    strokeLinecap: 'round'
};
var DEFAULT_EASE = [
    0.55,
    0.055,
    0.675,
    0.19
];
function formatCubicBezier(param) {
    var _param = (0, _slicedToArray._)(param, 4), x1 = _param[0], y1 = _param[1], x2 = _param[2], y2 = _param[3];
    return "cubic-bezier(".concat(x1, ", ").concat(y1, ", ").concat(x2, ", ").concat(y2, ")");
}
function Scribble(param) {
    var _param_durationMs = param.durationMs, durationMs = _param_durationMs === void 0 ? 1000 : _param_durationMs, _param_ease = param.ease, ease = _param_ease === void 0 ? DEFAULT_EASE : _param_ease, _param_color = param.color, color = _param_color === void 0 ? '#FFC716' : _param_color, _param_lineWidth = param.lineWidth, lineWidth = _param_lineWidth === void 0 ? SCRIBBLE.strokeWidth : _param_lineWidth, _param_blurPx = param.blurPx, blurPx = _param_blurPx === void 0 ? 0 : _param_blurPx, _param_reducedMotion = param.reducedMotion, reducedMotion = _param_reducedMotion === void 0 ? false : _param_reducedMotion;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("style", null, "\n				@keyframes ".concat(DRAW_KEYFRAMES_NAME, " {\n					from { stroke-dashoffset: 1; }\n					to { stroke-dashoffset: 0; }\n				}\n			")), /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 ".concat(SCRIBBLE.width, " ").concat(SCRIBBLE.height),
        fill: "none",
        overflow: "visible",
        "aria-hidden": true,
        style: {
            width: '100%',
            height: '100%'
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: SCRIBBLE.pathD,
        pathLength: 1,
        stroke: color,
        strokeLinecap: SCRIBBLE.strokeLinecap,
        strokeWidth: lineWidth,
        style: {
            filter: blurPx > 0 ? "blur(".concat(blurPx, "px)") : undefined,
            strokeDasharray: 1,
            strokeDashoffset: reducedMotion ? 0 : 1,
            animation: "".concat(DRAW_KEYFRAMES_NAME, " ").concat(reducedMotion ? 0 : Math.max(0, durationMs), "ms ").concat(formatCubicBezier(ease), " forwards")
        }
    })));
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1jDzn":[function(require,module,exports,__globalThis) {
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useMediaQuery", function() {
    return useMediaQuery;
});
var _react = require("react");
var _browserApis = require("@atlaskit/browser-apis");
var subscribeToMediaQuery = function(query, onStoreChange) {
    var _getDocument;
    var win = (_getDocument = (0, _browserApis.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.defaultView;
    if (!(win === null || win === void 0 ? void 0 : win.matchMedia)) return function() {};
    var media = win.matchMedia(query);
    media.addEventListener('change', onStoreChange);
    return function() {
        return media.removeEventListener('change', onStoreChange);
    };
};
var getMediaQuerySnapshot = function(query) {
    var _getDocument;
    var win = (_getDocument = (0, _browserApis.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.defaultView;
    if (!(win === null || win === void 0 ? void 0 : win.matchMedia)) return false;
    return win.matchMedia(query).matches;
};
var useMediaQuery = function(query) {
    return (0, _react.useSyncExternalStore)(function(onStoreChange) {
        return subscribeToMediaQuery(query, onStoreChange);
    }, function() {
        return getMediaQuerySnapshot(query);
    }, function() {
        return false;
    });
};

},{"react":"ltHCL","@atlaskit/browser-apis":"2dayt","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9x0nm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "usePointerInteractivity", function() {
    return usePointerInteractivity;
});
var _useMediaQuery = require("./use-media-query");
var DRAGGABLE_POINTER_QUERY = '(hover: hover) and (pointer: fine)';
function usePointerInteractivity() {
    return (0, _useMediaQuery.useMediaQuery)(DRAGGABLE_POINTER_QUERY);
}

},{"./use-media-query":"1jDzn","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dhHjN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "usePrefersReducedMotion", function() {
    return usePrefersReducedMotion;
});
var _useMediaQuery = require("./use-media-query");
var REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';
function usePrefersReducedMotion() {
    return (0, _useMediaQuery.useMediaQuery)(REDUCED_MOTION_QUERY);
}

},{"./use-media-query":"1jDzn","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5p3Rq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useViewportTier", function() {
    return useViewportTier;
});
var _useMediaQuery = require("./use-media-query");
var MOBILE_VIEWPORT_QUERY = '(max-width: 600px)';
var COMPACT_VIEWPORT_QUERY = '(max-width: 1024px)';
function useViewportTier() {
    var isMobile = (0, _useMediaQuery.useMediaQuery)(MOBILE_VIEWPORT_QUERY);
    var isCompact = (0, _useMediaQuery.useMediaQuery)(COMPACT_VIEWPORT_QUERY);
    if (isMobile) return 'mobile';
    return isCompact ? 'compact' : 'desktop';
}

},{"./use-media-query":"1jDzn","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kazTe":[function(require,module,exports,__globalThis) {
module.exports = require("8974cf1090cd20d9").getBundleURL('a140o') + "whoops.5a6ad056.png" + "?" + Date.now();

},{"8974cf1090cd20d9":"cZKtR"}],"ci7ka":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "messages", function() {
    return messages;
});
var _reactIntl = require("react-intl");
var intlMessages = {
    description: {
        id: 'twg-microsite.errorView.description',
        defaultMessage: "Looks like something's gone wrong. We're currently untangling things to get your context back on track.\n\nRefresh the page to give it another go.",
        description: 'Supporting copy shown below the Whoops graphic in the home page error fallback.'
    }
};
var messages = (0, _reactIntl.defineMessages)(intlMessages);

},{"react-intl":"f41fF","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1rBZb":[function(require,module,exports,__globalThis) {
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LoadingView", function() {
    return LoadingView;
});
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _loadHold = require("@atlaskit/react-ufo/load-hold");
var _loadHoldDefault = parcelHelpers.interopDefault(_loadHold);
var _loadingSpinner = require("../LoadingSpinner");
var _loadingSpinnerDefault = parcelHelpers.interopDefault(_loadingSpinner);
var styles = {
    loadingContainer: "_bfhk1hlk _1bsb1osq _1e0c1txw _1bah1h6o _4cvr1h6o _1tke1kxc _1yyebys6 _162wvehm",
    nonMobileLoadingContainer: "_1e0cn7od _7l59glyw",
    mobileLoadingContainer: "_1e0cglyw _7l59n7od",
    spinnerContainer: "_1e0c1bgi"
};
var LoadingView = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, holdName = _ref.holdName, _ref_appearance = _ref.appearance, appearance = _ref_appearance === void 0 ? 'spinner' : _ref_appearance;
    var view = /*#__PURE__*/ _react.createElement("div", {
        className: (0, _runtime.ax)([
            styles.loadingContainer
        ])
    }, appearance === 'spinner' && /*#__PURE__*/ _react.createElement("div", {
        className: (0, _runtime.ax)([
            styles.spinnerContainer
        ])
    }, /*#__PURE__*/ _react.createElement("div", {
        className: (0, _runtime.ax)([
            styles.mobileLoadingContainer
        ])
    }, /*#__PURE__*/ _react.createElement((0, _loadingSpinnerDefault.default), {
        size: "large"
    })), /*#__PURE__*/ _react.createElement("div", {
        className: (0, _runtime.ax)([
            styles.nonMobileLoadingContainer
        ])
    }, /*#__PURE__*/ _react.createElement((0, _loadingSpinnerDefault.default), {
        size: "xlarge"
    }))));
    if (!holdName) return view;
    return /*#__PURE__*/ _react.createElement((0, _loadHoldDefault.default), {
        name: holdName
    }, view);
};

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/react-ufo/load-hold":"9dVJu","../LoadingSpinner":"lUqtM","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9dVJu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _ufoloadHold = require("./UFOLoadHold");
var _ufoloadHoldDefault = parcelHelpers.interopDefault(_ufoloadHold);
exports.default = (0, _ufoloadHoldDefault.default);

},{"./UFOLoadHold":"6xg4y","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6xg4y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return UFOLoadHold;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _config = require("../config");
var _interactionContext = require("../interaction-context");
var _interactionContextDefault = parcelHelpers.interopDefault(_interactionContext);
var _interactionIdContext = require("../interaction-id-context");
var _interactionIdContextDefault = parcelHelpers.interopDefault(_interactionIdContext);
var useLayoutEffectSAFE = typeof window === 'undefined' ? (0, _react.useEffect) : (0, _react.useLayoutEffect);
/**
 * Custom hook to track changes to the interaction ID.
 * Uses a subscription system to automatically update when the interaction ID changes.
 */ function useInteractionIdValue() {
    var interactionId = (0, _react.useContext)((0, _interactionIdContextDefault.default));
    var _useState = (0, _slicedToArray._)((0, _react.useState)((interactionId === null || interactionId === void 0 ? void 0 : interactionId.current) || null), 2), currentId = _useState[0], setCurrentId = _useState[1];
    useLayoutEffectSAFE(function() {
        setCurrentId((interactionId === null || interactionId === void 0 ? void 0 : interactionId.current) || null);
        var unsubscribe = (0, _interactionIdContext.subscribeToInteractionIdChanges)(function(newId) {
            setCurrentId(newId);
        });
        return unsubscribe;
    }, [
        interactionId
    ]);
    return currentId;
}
function UFOLoadHold(param) {
    var children = param.children, name = param.name, _param_hold = param.hold, hold = _param_hold === void 0 ? true : _param_hold, _param_experimental = param.experimental, experimental = _param_experimental === void 0 ? false : _param_experimental;
    // Check if UFO is enabled
    // Note: isUFOEnabled() returns a stable value based on config, so it's safe to call before hooks
    var ufoEnabled = (0, _config.isUFOEnabled)();
    var currentInteractionId = useInteractionIdValue();
    // react-18: useId instead
    var context = (0, _react.useContext)((0, _interactionContextDefault.default));
    useLayoutEffectSAFE(function() {
        // Skip hold registration if UFO is disabled
        if (!ufoEnabled) return;
        if (hold && context != null) {
            if (!(0, _platformFeatureFlags.fg)('platform_ufo_remove_experimental_holds') && experimental && context.holdExperimental) return context.holdExperimental(name);
            return context.hold(name);
        }
    }, [
        hold,
        context,
        name,
        currentInteractionId,
        ufoEnabled
    ]);
    // react-18: can return children directly
    return children != null ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: children
    }) : null;
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","react/jsx-runtime":"bGvcw","react":"ltHCL","@atlaskit/platform-feature-flags":"kO5t9","../config":"1BZI5","../interaction-context":"6ICC9","../interaction-id-context":"eh9Yb","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lUqtM":[function(require,module,exports,__globalThis) {
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ /**
 * LoadingSpinner — Teamwork Graph branded loading indicator.
 *
 * A four-dot logo that bursts out from the center, then continuously
 * draws a multi-color "snake" between the dots, rotating between
 * patterns. Mirrors the public size API of `@atlaskit/spinner` so it
 * can be a drop-in replacement at existing call sites.
 *
 * The SVG is rendered once and updated imperatively from a
 * `requestAnimationFrame` loop to avoid re-rendering React 60 times/sec.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LoadingSpinner", function() {
    return LoadingSpinner;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _usePrefersReducedMotion = require("../InteractiveHeroIcons/use-prefers-reduced-motion");
var _Math;
var styles = {
    wrapper: "_1e0c116y _vwz4idpf"
};
/* -------------------------------------------------------------------------- */ /* Geometry, timing and patterns                                              */ /* -------------------------------------------------------------------------- */ var VIEWBOX_SIZE = 24;
var VIEWBOX_CENTER = VIEWBOX_SIZE / 2;
var SIZE_PX = {
    small: 16,
    medium: 24,
    large: 32,
    xlarge: 64
};
var DOT_RADIUS = 2.5;
var NODE_STROKE_WIDTH = 1.5;
var SPREAD_RADIUS = 8;
var LINE_WIDTH = 1.5;
var BURST_DURATION_S = 0.4;
var ROTATE_DURATION_S = 0.4;
var DRAW_DURATION_S = 0.8;
/** Fraction of the snake duration after which the tail begins to retract. */ var TAIL_DELAY = 0.35;
var ROTATION_AMOUNT_DEG = 45;
/** Dot starting angles (radians). Order matters — patterns reference these indices. */ var DOT_ANGLES = [
    -Math.PI / 2,
    // top
    0,
    // right
    Math.PI / 2,
    // bottom
    Math.PI // left
];
/** Snake patterns — one set of dot-to-dot segments per cycle. */ var DRAW_PATTERNS = [
    [
        [
            3,
            0
        ],
        [
            0,
            2
        ],
        [
            2,
            1
        ]
    ],
    [
        [
            0,
            2
        ],
        [
            2,
            3
        ],
        [
            3,
            1
        ]
    ],
    [
        [
            3,
            1
        ],
        [
            1,
            0
        ],
        [
            0,
            2
        ]
    ],
    [
        [
            0,
            1
        ],
        [
            1,
            3
        ],
        [
            3,
            2
        ]
    ]
];
var MAX_LINE_COUNT = (_Math = Math).max.apply(_Math, (0, _toConsumableArray._)(DRAW_PATTERNS.map(function(p) {
    return p.length;
})));
var TOTAL_SNAKE_DURATION_S = DRAW_DURATION_S / (1 - TAIL_DELAY);
var CYCLE_DURATION_S = TOTAL_SNAKE_DURATION_S + ROTATE_DURATION_S;
var ROTATION_AMOUNT_RAD = ROTATION_AMOUNT_DEG * Math.PI / 180;
/* -------------------------------------------------------------------------- */ /* Easing                                                                     */ /* -------------------------------------------------------------------------- */ var clamp01 = function(t) {
    return Math.min(1, Math.max(0, t));
};
function easeOutBack(t) {
    var overshoot = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1.0;
    var c = clamp01(t);
    var c3 = overshoot + 1;
    return 1 + c3 * Math.pow(c - 1, 3) + overshoot * Math.pow(c - 1, 2);
}
function easeInOutQuad(t) {
    var c = clamp01(t);
    return c < 0.5 ? 2 * c * c : 1 - Math.pow(-2 * c + 2, 2) / 2;
}
/* -------------------------------------------------------------------------- */ /* Colors                                                                     */ /* -------------------------------------------------------------------------- */ /** Brand colors for the four dot rings. Aligned with `DOT_ANGLES`. */ function getDotColors() {
    return [
        "var(--ds-icon-accent-orange, #FCA700)",
        "var(--ds-icon-accent-lime, #6A9A23)",
        "var(--ds-icon-accent-blue, #1868DB)",
        "var(--ds-icon-accent-purple, #AF59E0)"
    ];
}
/** Single neutral color for the snake / connector lines. No exact ADS token. */ function getLineColor() {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    return '#6C6F77';
}
function getMaskColor() {
    return "var(--ds-surface, #FFFFFF)";
}
function getDotPositions(spread, rotation) {
    return DOT_ANGLES.map(function(angle) {
        return {
            x: VIEWBOX_CENTER + Math.cos(angle + rotation) * spread,
            y: VIEWBOX_CENTER + Math.sin(angle + rotation) * spread
        };
    });
}
/**
 * Compute the frame at `elapsedSeconds` since animation start.
 *
 * Phase 1 (`< BURST_DURATION_S`): dots fly out from center with overshoot.
 * Phase 2 (repeating): snake draws + retracts, then logo rotates and
 * advances to the next pattern.
 */ function computeFrame(elapsedSeconds) {
    var spread = SPREAD_RADIUS;
    var rotation = 0;
    var drawFrac = -1;
    var retractFrac = 0;
    var patternIndex = 0;
    if (elapsedSeconds < BURST_DURATION_S) {
        var progress = elapsedSeconds / BURST_DURATION_S;
        spread = easeOutBack(progress, 0.8) * SPREAD_RADIUS;
    } else {
        var cycleElapsed = elapsedSeconds - BURST_DURATION_S;
        var cycleCount = Math.floor(cycleElapsed / CYCLE_DURATION_S);
        var cycleTime = cycleElapsed % CYCLE_DURATION_S;
        patternIndex = cycleCount % DRAW_PATTERNS.length;
        var baseRotation = cycleCount * ROTATION_AMOUNT_RAD;
        if (cycleTime < TOTAL_SNAKE_DURATION_S) {
            var snakeProgress = cycleTime / TOTAL_SNAKE_DURATION_S;
            drawFrac = easeInOutQuad(Math.min(1, snakeProgress / (1 - TAIL_DELAY)));
            var tailRaw = Math.max(0, (snakeProgress - TAIL_DELAY) / (1 - TAIL_DELAY));
            retractFrac = easeInOutQuad(Math.min(1, tailRaw));
            rotation = baseRotation;
        } else {
            var rotateProgress = (cycleTime - TOTAL_SNAKE_DURATION_S) / ROTATE_DURATION_S;
            rotation = baseRotation + easeOutBack(rotateProgress, 0.6) * ROTATION_AMOUNT_RAD;
        }
    }
    return {
        positions: getDotPositions(spread, rotation),
        drawFrac: drawFrac,
        retractFrac: retractFrac,
        patternIndex: patternIndex
    };
}
/** Static frame used for `prefers-reduced-motion: reduce`. */ function computeStaticFrame() {
    return {
        positions: getDotPositions(SPREAD_RADIUS, 0),
        drawFrac: -1,
        retractFrac: 0,
        patternIndex: 0
    };
}
/* -------------------------------------------------------------------------- */ /* Imperative DOM updaters                                                    */ /* -------------------------------------------------------------------------- */ var HIDDEN_DASH = '0 9999';
var EPSILON = 0.001;
function hideLine(el) {
    el.setAttribute('stroke-dasharray', HIDDEN_DASH);
    el.setAttribute('stroke-dashoffset', '0');
}
function updateDots(svg, positions) {
    var circles = svg.querySelectorAll('[data-type="dot"], [data-type="mask"]');
    circles.forEach(function(circle) {
        var idx = Number(circle.getAttribute('data-idx'));
        var pos = positions[idx];
        if (!pos) return;
        circle.setAttribute('cx', String(pos.x));
        circle.setAttribute('cy', String(pos.y));
    });
}
function updateLines(svg, positions, pattern, drawFrac, retractFrac) {
    var segLengths = [];
    var cumDist = [
        0
    ];
    for(var i = 0; i < pattern.length; i++){
        var from = positions[pattern[i][0]];
        var to = positions[pattern[i][1]];
        var dx = to.x - from.x;
        var dy = to.y - from.y;
        var len = Math.sqrt(dx * dx + dy * dy);
        segLengths.push(len);
        cumDist.push(cumDist[i] + len);
    }
    var totalLen = cumDist[pattern.length];
    var headDist = drawFrac * totalLen;
    var tailDist = retractFrac * totalLen;
    for(var i1 = 0; i1 < MAX_LINE_COUNT; i1++){
        var el = svg.getElementById("line-".concat(i1));
        if (!el) continue;
        var isInactive = i1 >= pattern.length || drawFrac < 0;
        if (isInactive) {
            hideLine(el);
            continue;
        }
        var _pattern_i = (0, _slicedToArray._)(pattern[i1], 2), fromIdx = _pattern_i[0], toIdx = _pattern_i[1];
        var from1 = positions[fromIdx];
        var to1 = positions[toIdx];
        var segLen = segLengths[i1];
        var segCumStart = cumDist[i1];
        var headPos = Math.min(segLen, Math.max(0, headDist - segCumStart));
        var tailPos = Math.min(segLen, Math.max(0, tailDist - segCumStart));
        var visibleLen = headPos - tailPos;
        if (visibleLen <= EPSILON || segLen < EPSILON) {
            hideLine(el);
            continue;
        }
        var gapLen = segLen - visibleLen;
        el.setAttribute('d', "M".concat(from1.x, ",").concat(from1.y, " L").concat(to1.x, ",").concat(to1.y));
        el.setAttribute('stroke-dasharray', "".concat(visibleLen.toFixed(4), " ").concat(gapLen.toFixed(4)));
        el.setAttribute('stroke-dashoffset', (-tailPos).toFixed(4));
    }
}
/* -------------------------------------------------------------------------- */ /* Component                                                                  */ /* -------------------------------------------------------------------------- */ /** Visiting order for masks/dots — preserves the original stacking. */ var DOT_ORDER = [
    0,
    1,
    3,
    2
];
function LoadingSpinner(param) {
    var _param_size = param.size, size = _param_size === void 0 ? 'medium' : _param_size, _param_label = param.label, label = _param_label === void 0 ? 'Loading' : _param_label, testId = param.testId;
    var sizePx = SIZE_PX[size];
    var reducedMotion = (0, _usePrefersReducedMotion.usePrefersReducedMotion)();
    // Tokens flip with `data-theme`; resolve once per render.
    var dotColors = (0, _react.useMemo)(function() {
        return getDotColors();
    }, []);
    var lineColor = (0, _react.useMemo)(function() {
        return getLineColor();
    }, []);
    var maskColor = (0, _react.useMemo)(function() {
        return getMaskColor();
    }, []);
    var svgRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(function() {
        var svg = svgRef.current;
        if (!svg) return;
        var applyFrame = function(param) {
            var positions = param.positions, drawFrac = param.drawFrac, retractFrac = param.retractFrac, patternIndex = param.patternIndex;
            updateDots(svg, positions);
            updateLines(svg, positions, DRAW_PATTERNS[patternIndex], drawFrac, retractFrac);
        };
        if (reducedMotion) {
            applyFrame(computeStaticFrame());
            return;
        }
        var rafId = 0;
        var startTime = 0;
        var tick = function(timestamp) {
            if (!startTime) startTime = timestamp;
            var elapsedSeconds = (timestamp - startTime) / 1000;
            applyFrame(computeFrame(elapsedSeconds));
            rafId = requestAnimationFrame(tick);
        };
        rafId = requestAnimationFrame(tick);
        return function() {
            cancelAnimationFrame(rafId);
        };
    }, [
        reducedMotion
    ]);
    return /*#__PURE__*/ _react.createElement("div", {
        role: "status",
        "aria-label": label,
        "data-testid": testId,
        "data-vc-ignore-if-no-layout-shift": "true",
        className: (0, _runtime.ax)([
            styles.wrapper
        ])
    }, /*#__PURE__*/ _react.createElement("svg", {
        ref: svgRef,
        width: sizePx,
        height: sizePx,
        viewBox: "0 0 ".concat(VIEWBOX_SIZE, " ").concat(VIEWBOX_SIZE),
        fill: "none",
        "aria-hidden": "true",
        focusable: "false"
    }, /*#__PURE__*/ _react.createElement("g", null, Array.from({
        length: MAX_LINE_COUNT
    }, function(_, i) {
        return /*#__PURE__*/ _react.createElement("path", {
            key: "line-".concat(i),
            id: "line-".concat(i),
            stroke: lineColor,
            strokeWidth: LINE_WIDTH,
            strokeLinecap: "butt",
            fill: "none",
            strokeDasharray: HIDDEN_DASH
        });
    })), /*#__PURE__*/ _react.createElement("g", null, DOT_ORDER.map(function(i) {
        return /*#__PURE__*/ _react.createElement("circle", {
            key: "mask-".concat(i),
            "data-type": "mask",
            "data-idx": i,
            cx: VIEWBOX_CENTER,
            cy: VIEWBOX_CENTER,
            r: DOT_RADIUS,
            fill: maskColor,
            stroke: "none"
        });
    })), /*#__PURE__*/ _react.createElement("g", null, DOT_ORDER.map(function(i) {
        return /*#__PURE__*/ _react.createElement("circle", {
            key: "dot-".concat(i),
            "data-type": "dot",
            "data-idx": i,
            cx: VIEWBOX_CENTER,
            cy: VIEWBOX_CENTER,
            r: DOT_RADIUS,
            fill: "none",
            stroke: dotColors[i],
            strokeWidth: NODE_STROKE_WIDTH
        });
    }))));
}
exports.default = LoadingSpinner;

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_to_consumable_array":"1eSZf","react":"ltHCL","@compiled/react/runtime":"d27Vo","../InteractiveHeroIcons/use-prefers-reduced-motion":"dhHjN","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1Dovo":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("1c9effb04c8554c9")(require("5bbb504c16b56db8").resolve("iQegX")),
    require("5ca6877399fc4495")(require("5bbb504c16b56db8").resolve("f25Vl")),
    require("5ca6877399fc4495")(require("5bbb504c16b56db8").resolve("1CDb0")),
    require("5ca6877399fc4495")(require("5bbb504c16b56db8").resolve("66ueH")),
    require("5ca6877399fc4495")(require("5bbb504c16b56db8").resolve("lwHpQ")),
    require("5ca6877399fc4495")(require("5bbb504c16b56db8").resolve("7w2Z9")),
    require("5ca6877399fc4495")(require("5bbb504c16b56db8").resolve("8ig6x")),
    require("5ca6877399fc4495")(require("5bbb504c16b56db8").resolve("j5rqC")),
    require("5ca6877399fc4495")(require("5bbb504c16b56db8").resolve("zpFQG")),
    require("5ca6877399fc4495")(require("5bbb504c16b56db8").resolve("bMJ9V")),
    require("5ca6877399fc4495")(require("5bbb504c16b56db8").resolve("krtdN")),
    require("5ca6877399fc4495")(require("5bbb504c16b56db8").resolve("8Sh3Z")),
    require("5ca6877399fc4495")(require("5bbb504c16b56db8").resolve("jhpPW")),
    require("5ca6877399fc4495")(require("5bbb504c16b56db8").resolve("4NAG6")),
    require("5ca6877399fc4495")(require("5bbb504c16b56db8").resolve("hUKTM")),
    require("5ca6877399fc4495")(require("5bbb504c16b56db8").resolve("bbFRf")),
    require("5ca6877399fc4495")(require("5bbb504c16b56db8").resolve("dsn0k")),
    require("5ca6877399fc4495")(require("5bbb504c16b56db8").resolve("4U2Tv")),
    require("5ca6877399fc4495")(require("5bbb504c16b56db8").resolve("dSWWh")),
    require("5ca6877399fc4495")(require("5bbb504c16b56db8").resolve("g2f85")),
    require("5ca6877399fc4495")(require("5bbb504c16b56db8").resolve("jtnnc")),
    require("5ca6877399fc4495")(require("5bbb504c16b56db8").resolve("9judO"))
]).then(function() {
    return module.bundle.root('i5Sl4');
});

},{"1c9effb04c8554c9":"kXvay","5bbb504c16b56db8":"l4T2r","5ca6877399fc4495":"hkfCW"}],"kXvay":[function(require,module,exports,__globalThis) {
"use strict";
var cacheLoader = require("21537421481d46a4");
module.exports = cacheLoader(function loadCSSBundle(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        var isCurrentBundle = function isCurrentBundle(link) {
            return link.href === bundle && link.rel.indexOf('stylesheet') > -1;
        };
        if ([].concat(existingLinks).some(isCurrentBundle)) {
            resolve();
            return;
        }
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

},{"21537421481d46a4":"62BBR"}],"b9phQ":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("b1c0b6efdf4ffb6e")(require("c1f7336f217362ca").resolve("2cFf2")),
    require("df8d64f4b3aa67cb")(require("c1f7336f217362ca").resolve("jKTeJ")),
    require("df8d64f4b3aa67cb")(require("c1f7336f217362ca").resolve("3KVy9")),
    require("df8d64f4b3aa67cb")(require("c1f7336f217362ca").resolve("akzIL")),
    require("df8d64f4b3aa67cb")(require("c1f7336f217362ca").resolve("za7z7")),
    require("df8d64f4b3aa67cb")(require("c1f7336f217362ca").resolve("jtnnc")),
    require("df8d64f4b3aa67cb")(require("c1f7336f217362ca").resolve("e4ZM6"))
]).then(function() {
    return module.bundle.root('k50Jh');
});

},{"b1c0b6efdf4ffb6e":"kXvay","c1f7336f217362ca":"l4T2r","df8d64f4b3aa67cb":"hkfCW"}],"hTim7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useReactUFORouteWatcher", function() {
    return useReactUFORouteWatcher;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _reactResourceRouter = require("react-resource-router");
var _traceTransition = require("@atlaskit/react-ufo/trace-transition");
var _traceTransitionDefault = parcelHelpers.interopDefault(_traceTransition);
var useReactUFORouteWatcher = function() {
    var _useRouter = (0, _slicedToArray._)((0, _reactResourceRouter.useRouter)(), 1), route = _useRouter[0].route;
    var isFirstRender = (0, _react.useRef)(true);
    (0, _react.useEffect)(function() {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        if (route === null || route === void 0 ? void 0 : route.name) (0, _traceTransitionDefault.default)(route.name, route.name);
    }, [
        route === null || route === void 0 ? void 0 : route.name
    ]);
};

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","react":"ltHCL","react-resource-router":"aVqdw","@atlaskit/react-ufo/trace-transition":"81rN7","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"81rN7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useUFOTransitionCompleter", function() {
    return useUFOTransitionCompleter;
});
var _react = require("react");
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
var _uuid = require("uuid");
var _coinflip = require("../coinflip");
var _coinflipDefault = parcelHelpers.interopDefault(_coinflip);
var _config = require("../config");
var _experienceTraceIdContext = require("../experience-trace-id-context");
var _interactionIdContext = require("../interaction-id-context");
var _interactionIdContextDefault = parcelHelpers.interopDefault(_interactionIdContext);
var _interactionMetrics = require("../interaction-metrics");
var _routeNameContext = require("../route-name-context");
var _routeNameContextDefault = parcelHelpers.interopDefault(_routeNameContext);
var _setInteractionActiveTrace = require("./utils/set-interaction-active-trace");
function traceUFOTransition(ufoName) {
    var routeName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ufoName;
    if (!(0, _config.isUFOEnabled)()) return;
    var pressInteractionsList = (0, _config.getDoNotAbortActivePressInteractionOnTransition)();
    var interaction = (0, _interactionMetrics.getActiveInteraction)();
    if (pressInteractionsList && interaction) {
        if (pressInteractionsList.includes(interaction.ufoName)) return;
    }
    (0, _interactionMetrics.abortAll)('transition', ufoName !== null && ufoName !== void 0 ? ufoName : undefined);
    if (ufoName) {
        (0, _routeNameContextDefault.default).current = ufoName;
        var rate = (0, _config.getInteractionRate)(ufoName, 'transition');
        if ((0, _coinflipDefault.default)(rate)) {
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            var newId = (0, _uuid.v4)();
            (0, _setInteractionActiveTrace.setInteractionActiveTrace)(newId);
            (0, _interactionIdContext.DefaultInteractionID).current = newId;
            (0, _interactionMetrics.addNewInteraction)(newId, ufoName, 'transition', performance.now(), rate, null, routeName, (0, _experienceTraceIdContext.getActiveTrace)());
        }
    }
}
function useUFOTransitionCompleter() {
    var interactionId = (0, _react.useContext)((0, _interactionIdContextDefault.default));
    var capturedInteractionId = interactionId.current;
    (0, _react.useEffect)(function() {
        // If we have a current interaction set...
        if (capturedInteractionId != null) {
            var cancel = requestAnimationFrame(function() {
                cancel = requestAnimationFrame(function() {
                    if (capturedInteractionId === interactionId.current) (0, _interactionMetrics.tryComplete)(capturedInteractionId);
                });
            });
            (0, _interactionMetrics.addOnCancelCallback)(capturedInteractionId, function() {
                cancelAnimationFrame(cancel);
            });
        }
    }, [
        capturedInteractionId,
        interactionId
    ]);
}
exports.default = traceUFOTransition;

},{"react":"ltHCL","uuid":"5elg8","../coinflip":"cHdgG","../config":"1BZI5","../experience-trace-id-context":"7SDPo","../interaction-id-context":"eh9Yb","../interaction-metrics":"diQdd","../route-name-context":"61t5e","./utils/set-interaction-active-trace":"gj9lV","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gj9lV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setInteractionActiveTrace", function() {
    return setInteractionActiveTrace;
});
var _experienceTraceIdContext = require("../../../experience-trace-id-context");
var _generateSpanId = require("../generate-span-id");
function setInteractionActiveTrace(newId) {
    (0, _experienceTraceIdContext.setActiveTrace)(newId.replace(/-/g, ''), (0, _generateSpanId.generateSpanId)(), 'transition');
}

},{"../../../experience-trace-id-context":"7SDPo","../generate-span-id":"3UhEA","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3UhEA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateSpanId", function() {
    return generateSpanId;
});
function generateSpanId() {
    return Array.from(new Array(16), function() {
        return Math.floor(Math.random() * 16).toString(16);
    }).join('');
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jS31Y":[function(require,module,exports,__globalThis) {
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Re-export catalog so consumers can build their own selectors if needed.
parcelHelpers.export(exports, "DEFAULT_LOCALE", function() {
    return 0, _locales.DEFAULT_LOCALE;
});
parcelHelpers.export(exports, "SELECTABLE_LOCALES", function() {
    return 0, _locales.SELECTABLE_LOCALES;
});
parcelHelpers.export(exports, "SUPPORTED_LOCALES", function() {
    return 0, _locales.SUPPORTED_LOCALES;
});
parcelHelpers.export(exports, "LocaleProvider", function() {
    return LocaleProvider;
});
parcelHelpers.export(exports, "useLocale", function() {
    return useLocale;
});
parcelHelpers.export(exports, "useSetLocale", function() {
    return useSetLocale;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _reactIntl = require("react-intl");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _detectLocale = require("./detect-locale");
var _locales = require("./locales");
var _storage = require("./storage");
var LocaleContext = /*#__PURE__*/ (0, _react.createContext)(null);
var LocaleProvider = function(param) {
    var children = param.children, initialLocale = param.initialLocale;
    if (!(0, _platformFeatureFlags.fg)('twg-microsite-enable-i18n')) return /*#__PURE__*/ _react.createElement((0, _reactIntl.IntlProvider), {
        locale: (0, _locales.DEFAULT_LOCALE)
    }, children);
    return /*#__PURE__*/ _react.createElement(LocaleProviderInner, {
        initialLocale: initialLocale
    }, children);
};
var LocaleProviderInner = function(param) {
    var children = param.children, initialLocale = param.initialLocale;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(function() {
        return initialLocale !== null && initialLocale !== void 0 ? initialLocale : (0, _detectLocale.resolveInitialLocale)();
    }), 2), locale = _useState[0], setLocaleState = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(undefined), 2), messages = _useState1[0], setMessages = _useState1[1];
    (0, _react.useEffect)(function() {
        var cancelled = false;
        var descriptor = (0, _locales.getDescriptor)(locale);
        descriptor.loadMessages().then(function(loaded) {
            if (!cancelled) setMessages(loaded);
        }).catch(function(err) {
            // Non-fatal: log to console; surfaces to Sentry via the
            // global error handler already wired by initSentry.
            // eslint-disable-next-line no-console
            console.error('[LocaleProvider] Failed to load messages for "'.concat(locale, '"'), err);
        });
        return function() {
            cancelled = true;
        };
    }, [
        locale
    ]);
    var setLocale = (0, _react.useCallback)(function(next) {
        (0, _storage.writePersistedLocale)(next);
        setLocaleState(next);
    }, []);
    var ctx = (0, _react.useMemo)(function() {
        return {
            locale: locale,
            setLocale: setLocale
        };
    }, [
        locale,
        setLocale
    ]);
    return /*#__PURE__*/ _react.createElement(LocaleContext.Provider, {
        value: ctx
    }, /*#__PURE__*/ _react.createElement((0, _reactIntl.IntlProvider), {
        locale: locale,
        defaultLocale: (0, _locales.DEFAULT_LOCALE),
        messages: messages
    }, children));
};
var useLocale = function() {
    var ctx = (0, _react.useContext)(LocaleContext);
    if (!ctx) throw new Error('useLocale must be used inside <LocaleProvider>');
    return ctx.locale;
};
var useSetLocale = function() {
    var ctx = (0, _react.useContext)(LocaleContext);
    if (!ctx) throw new Error('useSetLocale must be used inside <LocaleProvider>');
    return ctx.setLocale;
};

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","react":"ltHCL","react-intl":"f41fF","@atlaskit/platform-feature-flags":"kO5t9","./detect-locale":"6phhA","./locales":"5bQNX","./storage":"aEB63","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6phhA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveInitialLocale", function() {
    return resolveInitialLocale;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _locales = require("./locales");
var _storage = require("./storage");
/**
 * Normalize a browser-supplied tag into our catalog.
 *
 * Strategy:
 *   1. Exact case-insensitive match against a supported code (`pt-BR`).
 *   2. Language-only match (`de-AT` → `de`).
 *   3. null if nothing matches.
 *
 * BCP-47 tags use `-` separators; Traduki file names use `_`. We always
 * normalize to `-` here because that's what `SUPPORTED_LOCALES.code`
 * uses. The underscore form only appears inside dynamic-import paths.
 */ var matchSupported = function(tag) {
    var _normalized_split_;
    var normalized = tag.replace('_', '-');
    var exact = (0, _locales.SUPPORTED_LOCALES).find(function(l) {
        return l.code.toLowerCase() === normalized.toLowerCase();
    });
    if (exact) return exact.code;
    var languageOnly = (_normalized_split_ = normalized.split('-')[0]) === null || _normalized_split_ === void 0 ? void 0 : _normalized_split_.toLowerCase();
    if (!languageOnly) return null;
    var langMatch = (0, _locales.SUPPORTED_LOCALES).find(function(l) {
        return l.code.toLowerCase().split('-')[0] === languageOnly;
    });
    return langMatch ? langMatch.code : null;
};
var detectFromNavigator = function(nav) {
    var _candidates;
    if (!nav) return null;
    var candidates = [];
    if (Array.isArray(nav.languages)) (_candidates = candidates).push.apply(_candidates, (0, _toConsumableArray._)(nav.languages));
    if (typeof nav.language === 'string') candidates.push(nav.language);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = candidates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var tag = _step.value;
            var matched = matchSupported(tag);
            if (matched) return matched;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
};
var resolveInitialLocale = function() {
    var nav = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : typeof navigator !== 'undefined' ? navigator : undefined;
    var persisted = (0, _storage.readPersistedLocale)();
    if ((0, _locales.isSupportedLocale)(persisted)) return persisted;
    var fromBrowser = detectFromNavigator(nav);
    if (fromBrowser) return fromBrowser;
    return 0, _locales.DEFAULT_LOCALE;
};

},{"@swc/helpers/_/_to_consumable_array":"1eSZf","./locales":"5bQNX","./storage":"aEB63","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5bQNX":[function(require,module,exports,__globalThis) {
/**
 * Single source of truth for the locales the microsite ships
 * translations for. Each entry describes:
 *   - `code`        BCP-47 tag used by react-intl-next (`pt-BR`, not `pt_BR`)
 *   - `nativeName`  How the locale labels itself in the dropdown
 *   - `loadMessages` Lazy import of the Traduki bundle re-exported by
 *                    this package's `./i18n/<code>` subpath
 *
 * The keys of the dynamic-import paths use the underscore form because
 * that's how Traduki names the files (see ./src/i18n/*.ts).
 *
 * IMPORTANT: When a new locale is added under `src/i18n/`, append it
 * here. Nothing else needs to change.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SUPPORTED_LOCALES", function() {
    return SUPPORTED_LOCALES;
});
parcelHelpers.export(exports, "SELECTABLE_LOCALES", function() {
    return SELECTABLE_LOCALES;
});
parcelHelpers.export(exports, "DEFAULT_LOCALE", function() {
    return DEFAULT_LOCALE;
});
parcelHelpers.export(exports, "isSupportedLocale", function() {
    return isSupportedLocale;
});
parcelHelpers.export(exports, "getDescriptor", function() {
    return getDescriptor;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var importDefault = function(p) {
    return (0, _asyncToGenerator._)(function() {
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        p
                    ];
                case 1:
                    return [
                        2,
                        _state.sent().default
                    ];
            }
        });
    })();
};
var SUPPORTED_LOCALES = [
    {
        code: 'en',
        nativeName: 'English',
        loadMessages: function() {
            return importDefault(require(/* webpackChunkName: "twg-microsite-i18n-en" */ "74f054c2cdc3f801"));
        }
    },
    {
        code: 'en-GB',
        nativeName: 'English (UK)',
        loadMessages: function() {
            return importDefault(require(/* webpackChunkName: "twg-microsite-i18n-en_GB" */ "a8dd4e952241c294"));
        }
    },
    {
        // Pseudo-locale, useful for QA. Hidden from the dropdown via
        // `SELECTABLE_LOCALES` below but still loadable if persisted.
        code: 'en-ZZ',
        nativeName: 'English (pseudo)',
        loadMessages: function() {
            return importDefault(require(/* webpackChunkName: "twg-microsite-i18n-en_ZZ" */ "2eb73cfd244f162d"));
        }
    },
    {
        code: 'cs',
        nativeName: "\u010Ce\u0161tina",
        loadMessages: function() {
            return importDefault(require(/* webpackChunkName: "twg-microsite-i18n-cs" */ "4da3ae86d7c7a6a9"));
        }
    },
    {
        code: 'da',
        nativeName: 'Dansk',
        loadMessages: function() {
            return importDefault(require(/* webpackChunkName: "twg-microsite-i18n-da" */ "386606f184c61f6e"));
        }
    },
    {
        code: 'de',
        nativeName: 'Deutsch',
        loadMessages: function() {
            return importDefault(require(/* webpackChunkName: "twg-microsite-i18n-de" */ "5412d0d8e6a4aba2"));
        }
    },
    {
        code: 'es',
        nativeName: "Espa\xf1ol",
        loadMessages: function() {
            return importDefault(require(/* webpackChunkName: "twg-microsite-i18n-es" */ "8c7bbad7963be634"));
        }
    },
    {
        code: 'fi',
        nativeName: 'Suomi',
        loadMessages: function() {
            return importDefault(require(/* webpackChunkName: "twg-microsite-i18n-fi" */ "159466881ba3e7ef"));
        }
    },
    {
        code: 'fr',
        nativeName: "Fran\xe7ais",
        loadMessages: function() {
            return importDefault(require(/* webpackChunkName: "twg-microsite-i18n-fr" */ "bb048247fa9876ef"));
        }
    },
    {
        code: 'hr',
        nativeName: 'Hrvatski',
        loadMessages: function() {
            return importDefault(require(/* webpackChunkName: "twg-microsite-i18n-hr" */ "68ec3db08628d7b4"));
        }
    },
    {
        code: 'hu',
        nativeName: 'Magyar',
        loadMessages: function() {
            return importDefault(require(/* webpackChunkName: "twg-microsite-i18n-hu" */ "2565efed792dfd5a"));
        }
    },
    {
        code: 'it',
        nativeName: 'Italiano',
        loadMessages: function() {
            return importDefault(require(/* webpackChunkName: "twg-microsite-i18n-it" */ "4cc92cdba481bb4a"));
        }
    },
    {
        code: 'ja',
        nativeName: "\u65E5\u672C\u8A9E",
        loadMessages: function() {
            return importDefault(require(/* webpackChunkName: "twg-microsite-i18n-ja" */ "972733288644824e"));
        }
    },
    {
        code: 'ko',
        nativeName: "\uD55C\uAD6D\uC5B4",
        loadMessages: function() {
            return importDefault(require(/* webpackChunkName: "twg-microsite-i18n-ko" */ "f1c191efe8d0532a"));
        }
    },
    {
        code: 'nb',
        nativeName: "Norsk bokm\xe5l",
        loadMessages: function() {
            return importDefault(require(/* webpackChunkName: "twg-microsite-i18n-nb" */ "df6b8f5ed2bb9f56"));
        }
    },
    {
        code: 'nl',
        nativeName: 'Nederlands',
        loadMessages: function() {
            return importDefault(require(/* webpackChunkName: "twg-microsite-i18n-nl" */ "addcca832206138f"));
        }
    },
    {
        code: 'pl',
        nativeName: 'Polski',
        loadMessages: function() {
            return importDefault(require(/* webpackChunkName: "twg-microsite-i18n-pl" */ "c8c4650d9e35a344"));
        }
    },
    {
        code: 'pt-BR',
        nativeName: "Portugu\xeas (Brasil)",
        loadMessages: function() {
            return importDefault(require(/* webpackChunkName: "twg-microsite-i18n-pt_BR" */ "f68c323e1f105ffa"));
        }
    },
    {
        code: 'ru',
        nativeName: "\u0420\u0443\u0441\u0441\u043A\u0438\u0439",
        loadMessages: function() {
            return importDefault(require(/* webpackChunkName: "twg-microsite-i18n-ru" */ "44ac5be4e469b0c"));
        }
    },
    {
        code: 'sl',
        nativeName: "Sloven\u0161\u010Dina",
        loadMessages: function() {
            return importDefault(require(/* webpackChunkName: "twg-microsite-i18n-sl" */ "5a4ab5c18e34e0bd"));
        }
    },
    {
        code: 'sr-RS',
        nativeName: "\u0421\u0440\u043F\u0441\u043A\u0438",
        loadMessages: function() {
            return importDefault(require(/* webpackChunkName: "twg-microsite-i18n-sr_RS" */ "42918efb0738f1d2"));
        }
    },
    {
        code: 'sr-YR',
        nativeName: 'Srpski',
        loadMessages: function() {
            return importDefault(require(/* webpackChunkName: "twg-microsite-i18n-sr_YR" */ "a69776aa1b790d62"));
        }
    },
    {
        code: 'sv',
        nativeName: 'Svenska',
        loadMessages: function() {
            return importDefault(require(/* webpackChunkName: "twg-microsite-i18n-sv" */ "227a18fa9e611ec5"));
        }
    },
    {
        code: 'th',
        nativeName: "\u0E44\u0E17\u0E22",
        loadMessages: function() {
            return importDefault(require(/* webpackChunkName: "twg-microsite-i18n-th" */ "d4c4e49b64f830b0"));
        }
    },
    {
        code: 'tr',
        nativeName: "T\xfcrk\xe7e",
        loadMessages: function() {
            return importDefault(require(/* webpackChunkName: "twg-microsite-i18n-tr" */ "4d0dd16c4fb816fa"));
        }
    },
    {
        code: 'uk',
        nativeName: "\u0423\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430",
        loadMessages: function() {
            return importDefault(require(/* webpackChunkName: "twg-microsite-i18n-uk" */ "b13a11efc0b425b8"));
        }
    },
    {
        code: 'vi',
        nativeName: "Ti\u1EBFng Vi\u1EC7t",
        loadMessages: function() {
            return importDefault(require(/* webpackChunkName: "twg-microsite-i18n-vi" */ "ba038fd893674ab"));
        }
    },
    {
        code: 'zh',
        nativeName: "\u7B80\u4F53\u4E2D\u6587",
        loadMessages: function() {
            return importDefault(require(/* webpackChunkName: "twg-microsite-i18n-zh" */ "16846e6c6537dad5"));
        }
    },
    {
        code: 'zh-TW',
        nativeName: "\u7E41\u9AD4\u4E2D\u6587",
        loadMessages: function() {
            return importDefault(require(/* webpackChunkName: "twg-microsite-i18n-zh_TW" */ "dc312a4f4a91ce13"));
        }
    }
];
var SELECTABLE_LOCALES = SUPPORTED_LOCALES.filter(function(l) {
    return l.code !== 'en-ZZ';
});
var DEFAULT_LOCALE = 'en';
var isSupportedLocale = function(value) {
    return value !== null && value !== undefined && SUPPORTED_LOCALES.some(function(l) {
        return l.code === value;
    });
};
var getDescriptor = function(code) {
    return(// Safe non-null assert: type guard ensures `code` is in the catalog.
    SUPPORTED_LOCALES.find(function(l) {
        return l.code === code;
    }));
};

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_ts_generator":"78Tqx","74f054c2cdc3f801":"dwn8V","a8dd4e952241c294":"961Ps","2eb73cfd244f162d":"9OZPo","4da3ae86d7c7a6a9":"l7P4d","386606f184c61f6e":"iyhT7","5412d0d8e6a4aba2":"6K6iP","8c7bbad7963be634":"j5tgU","159466881ba3e7ef":"61iAY","bb048247fa9876ef":"fp7Mm","68ec3db08628d7b4":"4jfNX","2565efed792dfd5a":"e59pY","4cc92cdba481bb4a":"iOGdk","972733288644824e":"cNhtZ","f1c191efe8d0532a":"bWEcc","df6b8f5ed2bb9f56":"ch7cI","addcca832206138f":"8UUTk","c8c4650d9e35a344":"afm60","f68c323e1f105ffa":"5Y55M","44ac5be4e469b0c":"3UNyk","5a4ab5c18e34e0bd":"eTyqK","42918efb0738f1d2":"1stPF","a69776aa1b790d62":"3yicE","227a18fa9e611ec5":"glnjE","d4c4e49b64f830b0":"2pJZX","4d0dd16c4fb816fa":"5CBUu","b13a11efc0b425b8":"bcIbq","ba038fd893674ab":"1Wd3T","16846e6c6537dad5":"2fKwz","dc312a4f4a91ce13":"iSi8y","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dwn8V":[function(require,module,exports,__globalThis) {
module.exports = require("733726beaee5eeaf")(require("4b02c6e1ee4d9a79").resolve("cdclT")).then(function() {
    return module.bundle.root('7GwHY');
});

},{"733726beaee5eeaf":"hkfCW","4b02c6e1ee4d9a79":"l4T2r"}],"961Ps":[function(require,module,exports,__globalThis) {
module.exports = require("2291c7529e4e49")(require("17d10f919556e8c2").resolve("dzQRf")).then(function() {
    return module.bundle.root('hCqor');
});

},{"2291c7529e4e49":"hkfCW","17d10f919556e8c2":"l4T2r"}],"9OZPo":[function(require,module,exports,__globalThis) {
module.exports = require("2c6a3ae268fe4693")(require("36c8ec23da5a2da2").resolve("hlBqQ")).then(function() {
    return module.bundle.root('bLLkt');
});

},{"2c6a3ae268fe4693":"hkfCW","36c8ec23da5a2da2":"l4T2r"}],"l7P4d":[function(require,module,exports,__globalThis) {
module.exports = require("1b2c608e0ebc8c61")(require("ea3eaf69d0bf58e0").resolve("lnVjz")).then(function() {
    return module.bundle.root('hD8Cd');
});

},{"1b2c608e0ebc8c61":"hkfCW","ea3eaf69d0bf58e0":"l4T2r"}],"iyhT7":[function(require,module,exports,__globalThis) {
module.exports = require("2b740994bcd1a6a9")(require("b92667f9edfddb36").resolve("br28T")).then(function() {
    return module.bundle.root('c1sNE');
});

},{"2b740994bcd1a6a9":"hkfCW","b92667f9edfddb36":"l4T2r"}],"6K6iP":[function(require,module,exports,__globalThis) {
module.exports = require("9a1f083131a7784f")(require("28067e60b6761ca9").resolve("kH7Yd")).then(function() {
    return module.bundle.root('eTnDU');
});

},{"9a1f083131a7784f":"hkfCW","28067e60b6761ca9":"l4T2r"}],"j5tgU":[function(require,module,exports,__globalThis) {
module.exports = require("e4fd2b7be20faf69")(require("a8468bdb2823eec4").resolve("cxItN")).then(function() {
    return module.bundle.root('RRc1V');
});

},{"e4fd2b7be20faf69":"hkfCW","a8468bdb2823eec4":"l4T2r"}],"61iAY":[function(require,module,exports,__globalThis) {
module.exports = require("a8be480ae9fa7722")(require("5450fc8d1e35c078").resolve("96GQN")).then(function() {
    return module.bundle.root('52iDA');
});

},{"a8be480ae9fa7722":"hkfCW","5450fc8d1e35c078":"l4T2r"}],"fp7Mm":[function(require,module,exports,__globalThis) {
module.exports = require("c9b0fb024af32c8c")(require("e6ae608fa87bbbeb").resolve("aihnn")).then(function() {
    return module.bundle.root('dw3Yr');
});

},{"c9b0fb024af32c8c":"hkfCW","e6ae608fa87bbbeb":"l4T2r"}],"4jfNX":[function(require,module,exports,__globalThis) {
module.exports = require("14c3b914bcead19d")(require("7161c4ae539c024c").resolve("8YqLk")).then(function() {
    return module.bundle.root('ayA5E');
});

},{"14c3b914bcead19d":"hkfCW","7161c4ae539c024c":"l4T2r"}],"e59pY":[function(require,module,exports,__globalThis) {
module.exports = require("e5d78bb3b5a4b2e")(require("57094116b3ac6003").resolve("cBRjP")).then(function() {
    return module.bundle.root('2B1q4');
});

},{"e5d78bb3b5a4b2e":"hkfCW","57094116b3ac6003":"l4T2r"}],"iOGdk":[function(require,module,exports,__globalThis) {
module.exports = require("636b86faec79e024")(require("15cc642584661d14").resolve("hSGtd")).then(function() {
    return module.bundle.root('fLQNX');
});

},{"636b86faec79e024":"hkfCW","15cc642584661d14":"l4T2r"}],"cNhtZ":[function(require,module,exports,__globalThis) {
module.exports = require("9b6391163e2cd518")(require("71e3b088e9e702a8").resolve("cV1OE")).then(function() {
    return module.bundle.root('9vpTv');
});

},{"9b6391163e2cd518":"hkfCW","71e3b088e9e702a8":"l4T2r"}],"bWEcc":[function(require,module,exports,__globalThis) {
module.exports = require("cf8b3f83d678ef5b")(require("6a244196cd42829e").resolve("gMaub")).then(function() {
    return module.bundle.root('7AHhf');
});

},{"cf8b3f83d678ef5b":"hkfCW","6a244196cd42829e":"l4T2r"}],"ch7cI":[function(require,module,exports,__globalThis) {
module.exports = require("bbc222a6cd3b4bf2")(require("92905797e3b43946").resolve("5n7rK")).then(function() {
    return module.bundle.root('1YPlB');
});

},{"bbc222a6cd3b4bf2":"hkfCW","92905797e3b43946":"l4T2r"}],"8UUTk":[function(require,module,exports,__globalThis) {
module.exports = require("7c540281c89fb251")(require("2b3377f44bb38dee").resolve("cSP52")).then(function() {
    return module.bundle.root('bZNXA');
});

},{"7c540281c89fb251":"hkfCW","2b3377f44bb38dee":"l4T2r"}],"afm60":[function(require,module,exports,__globalThis) {
module.exports = require("58fe018c0f5f0f14")(require("fca77e834546608d").resolve("lDbE2")).then(function() {
    return module.bundle.root('cLBFP');
});

},{"58fe018c0f5f0f14":"hkfCW","fca77e834546608d":"l4T2r"}],"5Y55M":[function(require,module,exports,__globalThis) {
module.exports = require("597b65af1eaa37b")(require("ac74900d448bb507").resolve("gi4AZ")).then(function() {
    return module.bundle.root('9MOcg');
});

},{"597b65af1eaa37b":"hkfCW","ac74900d448bb507":"l4T2r"}],"3UNyk":[function(require,module,exports,__globalThis) {
module.exports = require("bedd6e609ddf07bd")(require("dc8279e7c7d32375").resolve("2Kzmf")).then(function() {
    return module.bundle.root('bR7SK');
});

},{"bedd6e609ddf07bd":"hkfCW","dc8279e7c7d32375":"l4T2r"}],"eTyqK":[function(require,module,exports,__globalThis) {
module.exports = require("da7766ec99886a27")(require("50d0ccc5597b54ec").resolve("lOsPP")).then(function() {
    return module.bundle.root('i6ae6');
});

},{"da7766ec99886a27":"hkfCW","50d0ccc5597b54ec":"l4T2r"}],"1stPF":[function(require,module,exports,__globalThis) {
module.exports = require("d3c537a04e7f2e5c")(require("f47833ed9927afdf").resolve("ll1oj")).then(function() {
    return module.bundle.root('6MNhD');
});

},{"d3c537a04e7f2e5c":"hkfCW","f47833ed9927afdf":"l4T2r"}],"3yicE":[function(require,module,exports,__globalThis) {
module.exports = require("7d99b0d43a985c62")(require("7410794ce8bbdebf").resolve("iW114")).then(function() {
    return module.bundle.root('htOE1');
});

},{"7d99b0d43a985c62":"hkfCW","7410794ce8bbdebf":"l4T2r"}],"glnjE":[function(require,module,exports,__globalThis) {
module.exports = require("378dd9edbaaf3b85")(require("50ac59b2e0930b97").resolve("cAOL5")).then(function() {
    return module.bundle.root('kE0Wc');
});

},{"378dd9edbaaf3b85":"hkfCW","50ac59b2e0930b97":"l4T2r"}],"2pJZX":[function(require,module,exports,__globalThis) {
module.exports = require("e5d3d012271cec5e")(require("f8c1c1151a09f530").resolve("hF7qa")).then(function() {
    return module.bundle.root('kBZKV');
});

},{"e5d3d012271cec5e":"hkfCW","f8c1c1151a09f530":"l4T2r"}],"5CBUu":[function(require,module,exports,__globalThis) {
module.exports = require("d3dc93127bc4e8f0")(require("f08fb3600670f495").resolve("cBQUh")).then(function() {
    return module.bundle.root('6pLzk');
});

},{"d3dc93127bc4e8f0":"hkfCW","f08fb3600670f495":"l4T2r"}],"bcIbq":[function(require,module,exports,__globalThis) {
module.exports = require("cecba8f6b65aeab4")(require("6e5aa284b3094c0a").resolve("AC0xZ")).then(function() {
    return module.bundle.root('ejY9N');
});

},{"cecba8f6b65aeab4":"hkfCW","6e5aa284b3094c0a":"l4T2r"}],"1Wd3T":[function(require,module,exports,__globalThis) {
module.exports = require("ad71cd4204549824")(require("47ab2c0a56ff2b3d").resolve("iDfn8")).then(function() {
    return module.bundle.root('a9dX2');
});

},{"ad71cd4204549824":"hkfCW","47ab2c0a56ff2b3d":"l4T2r"}],"2fKwz":[function(require,module,exports,__globalThis) {
module.exports = require("426624032bc037c0")(require("bd0922a498675eb5").resolve("4s3fz")).then(function() {
    return module.bundle.root('hn7Gz');
});

},{"426624032bc037c0":"hkfCW","bd0922a498675eb5":"l4T2r"}],"iSi8y":[function(require,module,exports,__globalThis) {
module.exports = require("38622bab1d7ab7ea")(require("dcf107875df9f7a1").resolve("fIgqJ")).then(function() {
    return module.bundle.root('3WzCP');
});

},{"38622bab1d7ab7ea":"hkfCW","dcf107875df9f7a1":"l4T2r"}],"aEB63":[function(require,module,exports,__globalThis) {
/**
 * Thin, exception-safe wrapper around localStorage. Returns null /
 * silently no-ops when storage is unavailable (SSR, private mode,
 * cookies-blocked browsers, quota exceeded).
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "readPersistedLocale", function() {
    return readPersistedLocale;
});
parcelHelpers.export(exports, "writePersistedLocale", function() {
    return writePersistedLocale;
});
var STORAGE_KEY = 'twg-microsite.locale';
var getStorage = function() {
    try {
        // `globalThis.localStorage` may throw on access in some sandboxed iframes.
        return typeof globalThis !== 'undefined' && globalThis.localStorage ? globalThis.localStorage : null;
    } catch (e) {
        return null;
    }
};
var readPersistedLocale = function() {
    var storage = getStorage();
    if (!storage) return null;
    try {
        return storage.getItem(STORAGE_KEY);
    } catch (e) {
        return null;
    }
};
var writePersistedLocale = function(locale) {
    var storage = getStorage();
    if (!storage) return;
    try {
        storage.setItem(STORAGE_KEY, locale);
    } catch (e) {
    // Quota exceeded or storage disabled mid-session — non-fatal.
    }
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6EHQI":[function(require,module,exports,__globalThis) {
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NAV_BAR_HEIGHT_PX", function() {
    return NAV_BAR_HEIGHT_PX;
});
parcelHelpers.export(exports, "NavigationBar", function() {
    return NavigationBar;
});
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _reactIntl = require("react-intl");
var _new = require("@atlaskit/button/new");
var _bug = require("@atlaskit/icon/core/bug");
var _bugDefault = parcelHelpers.interopDefault(_bug);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _compiled = require("@atlaskit/primitives/compiled");
var _segment = require("@atlaskit/react-ufo/segment");
var _segmentDefault = parcelHelpers.interopDefault(_segment);
var _spinner = require("@atlaskit/spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _twgLogoSvg = require("../../../assets/twg-logo.svg");
var _twgLogoSvgDefault = parcelHelpers.interopDefault(_twgLogoSvg);
var _useAnalyticsEvents = require("../../../common/analytics/generated/use-analytics-events");
var _usePanelContext = require("../../../hooks/use-panel-context");
var _useUserContext = require("../../../hooks/use-user-context");
var _siteSwitcher = require("../SiteSwitcher");
var _messages = require("./messages");
var _navButtons = require("./NavButtons");
var _userAvatarDropdown = require("./UserAvatarDropdown");
var NAV_BAR_HEIGHT_PX = 88;
var styles = {
    navBar: "_1bsb1osq _bfhk1hlk _kqsw1n9t _154iidpf _1pbyzo7u",
    navBarContent: "_18zrxy5q _195g1wug _1bsb1osq _p12fuj8w _4t3icmky _ca0q1ejb _n3td1ejb",
    logoContainer: "_zulpu2gc _11c81af2 _1e0c1txw _4cvr1h6o _ect41roz _10fpv2br _k48pi7a9 _vwz4gktf",
    logo: "_1bsb7vkz _4t3i7vkz _jjfozwfg _1e1uzwfg",
    logoLabel: "_7l59glyw",
    rightControls: "_zulppxbi _1e0c1txw _2lx2vrvc _4cvr1h6o _10fph9n0",
    loginButton: "_zulp12x7 _2rko1qi0 _v5641ux5 _11c8fhey _18zrsm30 _1rjccy7w _189e1lya _1dqonqa1 _1h6d1e01 _1e0c116y _4cvr1h6o _bfhk1hlk _80omtlke _1pbykb7n _vwz4gktf _syaz14je _k48p1wq8 _irr31dpa"
};
var navBarContentStyles = null;
var leftNavStyles = null;
var NavigationBar = function() {
    var _useAtlassianUserContext = (0, _useUserContext.useAtlassianUserContext)(), user = _useAtlassianUserContext.identity, loading = _useAtlassianUserContext.loading, error = _useAtlassianUserContext.error, attemptUserLogin = _useAtlassianUserContext.attemptUserLogin;
    var formatMessage = (0, _reactIntl.useIntl)().formatMessage;
    var _usePanelContext1 = (0, _usePanelContext.usePanelContext)(), togglePanel = _usePanelContext1.togglePanel, isOpen = _usePanelContext1.isOpen;
    var fireEvent = (0, _useAnalyticsEvents.useAnalyticsEvents)().fireEvent;
    var handleLoginClick = (0, _react.useCallback)(function() {
        fireEvent('ui.button.clicked.twgMicrositeLogin', {
            location: 'navBar'
        });
        attemptUserLogin();
    }, [
        fireEvent,
        attemptUserLogin
    ]);
    var isLoggedIn = !loading && !error && !!user.email;
    return /*#__PURE__*/ _react.createElement((0, _segmentDefault.default), {
        name: "twg-microsite.nav-bar"
    }, /*#__PURE__*/ _react.createElement("div", {
        className: (0, _runtime.ax)([
            styles.navBar
        ])
    }, /*#__PURE__*/ _react.createElement((0, _compiled.Box), {
        xcss: styles.navBarContent
    }, /*#__PURE__*/ _react.createElement("div", {
        className: (0, _runtime.ax)([
            "_1bsb1osq _1e0c1txw _4cvr1h6o _1bah1yb4"
        ])
    }, /*#__PURE__*/ _react.createElement("div", {
        className: (0, _runtime.ax)([
            "_zulpxy5q _1e0c1txw _4cvr1h6o"
        ])
    }, /*#__PURE__*/ _react.createElement("div", {
        className: (0, _runtime.ax)([
            styles.logoContainer
        ])
    }, /*#__PURE__*/ _react.createElement("img", {
        src: (0, _twgLogoSvgDefault.default),
        alt: formatMessage((0, _messages.messages).logoAlt),
        className: (0, _runtime.ax)([
            styles.logo
        ])
    }), /*#__PURE__*/ _react.createElement("span", {
        className: (0, _runtime.ax)([
            styles.logoLabel
        ])
    }, /*#__PURE__*/ _react.createElement((0, _reactIntl.FormattedMessage), (0, _messages.messages).teamworkGraphBrand))), !loading && /*#__PURE__*/ _react.createElement((0, _navButtons.NavButtons), {
        ariaLabel: formatMessage((0, _messages.messages).teamworkGraphBrand),
        isLoggedIn: isLoggedIn
    })), /*#__PURE__*/ _react.createElement("div", {
        className: (0, _runtime.ax)([
            styles.rightControls
        ])
    }, loading && // `data-vc-ignore-if-no-layout-shift="true"` excludes the
    // auth-loading spinner from React UFO's VC tracking. The
    // `@atlaskit/spinner` SVG runs an infinite CSS animation in
    // a fixed-size box (no layout shift) so VC can safely
    // ignore its mutations — otherwise the spinner kicks the
    // VC quiet window for the full duration of auth resolution
    // and prevents the page-load interaction from sealing.
    /*#__PURE__*/ _react.createElement("span", {
        "data-vc-ignore-if-no-layout-shift": "true"
    }, /*#__PURE__*/ _react.createElement((0, _spinnerDefault.default), {
        size: "small",
        interactionName: "twg-microsite.nav-bar.user-loading"
    })), error && /*#__PURE__*/ _react.createElement("button", {
        onClick: handleLoginClick,
        "aria-label": formatMessage((0, _messages.messages).loginAriaLabel),
        className: (0, _runtime.ax)([
            styles.loginButton
        ])
    }, /*#__PURE__*/ _react.createElement((0, _reactIntl.FormattedMessage), (0, _messages.messages).loginButton)), !loading && !error && user && /*#__PURE__*/ _react.createElement((0, _siteSwitcher.SiteSwitcher), null), !loading && !error && user && /*#__PURE__*/ _react.createElement((0, _userAvatarDropdown.UserAvatarDropdown), {
        user: user
    }), (0, _platformFeatureFlags.fg)('twg_microsite_debug_panel') && /*#__PURE__*/ _react.createElement((0, _new.IconButton), {
        icon: (0, _bugDefault.default),
        label: "Debug Menu Toggle",
        appearance: isOpen ? 'discovery' : 'default',
        onClick: togglePanel
    }))))));
};

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","react-intl":"f41fF","@atlaskit/button/new":"2LnSZ","@atlaskit/icon/core/bug":"jWYsB","@atlaskit/platform-feature-flags":"kO5t9","@atlaskit/primitives/compiled":"jhQE8","@atlaskit/react-ufo/segment":"cMGle","@atlaskit/spinner":"04ZYE","../../../assets/twg-logo.svg":"liCCW","../../../common/analytics/generated/use-analytics-events":"hpATH","../../../hooks/use-panel-context":"18Ozg","../../../hooks/use-user-context":"6Qevx","../SiteSwitcher":"bPdBB","./messages":"ik60l","./NavButtons":"kjP9L","./UserAvatarDropdown":"2B025","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jWYsB":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b1c065f0aa91b3c3f089345b7ec72ae8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("991c470762005b2d"));
var _baseNew = _interopRequireDefault(require("f5c9e17ec3eaa55a"));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Bug".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Request types in JSM, bugs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ var BugIcon = function(props) {
    return /*#__PURE__*/ _react.default.createElement(_baseNew.default, Object.assign({
        name: "BugIcon",
        dangerouslySetGlyph: '<path fill="currentcolor" fill-rule="evenodd" d="M8 2.5A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 8 2.5m3 1.52V4a3 3 0 0 0-6 0v.02c-.29.05-.553.182-.761.372l-.887-.633-.917-2.064-1.37.61.944 2.125c.09.204.234.38.416.51l1.325.946V7H.5v1.5h3.25v1.149l-1.15.958a1.25 1.25 0 0 0-.318.401L1.08 13.415l1.342.67 1.18-2.36.46-.383A4.25 4.25 0 0 0 8.001 14h.249A4 4 0 0 0 12 11.393l.4.333 1.18 2.36 1.34-.671-1.202-2.407a1.25 1.25 0 0 0-.318-.401l-1.15-.958V8.5h3.25V7h-3.25V5.886l1.325-.946a1.25 1.25 0 0 0 .416-.51l.944-2.125-1.37-.61-.917 2.064-.887.633A1.5 1.5 0 0 0 11 4.02M10.75 10V5.5h-5.5v4.443l.035.226A2.75 2.75 0 0 0 8 12.5h.249a2.5 2.5 0 0 0 2.5-2.5" clip-rule="evenodd"/>'
    }, props));
};
BugIcon.displayName = 'BugIcon';
var _default = exports.default = BugIcon;

},{"991c470762005b2d":"ltHCL","f5c9e17ec3eaa55a":"kuGeY"}],"liCCW":[function(require,module,exports,__globalThis) {
module.exports = require("cf10488b4e23a4d4").getBundleURL('a140o') + "twg-logo.cc815930.svg" + "?" + Date.now();

},{"cf10488b4e23a4d4":"cZKtR"}],"18Ozg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "usePanelContext", function() {
    return usePanelContext;
});
var _react = require("react");
var _panelProvider = require("../../providers/panel-provider");
var usePanelContext = function() {
    var context = (0, _react.useContext)((0, _panelProvider.PanelContext));
    if (!context) throw new Error('usePanelContext must be used within PanelProvider');
    return context;
};

},{"react":"ltHCL","../../providers/panel-provider":"v06Iw","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"v06Iw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PanelContext", function() {
    return PanelContext;
});
parcelHelpers.export(exports, "PanelProvider", function() {
    return PanelProvider;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var PanelContext = /*#__PURE__*/ (0, _react.createContext)(undefined);
function PanelProvider(param) {
    var children = param.children;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), isOpen = _useState[0], setIsOpen = _useState[1];
    var togglePanel = (0, _react.useCallback)(function() {
        setIsOpen(function(_) {
            return !_;
        });
    }, []);
    var value = (0, _react.useMemo)(function() {
        return {
            isOpen: isOpen,
            togglePanel: togglePanel
        };
    }, [
        isOpen,
        togglePanel
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(PanelContext.Provider, {
        value: value
    }, children);
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bPdBB":[function(require,module,exports,__globalThis) {
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SiteSwitcher", function() {
    return SiteSwitcher;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _jotai = require("jotai");
var _reactIntl = require("react-intl");
var _chevronDown = require("@atlaskit/icon/core/chevron-down");
var _chevronDownDefault = parcelHelpers.interopDefault(_chevronDown);
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
var _menu = require("@atlaskit/menu");
var _popup = require("@atlaskit/popup");
var _popupDefault = parcelHelpers.interopDefault(_popup);
var _useAnalyticsEvents = require("../../../common/analytics/generated/use-analytics-events");
var _siteSelectionStorage = require("../../../utils/site-selection-storage");
var _state = require("../../state");
var _messages = require("./messages");
var _switchSiteItem = require("./SwitchSiteItem");
var _types = require("./types");
var styles = {
    trigger: "_zulp12x7 _2rkoi2wt _11c8fhey _v5642qyk _1rjcu2gc _18zrutpp _189e1lya _1dqonqa1 _1h6d1e01 _1e0c116y _4cvr1h6o _1bah1h6o _bfhk1j28 _syaz14je _ect4ttxp _k48p1wq8 _vwz4gktf _o5721q9c _80omtlke _1ygb7g83 _1ah3v77o _4cvx1ggn _irr311vq _30l317fj"
};
var SiteSwitcher = function() {
    var _useAtom = (0, _slicedToArray._)((0, _jotai.useAtom)((0, _state.cloudIdAtom)), 2), cloudId = _useAtom[0], setCloudId = _useAtom[1];
    var _useAtom1 = (0, _slicedToArray._)((0, _jotai.useAtom)((0, _state.orgIdAtom)), 2), setOrgId = _useAtom1[1];
    var setSelectedSiteCloudId = (0, _jotai.useSetAtom)((0, _siteSelectionStorage.selectedSiteCloudIdAtom));
    var _useAtom2 = (0, _slicedToArray._)((0, _jotai.useAtom)((0, _state.previousSelectionSourceAtom)), 2), previousSelectionSource = _useAtom2[0], setPreviousSelectionSource = _useAtom2[1];
    var _useAtomValue = (0, _jotai.useAtomValue)((0, _state.availableSitesAtom)), sites = _useAtomValue.data;
    var formatMessage = (0, _reactIntl.useIntl)().formatMessage;
    var fireEvent = (0, _useAnalyticsEvents.useAnalyticsEvents)().fireEvent;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), isOpen = _useState[0], setIsOpen = _useState[1];
    var onClose = (0, _react.useCallback)(function() {
        setIsOpen(function(prev) {
            if (prev) fireEvent('ui.dropdown.closed.twgMicrositeSiteSwitcher', {
                closeReason: (0, _types.SiteSwitcherCloseReason).Dismissed
            });
            return false;
        });
    }, [
        fireEvent
    ]);
    var onTriggerClick = (0, _react.useCallback)(function() {
        setIsOpen(function(prev) {
            var next = !prev;
            if (next) fireEvent('ui.dropdown.opened.twgMicrositeSiteSwitcher', {});
            else fireEvent('ui.dropdown.closed.twgMicrositeSiteSwitcher', {
                closeReason: (0, _types.SiteSwitcherCloseReason).Dismissed
            });
            return next;
        });
    }, [
        fireEvent
    ]);
    var handleSiteClick = (0, _react.useCallback)(function(e, site) {
        var _site_org;
        e.preventDefault();
        var isActualChange = Boolean(site.cloudId) && site.cloudId !== cloudId;
        if (isActualChange && site.cloudId) {
            fireEvent('ui.dropdownItem.clicked.twgMicrositeSiteSwitcher', {
                previousSelectionSource: previousSelectionSource,
                siteCount: sites.length
            });
            setCloudId(site.cloudId);
            setSelectedSiteCloudId(site.cloudId);
            setPreviousSelectionSource((0, _types.SiteSelectionSource).UserSelection);
        }
        if ((_site_org = site.org) === null || _site_org === void 0 ? void 0 : _site_org.id) setOrgId(site.org.id);
        fireEvent('ui.dropdown.closed.twgMicrositeSiteSwitcher', {
            closeReason: (0, _types.SiteSwitcherCloseReason).ItemSelected
        });
        setIsOpen(false);
    }, [
        cloudId,
        fireEvent,
        previousSelectionSource,
        setCloudId,
        setOrgId,
        setSelectedSiteCloudId,
        setPreviousSelectionSource,
        sites.length
    ]);
    if (sites.length <= 1) // only show the switcher if there are multiple sites
    return null;
    var currentSite = sites.find(function(site) {
        var _this;
        var _site_cloudId;
        return ((_this = (_site_cloudId = site.cloudId) !== null && _site_cloudId !== void 0 ? _site_cloudId : '') === null || _this === void 0 ? void 0 : _this.length) !== 0 && site.cloudId === cloudId;
    });
    var _currentSite_displayName;
    var triggerLabel = (_currentSite_displayName = currentSite === null || currentSite === void 0 ? void 0 : currentSite.displayName) !== null && _currentSite_displayName !== void 0 ? _currentSite_displayName : formatMessage((0, _messages.messages).switchSiteLabel);
    // Pin the currently selected site to the top of the list, then sort the
    // remaining sites alphabetically by displayName. `localeCompare` with
    // `sensitivity: 'base'` makes the alphabetical order locale-aware and
    // case-insensitive (so "atlassian" and "Atlassian" sort together).
    var sortedSites = (0, _toConsumableArray._)(sites).sort(function(a, b) {
        if (a.cloudId === cloudId) return -1;
        if (b.cloudId === cloudId) return 1;
        var _a_displayName, _b_displayName;
        return ((_a_displayName = a.displayName) !== null && _a_displayName !== void 0 ? _a_displayName : '').localeCompare((_b_displayName = b.displayName) !== null && _b_displayName !== void 0 ? _b_displayName : '', undefined, {
            sensitivity: 'base'
        });
    });
    return /*#__PURE__*/ _react.createElement((0, _popupDefault.default), {
        placement: "bottom-end",
        isOpen: isOpen,
        onClose: onClose,
        shouldRenderToParent: true,
        testId: "site-switcher-menu",
        content: function() {
            return /*#__PURE__*/ _react.createElement((0, _menu.MenuGroup), {
                minWidth: 192,
                maxWidth: 480,
                maxHeight: "80vh"
            }, /*#__PURE__*/ _react.createElement((0, _menu.Section), {
                isList: true,
                titleId: "site-switcher-heading"
            }, /*#__PURE__*/ _react.createElement((0, _menu.HeadingItem), {
                id: "site-switcher-heading"
            }, /*#__PURE__*/ _react.createElement((0, _reactIntl.FormattedMessage), (0, _messages.messages).switchSiteHeading)), sortedSites.map(function(site) {
                var _this;
                var _site_cloudId, _site_cloudId1;
                return /*#__PURE__*/ _react.createElement((0, _switchSiteItem.SwitchSiteItem), {
                    key: (_site_cloudId = site.cloudId) !== null && _site_cloudId !== void 0 ? _site_cloudId : site.url,
                    href: site.url,
                    onItemClick: handleSiteClick,
                    site: site,
                    isSelected: ((_this = (_site_cloudId1 = site.cloudId) !== null && _site_cloudId1 !== void 0 ? _site_cloudId1 : '') === null || _this === void 0 ? void 0 : _this.length) !== 0 && site.cloudId === cloudId
                });
            })));
        },
        trigger: function(triggerProps) {
            return /*#__PURE__*/ _react.createElement("button", (0, _objectSpreadProps._)((0, _objectSpread._)({}, triggerProps), {
                type: "button",
                "aria-label": formatMessage((0, _messages.messages).switchSiteLabel),
                "aria-haspopup": "true",
                "aria-expanded": isOpen,
                onClick: onTriggerClick,
                "data-testid": "site-switcher-dropdown-button",
                className: (0, _runtime.ax)([
                    styles.trigger
                ])
            }), triggerLabel, /*#__PURE__*/ _react.createElement((0, _chevronDownDefault.default), {
                label: "",
                color: "currentColor"
            }));
        }
    });
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_to_consumable_array":"1eSZf","react":"ltHCL","@compiled/react/runtime":"d27Vo","jotai":"4mcir","react-intl":"f41fF","@atlaskit/icon/core/chevron-down":"6b1ia","@atlaskit/menu":"drNQs","@atlaskit/popup":"9PMZe","../../../common/analytics/generated/use-analytics-events":"hpATH","../../../utils/site-selection-storage":"gaJ0A","../../state":"jgfkg","./messages":"kiEOl","./SwitchSiteItem":"cQnjS","./types":"hBDS8","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4mcir":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vanilla = require("jotai/vanilla");
parcelHelpers.exportAll(_vanilla, exports);
var _react = require("jotai/react");
parcelHelpers.exportAll(_react, exports);

},{"jotai/vanilla":"7uoOf","jotai/react":"9TfKr","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7uoOf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "INTERNAL_overrideCreateStore", function() {
    return INTERNAL_overrideCreateStore;
});
parcelHelpers.export(exports, "atom", function() {
    return atom;
});
parcelHelpers.export(exports, "createStore", function() {
    return createStore;
});
parcelHelpers.export(exports, "getDefaultStore", function() {
    return getDefaultStore;
});
var _internals = require("jotai/vanilla/internals");
var $573e945fcb53fc76$import_meta = Object.assign(Object.create(null), {
    url: "file:///../node_modules/jotai/esm/vanilla.mjs"
});
var keyCount = 0;
function atom(read, write) {
    var key = "atom".concat(++keyCount);
    var config = {
        toString: function toString() {
            return ($573e945fcb53fc76$import_meta.env ? $573e945fcb53fc76$import_meta.env.MODE : void 0) !== "production" && this.debugLabel ? key + ":" + this.debugLabel : key;
        }
    };
    if (typeof read === "function") config.read = read;
    else {
        config.init = read;
        config.read = defaultRead;
        config.write = defaultWrite;
    }
    if (write) config.write = write;
    return config;
}
function defaultRead(get) {
    return get(this);
}
function defaultWrite(get, set, arg) {
    return set(this, typeof arg === "function" ? arg(get(this)) : arg);
}
var overiddenCreateStore;
function INTERNAL_overrideCreateStore(fn) {
    overiddenCreateStore = fn(overiddenCreateStore);
}
function createStore() {
    if (overiddenCreateStore) return overiddenCreateStore();
    return (0, _internals.INTERNAL_buildStoreRev2)();
}
var defaultStore;
function getDefaultStore() {
    if (!defaultStore) {
        defaultStore = createStore();
        if (($573e945fcb53fc76$import_meta.env ? $573e945fcb53fc76$import_meta.env.MODE : void 0) !== "production") {
            globalThis.__JOTAI_DEFAULT_STORE__ || (globalThis.__JOTAI_DEFAULT_STORE__ = defaultStore);
            if (globalThis.__JOTAI_DEFAULT_STORE__ !== defaultStore) console.warn("Detected multiple Jotai instances. It may cause unexpected behavior with the default store. https://github.com/pmndrs/jotai/discussions/2044");
        }
    }
    return defaultStore;
}

},{"jotai/vanilla/internals":"c2IHS","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"c2IHS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "INTERNAL_abortPromise", function() {
    return abortPromise;
});
parcelHelpers.export(exports, "INTERNAL_addPendingPromiseToDependency", function() {
    return addPendingPromiseToDependency;
});
parcelHelpers.export(exports, "INTERNAL_buildStoreRev2", function() {
    return buildStore;
});
parcelHelpers.export(exports, "INTERNAL_getBuildingBlocksRev2", function() {
    return getBuildingBlocks;
});
parcelHelpers.export(exports, "INTERNAL_getMountedOrPendingDependents", function() {
    return getMountedOrPendingDependents;
});
parcelHelpers.export(exports, "INTERNAL_hasInitialValue", function() {
    return hasInitialValue;
});
parcelHelpers.export(exports, "INTERNAL_initializeStoreHooksRev2", function() {
    return initializeStoreHooks;
});
parcelHelpers.export(exports, "INTERNAL_isActuallyWritableAtom", function() {
    return isActuallyWritableAtom;
});
parcelHelpers.export(exports, "INTERNAL_isAtomStateInitialized", function() {
    return isAtomStateInitialized;
});
parcelHelpers.export(exports, "INTERNAL_isPendingPromise", function() {
    return isPendingPromise;
});
parcelHelpers.export(exports, "INTERNAL_isPromiseLike", function() {
    return isPromiseLike;
});
parcelHelpers.export(exports, "INTERNAL_promiseStateMap", function() {
    return promiseStateMap;
});
parcelHelpers.export(exports, "INTERNAL_registerAbortHandler", function() {
    return registerAbortHandler;
});
parcelHelpers.export(exports, "INTERNAL_returnAtomValue", function() {
    return returnAtomValue;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var $8c4859bd5c0245bc$import_meta = Object.assign(Object.create(null), {
    url: "file:///../node_modules/jotai/esm/vanilla/internals.mjs"
});
var _atom, _atom1;
function hasInitialValue(atom) {
    return "init" in atom;
}
function isActuallyWritableAtom(atom) {
    return !!atom.write;
}
function isAtomStateInitialized(atomState) {
    return "v" in atomState || "e" in atomState;
}
function returnAtomValue(atomState) {
    if ("e" in atomState) throw atomState.e;
    if (($8c4859bd5c0245bc$import_meta.env ? $8c4859bd5c0245bc$import_meta.env.MODE : void 0) !== "production" && !("v" in atomState)) throw new Error("[Bug] atom state is not initialized");
    return atomState.v;
}
var promiseStateMap = /* @__PURE__ */ new WeakMap();
function isPendingPromise(value) {
    var _a;
    return isPromiseLike(value) && !!((_a = promiseStateMap.get(value)) == null ? void 0 : _a[0]);
}
function abortPromise(promise) {
    var promiseState = promiseStateMap.get(promise);
    if (promiseState == null ? void 0 : promiseState[0]) {
        promiseState[0] = false;
        promiseState[1].forEach(function(fn) {
            return fn();
        });
    }
}
function registerAbortHandler(promise, abortHandler) {
    var promiseState = promiseStateMap.get(promise);
    if (!promiseState) {
        promiseState = [
            true,
            /* @__PURE__ */ new Set()
        ];
        promiseStateMap.set(promise, promiseState);
        var settle = function() {
            promiseState[0] = false;
        };
        promise.then(settle, settle);
    }
    promiseState[1].add(abortHandler);
}
function isPromiseLike(p) {
    return typeof (p == null ? void 0 : p.then) === "function";
}
function addPendingPromiseToDependency(atom, promise, dependencyAtomState) {
    if (!dependencyAtomState.p.has(atom)) {
        dependencyAtomState.p.add(atom);
        var cleanup = function() {
            return dependencyAtomState.p.delete(atom);
        };
        promise.then(cleanup, cleanup);
    }
}
function getMountedOrPendingDependents(atom, atomState, mountedMap) {
    var _a;
    var dependents = /* @__PURE__ */ new Set();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = (((_a = mountedMap.get(atom)) == null ? void 0 : _a.t) || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var a = _step.value;
            if (mountedMap.has(a)) dependents.add(a);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = atomState.p[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var atomWithPendingPromise = _step1.value;
            dependents.add(atomWithPendingPromise);
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return dependents;
}
var createStoreHook = function() {
    var callbacks = /* @__PURE__ */ new Set();
    var notify = function() {
        return callbacks.forEach(function(fn) {
            return fn();
        });
    };
    notify.add = function(fn) {
        callbacks.add(fn);
        return function() {
            return callbacks.delete(fn);
        };
    };
    return notify;
};
var createStoreHookForAtoms = function() {
    var all = {};
    var callbacks = /* @__PURE__ */ new WeakMap();
    var notify = function(atom) {
        var _a, _b;
        (_a = callbacks.get(all)) == null || _a.forEach(function(fn) {
            return fn(atom);
        });
        (_b = callbacks.get(atom)) == null || _b.forEach(function(fn) {
            return fn();
        });
    };
    notify.add = function(atom, fn) {
        var key = atom || all;
        var fns = (callbacks.has(key) ? callbacks : callbacks.set(key, /* @__PURE__ */ new Set())).get(key);
        fns.add(fn);
        return function() {
            fns == null || fns.delete(fn);
            if (!fns.size) callbacks.delete(key);
        };
    };
    return notify;
};
function initializeStoreHooks(storeHooks) {
    storeHooks.r || (storeHooks.r = createStoreHookForAtoms());
    storeHooks.c || (storeHooks.c = createStoreHookForAtoms());
    storeHooks.m || (storeHooks.m = createStoreHookForAtoms());
    storeHooks.u || (storeHooks.u = createStoreHookForAtoms());
    storeHooks.f || (storeHooks.f = createStoreHook());
    return storeHooks;
}
var atomRead = function(_store, atom) {
    for(var _len = arguments.length, params = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        params[_key - 2] = arguments[_key];
    }
    return (_atom = atom).read.apply(_atom, (0, _toConsumableArray._)(params));
};
var atomWrite = function(_store, atom) {
    for(var _len = arguments.length, params = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        params[_key - 2] = arguments[_key];
    }
    return (_atom1 = atom).write.apply(_atom1, (0, _toConsumableArray._)(params));
};
var atomOnInit = function(store, atom) {
    var _a;
    return (_a = atom.unstable_onInit) == null ? void 0 : _a.call(atom, store);
};
var atomOnMount = function(_store, atom, setAtom) {
    var _a;
    return (_a = atom.onMount) == null ? void 0 : _a.call(atom, setAtom);
};
var ensureAtomState = function(store, atom) {
    var buildingBlocks = getInternalBuildingBlocks(store);
    var atomStateMap = buildingBlocks[0];
    var atomOnInit2 = buildingBlocks[9];
    if (($8c4859bd5c0245bc$import_meta.env ? $8c4859bd5c0245bc$import_meta.env.MODE : void 0) !== "production" && !atom) throw new Error("Atom is undefined or null");
    var atomState = atomStateMap.get(atom);
    if (!atomState) {
        atomState = {
            d: /* @__PURE__ */ new Map(),
            p: /* @__PURE__ */ new Set(),
            n: 0
        };
        atomStateMap.set(atom, atomState);
        atomOnInit2 == null || atomOnInit2(store, atom);
    }
    return atomState;
};
var flushCallbacks = function(store) {
    var _loop = function() {
        if (storeHooks.f) call(storeHooks.f);
        var callbacks = /* @__PURE__ */ new Set();
        var add = callbacks.add.bind(callbacks);
        changedAtoms.forEach(function(atom) {
            var _a;
            return (_a = mountedMap.get(atom)) == null ? void 0 : _a.l.forEach(add);
        });
        changedAtoms.clear();
        unmountCallbacks.forEach(add);
        unmountCallbacks.clear();
        mountCallbacks.forEach(add);
        mountCallbacks.clear();
        callbacks.forEach(call);
        if (changedAtoms.size) recomputeInvalidatedAtoms2(store);
    };
    var buildingBlocks = getInternalBuildingBlocks(store);
    var mountedMap = buildingBlocks[1];
    var changedAtoms = buildingBlocks[3];
    var mountCallbacks = buildingBlocks[4];
    var unmountCallbacks = buildingBlocks[5];
    var storeHooks = buildingBlocks[6];
    var recomputeInvalidatedAtoms2 = buildingBlocks[13];
    var errors = [];
    var call = function(fn) {
        try {
            fn();
        } catch (e) {
            errors.push(e);
        }
    };
    do _loop();
    while (changedAtoms.size || unmountCallbacks.size || mountCallbacks.size);
    if (errors.length) throw new AggregateError(errors);
};
var recomputeInvalidatedAtoms = function(store) {
    var buildingBlocks = getInternalBuildingBlocks(store);
    var mountedMap = buildingBlocks[1];
    var invalidatedAtoms = buildingBlocks[2];
    var changedAtoms = buildingBlocks[3];
    var ensureAtomState2 = buildingBlocks[11];
    var readAtomState2 = buildingBlocks[14];
    var mountDependencies2 = buildingBlocks[17];
    var topSortedReversed = [];
    var visiting = /* @__PURE__ */ new WeakSet();
    var visited = /* @__PURE__ */ new WeakSet();
    var stack = Array.from(changedAtoms);
    while(stack.length){
        var a = stack[stack.length - 1];
        var aState = ensureAtomState2(store, a);
        if (visited.has(a)) {
            stack.pop();
            continue;
        }
        if (visiting.has(a)) {
            if (invalidatedAtoms.get(a) === aState.n) topSortedReversed.push([
                a,
                aState
            ]);
            else if (($8c4859bd5c0245bc$import_meta.env ? $8c4859bd5c0245bc$import_meta.env.MODE : void 0) !== "production" && invalidatedAtoms.has(a)) throw new Error("[Bug] invalidated atom exists");
            visited.add(a);
            stack.pop();
            continue;
        }
        visiting.add(a);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = getMountedOrPendingDependents(a, aState, mountedMap)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var d = _step.value;
                if (!visiting.has(d)) stack.push(d);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    for(var i = topSortedReversed.length - 1; i >= 0; --i){
        var _topSortedReversed_i = (0, _slicedToArray._)(topSortedReversed[i], 2), a1 = _topSortedReversed_i[0], aState1 = _topSortedReversed_i[1];
        var hasChangedDeps = false;
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = aState1.d.keys()[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var dep = _step1.value;
                if (dep !== a1 && changedAtoms.has(dep)) {
                    hasChangedDeps = true;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        if (hasChangedDeps) {
            readAtomState2(store, a1);
            mountDependencies2(store, a1);
        }
        invalidatedAtoms.delete(a1);
    }
};
var readAtomState = function(store, atom) {
    var _a, _b;
    var buildingBlocks = getInternalBuildingBlocks(store);
    var mountedMap = buildingBlocks[1];
    var invalidatedAtoms = buildingBlocks[2];
    var changedAtoms = buildingBlocks[3];
    var storeHooks = buildingBlocks[6];
    var atomRead2 = buildingBlocks[7];
    var ensureAtomState2 = buildingBlocks[11];
    var flushCallbacks2 = buildingBlocks[12];
    var recomputeInvalidatedAtoms2 = buildingBlocks[13];
    var readAtomState2 = buildingBlocks[14];
    var writeAtomState2 = buildingBlocks[16];
    var mountDependencies2 = buildingBlocks[17];
    var atomState = ensureAtomState2(store, atom);
    if (isAtomStateInitialized(atomState)) {
        if (mountedMap.has(atom) && invalidatedAtoms.get(atom) !== atomState.n) return atomState;
        if (Array.from(atomState.d).every(function(param) {
            var _param = (0, _slicedToArray._)(param, 2), a = _param[0], n = _param[1];
            return(// Recursively, read the atom state of the dependency, and
            // check if the atom epoch number is unchanged
            readAtomState2(store, a).n === n);
        })) return atomState;
    }
    atomState.d.clear();
    var isSync = true;
    function mountDependenciesIfAsync() {
        if (mountedMap.has(atom)) {
            mountDependencies2(store, atom);
            recomputeInvalidatedAtoms2(store);
            flushCallbacks2(store);
        }
    }
    function getter(a) {
        var _a2;
        if (a === atom) {
            var aState2 = ensureAtomState2(store, a);
            if (!isAtomStateInitialized(aState2)) {
                if (hasInitialValue(a)) setAtomStateValueOrPromise(store, a, a.init);
                else throw new Error("no atom init");
            }
            return returnAtomValue(aState2);
        }
        var aState = readAtomState2(store, a);
        try {
            return returnAtomValue(aState);
        } finally{
            atomState.d.set(a, aState.n);
            if (isPendingPromise(atomState.v)) addPendingPromiseToDependency(atom, atomState.v, aState);
            (_a2 = mountedMap.get(a)) == null || _a2.t.add(atom);
            if (!isSync) mountDependenciesIfAsync();
        }
    }
    var controller;
    var setSelf;
    var options = {
        get signal () {
            if (!controller) controller = new AbortController();
            return controller.signal;
        },
        get setSelf () {
            if (($8c4859bd5c0245bc$import_meta.env ? $8c4859bd5c0245bc$import_meta.env.MODE : void 0) !== "production" && !isActuallyWritableAtom(atom)) console.warn("setSelf function cannot be used with read-only atom");
            if (!setSelf && isActuallyWritableAtom(atom)) setSelf = function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                if (($8c4859bd5c0245bc$import_meta.env ? $8c4859bd5c0245bc$import_meta.env.MODE : void 0) !== "production" && isSync) console.warn("setSelf function cannot be called in sync");
                if (!isSync) try {
                    return writeAtomState2.apply(void 0, [
                        store,
                        atom
                    ].concat((0, _toConsumableArray._)(args)));
                } finally{
                    recomputeInvalidatedAtoms2(store);
                    flushCallbacks2(store);
                }
            };
            return setSelf;
        }
    };
    var prevEpochNumber = atomState.n;
    try {
        var valueOrPromise = atomRead2(store, atom, getter, options);
        setAtomStateValueOrPromise(store, atom, valueOrPromise);
        if (isPromiseLike(valueOrPromise)) {
            registerAbortHandler(valueOrPromise, function() {
                return controller == null ? void 0 : controller.abort();
            });
            valueOrPromise.then(mountDependenciesIfAsync, mountDependenciesIfAsync);
        }
        (_a = storeHooks.r) == null || _a.call(storeHooks, atom);
        return atomState;
    } catch (error) {
        delete atomState.v;
        atomState.e = error;
        ++atomState.n;
        return atomState;
    } finally{
        isSync = false;
        if (prevEpochNumber !== atomState.n && invalidatedAtoms.get(atom) === prevEpochNumber) {
            invalidatedAtoms.set(atom, atomState.n);
            changedAtoms.add(atom);
            (_b = storeHooks.c) == null || _b.call(storeHooks, atom);
        }
    }
};
var invalidateDependents = function(store, atom) {
    var buildingBlocks = getInternalBuildingBlocks(store);
    var mountedMap = buildingBlocks[1];
    var invalidatedAtoms = buildingBlocks[2];
    var ensureAtomState2 = buildingBlocks[11];
    var stack = [
        atom
    ];
    while(stack.length){
        var a = stack.pop();
        var aState = ensureAtomState2(store, a);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = getMountedOrPendingDependents(a, aState, mountedMap)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var d = _step.value;
                var dState = ensureAtomState2(store, d);
                invalidatedAtoms.set(d, dState.n);
                stack.push(d);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
};
var writeAtomState = function(store, atom) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        args[_key - 2] = arguments[_key];
    }
    var buildingBlocks = getInternalBuildingBlocks(store);
    var changedAtoms = buildingBlocks[3];
    var storeHooks = buildingBlocks[6];
    var atomWrite2 = buildingBlocks[8];
    var ensureAtomState2 = buildingBlocks[11];
    var flushCallbacks2 = buildingBlocks[12];
    var recomputeInvalidatedAtoms2 = buildingBlocks[13];
    var readAtomState2 = buildingBlocks[14];
    var invalidateDependents2 = buildingBlocks[15];
    var mountDependencies2 = buildingBlocks[17];
    var isSync = true;
    var getter = function(a) {
        return returnAtomValue(readAtomState2(store, a));
    };
    var setter = function(a) {
        for(var _len = arguments.length, args2 = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args2[_key - 1] = arguments[_key];
        }
        var _a;
        var aState = ensureAtomState2(store, a);
        try {
            if (a === atom) {
                if (!hasInitialValue(a)) throw new Error("atom not writable");
                var prevEpochNumber = aState.n;
                var v = args2[0];
                setAtomStateValueOrPromise(store, a, v);
                mountDependencies2(store, a);
                if (prevEpochNumber !== aState.n) {
                    changedAtoms.add(a);
                    (_a = storeHooks.c) == null || _a.call(storeHooks, a);
                    invalidateDependents2(store, a);
                }
                return void 0;
            } else return writeAtomState.apply(void 0, [
                store,
                a
            ].concat((0, _toConsumableArray._)(args2)));
        } finally{
            if (!isSync) {
                recomputeInvalidatedAtoms2(store);
                flushCallbacks2(store);
            }
        }
    };
    try {
        return atomWrite2.apply(void 0, [
            store,
            atom,
            getter,
            setter
        ].concat((0, _toConsumableArray._)(args)));
    } finally{
        isSync = false;
    }
};
var mountDependencies = function(store, atom) {
    var _a;
    var buildingBlocks = getInternalBuildingBlocks(store);
    var mountedMap = buildingBlocks[1];
    var changedAtoms = buildingBlocks[3];
    var storeHooks = buildingBlocks[6];
    var ensureAtomState2 = buildingBlocks[11];
    var invalidateDependents2 = buildingBlocks[15];
    var mountAtom2 = buildingBlocks[18];
    var unmountAtom2 = buildingBlocks[19];
    var atomState = ensureAtomState2(store, atom);
    var mounted = mountedMap.get(atom);
    if (mounted && !isPendingPromise(atomState.v)) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = atomState.d[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, _slicedToArray._)(_step.value, 2), a = _step_value[0], n = _step_value[1];
                if (!mounted.d.has(a)) {
                    var aState = ensureAtomState2(store, a);
                    var aMounted = mountAtom2(store, a);
                    aMounted.t.add(atom);
                    mounted.d.add(a);
                    if (n !== aState.n) {
                        changedAtoms.add(a);
                        (_a = storeHooks.c) == null || _a.call(storeHooks, a);
                        invalidateDependents2(store, a);
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = (mounted.d || [])[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var a1 = _step1.value;
                if (!atomState.d.has(a1)) {
                    mounted.d.delete(a1);
                    var aMounted1 = unmountAtom2(store, a1);
                    aMounted1 == null || aMounted1.t.delete(atom);
                }
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
};
var mountAtom = function(store, atom) {
    var _a;
    var buildingBlocks = getInternalBuildingBlocks(store);
    var mountedMap = buildingBlocks[1];
    var mountCallbacks = buildingBlocks[4];
    var storeHooks = buildingBlocks[6];
    var atomOnMount2 = buildingBlocks[10];
    var ensureAtomState2 = buildingBlocks[11];
    var flushCallbacks2 = buildingBlocks[12];
    var recomputeInvalidatedAtoms2 = buildingBlocks[13];
    var readAtomState2 = buildingBlocks[14];
    var writeAtomState2 = buildingBlocks[16];
    var atomState = ensureAtomState2(store, atom);
    var mounted = mountedMap.get(atom);
    if (!mounted) {
        readAtomState2(store, atom);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = atomState.d.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var a = _step.value;
                var aMounted = mountAtom(store, a);
                aMounted.t.add(atom);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        mounted = {
            l: /* @__PURE__ */ new Set(),
            d: new Set(atomState.d.keys()),
            t: /* @__PURE__ */ new Set()
        };
        mountedMap.set(atom, mounted);
        (_a = storeHooks.m) == null || _a.call(storeHooks, atom);
        if (isActuallyWritableAtom(atom)) {
            var processOnMount = function() {
                var isSync = true;
                var setAtom = function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    try {
                        return writeAtomState2.apply(void 0, [
                            store,
                            atom
                        ].concat((0, _toConsumableArray._)(args)));
                    } finally{
                        if (!isSync) {
                            recomputeInvalidatedAtoms2(store);
                            flushCallbacks2(store);
                        }
                    }
                };
                try {
                    var onUnmount = atomOnMount2(store, atom, setAtom);
                    if (onUnmount) mounted.u = function() {
                        isSync = true;
                        try {
                            onUnmount();
                        } finally{
                            isSync = false;
                        }
                    };
                } finally{
                    isSync = false;
                }
            };
            mountCallbacks.add(processOnMount);
        }
    }
    return mounted;
};
var unmountAtom = function(store, atom) {
    var _a;
    var buildingBlocks = getInternalBuildingBlocks(store);
    var mountedMap = buildingBlocks[1];
    var unmountCallbacks = buildingBlocks[5];
    var storeHooks = buildingBlocks[6];
    var ensureAtomState2 = buildingBlocks[11];
    var unmountAtom2 = buildingBlocks[19];
    var atomState = ensureAtomState2(store, atom);
    var mounted = mountedMap.get(atom);
    if (mounted && !mounted.l.size && !Array.from(mounted.t).some(function(a) {
        var _a2;
        return (_a2 = mountedMap.get(a)) == null ? void 0 : _a2.d.has(atom);
    })) {
        if (mounted.u) unmountCallbacks.add(mounted.u);
        mounted = void 0;
        mountedMap.delete(atom);
        (_a = storeHooks.u) == null || _a.call(storeHooks, atom);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = atomState.d.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var a = _step.value;
                var aMounted = unmountAtom2(store, a);
                aMounted == null || aMounted.t.delete(atom);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return void 0;
    }
    return mounted;
};
var setAtomStateValueOrPromise = function(store, atom, valueOrPromise) {
    var ensureAtomState2 = getInternalBuildingBlocks(store)[11];
    var atomState = ensureAtomState2(store, atom);
    var hasPrevValue = "v" in atomState;
    var prevValue = atomState.v;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (isPromiseLike(valueOrPromise)) try {
        for(var _iterator = atomState.d.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var a = _step.value;
            addPendingPromiseToDependency(atom, valueOrPromise, ensureAtomState2(store, a));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    atomState.v = valueOrPromise;
    delete atomState.e;
    if (!hasPrevValue || !Object.is(prevValue, atomState.v)) {
        ++atomState.n;
        if (isPromiseLike(prevValue)) abortPromise(prevValue);
    }
};
var storeGet = function(store, atom) {
    var readAtomState2 = getInternalBuildingBlocks(store)[14];
    return returnAtomValue(readAtomState2(store, atom));
};
var storeSet = function(store, atom) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        args[_key - 2] = arguments[_key];
    }
    var buildingBlocks = getInternalBuildingBlocks(store);
    var flushCallbacks2 = buildingBlocks[12];
    var recomputeInvalidatedAtoms2 = buildingBlocks[13];
    var writeAtomState2 = buildingBlocks[16];
    try {
        return writeAtomState2.apply(void 0, [
            store,
            atom
        ].concat((0, _toConsumableArray._)(args)));
    } finally{
        recomputeInvalidatedAtoms2(store);
        flushCallbacks2(store);
    }
};
var storeSub = function(store, atom, listener) {
    var buildingBlocks = getInternalBuildingBlocks(store);
    var flushCallbacks2 = buildingBlocks[12];
    var mountAtom2 = buildingBlocks[18];
    var unmountAtom2 = buildingBlocks[19];
    var mounted = mountAtom2(store, atom);
    var listeners = mounted.l;
    listeners.add(listener);
    flushCallbacks2(store);
    return function() {
        listeners.delete(listener);
        unmountAtom2(store, atom);
        flushCallbacks2(store);
    };
};
var buildingBlockMap = /* @__PURE__ */ new WeakMap();
var getInternalBuildingBlocks = function(store) {
    var buildingBlocks = buildingBlockMap.get(store);
    if (($8c4859bd5c0245bc$import_meta.env ? $8c4859bd5c0245bc$import_meta.env.MODE : void 0) !== "production" && !buildingBlocks) throw new Error("Store must be created by buildStore to read its building blocks");
    return buildingBlocks;
};
function getBuildingBlocks(store) {
    var buildingBlocks = getInternalBuildingBlocks(store);
    var enhanceBuildingBlocks = buildingBlocks[24];
    if (enhanceBuildingBlocks) return enhanceBuildingBlocks(buildingBlocks);
    return buildingBlocks;
}
function buildStore() {
    for(var _len = arguments.length, buildArgs = new Array(_len), _key = 0; _key < _len; _key++){
        buildArgs[_key] = arguments[_key];
    }
    var store = {
        get: function get(atom) {
            var storeGet2 = getInternalBuildingBlocks(store)[21];
            return storeGet2(store, atom);
        },
        set: function set(atom) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                args[_key - 1] = arguments[_key];
            }
            var storeSet2 = getInternalBuildingBlocks(store)[22];
            return storeSet2.apply(void 0, [
                store,
                atom
            ].concat((0, _toConsumableArray._)(args)));
        },
        sub: function sub(atom, listener) {
            var storeSub2 = getInternalBuildingBlocks(store)[23];
            return storeSub2(store, atom, listener);
        }
    };
    var buildingBlocks = [
        // store state
        /* @__PURE__ */ new WeakMap(),
        // atomStateMap
        /* @__PURE__ */ new WeakMap(),
        // mountedMap
        /* @__PURE__ */ new WeakMap(),
        // invalidatedAtoms
        /* @__PURE__ */ new Set(),
        // changedAtoms
        /* @__PURE__ */ new Set(),
        // mountCallbacks
        /* @__PURE__ */ new Set(),
        // unmountCallbacks
        {},
        // storeHooks
        // atom interceptors
        atomRead,
        atomWrite,
        atomOnInit,
        atomOnMount,
        // building-block functions
        ensureAtomState,
        flushCallbacks,
        recomputeInvalidatedAtoms,
        readAtomState,
        invalidateDependents,
        writeAtomState,
        mountDependencies,
        mountAtom,
        unmountAtom,
        setAtomStateValueOrPromise,
        storeGet,
        storeSet,
        storeSub,
        void 0
    ].map(function(fn, i) {
        return buildArgs[i] || fn;
    });
    buildingBlockMap.set(store, Object.freeze(buildingBlocks));
    return store;
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_to_consumable_array":"1eSZf","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9TfKr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Provider", function() {
    return Provider;
});
parcelHelpers.export(exports, "useAtom", function() {
    return useAtom;
});
parcelHelpers.export(exports, "useAtomValue", function() {
    return useAtomValue;
});
parcelHelpers.export(exports, "useSetAtom", function() {
    return useSetAtom;
});
parcelHelpers.export(exports, "useStore", function() {
    return useStore;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _vanilla = require("jotai/vanilla");
var _internals = require("jotai/vanilla/internals");
var $73357756bde0d2ae$import_meta = Object.assign(Object.create(null), {
    url: "file:///../node_modules/jotai/esm/react.mjs"
});
'use client';
var StoreContext = (0, _react.createContext)(void 0);
function useStore(options) {
    var store = (0, _react.useContext)(StoreContext);
    return (options == null ? void 0 : options.store) || store || (0, _vanilla.getDefaultStore)();
}
function Provider(param) {
    var children = param.children, store = param.store;
    var storeRef = (0, _react.useRef)(void 0);
    if (!store && !storeRef.current) storeRef.current = (0, _vanilla.createStore)();
    return (0, _react.createElement)(StoreContext.Provider, {
        value: store || storeRef.current
    }, children);
}
var isPromiseLike = function(x) {
    return typeof (x == null ? void 0 : x.then) === "function";
};
var attachPromiseStatus = function(promise) {
    if (!promise.status) {
        promise.status = "pending";
        promise.then(function(v) {
            promise.status = "fulfilled";
            promise.value = v;
        }, function(e) {
            promise.status = "rejected";
            promise.reason = e;
        });
    }
};
var use = (0, _reactDefault.default).use || // A shim for older React versions
function(promise) {
    if (promise.status === "pending") throw promise;
    else if (promise.status === "fulfilled") return promise.value;
    else if (promise.status === "rejected") throw promise.reason;
    else {
        attachPromiseStatus(promise);
        throw promise;
    }
};
var continuablePromiseMap = /* @__PURE__ */ new WeakMap();
var createContinuablePromise = function(promise, getValue) {
    var continuablePromise = continuablePromiseMap.get(promise);
    if (!continuablePromise) {
        continuablePromise = new Promise(function(resolve, reject) {
            var curr = promise;
            var onFulfilled = function(me) {
                return function(v) {
                    if (curr === me) resolve(v);
                };
            };
            var onRejected = function(me) {
                return function(e) {
                    if (curr === me) reject(e);
                };
            };
            var onAbort = function() {
                try {
                    var nextValue = getValue();
                    if (isPromiseLike(nextValue)) {
                        continuablePromiseMap.set(nextValue, continuablePromise);
                        curr = nextValue;
                        nextValue.then(onFulfilled(nextValue), onRejected(nextValue));
                        (0, _internals.INTERNAL_registerAbortHandler)(nextValue, onAbort);
                    } else resolve(nextValue);
                } catch (e) {
                    reject(e);
                }
            };
            promise.then(onFulfilled(promise), onRejected(promise));
            (0, _internals.INTERNAL_registerAbortHandler)(promise, onAbort);
        });
        continuablePromiseMap.set(promise, continuablePromise);
    }
    return continuablePromise;
};
function useAtomValue(atom, options) {
    var _ref = options || {}, delay = _ref.delay, tmp = _ref.unstable_promiseStatus, promiseStatus = tmp === void 0 ? !(0, _reactDefault.default).use : tmp;
    var store = useStore(options);
    var _useReducer = (0, _slicedToArray._)((0, _react.useReducer)(function(prev) {
        var nextValue = store.get(atom);
        if (Object.is(prev[0], nextValue) && prev[1] === store && prev[2] === atom) return prev;
        return [
            nextValue,
            store,
            atom
        ];
    }, void 0, function() {
        return [
            store.get(atom),
            store,
            atom
        ];
    }), 2), _useReducer_ = (0, _slicedToArray._)(_useReducer[0], 3), valueFromReducer = _useReducer_[0], storeFromReducer = _useReducer_[1], atomFromReducer = _useReducer_[2], rerender = _useReducer[1];
    var value = valueFromReducer;
    if (storeFromReducer !== store || atomFromReducer !== atom) {
        rerender();
        value = store.get(atom);
    }
    (0, _react.useEffect)(function() {
        var unsub = store.sub(atom, function() {
            if (promiseStatus) try {
                var value2 = store.get(atom);
                if (isPromiseLike(value2)) attachPromiseStatus(createContinuablePromise(value2, function() {
                    return store.get(atom);
                }));
            } catch (e) {}
            if (typeof delay === "number") {
                setTimeout(rerender, delay);
                return;
            }
            rerender();
        });
        rerender();
        return unsub;
    }, [
        store,
        atom,
        delay,
        promiseStatus
    ]);
    (0, _react.useDebugValue)(value);
    if (isPromiseLike(value)) {
        var promise = createContinuablePromise(value, function() {
            return store.get(atom);
        });
        if (promiseStatus) attachPromiseStatus(promise);
        return use(promise);
    }
    return value;
}
function useSetAtom(atom, options) {
    var store = useStore(options);
    var setAtom = (0, _react.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _store;
        if (($73357756bde0d2ae$import_meta.env ? $73357756bde0d2ae$import_meta.env.MODE : void 0) !== "production" && !("write" in atom)) throw new Error("not writable atom");
        return (_store = store).set.apply(_store, [
            atom
        ].concat((0, _toConsumableArray._)(args)));
    }, [
        store,
        atom
    ]);
    return setAtom;
}
function useAtom(atom, options) {
    return [
        useAtomValue(atom, options),
        // We do wrong type assertion here, which results in throwing an error.
        useSetAtom(atom, options)
    ];
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_to_consumable_array":"1eSZf","react":"ltHCL","jotai/vanilla":"7uoOf","jotai/vanilla/internals":"c2IHS","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"drNQs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ButtonItem", function() {
    return 0, _buttonItemDefault.default;
});
parcelHelpers.export(exports, "LinkItem", function() {
    return 0, _linkItemDefault.default;
});
parcelHelpers.export(exports, "CustomItem", function() {
    return 0, _customItemDefault.default;
});
parcelHelpers.export(exports, "SkeletonItem", function() {
    return 0, _skeletonItemDefault.default;
});
parcelHelpers.export(exports, "SpacingContext", function() {
    return 0, _menuContext.SpacingContext;
});
parcelHelpers.export(exports, "SELECTION_STYLE_CONTEXT_DO_NOT_USE", function() {
    return 0, _menuContext.SELECTION_STYLE_CONTEXT_DO_NOT_USE;
});
parcelHelpers.export(exports, "HeadingItem", function() {
    return 0, _headingItemDefault.default;
});
parcelHelpers.export(exports, "SkeletonHeadingItem", function() {
    return 0, _skeletonHeadingItemDefault.default;
});
parcelHelpers.export(exports, "Section", function() {
    return 0, _sectionDefault.default;
});
parcelHelpers.export(exports, "MenuGroup", function() {
    return 0, _menuGroupDefault.default;
});
parcelHelpers.export(exports, "PopupMenuGroup", function() {
    return 0, _popupMenuGroupDefault.default;
});
var _buttonItem = require("./menu-item/button-item");
var _buttonItemDefault = parcelHelpers.interopDefault(_buttonItem);
var _linkItem = require("./menu-item/link-item");
var _linkItemDefault = parcelHelpers.interopDefault(_linkItem);
var _customItem = require("./menu-item/custom-item");
var _customItemDefault = parcelHelpers.interopDefault(_customItem);
var _skeletonItem = require("./menu-item/skeleton-item");
var _skeletonItemDefault = parcelHelpers.interopDefault(_skeletonItem);
var _menuContext = require("./internal/components/menu-context");
var _headingItem = require("./menu-item/heading-item");
var _headingItemDefault = parcelHelpers.interopDefault(_headingItem);
var _skeletonHeadingItem = require("./menu-item/skeleton-heading-item");
var _skeletonHeadingItemDefault = parcelHelpers.interopDefault(_skeletonHeadingItem);
var _section = require("./menu-section/section");
var _sectionDefault = parcelHelpers.interopDefault(_section);
var _menuGroup = require("./menu-section/menu-group");
var _menuGroupDefault = parcelHelpers.interopDefault(_menuGroup);
var _popupMenuGroup = require("./menu-section/popup-menu-group");
var _popupMenuGroupDefault = parcelHelpers.interopDefault(_popupMenuGroup);

},{"./menu-item/button-item":false,"./menu-item/link-item":"3Zkbe","./menu-item/custom-item":false,"./menu-item/skeleton-item":false,"./internal/components/menu-context":false,"./menu-item/heading-item":"ddDui","./menu-item/skeleton-heading-item":false,"./menu-section/section":"e0SFH","./menu-section/menu-group":"e3SBq","./menu-section/popup-menu-group":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6Dsx3":[function(require,module,exports,__globalThis) {
/* button-item.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _interactionContext = require("@atlaskit/interaction-context");
var _interactionContextDefault = parcelHelpers.interopDefault(_interactionContext);
var _menuItemPrimitive = require("../internal/components/menu-item-primitive");
var _menuItemPrimitiveDefault = parcelHelpers.interopDefault(_menuItemPrimitive);
/**
 * __Button item__
 *
 * A button item is used to populate a menu with items that are buttons.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/button-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var ButtonItem = /*#__PURE__*/ (0, _react.memo)(/*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    var children = props.children, description = props.description, iconAfter = props.iconAfter, iconBefore = props.iconBefore, _props_isDisabled = props.isDisabled, isDisabled = _props_isDisabled === void 0 ? false : _props_isDisabled, _props_isSelected = props.isSelected, isSelected = _props_isSelected === void 0 ? false : _props_isSelected, onClick = props.onClick, testId = props.testId, onMouseDown = props.onMouseDown, shouldTitleWrap = props.shouldTitleWrap, shouldDescriptionWrap = props.shouldDescriptionWrap, UNSAFE_className = props.className, interactionName = props.interactionName, rest = (0, _objectWithoutProperties._)(props, [
        "children",
        "description",
        "iconAfter",
        "iconBefore",
        "isDisabled",
        "isSelected",
        "onClick",
        "testId",
        "onMouseDown",
        "shouldTitleWrap",
        "shouldDescriptionWrap",
        "className",
        "interactionName"
    ]);
    var onMouseDownHandler = onMouseDown;
    var interactionContext = (0, _react.useContext)((0, _interactionContextDefault.default));
    var handleClick = (0, _react.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 ? void 0 : interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemPrimitiveDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className
    }, rest), {
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isDisabled: isDisabled,
        isSelected: isSelected,
        isTitleHeading: false,
        description: description,
        title: children,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        testId: testId && "".concat(testId, "--primitive"),
        children: function(param) {
            var children = param.children, className = param.className;
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", (0, _objectSpreadProps._)((0, _objectSpread._)({
                "data-testid": testId,
                // This is intentionally placed before the `...rest` spread to prevent overriding existing usages of `aria-current`,
                // which are already being passed to the button element.
                "aria-current": isSelected ? 'true' : undefined
            }, rest), {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                ref: ref,
                disabled: isDisabled,
                onClick: handleClick,
                onMouseDown: onMouseDownHandler,
                type: "button",
                children: children
            }));
        }
    }));
}));
exports.default = ButtonItem;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react/jsx-runtime":"bGvcw","react":"ltHCL","@atlaskit/interaction-context":"4Lyu9","../internal/components/menu-item-primitive":"9gji6","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9gji6":[function(require,module,exports,__globalThis) {
/* menu-item-primitive.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _compiled = require("@atlaskit/primitives/compiled");
var _menuContext = require("./menu-context");
var _selectionStyleContextDoNotUse = require("./selection-style-context-do-not-use");
var renderTitle = function(Component, props) {
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, (0, _objectSpread._)({}, props)));
};
var styles = {
    root: "_19itidpf _12ji1r31 _1qu2glyw _12y3idpf _4bfu1r31 _1hmsglyw _ajmmnqa1 _kqswh2mm _1e0c1txw _vchhusvi _1bsb1osq _1tke1ylp _1pfhze3t _12l2ze3t _6rthze3t _ahbqze3t _4cvr1h6o _uiztglyw _80omtlke _ymio1r31 _ypr0glyw _zcxs1o36 _nt751v1w _mizu1v1w _1bg41gjf _1ah31gjf _49pcnqa1 _ra3xnqa1 _1hvwdkaa _128mdkaa _9oik1r31 _1bnxglyw _jf4cnqa1 _1cvmnqa1 _4davt94y",
    beforeAfterElement: "_1e0c1txw _1ul91tcg _1tke1tcg _4cvr1h6o _1bah1h6o _1o9zidpf",
    content: "_12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _1bah1h6o _16jlkb7n _y3gn1e5h",
    truncate: "_1reo15vq _18m915vq _1e0c1ule _1bto1l2s _o5721q9c",
    title: "_11c8fhey",
    wordBreak: "_1nmz1hna",
    description: "_11c8wadc _syaz1rpy",
    disabledDescription: "_syaz1gmx",
    unselected: "_bfhksm61 _syaz1r31 _10531r31 _irr31dpa _30l31r31 _1di61dpa _9h8h1r31",
    disabled: "_80om13gf _bfhksm61 _syaz1gmx _irr3sm61 _30l31gmx _1di6sm61 _9h8h1gmx",
    selectedBorder: "_1mp4yh40 _1cs8stnw _1rusq98m _1kt9b3bt _1fkrze3t _iajmze3t _z5wtze3t",
    selectedNotch: "_rfx3bx74 _1mp41y44 _1cs8stnw _1rusq98m _1kt9b3bt _1fkrutpp _iajmutpp _z5wtze3t",
    selected: "_bfhk15s3 _syaz6x5g _10536x5g _irr3ufnl _30l316jw _1di6nozp _9h8h6x5g",
    selectedOld: "_30l36x5g"
};
var spacingMapStyles = {
    cozy: "_1rjcu2gc _18zrpxbi",
    compact: "_1rjc1b66 _18zrutpp _1tkezwfg"
};
var gapMap = {
    compact: 'space.100',
    cozy: 'space.150'
};
/**
 * __Menu item primitive__
 *
 * Menu item primitive contains all the styles for menu items,
 * including support for selected, disabled, and interaction states.
 *
 * Using children as function prop you wire up this to your own host element.
 *
 * ```jsx
 * <MenuItemPrimitive>
 *   {({ children, ...props }) => <button {...props}>{children}</button>}
 * </MenuItemPrimitive>
 * ```
 */ var MenuItemPrimitive = function(param) {
    var children = param.children, title = param.title, description = param.description, iconAfter = param.iconAfter, iconBefore = param.iconBefore, UNSAFE_externalClassName = param.className, _param_shouldTitleWrap = param.shouldTitleWrap, shouldTitleWrap = _param_shouldTitleWrap === void 0 ? false : _param_shouldTitleWrap, _param_shouldDescriptionWrap = param.shouldDescriptionWrap, shouldDescriptionWrap = _param_shouldDescriptionWrap === void 0 ? false : _param_shouldDescriptionWrap, _param_isDisabled = param.isDisabled, isDisabled = _param_isDisabled === void 0 ? false : _param_isDisabled, _param_isSelected = param.isSelected, isSelected = _param_isSelected === void 0 ? false : _param_isSelected, _param_isTitleHeading = param.isTitleHeading, isTitleHeading = _param_isTitleHeading === void 0 ? false : _param_isTitleHeading, testId = param.testId;
    var spacing = (0, _react.useContext)((0, _menuContext.SpacingContext));
    var selectionStyle = (0, _react.useContext)((0, _selectionStyleContextDoNotUse.SELECTION_STYLE_CONTEXT_DO_NOT_USE));
    var UNSAFE_className = UNSAFE_externalClassName;
    return function() {
        return children({
            className: (0, _runtime.ax)([
                (0, _runtime.ax)([
                    styles.root,
                    spacingMapStyles[spacing],
                    !isDisabled && !isSelected && styles.unselected,
                    !isDisabled && isSelected && styles.selected,
                    !isDisabled && isSelected && styles.selectedOld,
                    !isDisabled && isSelected && selectionStyle === 'border' && styles.selectedBorder,
                    !isDisabled && isSelected && selectionStyle === 'notch' && styles.selectedNotch,
                    isDisabled && styles.disabled
                ]),
                UNSAFE_className
            ]),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _compiled.Inline), {
                as: "span",
                spread: "space-between",
                alignBlock: "center",
                space: gapMap[spacing],
                grow: "fill",
                testId: testId && "".concat(testId, "--container"),
                children: [
                    iconBefore && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        "data-item-elem-before": true,
                        "data-testid": testId && "".concat(testId, "--icon-before"),
                        className: (0, _runtime.ax)([
                            styles.beforeAfterElement
                        ]),
                        children: iconBefore
                    }),
                    title && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: (0, _runtime.ax)([
                            styles.content
                        ]),
                        children: [
                            renderTitle(isTitleHeading ? 'h2' : 'span', {
                                children: title,
                                className: (0, _runtime.ax)([
                                    styles.title,
                                    shouldTitleWrap ? styles.wordBreak : styles.truncate
                                ]),
                                'data-item-title': true
                            }),
                            description && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                "data-item-description": true,
                                className: (0, _runtime.ax)([
                                    styles.description,
                                    isDisabled && styles.disabledDescription,
                                    shouldDescriptionWrap && styles.wordBreak,
                                    !shouldDescriptionWrap && styles.truncate
                                ]),
                                children: description
                            })
                        ]
                    }),
                    iconAfter && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        "data-item-elem-after": true,
                        "data-testid": testId && "".concat(testId, "--icon-after"),
                        className: (0, _runtime.ax)([
                            styles.beforeAfterElement
                        ]),
                        children: iconAfter
                    })
                ]
            })
        });
    }();
};
exports.default = MenuItemPrimitive;

},{"@swc/helpers/_/_object_spread":"9gdrV","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/primitives/compiled":"jhQE8","./menu-context":"aJY8A","./selection-style-context-do-not-use":"02j6i","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aJY8A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SELECTION_STYLE_CONTEXT_DO_NOT_USE", function() {
    return 0, _selectionStyleContextDoNotUse.SELECTION_STYLE_CONTEXT_DO_NOT_USE;
});
parcelHelpers.export(exports, "SpacingContext", function() {
    return SpacingContext;
});
var _react = require("react");
var _selectionStyleContextDoNotUse = require("./selection-style-context-do-not-use");
var SpacingContext = /*#__PURE__*/ (0, _react.createContext)('cozy');

},{"react":"ltHCL","./selection-style-context-do-not-use":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"02j6i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SELECTION_STYLE_CONTEXT_DO_NOT_USE", function() {
    return SELECTION_STYLE_CONTEXT_DO_NOT_USE;
});
var _react = require("react");
var SELECTION_STYLE_CONTEXT_DO_NOT_USE = /*#__PURE__*/ (0, _react.createContext)('border');

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3Zkbe":[function(require,module,exports,__globalThis) {
/* link-item.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _appProvider = require("@atlaskit/app-provider");
var _interactionContext = require("@atlaskit/interaction-context");
var _interactionContextDefault = parcelHelpers.interopDefault(_interactionContext);
var _menuItemPrimitive = require("../internal/components/menu-item-primitive");
var _menuItemPrimitiveDefault = parcelHelpers.interopDefault(_menuItemPrimitive);
var IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
var preventEvent = function(e) {
    e.preventDefault();
};
/**
 * __Link item__
 *
 * A link item is used to populate a menu with items that are links.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/link-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var LinkItem = /*#__PURE__*/ (0, _react.memo)(/*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    var children = props.children, href = props.href, description = props.description, iconAfter = props.iconAfter, iconBefore = props.iconBefore, _props_isDisabled = props.isDisabled, isDisabled = _props_isDisabled === void 0 ? false : _props_isDisabled, _props_isSelected = props.isSelected, isSelected = _props_isSelected === void 0 ? false : _props_isSelected, onClick = props.onClick, testId = props.testId, onMouseDown = props.onMouseDown, shouldTitleWrap = props.shouldTitleWrap, shouldDescriptionWrap = props.shouldDescriptionWrap, UNSAFE_className = props.className, UNSAFE_shouldDisableRouterLink = props.UNSAFE_shouldDisableRouterLink, UNSAFE_isDraggable = props.UNSAFE_isDraggable, interactionName = props.interactionName, rest = (0, _objectWithoutProperties._)(props, [
        "children",
        "href",
        "description",
        "iconAfter",
        "iconBefore",
        "isDisabled",
        "isSelected",
        "onClick",
        "testId",
        "onMouseDown",
        "shouldTitleWrap",
        "shouldDescriptionWrap",
        "className",
        "UNSAFE_shouldDisableRouterLink",
        "UNSAFE_isDraggable",
        "interactionName"
    ]);
    var onMouseDownHandler = onMouseDown;
    var RouterLink = (0, _appProvider.useRouterLink)();
    var interactionContext = (0, _react.useContext)((0, _interactionContextDefault.default));
    var handleClick = (0, _react.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 ? void 0 : interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    var isExternal = typeof href === 'string' && IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === 'string' && IS_NON_HTTP_BASED.test(href);
    var isEmptyHref = href == null || href === '';
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.)
   * - it doesn't have an empty href (e.g. href="" or href={undefined})
   */ var isRouterLink = !UNSAFE_shouldDisableRouterLink && RouterLink && !isExternal && !isNonHttpBased && !isEmptyHref;
    var Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemPrimitiveDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, rest), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isTitleHeading: false,
        description: description,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        title: children,
        testId: testId && "".concat(testId, "--primitive"),
        children: function(param) {
            var children = param.children, className = param.className;
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({
                "data-testid": testId,
                "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
                "data-vc": "link-item"
            }, rest), {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                // @ts-expect-error
                href: isDisabled ? undefined : href
            }), UNSAFE_isDraggable ? {} : {
                draggable: false,
                onDragStart: preventEvent
            }), {
                onMouseDown: isDisabled ? preventEvent : onMouseDownHandler,
                onClick: isDisabled ? preventEvent : handleClick,
                "aria-current": isSelected ? 'page' : undefined,
                "aria-disabled": isDisabled,
                ref: ref,
                children: children
            }));
        }
    }));
}));
exports.default = LinkItem;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react/jsx-runtime":"bGvcw","react":"ltHCL","@atlaskit/app-provider":"cnK0e","@atlaskit/interaction-context":"4Lyu9","../internal/components/menu-item-primitive":"9gji6","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"84i1Q":[function(require,module,exports,__globalThis) {
/* custom-item.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _interactionContext = require("@atlaskit/interaction-context");
var _interactionContextDefault = parcelHelpers.interopDefault(_interactionContext);
var _menuItemPrimitive = require("../internal/components/menu-item-primitive");
var _menuItemPrimitiveDefault = parcelHelpers.interopDefault(_menuItemPrimitive);
var preventEvent = function(e) {
    e.preventDefault();
};
/**
 * __Custom item__
 *
 * A custom item is used to populate a menu with items that can be any element.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/custom-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var CustomItem = /*#__PURE__*/ (0, _react.memo)(/*#__PURE__*/ (0, _react.forwardRef)(function(_param, ref) {
    var Component = _param.component, _param_isDisabled = _param.isDisabled, isDisabled = _param_isDisabled === void 0 ? false : _param_isDisabled, _param_isSelected = _param.isSelected, isSelected = _param_isSelected === void 0 ? false : _param_isSelected, _param_isTitleHeading = _param.isTitleHeading, isTitleHeading = _param_isTitleHeading === void 0 ? false : _param_isTitleHeading, onClick = _param.onClick, testId = _param.testId, children = _param.children, description = _param.description, iconAfter = _param.iconAfter, iconBefore = _param.iconBefore, onMouseDown = _param.onMouseDown, shouldTitleWrap = _param.shouldTitleWrap, shouldDescriptionWrap = _param.shouldDescriptionWrap, UNSAFE_className = _param.className, UNSAFE_isDraggable = _param.UNSAFE_isDraggable, interactionName = _param.interactionName, rest = (0, _objectWithoutProperties._)(_param, [
        "component",
        "isDisabled",
        "isSelected",
        "isTitleHeading",
        "onClick",
        "testId",
        "children",
        "description",
        "iconAfter",
        "iconBefore",
        "onMouseDown",
        "shouldTitleWrap",
        "shouldDescriptionWrap",
        "className",
        "UNSAFE_isDraggable",
        "interactionName"
    ]);
    var onMouseDownHandler = onMouseDown;
    var interactionContext = (0, _react.useContext)((0, _interactionContextDefault.default));
    var handleClick = (0, _react.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 ? void 0 : interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!Component) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemPrimitiveDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className
    }, rest), {
        description: description,
        iconAfter: iconAfter,
        title: children,
        iconBefore: iconBefore,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isTitleHeading: isTitleHeading,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        testId: testId && "".concat(testId, "--primitive"),
        children: function(param) {
            var children = param.children, className = param.className;
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({
                "data-testid": testId
            }, rest), {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                ref: ref
            }), UNSAFE_isDraggable ? {} : {
                draggable: false,
                onDragStart: preventEvent
            }), {
                onMouseDown: isDisabled ? preventEvent : onMouseDownHandler,
                onClick: isDisabled ? preventEvent : handleClick,
                tabIndex: isDisabled ? -1 : undefined,
                "aria-disabled": isDisabled,
                children: children
            }));
        }
    }));
}));
exports.default = CustomItem;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react/jsx-runtime":"bGvcw","react":"ltHCL","@atlaskit/interaction-context":"4Lyu9","../internal/components/menu-item-primitive":"9gji6","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ddDui":[function(require,module,exports,__globalThis) {
/* heading-item.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var headingStyles = null;
/**
 * __Heading item__
 *
 * A heading item is used to describe sibling menu items.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var HeadingItem = /*#__PURE__*/ (0, _react.memo)(function(_param) {
    var children = _param.children, testId = _param.testId, _param_headingLevel = _param.headingLevel, headingLevel = _param_headingLevel === void 0 ? 2 : _param_headingLevel, id = _param.id, // Although this isn't defined on props it is available because we've used
    // Spread props below and on the jsx element. To forcibly block usage I've
    // picked it out and supressed the expected type error.
    // @ts-expect-error
    UNSAFE_className = _param.className, rest = (0, _objectWithoutProperties._)(_param, [
        "children",
        "testId",
        "headingLevel",
        "id",
        "className"
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({
        role: "heading",
        "aria-level": headingLevel,
        "data-testid": testId,
        "data-ds--menu--heading-item": true,
        id: id,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, _runtime.ax)([
            "_11c8i4vh _1rjcze3t _18zrpxbi _syazazsu",
            UNSAFE_className
        ])
    }, rest), {
        children: children
    }));
});
exports.default = HeadingItem;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"e0SFH":[function(require,module,exports,__globalThis) {
/* section.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _headingItem = require("../menu-item/heading-item");
var _headingItemDefault = parcelHelpers.interopDefault(_headingItem);
var itemHeadingTopMargin = 20;
var itemHeadingBottomMargin = 6;
// Skeleton content is slightly shorter than the real content.
// Because of that we slightly increase the top margin to offset this so the
// containing size both real and skeleton always equal approx 30px.
var itemHeadingContentHeight = 16; // Originally headingSizes.h100.lineHeight from '@atlaskit/theme/typography'
var skeletonHeadingHeight = 8;
var skeletonHeadingMarginOffset = 3;
var skeletonHeadingTopMargin = itemHeadingTopMargin + (itemHeadingContentHeight - skeletonHeadingHeight) - skeletonHeadingMarginOffset;
var sectionPaddingTopBottom = 6;
var styles = {
    root: "_1ywu1ule _cfu11ule _1qdgi2wt _kfgti2wt _aetrb3bt _1kt9b3bt _1p3hi2wt _1l6bgktf _osbldlk8 _auo4rdoj _hp2110yn _1mfv8jkm _1bg41n1a",
    scrollable: "_1reo1wug _18m91wug _1o9zkb7n",
    unscrollable: "_1o9zidpf",
    thinSeparator: "_mqm2lllh",
    noSeparator: "_n7cnyjp0",
    sideNavSectionHeading: "_18zru2gc"
};
/**
 * __Section__
 *
 * A section includes related actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/section)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var Section = /*#__PURE__*/ (0, _react.forwardRef)(function(_param, ref) {
    var children = _param.children, title = _param.title, titleId = _param.titleId, testId = _param.testId, isScrollable = _param.isScrollable, hasSeparator = _param.hasSeparator, id = _param.id, _param_isList = _param.isList, isList = _param_isList === void 0 ? false : _param_isList, _param_isSideNavSection = _param.isSideNavSection, isSideNavSection = _param_isSideNavSection === void 0 ? false : _param_isSideNavSection, label = _param.label, // Although this isn't defined on props it is available because we've used
    // Spread props below and on the jsx element. To forcibly block usage I've
    // picked it out and supressed the expected type error.
    // @ts-expect-error
    UNSAFE_className = _param.className, rest = (0, _objectWithoutProperties._)(_param, [
        "children",
        "title",
        "titleId",
        "testId",
        "isScrollable",
        "hasSeparator",
        "id",
        "isList",
        "isSideNavSection",
        "label",
        "className"
    ]);
    var content = isList ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            padding: 0
        },
        children: (0, _react.Children).map((0, _react.Children).toArray(children), function(child, index) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: {
                    listStyleType: 'none',
                    margin: 0,
                    padding: 0
                },
                children: child
            }, index);
        })
    }) : children;
    var childrenMarkup = title !== undefined ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headingItemDefault.default), {
                testId: testId && "".concat(testId, "--heading"),
                "aria-hidden": true,
                // @ts-expect-error
                // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
                className: (0, _runtime.ax)([
                    isSideNavSection && styles.sideNavSectionHeading
                ]),
                children: title
            }),
            content
        ]
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Fragment), {
        children: content
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, rest), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, _runtime.ax)([
            styles.root,
            isScrollable ? styles.scrollable : styles.unscrollable,
            hasSeparator ? styles.thinSeparator : styles.noSeparator,
            UNSAFE_className
        ]),
        id: id,
        // NOTE: Firefox allows elements that have "overflow: auto" to gain focus (as if it had tab-index="0")
        // We have made a deliberate choice to leave this behaviour as is.
        "aria-label": title || label,
        "aria-labelledby": titleId,
        "data-testid": testId,
        role: "group",
        "data-section": true,
        ref: ref,
        children: childrenMarkup
    }));
});
exports.default = Section;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","../menu-item/heading-item":"ddDui","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"e3SBq":[function(require,module,exports,__globalThis) {
/* menu-group.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _menuContext = require("../internal/components/menu-context");
var _selectionStyleContextDoNotUse = require("../internal/components/selection-style-context-do-not-use");
var baseStyles = null;
/**
 * __Menu group__
 *
 * A menu group includes all the actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/menu-group)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var MenuGroup = function(_param) {
    var isLoading = _param.isLoading, maxWidth = _param.maxWidth, minWidth = _param.minWidth, minHeight = _param.minHeight, maxHeight = _param.maxHeight, testId = _param.testId, role = _param.role, _param_spacing = _param.spacing, spacing = _param_spacing === void 0 ? 'cozy' : _param_spacing, menuLabel = _param.menuLabel, // Although this isn't defined on props it is available because we've used
    // Spread props below and on the jsx element. To forcibly block usage I've
    // picked it out and supressed the expected type error.
    // @ts-expect-error
    UNSAFE_className = _param.className, rest = (0, _objectWithoutProperties._)(_param, [
        "isLoading",
        "maxWidth",
        "minWidth",
        "minHeight",
        "maxHeight",
        "testId",
        "role",
        "spacing",
        "menuLabel",
        "className"
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuContext.SpacingContext).Provider, {
        value: spacing,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectionStyleContextDoNotUse.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
            value: "border",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpread._)({
                "aria-busy": isLoading,
                style: {
                    minWidth: minWidth,
                    maxWidth: maxWidth,
                    minHeight: minHeight,
                    maxHeight: maxHeight
                },
                "data-testid": testId,
                role: role,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, _runtime.ax)([
                    "_1reo1wug _18m91wug _1e0c1txw _kqswpfqs _2lx21bp4",
                    UNSAFE_className
                ]),
                "aria-label": menuLabel
            }, rest))
        })
    });
};
exports.default = MenuGroup;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_without_properties":"6HqIM","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","../internal/components/menu-context":"aJY8A","../internal/components/selection-style-context-do-not-use":"02j6i","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gaJ0A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SELECTED_SITE_STORAGE_KEY", function() {
    return SELECTED_SITE_STORAGE_KEY;
});
parcelHelpers.export(exports, "selectedSiteCloudIdAtom", function() {
    return selectedSiteCloudIdAtom;
});
// eslint-disable-next-line @typescript-eslint/consistent-type-imports -- Jotai RESET is a `unique symbol`; atom generics need `typeof RESET`, which requires a value binding
var _utils = require("jotai/utils");
var SELECTED_SITE_STORAGE_KEY = 'twg-microsite.selectedSite.v1';
var selectedSiteCloudIdAtom = (0, _utils.atomWithStorage)(SELECTED_SITE_STORAGE_KEY, null, (0, _utils.createJSONStorage)(function() {
    return localStorage;
}), {
    getOnInit: true
});

},{"jotai/utils":"bocLd","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bocLd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utils = require("jotai/vanilla/utils");
parcelHelpers.exportAll(_utils, exports);
var _utils1 = require("jotai/react/utils");
parcelHelpers.exportAll(_utils1, exports);

},{"jotai/vanilla/utils":"9Ps6a","jotai/react/utils":"gAqnx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9Ps6a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RESET", function() {
    return RESET;
});
parcelHelpers.export(exports, "atomFamily", function() {
    return atomFamily;
});
parcelHelpers.export(exports, "atomWithDefault", function() {
    return atomWithDefault;
});
parcelHelpers.export(exports, "atomWithLazy", function() {
    return atomWithLazy;
});
parcelHelpers.export(exports, "atomWithObservable", function() {
    return atomWithObservable;
});
parcelHelpers.export(exports, "atomWithReducer", function() {
    return atomWithReducer;
});
parcelHelpers.export(exports, "atomWithRefresh", function() {
    return atomWithRefresh;
});
parcelHelpers.export(exports, "atomWithReset", function() {
    return atomWithReset;
});
parcelHelpers.export(exports, "atomWithStorage", function() {
    return atomWithStorage;
});
parcelHelpers.export(exports, "createJSONStorage", function() {
    return createJSONStorage;
});
parcelHelpers.export(exports, "freezeAtom", function() {
    return freezeAtom;
});
parcelHelpers.export(exports, "freezeAtomCreator", function() {
    return freezeAtomCreator;
});
parcelHelpers.export(exports, "loadable", function() {
    return loadable;
});
parcelHelpers.export(exports, "selectAtom", function() {
    return selectAtom;
});
parcelHelpers.export(exports, "splitAtom", function() {
    return splitAtom;
});
parcelHelpers.export(exports, "unstable_withStorageValidator", function() {
    return withStorageValidator;
});
parcelHelpers.export(exports, "unwrap", function() {
    return unwrap;
});
var _instanceof = require("@swc/helpers/_/_instanceof");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var _vanilla = require("jotai/vanilla");
var $727eac459c311d54$import_meta = Object.assign(Object.create(null), {
    url: "file:///../node_modules/jotai/esm/vanilla/utils.mjs"
});
var RESET = Symbol(($727eac459c311d54$import_meta.env ? $727eac459c311d54$import_meta.env.MODE : void 0) !== "production" ? "RESET" : "");
function atomWithReset(initialValue) {
    var anAtom = (0, _vanilla.atom)(initialValue, function(get, set, update) {
        var nextValue = typeof update === "function" ? update(get(anAtom)) : update;
        set(anAtom, nextValue === RESET ? initialValue : nextValue);
    });
    return anAtom;
}
function atomWithReducer(initialValue, reducer) {
    return (0, _vanilla.atom)(initialValue, function(get, set, action) {
        set(this, reducer(get(this), action));
    });
}
function atomFamily(initializeAtom, areEqual) {
    var shouldRemove = null;
    var atoms = /* @__PURE__ */ new Map();
    var listeners = /* @__PURE__ */ new Set();
    var createAtom = function(param) {
        var item;
        if (areEqual === void 0) item = atoms.get(param);
        else {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = atoms[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, _slicedToArray._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                    if (areEqual(key, param)) {
                        item = value;
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        if (item !== void 0) {
            if (shouldRemove == null ? void 0 : shouldRemove(item[1], param)) createAtom.remove(param);
            else return item[0];
        }
        var newAtom = initializeAtom(param);
        atoms.set(param, [
            newAtom,
            Date.now()
        ]);
        notifyListeners("CREATE", param, newAtom);
        return newAtom;
    };
    var notifyListeners = function(type, param, atom) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = listeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var listener = _step.value;
                listener({
                    type: type,
                    param: param,
                    atom: atom
                });
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
    createAtom.unstable_listen = function(callback) {
        listeners.add(callback);
        return function() {
            listeners.delete(callback);
        };
    };
    createAtom.getParams = function() {
        return atoms.keys();
    };
    createAtom.remove = function(param) {
        if (areEqual === void 0) {
            if (!atoms.has(param)) return;
            var _atoms_get = (0, _slicedToArray._)(atoms.get(param), 1), atom = _atoms_get[0];
            atoms.delete(param);
            notifyListeners("REMOVE", param, atom);
        } else {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = atoms[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, _slicedToArray._)(_step.value, 2), key = _step_value[0], _step_value_ = (0, _slicedToArray._)(_step_value[1], 1), atom1 = _step_value_[0];
                    if (areEqual(key, param)) {
                        atoms.delete(key);
                        notifyListeners("REMOVE", key, atom1);
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    };
    createAtom.setShouldRemove = function(fn) {
        shouldRemove = fn;
        if (!shouldRemove) return;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = atoms[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, _slicedToArray._)(_step.value, 2), key = _step_value[0], _step_value_ = (0, _slicedToArray._)(_step_value[1], 2), atom = _step_value_[0], createdAt = _step_value_[1];
                if (shouldRemove(createdAt, key)) {
                    atoms.delete(key);
                    notifyListeners("REMOVE", key, atom);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
    return createAtom;
}
var getCached$2 = function(c, m, k) {
    return (m.has(k) ? m : m.set(k, c())).get(k);
};
var cache1$3 = /* @__PURE__ */ new WeakMap();
var memo3 = function(create, dep1, dep2, dep3) {
    var cache2 = getCached$2(function() {
        return /* @__PURE__ */ new WeakMap();
    }, cache1$3, dep1);
    var cache3 = getCached$2(function() {
        return /* @__PURE__ */ new WeakMap();
    }, cache2, dep2);
    return getCached$2(create, cache3, dep3);
};
function selectAtom(anAtom, selector) {
    var equalityFn = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Object.is;
    return memo3(function() {
        var EMPTY = Symbol();
        var selectValue = function(param) {
            var _param = (0, _slicedToArray._)(param, 2), value = _param[0], prevSlice = _param[1];
            if (prevSlice === EMPTY) return selector(value);
            var slice = selector(value, prevSlice);
            return equalityFn(prevSlice, slice) ? prevSlice : slice;
        };
        var derivedAtom = (0, _vanilla.atom)(function(get) {
            var prev = get(derivedAtom);
            var value = get(anAtom);
            return selectValue([
                value,
                prev
            ]);
        });
        derivedAtom.init = EMPTY;
        return derivedAtom;
    }, anAtom, selector, equalityFn);
}
var frozenAtoms = /* @__PURE__ */ new WeakSet();
var deepFreeze = function(value) {
    if ((typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) !== "object" || value === null) return value;
    Object.freeze(value);
    var propNames = Object.getOwnPropertyNames(value);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = propNames[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var name = _step.value;
            deepFreeze(value[name]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return value;
};
function freezeAtom(anAtom) {
    if (frozenAtoms.has(anAtom)) return anAtom;
    frozenAtoms.add(anAtom);
    var origRead = anAtom.read;
    anAtom.read = function(get, options) {
        return deepFreeze(origRead.call(this, get, options));
    };
    if ("write" in anAtom) {
        var origWrite = anAtom.write;
        anAtom.write = function(get, set) {
            for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
                args[_key - 2] = arguments[_key];
            }
            var _origWrite;
            return (_origWrite = origWrite).call.apply(_origWrite, [
                this,
                get,
                function() {
                    for(var _len = arguments.length, setArgs = new Array(_len), _key = 0; _key < _len; _key++){
                        setArgs[_key] = arguments[_key];
                    }
                    if (setArgs[0] === anAtom) setArgs[1] = deepFreeze(setArgs[1]);
                    return set.apply(void 0, (0, _toConsumableArray._)(setArgs));
                }
            ].concat((0, _toConsumableArray._)(args)));
        };
    }
    return anAtom;
}
function freezeAtomCreator(createAtom) {
    if (($727eac459c311d54$import_meta.env ? $727eac459c311d54$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] freezeAtomCreator is deprecated, define it on users end");
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return freezeAtom(createAtom.apply(void 0, (0, _toConsumableArray._)(args)));
    };
}
var getCached$1 = function(c, m, k) {
    return (m.has(k) ? m : m.set(k, c())).get(k);
};
var cache1$2 = /* @__PURE__ */ new WeakMap();
var memo2$1 = function(create, dep1, dep2) {
    var cache2 = getCached$1(function() {
        return /* @__PURE__ */ new WeakMap();
    }, cache1$2, dep1);
    return getCached$1(create, cache2, dep2);
};
var cacheKeyForEmptyKeyExtractor = {};
var isWritable = function(atom2) {
    return !!atom2.write;
};
var isFunction = function(x) {
    return typeof x === "function";
};
function splitAtom(arrAtom, keyExtractor) {
    return memo2$1(function() {
        var mappingCache = /* @__PURE__ */ new WeakMap();
        var getMapping = function(arr, prev) {
            var mapping = mappingCache.get(arr);
            if (mapping) return mapping;
            var prevMapping = prev && mappingCache.get(prev);
            var atomList = [];
            var keyList = [];
            arr.forEach(function(item, index) {
                var key = keyExtractor ? keyExtractor(item) : index;
                keyList[index] = key;
                var cachedAtom = prevMapping && prevMapping.atomList[prevMapping.keyList.indexOf(key)];
                if (cachedAtom) {
                    atomList[index] = cachedAtom;
                    return;
                }
                var read = function(get) {
                    var prev2 = get(mappingAtom);
                    var currArr = get(arrAtom);
                    var mapping2 = getMapping(currArr, prev2 == null ? void 0 : prev2.arr);
                    var index2 = mapping2.keyList.indexOf(key);
                    if (index2 < 0 || index2 >= currArr.length) {
                        var prevItem = arr[getMapping(arr).keyList.indexOf(key)];
                        if (prevItem) return prevItem;
                        throw new Error("splitAtom: index out of bounds for read");
                    }
                    return currArr[index2];
                };
                var write = function(get, set, update) {
                    var prev2 = get(mappingAtom);
                    var arr2 = get(arrAtom);
                    var mapping2 = getMapping(arr2, prev2 == null ? void 0 : prev2.arr);
                    var index2 = mapping2.keyList.indexOf(key);
                    if (index2 < 0 || index2 >= arr2.length) throw new Error("splitAtom: index out of bounds for write");
                    var nextItem = isFunction(update) ? update(arr2[index2]) : update;
                    if (!Object.is(arr2[index2], nextItem)) set(arrAtom, (0, _toConsumableArray._)(arr2.slice(0, index2)).concat([
                        nextItem
                    ], (0, _toConsumableArray._)(arr2.slice(index2 + 1))));
                };
                atomList[index] = isWritable(arrAtom) ? (0, _vanilla.atom)(read, write) : (0, _vanilla.atom)(read);
            });
            if (prevMapping && prevMapping.keyList.length === keyList.length && prevMapping.keyList.every(function(x, i) {
                return x === keyList[i];
            })) mapping = prevMapping;
            else mapping = {
                arr: arr,
                atomList: atomList,
                keyList: keyList
            };
            mappingCache.set(arr, mapping);
            return mapping;
        };
        var mappingAtom = (0, _vanilla.atom)(function(get) {
            var prev = get(mappingAtom);
            var arr = get(arrAtom);
            var mapping = getMapping(arr, prev == null ? void 0 : prev.arr);
            return mapping;
        });
        if (($727eac459c311d54$import_meta.env ? $727eac459c311d54$import_meta.env.MODE : void 0) !== "production") mappingAtom.debugPrivate = true;
        mappingAtom.init = void 0;
        var splittedAtom = isWritable(arrAtom) ? (0, _vanilla.atom)(function(get) {
            return get(mappingAtom).atomList;
        }, function(get, set, action) {
            switch(action.type){
                case "remove":
                    {
                        var index = get(splittedAtom).indexOf(action.atom);
                        if (index >= 0) {
                            var arr = get(arrAtom);
                            set(arrAtom, (0, _toConsumableArray._)(arr.slice(0, index)).concat((0, _toConsumableArray._)(arr.slice(index + 1))));
                        }
                        break;
                    }
                case "insert":
                    {
                        var index1 = action.before ? get(splittedAtom).indexOf(action.before) : get(splittedAtom).length;
                        if (index1 >= 0) {
                            var arr1 = get(arrAtom);
                            set(arrAtom, (0, _toConsumableArray._)(arr1.slice(0, index1)).concat([
                                action.value
                            ], (0, _toConsumableArray._)(arr1.slice(index1))));
                        }
                        break;
                    }
                case "move":
                    {
                        var index11 = get(splittedAtom).indexOf(action.atom);
                        var index2 = action.before ? get(splittedAtom).indexOf(action.before) : get(splittedAtom).length;
                        if (index11 >= 0 && index2 >= 0) {
                            var arr2 = get(arrAtom);
                            if (index11 < index2) set(arrAtom, (0, _toConsumableArray._)(arr2.slice(0, index11)).concat((0, _toConsumableArray._)(arr2.slice(index11 + 1, index2)), [
                                arr2[index11]
                            ], (0, _toConsumableArray._)(arr2.slice(index2))));
                            else set(arrAtom, (0, _toConsumableArray._)(arr2.slice(0, index2)).concat([
                                arr2[index11]
                            ], (0, _toConsumableArray._)(arr2.slice(index2, index11)), (0, _toConsumableArray._)(arr2.slice(index11 + 1))));
                        }
                        break;
                    }
            }
        }) : (0, _vanilla.atom)(function(get) {
            return get(mappingAtom).atomList;
        });
        return splittedAtom;
    }, arrAtom, keyExtractor || cacheKeyForEmptyKeyExtractor);
}
function atomWithDefault(getDefault) {
    var EMPTY = Symbol();
    var overwrittenAtom = (0, _vanilla.atom)(EMPTY);
    if (($727eac459c311d54$import_meta.env ? $727eac459c311d54$import_meta.env.MODE : void 0) !== "production") overwrittenAtom.debugPrivate = true;
    var anAtom = (0, _vanilla.atom)(function(get, options) {
        var overwritten = get(overwrittenAtom);
        if (overwritten !== EMPTY) return overwritten;
        return getDefault(get, options);
    }, function(get, set, update) {
        var newValue = typeof update === "function" ? update(get(anAtom)) : update;
        set(overwrittenAtom, newValue === RESET ? EMPTY : newValue);
    });
    return anAtom;
}
var isPromiseLike$3 = function(x) {
    return typeof (x == null ? void 0 : x.then) === "function";
};
function withStorageValidator(validator) {
    return function(unknownStorage) {
        var storage = (0, _objectSpreadProps._)((0, _objectSpread._)({}, unknownStorage), {
            getItem: function(key, initialValue) {
                var validate = function(value2) {
                    if (!validator(value2)) return initialValue;
                    return value2;
                };
                var value = unknownStorage.getItem(key, initialValue);
                if (isPromiseLike$3(value)) return value.then(validate);
                return validate(value);
            }
        });
        return storage;
    };
}
function createJSONStorage() {
    var getStringStorage = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {
        try {
            return window.localStorage;
        } catch (e) {
            if (($727eac459c311d54$import_meta.env ? $727eac459c311d54$import_meta.env.MODE : void 0) !== "production") {
                if (typeof window !== "undefined") console.warn(e);
            }
            return void 0;
        }
    }, options = arguments.length > 1 ? arguments[1] : void 0;
    var _a;
    var lastStr;
    var lastValue;
    var storage = {
        getItem: function(key, initialValue) {
            var _a2, _b;
            var parse = function(str2) {
                str2 = str2 || "";
                if (lastStr !== str2) {
                    try {
                        lastValue = JSON.parse(str2, options == null ? void 0 : options.reviver);
                    } catch (e) {
                        return initialValue;
                    }
                    lastStr = str2;
                }
                return lastValue;
            };
            var str = (_b = (_a2 = getStringStorage()) == null ? void 0 : _a2.getItem(key)) != null ? _b : null;
            if (isPromiseLike$3(str)) return str.then(parse);
            return parse(str);
        },
        setItem: function(key, newValue) {
            var _a2;
            return (_a2 = getStringStorage()) == null ? void 0 : _a2.setItem(key, JSON.stringify(newValue, options == null ? void 0 : options.replacer));
        },
        removeItem: function(key) {
            var _a2;
            return (_a2 = getStringStorage()) == null ? void 0 : _a2.removeItem(key);
        }
    };
    var createHandleSubscribe = function(subscriber2) {
        return function(key, callback, initialValue) {
            return subscriber2(key, function(v) {
                var newValue;
                try {
                    newValue = JSON.parse(v || "");
                } catch (e) {
                    newValue = initialValue;
                }
                callback(newValue);
            });
        };
    };
    var subscriber;
    try {
        subscriber = (_a = getStringStorage()) == null ? void 0 : _a.subscribe;
    } catch (e) {}
    if (!subscriber && typeof window !== "undefined" && typeof window.addEventListener === "function" && window.Storage) subscriber = function(key, callback) {
        if (!(0, _instanceof._)(getStringStorage(), window.Storage)) return function() {};
        var storageEventCallback = function(e) {
            if (e.storageArea === getStringStorage() && e.key === key) callback(e.newValue);
        };
        window.addEventListener("storage", storageEventCallback);
        return function() {
            window.removeEventListener("storage", storageEventCallback);
        };
    };
    if (subscriber) storage.subscribe = createHandleSubscribe(subscriber);
    return storage;
}
var defaultStorage = createJSONStorage();
function atomWithStorage(key, initialValue) {
    var storage = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : defaultStorage, options = arguments.length > 3 ? arguments[3] : void 0;
    var getOnInit = options == null ? void 0 : options.getOnInit;
    var baseAtom = (0, _vanilla.atom)(getOnInit ? storage.getItem(key, initialValue) : initialValue);
    if (($727eac459c311d54$import_meta.env ? $727eac459c311d54$import_meta.env.MODE : void 0) !== "production") baseAtom.debugPrivate = true;
    baseAtom.onMount = function(setAtom) {
        setAtom(storage.getItem(key, initialValue));
        var unsub;
        if (storage.subscribe) unsub = storage.subscribe(key, setAtom, initialValue);
        return unsub;
    };
    var anAtom = (0, _vanilla.atom)(function(get) {
        return get(baseAtom);
    }, function(get, set, update) {
        var nextValue = typeof update === "function" ? update(get(baseAtom)) : update;
        if (nextValue === RESET) {
            set(baseAtom, initialValue);
            return storage.removeItem(key);
        }
        if (isPromiseLike$3(nextValue)) return nextValue.then(function(resolvedValue) {
            set(baseAtom, resolvedValue);
            return storage.setItem(key, resolvedValue);
        });
        set(baseAtom, nextValue);
        return storage.setItem(key, nextValue);
    });
    return anAtom;
}
var isPromiseLike$2 = function(x) {
    return typeof (x == null ? void 0 : x.then) === "function";
};
function atomWithObservable(getObservable, options) {
    var returnResultData = function(result) {
        if ("e" in result) throw result.e;
        return result.d;
    };
    var observableResultAtom = (0, _vanilla.atom)(function(get) {
        var _a;
        var observable = getObservable(get);
        var itself = (_a = observable[Symbol.observable]) == null ? void 0 : _a.call(observable);
        if (itself) observable = itself;
        var resolve;
        var makePending = function() {
            return new Promise(function(r) {
                resolve = r;
            });
        };
        var initialResult = options && "initialValue" in options ? {
            d: typeof options.initialValue === "function" ? options.initialValue() : options.initialValue
        } : makePending();
        var setResult;
        var lastResult;
        var listener = function(result) {
            lastResult = result;
            resolve == null || resolve(result);
            setResult == null || setResult(result);
        };
        var subscription;
        var timer;
        var isNotMounted = function() {
            return !setResult;
        };
        var unsubscribe = function() {
            if (subscription) {
                subscription.unsubscribe();
                subscription = void 0;
            }
        };
        var start = function() {
            if (subscription) {
                clearTimeout(timer);
                subscription.unsubscribe();
            }
            subscription = observable.subscribe({
                next: function(d) {
                    return listener({
                        d: d
                    });
                },
                error: function(e) {
                    return listener({
                        e: e
                    });
                },
                complete: function() {}
            });
            if (isNotMounted() && (options == null ? void 0 : options.unstable_timeout)) timer = setTimeout(unsubscribe, options.unstable_timeout);
        };
        start();
        var resultAtom = (0, _vanilla.atom)(lastResult || initialResult);
        if (($727eac459c311d54$import_meta.env ? $727eac459c311d54$import_meta.env.MODE : void 0) !== "production") resultAtom.debugPrivate = true;
        resultAtom.onMount = function(update) {
            setResult = update;
            if (lastResult) update(lastResult);
            if (subscription) clearTimeout(timer);
            else start();
            return function() {
                setResult = void 0;
                if (options == null ? void 0 : options.unstable_timeout) timer = setTimeout(unsubscribe, options.unstable_timeout);
                else unsubscribe();
            };
        };
        return [
            resultAtom,
            observable,
            makePending,
            start,
            isNotMounted
        ];
    });
    if (($727eac459c311d54$import_meta.env ? $727eac459c311d54$import_meta.env.MODE : void 0) !== "production") observableResultAtom.debugPrivate = true;
    var observableAtom = (0, _vanilla.atom)(function(get) {
        var _get = (0, _slicedToArray._)(get(observableResultAtom), 1), resultAtom = _get[0];
        var result = get(resultAtom);
        if (isPromiseLike$2(result)) return result.then(returnResultData);
        return returnResultData(result);
    }, function(get, set, data) {
        var _get = (0, _slicedToArray._)(get(observableResultAtom), 5), resultAtom = _get[0], observable = _get[1], makePending = _get[2], start = _get[3], isNotMounted = _get[4];
        if ("next" in observable) {
            if (isNotMounted()) {
                set(resultAtom, makePending());
                start();
            }
            observable.next(data);
        } else throw new Error("observable is not subject");
    });
    return observableAtom;
}
var cache1$1 = /* @__PURE__ */ new WeakMap();
var memo1 = function(create, dep1) {
    return (cache1$1.has(dep1) ? cache1$1 : cache1$1.set(dep1, create())).get(dep1);
};
var isPromiseLike$1 = function(p) {
    return typeof (p == null ? void 0 : p.then) === "function";
};
var LOADING = {
    state: "loading"
};
function loadable(anAtom) {
    return memo1(function() {
        var loadableCache = /* @__PURE__ */ new WeakMap();
        var refreshAtom = (0, _vanilla.atom)(0);
        if (($727eac459c311d54$import_meta.env ? $727eac459c311d54$import_meta.env.MODE : void 0) !== "production") refreshAtom.debugPrivate = true;
        var derivedAtom = (0, _vanilla.atom)(function(get, param) {
            var setSelf = param.setSelf;
            get(refreshAtom);
            var value;
            try {
                value = get(anAtom);
            } catch (error) {
                return {
                    state: "hasError",
                    error: error
                };
            }
            if (!isPromiseLike$1(value)) return {
                state: "hasData",
                data: value
            };
            var promise = value;
            var cached1 = loadableCache.get(promise);
            if (cached1) return cached1;
            promise.then(function(data) {
                loadableCache.set(promise, {
                    state: "hasData",
                    data: data
                });
                setSelf();
            }, function(error) {
                loadableCache.set(promise, {
                    state: "hasError",
                    error: error
                });
                setSelf();
            });
            var cached2 = loadableCache.get(promise);
            if (cached2) return cached2;
            loadableCache.set(promise, LOADING);
            return LOADING;
        }, function(_get, set) {
            set(refreshAtom, function(c) {
                return c + 1;
            });
        });
        if (($727eac459c311d54$import_meta.env ? $727eac459c311d54$import_meta.env.MODE : void 0) !== "production") derivedAtom.debugPrivate = true;
        return (0, _vanilla.atom)(function(get) {
            return get(derivedAtom);
        });
    }, anAtom);
}
var getCached = function(c, m, k) {
    return (m.has(k) ? m : m.set(k, c())).get(k);
};
var cache1 = /* @__PURE__ */ new WeakMap();
var memo2 = function(create, dep1, dep2) {
    var cache2 = getCached(function() {
        return /* @__PURE__ */ new WeakMap();
    }, cache1, dep1);
    return getCached(create, cache2, dep2);
};
var isPromiseLike = function(p) {
    return typeof (p == null ? void 0 : p.then) === "function";
};
var defaultFallback = function() {
    return void 0;
};
function unwrap(anAtom) {
    var fallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultFallback;
    return memo2(function() {
        var promiseErrorCache = /* @__PURE__ */ new WeakMap();
        var promiseResultCache = /* @__PURE__ */ new WeakMap();
        var refreshAtom = (0, _vanilla.atom)(0);
        if (($727eac459c311d54$import_meta.env ? $727eac459c311d54$import_meta.env.MODE : void 0) !== "production") refreshAtom.debugPrivate = true;
        var promiseAndValueAtom = (0, _vanilla.atom)(function(get, param) {
            var setSelf = param.setSelf;
            get(refreshAtom);
            var prev = get(promiseAndValueAtom);
            var promise = get(anAtom);
            if (!isPromiseLike(promise)) return {
                v: promise
            };
            if (promise !== (prev == null ? void 0 : prev.p)) promise.then(function(v) {
                promiseResultCache.set(promise, v);
                setSelf();
            }, function(e) {
                promiseErrorCache.set(promise, e);
                setSelf();
            });
            if (promiseErrorCache.has(promise)) throw promiseErrorCache.get(promise);
            if (promiseResultCache.has(promise)) return {
                p: promise,
                v: promiseResultCache.get(promise)
            };
            if (prev && "v" in prev) return {
                p: promise,
                f: fallback(prev.v),
                v: prev.v
            };
            return {
                p: promise,
                f: fallback()
            };
        }, function(_get, set) {
            set(refreshAtom, function(c) {
                return c + 1;
            });
        });
        promiseAndValueAtom.init = void 0;
        if (($727eac459c311d54$import_meta.env ? $727eac459c311d54$import_meta.env.MODE : void 0) !== "production") promiseAndValueAtom.debugPrivate = true;
        return (0, _vanilla.atom)(function(get) {
            var state = get(promiseAndValueAtom);
            if ("f" in state) return state.f;
            return state.v;
        }, function(_get, set) {
            for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
                args[_key - 2] = arguments[_key];
            }
            return set.apply(void 0, [
                anAtom
            ].concat((0, _toConsumableArray._)(args)));
        });
    }, anAtom, fallback);
}
function atomWithRefresh(read, write) {
    var refreshAtom = (0, _vanilla.atom)(0);
    if (($727eac459c311d54$import_meta.env ? $727eac459c311d54$import_meta.env.MODE : void 0) !== "production") refreshAtom.debugPrivate = true;
    return (0, _vanilla.atom)(function(get, options) {
        get(refreshAtom);
        return read(get, options);
    }, function(get, set) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
            args[_key - 2] = arguments[_key];
        }
        if (args.length === 0) set(refreshAtom, function(c) {
            return c + 1;
        });
        else if (write) return write.apply(void 0, [
            get,
            set
        ].concat((0, _toConsumableArray._)(args)));
        else if (($727eac459c311d54$import_meta.env ? $727eac459c311d54$import_meta.env.MODE : void 0) !== "production") throw new Error("refresh must be called without arguments");
    });
}
function atomWithLazy(makeInitial) {
    var a = (0, _vanilla.atom)(void 0);
    delete a.init;
    Object.defineProperty(a, "init", {
        get: function get() {
            return makeInitial();
        }
    });
    return a;
}

},{"@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_to_consumable_array":"1eSZf","@swc/helpers/_/_type_of":"iFJdx","jotai/vanilla":"7uoOf","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gAqnx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAtomCallback", function() {
    return useAtomCallback;
});
parcelHelpers.export(exports, "useHydrateAtoms", function() {
    return useHydrateAtoms;
});
parcelHelpers.export(exports, "useReducerAtom", function() {
    return useReducerAtom;
});
parcelHelpers.export(exports, "useResetAtom", function() {
    return useResetAtom;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toArray = require("@swc/helpers/_/_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _react = require("react");
var _react1 = require("jotai/react");
var _utils = require("jotai/vanilla/utils");
var _vanilla = require("jotai/vanilla");
var $c134786810d83f9c$import_meta = Object.assign(Object.create(null), {
    url: "file:///../node_modules/jotai/esm/react/utils.mjs"
});
'use client';
function useResetAtom(anAtom, options) {
    var setAtom = (0, _react1.useSetAtom)(anAtom, options);
    var resetAtom = (0, _react.useCallback)(function() {
        return setAtom((0, _utils.RESET));
    }, [
        setAtom
    ]);
    return resetAtom;
}
function useReducerAtom(anAtom, reducer, options) {
    if (($c134786810d83f9c$import_meta.env ? $c134786810d83f9c$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] useReducerAtom is deprecated and will be removed in the future. Please create your own version using the recipe. https://github.com/pmndrs/jotai/pull/2467");
    var _useAtom = (0, _slicedToArray._)((0, _react1.useAtom)(anAtom, options), 2), state = _useAtom[0], setState = _useAtom[1];
    var dispatch = (0, _react.useCallback)(function(action) {
        setState(function(prev) {
            return reducer(prev, action);
        });
    }, [
        setState,
        reducer
    ]);
    return [
        state,
        dispatch
    ];
}
function useAtomCallback(callback, options) {
    var anAtom = (0, _react.useMemo)(function() {
        return (0, _vanilla.atom)(null, function(get, set) {
            for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
                args[_key - 2] = arguments[_key];
            }
            return callback.apply(void 0, [
                get,
                set
            ].concat((0, _toConsumableArray._)(args)));
        });
    }, [
        callback
    ]);
    return (0, _react1.useSetAtom)(anAtom, options);
}
var hydratedMap = /* @__PURE__ */ new WeakMap();
function useHydrateAtoms(values, options) {
    var store = (0, _react1.useStore)(options);
    var hydratedSet = getHydratedSet(store);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, _toArray._)(_step.value), atom = _step_value[0], args = _step_value.slice(1);
            if (!hydratedSet.has(atom) || (options == null ? void 0 : options.dangerouslyForceHydrate)) {
                var _store;
                hydratedSet.add(atom);
                (_store = store).set.apply(_store, [
                    atom
                ].concat((0, _toConsumableArray._)(args)));
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
var getHydratedSet = function(store) {
    var hydratedSet = hydratedMap.get(store);
    if (!hydratedSet) {
        hydratedSet = /* @__PURE__ */ new WeakSet();
        hydratedMap.set(store, hydratedSet);
    }
    return hydratedSet;
};

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_to_array":"auK39","@swc/helpers/_/_to_consumable_array":"1eSZf","react":"ltHCL","jotai/react":"9TfKr","jotai/vanilla/utils":"9Ps6a","jotai/vanilla":"7uoOf","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jgfkg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "forceLoggedOutViewAtom", function() {
    return forceLoggedOutViewAtom;
});
parcelHelpers.export(exports, "orgMetricsSourceAtom", function() {
    return orgMetricsSourceAtom;
});
parcelHelpers.export(exports, "selectedDebugTierAtom", function() {
    return selectedDebugTierAtom;
});
parcelHelpers.export(exports, "currentDisplayedTierAtom", function() {
    return currentDisplayedTierAtom;
});
parcelHelpers.export(exports, "selectedStaticTier1DatasetKeyAtom", function() {
    return selectedStaticTier1DatasetKeyAtom;
});
parcelHelpers.export(exports, "selectedStaticTier2DatasetKeyAtom", function() {
    return selectedStaticTier2DatasetKeyAtom;
});
parcelHelpers.export(exports, "selectedStaticTier3DatasetKeyAtom", function() {
    return selectedStaticTier3DatasetKeyAtom;
});
parcelHelpers.export(exports, "cloudIdAtom", function() {
    return cloudIdAtom;
});
parcelHelpers.export(exports, "orgIdAtom", function() {
    return orgIdAtom;
});
parcelHelpers.export(exports, "previousSelectionSourceAtom", function() {
    return previousSelectionSourceAtom;
});
parcelHelpers.export(exports, "accountIdAtom", function() {
    return accountIdAtom;
});
parcelHelpers.export(exports, "relayEnvironmentAtom", function() {
    return relayEnvironmentAtom;
});
parcelHelpers.export(exports, "availableSitesAtom", function() {
    return availableSitesAtom;
});
parcelHelpers.export(exports, "KnowledgeSourcesAtom", function() {
    return KnowledgeSourcesAtom;
});
parcelHelpers.export(exports, "CollaborationUsersAtom", function() {
    return CollaborationUsersAtom;
});
parcelHelpers.export(exports, "GlobalMetricsAtom", function() {
    return GlobalMetricsAtom;
});
parcelHelpers.export(exports, "OrgMetricsAtom", function() {
    return OrgMetricsAtom;
});
parcelHelpers.export(exports, "gettingStartedSelectedTabAtom", function() {
    return gettingStartedSelectedTabAtom;
});
parcelHelpers.export(exports, "UserMetricsFastAtom", function() {
    return UserMetricsFastAtom;
});
parcelHelpers.export(exports, "UserMetricsSlowAtom", function() {
    return UserMetricsSlowAtom;
});
parcelHelpers.export(exports, "UserMetricsAtom", function() {
    return UserMetricsAtom;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _jotai = require("jotai");
var _withRequestTiming = require("../../common/analytics/withRequestTiming");
var _appConnectors = require("../../utils/appConnectors");
var _availableProducts = require("../../utils/availableProducts");
var _collaborationUsers = require("../../utils/collaborationUsers");
var _globalMetrics = require("../../utils/globalMetrics");
var _orgMetrics = require("../../utils/orgMetrics");
var _userMetrics = require("../../utils/userMetrics");
var _staticDatasets = require("../components/DebugPanel/staticDatasets");
var _types = require("../components/SiteSwitcher/types");
var forceLoggedOutViewAtom = (0, _jotai.atom)(false);
var orgMetricsSourceAtom = (0, _jotai.atom)('api');
var selectedDebugTierAtom = (0, _jotai.atom)('tier1');
var currentDisplayedTierAtom = (0, _jotai.atom)(null);
var selectedStaticTier1DatasetKeyAtom = (0, _jotai.atom)(null);
var selectedStaticTier2DatasetKeyAtom = (0, _jotai.atom)(null);
var selectedStaticTier3DatasetKeyAtom = (0, _jotai.atom)(null);
var cloudIdAtom = (0, _jotai.atom)(null);
var orgIdAtom = (0, _jotai.atom)(null);
var previousSelectionSourceAtom = (0, _jotai.atom)((0, _types.SiteSelectionSource).Default);
var accountIdAtom = (0, _jotai.atom)('');
var relayEnvironmentAtom = (0, _jotai.atom)(null);
var availableSitesAtom = (0, _jotai.atom)(function() {
    return (0, _asyncToGenerator._)(function() {
        var _response_error, execute, response, _response_error_message, error;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    execute = (0, _availableProducts.requestAvailableProducts)().execute;
                    return [
                        4,
                        (0, _withRequestTiming.withRequestTiming)('operational.availableProductsRequest.completed.twgMicrositeAvailableProducts', execute)
                    ];
                case 1:
                    response = _state.sent();
                    if (response.success) return [
                        2,
                        {
                            data: response.data.sites.filter(function(site) {
                                return (site === null || site === void 0 ? void 0 : site.org) !== undefined;
                            }),
                            error: null
                        }
                    ];
                    return [
                        2,
                        {
                            data: [],
                            error: "Failed to fetch available products: ".concat((_response_error_message = (_response_error = response.error) === null || _response_error === void 0 ? void 0 : _response_error.message) !== null && _response_error_message !== void 0 ? _response_error_message : response.error)
                        }
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        2,
                        {
                            data: [],
                            error: (0, _instanceof._)(error, Error) ? error.message : 'An unexpected error occurred'
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
});
var KnowledgeSourcesAtom = (0, _jotai.atom)(function(get) {
    return (0, _asyncToGenerator._)(function() {
        var cloudId, _rovoResponse_error, rovoRequest, rovoResponse, _rovoResponse_error_message, rovoConnectors, finalParsedConnectors, seenConnectorKeys, error;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    cloudId = get(cloudIdAtom);
                    if (!cloudId) return [
                        2,
                        {
                            data: [],
                            error: null
                        }
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    rovoRequest = (0, _appConnectors.requestKnowledgeSources)(cloudId);
                    return [
                        4,
                        (0, _withRequestTiming.withRequestTiming)('operational.appConnectorsRequest.completed.twgMicrositeAppConnectors', rovoRequest.execute, {
                            requestName: 'knowledgeSources'
                        })
                    ];
                case 2:
                    rovoResponse = _state.sent();
                    if (!rovoResponse.success) return [
                        2,
                        {
                            data: [],
                            error: "Failed to fetch connectors: ".concat((_rovoResponse_error_message = (_rovoResponse_error = rovoResponse.error) === null || _rovoResponse_error === void 0 ? void 0 : _rovoResponse_error.message) !== null && _rovoResponse_error_message !== void 0 ? _rovoResponse_error_message : rovoResponse.error)
                        }
                    ];
                    rovoConnectors = rovoResponse.data.knowledgeSources;
                    finalParsedConnectors = [];
                    seenConnectorKeys = new Set();
                    rovoConnectors.forEach(function(connector) {
                        var parsedConnector = {
                            source: connector.source,
                            displayName: connector.friendlyName,
                            iconUrl: connector.iconUrl,
                            outboundAuthUrl: connector.outboundAuthUrl,
                            isUserOAuthed: connector.isUserOAuthed
                        };
                        var _parsedConnector_outboundAuthUrl;
                        var connectorKey = "".concat(parsedConnector.source, "::").concat(parsedConnector.displayName, "::").concat(parsedConnector.iconUrl, "::").concat((_parsedConnector_outboundAuthUrl = parsedConnector.outboundAuthUrl) !== null && _parsedConnector_outboundAuthUrl !== void 0 ? _parsedConnector_outboundAuthUrl : '');
                        if (seenConnectorKeys.has(connectorKey)) return;
                        seenConnectorKeys.add(connectorKey);
                        finalParsedConnectors.push(parsedConnector);
                    });
                    return [
                        2,
                        {
                            data: finalParsedConnectors,
                            error: null
                        }
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        2,
                        {
                            data: [],
                            error: (0, _instanceof._)(error, Error) ? error.message : 'An unexpected error occurred'
                        }
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    })();
});
var CollaborationUsersAtom = (0, _jotai.atom)(function(get) {
    return (0, _asyncToGenerator._)(function() {
        var source, tier, hasSelection, cloudId, accountId, _response_error, execute, response, _response_error_message, error;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    source = get(orgMetricsSourceAtom);
                    // Debug panel override: when a static dataset has been picked for the
                    // active tier, serve the canned collaborator roster directly without
                    // touching the network. The same roster is returned for every
                    // dataset (and every tier) so demo flows always show a recognisable
                    // Teamwork Graph team. Tier 3 is a pure capability showcase that
                    // doesn't render collaborators, so the roster is still returned but
                    // ignored downstream.
                    if (source === 'static') {
                        tier = get(selectedDebugTierAtom);
                        hasSelection = tier === 'tier1' && get(selectedStaticTier1DatasetKeyAtom) !== null || tier === 'tier2' && get(selectedStaticTier2DatasetKeyAtom) !== null || tier === 'tier3' && get(selectedStaticTier3DatasetKeyAtom) !== null;
                        if (hasSelection) return [
                            2,
                            {
                                data: (0, _toConsumableArray._)((0, _staticDatasets.STATIC_COLLABORATION_USERS)),
                                error: null
                            }
                        ];
                        return [
                            2,
                            {
                                data: [],
                                error: null
                            }
                        ];
                    }
                    cloudId = get(cloudIdAtom);
                    accountId = get(accountIdAtom);
                    if (!cloudId || !accountId) return [
                        2,
                        {
                            data: [],
                            error: null
                        }
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    execute = (0, _collaborationUsers.requestCollaborationUsers)({
                        requestingUserId: accountId,
                        targetUserId: accountId,
                        tenantId: cloudId,
                        limit: 5
                    }).execute;
                    return [
                        4,
                        (0, _withRequestTiming.withRequestTiming)('operational.collaborationUsersRequest.completed.twgMicrositeCollaborationUsers', execute)
                    ];
                case 2:
                    response = _state.sent();
                    if (response.success) return [
                        2,
                        {
                            data: response.data.recommendedEntities,
                            error: null
                        }
                    ];
                    return [
                        2,
                        {
                            data: [],
                            error: "Failed to fetch collaboration users: ".concat((_response_error_message = (_response_error = response.error) === null || _response_error === void 0 ? void 0 : _response_error.message) !== null && _response_error_message !== void 0 ? _response_error_message : response.error)
                        }
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        2,
                        {
                            data: [],
                            error: (0, _instanceof._)(error, Error) ? error.message : 'An unexpected error occurred'
                        }
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    })();
});
var GlobalMetricsAtom = (0, _jotai.atom)(function() {
    return (0, _asyncToGenerator._)(function() {
        var _response_error, execute, response, _response_error_message, error;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    execute = (0, _globalMetrics.requestGlobalMetrics)().execute;
                    return [
                        4,
                        (0, _withRequestTiming.withRequestTiming)('operational.globalMetricsRequest.completed.twgMicrositeGlobalMetrics', execute)
                    ];
                case 1:
                    response = _state.sent();
                    if (response.success) return [
                        2,
                        {
                            data: response.data,
                            error: null
                        }
                    ];
                    return [
                        2,
                        {
                            data: null,
                            error: "Failed to fetch global metrics: ".concat((_response_error_message = (_response_error = response.error) === null || _response_error === void 0 ? void 0 : _response_error.message) !== null && _response_error_message !== void 0 ? _response_error_message : response.error)
                        }
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        2,
                        {
                            data: null,
                            error: (0, _instanceof._)(error, Error) ? error.message : 'An unexpected error occurred'
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
});
var OrgMetricsAtom = (0, _jotai.atom)(function(get) {
    return (0, _asyncToGenerator._)(function() {
        var source, tier, datasetKey, datasetKey1, orgId, cloudId, accountId, _response_error, execute, response, _response_error_message, error;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    source = get(orgMetricsSourceAtom);
                    // Debug panel override: when the source is `'static'` and a Tier 2
                    // dataset has been picked, serve it directly without touching the
                    // network. The payload conforms to `OrgMetricsResponse`, so
                    // downstream consumers (e.g. `selectMetrics`) treat it identically
                    // to a live response. Tier 1 and Tier 3 previews intentionally do
                    // not seed org metrics — Tier 1 drives `UserMetricsAtom` instead,
                    // and Tier 3 is a pure capability showcase that ignores numeric
                    // data — so we fall through to the null payload in those cases.
                    if (source === 'static') {
                        tier = get(selectedDebugTierAtom);
                        if (tier === 'tier2') {
                            datasetKey = get(selectedStaticTier2DatasetKeyAtom);
                            if (datasetKey) return [
                                2,
                                {
                                    data: (0, _staticDatasets.STATIC_TIER2_DATASETS)[datasetKey].metrics,
                                    error: null
                                }
                            ];
                        }
                        if (tier === 'tier3') {
                            datasetKey1 = get(selectedStaticTier3DatasetKeyAtom);
                            if (datasetKey1) return [
                                2,
                                {
                                    data: (0, _staticDatasets.STATIC_TIER3_DATASETS)[datasetKey1].metrics,
                                    error: null
                                }
                            ];
                        }
                        return [
                            2,
                            {
                                data: null,
                                error: null
                            }
                        ];
                    }
                    orgId = get(orgIdAtom);
                    cloudId = get(cloudIdAtom);
                    accountId = get(accountIdAtom);
                    if (!orgId || !cloudId) return [
                        2,
                        {
                            data: null,
                            error: null
                        }
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    execute = (0, _orgMetrics.requestOrgMetrics)(orgId, cloudId, accountId).execute;
                    return [
                        4,
                        (0, _withRequestTiming.withRequestTiming)('operational.orgMetricsRequest.completed.twgMicrositeOrgMetrics', execute)
                    ];
                case 2:
                    response = _state.sent();
                    if (response.success) {
                        if ('status' in response.data && response.data.status === 'NO_DATA') return [
                            2,
                            {
                                data: null,
                                error: null
                            }
                        ];
                        return [
                            2,
                            {
                                data: response.data,
                                error: null
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            data: null,
                            error: "Failed to fetch org metrics: ".concat((_response_error_message = (_response_error = response.error) === null || _response_error === void 0 ? void 0 : _response_error.message) !== null && _response_error_message !== void 0 ? _response_error_message : response.error)
                        }
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        2,
                        {
                            data: null,
                            error: (0, _instanceof._)(error, Error) ? error.message : 'An unexpected error occurred'
                        }
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    })();
});
var gettingStartedSelectedTabAtom = (0, _jotai.atom)('cli');
/**
 * Internal helper — issue a user-metrics request for the given groups
 * and normalise to a `UserMetricsResult`. NO_DATA / 404 / network
 * failures are funnelled through the same null-data branch so callers
 * never have to throw-catch.
 *
 * Both the fast and slow paths reuse the existing
 * `…twgMicrositeUserMetrics` timing event key — finer-grained
 * fast/slow analytics would require adding new keys to
 * `analytics.spec.yaml` and regenerating the union, which is out of
 * scope for this change.
 */ var fetchUserMetricsForGroups = function(orgId, cloudId, topCollaboratorAris, groups) {
    return (0, _asyncToGenerator._)(function() {
        var _response_error, execute, response, _response_error_message, error;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    execute = (0, _userMetrics.requestUserMetrics)(orgId, cloudId, topCollaboratorAris, groups).execute;
                    return [
                        4,
                        (0, _withRequestTiming.withRequestTiming)('operational.userMetricsRequest.completed.twgMicrositeUserMetrics', execute)
                    ];
                case 1:
                    response = _state.sent();
                    if (response.success) {
                        if ((0, _userMetrics.isUserNoDataResponse)(response.data)) return [
                            2,
                            {
                                data: null,
                                error: null
                            }
                        ];
                        return [
                            2,
                            {
                                data: response.data,
                                error: null
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            data: null,
                            error: "Failed to fetch user metrics: ".concat((_response_error_message = (_response_error = response.error) === null || _response_error === void 0 ? void 0 : _response_error.message) !== null && _response_error_message !== void 0 ? _response_error_message : response.error)
                        }
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        2,
                        {
                            data: null,
                            error: (0, _instanceof._)(error, Error) ? error.message : 'An unexpected error occurred'
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
};
var UserMetricsFastAtom = (0, _jotai.atom)(function(get) {
    return (0, _asyncToGenerator._)(function() {
        var source, tier, tier1Key, orgId, cloudId;
        return (0, _tsGenerator._)(this, function(_state) {
            source = get(orgMetricsSourceAtom);
            if (source === 'static') {
                tier = get(selectedDebugTierAtom);
                if (tier === 'tier1') {
                    tier1Key = get(selectedStaticTier1DatasetKeyAtom);
                    if (tier1Key) return [
                        2,
                        {
                            data: (0, _staticDatasets.STATIC_TIER1_DATASETS)[tier1Key].metrics,
                            error: null
                        }
                    ];
                }
                return [
                    2,
                    {
                        data: null,
                        error: null
                    }
                ];
            }
            orgId = get(orgIdAtom);
            cloudId = get(cloudIdAtom);
            if (!orgId || !cloudId) return [
                2,
                {
                    data: null,
                    error: null
                }
            ];
            return [
                2,
                fetchUserMetricsForGroups(orgId, cloudId, [], [
                    'fast',
                    'medium'
                ])
            ];
        });
    })();
});
var UserMetricsSlowAtom = (0, _jotai.atom)(function(get) {
    return (0, _asyncToGenerator._)(function() {
        var source, tier, tier1Key, tier3Key, orgId, cloudId, collaborationUsers, topCollaboratorAris;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    source = get(orgMetricsSourceAtom);
                    if (source === 'static') {
                        tier = get(selectedDebugTierAtom);
                        if (tier === 'tier1') {
                            tier1Key = get(selectedStaticTier1DatasetKeyAtom);
                            if (tier1Key) return [
                                2,
                                {
                                    data: (0, _staticDatasets.STATIC_TIER1_DATASETS)[tier1Key].metrics,
                                    error: null
                                }
                            ];
                        }
                        if (tier === 'tier3') {
                            tier3Key = get(selectedStaticTier3DatasetKeyAtom);
                            if (tier3Key) return [
                                2,
                                {
                                    data: (0, _staticDatasets.TIER_3_USER_DATASET).metrics,
                                    error: null
                                }
                            ];
                        }
                        return [
                            2,
                            {
                                data: null,
                                error: null
                            }
                        ];
                    }
                    orgId = get(orgIdAtom);
                    cloudId = get(cloudIdAtom);
                    if (!orgId || !cloudId) return [
                        2,
                        {
                            data: null,
                            error: null
                        }
                    ];
                    return [
                        4,
                        get(CollaborationUsersAtom)
                    ];
                case 1:
                    collaborationUsers = _state.sent();
                    topCollaboratorAris = collaborationUsers.data.map(function(entity) {
                        var _entity_expand;
                        return (_entity_expand = entity.expand) === null || _entity_expand === void 0 ? void 0 : _entity_expand.ari;
                    }).filter(function(ari) {
                        return typeof ari === 'string' && ari.length > 0;
                    });
                    return [
                        2,
                        fetchUserMetricsForGroups(orgId, cloudId, topCollaboratorAris, [
                            'slow'
                        ])
                    ];
            }
        });
    })();
});
var UserMetricsAtom = (0, _jotai.atom)(function(get) {
    return (0, _asyncToGenerator._)(function() {
        var _ref, fast, slow, _fast_error, _fast_data, base, _fast_error1, _fast_data1, merged, _fast_error2;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        Promise.all([
                            get(UserMetricsFastAtom),
                            get(UserMetricsSlowAtom)
                        ])
                    ];
                case 1:
                    _ref = (0, _slicedToArray._).apply(void 0, [
                        _state.sent(),
                        2
                    ]), fast = _ref[0], slow = _ref[1];
                    // If neither call produced data, surface the fast error first
                    // (it's the cheap one consumers care about most) and fall back
                    // to the slow error.
                    if (!fast.data && !slow.data) return [
                        2,
                        {
                            data: null,
                            error: (_fast_error = fast.error) !== null && _fast_error !== void 0 ? _fast_error : slow.error
                        }
                    ];
                    base = (_fast_data = fast.data) !== null && _fast_data !== void 0 ? _fast_data : slow.data;
                    // `base` is non-null here because at least one of the two has
                    // data — TS narrowing.
                    if (!base) return [
                        2,
                        {
                            data: null,
                            error: (_fast_error1 = fast.error) !== null && _fast_error1 !== void 0 ? _fast_error1 : slow.error
                        }
                    ];
                    merged = (0, _objectSpreadProps._)((0, _objectSpread._)({}, base, fast.data, slow.data ? {
                        workByCollaborators: slow.data.workByCollaborators
                    } : {}), {
                        computedAt: fast.data && slow.data ? fast.data.computedAt > slow.data.computedAt ? fast.data.computedAt : slow.data.computedAt : ((_fast_data1 = fast.data) !== null && _fast_data1 !== void 0 ? _fast_data1 : slow.data).computedAt
                    });
                    return [
                        2,
                        {
                            data: merged,
                            error: (_fast_error2 = fast.error) !== null && _fast_error2 !== void 0 ? _fast_error2 : slow.error
                        }
                    ];
            }
        });
    })();
});

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_to_consumable_array":"1eSZf","@swc/helpers/_/_ts_generator":"78Tqx","jotai":"4mcir","../../common/analytics/withRequestTiming":"8C7Tc","../../utils/appConnectors":"lz6AC","../../utils/availableProducts":"kpiRa","../../utils/collaborationUsers":"hK0rz","../../utils/globalMetrics":"jxNTY","../../utils/orgMetrics":"gdH4Q","../../utils/userMetrics":"9imAr","../components/DebugPanel/staticDatasets":"5RRMs","../components/SiteSwitcher/types":"hBDS8","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8C7Tc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "withRequestTiming", function() {
    return withRequestTiming;
});
parcelHelpers.export(exports, "withTimingAdapter", function() {
    return withTimingAdapter;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _analyticsClient = require("./analytics-client");
var _constants = require("./constants");
var ACTION_BY_KEY = {
    'operational.globalMetricsRequest.completed.twgMicrositeGlobalMetrics': {
        actionSubject: 'globalMetricsRequest',
        actionSubjectId: 'twgMicrositeGlobalMetrics'
    },
    'operational.orgMetricsRequest.completed.twgMicrositeOrgMetrics': {
        actionSubject: 'orgMetricsRequest',
        actionSubjectId: 'twgMicrositeOrgMetrics'
    },
    'operational.appConnectorsRequest.completed.twgMicrositeAppConnectors': {
        actionSubject: 'appConnectorsRequest',
        actionSubjectId: 'twgMicrositeAppConnectors'
    },
    'operational.availableProductsRequest.completed.twgMicrositeAvailableProducts': {
        actionSubject: 'availableProductsRequest',
        actionSubjectId: 'twgMicrositeAvailableProducts'
    },
    'operational.userMetricsRequest.completed.twgMicrositeUserMetrics': {
        actionSubject: 'userMetricsRequest',
        actionSubjectId: 'twgMicrositeUserMetrics'
    },
    'operational.collaborationUsersRequest.completed.twgMicrositeCollaborationUsers': {
        actionSubject: 'collaborationUsersRequest',
        actionSubjectId: 'twgMicrositeCollaborationUsers'
    }
};
var withRequestTiming = function(eventKey, promise, extraAttrs) {
    return (0, _asyncToGenerator._)(function() {
        var start, response, e, _response_statusCode;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    start = Date.now();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        promise
                    ];
                case 2:
                    response = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    fireTimingEvent(eventKey, (0, _objectSpread._)({
                        durationMs: Date.now() - start,
                        statusCode: null,
                        success: false
                    }, extraAttrs));
                    throw e;
                case 4:
                    fireTimingEvent(eventKey, (0, _objectSpread._)({
                        durationMs: Date.now() - start,
                        statusCode: (_response_statusCode = response.statusCode) !== null && _response_statusCode !== void 0 ? _response_statusCode : null,
                        success: response.success
                    }, extraAttrs));
                    return [
                        2,
                        response
                    ];
            }
        });
    })();
};
var withTimingAdapter = function(eventKey, promise, deriveAttrs) {
    return (0, _asyncToGenerator._)(function() {
        var start, value, _deriveAttrs, e, _deriveAttrs1;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    start = Date.now();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        promise
                    ];
                case 2:
                    value = _state.sent();
                    fireTimingEvent(eventKey, (0, _objectSpread._)({
                        durationMs: Date.now() - start,
                        statusCode: null,
                        success: true
                    }, (_deriveAttrs = deriveAttrs === null || deriveAttrs === void 0 ? void 0 : deriveAttrs({
                        ok: true,
                        value: value
                    })) !== null && _deriveAttrs !== void 0 ? _deriveAttrs : {}));
                    return [
                        2,
                        value
                    ];
                case 3:
                    e = _state.sent();
                    fireTimingEvent(eventKey, (0, _objectSpread._)({
                        durationMs: Date.now() - start,
                        statusCode: null,
                        success: false
                    }, (_deriveAttrs1 = deriveAttrs === null || deriveAttrs === void 0 ? void 0 : deriveAttrs({
                        ok: false,
                        error: e
                    })) !== null && _deriveAttrs1 !== void 0 ? _deriveAttrs1 : {}));
                    throw e;
                case 4:
                    return [
                        2
                    ];
            }
        });
    })();
};
/**
 * Fires a track event imperatively via the singleton AnalyticsWebClient.
 * Safe to call from non-React contexts (Jotai atoms, util modules).
 */ var fireTimingEvent = function(eventKey, attributes) {
    var client;
    try {
        client = (0, _analyticsClient.getAnalyticsClient)();
    } catch (e) {
        // Analytics not initialised yet (e.g. during SSR or pre-bootstrap);
        // silently drop the event.
        return;
    }
    var _ACTION_BY_KEY_eventKey = ACTION_BY_KEY[eventKey], actionSubject = _ACTION_BY_KEY_eventKey.actionSubject, actionSubjectId = _ACTION_BY_KEY_eventKey.actionSubjectId;
    client.sendOperationalEvent({
        action: 'completed',
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        source: 'twgMicrositeHome',
        attributes: attributes,
        tags: [
            (0, _constants.EVENT_CHANNEL)
        ]
    });
};

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_ts_generator":"78Tqx","./analytics-client":"aVBNX","./constants":"7H6IQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lz6AC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "requestKnowledgeSources", function() {
    return requestKnowledgeSources;
});
/**
 * Fetch combined first-party + third-party search configuration for the
 * current site via the `/gateway/api/graphql` endpoint.
 *
 * Uses Relay's imperative `fetchQuery` so the call participates in the
 * same network/cache layer wired up by `@atlassian/relay-environment-provider`.
 * Auth, tracing and `atl-attribution` headers are attached automatically by
 * that environment — no need to forward cookies/headers manually.
 */ parcelHelpers.export(exports, "searchCombinedConfig", function() {
    return searchCombinedConfig;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _appConnectorsTwgMicrositeSearchCombinedConfigQueryGraphql = require("./__generated__/appConnectors_twg_microsite_SearchCombinedConfig_Query.graphql");
var _appConnectorsTwgMicrositeSearchCombinedConfigQueryGraphqlDefault = parcelHelpers.interopDefault(_appConnectorsTwgMicrositeSearchCombinedConfigQueryGraphql);
/* eslint-disable @atlassian/relay/unused-fields */ var _reactRelay = require("react-relay");
var _twgCommon = require("@atlassian/twg-common");
var requestKnowledgeSources = function(cloudId) {
    var _requestWithAbort = (0, _twgCommon.requestWithAbort)('get', '/gateway/api/assist/rovo/v1/agents/configuration/knowledge', undefined, {
        credentials: 'include',
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Product': 'rovo',
        'X-Experience-Id': 'ai-mate',
        'X-Cloudid': cloudId
    }), controller = _requestWithAbort.controller, execute = _requestWithAbort.execute;
    return {
        controller: controller,
        execute: execute
    };
};
function searchCombinedConfig(environment, cloudId) {
    return (0, _asyncToGenerator._)(function() {
        var _data_search, data, configuration, error;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0, _reactRelay.fetchQuery)(environment, (0, _appConnectorsTwgMicrositeSearchCombinedConfigQueryGraphqlDefault.default), {
                            cloudId: cloudId
                        }).toPromise()
                    ];
                case 1:
                    data = _state.sent();
                    configuration = data === null || data === void 0 ? void 0 : (_data_search = data.search) === null || _data_search === void 0 ? void 0 : _data_search.configuration;
                    if (!configuration) return [
                        2,
                        {
                            success: false
                        }
                    ];
                    return [
                        2,
                        {
                            success: true,
                            configuration: configuration
                        }
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        2,
                        {
                            success: false,
                            error: error
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
}

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_ts_generator":"78Tqx","./__generated__/appConnectors_twg_microsite_SearchCombinedConfig_Query.graphql":"fkdSl","react-relay":"9HAyN","@atlassian/twg-common":"7BO56","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fkdSl":[function(require,module,exports,__globalThis) {
/**
 * @generated SignedSource<<75543bad9b6901526e8e7bc9d116fd3b>>
 * @relayHash 830e3a87656c190d259f4de3cffb876c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8f025b5712462290c910466d41e500bb7d42f2334e5cca14610d8725a9d29be5
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "name"
    }, v2 = [
        {
            "concreteType": "SearchQueryAPI",
            "kind": "LinkedField",
            "name": "search",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "concreteType": "SearchGraphQLConfigurationResponse",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "SearchFirstPartyMetadata",
                            "kind": "LinkedField",
                            "name": "firstPartyProducts",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "SearchThirdPartyMetadata",
                            "kind": "LinkedField",
                            "name": "thirdPartyProducts",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "outboundAuthUrl"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isUserOAuthed"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "providerId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "integrationARI"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "workspaceName"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "workspaceUrl"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "datasourceId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "connectionId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "connectorSyncType"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isImpersonationAuthEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "connectorCreatedAt"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "lightIcon"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "entityTypes"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "environmentType"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "intercomHmac"
                        },
                        {
                            "concreteType": "SearchConfigurationSiteMetadata",
                            "kind": "LinkedField",
                            "name": "siteMetadata",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isRovoEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isJiraIssueIndexed"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "applicationMode"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "siteName"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "orgId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "productEdition"
                                },
                                {
                                    "concreteType": "SearchProductInfo",
                                    "kind": "LinkedField",
                                    "name": "productInfo",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "dataRegion"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "appConnectors_twg_microsite_SearchCombinedConfig_Query",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "appConnectors_twg_microsite_SearchCombinedConfig_Query",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "id": "8f025b5712462290c910466d41e500bb7d42f2334e5cca14610d8725a9d29be5",
            "metadata": {},
            "name": "appConnectors_twg_microsite_SearchCombinedConfig_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
node.hash = "30926d71734e98454a9fd61a37953b2f";
exports.default = node;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kpiRa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "requestAvailableProducts", function() {
    return requestAvailableProducts;
});
var _twgCommon = require("@atlassian/twg-common");
var requestAvailableProducts = function() {
    var _requestWithAbort = (0, _twgCommon.requestWithAbort)('get', '/gateway/api/app-switcher/api/available-products?source=app-switcher-fe&product=twg-microsite-bifrost', null, {
        'Atl-App-Switcher-Private-API': 'true'
    }), execute = _requestWithAbort.execute, controller = _requestWithAbort.controller;
    return {
        controller: controller,
        execute: execute
    };
};

},{"@atlassian/twg-common":"7BO56","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hK0rz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "requestCollaborationUsers", function() {
    return requestCollaborationUsers;
});
var _twgCommon = require("@atlassian/twg-common");
var requestCollaborationUsers = function(param) {
    var requestingUserId = param.requestingUserId, targetUserId = param.targetUserId, tenantId = param.tenantId, limit = param.limit;
    var body = {
        modelRequestParams: {
            experience: 'CgUserNearbyUser',
            caller: 'twg-microsite',
            featureServiceModel: 'cg_user_user_v5'
        },
        expand: 'all',
        requestingUserId: requestingUserId,
        context: {
            userId: targetUserId,
            tenantId: tenantId
        },
        maxNumberOfResults: limit
    };
    return (0, _twgCommon.requestWithAbort)('post', "/gateway/api/collaboration/v2/recommend/user", body, {
        credentials: 'include'
    });
};

},{"@atlassian/twg-common":"7BO56","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jxNTY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "requestGlobalMetrics", function() {
    return requestGlobalMetrics;
});
var _twgCommon = require("@atlassian/twg-common");
var requestGlobalMetrics = function() {
    var _requestWithAbort = (0, _twgCommon.requestWithAbort)('get', '/gateway/api/twg-api/v1/microsite/metrics/global', undefined, undefined, undefined, true), controller = _requestWithAbort.controller, execute = _requestWithAbort.execute;
    return {
        controller: controller,
        execute: execute
    };
};

},{"@atlassian/twg-common":"7BO56","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gdH4Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "requestOrgMetrics", function() {
    return requestOrgMetrics;
});
parcelHelpers.export(exports, "INTRO_METRICS", function() {
    return INTRO_METRICS;
});
parcelHelpers.export(exports, "GRAPH_SHAPE_METRICS", function() {
    return GRAPH_SHAPE_METRICS;
});
parcelHelpers.export(exports, "GRAPH_CONNECTIVITY_METRICS", function() {
    return GRAPH_CONNECTIVITY_METRICS;
});
parcelHelpers.export(exports, "ALL_METRIC_DESCRIPTORS", function() {
    return ALL_METRIC_DESCRIPTORS;
});
parcelHelpers.export(exports, "isNoDataResponse", function() {
    return isNoDataResponse;
});
parcelHelpers.export(exports, "extractValue", function() {
    return extractValue;
});
parcelHelpers.export(exports, "passesFloor", function() {
    return passesFloor;
});
parcelHelpers.export(exports, "extractExtraValues", function() {
    return extractExtraValues;
});
parcelHelpers.export(exports, "evaluateOrgTier", function() {
    return evaluateOrgTier;
});
parcelHelpers.export(exports, "evaluateExperienceState", function() {
    return evaluateExperienceState;
});
parcelHelpers.export(exports, "selectMetrics", function() {
    return selectMetrics;
});
parcelHelpers.export(exports, "selectAllMetrics", function() {
    return selectAllMetrics;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var _videoClip = require("@atlaskit/icon-lab/core/video-clip");
var _videoClipDefault = parcelHelpers.interopDefault(_videoClip);
var _comment = require("@atlaskit/icon/core/comment");
var _commentDefault = parcelHelpers.interopDefault(_comment);
var _link = require("@atlaskit/icon/core/link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _page = require("@atlaskit/icon/core/page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _peopleGroup = require("@atlaskit/icon/core/people-group");
var _peopleGroupDefault = parcelHelpers.interopDefault(_peopleGroup);
var _search = require("@atlaskit/icon/core/search");
var _searchDefault = parcelHelpers.interopDefault(_search);
var _task = require("@atlaskit/icon/core/task");
var _taskDefault = parcelHelpers.interopDefault(_task);
var _teams = require("@atlaskit/icon/core/teams");
var _teamsDefault = parcelHelpers.interopDefault(_teams);
var _twgCommon = require("@atlassian/twg-common");
var requestOrgMetrics = function(orgId, cloudId, accountId) {
    var headers = {
        'X-Query-Context': "ari:cloud:platform::site/".concat(cloudId)
    };
    if (accountId) {
        headers['x-user-id'] = accountId;
        headers['x-cloudid'] = cloudId;
    }
    var _requestWithAbort = (0, _twgCommon.requestWithAbort)('GET', "/gateway/api/twg-api/v1/microsite/metrics/org/".concat(orgId), null, headers, [
        200,
        404
    ]), controller = _requestWithAbort.controller, execute = _requestWithAbort.execute;
    return {
        controller: controller,
        execute: execute
    };
};
var INTRO_METRICS = [
    {
        id: 'totalNodes',
        section: 'intro',
        priority: 1,
        floor: 'always',
        copyKey: 'introTotalNodes',
        field: 'estimatedNodesNow',
        requiresField: false,
        fallbackFields: [
            'totalNodes'
        ]
    },
    {
        id: 'totalUsers',
        section: 'intro',
        priority: 2,
        floor: 'always',
        copyKey: 'introTotalUsers',
        field: 'userCount',
        requiresField: false
    },
    {
        id: 'totalRelationships',
        section: 'intro',
        priority: 3,
        floor: 'always',
        copyKey: 'introTotalRelationships',
        field: 'totalRelationships',
        requiresField: false
    },
    {
        id: 'totalApps',
        section: 'intro',
        priority: 4,
        floor: 2,
        copyKey: 'introTotalApps',
        field: 'totalAppsInstalled',
        requiresField: false
    }
];
var GRAPH_SHAPE_METRICS = [
    {
        id: 'pagesCreated',
        section: 'graphShape',
        priority: 1,
        floor: 50,
        copyKey: 'shapePagesCreated',
        field: 'pagesCreated180d',
        requiresField: false,
        icon: (0, _pageDefault.default)
    },
    {
        id: 'loomsRecorded',
        section: 'graphShape',
        priority: 2,
        floor: 20,
        copyKey: 'shapeLoomsRecorded',
        field: 'loomsRecorded180d',
        requiresField: false,
        extraValues: {
            minutesSaved: 'meetingMinutesSaved'
        },
        icon: (0, _videoClipDefault.default)
    },
    {
        id: 'workItemUpdates',
        section: 'graphShape',
        priority: 3,
        floor: 50,
        copyKey: 'shapeWorkItemUpdates',
        field: 'issuesMovedForward180d',
        requiresField: false,
        icon: (0, _taskDefault.default)
    },
    {
        id: 'queriesPerDay',
        section: 'graphShape',
        priority: 4,
        floor: 1000,
        copyKey: 'shapeQueriesPerDay',
        field: 'avgFetchQueriesPerDay',
        requiresField: false,
        icon: (0, _searchDefault.default)
    },
    {
        id: 'teamsConnected',
        section: 'graphShape',
        priority: 5,
        floor: 5,
        copyKey: 'shapeTeamsConnected',
        field: 'teamCount',
        requiresField: false,
        icon: (0, _teamsDefault.default)
    },
    {
        id: 'commentsAdded',
        section: 'graphShape',
        priority: 6,
        floor: 100,
        copyKey: 'shapeCommentsAdded',
        field: 'commentsCreated180d',
        requiresField: false,
        icon: (0, _commentDefault.default)
    },
    {
        id: 'usersActive',
        section: 'graphShape',
        priority: 7,
        floor: 0,
        copyKey: 'shapeUsersActive',
        field: 'activeContributors180d',
        requiresField: false,
        icon: (0, _peopleGroupDefault.default)
    },
    {
        id: 'jiraCodeLinks',
        section: 'graphShape',
        priority: 8,
        floor: 5,
        copyKey: 'shapeJiraCodeLinks',
        field: 'jiraCodeLinks',
        requiresField: false,
        icon: (0, _linkDefault.default)
    }
];
var GRAPH_CONNECTIVITY_METRICS = [
    {
        id: 'jiraCodeLinks',
        section: 'graphConnectivity',
        priority: 1,
        floor: 100,
        copyKey: 'connectivityJiraCodeLinks',
        field: 'jiraCodeLinks',
        requiresField: false
    },
    {
        id: 'smartLinkPastes',
        section: 'graphConnectivity',
        priority: 2,
        floor: 100,
        copyKey: 'connectivitySmartLinkPastes',
        field: 'smartlinkPastes180d',
        requiresField: false
    },
    {
        id: 'artifactsPerIssue',
        section: 'graphConnectivity',
        priority: 3,
        floor: 2,
        copyKey: 'connectivityArtifactsPerIssue',
        field: 'avgArtifactsPerIssue',
        requiresField: false
    },
    {
        id: 'goalLinks',
        section: 'graphConnectivity',
        priority: 4,
        floor: 10,
        copyKey: 'connectivityGoalLinks',
        field: 'goalWorkItemLinks',
        requiresField: false
    },
    {
        id: 'activeContributors',
        section: 'graphConnectivity',
        priority: 5,
        floor: 10,
        copyKey: 'connectivityActiveContributors',
        field: 'activeContributors180d',
        requiresField: false
    },
    {
        id: 'entitiesTouched',
        section: 'graphConnectivity',
        priority: 6,
        floor: 20,
        copyKey: 'connectivityEntitiesTouched',
        field: 'entitiesTouched',
        requiresField: false
    },
    {
        id: 'uniqueCollaborators',
        section: 'graphConnectivity',
        priority: 7,
        floor: 5,
        copyKey: 'connectivityUniqueCollaborators',
        field: 'collaborators',
        requiresField: false,
        extraValues: {
            teams: 'collaboratorTeams'
        }
    },
    {
        id: 'meetingsLinked',
        section: 'graphConnectivity',
        priority: 8,
        floor: 10,
        copyKey: 'connectivityMeetingsLinked',
        field: 'meetingNotesWithRecording180d',
        requiresField: false
    }
];
var ALL_METRIC_DESCRIPTORS = (0, _toConsumableArray._)(INTRO_METRICS).concat((0, _toConsumableArray._)(GRAPH_SHAPE_METRICS), (0, _toConsumableArray._)(GRAPH_CONNECTIVITY_METRICS));
var isNoDataResponse = function(metrics) {
    return metrics != null && (typeof metrics === "undefined" ? "undefined" : (0, _typeOf._)(metrics)) === 'object' && metrics.status === 'NO_DATA';
};
var extractValue = function(metrics, descriptor) {
    if (descriptor.requiresField || descriptor.field === null) return null;
    var primary = metrics[descriptor.field];
    if (typeof primary === 'number') return primary;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (descriptor.fallbackFields) try {
        for(var _iterator = descriptor.fallbackFields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var fallbackField = _step.value;
            var fallback = metrics[fallbackField];
            if (typeof fallback === 'number') return fallback;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Backing field is present on the response but has no value yet — surface 0
    // rather than dropping the metric so consumers can render "0" copy.
    return 0;
};
var passesFloor = function(value, floor) {
    if (floor === 'always') return true;
    return value >= floor;
};
var extractExtraValues = function(metrics, descriptor) {
    if (!descriptor.extraValues) return {};
    var resolved = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(descriptor.extraValues)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, _slicedToArray._)(_step.value, 2), placeholder = _step_value[0], field = _step_value[1];
            var raw = metrics[field];
            resolved[placeholder] = typeof raw === 'number' ? raw : 0;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return resolved;
};
var evaluateOrgTier = function(metrics) {
    if (metrics == null || isNoDataResponse(metrics)) return 'GETTING_STARTED';
    var orgMetrics = metrics;
    var _orgMetrics_userCount, _orgMetrics_totalRelationships;
    if (((_orgMetrics_userCount = orgMetrics.userCount) !== null && _orgMetrics_userCount !== void 0 ? _orgMetrics_userCount : 0) >= 10 && ((_orgMetrics_totalRelationships = orgMetrics.totalRelationships) !== null && _orgMetrics_totalRelationships !== void 0 ? _orgMetrics_totalRelationships : 0) >= 5000) return 'SHOW_METRICS';
    return 'GETTING_STARTED';
};
var evaluateExperienceState = function(metrics, selectedSections) {
    // If metrics is null or NoDataResponse, return GETTING_STARTED.
    if (metrics == null || isNoDataResponse(metrics)) return 'GETTING_STARTED';
    // Tier 2 scale gate: org must have >= 10 seats and >= 5,000 relationships.
    if (evaluateOrgTier(metrics) === 'GETTING_STARTED') return 'GETTING_STARTED';
    // If selected sections are provided and all are empty, return GETTING_STARTED.
    if (selectedSections) {
        var allEmpty = selectedSections.intro.length === 0 && selectedSections.graphShape.length === 0 && selectedSections.graphConnectivity.length === 0;
        if (allEmpty) return 'GETTING_STARTED';
    }
    return 'SHOW_METRICS';
};
var selectMetrics = function(metrics, options) {
    // If metrics is null or NoDataResponse, return empty result with GETTING_STARTED state.
    if (metrics == null || isNoDataResponse(metrics)) {
        var emptySections = {
            intro: [],
            graphShape: [],
            graphConnectivity: []
        };
        return {
            state: 'GETTING_STARTED',
            sections: Object.freeze(emptySections)
        };
    }
    // Cast to OrgMetricsResponse now that we know it's not null/NoData.
    var metricsData = metrics;
    // Resolve which sections to compute. Undefined/empty `options.sections` means "all sections"
    // so the default call signature behaves identically to the pre-options implementation.
    var requestedSections = (options === null || options === void 0 ? void 0 : options.sections) && options.sections.length > 0 ? new Set(options.sections) : new Set([
        'intro',
        'graphShape',
        'graphConnectivity'
    ]);
    var ignoreFloor = (options === null || options === void 0 ? void 0 : options.ignoreFloor) === true;
    // Section capacity limits.
    var sectionCaps = {
        intro: Infinity,
        graphShape: 8,
        graphConnectivity: 4
    };
    // Collect selected metrics per section.
    var selectedBySection = {
        intro: [],
        graphShape: [],
        graphConnectivity: []
    };
    // Process each descriptor array in order.
    var descriptorArrays = [
        INTRO_METRICS,
        GRAPH_SHAPE_METRICS,
        GRAPH_CONNECTIVITY_METRICS
    ];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator = descriptorArrays[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
            var descriptorArray = _step.value;
            try {
                for(var _iterator1 = descriptorArray[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                    var descriptor = _step1.value;
                    var section = descriptor.section;
                    // Skip if this section was not requested.
                    if (!requestedSections.has(section)) continue;
                    // Skip if we've already hit the cap for this section.
                    if (selectedBySection[section].length >= sectionCaps[section]) continue;
                    // Extract the value.
                    var value = extractValue(metricsData, descriptor);
                    // Skip if value is null or — unless explicitly ignored — doesn't pass the floor.
                    if (value === null) continue;
                    if (!ignoreFloor && !passesFloor(value, descriptor.floor)) continue;
                    // Build and add the selected metric. `values` carries any extra ICU placeholders
                    // resolved from `descriptor.extraValues` so consumers can spread them straight into
                    // `<FormattedMessage values={{ value: stat.value, ...stat.values }} />`.
                    var selected = {
                        id: descriptor.id,
                        section: section,
                        value: value,
                        copyKey: descriptor.copyKey,
                        values: Object.freeze(extractExtraValues(metricsData, descriptor)),
                        icon: descriptor.icon
                    };
                    selectedBySection[section].push(selected);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    // Convert to readonly record and evaluate state.
    var sections = {
        intro: Object.freeze(selectedBySection.intro),
        graphShape: Object.freeze(selectedBySection.graphShape),
        graphConnectivity: Object.freeze(selectedBySection.graphConnectivity)
    };
    var state = evaluateExperienceState(metricsData, sections);
    return {
        state: state,
        sections: Object.freeze(sections)
    };
};
var selectAllMetrics = function(metrics) {
    if (metrics == null || isNoDataResponse(metrics)) return null;
    return metrics;
};

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_to_consumable_array":"1eSZf","@swc/helpers/_/_type_of":"iFJdx","@atlaskit/icon-lab/core/video-clip":"iUQeI","@atlaskit/icon/core/comment":"fIzVb","@atlaskit/icon/core/link":"dXcsA","@atlaskit/icon/core/page":"enPLB","@atlaskit/icon/core/people-group":"bR2TU","@atlaskit/icon/core/search":"3ZOPW","@atlaskit/icon/core/task":"1iEfu","@atlaskit/icon/core/teams":"8BW7M","@atlassian/twg-common":"7BO56","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iUQeI":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fe61b72b13c6065e67933b6fcf6ec77a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("28fc422377cd1198"));
var _baseNew = _interopRequireDefault(require("9effccca67a55944"));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoClip".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Known uses: add clip in Loom video editor
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ var VideoClipIcon = function(props) {
    return /*#__PURE__*/ _react.default.createElement(_baseNew.default, Object.assign({
        name: "VideoClipIcon",
        dangerouslySetGlyph: '<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1.125h1.25V2.5zm2.25 0v4.75h5.5V2.5zm7 0v1.625h1.25V3a.5.5 0 0 0-.5-.5zm1.25 3.125h-1.25V7.25h1.25zm0 3.125h-1.25v1.625h1.25zm0 3.125h-1.25V13.5H13a.5.5 0 0 0 .5-.5zM10.75 13.5V8.75h-5.5v4.75zm-7 0v-1.625H2.5V13a.5.5 0 0 0 .5.5zM2.5 10.375h1.25V8.75H2.5zm0-3.125h1.25V5.625H2.5z" clip-rule="evenodd"/>'
    }, props));
};
VideoClipIcon.displayName = 'VideoClipIcon';
var _default = exports.default = VideoClipIcon;

},{"28fc422377cd1198":"ltHCL","9effccca67a55944":"kuGeY"}],"fIzVb":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::33181fb6c3dda951a22e3b4873cc95fe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("d6ff4e9165e63ac7"));
var _baseNew = _interopRequireDefault(require("c9863227a21b2698"));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Comment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ var CommentIcon = function(props) {
    return /*#__PURE__*/ _react.default.createElement(_baseNew.default, Object.assign({
        name: "CommentIcon",
        dangerouslySetGlyph: '<path fill="currentcolor" fill-rule="evenodd" d="M0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2zM12 6.5H4V5h8zm-3 3H4V8h5z" clip-rule="evenodd"/>'
    }, props));
};
CommentIcon.displayName = 'CommentIcon';
var _default = exports.default = CommentIcon;

},{"d6ff4e9165e63ac7":"ltHCL","c9863227a21b2698":"kuGeY"}],"dXcsA":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f51e3026bdf0966f56fca36d1a42e0f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("e425ad6b7f4ec0a3"));
var _baseNew = _interopRequireDefault(require("a53d71c12ccb2ccc"));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ var LinkIcon = function(props) {
    return /*#__PURE__*/ _react.default.createElement(_baseNew.default, Object.assign({
        name: "LinkIcon",
        dangerouslySetGlyph: '<path fill="currentcolor" fill-rule="evenodd" d="M8.22 2.22a3.932 3.932 0 1 1 5.56 5.56l-2.25 2.25-1.06-1.06 2.25-2.25a2.432 2.432 0 0 0-3.44-3.44L7.03 5.53 5.97 4.47zm3.06 3.56-5.5 5.5-1.06-1.06 5.5-5.5zM2.22 8.22l2.25-2.25 1.06 1.06-2.25 2.25a2.432 2.432 0 0 0 3.44 3.44l2.25-2.25 1.06 1.06-2.25 2.25a3.932 3.932 0 1 1-5.56-5.56" clip-rule="evenodd"/>'
    }, props));
};
LinkIcon.displayName = 'LinkIcon';
var _default = exports.default = LinkIcon;

},{"e425ad6b7f4ec0a3":"ltHCL","a53d71c12ccb2ccc":"kuGeY"}],"enPLB":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a80f298c9d6e0d96eff1b09e3e1e4079>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("d7878d7fc6a5b54b"));
var _baseNew = _interopRequireDefault(require("92094151093ba503"));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Page".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ var PageIcon = function(props) {
    return /*#__PURE__*/ _react.default.createElement(_baseNew.default, Object.assign({
        name: "PageIcon",
        dangerouslySetGlyph: '<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM12 6H4V4.5h8zm-2 3.5H4V8h6z" clip-rule="evenodd"/>'
    }, props));
};
PageIcon.displayName = 'PageIcon';
var _default = exports.default = PageIcon;

},{"d7878d7fc6a5b54b":"ltHCL","92094151093ba503":"kuGeY"}],"bR2TU":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a53e84608f4cc80b860fc333251d7715>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("3592f7a02b95c3d4"));
var _baseNew = _interopRequireDefault(require("7ee680d5793cdca3"));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PeopleGroup".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ var PeopleGroupIcon = function(props) {
    return /*#__PURE__*/ _react.default.createElement(_baseNew.default, Object.assign({
        name: "PeopleGroupIcon",
        dangerouslySetGlyph: '<path fill="currentcolor" fill-rule="evenodd" d="M9 4.5a2 2 0 1 1 4 0 2 2 0 0 1-4 0M11 1a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M3 5.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0M4 3a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M2.625 9A2.625 2.625 0 0 0 0 11.625V13h1.5v-1.375c0-.621.504-1.125 1.125-1.125H5V9zM6 12.5A3.5 3.5 0 0 1 9.5 9h3a3.5 3.5 0 0 1 3.5 3.5V14h-1.5v-1.5a2 2 0 0 0-2-2h-3a2 2 0 0 0-2 2V14H6z" clip-rule="evenodd"/>'
    }, props));
};
PeopleGroupIcon.displayName = 'PeopleGroupIcon';
var _default = exports.default = PeopleGroupIcon;

},{"3592f7a02b95c3d4":"ltHCL","7ee680d5793cdca3":"kuGeY"}],"3ZOPW":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0ed30ba2fe598b1c691c4159780db191>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("c47300a755dc714a"));
var _baseNew = _interopRequireDefault(require("9cf87b5b6e70ab91"));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Search".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ var SearchIcon = function(props) {
    return /*#__PURE__*/ _react.default.createElement(_baseNew.default, Object.assign({
        name: "SearchIcon",
        dangerouslySetGlyph: '<path fill="currentcolor" fill-rule="evenodd" d="M7 2.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9M1 7a6 6 0 1 1 10.74 3.68l3.29 3.29-1.06 1.06-3.29-3.29A6 6 0 0 1 1 7" clip-rule="evenodd"/>'
    }, props));
};
SearchIcon.displayName = 'SearchIcon';
var _default = exports.default = SearchIcon;

},{"c47300a755dc714a":"ltHCL","9cf87b5b6e70ab91":"kuGeY"}],"1iEfu":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::511501585faa18257c05d7a2687e12c9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("9f3b8969bdaba9df"));
var _baseNew = _interopRequireDefault(require("9df2062383e934a7"));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Task".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tasks in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ var TaskIcon = function(props) {
    return /*#__PURE__*/ _react.default.createElement(_baseNew.default, Object.assign({
        name: "TaskIcon",
        dangerouslySetGlyph: '<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm9.326 2.98-5 6a.75.75 0 0 1-1.152 0l-2.5-3 1.152-.96L6.75 9.828l4.424-5.308z" clip-rule="evenodd"/>'
    }, props));
};
TaskIcon.displayName = 'TaskIcon';
var _default = exports.default = TaskIcon;

},{"9f3b8969bdaba9df":"ltHCL","9df2062383e934a7":"kuGeY"}],"8BW7M":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2f93b4fc46a2af93e5da0e2c365640ac>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("906fd237de813171"));
var _baseNew = _interopRequireDefault(require("af87e1349381166d"));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Teams".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for teams in Atlassian.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ var TeamsIcon = function(props) {
    return /*#__PURE__*/ _react.default.createElement(_baseNew.default, Object.assign({
        name: "TeamsIcon",
        dangerouslySetGlyph: '<path fill="currentcolor" fill-rule="evenodd" d="M4 2.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M1 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0m11-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M9 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0M3.75 9.5a2.25 2.25 0 0 0-2.25 2.25V13a.5.5 0 0 0 .5.5h4V15H2a2 2 0 0 1-2-2v-1.25A3.75 3.75 0 0 1 3.75 8h1.149a3.75 3.75 0 0 1 3.524 2.469l.564 1.55A2.25 2.25 0 0 0 11.1 13.5H14a.5.5 0 0 0 .5-.5v-1.25a2.25 2.25 0 0 0-2.25-2.25H12c-.775 0-1.258.06-1.531.112-.137.026-.22.05-.26.062l-.027.01.007-.003.01-.004.005-.003.003-.002h.002c.001-.001.001-.001-.334-.672l-.335-.671h.001l.002-.002.004-.001.008-.004.018-.008a1 1 0 0 1 .174-.066q.156-.053.44-.11C10.572 8.065 11.15 8 12 8h.25A3.75 3.75 0 0 1 16 11.75V13a2 2 0 0 1-2 2h-2.899a3.75 3.75 0 0 1-3.524-2.469l-.564-1.55A2.25 2.25 0 0 0 4.9 9.5z" clip-rule="evenodd"/>'
    }, props));
};
TeamsIcon.displayName = 'TeamsIcon';
var _default = exports.default = TeamsIcon;

},{"906fd237de813171":"ltHCL","af87e1349381166d":"kuGeY"}],"9imAr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isUserNoDataResponse", function() {
    return isUserNoDataResponse;
});
parcelHelpers.export(exports, "requestUserMetrics", function() {
    return requestUserMetrics;
});
parcelHelpers.export(exports, "selectUserMetrics", function() {
    return selectUserMetrics;
});
parcelHelpers.export(exports, "getPagesCreated", function() {
    return getPagesCreated;
});
parcelHelpers.export(exports, "getWorkItemsCreated", function() {
    return getWorkItemsCreated;
});
parcelHelpers.export(exports, "getVideosCreated", function() {
    return getVideosCreated;
});
parcelHelpers.export(exports, "getCommentsCreated", function() {
    return getCommentsCreated;
});
parcelHelpers.export(exports, "getDesignsCreated", function() {
    return getDesignsCreated;
});
parcelHelpers.export(exports, "getPullRequestsCreated", function() {
    return getPullRequestsCreated;
});
parcelHelpers.export(exports, "getReleasesCreated", function() {
    return getReleasesCreated;
});
parcelHelpers.export(exports, "getWhiteboardsCreated", function() {
    return getWhiteboardsCreated;
});
parcelHelpers.export(exports, "getDatabasesCreated", function() {
    return getDatabasesCreated;
});
parcelHelpers.export(exports, "getSpacesCreated", function() {
    return getSpacesCreated;
});
parcelHelpers.export(exports, "getGoalsCreated", function() {
    return getGoalsCreated;
});
parcelHelpers.export(exports, "getProjectsCreated", function() {
    return getProjectsCreated;
});
parcelHelpers.export(exports, "getFocusAreasCreated", function() {
    return getFocusAreasCreated;
});
parcelHelpers.export(exports, "getGoalUpdatesCreated", function() {
    return getGoalUpdatesCreated;
});
parcelHelpers.export(exports, "getProjectUpdatesCreated", function() {
    return getProjectUpdatesCreated;
});
parcelHelpers.export(exports, "getMessagesCreated", function() {
    return getMessagesCreated;
});
parcelHelpers.export(exports, "getBranchesCreated", function() {
    return getBranchesCreated;
});
parcelHelpers.export(exports, "getCommitsCreated", function() {
    return getCommitsCreated;
});
parcelHelpers.export(exports, "getTotalContributions", function() {
    return getTotalContributions;
});
parcelHelpers.export(exports, "getThirdPartyProviders", function() {
    return getThirdPartyProviders;
});
parcelHelpers.export(exports, "getThirdPartyEventTotal", function() {
    return getThirdPartyEventTotal;
});
parcelHelpers.export(exports, "getAllProviders", function() {
    return getAllProviders;
});
parcelHelpers.export(exports, "getThirdPartyDistinctCount", function() {
    return getThirdPartyDistinctCount;
});
parcelHelpers.export(exports, "getRelationshipsCreated180d", function() {
    return getRelationshipsCreated180d;
});
parcelHelpers.export(exports, "evaluateUserTier", function() {
    return evaluateUserTier;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var _twgCommon = require("@atlassian/twg-common");
var isUserNoDataResponse = function(metrics) {
    return metrics != null && (typeof metrics === "undefined" ? "undefined" : (0, _typeOf._)(metrics)) === 'object' && metrics.status === 'NO_DATA';
};
// ============================================================================
// Constants
// ============================================================================
/**
 * Provider keys whose presence and entity-type vocabulary are guaranteed by
 * the BE. Anything not in this set is treated as a third-party integration
 * for the purposes of `provider3p…` derivations below.
 */ var FIRST_PARTY_PROVIDERS = new Set([
    'confluence',
    'jira',
    'loom',
    'atlas',
    'code'
]);
/**
 * Spec cap on `X-Top-Collaborators` header — the BE will reject anything
 * over five entries, so we trim defensively client-side.
 */ var MAX_TOP_COLLABORATORS = 5;
var requestUserMetrics = function(orgId, cloudId, topCollaboratorAris, groups) {
    var headers = {
        'X-Query-Context': "ari:cloud:platform::site/".concat(cloudId)
    };
    if (topCollaboratorAris && topCollaboratorAris.length > 0) headers['X-Top-Collaborators'] = topCollaboratorAris.slice(0, MAX_TOP_COLLABORATORS).join(',');
    // Append `?groups=…` so the BE can short-circuit the expensive batches
    // the caller doesn't need yet. Per the integration guide, omitting
    // the param entirely runs all groups; unknown values are silently
    // ignored. Dedupe + sort for a stable URL (helps caching layers).
    var groupsParam = groups && groups.length > 0 ? "&groups=".concat(Array.from(new Set(groups)).sort().join(',')) : '';
    var _requestWithAbort = (0, _twgCommon.requestWithAbort)('GET', "/gateway/api/twg-api/v1/microsite/metrics/user?organisationId=".concat(orgId).concat(groupsParam), null, headers, [
        200,
        404
    ]), controller = _requestWithAbort.controller, execute = _requestWithAbort.execute;
    return {
        controller: controller,
        execute: execute
    };
};
var selectUserMetrics = function(metrics) {
    if (metrics == null || isUserNoDataResponse(metrics)) return null;
    return metrics;
};
// ============================================================================
// Derivation Helpers
// ============================================================================
// The Flock-backed endpoint no longer returns hand-rolled top-level counts
// (pagesCreated180d, commentsCreated180d, …). Per the integration guide, the
// FE derives them from `relationshipsByProvider`. The helpers below are the
// canonical derivation surface — UI code should never reach into the raw
// `relationshipsByProvider` map directly.
var getProviderEntityCount = function(rbp, provider, entityType) {
    var _rbp_provider;
    var value = (_rbp_provider = rbp[provider]) === null || _rbp_provider === void 0 ? void 0 : _rbp_provider[entityType];
    return typeof value === 'number' ? value : 0;
};
/**
 * Sum a single entity type across every third-party provider in the
 * response. Used for headline counts (designs, pull requests, …) that
 * have no first-party equivalent.
 */ var sumThirdPartyEntityType = function(rbp, entityType) {
    var total = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(rbp)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, _slicedToArray._)(_step.value, 2), provider = _step_value[0], entityTypes = _step_value[1];
            if (FIRST_PARTY_PROVIDERS.has(provider)) continue;
            var value = entityTypes[entityType];
            if (typeof value === 'number') total += value;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return total;
};
var getPagesCreated = function(rbp) {
    var total = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.values(rbp)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var entityTypes = _step.value;
            var value = entityTypes.page;
            if (typeof value === 'number') total += value;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return total;
};
var getWorkItemsCreated = function(rbp) {
    return getProviderEntityCount(rbp, 'jira', 'workItem');
};
var getVideosCreated = function(rbp) {
    return getProviderEntityCount(rbp, 'loom', 'video');
};
var getCommentsCreated = function(rbp) {
    var total = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.values(rbp)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var entityTypes = _step.value;
            var value = entityTypes.comment;
            if (typeof value === 'number') total += value;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return total;
};
var getDesignsCreated = function(rbp) {
    return sumThirdPartyEntityType(rbp, 'design');
};
var getPullRequestsCreated = function(rbp) {
    return sumThirdPartyEntityType(rbp, 'pullRequest');
};
var getReleasesCreated = function(rbp) {
    return getProviderEntityCount(rbp, 'jira', 'release');
};
var getWhiteboardsCreated = function(rbp) {
    return getProviderEntityCount(rbp, 'confluence', 'whiteboard');
};
var getDatabasesCreated = function(rbp) {
    return getProviderEntityCount(rbp, 'confluence', 'database');
};
var getSpacesCreated = function(rbp) {
    return getProviderEntityCount(rbp, 'confluence', 'space');
};
var getGoalsCreated = function(rbp) {
    return getProviderEntityCount(rbp, 'atlas', 'goal');
};
var getProjectsCreated = function(rbp) {
    return getProviderEntityCount(rbp, 'atlas', 'project');
};
var getFocusAreasCreated = function(rbp) {
    return getProviderEntityCount(rbp, 'atlas', 'focusArea');
};
var getGoalUpdatesCreated = function(rbp) {
    return getProviderEntityCount(rbp, 'atlas', 'goalUpdate');
};
var getProjectUpdatesCreated = function(rbp) {
    return getProviderEntityCount(rbp, 'atlas', 'projectUpdate');
};
var getMessagesCreated = function(rbp) {
    var total = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.values(rbp)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var entityTypes = _step.value;
            var value = entityTypes.message;
            if (typeof value === 'number') total += value;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return total;
};
var getBranchesCreated = function(rbp) {
    return sumThirdPartyEntityType(rbp, 'branch');
};
var getCommitsCreated = function(rbp) {
    return sumThirdPartyEntityType(rbp, 'commit');
};
var getTotalContributions = function(rbp) {
    var total = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.values(rbp)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var entityTypes = _step.value;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = Object.values(entityTypes)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var value = _step1.value;
                    if (typeof value === 'number') total += value;
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return total;
};
var getThirdPartyProviders = function(rbp) {
    var providers = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(rbp)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, _slicedToArray._)(_step.value, 2), providerName = _step_value[0], entityTypes = _step_value[1];
            if (FIRST_PARTY_PROVIDERS.has(providerName)) continue;
            var events180d = 0;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = Object.values(entityTypes)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var value = _step1.value;
                    if (typeof value === 'number') events180d += value;
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            if (events180d > 0) providers.push({
                providerName: providerName,
                events180d: events180d
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    providers.sort(function(a, b) {
        return b.events180d - a.events180d;
    });
    return providers;
};
var getThirdPartyEventTotal = function(rbp) {
    return getThirdPartyProviders(rbp).reduce(function(sum, p) {
        return sum + p.events180d;
    }, 0);
};
var getAllProviders = function(rbp) {
    var providers = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(rbp)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, _slicedToArray._)(_step.value, 2), providerName = _step_value[0], entityTypes = _step_value[1];
            var events180d = 0;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = Object.values(entityTypes)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var value = _step1.value;
                    if (typeof value === 'number') events180d += value;
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            if (events180d > 0) providers.push({
                providerName: providerName,
                events180d: events180d
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    providers.sort(function(a, b) {
        return b.events180d - a.events180d;
    });
    return providers;
};
var getThirdPartyDistinctCount = function(rbp) {
    return getThirdPartyProviders(rbp).length;
};
var getRelationshipsCreated180d = function(value) {
    if (typeof value === 'number') return Number.isFinite(value) ? value : null;
    if (typeof value === 'string') {
        var trimmedValue = value.trim();
        if (!trimmedValue) return null;
        var parsedValue = Number(trimmedValue);
        return Number.isFinite(parsedValue) ? parsedValue : null;
    }
    return null;
};
// ============================================================================
// Tier 1 Gating
// ============================================================================
var ACCOUNT_MATURITY_DAYS = 30;
var USER_METRIC_COVERAGE_FLOORS = [
    {
        label: 'pagesCreated',
        floor: 10,
        derive: function(r) {
            return getPagesCreated(r.relationshipsByProvider);
        }
    },
    {
        label: 'commentsCreated',
        floor: 30,
        derive: function(r) {
            return getCommentsCreated(r.relationshipsByProvider);
        }
    },
    {
        label: 'workItemsCreated',
        floor: 20,
        derive: function(r) {
            return getWorkItemsCreated(r.relationshipsByProvider);
        }
    },
    {
        label: 'videosCreated',
        floor: 23,
        derive: function(r) {
            return getVideosCreated(r.relationshipsByProvider);
        }
    },
    {
        label: 'designsCreated',
        floor: 5,
        derive: function(r) {
            return getDesignsCreated(r.relationshipsByProvider);
        }
    },
    {
        label: 'prsCreated',
        floor: 16,
        derive: function(r) {
            return getPullRequestsCreated(r.relationshipsByProvider);
        }
    },
    {
        label: 'relationshipsCreated180d',
        floor: 1,
        derive: function(r) {
            return getRelationshipsCreated180d(r.relationshipsCreated180d);
        }
    },
    {
        label: 'totalItemsCreated',
        floor: 1,
        derive: function(r) {
            return getTotalContributions(r.relationshipsByProvider);
        }
    },
    {
        label: 'thirdPartyEventsTotal',
        floor: 1,
        derive: function(r) {
            return getThirdPartyEventTotal(r.relationshipsByProvider);
        }
    },
    {
        label: 'thirdPartyDistinctCount',
        floor: 1,
        derive: function(r) {
            return getThirdPartyDistinctCount(r.relationshipsByProvider);
        }
    }
];
var MIN_COVERAGE = 5;
var evaluateUserTier = function(metrics, accountCreatedAt) {
    var userMetrics = selectUserMetrics(metrics);
    if (!userMetrics) return false;
    // Gate 1: account maturity — fail safe if date is missing or unparseable
    if (!accountCreatedAt) return false;
    var createdAtMs = Date.parse(accountCreatedAt);
    if (!Number.isFinite(createdAtMs)) return false;
    var ageDays = (Date.now() - createdAtMs) / 86400000;
    if (ageDays < ACCOUNT_MATURITY_DAYS) return false;
    // Gate 2: metric coverage
    var passingMetricCount = USER_METRIC_COVERAGE_FLOORS.filter(function(param) {
        var derive = param.derive, floor = param.floor;
        var value = derive(userMetrics);
        return typeof value === 'number' && value >= floor;
    }).length;
    return passingMetricCount >= MIN_COVERAGE;
};

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_type_of":"iFJdx","@atlassian/twg-common":"7BO56","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5RRMs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "STATIC_TIER1_DATASETS", function() {
    return STATIC_TIER1_DATASETS;
});
parcelHelpers.export(exports, "TIER_3_USER_DATASET", function() {
    return TIER_3_USER_DATASET;
});
parcelHelpers.export(exports, "STATIC_TIER1_DATASET_LIST", function() {
    return STATIC_TIER1_DATASET_LIST;
});
parcelHelpers.export(exports, "STATIC_TIER2_DATASETS", function() {
    return STATIC_TIER2_DATASETS;
});
parcelHelpers.export(exports, "STATIC_TIER2_DATASET_LIST", function() {
    return STATIC_TIER2_DATASET_LIST;
});
parcelHelpers.export(exports, "STATIC_TIER3_DATASETS", function() {
    return STATIC_TIER3_DATASETS;
});
parcelHelpers.export(exports, "STATIC_TIER3_DATASET_LIST", function() {
    return STATIC_TIER3_DATASET_LIST;
});
parcelHelpers.export(exports, "STATIC_COLLABORATION_USERS", function() {
    return STATIC_COLLABORATION_USERS;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _messages = require("./messages");
/**
 * Wrap a raw ARI in a `SharedWorkEntity` for the static datasets. The
 * Flock-backed BE now returns hydrated objects (with `displayName`,
 * `url`, `__typename`, etc.) per the integration guide; the debug
 * fixtures never hit the network so we synthesise a plausible-looking
 * payload from the ARI alone.
 *
 * - `__typename` is best-effort derived from the ARI's resource segment
 *   (e.g. `ari:cloud:confluence:…:page/…` → `'page'`). Consumers like
 *   `getProductLogoUrl` look at the ARI prefix first, so a precise
 *   `__typename` is not required to render the right logo.
 * - `displayName` is a humanised tail of the ARI so the UI has
 *   *something* meaningful to show; engineers wanting realistic copy
 *   should override the field directly in the dataset.
 * - `url` is set to `'#'` so links render but never navigate during
 *   static preview.
 */ var sharedItem = function(ari, overrides) {
    var _ari_split_pop;
    var _ari_split_pop_split_pop;
    var resourceSegment = (_ari_split_pop_split_pop = (_ari_split_pop = ari.split('::').pop()) === null || _ari_split_pop === void 0 ? void 0 : _ari_split_pop.split(':').pop()) !== null && _ari_split_pop_split_pop !== void 0 ? _ari_split_pop_split_pop : '';
    var _resourceSegment_split = (0, _slicedToArray._)(resourceSegment.split('/'), 2), typenameFromAri = _resourceSegment_split[0], tmp = _resourceSegment_split[1], idTail = tmp === void 0 ? '' : tmp;
    return (0, _objectSpread._)({
        ari: ari,
        __typename: typenameFromAri,
        displayName: idTail || ari,
        url: '#'
    }, overrides);
};
var TIER1_COMPUTED_AT = '2026-05-02T12:32:06.945Z';
/**
 * Batch outcomes used by every Tier 1 fixture. The static datasets are
 * always "fully successful" so the debug panel preview never has to render
 * the partial-failure UI by accident — engineers verifying that branch
 * should construct an ad-hoc payload instead of relying on these.
 */ var TIER1_BATCH_OUTCOMES_FULFILLED = {
    relationshipsByProvider: 'fulfilled',
    peopleWorkedWith: 'fulfilled',
    relationshipsCreated180d: 'fulfilled'
};
/**
 * Sample collaborator ARIs used by every Tier 1 fixture's
 * `workByCollaborators` map. Mirrors the first three entries of
 * `STATIC_COLLABORATION_USERS` so the demo data is internally consistent.
 */ var TIER1_COLLABORATOR_ARIS = [
    'ari:cloud:identity::user/712020:fe8c7aeb-92b9-4075-bfed-e4d859bb587f',
    'ari:cloud:identity::user/70121:f604320b-d57f-4347-9af4-6134863803c2',
    'ari:cloud:identity::user/63749bac9960988ef6bc6096'
];
var _obj, _obj1, _obj2;
var STATIC_TIER1_DATASETS = {
    powerUser: {
        key: 'powerUser',
        label: (0, _messages.messages).datasetTier1PowerUserLabel,
        description: (0, _messages.messages).datasetTier1PowerUserDescription,
        metrics: {
            workByCollaborators: {
                'ari:cloud:identity::user/712020:fe8c7aeb-92b9-4075-bfed-e4d859bb587f': [
                    sharedItem('ari:cloud:confluence:DUMMY-a5a01d21-1cc3-4f29-9565-f2bb8cd969f5:page/455657226241')
                ],
                'ari:cloud:identity::user/70121:f604320b-d57f-4347-9af4-6134863803c2': [
                    sharedItem('ari:cloud:confluence:DUMMY-a5a01d21-1cc3-4f29-9565-f2bb8cd969f5:page/455593164839'),
                    sharedItem('ari:cloud:confluence:DUMMY-a5a01d21-1cc3-4f29-9565-f2bb8cd969f5:page/455593197628')
                ],
                'ari:cloud:identity::user/63749bac9960988ef6bc6096': [
                    sharedItem('ari:cloud:jira:DUMMY-a5a01d21-1cc3-4f29-9565-f2bb8cd969f5:issue/12553'),
                    sharedItem('ari:cloud:townsquare:DUMMY-a5a01d21-1cc3-4f29-9565-f2bb8cd969f5:project/82911173-82cc-431f-baf4-1bb758b3c7be')
                ]
            },
            relationshipsByProvider: {
                confluence: {
                    page: 312,
                    comment: 600,
                    whiteboard: 12,
                    space: 4,
                    database: 0
                },
                'jira-dc': {
                    workItem: 427,
                    comment: 400,
                    release: 18
                },
                loom: {
                    video: 96,
                    comment: 8
                },
                atlas: {
                    goal: 14,
                    project: 26,
                    focusArea: 6,
                    goalUpdate: 38,
                    projectUpdate: 56,
                    comment: 12
                },
                code: {
                    comment: 184
                },
                github: {
                    pullRequest: 214,
                    commit: 712,
                    branch: 96,
                    repository: 8
                },
                figma: {
                    design: 38
                },
                slack: {
                    message: 5482
                },
                'google-drive': {
                    page: 3174
                }
            },
            peopleWorkedWithCount: 87,
            relationshipsCreated180d: 184220,
            computedAt: TIER1_COMPUTED_AT,
            meta: {
                batchOutcomes: TIER1_BATCH_OUTCOMES_FULFILLED
            }
        }
    },
    engineerIC: {
        key: 'engineerIC',
        label: (0, _messages.messages).datasetTier1EngineerICLabel,
        description: (0, _messages.messages).datasetTier1EngineerICDescription,
        metrics: {
            workByCollaborators: (_obj = {}, (0, _defineProperty._)(_obj, TIER1_COLLABORATOR_ARIS[0], [
                sharedItem('ari:cloud:bitbucket:DUMMY-engineerIC:repository/twg-api'),
                sharedItem('ari:cloud:jira:DUMMY-engineerIC:issue/ENG-2118')
            ]), (0, _defineProperty._)(_obj, TIER1_COLLABORATOR_ARIS[1], [
                sharedItem('ari:cloud:jira:DUMMY-engineerIC:issue/ENG-2204')
            ]), _obj),
            relationshipsByProvider: {
                confluence: {
                    page: 58,
                    comment: 380,
                    whiteboard: 4,
                    space: 1
                },
                jira: {
                    workItem: 198,
                    comment: 280,
                    release: 8
                },
                loom: {
                    video: 28,
                    comment: 2
                },
                atlas: {
                    goal: 0,
                    project: 1,
                    focusArea: 0,
                    goalUpdate: 1,
                    projectUpdate: 4,
                    comment: 4
                },
                code: {
                    comment: 76
                },
                github: {
                    pullRequest: 163,
                    commit: 540,
                    branch: 72,
                    repository: 5
                },
                figma: {
                    design: 8
                },
                slack: {
                    message: 1874
                },
                sentry: {
                    workItem: 231
                }
            },
            peopleWorkedWithCount: 42,
            relationshipsCreated180d: 61440,
            computedAt: TIER1_COMPUTED_AT,
            meta: {
                batchOutcomes: TIER1_BATCH_OUTCOMES_FULFILLED
            }
        }
    },
    designerIC: {
        key: 'designerIC',
        label: (0, _messages.messages).datasetTier1DesignerICLabel,
        description: (0, _messages.messages).datasetTier1DesignerICDescription,
        metrics: {
            workByCollaborators: (_obj1 = {}, (0, _defineProperty._)(_obj1, TIER1_COLLABORATOR_ARIS[0], [
                sharedItem('ari:cloud:figma:DUMMY-designerIC:design/teamwork-graph-system'),
                sharedItem('ari:cloud:confluence:DUMMY-designerIC:page/8842055120')
            ]), (0, _defineProperty._)(_obj1, TIER1_COLLABORATOR_ARIS[2], [
                sharedItem('ari:cloud:figma:DUMMY-designerIC:design/microsite-tier1-flow')
            ]), _obj1),
            relationshipsByProvider: {
                confluence: {
                    page: 74,
                    comment: 240,
                    whiteboard: 8,
                    space: 1
                },
                jira: {
                    workItem: 46,
                    comment: 80
                },
                loom: {
                    video: 84,
                    comment: 16
                },
                atlas: {
                    goal: 4,
                    project: 8,
                    projectUpdate: 12,
                    comment: 6
                },
                code: {
                    comment: 0
                },
                github: {
                    pullRequest: 17,
                    commit: 24,
                    branch: 6,
                    repository: 2
                },
                figma: {
                    design: 192
                },
                slack: {
                    message: 1102
                },
                'google-drive': {
                    page: 842
                }
            },
            peopleWorkedWithCount: 35,
            relationshipsCreated180d: 42118,
            computedAt: TIER1_COMPUTED_AT,
            meta: {
                batchOutcomes: TIER1_BATCH_OUTCOMES_FULFILLED
            }
        }
    },
    productLead: {
        key: 'productLead',
        label: (0, _messages.messages).datasetTier1ProductLeadLabel,
        description: (0, _messages.messages).datasetTier1ProductLeadDescription,
        metrics: {
            workByCollaborators: (_obj2 = {}, (0, _defineProperty._)(_obj2, TIER1_COLLABORATOR_ARIS[0], [
                sharedItem('ari:cloud:townsquare:DUMMY-productLead:project/h2-roadmap'),
                sharedItem('ari:cloud:confluence:DUMMY-productLead:page/8842061177')
            ]), (0, _defineProperty._)(_obj2, TIER1_COLLABORATOR_ARIS[1], [
                sharedItem('ari:cloud:jira:DUMMY-productLead:issue/PRD-908')
            ]), (0, _defineProperty._)(_obj2, TIER1_COLLABORATOR_ARIS[2], [
                sharedItem('ari:cloud:townsquare:DUMMY-productLead:goal/north-star-2026')
            ]), _obj2),
            relationshipsByProvider: {
                confluence: {
                    page: 204,
                    comment: 540,
                    whiteboard: 6,
                    space: 2
                },
                jira: {
                    workItem: 316,
                    comment: 320
                },
                loom: {
                    video: 58,
                    comment: 8
                },
                atlas: {
                    goal: 8,
                    project: 18,
                    focusArea: 4,
                    goalUpdate: 22,
                    projectUpdate: 34,
                    comment: 18
                },
                code: {
                    comment: 110
                },
                github: {
                    pullRequest: 21,
                    commit: 38,
                    branch: 4,
                    repository: 1
                },
                figma: {
                    design: 9
                },
                slack: {
                    message: 4318
                },
                'google-calendar': {
                    calendarEvent: 1274
                },
                'google-drive': {
                    page: 1623
                }
            },
            peopleWorkedWithCount: 64,
            relationshipsCreated180d: 38742,
            computedAt: TIER1_COMPUTED_AT,
            meta: {
                batchOutcomes: TIER1_BATCH_OUTCOMES_FULFILLED
            }
        }
    },
    newContributor: {
        key: 'newContributor',
        label: (0, _messages.messages).datasetTier1NewContributorLabel,
        description: (0, _messages.messages).datasetTier1NewContributorDescription,
        metrics: {
            // New contributor naturally works alone — leave
            // `workByCollaborators` omitted to exercise the "header was sent
            // but no shared work found" branch downstream.
            relationshipsByProvider: {
                confluence: {
                    page: 4,
                    comment: 3,
                    whiteboard: 0
                },
                jira: {
                    workItem: 0,
                    comment: 2
                },
                loom: {
                    video: 0,
                    comment: 1
                },
                atlas: {
                    project: 0
                },
                code: {
                    comment: 4
                },
                github: {
                    pullRequest: 0,
                    commit: 0,
                    branch: 0,
                    repository: 0
                },
                figma: {
                    design: 0
                },
                slack: {
                    message: 3
                },
                'google-drive': {
                    page: 2
                }
            },
            peopleWorkedWithCount: 3,
            relationshipsCreated180d: 19,
            computedAt: TIER1_COMPUTED_AT,
            meta: {
                batchOutcomes: TIER1_BATCH_OUTCOMES_FULFILLED
            }
        }
    }
};
var TIER_3_USER_DATASET = {
    key: 'tier3Contributor',
    label: (0, _messages.messages).datasetTier1NewContributorLabel,
    description: (0, _messages.messages).datasetTier1NewContributorDescription,
    metrics: {
        // New contributor naturally works alone — leave
        // `workByCollaborators` omitted to exercise the "header was sent
        // but no shared work found" branch downstream.
        relationshipsByProvider: {
            confluence: {
                page: 4,
                comment: 3,
                whiteboard: 0
            },
            jira: {
                workItem: 0,
                comment: 2
            },
            loom: {
                video: 0,
                comment: 1
            }
        },
        peopleWorkedWithCount: 3,
        relationshipsCreated180d: 19,
        computedAt: TIER1_COMPUTED_AT,
        meta: {
            batchOutcomes: TIER1_BATCH_OUTCOMES_FULFILLED
        }
    }
};
var STATIC_TIER1_DATASET_LIST = [
    STATIC_TIER1_DATASETS.powerUser,
    STATIC_TIER1_DATASETS.engineerIC,
    STATIC_TIER1_DATASETS.designerIC,
    STATIC_TIER1_DATASETS.productLead,
    STATIC_TIER1_DATASETS.newContributor
];
var COMPUTED_AT = '2026-04-23T07:54:06.392+00:00';
var STATIC_TIER2_DATASETS = {
    /**
	 * Synthetic "Fast Med" healthcare tenant — every metric needed to
	 * exercise the inferred-1p-apps fallback in `ConnectedAppsSection`.
	 *
	 * The defining feature: `connectorObjectsByProvider: null`,
	 * `threePConnectorsInstalled: 0`, `connectorsActive28d: 0` —
	 * combined with a `KnowledgeSourcesAtom` that returns no connected
	 * apps, this triggers `infer1pAppsFromOrgMetrics` to surface
	 * Confluence (pages), Jira (work items), Loom (recordings),
	 * Bitbucket (jira-code-links) and Atlas (goal-work-item links) as
	 * the org's "favourite apps".
	 *
	 * Activity counts are deliberately mid-sized so the panel renders
	 * realistic numbers without dominating the rest of the dashboard.
	 */ fastMed: {
        key: 'fastMed',
        label: (0, _messages.messages).datasetFastMedLabel,
        description: (0, _messages.messages).datasetFastMedDescription,
        metrics: {
            activeContributors180d: 412,
            activeNodeTypes: 28,
            activeRelTypes: 96,
            activityDataAsOf: '2026-04-17',
            avgArtifactsPerIssue: 1.4,
            avgDailyJiraCodeLinkChange: 86,
            avgDailyNodeGrowth: 5210,
            avgDailyRelChange: 18430,
            avgFetchQueriesPerDay: 540,
            avgFetchQueriesPerSecond: 0.00625,
            avgJiraCodeLinkChangePerSecond: 0.001,
            avgNodeGrowthPerSecond: 0.0603,
            avgRelChangePerSecond: 0.2133,
            cacheStatus: null,
            collaboratorTeams: null,
            collaboratorTeamsTruncated: null,
            collaborators: null,
            commentsCreated180d: 14582,
            commentsDataAsOf: null,
            computedAt: COMPUTED_AT,
            connectorDataAsOf: null,
            // No 3P connectors — this is the gate that makes the
            // inferred-1p-apps fallback fire.
            connectorObjects180d: 0,
            connectorObjectsByProvider: null,
            connectorsActive28d: 0,
            connectorsDetail: null,
            connectorsInstalled: 0,
            daysSinceSnapshot: null,
            entitiesTouched: null,
            estimatedNodesNow: null,
            forgeAppsInstalled: null,
            // Atlas signal — goal ↔ work item links exist, so Atlas is
            // inferred.
            goalWorkItemLinks: 248,
            issueActivityDataAsOf: '2026-04-21',
            // Jira signal — work items moved forward.
            issuesMovedForward180d: 6842,
            // Bitbucket signal — Jira ↔ code links exist.
            jiraCodeLinks: 12540,
            loomDataAsOf: '2026-04-21T12:14:21.319+00:00',
            // Loom signal — recordings made in the last 180d.
            loomsRecorded180d: 318,
            marketplaceAddonsInstalled: 12,
            meetingMinutesSaved: 1240,
            meetingNotesDataAsOf: null,
            meetingNotesWithRecording180d: 22,
            nodeDataAsOf: '2026-04-18',
            onePAppsInstalled: 5,
            organisationId: 'fast-med-org-no-3p-fallback-fixture',
            // Confluence signal — pages created in the last 180d.
            pagesCreated180d: 8915,
            pagesDataAsOf: '2026-04-18',
            pctConnectorsActive28d: 0,
            queryDataAsOf: null,
            relDataAsOf: '2026-04-18',
            smartlinkDataAsOf: null,
            smartlinkPastes180d: 612,
            teamCount: 96,
            threePConnectorsInstalled: 0,
            totalAppsInstalled: 5,
            totalJiraIssues: 184320,
            totalMinutesRecorded: 1540,
            totalNodes: 612400,
            totalRelationships: 2184900,
            userCount: 845
        }
    },
    accenture: {
        key: 'accenture',
        label: (0, _messages.messages).datasetAccentureLabel,
        description: (0, _messages.messages).datasetAccentureDescription,
        metrics: {
            activeContributors180d: 0,
            activeNodeTypes: 71,
            activeRelTypes: 235,
            activityDataAsOf: '2026-04-17',
            avgArtifactsPerIssue: 0.7,
            avgDailyJiraCodeLinkChange: 1107,
            avgDailyNodeGrowth: 70638,
            avgDailyRelChange: 643225,
            avgFetchQueriesPerDay: 1421,
            avgFetchQueriesPerSecond: 0.0164,
            avgJiraCodeLinkChangePerSecond: 0.0128,
            avgNodeGrowthPerSecond: 0.8176,
            avgRelChangePerSecond: 7.4447,
            cacheStatus: null,
            collaboratorTeams: null,
            collaboratorTeamsTruncated: null,
            collaborators: null,
            commentsCreated180d: 29,
            commentsDataAsOf: null,
            computedAt: COMPUTED_AT,
            connectorDataAsOf: null,
            connectorObjects180d: 790,
            connectorObjectsByProvider: [
                {
                    providerName: 'Slack provider',
                    objects30d: 719
                },
                {
                    providerName: 'Figma',
                    objects30d: 71
                }
            ],
            connectorsActive28d: 0,
            connectorsDetail: null,
            connectorsInstalled: 0,
            daysSinceSnapshot: null,
            entitiesTouched: null,
            estimatedNodesNow: null,
            forgeAppsInstalled: null,
            goalWorkItemLinks: 4919,
            issueActivityDataAsOf: '2026-04-21',
            issuesMovedForward180d: 1855,
            jiraCodeLinks: 1136203,
            loomDataAsOf: '2026-04-21T12:14:21.319+00:00',
            loomsRecorded180d: 2,
            marketplaceAddonsInstalled: 292,
            meetingMinutesSaved: 48,
            meetingNotesDataAsOf: null,
            meetingNotesWithRecording180d: 0,
            nodeDataAsOf: '2026-04-18',
            onePAppsInstalled: 13,
            organisationId: 'a53d6b63-3k57-1408-j79d-0b60b08kb685',
            pagesCreated180d: 167966,
            pagesDataAsOf: '2026-04-18',
            pctConnectorsActive28d: 0,
            queryDataAsOf: null,
            relDataAsOf: '2026-04-18',
            smartlinkDataAsOf: null,
            smartlinkPastes180d: 0,
            teamCount: 13750,
            threePConnectorsInstalled: 0,
            totalAppsInstalled: 305,
            totalJiraIssues: 4844413,
            totalMinutesRecorded: 32,
            totalNodes: 24456310,
            totalRelationships: 107366741,
            userCount: 12358
        }
    },
    allegion: {
        key: 'allegion',
        label: (0, _messages.messages).datasetAllegionLabel,
        description: (0, _messages.messages).datasetAllegionDescription,
        metrics: {
            activeContributors180d: 1,
            activeNodeTypes: 51,
            activeRelTypes: 152,
            activityDataAsOf: '2026-04-19',
            avgArtifactsPerIssue: 2.8,
            avgDailyJiraCodeLinkChange: 312,
            avgDailyNodeGrowth: 1426,
            avgDailyRelChange: 13365,
            avgFetchQueriesPerDay: 6834,
            avgFetchQueriesPerSecond: 0.0791,
            avgJiraCodeLinkChangePerSecond: 0.0036,
            avgNodeGrowthPerSecond: 0.0165,
            avgRelChangePerSecond: 0.1547,
            cacheStatus: null,
            collaboratorTeams: null,
            collaboratorTeamsTruncated: null,
            collaborators: null,
            commentsCreated180d: 664,
            commentsDataAsOf: null,
            computedAt: COMPUTED_AT,
            connectorDataAsOf: null,
            connectorObjects180d: 107702,
            connectorObjectsByProvider: [
                {
                    providerName: 'GitHub for Jira',
                    objects30d: 106757
                },
                {
                    providerName: 'Figma',
                    objects30d: 589
                },
                {
                    providerName: 'Azure Devops provider',
                    objects30d: 243
                },
                {
                    providerName: 'Mural',
                    objects30d: 79
                },
                {
                    providerName: 'Bitbucket Pipelines Integration',
                    objects30d: 15
                },
                {
                    providerName: 'Gitlab provider',
                    objects30d: 8
                },
                {
                    providerName: 'Adobe',
                    objects30d: 7
                },
                {
                    providerName: 'Version Related Links app',
                    objects30d: 4
                }
            ],
            connectorsActive28d: 0,
            connectorsDetail: null,
            connectorsInstalled: 0,
            daysSinceSnapshot: null,
            entitiesTouched: null,
            estimatedNodesNow: null,
            forgeAppsInstalled: null,
            goalWorkItemLinks: 0,
            issueActivityDataAsOf: '2026-04-18',
            issuesMovedForward180d: 462,
            jiraCodeLinks: 31049,
            loomDataAsOf: null,
            loomsRecorded180d: 0,
            marketplaceAddonsInstalled: 4,
            meetingMinutesSaved: 0,
            meetingNotesDataAsOf: null,
            meetingNotesWithRecording180d: 0,
            nodeDataAsOf: '2026-04-18',
            onePAppsInstalled: 8,
            organisationId: 'b588d5e7-4ecd-4761-ba49-53e2027dea76',
            pagesCreated180d: 30399,
            pagesDataAsOf: '2026-04-19',
            pctConnectorsActive28d: 0,
            queryDataAsOf: '2026-04-19',
            relDataAsOf: '2026-04-19',
            smartlinkDataAsOf: null,
            smartlinkPastes180d: 0,
            teamCount: 98,
            threePConnectorsInstalled: 0,
            totalAppsInstalled: 12,
            totalJiraIssues: 17952,
            totalMinutesRecorded: 0,
            totalNodes: 315970,
            totalRelationships: 1369930,
            userCount: 138
        }
    },
    atlassian: {
        key: 'atlassian',
        label: (0, _messages.messages).datasetAtlassianLabel,
        description: (0, _messages.messages).datasetAtlassianDescription,
        metrics: {
            activeContributors180d: 7902,
            activeNodeTypes: 96,
            activeRelTypes: 356,
            activityDataAsOf: '2026-04-18',
            avgArtifactsPerIssue: 37.1,
            avgDailyJiraCodeLinkChange: 206668,
            avgDailyNodeGrowth: 9897860,
            avgDailyRelChange: 10361407,
            avgFetchQueriesPerDay: 6019720,
            avgFetchQueriesPerSecond: 69.6727,
            avgJiraCodeLinkChangePerSecond: 2.392,
            avgNodeGrowthPerSecond: 114.5586,
            avgRelChangePerSecond: 119.9237,
            cacheStatus: null,
            collaboratorTeams: null,
            collaboratorTeamsTruncated: null,
            collaborators: null,
            commentsCreated180d: 2258042,
            commentsDataAsOf: null,
            computedAt: COMPUTED_AT,
            connectorDataAsOf: null,
            connectorObjects180d: 9608,
            connectorObjectsByProvider: [
                {
                    providerName: 'Google Drive provider',
                    objects30d: 7392
                },
                {
                    providerName: 'Slack provider',
                    objects30d: 1740
                },
                {
                    providerName: 'Salesforce',
                    objects30d: 441
                },
                {
                    providerName: 'Docusign provider',
                    objects30d: 31
                },
                {
                    providerName: 'Bitbucket Pipelines Integration',
                    objects30d: 4
                }
            ],
            connectorsActive28d: 11,
            connectorsDetail: null,
            connectorsInstalled: 15,
            daysSinceSnapshot: null,
            entitiesTouched: null,
            estimatedNodesNow: null,
            forgeAppsInstalled: null,
            goalWorkItemLinks: 41083,
            issueActivityDataAsOf: '2026-04-18',
            issuesMovedForward180d: 317494,
            jiraCodeLinks: 56152610,
            loomDataAsOf: '2026-04-22T23:59:51.278+00:00',
            loomsRecorded180d: 132785,
            marketplaceAddonsInstalled: 5,
            meetingMinutesSaved: 3591291,
            meetingNotesDataAsOf: null,
            meetingNotesWithRecording180d: 1527,
            nodeDataAsOf: '2026-04-18',
            onePAppsInstalled: 9,
            organisationId: '2346a038-3c8c-498b-a79b-e7847859868d',
            pagesCreated180d: 5068524,
            pagesDataAsOf: '2026-04-18',
            pctConnectorsActive28d: 73.3,
            queryDataAsOf: '2026-04-18',
            relDataAsOf: '2026-04-18',
            smartlinkDataAsOf: null,
            smartlinkPastes180d: 52,
            teamCount: 26522,
            threePConnectorsInstalled: 15,
            totalAppsInstalled: 29,
            totalJiraIssues: 1739733,
            totalMinutesRecorded: 2394194,
            totalNodes: 1642078616,
            totalRelationships: 4465869234,
            userCount: 46491
        }
    },
    communardo: {
        key: 'communardo',
        label: (0, _messages.messages).datasetCommunardoLabel,
        description: (0, _messages.messages).datasetCommunardoDescription,
        metrics: {
            activeContributors180d: 31,
            activeNodeTypes: 66,
            activeRelTypes: 206,
            activityDataAsOf: '2026-04-18',
            avgArtifactsPerIssue: 7.1,
            avgDailyJiraCodeLinkChange: 94,
            avgDailyNodeGrowth: 1732,
            avgDailyRelChange: 115491,
            avgFetchQueriesPerDay: 29473,
            avgFetchQueriesPerSecond: 0.3411,
            avgJiraCodeLinkChangePerSecond: 0.0011,
            avgNodeGrowthPerSecond: 0.02,
            avgRelChangePerSecond: 1.3367,
            cacheStatus: null,
            collaboratorTeams: null,
            collaboratorTeamsTruncated: null,
            collaborators: null,
            commentsCreated180d: 5143,
            commentsDataAsOf: null,
            computedAt: COMPUTED_AT,
            connectorDataAsOf: null,
            connectorObjects180d: 2338235,
            connectorObjectsByProvider: [
                {
                    providerName: 'OneDrive provider',
                    objects30d: 1106642
                },
                {
                    providerName: 'Sharepoint provider',
                    objects30d: 630301
                },
                {
                    providerName: 'MS Teams provider',
                    objects30d: 550977
                },
                {
                    providerName: 'Bitbucket Pipelines Integration',
                    objects30d: 24752
                },
                {
                    providerName: 'Google Drive provider',
                    objects30d: 20483
                },
                {
                    providerName: 'Snyk Security in Jira Cloud',
                    objects30d: 3787
                },
                {
                    providerName: 'Jira-Cloud-Bitbucket-OnPrem',
                    objects30d: 742
                },
                {
                    providerName: 'Loom',
                    objects30d: 405
                },
                {
                    providerName: 'Figma',
                    objects30d: 65
                },
                {
                    providerName: 'Power-BI',
                    objects30d: 54
                },
                {
                    providerName: 'Version Related Links app',
                    objects30d: 27
                }
            ],
            connectorsActive28d: 2,
            connectorsDetail: null,
            connectorsInstalled: 3,
            daysSinceSnapshot: null,
            entitiesTouched: null,
            estimatedNodesNow: null,
            forgeAppsInstalled: null,
            goalWorkItemLinks: 160,
            issueActivityDataAsOf: '2026-04-18',
            issuesMovedForward180d: 6075,
            jiraCodeLinks: 85239,
            loomDataAsOf: '2026-04-17T14:36:42.367+00:00',
            loomsRecorded180d: 92,
            marketplaceAddonsInstalled: 60,
            meetingMinutesSaved: 5346,
            meetingNotesDataAsOf: null,
            meetingNotesWithRecording180d: 4,
            nodeDataAsOf: '2026-04-1',
            onePAppsInstalled: 11,
            organisationId: '3cc38732-6e1a-46de-9520-6365c14cc4ca',
            pagesCreated180d: 5287,
            pagesDataAsOf: '2026-04-18',
            pctConnectorsActive28d: 66.7,
            queryDataAsOf: '2026-04-18',
            relDataAsOf: '2026-04-18',
            smartlinkDataAsOf: null,
            smartlinkPastes180d: 0,
            teamCount: 76,
            threePConnectorsInstalled: 3,
            totalAppsInstalled: 74,
            totalJiraIssues: 31694,
            totalMinutesRecorded: 3564,
            totalNodes: 8072099,
            totalRelationships: 25013683,
            userCount: 680
        }
    },
    reddit: {
        key: 'reddit',
        label: (0, _messages.messages).datasetRedditLabel,
        description: (0, _messages.messages).datasetRedditDescription,
        metrics: {
            activeContributors180d: 40,
            activeNodeTypes: 65,
            activeRelTypes: 215,
            activityDataAsOf: '2026-04-18',
            avgArtifactsPerIssue: 21.2,
            avgDailyJiraCodeLinkChange: 3618,
            avgDailyNodeGrowth: 33617,
            avgDailyRelChange: 169455,
            avgFetchQueriesPerDay: 256704,
            avgFetchQueriesPerSecond: 2.9711,
            avgJiraCodeLinkChangePerSecond: 0.0419,
            avgNodeGrowthPerSecond: 0.3891,
            avgRelChangePerSecond: 1.9613,
            cacheStatus: null,
            collaboratorTeams: null,
            collaboratorTeamsTruncated: null,
            collaborators: null,
            commentsCreated180d: 18871,
            commentsDataAsOf: null,
            computedAt: COMPUTED_AT,
            connectorDataAsOf: null,
            connectorObjects180d: 14156619,
            connectorObjectsByProvider: [
                {
                    providerName: 'Zendesk provider',
                    objects30d: 7859462
                },
                {
                    providerName: 'Google Drive provider',
                    objects30d: 4533543
                },
                {
                    providerName: 'Google Calendar',
                    objects30d: 997478
                },
                {
                    providerName: 'GitHub for Jira',
                    objects30d: 545570
                },
                {
                    providerName: 'Slack provider',
                    objects30d: 200175
                },
                {
                    providerName: 'Loom',
                    objects30d: 19429
                },
                {
                    providerName: 'Figma',
                    objects30d: 471
                },
                {
                    providerName: 'Figma for Jira',
                    objects30d: 381
                },
                {
                    providerName: 'pagerduty',
                    objects30d: 74
                },
                {
                    providerName: 'Web Pages Provider',
                    objects30d: 29
                },
                {
                    providerName: 'Salesforce',
                    objects30d: 7
                }
            ],
            connectorsActive28d: 6,
            connectorsDetail: null,
            connectorsInstalled: 7,
            daysSinceSnapshot: null,
            entitiesTouched: null,
            estimatedNodesNow: null,
            forgeAppsInstalled: null,
            goalWorkItemLinks: 562,
            issueActivityDataAsOf: '2026-04-18',
            issuesMovedForward180d: 18519,
            jiraCodeLinks: 1553778,
            loomDataAsOf: '2026-04-18T00:34:13.240+00:00',
            loomsRecorded180d: 1941,
            marketplaceAddonsInstalled: 28,
            meetingMinutesSaved: 10366,
            meetingNotesDataAsOf: null,
            meetingNotesWithRecording180d: 0,
            nodeDataAsOf: '2026-04-18',
            onePAppsInstalled: 11,
            organisationId: '9d6f1fce-a96f-4999-9afb-7c1c9b6ee40b',
            pagesCreated180d: 1278,
            pagesDataAsOf: '2026-04-18',
            pctConnectorsActive28d: 85.7,
            queryDataAsOf: '2026-04-18',
            relDataAsOf: '2026-04-18',
            smartlinkDataAsOf: null,
            smartlinkPastes180d: 2,
            teamCount: 257,
            threePConnectorsInstalled: 7,
            totalAppsInstalled: 46,
            totalJiraIssues: 96065,
            totalMinutesRecorded: 6911,
            totalNodes: 23338742,
            totalRelationships: 77679572,
            userCount: 447
        }
    },
    procoreLargest: {
        key: 'procoreLargest',
        label: (0, _messages.messages).datasetProcoreLargestLabel,
        description: (0, _messages.messages).datasetProcoreLargestDescription,
        metrics: {
            activeContributors180d: 50,
            activeNodeTypes: 77,
            activeRelTypes: 272,
            activityDataAsOf: '2026-04-19',
            avgArtifactsPerIssue: 15.3,
            avgDailyJiraCodeLinkChange: 7253,
            avgDailyNodeGrowth: 36653,
            avgDailyRelChange: 253452,
            avgFetchQueriesPerDay: 397534,
            avgFetchQueriesPerSecond: 4.6011,
            avgJiraCodeLinkChangePerSecond: 0.0839,
            avgNodeGrowthPerSecond: 0.4242,
            avgRelChangePerSecond: 2.9335,
            cacheStatus: null,
            collaboratorTeams: null,
            collaboratorTeamsTruncated: null,
            collaborators: null,
            commentsCreated180d: 31176,
            commentsDataAsOf: null,
            computedAt: COMPUTED_AT,
            connectorDataAsOf: null,
            connectorObjects180d: 8642100,
            connectorObjectsByProvider: [
                {
                    providerName: 'Google Drive provider',
                    objects30d: 4509208
                },
                {
                    providerName: 'GitHub for Jira',
                    objects30d: 2735347
                },
                {
                    providerName: 'Workday',
                    objects30d: 1315602
                },
                {
                    providerName: 'Loom',
                    objects30d: 51897
                },
                {
                    providerName: 'Slack provider',
                    objects30d: 11053
                },
                {
                    providerName: 'Figma for Jira',
                    objects30d: 8444
                },
                {
                    providerName: 'Figma',
                    objects30d: 7814
                },
                {
                    providerName: 'LaunchDarkly',
                    objects30d: 2362
                },
                {
                    providerName: 'Jenkins',
                    objects30d: 273
                },
                {
                    providerName: 'Lucid provider',
                    objects30d: 71
                },
                {
                    providerName: 'Power-BI',
                    objects30d: 15
                },
                {
                    providerName: 'Amplitude',
                    objects30d: 6
                },
                {
                    providerName: 'LaunchDarkly for Jira',
                    objects30d: 4
                },
                {
                    providerName: 'Sharepoint provider',
                    objects30d: 3
                },
                {
                    providerName: 'Sentry',
                    objects30d: 1
                }
            ],
            connectorsActive28d: 2,
            connectorsDetail: null,
            connectorsInstalled: 4,
            daysSinceSnapshot: null,
            entitiesTouched: null,
            estimatedNodesNow: null,
            forgeAppsInstalled: null,
            goalWorkItemLinks: 2444,
            issueActivityDataAsOf: '2026-04-21',
            issuesMovedForward180d: 42805,
            jiraCodeLinks: 3481503,
            loomDataAsOf: '2026-04-22T23:48:47.695+00:00',
            loomsRecorded180d: 5006,
            marketplaceAddonsInstalled: 46,
            meetingMinutesSaved: 77785,
            meetingNotesDataAsOf: null,
            meetingNotesWithRecording180d: 31,
            nodeDataAsOf: '2026-04-18',
            onePAppsInstalled: 9,
            organisationId: 'd1de2e90-c8b6-4598-9400-85329abae8a8',
            pagesCreated180d: 5299,
            pagesDataAsOf: '2026-04-19',
            pctConnectorsActive28d: 50,
            queryDataAsOf: '2026-04-19',
            relDataAsOf: '2026-04-19',
            smartlinkDataAsOf: null,
            smartlinkPastes180d: 2,
            teamCount: 1734,
            threePConnectorsInstalled: 4,
            totalAppsInstalled: 59,
            totalJiraIssues: 287928,
            totalMinutesRecorded: 51856,
            totalNodes: 40400747,
            totalRelationships: 152234806,
            userCount: 771
        }
    },
    helloFresh: {
        key: 'helloFresh',
        label: (0, _messages.messages).datasetHelloFreshLabel,
        description: (0, _messages.messages).datasetHelloFreshDescription,
        metrics: {
            activeContributors180d: 5,
            activeNodeTypes: 53,
            activeRelTypes: 182,
            activityDataAsOf: '2026-04-18',
            avgArtifactsPerIssue: 14.9,
            avgDailyJiraCodeLinkChange: 3415,
            avgDailyNodeGrowth: 12374,
            avgDailyRelChange: 63107,
            avgFetchQueriesPerDay: 153295,
            avgFetchQueriesPerSecond: 1.7742,
            avgJiraCodeLinkChangePerSecond: 0.0395,
            avgNodeGrowthPerSecond: 0.1432,
            avgRelChangePerSecond: 0.7304,
            cacheStatus: null,
            collaboratorTeams: null,
            collaboratorTeamsTruncated: null,
            collaborators: null,
            commentsCreated180d: 17560,
            commentsDataAsOf: null,
            computedAt: COMPUTED_AT,
            connectorDataAsOf: null,
            connectorObjects180d: 2016164,
            connectorObjectsByProvider: [
                {
                    providerName: 'GitHub for Jira',
                    objects30d: 1862699
                },
                {
                    providerName: 'Google Drive provider',
                    objects30d: 144973
                },
                {
                    providerName: 'Slack provider',
                    objects30d: 4873
                },
                {
                    providerName: 'Figma',
                    objects30d: 2512
                },
                {
                    providerName: 'Miro provider',
                    objects30d: 649
                },
                {
                    providerName: 'Figma for Jira',
                    objects30d: 448
                },
                {
                    providerName: 'Box',
                    objects30d: 8
                },
                {
                    providerName: 'Version Related Links app',
                    objects30d: 2
                }
            ],
            connectorsActive28d: 0,
            connectorsDetail: null,
            connectorsInstalled: 1,
            daysSinceSnapshot: null,
            entitiesTouched: null,
            estimatedNodesNow: null,
            forgeAppsInstalled: null,
            goalWorkItemLinks: 2,
            issueActivityDataAsOf: '2026-04-18',
            issuesMovedForward180d: 24590,
            jiraCodeLinks: 2130875,
            loomDataAsOf: null,
            loomsRecorded180d: 0,
            marketplaceAddonsInstalled: 47,
            meetingMinutesSaved: 0,
            meetingNotesDataAsOf: null,
            meetingNotesWithRecording180d: 1,
            nodeDataAsOf: '2026-04-18',
            onePAppsInstalled: 7,
            organisationId: 'bbf8f438-d361-4796-8c68-08df9b370626',
            pagesCreated180d: 1579,
            pagesDataAsOf: '2026-04-18',
            pctConnectorsActive28d: 0,
            queryDataAsOf: '2026-04-18',
            relDataAsOf: '2026-04-18',
            smartlinkDataAsOf: null,
            smartlinkPastes180d: 0,
            teamCount: 1427,
            threePConnectorsInstalled: 1,
            totalAppsInstalled: 55,
            totalJiraIssues: 186994,
            totalMinutesRecorded: 0,
            totalNodes: 12155494,
            totalRelationships: 66735838,
            userCount: 634
        }
    },
    workday: {
        key: 'workday',
        label: (0, _messages.messages).datasetWorkdayLabel,
        description: (0, _messages.messages).datasetWorkdayDescription,
        metrics: {
            activeContributors180d: 1,
            activeNodeTypes: 48,
            activeRelTypes: 158,
            activityDataAsOf: '2026-04-19',
            avgArtifactsPerIssue: 17.8,
            avgDailyJiraCodeLinkChange: 781,
            avgDailyNodeGrowth: 1942,
            avgDailyRelChange: 14226,
            avgFetchQueriesPerDay: 118663,
            avgFetchQueriesPerSecond: 1.3734,
            avgJiraCodeLinkChangePerSecond: 0.009,
            avgNodeGrowthPerSecond: 0.0225,
            avgRelChangePerSecond: 0.1647,
            cacheStatus: null,
            collaboratorTeams: null,
            collaboratorTeamsTruncated: null,
            collaborators: null,
            commentsCreated180d: 8315,
            commentsDataAsOf: null,
            computedAt: COMPUTED_AT,
            connectorDataAsOf: null,
            connectorObjects180d: 140593,
            connectorObjectsByProvider: [
                {
                    providerName: 'GitHub for Jira',
                    objects30d: 81019
                },
                {
                    providerName: 'Google Drive provider',
                    objects30d: 56964
                },
                {
                    providerName: '__unknown__',
                    objects30d: 2196
                },
                {
                    providerName: 'Figma',
                    objects30d: 390
                },
                {
                    providerName: 'Version Related Links app',
                    objects30d: 12
                },
                {
                    providerName: 'Smartsheet provider',
                    objects30d: 12
                }
            ],
            connectorsActive28d: 0,
            connectorsDetail: null,
            connectorsInstalled: 0,
            daysSinceSnapshot: null,
            entitiesTouched: null,
            estimatedNodesNow: null,
            forgeAppsInstalled: null,
            goalWorkItemLinks: 0,
            issueActivityDataAsOf: '2026-04-19',
            issuesMovedForward180d: 13336,
            jiraCodeLinks: 400310,
            loomDataAsOf: null,
            loomsRecorded180d: 0,
            marketplaceAddonsInstalled: 23,
            meetingMinutesSaved: 0,
            meetingNotesDataAsOf: null,
            meetingNotesWithRecording180d: 0,
            nodeDataAsOf: '2026-04-18',
            onePAppsInstalled: 7,
            organisationId: 'f98b223b-a1fb-4b98-8b5c-81a6b3360896',
            pagesCreated180d: 174,
            pagesDataAsOf: '2026-04-18',
            pctConnectorsActive28d: 0,
            queryDataAsOf: '2026-04-19',
            relDataAsOf: '2026-04-19',
            smartlinkDataAsOf: null,
            smartlinkPastes180d: 0,
            teamCount: 202,
            threePConnectorsInstalled: 0,
            totalAppsInstalled: 30,
            totalJiraIssues: 43146,
            totalMinutesRecorded: 0,
            totalNodes: 1889990,
            totalRelationships: 7445978,
            userCount: 303
        }
    },
    workdayLargest: {
        key: 'workdayLargest',
        label: (0, _messages.messages).datasetWorkdayLargestLabel,
        description: (0, _messages.messages).datasetWorkdayLargestDescription,
        metrics: {
            activeContributors180d: 4,
            activeNodeTypes: 52,
            activeRelTypes: 192,
            activityDataAsOf: '2026-04-21',
            avgArtifactsPerIssue: 59.7,
            avgDailyJiraCodeLinkChange: 1457,
            avgDailyNodeGrowth: 4857,
            avgDailyRelChange: 34648,
            avgFetchQueriesPerDay: 75641,
            avgFetchQueriesPerSecond: 0.8755,
            avgJiraCodeLinkChangePerSecond: 0.0169,
            avgNodeGrowthPerSecond: 0.0562,
            avgRelChangePerSecond: 0.401,
            cacheStatus: null,
            collaboratorTeams: null,
            collaboratorTeamsTruncated: null,
            collaborators: null,
            commentsCreated180d: 5043,
            commentsDataAsOf: null,
            computedAt: COMPUTED_AT,
            connectorDataAsOf: null,
            connectorObjects180d: 610847,
            connectorObjectsByProvider: [
                {
                    providerName: 'GitHub for Jira',
                    objects30d: 558225
                },
                {
                    providerName: 'Google Drive provider',
                    objects30d: 46406
                },
                {
                    providerName: 'Figma',
                    objects30d: 4864
                },
                {
                    providerName: 'Slack provider',
                    objects30d: 1294
                },
                {
                    providerName: 'Lucid provider',
                    objects30d: 35
                },
                {
                    providerName: 'Salesforce',
                    objects30d: 14
                },
                {
                    providerName: 'Figma for Jira',
                    objects30d: 9
                }
            ],
            connectorsActive28d: 0,
            connectorsDetail: null,
            connectorsInstalled: 1,
            daysSinceSnapshot: null,
            entitiesTouched: null,
            estimatedNodesNow: null,
            forgeAppsInstalled: null,
            goalWorkItemLinks: 422,
            issueActivityDataAsOf: '2026-04-21',
            issuesMovedForward180d: 4785,
            jiraCodeLinks: 1128522,
            loomDataAsOf: null,
            loomsRecorded180d: 0,
            marketplaceAddonsInstalled: 31,
            meetingMinutesSaved: 0,
            meetingNotesDataAsOf: null,
            meetingNotesWithRecording180d: 0,
            nodeDataAsOf: '2026-04-18',
            onePAppsInstalled: 9,
            organisationId: 'c175835a-1029-4b03-bda0-601b1a101710',
            pagesCreated180d: 449,
            pagesDataAsOf: '2026-04-21',
            pctConnectorsActive28d: 0,
            queryDataAsOf: '2026-04-21',
            relDataAsOf: '2026-04-19',
            smartlinkDataAsOf: null,
            smartlinkPastes180d: 0,
            teamCount: 101,
            threePConnectorsInstalled: 1,
            totalAppsInstalled: 41,
            totalJiraIssues: 21202,
            totalMinutesRecorded: 0,
            totalNodes: 3185817,
            totalRelationships: 20547334,
            userCount: 67
        }
    }
};
var STATIC_TIER2_DATASET_LIST = [
    STATIC_TIER2_DATASETS.fastMed,
    STATIC_TIER2_DATASETS.accenture,
    STATIC_TIER2_DATASETS.allegion,
    STATIC_TIER2_DATASETS.atlassian,
    STATIC_TIER2_DATASETS.communardo,
    STATIC_TIER2_DATASETS.reddit,
    STATIC_TIER2_DATASETS.procoreLargest,
    STATIC_TIER2_DATASETS.helloFresh,
    STATIC_TIER2_DATASETS.workday,
    STATIC_TIER2_DATASETS.workdayLargest
];
var STATIC_TIER3_DATASETS = {
    brandNewTenant: {
        key: 'brandNewTenant',
        label: (0, _messages.messages).datasetTier3BrandNewLabel,
        description: (0, _messages.messages).datasetTier3BrandNewDescription,
        metrics: {
            activeContributors180d: -1,
            activeNodeTypes: 71,
            activeRelTypes: 235,
            activityDataAsOf: '2026-04-17',
            avgArtifactsPerIssue: 0.7,
            avgDailyJiraCodeLinkChange: 1107,
            avgDailyNodeGrowth: 70638,
            avgDailyRelChange: 643225,
            avgFetchQueriesPerDay: 389,
            avgFetchQueriesPerSecond: 0.0164,
            avgJiraCodeLinkChangePerSecond: 0.0128,
            avgNodeGrowthPerSecond: 0.8176,
            avgRelChangePerSecond: 7.4447,
            cacheStatus: null,
            collaboratorTeams: null,
            collaboratorTeamsTruncated: null,
            collaborators: null,
            commentsCreated180d: 99,
            commentsDataAsOf: null,
            computedAt: COMPUTED_AT,
            connectorDataAsOf: null,
            connectorObjects180d: 790,
            connectorObjectsByProvider: [
                {
                    providerName: 'Slack provider',
                    objects30d: 719
                },
                {
                    providerName: 'Figma',
                    objects30d: 71
                }
            ],
            connectorsActive28d: 0,
            connectorsDetail: null,
            connectorsInstalled: 0,
            daysSinceSnapshot: null,
            entitiesTouched: null,
            estimatedNodesNow: null,
            forgeAppsInstalled: null,
            goalWorkItemLinks: 4919,
            issueActivityDataAsOf: '2026-04-21',
            issuesMovedForward180d: 49,
            jiraCodeLinks: 4,
            loomDataAsOf: '2026-04-21T12:14:21.319+00:00',
            loomsRecorded180d: 19,
            marketplaceAddonsInstalled: 292,
            meetingMinutesSaved: 48,
            meetingNotesDataAsOf: null,
            meetingNotesWithRecording180d: 0,
            nodeDataAsOf: '2026-04-18',
            onePAppsInstalled: 13,
            organisationId: 'a53d6b63-3k57-1408-j79d-0b60b08kb685',
            pagesCreated180d: 34,
            pagesDataAsOf: '2026-04-18',
            pctConnectorsActive28d: 0,
            queryDataAsOf: null,
            relDataAsOf: '2026-04-18',
            smartlinkDataAsOf: null,
            smartlinkPastes180d: 0,
            teamCount: 4,
            threePConnectorsInstalled: 0,
            totalAppsInstalled: 305,
            totalJiraIssues: 4844413,
            totalMinutesRecorded: 32,
            totalNodes: 24456310,
            totalRelationships: 107366741,
            userCount: 12358
        }
    },
    trialTenant: {
        key: 'trialTenant',
        label: (0, _messages.messages).datasetTier3TrialLabel,
        description: (0, _messages.messages).datasetTier3TrialDescription,
        metrics: {
            activeContributors180d: -1,
            activeNodeTypes: 71,
            activeRelTypes: 235,
            activityDataAsOf: '2026-04-17',
            avgArtifactsPerIssue: 0.7,
            avgDailyJiraCodeLinkChange: 1107,
            avgDailyNodeGrowth: 70638,
            avgDailyRelChange: 643225,
            avgFetchQueriesPerDay: 999,
            avgFetchQueriesPerSecond: 0.0164,
            avgJiraCodeLinkChangePerSecond: 0.0128,
            avgNodeGrowthPerSecond: 0.8176,
            avgRelChangePerSecond: 7.4447,
            cacheStatus: null,
            collaboratorTeams: null,
            collaboratorTeamsTruncated: null,
            collaborators: null,
            commentsCreated180d: 99,
            commentsDataAsOf: null,
            computedAt: COMPUTED_AT,
            connectorDataAsOf: null,
            connectorObjects180d: 790,
            connectorObjectsByProvider: [
                {
                    providerName: 'Slack provider',
                    objects30d: 719
                },
                {
                    providerName: 'Figma',
                    objects30d: 71
                }
            ],
            connectorsActive28d: 0,
            connectorsDetail: null,
            connectorsInstalled: 0,
            daysSinceSnapshot: null,
            entitiesTouched: null,
            estimatedNodesNow: null,
            forgeAppsInstalled: null,
            goalWorkItemLinks: 4919,
            issueActivityDataAsOf: '2026-04-21',
            issuesMovedForward180d: 36,
            jiraCodeLinks: 4,
            loomDataAsOf: '2026-04-21T12:14:21.319+00:00',
            loomsRecorded180d: 19,
            marketplaceAddonsInstalled: 292,
            meetingMinutesSaved: 48,
            meetingNotesDataAsOf: null,
            meetingNotesWithRecording180d: 0,
            nodeDataAsOf: '2026-04-18',
            onePAppsInstalled: 13,
            organisationId: 'a53d6b63-3k57-1408-j79d-0b60b08kb685',
            pagesCreated180d: 49,
            pagesDataAsOf: '2026-04-18',
            pctConnectorsActive28d: 0,
            queryDataAsOf: null,
            relDataAsOf: '2026-04-18',
            smartlinkDataAsOf: null,
            smartlinkPastes180d: 0,
            teamCount: 4,
            threePConnectorsInstalled: 0,
            totalAppsInstalled: 305,
            totalJiraIssues: 4844413,
            totalMinutesRecorded: 32,
            totalNodes: 24456310,
            totalRelationships: 107366741,
            userCount: 12358
        }
    },
    soloTenant: {
        key: 'soloTenant',
        label: (0, _messages.messages).datasetTier3SoloLabel,
        description: (0, _messages.messages).datasetTier3SoloDescription,
        metrics: {
            activeContributors180d: -1,
            activeNodeTypes: 71,
            activeRelTypes: 235,
            activityDataAsOf: '2026-04-17',
            avgArtifactsPerIssue: 0.7,
            avgDailyJiraCodeLinkChange: 1107,
            avgDailyNodeGrowth: 70638,
            avgDailyRelChange: 643225,
            avgFetchQueriesPerDay: 714,
            avgFetchQueriesPerSecond: 0.0164,
            avgJiraCodeLinkChangePerSecond: 0.0128,
            avgNodeGrowthPerSecond: 0.8176,
            avgRelChangePerSecond: 7.4447,
            cacheStatus: null,
            collaboratorTeams: null,
            collaboratorTeamsTruncated: null,
            collaborators: null,
            commentsCreated180d: 99,
            commentsDataAsOf: null,
            computedAt: COMPUTED_AT,
            connectorDataAsOf: null,
            connectorObjects180d: 790,
            connectorObjectsByProvider: [
                {
                    providerName: 'Slack provider',
                    objects30d: 719
                },
                {
                    providerName: 'Figma',
                    objects30d: 71
                }
            ],
            connectorsActive28d: 0,
            connectorsDetail: null,
            connectorsInstalled: 0,
            daysSinceSnapshot: null,
            entitiesTouched: null,
            estimatedNodesNow: null,
            forgeAppsInstalled: null,
            goalWorkItemLinks: 4919,
            issueActivityDataAsOf: '2026-04-21',
            issuesMovedForward180d: 21,
            jiraCodeLinks: 4,
            loomDataAsOf: '2026-04-21T12:14:21.319+00:00',
            loomsRecorded180d: 19,
            marketplaceAddonsInstalled: 292,
            meetingMinutesSaved: 48,
            meetingNotesDataAsOf: null,
            meetingNotesWithRecording180d: 0,
            nodeDataAsOf: '2026-04-18',
            onePAppsInstalled: 13,
            organisationId: 'a53d6b63-3k57-1408-j79d-0b60b08kb685',
            pagesCreated180d: 52,
            pagesDataAsOf: '2026-04-18',
            pctConnectorsActive28d: 0,
            queryDataAsOf: null,
            relDataAsOf: '2026-04-18',
            smartlinkDataAsOf: null,
            smartlinkPastes180d: 0,
            teamCount: 4,
            threePConnectorsInstalled: 0,
            totalAppsInstalled: 305,
            totalJiraIssues: 4844413,
            totalMinutesRecorded: 32,
            totalNodes: 24456310,
            totalRelationships: 107366741,
            userCount: 12358
        }
    }
};
var STATIC_TIER3_DATASET_LIST = [
    STATIC_TIER3_DATASETS.brandNewTenant,
    STATIC_TIER3_DATASETS.trialTenant,
    STATIC_TIER3_DATASETS.soloTenant
];
var STATIC_COLLABORATION_USERS = [
    {
        score: 0.5758,
        id: 'ari:cloud:identity::user/712020:fe8c7aeb-92b9-4075-bfed-e4d859bb587f',
        expand: {
            ari: 'ari:cloud:identity::user/712020:fe8c7aeb-92b9-4075-bfed-e4d859bb587f',
            account_id: '712020:fe8c7aeb-92b9-4075-bfed-e4d859bb587f',
            email: 'acherk@atlassian.com',
            name: 'Alvin Cherk',
            picture: 'https://secure.gravatar.com/avatar/527c98c2e4b0cf1c9a2bc979886644a4?d=https%3A%2F%2Favatar-management--avatars.us-west-2.prod.public.atl-paas.net%2Finitials%2FAC-6.png'
        }
    },
    {
        score: 0.3358,
        id: 'ari:cloud:identity::user/70121:f604320b-d57f-4347-9af4-6134863803c2',
        expand: {
            ari: 'ari:cloud:identity::user/70121:f604320b-d57f-4347-9af4-6134863803c2',
            account_id: '70121:f604320b-d57f-4347-9af4-6134863803c2',
            email: 'hshahid@atlassian.com',
            name: 'Hamza Shahid',
            picture: 'https://avatar-management--avatars.us-west-2.prod.public.atl-paas.net/70121:f604320b-d57f-4347-9af4-6134863803c2/371838a1-9613-4320-8e6e-b0542872590a/128'
        }
    },
    {
        score: 0.3259,
        id: 'ari:cloud:identity::user/63749bac9960988ef6bc6096',
        expand: {
            ari: 'ari:cloud:identity::user/63749bac9960988ef6bc6096',
            account_id: '63749bac9960988ef6bc6096',
            email: 'efernando@atlassian.com',
            name: 'Eve Fernando',
            picture: 'https://avatar-management--avatars.us-west-2.prod.public.atl-paas.net/63749bac9960988ef6bc6096/835e5c9d-bb4d-4976-8408-03419a49b5c1/128'
        }
    },
    {
        score: 0.3024,
        id: 'ari:cloud:identity::user/712020:538b5dc0-5d53-4703-95be-0803cdd14327',
        expand: {
            ari: 'ari:cloud:identity::user/712020:538b5dc0-5d53-4703-95be-0803cdd14327',
            account_id: '712020:538b5dc0-5d53-4703-95be-0803cdd14327',
            email: 'shaq@atlassian.com',
            name: 'Shan Haq',
            picture: 'https://avatar-management--avatars.us-west-2.prod.public.atl-paas.net/712020:538b5dc0-5d53-4703-95be-0803cdd14327/47074604-003e-4efd-a650-4b14283b5a5f/128'
        }
    },
    {
        score: 0.2296,
        id: 'ari:cloud:identity::user/63749bf65fce844d606712e6',
        expand: {
            ari: 'ari:cloud:identity::user/63749bf65fce844d606712e6',
            account_id: '63749bf65fce844d606712e6',
            email: 'ndutta2@atlassian.com',
            name: 'Neel Dutta',
            picture: 'https://avatar-management--avatars.us-west-2.prod.public.atl-paas.net/63749bf65fce844d606712e6/c8f3eb84-f065-4e52-92c5-baac27ed7e6f/128'
        }
    }
];

},{"@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_sliced_to_array":"8PtL6","./messages":"jGo7V","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jGo7V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "messages", function() {
    return messages;
});
var _reactIntl = require("react-intl");
var intlMessages = {
    tier1HelperText: {
        id: 'twg-microsite.debugPanel.tier1HelperText.non-final',
        defaultMessage: 'Pick a Tier 1 dataset to preview the user-scoped view. The home page will render the user graph view seeded with the selected user-metrics payload.',
        description: 'Helper text shown above the Tier 1 dataset list in the Debug Panel'
    },
    tier2HelperText: {
        id: 'twg-microsite.debugPanel.tier2HelperText.non-final',
        defaultMessage: 'Pick a Tier 2 dataset to preview the org-scoped view. The home page will render the org graph view seeded with the selected organisation metrics payload.',
        description: 'Helper text shown above the Tier 2 dataset list in the Debug Panel'
    },
    tier3HelperText: {
        id: 'twg-microsite.debugPanel.tier3HelperText.non-final',
        defaultMessage: 'Pick a Tier 3 scenario to preview the getting-started view. The home page will render the capability showcase with no org metrics data.',
        description: 'Helper text shown above the Tier 3 dataset list in the Debug Panel'
    },
    title: {
        id: 'twg-microsite.debugPanel.title.non-final',
        defaultMessage: 'Data Simulation',
        description: 'Main heading for the Debug Panel'
    },
    description: {
        id: 'twg-microsite.debugPanel.description.non-final',
        defaultMessage: 'This section allows you to simulate data for different scenarios as different organisations have verying levels of graph density and breadth.',
        description: 'Description text explaining what the Debug Panel does'
    },
    instructionsIntro: {
        id: 'twg-microsite.debugPanel.instructionsIntro.non-final',
        defaultMessage: 'Choose a tier to preview:',
        description: 'Introductory sentence before listing tier options in the Debug Panel'
    },
    instructionsTier1: {
        id: 'twg-microsite.debugPanel.instructionsTier1.non-final',
        defaultMessage: "Tier 1 \u2014 user-scoped view seeded from a simulated user-metrics payload.",
        description: 'List item describing the Tier 1 preview in the Debug Panel instructions'
    },
    instructionsTier2: {
        id: 'twg-microsite.debugPanel.instructionsTier2.non-final',
        defaultMessage: "Tier 2 \u2014 org-scoped view seeded from a simulated organisation-metrics payload.",
        description: 'List item describing the Tier 2 preview in the Debug Panel instructions'
    },
    instructionsTier3: {
        id: 'twg-microsite.debugPanel.instructionsTier3.non-final',
        defaultMessage: "Tier 3 \u2014 getting-started capability showcase for early-days tenants.",
        description: 'List item describing the Tier 3 preview in the Debug Panel instructions'
    },
    tier1TabLabel: {
        id: 'twg-microsite.debugPanel.tier1TabLabel.non-final',
        defaultMessage: 'Tier 1',
        description: 'Tab label for Tier 1 (user-scoped) view previews in the Debug Panel tier switcher'
    },
    tier2TabLabel: {
        id: 'twg-microsite.debugPanel.tier2TabLabel.non-final',
        defaultMessage: 'Tier 2',
        description: 'Tab label for Tier 2 (org-scoped) view previews in the Debug Panel tier switcher'
    },
    tier3TabLabel: {
        id: 'twg-microsite.debugPanel.tier3TabLabel.non-final',
        defaultMessage: 'Tier 3',
        description: 'Tab label for Tier 3 (getting started) view previews in the Debug Panel tier switcher'
    },
    resetButton: {
        id: 'twg-microsite.debugPanel.resetButton.non-final',
        defaultMessage: 'Reset',
        description: 'Button label that reloads the page and resets the Debug Panel state'
    },
    closePanelLabel: {
        id: 'twg-microsite.debugPanel.closePanelLabel.non-final',
        defaultMessage: 'Close debug panel',
        description: 'Accessibility label for the debug panel close control'
    },
    datasetFastMedLabel: {
        id: 'twg-microsite.debugPanel.dataset.fastMed.label.non-final',
        defaultMessage: 'Fast Med (no 3P)',
        description: "Label for the Fast Med static dataset option in the Debug Panel \u2014 a synthetic org with no third-party connectors but lots of first-party Atlassian activity, used to validate the inferred-1p-apps fallback."
    },
    datasetFastMedDescription: {
        id: 'twg-microsite.debugPanel.dataset.fastMed.description.non-final',
        defaultMessage: "Healthcare org with no 3P connectors \u2014 exercises the inferred 1P apps fallback (Confluence, Jira, Loom, Bitbucket, Atlas).",
        description: 'Description for the Fast Med static dataset option in the Debug Panel'
    },
    datasetAccentureLabel: {
        id: 'twg-microsite.debugPanel.dataset.accenture.label.non-final',
        defaultMessage: 'Accenture',
        description: 'Label for the Accenture static dataset option in the Debug Panel'
    },
    datasetAccentureDescription: {
        id: 'twg-microsite.debugPanel.dataset.accenture.description.non-final',
        defaultMessage: 'Large enterprise tenant with broad Jira footprint.',
        description: 'Description for the Accenture static dataset option in the Debug Panel'
    },
    datasetAllegionLabel: {
        id: 'twg-microsite.debugPanel.dataset.allegion.label.non-final',
        defaultMessage: 'Allegion',
        description: 'Label for the Allegion static dataset option in the Debug Panel'
    },
    datasetAllegionDescription: {
        id: 'twg-microsite.debugPanel.dataset.allegion.description.non-final',
        defaultMessage: 'Mid-size tenant, low goal coverage.',
        description: 'Description for the Allegion static dataset option in the Debug Panel'
    },
    datasetAtlassianLabel: {
        id: 'twg-microsite.debugPanel.dataset.atlassian.label.non-final',
        defaultMessage: 'Atlassian',
        description: 'Label for the Atlassian static dataset option in the Debug Panel'
    },
    datasetAtlassianDescription: {
        id: 'twg-microsite.debugPanel.dataset.atlassian.description.non-final',
        defaultMessage: 'Densest internal graph; superuser of every product.',
        description: 'Description for the Atlassian static dataset option in the Debug Panel'
    },
    datasetCommunardoLabel: {
        id: 'twg-microsite.debugPanel.dataset.communardo.label.non-final',
        defaultMessage: 'Communardo',
        description: 'Label for the Communardo static dataset option in the Debug Panel'
    },
    datasetCommunardoDescription: {
        id: 'twg-microsite.debugPanel.dataset.communardo.description.non-final',
        defaultMessage: 'Smaller customer with focused activity.',
        description: 'Description for the Communardo static dataset option in the Debug Panel'
    },
    datasetRedditLabel: {
        id: 'twg-microsite.debugPanel.dataset.reddit.label.non-final',
        defaultMessage: 'Reddit',
        description: 'Label for the Reddit static dataset option in the Debug Panel'
    },
    datasetRedditDescription: {
        id: 'twg-microsite.debugPanel.dataset.reddit.description.non-final',
        defaultMessage: 'Heavy Jira usage with strong code linkage.',
        description: 'Description for the Reddit static dataset option in the Debug Panel'
    },
    datasetProcoreLargestLabel: {
        id: 'twg-microsite.debugPanel.dataset.procoreLargest.label.non-final',
        defaultMessage: 'Procore (largest)',
        description: 'Label for the largest Procore static dataset option in the Debug Panel'
    },
    datasetProcoreLargestDescription: {
        id: 'twg-microsite.debugPanel.dataset.procoreLargest.description.non-final',
        defaultMessage: 'Largest Procore tenant with rich connector activity.',
        description: 'Description for the largest Procore static dataset option in the Debug Panel'
    },
    datasetHelloFreshLabel: {
        id: 'twg-microsite.debugPanel.dataset.helloFresh.label.non-final',
        defaultMessage: 'HelloFresh',
        description: 'Label for the HelloFresh static dataset option in the Debug Panel'
    },
    datasetHelloFreshDescription: {
        id: 'twg-microsite.debugPanel.dataset.helloFresh.description.non-final',
        defaultMessage: 'Operations-heavy tenant.',
        description: 'Description for the HelloFresh static dataset option in the Debug Panel'
    },
    datasetWorkdayLabel: {
        id: 'twg-microsite.debugPanel.dataset.workday.label.non-final',
        defaultMessage: 'Workday',
        description: 'Label for the Workday static dataset option in the Debug Panel'
    },
    datasetWorkdayDescription: {
        id: 'twg-microsite.debugPanel.dataset.workday.description.non-final',
        defaultMessage: 'Mid-size tenant with very high artifact density per issue.',
        description: 'Description for the Workday static dataset option in the Debug Panel'
    },
    datasetWorkdayLargestLabel: {
        id: 'twg-microsite.debugPanel.dataset.workdayLargest.label.non-final',
        defaultMessage: 'Workday (largest)',
        description: 'Label for the largest Workday static dataset option in the Debug Panel'
    },
    datasetWorkdayLargestDescription: {
        id: 'twg-microsite.debugPanel.dataset.workdayLargest.description.non-final',
        defaultMessage: 'Largest Workday tenant with the highest artifacts-per-issue ratio.',
        description: 'Description for the largest Workday static dataset option in the Debug Panel'
    },
    datasetTier1PowerUserLabel: {
        id: 'twg-microsite.debugPanel.dataset.tier1.powerUser.label.non-final',
        defaultMessage: 'Power user',
        description: 'Label for the Tier 1 "power user" static dataset in the Debug Panel'
    },
    datasetTier1PowerUserDescription: {
        id: 'twg-microsite.debugPanel.dataset.tier1.powerUser.description.non-final',
        defaultMessage: 'Top of the org across pages, comments, work items, videos, and code.',
        description: 'Description for the Tier 1 "power user" static dataset in the Debug Panel'
    },
    datasetTier1EngineerICLabel: {
        id: 'twg-microsite.debugPanel.dataset.tier1.engineerIC.label.non-final',
        defaultMessage: 'Engineer (IC)',
        description: 'Label for the Tier 1 "engineer IC" static dataset in the Debug Panel'
    },
    datasetTier1EngineerICDescription: {
        id: 'twg-microsite.debugPanel.dataset.tier1.engineerIC.description.non-final',
        defaultMessage: "Heavy code activity \u2014 PRs, Jira links, and GitHub events dominate.",
        description: 'Description for the Tier 1 "engineer IC" static dataset in the Debug Panel'
    },
    datasetTier1DesignerICLabel: {
        id: 'twg-microsite.debugPanel.dataset.tier1.designerIC.label.non-final',
        defaultMessage: 'Designer (IC)',
        description: 'Label for the Tier 1 "designer IC" static dataset in the Debug Panel'
    },
    datasetTier1DesignerICDescription: {
        id: 'twg-microsite.debugPanel.dataset.tier1.designerIC.description.non-final',
        defaultMessage: "Design-heavy profile \u2014 strong Figma, Loom, and page activity.",
        description: 'Description for the Tier 1 "designer IC" static dataset in the Debug Panel'
    },
    datasetTier1ProductLeadLabel: {
        id: 'twg-microsite.debugPanel.dataset.tier1.productLead.label.non-final',
        defaultMessage: 'Product lead',
        description: 'Label for the Tier 1 "product lead" static dataset in the Debug Panel'
    },
    datasetTier1ProductLeadDescription: {
        id: 'twg-microsite.debugPanel.dataset.tier1.productLead.description.non-final',
        defaultMessage: 'Lots of pages, comments, and work items; moderate code and design.',
        description: 'Description for the Tier 1 "product lead" static dataset in the Debug Panel'
    },
    datasetTier1NewContributorLabel: {
        id: 'twg-microsite.debugPanel.dataset.tier1.newContributor.label.non-final',
        defaultMessage: 'New contributor',
        description: 'Label for the Tier 1 "new contributor" static dataset in the Debug Panel'
    },
    datasetTier1NewContributorDescription: {
        id: 'twg-microsite.debugPanel.dataset.tier1.newContributor.description.non-final',
        defaultMessage: 'Low volume across all surfaces but just above the Tier 1 floor.',
        description: 'Description for the Tier 1 "new contributor" static dataset in the Debug Panel'
    },
    datasetTier3BrandNewLabel: {
        id: 'twg-microsite.debugPanel.dataset.tier3.brandNewTenant.label.non-final',
        defaultMessage: 'Brand new tenant',
        description: 'Label for the Tier 3 "brand new tenant" static dataset in the Debug Panel'
    },
    datasetTier3BrandNewDescription: {
        id: 'twg-microsite.debugPanel.dataset.tier3.brandNewTenant.description.non-final',
        defaultMessage: "Freshly provisioned org \u2014 nothing connected, no graph activity yet.",
        description: 'Description for the Tier 3 "brand new tenant" static dataset in the Debug Panel'
    },
    datasetTier3TrialLabel: {
        id: 'twg-microsite.debugPanel.dataset.tier3.trialTenant.label.non-final',
        defaultMessage: 'Trial tenant',
        description: 'Label for the Tier 3 "trial tenant" static dataset in the Debug Panel'
    },
    datasetTier3TrialDescription: {
        id: 'twg-microsite.debugPanel.dataset.tier3.trialTenant.description.non-final',
        defaultMessage: 'Evaluation tenant with a handful of seats; below the Tier 2 scale gate.',
        description: 'Description for the Tier 3 "trial tenant" static dataset in the Debug Panel'
    },
    datasetTier3SoloLabel: {
        id: 'twg-microsite.debugPanel.dataset.tier3.soloTenant.label.non-final',
        defaultMessage: 'Solo tenant',
        description: 'Label for the Tier 3 "solo tenant" static dataset in the Debug Panel'
    },
    datasetTier3SoloDescription: {
        id: 'twg-microsite.debugPanel.dataset.tier3.soloTenant.description.non-final',
        defaultMessage: "Single-user tenant \u2014 not enough activity to meet the Tier 2 relationships gate.",
        description: 'Description for the Tier 3 "solo tenant" static dataset in the Debug Panel'
    },
    sentryTestSectionTitle: {
        id: 'twg-microsite.debugPanel.sentryTestSectionTitle.non-final',
        defaultMessage: 'Sentry',
        description: 'Section header for the Sentry test-exception controls in the Debug Panel'
    },
    sentryTestSectionHelper: {
        id: 'twg-microsite.debugPanel.sentryTestSectionHelper.non-final',
        defaultMessage: 'Throws a test exception and reports it to Sentry via logException. Sentry is disabled in dev environments, so events only appear in the Sentry UI on staging or production.',
        description: 'Helper text explaining what the Sentry test-exception button does'
    },
    sentryTestButtonLabel: {
        id: 'twg-microsite.debugPanel.sentryTestButtonLabel.non-final',
        defaultMessage: 'Trigger test exception',
        description: 'Label for the button that throws a test exception and reports it to Sentry'
    },
    sentryBoundaryButtonLabel: {
        id: 'twg-microsite.debugPanel.sentryBoundaryButtonLabel.non-final',
        defaultMessage: 'Throw render error (boundary)',
        description: 'Label for the button that throws an error during render to be caught by SentryErrorBoundary'
    },
    sentryBoundaryFallbackText: {
        id: 'twg-microsite.debugPanel.sentryBoundaryFallbackText.non-final',
        defaultMessage: 'SentryErrorBoundary caught a render error and reported it.',
        description: 'Text shown in the SentryErrorBoundary fallback after a synthetic render error'
    },
    sentryBoundaryResetButtonLabel: {
        id: 'twg-microsite.debugPanel.sentryBoundaryResetButtonLabel.non-final',
        defaultMessage: 'Reset boundary',
        description: 'Label for the button that resets the SentryErrorBoundary fallback'
    }
};
var messages = (0, _reactIntl.defineMessages)(intlMessages);

},{"react-intl":"f41fF","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hBDS8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SiteSelectionSource", function() {
    return SiteSelectionSource;
});
parcelHelpers.export(exports, "SiteSwitcherCloseReason", function() {
    return SiteSwitcherCloseReason;
});
var SiteSelectionSource = /*#__PURE__*/ function(SiteSelectionSource) {
    SiteSelectionSource["Default"] = "default";
    SiteSelectionSource["SavedPreference"] = "savedPreference";
    SiteSelectionSource["UserSelection"] = "userSelection";
    return SiteSelectionSource;
}({});
var SiteSwitcherCloseReason = /*#__PURE__*/ function(SiteSwitcherCloseReason) {
    SiteSwitcherCloseReason["ItemSelected"] = "itemSelected";
    SiteSwitcherCloseReason["Dismissed"] = "dismissed";
    return SiteSwitcherCloseReason;
}({});

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kiEOl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "messages", function() {
    return messages;
});
var _reactIntl = require("react-intl");
var intlMessages = {
    switchSiteLabel: {
        id: 'twg-microsite.siteSwitcher.switchSiteLabel',
        defaultMessage: 'Switch site',
        description: 'Accessible label and tooltip for the site switcher trigger button'
    },
    switchSiteHeading: {
        id: 'twg-microsite.siteSwitcher.switchSiteHeading',
        defaultMessage: 'Switch site',
        description: 'Heading shown at the top of the site switcher dropdown menu'
    }
};
var messages = (0, _reactIntl.defineMessages)(intlMessages);

},{"react-intl":"f41fF","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cQnjS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SwitchSiteItem", function() {
    return SwitchSiteItem;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _officeBuilding = require("@atlaskit/icon/core/office-building");
var _officeBuildingDefault = parcelHelpers.interopDefault(_officeBuilding);
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
var _menu = require("@atlaskit/menu");
var _tooltip = require("@atlaskit/tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
// MenuGroup max width of 480 - 56 (icon width + padding + margin)
var MAX_WIDTH_OF_TEXT_BEFORE_TRUNCATING = 424;
var SwitchSiteItem = function(param) {
    var onItemClick = param.onItemClick, site = param.site, href = param.href, isSelected = param.isSelected;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), includeTooltip = _useState[0], setIncludeTooltip = _useState[1];
    var handleOnClick = function(e) {
        return onItemClick(e, site);
    };
    var _site_cloudId;
    var SiteLinkItem = /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _menu.LinkItem), {
        href: href,
        iconBefore: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _officeBuildingDefault.default), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        }),
        key: "site-switcher-option-".concat((_site_cloudId = site.cloudId) !== null && _site_cloudId !== void 0 ? _site_cloudId : site.url),
        testId: site.cloudId ? "site-switcher-option-".concat(site.cloudId) : 'site-switcher-option-unknown',
        onClick: handleOnClick,
        isSelected: isSelected
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        ref: function(el) {
            var _el_offsetWidth;
            if (((_el_offsetWidth = el === null || el === void 0 ? void 0 : el.offsetWidth) !== null && _el_offsetWidth !== void 0 ? _el_offsetWidth : 0) >= MAX_WIDTH_OF_TEXT_BEFORE_TRUNCATING) setIncludeTooltip(true);
        }
    }, site.displayName)));
    var _site_cloudId1;
    return includeTooltip ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltipDefault.default), {
        key: (_site_cloudId1 = site.cloudId) !== null && _site_cloudId1 !== void 0 ? _site_cloudId1 : site.url,
        content: site.displayName
    }, SiteLinkItem) : SiteLinkItem;
};

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","react":"ltHCL","@atlaskit/icon/core/office-building":"cC5zm","@atlaskit/menu":"drNQs","@atlaskit/tooltip":"47wSA","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cC5zm":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::61e479f96d30ea6369ef34d699ad08b2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("b65044a910e3ed1c"));
var _baseNew = _interopRequireDefault(require("5e45595268df6026"));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "OfficeBuilding".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: office in Atlas, company.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ var OfficeBuildingIcon = function(props) {
    return /*#__PURE__*/ _react.default.createElement(_baseNew.default, Object.assign({
        name: "OfficeBuildingIcon",
        dangerouslySetGlyph: '<path fill="currentcolor" fill-rule="evenodd" d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12.5h1V16H1v-1.5h1zm1.5 12.5h2v-3.75a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 .75.75v3.75h2V2a.5.5 0 0 0-.5-.5H4a.5.5 0 0 0-.5.5zm5.5 0v-3H7v3zm-2-10H5V3h2zm4 0H9V3h2zM5 6h2v1.5H5zm4 0h2v1.5H9z" clip-rule="evenodd"/>'
    }, props));
};
OfficeBuildingIcon.displayName = 'OfficeBuildingIcon';
var _default = exports.default = OfficeBuildingIcon;

},{"b65044a910e3ed1c":"ltHCL","5e45595268df6026":"kuGeY"}],"ik60l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "messages", function() {
    return messages;
});
var _reactIntl = require("react-intl");
var intlMessages = {
    loginButton: {
        id: 'twg-microsite.navbar.loginButton',
        defaultMessage: 'Log in',
        description: 'Button to log in to the application'
    },
    loginAriaLabel: {
        id: 'twg-microsite.navbar.loginAriaLabel',
        defaultMessage: 'Log in',
        description: 'Accessible label for the log in button'
    },
    userAccountMenuAriaLabel: {
        id: 'twg-microsite.navbar.userAccountMenuAriaLabel',
        defaultMessage: 'Account menu, {userName}',
        description: 'Accessible label for the signed-in user avatar that opens the account menu. {userName} is the user display name.'
    },
    teamworkGraphBrand: {
        id: 'twg-microsite.navbar.teamworkGraphBrand.do-not-translate',
        defaultMessage: 'Atlassian Teamwork Graph',
        description: 'Teamwork Graph brand name shown in the nav bar'
    },
    navAbout: {
        id: 'twg-microsite.navbar.navAbout',
        defaultMessage: 'About',
        description: 'Navigation link to the About section of the microsite'
    },
    navConnectors: {
        id: 'twg-microsite.navbar.navConnectors',
        defaultMessage: 'Connectors',
        description: 'Navigation link to the Connectors section of the microsite'
    },
    navCli: {
        id: 'twg-microsite.navbar.navCli.do-not-translate',
        defaultMessage: 'CLI',
        description: 'Navigation link to the CLI section of the microsite'
    },
    navMcp: {
        id: 'twg-microsite.navbar.navMcp.do-not-translate',
        defaultMessage: 'MCP',
        description: 'Navigation link to the Getting Started section of the microsite, pre-selecting the MCP install instructions tab'
    },
    navDocs: {
        id: 'twg-microsite.navbar.navDocs',
        defaultMessage: 'Docs',
        description: 'Navigation link to the documentation section of the microsite'
    },
    navYourGraph: {
        id: 'twg-microsite.navbar.navYourGraphs',
        defaultMessage: 'Your Graph',
        description: 'Navigation link to the Your Graphs section of the microsite'
    },
    profileLabel: {
        id: 'twg-microsite.navbar.profileLabel',
        defaultMessage: 'Profile',
        description: 'Label and icon label for the Profile menu item in the user dropdown'
    },
    logoutLabel: {
        id: 'twg-microsite.navbar.logoutLabel',
        defaultMessage: 'Logout',
        description: 'Label and icon label for the Logout menu item in the user dropdown'
    },
    logoAlt: {
        id: 'twg-microsite.navbar.logoAlt',
        defaultMessage: 'Teamwork Graph logo',
        description: 'Accessible label for the Teamwork Graph logo'
    }
};
var messages = (0, _reactIntl.defineMessages)(intlMessages);

},{"react-intl":"f41fF","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kjP9L":[function(require,module,exports,__globalThis) {
/* NavButtons.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NavButtons", function() {
    return NavButtons;
});
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _jotai = require("jotai");
var _reactIntl = require("react-intl");
var _browserApis = require("@atlaskit/browser-apis");
var _state = require("../../state");
var _messages = require("./messages");
/**
 * Smoothly scrolls the section with the matching `id` into view, aligning its
 * top with the viewport top (offset by each section's `scroll-margin-top`,
 * which accounts for the fixed `NavigationBar`).
 *
 * Used by every nav button that maps to an in-page section, so the behaviour
 * stays consistent whether the user clicks "About", "Connectors", "CLI", etc.
 */ var scrollToSection = function(sectionId) {
    return function() {
        var _getDocument_getElementById, _getDocument;
        (_getDocument = (0, _browserApis.getDocument)()) === null || _getDocument === void 0 ? void 0 : (_getDocument_getElementById = _getDocument.getElementById(sectionId)) === null || _getDocument_getElementById === void 0 ? void 0 : _getDocument_getElementById.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    };
};
var styles = {
    centerNav: "_zulpu2gc _1e0c1txw _2lx2vrvc _4cvr1h6o _10fp1h6o _otyrr5cr _i5csglyw",
    button: "_19itglyw _2rko1qi0 _11c81kw7 _1rjcu2gc _18zrutpp _1e0c116y _4cvr1h6o _1bah1h6o _bfhk1j28 _syaz1kw7 _80omtlke _irr31dpa"
};
var NavButtons = function(param) {
    var ariaLabel = param.ariaLabel, isLoggedIn = param.isLoggedIn;
    // tier is 'tier1' | 'tier2' | 'tier3' | null
    var tier = (0, _jotai.useAtomValue)((0, _state.currentDisplayedTierAtom));
    if (!isLoggedIn) // CLI and MCP both scroll to the new "Connect your agents" section,
    // which renders the CLI and MCP options side-by-side. There's no tab
    // state to flip on the new section, so a plain scroll is enough.
    return /*#__PURE__*/ _react.createElement("nav", {
        "aria-label": ariaLabel,
        className: (0, _runtime.ax)([
            styles.centerNav
        ])
    }, /*#__PURE__*/ _react.createElement("button", {
        type: "button",
        onClick: scrollToSection('overview'),
        className: (0, _runtime.ax)([
            styles.button
        ])
    }, /*#__PURE__*/ _react.createElement((0, _reactIntl.FormattedMessage), (0, _messages.messages).navAbout)), /*#__PURE__*/ _react.createElement("button", {
        type: "button",
        onClick: scrollToSection('connector-showcase'),
        className: (0, _runtime.ax)([
            styles.button
        ])
    }, /*#__PURE__*/ _react.createElement((0, _reactIntl.FormattedMessage), (0, _messages.messages).navConnectors)), /*#__PURE__*/ _react.createElement("button", {
        type: "button",
        onClick: scrollToSection('getting-started-v2-cli'),
        className: (0, _runtime.ax)([
            styles.button
        ])
    }, /*#__PURE__*/ _react.createElement((0, _reactIntl.FormattedMessage), (0, _messages.messages).navCli)), /*#__PURE__*/ _react.createElement("button", {
        type: "button",
        onClick: scrollToSection('getting-started-v2-mcp'),
        className: (0, _runtime.ax)([
            styles.button
        ])
    }, /*#__PURE__*/ _react.createElement((0, _reactIntl.FormattedMessage), (0, _messages.messages).navMcp)));
    if (!tier) return /*#__PURE__*/ _react.createElement("nav", {
        "aria-label": ariaLabel,
        className: (0, _runtime.ax)([
            styles.centerNav
        ])
    });
    return /*#__PURE__*/ _react.createElement("nav", {
        "aria-label": ariaLabel,
        className: (0, _runtime.ax)([
            styles.centerNav
        ])
    }, tier !== 'tier3' && /*#__PURE__*/ _react.createElement("button", {
        type: "button",
        onClick: scrollToSection('graph-preview'),
        className: (0, _runtime.ax)([
            styles.button
        ])
    }, /*#__PURE__*/ _react.createElement((0, _reactIntl.FormattedMessage), (0, _messages.messages).navYourGraph)), /*#__PURE__*/ _react.createElement("button", {
        type: "button",
        onClick: scrollToSection('connectors'),
        className: (0, _runtime.ax)([
            styles.button
        ])
    }, /*#__PURE__*/ _react.createElement((0, _reactIntl.FormattedMessage), (0, _messages.messages).navConnectors)), /*#__PURE__*/ _react.createElement("button", {
        type: "button",
        onClick: scrollToSection('getting-started-v2-cli'),
        className: (0, _runtime.ax)([
            styles.button
        ])
    }, /*#__PURE__*/ _react.createElement((0, _reactIntl.FormattedMessage), (0, _messages.messages).navCli)), /*#__PURE__*/ _react.createElement("button", {
        type: "button",
        onClick: scrollToSection('getting-started-v2-mcp'),
        className: (0, _runtime.ax)([
            styles.button
        ])
    }, /*#__PURE__*/ _react.createElement((0, _reactIntl.FormattedMessage), (0, _messages.messages).navMcp)));
};

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","jotai":"4mcir","react-intl":"f41fF","@atlaskit/browser-apis":"2dayt","../../state":"jgfkg","./messages":"ik60l","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2B025":[function(require,module,exports,__globalThis) {
/* UserAvatarDropdown.tsx generated by @compiled/babel-plugin v0.39.1 */ /* eslint-disable @atlaskit/design-system/use-primitives-text */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UserAvatarDropdown", function() {
    return UserAvatarDropdown;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _reactIntl = require("react-intl");
var _dropdownMenu = require("@atlaskit/dropdown-menu");
var _dropdownMenuDefault = parcelHelpers.interopDefault(_dropdownMenu);
var _logOut = require("@atlaskit/icon/core/log-out");
var _logOutDefault = parcelHelpers.interopDefault(_logOut);
var _person = require("@atlaskit/icon/core/person");
var _personDefault = parcelHelpers.interopDefault(_person);
var _compiled = require("@atlaskit/primitives/compiled");
var _config = require("../../../config");
var _messages = require("./messages");
var styles = {
    userMenuTrigger: "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itglyw _2rko1rr0 _1e0c116y _4cvr1h6o _1bah1h6o _bfhk1j28 _80omtlke _1ygb7g83 _1ah3v77o",
    userPicture: "_2rko1rr0 _1bsbzwfg _4t3izwfg _5ral1dfr _1e0c1ule",
    dropdownItem: "_1bsbuuw1"
};
var UserAvatarDropdown = function(param) {
    var user = param.user;
    var formatMessage = (0, _reactIntl.useIntl)().formatMessage;
    return /*#__PURE__*/ _react.createElement((0, _dropdownMenuDefault.default), {
        trigger: function(_param) {
            var triggerRef = _param.triggerRef, triggerProps = (0, _objectWithoutProperties._)(_param, [
                "triggerRef"
            ]);
            return /*#__PURE__*/ _react.createElement("button", (0, _objectSpreadProps._)((0, _objectSpread._)({}, triggerProps), {
                ref: triggerRef,
                type: "button",
                "aria-label": formatMessage((0, _messages.messages).userAccountMenuAriaLabel, {
                    userName: user.name
                }),
                className: (0, _runtime.ax)([
                    styles.userMenuTrigger
                ])
            }), /*#__PURE__*/ _react.createElement("img", {
                src: user.picture,
                alt: "",
                className: (0, _runtime.ax)([
                    styles.userPicture
                ])
            }));
        },
        shouldRenderToParent: true,
        placement: "bottom-end"
    }, /*#__PURE__*/ _react.createElement((0, _dropdownMenu.DropdownItemGroup), null, /*#__PURE__*/ _react.createElement((0, _dropdownMenu.DropdownItem), {
        onClick: function() {
            return window.open("".concat((0, _config.getConfig)().atlassianHomeUrl, "/people/").concat(encodeURIComponent(user.accountId)), '_blank');
        }
    }, /*#__PURE__*/ _react.createElement((0, _compiled.Inline), {
        space: "space.150",
        alignBlock: "center",
        xcss: styles.dropdownItem
    }, /*#__PURE__*/ _react.createElement((0, _personDefault.default), {
        label: formatMessage((0, _messages.messages).profileLabel)
    }), /*#__PURE__*/ _react.createElement((0, _compiled.Text), null, /*#__PURE__*/ _react.createElement((0, _reactIntl.FormattedMessage), (0, _messages.messages).profileLabel))))), /*#__PURE__*/ _react.createElement((0, _dropdownMenu.DropdownItemGroup), {
        hasSeparator: true
    }, /*#__PURE__*/ _react.createElement((0, _dropdownMenu.DropdownItem), {
        onClick: function() {
            globalThis.window.location.replace("".concat((0, _config.getConfig)().atlassianAccountUrl, "/logout?application=twg-microsite-bifrost&continue=").concat(encodeURIComponent((0, _config.getConfig)().serviceUrl)));
        }
    }, /*#__PURE__*/ _react.createElement((0, _compiled.Inline), {
        space: "space.150",
        alignBlock: "center",
        xcss: styles.dropdownItem
    }, /*#__PURE__*/ _react.createElement((0, _logOutDefault.default), {
        label: formatMessage((0, _messages.messages).logoutLabel)
    }), /*#__PURE__*/ _react.createElement((0, _compiled.Text), null, /*#__PURE__*/ _react.createElement((0, _reactIntl.FormattedMessage), (0, _messages.messages).logoutLabel))))));
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","@compiled/react/runtime":"d27Vo","react-intl":"f41fF","@atlaskit/dropdown-menu":"OX9kI","@atlaskit/icon/core/log-out":"4GkAM","@atlaskit/icon/core/person":"6cPB0","@atlaskit/primitives/compiled":"jhQE8","../../../config":"sjwAz","./messages":"ik60l","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"OX9kI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return 0, _dropdownMenuDefault.default;
});
parcelHelpers.export(exports, "DropdownItemGroup", function() {
    return 0, _dropdownMenuItemGroupDefault.default;
});
parcelHelpers.export(exports, "DropdownItem", function() {
    return 0, _dropdownMenuItemDefault.default;
});
parcelHelpers.export(exports, "DropdownItemCheckbox", function() {
    return 0, _dropdownItemCheckboxDefault.default;
});
parcelHelpers.export(exports, "DropdownItemCheckboxGroup", function() {
    return 0, _dropdownItemCheckboxGroupDefault.default;
});
parcelHelpers.export(exports, "DropdownItemRadio", function() {
    return 0, _dropdownItemRadioDefault.default;
});
parcelHelpers.export(exports, "DropdownItemRadioGroup", function() {
    return 0, _dropdownItemRadioGroupDefault.default;
});
var _dropdownMenu = require("./dropdown-menu");
var _dropdownMenuDefault = parcelHelpers.interopDefault(_dropdownMenu);
var _dropdownMenuItemGroup = require("./dropdown-menu-item-group");
var _dropdownMenuItemGroupDefault = parcelHelpers.interopDefault(_dropdownMenuItemGroup);
var _dropdownMenuItem = require("./dropdown-menu-item");
var _dropdownMenuItemDefault = parcelHelpers.interopDefault(_dropdownMenuItem);
var _dropdownItemCheckbox = require("./checkbox/dropdown-item-checkbox");
var _dropdownItemCheckboxDefault = parcelHelpers.interopDefault(_dropdownItemCheckbox);
var _dropdownItemCheckboxGroup = require("./checkbox/dropdown-item-checkbox-group");
var _dropdownItemCheckboxGroupDefault = parcelHelpers.interopDefault(_dropdownItemCheckboxGroup);
var _dropdownItemRadio = require("./radio/dropdown-item-radio");
var _dropdownItemRadioDefault = parcelHelpers.interopDefault(_dropdownItemRadio);
var _dropdownItemRadioGroup = require("./radio/dropdown-item-radio-group");
var _dropdownItemRadioGroupDefault = parcelHelpers.interopDefault(_dropdownItemRadioGroup);

},{"./dropdown-menu":"3YBZs","./dropdown-menu-item-group":"lidz0","./dropdown-menu-item":"c8OvS","./checkbox/dropdown-item-checkbox":false,"./checkbox/dropdown-item-checkbox-group":false,"./radio/dropdown-item-radio":false,"./radio/dropdown-item-radio-group":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3YBZs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _instanceof = require("@swc/helpers/_/_instanceof");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _bindEventListener = require("bind-event-listener");
var _new = require("@atlaskit/button/new");
var _newDefault = parcelHelpers.interopDefault(_new);
var _keycodes = require("@atlaskit/ds-lib/keycodes");
var _mergeRefs = require("@atlaskit/ds-lib/merge-refs");
var _mergeRefsDefault = parcelHelpers.interopDefault(_mergeRefs);
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var _useControlled = require("@atlaskit/ds-lib/use-controlled");
var _useControlledDefault = parcelHelpers.interopDefault(_useControlled);
var _useFocusEvent = require("@atlaskit/ds-lib/use-focus-event");
var _useFocusEventDefault = parcelHelpers.interopDefault(_useFocusEvent);
var _chevronDown = require("@atlaskit/icon/core/chevron-down");
var _chevronDownDefault = parcelHelpers.interopDefault(_chevronDown);
var _layering = require("@atlaskit/layering");
var _popup = require("@atlaskit/popup");
var _popupDefault = parcelHelpers.interopDefault(_popup);
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports
var _constants = require("@atlaskit/theme/constants");
var _focusManager = require("./internal/components/focus-manager");
var _focusManagerDefault = parcelHelpers.interopDefault(_focusManager);
var _menuWrapper = require("./internal/components/menu-wrapper");
var _menuWrapperDefault = parcelHelpers.interopDefault(_menuWrapper);
var _selectionStore = require("./internal/context/selection-store");
var _selectionStoreDefault = parcelHelpers.interopDefault(_selectionStore);
var _useRegisterItemWithFocusManager = require("./internal/hooks/use-register-item-with-focus-manager");
var _useRegisterItemWithFocusManagerDefault = parcelHelpers.interopDefault(_useRegisterItemWithFocusManager);
var _useGeneratedId = require("./internal/utils/use-generated-id");
var _useGeneratedIdDefault = parcelHelpers.interopDefault(_useGeneratedId);
var MAX_HEIGHT = "calc(100vh - 16px)";
var opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
var getFallbackPlacements = function(placement) {
    var placementPieces = placement.split('-');
    var mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        var crossAxis = placementPieces[1];
        return [
            "".concat(mainAxis),
            "".concat(mainAxis, "-").concat(opposites[crossAxis]),
            "".concat(opposites[mainAxis], "-").concat(crossAxis),
            "".concat(opposites[mainAxis]),
            "".concat(opposites[mainAxis], "-").concat(opposites[crossAxis]),
            'auto'
        ];
    } else return [
        "".concat(mainAxis, "-start"),
        "".concat(mainAxis, "-end"),
        "".concat(opposites[mainAxis]),
        "".concat(opposites[mainAxis], "-start"),
        "".concat(opposites[mainAxis], "-end"),
        "auto"
    ];
};
function isKeyboardEvent(event) {
    return event !== null && ((0, _instanceof._)(event, KeyboardEvent) || 'nativeEvent' in event && (0, _instanceof._)(event.nativeEvent, KeyboardEvent));
}
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ var DropdownMenu = function(param) {
    var _param_autoFocus = param.autoFocus, autoFocus = _param_autoFocus === void 0 ? false : _param_autoFocus, children = param.children, _param_defaultOpen = param.defaultOpen, defaultOpen = _param_defaultOpen === void 0 ? false : _param_defaultOpen, _param_isLoading = param.isLoading, isLoading = _param_isLoading === void 0 ? false : _param_isLoading, isOpen = param.isOpen, _param_onOpenChange = param.onOpenChange, onOpenChange = _param_onOpenChange === void 0 ? (0, _noopDefault.default) : _param_onOpenChange, _param_placement = param.placement, placement = _param_placement === void 0 ? 'bottom-start' : _param_placement, _param_shouldFitContainer = param.shouldFitContainer, shouldFitContainer = _param_shouldFitContainer === void 0 ? false : _param_shouldFitContainer, _param_shouldFlip = param.shouldFlip, shouldFlip = _param_shouldFlip === void 0 ? true : _param_shouldFlip, _param_shouldRenderToParent = param.shouldRenderToParent, shouldRenderToParent = _param_shouldRenderToParent === void 0 ? false : _param_shouldRenderToParent, returnFocusRef = param.returnFocusRef, spacing = param.spacing, statusLabel = param.statusLabel, testId = param.testId, trigger = param.trigger, _param_zIndex = param.zIndex, zIndex = _param_zIndex === void 0 ? (0, _constants.layers).modal() : _param_zIndex, label = param.label, interactionName = param.interactionName, strategy = param.strategy, menuLabel = param.menuLabel, _param_shouldPreventEscapePropagation = param.shouldPreventEscapePropagation, shouldPreventEscapePropagation = _param_shouldPreventEscapePropagation === void 0 ? false : _param_shouldPreventEscapePropagation;
    var _useControlledState = (0, _slicedToArray._)((0, _useControlledDefault.default)(isOpen, function() {
        return defaultOpen;
    }), 2), isLocalOpen = _useControlledState[0], setLocalIsOpen = _useControlledState[1];
    var triggerRef = (0, _react.useRef)(null);
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), isTriggeredUsingKeyboard = _useState[0], setTriggeredUsingKeyboard = _useState[1];
    var id = (0, _useGeneratedIdDefault.default)();
    var itemRef = (0, _useRegisterItemWithFocusManagerDefault.default)();
    var currentLevel = (0, _layering.useLayering)().currentLevel;
    var fallbackPlacements = (0, _react.useMemo)(function() {
        return getFallbackPlacements(placement);
    }, [
        placement
    ]);
    var handleTriggerClicked = (0, _react.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    function(event) {
        var newValue = !isLocalOpen;
        var clientX = event.clientX, clientY = event.clientY, type = event.type, detail = event.detail;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            var // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            _itemRef_current;
            itemRef === null || itemRef === void 0 ? void 0 : (_itemRef_current = itemRef.current) === null || _itemRef_current === void 0 ? void 0 : _itemRef_current.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange,
        itemRef
    ]);
    var handleOnClose = (0, _react.useCallback)(function(event, currentLevel) {
        var _event_target_closest, _event_target;
        var isTabLeftOrEscapeKey = isKeyboardEvent(event) && (event.key === 'Tab' || event.key === 'Escape' || event.key === (0, _keycodes.KEY_LEFT));
        // Stop propagation on ESCAPE or Left arrow if shouldPreventEscapePropagation is true
        if (shouldPreventEscapePropagation && isKeyboardEvent(event) && (event.key === 'Escape' || event.key === (0, _keycodes.KEY_LEFT))) event.stopPropagation();
        if (event !== null && !isTabLeftOrEscapeKey && (0, _instanceof._)(event.target, HTMLElement) && ((_event_target_closest = (_event_target = event.target).closest) === null || _event_target_closest === void 0 ? void 0 : _event_target_closest.call(_event_target, "[id^=".concat((0, _useGeneratedId.PREFIX), "] [aria-haspopup]")))) {
            var _itemRef_current;
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            var toCloseLevel = (_itemRef_current = itemRef.current) === null || _itemRef_current === void 0 ? void 0 : _itemRef_current.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(function() {
            var _returnFocusRef_current;
            (_returnFocusRef_current = returnFocusRef.current) === null || _returnFocusRef_current === void 0 ? void 0 : _returnFocusRef_current.focus();
        });
        else if (isKeyboardEvent(event) && (event.key === 'Tab' && event.shiftKey || event.key === 'Escape' || event.key === (0, _keycodes.KEY_LEFT))) requestAnimationFrame(function() {
            var _itemRef_current;
            (_itemRef_current = itemRef.current) === null || _itemRef_current === void 0 ? void 0 : _itemRef_current.focus();
        });
        else if (triggerRef.current) {
            var _event_target_closest1, _event_target1;
            // Don't focus the trigger if the click was outside of the menu
            var isClickOutsideMenu = (0, _instanceof._)(event === null || event === void 0 ? void 0 : event.target, HTMLElement) && ((_event_target_closest1 = (_event_target1 = event.target).closest) === null || _event_target_closest1 === void 0 ? void 0 : _event_target_closest1.call(_event_target1, '[role="menu"]')) === null;
            var shouldPreventFocus = isClickOutsideMenu && document.activeElement !== document.body; // except if clicking on the body
            if (!shouldPreventFocus) requestAnimationFrame(function() {
                var _triggerRef_current;
                (_triggerRef_current = triggerRef.current) === null || _triggerRef_current === void 0 ? void 0 : _triggerRef_current.focus();
            });
        }
        var newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen,
        shouldPreventEscapePropagation
    ]);
    var _useFocus = (0, _useFocusEventDefault.default)(), isFocused = _useFocus.isFocused, bindFocus = _useFocus.bindFocus;
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, _react.useEffect)(function() {
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, _noopDefault.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, _noopDefault.default;
        return (0, _bindEventListener.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                var isNestedTriggerButton;
                if ((0, _instanceof._)(e.target, HTMLElement)) isNestedTriggerButton = e.target.closest("[id^=".concat((0, _useGeneratedId.PREFIX), "] [aria-haspopup]"));
                if (e.key === (0, _keycodes.KEY_DOWN) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, _keycodes.KEY_SPACE) || e.key === (0, _keycodes.KEY_ENTER)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, _keycodes.KEY_TAB) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
	 * The Popup component requires either:
	 * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
	 * or
	 * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
	 *
	 * But not:
	 * - shouldFitContainer={true} and shouldRenderToParent={false}
	 *
	 * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
	 * types are satisfied.
	 */ var conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer,
        // When shouldFitContainer is true, `fixed` positions are not allowed
        strategy: strategy !== 'fixed' ? strategy : undefined
    } : {
        shouldRenderToParent: shouldRenderToParent,
        strategy: strategy
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectionStoreDefault.default), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popupDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({
            id: isLocalOpen ? id : undefined,
            shouldFlip: shouldFlip,
            isOpen: isLocalOpen,
            shouldReturnFocus: // If returnFocusRef is provided, we **don't** want to return focus to the trigger.
            // Otherwise, Popup will focus on the dropdown trigger after the `returnFocusRef` element is focused.
            returnFocusRef === undefined,
            onClose: handleOnClose,
            zIndex: zIndex,
            placement: placement,
            role: shouldRenderToParent && currentLevel > 0 ? 'group' : undefined,
            fallbackPlacements: fallbackPlacements,
            testId: testId && "".concat(testId, "--content"),
            shouldUseCaptureOnOutsideClick: true
        }, conditionalProps), {
            shouldDisableFocusLock: true,
            trigger: function(_param) {
                var ref = _param.ref, ariaControls = _param['aria-controls'], ariaExpanded = _param['aria-expanded'], ariaHasPopup = _param['aria-haspopup'], rest = (0, _objectWithoutProperties._)(_param, [
                    "ref",
                    'aria-controls',
                    'aria-expanded',
                    'aria-haspopup'
                ]);
                if (typeof trigger === 'function') return trigger((0, _objectSpreadProps._)((0, _objectSpread._)({
                    'aria-controls': ariaControls,
                    'aria-expanded': ariaExpanded,
                    'aria-haspopup': ariaHasPopup
                }, rest, bindFocus), {
                    triggerRef: (0, _mergeRefsDefault.default)([
                        ref,
                        triggerRef,
                        itemRef
                    ]),
                    isSelected: isLocalOpen,
                    onClick: handleTriggerClicked,
                    testId: testId && "".concat(testId, "--trigger")
                }));
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _newDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, bindFocus), {
                    ref: (0, _mergeRefsDefault.default)([
                        ref,
                        triggerRef,
                        itemRef
                    ]),
                    "aria-controls": ariaControls,
                    "aria-expanded": ariaExpanded,
                    "aria-haspopup": ariaHasPopup,
                    isSelected: isLocalOpen,
                    iconAfter: function(iconProps) {
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chevronDownDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, iconProps), {
                            size: "small"
                        }));
                    },
                    onClick: handleTriggerClicked,
                    testId: testId && "".concat(testId, "--trigger"),
                    "aria-label": label,
                    interactionName: interactionName,
                    children: trigger
                }));
            },
            content: function(param) {
                var setInitialFocusRef = param.setInitialFocusRef, update = param.update;
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _focusManagerDefault.default), {
                    onClose: handleOnClose,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuWrapperDefault.default), {
                        spacing: spacing,
                        maxHeight: MAX_HEIGHT,
                        maxWidth: shouldFitContainer ? undefined : 800,
                        onClose: handleOnClose,
                        onUpdate: update,
                        isLoading: isLoading,
                        statusLabel: statusLabel,
                        setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                        shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                        isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                        autoFocus: autoFocus,
                        testId: testId && "".concat(testId, "--menu-wrapper"),
                        menuLabel: menuLabel,
                        children: children
                    })
                });
            }
        }))
    });
};
exports.default = DropdownMenu;

},{"@swc/helpers/_/_instanceof":"h9UKc","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","@swc/helpers/_/_sliced_to_array":"8PtL6","react/jsx-runtime":"bGvcw","react":"ltHCL","bind-event-listener":"bjeUU","@atlaskit/button/new":"2LnSZ","@atlaskit/ds-lib/keycodes":"fHxyW","@atlaskit/ds-lib/merge-refs":"bhv2L","@atlaskit/ds-lib/noop":"2f3bg","@atlaskit/ds-lib/use-controlled":"gaF7c","@atlaskit/ds-lib/use-focus-event":"dI0tQ","@atlaskit/icon/core/chevron-down":"6b1ia","@atlaskit/layering":"laO1Y","@atlaskit/popup":"9PMZe","@atlaskit/theme/constants":"3DRjL","./internal/components/focus-manager":"bPN8A","./internal/components/menu-wrapper":"8Fn6w","./internal/context/selection-store":"gCnRU","./internal/hooks/use-register-item-with-focus-manager":"eBixg","./internal/utils/use-generated-id":"61rZz","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gaF7c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return useControlled;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
function useControlled(propValue) {
    var getDefaultPropValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {
        return propValue;
    };
    var isControlled = propValue !== undefined;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(getDefaultPropValue), 2), valueState = _useState[0], setValue = _useState[1];
    var isControlledRef = (0, _react.useRef)(isControlled);
    (0, _react.useEffect)(function() {
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    var value = isControlled ? propValue : valueState;
    var setValueIfUncontrolled = (0, _react.useCallback)(function(newValue) {
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dI0tQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return useFocus;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
function useFocus() {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), isFocused = _useState[0], setIsFocused = _useState[1];
    // ensure bindFocus has a stable ref
    var bindFocus = (0, _react.useRef)({
        onFocus: function() {
            return setIsFocused(true);
        },
        onBlur: function() {
            return setIsFocused(false);
        }
    });
    (0, _react.useEffect)(function() {
        // handle the case where a component might
        // unmount while being focused.
        return function() {
            return setIsFocused(false);
        };
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bPN8A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _bindEventListener = require("bind-event-listener");
var _layering = require("@atlaskit/layering");
var _handleFocus = require("../utils/handle-focus");
var _handleFocusDefault = parcelHelpers.interopDefault(_handleFocus);
var _focusManagerContext = require("./focus-manager-context");
/**
 * Focus manager logic.
 */ var FocusManager = function(param) {
    var children = param.children, onClose = param.onClose;
    var menuItemRefs = (0, _react.useRef)([]);
    // Used to force a re-render only
    var _useState = (0, _slicedToArray._)((0, _react.useState)(0), 2), refresh = _useState[0], setRefresh = _useState[1];
    var registerMode = (0, _react.useRef)('ordered');
    registerMode.current = 'ordered';
    var registerRef = (0, _react.useCallback)(function(ref) {
        if (menuItemRefs.current.includes(ref)) return;
        switch(registerMode.current){
            case 'ordered':
                menuItemRefs.current.push(ref);
                break;
            case 'unordered':
                // Reset and force a rerender
                registerMode.current = 'regenerate';
                menuItemRefs.current = [];
                setRefresh(refresh + 1);
                break;
            case 'regenerate':
                break;
            default:
                throw new Error("Unexpected case of ".concat(registerMode.current));
        }
    }, // Updating register ref on force reload will cause `useRegisterItemWithFocusManager` to re-register
    [
        refresh
    ]);
    var _useLayering = (0, _layering.useLayering)(), isLayerDisabled = _useLayering.isLayerDisabled, currentLevel = _useLayering.currentLevel;
    // Root menu (from a button) is at level 1; first submenu is at level 2. ARIA: Left only closes submenus.
    var isNestedMenu = currentLevel > 1;
    // Intentionally rebinding on each render
    (0, _react.useEffect)(function() {
        if (registerMode.current === 'ordered') // Use effect is called after rendering is complete and useEffects of the children a called first
        registerMode.current = 'unordered';
    });
    (0, _react.useEffect)(function() {
        return (0, _bindEventListener.bind)(window, {
            type: 'keydown',
            listener: (0, _handleFocusDefault.default)(menuItemRefs, isLayerDisabled, onClose, isNestedMenu)
        });
    }, [
        isLayerDisabled,
        onClose,
        isNestedMenu
    ]);
    var contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _focusManagerContext.FocusManagerContext).Provider, {
        value: contextValue,
        children: children
    });
};
exports.default = FocusManager;

},{"@swc/helpers/_/_sliced_to_array":"8PtL6","react/jsx-runtime":"bGvcw","react":"ltHCL","bind-event-listener":"bjeUU","@atlaskit/layering":"laO1Y","../utils/handle-focus":"jy2rt","./focus-manager-context":"ajzLU","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jy2rt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return handleFocus;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _instanceof = require("@swc/helpers/_/_instanceof");
var _keycodes = require("@atlaskit/ds-lib/keycodes");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _useGeneratedId = require("./use-generated-id");
var _obj;
var actionMap = (_obj = {}, (0, _defineProperty._)(_obj, (0, _keycodes.KEY_DOWN), 'next'), (0, _defineProperty._)(_obj, (0, _keycodes.KEY_UP), 'prev'), (0, _defineProperty._)(_obj, (0, _keycodes.KEY_HOME), 'first'), (0, _defineProperty._)(_obj, (0, _keycodes.KEY_END), 'last'), _obj);
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ var getNextFocusableElement = function(refs, currentFocusedIdx) {
    for(var i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx + 1 === refs.length) currentFocusedIdx = 0;
        else currentFocusedIdx++;
        var _refs_currentFocusedIdx = refs[currentFocusedIdx], element = _refs_currentFocusedIdx.current;
        var isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ var getPrevFocusableElement = function(refs, currentFocusedIdx) {
    for(var i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx === 0) currentFocusedIdx = refs.length - 1;
        else currentFocusedIdx--;
        var _refs_currentFocusedIdx = refs[currentFocusedIdx], element = _refs_currentFocusedIdx.current;
        var isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
function handleFocus(refs, isLayerDisabled, onClose) {
    var isNestedMenu = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    return function(e) {
        var _refs_current;
        var currentRefs = (_refs_current = refs.current) !== null && _refs_current !== void 0 ? _refs_current : [];
        var currentFocusedIdx = currentRefs.findIndex(function(param) {
            var el = param.current;
            var _document_activeElement;
            return el && ((_document_activeElement = document.activeElement) === null || _document_activeElement === void 0 ? void 0 : _document_activeElement.isSameNode(el));
        });
        if ((0, _platformFeatureFlags.fg)('platform_dst_popup-disable-focuslock')) {
            var _document_activeElement;
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            var isNestedDropdown = !!((_document_activeElement = document.activeElement) === null || _document_activeElement === void 0 ? void 0 : _document_activeElement.closest("[id^=".concat((0, _useGeneratedId.PREFIX), "]")));
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, _keycodes.KEY_TAB) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, _keycodes.KEY_TAB) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        // Left arrow: only in a submenu — close and return focus to parent. No navigation within menu.
        if (e.key === (0, _keycodes.KEY_LEFT)) {
            e.preventDefault();
            if (isNestedMenu) onClose(e);
            return;
        }
        // Right arrow: only when item has submenu — open it. No navigation within menu.
        if (e.key === (0, _keycodes.KEY_RIGHT)) {
            var activeElement = document.activeElement;
            if ((0, _instanceof._)(activeElement, HTMLElement) && (activeElement.getAttribute('aria-haspopup') === 'true' || activeElement.getAttribute('aria-haspopup') === 'menu')) {
                e.preventDefault();
                activeElement.click();
            }
            return;
        }
        var action = actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                var nextFocusableElement = getNextFocusableElement(currentRefs, currentFocusedIdx);
                nextFocusableElement === null || nextFocusableElement === void 0 ? void 0 : nextFocusableElement.focus();
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                var prevFocusableElement = getPrevFocusableElement(currentRefs, currentFocusedIdx);
                prevFocusableElement === null || prevFocusableElement === void 0 ? void 0 : prevFocusableElement.focus();
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                var firstFocusableElement = getNextFocusableElement(currentRefs, -1);
                firstFocusableElement === null || firstFocusableElement === void 0 ? void 0 : firstFocusableElement.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                var lastFocusableElement = getPrevFocusableElement(currentRefs, currentRefs.length);
                lastFocusableElement === null || lastFocusableElement === void 0 ? void 0 : lastFocusableElement.focus();
                break;
            default:
                return;
        }
    };
}

},{"@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_instanceof":"h9UKc","@atlaskit/ds-lib/keycodes":"fHxyW","@atlaskit/platform-feature-flags":"kO5t9","./use-generated-id":"61rZz","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"61rZz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PREFIX", function() {
    return PREFIX;
});
parcelHelpers.export(exports, "default", function() {
    return useGeneratedId;
});
var _useId = require("@atlaskit/ds-lib/use-id");
var PREFIX = 'ds--dropdown--';
function useGeneratedId() {
    var id = (0, _useId.useId)();
    return "".concat(PREFIX).concat(id);
}

},{"@atlaskit/ds-lib/use-id":"axFod","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ajzLU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FocusManagerContext", function() {
    return FocusManagerContext;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var FocusManagerContext = /*#__PURE__*/ (0, _react.createContext)({
    menuItemRefs: [],
    registerRef: (0, _noopDefault.default)
});

},{"react":"ltHCL","@atlaskit/ds-lib/noop":"2f3bg","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8Fn6w":[function(require,module,exports,__globalThis) {
/* menu-wrapper.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _menuGroup = require("@atlaskit/menu/menu-group");
var _menuGroupDefault = parcelHelpers.interopDefault(_menuGroup);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _compiled = require("@atlaskit/primitives/compiled");
var _spinner = require("@atlaskit/spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _isCheckboxItem = require("../utils/is-checkbox-item");
var _isCheckboxItemDefault = parcelHelpers.interopDefault(_isCheckboxItem);
var _isRadioItem = require("../utils/is-radio-item");
var _isRadioItemDefault = parcelHelpers.interopDefault(_isRadioItem);
var _focusManagerContext = require("./focus-manager-context");
var styles = {
    spinnerContainer: "_1e0c1txw _1ul91lit _1bah1h6o _1q51v47k _y4tiv47k _85i5v47k _bozgv47k"
};
var LoadingIndicator = function(param) {
    var _param_statusLabel = param.statusLabel, statusLabel = _param_statusLabel === void 0 ? 'Loading' : _param_statusLabel, testId = param.testId;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _compiled.Box), {
        xcss: styles.spinnerContainer,
        role: "menuitem",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {
            size: "small",
            label: statusLabel,
            testId: testId
        })
    });
};
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ var MenuWrapper = function(param) {
    var children = param.children, isLoading = param.isLoading, maxHeight = param.maxHeight, maxWidth = param.maxWidth, onClose = param.onClose, onUpdate = param.onUpdate, statusLabel = param.statusLabel, setInitialFocusRef = param.setInitialFocusRef, shouldRenderToParent = param.shouldRenderToParent, spacing = param.spacing, testId = param.testId, isTriggeredUsingKeyboard = param.isTriggeredUsingKeyboard, autoFocus = param.autoFocus, menuLabel = param.menuLabel;
    var menuItemRefs = (0, _react.useContext)((0, _focusManagerContext.FocusManagerContext)).menuItemRefs;
    var closeOnMenuItemClick = function(e) {
        var isTargetMenuItemOrDescendant = menuItemRefs.some(function(menuItemRef) {
            var menuItem = menuItemRef.current;
            if (!menuItem) return false;
            var isCheckboxOrRadio = (0, _isCheckboxItemDefault.default)(menuItem) || (0, _isRadioItemDefault.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDescendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, _react.useLayoutEffect)(function() {
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, _react.useEffect)(function() {
        var _menuItemRefs_map_find;
        var firstFocusableRef = (_menuItemRefs_map_find = menuItemRefs.map(function(param) {
            var current = param.current;
            return current;
        }).find(function(el) {
            return !!el && !el.hasAttribute('disabled');
        })) !== null && _menuItemRefs_map_find !== void 0 ? _menuItemRefs_map_find : null;
        if (((0, _platformFeatureFlags.fg)('platform_dst_menu_item_focus') || shouldRenderToParent) && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef === null || firstFocusableRef === void 0 ? void 0 : firstFocusableRef.focus();
        setInitialFocusRef === null || setInitialFocusRef === void 0 ? void 0 : setInitialFocusRef(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuGroupDefault.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && "".concat(testId, "--menu-group"),
        menuLabel: menuLabel,
        children: isLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(LoadingIndicator, {
            statusLabel: statusLabel,
            testId: testId && "".concat(testId, "--loading-indicator")
        }) : children
    });
};
exports.default = MenuWrapper;

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","@atlaskit/menu/menu-group":"jWEX5","@atlaskit/platform-feature-flags":"kO5t9","@atlaskit/primitives/compiled":"jhQE8","@atlaskit/spinner":"04ZYE","../utils/is-checkbox-item":"hOPTP","../utils/is-radio-item":"RdQqs","./focus-manager-context":"ajzLU","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jWEX5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return 0, _menuGroupDefault.default;
});
var _menuGroup = require("../../menu-section/menu-group");
var _menuGroupDefault = parcelHelpers.interopDefault(_menuGroup);

},{"../../menu-section/menu-group":"e3SBq","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hOPTP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isCheckboxItem;
});
function isCheckboxItem(element) {
    var role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"RdQqs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isCheckboxItem;
});
function isCheckboxItem(element) {
    var role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gCnRU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _selectionStoreContext = require("./selection-store-context");
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ var SelectionStore = function(props) {
    var children = props.children;
    var store = (0, _react.useRef)({});
    var context = (0, _react.useMemo)(function() {
        return {
            setItemState: function(group, id, value) {
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: function(group, id) {
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: function(group, value) {
                store.current[group] = value;
            },
            getGroupState: function(group) {
                return store.current[group] || {};
            }
        };
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectionStoreContext.SelectionStoreContext).Provider, {
        value: context,
        children: children
    });
};
exports.default = SelectionStore;

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","./selection-store-context":"ijea9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ijea9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SelectionStoreContext", function() {
    return SelectionStoreContext;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var SelectionStoreContext = /*#__PURE__*/ (0, _react.createContext)({
    setItemState: (0, _noopDefault.default),
    getItemState: function() {
        return undefined;
    },
    setGroupState: (0, _noopDefault.default),
    getGroupState: function() {
        return {};
    }
});

},{"react":"ltHCL","@atlaskit/ds-lib/noop":"2f3bg","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eBixg":[function(require,module,exports,__globalThis) {
// eslint-disable-next-line sort-imports
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _focusManagerContext = require("../components/focus-manager-context");
// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programmatically
// control focus on a user navigates using the keyboard.
function useRegisterItemWithFocusManager() {
    var hasPopup = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var registerRef = (0, _react.useContext)((0, _focusManagerContext.FocusManagerContext)).registerRef;
    var itemRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(function() {
        if (hasPopup && (0, _platformFeatureFlags.fg)('select-avoid-duplicated-registered-ref')) return;
        registerRef(itemRef);
    }, [
        registerRef,
        hasPopup
    ]);
    return itemRef;
}
exports.default = useRegisterItemWithFocusManager;

},{"react":"ltHCL","@atlaskit/platform-feature-flags":"kO5t9","../components/focus-manager-context":"ajzLU","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lidz0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useId = require("@atlaskit/ds-lib/use-id");
var _menu = require("@atlaskit/menu");
var _groupTitle = require("./internal/components/group-title");
var _groupTitleDefault = parcelHelpers.interopDefault(_groupTitle);
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ var DropdownMenuItemGroup = /*#__PURE__*/ (0, _react.forwardRef)(function(_param, ref) {
    var children = _param.children, id = _param.id, isList = _param.isList, isScrollable = _param.isScrollable, title = _param.title, testId = _param.testId, hasSeparator = _param.hasSeparator, rest = (0, _objectWithoutProperties._)(_param, [
        "children",
        "id",
        "isList",
        "isScrollable",
        "title",
        "testId",
        "hasSeparator"
    ]);
    var uid = (0, _useId.useId)();
    var titleId = "dropdown-menu-item-group-title-".concat(uid);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.Section), (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined
    }, rest), {
        children: [
            title && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _groupTitleDefault.default), {
                id: titleId,
                title: title
            }),
            children
        ]
    }));
});
exports.default = DropdownMenuItemGroup;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react/jsx-runtime":"bGvcw","react":"ltHCL","@atlaskit/ds-lib/use-id":"axFod","@atlaskit/menu":"drNQs","./internal/components/group-title":"2Pv9e","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2Pv9e":[function(require,module,exports,__globalThis) {
/* group-title.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _compiled = require("@atlaskit/primitives/compiled");
var styles = {
    heading: "_11c8i4vh _1rjcze3t _18zrpxbi _syazazsu"
};
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups
 *
 * @internal
 */ var GroupTitle = function(param) {
    var id = param.id, title = param.title;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _compiled.Box), {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        xcss: styles.heading,
        children: title
    });
};
exports.default = GroupTitle;

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","@atlaskit/primitives/compiled":"jhQE8","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"c8OvS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _mergeRefs = require("@atlaskit/ds-lib/merge-refs");
var _mergeRefsDefault = parcelHelpers.interopDefault(_mergeRefs);
var _buttonItem = require("@atlaskit/menu/button-item");
var _buttonItemDefault = parcelHelpers.interopDefault(_buttonItem);
var _customItem = require("@atlaskit/menu/custom-item");
var _customItemDefault = parcelHelpers.interopDefault(_customItem);
var _linkItem = require("@atlaskit/menu/link-item");
var _linkItemDefault = parcelHelpers.interopDefault(_linkItem);
var _useRegisterItemWithFocusManager = require("./internal/hooks/use-register-item-with-focus-manager");
var _useRegisterItemWithFocusManagerDefault = parcelHelpers.interopDefault(_useRegisterItemWithFocusManager);
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item/usage)
 */ var DropdownMenuItem = /*#__PURE__*/ (0, _react.forwardRef)(function(_param, ref) {
    var children = _param.children, component = _param.component, description = _param.description, elemAfter = _param.elemAfter, elemBefore = _param.elemBefore, href = _param.href, isDisabled = _param.isDisabled, isSelected = _param.isSelected, onClick = _param.onClick, rel = _param.rel, _param_shouldDescriptionWrap = _param.shouldDescriptionWrap, shouldDescriptionWrap = _param_shouldDescriptionWrap === void 0 ? true : _param_shouldDescriptionWrap, _param_shouldTitleWrap = _param.shouldTitleWrap, shouldTitleWrap = _param_shouldTitleWrap === void 0 ? true : _param_shouldTitleWrap, target = _param.target, testId = _param.testId, UNSAFE_shouldDisableRouterLink = _param.UNSAFE_shouldDisableRouterLink, returnFocusRef = _param.returnFocusRef, interactionName = _param.interactionName, role = _param.role, rest = (0, _objectWithoutProperties._)(_param, [
        "children",
        "component",
        "description",
        "elemAfter",
        "elemBefore",
        "href",
        "isDisabled",
        "isSelected",
        "onClick",
        "rel",
        "shouldDescriptionWrap",
        "shouldTitleWrap",
        "target",
        "testId",
        "UNSAFE_shouldDisableRouterLink",
        "returnFocusRef",
        "interactionName",
        "role"
    ]);
    // if the dropdown item has aria-haspopup, we won't register with focus manager
    // since it is a nested trigger, we have registered inside dropdown-menu
    var itemRef = (0, _useRegisterItemWithFocusManagerDefault.default)(!!rest['aria-haspopup']);
    var handleItemClick = (0, _react.useCallback)(function(event) {
        if (returnFocusRef === null || returnFocusRef === void 0 ? void 0 : returnFocusRef.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customItemDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, _mergeRefsDefault.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        interactionName: interactionName
    }, rest), {
        children: children
    }));
    else if (href) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkItemDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, _mergeRefsDefault.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        interactionName: interactionName
    }, rest), {
        children: children
    }));
    else return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonItemDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, _mergeRefsDefault.default)([
            ref,
            itemRef
        ]),
        role: role || 'menuitem',
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        interactionName: interactionName
    }, rest), {
        children: children
    }));
});
exports.default = DropdownMenuItem;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react/jsx-runtime":"bGvcw","react":"ltHCL","@atlaskit/ds-lib/merge-refs":"bhv2L","@atlaskit/menu/button-item":"jPxdQ","@atlaskit/menu/custom-item":"49lt0","@atlaskit/menu/link-item":"lRLUT","./internal/hooks/use-register-item-with-focus-manager":"eBixg","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jPxdQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return 0, _buttonItemDefault.default;
});
var _buttonItem = require("../../menu-item/button-item");
var _buttonItemDefault = parcelHelpers.interopDefault(_buttonItem);

},{"../../menu-item/button-item":"6Dsx3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"49lt0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return 0, _customItemDefault.default;
});
var _customItem = require("../../menu-item/custom-item");
var _customItemDefault = parcelHelpers.interopDefault(_customItem);

},{"../../menu-item/custom-item":"84i1Q","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lRLUT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return 0, _linkItemDefault.default;
});
var _linkItem = require("../../menu-item/link-item");
var _linkItemDefault = parcelHelpers.interopDefault(_linkItem);

},{"../../menu-item/link-item":"3Zkbe","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4GkAM":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::282b63b14f5d8b9b1a4035ff1652d30e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("e96cc69b3141b3b2"));
var _baseNew = _interopRequireDefault(require("c964f2522605f27a"));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LogOut".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for log out.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ var LogOutIcon = function(props) {
    return /*#__PURE__*/ _react.default.createElement(_baseNew.default, Object.assign({
        name: "LogOutIcon",
        dangerouslySetGlyph: '<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5h5V1H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h5v-1.5H3a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5m11.78 4.97-3.5-3.5-1.06 1.06 2.22 2.22H6v1.5h6.44l-2.22 2.22 1.06 1.06 3.5-3.5a.75.75 0 0 0 0-1.06" clip-rule="evenodd"/>'
    }, props));
};
LogOutIcon.displayName = 'LogOutIcon';
var _default = exports.default = LogOutIcon;

},{"e96cc69b3141b3b2":"ltHCL","c964f2522605f27a":"kuGeY"}],"6cPB0":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fc4353a18034f564a0b3573d4163ea60>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("539b6ac0d1bc605d"));
var _baseNew = _interopRequireDefault(require("acbeda8d8cd09c61"));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ var PersonIcon = function(props) {
    return /*#__PURE__*/ _react.default.createElement(_baseNew.default, Object.assign({
        name: "PersonIcon",
        dangerouslySetGlyph: '<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-2 9a3.75 3.75 0 0 1 3.75-3.75h4.5A3.75 3.75 0 0 1 14 13v2h-1.5v-2a2.25 2.25 0 0 0-2.25-2.25h-4.5A2.25 2.25 0 0 0 3.5 13v2H2z" clip-rule="evenodd"/>'
    }, props));
};
PersonIcon.displayName = 'PersonIcon';
var _default = exports.default = PersonIcon;

},{"539b6ac0d1bc605d":"ltHCL","acbeda8d8cd09c61":"kuGeY"}],"jT3Dw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AnalyticsProvider", function() {
    return AnalyticsProvider;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _analyticsListeners = require("@atlaskit/analytics-listeners");
var _analyticsListenersDefault = parcelHelpers.interopDefault(_analyticsListeners);
var _attribution = require("./attribution");
var DEFAULT_SOURCE = 'teamworkGraph';
/**
 * Track-event keys (matching `${actionSubject}.${action}`) that should
 * have first-touch acquisition attribution merged into their attributes.
 *
 * Track events are usually post-login conversions worth attributing
 * (e.g. `user.loggedIn`). Add to this set as new conversion-style track
 * events are introduced.
 */ var TRACK_EVENTS_WITH_ATTRIBUTION = new Set([
    'user.loggedIn'
]);
/**
 * Predicate: should this event automatically inherit the AttributionContext
 * fields (utmSource, trafficSource, gclid, etc.) from `attribution.ts`?
 *
 * Policy:
 *   - All `screen.*` events (page-view-equivalent — always relevant for
 *     funnel slicing).
 *   - All `ui.*` events (CTA clicks, scroll-to-bottom, section reveals,
 *     dropdown interactions — every user interaction is a candidate
 *     funnel step worth attributing).
 *   - Track events listed in TRACK_EVENTS_WITH_ATTRIBUTION (conversions
 *     only — most track events are domain-specific signals that don't
 *     benefit from marketing attribution).
 *   - All `operational.*` events stay lean — they are infra telemetry
 *     (API timing, request success/failure) that marketing dashboards
 *     do not consume.
 *
 * Designed so adding a NEW UI or screen event in the future requires
 * zero changes here: the new event automatically inherits attribution.
 */ var shouldAttachAttribution = function(eventType, actionSubject, action) {
    if (eventType === 'screen') return true;
    if (eventType === 'ui') return true;
    if (eventType === 'track') return TRACK_EVENTS_WITH_ATTRIBUTION.has("".concat(actionSubject, ".").concat(action));
    return false;
};
/**
 * Reads the persisted first-touch attribution + anon ID and returns the
 * attribute bag to merge into outgoing events. Defensive — any failure
 * (SSR, blocked storage, JSON parse error inside attribution.ts) collapses
 * to an empty object so an event still fires.
 */ var getAttributionAttrs = function() {
    try {
        return (0, _attribution.getAttribution)();
    } catch (e) {
        return {};
    }
};
/**
 * Adapts @atlassiansox/analytics-web-client to the @atlaskit/analytics-listeners
 * AnalyticsWebClient type. The two packages define AnalyticsWebClient with different
 * method signatures — the SOX version requires `action` and `source` fields that
 * may not be present in the GasPurePayload type. This adapter fills in defaults.
 *
 * Also automatically merges first-touch acquisition attribution
 * (`AttributionContext` from `analytics.spec.yaml`) into the events that
 * feed marketing-conversion dashboards. Call-sites do not need to know
 * about attribution — it rides along for free on the events listed above.
 */ var useAnalyticsClientAdapter = function(client) {
    return (0, _react.useMemo)(function() {
        return {
            sendUIEvent: function(event) {
                var _event_actionSubject, _event_action, _event_attributes;
                var withAttribution = shouldAttachAttribution('ui', (_event_actionSubject = event.actionSubject) !== null && _event_actionSubject !== void 0 ? _event_actionSubject : '', (_event_action = event.action) !== null && _event_action !== void 0 ? _event_action : '') ? (0, _objectSpreadProps._)((0, _objectSpread._)({}, event), {
                    attributes: (0, _objectSpread._)({}, getAttributionAttrs(), (_event_attributes = event.attributes) !== null && _event_attributes !== void 0 ? _event_attributes : {})
                }) : event;
                return client.sendUIEvent((0, _objectSpreadProps._)((0, _objectSpread._)({}, withAttribution), {
                    action: withAttribution.action || '',
                    source: withAttribution.source || DEFAULT_SOURCE
                }));
            },
            sendOperationalEvent: function(event) {
                return(// Operational events are infra telemetry — never attributed.
                client.sendOperationalEvent((0, _objectSpreadProps._)((0, _objectSpread._)({}, event), {
                    action: event.action || '',
                    source: event.source || DEFAULT_SOURCE
                })));
            },
            sendTrackEvent: function(event) {
                var _event_actionSubject, _event_action, _event_attributes;
                var withAttribution = shouldAttachAttribution('track', (_event_actionSubject = event.actionSubject) !== null && _event_actionSubject !== void 0 ? _event_actionSubject : '', (_event_action = event.action) !== null && _event_action !== void 0 ? _event_action : '') ? (0, _objectSpreadProps._)((0, _objectSpread._)({}, event), {
                    attributes: (0, _objectSpread._)({}, getAttributionAttrs(), (_event_attributes = event.attributes) !== null && _event_attributes !== void 0 ? _event_attributes : {})
                }) : event;
                return client.sendTrackEvent((0, _objectSpreadProps._)((0, _objectSpread._)({}, withAttribution), {
                    action: withAttribution.action || '',
                    source: withAttribution.source || DEFAULT_SOURCE
                }));
            },
            sendScreenEvent: function(event) {
                var _event_attributes;
                var withAttribution = shouldAttachAttribution('screen', '', '') ? (0, _objectSpreadProps._)((0, _objectSpread._)({}, event), {
                    attributes: (0, _objectSpread._)({}, getAttributionAttrs(), (_event_attributes = event.attributes) !== null && _event_attributes !== void 0 ? _event_attributes : {})
                }) : event;
                return client.sendScreenEvent(withAttribution);
            }
        };
    }, [
        client
    ]);
};
var AnalyticsProvider = function(param) {
    var children = param.children, analyticsClient = param.analyticsClient;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _analyticsListenersDefault.default), {
        client: useAnalyticsClientAdapter(analyticsClient)
    }, children);
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","@atlaskit/analytics-listeners":"c8lX6","./attribution":"dTmHb","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"c8lX6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return 0, _fabricAnalyticsListenersDefault.default;
});
parcelHelpers.export(exports, "LOG_LEVEL", function() {
    return 0, _logger.LOG_LEVEL;
});
parcelHelpers.export(exports, "FabricChannel", function() {
    return 0, _types.FabricChannel;
});
var _fabricAnalyticsListeners = require("./FabricAnalyticsListeners");
var _fabricAnalyticsListenersDefault = parcelHelpers.interopDefault(_fabricAnalyticsListeners);
var _logger = require("./helpers/logger");
var _types = require("./types");

},{"./FabricAnalyticsListeners":"9qDOx","./helpers/logger":"d8Nlm","./types":"eUjnT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9qDOx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _types = require("./types");
var _fabricElementsListener = require("./fabric/FabricElementsListener");
var _fabricElementsListenerDefault = parcelHelpers.interopDefault(_fabricElementsListener);
var _atlaskitListener = require("./atlaskit/AtlaskitListener");
var _atlaskitListenerDefault = parcelHelpers.interopDefault(_atlaskitListener);
var _logger = require("./helpers/logger");
var _loggerDefault = parcelHelpers.interopDefault(_logger);
var _navigationListener = require("./navigation/NavigationListener");
var _navigationListenerDefault = parcelHelpers.interopDefault(_navigationListener);
var _fabricEditorListener = require("./fabric/FabricEditorListener");
var _fabricEditorListenerDefault = parcelHelpers.interopDefault(_fabricEditorListener);
var _mediaAnalyticsListener = require("./media/MediaAnalyticsListener");
var _mediaAnalyticsListenerDefault = parcelHelpers.interopDefault(_mediaAnalyticsListener);
var _peopleTeamsAnalyticsListener = require("./peopleTeams/PeopleTeamsAnalyticsListener");
var _peopleTeamsAnalyticsListenerDefault = parcelHelpers.interopDefault(_peopleTeamsAnalyticsListener);
var _notificationsAnalyticsListener = require("./notifications/NotificationsAnalyticsListener");
var _notificationsAnalyticsListenerDefault = parcelHelpers.interopDefault(_notificationsAnalyticsListener);
var _recentWorkAnalyticsListener = require("./recentWork/RecentWorkAnalyticsListener");
var _recentWorkAnalyticsListenerDefault = parcelHelpers.interopDefault(_recentWorkAnalyticsListener);
var _atlasAnalyticsListener = require("./atlas/AtlasAnalyticsListener");
var _atlasAnalyticsListenerDefault = parcelHelpers.interopDefault(_atlasAnalyticsListener);
var _crossFlowAnalyticsListener = require("./cross-flow/CrossFlowAnalyticsListener");
var _crossFlowAnalyticsListenerDefault = parcelHelpers.interopDefault(_crossFlowAnalyticsListener);
var _linkingPlatformAnalyticsListener = require("./linkingPlatform/LinkingPlatformAnalyticsListener");
var _linkingPlatformAnalyticsListenerDefault = parcelHelpers.interopDefault(_linkingPlatformAnalyticsListener);
var _postOfficeAnalyticsListener = require("./postOffice/PostOfficeAnalyticsListener");
var _postOfficeAnalyticsListenerDefault = parcelHelpers.interopDefault(_postOfficeAnalyticsListener);
var _aimateAnalyticsListener = require("./aiMate/AIMateAnalyticsListener");
var _aimateAnalyticsListenerDefault = parcelHelpers.interopDefault(_aimateAnalyticsListener);
var _avpanalyticsListener = require("./avp/AVPAnalyticsListener");
var _avpanalyticsListenerDefault = parcelHelpers.interopDefault(_avpanalyticsListener);
var _growthAnalyticsListener = require("./growth/GrowthAnalyticsListener");
var _growthAnalyticsListenerDefault = parcelHelpers.interopDefault(_growthAnalyticsListener);
var _omniChannelAnalyticsListener = require("./omni-channel/OmniChannelAnalyticsListener");
var _omniChannelAnalyticsListenerDefault = parcelHelpers.interopDefault(_omniChannelAnalyticsListener);
var _townsquareHomeAnalyticsListener = require("./townsquareHome/TownsquareHomeAnalyticsListener");
var _townsquareHomeAnalyticsListenerDefault = parcelHelpers.interopDefault(_townsquareHomeAnalyticsListener);
var _rovoExtensionAnalyticsListener = require("./rovoExtension/RovoExtensionAnalyticsListener");
var _rovoExtensionAnalyticsListenerDefault = parcelHelpers.interopDefault(_rovoExtensionAnalyticsListener);
var _teamworkGraphAnalyticsListener = require("./teamworkGraph/TeamworkGraphAnalyticsListener");
var _teamworkGraphAnalyticsListenerDefault = parcelHelpers.interopDefault(_teamworkGraphAnalyticsListener);
var _obj;
var listenerMap = (_obj = {}, (0, _defineProperty._)(_obj, (0, _types.FabricChannel).elements, (0, _fabricElementsListenerDefault.default)), (0, _defineProperty._)(_obj, (0, _types.FabricChannel).editor, (0, _fabricEditorListenerDefault.default)), (0, _defineProperty._)(_obj, (0, _types.FabricChannel).atlaskit, (0, _atlaskitListenerDefault.default)), (0, _defineProperty._)(_obj, (0, _types.FabricChannel).navigation, (0, _navigationListenerDefault.default)), (0, _defineProperty._)(_obj, (0, _types.FabricChannel).media, (0, _mediaAnalyticsListenerDefault.default)), (0, _defineProperty._)(_obj, (0, _types.FabricChannel).peopleTeams, (0, _peopleTeamsAnalyticsListenerDefault.default)), (0, _defineProperty._)(_obj, (0, _types.FabricChannel).notifications, (0, _notificationsAnalyticsListenerDefault.default)), (0, _defineProperty._)(_obj, (0, _types.FabricChannel).recentWork, (0, _recentWorkAnalyticsListenerDefault.default)), (0, _defineProperty._)(_obj, (0, _types.FabricChannel).atlas, (0, _atlasAnalyticsListenerDefault.default)), (0, _defineProperty._)(_obj, (0, _types.FabricChannel).crossFlow, (0, _crossFlowAnalyticsListenerDefault.default)), (0, _defineProperty._)(_obj, (0, _types.FabricChannel).linkingPlatform, (0, _linkingPlatformAnalyticsListenerDefault.default)), (0, _defineProperty._)(_obj, (0, _types.FabricChannel).postOffice, (0, _postOfficeAnalyticsListenerDefault.default)), (0, _defineProperty._)(_obj, (0, _types.FabricChannel).aiMate, (0, _aimateAnalyticsListenerDefault.default)), (0, _defineProperty._)(_obj, (0, _types.FabricChannel).avp, (0, _avpanalyticsListenerDefault.default)), (0, _defineProperty._)(_obj, (0, _types.FabricChannel).growth, (0, _growthAnalyticsListenerDefault.default)), (0, _defineProperty._)(_obj, (0, _types.FabricChannel).omniChannel, (0, _omniChannelAnalyticsListenerDefault.default)), (0, _defineProperty._)(_obj, (0, _types.FabricChannel).townsquareHome, (0, _townsquareHomeAnalyticsListenerDefault.default)), (0, _defineProperty._)(_obj, (0, _types.FabricChannel).rovoExtension, (0, _rovoExtensionAnalyticsListenerDefault.default)), (0, _defineProperty._)(_obj, (0, _types.FabricChannel).teamworkGraph, (0, _teamworkGraphAnalyticsListenerDefault.default)), _obj);
var FabricAnalyticsListeners = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, _inherits._)(FabricAnalyticsListeners, _React_Component);
    function FabricAnalyticsListeners(props) {
        (0, _classCallCheck._)(this, FabricAnalyticsListeners);
        var _this;
        _this = (0, _callSuper._)(this, FabricAnalyticsListeners, [
            props
        ]);
        _this.logger = new (0, _loggerDefault.default)({
            logLevel: props.logLevel
        });
        return _this;
    }
    (0, _createClass._)(FabricAnalyticsListeners, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this_props = this.props, client = _this_props.client, children = _this_props.children, logLevel = _this_props.logLevel, excludedChannels = _this_props.excludedChannels;
                if (typeof logLevel === 'number') this.logger.setLogLevel(logLevel);
                var listeners = Object.keys(listenerMap).filter(function(channel) {
                    return !excludedChannels || excludedChannels.indexOf(channel) < 0;
                }).map(function(channel) {
                    return listenerMap[channel];
                }).reduce(function(prev, Listener) {
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Listener, {
                        client: client,
                        logger: _this.logger,
                        children: prev
                    });
                }, children);
                return listeners;
            }
        }
    ]);
    return FabricAnalyticsListeners;
}((0, _reactDefault.default).Component);
exports.default = FabricAnalyticsListeners;

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_inherits":"2sfqW","react/jsx-runtime":"bGvcw","react":"ltHCL","./types":"eUjnT","./fabric/FabricElementsListener":"8M2JT","./atlaskit/AtlaskitListener":"hHWi8","./helpers/logger":"d8Nlm","./navigation/NavigationListener":"ffmyD","./fabric/FabricEditorListener":"f8dwo","./media/MediaAnalyticsListener":"dqBBg","./peopleTeams/PeopleTeamsAnalyticsListener":"hfyNS","./notifications/NotificationsAnalyticsListener":"2ccw6","./recentWork/RecentWorkAnalyticsListener":"56z8Q","./atlas/AtlasAnalyticsListener":"liKpX","./cross-flow/CrossFlowAnalyticsListener":"4X2ix","./linkingPlatform/LinkingPlatformAnalyticsListener":"b37RF","./postOffice/PostOfficeAnalyticsListener":"l6TnG","./aiMate/AIMateAnalyticsListener":"86bQ1","./avp/AVPAnalyticsListener":"cjmAh","./growth/GrowthAnalyticsListener":"dfviK","./omni-channel/OmniChannelAnalyticsListener":"7RXeX","./townsquareHome/TownsquareHomeAnalyticsListener":"98lOW","./rovoExtension/RovoExtensionAnalyticsListener":"eRmN7","./teamworkGraph/TeamworkGraphAnalyticsListener":"gR0x5","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eUjnT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FabricChannel", function() {
    return FabricChannel;
});
var FabricChannel = /*#__PURE__*/ function(FabricChannel) {
    FabricChannel["atlaskit"] = "atlaskit";
    FabricChannel["elements"] = "fabric-elements";
    FabricChannel["navigation"] = "navigation";
    FabricChannel["editor"] = "editor";
    FabricChannel["media"] = "media";
    FabricChannel["peopleTeams"] = "peopleTeams";
    FabricChannel["notifications"] = "notifications";
    FabricChannel["recentWork"] = "recentWork";
    FabricChannel["atlas"] = "atlas";
    FabricChannel["crossFlow"] = "crossFlow";
    FabricChannel["linkingPlatform"] = "linkingPlatform";
    FabricChannel["postOffice"] = "postOffice";
    FabricChannel["aiMate"] = "aiMate";
    FabricChannel["avp"] = "avp";
    FabricChannel["growth"] = "growth";
    FabricChannel["omniChannel"] = "omniChannel";
    FabricChannel["townsquareHome"] = "townsquareHome";
    FabricChannel["rovoExtension"] = "rovoExtension";
    FabricChannel["teamworkGraph"] = "teamworkGraph";
    return FabricChannel;
}({});

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8M2JT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ELEMENTS_TAG", function() {
    return ELEMENTS_TAG;
});
parcelHelpers.export(exports, "default", function() {
    return FabricElementsListener;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _analyticsNext = require("@atlaskit/analytics-next");
var _types = require("../types");
var _handleEvent = require("./handle-event");
var ELEMENTS_TAG = 'fabricElements';
var FabricElementsListener = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, _inherits._)(FabricElementsListener, _React_Component);
    function FabricElementsListener() {
        (0, _classCallCheck._)(this, FabricElementsListener);
        var _this;
        _this = (0, _callSuper._)(this, FabricElementsListener, arguments), _this.handleEventWrapper = function(event) {
            (0, _handleEvent.handleEvent)(event, ELEMENTS_TAG, _this.props.logger, _this.props.client);
        };
        return _this;
    }
    (0, _createClass._)(FabricElementsListener, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _analyticsNext.AnalyticsListener), {
                    onEvent: this.handleEventWrapper,
                    channel: (0, _types.FabricChannel).elements,
                    children: this.props.children
                });
            }
        }
    ]);
    return FabricElementsListener;
}((0, _reactDefault.default).Component);

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_inherits":"2sfqW","react/jsx-runtime":"bGvcw","react":"ltHCL","@atlaskit/analytics-next":"auH4u","../types":"eUjnT","./handle-event":"gNZ7w","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gNZ7w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "handleEvent", function() {
    return handleEvent;
});
var _analyticsWebClientWrapper = require("../analytics-web-client-wrapper");
var _processEventPayload = require("./process-event-payload");
var handleEvent = function(event, // If passing through multiple tags, the primary tag should be first in the array.
// The primary tag is used for matching context.
tags, logger, client) {
    if (!event.payload) return;
    var payload = (0, _processEventPayload.processEventPayload)(event, tags);
    (0, _analyticsWebClientWrapper.sendEvent)(logger, client)(payload);
};

},{"../analytics-web-client-wrapper":"iRjcE","./process-event-payload":"iW2R2","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iRjcE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sendEvent", function() {
    return sendEvent;
});
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var isPromise = function(c) {
    return typeof c.then === 'function';
};
var sendEvent = function(logger, client) {
    return function(event) {
        if (client) {
            var eventType = event.eventType, gasEvent = (0, _objectWithoutProperties._)(event, [
                "eventType"
            ]);
            var withClient = function(cb) {
                if (isPromise(client)) client.then(cb).catch(function(e) {
                    return logger.warn('There was an error sending the event', e);
                });
                else try {
                    cb(client);
                } catch (e) {
                    logger.warn('There was an error sending the event', e);
                }
            };
            switch(event.eventType){
                case 'ui':
                    logger.debug('Sending UI Event via analytics client', gasEvent);
                    withClient(function(client) {
                        return client.sendUIEvent(gasEvent);
                    });
                    break;
                case 'operational':
                    logger.debug('Sending Operational Event via analytics client', gasEvent);
                    withClient(function(client) {
                        return client.sendOperationalEvent(gasEvent);
                    });
                    break;
                case 'track':
                    logger.debug('Sending Track Event via analytics client', gasEvent);
                    withClient(function(client) {
                        return client.sendTrackEvent(gasEvent);
                    });
                    break;
                case 'screen':
                    logger.debug('Sending Screen Event via analytics client', gasEvent);
                    withClient(function(client) {
                        return client.sendScreenEvent(gasEvent);
                    });
                    break;
                default:
                    logger.error("cannot map eventType ".concat(event.eventType, " to an analytics-web-client function"));
            }
        } else logger.warn('AnalyticsWebClient instance is not provided');
    };
};

},{"@swc/helpers/_/_object_without_properties":"6HqIM","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iW2R2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "processEventPayload", function() {
    return processEventPayload;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _toPropertyKey = require("@swc/helpers/_/_to_property_key");
var _analyticsGasTypes = require("@atlaskit/analytics-gas-types");
var _analyticsNamespacedContext = require("@atlaskit/analytics-namespaced-context");
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _fabricElementsListener = require("./FabricElementsListener");
var _fabricEditorListener = require("./FabricEditorListener");
var extractFieldsFromContext = function(fieldsToPick) {
    return function(contexts) {
        return contexts.map(function(ctx) {
            return fieldsToPick.reduce(function(result, key) {
                return ctx[key] ? (0, _mergeDefault.default)(result, (0, _defineProperty._)({}, key, ctx[key])) : result;
            }, {});
        }).reduce(function(result, item) {
            return (0, _mergeDefault.default)(result, item);
        }, {});
    };
};
var fieldExtractor = function(contextKey) {
    return extractFieldsFromContext([
        'source',
        'objectType',
        'objectId',
        'containerType',
        'containerId',
        contextKey
    ]);
};
var getContextKey = function(tag) {
    switch(tag){
        case 0, _fabricElementsListener.ELEMENTS_TAG:
            return 0, _analyticsNamespacedContext.ELEMENTS_CONTEXT;
        case 0, _fabricEditorListener.EDITOR_TAG:
            return 0, _analyticsNamespacedContext.EDITOR_CONTEXT;
        default:
            return '';
    }
};
var updatePayloadWithContext = function(primaryTag, event) {
    if (event.context.length === 0) return (0, _objectSpread._)({
        source: (0, _analyticsGasTypes.DEFAULT_SOURCE)
    }, event.payload);
    var contextKey = getContextKey(primaryTag) || 'attributes';
    var _fieldExtractor = fieldExtractor(contextKey)(event.context), attributes = _fieldExtractor[contextKey], fields = (0, _objectWithoutProperties._)(_fieldExtractor, [
        contextKey
    ].map((0, _toPropertyKey._)));
    if (attributes) event.payload.attributes = (0, _mergeDefault.default)(attributes, event.payload.attributes || {});
    return (0, _objectSpread._)({
        source: (0, _analyticsGasTypes.DEFAULT_SOURCE)
    }, fields, event.payload);
};
var addTags = function(tags) {
    var originalTags = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var mergedTags = new Set((0, _toConsumableArray._)(originalTags).concat((0, _toConsumableArray._)(tags)));
    return Array.from(mergedTags);
};
/**
 * The primary tag is used for matching the analytics event payload
 * with its context.
 */ function getPrimaryTag(tags) {
    if (typeof tags === 'string') return tags;
    if (!tags.length) throw new Error('Empty tags string array. Unable to match analytics event payload with context');
    return tags[0];
}
var processEventPayload = function(event, tags) {
    var primaryTag = getPrimaryTag(tags);
    var tagsArray = typeof tags === 'string' ? [
        tags
    ] : tags;
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, updatePayloadWithContext(primaryTag, event)), {
        tags: addTags(tagsArray, event.payload.tags)
    });
};

},{"@swc/helpers/_/_define_property":"e80IS","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","@swc/helpers/_/_to_consumable_array":"1eSZf","@swc/helpers/_/_to_property_key":"6fsv0","@atlaskit/analytics-gas-types":"hAfQ5","@atlaskit/analytics-namespaced-context":"dWmBD","lodash/merge":"yJjRX","./FabricElementsListener":"8M2JT","./FabricEditorListener":"f8dwo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6fsv0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _to_property_key;
});
var _toPrimitiveJs = require("./_to_primitive.js");
var _typeOfJs = require("./_type_of.js");
function _to_property_key(arg) {
    var key = (0, _toPrimitiveJs._)(arg, "string");
    return (0, _typeOfJs._)(key) === "symbol" ? key : String(key);
}

},{"./_to_primitive.js":"18g3k","./_type_of.js":"iFJdx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"18g3k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _to_primitive;
});
var _typeOfJs = require("./_type_of.js");
function _to_primitive(input, hint) {
    if ((0, _typeOfJs._)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, _typeOfJs._)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

},{"./_type_of.js":"iFJdx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hAfQ5":[function(require,module,exports,__globalThis) {
// same types defined in analytics-web-client but avoid creating dependency with that
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UI_EVENT_TYPE", function() {
    return UI_EVENT_TYPE;
});
parcelHelpers.export(exports, "TRACK_EVENT_TYPE", function() {
    return TRACK_EVENT_TYPE;
});
parcelHelpers.export(exports, "SCREEN_EVENT_TYPE", function() {
    return SCREEN_EVENT_TYPE;
});
parcelHelpers.export(exports, "OPERATIONAL_EVENT_TYPE", function() {
    return OPERATIONAL_EVENT_TYPE;
});
parcelHelpers.export(exports, "DEFAULT_SOURCE", function() {
    return DEFAULT_SOURCE;
});
var UI_EVENT_TYPE = 'ui';
var TRACK_EVENT_TYPE = 'track';
var SCREEN_EVENT_TYPE = 'screen';
var OPERATIONAL_EVENT_TYPE = 'operational';
var DEFAULT_SOURCE = 'unknown';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dWmBD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ELEMENTS_CONTEXT", function() {
    return 0, _fabricElementsAnalyticsContext.ELEMENTS_CONTEXT;
});
parcelHelpers.export(exports, "FabricElementsAnalyticsContext", function() {
    return 0, _fabricElementsAnalyticsContext.FabricElementsAnalyticsContext;
});
parcelHelpers.export(exports, "NAVIGATION_CONTEXT", function() {
    return 0, _navigationAnalyticsContext.NAVIGATION_CONTEXT;
});
parcelHelpers.export(exports, "NavigationAnalyticsContext", function() {
    return 0, _navigationAnalyticsContext.NavigationAnalyticsContext;
});
parcelHelpers.export(exports, "EDITOR_CONTEXT", function() {
    return 0, _fabricEditorAnalyticsContext.EDITOR_CONTEXT;
});
parcelHelpers.export(exports, "EDITOR_APPEARANCE_CONTEXT", function() {
    return 0, _fabricEditorAnalyticsContext.EDITOR_APPEARANCE_CONTEXT;
});
parcelHelpers.export(exports, "FabricEditorAnalyticsContext", function() {
    return 0, _fabricEditorAnalyticsContext.FabricEditorAnalyticsContext;
});
parcelHelpers.export(exports, "MEDIA_CONTEXT", function() {
    return 0, _mediaAnalyticsContext.MEDIA_CONTEXT;
});
parcelHelpers.export(exports, "PEOPLE_TEAMS_CONTEXT", function() {
    return 0, _peopleTeamsAnalyticsContext.PEOPLE_TEAMS_CONTEXT;
});
parcelHelpers.export(exports, "PeopleTeamsAnalyticsContext", function() {
    return 0, _peopleTeamsAnalyticsContext.PeopleTeamsAnalyticsContext;
});
parcelHelpers.export(exports, "NOTIFICATIONS_CONTEXT", function() {
    return 0, _notificationsAnalyticsContext.NOTIFICATIONS_CONTEXT;
});
parcelHelpers.export(exports, "NotificationsAnalyticsContext", function() {
    return 0, _notificationsAnalyticsContext.NotificationsAnalyticsContext;
});
parcelHelpers.export(exports, "RECENT_WORK_CONTEXT", function() {
    return 0, _recentWorkAnalyticsContext.RECENT_WORK_CONTEXT;
});
parcelHelpers.export(exports, "RecentWorkAnalyticsContext", function() {
    return 0, _recentWorkAnalyticsContext.RecentWorkAnalyticsContext;
});
parcelHelpers.export(exports, "ATLAS_CONTEXT", function() {
    return 0, _atlasAnalyticsContext.ATLAS_CONTEXT;
});
parcelHelpers.export(exports, "AtlasAnalyticsContext", function() {
    return 0, _atlasAnalyticsContext.AtlasAnalyticsContext;
});
parcelHelpers.export(exports, "TOWNSQUARE_HOME_CONTEXT", function() {
    return 0, _townsquareHomeAnalyticsContext.TOWNSQUARE_HOME_CONTEXT;
});
parcelHelpers.export(exports, "TownsquareHomeAnalyticsContext", function() {
    return 0, _townsquareHomeAnalyticsContext.TownsquareHomeAnalyticsContext;
});
parcelHelpers.export(exports, "LINKING_PLATFORM_CONTEXT", function() {
    return 0, _linkingPlatformAnalyticsContext.LINKING_PLATFORM_CONTEXT;
});
parcelHelpers.export(exports, "LinkingPlatformAnalyticsContext", function() {
    return 0, _linkingPlatformAnalyticsContext.LinkingPlatformAnalyticsContext;
});
parcelHelpers.export(exports, "POST_OFFICE_CONTEXT", function() {
    return 0, _postOfficeAnalyticsContext.POST_OFFICE_CONTEXT;
});
parcelHelpers.export(exports, "PostOfficeAnalyticsContext", function() {
    return 0, _postOfficeAnalyticsContext.PostOfficeAnalyticsContext;
});
parcelHelpers.export(exports, "AI_MATE_CONTEXT", function() {
    return 0, _aimateAnalyticsContext.AI_MATE_CONTEXT;
});
parcelHelpers.export(exports, "AIMateAnalyticsContext", function() {
    return 0, _aimateAnalyticsContext.AIMateAnalyticsContext;
});
parcelHelpers.export(exports, "AVP_CONTEXT", function() {
    return 0, _avpanalyticsContext.AVP_CONTEXT;
});
parcelHelpers.export(exports, "AVPAnalyticsContext", function() {
    return 0, _avpanalyticsContext.AVPAnalyticsContext;
});
parcelHelpers.export(exports, "GROWTH_CONTEXT", function() {
    return 0, _growthAnalyticsContext.GROWTH_CONTEXT;
});
parcelHelpers.export(exports, "GrowthAnalyticsContext", function() {
    return 0, _growthAnalyticsContext.GrowthAnalyticsContext;
});
parcelHelpers.export(exports, "OMNI_CHANNEL_CONTEXT", function() {
    return 0, _omniChannelAnalyticsContext.OMNI_CHANNEL_CONTEXT;
});
parcelHelpers.export(exports, "OmniChannelAnalyticsContext", function() {
    return 0, _omniChannelAnalyticsContext.OmniChannelAnalyticsContext;
});
parcelHelpers.export(exports, "ROVO_EXTENSION_CONTEXT", function() {
    return 0, _rovoExtensionAnalyticsContext.ROVO_EXTENSION_CONTEXT;
});
parcelHelpers.export(exports, "RovoExtensionAnalyticsContext", function() {
    return 0, _rovoExtensionAnalyticsContext.RovoExtensionAnalyticsContext;
});
var _fabricElementsAnalyticsContext = require("./FabricElementsAnalyticsContext");
var _navigationAnalyticsContext = require("./NavigationAnalyticsContext");
var _fabricEditorAnalyticsContext = require("./FabricEditorAnalyticsContext");
var _mediaAnalyticsContext = require("./MediaAnalyticsContext");
var _peopleTeamsAnalyticsContext = require("./PeopleTeamsAnalyticsContext");
var _notificationsAnalyticsContext = require("./NotificationsAnalyticsContext");
var _recentWorkAnalyticsContext = require("./RecentWorkAnalyticsContext");
var _atlasAnalyticsContext = require("./AtlasAnalyticsContext");
var _townsquareHomeAnalyticsContext = require("./TownsquareHomeAnalyticsContext");
var _linkingPlatformAnalyticsContext = require("./LinkingPlatformAnalyticsContext");
var _postOfficeAnalyticsContext = require("./PostOfficeAnalyticsContext");
var _aimateAnalyticsContext = require("./AIMateAnalyticsContext");
var _avpanalyticsContext = require("./AVPAnalyticsContext");
var _growthAnalyticsContext = require("./GrowthAnalyticsContext");
var _omniChannelAnalyticsContext = require("./OmniChannelAnalyticsContext");
var _rovoExtensionAnalyticsContext = require("./RovoExtensionAnalyticsContext");

},{"./FabricElementsAnalyticsContext":"bGY2y","./NavigationAnalyticsContext":"lVvKV","./FabricEditorAnalyticsContext":"c2KEx","./MediaAnalyticsContext":"jJ0KN","./PeopleTeamsAnalyticsContext":"cNFc7","./NotificationsAnalyticsContext":"bKFjJ","./RecentWorkAnalyticsContext":"ds64L","./AtlasAnalyticsContext":"ih4Zf","./TownsquareHomeAnalyticsContext":"9lX1j","./LinkingPlatformAnalyticsContext":"1hoza","./PostOfficeAnalyticsContext":"gQ8mX","./AIMateAnalyticsContext":"aeGHX","./AVPAnalyticsContext":"8Q3Ch","./GrowthAnalyticsContext":"91FAs","./OmniChannelAnalyticsContext":"aCoYt","./RovoExtensionAnalyticsContext":"kZ2rr","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bGY2y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ELEMENTS_CONTEXT", function() {
    return ELEMENTS_CONTEXT;
});
parcelHelpers.export(exports, "FabricElementsAnalyticsContext", function() {
    return FabricElementsAnalyticsContext;
});
var _createNamespaceContext = require("./helper/createNamespaceContext");
var _createNamespaceContextDefault = parcelHelpers.interopDefault(_createNamespaceContext);
var ELEMENTS_CONTEXT = 'fabricElementsCtx';
var FabricElementsAnalyticsContext = (0, _createNamespaceContextDefault.default)(ELEMENTS_CONTEXT, 'FabricElementsAnalyticsContext');

},{"./helper/createNamespaceContext":"77p0F","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"77p0F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@swc/helpers/_/_define_property");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _analyticsNext = require("@atlaskit/analytics-next");
var createNamespaceContext = function(namespace) {
    var displayName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'NamespacedContext';
    var Component = function(props) {
        var newData = (0, _defineProperty._)({}, namespace, props.data);
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _analyticsNext.AnalyticsContext), {
            data: newData,
            children: (0, _reactDefault.default).Children.only(props.children)
        });
    };
    Component.displayName = displayName;
    return Component;
};
exports.default = createNamespaceContext;

},{"@swc/helpers/_/_define_property":"e80IS","react/jsx-runtime":"bGvcw","react":"ltHCL","@atlaskit/analytics-next":"auH4u","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lVvKV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NAVIGATION_CONTEXT", function() {
    return NAVIGATION_CONTEXT;
});
parcelHelpers.export(exports, "NavigationAnalyticsContext", function() {
    return NavigationAnalyticsContext;
});
var _createNamespaceContext = require("./helper/createNamespaceContext");
var _createNamespaceContextDefault = parcelHelpers.interopDefault(_createNamespaceContext);
var NAVIGATION_CONTEXT = 'navigationCtx';
var NavigationAnalyticsContext = (0, _createNamespaceContextDefault.default)(NAVIGATION_CONTEXT, 'NavigationAnalyticsContext');

},{"./helper/createNamespaceContext":"77p0F","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"c2KEx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EDITOR_CONTEXT", function() {
    return EDITOR_CONTEXT;
});
parcelHelpers.export(exports, "EDITOR_APPEARANCE_CONTEXT", function() {
    return EDITOR_APPEARANCE_CONTEXT;
});
parcelHelpers.export(exports, "FabricEditorAnalyticsContext", function() {
    return FabricEditorAnalyticsContext;
});
var _createNamespaceContext = require("./helper/createNamespaceContext");
var _createNamespaceContextDefault = parcelHelpers.interopDefault(_createNamespaceContext);
var EDITOR_CONTEXT = 'fabricEditorCtx';
var EDITOR_APPEARANCE_CONTEXT = /*#__PURE__*/ function(EDITOR_APPEARANCE_CONTEXT) {
    EDITOR_APPEARANCE_CONTEXT["FIXED_WIDTH"] = "fixedWidth";
    EDITOR_APPEARANCE_CONTEXT["FULL_WIDTH"] = "fullWidth";
    EDITOR_APPEARANCE_CONTEXT["COMMENT"] = "comment";
    EDITOR_APPEARANCE_CONTEXT["CHROMELESS"] = "chromeless";
    EDITOR_APPEARANCE_CONTEXT["MOBILE"] = "mobile";
    EDITOR_APPEARANCE_CONTEXT["MAX"] = "max";
    return EDITOR_APPEARANCE_CONTEXT;
}({});
var FabricEditorAnalyticsContext = (0, _createNamespaceContextDefault.default)(EDITOR_CONTEXT, 'FabricEditorAnalyticsContext');

},{"./helper/createNamespaceContext":"77p0F","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jJ0KN":[function(require,module,exports,__globalThis) {
// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MEDIA_CONTEXT", function() {
    return MEDIA_CONTEXT;
});
var MEDIA_CONTEXT = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cNFc7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PEOPLE_TEAMS_CONTEXT", function() {
    return PEOPLE_TEAMS_CONTEXT;
});
parcelHelpers.export(exports, "PeopleTeamsAnalyticsContext", function() {
    return PeopleTeamsAnalyticsContext;
});
var _createNamespaceContext = require("./helper/createNamespaceContext");
var _createNamespaceContextDefault = parcelHelpers.interopDefault(_createNamespaceContext);
var PEOPLE_TEAMS_CONTEXT = 'peopleTeamsCtx';
var PeopleTeamsAnalyticsContext = (0, _createNamespaceContextDefault.default)(PEOPLE_TEAMS_CONTEXT, 'PeopleTeamsAnalyticsContext');

},{"./helper/createNamespaceContext":"77p0F","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bKFjJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NOTIFICATIONS_CONTEXT", function() {
    return NOTIFICATIONS_CONTEXT;
});
parcelHelpers.export(exports, "NotificationsAnalyticsContext", function() {
    return NotificationsAnalyticsContext;
});
var _createNamespaceContext = require("./helper/createNamespaceContext");
var _createNamespaceContextDefault = parcelHelpers.interopDefault(_createNamespaceContext);
var NOTIFICATIONS_CONTEXT = 'NotificationsCtx';
var NotificationsAnalyticsContext = (0, _createNamespaceContextDefault.default)(NOTIFICATIONS_CONTEXT, 'NotificationsAnalyticsContext');

},{"./helper/createNamespaceContext":"77p0F","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ds64L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RECENT_WORK_CONTEXT", function() {
    return RECENT_WORK_CONTEXT;
});
parcelHelpers.export(exports, "RecentWorkAnalyticsContext", function() {
    return RecentWorkAnalyticsContext;
});
var _createNamespaceContext = require("./helper/createNamespaceContext");
var _createNamespaceContextDefault = parcelHelpers.interopDefault(_createNamespaceContext);
var RECENT_WORK_CONTEXT = 'RecentWorkCtx';
var RecentWorkAnalyticsContext = (0, _createNamespaceContextDefault.default)(RECENT_WORK_CONTEXT, 'RecentWorkAnalyticsContext');

},{"./helper/createNamespaceContext":"77p0F","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ih4Zf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ATLAS_CONTEXT", function() {
    return ATLAS_CONTEXT;
});
parcelHelpers.export(exports, "AtlasAnalyticsContext", function() {
    return AtlasAnalyticsContext;
});
var _createNamespaceContext = require("./helper/createNamespaceContext");
var _createNamespaceContextDefault = parcelHelpers.interopDefault(_createNamespaceContext);
var ATLAS_CONTEXT = 'atlasCtx';
var AtlasAnalyticsContext = (0, _createNamespaceContextDefault.default)(ATLAS_CONTEXT, 'AtlasAnalyticsContext');

},{"./helper/createNamespaceContext":"77p0F","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9lX1j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TOWNSQUARE_HOME_CONTEXT", function() {
    return TOWNSQUARE_HOME_CONTEXT;
});
parcelHelpers.export(exports, "TownsquareHomeAnalyticsContext", function() {
    return TownsquareHomeAnalyticsContext;
});
var _createNamespaceContext = require("./helper/createNamespaceContext");
var _createNamespaceContextDefault = parcelHelpers.interopDefault(_createNamespaceContext);
var TOWNSQUARE_HOME_CONTEXT = 'townsquareHomeCtx';
var TownsquareHomeAnalyticsContext = (0, _createNamespaceContextDefault.default)(TOWNSQUARE_HOME_CONTEXT, 'TownsquareHomeAnalyticsContext');

},{"./helper/createNamespaceContext":"77p0F","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1hoza":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LINKING_PLATFORM_CONTEXT", function() {
    return LINKING_PLATFORM_CONTEXT;
});
parcelHelpers.export(exports, "LinkingPlatformAnalyticsContext", function() {
    return LinkingPlatformAnalyticsContext;
});
var _createNamespaceContext = require("./helper/createNamespaceContext");
var _createNamespaceContextDefault = parcelHelpers.interopDefault(_createNamespaceContext);
var LINKING_PLATFORM_CONTEXT = 'linkingPlatformCtx';
var LinkingPlatformAnalyticsContext = (0, _createNamespaceContextDefault.default)(LINKING_PLATFORM_CONTEXT, 'LinkingPlatformAnalyticsContext');

},{"./helper/createNamespaceContext":"77p0F","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gQ8mX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "POST_OFFICE_CONTEXT", function() {
    return POST_OFFICE_CONTEXT;
});
parcelHelpers.export(exports, "PostOfficeAnalyticsContext", function() {
    return PostOfficeAnalyticsContext;
});
var _createNamespaceContext = require("./helper/createNamespaceContext");
var _createNamespaceContextDefault = parcelHelpers.interopDefault(_createNamespaceContext);
var POST_OFFICE_CONTEXT = 'postOfficeCtx';
var PostOfficeAnalyticsContext = (0, _createNamespaceContextDefault.default)(POST_OFFICE_CONTEXT, 'PostOfficeAnalyticsContext');

},{"./helper/createNamespaceContext":"77p0F","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aeGHX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AI_MATE_CONTEXT", function() {
    return AI_MATE_CONTEXT;
});
parcelHelpers.export(exports, "AIMateAnalyticsContext", function() {
    return AIMateAnalyticsContext;
});
var _createNamespaceContext = require("./helper/createNamespaceContext");
var _createNamespaceContextDefault = parcelHelpers.interopDefault(_createNamespaceContext);
var AI_MATE_CONTEXT = 'aiMateCtx';
var AIMateAnalyticsContext = (0, _createNamespaceContextDefault.default)(AI_MATE_CONTEXT, 'AIMateAnalyticsContext');

},{"./helper/createNamespaceContext":"77p0F","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8Q3Ch":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AVP_CONTEXT", function() {
    return AVP_CONTEXT;
});
parcelHelpers.export(exports, "AVPAnalyticsContext", function() {
    return AVPAnalyticsContext;
});
var _createNamespaceContext = require("./helper/createNamespaceContext");
var _createNamespaceContextDefault = parcelHelpers.interopDefault(_createNamespaceContext);
var AVP_CONTEXT = 'avpCtx';
var AVPAnalyticsContext = (0, _createNamespaceContextDefault.default)(AVP_CONTEXT, 'AVPAnalyticsContext');

},{"./helper/createNamespaceContext":"77p0F","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"91FAs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GROWTH_CONTEXT", function() {
    return GROWTH_CONTEXT;
});
parcelHelpers.export(exports, "GrowthAnalyticsContext", function() {
    return GrowthAnalyticsContext;
});
var _createNamespaceContext = require("./helper/createNamespaceContext");
var _createNamespaceContextDefault = parcelHelpers.interopDefault(_createNamespaceContext);
var GROWTH_CONTEXT = 'editionAwarenessCtx';
var GrowthAnalyticsContext = (0, _createNamespaceContextDefault.default)(GROWTH_CONTEXT, 'GrowthAnalyticsContext');

},{"./helper/createNamespaceContext":"77p0F","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aCoYt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OMNI_CHANNEL_CONTEXT", function() {
    return OMNI_CHANNEL_CONTEXT;
});
parcelHelpers.export(exports, "OmniChannelAnalyticsContext", function() {
    return OmniChannelAnalyticsContext;
});
var _createNamespaceContext = require("./helper/createNamespaceContext");
var _createNamespaceContextDefault = parcelHelpers.interopDefault(_createNamespaceContext);
var OMNI_CHANNEL_CONTEXT = 'omniChannelCtx';
var OmniChannelAnalyticsContext = (0, _createNamespaceContextDefault.default)(OMNI_CHANNEL_CONTEXT, 'OmniChannelAnalyticsContext');

},{"./helper/createNamespaceContext":"77p0F","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kZ2rr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ROVO_EXTENSION_CONTEXT", function() {
    return ROVO_EXTENSION_CONTEXT;
});
parcelHelpers.export(exports, "RovoExtensionAnalyticsContext", function() {
    return RovoExtensionAnalyticsContext;
});
var _createNamespaceContext = require("./helper/createNamespaceContext");
var _createNamespaceContextDefault = parcelHelpers.interopDefault(_createNamespaceContext);
var ROVO_EXTENSION_CONTEXT = 'rovoExtensionCtx';
var RovoExtensionAnalyticsContext = (0, _createNamespaceContextDefault.default)(ROVO_EXTENSION_CONTEXT, 'RovoExtensionAnalyticsContext');

},{"./helper/createNamespaceContext":"77p0F","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"f8dwo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EDITOR_TAG", function() {
    return EDITOR_TAG;
});
parcelHelpers.export(exports, "LEGACY_EDITOR_TAG", function() {
    return LEGACY_EDITOR_TAG;
});
parcelHelpers.export(exports, "default", function() {
    return FabricEditorListener;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _analyticsNext = require("@atlaskit/analytics-next");
var _types = require("../types");
var _handleEvent = require("./handle-event");
var EDITOR_TAG = 'editor';
var LEGACY_EDITOR_TAG = 'fabricEditor';
var FabricEditorListener = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, _inherits._)(FabricEditorListener, _React_Component);
    function FabricEditorListener() {
        (0, _classCallCheck._)(this, FabricEditorListener);
        var _this;
        _this = (0, _callSuper._)(this, FabricEditorListener, arguments), _this.handleEventWrapper = function(event) {
            (0, _handleEvent.handleEvent)(event, [
                EDITOR_TAG,
                LEGACY_EDITOR_TAG
            ], _this.props.logger, _this.props.client);
        };
        return _this;
    }
    (0, _createClass._)(FabricEditorListener, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _analyticsNext.AnalyticsListener), {
                    onEvent: this.handleEventWrapper,
                    channel: (0, _types.FabricChannel).editor,
                    children: this.props.children
                });
            }
        }
    ]);
    return FabricEditorListener;
}((0, _reactDefault.default).Component);

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_inherits":"2sfqW","react/jsx-runtime":"bGvcw","react":"ltHCL","@atlaskit/analytics-next":"auH4u","../types":"eUjnT","./handle-event":"gNZ7w","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hHWi8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return AtlaskitListener;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _types = require("../types");
var _processEvent = require("./process-event");
var _processEventDefault = parcelHelpers.interopDefault(_processEvent);
var _genericAnalyticsListener = require("../GenericAnalyticsListener");
var _genericAnalyticsListenerDefault = parcelHelpers.interopDefault(_genericAnalyticsListener);
function AtlaskitListener(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _genericAnalyticsListenerDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        channel: (0, _types.FabricChannel).atlaskit,
        processEvent: (0, _processEventDefault.default)
    }));
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","../types":"eUjnT","./process-event":"4Hho4","../GenericAnalyticsListener":"7NVs3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4Hho4":[function(require,module,exports,__globalThis) {
/**
 * Inspired by analytics-web-react
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _last = require("lodash/last");
var _lastDefault = parcelHelpers.interopDefault(_last);
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _analyticsGasTypes = require("@atlaskit/analytics-gas-types");
var _extractDataFromEvent = require("./extract-data-from-event");
var ATLASKIT_TAG = 'atlaskit';
var listenerVersion = undefined;
/**
 * This util exists to convert the Atlaskit event format into the analytics platform format.
 *
 * Atlaskit event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ exports.default = function(event, logger) {
    var sources = (0, _extractDataFromEvent.getSources)(event);
    var source = (0, _lastDefault.default)(sources) || (0, _analyticsGasTypes.DEFAULT_SOURCE);
    var extraAttributes = (0, _extractDataFromEvent.getExtraAttributes)(event);
    var components = (0, _extractDataFromEvent.getComponents)(event);
    var _ref = (0, _lastDefault.default)((0, _extractDataFromEvent.getPackageInfo)(event)) || {}, packageName = _ref.packageName, packageVersion = _ref.packageVersion;
    var _event_payload = event.payload, _event_payload_eventType = _event_payload.eventType, eventType = _event_payload_eventType === void 0 ? (0, _analyticsGasTypes.UI_EVENT_TYPE) : _event_payload_eventType, action = _event_payload.action, actionSubjectId = _event_payload.actionSubjectId, payloadAttributes = _event_payload.attributes, containerId = _event_payload.containerId;
    var attributes = (0, _objectSpread._)({
        listenerVersion: listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: (0, _extractDataFromEvent.getPackageHierarchy)(event) || undefined,
        packageName: packageName,
        packageVersion: packageVersion
    }, (0, _mergeDefault.default)(extraAttributes, payloadAttributes));
    // Ensure atlaskit tag is not duplicated by using Set
    var tags = new Set(event.payload.tags || []);
    tags.add(ATLASKIT_TAG);
    if (event.payload) {
        if (eventType === (0, _analyticsGasTypes.UI_EVENT_TYPE)) return {
            eventType: eventType,
            source: source,
            actionSubject: (0, _extractDataFromEvent.getActionSubject)(event),
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: attributes,
            containerId: containerId,
            tags: Array.from(tags)
        };
        if (eventType === (0, _analyticsGasTypes.TRACK_EVENT_TYPE) || eventType === (0, _analyticsGasTypes.OPERATIONAL_EVENT_TYPE) || eventType === (0, _analyticsGasTypes.SCREEN_EVENT_TYPE)) logger.error('Track, screen and operational events are currently not supported for atlaskit events');
        else logger.error('Invalid event type', eventType);
    }
    return null;
};

},{"@swc/helpers/_/_object_spread":"9gdrV","lodash/last":"9zzEk","lodash/merge":"yJjRX","@atlaskit/analytics-gas-types":"hAfQ5","./extract-data-from-event":"1wXDW","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9zzEk":[function(require,module,exports,__globalThis) {
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
module.exports = last;

},{}],"1wXDW":[function(require,module,exports,__globalThis) {
/**
 * Largely taken from analytics-web-react
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extractFromEventContext", function() {
    return extractFromEventContext;
});
parcelHelpers.export(exports, "getActionSubject", function() {
    return getActionSubject;
});
parcelHelpers.export(exports, "getSources", function() {
    return getSources;
});
parcelHelpers.export(exports, "getComponents", function() {
    return getComponents;
});
parcelHelpers.export(exports, "getExtraAttributes", function() {
    return getExtraAttributes;
});
parcelHelpers.export(exports, "getPackageInfo", function() {
    return getPackageInfo;
});
parcelHelpers.export(exports, "getPackageVersion", function() {
    return getPackageVersion;
});
// This function scans the whole context and looks for context data that includes packageName at the root of the object.
// Every package should include this info once, just to differentiate between packages, but no between internal components of each package
// If no context data brings a packageName, the map function retuns an empty string that is replaced for "undefined"
parcelHelpers.export(exports, "getPackageHierarchy", function() {
    return getPackageHierarchy;
});
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var extractFromEventContext = function(propertyName, event) {
    return event.context.map(function(contextItem) {
        return contextItem[propertyName];
    }).filter(Boolean);
};
var getActionSubject = function(event) {
    var overrides = extractFromEventContext('actionSubjectOverride', event);
    var closestContext = event.context.length > 0 ? event.context[event.context.length - 1] : {};
    var actionSubject = event.payload.actionSubject || closestContext.component;
    return overrides.length > 0 ? overrides[0] : actionSubject;
};
var getSources = function(event) {
    return extractFromEventContext('source', event);
};
var getComponents = function(event) {
    return extractFromEventContext('component', event);
};
var getExtraAttributes = function(event) {
    return extractFromEventContext('attributes', event).reduce(function(result, extraAttributes) {
        return (0, _mergeDefault.default)(result, extraAttributes);
    }, {});
};
var getPackageInfo = function(event) {
    return event.context.map(function(contextItem) {
        return {
            packageName: contextItem.packageName,
            packageVersion: contextItem.packageVersion
        };
    }).filter(function(p) {
        return p.packageName;
    });
};
var getPackageVersion = function(event) {
    return extractFromEventContext('packageVersion', event);
};
function getPackageHierarchy(event) {
    var packages = getPackageInfo(event) || [];
    return packages.map(function(p) {
        return p.packageVersion ? "".concat(p.packageName, "@").concat(p.packageVersion) : p.packageName;
    }).join(',') || undefined;
}

},{"lodash/merge":"yJjRX","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7NVs3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return GenericAnalyticsListener;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _analyticsNext = require("@atlaskit/analytics-next");
var _analyticsWebClientWrapper = require("./analytics-web-client-wrapper");
var GenericAnalyticsListener = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, _inherits._)(GenericAnalyticsListener, _React_Component);
    function GenericAnalyticsListener() {
        (0, _classCallCheck._)(this, GenericAnalyticsListener);
        var _this;
        _this = (0, _callSuper._)(this, GenericAnalyticsListener, arguments), _this.listenerHandler = function(event) {
            var _this_props = _this.props, client = _this_props.client, logger = _this_props.logger, channel = _this_props.channel, processEvent = _this_props.processEvent;
            if (!event.payload) return;
            logger.debug("Received ".concat(channel, " event"), event);
            var payload = processEvent(event, logger);
            logger.debug("Processed ".concat(channel, " event"), payload);
            if (payload) (0, _analyticsWebClientWrapper.sendEvent)(logger, client)(payload);
        };
        return _this;
    }
    (0, _createClass._)(GenericAnalyticsListener, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _analyticsNext.AnalyticsListener), {
                    onEvent: this.listenerHandler,
                    channel: this.props.channel,
                    children: this.props.children
                });
            }
        }
    ]);
    return GenericAnalyticsListener;
}((0, _reactDefault.default).Component);

},{"@swc/helpers/_/_call_super":"cRy4y","@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_inherits":"2sfqW","react/jsx-runtime":"bGvcw","react":"ltHCL","@atlaskit/analytics-next":"auH4u","./analytics-web-client-wrapper":"iRjcE","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"d8Nlm":[function(require,module,exports,__globalThis) {
/* eslint-disable no-console */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LOG_LEVEL", function() {
    return LOG_LEVEL;
});
parcelHelpers.export(exports, "default", function() {
    return Logger;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var LOG_LEVEL = {
    DEBUG: 0,
    INFO: 1,
    WARN: 2,
    ERROR: 3,
    OFF: 4
};
var Logger = /*#__PURE__*/ function() {
    "use strict";
    function Logger() {
        var logLevel = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).logLevel;
        (0, _classCallCheck._)(this, Logger);
        this.logLevel = LOG_LEVEL.OFF;
        if (typeof logLevel === 'number') this.setLogLevel(logLevel);
    }
    (0, _createClass._)(Logger, [
        {
            key: "setLogLevel",
            value: function setLogLevel(logLevel) {
                if (logLevel >= LOG_LEVEL.DEBUG && logLevel <= LOG_LEVEL.OFF) this.logLevel = +logLevel;
                else this.logLevel = LOG_LEVEL.OFF;
            }
        },
        {
            key: "logMessage",
            value: function logMessage(level, type) {
                for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
                    args[_key - 2] = arguments[_key];
                }
                var _console;
                if (level >= this.logLevel) (_console = console)[type].apply(_console, (0, _toConsumableArray._)(args));
            }
        },
        {
            key: "debug",
            value: function debug() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this.logMessage.apply(this, [
                    LOG_LEVEL.DEBUG,
                    'log'
                ].concat((0, _toConsumableArray._)(args)));
            }
        },
        {
            key: "info",
            value: function info() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this.logMessage.apply(this, [
                    LOG_LEVEL.INFO,
                    'info'
                ].concat((0, _toConsumableArray._)(args)));
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this.logMessage.apply(this, [
                    LOG_LEVEL.WARN,
                    'warn'
                ].concat((0, _toConsumableArray._)(args)));
            }
        },
        {
            key: "error",
            value: function error() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this.logMessage.apply(this, [
                    LOG_LEVEL.ERROR,
                    'error'
                ].concat((0, _toConsumableArray._)(args)));
            }
        }
    ]);
    return Logger;
}();

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_to_consumable_array":"1eSZf","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ffmyD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return NavigationListener;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _types = require("../types");
var _processEvent = require("./process-event");
var _processEventDefault = parcelHelpers.interopDefault(_processEvent);
var _genericAnalyticsListener = require("../GenericAnalyticsListener");
var _genericAnalyticsListenerDefault = parcelHelpers.interopDefault(_genericAnalyticsListener);
function NavigationListener(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _genericAnalyticsListenerDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        channel: (0, _types.FabricChannel).navigation,
        processEvent: (0, _processEventDefault.default)
    }));
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","../types":"eUjnT","./process-event":"kohcF","../GenericAnalyticsListener":"7NVs3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kohcF":[function(require,module,exports,__globalThis) {
/**
 * Inspired by analytics-web-react
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _last = require("lodash/last");
var _lastDefault = parcelHelpers.interopDefault(_last);
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _analyticsGasTypes = require("@atlaskit/analytics-gas-types");
var _analyticsNamespacedContext = require("@atlaskit/analytics-namespaced-context");
var _extractDataFromEvent = require("../helpers/extract-data-from-event");
var NAVIGATION_TAG = 'navigation';
var listenerVersion = undefined;
/**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ exports.default = function(event, logger) {
    var sources = (0, _extractDataFromEvent.getSources)(event, (0, _analyticsNamespacedContext.NAVIGATION_CONTEXT));
    var source = (0, _lastDefault.default)(sources) || (0, _analyticsGasTypes.DEFAULT_SOURCE);
    var extraAttributes = (0, _extractDataFromEvent.getExtraAttributes)(event, (0, _analyticsNamespacedContext.NAVIGATION_CONTEXT));
    var components = (0, _extractDataFromEvent.getComponents)(event, (0, _analyticsNamespacedContext.NAVIGATION_CONTEXT));
    var packages = (0, _extractDataFromEvent.getPackageInfo)(event, (0, _analyticsNamespacedContext.NAVIGATION_CONTEXT));
    var _ref = (0, _lastDefault.default)((0, _extractDataFromEvent.getPackageInfo)(event, (0, _analyticsNamespacedContext.NAVIGATION_CONTEXT))) || {}, packageName = _ref.packageName, packageVersion = _ref.packageVersion;
    var packageHierarchy = packages.map(function(p) {
        return p.packageVersion ? "".concat(p.packageName, "@").concat(p.packageVersion) : p.packageName;
    });
    var _event_payload = event.payload, _event_payload_eventType = _event_payload.eventType, eventType = _event_payload_eventType === void 0 ? (0, _analyticsGasTypes.UI_EVENT_TYPE) : _event_payload_eventType, action = _event_payload.action, actionSubject = _event_payload.actionSubject, actionSubjectId = _event_payload.actionSubjectId, payloadAttributes = _event_payload.attributes, name = _event_payload.name;
    var attributes = (0, _objectSpread._)({
        listenerVersion: listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion
    }, (0, _mergeDefault.default)(extraAttributes, payloadAttributes));
    // Ensure navigation tag is not duplicated by using Set
    var tags = new Set(event.payload.tags || []);
    tags.add(NAVIGATION_TAG);
    if (event.payload) switch(eventType){
        case 0, _analyticsGasTypes.UI_EVENT_TYPE:
        case 0, _analyticsGasTypes.OPERATIONAL_EVENT_TYPE:
        case 0, _analyticsGasTypes.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, _analyticsGasTypes.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

},{"@swc/helpers/_/_object_spread":"9gdrV","lodash/last":"9zzEk","lodash/merge":"yJjRX","@atlaskit/analytics-gas-types":"hAfQ5","@atlaskit/analytics-namespaced-context":"dWmBD","../helpers/extract-data-from-event":"iUV36","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iUV36":[function(require,module,exports,__globalThis) {
/**
 * Largely taken from analytics-web-react
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSources", function() {
    return getSources;
});
parcelHelpers.export(exports, "getComponents", function() {
    return getComponents;
});
parcelHelpers.export(exports, "getExtraAttributes", function() {
    return getExtraAttributes;
});
parcelHelpers.export(exports, "getPackageInfo", function() {
    return getPackageInfo;
});
parcelHelpers.export(exports, "getPackageVersion", function() {
    return getPackageVersion;
});
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var extractFromEventContext = function(propertyNames, event) {
    var namespacedContextOnly = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, contextName = arguments.length > 3 ? arguments[3] : void 0;
    return event.context.reduce(function(acc, contextItem) {
        propertyNames.forEach(function(propertyName) {
            var navContext = contextItem[contextName];
            var navContextProp = navContext ? navContext[propertyName] : null;
            var value = namespacedContextOnly ? navContextProp : navContextProp || contextItem[propertyName];
            if (value) acc.push(value);
        });
        return acc;
    }, []);
};
var getSources = function(event, contextName) {
    return extractFromEventContext([
        'source'
    ], event, false, contextName);
};
var getComponents = function(event, contextName) {
    return extractFromEventContext([
        'component',
        'componentName'
    ], event, false, contextName);
};
var getExtraAttributes = function(event, contextName) {
    return extractFromEventContext([
        'attributes'
    ], event, true, contextName).reduce(function(result, extraAttributes) {
        return (0, _mergeDefault.default)(result, extraAttributes);
    }, {});
};
var getPackageInfo = function(event, contextName) {
    return event.context.map(function(contextItem) {
        var navContext = contextItem[contextName];
        var item = navContext ? navContext : contextItem;
        return {
            packageName: item.packageName,
            packageVersion: item.packageVersion
        };
    }).filter(function(p) {
        return p.packageName;
    });
};
var getPackageVersion = function(event, contextName) {
    return extractFromEventContext([
        'packageVersion'
    ], event, true, contextName);
};

},{"lodash/merge":"yJjRX","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dqBBg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return MediaAnalyticsListener;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _types = require("../types");
var _processEvent = require("./process-event");
var _genericAnalyticsListener = require("../GenericAnalyticsListener");
var _genericAnalyticsListenerDefault = parcelHelpers.interopDefault(_genericAnalyticsListener);
function MediaAnalyticsListener(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _genericAnalyticsListenerDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        channel: (0, _types.FabricChannel).media,
        processEvent: (0, _processEvent.processEvent)
    }));
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","../types":"eUjnT","./process-event":"7DA5F","../GenericAnalyticsListener":"7NVs3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7DA5F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "processEvent", function() {
    return processEvent;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _analyticsGasTypes = require("@atlaskit/analytics-gas-types");
var _analyticsNamespacedContext = require("@atlaskit/analytics-namespaced-context");
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _last = require("lodash/last");
var _lastDefault = parcelHelpers.interopDefault(_last);
var _extractDataFromEvent = require("../atlaskit/extract-data-from-event");
var listenerVersion = undefined;
function getMediaContexts(event) {
    return (0, _extractDataFromEvent.extractFromEventContext)((0, _analyticsNamespacedContext.MEDIA_CONTEXT), event);
}
function getMediaRegion() {
    try {
        return window && window.sessionStorage && window.sessionStorage.getItem('media-api-region');
    } catch (e) {
        return;
    }
}
function processEvent(event) {
    var sources = (0, _extractDataFromEvent.getSources)(event);
    var _ref = (0, _lastDefault.default)((0, _extractDataFromEvent.getPackageInfo)(event)) || {}, packageName = _ref.packageName, packageVersion = _ref.packageVersion;
    var extraAttributes = (0, _extractDataFromEvent.getExtraAttributes)(event);
    var mediaContexts = getMediaContexts(event) || [];
    var mediaAttributes = (0, _mergeDefault.default).apply(void 0, [
        {}
    ].concat((0, _toConsumableArray._)(mediaContexts)));
    var tags = new Set(event.payload.tags || []);
    tags.add('media');
    var components = (0, _extractDataFromEvent.getComponents)(event);
    var mediaRegion = getMediaRegion();
    var payload = {
        source: (0, _lastDefault.default)(sources) || (0, _analyticsGasTypes.DEFAULT_SOURCE),
        actionSubject: event.payload.actionSubject,
        action: event.payload.action,
        eventType: event.payload.eventType,
        actionSubjectId: event.payload.actionSubjectId,
        // for backward compatibilty
        name: event.payload.name,
        tags: Array.from(tags),
        attributes: (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({
            packageName: packageName,
            packageVersion: packageVersion
        }, (0, _mergeDefault.default)({}, extraAttributes, mediaAttributes, event.payload.attributes)), {
            componentHierarchy: components.join('.') || undefined,
            packageHierarchy: (0, _extractDataFromEvent.getPackageHierarchy)(event),
            sourceHierarchy: sources.join('.') || undefined,
            listenerVersion: listenerVersion
        }), mediaRegion ? {
            mediaRegion: mediaRegion
        } : undefined),
        nonPrivacySafeAttributes: event.payload.nonPrivacySafeAttributes
    };
    return payload;
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_to_consumable_array":"1eSZf","@atlaskit/analytics-gas-types":"hAfQ5","@atlaskit/analytics-namespaced-context":"dWmBD","lodash/merge":"yJjRX","lodash/last":"9zzEk","../atlaskit/extract-data-from-event":"1wXDW","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hfyNS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return PeopleTeamsAnalyticsListener;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _types = require("../types");
var _processEvent = require("./process-event");
var _processEventDefault = parcelHelpers.interopDefault(_processEvent);
var _genericAnalyticsListener = require("../GenericAnalyticsListener");
var _genericAnalyticsListenerDefault = parcelHelpers.interopDefault(_genericAnalyticsListener);
function PeopleTeamsAnalyticsListener(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _genericAnalyticsListenerDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        channel: (0, _types.FabricChannel).peopleTeams,
        processEvent: (0, _processEventDefault.default)
    }));
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","../types":"eUjnT","./process-event":"5JrWL","../GenericAnalyticsListener":"7NVs3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5JrWL":[function(require,module,exports,__globalThis) {
/**
 * Inspired by analytics-web-react
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _last = require("lodash/last");
var _lastDefault = parcelHelpers.interopDefault(_last);
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _analyticsGasTypes = require("@atlaskit/analytics-gas-types");
var _analyticsNamespacedContext = require("@atlaskit/analytics-namespaced-context");
var _extractDataFromEvent = require("../helpers/extract-data-from-event");
var PEOPLE_TEAMS_TAG = 'peopleTeams';
var listenerVersion = undefined;
/**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ exports.default = function(event, logger) {
    var sources = (0, _extractDataFromEvent.getSources)(event, (0, _analyticsNamespacedContext.PEOPLE_TEAMS_CONTEXT));
    var source = (0, _lastDefault.default)(sources) || (0, _analyticsGasTypes.DEFAULT_SOURCE);
    var extraAttributes = (0, _extractDataFromEvent.getExtraAttributes)(event, (0, _analyticsNamespacedContext.PEOPLE_TEAMS_CONTEXT));
    var components = (0, _extractDataFromEvent.getComponents)(event, (0, _analyticsNamespacedContext.PEOPLE_TEAMS_CONTEXT));
    var packages = (0, _extractDataFromEvent.getPackageInfo)(event, (0, _analyticsNamespacedContext.PEOPLE_TEAMS_CONTEXT));
    var _ref = (0, _lastDefault.default)((0, _extractDataFromEvent.getPackageInfo)(event, (0, _analyticsNamespacedContext.PEOPLE_TEAMS_CONTEXT))) || {}, packageName = _ref.packageName, packageVersion = _ref.packageVersion;
    var packageHierarchy = packages.map(function(p) {
        return p.packageVersion ? "".concat(p.packageName, "@").concat(p.packageVersion) : p.packageName;
    });
    var _event_payload = event.payload, _event_payload_eventType = _event_payload.eventType, eventType = _event_payload_eventType === void 0 ? (0, _analyticsGasTypes.UI_EVENT_TYPE) : _event_payload_eventType, action = _event_payload.action, actionSubject = _event_payload.actionSubject, actionSubjectId = _event_payload.actionSubjectId, payloadAttributes = _event_payload.attributes, name = _event_payload.name;
    var attributes = (0, _objectSpread._)({
        listenerVersion: listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion
    }, (0, _mergeDefault.default)(extraAttributes, payloadAttributes));
    // Ensure navigation tag is not duplicated by using Set
    var tags = new Set(event.payload.tags || []);
    tags.add(PEOPLE_TEAMS_TAG);
    if (event.payload) switch(eventType){
        case 0, _analyticsGasTypes.UI_EVENT_TYPE:
        case 0, _analyticsGasTypes.OPERATIONAL_EVENT_TYPE:
        case 0, _analyticsGasTypes.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, _analyticsGasTypes.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

},{"@swc/helpers/_/_object_spread":"9gdrV","lodash/last":"9zzEk","lodash/merge":"yJjRX","@atlaskit/analytics-gas-types":"hAfQ5","@atlaskit/analytics-namespaced-context":"dWmBD","../helpers/extract-data-from-event":"iUV36","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2ccw6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return NotificationsAnalyticsListener;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _types = require("../types");
var _processEvent = require("./process-event");
var _processEventDefault = parcelHelpers.interopDefault(_processEvent);
var _genericAnalyticsListener = require("../GenericAnalyticsListener");
var _genericAnalyticsListenerDefault = parcelHelpers.interopDefault(_genericAnalyticsListener);
function NotificationsAnalyticsListener(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _genericAnalyticsListenerDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        channel: (0, _types.FabricChannel).notifications,
        processEvent: (0, _processEventDefault.default)
    }));
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","../types":"eUjnT","./process-event":"gPu0h","../GenericAnalyticsListener":"7NVs3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gPu0h":[function(require,module,exports,__globalThis) {
/**
 * Inspired by analytics-web-react
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _last = require("lodash/last");
var _lastDefault = parcelHelpers.interopDefault(_last);
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _analyticsGasTypes = require("@atlaskit/analytics-gas-types");
var _extractDataFromEvent = require("../helpers/extract-data-from-event");
var _analyticsNamespacedContext = require("@atlaskit/analytics-namespaced-context");
var _types = require("../types");
var listenerVersion = undefined;
/**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ exports.default = function(event, logger) {
    var sources = (0, _extractDataFromEvent.getSources)(event, (0, _analyticsNamespacedContext.NOTIFICATIONS_CONTEXT));
    var source = (0, _lastDefault.default)(sources) || (0, _analyticsGasTypes.DEFAULT_SOURCE);
    var extraAttributes = (0, _extractDataFromEvent.getExtraAttributes)(event, (0, _analyticsNamespacedContext.NOTIFICATIONS_CONTEXT));
    var components = (0, _extractDataFromEvent.getComponents)(event, (0, _analyticsNamespacedContext.NOTIFICATIONS_CONTEXT));
    var packages = (0, _extractDataFromEvent.getPackageInfo)(event, (0, _analyticsNamespacedContext.NOTIFICATIONS_CONTEXT));
    var _ref = (0, _lastDefault.default)((0, _extractDataFromEvent.getPackageInfo)(event, (0, _analyticsNamespacedContext.NOTIFICATIONS_CONTEXT))) || {}, packageName = _ref.packageName, packageVersion = _ref.packageVersion;
    var packageHierarchy = packages.map(function(p) {
        return p.packageVersion ? "".concat(p.packageName, "@").concat(p.packageVersion) : p.packageName;
    });
    var _event_payload = event.payload, _event_payload_eventType = _event_payload.eventType, eventType = _event_payload_eventType === void 0 ? (0, _analyticsGasTypes.UI_EVENT_TYPE) : _event_payload_eventType, action = _event_payload.action, actionSubject = _event_payload.actionSubject, actionSubjectId = _event_payload.actionSubjectId, payloadAttributes = _event_payload.attributes, name = _event_payload.name;
    var attributes = (0, _objectSpread._)({
        listenerVersion: listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion
    }, (0, _mergeDefault.default)(extraAttributes, payloadAttributes));
    // Ensure navigation tag is not duplicated by using Set
    var tags = new Set(event.payload.tags || []);
    tags.add((0, _types.FabricChannel).notifications);
    if (event.payload) switch(eventType){
        case 0, _analyticsGasTypes.UI_EVENT_TYPE:
        case 0, _analyticsGasTypes.OPERATIONAL_EVENT_TYPE:
        case 0, _analyticsGasTypes.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, _analyticsGasTypes.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

},{"@swc/helpers/_/_object_spread":"9gdrV","lodash/last":"9zzEk","lodash/merge":"yJjRX","@atlaskit/analytics-gas-types":"hAfQ5","../helpers/extract-data-from-event":"iUV36","@atlaskit/analytics-namespaced-context":"dWmBD","../types":"eUjnT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"56z8Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return RecentWorkAnalyticsListener;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _types = require("../types");
var _processEvent = require("./process-event");
var _processEventDefault = parcelHelpers.interopDefault(_processEvent);
var _genericAnalyticsListener = require("../GenericAnalyticsListener");
var _genericAnalyticsListenerDefault = parcelHelpers.interopDefault(_genericAnalyticsListener);
function RecentWorkAnalyticsListener(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _genericAnalyticsListenerDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        channel: (0, _types.FabricChannel).recentWork,
        processEvent: (0, _processEventDefault.default)
    }));
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","../types":"eUjnT","./process-event":"lFSXs","../GenericAnalyticsListener":"7NVs3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lFSXs":[function(require,module,exports,__globalThis) {
/**
 * Inspired by analytics-web-react
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _last = require("lodash/last");
var _lastDefault = parcelHelpers.interopDefault(_last);
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _analyticsGasTypes = require("@atlaskit/analytics-gas-types");
var _extractDataFromEvent = require("../helpers/extract-data-from-event");
var _analyticsNamespacedContext = require("@atlaskit/analytics-namespaced-context");
var _types = require("../types");
var listenerVersion = undefined;
/**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ exports.default = function(event, logger) {
    var sources = (0, _extractDataFromEvent.getSources)(event, (0, _analyticsNamespacedContext.RECENT_WORK_CONTEXT));
    var source = (0, _lastDefault.default)(sources) || (0, _analyticsGasTypes.DEFAULT_SOURCE);
    var extraAttributes = (0, _extractDataFromEvent.getExtraAttributes)(event, (0, _analyticsNamespacedContext.RECENT_WORK_CONTEXT));
    var components = (0, _extractDataFromEvent.getComponents)(event, (0, _analyticsNamespacedContext.RECENT_WORK_CONTEXT));
    var packages = (0, _extractDataFromEvent.getPackageInfo)(event, (0, _analyticsNamespacedContext.RECENT_WORK_CONTEXT));
    var _ref = (0, _lastDefault.default)((0, _extractDataFromEvent.getPackageInfo)(event, (0, _analyticsNamespacedContext.RECENT_WORK_CONTEXT))) || {}, packageName = _ref.packageName, packageVersion = _ref.packageVersion;
    var packageHierarchy = packages.map(function(p) {
        return p.packageVersion ? "".concat(p.packageName, "@").concat(p.packageVersion) : p.packageName;
    });
    var _event_payload = event.payload, _event_payload_eventType = _event_payload.eventType, eventType = _event_payload_eventType === void 0 ? (0, _analyticsGasTypes.UI_EVENT_TYPE) : _event_payload_eventType, action = _event_payload.action, actionSubject = _event_payload.actionSubject, actionSubjectId = _event_payload.actionSubjectId, payloadAttributes = _event_payload.attributes, name = _event_payload.name;
    var attributes = (0, _objectSpread._)({
        listenerVersion: listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion
    }, (0, _mergeDefault.default)(extraAttributes, payloadAttributes));
    // Ensure navigation tag is not duplicated by using Set
    var tags = new Set(event.payload.tags || []);
    tags.add((0, _types.FabricChannel).recentWork);
    if (event.payload) switch(eventType){
        case 0, _analyticsGasTypes.UI_EVENT_TYPE:
        case 0, _analyticsGasTypes.OPERATIONAL_EVENT_TYPE:
        case 0, _analyticsGasTypes.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, _analyticsGasTypes.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

},{"@swc/helpers/_/_object_spread":"9gdrV","lodash/last":"9zzEk","lodash/merge":"yJjRX","@atlaskit/analytics-gas-types":"hAfQ5","../helpers/extract-data-from-event":"iUV36","@atlaskit/analytics-namespaced-context":"dWmBD","../types":"eUjnT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"liKpX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return AtlasAnalyticsListener;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _types = require("../types");
var _processEvent = require("./process-event");
var _processEventDefault = parcelHelpers.interopDefault(_processEvent);
var _genericAnalyticsListener = require("../GenericAnalyticsListener");
var _genericAnalyticsListenerDefault = parcelHelpers.interopDefault(_genericAnalyticsListener);
function AtlasAnalyticsListener(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _genericAnalyticsListenerDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        channel: (0, _types.FabricChannel).atlas,
        processEvent: (0, _processEventDefault.default)
    }));
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","../types":"eUjnT","./process-event":"gv2Cn","../GenericAnalyticsListener":"7NVs3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gv2Cn":[function(require,module,exports,__globalThis) {
/**
 * Inspired by analytics-web-react
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _last = require("lodash/last");
var _lastDefault = parcelHelpers.interopDefault(_last);
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _analyticsGasTypes = require("@atlaskit/analytics-gas-types");
var _extractDataFromEvent = require("../helpers/extract-data-from-event");
var _analyticsNamespacedContext = require("@atlaskit/analytics-namespaced-context");
var ATLAS_TAG = 'atlas';
var listenerVersion = undefined;
/**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ exports.default = function(event, logger) {
    var sources = (0, _extractDataFromEvent.getSources)(event, (0, _analyticsNamespacedContext.ATLAS_CONTEXT));
    var source = (0, _lastDefault.default)(sources) || (0, _analyticsGasTypes.DEFAULT_SOURCE);
    var extraAttributes = (0, _extractDataFromEvent.getExtraAttributes)(event, (0, _analyticsNamespacedContext.ATLAS_CONTEXT));
    var components = (0, _extractDataFromEvent.getComponents)(event, (0, _analyticsNamespacedContext.ATLAS_CONTEXT));
    var packages = (0, _extractDataFromEvent.getPackageInfo)(event, (0, _analyticsNamespacedContext.ATLAS_CONTEXT));
    var _ref = (0, _lastDefault.default)((0, _extractDataFromEvent.getPackageInfo)(event, (0, _analyticsNamespacedContext.ATLAS_CONTEXT))) || {}, packageName = _ref.packageName, packageVersion = _ref.packageVersion;
    var packageHierarchy = packages.map(function(p) {
        return p.packageVersion ? "".concat(p.packageName, "@").concat(p.packageVersion) : p.packageName;
    });
    var _event_payload = event.payload, _event_payload_eventType = _event_payload.eventType, eventType = _event_payload_eventType === void 0 ? (0, _analyticsGasTypes.UI_EVENT_TYPE) : _event_payload_eventType, action = _event_payload.action, actionSubject = _event_payload.actionSubject, actionSubjectId = _event_payload.actionSubjectId, payloadAttributes = _event_payload.attributes, name = _event_payload.name;
    var attributes = (0, _objectSpread._)({
        listenerVersion: listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion
    }, (0, _mergeDefault.default)(extraAttributes, payloadAttributes));
    // Ensure navigation tag is not duplicated by using Set
    var tags = new Set(event.payload.tags || []);
    tags.add(ATLAS_TAG);
    if (event.payload) switch(eventType){
        case 0, _analyticsGasTypes.UI_EVENT_TYPE:
        case 0, _analyticsGasTypes.OPERATIONAL_EVENT_TYPE:
        case 0, _analyticsGasTypes.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, _analyticsGasTypes.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

},{"@swc/helpers/_/_object_spread":"9gdrV","lodash/last":"9zzEk","lodash/merge":"yJjRX","@atlaskit/analytics-gas-types":"hAfQ5","../helpers/extract-data-from-event":"iUV36","@atlaskit/analytics-namespaced-context":"dWmBD","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4X2ix":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return CrossFlowAnalyticsListener;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _types = require("../types");
var _processEvent = require("./process-event");
var _processEventDefault = parcelHelpers.interopDefault(_processEvent);
var _genericAnalyticsListener = require("../GenericAnalyticsListener");
var _genericAnalyticsListenerDefault = parcelHelpers.interopDefault(_genericAnalyticsListener);
function CrossFlowAnalyticsListener(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _genericAnalyticsListenerDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        channel: (0, _types.FabricChannel).crossFlow,
        processEvent: (0, _processEventDefault.default)
    }));
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","../types":"eUjnT","./process-event":"56Ypt","../GenericAnalyticsListener":"7NVs3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"56Ypt":[function(require,module,exports,__globalThis) {
/**
 * Inspired by analytics-web-react
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _analyticsGasTypes = require("@atlaskit/analytics-gas-types");
var _last = require("lodash/last");
var _lastDefault = parcelHelpers.interopDefault(_last);
var _analyticsNamespacedContext = require("@atlaskit/analytics-namespaced-context");
var _extractDataFromEvent = require("../atlaskit/extract-data-from-event");
var _extractDataFromEvent1 = require("../helpers/extract-data-from-event");
var CROSS_FLOW_TAG = 'crossFlow';
exports.default = function(event, logger) {
    var _event_payload = event.payload, _event_payload_eventType = _event_payload.eventType, eventType = _event_payload_eventType === void 0 ? (0, _analyticsGasTypes.UI_EVENT_TYPE) : _event_payload_eventType, action = _event_payload.action, actionSubject = _event_payload.actionSubject, actionSubjectId = _event_payload.actionSubjectId, name = _event_payload.name;
    var sources = (0, _extractDataFromEvent.getSources)(event);
    var lastSourceFromContext = (0, _lastDefault.default)(sources);
    var _event_payload_source;
    var source = (_event_payload_source = event.payload.source) !== null && _event_payload_source !== void 0 ? _event_payload_source : lastSourceFromContext;
    if (lastSourceFromContext !== source) sources.push(source);
    var attributes = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _extractDataFromEvent.getExtraAttributes)(event), (0, _extractDataFromEvent1.getExtraAttributes)(event, (0, _analyticsNamespacedContext.NAVIGATION_CONTEXT)), event.payload.attributes), {
        namespaces: sources.join('.')
    });
    // Ensure navigation tag is not duplicated by using Set
    var tags = new Set(event.payload.tags || []);
    tags.add(CROSS_FLOW_TAG);
    if (event.payload) switch(eventType){
        case 0, _analyticsGasTypes.UI_EVENT_TYPE:
        case 0, _analyticsGasTypes.OPERATIONAL_EVENT_TYPE:
        case 0, _analyticsGasTypes.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, _analyticsGasTypes.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@atlaskit/analytics-gas-types":"hAfQ5","lodash/last":"9zzEk","@atlaskit/analytics-namespaced-context":"dWmBD","../atlaskit/extract-data-from-event":"1wXDW","../helpers/extract-data-from-event":"iUV36","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"b37RF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return LinkingPlatformAnalyticsListener;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _processEvent = require("./process-event");
var _processEventDefault = parcelHelpers.interopDefault(_processEvent);
var _types = require("../types");
var _genericAnalyticsListener = require("../GenericAnalyticsListener");
var _genericAnalyticsListenerDefault = parcelHelpers.interopDefault(_genericAnalyticsListener);
function LinkingPlatformAnalyticsListener(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _genericAnalyticsListenerDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        channel: (0, _types.FabricChannel).linkingPlatform,
        processEvent: (0, _processEventDefault.default)
    }));
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","./process-event":"87Ni0","../types":"eUjnT","../GenericAnalyticsListener":"7NVs3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"87Ni0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _last = require("lodash/last");
var _lastDefault = parcelHelpers.interopDefault(_last);
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _analyticsGasTypes = require("@atlaskit/analytics-gas-types");
var _analyticsNamespacedContext = require("@atlaskit/analytics-namespaced-context");
var _extractDataFromEvent = require("../helpers/extract-data-from-event");
var _types = require("../types");
var listenerVersion = undefined;
exports.default = function(event) {
    var sources = (0, _extractDataFromEvent.getSources)(event, (0, _analyticsNamespacedContext.LINKING_PLATFORM_CONTEXT));
    var packages = (0, _extractDataFromEvent.getPackageInfo)(event, (0, _analyticsNamespacedContext.LINKING_PLATFORM_CONTEXT));
    var components = (0, _extractDataFromEvent.getComponents)(event, (0, _analyticsNamespacedContext.LINKING_PLATFORM_CONTEXT));
    var extraAttributes = (0, _extractDataFromEvent.getExtraAttributes)(event, (0, _analyticsNamespacedContext.LINKING_PLATFORM_CONTEXT));
    var _ref = (0, _lastDefault.default)(packages) || {}, packageName = _ref.packageName, packageVersion = _ref.packageVersion;
    var packageHierarchy = packages.map(function(p) {
        return p.packageVersion ? "".concat(p.packageName, "@").concat(p.packageVersion) : p.packageName;
    });
    var tags = new Set(event.payload.tags || []);
    tags.add((0, _types.FabricChannel).linkingPlatform);
    var payload = {
        name: event.payload.name,
        action: event.payload.action,
        actionSubject: event.payload.actionSubject,
        actionSubjectId: event.payload.actionSubjectId,
        eventType: event.payload.eventType,
        attributes: (0, _objectSpread._)({
            packageName: packageName,
            packageVersion: packageVersion,
            listenerVersion: listenerVersion,
            sourceHierarchy: sources.join('.') || undefined,
            componentHierarchy: components.join('.') || undefined,
            packageHierarchy: packageHierarchy.join(',') || undefined
        }, (0, _mergeDefault.default)(extraAttributes, event.payload.attributes)),
        tags: Array.from(tags),
        source: (0, _lastDefault.default)(sources) || (0, _analyticsGasTypes.DEFAULT_SOURCE),
        nonPrivacySafeAttributes: event.payload.nonPrivacySafeAttributes
    };
    return payload;
};

},{"@swc/helpers/_/_object_spread":"9gdrV","lodash/last":"9zzEk","lodash/merge":"yJjRX","@atlaskit/analytics-gas-types":"hAfQ5","@atlaskit/analytics-namespaced-context":"dWmBD","../helpers/extract-data-from-event":"iUV36","../types":"eUjnT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"l6TnG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return PostOfficeAnalyticsListener;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _types = require("../types");
var _processEvent = require("./process-event");
var _processEventDefault = parcelHelpers.interopDefault(_processEvent);
var _genericAnalyticsListener = require("../GenericAnalyticsListener");
var _genericAnalyticsListenerDefault = parcelHelpers.interopDefault(_genericAnalyticsListener);
function PostOfficeAnalyticsListener(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _genericAnalyticsListenerDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        channel: (0, _types.FabricChannel).postOffice,
        processEvent: (0, _processEventDefault.default)
    }));
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","../types":"eUjnT","./process-event":"2CqGK","../GenericAnalyticsListener":"7NVs3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2CqGK":[function(require,module,exports,__globalThis) {
/**
 * Inspired by analytics-web-react
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _last = require("lodash/last");
var _lastDefault = parcelHelpers.interopDefault(_last);
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _analyticsGasTypes = require("@atlaskit/analytics-gas-types");
var _analyticsNamespacedContext = require("@atlaskit/analytics-namespaced-context");
var _extractDataFromEvent = require("../helpers/extract-data-from-event");
var _types = require("../types");
var POST_OFFICE_TAG = (0, _types.FabricChannel).postOffice;
var listenerVersion = undefined;
/**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ exports.default = function(event, logger) {
    var sources = (0, _extractDataFromEvent.getSources)(event, (0, _analyticsNamespacedContext.POST_OFFICE_CONTEXT));
    var source = (0, _lastDefault.default)(sources) || (0, _analyticsGasTypes.DEFAULT_SOURCE);
    var extraAttributes = (0, _extractDataFromEvent.getExtraAttributes)(event, (0, _analyticsNamespacedContext.POST_OFFICE_CONTEXT));
    var components = (0, _extractDataFromEvent.getComponents)(event, (0, _analyticsNamespacedContext.POST_OFFICE_CONTEXT));
    var packages = (0, _extractDataFromEvent.getPackageInfo)(event, (0, _analyticsNamespacedContext.POST_OFFICE_CONTEXT));
    var _ref = (0, _lastDefault.default)((0, _extractDataFromEvent.getPackageInfo)(event, (0, _analyticsNamespacedContext.POST_OFFICE_CONTEXT))) || {}, packageName = _ref.packageName, packageVersion = _ref.packageVersion;
    var packageHierarchy = packages.map(function(p) {
        return p.packageVersion ? "".concat(p.packageName, "@").concat(p.packageVersion) : p.packageName;
    });
    var _event_payload = event.payload, _event_payload_eventType = _event_payload.eventType, eventType = _event_payload_eventType === void 0 ? (0, _analyticsGasTypes.UI_EVENT_TYPE) : _event_payload_eventType, action = _event_payload.action, actionSubject = _event_payload.actionSubject, actionSubjectId = _event_payload.actionSubjectId, payloadAttributes = _event_payload.attributes, name = _event_payload.name;
    var attributes = (0, _objectSpread._)({
        listenerVersion: listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion
    }, (0, _mergeDefault.default)(extraAttributes, payloadAttributes));
    // Ensure navigation tag is not duplicated by using Set
    var tags = new Set(event.payload.tags || []);
    tags.add(POST_OFFICE_TAG);
    if (event.payload) switch(eventType){
        case 0, _analyticsGasTypes.UI_EVENT_TYPE:
        case 0, _analyticsGasTypes.OPERATIONAL_EVENT_TYPE:
        case 0, _analyticsGasTypes.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, _analyticsGasTypes.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

},{"@swc/helpers/_/_object_spread":"9gdrV","lodash/last":"9zzEk","lodash/merge":"yJjRX","@atlaskit/analytics-gas-types":"hAfQ5","@atlaskit/analytics-namespaced-context":"dWmBD","../helpers/extract-data-from-event":"iUV36","../types":"eUjnT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"86bQ1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return AIMateAnalyticsListener;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _types = require("../types");
var _processEvent = require("./process-event");
var _processEventDefault = parcelHelpers.interopDefault(_processEvent);
var _genericAnalyticsListener = require("../GenericAnalyticsListener");
var _genericAnalyticsListenerDefault = parcelHelpers.interopDefault(_genericAnalyticsListener);
function AIMateAnalyticsListener(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _genericAnalyticsListenerDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        channel: (0, _types.FabricChannel).aiMate,
        processEvent: (0, _processEventDefault.default)
    }));
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","../types":"eUjnT","./process-event":"ysqGd","../GenericAnalyticsListener":"7NVs3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ysqGd":[function(require,module,exports,__globalThis) {
/**
 * Inspired by analytics-web-react
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _last = require("lodash/last");
var _lastDefault = parcelHelpers.interopDefault(_last);
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _analyticsGasTypes = require("@atlaskit/analytics-gas-types");
var _analyticsNamespacedContext = require("@atlaskit/analytics-namespaced-context");
var _extractDataFromEvent = require("../helpers/extract-data-from-event");
var AI_MATE_TAG = 'aiMate';
var listenerVersion = undefined;
/**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ exports.default = function(event, logger) {
    var sources = (0, _extractDataFromEvent.getSources)(event, (0, _analyticsNamespacedContext.AI_MATE_CONTEXT));
    var source = (0, _lastDefault.default)(sources) || (0, _analyticsGasTypes.DEFAULT_SOURCE);
    var extraAttributes = (0, _extractDataFromEvent.getExtraAttributes)(event, (0, _analyticsNamespacedContext.AI_MATE_CONTEXT));
    var components = (0, _extractDataFromEvent.getComponents)(event, (0, _analyticsNamespacedContext.AI_MATE_CONTEXT));
    var packages = (0, _extractDataFromEvent.getPackageInfo)(event, (0, _analyticsNamespacedContext.AI_MATE_CONTEXT));
    var _ref = (0, _lastDefault.default)((0, _extractDataFromEvent.getPackageInfo)(event, (0, _analyticsNamespacedContext.AI_MATE_CONTEXT))) || {}, packageName = _ref.packageName, packageVersion = _ref.packageVersion;
    var packageHierarchy = packages.map(function(p) {
        return p.packageVersion ? "".concat(p.packageName, "@").concat(p.packageVersion) : p.packageName;
    });
    var _event_payload = event.payload, _event_payload_eventType = _event_payload.eventType, eventType = _event_payload_eventType === void 0 ? (0, _analyticsGasTypes.UI_EVENT_TYPE) : _event_payload_eventType, action = _event_payload.action, actionSubject = _event_payload.actionSubject, actionSubjectId = _event_payload.actionSubjectId, payloadAttributes = _event_payload.attributes, name = _event_payload.name, objectId = _event_payload.objectId, objectType = _event_payload.objectType, containerType = _event_payload.containerType, containerId = _event_payload.containerId;
    var attributes = (0, _objectSpread._)({
        listenerVersion: listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion
    }, (0, _mergeDefault.default)(extraAttributes, payloadAttributes));
    // Ensure navigation tag is not duplicated by using Set
    var tags = new Set(event.payload.tags || []);
    tags.add(AI_MATE_TAG);
    if (event.payload) switch(eventType){
        case 0, _analyticsGasTypes.UI_EVENT_TYPE:
        case 0, _analyticsGasTypes.OPERATIONAL_EVENT_TYPE:
        case 0, _analyticsGasTypes.TRACK_EVENT_TYPE:
            return (0, _objectSpread._)({
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            }, objectId && {
                objectId: objectId
            }, objectType && {
                objectType: objectType
            }, containerType && {
                containerType: containerType
            }, containerId && {
                containerId: containerId
            });
        case 0, _analyticsGasTypes.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

},{"@swc/helpers/_/_object_spread":"9gdrV","lodash/last":"9zzEk","lodash/merge":"yJjRX","@atlaskit/analytics-gas-types":"hAfQ5","@atlaskit/analytics-namespaced-context":"dWmBD","../helpers/extract-data-from-event":"iUV36","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cjmAh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return AVPAnalyticsListener;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _types = require("../types");
var _processEvent = require("./process-event");
var _processEventDefault = parcelHelpers.interopDefault(_processEvent);
var _genericAnalyticsListener = require("../GenericAnalyticsListener");
var _genericAnalyticsListenerDefault = parcelHelpers.interopDefault(_genericAnalyticsListener);
function AVPAnalyticsListener(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _genericAnalyticsListenerDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        channel: (0, _types.FabricChannel).avp,
        processEvent: (0, _processEventDefault.default)
    }));
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","../types":"eUjnT","./process-event":"4rI34","../GenericAnalyticsListener":"7NVs3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4rI34":[function(require,module,exports,__globalThis) {
/**
 * Inspired by analytics-web-react
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _last = require("lodash/last");
var _lastDefault = parcelHelpers.interopDefault(_last);
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _analyticsGasTypes = require("@atlaskit/analytics-gas-types");
var _analyticsNamespacedContext = require("@atlaskit/analytics-namespaced-context");
var _extractDataFromEvent = require("../helpers/extract-data-from-event");
var AVP_TAG = 'avp';
var listenerVersion = undefined;
/**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ exports.default = function(event, logger) {
    var sources = (0, _extractDataFromEvent.getSources)(event, (0, _analyticsNamespacedContext.AVP_CONTEXT));
    var source = (0, _lastDefault.default)(sources) || (0, _analyticsGasTypes.DEFAULT_SOURCE);
    var extraAttributes = (0, _extractDataFromEvent.getExtraAttributes)(event, (0, _analyticsNamespacedContext.AVP_CONTEXT));
    var components = (0, _extractDataFromEvent.getComponents)(event, (0, _analyticsNamespacedContext.AVP_CONTEXT));
    var packages = (0, _extractDataFromEvent.getPackageInfo)(event, (0, _analyticsNamespacedContext.AVP_CONTEXT));
    var _ref = (0, _lastDefault.default)((0, _extractDataFromEvent.getPackageInfo)(event, (0, _analyticsNamespacedContext.AVP_CONTEXT))) || {}, packageName = _ref.packageName, packageVersion = _ref.packageVersion;
    var packageHierarchy = packages.map(function(p) {
        return p.packageVersion ? "".concat(p.packageName, "@").concat(p.packageVersion) : p.packageName;
    });
    var _event_payload = event.payload, _event_payload_eventType = _event_payload.eventType, eventType = _event_payload_eventType === void 0 ? (0, _analyticsGasTypes.UI_EVENT_TYPE) : _event_payload_eventType, action = _event_payload.action, actionSubject = _event_payload.actionSubject, actionSubjectId = _event_payload.actionSubjectId, payloadAttributes = _event_payload.attributes, name = _event_payload.name;
    var attributes = (0, _objectSpread._)({
        listenerVersion: listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion
    }, (0, _mergeDefault.default)(extraAttributes, payloadAttributes), (0, _mergeDefault.default).apply(void 0, [
        {}
    ].concat((0, _toConsumableArray._)(event.context))));
    // Ensure navigation tag is not duplicated by using Set
    var tags = new Set(event.payload.tags || []);
    tags.add(AVP_TAG);
    if (event.payload) switch(eventType){
        case 0, _analyticsGasTypes.UI_EVENT_TYPE:
        case 0, _analyticsGasTypes.OPERATIONAL_EVENT_TYPE:
        case 0, _analyticsGasTypes.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, _analyticsGasTypes.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_to_consumable_array":"1eSZf","lodash/last":"9zzEk","lodash/merge":"yJjRX","@atlaskit/analytics-gas-types":"hAfQ5","@atlaskit/analytics-namespaced-context":"dWmBD","../helpers/extract-data-from-event":"iUV36","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dfviK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return GrowthAnalyticsListener;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _types = require("../types");
var _processEvent = require("./process-event");
var _processEventDefault = parcelHelpers.interopDefault(_processEvent);
var _genericAnalyticsListener = require("../GenericAnalyticsListener");
var _genericAnalyticsListenerDefault = parcelHelpers.interopDefault(_genericAnalyticsListener);
function GrowthAnalyticsListener(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _genericAnalyticsListenerDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        channel: (0, _types.FabricChannel).growth,
        processEvent: (0, _processEventDefault.default)
    }));
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","../types":"eUjnT","./process-event":"5MiD3","../GenericAnalyticsListener":"7NVs3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5MiD3":[function(require,module,exports,__globalThis) {
/**
 * Inspired by analytics-web-react
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _last = require("lodash/last");
var _lastDefault = parcelHelpers.interopDefault(_last);
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _analyticsGasTypes = require("@atlaskit/analytics-gas-types");
var _analyticsNamespacedContext = require("@atlaskit/analytics-namespaced-context");
var _extractDataFromEvent = require("../helpers/extract-data-from-event");
var GROWTH_TAG = 'growth';
var listenerVersion = undefined;
/**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ exports.default = function(event, logger) {
    var sources = (0, _extractDataFromEvent.getSources)(event, (0, _analyticsNamespacedContext.GROWTH_CONTEXT));
    var source = (0, _lastDefault.default)(sources) || (0, _analyticsGasTypes.DEFAULT_SOURCE);
    var extraAttributes = (0, _extractDataFromEvent.getExtraAttributes)(event, (0, _analyticsNamespacedContext.GROWTH_CONTEXT));
    var components = (0, _extractDataFromEvent.getComponents)(event, (0, _analyticsNamespacedContext.GROWTH_CONTEXT));
    var packages = (0, _extractDataFromEvent.getPackageInfo)(event, (0, _analyticsNamespacedContext.GROWTH_CONTEXT));
    var _ref = (0, _lastDefault.default)((0, _extractDataFromEvent.getPackageInfo)(event, (0, _analyticsNamespacedContext.GROWTH_CONTEXT))) || {}, packageName = _ref.packageName, packageVersion = _ref.packageVersion;
    var packageHierarchy = packages.map(function(p) {
        return p.packageVersion ? "".concat(p.packageName, "@").concat(p.packageVersion) : p.packageName;
    });
    var _event_payload = event.payload, _event_payload_eventType = _event_payload.eventType, eventType = _event_payload_eventType === void 0 ? (0, _analyticsGasTypes.UI_EVENT_TYPE) : _event_payload_eventType, action = _event_payload.action, actionSubject = _event_payload.actionSubject, actionSubjectId = _event_payload.actionSubjectId, payloadAttributes = _event_payload.attributes, name = _event_payload.name;
    var attributes = (0, _objectSpread._)({
        listenerVersion: listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion
    }, (0, _mergeDefault.default)(extraAttributes, payloadAttributes));
    // Ensure navigation tag is not duplicated by using Set
    var tags = new Set(event.payload.tags || []);
    tags.add(GROWTH_TAG);
    if (event.payload) switch(eventType){
        case 0, _analyticsGasTypes.UI_EVENT_TYPE:
        case 0, _analyticsGasTypes.OPERATIONAL_EVENT_TYPE:
        case 0, _analyticsGasTypes.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, _analyticsGasTypes.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

},{"@swc/helpers/_/_object_spread":"9gdrV","lodash/last":"9zzEk","lodash/merge":"yJjRX","@atlaskit/analytics-gas-types":"hAfQ5","@atlaskit/analytics-namespaced-context":"dWmBD","../helpers/extract-data-from-event":"iUV36","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7RXeX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _types = require("../types");
var _processEvent = require("./process-event");
var _processEventDefault = parcelHelpers.interopDefault(_processEvent);
var _genericAnalyticsListener = require("../GenericAnalyticsListener");
var _genericAnalyticsListenerDefault = parcelHelpers.interopDefault(_genericAnalyticsListener);
var OmniChannelAnalyticsListener = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _genericAnalyticsListenerDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        channel: (0, _types.FabricChannel).omniChannel,
        processEvent: (0, _processEventDefault.default)
    }));
};
exports.default = OmniChannelAnalyticsListener;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","../types":"eUjnT","./process-event":"6OdL9","../GenericAnalyticsListener":"7NVs3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6OdL9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _analyticsGasTypes = require("@atlaskit/analytics-gas-types");
var _analyticsNamespacedContext = require("@atlaskit/analytics-namespaced-context");
var _extractDataFromEvent = require("../helpers/extract-data-from-event");
var _last = require("lodash/last");
var _lastDefault = parcelHelpers.interopDefault(_last);
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _types = require("../types");
var listenerVersion = undefined;
exports.default = function(event, logger) {
    var sources = (0, _extractDataFromEvent.getSources)(event, (0, _analyticsNamespacedContext.OMNI_CHANNEL_CONTEXT));
    var source = (0, _lastDefault.default)(sources) || (0, _analyticsGasTypes.DEFAULT_SOURCE);
    var extraAttributes = (0, _extractDataFromEvent.getExtraAttributes)(event, (0, _analyticsNamespacedContext.OMNI_CHANNEL_CONTEXT));
    var components = (0, _extractDataFromEvent.getComponents)(event, (0, _analyticsNamespacedContext.OMNI_CHANNEL_CONTEXT));
    var packages = (0, _extractDataFromEvent.getPackageInfo)(event, (0, _analyticsNamespacedContext.OMNI_CHANNEL_CONTEXT));
    var _ref = (0, _lastDefault.default)((0, _extractDataFromEvent.getPackageInfo)(event, (0, _analyticsNamespacedContext.OMNI_CHANNEL_CONTEXT))) || {}, packageName = _ref.packageName, packageVersion = _ref.packageVersion;
    var packageHierarchy = packages.map(function(p) {
        return p.packageVersion ? "".concat(p.packageName, "@").concat(p.packageVersion) : p.packageName;
    });
    var _event_payload = event.payload, _event_payload_eventType = _event_payload.eventType, eventType = _event_payload_eventType === void 0 ? (0, _analyticsGasTypes.UI_EVENT_TYPE) : _event_payload_eventType, action = _event_payload.action, actionSubject = _event_payload.actionSubject, actionSubjectId = _event_payload.actionSubjectId, payloadAttributes = _event_payload.attributes, name = _event_payload.name;
    var attributes = (0, _objectSpread._)({
        listenerVersion: listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion
    }, (0, _mergeDefault.default)(extraAttributes, payloadAttributes));
    // Ensure navigation tag is not duplicated by using Set
    var tags = new Set(event.payload.tags || []);
    tags.add((0, _types.FabricChannel).omniChannel);
    if (event.payload) switch(eventType){
        case 0, _analyticsGasTypes.UI_EVENT_TYPE:
        case 0, _analyticsGasTypes.OPERATIONAL_EVENT_TYPE:
        case 0, _analyticsGasTypes.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, _analyticsGasTypes.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@atlaskit/analytics-gas-types":"hAfQ5","@atlaskit/analytics-namespaced-context":"dWmBD","../helpers/extract-data-from-event":"iUV36","lodash/last":"9zzEk","lodash/merge":"yJjRX","../types":"eUjnT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"98lOW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return TownsquareHomeAnalyticsListener;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _types = require("../types");
var _processEvent = require("./process-event");
var _processEventDefault = parcelHelpers.interopDefault(_processEvent);
var _genericAnalyticsListener = require("../GenericAnalyticsListener");
var _genericAnalyticsListenerDefault = parcelHelpers.interopDefault(_genericAnalyticsListener);
function TownsquareHomeAnalyticsListener(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _genericAnalyticsListenerDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        channel: (0, _types.FabricChannel).townsquareHome,
        processEvent: (0, _processEventDefault.default)
    }));
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","../types":"eUjnT","./process-event":"gV8YI","../GenericAnalyticsListener":"7NVs3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gV8YI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _last = require("lodash/last");
var _lastDefault = parcelHelpers.interopDefault(_last);
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _analyticsGasTypes = require("@atlaskit/analytics-gas-types");
var _extractDataFromEvent = require("../helpers/extract-data-from-event");
var _analyticsNamespacedContext = require("@atlaskit/analytics-namespaced-context");
var TOWNSQUARE_TAG = 'townsquare';
var TOWNSQUARE_HOME_TAG = 'townsquareHome';
var listenerVersion = undefined;
/**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * It's a copy paste from the other process-event mappers.
 */ exports.default = function(event, logger) {
    var sources = (0, _extractDataFromEvent.getSources)(event, (0, _analyticsNamespacedContext.TOWNSQUARE_HOME_CONTEXT));
    var source = (0, _lastDefault.default)(sources) || (0, _analyticsGasTypes.DEFAULT_SOURCE);
    var extraAttributes = (0, _extractDataFromEvent.getExtraAttributes)(event, (0, _analyticsNamespacedContext.TOWNSQUARE_HOME_CONTEXT));
    var components = (0, _extractDataFromEvent.getComponents)(event, (0, _analyticsNamespacedContext.TOWNSQUARE_HOME_CONTEXT));
    var packages = (0, _extractDataFromEvent.getPackageInfo)(event, (0, _analyticsNamespacedContext.TOWNSQUARE_HOME_CONTEXT));
    var _ref = (0, _lastDefault.default)((0, _extractDataFromEvent.getPackageInfo)(event, (0, _analyticsNamespacedContext.TOWNSQUARE_HOME_CONTEXT))) || {}, packageName = _ref.packageName, packageVersion = _ref.packageVersion;
    var packageHierarchy = packages.map(function(p) {
        return p.packageVersion ? "".concat(p.packageName, "@").concat(p.packageVersion) : p.packageName;
    });
    var _event_payload = event.payload, _event_payload_eventType = _event_payload.eventType, eventType = _event_payload_eventType === void 0 ? (0, _analyticsGasTypes.UI_EVENT_TYPE) : _event_payload_eventType, action = _event_payload.action, actionSubject = _event_payload.actionSubject, actionSubjectId = _event_payload.actionSubjectId, payloadAttributes = _event_payload.attributes, name = _event_payload.name;
    var attributes = (0, _objectSpread._)({
        listenerVersion: listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion
    }, (0, _mergeDefault.default)(extraAttributes, payloadAttributes));
    var tags = new Set(event.payload.tags || []);
    // "townsquare" is our platform analytic for data portal
    tags.add(TOWNSQUARE_TAG);
    // "townsquareHome" allows us to differentiate our events from townsquare events.
    tags.add(TOWNSQUARE_HOME_TAG);
    if (event.payload) switch(eventType){
        case 0, _analyticsGasTypes.UI_EVENT_TYPE:
        case 0, _analyticsGasTypes.OPERATIONAL_EVENT_TYPE:
        case 0, _analyticsGasTypes.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, _analyticsGasTypes.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

},{"@swc/helpers/_/_object_spread":"9gdrV","lodash/last":"9zzEk","lodash/merge":"yJjRX","@atlaskit/analytics-gas-types":"hAfQ5","../helpers/extract-data-from-event":"iUV36","@atlaskit/analytics-namespaced-context":"dWmBD","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eRmN7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return RovoExtensionAnalyticsListener;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _types = require("../types");
var _processEvent = require("./process-event");
var _processEventDefault = parcelHelpers.interopDefault(_processEvent);
var _genericAnalyticsListener = require("../GenericAnalyticsListener");
var _genericAnalyticsListenerDefault = parcelHelpers.interopDefault(_genericAnalyticsListener);
function RovoExtensionAnalyticsListener(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _genericAnalyticsListenerDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        channel: (0, _types.FabricChannel).rovoExtension,
        processEvent: (0, _processEventDefault.default)
    }));
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","../types":"eUjnT","./process-event":"7K0Ul","../GenericAnalyticsListener":"7NVs3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7K0Ul":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _last = require("lodash/last");
var _lastDefault = parcelHelpers.interopDefault(_last);
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _analyticsGasTypes = require("@atlaskit/analytics-gas-types");
var _extractDataFromEvent = require("../helpers/extract-data-from-event");
var _analyticsNamespacedContext = require("@atlaskit/analytics-namespaced-context");
var ROVO_EXTENSION_TAG = 'rovoExtension';
var listenerVersion = undefined;
/**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * It's a copy paste from the other process-event mappers.
 */ exports.default = function(event, logger) {
    var sources = (0, _extractDataFromEvent.getSources)(event, (0, _analyticsNamespacedContext.ROVO_EXTENSION_CONTEXT));
    var source = (0, _lastDefault.default)(sources) || (0, _analyticsGasTypes.DEFAULT_SOURCE);
    var extraAttributes = (0, _extractDataFromEvent.getExtraAttributes)(event, (0, _analyticsNamespacedContext.ROVO_EXTENSION_CONTEXT));
    var components = (0, _extractDataFromEvent.getComponents)(event, (0, _analyticsNamespacedContext.ROVO_EXTENSION_CONTEXT));
    var packages = (0, _extractDataFromEvent.getPackageInfo)(event, (0, _analyticsNamespacedContext.ROVO_EXTENSION_CONTEXT));
    var _ref = (0, _lastDefault.default)((0, _extractDataFromEvent.getPackageInfo)(event, (0, _analyticsNamespacedContext.ROVO_EXTENSION_CONTEXT))) || {}, packageName = _ref.packageName, packageVersion = _ref.packageVersion;
    var packageHierarchy = packages.map(function(p) {
        return p.packageVersion ? "".concat(p.packageName, "@").concat(p.packageVersion) : p.packageName;
    });
    var _event_payload = event.payload, _event_payload_eventType = _event_payload.eventType, eventType = _event_payload_eventType === void 0 ? (0, _analyticsGasTypes.UI_EVENT_TYPE) : _event_payload_eventType, action = _event_payload.action, actionSubject = _event_payload.actionSubject, actionSubjectId = _event_payload.actionSubjectId, payloadAttributes = _event_payload.attributes, name = _event_payload.name;
    var attributes = (0, _objectSpread._)({
        listenerVersion: listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion
    }, (0, _mergeDefault.default)(extraAttributes, payloadAttributes));
    var tags = new Set(event.payload.tags || []);
    // "rovoExtension" allows us to differentiate our events from rovo events.
    tags.add(ROVO_EXTENSION_TAG);
    if (event.payload) switch(eventType){
        case 0, _analyticsGasTypes.UI_EVENT_TYPE:
        case 0, _analyticsGasTypes.OPERATIONAL_EVENT_TYPE:
        case 0, _analyticsGasTypes.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, _analyticsGasTypes.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

},{"@swc/helpers/_/_object_spread":"9gdrV","lodash/last":"9zzEk","lodash/merge":"yJjRX","@atlaskit/analytics-gas-types":"hAfQ5","../helpers/extract-data-from-event":"iUV36","@atlaskit/analytics-namespaced-context":"dWmBD","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gR0x5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return TeamworkGraphAnalyticsListener;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _types = require("../types");
var _processEvent = require("./process-event");
var _genericAnalyticsListener = require("../GenericAnalyticsListener");
var _genericAnalyticsListenerDefault = parcelHelpers.interopDefault(_genericAnalyticsListener);
function TeamworkGraphAnalyticsListener(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _genericAnalyticsListenerDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        channel: (0, _types.FabricChannel).teamworkGraph,
        processEvent: (0, _processEvent.processEvent)
    }));
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","../types":"eUjnT","./process-event":"el3IY","../GenericAnalyticsListener":"7NVs3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"el3IY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "processEvent", function() {
    return processEvent;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _analyticsGasTypes = require("@atlaskit/analytics-gas-types");
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _last = require("lodash/last");
var _lastDefault = parcelHelpers.interopDefault(_last);
var _extractDataFromEvent = require("../atlaskit/extract-data-from-event");
var listenerVersion = undefined;
function processEvent(event) {
    var sources = (0, _extractDataFromEvent.getSources)(event);
    var _ref = (0, _lastDefault.default)((0, _extractDataFromEvent.getPackageInfo)(event)) || {}, packageName = _ref.packageName, packageVersion = _ref.packageVersion;
    var extraAttributes = (0, _extractDataFromEvent.getExtraAttributes)(event);
    var tags = new Set(event.payload.tags || []);
    tags.add('teamworkGraph');
    var components = (0, _extractDataFromEvent.getComponents)(event);
    var payload = {
        source: (0, _lastDefault.default)(sources) || (0, _analyticsGasTypes.DEFAULT_SOURCE),
        actionSubject: event.payload.actionSubject,
        action: event.payload.action,
        eventType: event.payload.eventType,
        actionSubjectId: event.payload.actionSubjectId,
        name: event.payload.name,
        tags: Array.from(tags),
        attributes: (0, _objectSpreadProps._)((0, _objectSpread._)({
            packageName: packageName,
            packageVersion: packageVersion
        }, (0, _mergeDefault.default)({}, extraAttributes, event.payload.attributes)), {
            componentHierarchy: components.join('.') || undefined,
            packageHierarchy: (0, _extractDataFromEvent.getPackageHierarchy)(event),
            sourceHierarchy: sources.join('.') || undefined,
            listenerVersion: listenerVersion
        }),
        nonPrivacySafeAttributes: event.payload.nonPrivacySafeAttributes
    };
    return payload;
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@atlaskit/analytics-gas-types":"hAfQ5","lodash/merge":"yJjRX","lodash/last":"9zzEk","../atlaskit/extract-data-from-event":"1wXDW","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6Avht":[function(require,module,exports,__globalThis) {
/**
 * Feature Gates initialization for DTAC
 * Following Studio's pattern from @atlassian/studio-foundations-feature-gates
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "featureGatesOptions", function() {
    return featureGatesOptions;
});
parcelHelpers.export(exports, "initializeFeatureGates", function() {
    return initializeFeatureGates;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _featureGateJsClient = require("@atlaskit/feature-gate-js-client");
var _featureGateJsClientDefault = parcelHelpers.interopDefault(_featureGateJsClient);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _config = require("@atlassian/twg-microsite-experience/config");
var TARGET_APP = 'twg-microsite-bifrost_web'; // https://hello.help.atlassian.cloud/servicedesk/customer/portal/3450/MHD-18131?created=true
/**
 * Get the feature gate environment based on the current config environment
 */ var getFeatureGateEnvironment = function() {
    var env = (0, _config.getConfig)().env;
    if (env === 'production') return (0, _featureGateJsClient.FeatureGateEnvironment).Production;
    return (0, _featureGateJsClient.FeatureGateEnvironment).Staging;
};
var featureGatesOptions = {
    apiKey: (0, _config.getConfig)().featureGateApiKey,
    environment: getFeatureGateEnvironment(),
    targetApp: TARGET_APP,
    perimeter: (0, _featureGateJsClient.PerimeterType).COMMERCIAL
};
var initialized = false;
var initializeFeatureGates = function(accountId, orgId) {
    return (0, _asyncToGenerator._)(function() {
        var identifiers, error;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (initialized) return [
                        2
                    ];
                    identifiers = {
                        atlassianAccountId: accountId,
                        atlassianOrgId: orgId
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0, _featureGateJsClientDefault.default).initialize(featureGatesOptions, identifiers)
                    ];
                case 2:
                    _state.sent();
                    // Patch fg() from @atlaskit/platform-feature-flags to use Statsig gate values
                    (0, _platformFeatureFlags.setBooleanFeatureFlagResolver)(function(gateName) {
                        return (0, _featureGateJsClientDefault.default).checkGate(gateName);
                    });
                    initialized = true;
                    // eslint-disable-next-line no-console
                    console.debug('[FeatureGates] Initialized successfully');
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    // eslint-disable-next-line no-console
                    console.error('[FeatureGates] Failed to initialize:', error);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    })();
};

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_ts_generator":"78Tqx","@atlaskit/feature-gate-js-client":"8JPKt","@atlaskit/platform-feature-flags":"kO5t9","@atlassian/twg-microsite-experience/config":"sjwAz","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lf7ae":[function(require,module,exports,__globalThis) {
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DebugPanel", function() {
    return DebugPanel;
});
var _react = require("react");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _useUserContext = require("../../../hooks/use-user-context");
var LazyDebugPanelComponent = /*#__PURE__*/ (0, _react.lazy)(function() {
    return require(/* webpackChunkName: "@atlassian/twg-microsite-debug-panel" */ "31c36b61f85d3e44").then(function(module) {
        return {
            default: module.DebugPanel
        };
    });
});
var DebugPanel = function() {
    (0, _useUserContext.useAtlassianUserContext)();
    if (!(0, _platformFeatureFlags.fg)('twg_microsite_debug_panel')) return null;
    return /*#__PURE__*/ _react.createElement((0, _react.Suspense), {
        fallback: null
    }, /*#__PURE__*/ _react.createElement(LazyDebugPanelComponent, null));
};

},{"react":"ltHCL","@atlaskit/platform-feature-flags":"kO5t9","../../../hooks/use-user-context":"6Qevx","31c36b61f85d3e44":"kCih7","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kCih7":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("398de8fc305c784b")(require("49f1bbead360cbe6").resolve("8yHn9")),
    require("398de8fc305c784b")(require("49f1bbead360cbe6").resolve("9s6tR")),
    require("398de8fc305c784b")(require("49f1bbead360cbe6").resolve("i0bTG")),
    require("398de8fc305c784b")(require("49f1bbead360cbe6").resolve("6tali"))
]).then(function() {
    return module.bundle.root('dPbmI');
});

},{"398de8fc305c784b":"hkfCW","49f1bbead360cbe6":"l4T2r"}],"7lXyx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Boot React UFO for the TwG Microsite.
 *
 * Must be called *before* `createRoot(...).render(<App />)` in `index.tsx`.
 * Reuses the singleton `AnalyticsWebClient` returned by `initAnalyticsClient`
 * so UFO and product analytics share one transport.
 */ parcelHelpers.export(exports, "initUFO", function() {
    return initUFO;
});
var _interactionMetricsInit = require("@atlaskit/react-ufo/interaction-metrics-init");
var _tracePageload = require("@atlaskit/react-ufo/trace-pageload");
var _tracePageloadDefault = parcelHelpers.interopDefault(_tracePageload);
var _twgMicrositeExperience = require("@atlassian/twg-microsite-experience");
var _config = require("@atlassian/twg-microsite-experience/config");
var kind = {
    page_load: 1,
    // Single-route marketing-style app today — no real client-side
    // transitions occur. Leaving this on would only record noise (or
    // surprise telemetry if a route is added without revisiting this).
    transition: 0,
    press: 1,
    typing: 0,
    legacy: 0,
    hover: 0,
    segment: 0
};
var _getConfig = (0, _config.getConfig)(), env = _getConfig.env, region = _getConfig.region;
var config = {
    product: 'teamworkGraph',
    region: region,
    capability: {
        // `feature_flag_access: 0` for now — wiring `addFeatureFlagAccessed`
        // into the feature-flag layer is a follow-up. Without that hook
        // `feature_flag_access: 1` would advertise a capability we don't
        // fulfil yet.
        feature_flag_access: 0,
        react_profiler: 1
    },
    kind: kind,
    vc: {
        enabled: true,
        // Default (100) is plenty for a marketing-style page; reduces VC
        // compute on every paint, which matters more on mobile / low-end
        // devices that often hit landing pages.
        heatmapSize: 100,
        oldDomUpdates: false,
        // Devtools surface should never ship to real users — gate to
        // non-prod to keep the prod bundle lean and avoid leaking
        // internal UFO state on `window`.
        devToolsEnabled: env !== 'production',
        selectorConfig: {
            id: false,
            role: true,
            className: true,
            testId: true
        }
    }
};
function initUFO() {
    var client = (0, _twgMicrositeExperience.initAnalyticsClient)();
    (0, _interactionMetricsInit.init)(Promise.resolve(client), config);
    // Single-route app today — fire the page-load trace immediately with the
    // known route name so the initial interaction is fully classified.
    // Both args use the route registry name `HOME` (see ./ui/routes/index.ts)
    // so the interaction name and route name are consistent in dashboards.
    (0, _tracePageloadDefault.default)('HOME', 'HOME');
}

},{"@atlaskit/react-ufo/interaction-metrics-init":"coa1p","@atlaskit/react-ufo/trace-pageload":"enJdV","@atlassian/twg-microsite-experience":"3ciWs","@atlassian/twg-microsite-experience/config":"sjwAz","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"coa1p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "init", function() {
    return init;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _api = require("@opentelemetry/api");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _additionalPayload = require("../additional-payload");
var _config = require("../config");
var _createExperimentalInteractionMetricsPayload = require("../create-experimental-interaction-metrics-payload");
var _createExtraSearchPageInteractionPayload = require("../create-extra-search-page-interaction-payload");
var _contextManager = require("../experience-trace-id-context/context-manager");
var _hiddenTiming = require("../hidden-timing");
var _interactionMetrics = require("../interaction-metrics");
var _interactionsPerformanceObserver = require("../interactions-performance-observer");
var _machineUtilisation = require("../machine-utilisation");
var _setTerminalError = require("../set-terminal-error");
var _scheduleIdleCallback = require("./schedule-idle-callback");
var _scheduleIdleCallbackDefault = parcelHelpers.interopDefault(_scheduleIdleCallback);
var initialized = false;
function sinkInteraction(instance, payloadPackage) {
    function sinkFn(interactionId, interaction) {
        function onIdle() {
            payloadPackage.createPayloads(interactionId, interaction).then(function(payloads) {
                // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
                var devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                payloads === null || payloads === void 0 ? void 0 : payloads.forEach(function(payload) {
                    if (typeof devToolObserver === 'function') devToolObserver === null || devToolObserver === void 0 ? void 0 : devToolObserver(payload);
                    instance.sendOperationalEvent(payload);
                });
            }).catch(function(error) {
                throw error;
            });
        }
        (0, _scheduleIdleCallbackDefault.default)(onIdle);
    }
    (0, _interactionMetrics.sinkInteractionHandler)(sinkFn);
}
function sinkExperimentalInteractionMetrics(instance, payloadPackage) {
    function experimentalMetricsSinkFn(interactionId, interaction) {
        function experimentalMetricsOnIdle() {
            var payloadPromise = payloadPackage.createExperimentalMetricsPayload(interactionId, interaction);
            payloadPromise.then(function(payload) {
                if (payload) instance.sendOperationalEvent(payload);
            });
        }
        (0, _scheduleIdleCallbackDefault.default)(experimentalMetricsOnIdle);
    }
    (0, _createExperimentalInteractionMetricsPayload.sinkExperimentalHandler)(experimentalMetricsSinkFn);
}
function sinkPostInteractionLog(instance, createPostInteractionLogPayload) {
    (0, _interactionMetrics.sinkPostInteractionLogHandler)(function(logOutput) {
        (0, _scheduleIdleCallbackDefault.default)(function() {
            var payload = createPostInteractionLogPayload(logOutput);
            if (payload) instance.sendOperationalEvent(payload);
        });
    });
}
function sinkTerminalErrors(instance, createTerminalErrorPayload) {
    (0, _setTerminalError.sinkTerminalErrorHandler)(function(errorData, context) {
        (0, _scheduleIdleCallbackDefault.default)(function() {
            var payload = createTerminalErrorPayload(errorData, context);
            if (payload) instance.sendOperationalEvent(payload);
        });
    });
}
function sinkInteractionExtraMetrics(instance, createInteractionExtraLogPayload) {
    (0, _interactionMetrics.interactionExtraMetrics).sinkHandler(function(interactionId, interaction, lastInteractionFinish, lastInteractionFinishVCResult) {
        (0, _scheduleIdleCallbackDefault.default)(function() {
            return (0, _asyncToGenerator._)(function() {
                var payload;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                createInteractionExtraLogPayload(interactionId, interaction, lastInteractionFinish, lastInteractionFinishVCResult)
                            ];
                        case 1:
                            payload = _state.sent();
                            if (payload) instance.sendOperationalEvent(payload);
                            return [
                                2
                            ];
                    }
                });
            })();
        });
    });
}
function sinkExtraSearchPageInteraction(instance, payloadPackage) {
    function sinkFn(interactionId, interaction) {
        function onIdle() {
            payloadPackage.createExtraSearchPageInteractionPayload(interactionId, interaction).then(function(payloads) {
                // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
                var devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                payloads === null || payloads === void 0 ? void 0 : payloads.forEach(function(payload) {
                    if (typeof devToolObserver === 'function') devToolObserver === null || devToolObserver === void 0 ? void 0 : devToolObserver(payload);
                    instance.sendOperationalEvent(payload);
                });
            }).catch(function(error) {
                throw error;
            });
        }
        (0, _scheduleIdleCallbackDefault.default)(onIdle);
    }
    (0, _createExtraSearchPageInteractionPayload.sinkExtraSearchPageInteractionHandler)(sinkFn);
}
function init(analyticsWebClientAsync, config) {
    var _config_vc;
    if (initialized) return;
    // Always set config first so isUFOEnabled() can check config.enabled
    (0, _config.setUFOConfig)(config);
    // If UFO is disabled via config, skip all initialization
    if (!(0, _config.isUFOEnabled)()) {
        initialized = true;
        return;
    }
    // Initialize pressure observer for CPU usage monitoring
    (0, _machineUtilisation.initialisePressureObserver)();
    (0, _machineUtilisation.initialiseMemoryObserver)();
    if ((0, _platformFeatureFlags.fg)('platform_ufo_enable_otel_context_manager')) {
        // Configure global OTel context manager
        var contextManager = new (0, _contextManager.UFOContextManager)();
        // set the contextmanager somewhere we can reference it later
        (0, _contextManager.setContextManager)(contextManager);
        // Register the context manager with the global OTel API
        contextManager.enable();
        (0, _api.context).setGlobalContextManager(contextManager);
    }
    if ((_config_vc = config.vc) === null || _config_vc === void 0 ? void 0 : _config_vc.enabled) {
        var _config_experimentalInteractionMetrics, _config_extraInteractionMetrics;
        var vcOptions = {
            heatmapSize: config.vc.heatmapSize,
            oldDomUpdates: config.vc.oldDomUpdates,
            devToolsEnabled: config.vc.devToolsEnabled,
            // Use centralised getter so the FedRAMP override (forces every
            // selector field to false) is applied consistently.
            selectorConfig: (0, _config.getSelectorConfig)(),
            ssrEnablePageLayoutPlaceholder: config.vc.ssrEnablePageLayoutPlaceholder,
            trackLayoutShiftOffenders: config.vc.trackLayoutShiftOffenders
        };
        (0, _interactionMetrics.postInteractionLog).initializeVCObserver(vcOptions);
        if (!(0, _platformFeatureFlags.fg)('platform_ufo_remove_experimental_holds') && (config === null || config === void 0 ? void 0 : (_config_experimentalInteractionMetrics = config.experimentalInteractionMetrics) === null || _config_experimentalInteractionMetrics === void 0 ? void 0 : _config_experimentalInteractionMetrics.enabled)) (0, _createExperimentalInteractionMetricsPayload.experimentalVC).initialize(vcOptions).start({
            startTime: 0
        });
        if (config === null || config === void 0 ? void 0 : (_config_extraInteractionMetrics = config.extraInteractionMetrics) === null || _config_extraInteractionMetrics === void 0 ? void 0 : _config_extraInteractionMetrics.enabled) (0, _interactionMetrics.interactionExtraMetrics).initializeVCObserver(vcOptions);
    }
    (0, _hiddenTiming.setupHiddenTimingCapture)();
    (0, _additionalPayload.startLighthouseObserver)();
    (0, _hiddenTiming.setupThrottleDetection)();
    initialized = true;
    if (typeof PerformanceObserver !== 'undefined') {
        var observer = (0, _interactionsPerformanceObserver.getPerformanceObserver)();
        observer.observe({
            type: 'event',
            buffered: true,
            durationThreshold: 16
        });
    }
    Promise.all([
        analyticsWebClientAsync,
        require(/* webpackChunkName: "create-payloads" */ "aa686257ee48224b"),
        require(/* webpackChunkName: "create-post-interaction-log-payload" */ "7bb65f369e215a20"),
        require(/* webpackChunkName: "create-interaction-extra-metrics-payload" */ "4070533a77a290f4"),
        require(/* webpackChunkName: "create-terminal-error-payload@atlaskit-internal_terminal_errors" */ "17f90c8d7e631f0f")
    ]).then(function(param) {
        var _param = (0, _slicedToArray._)(param, 5), awc = _param[0], payloadPackage = _param[1], createPostInteractionLogPayloadPackage = _param[2], createInteractionExtraMetricsPayloadPackage = _param[3], createTerminalErrorPayloadPackage = _param[4];
        if (awc.getAnalyticsWebClientPromise) awc.getAnalyticsWebClientPromise().then(function(client) {
            var _config_terminalErrors, _config_experimentalInteractionMetrics, _config_postInteractionLog, _config_extraInteractionMetrics, _config_extraSearchPageInteraction;
            var instance = client.getInstance();
            sinkInteraction(instance, payloadPackage);
            if ((config === null || config === void 0 ? void 0 : (_config_terminalErrors = config.terminalErrors) === null || _config_terminalErrors === void 0 ? void 0 : _config_terminalErrors.enabled) && (0, _platformFeatureFlags.fg)('platform_ufo_enable_terminal_errors')) sinkTerminalErrors(instance, createTerminalErrorPayloadPackage.default);
            if (!(0, _platformFeatureFlags.fg)('platform_ufo_remove_experimental_holds') && (config === null || config === void 0 ? void 0 : (_config_experimentalInteractionMetrics = config.experimentalInteractionMetrics) === null || _config_experimentalInteractionMetrics === void 0 ? void 0 : _config_experimentalInteractionMetrics.enabled)) sinkExperimentalInteractionMetrics(instance, payloadPackage);
            if ((_config_postInteractionLog = config.postInteractionLog) === null || _config_postInteractionLog === void 0 ? void 0 : _config_postInteractionLog.enabled) sinkPostInteractionLog(instance, createPostInteractionLogPayloadPackage.default);
            if (config === null || config === void 0 ? void 0 : (_config_extraInteractionMetrics = config.extraInteractionMetrics) === null || _config_extraInteractionMetrics === void 0 ? void 0 : _config_extraInteractionMetrics.enabled) sinkInteractionExtraMetrics(instance, createInteractionExtraMetricsPayloadPackage.default);
            if (config === null || config === void 0 ? void 0 : (_config_extraSearchPageInteraction = config.extraSearchPageInteraction) === null || _config_extraSearchPageInteraction === void 0 ? void 0 : _config_extraSearchPageInteraction.enabled) sinkExtraSearchPageInteraction(instance, payloadPackage);
        });
        else if (awc.sendOperationalEvent) {
            var _config_terminalErrors, _config_experimentalInteractionMetrics, _config_postInteractionLog, _config_extraInteractionMetrics, _config_extraSearchPageInteraction;
            sinkInteraction(awc, payloadPackage);
            if ((config === null || config === void 0 ? void 0 : (_config_terminalErrors = config.terminalErrors) === null || _config_terminalErrors === void 0 ? void 0 : _config_terminalErrors.enabled) && (0, _platformFeatureFlags.fg)('platform_ufo_enable_terminal_errors')) sinkTerminalErrors(awc, createTerminalErrorPayloadPackage.default);
            if (!(0, _platformFeatureFlags.fg)('platform_ufo_remove_experimental_holds') && (config === null || config === void 0 ? void 0 : (_config_experimentalInteractionMetrics = config.experimentalInteractionMetrics) === null || _config_experimentalInteractionMetrics === void 0 ? void 0 : _config_experimentalInteractionMetrics.enabled)) sinkExperimentalInteractionMetrics(awc, payloadPackage);
            if ((_config_postInteractionLog = config.postInteractionLog) === null || _config_postInteractionLog === void 0 ? void 0 : _config_postInteractionLog.enabled) sinkPostInteractionLog(awc, createPostInteractionLogPayloadPackage.default);
            if (config === null || config === void 0 ? void 0 : (_config_extraInteractionMetrics = config.extraInteractionMetrics) === null || _config_extraInteractionMetrics === void 0 ? void 0 : _config_extraInteractionMetrics.enabled) sinkInteractionExtraMetrics(awc, createInteractionExtraMetricsPayloadPackage.default);
            if (config === null || config === void 0 ? void 0 : (_config_extraSearchPageInteraction = config.extraSearchPageInteraction) === null || _config_extraSearchPageInteraction === void 0 ? void 0 : _config_extraSearchPageInteraction.enabled) sinkExtraSearchPageInteraction(awc, payloadPackage);
        }
    });
}

},{"@swc/helpers/_/_async_to_generator":"hjHWA","@swc/helpers/_/_sliced_to_array":"8PtL6","@swc/helpers/_/_ts_generator":"78Tqx","@opentelemetry/api":"9lCa7","@atlaskit/platform-feature-flags":"kO5t9","../additional-payload":"COolf","../config":"1BZI5","../create-experimental-interaction-metrics-payload":"c2BXB","../create-extra-search-page-interaction-payload":"hcmdv","../experience-trace-id-context/context-manager":"8G8ci","../hidden-timing":"lV0ww","../interaction-metrics":"diQdd","../interactions-performance-observer":"ayhky","../machine-utilisation":"96IW9","../set-terminal-error":"iW354","./schedule-idle-callback":"kYNI2","aa686257ee48224b":"9mC2Z","7bb65f369e215a20":"642W1","4070533a77a290f4":"gSPaW","17f90c8d7e631f0f":"FsT4Z","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"COolf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "startLighthouseObserver", function() {
    return 0, _lighthouseMetrics.startLighthouseObserver;
});
parcelHelpers.export(exports, "getLighthouseMetrics", function() {
    return 0, _lighthouseMetrics.getLighthouseMetrics;
});
parcelHelpers.export(exports, "getCacheHitRatio", function() {
    return 0, _cacheHitRatio.getCacheHitRatio;
});
var _lighthouseMetrics = require("./utils/lighthouse-metrics");
var _cacheHitRatio = require("./utils/cache-hit-ratio");

},{"./utils/lighthouse-metrics":"aBrzw","./utils/cache-hit-ratio":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aBrzw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "startLighthouseObserver", function() {
    return startLighthouseObserver;
});
parcelHelpers.export(exports, "getLighthouseMetrics", function() {
    return getLighthouseMetrics;
});
var _cls = require("./cls");
var _const = require("./const");
var _tbt = require("./tbt");
var _buffer = require("./utils/buffer");
var _observer = require("./utils/observer");
function startLighthouseObserver() {
    (0, _observer.startLSObserver)();
    (0, _observer.startLTObserver)();
}
function getLighthouseMetrics(param) {
    var start = param.start, stop = param.stop;
    var tbt = (0, _tbt.getTBT)(start, stop, (0, _buffer.EntriesBuffer)[(0, _const.PerformanceObserverEntryTypes).LongTask]);
    // no round as CLS is usually 0-1
    var cls = (0, _cls.getCLS)(start, stop, (0, _buffer.EntriesBuffer)[(0, _const.PerformanceObserverEntryTypes).LayoutShift]);
    return {
        'metric:tbt': Math.round(tbt.total),
        'metric:tbt:observed': Math.round(tbt.observed),
        'metric:cls': cls
    };
}

},{"./cls":"k9DxE","./const":"jnaSC","./tbt":"iPOOB","./utils/buffer":"lxCdY","./utils/observer":"bSWAb","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"k9DxE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCLS", function() {
    return getCLS;
});
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
function isSameRects(rect1, rect2) {
    return rect1.x === rect2.x && rect1.y === rect2.y && rect1.width === rect2.width && rect1.height === rect2.height && rect1.top === rect2.top && rect1.right === rect2.right && rect1.bottom === rect2.bottom && rect1.left === rect2.left;
}
function getCLS(start, stop, buffer) {
    var layoutShifts = buffer.getAll().filter(function(_entry) {
        var entry = _entry;
        var isWithinObservationWindow = entry.startTime >= start && entry.startTime <= stop;
        if ((0, _platformFeatureFlags.fg)('platform_ufo_filter_cls_logs_same_rects_positions')) {
            var _entry_sources;
            var allSourcesHaveSameRects = entry === null || entry === void 0 ? void 0 : (_entry_sources = entry.sources) === null || _entry_sources === void 0 ? void 0 : _entry_sources.every(function(param) {
                var previousRect = param.previousRect, currentRect = param.currentRect;
                return isSameRects(previousRect, currentRect);
            });
            return isWithinObservationWindow && !allSourcesHaveSameRects;
        }
        return isWithinObservationWindow;
    });
    var sessionWindows = [];
    var currentWindow = null;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // Group layout shifts into session windows
        for(var _iterator = layoutShifts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var shift = _step.value;
            var startTime = shift.startTime;
            var endTime = shift.startTime + shift.duration;
            var score = shift.value;
            if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
                // Start a new session window
                currentWindow = {
                    startTime: startTime,
                    endTime: endTime,
                    score: score
                };
                sessionWindows.push(currentWindow);
            } else {
                // Add layout shift to current session window
                currentWindow.endTime = endTime;
                currentWindow.score += score;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Find session window with highest cumulative score
    var maxScore = sessionWindows.reduce(function(max, sessionWindow) {
        return sessionWindow.score > max ? sessionWindow.score : max;
    }, 0);
    // Return score of largest burst as CLS metric
    return Math.round(maxScore * 10000) / 10000;
}

},{"@atlaskit/platform-feature-flags":"kO5t9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jnaSC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PerformanceObserverEntryTypes", function() {
    return PerformanceObserverEntryTypes;
});
var PerformanceObserverEntryTypes = {
    LayoutShift: 'layout-shift',
    LongTask: 'longtask'
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iPOOB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTBT", function() {
    return getTBT;
});
var MAX_ACCEPTABLE_TASK_DURATION = 50;
function getTBT(start, stop, buffer) {
    return buffer.getAll().filter(function(entry) {
        return entry.startTime <= stop && entry.duration > MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop);
    }).reduce(function(tbt, entry) {
        var longTaskStop = entry.startTime + entry.duration;
        var intersectStart = Math.max(entry.startTime + MAX_ACCEPTABLE_TASK_DURATION, start);
        var intersectStop = Math.min(longTaskStop, stop);
        var longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
        // eslint-disable-next-line no-param-reassign
        tbt.observed += entry.duration - MAX_ACCEPTABLE_TASK_DURATION;
        // eslint-disable-next-line no-param-reassign
        tbt.total += longTaskIncluded;
        return tbt;
    }, {
        total: 0,
        observed: 0
    });
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lxCdY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BufferWithMaxLength", function() {
    return BufferWithMaxLength;
});
parcelHelpers.export(exports, "EntriesBuffer", function() {
    return EntriesBuffer;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _const = require("../../const");
var BufferWithMaxLength = /*#__PURE__*/ function() {
    "use strict";
    function BufferWithMaxLength() {
        var maxLength = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1000;
        (0, _classCallCheck._)(this, BufferWithMaxLength);
        this.buffer = [];
        this.full = false;
        this.maxLength = maxLength;
    }
    (0, _createClass._)(BufferWithMaxLength, [
        {
            key: "push",
            value: function push(item) {
                if (this.full || this.maxLength === this.buffer.length) {
                    this.full = true;
                    this.buffer.shift();
                }
                this.buffer.push(item);
            }
        },
        {
            key: "getAll",
            value: function getAll() {
                return this.buffer;
            }
        }
    ]);
    return BufferWithMaxLength;
}();
var _obj;
var EntriesBuffer = (_obj = {}, (0, _defineProperty._)(_obj, (0, _const.PerformanceObserverEntryTypes).LongTask, new BufferWithMaxLength()), (0, _defineProperty._)(_obj, (0, _const.PerformanceObserverEntryTypes).LayoutShift, new BufferWithMaxLength()), _obj);

},{"@swc/helpers/_/_class_call_check":"5CNCO","@swc/helpers/_/_create_class":"8eDyv","@swc/helpers/_/_define_property":"e80IS","../../const":"jnaSC","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bSWAb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "startLSObserver", function() {
    return startLSObserver;
});
parcelHelpers.export(exports, "startLTObserver", function() {
    return startLTObserver;
});
var _const = require("../../const");
var _buffer = require("../buffer");
var pe = null;
function getObserver() {
    if (typeof PerformanceObserver !== 'function') // Only instantiate the IntersectionObserver if it's supported
    return null;
    if (pe !== null) return pe;
    var performanceObserverCallback = function(list) {
        list.getEntries().forEach(function(entry) {
            if (entry.entryType === (0, _const.PerformanceObserverEntryTypes).LayoutShift) (0, _buffer.EntriesBuffer)[(0, _const.PerformanceObserverEntryTypes).LayoutShift].push(entry);
            if (entry.entryType === (0, _const.PerformanceObserverEntryTypes).LongTask) (0, _buffer.EntriesBuffer)[(0, _const.PerformanceObserverEntryTypes).LongTask].push(entry);
        });
    };
    pe = new PerformanceObserver(performanceObserverCallback);
    return pe;
}
function startLSObserver() {
    var _getObserver;
    (_getObserver = getObserver()) === null || _getObserver === void 0 ? void 0 : _getObserver.observe({
        type: (0, _const.PerformanceObserverEntryTypes).LayoutShift,
        buffered: true
    });
}
function startLTObserver() {
    var _getObserver;
    (_getObserver = getObserver()) === null || _getObserver === void 0 ? void 0 : _getObserver.observe({
        type: (0, _const.PerformanceObserverEntryTypes).LongTask,
        buffered: true
    });
}

},{"../../const":"jnaSC","../buffer":"lxCdY","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ayhky":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPerformanceObserver", function() {
    return getPerformanceObserver;
});
parcelHelpers.export(exports, "setInteractionPerformanceEvent", function() {
    return setInteractionPerformanceEvent;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _config = require("../config");
var _interactionMetrics = require("../interaction-metrics");
var _getUniqueElementName = require("../vc/vc-observer-new/get-unique-element-name");
var _getUniqueElementNameDefault = parcelHelpers.interopDefault(_getUniqueElementName);
var performanceEventObserver;
var DEFAULT_SELECTOR_CONFIG = {
    id: true,
    testId: true,
    role: true,
    className: true
};
/**
 * Resolve the SelectorConfig for the performance-observer code path.
 *
 * In FedRAMP Moderate environments (when `getSelectorConfig()` returns the
 * forced all-`false` config) we honour that override; otherwise we fall back
 * to the historical default that enables every selector.
 */ function resolveSelectorConfig() {
    var _getSelectorConfig;
    return (_getSelectorConfig = (0, _config.getSelectorConfig)()) !== null && _getSelectorConfig !== void 0 ? _getSelectorConfig : DEFAULT_SELECTOR_CONFIG;
}
function getTestIdName(memoizedProps) {
    if (memoizedProps['data-testid']) return "[data-testid=".concat(memoizedProps['data-testid'], "]");
    else if (memoizedProps['data-test-id']) return "[data-test-id=".concat(memoizedProps['data-testid'], "]");
    else if (memoizedProps['data-vc']) return "[data-vc=".concat(memoizedProps['data-vc'], "]");
    return null;
}
function getUFOSegmentName(componentName, memoizedProps) {
    if (memoizedProps && memoizedProps['name']) return "UFOSegment[name=".concat(memoizedProps['name'], "]");
    return componentName;
}
function getReactComponentHierarchy(element) {
    var componentHierarchy = [];
    // Function to traverse up the fiber tree
    function traverseFiber(fiber) {
        var currentFiber = fiber;
        while(currentFiber){
            if (currentFiber.type) {
                // Check if there's a display name or a function name
                var componentName = currentFiber.type.displayName || currentFiber.type.name;
                // checking when component name is bigger than the minimized name produced by react
                if (componentName && componentName.length > 2 && !componentName.includes('Listener') && !componentName.includes('Provider')) {
                    if (componentName === 'UFOSegment') {
                        componentHierarchy.push(getUFOSegmentName(componentName, currentFiber.memoizedProps));
                        break;
                    }
                    componentHierarchy.push(componentName);
                }
            }
            if (currentFiber.memoizedProps) {
                var dataIdInfo = getTestIdName(currentFiber.memoizedProps);
                if (dataIdInfo) {
                    componentHierarchy.push(dataIdInfo);
                    currentFiber = null;
                    continue;
                }
            }
            currentFiber = currentFiber.return;
        }
    }
    // Access the reactFiber node from the HTML element
    var reactFiberKey = Object.keys(element).find(function(key) {
        return key.startsWith('__reactFiber$');
    });
    if (reactFiberKey) {
        var fiber = element[reactFiberKey];
        traverseFiber(fiber);
    }
    return componentHierarchy.reverse().join(' > ');
}
var getPerformanceObserver = function() {
    performanceEventObserver = performanceEventObserver || new PerformanceObserver(function(entries) {
        var list = entries.getEntries();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entry = _step.value;
                if (entry.name === 'click') setInteractionPerformanceEvent(entry);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    return performanceEventObserver;
};
var setInteractionPerformanceEvent = function(entry) {
    var _interaction_responsiveness;
    var interaction = (0, _interactionMetrics.getActiveInteraction)();
    if ((interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'press') {
        if (!((_interaction_responsiveness = interaction.responsiveness) === null || _interaction_responsiveness === void 0 ? void 0 : _interaction_responsiveness.experimentalInputToNextPaint)) {
            var _interaction_responsiveness1, _interaction_responsiveness2;
            interaction.responsiveness = (0, _objectSpreadProps._)((0, _objectSpread._)({}, interaction.responsiveness), {
                experimentalInputToNextPaint: ((_interaction_responsiveness1 = interaction.responsiveness) === null || _interaction_responsiveness1 === void 0 ? void 0 : _interaction_responsiveness1.experimentalInputToNextPaint) || entry.duration,
                inputDelay: ((_interaction_responsiveness2 = interaction.responsiveness) === null || _interaction_responsiveness2 === void 0 ? void 0 : _interaction_responsiveness2.inputDelay) || entry.processingStart - entry.startTime
            });
            if (interaction.ufoName === 'unknown') {
                if (entry.target) {
                    var componentHierarchy = getReactComponentHierarchy(entry.target);
                    interaction.unknownElementHierarchy = componentHierarchy;
                }
                interaction.unknownElementName = (0, _getUniqueElementNameDefault.default)(resolveSelectorConfig(), entry.target);
            }
        }
    }
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","../config":"1BZI5","../interaction-metrics":"diQdd","../vc/vc-observer-new/get-unique-element-name":"8nqbL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8nqbL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _instanceof = require("@swc/helpers/_/_instanceof");
var nameCache = new WeakMap();
function getAttributeSelector(element, attributeName) {
    var attrValue = element.getAttribute(attributeName);
    if (!attrValue) return '';
    return "[".concat(attributeName, '="').concat(attrValue, '"]');
}
function isValidSelector(selector) {
    try {
        document.querySelector(selector);
        return true;
    } catch (e) {
        return false;
    }
}
function isSelectorUnique(selector) {
    return document.querySelectorAll(selector).length === 1;
}
function getUniqueSelector(selectorConfig, element) {
    var currentElement = element;
    var parts = [];
    var MAX_DEPTH = 3;
    var currentDepth = 0;
    while(currentElement && currentElement.localName !== 'body' && currentDepth <= MAX_DEPTH){
        var tagName = currentElement.localName;
        var selectorPart = tagName;
        if (selectorConfig.id && currentElement.id && isValidSelector("#".concat(currentElement.id))) selectorPart += "#".concat(currentElement.id);
        else if (selectorConfig.dataVC) selectorPart += getAttributeSelector(currentElement, 'data-vc');
        else if (selectorConfig.testId) selectorPart += getAttributeSelector(currentElement, 'data-testid') || getAttributeSelector(currentElement, 'data-test-id');
        else if (selectorConfig.role) selectorPart += getAttributeSelector(currentElement, 'role');
        else if (selectorConfig.className && currentElement.className) {
            var classNames = Array.from(currentElement.classList).join('.');
            if (classNames) {
                if (isValidSelector(".".concat(classNames))) selectorPart += ".".concat(classNames);
            }
        }
        parts.unshift(selectorPart);
        var potentialSelector = parts.join(' > ').trim();
        if (potentialSelector && isSelectorUnique(potentialSelector)) return potentialSelector;
        currentElement = currentElement.parentElement;
        currentDepth++;
    }
    var potentialSelector1 = parts.join(' > ').trim();
    if (!potentialSelector1) return 'unknown';
    else if (!isSelectorUnique(potentialSelector1)) {
        var parentElement = element.parentElement;
        if (parentElement) return "".concat(potentialSelector1, ":nth-child"); // NOTE: invalid DOM selector, but enough information for VC
    }
    return potentialSelector1;
}
function getElementName(selectorConfig, element) {
    if (!(0, _instanceof._)(element, HTMLElement)) return 'error';
    var cachedName = nameCache.get(element);
    if (cachedName) return cachedName;
    var uniqueSelector = getUniqueSelector(selectorConfig, element);
    nameCache.set(element, uniqueSelector);
    return uniqueSelector;
}
exports.default = getElementName;

},{"@swc/helpers/_/_instanceof":"h9UKc","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"96IW9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resetPressureRecordBuffer", function() {
    return resetPressureRecordBuffer;
});
parcelHelpers.export(exports, "resetMemoryRecordBuffer", function() {
    return resetMemoryRecordBuffer;
});
parcelHelpers.export(exports, "removeOldPressureBufferRecords", function() {
    return removeOldPressureBufferRecords;
});
parcelHelpers.export(exports, "removeOldMemoryBufferRecords", function() {
    return removeOldMemoryBufferRecords;
});
parcelHelpers.export(exports, "createPressureStateReport", function() {
    return createPressureStateReport;
});
parcelHelpers.export(exports, "createMemoryStateReport", function() {
    return createMemoryStateReport;
});
parcelHelpers.export(exports, "initialisePressureObserver", function() {
    return initialisePressureObserver;
});
parcelHelpers.export(exports, "initialiseMemoryObserver", function() {
    return initialiseMemoryObserver;
});
parcelHelpers.export(exports, "disconnectMemoryObserver", function() {
    return disconnectMemoryObserver;
});
parcelHelpers.export(exports, "disconnectPressureObserver", function() {
    return disconnectPressureObserver;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var BUFFER_MAX_LENGTH = 1000; // ensure we don't blow up this buffer
var pressureRecordBuffer = [];
var pressureObserver = null;
var memoryRecordBuffer = [];
var memoryInterval;
function resetPressureRecordBuffer() {
    pressureRecordBuffer.length = 0;
}
function resetMemoryRecordBuffer() {
    memoryRecordBuffer.length = 0;
}
function removeOldPressureBufferRecords(filter) {
    pressureRecordBuffer = pressureRecordBuffer.filter(function(param) {
        var time = param.time;
        return time > filter;
    });
}
function removeOldMemoryBufferRecords(filter) {
    memoryRecordBuffer = memoryRecordBuffer.filter(function(param) {
        var time = param.time;
        return time > filter;
    });
}
function createPressureStateReport(start, end) {
    try {
        // To differentiate between the API not available, vs no PressureRecords added
        if (!('PressureObserver' in globalThis)) return null;
        var pressureStateCount = pressureRecordBuffer.reduce(function(pressureReport, param) {
            var time = param.time, state = param.state;
            if (time >= start && time <= end) pressureReport[state] += 1;
            return pressureReport;
        }, {
            nominal: 0,
            fair: 0,
            serious: 0,
            critical: 0
        });
        var pressureStateTotal = Object.values(pressureStateCount).reduce(function(total, count) {
            return total + count;
        }) || 1;
        removeOldPressureBufferRecords(end);
        return {
            count: pressureStateCount,
            percentage: {
                nominal: Math.round(pressureStateCount.nominal / pressureStateTotal * 100),
                fair: Math.round(pressureStateCount.fair / pressureStateTotal * 100),
                serious: Math.round(pressureStateCount.serious / pressureStateTotal * 100),
                critical: Math.round(pressureStateCount.critical / pressureStateTotal * 100)
            }
        };
    } catch (e) {
        return null;
    }
}
function convertBytesToMegabytes(bytes) {
    return Math.round(Math.round(bytes / 1048576 * 100) / 100);
}
function createMemoryStateReport(start, end) {
    try {
        if (!('memory' in performance)) return null;
        var accumulatedMemoryUsage = memoryRecordBuffer.reduce(function(acc, snapshot) {
            if (snapshot.time >= start && snapshot.time <= end) {
                acc.totalJSHeapSize += snapshot.totalJSHeapSize;
                acc.usedJSHeapSize += snapshot.usedJSHeapSize;
                acc.snapshotCount += 1;
            }
            return acc;
        }, {
            totalJSHeapSize: 0,
            usedJSHeapSize: 0,
            snapshotCount: 0
        });
        var memoryStateReport = {
            jsHeapSizeLimitInMB: convertBytesToMegabytes(memoryRecordBuffer[0].jsHeapSizeLimit),
            avgTotalJSHeapSizeInMB: convertBytesToMegabytes(accumulatedMemoryUsage.totalJSHeapSize / accumulatedMemoryUsage.snapshotCount),
            avgUsedJSHeapSizeInMB: convertBytesToMegabytes(accumulatedMemoryUsage.usedJSHeapSize / accumulatedMemoryUsage.snapshotCount)
        };
        removeOldMemoryBufferRecords(end);
        return memoryStateReport;
    } catch (e) {
        return null;
    }
}
function initialisePressureObserver() {
    try {
        if ('PressureObserver' in globalThis) {
            pressureObserver = new PressureObserver(function(records) {
                var _pressureRecordBuffer;
                if (pressureRecordBuffer.length + records.length <= BUFFER_MAX_LENGTH) (_pressureRecordBuffer = pressureRecordBuffer).push.apply(_pressureRecordBuffer, (0, _toConsumableArray._)(records));
            });
            pressureObserver.observe('cpu', {
                sampleInterval: 100
            }).catch(function() {
            // Silently handle permission policy restrictions or other observe failures
            // This prevents unhandled promise rejections from being reported to Sentry
            });
        }
    } catch (e) {
    /* do nothing, this is a best efforts metric */ }
}
function initialiseMemoryObserver() {
    try {
        // only set up the interval if `performance.memory` is available in the browser
        if ('memory' in performance) memoryInterval = setInterval(function() {
            // another check of `performance.memory` availability to satisfy typescript
            if ('memory' in performance) {
                var memory = performance.memory;
                if (memoryRecordBuffer.length <= BUFFER_MAX_LENGTH) memoryRecordBuffer.push({
                    time: performance.now(),
                    jsHeapSizeLimit: memory.jsHeapSizeLimit,
                    totalJSHeapSize: memory.totalJSHeapSize,
                    usedJSHeapSize: memory.usedJSHeapSize
                });
            }
        }, 100);
    } catch (e) {
    /* do nothing, this is a best efforts metric */ }
}
function disconnectMemoryObserver() {
    clearInterval(memoryInterval);
}
function disconnectPressureObserver() {
    pressureObserver === null || pressureObserver === void 0 ? void 0 : pressureObserver.disconnect();
}

},{"@swc/helpers/_/_to_consumable_array":"1eSZf","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iW354":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sinkTerminalErrorHandler", function() {
    return sinkTerminalErrorHandler;
});
parcelHelpers.export(exports, "isRelayNetworkError", function() {
    return isRelayNetworkError;
});
parcelHelpers.export(exports, "setTerminalError", function() {
    return setTerminalError;
});
parcelHelpers.export(exports, "useReportTerminalError", function() {
    return useReportTerminalError;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _typeOf = require("@swc/helpers/_/_type_of");
var _react = require("react");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _experienceTraceIdContext = require("../experience-trace-id-context");
var _interactionContext = require("../interaction-context");
var _interactionMetrics = require("../interaction-metrics");
var _routeNameContext = require("../route-name-context");
var _routeNameContextDefault = parcelHelpers.interopDefault(_routeNameContext);
var sinkHandlerFn = function() {};
function sinkTerminalErrorHandler(fn) {
    sinkHandlerFn = fn;
}
var RELAY_NETWORK_ERRORS_NAME = 'RelayNetwork';
var isRelayNetworkError = function(error) {
    return error.name === RELAY_NETWORK_ERRORS_NAME;
};
var isErrorObject = function(error) {
    return (typeof error === "undefined" ? "undefined" : (0, _typeOf._)(error)) === 'object' && error !== null;
};
var getErrorStatusCode = function(error) {
    var _error_source_errors__extensions, _error_source_errors_, _error_source_errors, _error_source;
    if (!isErrorObject(error)) return undefined;
    if (isRelayNetworkError(error)) return (_error_source = error.source) === null || _error_source === void 0 ? void 0 : (_error_source_errors = _error_source.errors) === null || _error_source_errors === void 0 ? void 0 : (_error_source_errors_ = _error_source_errors[0]) === null || _error_source_errors_ === void 0 ? void 0 : (_error_source_errors__extensions = _error_source_errors_.extensions) === null || _error_source_errors__extensions === void 0 ? void 0 : _error_source_errors__extensions.statusCode;
    if ('statusCode' in error && typeof error.statusCode === 'number') return error.statusCode;
    return undefined;
};
var getErrorTraceId = function(error) {
    return isErrorObject(error) && 'traceId' in error && typeof error.traceId === 'string' ? error.traceId : undefined;
};
function setTerminalError(error, additionalAttributes, labelStack) {
    var _error_message, _getActiveTrace;
    if (additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.isClientNetworkError) // Exclude client network errors from being reported to UFO
    return;
    var activeInteraction = (0, _interactionMetrics.getActiveInteraction)();
    var currentTime = performance.now();
    var baseErrorData = {
        errorType: error.name || 'Error',
        errorMessage: ((_error_message = error.message) === null || _error_message === void 0 ? void 0 : _error_message.slice(0, 100)) || 'Unknown error',
        timestamp: currentTime
    };
    var _additionalAttributes_statusCode, _getActiveTrace_traceId;
    var errorData = (0, _platformFeatureFlags.fg)('platform_ufo_terminal_errors_fix_missing_data') ? (0, _objectSpreadProps._)((0, _objectSpread._)({}, baseErrorData), {
        statusCode: (_additionalAttributes_statusCode = additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.statusCode) !== null && _additionalAttributes_statusCode !== void 0 ? _additionalAttributes_statusCode : getErrorStatusCode(error),
        // Fallback to traceId from error object if it exists (e.g. FetchError)
        traceId: (_getActiveTrace_traceId = (_getActiveTrace = (0, _experienceTraceIdContext.getActiveTrace)()) === null || _getActiveTrace === void 0 ? void 0 : _getActiveTrace.traceId) !== null && _getActiveTrace_traceId !== void 0 ? _getActiveTrace_traceId : getErrorTraceId(error),
        teamName: additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.teamName,
        packageName: additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.packageName,
        errorBoundaryId: additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.errorBoundaryId,
        errorHash: additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.errorHash,
        fallbackType: additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.fallbackType
    }) : (0, _objectSpread._)({}, baseErrorData, additionalAttributes);
    // Calculate time since previous interaction
    var timeSincePreviousInteraction = (0, _interactionMetrics.PreviousInteractionLog).timestamp != null ? currentTime - (0, _interactionMetrics.PreviousInteractionLog).timestamp : null;
    var _activeInteraction_ufoName, _activeInteraction_id, _activeInteraction_type, _PreviousInteractionLog_id, _PreviousInteractionLog_name, _PreviousInteractionLog_type, _UFORouteName_current;
    var context = {
        labelStack: labelStack !== null && labelStack !== void 0 ? labelStack : null,
        activeInteractionName: (_activeInteraction_ufoName = activeInteraction === null || activeInteraction === void 0 ? void 0 : activeInteraction.ufoName) !== null && _activeInteraction_ufoName !== void 0 ? _activeInteraction_ufoName : null,
        activeInteractionId: (_activeInteraction_id = activeInteraction === null || activeInteraction === void 0 ? void 0 : activeInteraction.id) !== null && _activeInteraction_id !== void 0 ? _activeInteraction_id : null,
        activeInteractionType: (_activeInteraction_type = activeInteraction === null || activeInteraction === void 0 ? void 0 : activeInteraction.type) !== null && _activeInteraction_type !== void 0 ? _activeInteraction_type : null,
        previousInteractionId: (_PreviousInteractionLog_id = (0, _interactionMetrics.PreviousInteractionLog).id) !== null && _PreviousInteractionLog_id !== void 0 ? _PreviousInteractionLog_id : null,
        previousInteractionName: (_PreviousInteractionLog_name = (0, _interactionMetrics.PreviousInteractionLog).name) !== null && _PreviousInteractionLog_name !== void 0 ? _PreviousInteractionLog_name : null,
        previousInteractionType: (_PreviousInteractionLog_type = (0, _interactionMetrics.PreviousInteractionLog).type) !== null && _PreviousInteractionLog_type !== void 0 ? _PreviousInteractionLog_type : null,
        timeSincePreviousInteraction: timeSincePreviousInteraction,
        routeName: (_UFORouteName_current = (0, _routeNameContextDefault.default).current) !== null && _UFORouteName_current !== void 0 ? _UFORouteName_current : null
    };
    sinkHandlerFn(errorData, context);
}
function useReportTerminalError(error, additionalAttributes) {
    var interactionContext = (0, _interactionContext.useInteractionContext)();
    var hasReportedRef = (0, _react.useRef)(false);
    (0, _react.useEffect)(function() {
        if (error && !hasReportedRef.current) {
            hasReportedRef.current = true;
            setTerminalError(error, additionalAttributes, interactionContext === null || interactionContext === void 0 ? void 0 : interactionContext.labelStack);
        }
    }, [
        error,
        additionalAttributes,
        interactionContext === null || interactionContext === void 0 ? void 0 : interactionContext.labelStack
    ]);
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_type_of":"iFJdx","react":"ltHCL","@atlaskit/platform-feature-flags":"kO5t9","../experience-trace-id-context":"7SDPo","../interaction-context":"6ICC9","../interaction-metrics":"diQdd","../route-name-context":"61t5e","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kYNI2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _scheduler = require("scheduler");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
function scheduleIdleCallback(work) {
    if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function' && (0, _platformFeatureFlags.fg)('ufo_payload_use_idle_callback')) window.requestIdleCallback(work);
    else (0, _scheduler.unstable_scheduleCallback)((0, _scheduler.unstable_IdlePriority), work);
}
exports.default = scheduleIdleCallback;

},{"scheduler":"NHulo","@atlaskit/platform-feature-flags":"kO5t9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9mC2Z":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("690e4d24f3f218aa")(require("9440a4a6dab5c20").resolve("9PrN4")),
    require("690e4d24f3f218aa")(require("9440a4a6dab5c20").resolve("aROUw"))
]).then(function() {
    return module.bundle.root('5twA2');
});

},{"690e4d24f3f218aa":"hkfCW","9440a4a6dab5c20":"l4T2r"}],"642W1":[function(require,module,exports,__globalThis) {
module.exports = require("8440698d24543d98")(require("7cd672c9a83b25e3").resolve("d1jiO")).then(function() {
    return module.bundle.root('gYGBS');
});

},{"8440698d24543d98":"hkfCW","7cd672c9a83b25e3":"l4T2r"}],"gSPaW":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("1e36a35fdba252a9")(require("1a200fe7e918060d").resolve("9PrN4")),
    require("1e36a35fdba252a9")(require("1a200fe7e918060d").resolve("ddxIx"))
]).then(function() {
    return module.bundle.root('broks');
});

},{"1e36a35fdba252a9":"hkfCW","1a200fe7e918060d":"l4T2r"}],"FsT4Z":[function(require,module,exports,__globalThis) {
module.exports = require("b4cab039426ded59")(require("16362e7e595be63c").resolve("6nBS9")).then(function() {
    return module.bundle.root('hpIJF');
});

},{"b4cab039426ded59":"hkfCW","16362e7e595be63c":"l4T2r"}],"enJdV":[function(require,module,exports,__globalThis) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "updatePageloadName", function() {
    return updatePageloadName;
});
var _uuid = require("uuid");
var _coinflip = require("../coinflip");
var _coinflipDefault = parcelHelpers.interopDefault(_coinflip);
var _config = require("../config");
var _experienceTraceIdContext = require("../experience-trace-id-context");
var _interactionIdContext = require("../interaction-id-context");
var _interactionMetrics = require("../interaction-metrics");
var _routeNameContext = require("../route-name-context");
var _routeNameContextDefault = parcelHelpers.interopDefault(_routeNameContext);
var AWAITING_PAGELOAD_NAME = 'awaiting_pageload_name';
function traceUFOPageLoad(ufoName) {
    var routeName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ufoName;
    if (!(0, _config.isUFOEnabled)()) return;
    var activeInteraction = (0, _interactionMetrics.getActiveInteraction)();
    if (activeInteraction && !ufoName) return;
    (0, _routeNameContextDefault.default).current = routeName || null;
    var rate = ufoName ? (0, _config.getInteractionRate)(ufoName, 'page_load') : 1;
    var enabledBySamplingRate = (0, _coinflipDefault.default)(rate);
    if (enabledBySamplingRate && !activeInteraction) {
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        var newId = (0, _uuid.v4)();
        (0, _interactionIdContext.DefaultInteractionID).current = newId;
        (0, _interactionMetrics.addNewInteraction)(newId, ufoName || '', 'page_load', 0, rate, null, routeName, (0, _experienceTraceIdContext.getActiveTrace)());
        if (!ufoName) // if no name is provided we add a hold to the interaction, it is removed if the name is provided while the interaction is holding
        (0, _interactionMetrics.addHoldByID)(newId, [], AWAITING_PAGELOAD_NAME, AWAITING_PAGELOAD_NAME, true);
    } else if (!enabledBySamplingRate && activeInteraction && activeInteraction.type === 'page_load') // if there is an active interaction it will be aborted without initialising a new one because the coinflip returned false
    (0, _interactionMetrics.abort)(activeInteraction.id, 'excluded_by_sampling');
    else if (ufoName && activeInteraction && !activeInteraction.ufoName && activeInteraction.type === 'page_load') {
        (0, _interactionMetrics.updatePageLoadInteractionName)(ufoName, routeName);
        (0, _interactionMetrics.removeHoldByID)(activeInteraction.id, AWAITING_PAGELOAD_NAME);
    }
}
exports.default = traceUFOPageLoad;
function updatePageloadName(ufoName) {
    var routeName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ufoName;
    if (!(0, _config.isUFOEnabled)()) return;
    var interaction = (0, _interactionMetrics.getActiveInteraction)();
    if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
    if (ufoName) {
        var rate = (0, _config.getInteractionRate)(ufoName, 'page_load');
        (0, _interactionMetrics.updatePageLoadInteractionName)(ufoName, routeName);
        if ((0, _coinflipDefault.default)(rate)) (0, _routeNameContextDefault.default).current = ufoName;
        else (0, _interactionMetrics.abort)(interaction.id, 'excluded_by_sampling');
    }
    (0, _interactionMetrics.removeHoldByID)(interaction.id, AWAITING_PAGELOAD_NAME);
}

},{"uuid":"5elg8","../coinflip":"cHdgG","../config":"1BZI5","../experience-trace-id-context":"7SDPo","../interaction-id-context":"eh9Yb","../interaction-metrics":"diQdd","../route-name-context":"61t5e","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}]},["d0evx","gxDd3"], "gxDd3", "parcelRequire213a")

//# sourceMappingURL=index.90cf02d8.js.map
